(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.BridgeInspection = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */
/**
 * Pure rules for approval workflow configuration. See README.md.
 */

// These lists and readActorSpec must match api/approvals/source/Workflow.js and WorkflowProvider.js.
const ROLE_ACTOR_TYPES = [ 'ProjectRole', 'UserRole', 'UserRoleProjectMembership', 'FormLabRole', 'FormMaterialLabRole', 'ProjectEntitlement' ];
const KEYWORD_ACTOR_TYPES = [ 'Admin', 'CreatingUser', 'HigherUserLevelInProject', 'MinimumUserLevelInProject', 'FormLabUser', 'FormMaterialLabInitialUser', 'FormMaterialLabEscalationUser' ];
const ACTOR_TYPES = ROLE_ACTOR_TYPES.concat(KEYWORD_ACTOR_TYPES, [ 'Users' ]);
const CRITERION_TYPES = [ 'True', 'False', 'EntityOwner', 'HasProjectSetting', 'FormDataMetadata', 'ChangeOrderThreshold', 'DocumentHasObsWithLabel', 'RecordNotFound' ];
const TRIGGER_EVENTS = [ 'ProjectFilePromote', 'LockDocumentSample', 'UnlockDocumentSample', 'SetDocumentSampleStatus', 'LIMSClaim' ];
const STATE_KEYS = [ 'Status', 'StateName', 'Transitions' ];
const TRANSITION_KEYS = [ 'Action', 'ToStatus', 'Actors', 'LockEntity', 'UnlockEntity', 'AllowOnLocked', 'IsApproval', 'InvalidatesApproval', 'CreateLineItem', 'RequireProjectSetting', 'AdditionalRequiredFields', 'Criteria', 'Branches', 'BackPropagateTo', 'BackPropagateCriteria', 'InferBackPropagateCriteria', 'Triggers' ];
// The approvals service and document code key on these by name.
const CONVENTIONAL_STATES = [ 'Draft', 'Approved', 'Rejected' ];
const SPECIAL_STATES = [ 'Draft', 'Approved' ];

/**
 * @typedef {object} ActorSpec
 * @property {string} Type - The actor type.
 * @property {Array<any>} Settings - Its roles, users or values.
 * @property {Array<string>} Tags - Its tags.
 * @property {string|null} Field - The object field holding the settings; null for a string actor or an actor with none.
 */

/**
 * @typedef {object} Finding
 * @property {string} Code - Stable identifier of the rule.
 * @property {'error'|'warning'|'info'} Severity - How serious it is.
 * @property {string} Message - What's wrong, for the person editing.
 * @property {string} [Status] - The state it concerns.
 * @property {number} [TransitionIndex] - The transition it concerns, within that state.
 */

/**
 * @typedef {object} CheckContext
 * @property {Set<string>} [KnownRoleCodes] - Role.PermissionLevel codes in the customer.
 * @property {Record<string, { Disabled?: any, IDCustomer?: number }>} [Users] - The users named by actors, by IDUser.
 * @property {number} [IDCustomer] - The customer the workflow belongs to.
 * @property {any} [Baseline] - The workflow as last saved, to notice risky renames.
 */

/**
 * Read an actor in any form the approvals service accepts, in the same order it reads them.
 *
 * @param {any} pActor - A string or object actor.
 *
 * @return {ActorSpec} The normalized actor.
 */
function readActorSpec(pActor)
{
	if (pActor && (typeof pActor === 'object'))
	{
		const tmpTags = Array.isArray(pActor.Tags) ? pActor.Tags : [];
		for (const tmpField of [ 'IDs', 'Values', 'Hashes' ])
		{
			if (Array.isArray(pActor[tmpField]))
			{
				return { Type: pActor.Type, Settings: pActor[tmpField], Tags: tmpTags, Field: tmpField };
			}
		}
		for (const tmpField of [ 'Value', 'Hash', 'ID' ])
		{
			if (pActor[tmpField] !== undefined)
			{
				return { Type: pActor.Type, Settings: [ pActor[tmpField] ], Tags: tmpTags, Field: tmpField };
			}
		}
		if (typeof pActor.Settings === 'string')
		{
			return { Type: pActor.Type, Settings: pActor.Settings.split(',').filter(Boolean), Tags: tmpTags, Field: 'Settings' };
		}
		return { Type: pActor.Type, Settings: [], Tags: tmpTags, Field: null };
	}
	const tmpString = String(pActor || '');
	const tmpSeparator = tmpString.indexOf(':');
	if (tmpSeparator > -1)
	{
		return { Type: tmpString.substring(0, tmpSeparator), Settings: tmpString.substring(tmpSeparator + 1).split(',').filter(Boolean), Tags: [], Field: null };
	}
	return { Type: tmpString, Settings: [], Tags: [], Field: null };
}

/**
 * Visit every transition of a workflow, including nested branches.
 *
 * @param {any} pWorkflow - A workflow.
 * @param {(pEdge: any, pState: any, pPath: string, pTransition: any, pTransitionIndex: number) => void} fVisit - Called per transition or branch.
 */
function forEachEdge(pWorkflow, fVisit)
{
	const fWalk = (pEdge, pState, pPath, pTransition, pTransitionIndex) =>
	{
		fVisit(pEdge, pState, pPath, pTransition, pTransitionIndex);
		(Array.isArray(pEdge.Branches) ? pEdge.Branches : []).forEach((pBranch, pIndex) => fWalk(pBranch, pState, `${pPath} branch ${pIndex + 1}`, pTransition, pTransitionIndex));
	};
	((pWorkflow && pWorkflow.States) || []).forEach((pState) =>
	{
		(Array.isArray(pState && pState.Transitions) ? pState.Transitions : []).forEach((pTransition, pIndex) =>
		{
			fWalk(pTransition, pState, `[${pState.Status}] ${pTransition.Action || `transition ${pIndex + 1}`}`, pTransition, pIndex);
		});
	});
}

/**
 * Literal deep equality as the config service stores values: object key order doesn't matter, array order does.
 *
 * @param {any} pA - First value.
 * @param {any} pB - Second value.
 *
 * @return {boolean} True when equal.
 */
function deepEqual(pA, pB)
{
	if (pA === pB)
	{
		return true;
	}
	if ((typeof pA !== 'object') || (typeof pB !== 'object') || (pA === null) || (pB === null))
	{
		return false;
	}
	if (Array.isArray(pA) !== Array.isArray(pB))
	{
		return false;
	}
	if (Array.isArray(pA))
	{
		return (pA.length === pB.length) && pA.every((pValue, pIndex) => deepEqual(pValue, pB[pIndex]));
	}
	const tmpKeysA = Object.keys(pA);
	const tmpKeysB = Object.keys(pB);
	if (tmpKeysA.length !== tmpKeysB.length)
	{
		return false;
	}
	return tmpKeysA.every((pKey) => Object.prototype.hasOwnProperty.call(pB, pKey) && deepEqual(pA[pKey], pB[pKey]));
}

/**
 * A workflow name is one URL segment.
 *
 * @param {string} pName - A proposed workflow name.
 *
 * @return {string} Why it can't be used; empty when it can.
 */
function workflowNameProblem(pName)
{
	const tmpName = String(pName == null ? '' : pName);
	if (!tmpName.trim())
	{
		return 'A workflow needs a name.';
	}
	if (/[/\\?#%'"]/.test(tmpName))
	{
		return 'A workflow name can\'t contain / \\ ? # % or quotes.';
	}
	return '';
}

/**
 * States other than the first that nothing transitions into, so only documents already there can be in them.
 *
 * @param {any} pWorkflow - A workflow.
 *
 * @return {Array<any>} The states.
 */
function unreachableStateRecords(pWorkflow)
{
	const tmpReachable = new Set();
	forEachEdge(pWorkflow, (pEdge) =>
	{
		tmpReachable.add(pEdge.ToStatus);
	});
	return ((pWorkflow && pWorkflow.States) || []).slice(1).filter((pState) => !tmpReachable.has(pState.Status));
}

/**
 * @param {any} pWorkflow - A workflow.
 *
 * @return {Array<string>} The names of states nothing transitions into.
 */
function findUnreachableStates(pWorkflow)
{
	return unreachableStateRecords(pWorkflow).map((pState) => pState.StateName || pState.Status);
}

/**
 * @param {any} pWorkflow - A workflow.
 *
 * @return {Array<string>} One line per ToStatus or BackPropagateTo that names no state.
 */
function findDanglingTargets(pWorkflow)
{
	const tmpStatuses = new Set(((pWorkflow && pWorkflow.States) || []).map((pState) => pState.Status));
	const tmpDangling = [];
	forEachEdge(pWorkflow, (pEdge, pState, pPath, pTransition) =>
	{
		if ((pEdge.ToStatus !== undefined) && !tmpStatuses.has(pEdge.ToStatus))
		{
			tmpDangling.push(`${pState.Status} '${pTransition.Action}' → ${pEdge.ToStatus}`);
		}
		(Array.isArray(pEdge.BackPropagateTo) ? pEdge.BackPropagateTo : []).filter((pTarget) => !tmpStatuses.has(pTarget)).forEach((pTarget) =>
		{
			tmpDangling.push(`${pState.Status} '${pTransition.Action}' back-propagates to ${pTarget}`);
		});
	});
	return tmpDangling;
}

/**
 * Where a transition can end, after branch fields merge over their parent's the way the service merges them.
 *
 * @param {any} pTransition - A transition.
 *
 * @return {Array<any>} One merged edge for the transition and for each branch path.
 */
function transitionOutcomes(pTransition)
{
	const tmpOutcomes = [];
	const fWalk = (pEdge, pMerged) =>
	{
		const tmpMerged = Object.assign({}, pMerged, pEdge);
		tmpOutcomes.push(tmpMerged);
		(Array.isArray(pEdge.Branches) ? pEdge.Branches : []).forEach((pBranch) => fWalk(pBranch, tmpMerged));
	};
	fWalk(pTransition, {});
	return tmpOutcomes;
}

/**
 * Work out which lock conditions a document can be in at each state, starting unlocked at the first state and at any
 * state nothing leads to. A locked document can only leave by an action with AllowOnLocked.
 *
 * @param {any} pWorkflow - A workflow.
 *
 * @return {Map<string, Set<boolean>>} Status to the lock conditions it can be reached in.
 */
function reachableLockStates(pWorkflow)
{
	const tmpStates = Array.isArray(pWorkflow && pWorkflow.States) ? pWorkflow.States : [];
	const tmpByStatus = new Map(tmpStates.map((pState) => [ pState.Status, pState ]));
	const tmpLockStates = new Map(tmpStates.map((pState) => [ pState.Status, new Set() ]));
	const tmpQueue = [];
	const fReach = (pStatus, pLocked) =>
	{
		const tmpSeen = tmpLockStates.get(pStatus);
		if (tmpSeen && !tmpSeen.has(pLocked))
		{
			tmpSeen.add(pLocked);
			tmpQueue.push([ pStatus, pLocked ]);
		}
	};
	if (tmpStates.length)
	{
		fReach(tmpStates[0].Status, false);
	}
	unreachableStateRecords(pWorkflow).forEach((pState) => fReach(pState.Status, false));
	while (tmpQueue.length)
	{
		const [ tmpStatus, tmpLocked ] = tmpQueue.shift();
		const tmpState = tmpByStatus.get(tmpStatus);
		(Array.isArray(tmpState.Transitions) ? tmpState.Transitions : []).forEach((pTransition) =>
		{
			if (tmpLocked && !pTransition.AllowOnLocked)
			{
				return;
			}
			transitionOutcomes(pTransition).forEach((pOutcome) =>
			{
				fReach(pOutcome.ToStatus, !!(pOutcome.LockEntity || (tmpLocked && !pOutcome.UnlockEntity)));
			});
		});
	}
	return tmpLockStates;
}

/**
 * @param {string} pKey - A key the service doesn't read.
 *
 * @return {string} A hint when it looks like a misspelling of one it does.
 */
function misspellingHint(pKey)
{
	const tmpMatch = TRANSITION_KEYS.find((pKnown) => pKnown.toLowerCase() === String(pKey).toLowerCase());
	return tmpMatch ? ` Did you mean ${tmpMatch}?` : '';
}

/**
 * Check a workflow against what the approvals service does with it. Rules whose context is missing are skipped.
 *
 * @param {any} pWorkflow - A workflow.
 * @param {CheckContext} [pContext] - What's known beyond the workflow.
 *
 * @return {Array<Finding>} What's wrong; errors first.
 */
function checkWorkflow(pWorkflow, pContext)
{
	const tmpContext = pContext || {};
	const tmpFindings = [];
	/**
	 * @param {string} pCode
	 * @param {'error'|'warning'|'info'} pSeverity
	 * @param {string} pMessage
	 * @param {string} [pStatus]
	 * @param {number} [pTransitionIndex]
	 */
	const fAdd = (pCode, pSeverity, pMessage, pStatus, pTransitionIndex) =>
	{
		const tmpFinding = { Code: pCode, Severity: pSeverity, Message: pMessage };
		if (pStatus !== undefined)
		{
			tmpFinding.Status = pStatus;
		}
		if (pTransitionIndex !== undefined)
		{
			tmpFinding.TransitionIndex = pTransitionIndex;
		}
		tmpFindings.push(tmpFinding);
	};
	const tmpStates = (pWorkflow && Array.isArray(pWorkflow.States)) ? pWorkflow.States : [];
	if (!tmpStates.length)
	{
		fAdd('no-states', 'error', 'A workflow needs at least one state.');
		return tmpFindings;
	}

	const tmpStatuses = new Set();
	tmpStates.forEach((pState, pIndex) =>
	{
		if (!pState || (typeof pState.Status !== 'string') || !pState.Status)
		{
			fAdd('missing-status', 'error', `State ${pIndex + 1} (${(pState && pState.StateName) || 'unnamed'}) has no state hash.`);
			return;
		}
		if (tmpStatuses.has(pState.Status))
		{
			fAdd('duplicate-status', 'error', `More than one state uses the hash "${pState.Status}".`, pState.Status);
		}
		tmpStatuses.add(pState.Status);
		if (!Array.isArray(pState.Transitions))
		{
			fAdd('transitions-not-list', 'error', `"${pState.Status}" has no list of transitions. Use an empty list for a final state.`, pState.Status);
		}
		if (typeof pState.StateName !== 'string')
		{
			fAdd('missing-state-name', 'info', `"${pState.Status}" has no display name, so people will see its hash.`, pState.Status);
		}
		Object.keys(pState).filter((pKey) => !STATE_KEYS.includes(pKey) && (pKey !== 'StateIndex')).forEach((pKey) =>
		{
			fAdd('unknown-key', 'info', `"${pState.Status}" has a setting the approvals service doesn't read: ${pKey}.`, pState.Status);
		});
	});

	const tmpLockStates = reachableLockStates(pWorkflow);
	tmpStates.filter((pState) => pState && Array.isArray(pState.Transitions)).forEach((pState) =>
	{
		const tmpSeenActions = new Set();
		const tmpLocks = tmpLockStates.get(pState.Status);
		const tmpAlwaysLocked = !!tmpLocks && (tmpLocks.size === 1) && tmpLocks.has(true);
		pState.Transitions.forEach((pTransition, pIndex) =>
		{
			const tmpAction = String(pTransition.Action || '');
			if (!tmpAction.trim())
			{
				fAdd('missing-action', 'error', `A transition from "${pState.Status}" has no action name.`, pState.Status, pIndex);
			}
			else if (tmpSeenActions.has(tmpAction))
			{
				fAdd('duplicate-action', 'warning', `"${pState.Status}" has two "${tmpAction}" transitions. Everyone on both is offered the action, but only the first is ever used, so the second group is refused.`, pState.Status, pIndex);
			}
			tmpSeenActions.add(tmpAction);
			if (!Array.isArray(pTransition.Actors) || !pTransition.Actors.length)
			{
				fAdd('no-actors', 'warning', `Nobody can take "${tmpAction}" from "${pState.Status}". Documents that depend on it get stuck.`, pState.Status, pIndex);
			}
			if (tmpAlwaysLocked && !pTransition.AllowOnLocked)
			{
				fAdd('locked-action', 'warning', `"${tmpAction}" is refused: documents are always locked in "${pState.Status}" and this action isn't allowed on locked documents.`, pState.Status, pIndex);
			}
			if (/^approve/i.test(tmpAction) && !pTransition.IsApproval)
			{
				fAdd('approve-without-flag', 'info', `"${tmpAction}" from "${pState.Status}" isn't marked as an approval, so it won't count as one.`, pState.Status, pIndex);
			}
			if (/reject|void|return|deny/i.test(tmpAction) && pTransition.IsApproval)
			{
				fAdd('reject-with-flag', 'info', `"${tmpAction}" from "${pState.Status}" is marked as an approval, so it will count as one.`, pState.Status, pIndex);
			}
			(Array.isArray(pTransition.Actors) ? pTransition.Actors : []).forEach((pActor) =>
			{
				if (!pActor || !((typeof pActor === 'string') || (typeof pActor.Type === 'string')))
				{
					fAdd('bad-actor', 'warning', `"${tmpAction}" from "${pState.Status}" has an actor the approvals service can't read: ${JSON.stringify(pActor)}.`, pState.Status, pIndex);
					return;
				}
				const tmpSpec = readActorSpec(pActor);
				if (!ACTOR_TYPES.includes(tmpSpec.Type))
				{
					fAdd('unknown-actor-type', 'warning', `"${tmpAction}" from "${pState.Status}" names an actor type the approvals service doesn't know, so it matches nobody: ${tmpSpec.Type}.`, pState.Status, pIndex);
				}
				if (tmpContext.KnownRoleCodes && ROLE_ACTOR_TYPES.includes(tmpSpec.Type))
				{
					tmpSpec.Settings.filter((pCode) => !tmpContext.KnownRoleCodes.has(String(pCode))).forEach((pCode) =>
					{
						fAdd('unknown-role', 'warning', `"${tmpAction}" from "${pState.Status}" names a role this customer doesn't have, so it matches nobody: ${pCode}.`, pState.Status, pIndex);
					});
				}
				if (tmpContext.Users && (tmpSpec.Type === 'Users'))
				{
					tmpSpec.Settings.forEach((pID) =>
					{
						const tmpUser = tmpContext.Users[String(pID)];
						if (!tmpUser)
						{
							fAdd('unknown-user', 'warning', `"${tmpAction}" from "${pState.Status}" names user ${pID}, who couldn't be found.`, pState.Status, pIndex);
						}
						else if (tmpUser.Disabled)
						{
							fAdd('disabled-user', 'warning', `"${tmpAction}" from "${pState.Status}" names user ${pID}, who is disabled.`, pState.Status, pIndex);
						}
						else if (tmpContext.IDCustomer && tmpUser.IDCustomer && (Number(tmpUser.IDCustomer) !== Number(tmpContext.IDCustomer)))
						{
							fAdd('other-customer-user', 'warning', `"${tmpAction}" from "${pState.Status}" names user ${pID}, who belongs to another customer.`, pState.Status, pIndex);
						}
					});
				}
			});
		});
	});

	forEachEdge(pWorkflow, (pEdge, pState, pPath, pTransition, pTransitionIndex) =>
	{
		const tmpIsBranch = pEdge !== pTransition;
		if ((pEdge.ToStatus === undefined) ? !tmpIsBranch : !tmpStatuses.has(pEdge.ToStatus))
		{
			fAdd('dangling-target', 'warning', `${pPath} goes to "${pEdge.ToStatus}", which isn't a state in this workflow.`, pState.Status, pTransitionIndex);
		}
		(Array.isArray(pEdge.BackPropagateTo) ? pEdge.BackPropagateTo : []).filter((pTarget) => !tmpStatuses.has(pTarget)).forEach((pTarget) =>
		{
			fAdd('dangling-target', 'warning', `${pPath} back-propagates to "${pTarget}", which isn't a state in this workflow.`, pState.Status, pTransitionIndex);
		});
		if (tmpIsBranch && !(Array.isArray(pEdge.Criteria) && pEdge.Criteria.length))
		{
			fAdd('branch-no-criteria', 'warning', `${pPath} has no conditions, so it's never used.`, pState.Status, pTransitionIndex);
		}
		[].concat(Array.isArray(pEdge.Criteria) ? pEdge.Criteria : [], Array.isArray(pEdge.BackPropagateCriteria) ? pEdge.BackPropagateCriteria : []).forEach((pCriterion) =>
		{
			if (!pCriterion || !CRITERION_TYPES.includes(pCriterion.Type))
			{
				fAdd('unknown-criterion', 'warning', `${pPath} has a condition the approvals service doesn't know, so it never matches: ${(pCriterion && pCriterion.Type) || JSON.stringify(pCriterion)}.`, pState.Status, pTransitionIndex);
			}
		});
		(Array.isArray(pEdge.Triggers) ? pEdge.Triggers : []).filter((pTrigger) => !pTrigger || !TRIGGER_EVENTS.includes(pTrigger.Event)).forEach((pTrigger) =>
		{
			fAdd('unknown-trigger', 'warning', `${pPath} has a trigger the approvals service doesn't know: ${(pTrigger && pTrigger.Event) || JSON.stringify(pTrigger)}.`, pState.Status, pTransitionIndex);
		});
		Object.keys(pEdge).filter((pKey) => !TRANSITION_KEYS.includes(pKey)).forEach((pKey) =>
		{
			fAdd('unknown-key', 'info', `${pPath} has a setting the approvals service doesn't read: ${pKey}.${misspellingHint(pKey)}`, pState.Status, pTransitionIndex);
		});
	});

	unreachableStateRecords(pWorkflow).forEach((pState) =>
	{
		fAdd('unreachable-state', 'info', `Nothing leads to "${pState.Status}". Only documents already there can be in it.`, pState.Status);
	});
	CONVENTIONAL_STATES.filter((pStatus) => !tmpStatuses.has(pStatus)).forEach((pStatus) =>
	{
		fAdd('missing-conventional-state', 'info', `There's no "${pStatus}" state. Some document and finance behavior depends on Draft, Approved and Rejected by name.`);
	});

	const tmpBaseline = tmpContext.Baseline;
	if (tmpBaseline && Array.isArray(tmpBaseline.States))
	{
		const tmpHasPreApprovals = tmpBaseline.States.some((pState) => (pState.Transitions || []).some((pTransition) => Array.isArray(pTransition.BackPropagateTo) && pTransition.BackPropagateTo.length));
		tmpBaseline.States.forEach((pOldState) =>
		{
			const tmpCurrent = tmpStates.find((pState) => pState && (pState.Status === pOldState.Status));
			if (!tmpCurrent)
			{
				if (SPECIAL_STATES.includes(pOldState.Status))
				{
					fAdd('renamed-special-state', 'warning', `"${pOldState.Status}" is gone. Some document and finance behavior depends on that name.`);
				}
				return;
			}
			if (tmpHasPreApprovals)
			{
				(pOldState.Transitions || []).filter((pOld) => !(tmpCurrent.Transitions || []).some((pNew) => pNew.Action === pOld.Action)).forEach((pOld) =>
				{
					fAdd('renamed-action', 'warning', `"${pOld.Action}" from "${pOldState.Status}" is gone. Pending pre-approvals store the action name, so any waiting on it will fail.`, pOldState.Status);
				});
			}
		});
	}

	const tmpOrder = { error: 0, warning: 1, info: 2 };
	return tmpFindings.sort((pA, pB) => tmpOrder[pA.Severity] - tmpOrder[pB.Severity]);
}

/**
 * Re-key a workflow by Status and transitions by Action, so a comparison names states instead of array positions.
 *
 * @param {any} pWorkflow - A workflow.
 *
 * @return {any} The keyed form (transitions with duplicate actions get a #n suffix).
 */
function keyedWorkflow(pWorkflow)
{
	/** @type {any} */
	const tmpKeyed = {};
	Object.keys(pWorkflow || {}).filter((pKey) => pKey !== 'States').forEach((pKey) =>
	{
		tmpKeyed[pKey] = pWorkflow[pKey];
	});
	tmpKeyed.States = {};
	((pWorkflow && pWorkflow.States) || []).forEach((pState, pIndex) =>
	{
		const tmpState = Object.assign({}, pState, { Position: pIndex + 1, Transitions: {} });
		((pState && pState.Transitions) || []).forEach((pEdge, pEdgeIndex) =>
		{
			let tmpKey = pEdge.Action || `#${pEdgeIndex + 1}`;
			while (Object.prototype.hasOwnProperty.call(tmpState.Transitions, tmpKey))
			{
				tmpKey = `${tmpKey}#${pEdgeIndex + 1}`;
			}
			tmpState.Transitions[tmpKey] = Object.assign({ Position: pEdgeIndex + 1 }, pEdge);
		});
		tmpKeyed.States[(pState && pState.Status) || `#${pIndex + 1}`] = tmpState;
	});
	return tmpKeyed;
}

/**
 * @param {any} pValue - A value to show in a change line.
 *
 * @return {string} Compact JSON, cut at 160 characters.
 */
function brief(pValue)
{
	const tmpText = (pValue === undefined) ? '(none)' : JSON.stringify(pValue);
	return (tmpText.length > 160) ? `${tmpText.slice(0, 157)}...` : tmpText;
}

/**
 * List the differences between two values as "path: from → to" lines. Objects recurse; arrays and scalars compare whole.
 *
 * @param {any} pFrom - The earlier value.
 * @param {any} pTo - The later value.
 * @param {string} [pPath] - The path so far.
 * @param {Array<string>} [pLines] - Accumulator.
 *
 * @return {Array<string>} The change lines.
 */
function diffLines(pFrom, pTo, pPath, pLines)
{
	const tmpLines = pLines || [];
	const tmpPath = pPath || '';
	const fIsObject = (pValue) => pValue && (typeof pValue === 'object') && !Array.isArray(pValue);
	if (deepEqual(pFrom, pTo))
	{
		return tmpLines;
	}
	if (fIsObject(pFrom) && fIsObject(pTo))
	{
		Array.from(new Set(Object.keys(pFrom).concat(Object.keys(pTo)))).forEach((pKey) =>
		{
			const tmpChildPath = tmpPath ? `${tmpPath} › ${pKey}` : pKey;
			if (!Object.prototype.hasOwnProperty.call(pFrom, pKey))
			{
				tmpLines.push(`+ ${tmpChildPath}: ${brief(pTo[pKey])}`);
			}
			else if (!Object.prototype.hasOwnProperty.call(pTo, pKey))
			{
				tmpLines.push(`- ${tmpChildPath}: ${brief(pFrom[pKey])}`);
			}
			else
			{
				diffLines(pFrom[pKey], pTo[pKey], tmpChildPath, tmpLines);
			}
		});
		return tmpLines;
	}
	tmpLines.push(`~ ${tmpPath || '(value)'}: ${brief(pFrom)} → ${brief(pTo)}`);
	return tmpLines;
}

/**
 * What changed between two versions of a workflow, by state and action name rather than position.
 *
 * @param {any} pFrom - The earlier workflow.
 * @param {any} pTo - The later workflow.
 *
 * @return {Array<string>} The change lines.
 */
function workflowChanges(pFrom, pTo)
{
	return diffLines(keyedWorkflow(pFrom), keyedWorkflow(pTo));
}

module.exports =
{
	ROLE_ACTOR_TYPES,
	KEYWORD_ACTOR_TYPES,
	ACTOR_TYPES,
	CRITERION_TYPES,
	TRIGGER_EVENTS,
	TRANSITION_KEYS,
	readActorSpec,
	forEachEdge,
	deepEqual,
	workflowNameProblem,
	findUnreachableStates,
	findDanglingTargets,
	transitionOutcomes,
	checkWorkflow,
	keyedWorkflow,
	diffLines,
	workflowChanges,
};

},{}],2:[function(require,module,exports){

const Util = require('util');

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/** @typedef {import('fable')} Fable */
/** @typedef {import('headlight-rest-client')} HeadlightRestClient */

/**
 * Manage bridge documents.
 *
 * TODO: Abstract away bridge. Make this an inspection document manager.
 *
 *   * Create missing inspection documents that are needed given its type.
 */
class HeadlightBridgeDocumentManager extends libFableServiceProviderBase
{
	/**
	 * @param {Fable} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Fable & { HeadlightRestClient: HeadlightRestClient }} */
		this.fable;

		/** @type {any} */
		this.options;

		this.serviceType = 'BridgeDocumentManager';

		// Check if there is a REST client ... if not make one
		if (!this.fable.hasOwnProperty('HeadlightRestClient'))
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = '/1.0/';
			}
			this.client = this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		}
		else
		{
			this.client = this.fable.HeadlightRestClient;
		}

		/** @type {HeadlightRestClient} */
		this.client;
		this._fieldsToConcat = [ 'Notes' ];
	}

	/**
	 * @private
	 * @param {string|number} fromDocumentID
	 * @param {boolean} [lite=false]
	 * @return {Promise<Array<any>>}
	 */
	async _loadDocumentPolyJoinsFromDocument(fromDocumentID, lite = true)
	{
		const joins = await this._get(`DocumentPolyJoins${lite ? '/LiteExtended/RemoteType,Ordinal' : ''}/FilteredTo/FBV~IDDocument~EQ~${fromDocumentID}~FBV~RemoteType~EQ~Document~FSF~Ordinal~ASC~0~FSF~IDDocumentPolyJoin~ASC~0`);
		for (const join of joins)
		{
			if (lite)
			{
				delete join.Value; // if we want to re-save these, this breaks that
			}
			else
			{
				// these being here slows down saves, and also re-saves the underlying record
				delete join.RemoteRecord;
			}
		}
		if (!lite) // sorting is broken in the API for non-lite requests...
		{
			joins.sort((a, b) =>
			{
				if (a.Ordinal == b.Ordinal)
				{
					return a.IDDocumentPolyJoin - b.IDDocumentPolyJoin;
				}
				return a.Ordinal - b.Ordinal;
			});
		}
		return joins;
	}

	/**
	 * @private
	 * @param {number|string} inspectionID
	 * @return {Promise<Array<any>>}
	 */
	async _loadInspectionDocumentJoins(inspectionID)
	{
		return await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${inspectionID}~FSF~Ordinal~ASC~0~FSF~IDInspectionDocumentJoin~ASC~0`);
	}

	/**
	 * @private
	 * @param {string|number} fromDocumentID
	 * @param {string|number} toDocumentID
	 * @param {boolean} [lite=false]
	 * @return {Promise<any>}
	 */
	async _loadDocumentPolyJoinToDocument(fromDocumentID, toDocumentID, lite = true)
	{
		const joins = await this._get(`DocumentPolyJoins${lite ? '/LiteExtended/RemoteType,Ordinal' : ''}/FilteredTo/FBV~IDDocument~EQ~${fromDocumentID}~FBV~RemoteType~EQ~Document~FBV~IDRemote~EQ~${toDocumentID}`);
		for (const join of joins)
		{
			if (lite)
			{
				delete join.Value;
			}
			else
			{
				// these being here slows down saves, and also re-saves the underlying record
				delete join.RemoteRecord;
			}
		}
		return joins[0];
	}

	/**
	 * Async wrapper for HTTP get.
	 *
	 * @param {String} uri The URI to get.
	 *
	 * @return {Promise<any>} The result of the get.
	 */
	async _get(uri)
	{
		this.fable.log.info(`GET ${uri}`);
		return Util.promisify(this.client.getJSON.bind(this.client))(uri);
	}

	/**
	 * Async wrapper for HTTP put.
	 *
	 * @param {String} uri The URI to put to.
	 * @param {any} payload The payload to put (as JSON).
	 *
	 * @return {Promise<any>} The result of the put.
	 */
	async _put(uri, payload)
	{
		this.fable.log.info(`PUT ${uri}`, { payload });
		return Util.promisify(this.client.putJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP post.
	 *
	 * @param {String} uri The URI to post to.
	 * @param {any} payload The payload to post (as JSON).
	 *
	 * @return {Promise<Object>} The result of the post.
	 */
	async _post(uri, payload)
	{
		this.fable.log.info(`POST ${uri}`, { payload });
		return Util.promisify(this.client.postJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP delete.
	 *
	 * @param {string} entityType The entity type to delete.
	 * @param {string|number} entityID The entity ID to delete.
	 *
	 * @return {Promise<Object>} The result of the delete.
	 */
	async _deleteEntity(entityType, entityID)
	{
		this.fable.log.info(`DELETE ${entityType}:${entityID}`, { entityType, entityID });
		return Util.promisify(this.client.deleteEntity.bind(this.client))(entityType, entityID);
	}

	/**
	 * Create a Bridge inspection.
	 *
	 * @param {Number} bridgeID
	 * @param {any} inspectionPayload - The new inspection record shape.
	 * @param {Boolean} [physicalAssetPassed] - Set to true if a physical asset id was passed instead of a bridge.
	 *
	 * @return {Promise<any>} The inspection record.
	 */
	/**
	 * Create an inspection for a PhysicalAsset. This is the generic entry
	 * point — creates the inspection, links it to the asset, and generates
	 * the initial inspection documents.
	 *
	 * @param {number|string} pIDPhysicalAsset - The PhysicalAsset ID.
	 * @param {Object} pInspectionPayload - The inspection record to create.
	 * @return {Promise<Object>} The created inspection record.
	 */
	async createInspection(pIDPhysicalAsset, pInspectionPayload)
	{
		return this.createBridgeInspection(pIDPhysicalAsset, pInspectionPayload, true);
	}

	/**
	 * Create an inspection for a Bridge. Resolves Bridge → PhysicalAsset
	 * unless physicalAssetPassed is true, in which case bridgeID is treated
	 * as an IDPhysicalAsset directly.
	 *
	 * @deprecated Use createInspection() for new code — it accepts
	 * IDPhysicalAsset directly without the Bridge lookup.
	 *
	 * @param {number|string} bridgeID - Bridge ID or PhysicalAsset ID.
	 * @param {Object} inspectionPayload - The inspection record.
	 * @param {boolean} [physicalAssetPassed] - If true, bridgeID is an IDPhysicalAsset.
	 * @return {Promise<Object>} The created inspection record.
	 */
	async createBridgeInspection(bridgeID, inspectionPayload, physicalAssetPassed)
	{
		const inspection = await this._post('Inspection', inspectionPayload);
		try
		{
			if (physicalAssetPassed)
			{
				// create join to physical asset
				await this._post('InspectionPhysicalAssetJoin',
					{
						IDPhysicalAsset: bridgeID,
						IDInspection: inspection.IDInspection,
					});
				return inspection;
			}
			// look up bridge
			const bridge = await this._get(`Bridge/${bridgeID}`);
			if (!bridge)
			{
				this.log.error(`Bridge with ID ${bridgeID} not found; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			if (!bridge.StructureNumber)
			{
				this.log.error(`Bridge with ID ${bridgeID} has no structure number; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			if (inspectionPayload.StatusDisplay && !inspectionPayload.IDInspectionStatus)
			{
				// attempt to look up by name
				const status = (await this._get(`InspectionStatuss/FilteredTo/FBV~Code~EQ~${inspectionPayload.StatusDisplay}`))[0];
				if (status)
				{
					inspection.IDInspectionStatus = status.IDInspectionStatus;
				}
			}
			// look up physical asset
			const physicalAssetPolyJoin = (await this._get(`PhysicalAssetPolyJoins/FilteredTo/FBV~RemoteType~EQ~Bridge~FBV~IDRemote~EQ~${bridgeID}`))[0];
			if (!physicalAssetPolyJoin)
			{
				this.log.error(`Physical asset association for bridge ID ${bridgeID} not found; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			const physicalAsset = await this._get(`PhysicalAsset/${physicalAssetPolyJoin.IDPhysicalAsset}`);
			if (!physicalAsset)
			{
				this.log.error(`Physical asset with ID ${physicalAssetPolyJoin.IDPhysicalAsset} not found; not associating inspection with bridge / physical asset`);
				return inspection;
			}
			// create join to physical asset
			await this._post('InspectionPhysicalAssetJoin',
				{
					IDPhysicalAsset: physicalAsset.IDPhysicalAsset,
					IDInspection: inspection.IDInspection,
				});
		}
		finally
		{
			try
			{
				await this.createInspectionDocuments(inspection);
			}
			catch (err)
			{
				this.log.error('Failed to create inspection documents', { inspection, err });
			}
		}
		return inspection;
	}

	/**
	 * @param {number|string} inspectionID
	 *
	 * @return {Promise<any>}
	 */
	/**
	 * Get the PhysicalAsset linked to an inspection.
	 *
	 * @param {number|string} pInspectionID - The inspection ID.
	 * @return {Promise<Object|null>} The PhysicalAsset record, or null.
	 */
	async getPhysicalAssetForInspection(pInspectionID)
	{
		const tmpJoins = await this._get(`InspectionPhysicalAssetJoins/FilteredTo/FBV~IDInspection~EQ~${pInspectionID}`);
		if (tmpJoins.length > 0)
		{
			return await this._get(`PhysicalAsset/${tmpJoins[0].IDPhysicalAsset}`);
		}
		return null;
	}

	/**
	 * Get the Bridge linked to an inspection via PhysicalAsset → PolyJoin.
	 *
	 * @deprecated Use getPhysicalAssetForInspection() for generic asset
	 * lookups. This method is Bridge-specific.
	 *
	 * @param {number|string} inspectionID
	 * @return {Promise<Object|null>}
	 */
	async _getBridgeForInspection(inspectionID)
	{
		const tmpPhysicalAsset = await this.getPhysicalAssetForInspection(inspectionID);
		if (tmpPhysicalAsset)
		{
			const tmpPolyJoin = (await this._get(`PhysicalAssetPolyJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${tmpPhysicalAsset.IDPhysicalAsset}~FBV~RemoteType~EQ~Bridge`))[0];
			if (tmpPolyJoin)
			{
				return await this._get(`Bridge/${tmpPolyJoin.IDRemote}`);
			}
		}
		return null;
	}

	/**
	 * @param {String} dateString
	 * @return {String} formattedDateString
	 */
	addCurrentTimeToDateString(dateString)
	{
		const dateStr = dateString ? dateString : new Date().toISOString();
		const currentDateAndTime = new Date();
		const hours = String(currentDateAndTime.getHours()).padStart(2, '0');
		const minutes = String(currentDateAndTime.getMinutes()).padStart(2, '0');
		const seconds = String(currentDateAndTime.getSeconds()).padStart(2, '0');
		const timeString = `${hours}:${minutes}:${seconds}`;

		const formattedDateString = dateStr.includes('T') ? `${dateStr.split('T')[0]}T${timeString}:000Z` : `${dateStr}T${timeString}:000Z`;
		return formattedDateString;
	}

	/**
	 * Load the list of current inspection documents for an inspection.
	 * @param {number|string} inspectionID
	 * @return {Promise<Array<any>>} The list of current inspection documents.
	 */
	async getListOfCurrentInspectionIDDocuments(inspectionID)
	{
		if (!inspectionID)
		{
			throw new Error('InspectionID is required');
		}
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		if (inspectionDocJoins.length === 0)
		{
			this.log.warn(`No inspection documents found for inspection ID ${inspectionID}`);
			return [];
		}
		const inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}`);
		if (inspectionDocs.length === 0)
		{
			this.log.warn(`No inspection documents found for inspection ID ${inspectionID} with joins ${inspectionDocJoins.map((j) => j.IDDocument).join(',')}`);
			return [];
		}
		// return only the IDDocuments that are not deleted
		const IDDocumentList = inspectionDocs.filter((doc) => !doc.Deleted).map((j) => j.IDDocument);
		return IDDocumentList.length > 0 ? IDDocumentList : [];
	}

	/**
	 * Create missing inspection documents.
	 *
	 * @param {any} inspection
	 * @param {Number} [projectID]
	 *
	 * @return {Promise<Array<any>>} The documents
	 */
	async createInspectionDocuments(inspection, projectID)
	{
		const createdDocs = [];
		const inspectionID = typeof inspection === 'number' && inspection;
		if (inspectionID && inspectionID > 0)
		{
			// support ID for convenience
			inspection = (await this._get(`Inspections/FilteredTo/FBV~IDInspection~EQ~${inspectionID}`))[0];
		}
		if (!inspection)
		{
			throw new Error('Inspection is required');
		}
		if (!inspection.IDInspection)
		{
			this.log.error('Inspection does not have an IDInspection', { inspection });
			return createdDocs;
		}
		if (!inspection.IDInspectionType)
		{
			this.log.error('Inspection does not have an IDInspectionType', { inspection });
			return createdDocs;
		}
		if (!projectID)
		{
			projectID = inspection.IDProject;
		}
		if (!projectID)
		{
			throw new Error('ProjectID is required to create inspection documents; either pass it or set it on the inspection');
		}

		// get expected documents for inspection type
		const rniJoins = await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${inspection.IDInspectionType}~FSF~Ordinal~ASC~0~FSF~IDInspectionTypeReportNamedInstanceJoin~ASC~0`);

		// get existing documents for inspection
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspection.IDInspection);
		const inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((d) => d.IDDocument).join(',')}`);

		// create missing documents
		const rnis = await this._get(`ReportNamedInstances/FilteredTo/FBL~IDReportNamedInstance~INN~${rniJoins.map((rni) => rni.IDReportNamedInstance).join(',')}`);

		// Index RNIs by ID for lookup, then build missingTypes in rniJoin ordinal order
		const rnisByID = {};
		for (const rni of rnis)
		{
			rnisByID[rni.IDReportNamedInstance] = rni;
		}
		const missingTypes = rniJoins
			.map((join) => rnisByID[join.IDReportNamedInstance])
			.filter((rni) => rni && !inspectionDocs.some((d) => d.DocumentType === rni.Hash));

		const bridge = await this._getBridgeForInspection(inspection.IDInspection);

		const formData = { };
		if (bridge)
		{
			// this lets the form know this is coming from external so it can handle it specially
			formData.InitialIDBridge = String(bridge.IDBridge);
		}
		let dossier;
		for (const rni of missingTypes)
		{
			const inspectionDate = inspection.StartDate || inspection.ScheduledStartDate || new Date().toISOString();
			const inspectionDateWithCurrentTime = this.addCurrentTimeToDateString(inspectionDate);
			const documentPayload =
			{
				IDProject: projectID,
				DocumentType: rni.Hash,
				Name: `${rni.Name} for ${inspection.Name}`,
				DocumentDate: inspectionDateWithCurrentTime,
				Form: 1,
				FormData: Object.assign({}, formData),
			};
			if (rni.Hash === 'Bridge-Inspection')
			{
				documentPayload.FormData.CurrentInspection = { Date: this._formatDate(inspectionDate, 'MM/YYYY') };
			}
			const doc = await this._post('Document', documentPayload);
			if (doc.DocumentType === 'Inspection-Dossier')
			{
				dossier = doc;
			}
			inspectionDocJoins.push(
				{
					IDInspection: inspection.IDInspection,
					IDDocument: doc.IDDocument,
					IncludeOnDossier: 1,
				});
			inspectionDocs.push(doc);
			createdDocs.push(doc);
		}
		// New docs were created in InspectionTypeReportNamedInstanceJoin.Ordinal order;
		// existing inspections keep their user-set order with new docs appended.
		const updatedJoins = await this._saveJoins(inspectionDocJoins);

		if (!dossier)
		{
			dossier = (await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${updatedJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`))[0];
		}
		if (dossier)
		{
			const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
			for (const join of updatedJoins)
			{
				if (join.IDDocument == dossier.IDDocument)
				{
					continue;
				}
				if (!join.IncludeOnDossier)
				{
					continue;
				}
				if (!previousDPJoins.some((j) => j.RemoteType == 'Document' && j.IDRemote == join.IDDocument))
				{
					previousDPJoins.push({ IDDocument: dossier.IDDocument, IDRemote: join.IDDocument, RemoteType: 'Document', Ordinal: 0 });
				}
			}

			this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
			await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
		}
		return createdDocs;
	}

	/**
	 * @typedef {Function} InspectionDocumentsCallback
	 * @param {any} [error] - The error, if any.
	 * @param {Array<any>} [documents] - The documents, if no error.
	 */

	/**
	 * Create missing inspection documents.
	 *
	 * @param {any} inspection
	 * @param {InspectionDocumentsCallback} callback
	 */
	createInspectionDocumentsCallback(inspection, callback)
	{
		const onceCallback = (err, docs) =>
		{
			const cb = callback;
			callback = () =>
			{
			};
			cb(err, docs);
		};
		this.createInspectionDocuments(inspection).then((docs) => onceCallback(null, docs)).catch((err) => onceCallback(err));
	}

	/**
	 * Add a document type to an inspection type.
	 *
	 * @param {Number} inspectionTypeID
	 * @param {Number} reportNamedInstanceID
	 *
	 * @return {Promise<any>} The (existing, or new) join object.
	 */
	async addDocumentTypeToInspectionType(inspectionTypeID, reportNamedInstanceID)
	{
		if (!(inspectionTypeID > 0) || !(reportNamedInstanceID > 0))
		{
			throw new Error('InspectionTypeID and ReportNamedInstanceID are required');
		}
		if (!(await this._get(`InspectionType/${inspectionTypeID}`))) // don't care, just make sure it exists
		{
			throw new Error(`InspectionType with ID ${inspectionTypeID} does not exist`);
		}
		if (!(await this._get(`ReportNamedInstance/${reportNamedInstanceID}`))) // don't care, just make sure it exists
		{
			throw new Error(`ReportNamedInstance with ID ${reportNamedInstanceID} does not exist`);
		}
		const existing = (await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${inspectionTypeID}~FBV~IDReportNamedInstance~EQ~${reportNamedInstanceID}~FSF~Ordinal~ASC~0~FSF~IDInspectionTypeReportNamedInstanceJoin~ASC~0`))[0];
		if (existing)
		{
			return existing;
		}
		return await this._post('InspectionTypeReportNamedInstanceJoin',
			{
				IDInspectionType: inspectionTypeID,
				IDReportNamedInstance: reportNamedInstanceID,
			});
	}

	/**
	 * @typedef {Function} AddDocumentTypeToInspectionTypeCallback
	 * @param {any} [error] - The error, if any.
	 * @param {any} [join] - The join object, if no error.
	 */

	/**
	 * Create missing inspection documents.
	 *
	 * @param {Number} inspectionTypeID
	 * @param {Number} reportNamedInstanceID
	 * @param {AddDocumentTypeToInspectionTypeCallback} callback
	 */
	addDocumentTypeToInspectionTypeCallback(inspectionTypeID, reportNamedInstanceID, callback)
	{
		const onceCallback = (err, docs) =>
		{
			const cb = callback;
			callback = () =>
			{
			};
			cb(err, docs);
		};
		this.addDocumentTypeToInspectionType(inspectionTypeID, reportNamedInstanceID).then((docs) => onceCallback(null, docs)).catch((err) => onceCallback(err));
	}

	/**
	 * Set the included bit on a document in an inspection.
	 *
	 * @param {Number} documentID
	 * @param {Number} inspectionID
	 * @param {Boolean} isIncluded
	 */
	async includeDocumentInInspectionDossier(documentID, inspectionID, isIncluded)
	{
		const join = await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${inspectionID}~FBV~IDDocument~EQ~${documentID}`).then((joins) => joins[0]);
		if (!join)
		{
			throw new Error(`Document ${documentID} is not associated with inspection ${inspectionID}`);
		}
		const newInclude = !!isIncluded ? 1 : 0;
		if (newInclude == join.IncludeOnDossier)
		{
			return join;
		}
		join.IncludeOnDossier = newInclude;
		const inspectionDocumentJoin = await this._put(`InspectionDocumentJoin`, join);
		// get dossier from inspection
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const dossier = await this._get(`Documents/Lite/FilteredTo/FBV~DocumentType~EQ~Inspection-Dossier~FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}`).then((docs) => docs[0]);
		if (!dossier)
		{
			this.log.warn(`Inspection ${inspectionID} does not have an associated dossier document`);
			return inspectionDocumentJoin;
		}
		// ensure it has a document poly join to this document (or not) based on isIncluded
		const existingPolyJoin = await this._loadDocumentPolyJoinToDocument(dossier.IDDocument, documentID);
		if (existingPolyJoin && !isIncluded)
		{
			await this._deleteEntity(`DocumentPolyJoin`, existingPolyJoin.IDDocumentPolyJoin);
		}
		else if (!existingPolyJoin && isIncluded && dossier.IDDocument != documentID)
		{
			const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
			const orderedDPJoins = previousDPJoins.concat([ { IDDocument: dossier.IDDocument, RemoteType: 'Document', IDRemote: documentID } ]);
			this._sortDocumentPolyJoinsByInspectionJoins(inspectionDocJoins, orderedDPJoins);
			await this._saveJoins(orderedDPJoins, 'DocumentPolyJoin');
		}
		return inspectionDocumentJoin;
	}

	/**
	 * @param {number|string} documentID
	 * @param {number|string} inspectionID
	 * @param {boolean} [includeOnDossier=false]
	 */
	async addDocumentToInspection(documentID, inspectionID, includeOnDossier = false)
	{
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const existingJoin = inspectionDocJoins.find((j) => j.IDDocument == documentID);
		let dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
		const existingPolyJoin = dossier && await this._loadDocumentPolyJoinToDocument(dossier.IDDocument, documentID);
		if (existingJoin && (existingJoin.IncludeOnDossier ? existingPolyJoin : !existingPolyJoin))
		{
			throw new Error(`Document ${documentID} is already associated with inspection ${inspectionID}`);
		}

		let updatedJoins = inspectionDocJoins;
		let join = existingJoin;
		if (!join)
		{
			join = await this._post('InspectionDocumentJoin', { IDInspection: inspectionID, IDDocument: documentID, IncludeOnDossier: includeOnDossier ? 1 : 0 });
			const orderedJoins = inspectionDocJoins.concat([ join ]);
			updatedJoins = await this._saveJoins(orderedJoins);
		}
		if (join.IncludeOnDossier && !existingPolyJoin)
		{
			// decided to not delete joins here since this is an add method
			if (!dossier)
			{
				// handles the case where the document being added is a dossier, so we add existing documents to it
				dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~EQ~${documentID}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
				if (dossier)
				{
					let needToSave = false;
					const polyJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
					// need to create joins to this dossier?
					for (const join of updatedJoins)
					{
						if (join.IDDocument == dossier.IDDocument || !join.IncludeOnDossier || polyJoins.some((j) => j.IDRemote == join.IDDocument))
						{
							continue;
						}
						needToSave = true;
						polyJoins.push({ IDDocument: dossier.IDDocument, RemoteType: 'Document', IDRemote: join.IDDocument });
					}

					if (needToSave)
					{
						this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, polyJoins);
						await this._saveJoins(polyJoins, 'DocumentPolyJoin');
					}
				}
			}
			else
			{
				const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
				const orderedDPJoins = previousDPJoins.concat([ { IDDocument: dossier.IDDocument, RemoteType: 'Document', IDRemote: documentID } ]);
				this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, orderedDPJoins);
				await this._saveJoins(orderedDPJoins, 'DocumentPolyJoin');
			}
		}

		return join;
	}

	/**
	 * @private
	 * @param {Array<any>} inspectionDocJoins
	 * @param {Array<any>} documentPolyJoins
	 */
	_sortDocumentPolyJoinsByInspectionJoins(inspectionDocJoins, documentPolyJoins)
	{
		const joinsByIDDocument = {};
		for (const join of inspectionDocJoins)
		{
			joinsByIDDocument[join.IDDocument] = join;
		}
		documentPolyJoins.sort((a, b) =>
		{
			const joinA = joinsByIDDocument[a.IDRemote];
			const joinB = joinsByIDDocument[b.IDRemote];
			if (!joinA && !joinB)
			{
				return 0;
			}
			if (!joinB)
			{
				return -1;
			}
			if (!joinA)
			{
				return 1;
			}
			return joinA.Ordinal - joinB.Ordinal;
		});
	}

	/**
	 * @param {number|string} inspectionID
	 * @param {number|string} documentID
	 * @param {number} ordinalOffset
	 */
	async rearrangeDocument(inspectionID, documentID, ordinalOffset)
	{
		if (!ordinalOffset)
		{
			return;
		}
		/** @type {Array<any>} */
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const existingJoinIndex = inspectionDocJoins.findIndex((j) => j.IDDocument == documentID);
		if (existingJoinIndex < 0)
		{
			throw new Error(`Document ${documentID} is not associated with inspection ${inspectionID}`);
		}
		if (existingJoinIndex + ordinalOffset < 0 || existingJoinIndex + ordinalOffset >= inspectionDocJoins.length)
		{
			this.log.error(`Document ${documentID} cannot be moved to ordinal ${existingJoinIndex + ordinalOffset} in inspection ${inspectionID}`,
				{ inspectionID, documentID, ordinalOffset, existingJoinIndex });
			return;
		}
		const existingJoin = inspectionDocJoins[existingJoinIndex];
		inspectionDocJoins.splice(existingJoinIndex, 1);
		inspectionDocJoins.splice(existingJoinIndex + ordinalOffset, 0, existingJoin);
		const updatedJoins = await this._saveJoins(inspectionDocJoins);

		const dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
		const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
		this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
		await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
	}

	/**
	 * @param {number|string} documentID
	 * @param {number|string} inspectionID
	 */
	async removeDocumentFromInspection(documentID, inspectionID)
	{
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
		const existingJoin = inspectionDocJoins.find((j) => j.IDDocument == documentID);
		const dossier = await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`).then((docs) => docs[0]);
		const existingPolyJoin = dossier && await this._loadDocumentPolyJoinToDocument(dossier.IDDocument, documentID);

		if (!existingJoin && !existingPolyJoin)
		{
			throw new Error(`Document ${documentID} is not associated with inspection ${inspectionID}`);
		}
		if (existingJoin)
		{
			await this._deleteEntity('InspectionDocumentJoin', existingJoin.IDInspectionDocumentJoin);
		}
		if (existingPolyJoin)
		{
			await this._deleteEntity('DocumentPolyJoin', existingPolyJoin.IDDocumentPolyJoin);
		}
	}

	/**
	 * @param {Array<any>} joins
	 * @param {string} [table='InspectionDocumentJoin']
	 * @return {Promise<Array<any>>} the updated joins
	 */
	async _saveJoins(joins, table = 'InspectionDocumentJoin')
	{
		const updatedJoins = [];
		// update join ordinals and create / update records as needed
		for (let i = 0; i < joins.length; i++)
		{
			const join = joins[i];
			const desiredOrdinal = i;
			if (join[`ID${table}`]) // existing record
			{
				if (join.Ordinal == desiredOrdinal)
				{
					updatedJoins.push(join);
					continue;
				}
				join.Ordinal = desiredOrdinal;
				const updated = await this._put(table, join);
				updatedJoins.push(updated);
			}
			else
			{
				join.Ordinal = desiredOrdinal;
				const created = await this._post(table, join);
				updatedJoins.push(created);
			}
		}
		return updatedJoins;
	}

	/**
	 * Reorder the InspectionTypeReportNamedInstanceJoins for an inspection type.
	 *
	 * @param {Number} inspectionTypeID
	 * @param {Array<Number>} orderedJoinIDs - The IDs of the joins in the desired order.
	 *
	 * @return {Promise<Array<any>>} The updated joins.
	 */
	async reorderInspectionTypeDocuments(inspectionTypeID, orderedJoinIDs)
	{
		if (!(inspectionTypeID > 0))
		{
			throw new Error('InspectionTypeID is required');
		}
		if (!Array.isArray(orderedJoinIDs) || orderedJoinIDs.length === 0)
		{
			throw new Error('orderedJoinIDs must be a non-empty array');
		}
		// Verify the inspection type exists
		if (!(await this._get(`InspectionType/${inspectionTypeID}`)))
		{
			throw new Error(`InspectionType with ID ${inspectionTypeID} does not exist`);
		}

		// Bulk load all joins for this inspection type
		const allJoins = await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${inspectionTypeID}~FSF~Ordinal~ASC~0~FSF~IDInspectionTypeReportNamedInstanceJoin~ASC~0`);

		// Sniff test: ensure the passed IDs cover all joins (no partial reorders)
		if (orderedJoinIDs.length !== allJoins.length)
		{
			throw new Error(`Expected ${allJoins.length} join IDs for InspectionType ${inspectionTypeID} but received ${orderedJoinIDs.length}; all joins must be included in a reorder`);
		}

		// Index joins by ID for fast lookup
		const joinsByID = {};
		for (const join of allJoins)
		{
			joinsByID[join.IDInspectionTypeReportNamedInstanceJoin] = join;
		}

		// Validate every passed ID exists and belongs to this inspection type
		for (const joinID of orderedJoinIDs)
		{
			if (!joinsByID[joinID])
			{
				throw new Error(`InspectionTypeReportNamedInstanceJoin with ID ${joinID} does not exist for InspectionType ${inspectionTypeID}`);
			}
		}

		// Only update joins whose ordinal actually changed
		const updatedJoins = [];
		for (let i = 0; i < orderedJoinIDs.length; i++)
		{
			const join = joinsByID[orderedJoinIDs[i]];
			if (join.Ordinal !== i)
			{
				join.Ordinal = i;
				const updated = await this._put('InspectionTypeReportNamedInstanceJoin', join);
				updatedJoins.push(updated);
			}
			else
			{
				updatedJoins.push(join);
			}
		}
		return updatedJoins;
	}

	/**
	 * NOTE: stolen from pict DateFormat template instruction
	 * @param {string} dateValue
	 * @param {string} formatString
	 * @return {string}
	 */
	_formatDate(dateValue, formatString)
	{
		let tmpDayJS = this.fable.Dates.dayJS.utc(dateValue);
		try
		{
			// Try to cast the day to be a specific timezone if one is set for the app
			if (this.options.Timezone)
			{
				tmpDayJS = tmpDayJS.tz(this.options.Timezone);
			}
			else
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
		}
		catch
		{
			//this.log.error(`Error casting date passed timezone using tz .. casting to the browser guess which is [${this.fable.Dates.dayJS.tz.guess()}].`);
			// Day.js will try to guess the user's timezone for us
			try
			{
				tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
			}
			catch (pError)
			{
				this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
			}
		}

		return tmpDayJS.format(formatString);
	}

	/**
	 * @param {Number|String} inspectionID
	 * @param {Number|String} projectID
	 * @param {String} documentType
	 * @param {Number|String} userID
	 * @param {Boolean} [includeOnDossier=true]
	 * @return {Promise<any>}
	 */
	async createInspectionDocumentForUser(inspectionID, projectID, documentType, userID, includeOnDossier = true)
	{
		const user = await this._get(`User/${userID}`);
		if (!user)
		{
			throw new Error(`User with ID ${userID} not found`);
		}
		const inspection = await this._get(`Inspection/${inspectionID}`);
		if (!inspection)
		{
			throw new Error(`Inspection with ID ${inspectionID} not found`);
		}
		const rni = (await this._get(`ReportNamedInstancesByProject/${projectID}/0/100`)).find((rni) => rni.Hash === documentType);
		if (!rni)
		{
			throw new Error(`Failed to resolve report hash ${documentType} in project ${projectID}`);
		}
		const bridge = await this._getBridgeForInspection(inspectionID);
		const documentPayload =
		{
			//TODO: should we put their name in the document name? makes re-assign really funky
			Name: `${rni.Name} for ${inspection.Name}`,
			IDProject: projectID,
			DocumentType: documentType,
			DocumentDate: new Date().toISOString(),
			Form: 1,
			FormData: { },
		};
		const inspectionDate = inspection.StartDate || inspection.ScheduledStartDate;
		if (bridge)
		{
			documentPayload.FormData.InitialIDBridge = bridge.IDBridge;
		}
		if (rni.Hash === 'Bridge-Inspection')
		{
			documentPayload.FormData.CurrentInspection = { Date: this._formatDate(inspectionDate, 'MM/YYYY') };
		}
		//TODO: check if user already has a document of this type?
		const doc = await this._post('Document', documentPayload);
		const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspection.IDInspection);
		const newJoin = await this._post('InspectionDocumentJoin', { IDInspection: inspectionID, IDDocument: doc.IDDocument, IncludeOnDossier: includeOnDossier ? 1 : 0 });
		const orderedJoins = inspectionDocJoins.concat([ newJoin ]);
		const updatedJoins = await this._saveJoins(orderedJoins);

		if (includeOnDossier)
		{
			const dossier = (await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${updatedJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`))[0];
			if (dossier && dossier.IDDocument != doc.IDDocument)
			{
				const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
				if (!previousDPJoins.some((j) => j.RemoteType == 'Document' && j.IDRemote == doc.IDDocument))
				{
					previousDPJoins.push({ IDDocument: dossier.IDDocument, IDRemote: doc.IDDocument, RemoteType: 'Document' });
				}
				this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
				await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
			}
		}

		await this._get(`Permissions/AssignOwner/Document/${doc.IDDocument}/To/User/${userID}`);
		// ensure it has a document poly join to this document (or not) based on isIncluded
		return doc;
	}

	/**
	 * @param {String} field
	 * @param {Set<String>} touchedMergedElementConditions
	 * @return {boolean}
	 */
	_fieldSeen(field, touchedMergedElementConditions)
	{
		if (touchedMergedElementConditions.has(field))
		{
			return true;
		}
		touchedMergedElementConditions.add(field);
		return false;
	}

	/**
	 * NOTE: provisional - we want to make a tool to allow manual merging eventually
	 *
	 * FIXME: The only document type that this currently supports is bridge inspection (element condition) documents.
	 *
	 * @param {Number|String} inspectionID
	 * @param {Number|String} documentType
	 * @param {Array<Number|String>} [documentIDs]
	 * @param {Number|String} [existingMergedDocumentID]
	 * @param {Boolean} [includeOnDossier=true]
	 */
	async mergeDocuments(inspectionID, documentType, documentIDs, existingMergedDocumentID, includeOnDossier = true)
	{
		if (documentType !== 'Bridge-Inspection')
		{
			throw new Error(`Document type ${documentType} is not supported for merging`);
		}
		// load inspection documents of the given type
		/** @type {Array<any>} */
		let inspectionDocs;
		if (Array.isArray(documentIDs))
		{
			inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${documentIDs.join(',')}~FBV~DocumentType~EQ~${documentType}`);
		}
		else
		{
			const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
			inspectionDocs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${inspectionDocJoins.map((d) => d.IDDocument).join(',')}~FBV~DocumentType~EQ~${documentType}`);
		}
		if (!inspectionDocs || inspectionDocs.length < 2)
		{
			throw new Error(`Inspection ${inspectionID} does not have at least two documents of type ${documentType}`);
		}
		let existingMergedDoc;
		if (!existingMergedDocumentID)
		{
			existingMergedDoc = inspectionDocs.find((d) => d.FormData?.Meta?.Merge == true);
			if (existingMergedDoc)
			{
				existingMergedDocumentID = existingMergedDoc.IDDocument;
			}
		}
		// sanity check documents
		let docType;
		let projectID;
		for (const doc of inspectionDocs)
		{
			if (!docType)
			{
				docType = doc.DocumentType;
			}
			else if (doc.DocumentType !== docType)
			{
				throw new Error(`Documents are not all of the same type; expected ${docType} but found ${doc.DocumentType} on document ${doc.IDDocument}`);
			}
			if (!projectID)
			{
				projectID = doc.IDProject;
			}
			else if (doc.IDProject != projectID)
			{
				throw new Error(`Documents are not all in the same project; expected ${projectID} but found ${doc.IDProject} on document ${doc.IDDocument}`);
			}
		}
		// merge
		let newDoc;
		let resetConcat = false; // for concatentated fields, should we reset to note duplicate values
		if (existingMergedDocumentID)
		{
			if (!existingMergedDoc)
			{
				existingMergedDoc = inspectionDocs.find((d) => d.IDDocument == existingMergedDocumentID);
			}
			if (existingMergedDoc)
			{
				newDoc = existingMergedDoc;
				inspectionDocs = inspectionDocs.filter((d) => d.IDDocument != existingMergedDocumentID);
				resetConcat = true;
			}
			else
			{
				newDoc = this._get(`Document/${existingMergedDocumentID}`);
			}
		}
		if (!newDoc)
		{
			newDoc = JSON.parse(JSON.stringify(inspectionDocs.shift()));
			newDoc.Name = `${newDoc.Name} (Merged)`;
			delete newDoc.IDDocument;
			delete newDoc.GUIDDocument;
			delete newDoc.CreatingIDUser;
			delete newDoc.CreateDate;
			delete newDoc.UpdatingIDUser;
			delete newDoc.UpdateDate;
			if (!newDoc.FormData)
			{
				newDoc.FormData = { };
			}
			if (!newDoc.FormData.Meta)
			{
				newDoc.FormData.Meta = { };
			}
			newDoc.FormData.Meta.Merge = true;
		}
		if (!Array.isArray(newDoc.Observations))
		{
			newDoc.Observations = [];
		}
		const mergedFormData = newDoc.FormData;
		const touchedMergedElementConditions = new Set();
		for (const doc of inspectionDocs)
		{
			if (Array.isArray(doc.Observations))
			{
				for (const obsID of doc.Observations)
				{
					if (!newDoc.Observations.includes(obsID))
					{
						newDoc.Observations.push(obsID);
					}
				}
			}
			const formData = doc.FormData;
			if (typeof formData.ElementConditionTotalMap === 'object')
			{
				if (!mergedFormData.ElementConditionTotalMap)
				{
					mergedFormData.ElementConditionTotalMap = { };
				}
				for (const elementID in formData.ElementConditionTotalMap)
				{
					if (mergedFormData.ElementConditionTotalMap.hasOwnProperty(elementID))
					{
						const mergedElementCondition = mergedFormData.ElementConditionTotalMap[elementID];
						const elementCondition = formData.ElementConditionTotalMap[elementID];
						mergedElementCondition.CS2 = String((parseInt(mergedElementCondition.CS2) || 0) + (parseInt(elementCondition.CS2) || 0));
						mergedElementCondition.CS3 = String((parseInt(mergedElementCondition.CS3) || 0) + (parseInt(elementCondition.CS3) || 0));
						mergedElementCondition.CS4 = String((parseInt(mergedElementCondition.CS4) || 0) + (parseInt(elementCondition.CS4) || 0));
						if (mergedElementCondition.TotalAmount)
						{
							mergedElementCondition.CS1 = String(parseInt(mergedElementCondition.TotalAmount) -
								(parseInt(mergedElementCondition.CS2) || 0) - (parseInt(mergedElementCondition.CS3) || 0) - (parseInt(mergedElementCondition.CS4) || 0));
							mergedElementCondition.CS1Percentage = String((parseInt(mergedElementCondition.CS1) / parseInt(mergedElementCondition.TotalAmount) * 100));
							mergedElementCondition.CS2Percentage = String((parseInt(mergedElementCondition.CS2) / parseInt(mergedElementCondition.TotalAmount) * 100));
							mergedElementCondition.CS3Percentage = String((parseInt(mergedElementCondition.CS3) / parseInt(mergedElementCondition.TotalAmount) * 100));
							mergedElementCondition.CS4Percentage = String((parseInt(mergedElementCondition.CS4) / parseInt(mergedElementCondition.TotalAmount) * 100));
						}

						if (Array.isArray(elementCondition.Defects))
						{
							if (!Array.isArray(mergedElementCondition.Defects))
							{
								mergedElementCondition.Defects = [];
							}
							for (const defect of elementCondition.Defects)
							{
								const existingDefect = mergedElementCondition.Defects.find((d) => d.GUIDPart == defect.GUIDPart);
								if (existingDefect)
								{
									mergedElementCondition.Defects = mergedElementCondition.Defects.filter((d) => d.GUIDPart != defect.GUIDPart);
								}
								mergedElementCondition.Defects.push(defect);
								this._transferDefect(doc, newDoc, defect);
							}
						}
					}
					else
					{
						mergedFormData.ElementConditionTotalMap[elementID] = JSON.parse(JSON.stringify(formData.ElementConditionTotalMap[elementID]));
					}
				}
			}
			if (typeof formData.CurrentInspection === 'object')
			{
				if (!mergedFormData.CurrentInspection)
				{
					mergedFormData.CurrentInspection = { };
				}
				for (const field in formData.CurrentInspection)
				{
					if (field == 'ElementConditions')
					{
						if (!mergedFormData.CurrentInspection.ElementConditions)
						{
							mergedFormData.CurrentInspection.ElementConditions = { };
						}
						// merge notes
						for (const elementID of Object.keys(formData.CurrentInspection.ElementConditions))
						{
							if (!mergedFormData.CurrentInspection.ElementConditions[elementID])
							{
								mergedFormData.CurrentInspection.ElementConditions[elementID] = { };
							}
							if (resetConcat && !this._fieldSeen(`CurrentInspection.ElementConditions.${elementID}.Notes`, touchedMergedElementConditions))
							{
								mergedFormData.CurrentInspection.ElementConditions[elementID].Notes = formData.CurrentInspection.ElementConditions[elementID].Notes;
							}
							else if (typeof formData.CurrentInspection.ElementConditions[elementID].Notes === 'string' && formData.CurrentInspection.ElementConditions[elementID].Notes.length > 0)
							{
								if (!mergedFormData.CurrentInspection.ElementConditions[elementID].Notes)
								{
									mergedFormData.CurrentInspection.ElementConditions[elementID].Notes = formData.CurrentInspection.ElementConditions[elementID].Notes;
								}
								else
								{
									mergedFormData.CurrentInspection.ElementConditions[elementID].Notes += '\n';
									mergedFormData.CurrentInspection.ElementConditions[elementID].Notes += formData.CurrentInspection.ElementConditions[elementID].Notes;
								}
							}
						}
					}
					else if (!mergedFormData.CurrentInspection.hasOwnProperty(field))
					{
						mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
					}
					else if (this._fieldsToConcat.includes(field))
					{
						if (resetConcat && !this._fieldSeen(`CurrentInspection.${field}`, touchedMergedElementConditions))
						{
							mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
						}
						// merge field - we don't merge all of them, but remarks etc get concatenated
						else if (typeof formData.CurrentInspection[field] === 'string' && formData.CurrentInspection[field].length > 0)
						{
							if (!mergedFormData.CurrentInspection[field])
							{
								mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
							}
							else
							{
								mergedFormData.CurrentInspection[field] += '\n';
								mergedFormData.CurrentInspection[field] += formData.CurrentInspection[field];
							}
						}
					}
					else if (!mergedFormData.CurrentInspection[field])
					{
						mergedFormData.CurrentInspection[field] = formData.CurrentInspection[field];
					}
				}
			}
			for (const formDataKey of Object.keys(formData))
			{
				if (!mergedFormData.hasOwnProperty(formDataKey))
				{
					mergedFormData[formDataKey] = formData[formDataKey];
				}
			}
		}

		delete newDoc.FormData.InitialIDBridge; // never want this on a merged doc - can be there if one doc to merge was never opened
		// save as new document
		const savedMergedDoc = await this._put('Document/Upsert', newDoc);
		if (!newDoc.IDDocument)
		{
			const inspectionDocJoins = await this._loadInspectionDocumentJoins(inspectionID);
			const orderedJoins = inspectionDocJoins.concat([ { IDInspection: inspectionID, IDDocument: savedMergedDoc.IDDocument, IncludeOnDossier: includeOnDossier ? 1 : 0 } ]);
			const updatedJoins = await this._saveJoins(orderedJoins);
			if (includeOnDossier)
			{
				const dossier = (await this._get(`Documents/Lite/FilteredTo/FBL~IDDocument~INN~${updatedJoins.map((j) => j.IDDocument).join(',')}~FBV~DocumentType~EQ~Inspection-Dossier`))[0];
				if (dossier)
				{
					const previousDPJoins = await this._loadDocumentPolyJoinsFromDocument(dossier.IDDocument);
					if (!previousDPJoins.some((j) => j.RemoteType == 'Document' && j.IDRemote == savedMergedDoc.IDDocument))
					{
						previousDPJoins.push({ IDDocument: dossier.IDDocument, IDRemote: savedMergedDoc.IDDocument, RemoteType: 'Document' });
						this._sortDocumentPolyJoinsByInspectionJoins(updatedJoins, previousDPJoins);
						await this._saveJoins(previousDPJoins, 'DocumentPolyJoin');
					}
				}
			}
		}
	}

	/**
	 * @param {any} mergedFormData
	 * @param {any} sourceFormData
	 * @param {any} defect
	 */
	_transferDefect(mergedFormData, sourceFormData, defect)
	{
		// observation set binding to defect
		const binding = `${defect.IDDefect}-${defect.GUIDPart}`;
		if (sourceFormData[binding])
		{
			if (mergedFormData[binding] && mergedFormData[binding] != sourceFormData[binding])
			{
				this.fable.log.warn(`Defect binding ${binding} already exists in merged document`, { old: mergedFormData[binding], new: sourceFormData[binding] });
			}
			mergedFormData[binding] = sourceFormData[binding];
		}
	}
}

module.exports = HeadlightBridgeDocumentManager;

},{"fable-serviceproviderbase":438,"headlight-rest-client":20,"util":821}],3:[function(require,module,exports){
(function (setImmediate){(function (){
/* eslint brace-style: ["error", "allman"] */

/**
 * A comprehension the processor can consume without holding it in memory.
 *
 * The processor used to take the whole comprehension as one object, which caps a load at whatever
 * fits in the heap — and the records are the overwhelming majority of that. Everything it does
 * before the records reach an adapter, though, needs only two things up front:
 *
 *   1. which entity types are present, and
 *   2. the *shape* of each — the field names, which is what the dependency sort reads.
 *
 * So a source declares those two, and hands records over in batches. A caller with a comprehension
 * already in memory builds one with `fromComprehension`; a caller reading a lake table builds one
 * that pages.
 *
 * ## Shapes carry two field sets, and the distinction is load-bearing
 *
 * The dependency sort treats the two reference forms differently, and collapsing them changes the
 * graph:
 *
 *   - `GUID<Entity>` / `_GUID<Entity>` create an edge only when some record holds a **truthy value**.
 *     A record carrying `GUIDMaterial: ''` does not depend on Material.
 *   - `…_Via_GUID<Entity>` creates an edge on **field name alone**.
 *
 * A shape built from field names only would invent dependencies from empty columns — and since the
 * sort throws on a cycle, an invented edge can fail a load that would otherwise have run.
 *
 * @typedef {Object} EntityShape
 * @property {Array<string>} Fields - Every field name seen on any record of this entity.
 * @property {Array<string>} PopulatedFields - Field names that held a truthy value on some record.
 *
 * @typedef {Object} ComprehensionSource
 * @property {Array<string>} EntityTypes - Entity names, in no particular order; the sort orders them.
 * @property {Object<string, EntityShape>} EntityShapes
 * @property {(pEntity: string) => number|null} recordCount - Known count, or null when unknowable
 *           without reading (a paging source may not know until it has read).
 * @property {(pEntity: string, fOnBatch: (pRecords: Array<Object>, fNext: (pError?: Error) => void) => void, fDone: (pError?: Error) => void) => void} streamRecords
 */

/**
 * Fold one record into an accumulating shape.
 *
 * @param {EntityShape} pShape
 * @param {Object} pRecord
 * @return {EntityShape}
 */
const foldRecordIntoShape = function(pShape, pRecord)
{
	if (!pRecord || (typeof(pRecord) !== 'object'))
	{
		return pShape;
	}
	for (const tmpFieldKey of Object.keys(pRecord))
	{
		if (pShape.Fields.indexOf(tmpFieldKey) < 0)
		{
			pShape.Fields.push(tmpFieldKey);
		}
		if (pRecord[tmpFieldKey] && (pShape.PopulatedFields.indexOf(tmpFieldKey) < 0))
		{
			pShape.PopulatedFields.push(tmpFieldKey);
		}
	}
	return pShape;
};

/**
 * @return {EntityShape}
 */
const emptyShape = function()
{
	return { Fields: [], PopulatedFields: [] };
};

/**
 * @param {Array<Object>|Object<string, Object>} pRecords
 * @return {EntityShape}
 */
const deriveEntityShape = function(pRecords)
{
	const tmpShape = emptyShape();
	const tmpList = Array.isArray(pRecords) ? pRecords : Object.values(pRecords || {});
	for (const tmpRecord of tmpList)
	{
		foldRecordIntoShape(tmpShape, tmpRecord);
	}
	return tmpShape;
};

/**
 * Wrap an in-memory comprehension as a source, so the streaming path is the only path the processor
 * has and the existing entry point keeps working unchanged.
 *
 * @param {Object<string, Array<Object>|Object<string, Object>>} pComprehension
 * @param {Object} [pOptions]
 * @param {number} [pOptions.BatchSize] - Records handed over per batch.
 * @return {ComprehensionSource}
 */
const fromComprehension = function(pComprehension, pOptions)
{
	const tmpComprehension = pComprehension || {};
	const tmpBatchSize = (pOptions && pOptions.BatchSize) || 5000;
	const tmpEntityTypes = Object.keys(tmpComprehension);
	/** @type {Object<string, EntityShape>} */
	const tmpShapes = {};
	for (const tmpEntity of tmpEntityTypes)
	{
		tmpShapes[tmpEntity] = deriveEntityShape(tmpComprehension[tmpEntity]);
	}

	const recordsOf = function(pEntity)
	{
		const tmpRecords = tmpComprehension[pEntity];
		if (!tmpRecords)
		{
			return [];
		}
		return Array.isArray(tmpRecords) ? tmpRecords : Object.values(tmpRecords);
	};

	return {
		EntityTypes: tmpEntityTypes,
		EntityShapes: tmpShapes,
		recordCount: (pEntity) => recordsOf(pEntity).length,
		streamRecords: (pEntity, fOnBatch, fDone) =>
		{
			const tmpRecords = recordsOf(pEntity);
			let tmpOffset = 0;
			const fPump = () =>
			{
				if (tmpOffset >= tmpRecords.length)
				{
					return fDone();
				}
				const tmpBatch = tmpRecords.slice(tmpOffset, tmpOffset + tmpBatchSize);
				tmpOffset += tmpBatchSize;
				// Recursing through the callback would grow the stack by one frame per batch on an
				// in-memory source, where nothing yields to the event loop between batches.
				return fOnBatch(tmpBatch, (pError) => (pError ? fDone(pError) : setImmediate(fPump)));
			};
			return fPump();
		},
	};
};

/**
 * A comprehension table stores either one record per row — `EntityName`, `RecordGUID`,
 * `RecordJSON` — or one CHUNK of records per row. The chunked layout exists because a single-pass
 * streaming clone cannot produce a per-record `RecordJSON`: `{~DataJson:Record~}` in that layout
 * serializes the source row, and building the JSON by string interpolation instead is what
 * produced 268 malformed rows the last time it was tried. A chunk's `RecordsJSON` is serialized
 * from the already-projected records, so the problem does not arise.
 *
 * @typedef {Object} ChunkRow
 * @property {string} EntityName
 * @property {number} ChunkOrdinal - 0-based, contiguous within an entity.
 * @property {number} ChunkCount - Chunks this entity is expected to have.
 * @property {number} RecordCount - Records in this chunk.
 * @property {number} SourceRowCount - Records this entity is expected to have.
 * @property {string} RecordsJSON - JSON array of records.
 */

/**
 * @param {Object} pRow
 * @return {boolean}
 */
const isChunkRow = function(pRow)
{
	return !!pRow && (typeof(pRow) === 'object') && Object.prototype.hasOwnProperty.call(pRow, 'RecordsJSON');
};

/**
 * @param {string|Array<Object>} pRecordsJSON
 * @param {string} pWhere - identifies the row in an error message
 * @return {Array<Object>}
 */
const parseChunkRecords = function(pRecordsJSON, pWhere)
{
	if (Array.isArray(pRecordsJSON))
	{
		return pRecordsJSON;
	}
	let tmpParsed;
	try
	{
		tmpParsed = JSON.parse(pRecordsJSON);
	}
	catch (pError)
	{
		throw new Error(`${pWhere}: RecordsJSON is not valid JSON — ${pError.message}`);
	}
	if (!Array.isArray(tmpParsed))
	{
		throw new Error(`${pWhere}: RecordsJSON parsed to ${typeof(tmpParsed)}, expected an array of records.`);
	}
	return tmpParsed;
};

/**
 * Everything a chunked entity claims about itself, accumulated as its rows are read.
 *
 * @return {Object}
 */
const emptyChunkTally = function()
{
	return { Ordinals: [], RecordSum: 0, DeclaredChunks: null, DeclaredRecords: null, Shape: emptyShape() };
};

/**
 * Decide whether an entity's chunks amount to a complete set.
 *
 * A dropped write costs `ChunkSize` records here rather than one, and `WriteRecords` has reported
 * success while losing whole chunks. So this is a precondition, not a diagnostic: three
 * independent invariants, any of which failing means the table is not loadable.
 *
 * @param {string} pEntity
 * @param {Object} pTally
 * @return {Array<string>} problems; empty when the entity is complete
 */
const findChunkProblems = function(pEntity, pTally)
{
	const tmpProblems = [];
	if (pTally.DeclaredChunks === null)
	{
		return [ `${pEntity}: no chunk rows found` ];
	}
	if (pTally.Ordinals.length !== pTally.DeclaredChunks)
	{
		tmpProblems.push(`${pEntity}: ${pTally.Ordinals.length} chunk row(s) present, ${pTally.DeclaredChunks} declared`);
	}
	const tmpSorted = pTally.Ordinals.slice().sort((pLeft, pRight) => pLeft - pRight);
	for (let i = 0; i < tmpSorted.length; i++)
	{
		if (tmpSorted[i] !== i)
		{
			tmpProblems.push(`${pEntity}: chunk ordinals are not contiguous — expected ${i}, found ${tmpSorted[i]}`);
			break;
		}
	}
	if (pTally.RecordSum !== pTally.DeclaredRecords)
	{
		tmpProblems.push(`${pEntity}: chunk record counts sum to ${pTally.RecordSum}, SourceRowCount declares ${pTally.DeclaredRecords}`);
	}
	return tmpProblems;
};

/**
 * Build a source over a chunked comprehension table.
 *
 * Two passes. The first reads every chunk row to derive each entity's shape and prove the set
 * complete, keeping only the shape — the records are parsed and discarded, so memory stays at one
 * chunk. The second pass is `streamRecords`, which re-reads and hands each chunk over as a batch.
 *
 * The shape cannot be sampled: `PopulatedFields` drives the dependency sort, and a populated field
 * that appears only in a late record would go unseen, dropping an edge and letting a child load
 * before its parent.
 *
 * @param {(pEntity: string|null, pOffset: number, pLimit: number, fCallback: (pError: Error|null, pRows?: Array<ChunkRow>) => void) => void} fReadChunkPage
 *        Pages chunk rows in a stable order. `pEntity` null means every entity.
 * @param {Object} [pOptions]
 * @param {number} [pOptions.PageSize] - Chunk ROWS per read. Resident records are this times the
 *        chunk size, so it is deliberately small.
 * @param {function} fCallback - function(pError, pSource)
 * @return {void}
 */
const fromChunkedTable = function(fReadChunkPage, pOptions, fCallback)
{
	const tmpPageSize = (pOptions && pOptions.PageSize) || 20;
	/** @type {Object<string, Object>} */
	const tmpTallies = {};
	let tmpOffset = 0;

	const fScanPage = () =>
	{
		fReadChunkPage(null, tmpOffset, tmpPageSize, (pError, pRows) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			const tmpRows = Array.isArray(pRows) ? pRows : [];
			if (tmpRows.length === 0)
			{
				return fFinishScan();
			}
			for (const tmpRow of tmpRows)
			{
				const tmpEntity = tmpRow.EntityName;
				if (!tmpEntity)
				{
					return fCallback(new Error(`Chunk row at offset ${tmpOffset} is missing EntityName — not a comprehension table.`));
				}
				if (!tmpTallies[tmpEntity])
				{
					tmpTallies[tmpEntity] = emptyChunkTally();
				}
				const tmpTally = tmpTallies[tmpEntity];
				let tmpRecords;
				try
				{
					tmpRecords = parseChunkRecords(tmpRow.RecordsJSON, `${tmpEntity} chunk ${tmpRow.ChunkOrdinal}`);
				}
				catch (pParseError)
				{
					return fCallback(pParseError);
				}
				tmpTally.Ordinals.push(parseInt(tmpRow.ChunkOrdinal, 10));
				tmpTally.RecordSum += tmpRecords.length;
				tmpTally.DeclaredChunks = parseInt(tmpRow.ChunkCount, 10);
				tmpTally.DeclaredRecords = parseInt(tmpRow.SourceRowCount, 10);
				// RecordCount is what the row claims; the parsed length is what it holds. A
				// disagreement means the row was truncated in transit and the sum below would
				// otherwise validate against the claim rather than the contents.
				const tmpClaimed = parseInt(tmpRow.RecordCount, 10);
				if (Number.isFinite(tmpClaimed) && (tmpClaimed !== tmpRecords.length))
				{
					return fCallback(new Error(`${tmpEntity} chunk ${tmpRow.ChunkOrdinal}: RecordCount claims ${tmpClaimed} but RecordsJSON holds ${tmpRecords.length}.`));
				}
				for (const tmpRecord of tmpRecords)
				{
					foldRecordIntoShape(tmpTally.Shape, tmpRecord);
				}
			}
			tmpOffset += tmpRows.length;
			return setImmediate(fScanPage);
		});
	};

	const fFinishScan = () =>
	{
		const tmpEntityTypes = Object.keys(tmpTallies);
		if (tmpEntityTypes.length === 0)
		{
			return fCallback(new Error('The chunked comprehension table holds no rows.'));
		}
		let tmpProblems = [];
		for (const tmpEntity of tmpEntityTypes)
		{
			tmpProblems = tmpProblems.concat(findChunkProblems(tmpEntity, tmpTallies[tmpEntity]));
		}
		if (tmpProblems.length > 0)
		{
			return fCallback(new Error(`The chunked comprehension is incomplete and was not loaded: ${tmpProblems.join('; ')}.`));
		}

		/** @type {Object<string, EntityShape>} */
		const tmpShapes = {};
		for (const tmpEntity of tmpEntityTypes)
		{
			tmpShapes[tmpEntity] = tmpTallies[tmpEntity].Shape;
		}

		return fCallback(null,
			{
				EntityTypes: tmpEntityTypes,
				EntityShapes: tmpShapes,
				recordCount: (pEntity) => (tmpTallies[pEntity] ? tmpTallies[pEntity].RecordSum : 0),
				streamRecords: (pEntity, fOnBatch, fDone) =>
				{
					let tmpStreamOffset = 0;
					const fPump = () =>
					{
						fReadChunkPage(pEntity, tmpStreamOffset, tmpPageSize, (pError, pRows) =>
						{
							if (pError)
							{
								return fDone(pError);
							}
							const tmpRows = Array.isArray(pRows) ? pRows : [];
							if (tmpRows.length === 0)
							{
								return fDone();
							}
							tmpStreamOffset += tmpRows.length;
							let tmpIndex = 0;
							const fNextRow = () =>
							{
								if (tmpIndex >= tmpRows.length)
								{
									return setImmediate(fPump);
								}
								const tmpRow = tmpRows[tmpIndex++];
								let tmpRecords;
								try
								{
									tmpRecords = parseChunkRecords(tmpRow.RecordsJSON, `${pEntity} chunk ${tmpRow.ChunkOrdinal}`);
								}
								catch (pParseError)
								{
									return fDone(pParseError);
								}
								// One chunk is one batch — the shape was built for exactly this.
								return fOnBatch(tmpRecords, (pBatchError) => (pBatchError ? fDone(pBatchError) : setImmediate(fNextRow)));
							};
							return fNextRow();
						});
					};
					return fPump();
				},
			});
	};

	return fScanPage();
};

/**
 * @param {any} pCandidate
 * @return {boolean} True when this is already a source rather than a raw comprehension.
 */
const isComprehensionSource = function(pCandidate)
{
	return !!pCandidate && Array.isArray(pCandidate.EntityTypes) && (typeof(pCandidate.streamRecords) === 'function');
};

/**
 * Accept either shape at an entry point, so callers holding a comprehension keep working.
 *
 * @param {Object|ComprehensionSource} pCandidate
 * @return {ComprehensionSource}
 */
const asComprehensionSource = function(pCandidate)
{
	return isComprehensionSource(pCandidate) ? pCandidate : fromComprehension(pCandidate);
};

module.exports =
	{
		deriveEntityShape,
		foldRecordIntoShape,
		emptyShape,
		fromComprehension,
		fromChunkedTable,
		isChunkRow,
		parseChunkRecords,
		findChunkProblems,
		isComprehensionSource,
		asComprehensionSource,
	};

}).call(this)}).call(this,require("timers").setImmediate)

},{"timers":815}],4:[function(require,module,exports){

const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libIntegrationAdapter = require('headlight-integration-adapter');
const libGUIDBatchResolver = libIntegrationAdapter.GUIDBatchResolver;
const libDeletedRecordReviver = require('./Headlight-Deleted-Record-Reviver.js');
const libComprehensionSource = require('./Comprehension-Source.js');

const SPECIAL_TABLES_KEYS = new Set(['OnSave', 'OnApprovalAction', 'OnEnteringState', 'ExecutionLog']);

class HeadlightComprehensionProcessor extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the adapter
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client') }} */
		this.fable;

		this.serviceType = 'ComprehensionProcessor';

		/** @type {import('headlight-rest-client')} */
		this._Client = null;

		/** @type {import('headlight-integration-adapter').GUIDBatchResolver} */
		this._GUIDBatchResolver = null;
	}

	/**
	 * Order the entity types so a referenced entity is always integrated before the entity that
	 * references it.
	 *
	 * Reads shapes only — never records — so this costs the same on a 200-row comprehension and a
	 * 200,000-row one. The two ordering forms are deliberately tested differently: a `GUID<Entity>`
	 * edge needs a populated value somewhere, while a `…_Via_GUID<Entity>` edge is established by the
	 * field name alone. `_GUID<Entity>` addresses a record that already exists on the server, so it
	 * establishes no edge at all.
	 *
	 * @param {import('./Comprehension-Source.js').ComprehensionSource|Object} pSource - A source, or
	 *        a raw comprehension, which is wrapped.
	 * @return {Array<string>} The entity types in dependency order.
	 */
	getAdapterSequence(pSource)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pSource);
		/** @type {Record<string, Array<string>>} */
		const tmpDependencyMap = { };
		const tmpTables = tmpSource.EntityTypes.filter((pTable) => !SPECIAL_TABLES_KEYS.has(pTable));
		for (const tmpTable of tmpTables)
		{
			const tmpShape = tmpSource.EntityShapes[tmpTable] || libComprehensionSource.emptyShape();
			for (const tmpTableKey of tmpTables)
			{
				if (tmpTable === tmpTableKey)
				{
					continue;
				}
				// A direct reference counts only where some record populated it; an empty column is
				// not a dependency.
				let tmpHasDependency = (tmpShape.PopulatedFields.indexOf(`GUID${tmpTableKey}`) > -1);

				// `_Dest_IDEntity_*_Via_GUID{Table}` is established by the field name.
				if (!tmpHasDependency)
				{
					const tmpViaKey = `_Via_GUID${tmpTableKey}`;
					for (const tmpFieldKey of tmpShape.Fields)
					{
						if (tmpFieldKey.endsWith(tmpViaKey))
						{
							tmpHasDependency = true;
							break;
						}
					}
				}

				if (tmpHasDependency)
				{
					if (!tmpDependencyMap[tmpTable])
					{
						tmpDependencyMap[tmpTable] = [];
					}
					if (!tmpDependencyMap[tmpTable].includes(tmpTableKey))
					{
						this.fable.log.info(`Data dependency detected: [${tmpTableKey}] must come before [${tmpTable}]`);
						tmpDependencyMap[tmpTable].push(tmpTableKey);
					}
				}
			}
		}
		return this.topologicalSort(tmpTables, tmpDependencyMap);
	}

	/**
	 * Sort the adapters topologically based on their dependencies.
	 *
	 * @param {Array<string>} pNodes - The nodes to sort
	 * @param {Record<string, Array<string>>} pDependencyMap - The dependency map
	 *
	 * @return {Array<string>} - The sorted keys
	 */
	topologicalSort(pNodes, pDependencyMap)
	{
		/* Algorithm source: https://en.wikipedia.org/wiki/Topological_sorting#Kahn's_algorithm
		L ← Empty list that will contain the sorted elements
		S ← Set of all nodes with no incoming edges
		while S is non-empty do
			remove a node n from S
			add n to tail of L
			for each node m with an edge e from n to m do
				remove edge e from the graph
				if m has no other incoming edges then
					insert m into S
		if graph has edges then
			return error (graph has at least one cycle)
		else
			return L (a topologically sorted order)
		 */
		const tmpL = [];
		const tmpS = pNodes.filter((pNode) => !Object.keys(pDependencyMap).includes(pNode));
		const tmpDependencyMap = JSON.parse(JSON.stringify(pDependencyMap));

		while (tmpS.length > 0)
		{
			const tmpN = tmpS.pop();
			tmpL.push(tmpN);
			for (const tmpM in tmpDependencyMap)
			{
				if (tmpDependencyMap[tmpM].includes(tmpN))
				{
					tmpDependencyMap[tmpM] = tmpDependencyMap[tmpM].filter((pNode) => pNode !== tmpN);
					if (tmpDependencyMap[tmpM].length === 0)
					{
						tmpS.push(tmpM);
						delete tmpDependencyMap[tmpM];
					}
				}
			}
		}
		if (Object.keys(tmpDependencyMap).length > 0)
		{
			throw new Error(`Graph has at least one cycle: ${JSON.stringify(tmpDependencyMap)}`);
		}
		return tmpL;
	}

	/**
	 * @param {Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>} pComprehension - The comprehension to integrate
	 * @param {Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>} pPreviousComprehension - The previous comprehension to diff against. Any GUIDs not present in the new comprehension will be deleted.
	 * @param {(pError?: Error, pUpdatedComprehension?: Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>) => void} fCallback - A callback invoked when the integration is complete - if records are deleted, the updated comprehension after deletions will be passed as the second parameter
	 * @param {(pRecord: Record<string, any>, pTable: string) => boolean} [fCanRecordBeDeleted] - (optional) A function that determines if a record can be deleted. If not provided, all records not present in the new comprehension will be deleted.
	 */
	integrateComprehensionWithDiffDelete(pComprehension, pPreviousComprehension, fCallback, fCanRecordBeDeleted)
	{
		let tmpUpdatedComprehension = JSON.parse(JSON.stringify(pPreviousComprehension || { }));
		this.integrateComprehension(pComprehension, (pError) =>
		{
			// Surgically merge the new entity records (regular tables) into the copy of the previous
			// comprehension. Intent-typed special keys (OnSave/OnApprovalAction/OnEnteringState) live only on
			// Document.EntityData (never in the FormData entity-data copy); the copy above preserves them
			// untouched, and we skip them here so they are never merged, diffed, or deleted.
			for (const tmpTableKey in pComprehension)
			{
				if (SPECIAL_TABLES_KEYS.has(tmpTableKey))
				{
					continue;
				}
				const tmpRecordMap = pComprehension[tmpTableKey];
				for (const tmpRecordGUID in tmpRecordMap)
				{
					tmpUpdatedComprehension[tmpTableKey] = tmpUpdatedComprehension[tmpTableKey] || {};
					tmpUpdatedComprehension[tmpTableKey][tmpRecordGUID] = tmpRecordMap[tmpRecordGUID];
				}
			}
			if (!pPreviousComprehension || Object.keys(pPreviousComprehension).length === 0)
			{
				// No baseline to diff against (e.g. first save): nothing to delete; persist the merged comprehension.
				return fCallback(pError, tmpUpdatedComprehension);
			}
			const tmpRecordsToDelete = [];
			for (const tmpTableKey in pPreviousComprehension)
			{
				if (SPECIAL_TABLES_KEYS.has(tmpTableKey))
				{
					continue;
				}
				const tmpPreviousRecordMap = pPreviousComprehension[tmpTableKey];
				for (const tmpRecordGUID in tmpPreviousRecordMap)
				{
					if (pComprehension?.[tmpTableKey]?.[tmpRecordGUID])
					{
						continue;
					}
					if (typeof fCanRecordBeDeleted === 'function' && !fCanRecordBeDeleted(tmpPreviousRecordMap[tmpRecordGUID], tmpTableKey))
					{
						continue;
					}
					tmpRecordsToDelete.push({ Table: tmpTableKey, GUID: tmpRecordGUID });
					if (tmpUpdatedComprehension?.[tmpTableKey]?.[tmpRecordGUID])
					{
						delete tmpUpdatedComprehension[tmpTableKey][tmpRecordGUID];
					}
				}
			}
			if (tmpRecordsToDelete.length < 1)
			{
				// Nothing to delete, but the merged comprehension (new entities + preserved special keys) must persist.
				return fCallback(pError, tmpUpdatedComprehension);
			}
			const tmpClient = this.client;
			const tmpAnticipate = this.fable.newAnticipate();
			tmpAnticipate.anticipate(
				(fNext) =>
				{
					tmpClient.getJSON('CheckSession', (pError, pSession) =>
					{
						if (!pError && pSession?.LoggedIn)
						{
							return fNext();
						}
						tmpClient.authenticate(
							(pError, pResponse) =>
							{
								if (pError)
								{
									this.log.error(`Error authenticating`, pError);
								}
								else
								{
									this.log.info(`Authenticated - Session [${pResponse.SessionID}]`);
								}
								return fNext(pError);
							});
					});
				});

			tmpAnticipate.anticipate(
				(fNext) =>
				{
					this.fable.log.info(`Going to delete ${tmpRecordsToDelete.length} records by GUID...`);
					/** @type {Map<string, Set<string>>} */
					const tmpDeleteTargets = new Map();
					for (const tmpRecord of tmpRecordsToDelete)
					{
						if (!tmpDeleteTargets.has(tmpRecord.Table))
						{
							tmpDeleteTargets.set(tmpRecord.Table, new Set());
						}
						tmpDeleteTargets.get(tmpRecord.Table).add(tmpRecord.GUID);
					}
					this.guidBatchResolver.resolveReferences(tmpDeleteTargets)
						.then(() => fNext())
						.catch((pError) =>
						{
							this.fable.log.warn(`Could not resolve records to delete in batches: ${pError.message || pError}`);
							return fNext();
						});
				});
			const fResolveRecordID = (pTable, pGUID) =>
			{
				const tmpGUIDMap = this.guidBatchResolver.guidMap;
				return tmpGUIDMap.getHeadlightIDFromExternalGUID(pTable, pGUID) || tmpGUIDMap.getIDFromGUID(pTable, pGUID);
			};
			for (const tmpRecord of tmpRecordsToDelete)
			{
				tmpAnticipate.anticipate(
					(fNext) =>
					{
						const tmpIDRecord = fResolveRecordID(tmpRecord.Table, tmpRecord.GUID);
						if (!tmpIDRecord)
						{
							this.fable.log.warn(`Record to delete not found: ${tmpRecord.Table} - ${tmpRecord.GUID}`);
							return fNext();
						}
						tmpClient.deleteEntity(tmpRecord.Table, tmpIDRecord, (pError) =>
							{
								if (pError)
								{
									this.fable.log.error(`Error deleting record: ${tmpRecord.Table} - ${tmpRecord.GUID}`, pError);
								}
								return fNext();
							});
					});
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error importing comprehension file.`, pError);
						return fCallback(pError, tmpUpdatedComprehension);
					}
					this.fable.log.info(`Finished importing comprehension file.`);
					return fCallback(null, tmpUpdatedComprehension);
				});
		});
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		if (this.options.UseSiloedClient)
		{
			if (!this._Client)
			{
				this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
				this._Client = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', this.options);
			}
			return this._Client;
		}

		let tmpClient = this.fable.services.HeadlightRestClient;
		if (!tmpClient)
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			tmpClient = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', this.options);
		}
		return tmpClient;
	}

	set client(pClient)
	{
		this._Client = pClient;
	}

	/**
	 * Build the option set for one entity's integration adapter. The caller's
	 * upsert tuning — RecordThresholdForBulkUpsert, BulkUpsertBatchSize,
	 * RecordPushRetryThreshold — is forwarded when supplied as a positive
	 * integer on the processor's options; the adapter's own defaults apply
	 * otherwise.
	 *
	 * @param {string} pEntity - The entity the adapter will integrate.
	 * @return {Record<string, any>} Options for a headlight-integration-adapter instance.
	 */
	buildAdapterOptions(pEntity)
	{
		/** @type {Record<string, any>} */
		const tmpOptions =
			{
				Entity: pEntity,
				EntityGUIDMarshalPrefix: '',
				AdapterSetGUIDMarshalPrefix: '',
				SimpleMarshal: true,
				ForceMarshal: true,
			};
		for (const tmpTuningKey of [ 'RecordThresholdForBulkUpsert', 'BulkUpsertBatchSize', 'RecordPushRetryThreshold' ])
		{
			const tmpValue = parseInt(this.options[tmpTuningKey], 10);
			if (Number.isFinite(tmpValue) && tmpValue > 0)
			{
				tmpOptions[tmpTuningKey] = tmpValue;
			}
		}
		return tmpOptions;
	}

	/**
	 * Revive any soft-deleted records the comprehension is about to upsert.
	 *
	 * Enabled by the `ReviveDeletedRecords` option. Off by default because the
	 * scan costs a paged read per entity, and most loads never touch a deleted
	 * GUID; a pipeline that deletes and later restores records wants it on.
	 *
	 * @param {Record<string, any>} pComprehension
	 * @param {(pError?: Error, pSummary?: Object) => void} fCallback
	 */
	reviveDeletedRecords(pSource, fCallback)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pSource);
		let tmpEntitySequence;
		try
		{
			tmpEntitySequence = this.getAdapterSequence(tmpSource).filter((pEntity) => !SPECIAL_TABLES_KEYS.has(pEntity));
		}
		catch (pError)
		{
			return fCallback(pError);
		}

		this.fable.serviceManager.addServiceType('DeletedRecordReviver', libDeletedRecordReviver);
		const tmpReviver = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('DeletedRecordReviver',
			{ ScanLimit: this.options.RevivalScanLimit });
		tmpReviver.client = this.client;

		// Per entity, per batch: `reviveEntity` answers a tally, so batches sum rather than needing
		// the whole comprehension resident.
		const tmpResults = [];
		let tmpTotalRevived = 0;
		let tmpTotalFailed = 0;
		const fReviveEntity = (pIndex, fDone) =>
		{
			if (pIndex >= tmpEntitySequence.length)
			{
				return fDone();
			}
			const tmpEntity = tmpEntitySequence[pIndex];
			return tmpSource.streamRecords(tmpEntity,
				(pRecords, fNext) =>
				{
					tmpReviver.reviveEntity(tmpEntity, pRecords)
						.then((pResult) =>
						{
							tmpResults.push(pResult);
							tmpTotalRevived += pResult.Revived;
							tmpTotalFailed += pResult.Failed;
							return fNext();
						})
						.catch((pError) => fNext(pError));
				},
				(pError) => (pError ? fDone(pError) : fReviveEntity(pIndex + 1, fDone)));
		};

		return fReviveEntity(0, (pError) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				return fCallback(null, { Entities: tmpResults, TotalRevived: tmpTotalRevived, TotalFailed: tmpTotalFailed });
			});
	}

	/**
	 * The batch resolver shared by every entity in one comprehension load.
	 *
	 * @return {import('headlight-integration-adapter').GUIDBatchResolver}
	 */
	get guidBatchResolver()
	{
		if (!this._GUIDBatchResolver)
		{
			this.fable.serviceManager.addServiceType('IntegrationGUIDBatchResolver', libGUIDBatchResolver);
			this._GUIDBatchResolver = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('IntegrationGUIDBatchResolver',
				this.options.GUIDBatchResolutionOptions || {});
		}
		this._GUIDBatchResolver.client = this.client;
		return this._GUIDBatchResolver;
	}

	/**
	 * Ask the server, once, whether it serves the body-driven read route, so the
	 * batch resolver can send large IN lists in a request body instead of
	 * chunking them across URI-bounded reads.  The capability rides along on
	 * every entity's schema, so any entity in the comprehension answers it.
	 *
	 * @param {Array<string>} pEntitySequence - The entities being loaded.
	 * @param {() => void} fCallback - Invoked once the capability is known (or known to be unknowable).
	 */
	loadBatchReadCapability(pEntitySequence, fCallback)
	{
		const tmpResolver = this.guidBatchResolver;
		if (typeof(tmpResolver.QueryEndpointSupported) === 'boolean' || pEntitySequence.length < 1)
		{
			return fCallback();
		}
		this.client.getJSON(`${pEntitySequence[0]}/Schema`,
			(pError, pSchema) =>
			{
				if (pError)
				{
					this.fable.log.info(`Could not read the [${pEntitySequence[0]}] schema to detect batch read capabilities; using URI reads.`);
					tmpResolver.QueryEndpointSupported = false;
					return fCallback();
				}
				tmpResolver.applySchemaCapabilities(pSchema);
				return fCallback();
			});
	}

	/**
	 * Resolve every GUID the comprehension references, across all of its
	 * entities, in batched reads before any adapter runs.
	 *
	 * The per-entity adapters do the same thing for their own slice, but doing
	 * it once for the whole comprehension collapses what would otherwise be one
	 * batch round-trip per entity into a handful -- which is what the browser
	 * save path (many entities, few records each) actually spends its time on.
	 * Only hits are cached: a reference whose target this run is about to create
	 * has to stay resolvable later.
	 *
	 * @param {Record<string, any>} pComprehension - The comprehension to scan.
	 * @param {Array<string>} pEntitySequence - The entities being loaded.
	 * @param {(pError?: Error, pSummary?: Object) => void} fCallback - Invoked when the prefetch is done.
	 */
	prefetchComprehensionGUIDs(pSource, pEntitySequence, fCallback)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pSource);
		/** @type {Map<string, Set<string>>} */
		let tmpReferences = new Map();

		// The collector merges into an existing map, so batches fold in one at a time and the map
		// stays bounded by distinct referenced GUIDs rather than by record count.
		const tmpEntities = pEntitySequence.filter((pEntity) => !SPECIAL_TABLES_KEYS.has(pEntity));
		const fCollectEntity = (pIndex, fDone) =>
		{
			if (pIndex >= tmpEntities.length)
			{
				return fDone();
			}
			const tmpEntity = tmpEntities[pIndex];
			return tmpSource.streamRecords(tmpEntity,
				(pRecords, fNext) =>
				{
					tmpReferences = libGUIDBatchResolver.collectMappedGUIDReferences(pRecords, `GUID${tmpEntity}`, tmpReferences);
					return fNext();
				},
				(pError) => (pError ? fDone(pError) : fCollectEntity(pIndex + 1, fDone)));
		};

		return fCollectEntity(0, (pStreamError) =>
		{
		if (pStreamError)
		{
			this.fable.log.warn(`Could not read records for GUID pre-resolution; entity adapters will resolve references themselves: ${pStreamError.message || pStreamError}`);
			return fCallback();
		}
		if (tmpReferences.size < 1)
		{
			return fCallback();
		}

		this.loadBatchReadCapability(pEntitySequence,
			() =>
			{
				this.guidBatchResolver.resolveReferences(tmpReferences)
					.then((pSummary) =>
					{
						const tmpUnverifiedNote = (pSummary.Unverified > 0) ? `, ${pSummary.Unverified} left to single lookups` : '';
						this.fable.log.info(`Pre-resolved ${pSummary.Resolved} of ${pSummary.Requested} referenced GUID(s) across ${tmpReferences.size} entities in ${pSummary.Requests} batch read(s)${tmpUnverifiedNote}.`);
						return fCallback(null, pSummary);
					})
					.catch((pError) =>
					{
						this.fable.log.warn(`Batch GUID pre-resolution did not complete; entity adapters will resolve references themselves: ${pError.message || pError}`);
						return fCallback();
					});
			});
		});
	}

	/**
	 * @param {Record<string, Array<Record<string, any>> | Record<string, Record<string, any>>>} pComprehension - The comprehension to integrate
	 * @param {(pError?: Error) => void} fCallback - A callback invoked when the integration is complete
	 */
	integrateComprehension(pComprehension, fCallback)
	{
		const tmpSource = libComprehensionSource.asComprehensionSource(pComprehension);
		const tmpClient = this.client;
		const tmpAnticipate = this.fable.newAnticipate();

		// Track stats for the summary
		let tmpStats = { entities: {}, startTime: Date.now(), warnings: 0, errors: 0, revived: 0 };

		// Intercept log warnings/errors to count them
		let tmpOriginalWarn = this.fable.log.warn.bind(this.fable.log);
		let tmpOriginalError = this.fable.log.error.bind(this.fable.log);
		this.fable.log.warn = (...pArgs) => { tmpStats.warnings++; return tmpOriginalWarn(...pArgs); };
		this.fable.log.error = (...pArgs) => { tmpStats.errors++; return tmpOriginalError(...pArgs); };

		this.fable.log.info(`Initializing and configuring data integration adapters...`);
		this.fable.serviceManager.addServiceType('IntegrationAdapter', libIntegrationAdapter);

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				tmpClient.getJSON('CheckSession', (pError, pSession) =>
				{
					if (!pError && pSession?.LoggedIn)
					{
						return fCallback();
					}
					tmpClient.authenticate(
						(pError, pResponse) =>
						{
							if (pError)
							{
								this.log.error(`Error authenticating`, pError);
							}
							else
							{
								this.log.info(`Authenticated - Session [${pResponse.SessionID}]`);
							}
							return fCallback(pError);
						});
				});
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				if (!this.options.ReviveDeletedRecords)
				{
					return fCallback();
				}
				// Upsert cannot see a soft-deleted row, so a GUID belonging to one
				// would create a silent duplicate instead of reviving the original.
				// Revive them first, before any adapter runs.
				this.reviveDeletedRecords(tmpSource,
					(pError, pSummary) =>
					{
						if (pError)
						{
							this.fable.log.error(`Error reviving soft-deleted records; continuing with the push.`, pError);
						}
						else if (pSummary && pSummary.TotalRevived > 0)
						{
							tmpStats.revived = pSummary.TotalRevived;
							this.fable.log.info(`Revived ${pSummary.TotalRevived} soft-deleted record(s) before upsert.`);
						}
						return fCallback();
					});
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				if (this.options.BatchGUIDResolution === false)
				{
					return fCallback();
				}
				let tmpEntitySequence;
				try
				{
					tmpEntitySequence = this.getAdapterSequence(tmpSource);
				}
				catch (pError)
				{
					// A dependency cycle is reported by the wiring stage below.
					return fCallback();
				}
				return this.prefetchComprehensionGUIDs(tmpSource, tmpEntitySequence, () => fCallback());
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				this.fable.log.info(`Wiring up Integration Adapters...`);

				const tmpIntegrationAdapterSet = this.getAdapterSequence(tmpSource);
				this.fable.log.info(`Integration Adapter sequence: ${tmpIntegrationAdapterSet.join(' -> ')}`);

				try
				{
					for (let i = 0; i < tmpIntegrationAdapterSet.length; i++)
					{
						// Initialize the adapter
						const tmpAdapterKey = tmpIntegrationAdapterSet[i];
						const tmpRecordCount = tmpSource.recordCount(tmpAdapterKey);
						tmpStats.entities[tmpAdapterKey] = { input: tmpRecordCount };

						if (tmpRecordCount === 0)
						{
							//NOTE: if you invoke the adapter with zero records, it logs an error; just skip, nothing to do
							continue;
						}

						/** @type {libIntegrationAdapter} */
						const tmpAdapter = this.fable.instantiateServiceProviderWithoutRegistration('IntegrationAdapter', this.buildAdapterOptions(tmpAdapterKey));
						tmpAdapter.client = tmpClient;
						this.runAdapter(tmpAnticipate, tmpAdapter, tmpSource, tmpAdapterKey);
					}
				}
				catch (pError)
				{
					this.fable.log.error(`Error wiring up integration adapters: ${pError}`, pError);
					return fCallback(pError);
				}

				return fCallback();
			});

		tmpAnticipate.wait(
			(pError) =>
			{
				// Restore original log methods
				this.fable.log.warn = tmpOriginalWarn;
				this.fable.log.error = tmpOriginalError;

				// Print summary
				let tmpElapsed = ((Date.now() - tmpStats.startTime) / 1000).toFixed(1);
				this.fable.log.info(`\n========== Integration Summary ==========`);
				this.fable.log.info(`Duration: ${tmpElapsed}s`);
				this.fable.log.info(`Entity records pushed:`);
				for (let tmpEntity in tmpStats.entities)
				{
					this.fable.log.info(`  ${tmpEntity}: ${tmpStats.entities[tmpEntity].input}`);
				}
				if (tmpStats.revived > 0)
				{
					this.fable.log.info(`Soft-deleted records revived before upsert: ${tmpStats.revived}`);
				}
				if (tmpStats.warnings > 0)
				{
					this.fable.log.warn(`Warnings: ${tmpStats.warnings} (review log output above for details)`);
				}
				if (tmpStats.errors > 0)
				{
					this.fable.log.error(`Errors: ${tmpStats.errors} (review log output above for details)`);
				}
				if (tmpStats.warnings === 0 && tmpStats.errors === 0)
				{
					this.fable.log.info(`No warnings or errors.`);
				}
				this.fable.log.info(`==========================================\n`);

				if (pError)
				{
					this.fable.log.error(`Error importing comprehension file.`, pError);
					return fCallback(pError);
				}
				this.fable.log.info(`Finished importing comprehension file.`);
				return fCallback(pError);
			});
	}

	/**
	 * Feed one entity's records into its adapter, a batch at a time.
	 *
	 * The adapter still accumulates what it is given before `integrateRecords` runs, so this bounds
	 * what the PROCESSOR holds, not yet what the adapter does — see the note in the class header.
	 *
	 * @param {any} pAnticipate - The anticipate instance - FIXME: not exporting this interface - fake types anyway
	 * @param {import('headlight-integration-adapter')} pAdapter - The adapter to feed
	 * @param {import('./Comprehension-Source.js').ComprehensionSource} pSource - The record source
	 * @param {string} pEntity - The entity type to stream
	 * @param {(pRecord: Record<string, any>) => Record<string, any>} [fMarshalRecord] - (optional) A function to marshal each record before integration
	 */
	runAdapter(pAnticipate, pAdapter, pSource, pEntity, fMarshalRecord)
	{
		let tmpAdapter = pAdapter;

		if (!tmpAdapter)
		{
			throw new Error(`Adapter not found.`);
		}
		let tmpPrefix = this.options.prefix || this.fable.settings.prefix;
		if (tmpPrefix)
		{
			tmpAdapter.AdapterSetGUIDMarshalPrefix = tmpPrefix;
		}

		let tmpMarshalRecordFunction = fMarshalRecord;
		pAnticipate.anticipate(
			(fDone) =>
			{
				pSource.streamRecords(pEntity,
					(pRecords, fNext) =>
					{
						for (const tmpRecord of pRecords)
						{
							tmpAdapter.addSourceRecord(tmpRecord);
						}
						return fNext();
					},
					fDone);
			});
		pAnticipate.anticipate(
			(fDone) =>
			{
				tmpAdapter.integrateRecords(fDone, tmpMarshalRecordFunction);
			});
	}

	getCapitalLettersAsString(inputString)
	{
		let tmpRegex = /[A-Z]/g;
		let tmpMatch = inputString.match(tmpRegex);
		let tmpString = tmpMatch ? tmpMatch.join('') : 'UNK';
		return tmpString;
	}
}

module.exports = HeadlightComprehensionProcessor;
/** @type {Record<string, any>} */
module.exports.default_configuration = { };

},{"./Comprehension-Source.js":3,"./Headlight-Deleted-Record-Reviver.js":5,"fable-serviceproviderbase":438,"headlight-integration-adapter":8,"headlight-rest-client":20}],5:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Reads exclude soft-deleted rows unless this exact query parameter is present.
 * It is case-sensitive and value-sensitive: `includedeleted`, `IncludeDeleted`
 * and `includeDeleted=1` are all ignored, silently returning zero rows.
 */
const INCLUDE_DELETED_PARAMETER = 'includeDeleted=true';

/**
 * Records are read back in pages of this size while scanning for soft-deleted
 * GUIDs. Kept modest because the read carries every column.
 */
const SCAN_PAGE_SIZE = 500;

/**
 * A scan that would walk more rows than this bails out and reports it rather
 * than silently spending minutes on a table with a large delete history. The
 * caller can raise it deliberately.
 */
const DEFAULT_SCAN_LIMIT = 20000;

/**
 * Revives soft-deleted records whose GUIDs are about to be upserted.
 *
 * Upsert resolves an existing record by reading it back by GUID, and reads
 * exclude soft-deleted rows. A GUID belonging to a deleted row therefore looks
 * absent, so Upsert takes the CREATE branch -- and the create is then rejected
 * by the GUID uniqueness guard, which does see the deleted row:
 *
 *     Error creating record:Error in DAL create: Record with GUID <guid> already exists!
 *
 * That rejection arrives as an `Error` property inside an HTTP **200** body
 * with no identity column, so it does not surface as a transport error. The
 * integration adapter cannot match it either -- its duplicate-detection looks
 * for `Duplicate entry`, which this message does not contain -- so the record
 * burns the retry budget and is then abandoned. The net effect is a record
 * that silently never lands, on a load that reports success.
 *
 * This service closes the gap by reviving those rows before the push, so the
 * subsequent Upsert finds the original and updates it in place.
 *
 * Reviving requires two things from the API:
 *   - reading soft-deleted rows, via `?includeDeleted=true`; and
 *   - `GET /<Entity>/Undelete/:IDRecord`, which exists in meadow-endpoints 4.x
 *     but is NOT registered in 2.1.1 (`api/headlight`). Update cannot
 *     substitute -- meadow excludes the Deleted column from updatable fields,
 *     so clearing it through Update or Upsert returns 200 and changes nothing.
 *
 * `tools/smoke-test-deleted-record-revival.js` asserts all of the above
 * against a live server and is the acceptance test for the 2.x Undelete work.
 */
class HeadlightDeletedRecordReviver extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'DeletedRecordReviver';

		/** @type {import('headlight-rest-client')} */
		this._Client = null;
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		return this._Client;
	}

	set client(pClient)
	{
		this._Client = pClient;
	}

	/**
	 * Build the meadow filter that finds soft-deleted rows for an entity,
	 * optionally scoped to one customer.
	 *
	 * @param {number} [pIDCustomer]
	 * @return {string}
	 */
	buildDeletedFilter(pIDCustomer)
	{
		const tmpClauses = [ 'FBV~Deleted~EQ~1' ];
		if (pIDCustomer > 0)
		{
			tmpClauses.push(`FBV~IDCustomer~EQ~${pIDCustomer}`);
		}
		return tmpClauses.join('~');
	}

	/**
	 * Scan an entity's soft-deleted rows and return the ones whose GUID appears
	 * in the supplied set.
	 *
	 * @param {string} pEntity
	 * @param {Set<string>} pGUIDs - GUIDs about to be upserted.
	 * @param {number} [pIDCustomer]
	 * @return {Promise<{ Matches: Array<{ GUID: string, ID: number }>, Scanned: number, Truncated: boolean }>}
	 */
	async findDeletedMatches(pEntity, pGUIDs, pIDCustomer)
	{
		const tmpGUIDColumn = `GUID${pEntity}`;
		const tmpIDColumn = `ID${pEntity}`;
		const tmpFilter = this.buildDeletedFilter(pIDCustomer);
		const tmpScanLimit = this.options.ScanLimit || DEFAULT_SCAN_LIMIT;

		/** @type {Array<{ GUID: string, ID: number }>} */
		const tmpMatches = [];
		let tmpScanned = 0;
		let tmpTruncated = false;

		for (let tmpOffset = 0; ; tmpOffset += SCAN_PAGE_SIZE)
		{
			if (tmpOffset >= tmpScanLimit)
			{
				tmpTruncated = true;
				break;
			}

			/** @type {Array<Record<string, any>>} */
			const tmpPage = await new Promise((resolve, reject) =>
			{
				this.client.getJSON(`${pEntity}s/FilteredTo/${tmpFilter}/${tmpOffset}/${SCAN_PAGE_SIZE}?${INCLUDE_DELETED_PARAMETER}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						return resolve(Array.isArray(pBody) ? pBody : []);
					});
			});

			if (tmpPage.length < 1)
			{
				break;
			}
			tmpScanned += tmpPage.length;

			for (const tmpRecord of tmpPage)
			{
				const tmpGUID = tmpRecord[tmpGUIDColumn];
				if (tmpGUID && pGUIDs.has(tmpGUID))
				{
					tmpMatches.push({ GUID: tmpGUID, ID: tmpRecord[tmpIDColumn] });
				}
			}

			if (tmpPage.length < SCAN_PAGE_SIZE)
			{
				break;
			}
		}

		return { Matches: tmpMatches, Scanned: tmpScanned, Truncated: tmpTruncated };
	}

	/**
	 * @param {string} pEntity
	 * @param {number} pIDRecord
	 * @return {Promise<boolean>}
	 */
	async undeleteRecord(pEntity, pIDRecord)
	{
		return new Promise((resolve) =>
		{
			this.client.getJSON(`${pEntity}/Undelete/${pIDRecord}`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.warn(`Could not undelete [${pEntity}] ID [${pIDRecord}]: ${pError.message || pError}`);
						return resolve(false);
					}
					const tmpCount = (pBody && typeof pBody.Count === 'number') ? pBody.Count : 0;
					if (tmpCount < 1)
					{
						this.log.warn(`Undelete of [${pEntity}] ID [${pIDRecord}] affected no rows.`);
						return resolve(false);
					}
					return resolve(true);
				});
		});
	}

	/**
	 * Revive records from an explicit ledger of `{ EntityName, RecordGUID,
	 * IDRecord }` captured when they were deleted.
	 *
	 * Preferred over scanning when the caller already knows the IDs: it costs
	 * one Undelete call per record instead of paging the entity's whole
	 * delete history.
	 *
	 * @param {Array<{ EntityName: string, RecordGUID: string, IDRecord: number }>} pLedger
	 * @param {Record<string, any>} pComprehension - Only ledger entries whose GUID reappears here are revived.
	 * @return {Promise<{ Considered: number, Revived: number, Failed: number, Skipped: number }>}
	 */
	async reviveFromLedger(pLedger, pComprehension)
	{
		const tmpResult = { Considered: 0, Revived: 0, Failed: 0, Skipped: 0 };
		if (!Array.isArray(pLedger) || pLedger.length < 1)
		{
			return tmpResult;
		}

		/** @type {Map<string, Set<string>>} */
		const tmpIncomingGUIDs = new Map();
		for (const tmpEntity of Object.keys(pComprehension || {}))
		{
			const tmpGUIDColumn = `GUID${tmpEntity}`;
			const tmpRecords = Array.isArray(pComprehension[tmpEntity]) ? pComprehension[tmpEntity] : Object.values(pComprehension[tmpEntity] || {});
			tmpIncomingGUIDs.set(tmpEntity, new Set(tmpRecords.map((pRecord) => String(pRecord[tmpGUIDColumn] || pRecord[`_${tmpGUIDColumn}`] || '')).filter(Boolean)));
		}

		for (const tmpEntry of pLedger)
		{
			const tmpEntityGUIDs = tmpIncomingGUIDs.get(tmpEntry.EntityName);
			if (!tmpEntityGUIDs || !tmpEntityGUIDs.has(String(tmpEntry.RecordGUID)))
			{
				tmpResult.Skipped++;
				continue;
			}
			if (!(Number(tmpEntry.IDRecord) > 0))
			{
				tmpResult.Skipped++;
				continue;
			}

			tmpResult.Considered++;
			const tmpUndeleted = await this.undeleteRecord(tmpEntry.EntityName, Number(tmpEntry.IDRecord));
			if (tmpUndeleted)
			{
				tmpResult.Revived++;
			}
			else
			{
				tmpResult.Failed++;
			}
		}

		if (tmpResult.Revived > 0)
		{
			this.log.info(`Revived ${tmpResult.Revived} previously deleted record(s) from the deletion ledger.`);
		}
		return tmpResult;
	}

	/**
	 * Revive every soft-deleted record in one entity's slice of a comprehension.
	 *
	 * @param {string} pEntity
	 * @param {Record<string, Record<string, any>> | Array<Record<string, any>>} pRecords
	 * @return {Promise<{ Entity: string, Candidates: number, Revived: number, Failed: number, Scanned: number, Truncated: boolean }>}
	 */
	async reviveEntity(pEntity, pRecords)
	{
		const tmpGUIDColumn = `GUID${pEntity}`;
		/** @type {Set<string>} */
		const tmpGUIDs = new Set();
		let tmpIDCustomer = 0;

		const tmpRecordList = Array.isArray(pRecords) ? pRecords : Object.values(pRecords || {});
		for (const tmpRecord of tmpRecordList)
		{
			const tmpGUID = tmpRecord[tmpGUIDColumn] || tmpRecord[`_${tmpGUIDColumn}`];
			if (tmpGUID)
			{
				tmpGUIDs.add(String(tmpGUID));
			}
			if (!tmpIDCustomer && tmpRecord.IDCustomer > 0)
			{
				tmpIDCustomer = Number(tmpRecord.IDCustomer);
			}
		}

		const tmpResult = { Entity: pEntity, Candidates: tmpGUIDs.size, Revived: 0, Failed: 0, Scanned: 0, Truncated: false };
		if (tmpGUIDs.size < 1)
		{
			return tmpResult;
		}

		let tmpFound;
		try
		{
			tmpFound = await this.findDeletedMatches(pEntity, tmpGUIDs, tmpIDCustomer);
		}
		catch (pError)
		{
			// A table without a Deleted column rejects the filter. That is not a
			// failure of the load -- it just cannot hold a soft-deleted row.
			this.log.info(`Skipping delete-revival scan for [${pEntity}]: ${pError.message || pError}`);
			return tmpResult;
		}

		tmpResult.Scanned = tmpFound.Scanned;
		tmpResult.Truncated = tmpFound.Truncated;

		if (tmpFound.Truncated)
		{
			this.log.warn(`Delete-revival scan for [${pEntity}] stopped at the scan limit after ${tmpFound.Scanned} rows; soft-deleted records beyond it were not checked and may upsert as duplicates.`);
		}
		if (tmpFound.Matches.length < 1)
		{
			return tmpResult;
		}

		this.log.info(`Reviving ${tmpFound.Matches.length} soft-deleted [${pEntity}] record(s) before upsert.`);

		for (const tmpMatch of tmpFound.Matches)
		{
			const tmpUndeleted = await this.undeleteRecord(pEntity, tmpMatch.ID);
			if (tmpUndeleted)
			{
				tmpResult.Revived++;
			}
			else
			{
				tmpResult.Failed++;
			}
		}

		return tmpResult;
	}

	/**
	 * Revive soft-deleted records across a whole comprehension.
	 *
	 * @param {Record<string, any>} pComprehension
	 * @param {Array<string>} [pEntitySequence] - Restrict/order the entities scanned.
	 * @return {Promise<{ Entities: Array<Object>, TotalRevived: number, TotalFailed: number }>}
	 */
	async reviveComprehension(pComprehension, pEntitySequence)
	{
		const tmpEntities = pEntitySequence || Object.keys(pComprehension || {});
		const tmpResults = [];
		let tmpTotalRevived = 0;
		let tmpTotalFailed = 0;

		for (const tmpEntity of tmpEntities)
		{
			if (!pComprehension[tmpEntity])
			{
				continue;
			}
			const tmpResult = await this.reviveEntity(tmpEntity, pComprehension[tmpEntity]);
			tmpResults.push(tmpResult);
			tmpTotalRevived += tmpResult.Revived;
			tmpTotalFailed += tmpResult.Failed;
		}

		return { Entities: tmpResults, TotalRevived: tmpTotalRevived, TotalFailed: tmpTotalFailed };
	}
}

module.exports = HeadlightDeletedRecordReviver;
module.exports.default_configuration = { ScanLimit: DEFAULT_SCAN_LIMIT };
module.exports.SCAN_PAGE_SIZE = SCAN_PAGE_SIZE;
module.exports.DEFAULT_SCAN_LIMIT = DEFAULT_SCAN_LIMIT;
module.exports.INCLUDE_DELETED_PARAMETER = INCLUDE_DELETED_PARAMETER;

},{"fable-serviceproviderbase":438}],6:[function(require,module,exports){
/**
 * headlight-dashboard-access — which dashboards a user may open, the one they land on, and the data filter their roles
 * bind to each.
 *
 * Rules are data: a map in the `DashboardAccess` configuration namespace (NamespaceValue `Rules`). A rule grants the
 * dashboards it lists to an audience of roles. Customer roles grant every listed dashboard; project roles grant only the
 * project-bound ones, and only for the project being viewed.
 *
 * DOM-free so the resolver endpoint and the config app's preview answer identically.
 */

const libNavigation = require('headlight-entity-navigation');

const NAMESPACE = 'DashboardAccess';
const NAMESPACE_VALUE = 'Rules';

/**
 * Filter operators a rule may bind, with their meadow filter spelling and plain-language label.
 *
 * @type {Record<string, { Meadow: string, List: boolean, Label: string }>}
 */
const OPERATORS =
{
	EQ: { Meadow: 'EQ', List: false, Label: 'is' },
	NE: { Meadow: 'NE', List: false, Label: 'is not' },
	GT: { Meadow: 'GT', List: false, Label: 'is more than' },
	GE: { Meadow: 'GE', List: false, Label: 'is at least' },
	LT: { Meadow: 'LT', List: false, Label: 'is less than' },
	LE: { Meadow: 'LE', List: false, Label: 'is at most' },
	LK: { Meadow: 'LK', List: false, Label: 'matches' },
	IN: { Meadow: 'INN', List: true, Label: 'is one of' },
	NI: { Meadow: 'NIN', List: true, Label: 'is not one of' },
};

/**
 * Values a filter can take from the person viewing, with the phrase the config screen shows for each. `Missing` is what
 * the person is told when they have no such value, so the filter is dropped and they see more than usual: what is
 * missing, what they see instead, and who can set it up.
 *
 * @type {Record<string, { Label: string, List: boolean, Missing?: { Title: string, Message: string } }>}
 */
const TOKENS =
{
	'User.IDUser': { Label: 'the person viewing', List: false },
	'User.IDCustomer': { Label: 'their organization', List: false },
	'User.LabIDs':
	{
		Label: 'their labs', List: true,
		Missing:
		{
			Title: 'Showing every lab, not just yours',
			Message: 'You aren\'t on a lab team in HeadLight, so this dashboard can\'t tell which lab is yours. To see only your lab\'s work, ask your lab supervisor or HeadLight administrator to add you to your lab\'s team.',
		},
	},
	'User.TeamIDs':
	{
		Label: 'their teams', List: true,
		Missing:
		{
			Title: 'Showing every team, not just yours',
			Message: 'You aren\'t on a team in HeadLight, so this dashboard can\'t narrow itself to your team\'s work. Ask your supervisor or HeadLight administrator to add you to your team.',
		},
	},
	'User.TeamHashes':
	{
		Label: 'their teams (by team code)', List: true,
		Missing:
		{
			Title: 'Showing every team, not just yours',
			Message: 'You aren\'t on a team in HeadLight, so this dashboard can\'t narrow itself to your team\'s work. Ask your supervisor or HeadLight administrator to add you to your team.',
		},
	},
	'User.ProjectIDs':
	{
		Label: 'their projects', List: true,
		Missing:
		{
			Title: 'Showing every project, not just yours',
			Message: 'You aren\'t a member of any project in HeadLight, so this dashboard can\'t narrow itself to your projects. Ask the project engineer or your HeadLight administrator to add you to your projects.',
		},
	},
	'User.CertifiedTestHashes':
	{
		Label: 'the tests they are certified for', List: true,
		Missing:
		{
			Title: 'Showing every test, not just the ones you\'re certified for',
			Message: 'HeadLight doesn\'t have your test certifications yet, so this dashboard can\'t narrow itself to the tests you\'re certified for.',
		},
	},
	'Context.IDProject': { Label: 'the project being viewed', List: false },
};

const TOKEN_PATTERN = /\{~D:([A-Za-z0-9_.]+)~\}/g;
const WHOLE_TOKEN_PATTERN = /^\{~D:([A-Za-z0-9_.]+)~\}$/;

/**
 * @typedef {Object} FilterClause
 * @property {string} Field - Column on the dashboard's data source.
 * @property {string} Operator - A key of OPERATORS.
 * @property {any} Value - A literal, a list, or a `{~D:User.LabIDs~}` style token.
 */

/**
 * @typedef {Object} AccessRule
 * @property {string} [Label] - Plain-language name, e.g. "Lab technicians".
 * @property {number} [Order] - Lower runs first. Default 100.
 * @property {boolean} [Enabled] - false turns the rule off.
 * @property {{ Roles?: Array<string>, PermissionLevels?: Array<string> }} Audience - GUIDRole (or role name) values.
 * @property {Array<string>} Dashboards - Dashboard hashes this rule grants.
 * @property {string} [Landing] - The dashboard to open first. When the customer doesn't have it (yet), the first dashboard
 *   this rule does grant, unless another rule's own landing applies.
 * @property {Record<string, Array<FilterClause>>} [DataFilters] - Per dashboard hash.
 */

/**
 * @typedef {Object} RoleRecord
 * @property {string} [Hash] - GUIDRole.
 * @property {string} [Name]
 * @property {string} [PermissionLevel]
 */

/**
 * @typedef {Object} CatalogEntry
 * @property {string} Hash
 * @property {boolean} [ProjectBound]
 */

/**
 * @typedef {Object} ResolvedDashboard
 * @property {string} Hash
 * @property {Array<string>} GrantedBy - Rule keys (or 'super-user' / 'no rules').
 * @property {Array<FilterClause>} DataFilter - Clauses with their values resolved.
 * @property {string} DataFilterString - The same clauses as a meadow filter string ('' when none).
 * @property {Array<FilterClause>} Unresolved - Clauses dropped because a token had no value for this user.
 */

/**
 * @param {any} pObject
 * @param {string} pAddress - Dotted path.
 * @return {any}
 */
function getAtAddress(pObject, pAddress)
{
	let tmpValue = pObject;
	for (const tmpPart of String(pAddress).split('.'))
	{
		if (tmpValue === null || tmpValue === undefined)
		{
			return undefined;
		}
		tmpValue = tmpValue[tmpPart];
	}
	return tmpValue;
}

/**
 * @param {Record<string, AccessRule>} pRules
 * @return {Array<[string, AccessRule]>} enabled rules, by Order then key
 */
function orderRules(pRules)
{
	return Object.entries(pRules || {})
		.filter(([ , pRule ]) => pRule && typeof pRule === 'object' && pRule.Enabled !== false && Array.isArray(pRule.Dashboards))
		.sort(([ pKeyA, pA ], [ pKeyB, pB ]) => ((pA.Order ?? 100) - (pB.Order ?? 100)) || pKeyA.localeCompare(pKeyB));
}

/**
 * @param {Record<string, AccessRule>} pRules
 * @return {boolean} true when at least one enabled rule exists — with none, access control is off for the customer
 */
function hasRules(pRules)
{
	return orderRules(pRules).length > 0;
}

/**
 * A rule with no roles and no permission levels matches nobody: a rule must say who it is for.
 *
 * @param {AccessRule['Audience']} pAudience
 * @param {Array<RoleRecord>} pRoles
 * @return {{ Match: boolean, Reason?: string }}
 */
function matchRoles(pAudience, pRoles)
{
	const tmpHasRoles = pAudience && Array.isArray(pAudience.Roles) && pAudience.Roles.length > 0;
	const tmpHasLevels = pAudience && Array.isArray(pAudience.PermissionLevels) && pAudience.PermissionLevels.length > 0;
	if (!tmpHasRoles && !tmpHasLevels)
	{
		return { Match: false, Reason: 'no audience' };
	}
	return libNavigation.matchAudience({ Roles: pAudience.Roles, PermissionLevels: pAudience.PermissionLevels }, { UserRoles: pRoles || [] }, null);
}

/**
 * Resolve one clause's value against `{ User, Context }`.
 *
 * @param {FilterClause} pClause
 * @param {Object} pData
 * @return {FilterClause|null} null when the clause can't be applied for this user
 */
function resolveClause(pClause, pData)
{
	const tmpOperator = OPERATORS[pClause && pClause.Operator];
	if (!tmpOperator || !pClause.Field)
	{
		return null;
	}
	let tmpValue = pClause.Value;
	if (typeof tmpValue === 'string')
	{
		const tmpWhole = WHOLE_TOKEN_PATTERN.exec(tmpValue);
		if (tmpWhole)
		{
			tmpValue = getAtAddress(pData, tmpWhole[1]);
		}
		else
		{
			let tmpMissing = false;
			tmpValue = tmpValue.replace(TOKEN_PATTERN, (pMatch, pAddress) =>
			{
				const tmpPart = getAtAddress(pData, pAddress);
				if (tmpPart === undefined || tmpPart === null || tmpPart === '' || Array.isArray(tmpPart))
				{
					tmpMissing = true;
					return '';
				}
				return String(tmpPart);
			});
			if (tmpMissing)
			{
				return null;
			}
		}
	}
	if (tmpOperator.List)
	{
		const tmpList = Array.isArray(tmpValue) ? tmpValue : (tmpValue === undefined || tmpValue === null || tmpValue === '') ? [] : String(tmpValue).split(',');
		const tmpClean = tmpList.map((pItem) => String(pItem).trim()).filter((pItem) => pItem !== '');
		if (tmpClean.length < 1)
		{
			return null;
		}
		return { Field: pClause.Field, Operator: pClause.Operator, Value: tmpClean };
	}
	if (tmpValue === undefined || tmpValue === null || tmpValue === '' || Array.isArray(tmpValue) || typeof tmpValue === 'object')
	{
		return null;
	}
	return { Field: pClause.Field, Operator: pClause.Operator, Value: tmpValue };
}

/**
 * @param {Array<FilterClause>} pClauses
 * @param {Object} pData - `{ User, Context }`
 * @return {{ Clauses: Array<FilterClause>, Unresolved: Array<FilterClause> }}
 */
function resolveClauses(pClauses, pData)
{
	const tmpResult = { Clauses: [], Unresolved: [] };
	for (const tmpClause of (Array.isArray(pClauses) ? pClauses : []))
	{
		const tmpResolved = resolveClause(tmpClause, pData);
		if (tmpResolved)
		{
			tmpResult.Clauses.push(tmpResolved);
		}
		else
		{
			tmpResult.Unresolved.push(tmpClause);
		}
	}
	return tmpResult;
}

/**
 * Compile resolved clauses into a meadow filter string (not URI-encoded).
 *
 * @param {Array<FilterClause>} pClauses
 * @return {string}
 */
function compileFilter(pClauses)
{
	return (Array.isArray(pClauses) ? pClauses : [])
		.filter((pClause) => OPERATORS[pClause.Operator])
		.map((pClause) =>
		{
			const tmpOperator = OPERATORS[pClause.Operator];
			if (tmpOperator.List)
			{
				return `FBL~${pClause.Field}~${tmpOperator.Meadow}~${[].concat(pClause.Value).join(',')}`;
			}
			return `FBV~${pClause.Field}~${tmpOperator.Meadow}~${pClause.Value}`;
		})
		.join('~');
}

/**
 * @param {FilterClause} pClause
 * @return {string}
 */
function clauseKey(pClause)
{
	return `${pClause.Field}|${pClause.Operator}|${JSON.stringify(pClause.Value)}`;
}

/**
 * Combine the filters of every rule that grants one dashboard. Most permissive wins: an unfiltered grant means no role
 * filter at all; otherwise only clauses common to every grant apply, so the result shows at least what each rule would.
 *
 * @param {Array<Array<FilterClause>|null>} pGrantFilters
 * @return {Array<FilterClause>}
 */
function combineGrantFilters(pGrantFilters)
{
	if (pGrantFilters.length < 1 || pGrantFilters.some((pClauses) => !Array.isArray(pClauses) || pClauses.length < 1))
	{
		return [];
	}
	const [ tmpFirst, ...tmpRest ] = pGrantFilters;
	return tmpFirst.filter((pClause) => tmpRest.every((pClauses) => pClauses.some((pOther) => clauseKey(pOther) === clauseKey(pClause))));
}

/**
 * @param {CatalogEntry} pEntry
 * @param {Array<string>} pGrantedBy
 * @param {Array<FilterClause>} pClauses
 * @param {Object} pData
 * @return {CatalogEntry & ResolvedDashboard}
 */
function buildResolved(pEntry, pGrantedBy, pClauses, pData)
{
	const tmpResolved = resolveClauses(pClauses, pData);
	return Object.assign({}, pEntry, { GrantedBy: pGrantedBy, DataFilter: tmpResolved.Clauses, DataFilterString: compileFilter(tmpResolved.Clauses), Unresolved: tmpResolved.Unresolved });
}

/**
 * Resolve which dashboards a user may open.
 *
 * @param {Object} pRequest
 * @param {Record<string, AccessRule>} pRequest.Rules - The merged `DashboardAccess` / `Rules` map.
 * @param {Array<CatalogEntry>} pRequest.Catalog - Every dashboard the customer has, in display order.
 * @param {Array<RoleRecord>} pRequest.CustomerRoles - The user's customer roles (with child roles).
 * @param {Array<RoleRecord>} [pRequest.ProjectRoles] - Their roles on Context.IDProject.
 * @param {{ IDProject?: number }} [pRequest.Context]
 * @param {Object} [pRequest.User] - Token values: IDUser, IDCustomer, LabIDs, ProjectIDs, CertifiedTestHashes.
 * @param {boolean} [pRequest.IsSuperUser]
 * @return {{ Enforced: boolean, Landing: string|null, Dashboards: Array<CatalogEntry & ResolvedDashboard>, Explain: Array<string> }}
 */
function resolveAccess(pRequest)
{
	const tmpCatalog = Array.isArray(pRequest.Catalog) ? pRequest.Catalog : [];
	const tmpContext = pRequest.Context || {};
	const tmpData = { User: pRequest.User || {}, Context: tmpContext };
	const tmpExplain = [];

	if (pRequest.IsSuperUser)
	{
		tmpExplain.push('super-user: every dashboard, no role filters');
		return { Enforced: false, Landing: null, Dashboards: tmpCatalog.map((pEntry) => buildResolved(pEntry, [ 'super-user' ], [], tmpData)), Explain: tmpExplain };
	}
	if (!hasRules(pRequest.Rules))
	{
		tmpExplain.push('no access rules for this customer: every dashboard, no role filters');
		return { Enforced: false, Landing: null, Dashboards: tmpCatalog.map((pEntry) => buildResolved(pEntry, [ 'no rules' ], [], tmpData)), Explain: tmpExplain };
	}

	const tmpCatalogByHash = new Map(tmpCatalog.map((pEntry) => [ pEntry.Hash, pEntry ]));
	/** @type {Map<string, Array<{ RuleKey: string, Clauses: Array<FilterClause>|null }>>} */
	const tmpGrants = new Map();
	let tmpLanding = null;
	let tmpFallbackLanding = null;

	for (const [ tmpKey, tmpRule ] of orderRules(pRequest.Rules))
	{
		const tmpCustomerMatch = matchRoles(tmpRule.Audience, pRequest.CustomerRoles);
		const tmpProjectMatch = tmpContext.IDProject ? matchRoles(tmpRule.Audience, pRequest.ProjectRoles) : { Match: false, Reason: 'no project' };
		if (!tmpCustomerMatch.Match && !tmpProjectMatch.Match)
		{
			tmpExplain.push(`${tmpKey}: skipped (${tmpCustomerMatch.Reason})`);
			continue;
		}
		const tmpGrantedHere = [];
		for (const tmpHash of tmpRule.Dashboards)
		{
			const tmpEntry = tmpCatalogByHash.get(tmpHash);
			if (!tmpEntry)
			{
				tmpExplain.push(`${tmpKey}: ${tmpHash} skipped (not a dashboard this customer has)`);
				continue;
			}
			if (!tmpCustomerMatch.Match && !tmpEntry.ProjectBound)
			{
				tmpExplain.push(`${tmpKey}: ${tmpHash} skipped (project role, dashboard is not project-bound)`);
				continue;
			}
			const tmpClauses = (tmpRule.DataFilters && Array.isArray(tmpRule.DataFilters[tmpHash])) ? tmpRule.DataFilters[tmpHash] : null;
			if (!tmpGrants.has(tmpHash))
			{
				tmpGrants.set(tmpHash, []);
			}
			tmpGrants.get(tmpHash).push({ RuleKey: tmpKey, Clauses: tmpClauses });
			tmpGrantedHere.push(tmpHash);
		}
		tmpExplain.push(`${tmpKey}: matched (${tmpCustomerMatch.Match ? 'customer role' : 'project role'}) → ${tmpGrantedHere.join(', ') || 'nothing'}`);
		// A project-bound dashboard can't open without a project, so it is never a landing outside one.
		const tmpOpenableHere = tmpGrantedHere.filter((pHash) => tmpContext.IDProject || !tmpCatalogByHash.get(pHash).ProjectBound);
		if (!tmpLanding && tmpRule.Landing && tmpOpenableHere.includes(tmpRule.Landing))
		{
			tmpLanding = tmpRule.Landing;
		}
		else if (!tmpFallbackLanding && tmpRule.Landing && !tmpOpenableHere.includes(tmpRule.Landing) && tmpOpenableHere.length > 0)
		{
			tmpFallbackLanding = tmpOpenableHere[0];
			tmpExplain.push(`${tmpKey}: landing ${tmpRule.Landing} not available here; falls back to ${tmpFallbackLanding}`);
		}
	}
	if (!tmpLanding)
	{
		tmpLanding = tmpFallbackLanding;
	}

	const tmpDashboards = tmpCatalog
		.filter((pEntry) => tmpGrants.has(pEntry.Hash))
		.map((pEntry) =>
		{
			const tmpEntryGrants = tmpGrants.get(pEntry.Hash);
			return buildResolved(pEntry, tmpEntryGrants.map((pGrant) => pGrant.RuleKey), combineGrantFilters(tmpEntryGrants.map((pGrant) => pGrant.Clauses)), tmpData);
		});
	return { Enforced: true, Landing: tmpLanding, Dashboards: tmpDashboards, Explain: tmpExplain };
}

/**
 * Plain-language sentence for a clause, e.g. "Lab is one of their labs".
 *
 * @param {FilterClause} pClause
 * @param {Record<string, string>} [pFieldLabels] - Field → label.
 * @return {string}
 */
function describeClause(pClause, pFieldLabels)
{
	const tmpField = (pFieldLabels && pFieldLabels[pClause.Field]) || pClause.Field;
	const tmpOperator = OPERATORS[pClause.Operator];
	const tmpVerb = tmpOperator ? tmpOperator.Label : pClause.Operator;
	let tmpValue = pClause.Value;
	if (typeof tmpValue === 'string')
	{
		const tmpWhole = WHOLE_TOKEN_PATTERN.exec(tmpValue);
		if (tmpWhole && TOKENS[tmpWhole[1]])
		{
			return `${tmpField} ${tmpVerb} ${TOKENS[tmpWhole[1]].Label}`;
		}
	}
	if (Array.isArray(tmpValue))
	{
		tmpValue = tmpValue.join(', ');
	}
	return `${tmpField} ${tmpVerb} ${tmpValue}`;
}

/**
 * What to tell the person viewing about filter clauses dropped for them (a dashboard's `Unresolved`): one notice per
 * missing value, in plain language. A clause with no `Missing` copy gets a general notice naming the filter.
 *
 * @param {Array<FilterClause>} pClauses
 * @param {Record<string, string>} [pFieldLabels] - Field → label.
 * @return {Array<{ Title: string, Message: string }>}
 */
function describeUnresolved(pClauses, pFieldLabels)
{
	const tmpNotices = [];
	const tmpSeen = new Set();
	for (const tmpClause of (Array.isArray(pClauses) ? pClauses : []))
	{
		const tmpWhole = (typeof tmpClause.Value === 'string') ? WHOLE_TOKEN_PATTERN.exec(tmpClause.Value) : null;
		const tmpToken = tmpWhole && TOKENS[tmpWhole[1]];
		const tmpNotice = (tmpToken && tmpToken.Missing) ? tmpToken.Missing :
			{
				Title: 'Showing more than usual',
				Message: `Part of this dashboard's usual filter (${describeClause(tmpClause, pFieldLabels)}) isn't set up for you in HeadLight, so it shows more than it normally would. If that looks wrong, contact HeadLight support.`,
			};
		if (!tmpSeen.has(tmpNotice.Title + tmpNotice.Message))
		{
			tmpSeen.add(tmpNotice.Title + tmpNotice.Message);
			tmpNotices.push({ Title: tmpNotice.Title, Message: tmpNotice.Message });
		}
	}
	return tmpNotices;
}

module.exports =
{
	NAMESPACE,
	NAMESPACE_VALUE,
	OPERATORS,
	TOKENS,
	orderRules,
	hasRules,
	matchRoles,
	resolveClause,
	resolveClauses,
	compileFilter,
	combineGrantFilters,
	resolveAccess,
	describeClause,
	describeUnresolved,
};

},{"headlight-entity-navigation":7}],7:[function(require,module,exports){
/**
 * headlight-entity-navigation — where a record opens, for whom.
 *
 * Rules are data: an ordered map per entity type (stored in the `EntityDestinations` configuration
 * namespace, NamespaceValue = entity name, so Global → Customer → Project cascade merges them by
 * rule key). A rule matches when its Audience matches the signed-in user and its When conditions
 * match the record; the first match is the primary destination and the rest are alternatives.
 *
 * DOM-free and dependency-light so the links server and browser apps resolve identically.
 */

const libHosts = require('headlight-qrcode/source/Headlight-QRCode-Hosts.js');

/**
 * Apps a destination can target. Module gates only where an app really checks one (LIMS does not).
 *
 * @type {Record<string, { Subdomain: string, Module?: string }>}
 */
const APPS =
{
	LIMS: { Subdomain: 'lims' },
	Fieldbook: { Subdomain: 'fieldbook', Module: 'HEADLIGHT_FIELDBOOK' },
	Vault: { Subdomain: 'vault', Module: 'HEADLIGHT_VAULT' },
	Portal: { Subdomain: 'portal' },
	Home: { Subdomain: 'home', Module: 'HeadLight' },
	Config: { Subdomain: 'config' },
	Links: { Subdomain: 'links' },
};

/**
 * @typedef {Object} DestinationRule
 * @property {number} [Order] - Lower runs first. Default 100.
 * @property {boolean} [Enabled] - false turns a rule off (e.g. a customer disabling a platform rule).
 * @property {string} Label - Plain-language button text, e.g. "Open in LIMS".
 * @property {{ Roles?: Array<string>, PermissionLevels?: Array<string>, MinimumRoleIndex?: number, Modules?: Array<string>, From?: Array<string> }} [Audience]
 * @property {Record<string, Array<any>>} [When] - e.g. `{ "Record.Status": [ "RECV" ], "Project.Status": [ "Closed" ] }`
 * @property {{ App?: string, Route?: string, Via?: string, Pick?: 'Oldest'|'Newest', Landing?: boolean }} Target
 */

/**
 * @typedef {Object} Destination
 * @property {string} Key - The rule key.
 * @property {string} Label
 * @property {'URL'|'Via'|'Landing'} Kind
 * @property {string} [URL]
 * @property {string} [App]
 * @property {string} [Via] - Related entity to resolve instead (e.g. Document).
 * @property {'Oldest'|'Newest'} [Pick]
 */

/**
 * @param {any} pObject
 * @param {string} pAddress - Dotted path.
 * @return {any}
 */
function getAtAddress(pObject, pAddress)
{
	let tmpValue = pObject;
	for (const tmpPart of String(pAddress).split('.'))
	{
		if (tmpValue === null || tmpValue === undefined)
		{
			return undefined;
		}
		tmpValue = tmpValue[tmpPart];
	}
	return tmpValue;
}

/**
 * Fill `{~D:Record.GUIDSample~}` style tokens, URI-encoding each value. Nothing else is evaluated:
 * route templates are written by administrators, so they get data substitution only.
 *
 * @param {string} pTemplate
 * @param {Object} pData - `{ Record, Project, Document, Session }`
 * @return {string|null} null when a referenced value is missing
 */
function fillRouteTemplate(pTemplate, pData)
{
	let tmpMissing = false;
	const tmpResult = String(pTemplate || '').replace(/\{~D:([A-Za-z0-9_.]+)~\}/g, (pMatch, pAddress) =>
	{
		const tmpValue = getAtAddress(pData, pAddress);
		if (tmpValue === undefined || tmpValue === null || tmpValue === '')
		{
			tmpMissing = true;
			return '';
		}
		return encodeURIComponent(String(tmpValue));
	});
	return tmpMissing ? null : tmpResult;
}

/**
 * @param {DestinationRule['Audience']} pAudience
 * @param {Object} pSession - `{ UserRoleIndex, UserRoles: [{ Hash, Name, PermissionLevel }] }`
 * @param {Array<string>|null} pModules
 * @param {string} [pFrom]
 * @return {{ Match: boolean, Reason?: string }}
 */
function matchAudience(pAudience, pSession, pModules, pFrom)
{
	if (!pAudience)
	{
		return { Match: true };
	}
	const tmpSession = pSession || {};
	const tmpRoles = Array.isArray(tmpSession.UserRoles) ? tmpSession.UserRoles : [];
	if (Array.isArray(pAudience.Roles) && pAudience.Roles.length > 0)
	{
		const tmpHasRole = tmpRoles.some((pRole) => pAudience.Roles.includes(pRole.Hash) || pAudience.Roles.includes(pRole.Name));
		if (!tmpHasRole)
		{
			return { Match: false, Reason: 'role' };
		}
	}
	if (Array.isArray(pAudience.PermissionLevels) && pAudience.PermissionLevels.length > 0)
	{
		if (!tmpRoles.some((pRole) => pAudience.PermissionLevels.includes(pRole.PermissionLevel)))
		{
			return { Match: false, Reason: 'permission level' };
		}
	}
	if (typeof pAudience.MinimumRoleIndex === 'number' && !(Number(tmpSession.UserRoleIndex) >= pAudience.MinimumRoleIndex))
	{
		return { Match: false, Reason: 'role level' };
	}
	if (Array.isArray(pAudience.Modules) && pAudience.Modules.length > 0)
	{
		if (!pModules || !pAudience.Modules.some((pModule) => pModules.includes(pModule)))
		{
			return { Match: false, Reason: 'module' };
		}
	}
	if (Array.isArray(pAudience.From) && pAudience.From.length > 0 && !pAudience.From.includes(pFrom))
	{
		return { Match: false, Reason: 'calling app' };
	}
	return { Match: true };
}

/**
 * @param {Record<string, Array<any>>} pWhen
 * @param {Object} pData
 * @return {{ Match: boolean, Reason?: string }}
 */
function matchWhen(pWhen, pData)
{
	if (!pWhen)
	{
		return { Match: true };
	}
	for (const [ tmpAddress, tmpAllowed ] of Object.entries(pWhen))
	{
		const tmpValue = getAtAddress(pData, tmpAddress);
		const tmpList = Array.isArray(tmpAllowed) ? tmpAllowed : [ tmpAllowed ];
		if (!tmpList.some((pAllowed) => String(pAllowed) === String(tmpValue)))
		{
			return { Match: false, Reason: `${tmpAddress} is ${tmpValue === undefined ? 'unset' : JSON.stringify(tmpValue)}` };
		}
	}
	return { Match: true };
}

/**
 * @param {Record<string, DestinationRule>} pRules
 * @return {Array<[string, DestinationRule]>} enabled rules, by Order then key
 */
function orderRules(pRules)
{
	return Object.entries(pRules || {})
		.filter(([ , pRule ]) => pRule && typeof pRule === 'object' && pRule.Enabled !== false && pRule.Target)
		.sort(([ pKeyA, pA ], [ pKeyB, pB ]) => ((pA.Order ?? 100) - (pB.Order ?? 100)) || pKeyA.localeCompare(pKeyB));
}

/**
 * Resolve where a record opens.
 *
 * @param {Object} pRequest
 * @param {Record<string, DestinationRule>} pRequest.Rules - The merged rule map for this entity.
 * @param {Object} pRequest.Data - `{ Record, Project?, Document?, Session }` (addresses rules can test and template).
 * @param {Array<string>|null} [pRequest.Modules] - The user's modules, when any rule needs them.
 * @param {string} [pRequest.From] - The calling app (e.g. 'links', 'LIMS').
 * @param {string} [pRequest.Environment] - Environment name for app URLs. Default Production.
 * @return {{ Primary: Destination|null, Alternatives: Array<Destination>, Explain: Array<string> }}
 */
function resolveDestinations(pRequest)
{
	const tmpExplain = [];
	const tmpMatches = [];
	const tmpSeen = new Set();
	for (const [ tmpKey, tmpRule ] of orderRules(pRequest.Rules))
	{
		const tmpAudience = matchAudience(tmpRule.Audience, pRequest.Data && pRequest.Data.Session, pRequest.Modules || null, pRequest.From);
		if (!tmpAudience.Match)
		{
			tmpExplain.push(`${tmpKey}: skipped (${tmpAudience.Reason})`);
			continue;
		}
		const tmpWhen = matchWhen(tmpRule.When, pRequest.Data);
		if (!tmpWhen.Match)
		{
			tmpExplain.push(`${tmpKey}: skipped (${tmpWhen.Reason})`);
			continue;
		}
		const tmpTarget = tmpRule.Target;
		/** @type {Destination|null} */
		let tmpDestination = null;
		if (tmpTarget.Landing)
		{
			tmpDestination = { Key: tmpKey, Label: tmpRule.Label, Kind: 'Landing' };
		}
		else if (tmpTarget.Via)
		{
			tmpDestination = { Key: tmpKey, Label: tmpRule.Label, Kind: 'Via', Via: tmpTarget.Via, Pick: tmpTarget.Pick || 'Oldest' };
		}
		else if (tmpTarget.App && APPS[tmpTarget.App])
		{
			const tmpApp = APPS[tmpTarget.App];
			if (tmpApp.Module && pRequest.Modules && !pRequest.Modules.includes(tmpApp.Module))
			{
				tmpExplain.push(`${tmpKey}: skipped (no ${tmpTarget.App} module)`);
				continue;
			}
			const tmpRoute = fillRouteTemplate(tmpTarget.Route || '', pRequest.Data);
			if (tmpRoute === null)
			{
				tmpExplain.push(`${tmpKey}: skipped (route needs a value the record doesn't have)`);
				continue;
			}
			tmpDestination = { Key: tmpKey, Label: tmpRule.Label, Kind: 'URL', App: tmpTarget.App, URL: `${libHosts.getAppBaseURL(tmpApp.Subdomain, pRequest.Environment)}${tmpRoute}` };
		}
		else
		{
			tmpExplain.push(`${tmpKey}: skipped (unknown target)`);
			continue;
		}
		const tmpIdentity = tmpDestination.URL || `${tmpDestination.Kind}:${tmpDestination.Via || ''}`;
		if (tmpSeen.has(tmpIdentity))
		{
			continue;
		}
		tmpSeen.add(tmpIdentity);
		tmpExplain.push(`${tmpKey}: matched`);
		tmpMatches.push(tmpDestination);
	}
	return { Primary: tmpMatches[0] || null, Alternatives: tmpMatches.slice(1), Explain: tmpExplain };
}

/**
 * @param {Record<string, DestinationRule>} pRules
 * @return {boolean} true when at least one enabled rule exists
 */
function hasRules(pRules)
{
	return orderRules(pRules).length > 0;
}

/**
 * True when any enabled rule needs the user's module list (so callers only fetch it when needed).
 *
 * @param {Record<string, DestinationRule>} pRules
 * @return {boolean}
 */
function needsModules(pRules)
{
	return orderRules(pRules).some(([ , pRule ]) => (pRule.Audience && Array.isArray(pRule.Audience.Modules) && pRule.Audience.Modules.length > 0) || (pRule.Target.App && APPS[pRule.Target.App] && APPS[pRule.Target.App].Module));
}

module.exports =
{
	APPS,
	resolveDestinations,
	fillRouteTemplate,
	matchAudience,
	matchWhen,
	hasRules,
	needsModules,
};

},{"headlight-qrcode/source/Headlight-QRCode-Hosts.js":16}],8:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libAsync = require('async');
const libGUIDMap = require('./Headlight-Integration-GUIDMap.js');
const libGUIDBatchResolver = require('./Headlight-Integration-GUIDBatchResolver.js');

// Conservative default used until loadSchema() applies the authoritative
// per-entity GUID column size from the live Headlight API.
const _GUID_MAX_LENGTH_FALLBACK = 36;

// Composite-key separator for the unresolved-reference set. Printable on purpose: a literal NUL
// here makes GNU grep treat this whole source file as binary and silently skip it.
const UNRESOLVED_GUID_KEY_SEPARATOR = '\u241F';

/**
 * Is a source record's `Deleted` flag set, in whatever shape the source produced it?
 *
 * Storage layers disagree about how a boolean is represented and every one of them is legitimate:
 * MySQL's `tinyint` arrives as `1`/`0` through mysql2, PostgreSQL gives a real `true`/`false`, and
 * anything that has been through JSON, a CSV, a spreadsheet or a comprehension projection arrives
 * as the string `"1"`. A strict `=== true` honoured only the second of those and treated the rest as
 * a live record — an upsert instead of a delete, reported as success.
 *
 * Only the SET side is widened. `0`, `"0"`, `""`, `false`, `"false"`, `null`, `undefined` and an
 * absent property all remain not-deleted, so a record can never become a delete by accident.
 *
 * Kept in step with the same predicate in `meadow-integration`, which this adapter is a fork of.
 *
 * @param {any} pValue - the source record's `Deleted` value, in any representation
 * @return {boolean} true when the record should be routed to the delete pass
 */
const isDeletedFlagSet = function(pValue)
{
	if (typeof (pValue) === 'boolean')
	{
		return pValue;
	}
	if (typeof (pValue) === 'number')
	{
		return (pValue !== 0);
	}
	if (typeof (pValue) === 'string')
	{
		const tmpValue = pValue.trim().toLowerCase();
		return (tmpValue === '1') || (tmpValue === 'true') || (tmpValue === 't') || (tmpValue === 'y') || (tmpValue === 'yes');
	}
	return false;
};

const defaultHeadlightIntegrationAdapterOptions = (
	{
		"Entity": "DefaultEntity",

		"AdapterSetGUIDMarshalPrefix": false,

		"EntityGUIDMarshalPrefix": false,

		// Maximum allowed length for generated Headlight GUIDs.
		// When 0, the authoritative per-entity size is applied by
		// loadSchema() (called automatically from integrateRecords()).
		// Until then, _GUID_MAX_LENGTH_FALLBACK (36) is used as a
		// conservative default.  Set to a positive integer to explicitly
		// override for all entities.
		"GUIDMaxLength": 0,

		// Optional pre-fetched entity schema document (same shape as the
		// /{Entity}/Schema API response).  When provided, the adapter
		// applies it at construction time and loadSchema() skips the
		// network round-trip.  Useful for callers that cache schemas
		// across many adapters.  Caller is responsible for keeping the
		// cached copy reasonably fresh relative to the deployed server.
		"Schema": null,

		// When false (default), the adapter will throw an error if a generated GUID
		// exceeds GUIDMaxLength, halting the integration.
		// When true, the prefix is truncated to fit while preserving the full external GUID.
		// Only enable this for one-time imports where GUID stability is not required.
		"AllowGUIDTruncation": false,

		"PerformUpserts": true,
		"PerformDeletes": true,

		// Resolve every mapped GUID reference in the source buffer with batched
		// IN-list reads before marshaling, instead of one lookup per reference.
		"BatchGUIDResolution": true,

		// Options for the batch resolver (batch sizes, read mode, whether the
		// body-driven read route may be used) -- see
		// Headlight-Integration-GUIDBatchResolver.js.
		"GUIDBatchResolutionOptions": {},

		"RecordPushRetryThreshold": 5,

		"RecordThresholdForBulkUpsert": 250,
		"BulkUpsertBatchSize": 100,

		"HeadlightAPIURL": '/1.0/'
	});

/**
 * Pull a readable message out of the per-record `Error` property meadow-endpoints attaches to a
 * row that failed inside a bulk operation.
 *
 * The shape depends on the server's meadow-endpoints major -- 2.x sets a preformatted string,
 * 4.x an error object -- so anything truthy counts as a failure and is reduced to a string.
 *
 * @param {any} pRecord - a record row from a bulk response
 * @return {string|false} the failure message, or false when the row carries no error
 */
const getRecordErrorMessage = function(pRecord)
{
	if (!pRecord || (typeof(pRecord) !== 'object') || !pRecord.Error)
	{
		return false;
	}

	const tmpError = pRecord.Error;

	if (typeof(tmpError) === 'string')
	{
		return tmpError;
	}
	if (typeof(tmpError.message) === 'string')
	{
		return tmpError.message;
	}
	if (typeof(tmpError.Error) === 'string')
	{
		return tmpError.Error;
	}

	try
	{
		return JSON.stringify(tmpError);
	}
	catch (pStringifyError)
	{
		return String(tmpError);
	}
};

class HeadlightIntegrationAdapter extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadlightIntegrationAdapterOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client'), HeadlightGUIDMap: libGUIDMap, ProgressTrackerSet: any }} */
		this.fable;
		this.serviceType = 'IntegrationAdapter';

		// Check if there is a GUIDMap .. if not make one
		if (!this.fable.hasOwnProperty('HeadlightGUIDMap'))
		{
			this.fable.addAndInstantiateServiceType('HeadlightGUIDMap', libGUIDMap);
		}

		/** @type {import('headlight-rest-client')} */
		this.client = this.options.Client || this.fable.HeadlightRestClient;
		// Check if there is a REST client ... if not make one
		if (!this.client)
		{
			this.fable.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = '/1.0/';
			}
			this.client = this.fable.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		}
		this.client.prepareRequestOptions = (pOptions) =>
		{
			pOptions.timeout = 600000;
			return pOptions;
		};

		this.fable.instantiateServiceProviderIfNotExists('ProgressTrackerSet');

		this.Entity = this.options.Entity;
		this.EntityGUIDName = `GUID${this.Entity}`;
		this.EntityIDName = `ID${this.Entity}`;

		// Automagic GUID Components
		this.AdapterSetGUIDMarshalPrefix = this.options.AdapterSetGUIDMarshalPrefix;
		if (typeof this.AdapterSetGUIDMarshalPrefix !== 'string')
		{
			if (typeof this.fable.settings.AdapterSetGUIDMarshalPrefix === 'string')
			{
				this.AdapterSetGUIDMarshalPrefix = this.fable.settings.AdapterSetGUIDMarshalPrefix;
			}
			else
			{
				this.AdapterSetGUIDMarshalPrefix = 'INTG-DEF';
			}
		}
		this.EntityGUIDMarshalPrefix = this.options.EntityGUIDMarshalPrefix;
		if (typeof this.EntityGUIDMarshalPrefix !== 'string')
		{
			this.EntityGUIDMarshalPrefix = `E-${this.Entity}`;
		}

		// Resolve GUID max length: explicit option > fallback.  The
		// authoritative per-entity size is applied by loadSchema() once
		// the live server schema has been fetched.
		if (this.options.GUIDMaxLength > 0)
		{
			this.GUIDMaxLength = this.options.GUIDMaxLength;
		}
		else
		{
			this.GUIDMaxLength = _GUID_MAX_LENGTH_FALLBACK;
		}
		this.AllowGUIDTruncation = this.options.AllowGUIDTruncation;

		// Integration Adapter Controls
		this._PerformUpserts = this.options.PerformUpserts;
		this._PerformDeletes = this.options.PerformDeletes;

		this._RecordPushRetryThreshold = this.options.RecordPushRetryThreshold;

		// Meta progress tracker — an optional external progress tracker hash that is
		// incremented alongside the per-entity tracker so callers can monitor overall
		// progress across multiple adapters/entities.
		this.MetaProgressTrackerHash = false;
		// How often (in records) to log the meta progress tracker status (0 = never auto-log).
		this.MetaProgressTrackerLogInterval = 0;

		// The source records (coming from the external system)
		this._SourceRecords = {};

		// The marshaled records (going to HeadLight or Queued for Delete)
		this._MarshaledRecords = {};
		this._DeletedRecords = {};

		// Records the server refused, one entry per record, for the run summary.
		/** @type {Array<{ Entity: string, RecordKey: string, Error: string }>} */
		this.RecordPushFailures = [];

		/** @type {import('./Headlight-Integration-GUIDBatchResolver.js')} */
		this._GUIDBatchResolver = null;

		// Mapped GUIDs the server has already been asked about -- and did not
		// have -- during the current marshal pass.  Without this, a reference
		// that resolves to nothing is re-requested once per record that carries
		// it.  Scoped to the pass because a GUID absent now can be created by a
		// later stage of the same run.
		/** @type {Set<string>} */
		this._UnresolvedMappedGUIDs = new Set();

		// Whether this server serves the body-driven read route, per the
		// capabilities its schema advertises.
		/** @type {boolean|undefined} */
		this.QueryEndpointSupported = undefined;

		// Optional caller-supplied schema: stash it and apply the authoritative
		// GUID size now so consumers can generate GUIDs without first awaiting
		// a network round-trip.
		if (this.options.Schema)
		{
			this._applySchemaDocument(this.options.Schema);
		}
	}

	/**
	 * Apply an entity schema document (in the shape returned by the
	 * /{Entity}/Schema API) to this adapter: stash it on meadowSchema and,
	 * unless the caller explicitly set GUIDMaxLength in options, adopt the
	 * GUID column size from the schema's `properties` map.
	 *
	 * @param {Object} pSchemaDocument - The entity schema document
	 * @private
	 */
	_applySchemaDocument(pSchemaDocument)
	{
		if (!pSchemaDocument || typeof(pSchemaDocument) !== 'object')
		{
			return;
		}
		this.meadowSchema = pSchemaDocument;

		// The advertised capability describes the server, not the entity, so it
		// applies to every entity this adapter resolves references against.
		const tmpCapabilities = pSchemaDocument.RetoldMetadata && pSchemaDocument.RetoldMetadata.Capabilities;
		if (tmpCapabilities && typeof(tmpCapabilities.QueryEndpoint) === 'boolean')
		{
			this.QueryEndpointSupported = tmpCapabilities.QueryEndpoint;
			if (this._GUIDBatchResolver)
			{
				this._GUIDBatchResolver.QueryEndpointSupported = tmpCapabilities.QueryEndpoint;
			}
		}

		if (this.options.GUIDMaxLength <= 0
			&& pSchemaDocument.properties
			&& pSchemaDocument.properties[this.EntityGUIDName])
		{
			let tmpSchemaSize = Number(pSchemaDocument.properties[this.EntityGUIDName].size);
			if (tmpSchemaSize > 0)
			{
				if (tmpSchemaSize !== this.GUIDMaxLength)
				{
					this.log.info(`Schema GUID column size for [${this.Entity}] is ${tmpSchemaSize} (was ${this.GUIDMaxLength}); using schema value.`);
				}
				this.GUIDMaxLength = tmpSchemaSize;
			}
		}
	}

	/**
	 * Load the live entity schema from the Headlight API and apply the
	 * authoritative GUID column size when no explicit GUIDMaxLength override
	 * was provided.  integrateRecords() calls this automatically; consumers
	 * that need to generate GUIDs before integration runs should call it
	 * explicitly.  Idempotent: if a schema has already been applied (via the
	 * Schema option or a prior call), the network fetch is skipped.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback fired when the schema has been loaded (or failed to load)
	 */
	loadSchema(fCallback)
	{
		if (this.meadowSchema && typeof(this.meadowSchema) === 'object')
		{
			return fCallback();
		}
		this.fable.log.info(`Getting schema for ${this.Entity}....`);
		let tmpRequestOptions = (
			{
				url: `${this.client.serverURL}${this.Entity}/Schema`
			});
		tmpRequestOptions = this.client._prepareRequestOptions(tmpRequestOptions);
		return this.client.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (!pError)
				{
					this._applySchemaDocument(pBody);
				}
				return fCallback(pError);
			});
	}

	/**
	 * TODO: This was lifted from the old HDOT integration code but a more elegant streaming solution would be way cooler.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are integrated
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - (optional) Function to call to marshal extra data per-record
	 */
	integrateRecords(fCallback, fMarshalExtraData)
	{
		let tmpMarshalExtraData = fMarshalExtraData;
		let tmpAnticipate = this.fable.newAnticipate();
		if (this.options.ValidateSession)
		{
			tmpAnticipate.anticipate(
				(fStageComplete)=>
				{
					this.client.getJSON('CheckSession', (pError, pBody) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error checking session with Headlight server: ${pError.message || pError}`, { Stack: pError.stack });
								return fStageComplete(pError);
							}
							if (!pBody || !pBody.LoggedIn)
							{
								this.fable.log.error(`Not logged in; cannot proceed with integration of ${this.Entity} records.`, { Response: pBody });
								return fStageComplete(new Error('Not logged in'));
							}
							return fStageComplete();
						});
				});
		}
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				this.loadSchema(fStageComplete);
			});
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				this.fable.log.info(`Marshaling ${this.Entity} records....`);
				this.marshalSourceRecords(fStageComplete, tmpMarshalExtraData);
			});
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				this.fable.log.info(`Posting ${this.Entity} records....`);
				this.pushRecordsToServer(fStageComplete);
			});
		// Retirements are routed to _DeletedRecords by marshalSingleSourceRecord, and
		// pushRecordsToServer only walks _MarshaledRecords -- so without this stage the delete queue
		// was built and then dropped when the adapter went out of scope. A record flagged Deleted
		// therefore neither upserted nor deleted, and the run reported success either way. Guarded
		// inside deleteRecordsFromServer by PerformDeletes, and a no-op when nothing is queued.
		tmpAnticipate.anticipate(
			(fStageComplete)=>
			{
				const tmpDeleteCount = Object.keys(this._DeletedRecords).length;
				if (tmpDeleteCount < 1)
				{
					return fStageComplete();
				}
				this.fable.log.info(`Deleting ${tmpDeleteCount} ${this.Entity} record(s)....`);
				this.deleteRecordsFromServer(fStageComplete);
			});
		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Add a record to the adapter's Source Records buffer to be pushed
	 *
	 * @param {Object} pRecord - The record to add
	 */
	addSourceRecord(pRecord)
	{
		if (!pRecord || typeof(pRecord) !== 'object' || Array.isArray(pRecord))
		{
			this.log.error(`Passed-in record was null, or not of type "object" (${typeof(pRecord)}), therefore it was not added to the Source Record buffer.`);
			return false;
		}
		let tmpRecordGUID = pRecord[this.EntityGUIDName];
		if (!tmpRecordGUID && (!pRecord.hasOwnProperty(this.EntityIDName) || !(pRecord[this.EntityIDName])))
		{
			tmpRecordGUID = pRecord[`_${this.EntityGUIDName}`];
			if (!tmpRecordGUID)
			{
				this.log.error(`Passed-in record did not contain a source system GUID data element [${this.Entity}].[${this.EntityGUIDName}], therefore it was not added to the Source Record Buffer:`, pRecord);
				return false;
			}
		}

		if (tmpRecordGUID)
		{
			this._SourceRecords[tmpRecordGUID] = pRecord;
		}
		else
		{
			this._SourceRecords[pRecord[this.EntityIDName]] = pRecord;
		}
	}

	get GUIDPrefix()
	{
		let tmpPrefix = '';
		if (this.AdapterSetGUIDMarshalPrefix)
		{
			tmpPrefix += `${this.AdapterSetGUIDMarshalPrefix}-`;
		}
		if (this.EntityGUIDMarshalPrefix)
		{
			tmpPrefix += `${this.EntityGUIDMarshalPrefix}-`;
		}
		return tmpPrefix;
	}

	/**
	 * Generate a Headlight GUID from an external system GUID
	 *
	 * If the generated GUID would exceed GUIDMaxLength (resolved per-entity
	 * from the Headlight schema) and AllowGUIDTruncation is false (the
	 * default), an error is thrown so the integration stops immediately with
	 * a clear message.
	 *
	 * When AllowGUIDTruncation is true (one-time imports only), the prefix is
	 * progressively truncated to fit while preserving the full external GUID.
	 *
	 * @param {string} pExternalGUID - The external system GUID to generate a Headlight GUID from
	 * @return {string} The generated Headlight GUID
	 */
	generateHeadlightGUIDFromExternalGUID(pExternalGUID)
	{
		let tmpFullGUID = `${this.GUIDPrefix}${pExternalGUID}`;

		if (this.GUIDMaxLength > 0 && tmpFullGUID.length > this.GUIDMaxLength)
		{
			if (!this.AllowGUIDTruncation)
			{
				let tmpMessage = `Generated GUID for [${this.Entity}] exceeds the maximum allowed length of ${this.GUIDMaxLength} characters.\n`
					+ `  Comprehension GUID: [${pExternalGUID}] (${pExternalGUID.length} chars)\n`
					+ `  Server GUID:        [${tmpFullGUID}] (${tmpFullGUID.length} chars)\n`
					+ `  Prefix:             [${this.GUIDPrefix}] (${this.GUIDPrefix.length} chars)\n`
					+ `  To allow automatic prefix truncation for one-time imports, set AllowGUIDTruncation to true (CLI: --allowguidtruncation).`;
				this.log.error(tmpMessage);
				throw new Error(tmpMessage);
			}

			// AllowGUIDTruncation is on -- the external GUID is sacrosanct, so truncate the prefix instead.
			let tmpAvailablePrefixLength = this.GUIDMaxLength - pExternalGUID.length;

			if (tmpAvailablePrefixLength <= 0)
			{
				// External GUID alone meets or exceeds the limit; drop the prefix entirely.
				this.log.warn(`External GUID [${pExternalGUID}] for [${this.Entity}] is ${pExternalGUID.length} characters which meets or exceeds the GUID max length of ${this.GUIDMaxLength}.  Using external GUID with no prefix.`);
				tmpFullGUID = pExternalGUID.substring(0, this.GUIDMaxLength);
			}
			else
			{
				let tmpTruncatedPrefix = this.GUIDPrefix.substring(0, tmpAvailablePrefixLength);
				tmpFullGUID = `${tmpTruncatedPrefix}${pExternalGUID}`;
				this.log.warn(`Generated GUID for [${this.Entity}] would be ${this.GUIDPrefix.length + pExternalGUID.length} characters (limit ${this.GUIDMaxLength}); prefix truncated from [${this.GUIDPrefix}] to [${tmpTruncatedPrefix}].`);
			}
		}

		return tmpFullGUID;
	}

	/**
	 * The batch resolver used to pre-populate the GUID map before marshaling.
	 *
	 * @return {import('./Headlight-Integration-GUIDBatchResolver.js')}
	 */
	get guidBatchResolver()
	{
		if (!this._GUIDBatchResolver)
		{
			this.fable.addServiceType('IntegrationGUIDBatchResolver', libGUIDBatchResolver);
			const tmpOptions = Object.assign({}, this.options.GUIDBatchResolutionOptions, { QueryEndpointSupported: this.QueryEndpointSupported });
			this._GUIDBatchResolver = this.fable.instantiateServiceProviderWithoutRegistration('IntegrationGUIDBatchResolver', tmpOptions);
		}
		this._GUIDBatchResolver.client = this.client;
		return this._GUIDBatchResolver;
	}

	/**
	 * @param {string} pMappedEntityName - The referenced entity.
	 * @param {string} pMappedGUIDValue - The referenced GUID.
	 * @return {string} The key this pass tracks an unresolvable reference under.
	 * @private
	 */
	_unresolvedMappedGUIDKey(pMappedEntityName, pMappedGUIDValue)
	{
		return `${pMappedEntityName}${UNRESOLVED_GUID_KEY_SEPARATOR}${pMappedGUIDValue}`;
	}

	/**
	 * Resolve every mapped GUID reference in the source buffer up front, in
	 * batched IN-list reads, so the marshal path finds them in the GUID map.
	 *
	 * References already answered by the in-memory maps -- entities pushed
	 * earlier in this run, GUIDs resolved by an earlier batch -- are never
	 * re-requested.  Failures are not fatal: anything a batch does not resolve
	 * still goes through the single-GUID lookup during marshaling.
	 *
	 * @return {Promise<Object|null>} The resolver's summary, or null when nothing was prefetched.
	 */
	async prefetchMappedEntityIDs()
	{
		if (!this.options.BatchGUIDResolution)
		{
			return null;
		}

		try
		{
			const tmpReferences = libGUIDBatchResolver.collectMappedGUIDReferences(this._SourceRecords, this.EntityGUIDName);
			if (tmpReferences.size < 1)
			{
				return null;
			}

			const tmpSummary = await this.guidBatchResolver.resolveReferences(tmpReferences);

			for (const [tmpMappedEntityName, tmpMissingGUIDs] of tmpSummary.Missing)
			{
				for (const tmpMissingGUID of tmpMissingGUIDs)
				{
					this._UnresolvedMappedGUIDs.add(this._unresolvedMappedGUIDKey(tmpMappedEntityName, tmpMissingGUID));
				}
			}

			if (tmpSummary.Requested > 0)
			{
				const tmpUnverifiedNote = (tmpSummary.Unverified > 0) ? `, ${tmpSummary.Unverified} left to single lookups` : '';
				this.fable.log.info(`Resolved ${tmpSummary.Resolved} of ${tmpSummary.Requested} referenced GUID(s) for [${this.Entity}] in ${tmpSummary.Requests} batch read(s) (${tmpSummary.Cached} already cached${tmpUnverifiedNote}).`);
			}
			return tmpSummary;
		}
		catch (pError)
		{
			this.fable.log.warn(`Batch GUID resolution for [${this.Entity}] did not complete; falling back to per-reference lookups: ${pError.message || pError}`, { Stack: pError.stack });
			return null;
		}
	}

	/**
	 * Resolve a referenced entity's GUID to its Headlight ID, consistently for
	 * every mapped-GUID form (`GUID<Entity>`, `_GUID<Entity>`, and
	 * `_Dest_IDEntity_..._Via_GUID<Entity>`).
	 *
	 * Resolution order:
	 *   1. This run's in-memory external map (external GUID -> Headlight GUID ->
	 *      ID), populated when the referenced entity was integrated earlier in
	 *      the same run.
	 *   2. A direct GUID lookup that checks the in-memory map -- which the batch
	 *      prefetch has usually already filled -- and then falls back to a live
	 *      server fetch.  This second step is what lets a reference resolve when
	 *      its target was loaded by a *prior* run (and so is absent from this
	 *      run's cache) -- the case the `GUID<Entity>` branch used to miss,
	 *      dropping the foreign key.
	 *
	 * @param {string} pMappedEntityName - The referenced entity (e.g. 'PayItem')
	 * @param {string} pMappedGUIDValue - The referenced GUID (external or Headlight)
	 * @return {Promise<number>} The resolved Headlight ID, or 0 if none could be found
	 */
	async resolveMappedEntityID(pMappedEntityName, pMappedGUIDValue)
	{
		if (!pMappedGUIDValue)
		{
			return 0;
		}

		// 1. External-GUID cache (external GUID -> Headlight GUID -> ID).
		let tmpHeadlightIDValue = this.fable.HeadlightGUIDMap.getHeadlightIDFromExternalGUID(pMappedEntityName, pMappedGUIDValue);
		if (tmpHeadlightIDValue)
		{
			return tmpHeadlightIDValue;
		}

		const tmpUnresolvedKey = this._unresolvedMappedGUIDKey(pMappedEntityName, pMappedGUIDValue);
		if (this._UnresolvedMappedGUIDs.has(tmpUnresolvedKey))
		{
			return 0;
		}

		// 2. Direct GUID lookup: in-memory map, then live server fetch.  Covers
		//    GUIDs that are already Headlight GUIDs, were stored without a prefix,
		//    or belong to an entity integrated by a prior run (not in this run's
		//    cache).
		return await new Promise((resolve) =>
		{
			this.fable.HeadlightGUIDMap.getIDFromGUIDAsync(pMappedEntityName, pMappedGUIDValue,
			(pError, pResponse) =>
			{
				if (pResponse)
				{
					return resolve(pResponse);
				}
				if (pError)
				{
					this.fable.log.warn(`Error getting Headlight id for ${pMappedEntityName} GUID [${pMappedGUIDValue}]: ${pError.message || pError}`, { Stack: pError.stack });
				}
				this._UnresolvedMappedGUIDs.add(tmpUnresolvedKey);
				return resolve(0);
			}, this.client);
		});
	}

	/**
	 * Marshal a record from the source system to a Headlight record
	 *
	 * @param {Object} pSourceRecord - The source record to marshal
	 * @return {Promise<Object>} The marshaled record
	 */
	async marshalRecord(pSourceRecord)
	{
		let tmpRecord = {};

		// Create the new GUID
		let tmpRecordHeadLightGUID;
		let tmpRecordExternalGUID = pSourceRecord[this.EntityGUIDName];
		if (tmpRecordExternalGUID)
		{
			tmpRecordHeadLightGUID = this.generateHeadlightGUIDFromExternalGUID(tmpRecordExternalGUID);
		}
		else
		{
			tmpRecordExternalGUID = pSourceRecord[`_${this.EntityGUIDName}`];
			tmpRecordHeadLightGUID = tmpRecordExternalGUID;
		}

		if (!tmpRecordHeadLightGUID && !pSourceRecord.hasOwnProperty(this.EntityIDName))
		{
			throw new Error(`Could not marshal record for [${this.Entity}] because no external system GUID was found in source record.`);
		}

		if (tmpRecordHeadLightGUID)
		{
			// Mapping table for going between HeadLight system GUIDs and External system GUIDs.
			tmpRecord[this.EntityGUIDName] = tmpRecordHeadLightGUID;
			this.fable.HeadlightGUIDMap.mapExternalGUIDtoHeadlightGUID(this.Entity, tmpRecordExternalGUID, tmpRecordHeadLightGUID);
		}

		// Now that we've dealt with basic identifiers, time to see if there are other Mapped GUIDs to look up.
		// TODO: This can be the path through to a recursive integration -- if
		//       the GUIDs are not found, then the appropriate adapter can launch
		//       (and integrate just the proper records!)
		for (const tmpRecordKey of Object.keys(pSourceRecord))
		{
			const tmpMappedReference = libGUIDBatchResolver.classifyMappedGUIDField(tmpRecordKey, this.EntityGUIDName);

			if (tmpMappedReference)
			{
				const tmpMappedEntityName = tmpMappedReference.MappedEntityName;
				const tmpMappedEntityGUIDValue = pSourceRecord[tmpRecordKey];

				let tmpHeadlightIDValue = await this.resolveMappedEntityID(tmpMappedEntityName, tmpMappedEntityGUIDValue);
				if (tmpHeadlightIDValue)
				{
					const tmpIDDestinationField = tmpMappedReference.DestinationField || pSourceRecord[`_Dest_${tmpRecordKey}`] || `ID${tmpMappedEntityName}`;
					tmpRecord[tmpIDDestinationField] = tmpHeadlightIDValue;
					if (tmpMappedReference.SetMappedEntityIDField)
					{
						tmpRecord[`ID${tmpMappedEntityName}`] = tmpHeadlightIDValue;
					}
				}
				else
				{
					const tmpGUIDLabel = (tmpMappedReference.Kind === 'External') ? 'External GUID' : 'GUID';
					this.fable.log.warn(`Could not find Headlight ID for [${tmpMappedEntityName}] with ${tmpGUIDLabel} [${tmpMappedEntityGUIDValue}] while integrating [${this.Entity}] record [${tmpRecord[this.EntityGUIDName]}].`)
				}
			}
			else if (tmpRecordKey == this.EntityGUIDName || tmpRecordKey == `_${this.EntityGUIDName}`)
			{
				// Don't do anything for the GUID whose already set...
			}
			else if (tmpRecordKey.startsWith('_Dest_'))
			{
				// skip this, it's a destination field override for a GUID
			}
			else if ((this.meadowSchema && this.meadowSchema.hasOwnProperty('properties')) && (this.meadowSchema.properties.hasOwnProperty(tmpRecordKey)))
			{
				// Check the length if it's a string -- truncate if it isn't there for now.
				// TODO: MAKE THIS CONFIGURABLE AND OVERRIDABLE
				if (this.options.SimpleMarshal)
				{
					//FIXME: this is a hack I added to allow me to marshal object types without things breaking; revisit - bigal
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
				}
				else if ((this.meadowSchema.properties[tmpRecordKey].type == 'string')
					&& pSourceRecord.hasOwnProperty(tmpRecordKey)
					&& (pSourceRecord[tmpRecordKey] != null)
					&& (pSourceRecord[tmpRecordKey].toString().length > this.meadowSchema.properties[tmpRecordKey].size))
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey].substring(0, this.meadowSchema.properties[tmpRecordKey].size);
				}
				else if (this.meadowSchema.properties[tmpRecordKey].type == 'string')
				{
					if ((pSourceRecord[tmpRecordKey] !== null) && (pSourceRecord[tmpRecordKey] !== undefined))
					{
						tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey].toString();
					}
				}
				else
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
				}
			}
			else if (this.options.ForceMarshal)
			{
				tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
			}
		}

		// Clean any elements in the record that are reserved by HeadLight
		if (tmpRecord.hasOwnProperty('CreateDate')) delete tmpRecord.CreateDate;
		if (tmpRecord.hasOwnProperty('UpdateDate')) delete tmpRecord.UpdateDate;
		if (tmpRecord.hasOwnProperty('Deleted')) delete tmpRecord.Deleted;

		return tmpRecord;
	}

	/**
	 * Marshal a single source record
	 *
	 * @param {string} pSourceRecordGUID - The GUID of the source record to marshal
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - (optional) Function to call to marshal extra data per-record
	 *
	 * @return {Promise<boolean>} - Promise that resolves to true (why?)
	 */
	async marshalSingleSourceRecord(pSourceRecordGUID, fMarshalExtraData)
	{
		// 0. Get the original GUID
		let tmpSourceRecordGUID = pSourceRecordGUID;

		// 0.3 Get the Source Record
		let tmpSourceRecord = this._SourceRecords[tmpSourceRecordGUID];

		if (!tmpSourceRecord)
		{
			this.log.fatal(`Could not marshal source record for [${this.Entity}] because source record with GUID [${tmpSourceRecordGUID}] was not found in Source Records buffer.`);
			return;
		}

		// 0.5 Check if this is a delete
		let tmpDeleteOperation = isDeletedFlagSet(tmpSourceRecord.Deleted);

		// 1. Marshal the Source record into a HeadLight record
		let tmpMarshaledRecord = await this.marshalRecord(tmpSourceRecord);

		// 2. Get the GUID of the record after Marshaling...
		let tmpMarshaledRecordGUID = tmpMarshaledRecord[this.EntityIDName];
		if (tmpMarshaledRecord.hasOwnProperty(this.EntityGUIDName))
		{
			tmpMarshaledRecordGUID = tmpMarshaledRecord[this.EntityGUIDName];
		}
		else if (tmpMarshaledRecord.hasOwnProperty(`_${this.EntityGUIDName}`))
		{
			tmpMarshaledRecordGUID = tmpMarshaledRecord[`_${this.EntityGUIDName}`];
		}

		// 3. Get a new Object or the existing object as start of the append operation
		let tmpOriginalRecord = (this._MarshaledRecords.hasOwnProperty(tmpMarshaledRecordGUID)) ? this._MarshaledRecords[tmpMarshaledRecordGUID] : {};

		// 4. Now merge the properties of the two records, using the new one as the more important values
		//    Yes this will guaranteed overwrite the GUID like a zillion times, but, whatevers
		if (tmpDeleteOperation)
		{
			this._DeletedRecords[tmpMarshaledRecordGUID] = tmpMarshaledRecord;
		}
		else
		{
			this._MarshaledRecords[tmpMarshaledRecordGUID] = Object.assign(tmpOriginalRecord, tmpMarshaledRecord);
		}

		// 4.5 Inject a marshal stack
		if (typeof(fMarshalExtraData) == 'function')
		{
			fMarshalExtraData(tmpSourceRecord, tmpMarshaledRecord);
		}

		// 5. Now delete the record from the SourceRecords set so next marshal operation doesn't do it again needlessly
		delete this._SourceRecords[tmpSourceRecordGUID];

		return true;
	}

	/**
	 * Take all Source Records in the buffer and marshal them
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are marshaled
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - (optional) Function to call to marshal extra data per-record
	 * @return {Promise<void>} - Promise that resolves when all records are marshaled
	 */
	async marshalSourceRecords(fCallback, fMarshalExtraData)
	{
		try
		{
			this._UnresolvedMappedGUIDs.clear();
			await this.prefetchMappedEntityIDs();

			let tmpRecordKeys = Object.keys(this._SourceRecords);

			// Later switch to something paralleler?
			for (let i = 0; i < tmpRecordKeys.length; i++)
			{
				await this.marshalSingleSourceRecord(tmpRecordKeys[i], fMarshalExtraData);
			}

			return fCallback();
		}
		catch (error)
		{
			return fCallback(error);
		}
	}

	/**
	 * Log a record the server refused and tally it for the run summary.
	 *
	 * These are decisions the server has already made about one record -- a constraint violation,
	 * a value too long for its column -- so they are terminal for that record and never retried.
	 * The rest of the batch is unaffected and the load continues.
	 *
	 * @param {string} pRecordKey - the GUID (or ID) the marshaled record is keyed on
	 * @param {string} pMessage - the failure as reported by the server
	 */
	trackRecordPushFailure(pRecordKey, pMessage)
	{
		this.RecordPushFailures.push({ Entity: this.Entity, RecordKey: pRecordKey, Error: pMessage });
		this.log.error(`Record push failure for [${this.Entity}].[${pRecordKey}]: ${pMessage}`);
	}

	/**
	 * Match a bulk upsert response back to the batch that was sent: map the records that landed,
	 * and log the ones that did not.
	 *
	 * A bulk upsert answers 200 whether or not every row succeeded, and the two shapes of
	 * per-record failure both arrive inside that 200. meadow-endpoints 2.x returns the failed row
	 * in the array with an `Error` property set; 4.x omits it from the array entirely and reports
	 * the counts in `X-Meadow-Upsert-*` response headers, which the REST client does not surface.
	 * Trusting every returned row therefore writes a GUID -> undefined entry into the GUID map,
	 * which every later reference to that record then resolves against.
	 *
	 * @param {string[]} pRecordGUIDs - the record keys sent in this batch
	 * @param {Array<Object>} pResponseRecords - the array the server answered with
	 * @return {number} how many records in the batch did not land
	 */
	reconcileBulkUpsertResponse(pRecordGUIDs, pResponseRecords)
	{
		let tmpResponseByKey = {};

		for (let i = 0; i < pResponseRecords.length; i++)
		{
			let tmpResponseRecord = pResponseRecords[i];

			if (!tmpResponseRecord || (typeof(tmpResponseRecord) !== 'object'))
			{
				continue;
			}
			if (tmpResponseRecord[this.EntityGUIDName])
			{
				tmpResponseByKey[tmpResponseRecord[this.EntityGUIDName]] = tmpResponseRecord;
			}
			if (tmpResponseRecord[this.EntityIDName])
			{
				tmpResponseByKey[tmpResponseRecord[this.EntityIDName]] = tmpResponseRecord;
			}
		}

		let tmpFailureCount = 0;

		for (let i = 0; i < pRecordGUIDs.length; i++)
		{
			let tmpRecordGUID = pRecordGUIDs[i];
			let tmpResponseRecord = tmpResponseByKey[tmpRecordGUID];

			if (!tmpResponseRecord)
			{
				tmpFailureCount++;
				this.trackRecordPushFailure(tmpRecordGUID, `The server did not return a row for this record in the bulk upsert response.`);
				continue;
			}

			let tmpErrorMessage = getRecordErrorMessage(tmpResponseRecord);
			if (tmpErrorMessage)
			{
				tmpFailureCount++;
				this.trackRecordPushFailure(tmpRecordGUID, tmpErrorMessage);
				continue;
			}

			if (!(tmpResponseRecord[this.EntityIDName] > 0))
			{
				tmpFailureCount++;
				this.trackRecordPushFailure(tmpRecordGUID, `The server returned this record without a valid ${this.EntityIDName}; it was not persisted.`);
				continue;
			}

			let tmpMappedGUID = (tmpResponseRecord[this.EntityGUIDName]) ? tmpResponseRecord[this.EntityGUIDName] : tmpRecordGUID;
			this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, tmpMappedGUID, tmpResponseRecord[this.EntityIDName]);
		}

		if (tmpFailureCount > 0)
		{
			this.log.error(`[${this.Entity}] Bulk upsert batch of ${pRecordGUIDs.length} records completed with ${tmpFailureCount} record-level failure(s); these are not retried.`);
		}

		return tmpFailureCount;
	}

	/**
	 * Take a single record and push it to the server
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the record is pushed
	 * @param {string} pRecordGUID - The GUID of the record to push
	 * @param {number} [pRetryCount] - (optional) The number of times this record has been retried
	 */
	upsertSingleRecord(fCallback, pRecordGUID, pRetryCount)
	{
		// TODO: The retry count recursion method here is very brute force.  Fix it!
		let tmpRetryCount = (typeof(pRetryCount) === 'undefined') ? 0 : pRetryCount;

		// Non-configurable cap for a bit here... until better logic is written.
		if ((tmpRetryCount > this._RecordPushRetryThreshold) || (tmpRetryCount > 50))
		{
			let tmpIdentifierType = 'GUID';
			this.trackRecordPushFailure(pRecordGUID, `Upsert retry threshold of ${this._RecordPushRetryThreshold} reached.`);

			// upsert failed, so we will try to read the record instead so we can at least have a valid ID / GUID mapping
			const tmpFallbackCallback = (pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error reading record ${tmpIdentifierType} [${pRecordGUID}] after upsert failures: ${pError.message || pError}`, { Stack: pError.stack });
				}
				else if (pBody &&
						// Check that the server returned a valid record (look for the Identity column)
						(pBody.hasOwnProperty(this.EntityIDName)) &&
						// Check that the server returned a record that has a numeric ID which is nonzero
						(pBody[this.EntityIDName] > 0) &&
						// Check that the server also returned a GUID
						(pBody.hasOwnProperty(this.EntityGUIDName)) &&
						// Check that the GUID or ID matches what we expect
						((pBody[this.EntityGUIDName] === pRecordGUID) || (pBody[this.EntityIDName] == pRecordGUID))
					)
				{
					this.log.info(`Fallback: Loaded and mapping record ${tmpIdentifierType} [${pRecordGUID}] after upsert failure.`,
						{
							Record: pBody,
							Entity: this.Entity,
							IdentifierType: tmpIdentifierType,
							GUID: pBody[this.EntityGUIDName],
							ID: pBody[this.EntityIDName]
						});
					this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, pBody[this.EntityGUIDName], pBody[this.EntityIDName]);
				}
				else
				{
					this.log.error(`Could not verify record ${tmpIdentifierType} [${pRecordGUID}] after upsert failures; record not found or invalid response.`, { Record: pBody });
				}
				return fCallback();
			};
			if (this._MarshaledRecords[pRecordGUID][this.EntityIDName] == pRecordGUID)
			{
				tmpIdentifierType = 'ID';
				// It's an ID, not a GUID
				return this.client.getEntity(this.Entity, pRecordGUID, tmpFallbackCallback);
			}
			return this.client.getEntityByGUID(this.Entity, pRecordGUID, tmpFallbackCallback);
		}

		this.client.upsertEntity(this.Entity, this._MarshaledRecords[pRecordGUID],
			(pError, pBody)=>
			{
				if (pError)
				{
					this.log.error(`Error sending PUT [${this.Entity}].[${pRecordGUID}] to server:  ${pError}`);
					let tmpErrorMessage = (typeof(pError.message) === 'string') ? pError.message : String(pError);
					if (tmpErrorMessage.indexOf('Error in DAL create: Error: Duplicate entry') > 0)
					{
						this.log.warn(`Duplicate record attempted when sending PUT to server record GUID [${pRecordGUID}]: ${tmpErrorMessage}`, pBody);
						return fCallback();
					}
					if (tmpErrorMessage.indexOf('exceeds the maximum allowed length') > 0)
					{
						this.trackRecordPushFailure(pRecordGUID, `GUID length rejected by server (${pRecordGUID.length} chars): ${tmpErrorMessage}`);
						return fCallback();
					}
					if (tmpErrorMessage.indexOf('Rejected Create') > -1 && tmpErrorMessage.indexOf('GUID') > -1)
					{
						this.trackRecordPushFailure(pRecordGUID, `Server rejected create due to a GUID issue: ${tmpErrorMessage}`);
						return fCallback();
					}

					// simple delay for retries to not spam the server
					setTimeout(() =>
					{
						this.upsertSingleRecord(fCallback, pRecordGUID, tmpRetryCount + 1);
					}, 500);
					return;
				}

				if (
						pBody &&
						// Check that the server returned a valid record (look for the Identity column)
						(pBody.hasOwnProperty(this.EntityIDName)) &&
						// Check that the server returned a record that has a numeric ID which is nonzero
						(pBody[this.EntityIDName] > 0) &&
						// Check that the server also returned a GUID
						(pBody.hasOwnProperty(this.EntityGUIDName)) &&
						// Check that the GUID or ID matches what we expect
						((pBody[this.EntityGUIDName] === pRecordGUID) || (pBody[this.EntityIDName] == pRecordGUID))
					)
				{
					// Add the record ID to the lookup table
					this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, pBody[this.EntityGUIDName], pBody[this.EntityIDName]);
					return fCallback();
				}

				// Try again...
				this.log.error(`Problem sending PUT [${this.Entity}].[${pRecordGUID}] to server.  Incrementing retry count and trying again.`, { Record: pBody, RetryCount: tmpRetryCount });
				this.upsertSingleRecord(fCallback, pRecordGUID, tmpRetryCount + 1);
			});
	}

	/**
	 * Take a set of records and push them to the server
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are pushed
	 * @param {string[]} pRecordGUIDs - The GUIDs of the records to push
	 * @param {number} [pRetryCount] - (optional) The number of times this record has been retried
	 */
	upsertBulkRecords(fCallback, pRecordGUIDs, pRetryCount)
	{
		// TODO: The retry count recursion method here is very brute force.  Fix it!
		let tmpRetryCount = (typeof(pRetryCount) === 'undefined') ? 0 : pRetryCount;

		// Non-configurable cap for a bit here... until better logic is written.
		if ((tmpRetryCount > this._RecordPushRetryThreshold) || (tmpRetryCount > 50))
		{
			for (let i = 0; i < pRecordGUIDs.length; i++)
			{
				this.trackRecordPushFailure(pRecordGUIDs[i], `Bulk upsert retry threshold of ${this._RecordPushRetryThreshold} reached.`);
			}
			//FIXME: handle reading records in bulk to backfill ID / GUID map?
			return fCallback();
		}

		let tmpRecordsToUpsert = [];

		for (let i = 0; i < pRecordGUIDs.length; i++)
		{
			tmpRecordsToUpsert.push(this._MarshaledRecords[pRecordGUIDs[i]]);
		}

		this.client.upsertEntities(this.Entity, tmpRecordsToUpsert,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error sending PUT [${this.Entity}] to server:  ${pError}`);
					return this.upsertBulkRecords(fCallback, pRecordGUIDs, tmpRetryCount + 1);
				}

				if (Array.isArray(pBody))
				{
					this.reconcileBulkUpsertResponse(pRecordGUIDs, pBody);
					return fCallback();
				}

				// Try again...
				this.log.error(`Problem sending PUT [${this.Entity}] to server.  Incrementing retry count and trying again.`, { Records: pBody, RetryCount: tmpRetryCount });
				this.upsertBulkRecords(fCallback, pRecordGUIDs, tmpRetryCount + 1);
			});
	}

	/**
	 * Increment the meta progress tracker (if configured) and conditionally log its status.
	 *
	 * @param {number} pAmount - The number of operations to increment by
	 */
	_incrementMetaProgressTracker(pAmount)
	{
		if (!this.MetaProgressTrackerHash)
		{
			return;
		}
		let tmpTracker = this.fable.ProgressTrackerSet;
		let tmpStatus = tmpTracker.incrementProgressTracker(this.MetaProgressTrackerHash, pAmount);

		if (this.MetaProgressTrackerLogInterval > 0 && tmpStatus)
		{
			// Use a threshold-crossing check rather than exact modulo so that
			// bulk increments (e.g. +100) reliably trigger a log when they cross
			// an interval boundary.  This makes the interval mean "log at least
			// every N records" regardless of whether records are pushed one at a
			// time or in batches.
			let tmpPreviousCount = tmpStatus.CurrentCount - pAmount;
			let tmpPreviousInterval = Math.floor(tmpPreviousCount / this.MetaProgressTrackerLogInterval);
			let tmpCurrentInterval = Math.floor(tmpStatus.CurrentCount / this.MetaProgressTrackerLogInterval);

			if (tmpCurrentInterval > tmpPreviousInterval
				|| tmpStatus.CurrentCount >= tmpStatus.TotalCount)
			{
				tmpTracker.logProgressTrackerStatus(this.MetaProgressTrackerHash);
			}
		}
	}

	/**
	 * Push any records in the adapter buffer to the server
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records are pushed
	 */
	pushRecordsToServer(fCallback)
	{
		if (!this._PerformUpserts)
		{
			return fCallback();
		}
		// Run the upserts...
		let tmpRecordKeys = Object.keys(this._MarshaledRecords);
		// Nothing to upsert is a legitimate outcome, not a problem: a retirement-only load routes
		// every record to the delete queue. Falling through would build a progress tracker with a
		// total of 0, which logs at ERROR level and flips an otherwise clean run to
		// `succeeded-with-failures` -- the one status a caller must not learn to ignore.
		if (tmpRecordKeys.length < 1)
		{
			return fCallback();
		}
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpProgressTrackerGUID = this.fable.getUUID();
		let tmpProgressTracker = this.fable.ProgressTrackerSet;
		tmpProgressTracker.createProgressTracker(tmpProgressTrackerGUID, tmpRecordKeys.length);
		tmpProgressTracker.startProgressTracker(tmpProgressTrackerGUID);

		// Log meta tracker at the start of each entity
		if (this.MetaProgressTrackerHash)
		{
			this.log.info(`[${this.Entity}] Starting push of ${tmpRecordKeys.length} records...`);
			tmpProgressTracker.logProgressTrackerStatus(this.MetaProgressTrackerHash);
		}

		// Determine if bulk upserts are possible
		if (tmpRecordKeys.length > this.options.RecordThresholdForBulkUpsert)
		{
			let tmpBulkUpsertBatchCount = Math.ceil(tmpRecordKeys.length / this.options.BulkUpsertBatchSize);
			for (let i = 0; i < tmpBulkUpsertBatchCount; i++)
			{
				let tmpBatchRecordKeys = [];
				for (let j = 0; j < this.options.BulkUpsertBatchSize; j++)
				{
					let tmpRecordKey = tmpRecordKeys[(i * this.options.BulkUpsertBatchSize) + j];
					if (tmpRecordKey)
					{
						tmpBatchRecordKeys.push(tmpRecordKey);
					}
				}

				tmpAnticipate.anticipate(
					function(fDone)
					{
						this.log.trace(`[${this.Entity}] Bulk Upserting ${tmpBatchRecordKeys.length} records to server for transaction set [${tmpProgressTrackerGUID}]...`);
						this.upsertBulkRecords(
							(pError, pBody)=>
							{
								if (pError)
								{
									this.log.error(`Error sending Bulk Upserts for [${this.Entity}] to server:  ${pError}`);
								}
								tmpProgressTracker.incrementProgressTracker(tmpProgressTrackerGUID, tmpBatchRecordKeys.length);
								tmpProgressTracker.logProgressTrackerStatus(tmpProgressTrackerGUID);
								this._incrementMetaProgressTracker(tmpBatchRecordKeys.length);
								return fDone();
							}, tmpBatchRecordKeys);
					}.bind(this));
			}
		}
		else
		{
			for (let i = 0; i < tmpRecordKeys.length; i++)
			{
				let tmpRecordKey = tmpRecordKeys[i];
				tmpAnticipate.anticipate(
					function(fDone)
					{
						this.log.trace(`[${this.Entity}] Record [${tmpRecordKey}] pushing to server...`);
						tmpProgressTracker.incrementProgressTracker(tmpProgressTrackerGUID, 1);
						tmpProgressTracker.logProgressTrackerStatus(tmpProgressTrackerGUID);
						this.upsertSingleRecord(
							()=>
							{
								this._incrementMetaProgressTracker(1);
								return fDone();
							}, tmpRecordKey);
					}.bind(this));
			}
		}

		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Delete record from the adapter's marshaled records buffer
	 *
	 * @param {(error?: Error) => void} fCallback - Callback function to call when the records have been deleted
	 */
	deleteRecordsFromServer(fCallback)
	{
		if (!this._PerformDeletes)
		{
			return fCallback();
		}
		// Run the deletes...
		// TODO: THIS IS DANGEROUS
		let tmpRecordKeys = Object.keys(this._DeletedRecords);
		if (tmpRecordKeys.length < 1)
		{
			return fCallback();
		}

		const fDeleteRecords = () =>
		{
			libAsync.eachSeries(tmpRecordKeys,
				(pRecordGUID, fDeleteComplete) =>
				{
					this.log.trace(`[${this.Entity}] Record [${this._MarshaledRecords[this.EntityGUIDName]}] deleting from server...`);
					const tmpIDRecord = this.fable.HeadlightGUIDMap.getIDFromGUID(this.Entity, pRecordGUID);
					if (tmpIDRecord)
					{
						return this.client.deleteEntity(this.Entity, tmpIDRecord, fDeleteComplete);
					}

					this.log.warn(`Could not delete [${this.Entity}] GUID [${pRecordGUID}] because lookup on HeadLight did not return an IDRecord.`);
					return fDeleteComplete();
				},
				(pError)=>
				{
					if (pError)
					{
						this.log.error(`Error sending trying to Delete from [${this.Entity}]:  ${pError}`);
					}
					return fCallback(pError);
				});
		};

		if (!this.options.BatchGUIDResolution)
		{
			libAsync.eachSeries(tmpRecordKeys,
				(pRecordGUID, fLookupComplete) =>
				{
					this.client.getEntityByGUID(this.Entity, pRecordGUID,
						(pReadError, pReadBody)=>
						{
							if (pReadError)
							{
								this.log.warn(`Could not read [${this.Entity}] GUID [${pRecordGUID}] for DELETE operation:  ${pReadError}`);
								return fLookupComplete();
							}
							if (pReadBody && pReadBody.hasOwnProperty(this.EntityIDName))
							{
								this.fable.HeadlightGUIDMap.mapGUIDToID(this.Entity, pRecordGUID, pReadBody[this.EntityIDName]);
							}
							return fLookupComplete();
						});
				},
				() => fDeleteRecords());
			return;
		}

		this.guidBatchResolver.resolveEntityGUIDs(this.Entity, tmpRecordKeys)
			.then(() => fDeleteRecords())
			.catch((pError) =>
			{
				this.log.warn(`Could not resolve [${this.Entity}] records to delete in batches: ${pError.message || pError}`);
				return fDeleteRecords();
			});
	}
}

module.exports = HeadlightIntegrationAdapter;

// Macro for backwards compatibility
module.exports.getAdapter = (
	/**
	 * @param {import('fable')} pFable
	 * @param {string} pEntity
	 * @param {string} pEntityPrefix
	 * @param {Object} [pCustomOptions]
	 */
	function(pFable, pEntity, pEntityPrefix, pCustomOptions)
	{
		if (pFable.servicesMap.IntegrationAdapter && pFable.servicesMap.IntegrationAdapter.hasOwnProperty(pEntity))
		{
			pFable.log.info(`Reusing existing Integration Adapter for entity [${pEntity}].`);
			return pFable.servicesMap.IntegrationAdapter[pEntity];
		}
		else
		{
			const tmpOptions = Object.assign({}, pCustomOptions, { Entity: pEntity, EntityGUIDMarshalPrefix: pEntityPrefix });
			return pFable.instantiateServiceProvider('IntegrationAdapter', tmpOptions, pEntity);
		}
	});

module.exports.default_configuration = defaultHeadlightIntegrationAdapterOptions;
module.exports.GUID_MAX_LENGTH_FALLBACK = _GUID_MAX_LENGTH_FALLBACK;
module.exports.GUIDBatchResolver = libGUIDBatchResolver;

// Exported for testing: the predicate that decides whether a source record is a delete.
module.exports.isDeletedFlagSet = isDeletedFlagSet;

// Exported for testing: the normalizer for the per-record `Error` property on a bulk response row.
module.exports.getRecordErrorMessage = getRecordErrorMessage;

/**
 * Report every record the server refused across all of a run's adapters.
 *
 * The bulk endpoints answer 200 for a batch in which individual rows failed, so these never reach
 * a run-level error callback. They are terminal for the record and not retried, which makes an
 * end-of-run tally the only place a partial load is visible.
 *
 * @param {import('fable')} pFable - the fable the adapters were registered on
 * @return {number} how many records were rejected across every entity
 */
module.exports.logRecordPushFailureSummary = function(pFable)
{
	let tmpAdapters = pFable.servicesMap.IntegrationAdapter;

	if (!tmpAdapters)
	{
		return 0;
	}

	let tmpFailures = [];
	let tmpFailureCountByEntity = {};
	let tmpAdapterKeys = Object.keys(tmpAdapters);

	for (let i = 0; i < tmpAdapterKeys.length; i++)
	{
		let tmpAdapter = tmpAdapters[tmpAdapterKeys[i]];

		if (!tmpAdapter || !Array.isArray(tmpAdapter.RecordPushFailures) || (tmpAdapter.RecordPushFailures.length < 1))
		{
			continue;
		}

		tmpFailureCountByEntity[tmpAdapter.Entity] = tmpAdapter.RecordPushFailures.length;
		tmpFailures = tmpFailures.concat(tmpAdapter.RecordPushFailures);
	}

	if (tmpFailures.length < 1)
	{
		pFable.log.info(`No records were rejected by the server during this load.`);
		return 0;
	}

	pFable.log.error(`${tmpFailures.length} record(s) were rejected by the server during this load and were NOT persisted:`);

	let tmpEntityKeys = Object.keys(tmpFailureCountByEntity);
	for (let i = 0; i < tmpEntityKeys.length; i++)
	{
		pFable.log.error(`  [${tmpEntityKeys[i]}]: ${tmpFailureCountByEntity[tmpEntityKeys[i]]} rejected record(s)`);
	}

	for (let i = 0; i < tmpFailures.length; i++)
	{
		pFable.log.error(`  [${tmpFailures[i].Entity}].[${tmpFailures[i].RecordKey}]: ${tmpFailures[i].Error}`);
	}

	return tmpFailures.length;
};

},{"./Headlight-Integration-GUIDBatchResolver.js":9,"./Headlight-Integration-GUIDMap.js":10,"async":330,"fable-serviceproviderbase":438,"headlight-rest-client":20}],9:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Reads default to a cap of 250 records (`MeadowDefaultMaxCap`), so every batch
 * read has to state its own cap or the tail of a large IN list is silently
 * dropped.
 */
const DEFAULT_BATCH_SIZE = 100;

/**
 * The body-driven `POST <Entity>s/Query` read carries the filter outside the
 * URI, so batches there are bounded by nothing but the server's read cap.
 */
const DEFAULT_QUERY_BATCH_SIZE = 500;

/**
 * Length at which a GET read URL is considered too long to be safe through
 * Kong and restify. Matches the threshold the web Select2 reader uses to swap
 * a GET for the equivalent POST.
 */
const DEFAULT_URL_LENGTH_BUDGET = 1800;

/**
 * How many entities are resolved concurrently.
 */
const DEFAULT_ENTITY_CONCURRENCY = 4;

/**
 * A `~` separates filter terms and a `,` separates the members of an IN list,
 * and both are split *after* the transport layer has URL-decoded the filter
 * once. A GUID containing either character therefore cannot travel inside an IN
 * list on any route, and has to fall back to a single-GUID lookup.
 */
const UNBATCHABLE_GUID_PATTERN = /[,~]/;

const defaultHeadlightIntegrationGUIDBatchResolverOptions = (
	{
		BatchSize: DEFAULT_BATCH_SIZE,
		QueryBatchSize: DEFAULT_QUERY_BATCH_SIZE,
		URLLengthBudget: DEFAULT_URL_LENGTH_BUDGET,
		EntityConcurrency: DEFAULT_ENTITY_CONCURRENCY,

		// Read mode for the batch lookup. 'Lite' returns every ID/GUID column
		// (all this needs) instead of every column; 'Reads' returns whole records.
		ReadMode: 'Lite',

		// Route template for the body-driven read, used when the server
		// advertises RetoldMetadata.Capabilities.QueryEndpoint on its schema.
		QueryEndpointRoute: '<Entity>s/Query',

		// Set false to keep every batch on the URI-based GET route.
		UseQueryEndpoint: true
	});

/**
 * @typedef {Object} MappedGUIDReference
 * @property {'External'|'Headlight'|'Destination'} Kind - Which mapped-GUID form the field uses.
 * @property {string} MappedEntityName - The referenced entity.
 * @property {string} [DestinationField] - The ID column the value lands in, when the field name dictates it.
 * @property {boolean} SetMappedEntityIDField - Whether `ID<MappedEntity>` is also written.
 */

/**
 * Classify one source-record field as a mapped-GUID reference, or not a
 * reference at all.
 *
 * This is the single definition of what counts as a foreign key in a
 * comprehension record: the marshal path and the batch prefetch both read it,
 * so they cannot disagree about which fields need resolving.
 *
 * @param {string} pFieldKey - The source record's field name.
 * @param {string} pEntityGUIDName - The owning entity's own GUID column (`GUID<Entity>`), which is never a reference.
 * @return {MappedGUIDReference|null} The reference, or null when the field is not one.
 */
const classifyMappedGUIDField = (pFieldKey, pEntityGUIDName) =>
{
	if (!pFieldKey || typeof(pFieldKey) !== 'string')
	{
		return null;
	}
	if (pFieldKey === pEntityGUIDName || pFieldKey === `_${pEntityGUIDName}`)
	{
		return null;
	}
	if (pFieldKey.startsWith('_Dest_IDEntity_') && pFieldKey.includes('_Via_'))
	{
		const tmpMappedEntityGUIDName = pFieldKey.split('_Via_')[1];
		return (
			{
				Kind: 'Destination',
				MappedEntityName: tmpMappedEntityGUIDName.substring(4),
				DestinationField: pFieldKey.split('_Via_')[0].split('_Dest_IDEntity_')[1],
				SetMappedEntityIDField: false
			});
	}
	if (pFieldKey.startsWith('_Dest_'))
	{
		return null;
	}
	if (pFieldKey.startsWith('GUID'))
	{
		return { Kind: 'External', MappedEntityName: pFieldKey.substring(4), SetMappedEntityIDField: false };
	}
	if (pFieldKey.startsWith('_GUID'))
	{
		return { Kind: 'Headlight', MappedEntityName: pFieldKey.substring(5), SetMappedEntityIDField: true };
	}
	return null;
};

/**
 * Gather every mapped-GUID reference in a set of source records, grouped by the
 * entity being referenced.
 *
 * @param {Array<Record<string, any>>|Record<string, Record<string, any>>} pRecords - The source records.
 * @param {string} pEntityGUIDName - The owning entity's own GUID column.
 * @param {Map<string, Set<string>>} [pReferences] - An existing map to merge into.
 * @return {Map<string, Set<string>>} Referenced entity -> the GUID values referenced.
 */
const collectMappedGUIDReferences = (pRecords, pEntityGUIDName, pReferences) =>
{
	const tmpReferences = pReferences || new Map();
	const tmpRecordList = Array.isArray(pRecords) ? pRecords : Object.values(pRecords || {});

	for (const tmpRecord of tmpRecordList)
	{
		if (!tmpRecord || typeof(tmpRecord) !== 'object')
		{
			continue;
		}
		for (const tmpFieldKey of Object.keys(tmpRecord))
		{
			const tmpReference = classifyMappedGUIDField(tmpFieldKey, pEntityGUIDName);
			if (!tmpReference || !tmpReference.MappedEntityName)
			{
				continue;
			}
			const tmpValue = tmpRecord[tmpFieldKey];
			if (typeof(tmpValue) !== 'string' && typeof(tmpValue) !== 'number')
			{
				continue;
			}
			const tmpGUIDValue = String(tmpValue);
			if (!tmpGUIDValue)
			{
				continue;
			}
			if (!tmpReferences.has(tmpReference.MappedEntityName))
			{
				tmpReferences.set(tmpReference.MappedEntityName, new Set());
			}
			tmpReferences.get(tmpReference.MappedEntityName).add(tmpGUIDValue);
		}
	}

	return tmpReferences;
};

/**
 * Resolves referenced-entity GUIDs to Headlight IDs in batches, filling the
 * shared GUID map so the per-record marshal path finds them in memory instead
 * of issuing one request per reference.
 *
 * Every batch is an IN list against the referenced entity's GUID column, sent
 * either as `GET <Entity>s/Lite/FilteredTo/<filter>/0/<cap>` or, when the
 * server advertises the capability, as the body-driven
 * `POST <Entity>s/Query` — which carries far larger lists because the filter
 * never touches the URI.
 *
 * Values are URI-encoded in both directions: the body-driven read decodes the
 * `Filter` exactly once, mirroring what the HTTP layer does to the equivalent
 * GET path segment.
 */
class HeadlightIntegrationGUIDBatchResolver extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the resolver.
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, defaultHeadlightIntegrationGUIDBatchResolverOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client'), HeadlightGUIDMap: import('./Headlight-Integration-GUIDMap.js') }} */
		this.fable;
		this.serviceType = 'IntegrationGUIDBatchResolver';

		if (!this.fable.hasOwnProperty('HeadlightGUIDMap'))
		{
			this.fable.addAndInstantiateServiceType('HeadlightGUIDMap', require('./Headlight-Integration-GUIDMap.js'));
		}

		/** @type {import('headlight-rest-client')} */
		this._Client = this.options.Client || null;

		/**
		 * Whether the server serves the body-driven read. Left undefined until a
		 * caller sets it from the schema's RetoldMetadata capabilities; the
		 * URI-based GET route is used until then.
		 *
		 * @type {boolean|undefined}
		 */
		this.QueryEndpointSupported = this.options.QueryEndpointSupported;
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		return this._Client || this.fable.HeadlightRestClient;
	}

	set client(pClient)
	{
		this._Client = pClient;
	}

	/**
	 * @return {import('./Headlight-Integration-GUIDMap.js')}
	 */
	get guidMap()
	{
		return this.fable.HeadlightGUIDMap;
	}

	/**
	 * Adopt the batch-read capability advertised by an entity schema document.
	 * The capability describes the server, not the entity, so any entity's
	 * schema answers for all of them.
	 *
	 * @param {Object} pSchemaDocument - A `/{Entity}/Schema` response.
	 */
	applySchemaCapabilities(pSchemaDocument)
	{
		if (!pSchemaDocument || typeof(pSchemaDocument) !== 'object')
		{
			return;
		}
		const tmpCapabilities = pSchemaDocument.RetoldMetadata && pSchemaDocument.RetoldMetadata.Capabilities;
		if (tmpCapabilities && typeof(tmpCapabilities.QueryEndpoint) === 'boolean')
		{
			this.QueryEndpointSupported = tmpCapabilities.QueryEndpoint;
		}
	}

	/**
	 * @return {boolean} Whether batches should go out on the body-driven read route.
	 */
	get useQueryEndpoint()
	{
		return (this.options.UseQueryEndpoint !== false) && (this.QueryEndpointSupported === true);
	}

	/**
	 * Whether a GUID is already answered by the in-memory maps the marshal path
	 * consults first: the external-GUID map (populated as earlier entities in
	 * this run were pushed) and the Headlight GUID map (populated by upserts and
	 * by earlier batches).
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {string} pGUID - The referenced GUID.
	 * @return {boolean} True when a lookup would be answered from memory.
	 */
	isCached(pEntity, pGUID)
	{
		return Boolean(this.guidMap.getHeadlightIDFromExternalGUID(pEntity, pGUID))
			|| Boolean(this.guidMap.getIDFromGUID(pEntity, pGUID));
	}

	/**
	 * Reduce a set of referenced GUIDs to the ones actually worth asking the
	 * server about.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Set<string>|Array<string>} pGUIDs - The referenced GUIDs.
	 * @return {{ Pending: Array<string>, Cached: number, Unbatchable: Array<string> }} The split.
	 */
	partitionGUIDs(pEntity, pGUIDs)
	{
		/** @type {Array<string>} */
		const tmpPending = [];
		/** @type {Array<string>} */
		const tmpUnbatchable = [];
		let tmpCached = 0;

		for (const tmpGUID of pGUIDs)
		{
			if (!tmpGUID)
			{
				continue;
			}
			if (this.isCached(pEntity, tmpGUID))
			{
				tmpCached++;
				continue;
			}
			if (UNBATCHABLE_GUID_PATTERN.test(tmpGUID))
			{
				tmpUnbatchable.push(tmpGUID);
				continue;
			}
			tmpPending.push(tmpGUID);
		}

		return { Pending: tmpPending, Cached: tmpCached, Unbatchable: tmpUnbatchable };
	}

	/**
	 * Build the meadow IN filter for a batch of GUIDs.
	 *
	 * The instruction must be `FBL` (filter by list): `FBV` binds the whole
	 * comma-joined value as a single scalar, producing `IN ('a,b,c')` -- which
	 * matches nothing and reports no error.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Array<string>} pGUIDs - The GUIDs in the batch.
	 * @return {string} The filter expression.
	 */
	buildGUIDFilter(pEntity, pGUIDs)
	{
		return `FBL~GUID${pEntity}~INN~${pGUIDs.map(encodeURIComponent).join(',')}`;
	}

	/**
	 * Take the next batch off the front of a pending queue, bounded by the batch
	 * size and — on the URI-based route — by the length of the URL it would
	 * produce.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Array<string>} pQueue - The pending GUIDs; the returned batch is spliced off it.
	 * @return {Array<string>} The next batch.
	 */
	takeBatch(pEntity, pQueue)
	{
		if (this.useQueryEndpoint)
		{
			return pQueue.splice(0, this.options.QueryBatchSize);
		}

		// `<Entity>s/Lite/FilteredTo/<filter>/0/<cap>` less the filter itself,
		// with room for the server URL prefix the client prepends.
		let tmpBudget = this.options.URLLengthBudget - (pEntity.length * 2) - 48;
		const tmpBatch = [];

		while (pQueue.length > 0 && tmpBatch.length < this.options.BatchSize)
		{
			const tmpCost = encodeURIComponent(pQueue[0]).length + 1;
			if (tmpBatch.length > 0 && tmpCost > tmpBudget)
			{
				break;
			}
			tmpBudget -= tmpCost;
			tmpBatch.push(pQueue.shift());
		}

		return tmpBatch;
	}

	/**
	 * Read one batch of GUIDs.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Array<string>} pGUIDs - The GUIDs in the batch.
	 * @return {Promise<Array<Record<string, any>>|null>} The records, or null when the body-driven read is unavailable and the batch should be retried on the GET route.
	 */
	async readBatch(pEntity, pGUIDs)
	{
		const tmpFilter = this.buildGUIDFilter(pEntity, pGUIDs);

		if (this.useQueryEndpoint)
		{
			try
			{
				return await this._postQueryBatch(pEntity, tmpFilter, pGUIDs.length);
			}
			catch (pError)
			{
				this.log.warn(`Batch GUID read for [${pEntity}] could not use the body-driven read route; falling back to URI reads: ${pError.message || pError}`);
				this.QueryEndpointSupported = false;
				return null;
			}
		}

		try
		{
			return await this._getFilteredBatch(pEntity, tmpFilter, pGUIDs.length);
		}
		catch (pError)
		{
			this.log.warn(`Batch GUID read for [${pEntity}] failed for ${pGUIDs.length} GUID(s); those references fall back to single lookups: ${pError.message || pError}`);
			return [];
		}
	}

	/**
	 * @param {string} pEntity - The referenced entity.
	 * @param {string} pFilter - The IN filter.
	 * @param {number} pCap - The record cap.
	 * @return {Promise<Array<Record<string, any>>>} The records.
	 * @private
	 */
	_getFilteredBatch(pEntity, pFilter, pCap)
	{
		const tmpReadMode = (this.options.ReadMode === 'Lite') ? '/Lite' : '';
		return new Promise((resolve, reject) =>
		{
			this.client.getJSON(`${pEntity}s${tmpReadMode}/FilteredTo/${pFilter}/0/${pCap}`,
				(pError, pBody) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					return resolve(Array.isArray(pBody) ? pBody : []);
				});
		});
	}

	/**
	 * @param {string} pEntity - The referenced entity.
	 * @param {string} pFilter - The IN filter.
	 * @param {number} pCap - The record cap.
	 * @return {Promise<Array<Record<string, any>>>} The records.
	 * @private
	 */
	_postQueryBatch(pEntity, pFilter, pCap)
	{
		const tmpRoute = this.options.QueryEndpointRoute.replace('<Entity>', pEntity);
		const tmpBody = { Filter: pFilter, Begin: 0, Cap: pCap };
		if (this.options.ReadMode === 'Lite')
		{
			tmpBody.Lite = true;
		}
		return new Promise((resolve, reject) =>
		{
			this.client.postJSON(tmpRoute, tmpBody,
				(pError, pBody) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					if (!Array.isArray(pBody))
					{
						return reject(new Error(`Body-driven read of [${pEntity}] did not return a record array.`));
					}
					return resolve(pBody);
				});
		});
	}

	/**
	 * Resolve one entity's referenced GUIDs, mapping every hit into the shared
	 * GUID map.
	 *
	 * @param {string} pEntity - The referenced entity.
	 * @param {Set<string>|Array<string>} pGUIDs - The referenced GUIDs.
	 * @return {Promise<{ Entity: string, Requested: number, Cached: number, Resolved: number, Missing: Array<string>, Unverified: number, Requests: number }>} What the batch resolved.
	 */
	async resolveEntityGUIDs(pEntity, pGUIDs)
	{
		const tmpPartition = this.partitionGUIDs(pEntity, pGUIDs);
		const tmpResult = (
			{
				Entity: pEntity,
				Requested: tmpPartition.Pending.length,
				Cached: tmpPartition.Cached,
				Resolved: 0,
				Missing: [],
				Unverified: tmpPartition.Unbatchable.length,
				Requests: 0
			});

		if (tmpPartition.Pending.length < 1)
		{
			return tmpResult;
		}

		const tmpGUIDColumn = `GUID${pEntity}`;
		const tmpIDColumn = `ID${pEntity}`;
		const tmpQueue = tmpPartition.Pending.slice();

		while (tmpQueue.length > 0)
		{
			const tmpBatch = this.takeBatch(pEntity, tmpQueue);
			const tmpRecords = await this.readBatch(pEntity, tmpBatch);

			if (tmpRecords === null)
			{
				// The body-driven route dropped out; the batch goes back on the
				// queue and is re-cut for the (smaller) URI route.
				tmpQueue.unshift(...tmpBatch);
				continue;
			}

			tmpResult.Requests++;

			const tmpFound = new Set();
			for (const tmpRecord of tmpRecords)
			{
				if (!tmpRecord || typeof(tmpRecord) !== 'object')
				{
					continue;
				}
				const tmpGUID = tmpRecord[tmpGUIDColumn];
				const tmpID = tmpRecord[tmpIDColumn];
				if (!tmpGUID || !(tmpID > 0))
				{
					continue;
				}
				this.guidMap.mapGUIDToID(pEntity, tmpGUID, tmpID);
				tmpFound.add(tmpGUID);
			}

			if (tmpFound.size < 1)
			{
				// A batch that matches nothing at all is far more likely to be a
				// broken filter or route than a batch of entirely absent records,
				// and a caller that trusted it would skip the single-GUID lookups
				// that would have resolved them.  Report those GUIDs as unverified
				// rather than missing.
				tmpResult.Unverified += tmpBatch.length;
				this.log.warn(`Batch read of ${tmpBatch.length} [${pEntity}] GUID(s) matched no records; those references fall back to single lookups.`);
				continue;
			}

			tmpResult.Resolved += tmpFound.size;
			for (const tmpGUID of tmpBatch)
			{
				if (!tmpFound.has(tmpGUID))
				{
					tmpResult.Missing.push(tmpGUID);
				}
			}
		}

		return tmpResult;
	}

	/**
	 * Resolve a whole map of referenced GUIDs, a few entities at a time.
	 *
	 * @param {Map<string, Set<string>>} pReferences - Referenced entity -> GUID values.
	 * @return {Promise<{ Entities: Array<Object>, Requested: number, Cached: number, Resolved: number, Unverified: number, Requests: number, Missing: Map<string, Set<string>> }>} What the pass resolved.
	 */
	async resolveReferences(pReferences)
	{
		const tmpSummary = { Entities: [], Requested: 0, Cached: 0, Resolved: 0, Unverified: 0, Requests: 0, Missing: new Map() };
		const tmpEntities = Array.from(pReferences.keys()).filter((pEntity) => Boolean(pEntity));
		if (tmpEntities.length < 1)
		{
			return tmpSummary;
		}

		let tmpNextEntityIndex = 0;
		const tmpWorkerCount = Math.max(1, Math.min(this.options.EntityConcurrency, tmpEntities.length));
		const tmpWorkers = [];

		for (let i = 0; i < tmpWorkerCount; i++)
		{
			tmpWorkers.push((async () =>
			{
				while (tmpNextEntityIndex < tmpEntities.length)
				{
					const tmpEntity = tmpEntities[tmpNextEntityIndex++];
					const tmpResult = await this.resolveEntityGUIDs(tmpEntity, pReferences.get(tmpEntity));
					tmpSummary.Entities.push(tmpResult);
					tmpSummary.Requested += tmpResult.Requested;
					tmpSummary.Cached += tmpResult.Cached;
					tmpSummary.Resolved += tmpResult.Resolved;
					tmpSummary.Unverified += tmpResult.Unverified;
					tmpSummary.Requests += tmpResult.Requests;
					if (tmpResult.Missing.length > 0)
					{
						tmpSummary.Missing.set(tmpEntity, new Set(tmpResult.Missing));
					}
				}
			})());
		}

		await Promise.all(tmpWorkers);

		return tmpSummary;
	}
}

module.exports = HeadlightIntegrationGUIDBatchResolver;

module.exports.default_configuration = defaultHeadlightIntegrationGUIDBatchResolverOptions;
module.exports.classifyMappedGUIDField = classifyMappedGUIDField;
module.exports.collectMappedGUIDReferences = collectMappedGUIDReferences;
module.exports.UNBATCHABLE_GUID_PATTERN = UNBATCHABLE_GUID_PATTERN;

},{"./Headlight-Integration-GUIDMap.js":10,"fable-serviceproviderbase":438}],10:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const defaultHeadlightGUIDMapOptions = (
	{
		// Nothing here yet.
		// Maybe overwrite rules?  Right now it's just obliterate.
		// When we add persistence that would be here as well.
	});

class HeadlightGUIDMap extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadlightGUIDMapOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client') }} */
		this.fable;
		this.serviceType = 'HeadlightGUIDMap';

		// For now, keep GUID mappings to IDs in memory forever.
		// At the moment, we don't have enough data throughput for that to be a problem really.
		// When it becomes so, we can shift the persistence to some kind of key-value store.
		// These are back and forth between the Headlight GUIDs and the Headlight IDs
		this._GUIDMap = {};
		this._IDMap = {};

		// Keep track of *external* GUIDS that map to Headlight GUIDs
		this._ExternalGUIDMap = {};
	}

	// Add an entity for the mapping
	addEntity(pEntity)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this._GUIDMap[pEntity] = {};
			this._IDMap[pEntity] = {};
			this._ExternalGUIDMap[pEntity] = {};
		}

		return true;
	}

	// Map a Headlight GUID to an ID
	mapGUIDToID(pEntity, pGUID, pID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._GUIDMap[pEntity][pGUID] = pID;
		this._IDMap[pEntity][pID] = pGUID;

		return true;
	}

	// Get an ID from a GUID
	getIDFromGUID(pEntity, pGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._GUIDMap[pEntity].hasOwnProperty(pGUID)) ? this._GUIDMap[pEntity][pGUID] : false;
	}

	/**
	 * @param {string} pEntity
	 * @param {string} pGUID
	 * @param {(pError: Error|null, pID?: number|false) => void} fCallback
	 * @param {import('headlight-rest-client')} [pClient] - the client instance to use; defaults to the default fable service
	 */
	getIDFromGUIDAsync(pEntity, pGUID, fCallback, pClient)
	{
		const tmpClient = pClient || this.fable.HeadlightRestClient;
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		// If it has already been loaded, return it.
		if (this._GUIDMap[pEntity].hasOwnProperty(pGUID))
		{
			fCallback(null, this._GUIDMap[pEntity][pGUID]);
		}
		else
		{
			// Try to load it from the server
			tmpClient.getEntityByGUID(pEntity, pGUID,
				(pError, pBody) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					else
					{
						let tmpEntityIDName = `ID${pEntity}`;
						if (pBody && pBody.hasOwnProperty(tmpEntityIDName))
						{
							this.mapGUIDToID(pEntity, pGUID, pBody[tmpEntityIDName]);
							return fCallback(pError, pBody[tmpEntityIDName]);
						}
						else
						{
							return fCallback(pError, false)
						}
					}
				});
		}
	}

	// Get a GUID from an ID
	getGUIDFromID(pEntity, pID)
	{
		if (!this._IDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._IDMap[pEntity].hasOwnProperty(pID)) ? this._IDMap[pEntity][pID] : false;
	}

	// For now this is one-directional; we may need two for bi-directional sync but there are other ways to resolve this.
	mapExternalGUIDtoHeadlightGUID(pEntity, pExternalGUID, pHeadlightGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._ExternalGUIDMap[pEntity][pExternalGUID] = pHeadlightGUID;

		return true;
	}

	getHeadlightGUIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._ExternalGUIDMap[pEntity].hasOwnProperty(pExternalGUID)) ? this._ExternalGUIDMap[pEntity][pExternalGUID] : false;
	}

	getHeadlightIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		let tmpHeadlightGUID = this.getHeadlightGUIDFromExternalGUID(pEntity, pExternalGUID);
		return (tmpHeadlightGUID) ? this.getIDFromGUID(pEntity, tmpHeadlightGUID) : false;
	}
}

module.exports = HeadlightGUIDMap;

module.exports.default_configuration = defaultHeadlightGUIDMapOptions;

},{"fable-serviceproviderbase":438}],11:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libCrypto = require('crypto');
const libIntegrationAdapter = require('headlight-integration-adapter');

const SPECIFICATION_SET_LINE_ITEM_SAMPLE = 500;
// INN values ride in the URL path; the browser -> Kong path drops requests well below what Node -> API accepts.
const INN_VALUE_CHARACTER_BUDGET = 2000;

class SamplePlanService extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'SamplePlanService';
	}

	/**
	 * The HeadlightRestClient instance from the fable service manager.
	 * Both CLI and web contexts register this service on fable.
	 */
	get restClient()
	{
		return this.fable.HeadlightRestClient;
	}

	/**
	 * Generate a deterministic GUID from a prefix and composite key using MD5.
	 *
	 * @param {string} pPrefix - The prefix for the GUID (e.g., 'MSP-PLIMT', 'MSP-MLJ').
	 * @param {string} pCompositeKey - The composite key to hash.
	 * @return {string} The generated GUID.
	 */
	generateGUID(pPrefix, pCompositeKey)
	{
		let tmpHash = libCrypto.createHash('md5').update(pCompositeKey).digest('hex').substring(0, 12);
		return `${pPrefix}-${tmpHash}`;
	}

	/**
	 * Split INN filter values into batches whose comma-joined length stays within a character budget, so short
	 * numeric IDs batch widely and long strings batch small. A value longer than the budget goes out alone.
	 *
	 * @param {Array<string|number>} pValues - The values to filter by.
	 * @param {number} [pBudget] - Maximum comma-joined length per batch; defaults to INN_VALUE_CHARACTER_BUDGET.
	 * @return {Array<Array<string|number>>} The batches, in input order.
	 */
	batchINNValues(pValues, pBudget)
	{
		let tmpBudget = pBudget || INN_VALUE_CHARACTER_BUDGET;
		let tmpBatches = [];
		let tmpBatch = [];
		let tmpBatchLength = 0;
		for (let i = 0; i < pValues.length; i++)
		{
			let tmpValueLength = String(pValues[i]).length;
			let tmpNextLength = (tmpBatch.length > 0) ? (tmpBatchLength + 1 + tmpValueLength) : tmpValueLength;
			if ((tmpBatch.length > 0) && (tmpNextLength > tmpBudget))
			{
				tmpBatches.push(tmpBatch);
				tmpBatch = [];
				tmpNextLength = tmpValueLength;
			}
			tmpBatch.push(pValues[i]);
			tmpBatchLength = tmpNextLength;
		}
		if (tmpBatch.length > 0)
		{
			tmpBatches.push(tmpBatch);
		}
		return tmpBatches;
	}

	/**
	 * Fetch entities in batched INN filters, each within INN_VALUE_CHARACTER_BUDGET, to avoid URL length limits.
	 *
	 * @param {string} pEntityType - The Meadow entity type.
	 * @param {string} pFilterField - The field to filter on.
	 * @param {Array<string|number>} pIDs - The values to filter by (IDs, or strings such as ItemCode).
	 * @param {string|null} pExtraFilter - Additional filter expression to append.
	 * @param {Function} fCallback - Callback: (error, records[]).
	 */
	getEntitySetBatched(pEntityType, pFilterField, pIDs, pExtraFilter, fCallback)
	{
		let tmpAllRecords = [];

		if (pIDs.length === 0)
		{
			return fCallback(null, []);
		}

		let tmpBatches = this.batchINNValues(pIDs);

		let tmpBatchIndex = 0;
		let tmpProcessBatch = () =>
		{
			if (tmpBatchIndex >= tmpBatches.length)
			{
				this.log.info(`    ... fetched ${tmpAllRecords.length} ${pEntityType} records total.`);
				return fCallback(null, tmpAllRecords);
			}

			if (tmpBatches.length > 1)
			{
				this.log.info(`    ... batch ${tmpBatchIndex + 1}/${tmpBatches.length} (${tmpAllRecords.length} records so far)`);
			}

			let tmpBatchIDs = tmpBatches[tmpBatchIndex].join(',');
			let tmpFilter = `FBL~${pFilterField}~INN~${tmpBatchIDs}~FBV~Deleted~EQ~0`;
			if (pExtraFilter)
			{
				tmpFilter += `~${pExtraFilter}`;
			}

			this.restClient.getEntitySet(pEntityType, tmpFilter,
				(pError, pRecords) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					tmpAllRecords = tmpAllRecords.concat(pRecords);
					tmpBatchIndex++;
					tmpProcessBatch();
				}, 0, 200000);
		};
		tmpProcessBatch();
	}

	/**
	 * Count entities in batched INN filters, each within INN_VALUE_CHARACTER_BUDGET, to avoid URL length limits.
	 *
	 * @param {string} pEntityType - The Meadow entity type.
	 * @param {string} pFilterField - The field to filter on.
	 * @param {Array<string|number>} pIDs - The values to filter by (IDs, or strings such as ItemCode).
	 * @param {string|null} pExtraFilter - Additional filter expression to append.
	 * @param {(pError?: any, pCount?: number) => void} fCallback - Callback with the total across batches.
	 */
	getEntitySetCountBatched(pEntityType, pFilterField, pIDs, pExtraFilter, fCallback)
	{
		let tmpBatches = this.batchINNValues(pIDs);
		let tmpTotal = 0;
		let tmpBatchIndex = 0;

		let tmpProcessBatch = () =>
		{
			if (tmpBatchIndex >= tmpBatches.length)
			{
				return fCallback(null, tmpTotal);
			}

			let tmpFilter = `FBL~${pFilterField}~INN~${tmpBatches[tmpBatchIndex].join(',')}~FBV~Deleted~EQ~0`;
			if (pExtraFilter)
			{
				tmpFilter += `~${pExtraFilter}`;
			}
			tmpBatchIndex++;

			this.restClient.getEntitySetCount(pEntityType, tmpFilter,
				(pError, pResult) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					tmpTotal += (pResult && pResult.Count) ? pResult.Count : 0;
					tmpProcessBatch();
				});
		};
		tmpProcessBatch();
	}

	/**
	 * Index line items by ItemCode. When an ItemCode repeats, the last line item read wins, and the
	 * repeats are reported so the caller can warn.
	 *
	 * @param {Array<Record<string, any>>} pLineItems - Line items carrying ItemCode.
	 * @return {{ByItemCode: Record<string, Record<string, any>>, DuplicateItemCodes: Array<string>, Warning: string|null}} The index.
	 */
	indexLineItemsByItemCode(pLineItems)
	{
		let tmpByItemCode = {};
		let tmpDuplicates = {};
		for (let i = 0; i < pLineItems.length; i++)
		{
			let tmpItemCode = pLineItems[i].ItemCode;
			if (!tmpItemCode)
			{
				continue;
			}
			if (tmpByItemCode[tmpItemCode])
			{
				tmpDuplicates[tmpItemCode] = true;
			}
			tmpByItemCode[tmpItemCode] = pLineItems[i];
		}

		let tmpDuplicateItemCodes = Object.keys(tmpDuplicates);
		let tmpWarning = null;
		if (tmpDuplicateItemCodes.length > 0)
		{
			let tmpShown = tmpDuplicateItemCodes.slice(0, 10).join(', ') + ((tmpDuplicateItemCodes.length > 10) ? ', ...' : '');
			tmpWarning = `${tmpDuplicateItemCodes.length} item code(s) appear on more than one source line item, so the plan is copied from only one of them: ${tmpShown}.`;
		}
		return { ByItemCode: tmpByItemCode, DuplicateItemCodes: tmpDuplicateItemCodes, Warning: tmpWarning };
	}

	/**
	 * @typedef {object} SamplePlanProjectContext
	 * @property {Record<string, any>} Project - The Project record.
	 * @property {Record<string, any>|null} Contract - The project's Contract, or null when it has none.
	 * @property {Array<{IDProject: number, Name: string}>} ContractProjects - Every live project on that Contract, this one included.
	 */

	/**
	 * @typedef {object} ProjectSpecificationSets
	 * @property {number} IDProject - The project.
	 * @property {string} Name - The project name.
	 * @property {Record<string, any>|null} Contract - The project's Contract, or null.
	 * @property {Array<{IDProject: number, Name: string}>} ContractProjects - Every live project on that Contract.
	 * @property {number} ItemIDTestSpecificationSet - The Contract's item set, else the single set the line items' pay items share; 0 when neither resolves.
	 * @property {number} MaterialIDTestSpecificationSet - The Contract's material set, else the item set.
	 * @property {string} Basis - Where the item set came from: 'Contract', 'PayItems' or 'None'.
	 * @property {Record<string, number>} PayItemSetDistribution - Line item count per PayItem.IDTestSpecificationSet.
	 * @property {boolean} PayItemSetMixed - True when the line items' pay items span more than one set.
	 * @property {number} LineItemsWithoutPayItem - Line items with no live pay item.
	 * @property {number} LineItemsExamined - Line items the distribution was built from.
	 * @property {Record<string, string>} [SpecificationSetNames] - TestSpecificationSet names by ID, when fetched.
	 */

	/**
	 * @typedef {object} LineItemPayItemRemap
	 * @property {number} IDLineItem - The destination line item.
	 * @property {string} GUIDLineItem - Its existing GUID, used verbatim to update in place.
	 * @property {string} ItemCode - The ItemCode the pay items were matched on.
	 * @property {string} Name - The line item name.
	 * @property {number} FromIDPayItem - The current pay item.
	 * @property {number} FromIDTestSpecificationSet - The current pay item's set.
	 * @property {number} ToIDPayItem - The target-set pay item.
	 */

	/**
	 * @typedef {object} SpecificationSetContractUpdate
	 * @property {number} IDContract - The destination Contract.
	 * @property {string} GUIDContract - Its existing GUID, used verbatim to update in place.
	 * @property {string} Name - The Contract name.
	 * @property {{ItemIDTestSpecificationSet: number, MaterialIDTestSpecificationSet: number}} Before - Current sets.
	 * @property {{ItemIDTestSpecificationSet: number, MaterialIDTestSpecificationSet: number}} After - Target sets.
	 * @property {Array<{IDProject: number, Name: string}>} SharedWithProjects - Other projects on the same Contract.
	 */

	/**
	 * @typedef {object} SpecificationSetAlignment
	 * @property {boolean} Crossing - True when the destination sits on different sets than the source.
	 * @property {number} ItemIDTestSpecificationSet - Target item set.
	 * @property {number} MaterialIDTestSpecificationSet - Target material set.
	 * @property {SpecificationSetContractUpdate|null} Contract - The Contract update, or null when none is needed or possible.
	 * @property {Array<LineItemPayItemRemap>} LineItemRemaps - Line items to move onto target-set pay items.
	 * @property {Array<{IDLineItem: number, ItemCode: string, Name: string, Reason: string}>} Unmapped - Line items on another set that cannot be moved.
	 * @property {number} AlreadyAlignedCount - Line items already on target-set pay items.
	 * @property {number} WithoutPayItemCount - Line items with no live pay item, left alone.
	 * @property {Array<string>} Warnings - Conditions to surface before the load.
	 * @property {boolean} [Flip] - Set by `resolveSpecificationSetAlignment`: whether the copy applies the plan.
	 */

	/**
	 * Fetch a project, its Contract (if any) and every live project sharing that Contract.
	 *
	 * @param {number} pIDProject - The project.
	 * @param {(pError?: any, pContext?: SamplePlanProjectContext) => void} fCallback - Callback.
	 */
	getProjectContext(pIDProject, fCallback)
	{
		this.restClient.getEntity('Project', pIDProject,
			(pError, pProject) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpContext = { Project: pProject || {}, Contract: null, ContractProjects: [] };
				if (!(tmpContext.Project.IDContract > 0))
				{
					return fCallback(null, tmpContext);
				}
				this.restClient.getEntity('Contract', tmpContext.Project.IDContract,
					(pContractError, pContract) =>
					{
						if (pContractError)
						{
							return fCallback(pContractError);
						}
						if (!pContract || !(pContract.IDContract > 0))
						{
							return fCallback(null, tmpContext);
						}
						tmpContext.Contract = pContract;
						this.restClient.getEntitySet('Project', `FBV~IDContract~EQ~${pContract.IDContract}~FBV~Deleted~EQ~0`,
							(pProjectsError, pProjects) =>
							{
								if (pProjectsError)
								{
									return fCallback(pProjectsError);
								}
								tmpContext.ContractProjects = (pProjects || []).map((pSharingProject) => ({ IDProject: pSharingProject.IDProject, Name: pSharingProject.Name || '' }));
								return fCallback(null, tmpContext);
							}, 0, 1000);
					});
			});
	}

	/**
	 * Fetch the live pay items referenced by a set of line items.
	 *
	 * @param {Array<Record<string, any>>} pLineItems - Line items carrying IDPayItem.
	 * @param {(pError?: any, pPayItemsByID?: Record<string, Record<string, any>>) => void} fCallback - Callback.
	 */
	getPayItemsForLineItems(pLineItems, fCallback)
	{
		let tmpIDs = [ ...new Set(pLineItems.map((pLineItem) => pLineItem.IDPayItem).filter((pID) => pID > 0)) ];
		this.getEntitySetBatched('PayItem', 'IDPayItem', tmpIDs, null,
			(pError, pPayItems) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpPayItemsByID = {};
				for (let i = 0; i < pPayItems.length; i++)
				{
					tmpPayItemsByID[pPayItems[i].IDPayItem] = pPayItems[i];
				}
				return fCallback(null, tmpPayItemsByID);
			});
	}

	/**
	 * Fetch TestSpecificationSet names.
	 *
	 * @param {Array<number>} pSetIDs - Set IDs; zeros and repeats are ignored.
	 * @param {(pError?: any, pNames?: Record<string, string>) => void} fCallback - Callback.
	 */
	getSpecificationSetNames(pSetIDs, fCallback)
	{
		let tmpIDs = [ ...new Set(pSetIDs.filter((pID) => pID > 0)) ];
		this.getEntitySetBatched('TestSpecificationSet', 'IDTestSpecificationSet', tmpIDs, null,
			(pError, pSets) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpNames = {};
				for (let i = 0; i < pSets.length; i++)
				{
					tmpNames[pSets[i].IDTestSpecificationSet] = pSets[i].Name || '';
				}
				return fCallback(null, tmpNames);
			});
	}

	/**
	 * Work out which specification sets a project is on. The Contract is authoritative; a project
	 * without one falls back to PayItem.IDTestSpecificationSet across its line items.
	 *
	 * @param {SamplePlanProjectContext} pContext - The project and its Contract.
	 * @param {Array<Record<string, any>>} pLineItems - The line items to read pay item sets from.
	 * @param {Record<string, Record<string, any>>} pPayItemsByID - Pay items by IDPayItem.
	 * @return {ProjectSpecificationSets} The project's sets.
	 */
	summarizeProjectSpecificationSets(pContext, pLineItems, pPayItemsByID)
	{
		let tmpDistribution = {};
		let tmpWithoutPayItem = 0;
		for (let i = 0; i < pLineItems.length; i++)
		{
			let tmpPayItem = pPayItemsByID[pLineItems[i].IDPayItem];
			if (!tmpPayItem)
			{
				tmpWithoutPayItem++;
				continue;
			}
			let tmpSetID = Number(tmpPayItem.IDTestSpecificationSet) || 0;
			tmpDistribution[tmpSetID] = (tmpDistribution[tmpSetID] || 0) + 1;
		}
		let tmpPayItemSetIDs = Object.keys(tmpDistribution);
		let tmpPayItemSetID = (tmpPayItemSetIDs.length === 1) ? parseInt(tmpPayItemSetIDs[0], 10) : 0;

		let tmpContract = pContext.Contract;
		let tmpItemSetID = 0;
		let tmpBasis = 'None';
		if (tmpContract && (Number(tmpContract.ItemIDTestSpecificationSet) > 0))
		{
			tmpItemSetID = Number(tmpContract.ItemIDTestSpecificationSet);
			tmpBasis = 'Contract';
		}
		else if (tmpPayItemSetID > 0)
		{
			tmpItemSetID = tmpPayItemSetID;
			tmpBasis = 'PayItems';
		}
		let tmpMaterialSetID = (tmpContract && (Number(tmpContract.MaterialIDTestSpecificationSet) > 0)) ? Number(tmpContract.MaterialIDTestSpecificationSet) : tmpItemSetID;

		return (
			{
				IDProject: pContext.Project.IDProject,
				Name: pContext.Project.Name || '',
				Contract: tmpContract,
				ContractProjects: pContext.ContractProjects,
				ItemIDTestSpecificationSet: tmpItemSetID,
				MaterialIDTestSpecificationSet: tmpMaterialSetID,
				Basis: tmpBasis,
				PayItemSetDistribution: tmpDistribution,
				PayItemSetMixed: tmpPayItemSetIDs.length > 1,
				LineItemsWithoutPayItem: tmpWithoutPayItem,
				LineItemsExamined: pLineItems.length
			});
	}

	/**
	 * Work out a project's specification sets from its Contract, else from a sample of its own line items.
	 *
	 * @param {SamplePlanProjectContext} pContext - The project and its Contract.
	 * @param {number} [pLineItemLimit] - Maximum line items to sample for the pay item fallback.
	 * @param {(pError?: any, pSets?: ProjectSpecificationSets) => void} fCallback - Callback.
	 */
	resolveProjectSpecificationSets(pContext, pLineItemLimit, fCallback)
	{
		this.restClient.getEntitySet('LineItem', `FBV~IDProject~EQ~${pContext.Project.IDProject}~FBV~Deleted~EQ~0`,
			(pError, pRecords) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				let tmpLineItems = pRecords || [];
				this.getPayItemsForLineItems(tmpLineItems,
					(pPayItemError, pPayItemsByID) =>
					{
						if (pPayItemError)
						{
							return fCallback(pPayItemError);
						}
						return fCallback(null, this.summarizeProjectSpecificationSets(pContext, tmpLineItems, pPayItemsByID));
					});
			}, 0, pLineItemLimit || SPECIFICATION_SET_LINE_ITEM_SAMPLE);
	}

	/**
	 * Describe a project's specification sets for display.
	 *
	 * @param {number} pIDProject - The project.
	 * @param {number|null} pLineItemLimit - Maximum line items to sample for the pay item fallback; null for the default.
	 * @param {(pError?: any, pSets?: ProjectSpecificationSets) => void} fCallback - Callback.
	 */
	describeProjectSpecificationSets(pIDProject, pLineItemLimit, fCallback)
	{
		let tmpSets = null;

		this.fable.Utility.waterfall(
			[
				(fStageComplete) =>
				{
					this.getProjectContext(pIDProject,
						(pError, pContext) =>
						{
							if (pError)
							{
								return fStageComplete(pError);
							}
							this.resolveProjectSpecificationSets(pContext, pLineItemLimit,
								(pSetsError, pSets) =>
								{
									tmpSets = pSets;
									return fStageComplete(pSetsError);
								});
						});
				},
				(fStageComplete) =>
				{
					this.getSpecificationSetNames([ tmpSets.ItemIDTestSpecificationSet, tmpSets.MaterialIDTestSpecificationSet ],
						(pError, pNames) =>
						{
							tmpSets.SpecificationSetNames = pNames || {};
							return fStageComplete(pError);
						});
				}
			],
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`Error describing specification sets for project ${pIDProject}`, pError);
				}
				return fCallback(pError, tmpSets);
			});
	}

	/**
	 * Plan the Contract and LineItem updates that move a destination project onto the source's
	 * specification sets. Line items are matched to target-set pay items by ItemCode through
	 * PayItem.IDTestSpecificationSet.
	 *
	 * @param {object} pInputs - Planning inputs.
	 * @param {number} pInputs.ItemIDTestSpecificationSet - Target item set; 0 disables realignment.
	 * @param {number} pInputs.MaterialIDTestSpecificationSet - Target material set; defaults to the item set.
	 * @param {number} pInputs.DestIDProject - The destination project.
	 * @param {Record<string, any>|null} pInputs.DestContract - The destination's Contract, or null.
	 * @param {Array<{IDProject: number, Name: string}>} pInputs.DestContractProjects - Every live project on that Contract.
	 * @param {Array<Record<string, any>>} pInputs.DestLineItems - Every destination line item.
	 * @param {Record<string, Record<string, any>>} pInputs.DestPayItemsByID - The destination line items' pay items.
	 * @param {Record<string, Array<Record<string, any>>>} pInputs.TargetPayItemsByItemCode - Target-set pay items by ItemCode.
	 * @return {SpecificationSetAlignment} The plan.
	 */
	planSpecificationSetAlignment(pInputs)
	{
		let tmpItemSetID = Number(pInputs.ItemIDTestSpecificationSet) || 0;
		let tmpMaterialSetID = Number(pInputs.MaterialIDTestSpecificationSet) || tmpItemSetID;
		let tmpAlignment = (
			{
				Crossing: false,
				ItemIDTestSpecificationSet: tmpItemSetID,
				MaterialIDTestSpecificationSet: tmpMaterialSetID,
				Contract: null,
				LineItemRemaps: [],
				Unmapped: [],
				AlreadyAlignedCount: 0,
				WithoutPayItemCount: 0,
				Warnings: []
			});

		if (tmpItemSetID < 1)
		{
			return tmpAlignment;
		}

		let tmpContract = pInputs.DestContract;
		if (tmpContract)
		{
			let tmpBefore = (
				{
					ItemIDTestSpecificationSet: Number(tmpContract.ItemIDTestSpecificationSet) || 0,
					MaterialIDTestSpecificationSet: Number(tmpContract.MaterialIDTestSpecificationSet) || 0
				});
			if ((tmpBefore.ItemIDTestSpecificationSet !== tmpItemSetID) || (tmpBefore.MaterialIDTestSpecificationSet !== tmpMaterialSetID))
			{
				tmpAlignment.Crossing = true;
				let tmpSharedWith = (pInputs.DestContractProjects || []).filter((pProject) => Number(pProject.IDProject) !== Number(pInputs.DestIDProject));
				if (!tmpContract.GUIDContract)
				{
					tmpAlignment.Warnings.push(`Contract ${tmpContract.Name || tmpContract.IDContract} has no stable identifier (GUID), so its specification sets cannot be updated by this copy.`);
				}
				else
				{
					tmpAlignment.Contract = (
						{
							IDContract: tmpContract.IDContract,
							GUIDContract: tmpContract.GUIDContract,
							Name: tmpContract.Name || '',
							Before: tmpBefore,
							After: { ItemIDTestSpecificationSet: tmpItemSetID, MaterialIDTestSpecificationSet: tmpMaterialSetID },
							SharedWithProjects: tmpSharedWith
						});
					if (tmpSharedWith.length > 0)
					{
						tmpAlignment.Warnings.push(`Contract ${tmpContract.Name || tmpContract.IDContract} is shared with ${tmpSharedWith.length} other project(s) (${tmpSharedWith.map((pProject) => pProject.IDProject).join(', ')}); changing its specification sets affects them too.`);
					}
				}
			}
		}

		let tmpLineItems = pInputs.DestLineItems || [];
		for (let i = 0; i < tmpLineItems.length; i++)
		{
			let tmpLineItem = tmpLineItems[i];
			let tmpPayItem = (tmpLineItem.IDPayItem > 0) ? pInputs.DestPayItemsByID[tmpLineItem.IDPayItem] : null;
			if (!tmpPayItem)
			{
				tmpAlignment.WithoutPayItemCount++;
				continue;
			}
			let tmpFromSetID = Number(tmpPayItem.IDTestSpecificationSet) || 0;
			if (tmpFromSetID === tmpItemSetID)
			{
				tmpAlignment.AlreadyAlignedCount++;
				continue;
			}

			tmpAlignment.Crossing = true;
			let tmpItemCode = tmpPayItem.ItemCode || tmpLineItem.ItemCode || '';
			let tmpCandidates = (tmpItemCode && pInputs.TargetPayItemsByItemCode[tmpItemCode]) || [];
			let tmpReason = '';
			if (tmpCandidates.length === 0)
			{
				tmpReason = `No pay item with item code ${tmpItemCode} in specification set ${tmpItemSetID}.`;
			}
			else if (tmpCandidates.length > 1)
			{
				tmpReason = `${tmpCandidates.length} pay items share item code ${tmpItemCode} in specification set ${tmpItemSetID}.`;
			}
			else if (!tmpLineItem.GUIDLineItem)
			{
				tmpReason = 'Line item has no stable identifier (GUID), so it cannot be updated.';
			}
			if (tmpReason)
			{
				tmpAlignment.Unmapped.push({ IDLineItem: tmpLineItem.IDLineItem, ItemCode: tmpLineItem.ItemCode || '', Name: tmpLineItem.Name || '', Reason: tmpReason });
				continue;
			}

			tmpAlignment.LineItemRemaps.push(
				{
					IDLineItem: tmpLineItem.IDLineItem,
					GUIDLineItem: tmpLineItem.GUIDLineItem,
					ItemCode: tmpItemCode,
					Name: tmpLineItem.Name || '',
					FromIDPayItem: tmpLineItem.IDPayItem,
					FromIDTestSpecificationSet: tmpFromSetID,
					ToIDPayItem: tmpCandidates[0].IDPayItem
				});
		}

		if (tmpAlignment.Unmapped.length > 0)
		{
			tmpAlignment.Warnings.push(`${tmpAlignment.Unmapped.length} destination line item(s) have no matching pay item in specification set ${tmpItemSetID} and will keep their current pay item.`);
		}

		return tmpAlignment;
	}

	/**
	 * Settle what a copy applies from an alignment plan. With the flip on the plan is kept as-is; with it off the
	 * crossing is still reported, but no Contract or LineItem change is planned.
	 *
	 * @param {SpecificationSetAlignment} pAlignment - The plan from `planSpecificationSetAlignment`.
	 * @param {boolean} pFlipTargetSpecificationSet - Whether the copy moves the destination onto the source's sets.
	 * @return {SpecificationSetAlignment} The alignment the copy applies, with `Flip` set.
	 */
	resolveSpecificationSetAlignment(pAlignment, pFlipTargetSpecificationSet)
	{
		if (pFlipTargetSpecificationSet)
		{
			return Object.assign({}, pAlignment, { Flip: true });
		}
		return Object.assign({}, pAlignment, { Flip: false, Contract: null, LineItemRemaps: [], Unmapped: [], Warnings: [] });
	}

	/**
	 * Turn an alignment plan into comprehension records. Both entities update existing rows, so
	 * they carry `_GUID<Entity>` (used verbatim) rather than `GUID<Entity>` (which gets prefixed
	 * and would insert a new row).
	 *
	 * @param {SpecificationSetAlignment} pAlignment - The plan.
	 * @return {{Contract?: Record<string, Record<string, any>>, LineItem?: Record<string, Record<string, any>>}} Comprehension entities; empty when nothing changes.
	 */
	buildSpecificationSetRealignmentRecords(pAlignment)
	{
		let tmpRecords = {};
		if (pAlignment.Contract)
		{
			tmpRecords.Contract = {};
			tmpRecords.Contract[pAlignment.Contract.GUIDContract] = (
				{
					_GUIDContract: pAlignment.Contract.GUIDContract,
					ItemIDTestSpecificationSet: pAlignment.Contract.After.ItemIDTestSpecificationSet,
					MaterialIDTestSpecificationSet: pAlignment.Contract.After.MaterialIDTestSpecificationSet
				});
		}
		if (pAlignment.LineItemRemaps.length > 0)
		{
			tmpRecords.LineItem = {};
			for (let i = 0; i < pAlignment.LineItemRemaps.length; i++)
			{
				let tmpRemap = pAlignment.LineItemRemaps[i];
				tmpRecords.LineItem[tmpRemap.GUIDLineItem] = { _GUIDLineItem: tmpRemap.GUIDLineItem, IDPayItem: tmpRemap.ToIDPayItem };
			}
		}
		return tmpRecords;
	}

	/**
	 * @typedef {object} SamplePlanCopyOptions
	 * @property {boolean} [FlipTargetSpecificationSet] - Also move the destination onto the source's specification sets
	 *   (Contract set columns and LineItem.IDPayItem). Off by default: the destination keeps its sets and only plan rows are copied.
	 */

	/**
	 * Build a sample plan comprehension by matching source project line items
	 * to destination project line items by ItemCode. The copy only adds and updates rows; it never removes any.
	 *
	 * @param {number} pSourceIDProject - Source (master) project IDProject.
	 * @param {number} pDestIDProject - Destination project IDProject.
	 * @param {SamplePlanCopyOptions|Function} pOptions - Copy options; may be omitted, in which case this is the callback.
	 * @param {Function} [fCallback] - Callback: (error, result) where result is { comprehension, reportData, warnings }.
	 */
	buildComprehension(pSourceIDProject, pDestIDProject, pOptions, fCallback)
	{
		if (typeof pOptions === 'function')
		{
			return this.buildComprehension(pSourceIDProject, pDestIDProject, {}, pOptions);
		}
		let tmpFlipTargetSpecificationSet = !!(pOptions && pOptions.FlipTargetSpecificationSet);

		let tmpSourceProject = {};
		let tmpDestProject = {};
		let tmpSourceContext = null;
		let tmpDestContext = null;
		let tmpPayItemsByID = {};
		let tmpSourceSets = null;
		let tmpDestSets = null;
		let tmpTargetPayItemsByItemCode = {};
		let tmpSetNames = {};
		let tmpSourceLineItems = [];
		let tmpSourceLineItemCount = 0;
		let tmpSourcePLIMTTotal = 0;
		let tmpSourcePLIMTs = [];
		let tmpSourceMLIJs = [];
		let tmpDestLineItems = [];
		let tmpDestExistingPLIMTCount = 0;
		let tmpDestExistingMLIJCount = 0;
		let tmpWarnings = [];

		this.log.info(`Sample Plan Comprehension Builder`);
		this.log.info(`  Source IDProject:      ${pSourceIDProject}`);
		this.log.info(`  Destination IDProject: ${pDestIDProject}`);
		this.log.info(`  Flip target specification set: ${tmpFlipTargetSpecificationSet ? 'yes' : 'no'}`);

		this.fable.Utility.waterfall(
			[
				// Stage 1: Fetch both projects and their contracts
				(fStageComplete) =>
				{
					this.log.info(`Fetching project records...`);
					this.getProjectContext(pSourceIDProject,
						(pError, pSourceContext) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source project`, pError);
								return fStageComplete(pError);
							}
							tmpSourceContext = pSourceContext;
							tmpSourceProject = pSourceContext.Project;
							this.log.info(`  Source:      [${tmpSourceProject.IDProject}] ${tmpSourceProject.Name || '(unnamed)'}`);

							this.getProjectContext(pDestIDProject,
								(pError2, pDestContext) =>
								{
									if (pError2)
									{
										this.log.error(`Error fetching destination project`, pError2);
										return fStageComplete(pError2);
									}
									tmpDestContext = pDestContext;
									tmpDestProject = pDestContext.Project;
									this.log.info(`  Destination: [${tmpDestProject.IDProject}] ${tmpDestProject.Name || '(unnamed)'}`);
									let tmpDestContract = tmpDestContext.Contract;
									if (tmpDestContract)
									{
										this.log.info(`  Destination contract [${tmpDestContract.IDContract}] item set ${tmpDestContract.ItemIDTestSpecificationSet}, material set ${tmpDestContract.MaterialIDTestSpecificationSet}, on ${tmpDestContext.ContractProjects.length} project(s)`);
									}
									return fStageComplete();
								});
						});
				},

				// Stage 2: Count all source line items (regardless of matching)
				(fStageComplete) =>
				{
					this.log.info(`Counting source project line items...`);
					this.restClient.getEntitySetCount('LineItem',
						`FBV~IDProject~EQ~${pSourceIDProject}~FBV~Deleted~EQ~0`,
						(pError, pResult) =>
						{
							if (pError)
							{
								this.log.error(`Error counting source line items`, pError);
								return fStageComplete(pError);
							}
							tmpSourceLineItemCount = (pResult && pResult.Count) ? pResult.Count : 0;
							this.log.info(`  Source project has ${tmpSourceLineItemCount} total line items.`);
							this.restClient.getEntitySetCount('ProjectLineItemMaterialTest',
								`FBV~IDProject~EQ~${pSourceIDProject}~FBV~Deleted~EQ~0`,
								(pPLIMTError, pPLIMTResult) =>
								{
									if (pPLIMTError)
									{
										this.log.error(`Error counting source PLIMTs`, pPLIMTError);
										return fStageComplete(pPLIMTError);
									}
									tmpSourcePLIMTTotal = (pPLIMTResult && pPLIMTResult.Count) ? pPLIMTResult.Count : 0;
									this.log.info(`  Source project has ${tmpSourcePLIMTTotal} sample plan tests.`);
									return fStageComplete();
								});
						});
				},

				// Stage 3: Fetch destination line items
				(fStageComplete) =>
				{
					this.log.info(`Fetching destination project line items...`);
					this.restClient.getEntitySet('LineItem',
						`FBV~IDProject~EQ~${pDestIDProject}~FBV~Deleted~EQ~0`,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching destination line items`, pError);
							}
							else
							{
								tmpDestLineItems = pRecords;
								this.log.info(`  Found ${tmpDestLineItems.length} destination line items.`);
							}
							return fStageComplete(pError);
						}, 0, 100000);
				},

				// Stage 4: Fetch matching source line items by ItemCode
				(fStageComplete) =>
				{
					this.log.info(`Fetching matching source project line items...`);
					let tmpDestItemCodes = {};
					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						if (tmpDestLineItems[i].ItemCode)
						{
							tmpDestItemCodes[tmpDestLineItems[i].ItemCode] = true;
						}
					}
					let tmpUniqueItemCodes = Object.keys(tmpDestItemCodes);
					this.log.info(`  Destination has ${tmpUniqueItemCodes.length} unique ItemCodes.`);

					if (tmpUniqueItemCodes.length === 0)
					{
						this.log.warn(`  No ItemCodes found in destination — nothing to match.`);
						return fStageComplete();
					}

					this.getEntitySetBatched('LineItem', 'ItemCode', tmpUniqueItemCodes,
						`FBV~IDProject~EQ~${pSourceIDProject}`,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source line items`, pError);
							}
							else
							{
								tmpSourceLineItems = pRecords;
								this.log.info(`  Found ${tmpSourceLineItems.length} matching source line items.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 5: Fetch source PLIMTs
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);

					if (tmpSourceLineItemIDs.length === 0)
					{
						this.log.warn(`No matching source line items — skipping PLIMT fetch.`);
						return fStageComplete();
					}

					this.log.info(`Fetching source ProjectLineItemMaterialTests for ${tmpSourceLineItemIDs.length} line items...`);
					this.getEntitySetBatched('ProjectLineItemMaterialTest', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source PLIMTs`, pError);
							}
							else
							{
								tmpSourcePLIMTs = pRecords;
								this.log.info(`  Found ${tmpSourcePLIMTs.length} source ProjectLineItemMaterialTests.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 6: Fetch source MaterialLineItemJoins
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);

					if (tmpSourceLineItemIDs.length === 0)
					{
						this.log.warn(`No matching source line items — skipping MLJ fetch.`);
						return fStageComplete();
					}

					this.log.info(`Fetching source MaterialLineItemJoins...`);
					this.getEntitySetBatched('MaterialLineItemJoin', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source MLIJs`, pError);
							}
							else
							{
								tmpSourceMLIJs = pRecords;
								this.log.info(`  Found ${tmpSourceMLIJs.length} source MaterialLineItemJoins.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 7: Check for existing sample plan data in destination
				(fStageComplete) =>
				{
					this.log.info(`Checking for existing sample plan data in destination...`);
					this.restClient.getEntitySetCount('ProjectLineItemMaterialTest',
						`FBV~IDProject~EQ~${pDestIDProject}~FBV~Deleted~EQ~0`,
						(pError, pResult) =>
						{
							if (pError)
							{
								this.log.error(`Error checking existing PLIMTs`, pError);
								return fStageComplete(pError);
							}

							let tmpExistingCount = (pResult && pResult.Count) ? pResult.Count : 0;
							tmpDestExistingPLIMTCount = tmpExistingCount;
							if (tmpExistingCount > 0)
							{
								let tmpMsg = `Destination project already has ${tmpExistingCount} sample plan tests. The copy adds to them and removes none, so they may duplicate the copied tests.`;
								this.log.warn(tmpMsg);
								tmpWarnings.push(tmpMsg);
							}
							else
							{
								this.log.info(`  No existing sample plan data in destination.`);
							}

							let tmpDestLineItemIDs = tmpDestLineItems.map((pLI) => pLI.IDLineItem);
							this.getEntitySetCountBatched('MaterialLineItemJoin', 'IDLineItem', tmpDestLineItemIDs, null,
								(pMLIJError, pMLIJCount) =>
								{
									if (pMLIJError)
									{
										let tmpMsg = `Could not check whether the destination line items already have materials assigned.`;
										this.log.warn(tmpMsg, pMLIJError);
										tmpWarnings.push(tmpMsg);
									}
									else if (pMLIJCount > 0)
									{
										tmpDestExistingMLIJCount = pMLIJCount;
										let tmpMsg = `Destination line items already have ${pMLIJCount} materials assigned.`;
										this.log.warn(tmpMsg);
										tmpWarnings.push(tmpMsg);
									}
									return fStageComplete();
								});
						});
				},

				// Stage 8: Resolve each project's specification sets
				(fStageComplete) =>
				{
					this.log.info(`Resolving specification sets...`);
					this.resolveProjectSpecificationSets(tmpSourceContext, SPECIFICATION_SET_LINE_ITEM_SAMPLE,
						(pSourceError, pSourceSets) =>
						{
							if (pSourceError)
							{
								this.log.error(`Error resolving the source project's specification sets`, pSourceError);
								return fStageComplete(pSourceError);
							}
							tmpSourceSets = pSourceSets;
							this.getPayItemsForLineItems(tmpDestLineItems,
								(pError, pPayItemsByID) =>
								{
									if (pError)
									{
										this.log.error(`Error fetching destination line item pay items`, pError);
										return fStageComplete(pError);
									}
									tmpPayItemsByID = pPayItemsByID;
									tmpDestSets = this.summarizeProjectSpecificationSets(tmpDestContext, tmpDestLineItems, tmpPayItemsByID);
									this.log.info(`  Source:      item set ${tmpSourceSets.ItemIDTestSpecificationSet}, material set ${tmpSourceSets.MaterialIDTestSpecificationSet} (from ${tmpSourceSets.Basis})`);
									this.log.info(`  Destination: item set ${tmpDestSets.ItemIDTestSpecificationSet}, material set ${tmpDestSets.MaterialIDTestSpecificationSet} (from ${tmpDestSets.Basis})`);
									if (tmpFlipTargetSpecificationSet && tmpSourceSets.PayItemSetMixed && (tmpSourceSets.Basis !== 'Contract'))
									{
										let tmpSetCounts = Object.keys(tmpSourceSets.PayItemSetDistribution).map((pID) => `set ${pID}: ${tmpSourceSets.PayItemSetDistribution[pID]}`).join(', ');
										let tmpMsg = `Source line items use pay items from more than one specification set (${tmpSetCounts}), so the destination will not be moved onto the source's sets.`;
										this.log.warn(tmpMsg);
										tmpWarnings.push(tmpMsg);
									}
									return fStageComplete();
								});
						});
				},

				// Stage 9: Fetch target-set pay items for destination line items on another set
				(fStageComplete) =>
				{
					let tmpTargetSetID = tmpSourceSets.ItemIDTestSpecificationSet;
					if (!tmpFlipTargetSpecificationSet || !(tmpTargetSetID > 0))
					{
						return fStageComplete();
					}

					let tmpItemCodes = {};
					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						let tmpPayItem = tmpPayItemsByID[tmpDestLineItems[i].IDPayItem];
						let tmpItemCode = tmpPayItem ? (tmpPayItem.ItemCode || tmpDestLineItems[i].ItemCode) : null;
						if (tmpItemCode && ((Number(tmpPayItem.IDTestSpecificationSet) || 0) !== tmpTargetSetID))
						{
							tmpItemCodes[tmpItemCode] = true;
						}
					}
					let tmpUniqueItemCodes = Object.keys(tmpItemCodes);
					if (tmpUniqueItemCodes.length === 0)
					{
						return fStageComplete();
					}

					this.log.info(`Fetching set ${tmpTargetSetID} pay items for ${tmpUniqueItemCodes.length} destination ItemCodes on another set...`);
					let tmpExtraFilter = `FBV~IDTestSpecificationSet~EQ~${tmpTargetSetID}`;
					if (tmpDestProject.IDCustomer > 0)
					{
						tmpExtraFilter += `~FBV~IDCustomer~EQ~${tmpDestProject.IDCustomer}`;
					}
					this.getEntitySetBatched('PayItem', 'ItemCode', tmpUniqueItemCodes, tmpExtraFilter,
						(pError, pPayItems) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching target-set pay items`, pError);
								return fStageComplete(pError);
							}
							for (let i = 0; i < pPayItems.length; i++)
							{
								let tmpItemCode = pPayItems[i].ItemCode;
								if (!tmpTargetPayItemsByItemCode[tmpItemCode])
								{
									tmpTargetPayItemsByItemCode[tmpItemCode] = [];
								}
								tmpTargetPayItemsByItemCode[tmpItemCode].push(pPayItems[i]);
							}
							return fStageComplete();
						});
				},

				// Stage 10: Name the specification sets involved
				(fStageComplete) =>
				{
					let tmpSetIDs = [
						tmpSourceSets.ItemIDTestSpecificationSet,
						tmpSourceSets.MaterialIDTestSpecificationSet,
						tmpDestSets.ItemIDTestSpecificationSet,
						tmpDestSets.MaterialIDTestSpecificationSet
					].concat(Object.keys(tmpDestSets.PayItemSetDistribution).map((pID) => parseInt(pID, 10)));
					this.getSpecificationSetNames(tmpSetIDs,
						(pError, pNames) =>
						{
							if (pError)
							{
								this.log.warn(`Could not fetch specification set names; IDs will be shown instead.`, pError);
							}
							tmpSetNames = pNames || {};
							return fStageComplete();
						});
				},

				// Stage 11: Build the comprehension and report data
				(fStageComplete) =>
				{
					this.log.info(`Building comprehension...`);
					this.log.info(`  Indexing source data...`);
					let tmpSourceIndex = this.indexLineItemsByItemCode(tmpSourceLineItems);
					let tmpSourceLineItemsByItemCode = tmpSourceIndex.ByItemCode;
					if (tmpSourceIndex.Warning)
					{
						this.log.warn(tmpSourceIndex.Warning);
						tmpWarnings.push(tmpSourceIndex.Warning);
					}

					let tmpSourcePLIMTsByIDLineItem = {};
					for (let i = 0; i < tmpSourcePLIMTs.length; i++)
					{
						let tmpPLIMT = tmpSourcePLIMTs[i];
						if (!tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem])
						{
							tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem] = [];
						}
						tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem].push(tmpPLIMT);
					}

					let tmpSourceMLIJsByIDLineItem = {};
					for (let i = 0; i < tmpSourceMLIJs.length; i++)
					{
						let tmpMLIJ = tmpSourceMLIJs[i];
						if (!tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem])
						{
							tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem] = [];
						}
						tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem].push(tmpMLIJ);
					}

					let tmpAlignment = this.resolveSpecificationSetAlignment(this.planSpecificationSetAlignment(
						{
							ItemIDTestSpecificationSet: tmpSourceSets.ItemIDTestSpecificationSet,
							MaterialIDTestSpecificationSet: tmpSourceSets.MaterialIDTestSpecificationSet,
							DestIDProject: pDestIDProject,
							DestContract: tmpDestContext.Contract,
							DestContractProjects: tmpDestContext.ContractProjects,
							DestLineItems: tmpDestLineItems,
							DestPayItemsByID: tmpPayItemsByID,
							TargetPayItemsByItemCode: tmpTargetPayItemsByItemCode
						}), tmpFlipTargetSpecificationSet);
					if (tmpAlignment.Crossing && tmpAlignment.Flip)
					{
						this.log.info(`  Specification set crossing: ${tmpAlignment.Contract ? 1 : 0} Contract update, ${tmpAlignment.LineItemRemaps.length} LineItem pay item remaps, ${tmpAlignment.Unmapped.length} unmapped, ${tmpAlignment.AlreadyAlignedCount} already aligned.`);
					}
					else if (tmpAlignment.Crossing)
					{
						tmpAlignment.Warnings.push(`The source is on specification set ${tmpSourceSets.ItemIDTestSpecificationSet} and the destination on ${tmpDestSets.ItemIDTestSpecificationSet || 'none'}. The destination keeps its specification sets and line item pay items; sample plan tests are copied onto its line items by item code.`);
					}
					for (let i = 0; i < tmpAlignment.Warnings.length; i++)
					{
						this.log.warn(tmpAlignment.Warnings[i]);
						tmpWarnings.push(tmpAlignment.Warnings[i]);
					}

					let tmpComprehension = Object.assign(this.buildSpecificationSetRealignmentRecords(tmpAlignment),
						{
							ProjectLineItemMaterialTest: {},
							MaterialLineItemJoin: {}
						});

					let tmpMatchedCount = 0;
					let tmpUnmatchedCount = 0;
					let tmpPLIMTRowCount = 0;
					let tmpMLIJCount = 0;
					let tmpSeenMLIJKeys = {};
					let tmpUsedSourceLineItemIDs = {};
					let tmpReportLineItems = [];

					this.log.info(`  Indexed ${Object.keys(tmpSourceLineItemsByItemCode).length} source ItemCodes, ${Object.keys(tmpSourcePLIMTsByIDLineItem).length} PLIMT groups, ${Object.keys(tmpSourceMLIJsByIDLineItem).length} MLJ groups.`);
					this.log.info(`Processing ${tmpDestLineItems.length} destination line items...`);

					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						let tmpDestLI = tmpDestLineItems[i];
						let tmpSourceLI = tmpSourceLineItemsByItemCode[tmpDestLI.ItemCode];

						if (!tmpSourceLI)
						{
							tmpUnmatchedCount++;
							tmpReportLineItems.push({
								itemCode: tmpDestLI.ItemCode || '',
								name: tmpDestLI.Name || '',
								units: tmpDestLI.Units || '',
								contractQuantity: tmpDestLI.ContractQuantity || 0,
								matched: false,
								plimtCount: 0,
								mljCount: 0,
								tests: []
							});
							continue;
						}

						tmpMatchedCount++;
						tmpUsedSourceLineItemIDs[tmpSourceLI.IDLineItem] = true;
						let tmpSourcePLIMTsForLI = tmpSourcePLIMTsByIDLineItem[tmpSourceLI.IDLineItem] || [];
						let tmpSourceMLIJsForLI = tmpSourceMLIJsByIDLineItem[tmpSourceLI.IDLineItem] || [];
						this.log.info(`  [${tmpMatchedCount}] ${tmpDestLI.ItemCode} (IDLineItem ${tmpDestLI.IDLineItem}) -> ${tmpSourcePLIMTsForLI.length} PLIMTs, ${tmpSourceMLIJsForLI.length} MLIJs`);

						let tmpTestDetails = [];

						// Copy PLIMTs for this line item
						for (let j = 0; j < tmpSourcePLIMTsForLI.length; j++)
						{
							let tmpSrc = tmpSourcePLIMTsForLI[j];
							let tmpCompositeKey = `${pDestIDProject}|${tmpDestLI.IDLineItem}|${tmpSrc.IDMaterial}|${tmpSrc.IDTest}|${tmpSrc.SampleType}`;
							let tmpGUID = this.generateGUID('MSP-PLIMT', tmpCompositeKey);

							tmpComprehension.ProjectLineItemMaterialTest[tmpGUID] = {
								GUIDProjectLineItemMaterialTest: tmpGUID,
								IDProject: pDestIDProject,
								IDLineItem: tmpDestLI.IDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								IDTest: tmpSrc.IDTest,
								IDLab: tmpSrc.IDLab || 0,
								Intent: tmpSrc.Intent || '',
								SampleType: tmpSrc.SampleType || '',
								SampleSize: tmpSrc.SampleSize || 0,
								SampleUnits: tmpSrc.SampleUnits || '',
								Rate: tmpSrc.Rate || 0,
								Frequency: tmpSrc.Frequency || 0,
								Units: tmpSrc.Units || '',
								TestDescription: tmpSrc.TestDescription || '',
								SampleDescription: tmpSrc.SampleDescription || '',
								SamplingInstructions: tmpSrc.SamplingInstructions || '',
								SamplingRequirements: tmpSrc.SamplingRequirements || '',
								SamplingPeriod: tmpSrc.SamplingPeriod || '',
								Remarks: tmpSrc.Remarks || '',
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								CertificateRequired: tmpSrc.CertificateRequired || 0,
								TestsNotRequired: tmpSrc.TestsNotRequired || 0,
								ErrorOmission: tmpSrc.ErrorOmission || 0,
								ErrorOmissionDetail: tmpSrc.ErrorOmissionDetail || '',
								ManualPlannedSampleCount: -1,
								ManualRequiredSampleCount: -1,
								ComputedPlannedSampleCount: 0,
								ComputedRequiredSampleCount: 0,
								CreatedSampleCount: 0,
								PassingSampleCount: 0,
								FailingSampleCount: 0,
								Deleted: 0
							};
							tmpPLIMTRowCount++;

							tmpTestDetails.push({
								testDescription: tmpSrc.TestDescription || '',
								sampleType: tmpSrc.SampleType || '',
								intent: tmpSrc.Intent || '',
								rate: tmpSrc.Rate || 0,
								frequency: tmpSrc.Frequency || 0,
								units: tmpSrc.Units || '',
								sampleSize: tmpSrc.SampleSize || 0,
								sampleUnits: tmpSrc.SampleUnits || '',
								remarks: tmpSrc.Remarks || ''
							});
						}

						// Copy MLIJs for this line item (deduplicate)
						let tmpLIMljCount = 0;
						for (let j = 0; j < tmpSourceMLIJsForLI.length; j++)
						{
							let tmpSrc = tmpSourceMLIJsForLI[j];
							let tmpMLIJKey = `${tmpDestLI.IDLineItem}|${tmpSrc.IDMaterial}`;

							if (tmpSeenMLIJKeys[tmpMLIJKey]) continue;
							tmpSeenMLIJKeys[tmpMLIJKey] = true;

							let tmpGUID = this.generateGUID('MSP-MLJ', tmpMLIJKey);

							tmpComprehension.MaterialLineItemJoin[tmpGUID] = {
								GUIDMaterialLineItemJoin: tmpGUID,
								IDLineItem: tmpDestLI.IDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								ApprovedSourceRequired: tmpSrc.ApprovedSourceRequired || 0,
								SpecialInstructions: tmpSrc.SpecialInstructions || '',
								Units: tmpSrc.Units || '',
								SampleRate: tmpSrc.SampleRate || 0,
								SampleFrequency: tmpSrc.SampleFrequency || 0,
								RequiredSampleCount: tmpSrc.RequiredSampleCount || 0,
								Quantity: tmpSrc.Quantity || 0,
								Deleted: 0
							};
							tmpMLIJCount++;
							tmpLIMljCount++;
						}

						tmpReportLineItems.push({
							itemCode: tmpDestLI.ItemCode || '',
							name: tmpDestLI.Name || '',
							units: tmpDestLI.Units || '',
							contractQuantity: tmpDestLI.ContractQuantity || 0,
							matched: true,
							plimtCount: tmpSourcePLIMTsForLI.length,
							mljCount: tmpLIMljCount,
							tests: tmpTestDetails
						});
					}

					let tmpPLIMTCount = Object.keys(tmpComprehension.ProjectLineItemMaterialTest).length;
					let tmpMappedSourcePLIMTCount = 0;
					for (let i = 0; i < tmpSourcePLIMTs.length; i++)
					{
						if (tmpUsedSourceLineItemIDs[tmpSourcePLIMTs[i].IDLineItem])
						{
							tmpMappedSourcePLIMTCount++;
						}
					}
					let tmpUnmappedSourcePLIMTCount = Math.max(0, tmpSourcePLIMTTotal - tmpMappedSourcePLIMTCount);
					let tmpCollapsedPLIMTCount = tmpPLIMTRowCount - tmpPLIMTCount;

					this.log.info(`=== Comprehension Built ===`);
					this.log.info(`  Source Line Items: ${tmpSourceLineItems.length}`);
					this.log.info(`  Destination Line Items: ${tmpDestLineItems.length}`);
					this.log.info(`  Matched Line Items: ${tmpMatchedCount}`);
					this.log.info(`  Unmatched Destination Line Items: ${tmpUnmatchedCount}`);
					this.log.info(`  Source ProjectLineItemMaterialTests: ${tmpSourcePLIMTTotal} (${tmpMappedSourcePLIMTCount} on matched line items, ${tmpUnmappedSourcePLIMTCount} unmapped)`);
					this.log.info(`  ProjectLineItemMaterialTest Records: ${tmpPLIMTCount}`);
					this.log.info(`  MaterialLineItemJoin Records: ${tmpMLIJCount}`);

					if (tmpUnmatchedCount > 0)
					{
						let tmpMsg = `${tmpUnmatchedCount} destination line items have no line item with the same item code in the source project.`;
						this.log.warn(tmpMsg);
						tmpWarnings.push(tmpMsg);
					}
					if (tmpUnmappedSourcePLIMTCount > 0)
					{
						let tmpMsg = `${tmpUnmappedSourcePLIMTCount} of the source's ${tmpSourcePLIMTTotal} sample plan tests are on line items whose item code the destination does not have (or repeats of an item code), so they are not copied.`;
						this.log.warn(tmpMsg);
						tmpWarnings.push(tmpMsg);
					}
					if (tmpCollapsedPLIMTCount > 0)
					{
						let tmpMsg = `${tmpCollapsedPLIMTCount} source sample plan tests repeat the same material, test and sample type on one line item, so each repeat is copied once.`;
						this.log.warn(tmpMsg);
						tmpWarnings.push(tmpMsg);
					}

					let tmpReportData = {
						sourceProject: tmpSourceProject,
						destProject: tmpDestProject,
						generatedDate: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }),
						stats: {
							sourceLineItemCount: tmpSourceLineItemCount,
							destLineItemCount: tmpDestLineItems.length,
							matched: tmpMatchedCount,
							unmatched: tmpUnmatchedCount,
							plimtCount: tmpPLIMTCount,
							mljCount: tmpMLIJCount,
							sourcePlimtCount: tmpSourcePLIMTTotal,
							mappedSourcePlimtCount: tmpMappedSourcePLIMTCount,
							unmappedSourcePlimtCount: tmpUnmappedSourcePLIMTCount,
							collapsedPlimtCount: tmpCollapsedPLIMTCount,
							destExistingPlimtCount: tmpDestExistingPLIMTCount,
							destExistingMljCount: tmpDestExistingMLIJCount,
							contractUpdateCount: tmpAlignment.Contract ? 1 : 0,
							lineItemRemapCount: tmpAlignment.LineItemRemaps.length,
							lineItemUnmappedCount: tmpAlignment.Unmapped.length
						},
						options: { FlipTargetSpecificationSet: tmpFlipTargetSpecificationSet },
						lineItems: tmpReportLineItems,
						specificationSets: {
							Source: tmpSourceSets,
							Dest: tmpDestSets,
							Names: tmpSetNames,
							Alignment: tmpAlignment
						}
					};

					return fStageComplete(null, { comprehension: tmpComprehension, reportData: tmpReportData, warnings: tmpWarnings });
				}
			],
			(pError, pResult) =>
			{
				if (pError)
				{
					this.log.error(`Sample plan comprehension build failed.`, pError);
				}
				return fCallback(pError, pResult);
			});
	}

	/**
	 * Look up a Project record by GUIDProject. Returns null (not an error) when not found,
	 * so the caller can use "missing" as a natural skip case.
	 *
	 * @param {string} pGUIDProject - The GUID to look up.
	 * @param {Function} fCallback - Callback: (error, project or null).
	 */
	lookupProjectByGUID(pGUIDProject, fCallback)
	{
		if (!pGUIDProject)
		{
			return fCallback(null, null);
		}
		let tmpFilter = `FBV~GUIDProject~EQ~${encodeURIComponent(pGUIDProject)}`;
		this.restClient.getEntitySet('Project', tmpFilter,
			(pError, pRecords) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				if (!pRecords || pRecords.length === 0)
				{
					return fCallback(null, null);
				}
				return fCallback(null, pRecords[0]);
			}, 0, 1);
	}

	/**
	 * Sibling of `buildComprehension` for the case where the destination project (and its
	 * LineItems) does NOT yet exist on the server — typically because it's about to be
	 * created in the same comprehension push the caller is assembling.
	 *
	 * Differences from `buildComprehension`:
	 *   - Source project is looked up by `GUIDProject` instead of an integer `IDProject`.
	 *   - Destination LineItems are passed in directly rather than fetched via REST.
	 *   - Output PLIMT / MLJ records use `GUIDProject` / `GUIDLineItem` FK refs (not integer IDs)
	 *     so the integration adapter resolves them at push time against the same comprehension.
	 *
	 * Returns `null` for `result` when the source GUID does not resolve, so callers can use
	 * "no master sample plan for this year, skip" as a natural pattern.
	 *
	 * @param {object} pOptions
	 * @param {string} pOptions.SourceGUIDProject - GUID of the source / master sample plan project (e.g. `HLICLI-P-L26-ProtoMSP`).
	 * @param {string} pOptions.DestGUIDProject - GUID of the destination project (used as the FK ref in output records).
	 * @param {Array<{GUIDLineItem: string, ItemCode: string}>} pOptions.DestLineItems - Destination line items from the in-flight comprehension. Each must carry at least `GUIDLineItem` and `ItemCode`.
	 * @param {string} [pOptions.GUIDPrefixPLIMT] - Prefix for generated PLIMT GUIDs. Defaults to `MSP-PLIMT`.
	 * @param {string} [pOptions.GUIDPrefixMLJ] - Prefix for generated MLJ GUIDs. Defaults to `MSP-MLJ`.
	 * @param {Function} fCallback - Callback: (error, result) where result is { comprehension, reportData, warnings } or null when the source project is not found.
	 */
	buildComprehensionFromLineItems(pOptions, fCallback)
	{
		let tmpOptions = pOptions || {};
		let tmpSourceGUIDProject = tmpOptions.SourceGUIDProject;
		let tmpDestGUIDProject = tmpOptions.DestGUIDProject;
		let tmpDestLineItems = Array.isArray(tmpOptions.DestLineItems) ? tmpOptions.DestLineItems : [];
		let tmpGUIDPrefixPLIMT = tmpOptions.GUIDPrefixPLIMT || 'MSP-PLIMT';
		let tmpGUIDPrefixMLJ = tmpOptions.GUIDPrefixMLJ || 'MSP-MLJ';

		if (!tmpSourceGUIDProject)
		{
			return fCallback(new Error('SourceGUIDProject is required.'));
		}
		if (!tmpDestGUIDProject)
		{
			return fCallback(new Error('DestGUIDProject is required.'));
		}

		let tmpSourceProject = null;
		let tmpSourceSets = null;
		let tmpSourceLineItems = [];
		let tmpSourceLineItemCount = 0;
		let tmpSourcePLIMTs = [];
		let tmpSourceMLIJs = [];
		let tmpWarnings = [];

		this.log.info(`Sample Plan Comprehension (in-flight dest) Builder`);
		this.log.info(`  Source GUIDProject:    ${tmpSourceGUIDProject}`);
		this.log.info(`  Dest GUIDProject:      ${tmpDestGUIDProject}`);
		this.log.info(`  Dest LineItems given:  ${tmpDestLineItems.length}`);

		this.fable.Utility.waterfall(
			[
				// Stage 1: Look up source project by GUID. Missing source = silent skip.
				(fStageComplete) =>
				{
					this.lookupProjectByGUID(tmpSourceGUIDProject,
						(pError, pRecord) =>
						{
							if (pError)
							{
								this.log.error(`Error looking up source project by GUID`, pError);
								return fStageComplete(pError);
							}
							if (!pRecord)
							{
								this.log.info(`  Source project [${tmpSourceGUIDProject}] not found — skipping sample plan section.`);
								return fStageComplete('SKIP');
							}
							tmpSourceProject = pRecord;
							this.log.info(`  Source resolved:       [${tmpSourceProject.IDProject}] ${tmpSourceProject.Name || '(unnamed)'}`);
							return fStageComplete();
						});
				},

				// Stage 2: Count source line items (stats only).
				(fStageComplete) =>
				{
					this.restClient.getEntitySetCount('LineItem',
						`FBV~IDProject~EQ~${tmpSourceProject.IDProject}~FBV~Deleted~EQ~0`,
						(pError, pResult) =>
						{
							if (pError)
							{
								this.log.error(`Error counting source line items`, pError);
								return fStageComplete(pError);
							}
							tmpSourceLineItemCount = (pResult && pResult.Count) ? pResult.Count : 0;
							this.log.info(`  Source project has ${tmpSourceLineItemCount} total line items.`);
							return fStageComplete();
						});
				},

				// Stage 3: Fetch matching source line items by ItemCode (only those that match dest).
				(fStageComplete) =>
				{
					let tmpDestItemCodes = {};
					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						if (tmpDestLineItems[i].ItemCode)
						{
							tmpDestItemCodes[tmpDestLineItems[i].ItemCode] = true;
						}
					}
					let tmpUniqueItemCodes = Object.keys(tmpDestItemCodes);
					this.log.info(`  Destination has ${tmpUniqueItemCodes.length} unique ItemCodes.`);

					if (tmpUniqueItemCodes.length === 0)
					{
						this.log.warn(`  No ItemCodes found in destination — nothing to match.`);
						return fStageComplete();
					}

					this.getEntitySetBatched('LineItem', 'ItemCode', tmpUniqueItemCodes,
						`FBV~IDProject~EQ~${tmpSourceProject.IDProject}`,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source line items`, pError);
							}
							else
							{
								tmpSourceLineItems = pRecords;
								this.log.info(`  Found ${tmpSourceLineItems.length} matching source line items.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 4: Fetch source PLIMTs.
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);
					if (tmpSourceLineItemIDs.length === 0) return fStageComplete();

					this.getEntitySetBatched('ProjectLineItemMaterialTest', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source PLIMTs`, pError);
							}
							else
							{
								tmpSourcePLIMTs = pRecords;
								this.log.info(`  Found ${tmpSourcePLIMTs.length} source ProjectLineItemMaterialTests.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 5: Fetch source MaterialLineItemJoins.
				(fStageComplete) =>
				{
					let tmpSourceLineItemIDs = tmpSourceLineItems.map((pLI) => pLI.IDLineItem);
					if (tmpSourceLineItemIDs.length === 0) return fStageComplete();

					this.getEntitySetBatched('MaterialLineItemJoin', 'IDLineItem', tmpSourceLineItemIDs, null,
						(pError, pRecords) =>
						{
							if (pError)
							{
								this.log.error(`Error fetching source MLIJs`, pError);
							}
							else
							{
								tmpSourceMLIJs = pRecords;
								this.log.info(`  Found ${tmpSourceMLIJs.length} source MaterialLineItemJoins.`);
							}
							return fStageComplete(pError);
						});
				},

				// Stage 6: Resolve the source's specification sets so the caller can check them against its contract.
				(fStageComplete) =>
				{
					this.getProjectContext(tmpSourceProject.IDProject,
						(pContextError, pContext) =>
						{
							if (pContextError)
							{
								this.log.warn(`Could not read the source project's contract; its specification sets are unknown.`, pContextError);
								return fStageComplete();
							}
							this.resolveProjectSpecificationSets(pContext, SPECIFICATION_SET_LINE_ITEM_SAMPLE,
								(pSetsError, pSets) =>
								{
									if (pSetsError)
									{
										this.log.warn(`Could not read the source project's line item pay items; its specification sets are unknown.`, pSetsError);
										return fStageComplete();
									}
									tmpSourceSets = pSets;
									return fStageComplete();
								});
						});
				},

				// Stage 7: Build the comprehension. Uses GUID refs (not IDs) for the dest FKs.
				(fStageComplete) =>
				{
					let tmpSourceIndex = this.indexLineItemsByItemCode(tmpSourceLineItems);
					let tmpSourceLineItemsByItemCode = tmpSourceIndex.ByItemCode;
					if (tmpSourceIndex.Warning)
					{
						this.log.warn(tmpSourceIndex.Warning);
						tmpWarnings.push(tmpSourceIndex.Warning);
					}

					let tmpSourcePLIMTsByIDLineItem = {};
					for (let i = 0; i < tmpSourcePLIMTs.length; i++)
					{
						let tmpPLIMT = tmpSourcePLIMTs[i];
						if (!tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem])
						{
							tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem] = [];
						}
						tmpSourcePLIMTsByIDLineItem[tmpPLIMT.IDLineItem].push(tmpPLIMT);
					}

					let tmpSourceMLIJsByIDLineItem = {};
					for (let i = 0; i < tmpSourceMLIJs.length; i++)
					{
						let tmpMLIJ = tmpSourceMLIJs[i];
						if (!tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem])
						{
							tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem] = [];
						}
						tmpSourceMLIJsByIDLineItem[tmpMLIJ.IDLineItem].push(tmpMLIJ);
					}

					let tmpComprehension = {
						ProjectLineItemMaterialTest: {},
						MaterialLineItemJoin: {}
					};

					let tmpMatchedCount = 0;
					let tmpUnmatchedCount = 0;
					let tmpPLIMTCount = 0;
					let tmpMLIJCount = 0;
					let tmpSeenMLIJKeys = {};

					for (let i = 0; i < tmpDestLineItems.length; i++)
					{
						let tmpDestLI = tmpDestLineItems[i];
						let tmpSourceLI = tmpSourceLineItemsByItemCode[tmpDestLI.ItemCode];

						if (!tmpSourceLI)
						{
							tmpUnmatchedCount++;
							continue;
						}

						tmpMatchedCount++;
						let tmpSourcePLIMTsForLI = tmpSourcePLIMTsByIDLineItem[tmpSourceLI.IDLineItem] || [];
						let tmpSourceMLIJsForLI = tmpSourceMLIJsByIDLineItem[tmpSourceLI.IDLineItem] || [];

						for (let j = 0; j < tmpSourcePLIMTsForLI.length; j++)
						{
							let tmpSrc = tmpSourcePLIMTsForLI[j];
							let tmpCompositeKey = `${tmpDestGUIDProject}|${tmpDestLI.GUIDLineItem}|${tmpSrc.IDMaterial}|${tmpSrc.IDTest}|${tmpSrc.SampleType}`;
							let tmpGUID = this.generateGUID(tmpGUIDPrefixPLIMT, tmpCompositeKey);

							tmpComprehension.ProjectLineItemMaterialTest[tmpGUID] = {
								GUIDProjectLineItemMaterialTest: tmpGUID,
								GUIDProject: tmpDestGUIDProject,
								GUIDLineItem: tmpDestLI.GUIDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								IDTest: tmpSrc.IDTest,
								IDLab: tmpSrc.IDLab || 0,
								Intent: tmpSrc.Intent || '',
								SampleType: tmpSrc.SampleType || '',
								SampleSize: tmpSrc.SampleSize || 0,
								SampleUnits: tmpSrc.SampleUnits || '',
								Rate: tmpSrc.Rate || 0,
								Frequency: tmpSrc.Frequency || 0,
								Units: tmpSrc.Units || '',
								TestDescription: tmpSrc.TestDescription || '',
								SampleDescription: tmpSrc.SampleDescription || '',
								SamplingInstructions: tmpSrc.SamplingInstructions || '',
								SamplingRequirements: tmpSrc.SamplingRequirements || '',
								SamplingPeriod: tmpSrc.SamplingPeriod || '',
								Remarks: tmpSrc.Remarks || '',
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								CertificateRequired: tmpSrc.CertificateRequired || 0,
								TestsNotRequired: tmpSrc.TestsNotRequired || 0,
								ErrorOmission: tmpSrc.ErrorOmission || 0,
								ErrorOmissionDetail: tmpSrc.ErrorOmissionDetail || '',
								ManualPlannedSampleCount: -1,
								ManualRequiredSampleCount: -1,
								ComputedPlannedSampleCount: 0,
								ComputedRequiredSampleCount: 0,
								CreatedSampleCount: 0,
								PassingSampleCount: 0,
								FailingSampleCount: 0,
								Deleted: 0
							};
							tmpPLIMTCount++;
						}

						for (let j = 0; j < tmpSourceMLIJsForLI.length; j++)
						{
							let tmpSrc = tmpSourceMLIJsForLI[j];
							let tmpMLIJKey = `${tmpDestLI.GUIDLineItem}|${tmpSrc.IDMaterial}`;

							if (tmpSeenMLIJKeys[tmpMLIJKey]) continue;
							tmpSeenMLIJKeys[tmpMLIJKey] = true;

							let tmpGUID = this.generateGUID(tmpGUIDPrefixMLJ, tmpMLIJKey);

							tmpComprehension.MaterialLineItemJoin[tmpGUID] = {
								GUIDMaterialLineItemJoin: tmpGUID,
								GUIDLineItem: tmpDestLI.GUIDLineItem,
								IDMaterial: tmpSrc.IDMaterial,
								ConversionFactor: tmpSrc.ConversionFactor || 1,
								ApprovedSourceRequired: tmpSrc.ApprovedSourceRequired || 0,
								SpecialInstructions: tmpSrc.SpecialInstructions || '',
								Units: tmpSrc.Units || '',
								SampleRate: tmpSrc.SampleRate || 0,
								SampleFrequency: tmpSrc.SampleFrequency || 0,
								RequiredSampleCount: tmpSrc.RequiredSampleCount || 0,
								Quantity: tmpSrc.Quantity || 0,
								Deleted: 0
							};
							tmpMLIJCount++;
						}
					}

					this.log.info(`=== Comprehension (in-flight dest) Built ===`);
					this.log.info(`  Matched / Unmatched dest LineItems: ${tmpMatchedCount} / ${tmpUnmatchedCount}`);
					this.log.info(`  PLIMT: ${tmpPLIMTCount}, MLJ: ${tmpMLIJCount}`);

					if (tmpUnmatchedCount > 0)
					{
						tmpWarnings.push(`${tmpUnmatchedCount} destination line items have no line item with the same item code in source [${tmpSourceGUIDProject}].`);
					}

					let tmpReportData = {
						sourceProject: tmpSourceProject,
						destGUIDProject: tmpDestGUIDProject,
						specificationSets: { Source: tmpSourceSets },
						stats: {
							sourceLineItemCount: tmpSourceLineItemCount,
							destLineItemCount: tmpDestLineItems.length,
							matched: tmpMatchedCount,
							unmatched: tmpUnmatchedCount,
							plimtCount: tmpPLIMTCount,
							mljCount: tmpMLIJCount
						}
					};

					return fStageComplete(null, { comprehension: tmpComprehension, reportData: tmpReportData, warnings: tmpWarnings });
				}
			],
			(pError, pResult) =>
			{
				// Sentinel "SKIP" means the source project didn't exist — surface null result, not an error.
				if (pError === 'SKIP')
				{
					return fCallback(null, null);
				}
				if (pError)
				{
					this.log.error(`Sample plan (in-flight dest) comprehension build failed.`, pError);
				}
				return fCallback(pError, pResult);
			});
	}

	/**
	 * @typedef {object} SamplePlanEntityLoadResult
	 * @property {string} Entity - The Meadow entity.
	 * @property {number} Sent - Records in the comprehension.
	 * @property {number} Succeeded - Records the server accepted.
	 * @property {number} Failed - Records that failed to marshal or were refused by the server.
	 * @property {string} Status - 'Loaded', 'Errors', or 'Not attempted' when an earlier entity failed.
	 */

	/**
	 * Load a sample plan comprehension into the destination project via the Headlight Integration
	 * Adapter (batch upserts with retry). Entities load in order -- Contract, LineItem,
	 * ProjectLineItemMaterialTest, MaterialLineItemJoin -- and a failed entity stops the ones after it.
	 *
	 * @param {Record<string, Record<string, any>>} pComprehension - Output of `buildComprehension` or `buildComprehensionFromLineItems`.
	 * @param {(pError?: any, pResult?: {entities: Array<SamplePlanEntityLoadResult>}) => void} fCallback - Callback.
	 */
	loadComprehension(pComprehension, fCallback)
	{
		let tmpEntityPlan = [
			{ Entity: 'Contract' },
			{ Entity: 'LineItem' },
			{ Entity: 'ProjectLineItemMaterialTest', EntityGUIDMarshalPrefix: 'MSP-PLIMT' },
			{ Entity: 'MaterialLineItemJoin', EntityGUIDMarshalPrefix: 'MSP-MLJ' }
		];

		// Register the IntegrationAdapter service type if not already registered
		if (!this.fable.servicesMap.IntegrationAdapter)
		{
			this.fable.addServiceType('IntegrationAdapter', libIntegrationAdapter);
		}

		let tmpAdapterOptions = {
			ForceMarshal: true,
			PerformDeletes: false,
			AllowGUIDTruncation: true,
		};

		let tmpResults = [];
		let tmpStages = [];
		for (let i = 0; i < tmpEntityPlan.length; i++)
		{
			let tmpPlan = tmpEntityPlan[i];
			let tmpRecords = pComprehension[tmpPlan.Entity] || {};
			let tmpKeys = Object.keys(tmpRecords);
			if (tmpKeys.length === 0)
			{
				continue;
			}

			let tmpResult = { Entity: tmpPlan.Entity, Sent: tmpKeys.length, Succeeded: 0, Failed: 0, Status: 'Not attempted' };
			tmpResults.push(tmpResult);
			tmpStages.push(
				(fStageComplete) =>
				{
					// Create fresh adapter instances each load (not cached via getAdapter)
					// so that source/marshaled record buffers are clean between runs.
					let tmpAdapter = this.fable.instantiateServiceProviderWithoutRegistration('IntegrationAdapter', Object.assign({}, tmpAdapterOptions, tmpPlan));
					for (let j = 0; j < tmpKeys.length; j++)
					{
						tmpAdapter.addSourceRecord(tmpRecords[tmpKeys[j]]);
					}

					this.log.info(`Integrating ${tmpKeys.length} ${tmpPlan.Entity} records...`);
					tmpAdapter.integrateRecords(
						(pError) =>
						{
							let tmpLanded = Object.keys(tmpAdapter._MarshaledRecords).length - tmpAdapter.RecordPushFailures.length;
							tmpResult.Succeeded = Math.max(0, tmpLanded);
							tmpResult.Failed = tmpResult.Sent - tmpResult.Succeeded;
							tmpResult.Status = (pError || (tmpResult.Failed > 0)) ? 'Errors' : 'Loaded';
							if (pError)
							{
								this.log.error(`Error integrating ${tmpPlan.Entity} records`, pError);
							}
							return fStageComplete(pError);
						});
				});
		}

		this.log.info(`Loading comprehension via Integration Adapter: ${tmpResults.map((pResult) => `${pResult.Sent} ${pResult.Entity}`).join(', ')}`);
		if (tmpStages.length === 0)
		{
			return fCallback(null, { entities: tmpResults });
		}

		this.fable.Utility.waterfall(tmpStages,
			(pError) =>
			{
				this.log.info(`=== Comprehension Load Complete ===`);
				for (let i = 0; i < tmpResults.length; i++)
				{
					this.log.info(`  ${tmpResults[i].Entity}: ${tmpResults[i].Succeeded} of ${tmpResults[i].Sent} succeeded, ${tmpResults[i].Failed} failed (${tmpResults[i].Status})`);
				}
				return fCallback(pError, { entities: tmpResults });
			});
	}
}

module.exports = SamplePlanService;

module.exports.default_configuration = {
	Name: 'SamplePlanService'
};

module.exports.INN_VALUE_CHARACTER_BUDGET = INN_VALUE_CHARACTER_BUDGET;

},{"crypto":393,"fable-serviceproviderbase":438,"headlight-integration-adapter":8}],12:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libCrypto = require('crypto');
const libAsync = require('async');

const DEFAULT_GUID_PREFIX = 'PCL';

// Per-entity cloning recipe.
//   `KeyFields`         — natural-key columns combined with the destination
//                         project identity to produce a deterministic upsert GUID.
//                         Also used to skip source rows whose natural key
//                         already exists in dest.
//   `CopyFields`        — pass-through values read straight from the source row.
//   `InheritFromDestProject`
//                       — columns stamped from the destination project record
//                         (IDCustomer, IDOrganization, IDProgram, …) so cloned
//                         rows live in the right tenant / org / program slice.
//                         In auto-create mode the "destination project record"
//                         is the source project (since the new dest project
//                         inherits customer / org / program from source).
//                         NOTE: `IDContract` is NOT in this list — contract
//                         resolution is per-call (see `RefContract`).
//   `RefContract`       — when true, the cloned record gets `IDContract` or
//                         `GUIDContract` stamped onto it from the per-call
//                         contract-ref, based on which contract-clone mode
//                         the run is in.
//   `GUIDFKs`           — cross-entity GUID-FK refs. Key is the field name to
//                         emit on the clone record (e.g. `GUIDBidItem`); value
//                         is `{ entity, sourceField }` describing which other
//                         cloned entity to look up and which source-row column
//                         supplies its source ID. The IntegrationAdapter resolves
//                         `GUID<Entity>` -> `ID<Entity>` at push time via the
//                         in-call HeadlightGUIDMap.
//   `DefaultMaxRecords` — soft cap on how many source rows to fetch. Heavy
//                         entities (Observation, Document) default to 5000; the
//                         caller can override per-entity via `pOptions.MaxRecords`.
//                         Unset = no cap. When the source-row count exceeds the
//                         cap, the slice emits a warning naming the entity, the
//                         total, and how many were skipped.
//   `OnlyEmitIfReferencedClonesPresent`
//                       — when true (e.g. DocumentObservationJoin), drop emitted
//                         rows whose source-FK targets aren't in the clone set
//                         (the referenced Document or Observation was capped out
//                         or excluded). Prevents orphan join rows.
//   `PostBuild`         — optional `(record, sourceRow, recipe) => void` hook
//                         called after a clone record is built but before it's
//                         bucketed. Lets recipes flip flags the API expects to
//                         see on the cloned body — e.g. `Labels.SAVE = true` so
//                         Observation's storeLabels hook materializes the tags.
//
// Order in this array IS the push order — entities must appear after anything
// they reference via GUIDFKs.
const CLONED_ENTITIES = [
	{
		Entity: 'BidItem',
		Prefix: 'PCL-BI',
		// Source IDBidItem is the most stable per-source-project identifier; using
		// it for the natural key means a re-clone targeting the same dest project
		// upserts in place rather than duplicating, while two source BidItems with
		// the same Name don't collapse into one dest row.
		KeyFields: ['IDBidItem'],
		CopyFields: ['ExternalSyncDate', 'Name', 'Description', 'Quantity', 'Units', 'CostPerUnit'],
		InheritFromDestProject: { IDCustomer: 'IDCustomer', IDOrganization: 'IDOrganization' },
		RefContract: true,
		GUIDFKs: {},
	},
	{
		Entity: 'LineItem',
		Prefix: 'PCL-LI',
		KeyFields: ['IDLineItem'],
		// Drop IDPayItem, IDFundingCategory, ParentIDLineItem — they reference
		// entities not in the clone surface, so copying source integer IDs would
		// leak cross-project refs. IDBidItem is bridged via GUIDFKs below.
		CopyFields: [
			'ExternalSyncDate', 'Name', 'Description', 'Notes', 'Units',
			'SpecificationYear', 'ItemCode', 'ItemNumber', 'CostPerUnit',
			'ExpectedQuantity', 'ContractorReportedQuantity', 'ActualQuantity',
			'ContractQuantity', 'InstalledQuantity', 'ChangeOrderQuantity',
			'ChangeOrderQuantityPending', 'Tax', 'ChangeOrderNumber',
			'FundingCategory', 'Status', 'ProposalIdentifier', 'PercentComplete',
			'CategoryNumber', 'Retainage', 'ImprovementType', 'DeliveryDate',
			'FHWAEligible',
		],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		RefContract: true,
		GUIDFKs:
		{
			GUIDBidItem: { entity: 'BidItem', sourceField: 'IDBidItem' },
		},
	},
	{
		Entity: 'ReportNamedInstanceProjectJoin',
		Prefix: 'PCL-RNIPJ',
		KeyFields: ['IDReportNamedInstance'],
		CopyFields: ['IDReportNamedInstance', 'Ordinal'],
		InheritFromDestProject: { IDProgram: 'IDProgram', IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
	},
	{
		Entity: 'ObservationTagProjectJoin',
		Prefix: 'PCL-OTPJ',
		KeyFields: ['IDObservationTag'],
		CopyFields: ['IDObservationTag', 'Tag', 'TagType'],
		InheritFromDestProject: { IDOrganization: 'IDOrganization', IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
	},
	{
		Entity: 'ProjectTagType',
		Prefix: 'PCL-PTT',
		KeyFields: ['TagType', 'Name'],
		CopyFields: ['TagType', 'Name', 'Ordinal'],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
	},
	{
		Entity: 'ProjectDate',
		Prefix: 'PCL-PD',
		// Hash is the dedup key the platform already maintains for ProjectDate;
		// fall back to Name|Date when a source row has no Hash so we still get
		// a stable composite key per logical date.
		KeyFields: ['Hash', 'Name', 'Date'],
		CopyFields: ['Name', 'Date', 'Hash'],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
	},
	{
		// Observation types enabled on the project. The manifest name is the
		// stable per-project identifier; the manifest content itself lives in
		// ObservationManifest and is referenced by name, so only the join is cloned.
		Entity: 'ProjectObservationManifestJoin',
		Prefix: 'PCL-POMJ',
		KeyFields: ['ObservationManifestName'],
		CopyFields: ['ObservationManifestName', 'Priority', 'Ordinal', 'Spreadsheet', 'Journal'],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
	},
	{
		// Equipment on the project. Equipment is a customer master list, so only the
		// join is cloned; (IDProject, IDEquipment, IDOrganization) is unique, with
		// IDOrganization 0 for project-level equipment. Equipment labels are derived
		// from these rows by RebuildTags/Equipment, not cloned.
		Entity: 'ProjectEquipmentJoin',
		Prefix: 'PCL-PEJ',
		KeyFields: ['IDEquipment', 'IDOrganization'],
		CopyFields: ['IDEquipment', 'IDOrganization'],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
	},
	{
		// Observation rows themselves. Heavy entity — capped at 5000 by default.
		// `Labels` rides along verbatim; the slice sets `Labels.SAVE = true` via
		// the PostBuild hook so the API's storeLabels hook ([Observations.ts])
		// materializes the ObservationTagJoin rows on insert. Line-item label
		// semantics: Tag values are strings (e.g. ItemCode) which carry verbatim
		// because LineItems retain ItemCode across the clone.
		Entity: 'Observation',
		Prefix: 'PCL-OBS',
		KeyFields: ['IDObservation'],
		CopyFields: [
			'ExternalSyncDate', 'ExternalSyncGUID',
			'Name', 'Description',
			'ObservationType', 'Status', 'Priority', 'Version',
			'CaptureLatitude', 'CaptureLongitude', 'UserLatitude', 'UserLongitude',
			'IDDevice', 'AlignmentStation', 'AlignmentOffset',
			'AppHash', 'StateName', 'StateStep', 'Locked', 'Transcoded',
			// Labels is the auto-materialized array; carry it verbatim and let
			// the PostBuild hook flip SAVE=true so the server materializes the
			// ObservationTagJoin rows.
			'Labels',
		],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
		DefaultMaxRecords: 5000,
		PostBuild: (pRecord) =>
		{
			// The server's fetchLabels stamps Labels.SAVE = false on reads (so
			// round-tripping a record doesn't accidentally rewrite tags). For a
			// real clone we DO want them written, so flip the flag.
			if (pRecord.Labels && typeof(pRecord.Labels) === 'object')
			{
				pRecord.Labels.SAVE = true;
			}
		},
	},
	{
		// Document rows. Heavy entity — capped at 5000 by default. We deliberately
		// strip the auto-populated `Observations` integer array (CopyFields below
		// does not include it). If we let it carry, the server's updateObservations
		// hook would materialize DocumentObservationJoin rows from the SOURCE
		// IDObservation integers — a cross-project leak. The explicit
		// DocumentObservationJoin recipe below replaces that path.
		Entity: 'Document',
		Prefix: 'PCL-DOC',
		KeyFields: ['IDDocument'],
		CopyFields: [
			'ExternalSyncDate', 'ExternalSyncGUID',
			'Name', 'Description',
			'DocumentType', 'DocumentDate', 'Status', 'Version',
			'AppHash', 'Form',
			// FormData / EntityData ARE the document body — clone verbatim.
			// The schema columns are `FormData` and `EntityData` (objects);
			// the *JSON-suffix names only appear in legacy payloads. POSTing
			// either name lands in the non-suffix field; reads back via
			// getEntitySet expose only the non-suffix names, so the suffix
			// variants would never actually be copied across.
			'FormData', 'EntityData',
			'SequenceNumber', 'StateName', 'StateStep', 'Locked',
			'Timezone', 'Shift',
		],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs: {},
		DefaultMaxRecords: 5000,
	},
	{
		// Explicit document↔observation join. Pure GUID-FK chain — the
		// IntegrationAdapter resolves GUIDDocument / GUIDObservation to integer
		// IDs at push time via the in-call HeadlightGUIDMap. Composite natural
		// key keeps the deterministic GUID idempotent across re-clones.
		// `OnlyEmitIfReferencedClonesPresent` drops join rows whose Document or
		// Observation was capped out of the clone set, avoiding orphans.
		Entity: 'DocumentObservationJoin',
		Prefix: 'PCL-DOJ',
		KeyFields: ['IDDocument', 'IDObservation'],
		CopyFields: [],
		InheritFromDestProject: { IDCustomer: 'IDCustomer' },
		GUIDFKs:
		{
			GUIDDocument: { entity: 'Document', sourceField: 'IDDocument' },
			GUIDObservation: { entity: 'Observation', sourceField: 'IDObservation' },
		},
		// DocumentObservationJoin has no IDProject column, so we can't fetch
		// source rows with `FBV~IDProject~EQ~<id>` like every other recipe.
		// `SourceScope` tells _cloneEntity to look up the join rows by
		// `IDDocument INN (<source Document IDs cloned earlier>)` instead —
		// same pattern the sample-plan slice uses for MaterialLineItemJoin.
		// The ParentEntity must appear before this recipe in CLONED_ENTITIES
		// so its cloneIndex is populated by the time we get here.
		SourceScope: { ParentEntity: 'Document', FK: 'IDDocument' },
		OnlyEmitIfReferencedClonesPresent: true,
		// DOJ schema has no IDProject column — stamping pProjectRef would
		// make the DAL reject every insert with "Unknown column 'IDProject'".
		NoProjectRef: true,
	},
];

const SAMPLE_PLAN_ENTITIES = ['ProjectLineItemMaterialTest', 'MaterialLineItemJoin'];

// Fields cloned from the source Project row into a brand-new destination project.
// IDProjectType is intentionally on this list AND on UPDATE_EXISTING's partial
// update — the rule is "always apply source IDProjectType to the destination
// project, whether new or existing."
const PROJECT_CLONE_COPY_FIELDS = [
	'IDProjectType', 'IDCustomer', 'IDOrganization',
	'Timezone', 'Status', 'ImprovementTypeCode',
];

// Fields cloned from the source Contract row into either a new contract row
// (NEW_LINKED mode) or upserted into the destination project's existing
// contract (UPSERT_INTO_DEST mode). IDCustomer / IDOrganization scope the
// row to the right tenant.
const CONTRACT_CLONE_COPY_FIELDS = [
	'Status', 'DBEStructure',
	'ItemSpecificationYear', 'MaterialsSpecificationYear',
	'ItemIDTestSpecificationSet', 'MaterialIDTestSpecificationSet',
	'IDOrganization', 'IDCustomer', 'IDContractType',
];

class ProjectCloningAdapter extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ProjectCloningAdapter';

		/**
		 * Concierge clients built by _buildConciergeClient, keyed by IDCustomer —
		 * one elevated-login + impersonation handshake per customer per adapter
		 * instance, retired together via retireConciergeClients.
		 * @type {Object<number, *>}
		 */
		this._ConciergeClients = {};
	}

	/** @returns {*} HeadlightRestClient registered on the fable by the caller. */
	get restClient()
	{
		return this.fable.HeadlightRestClient;
	}

	/**
	 * Deterministic GUID: `{prefix}-{md5(compositeKey).slice(0,12)}`.
	 * Same composite key → same GUID → idempotent upsert via the Integration Adapter.
	 *
	 * @param {string} pPrefix
	 * @param {string} pCompositeKey
	 * @returns {string}
	 */
	generateGUID(pPrefix, pCompositeKey)
	{
		const tmpHash = libCrypto.createHash('md5').update(pCompositeKey).digest('hex').substring(0, 12);
		return `${pPrefix}-${tmpHash}`;
	}

	/**
	 * Parse a value that is expected to be a JSON array (e.g. EmailRule.Projects,
	 * a TEXT column holding `[123,456]`). Tolerates an already-parsed array, and
	 * null / blank / malformed input by returning an empty array — mirroring the
	 * email service's own defensive reads of these fields.
	 *
	 * @param {*} pValue
	 * @returns {Array}
	 */
	_parseJSONArray(pValue)
	{
		if (Array.isArray(pValue)) return pValue;
		if (typeof(pValue) !== 'string' || pValue.trim().length === 0) return [];
		try
		{
			const tmpParsed = JSON.parse(pValue);
			return Array.isArray(tmpParsed) ? tmpParsed : [];
		}
		catch (pError)
		{
			return [];
		}
	}

	/**
	 * Batched INN filter to avoid URL length limits on large id lists.
	 *
	 * @param {string} pEntityType
	 * @param {string} pFilterField
	 * @param {Array} pIDs
	 * @param {string|null} pExtraFilter
	 * @param {function(Error|null, Array=)} fCallback
	 */
	getEntitySetBatched(pEntityType, pFilterField, pIDs, pExtraFilter, fCallback)
	{
		if (!pIDs || pIDs.length === 0)
		{
			return fCallback(null, []);
		}

		const tmpBatchSize = 50;
		const tmpBatches = [];
		for (let i = 0; i < pIDs.length; i += tmpBatchSize)
		{
			tmpBatches.push(pIDs.slice(i, i + tmpBatchSize));
		}

		let tmpAllRecords = [];
		let tmpBatchIndex = 0;
		const tmpProcessBatch = () =>
		{
			if (tmpBatchIndex >= tmpBatches.length)
			{
				return fCallback(null, tmpAllRecords);
			}
			// Do not include `Deleted~EQ~0` — the API backplane adds it automatically
			// for entities that have a Deleted column, and including it for entities
			// that don't (e.g. ReportNamedInstanceProjectJoin) causes the request to fail.
			let tmpFilter = `FBL~${pFilterField}~INN~${tmpBatches[tmpBatchIndex].join(',')}`;
			if (pExtraFilter)
			{
				tmpFilter += `~${pExtraFilter}`;
			}
			// Per-batch progress: each batch is a Count + N download requests round-tripped
			// through the rest client, so for large IDs lists this can take a while.
			// Without this line the caller sees nothing between the "Building …" header
			// and the final per-entity count.
			if (tmpBatches.length > 1)
			{
				this.log.info(`    ${pEntityType}: fetching batch ${tmpBatchIndex + 1}/${tmpBatches.length} (${tmpBatches[tmpBatchIndex].length} ${pFilterField} ids, ${tmpAllRecords.length} records so far)`);
			}
			this.restClient.getEntitySet(pEntityType, tmpFilter,
				(pError, pRecords) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					tmpAllRecords = tmpAllRecords.concat(pRecords || []);
					tmpBatchIndex++;
					tmpProcessBatch();
				}, 0, 200000);
		};
		tmpProcessBatch();
	}

	/**
	 * Fetch rows of pEntity in pIDProject. Convenience wrapper around restClient.getEntitySet.
	 *
	 * @param {string} pEntity
	 * @param {number} pIDProject
	 * @param {number} pMaxRecords - record cap. Pass 0 / negative to use the default (200000).
	 * @param {function(Error|null, Array=)} fCallback
	 */
	getEntityRowsForProject(pEntity, pIDProject, pMaxRecords, fCallback)
	{
		const tmpLimit = (Number.isInteger(pMaxRecords) && pMaxRecords > 0) ? pMaxRecords : 200000;
		// `Deleted~EQ~0` is added by the API backplane for entities that have a
		// Deleted column; appending it here breaks entities that don't (e.g.
		// ReportNamedInstanceProjectJoin).
		const tmpFilter = `FBV~IDProject~EQ~${pIDProject}`;
		this.restClient.getEntitySet(pEntity, tmpFilter, fCallback, 0, tmpLimit);
	}

	/**
	 * Count rows of pEntity in pIDProject. Used to precheck whether a per-entity
	 * cap will fire, so we can surface a warning naming how many rows were skipped.
	 *
	 * @param {string} pEntity
	 * @param {number} pIDProject
	 * @param {function(Error|null, number=)} fCallback
	 */
	getEntityCountForProject(pEntity, pIDProject, fCallback)
	{
		// Defensive: not every HeadlightRestClient variant (or test stub) exposes
		// getEntitySetCount. If it's missing, fall back to "unknown" — the caller
		// can still proceed with a capped fetch and emit a "may have hit the cap"
		// warning, just without an exact skipped-row count.
		if (typeof(this.restClient.getEntitySetCount) !== 'function')
		{
			return fCallback(null, null);
		}
		const tmpFilter = `FBV~IDProject~EQ~${pIDProject}`;
		this.restClient.getEntitySetCount(pEntity, tmpFilter,
			(pError, pBody) =>
			{
				if (pError) return fCallback(pError);
				const tmpCount = (pBody && typeof(pBody.Count) === 'number') ? pBody.Count : 0;
				return fCallback(null, tmpCount);
			});
	}

	/**
	 * Lookup a Project by IDProject. Errors if not found.
	 *
	 * @param {number} pIDProject
	 * @param {function(Error|null, object=)} fCallback
	 */
	lookupProjectByID(pIDProject, fCallback)
	{
		this.restClient.getEntity('Project', pIDProject,
			(pError, pRecord) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				if (!pRecord || !pRecord.IDProject)
				{
					return fCallback(new Error(`Project [${pIDProject}] not found.`));
				}
				return fCallback(null, pRecord);
			});
	}

	/**
	 * Lookup a Contract by IDContract. Returns null (not error) when not found.
	 *
	 * @param {number} pIDContract
	 * @param {function(Error|null, object|null=)} fCallback
	 */
	lookupContractByID(pIDContract, fCallback)
	{
		if (!pIDContract || pIDContract <= 0)
		{
			return fCallback(null, null);
		}
		this.restClient.getEntity('Contract', pIDContract,
			(pError, pRecord) =>
			{
				if (pError)
				{
					return fCallback(pError);
				}
				if (!pRecord || !pRecord.IDContract)
				{
					return fCallback(null, null);
				}
				return fCallback(null, pRecord);
			});
	}

	/**
	 * Build a comprehension that mirrors the source project's join / config rows
	 * (and sample-plan rows) onto a destination project. Does not write anything.
	 *
	 * Destination project modes:
	 *  - **UPDATE_EXISTING**: pDestIDProject > 0 — existing project; cloned rows
	 *    reference it by literal `IDProject`. A small partial-update record for
	 *    the dest Project itself is also pushed so its `IDProjectType` (and
	 *    sometimes `IDContract`) match the source.
	 *  - **AUTO_CREATE**:    pDestIDProject is null / 0 / undefined — a brand-new
	 *    Project row is added to the comprehension with a deterministic
	 *    `GUIDProject`; all cloned rows reference it via `GUIDProject`.
	 *
	 * Contract modes (controlled by `pOptions.CloneContract`):
	 *  - **NONE**:               source contract untouched; cloned rows get
	 *                            `IDContract: destProject.IDContract || 0`.
	 *  - **UPSERT_INTO_DEST**:   `CloneContract: true` AND dest project has
	 *                            an existing contract. Source contract field
	 *                            data is upserted INTO dest's existing contract
	 *                            row; cloned rows reference dest's existing
	 *                            `IDContract` literally.
	 *  - **NEW_LINKED**:         `CloneContract: true` AND dest project has
	 *                            no contract (or dest is being auto-created).
	 *                            A new Contract is created from the source
	 *                            contract; dest Project (new or existing) is
	 *                            updated to point at it via `GUIDContract`;
	 *                            cloned rows reference the new contract via
	 *                            `GUIDContract`.
	 *
	 * Always applies: source project's `IDProjectType` is stamped onto the
	 * destination project, whether new or existing.
	 *
	 * Also reads every Project-layer Configuration namespace set on the source
	 * (no cascade) and surfaces them on the returned envelope. Configuration
	 * blobs live in the separate Configuration microservice, not in Meadow, so
	 * they aren't part of the `comprehension` object — they're applied via a
	 * separate POST /Configuration/Put/… loop in `cloneProject` /
	 * `applyAllConfiguration`.
	 *
	 * @param {number} pSourceIDProject
	 * @param {number|null|undefined} pDestIDProject - omit / null / 0 to auto-create.
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.CloneContract=false]
	 * @param {string[]} [pOptions.OnlyEntities] - When non-empty, only these entity
	 *        names are cloned (e.g. config-only seeding). The Project/Contract anchor
	 *        records are always emitted.
	 * @param {string[]} [pOptions.ExcludeEntities] - Entity names to skip (ignored
	 *        when OnlyEntities is provided).
	 * @param {string}  [pOptions.ProjectName]
	 * @param {string}  [pOptions.ProjectDescription]
	 * @param {string}  [pOptions.ContractName]
	 * @param {string}  [pOptions.ContractDescription]
	 * @param {function(Error|null, { comprehension: object, reportData: object, warnings: string[], configuration: object }=)} fCallback
	 */
	buildComprehension(pSourceIDProject, pDestIDProject, pOptions, fCallback)
	{
		// Back-compat: (src, dest, cb) — no options.
		if (typeof(pOptions) === 'function')
		{
			fCallback = pOptions;
			pOptions = {};
		}
		const tmpOptions = pOptions || {};
		const tmpCloneContract = !!tmpOptions.CloneContract;

		// Entity scoping — used by type-seeding to clone config-only (forms,
		// observation types, label types, labels, dates) while skipping
		// BidItem/LineItem/sample-plan. When OnlyEntities is a non-empty array,
		// only those entity names are emitted; otherwise any name in
		// ExcludeEntities is skipped. The Project (and Contract, when requested)
		// anchor records are always emitted regardless — for UPDATE_EXISTING the
		// Project record is a harmless partial update (IDProject + IDProjectType).
		const tmpOnlyEntities = (Array.isArray(tmpOptions.OnlyEntities) && tmpOptions.OnlyEntities.length > 0)
			? new Set(tmpOptions.OnlyEntities) : null;
		const tmpExcludeEntities = new Set(Array.isArray(tmpOptions.ExcludeEntities) ? tmpOptions.ExcludeEntities : []);
		const fIncludeEntity = (pEntity) => tmpOnlyEntities ? tmpOnlyEntities.has(pEntity) : !tmpExcludeEntities.has(pEntity);

		// Normalize dest: null / 0 / undefined / negative → auto-create.
		const tmpDestIDProject = (Number.isInteger(pDestIDProject) && pDestIDProject > 0) ? pDestIDProject : null;
		const tmpProjectMode = tmpDestIDProject ? 'UPDATE_EXISTING' : 'AUTO_CREATE';

		if (tmpProjectMode === 'UPDATE_EXISTING' && pSourceIDProject === tmpDestIDProject)
		{
			return fCallback(new Error('Source and destination IDProject must differ.'));
		}
		if (!Number.isInteger(pSourceIDProject) || pSourceIDProject <= 0)
		{
			return fCallback(new Error('SourceIDProject is required and must be a positive integer.'));
		}

		this.log.info(`Project Cloning Adapter — Build Comprehension`);
		this.log.info(`  Source IDProject:      ${pSourceIDProject}`);
		this.log.info(`  Destination IDProject: ${tmpDestIDProject || '(auto-create)'}`);
		this.log.info(`  Project mode:          ${tmpProjectMode}`);
		this.log.info(`  Clone contract:        ${tmpCloneContract}`);

		const tmpComprehension = {};
		const tmpCounts = {};
		const tmpWarnings = [];
		let tmpSourceProject = null;
		let tmpDestProject = null;
		let tmpSourceContract = null;
		let tmpConfiguration = {};   // { <NamespaceKey>: { <NamespaceValue>: blob } }
		// Per-rule EmailRule config to re-home after the rules are pushed (each
		// entry: { GUIDEmailRule, Handler, SourceConfig, SourceCustomerID, DestCustomerID }).
		let tmpEmailRuleConfigSync = [];
		const tmpCloneIndex = {};

		// Mode + refs computed in the project / contract slice stages and then
		// passed to entity cloning so per-row stamping is uniform.
		let tmpContractMode = 'NONE';
		let tmpProjectRef = null;     // { IDProject } or { GUIDProject }
		let tmpContractRef = null;    // { IDContract } or { GUIDContract }
		let tmpDestProjectScope = null;  // record used for InheritFromDestProject lookups

		libAsync.waterfall(
			[
				// Stage: source / dest project lookups.
				(fStageComplete) => this.lookupProjectByID(pSourceIDProject,
					(pError, pRecord) =>
					{
						if (pError) return fStageComplete(pError);
						tmpSourceProject = pRecord;
						return fStageComplete();
					}),
				(fStageComplete) =>
				{
					if (tmpProjectMode === 'AUTO_CREATE')
					{
						// No dest project to fetch; the "dest project scope" for
						// InheritFromDestProject is the source project (since the
						// new dest inherits customer / org / program from source).
						tmpDestProject = null;
						tmpDestProjectScope = tmpSourceProject;
						return fStageComplete();
					}
					this.lookupProjectByID(tmpDestIDProject,
						(pError, pRecord) =>
						{
							if (pError) return fStageComplete(pError);
							tmpDestProject = pRecord;
							tmpDestProjectScope = pRecord;
							return fStageComplete();
						});
				},
				// Stage: source contract lookup (only when CloneContract).
				(fStageComplete) =>
				{
					if (!tmpCloneContract)
					{
						return fStageComplete();
					}
					if (!tmpSourceProject.IDContract)
					{
						tmpWarnings.push(`CloneContract requested but source project [${pSourceIDProject}] has no contract — nothing to clone for the contract slice.`);
						return fStageComplete();
					}
					this.lookupContractByID(tmpSourceProject.IDContract,
						(pError, pRecord) =>
						{
							if (pError) return fStageComplete(pError);
							if (!pRecord)
							{
								tmpWarnings.push(`Source project's contract [IDContract=${tmpSourceProject.IDContract}] not found — contract slice will be skipped.`);
								return fStageComplete();
							}
							tmpSourceContract = pRecord;
							return fStageComplete();
						});
				},
				// Stage: determine contract mode + contract slice (if any).
				(fStageComplete) =>
				{
					// Determine contract mode based on options + dest project state.
					if (!tmpCloneContract || !tmpSourceContract)
					{
						tmpContractMode = 'NONE';
					}
					else if (tmpDestProject && tmpDestProject.IDContract && tmpDestProject.IDContract > 0)
					{
						tmpContractMode = 'UPSERT_INTO_DEST';
					}
					else
					{
						tmpContractMode = 'NEW_LINKED';
					}
					this.log.info(`  Contract mode:         ${tmpContractMode}`);

					const fBuildContractSlice = () =>
					{
						const tmpContractSlice = this._buildContractSlice(
							tmpSourceContract,
							tmpDestProject,
							tmpContractMode,
							tmpOptions);
						if (tmpContractSlice.record)
						{
							tmpComprehension.Contract = { [tmpContractSlice.recordGUIDKey]: tmpContractSlice.record };
							tmpCounts.Contract = tmpContractSlice.counts;
						}
						tmpContractRef = tmpContractSlice.contractRef;
						return fStageComplete();
					};

					// UPSERT_INTO_DEST upserts source contract field data INTO the dest's existing
					// contract row, keyed by that row's GUIDContract. tmpDestProject is a plain
					// Project record (lookupProjectByID) carrying only IDContract, not GUIDContract —
					// resolve the real contract GUID first, else the upsert can't match the existing
					// row and inserts a stray contract.
					if (tmpContractMode === 'UPSERT_INTO_DEST')
					{
						return this.lookupContractByID(tmpDestProject.IDContract,
							(pContractError, pDestContract) =>
							{
								if (pContractError) return fStageComplete(pContractError);
								if (pDestContract && pDestContract.GUIDContract)
								{
									tmpDestProject.GUIDContract = pDestContract.GUIDContract;
								}
								else
								{
									tmpWarnings.push(`UPSERT_INTO_DEST: could not resolve dest contract [IDContract=${tmpDestProject.IDContract}] GUIDContract; upsert may not match the existing row.`);
								}
								return fBuildContractSlice();
							});
					}
					return fBuildContractSlice();
				},
				// Stage: build the Project record (always — full clone for AUTO_CREATE,
				// partial update for UPDATE_EXISTING). This stage also locks in tmpProjectRef.
				(fStageComplete) =>
				{
					const tmpProjectSlice = this._buildProjectSlice(
						pSourceIDProject,
						tmpSourceProject,
						tmpDestIDProject,
						tmpDestProject,
						tmpProjectMode,
						tmpContractMode,
						tmpContractRef,
						tmpOptions);
					tmpComprehension.Project = { [tmpProjectSlice.recordGUIDKey]: tmpProjectSlice.record };
					tmpCounts.Project = tmpProjectSlice.counts;
					tmpProjectRef = tmpProjectSlice.projectRef;
					this.log.info(`  Project ref for cloned rows:  ${JSON.stringify(tmpProjectRef)}`);
					this.log.info(`  Contract ref for cloned rows: ${JSON.stringify(tmpContractRef)}`);
					return fStageComplete();
				},
				// Stage: clone all configured entities sequentially, in CLONED_ENTITIES order.
				(fStageComplete) =>
				{
					libAsync.eachSeries(CLONED_ENTITIES.filter((pRecipe) => fIncludeEntity(pRecipe.Entity)),
						(pRecipe, fEntityDone) =>
						{
							this._cloneEntity(pRecipe, pSourceIDProject, tmpDestIDProject, tmpDestProjectScope,
								tmpProjectRef, tmpContractRef, tmpCloneIndex, tmpOptions,
								(pError, pSlice) =>
								{
									if (pError) return fEntityDone(pError);
									tmpComprehension[pRecipe.Entity] = pSlice.bucket;
									tmpCounts[pRecipe.Entity] = pSlice.counts;
									for (const w of pSlice.warnings)
									{
										tmpWarnings.push(w);
									}
									return fEntityDone();
								});
						}, fStageComplete);
				},
				// Stage: sample-plan slice (PLIMT / MLJ). Skipped entirely when entity
				// scoping excludes both sample-plan entities (e.g. config-only seeding).
				(fStageComplete) =>
				{
					if (!SAMPLE_PLAN_ENTITIES.some((pEntity) => fIncludeEntity(pEntity)))
					{
						return fStageComplete();
					}
					this._buildSamplePlanSlice(pSourceIDProject, tmpProjectRef, tmpCloneIndex,
						(pError, pSlice) =>
						{
							if (pError) return fStageComplete(pError);
							for (const entity of SAMPLE_PLAN_ENTITIES)
							{
								if (pSlice.buckets[entity])
								{
									tmpComprehension[entity] = pSlice.buckets[entity];
									tmpCounts[entity] = pSlice.counts[entity];
								}
							}
							for (const w of pSlice.warnings) tmpWarnings.push(w);
							return fStageComplete();
						});
				},
				// Stage: email notification rules (EmailRule + EmailRuleSchedule).
				// Email rules aren't project-scoped by a column — membership is the
				// `Projects` JSON array — so this is a dedicated slice, not a
				// CLONED_ENTITIES recipe. The cloned rule's `Projects` array embeds
				// the NUMERIC dest IDProject, so we can only build it inline when the
				// dest id is known: UPDATE_EXISTING clone AND all type-seeding (the
				// target project already exists). For AUTO_CREATE the dest id isn't
				// known until the push lands, so we report candidate counts here (so
				// Preview shows a number) and defer the real build/push to cloneProject
				// once `_resolveDestIDProject` has the numeric id.
				(fStageComplete) =>
				{
					if (!fIncludeEntity('EmailRule'))
					{
						return fStageComplete();
					}
					const tmpSourceCustomerID = tmpSourceProject && tmpSourceProject.IDCustomer;
					if (tmpProjectMode === 'AUTO_CREATE')
					{
						this._fetchCloneableEmailRules(tmpSourceCustomerID, pSourceIDProject, null,
							(pError, pCloneableRules) =>
							{
								if (pError) return fStageComplete(pError);
								const tmpCandidateCount = (pCloneableRules || []).length;
								tmpCounts.EmailRule = { Source: tmpCandidateCount, ToCreate: tmpCandidateCount, Deferred: 'post-push' };
								return fStageComplete();
							});
						return;
					}
					const tmpDestCustomerID = tmpDestProjectScope && tmpDestProjectScope.IDCustomer;
					this._buildEmailRuleSlice(pSourceIDProject, tmpSourceCustomerID, tmpDestIDProject, tmpDestCustomerID, tmpOptions,
						(pError, pSlice) =>
						{
							if (pError) return fStageComplete(pError);
							tmpComprehension.EmailRule = pSlice.buckets.EmailRule;
							tmpComprehension.EmailRuleSchedule = pSlice.buckets.EmailRuleSchedule;
							tmpCounts.EmailRule = pSlice.counts.EmailRule;
							tmpCounts.EmailRuleSchedule = pSlice.counts.EmailRuleSchedule;
							tmpEmailRuleConfigSync = pSlice.configSync || [];
							for (const w of pSlice.warnings) tmpWarnings.push(w);
							return fStageComplete();
						});
				},
				// Stage: every Project-layer Configuration namespace (config service,
				// applied separately because it's owned by a sibling microservice with
				// its own write semantics and cache invalidation).
				(fStageComplete) =>
				{
					this._buildAllConfigurationSlices(pSourceIDProject,
						(pError, pSlice) =>
						{
							if (pError) return fStageComplete(pError);
							tmpConfiguration = pSlice.configByNamespaceKey;
							tmpCounts.Configuration = pSlice.counts;
							for (const w of pSlice.warnings) tmpWarnings.push(w);
							return fStageComplete();
						});
				},
			],
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`Project clone comprehension build failed: ${(pError && pError.message) || pError}`, pError);
					return fCallback(pError);
				}
				const tmpResult = {
					comprehension: tmpComprehension,
					reportData:
					{
						SourceIDProject: pSourceIDProject,
						DestIDProject: tmpDestIDProject,
						ProjectMode: tmpProjectMode,
						ContractMode: tmpContractMode,
						// In AUTO_CREATE mode the dest project is identified by GUID until
						// the comprehension lands; surface it so post-apply callers (e.g.
						// applyAllConfiguration) can resolve to the new IDProject.
						DestProjectGUID: (tmpProjectRef && tmpProjectRef.GUIDProject) || null,
						Counts: tmpCounts,
					},
					warnings: tmpWarnings,
					configuration: tmpConfiguration,
					// Post-push work list to re-home each cloned rule's per-rule config.
					emailRuleConfigSync: tmpEmailRuleConfigSync,
				};
				return fCallback(null, tmpResult);
			});
	}

	/**
	 * Build one entity's slice of the comprehension.
	 *
	 * Idempotency comes from the deterministic per-row GUIDs (`<prefix>-<md5(destIdentifier|naturalKey)>`)
	 * combined with the IntegrationAdapter's upsert-by-GUID semantics. Re-cloning
	 * the same source into the same dest produces the same GUIDs, so the adapter
	 * UPDATEs existing rows in place rather than INSERTing duplicates. We do NOT
	 * pre-fetch dest rows to skip natural-key matches — that check was a no-op
	 * for AutoIdentity-keyed entities (BidItem/LineItem/Observation/Document)
	 * and the manual-pre-existing-row scenario it protected against on shared-FK
	 * entities is not part of the spec.
	 *
	 * @param {object} pRecipe - One CLONED_ENTITIES entry.
	 * @param {number} pSourceIDProject
	 * @param {number|null} pDestIDProject - null in AUTO_CREATE mode.
	 * @param {object} pDestProjectScope - Project record (dest in UPDATE_EXISTING,
	 *                                     source in AUTO_CREATE) used for
	 *                                     InheritFromDestProject field lookups.
	 * @param {object} pProjectRef - { IDProject } or { GUIDProject } stamped onto each clone record.
	 * @param {object} pContractRef - { IDContract } or { GUIDContract } stamped onto cloned
	 *                                rows whose recipe has `RefContract: true`.
	 * @param {object} pCloneIndex - Accumulator: { <entity>: { sourceIDToCloneGUID, sourceRows } }.
	 * @param {object} pOptions - buildComprehension options. Reads `pOptions.MaxRecords[<entity>]`
	 *                            to resolve the per-entity record cap (overrides recipe default).
	 * @param {function(Error|null, { bucket: object, counts: object, warnings: string[] }=)} fCallback
	 * @private
	 */
	_cloneEntity(pRecipe, pSourceIDProject, pDestIDProject, pDestProjectScope, pProjectRef, pContractRef, pCloneIndex, pOptions, fCallback)
	{
		const tmpOptions = pOptions || {};
		// Resolve the effective per-entity record cap. Option override > recipe default > no cap.
		const tmpMaxRecordsOption = (tmpOptions.MaxRecords && typeof(tmpOptions.MaxRecords) === 'object')
			? tmpOptions.MaxRecords[pRecipe.Entity]
			: undefined;
		let tmpEffectiveCap = null;
		if (Number.isInteger(tmpMaxRecordsOption) && tmpMaxRecordsOption > 0)
		{
			tmpEffectiveCap = tmpMaxRecordsOption;
		}
		else if (tmpMaxRecordsOption === 0)
		{
			tmpEffectiveCap = null; // explicit "no cap"
		}
		else if (Number.isInteger(pRecipe.DefaultMaxRecords) && pRecipe.DefaultMaxRecords > 0)
		{
			tmpEffectiveCap = pRecipe.DefaultMaxRecords;
		}

		this.log.info(`  Cloning ${pRecipe.Entity}${tmpEffectiveCap ? ` (cap: ${tmpEffectiveCap})` : ''}...`);
		const tmpCapWarnings = [];
		// Source-row fetcher. Two shapes:
		//   1. Default: filter by IDProject. Works for every recipe whose entity
		//      has an IDProject column. Honors per-entity caps with a precount
		//      so we can name how many rows are skipped in the warning.
		//   2. SourceScope: for entities like DocumentObservationJoin that have
		//      no IDProject column, fetch by INN against the source IDs of an
		//      already-cloned parent entity (e.g. IDDocument INN <doc src IDs>).
		//      The parent's cloneIndex is the bound here — no cap precount
		//      because the fetch is already scoped to a known finite set.
		const tmpFetchSource = (fDone) =>
		{
			if (pRecipe.SourceScope)
			{
				const tmpScope = pRecipe.SourceScope;
				const tmpParentIndex = pCloneIndex[tmpScope.ParentEntity];
				const tmpParentSourceIDs = (tmpParentIndex && tmpParentIndex.sourceIDToCloneGUID)
					? Object.keys(tmpParentIndex.sourceIDToCloneGUID).map((tmpID) => Number(tmpID)).filter((tmpID) => !!tmpID)
					: [];
				if (tmpParentSourceIDs.length === 0)
				{
					this.log.info(`    ${pRecipe.Entity}: no cloned ${tmpScope.ParentEntity} rows to scope against — skipping fetch.`);
					return fDone(null, []);
				}
				return this.getEntitySetBatched(pRecipe.Entity, tmpScope.FK, tmpParentSourceIDs, null, fDone);
			}
			const fGo = () => this.getEntityRowsForProject(pRecipe.Entity, pSourceIDProject, tmpEffectiveCap || 200000, fDone);
			if (!tmpEffectiveCap) return fGo();
			this.getEntityCountForProject(pRecipe.Entity, pSourceIDProject,
				(pCountError, pTotal) =>
				{
					if (pCountError)
					{
						this.log.info(`    ${pRecipe.Entity}: source-row precount failed (${pCountError.message || pCountError}) — proceeding to fetch capped at ${tmpEffectiveCap}.`);
						return fGo();
					}
					// pTotal === null means the rest client didn't expose a count
					// endpoint — proceed with the cap but without a skipped-row warning.
					if (pTotal !== null && pTotal > tmpEffectiveCap)
					{
						tmpCapWarnings.push(`${pRecipe.Entity}: source project has ${pTotal} row(s) but the per-entity cap is ${tmpEffectiveCap}; ${pTotal - tmpEffectiveCap} row(s) will be skipped.`);
					}
					return fGo();
				});
		};
		tmpFetchSource(
			(pError, pSourceRows) =>
			{
				if (pError) return fCallback(pError);

				const tmpSourceRows = pSourceRows || [];
				this.log.info(`    ${pRecipe.Entity}: ${tmpSourceRows.length} source row(s)`);

				// Stable per-run dest identifier used as the composite-key prefix
				// for deterministic GUID generation. Integer for UPDATE_EXISTING,
				// the new project's GUID (a string) for AUTO_CREATE — either way
				// a re-clone of the same (source, dest) produces the same GUIDs.
				// Idempotency: the IntegrationAdapter upserts by GUID, so re-cloning
				// the same source into the same dest updates rows in place rather
				// than duplicating. We intentionally do NOT pre-fetch dest rows
				// to "skip natural-key matches" — for AutoIdentity-keyed entities
				// (BidItem, LineItem, Observation, Document) the source's ID can't
				// match dest's, so the check is a no-op; for shared-FK / name-keyed
				// entities (RNI joins, ProjectTagType, ProjectDate) any pre-existing
				// dest row will simply coexist with the cloned row under a different
				// GUID — that's a manual-data scenario the spec doesn't ask us to
				// protect against.
				const tmpDestIdentifier = pDestIDProject
					? String(pDestIDProject)
					: (pProjectRef.GUIDProject || 'NEW');

				const tmpBucket = {};
				const tmpSourceIDToCloneGUID = {};
				const tmpSourceIDField = `ID${pRecipe.Entity}`;
				let tmpUnresolvedFKs = 0;
				let tmpDroppedOrphans = 0;
				const tmpGUIDFKs = pRecipe.GUIDFKs || {};
				const tmpGUIDFKFields = Object.keys(tmpGUIDFKs);
				const tmpInheritFromDestProject = pRecipe.InheritFromDestProject || {};
				const tmpWarnings = tmpCapWarnings.slice();

				for (const sourceRow of tmpSourceRows)
				{
					const tmpNaturalKey = this._naturalKey(pRecipe, sourceRow);
					const tmpGUIDKey = this.generateGUID(pRecipe.Prefix, `${tmpDestIdentifier}|${tmpNaturalKey}`);
					// Start with the per-call Project ref (IDProject literal or
					// GUIDProject FK). Recipes for entities that have no
					// IDProject column (e.g. DocumentObservationJoin) opt out
					// via `NoProjectRef: true` — otherwise the DAL rejects the
					// insert with "Unknown column 'IDProject' in 'field list'".
					const tmpRecord = pRecipe.NoProjectRef ? {} : Object.assign({}, pProjectRef);
					// Stamp GUID<Entity> onto the record body itself. The comprehension-processor's
					// runAdapter feeds the record (the bucket value) to IntegrationAdapter.addSourceRecord,
					// it does NOT pull the bucket key. Without this field on the body, the adapter
					// has no GUID to upsert by, the record fails to land, and downstream entities
					// that GUID-FK to it (e.g. PLIMT.GUIDLineItem) resolve to ID=0.
					tmpRecord[`GUID${pRecipe.Entity}`] = tmpGUIDKey;
					// Per-call Contract ref for entities that have IDContract.
					if (pRecipe.RefContract && pContractRef)
					{
						Object.assign(tmpRecord, pContractRef);
					}
					for (const field of pRecipe.CopyFields)
					{
						if (sourceRow[field] !== undefined && sourceRow[field] !== null)
						{
							tmpRecord[field] = sourceRow[field];
						}
					}
					for (const destField of Object.keys(tmpInheritFromDestProject))
					{
						const tmpSrcField = tmpInheritFromDestProject[destField];
						if (pDestProjectScope && pDestProjectScope[tmpSrcField] !== undefined && pDestProjectScope[tmpSrcField] !== null)
						{
							tmpRecord[destField] = pDestProjectScope[tmpSrcField];
						}
					}
					// Resolve cross-entity GUID-FK refs against the in-progress clone index.
					let tmpHasUnresolvedFK = false;
					for (const fkField of tmpGUIDFKFields)
					{
						const tmpFKDef = tmpGUIDFKs[fkField];
						const tmpSrcFKVal = sourceRow[tmpFKDef.sourceField];
						if (tmpSrcFKVal === undefined || tmpSrcFKVal === null || tmpSrcFKVal === 0)
						{
							continue;
						}
						const tmpRefIndex = pCloneIndex[tmpFKDef.entity];
						const tmpResolvedGUID = tmpRefIndex && tmpRefIndex.sourceIDToCloneGUID
							? tmpRefIndex.sourceIDToCloneGUID[tmpSrcFKVal]
							: undefined;
						if (tmpResolvedGUID)
						{
							tmpRecord[fkField] = tmpResolvedGUID;
						}
						else
						{
							tmpUnresolvedFKs++;
							tmpHasUnresolvedFK = true;
						}
					}
					// Recipes like DocumentObservationJoin opt out of emitting orphan
					// rows — if a side of the join lost its target (capped out or
					// excluded from the clone set), the join row has nothing to attach
					// to and is silently dropped.
					if (pRecipe.OnlyEmitIfReferencedClonesPresent && tmpHasUnresolvedFK)
					{
						tmpDroppedOrphans++;
						continue;
					}
					// PostBuild hook: lets the recipe flip flags on the cloned body
					// (e.g. Observation forces `Labels.SAVE = true` so the API's
					// storeLabels hook materializes the tags).
					if (typeof(pRecipe.PostBuild) === 'function')
					{
						try { pRecipe.PostBuild(tmpRecord, sourceRow, pRecipe); }
						catch (pHookError) { this.log.error(`PostBuild hook for ${pRecipe.Entity} threw: ${pHookError.message || pHookError}`); }
					}
					tmpBucket[tmpGUIDKey] = tmpRecord;
					const tmpSrcID = sourceRow[tmpSourceIDField];
					if (tmpSrcID !== undefined && tmpSrcID !== null)
					{
						tmpSourceIDToCloneGUID[tmpSrcID] = tmpGUIDKey;
					}
				}

				pCloneIndex[pRecipe.Entity] = {
					sourceIDToCloneGUID: tmpSourceIDToCloneGUID,
					sourceRows: tmpSourceRows,
				};

				if (tmpUnresolvedFKs > 0 && !pRecipe.OnlyEmitIfReferencedClonesPresent)
				{
					tmpWarnings.push(`${pRecipe.Entity}: ${tmpUnresolvedFKs} GUID-FK ref(s) could not be resolved (the referenced entity was either skipped or not in the clone set).`);
				}
				if (tmpDroppedOrphans > 0)
				{
					tmpWarnings.push(`${pRecipe.Entity}: dropped ${tmpDroppedOrphans} orphan row(s) whose source FK targets were not in the clone set.`);
				}

				return fCallback(null,
					{
						bucket: tmpBucket,
						counts:
						{
							Source: tmpSourceRows.length,
							ToCreate: Object.keys(tmpBucket).length,
						},
						warnings: tmpWarnings,
					});
			});
	}

	/**
	 * Stringify a row's natural-key fields into a stable lookup key.
	 * @private
	 */
	_naturalKey(pRecipe, pRow)
	{
		return pRecipe.KeyFields.map((f) => (pRow && pRow[f] !== undefined && pRow[f] !== null) ? String(pRow[f]) : '').join('|');
	}

	/**
	 * Build the Project record that lands in the comprehension AND determine the
	 * `projectRef` (`{ IDProject }` or `{ GUIDProject }`) that every cloned entity
	 * row will use to reference the destination project.
	 *
	 * AUTO_CREATE  → full clone from source + deterministic GUIDProject.
	 * UPDATE_EXISTING → partial update record carrying just IDProject, IDProjectType
	 *                   from source, and (if NEW_LINKED contract mode) GUIDContract.
	 *
	 * @returns {{ record: object, recordGUIDKey: string, projectRef: object, counts: object }}
	 * @private
	 */
	_buildProjectSlice(pSourceIDProject, pSourceProject, pDestIDProject, pDestProject,
		pProjectMode, pContractMode, pContractRef, pOptions)
	{
		const tmpOptions = pOptions || {};
		if (pProjectMode === 'AUTO_CREATE')
		{
			// Deterministic GUID — re-cloning the same source yields the same dest
			// project (idempotent upsert) rather than creating a new one each time.
			const tmpGUID = this.generateGUID('PCL-P', `FROM:${pSourceIDProject}`);
			const tmpRecord = { GUIDProject: tmpGUID };
			for (const field of PROJECT_CLONE_COPY_FIELDS)
			{
				if (pSourceProject[field] !== undefined && pSourceProject[field] !== null)
				{
					tmpRecord[field] = pSourceProject[field];
				}
			}
			// Caller overrides for the human-facing fields; fallback prefixes the source name.
			tmpRecord.Name = tmpOptions.ProjectName || `CLONED FROM ${pSourceProject.Name || `IDProject ${pSourceIDProject}`}`;
			if (tmpOptions.ProjectDescription !== undefined)
			{
				tmpRecord.Description = tmpOptions.ProjectDescription;
			}
			// Contract linkage on the new project.
			if (pContractRef && pContractRef.GUIDContract)
			{
				tmpRecord.GUIDContract = pContractRef.GUIDContract;
				delete tmpRecord.IDContract;
			}
			else if (pContractRef && pContractRef.IDContract !== undefined)
			{
				tmpRecord.IDContract = pContractRef.IDContract;
			}
			else
			{
				tmpRecord.IDContract = 0;
			}
			this.log.info(`  Project (AUTO_CREATE): GUIDProject=${tmpGUID} Name="${tmpRecord.Name}"`);
			return {
				record: tmpRecord,
				recordGUIDKey: tmpGUID,
				projectRef: { GUIDProject: tmpGUID },
				counts: { Mode: 'AUTO_CREATE', ToCreate: 1 },
			};
		}

		// UPDATE_EXISTING: minimal partial-update record. IDProjectType always from source
		// (per the always-apply rule). GUIDContract added only when we're creating a new
		// contract that the existing project needs to be linked to (NEW_LINKED).
		const tmpRecord = { IDProject: pDestIDProject };
		if (pSourceProject.IDProjectType !== undefined && pSourceProject.IDProjectType !== null)
		{
			tmpRecord.IDProjectType = pSourceProject.IDProjectType;
		}
		if (pContractMode === 'NEW_LINKED' && pContractRef && pContractRef.GUIDContract)
		{
			tmpRecord.GUIDContract = pContractRef.GUIDContract;
		}
		// Use the existing dest project's GUIDProject as the bucket key — the
		// adapter upserts by GUID against the existing row. If we don't have it
		// (shouldn't happen since lookupProjectByID returns it), fall back to a
		// generated key marked with the dest id for traceability.
		const tmpKey = pDestProject && pDestProject.GUIDProject
			? pDestProject.GUIDProject
			: this.generateGUID('PCL-PUPD', `DEST:${pDestIDProject}`);
		tmpRecord.GUIDProject = tmpKey;
		this.log.info(`  Project (UPDATE_EXISTING IDProject=${pDestIDProject}): IDProjectType=${tmpRecord.IDProjectType}${tmpRecord.GUIDContract ? ' GUIDContract=' + tmpRecord.GUIDContract : ''}`);
		return {
			record: tmpRecord,
			recordGUIDKey: tmpKey,
			projectRef: { IDProject: pDestIDProject },
			counts: { Mode: 'UPDATE_EXISTING', ToUpdate: 1 },
		};
	}

	/**
	 * Build the Contract record that lands in the comprehension AND determine the
	 * `contractRef` (`{ IDContract }` or `{ GUIDContract }`) that every contract-
	 * referencing cloned row will use.
	 *
	 * Returns `{ record: null, contractRef: { IDContract: ... } }` for NONE mode
	 * so the caller doesn't add a Contract entry to the comprehension.
	 *
	 * @returns {{ record: object|null, recordGUIDKey: string|null, contractRef: object, counts: object }}
	 * @private
	 */
	_buildContractSlice(pSourceContract, pDestProject, pContractMode, pOptions)
	{
		const tmpOptions = pOptions || {};
		if (pContractMode === 'NONE')
		{
			// Cloned rows reference dest project's existing contract literally (could be 0).
			const tmpIDContract = (pDestProject && pDestProject.IDContract) || 0;
			return {
				record: null,
				recordGUIDKey: null,
				contractRef: { IDContract: tmpIDContract },
				counts: { Mode: 'NONE' },
			};
		}

		if (pContractMode === 'UPSERT_INTO_DEST')
		{
			// Upsert source contract field data INTO dest's existing contract row.
			// Targeted by literal IDContract — no new row is created. Cloned entities
			// continue to reference dest's existing IDContract literally.
			const tmpDestIDContract = pDestProject.IDContract;
			const tmpRecord = { IDContract: tmpDestIDContract };
			for (const field of CONTRACT_CLONE_COPY_FIELDS)
			{
				if (pSourceContract[field] !== undefined && pSourceContract[field] !== null)
				{
					tmpRecord[field] = pSourceContract[field];
				}
			}
			if (tmpOptions.ContractName !== undefined)
			{
				tmpRecord.Name = tmpOptions.ContractName;
			}
			if (tmpOptions.ContractDescription !== undefined)
			{
				tmpRecord.Description = tmpOptions.ContractDescription;
			}
			// Bucket key must match the existing row's GUID so the adapter does an
			// UPDATE, not an INSERT.
			const tmpKey = pSourceContract && pDestProject && pDestProject.GUIDContract
				? pDestProject.GUIDContract
				: this.generateGUID('PCL-CUPD', `DEST:${tmpDestIDContract}`);
			tmpRecord.GUIDContract = tmpKey;
			this.log.info(`  Contract (UPSERT_INTO_DEST IDContract=${tmpDestIDContract}): upserting source contract fields in place`);
			return {
				record: tmpRecord,
				recordGUIDKey: tmpKey,
				contractRef: { IDContract: tmpDestIDContract },
				counts: { Mode: 'UPSERT_INTO_DEST', ToUpsert: 1 },
			};
		}

		// NEW_LINKED: brand-new contract row from source field data. Cloned entities
		// reference it via GUIDContract. The project record (new or existing-being-updated)
		// also references it via GUIDContract.
		const tmpGUID = this.generateGUID('PCL-C', `FROM:${pSourceContract.IDContract}`);
		const tmpRecord = { GUIDContract: tmpGUID };
		for (const field of CONTRACT_CLONE_COPY_FIELDS)
		{
			if (pSourceContract[field] !== undefined && pSourceContract[field] !== null)
			{
				tmpRecord[field] = pSourceContract[field];
			}
		}
		tmpRecord.Name = tmpOptions.ContractName || `CLONED FROM ${pSourceContract.Name || `IDContract ${pSourceContract.IDContract}`}`;
		if (tmpOptions.ContractDescription !== undefined)
		{
			tmpRecord.Description = tmpOptions.ContractDescription;
		}
		this.log.info(`  Contract (NEW_LINKED): GUIDContract=${tmpGUID} Name="${tmpRecord.Name}"`);
		return {
			record: tmpRecord,
			recordGUIDKey: tmpGUID,
			contractRef: { GUIDContract: tmpGUID },
			counts: { Mode: 'NEW_LINKED', ToCreate: 1 },
		};
	}

	/**
	 * Read every Project-layer Configuration namespace set on the source project.
	 *
	 * Two-step enumeration:
	 *  1. `GET /Describe/Configuration/In/Project/<src>` returns skeleton ConfigEntry
	 *     records — one per `(NamespaceKey, NamespaceValue)` pair set at the Project
	 *     layer for the source. We pull the distinct `NamespaceKey` set out of
	 *     that response.
	 *  2. For each `NamespaceKey`, `GET /Configuration/For/<key>/In/Project/<src>`
	 *     returns the reassembled blob keyed by `NamespaceValue`. The config
	 *     service handles the flatten→nested reconstruction; we just collect
	 *     the per-namespace blobs into a single map.
	 *
	 * The `/In/Project/<id>` form returns ONLY values set at the Project layer
	 * — no cascading. This preserves the destination's natural inheritance
	 * from Customer / Contract for everything the source didn't explicitly
	 * override.
	 *
	 * @param {number} pSourceIDProject
	 * @param {function(Error|null, { configByNamespaceKey: object, counts: object, warnings: string[] }=)} fCallback
	 * @private
	 */
	_buildAllConfigurationSlices(pSourceIDProject, fCallback)
	{
		this.log.info(`  Discovering Project-layer Configuration namespaces for IDProject ${pSourceIDProject}...`);
		const tmpDescribeURI = `Describe/Configuration/In/Project/${pSourceIDProject}`;
		this.restClient.getJSON(tmpDescribeURI,
			(pDescribeError, pDescribeBody) =>
			{
				if (pDescribeError)
				{
					this.log.error(`Failed to enumerate configuration namespaces for source project ${pSourceIDProject}: ${pDescribeError.message || pDescribeError}`);
					return fCallback(pDescribeError);
				}
				const tmpRows = Array.isArray(pDescribeBody) ? pDescribeBody : [];
				const tmpKeySet = new Set();
				for (const row of tmpRows)
				{
					if (row && row.NamespaceKey) tmpKeySet.add(row.NamespaceKey);
				}
				const tmpKeys = Array.from(tmpKeySet);
				this.log.info(`    Configuration: ${tmpKeys.length} NamespaceKey(s) — ${tmpKeys.join(', ') || '(none)'}`);

				if (tmpKeys.length === 0)
				{
					return fCallback(null,
						{
							configByNamespaceKey: {},
							counts: { Namespaces: 0, NamespaceValues: 0, ToCopy: 0 },
							warnings: [],
						});
				}

				const tmpConfigByNamespaceKey = {};
				const tmpWarnings = [];
				let tmpValuesCount = 0;
				libAsync.eachSeries(tmpKeys,
					(pKey, fNext) =>
					{
						const tmpFetchURI = `Configuration/For/${encodeURIComponent(pKey)}/In/Project/${pSourceIDProject}`;
						this.restClient.getJSON(tmpFetchURI,
							(pFetchError, pFetchBody) =>
							{
								if (pFetchError)
								{
									const errMsg = (pFetchError && pFetchError.message) || String(pFetchError);
									tmpWarnings.push(`Configuration/${pKey}: failed to read source blob (${errMsg}) — skipping.`);
									return fNext();
								}
								const tmpBlob = (pFetchBody && typeof(pFetchBody) === 'object') ? pFetchBody : {};
								const tmpValueKeys = Object.keys(tmpBlob);
								if (tmpValueKeys.length === 0)
								{
									return fNext();
								}
								tmpConfigByNamespaceKey[pKey] = tmpBlob;
								tmpValuesCount += tmpValueKeys.length;
								this.log.info(`    Configuration/${pKey}: ${tmpValueKeys.length} NamespaceValue(s)`);
								return fNext();
							});
					},
					() =>
					{
						return fCallback(null,
							{
								configByNamespaceKey: tmpConfigByNamespaceKey,
								counts: { Namespaces: Object.keys(tmpConfigByNamespaceKey).length, NamespaceValues: tmpValuesCount, ToCopy: tmpValuesCount },
								warnings: tmpWarnings,
							});
					});
			});
	}

	/**
	 * Build the sample-plan portion of the comprehension. Operates on the
	 * source LineItems already fetched by the LineItem clone step (read from
	 * `pCloneIndex.LineItem`). For each source LineItem that was cloned, emits
	 * a `ProjectLineItemMaterialTest` per source PLIMT and a deduped
	 * `MaterialLineItemJoin` per source MLJ, with `GUIDLineItem` pointing at
	 * the cloned (not-yet-created) destination LineItem. The IntegrationAdapter
	 * resolves `GUIDLineItem` -> `IDLineItem` at push time via HeadlightGUIDMap.
	 *
	 * GUID prefixes are kept as `MSP-PLIMT` / `MSP-MLJ` for upsert compatibility
	 * with rows previously seeded by the LIMS SamplePlan-Copy page.
	 *
	 * @param {number} pSourceIDProject
	 * @param {object} pProjectRef - { IDProject } or { GUIDProject } stamped onto each PLIMT record.
	 * @param {object} pCloneIndex - Accumulator populated by earlier _cloneEntity calls.
	 *                               Reads `pCloneIndex.LineItem.{sourceRows, sourceIDToCloneGUID}`.
	 * @param {function(Error|null, { buckets: object, counts: object, warnings: string[] }=)} fCallback
	 * @private
	 */
	_buildSamplePlanSlice(pSourceIDProject, pProjectRef, pCloneIndex, fCallback)
	{
		// Stable per-run dest identifier for composite-key prefixing.
		const tmpDestIdentifier = pProjectRef.IDProject
			? String(pProjectRef.IDProject)
			: (pProjectRef.GUIDProject || 'NEW');
		this.log.info(`  Building sample-plan slice (ProjectLineItemMaterialTest + MaterialLineItemJoin)...`);

		const tmpLineItemIndex = pCloneIndex.LineItem || { sourceRows: [], sourceIDToCloneGUID: {} };
		const tmpSourceLineItems = tmpLineItemIndex.sourceRows || [];
		const tmpSourceIDToCloneGUID = tmpLineItemIndex.sourceIDToCloneGUID || {};
		const tmpSourceLIIDs = tmpSourceLineItems.map((li) => li.IDLineItem);
		const tmpWarnings = [];

		if (tmpSourceLIIDs.length === 0)
		{
			this.log.info(`    No source LineItems were cloned — sample-plan slice will be empty.`);
			return fCallback(null,
				{
					buckets: { ProjectLineItemMaterialTest: {}, MaterialLineItemJoin: {} },
					counts:
					{
						ProjectLineItemMaterialTest: { Source: 0, ToCreate: 0 },
						MaterialLineItemJoin: { Source: 0, ToCreate: 0 },
					},
					warnings: tmpWarnings,
				});
		}

		let tmpSourcePLIMTs = [];
		let tmpSourceMLIJs = [];

		libAsync.waterfall(
			[
				(fStageComplete) =>
				{
					// PLIMT has its own IDProject column, so we can pull every row for
					// the source project in one filter — the rest client paginates the
					// response internally. Much faster than batching by IDLineItem INN,
					// which on a project with thousands of LineItems means dozens of
					// round-trips.
					// 0 → default cap (200000); PLIMT isn't user-capped today.
					this.getEntityRowsForProject('ProjectLineItemMaterialTest', pSourceIDProject, 0,
						(pError, pRows) =>
						{
							if (pError) return fStageComplete(pError);
							tmpSourcePLIMTs = pRows || [];
							this.log.info(`    ProjectLineItemMaterialTest (source IDProject ${pSourceIDProject}): ${tmpSourcePLIMTs.length} row(s)`);
							return fStageComplete();
						});
				},
				(fStageComplete) =>
				{
					// MaterialLineItemJoin has no IDProject column, so we have to fetch
					// it by IDLineItem INN against the source LineItem IDs.
					this.getEntitySetBatched('MaterialLineItemJoin', 'IDLineItem', tmpSourceLIIDs, null,
						(pError, pRows) =>
						{
							if (pError) return fStageComplete(pError);
							tmpSourceMLIJs = pRows || [];
							this.log.info(`    MaterialLineItemJoin (${tmpSourceLIIDs.length} source LineItems): ${tmpSourceMLIJs.length} row(s)`);
							return fStageComplete();
						});
				},
			],
			(pError) =>
			{
				if (pError) return fCallback(pError);

				const tmpPLIMTBucket = {};
				const tmpMLIJBucket = {};
				const tmpSeenMLIJ = {};
				let tmpOrphanedPLIMTs = 0;
				let tmpOrphanedMLIJs = 0;

				for (const src of tmpSourcePLIMTs)
				{
					const tmpCloneLIGUID = tmpSourceIDToCloneGUID[src.IDLineItem];
					if (!tmpCloneLIGUID)
					{
						// Source LineItem was skipped (e.g. natural-key collision) so its
						// material tests have nothing to attach to.
						tmpOrphanedPLIMTs++;
						continue;
					}
					const tmpCompositeKey = `${tmpDestIdentifier}|${src.IDLineItem}|${src.IDMaterial}|${src.IDTest}|${src.SampleType}`;
					const tmpGUID = this.generateGUID('MSP-PLIMT', tmpCompositeKey);
					tmpPLIMTBucket[tmpGUID] = Object.assign({}, pProjectRef, {
						GUIDProjectLineItemMaterialTest: tmpGUID,
						// GUID-FK — IntegrationAdapter resolves to the dest IDLineItem at push time.
						GUIDLineItem: tmpCloneLIGUID,
						IDMaterial: src.IDMaterial,
						IDTest: src.IDTest,
						IDLab: src.IDLab || 0,
						Intent: src.Intent || '',
						SampleType: src.SampleType || '',
						SampleSize: src.SampleSize || 0,
						SampleUnits: src.SampleUnits || '',
						Rate: src.Rate || 0,
						Frequency: src.Frequency || 0,
						Units: src.Units || '',
						TestDescription: src.TestDescription || '',
						SampleDescription: src.SampleDescription || '',
						SamplingInstructions: src.SamplingInstructions || '',
						SamplingRequirements: src.SamplingRequirements || '',
						SamplingPeriod: src.SamplingPeriod || '',
						Remarks: src.Remarks || '',
						ConversionFactor: src.ConversionFactor || 1,
						CertificateRequired: src.CertificateRequired || 0,
						TestsNotRequired: src.TestsNotRequired || 0,
						ErrorOmission: src.ErrorOmission || 0,
						ErrorOmissionDetail: src.ErrorOmissionDetail || '',
						ManualPlannedSampleCount: -1,
						ManualRequiredSampleCount: -1,
						ComputedPlannedSampleCount: 0,
						ComputedRequiredSampleCount: 0,
						CreatedSampleCount: 0,
						PassingSampleCount: 0,
						FailingSampleCount: 0,
						Deleted: 0,
					});
				}

				for (const src of tmpSourceMLIJs)
				{
					const tmpCloneLIGUID = tmpSourceIDToCloneGUID[src.IDLineItem];
					if (!tmpCloneLIGUID)
					{
						tmpOrphanedMLIJs++;
						continue;
					}
					// Dedup on (source IDLineItem, IDMaterial) — composite key matches the
					// MSP-MLJ key from when sample-plan-copy seeded dest by integer IDLineItem,
					// just substituted to the *source* LI's id for stability across re-clones.
					const tmpKey = `${src.IDLineItem}|${src.IDMaterial}`;
					if (tmpSeenMLIJ[tmpKey]) continue;
					tmpSeenMLIJ[tmpKey] = true;
					const tmpGUID = this.generateGUID('MSP-MLJ', `${tmpDestIdentifier}|${tmpKey}`);
					tmpMLIJBucket[tmpGUID] = {
						GUIDMaterialLineItemJoin: tmpGUID,
						GUIDLineItem: tmpCloneLIGUID,
						IDMaterial: src.IDMaterial,
						ConversionFactor: src.ConversionFactor || 1,
						ApprovedSourceRequired: src.ApprovedSourceRequired || 0,
						SpecialInstructions: src.SpecialInstructions || '',
						Units: src.Units || '',
						SampleRate: src.SampleRate || 0,
						SampleFrequency: src.SampleFrequency || 0,
						RequiredSampleCount: src.RequiredSampleCount || 0,
						Quantity: src.Quantity || 0,
						Deleted: 0,
					};
				}

				if (tmpOrphanedPLIMTs > 0)
				{
					tmpWarnings.push(`Sample plan: ${tmpOrphanedPLIMTs} source PLIMT row(s) skipped — their source LineItem was not in the clone set.`);
				}
				if (tmpOrphanedMLIJs > 0)
				{
					tmpWarnings.push(`Sample plan: ${tmpOrphanedMLIJs} source MLJ row(s) skipped — their source LineItem was not in the clone set.`);
				}

				return fCallback(null,
					{
						buckets:
						{
							ProjectLineItemMaterialTest: tmpPLIMTBucket,
							MaterialLineItemJoin: tmpMLIJBucket,
						},
						counts:
						{
							ProjectLineItemMaterialTest: { Source: tmpSourcePLIMTs.length, ToCreate: Object.keys(tmpPLIMTBucket).length },
							MaterialLineItemJoin: { Source: tmpSourceMLIJs.length, ToCreate: Object.keys(tmpMLIJBucket).length },
						},
						warnings: tmpWarnings,
					});
			});
	}

	/**
	 * Fetch the source customer's EmailRule rows that should be cloned onto the
	 * destination project. Email rules aren't project-scoped by a column — the
	 * `Projects` TEXT column holds a JSON array of project IDs (empty = "all
	 * projects" wildcard), so we read every rule for the customer and filter by
	 * membership in JS, exactly as the email service does when matching rules.
	 *
	 * A rule is cloneable when its `Projects` list is non-empty (a wildcard rule
	 * already applies to the destination — nothing to clone) AND includes the
	 * source project AND does not already include the destination project (that
	 * corresponding coverage effectively already exists).
	 *
	 * @param {number} pSourceCustomerID
	 * @param {number} pSourceIDProject
	 * @param {number|null} pDestIDProject - the numeric dest; null to skip the
	 *        "already includes dest" filter (used for AUTO_CREATE preview counts,
	 *        where the dest IDProject isn't known yet).
	 * @param {function(Error|null, Array=)} fCallback
	 * @private
	 */
	_fetchCloneableEmailRules(pSourceCustomerID, pSourceIDProject, pDestIDProject, fCallback)
	{
		if (!(Number(pSourceCustomerID) > 0))
		{
			return fCallback(null, []);
		}
		this.restClient.getEntitySet('EmailRule', `FBV~IDCustomer~EQ~${pSourceCustomerID}`,
			(pError, pRows) =>
			{
				if (pError) return fCallback(pError);
				const tmpCloneable = [];
				for (const tmpRule of (pRows || []))
				{
					const tmpProjects = this._parseJSONArray(tmpRule.Projects);
					// Wildcard (empty) rules already apply to the destination.
					if (tmpProjects.length === 0) continue;
					// Only rules that actually target the source project.
					if (!tmpProjects.includes(pSourceIDProject)) continue;
					// Skip when the destination is already covered by this rule.
					if (pDestIDProject && tmpProjects.includes(pDestIDProject)) continue;
					tmpCloneable.push(tmpRule);
				}
				return fCallback(null, tmpCloneable);
			}, 0, 200000);
	}

	/**
	 * Build the EmailRule + EmailRuleSchedule slice of the comprehension.
	 *
	 * For each cloneable source rule (see `_fetchCloneableEmailRules`) we emit a
	 * NEW corresponding rule that targets ONLY the destination project
	 * (`Projects: [destID]`), carrying a deterministic `PCL-ER-…` GUID so a
	 * re-clone upserts in place and the type-seeding prune (which keys off the
	 * `PCL-` prefix) can recognize it as seed-origin. The rule's Enabled state is
	 * preserved verbatim (a disabled source rule clones as disabled). `IDClonedRule`
	 * records the immediate source rule for audit.
	 *
	 * Scheduled rules (Handlers like ApprovalRollup / DailyTally) store their cron
	 * timing in a separate EmailRuleSchedule entity; a scheduled rule with no
	 * schedule row never fires, so each cloned rule's schedules ride along, bridged
	 * to the cloned rule via the `GUIDEmailRule` GUID-FK (the comprehension
	 * processor resolves it to the new IDEmailRule at push time).
	 *
	 * Requires a NUMERIC destination IDProject (the `Projects` array embeds it as a
	 * literal — the processor can't resolve a GUID inside a JSON string). Callers
	 * therefore only invoke this once the dest IDProject is known: inline for
	 * UPDATE_EXISTING clone + all type-seeding, and post-resolution for AUTO_CREATE.
	 *
	 * @param {number} pSourceIDProject
	 * @param {number} pSourceCustomerID - customer whose rules we read.
	 * @param {number} pDestIDProject - the resolved numeric destination project.
	 * @param {number} pDestCustomerID - customer stamped onto the cloned rows.
	 * @param {object} pOptions
	 * @param {function(Error|null, { buckets: object, counts: object, warnings: string[] }=)} fCallback
	 * @private
	 */
	_buildEmailRuleSlice(pSourceIDProject, pSourceCustomerID, pDestIDProject, pDestCustomerID, pOptions, fCallback)
	{
		this.log.info(`  Building email-rule slice (EmailRule + EmailRuleSchedule)...`);
		const tmpWarnings = [];
		const tmpEmailRuleBucket = {};
		const tmpEmailRuleScheduleBucket = {};
		// Map a source rule's IDEmailRule to the cloned rule's GUID so schedules can
		// bridge to their (re)parented rule.
		const tmpSourceRuleIDToCloneGUID = {};
		// Per-rule config to re-home after push (skips the shared 'default').
		const tmpConfigSync = [];

		this._fetchCloneableEmailRules(pSourceCustomerID, pSourceIDProject, pDestIDProject,
			(pError, pCloneableRules) =>
			{
				if (pError) return fCallback(pError);

				for (const tmpRule of pCloneableRules)
				{
					const tmpGUID = this.generateGUID('PCL-ER', `${pDestIDProject}|${tmpRule.IDEmailRule}`);
					tmpSourceRuleIDToCloneGUID[tmpRule.IDEmailRule] = tmpGUID;
					tmpEmailRuleBucket[tmpGUID] = {
						GUIDEmailRule: tmpGUID,
						IDCustomer: pDestCustomerID,
						// The corresponding rule targets ONLY the destination project.
						// `Projects` is a JSON-array column the API serializes on write,
						// so emit a raw array — pre-stringifying double-encodes it to
						// a `"[id]"` string that no longer parses as a project list.
						Projects: [pDestIDProject],
						DocumentType: tmpRule.DocumentType || '',
						// `Status` is likewise a JSON-array column; normalize to a raw
						// array (the read may hand back an array or a JSON string).
						Status: this._parseJSONArray(tmpRule.Status),
						Handler: tmpRule.Handler || '',
						Config: tmpRule.Config || '',
						// Preserve the source rule's enabled/disabled state.
						Enabled: tmpRule.Enabled || 0,
						// Audit pointer back to the immediate source rule.
						IDClonedRule: tmpRule.IDEmailRule,
					};

					// A per-rule config (NamespaceValue keyed by the source rule's own
					// id — the app writes `IDEmailRule-<id>`) must be copied to the
					// cloned rule's own namespace value post-push; the shared 'default'
					// (or an empty Config) already exists at the dest customer.
					const tmpRuleConfig = (typeof(tmpRule.Config) === 'string') ? tmpRule.Config.trim() : '';
					if (tmpRuleConfig !== '' && tmpRuleConfig !== 'default')
					{
						tmpConfigSync.push(
							{
								GUIDEmailRule: tmpGUID,
								Handler: tmpRule.Handler || '',
								SourceConfig: tmpRuleConfig,
								SourceCustomerID: pSourceCustomerID,
								DestCustomerID: pDestCustomerID,
							});
					}
				}

				// `Config` names a CUSTOMER-level configuration namespace; when the
				// clone crosses customers that namespace may not exist under the dest
				// customer. Surface it rather than silently shipping a dangling ref.
				if (pCloneableRules.length > 0 && Number(pSourceCustomerID) !== Number(pDestCustomerID))
				{
					tmpWarnings.push(`Email rules: cloned ${pCloneableRules.length} rule(s) across customers (${pSourceCustomerID} → ${pDestCustomerID}); each rule's Config namespace may not exist under the destination customer and may need to be provisioned.`);
				}

				const tmpSourceRuleIDs = pCloneableRules.map((pRule) => pRule.IDEmailRule);
				if (tmpSourceRuleIDs.length === 0)
				{
					return fCallback(null, this._emailRuleSliceResult(tmpEmailRuleBucket, tmpEmailRuleScheduleBucket, pCloneableRules.length, 0, tmpWarnings, tmpConfigSync));
				}

				// Fetch the schedules for exactly the rules we're cloning. ERS has no
				// IDProject column, so fetch by IDEmailRule INN against the source rule ids.
				this.getEntitySetBatched('EmailRuleSchedule', 'IDEmailRule', tmpSourceRuleIDs, null,
					(pScheduleError, pScheduleRows) =>
					{
						if (pScheduleError) return fCallback(pScheduleError);
						let tmpOrphanedSchedules = 0;
						for (const tmpSchedule of (pScheduleRows || []))
						{
							const tmpCloneRuleGUID = tmpSourceRuleIDToCloneGUID[tmpSchedule.IDEmailRule];
							if (!tmpCloneRuleGUID)
							{
								// Parent rule wasn't cloned — nothing to attach to.
								tmpOrphanedSchedules++;
								continue;
							}
							const tmpScheduleGUID = this.generateGUID('PCL-ERS', `${pDestIDProject}|${tmpSchedule.IDEmailRuleSchedule}`);
							tmpEmailRuleScheduleBucket[tmpScheduleGUID] = {
								GUIDEmailRuleSchedule: tmpScheduleGUID,
								// GUID-FK — resolved to the cloned rule's IDEmailRule at push time.
								GUIDEmailRule: tmpCloneRuleGUID,
								IDCustomer: pDestCustomerID,
								DayOfMonth: (tmpSchedule.DayOfMonth != null) ? tmpSchedule.DayOfMonth : -1,
								DayOfWeek: (tmpSchedule.DayOfWeek != null) ? tmpSchedule.DayOfWeek : -1,
								HourOfDay: tmpSchedule.HourOfDay || 0,
							};
						}
						if (tmpOrphanedSchedules > 0)
						{
							tmpWarnings.push(`Email rules: ${tmpOrphanedSchedules} schedule row(s) skipped — their parent rule was not in the clone set.`);
						}
						return fCallback(null, this._emailRuleSliceResult(
							tmpEmailRuleBucket, tmpEmailRuleScheduleBucket, pCloneableRules.length,
							(pScheduleRows || []).length - tmpOrphanedSchedules, tmpWarnings, tmpConfigSync));
					});
			});
	}

	/**
	 * Shape the email-rule slice return envelope (buckets + counts + warnings),
	 * matching the sample-plan slice's `{ Source, ToCreate }` count convention.
	 * @private
	 */
	_emailRuleSliceResult(pEmailRuleBucket, pEmailRuleScheduleBucket, pRuleSourceCount, pScheduleSourceCount, pWarnings, pConfigSync)
	{
		return {
			buckets:
			{
				EmailRule: pEmailRuleBucket,
				EmailRuleSchedule: pEmailRuleScheduleBucket,
			},
			counts:
			{
				EmailRule: { Source: pRuleSourceCount, ToCreate: Object.keys(pEmailRuleBucket).length },
				EmailRuleSchedule: { Source: pScheduleSourceCount, ToCreate: Object.keys(pEmailRuleScheduleBucket).length },
			},
			warnings: pWarnings,
			configSync: pConfigSync || [],
		};
	}

	/**
	 * Push a previously-built comprehension to the server by delegating to
	 * `headlight-comprehension-processor`. The processor scans each record for
	 * `GUID<Entity>` / `_GUID<Entity>` / `_Dest_IDEntity_*_Via_GUID<Entity>`
	 * fields, builds a dependency graph, topologically sorts entities, then
	 * pushes each through a fresh `headlight-integration-adapter` with the
	 * same options `/PushComprehension`'s `applyComprehensionSubtree` uses
	 * (`SimpleMarshal: true`, `ForceMarshal: true`, empty prefixes — so our
	 * `PCL-LI-…` / `MSP-PLIMT-…` keys are used as-is and cross-entity FKs
	 * resolve via the in-call `HeadlightGUIDMap`).
	 *
	 * The `require` is intentionally lazy: this keeps consumers that only
	 * call `buildComprehension` (e.g. the API service's `GET /ProjectClone/Preview`
	 * bundle, which doesn't vendor the processor) from failing on module load.
	 *
	 * Why not POST to /PushComprehension instead? Two reasons that don't go
	 * away with the processor refactor:
	 *  - CLI consumers authenticate as a real user; /PushComprehension is gated
	 *    for trusted internal services, not user-facing tools.
	 *  - Server-side consumers (a hypothetical `POST /ProjectClone/Apply`)
	 *    would be making a loopback HTTP hop on the same service when the
	 *    processor is callable in-process.
	 *
	 * @param {object} pComprehension - Output of buildComprehension().comprehension.
	 * @param {function(Error|null)} fCallback
	 */
	loadComprehension(pComprehension, fCallback)
	{
		const libComprehensionProcessor = require('headlight-comprehension-processor');
		if (!this.fable.servicesMap.ComprehensionProcessor)
		{
			this.fable.addServiceType('ComprehensionProcessor', libComprehensionProcessor);
		}
		const tmpProcessor = this.fable.instantiateServiceProviderWithoutRegistration('ComprehensionProcessor');
		// Hand it our already-authenticated rest client so it skips its own
		// CheckSession / authenticate round-trip and pushes through the same
		// session the caller set up.
		tmpProcessor.client = this.restClient;
		return tmpProcessor.integrateComprehension(pComprehension, fCallback);
	}

	/**
	 * Apply every Project-layer Configuration namespace to a destination project
	 * via the Configuration microservice. Iterates each `(NamespaceKey,
	 * NamespaceValue)` pair and POSTs to `Configuration/Put/<NamespaceKey>/
	 * <NamespaceValue>/IDProject/<dest>`. Order doesn't matter — each pair is
	 * independent. POSTs that succeed invalidate the config service's cache
	 * as a side-effect of going through `/Configuration/Put`, so dest reads
	 * pick up the new values without manual cache busting.
	 *
	 * Per-pair errors are collected into the result rather than aborting the
	 * loop, so one bad blob doesn't orphan the rest.
	 *
	 * @param {number} pDestIDProject
	 * @param {object} pConfigByNamespaceKey - Output of buildComprehension().configuration:
	 *        `{ <NamespaceKey>: { <NamespaceValue>: <blob> }, … }`.
	 * @param {function(Error|null, { applied: number, errors: Array<{ NamespaceKey: string, NamespaceValue: string, Error: string }> }=)} fCallback
	 */
	applyAllConfiguration(pDestIDProject, pConfigByNamespaceKey, fCallback)
	{
		const tmpConfig = pConfigByNamespaceKey || {};
		// Flatten into a list of POST jobs we can iterate with libAsync.eachSeries.
		const tmpJobs = [];
		for (const tmpKey of Object.keys(tmpConfig))
		{
			const tmpBlob = tmpConfig[tmpKey] || {};
			for (const tmpValue of Object.keys(tmpBlob))
			{
				tmpJobs.push({ NamespaceKey: tmpKey, NamespaceValue: tmpValue, Body: tmpBlob[tmpValue] });
			}
		}
		if (tmpJobs.length === 0)
		{
			this.log.info('[ProjectCloning] No Configuration to apply',
				{ Action: 'ProjectCloning-ConfigEmpty', IDProject: pDestIDProject });
			return fCallback(null, { applied: 0, errors: [] });
		}

		this.log.info('[ProjectCloning] Applying Configuration namespaces',
			{ Action: 'ProjectCloning-ConfigApplyStart', IDProject: pDestIDProject, Jobs: tmpJobs.length, Namespaces: Object.keys(tmpConfig).length });

		// Configuration writes require elevated privileges. Spin up a parallel
		// rest client impersonated as the dest customer's Concierge user (see
		// _buildConciergeClient) so the requesting user's own client — which
		// typically lacks Configuration-write rights — never touches the
		// Configuration service. The caller's client is left untouched either way.
		this.restClient.getEntity('Project', pDestIDProject,
			(pProjError, pDestProject) =>
			{
				if (pProjError || !pDestProject || !pDestProject.IDCustomer)
				{
					this.log.warn('[ProjectCloning] Could not resolve IDCustomer for Concierge lookup; falling back to caller client',
						{ Action: 'ProjectCloning-ConfigFallbackNoCustomer', IDProject: pDestIDProject, Error: pProjError ? (pProjError.message || String(pProjError)) : null });
					return this._writeConfigurationPOSTs(this.restClient, pDestIDProject, tmpJobs, fCallback);
				}
				this._buildConciergeClient(pDestProject.IDCustomer,
					(pErr, pConciergeClient) =>
					{
						// pErr is non-fatal — _buildConciergeClient logs and
						// returns null when concierge resolution or impersonation
						// fails. Either way we end up with a usable client.
						const tmpClient = pConciergeClient || this.restClient;
						if (!pConciergeClient)
						{
							this.log.warn('[ProjectCloning] Falling back to caller client for Configuration writes',
								{ Action: 'ProjectCloning-ConfigFallback', IDProject: pDestIDProject, IDCustomer: pDestProject.IDCustomer });
						}
						return this._writeConfigurationPOSTs(tmpClient, pDestIDProject, tmpJobs, fCallback);
					});
			});
	}

	/**
	 * Find the Concierge machine-account user for a customer. Concierge users
	 * follow the convention of a GUIDUser ending in `-Concierge` (the customer
	 * provisioning bootstrap creates them with that suffix), so we filter by
	 * IDCustomer + a LIKE on GUIDUser. There's at most one per customer; if
	 * none is found the caller falls back to the requesting user's own client.
	 *
	 * @param {number} pIDCustomer
	 * @param {function(Error|null, number)} fCallback - IDUser, or 0 when no concierge exists.
	 */
	_resolveConciergeUserID(pIDCustomer, fCallback)
	{
		const tmpFilter = `FBV~IDCustomer~EQ~${pIDCustomer}~FBV~GUIDUser~LK~%25-Concierge`;
		this.restClient.getEntitySet('User', tmpFilter,
			(pError, pUsers) =>
			{
				if (pError) return fCallback(pError, 0);
				const tmpUser = (Array.isArray(pUsers) && pUsers.length > 0) ? pUsers[0] : null;
				return fCallback(null, (tmpUser && tmpUser.IDUser) ? Number(tmpUser.IDUser) : 0);
			},
			0, 1);
	}

	/**
	 * Build a separate HeadlightRestClient instance impersonated as the
	 * customer's Concierge user. The flow mirrors the
	 * `HeadlightEssentialDataProvider.getImpersonatedSession` pattern used in
	 * the materials micro-service:
	 *
	 *   1. Spawn a fresh HeadlightRestClient (so the caller's client is
	 *      untouched).
	 *   2. Authenticate it as the configured `HeadLight.ElevatedUser` — a
	 *      service-account user whose privileges include impersonation. The
	 *      requesting user typically does NOT have impersonation rights, so
	 *      we never use the caller's session for the handshake.
	 *   3. `GET /Authentication/Impersonate/<conciergeIDUser>` to swap that
	 *      same client's session onto the concierge.
	 *   4. Hand the resulting client back to the caller — every subsequent
	 *      request through it runs as the concierge.
	 *
	 * No `X-Service-Trust` header is set: concierge privileges are expected
	 * to be sufficient for Configuration writes on their own.
	 *
	 * Returns `null` (not an error) when concierge resolution, ElevatedUser
	 * auth, or impersonation fail — the caller falls back to its own client
	 * and the Configuration POSTs will at least surface whatever permission
	 * error is in play, instead of getting silently lost.
	 *
	 * @param {number} pIDCustomer
	 * @param {function(Error|null, *|null)} fCallback - impersonated client or null.
	 */
	/**
	 * Log out every cached concierge session and clear the cache. Callers that
	 * drive multiple elevated steps (email-rule config sync + Configuration
	 * writes) call this once at the end of their run; the concierge session is
	 * a live privileged credential and must not linger until TTL. Best-effort:
	 * a failed logout is logged and never surfaces as an error.
	 *
	 * @param {function(Error|null)} fCallback
	 */
	retireConciergeClients(fCallback)
	{
		const tmpClients = Object.values(this._ConciergeClients);
		this._ConciergeClients = {};
		if (tmpClients.length === 0)
		{
			return fCallback(null);
		}
		libAsync.eachSeries(tmpClients,
			(pClient, fDone) =>
			{
				const tmpSession = this._clientSession(pClient);
				if (!tmpSession || !tmpSession.SessionID || typeof pClient.deauthenticate !== 'function')
				{
					return fDone();
				}
				pClient.deauthenticate(() => fDone());
			},
			() => fCallback(null));
	}

	/**
	 * The client's live session, across client variants (the real
	 * HeadlightRestClient exposes `.session`; stubs may only expose
	 * `getSessionData()`).
	 *
	 * @param {*} pClient
	 * @returns {object|null}
	 */
	_clientSession(pClient)
	{
		if (!pClient)
		{
			return null;
		}
		if (pClient.session)
		{
			return pClient.session;
		}
		return (typeof pClient.getSessionData === 'function') ? pClient.getSessionData() : null;
	}

	_buildConciergeClient(pIDCustomer, fCallback)
	{
		const tmpCached = this._ConciergeClients[pIDCustomer];
		const tmpCachedSession = this._clientSession(tmpCached);
		if (tmpCachedSession && tmpCachedSession.SessionID)
		{
			return fCallback(null, tmpCached);
		}
		// ElevatedUser creds come from the same settings path the materials
		// service reads — `HeadLight.ElevatedUser.{Username,Password}` — so
		// deployments configure one shared service account, not a per-app one.
		const tmpHeadLightSettings = (this.fable.settings && this.fable.settings.HeadLight) || {};
		const tmpElevatedUser = tmpHeadLightSettings.ElevatedUser || {};
		if (!tmpElevatedUser.Username || !tmpElevatedUser.Password)
		{
			this.log.warn('[ProjectCloning] HeadLight.ElevatedUser not configured; cannot build concierge client',
				{ Action: 'ProjectCloning-ConciergeSkipUnconfigured', IDCustomer: pIDCustomer });
			return fCallback(null, null);
		}

		this._resolveConciergeUserID(pIDCustomer,
			(pError, pConciergeIDUser) =>
			{
				if (pError)
				{
					this.log.warn('[ProjectCloning] Concierge lookup failed',
						{ Action: 'ProjectCloning-ConciergeLookupError', IDCustomer: pIDCustomer, Error: pError.message || String(pError) });
					return fCallback(null, null);
				}
				if (!pConciergeIDUser)
				{
					this.log.warn('[ProjectCloning] No Concierge user found for customer',
						{ Action: 'ProjectCloning-ConciergeMissing', IDCustomer: pIDCustomer });
					return fCallback(null, null);
				}

				let tmpConciergeClient;
				try
				{
					// CRITICAL: pass ServerURL + EnforceSSL from the caller's
					// (already-configured) client. Otherwise the parallel
					// HeadlightRestClient falls back to its module-level default —
					// which is the hardcoded QA URL
					// (`https://api.qa.headlight.com/1.0/`, see
					// `defaultHeadLightRestClientOptions` in
					// `headlight-rest-client`). On PROD that means the ElevatedUser
					// login attempt goes to QA, where the same username has a
					// different password, so the auth silently fails and the
					// caller falls back to its own unprivileged client for
					// Configuration writes.
					const clientOptions =
					{
						ServerURL: this.restClient && this.restClient.serverURL,
						EnforceSSL: this.restClient && this.restClient.enforceSSL,
					};
					this.log.info(`[ProjectCloning] instantiating dedicated client for concierge`,
						{ Action: 'ProjectCloning-ConciergeClientSetup', IDCustomer: pIDCustomer, clientOptions });
					tmpConciergeClient = this.fable.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', clientOptions);
				}
				catch (pInstErr)
				{
					this.log.warn('[ProjectCloning] Could not instantiate parallel HeadlightRestClient',
						{ Action: 'ProjectCloning-ConciergeClientInstantiationError', IDCustomer: pIDCustomer, Error: pInstErr.message || String(pInstErr) });
					return fCallback(null, null);
				}
				if (!tmpConciergeClient)
				{
					this.log.warn('[ProjectCloning] Parallel HeadlightRestClient instantiation returned nothing',
						{ Action: 'ProjectCloning-ConciergeClientNull', IDCustomer: pIDCustomer });
					return fCallback(null, null);
				}

				if (typeof tmpConciergeClient.authenticateWithCredentials !== 'function'
					|| typeof tmpConciergeClient.impersonate !== 'function')
				{
					this.log.warn('[ProjectCloning] HeadlightRestClient missing authenticateWithCredentials/impersonate',
						{ Action: 'ProjectCloning-ConciergeClientMissingMethods', IDCustomer: pIDCustomer });
					return fCallback(null, null);
				}

				// Step 1: log in as the ElevatedUser. This client now holds the
				// elevated session — used ONLY long enough to impersonate the
				// concierge, never reused for tenant data writes.
				tmpConciergeClient.authenticateWithCredentials(tmpElevatedUser.Username, tmpElevatedUser.Password,
					(pAuthError) =>
					{
						if (pAuthError)
						{
							this.log.error('[ProjectCloning] ElevatedUser authentication failed',
								{
									Action: 'ProjectCloning-ElevatedUserAuthFailed',
									IDCustomer: pIDCustomer,
									ElevatedUsername: tmpElevatedUser.Username,
									Error: pAuthError.message || String(pAuthError),
								});
							return fCallback(null, null);
						}
						// Step 2: swap the elevated session onto the concierge.
						tmpConciergeClient.impersonate(pConciergeIDUser,
							(pImpError) =>
							{
								if (pImpError)
								{
									this.log.error('[ProjectCloning] Concierge impersonation failed',
										{
											Action: 'ProjectCloning-ConciergeImpersonateFailed',
											IDCustomer: pIDCustomer,
											ConciergeIDUser: pConciergeIDUser,
											Error: pImpError.message || String(pImpError),
										});
									return fCallback(null, null);
								}
								this.log.info('[ProjectCloning] Concierge impersonation active',
									{ Action: 'ProjectCloning-ConciergeImpersonateSuccess', IDCustomer: pIDCustomer, ConciergeIDUser: pConciergeIDUser });
								this._ConciergeClients[pIDCustomer] = tmpConciergeClient;
								return fCallback(null, tmpConciergeClient);
							});
					});
			});
	}

	/**
	 * Iterate the Configuration POST jobs through the supplied client. Pulled
	 * out of `applyAllConfiguration` so the same loop runs whether we end up
	 * with the concierge-impersonated client or the caller's own.
	 *
	 * @param {*} pClient
	 * @param {number} pDestIDProject
	 * @param {Array<{NamespaceKey:string, NamespaceValue:string, Body:*}>} pJobs
	 * @param {function(Error|null, { applied:number, errors:Array }=)} fCallback
	 */
	/**
	 * Deep field-level merge: plain objects recurse; on any other conflict
	 * (scalar, array, type mismatch) the overlay wins; base-only keys are
	 * preserved. Neither input is mutated.
	 *
	 * @param {object} pBase
	 * @param {object} pOverlay
	 * @returns {object}
	 */
	_deepMergeObjects(pBase, pOverlay)
	{
		const tmpMerged = {};
		for (const tmpKey in (pBase || {}))
		{
			tmpMerged[tmpKey] = pBase[tmpKey];
		}
		for (const tmpKey in (pOverlay || {}))
		{
			const tmpBaseValue = tmpMerged[tmpKey];
			const tmpOverlayValue = pOverlay[tmpKey];
			const tmpBothObjects = tmpBaseValue && typeof tmpBaseValue === 'object' && !Array.isArray(tmpBaseValue)
				&& tmpOverlayValue && typeof tmpOverlayValue === 'object' && !Array.isArray(tmpOverlayValue);
			tmpMerged[tmpKey] = tmpBothObjects ? this._deepMergeObjects(tmpBaseValue, tmpOverlayValue) : tmpOverlayValue;
		}
		return tmpMerged;
	}

	/**
	 * Merge each job's source blob over the destination's CURRENT Project-layer
	 * value for the same (NamespaceKey, NamespaceValue) — source wins conflicts,
	 * dest-only fields survive. One read per distinct NamespaceKey
	 * (`Configuration/For/<key>/In/Project/<dest>`, Project layer only, no
	 * cascade). A failed read logs a warning and leaves that job's blob
	 * unmerged rather than blocking the write.
	 *
	 * @param {*} pClient
	 * @param {number} pDestIDProject
	 * @param {Array<{ NamespaceKey: string, NamespaceValue: string, Body: object }>} pJobs
	 * @param {function(Array<object>)} fCallback - The jobs with merged bodies.
	 */
	_mergeConfigurationJobs(pClient, pDestIDProject, pJobs, fCallback)
	{
		const tmpKeys = Array.from(new Set(pJobs.map((pJob) => pJob.NamespaceKey)));
		const tmpDestBlobsByKey = {};
		libAsync.eachSeries(tmpKeys,
			(pKey, fNext) =>
			{
				const tmpFetchURI = `Configuration/For/${encodeURIComponent(pKey)}/In/Project/${pDestIDProject}`;
				pClient.getJSON(tmpFetchURI,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.log.warn('[ProjectCloning] Destination Configuration read failed; writing this namespace unmerged',
								{ Action: 'ProjectCloning-ConfigMergeReadWarning', IDProject: pDestIDProject, NamespaceKey: pKey, Error: pError.message || String(pError) });
						}
						else if (pBody && typeof pBody === 'object')
						{
							tmpDestBlobsByKey[pKey] = pBody;
						}
						return fNext();
					});
			},
			() =>
			{
				const tmpMergedJobs = pJobs.map((pJob) =>
				{
					const tmpDestValue = tmpDestBlobsByKey[pJob.NamespaceKey] && tmpDestBlobsByKey[pJob.NamespaceKey][pJob.NamespaceValue];
					const tmpBothObjects = tmpDestValue && typeof tmpDestValue === 'object' && !Array.isArray(tmpDestValue)
						&& pJob.Body && typeof pJob.Body === 'object' && !Array.isArray(pJob.Body);
					if (!tmpBothObjects)
					{
						return pJob;
					}
					return { NamespaceKey: pJob.NamespaceKey, NamespaceValue: pJob.NamespaceValue, Body: this._deepMergeObjects(tmpDestValue, pJob.Body) };
				});
				return fCallback(tmpMergedJobs);
			});
	}

	_writeConfigurationPOSTs(pClient, pDestIDProject, pJobs, fCallback)
	{
		this.log.info('[ProjectCloning] Writing Configuration namespace-value pairs',
			{ Action: 'ProjectCloning-ConfigWriteStart', IDProject: pDestIDProject, Jobs: pJobs.length });
		const tmpErrors = [];
		let tmpApplied = 0;

		this._mergeConfigurationJobs(pClient, pDestIDProject, pJobs, (pMergedJobs) =>
		{
			libAsync.eachSeries(pMergedJobs,
				(pJob, fNext) =>
				{
					// URL form matters: Put/:NS/:NV/:LevelContext/:LevelContextID
					// writes at the named LevelContext, but the alternate
					// Put/:NS/:NV/IDProject/:IDProject form does NOT — the handler
					// falls back to LevelContext='User' because the route doesn't
					// capture :LevelContext. We want Project-layer writes so the
					// matching read path (Describe + For/<NS>/In/Project) sees them,
					// so we use the explicit /Project/<id> form here.
					// See api/config/source/endpoints/Configuration-Put-ByNamespace.js
					// line 184: `const levelContext = request.params.LevelContext || 'User';`
					const tmpURI = `Configuration/Put/${encodeURIComponent(pJob.NamespaceKey)}/${encodeURIComponent(pJob.NamespaceValue)}/Project/${pDestIDProject}`;
					pClient.postJSON(tmpURI, pJob.Body,
						(pError) =>
						{
							if (pError)
							{
								const errMsg = (pError && pError.message) || String(pError);
								this.log.error('[ProjectCloning] Configuration write failed',
									{
										Action: 'ProjectCloning-ConfigWriteError',
										IDProject: pDestIDProject,
										NamespaceKey: pJob.NamespaceKey,
										NamespaceValue: pJob.NamespaceValue,
										Error: errMsg,
									});
								tmpErrors.push({ NamespaceKey: pJob.NamespaceKey, NamespaceValue: pJob.NamespaceValue, Error: errMsg });
							}
							else
							{
								tmpApplied++;
								this.log.info('[ProjectCloning] Configuration write applied',
									{
										Action: 'ProjectCloning-ConfigWriteApplied',
										IDProject: pDestIDProject,
										NamespaceKey: pJob.NamespaceKey,
										NamespaceValue: pJob.NamespaceValue,
									});
							}
							return fNext();
						});
				},
				() =>
				{
					this.log.info('[ProjectCloning] Configuration writes complete',
						{
							Action: 'ProjectCloning-ConfigWriteComplete',
							IDProject: pDestIDProject,
							Jobs: pJobs.length,
							Applied: tmpApplied,
							Errors: tmpErrors.length,
						});
					return fCallback(null, { applied: tmpApplied, errors: tmpErrors });
				});
		});
	}

	/**
	 * Build + apply in one call. Convenience for CLI / one-shot server callers.
	 * Pushes the Meadow comprehension first, then writes the full Configuration
	 * blob (every Project-layer namespace) via the Configuration service. The two
	 * are independent; configuration comes second because it's typically small
	 * and we want the heavy work to surface errors first.
	 *
	 * In AUTO_CREATE mode the dest project doesn't have an IDProject until after
	 * the comprehension lands. After loadComprehension we look the new project up
	 * by its deterministic GUIDProject to get its IDProject for the configuration step.
	 *
	 * @param {number} pSourceIDProject
	 * @param {number|null|undefined} pDestIDProject - omit / null / 0 to auto-create.
	 * @param {object} [pOptions] - see buildComprehension options.
	 * @param {function(Error|null, { build: object, configuration: object, resolvedDestIDProject: number }=)} fCallback
	 */
	cloneProject(pSourceIDProject, pDestIDProject, pOptions, fCallback)
	{
		if (typeof(pOptions) === 'function')
		{
			fCallback = pOptions;
			pOptions = {};
		}
		this.buildComprehension(pSourceIDProject, pDestIDProject, pOptions,
			(pError, pBuild) =>
			{
				if (pError) return fCallback(pError);
				this.loadComprehension(pBuild.comprehension,
					(pLoadError) =>
					{
						if (pLoadError) return fCallback(pLoadError, { build: pBuild });
						// Resolve the dest IDProject — known up-front in UPDATE_EXISTING,
						// looked up by GUID in AUTO_CREATE.
						this._resolveDestIDProject(pBuild,
							(pResolveError, pResolvedID) =>
							{
								if (pResolveError) return fCallback(pResolveError, { build: pBuild });
								// AUTO_CREATE deferred the email-rule slice (the dest IDProject
								// wasn't known at build time). Now that it's resolved, build and
								// push that slice before applying Configuration.
								this._applyDeferredEmailRules(pBuild, pResolvedID, pOptions,
									(pEmailError) =>
									{
										if (pEmailError) return fCallback(pEmailError, { build: pBuild, resolvedDestIDProject: pResolvedID });
										// Re-home each cloned rule's per-rule config now that the rules
										// have new ids (post-push). Warnings only — never fails the clone.
										this.syncClonedEmailRuleConfigs(pBuild.emailRuleConfigSync,
											(pSyncErr, pSyncResult) =>
											{
												if (pSyncResult && Array.isArray(pSyncResult.warnings))
												{
													for (const w of pSyncResult.warnings) pBuild.warnings.push(w);
												}
											this.applyAllConfiguration(pResolvedID, pBuild.configuration,
												(pConfigError, pConfigResult) =>
												{
													return fCallback(pConfigError,
														{
															build: pBuild,
															configuration: pConfigResult,
															resolvedDestIDProject: pResolvedID,
														});
												});
										});
											});
							});
					});
			});
	}

	/**
	 * Resolve the destination IDProject after a comprehension push. In
	 * UPDATE_EXISTING mode it's already in the build result. In AUTO_CREATE mode
	 * we look it up by the deterministic GUIDProject we generated at build time.
	 * @private
	 */
	_resolveDestIDProject(pBuild, fCallback)
	{
		const tmpDestID = pBuild && pBuild.reportData && pBuild.reportData.DestIDProject;
		if (tmpDestID)
		{
			return fCallback(null, tmpDestID);
		}
		const tmpGUID = pBuild && pBuild.reportData && pBuild.reportData.DestProjectGUID;
		if (!tmpGUID)
		{
			return fCallback(new Error('Could not resolve destination IDProject: neither DestIDProject nor DestProjectGUID is set on the build result.'));
		}
		this.restClient.getEntitySet('Project', `FBV~GUIDProject~EQ~${tmpGUID}`,
			(pError, pRows) =>
			{
				if (pError) return fCallback(pError);
				if (!pRows || pRows.length === 0)
				{
					return fCallback(new Error(`Auto-created Project [GUIDProject=${tmpGUID}] was not found on the server after push.`));
				}
				return fCallback(null, pRows[0].IDProject);
			}, 0, 1);
	}

	/**
	 * Build and push the email-rule slice that `buildComprehension` deferred in
	 * AUTO_CREATE mode (where the dest IDProject — which the cloned rules' `Projects`
	 * array must embed — wasn't known until the main push resolved the new project).
	 * A no-op for UPDATE_EXISTING (the slice was already built inline and pushed with
	 * the rest of the comprehension) and when EmailRule was excluded. On success it
	 * overwrites the deferred candidate counts on `pBuild.reportData.Counts` with the
	 * real ones.
	 *
	 * @param {object} pBuild - the buildComprehension result.
	 * @param {number} pResolvedDestIDProject
	 * @param {object} pOptions
	 * @param {function(Error|null)} fCallback
	 * @private
	 */
	_applyDeferredEmailRules(pBuild, pResolvedDestIDProject, pOptions, fCallback)
	{
		const tmpDeferred = pBuild && pBuild.reportData && pBuild.reportData.Counts && pBuild.reportData.Counts.EmailRule;
		// Only the AUTO_CREATE preview-count path stamps `Deferred: 'post-push'`.
		if (!tmpDeferred || tmpDeferred.Deferred !== 'post-push')
		{
			return fCallback(null);
		}
		// In AUTO_CREATE the new dest inherits its customer from the source, so the
		// source project's IDCustomer is both the rule-read customer and the customer
		// stamped onto the cloned rows.
		this.lookupProjectByID(pBuild.reportData.SourceIDProject,
			(pError, pSourceProject) =>
			{
				if (pError) return fCallback(pError);
				const tmpCustomerID = pSourceProject && pSourceProject.IDCustomer;
				this._buildEmailRuleSlice(pBuild.reportData.SourceIDProject, tmpCustomerID, pResolvedDestIDProject, tmpCustomerID, pOptions || {},
					(pSliceError, pSlice) =>
					{
						if (pSliceError) return fCallback(pSliceError);
						pBuild.reportData.Counts.EmailRule = pSlice.counts.EmailRule;
						pBuild.reportData.Counts.EmailRuleSchedule = pSlice.counts.EmailRuleSchedule;
						pBuild.emailRuleConfigSync = pSlice.configSync || [];
						for (const w of pSlice.warnings) pBuild.warnings.push(w);
						this.loadComprehension(
							{ EmailRule: pSlice.buckets.EmailRule, EmailRuleSchedule: pSlice.buckets.EmailRuleSchedule },
							(pLoadError) => fCallback(pLoadError));
					});
			});
	}

	/**
	 * Re-home each cloned rule's per-rule Configuration after the rules are
	 * pushed. An EmailRule's config lives in a CUSTOMER-scoped Configuration
	 * entry keyed by `NamespaceKey: EmailRule-<Handler>` / `NamespaceValue:
	 * <rule.Config>`, and the app writes that value as `IDEmailRule-<the rule's
	 * own id>`. Carrying the source value verbatim would (a) share the source
	 * rule's config on a same-customer clone and (b) dangle on a cross-customer
	 * clone. So for each cloned rule we resolve its new id, copy the source blob
	 * to `IDEmailRule-<newId>` at the dest customer, and point the rule's Config
	 * at it. Per-rule failures warn and continue — they never fail the clone.
	 *
	 * Public post-push entry point: `cloneProject` calls it after `loadComprehension`,
	 * and the type-seeding service calls it after applying its own diff-delete
	 * comprehension. Both hand in the `emailRuleConfigSync` list `buildComprehension`
	 * produced. A `null`/empty list is a no-op.
	 *
	 * @param {Array<{GUIDEmailRule:string, Handler:string, SourceConfig:string, SourceCustomerID:number, DestCustomerID:number}>} pMeta
	 * @param {function(Error|null, { synced:number, warnings:string[] }=)} fCallback
	 */
	syncClonedEmailRuleConfigs(pMeta, fCallback)
	{
		const tmpMeta = Array.isArray(pMeta) ? pMeta : [];
		if (tmpMeta.length === 0)
		{
			return fCallback(null, { synced: 0, warnings: [] });
		}
		this.log.info(`  Re-homing ${tmpMeta.length} cloned email-rule config(s)...`);
		const tmpSourceCustomerID = tmpMeta[0].SourceCustomerID;
		const tmpDestCustomerID = tmpMeta[0].DestCustomerID;
		// Configuration writes need elevated privileges the requesting user
		// typically lacks — even a customer admin — which is the same reason
		// `applyAllConfiguration` writes through a Concierge. So the config write MUST
		// run through the Concierge (impersonated as the dest customer). We route the
		// rule resolve/read/update through it too: it's already built, keeps this to a
		// single client, and also stays correct in the less-common case where the
		// acting session's customer isn't the rule's (e.g. a super-user- or
		// platform-driven clone). Same-customer cloning is the norm; if the Concierge
		// can't be built we fall back to the caller client (fine for reads/updates in
		// that norm, but the Configuration write will likely be rejected).
		this._buildConciergeClient(tmpDestCustomerID,
			(pDestErr, pDestConcierge) =>
			{
				const tmpDestClient = pDestConcierge || this.restClient;
				if (!pDestConcierge)
				{
					this.log.warn('[ProjectCloning] Falling back to caller client for dest email-rule config writes/updates (will likely be rejected)',
						{ Action: 'ProjectCloning-EmailRuleConfigFallback', IDCustomer: tmpDestCustomerID });
				}
				const fRun = (pSrcClient) => this._runEmailRuleConfigSync(tmpMeta, pSrcClient, tmpDestClient, fCallback);
				// Same-customer clone (the common case): one Concierge serves both.
				if (Number(tmpSourceCustomerID) === Number(tmpDestCustomerID))
				{
					return fRun(tmpDestClient);
				}
				// Cross-customer: the source blob lives under the source customer,
				// so read it with a source-customer Concierge.
				this._buildConciergeClient(tmpSourceCustomerID,
					(pSrcErr, pSrcConcierge) =>
					{
						if (!pSrcConcierge)
						{
							this.log.warn('[ProjectCloning] Falling back to caller client for source email-rule config reads',
								{ Action: 'ProjectCloning-EmailRuleConfigFallback', IDCustomer: tmpSourceCustomerID });
						}
						return fRun(pSrcConcierge || this.restClient);
					});
			});
	}

	/**
	 * Per-rule config re-home loop. `pSrcClient` reads the source-customer config;
	 * `pDestClient` resolves the cloned rule, writes the dest-customer config, and
	 * updates the rule — both elevated (see `syncClonedEmailRuleConfigs`).
	 * @private
	 */
	_runEmailRuleConfigSync(pMeta, pSrcClient, pDestClient, fCallback)
	{
		const tmpWarnings = [];
		let tmpSynced = 0;
		libAsync.eachSeries(pMeta,
			(pEntry, fNext) =>
			{
				// 1. Resolve the cloned rule's new id by its deterministic GUID
				//    (dest-customer scoped — must use the elevated dest client).
				pDestClient.getEntitySet('EmailRule', `FBV~GUIDEmailRule~EQ~${pEntry.GUIDEmailRule}`,
					(pFindErr, pRows) =>
					{
						const tmpRule = (!pFindErr && Array.isArray(pRows)) ? pRows[0] : null;
						if (!tmpRule || !tmpRule.IDEmailRule)
						{
							tmpWarnings.push(`Email rule config: cloned rule ${pEntry.GUIDEmailRule} not found post-push — its config was not cloned.`);
							return fNext();
						}
						const tmpNewID = tmpRule.IDEmailRule;
						// 2. Read the source rule's config blob (source-customer scoped).
						const tmpReadURI = `Configuration/For/EmailRule-${encodeURIComponent(pEntry.Handler)}/In/Customer/${pEntry.SourceCustomerID}`;
						pSrcClient.getJSON(tmpReadURI,
							(pReadErr, pReadBody) =>
							{
								const tmpBlob = (pReadBody && typeof(pReadBody) === 'object') ? pReadBody : {};
								const tmpSourceBlob = tmpBlob[pEntry.SourceConfig];
								if (pReadErr || tmpSourceBlob === undefined || tmpSourceBlob === null)
								{
									tmpWarnings.push(`Email rule config: source config EmailRule-${pEntry.Handler}/${pEntry.SourceConfig} (customer ${pEntry.SourceCustomerID}) not found — cloned rule ${tmpNewID} left pointing at the source value.`);
									return fNext();
								}
								// 3. Copy it to the cloned rule's own namespace value.
								const tmpNewValue = `IDEmailRule-${tmpNewID}`;
								const tmpWriteURI = `Configuration/Put/EmailRule-${encodeURIComponent(pEntry.Handler)}/${encodeURIComponent(tmpNewValue)}/Customer/${pEntry.DestCustomerID}`;
								pDestClient.postJSON(tmpWriteURI, tmpSourceBlob,
									(pWriteErr) =>
									{
										if (pWriteErr)
										{
											tmpWarnings.push(`Email rule config: failed to write EmailRule-${pEntry.Handler}/${tmpNewValue} for rule ${tmpNewID} (${(pWriteErr && pWriteErr.message) || pWriteErr}).`);
											return fNext();
										}
										// 4. Point the cloned rule at its own config value. Carry
										//    IDCustomer so the update isn't read as a customer change.
										pDestClient.updateEntity('EmailRule', { IDEmailRule: tmpNewID, IDCustomer: pEntry.DestCustomerID, Config: tmpNewValue },
											(pUpdErr) =>
											{
												if (pUpdErr)
												{
													tmpWarnings.push(`Email rule config: copied config but failed to update rule ${tmpNewID}.Config to ${tmpNewValue} (${(pUpdErr && pUpdErr.message) || pUpdErr}).`);
													return fNext();
												}
												tmpSynced++;
												this.log.info(`  Email rule ${tmpNewID}: cloned per-rule config → ${tmpNewValue}`,
													{ Action: 'ProjectCloning-EmailRuleConfigCloned', IDEmailRule: tmpNewID, Handler: pEntry.Handler });
												return fNext();
											});
									});
							});
					});
			},
			() =>
			{
				this.log.info(`  Email-rule config sync: ${tmpSynced}/${pMeta.length} per-rule config(s) cloned.`);
				return fCallback(null, { synced: tmpSynced, warnings: tmpWarnings });
			});
	}
}

module.exports = ProjectCloningAdapter;

module.exports.default_configuration = {
	Name: 'ProjectCloningAdapter',
	GUIDPrefix: DEFAULT_GUID_PREFIX,
};

module.exports.CLONED_ENTITIES = CLONED_ENTITIES;
module.exports.SAMPLE_PLAN_ENTITIES = SAMPLE_PLAN_ENTITIES;


},{"async":330,"crypto":393,"fable-serviceproviderbase":438,"headlight-comprehension-processor":4}],13:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libQRCodeMinter = require('headlight-qrcode/source/Headlight-QRCode-Minter.js');
const libQRCodeProfiles = require('headlight-qrcode/source/Headlight-QRCode-Profiles.js');

/**
 * HeadLight QR code generation for browser apps (and anything else that registers this service).
 *
 * Generation is delegated to headlight-qrcode's minter, which never returns the same code twice
 * from one service instance. The legacy formats keep their exact shape.
 */
class HeadlightQRCodeHash extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance
	 * @param {any} [pOptions] - The options for the service
	 * @param {any} [pServiceHash] - The hash for the service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadlightQRCodeHash';

		this.minter = new libQRCodeMinter();
		/** @type {null|ReturnType<typeof libQRCodeProfiles.resolveProfile>} */
		this.customerProfile = null;
		/** @type {Record<string, Promise<any>>} */
		this.customerProfileLoads = {};
	}

	/**
	 * A generic method to generate a GUID (unique id) string value out of alphanumeric
	 * characters. The default length is 10 characters long but can be customized.
	 * @param {number} [prefix] - an optional prefix, used to make the scope more clear
	 * @param {number} [length] - the number of characters in the return string
	 * @return {string} - a generated id string
	 */
	_generateGUID(prefix, length)
	{
		const alphanumericString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		length = length ? length : 10;
		let guid = '';
		for (let i = 0; i < length; i++)
		{
			guid += alphanumericString.charAt(Math.floor(Math.random() * alphanumericString.length));
		}
		guid = prefix ? prefix + guid : guid;
		return guid;
	}

	/**
	 * The timezone the app's fable Dates service renders in (pict forms set it to the project's
	 * zone), so legacy codes keep using it; undefined means the runtime's local zone.
	 *
	 * @return {string|undefined}
	 */
	_getConfiguredTimeZone()
	{
		try
		{
			const tmpZone = this.fable && this.fable.Dates && this.fable.Dates.dayJS && this.fable.Dates.dayJS().tz().$x.$timezone;
			return (typeof tmpZone === 'string' && tmpZone) ? tmpZone : undefined;
		}
		catch (pError)
		{
			return undefined;
		}
	}

	/**
	 * Generates QR Codes in the pre-2026 web format, takes a project id and user id.
	 * @param {Number} projectId
	 * @param {Number} userId
	 * @returns {String}
	 */
	_generateHLQRCode(projectId, userId)
	{
		return this.minter.mint('Classic', { IDProject: projectId, IDUser: userId });
	}

	/**
	 * Generates a code in the SiteManager (LADOTD) format: prefix + YY M D hh mm ss.
	 * @param {string} tmpGUIDString - The prefix (the user's SiteManager id)
	 * @param {import('headlight-qrcode/source/Headlight-QRCode-Minter.js').SiteManagerOptions} [pSiteManagerOptions]
	 * @return {string} - The QR code string
	 */
	_generateLegacyGUID(tmpGUIDString, pSiteManagerOptions)
	{
		return this.minter.mint('SiteManager', { ExternalSyncGUID: tmpGUIDString || '', TimeZone: this._getConfiguredTimeZone() }, pSiteManagerOptions || {});
	}

	/**
	 * This handles the generation of the QR code hash string based on the options passed in
	 * @param {object} [pOptions] - The options for the hash generation
	 * @return {string} - The hash string
	 */
	generateQRCodeHash(pOptions)
	{
		if (pOptions && typeof pOptions !== 'object')
		{
			throw new Error('generateQRCodeHash() was expecting an object of options, but received a non-object value.');
		}
		pOptions = pOptions || {};
		if (pOptions.LegacyFormat && pOptions.GUIDPrefix)
		{
			return this._generateLegacyGUID(pOptions.GUIDPrefix);
		}
		if (pOptions.LegacyFormat && !pOptions.GUIDPrefix)
		{
			throw new Error('generateQRCodeHash() was expecting a GUIDPrefix value for the LegacyFormat option, but received none.');
		}
		return this._generateHLQRCode(pOptions.IDProject, pOptions.IDUser);
	}

	/**
	 * Set the signed-in customer's QR settings: its `QRCodes` configuration and `CustomProperties`.
	 *
	 * @param {Object} [pConfiguration]
	 * @param {Object|string} [pCustomProperties] - Object, or the JSON string the Customer record carries.
	 * @param {number|string} [pIDCustomer] - Picks the default when nothing is configured.
	 */
	setCustomerConfiguration(pConfiguration, pCustomProperties, pIDCustomer)
	{
		let tmpProperties = pCustomProperties || {};
		if (typeof tmpProperties === 'string')
		{
			try
			{
				tmpProperties = tmpProperties.trim() ? JSON.parse(tmpProperties) : {};
			}
			catch (pError)
			{
				tmpProperties = {};
			}
		}
		this.customerProfile = libQRCodeProfiles.resolveProfile(pConfiguration || {}, tmpProperties, { IDCustomer: pIDCustomer });
	}

	/**
	 * Load the customer's QR settings once per customer, through a HeadlightRestClient-style client.
	 *
	 * Only a complete load is kept. If either read fails the profile is left unset (mintForCustomer
	 * then uses its fallback) and the next call tries again, so a network blip at sign-in can't pin a
	 * whole session to the wrong format.
	 *
	 * @param {{ getJSON: (pPath: string, fCallback: (pError: any, pResult: any) => void) => void }} pRestClient
	 * @param {number|string} pIDCustomer
	 * @return {Promise<any>} the resolved profile, or null when it couldn't be loaded
	 */
	loadCustomerConfiguration(pRestClient, pIDCustomer)
	{
		const tmpKey = String(pIDCustomer);
		if (!this.customerProfileLoads[tmpKey])
		{
			const fGet = (pPath) => new Promise((fResolve) =>
			{
				pRestClient.getJSON(pPath, (pError, pResult) => fResolve({ OK: !pError && !!pResult && !pResult.Error, Value: pResult }));
			});
			this.customerProfileLoads[tmpKey] = Promise.all([ fGet('Configuration/For/QRCodes/Profile'), fGet(`Customer/${pIDCustomer}`) ])
				.then(([ pConfiguration, pCustomer ]) =>
				{
					if (!pConfiguration.OK || !pCustomer.OK)
					{
						delete this.customerProfileLoads[tmpKey];
						if (this.fable && this.fable.log)
						{
							this.fable.log.warn(`HeadlightQRCodeHash: could not load QR settings for customer ${tmpKey}; will retry.`);
						}
						return null;
					}
					this.setCustomerConfiguration(pConfiguration.Value, pCustomer.Value.CustomProperties, pIDCustomer);
					return this.customerProfile;
				});
		}
		return this.customerProfileLoads[tmpKey];
	}

	/**
	 * @return {null|ReturnType<typeof libQRCodeProfiles.resolveProfile>} the loaded profile, if any
	 */
	getCustomerProfile()
	{
		return this.customerProfile;
	}

	/**
	 * Mint a new code in the signed-in customer's format.
	 *
	 * @param {Object} pContext
	 * @param {number} [pContext.IDProject]
	 * @param {number} [pContext.IDUser]
	 * @param {string} [pContext.ExternalSyncGUID] - SiteManager prefix; falls back to `HL<IDUser>`.
	 * @param {string} [pContext.TimeZone] - The signed-in user's time zone (SiteManager codes carry its local time); defaults to the app's configured zone.
	 * @param {number|string} [pContext.CustomerID] - Only used when the profile hasn't loaded.
	 * @return {string}
	 */
	mintForCustomer(pContext)
	{
		const tmpContext = pContext || {};
		let tmpProfile = this.customerProfile;
		if (!tmpProfile)
		{
			const tmpFallback = libQRCodeProfiles.getDefaultProfileName(tmpContext.CustomerID);
			if (this.fable && this.fable.log)
			{
				this.fable.log.warn(`HeadlightQRCodeHash: customer QR settings not loaded; using ${tmpFallback}.`);
			}
			tmpProfile = libQRCodeProfiles.resolveProfile({ Profile: tmpFallback }, {});
		}
		if (tmpProfile.CodeFormat === 'SiteManager')
		{
			const tmpPrefix = tmpContext.ExternalSyncGUID || `HL${tmpContext.IDUser || 0}`;
			return this.minter.mint('SiteManager', { ExternalSyncGUID: tmpPrefix, TimeZone: tmpContext.TimeZone || this._getConfiguredTimeZone() }, tmpProfile.SiteManager);
		}
		return this.minter.mint(tmpProfile.CodeFormat, { IDProject: tmpContext.IDProject, IDUser: tmpContext.IDUser, TimeZone: (tmpProfile.CodeFormat === 'Standard') ? this._getConfiguredTimeZone() : undefined });
	}
}

module.exports = HeadlightQRCodeHash;

},{"fable-serviceproviderbase":438,"headlight-qrcode/source/Headlight-QRCode-Minter.js":17,"headlight-qrcode/source/Headlight-QRCode-Profiles.js":18}],14:[function(require,module,exports){
/**
 * Encode and decode QR payloads: every envelope printed since 2019, and the v1 forms.
 *
 * Decoding never rejects input. Anything that is not a recognised envelope comes back as a raw
 * value, because stored codes are opaque strings (adopted stickers, imported codes, free text).
 */

const libHosts = require('./Headlight-QRCode-Hosts.js');
const EntityRegistry = require('./Headlight-QRCode-EntityRegistry.js');

/**
 * @typedef {'Compact'|'Full'|'LegacyLinks'|'Raw'} Envelope
 */

/**
 * @typedef {Object} DecodedAction
 * @property {'Action'} Kind
 * @property {string} Workflow - e.g. `cart`, `receive`
 * @property {string} Verb - e.g. `open`, `submit`, `start`
 * @property {Array<string>} Arguments
 * @property {boolean} Legacy - True for the three codes printed before workflows were namespaced.
 * @property {string} Raw
 */

/**
 * @typedef {Object} DecodedEntity
 * @property {'Entity'} Kind
 * @property {string|null} Entity - Registry entity name, or null when the payload doesn't say (raw codes).
 * @property {'qr'|'guid'|'id'} Key
 * @property {string} Value
 * @property {1|'legacy'|'raw'} Version
 * @property {'Compact'|'Full'|'LegacyLinks'|'LegacyEntityLinks'|'LegacyDocumentLink'|'Raw'|'ForeignURL'} Shape
 * @property {string} [Environment] - Environment of the links host the label points at.
 * @property {string} Raw - The input, trimmed.
 */

/**
 * @typedef {Object} DecodedEmpty
 * @property {'Empty'} Kind
 * @property {string} Raw
 */

/** @typedef {DecodedAction|DecodedEntity|DecodedEmpty} Decoded */

/**
 * The three action codes printed before workflow namespacing, mapped to their workflow form.
 * New workflows must never be named `open`, `clear` or `submit`.
 */
const LEGACY_ACTIONS =
{
	'open/cart': { Workflow: 'cart', Verb: 'open' },
	'clear': { Workflow: 'cart', Verb: 'clear' },
	'submit': { Workflow: 'cart', Verb: 'submit' },
};
const LEGACY_ACTION_HEADS = [ 'open', 'clear', 'submit' ];

/** Characters QR alphanumeric mode can encode. */
const ALPHANUMERIC_MODE = /^[0-9A-Z $%*+\-./:]*$/;

/**
 * Strip whitespace and control characters scanners append or prepend (CR, LF, TAB, GS…).
 *
 * @param {string} pText
 * @return {string}
 */
function cleanScannedText(pText)
{
	// eslint-disable-next-line no-control-regex
	return String(pText).replace(/^[\s\u0000-\u001f\u007f]+|[\s\u0000-\u001f\u007f]+$/g, '');
}

/**
 * @param {string} pSegment
 * @return {string}
 */
function safeDecodeSegment(pSegment)
{
	try
	{
		return decodeURIComponent(pSegment);
	}
	catch (pError)
	{
		return pSegment;
	}
}

/**
 * @param {string} pText
 * @return {boolean} true when the whole string fits QR alphanumeric mode
 */
function isAlphanumericMode(pText)
{
	return ALPHANUMERIC_MODE.test(pText);
}

class QRCodeCodec
{
	/**
	 * @param {Object} [pOptions]
	 * @param {EntityRegistry} [pOptions.Registry]
	 */
	constructor(pOptions)
	{
		const tmpOptions = pOptions || {};
		/** @type {EntityRegistry} */
		this.registry = tmpOptions.Registry || new EntityRegistry();
	}

	/**
	 * Decode scanned or typed text.
	 *
	 * @param {any} pText
	 * @return {Decoded}
	 */
	decode(pText)
	{
		const tmpRaw = (pText === null || pText === undefined) ? '' : cleanScannedText(pText);
		if (!tmpRaw)
		{
			return { Kind: 'Empty', Raw: tmpRaw };
		}

		if (/^action\//i.test(tmpRaw))
		{
			return this._decodeActionSegments(tmpRaw.split('?')[0].split('/').slice(1), tmpRaw);
		}

		if (/^https?:\/\//i.test(tmpRaw))
		{
			return this._decodeURL(tmpRaw);
		}

		return this._raw(tmpRaw, 'Raw');
	}

	/**
	 * @param {string} pRaw
	 * @return {Decoded}
	 */
	_decodeURL(pRaw)
	{
		let tmpURL = null;
		try
		{
			tmpURL = new URL(pRaw);
		}
		catch (pError)
		{
			return this._raw(pRaw, 'Raw');
		}

		if (!libHosts.isLinksHostname(tmpURL.hostname))
		{
			return this._raw(pRaw, 'ForeignURL');
		}

		const tmpEnvironment = libHosts.parseHostname(tmpURL.hostname).Environment;
		const tmpSegments = tmpURL.pathname.split('/').filter((pSegment) => pSegment.length > 0).map(safeDecodeSegment);
		if (tmpSegments.length === 0)
		{
			return this._raw(pRaw, 'ForeignURL');
		}

		const tmpHead = tmpSegments[0].toLowerCase();

		if (tmpHead === 'action')
		{
			return this._decodeActionSegments(tmpSegments.slice(1), pRaw);
		}

		if (tmpHead === 'qr' && tmpSegments.length >= 2)
		{
			return this._entity('Sample', 'qr', tmpSegments[1], 'legacy', 'LegacyLinks', tmpEnvironment, pRaw);
		}

		if (tmpHead === 'document' && tmpSegments.length === 2 && /^\d+$/.test(tmpSegments[1]))
		{
			return this._entity('Document', 'id', tmpSegments[1], 'legacy', 'LegacyDocumentLink', tmpEnvironment, pRaw);
		}

		const tmpDefinition = this.registry.getEntity(tmpSegments[0]);
		if (tmpDefinition && tmpSegments.length >= 2)
		{
			const tmpIsAlias = tmpDefinition.Alias.toLowerCase() === tmpHead;
			if (tmpSegments.length >= 3)
			{
				const tmpKey = tmpSegments[1].toLowerCase();
				if (tmpKey === 'qr')
				{
					return this._entity(tmpDefinition.Entity, 'qr', tmpSegments[2], 1, tmpIsAlias ? 'Compact' : 'Full', tmpEnvironment, pRaw);
				}
				if (tmpKey === 'guid' || tmpKey === 'g')
				{
					return this._entity(tmpDefinition.Entity, 'guid', tmpSegments[2], 1, tmpIsAlias ? 'Compact' : 'Full', tmpEnvironment, pRaw);
				}
			}
			if (tmpSegments.length === 2)
			{
				return this._entity(tmpDefinition.Entity, tmpDefinition.Key, tmpSegments[1], 1, tmpIsAlias ? 'Compact' : 'Full', tmpEnvironment, pRaw);
			}
		}

		return this._raw(pRaw, 'ForeignURL');
	}

	/**
	 * @param {Array<string>} pSegments - Path segments after `action`.
	 * @param {string} pRaw
	 * @return {Decoded}
	 */
	_decodeActionSegments(pSegments, pRaw)
	{
		const tmpSegments = pSegments.filter((pSegment) => pSegment.length > 0).map((pSegment) => safeDecodeSegment(pSegment));
		if (tmpSegments.length === 0)
		{
			return this._raw(pRaw, 'Raw');
		}
		const tmpHead = tmpSegments[0].toLowerCase();
		if (LEGACY_ACTION_HEADS.includes(tmpHead))
		{
			const tmpLegacyKey = tmpSegments.map((pSegment) => pSegment.toLowerCase()).join('/');
			const tmpLegacy = LEGACY_ACTIONS[tmpLegacyKey] || LEGACY_ACTIONS[tmpHead];
			if (tmpLegacy)
			{
				return { Kind: 'Action', Workflow: tmpLegacy.Workflow, Verb: tmpLegacy.Verb, Arguments: [], Legacy: true, Raw: pRaw };
			}
		}
		if (tmpSegments.length < 2)
		{
			return { Kind: 'Action', Workflow: tmpHead, Verb: '', Arguments: [], Legacy: false, Raw: pRaw };
		}
		return { Kind: 'Action', Workflow: tmpHead, Verb: tmpSegments[1].toLowerCase(), Arguments: tmpSegments.slice(2), Legacy: false, Raw: pRaw };
	}

	/**
	 * @return {DecodedEntity}
	 */
	_entity(pEntity, pKey, pValue, pVersion, pShape, pEnvironment, pRaw)
	{
		return { Kind: 'Entity', Entity: pEntity, Key: pKey, Value: pValue, Version: pVersion, Shape: pShape, Environment: pEnvironment, Raw: pRaw };
	}

	/**
	 * @return {DecodedEntity}
	 */
	_raw(pRaw, pShape)
	{
		return { Kind: 'Entity', Entity: null, Key: 'qr', Value: pRaw, Version: 'raw', Shape: pShape, Raw: pRaw };
	}

	/**
	 * Build the payload to put in a QR image or a link.
	 *
	 * @param {Object} pTarget
	 * @param {string} pTarget.Entity - Registry entity name or alias.
	 * @param {string} pTarget.Value - The stored code or GUID.
	 * @param {'qr'|'guid'} [pTarget.Key] - Defaults to the entity's key.
	 * @param {Object} [pOptions]
	 * @param {Envelope} [pOptions.Envelope] - Defaults to Compact.
	 * @param {string} [pOptions.Environment] - Environment name for the links host; defaults to Production.
	 * @param {boolean} [pOptions.Uppercase] - Compact only: emit the whole URL in uppercase when that is lossless and fits alphanumeric mode. Defaults to true.
	 * @return {string}
	 */
	encode(pTarget, pOptions)
	{
		const tmpOptions = Object.assign({ Envelope: 'Compact', Environment: 'Production', Uppercase: true }, pOptions || {});
		const tmpDefinition = this.registry.getEntity(pTarget && pTarget.Entity);
		if (!tmpDefinition)
		{
			throw new Error(`Unknown entity "${pTarget && pTarget.Entity}".`);
		}
		const tmpValue = String((pTarget && pTarget.Value) ?? '');
		if (!tmpValue)
		{
			throw new Error('Cannot encode an empty value.');
		}
		const tmpKey = pTarget.Key || tmpDefinition.Key;
		const tmpEncodedValue = encodeURIComponent(tmpValue);
		const tmpLinks = libHosts.getLinksBaseURL(tmpOptions.Environment);

		switch (tmpOptions.Envelope)
		{
			case 'Raw':
				// A bare value reads back as a sample code (DefaultRawEntities), so only a sample code goes out bare; anything else keeps its links address.
				if (tmpDefinition.Entity === 'Sample' && tmpKey === 'qr')
				{
					return tmpValue;
				}
				return `${tmpLinks}/${tmpDefinition.Entity}/${tmpKey}/${tmpEncodedValue}`;
			case 'LegacyLinks':
				if (tmpKey === 'qr' && tmpDefinition.Entity === 'Sample')
				{
					return `${tmpLinks}/qr/${tmpEncodedValue}`;
				}
				return `${tmpLinks}/${tmpDefinition.Entity}/${tmpKey}/${tmpEncodedValue}`;
			case 'Full':
				return `${tmpLinks}/${tmpDefinition.Entity}/${tmpKey}/${tmpEncodedValue}`;
			case 'Compact':
			{
				const tmpKeySegment = (tmpKey === tmpDefinition.Key) ? '' : `${tmpKey === 'guid' ? 'g' : tmpKey}/`;
				const tmpPayload = `${tmpLinks}/${tmpDefinition.Alias}/${tmpKeySegment}${tmpEncodedValue}`;
				const tmpUpper = tmpPayload.toUpperCase();
				if (tmpOptions.Uppercase && tmpValue === tmpValue.toUpperCase() && isAlphanumericMode(tmpUpper))
				{
					return tmpUpper;
				}
				return tmpPayload;
			}
			default:
				throw new Error(`Unknown envelope "${tmpOptions.Envelope}".`);
		}
	}

	/**
	 * Build an action-card payload: `action/<workflow>/<verb>[/<arg>…]`.
	 *
	 * @param {string} pWorkflow
	 * @param {string} pVerb
	 * @param {Array<string>} [pArguments]
	 * @return {string}
	 */
	encodeAction(pWorkflow, pVerb, pArguments)
	{
		const tmpWorkflow = String(pWorkflow || '').toLowerCase();
		if (!tmpWorkflow || LEGACY_ACTION_HEADS.includes(tmpWorkflow))
		{
			throw new Error(`"${pWorkflow}" can't be used as a workflow name.`);
		}
		const tmpParts = [ 'action', tmpWorkflow, String(pVerb || '').toLowerCase() ].concat((pArguments || []).map((pArgument) => encodeURIComponent(String(pArgument))));
		return tmpParts.join('/');
	}
}

module.exports = QRCodeCodec;
module.exports.cleanScannedText = cleanScannedText;
module.exports.isAlphanumericMode = isAlphanumericMode;
module.exports.LEGACY_ACTIONS = LEGACY_ACTIONS;

},{"./Headlight-QRCode-EntityRegistry.js":15,"./Headlight-QRCode-Hosts.js":16}],15:[function(require,module,exports){
/**
 * Entity types that can be carried in a QR code or a links URL, and how to find each one.
 *
 * `Key` is the entity's default lookup key: `qr` (a minted, printable code column) or `guid`.
 * `Alias` is the compact path segment; aliases and names are matched case-insensitively and must
 * never collide with the reserved first segments (`qr`, `action`, `document`, `g`, `guid`, `v2`…).
 */

/**
 * @typedef {Object} EntityDefinition
 * @property {string} Entity - Meadow entity name, PascalCase.
 * @property {string} Alias - Compact path segment.
 * @property {'qr'|'guid'} Key - Default lookup key.
 * @property {string} [Column] - Column holding the QR code (for `qr`).
 * @property {string} GUIDColumn - Column holding the GUID.
 * @property {string} IDColumn - Primary key column.
 * @property {boolean} [Mint] - True when new codes are generated for this entity.
 * @property {string} [NameColumn] - Column shown as the record's display name.
 * @property {string} [Label] - Plain-language singular noun for user-facing text.
 */

/** @type {Record<string, EntityDefinition>} */
const DEFAULT_ENTITIES =
{
	Sample: { Entity: 'Sample', Alias: 'S', Key: 'qr', Column: 'QRCode', GUIDColumn: 'GUIDSample', IDColumn: 'IDSample', Mint: true, NameColumn: 'Name', Label: 'sample' },
	Location: { Entity: 'Location', Alias: 'L', Key: 'qr', Column: 'QRCode', GUIDColumn: 'GUIDLocation', IDColumn: 'IDLocation', Mint: false, NameColumn: 'Name', Label: 'location' },
	Core: { Entity: 'Core', Alias: 'C', Key: 'qr', Column: 'QRCode', GUIDColumn: 'GUIDCore', IDColumn: 'IDCore', Mint: false, NameColumn: 'Name', Label: 'core' },
	Document: { Entity: 'Document', Alias: 'D', Key: 'guid', GUIDColumn: 'GUIDDocument', IDColumn: 'IDDocument', NameColumn: 'Name', Label: 'document' },
	Project: { Entity: 'Project', Alias: 'P', Key: 'guid', GUIDColumn: 'GUIDProject', IDColumn: 'IDProject', NameColumn: 'Name', Label: 'project' },
	Observation: { Entity: 'Observation', Alias: 'O', Key: 'guid', GUIDColumn: 'GUIDObservation', IDColumn: 'IDObservation', NameColumn: 'Name', Label: 'observation' },
};

/** First path segments that can never be an entity name or alias. */
const RESERVED_SEGMENTS = [ 'qr', 'action', 'document', 'g', 'guid', 'id', 'auth', 'v2', 'v3', 'v4' ];

class EntityRegistry
{
	/**
	 * @param {Record<string, Partial<EntityDefinition>>} [pOverrides] - Entities to add or override, by name.
	 */
	constructor(pOverrides)
	{
		/** @type {Record<string, EntityDefinition>} */
		this.entities = {};
		for (const tmpDefinition of Object.values(DEFAULT_ENTITIES))
		{
			this.addEntity(tmpDefinition);
		}
		if (pOverrides && typeof pOverrides === 'object')
		{
			for (const [ tmpName, tmpDefinition ] of Object.entries(pOverrides))
			{
				this.addEntity(Object.assign({}, this.entities[tmpName] || {}, tmpDefinition, { Entity: tmpName }));
			}
		}
	}

	/**
	 * @param {EntityDefinition} pDefinition
	 */
	addEntity(pDefinition)
	{
		if (!pDefinition || !pDefinition.Entity || !pDefinition.Alias)
		{
			throw new Error('An entity definition needs at least Entity and Alias.');
		}
		const tmpName = pDefinition.Entity.toLowerCase();
		const tmpAlias = pDefinition.Alias.toLowerCase();
		if (RESERVED_SEGMENTS.includes(tmpAlias))
		{
			throw new Error(`Entity alias "${pDefinition.Alias}" is a reserved path segment.`);
		}
		for (const tmpExisting of Object.values(this.entities))
		{
			if (tmpExisting.Entity === pDefinition.Entity)
			{
				continue;
			}
			if (tmpExisting.Alias.toLowerCase() === tmpAlias || tmpExisting.Entity.toLowerCase() === tmpAlias || tmpExisting.Alias.toLowerCase() === tmpName)
			{
				throw new Error(`Entity "${pDefinition.Entity}" collides with "${tmpExisting.Entity}".`);
			}
		}
		this.entities[pDefinition.Entity] = Object.assign({ Key: 'guid', Label: pDefinition.Entity.toLowerCase() }, pDefinition);
	}

	/**
	 * Look up an entity by name or alias, case-insensitively.
	 *
	 * @param {string} pNameOrAlias
	 * @return {EntityDefinition|null}
	 */
	getEntity(pNameOrAlias)
	{
		if (typeof pNameOrAlias !== 'string' || !pNameOrAlias)
		{
			return null;
		}
		const tmpNeedle = pNameOrAlias.toLowerCase();
		for (const tmpDefinition of Object.values(this.entities))
		{
			if (tmpDefinition.Entity.toLowerCase() === tmpNeedle || tmpDefinition.Alias.toLowerCase() === tmpNeedle)
			{
				return tmpDefinition;
			}
		}
		return null;
	}

	/**
	 * @return {Array<EntityDefinition>}
	 */
	listEntities()
	{
		return Object.values(this.entities);
	}
}

module.exports = EntityRegistry;
module.exports.DEFAULT_ENTITIES = DEFAULT_ENTITIES;
module.exports.RESERVED_SEGMENTS = RESERVED_SEGMENTS;

},{}],16:[function(require,module,exports){
/**
 * HeadLight environment and host rules.
 *
 * Every deployed app answers on `<subdomain>[.<env>].headlight.com` (production has no env label).
 * This is the one place that turns an environment into an app's base URL, and a hostname back into
 * an environment, so labels, links and redirects agree.
 */

const HEADLIGHT_DOMAIN = 'headlight.com';

/** Domains whose `links.` host is still honoured when decoding old labels. */
const LEGACY_DOMAINS = [ 'paviasystems.com' ];

/** @type {Record<string, string>} environment name → hostname label ('' for production) */
const ENVIRONMENT_LABELS =
{
	Production: '',
	QA: 'qa',
	Staging: 'stg',
	Demo: 'demo',
	UAT: 'uat',
};

/** Alternate spellings seen in the wild (iOS uses `stage`). */
const LABEL_ALIASES =
{
	stage: 'stg',
};

/**
 * @typedef {Object} ParsedHost
 * @property {string} Subdomain - First label, e.g. `links`, `lims`.
 * @property {string} Environment - One of the ENVIRONMENT_LABELS keys, or '' when not a known HeadLight host.
 * @property {string} Domain - `headlight.com`, a legacy domain, or ''.
 * @property {boolean} IsHeadlight - True when the host is a HeadLight (or legacy) host.
 */

/**
 * @param {string} pLabel
 * @return {string} environment name for a hostname label, or '' if unknown
 */
function getEnvironmentForLabel(pLabel)
{
	const tmpLabel = LABEL_ALIASES[pLabel] || pLabel;
	for (const [ tmpName, tmpEnvLabel ] of Object.entries(ENVIRONMENT_LABELS))
	{
		if (tmpEnvLabel === tmpLabel)
		{
			return tmpName;
		}
	}
	return '';
}

/**
 * Parse a hostname into subdomain / environment / domain.
 *
 * @param {string} pHostname - e.g. `links.qa.headlight.com` (a port is ignored)
 * @return {ParsedHost}
 */
function parseHostname(pHostname)
{
	const tmpResult = { Subdomain: '', Environment: '', Domain: '', IsHeadlight: false };
	if (typeof pHostname !== 'string' || !pHostname)
	{
		return tmpResult;
	}
	const tmpHost = pHostname.toLowerCase().split(':')[0];
	const tmpDomains = [ HEADLIGHT_DOMAIN ].concat(LEGACY_DOMAINS);
	for (const tmpDomain of tmpDomains)
	{
		if (!tmpHost.endsWith(`.${tmpDomain}`))
		{
			continue;
		}
		const tmpLabels = tmpHost.slice(0, -(tmpDomain.length + 1)).split('.');
		if (tmpLabels.length === 1)
		{
			return { Subdomain: tmpLabels[0], Environment: 'Production', Domain: tmpDomain, IsHeadlight: true };
		}
		if (tmpLabels.length === 2)
		{
			const tmpEnvironment = getEnvironmentForLabel(tmpLabels[1]);
			if (tmpEnvironment)
			{
				return { Subdomain: tmpLabels[0], Environment: tmpEnvironment, Domain: tmpDomain, IsHeadlight: true };
			}
		}
		return tmpResult;
	}
	return tmpResult;
}

/**
 * True for hosts that only exist on the developer's machine: `localhost`, any `*.localhost` subdomain (browsers
 * resolve those to loopback; the QA persona proxy serves each persona at `<IDUser>.localhost:<port>`), and loopback
 * addresses.
 *
 * @param {string} pHostname - e.g. `21952.localhost:47203` (a port is ignored)
 * @return {boolean}
 */
function isLocalHostname(pHostname)
{
	const tmpRaw = String(pHostname || '').toLowerCase();
	if (tmpRaw === '::1' || tmpRaw.startsWith('[::1]'))
	{
		return true;
	}
	const tmpHost = tmpRaw.split(':')[0];
	return (tmpHost === 'localhost') || tmpHost.endsWith('.localhost') || tmpHost.startsWith('127.');
}

/**
 * The environment a browser page or server request is running in.
 * Local hosts (see isLocalHostname) map to QA, matching what local development talks to.
 *
 * @param {string} pHostname
 * @return {string} environment name ('Production' when unknown)
 */
function getEnvironmentFromHostname(pHostname)
{
	if (isLocalHostname(pHostname))
	{
		return 'QA';
	}
	const tmpHost = String(pHostname || '').toLowerCase().split(':')[0];
	const tmpParsed = parseHostname(tmpHost);
	return tmpParsed.Environment || 'Production';
}

/**
 * The environment a page is running in. A page opened from a file (the iOS app's offline forms) has no
 * host, so the API server the app injected decides instead.
 *
 * @param {{ Protocol?: string, Hostname?: string, ServerURL?: string }} pPage - e.g. from `window.location`
 *   and `window._OfflineServerBaseURL`
 * @return {string} environment name ('Production' when unknown)
 */
function getEnvironmentForPage(pPage)
{
	const tmpPage = pPage || {};
	if ((tmpPage.Protocol === 'file:' || !tmpPage.Hostname) && tmpPage.ServerURL)
	{
		try
		{
			return getEnvironmentFromHostname(new URL(String(tmpPage.ServerURL)).hostname);
		}
		catch (pError)
		{
			return 'Production';
		}
	}
	return getEnvironmentFromHostname(tmpPage.Hostname);
}

/**
 * Base URL for an app in an environment, with a trailing slash.
 *
 * @param {string} pSubdomain - e.g. `lims`, `links`
 * @param {string} [pEnvironment] - environment name; defaults to Production
 * @return {string}
 */
function getAppBaseURL(pSubdomain, pEnvironment)
{
	const tmpLabel = ENVIRONMENT_LABELS[pEnvironment || 'Production'];
	const tmpEnvSegment = tmpLabel ? `.${tmpLabel}` : '';
	return `https://${pSubdomain}${tmpEnvSegment}.${HEADLIGHT_DOMAIN}/`;
}

/**
 * Base URL of the links app (no trailing slash), which every printed label and emailed link targets.
 *
 * @param {string} [pEnvironment]
 * @return {string}
 */
function getLinksBaseURL(pEnvironment)
{
	return getAppBaseURL('links', pEnvironment).slice(0, -1);
}

/**
 * @param {string} pHostname
 * @return {boolean} true for `links[.<env>].headlight.com` and the legacy links hosts
 */
function isLinksHostname(pHostname)
{
	const tmpParsed = parseHostname(pHostname);
	return tmpParsed.IsHeadlight && tmpParsed.Subdomain === 'links';
}

module.exports =
{
	HEADLIGHT_DOMAIN,
	LEGACY_DOMAINS,
	ENVIRONMENT_LABELS,
	parseHostname,
	isLocalHostname,
	getEnvironmentFromHostname,
	getEnvironmentForPage,
	getAppBaseURL,
	getLinksBaseURL,
	isLinksHostname,
};

},{}],17:[function(require,module,exports){
/**
 * Mint new codes in each customer-selectable format.
 *
 * Every format is deterministic given a clock and a random source, so tests can pin both. Within one
 * minter instance a code is never returned twice: a collision advances the format's own clock unit
 * (Classic: 1 ms, SiteManager: 1 s) or redraws the random part (Standard), so legacy shapes are kept.
 */

const CALENDAR_MAP = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V' ];

/** Crockford base32: no I, L, O, U, so codes read aloud and typed by hand survive. */
const CROCKFORD_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

const MAX_ATTEMPTS = 1000;

/**
 * @typedef {'Standard'|'Classic'|'SiteManager'} CodeFormat
 */

/**
 * @typedef {Object} MintContext
 * @property {number} [IDProject]
 * @property {number} [IDUser]
 * @property {string} [ExternalSyncGUID] - SiteManager prefix source (the user's CMS id).
 * @property {string} [TimeZone] - IANA zone for date parts; runtime local when omitted.
 */

/**
 * @typedef {Object} SiteManagerOptions
 * @property {number} [MaxPrefixLength] - Prefixes longer than this are cut. Default 9, as the materials app cuts them.
 * @property {number} [TruncateTo] - Length a too-long prefix is cut to. Default MaxPrefixLength.
 * @property {'12'|'24'} [HourFormat] - Default '12' (01-12), as the materials app formats it.
 */

/**
 * @param {number} pRandomBits
 * @return {number}
 */
function defaultRandomInt(pRandomBits)
{
	const tmpCrypto = (typeof globalThis !== 'undefined' && globalThis.crypto && typeof globalThis.crypto.getRandomValues === 'function') ? globalThis.crypto : null;
	if (tmpCrypto)
	{
		const tmpBuffer = new Uint32Array(1);
		tmpCrypto.getRandomValues(tmpBuffer);
		return tmpBuffer[0] % pRandomBits;
	}
	return Math.floor(Math.random() * pRandomBits);
}

/**
 * Date parts in a time zone (or the runtime's zone), using Intl so no date library is needed.
 *
 * @param {Date} pDate
 * @param {string} [pTimeZone]
 * @return {{ Year: number, Month: number, Day: number, Hour: number, Minute: number, Second: number }}
 */
function getDateParts(pDate, pTimeZone)
{
	const tmpOptions =
	{
		timeZone: pTimeZone || undefined,
		year: 'numeric', month: 'numeric', day: 'numeric',
		hour: 'numeric', minute: 'numeric', second: 'numeric',
		hourCycle: 'h23',
	};
	let tmpFormatter;
	try
	{
		tmpFormatter = new Intl.DateTimeFormat('en-US', tmpOptions);
	}
	catch (pError)
	{
		// A zone Intl doesn't know (a stored user setting) falls back to the runtime's zone rather than failing the mint.
		tmpFormatter = new Intl.DateTimeFormat('en-US', Object.assign(tmpOptions, { timeZone: undefined }));
	}
	const tmpParts = {};
	for (const tmpPart of tmpFormatter.formatToParts(pDate))
	{
		tmpParts[tmpPart.type] = tmpPart.value;
	}
	return {
		Year: Number(tmpParts.year),
		Month: Number(tmpParts.month),
		Day: Number(tmpParts.day),
		Hour: Number(tmpParts.hour) % 24,
		Minute: Number(tmpParts.minute),
		Second: Number(tmpParts.second),
	};
}

/**
 * @param {number|string} pValue
 * @param {number} pLength
 * @return {string}
 */
function leftPad(pValue, pLength)
{
	return String(pValue).padStart(pLength, '0');
}

/**
 * @param {any} pID
 * @return {string} upper-case base36 of a positive integer id, or '0'
 */
function idToBase36(pID)
{
	const tmpNumber = parseInt(pID, 10);
	return (tmpNumber > 0) ? tmpNumber.toString(36).toUpperCase() : '0';
}

class QRCodeMinter
{
	/**
	 * @param {Object} [pOptions]
	 * @param {() => Date} [pOptions.Clock]
	 * @param {(pMax: number) => number} [pOptions.RandomInt] - Returns an integer in [0, pMax).
	 * @param {(pCode: string) => Promise<boolean>} [pOptions.IsTaken] - Online uniqueness check, used by mintAsync.
	 */
	constructor(pOptions)
	{
		const tmpOptions = pOptions || {};
		this.clock = tmpOptions.Clock || (() => new Date());
		this.randomInt = tmpOptions.RandomInt || defaultRandomInt;
		this.isTaken = tmpOptions.IsTaken || null;
		/** @type {Set<string>} */
		this.minted = new Set();
	}

	/**
	 * Mint a code that this minter has not returned before.
	 *
	 * @param {CodeFormat} pFormat
	 * @param {MintContext} [pContext]
	 * @param {Object} [pFormatOptions] - SiteManagerOptions for SiteManager.
	 * @return {string}
	 */
	mint(pFormat, pContext, pFormatOptions)
	{
		const tmpContext = pContext || {};
		let tmpDate = this.clock();
		for (let i = 0; i < MAX_ATTEMPTS; i++)
		{
			const tmpCode = this.build(pFormat, tmpContext, pFormatOptions, tmpDate);
			if (!this.minted.has(tmpCode))
			{
				this.minted.add(tmpCode);
				return tmpCode;
			}
			tmpDate = this.advance(pFormat, tmpDate);
		}
		throw new Error(`Could not mint a unique ${pFormat} code after ${MAX_ATTEMPTS} attempts.`);
	}

	/**
	 * Mint a code that is also free on the server (when an IsTaken check is configured).
	 *
	 * @param {CodeFormat} pFormat
	 * @param {MintContext} [pContext]
	 * @param {Object} [pFormatOptions]
	 * @return {Promise<string>}
	 */
	async mintAsync(pFormat, pContext, pFormatOptions)
	{
		for (let i = 0; i < 20; i++)
		{
			const tmpCode = this.mint(pFormat, pContext, pFormatOptions);
			if (!this.isTaken || !(await this.isTaken(tmpCode)))
			{
				return tmpCode;
			}
		}
		throw new Error(`Could not mint a ${pFormat} code that is free on the server.`);
	}

	/**
	 * Build the code for a given instant, without the uniqueness loop.
	 *
	 * @param {CodeFormat} pFormat
	 * @param {MintContext} pContext
	 * @param {Object} [pFormatOptions]
	 * @param {Date} pDate
	 * @return {string}
	 */
	build(pFormat, pContext, pFormatOptions, pDate)
	{
		switch (pFormat)
		{
			case 'Standard':
				return this.buildStandard(pContext, pDate);
			case 'Classic':
				return this.buildClassic(pContext, pDate);
			case 'SiteManager':
				return this.buildSiteManager(pContext, pFormatOptions || {}, pDate);
			default:
				throw new Error(`Unknown code format "${pFormat}".`);
		}
	}

	/**
	 * @param {CodeFormat} pFormat
	 * @param {Date} pDate
	 * @return {Date} the next instant to try after a collision
	 */
	advance(pFormat, pDate)
	{
		switch (pFormat)
		{
			case 'Classic':
				return new Date(pDate.getTime() + 1);
			case 'SiteManager':
				return new Date(pDate.getTime() + 1000);
			default:
				return pDate;
		}
	}

	/**
	 * `<IDProject b36>-<IDUser b36>-<YY><M><D><6 Crockford base32>`, e.g. `QKI-FF1-268K7G3QXM`.
	 * Uppercase only, so it is safe under case-insensitive collation and fits QR alphanumeric mode.
	 *
	 * @param {MintContext} pContext
	 * @param {Date} pDate
	 * @return {string}
	 */
	buildStandard(pContext, pDate)
	{
		const tmpParts = getDateParts(pDate, pContext.TimeZone);
		let tmpRandom = '';
		for (let i = 0; i < 6; i++)
		{
			tmpRandom += CROCKFORD_ALPHABET[this.randomInt(32)];
		}
		return `${idToBase36(pContext.IDProject)}-${idToBase36(pContext.IDUser)}-${leftPad(tmpParts.Year % 100, 2)}${CALENDAR_MAP[tmpParts.Month]}${CALENDAR_MAP[tmpParts.Day]}${tmpRandom}`;
	}

	/**
	 * The pre-2026 web format, unchanged: `<IDProject b36>-<IDUser b36>-<YY><M><D><hh%12><mm><ss><ms b36, 2>`.
	 * Runtime-local clock, as the original generator used.
	 *
	 * @param {MintContext} pContext
	 * @param {Date} pDate
	 * @return {string}
	 */
	buildClassic(pContext, pDate)
	{
		const tmpParts = getDateParts(pDate, pContext.TimeZone);
		const tmpMilliseconds = leftPad(pDate.getMilliseconds().toString(36), 2);
		return `${idToBase36(pContext.IDProject)}-${idToBase36(pContext.IDUser)}-${leftPad(tmpParts.Year % 100, 2)}${CALENDAR_MAP[tmpParts.Month]}${CALENDAR_MAP[tmpParts.Day]}${leftPad(tmpParts.Hour % 12, 2)}${leftPad(tmpParts.Minute, 2)}${leftPad(tmpParts.Second, 2)}${tmpMilliseconds}`;
	}

	/**
	 * The SiteManager / LADOTD format: `<prefix><YY><M><D><hh><mm><ss>`, prefix = the user's CMS id, else `HL<IDUser>`.
	 * The defaults follow the materials app (`materials-sampletracking` `sample.ts` `generateGUID`), and so do the API
	 * and the report_definitions forms mixin (`global/js/mixins/sample.mixins.js` `GenerateSampleQRCode`).
	 *
	 * @param {MintContext} pContext
	 * @param {SiteManagerOptions} pOptions
	 * @param {Date} pDate
	 * @return {string}
	 */
	buildSiteManager(pContext, pOptions, pDate)
	{
		const tmpMaxPrefix = pOptions.MaxPrefixLength || 9;
		let tmpPrefix = pContext.ExternalSyncGUID ? String(pContext.ExternalSyncGUID) : `HL${parseInt(pContext.IDUser, 10) || 0}`;
		if (tmpPrefix.length > tmpMaxPrefix)
		{
			tmpPrefix = tmpPrefix.substring(0, pOptions.TruncateTo || tmpMaxPrefix);
		}
		const tmpParts = getDateParts(pDate, pContext.TimeZone);
		let tmpHour = tmpParts.Hour;
		if ((pOptions.HourFormat || '12') === '12')
		{
			tmpHour = (tmpHour % 12) || 12;
		}
		return `${tmpPrefix}${leftPad(tmpParts.Year % 100, 2)}${CALENDAR_MAP[tmpParts.Month]}${CALENDAR_MAP[tmpParts.Day]}${leftPad(tmpHour, 2)}${leftPad(tmpParts.Minute, 2)}${leftPad(tmpParts.Second, 2)}`;
	}
}

module.exports = QRCodeMinter;
module.exports.CROCKFORD_ALPHABET = CROCKFORD_ALPHABET;
module.exports.getDateParts = getDateParts;

},{}],18:[function(require,module,exports){
/**
 * Per-customer QR profiles: which code format a customer mints and which envelope its labels print.
 *
 * A customer with external dependencies on today's labels (LADOTD, RIDOT) runs a legacy profile, so
 * nothing they print or generate changes until they move. Everyone else gets the Standard profile.
 */

/**
 * @typedef {Object} QRProfile
 * @property {string} Name
 * @property {import('./Headlight-QRCode-Minter.js').CodeFormat} CodeFormat
 * @property {import('./Headlight-QRCode-Codec.js').Envelope} Envelope
 * @property {import('./Headlight-QRCode-Minter.js').SiteManagerOptions} [SiteManager]
 */

/** @type {Record<string, QRProfile>} */
const PROFILES =
{
	'Standard':
	{
		Name: 'Standard',
		CodeFormat: 'Standard',
		Envelope: 'Compact',
	},
	'Legacy-Classic':
	{
		Name: 'Legacy-Classic',
		CodeFormat: 'Classic',
		Envelope: 'LegacyLinks',
	},
	'Legacy-SiteManager':
	{
		Name: 'Legacy-SiteManager',
		CodeFormat: 'SiteManager',
		Envelope: 'LegacyLinks',
		SiteManager: { MaxPrefixLength: 9, HourFormat: '12' },
	},
};

const DEFAULT_PROFILE = 'Standard';

/**
 * Customers whose own systems read today's codes. This is only their default: an explicit `QRCodes`
 * profile still wins. It covers an unconfigured customer, or settings that couldn't be read, so these
 * customers never fall through to Standard. Must agree with the QRCodes/Profile records written by
 * `tools/scripts/qrcode_profiles` on every environment.
 *
 * @type {Record<number, string>}
 */
const LEGACY_CUSTOMER_PROFILES =
{
	6: 'Legacy-Classic',
	10: 'Legacy-SiteManager',
};

/** The value `Customer.CustomProperties.CustomSampleGUID` takes for SiteManager-format customers. */
const SITEMANAGER_CUSTOM_SAMPLE_GUID = 'SiteManagerSampleGUID';

/**
 * @param {number|string} [pIDCustomer]
 * @return {string} the profile a customer gets when nothing is configured
 */
function getDefaultProfileName(pIDCustomer)
{
	return LEGACY_CUSTOMER_PROFILES[Number(pIDCustomer)] || DEFAULT_PROFILE;
}

/**
 * Resolve a customer's effective profile.
 *
 * Precedence: an explicit `Profile` name in the customer's QR configuration, then the long-standing
 * `CustomSampleGUID` customer property, then the customer's default (see getDefaultProfileName). Field overrides in the configuration
 * (`CodeFormat`, `Envelope`, `SiteManager`) apply on top of the chosen profile.
 *
 * The compact label envelope is only used when the configuration sets `AllowCompact: true`. Older
 * readers (in-app scanners, smartforms, form mixins, the iPad app) can't read it yet, so it stays
 * off until they are updated; a profile asking for Compact prints LegacyLinks meanwhile.
 *
 * @param {Object} [pConfiguration] - The customer's `QRCodes` configuration, e.g. `{ Profile: 'Legacy-Classic' }`.
 * @param {Object} [pCustomProperties] - The customer's `CustomProperties`.
 * @param {Object} [pOptions]
 * @param {number|string} [pOptions.IDCustomer] - Picks the default for customers with nothing configured.
 * @param {string} [pOptions.DefaultProfile] - Overrides that default.
 * @return {QRProfile & { Configured: boolean, SiteManagerConfigured: boolean }}
 */
function resolveProfile(pConfiguration, pCustomProperties, pOptions)
{
	const tmpConfiguration = pConfiguration || {};
	const tmpProperties = pCustomProperties || {};
	const tmpOptions = pOptions || {};
	const tmpDefault = (tmpOptions.DefaultProfile && PROFILES[tmpOptions.DefaultProfile]) ? tmpOptions.DefaultProfile : getDefaultProfileName(tmpOptions.IDCustomer);
	let tmpBaseName = tmpDefault;
	let tmpConfigured = false;
	if (tmpConfiguration.Profile && PROFILES[tmpConfiguration.Profile])
	{
		tmpBaseName = tmpConfiguration.Profile;
		tmpConfigured = true;
	}
	else if (tmpProperties.CustomSampleGUID === SITEMANAGER_CUSTOM_SAMPLE_GUID)
	{
		tmpBaseName = 'Legacy-SiteManager';
		tmpConfigured = true;
	}
	const tmpBase = PROFILES[tmpBaseName];
	const tmpProfile = Object.assign({}, tmpBase, { Configured: tmpConfigured, SiteManagerConfigured: !!tmpConfiguration.SiteManager });
	if (tmpConfiguration.CodeFormat)
	{
		tmpProfile.CodeFormat = tmpConfiguration.CodeFormat;
	}
	if (tmpConfiguration.Envelope)
	{
		tmpProfile.Envelope = tmpConfiguration.Envelope;
	}
	if (tmpProfile.Envelope === 'Compact' && tmpConfiguration.AllowCompact !== true)
	{
		tmpProfile.Envelope = 'LegacyLinks';
	}
	if (tmpBase.SiteManager || tmpConfiguration.SiteManager)
	{
		tmpProfile.SiteManager = Object.assign({}, tmpBase.SiteManager || {}, tmpConfiguration.SiteManager || {});
	}
	return tmpProfile;
}

module.exports =
{
	PROFILES,
	DEFAULT_PROFILE,
	LEGACY_CUSTOMER_PROFILES,
	SITEMANAGER_CUSTOM_SAMPLE_GUID,
	getDefaultProfileName,
	resolveProfile,
};

},{}],19:[function(require,module,exports){
/**
 * headlight-qrcode — the shared, DOM-free core of HeadLight QR handling.
 *
 * Used by browser apps (through headlight-qrcode-web), the links server and API services, so a label
 * printed anywhere is decoded the same way everywhere.
 */

const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libHosts = require('./Headlight-QRCode-Hosts.js');
const libProfiles = require('./Headlight-QRCode-Profiles.js');
const EntityRegistry = require('./Headlight-QRCode-EntityRegistry.js');
const QRCodeCodec = require('./Headlight-QRCode-Codec.js');
const QRCodeMinter = require('./Headlight-QRCode-Minter.js');

/**
 * Fable service wrapping the codec, minter and profile rules for one customer context.
 */
class HeadlightQRCode extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Object} [pOptions]
	 * @param {Record<string, Object>} [pOptions.Entities] - Registry overrides.
	 * @param {Object} [pOptions.Configuration] - The customer's QR configuration (`{ Profile, CodeFormat, Envelope, SiteManager }`).
	 * @param {Object} [pOptions.CustomProperties] - The customer's CustomProperties.
	 * @param {number|string} [pOptions.IDCustomer]
	 * @param {string} [pOptions.Environment] - Environment name for printed links; defaults to Production.
	 * @param {(pCode: string) => Promise<boolean>} [pOptions.IsTaken]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadlightQRCode';

		const tmpOptions = pOptions || {};
		this.registry = new EntityRegistry(tmpOptions.Entities);
		this.codec = new QRCodeCodec({ Registry: this.registry });
		this.minter = new QRCodeMinter({ IsTaken: tmpOptions.IsTaken });
		this.environment = tmpOptions.Environment || 'Production';
		this.setCustomerConfiguration(tmpOptions.Configuration, tmpOptions.CustomProperties, tmpOptions.IDCustomer);
	}

	/**
	 * @param {Object} [pConfiguration]
	 * @param {Object} [pCustomProperties]
	 * @param {number|string} [pIDCustomer] - Picks the default when nothing is configured.
	 */
	setCustomerConfiguration(pConfiguration, pCustomProperties, pIDCustomer)
	{
		/** @type {import('./Headlight-QRCode-Profiles.js').QRProfile} */
		this.profile = libProfiles.resolveProfile(pConfiguration, pCustomProperties, { IDCustomer: pIDCustomer });
	}

	/**
	 * @param {any} pText
	 * @return {import('./Headlight-QRCode-Codec.js').Decoded}
	 */
	decode(pText)
	{
		return this.codec.decode(pText);
	}

	/**
	 * Encode a label payload using the customer's envelope unless one is given.
	 *
	 * @param {string} pEntity
	 * @param {string} pValue
	 * @param {Object} [pOptions] - `{ Key, Envelope, Environment, Uppercase }`
	 * @return {string}
	 */
	encode(pEntity, pValue, pOptions)
	{
		const tmpOptions = Object.assign({ Envelope: this.profile.Envelope, Environment: this.environment }, pOptions || {});
		return this.codec.encode({ Entity: pEntity, Value: pValue, Key: tmpOptions.Key }, tmpOptions);
	}

	/**
	 * @param {string} pWorkflow
	 * @param {string} pVerb
	 * @param {Array<string>} [pArguments]
	 * @return {string}
	 */
	encodeAction(pWorkflow, pVerb, pArguments)
	{
		return this.codec.encodeAction(pWorkflow, pVerb, pArguments);
	}

	/**
	 * Mint a code in the customer's format.
	 *
	 * @param {import('./Headlight-QRCode-Minter.js').MintContext} pContext
	 * @return {string}
	 */
	mint(pContext)
	{
		return this.minter.mint(this.profile.CodeFormat, pContext, this.profile.SiteManager);
	}

	/**
	 * @param {import('./Headlight-QRCode-Minter.js').MintContext} pContext
	 * @return {Promise<string>}
	 */
	mintAsync(pContext)
	{
		return this.minter.mintAsync(this.profile.CodeFormat, pContext, this.profile.SiteManager);
	}
}

module.exports = HeadlightQRCode;
module.exports.default_configuration = {};
module.exports.Hosts = libHosts;
module.exports.Profiles = libProfiles;
module.exports.EntityRegistry = EntityRegistry;
module.exports.QRCodeCodec = QRCodeCodec;
module.exports.QRCodeMinter = QRCodeMinter;

},{"./Headlight-QRCode-Codec.js":14,"./Headlight-QRCode-EntityRegistry.js":15,"./Headlight-QRCode-Hosts.js":16,"./Headlight-QRCode-Minter.js":17,"./Headlight-QRCode-Profiles.js":18,"fable-serviceproviderbase":438}],20:[function(require,module,exports){
const FableServiceProviderBase = require('fable-serviceproviderbase');

const defaultHeadLightRestClientOptions = (
	{
		DownloadBatchSize: 100,

		ServerURL: 'https://api.qa.headlight.com/1.0/',
		UserID: 'DEFAULT',
		Password: false,

		// When a request comes back 401 on a session this client logged in itself (authenticate() with its own
		// UserID / Password), log in again and replay the request once. Sessions handed in (setSessionData) or
		// impersonated are never re-established: that would run the caller's request as a different user.
		AutoReauthenticate: true,
		// Before logging in again, ask CheckSession whether the session really expired; a 401 on a live session
		// (e.g. passed through from a downstream service) is returned as is.
		ReauthenticateVerifySession: true,
		// fable RestClient retry policy for the login request itself: transient failures only (502/503/504,
		// timeouts, dropped connections). A refused login is never retried. `false` disables.
		AuthenticateRetry: { MaxAttempts: 3 },
		// A failed authenticate() leaves the session the client already has in place, rather than clearing it.
		KeepSessionOnFailedAuthenticate: true
	});

//NOTE: copied from @paviasystems/service_pieces/HeadLightAPI
/**
 * @typedef {Object} SessionInfo
 * @description Shape of the session object stored in memcache, and returned from CheckSession.
 *
 * @property {string} SessionID - The session ID.
 * @property {boolean} LoggedIn - True if the user is logged in.
 * @property {string} UserRole - The human readable role of the user.
 * @property {number} UserRoleIndex - The user's (0-5) level.
 * @property {number} UserID - The IDUser (database ID) of the user.
 * @property {number} CustomerID - The IDCustomer (database ID) of the customer.
 * @property {string} Title - The title of the user.
 * @property {string} NameFirst - The first name of the user.
 * @property {string} NameLast - The last name of the user.
 * @property {string} Email - The email of the user.
 * @property {string} LoginID - The login ID of the user.
 * @property {string} UIHash - The UI hash of the user. (not sure what this is for)
 * @property {string} Timezone - The timezone of the user.
 * @property {object} Settings - The user's settings.
 * @property {string} LastSessionID - The user's last session ID.
 * @property {string} LastLoginTime - The time of the user's last login.
 * @property {Array<string>} UserRoles - The roles of the user.
 * @property {string} DeviceID - The device ID associated with the session.
 * @property {number} IDDevice - The IDDevice (database ID) of the device record associated with the session.
 */

/**
 * Per-request options, accepted wherever a method takes a URL. Every property except `url` passes through to fable's
 * RestClient unchanged, so the names are its own (fable docs/services/rest-client.md).
 *
 * @typedef {Object} HeadlightRequestOptions
 * @property {string} url - Relative to the server URL, or absolute.
 * @property {boolean} [RetrySafe] - The request may be replayed under the retry policy although its method is not
 *     idempotent (only set it when repeating the request cannot do harm, e.g. a full replace).
 * @property {boolean|number|Object} [Retry] - Override the retry policy for this request (`false` disables).
 * @property {number} [timeout] - Socket timeout in milliseconds (default: the fable `DefaultRestTimeout` setting, else 270000).
 * @property {Object<string, string>} [headers] - Extra request headers.
 */

/**
 * REST client fable service.
 */
class HeadlightRestClient extends FableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance.
	 * @param {Object<String, any>} [pOptions] - The options for the client.
	 * @param {String} [pServiceHash] - A service hash for the fable service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultHeadLightRestClientOptions, pOptions);

		// TODO: Should this default to local instead?
		if (!tmpOptions.hasOwnProperty('HeadlightAPIURL'))
		{
			tmpOptions.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
		}

		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'HeadLightRestClient';

		this.serverURL = this.options.ServerURL;
		this.userID = this.options.UserID;
		this.password = this.options.Password;
		this.enforceSSL = this.options.EnforceSSL ?? true;

		if (!this.serverURL)
		{
			//this.log.warn('No ServerURL was provided in the HeadLightFableClient options; requests will fail.');
		}

		/** @type {SessionInfo} */
		this._SessionData = false;
		this._Impersonating = false;
		/** @type {String} */
		this._SessionToken = null;
		this._LoggedIn = false;
		if (this.options.SessionToken)
		{
			this._SessionToken = this.options.SessionToken;
		}

		// Construct a RestClient to use for all requests
		// KeepAlive is configurable via options or fable settings (RestClientKeepAlive)
		let tmpRestClientOptions = {};
		if (this.options.KeepAlive || this.fable.settings.RestClientKeepAlive)
		{
			tmpRestClientOptions.KeepAlive = true;
		}
		this.restClient = this.fable.serviceManager.instantiateServiceProvider('RestClient', tmpRestClientOptions, 'HeadLightFableClient-RestClient');
		/** @type {'credentials'|'external'|null} How the current session was obtained: our own login, or handed in. */
		this._SessionSource = null;
		/** @type {number} Bumped whenever the session changes; stamped on each request so recovery can tell a 401 for a session already replaced. */
		this._SessionGeneration = 0;
		if (this.options.AutoReauthenticate !== false)
		{
			this.restClient.authenticationRecovery = (pContext) => this._recoverSession(pContext);
		}
		this.cache = {};
		/** @type {Record<string, Array<Function>>} callbacks waiting on an entity read already in flight */
		this._entityRequestsInFlight = {};
		this.urlParams = {};
		// checkDefaultsInSettings() populates this from fable settings, but it only
		// runs via authenticate(). Callers that use setSessionData() directly (e.g.
		// impersonated/session-reuse flows) never call authenticate, so initialize
		// here to avoid _prepareRequestOptions assigning undefined into pOptions.headers.
		/** @type {Record<string, string>} */
		this.defaultHeaders = {};
	}

	/**
	 * Check for default values in DefaultProgramConfiguration in settings if they haven't been set.
	 * 
	 */
	checkDefaultsInSettings()
	{
		if (!this.serverURL && this.fable.ProgramConfiguration && this.fable.ProgramConfiguration.ServerURL)
		{
			this.serverURL = this.fable.ProgramConfiguration.ServerURL;
		}
		else if (!this.serverURL && this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.ServerURL)
		{
			this.serverURL = this.fable.settings.DefaultProgramConfiguration.ServerURL;
		}
		else if (!this.serverURL)
		{
			throw new Error(`Headlight REST client cannot interact with a server without a Server URL.  If this is a user-facing tool, please check your .headlight.config.json and add a ServerURL: parameter, or run the auth command.`);
		}

		if (this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.Headers)
		{
			this.defaultHeaders = this.fable.settings.DefaultProgramConfiguration.Headers;
		}
		else
		{
			this.defaultHeaders = {};
		}

		if ((!this.userID || this.userID == 'DEFAULT') && this.fable.ProgramConfiguration && this.fable.ProgramConfiguration.UserID)
		{
			this.userID = this.fable.ProgramConfiguration.UserID;
		}
		else if ((!this.userID || this.userID == 'DEFAULT') && this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.UserID)
		{
			this.userID = this.fable.settings.DefaultProgramConfiguration.UserID;
		}
		else if (!this.userID || this.userID == 'DEFAULT')
		{
			throw new Error(`Headlight REST client cannot interact with a server without a User ID.  If this is a user-facing tool, please check your .headlight.config.json and add a UserID: parameter, or run the auth command.`);
		}

		if (!this.password && this.fable.ProgramConfiguration && this.fable.ProgramConfiguration.Password)
		{
			this.password = this.fable.ProgramConfiguration.Password;
		}
		else if (!this.password && this.fable.settings.DefaultProgramConfiguration && this.fable.settings.DefaultProgramConfiguration.Password)
		{
			this.password = this.fable.settings.DefaultProgramConfiguration.Password;
		}
		else if (!this.password)
		{
			throw new Error(`Headlight REST client cannot interact with a server without a Password.  If this is a user-facing tool, please check your .headlight.config.json and add a Password: parameter, or run the auth command.`);
		}
	}

	/**
	 * @param {String} pName - The name of the parameter.
	 * @param {String} pValue - The value of the parameter.
	 */
	setUrlParam(pName, pValue)
	{
		this.urlParams[pName] = pValue;
	}

	/**
	 * @param {Object<String, any>} pOptions - The request options.
	 *
	 * @return {Object<String, any>} - The request options to use.
	 */
	prepareRequestOptions(pOptions)
	{
		return pOptions;
	}

	/**
	 * @param {Object<String, any>} pOptions - The request options.
	 */
	_prepareRequestOptions(pOptions)
	{
		if (!this._SessionData && this._SessionToken)
		{
			if ((pOptions.url.indexOf('?') > -1) && (pOptions.url.indexOf('SessionToken=') === -1))
			{
				pOptions.url += `&SessionToken=${this._SessionToken}`;
			}
			else if (pOptions.url.indexOf('SessionToken=') === -1)
			{
				pOptions.url += `?SessionToken=${this._SessionToken}`;
			}
		}
		else if (this.fable.settings.HeadlightBearerToken && this._SessionData && this._SessionData.hasOwnProperty('SessionID'))
		{
			if (!pOptions.headers)
			{
				pOptions.headers = {};
			}

			pOptions.headers.Authorization = `Bearer ${this._SessionData.SessionID}`;
		}
		const defaultHeaders = this.defaultHeaders;
		// Always a per-request object: fable writes the session cookie into it, and on the shared defaults that cookie
		// would ride every later request as if the caller had supplied it, outliving any session change.
		pOptions.headers = Object.assign(pOptions.headers || {}, defaultHeaders);
		if (!('rejectUnauthorized' in pOptions))
		{
			pOptions.rejectUnauthorized = this.enforceSSL;
		}

		pOptions.HeadlightSessionGeneration = this._SessionGeneration;

		if (!pOptions.timeout)
		{
			if (this.fable.settings.DefaultRestTimeout)
			{
				pOptions.timeout = this.fable.settings.DefaultRestTimeout;
			}
			else
			{
				pOptions.timeout = 270000;
			}
		}

		return this.prepareRequestOptions(pOptions);
	}

	/**
	 * Remember the server's clock from a response's `Date` header, against the local clock at the same moment.
	 *
	 * @param {any} pResponse - The HTTP response object.
	 */
	_noteServerTime(pResponse)
	{
		const tmpServerMS = Date.parse(pResponse && pResponse.headers && pResponse.headers.date);
		if (!Number.isNaN(tmpServerMS))
		{
			this._lastServerTime = { ServerMS: tmpServerMS, ClientMS: Date.now() };
		}
	}

	/**
	 * The server's clock now, projected from the latest response that carried a `Date` header, so a caller can
	 * compare a server-stamped time without trusting the device clock. Accurate to about a second (the header's
	 * resolution). A browser exposes `Date` only on same-origin responses.
	 *
	 * @return {?number} Milliseconds since the epoch, or null before any dated response.
	 */
	estimateServerTime()
	{
		if (!this._lastServerTime)
		{
			return null;
		}
		return this._lastServerTime.ServerMS + (Date.now() - this._lastServerTime.ClientMS);
	}

	/**
	 * @param {Error | String} pError - The error.
	 * @param {any} pResponse - The HTTP response object.
	 * @param {any} pBody - The respone body.
	 */
	_checkForError(pError, pResponse, pBody)
	{
		this._noteServerTime(pResponse);
		/** @type {Error} */
		let tmpError = typeof pError === 'string' ? new Error(pError) : pError;
		if (!tmpError && pBody && pBody.Error)
		{
			tmpError = new Error(pBody.Error);
		}
		if (!tmpError && pResponse && pResponse.statusCode >= 400)
		{
			tmpError = new Error(pBody ? JSON.stringify(pBody) : `Failed with status code ${pResponse.statusCode}`);
		}
		if (!tmpError && pBody && pBody.ErrorCode)
		{
			tmpError = new Error(`Failed with ErrorCode: ${pBody.ErrorCode}`);
		}
		return tmpError;
	}

	/**
	 * Check one page of a bulk entity read before its body is trusted as records: any failure
	 * _checkForError recognizes, and any other body that is not a record array.
	 * Same rule as pict's Pict-Meadow-EntityProvider _validateEntityPageResponse.
	 *
	 * @param {Error | String} pError - The transport error, if any.
	 * @param {any} pResponse - The HTTP response object.
	 * @param {any} pBody - The parsed response body.
	 * @return {Error|null} The failure, or null when the body is a usable record array.
	 */
	_checkForPageError(pError, pResponse, pBody)
	{
		const tmpError = this._checkForError(pError, pResponse, pBody);
		if (tmpError)
		{
			return tmpError;
		}
		if (!Array.isArray(pBody))
		{
			const tmpStatusCode = (pResponse && pResponse.statusCode) ? pResponse.statusCode : 'no response';
			return new Error(`${tmpStatusCode} response body was not a record array: ${JSON.stringify(pBody === undefined ? null : pBody).substring(0, 300)}`);
		}
		return null;
	}

	////////////////////////////////////////////////////////////////////////////////
	// Entity Creation and Update Methods
	/**
	 * Create a new entity record.
	 *
	 * @param {String} pEntityType - The entity type to create.
	 * @param {Object<String, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	createEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.postJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error creating ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Created ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Update an entity record.
	 *
	 * @param {String} pEntityType - The entity type to create.
	 * @param {Object<String, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	updateEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error updating ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Updated ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Upsert an entity record.
	 *
	 * @param {String} pEntityType - The entity type to be upserted.
	 * @param {Object<String, any>} pRecord - The record to upsert.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upsert`),
				body: pRecord
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error upserting ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Upserted ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Upsert a array of entity records.
	 *
	 * @param {String} pEntityType - The entity type to be upserted.
	 * @param {Array<Object<String, any>>} pRecords - The records to upsert.
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntities(pEntityType, pRecords, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upserts`),
				body: pRecords
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error upserting ${pEntityType} records: ${pError.message}`);
				}
				else
				{
					this.log.info(`Upserted multiple ${pEntityType} records (count: ${pBody.length})`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Delete an entity record.
	 *
	 * @param {String} pEntityType - The entity type to create.
	 * @param {String | Number} pIDRecord - The ID of the record to delete.
	 * @param {Function} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	deleteEntity(pEntityType, pIDRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/${pIDRecord}`),
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.delJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error deleting ${pEntityType} record ID ${pIDRecord}: ${pError.message}`);
				}
				else
				{
					this.log.info(`Deleted ${pEntityType} record ID ${pIDRecord}`);
				}
				return fCallback(pError, pBody);
			});
	}

	////////////////////////////////////////////////////////////////////////////////
	// Entity Request Methods
	/**
	 * Initialize cache for a given entity type.
	 *
	 * @param {String} pEntityType - The entity type to cache.
	 */
	initializeCache(pEntityType)
	{
		// This should not be happening as often as it's happening.
		if (!this.cache.hasOwnProperty(pEntityType))
		{
			this.cache[pEntityType] = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('ObjectCache');
			// TODO: Make this a configuration?
			// For now cache for 30 seconds.
			this.cache[pEntityType].maxAge = 30000;
			this.cache[pEntityType].maxLength = 10000;
		}
	}

	/**
	 * Read a record by ID.
	 *
	 * @param {String} pEntityType - The entity type to read.
	 * @param {String | Number} pIDRecord - The ID of the record to read.
	 * @param {Function} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	getEntity(pEntityType, pIDRecord, fCallback)
	{
		this.initializeCache(pEntityType);
		// Discard anything from the cache that has expired or is over size.
		this.cache[pEntityType].prune(
			()=>
			{
				let tmpPossibleRecord = this.cache[pEntityType].read(pIDRecord);

				if (tmpPossibleRecord)
				{
					return fCallback(null, tmpPossibleRecord);
				}

				// Callers asking for a record already being fetched wait on that request instead of issuing another.
				const tmpRequestKey = `${pEntityType}/${pIDRecord}`;
				if (this._entityRequestsInFlight[tmpRequestKey])
				{
					this._entityRequestsInFlight[tmpRequestKey].push(fCallback);
					return;
				}
				this._entityRequestsInFlight[tmpRequestKey] = [ fCallback ];

				let tmpRequestOptions = (
					{
						url: this.formatUrl(`${pEntityType}/${pIDRecord}`),
					});
				tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

				return this.restClient.getJSON(tmpRequestOptions,
					(pError, pResponse, pBody) =>
					{
						pError = this._checkForError(pError, pResponse, pBody);
						if (!pError && pBody)
						{
							this.cache[pEntityType].put(pBody, pIDRecord);
						}
						const tmpWaitingCallbacks = this._entityRequestsInFlight[tmpRequestKey] || [];
						delete this._entityRequestsInFlight[tmpRequestKey];
						for (const tmpWaitingCallback of tmpWaitingCallbacks)
						{
							// One caller's failure must not starve the others waiting on the same record.
							try
							{
								tmpWaitingCallback(pError, pBody);
							}
							catch (pCallbackError)
							{
								this.log.error(`Error in getEntity callback for ${tmpRequestKey}: ${pCallbackError.message || pCallbackError}`);
							}
						}
					});
			}
		);
	}

	/**
	 * Read a record by GUID.
	 *
	 * @param {String} pEntityType - The entity type to read.
	 * @param {String} pGUIDRecord - The GUID of the record to read.
	 * @param {Function} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	getEntityByGUID(pEntityType, pGUIDRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}s/By/GUID${pEntityType}/${encodeURIComponent(pGUIDRecord)}`),
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		return this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError || !Array.isArray(pBody))
				{
					return fCallback(pError || new Error('No body returned') );
				}
				if (pBody && pBody.length > 0)
				{
					return fCallback(pError, pBody[0]);
				}
				else
				{
					return fCallback(pError);
				}
			});
	}

	/**
	 * Format a URL for the HTTP client.
	 *
	 * @param {String} pUrl - The URL to format.
	 *
	 * @return {String} the formatted URL.
	 */
	formatUrl(pUrl, makeAbsolute = true)
	{
		if (Object.keys(this.urlParams).length === 0)
		{
			return (makeAbsolute && !pUrl.includes('://')) ? `${this.serverURL}${pUrl}` : pUrl;
		}
		let joiningPart = pUrl.includes('?') ? '&' : '?';
		for(let paramName in this.urlParams)
		{
			const paramValue = this.urlParams[paramName];
			pUrl += joiningPart + `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`

			// any subsequent parameters join with an &
			joiningPart += '&';
		}

		if (makeAbsolute && !pUrl.includes('://'))
		{
			return `${this.serverURL}${pUrl}`;
		}
		return pUrl;
	}

	/**
	 * @param {String} [pMeadowFilterExpression] - A meadow filter expression; empty selects the unfiltered route.
	 * @return {String} The `/FilteredTo/<filter>` route segment, or an empty string.
	 */
	_filterSegment(pMeadowFilterExpression)
	{
		if (!pMeadowFilterExpression)
		{
			return '';
		}
		return `/FilteredTo/${pMeadowFilterExpression}`;
	}

	/**
	 * Read a count of records with filter.
	 *
	 * @param {String} pEntity - The entity type to read.
	 * @param {String} pMeadowFilterExpression - The filter expression to use.
	 * @param {(pError?: Error, pResults?: { Count: number }) => void} fCallback - The callback to call when the request is complete.
	 */
	getEntitySetCount(pEntity, pMeadowFilterExpression, fCallback)
	{
		this.initializeCache(pEntity);
		// TODO: Should we test for too many record IDs here by string length?
		// FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		// Discard anything from the cache that has expired or is over size.
		let tmpCountOptions = (
			{
				url: this.formatUrl(`${pEntity}s/Count${this._filterSegment(pMeadowFilterExpression)}`),
				rejectUnauthorized: this.enforceSSL,
			});
		if (pEntity.indexOf('/Lite') > 0)
		{
			tmpCountOptions = (
				{
					url: this.formatUrl(`${pEntity.replace('/Lite','')}/Count${this._filterSegment(pMeadowFilterExpression)}`),
					rejectUnauthorized: this.enforceSSL,
				});
		}
		tmpCountOptions = this.prepareRequestOptions(tmpCountOptions);

		return this.restClient.getJSON(tmpCountOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error getting bulk entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Read records with filter.
	 *
	 * @param {String} pEntity - The entity type to read.
	 * @param {String} pMeadowFilterExpression - The filter expression to use.
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 * @param {Number|String} [pCursorStart] - Zero-based index of where to start downloading records from
	 * @param {Number|String} [pRecordLimit] - The maximum number of records to return
	 */
	getEntitySet(pEntity, pMeadowFilterExpression, fCallback, pCursorStart, pRecordLimit)
	{
		this.initializeCache(pEntity);

		// TODO: Should we test for too many record IDs here by string length?
		// FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		// Discard anything from the cache that has expired or is over size.
		let tmpCountOptions = (
			{
				url: this.formatUrl(`${pEntity}s/Count${this._filterSegment(pMeadowFilterExpression)}`),
				rejectUnauthorized: this.enforceSSL,
			});
		if (pEntity.indexOf('/Lite') > 0)
		{
			tmpCountOptions = (
				{
					url: this.formatUrl(`${pEntity.replace('/Lite','')}/Count${this._filterSegment(pMeadowFilterExpression)}`),
					rejectUnauthorized: this.enforceSSL,
				});
		}
		tmpCountOptions = this.prepareRequestOptions(tmpCountOptions);

		let tmpCursorStart = (typeof(pCursorStart) !== 'undefined') ? parseInt(String(pCursorStart)) : 0;
		let tmpRecordLimit = (typeof(pRecordLimit) !== 'undefined') ? parseInt(String(pRecordLimit)) : 1000;

		return this.restClient.getJSON(tmpCountOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error getting bulk entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				let tmpRecordCount = 0;
				if (pBody.Count)
				{
					tmpRecordCount = pBody.Count;
				}

				if (tmpCursorStart > tmpRecordCount)
				{
					let tmpErrorMessage = `Cursor start of ${tmpCursorStart} for [${pEntity}] filtered to [${pMeadowFilterExpression}] is greater than the total records ${tmpRecordCount}.`;
					this.log.error(tmpErrorMessage);
					return fCallback(new Error(tmpErrorMessage));
				}

				let tmpDownloadURIFragments = [];
				let tmpDownloadBatchSize = this.options.DownloadBatchSize;

				// Create a depleting maximum as we create the uri fragments
				let tmpDepletingMaximum = tmpRecordLimit;

				for (let i = 0; i < (tmpRecordCount / tmpDownloadBatchSize); i++)
				{
					// If we've depleted the maximum, stop generating URI fragments
					if (tmpDepletingMaximum < 1)
					{
						continue;
					}

					// Depletion logic
					let tmpFragmentRecordCount = Math.min(tmpDepletingMaximum, tmpDownloadBatchSize);
					tmpDepletingMaximum = tmpDepletingMaximum - tmpFragmentRecordCount;

					// Generate each of the URI fragments to download -- Lite records come prepluralized
					if (pEntity.indexOf('/Lite') > 0)
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}${this._filterSegment(pMeadowFilterExpression)}/${(i*tmpDownloadBatchSize)+tmpCursorStart}/${tmpFragmentRecordCount}`));
					}
					else
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}s${this._filterSegment(pMeadowFilterExpression)}/${(i*tmpDownloadBatchSize)+tmpCursorStart}/${tmpFragmentRecordCount}`));
					}
				}

				let tmpEntitySet = [];
				// Now run these in series (it's possible to parallelize but no reason to)
				this.fable.Utility.eachLimit(tmpDownloadURIFragments, 1,
					(pURIFragment, fDownloadCallback)=>
					{
						let tmpRecordBatchRequestOptions = (
						{
							url: `${pURIFragment}`,
							rejectUnauthorized: this.enforceSSL,
						});
						tmpRecordBatchRequestOptions = this.prepareRequestOptions(tmpRecordBatchRequestOptions);

						this.restClient.getJSON(tmpRecordBatchRequestOptions,
							(pDownloadError, pDownloadResponse, pDownloadBody)=>
							{
								let tmpDownloadError = this._checkForPageError(pDownloadError, pDownloadResponse, pDownloadBody);
								if (tmpDownloadError)
								{
									this.log.error(`Error downloading bulk entities of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpRecordBatchRequestOptions.url}]: ${tmpDownloadError}`);
									return fDownloadCallback(tmpDownloadError);
								}
								tmpEntitySet = tmpEntitySet.concat(pDownloadBody);
								// Should we be caching each record?
								return fDownloadCallback();
							});
					},
					(pFullDownloadError)=>
					{
						return fCallback(pFullDownloadError, tmpEntitySet);
					})
			});
	}


	/**
	 * Read records with filter, executing a function for initial count and with each returned page.
	 *
	 * Great for longer queries.
	 *
	 * @param {String} pEntity - The entity type to read.
	 * @param {String} pMeadowFilterExpression - The filter expression to use.
	 * @param {(count: Number) => void} fCountFunction - The function to call the count of records
	 * @param {(count: Number, records: Array<any>) => void} fPageFunction - The function to call with each page of records
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 */
	getEntitySetWithPages(pEntity, pMeadowFilterExpression, fCountFunction, fPageFunction, fCallback)
	{
		this.initializeCache(pEntity);
		// TODO: Should we test for too many record IDs here by string length?
		// FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		// Discard anything from the cache that has expired or is over size.
		let tmpCountOptions = (
			{
				url: this.formatUrl(`${pEntity}s/Count${this._filterSegment(pMeadowFilterExpression)}`),
				rejectUnauthorized: this.enforceSSL,
			});
		if (pEntity.indexOf('/Lite') > 0)
		{
			tmpCountOptions = (
				{
					url: this.formatUrl(`${pEntity.replace('/Lite','')}/Count${this._filterSegment(pMeadowFilterExpression)}`),
					rejectUnauthorized: this.enforceSSL,
				});
		}
		tmpCountOptions = this.prepareRequestOptions(tmpCountOptions);

		return this.restClient.getJSON(tmpCountOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error getting bulk entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				let tmpRecordCount = 0;
				if (pBody.Count)
				{
					tmpRecordCount = pBody.Count;
				}

				// TODO: Map out if we need more than these hooks.
				try
				{
					fCountFunction(tmpRecordCount);
				}
				catch(pCountFunctionError)
				{
					this.log.error(`Error executing count function for getEntitySetWithPages [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pCountFunctionError}`);
				}

				let tmpDownloadURIFragments = [];
				let tmpDownloadBatchSize = this.options.DownloadBatchSize;
				for (let i = 0; i < (tmpRecordCount / tmpDownloadBatchSize); i++)
				{
					// Generate each of the URI fragments to download
					if (pEntity.indexOf('/Lite') > 0)
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}${this._filterSegment(pMeadowFilterExpression)}/${i*tmpDownloadBatchSize}/${tmpDownloadBatchSize}`));
					}
					else
					{
						tmpDownloadURIFragments.push(this.formatUrl(`${pEntity}s${this._filterSegment(pMeadowFilterExpression)}/${i*tmpDownloadBatchSize}/${tmpDownloadBatchSize}`));
					}
				}

				let tmpEntitySet = [];
				// Now run these in series (it's possible to parallelize but no reason to)
				this.fable.Utility.eachLimit(tmpDownloadURIFragments, 1,
					(pURIFragment, fDownloadCallback)=>
					{
						let tmpRecordBatchRequestOptions = (
						{
							url: `${pURIFragment}`,
							rejectUnauthorized: this.enforceSSL,
						});
						tmpRecordBatchRequestOptions = this.prepareRequestOptions(tmpRecordBatchRequestOptions);

						this.restClient.getJSON(tmpRecordBatchRequestOptions,
							(pDownloadError, pDownloadResponse, pDownloadBody)=>
							{
								let tmpDownloadError = this._checkForPageError(pDownloadError, pDownloadResponse, pDownloadBody);
								if (tmpDownloadError)
								{
									this.log.error(`Error downloading bulk entities of [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpRecordBatchRequestOptions.url}]: ${tmpDownloadError}`);
									return fDownloadCallback(tmpDownloadError);
								}
								tmpEntitySet = tmpEntitySet.concat(pDownloadBody);

								try
								{
									if (Array.isArray(pDownloadBody))
									{
										fPageFunction(pDownloadBody.length, pDownloadBody);
									}
								}
								catch(pPageFunctionError)
								{
									this.log.error(`Error executing page received function for getEntitySetWithPages [${pEntity}] filtered to [${pMeadowFilterExpression}] from server [${tmpCountOptions.url}]: ${pPageFunctionError}`);
								}

								// Should we be caching each record?
								return fDownloadCallback();
							});
					},
					(pFullDownloadError)=>
					{
						return fCallback(pFullDownloadError, tmpEntitySet);
					})
			});
	}

	/**
	 * Request options for a URL argument: a string, or an options object whose `url` is formatted like a string URL
	 * and whose other properties pass through to fable's RestClient (e.g. `RetrySafe`, `Retry`, `timeout`).
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL, or the request options.
	 * @param {boolean} [pMakeAbsolute] - Prefix a relative URL with the server URL (formatUrl).
	 *
	 * @return {Record<string, any>} A fresh request options object.
	 */
	_requestOptionsFor(pURL, pMakeAbsolute = true)
	{
		if (pURL && (typeof(pURL) === 'object'))
		{
			let tmpOptions = Object.assign({}, pURL, { url: this.formatUrl(pURL.url, pMakeAbsolute) });
			if (pURL.headers)
			{
				tmpOptions.headers = Object.assign({}, pURL.headers);
			}
			return tmpOptions;
		}
		return { url: this.formatUrl(String(pURL), pMakeAbsolute) };
	}

	/**
	 * @param {String|HeadlightRequestOptions} pURL - The URL, or the request options.
	 *
	 * @return {String} The URL as the caller gave it, for log lines.
	 */
	_requestURLFor(pURL)
	{
		return (pURL && (typeof(pURL) === 'object')) ? pURL.url : String(pURL);
	}

	////////////////////////////////////////////////////////////////////////////////
	// Low-level API service requests
	/**
	 * Send a GET request. Parses response as JSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 */
	getJSON(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL));

		return this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error reading JSON from server [${tmpRequestOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(null, pBody);
			});
	}

	/**
	 * Send a GET request. Parses response as a Buffer.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {(pError?: Error, pResult?: Buffer) => void} fCallback - The callback to call when the request is complete.
	 */
	getBinary(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL));

		return this.restClient.executeChunkedRequestBinary(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error reading Binary GET from from server [${tmpRequestOptions.url}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(null, pBody);
			});
	}

	/**
	 * Upload binary data to the server with optional progress tracking.
	 *
	 * Routes through this.restClient.executeBinaryUpload() so the offline
	 * interceptor can catch matching URLs at the RestClient layer, the
	 * same way JSON requests are intercepted via executeJSONRequest.
	 *
	 * @param {string|HeadlightRequestOptions} pURL - Relative URL (will be formatted with serverURL prefix), or request options carrying it (`url`)
	 * @param {File|Blob} pFile - The binary data to upload
	 * @param {string} pMimeType - MIME type for Content-Type header
	 * @param {function} fCallback - Callback (pError, pResponseBody)
	 * @param {function} [fOnProgress] - Optional progress callback (0.0 to 1.0)
	 */
	postBinary(pURL, pFile, pMimeType, fCallback, fOnProgress)
	{
		let tmpRequestOptions = this._requestOptionsFor(pURL, true);
		tmpRequestOptions.method = 'POST';
		tmpRequestOptions.body = pFile;
		tmpRequestOptions.headers = Object.assign({}, tmpRequestOptions.headers, { 'Content-Type': pMimeType });
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		return this.restClient.executeBinaryUpload(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error uploading binary to [${this._requestURLFor(pURL)}]: ${pError}`);
					return fCallback(pError);
				}
				return fCallback(null, pBody);
			},
			fOnProgress);
	}

	/**
	 * Download binary data from the server as a Blob.
	 *
	 * Routes through this.restClient so the offline interceptor can
	 * catch matching URLs at the IPC layer. Uses executeChunkedRequest
	 * (raw response, no JSON parsing) and converts the result to a Blob
	 * for browser consumers.
	 *
	 * @param {string|HeadlightRequestOptions} pURL - Relative URL (will be formatted with serverURL prefix), or request options carrying it (`url`)
	 * @param {function} fCallback - Callback (pError, pBlob)
	 */
	getBinaryBlob(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL, true));

		return this.restClient.executeChunkedRequest(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error downloading binary from [${this._requestURLFor(pURL)}]: ${pError}`);
					return fCallback(pError);
				}

				// If the body is already a Blob (e.g., from IPC BlobStore), return directly
				if (typeof Blob !== 'undefined' && pBody instanceof Blob)
				{
					return fCallback(null, pBody);
				}

				// Convert Buffer/string/ArrayBuffer to Blob for browser consumers
				if (typeof Blob !== 'undefined')
				{
					try
					{
						let tmpBlob = new Blob([pBody]);
						return fCallback(null, tmpBlob);
					}
					catch (pBlobError)
					{
						return fCallback(pBlobError);
					}
				}

				// Node.js: return the raw body as-is (Buffer/string)
				return fCallback(null, pBody);
			});
	}

	/**
	 * Send a POST request. Parses response as JSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {any} pRequestPostObject - The object to send in the body of the request as JSON.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 */
	postJSON(pURL, pRequestPostObject, fCallback)
	{
		let tmpRequestOptions = this._requestOptionsFor(pURL);
		tmpRequestOptions.body = pRequestPostObject;
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.postJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error posting to ${this._requestURLFor(pURL)}: ${pError.message}`, pRequestPostObject);
				}
				else
				{
					this.log.info(`Posted to ${this._requestURLFor(pURL)}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Send a PUT request. Parses response as JSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL to send the request to, or request options carrying it (`url`).
	 * @param {any} pRequestPutObject - The object to send in the body of the request as JSON.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 */
	putJSON(pURL, pRequestPutObject, fCallback)
	{
		let tmpRequestOptions = this._requestOptionsFor(pURL);
		tmpRequestOptions.body = pRequestPutObject;
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error putting to ${this._requestURLFor(pURL)}: ${pError.message}`, pRequestPutObject);
				}
				else
				{
					this.log.info(`Put to ${this._requestURLFor(pURL)}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Issue a DELETE to an arbitrary URL (for endpoints that aren't a plain entity delete, e.g.
	 * `Permissions/Memberships/For/User/:IDUser/In/:Context/:IDContext`). Mirrors putJSON.
	 *
	 * @param {String|HeadlightRequestOptions} pURL - The URL, or request options carrying it (`url`).
	 * @param {Function} fCallback - (error, body)
	 */
	deleteJSON(pURL, fCallback)
	{
		let tmpRequestOptions = this._prepareRequestOptions(this._requestOptionsFor(pURL));

		this.restClient.delJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Error deleting ${this._requestURLFor(pURL)}: ${pError.message}`);
				}
				else
				{
					this.log.info(`Deleted ${this._requestURLFor(pURL)}`);
				}
				return fCallback(pError, pBody);
			});
	}


	////////////////////////////////////////////////////////////////////////////////
	// User and Session Management
	/**
	 * @return {SessionInfo?} - The session data.
	 */
	get session()
	{
		return this._SessionData;
	}

	/**
	 * @return {Boolean} - True if the client is authenticated.
	 */
	get loggedIn()
	{
		return this._LoggedIn;
	}

	/**
	 * @param {String} [pSessionToken] - The session token to set on requests.
	 */
	setSessionToken(pSessionToken)
	{
		this._SessionToken = pSessionToken;
	}

	/**
	 * @param {SessionInfo} [pSessionData] - The session data to set.
	 */
	setSessionData(pSessionData)
	{
		this._SessionData = pSessionData;
		this._SessionSource = 'external';
		this._SessionGeneration++;

		if (!this.restClient.cookie)
		{
			this.restClient.cookie = {};
		}

		if ((typeof(this._SessionData) == 'object') && this._SessionData.SessionID)
		{
			this.restClient.cookie['UserSession'] = this._SessionData.SessionID;
		}
	}

	/**
	 * Clear local cookies and session data.
	 */
	resetSessionData()
	{
		if (typeof(this.restClient.cookie) === 'object')
		{
			this.restClient.cookie = false;
		}
		this._SessionData = false;
		this._SessionSource = null;
		this._SessionGeneration++;
		this._Impersonating = false;
	}

	/**
	 * @return {Boolean} - True if the client is impersonating.
	 */
	get impersonating()
	{
		return this._Impersonating;
	}

	/**
	 * Authenticate with the server.
	 *
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	authenticate(fCallback)
	{
		this.checkDefaultsInSettings();
		this.restClient.postJSON(
			this._authRequestOptions(
				{
					url: this.formatUrl('/Authenticate'),
					body:
						{
							UserName: this.userID,
							Password: this.password
						},
					rejectUnauthorized: this.enforceSSL,
				}),
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					const tmpKeepSession = (this.options.KeepSessionOnFailedAuthenticate !== false) && this._SessionData && this._SessionData.SessionID;
					this.log.error(`Problem Logging Into HeadLight API Server [${this.serverURL}] as ${this.userID}: ${pError.message || pError}${tmpKeepSession ? ' (keeping the existing session)' : ''}`);
					if (!tmpKeepSession)
					{
						this.resetSessionData();
					}
					return fCallback(pError, false);
				}

				//this.log.info(`Successfully logged into HeadLight API Server as ${pBody.LoginID}`);

				this.setSessionData(pBody);
				this._SessionSource = 'credentials';

				return fCallback(null, this._SessionData)
			});
	}

	/**
	 * Options for a request that is part of authentication itself: never routed through session recovery (it would
	 * wait on the recovery it belongs to), and replayed on transient failures under `AuthenticateRetry`.
	 *
	 * @param {Record<string, any>} pOptions - The request options.
	 * @param {boolean} [pRetry] - Apply the `AuthenticateRetry` policy (login requests only).
	 *
	 * @return {Record<string, any>} The same options, decorated.
	 */
	_authRequestOptions(pOptions, pRetry = true)
	{
		pOptions.AuthenticationRecovery = false;
		if (pRetry && this.options.AuthenticateRetry)
		{
			pOptions.Retry = this.options.AuthenticateRetry;
			// Logging in twice is harmless; the second login just mints another session.
			pOptions.RetrySafe = true;
		}
		return pOptions;
	}

	/**
	 * @return {boolean} True when the current session came from this client's own login and the credentials to log in
	 *     again are at hand. Never true for a session handed in or an impersonated one.
	 */
	_canReauthenticate()
	{
		return (this.options.AutoReauthenticate !== false)
			&& (this._SessionSource === 'credentials')
			&& !this._Impersonating
			&& !!this.userID && (this.userID !== 'DEFAULT')
			&& !!this.password;
	}

	/**
	 * fable RestClient authenticationRecovery hook: a request came back 401. When the session is one this client
	 * logged in itself and it has really expired, log in again; fable then replays the request once.
	 *
	 * @param {{ options: Record<string, any>, response: any }} pContext - The request about to be replayed, and the 401.
	 *
	 * @return {Promise<boolean>} True when a new session is in place and the request should be replayed.
	 */
	_recoverSession(pContext)
	{
		return new Promise((fResolve) =>
		{
			if (!this._canReauthenticate())
			{
				return fResolve(false);
			}
			const tmpRequest = `${(pContext.options && pContext.options.method) || 'request'} ${(pContext.options && pContext.options.url) || ''}`;
			const tmpSentGeneration = pContext.options ? pContext.options.HeadlightSessionGeneration : undefined;
			if ((typeof(tmpSentGeneration) === 'number') && (tmpSentGeneration !== this._SessionGeneration))
			{
				// Sent on a session that has since been replaced (another request's recovery logged in again).
				return fResolve(true);
			}
			const fLogin = () =>
			{
				this.authenticate((pError) =>
				{
					if (pError)
					{
						this.log.warn(`Session for ${this.userID} expired and logging in again failed; returning the 401 for ${tmpRequest}.`);
						return fResolve(false);
					}
					this.log.info(`Session for ${this.userID} expired; logged in again, replaying ${tmpRequest}.`);
					return fResolve(true);
				});
			};
			if (this.options.ReauthenticateVerifySession === false)
			{
				return fLogin();
			}
			this.checkSession((pError, pLoggedIn) =>
			{
				if (!pError && pLoggedIn)
				{
					this.log.warn(`Got a 401 for ${tmpRequest}, but the session for ${this.userID} is still valid; not logging in again.`);
					return fResolve(false);
				}
				return fLogin();
			});
		});
	}

	/**
	 * Authenticate with the server using credentials.
	 *
	 * @param {String} pUserID - The user ID to authenticate with.
	 * @param {String} pPassword - The password to authenticate with.
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	authenticateWithCredentials(pUserID, pPassword, fCallback)
	{
		this.restClient.postJSON(
			this._authRequestOptions(
				{
					url: this.formatUrl('/Authenticate'),
					body:
						{
							UserName: pUserID,
							Password: pPassword
						},
					// Honor the client's SSL-enforcement setting, matching authenticate()
					// and impersonate() (via _prepareRequestOptions). Without this, the
					// credential login falls back to Node's https default of
					// rejectUnauthorized:true, so an EnforceSSL:false client (e.g. one
					// talking to an internal gateway host like kong:8443 whose cert does
					// not list that hostname) fails the TLS handshake before authenticating.
					rejectUnauthorized: this.enforceSSL,
				}),
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Problem Logging Into HeadLight API Server [${this.serverURL}] as ${pUserID}:`, pError);
					this.resetSessionData();
					return fCallback(pError, this._SessionData);
				}

				//this.log.info(`Successfully logged into HeadLight API Server as ${pBody.LoginID}`);

				this.setSessionData(pBody);

				return fCallback(null, this._SessionData)
			});
	}

	/**
	 * Deauthenticate with the server.
	 *
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	deauthenticate(fCallback)
	{
		this.restClient.getJSON(
			this._authRequestOptions(
				{
					url: this.formatUrl('/Deauthenticate'),
				}, false),
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Problem Logging out of HeadLight API Server [${this.serverURL}] as ${this.userID}:`, pError);
				}

				this.log.info(`Successfully logged out of the HeadLight API Server`);
				this.resetSessionData();

				return fCallback(pError, this._SessionData)
			});
	}

	/**
	 * Impersonate a user.
	 *
	 * @param {String | Number} pIDUser - The ID of the user to impersonate.
	 * @param {(pError?: Error, pResult?: SessionInfo) => void} fCallback - The callback to call when the request is complete.
	 */
	impersonate(pIDUser, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`/Authentication/Impersonate/${pIDUser}`),
			});
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error(`Problem Impersonating User ${pIDUser}`, pError);
					return fCallback(pError);
				}

				if (pBody.Success)
				{
					// Never log the response body — it carries the live SessionID of
					// a privileged session.
					const tmpUser = pBody.User || {};
					this.log.info(`Successfully Impersonating User ${pIDUser}`,
						{ UserID: tmpUser.UserID, LoginID: tmpUser.LoginID, CustomerID: tmpUser.CustomerID, UserRoleIndex: tmpUser.UserRoleIndex });
					this._Impersonating = true;
					this.setSessionData(pBody.User);
					return fCallback(null, this._SessionData);
				}
				else
				{
					this.log.error(`Impersonating User ${pIDUser} Failed`, pBody);
					return fCallback(new Error(`Impersonation of ${pIDUser} was not successful!`));
				}
			});
	};

	/**
	 * Check out a new session token.
	 *
	 * @param {(pError?: Error, pResult?: String) => void} fCallback - The callback to call when the request is complete.
	 */
	checkoutSessionToken(fCallback)
	{
		this.restClient.getJSON(
			{
				url: this.formatUrl(`/CheckoutSessionToken`),
			},
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error('Problem Checking Out a Session Token from HeadLight API Server', pError);
					return fCallback(pError);
				}

				if (pBody.hasOwnProperty('Token'))
				{
					this.setSessionToken(pBody.Token);
				}

				return fCallback(null, pBody);
			});
	}

	/**
	 * Validate current authentication with the server. Updates local session state if it is de-synced.
	 *
	 * @param {(pError?: Error, pResult?: Boolean) => void} fCallback - The callback to call when the request is complete.
	 */
	checkSession(fCallback)
	{
		let tmpRequestOptions = this._authRequestOptions(
			{
				url: this.formatUrl(`/CheckSession`),
			}, false);
		tmpRequestOptions = this._prepareRequestOptions(tmpRequestOptions);

		this.restClient.getJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				pError = this._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					this.log.error('Problem Checking Session on HeadLight API Server', pError);
					return fCallback(pError);
				}

				if (pBody.hasOwnProperty('LoggedIn') && pBody.LoggedIn)
				{
					// Update cached session data in case configuration changed
					this._SessionData = pBody;
					this._LoggedIn = true;
					return fCallback(null, true);
				}
				else
				{
					this._LoggedIn = false;
					this._SessionData = false;
					return fCallback(null, false);
				}
			});
	}
}

module.exports = HeadlightRestClient;

module.exports.default_configuration = defaultHeadLightRestClientOptions;

},{"fable-serviceproviderbase":438}],21:[function(require,module,exports){
'use strict';

const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libSampleScope = require('./Sample-Scope.js');
const libSampleTestRules = require('./SampleTest-Rules.js');

const MAX_CACHED_SCOPES = 25;

/**
 * Samples and the things connected to them. forSample() hands back a SampleScope that loads and keeps one sample's
 * connected records; SampleTestRules answers the same questions over records a caller already has.
 *
 * Reads go through `options.RestClient`, else the fable's `HeadlightRestClient` (headlight-rest-client), so the
 * provider works wherever that client is set up: a pict app in the browser or a Node tool.
 */
class HeadlightSamples extends libFableServiceProviderBase
{
	/**
	 * @param {Object} pFable
	 * @param {{ RestClient?: Object }} [pOptions]
	 * @param {String} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'HeadlightSamples';
		/** @type {Map<number, libSampleScope>} - IDSample -> its scope, oldest first */
		this._scopes = new Map();
	}

	/**
	 * @return {Object} The headlight-rest-client reads go through.
	 */
	get restClient()
	{
		return (this.options && this.options.RestClient) || this.fable.HeadlightRestClient;
	}

	/**
	 * The scope for a sample: the same one for every caller, so what one screen loaded the next one reuses. The
	 * MAX_CACHED_SCOPES most recently asked-for samples are kept.
	 *
	 * @param {number} pIDSample
	 * @return {libSampleScope}
	 */
	forSample(pIDSample)
	{
		const tmpIDSample = Number(pIDSample) || 0;
		let tmpScope = this._scopes.get(tmpIDSample);
		if (tmpScope)
		{
			this._scopes.delete(tmpIDSample);
		}
		else
		{
			tmpScope = new libSampleScope(this, tmpIDSample);
		}
		this._scopes.set(tmpIDSample, tmpScope);
		while (this._scopes.size > MAX_CACHED_SCOPES)
		{
			this._scopes.delete(this._scopes.keys().next().value);
		}
		return tmpScope;
	}

	/**
	 * The test summary row for one test instance (see SampleTest-Rules buildTestSummary), from the scope of the sample
	 * it belongs to: a scope that has it loaded, else its sample's, found through TestInstanceSampleJoin.
	 *
	 * @param {number} pIDTestInstance
	 * @return {Promise<?import('./SampleTest-Rules.js').TestSummaryRow>} null when the test instance is on no sample
	 */
	async getTestSummaryRow(pIDTestInstance)
	{
		const tmpIDTestInstance = Number(pIDTestInstance) || 0;
		if (!tmpIDTestInstance)
		{
			return null;
		}
		let tmpScope = [ ...this._scopes.values() ].reverse().find((pScope) => pScope.hasLoadedTestInstance(tmpIDTestInstance));
		if (!tmpScope)
		{
			const tmpJoins = await this.getEntitySet('TestInstanceSampleJoin', `FBV~IDTestInstance~EQ~${tmpIDTestInstance}`);
			const tmpJoin = tmpJoins.find((pJoin) => Number(pJoin.IDSample) > 0);
			if (!tmpJoin)
			{
				return null;
			}
			tmpScope = this.forSample(tmpJoin.IDSample);
		}
		const tmpRows = await tmpScope.getTestSummary();
		return tmpRows.find((pRow) => Number(pRow.TestInstance.IDTestInstance) === tmpIDTestInstance) || null;
	}

	/**
	 * A QuickSummaries record decorator for TestInstance (`HeadlightQuickSummaries.addRecordDecorator('TestInstance',
	 * ...)`): the result and remarks a linked form holds for approval, marked `(pending approval)`, and the linked
	 * documents' form statuses as `FormStatus`, so the popover says what a sample's Tests tab says.
	 *
	 * @param {Record<string, any>} pSummaryRecord - the summary record QuickSummaries built
	 * @param {Record<string, any>} pTestInstance - the TestInstance record
	 * @return {Promise<Record<string, any>>}
	 */
	async decorateTestInstanceSummary(pSummaryRecord, pTestInstance)
	{
		const tmpRow = await this.getTestSummaryRow(pTestInstance && pTestInstance.IDTestInstance);
		if (!tmpRow)
		{
			return pSummaryRecord;
		}
		if (tmpRow.ResultPending)
		{
			pSummaryRecord.TestResult = `${tmpRow.Result} (pending approval)`;
		}
		if (tmpRow.NotesPending)
		{
			pSummaryRecord.Notes = `${tmpRow.Notes} (pending approval)`;
		}
		const tmpStatuses = tmpRow.Documents.filter((pEntry) => pEntry.Status)
			.map((pEntry) => `${pEntry.Document.Name || `Document #${pEntry.Document.IDDocument}`}: ${pEntry.Status}`);
		pSummaryRecord.FormStatus = tmpStatuses.length ? tmpStatuses.join('; ') : 'N/A';
		return pSummaryRecord;
	}

	/**
	 * Every record of an entity matching a meadow filter, across pages.
	 *
	 * @param {String} pEntity
	 * @param {String} pFilter
	 * @return {Promise<Array<Object>>}
	 */
	getEntitySet(pEntity, pFilter)
	{
		return new Promise((fResolve, fReject) =>
		{
			const tmpClient = this.restClient;
			if (!tmpClient || (typeof tmpClient.getEntitySetWithPages !== 'function'))
			{
				return fReject(new Error('HeadlightSamples has no REST client; register HeadlightRestClient or pass options.RestClient.'));
			}
			tmpClient.getEntitySetWithPages(pEntity, pFilter, () =>
			{
				return undefined;
			}, () =>
			{
				return undefined;
			}, (pError, pRecords) =>
			{
				if (pError)
				{
					return fReject((pError instanceof Error) ? pError : new Error(`Reading ${pEntity} failed: ${pError}`));
				}
				return fResolve(Array.isArray(pRecords) ? pRecords : []);
			});
		});
	}
}

module.exports = HeadlightSamples;
module.exports.default_configuration = {};
module.exports.SampleScope = libSampleScope;
module.exports.SampleTestRules = libSampleTestRules;

},{"./Sample-Scope.js":22,"./SampleTest-Rules.js":23,"fable-serviceproviderbase":438}],22:[function(require,module,exports){
'use strict';

const libSampleTestRules = require('./SampleTest-Rules.js');

/**
 * @typedef {Object} SampleRecordReader
 * @property {(pEntity: String, pFilter: String) => Promise<Array<Object>>} getEntitySet - Every record of an entity
 *   matching a meadow filter, across pages; rejects on a failed read.
 */

/**
 * Everything connected to one sample, loaded on first ask and kept until invalidate(). Get one from
 * HeadlightSamples.forSample, which hands every caller the same scope for a sample, so screens showing the same
 * sample agree; reads go through the provider's REST client.
 */
class SampleScope
{
	/**
	 * @param {SampleRecordReader} pReader
	 * @param {number} pIDSample
	 */
	constructor(pReader, pIDSample)
	{
		this.reader = pReader;
		this.IDSample = Number(pIDSample) || 0;
		/** @type {?Promise<import('./SampleTest-Rules.js').TestBundle>} */
		this._testBundle = null;
		/** @type {?import('./SampleTest-Rules.js').TestBundle} - the test bundle once it has loaded */
		this.loadedTestBundle = null;
	}

	/**
	 * Drop what has been loaded so the next ask reads it again.
	 */
	invalidate()
	{
		this._testBundle = null;
		this.loadedTestBundle = null;
	}

	/**
	 * Whether the loaded test bundle has a test instance; false until the bundle has loaded.
	 *
	 * @param {number} pIDTestInstance
	 * @return {boolean}
	 */
	hasLoadedTestInstance(pIDTestInstance)
	{
		const tmpMap = this.loadedTestBundle && this.loadedTestBundle.TestInstanceDocumentMap;
		return !!tmpMap && Object.prototype.hasOwnProperty.call(tmpMap, String(Number(pIDTestInstance) || 0));
	}

	/**
	 * The sample's test instances, their tests and the documents linked to each (see SampleTest-Rules buildTestBundle).
	 * A failed read rejects, and the next call tries again.
	 *
	 * @return {Promise<import('./SampleTest-Rules.js').TestBundle>}
	 */
	getTestBundle()
	{
		if (!this._testBundle)
		{
			const tmpLoad = this._loadTestBundle();
			this._testBundle = tmpLoad;
			tmpLoad.then((pBundle) =>
			{
				if (this._testBundle === tmpLoad)
				{
					this.loadedTestBundle = pBundle;
				}
			}, () =>
			{
				if (this._testBundle === tmpLoad)
				{
					this._testBundle = null;
				}
			});
		}
		return this._testBundle;
	}

	/**
	 * One row per test with its result, remarks and linked documents' form statuses, pending form values first (see
	 * SampleTest-Rules buildTestSummary).
	 *
	 * @return {Promise<Array<import('./SampleTest-Rules.js').TestSummaryRow>>}
	 */
	async getTestSummary()
	{
		return libSampleTestRules.buildTestSummary(await this.getTestBundle());
	}

	/**
	 * Every record of an entity whose `pField` is in `pIDs`; no read for an empty list, which the server would take as
	 * `IN ('')` and answer with ID 0 rows.
	 *
	 * @param {String} pEntity
	 * @param {String} pField
	 * @param {Array<number>} pIDs
	 * @param {String} [pExtraFilter] - more meadow filter terms, prefixed with `~`
	 * @return {Promise<Array<Object>>}
	 */
	async _getByIDs(pEntity, pField, pIDs, pExtraFilter)
	{
		const tmpIDs = [ ...new Set((pIDs || []).map(Number).filter((pID) => pID > 0)) ];
		if (!tmpIDs.length)
		{
			return [];
		}
		return (await this.reader.getEntitySet(pEntity, `FBL~${pField}~INN~${tmpIDs.join(',')}${pExtraFilter || ''}`)) || [];
	}

	/**
	 * @return {Promise<import('./SampleTest-Rules.js').TestBundle>}
	 */
	async _loadTestBundle()
	{
		if (!this.IDSample)
		{
			return libSampleTestRules.buildTestBundle({});
		}
		const tmpInstanceJoins = (await this.reader.getEntitySet('TestInstanceSampleJoin', `FBV~IDSample~EQ~${this.IDSample}`)) || [];
		const tmpTestInstances = await this._getByIDs('TestInstance', 'IDTestInstance', tmpInstanceJoins.map((pJoin) => pJoin.IDTestInstance));
		if (!tmpTestInstances.length)
		{
			return libSampleTestRules.buildTestBundle({});
		}
		const [ tmpTests, tmpTestInstanceDocumentJoins, tmpSampleDocumentJoins ] = await Promise.all(
			[
				this._getByIDs('Test', 'IDTest', tmpTestInstances.map((pInstance) => pInstance.IDTest)),
				this._getByIDs('DocumentPolyJoin', 'IDRemote', tmpTestInstances.map((pInstance) => pInstance.IDTestInstance), '~FBV~RemoteType~EQ~TestInstance'),
				this.reader.getEntitySet('DocumentPolyJoin', `FBV~RemoteType~EQ~Sample~FBV~IDRemote~EQ~${this.IDSample}`),
			]);
		const tmpDocuments = await this._getByIDs('Document', 'IDDocument', (tmpTestInstanceDocumentJoins || []).concat(tmpSampleDocumentJoins || []).map((pJoin) => pJoin.IDDocument));
		return libSampleTestRules.buildTestBundle(
			{
				TestInstances: tmpTestInstances,
				Tests: tmpTests,
				TestInstanceDocumentJoins: tmpTestInstanceDocumentJoins,
				SampleDocumentJoins: tmpSampleDocumentJoins || [],
				Documents: tmpDocuments,
			});
	}
}

module.exports = SampleScope;

},{"./SampleTest-Rules.js":23}],23:[function(require,module,exports){
'use strict';

/**
 * What a sample's tests and their documents say, as pure functions over records already loaded: no server or DOM
 * access, so the same answers come out in a browser bundle and in Node. Sample-Scope.js loads the records.
 */

const libTestResultOptions = require('headlight-dynamic-inputs-bundle/source/providers/_TestResultOptions.js');

// Test result code -> colour tone; pass / fail as the config app's Tests tab groups them (web/headlight-platform-configuration/source/samples/SampleWorkspace-Provider.js _tiStatusClass).
const RESULT_TONES = { PASS: 'success', PASC: 'success', SQTY: 'success', FAIL: 'danger', FAIC: 'danger', PROG: 'warning', PEND: 'warning', VOID: 'muted' };

/**
 * @typedef {Object} FormTestCatalog
 * @property {Record<String, { FormName: String, TestHashes: Array<String>, StoryRole?: String }>} Types - DocumentType (RNI Hash) -> the form's name, the tests it declares and its getRNIStoryRole.
 * @property {Record<String, { Name: String }>} Tests - Test.Hash -> the test.
 */

/**
 * @typedef {Object} DocumentTest
 * @property {String} Hash - Test.Hash, e.g. `TR327Av1`.
 * @property {String} Code - The hash as a lab reads it, e.g. `TR 327A`.
 * @property {String} Name - Test.Name, or '' when it only repeats the hash.
 * @property {boolean} Assigned - A test instance of this sample is joined to the document.
 * @property {String} Result - The test instance's result as text (`Passed`), or '' when none is recorded.
 * @property {String} ResultTone - 'success' | 'danger' | 'warning' | 'info' | 'muted' | ''.
 */

/**
 * A test hash as lab staff write it: the version suffix dropped and a space before the number (`TR327Av1` -> `TR 327A`,
 * `AASHTOMP41` -> `AASHTO MP 41`).
 * Hashes that don't fit that shape come back unchanged.
 *
 * @param {String} pHash
 * @return {String}
 */
function formatTestCode(pHash)
{
	const tmpHash = String(pHash || '').trim();
	const tmpMatch = /^([A-Za-z]+)(\d[0-9A-Za-z.-]*?)(v\d+)?$/.exec(tmpHash);
	if (!tmpMatch)
	{
		return tmpHash;
	}
	const tmpAASHTO = /^(AASHTO)([A-Z]+)$/.exec(tmpMatch[1]);
	if (tmpAASHTO)
	{
		return `${tmpAASHTO[1]} ${tmpAASHTO[2]} ${tmpMatch[2]}`;
	}
	return `${tmpMatch[1]} ${tmpMatch[2]}`;
}

/**
 * @param {Object} pRNI - a ReportNamedInstance row
 * @return {?Object} The RNI's options, parsed when stored as JSON; null when there are none.
 */
function getRNIOptions(pRNI)
{
	let tmpOptions = pRNI && (pRNI.Options || pRNI.OptionsJSON);
	if (typeof tmpOptions === 'string')
	{
		try
		{
			tmpOptions = JSON.parse(tmpOptions);
		}
		catch (pError)
		{
			tmpOptions = null;
		}
	}
	return (tmpOptions && (typeof tmpOptions === 'object')) ? tmpOptions : null;
}

/**
 * The test hashes an RNI's options declare for its form: `TestHashes` for a multi-test form, else a `TestHash` that names
 * a real test (multi-test forms set `TestHash` to the form's own hash, which the caller filters out against the Test list).
 *
 * @param {Object} pRNI - a ReportNamedInstance row
 * @return {Array<String>}
 */
function getRNITestHashes(pRNI)
{
	const tmpOptions = getRNIOptions(pRNI);
	if (!tmpOptions)
	{
		return [];
	}
	const tmpHashes = Array.isArray(tmpOptions.TestHashes) ? tmpOptions.TestHashes : [ tmpOptions.TestHash ];
	return [ ...new Set(tmpHashes.filter((pHash) => (typeof pHash === 'string') && (pHash.length > 0))) ];
}

/**
 * Where a form's documents sit in a sample's story: the form that creates the sample, or the one that authorizes it.
 * Read from the RNI's role, never its name or hash: `Options.SampleCreation` (the role Fieldbook's create flow reads) or
 * a form built on the SampleCreation schema, and a form built on the SampleApproval schema (ManifestSchema 390).
 *
 * @param {Object} pRNI - a ReportNamedInstance row
 * @return {String} 'creation' | 'authorization' | ''
 */
function getRNIStoryRole(pRNI)
{
	const tmpOptions = getRNIOptions(pRNI);
	if (!tmpOptions)
	{
		return '';
	}
	if (tmpOptions.SampleCreation || (tmpOptions.FormManifestSchemaHash === 'SampleCreation'))
	{
		return 'creation';
	}
	if (tmpOptions.FormManifestSchemaHash === 'SampleApproval')
	{
		return 'authorization';
	}
	return '';
}

const STORY_RANK = { 'creation': 0, '': 1, 'authorization': 2 };

/**
 * A sample's documents in the order its story runs: the creation form first, the test forms and anything else next,
 * the authorization last; oldest first within each, then by ID. Documents whose form is not in the catalog yet sit in
 * the middle.
 *
 * @param {Array<{ IDDocument: number, DocumentType?: String, CreateDate?: String }>} pDocuments
 * @param {?FormTestCatalog} pCatalog
 * @return {Array<Object>} A new array; the input is left as it was.
 */
function orderDocumentStory(pDocuments, pCatalog)
{
	const tmpTypes = (pCatalog && pCatalog.Types) || {};
	const tmpRank = (pDocument) =>
	{
		const tmpType = tmpTypes[pDocument.DocumentType];
		return STORY_RANK[(tmpType && tmpType.StoryRole) || ''];
	};
	const tmpTime = (pDocument) =>
	{
		const tmpParsed = Date.parse(pDocument.CreateDate || '');
		return Number.isNaN(tmpParsed) ? Number.MAX_SAFE_INTEGER : tmpParsed;
	};
	return (Array.isArray(pDocuments) ? pDocuments : []).slice().sort((pA, pB) =>
		(tmpRank(pA) - tmpRank(pB)) || (tmpTime(pA) - tmpTime(pB)) || (Number(pA.IDDocument) - Number(pB.IDDocument)));
}

/**
 * A stored test result code as text and a colour tone, the same pass / fail grouping as the Tests tab's status chip.
 * Codes outside the shared result list (and N/A) show nothing.
 *
 * @param {String} pCode - TestInstance.TestResult, e.g. `PASC`
 * @return {{ Result: String, ResultTone: String }}
 */
function getTestResult(pCode)
{
	const tmpCode = String(pCode || '').trim().toUpperCase();
	const tmpKnown = libTestResultOptions.DEFAULT_TEST_RESULT_OPTIONS.some((pOption) => pOption.id === tmpCode);
	if (!tmpKnown || (tmpCode === 'N/A'))
	{
		return { Result: '', ResultTone: '' };
	}
	return { Result: libTestResultOptions.getTestResultLabel(tmpCode), ResultTone: RESULT_TONES[tmpCode] || 'info' };
}

/**
 * @typedef {Object} TestInstanceFormValues
 * @property {String} Result - The result to show: the one a linked form holds for approval, else the instance's own.
 * @property {?Object} ResultDocument - The unapproved document holding Result, or null when Result is the instance's own.
 * @property {String} Notes - The remarks to show, chosen the same way.
 * @property {?Object} NotesDocument - The unapproved document holding Notes, or null.
 */

/**
 * The values a document holds back for a test instance until it is approved: its `OnEnteringState.Approved` comprehension
 * (the one test forms use), else its `OnApprovalAction.Approve` one. The Sample Authorization form's Test Summary
 * (ManifestSchema `SampleApproval`) reads the same two places; keep them in step.
 *
 * @param {Object} pDocument
 * @param {String} pGUIDTestInstance
 * @return {Object} The held-back TestInstance fields, or {} when the document holds none.
 */
function getHeldTestInstanceValues(pDocument, pGUIDTestInstance)
{
	const tmpEntityData = (pDocument && pDocument.EntityData) || {};
	const fHeld = (pTrigger, pState) =>
	{
		const tmpTrigger = tmpEntityData[pTrigger] && tmpEntityData[pTrigger][pState];
		return (tmpTrigger && tmpTrigger.TestInstance && tmpTrigger.TestInstance[pGUIDTestInstance]) || null;
	};
	return fHeld('OnEnteringState', 'Approved') || fHeld('OnApprovalAction', 'Approve') || {};
}

/**
 * What the Tests tab shows for a test instance's result and remarks: while a linked document is not approved yet, the
 * values it will write on approval; otherwise the instance's own. The first unapproved document holding a value wins.
 *
 * @param {{ GUIDTestInstance?: String, Status?: String, TestResult?: String, Notes?: String }} pTestInstance
 * @param {Array<Object>} pDocuments - the documents linked to the instance
 * @return {TestInstanceFormValues}
 */
function getTestInstanceFormValues(pTestInstance, pDocuments)
{
	const tmpInstance = pTestInstance || {};
	const tmpValues = { Result: tmpInstance.Status || tmpInstance.TestResult || '', ResultDocument: null, Notes: tmpInstance.Notes || '', NotesDocument: null };
	if (!tmpInstance.GUIDTestInstance)
	{
		return tmpValues;
	}
	for (const tmpDocument of (Array.isArray(pDocuments) ? pDocuments : []))
	{
		if (!tmpDocument || isDocumentApproved(tmpDocument))
		{
			continue;
		}
		const tmpHeld = getHeldTestInstanceValues(tmpDocument, tmpInstance.GUIDTestInstance);
		if (!tmpValues.ResultDocument && tmpHeld.TestResult)
		{
			tmpValues.Result = String(tmpHeld.TestResult);
			tmpValues.ResultDocument = tmpDocument;
		}
		if (!tmpValues.NotesDocument && tmpHeld.Notes)
		{
			tmpValues.Notes = String(tmpHeld.Notes);
			tmpValues.NotesDocument = tmpDocument;
		}
	}
	return tmpValues;
}

/**
 * This sample's test instances joined to a document, by test hash, with the first recorded result for each.
 *
 * @param {number} pIDDocument
 * @param {{ TestInstances?: Array<Object>, TestMap?: Record<String, Object>, TestInstanceDocumentMap?: Record<String, Array<Object>> }} pBundle
 * @return {Array<{ Hash: String, ResultCode: String }>}
 */
function getAssignedTests(pIDDocument, pBundle)
{
	const tmpBundle = pBundle || {};
	const tmpDocumentMap = tmpBundle.TestInstanceDocumentMap || {};
	const tmpTestMap = tmpBundle.TestMap || {};
	const tmpAssigned = [];
	for (const tmpInstance of (tmpBundle.TestInstances || []))
	{
		const tmpDocuments = tmpDocumentMap[tmpInstance.IDTestInstance] || [];
		const tmpTest = tmpTestMap[tmpInstance.IDTest];
		if (!tmpTest || !tmpTest.Hash || !tmpDocuments.some((pDocument) => Number(pDocument.IDDocument) === Number(pIDDocument)))
		{
			continue;
		}
		const tmpExisting = tmpAssigned.find((pEntry) => pEntry.Hash === tmpTest.Hash);
		if (!tmpExisting)
		{
			tmpAssigned.push({ Hash: tmpTest.Hash, ResultCode: tmpInstance.TestResult || '' });
		}
		else if (!tmpExisting.ResultCode && tmpInstance.TestResult)
		{
			tmpExisting.ResultCode = tmpInstance.TestResult;
		}
	}
	return tmpAssigned;
}

/**
 * The tests to show for a document: those its form declares (that exist as tests), in the form's order, then any other
 * test this sample assigned to it.
 *
 * @param {{ IDDocument: number, DocumentType?: String }} pDocument
 * @param {?FormTestCatalog} pCatalog
 * @param {Object} pBundle - the sample's test instance bundle (see getAssignedTests)
 * @return {Array<DocumentTest>}
 */
function getDocumentTests(pDocument, pCatalog, pBundle)
{
	const tmpCatalog = pCatalog || { Types: {}, Tests: {} };
	const tmpType = tmpCatalog.Types[pDocument.DocumentType];
	const tmpAssignedTests = getAssignedTests(pDocument.IDDocument, pBundle);
	const tmpAssigned = tmpAssignedTests.map((pEntry) => pEntry.Hash);
	const tmpTestMap = (pBundle && pBundle.TestMap) || {};
	const tmpNameByHash = {};
	for (const tmpTest of Object.values(tmpTestMap))
	{
		tmpNameByHash[tmpTest.Hash] = tmpTest.Name;
	}
	const tmpDeclared = (tmpType ? tmpType.TestHashes : []).filter((pHash) => tmpCatalog.Tests[pHash] || (tmpAssigned.indexOf(pHash) > -1));
	const tmpHashes = tmpDeclared.concat(tmpAssigned.filter((pHash) => tmpDeclared.indexOf(pHash) < 0));
	return tmpHashes.map((pHash) =>
	{
		const tmpName = (tmpCatalog.Tests[pHash] && tmpCatalog.Tests[pHash].Name) || tmpNameByHash[pHash] || '';
		const tmpAssignedTest = tmpAssignedTests.find((pEntry) => pEntry.Hash === pHash);
		return Object.assign(
			{ Hash: pHash, Code: formatTestCode(pHash), Name: (tmpName && (tmpName !== pHash)) ? tmpName : '', Assigned: !!tmpAssignedTest },
			getTestResult(tmpAssignedTest ? tmpAssignedTest.ResultCode : ''));
	});
}

/**
 * @typedef {Object} TestBundle
 * @property {Array<Object>} TestInstances - The sample's test instances.
 * @property {Record<String, Object>} TestMap - IDTest -> Test.
 * @property {Record<String, Array<Object>>} TestInstanceDocumentMap - IDTestInstance -> the documents linked to it, each once.
 */

/**
 * @typedef {Object} TestSummaryDocument
 * @property {Object} Document - The linked document.
 * @property {String} Status - Document.Status, the form's approval status (`Draft`, `Submitted`, `Approved` ...).
 * @property {String} StatusTone - See getDocumentStatusTone.
 */

/**
 * @typedef {Object} TestSummaryRow
 * @property {Object} TestInstance
 * @property {?Object} Test - The test instance's Test, or null when it was not loaded.
 * @property {String} Name - The test's name, else the instance's, else `Test #<IDTestInstance>`.
 * @property {String} Result - See getTestInstanceFormValues.
 * @property {boolean} ResultPending - Result comes from a linked form that is not approved yet.
 * @property {?Object} ResultDocument - That form, or null.
 * @property {String} Notes - See getTestInstanceFormValues.
 * @property {boolean} NotesPending
 * @property {?Object} NotesDocument
 * @property {Array<TestSummaryDocument>} Documents - The documents linked to the instance, in bundle order.
 */

/**
 * Whether a document's held-back values have been written to the records they name. Test forms hold them under
 * `OnEnteringState.Approved`, so only `Approved` counts.
 *
 * @param {Object} pDocument
 * @return {boolean}
 */
function isDocumentApproved(pDocument)
{
	return !!pDocument && (pDocument.Status === 'Approved');
}

/**
 * A document status as a colour tone: approved and authorized forms are `success`, rejected ones `danger`, the rest
 * `info`; no status is ''.
 *
 * @param {String} pStatus - Document.Status
 * @return {String} 'success' | 'danger' | 'info' | ''
 */
function getDocumentStatusTone(pStatus)
{
	if (!pStatus)
	{
		return '';
	}
	if ((pStatus === 'Approved') || (pStatus === 'Authorized'))
	{
		return 'success';
	}
	if (pStatus === 'Rejected')
	{
		return 'danger';
	}
	return 'info';
}

/**
 * Assemble a sample's test bundle from the loaded records. A document is linked to a test instance by a
 * `DocumentPolyJoin` (RemoteType `TestInstance`), or, for a document joined to the sample, by naming the instance's
 * GUID in its `EntityData.TestInstance` list (`{IDDocument}` in the GUID stands for the document's own ID); some
 * customers' forms only link that way.
 *
 * @param {Object} pRecords
 * @param {Array<Object>} [pRecords.TestInstances]
 * @param {Array<Object>} [pRecords.Tests]
 * @param {Array<{ IDRemote: number, IDDocument: number }>} [pRecords.TestInstanceDocumentJoins] - DocumentPolyJoins to the test instances
 * @param {Array<{ IDDocument: number }>} [pRecords.SampleDocumentJoins] - DocumentPolyJoins to the sample
 * @param {Array<Object>} [pRecords.Documents] - every document either join names
 * @return {TestBundle}
 */
function buildTestBundle(pRecords)
{
	const tmpRecords = pRecords || {};
	const tmpTestInstances = Array.isArray(tmpRecords.TestInstances) ? tmpRecords.TestInstances : [];
	const tmpTestMap = {};
	for (const tmpTest of (tmpRecords.Tests || []))
	{
		tmpTestMap[tmpTest.IDTest] = tmpTest;
	}
	const tmpDocumentByID = {};
	for (const tmpDocument of (tmpRecords.Documents || []))
	{
		tmpDocumentByID[tmpDocument.IDDocument] = tmpDocument;
	}
	/** @type {Record<String, Array<Object>>} */
	const tmpDocumentMap = {};
	const tmpIDByGUID = {};
	for (const tmpInstance of tmpTestInstances)
	{
		tmpDocumentMap[tmpInstance.IDTestInstance] = [];
		if (typeof tmpInstance.GUIDTestInstance === 'string')
		{
			tmpIDByGUID[tmpInstance.GUIDTestInstance] = tmpInstance.IDTestInstance;
		}
	}
	const fLink = (pIDTestInstance, pDocument) =>
	{
		const tmpLinked = tmpDocumentMap[pIDTestInstance];
		if (pDocument && tmpLinked && (tmpLinked.indexOf(pDocument) < 0))
		{
			tmpLinked.push(pDocument);
		}
	};
	for (const tmpJoin of (tmpRecords.TestInstanceDocumentJoins || []))
	{
		fLink(tmpJoin.IDRemote, tmpDocumentByID[tmpJoin.IDDocument]);
	}
	for (const tmpJoin of (tmpRecords.SampleDocumentJoins || []))
	{
		const tmpDocument = tmpDocumentByID[tmpJoin.IDDocument];
		const tmpNamed = tmpDocument && tmpDocument.EntityData && tmpDocument.EntityData.TestInstance;
		if (!Array.isArray(tmpNamed))
		{
			continue;
		}
		for (const tmpEntry of tmpNamed)
		{
			if (!tmpEntry || (typeof tmpEntry.GUIDTestInstance !== 'string'))
			{
				continue;
			}
			const tmpGUID = tmpEntry.GUIDTestInstance.replace('{IDDocument}', String(tmpDocument.IDDocument));
			if (tmpIDByGUID.hasOwnProperty(tmpGUID))
			{
				fLink(tmpIDByGUID[tmpGUID], tmpDocument);
			}
		}
	}
	return { TestInstances: tmpTestInstances, TestMap: tmpTestMap, TestInstanceDocumentMap: tmpDocumentMap };
}

/**
 * One row per test instance with what a screen listing a sample's tests shows: the result and remarks (a linked
 * form's pending values first, see getTestInstanceFormValues) and each linked document's form status.
 *
 * @param {TestBundle} pBundle
 * @return {Array<TestSummaryRow>}
 */
function buildTestSummary(pBundle)
{
	/** @type {Partial<TestBundle>} */
	const tmpBundle = pBundle || {};
	const tmpTestMap = tmpBundle.TestMap || {};
	const tmpDocumentMap = tmpBundle.TestInstanceDocumentMap || {};
	return (tmpBundle.TestInstances || []).map((pInstance) =>
	{
		const tmpTest = tmpTestMap[pInstance.IDTest] || null;
		const tmpDocuments = tmpDocumentMap[pInstance.IDTestInstance] || [];
		const tmpValues = getTestInstanceFormValues(pInstance, tmpDocuments);
		return {
			TestInstance: pInstance,
			Test: tmpTest,
			Name: (tmpTest && tmpTest.Name) || pInstance.Name || `Test #${pInstance.IDTestInstance}`,
			Result: tmpValues.Result,
			ResultPending: !!tmpValues.ResultDocument,
			ResultDocument: tmpValues.ResultDocument,
			Notes: tmpValues.Notes,
			NotesPending: !!tmpValues.NotesDocument,
			NotesDocument: tmpValues.NotesDocument,
			Documents: tmpDocuments.map((pDocument) => ({ Document: pDocument, Status: pDocument.Status || '', StatusTone: getDocumentStatusTone(pDocument.Status) })),
		};
	});
}

module.exports =
{
	formatTestCode,
	getRNIOptions,
	getRNITestHashes,
	getRNIStoryRole,
	orderDocumentStory,
	getTestResult,
	getHeldTestInstanceValues,
	getTestInstanceFormValues,
	isDocumentApproved,
	getDocumentStatusTone,
	getAssignedTests,
	getDocumentTests,
	buildTestBundle,
	buildTestSummary,
};

},{"headlight-dynamic-inputs-bundle/source/providers/_TestResultOptions.js":168}],24:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Headlight Stationing fable service
 */
class HeadlightStationing extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance
	 * @param {any} [pOptions] - The options for the service
	 * @param {any} [pServiceHash] - The hash for the service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadLightStationing';
	}

	/**
	 * convert a "station" value to a number
	 * EX: "125+00" to "12500"
	 * @param {string|number} pValue
	 * @return {number} the numeric value of the station and offset
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue = '125+00';
	 * const tmpNumberValue = tmpHeadlightStationing.fromStationValue(tmpValue);
	 * // tmpNumberValue = 12500
	*/
	fromStationValue(pValue)
	{
		// we expect a string here regardless of what's passed
		const tmpValue = typeof (pValue) === 'undefined' ? '' : pValue.toString();

		// if they included the plus sign manually, or it's an updated 'pValue'
		if (tmpValue.indexOf('+') !== -1)
		{
			// honor the first +, ignore any subsequent ones, strip spaces, then do our best
			const tmpDescendingValues = tmpValue.split(/\s*\+\s*/);

			let tmpComputed = 0;
			for (let i = 0; i < tmpDescendingValues.length; i++)
			{
				tmpComputed += Math.pow(100, 1 - i) * (parseFloat(tmpDescendingValues[i]) || 0);
			}
			return tmpComputed;
		}

		const tmpDecimalIndex = tmpValue.indexOf('.');
		if (tmpDecimalIndex === -1 && tmpValue.trim().length < 3)
		{
			return parseFloat(tmpValue) * 100; // two digits or fewer is treated as a station value (I hate this)
		}
		return parseFloat(tmpValue);
	}

	/**
	 * Normalize a value that may be EITHER a station-formatted string ("0+50")
	 * OR an already-numeric station offset (50) into a numeric offset in feet.
	 *
	 * Unlike fromStationValue(), this does NOT apply the "a bare two-digit number
	 * means N+00" (x100) heuristic. A value without a '+' is treated as a literal
	 * offset, so an offset of 50 stays 50 (it does not become 5000 / "50+00").
	 *
	 * This is what consumers need when the value has already been reduced to a
	 * numeric offset (e.g. the Station input provider stores the numeric offset
	 * as its bound value), while still tolerating legacy rows that persisted the
	 * station-formatted string.
	 *
	 * @param {string|number} pValue
	 * @return {number} the numeric station offset, or NaN if unparseable
	 * @memberof HeadlightStationing
	 * @example
	 * tmpHeadlightStationing.normalizeStationOffset(50);      // 50
	 * tmpHeadlightStationing.normalizeStationOffset('0+50');  // 50
	 * tmpHeadlightStationing.normalizeStationOffset('1+50');  // 150
	*/
	normalizeStationOffset(pValue)
	{
		if (typeof pValue === 'number')
		{
			return pValue;
		}
		const tmpValue = (typeof pValue === 'undefined' || pValue === null) ? '' : pValue.toString();
		// A '+' means it's a station-formatted string ("0+50"); parse it the normal way.
		if (tmpValue.indexOf('+') !== -1)
		{
			return this.fromStationValue(tmpValue);
		}
		// Otherwise it is already a literal numeric offset in feet - do not scale it.
		return parseFloat(tmpValue);
	}

	/**
	 * convert a number string to a "station" value
	 * EX: "12500" to "125+00"
	 * @param {any} pValue - the numeric offset
	 * @return {string} the converted station and offset
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue = 12500;
	 * const tmpStationValue = tmpHeadlightStationing.toStationValue(tmpValue);
	 * // tmpStationValue = '125+00'
	*/
	toStationValue(pValue)
	{
		/** @type {number|string} */
		let tmpValue;
		switch (typeof pValue)
		{
			case 'string':
				tmpValue = pValue.includes('+') ? this.fromStationValue(pValue) : parseFloat(pValue);
				break;
			case 'number':
				tmpValue = pValue;
				break;
			default:
				tmpValue = String(pValue);
		}
		let returnValue = '';

		// if they pass a non-parseable value, return it as is early
		if (isNaN(Number(tmpValue)))
		{
			console.error('Invalid station value: ' + pValue);
			return pValue;
		}
		tmpValue = tmpValue.toString();

		// we have to account for decimals too
		const [ whole, fractional ] = tmpValue.split('.');

		// insert the '+' before the last two digits before the decimal
		if (whole.length === 2)
		{
			returnValue = '0+' + whole;
		}
		else if (whole.length === 1)
		{
			returnValue = '0+0' + whole;
		}
		else if (whole.length)
		{
			returnValue = whole.slice(0, whole.length - 2) + '+' + whole.slice(whole.length - 2);
		}
		else
		{
			this.fable.log.error('Invalid station value: ' + pValue);
			// return the original value, ignore the decimal and formatting
			return pValue;
		}
		// if there's a decimal, add it
		if (fractional)
		{
			returnValue += '.' + fractional;
		}

		return returnValue;
	}

	/**
	 * add two station values together
	 *
	 * @param {string|number} pValue1
	 * @param {string|number} pValue2
	 *
	 * @return {string} the sum of the two station values, formatted as a station value
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = '125+00';
	 * const tmpNumberValue = tmpHeadlightStationing.addStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = '250+00'
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = 'potato';
	 * const tmpNumberValue = tmpHeadlightStationing.addStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = 'NaN'
	*/
	addStationValues(pValue1, pValue2)
	{
		return this.toStationValue(this.fromStationValue(pValue1) + this.fromStationValue(pValue2));
	}

	/**
	 * subtract two station values
	 *
	 * @param {string|number} pValue1
	 * @param {string|number} pValue2
	 *
	 * @return {string} the difference of the two station values, formatted as a station value
	 * @memberof HeadlightStationing
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = '125+00';
	 * const tmpNumberValue = tmpHeadlightStationing.subtractStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = '0+00'
	 * @example
	 * const tmpValue1 = '125+00';
	 * const tmpValue2 = 'potato';
	 * const tmpNumberValue = tmpHeadlightStationing.subtractStationValues(tmpValue1, tmpValue2);
	 * // tmpNumberValue = 'NaN'
	*/
	subtractStationValues(pValue1, pValue2)
	{
		return this.toStationValue(this.fromStationValue(pValue1) - this.fromStationValue(pValue2));
	}
}

module.exports = HeadlightStationing;

},{"fable-serviceproviderbase":438}],25:[function(require,module,exports){

const FableServiceProviderBase = require('fable-serviceproviderbase');
const JsonDiff = require('json-diff');
const Fs = require('fs');
const Path = require('path');
const IntegrationAdapter = require('headlight-integration-adapter');

/**
 * Headlight Manifest Packaging fable service
 *
 * WARNING: This is a work in progress.
 */
class ManifestPackagingService extends FableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The fable instance
	 * @param {any} [pOptions] - The options for the service
	 * @param {any} [pServiceHash] - The hash for the service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & {
		 *    HeadlightRestClient: import('headlight-rest-client')
		 * 	  PictApplication: any
		 * 	  newManyfest: any
		 * 	  providers: any
		 *    servicesMap: {
		 *      IntegrationAdapter: { [hash: string]: IntegrationAdapter? },
		 *    },
		 *  }} */
		this.fable;
		this.serviceType = 'HeadlightPackaging';

		if (!('HeadlightRestClient' in this.fable.services))
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				//TODO: should this be /1.0/ only? is there a web usecase? branching on that?
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', this.options);
		}

		this.comprehension = {};
		this.manifestCache = {};
		this.cacheInitialized = false;
	}

	/**
	 * Fetch data from a URI
	 *
	 * @param {string} uri - the URI to fetch
	 * @return {Promise<any>} the fetched data
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.fable.HeadlightRestClient.getJSON(uri, (error, data) =>
			{
				if (error)
				{
					return reject(error);
				}
				resolve(data);
			});
		});
	}

	/**
	 * Fetch an entity set with filtering
	 *
	 * @param {string} entity - the entity to fetch
	 * @param {string} filter - the filter to apply to the entity request
	 * @return {Promise<any>} the fetched data
	 */
	async _getEntitySetAsync(entity, filter)
	{
		return await new Promise((resolve, reject) => 
		{
			// @ts-ignore
			this.fable.EntityProvider.getEntitySet(entity, filter, (error, result) => 
			{
				if (error)
				{
					return reject(error);
				}
				resolve (result);
			}, null, { NoCount: true });
		});
	}

	/**
	 * Fetch the form manifest, if configured.
	 *
	 * NOTE: Mirrors the logic in report_definitions/global/server_js/mixins/document.pre-render-mixins.js#LoadFormManifest
	 *
	 * @param {any} pRNI - the ReportNamedInstance
	 * @param {(uri: string) => Promise<any>} [getImpl] - alternate implementation of HTTP get
	 *
	 * @return {Promise<any>} the form manifest object, or null
	 */
	async _loadFormManifest(pRNI, getImpl)
	{
		const get = getImpl || this._get.bind(this);
		const reportOptions = pRNI.Options;
		if (typeof reportOptions.FormDefinition === 'object')
		{
			return reportOptions.FormDefinition;
		}
		try
		{
			// Resolve the root ManifestSchema record. New ingestion tooling
			// (BLT / bridge-push) sets Options.FormManifestSchemaHash instead
			// of FormManifestSchemaID — accept both.
			let rootManifest = null;
			if (reportOptions.FormManifestSchemaID > 0)
			{
				rootManifest = await get(`ManifestSchema/${reportOptions.FormManifestSchemaID}`);
			}
			else if (reportOptions.FormManifestSchemaHash)
			{
				// Hash is NOT unique across customers, so prefer the schema
				// whose IDCustomer matches the RNI's IDCustomer.
				const tmpSchemas = await get(`ManifestSchemas/FilteredTo/FBV~Hash~EQ~${encodeURIComponent(reportOptions.FormManifestSchemaHash)}`);
				if (Array.isArray(tmpSchemas) && tmpSchemas.length > 0)
				{
					rootManifest = tmpSchemas.find((pSchema) => pSchema.IDCustomer == pRNI.IDCustomer) || tmpSchemas[0];
				}
				else
				{
					this.fable.log.warn(`No ManifestSchema found for hash ${reportOptions.FormManifestSchemaHash} (RNI ${pRNI.Hash || pRNI.IDReportNamedInstance}).`);
				}
			}

			if (!rootManifest)
			{
				return null;
			}

			// Fetch and merge partials using the resolved schema's ID.
			const manifestPartialJoins = await get(`ManifestSchemaManifestSchemaPartialJoins/FilteredTo/FBV~IDManifestSchema~EQ~${rootManifest.IDManifestSchema}`);
			let manifestPartials = [];
			if (manifestPartialJoins.length > 0)
			{
				const manifestSchemaPartialToOrdinal = {};
				for (const join of manifestPartialJoins)
				{
					manifestSchemaPartialToOrdinal[join.IDManifestSchemaPartial] = join.Ordinal;
				}
				manifestPartials = await get(`ManifestSchemaPartials/FilteredTo/FBL~IDManifestSchemaPartial~INN~${manifestPartialJoins.map(j => j.IDManifestSchemaPartial).join(',')}`);
				manifestPartials.sort((a, b) =>
				{
					return (manifestSchemaPartialToOrdinal[a.IDManifestSchemaPartial] ?? 0) - (manifestSchemaPartialToOrdinal[b.IDManifestSchemaPartial] ?? 0);
				});
			}
			return this._mergeManifests(rootManifest, manifestPartials);
		}
		catch (error)
		{
			this.fable.log.error(`Error loading form manifest: ${error}`);
		}
		return null;
	}

	/**
	 * @param {Record<string, any>} pTargetManifest - The target manifest to merge into.
	 * @param {Record<string, any>} pSourceManifest - The source manifest to merge from.
	 *
	 * @return {Record<string, any>} the merged manifest
	 */
	_simpleManifestMerge(pTargetManifest, pSourceManifest)
	{
		if (!pTargetManifest.Descriptors)
		{
			pTargetManifest.Descriptors = {};
		}
		if (!Array.isArray(pTargetManifest.Sections))
		{
			pTargetManifest.Sections = [];
		}
		if (!pTargetManifest.ReferenceManifests)
		{
			pTargetManifest.ReferenceManifests = {};
		}
		for (const [ descriptorKey, descriptor ] of Object.entries(pSourceManifest?.Descriptors || {}))
		{
			if (!pTargetManifest.Descriptors[descriptorKey])
			{
				pTargetManifest.Descriptors[descriptorKey] = descriptor;
			}
			else
			{
				//TODO: do we need to merge descriptors that repeat?
			}
		}
		for (const section of pSourceManifest?.Sections || [])
		{
			if (!pTargetManifest.Sections.find(s => s.Hash === section.Hash))
			{
				pTargetManifest.Sections.push(section);
			}
			else
			{
				//TODO: do we need to merge sections that repeat?
			}
		}
		for (const [ referenceKey, reference ] of Object.entries(pSourceManifest?.ReferenceManifests || {}))
		{
			if (!pTargetManifest.ReferenceManifests[referenceKey])
			{
				pTargetManifest.ReferenceManifests[referenceKey] = reference;
			}
			else
			{
				//TODO: do we need to merge references that repeat?
			}
		}
		return pTargetManifest;
	}

	/**
	 * @param {any} rootManifest - The root ManifestSchema Database Record to merge into.
	 * @param {any[]} manifestPartials - The ManifestSchemaPartial Database Records to merge.
	 * @return {any} the merged schema
	 */
	_mergeManifests(rootManifest, manifestPartials)
	{
		const manifest = rootManifest.Manifest || {};
		manifest.Source = { ManifestSchemaID: rootManifest.IDManifestSchema };
		if (!manifest.Descriptors)
		{
			manifest.Descriptors = {};
		}
		if (!Array.isArray(manifest.Sections))
		{
			manifest.Sections = [];
		}
		if (!manifest.ReferenceManifests)
		{
			manifest.ReferenceManifests = {};
		}
		for (const partial of manifestPartials)
		{
			this._simpleManifestMerge(manifest, partial.ManifestPartial);
		}
		const manifestDefinition =
		{
			Product: 'HeadlightDynamicForm', //TODO: does this matter? does it do anything?
			DefaultFormManifest: manifest,
		};
		return manifestDefinition;
	}

	foundDashboard(recordset, hash)
	{
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		for (let recordSet of recordSets)
		{
			const r = recordSet.RecordSet;
			if (r == recordset && recordSet.RecordSetDashboardManifests?.includes?.(hash))
			{
				return true;
			}
		}
		return false;
	}

	async dynamicDashboardLoad(recordset, hash)
	{
		if (this.foundDashboard(recordset, hash))
		{
			return true;
		}
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		for (let x = 0; x < recordSets.length; x++)
		{
			let recordSet = recordSets[x];
			const r = recordSet.RecordSet;
			if (r == recordset)
			{
				let activeRecordsetConfig = this.fable.services.PictSectionRecordSet.recordSetProviderConfigurations[r];
				activeRecordsetConfig[`RecordSetFilterURLTemplate-Dashboard-${ hash }`] = `/PSRS/{~D:Record.RecordSet~}/SpecificDashboard/${ hash }/FilteredTo/{~D:Record.FilterString~}`;
				activeRecordsetConfig.RecordSetDashboardManifests = recordSet.RecordSetDashboardManifests ? [hash] : recordSet.RecordSetDashboardManifests.concat([hash]);
			}
		}
		return await this.loadRecordSetSchemasForProduct(null, ['Dashboard'], recordset);
	}

	async getAvailableSpecificDashboards(recordset)
	{
		const manifests = await this._getManifestSchemas(`${ recordset }-Dashboard-`, true);
		const hashes = [];
		for (let m of manifests)
		{
			if (m.Manifest?.Scope && !hashes.includes(m.Manifest.Scope))
			{
				hashes.push(m.Manifest.Scope);
			}
		}
		return hashes;
	}

	constructDashboardNav()
	{
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		const navObj = 
		{
			topNav: '',
			sideNav: []
		};
		for (let recordSet of recordSets)
		{
			const r = recordSet.RecordSet;
			const manifestHashes = recordSet.RecordSetDashboardManifests;
			for (let m of manifestHashes)
			{
				const manifest = this.fable.services.PictSectionRecordSet.manifestDefinitions[m];
				if (!manifest || [`${ r }-List`, `${ r }-Dashboard`].includes(m))
				{
					continue;
				}
				navObj.topNav += /*html*/ `
				<a class="navbar-item" onclick="toggleNavBarHamburgerMenu()" href="#/PSRS/${ r }/SpecificDashboard/${ m }">
					<span class="icon">
						<i class="fas ${ manifest.Icon || 'fa-rectangle-list' }"></i>
					</span>
					<span class="icon-text">${ manifest.TitleTemplate || manifest.Scope || m }</span>
				</a>`;
				navObj.sideNav.push( 
				{
					Hash: m,
					Name: manifest.TitleTemplate || manifest.Scope || m,
					Icon: `fas ${ manifest.Icon || 'fa-rectangle-list' }`,
					Address: `#/PSRS/${ r }/SpecificDashboard/${ m }`,
					PanelSource: null,
				});
			}
		}
		return navObj;
	}

	/**
	 * Loads and overrides all manifest schemas for all recordsets (for a particular product/app).
	 * @param {string} [product] - limits the schema load by product
	 * @param {Array<String>} [actions] - limits the schema load to only specific actions
	 * @param {string} [limitingRecordSet] - limits the schema load to only a single recordset
	 */
	async loadRecordSetSchemasForProduct(product, actions = ['List', 'Dashboard', 'Create', 'View', 'Edit', 'Filter'], limitingRecordSet)
	{
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const recordSets = this.fable?.PictApplication?.options?.pict_configuration?.DefaultRecordSetConfigurations || [];
		const manifestPromises = [];
		for (let x = 0; x < recordSets.length; x++)
		{
			let recordSet = recordSets[x];
			const r = recordSet.RecordSet;
			let activeRecordsetConfig = this.fable.services.PictSectionRecordSet.recordSetProviderConfigurations[r];
			if (limitingRecordSet && limitingRecordSet !== r)
			{
				continue;
			}
			try
			{
				const dynamicDashboardHashes = await this.getAvailableSpecificDashboards(r);
				activeRecordsetConfig.RecordSetDashboardManifests = recordSet.RecordSetDashboardManifests || [];
				for (let d of dynamicDashboardHashes)
				{
					if (!recordSet.RecordSetDashboardManifests.includes(d))
					{
						activeRecordsetConfig.RecordSetDashboardManifests.push(d);
						activeRecordsetConfig[`RecordSetFilterURLTemplate-Dashboard-${ d }`] = `/PSRS/{~D:Record.RecordSet~}/SpecificDashboard/${ d }/FilteredTo/{~D:Record.FilterString~}`;
					}
				}
				const dashboardManifestSet = [...(recordSet.RecordSetDashboardManifests || [])];
				const dashboardManifestFetch = async (d) => 
				{
					let tempManifest = await this.loadRecordManifestSchema(r, 'Dashboard', product, d);
					if (!tempManifest)
					{
						tempManifest = this.fable.PictApplication.options.pict_configuration.Manifests[d];
					}
					if (!tempManifest.Form)
					{
						this.fable.services.PictSectionRecordSet.generateManifestTableCells(tempManifest);
					}
					this.fable.services.PictSectionRecordSet.manifestDefinitions[d] = tempManifest;
					this.fable.services.PictSectionRecordSet.manifests[d] = tempManifest.Form ? tempManifest : this.fable.newManyfest(tempManifest);
				};				
				for (let d of dashboardManifestSet)
				{
					if ([`${ r }-List`, `${ r }-Dashboard`].includes(d))
					{
						continue;
					}
					manifestPromises.push(dashboardManifestFetch(d));
				}
				const actionManifestFetch = async (a) => 
				{
					let tempManifest = await this.loadRecordManifestSchema(r, a, product);
					if (!tempManifest)
					{
						tempManifest = this.fable.PictApplication.options.pict_configuration.Manifests[`${ r }-${ a }`];
					}
					if (['Dashboard', 'List'].includes(a))
					{
						this.fable.services.PictSectionRecordSet.generateManifestTableCells(tempManifest);
					}
					this.fable.services.PictSectionRecordSet.manifestDefinitions[`${ r }-${ a }`] = tempManifest;
					this.fable.services.PictSectionRecordSet.manifests[`${ r }-${ a }`] = !['Dashboard', 'List'].includes(a) ? tempManifest : this.fable.newManyfest(tempManifest);
					if (a == 'Filter' && this.fable?.providers?.[`RSP-Provider-${ r }`]?._FilterSchema && tempManifest)
					{
						this.fable.providers[`RSP-Provider-${ r }`]._FilterSchema = tempManifest.ReplaceBaseFilters ? tempManifest.Descriptors : Object.assign(this.fable.providers[`RSP-Provider-${ r }`]._FilterSchema, tempManifest.Descriptors);
					}
				};
				for (let a of actions)
				{
					manifestPromises.push(actionManifestFetch(a));
				}
			}
			catch (e)
			{
				this.fable.log.error('Failed to get manifest for record set.', e);
			}
		}
		await Promise.all(manifestPromises);
	}

	async loadQuickSummaryManifests(entities, defaults, product)
	{
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const manifestPromises = [];
		const manifestConfig = defaults || {};
		for (const entity of entities)
		{
			try
			{
				const summaryManifestFetch = async () => 
				{
					const tempManifest = await this.loadRecordManifestSchema(entity, 'Summary', product);
					if (tempManifest)
					{
						manifestConfig[entity] = tempManifest;
					}
					return tempManifest;
				};
				manifestPromises.push(summaryManifestFetch());
			}
			catch (e)
			{
				this.fable.log.error('Failed to get manifest for entity.', e);
			}
		}
		await Promise.all(manifestPromises);
		this.fable.services.HeadlightQuickSummaries.applyTypeConfig(manifestConfig);
	}

	async loadPrintableManifests(entities, defaults, product)
	{
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const manifestPromises = [];
		const manifestConfig = defaults || {};
		for (const entity of entities)
		{
			try
			{
				const summaryManifestFetch = async () => 
				{
					const tempManifest = await this.loadRecordManifestSchema(entity, 'Printable', product);
					if (tempManifest)
					{
						manifestConfig[entity] = tempManifest;
					}
					return tempManifest;
				};
				manifestPromises.push(summaryManifestFetch());
			}
			catch (e)
			{
				this.fable.log.error('Failed to get manifest for entity.', e);
			}
		}
		await Promise.all(manifestPromises);
		this.fable.providers.QRCodeProvider.applyTypeConfig(manifestConfig);
	}

	/**
	 * Loads a record manifest schema for a particular action type.
	 * @param {string} recordset - The recordset we are fetching a "RecordManifest" for.
	 * @param {string} verb - The verb/"action" this is for (options include Create/View/Edit/List/Dashboard).
	 * @param {string} [product] - The product we are fetching this manifest for.
	 * @param {string} [specifier] - A further specifier beyond the verb. Main purpose is for multiple types of Dashboard.
	 * @returns {Promise<null|Object>} - returns null or the schema loaded from the DB.
	 */
	async loadRecordManifestSchema(recordset, verb, product, specifier)
	{
		if (!recordset || !verb)
		{
			return null;
		}
		let rootManifest = (await this._getManifestSchemas(`${ product ? `${ product }-` : '' }${ recordset }-${ verb }${ specifier ? `-${ specifier }` : '' }`))?.[0];
		if (!rootManifest)
		{
			if (specifier)
			{
				return await this.loadRecordManifestSchema(recordset, verb, product);
			}
			if (product)
			{
				return await this.loadRecordManifestSchema(recordset, verb, null, specifier);
			}
			if (verb === 'Edit')
			{
				return await this.loadRecordManifestSchema(recordset, 'View');
			}
			return null;
		}
		const manifestSchemaPartialJoins = await this._getManifestSchemaPartialJoins(rootManifest.IDManifestSchema);
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			(await this._getManifestSchemaPartials(manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial))) : [];
		const manifest = this._mergeManifests(rootManifest, manifestPartials);
		return manifest?.DefaultFormManifest;
	}

	async primeManifestCache(product, entities)
	{
		if (this.cacheInitialized)
		{
			return;
		}
		product = product || this.fable?.PictApplication?.options?.pict_configuration?.Product;
		const tempCache = {
			ManifestSchema: {},
			ManifestSchemaPartialJoin: {},
			ManifestSchemaPartial: {}
		};
		let schemaArr = [];
		// If a set of entities is passed, limit the set of customer level entities to cache for.
		if (entities)
		{
			const filters = ['FBV~Type~EQ~RecordManifest'];
			// Get all for the product
			if (product)
			{
				filters.push(`FBV~Type~EQ~RecordManifest~FBV~SubType~LK~${ product }-%25`);
			}
			// Get any customer level ones limited by entity.
			for (let e of entities)
			{
				filters.push(`FBVOR~Type~EQ~RecordManifest~FBV~SubType~LK~${ e }-%25`);
			}
			schemaArr = await this._getEntitySetAsync('ManifestSchema', filters.join('~'));
		}
		else
		{
			schemaArr = await this._getEntitySetAsync('ManifestSchema', 'FBV~Type~EQ~RecordManifest');
		}

		for (let s of schemaArr)
		{
			tempCache.ManifestSchema[s.SubType] = s;
		}
		const manifestSchemaPartialJoins = await this._getEntitySetAsync('ManifestSchemaManifestSchemaPartialJoin', `FBL~IDManifestSchema~INN~${ schemaArr.map(s => s.IDManifestSchema).join(',') }`);
		for (let mspj of manifestSchemaPartialJoins)
		{
			tempCache.ManifestSchemaPartialJoin[mspj.IDManifestSchema] = tempCache.ManifestSchemaPartialJoin[mspj.IDManifestSchema] || [];
			tempCache.ManifestSchemaPartialJoin[mspj.IDManifestSchema].push(mspj);
		}
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			(await this._getEntitySetAsync('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${ manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial).join(',') }`)) : [];
		for (let msp of manifestPartials)
		{
			tempCache.ManifestSchemaPartial[msp.IDManifestSchemaPartial] = msp;
		}
		this.manifestCache = tempCache
		this.cacheInitialized = true;
	}

	async _getManifestSchemas(subType, partialMatch)
	{
		if (!this.cacheInitialized)
		{
			return await this._getEntitySetAsync('ManifestSchema', `FBV~Type~EQ~RecordManifest~${partialMatch ? `FBV~SubType~LK~%25${ subType }%25` : `FBV~SubType~EQ~${ subType }` }`);
		}
		if (partialMatch)
		{
			const output = [];
			for (let m of Object.keys(this.manifestCache.ManifestSchema))
			{
				if (m.includes(subType))
				{
					output.push(this.manifestCache.ManifestSchema[m]);
				}
			}
			return output;
		}
		return this.manifestCache.ManifestSchema[subType] ? [this.manifestCache.ManifestSchema[subType]] : [];
	}

	async _getManifestSchemaPartials(IDManifestSchemaPartials)
	{
		if (!this.cacheInitialized)
		{
			return await this._getEntitySetAsync('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${ IDManifestSchemaPartials.join(',') }`);
		}
		let output = [];
		for (let id of IDManifestSchemaPartials)
		{
			if (this.manifestCache.ManifestSchemaPartial[id])
			{
				output.push(this.manifestCache.ManifestSchemaPartial[id]);
			}
		}
		return output;
	}

	async _getManifestSchemaPartialJoins(IDManifestSchema)
	{
		if (!this.cacheInitialized)
		{
			return await this._getEntitySetAsync('ManifestSchemaManifestSchemaPartialJoin', `FBV~IDManifestSchema~EQ~${ IDManifestSchema }`);
		}
		if (this.manifestCache.ManifestSchemaPartialJoin[IDManifestSchema])
		{
			return this.manifestCache.ManifestSchemaPartialJoin[IDManifestSchema];
		}
		return [];
	}

	async validate()
	{
		const rnis = await this._get(`ReportNamedInstancesByProject/9898/0/250`);
		for (const rni of rnis)
		{
			const fullManifest = rni.Options.FormDefinition;
			if (!fullManifest)
			{
				continue;
			}
			const newPipelineManifest = await this._loadFormManifest(rni);
			const baseSchema = await this._get(`ManifestSchemas/By/Hash/${rni.Hash.toLocaleLowerCase()}`).then((schemas) => schemas[0]);
			if (!baseSchema)
			{
				this.fable.log.info(`ERROR: No base schema for ${rni.Hash}`);
				continue;
			}
			delete rni.Options.FormDefinition;
			rni.Options.FormManifestSchemaID = baseSchema.IDManifestSchema;
			const newPipelineMergedManifest = await this._loadFormManifest(rni, (uri) => this._get(uri));
			const diff = JsonDiff.diffString(newPipelineManifest, newPipelineMergedManifest);
			this.fable.log.info(`Diff for ${rni.Hash}: ${diff}`);
			/*
			const newManifestString = JSON.stringify(newPipelineManifest, null, 2);
			const newMergedManifestString = JSON.stringify(newPipelineMergedManifest, null, 2);
			const fullManifestString = JSON.stringify(fullManifest, null, 2);
			if (newManifestString !== fullManifestString)
			{
				this.fable.log.info(`Mismatch for ${rni.Hash}`);
				this.fable.log.info(`New: ${newManifestString}`);
				this.fable.log.info(`Old: ${fullManifestString}`);
			}
			if (newManifestString !== newMergedManifestString)
			{
				this.fable.log.info(`Mismatch for ${rni.Hash}`);
				this.fable.log.info(`New: ${newManifestString}`);
				this.fable.log.info(`Merged: ${newMergedManifestString}`);
			}
			*/
		}
	}

	/**
	 * @param {string} form - the form name
	 * @param {string} descriptorKey - the descriptor key
	 * @param {any} descriptor - the descriptor object
	 * @param {string} [context] - the context - ie. which manifest or sub-manifest this descriptor is from
	 */
	sanityCheckDescriptor(form, descriptorKey, descriptor, context = 'Root Manifest')
	{
		let result = false;
		if (descriptorKey.includes(' ') || descriptorKey.includes('\t'))
		{
			this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has spaces in key.`);
			result = true;
		}

		if (!descriptor.Hash || typeof descriptor.Hash !== 'string')
		{
			this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has no Hash.`, { descriptor });
			result = true;
		}
		else if (descriptor.Hash.includes('.') || descriptor.Hash.includes(' '))
		{
			this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has Hash with illegal character.`, { descriptor });
			result = true;
		}

		if (Array.isArray(descriptor.PictForm?.SelectOptions))
		{
			const options = descriptor.PictForm.SelectOptions;
			const optionCount = options.length;
			const uniqueOptions = new Set(options.map((o) => o.id));
			if (uniqueOptions.size !== optionCount)
			{
				this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has duplicate SelectOptions ids.`, { options });
				result = true;
			}
			for (const option of options)
			{
				if (!option.id)
				{
					this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has SelectOption without id.`, { option });
					result = true;
				}
				if (!option.text)
				{
					this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has SelectOption without text.`, { option });
					result = true;
				}
				if (option.id == option.text && option.id.includes(' '))
				{
					this.fable.log.info(`[WARN] Form [${form}] [${context}] Descriptor [${descriptorKey}] has SelectOption with probably overspecified id`, { option });
					result = true;
				}
			}
			/* I used this to print all the select lists for Victoria
			this.fable.log.info(`DESCRIPTOR: Form [${form}] [${context}] Descriptor [${descriptorKey}] has ${optionCount} SelectOptions:`);
			for (const option of options)
			{
				this.fable.log.info(`DESCRIPTOR: ${option.id}: ${option.text}`);
			}
			*/
		}
		return result;
	}

	/**
	 * @param {any} manifest - the manifest to check
	 * @param {string} name - the name of the manifest
	 */
	checkManifestForAddressConflicts(manifest, name)
	{
		let result = false;
		const addresses = new Set();
		for (const [ key, descriptor ] of Object.entries(manifest.Descriptors || { }))
		{
			if (addresses.has(key))
			{
				this.fable.log.info(`[WARN] ${name} has duplicate DataAddress [${key}].`, { key, descriptor });
				result = true;
			}
			const sliced = key.split('.');
			while (sliced.length > 1)
			{
				sliced.pop();
				const prefix = sliced.join('.');
				if (addresses.has(prefix))
				{
					const conflict = manifest.Descriptors[prefix];
					this.fable.log.info(`[WARN] ${name} has conflicting DataAddress [${key}] with descriptor at [${prefix}].`, { key, descriptor, conflict });
					result = true;
				}
			}
			addresses.add(key);
		}
		return result;
	}

	/**
	 * @param {string} file - the file path
	 * @return {string} the guessed form name
	 */
	_guessFormName(file)
	{
		const candidates = Path.dirname(file).split(Path.sep);
		while (candidates.length > 0)
		{
			const candidate = candidates.pop();
			if (candidate !== 'source' && candidate.toLowerCase() != 'tmp')
			{
				return candidate;
			}
		}
		return null;
	}

	/**
	 * @param {string} globPath - the glob path to search
	 * @return {Array<ManifestInfo>} the manifest info
	findManifests(globPath)
	{
		const paths = [];
		for (const file of Glob.globSync(globPath, { absolute: true }))
		{
			this.fable.log.info(`Found candidate manifest: ${file}`);
			const wrproducterManifestData = require(file);
			const data = wrproducterManifestData.DefaultFormManifest;
			if (!data)
			{
				this.fable.log.info(`[WARN] No DefaultFormManifest in [${file}]; skipping.`);
				continue;
			}
			paths.push({ path: file, name: this._guessFormName(file), data }) || wrproducterManifestData.DefaultFormManifest.Form || 'uknknown-form';
		}
		return paths;
	}
	 */

	/**
	 * @param {ManifestInfo} manifestInfo - the manifest info
	 * @param {any} comprehension - the comprehension object
	 * @return {boolean} true if problems were found, otherwise false
	 */
	addManifestToComprehension(manifestInfo, comprehension)
	{
		const manifestSchema =
		{
			GUIDManifestSchema: manifestInfo.name,
			Hash: manifestInfo.name,
			Type: 'Form',
			Title: manifestInfo.name,
			Version: 1, //FIXME: version awareness - and Version in GUID
			Description: '',
			Manifest:
			{
				Descriptors: {},
			},
		};
		// copy over any key that isn't part of the three processed by this script
		for (const manifestKey of Object.keys(manifestInfo.data))
		{
			if (manifestKey === 'Descriptors' || manifestKey === 'Sections' || manifestKey === 'ReferenceManifests')
			{
				continue;
			}
			manifestSchema.Manifest[manifestKey] = manifestInfo.data[manifestKey];
		}
		// new manifest per section
		// split the desceriptors by section
		// split the ReferenceManifests by <tk logic>
		const referenceManifestMap = {};
		const seenManifests = new Set();
		const descriptorSectionKeys = new Set();
		const descriptorMap = {};
		const declarationDescriptors = []; // contains descriptors without a section - they are presumed to be declarations
		const declarationDescriptorKeys = new Set();
		const fieldDescriptorKeys = new Set();
		const sectionKeys = new Set();
		const orderedSectionHashes = [];
		const includeBySection = {};
		if (Array.isArray(manifestInfo.data.Sections))
		{
			for (const section of manifestInfo.data.Sections)
			{
				if (typeof section.Hash === 'string')
				{
					if (!sectionKeys.has(section.Hash))
					{
						orderedSectionHashes.push(section.Hash);
						sectionKeys.add(section.Hash);
					}
				}
			}
		}
		let problems = this.checkManifestForAddressConflicts(manifestInfo.data, 'Root Manifest');
		for (const [ descriptorKey, descriptor ] of Object.entries(manifestInfo.data.Descriptors))
		{
			if (descriptorKey !== descriptor.DataAddress)
			{
				this.fable.log.info(`[WARN] Descriptor hash mismatch [${descriptorKey} != ${descriptor.DataAddress}].`, { descriptor });
			}

			descriptorMap[descriptorKey] = descriptor;

			this.sanityCheckDescriptor(manifestInfo.name, descriptorKey, descriptor);

			const sectionHash = descriptor.PictForm?.Section;
			if (typeof sectionHash !== 'string')
			{
				declarationDescriptors.push(descriptor);
				declarationDescriptorKeys.add(descriptorKey);
				continue;
			}
			descriptorSectionKeys.add(sectionHash);
			fieldDescriptorKeys.add(descriptorKey);

			if (!includeBySection[sectionHash])
			{
				includeBySection[sectionHash] = {};
			}
			if (!includeBySection[sectionHash].Descriptors)
			{
				includeBySection[sectionHash].Descriptors = {};
			}
			includeBySection[sectionHash].Descriptors[descriptorKey] = descriptor;
		}
		if (manifestInfo.data.ReferenceManifests)
		{
			for (const [ key, manifest ] of Object.entries(manifestInfo.data.ReferenceManifests))
			{
				problems = this.checkManifestForAddressConflicts(manifestInfo.data, key) || problems;
				referenceManifestMap[key] = manifest;
				for (const [ descriptorKey, descriptor ] of Object.entries(manifest.Descriptors || { }))
				{
					this.sanityCheckDescriptor(manifestInfo.name, descriptorKey, descriptor, `Reference Manifest ${key}`);
				}
			}
		}
		const allSolvers = {};
		const orphanedDeclarationDescriptorHashes = new Set(declarationDescriptorKeys);
		if (Array.isArray(manifestInfo.data.Sections))
		{
			for (const section of manifestInfo.data.Sections)
			{
				if (!section.Hash)
				{
					this.fable.log.info(`[ERROR] No hash for section; skipping.`, { section });
					continue;
				}
				if (!sectionKeys.has(section.Hash))
				{
					orderedSectionHashes.push(section.Hash);
					sectionKeys.add(section.Hash);
				}

				let recordSetCount = 0;
				if (Array.isArray(section.Groups))
				{
					for (const group of section.Groups)
					{
						if (group.RecordSetAddress)
						{
							if (declarationDescriptorKeys.has(group.RecordSetAddress))
							{
								if (!includeBySection[section.Hash])
								{
									includeBySection[section.Hash] = {};
								}
								if (!includeBySection[section.Hash].Descriptors)
								{
									includeBySection[section.Hash].Descriptors = {};
								}
								includeBySection[section.Hash].Descriptors[group.RecordSetAddress] = descriptorMap[group.RecordSetAddress];
								++recordSetCount;
								orphanedDeclarationDescriptorHashes.delete(group.RecordSetAddress);
							}
							else if (!fieldDescriptorKeys.has(group.RecordSetAddress))
							{
								this.fable.log.info(`[WARN] Section [${section.Hash}] Group [${group.Hash || group.Name || '--N/A--'}] RecordSetAddress [${group.RecordSetAddress}] has no matching declaration.`, { group });
							}
						}

						if (group.RecordManifest)
						{
							const referenceManifest = referenceManifestMap[group.RecordManifest];
							if (referenceManifest)
							{
								seenManifests.add(group.RecordManifest);

								if (!includeBySection[section.Hash])
								{
									includeBySection[section.Hash] = {};
								}
								if (!includeBySection[section.Hash].ReferenceManifests)
								{
									includeBySection[section.Hash].ReferenceManifests = {};
								}
								includeBySection[section.Hash].ReferenceManifests[group.RecordManifest] = referenceManifest;
							}
							else
							{
								this.fable.log.info(`[WARN] Section [${section.Hash}] Group [${group.Hash || group.Name || '--N/A--'}] RecordManifest [${group.RecordManifest}] not found.`, { group });
							}
						}
					}
				}
				if (recordSetCount == 0 && !descriptorSectionKeys.has(section.Hash))
				{
					this.fable.log.info(`[WARN] Section [${section.Hash}] exists but no descriptor has that section.`);
				}
				if (Array.isArray(section.Solvers))
				{
					allSolvers[section.Hash] = [];
					for (const solver of section.Solvers)
					{
						allSolvers[section.Hash].push(solver);
					}
				}
			}
		}
		if (orphanedDeclarationDescriptorHashes.size)
		{
			for (const address of Array.from(orphanedDeclarationDescriptorHashes))
			{
				const descriptor = descriptorMap[address];
				const matcher = this.getEscapedRegex(descriptor.Hash);
				const dependentSections = Object.entries(allSolvers).filter(([ sectionHash, solvers ]) => solvers.some((s) => s.match(matcher))).map(([ sectionHash ]) => manifestInfo.data.Sections.find((s) => s.Hash === sectionHash));
				if (!dependentSections.length)
				{
					this.fable.log.info(`[WARN] Orphaned declaration descriptor; including at root: [${descriptor.DataAddress}](${descriptor.Hash})`);
					manifestSchema.Manifest.Descriptors[address] = descriptor;
				}
				else
				{
					orphanedDeclarationDescriptorHashes.delete(address);
					for (const section of dependentSections)
					{
						if (!includeBySection[section.Hash])
						{
							includeBySection[section.Hash] = {};
						}
						if (!includeBySection[section.Hash].Descriptors)
						{
							includeBySection[section.Hash].Descriptors = {};
						}
						includeBySection[section.Hash].Descriptors[address] = descriptor;
					}
				}
			}
		}
		for (const refManifestKey of Object.keys(referenceManifestMap))
		{
			if (!seenManifests.has(refManifestKey))
			{
				this.fable.log.info(`[ERROR] ReferenceManifest [${refManifestKey}] not used.`);
			}
		}

		// generate export
		if (orderedSectionHashes.length < 1)
		{
			this.fable.log.info(`[WARN] No sections found for [${manifestInfo.name}]; skipping.`);
			return problems;
		}
		comprehension.ManifestSchema.push(manifestSchema);
		let ordinal = 0;
		for (const sectionHash of orderedSectionHashes)
		{
			++ordinal;
			const sectionManifest =
			{
				Descriptors: includeBySection[sectionHash]?.Descriptors || {},
				Sections: [],
				ReferenceManifests: includeBySection[sectionHash]?.ReferenceManifests || {},
			};
			const section = manifestInfo.data.Sections.find((s) => s.Hash === sectionHash);
			if (section)
			{
				sectionManifest.Sections.push(section);
			}
			const manifestSchemaPartial =
			{
				GUIDManifestSchemaPartial: `${manifestSchema.GUIDManifestSchema}-${sectionHash}`,
				Hash: sectionHash,
				Type: 'Section',
				Title: `[${manifestSchema.Title}] ${section.Name || sectionHash}`,
				Version: 1,
				Description: '',
				ManifestPartial: sectionManifest,
			};
			comprehension.ManifestSchemaPartial.push(manifestSchemaPartial);
			const manifestSchemaManifestSchemaPartialJoin =
			{
				GUIDManifestSchemaManifestSchemaPartialJoin: `${manifestSchema.GUIDManifestSchema}-${sectionHash}`,
				GUIDManifestSchema: manifestSchema.GUIDManifestSchema,
				GUIDManifestSchemaPartial: manifestSchemaPartial.GUIDManifestSchemaPartial,
				Ordinal: ordinal,
			};
			comprehension.ManifestSchemaManifestSchemaPartialJoin.push(manifestSchemaManifestSchemaPartialJoin);
		}
		return problems;
	}

	/**
	 * @typedef {Object} ManifestInfo
	 * @property {string} name - the name of the manifest
	 * @property {string} path - the path to the manifest
	 * @property {any} data - the manifest data
	 */

	/**
	 * @param {Array<ManifestInfo>} manifestInfos - the manifest info
	 */
	async generateComprehension(manifestInfos, comprehensionOutputPath = 'comprehension.json')
	{
		const comprehension =
		{
			ManifestSchema: [],
			ManifestSchemaPartial: [],
			ManifestSchemaManifestSchemaPartialJoin: [],
		};
		for (const manifestInfo of manifestInfos)
		{
			if (this.addManifestToComprehension(manifestInfo, comprehension))
			{
				this.fable.log.info(`[WARN] Problems found in [${manifestInfo.name}].`);
			}
		}
		this.fable.log.info('Writing output...');
		Fs.writeFileSync(comprehensionOutputPath, JSON.stringify(comprehension, null, 2));
		return Path.resolve(comprehensionOutputPath);
	}

	/**
	 * Generate a RegExp to match a string, escaping any special characters.
	 *
	 * @param {string} str - the string to match
	 * @return {RegExp} the escaped regex
	 */
	getEscapedRegex(str)
	{
		return new RegExp(`\\b${str.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}\\b`);
	}

	/*
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.options.CommandKeyword = 'load_comprehension';
		this.options.Description = 'Load a comprehension into Headlight.';

		this.options.Aliases.push('load');

		this.options.CommandArguments.push({ Name: '<comprehension_file>', Description: 'The comprehension file path.' });

		this.addCommand();

		if (!('HeadlightRestClient' in this.fable.services))
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', this.pict.ProgramConfiguration);
		}

		this.comprehension = {};
	}
	*/

	runAdapter(pAnticipate, pAdapter, pDataMap, fMarshalRecord)
	{
		let tmpAdapter = this.fable.servicesMap.IntegrationAdapter[pAdapter];
		let tmpMarshalRecordFunction = fMarshalRecord;
		if (!tmpAdapter)
		{
			throw new Error(`Adapter [${pAdapter}] not found.`);
		}
		if (!pDataMap)
		{
			this.log.info(`No records to push for [${pAdapter}].`);
			return false;
		}
		pAnticipate.anticipate(
			(fDone) =>
			{
				for (const tmpRecord in pDataMap)
				{
					tmpAdapter.addSourceRecord(pDataMap[tmpRecord]);
				}
				return fDone()
			});
		pAnticipate.anticipate(
			(fDone) =>
			{
				tmpAdapter.integrateRecords(fDone, tmpMarshalRecordFunction);
			});
	}

	getCapitalLettersAsString(inputString)
	{
		let tmpRegex = /[A-Z]/g;
		let tmpMatch = inputString.match(tmpRegex);
		let tmpString = tmpMatch ? tmpMatch.join('') : 'UNK';
		return tmpString;
	}

	pushComprehension(pComprehensionFilePath, fCallback)
	{
		let tmpAnticipate = this.fable.newAnticipate();
		this.fable.log.info(`Pushing comprehension file [${pComprehensionFilePath}] to the Headlight API.`);

		this.fable.log.info(`Initializing and configuring data integration adapters...`);
		this.fable.serviceManager.addServiceType('IntegrationAdapter', IntegrationAdapter);

		/*
		 * TODO: is this necessary?
		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				this.fable.HeadlightRestClient.authenticate(
					(pError, pResponse) =>
					{
						if (pError)
						{
							this.log.error(`Error authenticating`, pError);
							return fCallback(typeof pError === 'string' ? new Error(pError) : pError);
						}
						this.log.info(`Authenticated - Session [${pResponse.SessionID}]`);
						return fCallback();
					});
			});
		 */

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				try
				{
					this.fable.log.info(`Loading Comprehension File...`);
					this.comprehension = require(pComprehensionFilePath);
					return fCallback();
				}
				catch(pError)
				{
					this.fable.log.error(`Error loading comprehension file [${pComprehensionFilePath}]: ${pError}`, pError);
					return fCallback(pError);
				}
			});

		tmpAnticipate.anticipate(
			(fCallback) =>
			{
				this.fable.log.info(`Wiring up Integration Adapters...`);

				let tmpIntegrationAdapterSet = Object.keys(this.comprehension);

				for (let i = 0; i < tmpIntegrationAdapterSet.length; i++)
				{
					// Initialize the adapter
					let tmpAdapterKey = tmpIntegrationAdapterSet[i];
					IntegrationAdapter.getAdapter(this.fable, tmpAdapterKey, this.getCapitalLettersAsString(tmpAdapterKey), { SimpleMarshal: true });
					this.runAdapter(tmpAnticipate, tmpAdapterKey, this.comprehension[tmpAdapterKey]);
				}

				return fCallback();
			});

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error importing comprehension file.`, pError);
					return fCallback(pError);
				}
				this.fable.log.info(`Finished importing comprehension file.`);
				return fCallback();
			});
	}
}

module.exports = ManifestPackagingService;

},{"fable-serviceproviderbase":438,"fs":363,"headlight-integration-adapter":8,"headlight-rest-client":20,"json-diff":503,"path":537}],26:[function(require,module,exports){

const SALT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

const Util = require('util');

const libFableServiceProviderBase = require('fable-serviceproviderbase');

const MaterialsLabRouter = require('./Materials-Lab-Router.js');

/**
 * Customer-agnostic substring patterns identifying LIMS-managed report named instances.
 *
 * Heuristic. The customer prefix segment (e.g. 'LADOTD') is intentionally excluded so the
 * check works across customers; future iterations should migrate to a structural marker
 * such as a ReportArchetype-driven membership lookup.
 *
 * @type {ReadonlyArray<string>}
 */
const LIMS_GUID_PATTERNS = Object.freeze([ 'LIMS-ContainerForm', '-MSP-', '-RNI-SO-' ]);
// Backstop for the IDMaterialParent walk — no FK prevents a cyclic/runaway chain.
const MAX_MATERIAL_PARENT_DEPTH = 16;

// Sample-level lab selector InputTypes seeded by _setSampleLabsInDocument. Deliberately excludes the
// per-test lab inputs (MaterialsTestLabSelector / MaterialsTestLabPicker) and the display-only variants.
const LAB_SELECTOR_INPUT_TYPES = Object.freeze([ 'MaterialsLabSelector', 'MaterialsLabPicker', 'LabSelector' ]);
// Long-lived instances (the pict web apps register this service once per page
// session) must pick up LabTestSpecificationSetJoin changes without a reload.
const DEFAULT_ALLOWED_LAB_SCOPE_CACHE_TTL_SECONDS = 60;

/**
 * @param {string} pGUIDReportNamedInstance
 * @return {boolean} true if the GUID matches the LIMS-form heuristic
 */
const isLIMSForm = (pGUIDReportNamedInstance) =>
{
	if (typeof pGUIDReportNamedInstance !== 'string')
	{
		return false;
	}
	for (const tmpPattern of LIMS_GUID_PATTERNS)
	{
		if (pGUIDReportNamedInstance.indexOf(tmpPattern) >= 0)
		{
			return true;
		}
	}
	return false;
};

/**
 * @typedef {object} FormGroupContext
 * @property {Record<string, any>} [ConciergeConfig] - Resolved ConciergeDefaults/Sample
 *   config for the project (e.g. `{ Hashes: ['...'], Enabled: true, CreatePerLab: false }`).
 *   When present, group membership unions any RNI whose Hash appears in `ConciergeConfig.Hashes`.
 */

/**
 * @typedef {object} FormGroupDescriptor
 * @property {string} Identifier - Stable machine identifier for the group
 * @property {string} Name - Human display name
 * @property {string} Description - Short description for the bulk-add UI
 * @property {(pAvailableRNIs: Array<Record<string, any>>, pContext?: FormGroupContext) => Array<Record<string, any>>} getMembers
 *   - Filter `pAvailableRNIs` to the subset belonging to this group given the project context.
 */

/**
 * Resolve the set of RNIs that should be treated as LIMS-managed for a given project context.
 *
 * Union of:
 *   - heuristic match: GUID/Hash contains a `LIMS_GUID_PATTERNS` substring
 *   - configured extras: `pContext.ConciergeConfig.Hashes` — the project-level "extra forms"
 *     list the materials API auto-creates on each sample sync regardless of whether they
 *     match the GUID heuristic. See SampleTestController.syncSampleTests's
 *     `tmpDefaultFormConfigs.Hashes` block.
 *
 * @param {Array<Record<string, any>>} pAvailableRNIs - candidate RNIs (typically the project's available list)
 * @param {FormGroupContext} [pContext]
 * @return {Array<Record<string, any>>} subset of pAvailableRNIs that are LIMS-managed in the given context
 */
const getLIMSFormCandidates = (pAvailableRNIs, pContext) =>
{
	if (!Array.isArray(pAvailableRNIs))
	{
		return [];
	}
	const tmpExtraHashesSource = pContext && pContext.ConciergeConfig && pContext.ConciergeConfig.Hashes;
	const tmpExtraHashes = new Set(Array.isArray(tmpExtraHashesSource) ? tmpExtraHashesSource : []);
	return pAvailableRNIs.filter((pRNI) =>
	{
		if (!pRNI)
		{
			return false;
		}
		if (isLIMSForm(pRNI.GUIDReportNamedInstance) || isLIMSForm(pRNI.Hash))
		{
			return true;
		}
		if (pRNI.Hash && tmpExtraHashes.has(pRNI.Hash))
		{
			return true;
		}
		return false;
	});
};

/**
 * Registry of named report-named-instance groups consumable by tooling that wants to
 * present forms in semantic clusters (e.g. the forms-editor bulk-add modal).
 *
 * Group descriptors expose `getMembers(pAvailableRNIs, pContext)` rather than a static
 * predicate so groups whose membership depends on project-level state (e.g. LIMS, where
 * "extra forms" are configured per-project via ConciergeDefaults/Sample.Hashes) can
 * resolve correctly. Groups with purely static membership simply ignore `pContext`.
 *
 * @type {Readonly<Record<string, FormGroupDescriptor>>}
 */
const FORM_GROUPS = Object.freeze(
{
	LIMS: Object.freeze(
	{
		Identifier: 'LIMS',
		Name: 'LIMS Forms',
		Description: 'Forms managed by the Lab Information Management System concierge auto-creation pipeline.',
		getMembers: getLIMSFormCandidates,
	}),
});

class MaterialsFormManager extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the adapter
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightRestClient: import('headlight-rest-client'), AppData: Record<string, any> }} */
		this.fable;

		if (!this.fable.AppData)
		{
			this.fable.AppData = {};
		}
		/** @type {import('headlight-rest-client')} */
		this._Client = null;

		this.serviceType = 'MaterialsFormManager';
		this.fable.addServiceType('ManifestPackagingService', require('manifest-packaging-service'));
		this.fable.instantiateServiceProviderIfNotExists('ManifestPackagingService', require('manifest-packaging-service'));

		/** @type {Record<number, { CachedAt: number, AllowedLabIDs: Set<number>|null }>} */
		this._AllowedLabIDsByContract = {};

		/** @type {MaterialsLabRouter|null} */
		this._LabRouter = null;
	}

	/**
	 * The lab router deciding which lab a sample ships to and which bench runs each of its tests.
	 *
	 * A customer needing behavior the declarative `LabRouting` rules cannot express names a registered fable
	 * service in `LabRouting.ResolverService`; it must answer `selectSampleLabID` / `selectTestLabID` with
	 * the same shape. An unresolvable name falls back to the built-in router rather than failing the sync.
	 *
	 * @param {Record<string, any>} [pLabRoutingConfig] - the ConciergeDefaults `LabRouting` block
	 *
	 * @return {MaterialsLabRouter}
	 */
	getLabRouter(pLabRoutingConfig)
	{
		if (this._LabRouter)
		{
			return this._LabRouter;
		}
		const tmpResolverService = pLabRoutingConfig && pLabRoutingConfig.ResolverService;
		if (tmpResolverService)
		{
			let tmpCustomRouter = this.fable.services[tmpResolverService];
			if (!tmpCustomRouter && (tmpResolverService in this.fable.serviceManager.servicesMap))
			{
				tmpCustomRouter = this.fable.serviceManager.instantiateServiceProvider(tmpResolverService, this.options);
			}
			if (tmpCustomRouter && typeof tmpCustomRouter.selectTestLabID === 'function')
			{
				this.fable.log.info(`Lab routing is delegated to the customer resolver service '${tmpResolverService}'.`);
				this._LabRouter = tmpCustomRouter;
			}
			else
			{
				this.fable.log.warn(`Lab routing resolver service '${tmpResolverService}' is not registered (or does not implement selectTestLabID); using the built-in router.`);
			}
		}
		if (!this._LabRouter)
		{
			this._LabRouter = new MaterialsLabRouter(this.fable, this.options);
		}
		// Bound lazily rather than at construction so the router reads through whatever session the manager
		// is impersonating at call time.
		this._LabRouter.setDataReaders(
			{
				get: (pURI) => this._get(pURI),
				getAll: (pURI) => this._getAll(pURI),
			});
		return this._LabRouter;
	}

	/**
	 * @return {import('headlight-rest-client')}
	 */
	get client()
	{
		if (this.options.UseSiloedClient)
		{
			if (!this._Client)
			{
				this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
				this._Client = this.fable.serviceManager.instantiateServiceProviderWithoutRegistration('HeadlightRestClient', this.options);
			}
			return this._Client;
		}

		let tmpClient = this.fable.services.HeadlightRestClient;
		if (!tmpClient)
		{
			this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
			if (!this.options.hasOwnProperty('HeadlightAPIURL'))
			{
				this.options.HeadlightAPIURL = 'https://api.qa.headlight.com/1.0/';
			}
			tmpClient = this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', this.options);
		}
		return tmpClient;
	}

	/**
	 * Async wrapper for HTTP get.
	 *
	 * @param {String} uri The URI to get.
	 *
	 * @return {Promise<any>} The result of the get.
	 */
	async _get(uri)
	{
		this.fable.log.info(`GET ${uri}`);
		return Util.promisify(this.client.getJSON.bind(this.client))(uri);
	}

	/**
	 * @param {String} pURI
	 * @param {number} [pPageSize=250]
	 *
	 * @return {Promise<Array<any>>}
	 */
	async _getAll(pURI, pPageSize = 250)
	{
		let tmpResults = [];
		let tmpOffset = 0;
		let tmpPage;
		do
		{
			const tmpPageURI = `${pURI}/${tmpOffset}/${pPageSize}`;
			tmpPage = await this._get(tmpPageURI);
			if (!Array.isArray(tmpPage))
			{
				throw new Error(`Expected array response from GET ${tmpPageURI}`);
			}
			tmpResults = tmpResults.concat(tmpPage);
			tmpOffset += pPageSize;
		}
		while (tmpPage.length >= pPageSize);
		return tmpResults;
	}

	/**
	 * Async wrapper for HTTP put.
	 *
	 * @param {String} uri The URI to put to.
	 * @param {any} payload The payload to put (as JSON).
	 *
	 * @return {Promise<any>} The result of the put.
	 */
	async _put(uri, payload)
	{
		this.fable.log.info(`PUT ${uri}`, { payload });
		return Util.promisify(this.client.putJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP post.
	 *
	 * @param {String} uri The URI to post to.
	 * @param {any} payload The payload to post (as JSON).
	 *
	 * @return {Promise<Object>} The result of the post.
	 */
	async _post(uri, payload)
	{
		this.fable.log.info(`POST ${uri}`, { payload });
		return Util.promisify(this.client.postJSON.bind(this.client))(uri, payload);
	}

	/**
	 * Async wrapper for HTTP delete.
	 *
	 * @param {string} entityType The entity type to delete.
	 * @param {string|number} entityID The entity ID to delete.
	 *
	 * @return {Promise<Object>} The result of the delete.
	 */
	async _deleteEntity(entityType, entityID)
	{
		this.fable.log.info(`DELETE ${entityType}:${entityID}`, { entityType, entityID });
		return Util.promisify(this.client.deleteEntity.bind(this.client))(entityType, entityID);
	}

	/**
	 * @param {Record<string, any>} pManifestSchema
	 *
	 * @return {void}
	 */
	_decorateManifestSchema(pManifestSchema)
	{
		switch (pManifestSchema.Type)
		{
			case 'Test':
				pManifestSchema.DisplayName = `Test Hash: ${pManifestSchema.SubType}`;
				pManifestSchema.TestHash = pManifestSchema.SubType;
				break;
			case 'Header':
				pManifestSchema.DisplayName = `Form Header: ${pManifestSchema.Title}`;
				break;
			case 'Footer':
				pManifestSchema.DisplayName = `Form Footer: ${pManifestSchema.Title}`;
				break;
			default:
				pManifestSchema.DisplayName = pManifestSchema.Title;
		}
		pManifestSchema.Enabled = true;
	}

	// things we need:
	// * get default manifests for a given IDMaterial
	// * get available RNIs and extract test and material mappings?
	//   * TODO: how do we map materials to RNIs? maybe we can put that in the RNI for now? but not long term
	// * return a summary of tests for a given material so it can be visualized
	// * function to apply a subset of the tests (manifests to one or more documents, RNIs as new forms)

	/**
	 * @param {Array<number>} pIDMaterials
	 *
	 * @return {Promise<Array<Record<string, any>>>} The manifests for the given IDMaterial
	 */
	async getManifestsForIDMaterial(pIDMaterials)
	{
		// load MaterialManifestSetJoins for given IDMaterial
		const tmpMaterialManifestSetJoins = await this._getAll(`MaterialManifestSetJoins/FilteredTo/FBL~IDMaterial~INN~${pIDMaterials}`);
		// then load ManifestSets recursively using ManifestSetManifestSetJoin
		let tmpManifestSets = await this._getAll(`ManifestSets/FilteredTo/FBL~IDManifestSet~INN~${tmpMaterialManifestSetJoins.map((join) => join.IDManifestSet).join(',')}`);
		let tmpManifestSchemas = [];
		if (tmpManifestSets.length > 0)
		{
			let tmpLoadedJoins;
			let tmpManifestSetIDs = tmpManifestSets.map((ms) => ms.IDManifestSet);
			const tmpSeenManifestSetIDs = new Set(tmpManifestSetIDs);
			let tmp
			do
			{
				tmpLoadedJoins = await this._getAll(`ManifestSetManifestSetJoins/FilteredTo/FBL~IDManifestSet~INN~${tmpManifestSetIDs.map((ms) => ms.IDManifestSet).join(',')}~FSF~Ordinal~ASC~0`);
				tmpManifestSetIDs = tmpLoadedJoins.map((join) => join.IncludedIDManifestSet).filter((id) => !tmpSeenManifestSetIDs.has(id));
				tmpManifestSetIDs.forEach((id) => tmpSeenManifestSetIDs.add(id));
				if (tmpManifestSetIDs.length > 0)
				{
					tmpManifestSets = tmpManifestSets.concat(await this._getAll(`ManifestSets/FilteredTo/FBL~IDManifestSet~INN~${tmpManifestSetIDs.join(',')}`));
				}
			}
			while (tmpLoadedJoins.length > 0);

			// load ManifestSetManifestSchemaJoins in bulk for the loaded ManifestSets
			const tmpManifestSetManifestSchemaJoins = await this._getAll(`ManifestSetManifestSchemaJoins/FilteredTo/FBL~IDManifestSet~INN~${tmpManifestSets.map((ms) => ms.IDManifestSet).join(',')}~FSF~Ordinal~ASC~0`);
			//FIXME: sort the sets then joins by Ordinal to enforce order on the returned records
			// load ManifestSchema records as we go using ManifestSetManifestSchemaJoin
			tmpManifestSchemas = await this._getAll(`ManifestSchemas/FilteredTo/FBL~IDManifestSchema~INN~${tmpManifestSetManifestSchemaJoins.map((join) => join.IDManifestSchema).join(',')}`);
		}
		// format the results (decide the shape)a
		for (const tmpManifestSchema of tmpManifestSchemas)
		{
			tmpManifestSchema.Enabled = true;
			this._decorateManifestSchema(tmpManifestSchema);
		}
		return tmpManifestSchemas;
	}

	/**
	 * @param {number|string} [pIDProject]
	 *
	 * @return {Promise<Array<Record<string, any>>>} The available RNIs for the given project
	 */
	async _getAvailableRNIs(pIDProject)
	{
		const tmpIDProject = pIDProject ? pIDProject : await this._get(`Projects/0/1`).then((res) => res[0].IDProject);
		if (!tmpIDProject)
		{
			throw new Error(`Could not determine a valid project ID to load RNIs for.`);
		}
		return this._getAll(`ReportNamedInstancesByProject/${tmpIDProject}`, 100);
	}

	/**
	 * Walk a material up its IDMaterialParent chain, returning the material and
	 * every ancestor (so tests/labs assigned to a parent material flow through to
	 * a child-material sample). The walk is guarded against cyclic or
	 * self-referential IDMaterialParent data (no FK prevents it): a repeat id or
	 * the depth cap stops the walk and logs, degrading to "use what we walked"
	 * rather than looping forever.
	 *
	 * @param {number} pIDMaterial
	 *
	 * @return {Promise<Array<number>>} The given material and its parent materials
	 */
	async _resolveMaterialParents(pIDMaterial)
	{
		let tmpIDMaterial = pIDMaterial;
		const tmpMaterialIDs = [];
		const tmpVisited = new Set();
		while (tmpIDMaterial && !tmpVisited.has(tmpIDMaterial) && tmpMaterialIDs.length < MAX_MATERIAL_PARENT_DEPTH)
		{
			tmpVisited.add(tmpIDMaterial);
			tmpMaterialIDs.push(tmpIDMaterial);
			const tmpMaterialRecord = await this._get(`Material/${tmpIDMaterial}`);
			//TODO: if the starting material doesn't exist, do we want to throw?
			tmpIDMaterial = tmpMaterialRecord && tmpMaterialRecord.IDMaterialParent;
		}
		if (tmpIDMaterial && tmpVisited.has(tmpIDMaterial))
		{
			this.fable.log.warn(`Material parent chain for ${pIDMaterial} hit a cycle at material ${tmpIDMaterial}; stopping walk`, { ResolvedMaterialIDs: tmpMaterialIDs });
		}
		else if (tmpIDMaterial && tmpMaterialIDs.length >= MAX_MATERIAL_PARENT_DEPTH)
		{
			this.fable.log.warn(`Material parent chain for ${pIDMaterial} exceeded depth ${MAX_MATERIAL_PARENT_DEPTH}; stopping walk`, { ResolvedMaterialIDs: tmpMaterialIDs });
		}
		return tmpMaterialIDs;
	}

	/**
	 * Index rows carrying `IDTest` + `IDLab` (TestLabJoin, LabTestDefault) into the per-test lab sets the
	 * router narrows with.
	 *
	 * @param {Array<Record<string, any>>} pRows
	 *
	 * @return {Record<string, Set<number>>}
	 */
	_indexLabIDsByTest(pRows)
	{
		/** @type {Record<string, Set<number>>} */
		const tmpIndex = {};
		for (const tmpRow of (pRows || []))
		{
			const tmpIDTest = (tmpRow.IDTest === null || tmpRow.IDTest === undefined) ? '' : String(tmpRow.IDTest).trim();
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDTest === '' || !(tmpIDLab > 0))
			{
				continue;
			}
			if (!tmpIndex[tmpIDTest])
			{
				tmpIndex[tmpIDTest] = new Set();
			}
			tmpIndex[tmpIDTest].add(tmpIDLab);
		}
		return tmpIndex;
	}

	/**
	 * @param {number|string} pIDSample
	 *
	 * @return {Promise<Array<number>>} The lab IDs associated with the sample
	 */
	async getSampleLabIDs(pIDSample)
	{
		return this._getAll(`SampleLabJoins/FilteredTo/FBV~IDSample~EQ~${pIDSample}`).then((res) => res.map((join) => join.IDLab));
	}

	/**
	 * The line items a sample is tested for: its SampleLineItemJoin rows. `Sample.IDLineItem` is deliberately
	 * ignored — the field apps leave it at 0 and record line items only as joins.
	 *
	 * @param {number} pIDSample
	 *
	 * @return {Promise<Array<number>>} unique positive line item ids (empty when the sample has none)
	 */
	async getSampleLineItemIDs(pIDSample)
	{
		const tmpJoins = Number(pIDSample) > 0 ? await this._getAll(`SampleLineItemJoins/FilteredTo/FBV~IDSample~EQ~${Number(pIDSample)}`) : [];
		return MaterialsFormManager.normalizeLineItemIDs(tmpJoins.map((pJoin) => pJoin.IDLineItem));
	}

	/**
	 * @param {number|Array<number>|null|undefined} pLineItemIDs
	 *
	 * @return {Array<number>} unique positive line item ids, in first-seen order
	 */
	static normalizeLineItemIDs(pLineItemIDs)
	{
		const tmpList = Array.isArray(pLineItemIDs) ? pLineItemIDs : [ pLineItemIDs ];
		return Array.from(new Set(tmpList.map((pID) => Number(pID)).filter((pID) => Number.isInteger(pID) && pID > 0)));
	}

	/**
	 * Resolve the contract's materials specification set ID. The explicit
	 * MaterialIDTestSpecificationSet FK wins; when unset, fall back to matching a
	 * TestSpecificationSet by the contract's MaterialsSpecificationYear.
	 *
	 * @param {Record<string, any>} pContract
	 * @return {Promise<number>} The set ID, or 0 when the contract references none
	 */
	async _resolveMaterialSpecificationSetID(pContract)
	{
		if (pContract.MaterialIDTestSpecificationSet > 0)
		{
			return pContract.MaterialIDTestSpecificationSet;
		}
		const tmpYear = pContract.MaterialsSpecificationYear == null ? '' : String(pContract.MaterialsSpecificationYear).trim();
		if (tmpYear === '' || tmpYear === '0')
		{
			return 0;
		}
		// A year is NOT unique: a customer may run a provisional set alongside the live one for the same year,
		// and nothing on TestSpecificationSet distinguishes them. Lowest id — the earliest set for the year —
		// is the stable pick; an ambiguous year is logged rather than resolved silently.
		const tmpSets = await this._getAll(`TestSpecificationSets/FilteredTo/FBV~IDCustomer~EQ~${pContract.IDCustomer}~FBV~Year~EQ~${encodeURIComponent(tmpYear)}~FSF~IDTestSpecificationSet~ASC~0`);
		if (tmpSets.length > 1)
		{
			this.fable.log.warn(`Specification year ${tmpYear} matches ${tmpSets.length} specification sets for customer ${pContract.IDCustomer}; using the lowest id (${tmpSets[0].IDTestSpecificationSet}). Set the contract's MaterialIDTestSpecificationSet to resolve this explicitly.`);
		}
		return tmpSets.length > 0 ? tmpSets[0].IDTestSpecificationSet : 0;
	}

	/**
	 * Labs assignable under the contract's materials specification set, per
	 * LabTestSpecificationSetJoin. Fails open — returns null (no constraint) when
	 * the contract resolves no materials set, the set has no lab joins, or the
	 * read fails — matching the sample form's lab-picker scoping.
	 *
	 * Cached per contract for options.AllowedLabScopeCacheTTLSeconds (default 60).
	 *
	 * @param {Record<string, any>} pContract
	 * @return {Promise<Set<number>|null>} Allowed lab IDs, or null when unconstrained
	 */
	async getAllowedLabIDsForContract(pContract)
	{
		if (!pContract || !(pContract.IDContract > 0))
		{
			return null;
		}
		const tmpTTLSeconds = (typeof this.options.AllowedLabScopeCacheTTLSeconds === 'number') ? this.options.AllowedLabScopeCacheTTLSeconds : DEFAULT_ALLOWED_LAB_SCOPE_CACHE_TTL_SECONDS;
		const tmpCacheEntry = this._AllowedLabIDsByContract[pContract.IDContract];
		if (tmpCacheEntry && (Date.now() - tmpCacheEntry.CachedAt) < (tmpTTLSeconds * 1000))
		{
			return tmpCacheEntry.AllowedLabIDs;
		}
		let tmpAllowedLabIDs = null;
		try
		{
			const tmpSpecSetID = await this._resolveMaterialSpecificationSetID(pContract);
			if (tmpSpecSetID > 0)
			{
				const tmpJoins = await this._getAll(`LabTestSpecificationSetJoins/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpSpecSetID}`);
				const tmpJoinedLabIDs = new Set(tmpJoins.map((pJoin) => pJoin.IDLab).filter((pIDLab) => pIDLab > 0));
				if (tmpJoinedLabIDs.size > 0)
				{
					tmpAllowedLabIDs = tmpJoinedLabIDs;
				}
			}
		}
		catch (pError)
		{
			this.fable.log.warn(`Failed to resolve the assignable-lab scope for contract ${pContract.IDContract}; failing open: ${pError.message}`);
		}
		this._AllowedLabIDsByContract[pContract.IDContract] = { CachedAt: Date.now(), AllowedLabIDs: tmpAllowedLabIDs };
		return tmpAllowedLabIDs;
	}

	/**
	 * Resolve the default lab for a material and sample type using LabTestDefaults.
	 * This mirrors the auto-select toggle behavior in the materials-sampletracking app's
	 * distilled-field component, which determines default labs from LabTestDefault records
	 * and resolves them to their parent lab ID.
	 *
	 * When a project is provided, candidates are constrained to the contract's
	 * materials-specification-set lab joins (see getAllowedLabIDsForContract); a
	 * candidate qualifies when it or its parent lab is joined.
	 *
	 * @param {number} pIDMaterial - The material ID
	 * @param {string} [pSampleType='ACPT'] - The sample type
	 * @param {number} [pIDProject=0] - Project whose contract scopes assignable labs
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 *
	 * @return {Promise<number>} The default parent lab ID, or 0 if none found
	 */
	async getDefaultLabForMaterial(pIDMaterial, pSampleType = 'ACPT', pIDProject = 0, pConciergeConfig = undefined)
	{
		const tmpResult = await this.getDefaultLabForMaterialWithDiagnostics(pIDMaterial, pSampleType, pIDProject, pConciergeConfig);
		return tmpResult.IDLab;
	}

	/**
	 * Same resolution as {@link getDefaultLabForMaterial}, but surfaces the bare-0
	 * causes as a structured Reason so callers can report why no default applied:
	 *   'OK'                        — a default parent lab resolved
	 *   'NoDefaults'                — no LabTestDefault (or lab record) for the material/sample-type,
	 *                                 and no routing rule named a lab for the project either
	 *   'ExcludedBySpecSetLabJoins' — defaults exist, but every candidate lab falls
	 *                                 outside the contract's materials-specification-set lab joins
	 *
	 * Which of several candidates wins is decided by the lab router: a parent lab the project's routing
	 * rules name (its district laboratory before its field unit, for a DOT) outranks one of the project's
	 * own joined labs, which outranks the first candidate the read happened to return. With routing rules
	 * configured this also answers where it previously could not — a material carrying no LabTestDefault
	 * still ships to the project's own lab — so configuring them only ever ADDS defaulting.
	 *
	 * @param {number} pIDMaterial - The material ID
	 * @param {string} [pSampleType='ACPT'] - The sample type
	 * @param {number} [pIDProject=0] - Project whose contract scopes assignable labs
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 *
	 * @return {Promise<{ IDLab: number, Reason: string, CandidateLabIDs: Array<number>, Source: string }>}
	 */
	async getDefaultLabForMaterialWithDiagnostics(pIDMaterial, pSampleType = 'ACPT', pIDProject = 0, pConciergeConfig = undefined)
	{
		const tmpLabRoutingConfig = pConciergeConfig && pConciergeConfig.LabRouting;
		const tmpRouter = this.getLabRouter(tmpLabRoutingConfig);
		const tmpAffinityRootIDs = await tmpRouter.getAffinityRootIDs(pIDProject, tmpLabRoutingConfig);
		const tmpProjectRootLabIDs = tmpLabRoutingConfig ? await this._getProjectRootLabIDs(pIDProject, tmpRouter) : [];
		const fSelect = (pCandidateLabIDs, pCandidateDiagnosticIDs) =>
		{
			const tmpSelection = tmpRouter.selectSampleLabID(pCandidateLabIDs, { AffinityRootIDs: tmpAffinityRootIDs, ProjectRootLabIDs: tmpProjectRootLabIDs });
			if (!(tmpSelection.IDLab > 0))
			{
				return { IDLab: 0, Reason: 'NoDefaults', CandidateLabIDs: pCandidateDiagnosticIDs, Source: 'None' };
			}
			return { IDLab: tmpSelection.IDLab, Reason: 'OK', CandidateLabIDs: pCandidateDiagnosticIDs, Source: tmpSelection.Source };
		};
		if (!pIDMaterial || pIDMaterial <= 0)
		{
			return fSelect([], []);
		}
		const tmpMaterialIDs = await this._resolveMaterialParents(pIDMaterial);
		const tmpLabTestDefaults = await this._getAll(`LabTestDefaults/FilteredTo/FBL~IDMaterial~INN~${tmpMaterialIDs.join(',')}~FBV~SampleType~EQ~${pSampleType}`);
		if (tmpLabTestDefaults.length < 1)
		{
			return fSelect([], []);
		}
		// Get unique lab IDs from the defaults
		const tmpLabIDs = [...new Set(tmpLabTestDefaults.map((ltd) => ltd.IDLab))];
		// Fetch the lab records to resolve parent labs
		let tmpLabs = await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${tmpLabIDs.join(',')}`);
		if (tmpLabs.length < 1)
		{
			return fSelect([], tmpLabIDs);
		}
		if (pIDProject > 0)
		{
			const tmpProject = await this._get(`Project/${pIDProject}`);
			const tmpContract = tmpProject && tmpProject.IDContract > 0 ? await this._get(`Contract/${tmpProject.IDContract}`) : null;
			const tmpAllowedLabIDs = await this.getAllowedLabIDsForContract(tmpContract);
			if (tmpAllowedLabIDs)
			{
				tmpLabs = tmpLabs.filter((pLab) => tmpAllowedLabIDs.has(pLab.IDLab) || tmpAllowedLabIDs.has(pLab.IDLabParent));
				if (tmpLabs.length < 1)
				{
					this.fable.log.info(`All default labs for material ${pIDMaterial} fall outside the contract's materials-specification-set lab joins; no default lab resolved`);
					return { IDLab: 0, Reason: 'ExcludedBySpecSetLabJoins', CandidateLabIDs: tmpLabIDs, Source: 'None' };
				}
			}
		}
		// The router promotes through its own lab tree, matching the web app's indexing by IDLabParent. A lab
		// the catalog does not carry has no tree to promote through, so its own parent pointer stands in.
		await tmpRouter.loadLabCatalog();
		const tmpCandidateRootIDs = tmpLabs.map((pLab) => tmpRouter.getLab(pLab.IDLab) ? pLab.IDLab : (pLab.IDLabParent > 0 ? pLab.IDLabParent : pLab.IDLab));
		return fSelect(tmpCandidateRootIDs, tmpLabIDs);
	}

	/**
	 * The project's own PARENT labs, from `ProjectLabJoin`. A customer that joins a bench instead of its
	 * parent still scopes to the right family, because the ids are normalized through the lab tree.
	 *
	 * NB: `ProjectLabJoin` has no `Deleted` column — foxhound's soft-delete predicate is schema-driven, so a
	 * hand-written `Deleted` clause would error the read and silently fail open to no project labs.
	 *
	 * @param {number} pIDProject
	 * @param {MaterialsLabRouter} pLabRouter - the router whose lab tree normalizes the joined ids
	 *
	 * @return {Promise<Array<number>>}
	 */
	async _getProjectRootLabIDs(pIDProject, pLabRouter)
	{
		if (!(pIDProject > 0))
		{
			return [];
		}
		const tmpJoins = await this._getAll(`ProjectLabJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}`);
		await pLabRouter.loadLabCatalog();
		return Array.from(pLabRouter.rootsOf(tmpJoins.map((pJoin) => pJoin.IDLab)));
	}

	/**
	 * @param {number} pIDMaterial
	 * @param {number} pIDProject
	 * @param {string} [pSampleType='ACPT']
	 * @param {Array<number>} [pSelectedParentLabIDs=undefined]
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 * @param {number|Array<number>} [pLineItemIDs] - the sample's line item(s) (see getSampleLineItemIDs); default
	 *   tests are scoped to them (none resolve without one)
	 *
	 * @return {Promise<Array<Record<string, any>>>} The default tests by material.
	 */
	async getMaterialTestDefaults(pIDMaterial, pIDProject, pSampleType = 'ACPT', pSelectedParentLabIDs = undefined, pConciergeConfig = undefined, pLineItemIDs = undefined)
	{
		const tmpResult = await this.getMaterialTestDefaultsWithDiagnostics(pIDMaterial, pIDProject, pSampleType, pSelectedParentLabIDs, pConciergeConfig, pLineItemIDs);
		return tmpResult.Tests;
	}

	/**
	 * Same resolution as {@link getMaterialTestDefaults}, but returns the bare
	 * `[]` causes as a structured Reason instead of an empty array — so callers
	 * (the LIMS concierge) can tell "material is not in this contract's spec
	 * year" apart from "configured but nothing to create". Reason is one of:
	 *   'OK'              — at least one default test resolved
	 *   'NoContract'      — the project has no contract (no spec year to draw from)
	 *   'NoMaterial'      — no material was given, so neither the sampling plan nor
	 *                       the spec-year fallback can resolve anything
	 *   'NoLineItem'      — no line item was given; the sampling plan and the
	 *                       spec-year fallback are both line-item scoped, so nothing resolves
	 *   'NoSamplingPlan'  — contract present, but no ProjectLineItemMaterialTest
	 *                       row for this line item/material/sample-type (the spec-year miss)
	 *   'TestsUnresolved' — sampling-plan rows present, but none resolved to a
	 *                       live Test record
	 *
	 * Each resolved test is routed to exactly one lab — a BENCH (leaf) where the capability tables name one,
	 * the sample's parent lab otherwise — so the returned entries partition across `LabID` rather than
	 * repeating a test under several labs.
	 *
	 * @param {number} pIDMaterial
	 * @param {number} pIDProject
	 * @param {string} [pSampleType='ACPT']
	 * @param {Array<number>} [pSelectedParentLabIDs=undefined]
	 * @param {Record<string, any>} [pConciergeConfig] - the project's ConciergeDefaults config (supplies LabRouting)
	 * @param {number|Array<number>} [pLineItemIDs] - the sample's line item(s), normally its SampleLineItemJoins
	 *   (see getSampleLineItemIDs). Sampling-plan rows and the spec-year fallback are both scoped to them; with
	 *   none, no default tests resolve (Reason 'NoLineItem').
	 * @return {Promise<{ Tests: Array<Record<string, any>>, Reason: string, Diagnostics: Record<string, any> }>}
	 */
	async getMaterialTestDefaultsWithDiagnostics(pIDMaterial, pIDProject, pSampleType = 'ACPT', pSelectedParentLabIDs = undefined, pConciergeConfig = undefined, pLineItemIDs = undefined)
	{
		const tmpIDMaterial = Number(pIDMaterial) > 0 ? Number(pIDMaterial) : 0;
		const tmpLineItemIDs = MaterialsFormManager.normalizeLineItemIDs(pLineItemIDs);
		if (!tmpIDMaterial)
		{
			// Without a material there is nothing to scope the sampling plan or the spec-year requirements by;
			// an empty material filter must not widen to every row on the project.
			this.log.info(`No material given for project ${pIDProject}; no default tests resolved`);
			return { Tests: [], Reason: 'NoMaterial', Diagnostics: { IDProject: pIDProject, IDMaterial: 0, LineItemIDs: tmpLineItemIDs, SampleType: pSampleType, SamplingPlanRowCount: 0 } };
		}
		if (tmpLineItemIDs.length < 1)
		{
			// Both the sampling plan and the spec-year fallback are scoped to the sample's line item, so without
			// one neither can apply — rather than widening to every pay item on the project.
			this.log.info(`No line item given for material ${tmpIDMaterial} in project ${pIDProject}; no default tests resolved`);
			return { Tests: [], Reason: 'NoLineItem', Diagnostics: { IDProject: pIDProject, IDMaterial: tmpIDMaterial, LineItemIDs: [], SampleType: pSampleType, SamplingPlanRowCount: 0 } };
		}
		const tmpLabRoutingConfig = pConciergeConfig && pConciergeConfig.LabRouting;
		const tmpRouter = this.getLabRouter(tmpLabRoutingConfig);
		const tmpAffinityRootIDs = await tmpRouter.getAffinityRootIDs(pIDProject, tmpLabRoutingConfig);
		const tmpProject = await this._get(`Project/${pIDProject}`);
		const tmpContract = tmpProject && tmpProject.IDContract > 0 ? await this._get(`Contract/${tmpProject.IDContract}`) : null;
		if (!tmpContract)
		{
			this.log.warn(`No Contract found for Project ${pIDProject}`);
			return { Tests: [], Reason: 'NoContract', Diagnostics: { IDProject: pIDProject, IDMaterial: pIDMaterial, SampleType: pSampleType, IDContract: (tmpProject && tmpProject.IDContract) || 0 } };
		}
		/*
		const tmpSpecificationSet = tmpContract && tmpContract.ItemIDTestSpecificationSet > 0 ?
			await this._get(`TestSpecificationSet/${tmpContract.ItemIDTestSpecificationSet}`) :
			await this._getAll(`TestSpecificationSets/FilteredTo/FBV~Year~EQ~${tmpContract.ItemSpecificationYear}`).then((res) => res[0]);
		if (!tmpSpecificationSet)
		{
			this.log.warn(`No TestSpecificationSet found for Contract ${tmpContract.IDContract}`);
			return [];
		}
		*/
		//const tmpSpecifications = await this._getAll(`TestSpecifications/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpSpecificationSet.IDTestSpecificationSet}`);
		const tmpMaterialIDs = await this._resolveMaterialParents(pIDMaterial);
		//const tmpTestJoins = await this._getAll(`TestSpecificationMaterialTestJoins/FilteredTo/FBL~IDMaterial~INN~${tmpMaterialIDs.join(',')}~FBL~IDTestSpecification~INN~${tmpSpecifications.map((spec) => spec.IDTestSpecification).join(',')}`);
		let tmpLabIDs = pSelectedParentLabIDs;
		let tmpParentLabs = [];
		let tmpChildLabs = [];
		if (Array.isArray(tmpLabIDs) && tmpLabIDs.length > 0)
		{
			[ tmpParentLabs, tmpChildLabs ] = await Promise.all([
				this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${tmpLabIDs.join(',')}`),
				this._getAll(`Labs/FilteredTo/FBL~IDLabParent~INN~${tmpLabIDs.join(',')}`)
			]);
			this.fable.log.info(`Resolved attached labs with ids: ${ tmpLabIDs.join(',') }`);
		}
		else
		{
			// use ProjectLabJoin if no labs are specified
			const tmpProjectLabsJoins = await this._getAll(`ProjectLabJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}`);
			tmpParentLabs = tmpProjectLabsJoins.length < 1 ? [] : await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${tmpProjectLabsJoins.map((pl) => pl.IDLab).join(',')}`);
			tmpChildLabs = tmpProjectLabsJoins.length < 1 ? [] : await this._getAll(`Labs/FilteredTo/FBL~IDLabParent~INN~${tmpProjectLabsJoins.map((pl) => pl.IDLab).join(',')}`);
			tmpLabIDs = Array.from(new Set(tmpParentLabs.map((lab) => lab.IDLab)));
			this.fable.log.info(`Falling back to Project Lab Joins for project ${ pIDProject }, found lab ids: ${ tmpLabIDs.join(',') }`);
		}
		const tmpAllowedLabIDs = await this.getAllowedLabIDsForContract(tmpContract);
		if (tmpAllowedLabIDs)
		{
			// Joined labs sit at either level of the depth-2 lab tree: a child lab is
			// assignable when it or its parent is joined; a parent when it or one of
			// its surviving children is joined.
			tmpChildLabs = tmpChildLabs.filter((pLab) => tmpAllowedLabIDs.has(pLab.IDLab) || tmpAllowedLabIDs.has(pLab.IDLabParent));
			tmpParentLabs = tmpParentLabs.filter((pLab) => tmpAllowedLabIDs.has(pLab.IDLab) || tmpChildLabs.some((pChildLab) => pChildLab.IDLabParent === pLab.IDLab));
			this.fable.log.info(`Assignable labs constrained by the materials-specification-set lab joins for contract ${tmpContract.IDContract}: parent labs [${tmpParentLabs.map((pLab) => pLab.IDLab).join(',')}], child labs [${tmpChildLabs.map((pLab) => pLab.IDLab).join(',')}]`);
		}
		// check for defaults on parent and child labs
		const tmpAllLabs = tmpParentLabs.concat(tmpChildLabs);
		// FIXME: Some of the above code is redundant with this change but we are switching this to use ProjectLineItemMaterialTests. Get this working for now.
		// Sampling-plan rows are scoped to the sample's line item: the same material often appears under
		// several pay items with different tests, and only the sample's own items apply.
		let tmpTestDefaults = await this._getAll(`ProjectLineItemMaterialTests/FilteredTo/FBL~SampleType~INN~${ pSampleType },~FBV~IDProject~EQ~${ pIDProject }~FBL~IDLineItem~INN~${ tmpLineItemIDs.join(',') }~FBL~IDMaterial~INN~${ tmpMaterialIDs.join(',') }`);
		this.fable.log.info(`Found the following PLIMTs for Project ${ pIDProject }, Line Items ${ tmpLineItemIDs.join(',') }, Materials ${ tmpMaterialIDs.join(',') }, Sample Type: ${ pSampleType }: `, { TestDefaults: tmpTestDefaults });
		const tmpSamplingPlanRowCount = tmpTestDefaults.length;
		// Fallback: when the sample's line items have no sampling plan for this material/sample-type,
		// pull tests from the contract's specification year (item spec set), scoped to
		// those line items' pay items. Sample type is filtered in code (a blank requirement type means "any").
		let tmpResolutionSource = 'SamplingPlan';
		let tmpSpecYear = null;
		if (tmpTestDefaults.length === 0)
		{
			tmpSpecYear = await this._resolveSpecYearTestDefaults(pIDMaterial, tmpMaterialIDs, pIDProject, tmpContract, pSampleType, tmpLineItemIDs);
			if (tmpSpecYear.Tests.length > 0)
			{
				tmpTestDefaults = tmpSpecYear.Tests;
				tmpResolutionSource = 'SpecYear';
				this.fable.log.info(`No sampling plan for material ${pIDMaterial} on line item(s) ${tmpLineItemIDs.join(',')} in project ${pIDProject}; using contract spec-year fallback (${tmpTestDefaults.length} test(s))`, { Diagnostics: tmpSpecYear.Diagnostics });
			}
		}

		/* FIXME: this tries to use the test specification to find the tests, but this isn't working...
		const tmpTestDefaults = tmpChildLabs.length < 1 ?
			await this._getAll(`LabTestDefaults/FilteredTo/FBL~SampleType~INN~${pSampleType},~FBL~IDTest~INN~${tmpTestJoins.map((join) => join.IDTest).join(',')}`) :
			await this._getAll(`LabTestDefaults/FilteredTo/FBL~SampleType~INN~${pSampleType},~FBL~IDTest~INN~${tmpTestJoins.map((join) => join.IDTest).join(',')}~FBL~IDLab~INN~${tmpChildLabs.map((pl) => pl.IDLab).join(',')}`);
			*/
		// Commenting this out for now but leaving for reference since plimts won't have IDLab on them.
		/*if (tmpParentLabs.length < 1)
		{
			tmpChildLabs = await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${Array.from(new Set(tmpTestDefaults.map((td) => td.IDLab))).join(',')}`);
			tmpParentLabs = tmpChildLabs.length < 1 ? [] : await this._getAll(`Labs/FilteredTo/FBL~IDLab~INN~${Array.from(new Set(tmpChildLabs.map((cl) => cl.IDLabParent))).join(',')}`);
		}*/
		const tmpTestIDs = Array.from(new Set(tmpTestDefaults.map((td) => td.IDTest)));
		const tmpTests = tmpTestIDs.length < 1 ? [] : await this._getAll(`Tests/FilteredTo/FBL~IDTest~INN~${tmpTestIDs.join(',')}`);
		// TestLabJoin is scoped to every in-scope lab, not just the benches: a project lab with no children
		// beneath it IS the bench, and scoping to children alone would leave it with no capability rows.
		const tmpScopeLabIDs = Array.from(new Set(tmpAllLabs.map((pLab) => pLab.IDLab).filter((pIDLab) => pIDLab > 0)));
		const tmpTestLabJoins = (tmpTestIDs.length < 1 || tmpScopeLabIDs.length < 1) ? [] : await this._getAll(`TestLabJoins/FilteredTo/FOP~0~(~0~FBV~DateEnd~GT~${new Date().toISOString()}~FBVOR~DateEnd~EQ~~FCP~0~)~0~FBL~IDTest~INN~${tmpTestIDs.join(',')}~FBL~IDLab~INN~${tmpScopeLabIDs.join(',')}`);
		this.fable.log.info(`Found the following test lab joins for labs ${ tmpScopeLabIDs.join(',') }, Tests ${ tmpTestIDs.join(',') }: `, { TestLabJoins: tmpTestLabJoins });
		// LabTestDefault is the per-test BACK-OFF axis: it narrows a test to its material's usual bench where
		// it has coverage, but it disagrees with TestLabJoin often enough that it is never allowed to empty
		// the candidates. Keyed on material, so it is skipped without one.
		const tmpLabTestDefaultRows = (tmpTestIDs.length < 1 || tmpMaterialIDs.length < 1) ? [] :
			await this._getAll(`LabTestDefaults/FilteredTo/FBL~IDMaterial~INN~${tmpMaterialIDs.join(',')}~FBV~SampleType~EQ~${pSampleType}~FBL~IDTest~INN~${tmpTestIDs.join(',')}`);

		const tmpTestMap = {};
		for (const tmpTest of tmpTests)
		{
			tmpTestMap[tmpTest.IDTest] = tmpTest;
		}
		// A test is run by ONE bench, so the routing below is a partition: every test resolves to exactly one
		// lab and appears in exactly one bucket. Nothing here fans a test out across labs — a sample gets a
		// second copy of a test only when a TestInstance already exists for the second lab.
		await tmpRouter.loadLabCatalog();
		tmpRouter.mergeLabCatalog(tmpAllLabs);
		const tmpTestLabsByTest = this._indexLabIDsByTest(tmpTestLabJoins);
		const tmpTestLabDefaultsByTest = this._indexLabIDsByTest(tmpLabTestDefaultRows);
		const tmpSpecSetFloor = tmpRouter.expandSpecSetFloor(tmpAllowedLabIDs);
		const tmpScopeParentLabIDs = tmpParentLabs.map((pLab) => pLab.IDLab);
		const tmpFirstParentLab = tmpParentLabs[0];
		/** @type {Record<string, number>} */
		const tmpTestLabAssignments = {};
		/** @type {Record<string, string>} */
		const tmpTestLabSources = {};
		for (const tmpIDTest of tmpTestIDs)
		{
			const tmpSelection = tmpRouter.selectTestLabID(tmpIDTest,
				{
					TestLabIDs: tmpTestLabsByTest[String(tmpIDTest)],
					TestLabDefaultIDs: tmpTestLabDefaultsByTest[String(tmpIDTest)],
					ParentLabIDs: tmpScopeParentLabIDs,
					SpecSetFloor: tmpSpecSetFloor,
					AffinityRootIDs: tmpAffinityRootIDs,
				});
			if (tmpSelection.IDLab > 0)
			{
				tmpTestLabAssignments[String(tmpIDTest)] = tmpRouter.applyAggregation(tmpSelection.IDLab);
				tmpTestLabSources[String(tmpIDTest)] = tmpSelection.Source;
				continue;
			}
			// No bench qualified. The sample's own parent lab still routes the test somewhere a technician can
			// see it, which is the behavior that predates per-test resolution.
			if (!tmpFirstParentLab)
			{
				this.fable.log.warn(`Test ID ${tmpIDTest} is not associated with a Lab ID and no parent lab was found; will create tests with no lab for material ${pIDMaterial}`);
				tmpTestLabAssignments[String(tmpIDTest)] = 0;
				tmpTestLabSources[String(tmpIDTest)] = 'None';
				continue;
			}
			tmpTestLabAssignments[String(tmpIDTest)] = tmpFirstParentLab.IDLab;
			tmpTestLabSources[String(tmpIDTest)] = 'SampleParentLab';
		}
		this.fable.log.info(`Resolved test lab assignments for material ${pIDMaterial} in project ${pIDProject}`, { TestLabAssignments: tmpTestLabAssignments, TestLabSources: tmpTestLabSources });
		const tmpTestDefaultsByLab = {};
		for (const tmpTestDefault of tmpTestDefaults)
		{
			const tmpAssignedLabID = tmpTestLabAssignments[String(tmpTestDefault.IDTest)] || 0;
			const tmpLabKey = String(tmpAssignedLabID);
			if (!tmpTestDefaultsByLab[tmpLabKey])
			{
				tmpTestDefaultsByLab[tmpLabKey] = [];
			}
			if (!tmpTestDefaultsByLab[tmpLabKey].find((t) => t.IDTest == tmpTestDefault.IDTest))
			{
				tmpTestDefaultsByLab[tmpLabKey].push(tmpTestDefault);
			}
		}
		const tmpRNIs = await this._getAvailableRNIs(pIDProject);
		// organize RNIs by tests
		let tmpResults = [];
		for (const [ tmpIDLab, tmpTestDefaults ] of Object.entries(tmpTestDefaultsByLab))
		{
			for (const tmpTestDefault of tmpTestDefaults)
			{
				const tmpTestID = tmpTestDefault.IDTest;
				const tmpTest = tmpTestMap[tmpTestID];
				if (!tmpTest)
				{
					this.fable.log.warn(`No test record found for default test ID ${tmpTestID} for material ${pIDMaterial}`);
					continue;
				}
				const tmpLabID = Number(tmpIDLab);
				const tmpLabName = tmpIDLab == '0' ? '' : (tmpAllLabs.find((lab) => lab.IDLab === tmpLabID) || tmpRouter.getLab(tmpLabID) || {}).Name || `Lab ${tmpIDLab}`;
				const tmpRNI = tmpRNIs.find((rni) => rni.Options.TestHash === tmpTest.Hash);
				const tmpFallbackRNI = tmpRNIs.find((rni) => Array.isArray(rni.Options.TestHashes) && rni.Options.TestHashes.includes(tmpTest.Hash));
				const tmpMatchedRNI = tmpRNI || tmpFallbackRNI;
				if (tmpMatchedRNI)
				{
					// Check if we already have a result for this RNI + lab combination
					const tmpExistingResult = tmpResults.find((r) => r.IDReportNamedInstance === tmpMatchedRNI.IDReportNamedInstance && r.LabID === tmpLabID);
					if (tmpExistingResult)
					{
						this.fable.log.info(`Form ${ tmpMatchedRNI.Name } for test ID ${tmpTestID} (hash: ${tmpTest.Hash}) already in result set.`);
						// Accumulate this test into the existing result
						if (!tmpExistingResult.SatisfiedTestHashes.includes(tmpTest.Hash))
						{
							tmpExistingResult.SatisfiedTestHashes.push(tmpTest.Hash);
						}
						if (!tmpExistingResult.SatisfiedIDTests.includes(tmpTestID))
						{
							tmpExistingResult.SatisfiedIDTests.push(tmpTestID);
						}
						continue;
					}
					this.fable.log.info(`Adding Form ${ tmpMatchedRNI.Name } for test ID ${tmpTestID} (hash: ${tmpTest.Hash}) to result set.`);

					const tmpResult = Object.assign({}, tmpMatchedRNI);
					tmpResult.Enabled = true;
					tmpResult.DisplayName = `Default Test RNI: ${tmpMatchedRNI.Name}`;
					tmpResult.TestHashes = tmpMatchedRNI.Options.TestHashes;
					tmpResult.TestHash = tmpRNI ? tmpRNI.Options.TestHash : tmpTest.Hash;
					tmpResult.IDTest = tmpTestID;
					tmpResult.SatisfiedIDTests = [tmpTestID];
					tmpResult.SatisfiedTestHashes = [tmpTest.Hash];
					tmpResult.LabID = tmpLabID;
					tmpResult.LabName = tmpLabName;
					tmpResult.LineItemIDs = tmpTestDefault.IDLineItem ? [ tmpTestDefault.IDLineItem ] : [];
					tmpResults.push(tmpResult);
					continue;
				}
				// Use the join-aware resolver — checks TestManifestSchemaJoin first then falls back
				// to Hash-based lookup. tmpTest already has IDTest/IDCustomer/Hash so no refetch.
				const tmpInjectableManifest = await this._resolveManifestForTestRecord(tmpTest);
				if (tmpInjectableManifest)
				{
					this.fable.log.info(`Found injectable Manifest with ID ${ tmpInjectableManifest.IDManifestSchema } for test ID ${tmpTestID} (hash: ${tmpTest.Hash}), adding to result set.`);
					tmpInjectableManifest.Enabled = true;
					tmpInjectableManifest.IDTest = tmpTestID;
					tmpInjectableManifest.SatisfiedIDTests = [tmpTestID];
					tmpInjectableManifest.SatisfiedTestHashes = [tmpTest.Hash];
					tmpInjectableManifest.LabID = tmpLabID;
					tmpInjectableManifest.LabName = tmpLabName;
					tmpInjectableManifest.Name = tmpInjectableManifest.Name || tmpTest.Name || tmpTest.Hash;
					tmpInjectableManifest.LineItemIDs = tmpTestDefault.IDLineItem ? [ tmpTestDefault.IDLineItem ] : [];
					tmpResults.push(tmpInjectableManifest);
					continue;
				}
				this.fable.log.warn(`No RNI or manifest found for default test ID ${tmpTestID} (hash: ${tmpTest.Hash}) for material ${pIDMaterial}`, { tmpTest });
				const tmpMissingTestEntry = Object.assign({}, tmpTest,
				{
					Enabled: true,
					IDTest: tmpTestID,
					SatisfiedIDTests: [tmpTestID],
					SatisfiedTestHashes: [tmpTest.Hash],
					LabID: tmpLabID,
					LabName: tmpLabName,
					DisplayName: tmpTest.Name || tmpTest.Hash,
					Missing: true,
					TestHash: tmpTest.Hash,
					LineItemIDs: tmpTestDefault.IDLineItem ? [ tmpTestDefault.IDLineItem ] : [],
				});
				tmpResults.push(tmpMissingTestEntry);
			}
		}
		let tmpReason = 'OK';
		if (tmpResults.length === 0)
		{
			if (tmpTestDefaults.length > 0)
			{
				tmpReason = 'TestsUnresolved';
			}
			else if (tmpSpecYear)
			{
				// The sampling plan was empty AND the spec-year fallback found nothing —
				// surface the fallback's specific reason (NoSpecYear / NoMatchingPayItems /
				// MaterialNotInPayItems / NoSpecYearTests).
				tmpReason = tmpSpecYear.Reason;
			}
			else
			{
				tmpReason = 'NoSamplingPlan';
			}
		}
		return {
			Tests: tmpResults,
			Reason: tmpReason,
			Diagnostics:
			{
				IDProject: pIDProject,
				IDMaterial: pIDMaterial,
				LineItemIDs: tmpLineItemIDs,
				SampleType: pSampleType,
				IDContract: tmpContract.IDContract,
				ItemSpecificationYear: tmpContract.ItemSpecificationYear,
				ResolvedMaterialIDs: tmpMaterialIDs,
				Source: tmpResolutionSource,
				SamplingPlanRowCount: tmpSamplingPlanRowCount,
				ResolvedTestCount: tmpResults.length,
				MissingFormCount: tmpResults.filter((r) => r.Missing).length,
				ResolvedLabIDs: Object.keys(tmpTestDefaultsByLab),
				TestLabAssignments: tmpTestLabAssignments,
				TestLabSources: tmpTestLabSources,
				AffinityLabIDs: tmpAffinityRootIDs,
				AssignableLabScope: tmpAllowedLabIDs ? { AllowedLabCount: tmpAllowedLabIDs.size, ParentLabIDs: tmpParentLabs.map((pLab) => pLab.IDLab), ChildLabIDs: tmpChildLabs.map((pLab) => pLab.IDLab) } : null,
				SpecYear: tmpSpecYear ? tmpSpecYear.Diagnostics : null,
			},
		};
	}

	/**
	 * Fallback test resolution from the contract's specification year, used when the
	 * sample's line items have no sampling plan (ProjectLineItemMaterialTest) for a material.
	 * Reads the spec-year requirements (PayItemMaterialTestRequirement — the
	 * pay-item / material / test / sample-type shape) and HARD-GATES on the
	 * sample's line items: a requirement is honored only when its pay item is one of
	 * those line items' pay items (matched by IDPayItem, or by ItemCode ->
	 * PayItem.ItemCode within the contract's spec set). Sample type is filtered
	 * against the sample's type (a blank requirement SampleType is treated as
	 * "any"). Returns the same `{ IDTest, IDMaterial }` shape the PLIMT branch
	 * produces so the downstream resolution is identical.
	 *
	 * @param {number} pIDMaterial - the sample's material
	 * @param {Array<number>} pMaterialIDs - the material and its parent chain
	 * @param {number} pIDProject
	 * @param {Record<string, any>} pContract - the project's contract
	 * @param {string} pSampleType - the sample's type to filter requirements by
	 * @param {Array<number>} pLineItemIDs - the sample's line items; only their pay items are honored
	 * @return {Promise<{ Tests: Array<Record<string, any>>, Reason: string, Diagnostics: Record<string, any> }>}
	 *   Reason: 'OK' | 'NoSpecYear' | 'NoMatchingPayItems' | 'MaterialNotInPayItems' | 'NoSpecYearTests'
	 */
	async _resolveSpecYearTestDefaults(pIDMaterial, pMaterialIDs, pIDProject, pContract, pSampleType, pLineItemIDs)
	{
		const tmpLineItemIDs = MaterialsFormManager.normalizeLineItemIDs(pLineItemIDs);
		const tmpDiagnostics = { IDProject: pIDProject, IDMaterial: pIDMaterial, LineItemIDs: tmpLineItemIDs, SampleType: pSampleType };
		// 1. Resolve the contract's ITEM specification set (explicit id, else by year).
		let tmpSpecSetID = pContract.ItemIDTestSpecificationSet > 0 ? pContract.ItemIDTestSpecificationSet : 0;
		if (!tmpSpecSetID && pContract.ItemSpecificationYear)
		{
			// See _resolveMaterialSpecificationSetID: a year can match a provisional set as well as the live one.
			const tmpSets = await this._getAll(`TestSpecificationSets/FilteredTo/FBV~IDCustomer~EQ~${pContract.IDCustomer}~FBV~Year~EQ~${encodeURIComponent(pContract.ItemSpecificationYear)}~FSF~IDTestSpecificationSet~ASC~0`);
			if (tmpSets.length > 1)
			{
				this.fable.log.warn(`Item specification year ${pContract.ItemSpecificationYear} matches ${tmpSets.length} specification sets for customer ${pContract.IDCustomer}; using the lowest id (${tmpSets[0].IDTestSpecificationSet}). Set the contract's ItemIDTestSpecificationSet to resolve this explicitly.`);
			}
			tmpSpecSetID = tmpSets.length > 0 ? tmpSets[0].IDTestSpecificationSet : 0;
		}
		tmpDiagnostics.IDTestSpecificationSet = tmpSpecSetID;
		if (!tmpSpecSetID)
		{
			return { Tests: [], Reason: 'NoSpecYear', Diagnostics: tmpDiagnostics };
		}
		// 2. The sample's line items (on this project) give the pay items, matched to the
		//    set's pay items by IDPayItem or ItemCode. Without a line item nothing is in scope.
		const tmpLineItems = tmpLineItemIDs.length > 0 ? await this._getAll(`LineItems/FilteredTo/FBV~IDProject~EQ~${pIDProject}~FBL~IDLineItem~INN~${tmpLineItemIDs.join(',')}`) : [];
		const tmpLineItemPayItemIDs = new Set(tmpLineItems.map((li) => li.IDPayItem).filter((id) => id > 0));
		const tmpLineItemCodes = new Set(tmpLineItems.map((li) => li.ItemCode).filter((c) => c != null && String(c).length > 0));
		tmpDiagnostics.ProjectLineItemCount = tmpLineItems.length;
		const tmpSetPayItems = await this._getAll(`PayItems/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpSpecSetID}`);
		const tmpScopedPayItemIDs = new Set(tmpSetPayItems
			.filter((pi) => tmpLineItemPayItemIDs.has(pi.IDPayItem) || tmpLineItemCodes.has(pi.ItemCode))
			.map((pi) => pi.IDPayItem));
		tmpDiagnostics.MatchedPayItemCount = tmpScopedPayItemIDs.size;
		if (tmpScopedPayItemIDs.size === 0)
		{
			return { Tests: [], Reason: 'NoMatchingPayItems', Diagnostics: tmpDiagnostics };
		}
		// 3. Spec-year requirements for the material (+ parents). Query by material
		//    (tiny list), then HARD-GATE to the line items' matched pay items in code.
		const tmpRequirements = await this._getAll(`PayItemMaterialTestRequirements/FilteredTo/FBL~IDMaterial~INN~${pMaterialIDs.join(',')}`);
		const tmpGatedRequirements = tmpRequirements.filter((r) => tmpScopedPayItemIDs.has(r.IDPayItem));
		tmpDiagnostics.PayItemGatedRequirementCount = tmpGatedRequirements.length;
		if (tmpGatedRequirements.length === 0)
		{
			return { Tests: [], Reason: 'MaterialNotInPayItems', Diagnostics: tmpDiagnostics };
		}
		// 4. Filter by sample type (a blank requirement SampleType means "any type"),
		//    then collapse to unique IDTest in the PLIMT-compatible shape.
		const tmpWantType = String(pSampleType || '').trim().toUpperCase();
		const tmpTests = [];
		const tmpSeenTestIDs = new Set();
		for (const tmpRequirement of tmpGatedRequirements)
		{
			const tmpRowType = String(tmpRequirement.SampleType || '').trim().toUpperCase();
			if (tmpRowType && tmpWantType && tmpRowType !== tmpWantType)
			{
				continue;
			}
			if (tmpRequirement.IDTest > 0 && !tmpSeenTestIDs.has(tmpRequirement.IDTest))
			{
				tmpSeenTestIDs.add(tmpRequirement.IDTest);
				tmpTests.push({ IDTest: tmpRequirement.IDTest, IDMaterial: tmpRequirement.IDMaterial, SampleType: tmpRequirement.SampleType, Source: 'SpecYear' });
			}
		}
		tmpDiagnostics.SpecYearTestCount = tmpTests.length;
		return { Tests: tmpTests, Reason: tmpTests.length > 0 ? 'OK' : 'NoSpecYearTests', Diagnostics: tmpDiagnostics };
	}

	async _getRNIForDocumentRecord(pDocumentRecord)
	{
		return (await this._getAvailableRNIs(pDocumentRecord.IDProject))?.find?.((rni) => rni.Hash === pDocumentRecord.DocumentType);
	}

	/**
	 * @param {Record<string, any>} pDocumentRecord
	 *
	 * @return {Promise<Record<string, any>>}
	 */
	async _getManifestForDocumentRecord(pDocumentRecord)
	{
		//FIXME: ...
		const tmpRNI = await this._getRNIForDocumentRecord(pDocumentRecord);
		if (!tmpRNI)
		{
			this.fable.log.warn(`No RNI found for document record`, { pDocumentRecord });
			return null;
		}
		return await this._loadFormManifest(tmpRNI);
	}

	/**
	 * Fetch the form manifest, if configured.
	 *
	 * NOTE: Mirrors the logic in report_definitions/global/server_js/mixins/document.pre-render-mixins.js#LoadFormManifest
	 *
	 * @param {any} pRNI - the ReportNamedInstance
	 *
	 * @return {Promise<Record<string, any>>} the form manifest object, or null
	 */
	async _loadFormManifest(pRNI)
	{
		const reportOptions = pRNI.Options;
		if (typeof reportOptions.FormDefinition === 'object')
		{
			return reportOptions.FormDefinition.DefaultFormManifest;
		}
		try
		{
			if (reportOptions.FormManifestSchemaID > 0)
			{
				return this.getManifestByID(reportOptions.FormManifestSchemaID).then((pManifestSchema) => pManifestSchema.Manifest);
			}
			if (reportOptions.FormManifestSchemaHash)
			{
				return this.getManifestByHash(reportOptions.FormManifestSchemaHash, pRNI.IDCustomer);
			}
		}
		catch (error)
		{
			this.fable.log.error(`Error loading form manifest: ${error}`);
		}
		return null;
	};

	/**
	 * Seed the sample-level Lab selector on a generated document.
	 *
	 * The Concierge resolves the sample's labs server-side, but a generated document is never driven
	 * through the interactive sample-selection chain that would otherwise derive them, so the Labs
	 * field renders empty. Writes the lab ids straight to the descriptor's address instead.
	 *
	 * The value is a comma-joined list of IDLab — the shape the Multiple entity selector parses
	 * (PictProvider-InputType-MaterialsEntitySelector splits a string value on commas). Per-test lab
	 * inputs (MaterialsTestLab*) are deliberately not matched; this is the sample-level field only.
	 *
	 * @param {Record<string, any>} pDocumentRecord - The document to seed (mutated in place).
	 * @param {Record<string, any>} pDocumentManifest - The already-resolved manifest for the document.
	 * @param {Array<number>} pLabIDs - The resolved lab ids for the sample.
	 *
	 * @return {string} the address written, or '' when the form has no lab selector
	 */
	_setSampleLabsInDocument(pDocumentRecord, pDocumentManifest, pLabIDs)
	{
		if (!Array.isArray(pLabIDs) || pLabIDs.length < 1 || !pDocumentManifest)
		{
			return '';
		}
		let tmpLabDescriptor;
		let tmpLabAddress = '';
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(pDocumentManifest.Descriptors || {}))
		{
			if (LAB_SELECTOR_INPUT_TYPES.indexOf(tmpDescriptor.PictForm?.InputType) < 0)
			{
				continue;
			}
			if (tmpLabDescriptor)
			{
				this.fable.log.warn(`Multiple sample lab selectors found in document manifest; seeding the first ('${tmpLabAddress}') and ignoring '${tmpDescriptor.DataAddress || tmpKey}'.`);
				continue;
			}
			tmpLabDescriptor = tmpDescriptor;
			tmpLabAddress = tmpDescriptor.DataAddress || tmpKey;
		}
		if (!tmpLabDescriptor)
		{
			// Not every generated form carries a Labs field; nothing to seed.
			return '';
		}
		const tmpUniqueLabIDs = Array.from(new Set(pLabIDs.map((pIDLab) => Number(pIDLab)).filter((pIDLab) => pIDLab > 0)));
		if (tmpUniqueLabIDs.length < 1)
		{
			return '';
		}
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpLabAddress, tmpUniqueLabIDs.join(','));
		return tmpLabAddress;
	}

	/**
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {string} [pGUIDSample]
	 * @param {Array<number>} [pLabIDs] - resolved lab ids for the sample, seeded into the form's Labs field
	 *
	 * @return {Promise<string>}
	 */
	async setSampleIdentityInDocument(pDocumentRecord, pGUIDSample, pLabIDs)
	{
		if (!pDocumentRecord)
		{
			throw new Error(`No document record provided to setSampleIdentityInDocument`);
		}
		if (!pDocumentRecord.GUIDDocument)
		{
			pDocumentRecord.GUIDDocument = this.fable.getUUID();
		}
		if (!pDocumentRecord.FormData)
		{
			pDocumentRecord.FormData = {};
		}
		if (!pDocumentRecord.FormData.__DynamicSectionData)
		{
			pDocumentRecord.FormData.__DynamicSectionData = {};
		}
		if (!Array.isArray(pDocumentRecord.FormData.__DynamicSectionData.Sequence))
		{
			pDocumentRecord.FormData.__DynamicSectionData.Sequence = [];
		}
		const tmpDocumentManifest = await this._getManifestForDocumentRecord(pDocumentRecord);
		if (pGUIDSample != null)
		{
			let tmpSampleSelectorDescriptor;
			if (tmpDocumentManifest)
			{
				for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDocumentManifest.Descriptors || {}))
				{
					if (tmpDescriptor.PictForm?.InputType === 'SampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsSampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenSampleSelector')
					{
						tmpSampleSelectorDescriptor = tmpDescriptor;
						if (!tmpSampleSelectorDescriptor.DataAddress)
						{
							tmpSampleSelectorDescriptor.DataAddress = tmpKey;
						}
					}
				}
				if (!tmpSampleSelectorDescriptor)
				{
					this.fable.log.warn(`No Sample Selector found in document manifest; defaulting to 'SampleID' address.`);
				}
			}
			else
			{
				this.fable.log.warn(`No document manifest found; defaulting to 'SampleID' address.`);
			}
			const tmpSampleAddress = tmpSampleSelectorDescriptor ? tmpSampleSelectorDescriptor.DataAddress : 'SampleID';
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleAddress, String(pGUIDSample));
			const tmpSampleSaltDataAddress = `${tmpSampleAddress}__Salt`;

			let tmpSampleSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress);
			if (!tmpSampleSalt)
			{
				tmpSampleSalt = this._generateSaltStr();
				this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress, tmpSampleSalt);
			}
			const tmpLabAddress = this._setSampleLabsInDocument(pDocumentRecord, tmpDocumentManifest, pLabIDs);
			if (tmpLabAddress)
			{
				this.fable.log.info(`Seeded ${tmpLabAddress} on document ${pDocumentRecord.GUIDDocument} with labs [${pLabIDs.join(',')}].`);
			}
			return tmpSampleSalt;
		}
		return null;
	}

	/**
	 * NOTE: does not save document
	 *
	 * @param {Array<Record<string, any>>} pTests - tests retrieved from getMaterialTestDefaults with Enabled flags set as desired
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {string} [pGUIDSample]
	 *
	 * @return {Promise<Record<string, Record<string, Record<string, any>>>>} - The updated document record with tests applied.
	 */
	async applyMaterialTestsToDocumentRecord(pTests, pDocumentRecord, pGUIDSample)
	{
		if (!pDocumentRecord)
		{
			throw new Error(`No document record provided to applyMaterialTestsToDocumentRecord`);
		}
		if (!pDocumentRecord.GUIDDocument)
		{
			pDocumentRecord.GUIDDocument = this.fable.getUUID();
		}
		if (!pDocumentRecord.FormData)
		{
			pDocumentRecord.FormData = {};
		}
		if (!pDocumentRecord.FormData.__DynamicSectionData)
		{
			pDocumentRecord.FormData.__DynamicSectionData = {};
		}
		if (!Array.isArray(pDocumentRecord.FormData.__DynamicSectionData.Sequence))
		{
			pDocumentRecord.FormData.__DynamicSectionData.Sequence = [];
		}
		const tmpDocumentManifest = await this._getManifestForDocumentRecord(pDocumentRecord);
		const tmpTestInputMap = { };
		if (pGUIDSample != null)
		{
			let tmpSampleSelectorDescriptor;
			if (tmpDocumentManifest)
			{
				for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDocumentManifest.Descriptors || {}))
				{
					if (tmpDescriptor.PictForm?.InputType === 'SampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsSampleSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenSampleSelector')
					{
						tmpSampleSelectorDescriptor = tmpDescriptor;
						if (!tmpSampleSelectorDescriptor.DataAddress)
						{
							tmpSampleSelectorDescriptor.DataAddress = tmpKey;
						}
					}
					if (tmpDescriptor.PictForm?.InputType === 'TestSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsTestSelector' ||
						tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenTestSelector')
					{
						if (tmpDescriptor.Default)
						{
							tmpTestInputMap[tmpDescriptor.Default] = tmpDescriptor;
						}
					}
				}
				if (!tmpSampleSelectorDescriptor)
				{
					this.fable.log.warn(`No Sample Selector found in document manifest; defaulting to 'SampleID' address.`);
				}
			}
			else
			{
				this.fable.log.warn(`No document manifest found; defaulting to 'SampleID' address.`);
			}
			const tmpSampleAddress = tmpSampleSelectorDescriptor ? tmpSampleSelectorDescriptor.DataAddress : 'SampleID';
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleAddress, String(pGUIDSample));
		}
		const tmpDynamicSectionData = pDocumentRecord.FormData.__DynamicSectionData;
		const tmpTestRecordComprehension =
		{
			TestInstance: { }, TestInstanceSampleJoin: { }, DocumentPolyJoin: { },
			Document:
			{
				[`${ pDocumentRecord.GUIDDocument }`]: { GUIDDocument: pDocumentRecord.GUIDDocument, IDProject: pDocumentRecord.IDProject }
			}
		};
		let tmpTestDescriptor;
		let tmpSampleDescriptor;
		if (tmpDocumentManifest)
		{
			for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDocumentManifest.Descriptors || {}))
			{
				if (tmpDescriptor.PictForm?.InputType === 'MaterialsTestSelector' ||
					tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenTestSelector')
				{
					tmpTestDescriptor = tmpDescriptor;
					if (!tmpTestDescriptor.DataAddress)
					{
						tmpTestDescriptor.DataAddress = tmpKey;
					}
					break;
				}
				if (tmpDescriptor.PictForm?.InputType === 'MaterialsSampleSelector' ||
					tmpDescriptor.PictForm?.InputType === 'MaterialsHiddenSampleSelector')
				{
					tmpSampleDescriptor = tmpDescriptor;
					if (!tmpSampleDescriptor.DataAddress)
					{
						tmpSampleDescriptor.DataAddress = tmpKey;
					}
					break;
				}
			}
		}
		this._addSampleToComprehension(pGUIDSample, pDocumentRecord, tmpSampleDescriptor, tmpTestRecordComprehension);
		for (const tmpTest of pTests)
		{
			if (!tmpTest.Enabled)
			{
				continue;
			}
			if (tmpTest.IDReportNamedInstance)
			{
				// we can't apply an RNI to an existing document; will be handled externally
				const tmpSatisfiedTestHashes = tmpTest.SatisfiedTestHashes || tmpTest.TestHashes || [];
				const tmpSatisfiedIDTests = tmpTest.SatisfiedIDTests || [];
				for (let tmpIdx = 0; tmpIdx < tmpSatisfiedTestHashes.length; tmpIdx++)
				{
					const tmpTestHash = tmpSatisfiedTestHashes[tmpIdx];
					const tmpTestDescriptor = tmpTestInputMap[tmpTestHash];
					if (!tmpTestDescriptor)
					{
						this.fable.log.error(`No test selector for test hash ${tmpTestHash} in the ${pDocumentRecord.DocumentType} manifest; its TestInstance is not linked to this document`, { IDReportNamedInstance: tmpTest.IDReportNamedInstance, TestHash: tmpTestHash });
						continue;
					}
					const tmpTestDataAddress = tmpTestDescriptor?.DataAddress;
					if (!tmpTestDataAddress)
					{
						this.fable.log.error(`No data address on the test selector for test hash ${tmpTestHash} in the ${pDocumentRecord.DocumentType} manifest; its TestInstance is not linked to this document`, { IDReportNamedInstance: tmpTest.IDReportNamedInstance, TestHash: tmpTestHash });
						continue;
					}
					// Reuse the existing salt if the document already has one for this
					// test slot, so the same TestInstance GUID is produced and the
					// comprehension upserts the existing record rather than creating a
					// duplicate.
					const tmpSampleSaltDataAddress = `${tmpTestDataAddress}__Salt`;
					let tmpSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress);
					if (!tmpSalt)
					{
						tmpSalt = this._generateSaltStr();
						this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress, tmpSalt);
					}
					const tmpHash = `${tmpSalt}_${tmpTestHash}`;
					// Standalone-form path: the test binds to a flat decorated selector whose DataAddress IS the record
					// base (the *-ladotd manifests carry only String selectors, no record/container address). Write flat
					// so the form reads the same salt and adopts the TestInstance; only the injectable dynamic-section
					// path below nests under <salt>_<testHash>.
					// Resolve the correct IDTest for this specific test hash
					const tmpIDTest = tmpSatisfiedIDTests[tmpIdx] || tmpTest.IDTest;
					const tmpTestInstanceForHash = tmpTest.TestInstance
						? Object.assign({}, tmpTest.TestInstance, { IDTest: tmpIDTest })
						: { IDTest: tmpIDTest };
					await this._addTestToComprehension({ TestHash: tmpTestHash, IDTest: tmpIDTest, TestInstance: tmpTestInstanceForHash }, pGUIDSample, { Hash: tmpHash, Flat: true }, pDocumentRecord, tmpTestDescriptor, tmpTestRecordComprehension);
				}
				continue;
			}
			if (tmpTest.IDManifestSchema || tmpTest.TestHash)
			{
				const tmpSalt = this._generateSaltStr();
				let tmpHash;
				if (tmpTest.TestHash)
				{
					// add manifest schema to document
					//FIXME: currently we are just adding the test hash, rework to add arbitrary manifest schemas?
					tmpHash = `${tmpSalt}_${tmpTest.TestHash}`;
					tmpDynamicSectionData.Sequence.push(tmpHash);
					tmpDynamicSectionData[tmpHash] =
					{
						Hash: tmpHash,
						SaltHash: tmpSalt,
						TestHash: tmpTest.TestHash,
					};
				}
				else
				{
					tmpHash = tmpSalt;
					tmpDynamicSectionData.Sequence.push(tmpHash);
					tmpDynamicSectionData[tmpHash] =
					{
						Hash: tmpHash,
						SaltHash: tmpSalt,
						IDManifestSchema: tmpTest.IDManifestSchema,
					};
				}
				await this._addTestToComprehension(tmpTest, pGUIDSample, tmpDynamicSectionData[tmpHash], pDocumentRecord, tmpTestDescriptor, tmpTestRecordComprehension);
			}
			else
			{
				this.fable.log.warn(`Unknown test type encountered in applyMaterialTestsToDocumentRecord`, { tmpTest });
			}
		}
		return tmpTestRecordComprehension;
	}

	/**
	 * @param {string} pGUIDSample
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {Record<string, any>} pSampleDescriptor
	 * @param {Record<string, Record<string, any>>} pTestRecordComprehension
	 */
	_addSampleToComprehension(pGUIDSample, pDocumentRecord, pSampleDescriptor, pTestRecordComprehension)
	{
		//TODO: support for multi-sample forms?
		const tmpSampleDataAddress = pSampleDescriptor?.DataAddress || 'SampleID';
		const tmpSampleSaltDataAddress = `${tmpSampleDataAddress}__Salt`;

		let tmpSampleSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress);
		if (!tmpSampleSalt)
		{
			tmpSampleSalt = this._generateSaltStr();
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpSampleSaltDataAddress, tmpSampleSalt);
		}
		const tmpDocumentPolyJoin =
		{
			GUIDDocumentPolyJoin: `${pDocumentRecord.GUIDDocument}-S_DPJ-${tmpSampleSalt}`,
			GUIDDocument: pDocumentRecord.GUIDDocument,
			RemoteType: 'Sample',
			_GUIDSample: pGUIDSample,
			_Dest__GUIDSample: 'IDRemote',
		};
		if (pDocumentRecord.IDDocument > 0)
		{
			tmpDocumentPolyJoin.IDDocument = pDocumentRecord.IDDocument;
		}
		else
		{
			tmpDocumentPolyJoin.GUIDDocument = pDocumentRecord.GUIDDocument;
		}
		pTestRecordComprehension.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
	}

	/**
	 * The write a record needs. A record that does not exist yet is written whole. An existing record
	 * may have been edited by someone else since it was read, so it carries only its identity and the
	 * fields that differ from the row as read — or nothing at all when no field does.
	 *
	 * @param {string} pEntity - The entity name, e.g. 'TestInstance'.
	 * @param {Record<string, any>} pRecordAsRead - A copy of the record taken before any change was applied.
	 * @param {Record<string, any>} pRecord - The record as it stands now.
	 *
	 * @return {Record<string, any> | null} the record to write, or null when there is nothing to write
	 */
	_getRecordWrite(pEntity, pRecordAsRead, pRecord)
	{
		const tmpIDField = `ID${pEntity}`;
		const tmpGUIDField = `GUID${pEntity}`;
		if (!(pRecord[tmpIDField] > 0))
		{
			return pRecord;
		}
		/** @type {Record<string, any>} */
		const tmpWrite = { [tmpIDField]: pRecord[tmpIDField] };
		let tmpHasChange = false;
		for (const [ tmpField, tmpValue ] of Object.entries(pRecord))
		{
			if (tmpField === tmpIDField || pRecordAsRead[tmpField] === tmpValue)
			{
				continue;
			}
			tmpWrite[tmpField] = tmpValue;
			tmpHasChange = true;
		}
		if (!tmpHasChange)
		{
			return null;
		}
		if (pRecord[tmpGUIDField])
		{
			tmpWrite[tmpGUIDField] = pRecord[tmpGUIDField];
		}
		return tmpWrite;
	}

	/**
	 * @param {Record<string, any>} pTest
	 * @param {string} pGUIDSample
	 * @param {Record<string, any>} pUniqueTestData
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {Record<string, any>} pTestDescriptor
	 * @param {Record<string, Record<string, any>>} pTestRecordComprehension
	 *
	 * @return {Promise<void>}
	 */
	async _addTestToComprehension(pTest, pGUIDSample, pUniqueTestData, pDocumentRecord, pTestDescriptor, pTestRecordComprehension)
	{
		if (!pGUIDSample)
		{
			this.fable.log.error(`No GUIDSample provided to _addTestToComprehension`, { pTest, pUniqueTestData, pDocumentRecord, pTestDescriptor });
			return;
		}
		const tmpTestDataAddressBase = pTestDescriptor?.DataAddress || 'TestID';
		// Injectable tests live in a dynamic section keyed <salt>_<testHash>; a standalone form binds the test to a
		// flat decorated selector whose DataAddress IS the record base. Nesting a standalone record under the
		// section key hides it from the flat selector, which then mints a second TestInstance on save (duplicate).
		const tmpTestDataAddress = pUniqueTestData.Flat ? tmpTestDataAddressBase : `${pUniqueTestData.Hash}.${tmpTestDataAddressBase}`;
		const tmpTestSaltDataAddress = `${tmpTestDataAddress}__Salt`;
		const tmpTestInstanceDataAddress = `${tmpTestDataAddress}__Record_Instance`;
		const tmpTestInstanceSampleJoinDataAddress = `${tmpTestDataAddress}__Record_SampleJoin`;
		const tmpDocumentPolyJoinDataAddress = `${tmpTestDataAddress}__Record_DocumentPolyJoin`;

		let tmpTestSalt = this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpTestSaltDataAddress);
		if (!tmpTestSalt)
		{
			tmpTestSalt = this._generateSaltStr();
			this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpTestSaltDataAddress, tmpTestSalt);
		}
		let tmpTestInstance = pTest.TestInstance
			|| this.fable.Utility.getValueByHash(pDocumentRecord.FormData, tmpTestInstanceDataAddress)
			|| { };
		const tmpTestInstanceAsRead = Object.assign({ }, tmpTestInstance);
		if (!tmpTestInstance.GUIDTestInstance)
		{
			tmpTestInstance.GUIDTestInstance = `${pDocumentRecord.GUIDDocument}-TI-${tmpTestSalt}`;
		}
		if (!tmpTestInstance.IDTest)
		{
			tmpTestInstance.IDTest = pTest.IDTest || (await this._getTestByHash(pTest.TestHash))?.IDTest || 0;
		}
		if (!tmpTestInstance.IDTest)
		{
			this.fable.log.error(`Could not resolve IDTest for test in applyMaterialTestsToDocumentRecord`, { pTest });
			return;
		}
		if (!(tmpTestInstance.IDTestInstance > 0) && !tmpTestInstance.Name && pTest.TestHash)
		{
			tmpTestInstance.Name = `Sample Test for ${pTest.TestHash}`;
		}
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpTestInstanceDataAddress, tmpTestInstance);
		let tmpTestInstanceSampleJoin;
		if (tmpTestInstance.IDTestInstance > 0)
		{
			const tmpSample = await this._get(`Samples/FilteredTo/FBV~GUIDSample~EQ~${encodeURIComponent(pGUIDSample)}`).then((res) => res[0]);
			if (tmpSample)
			{
				tmpTestInstanceSampleJoin = await this._get(`TestInstanceSampleJoins/FilteredTo/FBV~IDTestInstance~EQ~${tmpTestInstance.IDTestInstance}~FBV~IDSample~EQ~${tmpSample.IDSample}`).then((res) => res[0]);
			}
		}
		if (!tmpTestInstanceSampleJoin)
		{
			tmpTestInstanceSampleJoin =
			{
				GUIDTestInstanceSampleJoin: `${pDocumentRecord.GUIDDocument}-TISJ-${tmpTestSalt}`,
				GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
				_GUIDSample: pGUIDSample,
			};
		}
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpTestInstanceSampleJoinDataAddress, tmpTestInstanceSampleJoin);
		const tmpDocumentPolyJoin =
		{
			GUIDDocumentPolyJoin: `${pDocumentRecord.GUIDDocument}-TI_DPJ-${tmpTestSalt}`,
			RemoteType: 'TestInstance',
			GUIDDocument: pDocumentRecord.GUIDDocument,
			GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
			_Dest_GUIDTestInstance: 'IDRemote',

		};
		this.fable.Utility.setValueByHash(pDocumentRecord.FormData, tmpDocumentPolyJoinDataAddress, tmpDocumentPolyJoin);
		// The joins carry the instance's GUID, which the processor resolves from the server when the instance is not written here.
		const tmpTestInstanceWrite = this._getRecordWrite('TestInstance', tmpTestInstanceAsRead, tmpTestInstance);
		if (tmpTestInstanceWrite)
		{
			pTestRecordComprehension.TestInstance[tmpTestInstance.GUIDTestInstance] = tmpTestInstanceWrite;
		}
		if (!(tmpTestInstanceSampleJoin.IDTestInstanceSampleJoin > 0))
		{
			pTestRecordComprehension.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
		}
		pTestRecordComprehension.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
	}

	/**
	 * @typedef {Object} TestSectionDescriptor
	 * @property {string} Hash - the section's registration hash
	 * @property {string} [SaltHash]
	 * @property {string} [TestHash]
	 * @property {number} [IDManifestSchema]
	 * @property {number} IDTest - from the section's __Record_Instance bookkeeping (0 when unknown)
	 * @property {string} [GUIDTestInstance]
	 * @property {string} [GUIDDocumentPolyJoin]
	 * @property {boolean} ConciergeManaged - true when the section carries __Record_Instance bookkeeping
	 * @property {string} [RemovedTime] - present on tombstoned sections
	 */

	/**
	 * Describe one dynamic test section of a document record.
	 *
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {string} pSectionHash
	 * @param {Record<string, any>} pSectionEntry - the section's registration entry (from __DynamicSectionData or __RemovedSectionData)
	 *
	 * @return {TestSectionDescriptor}
	 */
	_describeTestSection(pDocumentRecord, pSectionHash, pSectionEntry)
	{
		const tmpDescriptor =
		{
			Hash: pSectionHash,
			SaltHash: pSectionEntry?.SaltHash,
			TestHash: pSectionEntry?.TestHash,
			IDManifestSchema: pSectionEntry?.IDManifestSchema,
			IDTest: 0,
			GUIDTestInstance: undefined,
			GUIDDocumentPolyJoin: undefined,
			ConciergeManaged: false,
			RemovedTime: pSectionEntry?.RemovedTime,
		};
		const tmpSectionData = pDocumentRecord?.FormData?.[pSectionHash];
		if (tmpSectionData && typeof tmpSectionData === 'object')
		{
			for (const tmpKey of Object.keys(tmpSectionData))
			{
				if (tmpKey.endsWith('__Record_Instance'))
				{
					tmpDescriptor.ConciergeManaged = true;
					tmpDescriptor.IDTest = Number(tmpSectionData[tmpKey]?.IDTest) || 0;
					tmpDescriptor.GUIDTestInstance = tmpSectionData[tmpKey]?.GUIDTestInstance;
				}
				else if (tmpKey.endsWith('__Record_DocumentPolyJoin'))
				{
					tmpDescriptor.GUIDDocumentPolyJoin = tmpSectionData[tmpKey]?.GUIDDocumentPolyJoin;
				}
			}
		}
		return tmpDescriptor;
	}

	/**
	 * Enumerate a document record's dynamic test sections: Active (registered in
	 * __DynamicSectionData.Sequence) and Removed (tombstoned in __RemovedSectionData).
	 *
	 * @param {Record<string, any>} pDocumentRecord
	 *
	 * @return {{ Active: Array<TestSectionDescriptor>, Removed: Array<TestSectionDescriptor> }}
	 */
	listTestSectionsInDocumentRecord(pDocumentRecord)
	{
		const tmpResult = { Active: [], Removed: [] };
		const tmpFormData = pDocumentRecord?.FormData;
		if (!tmpFormData)
		{
			return tmpResult;
		}
		const tmpDynamicSectionData = tmpFormData.__DynamicSectionData || { };
		const tmpSequence = Array.isArray(tmpDynamicSectionData.Sequence) ? tmpDynamicSectionData.Sequence : [];
		for (const tmpSectionHash of tmpSequence)
		{
			if (tmpDynamicSectionData[tmpSectionHash])
			{
				tmpResult.Active.push(this._describeTestSection(pDocumentRecord, tmpSectionHash, tmpDynamicSectionData[tmpSectionHash]));
			}
		}
		const tmpRemovedSectionData = tmpFormData.__RemovedSectionData || { };
		for (const tmpSectionHash of Object.keys(tmpRemovedSectionData))
		{
			tmpResult.Removed.push(this._describeTestSection(pDocumentRecord, tmpSectionHash, tmpRemovedSectionData[tmpSectionHash]));
		}
		return tmpResult;
	}

	/**
	 * NOTE: does not save document
	 *
	 * Remove dynamic test sections from a document record by section hash. Each
	 * section's registration moves from __DynamicSectionData (and its Sequence)
	 * to a __RemovedSectionData tombstone; the section's entered data under
	 * FormData[<hash>] is left in place so removal is recoverable.
	 *
	 * @param {Record<string, any>} pDocumentRecord
	 * @param {Array<string>} pSectionHashes
	 *
	 * @return {Array<TestSectionDescriptor>} descriptors of the sections actually removed
	 */
	removeTestSectionsFromDocumentRecord(pDocumentRecord, pSectionHashes)
	{
		if (!pDocumentRecord)
		{
			throw new Error(`No document record provided to removeTestSectionsFromDocumentRecord`);
		}
		const tmpRemoved = [];
		const tmpDynamicSectionData = pDocumentRecord.FormData?.__DynamicSectionData;
		if (!tmpDynamicSectionData || !Array.isArray(pSectionHashes) || pSectionHashes.length === 0)
		{
			return tmpRemoved;
		}
		const tmpRemovedTime = new Date().toISOString();
		for (const tmpSectionHash of pSectionHashes)
		{
			const tmpSectionEntry = tmpDynamicSectionData[tmpSectionHash];
			if (!tmpSectionEntry)
			{
				continue;
			}
			if (!pDocumentRecord.FormData.__RemovedSectionData)
			{
				pDocumentRecord.FormData.__RemovedSectionData = { };
			}
			pDocumentRecord.FormData.__RemovedSectionData[tmpSectionHash] = Object.assign({ }, tmpSectionEntry, { RemovedTime: tmpRemovedTime });
			delete tmpDynamicSectionData[tmpSectionHash];
			tmpRemoved.push(this._describeTestSection(pDocumentRecord, tmpSectionHash, pDocumentRecord.FormData.__RemovedSectionData[tmpSectionHash]));
		}
		if (tmpRemoved.length > 0 && Array.isArray(tmpDynamicSectionData.Sequence))
		{
			const tmpRemovedHashes = new Set(tmpRemoved.map((pSection) => pSection.Hash));
			tmpDynamicSectionData.Sequence = tmpDynamicSectionData.Sequence.filter((pSequenceHash) => !tmpRemovedHashes.has(pSequenceHash));
		}
		return tmpRemoved;
	}

	/**
	 * @param {string} pTestHash - The test hash to get.
	 *
	 * @return {Promise<Record<string, any>>} - The test record for the test hash.
	 */
	async _getTestByHash(pTestHash)
	{
		return await this._get(`Tests/FilteredTo/FBV~Hash~EQ~${pTestHash}`).then((res) => res[0]);
	}

	/**
	 * @param {number} pIDTest - The test ID to get the manifest or RNI for.
	 * @param {number} pIDProject - The Sample's project.
	 * @param {number} pIDMaterial - The Sample's material.
	 *
	 * @return {Promise<Record<string, any>>} - The manifest or RNI for the test ID.
	 */
	async getTestDefinitionForTestID(pIDTest, pIDProject, pIDMaterial)
	{
		// get RNIs
		const tmpRNIs = await this._getAvailableRNIs(pIDProject);
		/**
		 * @type {object|null}
		 */
		let tmpManifest = null;
		const test = await new Promise((resolve, reject) =>
		{
			this.client.getJSON(`Test/${ pIDTest }`, async (pError, pBody) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Test: ${ pError }`, pError);
					return reject(pError);
				}
				if (!pBody)
				{
					this.fable.log.error(`No Test found for ID: ${ pIDTest }`);
					return reject(new Error(`No Test found for ID: ${ pIDTest }`));
				}
				// Use the join-aware resolver so the join table is consulted on this hot path.
				tmpManifest = await this._resolveManifestForTestRecord(pBody);
				resolve(pBody);
			});
		});

		let tmpFallbackRNI;
		for (const tmpRNI of tmpRNIs)
		{
			if (tmpRNI.Options.TestHash == test.Hash)
			{
				tmpRNI.Enabled = true;
				tmpRNI.DisplayName = `Default Test RNI: ${tmpRNI.Name}`;
				tmpRNI.TestHash = tmpRNI.Options.TestHash;
				tmpRNI.TestHashes = tmpRNI.Options.TestHashes;
				tmpRNI.IDTest = pIDTest;
				tmpRNI.SatisfiedIDTests = [pIDTest];
				tmpRNI.SatisfiedTestHashes = [test.Hash];
				return tmpRNI;
			}
			if (Array.isArray(tmpRNI.Options.TestHashes) && tmpRNI.Options.TestHashes.includes(test.Hash))
			{
				tmpFallbackRNI = tmpRNI;
			}
		}
		if (tmpFallbackRNI)
		{
			tmpFallbackRNI.Enabled = true;
			tmpFallbackRNI.DisplayName = `Default Test RNI: ${tmpFallbackRNI.Name}`;
			tmpFallbackRNI.TestHash = test.Hash;
			tmpFallbackRNI.TestHashes = tmpFallbackRNI.Options.TestHashes;
			tmpFallbackRNI.IDTest = pIDTest;
			tmpFallbackRNI.SatisfiedIDTests = [pIDTest];
			tmpFallbackRNI.SatisfiedTestHashes = [test.Hash];
			return tmpFallbackRNI;
		}

		if (tmpManifest)
		{
			tmpManifest.Enabled = true;
			tmpManifest.DisplayName = `Test Hash: ${test.Hash}`;
			tmpManifest.TestHash = test.Hash;
			tmpManifest.TestHashes = [tmpManifest.TestHash];
			tmpManifest.IDTest = pIDTest;
			tmpManifest.SatisfiedIDTests = [pIDTest];
			tmpManifest.SatisfiedTestHashes = [test.Hash];
			return tmpManifest;
		}

		this.fable.log.warn(`No manifest or RNI found for Test ID: ${ pIDTest }`);
		const tmpMissingTestEntry = Object.assign({}, test,
		{
			Enabled: true,
			IDTest: pIDTest,
			SatisfiedIDTests: [pIDTest],
			SatisfiedTestHashes: [test.Hash],
			//LabID: Number(tmpIDLab),
			//LabName: tmpIDLab == '0' ? '' : (tmpParentLabs.find((lab) => lab.IDLab === Number(tmpIDLab)) || {}).Name || `Lab ${tmpIDLab}`,
			DisplayName: test.Name || test.Hash,
			Missing: true,
			TestHash: test.Hash,
		});

		return tmpMissingTestEntry;
	}

	/**
	 * Resolve the ManifestSchema for a given Test ID.
	 *
	 * Resolution order (added 2026-04 to address ManifestSchema hash collisions caused by the
	 * spec-year-2026 overlay deployment):
	 *
	 *   1. Look up TestManifestSchemaJoin rows for this IDTest (scoped by IDCustomer).
	 *      - Exactly 1 join row → deterministic binding; fetch the MS by ID and return.
	 *      - Multiple rows → data error per design; log.fatal and return the lowest-ID match defensively.
	 *      - Zero rows OR the join lookup hard-errors (e.g. table doesn't exist yet pre-migration) →
	 *        fall through to the legacy Hash-based path below. This is the safe-degrade path that
	 *        protects against deployment-order issues (code shipping ahead of schema migration).
	 *   2. Legacy: Test.Hash → getManifestForTestHash → getManifestByHash. First-match-wins on
	 *      collisions (Materials-Form-Manager.js:1110); this is the silent-ambiguity path that
	 *      the join table is here to eliminate for known-collision cases.
	 *
	 * Background: ~/dev/lims_test_routing_investigation_2026-04-28.md §9.1.
	 *
	 * @param {number} pTestID - The test ID to get the manifest for.
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test ID.
	 */
	async getManifestForTestID(pTestID)
	{
		if (!pTestID)
		{
			this.fable.log.error('No Test ID provided.');
			throw new Error('No Test ID provided.');
		}

		// Fetch the Test record (need its IDCustomer for the customer-scoped join lookup,
		// and its Hash for the legacy fallback).
		const tmpTest = await new Promise((resolve, reject) =>
		{
			this.client.getJSON(`Test/${pTestID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Test: ${pError}`, pError);
					return reject(pError);
				}
				if (!pBody)
				{
					this.fable.log.error(`No Test found for ID: ${pTestID}`);
					return reject(new Error(`No Test found for ID: ${pTestID}`));
				}
				return resolve(pBody);
			});
		});

		return this._resolveManifestForTestRecord(tmpTest);
	}

	/**
	 * Resolve a ManifestSchema given an already-fetched Test record. This is the join-aware
	 * resolution path used by both `getManifestForTestID` (after fetching the Test) and internal
	 * call sites in `getMaterialTestDefaults` etc. that already hold a Test record (avoids a
	 * redundant Test refetch on hot paths).
	 *
	 * Resolution order matches `getManifestForTestID`:
	 *   1. TestManifestSchemaJoin lookup by (IDTest, IDCustomer) — preferred, deterministic.
	 *   2. Hash-based lookup via `getManifestForTestHash(Test.Hash)` — legacy fallback.
	 *
	 * Fail-soft: any error in (1) is logged as warn and falls through to (2). Multiple rows in (1)
	 * is a data error — log.fatal fires and the lowest-ID match is returned defensively.
	 *
	 * @param {Record<string, any>} pTest - the Test record (must have IDTest, IDCustomer, Hash)
	 * @return {Promise<Record<string, any>>} the resolved ManifestSchema
	 */
	async _resolveManifestForTestRecord(pTest)
	{
		if (!pTest || !pTest.IDTest)
		{
			throw new Error('No Test record provided to _resolveManifestForTestRecord.');
		}

		let tmpJoinRows = null;
		try
		{
			tmpJoinRows = await new Promise((resolve, reject) =>
			{
				this.client.getJSON(`TestManifestSchemaJoins/FilteredTo/FBV~IDTest~EQ~${pTest.IDTest}~FBV~IDCustomer~EQ~${pTest.IDCustomer}/0/2`,
					(pError, pBody) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						return resolve(Array.isArray(pBody) ? pBody : []);
					});
			});
		}
		catch (pError)
		{
			// Likely causes: table doesn't exist yet (migration hasn't run), endpoint not wired,
			// transient API failure. Don't fail the form lookup — fall through to legacy Hash-based
			// resolution which preserves pre-2026-04 behavior.
			this.fable.log.warn(`TestManifestSchemaJoin lookup failed for IDTest ${pTest.IDTest}; falling back to legacy Hash-based lookup. Expected if schema migration has not yet applied.`,
				{ IDTest: pTest.IDTest, error: pError && pError.message });
			tmpJoinRows = null;
		}

		if (Array.isArray(tmpJoinRows) && tmpJoinRows.length === 1)
		{
			return this.getManifestByID(tmpJoinRows[0].IDManifestSchema);
		}
		if (Array.isArray(tmpJoinRows) && tmpJoinRows.length > 1)
		{
			// Data error per design — TestManifestSchemaJoin is meant to be 1:1 per (IDTest, IDCustomer).
			// Deterministic recovery: pick the lowest IDManifestSchema. Page oncall via log.fatal.
			this.fable.log.fatal(`Multiple TestManifestSchemaJoin rows for IDTest ${pTest.IDTest} (IDCustomer ${pTest.IDCustomer}); expected at most 1`,
				{ IDTest: pTest.IDTest, IDCustomer: pTest.IDCustomer, JoinRows: tmpJoinRows });
			const tmpFirst = [ ...tmpJoinRows ].sort((a, b) => a.IDManifestSchema - b.IDManifestSchema)[0];
			return this.getManifestByID(tmpFirst.IDManifestSchema);
		}

		// Legacy fallback: Hash-based MS lookup.
		return this.getManifestForTestHash(pTest.Hash);
	}

	/**
	 * @param {string} pManifestSchemaHash - The manifest schema hash to get.
	 * @param {number} pCustomerID - The customer ID for scoping.
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test hash.
	 */
	async getManifestByHash(pManifestSchemaHash, pCustomerID)
	{
		return new Promise((resolve, reject) =>
		{
			this.client.getJSON(`ManifestSchemas/FilteredTo/FBV~Hash~EQ~${pManifestSchemaHash}`, (pError, pManifestSchemas) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Manifest Schema for hash: ${pManifestSchemaHash}`, pError);
					return reject(pError);
				}
				if (!pManifestSchemas || !Array.isArray(pManifestSchemas) || pManifestSchemas.length === 0)
				{
					this.fable.log.error(`No Manifest Schema found for hash: ${pManifestSchemaHash}`);
					return reject(new Error(`No Manifest Schema found for hash: ${pManifestSchemaHash}`));
				}
				const tmpManifestSchema = pManifestSchemas.find((ms) => ms.IDCustomer == pCustomerID) || pManifestSchemas[0];
				//TODO: consolidate this with getManifestByID below
				this.client.getEntitySetWithPages('ManifestSchemaManifestSchemaPartialJoin', `FBV~IDManifestSchema~EQ~${tmpManifestSchema.IDManifestSchema}`,
					() => { }, () => { }, (pError, pManifestSchemaManifestSchemaPartialJoins) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error getting Manifest Schema Partial Joins for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`, pError);
						return reject(pError);
					}
					if (!pManifestSchemaManifestSchemaPartialJoins || !Array.isArray(pManifestSchemaManifestSchemaPartialJoins))
					{
						this.fable.log.error(`Invalid response for Manifest Schema Partial Joins.`);
						return reject(new Error(`Invalid response for Manifest Schema Partial Joins.`));
					}
					const tmpAnticipate = this.fable.newAnticipate();

					const tmpManifestSchemaPartialsByIDManifestSchema = {};
					const chunkSize = 100;
					for (let i = 0; i < pManifestSchemaManifestSchemaPartialJoins.length; i += chunkSize)
					{
						const chunk = pManifestSchemaManifestSchemaPartialJoins.slice(i, i + chunkSize);
						tmpAnticipate.anticipate(
							(fRequestCallback) =>
							{
								this.client.getEntitySetWithPages('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${chunk.map((ms) => ms.IDManifestSchemaPartial).join(',')}`,
									() => { }, () => { }, (pError, pManifestSchemaPartials) =>
								{
									if (pError)
									{
										this.fable.log.error(`Error getting Manifest Schema Partials for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`, pError);
										return fRequestCallback(pError);
									}
									if (!pManifestSchemaPartials || !Array.isArray(pManifestSchemaPartials))
									{
										this.fable.log.error(`Invalid response for Manifest Schema Partials.`);
										return fRequestCallback(pError);
									}
									if (pManifestSchemaPartials.length !== chunk.length)
									{
										this.fable.log.warn(`Mismatch in expected Manifest Schema Partials returned. Expected: ${chunk.length}, Received: ${pManifestSchemaPartials.length}`);
									}
									for (const tmpJoin of chunk)
									{
										const tmpManifestSchemaPartial = pManifestSchemaPartials.find((msp) => msp.IDManifestSchemaPartial === tmpJoin.IDManifestSchemaPartial);
										if (!tmpManifestSchemaPartial)
										{
											this.fable.log.warn(`Manifest Schema Partial not found for ID: ${tmpJoin.IDManifestSchemaPartial}`);
											continue;
										}
										if (!tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema])
										{
											tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema] = [];
										}
										tmpManifestSchemaPartial.Ordinal = tmpJoin.Ordinal;
										tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema].push(tmpManifestSchemaPartial);
									}
									fRequestCallback();
								});
							});
					}
					tmpAnticipate.wait(
						(pError) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error caching Test manifest for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`, pError);
								return reject(pError);
							}
							/** @type {Record<string, any>} */
							const tmpPartials = tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchema.IDManifestSchema] || [];
							tmpPartials.sort((a, b) => a.Ordinal - b.Ordinal);
							let tmpMergedConfig = this.fable.services.ManifestPackagingService._mergeManifests(tmpManifestSchema, tmpPartials)?.DefaultFormManifest;
							if (!tmpMergedConfig)
							{
								this.fable.log.error(`Manifest merge failed for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`);
							}
							this._decorateManifestSchema(tmpManifestSchema);
							tmpManifestSchema.Manifest = tmpMergedConfig;
							resolve(tmpManifestSchema);
						},
					);
				});
			});
		});
	}

	/**
	 * @param {number} pManifestSchemaID
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test hash.
	 */
	async getManifestByID(pManifestSchemaID)
	{
		return new Promise((resolve, reject) =>
		{
			this.client.getJSON(`ManifestSchema/${pManifestSchemaID}`, (pError, pManifestSchema) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting Manifest Schema ID: ${pManifestSchemaID}`, pError);
					return reject(pError);
				}
				if (!pManifestSchema)
				{
					this.fable.log.error(`Invalid response for Manifest Schema.`);
					return reject(new Error(`Invalid response for Manifest Schema.`));
				}
				this.client.getEntitySetWithPages('ManifestSchemaManifestSchemaPartialJoin', `FBV~IDManifestSchema~EQ~${pManifestSchemaID}`,
					() => { }, () => { }, (pError, pManifestSchemaManifestSchemaPartialJoins) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error getting Manifest Schema Partial Joins for Manifest Schema ID: ${pManifestSchemaID}`, pError);
						return reject(pError);
					}
					if (!pManifestSchemaManifestSchemaPartialJoins || !Array.isArray(pManifestSchemaManifestSchemaPartialJoins))
					{
						this.fable.log.error(`Invalid response for Manifest Schema Partial Joins.`);
						return reject(new Error(`Invalid response for Manifest Schema Partial Joins.`));
					}
					const tmpAnticipate = this.fable.newAnticipate();

					const tmpManifestSchemaPartialsByIDManifestSchema = {};
					const chunkSize = 100;
					for (let i = 0; i < pManifestSchemaManifestSchemaPartialJoins.length; i += chunkSize)
					{
						const chunk = pManifestSchemaManifestSchemaPartialJoins.slice(i, i + chunkSize);
						tmpAnticipate.anticipate(
							(fRequestCallback) =>
							{
								this.client.getEntitySetWithPages('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${chunk.map((ms) => ms.IDManifestSchemaPartial).join(',')}`,
									() => { }, () => { }, (pError, pManifestSchemaPartials) =>
								{
									if (pError)
									{
										this.fable.log.error(`Error getting Manifest Schema Partials for Manifest Schema ID: ${pManifestSchemaID}`, pError);
										return fRequestCallback(pError);
									}
									if (!pManifestSchemaPartials || !Array.isArray(pManifestSchemaPartials))
									{
										this.fable.log.error(`Invalid response for Manifest Schema Partials.`);
										return fRequestCallback(pError);
									}
									if (pManifestSchemaPartials.length !== chunk.length)
									{
										this.fable.log.warn(`Mismatch in expected Manifest Schema Partials returned. Expected: ${chunk.length}, Received: ${pManifestSchemaPartials.length}`);
									}
									for (const tmpJoin of chunk)
									{
										const tmpManifestSchemaPartial = pManifestSchemaPartials.find((msp) => msp.IDManifestSchemaPartial === tmpJoin.IDManifestSchemaPartial);
										if (!tmpManifestSchemaPartial)
										{
											this.fable.log.warn(`Manifest Schema Partial not found for ID: ${tmpJoin.IDManifestSchemaPartial}`);
											continue;
										}
										if (!tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema])
										{
											tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema] = [];
										}
										tmpManifestSchemaPartial.Ordinal = tmpJoin.Ordinal;
										tmpManifestSchemaPartialsByIDManifestSchema[tmpJoin.IDManifestSchema].push(tmpManifestSchemaPartial);
									}
									fRequestCallback();
								});
							});
					}
					tmpAnticipate.wait(
						(pError) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error caching Test manifest for Manifest Schema ID: ${pManifestSchemaID}`, pError);
								return reject(pError);
							}
							/** @type {Record<string, any>} */
							const tmpPartials = tmpManifestSchemaPartialsByIDManifestSchema[pManifestSchema.IDManifestSchema] || [];
							tmpPartials.sort((a, b) => a.Ordinal - b.Ordinal);
							let tmpMergedConfig = this.fable.services.ManifestPackagingService._mergeManifests(pManifestSchema, tmpPartials)?.DefaultFormManifest;
							if (!tmpMergedConfig)
							{
								this.fable.log.error(`Manifest merge failed for Manifest Schema ID: ${pManifestSchema.IDManifestSchema}`);
							}
							this._decorateManifestSchema(pManifestSchema);
							pManifestSchema.Manifest = tmpMergedConfig;
							resolve(pManifestSchema);
						},
					);
				});
			});
		});
	}

	/**
	 * @param {string} pTestHash - The test hash to get the manifest for.
	 * @param {Record<string, Record<string, any>>} [pOverrideManifestMap] - An optional manifest map to override the default one
	 *
	 * @return {Promise<Record<string, any>>} - The manifest for the test hash.
	 */
	async getManifestForTestHash(pTestHash, pOverrideManifestMap)
	{
		if (pOverrideManifestMap && pOverrideManifestMap[pTestHash])
		{
			return JSON.parse(JSON.stringify({ Manifest: pOverrideManifestMap[pTestHash]}));
		}
		let tmpTestManifestCache = this.fable.AppData._TestManifestCache;
		if (tmpTestManifestCache)
		{
			return tmpTestManifestCache[pTestHash] ? JSON.parse(JSON.stringify(tmpTestManifestCache[pTestHash])) : null;
		}
		return new Promise((resolve, reject) =>
		{
			this.client.getEntitySetWithPages('ManifestSchema', 'FBV~Type~EQ~Test', () => { }, () => { }, (pError, pManifestSchemas) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error caching Test manifest schemas for Test Hash: ${pTestHash}`, pError);
					return reject(pError);
				}
				if (!pManifestSchemas || !Array.isArray(pManifestSchemas))
				{
					this.fable.log.error(`No Manifest Schemas found for Tests.`);
					return reject(new Error(`No Manifest Schemas found for Tests.`));
				}

				this.client.getEntitySetWithPages('ManifestSchemaManifestSchemaPartialJoin', `FBL~IDManifestSchema~INN~${pManifestSchemas.map((ms) => ms.IDManifestSchema).join(',')}`,
					() => { }, () => { }, (pError, pManifestSchemaManifestSchemaPartialJoins) =>
				{
					if (pError)
					{
						this.fable.log.error(`Error caching Test manifest schema partials for Test Hash: ${pTestHash}`, pError);
						return reject(pError);
					}
					if (!pManifestSchemaManifestSchemaPartialJoins || !Array.isArray(pManifestSchemaManifestSchemaPartialJoins))
					{
						this.fable.log.error(`Invalid response for Manifest Schema Partial Joins.`);
						return reject(new Error(`Invalid response for Manifest Schema Partial Joins.`));
					}
					const tmpAnticipate = this.fable.newAnticipate();

					const tmpManifestSchemaPartialsByIDManifestSchema = {};
					const chunkSize = 100;
					for (let i = 0; i < pManifestSchemaManifestSchemaPartialJoins.length; i += chunkSize)
					{
						const chunk = pManifestSchemaManifestSchemaPartialJoins.slice(i, i + chunkSize);
						tmpAnticipate.anticipate(
							(fRequestCallback) =>
							{
								this.client.getEntitySetWithPages('ManifestSchemaPartial', `FBL~IDManifestSchemaPartial~INN~${chunk.map((ms) => ms.IDManifestSchemaPartial).join(',')}`,
									() => { }, () => { }, (pError, pManifestSchemaPartials) =>
								{
									if (pError)
									{
										this.fable.log.error(`Error caching Test manifest schema partials for Test Hash: ${pTestHash}`, pError);
										return fRequestCallback(pError);
									}
									if (!pManifestSchemaPartials || !Array.isArray(pManifestSchemaPartials))
									{
										this.fable.log.error(`Invalid response for Manifest Schema Partials.`);
										return fRequestCallback(pError);
									}
									if (pManifestSchemaPartials.length !== chunk.length)
									{
										this.fable.log.warn(`Mismatch in expected Manifest Schema Partials returned. Expected: ${chunk.length}, Received: ${pManifestSchemaPartials.length}`);
									}
									for (const tmpManifestSchemaPartial of pManifestSchemaPartials)
									{
										if (!tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchemaPartial.IDManifestSchema])
										{
											tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchemaPartial.IDManifestSchema] = [];
										}
										tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchemaPartial.IDManifestSchema].push(tmpManifestSchemaPartial);
									}
									fRequestCallback();
								});
							});
					}
					tmpAnticipate.wait(
						(pError) =>
						{
							if (pError)
							{
								this.fable.log.error(`Error caching Test manifest for Test Hash: ${pTestHash}`, pError);
								return reject(pError);
							}
							tmpTestManifestCache = {};
							for (const tmpManifestSchema of pManifestSchemas)
							{
								let tmpMergedConfig = this.fable.services.ManifestPackagingService._mergeManifests(tmpManifestSchema, tmpManifestSchemaPartialsByIDManifestSchema[tmpManifestSchema.IDManifestSchema] || [])?.DefaultFormManifest;
								if (tmpTestManifestCache[tmpManifestSchema.SubType])
								{
									// this causes us to merge manifest whose SubType collides on the same hash
									tmpMergedConfig = this.fable.services.ManifestPackagingService._simpleManifestMerge(
										JSON.parse(JSON.stringify(tmpTestManifestCache[tmpManifestSchema.SubType])),
										tmpMergedConfig);
								}
								if (!tmpMergedConfig)
								{
									this.fable.log.error(`Manifest merge failed for Manifest Schema ID: ${tmpManifestSchema.IDManifestSchema}`);
									continue;
								}
								this._decorateManifestSchema(tmpManifestSchema);
								tmpManifestSchema.Manifest = tmpMergedConfig;
								tmpTestManifestCache[tmpManifestSchema.SubType] = tmpManifestSchema;
							}
							resolve(tmpTestManifestCache[pTestHash] ? JSON.parse(JSON.stringify(tmpTestManifestCache[pTestHash])) : null);
						},
					);
				});
			});
		});
	}

	/**
	 * @param {number} [pLength=8]
	 * @return {string} a random salt to identify this input instance
	 */
	_generateSaltStr(pLength = 8)
	{
		let result = '';
		for (let i = 0; i < pLength; i++)
		{
			result += SALT_CHARS.charAt(Math.floor(Math.random() * SALT_CHARS.length));
		}
		return result;
	}
}

module.exports = MaterialsFormManager;
/** @type {Record<string, any>} */
module.exports.default_configuration = { };
module.exports.LIMS_GUID_PATTERNS = LIMS_GUID_PATTERNS;
module.exports.isLIMSForm = isLIMSForm;
module.exports.getLIMSFormCandidates = getLIMSFormCandidates;
module.exports.FORM_GROUPS = FORM_GROUPS;

},{"./Materials-Lab-Router.js":27,"fable-serviceproviderbase":438,"headlight-rest-client":20,"manifest-packaging-service":25,"util":821}],27:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * @typedef {object} LabAffinityRule
 * @property {string} LabField - the Lab column matched against (e.g. 'Name', 'ExternalLabID').
 * @property {string} Pattern - a regular expression with `{KeyName}` placeholders filled from the project keys.
 * @property {Array<string>} [Requires] - project key names that must resolve before the rule is evaluated.
 * @property {string} [Flags] - regular-expression flags (default 'i').
 */

/**
 * @typedef {object} LabRoutingConfiguration
 * @property {Record<string, Array<string>>} [ProjectKeys] - key name -> ordered `Project.CustomProperties` keys; first non-empty wins.
 * @property {Array<LabAffinityRule>} [Rules] - ordered; the order is the routing priority order.
 * @property {string} [ResolverService] - fable service hash of a customer-specific router replacing this one.
 * @property {boolean} [FormsPerTestLab] - false to keep every test's form on one document regardless of lab.
 */

/**
 * @typedef {object} SampleLabContext
 * @property {Array<number>} [AffinityRootIDs] - affinity-matched parent labs, in priority order.
 * @property {Set<number>|Array<number>} [ProjectRootLabIDs] - the project's own parent labs (ProjectLabJoin).
 */

/**
 * @typedef {object} TestLabContext
 * @property {Set<number>} [TestLabIDs] - labs named by `TestLabJoin` for this test.
 * @property {Set<number>} [TestLabDefaultIDs] - labs named by `LabTestDefault` for this test (back-off axis).
 * @property {Set<number>|Array<number>} [ParentLabIDs] - the sample's assigned parent labs.
 * @property {Set<number>|Array<number>} [ProjectRootLabIDs] - the project's own parent labs.
 * @property {Set<number>|null} [SpecSetFloor] - the family-expanded `LabTestSpecificationSetJoin` floor.
 * @property {Array<number>} [AffinityRootIDs] - affinity-matched parent labs, in priority order.
 */

/**
 * @typedef {object} LabSelection
 * @property {number} IDLab - the chosen lab, or 0 when no axis answered.
 * @property {string} Source - which axis settled it: 'TestLabJoin' | 'LabTestDefault' | 'Affinity' |
 *   'ParentFamily' | 'Ambiguous' | 'None' for tests; 'LabTestDefault' | 'Affinity' | 'ProjectLabJoin' |
 *   'None' for samples.
 */

/**
 * MaterialsLabRouter — decides which lab a sample ships to and which bench runs each of its tests.
 *
 * The lab model is two-level: a PARENT lab is the routing destination a sample is assigned to, and its
 * CHILD labs are the benches that actually run tests. `ProjectLabJoin` names parents; `TestLabJoin` and
 * `LabTestDefault` name children. The concierge therefore asks two different questions:
 *
 *   - {@link selectSampleLabID} picks the PARENT lab for the sample's `SampleLabJoin`.
 *   - {@link selectTestLabID} picks the LEAF lab for a test's `TestInstance` and its form.
 *
 * Per-test narrowing intersects the axes that carry data — the test's capable labs (`TestLabJoin`, resolved
 * to leaves), the families of the sample's parent labs, and the families of the project's labs — then keeps
 * only leaves and applies the specification-set floor. `LabTestDefault` is a BACK-OFF axis: it narrows where
 * it has coverage but is never allowed to empty the candidates, because it disagrees with `TestLabJoin` often
 * enough that intersecting it hard would strand a test with no bench.
 *
 * Which of several surviving benches wins is customer data, not code: `LabRouting.Rules` match project
 * metadata (`Project.CustomProperties`) against Lab columns to name the parent labs belonging to a project —
 * the district laboratory and the field unit, for a DOT — and rule order is priority order. Without a
 * `LabRouting` block the affinity tier is simply absent and selection falls through to the data axes.
 *
 * This mirrors the web `LabScopeResolver` the sample form uses, so a form the concierge generates offers the
 * same labs the engineer would have picked by hand.
 */
class MaterialsLabRouter extends libFableServiceProviderBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - (optional) Options for the router
	 * @param {string} [pServiceHash] - (optional) Hash to use for the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'MaterialsLabRouter';

		/** @type {Map<number, Record<string, any>>} the customer lab catalog, by IDLab */
		this._Labs = new Map();
		/** @type {Map<number, Set<number>>} IDLab -> its child IDLab set */
		this._ChildrenByParent = new Map();
		this._LabsLoaded = false;
		/** @type {Map<number, Array<number>>} IDProject -> affinity-matched parent labs, in rule order */
		this._AffinityByProject = new Map();
		/** @type {{ get: (pURI: string) => Promise<any>, getAll: (pURI: string) => Promise<Array<any>> }|null} */
		this._Readers = null;
	}

	/**
	 * Bind the router to a caller's API readers. The router owns no client of its own so it reads through
	 * whatever session the caller is already impersonating.
	 *
	 * @param {{ get: (pURI: string) => Promise<any>, getAll: (pURI: string) => Promise<Array<any>> }} pReaders
	 *
	 * @return {void}
	 */
	setDataReaders(pReaders)
	{
		this._Readers = pReaders;
	}

	// --- lab tree ------------------------------------------------------------------------------------

	/**
	 * The customer's lab catalog, loaded once per instance — the tree does not move mid-sync. Read in full
	 * rather than through the Lite projection, which emits only `ID*`/`GUID*` columns and so carries neither
	 * the names nor the codes the affinity rules match on.
	 *
	 * The sort clause is also what makes this a legal paged read: meadow-endpoints exposes no bare
	 * `s/:Begin/:Cap`, only `s/FilteredTo/:Filter/:Begin/:Cap`.
	 *
	 * @return {Promise<void>}
	 */
	async loadLabCatalog()
	{
		if (this._LabsLoaded || !this._Readers)
		{
			return;
		}
		const tmpRows = await this._Readers.getAll(`Labs/FilteredTo/FSF~Name~ASC~0`);
		this.setLabCatalog(tmpRows);
	}

	/**
	 * Seed the lab tree from records already in hand (or from a test fixture), instead of reading them.
	 *
	 * @param {Array<Record<string, any>>} pLabs
	 *
	 * @return {void}
	 */
	setLabCatalog(pLabs)
	{
		this._Labs = new Map();
		this._ChildrenByParent = new Map();
		for (const tmpRow of (pLabs || []))
		{
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDLab > 0)
			{
				this._Labs.set(tmpIDLab, tmpRow);
			}
		}
		for (const tmpLab of this._Labs.values())
		{
			const tmpIDLab = parseInt(tmpLab.IDLab, 10);
			const tmpParent = parseInt(tmpLab.IDLabParent, 10) || 0;
			if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
			{
				continue;
			}
			let tmpChildren = this._ChildrenByParent.get(tmpParent);
			if (!tmpChildren)
			{
				tmpChildren = new Set();
				this._ChildrenByParent.set(tmpParent, tmpChildren);
			}
			tmpChildren.add(tmpIDLab);
		}
		this._LabsLoaded = true;
	}

	/**
	 * Add lab records the caller already holds without discarding what is loaded. The concierge fetches the
	 * project's labs on its own path anyway, so merging them guarantees the tree covers every lab a decision
	 * touches even when the catalog read returned nothing.
	 *
	 * @param {Array<Record<string, any>>} pLabs
	 *
	 * @return {void}
	 */
	mergeLabCatalog(pLabs)
	{
		let tmpAdded = false;
		for (const tmpRow of (pLabs || []))
		{
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDLab > 0 && !this._Labs.has(tmpIDLab))
			{
				this._Labs.set(tmpIDLab, tmpRow);
				tmpAdded = true;
			}
		}
		if (tmpAdded)
		{
			this.setLabCatalog(Array.from(this._Labs.values()));
		}
	}

	/**
	 * The lab record from the catalog, or null when it is not loaded.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {Record<string, any>|null}
	 */
	getLab(pIDLab)
	{
		return this._Labs.get(parseInt(String(pIDLab), 10)) || null;
	}

	/**
	 * The parent of a lab, or the lab itself when it is already a root. A parent pointer referencing a lab
	 * outside the catalog (or the lab itself) is treated as "no parent" rather than followed.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {number}
	 */
	getParentLabID(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return 0;
		}
		const tmpLab = this._Labs.get(tmpIDLab);
		const tmpParent = tmpLab ? (parseInt(tmpLab.IDLabParent, 10) || 0) : 0;
		if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
		{
			return tmpIDLab;
		}
		return tmpParent;
	}

	/**
	 * Whether a lab is a leaf — it has no children, so a test assigned to it needs no further routing. A lab
	 * absent from the catalog counts as a leaf so an unloaded tree never hides an option.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {boolean}
	 */
	isLeafLab(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return false;
		}
		const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
		return !tmpChildren || tmpChildren.size < 1;
	}

	/**
	 * The child labs of a lab.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {Set<number>}
	 */
	getChildLabIDs(pIDLab)
	{
		return new Set(this._ChildrenByParent.get(parseInt(String(pIDLab), 10)) || []);
	}

	/**
	 * Resolve a set of labs to the leaves a test can actually be assigned to: a leaf stays, a parent is
	 * replaced by its children. Falls back to the input when the resolution empties it (a catalog that has
	 * not loaded), so this never removes the only options a caller had.
	 *
	 * @param {Set<number>|Array<number>|null|undefined} pLabIDs
	 *
	 * @return {Set<number>|null}
	 */
	resolveToLeaves(pLabIDs)
	{
		const tmpInput = this._toSet(pLabIDs);
		if (tmpInput.size < 1)
		{
			return null;
		}
		const tmpLeaves = new Set();
		for (const tmpIDLab of tmpInput)
		{
			const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
			if (tmpChildren && tmpChildren.size > 0)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpLeaves.add(tmpChild);
				}
				continue;
			}
			tmpLeaves.add(tmpIDLab);
		}
		return (tmpLeaves.size > 0) ? tmpLeaves : tmpInput;
	}

	/**
	 * Every lab in the families rooted at the given labs — each root plus its children. The root itself is
	 * included so a childless parent lab stays selectable per-test.
	 *
	 * @param {Set<number>|Array<number>} pRootIDs
	 *
	 * @return {Set<number>}
	 */
	expandFamilies(pRootIDs)
	{
		const tmpFamily = new Set();
		for (const tmpRoot of this._toSet(pRootIDs))
		{
			tmpFamily.add(tmpRoot);
			const tmpChildren = this._ChildrenByParent.get(tmpRoot);
			if (tmpChildren)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpFamily.add(tmpChild);
				}
			}
		}
		return tmpFamily;
	}

	/**
	 * The distinct parent labs standing over a set of labs.
	 *
	 * @param {Set<number>|Array<number>} pLabIDs
	 *
	 * @return {Set<number>}
	 */
	rootsOf(pLabIDs)
	{
		const tmpRoots = new Set();
		for (const tmpIDLab of this._toSet(pLabIDs))
		{
			const tmpRoot = this.getParentLabID(tmpIDLab);
			if (tmpRoot > 0)
			{
				tmpRoots.add(tmpRoot);
			}
		}
		return tmpRoots;
	}

	/**
	 * Collapse a bench to the lab its results aggregate to. `AggregateTo` on a PARENT means its benches'
	 * tests roll up to it; `AggregateTo` on the bench itself means the bench is the aggregation point and
	 * stays put.
	 *
	 * @param {number|string} pIDLab
	 *
	 * @return {number}
	 */
	applyAggregation(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return 0;
		}
		const tmpLab = this._Labs.get(tmpIDLab);
		if (!tmpLab || tmpLab.AggregateTo)
		{
			return tmpIDLab;
		}
		const tmpParentID = this.getParentLabID(tmpIDLab);
		const tmpParent = (tmpParentID !== tmpIDLab) ? this._Labs.get(tmpParentID) : null;
		return (tmpParent && tmpParent.AggregateTo) ? tmpParentID : tmpIDLab;
	}

	/**
	 * The specification-set lab floor, expanded across the lab family: a lab is admitted when IT is in
	 * `LabTestSpecificationSetJoin`, when its PARENT is, or when any of its CHILDREN is.
	 *
	 * Membership is declared at the FAMILY level — the set names the parent labs and their benches come
	 * along — so raw membership empties whichever level the set was not authored at. The floor's real job,
	 * separating parallel lab generations mid-rename, survives the expansion because generations differ by
	 * FAMILY: expanding within a family never reaches across to the other one.
	 *
	 * @param {Set<number>|Array<number>|null} pAdmittedLabIDs - the raw joined lab ids.
	 *
	 * @return {Set<number>|null} null when the join has no coverage (no floor at all).
	 */
	expandSpecSetFloor(pAdmittedLabIDs)
	{
		const tmpAdmitted = this._toSet(pAdmittedLabIDs);
		if (tmpAdmitted.size < 1)
		{
			return null;
		}
		const tmpFloor = new Set(tmpAdmitted);
		for (const tmpIDLab of tmpAdmitted)
		{
			const tmpParent = this.getParentLabID(tmpIDLab);
			if (tmpParent > 0)
			{
				tmpFloor.add(tmpParent);
			}
			for (const tmpChild of this.getChildLabIDs(tmpIDLab))
			{
				tmpFloor.add(tmpChild);
			}
		}
		return tmpFloor;
	}

	// --- selection -----------------------------------------------------------------------------------

	/**
	 * The PARENT lab a sample should be assigned to.
	 *
	 * Candidates are the parents standing over whatever the caller resolved from `LabTestDefault`, ranked:
	 * an affinity-matched parent (in rule order — the project's own district laboratory before its field
	 * unit) wins, then one of the project's own labs, then the project's own affinity lab even though no
	 * candidate sits under it, and only then the first candidate, which is the answer this gave before any
	 * routing configuration existed.
	 *
	 * `LabTestDefault` is customer-wide: it names every lab that runs a material, in any district. When none
	 * of those labs belongs to the project, its first row says nothing about where THIS project's samples go,
	 * so the routing rules answer instead — the same district lab the web sample form pins first.
	 *
	 * With no candidates at all the affinity and project axes still answer on their own, so configuring
	 * routing rules ADDS defaulting where a material carried no `LabTestDefault` rather than removing it.
	 *
	 * @param {Set<number>|Array<number>} pCandidateLabIDs - labs resolved from `LabTestDefault` (any level).
	 * @param {SampleLabContext} [pContext]
	 *
	 * @return {LabSelection}
	 */
	selectSampleLabID(pCandidateLabIDs, pContext)
	{
		const tmpContext = pContext || {};
		const tmpAffinityRootIDs = Array.isArray(tmpContext.AffinityRootIDs) ? tmpContext.AffinityRootIDs : [];
		const tmpProjectRoots = this.rootsOf(tmpContext.ProjectRootLabIDs);
		const tmpCandidateRoots = this.rootsOf(pCandidateLabIDs);
		if (tmpCandidateRoots.size > 0)
		{
			for (const tmpAffinityRoot of tmpAffinityRootIDs)
			{
				if (tmpCandidateRoots.has(tmpAffinityRoot))
				{
					return { IDLab: tmpAffinityRoot, Source: 'Affinity' };
				}
			}
			const tmpInProject = this._lowest(this._intersect([ tmpCandidateRoots, tmpProjectRoots ]));
			if (tmpInProject > 0)
			{
				return { IDLab: tmpInProject, Source: 'ProjectLabJoin' };
			}
		}
		for (const tmpAffinityRoot of tmpAffinityRootIDs)
		{
			if (tmpProjectRoots.size < 1 || tmpProjectRoots.has(tmpAffinityRoot))
			{
				return { IDLab: tmpAffinityRoot, Source: 'Affinity' };
			}
		}
		if (tmpCandidateRoots.size > 0)
		{
			return { IDLab: Array.from(tmpCandidateRoots)[0], Source: 'LabTestDefault' };
		}
		return { IDLab: 0, Source: 'None' };
	}

	/**
	 * The LEAF lab that should run a test.
	 *
	 * Intersects the axes that carry data — the test's capable labs, the families of the sample's parent
	 * labs, and the families of the project's labs — keeps only leaves, applies the specification-set floor,
	 * then narrows by `LabTestDefault` where that does not empty the result. A tie is broken only when
	 * something distinguishes the benches — the project's own labs in routing-rule order, then the sample's
	 * lab families — and each tier must resolve to exactly one bench to settle it.
	 *
	 * Returns 0 when no axis carries data, the floor admits nothing, or the tie stands; the caller falls back
	 * to the sample's parent lab rather than guessing a bench.
	 *
	 * @param {number|string} pIDTest
	 * @param {TestLabContext} [pContext]
	 *
	 * @return {LabSelection}
	 */
	selectTestLabID(pIDTest, pContext)
	{
		const tmpContext = pContext || {};
		/** @type {Array<Set<number>>} */
		const tmpAxes = [];
		const tmpTestLabs = this.resolveToLeaves(tmpContext.TestLabIDs);
		if (tmpTestLabs)
		{
			tmpAxes.push(tmpTestLabs);
		}
		const tmpParentFamilies = this.expandFamilies(tmpContext.ParentLabIDs);
		if (tmpParentFamilies.size > 0)
		{
			tmpAxes.push(tmpParentFamilies);
		}
		const tmpProjectFamilies = this.expandFamilies(tmpContext.ProjectRootLabIDs);
		if (tmpProjectFamilies.size > 0)
		{
			tmpAxes.push(tmpProjectFamilies);
		}
		if (tmpAxes.length < 1)
		{
			return { IDLab: 0, Source: 'None' };
		}
		// Leaf grain is an invariant of this selection, not a property of one axis: the family axes carry
		// their roots so a childless parent stays selectable, and with no TestLabJoin rows those roots
		// would otherwise be chosen.
		let tmpCandidates = this._keepLeaves(this._intersect(tmpAxes));
		if (tmpContext.SpecSetFloor && tmpContext.SpecSetFloor.size > 0)
		{
			tmpCandidates = this._intersect([ tmpCandidates, tmpContext.SpecSetFloor ]);
		}
		if (tmpCandidates.size < 1)
		{
			return { IDLab: 0, Source: 'None' };
		}
		let tmpSource = tmpTestLabs ? 'TestLabJoin' : 'ParentFamily';
		const tmpDefaults = this.resolveToLeaves(tmpContext.TestLabDefaultIDs);
		if (tmpDefaults)
		{
			const tmpNarrowed = this._intersect([ tmpCandidates, tmpDefaults ]);
			if (tmpNarrowed.size > 0)
			{
				tmpCandidates = tmpNarrowed;
				tmpSource = 'LabTestDefault';
			}
		}
		if (tmpCandidates.size === 1)
		{
			return { IDLab: Array.from(tmpCandidates)[0], Source: tmpSource };
		}
		// Ties are broken only where something actually distinguishes the benches — the project's own labs in
		// routing-rule order, then the sample's lab families. Guessing between equals is how a router ends up
		// sending a test to the wrong bench, so an unbroken tie declines and the caller keeps the sample's
		// parent lab, where a technician can route it by hand.
		const tmpAffinityRootIDs = Array.isArray(tmpContext.AffinityRootIDs) ? tmpContext.AffinityRootIDs : [];
		for (const tmpAffinityRoot of tmpAffinityRootIDs)
		{
			const tmpInFamily = this._filterByRoot(tmpCandidates, tmpAffinityRoot);
			if (tmpInFamily.size === 1)
			{
				return { IDLab: Array.from(tmpInFamily)[0], Source: 'Affinity' };
			}
		}
		const tmpParentRoots = this.rootsOf(tmpContext.ParentLabIDs);
		const tmpInParentFamily = new Set();
		for (const tmpIDLab of tmpCandidates)
		{
			if (tmpParentRoots.has(this.getParentLabID(tmpIDLab)))
			{
				tmpInParentFamily.add(tmpIDLab);
			}
		}
		if (tmpInParentFamily.size === 1)
		{
			return { IDLab: Array.from(tmpInParentFamily)[0], Source: 'ParentFamily' };
		}
		return { IDLab: 0, Source: 'Ambiguous' };
	}

	// --- affinity ------------------------------------------------------------------------------------

	/**
	 * The parent labs belonging to a project, from the `LabRouting` naming rules, in rule (priority) order.
	 * Cached per project. Every step fails open to "no affinity", which costs the routing preference and
	 * nothing else — the data axes still answer.
	 *
	 * @param {number} pIDProject
	 * @param {LabRoutingConfiguration} [pLabRoutingConfig]
	 *
	 * @return {Promise<Array<number>>}
	 */
	async getAffinityRootIDs(pIDProject, pLabRoutingConfig)
	{
		if (!pLabRoutingConfig || !Array.isArray(pLabRoutingConfig.Rules) || pLabRoutingConfig.Rules.length < 1 || !(pIDProject > 0))
		{
			return [];
		}
		if (this._AffinityByProject.has(pIDProject))
		{
			return this._AffinityByProject.get(pIDProject);
		}
		let tmpMatched = [];
		try
		{
			await this.loadLabCatalog();
			const tmpProject = this._Readers ? await this._Readers.get(`Project/${pIDProject}`) : null;
			const tmpKeys = this.resolveAffinityKeys(pLabRoutingConfig, this.readCustomProperties(tmpProject));
			tmpMatched = this.matchAffinityRules(pLabRoutingConfig, tmpKeys);
			this.fable.log.info(`Lab routing affinity for project ${pIDProject} resolved keys ${JSON.stringify(tmpKeys)} to parent labs [${tmpMatched.join(',')}]`);
		}
		catch (pError)
		{
			this.fable.log.warn(`Lab routing affinity failed to resolve for project ${pIDProject}; continuing without it: ${pError.message}`);
			tmpMatched = [];
		}
		this._AffinityByProject.set(pIDProject, tmpMatched);
		return tmpMatched;
	}

	/**
	 * `CustomProperties` as an object, whether it arrives parsed or as a JSON string.
	 *
	 * @param {Record<string, any>|null} pProject
	 *
	 * @return {Record<string, any>}
	 */
	readCustomProperties(pProject)
	{
		const tmpRaw = pProject ? pProject.CustomProperties : null;
		if (!tmpRaw)
		{
			return {};
		}
		if (typeof tmpRaw !== 'string')
		{
			return tmpRaw;
		}
		try
		{
			return JSON.parse(tmpRaw) || {};
		}
		catch (pError)
		{
			return {};
		}
	}

	/**
	 * Resolve each configured key to its first non-empty project value. A value that is all digits and
	 * numerically zero is the customer's "unassigned" sentinel and counts as unset.
	 *
	 * @param {LabRoutingConfiguration} pLabRoutingConfig
	 * @param {Record<string, any>} pProperties
	 *
	 * @return {Record<string, string>}
	 */
	resolveAffinityKeys(pLabRoutingConfig, pProperties)
	{
		/** @type {Record<string, string>} */
		const tmpKeys = {};
		const tmpProjectKeys = pLabRoutingConfig.ProjectKeys || {};
		for (const tmpName of Object.keys(tmpProjectKeys))
		{
			const tmpCandidates = Array.isArray(tmpProjectKeys[tmpName]) ? tmpProjectKeys[tmpName] : [ tmpProjectKeys[tmpName] ];
			for (const tmpCandidate of tmpCandidates)
			{
				const tmpRaw = (pProperties || {})[tmpCandidate];
				const tmpValue = (tmpRaw === null || tmpRaw === undefined) ? '' : String(tmpRaw).trim();
				if (tmpValue === '' || (/^\d+$/.test(tmpValue) && Number(tmpValue) === 0))
				{
					continue;
				}
				tmpKeys[tmpName] = tmpValue;
				break;
			}
		}
		return tmpKeys;
	}

	/**
	 * The parent labs matched by the routing rules, in rule order.
	 *
	 * @param {LabRoutingConfiguration} pLabRoutingConfig
	 * @param {Record<string, string>} pKeys
	 *
	 * @return {Array<number>}
	 */
	matchAffinityRules(pLabRoutingConfig, pKeys)
	{
		const tmpMatched = [];
		for (const tmpRule of (pLabRoutingConfig.Rules || []))
		{
			if (!tmpRule || !tmpRule.LabField || !tmpRule.Pattern)
			{
				continue;
			}
			const tmpRequires = Array.isArray(tmpRule.Requires) ? tmpRule.Requires : Object.keys(pKeys);
			if (tmpRequires.some((pRequired) => !pKeys[pRequired]))
			{
				continue;
			}
			let tmpExpression;
			try
			{
				tmpExpression = new RegExp(this.interpolatePattern(tmpRule.Pattern, pKeys), tmpRule.Flags || 'i');
			}
			catch (pError)
			{
				this.fable.log.warn(`Lab routing rule pattern is not a valid expression: ${tmpRule.Pattern}`);
				continue;
			}
			for (const tmpLab of this._Labs.values())
			{
				const tmpIDLab = parseInt(tmpLab.IDLab, 10);
				// Routing rules name the destination, so only parents are matched; benches inherit.
				if (this.getParentLabID(tmpIDLab) !== tmpIDLab || tmpMatched.indexOf(tmpIDLab) > -1)
				{
					continue;
				}
				const tmpFieldValue = (tmpLab[tmpRule.LabField] === null || tmpLab[tmpRule.LabField] === undefined) ? '' : tmpLab[tmpRule.LabField];
				if (tmpExpression.test(String(tmpFieldValue)))
				{
					tmpMatched.push(tmpIDLab);
				}
			}
		}
		return tmpMatched;
	}

	/**
	 * Fill `{KeyName}` placeholders in a rule pattern. An all-digits value interpolates as `0*<digits>` with
	 * leading zeros stripped, so one pattern matches both `District 02 Lab` and `District 2 Lab` and the
	 * customer's project metadata does not have to agree with its lab names on zero-padding. Anything else is
	 * escaped and matched literally.
	 *
	 * @param {string} pPattern
	 * @param {Record<string, string>} pKeys
	 *
	 * @return {string}
	 */
	interpolatePattern(pPattern, pKeys)
	{
		return String(pPattern).replace(/\{([A-Za-z0-9_]+)\}/g, (pMatch, pName) =>
		{
			const tmpValue = pKeys[pName];
			if (tmpValue === undefined)
			{
				return pMatch;
			}
			if (/^\d+$/.test(tmpValue))
			{
				return `0*${String(Number(tmpValue))}`;
			}
			return tmpValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		});
	}

	// --- helpers -------------------------------------------------------------------------------------

	/**
	 * @param {Set<number>|Array<number>|null|undefined} pValues
	 *
	 * @return {Set<number>} the positive integers in the input.
	 */
	_toSet(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of (pValues || []))
		{
			const tmpID = parseInt(String(tmpValue), 10);
			if (tmpID > 0)
			{
				tmpSet.add(tmpID);
			}
		}
		return tmpSet;
	}

	/**
	 * @param {Array<Set<number>>} pSets
	 *
	 * @return {Set<number>}
	 */
	_intersect(pSets)
	{
		const tmpResult = new Set(pSets[0]);
		for (let i = 1; i < pSets.length; i++)
		{
			for (const tmpValue of Array.from(tmpResult))
			{
				if (!pSets[i].has(tmpValue))
				{
					tmpResult.delete(tmpValue);
				}
			}
		}
		return tmpResult;
	}

	/**
	 * Drop any lab that routes further — a parent with benches beneath it. Its benches, when they qualify,
	 * are already in the set beside it.
	 *
	 * @param {Set<number>} pLabIDs
	 *
	 * @return {Set<number>}
	 */
	_keepLeaves(pLabIDs)
	{
		const tmpLeaves = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			if (this.isLeafLab(tmpIDLab))
			{
				tmpLeaves.add(tmpIDLab);
			}
		}
		return tmpLeaves;
	}

	/**
	 * @param {Set<number>} pLabIDs
	 * @param {number} pRootID
	 *
	 * @return {Set<number>} the members of pLabIDs standing under pRootID.
	 */
	_filterByRoot(pLabIDs, pRootID)
	{
		const tmpMatched = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			if (this.getParentLabID(tmpIDLab) === pRootID)
			{
				tmpMatched.add(tmpIDLab);
			}
		}
		return tmpMatched;
	}

	/**
	 * @param {Set<number>} pLabIDs
	 *
	 * @return {number} the lowest id in the set, or 0 when it is empty.
	 */
	_lowest(pLabIDs)
	{
		let tmpLowest = 0;
		for (const tmpIDLab of pLabIDs)
		{
			if (tmpLowest === 0 || tmpIDLab < tmpLowest)
			{
				tmpLowest = tmpIDLab;
			}
		}
		return tmpLowest;
	}
}

module.exports = MaterialsLabRouter;

},{"fable-serviceproviderbase":438}],28:[function(require,module,exports){

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Render a server-side Document into the form viewer / editor and forward the
 * user to the rendered URL.  This codifies the pattern Fieldbook, the legacy
 * DocumentProvider, the sampleplan helper, and the OfflinePreview view all use:
 *
 *   1.  GET  Report/Render/{IDDocument}/{Variation}     →  { GUIDReportDescription }
 *   2.  GET  CheckoutSessionToken                       →  { Token }   (optional)
 *   3.  Navigate to {apiBase}Report/{GUID}/index.html[?SessionToken=...]
 *
 * The render endpoint is synchronous from the caller's perspective — the API
 * server stages the rendered page and returns the GUID once it is ready, so
 * "wait for it to render" just means "wait for the HTTP response."  No polling.
 *
 * The CheckoutSessionToken step is only needed when the rendered URL lives on
 * a different origin than the calling page (e.g. smartforms iframing into the
 * API host).  When the API is reached on the same origin via Kong the token is
 * unnecessary.
 *
 * Reference implementations:
 *   web/sampleplan/src/helpers/openDocument.js
 *   web/providers/DocumentProvider.js  (openFormByIDDocument)
 *   web/headlight-form-editor/source/views/OfflinePreview.js  (_renderExistingDocumentShell)
 */
class WebHeadlightDocumentRenderService extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadlightDocumentRender';

		// Optional override: pass `RestClient: <instance>` in options to bypass
		// the discovery logic in `_restClient`.  Useful for tests, the example
		// app, and any host that wires up its own client.
		//
		// Read from `this.options` (already normalised by the base constructor)
		// rather than the raw `pOptions` parameter, so both calling styles work:
		//   new Service(fable, { RestClient: x })   → super stores it in this.options
		//   new Service({ RestClient: x })          → super treats arg 1 as options
		this._OverrideRestClient = (this.options && this.options.RestClient) ? this.options.RestClient : null;
	}

	/**
	 * Resolve the HeadlightRestClient instance regardless of where it lives.
	 * Discovery order:
	 *   1. options.RestClient (constructor override)
	 *   2. fable.HeadlightRestClient
	 *   3. fable.pict.HeadlightRestClient
	 */
	get _restClient()
	{
		if (this._OverrideRestClient) { return this._OverrideRestClient; }
		if (this.fable && this.fable.HeadlightRestClient) { return this.fable.HeadlightRestClient; }
		if (this.fable && this.fable.pict && this.fable.pict.HeadlightRestClient) { return this.fable.pict.HeadlightRestClient; }
		return null;
	}

	setRestClient(pClient)
	{
		this._OverrideRestClient = pClient || null;
	}

	/**
	 * Kick off a server-side render of a Document.
	 *
	 * @param {number} pIDDocument        The IDDocument to render.
	 * @param {string|((pError: Error|null, pResult?: { GUIDReportDescription: string, IndexURL: string }) => void)} pVariation
	 *                                    The render variation (default 'default').  Other known values: 'html'.
	 *                                    Pass the callback here for the shorthand `renderDocument(id, callback)`.
	 * @param {(pError: Error|null, pResult?: { GUIDReportDescription: string, IndexURL: string }) => void} [fCallback]
	 */
	renderDocument(pIDDocument, pVariation, fCallback)
	{
		// Allow `renderDocument(id, callback)` shorthand.
		if (typeof pVariation === 'function')
		{
			fCallback = pVariation;
			pVariation = null;
		}
		const tmpVariation = pVariation || 'default';
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : (() => {});
		const tmpClient = this._restClient;

		if (!tmpClient)
		{
			return tmpCallback(new Error('HeadlightDocumentRender: HeadlightRestClient is not available.'));
		}
		if (!pIDDocument)
		{
			return tmpCallback(new Error('HeadlightDocumentRender: IDDocument is required.'));
		}

		tmpClient.getJSON(`Report/Render/${pIDDocument}/${tmpVariation}`, (pError, pBody) =>
		{
			if (pError) { return tmpCallback(pError); }
			if (pBody && pBody.Error)
			{
				return tmpCallback(new Error(typeof pBody.Error === 'string' ? pBody.Error : 'Render returned an error.'));
			}
			if (!pBody || !pBody.GUIDReportDescription)
			{
				return tmpCallback(new Error('HeadlightDocumentRender: render response missing GUIDReportDescription.'));
			}
			return tmpCallback(null,
				{
					GUIDReportDescription: pBody.GUIDReportDescription,
					IndexURL: tmpClient.formatUrl(`Report/${pBody.GUIDReportDescription}/index.html`)
				});
		});
	}

	/**
	 * Fetch a short-lived session token suitable for cross-origin embedding of
	 * the rendered report.
	 *
	 * @param {(pError: Error|null, pToken?: { Token: string }) => void} fCallback
	 */
	getCheckoutSessionToken(fCallback)
	{
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : (() => {});
		const tmpClient = this._restClient;
		if (!tmpClient)
		{
			return tmpCallback(new Error('HeadlightDocumentRender: HeadlightRestClient is not available.'));
		}
		tmpClient.getJSON('CheckoutSessionToken', (pError, pBody) =>
		{
			if (pError) { return tmpCallback(pError); }
			return tmpCallback(null, pBody || {});
		});
	}

	/**
	 * Render a Document and navigate a window to the rendered page, mirroring
	 * the pattern in Fieldbook's openFormByIDDocument and sampleplan's
	 * openDocument helper.
	 *
	 * Options:
	 *   target              - '_self' | '_blank' | window reference (default '_blank')
	 *   variation           - render variation passed to Report/Render (default 'default')
	 *   includeSessionToken - if true, fetches CheckoutSessionToken and appends
	 *                         ?SessionToken=… to the URL.  Required when the
	 *                         rendered URL lives on a different origin than the
	 *                         calling page.  Default false (same-origin via Kong).
	 *   loadingHTML         - HTML written to a freshly-opened window while the
	 *                         render request is in flight.  Pass `false` to skip
	 *                         the loading splash.
	 *
	 * @param {number}   pIDDocument
	 * @param {object}   [pOptions]
	 * @param {(pError: Error|null, pURL?: string) => void} [fCallback]
	 */
	openDocument(pIDDocument, pOptions, fCallback)
	{
		const tmpOptions = pOptions || {};
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : (() => {});
		const tmpTarget = tmpOptions.target || '_blank';
		const tmpVariation = tmpOptions.variation || 'default';
		const tmpIncludeToken = tmpOptions.includeSessionToken === true;

		// Resolve the destination window.
		let tmpWindowRef = null;
		const tmpHasWindow = (typeof window !== 'undefined');
		const tmpOpenedWindow = (tmpTarget !== '_self' && typeof tmpTarget !== 'object');

		if (tmpHasWindow)
		{
			if (tmpTarget === '_self')
			{
				tmpWindowRef = window;
			}
			else if (typeof tmpTarget === 'object' && tmpTarget !== null)
			{
				tmpWindowRef = tmpTarget;
			}
			else
			{
				tmpWindowRef = window.open('', tmpTarget);
				if (!tmpWindowRef)
				{
					return tmpCallback(new Error('HeadlightDocumentRender: window.open was blocked by the browser.'));
				}
				if (tmpOptions.loadingHTML !== false)
				{
					try
					{
						tmpWindowRef.document.write(tmpOptions.loadingHTML || this._defaultLoadingHTML());
					}
					catch (e)
					{
						if (this.fable && this.fable.log)
						{
							this.fable.log.warn(`HeadlightDocumentRender: could not write loading splash: ${e.message || e}`);
						}
					}
				}
			}
		}

		const tmpFinish = (pError, pURL) =>
		{
			if (pError && tmpOpenedWindow && tmpWindowRef)
			{
				try { tmpWindowRef.close(); } catch (e) { /* ignore */ }
			}
			return tmpCallback(pError, pURL);
		};

		this.renderDocument(pIDDocument, tmpVariation, (pRenderError, pRenderResult) =>
		{
			if (pRenderError) { return tmpFinish(pRenderError); }

			const tmpNavigate = (pToken) =>
			{
				let tmpFinalURL = pRenderResult.IndexURL;
				if (pToken && pToken.Token)
				{
					tmpFinalURL += (tmpFinalURL.indexOf('?') === -1 ? '?' : '&');
					tmpFinalURL += 'SessionToken=' + encodeURIComponent(pToken.Token);
				}
				// Collapse accidental // (other than after the protocol).
				tmpFinalURL = tmpFinalURL.replace(/([^:])\/\//g, '$1/');

				if (tmpWindowRef)
				{
					try { tmpWindowRef.location = tmpFinalURL; }
					catch (e) { return tmpFinish(e); }
				}
				return tmpFinish(null, tmpFinalURL);
			};

			if (tmpIncludeToken)
			{
				this.getCheckoutSessionToken((pTokenError, pToken) =>
				{
					if (pTokenError) { return tmpFinish(pTokenError); }
					return tmpNavigate(pToken);
				});
			}
			else
			{
				return tmpNavigate(null);
			}
		});
	}

	/**
	 * Get the URL to download a Document's rendered PDF.  Same-origin via the
	 * REST client's serverURL, so a plain anchor `<a download>` works.
	 */
	getPDFURL(pIDDocument)
	{
		const tmpClient = this._restClient;
		if (!tmpClient || !pIDDocument) { return null; }
		return tmpClient.formatUrl(`Document/${pIDDocument}/DCR.pdf`);
	}

	/**
	 * Fire-and-forget PDF download.  Synthesizes a hidden `<a download>` to
	 * the same-origin PDF URL and clicks it — the browser handles the rest.
	 *
	 * Use this when you don't need to know when the file arrives (no spinner,
	 * no toast, no follow-up action).  No callback fires after the download
	 * completes; the click is the only signal you'll see.
	 *
	 * Use {@link downloadPDF} instead if you need to show progress UI, gate
	 * follow-up work on completion, or surface server errors to the user.
	 *
	 * Options:
	 *   filename - download filename hint passed to the anchor.  Default
	 *              `Document-{IDDocument}.pdf`.  Honoured by the browser only
	 *              for same-origin URLs that don't set their own
	 *              Content-Disposition.
	 *
	 * @param {number}  pIDDocument
	 * @param {object}  [pOptions]
	 * @returns {string|null} The PDF URL that was triggered, or null when no
	 *                        rest client is available.
	 */
	downloadPDFLink(pIDDocument, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpURL = this.getPDFURL(pIDDocument);
		if (!tmpURL) { return null; }
		if (typeof document === 'undefined' || typeof document.createElement !== 'function')
		{
			if (this.fable && this.fable.log) { this.fable.log.warn('HeadlightDocumentRender: downloadPDFLink requires a browser environment.'); }
			return null;
		}

		const tmpFilename = tmpOptions.filename || `Document-${pIDDocument}.pdf`;
		const tmpAnchor = document.createElement('a');
		tmpAnchor.href = tmpURL;
		tmpAnchor.download = tmpFilename;
		tmpAnchor.rel = 'noopener';
		tmpAnchor.style.display = 'none';
		try
		{
			document.body.appendChild(tmpAnchor);
			tmpAnchor.click();
		}
		finally
		{
			if (tmpAnchor.parentNode === document.body) { document.body.removeChild(tmpAnchor); }
		}
		return tmpURL;
	}

	/**
	 * Lifecycle-aware PDF download.  Fetches the PDF as a Blob (so the
	 * callback fires only after the file is fully available — important for
	 * documents that take a long time to render), then synthesizes a download
	 * via a hidden `<a download>` + object URL.
	 *
	 * If the configured rest client exposes a `getBlob(path, callback)`
	 * method it is preferred (so any client-defined headers — `X-Upstream`,
	 * session tokens, etc. — are applied).  Otherwise the service falls back
	 * to a credentialed global `fetch` against the same-origin URL.
	 *
	 * Options:
	 *   filename - download filename hint passed to the anchor.  Default
	 *              `Document-{IDDocument}.pdf`.
	 *
	 * Callback signature: `(error, { url, filename, blob })` on success, or
	 * `(error)` on failure.
	 *
	 * @param {number}  pIDDocument
	 * @param {object}  [pOptions]
	 * @param {(pError: Error|null, pResult?: { url: string, filename: string, blob: Blob }) => void} [fCallback]
	 */
	downloadPDF(pIDDocument, pOptions, fCallback)
	{
		// Allow `downloadPDF(id, callback)` shorthand.
		if (typeof pOptions === 'function')
		{
			fCallback = pOptions;
			pOptions = null;
		}
		const tmpOptions = pOptions || {};
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : (() => {});

		const tmpURL = this.getPDFURL(pIDDocument);
		if (!tmpURL)
		{
			return tmpCallback(new Error('HeadlightDocumentRender: HeadlightRestClient is not available.'));
		}
		if (typeof document === 'undefined' || typeof document.createElement !== 'function')
		{
			return tmpCallback(new Error('HeadlightDocumentRender: downloadPDF requires a browser environment.'));
		}

		const tmpFilename = tmpOptions.filename || `Document-${pIDDocument}.pdf`;

		const tmpDeliver = (pBlob) =>
		{
			let tmpObjectURL;
			let tmpAnchor;
			try
			{
				tmpObjectURL = URL.createObjectURL(pBlob);
				tmpAnchor = document.createElement('a');
				tmpAnchor.href = tmpObjectURL;
				tmpAnchor.download = tmpFilename;
				tmpAnchor.rel = 'noopener';
				tmpAnchor.style.display = 'none';
				document.body.appendChild(tmpAnchor);
				tmpAnchor.click();
			}
			catch (pError)
			{
				return tmpCallback(pError);
			}
			finally
			{
				if (tmpAnchor && tmpAnchor.parentNode === document.body)
				{
					document.body.removeChild(tmpAnchor);
				}
				// Revoke after a tick so the click has time to start the download.
				if (tmpObjectURL)
				{
					setTimeout(() => { try { URL.revokeObjectURL(tmpObjectURL); } catch (e) { /* ignore */ } }, 5000);
				}
			}
			return tmpCallback(null, { url: tmpURL, filename: tmpFilename, blob: pBlob });
		};

		const tmpClient = this._restClient;
		if (tmpClient && typeof tmpClient.getBlob === 'function')
		{
			tmpClient.getBlob(`Document/${pIDDocument}/DCR.pdf`, (pError, pBlob) =>
			{
				if (pError) { return tmpCallback(pError); }
				if (!pBlob) { return tmpCallback(new Error('HeadlightDocumentRender: PDF download returned no body.')); }
				return tmpDeliver(pBlob);
			});
			return;
		}

		if (typeof fetch !== 'function')
		{
			return tmpCallback(new Error('HeadlightDocumentRender: PDF download requires either a rest client with getBlob() or a global fetch implementation.'));
		}
		fetch(tmpURL, { credentials: 'include' })
			.then((pResponse) =>
			{
				if (!pResponse.ok) { throw new Error(`HTTP ${pResponse.status} from ${tmpURL}`); }
				return pResponse.blob();
			})
			.then((pBlob) => tmpDeliver(pBlob))
			.catch((pError) => tmpCallback(pError));
	}

	_defaultLoadingHTML()
	{
		return /*html*/`<!DOCTYPE html><html><head><title>Loading…</title>
<style>
@-webkit-keyframes load8 { 0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); } }
@keyframes load8 { 0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); } }
*, *:before, *:after { box-sizing: border-box; }
body { padding: 15px 0; margin: 0 auto; background-color: #53565A; font-family: Arial, sans-serif; width: 100%; font-size: 15px; max-width: 1000px; }
.loading-splash-screen { width: 100%; height: 100vh; background: #53565A; position: fixed; top: 0; left: 0; text-align: center; z-index: 10002; display: flex; align-items: center; }
.loading-splash-screen .loading-spinner, .loading-splash-screen .loading-spinner:after { border-radius: 50%; width: 15em; height: 15em; }
.loading-spinner { margin: 60px auto; font-size: 10px; position: relative; text-indent: -9999em; border-top: 1.1em solid rgba(255, 255, 255, 0.2); border-right: 1.1em solid rgba(255, 255, 255, 0.2); border-bottom: 1.1em solid rgba(255, 255, 255, 0.2); border-left: 1.1em solid #ffffff; -webkit-transform: translateZ(0); -ms-transform: translateZ(0); transform: translateZ(0); -webkit-animation: load8 1.1s infinite linear; animation: load8 1.1s infinite linear; color: #ffffff; }
</style></head><body>
<div class="loading-splash-screen"><div class="loading-spinner">Loading…</div></div>
</body></html>`;
	}
}

module.exports = WebHeadlightDocumentRenderService;

module.exports.default_configuration = (
{
	Name: 'HeadlightDocumentRender',
	ServiceType: 'HeadlightDocumentRender'
});

},{"fable-serviceproviderbase":438}],29:[function(require,module,exports){

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Browser-side Fable service that renders a Headlight Observation into HTML.
 *
 * This is the centralized observation renderer — the sibling of
 * web-headlight-document-render (documents contain observations; the two are
 * used in concert).  It replaces the scattered, ad-hoc observation rendering
 * that had grown up across the platform (the config-app Observation workspace's
 * bespoke `_renderDatum` walker, the legacy AngularJS/Mustache transcoder's
 * one-file-per-type templates, MediaCardBuilder, the Explorer map panels, …),
 * each of which re-derived its own field selection and its own data source.
 *
 * Two ideas make it "intelligent about built-in AND custom schemas":
 *
 *   1.  It never branches on built-in-vs-custom.  The API's manifest resolver
 *       already merges a customer's custom ObservationManifest over the global
 *       (IDCustomer=0) default, so a single lookup returns whichever wins.  This
 *       service just asks `GET ObservationSpecification/{type}/{project}` for the
 *       resolved schema (slots → ArtifactType.Schemata.properties) and drives
 *       layout off it.  Custom types "just work."
 *
 *   2.  It is schema-DRIVEN, not template-per-type.  One data pass builds a
 *       normalized model from the observation's assembled `.Details`
 *       (`{ <SlotName>: [ { IDArtifact, ArtifactType, Version, Datum:{...} }, ... ] }`),
 *       iterating EVERY artifact in EVERY slot (the old code took only `[0]`,
 *       which is why spreadsheet observations — one Artifact per row — showed a
 *       single row or nothing).  A slot whose CountMaximum>1 (or that holds
 *       multiple artifacts) renders as a header+rows table; a single record as a
 *       field card; a Data_String as prose; media as thumbnails/links.
 *
 * The same model feeds many named FORMATS (like the transcoder's one-template-
 * many-sizes model, but the "size" changes how much of the model is shown, not
 * just CSS):
 *
 *   full       Workspace Data body — hero media + meta + description + all
 *              captured-data slots (tables/cards/prose/media) + labels.
 *   card       ~square grid cell — square media (or type glyph) + name + type +
 *              a few headline datums.  Supersedes MediaCardBuilder / transcode Preview.
 *   strip      Thin rail item for the side of a map — thumbnail + name + type dot +
 *              date + 1-2 headline datums.
 *   tooltip    Data-laden hover popup — square image + name/type/date/author + top datums.
 *   thumbnail  128px — image or typed glyph + initials + date.
 *   marker     One-line map label — name · type.
 *
 * Every format degrades gracefully: handed a full Observation (with `.Details`)
 * it shows captured data; handed a thin Solr/geo doc (Name / RecordSubType /
 * DateOfRecord / IDAuthor / IDArtifact, no Details) it shows a metadata-only
 * compact shape and a typed glyph rather than a broken image.
 *
 * Non-image observations always render as HTML — never a broken `<img>`.
 *
 * Consumed like its sibling:
 *   pict.addServiceType('HeadlightObservationRender', require('.../Web-Headlight-Observation-Render.js'));
 *   pict.instantiateServiceProviderIfNotExists('HeadlightObservationRender');
 *   const html = pict.HeadlightObservationRender.renderObservationHTML(observation, { format: 'full' });
 */
class WebHeadlightObservationRenderService extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'HeadlightObservationRender';

		// options.RestClient overrides discovery — useful for tests + standalone use.
		this._OverrideRestClient = (this.options && this.options.RestClient) ? this.options.RestClient : null;

		// ObservationSpecification cache, keyed by `${ObservationType}::${IDProject||0}`.
		this._SpecificationCache = {};

		// Guard so injectStyles() only writes the <style> block once per document.
		this._StylesInjected = false;

		// Artifact types that carry media bytes rather than structured Datum fields.
		this._MediaArtifactTypes = { Image: 'image', Video: 'video', Audio: 'audio', File: 'file', Data_File: 'file' };
	}

	/**
	 * Resolve the HeadlightRestClient instance regardless of where it lives.
	 * Discovery order:
	 *   1. options.RestClient (constructor override)
	 *   2. fable.HeadlightRestClient
	 *   3. fable.pict.HeadlightRestClient
	 */
	get _restClient()
	{
		if (this._OverrideRestClient) { return this._OverrideRestClient; }
		if (this.fable && this.fable.HeadlightRestClient) { return this.fable.HeadlightRestClient; }
		if (this.fable && this.fable.pict && this.fable.pict.HeadlightRestClient) { return this.fable.pict.HeadlightRestClient; }
		return null;
	}

	setRestClient(pClient)
	{
		this._OverrideRestClient = pClient || null;
	}

	// ---- URL helpers ----------------------------------------------------

	/** Same-origin API URL for a path, via the rest client when available. */
	_formatUrl(pPath)
	{
		const tmpClient = this._restClient;
		if (tmpClient && (typeof tmpClient.formatUrl === 'function'))
		{
			try { return tmpClient.formatUrl(pPath); } catch (pError) { /* fall through */ }
		}
		return `/1.0/${pPath}`;
	}

	/**
	 * The rendered/composited observation image (annotations burned in).  Sizes:
	 * Thumbnail (128, reliably generated), Standard, Preview (larger, may lag).
	 * Compact formats use Thumbnail because larger sizes are generated lazily.
	 */
	observationImageURL(pIDObservation, pSize, pVersion)
	{
		if (!pIDObservation) { return null; }
		const tmpSize = pSize || 'Thumbnail';
		const tmpBase = `Observation/${pIDObservation}/Image/${tmpSize}`;
		return this._formatUrl((pVersion != null && pVersion !== '') ? `${tmpBase}/V/${pVersion}` : tmpBase);
	}

	/** Raw media stream for one artifact version. */
	artifactMediaURL(pIDArtifact, pVersion)
	{
		if (!pIDArtifact) { return null; }
		return this._formatUrl(`Artifact/Media/${Number(pIDArtifact)}/${Number(pVersion) || 1}`);
	}

	// ---- Specification (schema) loading ---------------------------------

	/**
	 * Load and cache the resolved schema for an ObservationType (built-in or
	 * custom — the API resolver merges them).  The schema drives column order,
	 * labels, and visibility.  Rendering still works WITHOUT it (columns fall
	 * back to the union of Datum keys), so this is an enhancement, not a
	 * requirement.
	 *
	 * @param {string} pObservationType
	 * @param {number|string} pIDProject   Project context for custom-type resolution.
	 * @param {(pError: Error|null, pSpecification?: object) => void} fCallback
	 *        pSpecification = { slots:[{name,idArtifactType,countMax,required}],
	 *                           schemasByID:{<id>:{name,columns:[...]}},
	 *                           schemasByName:{<name>:{...}} }
	 */
	loadSpecification(pObservationType, pIDProject, fCallback)
	{
		if (typeof pIDProject === 'function') { fCallback = pIDProject; pIDProject = null; }
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : (() => {});

		if (!pObservationType) { return tmpCallback(new Error('HeadlightObservationRender: ObservationType is required.')); }

		const tmpKey = `${pObservationType}::${pIDProject || 0}`;
		if (this._SpecificationCache[tmpKey]) { return tmpCallback(null, this._SpecificationCache[tmpKey]); }

		const tmpClient = this._restClient;
		if (!tmpClient) { return tmpCallback(new Error('HeadlightObservationRender: HeadlightRestClient is not available.')); }

		const tmpURL = `ObservationSpecification/${encodeURIComponent(pObservationType)}${(pIDProject != null && pIDProject !== '') ? ('/' + pIDProject) : ''}`;
		tmpClient.getJSON(tmpURL, (pError, pBody) =>
		{
			if (pError) { return tmpCallback(pError); }
			if (!pBody || pBody.Error) { return tmpCallback(new Error((pBody && pBody.Error) ? String(pBody.Error) : 'ObservationSpecification returned no body.')); }
			let tmpParsed;
			try { tmpParsed = this._parseSpecification(pBody, pObservationType); }
			catch (pParseError) { return tmpCallback(pParseError); }
			this._SpecificationCache[tmpKey] = tmpParsed;
			return tmpCallback(null, tmpParsed);
		});
	}

	/**
	 * Turn a raw ObservationSpecification `{ Manifest:{<type>:[slots]}, ArtifactTypes:{<id>:{Name,Schemata}} }`
	 * into `{ slots, schemasByID, schemasByName }` with parsed, sorted columns.
	 */
	_parseSpecification(pSpecification, pObservationType)
	{
		const tmpArtifactTypes = pSpecification.ArtifactTypes || {};
		const tmpSchemasByID = {};
		const tmpSchemasByName = {};
		Object.keys(tmpArtifactTypes).forEach((pID) =>
		{
			const tmpAT = tmpArtifactTypes[pID] || {};
			const tmpColumns = this._columnsFromSchemata(tmpAT.Schema || tmpAT.Schemata);
			const tmpEntry = { id: pID, name: tmpAT.Name, columns: tmpColumns };
			tmpSchemasByID[String(pID)] = tmpEntry;
			if (tmpAT.Name) { tmpSchemasByName[tmpAT.Name] = tmpEntry; }
		});

		const tmpManifest = pSpecification.Manifest || {};
		// Prefer the requested type's slot list; else the first manifest key present.
		const tmpTypeKey = (pObservationType && tmpManifest[pObservationType]) ? pObservationType : Object.keys(tmpManifest)[0];
		const tmpRawSlots = (tmpTypeKey && Array.isArray(tmpManifest[tmpTypeKey])) ? tmpManifest[tmpTypeKey] : [];
		const tmpSlots = tmpRawSlots.map((pSlot) => (
			{
				name: pSlot.Name,
				idArtifactType: (pSlot.IDArtifactType != null) ? String(pSlot.IDArtifactType) : null,
				countMax: Number(pSlot.CountMaximum) || 0,
				required: !!pSlot.Required
			}));

		return { slots: tmpSlots, schemasByID: tmpSchemasByID, schemasByName: tmpSchemasByName };
	}

	/**
	 * Parse an ArtifactType.Schemata (JSON-Schema, string or object) into an
	 * ordered column list: `[ { key, label, type, ordinal } ]`, sorted by
	 * `ordinal`, honouring `displayName`, dropping `visible === false`.
	 */
	_columnsFromSchemata(pSchemata)
	{
		let tmpSchema = pSchemata;
		if (typeof tmpSchema === 'string')
		{
			try { tmpSchema = JSON.parse(tmpSchema); } catch (pError) { return []; }
		}
		if (!tmpSchema || (typeof tmpSchema !== 'object') || !tmpSchema.properties) { return []; }
		const tmpProps = tmpSchema.properties;
		return Object.keys(tmpProps)
			.map((pKey) =>
			{
				const tmpProp = tmpProps[pKey] || {};
				return {
					key: pKey,
					label: tmpProp.displayName || this._prettyKey(pKey),
					type: tmpProp.type || 'string',
					ordinal: (tmpProp.ordinal != null) ? Number(tmpProp.ordinal) : 9999,
					visible: (tmpProp.visible !== false)
				};
			})
			.filter((pColumn) => pColumn.visible)
			.sort((pA, pB) => (pA.ordinal - pB.ordinal) || String(pA.key).localeCompare(String(pB.key)));
	}

	// ---- Public render entry points -------------------------------------

	/**
	 * Async render: ensures the schema is loaded (for schema-driven columns),
	 * then renders.  Pass `options.specification` (from a prior loadSpecification)
	 * or `options.autoLoadSpec: false` to skip the fetch and render immediately
	 * with key-derived columns.
	 *
	 * @param {object} pObservation   A hydrated Observation (with `.Details`) or a thin doc.
	 * @param {object} [pOptions]     { format, specification, autoLoadSpec, creatorName }
	 * @param {(pError: Error|null, pHTML?: string) => void} fCallback
	 */
	renderObservation(pObservation, pOptions, fCallback)
	{
		if (typeof pOptions === 'function') { fCallback = pOptions; pOptions = null; }
		const tmpOptions = pOptions || {};
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : (() => {});

		if (!pObservation) { return tmpCallback(new Error('HeadlightObservationRender: an observation is required.')); }

		const tmpType = pObservation.ObservationType;
		const tmpProject = pObservation.IDProject;

		if (tmpOptions.specification || (tmpOptions.autoLoadSpec === false) || !tmpType || !this._restClient)
		{
			try { return tmpCallback(null, this.renderObservationHTML(pObservation, tmpOptions)); }
			catch (pError) { return tmpCallback(pError); }
		}

		this.loadSpecification(tmpType, tmpProject, (pError, pSpecification) =>
		{
			// A spec failure is non-fatal — render with key-derived columns.
			const tmpMerged = Object.assign({}, tmpOptions, { specification: pError ? null : pSpecification });
			try { return tmpCallback(null, this.renderObservationHTML(pObservation, tmpMerged)); }
			catch (pRenderError) { return tmpCallback(pRenderError); }
		});
	}

	/**
	 * Synchronous render.  Builds the normalized model then dispatches by format.
	 * Auto-injects the stylesheet (once) when a document is available.
	 *
	 * @param {object} pObservation
	 * @param {object} [pOptions]   { format='full', specification, creatorName, injectStyles=true, typeLabel, showArtifactType=true }
	 *        typeLabel(ObservationType) → the type as shown (default: the stored ObservationType);
	 *        showArtifactType=false drops the stored ArtifactType from each slot's badge.
	 * @returns {string} HTML fragment.
	 */
	renderObservationHTML(pObservation, pOptions)
	{
		const tmpOptions = pOptions || {};
		if (tmpOptions.injectStyles !== false) { this.injectStyles(); }

		const tmpModel = this.buildObservationModel(pObservation, tmpOptions);
		const tmpFormat = tmpOptions.format || 'full';
		switch (tmpFormat)
		{
			case 'data':      return this._renderData(tmpModel);
			case 'card':      return this._renderCard(tmpModel);
			case 'strip':     return this._renderStrip(tmpModel);
			case 'tooltip':   return this._renderTooltip(tmpModel);
			case 'thumbnail': return this._renderThumbnail(tmpModel);
			case 'marker':    return this._renderMarker(tmpModel);
			case 'full':
			default:          return this._renderFull(tmpModel);
		}
	}

	// ---- Model building -------------------------------------------------

	/**
	 * Normalize an observation (full or thin) into the render model consumed by
	 * every format.  This is the single data pass; formats only choose how much
	 * of it to show.
	 */
	buildObservationModel(pObservation, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpObs = pObservation || {};
		const tmpSpec = tmpOptions.specification || null;

		const tmpID = tmpObs.IDObservation || tmpObs.IDRecord || tmpObs.ID || null;
		const tmpType = tmpObs.ObservationType || tmpObs.RecordSubType || tmpObs.Type || '';
		const tmpTypeLabel = (typeof tmpOptions.typeLabel === 'function') ? (tmpOptions.typeLabel(tmpType) || tmpType) : tmpType;
		const tmpName = tmpObs.Name || tmpObs.ObservationName || tmpObs.SearchText || (tmpID ? `Observation #${tmpID}` : 'Observation');
		const tmpDescription = tmpObs.Description || '';
		const tmpStatus = tmpObs.Status || '';
		const tmpWhen = tmpObs.DesignatedTime || tmpObs.DateOfRecord || tmpObs.CreateDate || '';
		const tmpCreator = tmpOptions.creatorName || tmpObs.CreatingUserName || tmpObs.AuthorName || tmpObs.Author || '';
		const tmpAuthorID = tmpObs.CreatingIDUser || tmpObs.IDAuthor || null;
		const tmpVersion = tmpObs.Version;

		const tmpDetails = (tmpObs.Details && (typeof tmpObs.Details === 'object')) ? tmpObs.Details : {};
		const tmpHasDetails = Object.keys(tmpDetails).length > 0;

		const tmpSlots = [];
		let tmpHeroArtifact = null;
		Object.keys(tmpDetails).forEach((pSlotName) =>
		{
			const tmpArray = Array.isArray(tmpDetails[pSlotName]) ? tmpDetails[pSlotName] : [];
			if (!tmpArray.length) { return; }
			const tmpSlotModel = this._buildSlotModel(pSlotName, tmpArray, tmpSpec);
			tmpSlotModel.showArtifactType = (tmpOptions.showArtifactType !== false);
			// The first image becomes the hero; annotation overlays are not shown as data.
			if (tmpSlotModel.kind === 'media' && tmpSlotModel.mediaKind === 'image' && !tmpHeroArtifact)
			{
				tmpHeroArtifact = tmpSlotModel.items[0];
				tmpSlotModel.isHeroSource = true;
			}
			tmpSlots.push(tmpSlotModel);
		});

		// Whether we can show a composited observation image.
		const tmpHasImage = !!tmpHeroArtifact
			|| (!tmpHasDetails && (!!tmpObs.IDArtifact || tmpObs.HasImage === true || /image|photo/i.test(tmpType)));

		const tmpLabels = [];
		const tmpRawLabels = (tmpObs.Labels && (typeof tmpObs.Labels === 'object')) ? tmpObs.Labels : {};
		Object.keys(tmpRawLabels).forEach((pType) =>
		{
			const tmpValues = (Array.isArray(tmpRawLabels[pType]) ? tmpRawLabels[pType] : [])
				.map((pTag) => (pTag && (pTag.Tag != null ? pTag.Tag : pTag)))
				.filter((pValue) => pValue != null && pValue !== '');
			if (tmpValues.length) { tmpLabels.push({ type: pType, label: this._prettyKey(pType), values: tmpValues }); }
		});

		return {
			id: tmpID,
			type: tmpType,
			typeLabel: tmpTypeLabel,
			name: tmpName,
			description: tmpDescription,
			status: tmpStatus,
			when: tmpWhen,
			creatorName: tmpCreator,
			authorID: tmpAuthorID,
			version: tmpVersion,
			hasDetails: tmpHasDetails,
			hasImage: tmpHasImage,
			imageThumbURL: (tmpID ? this.observationImageURL(tmpID, 'Thumbnail') : null),
			imagePreviewURL: (tmpID ? this.observationImageURL(tmpID, 'Preview') : null),
			slots: tmpSlots,
			labels: tmpLabels
		};
	}

	/** Build one slot's model: classify (media / prose / table / fields) + columns/rows. */
	_buildSlotModel(pSlotName, pArray, pSpecification)
	{
		const tmpFirst = pArray[0] || {};
		const tmpArtifactType = tmpFirst.ArtifactType || pSlotName;
		const tmpMediaKind = this._MediaArtifactTypes[tmpArtifactType] || ((pSlotName === 'Image') ? 'image' : null);

		const tmpBase = { name: pSlotName, prettyName: this._prettyKey(pSlotName), artifactType: tmpArtifactType, count: pArray.length };

		// Annotation slots are overlay geometry, not user-facing data.
		if (pSlotName === 'Annotation') { return Object.assign(tmpBase, { kind: 'skip' }); }

		// Media slots: build item list (image tiles / file links / a/v).
		if (tmpMediaKind)
		{
			const tmpItems = pArray.map((pArtifact) =>
			{
				const tmpDatum = pArtifact.Datum || {};
				return {
					idArtifact: pArtifact.IDArtifact,
					version: (pArtifact.Version != null) ? pArtifact.Version : 1,
					mediaKind: tmpMediaKind,
					fileName: tmpDatum.FileName || pArtifact.Name || tmpArtifactType,
					mimeType: tmpDatum.FileMimeType || '',
					url: this.artifactMediaURL(pArtifact.IDArtifact, (pArtifact.Version != null) ? pArtifact.Version : 1)
				};
			});
			return Object.assign(tmpBase, { kind: 'media', mediaKind: tmpMediaKind, items: tmpItems });
		}

		// Prose slots: a Data_String / MultiLine text capture (journal narrative).
		const tmpLooksProse = (tmpArtifactType === 'Data_String')
			|| pArray.every((pArtifact) => { const d = pArtifact.Datum || {}; return (d.MultiLine === true) || (('Value' in d) && (Object.keys(d).filter((k) => k !== 'MultiLine').length === 1)); });
		if (tmpLooksProse)
		{
			const tmpTexts = pArray
				.map((pArtifact) => { const d = pArtifact.Datum || {}; return (d.Value != null) ? String(d.Value) : ''; })
				.filter((pText) => pText !== '');
			if (tmpTexts.length) { return Object.assign(tmpBase, { kind: 'prose', texts: tmpTexts }); }
		}

		// Structured slots: derive columns (schema-driven, else union of keys).
		const tmpColumns = this._columnsForSlot(pSlotName, pArray, pSpecification);
		const tmpRows = pArray.map((pArtifact) => pArtifact.Datum || {});
		const tmpSlotSpec = this._findSlotSpecification(pSpecification, pSlotName);
		const tmpIsTable = (pArray.length > 1) || (!!tmpSlotSpec && tmpSlotSpec.countMax > 1);
		return Object.assign(tmpBase, { kind: tmpIsTable ? 'table' : 'fields', columns: tmpColumns, rows: tmpRows });
	}

	/**
	 * The spec slot named `pSlotName`, or null.  A plain loop rather than Array.prototype.find: some host pages
	 * (legacy AngularJS apps) carry a collections shim that redefines `find` to take a value, not a predicate.
	 */
	_findSlotSpecification(pSpecification, pSlotName)
	{
		const tmpSlots = (pSpecification && Array.isArray(pSpecification.slots)) ? pSpecification.slots : [];
		for (let i = 0; i < tmpSlots.length; i++)
		{
			if (tmpSlots[i] && (tmpSlots[i].name === pSlotName))
			{
				return tmpSlots[i];
			}
		}
		return null;
	}

	/**
	 * Columns for a structured slot.  Schema-driven when the spec has the slot's
	 * ArtifactType (ordered, labelled, visibility-filtered); otherwise the union
	 * of non-noise Datum keys across all rows, in first-seen order.
	 */
	_columnsForSlot(pSlotName, pArray, pSpecification)
	{
		if (pSpecification)
		{
			const tmpSlot = this._findSlotSpecification(pSpecification, pSlotName);
			if (tmpSlot)
			{
				const tmpSchema = (tmpSlot.idArtifactType && pSpecification.schemasByID[tmpSlot.idArtifactType])
					|| (pArray[0] && pArray[0].ArtifactType && pSpecification.schemasByName[pArray[0].ArtifactType]);
				if (tmpSchema && tmpSchema.columns && tmpSchema.columns.length)
				{
					return tmpSchema.columns.map((pColumn) => ({ key: pColumn.key, label: pColumn.label, type: pColumn.type }));
				}
			}
		}
		// Fallback: union of keys across the rows.
		const tmpSeen = {};
		const tmpColumns = [];
		pArray.forEach((pArtifact) =>
		{
			const tmpDatum = pArtifact.Datum || {};
			Object.keys(tmpDatum).forEach((pKey) =>
			{
				if (tmpSeen[pKey] || this._isNoiseKey(pKey, pArtifact.ArtifactType)) { return; }
				tmpSeen[pKey] = true;
				tmpColumns.push({ key: pKey, label: this._prettyKey(pKey), type: (typeof tmpDatum[pKey] === 'number') ? 'number' : 'string' });
			});
		});
		return tmpColumns;
	}

	// ---- Format renderers ----------------------------------------------

	_renderFull(pModel)
	{
		const tmpHero = pModel.hasImage
			? `<div class="hor-hero"><img class="hor-hero-img" src="${this._esc(pModel.imagePreviewURL)}" alt="${this._esc(pModel.name)}" onerror="this.parentNode.classList.add('hor-broken')"/></div>`
			: '';

		const tmpMeta = `<div class="hor-meta">
			${this._metaField('Name', pModel.name)}
			${this._metaField('Type', pModel.typeLabel)}
			${pModel.status ? this._metaField('Status', pModel.status) : ''}
			${pModel.when ? this._metaField('Observed', this._fmtDate(pModel.when)) : ''}
			${pModel.creatorName ? this._metaField('Captured by', pModel.creatorName) : ''}
			${(pModel.version != null && pModel.version !== '') ? this._metaField('Version', pModel.version) : ''}
		</div>`;

		const tmpDesc = pModel.description
			? `<div class="hor-desc"><div class="hor-meta-label">Description</div><div class="hor-desc-body">${this._esc(pModel.description)}</div></div>`
			: '';

		const tmpDataSlots = pModel.slots
			.filter((pSlot) => pSlot.kind !== 'skip' && !(pSlot.isHeroSource && pSlot.count === 1))
			.map((pSlot) => this._slotCardHTML(pSlot))
			.filter(Boolean)
			.join('');
		const tmpData = tmpDataSlots
			? `<div class="hor-section-h">Captured data</div><div class="hor-slots">${tmpDataSlots}</div>`
			: (pModel.hasDetails ? '' : '<div class="hor-note">No captured data on this observation.</div>');

		return `<div class="hor hor-full">${tmpHero}${tmpMeta}${tmpDesc}${tmpData}${this._labelsHTML(pModel)}</div>`;
	}

	/** Captured-data slots + labels only (no hero / meta / description) — for embedding beside a caller's own chrome. */
	_renderData(pModel)
	{
		const tmpDataSlots = pModel.slots
			.filter((pSlot) => pSlot.kind !== 'skip')
			.map((pSlot) => this._slotCardHTML(pSlot))
			.filter(Boolean)
			.join('');
		const tmpData = tmpDataSlots ? `<div class="hor-slots">${tmpDataSlots}</div>` : '<div class="hor-note">No captured data on this observation.</div>';
		return `<div class="hor hor-data">${tmpData}${this._labelsHTML(pModel)}</div>`;
	}

	_renderCard(pModel)
	{
		const tmpMedia = pModel.hasImage
			? `<div class="hor-card-media"><img src="${this._esc(pModel.imageThumbURL)}" alt="" loading="lazy" onerror="this.parentNode.classList.add('hor-broken');this.parentNode.innerHTML='${this._glyphHTML(pModel.type)}'"/></div>`
			: `<div class="hor-card-media hor-glyph">${this._glyphHTML(pModel.type)}</div>`;
		const tmpHeadline = this._headlineFields(pModel, 3)
			.map((pField) => `<div class="hor-kv"><span class="hor-k">${this._esc(pField.label)}</span><span class="hor-v">${pField.value}</span></div>`)
			.join('');
		return `<div class="hor hor-card">${tmpMedia}
			<div class="hor-card-body">
				<div class="hor-card-title">${this._esc(pModel.name)}</div>
				<div class="hor-card-sub"><span class="hor-type-dot"></span>${this._esc(pModel.typeLabel || 'Observation')}${pModel.when ? ` · <span class="hor-muted">${this._esc(this._fmtDateShort(pModel.when))}</span>` : ''}</div>
				${tmpHeadline ? `<div class="hor-card-fields">${tmpHeadline}</div>` : ''}
			</div>
		</div>`;
	}

	_renderStrip(pModel)
	{
		const tmpThumb = pModel.hasImage
			? `<img class="hor-strip-thumb" src="${this._esc(pModel.imageThumbURL)}" alt="" loading="lazy" onerror="this.outerHTML='<span class=&quot;hor-strip-thumb hor-glyph&quot;>${this._glyphHTML(pModel.type)}</span>'"/>`
			: `<span class="hor-strip-thumb hor-glyph">${this._glyphHTML(pModel.type)}</span>`;
		const tmpHeadline = this._headlineFields(pModel, 2)
			.map((pField) => `<span class="hor-strip-kv"><span class="hor-k">${this._esc(pField.label)}</span> ${pField.value}</span>`)
			.join('');
		return `<div class="hor hor-strip">${tmpThumb}
			<div class="hor-strip-body">
				<div class="hor-strip-title">${this._esc(pModel.name)}</div>
				<div class="hor-strip-sub"><span class="hor-type-dot"></span>${this._esc(pModel.typeLabel || 'Observation')}${pModel.when ? ` · ${this._esc(this._fmtDateShort(pModel.when))}` : ''}</div>
				${tmpHeadline ? `<div class="hor-strip-fields">${tmpHeadline}</div>` : ''}
			</div>
		</div>`;
	}

	_renderTooltip(pModel)
	{
		const tmpMedia = pModel.hasImage
			? `<div class="hor-tip-media"><img src="${this._esc(pModel.imageThumbURL)}" alt="" loading="lazy" onerror="this.parentNode.classList.add('hor-broken')"/></div>`
			: '';
		const tmpHeadline = this._headlineFields(pModel, 4)
			.map((pField) => `<div class="hor-kv"><span class="hor-k">${this._esc(pField.label)}</span><span class="hor-v">${pField.value}</span></div>`)
			.join('');
		return `<div class="hor hor-tooltip">${tmpMedia}
			<div class="hor-tip-body">
				<div class="hor-tip-title">${this._esc(pModel.name)}</div>
				<div class="hor-tip-sub"><span class="hor-type-dot"></span>${this._esc(pModel.typeLabel || 'Observation')}</div>
				<div class="hor-tip-meta">${pModel.when ? this._esc(this._fmtDate(pModel.when)) : ''}${pModel.creatorName ? ` · ${this._esc(pModel.creatorName)}` : ''}</div>
				${tmpHeadline ? `<div class="hor-tip-fields">${tmpHeadline}</div>` : ''}
			</div>
		</div>`;
	}

	_renderThumbnail(pModel)
	{
		const tmpInner = pModel.hasImage
			? `<img src="${this._esc(pModel.imageThumbURL)}" alt="${this._esc(pModel.name)}" loading="lazy" onerror="this.parentNode.classList.add('hor-broken');this.parentNode.innerHTML='${this._glyphHTML(pModel.type)}<span class=&quot;hor-thumb-init&quot;>${this._esc(this._initials(pModel.creatorName))}</span>'"/>`
			: `${this._glyphHTML(pModel.type)}`;
		return `<div class="hor hor-thumbnail" title="${this._esc(pModel.name)}">${tmpInner}<span class="hor-thumb-cap">${this._esc(this._fmtDateShort(pModel.when))}</span></div>`;
	}

	_renderMarker(pModel)
	{
		return `<span class="hor hor-marker"><strong>${this._esc(pModel.name)}</strong>${pModel.typeLabel ? ` · ${this._esc(pModel.typeLabel)}` : ''}</span>`;
	}

	// ---- Slot card renderers (full format) ------------------------------

	_slotCardHTML(pSlot)
	{
		let tmpBody = '';
		let tmpWide = '';
		switch (pSlot.kind)
		{
			case 'media': tmpBody = this._mediaSlotHTML(pSlot); break;
			case 'prose': tmpBody = this._proseSlotHTML(pSlot); tmpWide = ' hor-slot-wide'; break;
			case 'table': tmpBody = this._tableSlotHTML(pSlot); tmpWide = ' hor-slot-wide'; break;
			case 'fields': tmpBody = this._fieldsSlotHTML(pSlot); break;
			default: return '';
		}
		if (!tmpBody) { return ''; }
		const tmpBadgeParts = [];
		if (pSlot.showArtifactType !== false)
		{
			tmpBadgeParts.push(this._esc(pSlot.artifactType));
		}
		if (pSlot.count > 1)
		{
			tmpBadgeParts.push(String(pSlot.count));
		}
		const tmpBadge = tmpBadgeParts.length ? `<span class="hor-badge">${tmpBadgeParts.join(' · ')}</span>` : '';
		return `<div class="hor-slot${tmpWide}"><div class="hor-slot-h"><span>${this._esc(pSlot.prettyName)}</span>${tmpBadge}</div><div class="hor-slot-b">${tmpBody}</div></div>`;
	}

	_tableSlotHTML(pSlot)
	{
		const tmpColumns = pSlot.columns && pSlot.columns.length ? pSlot.columns : this._columnsFromRows(pSlot.rows);
		if (!tmpColumns.length) { return ''; }
		const tmpHead = tmpColumns.map((pColumn) => `<th class="${pColumn.type === 'number' ? 'hor-num' : ''}">${this._esc(pColumn.label)}</th>`).join('');
		const tmpBody = pSlot.rows.map((pRow) =>
		{
			const tmpCells = tmpColumns.map((pColumn) =>
			{
				const tmpValue = pRow ? pRow[pColumn.key] : undefined;
				return `<td class="${pColumn.type === 'number' ? 'hor-num' : ''}">${this._fmtCell(tmpValue)}</td>`;
			}).join('');
			return `<tr>${tmpCells}</tr>`;
		}).join('');
		return `<div class="hor-tablewrap"><table class="hor-table"><thead><tr>${tmpHead}</tr></thead><tbody>${tmpBody}</tbody></table></div>`;
	}

	_fieldsSlotHTML(pSlot)
	{
		const tmpDatum = pSlot.rows[0] || {};
		const tmpColumns = pSlot.columns && pSlot.columns.length ? pSlot.columns : this._columnsFromRows(pSlot.rows);
		const tmpRows = tmpColumns
			.map((pColumn) =>
			{
				const tmpValue = tmpDatum[pColumn.key];
				if (tmpValue == null || tmpValue === '') { return ''; }
				if ((typeof tmpValue === 'string') && this._isLongText(tmpValue))
				{
					return `<div class="hor-textblock"><div class="hor-k">${this._esc(pColumn.label)}</div><div class="hor-textbody">${this._esc(tmpValue)}</div></div>`;
				}
				return `<div class="hor-kv"><span class="hor-k">${this._esc(pColumn.label)}</span><span class="hor-v">${this._fmtValue(tmpValue)}</span></div>`;
			})
			.filter(Boolean)
			.join('');
		return tmpRows ? `<div class="hor-kvlist">${tmpRows}</div>` : '<span class="hor-muted">No structured data.</span>';
	}

	_proseSlotHTML(pSlot)
	{
		return pSlot.texts.map((pText) => `<div class="hor-textbody">${this._esc(pText)}</div>`).join('');
	}

	_mediaSlotHTML(pSlot)
	{
		return pSlot.items.map((pItem) =>
		{
			if (pItem.mediaKind === 'image')
			{
				return `<a class="hor-media-img" href="${this._esc(pItem.url)}" target="_blank" rel="noopener"><img src="${this._esc(pItem.url)}" alt="${this._esc(pItem.fileName)}" loading="lazy" onerror="this.parentNode.classList.add('hor-broken')"/></a>`;
			}
			const tmpIcon = (pItem.mediaKind === 'video') ? 'fa-video' : (pItem.mediaKind === 'audio') ? 'fa-volume-high' : 'fa-file';
			return `<a class="hor-media-file" href="${this._esc(pItem.url)}" target="_blank" rel="noopener"><i class="fas ${tmpIcon}"></i> ${this._esc(pItem.fileName)}</a>`;
		}).join('');
	}

	// ---- Small helpers --------------------------------------------------

	/** Headline datums for compact formats: first structured slot's first row, first N non-empty fields. */
	_headlineFields(pModel, pCount)
	{
		const tmpMax = pCount || 3;
		const tmpOut = [];
		for (let s = 0; s < pModel.slots.length && tmpOut.length < tmpMax; s++)
		{
			const tmpSlot = pModel.slots[s];
			if (tmpSlot.kind === 'prose' && tmpSlot.texts && tmpSlot.texts.length)
			{
				const tmpText = tmpSlot.texts[0];
				tmpOut.push({ label: tmpSlot.prettyName, value: this._esc(tmpText.length > 80 ? `${tmpText.slice(0, 80)}…` : tmpText) });
				continue;
			}
			if ((tmpSlot.kind === 'table' || tmpSlot.kind === 'fields') && tmpSlot.rows && tmpSlot.rows.length)
			{
				const tmpRow = tmpSlot.rows[0] || {};
				const tmpColumns = tmpSlot.columns && tmpSlot.columns.length ? tmpSlot.columns : this._columnsFromRows(tmpSlot.rows);
				for (let c = 0; c < tmpColumns.length && tmpOut.length < tmpMax; c++)
				{
					const tmpValue = tmpRow[tmpColumns[c].key];
					if (tmpValue == null || tmpValue === '' || tmpValue === 0) { continue; }
					tmpOut.push({ label: tmpColumns[c].label, value: this._fmtValue(tmpValue) });
				}
			}
		}
		return tmpOut;
	}

	_columnsFromRows(pRows)
	{
		const tmpSeen = {};
		const tmpColumns = [];
		(pRows || []).forEach((pRow) =>
		{
			Object.keys(pRow || {}).forEach((pKey) =>
			{
				if (tmpSeen[pKey] || this._isNoiseKey(pKey)) { return; }
				tmpSeen[pKey] = true;
				tmpColumns.push({ key: pKey, label: this._prettyKey(pKey), type: (typeof pRow[pKey] === 'number') ? 'number' : 'string' });
			});
		});
		return tmpColumns;
	}

	_metaField(pLabel, pValue)
	{
		return `<div class="hor-meta-field"><div class="hor-meta-label">${this._esc(pLabel)}</div><div class="hor-meta-value">${(pValue == null || pValue === '') ? '<span class="hor-muted">—</span>' : this._esc(pValue)}</div></div>`;
	}

	_labelsHTML(pModel)
	{
		if (!pModel.labels || !pModel.labels.length) { return ''; }
		const tmpRows = pModel.labels
			.map((pLabel) => `<div class="hor-label"><span class="hor-label-t">${this._esc(pLabel.label)}</span>${pLabel.values.map((pValue) => `<span class="hor-chip">${this._esc(pValue)}</span>`).join('')}</div>`)
			.join('');
		return `<div class="hor-section-h">Labels</div><div class="hor-labels">${tmpRows}</div>`;
	}

	_glyphHTML(pType)
	{
		const tmpType = String(pType || '').toLowerCase();
		let tmpIcon = 'fa-clipboard-list';
		if (/image|photo|camera/.test(tmpType)) { tmpIcon = 'fa-image'; }
		else if (/video/.test(tmpType)) { tmpIcon = 'fa-video'; }
		else if (/audio|sound/.test(tmpType)) { tmpIcon = 'fa-volume-high'; }
		else if (/file|document/.test(tmpType)) { tmpIcon = 'fa-file'; }
		else if (/weather|temperature/.test(tmpType)) { tmpIcon = 'fa-cloud-sun'; }
		else if (/equipment|material|goods/.test(tmpType)) { tmpIcon = 'fa-truck'; }
		else if (/safety/.test(tmpType)) { tmpIcon = 'fa-helmet-safety'; }
		else if (/personnel|staff|labor/.test(tmpType)) { tmpIcon = 'fa-users'; }
		else if (/narrative|journal|note/.test(tmpType)) { tmpIcon = 'fa-align-left'; }
		return `<i class="fas ${tmpIcon}"></i>`;
	}

	_initials(pName)
	{
		return String(pName || '').split(/\s+/).filter(Boolean).map((pPart) => pPart[0]).join('').slice(0, 2).toUpperCase();
	}

	_prettyKey(pKey) { return String(pKey || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ').replace(/\s+/g, ' ').trim(); }

	_isURL(pValue) { return /^https?:\/\//i.test(String(pValue)); }

	_isLongText(pValue) { const s = String(pValue); return (s.length > 110) || (s.indexOf('\n') >= 0); }

	_isNoiseKey(pKey, pArtifactType)
	{
		if (pKey === 'MultiLine' || pKey === 'URL') { return true; }
		if ((pArtifactType === 'File' || pArtifactType === 'Data_File' || pArtifactType === 'Video' || pArtifactType === 'Audio')
			&& (pKey === 'FileName' || pKey === 'FileMimeType' || pKey === 'AllowedMimeTypes')) { return true; }
		return false;
	}

	_fmtValue(pValue)
	{
		if (typeof pValue === 'boolean') { return pValue ? 'Yes' : 'No'; }
		if (typeof pValue === 'number') { return this._esc(Number.isInteger(pValue) ? pValue.toLocaleString() : pValue.toLocaleString(undefined, { maximumFractionDigits: 4 })); }
		const tmpString = String(pValue);
		if (this._isURL(tmpString)) { return `<a class="hor-link" href="${this._esc(tmpString)}" target="_blank" rel="noopener">${this._esc(tmpString.length > 48 ? `${tmpString.slice(0, 48)}…` : tmpString)}</a>`; }
		return this._esc(tmpString);
	}

	/** Table cell: empty renders as a blank cell (sparse spreadsheet rows are normal). */
	_fmtCell(pValue)
	{
		if (pValue == null || pValue === '') { return ''; }
		return this._fmtValue(pValue);
	}

	_fmtDate(pValue)
	{
		if (!pValue) { return ''; }
		try { const d = new Date(pValue); if (!Number.isNaN(d.getTime())) { return d.toLocaleString(); } } catch (pError) { /* fall through */ }
		return String(pValue).replace('T', ' ').slice(0, 16);
	}

	_fmtDateShort(pValue)
	{
		if (!pValue) { return ''; }
		try { const d = new Date(pValue); if (!Number.isNaN(d.getTime())) { return d.toLocaleDateString(); } } catch (pError) { /* fall through */ }
		return String(pValue).slice(0, 10);
	}

	_esc(pValue)
	{
		if (pValue == null) { return ''; }
		return String(pValue)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	// ---- Styles ---------------------------------------------------------

	/**
	 * Idempotently inject the stylesheet into a document's <head>.  Called
	 * automatically by renderObservationHTML (browser only); safe to call
	 * directly at registration.  Pass a document to target a specific one.
	 */
	injectStyles(pDocument)
	{
		const tmpDoc = pDocument || ((typeof document !== 'undefined') ? document : null);
		if (!tmpDoc || (typeof tmpDoc.getElementById !== 'function')) { return false; }
		if (this._StylesInjected && tmpDoc.getElementById('HeadlightObservationRender-Styles')) { return true; }
		if (tmpDoc.getElementById('HeadlightObservationRender-Styles')) { this._StylesInjected = true; return true; }
		try
		{
			const tmpStyle = tmpDoc.createElement('style');
			tmpStyle.id = 'HeadlightObservationRender-Styles';
			tmpStyle.textContent = this.renderStyles();
			(tmpDoc.head || tmpDoc.getElementsByTagName('head')[0] || tmpDoc.documentElement).appendChild(tmpStyle);
			this._StylesInjected = true;
			return true;
		}
		catch (pError) { return false; }
	}

	/** The stylesheet as a string (for injectStyles, or to inline in a headless render). */
	renderStyles()
	{
		return /*css*/`
.hor { --hor-fg:#1f2733; --hor-muted:#8a94a3; --hor-border:#e6eaf0; --hor-bg:#fff; --hor-soft:#f6f8fb; --hor-accent:#2f6fed; color:var(--hor-fg); font-size:0.9rem; line-height:1.4; box-sizing:border-box; }
.hor *, .hor *::before, .hor *::after { box-sizing:border-box; }
.hor-muted { color:var(--hor-muted); }
.hor-link { color:var(--hor-accent); text-decoration:none; } .hor-link:hover { text-decoration:underline; }
.hor-section-h { font-size:0.7rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--hor-muted); margin:1rem 0 0.5rem; }
.hor-note { color:var(--hor-muted); font-style:italic; padding:0.6rem 0; }
.hor-type-dot { display:inline-block; width:0.5rem; height:0.5rem; border-radius:50%; background:var(--hor-accent); margin-right:0.35rem; vertical-align:middle; }
.hor-chip { display:inline-block; background:var(--hor-soft); border:1px solid var(--hor-border); border-radius:999px; padding:0.05rem 0.5rem; font-size:0.78rem; margin:0 0.25rem 0.25rem 0; }
.hor-glyph { color:var(--hor-muted); display:flex; align-items:center; justify-content:center; }
.hor-glyph i { font-size:1.6em; }
.hor-broken img { display:none; }

/* full */
.hor-full { display:flex; flex-direction:column; }
.hor-hero { text-align:center; margin-bottom:0.9rem; }
.hor-hero-img { max-width:100%; max-height:22rem; border-radius:8px; border:1px solid var(--hor-border); }
.hor-broken.hor-hero::after { content:'no image'; color:var(--hor-muted); font-size:0.8rem; }
.hor-meta { display:grid; grid-template-columns:repeat(auto-fill,minmax(11rem,1fr)); gap:0.6rem; }
.hor-meta-field { min-width:0; }
.hor-meta-label { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--hor-muted); }
.hor-meta-value { font-size:0.92rem; overflow-wrap:anywhere; }
.hor-desc { margin-top:0.8rem; }
.hor-desc-body, .hor-textbody { white-space:pre-wrap; overflow-wrap:anywhere; background:var(--hor-soft); border:1px solid var(--hor-border); border-radius:8px; padding:0.55rem 0.7rem; }
.hor-slots { display:grid; grid-template-columns:repeat(auto-fill,minmax(16rem,1fr)); gap:0.7rem; align-items:start; }
.hor-slot { border:1px solid var(--hor-border); border-radius:10px; background:var(--hor-bg); overflow:hidden; }
.hor-slot-wide { grid-column:1/-1; }
.hor-slot-h { display:flex; justify-content:space-between; align-items:center; gap:0.5rem; padding:0.45rem 0.7rem; background:var(--hor-soft); border-bottom:1px solid var(--hor-border); font-weight:600; font-size:0.85rem; }
.hor-badge { font-size:0.66rem; font-weight:700; color:var(--hor-muted); background:var(--hor-bg); border:1px solid var(--hor-border); border-radius:6px; padding:0.05rem 0.4rem; white-space:nowrap; }
.hor-slot-b { padding:0.55rem 0.7rem; }
.hor-kvlist { display:flex; flex-direction:column; gap:0.3rem; }
.hor-kv { display:flex; justify-content:space-between; gap:0.75rem; font-size:0.85rem; }
.hor-k { color:var(--hor-muted); } .hor-v { text-align:right; overflow-wrap:anywhere; }
.hor-textblock .hor-k { display:block; margin-bottom:0.25rem; }
.hor-tablewrap { overflow-x:auto; }
.hor-table { border-collapse:collapse; width:100%; font-size:0.82rem; }
.hor-table th, .hor-table td { border-bottom:1px solid var(--hor-border); padding:0.3rem 0.5rem; text-align:left; white-space:nowrap; }
.hor-table thead th { position:sticky; top:0; background:var(--hor-soft); font-size:0.68rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--hor-muted); }
.hor-table td.hor-num, .hor-table th.hor-num { text-align:right; font-variant-numeric:tabular-nums; }
.hor-table tbody tr:hover { background:var(--hor-soft); }
.hor-media-img img { max-width:9rem; max-height:9rem; border-radius:6px; border:1px solid var(--hor-border); margin:0 0.4rem 0.4rem 0; }
.hor-media-file { display:inline-flex; gap:0.4rem; align-items:center; color:var(--hor-accent); text-decoration:none; padding:0.2rem 0; }
.hor-labels { display:flex; flex-direction:column; gap:0.4rem; }
.hor-label-t { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:var(--hor-muted); margin-right:0.5rem; }

/* card */
.hor-card { width:100%; max-width:20rem; border:1px solid var(--hor-border); border-radius:10px; overflow:hidden; background:var(--hor-bg); }
.hor-card-media { height:9rem; background:var(--hor-soft); display:flex; align-items:center; justify-content:center; overflow:hidden; }
.hor-card-media img { width:100%; height:100%; object-fit:cover; }
.hor-card-media.hor-glyph i { font-size:2.4em; }
.hor-card-body { padding:0.55rem 0.7rem; }
.hor-card-title { font-weight:600; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.hor-card-sub { font-size:0.78rem; color:var(--hor-fg); margin:0.15rem 0 0.35rem; }
.hor-card-fields { display:flex; flex-direction:column; gap:0.2rem; }

/* strip (map rail item) */
.hor-strip { display:flex; gap:0.6rem; align-items:flex-start; padding:0.5rem; border:1px solid var(--hor-border); border-radius:9px; background:var(--hor-bg); }
.hor-strip-thumb { flex:0 0 auto; width:3rem; height:3rem; border-radius:6px; object-fit:cover; background:var(--hor-soft); border:1px solid var(--hor-border); }
span.hor-strip-thumb { display:flex; align-items:center; justify-content:center; }
.hor-strip-body { min-width:0; flex:1 1 auto; }
.hor-strip-title { font-weight:600; font-size:0.86rem; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.hor-strip-sub { font-size:0.74rem; color:var(--hor-muted); margin:0.1rem 0; }
.hor-strip-fields { display:flex; flex-wrap:wrap; gap:0.5rem; font-size:0.76rem; }
.hor-strip-kv .hor-k { color:var(--hor-muted); }

/* tooltip */
.hor-tooltip { display:flex; gap:0.6rem; max-width:22rem; padding:0.5rem; }
.hor-tip-media img { width:5rem; height:5rem; object-fit:cover; border-radius:6px; border:1px solid var(--hor-border); }
.hor-tip-body { min-width:0; }
.hor-tip-title { font-weight:600; }
.hor-tip-sub { font-size:0.78rem; }
.hor-tip-meta { font-size:0.74rem; color:var(--hor-muted); margin:0.15rem 0 0.35rem; }
.hor-tip-fields { display:flex; flex-direction:column; gap:0.2rem; font-size:0.8rem; }

/* thumbnail */
.hor-thumbnail { position:relative; width:8rem; height:8rem; border-radius:8px; overflow:hidden; background:var(--hor-soft); border:1px solid var(--hor-border); display:flex; align-items:center; justify-content:center; }
.hor-thumbnail img { width:100%; height:100%; object-fit:cover; }
.hor-thumbnail i { font-size:2.4em; color:var(--hor-muted); }
.hor-thumb-init { position:absolute; font-weight:700; color:var(--hor-muted); }
.hor-thumb-cap { position:absolute; bottom:0; left:0; right:0; background:rgba(0,0,0,0.55); color:#fff; font-size:0.66rem; text-align:center; padding:0.1rem 0; }

/* marker */
.hor-marker { font-size:0.82rem; }
`;
	}
}

module.exports = WebHeadlightObservationRenderService;

module.exports.default_configuration = (
{
	Name:        'HeadlightObservationRender',
	ServiceType: 'HeadlightObservationRender'
});

},{"fable-serviceproviderbase":438}],30:[function(require,module,exports){

const Util = require('util');

const PictApplication = require('pict-application');
const PictSectionForm = require('pict-section-form');
const PictFormMetacontroller = require('pict-section-form/source/views/Pict-View-Form-Metacontroller.js');
const PictSectionModal = require('pict-section-modal');
const HeadlightQRCodeBundle = require('headlight-qrcode-web');

const HeadlightRestClient = require('headlight-rest-client');
const HeadlightViewSignatures = require('headlight-view-signatures');
const HeadlightPanels = require('headlight-view-panels');
const HeadlightViewLogin = require('headlight-view-login');

const InputTypeBehaviorProvider = require('./providers/InputTypeBehaviorProvider.js');
const DistillingProvider = require('./providers/DistillingProvider.js');
const AutoSaveProvider = require('./providers/AutoSaveProvider.js');
const DocumentFrameProvider = require('./providers/DocumentFrameProvider.js');

const ManifestConditionEvaluator = require('./services/ManifestConditionEvaluator.js');
const HeadlightFormLoadTiming = require('./services/Headlight-FormLoadTiming.js');

const libHeadlightQuickSummariesService = require('../../../../lib/web/headlight-quick-summaries/Headlight-Quick-Summaries-Service.js');

//FIXME: hack to hook into onAfterRenderAsync to perform local initialization
const originalPictFormMetacontrollerOnAfterRenderAsync = PictFormMetacontroller.prototype.onAfterRenderAsync;
PictFormMetacontroller.prototype.onAfterRenderAsync = function(pRenderable)
{
	const res = originalPictFormMetacontrollerOnAfterRenderAsync.call(this, pRenderable);
	this.onAfterRenderAsyncCallbacks?.forEach((callback) => callback());
	return res;
};

//FIXME: hack to hook into onAfterRender to perform local initialization
const originalPictFormMetacontrollerOnAfterMarshalToView = PictFormMetacontroller.prototype.onAfterMarshalToView;
PictFormMetacontroller.prototype.onAfterMarshalToView = function()
{
	const res = originalPictFormMetacontrollerOnAfterMarshalToView.call(this);
	this.onAfterMarshalToViewCallbacks?.forEach((callback) => callback());
	return res;
};

/** @typedef {import('./providers/DistillingProvider.js').FieldDistillingMapping} FieldDistillingMapping */

/**
 * FIXME: figure out how to flow these types through in a more sane way...
 * @typedef {import('pict') & import('fable') &
 * {
 *   HeadlightRestClient: import('headlight-rest-client'),
 *   MetaTemplate: any, // import('fable').MetaTemplate,
 *   views: { PictFormMetacontroller: import('pict-section-form').PictFormMetacontroller },
 *   fable: import('fable'),
 *   PictApplication: HeadlightConfigurableApplication,
 *   providers: {
 *     Input: import('./providers/InputTypeBehaviorProvider'),
 *     Distilling: import('./providers/DistillingProvider'),
 *     AutoSave: import('./providers/AutoSaveProvider'),
 *     PictFormSectionDefaultTemplateProvider: import('pict-section-form').PictFormTemplateProvider,
 *   },
 *   options: {
 *     Timezone: string,
 *     [key: string]: any,
 *   },
 * }} Pict
 */

/** @typedef {import('fable')} Fable */
/** @typedef {(pError?: Error) => void} ErrorCallback */


/**
 * Base class for Pict applications with configuration driven UI.
 *
 * Comes with pre-registered stock views and providers.
 *
 * NOTE: This class is a merge of each layer with an attempt to normalize and refactor.
 */
class HeadlightConfigurableApplication extends PictApplication
{
	/**
	 * Apply default options to the passed in options, if absent.
	 *
	 * @param {Object} pOptions - The options to apply defaults to.
	 */
	static applyDefaultOptions(pOptions)
	{
		if (!pOptions.Login)
		{
			pOptions.Login = { };
		}
		if (!('Required' in pOptions.Login))
		{
			pOptions.Login.Required = true;
		}
		if (!pOptions.Document)
		{
			pOptions.Document = { };
		}
		if (!('Required' in pOptions.Document))
		{
			pOptions.Document.Required = true;
		}
	}

	/**
	 * Check whether a builtin section should be rendered.
	 *
	 * Builtin section values follow this convention:
	 *   - `undefined` / `null` → enabled (shown by default)
	 *   - `false`              → disabled (hidden)
	 *   - `true`               → enabled
	 *   - any other value (e.g. a template string) → enabled (future use)
	 *
	 * @param {boolean | string | undefined | null} pBuiltinValue - The value from `manifest.Builtins.<Section>`.
	 * @return {boolean} `true` if the section should be shown, `false` if it should be hidden.
	 */
	static isBuiltinSectionEnabled(pBuiltinValue)
	{
		if (pBuiltinValue === undefined || pBuiltinValue === null)
		{
			return true;
		}
		return pBuiltinValue !== false;
	}

	/**
	 * Perform any pre-processing needed on the form definition.
	 *
	 * @param {Object<String, any>} formDefinition - The form definition to preprocess.
	 *
	 * @return {Object<String, any>} - The processed form definition. (it's just the original one, mutated)
	 */
	static preprocessFormDefinition(formDefinition)
	{
		//NOTE: This prevents PictSectionForm from automatically bootstrapping views and allows us to control when that happens.
		if (formDefinition?.DefaultFormManifest)
		{
			formDefinition.MyDefaultFormManifest = formDefinition.DefaultFormManifest;
			delete formDefinition.DefaultFormManifest;
		}
		// duck typing
		if (!formDefinition?.MyDefaultFormManifest?.Descriptors)
		{
			console.error(`Form manifest Descriptors is missing. No form configuration found.`, { formDefinition });
			return formDefinition;
		}
		let descriptors = formDefinition.MyDefaultFormManifest.Descriptors;
		descriptors = HeadlightConfigurableApplication.repairDescriptorMap(descriptors) || descriptors;
		descriptors = HeadlightConfigurableApplication.backfillWidthValueForDescriptors(descriptors) || descriptors;
		for (const descriptor of Object.values(descriptors))
		{
			InputTypeBehaviorProvider.validateDescriptor(descriptor);
			if (descriptor.PictForm?.DistillingKey)
			{
				if (descriptor.PictForm?.SelectOptionsPickList)
				{
					continue;
				}
				const tmpPickLists = formDefinition.MyDefaultFormManifest.PickLists || [];
				formDefinition.MyDefaultFormManifest.PickLists = tmpPickLists;
				const tmpPickListHash = `Distilling-${descriptor.PictForm.DistillingBundleHash}-${descriptor.PictForm.DistillingKey}`;
				descriptor.PictForm.SelectOptionsPickList = tmpPickListHash;
				if (!tmpPickLists.find((pl) => pl.Hash === tmpPickListHash))
				{
					tmpPickLists.push({ Hash: tmpPickListHash, Dynamic: true });
				}
			}
		}
		formDefinition.MyDefaultFormManifest.Descriptors = descriptors;
		return formDefinition;
	}

	/**
	 * Align all sections to 12 columns
	 *
	 * TODO: Pretty sure we can do this inside pict by making a default value but not sure how off the top of my head. Pre-process descriptors here
	 *
	 * @param {any} descriptorMap - The descriptor map to backfill.
	 *
	 * @return {any} - The backfilled descriptor map.
	 */
	static backfillWidthValueForDescriptors(descriptorMap)
	{
		if (Array.isArray(descriptorMap))
		{
			console.error(`Form manifest Descriptors is an array. Fatal error. Cannot continue.`, { descriptorMap });
			throw new Error('Descriptors should be an object, not an array');
		}

		for (const descriptor of Object.values(descriptorMap))
		{
			descriptor.Width = descriptor.Width || 1;
		}

		return descriptorMap;
	}

	/**
	 * Repair the descriptor map to be an object instead of an array.
	 *
	 * @param {any} descriptorMap - The descriptor map to repair.
	 *
	 * @return {Object<String, any> | any} - The repaired descriptor map, or the original value if it is not an array.
	 */
	static repairDescriptorMap(descriptorMap)
	{
		if (Array.isArray(descriptorMap))
		{
			console.error(`Form manifest Descriptors is an array which is not supported. Converting to object.`, { descriptorMap });
			//FIXME: this is a hack to make sure this works - template needs to be converted
			const newDescriptorMap = { };
			for (const descriptor of descriptorMap)
			{
				if (descriptor.Hash in newDescriptorMap)
				{
					console.error(`Duplicate descriptor hash found. Skipping.`, { descriptor });
					continue;
				}
				newDescriptorMap[descriptor.Hash] = descriptor;
			}
			console.trace(`Converted Descriptors to object.`, { newDescriptorMap });
			if (Object.keys(newDescriptorMap).length != descriptorMap.length)
			{
				console.error(`Descriptor map array had duplicate keys. Converted object is smaller. (${Object.keys(newDescriptorMap).length} != ${descriptorMap.length})`);
			}
			return newDescriptorMap;
		}
		return descriptorMap;
	}

	/**
	 * @param {Fable} pFable - The fable instance.
	 * @param {Object} [pOptions] - The options for the application.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = (pOptions || {});
		HeadlightConfigurableApplication.applyDefaultOptions(tmpOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Phase 0 form-load instrumentation. Constructed first so `Boot` is marked as early as the
		// application can mark anything; its startTime carries everything the page did before this.
		// See services/Headlight-FormLoadTiming.js for the phases and how to read the numbers.
		/** @type {HeadlightFormLoadTiming} */
		this.FormLoadTiming = new HeadlightFormLoadTiming(
		{
			Log: this.pict?.log,
			Context: this.options?.ApplicationName || 'Form',
		});
		this.markFormLoadPhase('Boot');

		/**
		 * FIXME: figure out how to flow these types through in a more sane way...
		 * @type {Pict}
		 */
		this.pict;

		/** @type {Fable} */
		this.fable;

		/** @type {any} */
		this.options;

		this.registerServiceTypes(
		{
			HeadlightRestClient,
			HeadlightStationing: require('../../../../lib/service/headlight-stationing-service/Headlight-Stationing.js'),
			HeadlightQRCodeHash: require('headlight-qrcode-hash'),
			HeadlightHintHighlighting: require('./services/Headlight-HintHighlighting.js'),
			HeadlightDocumentService: require('./services/Headlight-Document-Service.js'),
		});

		this.instantiateServices(
		{
			HeadlightRestClient: { ServerURL: this.options.HeadlightAPIURL || '/1.0/' },
			HeadlightStationing: { },
			HeadlightQRCodeHash: { },
			HeadlightHintHighlighting: { },
			HeadlightDocumentService: { },
		});

		/** @type {HeadlightViewSignatures} */
		this.pict.views.HeadlightSignatures;
		/**
		 * @type {HeadlightViewLogin}
		 */
		this.pict.views.HeadlightLogin;

		/**
		 * @type {Object<String, any>}
		 */
		this.services;

		// Add the pict form service
		this.pict.addServiceType('PictSectionForm', PictSectionForm);

		// Add the pict form metacontroller service, which provides programmaatic view construction from manifests and render/marshal methods.
		this.pict.addView('PictFormMetacontroller', {}, PictSectionForm.PictFormMetacontroller);

		this.pict.views.PictFormMetacontroller.onAfterRenderAsyncCallbacks = [];
		this.pict.views.PictFormMetacontroller.onAfterMarshalToViewCallbacks = [];

		// pict-section-modal — the canonical modal/tooltip view. Registered here in
		// the shared base so every web app and document that renders dynamic-input
		// forms has the tooltip surface the chips use (PictProvider-ChipTooltips
		// attaches pinnable tooltips to chip anchors). Guarded so an app that
		// already registered it (e.g. the data dashboards) isn't clobbered. Chips
		// degrade to native title tooltips if this is ever absent.
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addViewSingleton('Pict-Section-Modal', PictSectionModal.default_configuration, PictSectionModal);
		}
		/**
		 * @type {{
		 *	Interactive: boolean,
		 *	InitialSaveRequired: boolean,
		 *	Status: string,
		 *	DistillingMapping: Array<FieldDistillingMapping>,
		 *	Select2OptionsCache: Object<String, Array<{ id: string, text: string }>>,
		 *	DocumentData: any,
		 *	CurrentUser: any,
		 *	[key: string]: any, // allow for arbitrary data to be added
		 * }}
		 */
		this.AppData;
		// this is set on each index.html for the respective document behavior
		this.AppData.Interactive = window._InteractiveForm;

		// log noise level for pict
		this.pict.LogNoisiness = this.options.LogNoisiness ?? 0;

		//FIXME: what layer does this belong at - some kind of "reports" customization layer?
		const tempSessionToken = this.pict.ContentAssignment.readContent('#DocumentObjectSessionToken');
		if (tempSessionToken)
		{
			this.pict.HeadlightRestClient.setUrlParam('SessionToken', String(tempSessionToken));
		}

		// do a basic "to lower case" operation on the data
		this.pict.MetaTemplate.addPattern('{~ToLowerCase:', '~}', (pHash, pData, pContextArray) =>
		{
			const value = this.pict.manifest.getValueAtAddress(pData, pHash);
			return (value === undefined || value === null) ? '' : String(value).toLowerCase();
		});

		// create disabled attribute for values that are set to true
		this.pict.MetaTemplate.addPattern('{~Attr:', '~}', (pHash, pData, pContextArray) =>
		{
			// split on first colon only
			const [ attr, path ] = pHash.split(/:(.*)/s);
			if (!path)
			{
				this.pict.log.error('Invalid path in {~Attr:...~} pattern', pHash);
				return '';
			}

			let value = this.pict.manifest.getValueAtAddress(pData, path);
			if (!value)
			{
				return '';
			}

			// these attributes values should be the same as their name
			// I dont think this is a hard requirement but its cleaner than having random values in there
			if ([ 'disabled', 'readonly' ].includes(attr))
			{
				value = attr;
			}

			return `${attr}="${value}"`;
		});

		// include all three themes for the document (edit, read, print)
		this.registerProviders(
		{
			Input: { Provider: InputTypeBehaviorProvider, Options: { } },
			Distilling: { Provider: DistillingProvider, Options: { } },
			AutoSave: { Provider: AutoSaveProvider, Options: { } },
			DocumentFrame: { Provider: DocumentFrameProvider, Options: { } },
			SessionProvider: { Provider: require('../../../../web/providers/Session-Provider.js'), Options: { } },
		});

		// QR codes (headlight-qrcode-web): the HeadlightQR provider, its views and the `QRCode` form input. The keyboard
		// scanner is off unless an app turns it on (LIMS, the config app) or a scan session holds it (Scan Samples), so a
		// scanner never acts inside a form. Templates are added in registerTemplates().
		this.qrCodeBundle = new HeadlightQRCodeBundle(this.pict);
		this.qrCodeBundle.attach(
			{
				HeadlightQR:
				{
					EntitySource: new HeadlightQRCodeBundle.RestEntitySource(
						{
							getJSON: (pPath) => new Promise((fResolve) => this.pict.HeadlightRestClient.getJSON(pPath, (pError, pResult) => fResolve(pError ? null : pResult))),
						}),
					Wedge: { Enabled: false },
				},
				TemplatePrefixes: { Edit: [], Read: [], Print: [] },
			});

		// callbacks to run after the form is rendered
		this.pict.views.PictFormMetacontroller.onAfterRenderAsyncCallbacks.push(() =>
		{
			this.onAfterRenderAsync();
		});

		// callbacks to run after the form is marshalled to the view
		this.pict.views.PictFormMetacontroller.onAfterMarshalToViewCallbacks.push(() =>
		{
			// only run this if we are in interactive mode
			if (!this.AppData.Interactive)
			{
				return;
			}

			this.pict.log.info('onAfterMarshalToView running...');
			// find elements with dynamic-data-lookup and set their values based on entity and ID
			$('input.dynamic-data-lookup').each((_, element) =>
			{
				const $element = $(element);
				const entityType = $element.attr('data-entity-type');
				const entityDisplayField = $element.attr('data-entity-field');
				const entityIDField = $element.attr('data-entity-id');
				const entityIDElementID = $element.attr('data-entity-html-ref-id');
				const idElement = entityIDElementID ? $(`#${entityIDElementID}`) : null;

				let record;
				switch (entityType)
				{
				case 'Project':
					record = this.AppData.DocumentData?.ReportData?.Project;
					break;
				}
				const id = record?.[entityIDField];
				if (id && idElement)
				{
					idElement.val(id);
				}
				const value = record?.[entityDisplayField];
				if (value)
				{
					$element.val(value);
				}
			});
			this.pict.log.info('onAfterMarshalToView done.');
		});
		this.pict.serviceManager.addAndInstantiateServiceType('HeadlightQuickSummaries', libHeadlightQuickSummariesService);
	}

	/**
	 * Record a form-load phase for the Phase 0 latency instrumentation.
	 *
	 * The base marks Boot, SessionReady, DocumentLoaded and FirstRender itself. Subclasses mark
	 * SpinnerRemoved from their own removeLoadingSpinner(), which is what emits the summary line.
	 * Safe to call from anywhere: unknown or repeated phases are ignored and nothing here throws.
	 *
	 * @param {String} pPhase - One of the phases in services/Headlight-FormLoadTiming.js.
	 * @return {Boolean} True when this call recorded the phase.
	 */
	markFormLoadPhase(pPhase)
	{
		// Every mark call site sits in front of work the form needs (the render callback, the login
		// callback, the spinner teardown), so nothing below this line is allowed to escape.
		let tmpRecorded = false;
		try
		{
			tmpRecorded = this.FormLoadTiming ? this.FormLoadTiming.mark(pPhase) : false;
		}
		catch (pError)
		{
			tmpRecorded = false;
		}
		if (pPhase === 'SpinnerRemoved')
		{
			try
			{
				this.pict.providers.DocumentFrame?.announceReady(this.FormLoadTiming ? this.FormLoadTiming.summary() : null);
			}
			catch (pError)
			{
				this.pict.log.warn(`Could not tell the hosting page the form is ready: ${pError?.message || pError}`);
			}
		}
		return tmpRecorded;
	}

	/**
	 * Marshals data from any rendered dynamic views to application data.
	 */
	marshalDataFromDynamicViewsToAppData()
	{
		this.pict.views.PictFormMetacontroller.marshalFromView();
	}

	/**
	 * Marshals data from the application data to any rendered dynamic views.
	 */
	marshalDataFromAppDataToDynamicViews()
	{
		this.pict.views.PictFormMetacontroller.marshalToView();
	}

	/**
	 * Called during construction to register service types. Override to mutate or add service types.
	 *
	 * @param {Object<String, any>} pServiceTypes - The service types to register.
	 */
	registerServiceTypes(pServiceTypes)
	{
		for (const [ serviceHash, serviceClass ] of Object.entries(pServiceTypes))
		{
			this.fable.serviceManager.addServiceType(serviceHash, serviceClass);
		}
	}

	/**
	 * Called during construction to instantiate services. Override to mutate or add services and options.
	 *
	 * @param {Object<String, Object>} pServiceOptions - The service options to instantiate.
	 */
	instantiateServices(pServiceOptions)
	{
		for (const [ serviceHash, serviceOptions ] of Object.entries(pServiceOptions))
		{
			this.fable.serviceManager.instantiateServiceProvider(serviceHash, serviceOptions);
		}
	}

	/**
	 * Called during construction to register providers. Override to mutate or add providers.
	 *
	 * @param {Object<String, { Provider: any, Options: Object }>} pProviders - The providers to register.
	 */
	registerProviders(pProviders)
	{
		for (const [ providerHash, providerSetup ] of Object.entries(pProviders))
		{
			this.pict.addProvider(providerHash, providerSetup.Options, providerSetup.Provider);
		}
	}

	/**
	 * Called during onInitialize to instantiate shared views. Override to mutate or add shared views.
	 *
	 * @param {Object<String, { View: any, Options: Object }>} pViews - The views to instantiate.
	 */
	instantiateGlobalViews(pViews)
	{
		for (const [ viewHash, viewSetup ] of Object.entries(pViews))
		{
			viewSetup.preInitialize?.(this);
			this.pict.addView(viewHash, viewSetup.Options, viewSetup.View);
			viewSetup.postInitialize?.(this);
		}
	}

	/**
	 * The document's program logo, when its program has one.
	 * @return {string} - The source path for the document logo image
	 */
	getDocumentLogoSource()
	{
		const programId = this.AppData.DocumentData?.ReportData?.IDProgram;
		const programLogo = this.AppData.DocumentData?.ReportData?.ProgramLogoURL;
		if (programId && programLogo)
		{
			return programLogo;
		}
	};

	/**
	 * TEMPORARY? Provide an on-after-render callback for the metacontroller.
	 * @param {Function} [fCallback] - The callback to call when the method has completed.
	 */
	onAfterRenderAsync(fCallback)
	{
		const logoSrc = this.getDocumentLogoSource();
		if (logoSrc)
		{
			const tmpLogoWrapper = document.getElementById('Document-Logo-Wrapper');
			if (tmpLogoWrapper)
			{
				this.pict.ContentAssignment.assignContent('#Document-Logo-Wrapper', /*html*/`<img class="image" src="${ logoSrc }" style="max-height: 100px" alt="Logo" />`);
			}
		}

		if (fCallback)
		{
			fCallback();
		}
	}

	/**
	 * View initialization lifecycle hook.
	 * @return {boolean}
	 */
	onInitialize()
	{
		this.instantiateGlobalViews(
		{
			HeadlightSignatures: { View: HeadlightViewSignatures, Options: { } },
			HeadlightLogin:
			{
				View: HeadlightViewLogin,
				Options: false, // ???
				preInitialize: (app) =>
				{
					// create a login section for every form
					let loginSection = document.getElementById('HeadlightLogin-Standard-Wrap');
					if (!loginSection)
					{
						loginSection = document.createElement('section');
						loginSection.id = 'HeadlightLogin-Standard-Wrap';
						document.body.appendChild(loginSection);
					}
					// Typing a user name is never a scan.
					loginSection.setAttribute('data-headlight-qr-wedge', 'ignore');
				},
			},
			HeadlightPanels:
			{
				View: HeadlightPanels,
				Options: this.options.HeadlightPanels,
				preInitialize: (app) =>
				{
					// create a panel section for every form
					let panelSection = document.getElementById('HeadlightPanels-Container');
					if (!panelSection)
					{
						panelSection = document.createElement('section');
						panelSection.id = 'HeadlightPanels-Container';
						document.body.appendChild(panelSection);
					}
				},
			},
		});
		this.pict.CSSMap.generateCSS();
		this.pict.CSSMap.injectCSS();

		return super.onInitialize();
	}

	/**
	 * @param {Event} event - The event that triggered the logout.
	 * @return {Promise<void>} - A promise that resolves when the logout process is complete.
	 */
	logout(event)
	{
		if (event instanceof Event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		return this.pict.HeadlightRestClient.getJSON('Deauthenticate', (pError, pResponse) =>
		{
			if (pError)
			{
				this.pict.log.error(`Error deauthenticating: ${pError.message || pError}`);
			}
			this.pict.providers.SessionProvider?.invalidateSession?.();
			this.loginAsync((pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error in post-logout loginAsync: ${pError.message || pError}`);
				}
			});
		});
	}

	/**
	 * Loads data for the application.
	 * @param {ErrorCallback} fCallback - The callback to call when the method has completed.
	 */
	onLoadDataAsync(fCallback)
	{
		let tmpError = null;
		this.loadData()
		.then((data) =>
		{
			this.DATA = data;
			this.pict.options.Timezone = data.DocumentData?.ReportData?.Timezone || this.pict.options.Timezone;
			this.pict.Dates.dayJS.tz.setDefault(this.pict.options.Timezone);
			// Marked here rather than in loadData() so a subclass override of loadData() is still covered.
			this.markFormLoadPhase('DocumentLoaded');
		})
		.catch((error) =>
		{
			this.DATA = { };
			this.pict.log.error(`Error loading data: ${error.message || error}`, { Stack: error.stack });
			tmpError = error;
		})
		.finally(() =>
		{
			fCallback(tmpError);
		});
	}

	/**
	 * Loads data for the application.
	 *
	 * @return {Promise<any>}
	 */
	async loadData()
	{
		if (!this.loggedIn)
		{
			this.pict.log.info('Not logged in so not loading data by default.');
			return { };
		}
		const doc = await this.fable.services.HeadlightDocumentService.fetchCurrentDocumentReportParameters();
		// The user record fetch started in onBeforeLoginAsync; make sure it landed before anything can save.
		if (this.AppData.FullUserRecordPromise)
		{
			await this.AppData.FullUserRecordPromise;
		}
		this.pict.options.Timezone = doc?.ReportData?.Timezone || this.pict.options.Timezone;
		this.pict.Dates.dayJS.tz.setDefault(this.pict.options.Timezone);
		this.dataLoaded = true;
		return { DocumentData: doc };
	}

	/**
	 * Lifecycle method called before the document is saved.
	 * FIXME: lock into new Lifecycle
	 *
	 * @return {Promise<void>}
	 */
	async onBeforeDocumentSave()
	{
	}

	/**
	 * Lifecycle method called after the document is saved.
	 * FIXME: lock into new Lifecycle
	 *
	 * @return {Promise<void>}
	 */
	async onAfterDocumentSave()
	{
	}

	/**
	 * Arm periodic auto-saving for this document, if the manifest and the document allow it.
	 *
	 * Called from the load lifecycle once the document, the manifest and the edit/read theme decision
	 * are all in place. Subclasses can override to suppress auto-save for an app whose save path is
	 * not the standard document save.
	 *
	 * @return {boolean} Whether auto-save is now running.
	 */
	startAutoSave()
	{
		const tmpAutoSaveProvider = this.pict.providers?.AutoSave;
		if (!tmpAutoSaveProvider)
		{
			return false;
		}
		try
		{
			return tmpAutoSaveProvider.initializeFromManifest();
		}
		catch (pError)
		{
			// Auto-save is a convenience; a failure to arm it must never break loading the form.
			this.pict.log.error(`Error starting auto-save: ${pError.message || pError}`, { Stack: pError.stack });
			return false;
		}
	}

	/**
	 * Disarm periodic auto-saving.
	 * @param {String} [pReason] - Logged when supplied.
	 * @return {void}
	 */
	stopAutoSave(pReason)
	{
		this.pict.providers?.AutoSave?.stop(pReason);
	}

	/**
	 * @param {*} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		const tmpSessionProvider = this.pict.providers.SessionProvider;
		// On the boot login the SessionProvider synced moments ago during initialize, so reuse that.
		// Every later login (logout, the login form, a session change) asks the server again, since
		// those paths do not all go through logout() to invalidate the cached session.
		const tmpReuseSession = !this._initialLoginCompleted && tmpSessionProvider.hasSession();
		this._initialLoginCompleted = true;
		const tmpSessionLoad = tmpReuseSession ? tmpSessionProvider.getSession() : tmpSessionProvider.syncLoggedInState();
		tmpSessionLoad.then((session) =>
		{
			if (session && session.LoggedIn)
			{
				this.AppData.CurrentUser = session;
				this.loggedIn = true;
				this.pict.log.info(`User is already logged in.`);
				// Load the full user record (ExternalSyncGUID for sample QRCode generation; CheckSession
				// does not carry it) alongside the document instead of before it. loadData awaits the
				// promise, so the record is still in place before any sample is synthesized. Fail-open:
				// a failed fetch leaves FullUserRecord unset and the QRCode falls back.
				// The customer's QR settings (code format) load in the same window, also fail-open.
				const tmpQRCodeHash = this.pict.fable && this.pict.fable.services && this.pict.fable.services.HeadlightQRCodeHash;
				const tmpQRCodeProfileLoad = !tmpQRCodeHash ? Promise.resolve() : tmpQRCodeHash.loadCustomerConfiguration(this.pict.HeadlightRestClient, session.CustomerID)
					.then((pProfile) =>
					{
						if (pProfile && this.pict.providers.HeadlightQR)
						{
							this.pict.providers.HeadlightQR.useProfile(pProfile);
						}
					})
					.catch((pError) => this.pict.log.warn(`Could not load the customer's QR settings: ${(pError && pError.message) || pError}`));
				this.AppData.FullUserRecordPromise = Promise.all([ tmpQRCodeProfileLoad, new Promise((resolve) =>
				{
					this.pict.HeadlightRestClient.getJSON(`User/${session.UserID}`, (pError, pResult) =>
					{
						if (pResult)
						{
							this.AppData.FullUserRecord = pResult;
						}
						resolve();
					});
				}) ]);
			}
			else
			{
				this.loggedIn = false;
				delete this.AppData.CurrentUser;
				this.pict.log.info(`User is not logged in.`);
			}
		})
		.catch((error) =>
		{
			this.pict.log.warn(`session check failed: ${error?.message || error || 'not logged in'}`, { Stack: error?.stack });
			this.loggedIn = false;
		})
		.finally(() =>
		{
			// Marked on both outcomes: a failed session check still ends the session leg.
			this.markFormLoadPhase('SessionReady');
			return fCallback();
		});
	}

	/**
	 *
	 * @param {*} fCallback
	 * @return {void}
	 */
	onLoginAsync(fCallback)
	{
		if (this.loggedIn)
		{
			this.pict.log.info(`User logged in.`);
			this.loadDataAsync((error) =>
			{
				if (error)
				{
					this.pict.log.error(`Error loading data after login: ${error.message || error}`, { Stack: error.stack });
				}
				const tmpManifest = this.pict.settings.MyDefaultFormManifest;
				// The Fable ExpressionParser dereferences identifiers in the expression against the
				// scope object (e.g. `AppData.DocumentData.ReportData.Locked` walks AppData.* in scope).
				const tmpConditionScope = { AppData: this.pict.AppData };
				// Locked loads skip the solve pass by default (SkipSolveWhenLocked defaults true;
				// SkipSolveWhen adds expression-based gating) — re-running section solvers would
				// overwrite the frozen snapshot values with re-derived ones from current state.
				// A manifest opts back in with an explicit SkipSolveWhenLocked: false.
				if (ManifestConditionEvaluator.shouldSkipSolveOnLoad(tmpManifest, tmpConditionScope, this.fable))
				{
					this.pict.log.info('Skipping post-load solve() — manifest condition matched (Locked snapshot).');
				}
				else
				{
					this.solve();
					// A PDF page (each pdf/index.html sets _InteractiveForm = false) renders before this solve, and solve() only writes AppData.
					if (this.pict.AppData.Interactive === false)
					{
						this.marshalDataFromAppDataToDynamicViews();
					}
				}
				this.prepareForPrintingAsync()
				.catch((error) =>
				{
					this.pict.log.error(`Error preparing for printing: ${error.message || error}`, { Stack: error.stack });
				})
				.finally(() =>
				{
					return fCallback();
				});
			});
			return;
		}

		this.pict.log.info(`User logged out.`);
		this.dataLoaded = false;
		this.DATA = { };
		this.loggedIn = false;
		if (this.pict.views.HeadlightLogin && this.options.Login.Required)
		{
			this.pict.views.HeadlightLogin.show();
		}
		fCallback();
	}

	/**
	 * Called after the Pict form views have been bootstrapped from the manifest.
	 * @param {*} fCallback
	 * @return {*}
	 */
	onAfterBootstrapPictFormViewsFromManifestAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Called after data has been loaded.
	 * @param {*} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		// Auto-save is armed here rather than in onInitialize because eligibility depends on state that
		// only exists once the document has loaded: Interactive, Locked, CanEdit, and the manifest.
		const fCallbackWithAutoSave = (pError) =>
		{
			this.startAutoSave();
			return fCallback(pError);
		};
		//TODO: this is a shim that ties the old fake lifecylce into the new lifecycle events - should eventually remove
		this.onDataLoad(this.DATA).catch((error) =>
		{
			this.pict.log.error(`Error in onDataLoad: ${error.message || error}`, { Stack: error.stack });
		}).finally(() =>
		{
			// The InitialBundle only needs the loaded document, so fetch it while the panels render.
			let tmpInitialBundleLoad = null;
			if (this.pict.settings.MyDefaultFormManifest)
			{
				const tmpManifest = this.pict.settings.MyDefaultFormManifest;
				const tmpConditionScope = { AppData: this.pict.AppData };
				const tmpInitialBundle = ManifestConditionEvaluator.shouldSkipInitialBundle(tmpManifest, tmpConditionScope, this.fable) ?
					[] :
					(tmpManifest.InitialBundle || []);
				tmpInitialBundleLoad = new Promise((resolve) =>
				{
					this.pict.EntityProvider.gatherDataFromServer(tmpInitialBundle, (pError) => resolve(pError));
				});
			}
			this.pict.views.HeadlightPanels.renderAsync(() =>
			{
				this.pict.log.info('HeadlightPanels rendered via Async');
				if (!this.pict.settings.MyDefaultFormManifest)
				{
					this.render();
					this.markFormLoadPhase('FirstRender');
					return fCallbackWithAutoSave();
				}
				else
				{
					const tmpBootstrapAndRender = (pError) =>
					{
						// Same decision as the post-load solve() gate, so an explicit
						// SkipSolveWhenLocked: false re-enables solving everywhere.
						this.pict.views.PictFormMetacontroller.AutoSolveOnFirstRender = this.pict.AppData.Interactive
							&& !ManifestConditionEvaluator.shouldSkipSolveOnLoad(this.pict.settings.MyDefaultFormManifest, { AppData: this.pict.AppData }, this.fable);
						this.pict.views.PictFormMetacontroller.FirstRenderCompleted = false;
						this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.pict.settings.MyDefaultFormManifest);
						//TODO: this gives us a chance to take actions after everything is prepared but before rendering - think more about this pattern
						this.onAfterBootstrapPictFormViewsFromManifestAsync(() =>
						{
							this.render();
							this.pict.views.PictFormMetacontroller.renderDefaultFormSections();
							// Marked here, not from the metacontroller's onAfterRenderAsyncCallbacks: that list only
							// runs when something calls the metacontroller's renderAsync, and this load path renders
							// synchronously, so the callback never fires on a normal form open.
							// renderDefaultFormSections() is synchronous, so the sections are drawn by this line.
							this.markFormLoadPhase('FirstRender');
							return fCallbackWithAutoSave(pError);
						});
					};

					tmpInitialBundleLoad.then((pError) =>
					{
						tmpBootstrapAndRender(pError);
					}).catch((pError) =>
					{
						this.pict.log.error(`Error bootstrapping the form after the InitialBundle load: ${pError.message || pError}`, { Stack: pError.stack });
					});
				}
			});
		});
	}

	/**
	 * Draw the signature section from the loaded document's approval state, or hide it when the manifest
	 * turns it off. Called on load and again after an approval action changes that state in place.
	 *
	 * @return {Promise<void>} Resolves once the section is drawn; a render error is logged, not thrown.
	 */
	renderSignatureSection()
	{
		const tmpBuiltins = this.pict.settings?.MyDefaultFormManifest?.Builtins;
		if (!HeadlightConfigurableApplication.isBuiltinSectionEnabled(tmpBuiltins?.SignatureSection))
		{
			const tmpSignatureContainer = document.getElementById('Headlight-View-Signatures');
			if (tmpSignatureContainer)
			{
				tmpSignatureContainer.style.display = 'none';
			}
			return Promise.resolve();
		}
		if (!this.pict.views.HeadlightSignatures)
		{
			return Promise.resolve();
		}
		return new Promise((resolve) =>
		{
			this.pict.views.HeadlightSignatures.renderAsync(undefined, undefined, undefined, (error) =>
			{
				if (error)
				{
					this.pict.log.error(`Error rendering HeadlightSignatures view: ${error.message || error}`, { Stack: error.stack });
				}
				resolve();
			});
		});
	}

	/**
	 * Called after authentication has been verified.
	 *
	 * Override this method to perform actions after the user has been authenticated.
	 *
	 * FIXME: need to retool this
	 *
	 * @param {Object<String, any>} data - The data that was loaded.
	 *
	 * @return {Promise<Object<String, any>>}
	 */
	async onDataLoad(data)
	{
		const doc = data?.DocumentData?.ReportData;

		if (!doc)
		{
			this.pict.log.error('Document data not found in onDataLoad', { doc });
		}

		//FIXME: should be handled by document provider implicitly? how does this flow into the login stuff, etc. in a better way
		// The signature render, the input provider and the distilling bundle fetch are independent; run them together.
		const tmpLoadTasks = [ this.renderSignatureSection() ];

		if (this.pict.providers.Input)
		{
			tmpLoadTasks.push(this.pict.providers.Input.onDataLoad(data));
		}
		if (this.pict.providers.Distilling)
		{
			tmpLoadTasks.push(this.pict.providers.Distilling.onDataLoad(data));
		}
		await Promise.all(tmpLoadTasks);
	}

	/**
	 * Resolves the destination for lifecycle comprehension data.
	 *
	 * @return {String} - The destination address for marshalling data.
	 */
	resolveComprehensionMarshallDestination()
	{
		if (this.options.Document?.Required)
		{
			return 'AppData.DocumentData.ReportData.EntityData';
		}
		return 'AppData';
	}

	/**
	 * Resolves the destination for marshalling data.
	 *
	 * @return {String} - The destination address for marshalling data.
	 */
	resolveDataMarshallDestination()
	{
		if (this.options.Document?.Required)
		{
			return 'AppData.DocumentData.ReportData.FormData';
		}
		return 'AppData';
	}

	/**
	 * Lifecycle hook for adding tempplates to the metacontroller.
	 */
	registerTemplates()
	{
		this.pict.addProviderSingleton('PictFormSectionDefaultTemplateProvider', PictSectionForm.PictFormTemplateProvider.default_configuration, PictSectionForm.PictFormTemplateProvider);
		// The `QRCode` input under both the plain pict-section-form prefixes and the HeadLight themes. Apps inject
		// their theme sets after this; those sets don't carry InputType-QRCode, so these templates survive.
		this.qrCodeBundle.injectTemplates(
			{
				Edit: HeadlightQRCodeBundle.DEFAULT_TEMPLATE_PREFIXES.Edit.concat(HeadlightQRCodeBundle.HEADLIGHT_THEME_PREFIXES.Edit),
				Read: HeadlightQRCodeBundle.DEFAULT_TEMPLATE_PREFIXES.Read.concat(HeadlightQRCodeBundle.HEADLIGHT_THEME_PREFIXES.Read),
				Print: HeadlightQRCodeBundle.HEADLIGHT_THEME_PREFIXES.Print,
			});
	}

	/**
	 * Lifecycle method called after the application has been initialized.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the method has completed, and indicate if an error occurred.
	 */
	async onInitializeAsync(fCallback)
	{
		super.onInitializeAsync(async (pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}

			this.registerTemplates();

			this.pict.views.PictFormMetacontroller.viewMarshalDestination = this.resolveDataMarshallDestination();
			this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress = this.resolveComprehensionMarshallDestination();
			this.pict.views.PictFormMetacontroller.AutoSolveOnFirstRender = false;

			this.pict.log.info('onInitializeAsync HeadlightConfigurableApplication');

			return fCallback();
		});
	}

	/**
	 * Prepares the application for printing.
	 */
	async prepareForPrintingAsync()
	{
		try
		{
			for (const provider of Object.keys(this.pict.providers))
			{
				if (typeof this.pict.providers[provider]?.completeRender == 'function')
				{
					try
					{
						await this.pict.providers[provider].completeRender();
					}
					catch (error)
					{
						this.pict.log.error(`Error resolving render for provider ${ provider }: ${error.message || error}`, { Stack: error.stack });
					}
				}
			}

			//FIXME: need to add controls for this
			window.status = 'ready_to_print';
		}
		catch (error)
		{
			this.pict.log.error(`Error in onAfterInitializeAsync: ${error.message || error}`, { Stack: error.stack });

			if (this.pict.views.HeadlightPanels)
			{
				// TODO: maybe we want to handle this differently?
				this.pict.views.HeadlightPanels.renderAsync(() =>
				{
					this.pict.log.info('HeadlightPanels rendered via Async with error');
				});
				this.pict.views.HeadlightPaneIssues?.addIssueLog?.('HeadlightPanels rendered via Async with error', error);
			}
		}
	}

	/**
	 * Lifecycle method called after the application has been initialized.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the method has completed, and indicate if an error occurred.
	 */
	onAfterInitializeAsync(fCallback)
	{
		super.onAfterInitializeAsync((pError) =>
		{
			if (pError)
			{
				this.pict.log.error(`Error in onAfterInitializeAsync: ${pError.message || pError}`, { Stack: pError.stack });
			}

			// Hook: allow external code to configure the application
			// (e.g. REST client interceptors) before the login/data-load
			// lifecycle begins.  The hook receives the Pict instance so it
			// can wire up services, interceptors, IPC routes, etc.
			if (typeof window._onBeforeFormInit === 'function')
			{
				try
				{
					this.pict.log.info('HeadlightConfigurableApplication: Calling window._onBeforeFormInit hook.');
					window._onBeforeFormInit(this.pict);
				}
				catch (pHookError)
				{
					this.pict.log.error('HeadlightConfigurableApplication: Error in _onBeforeFormInit hook: ' + pHookError, { Stack: pHookError.stack });
				}
			}

			this.loginAsync(async (pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error in onAfterInitializeAsync loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
				}

				return fCallback(pError);
			});
		});
	}
	/** @typedef {(pError: (Error | String | null), pSuccess: Boolean) => void} ErrorBooleanCallback */

	/**
	 * Check if the user is authenticated.
	 *
	 * @param {ErrorBooleanCallback} callback - error-first callback to notify on loggedin status (error, true|false)
	 */
	isUserLoggedIn(callback)
	{
		this.pict.HeadlightRestClient.getJSON(`CheckSession`, (pError, pBody) =>
		{
			if (pError || !pBody.LoggedIn)
			{
				// this.AppData.CurrentUser = undefined;
				this.pict.log.trace('session check failed');
				callback(null, false);
				return;
			}
			// Fetch the user record first so that we can use it for generating the QRCode if needed.
			this.pict.HeadlightRestClient.getJSON('User/' + pBody.UserID, (pError, pResult) =>
			{
				if (pResult)
				{
					this.AppData.FullUserRecord = pResult;
				}
				// already logged in
				this.AppData.CurrentUser = pBody;
				callback(null, true);
			});
		});
	}

	/**
	 * Checks if a user is logged in.
	 *
	 * @return {Promise<Boolean>} - A promise that resolves to true if the user is logged in, false otherwise.
	 */
	async checkLogin()
	{
		//FIXME: we should separate login into a provider and a view
		const isLoggedIn = Util.promisify(this.isUserLoggedIn.bind(this));
		return await isLoggedIn();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		// only run this if we are in interactive mode
		if (!this.AppData.Interactive)
		{
			return;
		}

		if (!this.loggedIn && this.pict.views.HeadlightLogin && this.options.Login.Required)
		{
			return;
		}

		return super.onSolve();
	}

	/**
	 * Lifecycle method called before the view is rendered.
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		// over-ride some CSS class names for the tab section selector to use Bulma classes
		if (this.pict.providers['Pict-Input-TabSectionSelector'])
		{
			this.pict.providers['Pict-Input-TabSectionSelector'].cssSelectedTabClass = 'is-active';
			this.pict.providers['Pict-Input-TabSectionSelector'].cssHideClass = 'is-hidden';
		}
		// over-ride some CSS class names for the tab group selector to use Bulma classes
		if (this.pict.providers['Pict-Input-TabGroupSelector'])
		{
			this.pict.providers['Pict-Input-TabGroupSelector'].cssSelectedTabClass = 'is-active';
			this.pict.providers['Pict-Input-TabGroupSelector'].cssHideClass = 'is-hidden';
		}

		return super.onBeforeRender();
	}

	/**
	 * Set up the native bridge functions used by the iOS configurable form
	 * WKWebView. This mode is activated when the page is captured via
	 * single-file with ?Mode=OfflineTemplate. The captured HTML is later
	 * loaded from the device filesystem; the native layer injects a
	 * StorageAdapter and DocumentBridge via WKUserScript, then calls
	 * initFormWithManifest() to bootstrap the form.
	 *
	 * This is a static method so all subclasses (HeadlightDynamicForm,
	 * HeadlightDocument, etc.) inherit it. Each HTML template calls:
	 *   AppClass.setupOfflineTemplate(AppClass);
	 *
	 * @param {typeof HeadlightConfigurableApplication} pAppClass - The application class to use for form initialization.
	 */
	static setupOfflineTemplate(pAppClass)
	{
		/**
		 * Initialise the PICT configurable-form application with the
		 * given manifest and optional bundle (project reference data).
		 *
		 * Called by the iOS native layer after the page finishes loading.
		 *
		 * @param {object} pManifest - The resolved form manifest JSON.
		 * @param {object} [pBundle] - Optional project bundle/reference data.
		 */
		window.initFormWithManifest = (pManifest, pBundle) =>
		{
			window._InteractiveForm = true;
			window._OfflineMode = true;
			window._OfflineBundleData = pBundle || {};

			pAppClass.default_configuration.pict_configuration =
				pAppClass.preprocessFormDefinition(pManifest);

			Pict.safeLoadPictApplication(pAppClass, 3);
		};

		/**
		 * Load a document record from native storage and marshal it into
		 * the live form.  Called by the iOS native layer after
		 * initFormWithManifest has completed.
		 *
		 * @param {string} pGUID - The GUIDDocument or external index to load.
		 */
		window.nativeLoadDocument = (pGUID) =>
		{
			if (!window._configurableFormDocumentBridge)
			{
				console.error('[OfflineTemplate] _configurableFormDocumentBridge not available');
				return;
			}

			window._configurableFormDocumentBridge.loadDocument(pGUID, (pDocData) =>
			{
				if (!window._Pict || !window._Pict.PictApplication)
				{
					console.error('[OfflineTemplate] PICT application not ready');
					return;
				}

				const tmpApp = window._Pict.PictApplication;
				tmpApp.AppData.DocumentData = pDocData;

				// Bootstrap form views from manifest if not yet done
				if (typeof tmpApp.bootstrapPictFormViewsFromManifest === 'function')
				{
					tmpApp.bootstrapPictFormViewsFromManifest();
				}

				tmpApp.render();

				// Marshal document data into form fields
				if (tmpApp.pict && tmpApp.pict.views && tmpApp.pict.views.PictFormMetacontroller)
				{
					tmpApp.pict.views.PictFormMetacontroller.marshalToView();
				}

				// Offline, the document arrives here rather than through the load lifecycle, so this is
				// the first moment auto-save can tell whether the record is editable. Saves route back
				// through nativeSaveCurrentForm to the native bridge, not the REST client.
				tmpApp.startAutoSave();
			});
		};

		/**
		 * Run a full application save. Called by the iOS native layer before dismissing the form view
		 * controller, and by auto-save on its interval.
		 *
		 * This is the SAME save the online form runs: the whole lifecycle, so every provider's
		 * `onBeforeSaveDataAsync` marshals and emits, and only the transport underneath differs
		 * (`HeadlightDocumentService` writes through the native bridge instead of PUTting). Persisting
		 * the record directly from here would skip the marshal the form applications do and would never
		 * build `Document.EntityData`, so nothing the form created would exist once the device synced.
		 *
		 * Resolves once the save has been persisted, so the caller can await it before tearing the
		 * webview down. `callAsyncJavaScript:` resolves the returned promise; a caller using
		 * `evaluateJavaScript:` gets no such guarantee and will race the teardown.
		 *
		 * @return {Promise<{Saved: boolean, Error?: string}>} The outcome of the save.
		 */
		window.nativeSaveCurrentForm = async () =>
		{
			if (!window._Pict || !window._Pict.PictApplication)
			{
				return { Saved: false, Error: 'The form application is not ready.' };
			}

			const tmpApp = window._Pict.PictApplication;
			const tmpDocumentProvider = tmpApp.pict && tmpApp.pict.providers && tmpApp.pict.providers.DocumentProvider;
			if (!tmpDocumentProvider || typeof tmpDocumentProvider.handleSaveAsync !== 'function')
			{
				const tmpMessage = 'No DocumentProvider is registered, so this form has no save lifecycle to run.';
				tmpApp.pict.log.error(`nativeSaveCurrentForm: ${tmpMessage}`);
				return { Saved: false, Error: tmpMessage };
			}

			const tmpError = await tmpDocumentProvider.handleSaveAsync(true);
			if (tmpError)
			{
				return { Saved: false, Error: tmpError.message || String(tmpError) };
			}
			return { Saved: true };
		};

		/**
		 * Wire the native storage adapter (injected by iOS via
		 * ConfigurableFormStorageAdapter.js) into the FormPersistence
		 * provider once the PICT application has initialised.
		 *
		 * Can be called from native or from initFormWithManifest's
		 * post-init hook.
		 */
		window.setupNativeFormPersistence = () =>
		{
			if (!window._Pict || !window._nativeStorageAdapter)
			{
				return;
			}
			const tmpPersistence = window._Pict.providers && window._Pict.providers.FormPersistence;
			if (tmpPersistence && typeof tmpPersistence.setStorageAdapter === 'function')
			{
				tmpPersistence.setStorageAdapter(window._nativeStorageAdapter);
			}
		};
	}
}

/** @type {Record<string, any>} */
HeadlightConfigurableApplication.default_configuration = Object.assign(
{
	'MainViewportViewIdentifier': 'PictFormMetacontroller',
},
HeadlightConfigurableApplication.default_configuration,
{
	'AutoRenderMainViewportViewAfterInitialize': false,
});
/** @type {Record<string, any>} */
HeadlightConfigurableApplication.pict_configuration = require('./application-pict-config.json');

module.exports = HeadlightConfigurableApplication;

},{"../../../../lib/service/headlight-stationing-service/Headlight-Stationing.js":24,"../../../../lib/web/headlight-quick-summaries/Headlight-Quick-Summaries-Service.js":291,"../../../../web/providers/Session-Provider.js":1608,"./application-pict-config.json":31,"./providers/AutoSaveProvider.js":32,"./providers/DistillingProvider.js":33,"./providers/DocumentFrameProvider.js":34,"./providers/InputTypeBehaviorProvider.js":35,"./services/Headlight-Document-Service.js":36,"./services/Headlight-FormLoadTiming.js":37,"./services/Headlight-HintHighlighting.js":38,"./services/ManifestConditionEvaluator.js":39,"headlight-qrcode-hash":13,"headlight-qrcode-web":274,"headlight-rest-client":20,"headlight-view-login":307,"headlight-view-panels":1556,"headlight-view-signatures":308,"pict-application":545,"pict-section-form":587,"pict-section-form/source/views/Pict-View-Form-Metacontroller.js":654,"pict-section-modal":690,"util":821}],31:[function(require,module,exports){
module.exports={
    "Product": "HeadlightConfigurableApplication",
    "ProductVersion": "1.0.0",

    "Manifests":
    {
    }
}

},{}],32:[function(require,module,exports){
const PictProvider = require('pict-provider');

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */

/** Ships on by default; a manifest opts out with `AutoSave: false` (or `AutoSave: { Enabled: false }`). */
const DEFAULT_INTERVAL_SECONDS = 90;
/** Below this, saves stack up behind each other on a slow connection and hammer the API. */
const MINIMUM_INTERVAL_SECONDS = 15;
/** An hour. Anything longer is indistinguishable from "off" and is almost certainly a typo. */
const MAXIMUM_INTERVAL_SECONDS = 3600;
/** Consecutive failed auto-saves before the provider stops trying. */
const DEFAULT_MAX_CONSECUTIVE_FAILURES = 3;

/**
 * Auto-save states, in the order a healthy session moves through them.
 * `offline` and `retrying` are transient; `suspended` is terminal until a
 * successful save (manual or programmatic) revives the provider.
 */
const STATES = {
	DISABLED: 'disabled',
	IDLE: 'idle',
	SAVING: 'saving',
	SAVED: 'saved',
	OFFLINE: 'offline',
	RETRYING: 'retrying',
	SUSPENDED: 'suspended',
};

/**
 * Presentation metadata per state. Class names (not markup) so the navbar
 * template composes the DOM — see `HeadlightPanels-NavBar-AutoSaveStatus`.
 */
const STATE_PRESENTATION = {
	[STATES.IDLE]: { IconClass: 'fa-cloud', StateClass: 'is-idle' },
	[STATES.SAVING]: { IconClass: 'fa-circle-notch fa-spin', StateClass: 'is-saving' },
	[STATES.SAVED]: { IconClass: 'fa-check', StateClass: 'is-saved' },
	[STATES.OFFLINE]: { IconClass: 'fa-plug', StateClass: 'is-offline' },
	[STATES.RETRYING]: { IconClass: 'fa-exclamation-triangle', StateClass: 'is-retrying' },
	[STATES.SUSPENDED]: { IconClass: 'fa-exclamation-triangle', StateClass: 'is-suspended' },
};

/**
 * Message fragments that mean "the server refused you", as opposed to "the server was unreachable".
 * The REST client flattens the response into `new Error('Failed with status code 403')` (or the
 * JSON-stringified error body), so there is no status code property to read — matching on the
 * message is the only signal available.
 */
const AUTHORIZATION_ERROR_PATTERNS = [ /\b401\b/, /\b403\b/, /unauthorized/i, /forbidden/i, /not authorized/i, /permission/i ];

/** The navbar Save button in the panels configuration; auto-save follows whether it is offered. */
const SAVE_BUTTON_ID = 'HeadlightPanels-NavBar-Save-Button';

/** The document form element. Every document HTML shell uses this id, and it is never re-rendered. */
const DOCUMENT_FORM_ID = 'Headlight-Document-Form';

/**
 * Hook the framework's own "a value changed" calls so a custom input provider counts as an interaction.
 *
 * The DOM listener in the provider catches typing the moment a key lands, but pict binds `onchange` and
 * many widgets never fire a native event at all — pict-section-picker portals its dropdown to `<body>`,
 * so the option click happens outside the form and the value is written programmatically. Selecting
 * from a dropdown is half the interaction case we care about, so it has to be caught here rather than
 * in the DOM.
 *
 * Patched the same way the base application already patches the metacontroller's render hooks: the
 * upstream methods notify only a provider literally named `FormPersistence`, which this platform does
 * not register.
 */
const PictViewDynamicForm = require('pict-section-form/source/views/Pict-View-DynamicForm.js');
for (const tmpMethodName of [ 'dataChanged', 'dataChangedTabular' ])
{
	const tmpOriginalMethod = PictViewDynamicForm.prototype[tmpMethodName];
	if (typeof tmpOriginalMethod !== 'function')
	{
		continue;
	}
	PictViewDynamicForm.prototype[tmpMethodName] = function(...pArguments)
	{
		// Before, not after: the first interaction is what baselines the document for change detection,
		// and this method is what marshals the edit into it. Baselining afterwards would fold the edit
		// into the baseline, and a picker selection — which fires no DOM event to catch it earlier —
		// would never read as a change and so would never be auto-saved.
		try
		{
			this.pict?.providers?.AutoSave?.noteUserInteraction?.(tmpMethodName);
		}
		catch (pError)
		{
			// Never let auto-save bookkeeping break an edit.
			this.log?.error?.(`AutoSave: error recording a form interaction: ${pError?.message || pError}`);
		}
		return tmpOriginalMethod.apply(this, pArguments);
	};
}

/**
 * Keys under `AppData.CurrentUser.Settings.HeadlightPanels` that the Settings panel writes. They follow
 * the panel's `setting-<Key>` element-id convention so `updateUserPreferences` can paint them.
 */
const USER_PREFERENCE_ENABLED_KEY = 'AutoSave';
const USER_PREFERENCE_INTERVAL_KEY = 'AutoSaveIntervalSeconds';

/**
 * Periodically persists an editable document while the user works in it.
 *
 * Registered by `HeadlightConfigurableApplication` so every configuration-driven form app
 * (headlight-dynamic-form, materials-form, and anything else extending the base) inherits the
 * behavior without wiring anything up.
 *
 * ## Manifest configuration
 *
 * Read from the top level of the form manifest, alongside `SkipSolveWhenLocked` and friends:
 *
 * ```json
 * { "AutoSave": false }                                       // opt out entirely
 * { "AutoSave": { "IntervalSeconds": 300 } }                  // every 5 minutes instead of 90 seconds
 * { "AutoSave": { "Enabled": true, "SkipWhenUnchanged": false } }
 * ```
 *
 * | Key | Default | Meaning |
 * | --- | --- | --- |
 * | `Enabled` | `true` | Master switch. `AutoSave: false` is shorthand for `{ Enabled: false }`. |
 * | `IntervalSeconds` | `90` | Delay before the first save and between saves. Clamped to 15–3600. |
 * | `SkipWhenUnchanged` | `true` | Skip a cycle when nothing has changed since the last save. |
 * | `MaxConsecutiveFailures` | `3` | Failures in a row before auto-save suspends itself. |
 *
 * ## Guarantees
 *
 * - Sleeps between saves. The timer is dormant until a change is observed, runs one interval, saves,
 *   and goes dormant again — it does not poll. "Change" means the document differs from what the last
 *   save actually sent, so a value typed and then taken back out again wakes nothing.
 * - Never runs outside a form: it requires a `MyDefaultFormManifest`, which the web applications
 *   sharing this base class (LIMS, the configuration apps, internals, data) do not have.
 * - Follows the Save button: an application or customer whose panel configuration removes or hides the
 *   navbar Save button has turned saving off, and auto-save turns off with it.
 * - Never runs on a document the user cannot edit (locked, `CanEdit` false) or on a non-interactive
 *   render pass (the PDF/print bundle).
 * - Never runs on another customer's document, so a support user spot-checking a form in edit view does
 *   not silently stamp it. Manual saves are deliberate and are left alone.
 * - Never starts a second save lifecycle: it defers to `DocumentProvider`'s single-flight latch
 *   rather than queueing behind an in-flight save, and skips entirely while an approval action runs.
 * - Never spams a server that is refusing the write. Repeated failures — or any single failure that
 *   looks like a permission change — suspend auto-save until a save succeeds again.
 * - Works offline: in the iOS WKWebView offline template the save routes through the native document
 *   bridge instead of the REST client, and a browser reporting `navigator.onLine === false` skips the
 *   cycle without burning a failure.
 */
class AutoSaveProvider extends PictProvider
{
	/**
	 * Normalize whatever the manifest carries at `AutoSave` into a complete configuration object.
	 *
	 * Fails open — a malformed value logs and falls back to the default rather than disabling
	 * auto-save, because a typo in an optional tuning key should not silently cost a customer their
	 * unsaved work.
	 *
	 * @param {boolean | Object | undefined | null} pManifestAutoSave - The manifest's `AutoSave` value.
	 * @param {any} [pLog] - Optional logger for surfacing coercions.
	 * @return {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }}
	 */
	static resolveConfiguration(pManifestAutoSave, pLog)
	{
		const tmpConfiguration =
		{
			Enabled: true,
			IntervalSeconds: DEFAULT_INTERVAL_SECONDS,
			SkipWhenUnchanged: true,
			MaxConsecutiveFailures: DEFAULT_MAX_CONSECUTIVE_FAILURES,
		};

		if (pManifestAutoSave === undefined || pManifestAutoSave === null)
		{
			return tmpConfiguration;
		}
		if (typeof pManifestAutoSave === 'boolean')
		{
			tmpConfiguration.Enabled = pManifestAutoSave;
			return tmpConfiguration;
		}
		if (typeof pManifestAutoSave !== 'object' || Array.isArray(pManifestAutoSave))
		{
			pLog?.warn?.(`AutoSave: manifest value is a ${Array.isArray(pManifestAutoSave) ? 'array' : typeof pManifestAutoSave}; expected a boolean or an object. Using auto-save defaults.`);
			return tmpConfiguration;
		}

		if ('Enabled' in pManifestAutoSave)
		{
			tmpConfiguration.Enabled = pManifestAutoSave.Enabled !== false;
		}
		if ('SkipWhenUnchanged' in pManifestAutoSave)
		{
			tmpConfiguration.SkipWhenUnchanged = pManifestAutoSave.SkipWhenUnchanged !== false;
		}
		if ('IntervalSeconds' in pManifestAutoSave)
		{
			tmpConfiguration.IntervalSeconds = AutoSaveProvider.resolveIntervalSeconds(
				pManifestAutoSave.IntervalSeconds, DEFAULT_INTERVAL_SECONDS, 'manifest IntervalSeconds', pLog);
		}
		if ('MaxConsecutiveFailures' in pManifestAutoSave)
		{
			const tmpFailures = Number(pManifestAutoSave.MaxConsecutiveFailures);
			if (!Number.isFinite(tmpFailures) || tmpFailures < 1)
			{
				pLog?.warn?.(`AutoSave: MaxConsecutiveFailures "${pManifestAutoSave.MaxConsecutiveFailures}" is not a positive number; using ${DEFAULT_MAX_CONSECUTIVE_FAILURES}.`);
			}
			else
			{
				tmpConfiguration.MaxConsecutiveFailures = Math.round(tmpFailures);
			}
		}

		return tmpConfiguration;
	}

	/**
	 * Validate and clamp an interval to the supported range.
	 *
	 * @param {any} pValue - The candidate interval, from a manifest or a user preference.
	 * @param {number} pFallback - The interval to keep when the candidate is unusable.
	 * @param {String} pSource - Where the value came from, for the warning text.
	 * @param {any} [pLog] - Optional logger.
	 * @return {number}
	 */
	static resolveIntervalSeconds(pValue, pFallback, pSource, pLog)
	{
		const tmpInterval = Number(pValue);
		if (!Number.isFinite(tmpInterval) || tmpInterval <= 0)
		{
			pLog?.warn?.(`AutoSave: ${pSource} interval "${pValue}" is not a positive number; using ${pFallback} seconds.`);
			return pFallback;
		}
		const tmpRounded = Math.round(tmpInterval);
		const tmpClamped = Math.min(MAXIMUM_INTERVAL_SECONDS, Math.max(MINIMUM_INTERVAL_SECONDS, tmpRounded));
		if (tmpClamped !== tmpRounded)
		{
			pLog?.warn?.(`AutoSave: ${pSource} interval ${tmpRounded} is outside the supported ${MINIMUM_INTERVAL_SECONDS}-${MAXIMUM_INTERVAL_SECONDS} second range; using ${tmpClamped} seconds.`);
		}
		return tmpClamped;
	}

	/**
	 * Resolve whether auto-save is on, across the three things that get a say.
	 *
	 * The precedence is deliberate and not symmetric:
	 *   - A manifest opt-out is the customer's decision about the form and nobody overrides it.
	 *   - An explicit user preference beats everything below it, in either direction.
	 *   - Impersonation only moves the *default*. Someone impersonating is testing, and a timer save
	 *     would be an edit they did not mean to make — but a tester chasing an auto-save bug has to be
	 *     able to switch it back on, so this is a preference, not a lock.
	 *
	 * @param {boolean} pManifestEnabled - Whether the form manifest allows auto-save at all.
	 * @param {boolean} pImpersonating - Whether this session is impersonating another user.
	 * @param {boolean | undefined} pUserPreference - The user's stored `AutoSave` preference, if any.
	 * @return {boolean}
	 */
	static resolveEnabled(pManifestEnabled, pImpersonating, pUserPreference)
	{
		if (!pManifestEnabled)
		{
			return false;
		}
		if (pUserPreference === false)
		{
			return false;
		}
		if (pUserPreference === true)
		{
			return true;
		}
		return !pImpersonating;
	}

	/**
	 * Layer the logged-in user's Settings-panel preferences over the manifest configuration.
	 *
	 * The user has the final say on cadence, and can switch auto-save off for themselves entirely. They
	 * cannot switch it back **on** for a form whose manifest opted out: that is a decision the customer
	 * made about the form, not a personal preference, so `Enabled` is only ever narrowed here.
	 *
	 * @param {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }} pConfiguration - The manifest-resolved configuration.
	 * @param {Object | null | undefined} pUserPreferences - `CurrentUser.Settings.HeadlightPanels`.
	 * @param {any} [pLog] - Optional logger.
	 * @param {boolean} [pImpersonating] - Whether this session is impersonating another user.
	 * @return {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }} A new configuration; the input is not mutated.
	 */
	static applyUserPreferences(pConfiguration, pUserPreferences, pLog, pImpersonating)
	{
		const tmpConfiguration = Object.assign({ }, pConfiguration);
		const tmpUserPreferences = (pUserPreferences && typeof pUserPreferences === 'object') ? pUserPreferences : { };
		// `pConfiguration` is the manifest's configuration, so its Enabled is the ceiling.
		tmpConfiguration.Enabled = AutoSaveProvider.resolveEnabled(
			pConfiguration.Enabled, Boolean(pImpersonating), tmpUserPreferences[USER_PREFERENCE_ENABLED_KEY]);
		if (tmpUserPreferences[USER_PREFERENCE_INTERVAL_KEY] !== undefined && tmpUserPreferences[USER_PREFERENCE_INTERVAL_KEY] !== null)
		{
			tmpConfiguration.IntervalSeconds = AutoSaveProvider.resolveIntervalSeconds(
				tmpUserPreferences[USER_PREFERENCE_INTERVAL_KEY], tmpConfiguration.IntervalSeconds, 'user preference', pLog);
		}
		return tmpConfiguration;
	}

	/**
	 * @param {any} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {any} */
		this.options;

		/** @type {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }} */
		this.Configuration = AutoSaveProvider.resolveConfiguration(undefined);
		/**
		 * The manifest's configuration before the user's preferences are layered on. Kept so the Settings
		 * panel can distinguish "the customer turned this off for this form" from "you turned it off".
		 * @type {{ Enabled: boolean, IntervalSeconds: number, SkipWhenUnchanged: boolean, MaxConsecutiveFailures: number }}
		 */
		this.ManifestConfiguration = this.Configuration;
		/** @type {boolean} - Whether the interval timer is currently armed. */
		this.Running = false;
		/** @type {boolean} - Whether auto-save stopped itself because saving kept failing. */
		this.Suspended = false;
		/** @type {number} - Failed auto-saves since the last successful one. */
		this.ConsecutiveFailures = 0;
		/** @type {any} - The pending interval timer handle. */
		this._Timer = null;
		/** @type {?String} - Serialized document state as of the last save, for change detection. */
		this._SavedSnapshot = null;
		/** @type {?String} - Serialized document state just before the first edit, for hasUnsavedUserChanges. */
		this._FirstInteractionSnapshot = null;
		/** @type {boolean} - Whether the save currently in flight was started by this provider. */
		this._AutoSaveInFlight = false;
		/** @type {?Date} - When a save last completed, whoever asked for it. */
		this.LastSavedAt = null;
		/**
		 * Whether the user has modified anything in this form yet. The clock does not start until they
		 * have: opening someone's form to read it should never write to it 90 seconds later.
		 * @type {boolean}
		 */
		this.UserHasInteracted = false;
		/** @type {?Function} - The detach handle for the first-interaction DOM listener. */
		this._DetachInteractionListener = null;
		/** @type {String} */
		this.State = STATES.DISABLED;
		/** @type {String} */
		this.StateMessage = '';

		this._publishStatus();
	}

	/**
	 * Read the manifest's `AutoSave` block and arm the timer if the document qualifies.
	 *
	 * Called from the base application once the document is loaded and the form has rendered, so
	 * `Locked` / `CanEdit` / the print-vs-edit theme decision have all been made by then.
	 *
	 * @return {boolean} Whether auto-save is now running.
	 */
	initializeFromManifest()
	{
		this.ManifestConfiguration = AutoSaveProvider.resolveConfiguration(this.pict.settings?.MyDefaultFormManifest?.AutoSave, this.log);
		this.Configuration = AutoSaveProvider.applyUserPreferences(
			this.ManifestConfiguration, this.readUserPreferences(), this.log, this.isImpersonating());
		return this.start();
	}

	/**
	 * Whether this session is impersonating another user — CheckSession reports it.
	 *
	 * Read permissively: this only moves a default the user can change, so treating an unexpected
	 * truthy shape as impersonation errs toward not writing to a document somebody is testing on.
	 * @return {boolean}
	 */
	isImpersonating()
	{
		return Boolean(this.pict.AppData?.CurrentUser?.Impersonation);
	}

	/**
	 * The logged-in user's panel preferences, or undefined when nobody is logged in.
	 * @return {Object | undefined}
	 */
	readUserPreferences()
	{
		return this.pict.AppData?.CurrentUser?.Settings?.HeadlightPanels;
	}

	/**
	 * Re-read the manifest and the user's Settings-panel preferences, then re-arm.
	 *
	 * Called when the user changes an auto-save preference, so it takes effect on the open document
	 * rather than at the next page load. Re-arming also resets the countdown, which is the behavior a
	 * user changing the cadence expects.
	 * @return {boolean} Whether auto-save is running after the change.
	 */
	reconfigure()
	{
		return this.initializeFromManifest();
	}

	/**
	 * Describe auto-save for the Settings panel.
	 *
	 * `Available` is about whether the controls are meaningful on this screen at all, not about the
	 * document currently open: the preference is per-user and carries to their next document, so a
	 * locked document does not make it unavailable.
	 *
	 * @return {{ Available: boolean, Locked: boolean, Reason: string, Enabled: boolean, IntervalSeconds: number, DefaultIntervalSeconds: number, MinimumIntervalSeconds: number, MaximumIntervalSeconds: number }}
	 */
	getUserFacingState()
	{
		// Not a form application, or an application whose navbar offers no Save button: the controls
		// would be inert, so the panel hides them entirely.
		const tmpAvailable = Boolean(this.pict.settings?.MyDefaultFormManifest) && this.isSaveControlAvailable();
		// Conditions the user cannot change from here. Both leave the rows visible but inert, with the
		// reason spelled out, rather than a live toggle that does nothing.
		const tmpForeignCustomer = !this.isSameCustomerAsDocument();
		const tmpManifestOptedOut = !this.ManifestConfiguration.Enabled;
		const tmpEnabled = this.Configuration.Enabled && !tmpForeignCustomer;
		// Locked is "you cannot change this here". Impersonation is not locked — it only moved the
		// default — but it still explains itself, so the reason is tracked separately.
		let tmpReason = '';
		if (tmpForeignCustomer)
		{
			tmpReason = 'Auto-save is off because this document belongs to another customer.';
		}
		else if (tmpManifestOptedOut)
		{
			tmpReason = 'Auto-save is turned off for this form type.';
		}
		else if (!tmpEnabled && this.isImpersonating())
		{
			tmpReason = 'Auto-save defaults to off while impersonating. Turn it on if you are testing auto-save itself.';
		}
		return {
			Available: tmpAvailable,
			Locked: tmpForeignCustomer || tmpManifestOptedOut,
			Reason: tmpReason,
			Enabled: tmpEnabled,
			IntervalSeconds: this.Configuration.IntervalSeconds,
			DefaultIntervalSeconds: DEFAULT_INTERVAL_SECONDS,
			MinimumIntervalSeconds: MINIMUM_INTERVAL_SECONDS,
			MaximumIntervalSeconds: MAXIMUM_INTERVAL_SECONDS,
		};
	}

	/**
	 * Whether this document should be auto-saved at all.
	 *
	 * Re-checked on every cycle, not just at start: a document that gets locked mid-session (the user
	 * submits it in another tab, an approver locks it) must stop being written to.
	 * @return {boolean}
	 */
	isEligible()
	{
		if (!this.Configuration.Enabled)
		{
			return false;
		}
		// No form manifest means no form. Roughly a dozen web applications (LIMS, the configuration
		// apps, internals, data) extend this same base class and several of them set Interactive true
		// for their own purposes, so this — not Interactive — is what structurally keeps auto-save out
		// of them. The base class does not bootstrap form section views without a manifest either.
		if (!this.pict.settings?.MyDefaultFormManifest)
		{
			return false;
		}
		// The PDF/print render pass loads the same application with Interactive false. Saving there
		// would write the render's derived state back over the document.
		if (!this.pict.AppData?.Interactive)
		{
			return false;
		}
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData)
		{
			return false;
		}
		// A TINYINT Locked can arrive as the string "0", which is JS-truthy — the same trap
		// ManifestConditionEvaluator guards against.
		if (tmpReportData.Locked && tmpReportData.Locked !== '0')
		{
			return false;
		}
		if (!tmpReportData.CanEdit)
		{
			return false;
		}
		if (!this.isSameCustomerAsDocument())
		{
			return false;
		}
		return this.isSaveControlAvailable();
	}

	/**
	 * Whether the logged-in user belongs to the same customer as the open document.
	 *
	 * Support and engineering users (role index 5) open other customers' forms to spot-check them — open,
	 * read, close, no edits intended. In edit view a timer save would still fire, stamping the document
	 * with a foreign updating user, and in some configurations that leaves the customer's own users
	 * unable to open or edit it afterwards. A person who deliberately clicks Save has decided to write;
	 * a timer has not, so this guard is deliberately scoped to auto-save and leaves manual saves alone.
	 *
	 * Safe to apply unconditionally: only customer 1 (Headlight's own team) is supposed to be able to
	 * edit across customers at all, so a mismatch here is always an internal tester looking at someone
	 * else's document — never a customer doing their own work. That is why this gates on the customer
	 * rather than on the role index: a role-5 user inside their own customer is doing ordinary work and
	 * keeps auto-save.
	 *
	 * Fails open when either id is unresolvable: absence is not evidence of a mismatch, and the offline
	 * template has no session to compare against at all. Both ids come back as database integers, but
	 * they cross JSON boundaries from different endpoints, so compare them numerically rather than by
	 * identity.
	 * @return {boolean}
	 */
	isSameCustomerAsDocument()
	{
		const tmpUserCustomerID = Number(this.pict.AppData?.CurrentUser?.CustomerID);
		const tmpDocumentCustomerID = Number(this.pict.AppData?.DocumentData?.ReportData?.IDCustomer);
		if (!Number.isFinite(tmpUserCustomerID) || !Number.isFinite(tmpDocumentCustomerID) || tmpUserCustomerID <= 0 || tmpDocumentCustomerID <= 0)
		{
			return true;
		}
		return tmpUserCustomerID === tmpDocumentCustomerID;
	}

	/**
	 * Whether the panels navbar offers this application a Save button.
	 *
	 * Auto-save follows the Save button: an application or customer that turned saving off through the
	 * panel configuration should not have a timer writing the document behind their back. This reads
	 * the configuration rather than the DOM deliberately — the navbar hides the Save button at runtime
	 * whenever there is no document context, and that toggle is not a statement about whether saving is
	 * offered.
	 *
	 * Fails open when there is no panels configuration at all: an embedded or stripped shell that never
	 * renders a navbar has said nothing either way, and the manifest and document gates still apply.
	 * @return {boolean}
	 */
	isSaveControlAvailable()
	{
		const tmpNavBar = this.pict.settings?.HeadlightPanels?.Configuration?.NavBar;
		if (!tmpNavBar || !Array.isArray(tmpNavBar.Buttons))
		{
			return true;
		}
		if (tmpNavBar.hideNavbar)
		{
			return false;
		}
		const tmpSaveButton = tmpNavBar.Buttons.find((pButton) => pButton && (pButton.id === SAVE_BUTTON_ID || pButton.name === 'save'));
		if (!tmpSaveButton)
		{
			return false;
		}
		return !String(tmpSaveButton.wrapperClass || '').split(/\s+/).includes('is-hidden');
	}

	/**
	 * Arm the auto-save timer.
	 * @return {boolean} Whether the timer was armed.
	 */
	start()
	{
		this.stop();
		this.Suspended = false;
		this.ConsecutiveFailures = 0;
		if (!this.isEligible())
		{
			this.log.info('AutoSave: not enabled for this document (disabled by manifest, locked, read-only, or a non-interactive render).');
			this._setState(STATES.DISABLED);
			return false;
		}
		this.Running = true;
		if (!this.UserHasInteracted)
		{
			// A form opened to be read — the case a support user spot-checking someone else's document is
			// in — is never written to. The baseline moves to that first edit, which is also truer than
			// this one: entity hydration, the media registry and the load-time solve all settle in
			// between, and none of that is the user's work.
			this._captureSnapshot();
		}
		this._listenForInteractions();
		this._setState(STATES.IDLE);
		// Dormant by default. Re-arming here covers a reconfigure (the user changing the cadence in
		// Settings) that lands on top of edits which have not been written yet.
		if (this.UserHasInteracted && this._hasPendingWork())
		{
			this.log.info(`AutoSave: enabled; unsaved changes are pending, saving in ${this.Configuration.IntervalSeconds} seconds.`);
			this._scheduleNextCycle();
			return true;
		}
		this.log.info(`AutoSave: enabled; the ${this.Configuration.IntervalSeconds} second countdown starts at the next change.`);
		return true;
	}

	/**
	 * Whether there is anything worth waking up for.
	 *
	 * The document as it stands differs from what the last save actually sent — so a value typed and
	 * then taken back out again is not pending work, because the payload would be identical.
	 * `SkipWhenUnchanged: false` is a manifest opting out of exactly this reasoning, so it keeps the
	 * timer running regardless.
	 * @return {boolean}
	 */
	_hasPendingWork()
	{
		if (!this.Configuration.SkipWhenUnchanged)
		{
			return true;
		}
		return this._hasUnsavedChanges();
	}

	/**
	 * Record that the user has modified the form, and start the countdown if this is the first time.
	 *
	 * Cheap and idempotent — it is called on every keystroke and every framework data change, so the
	 * already-interacted path is a single boolean test.
	 *
	 * @param {String} [pSource] - What observed the interaction, for the log line.
	 * @return {void}
	 */
	noteUserInteraction(pSource)
	{
		const tmpFirstEver = !this.UserHasInteracted;
		if (tmpFirstEver)
		{
			this.UserHasInteracted = true;
			this._FirstInteractionSnapshot = this._serializeDocumentState();
		}
		this.pict.providers?.DocumentFrame?.notifyChanged?.();
		if (!this.Running)
		{
			// Auto-save is off for this document; the flag still latches so a later reconfigure (the user
			// switching it on in Settings mid-edit) does not have to wait for another edit.
			return;
		}
		if (this._Timer)
		{
			// A countdown is already running. Deliberately not restarted — a fast typist would otherwise
			// push the deadline out indefinitely and never be saved.
			return;
		}
		if (tmpFirstEver)
		{
			// Baseline the document as it stands immediately before this first edit lands, so the edit
			// itself is what the cycle sees as a change. After this, only a save moves the baseline.
			this._captureSnapshot();
		}
		this.log.info(`AutoSave: change observed (${pSource || 'unknown'}); saving in ${this.Configuration.IntervalSeconds} seconds.`);
		this._scheduleNextCycle();
	}

	/**
	 * Watch the document form for the first sign of the user entering data.
	 *
	 * One delegated listener on the form element, in the capture phase. The per-element
	 * `addEventListener` ban does not apply: this is a single listener on the shell's own `<form>`,
	 * which is never re-rendered (the section views render inside it), so there is nothing to leak.
	 * `input` rather than `change` because pict binds `onchange` — waiting for blur would leave someone
	 * typing for minutes with no countdown running at all.
	 * @return {void}
	 */
	_listenForInteractions()
	{
		this._stopListeningForInteractions();
		const tmpFormElement = this._resolveDocumentFormElement();
		if (!tmpFormElement)
		{
			// No form element to watch. The framework hooks still catch edits; this is only the fast path.
			return;
		}
		// Stays attached for the life of the provider: the timer goes dormant after every save, so each
		// later edit is what wakes it again. The handler is a couple of boolean tests once a countdown
		// is already running, which is what makes it cheap enough to sit on every keystroke.
		const fHandler = (pEvent) =>
		{
			this.noteUserInteraction(pEvent?.type === 'input' ? 'typing' : 'selection');
		};
		tmpFormElement.addEventListener('input', fHandler, true);
		tmpFormElement.addEventListener('change', fHandler, true);
		this._DetachInteractionListener = () =>
		{
			tmpFormElement.removeEventListener('input', fHandler, true);
			tmpFormElement.removeEventListener('change', fHandler, true);
		};
	}

	/**
	 * The document form element the shells all declare, or null outside a browser.
	 * @return {?any}
	 */
	_resolveDocumentFormElement()
	{
		if (typeof document === 'undefined')
		{
			return null;
		}
		return document.getElementById(DOCUMENT_FORM_ID);
	}

	/**
	 * @return {void}
	 */
	_stopListeningForInteractions()
	{
		if (this._DetachInteractionListener)
		{
			this._DetachInteractionListener();
			this._DetachInteractionListener = null;
		}
	}

	/**
	 * Disarm the timer. Safe to call when nothing is running.
	 * @param {String} [pReason] - Logged when supplied.
	 * @return {void}
	 */
	stop(pReason)
	{
		this._stopListeningForInteractions();
		if (this._Timer)
		{
			clearTimeout(this._Timer);
			this._Timer = null;
		}
		if (this.Running && pReason)
		{
			this.log.info(`AutoSave: stopping — ${pReason}`);
		}
		this.Running = false;
	}

	/**
	 * Stop auto-saving because saving is failing, and tell the user once.
	 *
	 * Deliberately terminal: a form whose saves are being refused (expired session, revoked edit
	 * permission, a document locked out from under the user) would otherwise retry forever, filling
	 * the log and the network tab with writes that can never land.
	 *
	 * @param {String} pMessage - User-facing explanation.
	 * @return {void}
	 */
	suspend(pMessage)
	{
		this.stop();
		this.Suspended = true;
		this.log.warn(`AutoSave: suspended — ${pMessage}`);
		this._setState(STATES.SUSPENDED, pMessage);
		this.pict.views?.HeadlightPanels?.toast?.(
		{
			message: `<strong>Auto-save paused.</strong><br/><em>${pMessage}</em>`,
			type: 'is-warning',
			duration: 8000,
		});
	}

	/**
	 * Re-arm auto-save after a suspension. A successful save of any kind calls this.
	 * @return {boolean} Whether auto-save is running again.
	 */
	resume()
	{
		if (!this.isEligible())
		{
			return false;
		}
		this.log.info('AutoSave: resuming after a successful save.');
		return this.start();
	}

	/**
	 * Run one save immediately, bypassing the interval and the unchanged-document check.
	 *
	 * Resolves with the error rather than rejecting, matching `DocumentProvider.handleSaveAsync`.
	 * @return {Promise<Error|undefined>}
	 */
	async saveNow()
	{
		this._setState(STATES.SAVING);
		this._AutoSaveInFlight = true;
		// Snapshot what this save is about to send. Promoting *this* on success rather than the state
		// afterwards is what keeps an edit made while the save was in flight counted as pending — with a
		// dormant timer nothing would come back for it otherwise.
		const tmpSentSnapshot = this._serializeDocumentState();
		/** @type {Error|undefined} */
		let tmpError;
		try
		{
			tmpError = await this._executeSave();
		}
		catch (pError)
		{
			tmpError = pError;
		}
		finally
		{
			this._AutoSaveInFlight = false;
		}
		if (tmpError)
		{
			this._recordFailure(tmpError);
		}
		else
		{
			this._recordSuccess(tmpSentSnapshot);
		}
		return tmpError;
	}

	/**
	 * Notification from `DocumentProvider` that a save lifecycle finished, whoever started it.
	 *
	 * Restarts the countdown from the last save rather than from the last tick, so a manual Save
	 * resets the clock — the user who just saved should not get an auto-save two seconds later.
	 * Also revives a suspended provider: if a manual save now succeeds, whatever was refusing the
	 * write has cleared.
	 *
	 * @param {Error} [pError] - The error the save lifecycle produced, if any.
	 * @return {void}
	 */
	onSaveLifecycleSettled(pError)
	{
		// The auto-save path owns its own bookkeeping in saveNow(); this callback fires first for
		// those saves and would double-publish the status.
		if (this._AutoSaveInFlight)
		{
			return;
		}
		if (pError)
		{
			// A failed manual save is reported to the user by whoever requested it; auto-save keeps
			// its own counter for its own writes and does not escalate on someone else's failure.
			return;
		}
		this._captureSnapshot();
		this.LastSavedAt = new Date();
		if (this.Suspended)
		{
			this.resume();
			return;
		}
		if (!this.Running)
		{
			return;
		}
		this.ConsecutiveFailures = 0;
		this._setState(STATES.SAVED, '', true);
		if (!this.UserHasInteracted)
		{
			// Someone saved a form they have not edited — a deliberate manual save on a document they are
			// only looking at. That is their call to make once; it does not start a timer that would keep
			// making it for them.
			return;
		}
		// A manual save settles the document, so the timer sleeps until the next change — the same as
		// after an auto-save. Anything the user changed while the save was in flight keeps it awake.
		if (this._hasPendingWork())
		{
			this._scheduleNextCycle();
			return;
		}
		this._goDormant();
	}

	/**
	 * Put the timer to sleep until the next change wakes it.
	 *
	 * Clears any countdown still in flight: a manual save can settle part-way through one, and that
	 * pending timer would otherwise fire against a document already written.
	 * @return {void}
	 */
	_goDormant()
	{
		if (this._Timer)
		{
			clearTimeout(this._Timer);
			this._Timer = null;
		}
	}

	/**
	 * Arm the timer for the next cycle, replacing any pending one.
	 * @return {void}
	 */
	_scheduleNextCycle()
	{
		if (this._Timer)
		{
			clearTimeout(this._Timer);
		}
		this._Timer = setTimeout(() =>
		{
			this._Timer = null;
			this._runCycle();
		}, this.Configuration.IntervalSeconds * 1000);
	}

	/**
	 * One timer tick: attempt a save, then re-arm.
	 * @return {Promise<void>}
	 */
	async _runCycle()
	{
		if (!this.Running)
		{
			return;
		}
		try
		{
			await this._attemptSave();
		}
		catch (pError)
		{
			this.log.error(`AutoSave: unexpected error during an auto-save cycle: ${pError?.message || pError}`, { Stack: pError?.stack });
		}
		// A suspension inside the cycle clears Running, which is what stops the loop. Otherwise the timer
		// only continues while there is something outstanding: a save that could not run yet (a manual
		// save in flight, an approval action, no connection), or one that failed and will be retried.
		// With nothing pending it goes dormant, and the next change is what wakes it.
		if (!this.Running)
		{
			return;
		}
		if (this._hasPendingWork())
		{
			this._scheduleNextCycle();
			return;
		}
		this._goDormant();
	}

	/**
	 * Decide whether this cycle should actually write, and write if so.
	 * @return {Promise<void>}
	 */
	async _attemptSave()
	{
		if (!this.isEligible())
		{
			this.stop('the document is no longer editable.');
			this._setState(STATES.DISABLED);
			return;
		}
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		if (tmpDocumentProvider)
		{
			// An approval action is mid-flight (it may be locking the document right now). Writing
			// underneath it is exactly the race this feature is meant to close.
			if (tmpDocumentProvider.isTakingAction)
			{
				return;
			}
			// A manual save is already running. Its completion calls onSaveLifecycleSettled, which
			// restarts our countdown — queueing a second write here would be pure duplication.
			if (tmpDocumentProvider.IsSaving)
			{
				return;
			}
		}
		else
		{
			// No save path at all — an app shell that never registered the panels providers. Stay armed
			// in case one appears rather than reporting a failure the user cannot act on.
			return;
		}
		if (this._isBrowserOffline())
		{
			this._setState(STATES.OFFLINE, 'Waiting for a connection.');
			return;
		}
		if (this.Configuration.SkipWhenUnchanged && !this._hasUnsavedChanges())
		{
			return;
		}
		await this.saveNow();
	}

	/**
	 * Request an application save.
	 *
	 * Every save goes through the document save lifecycle, offline included — the transport is chosen
	 * inside `HeadlightDocumentService`, below this. Writing to the native bridge from here instead
	 * would skip the lifecycle, and with it the marshal and the `Document.EntityData` emission the
	 * server applies when the record reaches it.
	 *
	 * @return {Promise<Error|undefined>}
	 */
	_executeSave()
	{
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		if (!tmpDocumentProvider || typeof tmpDocumentProvider.handleSaveAsync !== 'function')
		{
			return Promise.resolve(new Error('No document save path is available.'));
		}
		// Muted: the whole point of auto-save is that it does not interrupt with a toast.
		return Promise.resolve(tmpDocumentProvider.handleSaveAsync(true));
	}

	/**
	 * Whether this form's saves are written to local storage rather than to the server.
	 *
	 * `HeadlightDocumentService` owns the transport decision; this only asks it, so auto-save and the
	 * save itself can never disagree about which one is running.
	 *
	 * @return {boolean}
	 */
	_isLocalDocumentTransport()
	{
		const tmpDocumentService = this.pict.services?.HeadlightDocumentService;
		if (!tmpDocumentService || typeof tmpDocumentService.isLocalDocumentTransport !== 'function')
		{
			return false;
		}
		return tmpDocumentService.isLocalDocumentTransport();
	}

	/**
	 * Whether the browser is reporting no network. Skipping on this is not a failure — the device is
	 * in a tunnel, not the server refusing us — so it must not count toward the suspension budget.
	 *
	 * A form on the local transport is never blocked by this: the save goes to the device, and having
	 * no network is the state it is built for.
	 *
	 * @return {boolean}
	 */
	_isBrowserOffline()
	{
		if (this._isLocalDocumentTransport())
		{
			return false;
		}
		return typeof navigator !== 'undefined' && navigator.onLine === false;
	}

	/**
	 * Serialize the parts of the document the save actually sends, for change detection.
	 * @return {?String} The snapshot, or null when it could not be produced.
	 */
	_serializeDocumentState()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData)
		{
			return null;
		}
		try
		{
			return JSON.stringify(
			{
				FormData: tmpReportData.FormData,
				EntityData: tmpReportData.EntityData,
				Observations: Array.isArray(tmpReportData.Observations) ? tmpReportData.Observations.map((pObservation) => pObservation?.IDObservation) : tmpReportData.Observations,
			});
		}
		catch (pError)
		{
			this.log.warn(`AutoSave: could not serialize the document for change detection (${pError?.message || pError}); auto-saving unconditionally.`);
			return null;
		}
	}

	/**
	 * Record the current document state as "saved".
	 * @return {void}
	 */
	_captureSnapshot()
	{
		this._SavedSnapshot = this._serializeDocumentState();
	}

	/**
	 * Whether anything has changed since the last snapshot. Unserializable state is treated as
	 * changed so a form with exotic values still gets saved.
	 * @return {boolean}
	 */
	_hasUnsavedChanges()
	{
		const tmpSnapshot = this._serializeDocumentState();
		if (tmpSnapshot === null || this._SavedSnapshot === null)
		{
			return true;
		}
		return tmpSnapshot !== this._SavedSnapshot;
	}

	/**
	 * Whether the user has changed the document since it loaded or was last saved, whether or not
	 * auto-save is running for it. A form nobody has touched never reads as changed, even when the
	 * load-time solve or entity hydration moved values.
	 * @return {boolean}
	 */
	hasUnsavedUserChanges()
	{
		if (!this.UserHasInteracted)
		{
			return false;
		}
		// Auto-save's own baseline when it has one; when it is off and nothing has been saved yet, the
		// document as it stood just before the first edit.
		const tmpBaseline = (this._SavedSnapshot !== null) ? this._SavedSnapshot : this._FirstInteractionSnapshot;
		const tmpCurrent = this._serializeDocumentState();
		if ((tmpCurrent === null) || (tmpBaseline === null))
		{
			return true;
		}
		return tmpCurrent !== tmpBaseline;
	}

	/**
	 * @param {?String} [pSentSnapshot] - The document state this save sent, if it is known.
	 * @return {void}
	 */
	_recordSuccess(pSentSnapshot)
	{
		this.ConsecutiveFailures = 0;
		if (pSentSnapshot === undefined)
		{
			this._captureSnapshot();
		}
		else
		{
			this._SavedSnapshot = pSentSnapshot;
		}
		this.LastSavedAt = new Date();
		this._setState(STATES.SAVED, '', true);
	}

	/**
	 * Escalate a failed auto-save: back off, then suspend once it is clear the write cannot land.
	 * @param {Error} pError - The save error.
	 * @return {void}
	 */
	_recordFailure(pError)
	{
		this.ConsecutiveFailures++;
		this.log.error(`AutoSave: save attempt ${this.ConsecutiveFailures} failed: ${pError?.message || pError}`);
		if (AutoSaveProvider.isAuthorizationError(pError))
		{
			this.suspend('Your permission to edit this document has changed. Reload the page to continue.');
			return;
		}
		if (this.ConsecutiveFailures >= this.Configuration.MaxConsecutiveFailures)
		{
			this.suspend('The document could not be saved after several attempts. Use the Save button once the problem clears.');
			return;
		}
		this._setState(STATES.RETRYING, 'The last auto-save did not complete. Retrying.');
	}

	/**
	 * Whether an error means "the server refused you" rather than "the server was unreachable".
	 * @param {any} pError - The error to classify.
	 * @return {boolean}
	 */
	static isAuthorizationError(pError)
	{
		if (!pError)
		{
			return false;
		}
		const tmpStatus = pError.StatusCode ?? pError.statusCode ?? pError.status;
		if (tmpStatus === 401 || tmpStatus === 403)
		{
			return true;
		}
		const tmpMessage = String(pError.message || pError);
		return AUTHORIZATION_ERROR_PATTERNS.some((pPattern) => pPattern.test(tmpMessage));
	}

	/**
	 * @param {String} pState - One of STATES.
	 * @param {String} [pMessage] - Optional user-facing detail, surfaced as the indicator tooltip.
	 * @param {boolean} [pFlash] - Whether the indicator should briefly draw attention to itself.
	 * @return {void}
	 */
	_setState(pState, pMessage, pFlash)
	{
		this.State = pState;
		this.StateMessage = pMessage || '';
		this._publishStatus(pFlash);
	}

	/**
	 * Push the current state into AppData for the navbar indicator, and nudge the panels view to
	 * repaint it.
	 *
	 * `StatusSlot` is the one-or-zero-element array the navbar template iterates: empty renders
	 * nothing at all, which is what a form with auto-save turned off should show.
	 * @param {boolean} [pFlash] - Whether this transition should animate.
	 * @return {void}
	 */
	_publishStatus(pFlash)
	{
		const tmpRecord = this._buildStatusRecord(pFlash);
		this.pict.AppData.AutoSave =
		{
			Enabled: Boolean(this.Configuration?.Enabled),
			Running: this.Running,
			Suspended: this.Suspended,
			State: this.State,
			IntervalSeconds: this.Configuration?.IntervalSeconds,
			LastSavedISO: this.LastSavedAt ? this.LastSavedAt.toISOString() : null,
			StatusSlot: tmpRecord ? [ tmpRecord ] : [],
		};
		this.pict.views?.HeadlightPanels?.syncAutoSaveStatus?.();
	}

	/**
	 * Build the record the indicator template renders, or null when nothing should be shown.
	 * @param {boolean} [pFlash] - Whether this transition should animate.
	 * @return {?{ State: String, Label: String, IconClass: String, StateClass: String, Tooltip: String, FlashClass: String }}
	 */
	_buildStatusRecord(pFlash)
	{
		if (this.State === STATES.DISABLED)
		{
			return null;
		}
		const tmpPresentation = STATE_PRESENTATION[this.State] || STATE_PRESENTATION[STATES.IDLE];
		const tmpSavedClock = this.LastSavedAt ? this._formatClockTime(this.LastSavedAt) : '';
		let tmpLabel;
		switch (this.State)
		{
		case STATES.SAVING:
			tmpLabel = 'Saving…';
			break;
		case STATES.SAVED:
			tmpLabel = `Saved ${tmpSavedClock}`;
			break;
		case STATES.OFFLINE:
			tmpLabel = 'Waiting for connection';
			break;
		case STATES.RETRYING:
			tmpLabel = 'Save retrying';
			break;
		case STATES.SUSPENDED:
			tmpLabel = 'Auto-save paused';
			break;
		default:
			tmpLabel = tmpSavedClock ? `Saved ${tmpSavedClock}` : 'Auto-save on';
			break;
		}
		let tmpTooltip = this.StateMessage;
		if (!tmpTooltip)
		{
			tmpTooltip = tmpSavedClock ?
				`Auto-saving every ${this.Configuration.IntervalSeconds} seconds. Last saved at ${tmpSavedClock}.` :
				`Auto-saving every ${this.Configuration.IntervalSeconds} seconds.`;
		}
		return {
			State: this.State,
			Label: tmpLabel,
			IconClass: tmpPresentation.IconClass,
			StateClass: tmpPresentation.StateClass,
			Tooltip: tmpTooltip,
			FlashClass: pFlash ? 'is-flashing' : '',
		};
	}

	/**
	 * Format a wall-clock time in the document's timezone when Fable's Dates service is available.
	 * @param {Date} pDate - The moment to format.
	 * @return {String}
	 */
	_formatClockTime(pDate)
	{
		try
		{
			if (this.fable?.Dates?.dayJS)
			{
				return this.fable.Dates.dayJS(pDate).format('h:mm A');
			}
		}
		catch (pError)
		{
			this.log.trace?.(`AutoSave: falling back to the native clock formatter (${pError?.message || pError}).`);
		}
		return pDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	}
}

module.exports = AutoSaveProvider;
module.exports.STATES = STATES;
module.exports.DEFAULT_INTERVAL_SECONDS = DEFAULT_INTERVAL_SECONDS;
module.exports.MINIMUM_INTERVAL_SECONDS = MINIMUM_INTERVAL_SECONDS;
module.exports.MAXIMUM_INTERVAL_SECONDS = MAXIMUM_INTERVAL_SECONDS;
module.exports.DEFAULT_MAX_CONSECUTIVE_FAILURES = DEFAULT_MAX_CONSECUTIVE_FAILURES;
module.exports.USER_PREFERENCE_ENABLED_KEY = USER_PREFERENCE_ENABLED_KEY;
module.exports.USER_PREFERENCE_INTERVAL_KEY = USER_PREFERENCE_INTERVAL_KEY;

},{"pict-provider":552,"pict-section-form/source/views/Pict-View-DynamicForm.js":653}],33:[function(require,module,exports){
const Async = require('async');
const PictProvider = require('pict-provider');

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */
/** @typedef {import('./InputTypeBehaviorProvider')} InputTypeBehaviorProvider */

/**
 * @typedef {Object} FieldDistillingMapping
 *
 * @property {String} DatumKey - The data locatinon with in the form.
 * @property {String} BundleHash - The bundle hash to load from the distilling service.
 * @property {String} [BundleNameKey] - (optional) The bundle key that represents the value's name (for display). If omitted, the value is used for name and value.
 * @property {String} BundleValueKey - The bundle key that represents the value to store in the form datum.
 * @property {String} Type - The type of control (used to understand how to marshal data). 'select' is for a select2 dropdown, otherwise it is treated as scalar text.
 * @property {Boolean} [Readonly] - (optional) If the field should be readonly.
 * @property {String} [NoSelectionName] - (optional) The name to use for the "no selection" option.
 * @property {String} [NoSelectionValue] - (optional) The value to use for the "no selection" option.
 */

/**
 * Provider to add behaviors to interface with views / controls based on InputType.
 *
 * Ideas:
 *
 * Understand what kind of values the control can accept? Single- vs. multi-value?
 * Understand whether the control is editable / readonly.
 * Understand whether the control can be auto-filled.
 * Understand whether the control is part of a formula? (ex. in case we need to trigger the solver on distilling?)
 * Understand the control's connection to the distilling bundle.
 * Get / set the control value / selection.
 */
class DistillingProvider extends PictProvider
{
	/**
	 * @param {any} pFable - Fable instance
	 * @param {Object} pOptions - Options for the provider
	 * @param {String} pServiceHash - Hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/**
		 * @type {{
		 *	Interactive: boolean,
		 *	ConditionalCSS: Record<String, String>,
		 *	InitialSaveRequired: boolean,
		 *	Status: string,
		 *	DistillingMapping: Array<FieldDistillingMapping>,
		 *	Select2OptionsCache: Record<String, Array<{ id: string, text: string }>>,
		 *	DocumentData: any,
		 * }}
		 */
		this.AppData;
		// this is set on each index.html for the respective document behavior
		this.AppData.Interactive = window['_InteractiveForm'];
		this.Application = this.pict.PictApplication;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;
	}

	/**
	 * Using this top get the right type checking. zzz
	 *
	 * @return {InputTypeBehaviorProvider}
	 */
	get input()
	{
		return this.pict.providers.Input;
	}

	/**
	 * Initialize the provider. Call this before any other methods to provide relevant configuration.
	 *
	 * @private
	 *
	 * @param {Object} reportOptions - The report options.
	 * @param {Object} formManifestDefinition - The form manifest definition.
	 */
	_initializeProvider(reportOptions, formManifestDefinition)
	{
		if (Array.isArray(reportOptions?.DistillingMapping))
		{
			this.AppData.DistillingMapping = reportOptions.DistillingMapping;
		}
		else
		{
			this.AppData.DistillingMapping = this.extractDistillingMappingFromManifest(formManifestDefinition?.Descriptors);
		}
		if (Array.isArray(this.AppData.DistillingMapping))
		{
			// only keep mapping with required values populated
			this.AppData.DistillingMapping = this.AppData.DistillingMapping.filter((mapping) =>
			{
				const isValid = mapping?.BundleValueKey && mapping?.BundleHash && mapping?.DatumKey;
				if (!isValid)
				{
					this.pict.log.error('Invalid distilling mapping; ignoring', { mapping });
				}
				return isValid;
			});
		}
	}

	/**
	 * Initialize an HTML element as a distilling enabled control.
	 *
	 * @param {HTMLElement} input - The input to initialize.
	 * @param {Array<FieldDistillingMapping>} [dataToBundleKeyMappings] - The mappings from form fields to distilling bundle keys.
	 *
	 * @return {boolean} - True if the control was initialized.
	 */
	initializeControl(input, dataToBundleKeyMappings)
	{
		//FIXME: separation of concerns
		if (input instanceof HTMLSelectElement && input.getAttribute('pict-initialized') !== 'true')
		{
			const datumInput = this.input.getInputElementForControlElement(input);
			if (!datumInput)
			{
				this.pict.fable.log.error('No datum input found for control', { input });
				return false;
			}
			const options = { };
			const datumKey = datumInput.getAttribute('data-i-datum');
			if (datumKey && dataToBundleKeyMappings.some((mapping) => mapping.DatumKey == datumKey))
			{
				options.dataAdapter = $.fn.select2.amd.require('select2/data/localPaginationAdapter');
				options.ajax = {}; // necessary for pagination to work
				options.datumKey = datumKey; // attaches to the select2 options cache for local pagination (currently only used by distilling)
			}
			this.pict.log.info(`Initializing select2 for ${datumKey} with distilling`, { input });
			$(input).select2(options);
			input.setAttribute('pict-initialized', 'true');
			return true;
		}
		return false;
	}

	/**
	 * Synthesize the distilling mapping from the form definition.
	 *
	 * @param {Record<String, any> | Array<any>} descriptorMap - The descriptor map.
	 *
	 * @return {Array<FieldDistillingMapping>} - The field level distilling mappings to use.
	 */
	extractDistillingMappingFromManifest(descriptorMap)
	{
		const mapping = [];
		if (!descriptorMap)
		{
			return mapping;
		}

		if (!(typeof descriptorMap === 'object'))
		{
			this.pict.fable.log.error('Invalid descriptor map type', { descriptorMap });
			return mapping;
		}

		for (const [ datumKey, descriptor ] of Object.entries(descriptorMap))
		{
			if (typeof descriptor.PictForm?.DistillingMapping === 'object')
			{
				descriptor.PictForm.DistillingMapping.DatumKey = datumKey;
				// attempting to note here fields that should not be considered selected (readonly)
				descriptor.PictForm.DistillingMapping.Type = descriptor.PictForm?.InputType?.toLowerCase() || descriptor.DataType?.toLowerCase();
				if (!('Readonly' in descriptor.PictForm.DistillingMapping))
				{
					descriptor.PictForm.DistillingMapping.Readonly = descriptor.PictForm.Readonly || descriptor.PictForm.DistillingMapping.Type.toLowerCase() == 'readonly';
				}
				mapping.push(descriptor.PictForm.DistillingMapping);
			}
		}
		return mapping;
	}

	/**
	 * Handle document loaded event.
	 *
	 * @param {Record<String, any>} data - The loaded data.
	 */
	async onDataLoad(data)
	{
		//FIXME: once lifecycle exists for real: await super.onDataLoad(data);
		const doc = data?.DocumentData?.ReportData;

		//FIXME: should be able to work from other data sources, not just documents
		if (!doc)
		{
			this.pict.log.error('No document found for distilling provider', { data });
			return;
		}

		//FIXME: just once?
		this._initializeProvider(doc?.ReportOptions, this.pict.settings.DefaultFormManifest);

		//FIXME: streamline / parallelize this
		/**
		 * @type {Record<String, import('@paviasystems/grafee').Grafee>}
		 */
		this.Graphs = { };
		if (this.AppData.DistillingMapping?.length > 0)
		{
			const bundlesToLoad = Array.from(new Set(this.AppData.DistillingMapping
				.map((mapping) => mapping.BundleHash)
				.filter((bundleHash) => typeof bundleHash === 'string')));
			await Async.eachLimit(bundlesToLoad, 3, (bundleHash, next) =>
			{
				//FIXME: may want to source the project ID from elsewhere in some cases
				const uri = bundleHash ? `Distilling/For/${bundleHash}/Project/${doc.IDProject}` : `Distilling/For/Project/${doc.IDProject}`;
				this.pict.HeadlightRestClient.getJSON(uri, (err, bundleResponse) =>
				{
					if (err)
					{
						if (!(err instanceof Error))
						{
							err = new Error(err);
						}
						return next(err);
					}
					const graph = new window.Grafee(bundleResponse.Bundle);
					this.Graphs[bundleHash] = graph;
					next();
				});
			});
		}
	}

	/**
	 * Use configuration to look up current values for distilling mapped fields.
	 *
	 * @return {Record<String, String>} - The distilled values.
	 */
	getDistilledValues()
	{
		/** @type {Record<string, string>} */
		const snapshot = { };
		if (!this.AppData.DistillingMapping?.length)
		{
			return snapshot;
		}
		const formData = this.AppData.DocumentData?.ReportData?.FormData;
		if (!formData)
		{
			return snapshot;
		}
		for (const { DatumKey: datumKey } of this.AppData.DistillingMapping)
		{
			const value = this.pict.manifest.getValueAtAddress(formData, datumKey);
			snapshot[datumKey] = value;
		}
		return snapshot;
	}

	/**
	 * Wire any ui controls to pull data from the distilling graph, based on configuration.
	 *
	 * @param {Array<FieldDistillingMapping>} dataToBundleKeyMappings - The mappings from form fields to distilling bundle keys.
	 */
	registerDistilling(dataToBundleKeyMappings)
	{
		if (!Array.isArray(dataToBundleKeyMappings))
		{
			return;
		}

		const getSelectedValues = () =>
		{
			const snapshot = this.getDistilledValues();
			const selectedValues = { };
			for (const { DatumKey: datumKey, BundleValueKey: bundleValueKey, Readonly: readonly } of dataToBundleKeyMappings)
			{
				if (readonly)
				{
					// don't put readonly fields in the selected values as they are not editable
					continue;
				}
				if (snapshot[datumKey] !== undefined && snapshot[datumKey] !== null && snapshot[datumKey] !== '')
				{
					selectedValues[bundleValueKey] = snapshot[datumKey];
				}
			}
			return selectedValues;
		};

		/**
		 * Trigger the distilling cascade for a given field mapping.
		 *
		 * TODO: decide how we want to handle autofill then removing the original value
		 *
		 * @param {FieldDistillingMapping} sourceFieldMapping - The source field mapping.
		*/
		const triggerDistillingCascade = (sourceFieldMapping) =>
		{
			//TODO: this should also handle invalidating fields as needed
			for (const fieldMapping of dataToBundleKeyMappings)
			{
				const { BundleHash: bundleHash, DatumKey: datumKey, BundleNameKey: bundleNameKey, BundleValueKey: bundleValueKey, Type: type } = fieldMapping;
				/** @type {import('@paviasystems/grafee').Grafee} */
				const graph = this.Graphs[bundleHash];
				if (!graph || !type || type == 'select' || type == 'option')
				{
					continue;
				}
				const values = graph.listValues(bundleValueKey, getSelectedValues());
				if (values && values.length == 1)
				{
					let nameAndValue;
					if (bundleNameKey)
					{
						nameAndValue = graph.extractJoinedValues(bundleValueKey, values, [ bundleNameKey || bundleValueKey ])[0];
					}
					else
					{
						nameAndValue = { [bundleValueKey]: values[0] };
					}
					//FIXME: how should we approach setting both value and display name? do we need that?
					this.input.setValue(`[data-i-datum="${datumKey}"]`, nameAndValue[bundleNameKey || bundleValueKey]);
				}
			}
		};

		const initValues = getSelectedValues();
		for (const fieldMapping of dataToBundleKeyMappings)
		{
			const {
				BundleHash: bundleHash,
				DatumKey: datumKey,
				BundleNameKey: bundleNameKey,
				BundleValueKey: bundleValueKey,
				Type: type,
				NoSelectionName: noSelectionName = 'Select an option',
				NoSelectionValue: noSelectionValue = fieldMapping.Type == 'numeric' ? '0' :'',
			} = fieldMapping;

			const graph = this.Graphs[bundleHash];
			if (!graph)
			{
				this.pict.fable.log.error(`No data graph found for ${bundleHash} processing distilling mapping for ${datumKey}`, { fieldMapping });
				continue;
			}
			if (!type || type == 'select' || type == 'option')
			{
				const element = document.querySelector(`[data-i-datum="${datumKey}"]`);
				let inputElement;
				let selectElement;
				if (element && element instanceof HTMLInputElement)
				{
					inputElement = element;
					//FIXME: this belongs in the input provider
					selectElement = document.getElementById('SELECT-FOR-' + element.id);
				}
				if (element && element instanceof HTMLSelectElement)
				{
					selectElement = element;
					inputElement = this.input.getInputElementForControlElement(element);
				}
				if (!inputElement || !selectElement || !(selectElement instanceof HTMLSelectElement) || !(inputElement instanceof HTMLInputElement))
				{
					this.pict.log.error('Unable to resolve elements for control', { element });
					continue;
				}
				const $selectElement = $(selectElement);
				const cacheDistilledSelect2OptionsJustInTime = () =>
				{
					const selectedValues = getSelectedValues();
					//FIXME: using search and making this dynamic would be much better
					const values = graph.listValues(bundleValueKey, selectedValues);
					/** @type {Array<Record<String, any>>} */
					let namesAndValues;
					//FIXME: put an option for "no selection" in here??
					if (bundleNameKey)
					{
						namesAndValues = graph.extractJoinedValues(bundleValueKey, values, [ bundleNameKey || bundleValueKey ]);
					}
					else
					{
						// no need to query, but convert to objects so code below is agnostic
						namesAndValues = values.map((value) => ({ [bundleValueKey]: value }));
					}
					/** @type {Array<Array<string>>} */
					const select2Options = namesAndValues.map((nameAndValue) =>
						[
							nameAndValue[bundleValueKey] ?? '',
							nameAndValue[bundleNameKey || bundleValueKey] ?? '(no name)',
						]);
					select2Options.unshift([ noSelectionValue, noSelectionName || 'N/A' ]);
					this.pict.fable.log.info(`Pushing ${namesAndValues.length} values for ${datumKey} from ${bundleNameKey || bundleValueKey} (${bundleValueKey})`);
					this.input.setOptions(`[data-i-datum="${datumKey}"]`, select2Options);
				};
				//FIXME: how to delegate all of this to the InputTypeProvider?
				$selectElement.on('select2:opening', cacheDistilledSelect2OptionsJustInTime);
				$selectElement.on('select2:close', triggerDistillingCascade.bind(this, fieldMapping));

				// set initial select2 state for distilled fields
				$selectElement.empty();
				const emptyOption = new Option(noSelectionName, noSelectionValue, true, false);
				$selectElement.append(emptyOption).trigger('change');

				// on load, we just put one value in there, so we can show the selection - the full list is deferred until interaction
				if (bundleValueKey in initValues)
				{
					const value = initValues[bundleValueKey];
					const nameAndValue = graph.extractJoinedValues(bundleValueKey, [ value ], [ bundleNameKey || bundleValueKey ])[0];
					const newOption = new Option(nameAndValue?.[bundleNameKey || bundleValueKey] || value, value, false, true);
					$selectElement.append(newOption).trigger('change');
				}
			}
			//FIXME: how to support other types of inputs in a sane way?
			else // sane?
			{
				const values = graph.listValues(bundleValueKey, getSelectedValues());
				if (values && values.length == 1)
				{
					this.input.setValue(`[data-i-datum="${datumKey}"]`, values[0]);
				}
			}
		}
	}
/*
	Below are the available events from the parent class (PictProvider):

	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}
*/
}

module.exports = DistillingProvider;

},{"async":330,"pict-provider":552}],34:[function(require,module,exports){
const PictProvider = require('pict-provider');

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */

/** The postMessage channel both sides filter on. The parent copy lives in web/headlight-platform-configuration/source/documents/DocumentFrameSwitcher-Provider.js. */
const CHANNEL = 'headlight-document-frame';

/** The query parameter a parent puts on the form URL to adopt the page as one of its document frames. */
const FRAME_PARAMETER = 'HeadlightFrame';

/** State changes arrive per keystroke; the parent only needs to hear about them a few times a second. */
const NOTIFY_DEBOUNCE_MS = 250;

/**
 * @typedef {Object} DocumentFrameState
 * @property {boolean} Ready - Whether the form has finished loading and drawing.
 * @property {number} IDDocument
 * @property {String} Status - The document's approval status.
 * @property {boolean} Locked
 * @property {boolean} CanEdit
 * @property {boolean} HasUnsavedChanges - The user changed the document since it was loaded or last saved.
 * @property {boolean} Saving
 * @property {boolean} ApprovalBusy - An approval action is running.
 * @property {boolean} ReloadPending - An approval action landed and the page is about to reload itself.
 */

/**
 * Lets a same-origin parent page host this document form in an iframe and work with it: the parent learns
 * when the form is ready, whether it holds unsaved changes and what its approval state is, and can ask it
 * to save. The form itself is untouched; saving goes through DocumentProvider exactly as the Save button does.
 *
 * Inert unless the page is framed and its URL carries `HeadlightFrame=<id>`, so the standalone form, the PDF
 * render and the iOS offline template never see it.
 *
 * Messages are `{ channel, frameId, type, ... }`. Parent to frame: `getState`, `save` (each with a `requestId`).
 * Frame to parent: `ready` (with the `[FormLoad]` timing summary), `state`, and the `requestId`-tagged replies
 * `state` and `saveResult`.
 */
class DocumentFrameProvider extends PictProvider
{
	/**
	 * @param {any} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {?String} */
		this.FrameID = DocumentFrameProvider.readFrameID(typeof window === 'undefined' ? null : window);
		/** @type {boolean} */
		this.Enabled = !!this.FrameID;
		/** @type {boolean} */
		this.Ready = false;
		/** @type {?String} - The last state posted, so an unchanged state is not re-sent. */
		this._LastPostedState = null;
		/** @type {any} */
		this._NotifyTimer = null;

		if (this.Enabled)
		{
			this._onMessage = this._onMessage.bind(this);
			window.addEventListener('message', this._onMessage);
		}
	}

	/**
	 * The frame id the parent assigned, or null when this page is not hosted as a document frame.
	 *
	 * @param {any} pWindow - The page's window.
	 * @return {?String}
	 */
	static readFrameID(pWindow)
	{
		if (!pWindow || !pWindow.parent || (pWindow.parent === pWindow) || !pWindow.location)
		{
			return null;
		}
		try
		{
			const tmpFrameID = new URLSearchParams(pWindow.location.search).get(FRAME_PARAMETER);
			return tmpFrameID || null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * @return {DocumentFrameState}
	 */
	getState()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData || { };
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		const tmpAutoSave = this.pict.providers?.AutoSave;
		let tmpHasUnsavedChanges = false;
		try
		{
			tmpHasUnsavedChanges = !!(tmpAutoSave && (typeof tmpAutoSave.hasUnsavedUserChanges === 'function') && tmpAutoSave.hasUnsavedUserChanges());
		}
		catch (pError)
		{
			this.log.warn(`DocumentFrame: could not tell whether the document has unsaved changes: ${pError?.message || pError}`);
		}
		return {
			Ready: this.Ready,
			IDDocument: Number(tmpReportData.IDDocument) || 0,
			Status: tmpReportData.Status || '',
			Locked: !!tmpReportData.Locked,
			CanEdit: !!tmpReportData.CanEdit,
			HasUnsavedChanges: tmpHasUnsavedChanges,
			Saving: !!tmpDocumentProvider?.IsSaving,
			ApprovalBusy: !!tmpDocumentProvider?.isTakingAction,
			ReloadPending: !!tmpDocumentProvider?._ApprovalReloadPending,
		};
	}

	/**
	 * The form has loaded and drawn; tell the parent, with the load timing. Once per page load.
	 *
	 * @param {any} [pTiming] - The `[FormLoad]` summary.
	 * @return {void}
	 */
	announceReady(pTiming)
	{
		if (!this.Enabled || this.Ready)
		{
			return;
		}
		this.Ready = true;
		const tmpState = this.getState();
		this._LastPostedState = JSON.stringify(tmpState);
		this._post({ type: 'ready', state: tmpState, timing: pTiming || null });
	}

	/**
	 * Something the parent shows may have changed (an edit, a save, an approval action). Debounced.
	 *
	 * @param {boolean} [pImmediately] - Post now, e.g. when the page is about to reload.
	 * @return {void}
	 */
	notifyChanged(pImmediately)
	{
		if (!this.Enabled)
		{
			return;
		}
		if (this._NotifyTimer)
		{
			clearTimeout(this._NotifyTimer);
			this._NotifyTimer = null;
		}
		if (pImmediately)
		{
			this._postStateIfChanged();
			return;
		}
		this._NotifyTimer = setTimeout(() =>
		{
			this._NotifyTimer = null;
			this._postStateIfChanged();
		}, NOTIFY_DEBOUNCE_MS);
	}

	/** Post the current state unless it is what the parent already has. */
	_postStateIfChanged()
	{
		const tmpState = this.getState();
		const tmpSerialized = JSON.stringify(tmpState);
		if (tmpSerialized === this._LastPostedState)
		{
			return;
		}
		this._LastPostedState = tmpSerialized;
		this._post({ type: 'state', state: tmpState });
	}

	/**
	 * @param {MessageEvent} pEvent
	 * @return {void}
	 */
	_onMessage(pEvent)
	{
		const tmpData = pEvent?.data;
		if (!tmpData || (tmpData.channel !== CHANNEL) || (tmpData.frameId !== this.FrameID))
		{
			return;
		}
		if ((pEvent.source !== window.parent) || (pEvent.origin !== window.location.origin))
		{
			return;
		}
		switch (tmpData.type)
		{
		case 'getState':
				this._post({ type: 'state', requestId: tmpData.requestId, state: this.getState() });
			return;
		case 'save':
				this._save(tmpData.requestId);
			return;
		default:
			return;
		}
	}

	/**
	 * @param {String} pRequestID
	 * @return {Promise<void>}
	 */
	async _save(pRequestID)
	{
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		let tmpError = null;
		if (!tmpDocumentProvider || (typeof tmpDocumentProvider.handleSaveAsync !== 'function'))
		{
			tmpError = 'This form cannot be saved.';
		}
		else
		{
			try
			{
				const tmpSaveError = await tmpDocumentProvider.handleSaveAsync(false);
				if (tmpSaveError)
				{
					tmpError = tmpSaveError.message || String(tmpSaveError);
				}
			}
			catch (pError)
			{
				tmpError = pError?.message || String(pError);
			}
		}
		const tmpState = this.getState();
		this._LastPostedState = JSON.stringify(tmpState);
		this._post({ type: 'saveResult', requestId: pRequestID, error: tmpError, state: tmpState });
	}

	/**
	 * @param {Record<String, any>} pMessage
	 * @return {void}
	 */
	_post(pMessage)
	{
		try
		{
			window.parent.postMessage(Object.assign({ channel: CHANNEL, frameId: this.FrameID }, pMessage), window.location.origin);
		}
		catch (pError)
		{
			this.log.warn(`DocumentFrame: could not reach the hosting page: ${pError?.message || pError}`);
		}
	}
}

module.exports = DocumentFrameProvider;
module.exports.CHANNEL = CHANNEL;
module.exports.FRAME_PARAMETER = FRAME_PARAMETER;

},{"pict-provider":552}],35:[function(require,module,exports){
const PictProvider = require('pict-provider');

/** @typedef {import('./DistillingProvider')} DistillingProvider */
/** @typedef {import('./DistillingProvider').FieldDistillingMapping} FieldDistillingMapping */

/** @typedef {import('../HeadlightConfigurableApplication.js').Pict} Pict */

/**
 * Base class for InputType providers.
 *
 * Ideas:
 *
 * Understand what kind of values the control can accept? Single- vs. multi-value?
 * Understand whether the control is editable / readonly.
 * Understand whether the control can be auto-filled.
 * Understand whether the control is part of a formula? (ex. in case we need to trigger the solver on distilling?)
 * Understand the control's connection to the distilling bundle.
 * Get / set the control value / selection.
 */
class InputTypeProvider
{
	/**
	 * @param {Pict} pict - The Pict instance.
	 * @param {Function} formManifestDefinitionProvider - The form manifest definition.
	 */
	constructor(pict, formManifestDefinitionProvider)
	{
		this.pict = pict;
		this.formManifestDefinitionProvider = formManifestDefinitionProvider;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is supported by this provider.
	 */
	isControlSupported(element)
	{
		return false;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {boolean} - Whether the control is a scalar value (only stores a single selection).
	 */
	isScalar(element, manifestDefinition)
	{
		return true;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is editable.
	 */
	isEditable(element)
	{
		return true;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is aut-fill-able.
	 */
	isAutoFillEnabled(element)
	{
		return true;
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is part of a solver formula.
	 */
	isSolved(element)
	{
		return true;
	}

	/**
	 * Get the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(element, manifestDefinition)
	{
		return '';
	}

	/**
	 * Set the available options for the control (if supported).
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Array<Array<string>> | Array<string>} options - The options to set. Each array element is [ value, display ]. If there is no display, inner array can be the value string.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setOptions(element, options, manifestDefinition)
	{
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to set.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setValue(element, value, manifestDefinition)
	{
	}

	/**
	 * Add a control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to add.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	addValue(element, value, manifestDefinition)
	{
	}

	/**
	 * Remove the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to remove.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	removeValue(element, value, manifestDefinition)
	{
	}

	/**
	 * Get the input element for the control (where the value is stored in the DOM / has data-i-datum / etc.).
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {HTMLInputElement} the input element
	 */
	getInputElement(element)
	{
		if (element instanceof HTMLInputElement)
		{
			return element;
		}
		return null;
	}
}

/**
 * Provider for select input types.
 *
 * NOTE: We use select2 for all select inputs.
 */
class SelectInputTypeProvider extends InputTypeProvider
{
	/**
	 * @param {Pict} pict - The Pict instance.
	 * @param {Function} formManifestDefinitionProvider - The form manifest definition.
	 */
	constructor(pict, formManifestDefinitionProvider)
	{
		super(pict, formManifestDefinitionProvider);
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is supported by this provider.
	 */
	isControlSupported(element)
	{
		if (element.tagName == 'SELECT')
		{
			return true;
		}
		// if the control is the hidden control, resolve over to the select control
		const selectElement = document.getElementById('SELECT-FOR-' + element.id);
		if (selectElement && selectElement.tagName == 'SELECT')
		{
			return true;
		}
		return false;
	}

	/**
	 * Get the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(element, manifestDefinition)
	{
		return $(element).val();
	}

	/**
	 * Set the available options for the control (if supported).
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {Array<Array<string>> | Array<string>} options - The options to set. Each array element is [ value, display ]. If there is no display, inner array can be the value string.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setOptions(element, options, manifestDefinition)
	{
		/** @type {Array<{ id: string, text: string }>} */
		const select2Options = options.map((option) =>
		{
			if (Array.isArray(option))
			{
				return { id: option[0], text: option[1] || option[0] || '(no name)' };
			}
			return { id: option, text: option };
		});
		const inputElement = this.getInputElement(element);
		if (!inputElement)
		{
			this.pict.log.error(`SelectInputTypeProvider::setOptions: Could not find input element for select control.`, { element });
			return;
		}
		const datumKey = inputElement.getAttribute('data-i-datum');
		this.setSelect2OptionsForDatumKey(datumKey, select2Options);
	}

	/**
	 * Cache available values for a given field.
	 *
	 * @param {String} datumKey - The datum key to cache values for.
	 * @param {Array<{ id: string, text: string }>} namesAndValues - The values to cache.
	 */
	setSelect2OptionsForDatumKey(datumKey, namesAndValues)
	{
		const cache = this.pict.AppData.Select2OptionsCache = this.pict.AppData.Select2OptionsCache || { };
		cache[datumKey] = namesAndValues;
		this.pict.AppData.Select2OptionsCache = cache;
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to set.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	setValue(element, value, manifestDefinition)
	{
		$(element).val(value).trigger('change');
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number} value - The value to add.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	addValue(element, value, manifestDefinition)
	{
		if (this.isScalar(element, manifestDefinition))
		{
			this.setValue(element, value, manifestDefinition);
			return;
		}

		let selection = $(element).val();
		if (!Array.isArray(selection))
		{
			selection = [ String(selection) ];
		}
		if (selection.includes(String(value)))
		{
			return;
		}
		$(element).val(selection.concat([ String(value) ])).trigger('change');
	}

	/**
	 * Remove a value from the control.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to remove.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 */
	removeValue(element, value, manifestDefinition)
	{
		if (this.isScalar(element, manifestDefinition))
		{
			this.setValue(element, '', manifestDefinition);
			return;
		}

		let selection = $(element).val();
		if (!Array.isArray(selection))
		{
			selection = [ String(selection) ];
		}
		if (!selection.includes(String(value)))
		{
			return;
		}
		$(element).val(selection.filter((i) => i == value)).trigger('change');
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 * @param {Object} manifestDefinition - The manifest definition for the element.
	 *
	 * @return {boolean} - Whether the control is a scalar value (only stores a single selection).
	 */
	isScalar(element, manifestDefinition)
	{
		//FIXME: made up this property - does it exist?
		return !manifestDefinition?.MultiSelect;
	}

	/**
	 * Get the input element for the control (where the value is stored in the DOM / has data-i-datum / etc.).
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {HTMLInputElement} the input element
	 */
	getInputElement(element)
	{
		if (element instanceof HTMLSelectElement && element.id.startsWith('SELECT-FOR-'))
		{
			const hiddenElementID = element.id.replace('SELECT-FOR-', '');
			const hiddenInput = document.getElementById(hiddenElementID);
			if (!hiddenInput || !(hiddenInput instanceof HTMLInputElement))
			{
				this.pict.fable.log.error(`Could not find datum element for select; referenced element not found: ${hiddenElementID}`, { element });
				return null;
			}
			return hiddenInput;
		}
		if (element instanceof HTMLInputElement)
		{
			const selectElementID = 'SELECT-FOR-' + element.id;
			const selectInput = document.getElementById(selectElementID);
			if (!selectInput || !(selectInput instanceof HTMLSelectElement))
			{
				this.pict.fable.log.error(`Could not find datum element for select; referenced element not found: ${element.id}`, { element });
				return null;
			}
			return element;
		}
		this.pict.fable.log.error(`Could not find datum element for select; malformed ID: ${element.id}`, { element });
		return null;
	}
}

/**
 * Provider for text input types.
 */
class TextInputTypeProvider extends InputTypeProvider
{
	/**
	 * @param {Pict} pict - The Pict instance.
	 * @param {Function} formManifestDefinitionProvider - The form manifest definition.
	 */
	constructor(pict, formManifestDefinitionProvider)
	{
		super(pict, formManifestDefinitionProvider);
	}

	/**
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {boolean} - Whether the control is supported by this provider.
	 */
	isControlSupported(element)
	{
		return element instanceof HTMLInputElement;
	}

	/**
	 * Get the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(element)
	{
		if (element instanceof HTMLInputElement)
		{
			return element.value;
		}
		return element.innerText;
	}

	/**
	 * Set the control value.
	 *
	 * @param {HTMLElement} element - The control element.
	 * @param {string | number | string[]} value - The value to set.
	 */
	setValue(element, value)
	{
		if (Array.isArray(value))
		{
			value = value.join(', ');
		}
		if (typeof value == 'number')
		{
			value = String(value);
		}
		if (element instanceof HTMLInputElement)
		{
			element.value = value;
		}
		element.innerText = value;
	}
}

/**
 * Provider to add behaviors to interface with views / controls based on InputType.
 */
class InputTypeBehaviorProvider extends PictProvider
{
	/**
	 * @param {any} pFable - Fable instance
	 * @param {Object} pOptions - Options for the provider
	 * @param {String} pServiceHash - Hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {Array<InputTypeProvider>} */
		this.providers = [];

		this.addTypeProvider(SelectInputTypeProvider);
		this.setFallbackProvider(this.addTypeProvider(TextInputTypeProvider));
	}

	/**
	 * @return {DistillingProvider}
	 */
	get distilling()
	{
		return this.pict.providers.Distilling;
	}

	/**
	 * Validate a manifest descriptor.
	 *
	 * @param {Object} descriptor - The descriptor to validate.
	 */
	static validateDescriptor(descriptor)
	{
		//FIXME: how to do branching at this point?
		if (descriptor.DataType?.toLowerCase() == 'select' && !Array.isArray(descriptor?.PictForm?.SelectOptions))
		{
			if (descriptor.PictForm?.DistillingMapping)
			{
				console.info(`Descriptor for ${descriptor.Hash} is a select control with distilling mapping. Values will be populated just in time.`,
					{ mapping: descriptor.PictForm.DistillingMapping });
			}
			else
			{
				// TODO: We need to accurately account for "server-side paged" Select2 flow here. This warning can be a red herring.
				console.warn(`Descriptor for ${descriptor.Hash} is a select control but has no options provided.`, { descriptor });
				descriptor.SelectOptions = [ 'no options provided' ]; //FIXME: seems dumb - select2 currently renders weird if there is nothing in here
			}
		}
	}

	/** @typedef {typeof InputTypeProvider} InputTypeProviderClass */

	/**
	 * Add an InputType specific provider.
	 *
	 * @param {InputTypeProviderClass} TypeProviderClass - The provider to add.
	 *
	 * @return {InputTypeProvider} - The provider instance
	 */
	addTypeProvider(TypeProviderClass)
	{
		const provider = new TypeProviderClass(this.pict, () => this.formManifestDefinition);
		this.providers.push(provider);
		return provider;
	}

	/**
	 * Set the fallback provider. Used if no registered provider claims the control.
	 *
	 * @param {InputTypeProvider} provider - The provider to use
	 */
	setFallbackProvider(provider)
	{
		this.fallbackProvider = provider;
	}

	/**
	 * Get the provider for an element.
	 *
	 * @param {HTMLElement} element - The element to get the provider for.
	 *
	 * @return {InputTypeProvider} - The provider for the element.
	 */
	getProviderForElement(element)
	{
		for (const provider of this.providers)
		{
			if (provider.isControlSupported(element))
			{
				return provider;
			}
		}
		return this.fallbackProvider;
	}

	/**
	 * Handle Initialize lifecycle event.
	 */
	onInitialize()
	{
		if (!this.pict.AppData.Interactive)
		{
			return true;
		}

		this.registerSelect2Plugins();
		return super.onInitialize();
	}

	/**
	 * Register custom select2 plugins. Currently, a local pagination adapter.
	 */
	registerSelect2Plugins()
	{
		// idea: use this to get distilling options, or uhh, whatever we got
		const getOptions = (adapter) =>
		{
			return this.pict.AppData.Select2OptionsCache?.[adapter.options.options.datumKey] || [];
		};

		//NOTE: the select2 types don't include define here, but this works
		// @ts-ignore
		$.fn.select2.amd.define('select2/data/localPaginationAdapter', [
			'select2/data/array',
			'select2/utils',
		],
		function(ArrayAdapter, Utils)
		{
			/**
			 * The local pagination adapter "class".
			 *
			 * @param {JQuery<HTMLElement>} $element - The element to attach the adapter to.
			 * @param {any} options - The options for the adapter.
			 */
			function LocalPaginationAdapter($element, options)
			{
				//NOTE: the __super__ isn't recognized because the extension APIs / types aren't in the generated types
				// @ts-ignore
				LocalPaginationAdapter.__super__.constructor.call(this, $element, options);
			}
			Utils.Extend(LocalPaginationAdapter, ArrayAdapter); // eslint-disable-line new-cap

			LocalPaginationAdapter.prototype.query = function(params, callback)
			{
				const fullData = getOptions(this);
				//TODO: customizable
				const pageSize = 100;

				if (!('page' in params))
				{
					params.page = 1;
				}
				const term = (params.term || '').toLowerCase();
				let results;
				if (term == '')
				{
					results = fullData;
				}
				else
				{
					results = $.map(fullData, function(obj)
					{
						//TODO: something more locale friendly
						if (obj.text && obj.text.toLowerCase().includes(term))
						{
							return obj;
						}
					});
				}
				callback({
					results: results.slice((params.page - 1) * pageSize, params.page * pageSize),
					pagination: {
						more: results.length >= params.page * pageSize,
					},
				});
			};

			return LocalPaginationAdapter;
		});
	}

	/**
	 * Handle document loaded event.
	 *
	 * @param {Object<String, any>} data - The loaded data.
	 */
	async onDataLoad(data)
	{
		//FIXME: once lifecycle exists for real: await super.onDataLoad(data);
		this.formManifestDefinition = this.pict.settings.DefaultFormManifest;
	}

	/**
	 * Get the manifest definition for an element.
	 *
	 * @param {HTMLElement} element - The element to get the manifest definition for.
	 *
	 * @return {Object} - The manifest definition for the element.
	 */
	getElementManifestDefinition(element)
	{
		//TODO: also look at data-i-form..? do we need to since it's a manifest key and can't be duplicated? not sure
		const inputElement = this.getInputElementForControlElement(element);
		if (!inputElement)
		{
			this.pict.log.error(`SelectInputTypeProvider::setOptions: Could not find input element for select control.`, { element });
			return;
		}
		const elementDatumKey = inputElement.getAttribute('data-i-datum');
		const manifestDefinition = this.formManifestDefinition;
		return manifestDefinition?.Descriptors?.[elementDatumKey];
	}

	/**
	 * Set the available options for the control (if supported).
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 * @param {Array<Array<string>> | Array<string>} options - The options to set. Each array element is [ value, display ]. If there is no display, inner array can be the value string.
	 */
	setOptions(selector, options)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
			this.pict.log.warn(`InputType::setOptions: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`InputType::setOptions: Could not find element matching: ${selector}`);
			return;
		}
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return;
		}
		const manifestDefinition = this.getElementManifestDefinition(element);
		provider.setOptions(element, options, manifestDefinition);
	}

	/**
	 * Get the input (value storage) element for a control.
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 *
	 * @return {HTMLInputElement} - The input element.
	 */
	getInputElement(selector)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
			this.pict.log.warn(`InputType::setOptions: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`InputType::setOptions: Could not find element matching: ${selector}`);
			return;
		}
		return this.getInputElementForControlElement(element);
	}

	/**
	 * Get the input (value storage) element for a control based on one element.
	 *
	 * @param {HTMLElement} element - The control element.
	 *
	 * @return {HTMLInputElement} - The input element.
	 */
	getInputElementForControlElement(element)
	{
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return;
		}
		return provider.getInputElement(element);
	}

	/**
	 * Set a control's value.
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 * @param {String} value - The value to set.
	 */
	setValue(selector, value)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
			this.pict.log.warn(`InputType::setValue: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`InputType::setValue: Could not find element matching: ${selector}`);
			return;
		}
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return;
		}
		const manifestDefinition = this.getElementManifestDefinition(element);
		provider.setValue(element, value, manifestDefinition);
	}

	/**
	 * Get a control's value.
	 *
	 * @param {String} selector - A CSS selector for the (single) control.
	 *
	 * @return {string | number | string[]} - the control value.
	 */
	getValue(selector)
	{
		const matchingControls = $(selector);
		if (matchingControls.length > 1)
		{
		this.pict.log.warn(`InputType::getValue: More than one element matched selector ${selector}.`);
		}
		const element = matchingControls[0];
		if (!element)
		{
			this.pict.log.warn(`Could not find element matching: ${selector}`);
			return '';
		}
		const provider = this.getProviderForElement(element);
		if (!provider)
		{
			this.pict.log.warn(`Could not find provider for element ${element}`);
			return '';
		}
		const manifestDefinition = this.getElementManifestDefinition(element);
		return provider.getValue(element, manifestDefinition);
	}

	/**
	 * Initialize any uninitialized controls on the DOM.
	 *
	 * TODO: figure out how to distrubute the logic into control specific providers in a sane way
	 */
	initializeControls()
	{
		if (this.pict.AppData.DistillingMapping?.length > 0)
		{
			if (this.distilling)
			{
				//FIXME: how does this work with multiple mappings?
				this.distilling.registerDistilling(this.pict.AppData.DistillingMapping);
			}
		}
	}
}

module.exports = InputTypeBehaviorProvider;

},{"pict-provider":552}],36:[function(require,module,exports){
const FableServiceProviderBase = require('fable-serviceproviderbase');
//const SyncShim = require('sync-shim');

/** @typedef {import('fable')} Fable */
/** @typedef {import('headlight-rest-client')} HeadlightRestClient */

/** How long after the render the page may use the document data the render put in it. */
const INLINE_REPORT_PARAMETERS_MAX_AGE_MS = 60000;

/**
 * Document management services (load, save, download, etc.).
 */
class HeadlightDocumentService extends FableServiceProviderBase
{
	/**
	 * @param {Fable} pFable - The fable instance
	 * @param {any} pOptions - Options for this service
	 * @param {any} pServiceHash - The fable service hash for this instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { PictApplication?: any, AppData?: any, MetaTemplate?: any }} */
		this.pict = this.fable; // for parity with pict providers / views

		this.serviceType = 'HeadlightDocumentService';
	}

	/**
	 * @return {HeadlightRestClient} the headlight client instance
	 */
	get HeadlightRestClient()
	{
		return this.fable.services.HeadlightRestClient;
	}

	/**
	 * Get the current document id from the URL or the DOM
	 *
	 * @return {string} The current document id
	 */
	get documentId()
	{
		if (!this._documentId)
		{
			let documentId = null;
			const currentDocIDElement = document.querySelector('#Data_IDDocument');
			if (currentDocIDElement)
			{
				documentId = currentDocIDElement.textContent.trim();
			}

			if (!documentId)
			{
				const params = new URLSearchParams(window.location.search);
				documentId = params.get('documentID') || params.get('IDDocument');
			}

			this._documentId = documentId;
		}

		return this._documentId;
	}

	/**
	 * The document data the render put in the page (`<script id="Data_ReportParameters">`), so the form can skip
	 * fetching `Document/:id/ReportParameters`, which builds the same object again. Used only on a fresh open:
	 * the page URL keeps working after the open, and booting a refresh or a reopened tab from the render-time copy
	 * could save stale data over newer edits.
	 *
	 * @param {string|number} pDocumentID - The page's document id.
	 * @return {?any} The same object `ReportParameters` returns, or null to fetch it instead.
	 */
	readInlineReportParameters(pDocumentID)
	{
		const tmpDecline = (pReason) =>
		{
			this.log.info(`Fetching ReportParameters: ${pReason}`);
			return null;
		};
		if ((typeof document === 'undefined') || (typeof window === 'undefined'))
		{
			return null;
		}
		const tmpElement = document.getElementById('Data_ReportParameters');
		if (!tmpElement)
		{
			return null;
		}
		const tmpText = tmpElement.textContent;
		tmpElement.remove();

		const tmpParams = new URLSearchParams(window.location.search);
		let tmpForceFetch = tmpParams.get('fetchReportParameters') === '1';
		try
		{
			tmpForceFetch = tmpForceFetch || (window.localStorage.getItem('HeadlightFetchReportParameters') === '1');
		}
		catch (pError)
		{
			// Storage can be unavailable (privacy modes, sandboxed frames); the URL switch still works.
		}
		if (tmpForceFetch)
		{
			return tmpDecline('forced by fetchReportParameters');
		}

		const tmpNavigation = (typeof performance !== 'undefined') && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
		if (!tmpNavigation || (tmpNavigation.type !== 'navigate'))
		{
			return tmpDecline(`the page was not freshly opened (${tmpNavigation ? tmpNavigation.type : 'no navigation timing'})`);
		}

		const tmpSessionToken = tmpParams.get('SessionToken');
		if (!tmpSessionToken)
		{
			return tmpDecline('the page has no session token of its own');
		}

		let tmpReportParameters;
		try
		{
			tmpReportParameters = JSON.parse(tmpText);
		}
		catch (pError)
		{
			return tmpDecline(`the inline copy did not parse: ${pError.message}`);
		}
		if (!tmpReportParameters || !tmpReportParameters.Document || (Number(tmpReportParameters.Document.IDDocument) !== Number(pDocumentID)))
		{
			return tmpDecline('the inline copy is for another document');
		}

		const tmpServerNow = this.HeadlightRestClient && this.HeadlightRestClient.estimateServerTime ? this.HeadlightRestClient.estimateServerTime() : null;
		const tmpRenderedAt = Date.parse(tmpReportParameters.RenderedAt);
		if ((tmpServerNow === null) || Number.isNaN(tmpRenderedAt))
		{
			return tmpDecline('no server time to judge its age');
		}
		// Absolute: the render stamp and the server time come from different containers' clocks.
		const tmpAgeMS = tmpServerNow - tmpRenderedAt;
		if (Math.abs(tmpAgeMS) > INLINE_REPORT_PARAMETERS_MAX_AGE_MS)
		{
			return tmpDecline(`the inline copy is ${Math.round(tmpAgeMS / 1000)} s old`);
		}

		delete tmpReportParameters.RenderedAt;
		tmpReportParameters.SessionToken = tmpSessionToken;
		this.log.info(`Using the document data the render put in the page (${Math.round(tmpAgeMS / 1000)} s old)`);
		return tmpReportParameters;
	}

	/**
	 * Fetch the current document from the server
	 *
	 * @return {Promise<any>} The current document
	 */
	async fetchCurrentDocumentReportParameters()
	{
		if (this.pict.settings.IsHeadlightWebApplication)
		{
			// Headlight Document service skipping download Document entity record because this app has flagged itself as a web application
			return false;
		}
		const documentId = this.documentId;
		if (documentId)
		{
			if (Number.isNaN(documentId))
			{
				this.log.error(`Invalid document id ${documentId}`);
				return null;
			}
			const tmpInline = this.readInlineReportParameters(documentId);
			this.reportParametersSource = tmpInline ? 'inline' : 'fetched';
			const doc = tmpInline || await this.fetchDocumentReportParameters(documentId);
			this.pict.PictApplication.AppData.DocumentData = doc;
			return doc;
		}
		else
		{
			this.log.error('Failed to fetch current document, no document id provided');
		}
	}

	/**
	 * Read a document's report parameters from the server without adopting them, so a caller can compare
	 * them with what the page already holds.
	 *
	 * @param {string|number} pDocumentID - The document to read.
	 * @return {Promise<any>} The `Document/:id/ReportParameters` body.
	 */
	fetchDocumentReportParameters(pDocumentID)
	{
		return new Promise((resolve, reject) =>
		{
			this.HeadlightRestClient.getJSON(`Document/${pDocumentID}/ReportParameters`, (err, body) =>
			{
				if (err)
				{
					return reject(err);
				}
				resolve(body);
			});
		});
	}

	/**
	 * The native document bridge this form persists through, or null when it persists to the server.
	 *
	 * On the iOS offline template the native layer owns the document row: the form writes to local
	 * storage and the device syncs the record up later. The record it writes is the same one the PUT
	 * would carry, so this is a transport choice and nothing above it needs to know which one ran.
	 *
	 * @return {?any} The bridge, or null.
	 */
	get localDocumentBridge()
	{
		if (typeof window === 'undefined')
		{
			return null;
		}
		/** @type {any} */
		const tmpWindow = window;
		const tmpBridge = tmpWindow._configurableFormDocumentBridge;
		if (!tmpWindow._OfflineMode || !tmpBridge || typeof tmpBridge.saveDocument !== 'function')
		{
			return null;
		}
		return tmpBridge;
	}

	/**
	 * Whether a save from this form lands locally rather than on the server.
	 *
	 * Load-bearing for `Document.EntityData`: the server applies the comprehension when the record
	 * reaches it, so anything that may only advance once the server has seen the payload has to ask
	 * this first.
	 *
	 * @return {boolean} True when the save is written to local storage.
	 */
	isLocalDocumentTransport()
	{
		return !!this.localDocumentBridge;
	}

	/**
	 * Build the document record a save writes, whichever transport carries it.
	 *
	 * @return {Record<string, any>} The record to persist.
	 */
	buildDocumentSaveRecord()
	{
		const tmpDocument = this.pict.PictApplication.AppData.DocumentData.ReportData;
		// spread the IDObservation list into a new array so we don't mutate the original collection
		const tmpObservations = Array.isArray(tmpDocument.Observations) ? tmpDocument.Observations : [];
		return {
			IDDocument: tmpDocument.IDDocument,
			IDProject: tmpDocument.IDProject,
			FormData: tmpDocument.FormData,
			EntityData: tmpDocument.EntityData,
			Observations: [ ...tmpObservations.map((obs) => obs.IDObservation) ],
		};
	}

	/**
	 * Do the document save (this is the same as clicking the save button in the UI).
	 *
	 * Resolves with the saved record the transport handed back, which the server decorates and the
	 * local bridge does not — callers must treat everything on it as optional.
	 *
	 * @return {Promise<any>}
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async saveDocument()
	{
		try
		{
			const tmpRecord = this.buildDocumentSaveRecord();
			const tmpLocalBridge = this.localDocumentBridge;
			if (tmpLocalBridge)
			{
				return await this._saveDocumentToLocalBridge(tmpLocalBridge, tmpRecord);
			}
			const response = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.putJSON(`Document/`, tmpRecord,
				(err, body) =>
				{
					if (err)
					{
						return reject(err);
					}
					resolve(body);
				});
			});
			return response;
		}
		catch (error)
		{
			this.log.error('Failed to save document', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Hand the document record to the native bridge and wait for it to be persisted.
	 *
	 * Rejects on a bridge failure so the save lifecycle reports it exactly as it reports a failed PUT;
	 * a write that did not land must not be reported as one that did.
	 *
	 * @param {any} pBridge - The native document bridge.
	 * @param {Record<string, any>} pRecord - The record to persist.
	 * @return {Promise<any>} Resolves with whatever the bridge returned.
	 */
	_saveDocumentToLocalBridge(pBridge, pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			try
			{
				pBridge.saveDocument(pRecord, (pError, pResult) =>
				{
					if (pError)
					{
						return reject((pError instanceof Error) ? pError : new Error(String(pError)));
					}
					return resolve(pResult);
				});
			}
			catch (pError)
			{
				return reject((pError instanceof Error) ? pError : new Error(String(pError)));
			}
		});
	}

	/**
	 * Downloads the document as a PDF file; if the document is not locked, then a refreshed PDF is generated
	 * @param {boolean} forceRender - If true, then a refreshed PDF is generated regardless of the document's locked state
	 * @param {object} [pReportData] - Optional alternative ReportData (if we want to download "not my current document" data)
	 * @param {function} [pCallback] - Optional callback when the download is complete
	 * @return {Promise<void>}
	 */
	async downloadDocument(forceRender = false, pReportData, pCallback)
	{
		const reportData = pReportData || this.pict.PictApplication.AppData.DocumentData.ReportData;
		let url = `/1.0/Document/${reportData.IDDocument}/DCR.pdf`;
		// if the document is not locked, then we need to regenerate a rerfeshed pdf
		if (forceRender || !reportData.Locked)
		{
			// fetch the GUIDReportDescription from the server to use in the url
			const response = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`Report/Render/${reportData.IDDocument}/pdf`, (err, body) =>
				{
					if (err)
					{
						reject(err);
					}
					else
					{
						resolve(body);
					}
				});
			});
			url = `/1.0/Report/${ response.GUIDReportDescription }/index.pdf`;
		}
		// format the metadata for the pdf file name
		const metaList = [
			reportData.DocumentType,
			this.fable.Dates.dayJS(reportData.DocumentDate).format('YYYY-MM-DD'),
		];
		// create a download link and click it to download the pdf
		const downloadLink = document.createElement('a');
		downloadLink.href = url;
		downloadLink.classList.add('is-hidden');
		// config option to optionally show the project name in the pdf download file name
		if (reportData.ReportOptions?.Meta?.ShowProjectNameInPDF)
		{
			metaList.push(reportData?.Project?.Name?.replace(/[^a-z0-9]/gi, '_'));
		}
		downloadLink.download = metaList.join('_') + '.pdf';
		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);

		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
	}

	/**
	 * Get the current document's approval state
	 * @return {Promise<any>} The approval state of the document
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async fetchApprovalState()
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.log.error('No document id found');
				return null;
			}
			const approvalResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`DocumentApproval/${docId}/State`, (err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.log.info('Approval state fetched', { approvalResults });
			return approvalResults;
		}
		catch (error)
		{
			this.log.error('Failed to get approval state', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Fetch the list of users that can approve the current document
	 * @return {Promise<any>} The list of users that can approve the document
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async fetchApprovalUsersList()
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.log.error('No document id found');
				return null;
			}
			const approvalUserListResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`DocumentApproval/${docId}/ApproverList`, (err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.log.info('Approval user list fetched', { approvalUserListResults });
			return approvalUserListResults;
		}
		catch (error)
		{
			this.log.error('Failed to get approval user list', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Fetch the approval history of the current document (logs of who approved/rejected the document and when)
	 * @return {Promise<any>} The approval history of the document
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async fetchApprovalHistory()
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.fable.log.error('No document id found');
				return null;
			}
			const approvalHistoryResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.getJSON(`DocumentApprovalLogs/By/IDDocument/${docId}`, (err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.fable.log.info('Approval history fetched', { approvalHistoryResults });
			return approvalHistoryResults;
		}
		catch (error)
		{
			this.fable.log.error('Failed to get approval history', error);
			throw error;
		}
	}

	/**
	 * Take an approval action on the current document (approve, reject, etc)
	 * @param {string} pAction The action to take on the document
	 * @return {Promise<any>} The results of the approval action
	 * @memberof HeadlightDocumentService
	 * @async
	 * @example
	 * await this.fable.services.HeadlightDocumentService.doApprovalAction('Approve');
	 * await this.fable.services.HeadlightDocumentService.doApprovalAction('Reject');
	 */
	async doApprovalAction(pAction)
	{
		try
		{
			const docId = this.pict.PictApplication.AppData?.DocumentData?.ReportData?.IDDocument;
			if (!docId)
			{
				this.fable.log.error('No document id found');
				return null;
			}
			const approvalResults = await new Promise((resolve, reject) =>
			{
				this.HeadlightRestClient.postJSON(`DocumentApproval`,
				{
					Action: pAction,
					IDDocument: docId,
				},
				(err, body) =>
				{
					if (err)
					{
						reject(err);
						return;
					}
					resolve(body);
				});
			});
			this.fable.log.info('Approval action taken', { approvalResults });
			return approvalResults;
		}
		catch (error)
		{
			this.fable.log.error('Failed to take approval action', error);
			throw error;
		}
	}

	// TODO: Move this to a User provider? It doesn't belong here, but not sure where yet.
	/**
	 * Update the user's settings on the server.
	 *
	 * Impersonated sessions write somewhere else, and write less. `AppData.CurrentUser` is the
	 * *impersonated* user — including their Settings — so persisting it as-is would save a tester's
	 * preference onto the customer's record. Retargeting the write at the real user is not enough on
	 * its own either: sending CurrentUser.Settings to the real user would overwrite the real user's
	 * preferences with the impersonated user's. So an impersonated write goes to the real user
	 * (`ImpersonatingIDUser`, which stays pointed at the root user across chained impersonations) and
	 * carries only the keys that actually changed, merged onto that user's stored settings.
	 *
	 * Note the read side is unchanged: while impersonating, the panels still read the impersonated
	 * user's preferences, which is what makes "see what they see" work. A preference changed while
	 * impersonating therefore applies to the tester's own next session, not the current one.
	 *
	 * @param {Object} [pChangedSettings] - The settings that changed, e.g. `{ HeadlightPanels: { AutoSave: false } }`.
	 *   Required for impersonated sessions; without it there is no safe way to write.
	 * @memberof HeadlightDocumentService
	 * @async
	 */
	async updateUserSettings(pChangedSettings)
	{
		try
		{
			const user = this.pict.AppData.CurrentUser;
			if (!user)
			{
				this.log.warn('No current user; not updating user settings.');
				return;
			}
			if (user.Impersonation)
			{
				return await this._updateImpersonatingUserSettings(user, pChangedSettings);
			}
			this.pict.log.info('Updating user settings', { user });

			const userResults = await new Promise((resolve, reject) =>
			{
					this.HeadlightRestClient.putJSON(`User`,
					{
						IDUser: user.UserID,
						Settings: user.Settings,
					},
					(err, body) =>
					{
						if (err)
						{
							reject(err);
							return;
						}
						resolve(body);
					});
			});
				this.fable.log.info('User Settings updated', { userResults });
				return userResults;
		}
		catch (error)
		{
			this.log.error('Failed to update user settings', { error: error.message, stack: error.stack });
			throw error;
		}
	}

	/**
	 * Persist a settings change made during an impersonated session onto the real user's record.
	 *
	 * Refuses rather than guesses: with no changed-settings delta, or no real user to write to, the
	 * only options are to overwrite the real user's preferences with the impersonated user's or to
	 * write the tester's preference onto the customer's record. Skipping beats both.
	 *
	 * @param {any} pCurrentUser - The impersonated session user.
	 * @param {Object} [pChangedSettings] - The settings that changed.
	 * @return {Promise<any>}
	 */
	async _updateImpersonatingUserSettings(pCurrentUser, pChangedSettings)
	{
		const tmpRealIDUser = pCurrentUser.ImpersonatingIDUser;
		if (!tmpRealIDUser)
		{
			this.log.warn('Impersonated session carries no ImpersonatingIDUser; not saving the settings change to either user.');
			return;
		}
		if (!pChangedSettings || typeof pChangedSettings !== 'object')
		{
			this.log.warn(`Impersonated session changed a setting without saying which; not saving it to user ${tmpRealIDUser}.`);
			return;
		}
		const tmpRealUser = await new Promise((resolve) =>
		{
			this.HeadlightRestClient.getJSON(`User/${tmpRealIDUser}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Failed to load the impersonating user ${tmpRealIDUser} to save a settings change: ${pError.message || pError}`);
					return resolve(null);
				}
				return resolve(pBody);
			});
		});
		if (!tmpRealUser)
		{
			return;
		}
		let tmpRealSettings = tmpRealUser.Settings;
		if (!tmpRealSettings && tmpRealUser.SettingsJSON)
		{
			try
			{
				tmpRealSettings = JSON.parse(tmpRealUser.SettingsJSON);
			}
			catch (pParseError)
			{
				this.log.warn(`Could not parse settings for user ${tmpRealIDUser}; starting from an empty set.`);
			}
		}
		tmpRealSettings = tmpRealSettings || { };
		// Shallow per-namespace merge: the delta names a namespace (HeadlightPanels) and the keys within
		// it that changed, so the real user's other preferences in that namespace survive.
		for (const [ tmpNamespace, tmpValues ] of Object.entries(pChangedSettings))
		{
			if (tmpValues && typeof tmpValues === 'object' && !Array.isArray(tmpValues))
			{
				tmpRealSettings[tmpNamespace] = Object.assign({ }, tmpRealSettings[tmpNamespace], tmpValues);
			}
			else
			{
				tmpRealSettings[tmpNamespace] = tmpValues;
			}
		}
		this.log.info(`Impersonated session: saving the settings change to the real user ${tmpRealIDUser}, not the impersonated user ${pCurrentUser.UserID}.`, { ChangedSettings: pChangedSettings });
		return await new Promise((resolve, reject) =>
		{
			this.HeadlightRestClient.putJSON(`User`, { IDUser: tmpRealIDUser, Settings: tmpRealSettings }, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				return resolve(pBody);
			});
		});
	}
}

module.exports = HeadlightDocumentService;

},{"fable-serviceproviderbase":438}],37:[function(require,module,exports){
/**
 * Headlight-FormLoadTiming
 *
 * Phase 0 instrumentation for the form load latency work (the plan lives at
 * `docs/plans/form-load-latency-assessment.md`, §5 Phase 0). Drops a
 * `performance.mark()` at each of the five points that bound a form open and
 * emits one summary log line when the last one lands.
 *
 * The phases, in the order they are expected to arrive:
 *
 *	 - `Boot`			- the HeadlightConfigurableApplication constructor.
 *						  Bounds script parse + eval before the app exists.
 *	 - `SessionReady`	- `onBeforeLoginAsync` .finally(). Bounds the cached
 *						  session read or the CheckSession round trip.
 *	 - `DocumentLoaded` - `onLoadDataAsync` .then(). Bounds the
 *						  ReportParameters fetch plus the full user record.
 *	 - `FirstRender`	- `onAfterLoadDataAsync`, once the form sections
 *						  have rendered. Bounds the InitialBundle fetch, the
 *						  manifest bootstrap and the section render.
 *	 - `SpinnerRemoved` - the application's `removeLoadingSpinner()`. Bounds
 *						  whatever still covers the form after it is drawn.
 *
 * A mark's `startTime` is milliseconds since `performance.timeOrigin` - that
 * is, since navigation started - so `Boot` already carries the cost of
 * everything that ran before the application was constructed, and
 * `SpinnerRemoved` is the click-to-drawn number Phase 0 targets (p50 under 4 s
 * on QA for a 50-descriptor form).
 *
 * `SpinnerRemoved` is marked when `removeLoadingSpinner()` is CALLED, not when
 * the 200 ms fade finishes. The form underneath is already drawn at that
 * point; the fade is cosmetic, and excluding it keeps the number comparable
 * across apps that fade differently.
 *
 * This changes no behavior. Every entry point is guarded so a missing or
 * throwing `performance` API - node tests, jsdom, the offline template - is a
 * no-op, and each phase is recorded only once, so a re-login or a re-render
 * cannot overwrite the first-open numbers.
 *
 * Three ways to read the results:
 *
 *	 - the log line, prefixed `[FormLoad]` so it greps next to the existing
 *	   `[populateCanEditField]` timing lines;
 *	 - `window._HeadlightFormLoad`, for a harness or a console snippet;
 *	 - in DevTools, the marks and the span between each adjacent pair:
 *	   `performance.getEntriesByType('mark').filter((e) => e.name.startsWith('HeadlightFormLoad:'))`
 */

/** Prefix on every mark and measure name, so the entries filter cleanly out of the Performance timeline. */
const MARK_PREFIX = 'HeadlightFormLoad:';

/** The phases, in expected arrival order. The summary renders them in this order regardless of when they land. */
const PHASES = [ 'Boot', 'SessionReady', 'DocumentLoaded', 'FirstRender', 'SpinnerRemoved' ];

/**
 * Records the five form-load phases and emits the one-line summary.
 */
class HeadlightFormLoadTiming
{
	/**
	 * @param {Object} [pOptions] - Options.
	 * @param {any} [pOptions.Log] - A pict/fable logger. Optional; without one the summary is only on `window`.
	 * @param {any} [pOptions.Performance] - The `performance` object to use. Defaults to the global one. Injectable for tests.
	 * @param {String} [pOptions.Context] - A label for the log line (the application name, typically).
	 * @param {String} [pOptions.TerminalPhase] - The phase whose arrival emits the summary. Defaults to the last phase.
	 */
	constructor(pOptions)
	{
		const tmpOptions = pOptions || {};
		this.log = tmpOptions.Log || null;
		this.performance = tmpOptions.Performance || ((typeof globalThis !== 'undefined') ? globalThis.performance : null);
		this.Context = tmpOptions.Context || 'Form';
		this.TerminalPhase = tmpOptions.TerminalPhase || PHASES[PHASES.length - 1];

		/**
		 * Milliseconds since navigation start, per phase, in arrival order.
		 * @type {Object<String, Number>}
		 */
		this.Phases = {};
		this.SummaryEmitted = false;
		this._warnedPhases = {};
	}

	/**
	 * Whether the environment can be measured at all.
	 *
	 * @return {Boolean} True when a usable `performance` object is present.
	 */
	get enabled()
	{
		return !!(this.performance && (typeof this.performance.now === 'function'));
	}

	/**
	 * Record a phase. The first call for a phase wins; later calls are ignored.
	 *
	 * @param {String} pPhase - One of the PHASES names.
	 * @return {Boolean} True when this call recorded the phase.
	 */
	mark(pPhase)
	{
		if (!this.enabled || !pPhase)
		{
			return false;
		}
		if (PHASES.indexOf(pPhase) < 0)
		{
			// A typo in a call site would otherwise vanish silently. Warn once per name.
			if (this.log && !this._warnedPhases[pPhase])
			{
				this._warnedPhases[pPhase] = true;
				this.log.warn(`[FormLoad] ignoring unknown phase "${pPhase}"`);
			}
			return false;
		}
		if (pPhase in this.Phases)
		{
			return false;
		}

		try
		{
			const tmpName = MARK_PREFIX + pPhase;
			const tmpMark = this.performance.mark(tmpName);
			// performance.mark() returns the entry in current browsers; older ones return undefined.
			this.Phases[pPhase] = (tmpMark && (typeof tmpMark.startTime === 'number')) ?
				tmpMark.startTime :
				this._lookupMarkStartTime(tmpName);
			this._measureFromPreviousPhase(pPhase);
		}
		catch (pError)
		{
			// Instrumentation must never be able to break a form load.
			return false;
		}

		if (pPhase === this.TerminalPhase)
		{
			this.emitSummary();
		}
		return true;
	}

	/**
	 * Resolve a mark's start time when `performance.mark()` did not hand one back.
	 *
	 * @param {String} pName - The full mark name.
	 * @return {Number} Milliseconds since navigation start.
	 */
	_lookupMarkStartTime(pName)
	{
		if (typeof this.performance.getEntriesByName === 'function')
		{
			const tmpEntries = this.performance.getEntriesByName(pName, 'mark');
			if (tmpEntries && tmpEntries.length)
			{
				return tmpEntries[tmpEntries.length - 1].startTime;
			}
		}
		return this.performance.now();
	}

	/**
	 * Draw a measure from the most recently recorded earlier phase, so DevTools shows the span.
	 *
	 * @param {String} pPhase - The phase just recorded.
	 */
	_measureFromPreviousPhase(pPhase)
	{
		if (typeof this.performance.measure !== 'function')
		{
			return;
		}
		const tmpRecorded = PHASES.filter((pName) => (pName in this.Phases));
		const tmpIndex = tmpRecorded.indexOf(pPhase);
		if (tmpIndex < 1)
		{
			return;
		}
		const tmpPrevious = tmpRecorded[tmpIndex - 1];
		try
		{
			this.performance.measure(`${MARK_PREFIX}${tmpPrevious}->${pPhase}`, MARK_PREFIX + tmpPrevious, MARK_PREFIX + pPhase);
		}
		catch (pError)
		{
			// A measure is a convenience; losing it is not worth a thrown error.
		}
	}

	/**
	 * The numbers behind the summary line.
	 *
	 * @return {{ Context: String, Phases: Object<String, Number>, Deltas: Object<String, Number>, TotalMS: Number, Complete: Boolean }}
	 */
	summary()
	{
		const tmpPhases = {};
		const tmpDeltas = {};
		let tmpPrevious = 0;
		let tmpLast = 0;
		for (const tmpPhase of PHASES)
		{
			if (!(tmpPhase in this.Phases))
			{
				continue;
			}
			const tmpAt = Math.round(this.Phases[tmpPhase]);
			tmpPhases[tmpPhase] = tmpAt;
			tmpDeltas[tmpPhase] = tmpAt - tmpPrevious;
			tmpPrevious = tmpAt;
			tmpLast = tmpAt;
		}
		return {
			Context: this.Context,
			Phases: tmpPhases,
			Deltas: tmpDeltas,
			TotalMS: tmpLast,
			Complete: PHASES.every((pPhase) => (pPhase in this.Phases)),
		};
	}

	/**
	 * Render the one-line summary.
	 *
	 * @return {String} The log line.
	 */
	formatSummary()
	{
		const tmpSummary = this.summary();
		const tmpParts = PHASES.map((pPhase) =>
		{
			if (!(pPhase in tmpSummary.Phases))
			{
				return `${pPhase} -`;
			}
			return `${pPhase} +${tmpSummary.Deltas[pPhase]}ms`;
		});
		return `[FormLoad] ${tmpSummary.Context} total ${tmpSummary.TotalMS}ms (navigation to drawn) - ${tmpParts.join(' | ')}`;
	}

	/**
	 * Publish the summary: one log line, plus the numbers on `window` for a harness to scrape.
	 * Runs once per page; later calls are ignored.
	 *
	 * @return {Boolean} True when this call emitted the summary.
	 */
	emitSummary()
	{
		if (this.SummaryEmitted || !this.enabled)
		{
			return false;
		}
		this.SummaryEmitted = true;
		const tmpSummary = this.summary();
		try
		{
			if (typeof window !== 'undefined')
			{
				window._HeadlightFormLoad = tmpSummary;
			}
		}
		catch (pError)
		{
			// No window (node, a worker) - the log line is still worth emitting.
		}
		try
		{
			if (this.log && (typeof this.log.info === 'function'))
			{
				this.log.info(this.formatSummary());
			}
		}
		catch (pError)
		{
			// SpinnerRemoved marks ahead of the spinner teardown, so a logger that throws here would
			// otherwise leave the form sitting behind the loading overlay.
			return false;
		}
		return true;
	}
}

module.exports = HeadlightFormLoadTiming;
module.exports.PHASES = PHASES;
module.exports.MARK_PREFIX = MARK_PREFIX;

},{}],38:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/** @typedef {import('fable')} Fable */

/**
 * Headlight Hint Highlighting service.
 */
class HeadlightHintHighlighting extends libFableServiceProviderBase
{
	/**
	 * @param {Fable} pFable - The fable instance
	 * @param {any} pOptions - Options for this service
	 * @param {any} pServiceHash - The fable service hash for this instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { PictApplication?: any, AppData?: any, MetaTemplate?: any }} */
		this.pict = this.fable; // for parity with pict providers / views

		this.serviceType = 'HeadLightHintHighlighting';

		//FIXME: we should use the manifest tech for this, I think
		const pathEval = (path, record) => path
			.split(/[.[\]]/g)
			.reduce((p, c) => p && p[c],
			{
				Record: record,
				AppData: this.pict.AppData,
			});

		// create a label for the hint forumla
		this.pict.MetaTemplate.addPattern('{~HintLabel:', '~}', (pHash, pData, pContext) =>
		{
			const record = pathEval(pHash, pData);
			// NOTE: this is to support the old way until we migrate everything to the new way
			const hint = record?.PictForm?.Hint || record?.PictForm?.Formula || record?.hint;
			let hintConnections = record?.hintConnections;
			// parse the formula for the hint connections (non-numeric values are hint connections)
			if (!hintConnections && record?.PictForm?.Formula)
			{
				const formula = record.PictForm.Formula;
				const formulaArray = formula.split(/[\s\+\-\*\/\(\)]/);
				hintConnections = formulaArray.filter((value) => isNaN(value) && value !== '');
			}
			let template = ``;
			if (hint)
			{
				template =
				`<span class="hint-label is-pulled-right" data-hint-connections="${hintConnections}" onclick="this.pict.services.HeadlightHintHighlighting.toggleHintConnections(event)">
					<span class="icon"><i class="fas"></i></span>
					<span>${hint}</span>
				</span>`;
			}
			return template;
		});

		// create an ordinal tag for hint indentification
		this.pict.MetaTemplate.addPattern('{~HintOrdinal:', '~}', (pHash, pData, pContext) =>
		{
			const record = pathEval(pHash, pData);
			// NOTE: this is to support the old way until we migrate everything to the new way
			const ordinal = record?.PictForm?.Ordinal || record?.ordinal;
			return ordinal ? `<span class="hint-ordinal tag">${ordinal}</span>` : '';
		});

		// create a connection tag for hint connections
		this.pict.MetaTemplate.addPattern('{~HintConnection:', '~}', (pHash, pData, pContext) =>
		{
			const data = pathEval(pHash, pData);
			let template = ``;
			if (data)
			{
				template = `data-hint-connection="${data}"`;
			}
			return template;
		});
	}

	/**
	 * Find the parent element of an element that matches a selector
	 * @param {EventTarget} target - the element to start from
	 * @param {string} selector - the selector to match
	 * @return {Element[]} - an array of parent elements that match the selector
	 * @example
	 * const parents = this.findParents(el, '.parent-class');
	 * // parents = [HTMLElement, HTMLElement, HTMLElement]
	**/
	parents(target, selector)
	{
		if (!(target instanceof Element))
		{
			return [];
		}
		/** @type {Element} */
		let el = target;
		const parents = [];
		while (el.parentNode instanceof Element && (el = el.parentNode))
		{
			if (!selector || el.matches(selector))
			{
				parents.push(el);
			}
		}
		return parents;
	}

	/**
	 * This handles the highlighting of hint connections on the UI.
	 * If a hint connection is clicked, it will highlight the connection and the origin row to show the relationship
	 * @param {Event} event
	 * @memberof Application
	 *
	**/
	toggleHintConnections(event)
	{
		// remove rows that are currently active
		document.querySelectorAll('.hint-highlight-connection').forEach((hint) =>
		{
			hint.classList.remove('hint-highlight-connection');
		});
		// toggle active class on the hint connection
		if (this.parents(event.currentTarget, '.hint-highlight-origin').length)
		{
			this.parents(event.currentTarget, '.hint-highlight-origin')[0].classList.remove('hint-highlight-origin');
			return;
		}
		// turn off all other hint connections labels
		document.querySelectorAll('.hint-highlight-origin').forEach((hint) =>
		{
			hint.classList.remove('hint-highlight-origin');
		});
		// turn on the active class for this hint connection
		if (this.parents(event.currentTarget, '[data-hint-connection]').length)
		{
			this.parents(event.currentTarget, '[data-hint-connection]')[0].classList.add('hint-highlight-origin');
		}
		// for each row that has a hint connection, add the active class
		const connectionsList = event.currentTarget instanceof Element && event.currentTarget.getAttribute('data-hint-connections').split(',');
		if (connectionsList && connectionsList.length)
		{
			connectionsList.forEach((connection) =>
			{
				// NOTE: need to handle non-unqiue connections/ordinals (this only hightlights the first one found)
				document.querySelector(`[data-hint-connection="${connection}"]`)?.classList?.add('hint-highlight-connection');
			});
		}
	}
}

module.exports = HeadlightHintHighlighting;

},{"fable-serviceproviderbase":438}],39:[function(require,module,exports){
/**
 * ManifestConditionEvaluator
 *
 * Thin wrapper around `fable.ExpressionParser` that lets a form manifest gate
 * top-level lifecycle steps with a solver expression. Used by the base dynamic
 * form to decide whether to:
 *
 *   - skip the `InitialBundle` data fetch  (`shouldSkipInitialBundle`)
 *   - skip the post-load `solve()` pass    (`shouldSkipSolveOnLoad`)
 *
 * The expressions are the same Fable solver language the manifest's section
 * `Solvers: [...]` arrays already use, so form authors only have to know one
 * language. See `/Pavia/retold/modules/fable/fable/source/services/Fable-Service-ExpressionParser.js`
 * for the parser; `solve(expression, dataSource, results, manifest)` is the
 * public entry point.
 *
 * Two manifest shapes are honored per gating step:
 *
 *   - **Sugar:** `SkipInitialBundleWhenLocked: true` / `SkipSolveWhenLocked: true`
 *     Shorthand for "skip when the document is locked." Internally resolves to
 *     a `WHEN(AppData.DocumentData.ReportData.Locked, 1, 0)` expression so
 *     truthy-Locked returns truthy, falsy-Locked / missing-Locked returns 0.
 *     The solve sugar defaults to **true** (omitting `SkipSolveWhenLocked`
 *     skips solve on locked loads); the bundle sugar defaults to false.
 *
 *   - **General:** `SkipInitialBundleWhen: "<expression>"` / `SkipSolveWhen: "<expression>"`
 *     Any Fable solver expression. Evaluated against the supplied scope object
 *     (typically `{ AppData: ... }`). Truthy result → skip.
 *
 * When both are present, OR semantics apply — either matching is enough.
 *
 * Failure modes are fail-safe — a missing parser, a malformed expression, or a
 * thrown error during evaluation all resolve to "do not skip." We never skip
 * caller work unless the manifest is unambiguously correct and the expression
 * evaluates truthy.
 *
 * NB: The Fable solver returns numeric results as strings (`"1"` / `"0"`), so
 * the `_isTruthy` helper coerces strings: `"0"` and `""` are falsy, anything
 * else non-empty is truthy.
 */

const LOCKED_ADDRESS = 'AppData.DocumentData.ReportData.Locked';
const LOCKED_SUGAR_EXPRESSION = `WHEN(${LOCKED_ADDRESS}, 1, 0)`;

/**
 * Resolve `AppData.DocumentData.ReportData.Locked` from the scope using native
 * JavaScript truthiness — `0`, `"0"`, `false`, `null`, `undefined`, `""`, `NaN`
 * are all falsy.
 *
 * The sugar form (`SkipInitialBundleWhenLocked: true` / `SkipSolveWhenLocked: true`)
 * intentionally bypasses Fable's `WHEN(...)` for the resolution: Fable's
 * `Logic.when` checks truthiness with `!pValue`, which evaluates the *string*
 * `"0"` as truthy because non-empty strings are JS-truthy. The expression
 * parser stringifies numeric address values before passing them to `Logic.when`,
 * so a numeric `0` from the database (the common case for a draft document's
 * `Locked` TINYINT) was being mis-classified as "locked" and the InitialBundle
 * was being skipped on draft loads. See the test suite's "treats numeric 0 as
 * unlocked" case for the regression guard.
 *
 * @param {Object} pScope - The runtime scope (typically `{ AppData: ... }`).
 * @returns {boolean} `true` when the document is meaningfully locked.
 */
function _resolveLockedTruthy(pScope)
{
	const tmpLocked = pScope?.AppData?.DocumentData?.ReportData?.Locked;
	// Defensively treat the literal string "0" as falsy in addition to native
	// JS-falsy values. A TINYINT `Locked` column normally arrives as numeric 0/1,
	// but some serialization paths (older Meadow versions, JSON-stringified
	// snapshots) can deliver it as the string "0" / "1" — and `Boolean("0")` is
	// `true` in JS, which would re-introduce the same Locked=0 misclassification
	// we're fixing here.
	if (tmpLocked === '0')
	{
		return false;
	}
	return Boolean(tmpLocked);
}

/**
 * Coerce the parser's string-typed numeric output (or any other return shape)
 * to a boolean. Treats `"0"`, `""`, `null`, `undefined`, `false`, `NaN` as
 * falsy; anything else truthy.
 *
 * @param {*} pValue
 * @returns {boolean}
 */
function _isTruthy(pValue)
{
	if (pValue === null || pValue === undefined || pValue === false)
	{
		return false;
	}
	if (typeof pValue === 'number')
	{
		return pValue !== 0 && !Number.isNaN(pValue);
	}
	if (typeof pValue === 'string')
	{
		return pValue.length > 0 && pValue !== '0';
	}
	return Boolean(pValue);
}

/**
 * Evaluate a single Fable solver expression against the supplied scope.
 *
 * @param {string | null | undefined} pExpression - The solver expression to evaluate.
 * @param {Object} pScope - Data source object the parser dereferences against
 *   (typically `{ AppData: <runtime AppData> }`).
 * @param {*} pFable - The Fable instance, used to reach `ExpressionParser`.
 *   Optional — when absent the function fails closed (returns false).
 * @returns {boolean} `true` when the expression evaluates truthy.
 */
function evaluateExpression(pExpression, pScope, pFable)
{
	if (typeof pExpression !== 'string' || pExpression.length === 0)
	{
		return false;
	}
	if (!pFable)
	{
		return false;
	}
	let tmpParser = pFable.ExpressionParser;
	if (!tmpParser && typeof pFable.instantiateServiceProviderIfNotExists === 'function')
	{
		try
		{
			pFable.instantiateServiceProviderIfNotExists('ExpressionParser');
			tmpParser = pFable.ExpressionParser;
		}
		catch (pError)
		{
			return false;
		}
	}
	if (!tmpParser || typeof tmpParser.solve !== 'function')
	{
		return false;
	}
	try
	{
		const tmpResult = tmpParser.solve(pExpression, pScope || {}, {});
		return _isTruthy(tmpResult);
	}
	catch (pError)
	{
		if (pFable.log && typeof pFable.log.warn === 'function')
		{
			pFable.log.warn(`ManifestConditionEvaluator: expression failed to evaluate (${pError && pError.message ? pError.message : pError}). Expression: ${pExpression}`);
		}
		return false;
	}
}

/**
 * Decide whether to skip the InitialBundle fetch for the current load.
 *
 * Honors two manifest-level keys:
 *   - `SkipInitialBundleWhenLocked: true` — sugar; resolves to a Locked check.
 *   - `SkipInitialBundleWhen: "<expression>"` — general Fable solver expression.
 *
 * OR semantics across both — either truthy → skip.
 *
 * @param {Object | null | undefined} pManifest
 * @param {Object} pScope - The runtime scope (typically `{ AppData: ... }`).
 * @param {*} pFable - The Fable instance carrying ExpressionParser.
 * @returns {boolean}
 */
function shouldSkipInitialBundle(pManifest, pScope, pFable)
{
	if (!pManifest)
	{
		return false;
	}
	if (pManifest.SkipInitialBundleWhenLocked === true && _resolveLockedTruthy(pScope))
	{
		return true;
	}
	if (typeof pManifest.SkipInitialBundleWhen === 'string' && pManifest.SkipInitialBundleWhen.length > 0)
	{
		return evaluateExpression(pManifest.SkipInitialBundleWhen, pScope, pFable);
	}
	return false;
}

/**
 * Decide whether to skip the post-data-load `solve()` pass for the current
 * load. Used by snapshot forms that must not have stored values overwritten by
 * re-running the manifest's solver expressions on a Locked re-open.
 *
 * Honors two manifest-level keys:
 *   - `SkipSolveWhenLocked` — sugar; resolves to a Locked check. **Defaults to
 *     true**: a locked load skips solve unless the manifest explicitly sets
 *     `SkipSolveWhenLocked: false` (persisted solver outputs are part of the
 *     locked snapshot; re-deriving them from current state is the exception,
 *     not the rule).
 *   - `SkipSolveWhen: "<expression>"` — general Fable solver expression.
 *
 * OR semantics across both.
 *
 * @param {Object | null | undefined} pManifest
 * @param {Object} pScope
 * @param {*} pFable
 * @returns {boolean}
 */
function shouldSkipSolveOnLoad(pManifest, pScope, pFable)
{
	if (!pManifest)
	{
		return false;
	}
	if (pManifest.SkipSolveWhenLocked !== false && _resolveLockedTruthy(pScope))
	{
		return true;
	}
	if (typeof pManifest.SkipSolveWhen === 'string' && pManifest.SkipSolveWhen.length > 0)
	{
		return evaluateExpression(pManifest.SkipSolveWhen, pScope, pFable);
	}
	return false;
}

module.exports = {
	evaluateExpression,
	shouldSkipInitialBundle,
	shouldSkipSolveOnLoad,
	LOCKED_ADDRESS,
	LOCKED_SUGAR_EXPRESSION,
};

},{}],40:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libWorkbookWriter = require('./Workbook-Writer.js');

const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'DashboardExporter',
};

/**
 * Exports the currently-rendered dashboard's bucket records as CSV or as a
 * mildly-styled Excel file.
 *
 * Reads from `pict.AppData.WalbecRecords` (parsed Datum) and the active
 * dashboard's manifest at
 * `pict.PictSectionRecordSet.manifestDefinitions[pict.AppData.WalbecActiveDashboard]`.
 *
 * Column resolution: the dashboard manifest's `ReferenceManifests.<X>.Descriptors`
 * describes the detail-table columns. Each descriptor has `Hash`, `Name`,
 * `DataAddress` (path into a bucket record). Excellent already for export —
 * we use it to drive the column list, header labels, and per-row value lookup.
 *
 * The Excel output is HTML-as-Excel — a styled `<table>` saved with `.xls`
 * extension and `application/vnd.ms-excel` MIME. Excel respects inline CSS
 * for bold, color, borders, alignment and treats it as a one-sheet workbook.
 * Avoids bundling exceljs (~950KB) for "mildly styled" requirements.
 */
class DashboardExporter extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);
		/** @type {any} */
		this.pict = this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Map a ReferenceManifest's descriptor set to export columns. Skips the
	 * synthetic drill-down link cell (a URL, not data); Templated cells export
	 * their underlying DataAddress value.
	 *
	 * @param {Record<string, any>} pDescriptors
	 * @return {Array<{ Hash:string, Label:string, Path:string, DataType:string, DecimalPrecision:number|null }>}
	 */
	_columnsFromDescriptors(pDescriptors)
	{
		const tmpColumns = [];
		for (const tmpAddress of Object.keys(pDescriptors || {}))
		{
			const tmpDesc = pDescriptors[tmpAddress];
			if (tmpDesc && tmpDesc.PictForm && tmpDesc.PictForm.InputType === 'Link') continue;
			const tmpPictForm = tmpDesc.PictForm || {};
			tmpColumns.push(
				{
					Hash: tmpDesc.Hash,
					Label: tmpDesc.Name || tmpDesc.Hash || tmpAddress,
					Path: tmpDesc.DataAddress || tmpAddress,
					DataType: tmpDesc.DataType || 'String',
					// Carried for the Excel export: measurements are stored as STRINGS
					// throughout this system, deliberately, so arbitrary precision never
					// meets JavaScript's float mantissa. The workbook is the one place a
					// real number is required, and this is the precision to round to on
					// the way out. CSV keeps the untouched string.
					DecimalPrecision: (typeof tmpPictForm.DecimalPrecision === 'number') ? tmpPictForm.DecimalPrecision : null,
				});
		}
		return tmpColumns;
	}

	/**
	 * Resolve the export units for the active route — one unit per on-screen
	 * detail table, each pairing a column list with the records it renders:
	 *
	 *  1. **Form-mode dashboard** (`/SpecificDashboard/...`). The manifest
	 *     already declares every detail table: each `Sections[].Groups[]`
	 *     entry with `Layout: 'Tabular'` names its row template
	 *     (`RecordManifest` → `ReferenceManifests[...].Descriptors` = the
	 *     columns) and its data address (`RecordSetAddress` → the AppData
	 *     array the aggregation solvers populate = the records). One unit per
	 *     tabular group, so multi-table dashboards (e.g. Stockpile
	 *     Verification's stats + samples) export each table. Older manifests
	 *     with no tabular groups fall back to the legacy pairing (first
	 *     ReferenceManifest + AppData.WalbecDailyRecords) with a warning.
	 *
	 *  2. **List-mode dashboard / drilled document list** (`/List/...`).
	 *     One unit: columns from the recordset configuration's
	 *     `RecordSetListColumns`, records from
	 *     `pict.Bundle._ActiveFilterState[recordSet].Records`.
	 *
	 * Returns an empty array if no source resolves (e.g. on the chooser).
	 *
	 * @return {Array<{ title: string, groupName: string|null, columns: Array<{ Hash:string, Label:string, Path:string, DataType:string }>, records: Array<Record<string, any>>, recordsAddress: string|null }>}
	 */
	_resolveDashboardExportUnits()
	{
		const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) || '';
		const tmpDashMatch = tmpHash.match(/^#\/PSRS\/([^\/]+)\/SpecificDashboard\/([^\/]+)/);
		const tmpListMatch = tmpHash.match(/^#\/PSRS\/([^\/]+)\/List/);

		// Form-mode dashboard — one unit per tabular detail group in the manifest.
		if (tmpDashMatch)
		{
			const tmpScope = tmpDashMatch[2];
			const tmpManifest = this.pict.PictSectionRecordSet &&
				this.pict.PictSectionRecordSet.manifestDefinitions &&
				this.pict.PictSectionRecordSet.manifestDefinitions[tmpScope];
			if (!tmpManifest)
			{
				this.log.warn(`DashboardExporter: no manifest registered for dashboard [${tmpScope}].`);
				return [];
			}
			const tmpTitle = tmpManifest.Title || tmpScope;
			const tmpRefManifests = tmpManifest.ReferenceManifests || {};
			const tmpUnits = [];
			const tmpSections = Array.isArray(tmpManifest.Sections) ? tmpManifest.Sections : [];
			for (const tmpSection of tmpSections)
			{
				const tmpGroups = Array.isArray(tmpSection && tmpSection.Groups) ? tmpSection.Groups : [];
				for (const tmpGroup of tmpGroups)
				{
					if (!tmpGroup || tmpGroup.Layout !== 'Tabular' || !tmpGroup.RecordSetAddress || !tmpGroup.RecordManifest) continue;
					const tmpRefManifest = tmpRefManifests[tmpGroup.RecordManifest];
					if (!tmpRefManifest || !tmpRefManifest.Descriptors)
					{
						this.log.warn(`DashboardExporter: tabular group [${tmpGroup.Hash || tmpGroup.Name}] names RecordManifest [${tmpGroup.RecordManifest}] but the manifest has no such ReferenceManifest; skipping.`);
						continue;
					}
					const tmpRecords = this._readField(this.pict.AppData, tmpGroup.RecordSetAddress);
					if (!Array.isArray(tmpRecords) || tmpRecords.length === 0)
					{
						this.log.warn(`DashboardExporter: no records at AppData.${tmpGroup.RecordSetAddress} for tabular group [${tmpGroup.Hash || tmpGroup.Name}] — exporting headers only.`);
					}
					tmpUnits.push(
						{
							title: tmpTitle,
							groupName: tmpGroup.Name || tmpGroup.Hash || tmpGroup.RecordManifest,
							columns: this._columnsFromDescriptors(tmpRefManifest.Descriptors),
							records: Array.isArray(tmpRecords) ? tmpRecords : [],
							recordsAddress: tmpGroup.RecordSetAddress,
						});
				}
			}
			if (tmpUnits.length > 0)
			{
				return tmpUnits;
			}
			// Legacy fallback: a manifest with no declared tabular groups (pre-RecordSetAddress
			// shape). Pair the first ReferenceManifest with the historical roll-up address.
			const tmpKey = Object.keys(tmpRefManifests)[0];
			if (!tmpKey)
			{
				this.log.warn(`DashboardExporter: manifest [${tmpScope}] declares no tabular groups and no ReferenceManifests; nothing to export.`);
				return [];
			}
			this.log.warn(`DashboardExporter: manifest [${tmpScope}] declares no tabular groups; falling back to first ReferenceManifest [${tmpKey}] + AppData.WalbecDailyRecords.`);
			return [
				{
					title: tmpTitle,
					groupName: null,
					columns: this._columnsFromDescriptors((tmpRefManifests[tmpKey] && tmpRefManifests[tmpKey].Descriptors) || {}),
					records: Array.isArray(this.pict.AppData.WalbecDailyRecords) ? this.pict.AppData.WalbecDailyRecords : [],
					recordsAddress: 'WalbecDailyRecords',
				} ];
		}

		// List mode — read columns from the recordset config and records from
		// the active filter state.
		if (tmpListMatch)
		{
			const tmpRecordSet = tmpListMatch[1];
			const tmpConfig = this.pict.PictSectionRecordSet &&
				this.pict.PictSectionRecordSet.recordSetProviderConfigurations &&
				this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpRecordSet];
			if (!tmpConfig) return [];
			const tmpListColumns = Array.isArray(tmpConfig.RecordSetListColumns) ? tmpConfig.RecordSetListColumns : [];
			const tmpColumns = tmpListColumns.map((pCol) =>
			{
				if (typeof pCol === 'string') return { Hash: pCol, Label: pCol, Path: pCol, DataType: 'String' };
				return {
					Hash: pCol.Key || pCol.Hash || pCol.DisplayName,
					Label: pCol.DisplayName || pCol.Key || pCol.Hash || '',
					Path: pCol.Key || pCol.Hash,
					DataType: pCol.DataType || 'String',
				};
			});
			const tmpRecords = (this.pict.Bundle && this.pict.Bundle._ActiveFilterState &&
				this.pict.Bundle._ActiveFilterState[tmpRecordSet] &&
				this.pict.Bundle._ActiveFilterState[tmpRecordSet].Records) || [];
			return [ { title: tmpConfig.Title || tmpRecordSet, groupName: null, columns: tmpColumns, records: Array.isArray(tmpRecords) ? tmpRecords : [], recordsAddress: null } ];
		}

		return [];
	}

	/**
	 * Back-compat single-table resolution (the Excel export renders one
	 * sheet): the first export unit, or null when nothing resolves.
	 *
	 * @return {{ title: string, columns: Array<{ Hash:string, Label:string, Path:string, DataType:string }>, records: Array<Record<string, any>> } | null}
	 */
	_resolveActiveDashboardColumns()
	{
		const tmpUnits = this._resolveDashboardExportUnits();
		return (tmpUnits.length > 0) ? tmpUnits[0] : null;
	}

	/**
	 * Read a value from a record using the manyfest hash resolver — supports
	 * dotted paths into Datum, arrays via numeric index, and `.length`.
	 *
	 * @param {any} pRecord
	 * @param {string} pPath
	 */
	_readField(pRecord, pPath)
	{
		if (!pPath) return '';
		try
		{
			const tmpUtility = this.pict && this.pict.fable && this.pict.fable.Utility;
			if (tmpUtility && typeof tmpUtility.getValueByHash === 'function')
			{
				const tmpValue = tmpUtility.getValueByHash(pRecord, pPath);
				return tmpValue == null ? '' : tmpValue;
			}
		}
		catch (pError)
		{/* fall through to manual */}
		let tmpRef = pRecord;
		for (const tmpKey of String(pPath).split('.'))
		{
			if (tmpRef == null) return '';
			tmpRef = tmpRef[tmpKey];
		}
		return tmpRef == null ? '' : tmpRef;
	}

	/**
	 * @param {string} pValue
	 */
	_csvEscape(pValue)
	{
		const tmpStr = String(pValue == null ? '' : pValue);
		if (/[",\n\r]/.test(tmpStr))
		{
			return `"${tmpStr.replace(/"/g, '""')}"`;
		}
		return tmpStr;
	}

	/**
	 * Trigger a browser download of `pContent` as `pFileName` with `pMime`.
	 *
	 * @param {string} pContent
	 * @param {string} pFileName
	 * @param {string} pMime
	 */
	_downloadBlob(pContent, pFileName, pMime)
	{
		const tmpBlob = new Blob([ pContent ], { type: pMime });
		const tmpURL = URL.createObjectURL(tmpBlob);
		const tmpAnchor = document.createElement('a');
		tmpAnchor.href = tmpURL;
		tmpAnchor.download = pFileName;
		document.body.appendChild(tmpAnchor);
		tmpAnchor.click();
		document.body.removeChild(tmpAnchor);
		setTimeout(() => URL.revokeObjectURL(tmpURL), 1000);
	}

	/**
	 * Filename-safe version of the dashboard title plus today's date.
	 *
	 * @param {string} pBase
	 * @param {string} pExtension
	 */
	_buildFileName(pBase, pExtension)
	{
		const tmpSlug = String(pBase || 'dashboard')
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '');
		const tmpStamp = new Date().toISOString().slice(0, 10);
		return `${tmpSlug}-${tmpStamp}.${pExtension}`;
	}

	/**
	 * Public entry point — export the active dashboard's on-screen detail
	 * records as CSV, ONE FILE PER DETAIL TABLE. Single-table dashboards
	 * download `<title>-<date>.csv`; multi-table dashboards (e.g. Stockpile
	 * Verification's stats + samples) download `<title>-<group>-<date>.csv`
	 * per table, staggered so the browser doesn't throttle the burst.
	 */
	exportCSV()
	{
		const tmpUnits = this._resolveDashboardExportUnits();
		if (tmpUnits.length === 0)
		{
			this.log.warn('DashboardExporter.exportCSV: no exportable dashboard tables resolved for this route.');
			return;
		}
		tmpUnits.forEach((pUnit, pIndex) =>
		{
			const tmpHeader = pUnit.columns.map((pC) => this._csvEscape(pC.Label)).join(',');
			const tmpLines = pUnit.records.map((pRec) =>
				pUnit.columns.map((pCol) => this._csvEscape(this._readField(pRec, pCol.Path))).join(','),
			);
			const tmpCSV = [ tmpHeader ].concat(tmpLines).join('\r\n');
			const tmpFileBase = (tmpUnits.length > 1 && pUnit.groupName) ? `${pUnit.title} - ${pUnit.groupName}` : pUnit.title;
			const tmpFileName = this._buildFileName(tmpFileBase, 'csv');
			// Stagger the downloads — several synchronous anchor clicks in one tick
			// get coalesced/blocked by browser multi-download throttling.
			setTimeout(() =>
			{
				// Prepend a UTF-8 BOM so Excel's auto-import detects encoding correctly.
				this._downloadBlob('﻿' + tmpCSV, tmpFileName, 'text/csv;charset=utf-8');
				this.log.info(`DashboardExporter.exportCSV: ${pUnit.records.length} record(s) → ${tmpFileName}`);
			}, pIndex * 300);
		});
	}

	/**
	 * Round a DECIMAL STRING to a given number of places without ever letting the
	 * value become a float first.
	 *
	 * This matters more here than it looks. Measurements in this system are stored
	 * as STRINGS on purpose -- the lake columns are Text, the solvers pass them
	 * through as text -- precisely so arbitrary precision never meets JavaScript's
	 * float mantissa. Gmm arrives as values like "2.47770392749244712991", twenty
	 * significant digits, well past what a double holds. Calling Number() on that
	 * and then rounding would reintroduce exactly the drift the string storage
	 * exists to prevent. So the rounding is done on the digits, half-up, and only
	 * the already-short result is handed to Number().
	 *
	 * @param {string} pValue - a numeric string.
	 * @param {number} pPlaces - decimal places to keep.
	 * @return {string} The rounded decimal string.
	 */
	_roundDecimalString(pValue, pPlaces)
	{
		let tmpText = String(pValue).trim();
		let tmpSign = '';
		if ((tmpText.charAt(0) === '-') || (tmpText.charAt(0) === '+'))
		{
			tmpSign = (tmpText.charAt(0) === '-') ? '-' : '';
			tmpText = tmpText.slice(1);
		}
		const tmpPoint = tmpText.indexOf('.');
		if (tmpPoint < 0) { return tmpSign + tmpText; }
		let tmpWhole = tmpText.slice(0, tmpPoint);
		let tmpFraction = tmpText.slice(tmpPoint + 1);
		if (tmpFraction.length <= pPlaces) { return tmpSign + tmpText; }

		const tmpKept = tmpFraction.slice(0, pPlaces);
		const tmpRoundUp = (tmpFraction.charAt(pPlaces) >= '5');
		if (!tmpRoundUp) { return tmpSign + (pPlaces > 0 ? `${tmpWhole}.${tmpKept}` : tmpWhole); }

		// Carry through the kept digits, then into the whole part if it overflows.
		const tmpDigits = (tmpWhole + tmpKept).split('');
		let tmpIndex = tmpDigits.length - 1;
		while (tmpIndex >= 0)
		{
			if (tmpDigits[tmpIndex] === '9') { tmpDigits[tmpIndex] = '0'; tmpIndex--; }
			else { tmpDigits[tmpIndex] = String(Number(tmpDigits[tmpIndex]) + 1); break; }
		}
		if (tmpIndex < 0) { tmpDigits.unshift('1'); }
		const tmpCarried = tmpDigits.join('');
		const tmpSplit = tmpCarried.length - pPlaces;
		const tmpNewWhole = tmpCarried.slice(0, tmpSplit) || '0';
		const tmpNewFraction = tmpCarried.slice(tmpSplit);
		return tmpSign + (pPlaces > 0 ? `${tmpNewWhole}.${tmpNewFraction}` : tmpNewWhole);
	}

	/**
	 * The value to write into a workbook cell.
	 *
	 * A cell becomes a REAL NUMBER only when the column declares a numeric type and
	 * the value actually parses as one -- otherwise it stays text. That is the whole
	 * fidelity win over the old HTML-as-Excel output, which handed Excel every value
	 * as a string so nothing could be summed or pivoted.
	 *
	 * Anything that is not numeric, or a numeric column holding something odd, is
	 * passed through untouched rather than coerced: a blank must not become 0, and a
	 * stray '-' must not become NaN.
	 *
	 * @param {*} pValue @param {{DataType:string, DecimalPrecision:number|null}} pColumn
	 * @return {string|number}
	 */
	_toWorkbookValue(pValue, pColumn)
	{
		const tmpRaw = (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue).trim();
		if (tmpRaw === '') { return ''; }
		const tmpType = String((pColumn && pColumn.DataType) || '').toLowerCase();
		const tmpNumeric = (tmpType === 'integer') || (tmpType === 'precisenumber') ||
			(tmpType === 'number') || (tmpType === 'float') || (tmpType === 'decimal');
		if (!tmpNumeric) { return tmpRaw; }
		// Plain decimal only. Exponent notation, currency marks and thousands
		// separators all stay as text rather than being silently reinterpreted.
		if (!/^[-+]?(\d+\.?\d*|\.\d+)$/.test(tmpRaw)) { return tmpRaw; }
		const tmpPlaces = (pColumn && (typeof pColumn.DecimalPrecision === 'number')) ? pColumn.DecimalPrecision : null;
		const tmpRounded = (tmpPlaces === null) ? tmpRaw : this._roundDecimalString(tmpRaw, tmpPlaces);
		const tmpNumber = Number(tmpRounded);
		return isFinite(tmpNumber) ? tmpNumber : tmpRaw;
	}

	/**
	 * The provenance sheet: what this workbook covers.
	 *
	 * A workbook emailed to a DOT reviewer is as much a submittal as the printed
	 * page, and is just as meaningless without stating which mix design, which site
	 * and which dates produced it. Same provenance the print header carries, read
	 * from the live clause state rather than the URL so it reflects what actually
	 * generated the numbers.
	 *
	 * @param {Array<object>} pUnits
	 * @return {{name:string, columns:Array<object>, rows:Array<Array<*>>}}
	 */
	_buildReportInfoSheet(pUnits)
	{
		const tmpRows = [];
		const tmpTitle = (pUnits[0] && pUnits[0].title) || 'Dashboard';
		tmpRows.push([ 'Dashboard', tmpTitle ]);

		const tmpLoader = this.pict.providers.DynamicDashboardLoader;
		const tmpContext = (tmpLoader && typeof tmpLoader._resolveDashboardRouteContext === 'function')
			? tmpLoader._resolveDashboardRouteContext() : null;
		if (tmpContext && tmpContext.RecordSet && tmpLoader && (typeof tmpLoader._resolvePrintFilterSummary === 'function'))
		{
			const tmpSummary = tmpLoader._resolvePrintFilterSummary(tmpContext.RecordSet);
			// Said out loud either way: an unfiltered export is a different document
			// from a filtered one and must not look identical to one.
			tmpRows.push([ 'Filters', tmpSummary || 'None applied - covers ALL records' ]);
		}

		for (const tmpUnit of pUnits)
		{
			tmpRows.push([ tmpUnit.groupName ? `Rows (${tmpUnit.groupName})` : 'Rows', tmpUnit.records.length ]);
		}

		const tmpNow = new Date();
		const tmpStamp = `${tmpNow.getFullYear()}-${String(tmpNow.getMonth() + 1).padStart(2, '0')}-${String(tmpNow.getDate()).padStart(2, '0')}`;
		tmpRows.push([ 'Generated', tmpStamp ]);

		return { name: 'Report Info', columns: [ { Label: 'Field' }, { Label: 'Value' } ], rows: tmpRows };
	}

	/**
	 * Public entry point — export the active dashboard as a real .xlsx workbook.
	 *
	 * One workbook, one worksheet per on-screen detail table, plus a Report Info
	 * sheet. This replaces an HTML-as-Excel output (a styled <table> saved with an
	 * .xls extension) that modern Excel warns about on open and that handed every
	 * value over as text.
	 *
	 * @return {boolean} False when there is nothing on this route to export.
	 */
	exportExcel()
	{
		const tmpUnits = this._resolveDashboardExportUnits();
		if (!tmpUnits || (tmpUnits.length < 1))
		{
			this.log.warn('DashboardExporter.exportExcel: no exportable dashboard tables resolved for this route.');
			return false;
		}

		const tmpSheets = [ this._buildReportInfoSheet(tmpUnits) ];
		for (const tmpUnit of tmpUnits)
		{
			tmpSheets.push(
				{
					name: tmpUnit.groupName || 'Data',
					columns: tmpUnit.columns.map((pColumn) => ({ Label: pColumn.Label })),
					rows: tmpUnit.records.map((pRecord) =>
						tmpUnit.columns.map((pColumn) => this._toWorkbookValue(this._readField(pRecord, pColumn.Path), pColumn))),
				});
		}

		const tmpBytes = libWorkbookWriter.buildXLSX(tmpSheets);
		const tmpFileName = this._buildFileName(tmpUnits[0].title, 'xlsx');
		this._downloadBlob(tmpBytes, tmpFileName,
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
		const tmpTotal = tmpUnits.reduce((pSum, pUnit) => pSum + pUnit.records.length, 0);
		this.log.info(`DashboardExporter.exportExcel: ${tmpSheets.length} sheet(s), ${tmpTotal} record(s) -> ${tmpFileName}`);
		return true;
	}

	/**
	 * Public entry point — export the RAW, unaggregated, unfiltered backing rows
	 * (the lake table behind the current dashboard) as CSV. Where exportCSV() exports
	 * the on-screen per-day roll-up, this fetches the source rows straight from the
	 * lake Entity (scope = Deleted=0 only, no user filter clauses) and dumps every
	 * column — for offline pivoting in Excel. Cheap: one filtered fetch, all columns
	 * derived from the returned rows.
	 *
	 * @return {boolean} - False if not on a dashboard route or the recordset config is missing.
	 */
	exportRawCSV()
	{
		const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) || '';
		const tmpMatch = tmpHash.match(/^#\/PSRS\/([^\/]+)\/SpecificDashboard\/([^\/]+)/);
		if (!tmpMatch)
		{
			this.log.warn('DashboardExporter.exportRawCSV: not on a SpecificDashboard route.');
			return false;
		}
		const tmpRecordSet = tmpMatch[1];
		const tmpScope = tmpMatch[2];
		const tmpConfig = this.pict.PictSectionRecordSet &&
			this.pict.PictSectionRecordSet.recordSetProviderConfigurations &&
			this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpRecordSet];
		if (!tmpConfig || !tmpConfig.RecordSetMeadowEntity)
		{
			this.log.warn(`DashboardExporter.exportRawCSV: no recordset config / entity for ${tmpRecordSet}.`);
			return false;
		}
		const tmpEntity = tmpConfig.RecordSetMeadowEntity;
		const tmpURLPrefix = tmpConfig.RecordSetURLPrefix || '/1.0/';
		// Unfiltered/unaggregated: the recordset's default filter is scope + sort
		// (FBV~Deleted~EQ~0~FSF~BucketDate~ASC~0) with no user clauses — exactly the raw set.
		const tmpScopeFilter = tmpConfig.RecordSetDefaultFilter || 'FBV~Deleted~EQ~0';
		const tmpManifest = this.pict.PictSectionRecordSet.manifestDefinitions &&
			this.pict.PictSectionRecordSet.manifestDefinitions[tmpScope];
		const tmpTitle = (tmpManifest && tmpManifest.Title) || tmpConfig.Title || tmpRecordSet;
		const tmpCap = 25000;
		this.pict.EntityProvider.getEntitySetPage(
			tmpEntity,
			tmpScopeFilter,
			0,
			tmpCap,
			(pError, pRecords) =>
			{
				const tmpRecords = Array.isArray(pRecords) ? pRecords : [];
				if (pError)
				{
					this.log.warn(`DashboardExporter.exportRawCSV: fetch failed for ${tmpEntity}: ${pError.message || pError}`);
					return;
				}
				if (tmpRecords.length === 0)
				{
					this.log.warn('DashboardExporter.exportRawCSV: no backing rows returned.');
					return;
				}
				// Columns = union of keys across the returned rows (lake rows share a schema,
				// but union is safe). Object/array cells are JSON-stringified.
				const tmpColumns = [];
				const tmpSeen = {};
				for (const tmpRec of tmpRecords)
				{
					if (!tmpRec || typeof tmpRec !== 'object') continue;
					for (const tmpKey of Object.keys(tmpRec))
					{
						if (!tmpSeen[tmpKey])
						{
							tmpSeen[tmpKey] = true; tmpColumns.push(tmpKey);
						}
					}
				}
				const tmpHeader = tmpColumns.map((pK) => this._csvEscape(pK)).join(',');
				const tmpLines = tmpRecords.map((pRec) =>
					tmpColumns.map((pK) =>
					{
						let tmpValue = pRec ? pRec[pK] : '';
						if (tmpValue && typeof tmpValue === 'object')
						{
							try
							{
								tmpValue = JSON.stringify(tmpValue);
							}
							catch (pErr)
							{
								tmpValue = '';
							}
						}
						return this._csvEscape(tmpValue == null ? '' : tmpValue);
					}).join(','));
				const tmpCSV = [ tmpHeader ].concat(tmpLines).join('\r\n');
				const tmpFileName = this._buildFileName(`${tmpTitle} - raw backing data`, 'csv');
				// UTF-8 BOM so Excel auto-detects encoding.
				this._downloadBlob('﻿' + tmpCSV, tmpFileName, 'text/csv;charset=utf-8');
				const tmpCapNote = tmpRecords.length >= tmpCap ? ` (capped at ${tmpCap} rows)` : '';
				this.log.info(`DashboardExporter.exportRawCSV: ${tmpRecords.length} raw row(s)${tmpCapNote} → ${tmpFileName}`);
			},
			'',
			tmpURLPrefix,
		);
		return true;
	}
}

module.exports = DashboardExporter;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./Workbook-Writer.js":46,"fable-serviceproviderbase":438}],41:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
// The Pict-Input-Templated extension provider — fills a Templated cell's per-row content.
// pict-section-form wires it from metatemplate `DefaultInputExtensions` at load; our runtime
// tabular shim has to register + wire it by hand (see _installDocumentLinkSupport).
const libPictInputTemplated = require('pict-section-form/source/providers/inputs/Pict-Provider-Input-Templated.js');

/**
 * Row-aware tabular Templated input. The stock pict-section-form Pict-Input-Templated is
 * broken for tabular cells: `_handleInitialize()` calls `handleContentUpdate()` WITHOUT the
 * row index, so it renders the cell's `PictForm.Template` against FORM-level data
 * (`getMarshalDestinationObject()`) instead of the per-row record — every Templated cell in a
 * recordset LIST row paints empty (the literal string "undefined"). This subclass overrides
 * the tabular marshal to render the cell template against the actual ROW record, so
 * `{~D:Record.IDDocumentCount~}`, `Record.BucketDate`, `Record.BucketLabel` resolve — which is
 * what the per-day Documents button needs. Registered + wired in `_installDocumentLinkSupport`.
 */
class WalbecTabularTemplatedInput extends libPictInputTemplated
{
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		try
		{
			if (pInput && pInput.PictForm && (typeof pInput.PictForm.Template === 'string') && (pRowIndex != null))
			{
				const tmpMarshalDestination = pView.getMarshalDestinationObject() || {};
				// The tabular group binds to this address (e.g. WalbecDailyRecords). Fall back to
				// the known per-day records if the group didn't carry it.
				const tmpRecordSetAddress = (pGroup && pGroup.RecordSetAddress) || 'WalbecDailyRecords';
				const tmpRecords = Array.isArray(tmpMarshalDestination[tmpRecordSetAddress]) ? tmpMarshalDestination[tmpRecordSetAddress] : null;
				const tmpRow = tmpRecords ? tmpRecords[pRowIndex] : null;
				if (tmpRow)
				{
					// Render the cell template against the ROW (so `Record.*` is the row's data).
					const tmpContent = this.pict.parseTemplate(pInput.PictForm.Template, tmpRow, null, [ this ], this);
					this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
					return true;
				}
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`WalbecTabularTemplatedInput tabular render error: ${pError.message || pError}`);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

/**
 * Dashboard screen styling. Every rule is scoped to `[id^="PSRS-Dashboard-"]`, so it is safe inside any host page;
 * the page-level rules (print isolation, gutters, the bottom toolbar) stay with the data app's own chrome.
 */
const _SCOPED_DASHBOARD_CSS = /*css*/`
	/* ---------------------------------------------------------------
	   FULL-WIDTH DASHBOARDS
	   ---------------------------------------------------------------
	   pict-section-form puts Bulma's .container on every form section,
	   which caps it at 960px (and ~1152/1344px at wider breakpoints).
	   That measure is right for a FORM -- a readable line length -- and
	   wrong for a dashboard, where the content is a 48-column gradation
	   table and a wide control chart. On a 1168px window the table got
	   960px and the user scrolled horizontally for 208px they already
	   had; on a 2560px monitor the cap throws away over 1100px.

	   Scoped to [id^="PSRS-Dashboard-"] so ordinary forms keep the
	   readable measure the container exists to give them. */
	[id^="PSRS-Dashboard-"] .pict-form-section.container
	{
		max-width: none;
		width: 100%;
		margin-left: 0;
		margin-right: 0;
	}

	[id^="PSRS-Dashboard-"] .section-table-wrapper td > span:first-child { display: none; }
	[id^="PSRS-Dashboard-"] .section-table-wrapper td { white-space: nowrap; }
	/* Section / sub-section headers — turn the muted form labels
	   into proper dashboard section titles. */
	[id^="PSRS-Dashboard-"] h2.section-header,
	[id^="PSRS-Dashboard-"] h3.section-subheader
	{
		font-size: 1rem;
		font-weight: 700;
		color: #1a202c;
		letter-spacing: -0.005em;
		margin: 1.4rem 0 0.6rem;
		padding-bottom: 0.4rem;
		border-bottom: 2px solid #e6e8ee;
		text-transform: none;
	}
	[id^="PSRS-Dashboard-"] h2.section-header.is-hidden,
	[id^="PSRS-Dashboard-"] h3.section-subheader.is-hidden
	{
		display: none;
	}
	/* KPI tile cards — wrap each ReadOnly form input in a polished
	   card with label on top, large bold value below. We use the
	   :has() selector to scope the treatment to columns that
	   actually contain a readonly input (the KPI cells); chart /
	   tabular sections are unaffected. */
	[id^="PSRS-Dashboard-"] .column:has(> .field > .control > .input[readonly]),
	[id^="PSRS-Dashboard-"] .pict-form-vertical-input.column:has(.input[readonly])
	{
		background: #ffffff;
		border: 1px solid #e6e8ee;
		border-radius: 12px;
		padding: 0.85rem 1rem 0.95rem;
		box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
		margin: 0.4rem;
		transition: box-shadow 0.15s ease;
	}
	[id^="PSRS-Dashboard-"] .column:has(> .field > .control > .input[readonly]):hover,
	[id^="PSRS-Dashboard-"] .pict-form-vertical-input.column:has(.input[readonly]):hover
	{
		box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
	}
	[id^="PSRS-Dashboard-"] .column:has(> .field > .control > .input[readonly]) > label,
	[id^="PSRS-Dashboard-"] .pict-form-vertical-input.column:has(.input[readonly]) label
	{
		color: #64748b;
		font-size: 0.72rem;
		text-transform: uppercase;
		letter-spacing: 0.06em;
		font-weight: 600;
		margin-bottom: 0.25rem;
		display: block;
	}
	/* The readonly input itself loses its border / background and
	   becomes the headline number for the card. SCOPED to the KPI
	   card columns (same :has() scope as the card treatment above) so
	   it does NOT leak onto tabular readonly cells — those are styled
	   separately below. */
	[id^="PSRS-Dashboard-"] .column:has(> .field > .control > .input[readonly]) .input[readonly],
	[id^="PSRS-Dashboard-"] .pict-form-vertical-input.column:has(.input[readonly]) .input[readonly]
	{
		border: none !important;
		background: transparent !important;
		box-shadow: none !important;
		padding: 0 !important;
		font-weight: 700;
		font-size: 1.6rem;
		color: #1a202c;
		height: auto;
		text-align: left;
	}
	/* Tabular readonly value cells (PreciseNumberReadOnly etc. inside a
	   recordset table) — borderless like the KPI value but at the
	   table's own scale, and content-sized so formatted currency
	   ($9,791,990.30) is never clipped. NOT the 1.6rem KPI headline. */
	[id^="PSRS-Dashboard-"] table input[readonly][id^="TABULAR-DATA-"]
	{
		border: none !important;
		background: transparent !important;
		box-shadow: none !important;
		padding: 0 0.35rem 0 0 !important;
		font-weight: 400;
		font-size: 0.9rem;
		color: #1a202c;
		height: auto !important;
		min-height: 0 !important;
		width: auto;
		min-width: 0;
		field-sizing: content;
		max-width: 14rem;
		text-align: right;
	}
	/* Strip the addons / icons the form template adds around inputs so
	   the value sits cleanly in the card. */
	[id^="PSRS-Dashboard-"] .column:has(.input[readonly]) .has-addons-right { justify-content: flex-start; }
	[id^="PSRS-Dashboard-"] .column:has(.input[readonly]) .control-status-icon,
	[id^="PSRS-Dashboard-"] .column:has(.input[readonly]) .help { display: none; }
`;

const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'DynamicDashboardLoader',
	// true: this loader owns the page (the data app) — bottom toolbar, router hooks, print isolation, global template
	// overrides. false: a host app embeds dashboards; only dashboard-scoped styling and registration are installed.
	AppChrome: true,
};

/**
 * @typedef {Object} DashboardHostOptions
 * @property {string} [ExtraFilter] - Meadow filter clauses ANDed onto every read the dashboard makes (project + role filters).
 * @property {string} [URLTemplate] - Where applying a filter navigates, when the host owns the route (receives
 *   `/FilterExperience/<serialized>` appended).
 * @property {boolean} [ShowDescription] - true shows the dashboard's Description under its title.
 */

/**
 * The "extra column" row template the framework renders inside the actions
 * <td> for every Document-backed recordset. Replaces the stock View link with
 * Open-in-new-tab + Download PDF buttons that route through
 * `pict.HeadlightDocumentRender`. `Record.Data.IDDocument` resolves per-row
 * inside the framework's tabular iteration.
 *
 * Template hash is per-recordset (see RecordsSet-MetaController#loadRecordSetConfiguration);
 * the inline `onclick` handlers survive re-renders without needing observers.
 */
function _walbecDocumentActionRowTemplate()
{
	return /*html*/`<td class="has-text-centered">
		<div class="buttons are-small is-centered">
			<button type="button" class="button is-link is-small"
				onclick="event.preventDefault(); _Pict.HeadlightDocumentRender.openDocument({~D:Record.Data.IDDocument~}, { target: '_blank' });"
				title="Open the rendered form in a new tab">
				<span class="icon"><i class="fa fa-up-right-from-square"></i></span>
				<span>Open</span>
			</button>
			<button type="button" class="button is-info is-small is-light"
				onclick="event.preventDefault(); _Pict.HeadlightDocumentRender.downloadPDF({~D:Record.Data.IDDocument~});"
				title="Download the rendered PDF">
				<span class="icon"><i class="fa fa-file-pdf"></i></span>
				<span>PDF</span>
			</button>
		</div>
	</td>`;
}

/**
 * The modal-body template for the per-day Documents drill-down: a table of the day's
 * Document records (one Walbec-DayDocuments-ModalRow per row), rendered into
 * pict-section-modal by `DynamicDashboardLoader.openDayDocuments`. Iterates
 * AppData.WalbecDayDocuments.Records.
 */
function _walbecDayDocumentsModalBody()
{
	// max-height + scroll keeps the popup "not too tall"; the modal width is widened in
	// openDayDocuments. Rendered ASYNC (parseTemplateByHash with a callback) so the
	// `{~E:Project^...~}` per-row project-name lookups resolve.
	return /*html*/`<div class="walbec-daydocs" style="max-height:60vh;overflow-y:auto;">
		<table class="table is-fullwidth is-striped is-narrow is-hoverable">
			<thead><tr>
				<th>Date</th><th>Project</th><th>Document</th><th class="has-text-right">&nbsp;</th>
			</tr></thead>
			<tbody>{~TS:Walbec-DayDocuments-ModalRow:AppData.WalbecDayDocuments.Records~}</tbody>
		</table>
	</div>`;
}

/**
 * One Document row inside the drill-down popup — Date (YYYY-MM-DD), Project name (resolved
 * from the Document's IDProject), Document title, and Open-in-tab + Download-PDF actions
 * routed through `pict.HeadlightDocumentRender`. `Record` is the fetched Document entity.
 */
function _walbecDayDocumentsModalRow()
{
	return /*html*/`<tr>
		<td style="white-space:nowrap;">{~DateFormat:Record.DocumentDate^YYYY-MM-DD~}</td>
		<td>{~E:Project^Record.IDProject^Walbec-DayDoc-ProjectName~}</td>
		<td>{~D:Record.Name~}</td>
		<td class="has-text-right" style="white-space:nowrap;">
			<div class="buttons are-small" style="flex-wrap:nowrap;justify-content:flex-end;margin-bottom:0;">
				<button type="button" class="button is-link is-small"
					onclick="event.preventDefault(); _Pict.HeadlightDocumentRender.openDocument({~D:Record.IDDocument~}, { target: '_blank' });"
					title="Open the rendered form in a new tab">
					<span class="icon"><i class="fa fa-up-right-from-square"></i></span><span>Open</span>
				</button>
				<button type="button" class="button is-info is-small is-light"
					onclick="event.preventDefault(); _Pict.HeadlightDocumentRender.downloadPDF({~D:Record.IDDocument~});"
					title="Download the rendered PDF">
					<span class="icon"><i class="fa fa-file-pdf"></i></span><span>PDF</span>
				</button>
			</div>
		</td>
	</tr>`;
}

/**
 * Renders a Project's name. Used via `{~E:Project^Record.IDProject^Walbec-DayDoc-ProjectName~}`
 * in the documents popup row — here `Record` is the fetched Project entity (cached by the
 * entity-render provider, so repeated IDProjects only fetch once).
 */
function _walbecDayDocProjectName()
{
	return /*html*/`{~D:Record.Name~}`;
}

/**
 * Loads per-customer dashboards from AppData + ManifestSchema and registers
 * them into the running pict-section-recordset instance at runtime.
 *
 * Storage contract (matches `headlight/web/data` plan, demo shortcut):
 *   - AppData (Type=AvailableDashboards, IDCustomer=N)        — list of dashboards to wire for this customer
 *   - ManifestSchema (Type=DataDashboard, Hash=H, IDCustomer) — the pict-section-recordset manifest for each dashboard
 *   - AppData (Type=AggregatedDashboardData, AppHash=H)       — bucketed records the recordset reads
 *
 * The loader is a no-op for customers without an AvailableDashboards record,
 * which preserves the existing behavior for customer 10 (LADOTD).
 */
class DynamicDashboardLoader extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);
		/** @type {any} */
		this.pict = this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Runtime support for the dashboard Documents drill-down, installed once before the
	 * first dashboard renders:
	 *   1. pict-section-form (<= 1.1.8) ships tabular metatemplates for most input types
	 *      but NOT `Templated`, so a Templated cell inside a recordset LIST row throws
	 *      "missing input template" and takes the whole dashboard down. Until
	 *      pict-section-form publishes the pair, register it at runtime under every form
	 *      template-set prefix that already carries the tabular `Link` template
	 *      (Pict-MT-Base, the ReadOnly set, and the active theme sets — the dashboard form
	 *      runs under PictProvider-Theme-Edit). Mirrors the Begin/End pair added to
	 *      pict-section-form's Pict-DynamicTemplates-DefaultFormTemplates.js (publish later).
	 *   2. Register the two modal-content templates the Documents popup renders.
	 */
	_installDocumentLinkSupport()
	{
		if (this._documentLinkSupportInstalled)
		{
			return;
		}
		const tmpTemplateProvider = this.pict.TemplateProvider;
		if (!tmpTemplateProvider || !tmpTemplateProvider.templates)
		{
			return;
		}
		// 1. Tabular `Templated` metatemplate shim — register under every prefix that
		// already has the tabular `Link` template, so it lands in whatever set(s) the
		// dashboard form actually uses.
		const tmpReference = '-TabularTemplate-End-Input-InputType-Link';
		const tmpPrefixes = [ ...new Set(Object.keys(tmpTemplateProvider.templates)
			.filter((pHash) => pHash.endsWith(tmpReference))
			.map((pHash) => pHash.slice(0, -tmpReference.length))) ];
		const tmpBegin = /*html*/`<input type="hidden" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `;
		const tmpEnd = /*html*/` value=""><div id="DISPLAY-FOR-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-templated"></div>`;
		// A Templated cell only paints if an input extension is attached to its metatemplate
		// hash (its onDataMarshalToFormTabular fills the per-row DISPLAY-FOR-TABULAR div), and
		// the stock Pict-Input-Templated renders tabular cells against FORM-level data, not the
		// row — so it paints "undefined". We register the row-aware WalbecTabularTemplatedInput
		// and map each tabular Templated hash to it via DynamicInput.addDefaultInputProvider
		// (the same call the load-time `DefaultInputExtensions` processor makes, which a plain
		// addTemplate() can't carry). Without this the Documents button is a silent empty cell.
		if (!this.pict.providers['Walbec-Input-Templated'])
		{
			this.pict.addProvider('Walbec-Input-Templated', {}, WalbecTabularTemplatedInput);
		}
		const tmpDynamicInput = this.pict.providers.DynamicInput;
		let tmpInstalledCount = 0;
		for (const tmpPrefix of tmpPrefixes)
		{
			const tmpBeginHash = `${tmpPrefix}-TabularTemplate-Begin-Input-InputType-Templated`;
			const tmpEndHash = `${tmpPrefix}-TabularTemplate-End-Input-InputType-Templated`;
			if (!tmpTemplateProvider.templates[tmpBeginHash])
			{
				tmpTemplateProvider.addTemplate(tmpBeginHash, tmpBegin, 'DynamicDashboardLoader tabular Templated shim');
			}
			if (!tmpTemplateProvider.templates[tmpEndHash])
			{
				tmpTemplateProvider.addTemplate(tmpEndHash, tmpEnd, 'DynamicDashboardLoader tabular Templated shim');
				tmpInstalledCount++;
			}
			// getInputTemplateHash() resolves a tabular Templated cell to this Begin hash, so
			// this is the key DynamicInput looks up for the extension. Idempotent.
			if (tmpDynamicInput && typeof tmpDynamicInput.addDefaultInputProvider === 'function')
			{
				tmpDynamicInput.addDefaultInputProvider(tmpBeginHash, 'Walbec-Input-Templated');
			}
		}
		// 2. Documents popup content templates.
		tmpTemplateProvider.addTemplate('Walbec-DayDocuments-ModalBody', _walbecDayDocumentsModalBody(), 'DynamicDashboardLoader');
		tmpTemplateProvider.addTemplate('Walbec-DayDocuments-ModalRow', _walbecDayDocumentsModalRow(), 'DynamicDashboardLoader');
		tmpTemplateProvider.addTemplate('Walbec-DayDoc-ProjectName', _walbecDayDocProjectName(), 'DynamicDashboardLoader');
		this._documentLinkSupportInstalled = true;
		this.log.info(`DynamicDashboardLoader: installed Documents drill-down support (tabular Templated shim under ${tmpInstalledCount} template set(s) + modal templates).`);
	}

	/**
	 * Documents drill-down for a dashboard day-row. Opens a WIDE pict-section-modal listing the
	 * EXACT documents that rolled up into `pBucketDate` — pulled from the lake `Day` rows'
	 * `IDDocuments` list (already domain-scoped to this dashboard), not a DocumentDate-range
	 * fetch (which over-fetches every document type on that date). Each row shows the date
	 * (YYYY-MM-DD), the project name, the document title, and Open-in-tab + Download-PDF actions
	 * via HeadlightDocumentRender. Wired from the documentsLinkCell button:
	 *   onclick="_Pict.providers.DynamicDashboardLoader.openDayDocuments('2026-05-06T00:00:00.000Z', 'May 6')".
	 *
	 * @param {string} pBucketDate - The day-row's BucketDate (matches the lake rows' BucketDate).
	 * @param {string} [pLabel] - Human label for the modal title (the BucketLabel).
	 * @return {boolean} - False if the modal view is unavailable.
	 */
	openDayDocuments(pBucketDate, pLabel)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			this.log.warn('DynamicDashboardLoader: Pict-Section-Modal view is not registered; cannot open day documents.');
			return false;
		}
		// Opening another popup closes the first.
		if (typeof tmpModal.dismissModals === 'function')
		{
			tmpModal.dismissModals();
		}

		const tmpLabel = pLabel ? String(pLabel) : '';
		const tmpTitle = tmpLabel ? `Documents — ${tmpLabel}` : 'Documents';
		const tmpModalWidth = 'min(900px, 92vw)';
		const tmpBucketDate = String(pBucketDate || '').trim();
		const fShowMessage = (pMessage, pClass) =>
		{
			tmpModal.show({ title: tmpTitle, content: `<p class="${pClass || 'has-text-grey'}">${pMessage}</p>`, width: tmpModalWidth, buttons: [ { Hash: 'close', Label: 'Close' } ] });
		};
		if (!tmpBucketDate)
		{
			fShowMessage('No date on this row to look up documents.');
			return false;
		}

		// Collect the day's distinct document IDs from a set of lake rows (each lake row carries
		// a comma-separated IDDocuments list for its project/dimension bucket).
		const fCollectDocumentIDs = (pLakeRows) =>
		{
			const tmpSeen = {};
			const tmpIDs = [];
			for (const tmpRow of (Array.isArray(pLakeRows) ? pLakeRows : []))
			{
				// Aggregate tables carry IDDocuments (CSV); document-grain
				// tables (e.g. HmaRunAvg) carry IDDocument (singular).
				const tmpCSV = (tmpRow && tmpRow.IDDocuments != null) ? String(tmpRow.IDDocuments) :
					((tmpRow && tmpRow.IDDocument != null) ? String(tmpRow.IDDocument) : '');
				for (const tmpPart of tmpCSV.split(','))
				{
					const tmpID = parseInt(String(tmpPart).trim(), 10);
					if (Number.isInteger(tmpID) && tmpID > 0 && !tmpSeen[tmpID])
					{
						tmpSeen[tmpID] = true; tmpIDs.push(tmpID);
					}
				}
			}
			return tmpIDs;
		};

		// Fetch the exact Document records by ID (main api), then ASYNC-render the popup body so
		// the per-row `{~E:Project~}` name lookups + `{~DateFormat~}` resolve, then show it wide.
		const fShowDocuments = (pIDs) =>
		{
			if (!pIDs || pIDs.length === 0)
			{
				fShowMessage('No documents recorded for this day.');
				return;
			}
			this.pict.EntityProvider.getEntitySetPage(
				'Document',
				`FBV~Deleted~EQ~0~FBL~IDDocument~INN~${pIDs.join(',')}~FSF~DocumentDate~DESC~0`,
				0,
				pIDs.length,
				(pError, pRecords) =>
				{
					const tmpRecords = Array.isArray(pRecords) ? pRecords : [];
					if (pError)
					{
						this.log.warn(`DynamicDashboardLoader: failed to load documents for ${tmpBucketDate}: ${pError.message || pError}`);
						fShowMessage('Could not load documents for this day — see console.', 'has-text-danger');
						return;
					}
					if (tmpRecords.length === 0)
					{
						fShowMessage('No documents found for this day.');
						return;
					}
					this.pict.AppData.WalbecDayDocuments = { Label: tmpLabel, Count: tmpRecords.length, Records: tmpRecords };
					this.pict.parseTemplateByHash('Walbec-DayDocuments-ModalBody', this.pict.AppData.WalbecDayDocuments, (pRenderError, pContent) =>
					{
						const tmpContent = (!pRenderError && pContent) ? pContent : '<p class="has-text-danger">Could not render the documents list.</p>';
						tmpModal.show({ title: tmpTitle, content: tmpContent, width: tmpModalWidth, buttons: [ { Hash: 'close', Label: 'Close' } ] });
					});
				},
				'',
				'/1.0/',
			);
		};

		// Primary source: the post-filter lake rows the loader already stashed in memory.
		const tmpStashedRows = Array.isArray(this.pict.AppData.WalbecRecords) ? this.pict.AppData.WalbecRecords : [];
		const tmpDayRows = tmpStashedRows.filter((pRow) => pRow && String(pRow.BucketDate) === tmpBucketDate);
		if (tmpDayRows.length > 0)
		{
			fShowDocuments(fCollectDocumentIDs(tmpDayRows));
			return true;
		}

		// Fallback: the day isn't in the loaded page — fetch its lake rows directly from the
		// dashboard's lake recordset (URLPrefix + Entity resolved from the active route).
		const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) || '';
		const tmpRecordSetMatch = tmpHash.match(/^#\/PSRS\/([^/]+)\/SpecificDashboard\//);
		const tmpRecordSet = tmpRecordSetMatch ? tmpRecordSetMatch[1] : null;
		const tmpConfig = (tmpRecordSet && this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.recordSetProviderConfigurations) ?
			this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpRecordSet] : null;
		const tmpLakeEntity = tmpConfig && tmpConfig.RecordSetMeadowEntity;
		const tmpLakeURLPrefix = (tmpConfig && tmpConfig.RecordSetURLPrefix) || '/1.0/';
		if (!tmpLakeEntity)
		{
			fShowDocuments([]);
			return true;
		}
		this.pict.EntityProvider.getEntitySetPage(
			tmpLakeEntity,
			`FBV~Deleted~EQ~0~FBV~BucketDate~EQ~${tmpBucketDate}`,
			0,
			1000,
			(pLakeError, pLakeRows) =>
			{
				if (pLakeError)
				{
					this.log.warn(`DynamicDashboardLoader: lake fallback fetch failed for ${tmpBucketDate}: ${pLakeError.message || pLakeError}`);
				}
				fShowDocuments(fCollectDocumentIDs(pLakeRows));
			},
			'',
			tmpLakeURLPrefix,
		);
		return true;
	}

	/**
	 * Fetches the AvailableDashboards AppData record for a given customer.
	 *
	 * @param {number} pCustomerID - The IDCustomer to look up.
	 * @return {Promise<{ Dashboards: Array<{ Hash: string, Title: string, RecordSet: string }> } | null>}
	 */
	async loadAvailableDashboards(pCustomerID)
	{
		if (!pCustomerID)
		{
			return null;
		}
		// First-class Dashboard registry, read DIRECTLY from the meadow
		// endpoint like any entity — row-level auth scopes the customer, FSF
		// sorts by Ordinal, and the API serves DataSource as a parsed object.
		const tmpRows = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('Dashboards/FilteredTo/FSF~Ordinal~ASC~0/0/200', (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
		if (!Array.isArray(tmpRows) || tmpRows.length === 0)
		{
			return null;
		}
		// CustomerVisible=0 rows are internal-only (IDCustomer 1 sessions see
		// everything); the Dashboard entity uses Name (house convention) —
		// downstream consumers (chooser template, registerDashboard) read
		// Title.
		const tmpVisible = tmpRows
			.filter((pRow) => pRow.CustomerVisible == 1 || pCustomerID == 1)
			.map((pRow) => this._normalizeRegistryRow(pRow));
		if (tmpVisible.length === 0)
		{
			return null;
		}
		return { Dashboards: tmpVisible };
	}

	/**
	 * Shape a Dashboard registry row the way the wiring code expects: Name → Title, and List-mode config (Mode/Entity/
	 * ListColumns/SearchFields/ScopeFilter) hoisted from the DataSource bag back to the entry root.
	 *
	 * @param {Record<string, any>} pRow
	 * @return {Record<string, any>}
	 */
	_normalizeRegistryRow(pRow)
	{
		const tmpEntry = Object.assign({}, pRow, { Title: pRow.Name || pRow.Hash });
		if (typeof tmpEntry.DataSource === 'string')
		{
			try
			{
				tmpEntry.DataSource = JSON.parse(tmpEntry.DataSource);
			}
			catch (pError)
			{
				tmpEntry.DataSource = {};
			}
		}
		if (tmpEntry.DataSource && tmpEntry.DataSource.Mode === 'List')
		{
			Object.assign(tmpEntry, tmpEntry.DataSource);
			delete tmpEntry.DataSource;
		}
		else if (tmpEntry.DataSource && Object.keys(tmpEntry.DataSource).length === 0)
		{
			delete tmpEntry.DataSource;
		}
		return tmpEntry;
	}

	/**
	 * Put the dashboard's Description on its recordset config as `RecordSetHeaderDescription`, the line the title
	 * templates show under the title. Only when the host asks for it (`ShowDescription`), and never for a dashboard whose
	 * registry row sets `HideDescription` (at the root, or in its DataSource bag).
	 *
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {Record<string, any>} pEntry - A normalized registry row.
	 * @param {DashboardHostOptions} [pHost]
	 */
	_applyHeaderDescription(pRecordSetConfiguration, pEntry, pHost)
	{
		if (!pHost || (pHost.ShowDescription !== true) || !pEntry)
		{
			return;
		}
		const tmpDataSource = (pEntry.DataSource && typeof pEntry.DataSource === 'object') ? pEntry.DataSource : {};
		if ((pEntry.HideDescription === true) || (tmpDataSource.HideDescription === true))
		{
			return;
		}
		const tmpDescription = (typeof pEntry.Description === 'string') ? pEntry.Description.trim() : '';
		if (tmpDescription)
		{
			pRecordSetConfiguration.RecordSetHeaderDescription = tmpDescription;
		}
	}

	/**
	 * Install the dashboard-scoped styling once. Safe in any host page.
	 */
	installDashboardStyles()
	{
		if (this._dashboardStylesInstalled || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function')
		{
			return;
		}
		this._dashboardStylesInstalled = true;
		this.pict.CSSMap.addCSS('DynamicDashboardLoader-Scoped-CSS', _SCOPED_DASHBOARD_CSS, 600);
		if (typeof this.pict.CSSMap.injectCSS === 'function')
		{
			this.pict.CSSMap.injectCSS();
		}
	}

	/**
	 * Register one dashboard on demand, for a host that embeds dashboards rather than wiring them all at login.
	 * Re-registering is how a host applies a different project or role filter: the recordset config is replaced.
	 *
	 * @param {string} pHash - The dashboard hash.
	 * @param {number} pCustomerID
	 * @param {DashboardHostOptions} [pHost]
	 * @return {Promise<Record<string, any>|null>} the registered entry, or null when it can't be found or registered
	 */
	async prepareDashboard(pHash, pCustomerID, pHost)
	{
		this.installDashboardStyles();
		this._installActionColumnSuppressor();
		const tmpRows = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`Dashboards/FilteredTo/FBV~Hash~EQ~${encodeURIComponent(pHash)}/0/1`, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
		if (!Array.isArray(tmpRows) || tmpRows.length < 1)
		{
			this.log.warn(`DynamicDashboardLoader: no Dashboard registry row for ${pHash}.`);
			return null;
		}
		const tmpEntry = this._normalizeRegistryRow(tmpRows[0]);
		if (tmpEntry.Mode === 'List')
		{
			return this.registerListDashboard(tmpEntry, pCustomerID, pHost) ? tmpEntry : null;
		}
		const tmpManifest = await this.loadDashboardManifest(tmpEntry.Hash, pCustomerID);
		if (!tmpManifest)
		{
			return null;
		}
		return this.registerDashboard(tmpEntry, tmpManifest, pCustomerID, pHost) ? tmpEntry : null;
	}

	/**
	 * @param {string} pRecordSet
	 * @return {Promise<boolean>} resolves once the recordset's provider has initialized (true) or failed (false)
	 */
	whenProviderReady(pRecordSet)
	{
		return (this._providerReady && this._providerReady[pRecordSet]) || Promise.resolve(true);
	}

	/**
	 * Fetches a single DataDashboard ManifestSchema record by Hash + IDCustomer.
	 *
	 * @param {string} pHash - The dashboard hash.
	 * @param {number} pCustomerID - The IDCustomer to scope to.
	 * @return {Promise<Record<string, any> | null>} The parsed Manifest object, or null if not found.
	 */
	async loadDashboardManifest(pHash, pCustomerID)
	{
		if (!pHash || !pCustomerID)
		{
			return null;
		}
		const tmpURL = `ManifestSchemas/FilteredTo/FBV~Type~EQ~DataDashboard~FBV~Hash~EQ~${encodeURIComponent(pHash)}~FBV~IDCustomer~EQ~${pCustomerID}/0/1`;
		const tmpRecords = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pResult);
			});
		});
		if (!Array.isArray(tmpRecords) || tmpRecords.length === 0)
		{
			this.log.warn(`DynamicDashboardLoader: no ManifestSchema record found for Hash=${pHash} IDCustomer=${pCustomerID}.`);
			return null;
		}
		const tmpRecord = tmpRecords[0];
		let tmpManifest = tmpRecord.Manifest;
		if (typeof tmpManifest === 'string')
		{
			try
			{
				tmpManifest = JSON.parse(tmpManifest);
			}
			catch (pError)
			{
				this.log.error(`DynamicDashboardLoader: Manifest field of ManifestSchema ${tmpRecord.IDManifestSchema} could not be parsed as JSON.`, { error: pError.message });
				return null;
			}
		}
		return tmpManifest;
	}

	/**
	 * Registers a single dashboard's manifest + recordset config into the running
	 * pict-section-recordset instance. Idempotent — re-registering the same
	 * dashboard overwrites the prior entries.
	 *
	 * @param {{ Hash: string, Title: string, RecordSet: string }} pDashboardEntry
	 * @param {Record<string, any>} pManifest - The pict-section-recordset manifest object.
	 * @param {number} pCustomerID - The customer this registration is scoped to.
	 */
	registerDashboard(pDashboardEntry, pManifest, pCustomerID, pHost)
	{
		if (!pDashboardEntry || !pDashboardEntry.Hash || !pDashboardEntry.RecordSet)
		{
			this.log.warn(`DynamicDashboardLoader: registerDashboard called with invalid dashboard entry.`, pDashboardEntry);
			return false;
		}
		if (!pManifest || !pManifest.Scope)
		{
			this.log.warn(`DynamicDashboardLoader: registerDashboard called for ${pDashboardEntry.Hash} with invalid manifest (missing Scope).`);
			return false;
		}
		if (pManifest.Scope !== pDashboardEntry.Hash)
		{
			this.log.warn(`DynamicDashboardLoader: manifest Scope [${pManifest.Scope}] does not match dashboard Hash [${pDashboardEntry.Hash}]; using Hash as authoritative key.`);
			pManifest.Scope = pDashboardEntry.Hash;
		}
		// Install the Documents drill-down runtime support (tabular Templated metatemplate
		// shim + modal-content templates) once, before any dashboard form renders.
		this._installDocumentLinkSupport();

		// Keep the manifest by hash so the lake summary can run its declared GlobalSolvers
		// (config-driven aggregation — see _runAggregationSolvers).
		(this._dashboardManifests = this._dashboardManifests || {})[pManifest.Scope] = pManifest;

		const tmpRecordSet = this.pict.PictSectionRecordSet;
		if (!tmpRecordSet)
		{
			this.log.error(`DynamicDashboardLoader: PictSectionRecordSet service is not present on pict.`);
			return false;
		}

		// Register manifest into pict-section-recordset's manifest registry.
		// The MetaController's initialize() ran earlier and populated `manifests`
		// from settings.Manifests; we mirror that work for runtime entries.
		try
		{
			tmpRecordSet.generateManifestTableCells(pManifest);
		}
		catch (pError)
		{
			this.log.error(`DynamicDashboardLoader: generateManifestTableCells failed for ${pDashboardEntry.Hash}: ${pError.message || pError}`);
		}
		tmpRecordSet.manifestDefinitions[pManifest.Scope] = pManifest;
		tmpRecordSet.manifests[pManifest.Scope] = pManifest.Form ? pManifest : this.pict.newManyfest(pManifest);

		// Register the recordset config that the dashboard route will look up.
		// The pre-filter constrains every read to this dashboard's bucket records
		// for this customer; date-range filters compose on top.
		// Config-driven data source: a dashboard config may carry a DataSource block
		// (e.g. a private-data-lake table — Entity/URLPrefix/DefaultFilter/ScopeFilter).
		// Absent → the AppData AggregatedDashboardData behavior (unchanged).
		const tmpDataSource = pDashboardEntry.DataSource || null;
		const tmpDefaultFilter = (tmpDataSource && tmpDataSource.DefaultFilter) ||
			`FBV~Type~EQ~AggregatedDashboardData~FBV~AppHash~EQ~${pDashboardEntry.Hash}~FBV~IDCustomer~EQ~${pCustomerID}~FSF~CreateDate~ASC~0`;
		// When the user clicks Apply Filters, RecordSet-Filters.js's performSearch
		// rewrites the URL via RecordSetFilterURLTemplate-${pViewContext}. The
		// dashboard renders filters with ViewContext='Dashboard'. If we don't set
		// a template, the framework defaults to /PSRS/<rs>/Dashboard/FilteredTo/...
		// which (a) routes away from our SpecificDashboard form-mode render and
		// (b) drops the scope pre-filter. Pin the URL template back to
		// SpecificDashboard with the scope filter baked in — FilterExperience
		// (user-added clauses) gets appended automatically by performSearch.
		const tmpScopeFilter = (tmpDataSource && tmpDataSource.ScopeFilter != null) ?
			tmpDataSource.ScopeFilter :
			`FBV~Type~EQ~AggregatedDashboardData~FBV~AppHash~EQ~${pDashboardEntry.Hash}`;
		// PageSize here is an aggregation CAP, not a window: the dashboard rolls up the whole
		// filter-matched set (KPIs / charts / per-day table), so we pull all of it up to this
		// many rows. Config-driven via the DataSource (default 5000); real filter sets sit
		// under it → one page, pagination hidden, while a larger set paginates as a natural
		// "refine your filter" signal. Reused for filter-apply re-nav (performSearch), so the
		// cap survives filtering.
		const tmpDashboardPageSize = (tmpDataSource && tmpDataSource.PageSize) || 1000;
		const tmpDashboardURLTemplate = (pHost && pHost.URLTemplate) ||
			`/PSRS/${pDashboardEntry.RecordSet}/SpecificDashboard/${pDashboardEntry.Hash}/FilteredTo/${encodeURIComponent(tmpScopeFilter)}/0/${tmpDashboardPageSize}`;
		const tmpRecordSetConfiguration =
		{
			'RecordSet': pDashboardEntry.RecordSet,
			'Title': pDashboardEntry.Title || pDashboardEntry.RecordSet,
			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': (tmpDataSource && tmpDataSource.Entity) || 'AppData',
			'RecordSetDefaultFilter': tmpDefaultFilter,
			'RecordSetDashboardManifestOnly': true,
			'RecordSetDashboardDefaultManifest': pDashboardEntry.Hash,
			'RecordSetDashboardManifests': [ pDashboardEntry.Hash ],
			'RecordSetFilterURLTemplate-Dashboard': tmpDashboardURLTemplate,
			'RecordSetFilterURLTemplate-Default': tmpDashboardURLTemplate,
			'AvailableVerbs': [ 'Dashboard' ],
			'RecordSetURLPrefix': (tmpDataSource && tmpDataSource.URLPrefix) || '/1.0/',
		};
		// When the manifest opts into client-side filtering with HideSchemaFilters,
		// suppress every AppData column from auto-discovery so the picker only
		// shows our manifest-declared filters (Datum.* paths, etc). This is the
		// supported way — the provider reads RecordSetIgnoreFilterFields and
		// won't fold these into _FilterSchema during initializeFilterSchema.
		if (pManifest.ClientSide && pManifest.ClientSide.Enabled && pManifest.ClientSide.HideSchemaFilters)
		{
			tmpRecordSetConfiguration.RecordSetIgnoreFilterFields = [
				'IDAppData', 'GUIDAppData', 'CreateDate', 'CreatingIDUser',
				'UpdateDate', 'UpdatingIDUser', 'Deleted', 'DeleteDate', 'DeletingIDUser',
				'IDProject', 'Type', 'Title', 'Description', 'AppHash', 'IDCustomer', 'Datum',
			];
		}

		// Lake recordsets: the PK column (ID<PhysicalTable>) starts with 'ID', so the
		// recordset filter generator (getFieldFilterClauses) misreads it as a foreign
		// key and builds a self-join value-list whose Select2 fetch hits /1.0/<Table>s
		// — no lake URLPrefix → 404. Hide the key/audit/display columns so only the
		// business columns are offered as filters.
		if (tmpDataSource && /\/PrivateDataLake\//.test(tmpDataSource.URLPrefix || ''))
		{
			const tmpDomain = (String(tmpDataSource.URLPrefix).match(/PrivateDataLake\/([^/]+)\//) || [])[1] || '';
			const tmpPhysical = `C${pCustomerID}_${tmpDomain}_${tmpDataSource.Entity}`;
			tmpRecordSetConfiguration.RecordSetIgnoreFilterFields = [
				`ID${tmpPhysical}`, `GUID${tmpPhysical}`, 'BucketLabel', 'CreateDate', 'UpdateDate', 'Deleted',
			];
			// A lake table carries its source document id as DENORMALIZED DATA, not a
			// navigable reference. Without this the provider infers `IDDocument` is a
			// foreign key and bulk-reads the DECORATED /1.0/Documents endpoint with an
			// INN list of every distinct id on the page — a paged fan-out that fetches
			// records nothing renders and stalls the record bind. (pict-section-recordset
			// >= 1.25.10; supersedes the cacheConnectedEntityRecords monkey-patch in
			// _disableDeviceCaching for lake recordsets.)
			tmpRecordSetConfiguration.RecordSetIgnoreConnectedEntityFields = [ 'IDDocument' ];
		}

		// Apply the manifest's declarative `Filters` block to the recordset config
		// (SearchFields, QuickFilters, RecordSetIgnoreFilterFields) BEFORE the
		// provider initializes — those flow through as PSRS options.
		this._applyFilterConfigFromManifest(pManifest, tmpRecordSetConfiguration);
		// Register each Definition with FilterManager BEFORE the provider's
		// async schema init runs — PSRS folds them into the provider's
		// `_FilterSchema` during initializeFilterSchema (pict-section-recordset
		// ≥1.9.3 honours both CoreConnectionColumn-style and FilterByColumn-
		// style declarations, and the optional `RecordSet` field scopes a filter
		// to a single recordset). The host configures, PSRS renders the chrome.
		this._registerFilterDefinitions(pManifest, pDashboardEntry);
		this._applyHeaderDescription(tmpRecordSetConfiguration, pDashboardEntry, pHost);

		const tmpProvider = tmpRecordSet.loadRecordSetConfiguration(tmpRecordSetConfiguration);
		if (!tmpProvider)
		{
			this.log.error(`DynamicDashboardLoader: loadRecordSetConfiguration failed for ${pDashboardEntry.RecordSet}.`);
			return false;
		}
		// AppData.Datum is a String column holding JSON. Templates and chart
		// solvers reference Record.Data.Datum.<field> — which only works if
		// Datum is an object. Wrap getRecords to JSON.parse Datum on every
		// row before it reaches the renderer.
		this._installDatumParser(tmpProvider, pManifest.Scope);
		this._installHostFilter(tmpProvider, pHost && pHost.ExtraFilter);

		// Optional client-side filter mode: opt-in via manifest.ClientSide.Enabled.
		// Server returns scope-filtered records; user-added FilterClauses (from
		// the dashboard's Add Filters picker, including ones over Datum.* paths
		// the server can't reach via FBV) get applied locally against the parsed
		// records. Lets us expose Mix Design / Material / nested fields as
		// filterable without changing the data model.
		if (pManifest.ClientSide && pManifest.ClientSide.Enabled)
		{
			this._installClientSideFiltering(tmpProvider, pManifest, pDashboardEntry);
		}

		// Optional drill-down: register a sibling Document recordset and stamp
		// each bucket record with a DrillDownURL pointing into it. The Link
		// column in the detail table picks up that URL for its href.
		if (pManifest.DrillDown && pManifest.DrillDown.Enabled)
		{
			this._registerDrillDownRecordSet(pManifest, pDashboardEntry, pCustomerID);
			this._installDrillDownURLStamper(tmpProvider, pManifest, pDashboardEntry, pCustomerID);
		}
		// Initialize the freshly-registered provider so it can answer route requests. An embedding host renders straight
		// after registering, so it waits on whenProviderReady(); the data app wires at login and never has to.
		(this._providerReady = this._providerReady || {})[pDashboardEntry.RecordSet] = new Promise((fResolve) =>
		{
			try
			{
				if (typeof tmpProvider.initializeAsync !== 'function')
				{
					return fResolve(true);
				}
				tmpProvider.initializeAsync((pError) =>
				{
					if (pError)
					{
						this.log.error(`DynamicDashboardLoader: provider for ${pDashboardEntry.RecordSet} failed to initialize: ${pError.message || pError}`);
					}
					fResolve(!pError);
				});
			}
			catch (pError)
			{
				this.log.error(`DynamicDashboardLoader: initializeAsync threw for ${pDashboardEntry.RecordSet}: ${pError.message || pError}`);
				fResolve(false);
			}
		});
		return true;
	}

	/**
	 * AND a host's project and role filters onto every read a recordset provider makes — records, counts, inline reads,
	 * and the distinct-value reads behind filter pickers — so paging, searching and filtering can't drop them. The
	 * recordset's RecordSetDefaultFilter is only a fallback when a route names no filter, so it can't carry them.
	 * Re-registering a dashboard replaces the filter; an empty one turns the wrapper into a pass-through.
	 *
	 * @param {any} pProvider - The recordset provider.
	 * @param {string} [pExtraFilter] - Meadow filter clauses.
	 */
	_installHostFilter(pProvider, pExtraFilter)
	{
		if (!pProvider)
		{
			return;
		}
		const tmpNewHostFilter = pExtraFilter || '';
		if (pProvider._headlightHostFilterInstalled && pProvider._HeadlightHostFilter !== tmpNewHostFilter)
		{
			// Distinct values cached under the old host filter no longer apply.
			pProvider._scopeDistinctCache = {};
		}
		pProvider._HeadlightHostFilter = tmpNewHostFilter;
		if (pProvider._headlightHostFilterInstalled)
		{
			return;
		}
		pProvider._headlightHostFilterInstalled = true;
		const fWithHostFilter = (pFilterString) =>
		{
			const tmpHostFilter = pProvider._HeadlightHostFilter;
			if (!tmpHostFilter)
			{
				return pFilterString;
			}
			return (pFilterString && String(pFilterString).length > 0) ? `${tmpHostFilter}~${pFilterString}` : tmpHostFilter;
		};
		for (const tmpMethod of [ 'getRecords', 'getDecoratedRecords', 'getRecordSetCount' ])
		{
			if (typeof pProvider[tmpMethod] === 'function')
			{
				const fOriginal = pProvider[tmpMethod].bind(pProvider);
				pProvider[tmpMethod] = (pOptions, ...pRest) => fOriginal(Object.assign({}, pOptions, { FilterString: fWithHostFilter(pOptions && pOptions.FilterString) }), ...pRest);
			}
		}
		if (typeof pProvider.getRecordsInline === 'function')
		{
			const fOriginalInline = pProvider.getRecordsInline.bind(pProvider);
			pProvider.getRecordsInline = (pFilterString, ...pRest) => fOriginalInline(fWithHostFilter(pFilterString), ...pRest);
		}
		if (typeof pProvider.getRecordSetColumnDistinct === 'function')
		{
			const fOriginalDistinct = pProvider.getRecordSetColumnDistinct.bind(pProvider);
			pProvider.getRecordSetColumnDistinct = (pColumn, pOptions, fCallback, ...pRest) =>
			{
				let tmpOptions = pOptions;
				let tmpCallback = fCallback;
				if (typeof tmpOptions === 'function')
				{
					tmpCallback = tmpOptions;
					tmpOptions = {};
				}
				tmpOptions = tmpOptions || {};
				// The provider caches under `Column::<Filter>` using the filter it receives, which here
				// carries the host prefix. The recordset views peek at `_scopeDistinctCache` with the key
				// built from the filter THEY passed, and re-mount from the callback until that peek hits —
				// so mirror the result under the caller's key too, or they recurse forever.
				const tmpCallerKey = tmpOptions.Filter ? `${pColumn}::${tmpOptions.Filter}` : pColumn;
				return fOriginalDistinct(pColumn, Object.assign({}, tmpOptions, { Filter: fWithHostFilter(tmpOptions.Filter) }),
					(pError, pValues, ...pCallbackRest) =>
					{
						pProvider._scopeDistinctCache = pProvider._scopeDistinctCache || {};
						pProvider._scopeDistinctCache[tmpCallerKey] = Array.isArray(pValues) ? pValues : [];
						if (typeof tmpCallback === 'function')
						{
							return tmpCallback(pError, pValues, ...pCallbackRest);
						}
					}, ...pRest);
			};
		}
	}

	/**
	 * Wrap a recordset provider's `getRecords` so the Datum field on every
	 * returned record is a parsed object instead of a JSON string. Also stashes
	 * the parsed records and a per-dashboard summary aggregate at hyphen-free
	 * AppData addresses so form-mode KPI ValueSolvers / chart solvers can
	 * reference them as bare identifiers (expression parser cannot handle
	 * hyphenated property names like `PSRS-Dashboard-Data`).
	 *
	 * Idempotent — a second install on the same provider is a no-op.
	 *
	 * @param {any} pProvider - The recordset provider from loadRecordSetConfiguration.
	 * @param {string} pDashboardHash - The dashboard hash (manifest Scope) this provider serves.
	 */

	/**
	 * Apply the manifest's declarative `Filters` block to the recordset config
	 * object before `loadRecordSetConfiguration` runs, so SearchFields /
	 * QuickFilters / IgnoreFields are present when the provider initializes.
	 *
	 *   Filters: {
	 *     SearchFields: ['MixDesign', 'JMF'],
	 *     QuickFilters: ['BucketDate', 'IDProject', 'MixDesign'],
	 *     Definitions: { ... },          // ← handed off to _registerFilterDefinitions
	 *     IgnoreFields: ['BucketLabel', 'Result']
	 *   }
	 *
	 * Definitions themselves are NOT consumed here — they flow through
	 * `_registerFilterDefinitions` → FilterManager → PSRS's _FilterSchema fold-in.
	 * Safe no-op when `pManifest.Filters` is missing.
	 *
	 * @param {Record<string, any>} pManifest
	 * @param {Record<string, any>} pRecordSetConfiguration - mutated in place.
	 */
	_applyFilterConfigFromManifest(pManifest, pRecordSetConfiguration)
	{
		const tmpFilters = pManifest && pManifest.Filters;
		if (!tmpFilters || typeof tmpFilters !== 'object') return;
		if (Array.isArray(tmpFilters.SearchFields) && tmpFilters.SearchFields.length > 0)
		{
			pRecordSetConfiguration.SearchFields = tmpFilters.SearchFields.slice();
		}
		if (Array.isArray(tmpFilters.QuickFilters) && tmpFilters.QuickFilters.length > 0)
		{
			pRecordSetConfiguration.QuickFilters = tmpFilters.QuickFilters.slice();
		}
		if (Array.isArray(tmpFilters.IgnoreFields) && tmpFilters.IgnoreFields.length > 0)
		{
			const tmpExisting = Array.isArray(pRecordSetConfiguration.RecordSetIgnoreFilterFields) ?
				pRecordSetConfiguration.RecordSetIgnoreFilterFields :
				[];
			pRecordSetConfiguration.RecordSetIgnoreFilterFields = Array.from(new Set([ ...tmpExisting, ...tmpFilters.IgnoreFields ]));
		}
		// Project each Definition into RecordSetFieldFilterClauses[column].
		// PSRS reads this map in `getFieldFilterClauses` and uses the supplied
		// clause array INSTEAD OF auto-generating StringMatch / StringRange
		// clauses for that column — which is why our DateRange clause on
		// BucketDate would otherwise lose to the auto-emitted StringMatch
		// pair on a column the schema endpoint reports as `type: "string"`,
		// and why our InternalJoinSelectedValueList picker clauses on
		// IDProject / Product / MixDesign / JMF / Material would otherwise
		// sit next to an auto-emitted StringMatch entry that the popover
		// surfaces as a plain text input.
		const tmpDefs = tmpFilters.Definitions;
		if (tmpDefs && typeof tmpDefs === 'object')
		{
			const tmpFieldClauses = (pRecordSetConfiguration.RecordSetFieldFilterClauses &&
				typeof pRecordSetConfiguration.RecordSetFieldFilterClauses === 'object') ?
				pRecordSetConfiguration.RecordSetFieldFilterClauses :
				(pRecordSetConfiguration.RecordSetFieldFilterClauses = {});
			for (const tmpKey of Object.keys(tmpDefs))
			{
				const tmpDef = tmpDefs[tmpKey];
				if (!tmpDef || !tmpDef.Type || !tmpDef.FilterByColumn) continue;
				const tmpClause = Object.assign({}, tmpDef);
				if (!tmpClause.FilterKey) tmpClause.FilterKey = tmpDef.FilterByColumn;
				if (!tmpClause.ClauseKey)
				{
					tmpClause.ClauseKey = (tmpDef.Type === 'DateRange' || tmpDef.Type === 'NumericRange' || tmpDef.Type === 'StringRange') ?
						`${tmpDef.FilterByColumn}_Range` :
						`${tmpDef.FilterByColumn}_Match`;
				}
				if (!tmpClause.Label) tmpClause.Label = tmpClause.DisplayName || tmpKey;
				if (tmpClause.Ordinal == null) tmpClause.Ordinal = 1;
				tmpFieldClauses[tmpDef.FilterByColumn] = [ tmpClause ];
			}
		}
	}

	/**
	 * Register each `Filters.Definitions` entry with FilterManager. PSRS folds
	 * the resulting filters into the recordset's `_FilterSchema` during the
	 * provider's `initializeFilterSchema` pass (1.9.3+ recognises plain
	 * FilterByColumn-style filters and the optional per-recordset `RecordSet`
	 * scope).
	 *
	 *   Definitions: {
	 *     BucketDate: { Type: 'DateRange', FilterByColumn: 'BucketDate',
	 *                   DisplayName: 'Date', MinimumLabel: 'From', MaximumLabel: 'To' },
	 *     IDProject:  { Type: 'StringMatch', FilterByColumn: 'IDProject',
	 *                   DisplayName: 'Project',
	 *                   PictForm: { InputType: 'Picker', Entity: 'WalbecMoistureProjects',
	 *                               ValueField: 'IDProject', LabelField: 'ProjectName' } },
	 *     Product:    { ... }
	 *   }
	 *
	 * Each registered clause is stamped with `RecordSet` from the dashboard
	 * entry so PSRS only folds it into the matching provider — three lake
	 * dashboards can register a `Project` filter pointing at three different
	 * Picker entities without cross-pollination. Errors are logged but never
	 * thrown — a single bad filter shouldn't block dashboard registration.
	 *
	 * Legacy `FilterCriteria.Default` arrays are still consumed for back-compat
	 * with older manifests that pre-date the `Filters.Definitions` shape.
	 *
	 * @param {Record<string, any>} pManifest
	 * @param {{ Hash:string, RecordSet:string }} pDashboardEntry
	 */
	_registerFilterDefinitions(pManifest, pDashboardEntry)
	{
		try
		{
			const tmpFilterMgr = this.pict.providers.FilterManager;
			if (!tmpFilterMgr || typeof tmpFilterMgr.addFilter !== 'function') return;
			const tmpRecordSet = pDashboardEntry.RecordSet;
			const tmpDefinitions = (pManifest.Filters && pManifest.Filters.Definitions) || {};
			for (const tmpKey of Object.keys(tmpDefinitions))
			{
				const tmpDef = tmpDefinitions[tmpKey];
				if (!tmpDef || !tmpDef.Type) continue;
				const tmpClone = Object.assign({}, tmpDef);
				if (!tmpClone.FilterKey) tmpClone.FilterKey = tmpKey;
				if (!tmpClone.DisplayName) tmpClone.DisplayName = tmpClone.Label || tmpKey;
				// Per-dashboard scope: only fold into the matching recordset.
				if (!tmpClone.RecordSet) tmpClone.RecordSet = tmpRecordSet;
				// Namespace the FilterManager key by RecordSet so a second
				// dashboard registering the same Definition key doesn't clobber
				// the first (FilterManager.filters is global).
				const tmpRegistrationKey = `${tmpRecordSet}::${tmpKey}`;
				tmpFilterMgr.addFilter(tmpRegistrationKey, tmpClone);
			}
			// Legacy FilterCriteria.Default — back-compat for manifests pre-Filters.Definitions.
			const tmpLegacyDefs = (pManifest.FilterCriteria && pManifest.FilterCriteria.Default) || [];
			if (Array.isArray(tmpLegacyDefs))
			{
				for (let tmpIndex = 0; tmpIndex < tmpLegacyDefs.length; tmpIndex++)
				{
					const tmpDef = tmpLegacyDefs[tmpIndex];
					if (!tmpDef || !tmpDef.Type) continue;
					if (tmpDefinitions[tmpDef.FilterKey || tmpDef.FilterByColumn]) continue;
					const tmpClone = Object.assign({}, tmpDef);
					if (!tmpClone.DisplayName) tmpClone.DisplayName = tmpClone.Label || tmpClone.FilterKey || `legacy_${tmpIndex}`;
					if (!tmpClone.RecordSet) tmpClone.RecordSet = tmpRecordSet;
					const tmpKey = tmpClone.FilterKey || `${pManifest.Scope}_${tmpDef.Type}_${tmpDef.FilterByColumn || tmpIndex}`;
					tmpFilterMgr.addFilter(`${tmpRecordSet}::${tmpKey}`, tmpClone);
				}
			}
		}
		catch (pError)
		{
			this.log.warn(`DynamicDashboardLoader: failed to register filters for ${pDashboardEntry.Hash}: ${pError.message || pError}`);
		}
	}

	_installDatumParser(pProvider, pDashboardHash)
	{
		if (!pProvider || pProvider._datumParserInstalled)
		{
			return;
		}
		const tmpParseInPlace = (pRecords) =>
		{
			if (!Array.isArray(pRecords)) return;
			for (const tmpRecord of pRecords)
			{
				if (tmpRecord && typeof tmpRecord.Datum === 'string')
				{
					try
					{
						tmpRecord.Datum = JSON.parse(tmpRecord.Datum);
					}
					catch (pError)
					{
						// leave as-is; render renders empty rather than crashing
					}
				}
			}
		};

		const tmpStash = (pRecords) =>
		{
			if (!Array.isArray(pRecords)) return;
			// Document-form rendering elsewhere mutates DataBroker.marshalDestination
			// to a deep path (e.g. AppData.DocumentData.ReportData.FormData) and
			// never restores it. Chart / ValueSolver expressions then resolve bare
			// identifiers (WalbecRecords, WalbecSummary) against that stale scope
			// and find nothing. Reset here as well as in the chooser/route render —
			// covers direct-URL loads and back-button navigation.
			try
			{
				this.pict.providers.DataBroker.marshalDestination = 'AppData';
			}
			catch (pErr)
			{/* DataBroker may not be present */}
			// Charts and the detail table both want chronological order. The server
			// returns records sorted by ID/CreateDate which doesn't match the actual
			// bucket date (especially across day-rollover or republished buckets).
			// Sort in place by Datum.BucketDate ascending.
			pRecords.sort((pA, pB) =>
			{
				const tmpA = (pA && pA.Datum && pA.Datum.BucketDate) || '';
				const tmpB = (pB && pB.Datum && pB.Datum.BucketDate) || '';
				return tmpA < tmpB ? -1 : tmpA > tmpB ? 1 : 0;
			});
			// Hyphen-free aliases for expression-parser access. Only one dashboard
			// renders at a time, so a single shared slot is fine.
			this.pict.AppData.WalbecRecords = pRecords;
			this.pict.AppData.WalbecActiveDashboard = pDashboardHash;
			try
			{
				this.pict.AppData.WalbecSummary = this._computeDashboardSummary(pDashboardHash, pRecords);
			}
			catch (pError)
			{
				this.log.warn(`DynamicDashboardLoader: summary compute failed for ${pDashboardHash}: ${pError.message || pError}`);
				this.pict.AppData.WalbecSummary = {};
			}
			try
			{
				const tmpFirst = pRecords[0] && pRecords[0].Datum;
				const tmpDatumType = typeof tmpFirst;
				const tmpKeys = (tmpFirst && tmpDatumType === 'object') ? Object.keys(tmpFirst).slice(0, 8) : [];
				this.log.info(`DynamicDashboardLoader: stashed ${pRecords.length} record(s) for ${pDashboardHash}; Datum type=${tmpDatumType}, keys=${JSON.stringify(tmpKeys)}, summary=${JSON.stringify(this.pict.AppData.WalbecSummary)}`);
			}
			catch (pErr)
			{/* logging only */}
		};

		// Wrap getRecords (the primary fetch entry point on MeadowEndpoints
		// providers) to JSON-parse Datum before the result reaches callers.
		const tmpOriginalGetRecords = pProvider.getRecords.bind(pProvider);
		pProvider.getRecords = async (pOptions) =>
		{
			const tmpResult = await tmpOriginalGetRecords(pOptions);
			if (tmpResult)
			{
				tmpParseInPlace(tmpResult.Records);
				tmpStash(tmpResult.Records);
			}
			return tmpResult;
		};

		// getDecoratedRecords on the base class calls `this.getRecords`, which
		// resolves through the prototype chain to our wrapped version above —
		// but we override it explicitly here so dispatch is unambiguous.
		const tmpOriginalDecorated = pProvider.getDecoratedRecords ?
			pProvider.getDecoratedRecords.bind(pProvider) :
			null;
		pProvider.getDecoratedRecords = async (pOptions) =>
		{
			const tmpResult = tmpOriginalDecorated ?
				await tmpOriginalDecorated(pOptions) :
				await pProvider.getRecords(pOptions);
			if (tmpResult)
			{
				tmpParseInPlace(tmpResult.Records);
				tmpStash(tmpResult.Records);
			}
			return tmpResult;
		};

		const tmpOriginalInline = pProvider.getRecordsInline ?
			pProvider.getRecordsInline.bind(pProvider) :
			null;
		if (tmpOriginalInline)
		{
			pProvider.getRecordsInline = async (pFilterString, pOffset, pPageSize) =>
			{
				const tmpResult = await tmpOriginalInline(pFilterString, pOffset, pPageSize);
				if (tmpResult)
				{
					tmpParseInPlace(tmpResult.Records);
					tmpStash(tmpResult.Records);
				}
				return tmpResult;
			};
		}

		pProvider._datumParserInstalled = true;
	}

	/**
	 * Register a sibling pict-section-recordset configuration that targets
	 * the Document entity, scoped to the DocumentTypes a given dashboard
	 * aggregates. Dashboard rows then drill down to it via a per-row Link cell.
	 *
	 * Manifest opt-in shape:
	 *   ClientSide.Enabled       : not strictly required, but typical
	 *   DrillDown.Enabled        : must be truthy
	 *   DrillDown.RecordSet      : recordset key (defaults to `${dashboard}Docs`)
	 *   DrillDown.DocumentTypes  : Array<string> — DocumentTypes to include
	 *   DrillDown.Title          : label shown in URL / breadcrumb
	 *   DrillDown.ListColumns    : Array<{ Key, DisplayName }> for the Document list view
	 *
	 * @param {Record<string, any>} pManifest
	 * @param {{ Hash:string, RecordSet:string, Title:string }} pDashboardEntry
	 * @param {number} pCustomerID
	 */
	_registerDrillDownRecordSet(pManifest, pDashboardEntry, pCustomerID)
	{
		const tmpDD = pManifest.DrillDown || {};
		const tmpDocsRecordSet = tmpDD.RecordSet || `${pDashboardEntry.RecordSet}Docs`;
		const tmpDocumentTypes = Array.isArray(tmpDD.DocumentTypes) ? tmpDD.DocumentTypes : [];
		if (tmpDocumentTypes.length === 0)
		{
			this.log.warn(`DynamicDashboardLoader: drill-down for ${pDashboardEntry.Hash} declared without DocumentTypes; skipping registration.`);
			return;
		}

		// Filter clause: DocumentType IN (…) + IDCustomer = N. Meadow's URL filter
		// language uses FBV with EQ for single values and FBVOR/FBV chaining for
		// OR groups. For our short DocumentType lists we OR the EQ clauses and AND
		// in the customer scope.
		const tmpDocTypeOR = tmpDocumentTypes
			.map((pT, pIdx) => (pIdx === 0 ? `FBV~DocumentType~EQ~${pT}` : `FBVOR~DocumentType~EQ~${pT}`))
			.join('~');
		const tmpScopeFilter = `${tmpDocTypeOR}~FBV~IDCustomer~EQ~${pCustomerID}`;

		const tmpListColumns = Array.isArray(tmpDD.ListColumns) && tmpDD.ListColumns.length > 0 ?
			tmpDD.ListColumns :
			[
				{ Key: 'IDDocument', DisplayName: 'ID' },
				{ Key: 'DocumentName', DisplayName: 'Name' },
				{ Key: 'DocumentType', DisplayName: 'Type' },
				{ Key: 'DocumentDate', DisplayName: 'Date' },
			];

		const tmpRecordSetConfiguration =
		{
			'RecordSet': tmpDocsRecordSet,
			'Title': tmpDD.Title || `${pDashboardEntry.Title} — Source Documents`,
			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Document',
			'RecordSetDefaultFilter': tmpScopeFilter,
			'RecordSetListColumns': tmpListColumns,
			'RecordSetIgnoreFilterFields': [ 'Deleted', 'DeletingIDUser', 'DeleteDate' ],
			'AvailableVerbs': [ 'List' ],
			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': tmpDD.SearchFields || [ 'DocumentName', 'DocumentType' ],
			// Replace the stock Actions column on document recordsets with two
			// buttons that route through HeadlightDocumentRender. The framework
			// installs `RecordSetListExtraColumnRowTemplateHash` per-recordset
			// from these templates, so customizing the Actions cell here is
			// scoped to this RecordSet only — no global template clobbering.
			'RecordSetListHasExtraColumns': true,
			'RecordSetListExtraColumnsHeaderTemplate': '<th class="has-text-centered">Document</th>',
			'RecordSetListExtraColumnRowTemplate': _walbecDocumentActionRowTemplate(),
		};

		try
		{
			this.pict.PictSectionRecordSet.loadRecordSetConfiguration(tmpRecordSetConfiguration);
			this.log.info(`DynamicDashboardLoader: registered drill-down recordset ${tmpDocsRecordSet} for ${pDashboardEntry.Hash} (DocumentTypes=${tmpDocumentTypes.join(', ')}).`);
		}
		catch (pError)
		{
			this.log.error(`DynamicDashboardLoader: failed to register drill-down recordset ${tmpDocsRecordSet}: ${pError.message || pError}`);
		}
	}

	/**
	 * Wrap the provider's stash so each parsed bucket record carries a
	 * `DrillDownURL` field pointing to the sibling Document recordset
	 * filtered to that bucket's BucketDate. The detail table's Link cell
	 * reads from this address.
	 *
	 * @param {any} pProvider
	 * @param {Record<string, any>} pManifest
	 * @param {{ Hash:string, RecordSet:string }} pDashboardEntry
	 * @param {number} pCustomerID
	 */
	_installDrillDownURLStamper(pProvider, pManifest, pDashboardEntry, pCustomerID)
	{
		const tmpDD = pManifest.DrillDown || {};
		const tmpDocsRecordSet = tmpDD.RecordSet || `${pDashboardEntry.RecordSet}Docs`;
		const tmpDocumentTypes = Array.isArray(tmpDD.DocumentTypes) ? tmpDD.DocumentTypes : [];
		if (tmpDocumentTypes.length === 0) return;

		const tmpDocTypeOR = tmpDocumentTypes
			.map((pT, pIdx) => (pIdx === 0 ? `FBV~DocumentType~EQ~${pT}` : `FBVOR~DocumentType~EQ~${pT}`))
			.join('~');

		const tmpStampOne = (pRecord) =>
		{
			if (!pRecord || !pRecord.Datum) return;
			const tmpBucketDate = pRecord.Datum.BucketDate;
			if (!tmpBucketDate) return;
			// DocumentDate values from meadow include time; LIKE-match against the
			// bucket-date prefix catches all timestamps in that calendar day. Build
			// the filter as a raw FBV string and URL-encode just once at the end.
			const tmpFilter = `${tmpDocTypeOR}~FBV~IDCustomer~EQ~${pCustomerID}~FBV~DocumentDate~LK~${tmpBucketDate}%`;
			pRecord.DrillDownURL = `#/PSRS/${tmpDocsRecordSet}/List/FilteredTo/${encodeURIComponent(tmpFilter)}`;
		};

		const tmpRewireFetchMethod = (pMethodName) =>
		{
			const tmpOriginal = pProvider[pMethodName] && pProvider[pMethodName].bind(pProvider);
			if (!tmpOriginal) return;
			pProvider[pMethodName] = async (...pArgs) =>
			{
				const tmpResult = await tmpOriginal(...pArgs);
				if (tmpResult && Array.isArray(tmpResult.Records))
				{
					for (const tmpRecord of tmpResult.Records) tmpStampOne(tmpRecord);
				}
				return tmpResult;
			};
		};
		tmpRewireFetchMethod('getRecords');
		tmpRewireFetchMethod('getDecoratedRecords');
		tmpRewireFetchMethod('getRecordsInline');
	}

	/**
	 * Mount the persistent bottom toolbar. The toolbar is a single fixed
	 * element appended to `document.body` once at boot — it never gets
	 * re-rendered by the recordset views, so we don't fight them, and we
	 * don't need a MutationObserver to keep it pinned.
	 *
	 * Updates flow through PictRouter's `after` hook: every successful route
	 * resolution triggers `_refreshBottomToolbar()`, which recomputes the
	 * left-side content (Back button + breadcrumb) and the visibility based
	 * on the current URL. Inline `onclick` attributes drive the buttons.
	 *
	 * Pagination "single-page hide" rides along on the same hook (after the
	 * recordset router finishes rendering, peek at the pagination DOM and
	 * hide the page-button UL when it has at most one entry).
	 */
	_mountBottomToolbar()
	{
		if (this._bottomToolbarMounted) return;
		this._bottomToolbarMounted = true;
		if (typeof document === 'undefined') return;

		// One-time DOM insert.
		let tmpToolbar = document.getElementById('walbec-bottom-toolbar');
		if (!tmpToolbar)
		{
			tmpToolbar = document.createElement('div');
			tmpToolbar.id = 'walbec-bottom-toolbar';
			tmpToolbar.className = 'walbec-bottom-toolbar';
			document.body.appendChild(tmpToolbar);
		}
		this._refreshBottomToolbar();

		// Trigger a refresh after every router resolution. Two channels:
		//
		//  (a) Wrap PictRouter's `navigate` so any in-app navigation fires our
		//      refresh after the framework finishes route dispatch. Function
		//      override, no event listeners.
		//
		//  (b) `window.onhashchange` / `window.onpopstate` property assignment
		//      (NOT addEventListener) catches back/forward/manual hash edits.
		//
		// Each refresh is debounced to one animation frame so a single
		// navigation doesn't run the same recompute twice if both channels fire.
		const tmpScheduleRefresh = (() =>
		{
			let tmpScheduled = false;
			return () =>
			{
				if (tmpScheduled) return;
				tmpScheduled = true;
				const tmpFrame = (typeof requestAnimationFrame === 'function') ? requestAnimationFrame : (pFn) => setTimeout(pFn, 16);
				tmpFrame(() =>
				{
					tmpScheduled = false;
					this._refreshBottomToolbar();
					this._hideSinglePagePagination();
				});
			};
		})();
		this._scheduleBottomToolbarRefresh = tmpScheduleRefresh;

		try
		{
			const tmpPictRouter = this.pict.providers.PictRouter && this.pict.providers.PictRouter.router;
			if (tmpPictRouter && typeof tmpPictRouter.navigate === 'function')
			{
				const tmpOriginalNavigate = tmpPictRouter.navigate.bind(tmpPictRouter);
				tmpPictRouter.navigate = function(...pArgs)
				{
					const tmpResult = tmpOriginalNavigate(...pArgs);
					tmpScheduleRefresh();
					return tmpResult;
				};
			}
			if (tmpPictRouter && typeof tmpPictRouter.resolve === 'function')
			{
				const tmpOriginalResolve = tmpPictRouter.resolve.bind(tmpPictRouter);
				tmpPictRouter.resolve = function(...pArgs)
				{
					const tmpResult = tmpOriginalResolve(...pArgs);
					tmpScheduleRefresh();
					return tmpResult;
				};
			}
		}
		catch (pError)
		{
			this.log.warn(`DynamicDashboardLoader: failed to wire router navigate hook for bottom toolbar: ${pError.message || pError}`);
		}

		if (typeof window !== 'undefined')
		{
			const tmpExistingHash = window.onhashchange;
			window.onhashchange = (pEvent) =>
			{
				if (typeof tmpExistingHash === 'function') tmpExistingHash(pEvent);
				tmpScheduleRefresh();
			};
			const tmpExistingPop = window.onpopstate;
			window.onpopstate = (pEvent) =>
			{
				if (typeof tmpExistingPop === 'function') tmpExistingPop(pEvent);
				tmpScheduleRefresh();
			};
		}
	}

	/**
	 * Refresh the bottom toolbar's inner HTML based on the current route.
	 * Hides the toolbar when on the chooser (no recordset list mounted).
	 */
	_refreshBottomToolbar()
	{
		const tmpToolbar = (typeof document !== 'undefined') && document.getElementById('walbec-bottom-toolbar');
		if (!tmpToolbar) return;
		const tmpHTML = this._buildBottomToolbarHTML();
		if (!tmpHTML)
		{
			tmpToolbar.style.display = 'none';
			tmpToolbar.innerHTML = '';
			return;
		}
		if (tmpToolbar.innerHTML !== tmpHTML) tmpToolbar.innerHTML = tmpHTML;
		tmpToolbar.style.display = '';
	}

	/**
	 * Single-page pagination is hidden purely via CSS (see DynamicDashboardLoader-CSS).
	 * Method retained as a no-op for any caller still wired through the route
	 * hook. Removing it entirely from the call sites is fine; this keeps the
	 * call site readable without re-routing.
	 */
	_hideSinglePagePagination()
	{
	}

	/**
	 * Compose the inner HTML of the bottom toolbar based on the current route.
	 * Returns an empty string if we shouldn't render the toolbar (e.g. on the
	 * chooser page).
	 *
	 * @return {string}
	 */
	_buildBottomToolbarHTML()
	{
		// Logout is shown on every route — it's the one control that must always
		// be reachable (chooser, custom landing, lists, dashboards).
		const tmpLogoutHTML = '' +
			'<button type="button" class="button is-small is-light" ' +
			'onclick="_Pict.providers.DynamicDashboardLoader.logout();" title="Sign out and return to the login screen">' +
			'<span class="icon"><i class="fa fa-arrow-right-from-bracket"></i></span><span>Logout</span></button>';

		const tmpContext = this._resolveDashboardRouteContext();
		if (!tmpContext)
		{
			// Chooser / custom landing / anything without dashboard context:
			// just the persistent Logout on the right.
			return `<div class="walbec-bottom-toolbar-left"></div><div class="walbec-bottom-toolbar-right">${tmpLogoutHTML}</div>`;
		}

		// Left side — back button + (optional) breadcrumb.
		let tmpLeftHTML = '';
		if (tmpContext.kind === 'dashboard')
		{
			tmpLeftHTML =
				'<a class="button is-small is-light" onclick="_Pict.views.DashboardChooser.render(); window.location.hash=\'\';" title="Back to dashboard list">' +
					'<span class="icon"><i class="fa fa-chevron-left"></i></span>' +
					'<span>Dashboards</span>' +
				'</a>';
		}
		else if (tmpContext.kind === 'documents')
		{
			const tmpBack = tmpContext.SourceURL ?
				`onclick="window.location.hash='${tmpContext.SourceURL.replace(/^#/, '')}';"` :
				'onclick="_Pict.views.DashboardChooser.render(); window.location.hash=\'\';"';
			const tmpBackLabel = tmpContext.SourceTitle || 'Dashboards';
			tmpLeftHTML =
				`<a class="button is-small is-light" ${tmpBack} title="Back to ${tmpBackLabel}">` +
					'<span class="icon"><i class="fa fa-chevron-left"></i></span>' +
					`<span>${this._escapeHTML(tmpBackLabel)}</span>` +
				'</a>';
			if (tmpContext.BreadcrumbBucket || tmpContext.SourceTitle)
			{
				tmpLeftHTML += '<nav class="breadcrumb is-small walbec-breadcrumb" aria-label="breadcrumbs"><ul>';
				tmpLeftHTML += `<li><a onclick="_Pict.views.DashboardChooser.render(); window.location.hash='';">Dashboards</a></li>`;
				if (tmpContext.SourceTitle && tmpContext.SourceURL)
				{
					tmpLeftHTML += `<li><a href="${tmpContext.SourceURL}">${this._escapeHTML(tmpContext.SourceTitle)}</a></li>`;
				}
				if (tmpContext.BreadcrumbBucket)
				{
					tmpLeftHTML += `<li class="is-active"><a aria-current="page">${this._escapeHTML(tmpContext.BreadcrumbBucket)}</a></li>`;
				}
				tmpLeftHTML += '</ul></nav>';
			}
		}

		// Right side — exports + logout. Excel = a real .xlsx, one worksheet per
		// on-screen table plus a Report Info sheet, with measurements as NUMBERS
		// rounded to each column's declared precision. CSV = the on-screen per-day
		// roll-up as text (the lossless escape hatch -- it keeps the stored string
		// untouched rather than rounding). Raw CSV = the unaggregated lake rows.
		// Print is first: on a dashboard this is the submittal action, and the CSV
		// exports are the data-wrangling ones. Only offered on an actual dashboard
		// -- there is nothing submittal-shaped about the document drill-down list.
		const tmpPrintHTML = (tmpContext.kind === 'dashboard') ? '' +
			'<button type="button" class="button is-small is-light" ' +
			'onclick="_Pict.providers.DynamicDashboardLoader.printDashboard()" title="Print this dashboard as a submittal (choose Save as PDF in the print dialog)">' +
			'<span class="icon"><i class="fa fa-print"></i></span><span>Print</span></button>' +
			'<span class="walbec-toolbar-divider"></span>' : '';

		const tmpRightHTML = '' +
			tmpPrintHTML +
			'<button type="button" class="button is-link is-small is-light" ' +
			'onclick="_Pict.providers.DashboardExporter.exportExcel()" title="Download this dashboard as an Excel workbook, one sheet per table">' +
			'<span class="icon"><i class="fa fa-file-excel"></i></span><span>Excel</span></button>' +
			'<button type="button" class="button is-small is-light" ' +
			'onclick="_Pict.providers.DashboardExporter.exportCSV()" title="Download the visible dashboard table as CSV">' +
			'<span class="icon"><i class="fa fa-file-csv"></i></span><span>CSV</span></button>' +
			'<button type="button" class="button is-small is-light" ' +
			'onclick="_Pict.providers.DashboardExporter.exportRawCSV()" title="Download the raw, unaggregated backing rows as CSV">' +
			'<span class="icon"><i class="fa fa-table"></i></span><span>Raw CSV</span></button>' +
			'<span class="walbec-toolbar-divider"></span>' +
			tmpLogoutHTML;

		return `<div class="walbec-bottom-toolbar-left">${tmpLeftHTML}</div><div class="walbec-bottom-toolbar-right">${tmpRightHTML}</div>`;
	}

	/**
	 * A readable summary of the filters currently applied, for the submittal header.
	 *
	 * This is the single most important line on a printed submittal: a page of
	 * control charts means nothing to WisDOT/MDOT unless it states WHICH mix design,
	 * WHICH site and WHICH dates it covers. Read from the live clause state rather
	 * than the URL so it reflects exactly what produced the numbers on the page.
	 *
	 * @param {string} pRecordSet - the record set the dashboard is bound to.
	 * @return {string} e.g. 'Mix Design: 506723  |  Date Sampled: 2025-10-06 to 2026-10-06'
	 */
	_resolvePrintFilterSummary(pRecordSet)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || (typeof tmpProvider.getFilterClauses !== 'function')) { return ''; }

		const tmpParts = [];
		for (const tmpClause of (tmpProvider.getFilterClauses() || []))
		{
			const tmpField = tmpClause.FilterByColumn || String(tmpClause.QuickFilterKey || '').replace(/^Quick-/, '');
			// The clause carries the label the user actually sees, which is the
			// customer's own wording ("Mix Design", not the column name MixDesign) --
			// and on a submittal that distinction is the difference between a
			// readable cover line and a dump of internal field names. Do NOT reach
			// for getQuickFilterDefinitions() here: it is populated by the filter
			// view's render pass and is empty at print time.
			const tmpLabel = tmpClause.Label || tmpClause.DisplayName || tmpField;
			const tmpValues = tmpClause.Values;
			if (Array.isArray(tmpValues))
			{
				if (tmpValues.length > 0) { tmpParts.push(`${tmpLabel}: ${tmpValues.join(', ')}`); }
			}
			else if (tmpValues && (typeof tmpValues === 'object'))
			{
				// A date range prints as its bounds, with an open end said out loud
				// rather than left blank -- "from X" and "X to Y" cover different data.
				const tmpStart = tmpValues.Start || '';
				const tmpEnd = tmpValues.End || '';
				if (tmpStart && tmpEnd) { tmpParts.push(`${tmpLabel}: ${tmpStart} to ${tmpEnd}`); }
				else if (tmpStart) { tmpParts.push(`${tmpLabel}: from ${tmpStart}`); }
				else if (tmpEnd) { tmpParts.push(`${tmpLabel}: through ${tmpEnd}`); }
			}
			else if (tmpValues) { tmpParts.push(`${tmpLabel}: ${tmpValues}`); }
		}
		return tmpParts.join('   |   ');
	}

	/**
	 * Print the current dashboard as a submittal.
	 *
	 * Built fresh at print time and torn down afterwards, deliberately: the record
	 * set re-renders its container on every search, so a header injected once would
	 * be wiped by the next filter change and silently print stale filter text on a
	 * document that goes to a DOT.
	 */
	printDashboard()
	{
		if (typeof document === 'undefined') { return; }
		const tmpContext = this._resolveDashboardRouteContext();
		const tmpContainer = document.getElementById('PRSP_Container');
		if (!tmpContainer) { return; }

		const tmpTitleElement = document.getElementById('PRSP_Title');
		const tmpTitle = (tmpTitleElement && tmpTitleElement.textContent.trim()) || 'Dashboard';
		const tmpSummary = tmpContext ? this._resolvePrintFilterSummary(tmpContext.RecordSet) : '';
		// The on-screen title row is hidden in print (its title would duplicate the
		// one above), so the record count it carries is lifted into the header --
		// a submittal has to say how many samples it covers.
		let tmpScope = '';
		const tmpTitleContainer = document.getElementById('PRSP_Title_Container');
		if (tmpTitleContainer)
		{
			const tmpMatch = tmpTitleContainer.textContent.match(/Showing[^.]*\./);
			if (tmpMatch) { tmpScope = tmpMatch[0].trim(); }
		}
		const tmpGenerated = new Date();
		const tmpStamp = `${tmpGenerated.getFullYear()}-${String(tmpGenerated.getMonth() + 1).padStart(2, '0')}-${String(tmpGenerated.getDate()).padStart(2, '0')}`;

		// Remove any leftover from an earlier print that never cleaned up.
		const tmpExisting = document.getElementById('WalbecPrintHead');
		if (tmpExisting && tmpExisting.parentElement) { tmpExisting.parentElement.removeChild(tmpExisting); }

		const tmpHead = document.createElement('div');
		tmpHead.id = 'WalbecPrintHead';
		tmpHead.className = 'walbec-printhead';
		tmpHead.innerHTML =
			`<div class="walbec-printhead-title">${this._escapeHTML(tmpTitle)}</div>` +
			(tmpSummary ? `<div class="walbec-printhead-filters">${this._escapeHTML(tmpSummary)}</div>`
				: '<div class="walbec-printhead-filters walbec-printhead-unfiltered">No filters applied &mdash; this report covers ALL records.</div>') +
			`<div class="walbec-printhead-stamp">${tmpScope ? this._escapeHTML(tmpScope) + '  &middot;  ' : ''}Generated ${tmpStamp}</div>`;
		tmpContainer.insertBefore(tmpHead, tmpContainer.firstChild);

		// The browser uses document.title for the PDF filename and the page header,
		// so a submittal saves as something meaningful instead of "HeadLight Data App".
		const tmpPreviousTitle = document.title;
		const tmpFilenameBits = [ tmpTitle.replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, ''), tmpStamp ];
		document.title = tmpFilenameBits.join('_');

		const fCleanup = () =>
		{
			document.title = tmpPreviousTitle;
			const tmpPlanted = document.getElementById('WalbecPrintHead');
			if (tmpPlanted && tmpPlanted.parentElement) { tmpPlanted.parentElement.removeChild(tmpPlanted); }
			window.removeEventListener('afterprint', fCleanup);
		};
		window.addEventListener('afterprint', fCleanup);
		// afterprint does not fire on every cancel path in every browser, so the
		// page must not be left with a print header stuck to it.
		setTimeout(fCleanup, 60000);

		window.print();
	}

	/**
	 * Sign the current user out by calling `/1.0/Deauthenticate` on the data
	 * API, then reload the page so the login splash takes over. The Deauth
	 * endpoint accepts both GET and POST in our environments — use GET via
	 * the existing rest client so any per-host headers (X-Upstream, etc.)
	 * still apply. Falls back to a credentialed `fetch` if the rest client
	 * isn't available.
	 *
	 * Provided here on the loader because it's the natural home for the
	 * bottom-toolbar wiring; views call it via `_Pict.providers.DynamicDashboardLoader.logout()`.
	 */
	logout()
	{
		const tmpFinish = () =>
		{
			try
			{
				if (typeof window !== 'undefined' && window.location)
				{
					window.location.hash = '';
					window.location.reload();
				}
			}
			catch (pError)
			{/* navigation race — login splash will take over */}
		};

		try
		{
			const tmpClient = this.pict && this.pict.HeadlightRestClient;
			if (tmpClient && typeof tmpClient.getJSON === 'function')
			{
				tmpClient.getJSON('Deauthenticate', () => tmpFinish());
				return;
			}
		}
		catch (pError)
		{/* fall through to fetch */}

		if (typeof fetch === 'function')
		{
			fetch('/1.0/Deauthenticate', { credentials: 'include' })
				.catch(() =>
				{/* still log out locally */})
				.finally(() => tmpFinish());
			return;
		}
		tmpFinish();
	}

	/**
	 * Inspect the current URL hash and return a structured description of what
	 * the user is looking at. Used by the bottom toolbar to choose between
	 * "Back to Dashboards" and "Back to {Source Dashboard}" + breadcrumb.
	 *
	 * @return {{ kind:'dashboard'|'documents', RecordSet:string, SourceTitle?:string, SourceURL?:string, BreadcrumbBucket?:string } | null}
	 */
	_resolveDashboardRouteContext()
	{
		if (typeof window === 'undefined' || !window.location) return null;
		const tmpHash = window.location.hash || '';
		const tmpDashboardMatch = tmpHash.match(/^#\/PSRS\/([^\/]+)\/SpecificDashboard\/([^\/]+)/);
		if (tmpDashboardMatch)
		{
			return { kind: 'dashboard', RecordSet: tmpDashboardMatch[1], DashboardHash: tmpDashboardMatch[2] };
		}
		const tmpListMatch = tmpHash.match(/^#\/PSRS\/([^\/]+)\/List/);
		if (tmpListMatch)
		{
			const tmpRecordSet = tmpListMatch[1];
			// Try to map this Document recordset back to its source dashboard
			// so the user sees a meaningful "back" target. The drill-down sibling
			// is typically named `${SourceRecordSet}Docs`.
			const tmpResolved = { kind: 'documents', RecordSet: tmpRecordSet };
			const tmpSourceDashboard = this._findSourceDashboardForDocumentRecordSet(tmpRecordSet);
			if (tmpSourceDashboard)
			{
				tmpResolved.SourceTitle = tmpSourceDashboard.Title;
				const tmpScope = `FBV~Type~EQ~AggregatedDashboardData~FBV~AppHash~EQ~${tmpSourceDashboard.Hash}`;
				tmpResolved.SourceURL = `#/PSRS/${tmpSourceDashboard.RecordSet}/SpecificDashboard/${tmpSourceDashboard.Hash}/FilteredTo/${encodeURIComponent(tmpScope)}`;
			}
			// Sniff out the bucket date from the URL filter — drill-down stamps
			// `DocumentDate~LK~YYYY-MM-DD%` and we mirror that text into the
			// breadcrumb so the user knows which bucket spawned the list.
			const tmpDateMatch = tmpHash.match(/DocumentDate~LK~(\d{4}-\d{2}-\d{2})/);
			if (tmpDateMatch)
			{
				tmpResolved.BucketDate = tmpDateMatch[1];
				tmpResolved.BreadcrumbBucket = `Documents for ${tmpDateMatch[1]}`;
			}
			return tmpResolved;
		}
		return null;
	}

	/**
	 * Map a Document-list recordset back to the dashboard it drilled in from.
	 * Looks at every registered AvailableDashboards entry and matches by the
	 * `DrillDown.RecordSet` field on its loaded ManifestSchema.
	 *
	 * @param {string} pRecordSet
	 * @return {{ Hash:string, Title:string, RecordSet:string } | null}
	 */
	_findSourceDashboardForDocumentRecordSet(pRecordSet)
	{
		const tmpAvail = this.pict.AppData && this.pict.AppData.AvailableDashboards;
		if (!tmpAvail || !Array.isArray(tmpAvail.Dashboards)) return null;
		for (const tmpEntry of tmpAvail.Dashboards)
		{
			if (tmpEntry.Mode === 'List') continue;
			const tmpManifest = this.pict.PictSectionRecordSet &&
				this.pict.PictSectionRecordSet.manifestDefinitions &&
				this.pict.PictSectionRecordSet.manifestDefinitions[tmpEntry.Hash];
			if (!tmpManifest || !tmpManifest.DrillDown) continue;
			const tmpDocsRS = tmpManifest.DrillDown.RecordSet || `${tmpEntry.RecordSet}Docs`;
			if (tmpDocsRS === pRecordSet)
			{
				return { Hash: tmpEntry.Hash, Title: tmpEntry.Title, RecordSet: tmpEntry.RecordSet };
			}
		}
		return null;
	}

	/**
	 * Tiny escape — used only in template strings the toolbar pastes into
	 * innerHTML, so we cover the structurally dangerous chars.
	 *
	 * @param {string} pStr
	 */
	_escapeHTML(pStr)
	{
		return String(pStr == null ? '' : pStr)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	/**
	 * Register a List-mode "dashboard" — really a server-side recordset list
	 * (Documents). No ManifestSchema fetch, no client-side fu, just a clean
	 * RecordSetListColumns config so users can browse and filter the data via
	 * the standard pict-section-recordset list UI.
	 *
	 * `DashboardManifests` and `RecordDecoration` are what a recordset needs to be more than
	 * a flat browse: the manifests its Dashboard verb can render, and the related-entity
	 * pulls that decorate each row. They used to be reachable only from the app's hard-coded
	 * `DefaultRecordSetConfigurations`, which is why a per-customer landing recordset had to
	 * be compiled into the app. Both are optional and default to today's behaviour.
	 *
	 * There is deliberately no `Verbs` key. `AvailableVerbs` is not read by anything in
	 * pict-section-recordset -- `RecordSet-Router` registers List/Read/Create/Dashboard/
	 * Associate unconditionally for every recordset -- so accepting one here would be a
	 * config key that silently does nothing. Which verb a dashboard opens is decided by the
	 * route the chooser navigates to, not by this configuration.
	 *
	 * @param {{ Hash:string, Title:string, RecordSet:string, Entity?:string, ScopeFilter?:string, ListColumns?:Array, SearchFields?:Array, Filters?:Record<string, any>, DashboardManifests?:Array<string>, RecordDecoration?:Array<Object>, HideRowActions?:boolean }} pEntry
	 * @param {number} pCustomerID
	 */
	registerListDashboard(pEntry, pCustomerID, pHost)
	{
		if (!pEntry || !pEntry.RecordSet || !pEntry.Entity)
		{
			this.log.warn(`DynamicDashboardLoader: registerListDashboard called with invalid entry — Entity required.`);
			return false;
		}
		const tmpRecordSet = this.pict.PictSectionRecordSet;
		if (!tmpRecordSet)
		{
			this.log.error(`DynamicDashboardLoader: PictSectionRecordSet service is not present on pict.`);
			return false;
		}
		// PrivateDataLake tables sit behind the lake proxy and have NO IDCustomer
		// column (the C<n>_ table-name prefix IS the customer silo); customer
		// scope comes from the registration row's row-auth. Platform entities
		// (Document, …) at /1.0/ keep the IDCustomer scope clause. List mode is
		// the only server-paginated browse path, so lake tables too big to pull
		// client-side (the manifest/aggregate path) rely on it.
		const tmpURLPrefix = pEntry.URLPrefix || '/1.0/';
		const tmpIsLake = /\/PrivateDataLake\//.test(tmpURLPrefix);
		const tmpScopeBase = tmpIsLake ?
			(pEntry.ScopeFilter || '') :
			(pEntry.ScopeFilter && pEntry.ScopeFilter.length > 0 ?
				`${pEntry.ScopeFilter}~FBV~IDCustomer~EQ~${pCustomerID}` :
				`FBV~IDCustomer~EQ~${pCustomerID}`);
		const tmpRecordSetConfiguration =
		{
			'RecordSet': pEntry.RecordSet,
			'Title': pEntry.Title || pEntry.RecordSet,
			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': pEntry.Entity,
			'RecordSetDefaultFilter': tmpScopeBase,
			'RecordSetListColumns': pEntry.ListColumns || [],
			'RecordSetIgnoreFilterFields': [ 'Deleted', 'DeletingIDUser', 'DeleteDate' ],
			'AvailableVerbs': [ 'List' ],
			'RecordSetURLPrefix': tmpURLPrefix,
			'SearchFields': pEntry.SearchFields || [ 'Name' ],
		};
		// Set only when supplied. An empty array is not the same as absent to
		// pict-section-recordset, so assigning unconditionally would hand every list-mode
		// dashboard an empty manifest list and an empty decoration list.
		if (Array.isArray(pEntry.DashboardManifests) && pEntry.DashboardManifests.length > 0)
		{
			tmpRecordSetConfiguration.RecordSetDashboardManifests = pEntry.DashboardManifests;
		}
		if (Array.isArray(pEntry.RecordDecoration) && pEntry.RecordDecoration.length > 0)
		{
			tmpRecordSetConfiguration.RecordDecorationConfiguration = pEntry.RecordDecoration;
		}
		if (pEntry.HideRowActions === true)
		{
			tmpRecordSetConfiguration.RecordSetListHideRowActions = true;
		}
		// A `Filters` block works as it does on a manifest dashboard (SearchFields, QuickFilters, IgnoreFields, Definitions).
		if (pEntry.Filters && typeof pEntry.Filters === 'object')
		{
			this._applyFilterConfigFromManifest({ Filters: pEntry.Filters }, tmpRecordSetConfiguration);
			this._registerFilterDefinitions({ Filters: pEntry.Filters }, pEntry);
		}
		// Lake list: the PK column (ID<PhysicalTable>) starts with 'ID', so the
		// recordset filter generator misreads it as a foreign key and fires a
		// Select2 value-list fetch at /1.0/<Table>s (no lake prefix → 404). Hide
		// the key/audit columns from filter discovery — mirrors the chart path.
		if (tmpIsLake)
		{
			const tmpDomain = (tmpURLPrefix.match(/PrivateDataLake\/([^/]+)\//) || [])[1] || '';
			const tmpPhysical = `C${pCustomerID}_${tmpDomain}_${pEntry.Entity}`;
			tmpRecordSetConfiguration.RecordSetIgnoreFilterFields = [ `ID${tmpPhysical}`, `GUID${tmpPhysical}` ];
		}
		// Document recordsets pick up the same Open / PDF action column as
		// the drill-down lists do — keeps the Actions UI consistent across
		// every Document-backed recordset on the dashboard side of the app.
		if (pEntry.Entity === 'Document')
		{
			tmpRecordSetConfiguration.RecordSetListHasExtraColumns = true;
			tmpRecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplate = '<th class="has-text-centered">Document</th>';
			tmpRecordSetConfiguration.RecordSetListExtraColumnRowTemplate = _walbecDocumentActionRowTemplate();
		}
		this._applyHeaderDescription(tmpRecordSetConfiguration, pEntry, pHost);
		try
		{
			const tmpProvider = tmpRecordSet.loadRecordSetConfiguration(tmpRecordSetConfiguration);
			this._installHostFilter(tmpProvider || this.pict.providers[`RSP-Provider-${pEntry.RecordSet}`], pHost && pHost.ExtraFilter);
			this.log.info(`DynamicDashboardLoader: registered List-mode dashboard ${pEntry.Hash} (${pEntry.RecordSet} → ${pEntry.Entity}).`);
			return true;
		}
		catch (pError)
		{
			this.log.error(`DynamicDashboardLoader: failed to register List dashboard ${pEntry.Hash}: ${pError.message || pError}`);
			return false;
		}
	}

	/**
	 * Hook the recordset list view's onBeforeRender so we can re-stamp the
	 * framework's stock Actions cell + header templates to empty whenever the
	 * route lands on one of our Document recordsets. Mirrors the approach in
	 * `ImprovedTabularRecordSetProvider.prepareTable` — no MutationObserver,
	 * just a function override on a single Pict view.
	 *
	 * Must run AFTER ImprovedTabularRecordSetProvider's hook (which is what
	 * stamps the default View template); our chain wraps theirs so we get the
	 * last word per render.
	 */
	_installActionColumnSuppressor()
	{
		if (this._actionColumnSuppressorInstalled) return;
		this._actionColumnSuppressorInstalled = true;
		const tmpView = this.pict.views && this.pict.views['PRSP-List-RecordList'];
		if (!tmpView || typeof tmpView.onBeforeRender !== 'function') return;

		const tmpOriginal = tmpView.onBeforeRender.bind(tmpView);
		tmpView.onBeforeRender = (pCallback, pRenderable) =>
		{
			tmpOriginal(pCallback, pRenderable);
			this._maybeSuppressDefaultActionColumn();
		};

		// The dashboard list view has its own stock Actions column. Same trick.
		const tmpDashboardView = this.pict.views && this.pict.views['PRSP-Dashboard-RecordList'];
		if (tmpDashboardView && typeof tmpDashboardView.onBeforeRender === 'function')
		{
			const tmpOriginalDash = tmpDashboardView.onBeforeRender.bind(tmpDashboardView);
			tmpDashboardView.onBeforeRender = (pCallback, pRenderable) =>
			{
				tmpOriginalDash(pCallback, pRenderable);
				this._maybeSuppressDefaultActionColumn();
			};
		}

		// A dashboard host renders lists in place, off the #/PSRS/ route, so remember which record set each list
		// view is about to paint; onBeforeRenderList runs just before the child views above render.
		const tmpChildViews = (this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.childViews) || {};
		for (const tmpParentView of [ tmpChildViews.list, tmpChildViews.dashboard ])
		{
			if (!tmpParentView || typeof tmpParentView.onBeforeRenderList !== 'function')
			{
				continue;
			}
			const tmpOriginalBeforeList = tmpParentView.onBeforeRenderList.bind(tmpParentView);
			tmpParentView.onBeforeRenderList = (pRecordListData) =>
			{
				this._recordSetBeingPainted = (pRecordListData && pRecordListData.RecordSet) || null;
				return tmpOriginalBeforeList(pRecordListData);
			};
		}
	}

	/**
	 * Overwrite the framework's stock Actions cell + header templates with
	 * empty strings when the list being painted is one of our Document
	 * recordsets (drill-down `*Docs` or the All Documents list), a lake
	 * recordset, or a List-mode dashboard whose record sets `HideRowActions`.
	 * Otherwise leaves them alone, so other recordsets (PhysicalAsset etc.)
	 * keep their default View link.
	 */
	_maybeSuppressDefaultActionColumn()
	{
		try
		{
			const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) || '';
			// The generic lake browser renders in place at #/Lake/... (not #/PSRS/),
			// reusing the 'LakeBrowse' recordset; match that route too.
			const tmpListMatch = tmpHash.match(/^#\/PSRS\/([^\/]+)\//);
			const tmpRouteRecordSet = tmpListMatch ? tmpListMatch[1] : (/^#\/Lake\//.test(tmpHash) ? 'LakeBrowse' : null);
			const tmpConfigurations = (this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.recordSetProviderConfigurations) || {};
			const tmpPaintedConfig = this._recordSetBeingPainted ? tmpConfigurations[this._recordSetBeingPainted] : null;
			const tmpHideRowActions = !!(tmpPaintedConfig && tmpPaintedConfig.RecordSetListHideRowActions === true);
			if (!tmpRouteRecordSet && !tmpHideRowActions)
			{
				return;
			}
			// Only the app that owns the page blanks the column by route; an embedding app keeps its own lists' View links.
			const tmpProviderConfig = (tmpRouteRecordSet && this.options.AppChrome !== false) ? tmpConfigurations[tmpRouteRecordSet] : null;
			const tmpIsDoc = !!(tmpProviderConfig && tmpProviderConfig.RecordSetMeadowEntity === 'Document');
			// PrivateDataLake recordsets (the SiteManager dashboards + the generic
			// #/Lake browser) have no working Read view — their audit columns carry
			// the full physical name, so the stock View link resolves an empty GUID
			// and routes nowhere (see follow-up #30). Suppress the action column for
			// them too; navigation is via the custom drill/back links instead.
			const tmpIsLake = !!(tmpProviderConfig && /\/PrivateDataLake\//.test(tmpProviderConfig.URLPrefix || tmpProviderConfig.RecordSetURLPrefix || ''));
			if (!tmpIsDoc && !tmpIsLake && !tmpHideRowActions)
			{
				return;
			}
			if (this.pict.TemplateProvider && typeof this.pict.TemplateProvider.addTemplate === 'function')
			{
				this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListAction-Template-Cell', '');
				this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListActions-Template-Header', '');
				this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListAction-Template-Cell', '');
				this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListActions-Template-Header', '');
			}
		}
		catch (pError)
		{
			this.log.warn(`DynamicDashboardLoader: failed to suppress default action column: ${pError.message || pError}`);
		}
	}

	/**
	 * Drop `IDDevice` from the EntityProvider's connected-entity cache list so
	 * the framework never tries to bulk-fetch Devices (or fall back to per-row
	 * Device lookups when /Devices/Count is missing on the meadow deployment).
	 *
	 * Implemented as a one-time wrap around `cacheConnectedEntityRecords` —
	 * filters `pIDListToCache` and the parallel `pEntityListToCache`, then
	 * delegates to the original. Any other connected-entity caching (User,
	 * Project, etc.) keeps working untouched.
	 */
	_skipDeviceCaching()
	{
		if (this._deviceCachingDisabled) return;
		this._deviceCachingDisabled = true;
		const tmpEP = this.pict && this.pict.EntityProvider;
		if (!tmpEP) return;
		// Drop, from connected-entity caching:
		//  - 'IDDevice' (no /Devices/Count on some deployments);
		//  - lake physical-name PKs (IDC<n>_<table>): those don't match ID<Entity>,
		//    so the framework reads the PK as a foreign key and bulk-fetches a
		//    non-existent entity → 404, which aborts the record bind (#30 / #35);
		//  - 'IDDocument': denormalized lake tables (e.g. element inspections) carry
		//    the source document id as a column. The framework reads it as an FK and
		//    bulk-fetches the DECORATED /1.0/Documents endpoint with an INN list of
		//    every distinct id — the per-row CanEdit fan-out makes that hang for tens
		//    of seconds on a large set, blocking the whole dashboard's record bind.
		//    The per-row IDDocument value still displays (and drives the doc-link
		//    action); only the pointless entity prefetch is skipped.
		const fShouldDrop = (pField) => pField === 'IDDevice' /*TODO: || pField === 'IDDocument' */ || /^IDC\d+_/.test(pField);
		// Both the with-count and without-count variants need wrapping — the list
		// path uses one, the chart/dashboard record load the other.
		const fWrapConnectedCache = (pMethodName) =>
		{
			if (typeof tmpEP[pMethodName] !== 'function') return;
			const tmpOriginal = tmpEP[pMethodName].bind(tmpEP);
			tmpEP[pMethodName] = function(pFirst, pIDList, pEntityList, pLiteRecords, fCallback)
			{
				const tmpIDs = Array.isArray(pIDList) ? pIDList : [];
				const tmpEntities = Array.isArray(pEntityList) ? pEntityList : [];
				const tmpFilteredIDs = [];
				const tmpFilteredEntities = [];
				for (let i = 0; i < tmpIDs.length; i++)
				{
					if (fShouldDrop(tmpIDs[i])) continue;
					tmpFilteredIDs.push(tmpIDs[i]);
					tmpFilteredEntities.push(tmpEntities[i]);
				}
				return tmpOriginal(pFirst, tmpFilteredIDs, tmpFilteredEntities, pLiteRecords, fCallback);
			};
		};
		fWrapConnectedCache('cacheConnectedEntityRecords');
		fWrapConnectedCache('cacheConnectedEntityRecordsWithoutCount');
	}

	/**
	 * Opt-in client-side filter mode for a dashboard.
	 *
	 * The data app's recordset filters are by default sent to meadow as FBV
	 * clauses on top-level columns. That works for genuine table columns but
	 * breaks for fields buried inside a JSON Datum blob (Mix Design, Material,
	 * BucketDate, etc.) — meadow can't reach into JSON without JSON_EXTRACT.
	 *
	 * Approach:
	 *   1. Override `_prepareFilterState` to STRIP Bundle-stored FilterClauses
	 *      before each server fetch. Server only ever sees the URL scope filter
	 *      (Type=AggregatedDashboardData & AppHash=…), so it always returns the
	 *      full dashboard cohort.
	 *   2. Wrap getRecords/getDecoratedRecords to apply the user's clauses
	 *      against the parsed records locally, supporting nested paths via
	 *      `fable.Utility.getValueByHash`.
	 *   3. Inject the dashboard's declared `ClientSide.Filters` entries into
	 *      `_FilterSchema` so they appear in the "Add Filters" picker.
	 *
	 * The opt-in keeps server-side filtering as the default for future Walbec
	 * dashboards that DO want to push down to the lake.
	 *
	 * @param {any} pProvider - The recordset provider returned from loadRecordSetConfiguration.
	 * @param {Record<string, any>} pManifest - The manifest (with optional ClientSide config).
	 * @param {{ Hash: string, RecordSet: string, Title: string }} pDashboardEntry
	 */
	_installClientSideFiltering(pProvider, pManifest, pDashboardEntry)
	{
		if (!pProvider || pProvider._clientSideFilteringInstalled)
		{
			return;
		}

		// (1) Strip user clauses before they reach the server. The Bundle still
		// holds them so the filter UI / chips render correctly; we just don't
		// forward them as FBV.
		if (typeof pProvider._prepareFilterState === 'function')
		{
			const tmpOriginal = pProvider._prepareFilterState.bind(pProvider);
			pProvider._prepareFilterState = (pEntity, pOptions, pAddr) =>
			{
				const tmpResult = tmpOriginal(pEntity, pOptions, pAddr);
				const tmpClauses = Array.isArray(tmpResult[0]) ? tmpResult[0] : [];
				// Keep only RawFilter entries (the URL scope) — drop everything
				// else; we apply the rest client-side after the response lands.
				const tmpScopeOnly = tmpClauses.filter((pC) => pC && pC.Type === 'RawFilter');
				return [ tmpScopeOnly, tmpResult[1] ];
			};
		}

		// (2) Wrap the data-fetch entry points so the user's FilterClauses get
		// applied client-side after the server returns scope-only records. The
		// existing _installDatumParser wrapper already chains through these
		// methods; we overlay the filter step on top via a second wrap.
		const tmpApplyClientFilters = (pRecords) =>
		{
			const tmpInputRecords = Array.isArray(pRecords) ? pRecords : [];
			const tmpClauses = (this.pict.Bundle && this.pict.Bundle._ActiveFilterState &&
				this.pict.Bundle._ActiveFilterState[pDashboardEntry.RecordSet] &&
				this.pict.Bundle._ActiveFilterState[pDashboardEntry.RecordSet].FilterClauses) || [];
			if (!Array.isArray(tmpClauses) || tmpClauses.length === 0)
			{
				return tmpInputRecords;
			}
			return this._applyClientFilterClauses(tmpInputRecords, tmpClauses);
		};

		const tmpRewireFetchMethod = (pMethodName) =>
		{
			const tmpOriginal = pProvider[pMethodName] && pProvider[pMethodName].bind(pProvider);
			if (!tmpOriginal) return;
			pProvider[pMethodName] = async (...pArgs) =>
			{
				const tmpResult = await tmpOriginal(...pArgs);
				if (tmpResult && Array.isArray(tmpResult.Records))
				{
					tmpResult.Records = tmpApplyClientFilters(tmpResult.Records);
					// Re-stash filtered records so KPIs / charts reflect the filter.
					try
					{
						this.pict.AppData.WalbecRecords = tmpResult.Records;
						this.pict.AppData.WalbecSummary = this._computeDashboardSummary(pManifest.Scope, tmpResult.Records);
					}
					catch (pError)
					{/* keep going on summary failure */}
				}
				return tmpResult;
			};
		};
		tmpRewireFetchMethod('getRecords');
		tmpRewireFetchMethod('getDecoratedRecords');
		tmpRewireFetchMethod('getRecordsInline');

		// Override count: server sees only scope so its count is the cohort
		// size; subtract clauses client-side and report the filtered length.
		if (typeof pProvider.getRecordSetCount === 'function')
		{
			const tmpOriginalCount = pProvider.getRecordSetCount.bind(pProvider);
			pProvider.getRecordSetCount = async (pOptions) =>
			{
				const tmpRecordsResult = await pProvider.getRecords(pOptions);
				const tmpFiltered = tmpRecordsResult && Array.isArray(tmpRecordsResult.Records) ?
					tmpRecordsResult.Records :
					[];
				// Best-effort: report total-after-filter as both count fields the
				// dashboard shell looks at. Falls back to the original on error.
				try
				{
					const tmpServerCount = await tmpOriginalCount(pOptions);
					return Object.assign({}, tmpServerCount, { Count: tmpFiltered.length });
				}
				catch (pError)
				{
					return { Count: tmpFiltered.length };
				}
			};
		}

		// (3) Inject manifest-declared filter columns into the picker schema.
		this._injectClientSideFilterSchema(pProvider, pManifest, pDashboardEntry);

		pProvider._clientSideFilteringInstalled = true;
	}

	/**
	 * Apply an array of filter clauses to a record list, returning the subset
	 * that matches all clauses. Reads field values via the manyfest hash
	 * resolver so clauses can target nested paths (e.g. `Datum.MixDesigns.0.MixDesign`).
	 *
	 * Supports the clause Types our dashboards use:
	 *   - StringMatch (ExactMatch true/false)
	 *   - DateRange / DateMatch
	 *   - NumericRange / NumericMatch
	 *   - StringRange
	 *
	 * @param {Array<Record<string, any>>} pRecords
	 * @param {Array<Record<string, any>>} pClauses
	 * @return {Array<Record<string, any>>}
	 */
	_applyClientFilterClauses(pRecords, pClauses)
	{
		if (!Array.isArray(pRecords) || !Array.isArray(pClauses)) return pRecords || [];
		const tmpUtility = this.pict && this.pict.fable && this.pict.fable.Utility;
		const tmpReadField = (pRecord, pColumn) =>
		{
			if (!pColumn) return undefined;
			if (tmpUtility && typeof tmpUtility.getValueByHash === 'function')
			{
				return tmpUtility.getValueByHash(pRecord, pColumn);
			}
			// Manual dotted-path fallback if the utility isn't reachable.
			let tmpRef = pRecord;
			for (const tmpKey of String(pColumn).split('.'))
			{
				if (tmpRef == null) return undefined;
				tmpRef = tmpRef[tmpKey];
			}
			return tmpRef;
		};
		const tmpToTime = (pVal) =>
		{
			if (pVal == null || pVal === '') return null;
			const tmpDate = new Date(pVal);
			return Number.isNaN(tmpDate.getTime()) ? null : tmpDate.getTime();
		};

		const tmpClauseMatches = (pRecord, pClause) =>
		{
			if (!pClause || !pClause.FilterByColumn) return true;
			const tmpField = tmpReadField(pRecord, pClause.FilterByColumn);
			const tmpType = String(pClause.Type || '');
			const tmpValues = pClause.Values || {};
			switch (tmpType)
			{
			case 'StringMatch':
			{
				const tmpQuery = tmpValues.value;
				if (tmpQuery === undefined || tmpQuery === null || tmpQuery === '') return true;
				const tmpStrField = tmpField == null ? '' : String(tmpField);
				const tmpStrQuery = String(tmpQuery);
				if (pClause.ExactMatch) return tmpStrField === tmpStrQuery;
				return tmpStrField.toLowerCase().includes(tmpStrQuery.toLowerCase());
			}
			case 'StringRange':
			{
				const tmpStart = tmpValues.Start;
				const tmpEnd = tmpValues.End;
				const tmpStrField = tmpField == null ? '' : String(tmpField);
				if (tmpStart != null && tmpStart !== '' && tmpStrField < String(tmpStart)) return false;
				if (tmpEnd != null && tmpEnd !== '' && tmpStrField > String(tmpEnd)) return false;
				return true;
			}
			case 'DateRange':
			{
				const tmpStart = tmpToTime(tmpValues.Start);
				const tmpEnd = tmpToTime(tmpValues.End);
				const tmpFieldT = tmpToTime(tmpField);
				if (tmpFieldT == null) return tmpStart == null && tmpEnd == null;
				if (tmpStart != null && tmpFieldT < tmpStart) return false;
				if (tmpEnd != null && tmpFieldT > tmpEnd) return false;
				return true;
			}
			case 'DateMatch':
			{
				const tmpExpect = tmpToTime(tmpValues.value);
				if (tmpExpect == null) return true;
				const tmpFieldT = tmpToTime(tmpField);
				if (tmpFieldT == null) return false;
				if (pClause.ExactMatch) return tmpFieldT === tmpExpect;
				// Same calendar day fuzzy comparison.
				return new Date(tmpFieldT).toISOString().slice(0, 10) === new Date(tmpExpect).toISOString().slice(0, 10);
			}
			case 'NumericRange':
			{
				const tmpStart = tmpValues.Start;
				const tmpEnd = tmpValues.End;
				const tmpNum = Number(tmpField);
				if (!Number.isFinite(tmpNum)) return tmpStart == null && tmpEnd == null;
				if (tmpStart != null && tmpStart !== '' && tmpNum < Number(tmpStart)) return false;
				if (tmpEnd != null && tmpEnd !== '' && tmpNum > Number(tmpEnd)) return false;
				return true;
			}
			case 'NumericMatch':
			{
				const tmpExpect = tmpValues.value;
				if (tmpExpect === undefined || tmpExpect === null || tmpExpect === '') return true;
				return Number(tmpField) === Number(tmpExpect);
			}
			default:
				// Unknown / unsupported types: keep the record (fail open) so
				// the UI doesn't silently drop everything when a future
				// clause type isn't recognized.
				return true;
			}
		};

		return pRecords.filter((pRecord) => pClauses.every((pClause) => tmpClauseMatches(pRecord, pClause)));
	}

	/**
	 * Inject the manifest's `ClientSide.Filters` entries into the recordset
	 * provider's `_FilterSchema` so they appear in the dashboard's "Add Filters"
	 * picker alongside (or in place of) the server-derived schema columns.
	 *
	 * Each entry in pManifest.ClientSide.Filters has:
	 *   - FilterByColumn: e.g. "Datum.MixDesigns.0.MixDesign"
	 *   - Type:           "StringMatch" | "DateRange" | "NumericRange" | …
	 *   - DisplayName:    label in the picker
	 *   - Clauses:        optional array of { ClauseKey, DisplayName, Type, ExactMatch } overrides
	 *
	 * @param {any} pProvider
	 * @param {Record<string, any>} pManifest
	 * @param {{ RecordSet: string }} pDashboardEntry
	 */
	_injectClientSideFilterSchema(pProvider, pManifest, pDashboardEntry)
	{
		const tmpFilters = (pManifest.ClientSide && pManifest.ClientSide.Filters) || [];
		if (!Array.isArray(tmpFilters) || tmpFilters.length === 0) return;
		if (!pProvider._FilterSchema || typeof pProvider._FilterSchema !== 'object') return;

		// Optionally clear the schema-driven filters so users don't see internal
		// columns like "App Data Unique Database ID". Driven by manifest flag.
		if (pManifest.ClientSide && pManifest.ClientSide.HideSchemaFilters)
		{
			for (const tmpKey of Object.keys(pProvider._FilterSchema))
			{
				delete pProvider._FilterSchema[tmpKey];
			}
		}

		let tmpOrdinal = 1000;
		for (const tmpFilter of tmpFilters)
		{
			if (!tmpFilter || !tmpFilter.FilterByColumn) continue;
			const tmpKey = tmpFilter.FilterKey || tmpFilter.FilterByColumn;
			const tmpDisplayName = tmpFilter.DisplayName || tmpFilter.Label || tmpKey;
			const tmpType = tmpFilter.Type || 'StringMatch';
			const tmpClauses = Array.isArray(tmpFilter.Clauses) && tmpFilter.Clauses.length > 0 ?
				tmpFilter.Clauses :
				this._defaultClausesForFilterType(tmpType, tmpKey, tmpDisplayName);

			pProvider._FilterSchema[tmpKey] =
				{
					FilterKey: tmpKey,
					RecordSet: pDashboardEntry.RecordSet,
					DisplayName: tmpDisplayName,
					Description: tmpFilter.Description || `Filter by ${tmpDisplayName}`,
					HelpText: tmpFilter.HelpText || `Filter records by ${tmpDisplayName}.`,
					Ordinal: ++tmpOrdinal,
					AvailableClauses: tmpClauses.map((pC, pIdx) => Object.assign(
						{
							FilterKey: tmpKey,
							ClauseKey: pC.ClauseKey || `${tmpKey}_${pIdx}`,
							FilterByColumn: tmpFilter.FilterByColumn,
							DisplayName: pC.DisplayName || pC.Label || tmpDisplayName,
							Label: pC.Label || `${tmpDisplayName} ${pC.DisplayName || ''}`.trim(),
							Type: pC.Type || tmpType,
							ExactMatch: pC.ExactMatch,
							Ordinal: pIdx + 1,
							MinimumLabel: pC.MinimumLabel,
							MaximumLabel: pC.MaximumLabel,
						},
						pC.Extra || {},
					)),
				};
		}
	}

	/**
	 * Default clause set for a given filter type, used when the manifest entry
	 * doesn't specify its own. Mirrors the meadow provider's auto-generated
	 * clause shape so the UI for Datum.* filters looks identical to top-level
	 * column filters.
	 *
	 * @param {string} pType
	 * @param {string} pKey
	 * @param {string} pDisplayName
	 * @return {Array<Record<string, any>>}
	 */
	_defaultClausesForFilterType(pType, pKey, pDisplayName)
	{
		switch (pType)
		{
		case 'StringMatch':
			return [
				{ ClauseKey: `${pKey}_Match_Exact`, DisplayName: 'Exact Match', Type: 'StringMatch', ExactMatch: true, Label: `${pDisplayName} Exact Match` },
				{ ClauseKey: `${pKey}_Match_Fuzzy`, DisplayName: 'Partial Match', Type: 'StringMatch', ExactMatch: false, Label: `${pDisplayName} Partial Match` },
			];
		case 'DateRange':
		case 'DateMatch':
			return [
				{ ClauseKey: `${pKey}_Match_Exact`, DisplayName: 'Exact Match', Type: 'DateMatch', ExactMatch: true, Label: `${pDisplayName} Exact Match` },
				{ ClauseKey: `${pKey}_Range`, DisplayName: 'In Range', Type: 'DateRange', Label: `${pDisplayName} In Range`,
					  MinimumLabel: `Minimum ${pDisplayName}`, MaximumLabel: `Maximum ${pDisplayName}` },
			];
		case 'NumericRange':
		case 'NumericMatch':
			return [
				{ ClauseKey: `${pKey}_Match_Exact`, DisplayName: 'Exact Match', Type: 'NumericMatch', ExactMatch: true, Label: `${pDisplayName} Exact Match` },
				{ ClauseKey: `${pKey}_Range`, DisplayName: 'In Range', Type: 'NumericRange', Label: `${pDisplayName} In Range`,
					  MinimumLabel: `Minimum ${pDisplayName}`, MaximumLabel: `Maximum ${pDisplayName}` },
			];
		default:
			return [
				{ ClauseKey: `${pKey}_Match`, DisplayName: 'Match', Type: pType, Label: `${pDisplayName} Match` },
			];
		}
	}

	/**
	 * Run a lake dashboard's manifest GlobalSolvers (the config-declared aggregation)
	 * against the fetched rows, writing WalbecDaily + WalbecSummary to pict.AppData.
	 * Generic — the per-dashboard logic lives in the manifest, not here. Re-runs on
	 * every load/filter (called from _computeDashboardSummary), so filters re-aggregate.
	 *
	 * @param {Record<string, any>} pManifest
	 * @param {Array<Record<string, any>>} pRecords
	 * @return {boolean} Whether solvers ran.
	 */
	_runAggregationSolvers(pManifest, pRecords)
	{
		if (!pManifest || !Array.isArray(pManifest.GlobalSolvers) || pManifest.GlobalSolvers.length < 1)
		{
			return false;
		}
		const tmpParser = this.pict.ExpressionParser || this.pict.instantiateServiceProviderIfNotExists('ExpressionParser');
		// solve() resolves nested addresses (AppData._x) through the manifest's getValueByHash,
		// so the manifest arg MUST be a real Manyfest, not null. Reuse pict's shared instance.
		const tmpManyfest = this.pict.manifest;
		if (!tmpManyfest)
		{
			return false;
		}
		if (!this.pict.AppData.WalbecDaily)
		{
			this.pict.AppData.WalbecDaily = {};
		}
		if (!this.pict.AppData.WalbecSummary)
		{
			this.pict.AppData.WalbecSummary = {};
		}
		const tmpContext = { Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle, RecordSubset: Array.isArray(pRecords) ? pRecords : [], Manifest: tmpManyfest };
		for (const tmpExpression of pManifest.GlobalSolvers)
		{
			try
			{
				tmpParser.solve(tmpExpression, tmpContext, {}, tmpManyfest, tmpContext);
			}
			catch (pError)
			{
				this.log.warn(`DynamicDashboardLoader: aggregation solver failed [${tmpExpression}]: ${pError.message}`);
			}
		}
		// The GlobalSolvers set each day's IDDocumentCount to a per-bucket SUM, which over-counts a
		// document shared across product/result buckets (one worksheet covering 20 stockpile rows
		// reads as "20"). Recompute it as the DISTINCT document count per day from the lake rows'
		// IDDocuments CSV, so the "N docs" button matches the documents popup. (The solver DSL can't
		// dedup CSV strings, so this lives here in JS.)
		this._applyDistinctDocumentCounts(Array.isArray(pRecords) ? pRecords : [], this.pict.AppData.WalbecDailyRecords);
		return true;
	}

	/**
	 * Overwrite each day-row's IDDocumentCount with the count of DISTINCT documents contributed
	 * that day (deduped across the day's lake rows' comma-separated IDDocuments lists), so the
	 * Documents button count matches the documents popup.
	 *
	 * @param {Array<Record<string, any>>} pLakeRows - Lake rows (each with BucketDate + IDDocuments).
	 * @param {Array<Record<string, any>>} pDailyRecords - The per-day rows the detail table renders.
	 */
	_applyDistinctDocumentCounts(pLakeRows, pDailyRecords)
	{
		if (!Array.isArray(pLakeRows) || !Array.isArray(pDailyRecords))
		{
			return;
		}
		const tmpDistinctByDate = {};
		for (const tmpRow of pLakeRows)
		{
			// Rollup-grain tables carry IDDocuments (CSV); doc-grain tables
			// (e.g. HMA running-avg) carry a single IDDocument per row.
			const tmpDocumentIDs = (tmpRow && tmpRow.IDDocuments != null) ? tmpRow.IDDocuments :
				(tmpRow ? tmpRow.IDDocument : null);
			if (tmpDocumentIDs == null)
			{
				continue;
			}
			const tmpKey = String(tmpRow.BucketDate);
			const tmpSet = tmpDistinctByDate[tmpKey] || (tmpDistinctByDate[tmpKey] = {});
			for (const tmpPart of String(tmpDocumentIDs).split(','))
			{
				const tmpID = parseInt(String(tmpPart).trim(), 10);
				if (Number.isInteger(tmpID) && tmpID > 0)
				{
					tmpSet[tmpID] = true;
				}
			}
		}
		for (const tmpDay of pDailyRecords)
		{
			if (!tmpDay)
			{
				continue;
			}
			// Day rows built by GENERATEARRAYOFOBJECTSFROMSETS carry only
			// BucketLabel; others carry BucketDate. Same calendar-day string
			// either way.
			const tmpSet = tmpDistinctByDate[String((tmpDay.BucketDate != null) ? tmpDay.BucketDate : tmpDay.BucketLabel)];
			if (!tmpSet)
			{
				// No per-document evidence for this day — keep the manifest
				// solver's count rather than stomping a working value to zero.
				continue;
			}
			tmpDay.IDDocumentCount = Object.keys(tmpSet).length;
		}
	}

	/**
	 * Compute a dashboard-specific summary object across all currently-loaded
	 * bucket records. KPI ReadOnly inputs and chart solvers in the form-mode
	 * manifest read fields off this object.
	 *
	 * Each branch returns a flat object whose top-level keys match the
	 * DataAddress paths in that dashboard's manifest descriptors.
	 *
	 * @param {string} pHash - Dashboard hash (manifest Scope).
	 * @param {Array<Record<string, any>>} pRecords - Bucket records (Datum already parsed).
	 * @return {Record<string, any>}
	 */
	_computeDashboardSummary(pHash, pRecords)
	{
		const tmpRecords = Array.isArray(pRecords) ? pRecords : [];
		// Lake-sourced dashboards return flat rows (no Datum blob) — drive them
		// entirely from the manifest's GlobalSolvers. This covers both daily/
		// bucketed dashboards (walbec) AND inventory-style ones with no BucketDate
		// (e.g. HDOT bridge inventory); the earlier BucketDate gate silently
		// skipped the latter, leaving RecordSubset unset → blank KPIs/charts (#35).
		const tmpLakeManifest = this._dashboardManifests && this._dashboardManifests[pHash];
		// An EMPTY result set MUST still run the solvers. This used to read
		// `tmpRecords[0] && tmpRecords[0].Datum == null` -- sniffing the first record to
		// decide "is this a flat lake dashboard?" -- which is unanswerable when there is
		// no first record. So a filter that matched nothing fell straight through, the
		// solvers never ran, and every KPI kept the PREVIOUS filter's number while the
		// header honestly reported "0 of 0 total records". Observed on QA: 0 records
		// shown beside tiles still reading 124 samples / 34,853.0 tons / 71 days, which
		// a reader believes over the grey text.
		//
		// The manifest is what actually identifies a lake-sourced dashboard, and it is
		// known without inspecting any record. Solving an empty subset is cheap and
		// yields the zeroes the tiles should show.
		if (tmpLakeManifest && (tmpRecords.length < 1 || tmpRecords[0].Datum == null))
		{
			this._runAggregationSolvers(tmpLakeManifest, tmpRecords);
			return (this.pict.AppData && this.pict.AppData.WalbecSummary) || {};
		}
		const tmpData = tmpRecords.map((pR) => pR && pR.Datum).filter((pD) => pD && typeof pD === 'object');
		const tmpSum = (pField) => tmpData.reduce((pAcc, pD) => pAcc + (Number(pD[pField]) || 0), 0);
		const tmpAvg = (pField) =>
		{
			const tmpVals = tmpData.map((pD) => Number(pD[pField])).filter((pN) => Number.isFinite(pN));
			return tmpVals.length ? tmpVals.reduce((pA, pB) => pA + pB, 0) / tmpVals.length : 0;
		};
		const tmpRound = (pN, pD) => Math.round(pN * Math.pow(10, pD)) / Math.pow(10, pD);

		switch (pHash)
		{
		case 'walbec-moisture-daily':
			return {
				BucketCount: tmpData.length,
				TotalSamples: tmpSum('TotalSamples'),
				AvgMoisture: tmpRound(tmpAvg('OverallAvgMoisture'), 2),
				AvgMeter: tmpRound(tmpAvg('AvgMeter'), 2),
				AvgOven: tmpRound(tmpAvg('AvgOven'), 2),
				AvgDifference: tmpRound(tmpAvg('AvgDifference'), 2),
				AvgPassRate: tmpRound(tmpAvg('OverallPassRate') * 100, 1),
				DateFrom: tmpData.length ? tmpData[0].BucketDate : '',
				DateTo: tmpData.length ? tmpData[tmpData.length - 1].BucketDate : '',
			};
		case 'walbec-hma-running-avg':
		{
			// Aggregate across each bucket's MixDesigns[] entries — these
			// are the per-mix per-day rollups; weight by SampleCount where
			// each mix had measurements.
			let tmpMixSamples = 0; let tmpAirNum = 0; let tmpAirDen = 0; let tmpBinderNum = 0; let tmpBinderDen = 0; let tmpVMANum = 0; let tmpVMADen = 0;
			const tmpUniqueMixes = new Set();
			for (const tmpDatum of tmpData)
			{
				if (!Array.isArray(tmpDatum.MixDesigns)) continue;
				for (const tmpMD of tmpDatum.MixDesigns)
				{
					const tmpCount = Number(tmpMD.SampleCount) || 0;
					if (tmpMD.MixDesign) tmpUniqueMixes.add(String(tmpMD.MixDesign));
					tmpMixSamples += tmpCount;
					if (Number.isFinite(Number(tmpMD.AirVoidsAvg)))
					{
						tmpAirNum += Number(tmpMD.AirVoidsAvg) * tmpCount; tmpAirDen += tmpCount;
					}
					if (Number.isFinite(Number(tmpMD.BinderPctAvg)))
					{
						tmpBinderNum += Number(tmpMD.BinderPctAvg) * tmpCount; tmpBinderDen += tmpCount;
					}
					if (Number.isFinite(Number(tmpMD.VMAAvg)))
					{
						tmpVMANum += Number(tmpMD.VMAAvg) * tmpCount; tmpVMADen += tmpCount;
					}
				}
			}
			return {
				BucketCount: tmpData.length,
				TotalTonnage: tmpRound(tmpSum('DailyTonnage'), 0),
				AvgDailyTonnage: tmpRound(tmpAvg('DailyTonnage'), 1),
				AvgAirVoids: tmpAirDen ? tmpRound(tmpAirNum / tmpAirDen, 2) : 0,
				AvgBinderPct: tmpBinderDen ? tmpRound(tmpBinderNum / tmpBinderDen, 2) : 0,
				AvgVMA: tmpVMADen ? tmpRound(tmpVMANum / tmpVMADen, 2) : 0,
				MixDesignCount: tmpUniqueMixes.size,
				TotalSamples: tmpMixSamples,
				DateFrom: tmpData.length ? tmpData[0].BucketDate : '',
				DateTo: tmpData.length ? tmpData[tmpData.length - 1].BucketDate : '',
			};
		}
		case 'walbec-cpsgrad-stats':
		{
			let tmpMatSamples = 0; let tmpMoistNum = 0; let tmpMoistDen = 0;
			const tmpUniqueMaterials = new Set();
			for (const tmpDatum of tmpData)
			{
				if (!Array.isArray(tmpDatum.Materials)) continue;
				for (const tmpMat of tmpDatum.Materials)
				{
					const tmpCount = Number(tmpMat.SampleCount) || 0;
					if (tmpMat.Material) tmpUniqueMaterials.add(String(tmpMat.Material));
					tmpMatSamples += tmpCount;
					if (Number.isFinite(Number(tmpMat.MoistureAvg)))
					{
						tmpMoistNum += Number(tmpMat.MoistureAvg) * tmpCount; tmpMoistDen += tmpCount;
					}
				}
			}
			return {
				BucketCount: tmpData.length,
				MaterialCount: tmpUniqueMaterials.size,
				TotalSamples: tmpMatSamples,
				AvgMoisture: tmpMoistDen ? tmpRound(tmpMoistNum / tmpMoistDen, 2) : 0,
				DateFrom: tmpData.length ? tmpData[0].BucketDate : '',
				DateTo: tmpData.length ? tmpData[tmpData.length - 1].BucketDate : '',
			};
		}
		default:
			return { BucketCount: tmpData.length };
		}
	}

	/**
	 * Top-level orchestration: for the given customer, load the AvailableDashboards
	 * record, fetch each referenced ManifestSchema, register them all, and stash
	 * the resolved list onto pict.AppData.AvailableDashboards for the chooser view.
	 *
	 * Safe no-op for customers with no AvailableDashboards record (returns null).
	 *
	 * @param {number} pCustomerID - The IDCustomer to wire dashboards for.
	 * @param {{ Enforced?: boolean, Dashboards?: Array<{ Hash: string, ProjectBound?: boolean, DataFilterString?: string }> }|null} [pAccess] -
	 *   The PlatformDashboard/Available answer. When it enforces access, only granted dashboards are wired, each with its
	 *   role filter; project-bound ones are left to hosts that open them for a project.
	 * @return {Promise<{ Dashboards: Array } | null>} The loaded dashboard list, or null.
	 */
	async wireAvailableDashboardsForCustomer(pCustomerID, pAccess)
	{
		// NOTE: the CSS injection, bottom-toolbar mount, and render-hook installs
		// below run for EVERY logged-in customer — even those with no dashboards —
		// so the persistent bottom bar (and its always-present Logout) is available
		// app-wide. Only the dashboard registration loop is gated on tmpAvailable.
		const tmpAvailable = await this.loadAvailableDashboards(pCustomerID);

		this.installDashboardStyles();
		try
		{
			if (this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
			{
				this.pict.CSSMap.addCSS('DynamicDashboardLoader-CSS', /*css*/`
					/* ---------------------------------------------------------------
					   PRINT / SUBMITTAL VIEW
					   ---------------------------------------------------------------
					   Registered through CSSMap rather than css/data.css on purpose:
					   that file is linked media="screen", so @media print rules in it
					   never apply. The CSSMap <style> is the LAST stylesheet in <head>,
					   so these also win on source order.

					   The approach is visibility isolation (the pattern already proven
					   by SamplePlanDashboard): hide everything, re-show the dashboard
					   container, and pull it to the top of the page. That beats hiding
					   chrome element by element, which silently breaks the day someone
					   adds a new wrapper.
					*/
					.walbec-printhead { display: none; }

					@media print
					{
						/* Landscape: these are wide control charts and 20+ column
						   gradation tables. Portrait clips both. */
						@page { size: landscape; margin: 12mm 10mm 14mm 10mm; }

						body * { visibility: hidden !important; }
						#PRSP_Container, #PRSP_Container * { visibility: visible !important; }
						#PRSP_Container { position: absolute; left: 0; top: 0; width: 100%; }
						body { padding-bottom: 0 !important; background: #fff !important; }

						/* Interactive chrome has no meaning on paper. The filter bar is
						   hidden because its CONTENT is restated in the print header --
						   a reader needs the filter values, not the controls. */
						#PRSP_Filters_Container,
						#PRSP_FilterBar,
						#walbec-bottom-toolbar,
						#HeadlightLogin-Standard-Wrap,
						#HeadlightPanels-Container,
						#Headlight-Dynamic-Header-Container,
						.pagination,
						.prsp-pagination,
						#PRSP_Title_Container,
						.hl-view-description,
						.walbec-noprint
						{
							display: none !important;
						}

						/* The submittal header: what this report covers. */
						.walbec-printhead
						{
							display: block !important;
							visibility: visible !important;
							margin: 0 0 0.6rem;
							padding: 0 0 0.4rem;
							border-bottom: 2px solid #000;
							color: #000;
						}
						.walbec-printhead-title { font-size: 1.15rem; font-weight: 700; }
						.walbec-printhead-filters { font-size: 0.8rem; margin-top: 0.15rem; }
						/* Said out loud, because an unfiltered submittal is a different
						   document from a filtered one and must not look identical. */
						.walbec-printhead-unfiltered { font-style: italic; }
						.walbec-printhead-stamp { font-size: 0.7rem; margin-top: 0.1rem; color: #333; }

						/* The container cap would waste the page width too. */
						[id^="PSRS-Dashboard-"] .pict-form-section.container
						{
							max-width: none !important;
							width: 100% !important;
							margin-left: 0 !important;
							margin-right: 0 !important;
						}
						body > section.section { padding: 0 !important; }

						/* KPI tiles read as a strip of numbers, not input boxes. */
						[id^="PSRS-Dashboard-"] input.input
						{
							border: none !important;
							box-shadow: none !important;
							background: transparent !important;
							padding-left: 0 !important;
							color: #000 !important;
						}

						/* A chart split across a page break is unreadable. */
						[id^="PSRS-Dashboard-"] .pict-form-group,
						.pict-input-chart
						{
							break-inside: avoid;
							page-break-inside: avoid;
						}

						/* Tables: repeat the header on every page, never split a row.
						   Without the repeated header, page 2 onward is a wall of
						   unlabelled numbers. */
						[id^="PSRS-Dashboard-"] .section-table-wrapper { overflow: visible !important; }
						[id^="PSRS-Dashboard-"] .table-container { overflow: visible !important; }
						[id^="PSRS-Dashboard-"] table thead { display: table-header-group; }
						[id^="PSRS-Dashboard-"] table tr { break-inside: avoid; page-break-inside: avoid; }
						[id^="PSRS-Dashboard-"] .section-table-wrapper td,
						[id^="PSRS-Dashboard-"] .section-table-wrapper th
						{
							font-size: 0.62rem;
							padding: 2px 4px !important;
						}
					}

					/* The page gutter too: 1.5rem each side is plenty on a data screen,
					   and :has() means this only tightens the section that actually holds
					   a dashboard. A browser without :has() simply keeps the wider
					   default -- the container fix above is the one that matters. */
					body > section.section:has(#PRSP_Container)
					{
						padding-left: 1.5rem;
						padding-right: 1.5rem;
						padding-top: 1.5rem;
					}
					/* Single-page pagination — pure CSS via :has(). Hides the page-
					   button UL when it contains only one (or zero) <li>, which
					   is the "Showing 1 to N of N where N <= PageSize" case. */
					nav.pagination ul:has(> li:only-child),
					nav[aria-label="pagination"] ul:has(> li:only-child),
					nav.pagination ul:not(:has(> li + li)),
					nav[aria-label="pagination"] ul:not(:has(> li + li))
					{
						display: none !important;
					}
					/* Tight bottom toolbar — Back/breadcrumb on the left, exports right.
					   Toolbar is mounted into document.body and pinned with
					   position:fixed; pad the body bottom so the toolbar doesn't
					   cover the last row of the table. */
					body { padding-bottom: 4.25rem; }
					.walbec-bottom-toolbar
					{
						position: fixed; left: 0; right: 0; bottom: 0;
						display: flex; align-items: center; justify-content: space-between;
						padding: 0.4rem 1rem;
						background: rgba(255, 255, 255, 0.96);
						border-top: 1px solid #e0e4ec;
						box-shadow: 0 -2px 8px rgba(15, 23, 42, 0.06);
						z-index: 30;
						font-size: 0.85rem;
						backdrop-filter: blur(4px);
					}
					.walbec-bottom-toolbar-left  { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
					.walbec-bottom-toolbar-right { display: flex; align-items: center; gap: 0.4rem; }
					.walbec-bottom-toolbar .button { font-size: 0.8rem; }
					.walbec-toolbar-divider { display: inline-block; width: 1px; height: 20px; background: #cbd5e1; margin: 0 0.35rem; }
					.walbec-breadcrumb { margin: 0; font-size: 0.78rem; }
					.walbec-breadcrumb ul { margin: 0; }
					.walbec-breadcrumb a { cursor: pointer; }
					.walbec-breadcrumb li.is-active a { color: #4a5568; pointer-events: none; }
					/* Hide the framework's redundant top-of-page "View" link column for
					   our Document recordsets — once we rewrite the cell to hold our
					   buttons it has the right look already. */
				`, 600);
				if (typeof this.pict.CSSMap.injectCSS === 'function')
				{
					this.pict.CSSMap.injectCSS();
				}
			}
		}
		catch (pError)
		{
			this.log.warn(`DynamicDashboardLoader: failed to inject dashboard CSS: ${pError.message || pError}`);
		}

		// Mount the persistent bottom toolbar (Back / breadcrumb / CSV / Excel /
		// Logout) once into document.body. Updates flow through PictRouter's
		// `after` hook on every route change — no MutationObserver.
		if (this.options.AppChrome !== false)
		{
			this._mountBottomToolbar();
		}

		// Skip caching connected Device records. The /Devices/Count endpoint
		// isn't exposed on every meadow deployment; when missing, the
		// framework falls back to per-row entity decoration, which fetches
		// every single related record serially and stalls the list view.
		if (this.options.AppChrome !== false)
		{
			this._skipDeviceCaching();
		}

		// Suppress the framework's default Actions column on our Document
		// recordsets — we already render Open/PDF via RecordSetListExtraColumn —
		// and on any dashboard that sets HideRowActions. Hooks into PRSP-List-RecordList.onBeforeRender (same pattern as
		// ImprovedTabularRecordSetProvider) so the override is route-aware
		// without needing a MutationObserver.
		this._installActionColumnSuppressor();

		if (!tmpAvailable)
		{
			// Finished, with nothing to show -- a real empty state, not a pending one.
			this.pict.AppData.AvailableDashboards = { Dashboards: [], Loaded: true };
			this.log.info(`DynamicDashboardLoader: no AvailableDashboards record for customer ${pCustomerID}; skipping dynamic dashboard wiring.`);
			return null;
		}

		const tmpRegistered = [];
		const tmpGranted = (pAccess && pAccess.Enforced && Array.isArray(pAccess.Dashboards)) ? new Map(pAccess.Dashboards.map((pGrant) => [ pGrant.Hash, pGrant ])) : null;
		for (const tmpEntry of tmpAvailable.Dashboards)
		{
			const tmpGrant = tmpGranted ? tmpGranted.get(tmpEntry.Hash) : null;
			if (tmpGranted && (!tmpGrant || tmpGrant.ProjectBound))
			{
				continue;
			}
			const tmpHost = (tmpGrant && tmpGrant.DataFilterString) ? { ExtraFilter: tmpGrant.DataFilterString } : undefined;
			try
			{
				// List-mode entries skip the ManifestSchema fetch — they're plain
				// server-side recordset list views (e.g. "All Documents") that the
				// loader registers directly from the AvailableDashboards Datum.
				if (tmpEntry.Mode === 'List')
				{
					if (this.registerListDashboard(tmpEntry, pCustomerID, tmpHost))
					{
						tmpRegistered.push(tmpEntry);
					}
					continue;
				}

				const tmpManifest = await this.loadDashboardManifest(tmpEntry.Hash, pCustomerID);
				if (!tmpManifest)
				{
					this.log.warn(`DynamicDashboardLoader: dashboard ${tmpEntry.Hash} has no manifest; skipping.`);
					continue;
				}
				if (this.registerDashboard(tmpEntry, tmpManifest, pCustomerID, tmpHost))
				{
					tmpRegistered.push(tmpEntry);
				}
			}
			catch (pError)
			{
				this.log.error(`DynamicDashboardLoader: failed to load dashboard ${tmpEntry.Hash}: ${pError.message || pError}`, { Stack: pError.stack });
			}
		}

		// `Loaded` separates "finished, and there are none" from "still working".
		// Without it the chooser cannot tell the two apart, and renders its empty
		// state -- "No dashboards are configured for your account yet." -- during
		// the fetch, which flashes a false negative at every user on every load.
		const tmpResolved = { Dashboards: tmpRegistered, Loaded: true };
		this.pict.AppData.AvailableDashboards = tmpResolved;
		this.log.info(`DynamicDashboardLoader: wired ${tmpRegistered.length}/${tmpAvailable.Dashboards.length} dashboards for customer ${pCustomerID}.`);
		return tmpResolved;
	}
}

module.exports = DynamicDashboardLoader;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"fable-serviceproviderbase":438,"pict-section-form/source/providers/inputs/Pict-Provider-Input-Templated.js":625}],42:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Actions a dashboard can ask its host to take. Dashboards say what they want ("open sample 123"); the host decides
 * where that goes — a LIMS route, a native iPad screen, a new tab. Keep in step with the action table in
 * docs-internal/materials-dashboards/00-design.md and the iOS `dashboardAction` handler in ~/dev/mpi_ios.
 *
 * @type {Record<string, { Required: Array<string>, Optional?: Array<string> }>}
 */
const ACTIONS =
{
	'Sample.Open': { Required: [ 'IDSample' ] },
	'Sample.Create': { Required: [ 'IDProject', 'IDLineItem', 'IDMaterial' ], Optional: [ 'Quantity', 'SampleType' ] },
	'Sample.Receive': { Required: [ 'IDSample' ] },
	'Document.Open': { Required: [ 'IDDocument' ], Optional: [ 'IDSample' ] },
	'Project.Open': { Required: [ 'IDProject' ] },
	'Material.Open': { Required: [ 'IDMaterial' ] },
	'Dashboard.Open': { Required: [ 'Hash' ], Optional: [ 'IDProject', 'Filters' ] },
};

const NATIVE_HANDLER = 'dashboardAction';
const PARENT_MESSAGE_KEY = 'HeadlightDashboardAction';

/**
 * @typedef {Object} DashboardAction
 * @property {string} Action - A key of ACTIONS.
 */

/**
 * `data-*` attribute names arrive camel-cased (`data-id-line-item` → `idLineItem`); actions use HeadLight column
 * spelling (`IDLineItem`).
 *
 * @param {string} pKey
 * @return {string}
 */
function normalizeParamName(pKey)
{
	if (/^id[A-Z]/.test(pKey))
	{
		return `ID${pKey.slice(2)}`;
	}
	return pKey.charAt(0).toUpperCase() + pKey.slice(1);
}

/**
 * @param {string} pName
 * @param {string} pValue
 * @return {any}
 */
function normalizeParamValue(pName, pValue)
{
	if (pName === 'Filters')
	{
		try
		{
			return JSON.parse(pValue);
		}
		catch (pError)
		{
			return undefined;
		}
	}
	if ((/^ID[A-Z]/.test(pName) || pName === 'Quantity') && /^-?\d+(\.\d+)?$/.test(String(pValue)))
	{
		return Number(pValue);
	}
	return pValue;
}

/**
 * Build an action from an element's `data-hl-action` and `data-*` attributes.
 *
 * @param {{ dataset: Record<string, string> }} pElement
 * @return {DashboardAction|null}
 */
function actionFromElement(pElement)
{
	if (!pElement || !pElement.dataset || !pElement.dataset.hlAction)
	{
		return null;
	}
	/** @type {Record<string, any>} */
	const tmpAction = { Action: pElement.dataset.hlAction };
	for (const [ tmpKey, tmpValue ] of Object.entries(pElement.dataset))
	{
		if (tmpKey === 'hlAction')
		{
			continue;
		}
		const tmpName = normalizeParamName(tmpKey);
		const tmpNormalized = normalizeParamValue(tmpName, tmpValue);
		if (tmpNormalized !== undefined)
		{
			tmpAction[tmpName] = tmpNormalized;
		}
	}
	return /** @type {DashboardAction} */ (tmpAction);
}

/**
 * The legacy app_dashboards materials samples dashboard posts a bare `{ IDProject, IDLineItem, IDMaterial, Quantity,
 * Type }`; read it as Sample.Create.
 *
 * @param {Record<string, any>} pPayload
 * @return {DashboardAction|null}
 */
function actionFromLegacySamplePayload(pPayload)
{
	if (!pPayload || typeof pPayload !== 'object' || pPayload.Action || !pPayload.IDProject || !pPayload.IDLineItem || !pPayload.IDMaterial)
	{
		return null;
	}
	/** @type {Record<string, any>} */
	const tmpAction = { Action: 'Sample.Create', IDProject: Number(pPayload.IDProject), IDLineItem: Number(pPayload.IDLineItem), IDMaterial: Number(pPayload.IDMaterial) };
	if (pPayload.Quantity !== undefined && pPayload.Quantity !== null && pPayload.Quantity !== '')
	{
		tmpAction.Quantity = Number(pPayload.Quantity);
	}
	if (pPayload.Type)
	{
		tmpAction.SampleType = pPayload.Type;
	}
	return /** @type {DashboardAction} */ (tmpAction);
}

/**
 * @param {DashboardAction} pAction
 * @return {{ Valid: boolean, Reason?: string }}
 */
function validateAction(pAction)
{
	const tmpDefinition = pAction && ACTIONS[pAction.Action];
	if (!tmpDefinition)
	{
		return { Valid: false, Reason: `unknown action ${pAction && pAction.Action}` };
	}
	const tmpMissing = tmpDefinition.Required.filter((pName) => pAction[pName] === undefined || pAction[pName] === null || pAction[pName] === '' || pAction[pName] === 0);
	if (tmpMissing.length > 0)
	{
		return { Valid: false, Reason: `${pAction.Action} needs ${tmpMissing.join(', ')}` };
	}
	return { Valid: true };
}

/**
 * The action bus. A host registers a handler per action; anything it doesn't handle goes to the fallback, then to the
 * configured transport (the iPad app, or the page that framed this one).
 */
class HeadlightDashboardActions extends libFableServiceProviderBase
{
	/**
	 * @param {any} pFable
	 * @param {Record<string, any>} [pOptions] - `Transport`: 'native' | 'parent' | null; `ParentOrigin` for 'parent';
	 *   `TransportActions`: the actions whoever framed this page can take (null: all of them).
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({ Transport: null, ParentOrigin: null, TransportActions: null }, pOptions), pServiceHash);
		/** @type {any} */
		this.log;
		/** @type {Record<string, (pAction: DashboardAction) => any>} */
		this.handlers = {};
		/** @type {((pAction: DashboardAction) => any)|null} */
		this.fallback = null;
		this._boundContainers = new WeakSet();
	}

	/**
	 * @param {string} pAction - A key of ACTIONS.
	 * @param {(pAction: DashboardAction) => any} fHandler
	 */
	registerHandler(pAction, fHandler)
	{
		if (!ACTIONS[pAction])
		{
			this.log.warn(`HeadlightDashboardActions: registering a handler for unknown action ${pAction}.`);
		}
		this.handlers[pAction] = fHandler;
	}

	/**
	 * @param {(pAction: DashboardAction) => any} fHandler
	 */
	registerFallback(fHandler)
	{
		this.fallback = fHandler;
	}

	/**
	 * @param {'native'|'parent'|null} pTransport
	 * @param {string} [pParentOrigin] - Required for 'parent': where actions may be posted.
	 * @param {Array<string>|null} [pTransportActions] - What the framing app can take; null for all.
	 */
	setTransport(pTransport, pParentOrigin, pTransportActions)
	{
		this.options.Transport = pTransport;
		this.options.ParentOrigin = pParentOrigin || null;
		this.options.TransportActions = Array.isArray(pTransportActions) ? pTransportActions : null;
	}

	/**
	 * Can anything here take this action? Dashboards hide what can't be done — "Take a sample" in an app with no way to
	 * create one, or on an iPad project with no sample creation form.
	 *
	 * @param {string} pAction
	 * @return {boolean}
	 */
	isAvailable(pAction)
	{
		if (typeof this.handlers[pAction] === 'function' || typeof this.fallback === 'function')
		{
			return true;
		}
		if (this.options.Transport === 'native' || (this.options.Transport === 'parent' && this.options.ParentOrigin))
		{
			return !Array.isArray(this.options.TransportActions) || this.options.TransportActions.includes(pAction);
		}
		return false;
	}

	/**
	 * @param {string} pScopeSelector - The container the rule applies inside.
	 * @return {string} CSS hiding every element whose action is unavailable here ('' when all are available)
	 */
	unavailableActionsCSS(pScopeSelector)
	{
		return Object.keys(ACTIONS)
			.filter((pAction) => !this.isAvailable(pAction))
			.map((pAction) => `${pScopeSelector} [data-hl-action="${pAction}"] { display: none !important; }`)
			.join('\n');
	}

	/**
	 * @param {DashboardAction} pAction
	 * @return {boolean} true when something took the action
	 */
	dispatch(pAction)
	{
		const tmpValidity = validateAction(pAction);
		if (!tmpValidity.Valid)
		{
			this.log.warn(`HeadlightDashboardActions: ignored (${tmpValidity.Reason}).`, pAction);
			return false;
		}
		const tmpHandler = this.handlers[pAction.Action];
		if (typeof tmpHandler === 'function')
		{
			tmpHandler(pAction);
			return true;
		}
		if (this._sendThroughTransport(pAction))
		{
			return true;
		}
		if (typeof this.fallback === 'function')
		{
			this.fallback(pAction);
			return true;
		}
		this.log.warn(`HeadlightDashboardActions: nothing handles ${pAction.Action} in this app.`, pAction);
		return false;
	}

	/**
	 * @param {DashboardAction} pAction
	 * @return {boolean}
	 */
	_sendThroughTransport(pAction)
	{
		if (typeof window === 'undefined')
		{
			return false;
		}
		if (this.options.Transport === 'native')
		{
			const tmpBridge = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[NATIVE_HANDLER];
			if (tmpBridge && typeof tmpBridge.postMessage === 'function')
			{
				tmpBridge.postMessage(pAction);
				return true;
			}
			return false;
		}
		if (this.options.Transport === 'parent' && this.options.ParentOrigin && window.parent && window.parent !== window)
		{
			window.parent.postMessage({ [PARENT_MESSAGE_KEY]: pAction }, this.options.ParentOrigin);
			return true;
		}
		return false;
	}

	/**
	 * Turn clicks on `[data-hl-action]` inside a container into actions. One listener per container, however often its
	 * content re-renders.
	 *
	 * @param {Element} pContainer
	 */
	bindContainer(pContainer)
	{
		if (!pContainer || this._boundContainers.has(pContainer))
		{
			return;
		}
		this._boundContainers.add(pContainer);
		pContainer.addEventListener('click', (pEvent) =>
		{
			const tmpTarget = /** @type {Element} */ (pEvent.target);
			const tmpElement = tmpTarget && typeof tmpTarget.closest === 'function' ? tmpTarget.closest('[data-hl-action]') : null;
			// Containers nest (a dashboard frame inside a host page); one click is one action.
			if (!tmpElement || !pContainer.contains(tmpElement) || /** @type {any} */ (pEvent).headlightDashboardActionHandled)
			{
				return;
			}
			/** @type {any} */ (pEvent).headlightDashboardActionHandled = true;
			pEvent.preventDefault();
			const tmpAction = actionFromElement(/** @type {any} */ (tmpElement));
			if (tmpAction)
			{
				this.dispatch(tmpAction);
			}
		});
	}
}

module.exports = HeadlightDashboardActions;
module.exports.default_configuration = { ProviderIdentifier: 'HeadlightDashboardActions' };
module.exports.ACTIONS = ACTIONS;
module.exports.NATIVE_HANDLER = NATIVE_HANDLER;
module.exports.PARENT_MESSAGE_KEY = PARENT_MESSAGE_KEY;
module.exports.actionFromElement = actionFromElement;
module.exports.actionFromLegacySamplePayload = actionFromLegacySamplePayload;
module.exports.validateAction = validateAction;

/**
 * Read an `actions=Sample.Create,Document.Open` list (from the framing app) into known action names.
 *
 * @param {string|null|undefined} pValue
 * @return {Array<string>|null} null when absent (the framing app takes every action)
 */
module.exports.parseActionList = (pValue) =>
{
	if (pValue === null || pValue === undefined)
	{
		return null;
	}
	return String(pValue).split(',').map((pName) => pName.trim()).filter((pName) => ACTIONS[pName]);
};

},{"fable-serviceproviderbase":438}],43:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libDashboardAccess = require('headlight-dashboard-access');
const libHosts = require('headlight-qrcode/source/Headlight-QRCode-Hosts.js');

const libActions = require('./Headlight-Dashboard-Actions.js');

const CACHE_MILLISECONDS = 60 * 1000;
const BODY_ID = 'HeadlightDashboard-Body';
const PROJECT_PICKER_ID = 'HeadlightDashboard-ProjectPicker';
const PROJECT_PAGE_SIZE = 25;
const RECENT_PROJECTS_LIMIT = 5;
const DEFAULT_LIST_PAGE_SIZE = 100;
const MAX_SWITCHER_LINKS = 4;

/**
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	return String(pValue === undefined || pValue === null ? '' : pValue)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/**
 * The hash that means "the list of dashboards" rather than one dashboard. Registry hashes are lowercase, so it can't
 * collide with a real one.
 */
const CHOOSER_HASH = 'All';

/**
 * Route spellings a host registers (and a micro-app allows) for embedded dashboards under `pRouteBase`. Bare
 * `pRouteBase` opens the person's landing dashboard; `<base>/All[/Project/:IDProject]` is the list. `FilteredTo` and
 * `Page` keep a list dashboard's search, sort and paging inside the host, where its role filter, notices and dashboard
 * links stay.
 *
 * @param {string} [pRouteBase]
 * @return {Array<string>}
 */
function routePatterns(pRouteBase)
{
	const tmpBase = pRouteBase || '/Dashboards';
	const tmpPatterns = [ tmpBase ];
	for (const tmpProject of [ '', '/Project/:IDProject' ])
	{
		for (const tmpFilter of [ '', '/FilteredTo/:Filter' ])
		{
			for (const tmpPage of [ '', '/Page/:Offset/:PageSize' ])
			{
				const tmpRoute = `${tmpBase}/:Hash${tmpProject}${tmpFilter}${tmpPage}`;
				tmpPatterns.push(tmpRoute, `${tmpRoute}/FilterExperience/:FilterExperience`);
			}
		}
	}
	return tmpPatterns;
}

/**
 * Read a route or link to a list's own `/PSRS/<RecordSet>/List` view, as its search, sort and page links write it:
 * `[#]/PSRS/<RecordSet>/List[/FilteredTo/<filter>][/<offset>/<size>][/FilterExperience/<x>]`. Parts come back as they
 * appear in the URL (still encoded).
 *
 * @param {string} pRoute
 * @param {string} pRecordSet
 * @return {{ Filter: string, Offset: number, PageSize: number, FilterExperience: string }|null} null when it isn't that list
 */
function parseListLink(pRoute, pRecordSet)
{
	if (typeof pRoute !== 'string')
	{
		return null;
	}
	const tmpPrefix = `/PSRS/${pRecordSet}/List`;
	const tmpRoute = pRoute.replace(/^#/, '');
	if (tmpRoute.indexOf(tmpPrefix) !== 0)
	{
		return null;
	}
	const tmpMatch = /^(?:\/FilteredTo\/([^/]+))?(?:\/(\d+)\/(\d+))?(?:\/FilterExperience\/(.+))?\/?$/.exec(tmpRoute.slice(tmpPrefix.length));
	if (!tmpMatch)
	{
		return null;
	}
	return { Filter: tmpMatch[1] || '', Offset: tmpMatch[2] ? parseInt(tmpMatch[2], 10) : 0, PageSize: tmpMatch[3] ? parseInt(tmpMatch[3], 10) : 0, FilterExperience: tmpMatch[4] || '' };
}

/**
 * @param {string} pFilter - A meadow filter string.
 * @return {Array<string>} its four-part clauses (`FBV~Status~NE~VOID`)
 */
function filterClauses(pFilter)
{
	const tmpTrimmed = String(pFilter || '').replace(/^~+|~+$/g, '');
	const tmpParts = tmpTrimmed ? tmpTrimmed.split('~') : [];
	const tmpClauses = [];
	for (let i = 0; i + 3 < tmpParts.length; i += 4)
	{
		tmpClauses.push(tmpParts.slice(i, i + 4).join('~'));
	}
	return tmpClauses;
}

/**
 * The filter a list dashboard renders with: its configured scope, then what the person searched or sorted by. A sort
 * the person chose replaces the scope's default sort. The list hands back scope + person on its next search or sort, so
 * a leading copy of the scope is dropped rather than repeated.
 *
 * A header click cycles ascending, descending, then no sort; that last step arrives as a page with no sort in it. A
 * dashboard with a default sort never shows an unsorted list: clearing the default column sorts it the other way from
 * how it was last shown, and clearing any other column brings the default sort back.
 *
 * @param {string} pScopeFilter - The dashboard's ScopeFilter, e.g. `FBV~Status~NE~VOID~FSF~DaysSinceSampled~ASC~0`.
 * @param {string} [pFilter] - The route's FilteredTo part.
 * @param {boolean} [pIsPage] - The route names a page (a sort or page link), not only a search or filters.
 * @param {string} [pPreviousFilter] - The filter this list last rendered with.
 * @return {string}
 */
function composeListFilter(pScopeFilter, pFilter, pIsPage, pPreviousFilter)
{
	const fIsSort = (pClause) => pClause.indexOf('FSF~') === 0;
	const tmpScope = filterClauses(pScopeFilter);
	const tmpScopeTests = tmpScope.filter((pClause) => !fIsSort(pClause));
	const tmpPerson = filterClauses(pFilter);
	let tmpSkip = 0;
	while ((tmpSkip < tmpScopeTests.length) && (tmpPerson[tmpSkip] === tmpScopeTests[tmpSkip]))
	{
		tmpSkip++;
	}
	if (tmpSkip < tmpScopeTests.length)
	{
		tmpSkip = 0;
	}
	const tmpPersonTests = tmpPerson.slice(tmpSkip).filter((pClause) => !fIsSort(pClause));
	const tmpPersonSorts = tmpPerson.filter(fIsSort);
	const tmpScopeSorts = tmpScope.filter(fIsSort);
	let tmpSorts = (tmpPersonSorts.length > 0) ? tmpPersonSorts : tmpScopeSorts;
	if ((tmpPersonSorts.length < 1) && pIsPage && (tmpScopeSorts.length > 0))
	{
		const [ , tmpDefaultField ] = tmpScopeSorts[0].split('~');
		const tmpPreviousDefault = filterClauses(pPreviousFilter).filter(fIsSort).find((pClause) => pClause.split('~')[1] === tmpDefaultField);
		if (tmpPreviousDefault)
		{
			const tmpParts = tmpPreviousDefault.split('~');
			const tmpFlipped = `FSF~${tmpDefaultField}~${String(tmpParts[2]).toUpperCase() === 'DESC' ? 'ASC' : 'DESC'}~0`;
			tmpSorts = [ tmpFlipped ].concat(tmpScopeSorts.slice(1));
		}
	}
	return tmpScopeTests.concat(tmpPersonTests, tmpSorts).join('~');
}

/**
 * Hosts dashboards inside any pict app: asks the platform which dashboards this person may open, shows a chooser, and
 * opens one into a container the host owns — project and role filters applied, actions routed to the host.
 *
 * The host owns the route (`routePatterns()`); filter changes navigate back to it, so a micro-app allows one route
 * family rather than every dashboard's recordset.
 */
class HeadlightDashboardHost extends libFableServiceProviderBase
{
	/**
	 * @param {any} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({ RouteBase: '/Dashboards', LegacyDashboardsBaseURL: null }, pOptions), pServiceHash);
		/** @type {any} */
		this.pict = this.fable;
		/** @type {any} */
		this.log;
		/** @type {Record<string, { At: number, Value: any }>} */
		this._cache = {};
		/** @type {Record<string, Array<any>>} */
		this._pendingDrillFilters = {};
		this._legacyListenerInstalled = false;
		/** @type {Record<string, { Hash: string, IDProject: number }>} list dashboards by recordset, for `_redirectListRoute` */
		this._listDashboards = {};
		/** @type {Record<string, string>} the filter each list dashboard last rendered with, by recordset */
		this._lastListFilters = {};
		this._listRouteRedirectInstalled = false;
	}

	/**
	 * Whether an open dashboard shows its Description under its title: the host app's `getShowDescriptions` option.
	 *
	 * @return {boolean}
	 */
	_showDescriptions()
	{
		return (typeof this.options.getShowDescriptions === 'function') && (this.options.getShowDescriptions() === true);
	}

	/** @return {any} */
	get actions()
	{
		return this.pict.providers.HeadlightDashboardActions;
	}

	/** @return {any} */
	get loader()
	{
		return this.pict.providers.DynamicDashboardLoader;
	}

	/**
	 * @return {number}
	 */
	_customerID()
	{
		if (typeof this.options.getCustomerID === 'function')
		{
			return parseInt(this.options.getCustomerID(), 10) || 0;
		}
		const tmpAppData = this.pict.AppData || {};
		const tmpSession = tmpAppData.CurrentUser || tmpAppData.Session || (this.pict.providers.SessionProvider && this.pict.providers.SessionProvider.session) || {};
		return parseInt(tmpSession.CustomerID, 10) || 0;
	}

	/**
	 * @param {string} [pHash]
	 * @param {number} [pIDProject]
	 * @param {{ Filter?: string, Offset?: number, PageSize?: number, FilterExperience?: string }} [pPage] - A list's
	 *   search or sort and page; Filter and FilterExperience as they appear in a URL (already encoded).
	 * @return {string}
	 */
	routeFor(pHash, pIDProject, pPage)
	{
		let tmpRoute = this.options.RouteBase;
		if (pHash)
		{
			tmpRoute += `/${encodeURIComponent(pHash)}`;
		}
		if (pIDProject)
		{
			tmpRoute += `/Project/${pIDProject}`;
		}
		if (pPage)
		{
			if (pPage.Filter)
			{
				tmpRoute += `/FilteredTo/${pPage.Filter}`;
			}
			if (pPage.PageSize)
			{
				tmpRoute += `/Page/${pPage.Offset || 0}/${pPage.PageSize}`;
			}
			if (pPage.FilterExperience)
			{
				tmpRoute += `/FilterExperience/${pPage.FilterExperience}`;
			}
		}
		return tmpRoute;
	}

	/**
	 * Navigate to a dashboard (the default Dashboard.Open handling). `pFilters` narrows the next open of that dashboard
	 * — a drill-down from a statewide view into one district — and is not kept in the URL.
	 *
	 * @param {string} pHash
	 * @param {number} [pIDProject]
	 * @param {Array<any>} [pFilters] - Filter clauses, as in DashboardAccess rules.
	 */
	navigateTo(pHash, pIDProject, pFilters)
	{
		if (Array.isArray(pFilters) && pFilters.length > 0)
		{
			this._pendingDrillFilters[pHash] = pFilters;
		}
		const tmpRouter = this.pict.providers.PictRouter;
		if (tmpRouter && typeof tmpRouter.navigate === 'function')
		{
			tmpRouter.navigate(this.routeFor(pHash, pIDProject));
		}
	}

	/**
	 * Which dashboards this person may open (cached for a minute per project).
	 *
	 * @param {number} [pIDProject]
	 * @param {boolean} [pForce]
	 * @return {Promise<any>} the PlatformDashboard/Available response
	 */
	async loadAvailable(pIDProject, pForce)
	{
		const tmpKey = pIDProject ? `Project-${pIDProject}` : 'Customer';
		const tmpCached = this._cache[tmpKey];
		if (!pForce && tmpCached && (Date.now() - tmpCached.At) < CACHE_MILLISECONDS)
		{
			return tmpCached.Value;
		}
		const tmpURL = pIDProject ? `PlatformDashboard/Available/In/Project/${pIDProject}` : 'PlatformDashboard/Available';
		const tmpValue = await new Promise((fResolve, fReject) =>
		{
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					return fReject(pError);
				}
				if (!pBody || !Array.isArray(pBody.Dashboards))
				{
					return fReject(new Error((pBody && (pBody.error || pBody.Error)) || 'Unexpected response from PlatformDashboard/Available'));
				}
				fResolve(pBody);
			});
		});
		this._cache[tmpKey] = { At: Date.now(), Value: tmpValue };
		this.pict.AppData.HeadlightDashboards = tmpValue;
		return tmpValue;
	}

	/**
	 * @param {string} pURL - relative to the API, e.g. `Project/12`
	 * @return {Promise<any>}
	 */
	_getJSON(pURL)
	{
		return new Promise((fResolve, fReject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pURL, (pError, pBody) =>
			{
				if (pError)
				{
					return fReject(pError);
				}
				fResolve(pBody);
			});
		});
	}

	/**
	 * @return {string|null} the browser storage key for this customer's recent projects
	 */
	_recentProjectsKey()
	{
		const tmpCustomerID = this._customerID();
		return tmpCustomerID ? `HeadlightDashboards-RecentProjects-${tmpCustomerID}` : null;
	}

	/**
	 * The projects this person last opened a dashboard for, most recent first. Kept in browser storage, so it is a
	 * convenience only: empty in a private window or a fresh browser.
	 *
	 * @return {Array<number>}
	 */
	recentProjects()
	{
		const tmpKey = this._recentProjectsKey();
		if (!tmpKey || (typeof window === 'undefined') || !window.localStorage)
		{
			return [];
		}
		try
		{
			const tmpValue = JSON.parse(window.localStorage.getItem(tmpKey) || '[]');
			return Array.isArray(tmpValue) ? tmpValue.map((pID) => parseInt(pID, 10)).filter((pID) => pID > 0) : [];
		}
		catch (pError)
		{
			return [];
		}
	}

	/**
	 * @param {number} pIDProject
	 */
	rememberProject(pIDProject)
	{
		const tmpKey = this._recentProjectsKey();
		if (!tmpKey || !pIDProject || (typeof window === 'undefined') || !window.localStorage)
		{
			return;
		}
		const tmpRecent = [ pIDProject ].concat(this.recentProjects().filter((pID) => pID !== pIDProject)).slice(0, RECENT_PROJECTS_LIMIT);
		try
		{
			window.localStorage.setItem(tmpKey, JSON.stringify(tmpRecent));
		}
		catch (pError)
		{
			this.log.warn(`HeadlightDashboardHost: could not remember project ${pIDProject}: ${pError.message || pError}`);
		}
	}

	/**
	 * One page of projects for the project picker: matches on name (which carries the project number), newest first.
	 * With no search, the first page leads with this person's recent projects.
	 *
	 * @param {string} pTerm
	 * @param {number} pPage
	 * @return {Promise<{ results: Array<{ Value: number, Text: string, Group?: string }>, hasMore: boolean }>}
	 */
	async searchProjects(pTerm, pPage)
	{
		const tmpTerm = String(pTerm === undefined || pTerm === null ? '' : pTerm).trim();
		const tmpPage = Number(pPage) || 0;
		const tmpOption = (pProject) => ({ Value: Number(pProject.IDProject), Text: pProject.Value || pProject.Name || `Project ${pProject.IDProject}` });
		let tmpFilter = `FBV~IDCustomer~EQ~${this._customerID()}~FBV~Deleted~EQ~0`;
		if (tmpTerm)
		{
			tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`;
		}
		const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}~FSF~IDProject~DESC~0/${tmpPage * PROJECT_PAGE_SIZE}/${PROJECT_PAGE_SIZE}`);
		const tmpProjects = Array.isArray(tmpRows) ? tmpRows : [];
		const tmpHasMore = tmpProjects.length >= PROJECT_PAGE_SIZE;
		const tmpRecentIDs = tmpTerm ? [] : this.recentProjects();
		if (tmpRecentIDs.length < 1)
		{
			return { results: tmpProjects.map(tmpOption), hasMore: tmpHasMore };
		}
		// Recent projects lead the first page; every page leaves them out of "All projects" so none is listed twice.
		const tmpOthers = tmpProjects.filter((pProject) => !tmpRecentIDs.includes(Number(pProject.IDProject))).map((pProject) => Object.assign(tmpOption(pProject), { Group: 'All projects' }));
		if (tmpPage > 0)
		{
			return { results: tmpOthers, hasMore: tmpHasMore };
		}
		const tmpRecentRows = await this._getJSON(`Projects/Lite/FilteredTo/FBL~IDProject~INN~${tmpRecentIDs.join(',')}~FBV~Deleted~EQ~0/0/${tmpRecentIDs.length}`).catch(() => []);
		const tmpRecentByID = new Map((Array.isArray(tmpRecentRows) ? tmpRecentRows : []).map((pProject) => [ Number(pProject.IDProject), pProject ]));
		const tmpRecent = tmpRecentIDs.filter((pID) => tmpRecentByID.has(pID)).map((pID) => Object.assign(tmpOption(tmpRecentByID.get(pID)), { Group: 'Recent' }));
		return { results: tmpRecent.concat(tmpOthers), hasMore: tmpHasMore };
	}

	/**
	 * Forget cached access answers (after a role change, or when the config screen saves rules).
	 */
	invalidate()
	{
		this._cache = {};
	}

	/**
	 * @param {string|Element} pDestination
	 * @return {Element|null}
	 */
	_element(pDestination)
	{
		if (typeof document === 'undefined')
		{
			return null;
		}
		return (typeof pDestination === 'string') ? document.querySelector(pDestination) : pDestination;
	}

	/**
	 * @param {string|Element} pDestination
	 * @param {string} pHTML
	 * @return {Element|null}
	 */
	_paint(pDestination, pHTML)
	{
		const tmpElement = this._element(pDestination);
		if (!tmpElement)
		{
			this.log.warn(`HeadlightDashboardHost: destination ${pDestination} not found.`);
			return null;
		}
		tmpElement.innerHTML = pHTML;
		if (this.actions)
		{
			this.actions.bindContainer(tmpElement);
		}
		return tmpElement;
	}

	/**
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @return {string}
	 */
	_noticeHTML(pTitle, pMessage)
	{
		return `<section class="section hld-notice"><div class="notification is-light"><p class="has-text-weight-semibold">${escapeHTML(pTitle)}</p><p>${escapeHTML(pMessage)}</p>` +
			`<p class="mt-3"><a href="#${escapeHTML(this.options.RouteBase)}/${CHOOSER_HASH}">All your dashboards</a></p></div></section>`;
	}

	/**
	 * Paint the list of dashboards this person may open.
	 *
	 * @param {string|Element} pDestination
	 * @param {{ IDProject?: number }} [pContext]
	 * @return {Promise<void>}
	 */
	async renderChooser(pDestination, pContext)
	{
		const tmpProjectID = (pContext && pContext.IDProject) || 0;
		let tmpAvailable;
		try
		{
			tmpAvailable = await this.loadAvailable(tmpProjectID);
		}
		catch (pError)
		{
			this._paint(pDestination, this._noticeHTML('Dashboards are unavailable right now', 'Try again in a minute. If this keeps happening, contact HeadLight support.'));
			return;
		}
		if (tmpAvailable.Dashboards.length < 1)
		{
			this._paint(pDestination, this._noticeHTML('No dashboards yet', 'None of your roles has a dashboard. Your administrator can add one under Dashboard Access in the configuration app.'));
			return;
		}
		/** @type {Record<string, Array<any>>} */
		const tmpByCategory = {};
		for (const tmpDashboard of tmpAvailable.Dashboards)
		{
			const tmpCategory = tmpDashboard.Category || 'Dashboards';
			(tmpByCategory[tmpCategory] = tmpByCategory[tmpCategory] || []).push(tmpDashboard);
		}
		let tmpHTML = '<section class="section hld-chooser">';
		for (const [ tmpCategory, tmpDashboards ] of Object.entries(tmpByCategory))
		{
			tmpHTML += `<h2 class="title is-5">${escapeHTML(tmpCategory)}</h2><div class="columns is-multiline">`;
			for (const tmpDashboard of tmpDashboards)
			{
				const tmpLink = ` data-hl-action="Dashboard.Open" data-hash="${escapeHTML(tmpDashboard.Hash)}"${tmpProjectID ? ` data-id-project="${tmpProjectID}"` : ''}`;
				tmpHTML += `<div class="column is-one-third"><a class="box hld-card"${tmpLink}>` +
					`<p class="has-text-weight-semibold">${escapeHTML(tmpDashboard.Title)}</p>` +
					`<p class="is-size-7">${escapeHTML(tmpDashboard.Description)}</p>` +
					((tmpDashboard.ProjectBound && !tmpProjectID) ? '<p class="is-size-7 has-text-grey mt-2">One project at a time</p>' : '') +
					'</a></div>';
			}
			tmpHTML += '</div>';
		}
		tmpHTML += '</section>';
		this._paint(pDestination, tmpHTML);
	}

	/**
	 * Open a dashboard into a container. With no hash, opens this person's landing dashboard, or the chooser.
	 *
	 * @param {string|Element} pDestination
	 * @param {{ Hash?: string, IDProject?: number, Filter?: string, FilterExperience?: string, Offset?: number, PageSize?: number }} [pRequest]
	 * @return {Promise<void>}
	 */
	async openInto(pDestination, pRequest)
	{
		const tmpRequest = pRequest || {};
		const tmpProjectID = parseInt(String(tmpRequest.IDProject || 0), 10) || 0;
		let tmpAvailable;
		try
		{
			tmpAvailable = await this.loadAvailable(tmpProjectID);
		}
		catch (pError)
		{
			this.log.error(`HeadlightDashboardHost: could not load available dashboards: ${pError.message || pError}`);
			this._paint(pDestination, this._noticeHTML('Dashboards are unavailable right now', 'Try again in a minute. If this keeps happening, contact HeadLight support.'));
			return;
		}
		const tmpHash = tmpRequest.Hash || tmpAvailable.Landing;
		if (!tmpHash)
		{
			// No landing dashboard for this person: an app with its own home page (LIMS → Samples) goes there instead.
			const tmpFallback = (typeof this.options.getFallbackRoute === 'function') ? this.options.getFallbackRoute() : null;
			if (tmpFallback && this.pict.providers.PictRouter)
			{
				this.pict.providers.PictRouter.navigate(tmpFallback);
				return;
			}
			return this.renderChooser(pDestination, { IDProject: tmpProjectID });
		}
		const tmpDashboard = tmpAvailable.Dashboards.find((pDashboard) => pDashboard.Hash === tmpHash);
		if (!tmpDashboard)
		{
			this._paint(pDestination, this._noticeHTML('This dashboard isn\'t available to you', 'None of your roles includes it. If you need it, ask your administrator to add it under Dashboard Access.'));
			return;
		}
		if (tmpDashboard.ProjectBound && !tmpProjectID)
		{
			// Reopen the project they last worked in, in place: navigating would put a step in history that back can't pass.
			const tmpRecentProjectID = this.recentProjects()[0];
			if (tmpRecentProjectID)
			{
				return this.openInto(pDestination, Object.assign({}, tmpRequest, { Hash: tmpHash, IDProject: tmpRecentProjectID }));
			}
			if (this._paint(pDestination, this._frameHTML(tmpDashboard, 0, tmpAvailable)))
			{
				this._mountProjectPicker(tmpDashboard, 0);
			}
			return;
		}
		const tmpFrame = this._paint(pDestination, this._frameHTML(tmpDashboard, tmpProjectID, tmpAvailable));
		if (!tmpFrame)
		{
			return;
		}
		if (tmpDashboard.ProjectBound)
		{
			this.rememberProject(tmpProjectID);
			this._mountProjectPicker(tmpDashboard, tmpProjectID);
		}
		if (tmpDashboard.Kind === 'Legacy')
		{
			return this._openLegacy(tmpDashboard, tmpProjectID);
		}
		return this._openDynamic(tmpDashboard, tmpProjectID, tmpRequest.FilterExperience || '', { Filter: tmpRequest.Filter || '', Offset: parseInt(String(tmpRequest.Offset || 0), 10) || 0, PageSize: parseInt(String(tmpRequest.PageSize || 0), 10) || 0 });
	}

	/**
	 * A thin bar across the top of an open dashboard: back to the list, and straight to this person's other dashboards.
	 *
	 * @param {any} pDashboard
	 * @param {number} pIDProject
	 * @param {any} [pAvailable] - The PlatformDashboard/Available response.
	 * @return {string} '' when this is their only dashboard
	 */
	_switcherHTML(pDashboard, pIDProject, pAvailable)
	{
		const tmpOthers = ((pAvailable && Array.isArray(pAvailable.Dashboards)) ? pAvailable.Dashboards : []).filter((pOther) => pOther.Hash !== pDashboard.Hash);
		if (tmpOthers.length < 1)
		{
			return '';
		}
		const tmpProjectAttribute = pIDProject ? ` data-id-project="${pIDProject}"` : '';
		const tmpLinks = (tmpOthers.length <= MAX_SWITCHER_LINKS) ?
			tmpOthers.map((pOther) => `<a data-hl-action="Dashboard.Open" data-hash="${escapeHTML(pOther.Hash)}"${tmpProjectAttribute}>${escapeHTML(pOther.Title)}</a>`).join('<span class="hld-bar-dot" aria-hidden="true">·</span>') : '';
		return `<nav class="hld-bar" aria-label="Your dashboards">` +
			`<a class="hld-bar-all" href="#${escapeHTML(this.routeFor(CHOOSER_HASH, pIDProject))}"><span class="icon is-small"><i class="fas fa-table-cells-large" aria-hidden="true"></i></span><span>All your dashboards</span></a>` +
			(tmpLinks ? `<span class="hld-bar-others"><span class="hld-bar-label">Switch to</span>${tmpLinks}</span>` : '') +
			'</nav>';
	}

	/**
	 * @param {any} pDashboard
	 * @param {number} [pIDProject]
	 * @param {any} [pAvailable] - The PlatformDashboard/Available response.
	 * @return {string}
	 */
	_frameHTML(pDashboard, pIDProject, pAvailable)
	{
		const tmpNotices = libDashboardAccess.describeUnresolved(pDashboard.Unresolved)
			.map((pNotice) => `<div class="notification is-warning is-light hld-unresolved"><p class="has-text-weight-semibold">${escapeHTML(pNotice.Title)}</p><p>${escapeHTML(pNotice.Message)}</p></div>`)
			.join('');
		if (Array.isArray(pDashboard.Unresolved) && pDashboard.Unresolved.length > 0)
		{
			this.log.info(`HeadlightDashboardHost: ${pDashboard.Hash} opened without ${pDashboard.Unresolved.map((pClause) => libDashboardAccess.describeClause(pClause)).join(' and ')} (no value for this person).`);
		}
		const tmpHiddenActions = this.actions ? this.actions.unavailableActionsCSS('.hld-frame') : '';
		const tmpProjectBar = pDashboard.ProjectBound ?
			`<div class="hld-project-bar"><span class="hld-project-label">Project</span><div id="${PROJECT_PICKER_ID}" class="hld-project-picker"></div></div>` : '';
		const tmpBody = (pDashboard.ProjectBound && !pIDProject) ?
			`<div class="hld-project-prompt"><h1 class="title is-4">${escapeHTML(pDashboard.Title)}</h1><p>Shows one project at a time. Choose a project to see it.</p></div>` : '';
		return `<div class="hld-frame${pDashboard.ProjectBound ? ' is-project-bound' : ''}">` +
			(tmpHiddenActions ? `<style>${tmpHiddenActions}</style>` : '') +
			this._switcherHTML(pDashboard, pIDProject || 0, pAvailable) +
			tmpProjectBar +
			tmpNotices +
			`<div id="${BODY_ID}">${tmpBody}</div></div>`;
	}

	/**
	 * Put the project picker in a project-bound dashboard's frame. Choosing a project opens the dashboard for it.
	 *
	 * @param {any} pDashboard
	 * @param {number} pIDProject - 0 when none is chosen yet; the list then opens straight away.
	 */
	_mountProjectPicker(pDashboard, pIDProject)
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function'))
		{
			this.log.warn('HeadlightDashboardHost: Pict-Section-Picker is not registered, so there is no project picker.');
			return;
		}
		this.pict.AppData.HeadlightDashboardProject = { IDProject: pIDProject || 0 };
		const tmpView = tmpPicker.createPicker(PROJECT_PICKER_ID,
			{
				DestinationAddress: `#${PROJECT_PICKER_ID}`,
				ValueAddress: 'AppData.HeadlightDashboardProject.IDProject',
				Searchable: true,
				AllowClear: false,
				EmptyValues: [ 0 ],
				Placeholder: 'Search projects by name or number…',
				EmptyLabel: 'No projects match',
				DataProvider: (pTerm, pPage) => this.searchProjects(pTerm, pPage).catch((pError) =>
				{
					this.log.error(`HeadlightDashboardHost: project search failed: ${pError.message || pError}`);
					return { results: [], hasMore: false };
				}),
				ResolveValue: (pValue) =>
				{
					const tmpID = Number(pValue);
					if (!tmpID)
					{
						return Promise.resolve(null);
					}
					return this._getJSON(`Project/${tmpID}`)
						.then((pProject) => ({ Value: tmpID, Text: (pProject && pProject.Name) || `Project ${tmpID}` }))
						.catch(() => ({ Value: tmpID, Text: `Project ${tmpID}` }));
				},
				OnChange: (pValue) =>
				{
					const tmpID = parseInt(pValue, 10) || 0;
					if (tmpID && tmpID !== pIDProject)
					{
						this.rememberProject(tmpID);
						this.navigateTo(pDashboard.Hash, tmpID);
					}
				},
			});
		if (!tmpView || (typeof tmpView.render !== 'function'))
		{
			return;
		}
		tmpView.render();
		if (!pIDProject && (typeof tmpView.open === 'function'))
		{
			tmpView.open();
		}
	}

	/**
	 * @param {any} pDashboard
	 * @param {number} pIDProject
	 * @param {string} pFilterExperience
	 * @param {{ Filter?: string, Offset?: number, PageSize?: number }} [pPage]
	 * @return {Promise<void>}
	 */
	async _openDynamic(pDashboard, pIDProject, pFilterExperience, pPage)
	{
		if (!this.loader)
		{
			this.log.error('HeadlightDashboardHost: DynamicDashboardLoader provider is not registered.');
			return;
		}
		const tmpExtra = [];
		if (pDashboard.ProjectBound && pDashboard.ProjectField && pIDProject)
		{
			tmpExtra.push(`FBV~${pDashboard.ProjectField}~EQ~${pIDProject}`);
		}
		if (pDashboard.DataFilterString)
		{
			tmpExtra.push(pDashboard.DataFilterString);
		}
		const tmpDrill = this._pendingDrillFilters[pDashboard.Hash];
		if (tmpDrill)
		{
			delete this._pendingDrillFilters[pDashboard.Hash];
			const tmpResolved = libDashboardAccess.resolveClauses(tmpDrill, { User: {}, Context: { IDProject: pIDProject } });
			const tmpDrillString = libDashboardAccess.compileFilter(tmpResolved.Clauses);
			if (tmpDrillString)
			{
				tmpExtra.push(tmpDrillString);
			}
		}
		let tmpEntry;
		try
		{
			tmpEntry = await this.loader.prepareDashboard(pDashboard.Hash, this._customerID(), { ExtraFilter: tmpExtra.join('~'), URLTemplate: this.routeFor(pDashboard.Hash, pIDProject), ShowDescription: this._showDescriptions() });
		}
		catch (pError)
		{
			this.log.error(`HeadlightDashboardHost: could not prepare ${pDashboard.Hash}: ${pError.message || pError}`);
		}
		if (!tmpEntry)
		{
			this._paint(`#${BODY_ID}`, this._noticeHTML(pDashboard.Title, 'This dashboard could not be loaded. Contact HeadLight support if it keeps happening.'));
			return;
		}
		const tmpRecordSet = this.pict.PictSectionRecordSet;
		// A list's paging and search links go to its own /PSRS/<RecordSet>/List routes; a micro app has to allow them.
		if (typeof this.options.onRecordSetPrepared === 'function')
		{
			this.options.onRecordSetPrepared(tmpEntry.RecordSet);
		}
		const tmpIsList = (tmpEntry.Mode === 'List');
		if (!tmpIsList)
		{
			await this.loader.whenProviderReady(tmpEntry.RecordSet);
		}
		const tmpView = tmpIsList ? tmpRecordSet.childViews.list : tmpRecordSet.childViews.dashboard;
		const tmpConfiguration = tmpRecordSet.recordSetProviderConfigurations[tmpEntry.RecordSet];
		const tmpDataSource = tmpEntry.DataSource || {};
		const tmpPrevious = tmpView.options.DefaultDestinationAddress;
		tmpView.options.DefaultDestinationAddress = `#${BODY_ID}`;
		try
		{
			if (tmpIsList)
			{
				this._keepListInHost(pDashboard, pIDProject, tmpEntry.RecordSet);
				const tmpListFilter = composeListFilter(tmpEntry.ScopeFilter || '', pPage && pPage.Filter, !!(pPage && pPage.PageSize), this._lastListFilters[tmpEntry.RecordSet]);
				this._lastListFilters[tmpEntry.RecordSet] = tmpListFilter;
				await tmpView.renderList(tmpConfiguration, `RSP-Provider-${tmpEntry.RecordSet}`, tmpListFilter, pFilterExperience,
					(pPage && pPage.Offset) || 0, (pPage && pPage.PageSize) || DEFAULT_LIST_PAGE_SIZE, false);
			}
			else
			{
				await tmpView.renderSpecificDashboard(pDashboard.Hash, tmpConfiguration, `RSP-Provider-${tmpEntry.RecordSet}`,
					tmpDataSource.ScopeFilter || '', pFilterExperience, 0, tmpDataSource.PageSize || 1000);
			}
		}
		finally
		{
			tmpView.options.DefaultDestinationAddress = tmpPrevious;
		}
	}

	/**
	 * A list's search, sort and page links go to its own `/PSRS/<RecordSet>/List` route, outside the host: the frame, its
	 * notices and dashboard links would be gone, and a micro app refuses that route on a fresh load. Send them to the
	 * host's route instead. Page links are anchors (caught on click); search and sort navigate through the router.
	 *
	 * @param {any} pDashboard
	 * @param {number} pIDProject
	 * @param {string} pRecordSet
	 */
	_keepListInHost(pDashboard, pIDProject, pRecordSet)
	{
		this._listDashboards[pRecordSet] = { Hash: pDashboard.Hash, IDProject: pIDProject || 0 };
		this._installListRouteRedirect();
		const tmpBody = this._element(`#${BODY_ID}`);
		if (!tmpBody)
		{
			return;
		}
		tmpBody.addEventListener('click', (pEvent) =>
		{
			const tmpTarget = /** @type {any} */ (pEvent.target);
			const tmpLink = tmpTarget && (typeof tmpTarget.closest === 'function') ? tmpTarget.closest('a[href]') : null;
			const tmpRoute = tmpLink ? this._redirectListRoute(tmpLink.getAttribute('href')) : null;
			if (!tmpRoute)
			{
				return;
			}
			pEvent.preventDefault();
			const tmpRouter = this.pict.providers.PictRouter;
			if (tmpRouter && typeof tmpRouter.navigate === 'function')
			{
				tmpRouter.navigate(tmpRoute);
			}
		});
	}

	/**
	 * @param {string} pRoute
	 * @return {string|null} the host route for a list dashboard's own list route, or null when it isn't one
	 */
	_redirectListRoute(pRoute)
	{
		const tmpMatch = /^#?\/PSRS\/([^/]+)\/List(?:\/|$)/.exec(typeof pRoute === 'string' ? pRoute : '');
		const tmpDashboard = tmpMatch ? this._listDashboards[tmpMatch[1]] : null;
		const tmpLink = tmpDashboard ? parseListLink(pRoute, tmpMatch[1]) : null;
		if (!tmpLink)
		{
			return null;
		}
		return this.routeFor(tmpDashboard.Hash, tmpDashboard.IDProject, tmpLink);
	}

	/**
	 * Every router navigation (pict-section-recordset's search and sort included) passes through here once a list
	 * dashboard has opened.
	 */
	_installListRouteRedirect()
	{
		const tmpRouter = this.pict.providers.PictRouter && this.pict.providers.PictRouter.router;
		if (this._listRouteRedirectInstalled || !tmpRouter || (typeof tmpRouter.navigate !== 'function'))
		{
			return;
		}
		this._listRouteRedirectInstalled = true;
		const fNavigate = tmpRouter.navigate.bind(tmpRouter);
		tmpRouter.navigate = (pRoute, ...pRest) => fNavigate(this._redirectListRoute(pRoute) || pRoute, ...pRest);
	}

	/**
	 * The legacy app_dashboards bundles are their own pages; frame them and translate their sample request into an
	 * action. The session cookie is scoped to the parent domain, so the frame is signed in already.
	 *
	 * @param {any} pDashboard
	 * @param {number} pIDProject
	 */
	_openLegacy(pDashboard, pIDProject)
	{
		const tmpConfig = (pDashboard.Legacy && pDashboard.Legacy.Config) || {};
		const tmpQuery = [ `projectID=${pIDProject}` ];
		if (tmpConfig.ShowAddSample)
		{
			tmpQuery.push('addNewSamples');
		}
		const tmpURL = `${this.legacyDashboardsBaseURL()}/dashboards/${encodeURIComponent(pDashboard.Hash)}/index.html?${tmpQuery.join('&')}`;
		this._paint(`#${BODY_ID}`, `<iframe class="hld-legacy-frame" title="${escapeHTML(pDashboard.Title)}" src="${escapeHTML(tmpURL)}" style="width:100%;min-height:80vh;border:0;"></iframe>`);
		this._installLegacyListener();
	}

	/**
	 * @return {string} e.g. https://dashboards.qa.headlight.com for a page on lims.qa.headlight.com (no trailing slash)
	 */
	legacyDashboardsBaseURL()
	{
		if (this.options.LegacyDashboardsBaseURL)
		{
			return this.options.LegacyDashboardsBaseURL;
		}
		return this.appBaseURL('dashboards');
	}

	/**
	 * @param {string} pSubdomain - e.g. 'lims', 'dashboards'
	 * @return {string} that app's base URL in this page's environment, no trailing slash
	 */
	appBaseURL(pSubdomain)
	{
		const tmpHostname = (typeof window !== 'undefined' && window.location) ? window.location.hostname : '';
		return libHosts.getAppBaseURL(pSubdomain, libHosts.getEnvironmentFromHostname(tmpHostname)).replace(/\/$/, '');
	}

	_installLegacyListener()
	{
		if (this._legacyListenerInstalled || typeof window === 'undefined')
		{
			return;
		}
		this._legacyListenerInstalled = true;
		window.addEventListener('message', (pEvent) =>
		{
			if (!pEvent || pEvent.origin !== this.legacyDashboardsBaseURL())
			{
				return;
			}
			const tmpAction = libActions.actionFromLegacySamplePayload(pEvent.data);
			if (tmpAction && this.actions)
			{
				this.actions.dispatch(tmpAction);
			}
		});
	}
}

module.exports = HeadlightDashboardHost;
module.exports.default_configuration = { ProviderIdentifier: 'HeadlightDashboardHost' };
module.exports.routePatterns = routePatterns;
module.exports.parseListLink = parseListLink;
module.exports.composeListFilter = composeListFilter;
module.exports.BODY_ID = BODY_ID;
module.exports.CHOOSER_HASH = CHOOSER_HASH;

},{"./Headlight-Dashboard-Actions.js":42,"fable-serviceproviderbase":438,"headlight-dashboard-access":6,"headlight-qrcode/source/Headlight-QRCode-Hosts.js":16}],44:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The screen a host app routes to for dashboards: a thin frame around HeadlightDashboardHost, which does the loading
 * and painting. Other views can embed a dashboard without this view by calling `host.openInto(element, request)`.
 */
class HeadlightDashboardsView extends libPictView
{
	/**
	 * @param {any} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {{ Hash?: string, IDProject?: number, Filter?: string, FilterExperience?: string, Offset?: number, PageSize?: number, Chooser?: boolean }} */
		this.request = {};
	}

	/**
	 * Set what the next render opens; route handlers call this before rendering.
	 *
	 * @param {{ Hash?: string, IDProject?: number|string, Filter?: string, FilterExperience?: string, Offset?: number|string, PageSize?: number|string, Chooser?: boolean }} pRequest
	 */
	setRequest(pRequest)
	{
		const tmpRequest = pRequest || {};
		this.request =
		{
			Hash: tmpRequest.Hash ? decodeURIComponent(String(tmpRequest.Hash)) : undefined,
			IDProject: parseInt(String(tmpRequest.IDProject || 0), 10) || undefined,
			Filter: tmpRequest.Filter ? String(tmpRequest.Filter) : undefined,
			FilterExperience: tmpRequest.FilterExperience ? decodeURIComponent(String(tmpRequest.FilterExperience)) : undefined,
			Offset: parseInt(String(tmpRequest.Offset || 0), 10) || undefined,
			PageSize: parseInt(String(tmpRequest.PageSize || 0), 10) || undefined,
			Chooser: !!tmpRequest.Chooser,
		};
	}

	/**
	 * @param {any} pRenderable
	 * @return {any}
	 */
	onAfterRender(pRenderable)
	{
		const tmpHost = this.pict.providers.HeadlightDashboardHost;
		if (tmpHost)
		{
			if (this.request.Chooser)
			{
				tmpHost.renderChooser('#HeadlightDashboards-Host', { IDProject: this.request.IDProject });
			}
			else
			{
				tmpHost.openInto('#HeadlightDashboards-Host', this.request);
			}
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = HeadlightDashboardsView;

module.exports.default_configuration =
{
	ViewIdentifier: 'HeadlightDashboards',
	DefaultRenderable: 'HeadlightDashboards-Wrap',
	DefaultDestinationAddress: '#HeadlightDashboards-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.hld-chooser .hld-card { display: block; height: 100%; }
		.hld-frame.is-project-bound { background: var(--theme-color-background-panel, #fff); }
		.hld-project-bar { display: flex; align-items: center; gap: 0.75rem; padding: 0.75rem 15px; border-bottom: 1px solid var(--theme-color-border-light, #e5e7eb); }
		.hld-project-label { font-weight: 600; white-space: nowrap; color: var(--theme-color-text-secondary, inherit); }
		.hld-project-picker { flex: 1; min-width: 0; max-width: 40rem; }
		.hld-project-prompt { padding: 2rem 15px; min-height: 50vh; }
		.hld-project-prompt .title { margin-bottom: 0.5rem; }
		.hld-project-prompt p { color: var(--theme-color-text-muted, inherit); }
		.hld-frame:not(.is-project-bound) { padding: 0 3rem 3rem; }
		@media screen and (max-width: 768px) { .hld-frame:not(.is-project-bound) { padding: 0 1rem 2rem; } }
		.hld-bar { display: flex; flex-wrap: wrap; align-items: baseline; gap: 0.25rem 1.25rem; padding: 0.5rem 15px; font-size: 0.875rem; }
		.hld-frame:not(.is-project-bound) .hld-bar { padding: 0 0 0.75rem; }
		.hld-bar-all { display: inline-flex; align-items: center; gap: 0.35rem; font-weight: 600; }
		.hld-bar-others { display: inline-flex; flex-wrap: wrap; align-items: baseline; gap: 0.25rem 0.5rem; }
		.hld-bar-label { color: var(--theme-color-text-muted, #6b7280); }
		.hld-bar-dot { color: var(--theme-color-text-muted, #6b7280); }
		.hld-unresolved { margin: 1rem 1.5rem 0; }
		.hld-frame:not(.is-project-bound) .hld-unresolved { margin: 0 0 1rem; }
	`,

	Templates:
	[
		{
			Hash: 'HeadlightDashboards-Template',
			Template: '<div id="HeadlightDashboards-Host" class="hld-host"></div>',
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'HeadlightDashboards-Wrap',
			TemplateHash: 'HeadlightDashboards-Template',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":733}],45:[function(require,module,exports){
/**
 * headlight-dashboards — configurable dashboards for pict apps.
 *
 * `install(pict, options)` adds everything a host needs: the loader (in embedded mode unless the host owns the page),
 * the action bus, the host provider, the dashboards view and (if the app has none) the searchable picker the host uses
 * to choose a project. The host then routes `routePatterns()` to the view and
 * registers handlers for the actions it can take.
 */
const libPictSectionPicker = require('pict-section-picker');

const DynamicDashboardLoader = require('./DynamicDashboardLoader.js');
const DashboardExporter = require('./DashboardExporter.js');
const HeadlightDashboardActions = require('./Headlight-Dashboard-Actions.js');
const HeadlightDashboardHost = require('./Headlight-Dashboard-Host.js');
const HeadlightDashboardsView = require('./Headlight-Dashboards-View.js');

/**
 * @typedef {Object} InstallOptions
 * @property {boolean} [AppChrome] - true only for the app that owns the page (the data app). Default false.
 * @property {string} [RouteBase] - Default '/Dashboards'.
 * @property {string} [DestinationAddress] - Where the dashboards view renders.
 * @property {'native'|'parent'|null} [Transport] - Where unhandled actions go.
 * @property {string} [ParentOrigin] - Required with Transport 'parent'.
 * @property {Array<string>|null} [TransportActions] - The actions the framing app can take; null for all.
 * @property {string} [LegacyDashboardsBaseURL] - Override for the app_dashboards host.
 * @property {() => number} [getCustomerID] - Where the host keeps the session's customer, when not in AppData.CurrentUser.
 * @property {() => string|null} [getFallbackRoute] - Where `RouteBase` alone goes for someone with no landing dashboard;
 *   without one they get the list of their dashboards.
 * @property {() => boolean} [getShowDescriptions] - true shows each open dashboard's Description under its title.
 * @property {(pRecordSet: string) => void} [onRecordSetPrepared] - Called with each dashboard recordset before it renders,
 *   so a micro app can allow its /PSRS/<RecordSet>/... routes (list paging and search use them).
 */

/**
 * @param {any} pPict
 * @param {InstallOptions} [pOptions]
 * @return {{ host: any, actions: any, view: any }}
 */
function install(pPict, pOptions)
{
	const tmpOptions = pOptions || {};
	if (!pPict.providers.DynamicDashboardLoader)
	{
		pPict.addProvider('DynamicDashboardLoader', { AppChrome: tmpOptions.AppChrome === true }, DynamicDashboardLoader);
	}
	if (!pPict.providers['Pict-Section-Picker'])
	{
		pPict.addProvider('Pict-Section-Picker', libPictSectionPicker.default_configuration, libPictSectionPicker);
	}
	if (!pPict.providers.DashboardExporter)
	{
		pPict.addProvider('DashboardExporter', {}, DashboardExporter);
	}
	if (!pPict.providers.HeadlightDashboardActions)
	{
		pPict.addProvider('HeadlightDashboardActions', { Transport: tmpOptions.Transport || null, ParentOrigin: tmpOptions.ParentOrigin || null, TransportActions: tmpOptions.TransportActions || null }, HeadlightDashboardActions);
	}
	if (!pPict.providers.HeadlightDashboardHost)
	{
		pPict.addProvider('HeadlightDashboardHost',
			{
				RouteBase: tmpOptions.RouteBase || '/Dashboards',
				LegacyDashboardsBaseURL: tmpOptions.LegacyDashboardsBaseURL || null,
				getCustomerID: tmpOptions.getCustomerID || null,
				getFallbackRoute: tmpOptions.getFallbackRoute || null,
				getShowDescriptions: tmpOptions.getShowDescriptions || null,
				onRecordSetPrepared: tmpOptions.onRecordSetPrepared || null,
			}, HeadlightDashboardHost);
	}
	if (!pPict.views.HeadlightDashboards)
	{
		const tmpViewOptions = tmpOptions.DestinationAddress ? { DefaultDestinationAddress: tmpOptions.DestinationAddress } : {};
		pPict.addView('HeadlightDashboards', tmpViewOptions, HeadlightDashboardsView);
	}
	const tmpHost = pPict.providers.HeadlightDashboardHost;
	const tmpActions = pPict.providers.HeadlightDashboardActions;
	if (!tmpActions.handlers['Dashboard.Open'])
	{
		tmpActions.registerHandler('Dashboard.Open', (pAction) => tmpHost.navigateTo(pAction.Hash, pAction.IDProject, pAction.Filters));
	}
	// A dashboard list can render outside the host's frame (an app's own /PSRS route), so its links are heard page-wide.
	if (typeof document !== 'undefined' && document.documentElement)
	{
		tmpActions.bindContainer(document.documentElement);
	}
	return { host: tmpHost, actions: tmpActions, view: pPict.views.HeadlightDashboards };
}

/**
 * Read a route payload into a view request.
 *
 * @param {{ data?: Record<string, string> }} pRouteData
 * @return {{ Hash?: string, IDProject?: string, Filter?: string, FilterExperience?: string, Offset?: string, PageSize?: string, Chooser?: boolean }}
 */
function requestFromRoute(pRouteData)
{
	const tmpData = (pRouteData && pRouteData.data) || {};
	if (tmpData.Hash === HeadlightDashboardHost.CHOOSER_HASH)
	{
		return { IDProject: tmpData.IDProject, Chooser: true };
	}
	return { Hash: tmpData.Hash, IDProject: tmpData.IDProject, Filter: tmpData.Filter, FilterExperience: tmpData.FilterExperience, Offset: tmpData.Offset, PageSize: tmpData.PageSize, Chooser: false };
}

/**
 * Register the dashboard routes with a host's router.
 *
 * @param {any} pPict
 * @param {(pRoute: string, fHandler: (pRouteData: any) => void) => void} fAddRoute - The host's addRoute.
 * @param {(pViewIdentifier: string) => void} fRenderView - The host's way of rendering a routed view.
 * @param {string} [pRouteBase]
 */
function addRoutes(pPict, fAddRoute, fRenderView, pRouteBase)
{
	const tmpBase = pRouteBase || '/Dashboards';
	for (const tmpPattern of HeadlightDashboardHost.routePatterns(tmpBase))
	{
		fAddRoute(tmpPattern, (pRouteData) =>
		{
			pPict.views.HeadlightDashboards.setRequest(requestFromRoute(pRouteData));
			fRenderView('HeadlightDashboards');
		});
	}
}

module.exports =
{
	install,
	addRoutes,
	requestFromRoute,
	routePatterns: HeadlightDashboardHost.routePatterns,
	CHOOSER_HASH: HeadlightDashboardHost.CHOOSER_HASH,
	ACTIONS: HeadlightDashboardActions.ACTIONS,
	DynamicDashboardLoader,
	DashboardExporter,
	HeadlightDashboardActions,
	HeadlightDashboardHost,
	HeadlightDashboardsView,
};

},{"./DashboardExporter.js":40,"./DynamicDashboardLoader.js":41,"./Headlight-Dashboard-Actions.js":42,"./Headlight-Dashboard-Host.js":43,"./Headlight-Dashboards-View.js":44,"pict-section-picker":711}],46:[function(require,module,exports){
'use strict';
/**
 * Workbook-Writer.js — a minimal, zero-dependency OOXML (.xlsx) writer.
 *
 * WHY THIS EXISTS RATHER THAN A LIBRARY. The dashboards need a flat grid with a
 * header row, frozen panes and real numeric cells -- the thinnest slice of the
 * spreadsheet spec. Measured against this bundle with its own toolchain, SheetJS
 * costs +865 KB and ExcelJS +943 KB (roughly +20% of a 4.3 MB bundle), while this
 * writer costs about +5.7 KB. A library buys formulas, charts, images, merged
 * cells and reading .xlsx back in; none of that is wanted here. If any of it ever
 * is, the trade flips and SheetJS is the answer.
 *
 * What it does NOT do, stated plainly so nobody discovers it the hard way:
 * no formulas, no merged cells, no autofilter, no date cells (dates go out as
 * strings), no cell-level number formats. Column widths and a bold header are in.
 *
 * Browser-safe by construction: Uint8Array only, no node builtins, nothing that
 * browserify has to shim.
 *
 * @author HeadLight
 */

/** Precomputed CRC-32 table; the zip central directory needs a CRC per entry. */
const _CRCTable = (() =>
{
	const tmpTable = new Int32Array(256);
	for (let i = 0; i < 256; i++)
	{
		let tmpValue = i;
		for (let j = 0; j < 8; j++)
		{
			tmpValue = (tmpValue & 1) ? (0xEDB88320 ^ (tmpValue >>> 1)) : (tmpValue >>> 1);
		}
		tmpTable[i] = tmpValue;
	}
	return tmpTable;
})();

/**
 * @param {Uint8Array} pBuffer
 * @return {number} The CRC-32 of the buffer.
 */
function crc32(pBuffer)
{
	let tmpCRC = -1;
	for (let i = 0; i < pBuffer.length; i++)
	{
		tmpCRC = _CRCTable[(tmpCRC ^ pBuffer[i]) & 0xFF] ^ (tmpCRC >>> 8);
	}
	return (tmpCRC ^ -1) >>> 0;
}

/**
 * UTF-8 encode. Written out rather than relying on TextEncoder because this app's
 * browserslist still resolves old browsers, and a missing TextEncoder would fail
 * at the moment of export rather than at load.
 *
 * @param {string} pText
 * @return {Uint8Array}
 */
function encodeUTF8(pText)
{
	const tmpText = String(pText == null ? '' : pText);
	if (typeof TextEncoder !== 'undefined') { return new TextEncoder().encode(tmpText); }
	const tmpBytes = [];
	for (let i = 0; i < tmpText.length; i++)
	{
		let tmpCode = tmpText.charCodeAt(i);
		if (tmpCode < 0x80) { tmpBytes.push(tmpCode); }
		else if (tmpCode < 0x800) { tmpBytes.push(0xC0 | (tmpCode >> 6), 0x80 | (tmpCode & 0x3F)); }
		else if ((tmpCode >= 0xD800) && (tmpCode <= 0xDBFF))
		{
			// Surrogate pair -> one code point.
			const tmpLow = tmpText.charCodeAt(++i);
			tmpCode = 0x10000 + ((tmpCode - 0xD800) << 10) + (tmpLow - 0xDC00);
			tmpBytes.push(0xF0 | (tmpCode >> 18), 0x80 | ((tmpCode >> 12) & 0x3F), 0x80 | ((tmpCode >> 6) & 0x3F), 0x80 | (tmpCode & 0x3F));
		}
		else { tmpBytes.push(0xE0 | (tmpCode >> 12), 0x80 | ((tmpCode >> 6) & 0x3F), 0x80 | (tmpCode & 0x3F)); }
	}
	return new Uint8Array(tmpBytes);
}

/**
 * Pack files into a STORE (uncompressed) zip.
 *
 * STORE rather than DEFLATE keeps this dependency-free. The cost is file size on
 * very large exports; XML compresses well, so a deflate path is the upgrade if
 * that ever bites -- see the note in the module header.
 *
 * @param {Array<{name:string, data:Uint8Array}>} pFiles
 * @return {Uint8Array} The zip bytes.
 */
function storeZip(pFiles)
{
	const tmpParts = [];
	const tmpCentral = [];
	let tmpOffset = 0;
	const u16 = (pValue) => [ pValue & 0xFF, (pValue >>> 8) & 0xFF ];
	const u32 = (pValue) => [ pValue & 0xFF, (pValue >>> 8) & 0xFF, (pValue >>> 16) & 0xFF, (pValue >>> 24) & 0xFF ];
	for (const tmpFile of pFiles)
	{
		const tmpNameBytes = encodeUTF8(tmpFile.name);
		const tmpCRC = crc32(tmpFile.data);
		const tmpSize = tmpFile.data.length;
		// 0x0800 = the UTF-8 filename flag.
		const tmpLocal = new Uint8Array([].concat(
			u32(0x04034b50), u16(20), u16(0x0800), u16(0), u16(0), u16(0),
			u32(tmpCRC), u32(tmpSize), u32(tmpSize), u16(tmpNameBytes.length), u16(0)));
		tmpParts.push(tmpLocal, tmpNameBytes, tmpFile.data);
		tmpCentral.push(new Uint8Array([].concat(
			u32(0x02014b50), u16(20), u16(20), u16(0x0800), u16(0), u16(0), u16(0),
			u32(tmpCRC), u32(tmpSize), u32(tmpSize), u16(tmpNameBytes.length),
			u16(0), u16(0), u16(0), u16(0), u32(0), u32(tmpOffset))), tmpNameBytes);
		tmpOffset += tmpLocal.length + tmpNameBytes.length + tmpSize;
	}
	const tmpDirectoryStart = tmpOffset;
	let tmpDirectorySize = 0;
	for (const tmpEntry of tmpCentral) { tmpDirectorySize += tmpEntry.length; }
	const tmpEnd = new Uint8Array([].concat(
		u32(0x06054b50), u16(0), u16(0), u16(pFiles.length), u16(pFiles.length),
		u32(tmpDirectorySize), u32(tmpDirectoryStart), u16(0)));
	let tmpTotal = 0;
	for (const tmpPart of tmpParts) { tmpTotal += tmpPart.length; }
	tmpTotal += tmpDirectorySize + tmpEnd.length;
	const tmpOut = new Uint8Array(tmpTotal);
	let tmpCursor = 0;
	for (const tmpPart of tmpParts) { tmpOut.set(tmpPart, tmpCursor); tmpCursor += tmpPart.length; }
	for (const tmpEntry of tmpCentral) { tmpOut.set(tmpEntry, tmpCursor); tmpCursor += tmpEntry.length; }
	tmpOut.set(tmpEnd, tmpCursor);
	return tmpOut;
}

/** @param {*} pValue @return {string} XML-escaped text. */
const escapeXML = (pValue) => String(pValue == null ? '' : pValue)
	.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** @param {number} pIndex @return {string} Zero-based column index as A, B, ... AA. */
function columnName(pIndex)
{
	let tmpName = '';
	let tmpIndex = pIndex + 1;
	while (tmpIndex > 0)
	{
		const tmpRemainder = (tmpIndex - 1) % 26;
		tmpName = String.fromCharCode(65 + tmpRemainder) + tmpName;
		tmpIndex = (tmpIndex - tmpRemainder - 1) / 26;
	}
	return tmpName;
}

/**
 * A workbook sheet's XML.
 *
 * A cell is numeric ONLY when the value is already a JS number -- the caller
 * decides what becomes a number and what stays text. That split is deliberate:
 * these dashboards store measurements as STRINGS on purpose, to keep arbitrary
 * precision away from JavaScript's float mantissa, so the conversion belongs at
 * the one boundary where a number is actually required and must be done against
 * the column's declared precision.
 *
 * @param {{name:string, columns:Array<{Label:string}>, rows:Array<Array<*>>}} pSheet
 * @return {string}
 */
function buildSheetXML(pSheet)
{
	const tmpRows = [];
	tmpRows.push('<row r="1">' + pSheet.columns.map((pColumn, pIndex) =>
		`<c r="${columnName(pIndex)}1" s="1" t="inlineStr"><is><t xml:space="preserve">${escapeXML(pColumn.Label)}</t></is></c>`).join('') + '</row>');
	pSheet.rows.forEach((pRow, pRowIndex) =>
	{
		tmpRows.push(`<row r="${pRowIndex + 2}">` + pRow.map((pValue, pIndex) =>
		{
			const tmpRef = `${columnName(pIndex)}${pRowIndex + 2}`;
			if ((typeof pValue === 'number') && isFinite(pValue)) { return `<c r="${tmpRef}"><v>${pValue}</v></c>`; }
			return `<c r="${tmpRef}" t="inlineStr"><is><t xml:space="preserve">${escapeXML(pValue)}</t></is></c>`;
		}).join('') + '</row>');
	});

	// Column widths from the header text and a sample of the body, so a reviewer
	// does not open the file to a grid of ##### and have to size every column.
	const tmpWidths = pSheet.columns.map((pColumn, pIndex) =>
	{
		let tmpWidest = String(pColumn.Label || '').length;
		const tmpSampleCount = Math.min(pSheet.rows.length, 200);
		for (let i = 0; i < tmpSampleCount; i++)
		{
			const tmpCell = pSheet.rows[i][pIndex];
			const tmpLength = String(tmpCell == null ? '' : tmpCell).length;
			if (tmpLength > tmpWidest) { tmpWidest = tmpLength; }
		}
		return Math.max(8, Math.min(46, tmpWidest + 2));
	});
	const tmpCols = '<cols>' + tmpWidths.map((pWidth, pIndex) =>
		`<col min="${pIndex + 1}" max="${pIndex + 1}" width="${pWidth}" customWidth="1"/>`).join('') + '</cols>';

	return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
		'<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
		'<sheetViews><sheetView workbookViewId="0">' +
		'<pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/>' +
		'</sheetView></sheetViews>' +
		tmpCols +
		`<sheetData>${tmpRows.join('')}</sheetData></worksheet>`;
}

/**
 * Excel rejects a workbook whose sheet names collide, contain []:*?/\\ or exceed
 * 31 characters -- and it rejects it SILENTLY, as "we found a problem with some
 * content", which is a miserable thing to debug. Sanitise here, once.
 *
 * @param {Array<{name:string}>} pSheets
 * @return {Array<string>} Safe, unique sheet names in the same order.
 */
function resolveSheetNames(pSheets)
{
	const tmpUsed = {};
	return pSheets.map((pSheet, pIndex) =>
	{
		let tmpName = String(pSheet.name || `Sheet${pIndex + 1}`).replace(/[\[\]:*?\/\\]/g, ' ').trim().slice(0, 31);
		if (!tmpName) { tmpName = `Sheet${pIndex + 1}`; }
		let tmpCandidate = tmpName;
		let tmpSuffix = 2;
		while (tmpUsed[tmpCandidate.toLowerCase()])
		{
			const tmpTrimmed = tmpName.slice(0, 31 - String(tmpSuffix).length - 1);
			tmpCandidate = `${tmpTrimmed} ${tmpSuffix}`;
			tmpSuffix++;
		}
		tmpUsed[tmpCandidate.toLowerCase()] = true;
		return tmpCandidate;
	});
}

/**
 * Build a complete .xlsx.
 *
 * @param {Array<{name:string, columns:Array<{Label:string}>, rows:Array<Array<*>>}>} pSheets
 * @return {Uint8Array} The .xlsx bytes, ready for a Blob.
 */
function buildXLSX(pSheets)
{
	const tmpSheets = (Array.isArray(pSheets) && pSheets.length > 0) ? pSheets : [ { name: 'Sheet1', columns: [], rows: [] } ];
	const tmpNames = resolveSheetNames(tmpSheets);
	const tmpFiles = [];

	tmpFiles.push({ name: '[Content_Types].xml', data: encodeUTF8(
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
		'<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' +
		'<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' +
		'<Default Extension="xml" ContentType="application/xml"/>' +
		'<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' +
		tmpSheets.map((pSheet, pIndex) =>
			`<Override PartName="/xl/worksheets/sheet${pIndex + 1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join('') +
		'<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>' +
		'</Types>') });

	tmpFiles.push({ name: '_rels/.rels', data: encodeUTF8(
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
		'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
		'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>' +
		'</Relationships>') });

	tmpFiles.push({ name: 'xl/workbook.xml', data: encodeUTF8(
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
		'<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" ' +
		'xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>' +
		tmpNames.map((pName, pIndex) => `<sheet name="${escapeXML(pName)}" sheetId="${pIndex + 1}" r:id="rId${pIndex + 1}"/>`).join('') +
		'</sheets></workbook>') });

	tmpFiles.push({ name: 'xl/_rels/workbook.xml.rels', data: encodeUTF8(
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
		'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
		tmpSheets.map((pSheet, pIndex) =>
			`<Relationship Id="rId${pIndex + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${pIndex + 1}.xml"/>`).join('') +
		`<Relationship Id="rId${tmpSheets.length + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>` +
		'</Relationships>') });

	tmpFiles.push({ name: 'xl/styles.xml', data: encodeUTF8(
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
		'<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
		'<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font>' +
		'<font><b/><color rgb="FFFFFFFF"/><sz val="11"/><name val="Calibri"/></font></fonts>' +
		'<fills count="3"><fill><patternFill patternType="none"/></fill>' +
		'<fill><patternFill patternType="gray125"/></fill>' +
		'<fill><patternFill patternType="solid"><fgColor rgb="FF3273DC"/><bgColor indexed="64"/></patternFill></fill></fills>' +
		'<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>' +
		'<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' +
		'<cellXfs count="2"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>' +
		'<xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/></cellXfs>' +
		'</styleSheet>') });

	tmpSheets.forEach((pSheet, pIndex) =>
	{
		tmpFiles.push({ name: `xl/worksheets/sheet${pIndex + 1}.xml`, data: encodeUTF8(buildSheetXML(pSheet)) });
	});

	return storeZip(tmpFiles);
}

module.exports = { buildXLSX, storeZip, encodeUTF8, escapeXML, columnName, resolveSheetNames };

},{}],47:[function(require,module,exports){

/** @type{Record<string, typeof import('pict-provider')>} */
const providers = {};
providers.BridgeDisplay = require('./providers/PictProvider-InputType-BridgeDisplay.js');
providers.BridgeSelector = require('./providers/PictProvider-InputType-BridgeSelector.js');
providers['Bulma-HTML'] = require('./providers/PictProvider-Bulma-HTML.js');
providers['Bulma-Markdown'] = require('./providers/PictProvider-Bulma-Markdown.js');
// InputType MarkdownDisplay: the value-bound sibling of Markdown, for a remark a user typed.
providers['Bulma-MarkdownDisplay'] = require('./providers/PictProvider-Bulma-MarkdownDisplay.js');
providers['Bulma-MaterialsQRCodeDisplay'] = require('./providers/PictProvider-Bulma-MaterialsQRCodeDisplay.js');
providers['Bulma-TableControls'] = require('./providers/PictProvider-Bulma-TableControls.js');
providers['Bulma-RecordSetControls'] = require('./providers/PictProvider-Bulma-RecordSetControls.js');
providers.DataTypeDatePicker = require('./providers/PictProvider-DataType-DatePicker.js');
providers.DataTypeDateTimePicker = require('./providers/PictProvider-DataType-DateTimePicker.js');
providers.DataTypeTimePicker = require('./providers/PictProvider-DataType-TimePicker.js');
providers.DatePickerProvider = require('./providers/PictProvider-DataType-DatePicker.js');
providers.DateTimePickerProvider = require('./providers/PictProvider-DataType-DateTimePicker.js');
providers.DraggableUtil = require('./providers/PictProvider-DraggableUtil.js');
providers.EmailAddressProvider = require('./providers/PictProvider-InputType-EmailAddress.js');
providers.EntityBundleClient = require('./providers/PictProvider-EntityBundleClient.js');
providers.FlatpickrUtilProvider = require('./providers/PictProvider-FlatpickrUtil.js');
providers.InputValidation = require('./providers/PictProvider-InputValidation.js');
providers.ChipTooltips = require('./providers/PictProvider-ChipTooltips.js');
providers.NumberScrollLock = require('./providers/PictProvider-NumberScrollLock.js');
providers.LabDisplay = require('./providers/PictProvider-InputType-LabDisplay.js');
providers.LabSelector = require('./providers/PictProvider-InputType-LabSelector.js');
providers.SampleTypeSelector = require('./providers/PictProvider-InputType-SampleTypeSelector.js');
providers.LineItemDisplay = require('./providers/PictProvider-InputType-LineItemDisplay.js');
providers.LineItemSelector = require('./providers/PictProvider-InputType-LineItemSelector.js');
providers.GeolocationSelector = require('./providers/PictProvider-InputType-GeolocationSelector.js');
providers.MaterialDisplay = require('./providers/PictProvider-InputType-MaterialDisplay.js');
providers.MaterialSelector = require('./providers/PictProvider-InputType-MaterialSelector.js');
providers.MixSpecificationDisplay = require('./providers/PictProvider-InputType-MixSpecificationDisplay.js');
providers.MixSpecificationSelector = require('./providers/PictProvider-InputType-MixSpecificationSelector.js');
providers.ObservationCardDeckProvider = require('./providers/PictProvider-InputType-ObservationCardDeck.js');
providers.ObservationTypeDisplay = require('./providers/PictProvider-InputType-ObservationTypeDisplay.js');
providers.ObservationTypeSelector = require('./providers/PictProvider-InputType-ObservationTypeSelector.js');
providers.PhoneNumberProvider = require('./providers/PictProvider-InputType-PhoneNumber.js');
providers.PhysicalAssetSelector = require('./providers/PictProvider-InputType-PhysicalAssetSelector.js');
providers.PlantDisplay = require('./providers/PictProvider-InputType-PlantDisplay.js');
providers.PlantSelector = require('./providers/PictProvider-InputType-PlantSelector.js');
providers.FileSelector = require('./providers/PictProvider-InputType-FileSelector.js');
providers.PrecompiledFileSelector = require('./providers/PictProvider-InputType-PrecompiledFileSelector.js');
providers.ObservationPhoto = require('./providers/PictProvider-InputType-ObservationPhoto.js');
providers.ProducerDisplay = require('./providers/PictProvider-InputType-ProducerDisplay.js');
providers.ProducerSelector = require('./providers/PictProvider-InputType-ProducerSelector.js');
providers.ProductDisplay = require('./providers/PictProvider-InputType-ProductDisplay.js');
providers.ProductSelector = require('./providers/PictProvider-InputType-ProductSelector.js');
providers.EntityDisplay = require('./providers/PictProvider-InputType-EntityDisplay.js');
providers.EntitySelector = require('./providers/PictProvider-InputType-EntitySelector.js');
providers.EntityDisplayMultiple = require('./providers/PictProvider-InputType-EntityDisplayMultiple.js');
providers.EntitySelectorMultiple = require('./providers/PictProvider-InputType-EntitySelectorMultiple.js');
// pict-section-picker: the widget provider + the select2-free 'Picker' InputType (a Headlight subclass
// of the module's form-input adapter that adds project + spec-year scoping). Replaces EntitySelectorMultiple.
providers['Pict-Section-Picker'] = require('pict-section-picker');
providers.Picker = require('./providers/PictProvider-InputType-Picker.js');
// Unified test acceptance — the Picker-stack replacement for the legacy SampleTestResult select, plus
// the disclosure that shows its sibling RichText remarks field.
providers.SampleTestAcceptance = require('./providers/PictProvider-InputType-SampleTestAcceptance.js');
// Complex-editor InputTypes from pict-section-form. PSF exports these provider classes but does NOT
// auto-register them (their heavy editor deps are opt-in), so the bundle registers them here under the
// exact hashes the templates' DefaultInputExtensions reference. Each is a Headlight subclass adding the
// inline View/Edit presentation behavior.
// @ts-ignore - subclasses of an external provider class, same shape the Picker registration above has
providers['Pict-Input-Diagram'] = require('./providers/PictProvider-InputType-Diagram.js');
// @ts-ignore
providers['Pict-Input-RichText'] = require('./providers/PictProvider-InputType-RichText.js');
// PickerDisplay: the non-interactive Read/Print display for 'Picker' (resolves value -> label / entity name).
providers.PickerDisplay = require('./providers/PictProvider-InputType-PickerDisplay.js');
// The MaterialsEntitySelector cascade ports, each named by its wave's port-forward template. Each @ts-ignore
// below suppresses the same pict-provider static-identity mismatch the 'Picker' registration above carries.
// @ts-ignore — wave 5: SampleType cascade
providers.SampleTypePicker = require('./providers/PictProvider-InputType-SampleTypePicker.js');
// @ts-ignore — shared cascade base (waves 6-9)
providers.MaterialsCascadePicker = require('./providers/PictProvider-InputType-MaterialsCascadePicker.js');
// @ts-ignore — wave 6: Sample hub
providers.MaterialsSamplePicker = require('./providers/PictProvider-InputType-MaterialsSamplePicker.js');
// @ts-ignore — wave 7: Test driver (save-projection)
providers.MaterialsTestPicker = require('./providers/PictProvider-InputType-MaterialsTestPicker.js');
// @ts-ignore — wave 8: Lab join
providers.MaterialsLabPicker = require('./providers/PictProvider-InputType-MaterialsLabPicker.js');
// @ts-ignore — wave 8: LineItem join
providers.MaterialsLineItemPicker = require('./providers/PictProvider-InputType-MaterialsLineItemPicker.js');
// @ts-ignore — wave 8: Test-Lab join
providers.MaterialsTestLabPicker = require('./providers/PictProvider-InputType-MaterialsTestLabPicker.js');
// @ts-ignore — wave 9: Test injector (__Record opt-out)
providers.MaterialsTestInjectorPicker = require('./providers/PictProvider-InputType-MaterialsTestInjectorPicker.js');
// @ts-ignore — wave 10: the base MaterialsEntitySelector (descriptor-named Entity)
providers.MaterialsEntityPicker = require('./providers/PictProvider-InputType-MaterialsEntityPicker.js');
// @ts-ignore — SampleStatus vocabulary port (managed code list + the test-result status derivation)
providers.SampleStatusPicker = require('./providers/PictProvider-InputType-SampleStatusPicker.js');
// wave 9: Sample Read/Print display (PickerDisplay + QR-image prepend)
providers.MaterialsSamplePickerDisplay = require('./providers/PictProvider-InputType-MaterialsSamplePickerDisplay.js');
providers.MaterialsEntitySelector = require('./providers/PictProvider-InputType-MaterialsEntitySelector.js');
providers.MaterialsEntityDisplay = require('./providers/PictProvider-InputType-MaterialsEntityDisplay.js');
providers.MaterialsSampleSelector = require('./providers/PictProvider-InputType-MaterialsSampleSelector.js');
providers.MaterialsSampleDisplay = require('./providers/PictProvider-InputType-MaterialsSampleDisplay.js');
providers.MaterialsTestInjector = require('./providers/PictProvider-InputType-MaterialsTestInjector.js');
providers.MaterialsTestSectionRemover = require('./providers/PictProvider-InputType-MaterialsTestSectionRemover.js');
providers.MaterialsTestSelector = require('./providers/PictProvider-InputType-MaterialsTestSelector.js');
providers.MaterialsTestDisplay = require('./providers/PictProvider-InputType-MaterialsTestDisplay.js');
providers.MaterialsLineItemSelector = require('./providers/PictProvider-InputType-MaterialsLineItemSelector.js');
providers.MaterialsLabSelector = require('./providers/PictProvider-InputType-MaterialsLabSelector.js');
providers.MaterialsTestLabSelector = require('./providers/PictProvider-InputType-MaterialsTestLabSelector.js');
providers.MaterialsPlantSelector = require('./providers/PictProvider-InputType-MaterialsPlantSelector.js');
providers.MaterialsLabDisplay = require('./providers/PictProvider-InputType-MaterialsLabDisplay.js');
providers.MaterialsLineItemDisplay = require('./providers/PictProvider-InputType-MaterialsLineItemDisplay.js');
providers.SampleStatusSelector = require('./providers/PictProvider-InputType-SampleStatusSelector.js');
providers.SampleTestResult = require('./providers/PictProvider-InputType-SampleTestResult.js');
providers.ProjectDisplay = require('./providers/PictProvider-InputType-ProjectDisplay.js');
providers.ProjectSelector = require('./providers/PictProvider-InputType-ProjectSelector.js');
providers.QRCode = require('./providers/PictProvider-QRCode.js');
providers.ResponsiveUIAdjustmentProvider = require('./providers/PictProvider-ResponsiveUIAdjustment.js');
providers.SampleDisplay = require('./providers/PictProvider-InputType-SampleDisplay.js');
providers.SampleSelector = require('./providers/PictProvider-InputType-SampleSelector.js');
// EntityFilterEngine: the Headlight filter-composition engine extracted from Select2Util (which now
// extends it). Registered on its own so the pict-section-picker 'Picker' broker can call it directly.
providers.EntityFilterEngine = require('./providers/PictProvider-EntityFilterEngine.js');
providers.Select2Util = require('./providers/PictProvider-Select2Util.js');
providers.SpecScopeResolver = require('./providers/PictProvider-SpecScopeResolver.js');
providers.ThroughScopeResolver = require('./providers/PictProvider-ThroughScopeResolver.js');
providers.LabScopeResolver = require('./providers/PictProvider-LabScopeResolver.js');
providers.Station = require('./providers/PictProvider-InputType-Station.js');
providers.TimePickerProvider = require('./providers/PictProvider-DataType-TimePicker.js');
providers.MediaRegistry = require('./providers/PictProvider-MediaRegistry.js');
// MediaDetailCards provider removed — InputType now routes through ObservationCardDeckProvider via template redirect and patchedConfiguration.
providers.SignatureProvider = require('./providers/PictProvider-InputType-Signature.js');
providers.TextAreaProvider = require('./providers/PictProvider-InputType-TextArea.js');
providers.DistillingBundleManager = require('./providers/Pict-Provider-DistillingBundleManager.js');
providers.DistilledInput = require('./providers/Pict-Provider-Input-DistilledInput.js');
providers.DataRequirementsProvider = require('./providers/PictProvider-DataRequirements.js');
// NOTE: We have to 'override' the default Select provider to make trigger groups work since it's hardcoded to `Pict-Input-Select` in the trigger logic
providers['Pict-Input-Select'] = require('./providers/PictProvider-InputType-Select.js');
// Tier-2.5 a11y: Read/Print-theme static-display painter for the Color input, whose locked
// state can't use the `readonly` attribute. Paints a swatch + hex into the display node;
// no-op when that node is absent (Edit theme).
providers['Pict-Input-Color'] = require('./providers/PictProvider-InputType-Color.js');
providers['Pict-Input-TabGroupSelector'] = require('./providers/PictProvider-InputType-TabGroupSelector.js');
providers['Pict-Input-TabSectionSelector'] = require('./providers/PictProvider-InputType-TabSectionSelector.js');

/**
 * @typedef {Object} ThemeProvider
 * @property {String} TemplatePrefix - The template prefix for the theme.
 * @property {Array<Object>} Templates - The templates for the theme.
 * TODO: this is probably incomplete, and definitely not living in the right place; move this eventually
 */

/** @type {Record<string, ThemeProvider>} */
const themes = { };
themes.Base = require('./themes/PictProvider-Theme-Base.js');
themes.Edit = require('./themes/PictProvider-Theme-Edit.js');
themes.Read = require('./themes/PictProvider-Theme-Read.js');
themes.Print = require('./themes/PictProvider-Theme-Print.js');
// Body markup for the Geolocation input types, assembled per presentation by {~GeolocationBody:~}.
const libGeolocationBodies = require('./templates/GeolocationBodies.js');
// Body markup for the Diagram / RichText editor input types, assembled per presentation by {~EditorBody:~}.
const libEditorBodies = require('./templates/EditorBodies.js');
// Target/rel attribute resolution for the Link input type, emitted per anchor by {~LinkTarget:~}.
const libLinkTarget = require('./providers/PictProvider-Template-LinkTarget.js');

const libFilterToggleUI = require('./providers/_FilterToggleUI.js');

/**
 * Escape a value for safe use in both an HTML attribute (double-quoted) and an element text node.
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * The first of pKeys set on a PictForm block, as an HTML attribute; '' when none is set.
 * @param {Record<string, any>} pPictForm
 * @param {Array<string>} pKeys - PictForm keys in priority order.
 * @param {string} pAttribute - The HTML attribute name.
 * @return {string}
 */
function pictFormAttribute(pPictForm, pKeys, pAttribute)
{
	const tmpKey = pKeys.find((pKey) => pPictForm && pPictForm[pKey] !== undefined && pPictForm[pKey] !== null && pPictForm[pKey] !== '');
	return tmpKey ? `${pAttribute}="${escapeHTML(pPictForm[tmpKey])}"` : '';
}

/** @type {Record<string, typeof import('pict-view')>} */
const views = {};
views.FormHeader = require('./views/PictView-FormHeader.js');
views.TestResultsSummary = require('./views/PictView-TestResultsSummary.js');
// @ts-ignore
views.GeolocationSelector = require('./views/PictView-GeolocationSelector.js');

// inject all the templates for the themed views
const themedTemplatesList = require('./templates/_index.js');
for (const template of themedTemplatesList)
{
	for (const [ themeKey, themeTemplate ] of Object.entries(template))
	{
		if (!themes[themeKey])
		{
			themes[themeKey] = {
				TemplatePrefix: 'PictProvider-Theme-' + themeKey,
				Templates: [],
			};
		}
		themes[themeKey].Templates.push(...themeTemplate);
	}
}

class HeadlightDynamicInputsBundle
{
	static getProviderMap()
	{
		return providers;
	}

	static getViewMap()
	{
		return views;
	}

	static getThemeMap()
	{
		return themes;
	}

	/**
	 * The options to register a bundle provider with: the bundle's defaults for that provider, with any
	 * app-supplied option winning. Every registration path must go through this so the defaults apply.
	 *
	 * @param {string} pKey - The provider key from getProviderMap().
	 * @param {Record<string, any>} [pOptions] - App-supplied options for that provider.
	 * @return {Record<string, any>}
	 */
	static getProviderOptions(pKey, pOptions = { })
	{
		// One dropdown open at a time (select2 parity), fleet-wide.
		if (pKey === 'Pict-Section-Picker')
		{
			return Object.assign({ SingleActivePicker: true }, pOptions);
		}
		return pOptions;
	}

	/**
	 * @param {import('pict')} pict
	 */
	constructor(pict)
	{
		this.pict = pict;
	}

	attach(providerOptionsMap = { }, viewOptionsMap = { })
	{
		this.attachProviders(providerOptionsMap);
		this.attachInstructions();
		this.attachViews(viewOptionsMap);
		this.injectThemes();
	}

	attachProviders(providerOptionsMap = { })
	{
		for (const [ key, provider ] of Object.entries(providers))
		{
			this.pict.addProvider(key, HeadlightDynamicInputsBundle.getProviderOptions(key, providerOptionsMap[key] || { }), provider);
		}
	}

	attachViews(viewOptionsMap = { })
	{
		for (const [ key, view ] of Object.entries(views))
		{
			this.pict.addView(key, viewOptionsMap[key] || { }, view);
		}
	}

	injectThemes()
	{
		for (const templateSet of Object.values(themes))
		{
			this.pict.providers.PictFormSectionDefaultTemplateProvider.injectTemplateSet(templateSet);
		}
	}

	attachInstructions()
	{
		// create a label, but also account for extra inline tags, if they exist
		// NOTE: We do this here so that the "label" and any extra tags are all in same
		//	    flex container, so that they can be balanced properly
		this.pict.MetaTemplate.addPattern('{~LabelWithChips:', '~}', (pHash, pData) =>
		{
			// we need to first build the actual label content
			const labelContentTag = `<span${pData.PictForm.Required ? ' class="is-required"' : ''}>${pData.Name}</span>`;
			// if no data or chips, return the label string value
			if (!pData?.PictForm?.Chips) return labelContentTag;
			// if there are chips, build them
			const chips = {};
			// ignore the "Units" chip, as it's handled separately
			// TODO: Remove the script that puts "Units" in the chips object once we're sure it's not needed anymore
			for (const chipKey in pData.PictForm.Chips)
			{
				if (chipKey != 'Units')
				{
					chips[chipKey] = pData.PictForm.Chips[chipKey];
				}
			}
			// here's are basic chip map of known chips (icon, color)
			const chipMap = {
				'ExternalDatabaseID': {
					'icon': 'fa-database',
					'color': 'is-info',
				},
				'New': {
					'icon': 'fa-sparkles',
					'color': 'is-warning',
				},
			};
			// The chip value/id come from server data.
			let template = `<span class="chips">`;
			// todo: implement switch for TabularLabel if other tabular labels are needed
			// check hash for TabularLabel and add the appropriate template
			if (!pHash.includes('TabularLabel'))
			{
				template += `${ labelContentTag }`;
			}
			// Emit each chip as a self-contained, reflow-free anchor. The chip's
			// text lives in `.chip-label` (hidden on screen, revealed only in the
			// Print theme) and is mirrored in `data-chip-label` so the runtime
			// PictProvider-ChipTooltips can wire a pinnable tooltip to the anchor
			// without re-reading the DOM. No inline onclick / is-active here — the
			// provider owns hover + click-to-pin behavior and pin persistence.
			// eslint-disable-next-line guard-for-in
			for (const chipKey in chips)
			{
				const chipObject = {};
				// if it's a custom object, use it
				if (typeof pData.PictForm.Chips[chipKey] == 'object')
				{
					chipObject._id = chipKey;
					chipObject._value = pData.PictForm.Chips[chipKey].Value || pData.PictForm.Chips[chipKey].value || chipKey;
					// set the passed values, or use the map, or use the defaults
					chipObject.icon = pData.PictForm.Chips[chipKey].Icon || pData.PictForm.Chips[chipKey].icon || chipMap?.[chipKey]?.icon || 'fa-info';
					chipObject.color = pData.PictForm.Chips[chipKey].Color || pData.PictForm.Chips[chipKey].color || chipMap?.[chipKey]?.color || 'is-text';
				}
				else if (typeof pData.PictForm.Chips[chipKey] == 'string')
				{
					chipObject._id = chipKey;
					chipObject._value = pData.PictForm.Chips[chipKey];
					// check if it's in the chipMap and if so, use the icon and color (or defaults)
					chipObject.icon = chipMap?.[chipKey]?.icon || 'fa-info';
					chipObject.color = chipMap?.[chipKey]?.color || 'is-text';
				}
				else
				{
					// if it's not a string or object, we don't know what's going on, so skip it
					continue;
				}
				const tmpId = escapeHTML(chipObject._id);
				const tmpValue = escapeHTML(chipObject._value);
				const tmpIcon = escapeHTML(chipObject.icon);
				const tmpColor = escapeHTML(chipObject.color || '');
				template +=
				`<button type="button" class="chip ${tmpColor}"
					data-chip-for="${tmpId}"
					data-chip-label="${tmpValue}"
					data-chip-icon="${tmpIcon}"
					data-chip-color="${tmpColor}"
					aria-label="${tmpId}: ${tmpValue}">
					<span class="icon">
						<i class="fa fa-fw ${tmpIcon}"></i>
					</span>
					<span class="chip-label">${tmpValue}</span>
				</button>`;
			}
			// close the chips span
			template += '</span>';
			// check hash for TabularLabel and add the appropriate template
			if (pHash.includes('TabularLabel'))
			{
				template += `<span class="label">${ labelContentTag }</span>`;
			}
			return template;
		});

		// Start the runtime chip-tooltip wiring (idempotent). attachProviders()
		// runs before attachInstructions() in every host app, so the provider
		// exists here; it lazily wires any chip the MetaTemplate above emits.
		if (this.pict.providers.ChipTooltips && typeof this.pict.providers.ChipTooltips.start === 'function')
		{
			this.pict.providers.ChipTooltips.start();
		}

		this.pict.MetaTemplate.addPattern('{~UnitsAddon:', '~}', (pHash, pData, pContext) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// a table shows units in its column header; a record set has no header, so its units stay beside the field
			if (isTabular && !useInlineUnits && resolveGroupLayout(pData, pContext) !== 'RecordSet')
			{
				return '';
			}
			// if there are units, return the units. aria-hidden keeps the
			// decorative unit pill from being announced as a separate
			// interactive control (already conveyed by the label). (Tier 4)
			return `<p class="control control-status addon">
						<button tabindex="-1" aria-hidden="true" class="addon-button button is-static" type="button">${tmpUnits}</button>
					</p>`;
		});

		// TODO: Consider making Print an optional flag on the previous method
		this.pict.MetaTemplate.addPattern('{~UnitsAddonPrint:', '~}', (pHash, pData, pContext) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// a table shows units in its column header; a record set has no header, so its units stay beside the field
			if (isTabular && !useInlineUnits && resolveGroupLayout(pData, pContext) !== 'RecordSet')
			{
				return '';
			}
			// if there are units, return the units
			return `<span class="control">
				<div class="input is-static has-text-text-50 units-text">${tmpUnits}</div>
			</span>`;
		});

		this.pict.MetaTemplate.addPattern('{~UnitsTabularHeader:', '~}', (pHash, pData) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// if this is tabular and we are using inline units, don't return anything for the header on the table
			if (isTabular && useInlineUnits)
			{
				return '';
			}
			// if there are units, return the units
			return `<div class="tag has-text-centered is-block" style="line-height: 1.5rem">${tmpUnits}</div>`;
		});

		// add the required + aria-required attributes if the field is required.
		// The PictProvider-InputValidation runtime sync may later strip these
		// when the input becomes hidden (e.g. inactive tab) so that the
		// browser/framework's checkValidity() and assistive tech reflect what
		// the user can actually see.
		//
		// a11y tiers (tracked here): Tiers 1, 2, 2.5, 3 (Half A) and 4 are DONE,
		// as is Tier 5. See test/Templates-A11y-Tier2-*.{js,md},
		// test/Templates-A11y-Tier3-*.js and test/Templates-A11y-Tier4-*.js for
		// per-template coverage and the smoke checklist. (Tier 5 is runtime DOM
		// in PictProvider-InputValidation, so it has no string-level test here.)
		//   Tier 1 — aria-required / aria-disabled / aria-invalid / role=alert on validation-text /
		//     aria-describedby help-text pairing (PictProvider-InputValidation).
		//   Tier 2 — Read theme `disabled="disabled"` -> `readonly aria-readonly="true"` on text and
		//     number inputs (incl. Geolocation lat/long; its disableMap gate also treats readonly as
		//     locked). The locked look is preserved by the `[aria-readonly="true"]` rule in
		//     lib/web/headlight-styles/bulma-extended.scss.
		//   Tier 2.5 — non-text controls that can't use `readonly` present a static locked value:
		//     Option/Select2 render the selected LABEL into the DISPLAY-FOR node
		//     (PictProvider-InputType-Select); Boolean keeps a disabled checkbox (filled/empty, matches
		//     Print); Color paints a swatch + hex via PictProvider-InputType-Color in both Read and Print.
		//   Note (by design): the required-label "*" is a CSS ::after pseudo-element, not announced by
		//     mainstream screen readers; switch to an explicit aria-hidden span only if axe flags it.
		//   Note (carry-over): AJAX / dynamic-pick-list selects may show the raw id in the static view
		//     if PictForm.SelectOptions lacks the label (same gap the Print path already had).
		//
		//   Tier 3 (tab semantics) — Half A DONE, Half B intentionally skipped:
		//     Half A (shipped): <ul><li onclick> tab markup carries
		//       role="tablist" / role="presentation" / role="tab" + aria-selected,
		//       and each tab is wired to its panel via aria-controls <-> the
		//       panel's role="tabpanel" + aria-labelledby. The static roles live
		//       in the templates; the stateful aria-selected and the cross-element
		//       relationships (the panel id carries a runtime UUID/formID) are set
		//       in selectTabByViewHash, overridden in the local Tab*Selector
		//       providers. See: templates/InputType-TabSectionSelector.js,
		//            templates/InputType-TabGroupSelector.js,
		//            providers/PictProvider-InputType-Tab{Section,Group}Selector.js.
		//     Half B (NOT done, by decision): roving tabindex + arrow/Home/End
		//       key navigation. Skipped deliberately — tabs are already natively
		//       Tab/Shift+Tab focusable (WCAG 2.x keyboard-operable); roving
		//       tabindex would only trim Tab stops on long strips (ours are 3-5),
		//       and it requires a net-new keydown handler the team prefers to
		//       avoid for non-critical cases. Revisit only if long tab strips or
		//       a specific AT request makes the ergonomics worthwhile; it slots
		//       cleanly into the same provider override with no template churn.
		//
		//   Tier 4 (single-input edge cases) — DONE. See
		//     test/Templates-A11y-Tier4-IconLabels_tests.js.
		//     - Signature: aria-label on the modal drawing canvas + on the
		//       icon-only "edit" (pen) trigger buttons and the modal Undo/Redo
		//       buttons; alt text on every signature-preview <img>.
		//       See: templates/InputType-Signature.js,
		//            providers/PictProvider-InputType-Signature.js.
		//     - Tabular menus: aria-label on the icon-only row-actions ellipsis
		//       trigger; aria-hidden="true" on the decorative fa icons that sit
		//       beside visible text labels. See: templates/Tabular-Group.js.
		//     - aria-hidden="true" on the static-button units addon in
		//       {~UnitsAddon:~} above so the unit pill isn't read as a separate
		//       interactive control.
		//
		//   Tier 5 (richer announcements) — DONE.
		//     - aria-errormessage on the input pointing to the injected
		//       validation-text node's id (paired with the existing
		//       aria-invalid; cleared on every valid/hidden path). Lives in
		//       PictProvider-InputValidation alongside the validation-text
		//       injection in handleValidationHelpTextElementUpdate. Runtime DOM
		//       wiring, so no string-level test in this package.
		//
		// data-required="true" is the *persistent* marker — the manifest's
		// declaration of required-ness. The provider's runtime sync may flip
		// the `required` / `aria-required` attributes on/off as the field
		// becomes visible/hidden (e.g. tab switches), but data-required
		// stays put so we can restore the live attributes for fields that
		// re-appear, and so the pre-submit sweep can find every "ever
		// required" input across the form.
		this.pict.MetaTemplate.addPattern('{~Required:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.Required)
			{
				return 'required aria-required="true" data-required="true"';
			}
			return '';
		});

		// add the disabled + aria-disabled attributes if the field is disabled.
		// aria-disabled mirrors the native disabled state for assistive tech;
		// some screen readers don't announce native disabled consistently
		// across input variants, so emitting both belt-and-suspenders style.
		this.pict.MetaTemplate.addPattern('{~Disabled:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.Disabled)
			{
				return 'disabled aria-disabled="true"';
			}
			return '';
		});

		// Constraint attributes for native validation. Number templates take NumberMin / NumberMax / NumberStep, or
		// MinNumber / MaxNumber / StepNumber, which PictProvider-InputValidation also reads; text templates take
		// MinLength / MaxLength / Pattern.
		this.pict.MetaTemplate.addPattern('{~Min:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'NumberMin', 'MinNumber' ], 'min'));
		this.pict.MetaTemplate.addPattern('{~Max:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'NumberMax', 'MaxNumber' ], 'max'));
		this.pict.MetaTemplate.addPattern('{~Step:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'NumberStep', 'StepNumber' ], 'step') || 'step="any"');
		this.pict.MetaTemplate.addPattern('{~MinLength:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'MinLength' ], 'minlength'));
		this.pict.MetaTemplate.addPattern('{~MaxLength:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'MaxLength' ], 'maxlength'));
		this.pict.MetaTemplate.addPattern('{~Pattern:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'Pattern' ], 'pattern'));

		// manage the placeholder string value at a consistent level
		this.pict.MetaTemplate.addPattern('{~Placeholder:', '~}', (pHash, pData) =>
		{
			// if there is a custom placeholder, use it
			if (typeof pData.PictForm.Placeholder !== 'undefined')
			{
				return `${pData.PictForm.Placeholder}`;
			}
			// or if there is a predefined placeholder, use it
			else
			{
				switch (pData.PictForm.InputType || pData.DataType)
				{
				case 'String':
				case 'TextArea':
					return 'Enter text...';
				case 'Number':
					return '0';
				case 'Option':
				case 'Select':
				case 'Select2':
				case 'Select2Multiple':
					return 'Select...';
				case 'DateTime':
				case 'DateTimePicker':
					return 'Select date/time...';
				case 'Date':
				case 'DatePicker':
					return 'Select date...';
				case 'Time':
				case 'TimePicker':
					return 'Select time...';
				case 'PhoneNumber':
					return '(555) 555-5555';
				case 'EmailAddress':
					return 'yourname@domain.com';
				case 'StreetAddress':
					return '1234 West St.';
				case 'Station':
					return 'station (ex. 23+07)';
				default:
					return '';
				}
			}
		});

		// balance the columns based on the width set in the configuration
		this.pict.MetaTemplate.addPattern('{~ColumnWidth:', '~}', (pHash, pData) =>
		{
			let tmpClasses = '';
			const tmpResponsive = this.pict.providers.ResponsiveUIAdjustmentProvider;
			const tmpRowWidths = tmpResponsive ? tmpResponsive.getProportionalRowWidths(pData) : null;
			if (tmpRowWidths)
			{
				if (tmpRowWidths.Auto)
				{
					return '';
				}
				// a layout-excluded column (explicit zero width / hidden input) must take no horizontal space
				if (tmpRowWidths.Excluded)
				{
					// close the class attribute and open a style attribute
					return `" style="display:none;`;
				}
				return tmpRowWidths.Classes;
			}
			// other apps, and rows outside a Record layout: the per-field Bulma classes
			if (pData.PictForm.Width)
			{
				const tmpWidth = parseFloat(pData.PictForm.Width);
				if (tmpWidth > 0 && tmpWidth <= 12)
				{
					tmpClasses = `is-${tmpWidth}`;
				}
				// if there is a width offset set, add it to the classes
				if (pData.PictForm.WidthOffset)
				{
					const tmpWidthOffset = parseFloat(pData.PictForm.WidthOffset);
					if (tmpWidthOffset > 0 && tmpWidthOffset <= 12)
					{
						tmpClasses += ` is-offset-${tmpWidthOffset}`;
					}
				}
			}

			return tmpClasses;
		});

		this.pict.MetaTemplate.addPattern('{~FilterToggleHidden:', '~}', (pHash, pData) =>
		{
			// Visibility class for the inline "Show All" toggle — hidden unless the descriptor (or its config-map entry) enables it.
			return libFilterToggleUI.isToggleVisible(pData) ? '' : 'is-hidden';
		});

		this.pict.MetaTemplate.addPattern('{~FilterToggleDisabled:', '~}', (pHash, pData) =>
		{
			// Inert class for the inline "Show All" toggle on a read-only / disabled field — filtering a
			// picker whose value cannot change is wasted work, and a live-looking toggle implies otherwise.
			// The class is painted here so there is no enabled->disabled flash; _FilterToggleUI re-applies it
			// at input-initialize for descriptors disabled after render (e.g. DisabledOnceSaved).
			return libFilterToggleUI.isInputDisabled(pData) ? libFilterToggleUI.DISABLED_CLASS : '';
		});
		libFilterToggleUI.ensureFilterToggleCSS(this.pict);

		// support overcrowded columns for the row in the group
		this.pict.MetaTemplate.addPattern('{~ColumnsOvercrowded:', '~}', (pHash, pData) =>
		{
			// if there is a Bulma column class set, use it
			if (pData._OvercrowdedColumns)
			{
				// if the columns are overcrowded, return the class
				return pData._OvercrowdedColumns ? 'is-multiline' : '';
			}
			// otherwise, return an empty string
			return '';
		});

		// Lazily resolve and cache the group layout (Tabular | RecordSet | ...) on the input descriptor
		// so layout-aware macros below can branch on it without re-walking the data-context array.
		/**
		 * @param {any} pDataObject
		 * @param {Array<any>} pContext
		 * @returns {string | null | undefined}
		 */
		const resolveGroupLayout = (pDataObject, pContext) =>
		{
			if (!pDataObject?.PictForm) return undefined;
			if (pDataObject.PictForm._GroupLayout !== undefined) return pDataObject.PictForm._GroupLayout;
			if (!Array.isArray(pContext)) return undefined;
			const tmpView = pContext.find((pEntry) => pEntry && typeof pEntry.getGroup === 'function');
			const tmpGroupIndex = pDataObject.PictForm.GroupIndex;
			if (tmpView && tmpGroupIndex !== undefined)
			{
				const tmpGroup = tmpView.getGroup(tmpGroupIndex);
				pDataObject.PictForm._GroupLayout = tmpGroup?.Layout || null;
			}
			else
			{
				pDataObject.PictForm._GroupLayout = null;
			}
			return pDataObject.PictForm._GroupLayout;
		};

		/**
		 * @param {string} pAlignment - Left, Center or Right, any case
		 * @returns {string} The Bulma text-alignment class, or '' when unrecognized
		 */
		const getAlignmentClass = (pAlignment) =>
		{
			switch (String(pAlignment).toLowerCase())
			{
			case 'left':
				return 'has-text-left';
			case 'center':
				return 'has-text-centered';
			case 'right':
				return 'has-text-right';
			default:
				return '';
			}
		};

		// Templates whose values right-align by default. Matched against the template PSF actually resolves
		// for the descriptor (InputType first, then DataType), so cells and tabular headers can't disagree.
		const RIGHT_ALIGNED_TEMPLATE_POSTFIXES = [ '-Input-DataType-Number', '-Input-DataType-PreciseNumber', '-Input-InputType-PreciseNumberReadOnly', '-Input-InputType-UpdateAwareNumber' ];

		/**
		 * @param {any} pData - The input descriptor
		 * @param {Array<any>} pContext
		 * @returns {boolean}
		 */
		const isRightAlignedByDefault = (pData, pContext) =>
		{
			const tmpView = Array.isArray(pContext) ? pContext.find((pEntry) => pEntry && typeof pEntry.checkThemeSpecificTemplate === 'function') : undefined;
			const tmpTemplateHash = (tmpView && this.pict.providers.DynamicInput) ? this.pict.providers.DynamicInput.getInputTemplateHash(tmpView, pData) : false;
			if (typeof tmpTemplateHash === 'string')
			{
				return RIGHT_ALIGNED_TEMPLATE_POSTFIXES.some((pPostfix) => tmpTemplateHash.endsWith(pPostfix));
			}
			if (pData.PictForm.InputType)
			{
				return RIGHT_ALIGNED_TEMPLATE_POSTFIXES.includes(`-Input-InputType-${pData.PictForm.InputType}`);
			}
			return RIGHT_ALIGNED_TEMPLATE_POSTFIXES.includes(`-Input-DataType-${pData.DataType}`);
		};

		/**
		 * @param {any} pData - The input descriptor
		 * @param {Array<any>} pContext
		 * @returns {string} The alignment class for the input's value
		 */
		const getColumnAlignmentClass = (pData, pContext) =>
		{
			// Numbers stay right even with a ColumnAlignment: CSV-imported manifests carry a blanket "left" on every field.
			if (isRightAlignedByDefault(pData, pContext))
			{
				return 'has-text-right';
			}
			if (pData.PictForm.ColumnAlignment)
			{
				return getAlignmentClass(pData.PictForm.ColumnAlignment);
			}
			// Boolean checkbox cells are usually narrow single-checkbox columns — center in plain Tabular,
			// left everywhere else (standard, vertical, RecordSet)
			if (pData.PictForm.InputType === 'Boolean')
			{
				return resolveGroupLayout(pData, pContext) === 'Tabular' ? 'has-text-centered' : 'has-text-left';
			}
			return '';
		};

		// support column alignment for the input value
		this.pict.MetaTemplate.addPattern('{~ColumnAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData, /** @type {Array<any>} */ pContext) =>
		{
			return getColumnAlignmentClass(pData, pContext);
		});

		// field labels align only when the descriptor opts in with PictForm.LabelAlignment
		this.pict.MetaTemplate.addPattern('{~LabelAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData) =>
		{
			return pData.PictForm.LabelAlignment ? getAlignmentClass(pData.PictForm.LabelAlignment) : '';
		});

		// tabular column headers follow their column's values unless the descriptor sets PictForm.LabelAlignment
		this.pict.MetaTemplate.addPattern('{~TabularHeaderAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData, /** @type {Array<any>} */ pContext) =>
		{
			if (pData.PictForm.LabelAlignment)
			{
				return getAlignmentClass(pData.PictForm.LabelAlignment);
			}
			return getColumnAlignmentClass(pData, pContext);
		});

		// build help text content for vertical forms
		this.pict.MetaTemplate.addPattern('{~SelectOnFocus:', '~}', (pHash, pData) =>
		{
			return `onfocus="this.select();"`;
		});

		// NOTE: These are duplicated in the Panels, but we need them here for the form too.
		// TODO: Determine if we can remove the duplication with a Utility-like meta template collection
		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideContent:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject.Content || tmpDataObject.Default) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowContent:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject.Content || tmpDataObject.Default) ? '' : 'is-hidden';
		});

		// add the ".is-hidden-tablet" class to the input label if PictForm.HideLabel is set
		// NOTE: Mobile devices keep the label, as it's needed for context in a stacked layout
		this.pict.MetaTemplate.addPattern('{~HideLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			const hideLabel = tmpDataObject?.PictForm?.hasOwnProperty('HideLabel') && tmpDataObject?.PictForm?.HideLabel;
			return hideLabel ? 'is-hidden-tablet' : '';
		});

		// For Boolean inputs in a RecordSet layout, hide the cell-prefix "header" label since the checkbox template
		// renders its own inline label. Use "is-invisible" (preserves space) when sibling labels are visible so
		// row alignment matches; collapse fully ("is-hidden") only if PictForm.HideLabel is also set.
		this.pict.MetaTemplate.addPattern('{~HideCheckboxCellLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			if (tmpDataObject?.PictForm?.InputType !== 'Boolean') return '';
			if (resolveGroupLayout(tmpDataObject, pContext) !== 'RecordSet') return '';
			return tmpDataObject.PictForm.HideLabel ? 'is-hidden' : 'is-invisible';
		});

		// For Boolean inputs in a plain Tabular (non-RecordSet) layout, hide the inline checkbox label since
		// the Tabular column header already labels the field — keep visible in RecordSet (no column header there).
		this.pict.MetaTemplate.addPattern('{~HideCheckboxInlineLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			if (tmpDataObject?.PictForm?.InputType !== 'Boolean') return '';
			return resolveGroupLayout(tmpDataObject, pContext) === 'Tabular' ? 'is-hidden' : '';
		});

		// Geolocation input types have two presentations — the full picker (address search + editable
		// lat/long + readout + labeled buttons) and a compact readout bar whose picker lives in an Edit
		// modal. Rather than emit both and hide one, this macro picks the presentation and renders just
		// that body, so ids stay unique and no dead chrome ships in every tabular row. The tag carries
		// the theme (`{~GeolocationBody:Edit~}`); everything else comes off the input descriptor.
		//
		// Full size is the default everywhere and PictForm.Compact opts in — EXCEPT a Tabular table,
		// which is always compact because a full picker cannot fit a table cell. A Record Set stacks its
		// records, so it honors the flag exactly like a Standard field does.
		this.pict.MetaTemplate.addPattern('{~GeolocationBody:', '~}', (pHash, pData, pContext) =>
		{
			const tmpTabular = !!pData?.IsTabular;
			const tmpCompact = (resolveGroupLayout(pData, pContext) === 'Tabular') || !!pData?.PictForm?.Compact;
			const tmpBody = libGeolocationBodies.buildGeolocationBody(
				{
					Theme: `${pHash}`.trim(),
					Compact: tmpCompact,
					HasMap: pData?.PictForm?.InputType === 'GeolocationSelectorWithMap',
					Tabular: tmpTabular,
				});
			// Resolve the body's own tags against this same record + context (the macro output is not
			// re-parsed by the engine).
			return this.pict.parseTemplate(tmpBody, pData, null, pContext);
		});

		// Diagram / RichText editor body. Emits the inline View/Edit presentation for the theme the tag
		// carries (`{~EditorBody:Edit~}`); the InputType comes off the record. Like the geolocation macro,
		// the emitted body still contains {~D:...~} tags, so it is parsed here against the same record.
		this.pict.MetaTemplate.addPattern('{~EditorBody:', '~}', (pHash, pData, pContext) =>
		{
			const tmpBody = libEditorBodies.buildEditorBody(
				{
					Theme: `${pHash}`.trim(),
					InputType: pData?.PictForm?.InputType,
				});
			return this.pict.parseTemplate(tmpBody, pData, null, pContext);
		});

		// add the ".is-hidden" class to the group title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowGroupTitle:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject.hasOwnProperty('ShowTitle') && !tmpDataObject.ShowTitle) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the section title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowSectionTitle:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject.hasOwnProperty('ShowTitle') && !tmpDataObject.ShowTitle) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to a section or group title when ShowTitleInPDF is false; only the Print theme templates use it
		this.pict.MetaTemplate.addPattern('{~ShowTitleInPDF:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject?.hasOwnProperty('ShowTitleInPDF') && !tmpDataObject.ShowTitleInPDF) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the input if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideInPDF:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			let tmpHideFlag = false;
			// input level
			if (tmpDataObject?.hasOwnProperty('PictForm') && tmpDataObject.PictForm && tmpDataObject.PictForm?.hasOwnProperty('InputExtra') && tmpDataObject.PictForm.InputExtra)
			{
				tmpHideFlag = tmpDataObject.PictForm?.InputExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			// group level
			else if (tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				tmpHideFlag = tmpDataObject?.GroupExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			// section level
			else if (tmpDataObject?.hasOwnProperty('SectionExtra') && tmpDataObject.SectionExtra)
			{
				tmpHideFlag = tmpDataObject?.SectionExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			return tmpHideFlag ? 'is-hidden' : '';
		});

		// emit target/rel on Link anchors when the descriptor opts in via PictForm.LinkTarget
		this.pict.MetaTemplate.addPattern('{~LinkTarget:', '~}', (pHash, pData, pContext) =>
		{
			return libLinkTarget.resolveLinkTargetAttributes(this.pict.resolveStateFromAddress(pHash, pData, pContext));
		});

		this.pict.MetaTemplate.addPattern('{~HiddenInputTabularAdjustment:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the input is hidden in a tabular context, we need to add a placeholder to maintain alignment
			// keep in step with addHiddenInputColumns in PictProvider-Bulma-TableControls.js: the colgroup must skip the same columns
			if (tmpDataObject.PictForm?.InputType === 'Hidden' && pData.IsTabular)
			{
				return `is-hidden`;
			}
			return '';
		});

		// human readable count summaries
		this.pict.addTemplate(require('./providers/PictProvider-Template-HumanCount.js'));
	}
}

module.exports = HeadlightDynamicInputsBundle;

},{"./providers/Pict-Provider-DistillingBundleManager.js":48,"./providers/Pict-Provider-Input-DistilledInput.js":49,"./providers/PictProvider-Bulma-HTML.js":50,"./providers/PictProvider-Bulma-Markdown.js":51,"./providers/PictProvider-Bulma-MarkdownDisplay.js":52,"./providers/PictProvider-Bulma-MaterialsQRCodeDisplay.js":53,"./providers/PictProvider-Bulma-RecordSetControls.js":54,"./providers/PictProvider-Bulma-TableControls.js":55,"./providers/PictProvider-ChipTooltips.js":57,"./providers/PictProvider-DataRequirements.js":58,"./providers/PictProvider-DataType-DatePicker.js":59,"./providers/PictProvider-DataType-DateTimePicker.js":60,"./providers/PictProvider-DataType-TimePicker.js":61,"./providers/PictProvider-DraggableUtil.js":62,"./providers/PictProvider-EntityBundleClient.js":63,"./providers/PictProvider-EntityFilterEngine.js":64,"./providers/PictProvider-FlatpickrUtil.js":65,"./providers/PictProvider-InputType-BridgeDisplay.js":66,"./providers/PictProvider-InputType-BridgeSelector.js":67,"./providers/PictProvider-InputType-Color.js":68,"./providers/PictProvider-InputType-Diagram.js":69,"./providers/PictProvider-InputType-EmailAddress.js":72,"./providers/PictProvider-InputType-EntityDisplay.js":73,"./providers/PictProvider-InputType-EntityDisplayMultiple.js":74,"./providers/PictProvider-InputType-EntitySelector.js":75,"./providers/PictProvider-InputType-EntitySelectorMultiple.js":76,"./providers/PictProvider-InputType-FileSelector.js":77,"./providers/PictProvider-InputType-GeolocationSelector.js":79,"./providers/PictProvider-InputType-LabDisplay.js":80,"./providers/PictProvider-InputType-LabSelector.js":81,"./providers/PictProvider-InputType-LineItemDisplay.js":82,"./providers/PictProvider-InputType-LineItemSelector.js":83,"./providers/PictProvider-InputType-MaterialDisplay.js":84,"./providers/PictProvider-InputType-MaterialSelector.js":85,"./providers/PictProvider-InputType-MaterialsCascadePicker.js":86,"./providers/PictProvider-InputType-MaterialsEntityDisplay.js":87,"./providers/PictProvider-InputType-MaterialsEntityPicker.js":88,"./providers/PictProvider-InputType-MaterialsEntitySelector.js":89,"./providers/PictProvider-InputType-MaterialsLabDisplay.js":90,"./providers/PictProvider-InputType-MaterialsLabPicker.js":91,"./providers/PictProvider-InputType-MaterialsLabSelector.js":92,"./providers/PictProvider-InputType-MaterialsLineItemDisplay.js":93,"./providers/PictProvider-InputType-MaterialsLineItemPicker.js":94,"./providers/PictProvider-InputType-MaterialsLineItemSelector.js":95,"./providers/PictProvider-InputType-MaterialsPlantSelector.js":96,"./providers/PictProvider-InputType-MaterialsSampleDisplay.js":97,"./providers/PictProvider-InputType-MaterialsSamplePicker.js":98,"./providers/PictProvider-InputType-MaterialsSamplePickerDisplay.js":99,"./providers/PictProvider-InputType-MaterialsSampleSelector.js":100,"./providers/PictProvider-InputType-MaterialsTestDisplay.js":101,"./providers/PictProvider-InputType-MaterialsTestInjector.js":102,"./providers/PictProvider-InputType-MaterialsTestInjectorPicker.js":103,"./providers/PictProvider-InputType-MaterialsTestLabPicker.js":104,"./providers/PictProvider-InputType-MaterialsTestLabSelector.js":105,"./providers/PictProvider-InputType-MaterialsTestPicker.js":106,"./providers/PictProvider-InputType-MaterialsTestSectionRemover.js":107,"./providers/PictProvider-InputType-MaterialsTestSelector.js":108,"./providers/PictProvider-InputType-MixSpecificationDisplay.js":109,"./providers/PictProvider-InputType-MixSpecificationSelector.js":110,"./providers/PictProvider-InputType-ObservationCardDeck.js":111,"./providers/PictProvider-InputType-ObservationPhoto.js":112,"./providers/PictProvider-InputType-ObservationTypeDisplay.js":113,"./providers/PictProvider-InputType-ObservationTypeSelector.js":114,"./providers/PictProvider-InputType-PhoneNumber.js":115,"./providers/PictProvider-InputType-PhysicalAssetSelector.js":116,"./providers/PictProvider-InputType-Picker.js":117,"./providers/PictProvider-InputType-PickerDisplay.js":118,"./providers/PictProvider-InputType-PlantDisplay.js":119,"./providers/PictProvider-InputType-PlantSelector.js":120,"./providers/PictProvider-InputType-PrecompiledFileSelector.js":121,"./providers/PictProvider-InputType-ProducerDisplay.js":122,"./providers/PictProvider-InputType-ProducerSelector.js":123,"./providers/PictProvider-InputType-ProductDisplay.js":124,"./providers/PictProvider-InputType-ProductSelector.js":125,"./providers/PictProvider-InputType-ProjectDisplay.js":126,"./providers/PictProvider-InputType-ProjectSelector.js":127,"./providers/PictProvider-InputType-RichText.js":128,"./providers/PictProvider-InputType-SampleDisplay.js":129,"./providers/PictProvider-InputType-SampleSelector.js":130,"./providers/PictProvider-InputType-SampleStatusPicker.js":131,"./providers/PictProvider-InputType-SampleStatusSelector.js":132,"./providers/PictProvider-InputType-SampleTestAcceptance.js":133,"./providers/PictProvider-InputType-SampleTestResult.js":134,"./providers/PictProvider-InputType-SampleTypePicker.js":135,"./providers/PictProvider-InputType-SampleTypeSelector.js":136,"./providers/PictProvider-InputType-Select.js":137,"./providers/PictProvider-InputType-Signature.js":138,"./providers/PictProvider-InputType-Station.js":139,"./providers/PictProvider-InputType-TabGroupSelector.js":140,"./providers/PictProvider-InputType-TabSectionSelector.js":141,"./providers/PictProvider-InputType-TextArea.js":142,"./providers/PictProvider-InputValidation.js":143,"./providers/PictProvider-LabScopeResolver.js":144,"./providers/PictProvider-MediaRegistry.js":145,"./providers/PictProvider-NumberScrollLock.js":146,"./providers/PictProvider-QRCode.js":147,"./providers/PictProvider-ResponsiveUIAdjustment.js":148,"./providers/PictProvider-Select2Util.js":149,"./providers/PictProvider-SpecScopeResolver.js":150,"./providers/PictProvider-Template-HumanCount.js":151,"./providers/PictProvider-Template-LinkTarget.js":152,"./providers/PictProvider-ThroughScopeResolver.js":153,"./providers/_FilterToggleUI.js":158,"./templates/EditorBodies.js":179,"./templates/GeolocationBodies.js":182,"./templates/_index.js":262,"./themes/PictProvider-Theme-Base.js":263,"./themes/PictProvider-Theme-Edit.js":264,"./themes/PictProvider-Theme-Print.js":265,"./themes/PictProvider-Theme-Read.js":266,"./views/PictView-FormHeader.js":267,"./views/PictView-GeolocationSelector.js":268,"./views/PictView-TestResultsSummary.js":269,"pict-section-picker":711}],48:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

class DistillingBundleManager extends PictProvider
{
	/**
	 * @param {Pict} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - (optional) The options for the provider.
	 * @param {string} [pServiceHash] - (optional) The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable') & import('pict')} */
		this.fable;

		/** @type {Record<string, any>} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		this.pict.AppData._DistillingBundleData = {};
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after data load is complete.
	 *
	 * @return {void}
	 */
	onLoadDataAsync(fCallback)
	{
		return super.onLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}

			const tmpManifest = this.pict.settings.MyDefaultFormManifest;
			if (!tmpManifest)
			{
				return fCallback();
			}
			this._primeBundlesFromManifest(tmpManifest, fCallback);
		});
	}

	/**
	 * @param {Record<string, any>} pManifest
	 * @param {(pError?: Error) => void} fCallback
	 */
	_primeBundlesFromManifest(pManifest, fCallback)
	{
		const tmpBundlesToLoad = {};
		for (const tmpDescriptor of Object.values(pManifest.Descriptors || {}))
		{
			if (tmpDescriptor.PictForm?.DistillingBundleHash)
			{
				//FIXME: support alternate source for project ID; ex. the loaded sample record
				tmpBundlesToLoad[tmpDescriptor.PictForm.DistillingBundleHash] = this.pict.AppData.DocumentData.ReportData.IDProject;
			}
		}
		const tmpPromises = [];
		if (Object.keys(tmpBundlesToLoad).length > 0)
		{
			for (const [ tmpBundleHash, tmpIDProject ] of Object.entries(tmpBundlesToLoad))
			{
				tmpPromises.push(this.getBundle(tmpBundleHash, tmpIDProject).catch((pError) =>
				{
					this.pict.log.error(`Error loading distilling bundle ${tmpBundleHash}: ${pError.message}`, { Stack: pError.stack });
				}));
			}
		}
		Promise.all(tmpPromises).finally(() => fCallback());
	}

	/**
	 * Hook on pre-solve to detect changes to required bundles.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		return super.onPreSolveAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			// Ensure all bundles used in the current document are loaded
			const tmpManifest = this.pict.views.PictFormMetacontroller.manifestDefinition;
			if (!tmpManifest)
			{
				return fCallback();
			}
			this._primeBundlesFromManifest(tmpManifest, fCallback);
		});
	}

	/**
	 * @param {string} pBundleHash
	 * @param {number} [pIDProject]
	 *
	 * @return {Promise<any>}
	 */
	async getBundle(pBundleHash, pIDProject)
	{
		if (pIDProject == null)
		{
			pIDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		}
		let tmpBundle = this.pict.AppData._DistillingBundleData[pBundleHash]?.[pIDProject]?.Bundle;
		if (!tmpBundle)
		{
			tmpBundle = await this._loadBundle(pBundleHash, pIDProject);
		}
		return tmpBundle;
	}

	/**
	 * @param {string} pBundleHash
	 * @param {number} [pIDProject]
	 *
	 * @return {Grafee|null}
	 */
	getLatestGraph(pBundleHash, pIDProject)
	{
		let tmpData = this.pict.AppData._DistillingBundleData[pBundleHash]?.[pIDProject];
		if (!tmpData)
		{
			tmpData = this.pict.AppData._DistillingBundleData[pBundleHash]?.[this.pict.AppData._DistillingBundleData[pBundleHash]?.LatestProject];
		}
		if (!tmpData)
		{
			this.pict.log.warn(`Distilling bundle data for hash ${pBundleHash} not loaded yet.`);
			return null;
		}
		if (tmpData.Graph)
		{
			return tmpData.Graph;
		}
		if (tmpData.Bundle)
		{
			tmpData.Graph = new Grafee(tmpData.Bundle);
			return tmpData.Graph;
		}
		return null;
	}

	/**
	 * @param {string} pBundleHash
	 * @param {number} [pIDProject]
	 *
	 * @return {Promise<any>}
	 */
	async _loadBundle(pBundleHash, pIDProject)
	{
		this.pict.log.info(`Loading distilling bundle ${pBundleHash} for project ${pIDProject}`);
		const tmpBundle = await this._get(`Distilling/For/${pBundleHash}/Project/${pIDProject}`);
		this.pict.AppData._DistillingBundleData[pBundleHash] = this.pict.AppData._DistillingBundleData[pBundleHash] || {};
		this.pict.AppData._DistillingBundleData[pBundleHash].LatestProject = pIDProject;
		this.pict.AppData._DistillingBundleData[pBundleHash][pIDProject] = this.pict.AppData._DistillingBundleData[pBundleHash][pIDProject] || {};
		this.pict.AppData._DistillingBundleData[pBundleHash][pIDProject].Bundle = tmpBundle;
		//TODO: remove old bundles from AppData to release memory?
		return tmpBundle;
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 *
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = DistillingBundleManager;
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"headlight-rest-client":20,"pict-provider":552}],49:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// what it do:
//
// * detects changes to linked inputs and evaluates the local input value
//   * This may result in clearing the value if it is no longer valid
// * updates options list / filtering
//
class DistilledInputHandler extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}
	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!this._suppressDistillingEmit)
		{
			this._emitDistillingDataChangeEvent(pInput.PictForm.DistillingKey, pValue || '');
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {number} pRowIndex - The row index of the tabular data
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//TODO: any special handling for tabular / rows? ex. distilling that is row-local?
		if (!this._suppressDistillingEmit)
		{
			this._emitDistillingDataChangeEvent(pInput.PictForm.DistillingKey, pValue || '');
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * NOTE: You can pass in a date value with the :date flag in the DistillingDisplay field to format date fields.
	 * TODO: add tabular version...
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpResult = super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		if (typeof pEvent !== 'string')
		{
			return tmpResult;
		}
		const tmpEventParts = pEvent.split(':');
		const tmpEventHash = tmpEventParts[0];
		if (tmpEventHash !== 'GetPickList')
		{
			return tmpResult;
		}
		const tmpListHash = tmpEventParts[1];
		if (tmpListHash !== pInput.PictForm.SelectOptionsPickList)
		{
			return tmpResult;
		}
		const tmpListDataAddress = tmpEventParts[2];
		const tmpEventOptions = JSON.parse(tmpEventParts.slice(3).join(':'));
		this.pict.log.info(`CustomSelectInputProvider received event: ${pEvent} for list ${tmpListHash} with options:`, { tmpEventHash, tmpListHash, tmpListDataAddress, tmpEventOptions });
		const tmpListData = this.pict.manifest.getValueByHash(this.pict, tmpListDataAddress);
		if (!Array.isArray(tmpListData))
		{
			this.pict.log.error(`CustomSelectInputProvider expected array data at address ${tmpListDataAddress} but found:`, { tmpListData });
			return tmpResult;
		}
		if (tmpListData.length > 0)
		{
			// this happens when multiple inputs share the same picklist - don't want to double-populate
			return tmpResult;
		}
		/** @type {import('@paviasystems/grafee').Grafee} */
		const tmpGraph = this.pict.providers.DistillingBundleManager.getLatestGraph(pInput.PictForm.DistillingBundleHash);
		let tmpAvailableValues;
		if (tmpEventOptions.extractRootKey)
		{
			tmpAvailableValues = Array.isArray(tmpEventOptions.extractRootKey) ? tmpEventOptions.extractRootKey : [ tmpEventOptions.extractRootKey ];
		}
		else
		{
			const tmpSearchSelections = this._getSelectedDistillingValues(pView, pInput.PictForm.DistillingBundleHash, pInput.PictForm.DistillingKey);
			if (pInput.PictForm?.IgnoreKeys)
			{
				for (let k of pInput.PictForm.IgnoreKeys)
				{
					if (tmpSearchSelections[k])
					{
						delete tmpSearchSelections[k];
					}
				}
			}
			tmpAvailableValues = tmpGraph.searchValues(pInput.PictForm.DistillingKey, tmpEventOptions, tmpSearchSelections);
		}
		const tmpDisplayFields = (pInput.PictForm.DistillingDisplay || '').split(',').filter((v) => v !== '');
		const tmpDisplayFieldsWithDateFlags = [];
		// for each tmpDisplayFields, check for a `:date` flag at the end of the key and remove it/store it for formatting
		if (tmpDisplayFields.length > 0)
		{
			for (let i = 0; i < tmpDisplayFields.length; i++)
			{
				const tmpFieldParts = tmpDisplayFields[i].split(':');
				if (tmpFieldParts.length > 1 && tmpFieldParts[tmpFieldParts.length - 1] === 'date')
				{
					// store as date field
					tmpDisplayFieldsWithDateFlags.push({ field: tmpFieldParts.slice(0, -1).join(':'), isDate: true });
					// update original array to remove :date flag
					tmpDisplayFields[i] = tmpFieldParts.slice(0, -1).join(':');
				}
				else
				{
					tmpDisplayFieldsWithDateFlags.push({ field: tmpFieldParts.join(':'), isDate: false });
				}
			}
		}
		const tmpMappedValues = tmpGraph.extractJoinedValues(pInput.PictForm.DistillingKey, tmpAvailableValues, tmpDisplayFields);
		let tmpArray = [];
		const usedKeys = {};
		for (const tmpMappedValue of tmpMappedValues)
		{
			const displayParts = [];
			for (const tmpDisplayField of tmpDisplayFieldsWithDateFlags)
			{
				let fieldValue = tmpMappedValue[tmpDisplayField.field];
				// for date fields, format as YYYY-MM-DD
				if (tmpDisplayField.isDate && fieldValue)
				{
					const tmpDate = new Date(fieldValue);
					if (!isNaN(tmpDate.getTime()))
					{
						fieldValue = this.pict.Dates.dayJS(tmpDate).format('YYYY-MM-DD');
					}
				}
				if (fieldValue)
				{
					displayParts.push(fieldValue);
				}
			}
			const id = tmpMappedValue[pInput.PictForm.DistillingKey];
			const text = displayParts.filter((v) => v).join(': ') || tmpMappedValue[pInput.PictForm.DistillingKey];
			// This is to prevent duplicate key/values which can sometimes happen in the distilling bundle.
			if (usedKeys[id] !== text)
			{
				usedKeys[id] = text;
				tmpArray.push({
					id: tmpMappedValue[pInput.PictForm.DistillingKey],
					text: displayParts.filter((v) => v).join(': ') || tmpMappedValue[pInput.PictForm.DistillingKey],
				});
			}
		}
		tmpArray = tmpArray.sort((a, b) => {
			return a.text > b.text ? 1 : -1;
		});
		for (const t of tmpArray)
		{
			tmpListData.push(t);
		}
		return tmpResult;
	}

	/**
	 * @param {string} pDistillingKey - The distilling key that changed.
	 * @param {string} pDistillingValues - The distilling value that changed.
	 */
	_emitDistillingDataChangeEvent(pDistillingKey, pDistillingValues)
	{
		const tmpEvent = `InputDistilling:${pDistillingKey}:${pDistillingValues}`;
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this.pict.log.info(`DistilledInputHandler completed distilling data change event handling event ${pDistillingKey}.`);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 *
	 * @return {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 *
	 * @return {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID, pRowIndex);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @param {number} [pRowIndex] - The row index of the tabular data (if tabular).
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID, pRowIndex)
	{
		if (typeof pEvent !== 'string')
		{
			return;
		}
		const [ tmpType, tmpUpdatedKey ] = pEvent.split(':');
		if (tmpType !== 'InputDistilling')
		{
			return;
		}
		if (tmpUpdatedKey === pInput.PictForm.DistillingKey && pInput.PictForm.DistillingMode !== 'Projection')
		{
			return;
		}
		this.pict.log.info(`DistilledInputHandler handling event ${pEvent} for input ${pInput.Hash} in section ${pView.Hash}`);
		/** @type {import('@paviasystems/grafee').Grafee} */
		const tmpGraph = this.pict.providers.DistillingBundleManager.getLatestGraph(pInput.PictForm.DistillingBundleHash);
		let tmpChanged = false;
		if (pInput.PictForm.DistillingMode === 'Projection')
		{
			const tmpSelectedKeyValues = this._getSelectedDistillingValues(pView, pInput.PictForm.DistillingBundleHash)[pInput.PictForm.DistillingKey] || [];
			const tmpDisplayFields = (pInput.PictForm.DistillingDisplay || '').split(',').filter((v) => v !== '');
			const tmpMappedValues = tmpGraph.extractJoinedValues(pInput.PictForm.DistillingKey, tmpSelectedKeyValues, tmpDisplayFields);
			const tmpNewValue = tmpMappedValues.map((v) => tmpDisplayFields.map((f) => v[f]).filter((val) => val).join(': ') || v[pInput.PictForm.DistillingKey]).join(', ');
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), pInput.Hash, tmpNewValue);
		}
		else
		{
			const tmpListSelections = this._getSelectedDistillingValues(pView, pInput.PictForm.DistillingBundleHash, pInput.PictForm.DistillingKey);
			const tmpAvailableValues = tmpGraph.listValues(pInput.PictForm.DistillingKey, tmpListSelections);
			let tmpValue = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pInput.Hash);
			if (typeof tmpValue === 'string')
			{
				tmpValue = tmpValue.split(',').filter((v) => v !== '');
			}
			else if (tmpValue)
			{
				tmpValue = [ tmpValue ];
			}
			else
			{
				tmpValue = [];
			}
			//FIXME: doing a find here with a soft equals to deal with mixed strings and numbers... ugh - fix this upstream
			if (tmpValue.length > 0)
			{
				const tmpValidValues = tmpValue.filter((pValue) => tmpAvailableValues.find((v) => v == pValue) != null);
				if (tmpValidValues.length !== tmpValue.length)
				{
					this.pict.log.info(`DistilledInputHandler clearing value for input ${pInput.Hash} in section ${pView.Hash} due to distilling change.`);
					const tmpNewValue = tmpValidValues.length === 1 ? tmpValidValues[0] : tmpValidValues.length === 0 ? (pInput.Default ?? '') : tmpValidValues.join(',');
					pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), pInput.Hash, tmpNewValue);
					tmpValue = tmpValidValues;
					tmpChanged = true;
				}
			}
			if (tmpAvailableValues.length === 1 && (tmpValue.length !== 1 || tmpAvailableValues[0] != tmpValue[0]))
			{
				this.pict.log.info(`DistilledInputHandler auto-selecting only available value for input ${pInput.Hash} in section ${pView.Hash} due to distilling change.`);
				pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), pInput.Hash, tmpAvailableValues[0]);
				tmpChanged = true;
			}
		}
		if (tmpChanged)
		{
			if (pRowIndex != null)
			{
				pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
			}
			else
			{
				pView.manualMarshalDataToViewByInput(pInput);
			}
			const tmpPrevSuppressDistillingEmit = this._suppressDistillingEmit;
			this._suppressDistillingEmit = true;
			try
			{
				const tmpCommittedValue = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pInput.Hash);
				if (pRowIndex != null)
				{
					pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpCommittedValue);
				}
				else
				{
					pView.setDataByInput(pInput, tmpCommittedValue);
				}
			}
			finally
			{
				this._suppressDistillingEmit = tmpPrevSuppressDistillingEmit;
			}
		}
	}

	/**
	 * @param {InstanceType<import('pict-section-form')>} pView - The view object.
	 * @param {string} pDistillingBundleHash - The distilling bundle hash.
	 * @param {string} [pIgnoreKey] - A distilling key to ignore (usually the one that triggered the event).
	 *
	 * @return {Record<string, any>} - The selected distilling values.
	 */
	_getSelectedDistillingValues(pView, pDistillingBundleHash, pIgnoreKey)
	{
		//TODO: collect via event?
		/** @type {Record<string, any>} */
		const tmpSelectedValues = {};
		const tmpManifest = this.pict.views.PictFormMetacontroller.manifestDescription;
		if (!tmpManifest)
		{
			this.pict.log.warn('DistilledInputHandler could not get manifest description to collect selected distilling values.');
			return tmpSelectedValues;
		}
		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors || {}))
		{
			if (tmpDescriptor.PictForm?.DistillingBundleHash === pDistillingBundleHash && (pIgnoreKey == null || tmpDescriptor.PictForm?.DistillingKey !== pIgnoreKey))
			{
				const tmpRemoteValue = this._getInputDistillingValues(pView, tmpDescriptor);
				if (tmpRemoteValue && (!Array.isArray(tmpRemoteValue) || tmpRemoteValue.length > 0))
				{
					tmpSelectedValues[tmpDescriptor.PictForm.DistillingKey] = typeof tmpRemoteValue === 'string' && tmpRemoteValue.includes(',') ? tmpRemoteValue.split(',').filter((v) => { return v !== '' && v != '0'; }) : tmpRemoteValue;
				}
				if (tmpSelectedValues[tmpDescriptor.PictForm.DistillingKey] == 0)
				{
					delete tmpSelectedValues[tmpDescriptor.PictForm.DistillingKey];
				}
			}
		}
		return tmpSelectedValues;
	}

	/**
	 * @param {InstanceType<import('pict-section-form')>} pView - The view object.
	 * @param {Object} pDescriptor - The descriptor object.
	 *
	 * @return {any} - The distilling values for the input.
	 */
	_getInputDistillingValues(pView, pDescriptor)
	{
		//FIXME: how does this work for tabular inputs? do we just need to emit an event instead?
		return pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pDescriptor.Hash);
	}
}

module.exports = DistilledInputHandler;

},{"pict-section-form":587}],50:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		return tmpContent;
	}

	/**
	 * Adds Bulma flavor to the provided content (expected "default Bulma classes" on HTML elements).
	 * NOTE: We try to target only vanilla HTML elements with no existing classes - to give the designer more control.
	 * @param {string} pContent - The content to which to add Bulma flavor.
	 * @return {string} - The content with Bulma flavor added.
	 */
	addBulmaFlavor(pContent)
	{
		if (pContent)
		{
			// for tables, add the table class
			pContent = pContent.replace(/<table>/g, '<table class="table is-fullwidth is-striped is-hoverable">');
			// for images, add the image class
			pContent = pContent.replace(/<img/g, '<img class="image"');
			// h1-h6 (headings), add the title class with appropriate size modifier (NOTE: we bump down the size by 1 to make it less prominent)
			pContent = pContent.replace(/<h1>/g, '<h1 class="title is-2">');
			pContent = pContent.replace(/<h2>/g, '<h2 class="title is-3">');
			pContent = pContent.replace(/<h3>/g, '<h3 class="title is-4">');
			pContent = pContent.replace(/<h4>/g, '<h4 class="title is-5">');
			pContent = pContent.replace(/<h5>/g, '<h5 class="title is-6">');
			pContent = pContent.replace(/<h6>/g, '<h6 class="title is-7">');
		}
		return pContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpBulmaFlavoredContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],51:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (tmpContent)
		{
			tmpContent = libMarked.parse(tmpContent);
		}
		return tmpContent;
	}

	/**
	 * Adds Bulma flavor to the provided content (expected "default Bulma classes" on HTML elements).
	 * @param {string} pContent - The content to which to add Bulma flavor.
	 * @return {string} - The content with Bulma flavor added.
	 */
	addBulmaFlavor(pContent)
	{
		if (pContent)
		{
			// for tables, add the table class
			pContent = pContent.replace(/<table>/g, '<table class="table is-fullwidth is-striped is-hoverable">');
			// for images, add the image class
			pContent = pContent.replace(/<img/g, '<img class="image"');
			// h1-h6 (headings), add the title class with appropriate size modifier (NOTE: we bump down the size by 1 to make it less prominent)
			pContent = pContent.replace(/<h1>/g, '<h1 class="title is-2">');
			pContent = pContent.replace(/<h2>/g, '<h2 class="title is-3">');
			pContent = pContent.replace(/<h3>/g, '<h3 class="title is-4">');
			pContent = pContent.replace(/<h4>/g, '<h4 class="title is-5">');
			pContent = pContent.replace(/<h5>/g, '<h5 class="title is-6">');
			pContent = pContent.replace(/<h6>/g, '<h6 class="title is-7">');
		}
		return pContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpBulmaFlavoredContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.getInputContent(pInput, pValue);
		const tmpBulmaFlavoredContent = this.addBulmaFlavor(tmpContent);
		if (tmpBulmaFlavoredContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpBulmaFlavoredContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"marked":506,"pict-section-form":587}],52:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libBulmaMarkdown = require('./PictProvider-Bulma-Markdown.js');
const libUserMarkdown = require('./_UserMarkdown.js');

/**
 * The input extension behind InputType `MarkdownDisplay`: a read-only field that renders the
 * markdown held in its *value* -- a remark a user typed -- rather than static markdown authored in
 * the manifest.
 *
 * InputType `Markdown` cannot do this. Its templates gate the display div on the descriptor's
 * Content/Default, so a descriptor bound to a data address renders the "No Markdown content
 * available to display" notification and hides the content, and it carries no label.
 *
 * @class
 * @extends libBulmaMarkdown
 */
class CustomInputHandler extends libBulmaMarkdown
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.log;

		this._remarksCSSRegistered = false;
	}

	/**
	 * Renders the markdown for this input.
	 *
	 * A Content/Default in the descriptor is markdown we authored, so it keeps the trusted
	 * rendering the Markdown InputType has always given it. A value is markdown a user typed, so it
	 * goes through the hardened renderer instead -- see _UserMarkdown.js for what that changes.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The input value.
	 * @return {String} - The rendered HTML.
	 */
	getInputContent(pInput, pValue)
	{
		const tmpHasAuthoredContent = (pInput && (((typeof(pInput.Content) === 'string') && pInput.Content) || ((typeof(pInput.Default) === 'string') && pInput.Default)));
		if (tmpHasAuthoredContent)
		{
			return super.getInputContent(pInput, pValue);
		}
		// Templates call this directly to render a remark (Sample Authorization's test summary), with no
		// MarkdownDisplay input on the form to register the stylesheet.
		this.registerRemarksCSS();
		return libUserMarkdown.renderUserMarkdown(pValue, this.log);
	}

	/**
	 * A remark is body copy, not page furniture. The template already wraps it in Bulma's `content`
	 * class, and the parent's title classes would blow an `# h1` in a remark up to 2.5rem inside a
	 * form field, so the heading sizing is left to the shared remarks stylesheet.
	 *
	 * @param {string} pContent - The rendered content.
	 * @return {string} - The content, unchanged.
	 */
	addBulmaFlavor(pContent)
	{
		return pContent;
	}

	/**
	 * Puts the shared remarks styling in the page. Done on first render rather than in the
	 * constructor, because providers are attached before the document is ready.
	 */
	registerRemarksCSS()
	{
		if (this._remarksCSSRegistered || !this.pict.CSSMap)
		{
			return;
		}
		this._remarksCSSRegistered = true;
		this.pict.CSSMap.addCSS('Headlight-Markdown-Remarks', libUserMarkdown.RemarksCSS, 500, 'Bulma-MarkdownDisplay');
		this.pict.CSSMap.injectCSS();
		libUserMarkdown.watchRemarksTruncation();
	}

	/**
	 * The parent only writes to the display element when there is content, which would leave the
	 * previous remark on screen after the value is cleared. Emptying it first keeps the field honest.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The input value.
	 */
	clearDisplayWhenEmpty(pInput, pValue)
	{
		if (!this.getInputContent(pInput, pValue))
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), '');
		}
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.registerRemarksCSS();
		this.clearDisplayWhenEmpty(pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.registerRemarksCSS();
		this.clearDisplayWhenEmpty(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"./PictProvider-Bulma-Markdown.js":51,"./_UserMarkdown.js":170}],53:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const BulmaHTMLInputHandler = require('./PictProvider-Bulma-HTML.js');

/**
 * Renders a scannable QR code image into an input's display container from a QR code value.
 *
 * Subclasses the Bulma-HTML extension so it inherits the DISPLAY-FOR container plumbing (single
 * and tabular) and only swaps the content generation: the value (a Sample.QRCode string) is turned
 * into an <img> via QRCodeProvider.create. That path is fully offline — a canvas drawn by the
 * bundled window.QRCode library, no network round-trip — so the code is scannable on a sample that
 * has not been saved yet.
 *
 * @class
 * @extends BulmaHTMLInputHandler
 * @memberof providers.inputs
 */
class MaterialsQRCodeDisplayInputHandler extends BulmaHTMLInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Build the <img> HTML for a QR code value, or null when there is nothing to render (the base
	 * class skips assignment on a falsy return, leaving the template's "no QR code" message).
	 *
	 * @param {Object} pInput - The input descriptor (reads PictForm.QRCodeSize, default 192px).
	 * @param {any} pValue - The QR code value (a Sample.QRCode string).
	 * @return {string|null}
	 */
	getInputContent(pInput, pValue)
	{
		if (!pValue || typeof pValue !== 'string')
		{
			return null;
		}
		const tmpQRCodeProvider = this.pict.providers.QRCodeProvider;
		if (!tmpQRCodeProvider || typeof tmpQRCodeProvider.create !== 'function')
		{
			return null;
		}
		const tmpSize = (pInput && pInput.PictForm && pInput.PictForm.QRCodeSize) || 192;
		try
		{
			const tmpSource = tmpQRCodeProvider.create(pValue, { size: tmpSize });
			const tmpImage = `<img src="${tmpSource}" alt="Sample QR Code" style="width:${tmpSize}px;height:${tmpSize}px;" />`;
			const tmpPrintButton = this._getPrintButtonHTML(pValue);
			// A block is not moved by the container's text centering, so the button stays under the code.
			return tmpPrintButton ? `<div style="width:${tmpSize}px;text-align:center;">${tmpImage}${tmpPrintButton}</div>` : tmpImage;
		}
		catch (pError)
		{
			this.pict.log.warn(`MaterialsQRCodeDisplay could not render a QR code: ${pError.message || pError}`);
			return null;
		}
	}

	/**
	 * The Print label button shown under the code, for interactive forms in an app that can print.
	 *
	 * @param {string} pValue - The QR code value (a Sample.QRCode string).
	 * @return {string}
	 */
	_getPrintButtonHTML(pValue)
	{
		const tmpSampleProvider = this.pict.providers.SampleProvider;
		if (!this.pict.AppData?.Interactive || !tmpSampleProvider || typeof tmpSampleProvider.printFormSample !== 'function')
		{
			return '';
		}
		const tmpEscapedValue = pValue.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		const tmpOnClick = '_Pict.providers.SampleProvider.printFormSample(this.dataset.qrcode)';
		const tmpLabel = '<span class="icon"><i class="fas fa-fw fa-print"></i></span><span>Print label</span>';
		return `<div class="mt-2 is-hidden-print"><button type="button" class="button is-primary is-small" data-qrcode="${tmpEscapedValue}" onclick="${tmpOnClick}">${tmpLabel}</button></div>`;
	}

	/**
	 * Toggle the template's EMPTY-MESSAGE vs DISPLAY container after (re)assigning content. The
	 * `{~ShowContent~}`/`{~HideContent~}` classes are baked at render time from the value as it was
	 * THEN; the Sample QRCode is synthesized AFTER first render, so without this the field stays on
	 * "No QR code available" even once the value (and the <img>) have arrived in the DISPLAY div.
	 *
	 * @param {Object} pInput
	 * @param {boolean} pHasContent
	 * @return {void}
	 */
	_setContentVisibility(pInput, pHasContent)
	{
		const tmpRawHTMLID = pInput && pInput.Macro && pInput.Macro.RawHTMLID;
		if (!tmpRawHTMLID || typeof document === 'undefined')
		{
			return;
		}
		const tmpDisplay = document.getElementById(`DISPLAY-FOR-${tmpRawHTMLID}`);
		const tmpEmpty = document.getElementById(`EMPTY-MESSAGE-FOR-${tmpRawHTMLID}`);
		if (tmpDisplay)
		{
			tmpDisplay.classList.toggle('is-hidden', !pHasContent);
		}
		if (tmpEmpty)
		{
			tmpEmpty.classList.toggle('is-hidden', !!pHasContent);
		}
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pRow
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {boolean}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._setContentVisibility(pInput, !!(pValue && String(pValue).trim()));
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pRow
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._setContentVisibility(pInput, !!(pValue && String(pValue).trim()));
		return tmpResult;
	}
}

module.exports = MaterialsQRCodeDisplayInputHandler;

},{"./PictProvider-Bulma-HTML.js":50}],54:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const ScopedEntityData = require('./_ScopedEntityData.js');

class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { HeadlightPopover: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.pict.MetaTemplate.addPattern('{~HideRecordSetControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hideRecordSetControls = false;
			if (tmpDataObject && tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				// if we find 'HideRecordSetControls' or 'Hide RecordSet Controls' in the GroupExtra string, hide the record set controls manually
				// NOTE: We also support 'Hide Table Controls' and 'HideTableControls' for backward compatibility with the TableControls provider since Table controls is the common name for both tables and record sets
				if ([ 'HideRecordSetControls', 'Hide RecordSet Controls', 'Hide Record Set Controls', 'HideTableControls', 'Hide Table Controls' ].some((i) => tmpDataObject.GroupExtra.includes(i)))
				{
					hideRecordSetControls = true;
				}
			}
			else if (tmpDataObject.MinimumRowCount && tmpDataObject.MaximumRowCount)
			{
				hideRecordSetControls = tmpDataObject.MinimumRowCount >= tmpDataObject.MaximumRowCount;
			}
			return (hideRecordSetControls) ? 'hide-recordset-controls' : '';
		});
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getRecordSetHTMLID(pInputHTMLID)
	{
		return `#RECORDSET-FOR-${pInputHTMLID}`;
	}
	getRecordSetWrapperHTMLID(pInputHTMLID)
	{
		return `#RECORDSET-WRAPPER-FOR-${pInputHTMLID}`;
	}

	/**
	 * Tombstone the rows the row's selectors own before the row is spliced away.
	 *
	 * Row deletion is the one removal route with no input-level seam: `deleteDynamicTableRow` splices
	 * the record set and notifies nothing, so each selector in the row is asked for its owned rows here,
	 * the last point at which they still exist.
	 *
	 * @param {Object} pView - The dynamic-form view owning the row.
	 * @param {Record<string, any>} pGroup - The group descriptor (for its RecordSetAddress).
	 * @param {number|string} pRowIndex - The row about to be deleted.
	 * @return {number} - How many tombstones were staged.
	 */
	stageRowRemovalTombstones(pView, pGroup, pRowIndex)
	{
		if (!ScopedEntityData.isEnabled(this.pict))
		{
			return 0;
		}
		const tmpRemovals = ScopedEntityData.collectRowSelectorRemovals(this.pict, pView, pGroup, pRowIndex);
		if (tmpRemovals.length < 1)
		{
			return 0;
		}
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, ScopedEntityData.DEFAULT_CONTEXT, tmpRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`Bulma-RecordSetControls: staged deletion of ${tmpResult.Staged.length} record(s) with row ${pRowIndex} of [${pGroup.RecordSetAddress}].`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * Handle a record set action from a dropdown menu.
	 * @param {string} pAction - The action to perform.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {number} pGroupIndex - The group number of the table row.
	 * @param {string} pRowIndex - The key of the table row.
	 * @return {boolean} - True if the action was successful, false otherwise.
	 */
	handleRecordSetMenuButtonEvent(pAction, pViewHash, pGroupIndex, pRowIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		// handle toast notifications for table row actions based on min/max row counts
		if (pAction === 'Delete')
		{
			if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
			{
				this.pict.log.error(`Cannot delete record set, minimum set count reached: ${tmpGroup.MinimumRowCount}`);
				this.pict.views.HeadlightPanels.toast({
					message: `Cannot delete record set, minimum set count reached: ${tmpGroup.MinimumRowCount}`,
					type: 'is-warning',
				});
				this.fable.HeadlightPopover.hideAll();
				return false;
			}
			this.stageRowRemovalTombstones(tmpView, tmpGroup, pRowIndex);
			this.pict.views[pViewHash].deleteDynamicTableRow(pGroupIndex, pRowIndex);
		}
		else if (pAction === 'MoveUp')
		{
			const tmpRowIndex = parseInt(String(pRowIndex), 10);
			if (tmpRowIndex == 0)
			{
				this.pict.log.error(`Cannot move record set up, already at the top: ${tmpRowIndex}`);
				this.pict.views.HeadlightPanels.toast({
					message: `Cannot move record set up, already at the top.`,
					type: 'is-warning',
				});
				this.fable.HeadlightPopover.hideAll();
				return false;
			}
			this.pict.views[pViewHash].moveDynamicTableRowUp(pGroupIndex, pRowIndex);
		}
		else if (pAction === 'MoveDown')
		{
			const tmpRowIndex = parseInt(String(pRowIndex), 10);
			if (tmpRowIndex == (tmpDestinationObject.length - 1))
			{
				this.pict.log.error(`Cannot move record set down, already at the bottom: ${tmpRowIndex}`);
				this.pict.views.HeadlightPanels.toast({
					message: `Cannot move record set down, already at the bottom.`,
					type: 'is-warning',
				});
				this.fable.HeadlightPopover.hideAll();
				return false;
			}
			this.pict.views[pViewHash].moveDynamicTableRowDown(pGroupIndex, pRowIndex);
		}
		else
		{
			this.pict.log.error(`Unknown action: ${pAction}`);
		}
		// Update any necessary controls
		this.prepareAnyExtraRecordSetControls();
		// Hide the popover menu after the action is performed
		this.fable.HeadlightPopover.hideAll();
		return true;
	}

	/**
	 * Enable/disable each record set's "Add new set" button(s) against MaximumRowCount.
	 *
	 * Previously selected `button[data-recordset-controls="add-set"]`, but that
	 * attribute sits on the wrapping <div>, not on the button -- so this matched
	 * nothing and RecordSet groups were never actually capped. Select on
	 * `data-max-sets` instead: only add buttons carry it, it picks up both the
	 * bottom bar and the opt-in top bar, and it will not catch the entry-mode
	 * toggle button that shares the same wrapper.
	 */
	prepareAnyExtraRecordSetControls()
	{
		const tmpEntryControls = this.getEntryControlsProvider();
		const tmpRecordSetWrappers = document.querySelectorAll('.section-recordset-wrapper');
		tmpRecordSetWrappers.forEach((pWrapper) =>
		{
			const tmpAddButtons = pWrapper.querySelectorAll('button[data-max-sets]');
			if (!tmpAddButtons.length || !tmpEntryControls)
			{
				return;
			}
			const tmpEntryCount = pWrapper.querySelectorAll('.RecordSetEntry').length;
			tmpEntryControls.applyAddButtonRowLimit(tmpAddButtons, tmpEntryCount, 'data-max-sets', 'data-min-sets');
		});
		// recalculate responsive UI adjustments for label alignments, etc.
		this.pict.providers.ResponsiveUIAdjustmentProvider.onWindowResize();
	}

	/**
	 * The shared entry-controls engine. Every knob (add-bar position, modal
	 * entry, entry point, the inline/modal toggle) is implemented once in
	 * Bulma-TableControls and driven from here for RecordSet groups -- including
	 * the three MetaTemplate macros, which are registered there and NEVER also
	 * here (a second addPattern on the same pattern silently shadows the first).
	 * @return {Object|null} - The Bulma-TableControls provider, or null.
	 */
	getEntryControlsProvider()
	{
		const tmpProvider = this.pict.providers['Bulma-TableControls'];
		if (!tmpProvider || (typeof tmpProvider.handleAddEntryButtonClickEvents !== 'function'))
		{
			this.pict.log.error('Bulma-RecordSetControls could not resolve the Bulma-TableControls entry-controls provider.');
			return null;
		}
		return tmpProvider;
	}

	/**
	 * The single entry point for both add bars on a RecordSet group. With no
	 * `EntryControls` on the group this reproduces exactly what the template's
	 * onclick used to inline: create the set, then the post-add fixups.
	 * @param {Event} pEvent - The click event.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True when an entry was started.
	 */
	handleAddEntryButtonClickEvents(pEvent, pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`Entry controls could not resolve view [${pViewHash}].`);
			return false;
		}
		const tmpEntryControls = this.getEntryControlsProvider();
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		if (!tmpEntryControls || !tmpEntryControls.getEntryControlsConfig(tmpGroup))
		{
			// Legacy path.
			tmpView.createDynamicTableRow(pGroupIndex);
			this.handleAddRowButtonClickEvents(pEvent);
			return true;
		}
		return tmpEntryControls.handleAddEntryButtonClickEvents(pEvent, pViewHash, pGroupIndex);
	}

	/**
	 * Flip a RecordSet group between inline and modal entry.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True on success.
	 */
	toggleEntryMode(pViewHash, pGroupIndex)
	{
		const tmpEntryControls = this.getEntryControlsProvider();
		if (!tmpEntryControls)
		{
			return false;
		}
		return tmpEntryControls.toggleEntryMode(pViewHash, pGroupIndex);
	}

	/**
	 * Handle the click event for the "Add Row" button in a set.
	 * NOTE: This is a secondary call to prepare any extra set controls after the row is added/rendered - it doesn't actually add the row (that is handled by the Pict Provider).
	 * @param {Event} event - The click event.
	 */
	handleAddRowButtonClickEvents(event)
	{
		setTimeout(() =>
		{
			// Update any necessary controls
			this.prepareAnyExtraRecordSetControls();
		}, 100);
	}
}

module.exports = CustomInputHandler;

},{"./_ScopedEntityData.js":162,"pict-section-form":587}],55:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const libPictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const ScopedEntityData = require('./_ScopedEntityData.js');

// CSS for the Headlight "hide column in PDF only" toggle injected into each row of the
// pict-section-form ColumnChooser popover (opted-in groups only). The eye icon is the
// PDF visibility state; the row's existing checkbox remains the interactive (HTML) visibility.
const _PDFColumnChooserCSS = /*css*/`
	.pict-tabular-colchooser-row.has-pdf-toggle { justify-content: space-between; }
	.pict-tabular-colchooser-row.has-pdf-toggle .colchooser-html-label { display: inline-flex; align-items: center; gap: 0.5rem; flex: 1 1 auto; min-width: 0; cursor: pointer; }
	.pict-tabular-colchooser-row.has-pdf-toggle .colchooser-html-label span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.colchooser-pdf-toggle { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.1rem; cursor: pointer;
		border: 1px solid transparent; background: transparent; border-radius: 6px; padding: 0.1rem 0.3rem;
		color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; }
	.colchooser-pdf-toggle:hover:not([disabled]) { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
	.colchooser-pdf-toggle.is-pdf-hidden { color: var(--bulma-danger, #c0392b); }
	.colchooser-pdf-toggle[disabled] { opacity: 0.4; cursor: not-allowed; }
	.colchooser-pdf-toggle .icon { margin: 0; }
`;

// Theme tokens aren't loaded on form surfaces, so the light fallbacks above would show in dark mode. Same three dark
// signals as pict-section-form's ColumnChooser dark rules (Pict-Layout-Tabular.js); keep the two in step.
const _PDFColumnChooserDarkRules = (pScope) => /*css*/`
	${pScope} .colchooser-pdf-toggle { color: var(--theme-color-text-muted, #8b95a4); }
	${pScope} .colchooser-pdf-toggle:hover:not([disabled]) { background: var(--theme-color-background-tertiary, #2c3542); color: var(--theme-color-text-primary, #e6e9ee); }
`;
const _PDFColumnChooserDarkCSS = _PDFColumnChooserDarkRules('[data-theme="dark"]')
	+ _PDFColumnChooserDarkRules('.theme-dark')
	+ `@media (prefers-color-scheme: dark) {` + _PDFColumnChooserDarkRules('html:not([data-theme="light"])') + `}`;

// A group with `GroupExtra: "Hide Table Controls"` still reserved the height of the
// controls row (~21px of dead space under the last data row). The wrapper gets
// `.hide-table-controls`, but the existing rule in bulma-table.scss only reaches
// elements carrying `[data-table-controls]` -- and the controls ROW and its two
// `.column` children carry no such attribute, so they kept rendering.
//
// Collapse the row, but ONLY while the scroll slider inside it is hidden. That
// slider is deliberately exempt from `.hide-table-controls` so a WIDE table with
// controls hidden can still be scrolled; blanket-hiding the row would take that
// away. `:has()` re-evaluates when prepareAnyExtraTableControls() reveals the
// slider, so the row returns exactly when it is needed.
//
// Lives here rather than in headlight-styles.scss so the fix ships with the bundle
// rebuild instead of regenerating headlight-styles.css, which has to be coordinated
// with the in-flight Select2 -> Pict-Section-Picker migration.
const _HiddenTableControlsCSS = /*css*/`
	.hide-table-controls .columns:has([data-table-controls="scroll-slider"].is-hidden) { display: none; }
`;


// ─────────────────────────────────────────────────────────────────────────
// Entry controls (opt-in per group via `Group.EntryControls`)
//
// Long Tabular / RecordSet groups are frequently several viewport-heights
// tall, and the only "Add" button lives BELOW the whole group -- so adding an
// entry means scrolling to the bottom and back. `EntryControls` lets a form
// author put the add bar at the top, open the new entry in a modal, and/or
// prepend rather than append. Every knob is opt-in: a group with no
// `EntryControls` renders exactly the markup it did before this existed.
//
// NOTE: `EntryControls.Position` is the ADD BAR. It is orthogonal to the
// pict-section-form group option `EditingControlsPosition`, which positions
// the per-row del/up/down menu COLUMN (left/right/hidden). Similar names,
// different controls.
// ─────────────────────────────────────────────────────────────────────────
const _EntryControlsDefaults =
{
	Position: 'bottom',
	EntryPoint: 'end',
	Mode: 'inline',
	AllowModeToggle: false,
	RowThreshold: 10,
	ViewportMultiple: 3,
	ModalTitle: '',
	ModalWidth: 'min(1100px, 92vw)',
	ModalColumns: 1,
};

// localStorage key prefix for the per-user inline/modal preference. Bump the
// version segment if the stored shape ever changes.
const _ENTRY_MODE_STORAGE_PREFIX = 'Headlight.EntryMode.v1';

const _EntryControlsCSS = /*css*/`
	.pict-entry-mode-toggle { margin-right: 0.5rem; }
	.pict-entry-modal-body { max-height: min(70vh, 720px); overflow-y: auto; }
	.pict-entry-modal-body .columns { margin: 0; }
	.pict-entry-modal-body .column { padding: 0.4rem 0.6rem; }
	.pict-entry-modal-body .label { margin-bottom: 0.25rem; }
	.pict-entry-modal-body .help { margin-top: 0.15rem; }
	.pict-entry-modal-field--chooser-hidden > .label::after { content: ' (hidden in table)'; font-weight: 400; opacity: 0.7; font-size: 0.8em; }
`;

// Escape a manifest-authored string for safe interpolation into a template's
// text node. The value comes from form config rather than user data, but these
// templates are assembled as HTML strings, so escaping is the mitigation --
// see the same idiom in HeadlightDynamicInputsBundle's {~LabelWithChips:~}.
const _escapeTemplateText = (pString) => String(pString == null ? '' : pString)
	.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

class CustomInputHandler extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { HeadlightPopover: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.pict.MetaTemplate.addPattern('{~HideTableControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hideTableControls = false;
			if (tmpDataObject && tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				// if we find 'HideTableControls' or 'Hide Table Controls' in the GroupExtra string, hide the table controls manually
				if ([ 'HideTableControls', 'Hide Table Controls' ].some((i) => tmpDataObject.GroupExtra.includes(i)))
				{
					hideTableControls = true;
				}
			}
			else if (tmpDataObject.MinimumRowCount && tmpDataObject.MaximumRowCount)
			{
				hideTableControls = tmpDataObject.MinimumRowCount >= tmpDataObject.MaximumRowCount;
			}
			return (hideTableControls) ? 'hide-table-controls' : '';
		});

		// EditingControlsPosition 'hidden' has no menu column to toggle, so hide the
		// toggle button (Bulma 'is-hidden'). Record is the group descriptor.
		this.pict.MetaTemplate.addPattern('{~HideMenuColumnToggle:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			if (tmpDataObject && (tmpDataObject.EditingControlsPosition === 'hidden'))
			{
				return 'is-hidden';
			}
			return '';
		});

		// Per-group copy for the tabular "no rows" placeholder row. The row itself
		// and its show/hide are not ours -- the Group-Postfix template always emits
		// `tr.table-emtpy-row` (sic) last in the tbody and bulma-table.scss hides it
		// via `:not(:first-child)`. Only the WORDING was a hardcoded literal, so a
		// manifest had no way to explain why a particular table is empty.
		//
		// Body is `<address>:<default copy>`, split on the FIRST colon -- the default
		// is each theme's existing literal, so a group that does not opt in renders
		// byte-identically to before this macro existed.
		this.pict.MetaTemplate.addPattern('{~TabularEmptyMessage:', '~}', (pHash, pData, fCallback) =>
		{
			return this.resolveTabularEmptyMessage(pHash, pData, fCallback);
		});

		// 'left' controls: the framework's {~TEC:~} cell emits bare del/up/down links;
		// override it to reuse our right-side menu button so both positions match.
		this.overrideTabularEditingControlsRenderer();

		this.overrideTabularColGroupBuilder();

		// Register CSS for the PDF-only column-hide toggle injected into the chooser popover.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Headlight-Tabular-PDFColumnChooser-CSS', _PDFColumnChooserCSS + _PDFColumnChooserDarkCSS, 500);
			this.pict.CSSMap.addCSS('Headlight-Tabular-HiddenControls-CSS', _HiddenTableControlsCSS, 500);
		}

		// "Hide column in PDF (Print theme) only" — opt-in via group ColumnChooser.SelectPDFOnlyColumns.
		this.overrideColumnChooserForPDF();

		// ── Entry controls ────────────────────────────────────────────────
		// These three macros are registered HERE ONLY, never also in
		// Bulma-RecordSetControls: both providers are always attached together
		// and a second addPattern() on the same pattern silently shadows the
		// first. The RecordSet templates consume the same macros.

		// Top add bar: hidden unless the group opted into 'top' or 'both'.
		this.pict.MetaTemplate.addPattern('{~HideTopEntryControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpConfig = this.getEntryControlsConfig(this.pict.resolveStateFromAddress(pHash, pData, fCallback));
			return (tmpConfig && ((tmpConfig.Position === 'top') || (tmpConfig.Position === 'both'))) ? '' : 'is-hidden';
		});

		// Bottom add bar: visible unless the group explicitly moved it to 'top'.
		// The no-config case MUST return '' -- that is what keeps every existing
		// form rendering exactly as it does today.
		//
		// EXCEPT on a read-only table. `EditingControlsPosition: 'hidden'` already
		// removes the per-row del/up/down column and the menu-column toggle; a table
		// with no row controls is a report, and offering "Add new row" underneath it
		// is incoherent -- a reader clicks it and gets a blank row on a dashboard
		// that cannot save. The two express one intent, so the one flag drives both
		// rather than adding a second key nobody would remember to set.
		this.pict.MetaTemplate.addPattern('{~HideBottomEntryControls:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpGroup = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			if (tmpGroup && (tmpGroup.EditingControlsPosition === 'hidden'))
			{
				return 'is-hidden';
			}
			const tmpConfig = this.getEntryControlsConfig(tmpGroup);
			return (tmpConfig && (tmpConfig.Position === 'top')) ? 'is-hidden' : '';
		});

		// The inline/modal preference toggle. Emits nothing at all unless the
		// group set AllowModeToggle; when it does emit it starts hidden and
		// refreshEntryModeToggleVisibility() reveals it once the group is big
		// enough to be painful.
		// The whole opt-in TOP add bar (add button + mode toggle), or '' when the
		// group never opted in -- so untouched forms emit no extra markup.
		this.pict.MetaTemplate.addPattern('{~EntryAddBarTop:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpGroup = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// Same reasoning as the bottom bar: a read-only table has nothing to add to.
			if (tmpGroup && (tmpGroup.EditingControlsPosition === 'hidden'))
			{
				return '';
			}
			return this.renderEntryAddBarHTML(tmpGroup);
		});

		this.pict.MetaTemplate.addPattern('{~EntryModeToggleButton:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpGroup = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.renderEntryModeToggleHTML(tmpGroup);
		});

		// Column classes for one field cell inside the entry modal. Record is the
		// COLUMN DESCRIPTOR; buildModalRowTemplate stamps the two flags read here.
		// The modal deliberately does not honour per-descriptor PictForm.Width --
		// it is a stacked entry form, not the grid.
		this.pict.MetaTemplate.addPattern('{~EntryModalCellClass:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpInput = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const tmpPictForm = (tmpInput && tmpInput.PictForm) ? tmpInput.PictForm : {};
			let tmpClasses = tmpPictForm._EntryModalHalfWidth ? 'is-6' : 'is-12';
			if (tmpPictForm._EntryModalChooserHidden)
			{
				tmpClasses += ' pict-entry-modal-field--chooser-hidden';
			}
			return tmpClasses;
		});

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Headlight-Tabular-EntryControls-CSS', _EntryControlsCSS, 500);
		}

		// While a modal entry is staged, suppress the tabular layout's mid-marshal
		// rebuild so the staged row never gets an inline DOM twin.
		this.overrideTabularMarshalForModalEntry();

		// The staged-entry record, or null. Only one modal entry at a time (the
		// modal itself is a singleton overlay).
		/** @type {{ViewHash: string, GroupIndex: number, StagedIndex: number, Committed: boolean, Dialog: any}|null} */
		this._modalEntryState = null;
	}

	/**
	 * Override the Tabular layout's left-controls renderer ({~TEC:~}) to use our menu
	 * button. Idempotent; no-op if the layout provider isn't registered.
	 */
	overrideTabularEditingControlsRenderer()
	{
		const tmpTabularLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpTabularLayout ||
			(typeof tmpTabularLayout._renderTabularEditingControlsHTML !== 'function') ||
			tmpTabularLayout._headlightEditingControlsOverridden)
		{
			return;
		}
		const tmpSelf = this;
		tmpTabularLayout._headlightEditingControlsOverridden = true;
		tmpTabularLayout._renderTabularEditingControlsHTML = function(pView, pGroupIndex, pRowKey)
		{
			return tmpSelf.renderTabularEditingControlsMenuCell(pView, pGroupIndex, pRowKey);
		};
	}

	/**
	 * Keep InputType 'Hidden' columns out of the Tabular `<colgroup>`. Their cells are hidden
	 * with `is-hidden` ({~HiddenInputTabularAdjustment~} in HeadlightDynamicInputsBundle.js), and a
	 * `display:none` cell takes no column slot, so a `<col>` for one shifts every later width a
	 * column left. Idempotent; no-op if the layout provider or its colgroup builder is missing.
	 */
	overrideTabularColGroupBuilder()
	{
		const tmpTabularLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpTabularLayout ||
			(typeof tmpTabularLayout._buildTabularColGroupHTML !== 'function') ||
			tmpTabularLayout._headlightColGroupOverridden)
		{
			return;
		}
		const tmpSelf = this;
		const fOriginalColGroup = tmpTabularLayout._buildTabularColGroupHTML;
		tmpTabularLayout._headlightColGroupOverridden = true;
		tmpTabularLayout._buildTabularColGroupHTML = function(pGroup, pChooserHiddenSet, pLeadingColumnCount)
		{
			return fOriginalColGroup.call(this, pGroup, tmpSelf.addHiddenInputColumns(pGroup, pChooserHiddenSet), pLeadingColumnCount);
		};
	}

	/**
	 * Add every InputType 'Hidden' column of a tabular group to a hidden-column set.
	 *
	 * @param {Object} pGroup - a tabular group with a `supportingManifest`
	 * @param {Set<string>|null} pHiddenSet - the chooser-hidden set (null when the chooser is off)
	 * @returns {Set<string>|null} a new set with the Hidden columns added, or `pHiddenSet` itself when the group has none
	 */
	addHiddenInputColumns(pGroup, pHiddenSet)
	{
		const tmpManifest = pGroup && pGroup.supportingManifest;
		if (!tmpManifest || !Array.isArray(tmpManifest.elementAddresses) || !tmpManifest.elementDescriptors)
		{
			return pHiddenSet;
		}
		let tmpResult = pHiddenSet;
		for (const tmpHash of tmpManifest.elementAddresses)
		{
			const tmpDescriptor = tmpManifest.elementDescriptors[tmpHash];
			if (!tmpDescriptor || !tmpDescriptor.PictForm || (tmpDescriptor.PictForm.InputType !== 'Hidden'))
			{
				continue;
			}
			if (tmpResult === pHiddenSet)
			{
				tmpResult = new Set(pHiddenSet || []);
			}
			tmpResult.add(String(tmpHash));
		}
		return tmpResult;
	}

	// ─────────────────────────────────────────────────────────────────────────
	// "Hide column in PDF (Print theme) only"
	//
	// pict-section-form's ColumnChooser hides columns by NOT rendering them, driven
	// by a form-data array of column hashes at `<GroupHash>_HiddenColumns` (read via
	// Pict-Layout-Tabular._getTabularColumnChooserHiddenSet). That array hides a
	// column in EVERY theme. This Headlight feature adds a SECOND, parallel array,
	// `<GroupHash>_PDFHiddenColumns`, whose columns are hidden ONLY in the Print
	// theme — and unions it into the effective hidden set at render time when (and
	// only when) we are rendering non-interactively. Because the union always
	// includes the base (interactive) hidden set, an interactively-hidden column is
	// necessarily hidden in the PDF too (HTML-hide cascades to PDF; PDF-hide is the
	// lower-priority, additive layer). Nothing is written to pict-section-form.
	//
	// Opt-in: a tabular group sets `ColumnChooser: { SelectPDFOnlyColumns: true }`.
	// Per-column default: a descriptor sets `PictForm.TabularPDFDefaultHidden: true`.
	// ─────────────────────────────────────────────────────────────────────────

	/**
	 * The absolute form-data address of a group's PDF-only hidden-column-hash array.
	 * Mirrors Pict-Layout-Tabular._getTabularHiddenColumnsAddress; defaults to
	 * `<GroupHash>_PDFHiddenColumns`, overridable via ColumnChooser.PDFDataAddress.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @return {string} - The absolute address.
	 */
	getPDFHiddenColumnsAddress(pView, pGroup)
	{
		const tmpChooser = (pGroup && pGroup.ColumnChooser) || {};
		const tmpDataAddress = (typeof tmpChooser.PDFDataAddress === 'string' && tmpChooser.PDFDataAddress.length > 0) ?
			tmpChooser.PDFDataAddress :
			`${pGroup.Hash}_PDFHiddenColumns`;
		return `${pView.getMarshalDestinationAddress()}.${tmpDataAddress}`;
	}

	/**
	 * The set of column hashes hidden-in-PDF BY DEFAULT for a group: the group's
	 * `ColumnChooser.PDFDefaultHiddenColumns` array plus every choosable descriptor
	 * flagged `PictForm.TabularPDFDefaultHidden`. Mirrors the framework's
	 * `_getTabularColumnChooserDefaultHidden` (which merges `DefaultHiddenColumns`
	 * with per-descriptor `TabularDefaultHidden`). Applies only until the user makes
	 * an explicit choice (which writes an array to form data).
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @return {Array<string>} - Array of column hashes.
	 */
	getPDFDefaultHidden(pGroup)
	{
		const tmpDefaults = {};
		// group-level list (raw ColumnChooser config, same place SelectPDFOnlyColumns lives)
		const tmpChooser = (pGroup && pGroup.ColumnChooser) || {};
		if (Array.isArray(tmpChooser.PDFDefaultHiddenColumns))
		{
			for (let i = 0; i < tmpChooser.PDFDefaultHiddenColumns.length; i++)
			{
				tmpDefaults[String(tmpChooser.PDFDefaultHiddenColumns[i])] = true;
			}
		}
		// per-descriptor flags
		const tmpManifest = pGroup && pGroup.supportingManifest;
		if (tmpManifest && Array.isArray(tmpManifest.elementAddresses))
		{
			for (let k = 0; k < tmpManifest.elementAddresses.length; k++)
			{
				const tmpHash = String(tmpManifest.elementAddresses[k]);
				const tmpDescriptor = tmpManifest.elementDescriptors[tmpHash];
				if (tmpDescriptor && tmpDescriptor.PictForm &&
					!tmpDescriptor.PictForm.TabularHidden &&
					tmpDescriptor.PictForm.TabularPDFDefaultHidden === true)
				{
					tmpDefaults[tmpHash] = true;
				}
			}
		}
		return Object.keys(tmpDefaults);
	}

	/**
	 * The EFFECTIVE set of PDF-only-hidden column hashes for a group: the array
	 * stored in form data when the user has chosen, otherwise the configured
	 * defaults. This is the explicit "hide in PDF" layer only — it does NOT include
	 * the interactive hidden set (the union happens in the layout override).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @return {Set<string>} - Set of column hashes.
	 */
	getPDFHiddenColumnsSet(pView, pGroup)
	{
		const tmpStored = this.pict.resolveStateFromAddress(this.getPDFHiddenColumnsAddress(pView, pGroup));
		const tmpList = Array.isArray(tmpStored) ? tmpStored : this.getPDFDefaultHidden(pGroup);
		const tmpSet = new Set();
		for (let i = 0; i < tmpList.length; i++)
		{
			tmpSet.add(String(tmpList[i]));
		}
		return tmpSet;
	}

	/**
	 * Union the PDF-only hidden columns into a base (interactive) hidden set. Returns
	 * a NEW set so the caller's base set is never mutated.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @param {Set<string>} pBaseSet - The interactive hidden set.
	 * @return {Set<string>} - base ∪ PDF-only.
	 */
	unionPDFHiddenColumns(pView, pGroup, pBaseSet)
	{
		const tmpResult = new Set(pBaseSet);
		const tmpPDFSet = this.getPDFHiddenColumnsSet(pView, pGroup);
		tmpPDFSet.forEach((pHash) => tmpResult.add(pHash));
		return tmpResult;
	}

	/**
	 * Install the two Headlight overrides on the singleton Pict-Layout-Tabular
	 * provider (same monkey-patch pattern as overrideTabularEditingControlsRenderer):
	 *   1. _getTabularColumnChooserHiddenSet — union the PDF-only set when rendering
	 *      non-interactively (Print theme) for opted-in groups.
	 *   2. _renderTabularColumnChooserPopover — add a per-row PDF-hide toggle to the
	 *      chooser menu for opted-in groups.
	 * Idempotent; no-op if the layout provider isn't registered.
	 */
	overrideColumnChooserForPDF()
	{
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout ||
			(typeof tmpLayout._getTabularColumnChooserHiddenSet !== 'function') ||
			(typeof tmpLayout._renderTabularColumnChooserPopover !== 'function') ||
			tmpLayout._headlightPDFColumnChooserOverridden)
		{
			return;
		}
		const tmpSelf = this;
		tmpLayout._headlightPDFColumnChooserOverridden = true;

		// 1) Union PDF-only hidden columns into the effective hidden set — Print theme only.
		const fOriginalHiddenSet = tmpLayout._getTabularColumnChooserHiddenSet;
		tmpLayout._getTabularColumnChooserHiddenSet = function(pView, pGroup)
		{
			const tmpBaseSet = fOriginalHiddenSet.call(this, pView, pGroup);
			// Falsy base = chooser disabled (preserve legacy path). Interactive = no PDF
			// hiding. No opt-in = feature dormant. In all three, return the base untouched.
			if (!tmpBaseSet ||
				tmpSelf.pict.AppData.Interactive ||
				!(pGroup && pGroup.ColumnChooser && pGroup.ColumnChooser.SelectPDFOnlyColumns))
			{
				return tmpBaseSet;
			}
			return tmpSelf.unionPDFHiddenColumns(pView, pGroup, tmpBaseSet);
		};

		// 2) Add the per-row PDF-hide toggle to the chooser popover — opted-in groups only.
		const fOriginalPopover = tmpLayout._renderTabularColumnChooserPopover;
		tmpLayout._renderTabularColumnChooserPopover = function(pView, pGroup)
		{
			if (!(pGroup && pGroup.ColumnChooser && pGroup.ColumnChooser.SelectPDFOnlyColumns))
			{
				return fOriginalPopover.call(this, pView, pGroup);
			}
			return tmpSelf.renderColumnChooserPopoverWithPDF(this, pView, pGroup);
		};

		// 3) "Reset to defaults" must also reset the PDF-only hidden set (not just the
		// interactive hidden set). Write the PDF defaults BEFORE the framework reset so its
		// rebuild + popover repaint already reflect the cleared PDF indicators.
		if (typeof tmpLayout.resetTabularColumnVisibility === 'function')
		{
			const fOriginalReset = tmpLayout.resetTabularColumnVisibility;
			tmpLayout.resetTabularColumnVisibility = function(pViewHash, pGroupIndex)
			{
				const tmpView = tmpSelf.pict.views[pViewHash];
				const tmpGroup = (tmpView && tmpView.sectionDefinition && Array.isArray(tmpView.sectionDefinition.Groups)) ?
					tmpView.sectionDefinition.Groups[Number(pGroupIndex)] :
					null;
				if (tmpGroup && tmpGroup.ColumnChooser && tmpGroup.ColumnChooser.SelectPDFOnlyColumns)
				{
					tmpSelf.pict.setStateValueAtAddress(tmpSelf.getPDFHiddenColumnsAddress(tmpView, tmpGroup), null, tmpSelf.getPDFDefaultHidden(tmpGroup));
				}
				return fOriginalReset.call(this, pViewHash, pGroupIndex);
			};
		}
	}

	/**
	 * Render the ColumnChooser popover for an opted-in group: the framework's
	 * backdrop + panel + reset footer, but each column row carries the existing
	 * HTML show/hide checkbox AND a Headlight PDF-hide toggle. Replicates the
	 * framework markup (Pict-Layout-Tabular._renderTabularColumnChooserPopover) so
	 * the menu looks and behaves identically apart from the extra toggle.
	 * @param {Object} pLayout - The Pict-Layout-Tabular provider (override `this`).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 */
	renderColumnChooserPopoverWithPDF(pLayout, pView, pGroup)
	{
		const tmpColumns = pLayout._getTabularChoosableColumns(pView, pGroup);
		const tmpPDFSet = this.getPDFHiddenColumnsSet(pView, pGroup);
		let tmpRowsHTML = '';
		for (let i = 0; i < tmpColumns.length; i++)
		{
			const tmpColumn = tmpColumns[i];
			const tmpHTMLHidden = !tmpColumn.Visible;
			const tmpExplicitPDFHidden = tmpPDFSet.has(tmpColumn.Key);
			// Effective: a column hidden interactively is necessarily hidden in PDF.
			const tmpPDFHidden = tmpHTMLHidden || tmpExplicitPDFHidden;
			tmpRowsHTML += this.renderColumnChooserRowHTML(pLayout, pView, pGroup, tmpColumn, tmpHTMLHidden, tmpPDFHidden, tmpExplicitPDFHidden);
		}
		const tmpPopoverHTML = `<div class="pict-tabular-colchooser-backdrop" onclick="_Pict.providers['Pict-Layout-Tabular'].closeTabularColumnChooser('${pView.Hash}', ${pGroup.GroupIndex})"></div>` +
			`<div class="pict-tabular-colchooser-panel">` +
			`<div class="pict-tabular-colchooser-list">${tmpRowsHTML}</div>` +
			`<div class="pict-tabular-colchooser-footer">` +
			`<button type="button" class="pict-tabular-colchooser-reset" onclick="_Pict.providers['Pict-Layout-Tabular'].resetTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex})">Reset to defaults</button>` +
			`</div>` +
			`</div>`;
		this.pict.ContentAssignment.assignContent(`#${pLayout._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}`, tmpPopoverHTML);
	}

	/**
	 * Build one chooser row: the framework's HTML show/hide checkbox plus the
	 * Headlight PDF-hide toggle. The PDF toggle is disabled (locked) when the column
	 * is hidden in the interactive view, since that already forces it hidden in PDF.
	 * @param {Object} pLayout - The Pict-Layout-Tabular provider (for _escapeHTML).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @param {{Key: string, Name: string, ColumnIndex: number, Visible: boolean}} pColumn - The choosable column.
	 * @param {boolean} pHTMLHidden - Column hidden in the interactive (HTML) view.
	 * @param {boolean} pPDFHidden - Column effectively hidden in PDF (HTML-hidden OR PDF-hidden).
	 * @param {boolean} pExplicitPDFHidden - Column in the explicit PDF-only hidden set.
	 * @return {string} - The row HTML.
	 */
	renderColumnChooserRowHTML(pLayout, pView, pGroup, pColumn, pHTMLHidden, pPDFHidden, pExplicitPDFHidden)
	{
		const tmpName = pLayout._escapeHTML(pColumn.Name);
		// Same checkbox + handler the framework uses, so interactive show/hide is unchanged.
		const tmpCheckbox = `<label class="colchooser-html-label">` +
			`<input type="checkbox"${pColumn.Visible ? ' checked="checked"' : ''} ` +
			`onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumn.ColumnIndex}, this.checked)">` +
			`<span>${tmpName}</span>` +
			`</label>`;
		const tmpEyeIcon = pPDFHidden ? 'fa-eye-slash' : 'fa-eye';
		const tmpStateClass = pPDFHidden ? ' is-pdf-hidden' : '';
		const tmpDisabledAttr = pHTMLHidden ? ' disabled="disabled"' : '';
		const tmpTitle = pHTMLHidden ?
			'Hidden in all views (including PDF)' :
			(pExplicitPDFHidden ? 'Hidden in PDF — click to show in PDF' : 'Shown in PDF — click to hide in PDF');
		// Toggle target: flip the EXPLICIT PDF-only membership (cascade is read-only).
		const tmpNewHidden = String(!pExplicitPDFHidden);
		const tmpButton = `<button type="button" class="colchooser-pdf-toggle${tmpStateClass}"${tmpDisabledAttr} ` +
			`title="${tmpTitle}" aria-label="${tmpTitle}" ` +
			`onclick="_Pict.providers['Bulma-TableControls'].toggleTabularColumnPDFVisibility('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumn.ColumnIndex}, ${tmpNewHidden})">` +
			`<span class="icon is-small"><i class="fas fa-file-pdf" aria-hidden="true"></i></span>` +
			`<span class="icon is-small"><i class="fas ${tmpEyeIcon}" aria-hidden="true"></i></span>` +
			`</button>`;
		return `<div class="pict-tabular-colchooser-row has-pdf-toggle">${tmpCheckbox}${tmpButton}</div>`;
	}

	/**
	 * Inline-handler entry point for the PDF-hide toggle: add/remove a column from
	 * the group's PDF-only hidden set, persist it to form data, and repaint the
	 * popover (the interactive table is not rebuilt — its column set is unchanged).
	 * Refuses to hide the last column that would still print.
	 * @param {string} pViewHash - The view hash.
	 * @param {number|string} pGroupIndex - The tabular group index.
	 * @param {number|string} pColumnIndex - The column's manifest index.
	 * @param {boolean} pHidden - true to hide the column in PDF, false to show it.
	 * @return {boolean} - True on success.
	 */
	toggleTabularColumnPDFVisibility(pViewHash, pGroupIndex, pColumnIndex, pHidden)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		const tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !(tmpGroup.ColumnChooser && tmpGroup.ColumnChooser.SelectPDFOnlyColumns))
		{
			return false;
		}
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || (typeof tmpLayout._getTabularChoosableColumns !== 'function'))
		{
			return false;
		}
		const tmpColumns = tmpLayout._getTabularChoosableColumns(tmpView, tmpGroup);
		const tmpColumn = tmpColumns.find((pCandidate) => pCandidate.ColumnIndex === Number(pColumnIndex));
		if (!tmpColumn)
		{
			return false;
		}
		const tmpPDFSet = this.getPDFHiddenColumnsSet(tmpView, tmpGroup);
		if (pHidden)
		{
			// Don't let the last column that still prints be hidden — keep a non-empty PDF table.
			const tmpVisibleInPDF = tmpColumns.filter((pCandidate) => pCandidate.Visible && !tmpPDFSet.has(pCandidate.Key)).length;
			if (tmpVisibleInPDF <= 1 && tmpColumn.Visible && !tmpPDFSet.has(tmpColumn.Key))
			{
				this.pict.log.warn(`Headlight PDF column chooser on group [${tmpGroup.Hash}] refused to hide the last PDF-visible column [${tmpColumn.Key}].`);
				this.rerenderColumnChooserPopover(tmpView, tmpGroup);
				return false;
			}
			tmpPDFSet.add(tmpColumn.Key);
		}
		else
		{
			tmpPDFSet.delete(tmpColumn.Key);
		}
		this.pict.setStateValueAtAddress(this.getPDFHiddenColumnsAddress(tmpView, tmpGroup), null, Array.from(tmpPDFSet));
		this.rerenderColumnChooserPopover(tmpView, tmpGroup);
		return true;
	}

	/**
	 * Repaint a group's chooser popover and keep it open (mirrors what the framework
	 * toggle handlers do after a change).
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 */
	rerenderColumnChooserPopover(pView, pGroup)
	{
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || (typeof tmpLayout._renderTabularColumnChooserPopover !== 'function'))
		{
			return;
		}
		tmpLayout._renderTabularColumnChooserPopover(pView, pGroup);
		if (typeof tmpLayout._paintTabularColumnChooserOpenState === 'function')
		{
			tmpLayout._paintTabularColumnChooserOpenState(pView, pGroup, true);
		}
	}

	/**
	 * Render the left-position editing-controls cell: the same menu button the
	 * right-side ('Postfix') controls use. Mirrors -TabularTemplate-Row-ExtraPostfix.
	 * @param {Object} pView - The form view.
	 * @param {number|string} pGroupIndex - The tabular group index.
	 * @param {number|string} pRowKey - The row key/index.
	 * @return {string} - The <td> editing-controls cell HTML.
	 */
	renderTabularEditingControlsMenuCell(pView, pGroupIndex, pRowKey)
	{
		if (!pView)
		{
			return '';
		}
		const tmpUUID = pView.UUID;
		const tmpViewHash = pView.Hash;
		const tmpButtonID = `TABLE-MENU-BUTTON-FOR-${tmpUUID}-${tmpViewHash}-${pGroupIndex}-${pRowKey}`;
		return `<td class="extra-table-column" data-table-controls="menu">` +
			`<button id="${tmpButtonID}" class="button is-link is-outlined" type="button" aria-haspopup="true"` +
			` onmouseover="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '${tmpUUID}', '${tmpViewHash}', '${pGroupIndex}', '${pRowKey}', event)"` +
			` onclick="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '${tmpUUID}', '${tmpViewHash}', '${pGroupIndex}', '${pRowKey}', event)">` +
			`<span class="icon is-small"><i class="fas fa-ellipsis" aria-hidden="true"></i></span>` +
			`</button>` +
			`</td>`;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the content display input element.
	 */
	getTableHTMLID(pInputHTMLID)
	{
		return `#TABLE-FOR-${pInputHTMLID}`;
	}
	getTableWrapperHTMLID(pInputHTMLID)
	{
		return `#TABLE-WRAPPER-FOR-${pInputHTMLID}`;
	}
	getTableSliderHTMLID(pInputHTMLID)
	{
		return `#TABLE-SLIDER-FOR-${pInputHTMLID}`;
	}
	getTableSliderWrapperHTMLID(pInputHTMLID)
	{
		return `#TABLE-SLIDER-WRAPPER-FOR-${pInputHTMLID}`;
	}

	/**
	 * Check if an element has scroll overflow.
	 * @param {string} pInputHTMLID - The HTML ID of the element.
	 * @return {boolean} - True if the element has scroll overflow, false otherwise.
	 */
	doesElementHaveScrollOverflow(pInputHTMLID)
	{
		const tmpTableElement = document.querySelector(this.getTableHTMLID(pInputHTMLID));
		const tmpTableWrapperElement = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		return tmpTableElement.scrollWidth > tmpTableWrapperElement.clientWidth ? true : false;
	}

	/**
	 * Tombstone the rows the row's selectors own before the row is spliced away.
	 *
	 * Row deletion is the one removal route with no input-level seam: `deleteDynamicTableRow` splices
	 * the record set and notifies nothing, so each selector in the row is asked for its owned rows here,
	 * the last point at which they still exist.
	 *
	 * @param {Object} pView - The dynamic-form view owning the row.
	 * @param {Record<string, any>} pGroup - The group descriptor (for its RecordSetAddress).
	 * @param {number|string} pRowIndex - The row about to be deleted.
	 * @return {number} - How many tombstones were staged.
	 */
	stageRowRemovalTombstones(pView, pGroup, pRowIndex)
	{
		if (!ScopedEntityData.isEnabled(this.pict))
		{
			return 0;
		}
		const tmpRemovals = ScopedEntityData.collectRowSelectorRemovals(this.pict, pView, pGroup, pRowIndex);
		if (tmpRemovals.length < 1)
		{
			return 0;
		}
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, ScopedEntityData.DEFAULT_CONTEXT, tmpRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`Bulma-TableControls: staged deletion of ${tmpResult.Staged.length} record(s) with row ${pRowIndex} of [${pGroup.RecordSetAddress}].`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * Handle a table row action from a dropdown menu.
	 * @param {string} pAction - The action to perform.
	 * @param {string} pGUID - The GUID of the table row.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {number} pGroupIndex - The group number of the table row.
	 * @param {string} pRowIndex - The key of the table row.
	 * @return {boolean} - True if the action was successful, false otherwise.
	 */
	handleTableMenuButtonEvent(pAction, pGUID, pViewHash, pGroupIndex, pRowIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		// Hide the popover menu before the action is performed to avoid visual glitches
		this.fable.HeadlightPopover.hideAll();
		// Perform the action after a short delay to allow the popover to hide properly and not UI jump to the top left of the screen
		setTimeout(() =>
		{
			// handle toast notifications for table row actions based on min/max row counts
			if (pAction === 'Delete')
			{
				if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
				{
					this.pict.log.error(`Cannot delete row, minimum row count reached: ${tmpGroup.MinimumRowCount}`);
					this.pict.views.HeadlightPanels.toast({
						message: `Cannot delete row, minimum row count reached: ${tmpGroup.MinimumRowCount}`,
						type: 'is-warning',
					});
					this.fable.HeadlightPopover.hideAll();
					return false;
				}
				this.stageRowRemovalTombstones(tmpView, tmpGroup, pRowIndex);
				this.pict.views[pViewHash].deleteDynamicTableRow(pGroupIndex, pRowIndex);
			}
			else if (pAction === 'MoveUp')
			{
				const tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == 0)
				{
					this.pict.log.error(`Cannot move row up, already at the top: ${tmpRowIndex}`);
					this.pict.views.HeadlightPanels.toast({
						message: `Cannot move row up, already at the top.`,
						type: 'is-warning',
					});
					this.fable.HeadlightPopover.hideAll();
					return false;
				}
				this.pict.views[pViewHash].moveDynamicTableRowUp(pGroupIndex, pRowIndex);
			}
			else if (pAction === 'MoveDown')
			{
				const tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == (tmpDestinationObject.length - 1))
				{
					this.pict.log.error(`Cannot move row down, already at the bottom: ${tmpRowIndex}`);
					this.pict.views.HeadlightPanels.toast({
						message: `Cannot move row down, already at the bottom.`,
						type: 'is-warning',
					});
					this.fable.HeadlightPopover.hideAll();
					return false;
				}
				this.pict.views[pViewHash].moveDynamicTableRowDown(pGroupIndex, pRowIndex);
			}
			else
			{
				this.pict.log.error(`Unknown action: ${pAction}`);
			}
			// Update any necessary controls
			this.prepareAnyExtraTableControls();
		}, 0);
		return true;
	}

	/**
	 * Add a dropdown menu to the toggle button for a table row.
	 * @param {string} pElementId - The ID of the element to attach the popover menu to.
	 * @param {string} pGUID - The GUID of the table row.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {number} pGroup - The group number of the table row.
	 * @param {string} pKey - The key of the table row.
	 * @param {Event} pEvent - The event that triggered the function.
	 */
	showMenuForTable(pElementId, pGUID, pViewHash, pGroup, pKey, pEvent)
	{
		const tmpMenuElement = document.getElementById(`TABLE-MENU-BUTTON-FOR-${pGUID}-${pViewHash}-${pGroup}-${pKey}`);
		if (!tmpMenuElement)
		{
			return;
		}

		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'PictProvider-Theme-Edit-TabularTemplate-RowHeader-ExtraPostfix-TableMenu',
			PopoverTemplateRecord:
				{
					UUID: pGUID,
					Hash: pViewHash,
					Group: pGroup,
					Key: pKey,
				},
			theme: 'dropdown',
			delay: [ 500, 0 ], // delay showing the menu to allow for click events to propagate, avoid accidental hover displays, etc.
		});
	}

	/**
	 * Show any slider controls for tables that have scroll overflow.
	 */
	prepareAnyExtraTableControls()
	{
		const tmpScrollTables = document.querySelectorAll('.section-table-wrapper table');

		this.pict.log.info(`Checking ${ tmpScrollTables.length } tables for scroll overflow...`);
		tmpScrollTables.forEach((pTable) =>
		{
			if (!pTable.id.startsWith('TABLE-FOR-'))
			{
				return;
			}
			const tmpHTMLID = pTable.id.replace('TABLE-FOR-', '');
			// add a slider control to the table if it has scroll overflow
			this.toggleScrollTableSlider(tmpHTMLID);
			// Enable/disable both add bars (the default bottom one and the opt-in top
			// one) against MaximumRowCount.
			//
			// NOTE the placeholder row's class really is 'table-emtpy-row' (sic) -- that
			// is what the group templates emit. This used to count every tbody row and
			// then subtract one via `tr:not(.table-empty-row)`, a selector whose spelling
			// matched nothing, so it happened to land on the right number only because
			// there is always exactly one placeholder. Exclude it directly instead.
			const currentNumRows = pTable.querySelectorAll('tbody tr:not(.table-emtpy-row)').length;
			this.applyAddButtonRowLimit(
				[ document.getElementById(`TABLE-ADD-BUTTON-FOR-${tmpHTMLID}`), document.getElementById(`TABLE-ADD-BUTTON-TOP-FOR-${tmpHTMLID}`) ],
				currentNumRows, 'data-max-rows', 'data-min-rows');
		});
		// reveal the inline/modal entry toggle on groups that have grown large enough
		this.refreshEntryModeToggleVisibility();
		// recalculate responsive UI adjustments for label alignments, etc.
		this.pict.providers.ResponsiveUIAdjustmentProvider.onWindowResize();
	}

	/**
	 * Toggle the slider control for a table that has scroll overflow.
	 * @param {string} pHTMLSelector - The HTML ID of the table.
	 */
	toggleScrollTableSlider(pHTMLSelector)
	{
		const tmpSliderElement = document.querySelector(this.getTableSliderWrapperHTMLID(pHTMLSelector));
		if (tmpSliderElement)
		{
			if (this.doesElementHaveScrollOverflow(pHTMLSelector))
			{
				this.pict.log.info(`Adding slider to overflow table ID: ${ pHTMLSelector }`);
				tmpSliderElement.classList.remove('is-hidden');
			}
			else
			{
				tmpSliderElement.classList.add('is-hidden');
			}
		}
	}

	/**
	 * Handle the click event for the "Toggle Extra Column" button in a table.
	 * @param {Event} event - The click event.
	 * @param {string} pInputHTMLID - The HTML ID of the table.
	 */
	handleToggleExtraColumnButtonClickEvents(event, pInputHTMLID)
	{
		const tmpButton = /** @type {HTMLButtonElement} */ (event.currentTarget);
		const tmpTableWrapperElement = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		if (tmpTableWrapperElement && tmpButton)
		{
			// find the parent '.section-table-wrapper' element and toggle the 'hide-extra-table-columns' class on it to show/hide the extra column via CSS
			const tmpSectionTableWrapperElement = tmpTableWrapperElement.closest('.section-table-wrapper');
			if (tmpSectionTableWrapperElement)
			{
				const isVisible = !tmpSectionTableWrapperElement.classList.contains('hide-extra-table-columns');
				if (isVisible)
				{
					tmpSectionTableWrapperElement.classList.add('hide-extra-table-columns');
					this.setMenuColumnToggleButtonContent(tmpButton, 'fa-eye', ' Show Menu Column');
				}
				else
				{
					tmpSectionTableWrapperElement.classList.remove('hide-extra-table-columns');
					this.setMenuColumnToggleButtonContent(tmpButton, 'fa-eye-slash', ' Hide Menu Column');
				}
				// recalculate responsive UI adjustments for label alignments, etc.
				this.pict.providers.ResponsiveUIAdjustmentProvider.onWindowResize();
			}
		}
	}

	/**
	 * Repopulate the show/hide menu-column toggle button with an icon + label via DOM
	 * nodes (not an HTML string).
	 * @param {HTMLButtonElement} pButton - The toggle button to repopulate.
	 * @param {string} pIconClass - The Font Awesome icon class (e.g. 'fa-eye').
	 * @param {string} pLabel - The button label (leading space preserved for icon spacing).
	 */
	setMenuColumnToggleButtonContent(pButton, pIconClass, pLabel)
	{
		const tmpIconSpan = document.createElement('span');
		tmpIconSpan.className = 'icon';
		const tmpIcon = document.createElement('i');
		tmpIcon.className = `fas ${pIconClass}`;
		tmpIcon.setAttribute('aria-hidden', 'true'); // decorative; label text carries meaning
		tmpIconSpan.appendChild(tmpIcon);

		const tmpLabelSpan = document.createElement('span');
		tmpLabelSpan.textContent = pLabel;

		// Clear via removeChild loop (replaceChildren isn't in this bundle's browserslist target).
		while (pButton.firstChild)
		{
			pButton.removeChild(pButton.firstChild);
		}
		pButton.appendChild(tmpIconSpan);
		pButton.appendChild(tmpLabelSpan);
	}

	/**
	 * Handle the scroll event for a table that has scroll overflow the user uses the slider control to scroll.
	 * @param {string} pInputHTMLID - The HTML ID of the table.
	 * @param {Event} pEvent - The event that triggered the function.
	 */
	updateScrollTableFromSliderEvent(pInputHTMLID, pEvent)
	{
		pEvent.preventDefault();
		pEvent.stopPropagation();
		//console.log('handleScrollTableBySliderEvent', pEvent.currentTarget.value);
		// make the slider and the table horizontally scroll together
		/** @type {HTMLDivElement} */
		const tmpTableWrapper = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		/** @type {HTMLTableElement} */
		const tmpTable = document.querySelector(this.getTableHTMLID(pInputHTMLID));
		/** @type {HTMLInputElement} */
		const tmpSlider = document.querySelector(this.getTableSliderHTMLID(pInputHTMLID));
		// @ts-ignore
		const sliderValue = Number(pEvent.currentTarget.value);
		// if the table and the slider are found, make them scroll together
		if (tmpTableWrapper && tmpTable && tmpSlider)
		{
			// scroll the table horizontally based on the slider value
			const maxScrollLeft = tmpTable.scrollWidth - tmpTableWrapper.clientWidth;
			const scrollLeft = (Number(sliderValue) / 100) * maxScrollLeft;
			tmpTableWrapper.scrollLeft = scrollLeft;
		}
	}

	/**
	 * Handle the scroll event for a table that has scroll overflow the user scrolls the table horizontally.
	 * @param {string} pInputHTMLID - The HTML ID of the table.
	 * @param {Event} pEvent - The event that triggered the function.
	 */
	updateSliderFromScrollTableEvent(pInputHTMLID, pEvent)
	{
		pEvent.preventDefault();
		pEvent.stopPropagation();
		//console.log('updateSliderFromScrollTableEvent', pEvent.currentTarget.scrollLeft);
		// make the slider and the table horizontally scroll together
		/** @type {HTMLDivElement} */
		const tmpTableWrapper = document.querySelector(this.getTableWrapperHTMLID(pInputHTMLID));
		/** @type {HTMLTableElement} */
		const tmpTable = document.querySelector(this.getTableHTMLID(pInputHTMLID));
		/** @type {HTMLInputElement} */
		const tmpSlider = document.querySelector(this.getTableSliderHTMLID(pInputHTMLID));
		// if the table and the slider are found, make them scroll together
		if (tmpTableWrapper && tmpTable && tmpSlider)
		{
			// update the slider value based on the table scroll position
			const maxScrollLeft = tmpTable.scrollWidth - tmpTableWrapper.clientWidth;
			const sliderValue = ((tmpTableWrapper.scrollLeft / maxScrollLeft) * 100).toFixed(0);
			tmpSlider.value = sliderValue;
		}
	}

	/**
	 * Keep the "Add Row" button in view after adding a row to a table.
	 * @param {HTMLButtonElement} pButtonElement - The button element to keep in view.
	 */
	keepButtonInView(pButtonElement)
	{
		// Ensure the button is in view after adding a row
		const tmpButton = pButtonElement;
		const navBottomHeight = document.getElementById('HeadlightPanels-NavBar') ? document.getElementById('HeadlightPanels-NavBar').offsetHeight : 60;
		const extraSpacingGap = 10;
		window.scrollTo({
			top: tmpButton.getBoundingClientRect().top + window.scrollY + navBottomHeight + extraSpacingGap,
			behavior: 'smooth',
		});
	}

	/**
	 * Handle the click event for the "Add Row" button in a table.
	 * NOTE: This is a secondary call to prepare any extra table controls after the row is added/rendered - it doesn't actually add the row (that is handled by the Pict Provider).
	 * @param {Event} event - The click event.
	 */
	handleAddRowButtonClickEvents(event)
	{
		/** @ts-ignore */
		const tmpButton = event.currentTarget.TagName === 'BUTTON' ? event.currentTarget : event.currentTarget.parentElement;
		// After a short delay, keep the button in view
		setTimeout(() =>
		{
			this.keepButtonInView(tmpButton);
			// Update any necessary controls
			this.prepareAnyExtraTableControls();
		}, 100);
	}

	// ═════════════════════════════════════════════════════════════════════
	// Empty-table message
	// ═════════════════════════════════════════════════════════════════════

	/**
	 * Resolve the copy for a tabular group's "no rows" placeholder row.
	 *
	 * Backs the `{~TabularEmptyMessage:<address>:<default copy>~}` macro. The
	 * pattern body is split on the FIRST colon so the default copy may itself
	 * contain colons; everything after that first colon is the fallback.
	 *
	 * @param {string} pPatternBody - The macro body: `<address>:<default copy>`.
	 * @param {Object} pData - The template data scope.
	 * @param {any} [fCallback] - Passed through to resolveStateFromAddress.
	 * @return {string} - The escaped message text.
	 */
	resolveTabularEmptyMessage(pPatternBody, pData, fCallback)
	{
		const tmpBody = (typeof pPatternBody === 'string') ? pPatternBody : '';
		const tmpSeparatorIndex = tmpBody.indexOf(':');
		const tmpAddress = (tmpSeparatorIndex < 0) ? tmpBody : tmpBody.substring(0, tmpSeparatorIndex);
		const tmpDefaultMessage = (tmpSeparatorIndex < 0) ? '' : tmpBody.substring(tmpSeparatorIndex + 1);
		const tmpGroup = this.pict.resolveStateFromAddress(tmpAddress, pData, fCallback);
		// A group that never opted in falls back to the theme's own literal, which
		// the template passes in -- that is what keeps every existing form identical.
		const tmpMessage = (tmpGroup && tmpGroup.EmptyMessage) ? tmpGroup.EmptyMessage : tmpDefaultMessage;
		return _escapeTemplateText(tmpMessage);
	}

	// ═════════════════════════════════════════════════════════════════════
	// Entry controls
	// ═════════════════════════════════════════════════════════════════════

	/**
	 * Normalize a group's `EntryControls` block. Returns null when the group did
	 * not opt in (or explicitly disabled it) -- every caller treats null as
	 * "behave exactly the way this table behaved before the feature existed".
	 * @param {Object} pGroup - The group descriptor.
	 * @return {Object|null} - The normalized config, or null.
	 */
	getEntryControlsConfig(pGroup)
	{
		if (!pGroup || !pGroup.EntryControls || (typeof pGroup.EntryControls !== 'object'))
		{
			return null;
		}
		const tmpRaw = pGroup.EntryControls;
		if (tmpRaw.Enabled === false)
		{
			return null;
		}
		const tmpAutoReveal = (tmpRaw.ModeToggleAutoReveal && (typeof tmpRaw.ModeToggleAutoReveal === 'object')) ? tmpRaw.ModeToggleAutoReveal : {};
		const tmpPosition = ([ 'top', 'bottom', 'both' ].indexOf(tmpRaw.Position) > -1) ? tmpRaw.Position : _EntryControlsDefaults.Position;
		const tmpEntryPoint = ([ 'start', 'end' ].indexOf(tmpRaw.EntryPoint) > -1) ? tmpRaw.EntryPoint : _EntryControlsDefaults.EntryPoint;
		const tmpMode = ([ 'inline', 'modal' ].indexOf(tmpRaw.Mode) > -1) ? tmpRaw.Mode : _EntryControlsDefaults.Mode;
		return (
			{
				Position: tmpPosition,
				EntryPoint: tmpEntryPoint,
				Mode: tmpMode,
				AllowModeToggle: (tmpRaw.AllowModeToggle === true),
				RowThreshold: (typeof tmpAutoReveal.RowThreshold === 'number') ? tmpAutoReveal.RowThreshold : _EntryControlsDefaults.RowThreshold,
				// A ViewportMultiple of 0 disables the height half of the heuristic.
				ViewportMultiple: (typeof tmpAutoReveal.ViewportMultiple === 'number') ? tmpAutoReveal.ViewportMultiple : _EntryControlsDefaults.ViewportMultiple,
				// `false` means "always visible" -- skip the size heuristic entirely.
				AutoReveal: (tmpRaw.ModeToggleAutoReveal !== false),
				ModalTitle: (typeof tmpRaw.ModalTitle === 'string') ? tmpRaw.ModalTitle : _EntryControlsDefaults.ModalTitle,
				ModalWidth: (typeof tmpRaw.ModalWidth === 'string') ? tmpRaw.ModalWidth : _EntryControlsDefaults.ModalWidth,
				ModalColumns: (tmpRaw.ModalColumns === 2) ? 2 : _EntryControlsDefaults.ModalColumns,
			});
	}

	/**
	 * True when the group renders through the RecordSet layout rather than Tabular.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {boolean}
	 */
	isRecordSetGroup(pGroup)
	{
		return !!(pGroup && (pGroup.Layout === 'RecordSet'));
	}

	/**
	 * The form view hash that owns a group.
	 *
	 * Groups are not stamped with it, so find the section view whose own group list
	 * CONTAINS this exact group object. Do NOT read PictForm.ViewHash off the
	 * supportingManifest descriptors: ManifestFactory writes that onto the shared
	 * `ReferenceManifests` descriptor objects, so two groups built from the same
	 * RecordManifest overwrite each other and the last view to initialize wins.
	 *
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The view hash, or '' when it cannot be resolved.
	 */
	getGroupViewHash(pGroup)
	{
		if (!pGroup)
		{
			return '';
		}
		if (typeof pGroup._EntryControlsViewHash === 'string')
		{
			return pGroup._EntryControlsViewHash;
		}
		const tmpViewHashes = Object.keys(this.pict.views || {});
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			const tmpView = this.pict.views[tmpViewHashes[i]];
			if (!tmpView || !tmpView.isPictSectionForm || (typeof tmpView.getGroups !== 'function'))
			{
				continue;
			}
			const tmpGroups = tmpView.getGroups();
			if (!Array.isArray(tmpGroups))
			{
				continue;
			}
			for (let g = 0; g < tmpGroups.length; g++)
			{
				if (tmpGroups[g] === pGroup)
				{
					pGroup._EntryControlsViewHash = String(tmpView.Hash);
					return pGroup._EntryControlsViewHash;
				}
			}
		}
		return '';
	}

	/**
	 * The localStorage-shaped object the entry-mode preference lives in, or null
	 * when storage is unavailable. Mirrors PictProvider-SpecScopeResolver's
	 * accessor so tests can inject a fake via `options.EntryModeStorage`.
	 * @return {Object|null}
	 */
	_entryModeStorage()
	{
		try
		{
			if (this.options && this.options.EntryModeStorage)
			{
				return this.options.EntryModeStorage;
			}
			return (typeof localStorage !== 'undefined') ? localStorage : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The storage key for this group's entry-mode preference.
	 */
	getEntryModeStorageKey(pViewHash, pGroup)
	{
		return `${_ENTRY_MODE_STORAGE_PREFIX}.${pViewHash}.${(pGroup && pGroup.Hash) || 'UnknownGroup'}`;
	}

	/**
	 * The user's stored inline/modal preference for a group, or null when they
	 * have never chosen. Never read when the group didn't allow the toggle.
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @return {string|null} - 'inline' | 'modal' | null.
	 */
	readEntryModePreference(pViewHash, pGroup, pConfig)
	{
		if (!pConfig || !pConfig.AllowModeToggle)
		{
			return null;
		}
		const tmpStorage = this._entryModeStorage();
		if (!tmpStorage)
		{
			return null;
		}
		try
		{
			const tmpValue = tmpStorage.getItem(this.getEntryModeStorageKey(pViewHash, pGroup));
			return ((tmpValue === 'inline') || (tmpValue === 'modal')) ? tmpValue : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * Persist the user's inline/modal preference for a group.
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @param {string} pMode - 'inline' | 'modal'.
	 * @return {boolean} - True when it was written.
	 */
	writeEntryModePreference(pViewHash, pGroup, pConfig, pMode)
	{
		if (!pConfig || !pConfig.AllowModeToggle || ((pMode !== 'inline') && (pMode !== 'modal')))
		{
			return false;
		}
		const tmpStorage = this._entryModeStorage();
		if (!tmpStorage)
		{
			return false;
		}
		try
		{
			tmpStorage.setItem(this.getEntryModeStorageKey(pViewHash, pGroup), pMode);
			return true;
		}
		catch (pError)
		{
			return false;
		}
	}

	/**
	 * The mode that actually applies right now: the group's configured default,
	 * overridden by the user's stored preference when the toggle is allowed.
	 * @param {string} pViewHash - The form view hash.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - 'inline' | 'modal'.
	 */
	getEffectiveEntryMode(pViewHash, pGroup)
	{
		const tmpConfig = this.getEntryControlsConfig(pGroup);
		if (!tmpConfig)
		{
			return 'inline';
		}
		return this.readEntryModePreference(pViewHash, pGroup, tmpConfig) || tmpConfig.Mode;
	}

	/**
	 * The opt-in TOP add bar for a group, or '' when the group did not ask for
	 * one. Emitted as a whole from a macro (rather than living in the template
	 * behind a hide class) so that a group without `EntryControls` produces no
	 * extra DOM at all -- existing forms render exactly what they rendered before.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The bar HTML.
	 */
	renderEntryAddBarHTML(pGroup)
	{
		const tmpConfig = this.getEntryControlsConfig(pGroup);
		if (!tmpConfig || ((tmpConfig.Position !== 'top') && (tmpConfig.Position !== 'both')))
		{
			return '';
		}
		const tmpViewHash = this.getGroupViewHash(pGroup);
		const tmpView = this.pict.views[tmpViewHash];
		if (!tmpView)
		{
			this.pict.log.warn(`Entry controls on group [${pGroup.Hash}] could not resolve its form view; skipping the top add bar.`);
			return '';
		}
		const tmpIsRecordSet = this.isRecordSetGroup(pGroup);
		const tmpProviderHash = tmpIsRecordSet ? 'Bulma-RecordSetControls' : 'Bulma-TableControls';
		// The top bar is tagged 'entry-bar-top' so it is still swept up by the
		// `.hide-table-controls [data-table-controls]` /
		// `.hide-recordset-controls [data-recordset-controls]` suppression rules.
		const tmpControlsAttribute = tmpIsRecordSet ? 'data-recordset-controls' : 'data-table-controls';
		const tmpElementKey = `${tmpView.UUID}-${tmpViewHash}-${pGroup.Hash}`;
		const tmpButtonID = `${tmpIsRecordSet ? 'RECORDSET' : 'TABLE'}-ADD-BUTTON-TOP-FOR-${tmpElementKey}`;
		const tmpLabel = tmpIsRecordSet ? 'Add new set' : 'Add new row';
		const tmpMaxAttribute = tmpIsRecordSet ? 'data-max-sets' : 'data-max-rows';
		const tmpMinAttribute = tmpIsRecordSet ? 'data-min-sets' : 'data-min-rows';
		const tmpMaxValue = (pGroup.MaximumRowCount == null) ? '' : String(pGroup.MaximumRowCount);
		const tmpMinValue = (pGroup.MinimumRowCount == null) ? '' : String(pGroup.MinimumRowCount);
		return `<div class="columns is-vcentered is-mobile p-0 m-0" ${tmpControlsAttribute}="entry-bar-top">` +
			`<div class="column p-0 mt-2 mb-2 mr-3 has-text-right">` +
			this.renderEntryModeToggleHTML(pGroup) +
			`<button type="button" id="${this._escapeEntryAttribute(tmpButtonID)}" class="button is-link"` +
			` ${tmpControlsAttribute}="${tmpIsRecordSet ? 'add-set' : 'add-row'}"` +
			` ${tmpMaxAttribute}="${this._escapeEntryAttribute(tmpMaxValue)}" ${tmpMinAttribute}="${this._escapeEntryAttribute(tmpMinValue)}"` +
			` onclick="_Pict.providers['${tmpProviderHash}'].handleAddEntryButtonClickEvents(event, '${this._escapeEntryAttribute(tmpViewHash)}', '${this._escapeEntryAttribute(String(pGroup.GroupIndex))}')">` +
			`<span class="icon"><i class="fas fa-plus" aria-hidden="true"></i></span>` +
			`<span> ${tmpLabel}</span>` +
			`</button>` +
			`</div>` +
			`</div>`;
	}

	/**
	 * The inline/modal toggle button markup, or '' when the group didn't opt in.
	 * Starts hidden; refreshEntryModeToggleVisibility() reveals it.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {string} - The button HTML.
	 */
	renderEntryModeToggleHTML(pGroup)
	{
		const tmpConfig = this.getEntryControlsConfig(pGroup);
		if (!tmpConfig || !tmpConfig.AllowModeToggle)
		{
			return '';
		}
		const tmpViewHash = this.getGroupViewHash(pGroup);
		const tmpMode = tmpViewHash ? this.getEffectiveEntryMode(tmpViewHash, pGroup) : tmpConfig.Mode;
		const tmpIsModal = (tmpMode === 'modal');
		const tmpLabel = tmpIsModal ? 'Entry: Dialog' : 'Entry: Inline';
		const tmpIcon = tmpIsModal ? 'fa-window-restore' : 'fa-list';
		const tmpTitle = tmpIsModal ?
			'New entries open in a dialog. Click to switch to inline entry.' :
			'New entries are added inline. Click to switch to dialog entry.';
		// Hidden until the group is big enough to warrant the choice (or always,
		// when the author turned the heuristic off).
		const tmpHiddenClass = tmpConfig.AutoReveal ? ' is-hidden' : '';
		const tmpProviderHash = this.isRecordSetGroup(pGroup) ? 'Bulma-RecordSetControls' : 'Bulma-TableControls';
		return `<button type="button" class="button is-link is-outlined pict-entry-mode-toggle${tmpHiddenClass}"` +
			` data-entry-mode-toggle="${this._escapeEntryAttribute(String(pGroup.Hash))}"` +
			` data-entry-mode-group-index="${this._escapeEntryAttribute(String(pGroup.GroupIndex))}"` +
			` data-entry-mode-rows="${tmpConfig.RowThreshold}"` +
			` data-entry-mode-viewport="${tmpConfig.ViewportMultiple}"` +
			` title="${tmpTitle}" aria-label="${tmpTitle}"` +
			` onclick="_Pict.providers['${tmpProviderHash}'].toggleEntryMode('${this._escapeEntryAttribute(tmpViewHash)}', '${this._escapeEntryAttribute(String(pGroup.GroupIndex))}')">` +
			`<span class="icon is-small"><i class="fas ${tmpIcon}" aria-hidden="true"></i></span>` +
			`<span>${tmpLabel}</span>` +
			`</button>`;
	}

	/**
	 * Minimal attribute escaping for values interpolated into the toggle markup.
	 * @param {string} pValue - The raw value.
	 * @return {string} - The escaped value.
	 */
	_escapeEntryAttribute(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	/**
	 * Flip a group between inline and modal entry, persist the choice, and
	 * repaint the group so the toggle's own label updates.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True on success.
	 */
	toggleEntryMode(pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			return false;
		}
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);
		if (!tmpConfig || !tmpConfig.AllowModeToggle)
		{
			return false;
		}
		const tmpNextMode = (this.getEffectiveEntryMode(pViewHash, tmpGroup) === 'modal') ? 'inline' : 'modal';
		this.writeEntryModePreference(pViewHash, tmpGroup, tmpConfig, tmpNextMode);
		// The toggle lives in the group's baked markup, so a plain render is
		// enough to relabel it -- no template rebuild needed.
		tmpView.render();
		tmpView.marshalToView();
		this.prepareAnyExtraEntryControls(tmpGroup);
		return true;
	}

	/**
	 * The single entry point for BOTH add bars (top and bottom) on both layouts.
	 * When the group never opted into EntryControls this reproduces the exact
	 * legacy behavior the template's onclick used to inline.
	 * @param {Event} pEvent - The click event.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True when an entry was started.
	 */
	handleAddEntryButtonClickEvents(pEvent, pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`Entry controls could not resolve view [${pViewHash}].`);
			return false;
		}
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);

		if (!tmpConfig)
		{
			// Legacy path: create the row, then the original post-add fixups.
			tmpView.createDynamicTableRow(pGroupIndex);
			this.handleAddRowButtonClickEvents(pEvent);
			return true;
		}

		if (this.getEffectiveEntryMode(pViewHash, tmpGroup) === 'modal')
		{
			return this.openEntryModal(pViewHash, pGroupIndex);
		}
		return this.addEntryInline(pViewHash, pGroupIndex, tmpConfig);
	}

	/**
	 * Add a row inline, honoring EntryPoint. For 'start' the row is appended
	 * first and only then moved to index 0 -- see the comment in
	 * moveStagedEntryToStart for why the array must never be spliced at 0
	 * against a stale DOM.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @return {boolean} - True on success.
	 */
	addEntryInline(pViewHash, pGroupIndex, pConfig)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView.getGroup(pGroupIndex);
		const tmpRecordSet = this.getEntryRecordSet(tmpView, tmpGroup);
		if (!Array.isArray(tmpRecordSet))
		{
			return false;
		}
		const tmpLengthBefore = tmpRecordSet.length;
		tmpView.createDynamicTableRow(pGroupIndex);
		if (tmpRecordSet.length === tmpLengthBefore)
		{
			// createDynamicTableRow warns and no-ops at MaximumRowCount.
			this.toastEntryControlsMessage(`Cannot add: the maximum of ${tmpGroup.MaximumRowCount} has been reached.`);
			return false;
		}
		const tmpIndex = this.moveStagedEntryToStart(tmpView, pGroupIndex, pConfig, tmpRecordSet.length - 1);
		if (tmpIndex !== (tmpRecordSet.length - 1))
		{
			// The row moved, so the table DOM has to be rebuilt -- see the note in
			// moveStagedEntryToStart about undefined values not clearing an input.
			this.reconcileRecordSet(tmpView, tmpGroup);
		}
		this.prepareAnyExtraEntryControls(tmpGroup);
		this.scrollEntryIntoView(pViewHash, pGroupIndex, tmpIndex);
		return true;
	}


	/**
	 * Reflect a group's MaximumRowCount on its add button(s).
	 *
	 * Toggles BOTH ways on purpose. These functions used to only ever set
	 * `disabled`, never clear it, so a group that hit its cap kept a dead add
	 * button even after the user deleted rows back under it. Nothing else in the
	 * bundle disables an add button, so clearing it here is safe.
	 *
	 * @param {NodeList|Array} pButtons - The add buttons for one group (top and/or bottom).
	 * @param {number} pEntryCount - How many entries the group currently has.
	 * @param {string} pMaxAttribute - 'data-max-rows' (Tabular) or 'data-max-sets' (RecordSet).
	 * @param {string} pMinAttribute - 'data-min-rows' or 'data-min-sets'.
	 * @return {void}
	 */
	applyAddButtonRowLimit(pButtons, pEntryCount, pMaxAttribute, pMinAttribute)
	{
		for (let i = 0; i < pButtons.length; i++)
		{
			const tmpButton = pButtons[i];
			if (!tmpButton)
			{
				continue;
			}
			const tmpMaximum = parseInt(tmpButton.getAttribute(pMaxAttribute), 10);
			const tmpMinimum = parseInt(tmpButton.getAttribute(pMinAttribute), 10) || 0;
			// No configured maximum means the group is never capped.
			if (isNaN(tmpMaximum) || ((tmpMaximum > tmpMinimum) && (pEntryCount < tmpMaximum)))
			{
				tmpButton.removeAttribute('disabled');
				continue;
			}
			tmpButton.setAttribute('disabled', 'disabled');
		}
	}

	/**
	 * Run the post-mutation control fixups appropriate to a group's layout.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {void}
	 */
	prepareAnyExtraEntryControls(pGroup)
	{
		if (this.isRecordSetGroup(pGroup))
		{
			const tmpRecordSetControls = this.pict.providers['Bulma-RecordSetControls'];
			if (tmpRecordSetControls && (typeof tmpRecordSetControls.prepareAnyExtraRecordSetControls === 'function'))
			{
				tmpRecordSetControls.prepareAnyExtraRecordSetControls();
				// The RecordSet path has no table scan of its own, so drive the
				// toggle reveal from here.
				this.refreshEntryModeToggleVisibility();
				return;
			}
		}
		this.prepareAnyExtraTableControls();
	}

	/**
	 * The record-set array backing a group.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {Array|null}
	 */
	getEntryRecordSet(pView, pGroup)
	{
		if (!pView || !pGroup || (typeof pGroup.RecordSetAddress !== 'string'))
		{
			return null;
		}
		const tmpRecordSet = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), pGroup.RecordSetAddress);
		return Array.isArray(tmpRecordSet) ? tmpRecordSet : null;
	}

	/**
	 * Move a just-added entry to the top when EntryPoint is 'start'.
	 *
	 * This MUST go through setDynamicTableRowIndex rather than splicing the array
	 * directly. `data-i-index` is baked into the DOM at render time and an
	 * ordinary marshal does not re-render, so splicing at index 0 against a table
	 * that still shows the old order leaves every existing row's index off by one
	 * and Informary writes row k's DOM values into record k+1. setDynamicTableRowIndex
	 * also permutes dependent positional DynamicColumns before they re-resolve.
	 *
	 * The CALLER must then re-render the group. setDynamicTableRowIndex's repaint
	 * deliberately skips re-rendering the source view (re-initializing entity
	 * selectors costs seconds per move) and relies on the marshal pushing the
	 * reordered model into the existing row DOM. That is fine for a user-initiated
	 * move of populated rows, but a freshly added row's fields are `undefined` and
	 * Informary does not clear an input for an undefined value -- so the new empty
	 * row at index 0 would keep displaying whatever used to be there.
	 *
	 * @param {Object} pView - The form view.
	 * @param {number|string} pGroupIndex - The group index.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @param {number} pIndex - The index the new entry currently occupies.
	 * @return {number} - The index the entry ended up at.
	 */
	moveStagedEntryToStart(pView, pGroupIndex, pConfig, pIndex)
	{
		if (!pConfig || (pConfig.EntryPoint !== 'start') || (pIndex <= 0))
		{
			return pIndex;
		}
		pView.setDynamicTableRowIndex(pGroupIndex, pIndex, 0);
		return 0;
	}

	/**
	 * Non-blocking notice through the Headlight panels toast, when available.
	 * @param {string} pMessage - The message.
	 * @param {string} [pType] - A Bulma type class (default 'is-warning').
	 * @return {void}
	 */
	toastEntryControlsMessage(pMessage, pType)
	{
		this.pict.log.warn(pMessage);
		const tmpPanels = this.pict.views ? this.pict.views.HeadlightPanels : null;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast({ message: pMessage, type: pType || 'is-warning' });
		}
	}

	/**
	 * Open the "add a new entry" modal for a group.
	 *
	 * Stage-then-commit: a REAL row is appended to the record set first (without
	 * render/solve/marshal), and the modal renders that row's inputs. Because the
	 * row is genuinely in the model, per-row RecordSetSolvers, ReadOnly computed
	 * fields and AutofillTriggerGroup / EntityBundleRequest cascades all work
	 * live inside the dialog. Because the table is NOT re-rendered while the modal
	 * is open, the staged row has no inline DOM twin -- `data-i-index` for that
	 * index exists in exactly one place in the document.
	 *
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @return {boolean} - True when the modal opened.
	 */
	openEntryModal(pViewHash, pGroupIndex)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView ? tmpView.getGroup(pGroupIndex) : null;
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);
		if (!tmpView || !tmpGroup || !tmpConfig)
		{
			return false;
		}

		const tmpModal = this.pict.views['Pict-Section-Modal'] || this.pict.views['PictSectionModal'];
		if (!tmpModal || (typeof tmpModal.show !== 'function'))
		{
			// pict-section-modal is a soft dependency -- degrade to inline entry.
			this.pict.log.warn(`Entry controls on group [${tmpGroup.Hash}] requested modal entry but pict-section-modal is unavailable; adding inline.`);
			return this.addEntryInline(pViewHash, pGroupIndex, tmpConfig);
		}
		if (this._modalEntryState)
		{
			this.pict.log.warn('An entry modal is already open; ignoring the second request.');
			return false;
		}

		const tmpRecordSet = this.getEntryRecordSet(tmpView, tmpGroup);
		if (!tmpRecordSet)
		{
			return false;
		}
		if (tmpGroup.MaximumRowCount && (tmpRecordSet.length >= tmpGroup.MaximumRowCount))
		{
			this.toastEntryControlsMessage(`Cannot add: the maximum of ${tmpGroup.MaximumRowCount} has been reached.`);
			return false;
		}

		// Stage the row. Always at the END, even for EntryPoint 'start' -- the
		// move to index 0 happens on commit, after a render has refreshed every
		// row's data-i-index.
		const tmpLengthBefore = tmpRecordSet.length;
		this.pict.providers.DynamicTabularData.createDynamicTableRowWithoutEvents(tmpView, pGroupIndex);
		if (tmpRecordSet.length === tmpLengthBefore)
		{
			this.toastEntryControlsMessage(`Cannot add: the maximum of ${tmpGroup.MaximumRowCount} has been reached.`);
			return false;
		}
		const tmpStagedIndex = tmpRecordSet.length - 1;

		this._modalEntryState =
			{
				ViewHash: pViewHash,
				GroupIndex: Number(pGroupIndex),
				StagedIndex: tmpStagedIndex,
				Committed: false,
				Dialog: null,
			};

		const tmpIsRecordSet = this.isRecordSetGroup(tmpGroup);
		const tmpTemplateHash = tmpIsRecordSet ?
			tmpGroup.SectionTabularRowTemplateHash :
			this.buildModalRowTemplate(tmpView, tmpGroup, tmpConfig);

		// Context[0] must be the view and Context[2] the {Value, Key, Group} row
		// wrapper -- the MetaTemplate parser pushes exactly one level per nesting
		// and parseTemplateByHash pushes the record, so pass TWO context entries.
		// Get this wrong and data-i-index and the onchange handler render blank.
		const tmpRowHTML = this.pict.parseTemplateByHash(
			tmpTemplateHash,
			{ Value: tmpRecordSet[tmpStagedIndex], Key: tmpStagedIndex, Group: Number(pGroupIndex) },
			null,
			[ tmpView, tmpView.sectionDefinition ]);

		const tmpNounLabel = tmpIsRecordSet ? 'Record' : 'Row';
		tmpModal.show(
			{
				title: tmpConfig.ModalTitle || `Add New ${tmpGroup.Name || tmpNounLabel}`,
				content: `<div class="pict-entry-modal-body">${tmpRowHTML}</div>`,
				width: tmpConfig.ModalWidth,
				closeable: true,
				buttons:
					[
						{ Hash: 'cancel', Label: 'Cancel' },
						{ Hash: 'done', Label: 'Done', Style: 'primary' },
						{ Hash: 'done-goto', Label: `Finish and go to ${tmpNounLabel}`, Style: 'primary' },
					],
				onOpen: (pDialog) =>
				{
					if (this._modalEntryState)
					{
						this._modalEntryState.Dialog = pDialog;
					}
					this.initializeStagedRowInputs(tmpView, tmpGroup, tmpStagedIndex);
				},
			}).then((pResult) =>
			{
				this.handleEntryModalResult(pResult);
			});
		return true;
	}

	/**
	 * Compose a stacked, labeled "one record" template for a TABULAR group.
	 *
	 * The group's own SectionTabularRowTemplateHash emits bare <td>s (invalid
	 * inside a modal <div>, and carrying no labels -- those live in the <th>s), so
	 * it cannot be reused the way the RecordSet layout's can. Instead re-run the
	 * same input-metatemplate composition the layout does, wrapped in our own
	 * field markup. Every input template is reused verbatim, so Picker,
	 * MaterialsEntitySelector, Signature, Diagram etc. render exactly as inline.
	 *
	 * Rebuilt on every open -- it is cheap string work and it picks up
	 * DynamicColumns changes for free.
	 *
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The tabular group descriptor.
	 * @param {Object} pConfig - The normalized EntryControls config.
	 * @return {string} - The registered template hash.
	 */
	buildModalRowTemplate(pView, pGroup, pConfig)
	{
		const tmpGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpManifest = pGroup.supportingManifest;
		const tmpHash = `Headlight-Form-Template-TabularRow-Modal-${pView.options.Hash}-G${pGroup.GroupIndex}`;
		if (!tmpManifest || !Array.isArray(tmpManifest.elementAddresses))
		{
			this.pict.TemplateProvider.addTemplate(tmpHash, '');
			return tmpHash;
		}

		// ColumnChooser-hidden columns are SHOWN in the modal (marked with a note):
		// hiding is a transient view preference, and a hidden-but-required column
		// the user cannot fill is a dead end. TabularHidden is structural and is skipped.
		let tmpChooserHiddenSet = null;
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (tmpLayout && (typeof tmpLayout._getTabularColumnChooserHiddenSet === 'function'))
		{
			try
			{
				tmpChooserHiddenSet = tmpLayout._getTabularColumnChooserHiddenSet(pView, pGroup);
			}
			catch (pError)
			{
				tmpChooserHiddenSet = null;
			}
		}

		let tmpTemplate = '<div class="columns is-multiline">';
		for (let k = 0; k < tmpManifest.elementAddresses.length; k++)
		{
			const tmpKey = tmpManifest.elementAddresses[k];
			const tmpInput = tmpManifest.elementDescriptors[tmpKey];
			if (!tmpInput || !tmpInput.PictForm || tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			// Same index stamping the layouts perform on bake -- the input
			// templates read PictForm.InputIndex.
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			// Read back by the {~EntryModalCellClass:~} macro below.
			tmpInput.PictForm._EntryModalHalfWidth = (pConfig.ModalColumns === 2);
			tmpInput.PictForm._EntryModalChooserHidden = !!(tmpChooserHiddenSet &&
				(typeof tmpChooserHiddenSet.has === 'function') && tmpChooserHiddenSet.has(String(tmpKey)));

			const tmpAddress = `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`;
			tmpTemplate += tmpGenerator.getMetatemplateTemplateReference(pView, '-TabularTemplate-ModalCell-Prefix', tmpAddress);
			tmpTemplate += tmpGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType,
				(tmpInput.PictForm.InputType || 'Default'), tmpAddress, pGroup.GroupIndex, k);
			tmpTemplate += tmpGenerator.getMetatemplateTemplateReference(pView, '-TabularTemplate-ModalCell-Postfix', tmpAddress);
		}
		tmpTemplate += '</div>';
		this.pict.TemplateProvider.addTemplate(tmpHash, tmpTemplate);
		return tmpHash;
	}

	/**
	 * Initialize the input widgets of the staged row only.
	 *
	 * Deliberately NOT pView.runInputProviderFunctions: that walks every group and
	 * every non-tabular input in the section, re-initializing widgets that are
	 * already live and logging out-of-bounds errors for sibling groups whose
	 * record sets are shorter than this row index. This is its tabular branch,
	 * scoped to one group and one row.
	 *
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {number} pRowIndex - The staged row index.
	 * @return {void}
	 */
	initializeStagedRowInputs(pView, pGroup, pRowIndex)
	{
		const tmpManifest = pGroup.supportingManifest;
		if (!tmpManifest || !Array.isArray(tmpManifest.elementAddresses))
		{
			return;
		}
		// TransactionTracking is a runtime service on the pict instance that the
		// published pict types do not describe.
		const tmpPict = /** @type {any} */ (this.pict);
		const tmpTransactionGUID = this.fable.getUUID();
		const tmpTransaction = tmpPict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		for (let k = 0; k < tmpManifest.elementAddresses.length; k++)
		{
			const tmpInput = tmpManifest.elementDescriptors[tmpManifest.elementAddresses[k]];
			if (!tmpInput || !tmpInput.PictForm || tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			const tmpProviderList = pView.getInputProviderList(tmpInput);
			for (let l = 0; l < tmpProviderList.length; l++)
			{
				const tmpProvider = this.pict.providers[tmpProviderList[l]];
				if (!tmpProvider || (typeof tmpProvider.onInputInitializeTabular !== 'function'))
				{
					continue;
				}
				const tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(
					tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				const tmpValue = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpValueAddress);
				try
				{
					if (tmpPict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey,
						`TI${tmpInput.Hash}-P${tmpProviderList[l]}-R${pRowIndex}`, 'onInputInitialize'))
					{
						tmpProvider.onInputInitializeTabular(pView, pGroup, tmpInput, tmpValue,
							tmpInput.Macro.HTMLSelectorTabular, pRowIndex, tmpTransactionGUID);
					}
				}
				catch (pError)
				{
					this.pict.log.error(`Entry modal failed to initialize provider [${tmpProviderList[l]}] for input [${tmpInput.Hash}]: ${pError}`);
				}
			}
		}
		// Push the staged record's values (defaults, and anything a solver has
		// already produced) into the freshly rendered modal inputs.
		this.pict.providers.Informary.marshalDataToForm(pView.getMarshalDestinationObject(), pView.formID, pView.sectionManifest);
	}

	/**
	 * Resolve the entry modal: commit the staged row, or roll it back.
	 * @param {string|null} pResult - The clicked button hash, or null when dismissed.
	 * @return {boolean} - True when a row was committed.
	 */
	handleEntryModalResult(pResult)
	{
		const tmpState = this._modalEntryState;
		if (!tmpState)
		{
			return false;
		}
		this._modalEntryState = null;

		// pict-section-modal resolves the promise SYNCHRONOUSLY but only removes
		// the dialog from the DOM 220ms later. Empty the body now: the commit
		// render below paints inline row N with the same element ids and the same
		// data-i-index, and we must not let the two coexist even briefly.
		this.teardownEntryModalBody(tmpState.Dialog);

		const tmpView = this.pict.views[tmpState.ViewHash];
		const tmpGroup = tmpView ? tmpView.getGroup(tmpState.GroupIndex) : null;
		if (!tmpView || !tmpGroup)
		{
			return false;
		}
		const tmpConfig = this.getEntryControlsConfig(tmpGroup);
		const tmpCommitted = ((pResult === 'done') || (pResult === 'done-goto'));

		if (!tmpCommitted)
		{
			this.rollbackStagedEntry(tmpView, tmpGroup, tmpState.StagedIndex);
		}

		// Any rebuild the marshal guard swallowed while the modal was open has to
		// happen exactly once, now that the DOM and the model agree again.
		this.flushDeferredEntryRebuild(tmpView, tmpGroup);

		// Reorder BEFORE reconciling so a prepend costs one render, not two. The
		// reorder's own repaint marshals into a table that is still one row short;
		// that is harmless (Informary addresses rows by data-i-index and simply
		// finds nothing for the staged index) and the reconcile below repaints it.
		let tmpFinalIndex = tmpState.StagedIndex;
		if (tmpCommitted)
		{
			tmpFinalIndex = this.moveStagedEntryToStart(tmpView, tmpState.GroupIndex, tmpConfig, tmpState.StagedIndex);
		}

		this.reconcileRecordSet(tmpView, tmpGroup);
		this.prepareAnyExtraEntryControls(tmpGroup);

		if (tmpCommitted && (pResult === 'done-goto'))
		{
			this.scrollEntryIntoView(tmpState.ViewHash, tmpState.GroupIndex, tmpFinalIndex);
		}
		return tmpCommitted;
	}

	/**
	 * Remove the modal-hosted inputs from the document immediately.
	 * @param {any} pDialog - The pict-section-modal dialog element.
	 * @return {void}
	 */
	teardownEntryModalBody(pDialog)
	{
		if (!pDialog || (typeof pDialog.querySelector !== 'function'))
		{
			return;
		}
		const tmpBody = pDialog.querySelector('.pict-entry-modal-body') || pDialog.querySelector('.pict-modal-dialog-body');
		if (!tmpBody)
		{
			return;
		}
		while (tmpBody.firstChild)
		{
			tmpBody.removeChild(tmpBody.firstChild);
		}
	}

	/**
	 * Remove a cancelled staged entry from the record set.
	 *
	 * Deliberately NOT deleteDynamicTableRow: that refuses once the array is at
	 * MinimumRowCount, and the staged row is exactly what pushed it over. Splicing
	 * returns to the pre-add count, which was already a legal count.
	 *
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @param {number} pStagedIndex - The staged row index.
	 * @return {boolean} - True when a row was removed.
	 */
	rollbackStagedEntry(pView, pGroup, pStagedIndex)
	{
		const tmpRecordSet = this.getEntryRecordSet(pView, pGroup);
		if (!tmpRecordSet || (pStagedIndex < 0) || (pStagedIndex >= tmpRecordSet.length))
		{
			return false;
		}
		tmpRecordSet.splice(pStagedIndex, 1);
		const tmpTabular = this.pict.providers.DynamicTabularData;
		if (tmpTabular && (typeof tmpTabular._spliceDependentPositionalColumns === 'function'))
		{
			try
			{
				tmpTabular._spliceDependentPositionalColumns(pGroup.RecordSetAddress, pStagedIndex, pStagedIndex + 1);
			}
			catch (pError)
			{
				this.pict.log.error(`Entry modal rollback could not splice dependent positional columns: ${pError}`);
			}
		}
		return true;
	}

	/**
	 * Run the one rebuild the modal-entry marshal guard suppressed, if any.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {void}
	 */
	flushDeferredEntryRebuild(pView, pGroup)
	{
		if (!pGroup || !pGroup._HeadlightModalDeferredRebuild)
		{
			return;
		}
		pGroup._HeadlightModalDeferredRebuild = false;
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (tmpLayout && (typeof tmpLayout._rebuildTabularGroupView === 'function'))
		{
			tmpLayout._rebuildTabularGroupView(pView);
		}
	}

	/**
	 * Repaint + resolve everything bound to a group's record set. Mirrors the tail
	 * of DynamicTabularData.createDynamicTableRow: render the bound views,
	 * rebuild dependent DynamicColumns views, solve, marshal.
	 * @param {Object} pView - The form view.
	 * @param {Object} pGroup - The group descriptor.
	 * @return {void}
	 */
	reconcileRecordSet(pView, pGroup)
	{
		const tmpAddress = pGroup.RecordSetAddress;
		const tmpTabular = this.pict.providers.DynamicTabularData;
		const tmpViews = this.pict.views.PictFormMetacontroller.filterViews((pCandidate) =>
		{
			if (!pCandidate.isPictSectionForm)
			{
				return false;
			}
			const tmpGroups = pCandidate.getGroups();
			for (let i = 0; i < tmpGroups.length; i++)
			{
				if (tmpGroups[i].RecordSetAddress === tmpAddress)
				{
					return true;
				}
			}
			return false;
		});

		// _renderViewsPreservingRecordSet snapshots/restores entity-selector values
		// across the re-render; a plain render loses them ("the Source I just
		// picked disappeared after adding a row").
		if (tmpTabular && (typeof tmpTabular._renderViewsPreservingRecordSet === 'function'))
		{
			tmpTabular._renderViewsPreservingRecordSet(tmpAddress, tmpViews);
		}
		else
		{
			this.pict.log.warn('DynamicTabularData._renderViewsPreservingRecordSet is unavailable; falling back to a plain render (entity-selector values may be clobbered).');
			for (let i = 0; i < tmpViews.length; i++)
			{
				tmpViews[i].render();
			}
		}
		if (tmpTabular && (typeof tmpTabular._rebuildDependentDynamicColumnViews === 'function'))
		{
			tmpTabular._rebuildDependentDynamicColumnViews(tmpAddress);
		}
		this.pict.providers.DynamicSolver.solveViews();
		this.pict.views.PictFormMetacontroller.marshalFormSections();
	}

	/**
	 * Scroll a group's entry into view, but only when it is not already visible.
	 * @param {string} pViewHash - The form view hash.
	 * @param {number|string} pGroupIndex - The group index.
	 * @param {number} pRowIndex - The entry index.
	 * @return {boolean} - True when the entry element was found.
	 */
	scrollEntryIntoView(pViewHash, pGroupIndex, pRowIndex)
	{
		if (typeof document === 'undefined')
		{
			return false;
		}
		const tmpView = this.pict.views[pViewHash];
		const tmpGroup = tmpView ? tmpView.getGroup(pGroupIndex) : null;
		const tmpSelector = this.isRecordSetGroup(tmpGroup) ?
			`[data-recordset-group-index="${pGroupIndex}"][data-recordset-row-index="${pRowIndex}"]` :
			`tr[data-tabular-group-index="${pGroupIndex}"][data-tabular-row-index="${pRowIndex}"]`;
		const tmpElement = document.querySelector(tmpSelector);
		if (!tmpElement)
		{
			return false;
		}
		const tmpNavBar = document.getElementById('HeadlightPanels-NavBar');
		const tmpNavHeight = tmpNavBar ? tmpNavBar.offsetHeight : 60;
		const tmpRect = tmpElement.getBoundingClientRect();
		const tmpViewportHeight = window.innerHeight || 0;
		if ((tmpRect.top >= tmpNavHeight) && (tmpRect.bottom <= tmpViewportHeight))
		{
			return true;
		}
		window.scrollTo({ top: (tmpRect.top + window.scrollY) - tmpNavHeight - 10, behavior: 'smooth' });
		return true;
	}

	/**
	 * Reveal the inline/modal toggle on groups that have grown big enough to
	 * warrant the choice. Strictly read-all-then-write-all so the measurement
	 * never interleaves reads and writes, and STICKY -- once revealed a toggle is
	 * never hidden again, so a user who switched to modal entry does not lose the
	 * control when the row count drops back under the threshold.
	 *
	 * Called from prepareAnyExtraTableControls (every bake / add / delete) and
	 * from ResponsiveUIAdjustmentProvider.onWindowResize (already debounced), so
	 * it registers no listeners of its own.
	 *
	 * @return {void}
	 */
	refreshEntryModeToggleVisibility()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const tmpToggles = document.querySelectorAll('[data-entry-mode-toggle]');
		if (!tmpToggles.length)
		{
			return;
		}
		const tmpViewportHeight = window.innerHeight || 0;
		const tmpToReveal = [];

		// PASS 1 -- reads only.
		for (let i = 0; i < tmpToggles.length; i++)
		{
			const tmpToggle = tmpToggles[i];
			if (!tmpToggle.classList.contains('is-hidden'))
			{
				continue;
			}
			const tmpContainer = tmpToggle.closest('.section-table-wrapper') || tmpToggle.closest('.section-recordset-wrapper');
			if (!tmpContainer)
			{
				continue;
			}
			const tmpRowThreshold = parseInt(tmpToggle.getAttribute('data-entry-mode-rows'), 10);
			const tmpViewportMultiple = parseFloat(tmpToggle.getAttribute('data-entry-mode-viewport'));
			// NOTE: the placeholder row's class really is 'table-emtpy-row' (sic) --
			// that spelling is what the group templates emit.
			let tmpEntryCount = tmpContainer.querySelectorAll('tbody tr:not(.table-emtpy-row)').length;
			if (!tmpEntryCount)
			{
				tmpEntryCount = tmpContainer.querySelectorAll('.RecordSetEntry').length;
			}
			const tmpHeight = tmpContainer.getBoundingClientRect().height;
			const tmpRevealByRows = (!isNaN(tmpRowThreshold) && (tmpRowThreshold > 0) && (tmpEntryCount >= tmpRowThreshold));
			const tmpRevealByHeight = (!isNaN(tmpViewportMultiple) && (tmpViewportMultiple > 0) && (tmpViewportHeight > 0) &&
				(tmpHeight >= (tmpViewportMultiple * tmpViewportHeight)));
			if (tmpRevealByRows || tmpRevealByHeight)
			{
				tmpToReveal.push(tmpToggle);
			}
		}

		// PASS 2 -- writes only.
		for (let i = 0; i < tmpToReveal.length; i++)
		{
			tmpToReveal[i].classList.remove('is-hidden');
		}
	}

	/**
	 * While a modal entry is staged the row exists in the model but deliberately
	 * NOT in the table DOM. The tabular layout's onDataMarshalToForm can rebuild
	 * mid-marshal (a DynamicColumns set change, or a ColumnChooser state-key
	 * drift), which would paint an inline twin of the modal's row carrying the
	 * same data-i-index. Defer that rebuild until the modal closes.
	 *
	 * Idempotent; no-op when the layout provider isn't registered.
	 * @return {void}
	 */
	overrideTabularMarshalForModalEntry()
	{
		const tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout ||
			(typeof tmpLayout.onDataMarshalToForm !== 'function') ||
			tmpLayout._headlightModalEntryMarshalOverridden)
		{
			return;
		}
		const tmpSelf = this;
		tmpLayout._headlightModalEntryMarshalOverridden = true;
		const fOriginalMarshal = tmpLayout.onDataMarshalToForm;
		tmpLayout.onDataMarshalToForm = function(pView, pGroup)
		{
			const tmpState = tmpSelf._modalEntryState;
			if (tmpState && !tmpState.Committed && pView && pGroup &&
				(pView.Hash === tmpState.ViewHash) &&
				(Number(pGroup.GroupIndex) === Number(tmpState.GroupIndex)))
			{
				pGroup._HeadlightModalDeferredRebuild = true;
				return true;
			}
			return fOriginalMarshal.call(this, pView, pGroup);
		};
	}

	/**
	 * Generate the HTML for a group layout template.
	 * @param {Object} pGroup - The group object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pGroupKey - The key of the group.
	 * @param {Object} pGroupData - The data for the group.
	 * @param {number} pGroupDataIndex - The index of the group data.
	 * @param {string} pGroupDataKey - The key of the group data.
	 * @return {string} - The generated HTML for the group layout template.
	 */
	generateGroupLayoutTemplate(pGroup, pGroupIndex, pGroupKey, pGroupData, pGroupDataIndex, pGroupDataKey)
	{
		this.prepareAnyExtraTableControls();
		return '';
	}
}

module.exports = CustomInputHandler;

},{"./_ScopedEntityData.js":162,"pict-section-form":587}],56:[function(require,module,exports){
/**
 * Component-owned chip styling for PictProvider-ChipTooltips.
 *
 * The chip color/structure palette (and its theme variants) lives in the
 * headlight-styles Bulma layer (`bulma-chip.scss`), authored with the
 * `--bulma-*` design tokens. This file holds only the small set of rules that
 * belong with the runtime behavior: the keyboard-focus affordance for the chip
 * button-anchor and the tooltip body layout.
 */
module.exports = /*css*/`
.chip:focus-visible
{
	outline: 2px solid var(--bulma-link, #485fc7);
	outline-offset: 1px;
}

.chip-tooltip
{
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	white-space: nowrap;
}

.chip-tooltip .fa
{
	opacity: 0.85;
}

/* Chip tooltips must sit BELOW open Select2 dropdowns (z-index 30 in
   headlight-styles' bulma-select2) and other menus/overlays — a hover or pinned
   chip tooltip should never cover an open dropdown list. The shared
   .pict-modal-tooltip z-index (1020) is tuned for tooltips inside modal dialogs;
   chip tooltips live on form labels and only need to clear page content, so the
   chip-tooltip-bubble marker (added to every chip tooltip) scopes a lower value. */
.pict-modal-tooltip.chip-tooltip-bubble
{
	z-index: 20;
}

/* Theme the tooltip bubble (and its arrow, which reads --pict-modal-tooltip-bg)
   to the chip's color variant — a darker, saturated take on the chip color with
   a light same-hue label. PictProvider-ChipTooltips passes chip-tooltip-<variant>
   derived from the chip's is-<variant> class; unknown/default chips keep the
   standard dark tooltip. Uses the Bulma color tokens so it tracks the theme. */
.pict-modal-tooltip.chip-tooltip-primary
{
	--pict-modal-tooltip-bg: var(--bulma-primary-40);
	--pict-modal-tooltip-fg: var(--bulma-primary-95);
}
.pict-modal-tooltip.chip-tooltip-link
{
	--pict-modal-tooltip-bg: var(--bulma-link-40);
	--pict-modal-tooltip-fg: var(--bulma-link-95);
}
.pict-modal-tooltip.chip-tooltip-info
{
	--pict-modal-tooltip-bg: var(--bulma-info-40);
	--pict-modal-tooltip-fg: var(--bulma-info-95);
}
.pict-modal-tooltip.chip-tooltip-success
{
	--pict-modal-tooltip-bg: var(--bulma-success-40);
	--pict-modal-tooltip-fg: var(--bulma-success-95);
}
.pict-modal-tooltip.chip-tooltip-warning
{
	--pict-modal-tooltip-bg: var(--bulma-warning-40);
	--pict-modal-tooltip-fg: var(--bulma-warning-95);
}
.pict-modal-tooltip.chip-tooltip-danger
{
	--pict-modal-tooltip-bg: var(--bulma-danger-40);
	--pict-modal-tooltip-fg: var(--bulma-danger-95);
}
`;

},{}],57:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');
const libChipTooltipsCSS = require('./PictProvider-ChipTooltips-CSS.js');

/**
 * ChipTooltips — runtime behavior for the "chips" that the LabelWithChips
 * MetaTemplate renders next to form-field labels.
 *
 * The MetaTemplate emits each chip as a `<button class="chip" data-chip-for
 * data-chip-label ...>` with a zero-width `.chip-label` span. This provider gives
 * the chip its two states:
 *   - UNPINNED: hover / focus shows the chip's value in a portaled pict-section-
 *     modal tooltip (no DOM reflow); and
 *   - PINNED: clicking a chip toggles its whole *type* (e.g. "New",
 *     "ExternalDatabaseID") active and persists it via the existing
 *     HeadlightPaneSettings.toggleChipTypeActive (ActiveChipTypes). That toggles
 *     an `is-active` class on every chip of the type, and the headlight-styles
 *     CSS expands the `.chip-label` inline — the value reads as an extension of
 *     the field label, in the content flow. A pinned chip shows no portaled
 *     tooltip, so pinned chips never overlay the labels/inputs above them.
 *
 * Graceful fallback: if the Pict-Section-Modal view is not registered (or is an
 * older build without richTooltip), the chip falls back to a native `title`
 * tooltip — no hard dependency, nothing breaks. The inline pinned state is
 * independent of the modal (it's pure CSS + the settings view).
 *
 * Wiring is reactive: a MutationObserver re-sweeps as forms re-render (tab
 * switches, recordset row add/remove, dynamic sections), wiring any new chip
 * once and destroying handles for chips that leave the DOM.
 */
class ChipTooltips extends PictProvider
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this._started = false;
		this._sweepPending = false;
		this._observer = null;
		this._cssInjected = false;
		// Per-type hover-tooltip registry: { [chipTypeId]: Array<{ element, handle }> }.
		// `handle` is null for a pinned chip (it shows its value inline, no tooltip).
		this._handlesByType = {};
	}

	/**
	 * Begin wiring chips. Idempotent — safe to call from every host app's
	 * attachInstructions(). No-op outside a browser (tests / SSR).
	 */
	start()
	{
		if (this._started || typeof document === 'undefined')
		{
			return;
		}
		this._started = true;
		this._injectChipCSS();
		// Wire whatever is already on screen, after the current render flushes.
		this._scheduleSweep();
		// Re-wire as forms re-render. MutationObserver is the sanctioned way to
		// react to DOM the framework rebuilds outside our own render cycle.
		if (typeof MutationObserver !== 'undefined' && document.body)
		{
			this._observer = new MutationObserver(() => this._scheduleSweep());
			this._observer.observe(document.body, { childList: true, subtree: true });
		}
	}

	/**
	 * Register + inject the chip CSS once (the chip color/structure styling
	 * lives in the headlight-styles Bulma layer; this is the small set of
	 * component-owned rules — the button-anchor a11y ring and tooltip body).
	 */
	_injectChipCSS()
	{
		if (this._cssInjected || !this.pict || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function')
		{
			return;
		}
		this.pict.CSSMap.addCSS('Headlight-ChipTooltips', libChipTooltipsCSS, 500);
		if (typeof this.pict.CSSMap.injectCSS === 'function')
		{
			this.pict.CSSMap.injectCSS();
		}
		this._cssInjected = true;
	}

	/** Coalesce many mutations into a single wiring pass per tick. */
	_scheduleSweep()
	{
		if (this._sweepPending)
		{
			return;
		}
		this._sweepPending = true;
		setTimeout(() =>
		{
			this._sweepPending = false;
			this.wireChips();
		}, 0);
	}

	/** The modal view, if registered and tooltip-capable; otherwise null. */
	get modal()
	{
		const tmpModal = this.pict && this.pict.views && this.pict.views['Pict-Section-Modal'];
		return (tmpModal && typeof tmpModal.richTooltip === 'function') ? tmpModal : null;
	}

	/** The settings view that owns the persisted ActiveChipTypes preference. */
	get paneSettings()
	{
		return (this.pict && this.pict.views && this.pict.views.HeadlightPaneSettings) || null;
	}

	/**
	 * Whether a chip type is currently "active" (pinned — shows its label inline).
	 *
	 * @param {string} pId
	 * @return {boolean}
	 */
	checkChipTypeActive(pId)
	{
		const tmpView = this.paneSettings;
		return !!(tmpView && typeof tmpView.checkChipTypeActive === 'function' && tmpView.checkChipTypeActive(pId));
	}

	/** Wire every not-yet-wired chip currently in the DOM. */
	wireChips()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		this._pruneDetachedHandles();
		const tmpChips = document.querySelectorAll('.chip[data-chip-for]:not([data-chip-wired])');
		for (let i = 0; i < tmpChips.length; i++)
		{
			this._wireChip(/** @type {HTMLElement} */ (tmpChips[i]));
		}
	}

	/**
	 * Wire a single chip: seed its pinned (is-active) state, attach the click
	 * that toggles the whole type, and give it a hover tooltip while unpinned.
	 *
	 * @param {HTMLElement} pChip
	 */
	_wireChip(pChip)
	{
		pChip.setAttribute('data-chip-wired', 'true');
		const tmpId = pChip.getAttribute('data-chip-for') || '';
		const tmpLabel = pChip.getAttribute('data-chip-label') || '';

		const tmpModal = this.modal;
		if (!tmpModal)
		{
			// Graceful fallback: native tooltip, no reflow, no dependency. (The
			// inline pinned state still works — it's CSS + the settings view.)
			if (tmpLabel)
			{
				pChip.setAttribute('title', tmpLabel);
			}
			return;
		}

		// Seed the persisted pinned state onto chips rendered after load (tab
		// switches, dynamic rows) so the inline label shows immediately; chips
		// present at load already got is-active from the settings view.
		const tmpActive = this.checkChipTypeActive(tmpId);
		if (tmpActive)
		{
			pChip.classList.add('is-active');
		}

		// Click toggles the whole chip TYPE's pinned state + persists it. A real
		// listener, not an inline onclick in the emitted markup.
		pChip.addEventListener('click', (pEvent) => this._onChipToggle(pEvent, tmpId));

		// Hover/focus tooltip for the UNPINNED state only — a pinned chip shows
		// its value inline, so it needs no portaled tooltip.
		const tmpHandle = tmpActive ? null : this._attachHoverTooltip(pChip);

		if (!this._handlesByType[tmpId])
		{
			this._handlesByType[tmpId] = [];
		}
		this._handlesByType[tmpId].push({ element: pChip, handle: tmpHandle });
	}

	/**
	 * Attach a portaled hover/focus tooltip (pict-section-modal richTooltip) to a
	 * chip and return its handle (or null if the modal is unavailable).
	 *
	 * @param {HTMLElement} pChip
	 * @return {?{ destroy: function }}
	 */
	_attachHoverTooltip(pChip)
	{
		const tmpModal = this.modal;
		if (!tmpModal)
		{
			return null;
		}
		const tmpLabel = pChip.getAttribute('data-chip-label') || '';
		// Theme the tooltip bubble to the chip's color variant (e.g. is-info ->
		// chip-tooltip-info); unknown/default variants keep the standard dark
		// tooltip. The chip-tooltip-bubble marker scopes component CSS (e.g. the
		// z-index below the Select2 dropdown) to chip tooltips only. See
		// PictProvider-ChipTooltips-CSS.
		const tmpVariant = (pChip.getAttribute('data-chip-color') || '').replace(/^is-/, '').trim();
		const tmpClassName = 'chip-tooltip-bubble' + (tmpVariant ? ` chip-tooltip-${tmpVariant}` : '');
		return tmpModal.richTooltip(pChip, this._buildTooltipHTML(pChip, tmpLabel),
			{
				position: 'top',
				className: tmpClassName,
			});
	}

	/**
	 * Build the tooltip body for a chip — the icon for brand consistency plus
	 * the chip's text.
	 *
	 * @param {HTMLElement} pChip
	 * @param {string} pLabel
	 * @return {string}
	 */
	_buildTooltipHTML(pChip, pLabel)
	{
		const tmpIcon = pChip.getAttribute('data-chip-icon') || 'fa-info';
		const fEscape = (pStr) => String(pStr == null ? '' : pStr)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		return `<span class="chip-tooltip"><i class="fa fa-fw ${fEscape(tmpIcon)}"></i> ${fEscape(pLabel)}</span>`;
	}

	/**
	 * Toggle a chip TYPE's pinned state on click. Delegates the state change to
	 * HeadlightPaneSettings (flips ActiveChipTypes, toggles the `is-active` class
	 * on every chip of the type so the CSS expands the inline label, and persists
	 * to the server), then reconciles the hover tooltips for that type.
	 *
	 * @param {Event} pEvent
	 * @param {string} pId
	 */
	_onChipToggle(pEvent, pId)
	{
		const tmpView = this.paneSettings;
		if (!tmpView || typeof tmpView.toggleChipTypeActive !== 'function')
		{
			return;
		}
		tmpView.toggleChipTypeActive(pEvent, pId);
		this._syncHoverTooltips(pId);
	}

	/**
	 * Keep the hover tooltips consistent with the pinned state: a pinned chip
	 * shows its value inline and gets no hover tooltip; an unpinned one does.
	 *
	 * @param {string} pId
	 */
	_syncHoverTooltips(pId)
	{
		const tmpActive = this.checkChipTypeActive(pId);
		const tmpList = this._handlesByType[pId] || [];
		for (let i = 0; i < tmpList.length; i++)
		{
			const tmpEntry = tmpList[i];
			if (tmpActive && tmpEntry.handle)
			{
				// Now pinned: drop the portaled hover tooltip (value is inline).
				if (typeof tmpEntry.handle.destroy === 'function')
				{
					tmpEntry.handle.destroy();
				}
				tmpEntry.handle = null;
			}
			else if (!tmpActive && !tmpEntry.handle && tmpEntry.element && tmpEntry.element.isConnected)
			{
				// Now unpinned: (re)attach the hover tooltip.
				tmpEntry.handle = this._attachHoverTooltip(tmpEntry.element);
			}
		}
	}

	/**
	 * Drop handles whose chip element has left the DOM (form re-rendered),
	 * destroying their tooltips so no orphaned tooltip lingers.
	 */
	_pruneDetachedHandles()
	{
		const tmpKeys = Object.keys(this._handlesByType);
		for (let k = 0; k < tmpKeys.length; k++)
		{
			const tmpList = this._handlesByType[tmpKeys[k]];
			const tmpKept = [];
			for (let i = 0; i < tmpList.length; i++)
			{
				const tmpEntry = tmpList[i];
				if (tmpEntry.element && tmpEntry.element.isConnected)
				{
					tmpKept.push(tmpEntry);
				}
				else if (tmpEntry.handle && typeof tmpEntry.handle.destroy === 'function')
				{
					tmpEntry.handle.destroy();
				}
			}
			if (tmpKept.length)
			{
				this._handlesByType[tmpKeys[k]] = tmpKept;
			}
			else
			{
				delete this._handlesByType[tmpKeys[k]];
			}
		}
	}
}

module.exports = ChipTooltips;

},{"./PictProvider-ChipTooltips-CSS.js":56,"pict-provider":552}],58:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');
const libTestResultOptions = require('./_TestResultOptions.js');

const DATA_REQUIREMENTS_SOLVER_SOURCE = 'DataRequirements';

// The host form's own inputs carry no OriginalHash, so they translate to themselves.
const HOST_MANIFEST_COPY = Object.freeze({ RegistrationHash: null, TestHash: null, HashTranslation: Object.freeze({ }), AddressTranslation: Object.freeze({ }) });

class DataRequirementsProvider extends PictProvider
{
	/**
	 * @param {Pict} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - (optional) The options for the provider.
	 * @param {string} [pServiceHash] - (optional) The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { ExpressionParser: any }} */
		this.pict;

		/** @type {import('fable') & import('pict') & { ExpressionParser: any }} */
		this.fable;

		/** @type {Record<string, any>} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
		this.pict.instantiateServiceProviderIfNotExists('ExpressionParser');
		this.pict.ExpressionParser.addSolverFunction('settestresult', 'fable.providers.DataRequirementsProvider._setTestResult', 'Sets a test result by hash (for test requirement outcomes)', [ 2, 4 ]);
		this.pict.ExpressionParser.addSolverFunction('testresultlabel', 'fable.providers.DataRequirementsProvider._getTestResultLabel', 'The display text for a stored test-result code');
	}

	/**
	 * @param {string} pCode - The stored test-result code.
	 * @return {string} - Its display text, or the value itself when it isn't a known code.
	 */
	_getTestResultLabel(pCode)
	{
		return libTestResultOptions.getTestResultLabel(pCode);
	}

	/**
	 * @param {string} pTestHash - The hash of the test to set the result for.
	 * @param {string} pTestResult - The test result hash to set for the test.
	 * @param {string} [pPreviousValueAddress] - (optional) If provided, will only apply the change if the current value differes from the previous value (if present).
	 * @param {string} [pCurrentValue] - (optional) Should be provided if pPreviousValueAddress is provided. Value that will be stored if the change is applied.
	 * @param {string} [pPreviousValueFallbackAddress] - (optional) Read when pPreviousValueAddress holds nothing. Documents saved before the last-value key gained a copy scope hold it at the unscoped address.
	 */
	_setTestResult(pTestHash, pTestResult, pPreviousValueAddress, pCurrentValue, pPreviousValueFallbackAddress)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		if (pPreviousValueAddress)
		{
			if (pCurrentValue != null && this._getPreviousTestResultValue(pPreviousValueAddress, pPreviousValueFallbackAddress) === pCurrentValue)
			{
				return;
			}
		}
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SetTestResultByHash:${pTestHash}:${pTestResult}:TempData["${tmpPayloadUUID}"]`);
		if (this.pict.TempData[tmpPayloadUUID])
		{
			// we only set the previous value if the change was applied; ex. in cases where the solver runs before an injected test has been resolved
			if (pPreviousValueAddress)
			{
				this.pict.manifest.setValueByHash(this.pict, pPreviousValueAddress, pCurrentValue);
			}
			delete this.pict.TempData[tmpPayloadUUID];
		}
	}

	/**
	 * The last value a test result outcome was applied for, read from the copy-scoped address and falling back
	 * to the unscoped one a document saved before the scope existed holds. Nothing is written back through the
	 * fallback: an old document keeps the key it was saved with until its outcome actually changes.
	 *
	 * @param {string} pPreviousValueAddress - The address the current solver writes.
	 * @param {string} [pPreviousValueFallbackAddress] - The pre-copy-scope address, when it differs.
	 *
	 * @return {any}
	 */
	_getPreviousTestResultValue(pPreviousValueAddress, pPreviousValueFallbackAddress)
	{
		const tmpValue = this.pict.manifest.getValueByHash(this.pict, pPreviousValueAddress);
		if (tmpValue == null && pPreviousValueFallbackAddress)
		{
			return this.pict.manifest.getValueByHash(this.pict, pPreviousValueFallbackAddress);
		}
		return tmpValue;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after data load is complete.
	 *
	 * @return {void}
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}

			const tmpManifest = this.pict.settings.MyDefaultFormManifest;
			if (!tmpManifest)
			{
				return fCallback();
			}
			const tmpMarshalDestination = this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			this._populateDataRequiremetsForManifest(tmpManifest, tmpMarshalDestination, fCallback);
		});
	}

	/**
	 * Check to see if any new tests need to have data requirements loaded.
	 *
	 * @param {Record<string, any>} pManifest
	 * @param {(pError?: Error) => void} fCallback
	 * @param {Array<string>} [pTestHashes] - (optional) If provided, will include these test hashes when determining data requirements, in addition to any hashes already present in the manifest or marshal destination.
	 */
	updateDataRequirementsForManifest(pManifest, fCallback, pTestHashes)
	{
		if (Array.isArray(pTestHashes) && pTestHashes.length > 0)
		{
			if (this.AppData._DataRequirementsCache && Array.isArray(this.AppData._DataRequirementsCache.Tests))
			{
				if (pTestHashes.every((h) => this.AppData._DataRequirementsCache.Tests.some((t) => t.Hash === h)))
				{
					return fCallback();
				}
			}
		}
		this._populateDataRequiremetsForManifest(pManifest, this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.pict.views.PictFormMetacontroller.viewMarshalDestination), fCallback);
	}

	/**
	 * @param {Record<string, any>} pManifest
	 * @param {Record<string, any>} pMarshalDestination
	 * @param {(pError?: Error) => void} fCallback
	 * @param {Array<string>} [pTestHashes] - (optional) If provided, will include these test hashes.
	 */
	_populateDataRequiremetsForManifest(pManifest, pMarshalDestination, fCallback, pTestHashes)
	{
		const tmpTestHashes = new Set(pTestHashes || []);
		for (const tmpDescriptor of Object.values(pManifest.Descriptors || {}))
		{
			if (tmpDescriptor.PictForm?.TestHashes)
			{
				if (Array.isArray(tmpDescriptor.PictForm.TestHashes))
				{
					for (const tmpHash of tmpDescriptor.PictForm.TestHashes)
					{
						tmpTestHashes.add(tmpHash);
					}
				}
				else
				{
					tmpTestHashes.add(tmpDescriptor.PictForm.TestHashes);
				}
			}
			else if (tmpDescriptor.PictForm && (tmpDescriptor.PictForm.InputType === 'MaterialsTestSelector' || tmpDescriptor.PictForm.InputType === 'MaterialsHiddenTestSelector'))
			{
				if (tmpDescriptor.Default)
				{
					tmpTestHashes.add(tmpDescriptor.Default);
				}
			}
		}
		if (pMarshalDestination && pMarshalDestination.__DynamicSectionData)
		{
			for (const tmpHash of pMarshalDestination.__DynamicSectionData.Sequence)
			{
				const tmpSectionData = pMarshalDestination.__DynamicSectionData[tmpHash];
				if (tmpSectionData && tmpSectionData.TestHash)
				{
					tmpTestHashes.add(tmpSectionData.TestHash);
				}
			}
		}
		const tmpPromises = [];
		if (tmpTestHashes.size > 0)
		{
			tmpPromises.push(this.loadDataRequirementsForTestHashes(Array.from(tmpTestHashes)).catch((pError) =>
			{
				this.log.error('Error loading data requirements for test hashes', { testHashes: Array.from(tmpTestHashes), error: pError });
			}));
		}
		Promise.all(tmpPromises).finally(() => fCallback());
	}

	/**
	 * @param {Array<string>} pTestHashes
	 *
	 * @return {Promise<void>}
	 */
	async loadDataRequirementsForTestHashes(pTestHashes)
	{
		try
		{
			if (pTestHashes.length < 1)
			{
				this.log.info('No test hashes provided, skipping data requirements load.', { testHashes: pTestHashes });
				return;
			}
			const tmpTests = await this._get(`Tests/FilteredTo/FBL~Hash~INN~${pTestHashes.map((h) => encodeURIComponent(h)).join(',')}`);
			if (tmpTests.length < 1)
			{
				this.log.info('No tests found for provided test hashes, unable to determine data requirements.', { testHashes: pTestHashes });
				return;
			}
			const tmpTestSpecificationMaterialTestJoins = await this._getAll(`TestSpecificationMaterialTestJoins/FilteredTo/FBL~IDTest~INN~${tmpTests.map((t) => t.IDTest).join(',')}`);
			const tmpTestSpecificationIDs = Array.from(new Set(tmpTestSpecificationMaterialTestJoins.map((j) => j.IDTestSpecification)));
			const tmpHasSpecifications = tmpTestSpecificationIDs.length > 0;
			const tmpTestSpecificationRequirements = tmpHasSpecifications ? await this._getAll(`TestSpecificationRequirements/FilteredTo/FBL~IDTestSpecification~INN~${tmpTestSpecificationIDs.join(',')}`) : [ ];
			const tmpTestSpecifications = tmpHasSpecifications ? await this._getAll(`TestSpecifications/FilteredTo/FBL~IDTestSpecification~INN~${tmpTestSpecificationIDs.join(',')}`) : [ ];
			const tmpTestSpecificationToSetIDMap = {};
			for (const tmpTestSpecification of tmpTestSpecifications)
			{
				tmpTestSpecificationToSetIDMap[tmpTestSpecification.IDTestSpecification] = tmpTestSpecification.IDTestSpecificationSet;
			}
			this.AppData._DataRequirementsCache =
			{
				Tests: tmpTests ?? [],
				TestSpecificationMaterialTestJoins: tmpTestSpecificationMaterialTestJoins ?? [],
				TestSpecificationRequirements: tmpTestSpecificationRequirements ?? [],
				TestSpecifications: tmpTestSpecifications ?? [],
				TestSpecificationToSetIDMap: tmpTestSpecificationToSetIDMap ?? [],
			};
			if (this.AppData._DataRequirementsDeferredLoad)
			{
				const tmpParams = this.AppData._DataRequirementsDeferredLoad;
				delete this.AppData._DataRequirementsDeferredLoad;
				await this.applyDataRequirements(tmpParams.Manifest, tmpParams.SampleRecord);
			}
		}
		catch (pError)
		{
			this.log.error('Failed to load data requirements for test hashes', { testHashes: pTestHashes, error: pError });
		}
	}

	/**
	 * @param {Record<string, any>} pManifest
	 * @param {Record<string, any>} pSampleRecord
	 */
	async applyDataRequirements(pManifest, pSampleRecord)
	{
		if (!pSampleRecord)
		{
			this.log.warn('No valid sample record provided, unable to determine data requirements.', { sampleRecord: pSampleRecord });
			return;
		}
		if (!this.AppData._DataRequirementsCache || !Array.isArray(this.AppData._DataRequirementsCache.TestSpecificationMaterialTestJoins) ||
			!Array.isArray(this.AppData._DataRequirementsCache.TestSpecificationRequirements) || this.AppData._DataRequirementsCache.TestSpecificationRequirements.length < 1)
		{
			//FIXME: defer in case cache is still loading?
			this.AppData._DataRequirementsDeferredLoad = { Manifest: pManifest, SampleRecord: pSampleRecord };
			return;
		}
		const tmpSample = pSampleRecord;
		let tmpTestSpecificationSet;
		if (tmpSample)
		{
			if (tmpSample.IDProject > 0)
			{
				const tmpProject = await this._get(`Projects/Lite/FilteredTo/FBV~IDProject~EQ~${tmpSample.IDProject}`).then((projects) => projects[0]);
				if (tmpProject)
				{
					const tmpContract = await this._get(`Contract/${tmpProject.IDContract}`);
					if (tmpContract)
					{
						if (tmpContract.ItemIDTestSpecificationSet > 0)
						{
							tmpTestSpecificationSet = await this._get(`TestSpecificationSets/FilteredTo/FBV~IDTestSpecificationSet~EQ~${tmpContract.ItemIDTestSpecificationSet}`).then((sets) => sets[0]);
						}
						if (!tmpTestSpecificationSet && tmpContract.ItemSpecificationYear)
						{
							// A year is NOT unique (a provisional set can share it with the live one) and nothing on
							// the record distinguishes them — take the lowest id and flag the ambiguity.
							tmpTestSpecificationSet = await this._get(`TestSpecificationSets/FilteredTo/FBV~Year~EQ~${tmpContract.ItemSpecificationYear}~FSF~IDTestSpecificationSet~ASC~0`).then((sets) =>
							{
								if (Array.isArray(sets) && sets.length > 1)
								{
									this.log.warn(`Specification year ${tmpContract.ItemSpecificationYear} matches ${sets.length} specification sets; using the lowest id (${sets[0]?.IDTestSpecificationSet}). Set the contract's ItemIDTestSpecificationSet to resolve this explicitly.`);
								}
								return Array.isArray(sets) ? sets[0] : undefined;
							});
						}
					}
				}
			}
			if (!tmpTestSpecificationSet)
			{
				//FIXME: default specification set logic?
				this.log.info('Sample is not linked to a project, unable to determine specification set based on project contract. Defaulting to most recent specification set.', { sampleRecord: pSampleRecord });
				tmpTestSpecificationSet = await this._get(`TestSpecificationSets/FilteredTo/FSF~Year~DESC~0/0/1`).then((sets) => sets[0]);
			}
			if (!tmpTestSpecificationSet)
			{
				this.log.warn('No test specification sets found, unable to determine test specification requirements.', { sampleRecord: pSampleRecord });
				return;
			}
			const tmpSampleIDMaterial = tmpSample.IDMaterial ?? 0;
			const tmpValidSpecs = new Set();
			for (const tmpSpec of this.AppData._DataRequirementsCache.TestSpecifications)
			{
				if (tmpSpec.IDTestSpecificationSet == tmpTestSpecificationSet.IDTestSpecificationSet)
				{
					tmpValidSpecs.add(tmpSpec.IDTestSpecification);
				}
			}
			const tmpSpecificationMaterialJoins = this.AppData._DataRequirementsCache.TestSpecificationMaterialTestJoins
				.filter((j) => j.IDMaterial == tmpSampleIDMaterial && tmpValidSpecs.has(j.IDTestSpecification));
			const tmpSpecificationIDs = new Set(tmpSpecificationMaterialJoins.map((j) => j.IDTestSpecification));
			const tmpTestSpecificationRequirements = this.AppData._DataRequirementsCache.TestSpecificationRequirements
				.filter((r) => tmpSpecificationIDs.has(r.IDTestSpecification));
			if (tmpTestSpecificationRequirements.length < 1)
			{
				return;
			}

			// convert requirements into solver statements, once per copy of the test the requirement targets
			const tmpHostTestHashes = this._collectHostTestHashes(pManifest);
			const tmpSolvers = [];
			for (const tmpRequirement of tmpTestSpecificationRequirements)
			{
				const tmpTestID = tmpSpecificationMaterialJoins.find((j) => j.IDTestSpecification === tmpRequirement.IDTestSpecification)?.IDTest;
				const tmpTest = this.AppData._DataRequirementsCache.Tests.find((t) => t.IDTest === tmpTestID);
				const tmpCopies = this._resolveRequirementCopies(tmpTest?.Hash, tmpHostTestHashes);
				if (tmpCopies.length < 1)
				{
					this.log.info(`Test specification requirement ${tmpRequirement.IDTestSpecificationRequirement} targets test ${tmpTest?.Hash ?? tmpTestID}, which is not on this form; skipping it.`,
						{ IDTestSpecificationRequirement: tmpRequirement.IDTestSpecificationRequirement, IDTest: tmpTestID, TestHash: tmpTest?.Hash });
					continue;
				}
				for (const tmpCopy of tmpCopies)
				{
					tmpSolvers.push(...this._buildRequirementSolvers(pManifest, tmpRequirement, tmpTest, tmpTestID, tmpCopy, tmpCopies.length));
				}
			}
			if (tmpSolvers.length > 0)
			{
				this._replaceGeneratedValidationSolvers(pManifest, tmpSolvers);
				if (this.pict.PictApplication)
				{
					this.pict.PictApplication.solve();
				}
			}
		}
	}

	/**
	 * The test hashes the host form declares on its own inputs. A descriptor carrying an OriginalHash or an
	 * OriginalDataAddress came from an injected copy, which the section manager tracks separately; what is
	 * left is the host's own, and its references translate to themselves.
	 *
	 * @param {Record<string, any>} pManifest - The merged form manifest.
	 *
	 * @return {Set<string>}
	 */
	_collectHostTestHashes(pManifest)
	{
		const tmpTestHashes = new Set();
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || { }))
		{
			if (tmpDescriptor.OriginalHash || tmpDescriptor.OriginalDataAddress)
			{
				continue;
			}
			if (tmpDescriptor.PictForm?.TestHashes)
			{
				const tmpDescriptorHashes = Array.isArray(tmpDescriptor.PictForm.TestHashes) ? tmpDescriptor.PictForm.TestHashes : [ tmpDescriptor.PictForm.TestHashes ];
				for (const tmpHash of tmpDescriptorHashes)
				{
					tmpTestHashes.add(tmpHash);
				}
			}
			else if (tmpDescriptor.PictForm && (tmpDescriptor.PictForm.InputType === 'MaterialsTestSelector' || tmpDescriptor.PictForm.InputType === 'MaterialsHiddenTestSelector'))
			{
				if (tmpDescriptor.Default)
				{
					tmpTestHashes.add(tmpDescriptor.Default);
				}
			}
		}
		return tmpTestHashes;
	}

	/**
	 * Which copies of a test's inputs a requirement should be solved against.
	 *
	 * A test can be injected more than once, and every injected copy carries the same OriginalHash values, so
	 * the translation has to come from the copy the section manager recorded at injection rather than from the
	 * merged form manifest. A test the host form owns needs no translation at all.
	 *
	 * @param {string} [pTestHash] - The Test.Hash the requirement resolved to.
	 * @param {Set<string>} pHostTestHashes - The test hashes the host form declares on its own inputs.
	 *
	 * @return {Array<Record<string, any>>} - One entry per copy; empty when the test is not on this form.
	 */
	_resolveRequirementCopies(pTestHash, pHostTestHashes)
	{
		const tmpSectionManager = this.pict.providers?.DocumentDynamicSectionManager;
		if (pTestHash && tmpSectionManager && typeof tmpSectionManager.getInjectedManifestTranslationsForTestHash === 'function')
		{
			const tmpInjectedCopies = tmpSectionManager.getInjectedManifestTranslationsForTestHash(pTestHash);
			if (tmpInjectedCopies.length > 0)
			{
				return tmpInjectedCopies;
			}
		}
		if (!pTestHash || !tmpSectionManager || pHostTestHashes.has(pTestHash))
		{
			return [ HOST_MANIFEST_COPY ];
		}
		return [];
	}

	/**
	 * The descriptor an outcome target names, within one copy of the manifest.
	 *
	 * @param {Record<string, any>} pManifest - The merged form manifest.
	 * @param {string} pInputHash - The input hash as the requirement names it, before any salting.
	 * @param {Record<string, any>} pCopy - The copy to resolve within.
	 *
	 * @return {Record<string, any>|undefined}
	 */
	_findCopyDescriptor(pManifest, pInputHash, pCopy)
	{
		const tmpCopyHash = pCopy.RegistrationHash ? pCopy.HashTranslation[pInputHash] : pInputHash;
		if (!tmpCopyHash)
		{
			return undefined;
		}
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || { }))
		{
			if (tmpDescriptor.Hash !== tmpCopyHash || !tmpDescriptor.PictForm || !tmpDescriptor.PictForm.Section)
			{
				continue;
			}
			if (!pCopy.RegistrationHash && tmpDescriptor.OriginalHash)
			{
				continue;
			}
			return tmpDescriptor;
		}
		return undefined;
	}

	/**
	 * Build the validation solvers for one requirement against one copy of the test's inputs, rewritten
	 * through that copy's own translation maps.
	 *
	 * @param {Record<string, any>} pManifest - The merged form manifest.
	 * @param {Record<string, any>} pRequirement - The TestSpecificationRequirement row.
	 * @param {Record<string, any>} [pTest] - The Test row the requirement resolved to.
	 * @param {number} [pTestID] - The IDTest the requirement resolved to, for diagnostics when pTest is missing.
	 * @param {Record<string, any>} pCopy - The copy to solve against.
	 * @param {number} pCopyCount - How many copies of this test are on the form.
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_buildRequirementSolvers(pManifest, pRequirement, pTest, pTestID, pCopy, pCopyCount)
	{
		const tmpSolvers = [];
		const tmpLegacyResultKey = `Result_${pRequirement.IDTestSpecificationRequirement}`;
		// The last-value address is written into FormData and persisted with the document, so the key only
		// gains a copy scope where it has to: when the same test is on the form more than once. A form with a
		// single copy keeps the key every document saved before this change already holds.
		const tmpResultKey = (pCopyCount > 1 && pCopy.RegistrationHash) ? `${tmpLegacyResultKey}_${pCopy.RegistrationHash}` : tmpLegacyResultKey;
		const tmpResultAddress = `TempData._DataRequirementsValues.${tmpResultKey}`;
		const tmpLastValueAddress = `AppData.DocumentData.ReportData.FormData._DataRequirementsLastValues.${tmpResultKey}`;
		const tmpLegacyLastValueAddress = `AppData.DocumentData.ReportData.FormData._DataRequirementsLastValues.${tmpLegacyResultKey}`;
		const tmpComputationTemplate = pRequirement.ComputationTemplate;
		switch (pRequirement.OperationType)
		{
		case 'AddressInRange':
			// get value at address in ComputationTemplate
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, ">=", "${pRequirement.ValueMinimum}", IF(${tmpComputationTemplate}, "<=", "${pRequirement.ValueMaximum}", 1, 0), 0))`);
			break;
		case 'AddressOutOfRange':
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, ">=", "${pRequirement.ValueMaximum}", 1, IF(${tmpComputationTemplate}, "<=", "${pRequirement.ValueMinimum}", 1, 0)))`);
			break;
		case 'Solver': // just run it; outcome doesn't matter
			tmpSolvers.push(tmpComputationTemplate);
			return this._translateCopySolvers(tmpSolvers, pCopy);
		case 'TrueExpression':
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, "==", "true", 1, IF(${tmpComputationTemplate}, "==", 1, 1, IF(${tmpComputationTemplate}, "==", "yes", 1, 0))))`);
			break;
		case 'FalseExpression':
			tmpSolvers.push(`SETVALUE("${tmpResultAddress}", IF(${tmpComputationTemplate}, "==", "true", 0, IF(${tmpComputationTemplate}, "==", 1, 0, IF(${tmpComputationTemplate}, "==", "yes", 0, 1))))`);
			break;
		}
		const tmpOutcomeTargets = typeof pRequirement.OutcomeTargets !== 'string' ? [] : pRequirement.OutcomeTargets.split(',').map((t) => t.trim()).filter((t) => t.length > 0);
		switch (pRequirement.OutcomeType)
		{
		case 'ColorInputs':
			for (const tmpInputHash of tmpOutcomeTargets)
			{
				const tmpDescriptor = this._findCopyDescriptor(pManifest, tmpInputHash, pCopy);
				if (!tmpDescriptor)
				{
					continue;
				}
				//TODO: is there a risk of having quoted values in the DB?
				const tmpOutcome = `IF(GETVALUE("${tmpResultAddress}"), "==", 1, "${pRequirement.ComputationSuccessOutcome}", "${pRequirement.ComputationFailureOutcome}")`;
				tmpSolvers.push(`colorinputbackground("${tmpDescriptor.PictForm.Section}", "${tmpInputHash}", ${tmpOutcome}, WHEN(${tmpOutcome}, 1, 0))`);
			}
			break;
		case 'ShowSection':
			for (const tmpSectionHash of tmpOutcomeTargets)
			{
				tmpSolvers.push(`setsectionvisibility("${tmpSectionHash}", GETVALUE("${tmpResultAddress}"))`);
			}
			break;
		case 'HideSection':
			for (const tmpSectionHash of tmpOutcomeTargets)
			{
				tmpSolvers.push(`setsectionvisibility("${tmpSectionHash}", IF(GETVALUE("${tmpResultAddress}"), "==", 1, 0, 1))`);
			}
			break;
		case 'AssignContent':
			// do we have a solver function for this? do not think so... just doing an assingment for now
			for (const tmpOutputHash of tmpOutcomeTargets)
			{
				tmpSolvers.push(`${tmpOutputHash} = IF(GETVALUE("${tmpResultAddress}"), ${pRequirement.ComputationSuccessOutcome}, ${pRequirement.ComputationFailureOutcome}))`);
			}
			break;
		case 'TestResult':
			{
				//FIXME: should these somehow use tracking GUIDs? this still falls over when the same test is on
				//       the form twice: the solver names the test by hash, so the result lands on whichever
				//       TestInstance the global event resolves first.
				// The fifth argument is the pre-copy-scope address, so a document saved before the key gained a
				// scope is still read rather than re-applied from scratch.
				const tmpLastValueArguments = (tmpResultKey === tmpLegacyResultKey) ? `"${tmpLastValueAddress}", GETVALUE("${tmpResultAddress}")` : `"${tmpLastValueAddress}", GETVALUE("${tmpResultAddress}"), "${tmpLegacyLastValueAddress}"`;
				tmpSolvers.push(`settestresult("${pTest?.Hash ?? `test ${pTestID} not found`}", IF(GETVALUE("${tmpResultAddress}"), "==", 1, "${pRequirement.ComputationSuccessOutcome}", "${pRequirement.ComputationFailureOutcome}"), ${tmpLastValueArguments})`);
			}
			break;
		}
		return this._translateCopySolvers(tmpSolvers, pCopy);
	}

	/**
	 * Rewrite raw solver expressions through one copy's translation maps and wrap them as generated solvers.
	 *
	 * @param {Array<string>} pSolverExpressions - The raw expressions.
	 * @param {Record<string, any>} pCopy - The copy whose maps to rewrite through.
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_translateCopySolvers(pSolverExpressions, pCopy)
	{
		return pSolverExpressions.map((pExpression) => (
			{
				Expression: this.pict.views.PictFormMetacontroller.rewriteSolverExpression(pExpression, pCopy.HashTranslation, pCopy.AddressTranslation),
				Ordinal: 1,
				SolverSource: DATA_REQUIREMENTS_SOLVER_SOURCE,
			}));
	}

	/**
	 * Is this validation solver one this provider generated from test specification requirements?
	 *
	 * @param {any} pSolver - A validation solver entry, either an expression string or a solver object.
	 *
	 * @return {boolean}
	 */
	_isGeneratedValidationSolver(pSolver)
	{
		return (pSolver != null) && (typeof pSolver === 'object') && (pSolver.SolverSource === DATA_REQUIREMENTS_SOLVER_SOURCE);
	}

	/**
	 * Swap the validation solvers this provider generated on a previous pass for a freshly generated set,
	 * in place, leaving every other entry alone.
	 *
	 * The form manifest's ValidationSolvers array is shared: the metacontroller merges each injected
	 * section copy's translated solvers into it, so this provider may only touch its own entries.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest holding the validation solvers.
	 * @param {Array<Record<string, any>>} pGeneratedSolvers - The generated solvers to write.
	 *
	 * @return {void}
	 */
	_replaceGeneratedValidationSolvers(pManifest, pGeneratedSolvers)
	{
		const tmpExistingSolvers = Array.isArray(pManifest.ValidationSolvers) ? pManifest.ValidationSolvers : [];
		let tmpInsertAtIndex = tmpExistingSolvers.findIndex((pSolver) => this._isGeneratedValidationSolver(pSolver));
		const tmpRetainedSolvers = tmpExistingSolvers.filter((pSolver) => !this._isGeneratedValidationSolver(pSolver));
		if (tmpInsertAtIndex < 0)
		{
			tmpInsertAtIndex = tmpRetainedSolvers.length;
		}
		tmpRetainedSolvers.splice(tmpInsertAtIndex, 0, ...pGeneratedSolvers);
		pManifest.ValidationSolvers = tmpRetainedSolvers;
	}

	/**
	 * @param {any} pValue
	 *
	 * @return {boolean}
	 */
	_isTruthy(pValue)
	{
		if (pValue == null)
		{
			return false;
		}
		if (typeof pValue === 'boolean')
		{
			return pValue;
		}
		if (typeof pValue === 'number')
		{
			return pValue != 0;
		}
		const tmpCleanValue = String(pValue).trim().toLowerCase();
		return tmpCleanValue == '1' || tmpCleanValue == 'true' || tmpCleanValue == 'yes' || tmpCleanValue == 'y' || tmpCleanValue == 't';
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 *
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {string} uri - The URI to get all results from, should include any necessary filtering but not pagination (skip/take).
	 *
	 * @return {Promise<Array<any>>} - The aggregated results from all pages.
	 */
	async _getAll(uri)
	{
		let tmpResults = [];
		let tmpSkip = 0;
		const tmpPageSize = 250;
		while (true)
		{
			const tmpPage = await this._get(`${uri}/${tmpSkip}/${tmpPageSize}`);
			tmpResults = tmpResults.concat(tmpPage);
			if (tmpPage.length < tmpPageSize)
			{
				break;
			}
			tmpSkip += tmpPageSize;
		}
		return tmpResults;
	}
}

module.exports = DataRequirementsProvider;
module.exports.default_configuration =
{
	// register to receive data load/save lifecycle events, which are off by default
	AutoSaveDataWithApp: true,
	// default ordinal is zero; we want to come after other providers (ex. the dynamic section manager) so any existing dynamic sections are already loaded when we run
	AutoLoadDataOrdinal: 1,
};

},{"./_TestResultOptions.js":168,"headlight-rest-client":20,"pict-provider":552}],59:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// default date format in DayJS format
		this.defaultDateFormat = 'YYYY-MM-DD';
	}

	getDateHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getDateDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DATE-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularDateHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATE-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDateDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATE-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pValue The the date value in ISO format.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} pRowIndex The row index
	 */
	configureFlatpickr(pInput, pValue, isTabular = false, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			return;
		}
		// NOTE: pValue is expected to be in ISO format (e.g., "2024-06-01T00:00:00Z") for proper timezone handling
		this.pict.providers.FlatpickrUtilProvider.initializeFlatpickr({
			PickerType: 'date',
			AllowInput: true,
			HTMLID: isTabular ? this.getTabularDateDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getDateDisplayInputHTMLID(pInput.Macro.RawHTMLID),
			ISODateString: pValue,
			Timezone: pInput.PictForm.Timezone || this.fable.options.Timezone,
			DayJSDateFormat: pInput.PictForm.DateFormat || this.defaultDateFormat, // ex: 'YYYY-MM-DD'
			DefaultValue: pInput.Default,
			DisablePicker: pInput.PictForm.Disabled || false,
		});
	}

	/**
	 * Resolve a logical default token ('now'/'today') carried in the marshaled model
	 * value to a concrete ISO string and lock that value into the form's data model, so
	 * a defaulted-but-untouched field persists the instant it was created instead of
	 * re-evaluating live on every reload. Returns the (possibly resolved) value to use
	 * for the rest of the marshal. Non-token values pass through untouched.
	 *
	 * @param {Object} pView - The dynamic form view.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The marshaled model value.
	 * @param {number} [pRowIndex] - Row index when marshaling a tabular cell.
	 * @return {any} The value to continue the marshal with (resolved ISO for tokens).
	 */
	lockInSpecialDefault(pView, pInput, pValue, pRowIndex)
	{
		const tmpFlatpickr = this.pict.providers.FlatpickrUtilProvider;
		if (!tmpFlatpickr.isSpecialDefaultValue(pValue))
		{
			return pValue;
		}
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpResolvedISO = tmpFlatpickr.resolveSpecialDefaultToISO(pValue, tmpTimezone, 'date');
		if (pView && typeof pView.getMarshalDestinationObject === 'function' && pView.sectionManifest)
		{
			let tmpAddress = pInput.Hash;
			if (pRowIndex != null)
			{
				tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpAddress, tmpResolvedISO);
		}
		return tmpResolvedISO;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat, tmpTimezone);
		this.pict.ContentAssignment.assignContent(this.getDateHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getDateDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, false, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue, pRowIndex);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone(tmpValue, pInput.PictForm.DateFormat || this.defaultDateFormat, tmpTimezone);
		this.pict.ContentAssignment.assignContent(this.getTabularDateHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpValue);
		this.pict.ContentAssignment.assignContent(this.getTabularDateDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getDateDisplayInputHTMLID(pInput.Macro.RawHTMLID));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'date',
				);
				this.pict.ContentAssignment.assignContent(this.getDateHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpISOValue);
				pView.dataChanged(pInput.Hash);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Date input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTabularDateDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'date',
				);
				this.pict.ContentAssignment.assignContent(this.getTabularDateHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpISOValue);
				pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Date tabular input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],60:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * The DayJS format a field shows: its DateFormat, else the 24-hour or 12-hour default per PictForm.Time24Hour.
	 * @param {object} pInput The input object.
	 * @return {string}
	 */
	getDayJSDateFormat(pInput)
	{
		return pInput.PictForm.DateFormat || (pInput.PictForm.Time24Hour ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD hh:mm a');
	}

	getDateTimeHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getDateTimeDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DATETIME-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularDateTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDateTimeInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pValue The the date value in ISO format.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} pRowIndex The row index
	 */
	configureFlatpickr(pInput, pValue, isTabular = false, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			return;
		}
		// NOTE: pValue is expected to be in ISO format (e.g., "2024-06-01T00:00:00Z") for proper timezone handling
		this.pict.providers.FlatpickrUtilProvider.initializeFlatpickr({
			PickerType: 'datetime',
			AllowInput: true,
			HTMLID: isTabular ? this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getDateTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID),
			HiddenInputSelector: isTabular ? this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID),
			ISODateString: pValue,
			Timezone: pInput.PictForm.Timezone || this.fable.options.Timezone,
			DayJSDateFormat: this.getDayJSDateFormat(pInput), // ex: 'YYYY-MM-DD'
			DefaultValue: pInput.Default,
			DisablePicker: pInput.PictForm.Disabled || false,
			Time24Hour: pInput.PictForm.Time24Hour,
		});
	}

	/**
	 * Resolve a logical default token ('now'/'today') carried in the marshaled model
	 * value to a concrete ISO string and lock that value into the form's data model, so
	 * a defaulted-but-untouched field persists the instant it was created instead of
	 * re-evaluating live on every reload. Returns the (possibly resolved) value to use
	 * for the rest of the marshal. Non-token values pass through untouched.
	 *
	 * @param {Object} pView - The dynamic form view.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The marshaled model value.
	 * @param {number} [pRowIndex] - Row index when marshaling a tabular cell.
	 * @return {any} The value to continue the marshal with (resolved ISO for tokens).
	 */
	lockInSpecialDefault(pView, pInput, pValue, pRowIndex)
	{
		const tmpFlatpickr = this.pict.providers.FlatpickrUtilProvider;
		if (!tmpFlatpickr.isSpecialDefaultValue(pValue))
		{
			return pValue;
		}
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpResolvedISO = tmpFlatpickr.resolveSpecialDefaultToISO(pValue, tmpTimezone, 'datetime');
		if (pView && typeof pView.getMarshalDestinationObject === 'function' && pView.sectionManifest)
		{
			let tmpAddress = pInput.Hash;
			if (pRowIndex != null)
			{
				tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpAddress, tmpResolvedISO);
		}
		return tmpResolvedISO;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayID = this.getDateTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateForElement(tmpDisplayID, tmpValue, this.getDayJSDateFormat(pInput), tmpTimezone);
		this.pict.ContentAssignment.assignContent(this.getDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpValue);
		this.pict.ContentAssignment.assignContent(tmpDisplayID, tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, false, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue, pRowIndex);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayID = this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateForElement(tmpDisplayID, tmpValue, this.getDayJSDateFormat(pInput), tmpTimezone);
		this.pict.ContentAssignment.assignContent(tmpDisplayID, tmpDisplayDate);
		this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpValue);
		this.configureFlatpickr(pInput, tmpValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a datetime input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getDateTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'datetime',
				);
				this.pict.ContentAssignment.assignContent(this.getDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpISOValue);
				pView.dataChanged(pInput.Hash);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`DateTime input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular datetime input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'datetime',
				);
				this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpISOValue);
				pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`DateTime tabular input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Special handling for filters inputs, do not remove.
		if (pView.Hash === 'PSRSFilterProxyView')
		{
			pValue = this.pict.fable.Dates.dayJS(pValue).toISOString();
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.InformaryDataAddress, pValue);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],61:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * The DayJS format a field shows: its DateFormat, else the 24-hour or 12-hour default per PictForm.Time24Hour.
	 * @param {object} pInput The input object.
	 * @return {string}
	 */
	getDayJSDateFormat(pInput)
	{
		return pInput.PictForm.DateFormat || (pInput.PictForm.Time24Hour ? 'HH:mm' : 'hh:mm a');
	}

	getTimeHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getTimeDisplayInputHTMLID(pInputHTMLID)
	{
		return `#TIME-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularTimeDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pValue The the date value in ISO format.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} pRowIndex The row index
	 */
	configureFlatpickr(pInput, pValue, isTabular = false, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			return;
		}
		// NOTE: pValue is expected to be in ISO format (e.g., "2024-06-01T00:00:00Z") for proper timezone handling
		this.pict.providers.FlatpickrUtilProvider.initializeFlatpickr({
			PickerType: 'time',
			AllowInput: true,
			HTMLID: isTabular ? this.getTabularTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID),
			HiddenInputSelector: isTabular ? this.getTabularTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex) : this.getTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID),
			ISODateString: pValue,
			Timezone: pInput.PictForm.Timezone || this.fable.options.Timezone,
			DayJSDateFormat: this.getDayJSDateFormat(pInput), // ex: 'YYYY-MM-DD'
			DefaultValue: pInput.Default,
			DisablePicker: pInput.PictForm.Disabled || false,
			Time24Hour: pInput.PictForm.Time24Hour,
		});
	}
	/**
	 * Resolve a logical default token ('now'/'today') carried in the marshaled model
	 * value to a concrete ISO string and lock that value into the form's data model, so
	 * a defaulted-but-untouched field persists the instant it was created instead of
	 * re-evaluating live on every reload. Returns the (possibly resolved) value to use
	 * for the rest of the marshal. Non-token values pass through untouched.
	 *
	 * @param {Object} pView - The dynamic form view.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The marshaled model value.
	 * @param {number} [pRowIndex] - Row index when marshaling a tabular cell.
	 * @return {any} The value to continue the marshal with (resolved ISO for tokens).
	 */
	lockInSpecialDefault(pView, pInput, pValue, pRowIndex)
	{
		const tmpFlatpickr = this.pict.providers.FlatpickrUtilProvider;
		if (!tmpFlatpickr.isSpecialDefaultValue(pValue))
		{
			return pValue;
		}
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpResolvedISO = tmpFlatpickr.resolveSpecialDefaultToISO(pValue, tmpTimezone, 'time');
		if (pView && typeof pView.getMarshalDestinationObject === 'function' && pView.sectionManifest)
		{
			let tmpAddress = pInput.Hash;
			if (pRowIndex != null)
			{
				tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpAddress, tmpResolvedISO);
		}
		return tmpResolvedISO;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayID = this.getTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateForElement(tmpDisplayID, tmpValue, this.getDayJSDateFormat(pInput), tmpTimezone, true);
		this.pict.ContentAssignment.assignContent(this.getTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpValue);
		this.pict.ContentAssignment.assignContent(tmpDisplayID, tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, false, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpValue = !pValue || pValue == 0 ? '' : pValue;
		tmpValue = this.lockInSpecialDefault(pView, pInput, tmpValue, pRowIndex);
		const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
		const tmpDisplayID = this.getTabularTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex);
		const tmpDisplayDate = this.pict.providers.FlatpickrUtilProvider.formatDateForElement(tmpDisplayID, tmpValue, this.getDayJSDateFormat(pInput), tmpTimezone, true);
		this.pict.ContentAssignment.assignContent(this.getTabularTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpValue);
		this.pict.ContentAssignment.assignContent(tmpDisplayID, tmpDisplayDate);
		this.configureFlatpickr(pInput, tmpValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a time input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'time',
				);
				this.pict.ContentAssignment.assignContent(this.getTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpISOValue);
				pView.dataChanged(pInput.Hash);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Time input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular time input.
	 * Reads directly from Flatpickr's selectedDates and interprets as document-TZ via fromFlatpickrDate.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			// Read directly from Flatpickr's selectedDates and interpret as document-TZ via fromFlatpickrDate
			const tmpInputElement = document.querySelector(this.getTabularTimeDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			const tmpFlatpickrInstance = tmpInputElement?._flatpickr;
			if (tmpFlatpickrInstance && tmpFlatpickrInstance.selectedDates.length > 0)
			{
				const tmpTimezone = pInput.PictForm.Timezone || this.fable.options.Timezone;
				const tmpISOValue = this.pict.providers.FlatpickrUtilProvider.fromFlatpickrDate(
					tmpFlatpickrInstance.selectedDates[0], tmpTimezone, 'time',
				);
				this.pict.ContentAssignment.assignContent(this.getTabularTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpISOValue);
				pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Time tabular input error for [#${pInput.Macro.RawHTMLID}]: ${pError.message}`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],62:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
/**
 * @typedef {Object} DraggableOptions
 * @property {boolean} [limitToOwnCollection] - If true, items can only be dropped within the same parent container, preventing cross-container dragging. This is useful for maintaining logical groupings of items.
 * @property {boolean} [disabled] - If true, the draggable behavior will not be initialized, preventing any reordering of items. This is useful for locked or read-only states.
 * @property {string} [elementSelector] - CSS selector for the draggable element. If not provided, the entire container element will be draggable.
 * @property {function(HTMLElement, HTMLElement): void} [onDrag] - Callback function that is called continuously while dragging. Receives the dragged element and the current event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragStart] - Callback function that is called when dragging starts. Receives the dragged element and the original event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragEnter] - Callback function that is called when the dragged element enters a valid drop target. Receives the dragged element and the drop target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragOver] - Callback function that is called when the dragged element is moved over a valid drop target. Receives the dragged element and the current event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragLeave] - Callback function that is called when the dragged element leaves a valid drop target. Receives the dragged element and the drop target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDragEnd] - Callback function that is called when dragging ends. Receives the dragged element and the original event target as arguments.
 * @property {function(HTMLElement, HTMLElement): void} [onDrop] - Callback function that is called when the dragged element is dropped. Receives the dragged element and the drop target as arguments.
*/

class DraggableUtil extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.customCSSInjected = false;
		this.animationDuration = 500; // default duration for any animations related to dragging (e.g., shake animation when drop is denied)
		this.outlineThickness = 3; // default thickness for outlines when dragging over valid drop targets
	}

	/**
	 * Inject the custom CSS styles for the draggable behavior into the document head. This includes styles for the draggable items, drag-over states,
	 * and any animations for denied drops. The method checks if the styles have already been injected to avoid duplicates.
	 * @returns {void}
	 */
	injectCustomCSS()
	{
		if (this.customCSSInjected || document.getElementById('DraggableUtil-Styles')) return;

		const styleElement = document.createElement('style');
		styleElement.id = 'DraggableUtil-Styles';
		styleElement.textContent = /*css*/`
			/* Draggable item styles */
			[draggable="true"] {
				cursor: move;
				transition: transform 150ms ease, border-color 150ms ease;
			}
			/* Optional drag class for styling the dragged element */
			.is-dragging {
				opacity: 0.5;
			}
			/* Optional class for styling drop targets when an item is dragged over them */
			.is-drag-over {
				border: calc(${this.outlineThickness}px) solid var(--bulma-info);
				transform: scale(1.1, 1.1);
			}
			/* Optional class for styling drop targets when a drop is denied - shakes */
			.is-drag-over-denied {
				border: calc(${this.outlineThickness}px) solid var(--bulma-danger);
			}
			/* Optional class for styling the drop container when a drop is denied - shakes */
			.is-drag-over-denied-collection {
				animation: shake ${this.animationDuration}ms ease;
			}
			@keyframes shake {
				0% { transform: translate(0, 0) }
				25% { transform: translate(-5px, 0) }
				50% { transform: translate(5px, 0) }
				75% { transform: translate(-5px, 0) }
				100% { transform: translate(0, 0) }	
			}`;
		document.head.appendChild(styleElement);
		this.customCSSInjected = true;
	}

	/**
	 * Initializes the draggable behavior on a given element with specified options.
	 * @param {HTMLElement} containerElement - The container element that holds the draggable items.
	 * @param {DraggableOptions} options - Configuration options for the draggable behavior.
	 */
	initializeDraggableCollection(containerElement, options)
	{
		// If disabled option is set, do not initialize draggable behavior (these are for locked/readonly states)
		if (options.disabled)
		{
			this.pict.log.info('DraggableUtil: Draggable behavior is prevented by options, skipping initialization.');
			return;
		}
		if (!containerElement)
		{
			this.pict.log.warn('DraggableUtil: No container element provided for initializing draggable collection.');
			return;
		}
		if (options.elementSelector && typeof options.elementSelector !== 'string')
		{
			this.pict.log.warn('DraggableUtil: Invalid elementSelector provided in options. Expected a string CSS selector. Draggable behavior will not be initialized.');
			return;
		}
		this.injectCustomCSS();

		// make each item in the container that matches the elementSelector draggable and apply the necessary event listeners for drag-and-drop interactions
		const draggableItems = containerElement.querySelectorAll(options.elementSelector);
		draggableItems.forEach((item) =>
		{
			this.makeElementDraggable(/** @type {HTMLElement} */ (item), options);
		});
	}

	/**
	 * Makes a single element draggable and applies the necessary event listeners for drag-and-drop interactions.
	 * @param {HTMLElement|String} pElement - The element node or selector string to be made draggable.
	 * @param {DraggableOptions} pOptions - Configuration options for the draggable behavior.
	 */
	makeElementDraggable(pElement, pOptions)
	{
		if (pOptions.disabled)
		{
			this.pict.log.info('DraggableUtil: Draggable behavior is disabled by options, skipping initialization.');
			return;
		}
		const tmpElementNode = typeof pElement === 'string' ? document.querySelector(pElement) : pElement;
		if (!tmpElementNode)
		{
			this.pict.log.warn('DraggableUtil: No element found for making draggable with selector:', pElement);
			return;
		}
		tmpElementNode.setAttribute('draggable', 'true');
		tmpElementNode.classList.add('is-draggable');
		tmpElementNode.setAttribute('data-draggable-id', `draggable-${Math.random().toString(36).substr(2, 9)}`); // Assign a unique ID for tracking
		this.applyEventListenersToCard(/** @type {HTMLElement} */ (tmpElementNode), pOptions);
	}

	/**
	 * Applies the necessary event listeners to a draggable item for handling drag-and-drop interactions.
	 * @param {HTMLElement} item - The draggable item element.
	 * @param {DraggableOptions} options - Configuration options for the draggable behavior.
	 */
	applyEventListenersToCard(item, options)
	{
		item.addEventListener('dragstart', (/** @type {DragEvent} */ event) =>
		{
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			this._dragSourceElement = item;
			event.dataTransfer.effectAllowed = 'move';
			event.dataTransfer.dropEffect = 'move';
			event.dataTransfer.setData('text/plain', item.getAttribute('data-draggable-id')); // Store the unique ID of the dragged element for later reference (e.g., to identify the dragged element during drop)
			event.dataTransfer.setData('text/html', ''); // Required for Firefox compatibility
			item.classList.add('is-dragging');

			if (options.onDragStart)
			{
				options.onDragStart(item, /** @type {HTMLElement} */ (event.currentTarget));
			}
		}, false);

		item.addEventListener('dragenter', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			const isSameContainer = this._dragSourceElement.parentElement === target.parentElement;
			// if limitToOwnCollection option is set, only allow drag enter if the target is in the same parent container as the drag source (this is to prevent dragging items between different collections/containers which may have different rules or constraints)
			if (options.limitToOwnCollection && !isSameContainer)
			{
				this.pict.log.info('DraggableUtil: Drag enter ignored due to limitToOwnCollection option and different parent containers.');
				return;
			}
			target.classList.add('is-drag-over');

			if (options.onDragEnter)
			{
				options.onDragEnter(item, target);
			}
		}, false);

		item.addEventListener('dragover', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault(); // Necessary to allow dropping
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			target.classList.add('is-drag-over'); // Ensure the drag-over class is applied while dragging over the target

			if (options.onDragOver)
			{
				options.onDragOver(item, target);
			}
		}, false);

		item.addEventListener('dragleave', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			target.classList.remove('is-drag-over');

			if (options.onDragLeave)
			{
				options.onDragLeave(item, target);
			}
		}, false);

		item.addEventListener('drag', (/** @type {DragEvent} */ event) =>
		{
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			/** @type {HTMLElement} */
			const target = /** @type {HTMLElement} */ (event.currentTarget);
			target.classList.add('is-skeleton'); // Hide the original element while dragging to allow the drag image to be visible (especially if using a custom drag image)

			if (options.onDrag)
			{
				options.onDrag(item, target);
			}
		}, false);

		item.addEventListener('drop', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			this._dragSourceElement.classList.remove('is-skeleton'); // Unhide the original element after dropping

			// if the drop target is in the same collection as the drag source, we can allow dropping and reordering within the same container,
			// otherwise, we ignore the drop (this is to prevent dragging items between different collections/containers which may have different rules or constraints)
			if (item !== this._dragSourceElement)
			{
				/** @type {HTMLElement} */
				const target = /** @type {HTMLElement} */ (event.currentTarget);
				target.classList.remove('is-drag-over');

				// if limitToOwnCollection option is set, check if the drop target is in the same parent container as the drag source before allowing the drop
				if (options.limitToOwnCollection && item.parentElement !== this._dragSourceElement.parentElement)
				{
					this.pict.log.info('DraggableUtil: Drop ignored due to limitToOwnCollection option and different parent containers.');
					item.classList.remove('is-drag-over');
					this._dragSourceElement.classList.add('is-drag-over-denied');
					this._dragSourceElement.classList.remove('is-dragging');
					const sourceElement = this._dragSourceElement; // Store reference to the dragged element for use in the timeout callback
					setTimeout(() => sourceElement?.classList?.remove('is-drag-over-denied'), this.animationDuration);
					// find the parent container of the dropped element and apply a shake animation to indicate the drop was denied (optional, can be styled with CSS)
					const parentContainer = item.parentElement;
					if (parentContainer)
					{
						parentContainer.classList.add('is-drag-over-denied-collection');
						setTimeout(() => parentContainer.classList.remove('is-drag-over-denied-collection'), this.animationDuration);
					}
					return;
				}
				item.classList.remove('is-drag-over');
				// Move the dragged item to its new position in the DOM (before or after the drop target depending on cursor position within the target)
				const rect = item.getBoundingClientRect();
				const midpoint = rect.left + rect.width / 2;
				if (event.clientX > midpoint)
				{
					item.parentNode.insertBefore(this._dragSourceElement, item.nextSibling);
				}
				else
				{
					item.parentNode.insertBefore(this._dragSourceElement, item);
				}

				if (options.onDrop)
				{
					options.onDrop(item, /** @type {HTMLElement} */ (event.currentTarget));
				}
			}
		}, false);

		item.addEventListener('dragend', (/** @type {DragEvent} */ event) =>
		{
			event.preventDefault();
			event.stopPropagation(); // Prevent drag event from bubbling up to parent containers which may also be draggable

			item.classList.remove('is-dragging');
			item.classList.remove('is-skeleton');
			// Clean up any remaining drag-over classes on potential drop targets after dragging ends
			const dropTargets = document.querySelectorAll('.is-drag-over');
			dropTargets.forEach((target) => target.classList.remove('is-drag-over'));

			if (options.onDragEnd)
			{
				options.onDragEnd(item, /** @type {HTMLElement} */ (event.currentTarget));
			}
			this._dragSourceElement = null;
		}, false);
	}
}

module.exports = DraggableUtil;

},{"pict-provider":552}],63:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const LOCAL_SCRATCH_ADDRESS = 'AppData.EntityBundleClientScratch';

/**
 * EntityBundleClient — executes a pict EntityProvider bundle (MeadowEntity
 * steps with `Bundle.<Entity>` destinations) against the entity_bundles
 * service in ONE round trip, falling back to local execution through this
 * app's own pict EntityProvider when the service is unreachable (offline
 * clients, environments without the service). Both paths return the same
 * `{ <Entity>: rows[] }` map, so consumers author the steps once.
 *
 * Remote: POST /1.0/EntityBundle/ExecutePictBundle. The response must carry
 * an array for every step's destination — a step the service rejected (e.g.
 * over its record cap) surfaces as a missing key and fails the remote path
 * rather than silently returning partial scope.
 *
 * Local: the same steps re-homed to a scratch address (PJU references
 * rewritten to match) and forced to `NoCount` pagination, so the reads stay
 * plain FilteredTo GETs an offline entity store can serve — pict's Query/
 * Count/Schema conveniences are avoided or degrade gracefully.
 *
 * Usage:
 *   const client = pict.providers.EntityBundleClient;
 *   const result = await client.executeBundle(steps);
 *   // result.Data.<Entity> => rows[], result.Source => 'remote'|'local'
 */
class EntityBundleClient extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Execute a bundle remotely, falling back to local execution.
	 *
	 * @param {Array<Record<string, any>>} pSteps - MeadowEntity steps with `Bundle.<Entity>` destinations.
	 * @param {{ Context?: Record<string, any>, AllowRemote?: boolean, AllowLocal?: boolean }} [pOptions]
	 * @return {Promise<{ Data: Record<string, Array<any>>, Source: ('remote'|'local') }>}
	 */
	async executeBundle(pSteps, pOptions)
	{
		const tmpOptions = pOptions || {};
		if (!Array.isArray(pSteps) || pSteps.length === 0)
		{
			return { Data: {}, Source: 'local' };
		}
		if (tmpOptions.AllowRemote !== false)
		{
			try
			{
				return { Data: await this._executeRemote(pSteps, tmpOptions.Context || {}), Source: 'remote' };
			}
			catch (pError)
			{
				if (tmpOptions.AllowLocal === false)
				{
					throw pError;
				}
				this.pict?.log?.warn(`[EntityBundleClient] Remote bundle execution failed (${pError?.message || pError}); executing locally.`);
			}
		}
		if (tmpOptions.AllowLocal === false)
		{
			throw new Error('EntityBundleClient: remote execution disabled and local execution disallowed.');
		}
		return { Data: await this._executeLocal(pSteps), Source: 'local' };
	}

	/**
	 * @param {Record<string, any>} pStep
	 * @return {string} the response key for a step — the last Destination segment.
	 */
	destinationKey(pStep)
	{
		const tmpDestination = String(pStep?.Destination || '');
		return tmpDestination.substring(tmpDestination.lastIndexOf('.') + 1);
	}

	/**
	 * @param {Array<Record<string, any>>} pSteps
	 * @param {Record<string, any>} pContext
	 * @return {Promise<Record<string, Array<any>>>}
	 */
	_executeRemote(pSteps, pContext)
	{
		return new Promise((fResolve, fReject) =>
		{
			this.pict.HeadlightRestClient.postJSON('EntityBundle/ExecutePictBundle',
				{ bundle: pSteps, context: pContext, skipEntities: [] },
				(pError, pBody) =>
				{
					if (pError)
					{
						return fReject(pError);
					}
					const tmpData = pBody && pBody.Data;
					if (!tmpData || typeof tmpData !== 'object')
					{
						return fReject(new Error('ExecutePictBundle response carried no Data.'));
					}
					/** @type {Record<string, Array<any>>} */
					const tmpResult = {};
					for (const tmpStep of pSteps)
					{
						const tmpKey = this.destinationKey(tmpStep);
						if (!Array.isArray(tmpData[tmpKey]))
						{
							return fReject(new Error(`ExecutePictBundle response is missing step result [${tmpKey}] (step rejected server-side?).`));
						}
						tmpResult[tmpKey] = tmpData[tmpKey];
					}
					fResolve(tmpResult);
				});
		});
	}

	/**
	 * Execute the steps through this app's pict EntityProvider. Destinations
	 * (and PJU references to them) are re-homed under a scratch address so a
	 * live app's own `Bundle.*` state is never touched, and `NoCount` keeps
	 * pagination offline-servable.
	 *
	 * @param {Array<Record<string, any>>} pSteps
	 * @return {Promise<Record<string, Array<any>>>}
	 */
	async _executeLocal(pSteps)
	{
		const tmpLocalSteps = pSteps.map((pStep) =>
		{
			const tmpStep = Object.assign({}, pStep, { NoCount: true });
			tmpStep.Destination = `${LOCAL_SCRATCH_ADDRESS}.${this.destinationKey(pStep)}`;
			if (typeof tmpStep.Filter === 'string')
			{
				tmpStep.Filter = tmpStep.Filter.split('^Bundle.').join(`^${LOCAL_SCRATCH_ADDRESS}.`);
			}
			return tmpStep;
		});
		try
		{
			await new Promise((fResolve, fReject) =>
			{
				this.pict.EntityProvider.gatherDataFromServer(tmpLocalSteps, (pError) => (pError ? fReject(pError) : fResolve(undefined)));
			});
			const tmpScratch = this.pict.AppData.EntityBundleClientScratch || {};
			/** @type {Record<string, Array<any>>} */
			const tmpResult = {};
			for (const tmpStep of pSteps)
			{
				const tmpKey = this.destinationKey(tmpStep);
				tmpResult[tmpKey] = Array.isArray(tmpScratch[tmpKey]) ? tmpScratch[tmpKey] : [];
			}
			return tmpResult;
		}
		finally
		{
			delete this.pict.AppData.EntityBundleClientScratch;
		}
	}
}

module.exports = EntityBundleClient;

},{"pict-provider":552}],64:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/**
 * EntityFilterEngine — the Headlight-domain filter-composition half of the old Select2Util,
 * extracted verbatim so it can be shared without the select2 transport.
 *
 * These methods compose FoxHound scope clauses (Static / Dynamic `FromField` + per-row
 * `FromRowField` / SamplePlan / Through / Lab), split mandatory vs. back-off-able, and resolve
 * the Show-All override. They are select2-/DOM-free — they read live form state via
 * `this.pict.manifest` and delegate id-set resolution to the domain scope resolvers
 * (`SpecScopeResolver` / `ThroughScopeResolver` / `LabScopeResolver`), so they are unit-tested
 * directly against `this.pict` stubs.
 *
 * Two consumers share this one implementation:
 *   - `Select2Util` (the legacy select2 transport) **extends** this class, so its
 *     `getOptionsAjax` keeps calling `this.applyStaticFilters(...)` etc. unchanged.
 *   - the pict-section-picker `Picker` broker **calls** this via `this.pict.providers.EntityFilterEngine`
 *     from `getContextualSearchFilters`, feeding the composed clauses to PSP's `BaseFilter`.
 *
 * The manifest shapes (`PictForm.StaticFilters` / `DynamicFilters` / `ShowAllToggle` /
 * `OverrideField`) are unchanged — see docs/Filters.md — so no form edits are required.
 */
class EntityFilterEngineProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Append descriptor-level static scope filters to a select2 search filter
	 * list. Read from `pInput.PictForm.StaticFilters` — used to scope a picker
	 * to a polymorphic slice of its entity (e.g. `Organization` by `Type`,
	 * `Product` by `ProductCategory`). Applied on top of the per-provider
	 * `HandleSearchFilters` so the scope always constrains the result.
	 *
	 * Each entry is either:
	 *   - a structured `{ Field, Operator = 'EQ', Value }` (scalar) or
	 *     `{ Field, Operator = 'INN', Values: [...] }` (list) object whose
	 *     value(s) are URL-encoded here — the recommended form; or
	 *   - a ready Foxhound clause string, pushed verbatim (caller must
	 *     URL-encode any values — the `FilteredTo/<…>/` path rejects raw spaces).
	 *
	 * A filter entry flagged `BackOff: true` is routed to `pBackoff` (when provided) instead of
	 * `pFilters`, so the URL builder can drop it on the empty-result retry (see `getOptionsAjax`).
	 * Default static filters are deliberate scopes and stay mandatory.
	 *
	 * @param {string[]} pFilters - The mandatory filter list to append to.
	 * @param {object} pInput - The descriptor (reads `pInput.PictForm.StaticFilters`).
	 * @param {string[]} [pBackoff] - Optional back-off-able filter list for `BackOff: true` entries.
	 * @return {string[]} The (mutated) mandatory filter list.
	 */
	applyStaticFilters(pFilters, pInput, pBackoff)
	{
		pFilters = pFilters || [];
		const tmpStaticFilters = pInput && pInput.PictForm ? pInput.PictForm.StaticFilters : null;
		if (!Array.isArray(tmpStaticFilters))
		{
			return pFilters;
		}
		for (const tmpFilter of tmpStaticFilters)
		{
			if (typeof tmpFilter === 'string')
			{
				if (tmpFilter)
				{
					pFilters.push(tmpFilter);
				}
				continue;
			}
			if (!tmpFilter || !tmpFilter.Field)
			{
				continue;
			}
			const tmpTarget = (pBackoff && tmpFilter.BackOff === true) ? pBackoff : pFilters;
			const tmpOperator = tmpFilter.Operator || 'EQ';
			if (Array.isArray(tmpFilter.Values))
			{
				tmpTarget.push(`FBL~${tmpFilter.Field}~${tmpOperator}~${tmpFilter.Values.map((pValue) => encodeURIComponent(pValue)).join(',')}`);
			}
			else
			{
				tmpTarget.push(`FBV~${tmpFilter.Field}~${tmpOperator}~${encodeURIComponent(tmpFilter.Value)}`);
			}
		}
		return pFilters;
	}

	/**
	 * Append sibling-field-driven dynamic scope filters to a select2 search
	 * filter list, narrowing a picker to the entities associated with another
	 * field's current selection (e.g. Product scoped to the picked Producer:
	 * `Product.IDOrganization = <H.Producer>`). Read from
	 * `pInput.PictForm.DynamicFilters`.
	 *
	 * Each entry is `{ Field, FromField, Operator = 'EQ' }` where `FromField` is
	 * a pict address (e.g. `AppData.DocumentData.ReportData.FormData.H.Producer`)
	 * whose current value is read and URL-encoded into `FBV~Field~OP~<value>`.
	 * When the source value is unset — null, undefined, '', or the 1-based-id unset
	 * sentinel 0 / "0" — the filter is omitted (the picker shows its full set) rather
	 * than emitting `FBV~Field~EQ~0` (which would match nothing). The now-orphaned
	 * dependent value is cleared separately on the anchor's change (see
	 * MaterialsEntitySelector.onAfterEventCompletion), so an unset anchor never leaves
	 * a stale selection behind.
	 *
	 * Per-row tabular narrowing: when this picker is a column in a RecordSet table,
	 * `FromField` resolves a single global address — identical for every row — which
	 * is wrong when each row's anchor differs (e.g. each Aggregate Product row has its
	 * own Source/Producer). Use `FromRowField` instead: the sibling column's datum hash
	 * within the SAME row. It composes `<InformaryContainerAddress>[<pRowIndex>].<FromRowField>`
	 * and reads it from the marshal destination, so each row narrows by its OWN anchor.
	 * Requires `pRowIndex` and `pView` (threaded from MaterialsEntitySelector.initializeSelect2
	 * via the ajax options). Outside a tabular context (`pRowIndex == null`) a `FromRowField`
	 * entry without a `FromField` is skipped. `FromField` keeps working unchanged.
	 *
	 * @param {string[]} pFilters - The filter list to append to.
	 * @param {object} pInput - The descriptor (reads `pInput.PictForm.DynamicFilters`).
	 * @param {number} [pRowIndex] - The row index when this is a tabular column (enables `FromRowField`).
	 * @param {object} [pView] - The form view (provides the marshal destination for `FromRowField`).
	 * @param {string[]} [pBackoff] - Optional back-off-able filter list for `BackOff: true` entries (see `getOptionsAjax`).
	 * @return {string[]} The (mutated) mandatory filter list.
	 */
	applyDynamicFilters(pFilters, pInput, pRowIndex, pView, pBackoff)
	{
		pFilters = pFilters || [];
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters))
		{
			return pFilters;
		}
		// Show All is a MANUAL OVERRIDE WITH THE HIGHEST PRIORITY: it drops every sibling-driven
		// narrowing on this picker — the direct `FromField` / `FromRowField` clauses that solvers and
		// autofill triggers drive, as well as the `SamplePlanScope` / `Through` / `LabScope` id-set
		// scopes — so the dropdown falls back to the scope it would have had with
		// NO other selections made. `StaticFilters`, project scoping and the selector's own intrinsic
		// `HandleSearchFilters` are not "other selections" and still apply. Evaluated once, here, WITH
		// the row index, so a tabular picker honors its own row's toggle rather than the flat address
		// (the per-shape guards below repeat the check for direct callers, and are unit-tested as such).
		if (this.isFilterOverridden(pInput, pRowIndex))
		{
			return pFilters;
		}
		const tmpIsTabular = (pRowIndex != null) && pView && pInput.PictForm && pInput.PictForm.InformaryContainerAddress;
		for (const tmpFilter of tmpDynamicFilters)
		{
			// Sampling-plan scope is a distinct shape: it reads one or more upstream
			// siblings and resolves an INN id-set from the plan, rather than a single
			// FromField EQ clause. Handle (and skip) it before the generic guard below.
			if (tmpFilter && tmpFilter.SamplePlanScope)
			{
				this._applySamplePlanFilter(pFilters, tmpFilter, pInput);
				continue;
			}
			// Through ("chained") scope: narrows by a relationship with no direct FK on
			// this entity, hopping a bridge table via ThroughScopeResolver. Like the
			// sampling-plan scope it resolves an INN id-set, not a FromField EQ clause.
			if (tmpFilter && tmpFilter.Through)
			{
				this._applyThroughFilter(pFilters, tmpFilter, pInput);
				continue;
			}
			// Lab scope: parent labs for the sample-level selector, the leaf labs that can run the test for a
			// per-test one, resolved by LabScopeResolver. Like the other scopes it resolves an INN id-set.
			if (tmpFilter && tmpFilter.LabScope)
			{
				this._applyLabScopeFilter(pFilters, tmpFilter, pInput, pRowIndex, pView);
				continue;
			}
			if (!tmpFilter || !tmpFilter.Field || (!tmpFilter.FromField && !tmpFilter.FromRowField))
			{
				continue;
			}
			let tmpValue;
			if (tmpIsTabular && tmpFilter.FromRowField)
			{
				// Same-row sibling: compose `<container>[<row>].<datum>` and read the live value
				// from the marshal destination, so this row narrows by its own anchor cell.
				const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, tmpFilter.FromRowField);
				tmpValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
			}
			else if (tmpFilter.FromField)
			{
				tmpValue = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			}
			else
			{
				// A FromRowField-only entry outside a tabular context — nothing to resolve against.
				continue;
			}
			// Treat an unset anchor as "no constraint" and OMIT the filter (show the full set),
			// rather than emitting `FBV~Field~EQ~0` which would match nothing. FK ids are 1-based,
			// so 0 / "0" is the unset sentinel (e.g. ProductionPlant.IDOrganization = 0); null /
			// undefined / "" are also unset. The dependent's stale value is cleared separately when
			// the anchor changes (see MaterialsEntitySelector.onAfterEventCompletion).
			const tmpNormalized = (tmpValue === null || tmpValue === undefined) ? '' : String(tmpValue).trim();
			if (tmpNormalized === '' || tmpNormalized === '0')
			{
				continue;
			}
			const tmpOperator = tmpFilter.Operator || 'EQ';
			// Sibling-driven narrowing flagged `BackOff: true` routes to the back-off-able list so the
			// picker shows its full set rather than an empty dropdown when the anchor has no matches.
			const tmpTarget = (pBackoff && tmpFilter.BackOff === true) ? pBackoff : pFilters;
			tmpTarget.push(`FBV~${tmpFilter.Field}~${tmpOperator}~${encodeURIComponent(tmpValue)}`);
		}
		return pFilters;
	}

	/**
	 * Apply a sampling-plan scope clause for a DynamicFilters entry carrying a
	 * `SamplePlanScope` ('LineItem' | 'Material' | 'Test'). Reads the sibling values
	 * named by the entry's `SampleTypeFromField` / `LineItemFromField` /
	 * `MaterialFromField` / `TestFromField` addresses — bidirectional: each axis
	 * narrows by every OTHER axis's current selection through the plan, not just the
	 * upstream ones. Asks SpecScopeResolver for the plan-allowed ids on that axis and
	 * pushes a mandatory `FBL~Field~INN~<ids>` clause.
	 *
	 * Pushed to the mandatory list (not the back-off list) so an empty plan-filtered
	 * result does NOT auto-widen — it stays constrained until the user toggles Show
	 * All, which drops it here via isFilterOverridden. Omitted (fail-open) when there
	 * is no plan (resolver returns null) or the upstream selection yields no plan ids
	 * on this axis (so the picker keeps its other scopes rather than forcing empty).
	 *
	 * @param {string[]} pFilters - the mandatory filter list (mutated)
	 * @param {object} pFilter - the DynamicFilters entry (reads SamplePlanScope, Field, *FromField)
	 * @param {object} pInput - the descriptor (for the Show All override check)
	 * @return {void}
	 */
	_applySamplePlanFilter(pFilters, pFilter, pInput)
	{
		if (this.isFilterOverridden(pInput))
		{
			return;
		}
		const tmpResolver = this.pict.providers.SpecScopeResolver;
		if (!tmpResolver || !pFilter.Field)
		{
			return;
		}
		const tmpRead = (pAddress) => (pAddress ? this.pict.manifest.getValueByHash(this.pict, pAddress) : undefined);
		const tmpSampleType = tmpRead(pFilter.SampleTypeFromField);
		const tmpIDLineItem = tmpRead(pFilter.LineItemFromField);
		const tmpIDTest = tmpRead(pFilter.TestFromField);
		// The Material anchor is PUSHED to the Test / LineItem axes — expand it UP so a leaf
		// selection also matches plan rows bound to its parent categories. (Material is the only
		// hierarchical axis.) Comma-joined: the plan getters are list-aware (_samplePlanIDs).
		const tmpMaterialAnchor = tmpRead(pFilter.MaterialFromField);
		const tmpIDMaterial = (tmpMaterialAnchor && tmpResolver.expandMaterialAnchorsUp) ?
			Array.from(tmpResolver.expandMaterialAnchorsUp(tmpMaterialAnchor)).join(',') :
			tmpMaterialAnchor;
		let tmpAllowed = null;
		switch (pFilter.SamplePlanScope)
		{
		case 'LineItem':
			tmpAllowed = tmpResolver.getSamplePlanLineItemIDs?.(tmpSampleType, tmpIDMaterial, tmpIDTest);
			break;
		case 'Material':
			tmpAllowed = tmpResolver.getSamplePlanMaterialIDs?.(tmpSampleType, tmpIDLineItem, tmpIDTest);
			// The Material axis is this dropdown's own filter — expand the allowed set DOWN so a
			// child material is selectable under an allowed (parent/category) plan material.
			if (tmpAllowed && tmpResolver.expandMaterialSetDown)
			{
				tmpAllowed = tmpResolver.expandMaterialSetDown(tmpAllowed);
			}
			break;
		case 'Test':
			tmpAllowed = tmpResolver.getSamplePlanTestIDs?.(tmpSampleType, tmpIDLineItem, tmpIDMaterial);
			break;
		default:
			return;
		}
		if (tmpAllowed && tmpAllowed.size > 0)
		{
			pFilters.push(`FBL~${pFilter.Field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
		else if (tmpAllowed)
		{
			// Non-null but EMPTY: the plan IS loaded and authoritatively has no rows for this selection
			// (e.g. a SampleType with no plan tests) — constrain to none rather than fail open to the full
			// list. A null tmpAllowed (no plan loaded at all) still fails open below, and Show All overrides
			// both via isFilterOverridden at the top.
			pFilters.push(this._constrainToNoneClause(pFilter, pInput));
		}
	}

	/**
	 * Zero-row constraint clause for a scope filter. Targets the entity PK (`ID<Entity>` from
	 * `pInput.PictForm.Entity`) — always a positive auto-increment, so `0` can never match — rather than the
	 * scope `Field`, whose `0` may be a legitimate value (a status, or a nullable / parent FK such as
	 * `IDLabParent` which is 0 for root records). Falls back to `Field` only when the Entity is unknown.
	 * @param {object} pFilter @param {object} pInput @return {string}
	 */
	_constrainToNoneClause(pFilter, pInput)
	{
		const tmpEntity = (pInput && pInput.PictForm) ? pInput.PictForm.Entity : null;
		// Scalar EQ~0 (the "matches nothing" idiom the applyDynamicFilters unset-anchor path documents) rather
		// than INN~0 — no list to sanitize, and self-documenting as a zero-row constraint.
		return `FBV~${tmpEntity ? ('ID' + tmpEntity) : pFilter.Field}~EQ~0`;
	}

	/**
	 * Apply a Through ("chained") scope clause for a DynamicFilters entry carrying a
	 * `Through` bridge config. Reads the live anchor at `FromField`, asks
	 * ThroughScopeResolver for the bridge-allowed ids on the picker's `Field`, and
	 * pushes a mandatory `FBL~Field~INN~<ids>` clause (dropped by Show All via
	 * isFilterOverridden). Fail-open: omitted when there is no resolver, no resolved
	 * id-set (slice not yet primed), or an empty set — the picker keeps its full
	 * list rather than forcing empty.
	 *
	 * @param {string[]} pFilters - the mandatory filter list (mutated)
	 * @param {object} pFilter - the DynamicFilters entry (Through, ThroughKey, ThroughSelect, FromField, Field, Strategy)
	 * @param {object} pInput - the descriptor (for the Show All override check)
	 * @return {void}
	 */
	_applyThroughFilter(pFilters, pFilter, pInput)
	{
		if (this.isFilterOverridden(pInput))
		{
			return;
		}
		const tmpResolver = this.pict.providers.ThroughScopeResolver;
		if (!tmpResolver || !pFilter.Field)
		{
			return;
		}
		const tmpAnchor = pFilter.FromField ? this.pict.manifest.getValueByHash(this.pict, pFilter.FromField) : undefined;
		let tmpAllowed;
		const tmpSpecResolver = this.pict.providers.SpecScopeResolver;
		if (tmpAnchor && pFilter.ThroughKey === 'IDMaterial' && tmpSpecResolver?.expandMaterialAnchorsUp)
		{
			// A material anchor pushed through a bridge expands UP — rows for the material OR its
			// parent categories match. getThroughIDs is single-anchor, so union per id (null/not-yet-
			// primed ancestors are skipped; all-null stays null = fail-open). Map strategy is fully
			// covered; a query-strategy ancestor whose slice was not primed simply contributes nothing.
			tmpAllowed = null;
			for (const tmpMaterialID of tmpSpecResolver.expandMaterialAnchorsUp(tmpAnchor))
			{
				const tmpSet = tmpResolver.getThroughIDs(pFilter, tmpMaterialID);
				if (tmpSet)
				{
					if (!tmpAllowed)
					{
						tmpAllowed = new Set();
					}
					for (const tmpID of tmpSet)
					{
						tmpAllowed.add(tmpID);
					}
				}
			}
		}
		else
		{
			tmpAllowed = tmpResolver.getThroughIDs(pFilter, tmpAnchor);
		}
		if (tmpAllowed && tmpAllowed.size > 0)
		{
			pFilters.push(`FBL~${pFilter.Field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
	}

	/**
	 * Apply a lab-scope clause for a DynamicFilters entry carrying `LabScope` ('Sample' | 'Test'), resolved by
	 * LabScopeResolver.
	 *
	 *   'Sample' → the PARENT labs a sample can ship to (the project's labs, else the parents of the labs that
	 *              can run the selected tests).
	 *   'Test'   → the LEAF labs that can run this row's test. Reads the per-row test from `TestFromRowField`
	 *              (tabular) or `TestFromField`. Capability is the only clause: the project's own labs and the
	 *              material defaults rank the list (`getPreferredLabIDs`, pinned by the selector) rather than
	 *              narrowing it, so the dropdown and auto-fill order one list the same way.
	 *
	 * The mandatory set becomes `FBL~Field~INN~<ids>`; an empty-but-resolved set constrains to none (Show All
	 * overrides) and a null resolve stays fail-open. Only capability can produce that empty set, because it is
	 * the only clause whose emptiness is a fact rather than a preference.
	 *
	 * @param {Array<string>} pFilters
	 * @param {Object} pFilter
	 * @param {Object} pInput
	 * @param {number|string|null} [pRowIndex]
	 * @param {Object} [pView]
	 */
	_applyLabScopeFilter(pFilters, pFilter, pInput, pRowIndex, pView)
	{
		if (this.isFilterOverridden(pInput, pRowIndex))
		{
			return;
		}
		const tmpResolver = this.pict.providers.LabScopeResolver;
		if (!tmpResolver || !pFilter.Field)
		{
			return;
		}
		let tmpAllowed = null;
		if (pFilter.LabScope === 'Test')
		{
			const tmpIDTest = this._readLabScopeTestID(pFilter, pInput, pRowIndex, pView);
			tmpAllowed = tmpResolver.getTestLabIDs(tmpIDTest);
		}
		else
		{
			tmpAllowed = tmpResolver.getSampleLabIDs();
		}
		if (tmpAllowed && tmpAllowed.size > 0)
		{
			pFilters.push(`FBL~${pFilter.Field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
		else if (tmpAllowed)
		{
			// Empty (but resolved) set — no lab qualifies for this test on this project. Constrain to none
			// (Show All overrides); a null resolve (no data on any axis) stays fail-open and omits the clause.
			pFilters.push(this._constrainToNoneClause(pFilter, pInput));
		}
	}

	/**
	 * The test a per-test lab selector is bound to: the row's own sibling cell when tabular, else a flat address.
	 *
	 * @param {Object} pFilter @param {Object} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {any}
	 */
	_readLabScopeTestID(pFilter, pInput, pRowIndex, pView)
	{
		if (pRowIndex != null && pFilter.TestFromRowField && pInput.PictForm && pInput.PictForm.InformaryContainerAddress && pView)
		{
			const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pFilter.TestFromRowField);
			return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
		}
		if (pFilter.TestFromField)
		{
			return this.pict.manifest.getValueByHash(this.pict, pFilter.TestFromField);
		}
		return undefined;
	}

	/**
	 * Whether a descriptor's filters are currently user-overridden ("show all"). When
	 * `PictForm.OverrideField` names a form address whose live value is truthy, the back-off-able
	 * filters (spec-year, `BackOff` static/dynamic) are dropped entirely for that picker — the manual
	 * companion to the automatic empty-result back-off.
	 *
	 * @param {object} pInput - The descriptor (reads `pInput.PictForm.ShowAllToggle` / `OverrideField`).
	 * @param {number|string} [pRowIndex] - Row index for a tabular picker; selects the per-row state.
	 * @return {boolean}
	 */
	isFilterOverridden(pInput, pRowIndex)
	{
		const tmpPictForm = pInput && pInput.PictForm ? pInput.PictForm : null;
		if (!tmpPictForm)
		{
			return false;
		}
		// Integrated "Show All" toggle: the override state persists at the <DataAddress>__ShowAll suffix.
		// Tabular is per-row, keyed by Hash with a _<rowIndex> suffix (the col DataAddress may be a nested
		// path like TestInstance.IDLab, which can't compose a flat state address). Legacy forms instead
		// point PictForm.OverrideField at an external checkbox address.
		let tmpField;
		if (tmpPictForm.ShowAllToggle && pRowIndex != null && (pInput.Hash || pInput.DataAddress))
		{
			tmpField = `AppData.DocumentData.ReportData.FormData.${pInput.Hash || pInput.DataAddress}__ShowAll_${pRowIndex}`;
		}
		else if (tmpPictForm.ShowAllToggle && pInput.DataAddress)
		{
			tmpField = `AppData.DocumentData.ReportData.FormData.${pInput.DataAddress}__ShowAll`;
		}
		else
		{
			tmpField = tmpPictForm.OverrideField;
		}
		if (!tmpField)
		{
			return false;
		}
		const tmpValue = this.pict.manifest.getValueByHash(this.pict, tmpField);
		return tmpValue === true || tmpValue === 1 || tmpValue === 'true' || tmpValue === '1';
	}
}

module.exports = EntityFilterEngineProvider;

},{"pict-provider":552}],65:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const customParseFormat = require('dayjs/plugin/customParseFormat');

// Logical "live" default tokens a descriptor's `Default` may carry instead of a
// concrete value. They resolve to the current date/time when the form loads.
// Kept in one place so the date/time/datetime input types don't each carry their
// own copy of the list — route every check through isSpecialDefaultValue().
const SPECIAL_DEFAULT_VALUES = [ 'now', 'today' ];

// DayJS format tokens (core plus the advancedFormat plugin) and their flatpickr equivalents. `H` and `m` have no
// unpadded flatpickr form and render padded; `a` renders upper-case; `hh` renders unpadded, as the editable field
// always has, while the read-only and print text (DayJS) keeps it padded. A token mapped to null cannot be expressed.
const DAYJS_TO_FLATPICKR_TOKENS = {
	YYYY: 'Y', YY: 'y', MMMM: 'F', MMM: 'M', MM: 'm', M: 'n', Do: 'J', DD: 'd', D: 'j', dddd: 'l', ddd: 'D', d: 'w',
	HH: 'H', H: 'H', hh: 'h', h: 'h', mm: 'i', m: 'i', ss: 'S', s: 's', A: 'K', a: 'K', X: 'U', x: 'u',
	Y: null, YYY: null, dd: null, kk: null, k: null, SSS: null, ZZ: null, Z: null, Q: null, wo: null, ww: null, w: null,
	WW: null, W: null, gggg: null, GGGG: null, zzz: null, z: null,
};
// The DayJS tokens whose output differs from their flatpickr equivalent above, mapped to the DayJS token that matches
// what flatpickr shows, so text written into an editable field reads the same as the picker's own.
const DAYJS_TOKENS_AS_FLATPICKR_SHOWS = { a: 'A', hh: 'h', H: 'HH', m: 'mm' };
// A bracketed literal, or the longest DayJS token at this position.
const DAYJS_FORMAT_TOKEN_REGEX = new RegExp(`\\[([^\\]]*)]|${Object.keys(DAYJS_TO_FLATPICKR_TOKENS).sort((pA, pB) => pB.length - pA.length).join('|')}`, 'g');

/**
 * @typedef {Object} FlatpickrOptions
 * @property {boolean} AllowInput - Whether to allow manual input.
 * @property {string} DayJSDateFormat - The date format string, will be converted to Flatpickr format. (assumes standard DayJS formatting, e.g., 'YYYY-MM-DD')
 * @property {string} DefaultValue - The default value for the date input.
 * @property {boolean} DisablePicker - Whether to disable the date picker.
 * @property {string} HTMLID - The HTML ID of the input element.
 * @property {string} ISODateString - The date value in ISO format.
 * @property {string} PickerType - The type of picker (e.g., 'date', 'datetime', or 'time').
 * @property {string} Timezone - The timezone for the date input.
 * @property {boolean} [Time24Hour] - Whether to use 24-hour time format (only applicable for time or datetime pickers).
 * @property {string} [HiddenInputSelector] - The HTML ID of the hidden input element that stores the ISO value
 */

class FlatpickrUtilProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Extend dayJS with customParseFormat plugin work with Safari
		if (this.fable.Dates?.dayJS && !this.fable.Dates.dayJS.customParseFormatExtended)
		{
			this.fable.Dates.dayJS.extend(customParseFormat);
			this.fable.Dates.dayJS.customParseFormatExtended = true;
		}
	}

	/**
	 * Initialize the Flatpickr plugin for the input element.
	 * @param {FlatpickrOptions} pFlatpickrOptions The Flatpickr options.
	 * @return {void}
	 */
	initializeFlatpickr(pFlatpickrOptions)
	{
		if (!window.flatpickr)
		{
			console.error('Flatpickr library is not loaded.');
			return;
		}
		if (pFlatpickrOptions.DisablePicker)
		{
			console.info('Flatpickr initialization skipped because the picker is disabled.');
			return;
		}
		if (!pFlatpickrOptions.HTMLID)
		{
			console.error('Flatpickr initialization failed: HTMLID is required.');
			return;
		}
		// If the target input is a Read-theme static display (the Tier-2
		// a11y swap), don't attach the picker — the field is meant to be a
		// static, focusable, copyable display, not an interactive control.
		// We also tear down any prior Flatpickr instance from an earlier
		// render pass (e.g., the form transitioned Edit → Read at runtime),
		// since simply returning would leave the stale picker still
		// listening for focus / click.
		//
		// Discriminate ONLY on `aria-readonly="true"`: that is the marker
		// the Read-theme templates emit, and Flatpickr never sets it. We
		// must NOT also key off a bare `readonly` attribute — Flatpickr
		// itself stamps `readonly` on the input whenever it initializes with
		// allowInput:false, which this provider does on touch devices (see
		// tmpIsTouchDevice below). Treating that Flatpickr-set `readonly` as
		// a Read-theme signal would destroy a live, legitimately-initialized
		// Edit-mode picker on the very next marshal, leaving every date/time
		// field dead on tablets/phones after the first interaction.
		const tmpTargetElement = document.querySelector(pFlatpickrOptions.HTMLID);
		if (tmpTargetElement && tmpTargetElement.getAttribute('aria-readonly') === 'true')
		{
			if (tmpTargetElement['_flatpickr'] && typeof tmpTargetElement['_flatpickr'].destroy === 'function')
			{
				tmpTargetElement['_flatpickr'].destroy();
			}
			console.info(`Flatpickr initialization skipped for [${pFlatpickrOptions.HTMLID}] because the input is aria-readonly (Read-theme static display).`);
			return;
		}
		// Don't tear down a picker the user is actively using. A re-marshal can
		// fire mid-interaction: clicking the hour/minute spinner arrows or the
		// AM/PM toggle dispatches a native `change` on the display input (Flatpickr
		// updateTime -> _debouncedChange -> triggerEvent), which routes through the
		// data request -> solve -> marshal -> back into here. Re-initializing calls
		// window.flatpickr(), which destroys and recreates the instance, slamming
		// the open picker shut. Only skip re-init when the calendar is genuinely
		// rendered and visible — never for a stale/invisible "open" flag, so any bad
		// state always self-heals on the next marshal instead of getting stuck.
		const tmpExistingInstance = tmpTargetElement ? tmpTargetElement['_flatpickr'] : null;
		const tmpOpenCalendar = tmpExistingInstance ? tmpExistingInstance.calendarContainer : null;
		const tmpPickerIsOpen = !!tmpExistingInstance &&
			tmpExistingInstance.isOpen === true &&
			!!tmpOpenCalendar &&
			tmpOpenCalendar.classList.contains('open') &&
			tmpOpenCalendar.getBoundingClientRect().height > 0;
		if (tmpPickerIsOpen)
		{
			return;
		}
		// Define picker type map for resuable settings
		const pickerTypeMap = {
			date: {
				displayName: 'Date',
				flatpickrDateFormat: 'Y-m-d',
				dayJSDateFormat: 'YYYY-MM-DD',
				icon: 'fa-calendar',
			},
			datetime: {
				displayName: 'Date & Time',
				flatpickrDateFormat: 'Y-m-d H:i',
				dayJSDateFormat: 'YYYY-MM-DD HH:mm',
				icon: 'fa-calendar-clock',
			},
			time: {
				displayName: 'Time',
				flatpickrDateFormat: 'H:i',
				dayJSDateFormat: 'HH:mm',
				icon: 'fa-clock',
			},
		};
		const tmpPickerType = pFlatpickrOptions.PickerType?.toLowerCase() || 'date';
		const tmpHTMLID = pFlatpickrOptions.HTMLID;
		const tmpDayJSFormat = pFlatpickrOptions.DayJSDateFormat || pickerTypeMap[tmpPickerType]?.dayJSDateFormat || 'YYYY-MM-DD';
		const tmpISODateString = pFlatpickrOptions.ISODateString || '';
		const tmpDefaultValue = pFlatpickrOptions.DefaultValue || '';
		const tmpRequestedAllowInput = pFlatpickrOptions.AllowInput !== undefined ? pFlatpickrOptions.AllowInput : true;
		// Detect touch-primary devices so we can suppress manual keyboard entry on
		// mobile. Without this guard, iOS Safari opens the soft keyboard the
		// instant the user taps a date field, then the Flatpickr calendar overlay
		// (now forced on mobile via disableMobile: true) renders on top of the
		// keyboard — a screen-real-estate fight that hides part of the calendar
		// and confuses users about which UI is authoritative. The (maxTouchPoints
		// > 1) clause is intentional: touch-enabled laptops report 1 only for a
		// trackpad, so we don't accidentally strip typing from Surface/iPad-with-
		// keyboard users who do have a real keyboard attached. Explicit
		// AllowInput: false from callers is still honored everywhere.
		const tmpIsTouchDevice = (typeof navigator !== 'undefined') && (((navigator.maxTouchPoints || 0) > 1) || ('ontouchstart' in window));
		const tmpAllowInput = tmpRequestedAllowInput && !tmpIsTouchDevice;
		// Resolve timezone defensively: an invalid or unset timezone otherwise propagates
		// into dayjs.tz() and throws an exception that Flatpickr's init swallows silently.
		let tmpTimezone;
		let isDifferentTimezone = false;
		let timeZoneDisplay = '';
		try
		{
			tmpTimezone = this.resolveTimezone(pFlatpickrOptions.Timezone);
			const tmpCurrentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
			isDifferentTimezone = tmpTimezone && (tmpTimezone !== tmpCurrentTimezone);
			if (isDifferentTimezone)
			{
				const hourDifference = this.pict.Dates.dayJS().tz(tmpTimezone).utcOffset() - this.pict.Dates.dayJS().tz(tmpCurrentTimezone).utcOffset();
				timeZoneDisplay = tmpTimezone + ' ' + (hourDifference > 0 || hourDifference < 0 ? `(+${Math.abs(hourDifference / 60)} hrs)` : `(-${Math.abs(hourDifference / 60)} hrs)`);
			}
		}
		catch (err)
		{
			console.warn(`FlatpickrUtilProvider: timezone resolution failed during init, continuing with browser-local. Reason: ${err?.message}`);
			tmpTimezone = undefined;
			isDifferentTimezone = false;
			timeZoneDisplay = '';
		}
		const enableTime = (tmpPickerType === 'datetime' || tmpPickerType === 'time');
		// The picker's clock follows the format's hour token, so the picker and the field text agree.
		const tmpFormatClock = this.usesTwentyFourHourClock(tmpDayJSFormat);
		const tmpTime24Hour = (tmpFormatClock !== null) ? tmpFormatClock : (pFlatpickrOptions.Time24Hour !== undefined ? pFlatpickrOptions.Time24Hour : true);
		// Capture provider reference for use in Flatpickr event handler closures
		const self = this;
		// Convert ISO/default value to a fake-local Date that Flatpickr will display as document-TZ time
		const tmpDefaultDate = this.pict.providers.FlatpickrUtilProvider.toFlatpickrDate(tmpISODateString || tmpDefaultValue, tmpTimezone);
		// track manual time input changes for auto-save on close
		// store on the element to persist across re-initializations
		const tmpElement = document.querySelector(tmpHTMLID);
		if (tmpElement && (tmpElement).hasOwnProperty('_hasTimeChanges') === false)
		{
			tmpElement['_hasTimeChanges'] = false;
		}
		// Reset _userCleared on each initialization (marshal pushes fresh state)
		if (tmpElement)
		{
			tmpElement['_userCleared'] = false;
		}
		// Preview-only flag: when the picker is seeded with "now" on open, this tracks
		// whether the user has explicitly interacted. If still true on close, we revert.
		if (tmpElement && !tmpElement.hasOwnProperty('_previewOnly'))
		{
			tmpElement['_previewOnly'] = false;
		}
		// store the hidden input ID on element for use by clearDatePicker/setDatePickerToNow
		if (tmpElement && pFlatpickrOptions.HiddenInputSelector)
		{
			tmpElement['_hiddenInputID'] = pFlatpickrOptions.HiddenInputSelector;
		}
		if (tmpElement)
		{
			tmpElement['_timezone'] = tmpTimezone;
		}
		// NOTE: Flatpickr Plugin options and documentation: https://flatpickr.js.org/options/
		const tmpConfig = {
			dateFormat: this.convertDayJSToFlatpickrFormat(tmpDayJSFormat, pickerTypeMap[tmpPickerType]?.flatpickrDateFormat),
			allowInput: tmpAllowInput,
			defaultDate: tmpDefaultDate,
			enableTime: enableTime,
			noCalendar: (tmpPickerType === 'time'),
			time_24hr: tmpTime24Hour,
			// Force the Flatpickr UI on mobile devices instead of falling back to the
			// browser's native date/time picker. By default, Flatpickr detects mobile
			// user agents and silently swaps our <input type="text"> for a native
			// type="date" / "time" / "datetime-local", which causes iOS Safari to show
			// its OS UIDatePicker. That native path bypasses every lifecycle hook in
			// this provider — including the fake-local Date pattern (toFlatpickrDate /
			// fromFlatpickrDate) responsible for document-timezone correctness — so
			// dates picked on mobile would be written back without the TZ adjustment
			// the desktop flow applies. Keeping the Flatpickr UI on mobile also
			// ensures the Clear / "Set to Current" extras and the timezone indicator
			// render consistently across devices.
			disableMobile: true,
			// customize the picker UI after it's ready
			onReady: function(dateObj, dateStr, instance)
			{
				const template =
				`<div class="flatpicker-extras">
					${ isDifferentTimezone ? `<div class="timezone-indicator input is-static is-fullwidth is-small"><span class="has-text-text-50">Times shown in</span> ${timeZoneDisplay}</div>` : '' }
					<div class="buttons py-1 is-centered mb-0">
						<button class="button is-outline is-small" type="button" onclick="_Pict.providers.FlatpickrUtilProvider.clearDatePicker('${tmpHTMLID}')">
							<span class="icon">
								<i class="fa fa-fw fa-undo"></i>
							</span>
							<span class="icon-text">
								Clear
							</span>
						</button>
						<button class="button is-link is-small" type="button" onclick="_Pict.providers.FlatpickrUtilProvider.setDatePickerToNow('${tmpHTMLID}')">
							<span class="icon">
								<i class="fa fa-fw ${ pickerTypeMap[tmpPickerType]?.icon || 'fa-calendar'}"></i>
							</span>
							<span class="icon-text">
								Set to Current ${ pickerTypeMap[tmpPickerType]?.displayName || 'Date' }
							</span>
						</button>
					</div>
				</div>`;
				if (instance?.calendarContainer)
				{
					// add the extra buttons to the calendar container
					instance.calendarContainer.insertAdjacentHTML('beforeend', template);
				}
				// listeners for time picker manual inputs (hour, minute, AM/PM) to detect changes
				// only needed for time/datetime pickers - date picker saves automatically
				if (instance?.calendarContainer && enableTime)
				{
					const timeInputs = instance.calendarContainer.querySelectorAll('.flatpickr-hour, .flatpickr-minute');
					timeInputs.forEach(function(input)
					{
						input.addEventListener('input', function()
						{
							instance.input._hasTimeChanges = true;
							// User explicitly touched time inputs — no longer a preview
							instance.input._previewOnly = false;
						});
					});
					// Also track AM/PM toggle clicks!
					const ampmToggle = instance.calendarContainer.querySelector('.flatpickr-am-pm');
					if (ampmToggle)
					{
						ampmToggle.addEventListener('click', function()
						{
							instance.input._hasTimeChanges = true;
							// User explicitly toggled AM/PM — no longer a preview
							instance.input._previewOnly = false;
						});
					}
					// Close picker on Tab key ONLY when tabbing past the last time element.
					// Flatpickr only auto-parses typed input on Enter — Tab bypasses that,
					// so we parse it ourselves via setDate before closing.
					// In 12-hour mode the tab order is: input → hour → minute → AM/PM → close.
					// In 24-hour mode the tab order is: input → hour → minute → close.
					if (!tmpElement['_tabKeyHandler'])
					{
						tmpElement['_tabKeyHandler'] = function(event)
						{
							if (event.key !== 'Tab')
							{
								return;
							}
							const currentInstance = tmpElement?.['_flatpickr'];
							if (!currentInstance?.isOpen)
							{
								return;
							}
							const container = currentInstance.calendarContainer;
							if (!container)
							{
								return;
							}
							const target = event.target;
							// Determine the last focusable time element based on 12/24-hour mode
							const ampmToggle = container.querySelector('.flatpickr-am-pm');
							const minuteInput = container.querySelector('.flatpickr-minute');
							const lastTimeElement = ampmToggle || minuteInput;
							// Determine the first focusable time element (hour input)
							const hourInput = container.querySelector('.flatpickr-hour');
							const firstTimeElement = hourInput || currentInstance.input;
							// Only close when tabbing forward past the last element
							// or shift-tabbing before the first element (back to the main input)
							const isTabbingPastEnd = !event.shiftKey && (target === lastTimeElement);
							const isTabbingBeforeStart = event.shiftKey && (target === firstTimeElement || target === currentInstance.input);
							if (isTabbingPastEnd || isTabbingBeforeStart)
							{
								event.preventDefault();
								// Parse any manually typed value so selectedDates reflect what the user typed
								const inputValue = currentInstance.input?.value?.trim();
								if (inputValue)
								{
									// triggerChange=true fires onChange, which resets _hasTimeChanges
									// and dispatches the data request via the change event
									currentInstance.setDate(inputValue, true);
								}
								currentInstance.close();
								// Move focus to the next/previous focusable element outside the picker
								if (!event.shiftKey)
								{
									currentInstance.input.focus();
								}
							}
						};
						// Listen on document (capture phase) so we intercept Tab inside the
						// calendar container's time inputs, not just on the main input element
						document.addEventListener('keydown', tmpElement['_tabKeyHandler'], true);
					}
					// handle outside click/touch to close picker (known Flatpickr bug with allowInput + enableTime)
					if (tmpAllowInput && !tmpElement['_outsideClickHandler'])
					{
						tmpElement['_outsideClickHandler'] = function(event)
						{
							// get the current element and instance
							const currentElement = document.querySelector(tmpHTMLID);
							if (!currentElement)
							{
								return;
							}
							const currentInstance = currentElement['_flatpickr'];
							// check if picker is open using classList (isOpen property can be unreliable)
							const isPickerOpen = currentInstance?.calendarContainer?.classList.contains('open');
							if (!currentInstance || !isPickerOpen)
							{
								return;
							}
							const target = event.target;
							const isInsidePicker = currentInstance.calendarContainer?.contains(target);
							const isInput = currentInstance.input === target || currentInstance.input?.contains(target);
							if (!isInsidePicker && !isInput)
							{
								currentInstance.close();
							}
						};
						document.addEventListener('mousedown', tmpElement['_outsideClickHandler']);
						// Passive touchstart: the handler never calls preventDefault, and on
						// iOS Safari non-passive touchstart listeners block scroll/gesture
						// compositing while they run — a noticeable jank source on long forms.
						document.addEventListener('touchstart', tmpElement['_outsideClickHandler'], { passive: true });
					}
				}
			},
			onOpen: function(selectedDates, dateStr, instance)
			{
				// For time-enabled pickers: if the input is empty and hasn't been explicitly
				// cleared by the user, seed the picker UI with "now" in document timezone
				// as a visual preview. The value won't commit to the input field unless the
				// user explicitly interacts (clicks a date, edits time, clicks "Set to Current",
				// or presses Enter). If they close without interacting, we revert.
				if (enableTime && selectedDates.length === 0 && !instance.input['_userCleared'])
				{
					const fakeLocalNow = self.toFlatpickrDate('now', tmpTimezone);
					if (fakeLocalNow)
					{
						// false = don't trigger onChange, this is just a UI preview
						instance.setDate(fakeLocalNow, false);
						instance.input['_previewOnly'] = true;
						// Clear the display input so it still appears empty / shows placeholder
						instance.input.value = '';
					}
				}
				// On touch devices, scroll the input near the top of the viewport so
				// the calendar overlay has room to render below it without being
				// clipped — especially important for datetime and time pickers,
				// which are taller and where the iOS soft keyboard can still surface
				// for the in-picker hour/minute inputs. setTimeout defers the scroll
				// until after Flatpickr has placed its calendar, so Flatpickr's own
				// scroll-reposition handler runs once with the input in its final
				// resting spot rather than chasing a moving target.
				if (tmpIsTouchDevice)
				{
					setTimeout(function()
					{
						const tmpRect = instance.input.getBoundingClientRect();
						// Target ~80px from the top of the viewport — keeps the
						// field label visible above and frees maximum vertical
						// space below for the calendar (~340px for date-only,
						// taller for datetime/time pickers).
						const tmpTargetOffsetFromTop = 80;
						const tmpScrollDelta = tmpRect.top - tmpTargetOffsetFromTop;
						// Only scroll when we'd move more than a few pixels to
						// avoid jitter if the input is already well-placed.
						if (Math.abs(tmpScrollDelta) > 8)
						{
							window.scrollBy({ top: tmpScrollDelta, behavior: 'smooth' });
						}
					}, 50);
				}
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				if (selectedDates.length > 0)
				{
					// No offset math needed — Flatpickr now operates in document-TZ context.
					// The picker displays fake-local dates (via toFlatpickrDate), and the providers'
					// onDataRequest methods use fromFlatpickrDate to interpret the result correctly.
					if (enableTime)
					{
						// reset time changes flag for time/datetime pickers
						instance.input['_hasTimeChanges'] = false;
					}
					// User explicitly selected a value — no longer a preview
					instance.input['_previewOnly'] = false;
					// Clear the user-cleared flag since a value is now selected
					instance.input['_userCleared'] = false;
				}
			},
			onClose: function(selectedDates, dateStr, instance)
			{
				// If the picker was seeded with a preview "now" and the user never
				// interacted, revert — don't commit the previewed value.
				if (instance.input['_previewOnly'])
				{
					instance.clear();
					instance.input['_previewOnly'] = false;
					instance.input['_hasTimeChanges'] = false;
					return;
				}
				// auto-save any pending manual time changes when closing the picker
				if (enableTime && instance.input['_hasTimeChanges'])
				{
					// get current values from the time input fields (dateStr may be stale)
					const hourInput = instance.calendarContainer.querySelector('.flatpickr-hour');
					const minuteInput = instance.calendarContainer.querySelector('.flatpickr-minute');
					const ampmInput = instance.calendarContainer.querySelector('.flatpickr-am-pm');
					if (hourInput && minuteInput)
					{
						let hour = parseInt(hourInput.value, 10);
						const minute = parseInt(minuteInput.value, 10);
						// Handle AM/PM for 12-hour mode
						if (ampmInput && !tmpTime24Hour)
						{
							const isPM = ampmInput.textContent === 'PM';
							// Convert 12-hour to 24-hour format
							if (isPM && hour !== 12)
							{
								hour = hour + 12;
							}
							else if (!isPM && hour === 12)
							{
								hour = 0;
							}
						}
						// Create a fake-local Date with the manually entered time
						// (components represent document-TZ values since the picker operates in that context)
						const baseDate = selectedDates[0] || new Date();
						const newDate = new Date(
							baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(),
							hour, minute, 0, 0,
						);
						// Set date without triggering onChange - onDataRequest will use fromFlatpickrDate
						instance.setDate(newDate, false);
						// Dispatch change event to trigger onDataRequest
						const tmpChangeEvent = new Event('change', { bubbles: true });
						instance.input.dispatchEvent(tmpChangeEvent);
					}
					instance.input['_hasTimeChanges'] = false;
				}
				// Reset _userCleared after close so the next open of an empty picker
				// can seed the UI preview with "now" again
				instance.input['_userCleared'] = false;
			},
		};
		// initialize the flatpickr plugin
		window.flatpickr(tmpHTMLID, tmpConfig);
	}

	/**
	 * Split a DayJS format string into its tokens and literal runs.
	 * @param {string} pDayJSFormat
	 * @return {Array<{Token?: string, Literal?: string}>}
	 */
	tokenizeDayJSFormat(pDayJSFormat)
	{
		const tmpFormat = String(pDayJSFormat || '');
		const tmpParts = [];
		let tmpCursor = 0;
		for (const tmpMatch of tmpFormat.matchAll(DAYJS_FORMAT_TOKEN_REGEX))
		{
			if (tmpMatch.index > tmpCursor)
			{
				tmpParts.push({ Literal: tmpFormat.slice(tmpCursor, tmpMatch.index) });
			}
			tmpParts.push((tmpMatch[1] !== undefined) ? { Literal: tmpMatch[1] } : { Token: tmpMatch[0] });
			tmpCursor = tmpMatch.index + tmpMatch[0].length;
		}
		if (tmpCursor < tmpFormat.length)
		{
			tmpParts.push({ Literal: tmpFormat.slice(tmpCursor) });
		}
		return tmpParts;
	}

	/**
	 * Convert a DayJS date format string to a Flatpickr date format string, token by token. Literal letters are
	 * escaped so flatpickr prints them as written.
	 * @param {string} pDayJSFormat The DayJS date format string.
	 * @param {string} [pFallbackFormat] The Flatpickr format to use when pDayJSFormat has a token flatpickr cannot express.
	 * @return {string} The converted Flatpickr date format string.
	 */
	convertDayJSToFlatpickrFormat(pDayJSFormat, pFallbackFormat)
	{
		const tmpUnsupported = [];
		const tmpFormat = this.tokenizeDayJSFormat(pDayJSFormat).map((pPart) =>
		{
			if (pPart.Literal !== undefined)
			{
				return pPart.Literal.replace(/[A-Za-z]/g, '\\$&');
			}
			const tmpFlatpickrToken = DAYJS_TO_FLATPICKR_TOKENS[pPart.Token];
			if (!tmpFlatpickrToken)
			{
				tmpUnsupported.push(pPart.Token);
				return '';
			}
			return tmpFlatpickrToken;
		}).join('');
		if (tmpUnsupported.length < 1)
		{
			return tmpFormat;
		}
		const tmpFallback = pFallbackFormat || 'Y-m-d';
		console.warn(`DayJS format "${pDayJSFormat}" uses tokens the date picker cannot show (${tmpUnsupported.join(', ')}); the picker uses "${tmpFallback}" instead.`);
		return tmpFallback;
	}

	/**
	 * The DayJS format that prints a date the way flatpickr shows it in the field it edits: AM/PM upper-case, a 12-hour
	 * hour unpadded, a 24-hour hour and the minutes padded. Literal text stays as written.
	 * @param {string} pDayJSFormat
	 * @return {string}
	 */
	getEditableFieldFormat(pDayJSFormat)
	{
		return this.tokenizeDayJSFormat(pDayJSFormat).map((pPart) =>
		{
			if (pPart.Literal !== undefined)
			{
				return `[${pPart.Literal}]`;
			}
			return DAYJS_TOKENS_AS_FLATPICKR_SHOWS[pPart.Token] || pPart.Token;
		}).join('');
	}

	/**
	 * Format a date for the element that will show it: an editable input gets the text flatpickr would write there, so
	 * a re-marshal while the picker is open doesn't change its look; a read-only or print display keeps the format as
	 * written.
	 * @param {string} pHTMLSelector The element the text goes into.
	 * @param {string|Date} pDateValue
	 * @param {string} pDayJSDateFormat
	 * @param {string} [pTimezone]
	 * @param {boolean} [isTimeOnly]
	 * @return {string}
	 */
	formatDateForElement(pHTMLSelector, pDateValue, pDayJSDateFormat, pTimezone, isTimeOnly = false)
	{
		const tmpElement = (typeof document !== 'undefined') ? document.querySelector(pHTMLSelector) : null;
		const tmpEditable = !!tmpElement && tmpElement.tagName === 'INPUT' && tmpElement.getAttribute('aria-readonly') !== 'true';
		const tmpFormat = tmpEditable ? this.getEditableFieldFormat(pDayJSDateFormat) : pDayJSDateFormat;
		return this.formatDateWithTimezone(pDateValue, tmpFormat, pTimezone, isTimeOnly);
	}

	/**
	 * Which clock a DayJS format shows: true for a 24-hour hour token, false for a 12-hour one, null when it has no
	 * hour.
	 * @param {string} pDayJSFormat
	 * @return {boolean|null}
	 */
	usesTwentyFourHourClock(pDayJSFormat)
	{
		const tmpHourToken = this.tokenizeDayJSFormat(pDayJSFormat).find((pPart) => [ 'HH', 'H', 'kk', 'k', 'hh', 'h' ].includes(pPart.Token));
		if (!tmpHourToken)
		{
			return null;
		}
		return !tmpHourToken.Token.startsWith('h');
	}

	/**
	 * Safely resolve a timezone string, falling back to the document timezone option,
	 * and ultimately to undefined (which causes dayjs.tz() to use the browser-local
	 * zone instead of throwing). An invalid or unrecognized timezone otherwise causes
	 * dayjs.tz() to throw, and Flatpickr's init swallows that exception silently —
	 * so callers should always route through this helper.
	 *
	 * @param {string} [pTimezone] - Candidate timezone string (e.g., 'America/Chicago')
	 * @return {string|undefined} A validated timezone string, or undefined to mean "browser local"
	 */
	resolveTimezone(pTimezone)
	{
		const candidate = pTimezone || this.fable?.options?.Timezone;
		if (!candidate)
		{
			return undefined;
		}
		try
		{
			// Intl rejects unknown zones with a RangeError; this is the canonical validity check
			new Intl.DateTimeFormat('en-US', { timeZone: candidate });
			return candidate;
		}
		catch (err)
		{
			console.warn(`FlatpickrUtilProvider: invalid timezone "${candidate}", falling back to browser local. Reason: ${err?.message}`);
			return undefined;
		}
	}

	/**
	 * Convert an ISO string (or special value) to a Date object whose local components
	 * match the document-timezone representation. This "tricks" Flatpickr into displaying
	 * document-TZ time as if it were browser-local time, so the user sees the correct
	 * document-context date/time without any post-hoc shifting.
	 *
	 * @param {string|Date|null} pISOValue - ISO string, Date object, 'now', 'today', or null/empty
	 * @param {string} [pDocumentTZ] - Document timezone (e.g., 'America/Chicago')
	 * @return {Date|null} A Date whose local components match document-TZ values, or null if invalid
	 */
	toFlatpickrDate(pISOValue, pDocumentTZ)
	{
		if (!pISOValue)
		{
			return null;
		}

		const tmpTimezone = this.resolveTimezone(pDocumentTZ);

		// Handle 'now' / 'today' special values
		if (this.isSpecialDefaultValue(pISOValue))
		{
			const nowInDocTZ = this.pict.Dates.dayJS().tz(tmpTimezone);
			return new Date(
				nowInDocTZ.year(), nowInDocTZ.month(), nowInDocTZ.date(),
				nowInDocTZ.hour(), nowInDocTZ.minute(), 0, 0,
			);
		}

		const parsed = this.pict.Dates.dayJS(pISOValue);
		if (!parsed.isValid())
		{
			return null;
		}

		// Convert to document timezone and extract components
		const inDocTZ = parsed.tz(tmpTimezone);

		// Create a fake-local Date whose .getHours(), .getDate(), etc. match document-TZ values
		// Flatpickr will display these as-is since it assumes everything is browser-local
		return new Date(
			inDocTZ.year(), inDocTZ.month(), inDocTZ.date(),
			inDocTZ.hour(), inDocTZ.minute(), inDocTZ.second(), inDocTZ.millisecond(),
		);
	}

	/**
	 * Convert a Date picked by Flatpickr back to an ISO string, interpreting its local
	 * components as document-timezone values (since we fed Flatpickr a fake-local Date
	 * via toFlatpickrDate). This is the inverse of toFlatpickrDate.
	 *
	 * @param {Date} pFlatpickrDate - Date object from Flatpickr (browser-local interpretation)
	 * @param {string} pDocumentTZ - Document timezone (e.g., 'America/Chicago')
	 * @param {string} [pPickerType='datetime'] - 'date', 'time', or 'datetime'
	 * @return {string} ISO string representing the picked moment in document-TZ context
	 */
	fromFlatpickrDate(pFlatpickrDate, pDocumentTZ, pPickerType = 'datetime')
	{
		if (!pFlatpickrDate || !(pFlatpickrDate instanceof Date) || isNaN(pFlatpickrDate.getTime()))
		{
			return '';
		}

		const tmpTimezone = this.resolveTimezone(pDocumentTZ);

		// Read the components the user actually saw in the Flatpickr UI
		const y = pFlatpickrDate.getFullYear();
		const m = pFlatpickrDate.getMonth() + 1; // JS Date is 0-indexed
		const d = pFlatpickrDate.getDate();
		const h = pFlatpickrDate.getHours();
		const min = pFlatpickrDate.getMinutes();
		const sec = pFlatpickrDate.getSeconds();

		// For date-only pickers, zero out the time to avoid DST edge cases
		const timeH = (pPickerType === 'date') ? 0 : h;
		const timeM = (pPickerType === 'date') ? 0 : min;
		const timeS = (pPickerType === 'date') ? 0 : sec;

		// Build a date-time string and interpret it as document-TZ. The static dayjs.tz()
		// form throws on an undefined timezone (unlike the instance .tz()), so when
		// resolveTimezone falls through to undefined we parse as browser-local instead.
		const dateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')} ${String(timeH).padStart(2, '0')}:${String(timeM).padStart(2, '0')}:${String(timeS).padStart(2, '0')}`;
		const interpreted = tmpTimezone ?
			this.pict.Dates.dayJS.tz(dateStr, 'YYYY-MM-DD HH:mm:ss', tmpTimezone) :
			this.pict.Dates.dayJS(dateStr, 'YYYY-MM-DD HH:mm:ss');

		if (!interpreted.isValid())
		{
			return '';
		}

		return interpreted.toISOString();
	}

	/**
	 * Determine whether a value is one of the logical "live" default tokens
	 * ('now', 'today') rather than a concrete date value. Matching is trimmed and
	 * case-insensitive so configuration authors aren't tripped up by casing.
	 *
	 * @param {any} pValue - Candidate value (typically a descriptor's `Default` or a marshaled model value)
	 * @return {boolean} True when the value is a recognized special default token
	 */
	isSpecialDefaultValue(pValue)
	{
		return (typeof pValue === 'string') && SPECIAL_DEFAULT_VALUES.includes(pValue.trim().toLowerCase());
	}

	/**
	 * Resolve a logical default token ('now'/'today') to the concrete ISO string that
	 * would have been stored had the user picked that moment. Composes the same
	 * fake-local round-trip (toFlatpickrDate → fromFlatpickrDate) the interactive
	 * onDataRequest path uses, so a locked-in default is byte-for-byte consistent with
	 * a user-entered value for the same instant. Returns '' for non-special values.
	 *
	 * @param {any} pValue - The value to resolve (only special tokens produce a result)
	 * @param {string} [pTimezone] - Document timezone (e.g., 'America/Chicago')
	 * @param {string} [pPickerType='datetime'] - 'date', 'time', or 'datetime'
	 * @return {string} The resolved ISO string, or '' if the value is not a special token
	 */
	resolveSpecialDefaultToISO(pValue, pTimezone, pPickerType = 'datetime')
	{
		if (!this.isSpecialDefaultValue(pValue))
		{
			return '';
		}
		const tmpFakeLocalDate = this.toFlatpickrDate(pValue, pTimezone);
		return this.fromFlatpickrDate(tmpFakeLocalDate, pTimezone, pPickerType);
	}

	/**
	 * @deprecated Use fromFlatpickrDate() instead. Kept for backward compatibility during migration.
	 * Convert parsed local time to ISO string, adjusting for timezone context.
	 * For edits (storedValue exists), interprets input as record timezone.
	 * For initial entry, interprets input as browser local time.
	 * @param {object} pLocalParsed dayJS parsed object (browser local interpretation)
	 * @param {string} pStoredValue existing ISO value (empty/null for initial entry)
	 * @param {string} pTimezone record timezone (e.g., 'America/Chicago')
	 * @return {string} ISO string
	 */
	convertToISOWithTimezoneContext(pLocalParsed, pStoredValue, pTimezone)
	{
		if (pStoredValue && typeof pStoredValue === 'string' && pStoredValue.length > 10)
		{
			// Edit
			const browserTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
			const browserOffset = pLocalParsed.tz(browserTimezone).utcOffset();
			const recordOffset = pLocalParsed.tz(pTimezone).utcOffset();
			const offsetDiffMinutes = recordOffset - browserOffset;
			return pLocalParsed.subtract(offsetDiffMinutes, 'minute').toISOString();
		}
		// Initial entry
		return pLocalParsed.toISOString();
	}

	/**
	 * Clear the date time picker.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	clearDatePicker(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				tmpFlatpickrInstance.clear();
				// Mark as explicitly cleared so onOpen won't re-seed with "now"
				tmpFlatpickrElement['_userCleared'] = true;
				// Reset time changes flag so onClose doesn't re-apply stale hour/minute values
				tmpFlatpickrElement['_hasTimeChanges'] = false;
				// Clear hidden input so next entry is treated as initial (not edit)
				const tmpHiddenID = tmpFlatpickrElement['_hiddenInputID'];
				if (tmpHiddenID)
				{
					this.pict.ContentAssignment.assignContent(tmpHiddenID, '');
				}
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}

	/**
	 * Format a date value with the given format and timezone. Usually, the timezone is set for the document record, but can be overridden.
	 * @param {string|Date} pDateValue The date value to format.
	 * @param {string} pDayJSDateFormat The date format string. (assumes DayJS formatting)
	 * @param {string} [pTimezone] (optional) The timezone to use for formatting.
	 * @param {boolean} [isTimeOnly] (optional) Whether the value is time-only. Defaults to false. If true, the date portion will be applied to today's date.
	 * @return {string} The formatted date string.
	 */
	formatDateWithTimezone(pDateValue, pDayJSDateFormat, pTimezone, isTimeOnly = false)
	{
		if (!pDateValue)
		{
			return '';
		}
		if (!pDayJSDateFormat)
		{
			console.error('DayJS date format is required for formatting the date value.');
			return '';
		}
		// use the provided timezone or fall back to the document timezone
		const tmpTimezone = this.resolveTimezone(pTimezone);
		// handle special 'now' or 'today' values
		if (this.isSpecialDefaultValue(pDateValue))
		{
			if (isTimeOnly)
			{
				// for time-only, combine today's date with the current time to make it a valid date for Flatpickr (will be saved as ISO time later)
				const tmpTodayDate = this.pict.Dates.dayJS().tz(tmpTimezone).format('YYYY-MM-DD');
				const tmpCurrentTime = this.pict.Dates.dayJS().tz(tmpTimezone).format(pDayJSDateFormat);
				return this.pict.Dates.dayJS(tmpTodayDate + ' ' + tmpCurrentTime).tz(tmpTimezone).format('YYYY-MM-DD ' + pDayJSDateFormat);
			}
			// for date or datetime, just return the current date/time in the specified timezone
			return this.pict.Dates.dayJS().tz(tmpTimezone).format(pDayJSDateFormat);
		}
		// validate the date value
		if (this.pict.Dates.dayJS(pDateValue).isValid() === false)
		{
			console.error(`Invalid date value provided: ${pDateValue}`);
			return '';
		}
		if ((typeof pDateValue == 'string' || pDateValue instanceof String) && pDateValue?.length == 10)
		{
			return this.pict.Dates.dayJS(pDateValue).format(pDayJSDateFormat);
		}
		return this.pict.Dates.dayJS(pDateValue).tz(tmpTimezone).format(pDayJSDateFormat);
	}

	/**
	 * Set the date time picker to the 'now' date/time.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	setDatePickerToNow(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				// Clear hidden input so the next save writes fresh
				const tmpHiddenID = tmpFlatpickrElement['_hiddenInputID'];
				if (tmpHiddenID)
				{
					this.pict.ContentAssignment.assignContent(tmpHiddenID, '');
				}
				// Create a fake-local Date representing "now" in the timezone the picker shows
				const fakeLocalNow = this.toFlatpickrDate('now', tmpFlatpickrElement['_timezone']);
				tmpFlatpickrInstance.setDate(fakeLocalNow);
				// "Set to Current" commits a real value. setDate() above runs with
				// triggerChange=false (no onChange), so clear the onOpen "now" preview
				// flag (and any pending manual-time flag) ourselves — otherwise the
				// trailing close() -> onClose sees _previewOnly and reverts the value we
				// just set, so it would only reappear on a later marshal.
				tmpFlatpickrElement['_previewOnly'] = false;
				tmpFlatpickrElement['_hasTimeChanges'] = false;
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}
}

module.exports = FlatpickrUtilProvider;

},{"dayjs/plugin/customParseFormat":394,"pict-provider":552}],66:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#BRIDGE-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedBridge.StructureNumber || 'N/A',
				this.pict.AppData.SelectedBridge.Name || ('Unnamed Bridge #' + this.pict.AppData.SelectedBridge.IDBridge),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedBridge.Name || ('Unnamed Bridge #' + this.pict.AppData.SelectedBridge.IDBridge);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), resolve the Bridge for display (StructureNumber, Name)
		if (pValue)
		{
			// Prefer the bridge cached in FormData (the document is a point-in-time record), so long
			// as it matches the selection.
			const tmpCachedBridge = this.pict.AppData?.DocumentData?.ReportData?.FormData?.Bridge;
			if (tmpCachedBridge && tmpCachedBridge.IDBridge > 0 && tmpCachedBridge.IDBridge == pValue)
			{
				//FIXME: this input type managing SelectedBridge in AppData feels like a hack
				this.pict.AppData.SelectedBridge = tmpCachedBridge;
			}
			else if (!this.pict.AppData.SelectedBridge)
			{
				const tmpResult = await this.pict.providers.BridgeProvider.getBridgeByID(pValue);
				this.pict.AppData.SelectedBridge = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],67:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.onChangeCallbacks = [];
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#BRIDGE-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#BRIDGE-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Adds an onChange callback to the input handler.
	 * @param {function} pCallback The callback function.
	 */
	addOnChangeCallback(pCallback)
	{
		if (!pCallback || typeof pCallback !== 'function')
		{
			this.pict.log.error('Invalid onChangeCallback provided.');
			return;
		}
		// check if the callback is already in the list
		if (this.onChangeCallbacks.indexOf(pCallback) > -1)
		{
			this.pict.log.warn('onChangeCallback already exists in the list.');
			return;
		}
		this.onChangeCallbacks.push(pCallback);
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {string} pStateFilter The state fitler string.
	 */
	initializeSelect2(pInput, pStateFilter)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Bridge',
				{
					Input: pInput,
					SearchFields: [ 'StructureNumber', 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Select a Bridge by name or code...',
					HandleSearchFilters: (pFilters) =>
					{
						if (!pStateFilter)
						{
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						if (Array.isArray(pStateFilter))
						{
							pFilters.push(`FBL~State~INN~${pStateFilter.join(',')}`);
						}
						else
						{
							pFilters.push(`FBV~State~EQ~${pStateFilter}`);
						}
						return pFilters;
					},
					GetRecordUserFacingID: (pBridge) => pBridge.StructureNumber || 'N/A',
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), resolve the Bridge for display (StructureNumber, Name)
		if (pValue && typeof pValue === 'string' || typeof pValue === 'number')
		{
			// Prefer the bridge cached in FormData (the document is a point-in-time record), so long
			// as it matches the selection.
			const tmpCachedBridge = this.pict.AppData?.DocumentData?.ReportData?.FormData?.Bridge;
			let tmpBridge;
			if (tmpCachedBridge && tmpCachedBridge.IDBridge > 0 && tmpCachedBridge.IDBridge == pValue)
			{
				tmpBridge = tmpCachedBridge;
			}
			else
			{
				tmpBridge = await this.pict.providers.BridgeProvider.getBridgeByID(pValue);
			}
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			if (!tmpSelectElement)
			{
				return false;
			}
			tmpOption.value = tmpBridge.IDBridge;
			tmpOption.text = `${tmpBridge.StructureNumber || 'N/A'}|~|${tmpBridge.Name || ('Unnamed Bridge #' + tmpBridge.IDBridge)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		else
		{
			this.pict.log.info('No Bridge selected.');
		}
		// set the bridge selection callback for the Bridge Search Panel
		this.pict.views.HeadlightPaneBridges.setBridgeSelectionCallback((pBridge) =>
		{
			this.pict.log.info('Bridge selected:', pBridge.IDBridge);
			this.pict.log.info('Assigning bridge to the following input element:', pInput.Macro.RawHTMLID);
			// NOTE: ContentAssignment is failing to set this value for some reason, should investigate later
			document.getElementById(pInput.Macro.RawHTMLID)['value'] = pBridge.IDBridge;
			document.getElementById(pInput.Macro.RawHTMLID).dispatchEvent(new Event('change'));
		});
		// get the configuration for the current user to filter the Bridge search results (by State, etc.)
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.pict.AppData?.CurrentUser?.CustomerID, (pConfig) =>
		{
			const tmpStateFilter = pConfig?.StateAbbreviation || null;
			this.initializeSelect2(pInput, tmpStateFilter);
			this.removeLoadingSkeleton(pInput);
		});
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data change event for a select input in the PictProviderInputSelect class.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.onChangeCallbacks.length > 0)
		{
			this.onChangeCallbacks.forEach((pCallback) =>
			{
				pCallback(pView, pInput, pValue, pHTMLSelector);
			});
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],68:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/*
	Tier-2.5 accessibility helper for the Color input type.

	`readonly` does nothing on `<input type="color">`, so the Read (locked) theme can't use
	the text-input readonly swap. Instead the Read template renders a static display node
	(`DISPLAY-FOR-{RawHTMLID}`) and this extension paints a color swatch plus the hex value
	text into it — readable and announced, instead of a `disabled` color control that screen
	readers skip and that gives no textual value.

	Acts only when the display node is present (Read theme); a no-op in Edit/Print, where
	`super` still drives the core informary binding of the live control. Per the repo
	convention we build node content with createElement/append, not HTML strings.
*/
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Returns the HTML selector for the Read-theme static display node.
	 * @param {string} pInputHTMLID - The raw HTML ID of the input.
	 * @return {string} - The selector for the display node.
	 */
	getDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Returns the HTML selector for the Read-theme tabular static display node.
	 * @param {string} pInputHTMLID - The raw HTML ID of the input.
	 * @param {number} pRowIndex - The tabular row index.
	 * @return {string} - The selector for the tabular display node.
	 */
	getTabularDisplayHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-TABULAR-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Normalizes a marshalled value into a `#rrggbb` (or `#rgb`) hex string, or null if it
	 * doesn't look like a hex color. Used both as the swatch background and the visible text.
	 * @param {any} pValue - The value to normalize.
	 * @return {string|null} - The normalized hex string, or null.
	 */
	normalizeHex(pValue)
	{
		if (typeof pValue !== 'string')
		{
			return null;
		}
		const tmpTrimmed = pValue.trim();
		return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(tmpTrimmed) ? tmpTrimmed.toLowerCase() : null;
	}

	/**
	 * Paints the swatch + hex text into the display node, if present.
	 * @param {string} pDisplaySelector - The selector for the display node.
	 * @param {any} pValue - The marshalled value.
	 * @return {void}
	 */
	renderColorDisplay(pDisplaySelector, pValue)
	{
		const tmpElements = this.pict.ContentAssignment.getElement(pDisplaySelector);
		if (!tmpElements || tmpElements.length < 1)
		{
			return;
		}
		const tmpHex = this.normalizeHex(pValue);

		const tmpContainer = document.createElement('span');
		tmpContainer.className = 'color-display';

		const tmpSwatch = document.createElement('span');
		tmpSwatch.className = 'color-swatch';
		// Swatch is decorative; the adjacent hex text carries the value for assistive tech.
		tmpSwatch.setAttribute('aria-hidden', 'true');
		if (tmpHex)
		{
			tmpSwatch.style.backgroundColor = tmpHex;
		}
		tmpContainer.appendChild(tmpSwatch);

		const tmpText = document.createElement('span');
		tmpText.textContent = tmpHex || (typeof pValue === 'string' && pValue.trim() ? pValue.trim() : 'None');
		tmpContainer.appendChild(tmpText);

		for (let i = 0; i < tmpElements.length; i++)
		{
			const tmpTarget = tmpElements[i];
			// Clear via a removeChild loop rather than replaceChildren(), which isn't available
			// on the older browsers in this bundle's "since 2018" browserslist target.
			while (tmpTarget.firstChild)
			{
				tmpTarget.removeChild(tmpTarget.firstChild);
			}
			tmpTarget.appendChild(tmpContainer.cloneNode(true));
		}
	}

	/**
	 * Marshals the color value into the Read-theme display node (no-op outside Read).
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of super.onDataMarshalToForm.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.renderColorDisplay(this.getDisplayHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals the color value into the Read-theme tabular display node (no-op outside Read).
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of super.onDataMarshalToFormTabular.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.renderColorDisplay(this.getTabularDisplayHTMLID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],69:[function(require,module,exports){
// Headlight `Diagram` input provider — the Excalidraw-backed drawing canvas from pict-section-form,
// wrapped with the shared inline View/Edit presentation behavior (see EditorBase). PSF does
// not auto-register this provider (its heavy editor dep is an opt-in), so the Headlight bundle registers
// it under the hash `Pict-Input-Diagram` that the templates' DefaultInputExtensions reference.
const DiagramInput = require('pict-section-form').DiagramInput;
const { buildEditorInputProvider } = require('./PictProvider-InputType-EditorBase.js');

// The Excalidraw vendor bundle is ~25MB (8.4MB wrapper + 13MB fonts + locales), so it is never bundled
// or script-tagged — pict-section-excalidraw lazy-loads it from these URLs on the FIRST edit only.
// Defaulting them here means every form in every app that attaches this bundle gets a working editor
// with no per-descriptor config. Resolution order (first wins):
//   1. PictForm.Diagram.EditorOptions.LazyLoad*URL  — per field
//   2. provider option ExcalidrawVendorPath         — per app, e.g. attachProviders({'Pict-Input-Diagram': {...}})
//   3. the default below                            — document-relative, matching how headlight-dynamic-form
//                                                     serves its libs (./ alongside index.html)
// The host must serve the contents of
// node_modules/pict-section-excalidraw/vendor/excalidraw-built/ at that path.
const _DEFAULT_VENDOR_PATH = './excalidraw';
const _EDITOR_REACHABLE_TIMEOUT_MS = 5000;
const _UNAVAILABLE_NOTICE_CLASS = 'headlight-diagram-unavailable-notice';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Input-Diagram',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Join the app save-data lifecycle so EditorBase.onBeforeSaveDataAsync fires — it flushes an editor
	// left open at save time into FormData (the per-keystroke marshal is deferred to View, so without
	// this a Save-while-editing would persist the pre-edit value). NOT a framework default.
	AutoSaveDataWithApp: true,

	ExcalidrawVendorPath: _DEFAULT_VENDOR_PATH,
};

const EditorProviderBase = buildEditorInputProvider(DiagramInput, _DEFAULT_CONFIGURATION);

class PictProviderInputTypeDiagram extends EditorProviderBase
{
	/**
	 * Point the editor view at the lazily-loaded Excalidraw vendor bundle unless the field or the app
	 * already named its own URLs.
	 *
	 * @param {Record<string, any>} pInput @param {any} pValue @param {Record<string, any>} pInst
	 * @return {Record<string, any>}
	 */
	_buildEditorOptions(pInput, pValue, pInst)
	{
		const tmpOptions = super._buildEditorOptions(pInput, pValue, pInst);
		const tmpVendorPath = (this.options && this.options.ExcalidrawVendorPath) || _DEFAULT_VENDOR_PATH;

		// IFRAME mode is the default here, and that is a Headlight-specific requirement rather than a
		// preference: the form document already loads React 17 as a window global, Excalidraw needs
		// React 18+ (it calls ReactDOM.createRoot), and the react embed only fetches its own bundled
		// React when `window.React` is ABSENT — so in this host it binds to React 17 and dies with
		// "tmpReactDOM.createRoot is not a function". The iframe host loads its own React 18 inside the
		// frame, so the page's React is irrelevant. Switch to 'react' only in a host with React 18+.
		//
		// pict-section-form passes the field's choice as `EditorImplementation`, but the excalidraw
		// module reads `EmbedMode` — so map it here, which is also what makes the descriptor's
		// documented "EditorImplementation" option actually take effect.
		//
		// Read the choice off the DESCRIPTOR, not off the options PSF just built: PSF always writes
		// `EditorImplementation: <field value> || 'react'`, so the key is never absent and testing it
		// would pin every field to react and never reach the iframe default below.
		const tmpDiagramOptions = (pInput && pInput.PictForm && pInput.PictForm.Diagram) || {};
		const tmpRequestedMode = tmpOptions.EmbedMode || tmpDiagramOptions.EditorImplementation;
		const tmpEmbedMode = tmpRequestedMode || 'iframe';
		tmpOptions.EmbedMode = tmpEmbedMode;
		// Keep the two in step so anything reading the PSF-style key sees the mode actually in use.
		tmpOptions.EditorImplementation = tmpEmbedMode;

		if (!tmpOptions.IframeHostURL)
		{
			tmpOptions.IframeHostURL = `${tmpVendorPath}/excalidraw-iframe-host.html`;
		}
		// Fonts + locales. In iframe mode the wrapper runs INSIDE the host page (which already sits in
		// the vendor directory), so the path is relative to that; in react mode it runs in this page.
		if (!tmpOptions.AssetBaseURL)
		{
			tmpOptions.AssetBaseURL = (tmpEmbedMode === 'iframe') ? './assets/' : `${tmpVendorPath}/assets/`;
		}

		// Lazy-load URLs are for REACT mode only. Setting them in iframe mode is not merely redundant:
		// the react view's _lazyLoadVendor() unconditionally injects a <script> for the wrapper, so a
		// stray URL pulls all ~8.4MB of it into the PARENT page — which the iframe host never uses,
		// because it loads its own copy (and its own React) inside the frame.
		if (tmpEmbedMode === 'react')
		{
			// PSF merges PictForm.Diagram.EditorOptions first, so a field-level URL is already present
			// here and must not be clobbered.
			if (!tmpOptions.LazyLoadWrapperURL)
			{
				tmpOptions.LazyLoadWrapperURL = `${tmpVendorPath}/excalidraw-wrapper.min.js`;
			}
			if (!tmpOptions.LazyLoadReactVendorURL)
			{
				tmpOptions.LazyLoadReactVendorURL = `${tmpVendorPath}/react-vendor.min.js`;
			}
		}
		else
		{
			// IFRAME re-seeding. Reopening a saved diagram has to parse the scene back out of the stored
			// SVG, and only the iframe side has the vendor that can do it — the parent's
			// `_extractSceneFromSvg` calls `window.PictSectionExcalidrawVendor`, which is never present in
			// this host (that absence is the whole reason we run in the iframe), so it returns null and
			// the editor opens blank over real content. Hand the raw SVG through as InitialData.svgSource;
			// the iframe host (patched) parses it before mount. `_resolveInitialData` only falls back to
			// InitialData when the AppData scene is empty, which it always is here, so this does not fight
			// the react path. elements:[] is required — an empty array still reads as "no scene yet".
			if (this._isLikelySvg(pValue))
			{
				tmpOptions.InitialData =
				{
					elements: [],
					appState: {},
					files: {},
					svgSource: pValue,
				};
			}
		}
		return tmpOptions;
	}

	/**
	 * An iOS offline form (`window._OfflineMode`) carries no Excalidraw vendor, because the offline capture
	 * keeps only the scripts already on the page, and the iPad app loads that form from a local file even when
	 * online. There, Edit first checks that the editor can load; if it
	 * cannot, the field stays in View with the saved drawing and a note, instead of opening a blank editor.
	 *
	 * @param {string} pInputHash @param {string} pRawHTMLID @param {string} pMode - 'edit' | 'view'
	 */
	setEditorMode(pInputHash, pRawHTMLID, pMode)
	{
		if ((pMode !== 'edit') || (typeof window === 'undefined') || !(/** @type {any} */ (window))._OfflineMode)
		{
			return super.setEditorMode(pInputHash, pRawHTMLID, pMode);
		}
		this._isEditorReachable().then((pReachable) =>
		{
			if (pReachable)
			{
				super.setEditorMode(pInputHash, pRawHTMLID, pMode);
				return;
			}
			this._showEditorUnavailable(pRawHTMLID);
		});
	}

	/**
	 * @return {Promise<boolean>} True when the Excalidraw iframe host page can be fetched right now.
	 */
	_isEditorReachable()
	{
		if ((typeof navigator !== 'undefined') && (navigator.onLine === false))
		{
			return Promise.resolve(false);
		}
		const tmpVendorPath = (this.options && this.options.ExcalidrawVendorPath) || _DEFAULT_VENDOR_PATH;
		let tmpURL;
		try
		{
			tmpURL = new URL(`${tmpVendorPath}/excalidraw-iframe-host.html`, document.baseURI).href;
		}
		catch (pError)
		{
			return Promise.resolve(false);
		}
		const tmpTimeout = new Promise((fResolve) => setTimeout(() => fResolve(false), _EDITOR_REACHABLE_TIMEOUT_MS));
		// The reports service answers a missing asset with 200 and a JSON body, so a JSON reply is a miss.
		const tmpProbe = fetch(tmpURL, { cache: 'no-store' }).then(
			(pResponse) => pResponse.ok && !(pResponse.headers.get('content-type') || '').includes('json'),
			() => false);
		return Promise.race([ tmpProbe, tmpTimeout ]);
	}

	/**
	 * @param {string} pRawHTMLID
	 */
	_showEditorUnavailable(pRawHTMLID)
	{
		const tmpSlot = document.getElementById(this.getContentDisplayHTMLID(pRawHTMLID));
		if (!tmpSlot || tmpSlot.querySelector(`.${_UNAVAILABLE_NOTICE_CLASS}`))
		{
			return;
		}
		const tmpNotice = document.createElement('p');
		tmpNotice.className = `help is-warning ${_UNAVAILABLE_NOTICE_CLASS}`;
		tmpNotice.textContent = 'Drawings can\'t be edited in the iPad app yet. The saved drawing is unchanged.';
		tmpSlot.appendChild(tmpNotice);
	}
}

// NOTE: there is deliberately no "wipe guard" here. An earlier version refused to let a blank export
// overwrite a diagram whose scene could not be re-seeded, paired with a Clear button. Both were removed
// 2026-07-22 (Doug's call): with the export + re-seed fixes in place, a real Excalidraw diagram always
// carries an embedded scene and re-opens with its content, so open→close preserves it on its own. The
// only unseedable values left are hand-authored placeholder SVGs (the examples) — and treating an
// intentional blank (Excalidraw's nav-menu "reset the canvas") as a value worth keeping is the behavior
// Doug wants: what the editor shows on close is what saves, blank included.

module.exports = PictProviderInputTypeDiagram;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-EditorBase.js":71,"pict-section-form":587}],70:[function(require,module,exports){
/**
 * Headlight presentation styling for the Diagram / RichText editor input types.
 *
 * This is the WRAPPER chrome plus the small typography gaps PSF's view CSS leaves — the controls row,
 * the View/Edit segmented switch, rendered-markdown headings/lists, the single-segment editor, and the
 * print-theme border. The editors' own internals (Excalidraw, the markdown editor) self-register their
 * CSS; this only fills what the wrapper needs and what the app reset strips.
 *
 * NOTE: this whole module is a JS template literal — NEVER put a backtick in these comments, it
 * terminates the string and the module stops parsing (there is a test asserting no backticks).
 */
module.exports = /*css*/`
.pict-editor-controls
{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
}

/* is-small controls; align-items:center keeps them the same height, margin-bottom:0 undoes Bulma's
   .button spacing so the row height is exactly the button height. */
.pict-editor-controls .button
{
	margin-bottom: 0;
}

/* The View/Edit segmented switch. Both segments ship as is-link is-soft (soft, inactive look); the
   ACTIVE one is promoted to solid link here. The .button in the selector lifts specificity above
   Bulma's own .button.is-link.is-soft so the solid fill wins without !important. */
.pict-editor-switch
{
	margin-bottom: 0;
}
.pict-editor:not(.is-editing) .button.pict-editor-switch-view,
.pict-editor.is-editing .button.pict-editor-switch-edit
{
	background-color: var(--bulma-link, #485fc7);
	border-color: var(--bulma-link, #485fc7);
	color: var(--bulma-link-invert, #ffffff);
	z-index: 1;
}

/* --- Rendered-markdown typography (RichText view) ------------------------------------------------
   PSF's view CSS gives headings a color and margin but NO font-size, and does not touch lists at all,
   so the app's reset flattens h1..h6 to body size and strips bullets (verified: h1 rendered at 15px /
   weight 400, ul at list-style:none / padding:0). Restore a plain prose scale, scoped to the view. */
.pict-section-form-richtext-view h1 { font-size: 1.6em; font-weight: 700; }
.pict-section-form-richtext-view h2 { font-size: 1.35em; font-weight: 700; }
.pict-section-form-richtext-view h3 { font-size: 1.15em; font-weight: 700; }
.pict-section-form-richtext-view h4 { font-size: 1em; font-weight: 700; }
.pict-section-form-richtext-view h5 { font-size: 0.9em; font-weight: 700; }
.pict-section-form-richtext-view h6 { font-size: 0.85em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; }
.pict-section-form-richtext-view ul,
.pict-section-form-richtext-view ol
{
	margin: 0.5em 0;
	padding-left: 1.5em;
}
.pict-section-form-richtext-view ul { list-style: disc outside; }
.pict-section-form-richtext-view ol { list-style: decimal outside; }
.pict-section-form-richtext-view li { margin: 0.15em 0; display: list-item; }

/* Single segment per field: PSF's provider only ever serialises one segment (its onContentChange
   writes the changed segment over the whole value), but the markdown editor still renders an
   "Add Segment" button. Hide it so the UI matches the model — extra segments only ever got dropped. */
.pict-section-form-richtext .pict-mde-add-segment
{
	display: none;
}

/* Remarks are text-only: PSF rejects the upload unless the descriptor sets RichText.AllowImages, and the
   hardened renderer drops the data: URI the editor would inline. Hide the Insert Image button to match. */
.pict-section-form-richtext .pict-mde-sidebar-btn-image
{
	display: none;
}

/* Print/PDF theme: drop the view's outline so the exported document reads as content, not a form
   field. Read keeps the border on purpose (an on-screen boundary). Scoped to the print container class
   the template adds only for the Print theme. */
.pict-editor-print .pict-section-form-diagram,
.pict-editor-print .pict-section-form-richtext
{
	border: 0;
	border-radius: 0;
}
`;

},{}],71:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

// Shared Headlight behavior for the pict-section-form complex-editor input types (Diagram, RichText).
//
// PSF ships these editors booting in VIEW mode with no edit affordance — the host must drive setMode.
// The Diagram and RichText providers are structurally identical (same setMode/getMode/commit API, same
// _instances-keyed-by-Hash, same #DISPLAY-FOR-{RawHTMLID} slot), differing only in their base class and
// provider identifier, so this factory adds the Headlight presentation behavior once and both providers
// reuse it. The presentation is a single inline one: the field edits in place, and a View/Edit segmented
// switch (setEditorMode) flips between the static view and the live editor, toggling the `is-editing`
// class the CSS keys off. Switching to View commits first (a final synchronous export so a quick
// edit-then-View does not drop the last change).
//
// The field opens and closes through that switch ON PURPOSE. Closing is the commit point, so an
// "always editing" presentation would be a field with no moment at which its value is known to be
// exported — that mode was considered and dropped rather than carry an unreliable save path. (A
// floating "Compact" modal presentation also existed and was removed 2026-07-22: the inline editor
// carries its own toolbar, so the modal added bug surface — backdrop, centering, scroll containment,
// preview sizing — without a need it earned.)
//
// Tabular is intentionally unsupported — the PSF base throws in onInputInitializeTabular (N editors per
// row is a performance landmine), so these types are Standard/Vertical (and RecordSet-as-Tabular) only.

const libEditorCSS = require('./PictProvider-InputType-Editor-CSS.js');

/**
 * Build a Headlight subclass of a PSF complex-editor input provider.
 *
 * @param {any} pBaseClass - The PSF provider class (DiagramInput / RichTextInput).
 * @param {Record<string, any>} pDefaultConfiguration - Provider configuration (ProviderIdentifier etc.).
 * @return {any} The Headlight subclass.
 */
function buildEditorInputProvider(pBaseClass, pDefaultConfiguration)
{
	class HeadlightEditorInput extends pBaseClass
	{
		/**
		 * @param {import('fable')} pFable @param {Record<string, any>} [pOptions] @param {string} [pServiceHash]
		 */
		constructor(pFable, pOptions, pServiceHash)
		{
			super(pFable, Object.assign({}, pDefaultConfiguration, pOptions), pServiceHash);
			/** @type {Pict} */
			this.pict;
		}

		/**
		 * The id of the Headlight presentation container the templates wrap the field in. The PSF base
		 * only toggles mode classes on the hidden input / display slot, so the View/Edit switch needs its
		 * own container hook (the `is-editing` class), which this owns.
		 * @param {string} pRawHTMLID @return {string}
		 */
		getEditorContainerID(pRawHTMLID)
		{
			return `PICT-EDITOR-FOR-${pRawHTMLID}`;
		}

		/**
		 * Reflect edit/view state on the presentation container so the switch highlight and the
		 * view/editor swap respond in CSS.
		 * @param {string} pRawHTMLID @param {string} pMode - 'edit' | 'view'
		 */
		_reflectEditorState(pRawHTMLID, pMode)
		{
			if (typeof document === 'undefined')
			{
				return;
			}
			const tmpContainer = document.getElementById(this.getEditorContainerID(pRawHTMLID));
			if (tmpContainer && tmpContainer.classList)
			{
				tmpContainer.classList.toggle('is-editing', pMode === 'edit');
			}
		}

		/** One-time registration of the Headlight wrapper CSS (the PSF provider injects its own editor CSS separately). */
		_injectEditorCSS()
		{
			if (this._editorCSSInjected || !this.pict || !this.pict.CSSMap || (typeof this.pict.CSSMap.addCSS !== 'function'))
			{
				return;
			}
			this._editorCSSInjected = true;
			this.pict.CSSMap.addCSS('Headlight-Editor-Inputs', libEditorCSS, 500);
			if (typeof this.pict.CSSMap.injectCSS === 'function')
			{
				this.pict.CSSMap.injectCSS();
			}
		}

		onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
		{
			this._injectEditorCSS();
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}

		/**
		 * While an editor is OPEN, never let a marshal push content back into it — the open editor is
		 * the authority on its own content.
		 *
		 * Upstream, both PSF providers treat edit mode as "hot-replace what the user is working on":
		 * RichText re-renders its view (which destroys and rebuilds the CodeMirror EditorView) and
		 * Diagram calls setScene() on the live canvas. That fires on the field's OWN export, so every
		 * keystroke / tool click loops:
		 *     editor change -> _writeHiddenInputValue dispatches 'change' -> form marshals every section
		 *     -> onDataMarshalToForm hits this still-open editor -> it replaces itself mid-edit.
		 * Symptoms were RichText losing focus on the first keypress (unusable) and the Diagram canvas
		 * blanking on any tool click — the marshaled value there is the descriptor's hand-written
		 * placeholder SVG, which carries no embedded Excalidraw scene, so the replacement scene is empty.
		 *
		 * Skipping is safe in both directions: the echo case is a value the editor just produced, and a
		 * genuine external write (a solver) would be hostile mid-edit anyway — it would silently discard
		 * what the user is typing. Closing the editor commits, so the user's content wins on the way out.
		 * View mode still delegates, because re-mounting the static view from a new value IS correct.
		 * The base InputExtension.onDataMarshalToForm is a `return true` no-op, so returning true here
		 * matches the contract exactly.
		 *
		 * @param {Object} pView @param {Object} pGroup @param {Object} pRow @param {Object} pInput
		 * @param {any} pValue @param {string} pHTMLSelector @param {string} pTransactionGUID
		 * @return {any}
		 */
		onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
		{
			const tmpInstance = (this._instances && pInput) ? this._instances[pInput.Hash] : null;
			if (tmpInstance && (tmpInstance.mode === 'edit'))
			{
				return true;
			}
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}

		/**
		 * Defer the per-keystroke whole-form marshal to the View (accept) step.
		 *
		 * PSF writes the editor's value into the hidden <input> on every keystroke (RichText) / scene
		 * change (Diagram), and each write dispatches a 'change' that runs the form's WHOLE-form marshal —
		 * every section re-marshals on every keystroke (other providers' onDataMarshalToForm all fire; it
		 * shows up as their console logs and is pure overhead for a display field nothing else reads live).
		 * The value write is cheap and worth keeping (the hidden input stays current and informary-bound,
		 * so a save that re-reads fields still sees the latest); the 'change' DISPATCH is the expensive
		 * part. So while a field is being edited we keep the value write but SUPPRESS the dispatch. The one
		 * marshal then fires on toggle to View — the natural "accept" point before a document save (see
		 * setEditorMode → _flushMarshal). Diagram's OnChange is already throttled (150ms); this collapses
		 * both editors to a single marshal per edit session.
		 * @param {string} pInputHTMLID @param {any} pValue @return {boolean}
		 */
		_writeHiddenInputValue(pInputHTMLID, pValue)
		{
			if ((typeof document !== 'undefined') && this._isEditingRawHTMLID(pInputHTMLID))
			{
				const tmpElement = /** @type {HTMLInputElement} */ (document.getElementById(pInputHTMLID));
				if (!tmpElement)
				{
					return false;
				}
				// Keep the bound value current, but do NOT dispatch 'change' — the marshal waits for View.
				tmpElement.value = (pValue == null) ? '' : String(pValue);
				return true;
			}
			return super._writeHiddenInputValue(pInputHTMLID, pValue);
		}

		/**
		 * @param {string} pRawHTMLID @return {boolean} True if an instance with this RawHTMLID is editing.
		 */
		_isEditingRawHTMLID(pRawHTMLID)
		{
			if (!this._instances)
			{
				return false;
			}
			for (const tmpHash of Object.keys(this._instances))
			{
				const tmpInstance = this._instances[tmpHash];
				if (tmpInstance && (tmpInstance.mode === 'edit') && tmpInstance.input && tmpInstance.input.Macro &&
					(tmpInstance.input.Macro.RawHTMLID === pRawHTMLID))
				{
					return true;
				}
			}
			return false;
		}

		/**
		 * Dispatch one 'change' on the hidden input so its (already-current) value marshals a single time.
		 * Used both on View and at save time. The value is already in the bound hidden input; the 'change'
		 * makes the form read it into FormData (and propagate). The onDataMarshalToForm guard keeps this
		 * from disturbing a still-open editor.
		 * @param {string} pRawHTMLID
		 */
		/**
		 * The open editor's own latest content, for providers that track it; undefined when they don't.
		 * RichText overrides this (PSF keeps it as `lastValue` on every keystroke). Diagram does not: its
		 * value comes from a forced export at commit, so re-asserting a remembered value could clobber it.
		 * @param {Record<string, any>} pInstance @return {string|undefined}
		 */
		_getOpenEditorValue(pInstance)
		{
			return undefined;
		}

		/**
		 * Put an open editor's own content back into its hidden input before that input is flushed.
		 *
		 * The hidden input is the only place a typed value lives until it marshals, and the form writes
		 * FormData back into EVERY input on a whole-form marshal -- the provider's onDataMarshalToForm skip
		 * above cannot stop that. So with two editors open, the first one's flush reset the second one's
		 * hidden input to its stale saved value, and the second flush then saved the stale value: every
		 * open remark but one was lost on Save (Matt, LADOTD F&E forms, 2026-09-24).
		 * @param {Record<string, any>} pInstance
		 */
		_reassertHiddenInputValue(pInstance)
		{
			const tmpValue = this._getOpenEditorValue(pInstance);
			if ((typeof tmpValue !== 'string') || (typeof document === 'undefined') || !pInstance || !pInstance.input || !pInstance.input.Macro)
			{
				return;
			}
			const tmpElement = /** @type {HTMLInputElement} */ (document.getElementById(pInstance.input.Macro.RawHTMLID));
			if (tmpElement)
			{
				tmpElement.value = tmpValue;
			}
		}

		_flushMarshal(pRawHTMLID)
		{
			if (typeof document === 'undefined')
			{
				return;
			}
			const tmpElement = document.getElementById(pRawHTMLID);
			if (tmpElement && (typeof tmpElement.dispatchEvent === 'function'))
			{
				try
				{
					tmpElement.dispatchEvent(new Event('change', { bubbles: true }));
				}
				catch (pError)
				{
					// jsdom-in-test sometimes lacks the Event constructor; harmless in the browser.
				}
			}
		}

		/**
		 * Save-lifecycle hook — flush any editor still OPEN when the document is saved.
		 *
		 * The per-keystroke marshal is deferred to View (see _writeHiddenInputValue), and the app's save
		 * path reads the in-memory FormData without re-reading the DOM — so a Save fired while an editor is
		 * open would persist the PRE-edit value (the typed value is only in the bound hidden input, not yet
		 * in FormData). Here we flush each open editor first: the value is already in its hidden input, so
		 * one 'change' reads it into FormData before save proceeds. Requires AutoSaveDataWithApp:true in the
		 * provider config, or this hook never runs. Closed editors are already current and are skipped.
		 * @param {(pError?: Error) => void} fCallback
		 */
		onBeforeSaveDataAsync(fCallback)
		{
			if (this._instances)
			{
				for (const tmpHash of Object.keys(this._instances))
				{
					const tmpInstance = this._instances[tmpHash];
					if (tmpInstance && (tmpInstance.mode === 'edit') && tmpInstance.input && tmpInstance.input.Macro)
					{
						// An earlier editor's flush may have reset this one's hidden input -- see above.
						this._reassertHiddenInputValue(tmpInstance);
						this._flushMarshal(tmpInstance.input.Macro.RawHTMLID);
					}
				}
			}
			return super.onBeforeSaveDataAsync(fCallback);
		}

		/**
		 * Move a field to an explicit mode. Driven by the View/Edit segmented switch, where each segment
		 * names its target mode rather than flipping whatever is current.
		 * @param {string} pInputHash @param {string} pRawHTMLID @param {string} pMode - 'edit' | 'view'
		 */
		setEditorMode(pInputHash, pRawHTMLID, pMode)
		{
			if (this.getMode(pInputHash) === pMode)
			{
				return;
			}
			if (pMode === 'view')
			{
				// Commit (Diagram forces a final export; RichText already has the value from keystrokes),
				// drop to view, THEN marshal once. That single flush is the deferred, accept-time marshal
				// of everything done while editing — see _writeHiddenInputValue for why per-keystroke
				// marshals are suppressed. Flushing after setMode means the field is in view mode, so the
				// dispatch is not re-suppressed and onDataMarshalToForm delegates normally.
				this.commit(pInputHash, () =>
				{
					this.setMode(pInputHash, 'view', () =>
					{
						this._reflectEditorState(pRawHTMLID, 'view');
						// Any whole-form marshal while this was open (another editor's View, a picker change)
						// reset its hidden input to the saved value; put the typed content back first.
						this._reassertHiddenInputValue(this._instances ? this._instances[pInputHash] : null);
						this._flushMarshal(pRawHTMLID);
					});
				});
				return;
			}
			this.setMode(pInputHash, 'edit', (pError) =>
			{
				this._reflectEditorState(pRawHTMLID, 'edit');
				if (!pError)
				{
					this._focusEditor(pRawHTMLID);
				}
			});
		}

		/**
		 * Put the caret in a just-opened editor so the user can type without another click. Called only
		 * from the Edit switch, after the editor has rendered, so a remount never steals focus.
		 * @param {string} pRawHTMLID
		 */
		_focusEditor(pRawHTMLID)
		{
		}
	}
	return HeadlightEditorInput;
}

module.exports = { buildEditorInputProvider };

},{"./PictProvider-InputType-Editor-CSS.js":70}],72:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Validates the email address as a possible real email address.
	 * @param {string} pInput - The phone number.
	 * @param {string} pValue - The markdown content.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 */
	validateEmailAddress(pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, pattern.test(pValue));
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRowIndex - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRowIndex, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.validateEmailAddress(pInput, pValue, pHTMLSelector, 0);
		return super.onDataMarshalToForm(pView, pGroup, pRowIndex, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.validateEmailAddress(pInput, pValue, pHTMLSelector, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],73:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getTextInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularTextInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const inputMethod = pRowIndex != null ? 'getTabularTextInputID' : 'getTextInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputTextElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputTextElements || tmpInputTextElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLInputElement} */
		const tmpInputTextElement = tmpInputTextElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, pValue,
			{
				IdentityField: pInput.PictForm.IdentityField || null,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let tmpDisplayTemplate = '';
				if (tmpInputTextElement.tagName === 'DIV')
				{
					const tmpEntityTag = tmpEntity[pInput.PictForm.EntityTag];
					const tmpTaggedName = tmpDisplayName || (`Unnamed ${ pInput.PictForm.Entity } #` + tmpEntity[`ID${ pInput.PictForm.Entity }`]);
					// A configured-but-empty tag paints no badge, rendering exactly as the untagged case
					// below does. An EntityTag naming a field the record does not carry (or carries blank)
					// used to invent an "N/A" pill here that the edit selector never showed, so an author
					// only ever saw it in the PDF. A numeric 0 is a real tag and still badges.
					tmpDisplayTemplate = (tmpEntityTag === undefined || tmpEntityTag === null || tmpEntityTag === '') ?
						tmpTaggedName :
						this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
							tmpEntityTag,
							tmpTaggedName,
							false,
							tmpEntity.EntityTagLast,
						);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ pInput.PictForm.Entity } #` + tmpEntity[`ID${ pInput.PictForm.Entity }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputTextElement, tmpDisplayTemplate);
			}
			else
			{
				this.pict.ContentAssignment.assignContent(tmpInputTextElement, tmpDisplayName);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputTextElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],74:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-DISPLAY-MULTIPLE-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-DISPLAY-MULTIPLE-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-DISPLAY-MULTIPLE-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders the static `...TABULAR-DATA-...` div, not a `...DROPDOWN-...` select2 node.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			if (typeof pValue === 'string')
			{
				pValue = pValue.split(',').map((pVal) => pVal.trim());
			}
			if (Array.isArray(pValue) && pValue.length > 0)
			{
				const tmpDisplayValues = [];
				for (const tmpValue of pValue)
				{
					const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue,
					{
						IdentityField: pInput.PictForm.IdentityField || null,
						JoinEntity: pInput.PictForm.JoinEntity,
						JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
						EntityDisplayField: pInput.PictForm.EntityDisplayField,
						JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
						JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
						EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
					});
					// if we have an EntityTag, display that as a tag along with the Name
					if (pInput.PictForm.EntityTag)
					{
						let tmpDisplayTemplate = '';
						if (tmpInputSelectElement.tagName === 'DIV')
						{
							const tmpEntityTag = tmpEntity[pInput.PictForm.EntityTag];
							const tmpTaggedName = tmpDisplayName || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
							// A configured-but-empty tag paints no badge (per record, so a mixed list still
							// badges the records that have one), rendering as the untagged case below does.
							// This used to invent an "N/A" pill the edit selector never showed. 0 still badges.
							tmpDisplayTemplate = (tmpEntityTag === undefined || tmpEntityTag === null || tmpEntityTag === '') ?
								tmpTaggedName :
								this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
									tmpEntityTag,
									tmpTaggedName,
									true,
									tmpEntity.EntityTagLast,
								);
						}
						else
						{
							tmpDisplayTemplate = tmpValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
						}
						tmpDisplayValues.push(tmpDisplayTemplate);
					}
					else
					{
						tmpDisplayValues.push(tmpDisplayName);
					}
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayValues.join(', '));
				return;
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],75:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} inputID The input id.
	 */
	addLoadingSkeleton(inputID, rawID)
	{
		return;
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${rawID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(inputID)[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(inputID, 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} inputID The input id.
	 */
	removeLoadingSkeleton(inputID, rawID)
	{
		return;
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${rawID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(inputID, 'is-hidden');
	}

	/**
	 * Determines if a word starts with a leading vowel.
	 * @param {string} pWord The word to check.
	 * @returns {boolean} True if the word starts with a vowel, false otherwise.
	 */
	hasLeadingVowel(pWord)
	{
		return [ 'A', 'E', 'I', 'O', 'U' ].includes(pWord.charAt(0).toUpperCase());
	}

	// TODO: we need to handle Project Joins for all entity selectors in a more generic way - this is just a temporary solution for until we can implement that
	localHandleSearchFilters(pFilters, pInput, pRowIndex)
	{
		pFilters = pFilters || [];

		// Project scoping for project-resident entities. Off-switch:
		// PictForm.disableProjectFilteringForEntity.
		const tmpProjectEntityList = [ 'LineItem', 'BidItem' ];
		if (!pInput.PictForm.disableProjectFilteringForEntity &&
			tmpProjectEntityList.includes(pInput.PictForm.Entity))
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID && !pFilters.includes(`FBV~IDProject~EQ~${tmpProjectID}`))
			{
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
		}

		return pFilters;
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput, pRowIndex)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpConfigOptions = {
				Input: pInput,
				SearchFallbackPlaceholder: `Select ${ this.hasLeadingVowel(pInput.PictForm.Entity) ? 'an' : 'a' } ${ pInput.PictForm.Entity }...`,
				ApplySort: true,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				Disabled: pInput.PictForm.Disabled || false,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
				HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput, pRowIndex),
			};
			// Honor IdentityField so the bound value matches what the caller wants to persist
			// (e.g. storing Hash strings, not database IDs). Without this override the
			// select2 ajax pipeline always emits ID${Entity} as the option value.
			if (pInput.PictForm.IdentityField && pInput.PictForm.IdentityField !== `ID${pInput.PictForm.Entity}`)
			{
				const tmpIdentityField = pInput.PictForm.IdentityField;
				tmpConfigOptions.GetRecordID = (pEntity) => pEntity[tmpIdentityField];
			}
			// if an EntityTag is defined, use it to enhance the search and display
			if (pInput.PictForm.EntityTag)
			{
				tmpConfigOptions.GetRecordUserFacingID = (pEntity) => pEntity?.[pInput.PictForm.EntityTag] || 'N/A';
			}
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax(pInput.PictForm.Entity, tmpConfigOptions);
			// tabular vs. non-tabular context
			const methodNameByContext = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).data('select2'))
			{
				window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.addLoadingSkeleton(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue && pValue !== 'null')
		{
			// get the value of the selected Entity and set it as the selected Entity on the data object
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, pValue,
			{
				IdentityField: pInput.PictForm.IdentityField || null,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
				HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput),
			});
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex))[0];
			tmpOption.value = tmpEntity[`ID${ pInput.PictForm.Entity }`];
			tmpOption.text = tmpDisplayName;
			// if the EntityTag is defined and the entity has that property, use it for the leading tag in the selection display
			if (pInput.PictForm.EntityTag && tmpEntity.hasOwnProperty(pInput.PictForm.EntityTag))
			{
				if (pInput.PictForm.EntityTagLast)
				{
					tmpOption.text = `${tmpDisplayName || tmpEntity.Name || (`Unnamed ${pInput.PictForm.Entity} #` + tmpEntity[`ID${ pInput.PictForm.Entity }`])}|~|${tmpEntity[pInput.PictForm.EntityTag] || 'N/A'}`;
				}
				else
				{
					tmpOption.text = `${tmpEntity[pInput.PictForm.EntityTag] || 'N/A'}|~|${tmpDisplayName || tmpEntity.Name || (`Unnamed ${pInput.PictForm.Entity} #` + tmpEntity[`ID${ pInput.PictForm.Entity }`])}`;
				}
			}
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput, pRowIndex);
		this.initializeSelect2(pInput, pRowIndex);
	}

	/**
	 * When the picker is configured as a Sample selector, refresh the
	 * resolver's plan scope from the newly-picked sample. Resolver
	 * dedupes on unchanged project. No-op otherwise. Selectors with a
	 * non-default IdentityField (e.g. GUIDSample) pass that through.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.PictForm?.Entity === 'Sample')
		{
			const tmpIdentityField = pInput.PictForm.IdentityField || 'IDSample';
			this.pict.providers.SpecScopeResolver?.loadForSampleByIdentifier?.(pValue, tmpIdentityField);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Tabular variant of onDataChange. Same gate; same call shape.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm?.Entity === 'Sample')
		{
			const tmpIdentityField = pInput.PictForm.IdentityField || 'IDSample';
			this.pict.providers.SpecScopeResolver?.loadForSampleByIdentifier?.(pValue, tmpIdentityField);
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],76:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#ENTITY-SELECT-MULTIPLE-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-MULTIPLE-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#ENTITY-SELECT-MULTIPLE-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} inputID The input id.
	 */
	addLoadingSkeleton(inputID, rawID)
	{
		return;
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${rawID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(inputID)[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(inputID, 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} inputID The input id.
	 */
	removeLoadingSkeleton(inputID, rawID)
	{
		return;
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${rawID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(inputID, 'is-hidden');
	}

	/**
	 * Determines if a word starts with a leading vowel.
	 * @param {string} pWord The word to check.
	 * @returns {boolean} True if the word starts with a vowel, false otherwise.
	 */
	hasLeadingVowel(pWord)
	{
		return [ 'A', 'E', 'I', 'O', 'U' ].includes(pWord.charAt(0).toUpperCase());
	}

	// TODO: we need to handle Project Joins for all entity selectors in a more generic way - this is just a temporary solution for until we can implement that
	localHandleSearchFilters(pFilters, pInput, pRowIndex)
	{
		pFilters = pFilters || [];

		// Project scoping for project-resident entities. Off-switch:
		// PictForm.disableProjectFilteringForEntity.
		const tmpProjectEntityList = [ 'LineItem', 'BidItem' ];
		if (!pInput.PictForm.disableProjectFilteringForEntity &&
			tmpProjectEntityList.includes(pInput.PictForm.Entity))
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID && !pFilters.includes(`FBV~IDProject~EQ~${tmpProjectID}`))
			{
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
		}

		return pFilters;
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput, pRowIndex)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpConfigOptions = {
				Input: pInput,
				Multiple: true,
				SearchFallbackPlaceholder: `Select ${ this.hasLeadingVowel(pInput.PictForm.Entity) ? 'an' : 'a' } ${ pInput.PictForm.Entity }...`,
				ApplySort: true,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				Disabled: pInput.PictForm.Disabled || false,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
				HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput, pRowIndex),
			};
			// Honor IdentityField so the bound value matches what the caller wants to persist
			// (e.g. storing Hash strings, not database IDs). Without this override the
			// select2 ajax pipeline always emits ID${Entity} as the option value.
			if (pInput.PictForm.IdentityField && pInput.PictForm.IdentityField !== `ID${pInput.PictForm.Entity}`)
			{
				const tmpIdentityField = pInput.PictForm.IdentityField;
				tmpConfigOptions.GetRecordID = (pEntity) => pEntity[tmpIdentityField];
			}
			// if an EntityTag is defined, use it to enhance the search and display
			if (pInput.PictForm.EntityTag)
			{
				tmpConfigOptions.GetRecordUserFacingID = (pEntity) => pEntity?.[pInput.PictForm.EntityTag] || 'N/A';
			}
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax(pInput.PictForm.Entity, tmpConfigOptions);
			// tabular vs. non-tabular context
			const methodNameByContext = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).data('select2'))
			{
				window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.addLoadingSkeleton(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpInputSelectElement = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex))?.[0];
		if (!tmpInputSelectElement)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const tmpValues = pValue && typeof(pValue) === 'string' ? pValue.split(',') : [];
			if (tmpInputSelectElement?.options?.length > 0)
			{
				// for each option that is not in the list, add it as a custom value
				for (let i = 0; i < tmpValues.length; i++)
				{
					let tmpValueSelected = false;
					for (let j = 0; j < tmpInputSelectElement.options.length; j++)
					{
						if (tmpInputSelectElement.options[j].value === tmpValues[i])
						{
							tmpInputSelectElement.options[j].selected = true;
							tmpValueSelected = true;
							break;
						}
					}
					if (!tmpValueSelected)
					{
						const tmpOption = document.createElement('option');
						tmpOption.value = tmpValues[i];
						const { Record: result, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, tmpValues[i],
						{
							Multiple: true,
							IdentityField: pInput.PictForm.IdentityField || null,
							JoinEntity: pInput.PictForm.JoinEntity,
							JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
							JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
							EntityDisplayField: pInput.PictForm.EntityDisplayField,
							JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
							EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
							HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput),
						});
						// if we want to show the EntityTag in the selection display
						if (pInput.PictForm.EntityTag)
						{
							tmpOption.text = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
								result[pInput.PictForm.EntityTag] || 'N/A',
								tmpDisplayName,
								true,
								result.EntityTagLast,
							);
						}
						else
						{
							tmpOption.text = tmpDisplayName;
						}
						tmpOption.selected = true;
						tmpInputSelectElement.appendChild(tmpOption);
					}
				}
			}
			else
			{
				for (let i = 0; i < tmpValues.length; i++)
				{
					const tmpOption = document.createElement('option');
					tmpOption.value = tmpValues[i];
					const { Record: result, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(pInput.PictForm.Entity, tmpValues[i],
					{
						IdentityField: pInput.PictForm.IdentityField || null,
						JoinEntity: pInput.PictForm.JoinEntity,
						JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
						JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
						EntityDisplayField: pInput.PictForm.EntityDisplayField,
						JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
						EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
						HandleSearchFilters: (pFilters) => this.localHandleSearchFilters(pFilters, pInput),
					});
					// if we want to show the EntityTag in the selection display
					if (pInput.PictForm.EntityTag)
					{
						tmpOption.text = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
							result[pInput.PictForm.EntityTag] || 'N/A',
							tmpDisplayName,
							true,
							result.EntityTagLast,
						);
					}
					else
					{
						tmpOption.text = tmpDisplayName;
					}
					tmpOption.selected = true;
					tmpInputSelectElement.appendChild(tmpOption);
				}
			}
		}
		this.removeLoadingSkeleton(pInput, pRowIndex);
		this.initializeSelect2(pInput, pRowIndex);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Special handling for filters inputs, do not remove.
		if (pView.Hash === 'PSRSFilterProxyView')
		{
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.InformaryDataAddress.replace('StringArrayValue', 'Values'), pValue ? pValue.split(',') : []);
		}
		// Plan scope from the picked sample (multi-select case).
		// The resolver is single-project; multi-sample means the project is
		// only well-defined when all picks share one. Best-effort: take the
		// first identifier and warn loudly when there's more than one so a
		// real misconfiguration surfaces in logs. Resolver dedupes when the
		// project hasn't changed.
		if (pInput.PictForm?.Entity === 'Sample' && pValue && this.pict.providers.SpecScopeResolver)
		{
			const tmpIdentifiers = typeof pValue === 'string' ? pValue.split(',').map((v) => v.trim()).filter((v) => v.length > 0) : [];
			if (tmpIdentifiers.length > 1)
			{
				this.pict.log.warn(`EntitySelectorMultiple [${pInput?.Hash}]: multi-sample selection with plan scope active — using the first sample (${tmpIdentifiers[0]}) as the scope source. Picker has ${tmpIdentifiers.length} samples selected.`);
			}
			if (tmpIdentifiers.length > 0)
			{
				const tmpIdentityField = pInput.PictForm.IdentityField || 'IDSample';
				this.pict.providers.SpecScopeResolver.loadForSampleByIdentifier?.(tmpIdentifiers[0], tmpIdentityField);
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],77:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libUserMarkdown = require('./_UserMarkdown.js');

class FileSelectorInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {Object<string, { InputHTMLID: string, IDObservation: any, IsTabular: boolean, RowIndex: any }>} */
		this.observationDisplays = {};
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getControlContainerHTMLID(pInputHTMLID)
	{
		return `#CONTROL-FOR-${pInputHTMLID}`;
	}

	getInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	getFileInputHTMLID(pInputHTMLID)
	{
		return `#FILE-INPUT-FOR-${pInputHTMLID}`;
	}

	getLoadingInputHTMLID(pInputHTMLID)
	{
		return `#LOADING-FOR-${pInputHTMLID}`;
	}

	getTabularControlContainerHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-CONTROL-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DISPLAY-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularFileInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-FILE-INPUT-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularLoadingInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-LOADING-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Hides the loading indicator for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	hideLoadingIndicator(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpLoadingElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularLoadingInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getLoadingInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpLoadingElements) && tmpLoadingElements.length > 0)
		{
			const tmpLoadingElement = tmpLoadingElements[0];
			if (tmpLoadingElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.addClass(tmpLoadingElement, 'is-hidden');
			}
		}
	}

	/**
	 * Shows the loading indicator for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	showLoadingIndicator(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpLoadingElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularLoadingInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getLoadingInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpLoadingElements) && tmpLoadingElements.length > 0)
		{
			const tmpLoadingElement = tmpLoadingElements[0];
			if (tmpLoadingElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.removeClass(tmpLoadingElement, 'is-hidden');
			}
		}
	}

	/**
	 * Hides the entry container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	hideEntryContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpControlContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularControlContainerHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getControlContainerHTMLID(pInputHTMLID));
		if (Array.isArray(tmpControlContainerElements) && tmpControlContainerElements.length > 0)
		{
			const tmpControlContainerElement = tmpControlContainerElements[0];
			if (tmpControlContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.addClass(tmpControlContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * Shows the entry container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	showEntryContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpControlContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularControlContainerHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getControlContainerHTMLID(pInputHTMLID));
		if (Array.isArray(tmpControlContainerElements) && tmpControlContainerElements.length > 0)
		{
			const tmpControlContainerElement = tmpControlContainerElements[0];
			if (tmpControlContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.removeClass(tmpControlContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * Hides the display container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	hideDisplayContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpDisplayContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpDisplayContainerElements) && tmpDisplayContainerElements.length > 0)
		{
			const tmpDisplayContainerElement = tmpDisplayContainerElements[0];
			if (tmpDisplayContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.addClass(tmpDisplayContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * Shows the display container for the given input HTML ID.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	showDisplayContainer(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpDisplayContainerElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpDisplayContainerElements) && tmpDisplayContainerElements.length > 0)
		{
			const tmpDisplayContainerElement = tmpDisplayContainerElements[0];
			if (tmpDisplayContainerElement instanceof HTMLElement)
			{
				this.pict.ContentAssignment.removeClass(tmpDisplayContainerElement, 'is-hidden');
			}
		}
	}

	/**
	 * This function updates the display container for a given input HTML ID with the provided value if the value corresponds to a valid observation.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pValue - the value to set
	 * @param {*} [pResult] - the observation result object (if already known)
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	async updateDisplayContainer(pInputHTMLID, pValue, pResult, isTabular = false, pRowIndex = null)
	{
		const tmpDisplayHTMLID = isTabular ? this.getTabularDisplayInputHTMLID(pInputHTMLID, pRowIndex) : this.getDisplayInputHTMLID(pInputHTMLID);
		const tmpDisplayElements = this.pict.ContentAssignment.getElement(tmpDisplayHTMLID);
		let tmpObservation = pResult;
		// if no value is passed, clear it out and we're done
		if (!pValue)
		{
			delete this.observationDisplays[tmpDisplayHTMLID];
			// find the display element and update it
			if (Array.isArray(tmpDisplayElements) && tmpDisplayElements.length > 0)
			{
				const tmpDisplayElement = tmpDisplayElements[0];
				if (tmpDisplayElement instanceof HTMLElement)
				{
					this.pict.ContentAssignment.assignContent(tmpDisplayElement, '');
					return;
				}
			}
		}
		// look up the observation to get the Name and Description if we don't already have record available
		if (!tmpObservation)
		{
			tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pValue);
		}
		// now build the template for display
		if (tmpObservation)
		{
			this.observationDisplays[tmpDisplayHTMLID] = { InputHTMLID: pInputHTMLID, IDObservation: pValue, IsTabular: isTabular, RowIndex: pRowIndex };
			const tmpName = libUserMarkdown.escapeHTML(tmpObservation.Name || `Unnamed Observation #${pValue}`);
			const tmpFileType = this.pict.providers.ObservationProvider.getObservationFileType(tmpObservation);
			const tmpFileIcon = this.pict.providers.ObservationProvider.returnFileIconFromFileType(tmpFileType);
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			// set the input value to the ID and Name in a predefined format
			let tmpTemplate = '';
			// if we're in interactive mode, add links for rename and delete
			if (this.pict.AppData.Interactive && !this.pict.AppData?.DocumentData?.ReportData?.Locked)
			{
				tmpTemplate = /*HTML*/`
					<span class="tag has-background-text-90 mr-2">
						<span class="pr-1">
							<i class="fa fa-fw ${tmpFileIcon}"></i>
						</span>
						<span class="icon-text">${tmpFileType}</span>
					</span>
					<a class="has-text-text" href="javascript:void(0);" onclick="window._Pict.views.HeadlightPaneObservations.showObservationDetailView(event, ${pValue});">
						<strong class="mr-1">${tmpName}</strong>
					</a>
					<a class="ml-1 has-text-link" href="javascript:void(0);" onclick="window._Pict.providers.FileSelector.handleRenameFile('${pInputHTMLID}', ${pValue}, null, ${isTabular}, ${pRowIndex});" title="Rename File">
						<i class="fa fa-fw fa-edit"></i>
					</a>
					<a class="ml-1 has-text-danger" href="javascript:void(0);" onclick="window._Pict.providers.FileSelector.handleRemoveFile('${pInputHTMLID}', ${isTabular}, ${pRowIndex});" title="Remove File">
						<i class="fa fa-fw fa-times-circle"></i>
					</a>`;
			}
			else
			{
				tmpTemplate = /*HTML*/`
					<span class="tag has-background-text-90 mr-2">
						<span class="pr-1">
							<i class="fa fa-fw ${tmpFileIcon}"></i>
						</span>
						<span class="icon-text">${tmpFileType}</span>
					</span>
					<a href="${ this.pict.providers.UtilityProvider.buildLinksUrl() }/#/project/${ tmpProjectID }/journal/list/observation/${ pValue }" target="_blank" rel="noopener noreferrer">
						<strong class="mr-1">${tmpName}</strong>
					</a>`;
			}
			// find the display element and update it
			if (Array.isArray(tmpDisplayElements) && tmpDisplayElements.length > 0)
			{
				const tmpDisplayElement = tmpDisplayElements[0];
				if (tmpDisplayElement instanceof HTMLElement)
				{
					this.pict.ContentAssignment.assignContent(tmpDisplayElement, tmpTemplate);
				}
			}
		}
	}

	/**
	 * This function opens the observation search panel to allow the user to select an observation to associate with the input.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pViewHash - the hash of the current view
	 * @param {*} pInputHash - the hash of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	openObservationSearchPanel(pInputHTMLID, pViewHash, pInputHash, isTabular = false, pRowIndex = null)
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', async () =>
		{
			// start at the upload tab
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
			const tmpInput = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getInputHTMLID(pInputHTMLID));
			if (!Array.isArray(tmpInput) || tmpInput.length < 1)
			{
				console.warn(`Could not find input element for HTML ID: ${pInputHTMLID}`);
				return;
			}
			const tmpInputName = tmpInput[0] ? tmpInput[0].getAttribute('name') || 'Input Field' : 'Input Field';
			this.pict.views.HeadlightPaneObservations.setObservationPanelTarget(this.pict.views[pViewHash], tmpInput[0], tmpInputName, 'add-to-set');
			/** @type {(observationInfos: Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>) => Promise<void>} */
			this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = async (observationInfos) =>
			{
				// if we have at least one observation, use the first one
				if (Array.isArray(observationInfos) && observationInfos.length > 0)
				{
					const tmpObservationInfo = observationInfos[0];
					if (tmpObservationInfo && tmpObservationInfo.IDObservation)
					{
						// update the hidden input value to the ID of the observation
						this.updateHiddenInputValue(pInputHTMLID, tmpObservationInfo.IDObservation, isTabular, pRowIndex);
						// update the display container with the new observation info
						await this.updateDisplayContainer(pInputHTMLID, tmpObservationInfo.IDObservation, tmpObservationInfo.Observation, isTabular, pRowIndex);
						// show/hide the appropriate containers
						this.hideLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
						this.hideEntryContainer(pInputHTMLID, isTabular, pRowIndex);
						this.showDisplayContainer(pInputHTMLID, isTabular, pRowIndex);
						// close/clear the panel
						this.pict.views.HeadlightPaneObservations.setObservationPanelTarget();
						this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
					}
				}
			};
		});
	}

	/**
	 * This function updates the hidden input value for a given input HTML ID with the provided value.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pValue - the value to set
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	updateHiddenInputValue(pInputHTMLID, pValue, isTabular = false, pRowIndex = null)
	{
		// set the hidden input value to the ID of the observation
		const tmpHiddenElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getInputHTMLID(pInputHTMLID));
		if (Array.isArray(tmpHiddenElements) && tmpHiddenElements.length > 0)
		{
			const tmpHiddenElement = tmpHiddenElements[0];
			if (tmpHiddenElement instanceof HTMLInputElement)
			{
				this.pict.ContentAssignment.setAttribute(tmpHiddenElement, 'value', pValue);
				// trigger change event on the hidden input to notify any listeners
				const event = new Event('change', { bubbles: true });
				tmpHiddenElement.dispatchEvent(event);
			}
		}
	}

	/**
	 * This function handles the renaming of a file associated with a given input HTML ID and observation ID.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {*} pObservationID - the ID of the observation to rename
	 * @param {string|null} pCurrentName - the current name of the observation; null looks it up
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 * @return {Promise<void>}
	 */
	async handleRenameFile(pInputHTMLID, pObservationID, pCurrentName, isTabular = false, pRowIndex = null)
	{
		const tmpCurrentName = (typeof pCurrentName === 'string') ? pCurrentName : await this.getObservationName(pObservationID);
		this.fable.HeadlightModal.spawnModal({
			title: 'Rename Observation',
			modalBodyTemplate: /*HTML*/`
				<div>
					<label class="label" for="FileInputType-Modal-Rename-Field">Observation Name:</label>
					<p class="control is-expanded">
						<input class="input" type="text" id="FileInputType-Modal-Rename-Field" value="${libUserMarkdown.escapeHTML(tmpCurrentName)}" />
					</p>
				</div>
			`,
			confirmText: 'Done',
		}, async () =>
		{
			const newName = document.getElementById('FileInputType-Modal-Rename-Field');
			if (Array.isArray(newName) || !(newName instanceof HTMLInputElement) || !newName.value || newName.value.trim().length < 1 || newName.value.trim() === tmpCurrentName)
			{
				console.info('No change to name, or invalid name provided');
				return;
			}
			let tmpUpdatedObservation = null;
			await this.pict.providers.ObservationProvider.updateObservation({
				IDObservation: pObservationID,
				Name: newName.value.trim(),
			}, (pObservation) =>
			{
				tmpUpdatedObservation = pObservation;
			});
			// update the display container with the new name
			await this.updateDisplayContainer(pInputHTMLID, pObservationID, tmpUpdatedObservation, isTabular, pRowIndex);
		});
	}

	/**
	 * The observation's current name, from the open document's observation list, or read from the server when the
	 * document doesn't list it.
	 * @param {any} pObservationID - the ID of the observation
	 * @return {Promise<string>}
	 */
	async getObservationName(pObservationID)
	{
		const tmpListed = (this.pict.AppData?.DocumentData?.ReportData?.Observations || []).find((pCandidate) => pCandidate && pCandidate.IDObservation == pObservationID);
		const tmpObservation = tmpListed || await this.pict.providers.ObservationProvider.getObservationByID(pObservationID);
		return (tmpObservation && tmpObservation.Name) || '';
	}

	/**
	 * Redraw every File selector field currently showing the given observation, so a change saved elsewhere (the
	 * Observation Details panel, annotations) shows without reopening the form. Called by
	 * ObservationProvider.applyUpdatedObservation.
	 * @param {Object} pObservation - the observation record the server returned
	 * @return {Promise<void>}
	 */
	async refreshObservationDisplays(pObservation)
	{
		if (!pObservation || !pObservation.IDObservation)
		{
			return;
		}
		const tmpRedraws = [];
		for (const tmpDisplayHTMLID of Object.keys(this.observationDisplays))
		{
			const tmpDisplay = this.observationDisplays[tmpDisplayHTMLID];
			if (tmpDisplay.IDObservation != pObservation.IDObservation)
			{
				continue;
			}
			const tmpDisplayElements = this.pict.ContentAssignment.getElement(tmpDisplayHTMLID);
			if (!Array.isArray(tmpDisplayElements) || tmpDisplayElements.length < 1)
			{
				delete this.observationDisplays[tmpDisplayHTMLID];
				continue;
			}
			tmpRedraws.push(this.updateDisplayContainer(tmpDisplay.InputHTMLID, tmpDisplay.IDObservation, pObservation, tmpDisplay.IsTabular, tmpDisplay.RowIndex));
		}
		await Promise.all(tmpRedraws);
	}

	/**
	 * This function handles the removal of a file associated with a given input HTML ID.
	 * @param {*} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 */
	handleRemoveFile(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		// show a confirmation modal
		this.fable.HeadlightModal.spawnModal({
			title: 'Remove File?',
			message: 'Are you sure you want to remove the selected file? This will not delete the underlying observation, but it will disassociate it from this form input field.',
			cancelColor: 'is-danger is-soft',
			confirmColor: 'is-danger',
			confirmText: 'Remove File',
			confirmIcon: 'trash',
		},
		() =>
		{
			// NOTE: we do NOT delete the observation here, just disassociate it from the input field (it's still available in the document's observation list)
			// NOTE: we also do NOT auto-save the document here, as the user may want to make other changes first or change their mind by closing the form...
			this.hideDisplayContainer(pInputHTMLID, isTabular, pRowIndex);
			this.hideLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
			this.showEntryContainer(pInputHTMLID, isTabular, pRowIndex);
			this.updateHiddenInputValue(pInputHTMLID, '', isTabular, pRowIndex);
		});
	}

	/**
	 * This function handles the file selection event for a file input element.
	 * @param {String} pInputHTMLID - the HTML ID of the input element
	 * @param {boolean} [isTabular=false] - whether this is for a tabular input
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 * @returns {Promise<boolean>} - true if successful
	 */
	async handleFileSelection(pInputHTMLID, isTabular = false, pRowIndex = null)
	{
		const tmpInputElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularFileInputHTMLID(pInputHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getFileInputHTMLID(pInputHTMLID));
		if (!Array.isArray(tmpInputElements) || tmpInputElements.length < 1)
		{
			return false;
		}
		const tmpInputElement = tmpInputElements[0];
		if (!(tmpInputElement instanceof HTMLInputElement))
		{
			return false;
		}
		const files = tmpInputElement.files;
		// if we have a file, process it
		if (files && files.length > 0)
		{
			this.hideEntryContainer(pInputHTMLID, isTabular, pRowIndex);
			this.showLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
			const tmpFile = files[0];
			// formatted object to store in the list
			const tmpFileDetails = {
				Name: tmpFile.name, // can be updated by the user - becomes the 'Observation Name'
				FileName: tmpFile.name, // for display purposes only
				File: tmpFile, // the original file object in its entirety
				ObservationType: this.pict.providers.ObservationProvider.returnObservationTypeFromFileType(tmpFile.type), // the type of observation to create
				GUID: this.pict.getUUID(), // a unique identifier for the file
			};
			await new Promise((resolve) =>
			{
				this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(tmpFileDetails, this.AppData?.DocumentData?.ReportData?.IDProject,
				(observationResult) =>
				{
					const observationResultList = [];
					// add the result to the list
					observationResultList.push(observationResult);
					// update the file object with the result so we can use it for the preview replacement
					tmpFileDetails._ObservationResult = observationResult;
					// join to the document, if we have one
					this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument, async () =>
					{
						// add the new observation to the document list (these are 'included' observations)
						const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
						// add result to our document if we have one and it is not already in the observations list
						if (tmpObservations && Array.isArray(tmpObservations) && tmpObservations.findIndex((o) => o.IDObservation === observationResult.IDObservation) < 0)
						{
							tmpObservations.push(observationResult);
						}
						resolve(observationResult);
					});
				});
			});
			// set the hidden input value to the new observation ID
			this.updateHiddenInputValue(pInputHTMLID, tmpFileDetails._ObservationResult.IDObservation, isTabular, pRowIndex);
			// if it's a document, we should auto-save the document now too
			if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				this.pict.providers.DocumentProvider.handleSave(true);
			}
			// update the display container with the new observation details
			await this.updateDisplayContainer(pInputHTMLID, tmpFileDetails._ObservationResult.IDObservation, tmpFileDetails._ObservationResult, isTabular, pRowIndex);
			// show/hide the appropriate containers
			this.hideLoadingIndicator(pInputHTMLID, isTabular, pRowIndex);
			this.hideEntryContainer(pInputHTMLID, isTabular, pRowIndex);
			this.showDisplayContainer(pInputHTMLID, isTabular, pRowIndex);
			// clear out the file input value so we can re-use it if needed
			tmpInputElement.value = '';
			return true;
		}
		// If no file is selected, don't change anything
		return true;
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be set.
	 * @param {boolean} [isTabular=false] - Whether the input is part of a tabular input set.
	 * @param {String|Number} [pRowIndex] - the row index if this is for a tabular input
	 * @returns {Promise<void>}
	 */
	async handleInputValue(pInput, pValue, isTabular = false, pRowIndex)
	{
		const tmpInputElements = isTabular ? this.pict.ContentAssignment.getElement(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex)) : this.pict.ContentAssignment.getElement(this.getInputHTMLID(pInput.Macro.RawHTMLID));
		if (Array.isArray(tmpInputElements) && tmpInputElements.length > 0)
		{
			const tmpInputElement = tmpInputElements[0];
			if (tmpInputElement instanceof HTMLInputElement)
			{
				if (pValue && Number(pValue) !== 0 && !isNaN(Number(pValue)))
				{
					// set the input value to the ID
					this.pict.ContentAssignment.assignContent(tmpInputElement, pValue);
					// immediately hide the upload controls to prevent flicker during async load
					this.hideEntryContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
					this.showLoadingIndicator(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
					// update the display container with the new value
					await this.updateDisplayContainer(pInput.Macro.RawHTMLID, pValue, null, isTabular, pRowIndex);
					this.hideLoadingIndicator(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
					this.showDisplayContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
				}
			}
		}
		else
		{
			this.hideDisplayContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
			this.hideLoadingIndicator(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
			this.showEntryContainer(pInput.Macro.RawHTMLID, isTabular, pRowIndex);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputNumericValue = this.pict.ContentAssignment.readContent(pInput.Macro.RawHTMLID);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputNumericValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputNumericValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = FileSelectorInputHandler;

},{"./_UserMarkdown.js":170,"pict-section-form":587}],78:[function(require,module,exports){
/**
 * Component-owned styling for the Geolocation input types.
 *
 * Everything here is phone-layout work. The desktop presentations are plain Bulma (columns, level,
 * addons) and need no rules of their own; below the tablet breakpoint the full picker's action row
 * and the compact presentation's edit modal both need a different shape than Bulma's defaults give.
 */
module.exports = /*css*/`
/* --- Full picker: phone action row ---------------------------------------------------------
   Bulma's .level.is-mobile keeps the readout and the action buttons on one line. On a phone that
   squeezes the coordinates until they wrap underneath the pin, leaving the marker stranded above
   and centered. Give the readout its own full-width row (pin left, coordinates beside it) and drop
   the buttons to a second row, split evenly the way a mobile action row normally reads. */
@media screen and (max-width: 768px)
{
	.geolocation-input .geo-action-level
	{
		display: block;
	}

	.geolocation-input .geo-action-level .level-left
	{
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: flex-start;
		min-width: 0;
		margin-bottom: 0.5rem;
	}

	.geolocation-input .geo-action-level .level-right
	{
		display: block;
		margin-left: 0;
	}

	/* Deliberately unscoped: geo-action-buttons is our own class, and the same even split is wanted
	   in both places it appears — the inline control's action row and the Edit modal's — for the
	   larger tap targets a phone needs. */
	.geo-action-buttons
	{
		display: flex;
		flex-wrap: nowrap;
		gap: 0.5rem;
	}

	/* Bulma's .buttons spaces children with margins; the flex gap owns spacing here so both
	   buttons can share the row exactly evenly. */
	.geo-action-buttons .button
	{
		flex: 1 1 0;
		min-width: 0;
		margin: 0;
	}
}

/* --- Compact presentation: full-screen edit modal on a phone -------------------------------
   The shared dialog centers itself with a translate and caps at 90vw/90vh, which on a phone leaves
   a cramped card with slivers of page around it — and the map inside wants every pixel. The class
   is added to the dialog element in onOpen, so this only ever reshapes the location editor.
   The .pict-modal-visible selector is included because the visible state re-declares transform. */
@media screen and (max-width: 768px)
{
	.pict-modal-dialog.geolocation-edit-modal,
	.pict-modal-dialog.geolocation-edit-modal.pict-modal-visible
	{
		top: 0;
		left: 0;
		width: 100vw;
		max-width: 100vw;
		height: 100vh;
		height: 100dvh;
		max-height: 100dvh;
		transform: none;
		border: none;
		border-radius: 0;
	}

	.pict-modal-dialog.geolocation-edit-modal .pict-modal-dialog-header
	{
		border-radius: 0;
	}
}
`;

},{}],79:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libGeolocationCSS = require('./PictProvider-InputType-GeolocationSelector-CSS.js');

// Coordinate display precision (decimal degrees) for the combined read-only readout.
const GEO_DISPLAY_PRECISION = 6;
// Fixed key for the transient "edit location" modal instance (only one modal is open at a time).
const GEO_MODAL_KEY = 'GEO-MODAL';
// Wide "no fix yet" default view (continental US) used when opening a map with no value.
const GEO_DEFAULT_CENTER = { Latitude: 39.5, Longitude: -98.35 };

/*
	Geolocation input type (both `GeolocationSelector` and `GeolocationSelectorWithMap`).

	Single control, both single-record and tabular. The map variant adds a full-width Leaflet map with a
	draggable marker + click-to-place + address search; the no-map variant is the same control without the
	map. The value persists as a {Latitude, Longitude} object via two informary-bound number inputs whose
	data-i-datum is suffixed `.Latitude`/`.Longitude`.

	Maps are LAZY-mounted via an IntersectionObserver (mounted only once their container is actually
	visible, then invalidateSize()). This resolves the old "map mis-centers when initialized behind a form
	tab" bug the previous implementation punted on, and is the same trick that makes the modal-hosted map
	work.

	All transient state (address-search results, per-map data) is keyed by the field rawHTMLID, so a form
	may hold many geolocation fields, N tabular rows, and the edit modal at once without collisions.

	A single-record field over a record that keeps its coordinates as two separate columns sets
	PictForm.LatitudeAddress and PictForm.LongitudeAddress (e.g. LocationDetails.Latitude / .Longitude): the two
	inputs then bind to exactly those addresses instead of <address>.Latitude/.Longitude, and are seeded from them.
	A change only marshals the element bound to the field's own address (the form filters by it) and then repaints
	every input from the record, so onDataChange writes both coordinates to their addresses itself.
*/
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// Address-search results, keyed by rawHTMLID (fields + the GEO_MODAL_KEY modal instance).
		this._addressResultsByID = {};
		// Guards onDataChange from re-syncing the map when the change originated from a map gesture or a
		// programmatic commit (only user-typed coordinate edits should move the marker).
		this._suppressMapSync = {};
		// Pending lazy-mount IntersectionObservers, keyed by rawHTMLID, so we can disconnect on teardown.
		this._mapObservers = {};
		// Latest working value for the open modal (read on Save, robust to modal-DOM teardown timing).
		this._modalValue = { Latitude: '', Longitude: '' };
		// Guards the one-time CSS registration.
		this._cssInjected = false;
		// Row identity for full-size tabular/record-set cells, keyed by `<rawHTMLID>-<rowIndex>`. The
		// address search is written against a single instance id, so this is how a result picked in a
		// row finds its way back to the right row commit.
		this._rowContexts = {};
	}

	/** The instance id a tabular/record-set row shares with the address-search DOM helpers. */
	getRowKey(pInputHTMLID, pRowIndex)
	{
		return `${pInputHTMLID}-${pRowIndex}`;
	}

	/** Register the component's phone-layout rules once per app. */
	_injectCSS()
	{
		if (this._cssInjected || !this.pict || !this.pict.CSSMap || (typeof this.pict.CSSMap.addCSS !== 'function'))
		{
			return;
		}
		this._cssInjected = true;
		this.pict.CSSMap.addCSS('Headlight-GeolocationSelector', libGeolocationCSS, 500);
		if (typeof this.pict.CSSMap.injectCSS === 'function')
		{
			this.pict.CSSMap.injectCSS();
		}
	}

	// --- HTML id helpers -----------------------------------------------------------------------------

	getMapContainerHTMLID(pInputHTMLID)
	{
		return `#MAP-CONTAINER-FOR-${pInputHTMLID}`;
	}

	/** Strip the map container/element prefix back to the owning rawHTMLID (or modal key). */
	getMapIDFromContainerID(pContainerID)
	{
		if (!pContainerID)
		{
			return '';
		}
		if (pContainerID.indexOf('MAP-CONTAINER-FOR-') > -1)
		{
			return pContainerID.replace('MAP-CONTAINER-FOR-', '');
		}
		if (pContainerID.indexOf('MAP-FOR-') > -1)
		{
			return pContainerID.replace('MAP-FOR-', '');
		}
		return pContainerID;
	}

	getLatitudeInputHTMLID(pInputHTMLID)
	{
		return `#LATITUDE-FOR-${pInputHTMLID}`;
	}

	getLongitudeInputHTMLID(pInputHTMLID)
	{
		return `#LONGITUDE-FOR-${pInputHTMLID}`;
	}

	getCombinedDisplayID(pInputHTMLID)
	{
		return `#GEO-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getAddressResultsID(pInputHTMLID)
	{
		return `GEO-ADDRESS-RESULTS-${pInputHTMLID}`;
	}

	getAddressInputID(pInputHTMLID)
	{
		return `GEO-ADDRESS-INPUT-${pInputHTMLID}`;
	}

	getTabularLatitudeInputID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-LAT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularLongitudeInputID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-LONG-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDisplayID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-DISPLAY-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * The full-size row presentation's visible coordinate editors. These are NOT informary-bound —
	 * the hidden Begin-partial inputs remain the only binding — so they are kept in sync from the
	 * value and commit back through the row methods.
	 */
	getRowEditorLatitudeID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-RS-LAT-${pInputHTMLID}-${pRowIndex}`;
	}

	getRowEditorLongitudeID(pInputHTMLID, pRowIndex)
	{
		return `#GEO-RS-LONG-${pInputHTMLID}-${pRowIndex}`;
	}

	// --- DOM value get/set (loosely typed — these are always <input> elements found by id/selector) ---

	/**
	 * @param {any} pElement
	 * @return {string}
	 */
	_domValue(pElement)
	{
		return (pElement && pElement.value != null) ? String(pElement.value) : '';
	}

	/**
	 * @param {any} pElement
	 * @param {any} pValue
	 */
	_setDomValue(pElement, pValue)
	{
		if (pElement)
		{
			pElement.value = (pValue === '' || pValue == null) ? '' : String(pValue);
		}
	}

	// --- Value coercion / formatting -----------------------------------------------------------------

	/**
	 * Normalize any stored representation to a { Latitude, Longitude } pair. Accepts the canonical object,
	 * a legacy JSON string ({"Latitude":..,"Longitude":..} — the old WithMap serialization), or empty.
	 * @param {any} pValue
	 * @return {{ Latitude: (string|number), Longitude: (string|number) }}
	 */
	_coerceLatLong(pValue)
	{
		if (pValue == null || pValue === '' || pValue === 'null')
		{
			return { Latitude: '', Longitude: '' };
		}
		if (typeof pValue === 'object')
		{
			return { Latitude: pValue.Latitude != null ? pValue.Latitude : '', Longitude: pValue.Longitude != null ? pValue.Longitude : '' };
		}
		if (typeof pValue === 'string')
		{
			try
			{
				const tmpParsed = JSON.parse(pValue);
				if (tmpParsed && typeof tmpParsed === 'object')
				{
					return { Latitude: tmpParsed.Latitude != null ? tmpParsed.Latitude : '', Longitude: tmpParsed.Longitude != null ? tmpParsed.Longitude : '' };
				}
			}
			catch (pError)
			{/* not JSON — fall through to empty */}
		}
		return { Latitude: '', Longitude: '' };
	}

	/**
	 * @param {Object} pInput
	 * @return {{ Latitude: string, Longitude: string }|null} the record addresses the coordinates bind to, when the
	 *     field names them (PictForm.LatitudeAddress / LongitudeAddress); null for the { Latitude, Longitude } value
	 */
	_coordinateAddresses(pInput)
	{
		const tmpForm = (pInput && pInput.PictForm) || {};
		if ((typeof tmpForm.LatitudeAddress === 'string') && tmpForm.LatitudeAddress && (typeof tmpForm.LongitudeAddress === 'string') && tmpForm.LongitudeAddress)
		{
			return { Latitude: tmpForm.LatitudeAddress, Longitude: tmpForm.LongitudeAddress };
		}
		return null;
	}

	/**
	 * The field's current coordinates: read from the record at the named addresses, or coerced from its value.
	 *
	 * @param {Object} pView - the form view
	 * @param {Object} pInput
	 * @param {any} pValue - the value at the field's own address
	 * @return {{ Latitude: any, Longitude: any }} '' for a coordinate that is not set
	 */
	_seedFor(pView, pInput, pValue)
	{
		const tmpAddresses = this._coordinateAddresses(pInput);
		if (!tmpAddresses || !pView || (typeof pView.getMarshalDestinationObject !== 'function'))
		{
			return this._coerceLatLong(pValue);
		}
		const tmpRecord = pView.getMarshalDestinationObject();
		const tmpLat = this.pict.manifest.getValueAtAddress(tmpRecord, tmpAddresses.Latitude);
		const tmpLng = this.pict.manifest.getValueAtAddress(tmpRecord, tmpAddresses.Longitude);
		return { Latitude: (tmpLat == null) ? '' : tmpLat, Longitude: (tmpLng == null) ? '' : tmpLng };
	}

	/**
	 * With named addresses, write both coordinate inputs to their record addresses. The form's change handling only
	 * marshals the element bound to the field's own address and then repaints every input from the record, so
	 * without this the other coordinate is overwritten with its stored value.
	 *
	 * @param {Object} pView - the form view
	 * @param {Object} pInput
	 */
	_writeNamedCoordinates(pView, pInput)
	{
		const tmpAddresses = this._coordinateAddresses(pInput);
		if (!tmpAddresses || !pView || (typeof pView.getMarshalDestinationObject !== 'function'))
		{
			return;
		}
		const tmpRecord = pView.getMarshalDestinationObject();
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			this.pict.manifest.setValueAtAddress(tmpRecord, tmpAddresses.Latitude, tmpLat.val());
		}
		if (tmpLong.length)
		{
			this.pict.manifest.setValueAtAddress(tmpRecord, tmpAddresses.Longitude, tmpLong.val());
		}
	}

	/** True when both coordinates are present, numeric, and within valid lat/long ranges. */
	_inRange(pLatitude, pLongitude)
	{
		if (pLatitude === '' || pLongitude === '' || pLatitude == null || pLongitude == null)
		{
			return false;
		}
		const tmpLat = Number(pLatitude);
		const tmpLng = Number(pLongitude);
		return Number.isFinite(tmpLat) && Number.isFinite(tmpLng) && (tmpLat >= -90) && (tmpLat <= 90) && (tmpLng >= -180) && (tmpLng <= 180);
	}

	/** Format the combined readout string, or the empty-state placeholder. */
	formatLocationDisplay(pLatitude, pLongitude)
	{
		if (!this._inRange(pLatitude, pLongitude))
		{
			return 'No location set';
		}
		return `${Number(pLatitude).toFixed(GEO_DISPLAY_PRECISION)}, ${Number(pLongitude).toFixed(GEO_DISPLAY_PRECISION)}`;
	}

	/** Repaint the single-record combined readout from the current lat/long inputs. No-op if absent. */
	refreshCombinedDisplay(pInputHTMLID)
	{
		if (!document.querySelector(this.getCombinedDisplayID(pInputHTMLID)))
		{
			return;
		}
		const tmpLat = $(this.getLatitudeInputHTMLID(pInputHTMLID)).val();
		const tmpLng = $(this.getLongitudeInputHTMLID(pInputHTMLID)).val();
		this.pict.ContentAssignment.assignContent(this.getCombinedDisplayID(pInputHTMLID), this.formatLocationDisplay(tmpLat, tmpLng));
	}

	/**
	 * Print/PDF only: populate the static map <img> from the value via the Google Static Maps helper. A
	 * single image (which the PDF renderer waits for) fills its container reliably, unlike a live Leaflet
	 * map whose raster tiles get sized to the narrower init width and leave the frame's right edge blank.
	 * No-op when the img is absent (Edit/Read themes render a live map instead) or the value is empty.
	 * @param {string} pInputHTMLID
	 * @param {{ Latitude: (string|number), Longitude: (string|number) }} pSeed
	 */
	_refreshStaticMapImage(pInputHTMLID, pSeed)
	{
		this._paintStaticMapImg(document.getElementById(`MAP-IMG-FOR-${pInputHTMLID}`), pSeed);
	}

	/** Build the Google Static Maps URL for a value (framed at neighborhood zoom), or '' when empty. */
	_staticMapURL(pSeed)
	{
		const tmpUtility = this.pict.providers.UtilityProvider;
		if (!pSeed || !this._inRange(pSeed.Latitude, pSeed.Longitude) || !tmpUtility || (typeof tmpUtility.getGoogleMapURLFromEntityRecord !== 'function'))
		{
			return '';
		}
		let tmpURL = tmpUtility.getGoogleMapURLFromEntityRecord(
			{ Latitude: pSeed.Latitude, Longitude: pSeed.Longitude },
			{ size: '640x360', scale: 2, markerColor: 'blue' });
		// The helper emits only a marker (no center/zoom → Google auto-fits a single point oddly); frame it
		// on the point at a neighborhood zoom to match the live map.
		if (tmpURL)
		{
			tmpURL += `&zoom=14&center=${encodeURIComponent(`${pSeed.Latitude},${pSeed.Longitude}`)}`;
		}
		return tmpURL;
	}

	/** Paint a static-map <img>: set src + show, or clear + hide when there's no URL. No-op if absent. */
	_paintStaticMapImg(pImgEl, pSeed)
	{
		if (!pImgEl)
		{
			return;
		}
		const tmpURL = this._staticMapURL(pSeed);
		if (tmpURL)
		{
			pImgEl.setAttribute('src', tmpURL);
			pImgEl.style.display = 'block';
		}
		else
		{
			pImgEl.removeAttribute('src');
			pImgEl.style.display = 'none';
		}
	}

	/** Print/PDF only: static map image for one record-set record (the Print theme's map host is an <img>). */
	_refreshRecordSetRowStaticImage(pInput, pRowIndex, pSeed)
	{
		this._paintStaticMapImg(document.getElementById(`GEO-RS-MAPIMG-FOR-${pInput.Macro.RawHTMLID}-${pRowIndex}`), pSeed);
	}

	_toast(pMessage, pType)
	{
		if (this.pict.views.HeadLightPanels && (typeof this.pict.views.HeadLightPanels.toast === 'function'))
		{
			this.pict.views.HeadLightPanels.toast({ message: pMessage, type: pType || 'is-info' });
		}
	}

	// --- Single-record lifecycle ---------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._injectCSS();
		const tmpHideMap = pInput.PictForm.InputType !== 'GeolocationSelectorWithMap';
		pView.options.hideLeafletMap = tmpHideMap;

		const rawHTMLID = pInput.Macro.RawHTMLID;
		// Bind the two number inputs to the .Latitude/.Longitude sub-addresses so the datum marshals as a
		// { Latitude, Longitude } object (the canonical shape for both variants).
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		const tmpAddresses = this._coordinateAddresses(pInput);
		if (tmpAddresses)
		{
			// Bound straight to the record's own coordinate columns.
			if (tmpLat.length && tmpLat.data('iDatum'))
			{
				tmpLat.attr('data-i-datum', tmpAddresses.Latitude);
			}
			if (tmpLong.length && tmpLong.data('iDatum'))
			{
				tmpLong.attr('data-i-datum', tmpAddresses.Longitude);
			}
		}
		else
		{
			if (tmpLat.length && tmpLat.data('iDatum'))
			{
				tmpLat.attr('data-i-datum', `${tmpLat.data('iDatum')}.Latitude`);
			}
			if (tmpLong.length && tmpLong.data('iDatum'))
			{
				tmpLong.attr('data-i-datum', `${tmpLong.data('iDatum')}.Longitude`);
			}
		}

		// Seed inputs from the incoming value (covers legacy JSON-string persistence, where informary can't
		// reach the .Latitude/.Longitude sub-addresses of a string base value). With named addresses both inputs
		// started out bound to the field's own address, so they are always reset from the record.
		const tmpSeed = this._seedFor(pView, pInput, pValue);
		if ((tmpSeed.Latitude !== '' && !tmpLat.val()) || tmpAddresses)
		{
			tmpLat.val(tmpSeed.Latitude);
		}
		if ((tmpSeed.Longitude !== '' && !tmpLong.val()) || tmpAddresses)
		{
			tmpLong.val(tmpSeed.Longitude);
		}
		this.refreshCombinedDisplay(rawHTMLID);

		if (!tmpHideMap)
		{
			// Print theme renders a static map image; Edit/Read mount the live Leaflet map. Each no-ops when
			// its target element is absent, so exactly one runs per theme.
			this._refreshStaticMapImage(rawHTMLID, tmpSeed);
			this._observeAndMountMap(rawHTMLID, pInput);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshal a value into the single-record control. Coerces object/legacy-string, repaints the readout,
	 * and (map variant) moves the marker. Populating the inputs here also migrates legacy string data to the
	 * object shape on next save.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const tmpSeed = this._seedFor(pView, pInput, pValue);
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			tmpLat.val(tmpSeed.Latitude === '' ? '' : tmpSeed.Latitude);
		}
		if (tmpLong.length)
		{
			tmpLong.val(tmpSeed.Longitude === '' ? '' : tmpSeed.Longitude);
		}
		this.refreshCombinedDisplay(rawHTMLID);
		this._refreshStaticMapImage(rawHTMLID, tmpSeed);
		// Marshal runs after every tabular row add/delete (marshalFormSections), so this is where a map
		// whose DOM was just regenerated gets re-mounted. No-op when the map is healthy or absent.
		this._observeAndMountMap(rawHTMLID, pInput);
		if (this._inRange(tmpSeed.Latitude, tmpSeed.Longitude))
		{
			this.moveMarkerTo(rawHTMLID, Number(tmpSeed.Latitude), Number(tmpSeed.Longitude));
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const rawHTMLID = pInput.Macro.RawHTMLID;
		this._writeNamedCoordinates(pView, pInput);
		this.refreshCombinedDisplay(rawHTMLID);
		// A user edit of the lat/long fields (not a map gesture / programmatic commit): follow it on the map.
		if (!this._suppressMapSync[rawHTMLID])
		{
			const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID)).val();
			const tmpLng = $(this.getLongitudeInputHTMLID(rawHTMLID)).val();
			if (this._inRange(tmpLat, tmpLng))
			{
				this.moveMarkerTo(rawHTMLID, Number(tmpLat), Number(tmpLng));
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	// --- Map: lazy mount, marker, click/drag/programmatic move ---------------------------------------

	/**
	 * Defer the Leaflet mount until the map container is actually visible (fixes the behind-a-tab
	 * mis-centering), then invalidateSize(). Falls back to an immediate mount where IntersectionObserver
	 * is unavailable.
	 */
	_observeAndMountMap(rawHTMLID, pInput)
	{
		const tmpContainer = (typeof document !== 'undefined') ? document.getElementById(`MAP-CONTAINER-FOR-${rawHTMLID}`) : null;
		if (!tmpContainer)
		{
			return;
		}
		// Keep an existing map ONLY if its container is still in the live DOM inside the current container.
		// A re-render (e.g. a tabular row add/delete calls pView.render(), which also regenerates this
		// field's DOM) swaps in a fresh empty container and detaches the old map — so a plain "map already
		// exists" guard would leave the map gone for good. Detect the stale map, tear it down, and re-mount.
		const tmpExisting = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpExisting && tmpExisting.map)
		{
			const tmpMapEl = (typeof tmpExisting.map.getContainer === 'function') ? tmpExisting.map.getContainer() : null;
			if (tmpMapEl && document.body.contains(tmpMapEl) && tmpContainer.contains(tmpMapEl))
			{
				return;
			}
			try
			{
 tmpExisting.map.remove();
			}
			catch (pError)
			{/* already detached */}
			delete this.pict.AppData.LeafletMapsData[rawHTMLID];
		}
		// A prior observer may still be watching the old (detached) container — retire it before re-observing.
		if (this._mapObservers[rawHTMLID])
		{
			this._mapObservers[rawHTMLID].disconnect();
			delete this._mapObservers[rawHTMLID];
		}
		const tmpMount = () =>
		{
			if (this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID] && this.pict.AppData.LeafletMapsData[rawHTMLID].map)
			{
				return;
			}
			this.initializeLeafletMap(rawHTMLID, pInput);
			const tmpMapData = this.pict.AppData.LeafletMapsData[rawHTMLID];
			if (tmpMapData && tmpMapData.map)
			{
				setTimeout(() =>
				{
					try
					{
 tmpMapData.map.invalidateSize();
					}
					catch (pError)
					{/* container detached */}
				}, 60);
			}
		};
		if (typeof IntersectionObserver === 'undefined')
		{
			tmpMount();
			return;
		}
		const tmpObserver = new IntersectionObserver((pEntries) =>
		{
			for (let i = 0; i < pEntries.length; i++)
			{
				if (pEntries[i].isIntersecting)
				{
					tmpObserver.disconnect();
					delete this._mapObservers[rawHTMLID];
					tmpMount();
					return;
				}
			}
		});
		this._mapObservers[rawHTMLID] = tmpObserver;
		tmpObserver.observe(tmpContainer);

		// Fallback for environments where the observer callback may not fire in time (e.g. a headless PDF
		// render that never scrolls): if the container is already visible shortly after init and still
		// unmounted, mount eagerly. A container hidden behind a tab has offsetParent === null, so it stays
		// deferred to the observer.
		setTimeout(() =>
		{
			if (this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID] && this.pict.AppData.LeafletMapsData[rawHTMLID].map)
			{
				return;
			}
			if (tmpContainer.offsetParent !== null)
			{
				if (this._mapObservers[rawHTMLID])
				{
					this._mapObservers[rawHTMLID].disconnect();
					delete this._mapObservers[rawHTMLID];
				}
				tmpMount();
			}
		}, 250);
	}

	/**
	 * Render the shared Leaflet view into this field's map container, seed the marker from the current
	 * lat/long, and wire click-to-place (unless the inputs are locked/read-only).
	 */
	initializeLeafletMap(rawHTMLID, pInput)
	{
		this.pict.views.GeolocationSelector.rawHTMLID = rawHTMLID;
		this.pict.views.GeolocationSelector.render('GeolocationSelector', this.getMapContainerHTMLID(rawHTMLID), pInput);

		const tmpMapData = this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (!tmpMapData || !tmpMapData.map)
		{
			return;
		}
		const tmpMap = tmpMapData.map;

		// Seed from the (now marshaled) input values.
		const tmpLatVal = $(this.getLatitudeInputHTMLID(rawHTMLID)).val();
		const tmpLngVal = $(this.getLongitudeInputHTMLID(rawHTMLID)).val();
		if (this._inRange(tmpLatVal, tmpLngVal))
		{
			const tmpLat = Number(tmpLatVal);
			const tmpLng = Number(tmpLngVal);
			tmpMapData.marker = this.setLeafletMarker({ lat: tmpLat, lng: tmpLng }, tmpMap, null, rawHTMLID);
			tmpMapData.location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
			tmpMap.setView([ tmpLat, tmpLng ], Math.max(tmpMap.getZoom() || 13, 13));
		}

		// Read theme renders the inputs readonly/aria-readonly; keep the map non-interactive to match.
		const tmpLatInput = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLocked = tmpLatInput.is(':disabled') || tmpLatInput.is('[readonly]') || tmpLatInput.attr('aria-readonly') === 'true';
		if (tmpLocked)
		{
			this.disableMap(tmpMap, tmpMapData.destinationAddress);
		}
		else
		{
			tmpMap.on('click', this.onMapSelectionMade, this);
		}
	}

	disableMap(pMap, pDestinationAddress)
	{
		pMap.dragging.disable();
		pMap.touchZoom.disable();
		pMap.doubleClickZoom.disable();
		pMap.scrollWheelZoom.disable();
		pMap.boxZoom.disable();
		pMap.keyboard.disable();
		// @ts-ignore
		if (pMap.tap) pMap.tap.disable();
		const tmpEl = document.getElementById(pDestinationAddress);
		if (tmpEl)
		{
			tmpEl.style.cursor = 'default';
		}
	}

	/**
	 * Create (draggable) or move a marker. Does NOT recenter the map — callers control the view so a drag
	 * doesn't yank the map out from under the user.
	 */
	setLeafletMarker(pLatLng, pMap, pMarker, pRawHTMLID)
	{
		if (pLatLng.lat == null || pLatLng.lng == null)
		{
			return pMarker;
		}
		const libLeaflet = window.L;
		let tmpMarker = pMarker;
		if (!tmpMarker)
		{
			tmpMarker = libLeaflet.marker(pLatLng, { draggable: true });
			tmpMarker.on('dragend', (pEvent) =>
			{
				const tmpLatLng = pEvent.target.getLatLng();
				// Marker is already where the user dropped it — commit the value without recentering.
				this._commitLatLong(pRawHTMLID, tmpLatLng.lat, tmpLatLng.lng);
			});
		}
		tmpMarker.setLatLng(pLatLng).addTo(pMap);
		return tmpMarker;
	}

	/** Map click handler: place the marker at the clicked point and commit (no recenter). */
	onMapSelectionMade(pEvent)
	{
		const tmpContainerID = (pEvent && pEvent.target && (typeof pEvent.target.getContainer === 'function')) ? pEvent.target.getContainer().id : '';
		const rawHTMLID = this.getMapIDFromContainerID(tmpContainerID);
		if (!rawHTMLID)
		{
			return;
		}
		const tmpMapData = this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpMapData && tmpMapData.map)
		{
			tmpMapData.marker = this.setLeafletMarker({ lat: pEvent.latlng.lat, lng: pEvent.latlng.lng }, tmpMapData.map, tmpMapData.marker, rawHTMLID);
		}
		this._commitLatLong(rawHTMLID, pEvent.latlng.lat, pEvent.latlng.lng);
	}

	/**
	 * Move the marker + recenter to a programmatically supplied point (typed coordinates, address pick, or
	 * GPS). Pure map operation — does not write the inputs (the caller commits separately), which avoids a
	 * commit/change loop.
	 */
	moveMarkerTo(rawHTMLID, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (!tmpMapData || !tmpMapData.map)
		{
			return;
		}
		const tmpLat = Number(pLatitude);
		const tmpLng = Number(pLongitude);
		if (!Number.isFinite(tmpLat) || !Number.isFinite(tmpLng))
		{
			return;
		}
		tmpMapData.marker = this.setLeafletMarker({ lat: tmpLat, lng: tmpLng }, tmpMapData.map, tmpMapData.marker, rawHTMLID);
		tmpMapData.location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
		tmpMapData.map.setView([ tmpLat, tmpLng ], Math.max(tmpMapData.map.getZoom() || 13, 13));
	}

	/**
	 * Write both lat/long inputs, repaint the readout, and marshal (single change on the latitude input;
	 * onDataChange handles the pair). The suppress flag prevents onDataChange from re-syncing the map.
	 */
	_commitLatLong(rawHTMLID, pLatitude, pLongitude)
	{
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			tmpLat.val(String(pLatitude));
		}
		if (tmpLong.length)
		{
			tmpLong.val(String(pLongitude));
		}
		this.refreshCombinedDisplay(rawHTMLID);
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpMapData)
		{
			tmpMapData.location = { Latitude: String(pLatitude), Longitude: String(pLongitude) };
		}
		if (rawHTMLID === GEO_MODAL_KEY)
		{
			this._modalValue = { Latitude: String(pLatitude), Longitude: String(pLongitude) };
		}
		this._suppressMapSync[rawHTMLID] = true;
		if (tmpLat.length)
		{
			tmpLat.trigger('change');
		}
		this._suppressMapSync[rawHTMLID] = false;
	}

	// --- Use My Location (device GPS) ----------------------------------------------------------------

	onUseMyLocation(rawHTMLID)
	{
		if (!navigator.geolocation)
		{
			this._toast('Could not fetch user location', 'is-error');
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pPosition) => this.setLocation(rawHTMLID, pPosition),
			() =>
			{
				this.pict.log.info('GeolocationSelector', 'onUseMyLocation', 'getCurrentPosition failed');
				this._toast('Could not fetch user location', 'is-error');
			});
	}

	setLocation(rawHTMLID, pPosition)
	{
		const tmpLat = pPosition.coords.latitude;
		const tmpLng = pPosition.coords.longitude;
		this._commitLatLong(rawHTMLID, tmpLat, tmpLng);
		this.moveMarkerTo(rawHTMLID, tmpLat, tmpLng);
	}

	// --- Address geocoding (Nominatim / OpenStreetMap) -----------------------------------------------

	/**
	 * Geocode the field's address box via public Nominatim — same provider as the tiles, no API key. One
	 * request per explicit Search (no as-you-type), keeping within OSM fair-use. Results render as clickable
	 * rows; picking one (chooseAddressResult) drops the pin.
	 * @param {string} rawHTMLID
	 */
	async searchAddress(rawHTMLID)
	{
		const tmpInputEl = document.getElementById(this.getAddressInputID(rawHTMLID));
		const tmpQuery = this._domValue(tmpInputEl).trim();
		if (!tmpQuery)
		{
			return;
		}
		this._renderAddressStatus(rawHTMLID, 'Searching…', false);
		try
		{
			const tmpURL = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=5&q=${encodeURIComponent(tmpQuery)}`;
			const tmpResponse = await fetch(tmpURL, { headers: { 'Accept': 'application/json' } });
			if (!tmpResponse.ok)
			{
				throw new Error(`the geocoder returned ${tmpResponse.status}`);
			}
			const tmpRows = await tmpResponse.json();
			this._addressResultsByID[rawHTMLID] = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pRow) => ({ DisplayName: String(pRow.display_name || 'result'), Latitude: Number(pRow.lat), Longitude: Number(pRow.lon) }))
				.filter((pRow) => Number.isFinite(pRow.Latitude) && Number.isFinite(pRow.Longitude))
				.slice(0, 5);
			this._renderAddressResults(rawHTMLID);
		}
		catch (pError)
		{
			this._addressResultsByID[rawHTMLID] = [];
			this._renderAddressStatus(rawHTMLID, `Address search failed: ${pError.message || pError}`, true);
		}
	}

	_clearAddressResultsDOM(rawHTMLID)
	{
		const tmpEl = document.getElementById(this.getAddressResultsID(rawHTMLID));
		if (tmpEl)
		{
			while (tmpEl.firstChild)
			{
				tmpEl.removeChild(tmpEl.firstChild);
			}
		}
		return tmpEl;
	}

	/** Render clickable result rows (createElement/append — no HTML-string injection). */
	_renderAddressResults(rawHTMLID)
	{
		const tmpEl = this._clearAddressResultsDOM(rawHTMLID);
		if (!tmpEl)
		{
			return;
		}
		const tmpResults = this._addressResultsByID[rawHTMLID] || [];
		if (tmpResults.length === 0)
		{
			this._renderAddressStatus(rawHTMLID, 'No matches found for that address.', false);
			return;
		}
		for (let i = 0; i < tmpResults.length; i++)
		{
			const tmpRow = document.createElement('button');
			tmpRow.type = 'button';
			tmpRow.className = 'button is-small is-fullwidth has-text-left mb-1';
			tmpRow.textContent = tmpResults[i].DisplayName;
			// eslint-disable-next-line no-loop-func
			tmpRow.addEventListener('click', ((pIndex) => () => this.chooseAddressResult(rawHTMLID, pIndex))(i));
			tmpEl.appendChild(tmpRow);
		}
	}

	_renderAddressStatus(rawHTMLID, pText, pIsError)
	{
		const tmpEl = this._clearAddressResultsDOM(rawHTMLID);
		if (!tmpEl)
		{
			return;
		}
		const tmpStatus = document.createElement('p');
		tmpStatus.className = pIsError ? 'help is-danger' : 'help';
		tmpStatus.textContent = pText;
		tmpEl.appendChild(tmpStatus);
	}

	chooseAddressResult(rawHTMLID, pIndex)
	{
		const tmpRow = (this._addressResultsByID[rawHTMLID] || [])[Number(pIndex)];
		if (!tmpRow)
		{
			return;
		}
		this._addressResultsByID[rawHTMLID] = [];
		this._clearAddressResultsDOM(rawHTMLID);
		// A full-size row's search is keyed by `<rawHTMLID>-<rowIndex>`; commit it to that row rather
		// than to a same-named single-record field.
		const tmpRowContext = this._rowContexts[rawHTMLID];
		if (tmpRowContext)
		{
			this._commitTabularRow(tmpRowContext.viewHash, tmpRowContext.groupIndex, tmpRowContext.inputIndex,
				tmpRowContext.rowIndex, tmpRowContext.rawHTMLID, tmpRow.Latitude, tmpRow.Longitude);
			return;
		}
		this._commitLatLong(rawHTMLID, tmpRow.Latitude, tmpRow.Longitude);
		this.moveMarkerTo(rawHTMLID, Number(tmpRow.Latitude), Number(tmpRow.Longitude));
	}

	// --- Clear / reset -------------------------------------------------------------------------------

	clearValue(rawHTMLID)
	{
		const tmpLat = $(this.getLatitudeInputHTMLID(rawHTMLID));
		const tmpLong = $(this.getLongitudeInputHTMLID(rawHTMLID));
		if (tmpLat.length)
		{
			tmpLat.val('');
		}
		if (tmpLong.length)
		{
			tmpLong.val('');
		}
		this.refreshCombinedDisplay(rawHTMLID);
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[rawHTMLID];
		if (tmpMapData)
		{
			tmpMapData.location = { Latitude: '', Longitude: '' };
			if (tmpMapData.marker && tmpMapData.map)
			{
				try
				{
 tmpMapData.map.removeLayer(tmpMapData.marker);
				}
				catch (pError)
				{/* already removed */}
				tmpMapData.marker = null;
			}
		}
		this._addressResultsByID[rawHTMLID] = [];
		this._clearAddressResultsDOM(rawHTMLID);
		this._suppressMapSync[rawHTMLID] = true;
		if (tmpLat.length)
		{
			tmpLat.trigger('change');
		}
		this._suppressMapSync[rawHTMLID] = false;
	}

	// --- Tabular -------------------------------------------------------------------------------------

	/** Repaint a tabular cell's readout (both presentations share the id) from a value. */
	_paintTabularDisplay(rawHTMLID, pRowIndex, pSeed)
	{
		if (!document.querySelector(this.getTabularDisplayID(rawHTMLID, pRowIndex)))
		{
			return;
		}
		this.pict.ContentAssignment.assignContent(this.getTabularDisplayID(rawHTMLID, pRowIndex),
			this.formatLocationDisplay(pSeed.Latitude, pSeed.Longitude));
	}

	/**
	 * Mirror a row's value into the full-size presentation's visible coordinate editors. No-op in the
	 * compact presentation, which has no editors (the value is edited in the modal instead).
	 */
	_syncRowEditors(rawHTMLID, pRowIndex, pSeed)
	{
		const tmpLatEl = document.querySelector(this.getRowEditorLatitudeID(rawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getRowEditorLongitudeID(rawHTMLID, pRowIndex));
		if (!tmpLatEl && !tmpLngEl)
		{
			return;
		}
		this._setDomValue(tmpLatEl, pSeed.Latitude);
		this._setDomValue(tmpLngEl, pSeed.Longitude);
	}

	/** Repaint a tabular cell's derived display + editors from its two hidden inputs. */
	_refreshTabularDisplay(rawHTMLID, pRowIndex)
	{
		const tmpLatEl = document.querySelector(this.getTabularLatitudeInputID(rawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getTabularLongitudeInputID(rawHTMLID, pRowIndex));
		const tmpSeed = { Latitude: this._domValue(tmpLatEl), Longitude: this._domValue(tmpLngEl) };
		this._paintTabularDisplay(rawHTMLID, pRowIndex, tmpSeed);
		this._syncRowEditors(rawHTMLID, pRowIndex, tmpSeed);
	}

	/** Write a row's two hidden inputs and repaint its display (does not marshal — caller does). */
	setTabularLatLong(rawHTMLID, pRowIndex, pLatitude, pLongitude)
	{
		const tmpLatEl = document.querySelector(this.getTabularLatitudeInputID(rawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getTabularLongitudeInputID(rawHTMLID, pRowIndex));
		this._setDomValue(tmpLatEl, pLatitude);
		this._setDomValue(tmpLngEl, pLongitude);
		this._refreshTabularDisplay(rawHTMLID, pRowIndex);
	}

	/**
	 * Commit a row's value from any of its controls: hidden inputs + derived display + editors, the
	 * inline record-set marker, then marshal the row. Every row-level action funnels through here.
	 */
	_commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, pLatitude, pLongitude)
	{
		this.setTabularLatLong(pRawHTMLID, pRowIndex, pLatitude, pLongitude);
		this._syncRecordSetRowMarker(`RS-${pRawHTMLID}-${pRowIndex}`, { Latitude: pLatitude, Longitude: pLongitude });
		if (this.pict.views[pViewHash])
		{
			this.pict.views[pViewHash].dataChangedTabular(pGroupIndex, pInputIndex, pRowIndex);
		}
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._injectCSS();
		const tmpSeed = this._coerceLatLong(pValue);
		this._paintTabularDisplay(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		this._syncRowEditors(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		// Record Sets render each record stacked (not a compact table), so the map variant gets an inline
		// per-record map. The compact Tabular table skips this and keeps its map in the Edit modal.
		if (pGroup && pGroup.Layout === 'RecordSet')
		{
			this._ensureRecordSetRowMap(pView, pGroup, pInput, pRowIndex, tmpSeed);
			this._refreshRecordSetRowStaticImage(pInput, pRowIndex, tmpSeed);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/** The readout and editors are derived state, so they must be repainted to the row's value after a reorder. */
	onTabularRowReorderRepaintTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpSeed = this._coerceLatLong(pValue);
		this._paintTabularDisplay(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		this._syncRowEditors(pInput.Macro.RawHTMLID, pRowIndex, tmpSeed);
		if (pGroup && pGroup.Layout === 'RecordSet')
		{
			this._ensureRecordSetRowMap(pView, pGroup, pInput, pRowIndex, tmpSeed);
			this._refreshRecordSetRowStaticImage(pInput, pRowIndex, tmpSeed);
		}
		// (base method is a no-op; not chaining super avoids a stale shipped-.d.ts type error)
		return true;
	}

	// --- Record Set inline per-record map (map variant only) -----------------------------------------

	/**
	 * Reveal + (re)mount the inline map for one record-set record. Visibility-gated (defers to an
	 * IntersectionObserver when the record is behind an inactive tab) and stale-aware (a record-set
	 * re-render on row add/delete regenerates the host, so the detached map is torn down and re-mounted).
	 * No-op for the no-map variant (no host element).
	 * @param {any} pView @param {any} pGroup @param {any} pInput @param {number} pRowIndex @param {any} pSeed
	 */
	_ensureRecordSetRowMap(pView, pGroup, pInput, pRowIndex, pSeed)
	{
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const tmpHost = document.getElementById(`GEO-RS-MAP-FOR-${rawHTMLID}-${pRowIndex}`);
		if (!tmpHost)
		{
			return;
		}
		tmpHost.style.display = 'block';
		const tmpLocked = tmpHost.getAttribute('data-geo-locked') === 'true';
		const tmpKey = `RS-${rawHTMLID}-${pRowIndex}`;
		const tmpContext = { view: pView, groupIndex: pGroup.GroupIndex, inputIndex: pInput.PictForm.InputIndex, rowIndex: pRowIndex, rawHTMLID };

		const tmpExisting = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[tmpKey];
		if (tmpExisting && tmpExisting.map)
		{
			const tmpEl = (typeof tmpExisting.map.getContainer === 'function') ? tmpExisting.map.getContainer() : null;
			if (tmpEl && tmpEl === tmpHost && document.body.contains(tmpEl))
			{
				tmpExisting.recordSet = tmpContext;
				this._syncRecordSetRowMarker(tmpKey, pSeed);
				return;
			}
			try
			{
 tmpExisting.map.remove();
			}
			catch (pError)
			{/* already detached */}
			delete this.pict.AppData.LeafletMapsData[tmpKey];
		}
		if (this._mapObservers[tmpKey])
		{
			this._mapObservers[tmpKey].disconnect();
			delete this._mapObservers[tmpKey];
		}

		const tmpMount = () =>
		{
			if (this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[tmpKey] && this.pict.AppData.LeafletMapsData[tmpKey].map)
			{
				return;
			}
			this._mountRecordSetRowMap(tmpKey, tmpHost, tmpContext, pSeed, tmpLocked);
		};
		if ((typeof IntersectionObserver === 'undefined') || (tmpHost.offsetParent !== null))
		{
			tmpMount();
			return;
		}
		const tmpObserver = new IntersectionObserver((pEntries) =>
		{
			for (let i = 0; i < pEntries.length; i++)
			{
				if (pEntries[i].isIntersecting)
				{
					tmpObserver.disconnect();
					delete this._mapObservers[tmpKey];
					tmpMount();
					return;
				}
			}
		});
		this._mapObservers[tmpKey] = tmpObserver;
		tmpObserver.observe(tmpHost);
	}

	_mountRecordSetRowMap(pKey, pHost, pContext, pSeed, pLocked)
	{
		const libLeaflet = window.L;
		if (!libLeaflet || !pHost)
		{
			return;
		}
		const tmpSeed = this._coerceLatLong(pSeed);
		const tmpHasFix = this._inRange(tmpSeed.Latitude, tmpSeed.Longitude);
		const tmpLat = tmpHasFix ? Number(tmpSeed.Latitude) : GEO_DEFAULT_CENTER.Latitude;
		const tmpLng = tmpHasFix ? Number(tmpSeed.Longitude) : GEO_DEFAULT_CENTER.Longitude;

		const tmpMap = libLeaflet.map(pHost).setView([ tmpLat, tmpLng ], tmpHasFix ? 13 : 4);
		libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(tmpMap);

		this.pict.AppData.LeafletMapsData = this.pict.AppData.LeafletMapsData || {};
		this.pict.AppData.LeafletMapsData[pKey] = {
			map: tmpMap,
			RawHTMLID: pKey,
			destinationAddress: pHost.id,
			hideMap: false,
			marker: null,
			location: { Latitude: '', Longitude: '' },
			locked: pLocked,
			recordSet: pContext,
		};
		if (tmpHasFix)
		{
			this.pict.AppData.LeafletMapsData[pKey].marker = this._recordSetMarker(pKey, tmpLat, tmpLng);
			this.pict.AppData.LeafletMapsData[pKey].location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
		}
		if (pLocked)
		{
			this.disableMap(tmpMap, pHost.id);
		}
		else
		{
			tmpMap.on('click', (pEvent) => this._onRecordSetRowMapClick(pKey, pEvent.latlng.lat, pEvent.latlng.lng));
		}
		setTimeout(() =>
		{
			try
			{
 tmpMap.invalidateSize();
			}
			catch (pError)
			{/* host detached */}
		}, 60);
	}

	/** Create (draggable) or move the record's marker. */
	_recordSetMarker(pKey, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData || !tmpMapData.map)
		{
			return tmpMapData ? tmpMapData.marker : null;
		}
		const libLeaflet = window.L;
		const tmpLatLng = { lat: Number(pLatitude), lng: Number(pLongitude) };
		let tmpMarker = tmpMapData.marker;
		if (!tmpMarker)
		{
			tmpMarker = libLeaflet.marker(tmpLatLng, { draggable: !tmpMapData.locked });
			if (!tmpMapData.locked)
			{
				tmpMarker.on('dragend', (pEvent) =>
				{
					const tmpDrag = pEvent.target.getLatLng();
					this._commitRecordSetRow(pKey, tmpDrag.lat, tmpDrag.lng);
				});
			}
		}
		tmpMarker.setLatLng(tmpLatLng).addTo(tmpMapData.map);
		return tmpMarker;
	}

	_onRecordSetRowMapClick(pKey, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData)
		{
			return;
		}
		tmpMapData.marker = this._recordSetMarker(pKey, pLatitude, pLongitude);
		this._commitRecordSetRow(pKey, pLatitude, pLongitude);
	}

	/** Write a record's value from its map gesture: hidden inputs + compact display, then marshal the row. */
	_commitRecordSetRow(pKey, pLatitude, pLongitude)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData || !tmpMapData.recordSet)
		{
			return;
		}
		const tmpContext = tmpMapData.recordSet;
		tmpMapData.location = { Latitude: String(pLatitude), Longitude: String(pLongitude) };
		this.setTabularLatLong(tmpContext.rawHTMLID, tmpContext.rowIndex, pLatitude, pLongitude);
		if (tmpContext.view && (typeof tmpContext.view.dataChangedTabular === 'function'))
		{
			tmpContext.view.dataChangedTabular(tmpContext.groupIndex, tmpContext.inputIndex, tmpContext.rowIndex);
		}
	}

	/** Refresh a healthy record map's marker to the marshaled row value (marker follows external edits). */
	_syncRecordSetRowMarker(pKey, pSeed)
	{
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[pKey];
		if (!tmpMapData || !tmpMapData.map)
		{
			return;
		}
		const tmpSeed = this._coerceLatLong(pSeed);
		if (this._inRange(tmpSeed.Latitude, tmpSeed.Longitude))
		{
			const tmpLat = Number(tmpSeed.Latitude);
			const tmpLng = Number(tmpSeed.Longitude);
			tmpMapData.marker = this._recordSetMarker(pKey, tmpLat, tmpLng);
			tmpMapData.location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
			// Recenter: a non-gesture set (Get-My-Location, Edit modal) may land off-screen, so bring it
			// into view. Map drag/click never routes here, so a drag is never yanked back to center.
			tmpMapData.map.setView([ tmpLat, tmpLng ], Math.max(tmpMapData.map.getZoom() || 13, 13));
		}
		else if (tmpMapData.marker)
		{
			try
			{
 tmpMapData.map.removeLayer(tmpMapData.marker);
			}
			catch (pError)
			{/* already gone */}
			tmpMapData.marker = null;
			tmpMapData.location = { Latitude: '', Longitude: '' };
		}
	}

	onUseMyLocationTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		if (!navigator.geolocation)
		{
			this._toast('Could not fetch user location', 'is-error');
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pPosition) => this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID,
				pPosition.coords.latitude, pPosition.coords.longitude),
			() => this._toast('Could not fetch user location', 'is-error'));
	}

	clearValueTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpKey = this.getRowKey(pRawHTMLID, pRowIndex);
		this._addressResultsByID[tmpKey] = [];
		this._clearAddressResultsDOM(tmpKey);
		this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, '', '');
	}

	/**
	 * A typed edit in the full-size row presentation's coordinate editors. Those inputs are unbound,
	 * so the value is pushed into the row's hidden informary inputs and marshaled from here.
	 */
	onRowCoordinateEdit(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpLat = this._domValue(document.querySelector(this.getRowEditorLatitudeID(pRawHTMLID, pRowIndex)));
		const tmpLng = this._domValue(document.querySelector(this.getRowEditorLongitudeID(pRawHTMLID, pRowIndex)));
		this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, tmpLat, tmpLng);
	}

	/**
	 * Address search from the full-size row presentation. The search DOM is keyed by instance id, so
	 * the row's identity is stashed first — chooseAddressResult reads it back to commit the pick to
	 * the right row.
	 */
	searchAddressTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpKey = this.getRowKey(pRawHTMLID, pRowIndex);
		this._rowContexts[tmpKey] = { viewHash: pViewHash, groupIndex: pGroupIndex, inputIndex: pInputIndex, rowIndex: pRowIndex, rawHTMLID: pRawHTMLID };
		return this.searchAddress(tmpKey);
	}

	openEditModalTabular(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpInput = (tmpView && typeof tmpView.getTabularRecordInput === 'function') ? tmpView.getTabularRecordInput(pGroupIndex, pInputIndex) : null;
		const tmpHasMap = !!(tmpInput && tmpInput.PictForm && tmpInput.PictForm.InputType === 'GeolocationSelectorWithMap');
		const tmpLatEl = document.querySelector(this.getTabularLatitudeInputID(pRawHTMLID, pRowIndex));
		const tmpLngEl = document.querySelector(this.getTabularLongitudeInputID(pRawHTMLID, pRowIndex));
		const tmpCurrent = { Latitude: this._domValue(tmpLatEl), Longitude: this._domValue(tmpLngEl) };
		this._openLocationModal(tmpHasMap, tmpCurrent, (pResult) =>
			this._commitTabularRow(pViewHash, pGroupIndex, pInputIndex, pRowIndex, pRawHTMLID, pResult.Latitude, pResult.Longitude));
	}

	/**
	 * Open the edit-location modal for a single-record field — the compact presentation's Edit button,
	 * where the picker lives in the modal instead of inline. Saving commits through the same path a
	 * map gesture uses, so the inline map (map variant) follows.
	 * @param {string} rawHTMLID
	 * @param {boolean} pHasMap
	 */
	openEditModal(rawHTMLID, pHasMap)
	{
		const tmpCurrent = {
			Latitude: $(this.getLatitudeInputHTMLID(rawHTMLID)).val(),
			Longitude: $(this.getLongitudeInputHTMLID(rawHTMLID)).val(),
		};
		this._openLocationModal(!!pHasMap, tmpCurrent, (pResult) =>
		{
			// An emptied modal is a clear — clearValue also drops the marker, which a bare commit
			// would leave stranded at the old point.
			if (!this._inRange(pResult.Latitude, pResult.Longitude))
			{
				this.clearValue(rawHTMLID);
				return;
			}
			this._commitLatLong(rawHTMLID, pResult.Latitude, pResult.Longitude);
			this.moveMarkerTo(rawHTMLID, Number(pResult.Latitude), Number(pResult.Longitude));
		});
	}

	// --- Edit-location modal (hosts the full picker; used by tabular Edit) ----------------------------

	/**
	 * The modal reuses the field-level methods keyed by GEO_MODAL_KEY: its lat/long inputs are
	 * LATITUDE-FOR-GEO-MODAL / LONGITUDE-FOR-GEO-MODAL, its search box GEO-ADDRESS-INPUT-GEO-MODAL, and its
	 * map is a self-contained Leaflet instance in LeafletMapsData[GEO_MODAL_KEY].
	 */
	_buildModalContentHTML(pHasMap)
	{
		const tmpKey = GEO_MODAL_KEY;
		let tmpHTML = '' +
			'<div class="field has-addons">' +
			'<div class="control is-expanded"><input id="' + this.getAddressInputID(tmpKey) + '" class="input" type="text" placeholder="Search an address or place…" autocomplete="off" ' +
			'onkeydown="if(event.key===\'Enter\'){event.preventDefault();_Pict.providers.GeolocationSelector.searchAddress(\'' + tmpKey + '\');}" /></div>' +
			'<div class="control"><button type="button" class="button is-soft" onclick="_Pict.providers.GeolocationSelector.searchAddress(\'' + tmpKey + '\')"><span class="icon"><i class="fas fa-search"></i></span><span class="is-hidden-mobile">Search</span></button></div>' +
			'</div>' +
			'<div id="' + this.getAddressResultsID(tmpKey) + '"></div>' +
			// Plain columns (no is-mobile) so the coordinate pair stacks into full-width rows on a phone
			// rather than truncating long decimals side by side.
			'<div class="columns mt-1">' +
			'<div class="column"><label class="label is-small">Latitude</label>' +
			'<input id="LATITUDE-FOR-' + tmpKey + '" class="input" type="number" step="any" onchange="_Pict.providers.GeolocationSelector.onModalCoordEdit()" /></div>' +
			'<div class="column"><label class="label is-small">Longitude</label>' +
			'<input id="LONGITUDE-FOR-' + tmpKey + '" class="input" type="number" step="any" onchange="_Pict.providers.GeolocationSelector.onModalCoordEdit()" /></div>' +
			'</div>' +
			// geo-action-buttons splits the pair evenly across the row on a phone, matching the
			// inline control's action row.
			'<div class="buttons are-small mt-1 geo-action-buttons">' +
			'<button type="button" class="button is-link" onclick="_Pict.providers.GeolocationSelector.onUseMyLocation(\'' + tmpKey + '\')"><span class="icon"><i class="fa fa-location-crosshairs"></i></span><span>Use My Location</span></button>' +
			'<button type="button" class="button is-link is-soft" onclick="_Pict.providers.GeolocationSelector.clearValue(\'' + tmpKey + '\')"><span class="icon"><i class="fa fa-eraser"></i></span><span>Clear</span></button>' +
			'</div>';
		if (pHasMap)
		{
			tmpHTML += '<div id="MAP-CONTAINER-FOR-' + tmpKey + '" class="mt-2" style="min-height: 300px; z-index: 1;"></div>';
		}
		return tmpHTML;
	}

	/** Typed edit inside the modal: follow it on the modal map + capture the working value. */
	onModalCoordEdit()
	{
		const tmpKey = GEO_MODAL_KEY;
		const tmpLat = (this._domValue(document.getElementById(`LATITUDE-FOR-${tmpKey}`)));
		const tmpLng = (this._domValue(document.getElementById(`LONGITUDE-FOR-${tmpKey}`)));
		this._modalValue = { Latitude: tmpLat, Longitude: tmpLng };
		if (this._inRange(tmpLat, tmpLng))
		{
			this.moveMarkerTo(tmpKey, Number(tmpLat), Number(tmpLng));
		}
	}

	_mountModalMap(pCurrent)
	{
		const tmpKey = GEO_MODAL_KEY;
		const libLeaflet = window.L;
		const tmpHost = document.getElementById(`MAP-CONTAINER-FOR-${tmpKey}`);
		if (!libLeaflet || !tmpHost)
		{
			return;
		}
		const tmpSeed = this._coerceLatLong(pCurrent);
		const tmpHasFix = this._inRange(tmpSeed.Latitude, tmpSeed.Longitude);
		const tmpLat = tmpHasFix ? Number(tmpSeed.Latitude) : GEO_DEFAULT_CENTER.Latitude;
		const tmpLng = tmpHasFix ? Number(tmpSeed.Longitude) : GEO_DEFAULT_CENTER.Longitude;

		const tmpMap = libLeaflet.map(tmpHost).setView([ tmpLat, tmpLng ], tmpHasFix ? 13 : 4);
		libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(tmpMap);

		this.pict.AppData.LeafletMapsData = this.pict.AppData.LeafletMapsData || {};
		this.pict.AppData.LeafletMapsData[tmpKey] = {
			map: tmpMap,
			RawHTMLID: tmpKey,
			destinationAddress: `MAP-CONTAINER-FOR-${tmpKey}`,
			hideMap: false,
			marker: null,
			location: { Latitude: '', Longitude: '' },
		};
		if (tmpHasFix)
		{
			this.pict.AppData.LeafletMapsData[tmpKey].marker = this.setLeafletMarker({ lat: tmpLat, lng: tmpLng }, tmpMap, null, tmpKey);
			this.pict.AppData.LeafletMapsData[tmpKey].location = { Latitude: String(tmpLat), Longitude: String(tmpLng) };
		}
		tmpMap.on('click', this.onMapSelectionMade, this);
		setTimeout(() =>
		{
			try
			{
 tmpMap.invalidateSize();
			}
			catch (pError)
			{/* host detached */}
		}, 80);
	}

	_teardownModalMap()
	{
		const tmpKey = GEO_MODAL_KEY;
		const tmpMapData = this.pict.AppData.LeafletMapsData && this.pict.AppData.LeafletMapsData[tmpKey];
		if (tmpMapData && tmpMapData.map)
		{
			try
			{
 tmpMapData.map.remove();
			}
			catch (pError)
			{/* already removed */}
		}
		if (this.pict.AppData.LeafletMapsData)
		{
			delete this.pict.AppData.LeafletMapsData[tmpKey];
		}
		delete this._addressResultsByID[tmpKey];
	}

	/**
	 * Open the shared edit-location modal, prefilled to pCurrent, and invoke pOnSave({Latitude, Longitude})
	 * when the user confirms. The working value is captured live (this._modalValue), so Save is robust to
	 * modal-DOM teardown timing.
	 */
	_openLocationModal(pHasMap, pCurrent, pOnSave)
	{
		const tmpKey = GEO_MODAL_KEY;
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || (typeof tmpModal.show !== 'function'))
		{
			this._toast('Location editor is unavailable', 'is-error');
			return;
		}
		this._addressResultsByID[tmpKey] = [];
		this._modalValue = { Latitude: pCurrent ? pCurrent.Latitude : '', Longitude: pCurrent ? pCurrent.Longitude : '' };

		tmpModal.show(
		{
			title: 'Edit Location',
			content: this._buildModalContentHTML(pHasMap),
			closeable: true,
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' },
			],
			onOpen: (pDialog) =>
			{
				// Scopes the phone-only full-screen rules to this dialog (the shared modal has no
				// full-screen option of its own).
				if (pDialog && pDialog.classList)
				{
					pDialog.classList.add('geolocation-edit-modal');
				}
				const tmpLatEl = document.getElementById(`LATITUDE-FOR-${tmpKey}`);
				const tmpLngEl = document.getElementById(`LONGITUDE-FOR-${tmpKey}`);
				if (pCurrent && pCurrent.Latitude !== '' && pCurrent.Latitude != null)
				{
					this._setDomValue(tmpLatEl, pCurrent.Latitude);
				}
				if (pCurrent && pCurrent.Longitude !== '' && pCurrent.Longitude != null)
				{
					this._setDomValue(tmpLngEl, pCurrent.Longitude);
				}
				if (pHasMap)
				{
					this._mountModalMap(pCurrent);
				}
				if (tmpLatEl)
				{
					tmpLatEl.focus();
				}
			},
			onClose: () => this._teardownModalMap(),
		}).then((pHash) =>
		{
			if (pHash !== 'save')
			{
				return;
			}
			pOnSave({ Latitude: this._modalValue.Latitude, Longitude: this._modalValue.Longitude });
		});
	}
}

module.exports = CustomInputHandler;

},{"./PictProvider-InputType-GeolocationSelector-CSS.js":78,"pict-section-form":587}],80:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LAB-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Lab for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Lab record yet, get it and store it
			if (!this.pict.AppData.SelectedLab || this.pict.AppData.SelectedLab.length < 1)
			{
				const tmpResult = await this.pict.providers.LabProvider.getLabByID(pValue);
				this.pict.AppData.SelectedLab = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedLab?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],81:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LAB-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LAB-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Lab',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Lab...',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}


	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Lab for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Lab and set it as the selected Lab on the data object
			const tmpLab = await this.pict.providers.LabProvider.getLabByID(pValue);
			this.pict.AppData.SelectedLab = tmpLab;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedLab.IDLab;
			tmpOption.text = this.pict.AppData.SelectedLab.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],82:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LINEITEM-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedLineItem.ItemCode || 'N/A',
				this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the LineItem for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the LineItem record yet, get it and store it
			if (!this.pict.AppData.SelectedLineItem)
			{
				const tmpResult = await this.pict.providers.LineItemProvider.getLineItemByID(pValue);
				this.pict.AppData.SelectedLineItem = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
		return true;
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],83:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#LINEITEM-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#LINEITEM-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('LineItem',
				{
					Input: pInput,
					SearchFields: [ 'ItemCode', 'Name' ],
					SearchFallbackPlaceholder: 'Select a Line Item by name or code...',
					GetRecordUserFacingID: (pLineItem) => pLineItem.ItemCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the LineItem for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected LineItem and set it as the selected LineItem on the data object
			const tmpLineItem = await this.pict.providers.LineItemProvider.getLineItemByID(pValue);
			this.pict.AppData.SelectedLineItem = tmpLineItem;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedLineItem.IDLineItem;
			tmpOption.text = `${this.pict.AppData.SelectedLineItem.ItemCode || 'N/A'}|~|${this.pict.AppData.SelectedLineItem.Name || ('Unnamed LineItem #' + this.pict.AppData.SelectedLineItem.IDLineItem)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],84:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.selectedMaterial = null;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIAL-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.SelectedMaterial.ItemCode || 'N/A',
				this.SelectedMaterial.Name || ('Unnamed Material #' + this.SelectedMaterial.IDMaterial),
			);
		}
		else
		{
			tmpDisplayTemplate = this.SelectedMaterial.Name || ('Unnamed Material #' + this.SelectedMaterial.IDMaterial);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the Material for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Material record yet, get it and store it
			if (!this.SelectedMaterial || this.SelectedMaterial.IDMaterial !== pValue)
			{
				try
				{
					const tmpMaterial = await this.pict.providers.MaterialProvider.getMaterialByID(pValue);
					this.SelectedMaterial = tmpMaterial;
				}
				catch (e)
				{
					this.pict.log.error(`Error fetching Material with ID ${ pValue }: ${ e }`);
					this.SelectedMaterial =
					{
						IDMaterial: pValue,
						Name: 'Unkown Material',
					};
				}
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],85:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.inputID = '';
		this.placeholder = '';
		this.showAllMaterials = false;
		this.disableSpecYearSiloing = false;
		this.selectedMaterial = null;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIAL-SELECT-FOR-${pInputHTMLID}`;
	}

	getSelectFilterToggleID(pInputHTMLID)
	{
		return `#MATERIAL-SELECT-FILTER-TOGGLE-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIAL-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 */
	initializeSelect2()
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpShowAllMaterials = this.showAllMaterials;
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Material',
				{
					SearchFields: [ 'ItemCode', 'Name' ],
					SearchPlaceholder: this.placeholder,
					GetRecordUserFacingID: (pMaterial) => pMaterial.ItemCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// if we are showing all materials, do not apply the parent filter
						// otherwise, filter to only show top-level materials (no parent)
						if (tmpShowAllMaterials)
						{
							// always ensure we have a sort by Name ascending
							if (!pFilters.length || !pFilters.includes('FSF'))
							{
								pFilters.push('FSF~Name~ASC~0');
							}
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						pFilters.push('FBV~IDMaterialParent~EQ~0');
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.inputID).data('select2'))
			{
				window['jQuery'](this.inputID).select2(tmpSelectOptions);
			}
		}
	}

	updateToggleFilterLink(pInputHTMLID)
	{
		// update the link toggle icon
		if (this.showAllMaterials)
		{
			const newToggleLinkIconElement = document.createElement('i');
			newToggleLinkIconElement.classList.add('fas', 'fa-toggle-on');
			this.pict.ContentAssignment.assignContent(this.getSelectFilterToggleID(pInputHTMLID) + ' > .icon', newToggleLinkIconElement.outerHTML);
		}
		else
		{
			const newToggleLinkIconElement = document.createElement('i');
			newToggleLinkIconElement.classList.add('fas', 'fa-toggle-off');
			this.pict.ContentAssignment.assignContent(this.getSelectFilterToggleID(pInputHTMLID) + ' > .icon', newToggleLinkIconElement.outerHTML);
		}
	}

	/**
	 * Toggle the material filter for the input element based on the user's selection.
	 * @param {string} pInputHTMLID The input HTML ID.
	 */
	toggleMaterialFilter(pInputHTMLID)
	{
		this.showAllMaterials = !this.showAllMaterials;
		this.updateToggleFilterLink(pInputHTMLID);
		// destroy and reinitialize the select2 plugin with the new filter settings
		window['jQuery'](this.getSelectInputHTMLID(pInputHTMLID)).data('select2').destroy();
		this.initializeSelect2();
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Material for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Material and set it as the selected Material on the data object
			try
			{
				const tmpMaterial = await this.pict.providers.MaterialProvider.getMaterialByID(pValue);
				this.SelectedMaterial = tmpMaterial;
			}
			catch (e)
			{
				this.pict.log.error(`Error fetching Material with ID ${ pValue }: ${ e }`);
				this.SelectedMaterial =
				{
					IDMaterial: pValue,
					Name: 'Unkown Material',
				};
			}
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.SelectedMaterial.IDMaterial;
			tmpOption.text = `${this.SelectedMaterial.ItemCode || 'N/A'}|~|${this.SelectedMaterial.Name || ('Unnamed Material #' + this.SelectedMaterial.IDMaterial)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		if (pInput)
		{
			this.inputID = this.getSelectInputHTMLID(pInput.Macro.RawHTMLID);
			this.showAllMaterials = pInput.PictForm?.InputExtra && typeof(pInput.PictForm?.InputExtra) === 'string' && pInput.PictForm?.InputExtra.toLowerCase().replaceAll(' ', '') === 'showallmaterials' ? true : false;
			this.updateToggleFilterLink(pInput.Macro.RawHTMLID);
			this.placeholder = pInput?.PictForm?.Placeholder || 'Select a Material by name or code...';
			this.removeLoadingSkeleton(pInput);
			this.initializeSelect2();
		}
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],86:[function(require,module,exports){
const PickerProvider = require('./PictProvider-InputType-Picker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const EntityDataBaseline = require('./_EntityDataBaseline.js');
const libSeedRecord = require('./_SeedRecord.js');

const SALT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
// Special committed value marking "create a new entity" — same sentinel the legacy MES used, so the
// synthesis path is diff-reviewable against it. Committed by the PSP pinned "New <Entity>..." create row (OnCreate).
const NEW_ENTITY_ID = '__NEW__';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsCascadePicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The intermediate broker base for the MaterialsEntitySelector family port (beast §8.8, architecture A):
 * `Picker` (config, `__Record`, filters, defaults) → `MaterialsCascadePicker` (THIS — the shared cascade
 * infrastructure the legacy MES base carried) → the bespoke `Materials*Picker` subclasses, each mirroring
 * its MES counterpart 1:1 for diff-review.
 *
 * Shared infrastructure ported from the MES base:
 *   - the cross-widget EVENT BUS fan-out (`<Entity>Changed:<trackingGUID>:<recordAddress>` +
 *     `FireTriggerGroupOnRecordRefresh`), fired from `_onEntityRecordCascade` — the broker seam that
 *     replaces the legacy `_onRecordRefresh` — and received via onAfterEvent(Tabular)Completion.
 *   - tracking-GUID plumbing (`MATERIALS-ENTITY-TRACKING-GUID-…` — SAME element id as the legacy
 *     templates, so still-legacy sibling selectors keep binding from a migrated Sample during the
 *     phased rollout).
 *   - `__Salt` (record-uniqueness salt kept beside `__Record`) + record-template translation.
 *   - the creation-GUID record identity (`GUID<Entity>` when creation is enabled) + the System-1
 *     local-record resolver, which doubles as the `_refreshEntityRecord` CLOBBER-GUARD: a synthesized
 *     unsaved record would miss every server lookup, and the guard keeps the snapshot without a
 *     guaranteed-miss round trip.
 */
class PictProviderInputTypeMaterialsCascadePicker extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		// Inherited fable-service members the duplicate-pict-provider type chain hides from tsc.
		/** @type {Record<string, any>} */
		this.options;
		/** @type {any} */
		this.log;
	}

	/**
	 * The pinned "New <Entity>..." row of a creation-enabled picker: always at the top of the open list,
	 * no typing needed, as the legacy pinned row (GetPinnedItem) was. Choosing it commits the
	 * NEW_ENTITY_ID sentinel, which onDataChange rewrites into a synthesized record; any typed term is
	 * ignored, as the legacy row ignored it.
	 * @param {Record<string, any>} pConfig - The picker config, given its Entity.
	 */
	_applyNewEntityRow(pConfig)
	{
		const tmpLabel = `New ${pConfig.Entity}...`;
		pConfig.OnCreate = () => ({ Value: NEW_ENTITY_ID, Text: tmpLabel });
		pConfig.CreateAlwaysVisible = true;
		pConfig.CreateLabel = tmpLabel;
	}

	/**
	 * Whether entity creation is enabled for this input — the per-input PictForm flag, falling back to
	 * the provider option the creating subclasses set. Latches a provider-level flag so the save-time
	 * EntityData projection fires even on a form where no sibling selector owns that trigger.
	 * Ported from the MES base.
	 * @param {Record<string, any>} pInput @return {boolean}
	 */
	_isEntityCreationEnabled(pInput)
	{
		const tmpEnabled = ((pInput?.PictForm?.AllowEntityCreation ?? this.options.AllowEntityCreation) === true);
		if (tmpEnabled)
		{
			this._entityCreationEnabled = true;
		}
		return tmpEnabled;
	}

	/**
	 * The record identity: a creation-enabled selector tracks records by `GUID<Entity>` (a new record
	 * has no numeric `ID<Entity>` yet) — the MES `_getDefaultRecordIdentity` branch layered onto the
	 * base broker's RecordIdentity/IdentityField precedence.
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (tmpPictForm.RecordIdentity || tmpPictForm.IdentityField)
		{
			return super._getRecordIdentity(pInput);
		}
		const tmpEntity = this._resolveEntity(tmpPictForm);
		if (this._isEntityCreationEnabled(pInput))
		{
			return `GUID${tmpEntity}`;
		}
		return `ID${tmpEntity}`;
	}

	/**
	 * Carry the cascade identity into the picker config: a creation-enabled field commits its GUID
	 * identity, so PSP's ValueField must match what the legacy select2 committed (GetRecordID read
	 * `_getRecordIdentity` too).
	 * @param {Record<string, any>} pInput @param {string} pHostSelector @param {Function} fOnChange
	 * @return {Record<string, any>}
	 */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpConfig = super._buildPickerConfig(pInput, pHostSelector, fOnChange);
		if (tmpConfig.Entity)
		{
			const tmpIdentity = this._getRecordIdentity(pInput);
			if (!((pInput.PictForm || {}).IdentityField) && tmpIdentity !== `ID${tmpConfig.Entity}`)
			{
				tmpConfig.ValueField = tmpIdentity;
			}
			if (this._isEntityCreationEnabled(pInput) && !tmpConfig.OnCreate)
			{
				this._applyNewEntityRow(tmpConfig);
			}
			// A distilled field lists its Dynamic picklist, as MaterialsEntitySelector's dynamicLocalPaginationAdapter did.
			const fPickListDataProvider = this._createDynamicPickListDataProvider(pInput);
			if (fPickListDataProvider)
			{
				tmpConfig.PickListDataProvider = fPickListDataProvider;
			}
			if (typeof tmpConfig.ResolveValue !== 'function')
			{
				const tmpMountContext = this._activeTabularContext;
				const tmpMountView = tmpMountContext ? tmpMountContext.pView : null;
				const tmpMountRow = (tmpMountContext && tmpMountContext.pRowIndex != null) ? tmpMountContext.pRowIndex : null;
				tmpConfig.ResolveValue = (pValue) => this._resolveHeldOrEntityOption(tmpConfig, pInput, tmpMountView, tmpMountRow, pValue);
			}
		}
		return tmpConfig;
	}

	/**
	 * Label a saved value from the `__Record` the form holds, as MaterialsEntitySelector did (its local-record render),
	 * so a record the server cannot return (offline, deleted, unreadable) still reads by name and a re-render costs no
	 * read; a value the form holds no record for is read the way pict-section-picker reads any value.
	 * @param {Record<string, any>} pConfig @param {Record<string, any>} pInput @param {Object|null} pView
	 * @param {number|string|null} pRowIndex @param {any} pValue
	 * @return {Promise<Record<string, any>|null>} the option, or null.
	 */
	_resolveHeldOrEntityOption(pConfig, pInput, pView, pRowIndex, pValue)
	{
		const tmpIdentity = this._getRecordIdentity(pInput);
		if (this._findHeldRecord(pView, pInput, tmpIdentity, pValue, pRowIndex))
		{
			return this._resolveIdentityOption(pConfig, pInput, tmpIdentity, pView, pRowIndex, pValue);
		}
		return Promise.resolve(this.pict.providers['Pict-Section-Picker'].createEntityResolveValue(pConfig)(pValue));
	}

	/**
	 * Mount the entity picker, then page a Dynamic picklist in place of the entity search when the config carries
	 * one. The saved value still resolves through the entity read, so it labels from its record.
	 * @param {string} pPickerHash @param {Record<string, any>} pConfig @return {any} The picker view.
	 */
	_instantiatePicker(pPickerHash, pConfig)
	{
		const tmpView = super._instantiatePicker(pPickerHash, pConfig);
		if (tmpView?.options && pConfig && (typeof pConfig.PickListDataProvider === 'function'))
		{
			tmpView.options.DataProvider = pConfig.PickListDataProvider;
		}
		return tmpView;
	}

	/**
	 * Leave out a tag that reads the same as the option's label, as the Select2 family does (Select2Util's
	 * option text, MaterialsEntitySelector._formatRecordForDisplay): every Lab picker is tagged on the Lab's own
	 * Name, and a Sample created on a form is named by its QR code.
	 *
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {Record<string, any>} pConfig - the picker config.
	 * @return {Record<string, any>} The option, or a copy of it.
	 */
	_presentEntityOption(pOption, pConfig)
	{
		const tmpOption = super._presentEntityOption(pOption, pConfig);
		if (!tmpOption || (typeof tmpOption !== 'object') || tmpOption.Tag === undefined || tmpOption.Tag === null)
		{
			return tmpOption;
		}
		const tmpText = (tmpOption.Text === undefined || tmpOption.Text === null) ? '' : String(tmpOption.Text);
		if (String(tmpOption.Tag).trim() !== tmpText.trim())
		{
			return tmpOption;
		}
		const tmpPresented = Object.assign({}, tmpOption);
		delete tmpPresented.Tag;
		return tmpPresented;
	}

	// --- Creation primitives (ported from the MES base _getDefaultRecord/_handleDefaultRecord) ---

	/**
	 * The record to synthesize for a new entity: the descriptor's `DefaultRecord`, plus — when creation
	 * is enabled and not opted out via `GenerateGUID: false` — a client `GUID<Entity>` minted from the
	 * document GUID + a per-input stanza (`GUIDEntityTypeStanza`, e.g. the Sample subclass's 'S') + the
	 * `__Salt`. Raw template tokens; translated downstream in _handleDefaultRecord.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>|undefined}
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = pInput.PictForm?.DefaultRecord;
		if (this._isEntityCreationEnabled(pInput) && pInput.PictForm?.GenerateGUID !== false)
		{
			const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
			const tmpGUIDField = `GUID${tmpEntity}`;
			tmpRecord = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? JSON.parse(JSON.stringify(tmpRecord)) : { };
			if (!tmpRecord[tmpGUIDField])
			{
				const tmpStanza = pInput.PictForm?.GUIDEntityTypeStanza || tmpEntity;
				tmpRecord[tmpGUIDField] = `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-${tmpStanza}-${this._getSalt(pView, pInput, pRowIndex)}`;
			}
		}
		return tmpRecord;
	}

	/**
	 * Synthesize the new record: deep-copy + translate the template tokens, land the record at
	 * `__Record` and its identity as the committed value, and return that value. The subsequent record
	 * refresh hits the System-1 local-record short-circuit (an unsaved GUID would miss every server
	 * lookup), so the cascade fires with the synthesized record and nothing clobbers it.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string|null} [pRowIndex]
	 * @return {any} the synthesized identity value (or null when nothing synthesized)
	 */
	_handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		let tmpDefaultRecord = this._getDefaultRecord(pView, pInput, pRowIndex);
		if (tmpDefaultRecord)
		{
			tmpDefaultRecord = JSON.parse(JSON.stringify(tmpDefaultRecord));
			this._translateRecordTemplateFields(tmpDefaultRecord);
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpSeedRecord = libSeedRecord.getUnsavedSeedRecord(
				this.pict.manifest.getValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex)),
				this._resolveEntity((pInput && pInput.PictForm) || {}), this._getRecordIdentity(pInput));
			if (tmpSeedRecord)
			{
				tmpDefaultRecord = Object.assign(tmpDefaultRecord, tmpSeedRecord);
			}
			const tmpDefaultID = tmpDefaultRecord[this._getRecordIdentity(pInput)];
			pValue = tmpDefaultID || null;
			if (pValue)
			{
				this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex, ''), pValue);
			}
			this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex), tmpDefaultRecord);
			// A record created here has no server row yet, so this open never needs to read it.
			const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
			if (pValue && !(Number(tmpDefaultRecord[`ID${tmpEntity}`]) > 0))
			{
				this._openRefreshes().add(this._openRefreshKey(pInput, pValue, pRowIndex));
			}
		}
		return pValue;
	}

	/**
	 * Intercept the NEW_ENTITY_ID commit (the pinned "New <Entity>..." row): force a fresh salt, synthesize the
	 * record, rewrite the committed value to its identity in the DOM (mid provider-loop — no second
	 * dataChanged), then continue the standard path: the base's record refresh short-circuits on the
	 * local record and fires the cascade fenced.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, null);
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, null, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, null);
			this._syncCommittedValueDOM(pInput, pValue, null);
		}
		else if (this._isClearedPickerValue(pValue))
		{
			this._handleEntitySelectionCleared(pView, pInput, null);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of the NEW_ENTITY_ID intercept. */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, pRowIndex);
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
			this._syncCommittedValueDOM(pInput, pValue, pRowIndex);
		}
		else if (this._isClearedPickerValue(pValue))
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * True when init must SYNTHESIZE a record rather than hydrate a stored one: a MaterialsHidden
	 * InputType or a `DefaultToNewRecord` field with no value auto-creates, and a persisted
	 * NEW_ENTITY_ID token re-synthesizes.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_isInitSynthesisValue(pInput, pValue)
	{
		const tmpInputType = pInput?.PictForm?.InputType || '';
		if (pValue === NEW_ENTITY_ID)
		{
			return true;
		}
		return !pValue && (tmpInputType.startsWith('MaterialsHidden') || !!pInput?.PictForm?.DefaultToNewRecord);
	}

	/**
	 * True when init carries a stored value to hydrate. Uses the same split `_refreshEntityRecord`
	 * decides "cleared" on, so the load path can never take that method's destructive clear branch —
	 * init must not blank a `__Record` slot it was not asked to fill.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_hasInitValueToHydrate(pInput, pValue)
	{
		return this._splitPickerValues(pValue, pInput).length > 0;
	}

	/**
	 * Init-time creation (ported) OR load-time hydration. The synthesis branch auto-creates the record;
	 * every other init routes the STORED value through the record refresh, which is the family's only
	 * cascade seam — `MaterialsEntitySelector.onInputInitialize` refreshes unconditionally, and without
	 * the same call here opening a saved document runs no DocumentPolyJoin synthesis, no `<Entity>Changed`
	 * fan-out, no spec-scope prime and no join reconciliation. The local-record short-circuit answers a
	 * matching persisted snapshot without a fetch, so the hydration costs a cascade, not a round trip.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._generateSaltIfNeeded(pView, pInput, null);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (this._isInitSynthesisValue(pInput, pValue))
		{
			const tmpValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, null);
			if (tmpValue)
			{
				this._syncCommittedValueDOM(pInput, tmpValue, null);
				this._refreshEntityRecord(pView, pInput, tmpValue, pTransactionGUID, null);
			}
		}
		else if (this._hasInitValueToHydrate(pInput, pValue))
		{
			this._markReinitOfFiredTriggerGroup(pInput, pValue, null);
			this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, null);
		}
		return tmpResult;
	}

	/** Tabular twin of the init-time creation and load-time hydration. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._generateSaltIfNeeded(pView, pInput, pRowIndex);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (this._isInitSynthesisValue(pInput, pValue))
		{
			const tmpValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
			if (tmpValue)
			{
				this._syncCommittedValueDOM(pInput, tmpValue, pRowIndex);
				this._refreshEntityRecord(pView, pInput, tmpValue, pTransactionGUID, pRowIndex);
			}
		}
		else if (this._hasInitValueToHydrate(pInput, pValue))
		{
			this._markReinitOfFiredTriggerGroup(pInput, pValue, pRowIndex);
			this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		}
		return tmpResult;
	}

	/**
	 * Whether the document is frozen (read-only / Locked): the same signal the entity selector gates refresh on.
	 * @return {boolean}
	 */
	_isRecordFrozen()
	{
		return !this.pict?.AppData?.Interactive || !!this.pict?.AppData?.DocumentData?.ReportData?.Locked;
	}

	/**
	 * Whether a sample-join refresh may rewrite this input's joins. A frozen document keeps the joins it
	 * saved; an input that must follow the database even then sets `PictForm.RefreshJoinsWhenLocked: true`.
	 * @param {Record<string, any>} pInput
	 * @return {boolean}
	 */
	_shouldRefreshSampleJoins(pInput)
	{
		return !this._isRecordFrozen() || pInput?.PictForm?.RefreshJoinsWhenLocked === true;
	}

	/**
	 * The empty-result branch of a sample-join refresh: drop the held joins whose rows were soft-deleted
	 * since the document was saved, and their values from the selection. Only a row read back as deleted
	 * is dropped (`ScopedEntityData.resolveSoftDeletedJoins`); anything else keeps the persisted value. The
	 * drop is a load, so no deletion is staged, and it re-salts the input so a re-add mints a GUID the
	 * deleted row does not own. An input with `RefreshOnOpen: false` keeps its saved snapshot.
	 *
	 * The drop is applied to the joins and value the input holds when the reads settle
	 * (`ScopedEntityData.applySoftDeletedDrop`), not to the ones it started from, so a refresh that landed
	 * meanwhile is not undone and an overlapping drop that already removed the links writes nothing.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {{ Entity: string, ValueField: string, JoinAddress: string, Value: any, Label: string }} pJoinScope
	 * @param {(pDropped: number) => void} fDone - Called once, after any write, with the number of held links
	 *   found deleted.
	 */
	_dropSoftDeletedHeldJoins(pView, pInput, pRowIndex, pJoinScope, fDone)
	{
		if (pInput.PictForm?.RefreshOnOpen === false)
		{
			return fDone(0);
		}
		const tmpHeldJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), pJoinScope.JoinAddress);
		ScopedEntityData.resolveSoftDeletedJoins(this.pict, pJoinScope.Entity, pJoinScope.ValueField, tmpHeldJoins, pJoinScope.Value, (pResult) =>
		{
			if (pResult.Dropped.length < 1)
			{
				return fDone(0);
			}
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpDrop = ScopedEntityData.applySoftDeletedDrop(pJoinScope.Entity, pJoinScope.ValueField,
				this.pict.manifest.getValueAtAddress(tmpDestination, pJoinScope.JoinAddress),
				this.pict.manifest.getValueAtAddress(tmpDestination, this._getPickerValueAddress(pInput, pRowIndex)),
				pResult);
			if (!tmpDrop.Changed)
			{
				return fDone(pResult.Dropped.length);
			}
			ScopedEntityData.beginProgrammaticLoad(this.pict);
			try
			{
				if (tmpDrop.Removed.length > 0)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, pJoinScope.JoinAddress, tmpDrop.Joins);
				}
				const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpHeldRecords = this.pict.manifest.getValueAtAddress(tmpDestination, tmpRecordAddress);
				const tmpKeptRecords = ScopedEntityData.pruneRecordsToValue(tmpHeldRecords, pJoinScope.ValueField, tmpDrop.Value);
				if (tmpKeptRecords !== tmpHeldRecords)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, tmpKeptRecords);
				}
				if (tmpDrop.ValueChanged)
				{
					this._setValueAndCommit(pView, pInput, tmpDrop.Value, pRowIndex);
				}
			}
			finally
			{
				ScopedEntityData.endProgrammaticLoad(this.pict);
			}
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			this.log.info(`${pJoinScope.Label}: dropped ${tmpDrop.Removed.length} link(s) whose record was deleted since the document was saved: ${pResult.Dropped.join(', ')}; value now [${tmpDrop.Value}].`);
			return fDone(pResult.Dropped.length);
		});
	}

	// --- __Salt + record-template translation (ported from the MES base) ---

	/** @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {boolean} [pForce] */
	_generateSaltIfNeeded(pView, pInput, pRowIndex, pForce)
	{
		const tmpSaltAddress = this._getRecordAddress(pInput, pRowIndex, '__Salt');
		const tmpSalt = !pForce && this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress);
		if (!tmpSalt)
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress, this._generateSaltStr());
		}
	}

	/** @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @return {string} */
	_getSalt(pView, pInput, pRowIndex)
	{
		return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex, '__Salt'));
	}

	/** @param {number} [pLength=8] @return {string} */
	_generateSaltStr(pLength = 8)
	{
		let tmpResult = '';
		for (let i = 0; i < pLength; i++)
		{
			tmpResult += SALT_CHARS.charAt(Math.floor(Math.random() * SALT_CHARS.length));
		}
		return tmpResult;
	}

	/** Translate `{~D:…~}` template tokens in every string field of a synthesized record (in place). */
	_translateRecordTemplateFields(pRecord)
	{
		for (const tmpField in pRecord)
		{
			if (typeof pRecord[tmpField] === 'string')
			{
				pRecord[tmpField] = this.pict.parseTemplate(pRecord[tmpField], this.pict);
			}
		}
	}

	// --- Tracking-GUID plumbing (ported; SAME element ids as the legacy templates) ---

	/** @param {string} pInputHTMLID @param {number|string|null} [pRowIndex] @param {string} [pType] @return {string} */
	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType)
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/** @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {string} [pType] @return {string} */
	_getTrackingGUID(pInput, pRowIndex, pType)
	{
		if (pRowIndex == null)
		{
			switch (pType)
			{
			case 'TEST':
				if (pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
				{
					return /** @type {string} */ (pInput.PictForm.TestTrackingGUID);
				}
			// eslint-disable-next-line no-fallthrough
			default:
				if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
				{
					return /** @type {string} */ (pInput.PictForm.SampleTrackingGUID);
				}
			}
		}
		return /** @type {string} */ (this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType)));
	}

	/** @param {Record<string, any>} pInput @param {number|string|null} pRowIndex @param {string} pTrackingGUID @param {string} [pType] */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	/**
	 * Bind a NON-Sample cascade selector's tracking GUID from its sibling Sample descriptor (tabular
	 * group first, then the global manifest) — the sample owns the family's tracking identity.
	 * Ported from the MES base; fired from the marshal hooks like the legacy.
	 * @param {Object} pView @param {Object} pGroup @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (this._resolveEntity((pInput && pInput.PictForm) || {}) == 'Sample')
		{
			return;
		}
		if (pRowIndex != null)
		{
			const tmpLocalManifest = pGroup && pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('MaterialsCascadePicker: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('MaterialsCascadePicker: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('MaterialsCascadePicker: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}

	/** Bind the tracking GUID and bring the value's record on marshal, like the legacy MES onDataMarshalToForm did. */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, null);
		// @ts-ignore — inherited through the PSP chain tsc cannot see (duplicate pict-provider types).
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._backfillRecordOnMarshal(pView, pInput, pValue, null);
		return tmpResult;
	}

	/** Tabular twin of the marshal-time tracking-GUID bind and record backfill. */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		const tmpResult = super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._backfillRecordOnMarshal(pView, pInput, pValue, pRowIndex);
		return tmpResult;
	}

	/**
	 * When a marshalled single value (a solver or an autofill wrote it) is not the entity its held `__Record` holds,
	 * read the value's row into `__Record`, as `MaterialsEntitySelector._backfillMissingRecords` did on marshal: the
	 * record only, with no cascade, so a solver reading `__Record` computes from the row the field shows. A frozen
	 * document keeps its saved record, a failed read keeps what is held, and a read that lands after the value moved
	 * on writes nothing.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 * @return {Promise<void>|void}
	 */
	_backfillRecordOnMarshal(pView, pInput, pValue, pRowIndex)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (this._isRecordFrozen() || this._isMultiplePicker(tmpPictForm) || !pView || (typeof pView.getMarshalDestinationObject !== 'function'))
		{
			return;
		}
		const tmpValues = this._splitPickerValues(pValue, pInput);
		if (tmpValues.length !== 1 || tmpValues[0] === NEW_ENTITY_ID || this._getLocalRecordForValue(pView, pInput, tmpValues[0], pRowIndex))
		{
			return;
		}
		const tmpEntity = this._resolveEntity(tmpPictForm);
		const tmpKey = this._openRefreshKey(pInput, tmpValues[0], pRowIndex);
		if (!tmpEntity || this._openRefreshes().has(tmpKey))
		{
			return;
		}
		this._openRefreshes().add(tmpKey);
		const tmpValueAddress = (pRowIndex != null) ?
			this.pict.providers.Informary.getComposedContainerAddress(tmpPictForm.InformaryContainerAddress, pRowIndex, tmpPictForm.InformaryDataAddress) :
			(pInput.DataAddress || pInput.Hash);
		const tmpIdentity = this._getRecordIdentity(pInput);
		return this._resolveEntityRecord(tmpEntity, tmpValues[0], pInput).then((pRecord) =>
		{
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpCurrentValue = this._splitPickerValues(this.pict.manifest.getValueAtAddress(tmpDestination, tmpValueAddress), pInput);
			if (!pRecord || (pRecord[tmpIdentity] == null) || (tmpCurrentValue.length !== 1) || (tmpCurrentValue[0] !== tmpValues[0]))
			{
				return;
			}
			this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex), pRecord);
		}).catch((pError) =>
		{
			this.pict.log.warn(`Picker [${pInput.Hash}]: marshal record backfill failed for [${tmpValues[0]}]: ${pError.message || pError}`);
		});
	}

	// --- System-1 local-record resolve + the __Record clobber-guard ---

	/**
	 * The locally-held record for a value — the persisted `__Record` snapshot or a freshly synthesized
	 * record — when its IDENTITY MATCHES the committed value. Returns a shallow copy, or null when
	 * System 2 must load.
	 *
	 * REASONED DIVERGENCE from the MES base (live-found 2026-07-17, the B2 clear-reset family): the
	 * legacy carried a second keep-branch — "unsaved record (client identity, no server id) → retain" —
	 * which returned the SYNTHESIZED record even after the user picked a DIFFERENT entity, so the
	 * cascade (DocumentPolyJoin, SampleChanged fan-out) ran against the phantom created record. The
	 * branch was creation-flow armor the port does not need: every creation path (the NEW_ENTITY_ID
	 * intercepts and the init auto-create) rewrites the committed value to the synthesized identity
	 * BEFORE the record refresh runs, so the identity-match branch already covers creation — a mismatch
	 * can only mean the value moved on, exactly when the snapshot must NOT be kept.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>|null}
	 */
	_getLocalRecordForValue(pView, pInput, pValue, pRowIndex)
	{
		const tmpLocalRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		if (tmpLocalRecord && typeof tmpLocalRecord === 'object' && !Array.isArray(tmpLocalRecord))
		{
			const tmpIdentity = this._getRecordIdentity(pInput);
			if (tmpLocalRecord[tmpIdentity] == pValue)
			{
				return Object.assign({}, tmpLocalRecord);
			}
		}
		return null;
	}

	/**
	 * CLOBBER-GUARD + System-1 short-circuit over the base record refresh: when the committed (single)
	 * value is already answered by the local `__Record` and `_keepsHeldRecord` allows it — a frozen
	 * document, `RefreshOnOpen: false`, a freshly synthesized unsaved record whose GUID would miss every
	 * server lookup, or a value this document open has already read — keep it and fire the cascade seam
	 * directly. Everything else (clears, multi, a value to read) delegates to the base, which reconciles
	 * the row through `_reconcileRefreshedRecord`.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string|null} [pRowIndex]
	 * @return {Promise<any>|void}
	 */
	_refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		const tmpValues = this._splitPickerValues(pValue, pInput);
		if (tmpValues.length === 1 && !this._isMultiplePicker(pInput.PictForm) && pView && typeof pView.getMarshalDestinationObject === 'function')
		{
			const tmpLocalRecord = this._getLocalRecordForValue(pView, pInput, tmpValues[0], pRowIndex);
			if (tmpLocalRecord && this._keepsHeldRecord(pInput, tmpLocalRecord, tmpValues[0], pRowIndex))
			{
				// The snapshot at the address IS the record (the copy protects the caller); fence the
				// cascade exactly like the base select path so async cascade writes land pre-PostSolvers.
				const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
				const tmpOperationHash = `PickerRecordLocal-${this._getRecordAddress(pInput, pRowIndex)}-${this.pict.getUUID()}`;
				const tmpFenced = !!pTransactionGUID && typeof pView.registerEventTransactionAsyncOperation === 'function';
				if (tmpFenced)
				{
					pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpOperationHash);
				}
				return Promise.resolve()
					.then(() => this._onEntityRecordCascade(pView, pInput, tmpRecord, pRowIndex, pTransactionGUID))
					.catch((pError) =>
					{
						this.pict.log.error(`Picker [${pInput.Hash}]: error in local-record cascade: ${pError.message || pError}`);
					})
					.finally(() =>
					{
						if (tmpFenced)
						{
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpOperationHash);
						}
					});
			}
			this._openRefreshes().add(this._openRefreshKey(pInput, tmpValues[0], pRowIndex));
		}
		return super._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
	}

	/**
	 * Whether a refresh answers from the record the form holds instead of reading the server. The open-refresh
	 * rule `MaterialsEntitySelector._refreshRecord` applies, and the two must agree: a frozen document or a field
	 * with `RefreshOnOpen: false` keeps its saved record. The port adds one case: a value this document open has
	 * already read, or created (`_handleDefaultRecord` marks a new record read), so neither a re-render nor a record
	 * with no server row yet costs a read. A held record without an `ID<Entity>` is still read: the server may have
	 * saved it after the document did.
	 * @param {Record<string, any>} pInput @param {Record<string, any>} pHeldRecord @param {any} pValue
	 * @param {number|string|null} [pRowIndex]
	 * @return {boolean}
	 */
	_keepsHeldRecord(pInput, pHeldRecord, pValue, pRowIndex)
	{
		if (this._isRecordFrozen() || pInput?.PictForm?.RefreshOnOpen === false)
		{
			return true;
		}
		return this._openRefreshes().has(this._openRefreshKey(pInput, pValue, pRowIndex));
	}

	/**
	 * @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 * @return {string} the key a document open records a read under.
	 */
	_openRefreshKey(pInput, pValue, pRowIndex)
	{
		const tmpDocument = this.pict?.AppData?.DocumentData?.ReportData?.GUIDDocument || '';
		return `${tmpDocument}|${this._getRecordAddress(pInput, pRowIndex)}|${pValue}`;
	}

	/** @return {Set<string>} the values read since the document opened (see `_openRefreshKey`). */
	_openRefreshes()
	{
		if (!this._openRefreshedKeys)
		{
			this._openRefreshedKeys = new Set();
		}
		return this._openRefreshedKeys;
	}

	/**
	 * A re-render re-runs `onInputInitialize` for every input in the section. When the value's trigger group already
	 * fired this document open, the re-init must not fire it again: a group whose PostSolvers refresh a table in the
	 * emitter's own section would re-render it, re-init the emitter, and loop without yielding (the local-record
	 * short-circuit answers in a microtask). The `<Entity>Changed` fan-out still runs. Diverges from the legacy
	 * `MaterialsEntitySelector._refreshRecord`, which re-fires on every re-init after a server read.
	 * @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 */
	_markReinitOfFiredTriggerGroup(pInput, pValue, pRowIndex)
	{
		if (!pInput?.PictForm?.FireTriggerGroupOnRecordRefresh || this._isMultiplePicker(pInput.PictForm))
		{
			return;
		}
		const tmpKey = this._openRefreshKey(pInput, pValue, pRowIndex);
		if (this._firedTriggerGroups().has(tmpKey))
		{
			this._reinitTriggerGroupKeys().add(tmpKey);
		}
	}

	/**
	 * Whether this cascade fires the input's trigger group: false for a re-init of a value whose group already fired
	 * this open (see `_markReinitOfFiredTriggerGroup`); otherwise true, and the value is recorded as fired.
	 * @param {Record<string, any>} pInput @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string|null} [pRowIndex]
	 * @return {boolean}
	 */
	_claimTriggerGroupFire(pInput, pRecord, pRowIndex)
	{
		const tmpValue = (pRecord && !Array.isArray(pRecord)) ? pRecord[this._getRecordIdentity(pInput)] : undefined;
		if (tmpValue === undefined || tmpValue === null || tmpValue === '')
		{
			return true;
		}
		const tmpKey = this._openRefreshKey(pInput, tmpValue, pRowIndex);
		if (this._reinitTriggerGroupKeys().delete(tmpKey))
		{
			return false;
		}
		this._firedTriggerGroups().add(tmpKey);
		return true;
	}

	/** @return {Set<string>} the values whose trigger group fired since the document opened (see `_openRefreshKey`). */
	_firedTriggerGroups()
	{
		if (!this._firedTriggerGroupKeys)
		{
			this._firedTriggerGroupKeys = new Set();
		}
		return this._firedTriggerGroupKeys;
	}

	/** @return {Set<string>} re-inits waiting on their cascade, which will not fire the trigger group. */
	_reinitTriggerGroupKeys()
	{
		if (!this._reinitTriggerGroupKeySet)
		{
			this._reinitTriggerGroupKeySet = new Set();
		}
		return this._reinitTriggerGroupKeySet;
	}

	/**
	 * Reconcile a refreshed row with the record the form holds — the rule `MaterialsEntitySelector._reconcileRefreshedRecord`
	 * applies, and the two must agree. A re-read of the held record is server state, so the baseline takes the
	 * fields the server moved (`EntityDataBaseline.classifyRecordRefresh`); a held change the server does not
	 * have keeps the held record; a changed selection takes the row. No "out of date" flag: DetectDesync is not
	 * ported to this family.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pHeldRecord
	 * @param {Record<string, any>} pFetchedRecord @param {string} pIdentityField @param {any} pValue
	 * @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>} the record to write.
	 */
	_reconcileRefreshedRecord(pView, pInput, pHeldRecord, pFetchedRecord, pIdentityField, pValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !pHeldRecord || typeof pHeldRecord !== 'object' || Array.isArray(pHeldRecord) || pHeldRecord[pIdentityField] != pValue)
		{
			return pFetchedRecord;
		}
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpGUID = pFetchedRecord[`GUID${tmpEntity}`] || pHeldRecord[`GUID${tmpEntity}`];
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpDecision = EntityDataBaseline.classifyRecordRefresh(this.pict, tmpContext, tmpEntity, tmpGUID, pHeldRecord, pFetchedRecord);
		if (tmpDecision.Action === 'keep')
		{
			this.pict.log.info(`MaterialsCascadePicker: kept the held ${tmpEntity} ${tmpGUID} over the server row: ${tmpDecision.Reason}.`);
			return pHeldRecord;
		}
		if (tmpDecision.Action === 'adopt')
		{
			EntityDataBaseline.adoptRefreshedFields(this.pict, tmpContext, tmpEntity, tmpGUID, pFetchedRecord, tmpDecision.Fields);
		}
		return pFetchedRecord;
	}

	// --- The event bus (the port of the legacy MES base _onRecordRefresh fan-out) ---

	/**
	 * Fan the record refresh out on the cross-widget bus: `<Entity>Changed:<trackingGUID>:<address>`,
	 * plus the opt-in `TriggerGroup:<hash>:RecordRefresh:…` (tabular variant carries the emitting row
	 * index so a dependent picker clears only its own row). Subclasses layer their bespoke cascade on
	 * top and call super for the fan-out.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 * @return {void|Promise<any>}
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpEvent = `${tmpEntity}Changed:${this._getTrackingGUID(pInput, pRowIndex)}:${this._getRecordAddress(pInput, pRowIndex)}`;
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, pTransactionGUID);
		if (pInput.PictForm.FireTriggerGroupOnRecordRefresh && this._claimTriggerGroupFire(pInput, pRecord, pRowIndex))
		{
			const tmpEmitterHash = pInput.Hash || pInput.DataAddress;
			// Hydration guard: this fan-out is a SYNCHRONOUS cascade (the trigger group plus every sibling
			// autofill it emits), and a load is authoritative — persisted values must display, not be re-vetted
			// against the current filter scope. The autofill-scope vet skips while the counter is set. Shared
			// with MaterialsEntitySelector by name so either family suppresses the other. Counter handles
			// re-entrant refreshes; finally guarantees the reset even if a handler throws.
			this.pict._MaterialsEntityHydrationDepth = (this.pict._MaterialsEntityHydrationDepth || 0) + 1;
			try
			{
				if (pRowIndex != null)
				{
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${pRowIndex}:${this.pict.getUUID()}`);
				}
				else
				{
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${this.pict.getUUID()}`);
				}
			}
			finally
			{
				this.pict._MaterialsEntityHydrationDepth--;
			}
		}
	}

	// --- Cross-widget event reception (the legacy onAfterEvent(Tabular)Completion seam) ---

	/**
	 * The per-subclass event handler. The base handles the save-projection sweep; subclasses override
	 * to handle their targeted events and call super (or replace it — the Sample subclass projects via
	 * its own _handleEvent, idempotently over the same GUID key).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	// eslint-disable-next-line no-unused-vars
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID);
	}

	// --- The _EntityData save projection (ported from the MES base) ---

	/**
	 * Fire the save-time EntityData projection when this provider has at least one creation-enabled
	 * input (latched in _isEntityCreationEnabled): reset `FormData._EntityData`, broadcast the
	 * ProjectEntityDataRecords sweep inside a transaction so every cascade input projects its created
	 * `__Record` (+ DocumentPolyJoin) into it, then continue the save once the sweep completes.
	 * Providers' onBeforeSaveDataAsync run once each; redundant passes are idempotent (same target,
	 * same GUID keys). No-op — and no empty _EntityData reset — with no creation-enabled input.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (!this._entityCreationEnabled)
		{
			// @ts-ignore — inherited through the PSP chain tsc cannot see.
			return super.onBeforeSaveDataAsync(fCallback);
		}
		if (!this._isScopedEntityDataEnabled())
		{
			this.pict.manifest.setValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.FormData._EntityData', { });
		}
		const tmpEvent = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';
		const tmpTransactionGUID = this.pict.getUUID();
		/** @type {any} */ (this.pict).TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this._sanitizeProjectedComprehensions();
			// @ts-ignore — inherited through the PSP chain tsc cannot see.
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * The object this input projects its created records into on the save sweep, keyed
	 * `<Entity>.<GUID>`. THE ONE PLACE the scoped/legacy decision is made on the emission side: the
	 * projectors below take the object and are identical on both paths, because a context root and
	 * the legacy ledger have the same shape.
	 *
	 * Scoped roots are remembered for the post-sweep sanitize pass.
	 *
	 * @param {Record<string, any>} pInput - The form input descriptor.
	 * @param {string} pEvent - The sweep event.
	 * @return {Record<string, any>|null} - The projection target, or null when this is not a sweep
	 *   event or no target resolves (never fabricates one).
	 */
	_getProjectionTarget(pInput, pEvent)
	{
		if (typeof pEvent !== 'string')
		{
			return null;
		}
		const [ tmpEventType, tmpTargetAddress ] = pEvent.split(':');
		if (tmpEventType !== 'ProjectEntityDataRecords')
		{
			return null;
		}
		if (this._isScopedEntityDataEnabled())
		{
			const tmpContext = this._getComprehensionContext(pInput);
			const tmpContextRoot = ScopedEntityData.resolveContextRoot(this.pict, tmpContext);
			// A baseline sweep collects into a detached scratch tree: nothing was emitted, so neither the
			// FormEntityCreator cross-check nor the post-sweep delta pass may be armed by it.
			if (tmpContextRoot && !ScopedEntityData.getBaselineSweepTarget(this.pict))
			{
				ScopedEntityData.markActive(this.pict);
				if (!this._scopedProjectionRoots)
				{
					this._scopedProjectionRoots = new Map();
				}
				this._scopedProjectionRoots.set(tmpContext, tmpContextRoot);
				ScopedEntityData.noteProjectionRoot(this.pict, tmpContext, tmpContextRoot);
			}
			return tmpContextRoot;
		}
		if (!tmpTargetAddress)
		{
			return null;
		}
		const tmpTarget = this.pict.manifest.getValueAtAddress(this.pict, tmpTargetAddress);
		if (!tmpTarget || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return null;
		}
		return tmpTarget;
	}

	/**
	 * Narrow every scoped root this provider projected into during the sweep: strip transient `__` UI
	 * state, then reduce each record to what changed since the baseline. Runs once, after the sweep,
	 * rather than at each write — the projectors key the form's LIVE record objects in, so acting
	 * earlier would either mutate the record the form renders from or force every projector to clone.
	 *
	 * Shares the pass with `MaterialsEntitySelector` so the two families cannot disagree on what a
	 * change is; they sweep one target and a partially-converted family would emit incoherently.
	 */
	_sanitizeProjectedComprehensions()
	{
		// Roots any picker-family input noted on this sweep, not only this provider's: a driver with no
		// inputs of its own still re-projects every other provider's records.
		const tmpRoots = new Map(this._scopedProjectionRoots || []);
		for (const [ tmpContext, tmpContextRoot ] of ScopedEntityData.takeNotedProjectionRoots(this.pict))
		{
			tmpRoots.set(tmpContext, tmpContextRoot);
		}
		if (tmpRoots.size < 1)
		{
			return;
		}
		// Handed to the document save, which folds every provider's emission ONCE just before the PUT.
		// Folding here instead would advance the baseline mid-save, and the next provider's prune over
		// this same root would then suppress every record and send an empty comprehension.
		const tmpEmitted = new Map();
		for (const [ tmpContext, tmpContextRoot ] of tmpRoots)
		{
			EntityDataBaseline.pruneContextRootToDelta(this.pict, tmpContext, tmpContextRoot);
			tmpEmitted.set(tmpContext, tmpContextRoot);
		}
		if (this._scopedProjectionRoots)
		{
			this._scopedProjectionRoots.clear();
		}
		tmpEmitted.forEach((pContextRoot, pContext) => EntityDataBaseline.recordPendingEmission(this.pict, pContext, pContextRoot));
	}

	/**
	 * Ask for the load-settled baseline capture on this render transaction. Idempotent across every
	 * input on the form and across both input families — the first to ask schedules it.
	 * @param {Object} pView @param {string} [pTransactionGUID]
	 */
	_scheduleBaselineCapture(pView, pTransactionGUID)
	{
		if (!this._isScopedEntityDataEnabled())
		{
			return;
		}
		EntityDataBaseline.scheduleLoadBaselineCapture(this.pict, pView, pTransactionGUID);
	}


	/**
	 * Generic save-time projection handler: on the ProjectEntityDataRecords sweep, write this input's
	 * created `__Record` into the shared collection (keyed `[Entity][GUID<Entity>]`), plus any sibling
	 * DocumentPolyJoin. Opt-in via creation; opt-out per input via SkipEntityDataProjection;
	 * _syncRecordToEntityData no-ops unless the record carries its GUID — a second safety gate.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string' || !this._isEntityCreationEnabled(pInput) || pInput?.PictForm?.SkipEntityDataProjection)
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpDocumentPolyJoinAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${tmpRecordAddress}_DocumentPolyJoin`;
		const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
		if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
		{
			if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
			{
				tmpTarget.DocumentPolyJoin = { };
			}
			tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
		}
	}

	/**
	 * Whether this provider emits scoped `Document.EntityData` comprehensions instead of the legacy
	 * `FormData._EntityData` ledger. The same flag stands `FormEntityCreator` down, so the two
	 * paths never run together.
	 * @return {boolean}
	 */
	_isScopedEntityDataEnabled()
	{
		return ScopedEntityData.isEnabled(this.pict);
	}

	/**
	 * The trigger context this input's records are applied under. Scheduling is manifest data:
	 * `PictForm.ComprehensionContext` selects it, the provider default (`OnSave`) applies otherwise.
	 * @param {Record<string, any>} pInput
	 * @return {string}
	 */
	_getComprehensionContext(pInput)
	{
		return ScopedEntityData.resolveContext(pInput, this.options?.ComprehensionContext || ScopedEntityData.DEFAULT_CONTEXT);
	}

	/** A committed picker value that means "nothing selected". @param {any} pValue @return {boolean} */
	_isClearedPickerValue(pValue)
	{
		return (pValue == null) || (pValue === '') || (pValue === 'null') || (pValue === 'undefined');
	}


	/**
	 * A creation-enabled selection was cleared. Two things follow, both only under the scoped path:
	 * a tombstone for the record IF it is known to exist server-side (never for one that has not
	 * been saved), and a FRESH `__Salt` so a re-add mints a NEW GUID — the apply cannot un-delete a
	 * soft-deleted row, because `Deleted` is stripped at marshal, so re-using the GUID would upsert
	 * into the tombstoned row. No-op unless the cleared record actually carried its client GUID.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_handleEntitySelectionCleared(pView, pInput, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !this._isEntityCreationEnabled(pInput))
		{
			return;
		}
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		const tmpGUID = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[`GUID${tmpEntity}`] : null;
		if (!tmpGUID)
		{
			return;
		}
		this._stageRemovalTombstones(pInput, this._collectRemovedDependentRecords(pView, pInput, pRowIndex, new Set()), 'clear');
		this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
	}

	/**
	 * Stage tombstones for a set of removed records and report what happened. Every removal route in
	 * this family funnels through here, so the gates (persisted, document-owned) and the logging are
	 * applied once. A record the guard would refuse is logged at debug and NOT staged — see
	 * `docs/plans/entitydata-round2/05-client-delete-completeness.md` §4.
	 * @param {Record<string, any>} pInput @param {Array<{ Entity: string, Record: Record<string, any> }>} pRemovals
	 * @param {string} pReason - What removed them, for the log line.
	 * @return {number} - How many tombstones were staged.
	 */
	_stageRemovalTombstones(pInput, pRemovals, pReason)
	{
		if (!this._isScopedEntityDataEnabled() || !Array.isArray(pRemovals) || pRemovals.length < 1)
		{
			return 0;
		}
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, tmpContext, pRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`MaterialsCascadePicker[${pInput.Hash || pInput.DataAddress}]: staged deletion of ${tmpResult.Staged.length} record(s) on ${pReason}.`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * The identity values a committed selection retains, as a Set of strings.
	 * @param {any} pValue @return {Set<string>}
	 */
	_getRetainedIdentitySet(pValue)
	{
		const tmpRetained = new Set();
		if (pValue == null || pValue === '')
		{
			return tmpRetained;
		}
		for (const tmpToken of String(pValue).split(','))
		{
			const tmpTrimmed = tmpToken.trim();
			if (tmpTrimmed.length > 0)
			{
				tmpRetained.add(tmpTrimmed);
			}
		}
		return tmpRetained;
	}

	/**
	 * Records this input's SUBCLASS holds that belong to a de-selected value. The base holds none.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	// eslint-disable-next-line no-unused-vars
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		if (pRetainedIdentities.size > 0)
		{
			return [ ];
		}
		const tmpAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${this._getRecordAddress(pInput, pRowIndex)}_DocumentPolyJoin`;
		return ScopedEntityData.collectTestInstanceUnit({ DocumentPolyJoin: this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress) });
	}

	/**
	 * The de-selection seam — the Picker twin of `MaterialsEntitySelector._handleSelectionRemovals`,
	 * and asserted equivalent to it by the parity contract. Suppressed during a programmatic load,
	 * because a loader that seeds a value re-enters here indistinguishably from a user de-selection.
	 * Anything removed also rotates `__Salt`, exactly as the selector does.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 */
	_handleSelectionRemovals(pView, pInput, pValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || ScopedEntityData.isProgrammaticLoad(this.pict))
		{
			return;
		}
		const tmpRetained = this._getRetainedIdentitySet(pValue);
		const tmpRemovals = this._collectRemovedDependentRecords(pView, pInput, pRowIndex, tmpRetained);
		this._stageRemovalTombstones(pInput, tmpRemovals, 'de-selection');
		if (tmpRemovals.length > 0)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
		}
	}

	/**
	 * Project this input's `__Record` into the entity-data collection, keyed `[Entity][GUID<Entity>]`.
	 * No-op unless the record carries its client GUID (only created/creating records project).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Record<string, Record<string, any>>} [pTargetObject]
	 */
	_syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !tmpRecord[`GUID${tmpEntity}`])
		{
			return;
		}
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}
		if (!tmpEntityData[tmpEntity] || typeof tmpEntityData[tmpEntity] !== 'object' || Array.isArray(tmpEntityData[tmpEntity]))
		{
			tmpEntityData[tmpEntity] = { };
		}
		tmpEntityData[tmpEntity][tmpRecord[`GUID${tmpEntity}`]] = tmpRecord;
	}

	/**
	 * Whether `_handleEvent` runs for this event while the event is being raised (`onEvent`) instead of
	 * once its transaction has completed. An event whose handler registers async loads on the transaction
	 * must be handled here: pict-section-form deletes a transaction right after running its completion
	 * callbacks, so a load registered from one of them is orphaned and the form settles before it lands.
	 * @param {string} pEvent
	 * @return {boolean}
	 */
	_handlesEventOnTrigger(pEvent)
	{
		if (typeof pEvent !== 'string')
		{
			return false;
		}
		return this._getTriggerTimeEventTypes().includes(pEvent.split(':')[0]);
	}

	/**
	 * The event types `_handleEvent` handles while they are raised (see `_handlesEventOnTrigger`).
	 * @return {Array<string>}
	 */
	_getTriggerTimeEventTypes()
	{
		return [ ];
	}

	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		if (this._handlesEventOnTrigger(pEvent))
		{
			this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		}
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (this._handlesEventOnTrigger(pEvent))
		{
			this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		if (!this._handlesEventOnTrigger(pEvent))
		{
			this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		}
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!this._handlesEventOnTrigger(pEvent))
		{
			this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = PictProviderInputTypeMaterialsCascadePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;
module.exports.NEW_ENTITY_ID = NEW_ENTITY_ID;

},{"./PictProvider-InputType-Picker.js":117,"./_EntityDataBaseline.js":154,"./_ScopedEntityData.js":162,"./_SeedRecord.js":163}],87:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libEntityDisplayName = require('./_EntityDisplayName.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorDisplayInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}

	/**
	 * The display name for a resolved entity, matching the PSP PickerDisplay contract so the old and new
	 * providers render identically through the migration:
	 *   - a present resolved name passes through,
	 *   - a resolved-but-blank name -> `<entity label> #<record ID>` (`Contractor #3456`),
	 *   - an unresolved/orphan id -> the raw stored value (orphan visibility), never an "Unnamed ..." label.
	 *
	 * @param {any} pDisplayName - The resolved display name from Select2Util.getEntityWithDisplayAsync.
	 * @param {Record<string, any>} pEntity - The raw entity record (has `.Name`, never `.DisplayName`).
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The raw stored value (id) for the orphan fallback.
	 * @return {string}
	 */
	_resolveDisplayNameHTML(pDisplayName, pEntity, pInput, pValue)
	{
		if (pDisplayName !== undefined && pDisplayName !== null && String(pDisplayName).trim() !== '')
		{
			return String(pDisplayName);
		}
		if (pEntity && pEntity[`ID${ this._getEntity(pInput) }`])
		{
			return libEntityDisplayName.unnamedEntityLabel(this._getEntity(pInput), pEntity[`ID${ this._getEntity(pInput) }`], pInput?.Name);
		}
		// Nothing resolved (orphan id) -> show the raw value so the bad reference stays visible.
		return String(pValue);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders a static `...TABULAR-DATA-...` div (no select2 dropdown), so target that
		// via getTabularSelectInputID. The `...TABULAR-DROPDOWN-...` id is never rendered here, so using it
		// silently bailed and left the raw ID the base marshal wrote into the cell.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];

		// if multiple, pValue will be a comma-separated list of IDs
		if (pInput.PictForm && pInput.PictForm.Multiple && typeof(pValue) === 'string')
		{
			const tmpValues = pValue.split(',');
			const tmpDisplayValues = [];
			for (const tmpValue of tmpValues)
			{
				if (tmpValue)
				{
					const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue,
					{
						JoinEntity: pInput.PictForm.JoinEntity,
						JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
						JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
						EntityDisplayField: pInput.PictForm.EntityDisplayField,
						JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
						Disabled: pInput.PictForm.Disabled || false,
						EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
					});
					// if we have an EntityTag, display that as a tag along with the Name
					if (pInput.PictForm.EntityTag)
					{
						let isDateTag = false;
						let tmpEntityTag = pInput.PictForm.EntityTag;
						if (pInput.PictForm.EntityTag.includes(':date'))
						{
							// update the EntityTag to remove the :date for display purposes
							tmpEntityTag = tmpEntityTag.replace(':date', '');
							isDateTag = true;
						}
						let tmpDisplayTemplate = '';
						if (tmpInputSelectElement.tagName === 'DIV')
						{
							tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
								isDateTag ? this.pict.Dates.dayJS(tmpEntity[tmpEntityTag]).format('YYYY-MM-DD') : tmpEntity[tmpEntityTag] || 'N/A',
								this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, tmpValue),
								true,
								tmpEntity.EntityTagLast,
							);
						}
						else
						{
							tmpDisplayTemplate = tmpValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
						}
						tmpDisplayValues.push(tmpDisplayTemplate);
					}
					else
					{
						tmpDisplayValues.push(this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, tmpValue));
					}
				}
			}
			// make the container look like a textarea for multiple values
			this.pict.ContentAssignment.addClass(tmpInputSelectElement, 'textarea');
			this.pict.ContentAssignment.removeClass(tmpInputSelectElement, 'input');
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayValues.join(', '));
			return;
		}
		// for single value
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), pValue,
			{
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				Disabled: pInput.PictForm.Disabled || false,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let isDateTag = false;
				let tmpEntityTag = pInput.PictForm.EntityTag;
				if (pInput.PictForm.EntityTag.includes(':date'))
				{
					// update the EntityTag to remove the :date for display purposes
					tmpEntityTag = tmpEntityTag.replace(':date', '');
					isDateTag = true;
				}
				let tmpDisplayTemplate = '';
				if (tmpInputSelectElement.tagName === 'DIV')
				{
					tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
						isDateTag ? this.pict.Dates.dayJS(tmpEntity[tmpEntityTag]).format('YYYY-MM-DD') : tmpEntity[tmpEntityTag] || 'N/A',
						this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, pValue),
						false,
						tmpEntity.EntityTagLast,
					);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
			}
			else
			{
				const displayString = this._resolveDisplayNameHTML(tmpDisplayName, tmpEntity, pInput, pValue);
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, displayString);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = MaterialsSelectorDisplayInputHandler;

},{"./_EntityDisplayName.js":155,"pict-section-form":587}],88:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const libEntityDisplayName = require('./_EntityDisplayName.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsEntityPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The base MaterialsEntitySelector on the Picker stack (Wave 10): a field that names its own Entity (Material,
 * MixDesign, Organization, Product, …) on the MaterialsCascadePicker base, which already carries the legacy base's
 * cascade, creation and save projection. This class holds only where the legacy base differed from the broker's
 * defaults for such a field: list order and search, a dotted display field's label, AllowCustomValues and the
 * placeholder. Its config-map entry (`MaterialsEntitySelector`) brings the rest of the Materials family behaviour.
 */
class PictProviderInputTypeMaterialsEntityPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/**
	 * The broker's picker config, with the legacy base's list and creation behaviour.
	 * @param {Record<string, any>} pInput @param {string} pHostSelector @param {Function} fOnChange
	 * @return {Record<string, any>}
	 */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpConfig = super._buildPickerConfig(pInput, pHostSelector, fOnChange);
		if (!tmpConfig.Entity)
		{
			return tmpConfig;
		}
		const tmpPictForm = (pInput && pInput.PictForm) || {};

		// Select2Util searched and sorted by SearchFields, in order, and by Name when the descriptor named none.
		// PSP sorts on one field, so the first stands in for the list.
		if (!Array.isArray(tmpPictForm.SearchFields) || tmpPictForm.SearchFields.length === 0)
		{
			tmpConfig.SearchFields = [ 'Name' ];
		}
		const tmpSortField = String(tmpConfig.SearchFields[0]);
		if (tmpPictForm.Sort === undefined && !tmpSortField.includes('.'))
		{
			tmpConfig.Sort = tmpSortField;
		}

		// The legacy base never read AllowCustomValues, so a typed term is never committed as the ID; a
		// creation-enabled field keeps the "New <Entity>..." row the broker's custom-value row displaced.
		if (tmpPictForm.AllowCustomValues)
		{
			delete tmpConfig.OnCreate;
			if (this._isEntityCreationEnabled(pInput))
			{
				this._applyNewEntityRow(tmpConfig);
			}
		}

		if (!tmpPictForm.Placeholder)
		{
			const tmpEntityLabel = String(tmpConfig.Entity).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
			tmpConfig.Placeholder = `Select ${/^[AEIOU]/i.test(tmpEntityLabel) ? 'an' : 'a'} ${tmpEntityLabel}...`;
		}
		return tmpConfig;
	}

	/**
	 * PSP reads the display field as a flat key, so a dotted one (`MixMetadata.MixName`) would label every option
	 * blank; walk it the way the legacy base and PickerDisplay do.
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {Record<string, any>} pConfig - the picker config.
	 * @return {Record<string, any>} The option, or a copy of it.
	 */
	_presentEntityOption(pOption, pConfig)
	{
		const tmpTextField = pConfig.TextField;
		if (pOption && (typeof pOption === 'object') && pOption.Record && !pConfig.TextTemplate
			&& (typeof tmpTextField === 'string') && tmpTextField.includes('.'))
		{
			const tmpText = libEntityDisplayName.resolveEntityDisplayName(pConfig.Entity, pOption.Record, { TextField: tmpTextField });
			return super._presentEntityOption(Object.assign({}, pOption, { Text: tmpText }), pConfig);
		}
		return super._presentEntityOption(pOption, pConfig);
	}
}

module.exports = PictProviderInputTypeMaterialsEntityPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86,"./_EntityDisplayName.js":155}],89:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const NEW_ENTITY_ID = '__NEW__'; // special value to indicate a new entity is being created and not collide with other possible values
const SALT_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

//FIXME: should this subclass the shared entity selector?
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const ScopedEntityData = require('./_ScopedEntityData.js');
const EntityDataBaseline = require('./_EntityDataBaseline.js');
const libFilterToggleUI = require('./_FilterToggleUI.js');
const libLabRouting = require('./_LabRouting.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');
const libSeedRecord = require('./_SeedRecord.js');

// Spec-set floors applied by entity: axis name -> resolver getter + the id column it floors.
// Materials, tests and pay items narrow through their DynamicFilters entries now; the lab axis
// is the one remaining set-membership floor. Extend by adding an axis here.
const SPEC_SET_AXIS =
{
	Lab: { getter: 'getAllowedLabIDs', field: 'IDLab' },
};

/**
 * A selection value as a set of identity strings: comma-separated or an array, blanks dropped.
 * @param {any} pValue
 * @return {Set<string>}
 */
function toIdentitySet(pValue)
{
	const tmpParts = Array.isArray(pValue) ? pValue : String(pValue ?? '').split(',');
	return new Set(tmpParts.map((pPart) => String(pPart ?? '').trim()).filter((pPart) => pPart.length > 0));
}

class MaterialsEntityInputType extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Latched true once any creation-enabled input initializes on this provider, so
		// onBeforeSaveDataAsync knows to fire the save-time EntityData projection.
		this._entityCreationEnabled = false;
	}

	/**
	 * Master opt-in gate for entity creation on this input. Reads PictForm.AllowEntityCreation,
	 * falling back to the provider option the creating subclasses set. Latches a provider-level
	 * flag so onBeforeSaveDataAsync fires the save-time EntityData projection even on a form with
	 * no sibling selector (e.g. a Test selector) that owns that trigger.
	 * @param {Object} pInput
	 * @return {boolean}
	 */
	_isEntityCreationEnabled(pInput)
	{
		const tmpEnabled = ((pInput?.PictForm?.AllowEntityCreation ?? this.options.AllowEntityCreation) === true);
		if (tmpEnabled)
		{
			this._entityCreationEnabled = true;
		}
		return tmpEnabled;
	}

	/**
	 * @param {string} pInputHTMLID
	 *
	 * @return {string}
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @param {number|string} pRowIndex
	 *
	 * @return {string}
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @param {number|string} pRowIndex
	 *
	 * @return {string}
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @param {number|string} [pRowIndex]
	 * @param {string} [pType]
	 */
	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType)
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/**
	 * Determines if a word starts with a leading vowel.
	 * @param {string} pWord The word to check.
	 * @returns {boolean} True if the word starts with a vowel, false otherwise.
	 */
	hasLeadingVowel(pWord)
	{
		if (typeof pWord !== 'string' || pWord.length === 0)
		{
			return false;
		}
		return [ 'A', 'E', 'I', 'O', 'U' ].includes(pWord.charAt(0).toUpperCase());
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		pConfigOptions.GetRecordName = (pRecord) =>
		{
			return this._formatRecordForDisplay(pRecord, pInput);
		};
	}

	/**
	 * Append the spec-set floor for this descriptor's entity. The resolver getter
	 * returns null on the fail-open paths (no contract FK, empty set, no join rows),
	 * in which case pFilters is left unchanged.
	 *
	 * Off-switch: PictForm.DisableSpecYearSiloing.
	 *
	 * Subclasses that bind Entity in the constructor (e.g. MaterialsLabSelector →
	 * 'Lab') are routed correctly via _getEntity(). Every other entity narrows
	 * through its DynamicFilters entries instead and gets nothing here.
	 *
	 * @param {Array<string>} pFilters
	 * @param {Object} pInput
	 * @param {Array<string>} [pBackoff] - Optional back-off-able filter list. When provided, the clause
	 *   routes here (self-omits on an empty result + override); when omitted it is mandatory (pFilters).
	 *   The call site (initializeSelect2) passes it only for descriptors that opt in via
	 *   PictForm.SpecYearBackOff, so the floor is mandatory by default.
	 * @param {number|string} [pRowIndex] - Row index for a tabular picker, so the Show All check below
	 *   reads THIS row's toggle state rather than the flat (non-tabular) address.
	 *
	 * @return {Array<string>}
	 */
	localHandleSearchFilters(pFilters, pInput, pBackoff, pRowIndex)
	{
		pFilters = pFilters || [];
		if (pInput?.PictForm?.DisableSpecYearSiloing || !this.pict.providers.SpecScopeResolver)
		{
			return pFilters;
		}
		const tmpAxis = SPEC_SET_AXIS[this._getEntity(pInput)];
		// Lab is the only axis here, and its floor must be read family-expanded: spec-set membership is
		// declared per FAMILY, so raw IDLab membership empties one level or the other (see
		// _LabRouting.resolveSpecSetLabFloor).
		const tmpAllowed = tmpAxis ? libLabRouting.resolveSpecSetLabFloor(this.pict) : null;
		if (tmpAllowed && tmpAllowed.size > 0 && (pInput?.PictForm?.SpecYearMandatory || !this.pict.providers.Select2Util?.isFilterOverridden?.(pInput, pRowIndex)))
		{
			// Honor pBackoff when the caller provides it; otherwise the clause is mandatory
			// (pFilters) — it stays applied even when it empties a search, so an out-of-spec search
			// trips the no-results signal instead of silently widening. The "Show all" override drops
			// it unless PictForm.SpecYearMandatory is set.
			(Array.isArray(pBackoff) ? pBackoff : pFilters).push(`FBL~${tmpAxis.field}~INN~${Array.from(tmpAllowed).join(',')}`);
		}
		return pFilters;
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput - The input object.
	 * @param {number} [pRowIndex] - The row index (optional, for tabular inputs).
	 */
	initializeSelect2(pView, pInput, pRowIndex)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpEntity = this._getEntity(pInput);
			// Human-readable entity label for the placeholder: de-camelCase the entity name so it reads with
			// spaces (SampleType -> "Sample Type", MixDesign -> "Mix Design", ProductionPlant -> "Production
			// Plant", LineItem -> "Line Item"). The baked input types own this; it is not a manifest concern.
			const tmpEntityLabel = String(tmpEntity || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2');
			/** @type {import('./PictProvider-Select2Util.js').Select2AjaxOptions} */
			const tmpConfigOptions = {
				Multiple: pInput.PictForm?.Multiple == true,
				Input: pInput,
				SearchFallbackPlaceholder: `Select ${ this.hasLeadingVowel(tmpEntityLabel) ? 'an' : 'a' } ${tmpEntityLabel}...`,
				ApplySort: true,
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				// Honor descriptor SearchFields (e.g. ['Name','ManufacturerCode']) so a picker is searchable by
				// the code shown in its chip, not just Name. Subclass _updateSelect2Options may still override.
				SearchFields: pInput.PictForm.SearchFields,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				Disabled: pInput.PictForm.Disabled || false,
				GetRecordID: (pEntity) => pEntity?.[this._getRecordIdentity(pInput)] || '',
				// Threaded so Select2Util.applyDynamicFilters can resolve a per-row
				// FromRowField against THIS row's sibling cell (each row's ajax closure
				// captures its own RowIndex). Undefined for non-tabular pickers.
				RowIndex: pRowIndex,
				View: pView,
			};
			// give child classes an opportunity to modify the select2 options
			this._updateSelect2Options(tmpConfigOptions, pView, pInput, pRowIndex);
			// Layer the spec-set floor over whatever HandleSearchFilters the
			// subclass installed. Subclasses replace HandleSearchFilters
			// wholesale (e.g. to force Active=1) rather than chaining, so
			// we wrap here once after _updateSelect2Options runs. Filters
			// the subclass added are evaluated first; the floor then narrows
			// the result. Off-switch handled inside localHandleSearchFilters
			// via PictForm.DisableSpecYearSiloing.
			const tmpSubclassHandleSearchFilters = tmpConfigOptions.HandleSearchFilters;
			tmpConfigOptions.HandleSearchFilters = (pFilters, pParams, pBackoff) =>
			{
				let tmpFilters = pFilters || [];
				if (typeof tmpSubclassHandleSearchFilters === 'function')
				{
					tmpFilters = tmpSubclassHandleSearchFilters(tmpFilters, pParams, pBackoff) || tmpFilters;
				}
				// The floor is mandatory by default; a descriptor opts into a back-off-able one (self-omit
				// on empty) via PictForm.SpecYearBackOff, which routes the clause into the back-off list.
				return this.localHandleSearchFilters(tmpFilters, pInput, pInput?.PictForm?.SpecYearBackOff ? pBackoff : undefined, pRowIndex);
			};
			const methodNameByContext = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			const tmpSelectElementSelector = this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex);
			if (tmpConfigOptions.Multiple)
			{
				this.pict.ContentAssignment.setAttribute(tmpSelectElementSelector, 'multiple', 'multiple');
				const tmpSelectWrapper = document.querySelector(tmpSelectElementSelector)?.parentElement;
				if (tmpSelectWrapper && tmpSelectWrapper.classList.contains('select'))
				{
					tmpSelectWrapper.classList.remove('select');
					if (!tmpSelectWrapper.classList.contains('is-multiple'))
					{
						tmpSelectWrapper.classList.add('is-multiple');
					}
				}
				// Strip the placeholder option -- but ONLY on a first initialization. This runs
				// on every initializeSelect2 call, and a re-init (any onAfterRender re-runs
				// onInputInitialize for every input in the section) would otherwise wipe the
				// user's real selections here and leave the picker visibly EMPTY until the
				// marshal repopulated it. Measured on LADOTD Sample Creation: removing one
				// test blanked the Tests picker for ~212ms (tags 1 -> 0 -> 1). Gate it on the
				// same condition the widget creation below uses, so first-init is unchanged.
				if (!window['jQuery'](tmpSelectElementSelector).data('select2'))
				{
					window['jQuery'](tmpSelectElementSelector).empty();
				}
			}
			if (this._isEntityCreationEnabled(pInput))
			{
				tmpConfigOptions.GetPinnedItem = () =>
				{
					return { id: NEW_ENTITY_ID, text: `New ${this._getEntity(pInput)}...` };
				}; //FIXME: human readable entity...
			}
			// if an EntityTag is defined, use it to enhance the search and display
			if (pInput.PictForm.EntityTag)
			{
				tmpConfigOptions.GetRecordUserFacingID = (pEntity) =>
				{
					return pEntity?.[pInput.PictForm.EntityTag] || 'N/A';
				};
			}
			/** @type {import('select2').Options & { [key: string]: any }} */
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax(tmpEntity, tmpConfigOptions);
			if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic)
			{
				tmpSelectOptions.ajax = {}; // necessary for custom data adapter to be used
				tmpSelectOptions.dataAdapter = $.fn.select2.amd.require('select2/data/dynamicLocalPaginationAdapter');
				// plumbing necessary context for the adapter since it doesn't have access to pict
				tmpSelectOptions.Input = pInput;
				tmpSelectOptions.DynamicMetaLists = this.pict.providers.DynamicMetaLists; //FIXME: ...
			}
			// tabular vs. non-tabular context
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](tmpSelectElementSelector).data('select2'))
			{
				window['jQuery'](tmpSelectElementSelector).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 *
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._generateSaltIfNeeded(pView, pInput);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		// initialize the select2 plugin
		this.initializeSelect2(pView, pInput);
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			// Empty picker on a new form — apply the descriptor Default (resolving it via DefaultField if set). The
			// async resolve's setDataByInput lands the id and repaints. Blank pValue so that, in the rare case the
			// value arrived as a raw token, super / _refreshRecord don't try to load a record keyed by it.
			this._applyConfiguredDefault(pView, pInput, null);
			pValue = '';
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput));
		if (pInput.PictForm?.DetectDesync && pValue)
		{
			this._checkRecordDesync(pView, pInput).catch((pError) =>
			{
				this.pict.log.warn(`MaterialsEntitySelector de-sync check failed: ${pError.message || pError}`);
			});
		}
		if (pInput.PictForm?.ShowAllToggle)
		{
			this._updateFilterToggleIcon(pInput.Macro.RawHTMLID, !!this.pict.providers.Select2Util?.isFilterOverridden?.(pInput));
			this._syncFilterToggleDisabledState(pInput);
		}
		// only put a default sample in if we are hidden, or user selected "new record"
		if (!pValue && (pInput.PictForm.InputType.startsWith('MaterialsHidden') || pInput.PictForm.DefaultToNewRecord) || pValue === NEW_ENTITY_ID)
		{
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID);
		}
		return tmpResult;
	}

	/**
	 * @param {string} pInputHTMLID
	 * @return {string} the integrated "Show All" filter-toggle element ID for this picker.
	 */
	getSelectFilterToggleID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-FILTER-TOGGLE-${pInputHTMLID}${(pRowIndex != null) ? `-${pRowIndex}` : ''}`;
	}

	/**
	 * Flip the integrated "Show All" override for this picker. The state persists at `<key>__ShowAll`
	 * (non-tabular) or `<key>__ShowAll_<rowIndex>` (tabular, per-row), read by Select2Util.isFilterOverridden,
	 * so the next option fetch drops or re-applies the scoped filters.
	 * @param {string} pInputHTMLID
	 * @param {string} pKey - state key: the DataAddress (non-tabular) or the input Hash (tabular per-row).
	 * @param {number|string} [pRowIndex] - present for a tabular per-row toggle.
	 */
	toggleFilterOverride(pInputHTMLID, pKey, pRowIndex)
	{
		// A read-only / disabled selector paints the toggle inert (_FilterToggleUI) — swallow the click rather
		// than writing override state and re-running the option fetch for a field whose value cannot change.
		if (libFilterToggleUI.isToggleDisabled(this.pict, this.getSelectFilterToggleID(pInputHTMLID, pRowIndex)))
		{
			return;
		}
		const tmpSuffix = (pRowIndex != null) ? `__ShowAll_${pRowIndex}` : '__ShowAll';
		const tmpAddress = `AppData.DocumentData.ReportData.FormData.${pKey}${tmpSuffix}`;
		const tmpNewState = !this.pict.manifest.getValueByHash(this.pict, tmpAddress);
		this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpNewState);
		this._updateFilterToggleIcon(pInputHTMLID, tmpNewState, pRowIndex);
	}

	/**
	 * Paint the toggle inert when the field is read-only / disabled. The render-time `{~FilterToggleDisabled:~}`
	 * macro already covers a manifest-declared Disabled; this catches one set AFTER render — `MaterialsSampleSelector`
	 * flips PictForm.Disabled from `DisabledOnceSaved` inside its own onInputInitialize.
	 * @param {Object} pInput @param {number|string} [pRowIndex]
	 */
	_syncFilterToggleDisabledState(pInput, pRowIndex)
	{
		libFilterToggleUI.syncToggleDisabledState(this.pict, this.getSelectFilterToggleID(pInput.Macro.RawHTMLID, pRowIndex), libFilterToggleUI.isInputDisabled(pInput));
	}

	/**
	 * Repaint the toggle icon to reflect the current override state.
	 * @param {string} pInputHTMLID
	 * @param {boolean} pState
	 * @param {number|string} [pRowIndex]
	 */
	_updateFilterToggleIcon(pInputHTMLID, pState, pRowIndex)
	{
		if (!this.pict?.ContentAssignment)
		{
			return;
		}
		const tmpIcon = pState ? 'fa-toggle-on' : 'fa-toggle-off';
		this.pict.ContentAssignment.assignContent(`${this.getSelectFilterToggleID(pInputHTMLID, pRowIndex)} > .icon`, `<i class="fas ${tmpIcon}"></i>`);
	}

	_getTrackingGUID(pInput, pRowIndex, pType)
	{
		if (pRowIndex == null)
		{
			switch (pType)
			{
			case 'TEST':
				if (pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
				{
					return pInput.PictForm.TestTrackingGUID;
				}
			default:
				if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
				{
					return pInput.PictForm.SampleTrackingGUID;
				}
			}
		}
		return this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType));
	}

	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (this._getEntity(pInput) == 'Sample')
		{
			return;
		}
		// modalities:
		//
		// single global sample
		// tabular row-based tests
		// tabular row-based sample and tests

		if (pRowIndex != null)
		{
			// tabular
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('MaterialsEntitySelector: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		// check sibling Descriptors for a sample descriptor
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('MaterialsEntitySelector: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('MaterialsEntitySelector: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index parameter. If present, this is a tabular input.
	 *
	 * @return {string}
	 */
	_handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		//FIXME: should not do this on every marshall - only on initial value marshall - move to on-init? does that flow in well with the initial value coming in or do those clash?
		let tmpDefaultRecord = this._getDefaultRecord(pView, pInput, pRowIndex);
		if (tmpDefaultRecord)
		{
			tmpDefaultRecord = JSON.parse(JSON.stringify(tmpDefaultRecord));
			this._translateRecordTemplateFields(tmpDefaultRecord);
			const tmpSeedRecord = libSeedRecord.getUnsavedSeedRecord(
				this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex)),
				this._getEntity(pInput), this._getRecordIdentity(pInput));
			if (tmpSeedRecord)
			{
				tmpDefaultRecord = Object.assign(tmpDefaultRecord, tmpSeedRecord);
			}
			const tmpDefaultID = tmpDefaultRecord[this._getRecordIdentity(pInput)];
			pValue = tmpDefaultID || null;
			if (!pValue)
			{
				//FIXME: some kind of negative ID thing to maintain uniqueness until we save? figure that out
			}
			if (pValue)
			{
				//FIXME: is this right? it seems weird but copied from another input provider; debug it
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), pInput.PictForm.InformaryDataAddress, pValue);
			}
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex), tmpDefaultRecord);
		}
		if (pValue)
		{
			// don't need to do this if we didn't synthesize a value, since it already had no value
			this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), pRowIndex, (pRecord) =>
			{
				if (pRecord)
				{
					//FIXME: if this finds a value, what should we do? iterate our uniqueness? push this value back into the sample selector? how do we tell select2 that we changed the value?
					/*
					if (pRowIndex != null)
					{
						this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pRecord[`ID${this._getEntity(pInput)}`]);
					}
					else
					{
						this.pict.ContentAssignment.assignContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), pRecord[`ID${this._getEntity(pInput)}`]);
					}*/
					if (pRowIndex != null)
					{
						this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), pRecord[this._getRecordIdentity(pInput)]);
					}
					else
					{
						this.pict.ContentAssignment.assignContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), pRecord[this._getRecordIdentity(pInput)]);
					}
					//FIXME: how we get select2 to update?
				}
			});
		}
		return pValue;
	}


	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = pInput.PictForm?.DefaultRecord;
		// When creation is enabled, mint a client GUID<Entity> so a synthesized record has a stable,
		// trackable identity before it is saved. Opt out via PictForm.GenerateGUID = false when the
		// caller supplies the GUID another way. The stanza segment defaults to the entity name and is
		// overridable via PictForm.GUIDEntityTypeStanza (e.g. the Sample subclass uses 'S'). The raw
		// template is translated downstream in _handleDefaultRecord.
		if (this._isEntityCreationEnabled(pInput) && pInput.PictForm?.GenerateGUID !== false)
		{
			const tmpEntity = this._getEntity(pInput);
			const tmpGUIDField = `GUID${tmpEntity}`;
			tmpRecord = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? JSON.parse(JSON.stringify(tmpRecord)) : { };
			if (!tmpRecord[tmpGUIDField])
			{
				const tmpStanza = pInput.PictForm?.GUIDEntityTypeStanza || tmpEntity;
				tmpRecord[tmpGUIDField] = `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-${tmpStanza}-${this._getSalt(pView, pInput, pRowIndex)}`;
			}
		}
		return tmpRecord;
	}

	_getRecordSimpleIdentity(pInput)
	{
		return `ID${this._getEntity(pInput)}`;
	}

	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || this._getDefaultRecordIdentity(pInput);
	}

	_getDefaultRecordIdentity(pInput)
	{
		// A creation-enabled selector tracks records by GUID<Entity> (a new record has no numeric
		// ID<Entity> yet), mirroring the Sample subclass's hard-coded GUIDSample identity. Still
		// overridable per input via PictForm.RecordIdentity. Non-creating selectors keep ID<Entity>.
		if (this._isEntityCreationEnabled(pInput))
		{
			return `GUID${this._getEntity(pInput)}`;
		}
		return this._getRecordSimpleIdentity(pInput);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} [pRowIndex]
	 * @param {boolean} [pForce]
	 */
	_generateSaltIfNeeded(pView, pInput, pRowIndex, pForce)
	{
		const tmpSaltAddress = this._getRecordAddress(pView, pInput, pRowIndex, '__Salt');
		let tmpSalt = !pForce && this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress);
		if (!tmpSalt)
		{
			tmpSalt = this._generateSaltStr();

			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress, tmpSalt);
		}
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 * @return {string} the salt to identify this input instance
	 */
	_getSalt(pView, pInput, pRowIndex)
	{
		const tmpSaltAddress = this._getRecordAddress(pView, pInput, pRowIndex, '__Salt');
		return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSaltAddress);
	}

	/**
	 * @param {number} [pLength=8]
	 * @return {string} a random salt to identify this input instance
	 */
	_generateSaltStr(pLength = 8)
	{
		let result = '';
		for (let i = 0; i < pLength; i++)
		{
			result += SALT_CHARS.charAt(Math.floor(Math.random() * SALT_CHARS.length));
		}
		return result;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 * @param {string} [pSuffix]
	 */
	_getRecordAddress(pView, pInput, pRowIndex, pSuffix = '__Record')
	{
		if (pInput.PictForm?.RecordAddress)
		{
			return pInput.PictForm.RecordAddress;
		}
		if (pRowIndex != null)
		{
			return pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + pSuffix;
			//FIXME: cute thing but not supported by setValueAtAddress in Manyfest
			//const tmpTestAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + '..__' + pInput.DataAddress;
			/** @type {string} */
			const tmpTestAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			const tmpSplitPoint = tmpTestAddress.lastIndexOf('.');
			if (tmpSplitPoint >= 0)
			{
				return tmpTestAddress.substring(0, tmpSplitPoint + 1) + '__' + tmpTestAddress.substring(tmpSplitPoint + 1);
			}

			return `__${tmpTestAddress}`;
		}
		//FIXME: if pRowIndex is given, this is tabular and we need to adjust the address accordingly? unless, we can apply this in the local tabular context
		return `${pInput.DataAddress || pInput.Hash}${pSuffix}`;
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options?.Entity || null;
	}

	/**
	 * Resolve the VALUE (not __Record) data address for this input/row -- the same address the
	 * marshal binds the select element to.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} [pRowIndex]
	 * @return {string}
	 */
	_getValueAddress(pView, pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.PictForm?.InformaryDataAddress || pInput.DataAddress || pInput.Hash;
	}

	/**
	 * Normalize a CLEARED entity selection. select2's clear ("x") marshals the literal string
	 * "null" (or null) into the value field; left as-is it persists in saved FormData and prints
	 * as "null" in the exported PDF, and _refreshRecord treats "null" as a real id so the previous
	 * __Record is never cleared (a stale record then drives downstream displays). Coerce a cleared
	 * value to '' and correct the value the marshal already wrote, so the caller's _refreshRecord('')
	 * takes its clear branch and resets __Record.
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {number} [pRowIndex]
	 * @return {any} the normalized value ('' when cleared, otherwise pValue unchanged)
	 */
	_coerceClearedEntityValue(pView, pInput, pValue, pRowIndex)
	{
		if ((pValue === 'null') || (pValue === 'undefined') || (pValue === null) || (typeof pValue === 'undefined'))
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pView, pInput, pRowIndex), '');
			return '';
		}
		return pValue;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._generateSaltIfNeeded(pView, pInput, pRowIndex);
		this._scheduleBaselineCapture(pView, pTransactionGUID);
		this.initializeSelect2(pView, pInput, pRowIndex);
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			// See onInputInitialize — apply the Default on an empty picker (blank pValue so a raw token, if any,
			// isn't loaded as a record key).
			this._applyConfiguredDefault(pView, pInput, pRowIndex);
			pValue = '';
		}
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), pRowIndex);
		if (pInput.PictForm?.ShowAllToggle)
		{
			this._updateFilterToggleIcon(pInput.Macro.RawHTMLID, !!this.pict.providers.Select2Util?.isFilterOverridden?.(pInput, pRowIndex), pRowIndex);
			this._syncFilterToggleDisabledState(pInput, pRowIndex);
		}
		// only put a default sample in if we are hidden, or user selected "new record"
		if (!pValue && (pInput.PictForm.InputType.startsWith('MaterialsHidden') || pInput.PictForm.DefaultToNewRecord) || pValue === NEW_ENTITY_ID)
		{
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * True when a declarative `Default` should be applied to the picker. Fires when the picker is empty — the new
	 * form's marshal destination holds `''` (a DEFINED empty string) at the address, so manyfest's getValueByHash
	 * does NOT substitute the descriptor Default (it only does so for `undefined`); `pValue` therefore arrives as
	 * `''` and we apply the Default ourselves. Also fires if `pValue` DID arrive as the raw Default token (from an
	 * undefined address) for a by-field default, so that token can be resolved. Mirrors the value-gate
	 * `_handleDefaultRecord` uses — once a value is set the gate is false and it does not re-fire.
	 *
	 * @param {Object} pInput @param {any} pValue @return {boolean}
	 */
	_shouldApplyConfiguredDefault(pInput, pValue)
	{
		if (pInput.Default == null || pInput.Default === '')
		{
			return false;
		}
		if (pValue == null || pValue === '')
		{
			return true;
		}
		// Non-empty but equal to the raw Default token (manyfest surfaced it at an undefined address) — resolve it,
		// but only for a by-field default; a by-id value already IS the record id and must not re-apply.
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		return (pValue === pInput.Default && !!tmpField && tmpField !== this._getRecordIdentity(pInput));
	}

	/**
	 * Apply `pInput.Default` to an empty picker. `PictForm.DefaultField` names a NON-identity field to match on
	 * (e.g. `Hash`) so the default is portable across customers — `Default:"ACPT"` + `DefaultField:"Hash"` resolves
	 * the customer's ACPT SampleType by its id via one read. Without a `DefaultField` (or when it IS the record
	 * identity) the `Default` is already the id and is set directly. `setDataByInput` writes the id into FormData,
	 * so the value-gate closes and this does not re-fire; a re-entrancy latch dedupes concurrent init passes while
	 * the read is in flight.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|null} [pRowIndex]
	 */
	_applyConfiguredDefault(pView, pInput, pRowIndex)
	{
		if (pInput._DefaultResolving)
		{
			return;
		}
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		if (!tmpField || tmpField === this._getRecordIdentity(pInput))
		{
			// Default is already the record id — set it directly, no resolve.
			this._setResolvedDefault(pView, pInput, pRowIndex, pInput.Default);
			return;
		}
		const tmpEntity = this._getEntity(pInput);
		if (!tmpEntity || !this.pict.HeadlightRestClient)
		{
			return;
		}
		pInput._DefaultResolving = true;
		this.pict.HeadlightRestClient.getJSON(`${tmpEntity}s/FilteredTo/FBV~${tmpField}~EQ~${encodeURIComponent(pInput.Default)}/0/1`, (pError, pRows) =>
		{
			pInput._DefaultResolving = false;
			const tmpRecord = (!pError && Array.isArray(pRows)) ? pRows[0] : null;
			if (tmpRecord)
			{
				this._setResolvedDefault(pView, pInput, pRowIndex, tmpRecord[this._getRecordIdentity(pInput)]);
			}
		});
	}

	/**
	 * Set a resolved default value onto the picker (single or tabular), which drives the record refresh + repaint.
	 * @param {Object} pView @param {Object} pInput @param {number|null} pRowIndex @param {any} pValue
	 */
	_setResolvedDefault(pView, pInput, pRowIndex, pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '')
		{
			return;
		}
		if (pRowIndex != null)
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pValue);
		}
		else
		{
			pView.setDataByInput(pInput, pValue);
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Repaint this cell's select2 to the row's current value after a tabular row REORDER.
	 *
	 * A plain marshal (`_renderEntitiesToPicker`) only APPENDS a selected `<option>`; for a cell
	 * that already shows a value, appending the reordered-in value's option does not deselect the
	 * stale one, so select2 keeps displaying the old product. Here we make sure the option exists
	 * (append it from the local `__Record` if not) and then EXPLICITLY set the select's value,
	 * which switches the display. `change.select2` is UI-only, so this does not re-enter the
	 * framework's data-change/marshal cycle. This is what lets `_repaintAfterRowReorder` skip the
	 * expensive full source-view render (which re-initialized every select2).
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The row's current value for this input.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onTabularRowReorderRepaintTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		try
		{
			const tmpElementID = this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex);
			const tmpElements = this.pict.ContentAssignment.getElement(tmpElementID);
			if (!tmpElements || tmpElements.length < 1)
			{
				return true;
			}
			const tmpJQuery = window['jQuery'];
			// Cleared cell -> clear the picker.
			if (pValue == null || pValue === '' || pValue === 'null')
			{
				tmpJQuery(tmpElementID).val(null).trigger('change.select2');
				return true;
			}
			// Ensure the option for the row's current value is present (append it from the locally
			// held record when select2 doesn't already carry it), then force-select it.
			const tmpIdentity = this._getRecordIdentity(pInput);
			const tmpAlreadyPresent = Array.prototype.some.call(tmpElements[0].options || [], (pOption) => String(pOption.value) === String(pValue));
			if (!tmpAlreadyPresent)
			{
				const tmpRecord = this._getLocalRecordForValue(pView, pInput, pValue, pRowIndex);
				if (tmpRecord && (tmpRecord[tmpIdentity] != null))
				{
					tmpJQuery(tmpElementID).append(new Option(this._formatRecordForDisplay(tmpRecord, pInput), tmpRecord[tmpIdentity], false, false));
				}
			}
			tmpJQuery(tmpElementID).val(String(pValue)).trigger('change.select2');
		}
		catch (pError)
		{
			this.pict.log.error(`MaterialsEntitySelector[${this._getEntity(pInput)}].onTabularRowReorderRepaintTabular error: ${pError.message || pError}`);
		}
		return true;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		try
		{
			const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
			if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
			{
				return false;
			}
			let tmpCurrentSelection = this._safeSelect2Data(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
			let tmpValues = (pValue == null || pValue == '') ? [] : [ pValue ];
			let tmpNeedsClear = false;
			if (pInput.PictForm?.Multiple == true && typeof pValue === 'string')
			{
				tmpValues = pValue.split(',').map((v) => v.trim()).filter((v) => v.length > 0);
				if (Array.isArray(tmpCurrentSelection) && tmpCurrentSelection.length == tmpValues.length && tmpValues.every((v) => tmpCurrentSelection.find((s) => s.id == v)))
				{
					return;
				}
				tmpNeedsClear = true;
			}
			const tmpEntities = [];
			const tmpMissingValues = [];
			if (pInput.PictForm.SelectOptionsPickList)
			{
				tmpEntities.push(...this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList, { extractRootKey: tmpValues }));
				for (const tmpEntity of tmpEntities)
				{
					tmpEntity.__Value = tmpEntity.id;
				}
			}
			else
			{
				for (const tmpValue of tmpValues)
				{
					// System 1: render single-select pickers from the local snapshot first; only load when missing.
					if (tmpValue && tmpValue !== 'null' && tmpValue !== NEW_ENTITY_ID) //FIXME: what's up with this null string?
					{
						// Prefer the local __Record (persisted snapshot / freshly synthesized record) — synchronous, no
						// fetch. No snapshot -> single-select defers to async backfill; multi-select fetches inline.
						let tmpEntity = this._getLocalRecordForValue(pView, pInput, tmpValue, pRowIndex);
						if (!tmpEntity)
						{
							if (!pInput.PictForm?.Multiple)
							{
								tmpMissingValues.push(tmpValue);
								continue;
							}
							try
							{
								const tmpEntityDisplay = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue, this._buildEntityFetchOptions(pInput));
								tmpEntity = Object.assign({}, tmpEntityDisplay.Record, { __DisplayName: tmpEntityDisplay.DisplayName });
							}
							catch (pFetchError)
							{
								tmpEntity = null;
							}
						}
						if (tmpEntity && typeof tmpEntity === 'object' && tmpEntity[this._getRecordIdentity(pInput)])
						{
							tmpEntity.__Value = tmpValue;
							tmpEntities.push(tmpEntity);
						}
					}
				}
			}
			if (tmpNeedsClear)
			{
				// Drop only the options that are no longer selected, rather than emptying the
				// element and letting _renderEntitiesToPicker rebuild it. select2 repaints from
				// the element, so a full empty makes every tag vanish and come back -- and the
				// marshal fan-out runs this ~4x per field per change, so the user sees it.
				// Measured on LADOTD Sample Creation (one test removed): 8 empties across the
				// Tests and Labs pickers, both blanking mid-change.
				//
				// This is the second half of the flicker. The first was the ungated placeholder
				// strip in initializeSelect2; both had to go. _renderEntitiesToPicker below
				// already appends only what is missing, so pruning here leaves the picker
				// converging on the right set without ever being empty.
				this._pruneUnselectedOptions(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex), tmpValues);
				tmpCurrentSelection = this._safeSelect2Data(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
			}
			// _renderEntitiesToPicker only APPENDS selected options; a single-select clear resolves nothing to
			// render, so reset the picker explicitly. Guarded to a genuine clear (not a value pending backfill
			// or a new-record pin). Multi-select clears via the tmpNeedsClear path above.
			if (!pInput.PictForm?.Multiple && tmpEntities.length === 0 && tmpMissingValues.length === 0 && !tmpValues.includes(NEW_ENTITY_ID) && tmpCurrentSelection.length > 0)
			{
				window['jQuery'](this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex)).val(null).trigger('change.select2');
			}
			this._renderEntitiesToPicker(pInput, tmpEntities, pRowIndex);
			this._renderDesyncAffordance(pView, pInput, pRowIndex);
			// System 2: load any values that had no local snapshot in the background and update the UI when they
			// arrive — non-blocking, so the user is in the form immediately on whatever System 1 rendered.
			if (tmpMissingValues.length > 0)
			{
				this._backfillMissingRecords(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, tmpMissingValues).catch((pError) =>
				{
					this.pict.log.warn(`MaterialsEntitySelector[${this._getEntity(pInput)}]: record backfill failed: ${pError.message || pError}`);
				});
			}
		}
		catch (pError)
		{
			this.pict.log.error(`Error in MaterialsEntitySelector[${this._getEntity(pInput)}]._onDataMarshalToForm: ${pError.message || pError}`);
		}
	}

	/**
	 * Build the entity-fetch options object (DB display fetch / backfill share it).
	 * @param {Object} pInput
	 * @return {Object}
	 */
	_buildEntityFetchOptions(pInput)
	{
		return {
			IdentityField: this._getRecordIdentity(pInput),
			JoinEntity: pInput.PictForm.JoinEntity,
			JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
			JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
			EntityDisplayField: pInput.PictForm.EntityDisplayField,
			JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
			Disabled: pInput.PictForm.Disabled || false,
			EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
		};
	}

	/**
	 * System 1 resolver: the locally-held record for a value — the persisted __Record snapshot or a freshly
	 * synthesized record, when its identity matches the value. Returns a shallow copy (so the transient marshal
	 * __Value never lands on the persisted snapshot), or null when there is no local record (System 2 must load).
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {number|string} [pRowIndex]
	 * @return {Record<string, any>|null}
	 */
	_getLocalRecordForValue(pView, pInput, pValue, pRowIndex)
	{
		const tmpLocalRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		if (tmpLocalRecord && typeof tmpLocalRecord === 'object' && !Array.isArray(tmpLocalRecord))
		{
			const tmpIdentity = this._getRecordIdentity(pInput);
			if (tmpLocalRecord[tmpIdentity] == pValue)
			{
				return Object.assign({}, tmpLocalRecord);
			}
			// A synthesized/unsaved record carries its client identity (e.g. a GUID) but no server ID.
			// This is for the record creation path; retain the local record in this case.
			if (tmpLocalRecord[tmpIdentity] && !tmpLocalRecord[`ID${this._getEntity(pInput)}`])
			{
				return Object.assign({}, tmpLocalRecord);
			}
		}
		return null;
	}

	/**
	 * Append the given resolved records as selected options on the picker and repaint select2. Shared by the
	 * synchronous marshal (System 1) and the async backfill (System 2). Dedupes against the live selection.
	 * @param {Object} pInput
	 * @param {Array<Record<string, any>>} pEntities - each carrying the transient __Value (the option id) and, when resolved from a fetch, __DisplayName
	 * @param {number|string} [pRowIndex]
	 */
	_renderEntitiesToPicker(pInput, pEntities, pRowIndex)
	{
		const inputMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpCurrentSelection = this._safeSelect2Data(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		let tmpChanged = false;
		for (const tmpEntity of pEntities)
		{
			if (!tmpCurrentSelection.find((s) => s.id == tmpEntity.__Value))
			{
				let tmpOption;
				if (pInput.PictForm.SelectOptionsPickList)
				{
					tmpOption = new Option(tmpEntity.text, tmpEntity.id, false, true);
				}
				else
				{
					tmpOption = new Option(this._formatRecordForDisplay(tmpEntity, pInput), tmpEntity[this._getRecordIdentity(pInput)], false, true);
				}
				tmpChanged = true;
				window['jQuery'](this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex)).append(tmpOption);
			}
			delete tmpEntity.__Value;
			delete tmpEntity.__DisplayName;
		}
		if (tmpChanged)
		{
			window['jQuery'](this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex)).trigger('change.select2');
		}
	}

	/**
	 * System 2: asynchronously load records that had no local snapshot, persist single-select results at
	 * __Record, and render them — non-blocking. Keeps any existing __Record on failure (offline-tolerant).
	 * @param {Object} pView @param {Object} pGroup @param {Object} pRow @param {Object} pInput
	 * @param {any} pValue @param {string} pHTMLSelector @param {number|string} [pRowIndex] @param {Array<any>} [pValues]
	 */
	async _backfillMissingRecords(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, pValues = [])
	{
		const tmpLoaded = [];
		for (const tmpValue of pValues)
		{
			let tmpEntity = null;
			let tmpDisplayName = null;
			try
			{
				const tmpEntityDisplay = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), tmpValue, this._buildEntityFetchOptions(pInput));
				tmpEntity = tmpEntityDisplay.Record;
				tmpDisplayName = tmpEntityDisplay.DisplayName;
			}
			catch (pFetchError)
			{
				this.pict.log.warn(`MaterialsEntitySelector[${this._getEntity(pInput)}]: backfill load failed for [${tmpValue}]: ${pFetchError.message || pFetchError}`);
			}
			if (tmpEntity && typeof tmpEntity === 'object' && tmpEntity[this._getRecordIdentity(pInput)])
			{
				if (!pInput.PictForm?.Multiple)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex), tmpEntity);
				}
				const tmpForRender = Object.assign({}, tmpEntity);
				tmpForRender.__Value = tmpValue;
				tmpForRender.__DisplayName = tmpDisplayName;
				tmpLoaded.push(tmpForRender);
			}
		}
		if (tmpLoaded.length > 0)
		{
			this._renderEntitiesToPicker(pInput, tmpLoaded, pRowIndex);
		}
	}

	/**
	 * Pure decision for the de-sync state of a snapshot vs the server record.
	 * @param {Record<string, any>} pSnapshot - the locally-held __Record snapshot
	 * @param {any} pFetched - the freshly-fetched server record (or null/empty if not found)
	 * @param {string} pIdentityField - the record identity field (e.g. GUIDSample)
	 * @return {'stale'|'deleted'|null}
	 */
	_computeDesyncState(pSnapshot, pFetched, pIdentityField)
	{
		if (!pFetched || typeof pFetched !== 'object' || Array.isArray(pFetched) || !pFetched[pIdentityField])
		{
			return 'deleted';
		}
		if (pSnapshot && pSnapshot.UpdateDate && pFetched.UpdateDate && pSnapshot.UpdateDate !== pFetched.UpdateDate)
		{
			return 'stale';
		}
		return null;
	}

	_desyncKey(pInput, pRowIndex)
	{
		return `${pInput.Macro.RawHTMLID}::${(pRowIndex || pRowIndex === 0) ? pRowIndex : '_'}`;
	}

	_desyncState()
	{
		if (!this._recordDesyncState)
		{
			this._recordDesyncState = {};
			this._recordDesyncFetched = {};
		}
		return this._recordDesyncState;
	}

	/**
	 * System 2 de-sync check (opt-in via PictForm.DetectDesync). Asynchronously compares the rendered snapshot
	 * __Record against the server and flags 'stale'/'deleted' without mutating the snapshot. Non-blocking; never
	 * runs on a synthesized (unsaved) record, a multi-select picker, or a frozen document.
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	async _checkRecordDesync(pView, pInput, pRowIndex)
	{
		if (!pInput.PictForm?.DetectDesync || pInput.PictForm?.Multiple || this._isRecordFrozen())
		{
			return;
		}
		const tmpSnapshot = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		if (!tmpSnapshot || typeof tmpSnapshot !== 'object' || Array.isArray(tmpSnapshot))
		{
			return;
		}
		const tmpIdentity = tmpSnapshot[this._getRecordIdentity(pInput)];
		// Only a saved record (has a DB id) is comparable; a synthesized record has nothing on the server yet.
		if (!tmpIdentity || !tmpSnapshot[`ID${this._getEntity(pInput)}`])
		{
			return;
		}
		let tmpFetched = null;
		try
		{
			tmpFetched = await this.pict.providers.Select2Util.getEntityAsync(this._getEntity(pInput), tmpIdentity, Object.assign({ }, this._buildEntityFetchOptions(pInput), { BypassCache: true }));
		}
		catch (pError)
		{
			// Couldn't reach the server (offline): leave the snapshot as-is, raise no false de-sync flag.
			return;
		}
		const tmpKey = this._desyncKey(pInput, pRowIndex);
		const tmpState = this._computeDesyncState(tmpSnapshot, tmpFetched, this._getRecordIdentity(pInput));
		this._desyncState()[tmpKey] = tmpState;
		if (tmpState === 'stale')
		{
			this._recordDesyncFetched[tmpKey] = tmpFetched;
		}
		this._renderDesyncAffordance(pView, pInput, pRowIndex);
	}

	/**
	 * Inject/update the "out of date / no longer exists" affordance next to the picker, reflecting the
	 * transient de-sync state. Clicking it runs the manual refresh. No-op outside a browser.
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	_renderDesyncAffordance(pView, pInput, pRowIndex)
	{
		if (typeof document === 'undefined' || !window['jQuery'])
		{
			return;
		}
		const tmpMethod = (pRowIndex || pRowIndex === 0) ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		const tmpSelectID = this[tmpMethod](pInput.Macro.RawHTMLID, pRowIndex);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpSelectID);
		const tmpSelectElement = tmpElements && tmpElements[0];
		if (!tmpSelectElement || !tmpSelectElement.parentElement)
		{
			return;
		}
		const tmpState = this._desyncState()[this._desyncKey(pInput, pRowIndex)];
		const tmpAffordanceID = `${tmpSelectID}--desync`.replace(/[^A-Za-z0-9_-]/g, '');
		let tmpAffordance = document.getElementById(tmpAffordanceID);
		if (!tmpState)
		{
			if (tmpAffordance)
			{
				tmpAffordance.remove();
			}
			return;
		}
		if (!tmpAffordance)
		{
			tmpAffordance = document.createElement('a');
			tmpAffordance.id = tmpAffordanceID;
			tmpAffordance.className = 'materials-record-desync is-size-7 has-text-warning';
			tmpAffordance.style.cssText = 'display:block;cursor:pointer;margin-top:2px;';
			tmpAffordance.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				this._refreshRecordManually(pView, pInput, pRowIndex);
			});
			tmpSelectElement.parentElement.appendChild(tmpAffordance);
		}
		tmpAffordance.textContent = tmpState === 'deleted' ? '⚠ This record no longer exists — dismiss' : '↻ Out of date — refresh';
	}

	/**
	 * Manual refresh: apply the freshly-fetched record as the new snapshot and re-sync the autofilled sibling
	 * fields (via _onRecordRefresh), then clear the de-sync flag. A 'deleted' record is simply dismissed,
	 * keeping the last-known snapshot.
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	_refreshRecordManually(pView, pInput, pRowIndex)
	{
		const tmpKey = this._desyncKey(pInput, pRowIndex);
		if (this._desyncState()[tmpKey] === 'stale')
		{
			const tmpFetched = this._recordDesyncFetched[tmpKey];
			if (tmpFetched)
			{
				const tmpAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress, tmpFetched);
				this._onRecordRefresh(pView, pInput, tmpFetched, tmpAddress, this.pict.getUUID(), pRowIndex);
				const tmpEntity = this._getEntity(pInput);
				const tmpGUID = tmpFetched[`GUID${tmpEntity}`];
				if (this._isScopedEntityDataEnabled() && typeof tmpGUID === 'string' && tmpGUID.length > 0)
				{
					EntityDataBaseline.refreshBaselineRecords(this.pict, tmpEntity, [ tmpGUID ]);
				}
			}
		}
		delete this._recordDesyncFetched[tmpKey];
		this._desyncState()[tmpKey] = null;
		this._renderDesyncAffordance(pView, pInput, pRowIndex);
		pView.marshalToView();
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 * @param {boolean} [pUseEntityTag=false]
	 *
	 * @return {string}
	 */
	_formatRecordForDisplay(pRecord, pInput, pUseEntityTag = true)
	{
		const tmpDisplayName = this._getRecordDisplayName(pRecord, pInput);
		// if the EntityTag is defined and the entity has that property, use it for the leading tag in the selection display
		if (pUseEntityTag && pInput.PictForm.EntityTag)
		{
			const tmpTag = pRecord[pInput.PictForm.EntityTag];
			// Suppress the leading tag when it's empty or identical to the name (e.g. Labs whose code IS their
			// name) — it would otherwise render a redundant "(X) X" pill (and the PDF shows only the name).
			if (tmpTag != null && String(tmpTag).trim() !== '' && String(tmpTag).trim() !== String(tmpDisplayName).trim())
			{
				return `${tmpTag}|~|${tmpDisplayName}`;
			}
		}
		return tmpDisplayName;
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		// if an EntityDisplayField is defined, use it
		if (pInput.PictForm.EntityDisplayField && pRecord[pInput.PictForm.EntityDisplayField])
		{
			return pRecord[pInput.PictForm.EntityDisplayField];
		}
		// if a EntityDisplayField is defined with dot notation, use it's child field
		else if (pInput.PictForm.EntityDisplayField && pInput.PictForm.EntityDisplayField.includes('.'))
		{
			const tmpJoinParts = pInput.PictForm.EntityDisplayField.split('.');
			if (tmpJoinParts.length === 2 && pRecord[tmpJoinParts[0]] && pRecord[tmpJoinParts[0]][tmpJoinParts[1]])
			{
				return pRecord[tmpJoinParts[0]][tmpJoinParts[1]];
			}
		}
		return pRecord.__DisplayName || pRecord.DisplayName || pRecord.Name || (`Unnamed ${this._getEntity(pInput)} #` + pRecord[`ID${this._getEntity(pInput)}`]);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, null);
		pValue = this._coerceClearedEntityValue(pView, pInput, pValue, null);
		let tmpNewEntity = false;
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, null, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID);
			tmpNewEntity = true;
		}
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), null, (pRecord) =>
		{
			if (!pRecord && tmpNewEntity)
			{
				const tmpRecordAddress = this._getRecordAddress(pView, pInput);
				const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
				if (tmpRecord)
				{
					this._onRecordRefresh(pView, pInput, tmpRecord, this._getRecordAddress(pView, pInput), pTransactionGUID);
				}
			}
		});
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Cross-field dependency cleanup. When an anchor field this picker depends on
	 * (declared via `PictForm.DynamicFilters[].TriggerGroupHash`) changes, the
	 * value already selected here may no longer belong to the new anchor — so
	 * clear it. The anchor emits the group through Pict-Input-AutofillTriggerGroup
	 * (`TriggerAllInputs: true`); this handler receives it like every other input.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pEvent - global event payload, e.g. `TriggerGroup:<hash>:DataChange:<emitter>:<uuid>`
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpMatchedFilter = this._matchedDynamicFilterForEvent(pInput, pEvent);
		if (tmpMatchedFilter && (!pInput.PictForm?.SmartClear || this._isSelectionIllegalForFilter(pView, pInput, tmpMatchedFilter, null)))
		{
			this._clearForDynamicFilter(pView, pInput, null);
		}
		// Autofill scope vetting (opt-in via PictForm.VetAutofillScope): when an autofill from a non-projection
		// source lands a value illegal for THIS picker's own Through filter, suppress it. Async — the Through
		// slice primes on demand, so it runs after the sync autofill has landed the value. Fail-open throughout.
		if (pInput.PictForm?.VetAutofillScope && !this.pict._MaterialsEntityHydrationDepth && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, null).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		// Warm any query-strategy Through slice for the new anchor value so a
		// dependent picker's INN clause resolves synchronously once it is opened.
		this.pict.providers.ThroughScopeResolver?.primeQueryScopesFromForm?.();
		// Re-prime lab scoping — the project or the selected-test set may have changed. Idempotent: only re-fetches
		// (ProjectLabJoin + batched TestLabJoin) when the (project, test-set) key actually changes.
		this.pict.providers.LabScopeResolver?.primeFromForm?.();
		this._handleBaseSaveProjectionEvent(pView, pInput, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Pure: does a global event target one of this input's DynamicFilters?
	 * Returns the matching filter entry, or null. Self-emitted events are ignored.
	 *
	 * @param {Object} pInput
	 * @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEvent(pInput, pEvent)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters))
		{
			return null;
		}
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup')
		{
			return null;
		}
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash)
		{
			return null;
		}
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Tabular sibling of `_matchedDynamicFilterForEvent`. A tabular anchor fires a
	 * ROW-SCOPED event (`TriggerGroup:<hash>:RecordRefresh:<emitter>:<rowIndex>:<uuid>`,
	 * see _onRecordRefresh). The global broadcast delivers it to EVERY row's
	 * onAfterEventTabularCompletion, so a dependent column must act on its own row
	 * ONLY — otherwise changing one row's Source would wipe valid selections in every
	 * other row. We therefore require the event's row index (slot [4]) to equal this
	 * picker's `pRowIndex`. A global (non-row-scoped) event has a UUID in slot [4],
	 * which `parseInt` yields NaN for, so it never matches here.
	 *
	 * @param {Object} pInput
	 * @param {string} pEvent
	 * @param {number} pRowIndex - this picker's row
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters))
		{
			return null;
		}
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup')
		{
			return null;
		}
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		const tmpEventRowIndex = parseInt(tmpParts[4], 10);
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash)
		{
			return null;
		}
		// Only row-scoped events carry an integer row index here; require it to be OUR row.
		if (isNaN(tmpEventRowIndex) || tmpEventRowIndex !== Number(pRowIndex))
		{
			return null;
		}
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Tabular sibling of onAfterEventCompletion: when an anchor in THIS row changes,
	 * clear this row's now-orphaned selection so it can't keep a value that no longer
	 * belongs to the new anchor. The next dropdown open re-fetches with the updated
	 * per-row FromRowField filter.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpMatchedFilter = this._matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex);
		if (tmpMatchedFilter && (!pInput.PictForm?.SmartClear || this._isSelectionIllegalForFilter(pView, pInput, tmpMatchedFilter, pRowIndex)))
		{
			this._clearForDynamicFilter(pView, pInput, pRowIndex);
		}
		// Autofill scope vetting (opt-in) — tabular sibling; vet only this row's autofilled value. Async / fail-open.
		if (pInput.PictForm?.VetAutofillScope && !this.pict._MaterialsEntityHydrationDepth && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		this._handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Smart-clear gate (opt-in via `PictForm.SmartClear`). Returns true only when this picker's resolved
	 * record is DEFINITIVELY illegal for the changed anchor — the record carries the filter's `Field` and
	 * its value no longer equals the anchor's current value. When the record isn't resolved yet, lacks the
	 * FK, or the anchor is unset, illegality can't be proven, so we keep the value: this avoids clobbering a
	 * just-autofilled selection during sample projection, and preserves a user override that sits outside
	 * the filter. (Without this, plain always-clear on the anchor's trigger group would wipe a Product/
	 * MixDesign that a sample selection is concurrently projecting.)
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {object} pFilter - the matched DynamicFilters entry (`{ Field, FromField | FromRowField, ... }`).
	 * @param {number|null} [pRowIndex]
	 * @return {boolean} true only when the current selection is provably illegal for pFilter.
	 */
	_isSelectionIllegalForFilter(pView, pInput, pFilter, pRowIndex)
	{
		if (!pFilter || !pFilter.Field)
		{
			return false;
		}
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !(pFilter.Field in tmpRecord))
		{
			return false;
		}
		let tmpAnchorValue;
		if (pFilter.FromRowField && pRowIndex != null && pInput.PictForm && pInput.PictForm.InformaryContainerAddress)
		{
			const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pFilter.FromRowField);
			tmpAnchorValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
		}
		else if (pFilter.FromField)
		{
			tmpAnchorValue = this.pict.manifest.getValueByHash(this.pict, pFilter.FromField);
		}
		else
		{
			return false;
		}
		// An unset anchor imposes no constraint (applyDynamicFilters omits it), so nothing is illegal.
		const tmpAnchorNormalized = (tmpAnchorValue === null || tmpAnchorValue === undefined) ? '' : String(tmpAnchorValue).trim();
		if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0')
		{
			return false;
		}
		return String(tmpRecord[pFilter.Field]) !== tmpAnchorNormalized;
	}

	/**
	 * Pure: does a global event correspond to an AUTOFILL into this input (an AutofillTriggerGroup entry whose
	 * TriggerGroupHash matches the event)? Returns the matched entry, or null. Self-emitted events, and entries
	 * flagged `AllowInvalidProjection`, are skipped — the latter marks record-projection sources (e.g. linking a
	 * saved sample) that legitimately carry pre-existing, possibly out-of-scope values that must not be vetted.
	 *
	 * @param {Object} pInput
	 * @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedAutofillGroupForEvent(pInput, pEvent)
	{
		let tmpGroups = (pInput && pInput.PictForm) ? pInput.PictForm.AutofillTriggerGroup : null;
		if (!tmpGroups)
		{
			return null;
		}
		if (!Array.isArray(tmpGroups))
		{
			tmpGroups = [ tmpGroups ];
		}
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup')
		{
			return null;
		}
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash)
		{
			return null;
		}
		return tmpGroups.find((pGroup) => pGroup && pGroup.TriggerGroupHash === tmpGroupHash && !pGroup.AllowInvalidProjection) || null;
	}

	/**
	 * Vet this picker's current value against its own Through DynamicFilters and suppress it when it is
	 * PROVABLY not a legal option — the selected `ThroughSelect` id is absent from the resolved allowed set for
	 * the current anchor. Fail-open everywhere else: no anchor, an unprimed/unresolved scope (getThroughIDs
	 * null), or no value all KEEP the value. Async because query-strategy Through slices load on demand — which
	 * also means it runs after the synchronous autofill has landed the value. Rejects an autofill (e.g.
	 * Plant → Producer) that lands an org outside the material-scoped supplier set; a plain user pick is always
	 * in-scope, and record-projection sources are excluded upstream via `_matchedAutofillGroupForEvent`.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|null} [pRowIndex]
	 * @return {Promise<void>}
	 */
	async _vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex)
	{
		const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
		const tmpResolver = this.pict.providers.ThroughScopeResolver;
		if (!Array.isArray(tmpFilters) || !tmpResolver)
		{
			return;
		}
		const tmpThroughFilters = tmpFilters.filter((pFilter) => pFilter && pFilter.Through && pFilter.ThroughSelect && pFilter.FromField);
		if (!tmpThroughFilters.length)
		{
			return;
		}
		const tmpDestination = pView.getMarshalDestinationObject();
		for (const tmpFilter of tmpThroughFilters)
		{
			const tmpAnchor = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			const tmpAnchorNormalized = (tmpAnchor === null || tmpAnchor === undefined) ? '' : String(tmpAnchor).trim();
			if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0')
			{
				continue;
			}
			const tmpRecord = this.pict.manifest.getValueAtAddress(tmpDestination, this._getRecordAddress(pView, pInput, pRowIndex));
			let tmpSelected = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[tmpFilter.ThroughSelect] : null;
			if ((tmpSelected === null || tmpSelected === undefined || tmpSelected === '') && pRowIndex == null)
			{
				tmpSelected = this.pict.manifest.getValueAtAddress(tmpDestination, pInput.DataAddress);
			}
			if (tmpSelected === null || tmpSelected === undefined || tmpSelected === '' || Number(tmpSelected) === 0)
			{
				continue;
			}
			await tmpResolver.primeThroughSlice(tmpFilter, tmpAnchor);
			const tmpAllowed = tmpResolver.getThroughIDs(tmpFilter, tmpAnchor);
			// Fail-open backstop: an empty allowed set means the scope couldn't be resolved (sparse/missing
			// OrganizationMaterialJoin data, or a failed prime) — treat that as "can't constrain", not "everything
			// is illegal". Clearing on an empty set would nuke a legitimately-chosen value. A genuinely-scoped
			// anchor returns a non-empty set and still clears an out-of-scope value below.
			if (!tmpAllowed || typeof tmpAllowed.has !== 'function' || tmpAllowed.size === 0)
			{
				continue;
			}
			if (!tmpAllowed.has(Number(tmpSelected)))
			{
				this._clearForDynamicFilter(pView, pInput, pRowIndex);
				return;
			}
		}
	}

	/**
	 * Reset this picker's value and its resolved-record companion (`__Record`),
	 * then re-marshal so the select2 reflects the cleared state. `__Record` is
	 * reset to an empty object (not deleted) to match the selector convention —
	 * new-record flows write fields into it and assume it is always an object.
	 * The next dropdown open re-fetches with the updated DynamicFilters (the new
	 * anchor value), so neither a stale selection nor a stale resolved record
	 * survives an anchor change.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|null} [pRowIndex]
	 */
	_clearForDynamicFilter(pView, pInput, pRowIndex)
	{
		try
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex, '__Record');
			// Reset the value and its resolved-record companion. __Record is reset to
			// an EMPTY OBJECT (not undefined/deleted) to match the selector convention:
			// downstream flows write fields into __Record and assume it is always an
			// object (e.g. new-record creation in MaterialsSampleSelector, which sets
			// tmpRecord.Status on SampleStatusChanged).
			this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, {});
			if (pRowIndex != null)
			{
				// Tabular: clear ONLY this row's cell + its own select2 instance.
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pInput.Default ?? '');
				const tmpTabularSelectID = this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex);
				if (window['jQuery'] && window['jQuery'](tmpTabularSelectID).data('select2'))
				{
					window['jQuery'](tmpTabularSelectID).val(null).empty().trigger('change.select2');
				}
				pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
			}
			else
			{
				pView.setDataByInput(pInput, pInput.Default ?? '');
				const tmpSelectID = this.getSelectInputHTMLID(pInput.Macro.RawHTMLID);
				if (window['jQuery'] && window['jQuery'](tmpSelectID).data('select2'))
				{
					window['jQuery'](tmpSelectID).val(null).empty().trigger('change.select2');
				}
				pView.manualMarshalDataToViewByInput(pInput);
			}
			this.pict.log.info(`DynamicFilter: cleared dependent input [${pInput.Hash}]${pRowIndex != null ? ` row ${pRowIndex}` : ''} after its anchor changed.`);
		}
		catch (pError)
		{
			this.pict.log.error(`DynamicFilter: failed to clear dependent input [${pInput && pInput.Hash}]: ${pError}`);
		}
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleSelectionRemovals(pView, pInput, pValue, pRowIndex);
		pValue = this._coerceClearedEntityValue(pView, pInput, pValue, pRowIndex);
		let tmpNewEntity = false;
		if (pValue === NEW_ENTITY_ID)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			pValue = this._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
			tmpNewEntity = true;
		}
		this._refreshRecord(pView, pInput, pValue, this._getEntity(pInput), pTransactionGUID, this._getRecordIdentity(pInput), pRowIndex, (pRecord) =>
		{
			if (!pRecord && tmpNewEntity)
			{
				const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
				if (tmpRecord)
				{
					this._onRecordRefresh(pView, pInput, tmpRecord, this._getRecordAddress(pView, pInput), pTransactionGUID);
				}
			}
		});
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	_translateRecordTemplateFields(pRecord)
	{
		for (const tmpField in pRecord)
		{
			if (typeof pRecord[tmpField] === 'string')
			{
				pRecord[tmpField] = this.pict.parseTemplate(pRecord[tmpField], this.pict);
			}
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string|number} pIDValue
	 * @param {string} pEntity
	 * @param {string} pTransactionGUID - A transaction GUID to associate with this operation.
	 * @param {string} [pRecordIdentityField]
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 * @param {(pRecord: Record<string, any>) => void} [fCallback] - (optional) A callback function to be called after the record is refreshed.
	 */
	/**
	 * Whether the document is frozen (read-only / Locked). A frozen document always uses the persisted
	 * snapshot — System 2 never refreshes it. Same lock signal the sibling selectors gate interactivity on.
	 * @return {boolean}
	 */
	_isRecordFrozen()
	{
		return !this.pict?.AppData?.Interactive || !!this.pict?.AppData?.DocumentData?.ReportData?.Locked;
	}

	/**
	 * Whether a record fetch has been overtaken: the input's committed value no longer names the ids the
	 * fetch asked for. A value nobody has written yet is no evidence either way, so it never counts as stale.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {any} pRequestedValue - The value the fetch was issued for.
	 * @return {boolean}
	 */
	_isStaleRecordRefresh(pView, pInput, pRowIndex, pRequestedValue)
	{
		const tmpCurrentValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pView, pInput, pRowIndex));
		if (tmpCurrentValue === undefined || tmpCurrentValue === null)
		{
			return false;
		}
		const tmpCurrent = toIdentitySet(tmpCurrentValue);
		const tmpRequested = toIdentitySet(pRequestedValue);
		if (tmpCurrent.size !== tmpRequested.size)
		{
			return true;
		}
		for (const tmpIdentity of tmpRequested)
		{
			if (!tmpCurrent.has(tmpIdentity))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * Fetch the record(s) behind a value and cascade them. A response that arrives after the value has moved on
	 * is discarded without writing the record, cascading or calling fCallback; the async operation still completes.
	 * @param {Object} pView @param {Object} pInput @param {any} pIDValue @param {string} pEntity
	 * @param {string} pTransactionGUID @param {string} [pRecordIdentityField] @param {number|string|null} [pRowIndex]
	 * @param {(pRecord: any) => void} [fCallback]
	 */
	_refreshRecord(pView, pInput, pIDValue, pEntity, pTransactionGUID, pRecordIdentityField, pRowIndex, fCallback)
	{
		const tmpRefreshEvent = `${pEntity}Refresh-${this.pict.getUUID()}`;
		pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pIDValue)
		{
			// if we don't have an ID value, we should clear out any existing record at this address and fire the change event with an empty record
			// rather than go do a fetch with an empty or undefined ID which is wasteful
			const tmpRecordPayload = pInput.PictForm.Multiple ? [] : { };
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress, tmpRecordPayload);
			this._onRecordRefresh(pView, pInput, tmpRecordPayload, tmpRecordAddress, pTransactionGUID, pRowIndex);
			if (typeof fCallback === 'function')
			{
				fCallback(tmpRecordPayload);
			}
			pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			return;
		}
		const tmpRecordIdentityField = pRecordIdentityField || `ID${pEntity}`;
		// Refresh by default: re-fetch the latest record on open. Two cases keep the persisted snapshot instead (when
		// it already matches the value): a frozen document (read-only / Locked), or a field that explicitly opts out
		// with PictForm.RefreshOnOpen === false. A changed selection never matches the snapshot, so it always loads.
		const tmpExistingRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!pInput.PictForm?.Multiple && tmpExistingRecord && typeof tmpExistingRecord === 'object' && !Array.isArray(tmpExistingRecord) &&
			tmpExistingRecord[tmpRecordIdentityField] == pIDValue && (this._isRecordFrozen() || pInput.PictForm?.RefreshOnOpen === false))
		{
			this._onRecordRefresh(pView, pInput, tmpExistingRecord, tmpRecordAddress, pTransactionGUID, pRowIndex);
			if (typeof fCallback === 'function')
			{
				fCallback(tmpExistingRecord);
			}
			pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			return;
		}
		const fOnRecords = (pError, pRecords) =>
		{
			// The value moved on while this fetch was in flight; the refresh for the current value owns the record.
			if (this._isStaleRecordRefresh(pView, pInput, pRowIndex, pIDValue))
			{
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
				return;
			}
			if (pError || !Array.isArray(pRecords))
			{
				this.pict.log.error(`Error fetching ${pEntity} record with ${tmpRecordIdentityField} = ${pIDValue}: ${pError || 'No records found'}`);
				if (typeof fCallback === 'function')
				{
					fCallback(null);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
				return;
			}
			let tmpRecordPayload;
			if (pInput.PictForm.Multiple)
			{
				tmpRecordPayload = this._alignRecordsToRequestedValues(pRecords || [], pIDValue, tmpRecordIdentityField, pEntity);
			}
			else
			{
				if (pRecords.length > 1)
				{
					this.pict.log.warn(`Multiple ${pEntity} records found with ${tmpRecordIdentityField} = ${pIDValue}. Using the first record.`);
				}
				const tmpHeldRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
				tmpRecordPayload = pRecords[0] ? this._reconcileRefreshedRecord(pView, pInput, tmpHeldRecord, pRecords[0], tmpRecordIdentityField, pIDValue, pRowIndex) : (tmpHeldRecord || { });
			}
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress, tmpRecordPayload);
			this._onRecordRefresh(pView, pInput, tmpRecordPayload, tmpRecordAddress, pTransactionGUID, pRowIndex);
			if (typeof fCallback === 'function')
			{
				fCallback(tmpRecordPayload);
			}
			pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
		};
		if (libSharedEntityRead.isEmptyIdentityValue(tmpRecordIdentityField, pIDValue))
		{
			fOnRecords(null, [ ]);
			return;
		}
		libSharedEntityRead.readJSON(this.pict, `${pEntity}s/FilteredTo/FBL~${tmpRecordIdentityField}~INN~${encodeURIComponent(pIDValue)}`, { ReuseResult: false }, fOnRecords);
	}

	/**
	 * Choose what a single-record refresh writes: the server row, or the record the form already holds.
	 *
	 * A re-fetch of the record already selected is server state, not an edit, so the baseline moves with
	 * the fields the server changed (`EntityDataBaseline.classifyRecordRefresh`). When the held record
	 * carries a change the server does not have yet, the row is not written; the record is flagged out of
	 * date instead, and the manual refresh stays the user's choice. A changed selection always takes the row.
	 * `MaterialsCascadePicker._reconcileRefreshedRecord` is the Picker family's copy; the two must agree.
	 *
	 * @param {Object} pView @param {Object} pInput
	 * @param {Record<string, any>|null} pHeldRecord - The record at the address when the row arrived.
	 * @param {Record<string, any>} pFetchedRecord - The server row.
	 * @param {string} pRecordIdentityField @param {any} pIDValue @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>} - The record to write.
	 */
	_reconcileRefreshedRecord(pView, pInput, pHeldRecord, pFetchedRecord, pRecordIdentityField, pIDValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !pHeldRecord || typeof pHeldRecord !== 'object' || Array.isArray(pHeldRecord) || pHeldRecord[pRecordIdentityField] != pIDValue)
		{
			return pFetchedRecord;
		}
		const tmpEntity = this._getEntity(pInput);
		const tmpGUID = pFetchedRecord[`GUID${tmpEntity}`] || pHeldRecord[`GUID${tmpEntity}`];
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpDecision = EntityDataBaseline.classifyRecordRefresh(this.pict, tmpContext, tmpEntity, tmpGUID, pHeldRecord, pFetchedRecord);
		if (tmpDecision.Action === 'keep')
		{
			this.pict.log.info(`MaterialsEntitySelector: kept the held ${tmpEntity} ${tmpGUID} over the server row: ${tmpDecision.Reason}.`);
			const tmpKey = this._desyncKey(pInput, pRowIndex);
			this._desyncState()[tmpKey] = 'stale';
			this._recordDesyncFetched[tmpKey] = pFetchedRecord;
			this._renderDesyncAffordance(pView, pInput, /** @type {number} */ (pRowIndex));
			return pHeldRecord;
		}
		if (tmpDecision.Action === 'adopt')
		{
			EntityDataBaseline.adoptRefreshedFields(this.pict, tmpContext, tmpEntity, tmpGUID, pFetchedRecord, tmpDecision.Fields);
		}
		return pFetchedRecord;
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - A transaction GUID to associate with this operation.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpEvent = `${this._getEntity(pInput)}Changed:${this._getTrackingGUID(pInput, pRowIndex)}:${this._getRecordAddress(pView, pInput, pRowIndex)}`;
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, pTransactionGUID);
		if (pInput.PictForm.FireTriggerGroupOnRecordRefresh)
		{
			const tmpEmitterHash = pInput.Hash || pInput.DataAddress;
			// Hydration guard: this record-refresh fan-out is a SYNCHRONOUS cascade (the trigger group plus every
			// sibling autofill it emits). A load is authoritative — persisted values must display, not be re-vetted
			// against the current filter scope — so mark the fan-out; the autofill-scope vet skips while it is set
			// (see onAfterEventCompletion / onAfterEventTabularCompletion). Counter handles re-entrant refreshes;
			// finally guarantees reset even if a handler throws.
			this.pict._MaterialsEntityHydrationDepth = (this.pict._MaterialsEntityHydrationDepth || 0) + 1;
			try
			{
				if (pRowIndex != null)
				{
					// Tabular anchor: include the emitting row index so a dependent picker
					// clears ONLY its own row, not every row of the table (see
					// _matchedDynamicFilterForEventTabular). The global broadcast still fans
					// this out to every row's onAfterEventTabularCompletion; the row index in
					// slot [4] is what lets each row decide whether the change was its own.
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${pRowIndex}:${this.pict.getUUID()}`);
				}
				else
				{
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${pInput.PictForm.FireTriggerGroupOnRecordRefresh}:RecordRefresh:${tmpEmitterHash}:${this.pict.getUUID()}`);
				}
			}
			finally
			{
				this.pict._MaterialsEntityHydrationDepth--;
			}
		}
	}

	/**
	 * Fire the save-time EntityData projection when this provider has at least one creation-enabled
	 * input (latched in _isEntityCreationEnabled). Mirrors the trigger the Test selector owns, so a
	 * creating base selector persists its records on a form with no Test selector present. Providers'
	 * onBeforeSaveDataAsync run once each, sequentially (Anticipate waterfall ordered by
	 * AutoSaveDataOrdinal); when both this and the Test selector are present each fires once and every
	 * projector re-collects from its current __Record, so the redundant pass is idempotent. No-op (and
	 * no empty _EntityData reset) for a provider with no creation-enabled input — default behavior.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (!this._entityCreationEnabled)
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}
		if (!this._isScopedEntityDataEnabled())
		{
			this.pict.manifest.setValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.FormData._EntityData', { });
		}
		const tmpEvent = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';
		const tmpTransactionGUID = this.pict.getUUID();
		/** @type {any} */ (this.pict).TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this._sanitizeProjectedComprehensions();
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * The object this input projects its created records into on the save sweep, keyed
	 * `<Entity>.<GUID>`. THE ONE PLACE the scoped/legacy decision is made on the emission side: the
	 * projectors below take the object and are identical on both paths, because a context root and
	 * the legacy ledger have the same shape.
	 *
	 * Scoped roots are remembered for the post-sweep sanitize pass.
	 *
	 * @param {Object} pInput - The form input descriptor.
	 * @param {string} pEvent - The sweep event.
	 * @return {Record<string, any>|null} - The projection target, or null when this is not a sweep
	 *   event or no target resolves (never fabricates one).
	 */
	_getProjectionTarget(pInput, pEvent)
	{
		if (typeof pEvent !== 'string')
		{
			return null;
		}
		const [ tmpEventType, tmpTargetAddress ] = pEvent.split(':');
		if (tmpEventType !== 'ProjectEntityDataRecords')
		{
			return null;
		}
		if (this._isScopedEntityDataEnabled())
		{
			const tmpContext = this._getComprehensionContext(pInput);
			const tmpContextRoot = ScopedEntityData.resolveContextRoot(this.pict, tmpContext);
			// A baseline sweep collects into a detached scratch tree: nothing was emitted, so neither the
			// FormEntityCreator cross-check nor the post-sweep delta pass may be armed by it.
			if (tmpContextRoot && !ScopedEntityData.getBaselineSweepTarget(this.pict))
			{
				ScopedEntityData.markActive(this.pict);
				if (!this._scopedProjectionRoots)
				{
					this._scopedProjectionRoots = new Map();
				}
				this._scopedProjectionRoots.set(tmpContext, tmpContextRoot);
			}
			return tmpContextRoot;
		}
		if (!tmpTargetAddress)
		{
			return null;
		}
		const tmpTarget = this.pict.manifest.getValueAtAddress(this.pict, tmpTargetAddress);
		if (!tmpTarget || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return null;
		}
		return tmpTarget;
	}

	/**
	 * Narrow every scoped root this provider projected into during the sweep: strip transient `__` UI
	 * state, then reduce each record to what changed since the baseline. Runs once, after the sweep,
	 * rather than at each write — the projectors key the form's LIVE record objects in, so acting
	 * earlier would either mutate the record the form renders from or force every projector to clone.
	 */
	_sanitizeProjectedComprehensions()
	{
		// Also the roots the picker family noted (this family never notes any): on a form that runs the
		// pickers, this provider's sweep re-projects their records and would otherwise send them whole.
		const tmpRoots = new Map(this._scopedProjectionRoots || []);
		for (const [ tmpContext, tmpContextRoot ] of ScopedEntityData.takeNotedProjectionRoots(this.pict))
		{
			tmpRoots.set(tmpContext, tmpContextRoot);
		}
		if (tmpRoots.size < 1)
		{
			return;
		}
		// Handed to the document save, which folds every provider's emission ONCE just before the PUT.
		// Folding here instead would advance the baseline mid-save, and the next provider's prune over
		// this same root would then suppress every record and send an empty comprehension.
		const tmpEmitted = new Map();
		for (const [ tmpContext, tmpContextRoot ] of tmpRoots)
		{
			EntityDataBaseline.pruneContextRootToDelta(this.pict, tmpContext, tmpContextRoot);
			tmpEmitted.set(tmpContext, tmpContextRoot);
		}
		if (this._scopedProjectionRoots)
		{
			this._scopedProjectionRoots.clear();
		}
		tmpEmitted.forEach((pContextRoot, pContext) => EntityDataBaseline.recordPendingEmission(this.pict, pContext, pContextRoot));
	}

	/**
	 * Ask for the load-settled baseline capture on this render transaction. Idempotent across every
	 * input on the form and across both input families — the first to ask schedules it.
	 * @param {Object} pView @param {string} pTransactionGUID
	 */
	_scheduleBaselineCapture(pView, pTransactionGUID)
	{
		if (!this._isScopedEntityDataEnabled())
		{
			return;
		}
		EntityDataBaseline.scheduleLoadBaselineCapture(this.pict, pView, pTransactionGUID);
	}


	/**
	 * Generic save-time projection handler. On the ProjectEntityDataRecords sweep, write this input's
	 * created __Record into the target _getProjectionTarget resolved (keyed by GUID<Entity> inside
	 * _syncRecordToEntityData), plus any sibling DocumentPolyJoin. Opt-in via AllowEntityCreation;
	 * opt-out per input via SkipEntityDataProjection. No-op for non-creating selectors, so default
	 * behavior is unchanged. _syncRecordToEntityData itself no-ops unless the record carries a
	 * GUID<Entity>, a second safety gate. Subclasses that already project via their own _handleEvent
	 * (e.g. Sample) re-run this idempotently through super — same target object, same GUID key.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string' || !this._isEntityCreationEnabled(pInput) || pInput?.PictForm?.SkipEntityDataProjection)
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpDocumentPolyJoinAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${tmpRecordAddress}_DocumentPolyJoin`;
		const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
		if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
		{
			if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
			{
				tmpTarget.DocumentPolyJoin = { };
			}
			tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
		}
	}

	/**
	 * Whether this provider emits scoped `Document.EntityData` comprehensions instead of the legacy
	 * `FormData._EntityData` ledger. The same flag stands `FormEntityCreator` down, so the two
	 * paths never run together.
	 * @return {boolean}
	 */
	_isScopedEntityDataEnabled()
	{
		return ScopedEntityData.isEnabled(this.pict);
	}

	/**
	 * The trigger context this input's records are applied under. Scheduling is manifest data:
	 * `PictForm.ComprehensionContext` selects it, the provider default (`OnSave`) applies otherwise.
	 * @param {Object} pInput
	 * @return {string}
	 */
	_getComprehensionContext(pInput)
	{
		return ScopedEntityData.resolveContext(pInput, this.options?.ComprehensionContext || ScopedEntityData.DEFAULT_CONTEXT);
	}


	/**
	 * Whether a sample-join refresh may rewrite this input's joins. A frozen document keeps the joins it
	 * saved; an input that must follow the database even then sets `PictForm.RefreshJoinsWhenLocked: true`.
	 * @param {Object} pInput
	 * @return {boolean}
	 */
	_shouldRefreshSampleJoins(pInput)
	{
		return !this._isRecordFrozen() || pInput?.PictForm?.RefreshJoinsWhenLocked === true;
	}

	/**
	 * The empty-result branch of a sample-join refresh: drop the held joins whose rows were soft-deleted
	 * since the document was saved, and their values from the selection. Only a row read back as deleted
	 * is dropped (`ScopedEntityData.resolveSoftDeletedJoins`); anything else keeps the persisted value. The
	 * drop is a load, so no deletion is staged, and it re-salts the input so a re-add mints a GUID the
	 * deleted row does not own. An input with `RefreshOnOpen: false` keeps its saved snapshot.
	 *
	 * The drop is applied to the joins and value the input holds when the reads settle
	 * (`ScopedEntityData.applySoftDeletedDrop`), not to the ones it started from, so a refresh that landed
	 * meanwhile is not undone and an overlapping drop that already removed the links writes nothing.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {{ Entity: string, ValueField: string, JoinAddress: string, Value: any, Label: string }} pJoinScope
	 * @param {(pDropped: number) => void} fDone - Called once, after any write, with the number of held links
	 *   found deleted.
	 */
	_dropSoftDeletedHeldJoins(pView, pInput, pRowIndex, pJoinScope, fDone)
	{
		if (pInput.PictForm?.RefreshOnOpen === false)
		{
			return fDone(0);
		}
		const tmpHeldJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), pJoinScope.JoinAddress);
		ScopedEntityData.resolveSoftDeletedJoins(this.pict, pJoinScope.Entity, pJoinScope.ValueField, tmpHeldJoins, pJoinScope.Value, (pResult) =>
		{
			if (pResult.Dropped.length < 1)
			{
				return fDone(0);
			}
			const tmpDestination = pView.getMarshalDestinationObject();
			const tmpDrop = ScopedEntityData.applySoftDeletedDrop(pJoinScope.Entity, pJoinScope.ValueField,
				this.pict.manifest.getValueAtAddress(tmpDestination, pJoinScope.JoinAddress),
				this.pict.manifest.getValueAtAddress(tmpDestination, this._getValueAddress(pView, pInput, pRowIndex)),
				pResult);
			if (!tmpDrop.Changed)
			{
				return fDone(pResult.Dropped.length);
			}
			ScopedEntityData.beginProgrammaticLoad(this.pict);
			try
			{
				if (tmpDrop.Removed.length > 0)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, pJoinScope.JoinAddress, tmpDrop.Joins);
				}
				const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpHeldRecords = this.pict.manifest.getValueAtAddress(tmpDestination, tmpRecordAddress);
				const tmpKeptRecords = ScopedEntityData.pruneRecordsToValue(tmpHeldRecords, pJoinScope.ValueField, tmpDrop.Value);
				if (tmpKeptRecords !== tmpHeldRecords)
				{
					this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, tmpKeptRecords);
				}
				if (tmpDrop.ValueChanged)
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpDrop.Value);
					}
					else
					{
						pView.setDataByInput(pInput, tmpDrop.Value);
					}
				}
			}
			finally
			{
				ScopedEntityData.endProgrammaticLoad(this.pict);
			}
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
			this.log.info(`${pJoinScope.Label}: dropped ${tmpDrop.Removed.length} link(s) whose record was deleted since the document was saved: ${pResult.Dropped.join(', ')}; value now [${tmpDrop.Value}].`);
			return fDone(pResult.Dropped.length);
		});
	}

	/**
	 * A creation-enabled selection was cleared. Two things follow, both only under the scoped path:
	 * tombstones for the rows this selector owns (`_collectRemovedDependentRecords`; never the selected
	 * record itself), and a FRESH `__Salt` so a re-add mints a NEW GUID — an upsert cannot un-delete a
	 * soft-deleted row, so re-using the GUID would upsert into the tombstoned row. No-op unless the
	 * cleared record actually carried its client GUID.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} [pRowIndex]
	 */
	_handleEntitySelectionCleared(pView, pInput, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || !this._isEntityCreationEnabled(pInput))
		{
			return;
		}
		const tmpEntity = this._getEntity(pInput);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		const tmpGUID = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[`GUID${tmpEntity}`] : null;
		if (!tmpGUID)
		{
			return;
		}
		this._stageRemovalTombstones(pInput, this._collectRemovedDependentRecords(pView, pInput, pRowIndex, new Set()), 'clear');
		this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
	}

	/**
	 * Stage tombstones for a set of removed records and report what happened. Every removal route in
	 * this family funnels through here, so the gates (persisted, document-owned) and the logging are
	 * applied once. A record the guard would refuse is logged at debug and NOT staged — see
	 * `docs/plans/entitydata-round2/05-client-delete-completeness.md` §4.
	 * @param {Object} pInput @param {Array<{ Entity: string, Record: Record<string, any> }>} pRemovals
	 * @param {string} pReason - What removed them, for the log line.
	 * @return {number} - How many tombstones were staged.
	 */
	_stageRemovalTombstones(pInput, pRemovals, pReason)
	{
		if (!this._isScopedEntityDataEnabled() || !Array.isArray(pRemovals) || pRemovals.length < 1)
		{
			return 0;
		}
		const tmpContext = this._getComprehensionContext(pInput);
		const tmpResult = ScopedEntityData.tombstoneRemovedRecords(this.pict, tmpContext, pRemovals);
		if (tmpResult.Staged.length > 0)
		{
			this.pict.log.info(`MaterialsEntitySelector[${pInput.Hash || pInput.DataAddress}]: staged deletion of ${tmpResult.Staged.length} record(s) on ${pReason}.`, { Records: tmpResult.Staged });
		}
		return tmpResult.Staged.length;
	}

	/**
	 * The identity values a committed selection retains, as a Set of strings. The value list IS the
	 * identity list for a Multiple selector (`_alignRecordsToRequestedValues` depends on the same
	 * property).
	 * @param {any} pValue @return {Set<string>}
	 */
	_getRetainedIdentitySet(pValue)
	{
		const tmpRetained = new Set();
		if (pValue == null || pValue === '')
		{
			return tmpRetained;
		}
		for (const tmpToken of String(pValue).split(','))
		{
			const tmpTrimmed = tmpToken.trim();
			if (tmpTrimmed.length > 0)
			{
				tmpRetained.add(tmpTrimmed);
			}
		}
		return tmpRetained;
	}

	/**
	 * The rows this selector owns for a de-selected value — the rows correlated to its selection, never the
	 * selected record. Subclasses declare their own (TestInstance units, `SampleLabJoin`s, `SampleLineItemJoin`s);
	 * the base owns the document's `DocumentPolyJoin` to the selection, which goes when nothing stays selected.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities - The identities still selected.
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		if (pRetainedIdentities.size > 0)
		{
			return [ ];
		}
		const tmpAddress = pInput.PictForm?.DocumentPolyJoinAddress || `${this._getRecordAddress(pView, pInput, pRowIndex)}_DocumentPolyJoin`;
		return ScopedEntityData.collectTestInstanceUnit({ DocumentPolyJoin: this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress) });
	}

	/**
	 * The de-selection seam. A Multiple selector expresses removal by committing a SHORTER value
	 * list, which `_pruneUnselectedOptions` then reflects in the DOM and `_refreshRecord` replaces
	 * `__Record` from — so the only moment the dropped records still exist is before that runs.
	 *
	 * Suppressed during a programmatic load: `setDataByInput` routes into `onDataChange`, so an
	 * adoption (`_loadSampleTests`) or a `SampleChanged` re-bind arrives here looking exactly like a
	 * user de-selection. Those detach records from the form without removing them from the sample,
	 * which is why they must stage nothing.
	 *
	 * Anything removed also rotates `__Salt`, so a later re-add of the same value mints a new GUID
	 * rather than the removed row's. Kept records carry their stored GUIDs and are never re-derived
	 * from the salt, so the rotation only reaches records minted after it.
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 */
	_handleSelectionRemovals(pView, pInput, pValue, pRowIndex)
	{
		if (!this._isScopedEntityDataEnabled() || ScopedEntityData.isProgrammaticLoad(this.pict))
		{
			return;
		}
		const tmpRetained = this._getRetainedIdentitySet(pValue);
		const tmpRemovals = this._collectRemovedDependentRecords(pView, pInput, pRowIndex, tmpRetained);
		this._stageRemovalTombstones(pInput, tmpRemovals, 'de-selection');
		if (tmpRemovals.length > 0)
		{
			this._generateSaltIfNeeded(pView, pInput, pRowIndex, true);
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Record<string, Record<string, any>>} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntity = this._getEntity(pInput);
		const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !tmpRecord[`GUID${tmpEntity}`])
		{
			return;
		}
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		if (!tmpEntityData[tmpEntity] || typeof tmpEntityData[tmpEntity] !== 'object' || Array.isArray(tmpEntityData[tmpEntity]))
		{
			tmpEntityData[tmpEntity] = { };
		}
		tmpEntityData[tmpEntity][tmpRecord[`GUID${tmpEntity}`]] = tmpRecord;
	}

	/**
	 * Remove only the <option>s that are no longer selected, leaving the rest untouched.
	 *
	 * The multi-select marshal used to `.empty()` the whole element and let
	 * _renderEntitiesToPicker rebuild it. Functionally fine, visually not: select2 repaints
	 * from the element, so every tag vanishes and comes back -- and the marshal fan-out runs
	 * it several times per change.
	 *
	 * Pruning is the half `.empty()` was actually needed for (dropping de-selected values);
	 * adding back is already _renderEntitiesToPicker's job and it appends only what is
	 * missing. Doing both incrementally means the picker is never empty.
	 *
	 * @param {string} pSelector - The select element's selector.
	 * @param {Array<string>} pValues - The values that should remain.
	 * @return {number} - How many options were removed.
	 */
	_pruneUnselectedOptions(pSelector, pValues)
	{
		const tmpElement = window['jQuery'](pSelector)[0];
		if (!tmpElement || !tmpElement.options)
		{
			return 0;
		}
		const tmpKeep = {};
		for (let i = 0; i < (pValues || []).length; i++)
		{
			tmpKeep[String(pValues[i])] = true;
		}
		let tmpRemoved = 0;
		// Backwards: removing shifts the live options collection.
		for (let i = tmpElement.options.length - 1; i >= 0; i--)
		{
			if (!tmpKeep[String(tmpElement.options[i].value)])
			{
				tmpElement.remove(i);
				tmpRemoved++;
			}
		}
		return tmpRemoved;
	}

	/**
	 * Reduce a Multiple selector's hydrated records to exactly ONE per selected value.
	 *
	 * The hydration query (`<Entity>s/FilteredTo/FBL~<identity>~INN~<values>`) is not scoped
	 * to a customer, so an identity field that is not globally unique returns a row per
	 * MATCH rather than per SELECTED VALUE. Seen on LADOTD Sample Creation: `SampleTestIDs`
	 * holds Test HASHES, and `FLDGLB01v1`/`LABGLB01v1` each exist for IDCustomer 10 AND 114,
	 * so two selected tests hydrated four records -- which the test-instance builder then
	 * turned into four table rows ("sometimes there are two tests instead of one").
	 *
	 * The single-value branch below has always collapsed this ("Using the first record"); the
	 * Multiple branch kept every row. A Multiple selector's records must be 1:1 with its
	 * values -- the value list IS the identity list.
	 *
	 * ⚠️ Ambiguity is resolved by taking the FIRST match, matching the single-value branch,
	 * and warns when it has to choose. It cannot prefer the "right" customer: there is no
	 * reliable client-side customer here (`CurrentUser.CustomerID` is the logged-in user's,
	 * which is 1 for internal staff, not the document's). Scoping the query -- or the
	 * endpoint -- is the real fix; this keeps the form self-consistent meanwhile.
	 *
	 * Fails OPEN: if nothing lines up (an identity field that is not what the value list
	 * holds) the original records are returned untouched rather than blanking the field.
	 *
	 * @param {Array<any>} pRecords - The hydrated records.
	 * @param {any} pIDValue - The selected value(s), comma-delimited.
	 * @param {string} pRecordIdentityField - The field the values are matched against.
	 * @param {string} pEntity - Entity name, for logging.
	 * @return {Array<any>} - One record per selected value, in the selected order.
	 */
	_alignRecordsToRequestedValues(pRecords, pIDValue, pRecordIdentityField, pEntity)
	{
		const tmpRequested = String((pIDValue === null || pIDValue === undefined) ? '' : pIDValue)
			.split(',').map((pValue) => pValue.trim()).filter((pValue) => pValue !== '');
		if (!tmpRequested.length || !Array.isArray(pRecords) || !pRecords.length)
		{
			return pRecords;
		}
		const tmpAligned = [];
		for (let i = 0; i < tmpRequested.length; i++)
		{
			const tmpMatches = pRecords.filter((pRecord) => pRecord && (String(pRecord[pRecordIdentityField]) === tmpRequested[i]));
			if (!tmpMatches.length)
			{
				continue;
			}
			if (tmpMatches.length > 1)
			{
				this.pict.log.warn(`Multiple ${pEntity} records share ${pRecordIdentityField} = ${tmpRequested[i]} (${tmpMatches.length} found); using the first. The hydration query is not customer-scoped.`);
			}
			tmpAligned.push(tmpMatches[0]);
		}
		// Nothing matched -- the identity field is not what the value list holds. Leave it alone.
		return tmpAligned.length ? tmpAligned : pRecords;
	}

	/**
	 * Safely read a select2 element's current selection, returning [] when the element isn't
	 * select2-initialized yet. The form can marshal a value before the picker's select2 finishes
	 * initializing; calling `.select2('data')` then logs "called on an element not using Select2"
	 * and throws "Cannot read properties of undefined (reading 'data')". Gate on the select2 instance.
	 *
	 * @param {string} pSelector
	 * @return {Array<any>}
	 */
	_safeSelect2Data(pSelector)
	{
		const tmp$ = window['jQuery'](pSelector);
		return (tmp$.data('select2') ? tmp$.select2('data') : null) || [];
	}
}

module.exports = MaterialsEntityInputType;

},{"./_EntityDataBaseline.js":154,"./_FilterToggleUI.js":158,"./_LabRouting.js":159,"./_ScopedEntityData.js":162,"./_SeedRecord.js":163,"./_SharedEntityRead.js":164,"pict-section-form":587}],90:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorLabDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = MaterialsSelectorLabDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":87}],91:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsLabPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'Lab',
};

/**
 * The Lab picker (beast B4 — a JOIN cascade): the Picker-stack port of MaterialsLabSelector, mirroring
 * the legacy provider 1:1 on the MaterialsCascadePicker base. Multi-select by default; selecting labs
 * reconciles the sibling SampleLabJoin array (reuse-by-IDLab so server ids and downstream edits — e.g.
 * Received — survive re-selection). On the bound sample's SampleChanged it re-derives value + joins from
 * the DB; SampleLabSync (broadcast when a per-test lab changes) reconciles this selection with them; the
 * ProjectEntityDataRecords sweep projects the joins into _EntityData.
 */
class PictProviderInputTypeMaterialsLabPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/** Labs are customer-scoped (row-level auth), not project-scoped — the legacy hook only added the
	 *  Name sort on top of the shared pipeline. @param {Record<string, any>} pInput
	 *  @param {number|string|null} [pRowIndex] @param {Object} [pView] @return {{Filters: Array<string>, BackOffFilters: Array<string>}} */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		tmpSplit.Filters.push('FSF~Name~ASC~0');
		return tmpSplit;
	}

	/** Init: legacy defaults (multi-select, Name EntityTag) + the configured family tracking GUID. */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyLabDefaults(pInput);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** Tabular twin of the init. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyLabDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** A sample can ship to several labs (multi-select), tag on Name. @param {Record<string, any>} pInput */
	_applyLabDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
	}

	/**
	 * Reconcile the selected Labs against the existing SampleLabJoins: reuse matches (by IDLab —
	 * preserving server ids + downstream edits), synthesize new (GUID minted off the document + salt +
	 * IDLab; saved-vs-unsaved sample keying), drop deselected. Ported 1:1.
	 * @param {Array<Record<string, any>>} pLabs @param {Array<Record<string, any>>} pCurrentSampleLabJoins
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex @return {Array<Record<string, any>>}
	 */
	_syncSampleLabJoins(pLabs, pCurrentSampleLabJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLabJoins) ? pCurrentSampleLabJoins.slice() : [ ];
		const tmpSampleLabJoins = [ ];
		for (const tmpLab of pLabs || [])
		{
			if (!tmpLab || typeof tmpLab !== 'object')
			{
				continue;
			}
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLab == tmpLab.IDLab);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLabJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLabJoinRecord ||
				{
					GUIDSampleLabJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLab: tmpLab.IDLab,
					Received: 0,
				}));
			tmpNewJoin.GUIDSampleLabJoin += `-${tmpLab.IDLab}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLabJoin)
			{
				tmpNewJoin.GUIDSampleLabJoin = this.pict.getUUID();
			}
			tmpSampleLabJoins.push(tmpNewJoin);
		}
		return tmpSampleLabJoins;
	}

	/**
	 * A de-selected Lab takes its `SampleLabJoin` with it. Picker twin of the selector hook.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpRecordAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLab)))
			{
				tmpRemovals.push({ Entity: 'SampleLabJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * The Lab cascade — the port of the legacy `_onRecordRefresh`: reconcile the SampleLabJoin array
	 * beside the record (clear → drop all joins), repaint dependents in-section, then super (the family
	 * bus fan-out). A cleared picker hands the seam `{}`/`[]` — normalized to "no labs" like the legacy's
	 * falsy-record branch.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpLabs = Array.isArray(pRecord) ? pRecord :
			((pRecord && typeof pRecord === 'object' && Object.keys(pRecord).length > 0) ? [ pRecord ] : [ ]);
		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		let tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLabJoins))
		{
			if (tmpSampleLabJoins)
			{
				this.log.error(`MaterialsLabPicker: SampleLabJoins at address ${tmpSampleLabJoinsAddress} is not an array`, { tmpSampleLabJoins });
			}
			tmpSampleLabJoins = [ ];
		}
		tmpSampleLabJoins = this._syncSampleLabJoins(tmpLabs, tmpSampleLabJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress, tmpSampleLabJoins);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * SampleChanged starts this input's sample-level load, so it is handled while the event is raised.
	 * @return {Array<string>}
	 */
	_getTriggerTimeEventTypes()
	{
		return [ 'SampleChanged' ];
	}

	/**
	 * Family + save-sweep events — ported 1:1 from the legacy `_handleEvent`:
	 *   - SampleChanged (tracking-matched): re-derive this selector from the DB — load the sample's
	 *     SampleLabJoins, land them at the join address, and commit the joined lab ids as the value
	 *     (the programmatic set re-runs the provider loop, so the join reconcile rides the same path a
	 *     user pick does). No/invalid sample resets the joins. The fence op is registered only when a
	 *     fetch actually runs (the legacy registered before its IDSample check and leaked the op —
	 *     unreachable-hang family, same reasoned-divergence lineage as B2's clear-reset).
	 *   - SampleLabSync (broadcast, no tracking): the per-test labs changed. Reconcile OUR value with
	 *     them (_LabRouting.syncSampleLabSelection) and commit — the programmatic set re-runs the
	 *     provider loop, so the join array derives itself.
	 *   - ProjectEntityDataRecords: project the joins (+ any sibling DocumentPolyJoin) into the sweep
	 *     target.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpSampleLabJoinAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			const tmpRefreshEvent = `SampleLabJoinRefresh-${this.pict.getUUID()}`;
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLabJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no labs". Treating it as an empty set and writing that
				// through overwrites the persisted selection on a transient network error -- and the document
				// auto-save then persists the loss with no user action. Abort instead: leave both the joins
				// address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLabPicker: failed to load SampleLabJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLabValue = pRecords.map((pJoin) => pJoin.IDLab).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex, ''));
				if (tmpLabValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLabJoin', ValueField: 'IDLab', JoinAddress: tmpSampleLabJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLabPicker' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLabPicker: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLabJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale; the outgoing sample's
				// joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					this._setValueAndCommit(pView, pInput, tmpLabValue, pRowIndex);
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === libLabRouting.SAMPLE_LAB_SYNC_EVENT)
		{
			const tmpNextValue = libLabRouting.syncSampleLabSelection(this.pict, pInput, pView.getMarshalDestinationObject(),
				this._getRecordAddress(pInput, null, '__Promoted'), pView.getValueByHash(pInput.Hash));
			if (tmpNextValue !== null)
			{
				this._setValueAndCommit(pView, pInput, tmpNextValue, null);
			}
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLabAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpTarget && typeof tmpTarget === 'object' && !Array.isArray(tmpTarget))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Project the SampleLabJoin array into the entity-data collection (keyed by GUIDSampleLabJoin) —
	 * the plural counterpart of the base _syncRecordToEntityData (the Lab CATALOG record itself never
	 * projects; the joins are the created data). Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLabAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		const tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		if (Array.isArray(tmpSampleLabJoins))
		{
			if (!tmpEntityData.SampleLabJoin || typeof tmpEntityData.SampleLabJoin !== 'object' || Array.isArray(tmpEntityData.SampleLabJoin))
			{
				tmpEntityData.SampleLabJoin = { };
			}
			for (const tmpSampleLabJoin of tmpSampleLabJoins)
			{
				tmpEntityData.SampleLabJoin[tmpSampleLabJoin.GUIDSampleLabJoin] = tmpSampleLabJoin;
			}
		}
	}

	/**
	 * The bound Sample record: ask the family over the bus (PushRecord into TempData), falling back to
	 * the conventional SampleAddress. Ported 1:1 (pView may be absent on a BaseFilter-closure call —
	 * the bus path needs no view).
	 * @param {Object|null} pView @param {Record<string, any>} pInput @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			if (!pView || typeof pView.getMarshalDestinationObject !== 'function')
			{
				return null;
			}
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = PictProviderInputTypeMaterialsLabPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86,"./_LabRouting.js":159,"./_ScopedEntityData.js":162}],92:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

/**
 * Install the pin-to-top resolver for a lab selector's select2 options, when the descriptor scopes by
 * `LabScope` and the LabScopeResolver is registered. The resolver answers with its preference ranking
 * (`LabScopeResolver.getPreferredLabIDs`); nothing is hidden.
 *
 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
 * @param {Object} pInput @param {number} [pRowIndex] @param {Object} [pView]
 */
function applyLabPriorityIDs(pPict, pConfigOptions, pInput, pRowIndex, pView)
{
	const tmpEngine = pPict.providers.EntityFilterEngine;
	const tmpResolver = pPict.providers.LabScopeResolver;
	if (!tmpEngine || !tmpResolver || pConfigOptions.GetPriorityIDs)
	{
		return;
	}
	const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
	if (!Array.isArray(tmpFilters))
	{
		return;
	}
	const tmpFilter = tmpFilters.find((pEntry) => pEntry && pEntry.LabScope);
	if (!tmpFilter)
	{
		return;
	}
	const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
	pConfigOptions.GetPriorityIDs = () =>
	{
		return tmpResolver.getPreferredLabIDs(tmpFilter.LabScope,
			{
				IDTest: tmpEngine._readLabScopeTestID(tmpFilter, pInput, tmpRowIndex, pView || null),
			});
	};
}

class MaterialsLabSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleLabJoinAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			const tmpRefreshEvent = `SampleLabJoinRefresh-${this.pict.getUUID()}`;
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLabJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no labs". Treating it as an empty set and writing that
				// through overwrites the persisted selection on a transient network error -- and the document
				// auto-save then persists the loss with no user action. Abort instead: leave both the joins
				// address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLabSelectorInputType: failed to load SampleLabJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLabValue = pRecords.map((pJoin) => pJoin.IDLab).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex, ''));
				if (tmpLabValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLabJoin', ValueField: 'IDLab', JoinAddress: tmpSampleLabJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLabSelectorInputType' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLabSelectorInputType: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLabJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale. It routes through
				// setDataByInput, which enters onDataChange looking exactly like a user de-selection -- but the
				// outgoing sample's joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpLabValue);
					}
					else
					{
						pView.setDataByInput(pInput, tmpLabValue);
					}
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLabAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}

		if (tmpEventType === libLabRouting.SAMPLE_LAB_SYNC_EVENT)
		{
			// The per-test labs changed. Reconcile OUR value (the source of truth) and commit through setDataByInput,
			// which fires onDataChange -> _onRecordRefresh, so the join array derives itself.
			const tmpNextValue = libLabRouting.syncSampleLabSelection(this.pict, pInput, pView.getMarshalDestinationObject(),
				this._getRecordAddress(pView, pInput, null, '__Promoted'), pView.getValueByHash(pInput.Hash));
			if (tmpNextValue !== null)
			{
				pView.setDataByInput(pInput, tmpNextValue);
			}
		}
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * A de-selected Lab takes its `SampleLabJoin` with it. The joins are keyed by `IDLab`, which is
	 * also what this input's value list holds, so the retained set filters them directly.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		const tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		if (!Array.isArray(tmpSampleLabJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpSampleLabJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLab)))
			{
				tmpRemovals.push({ Entity: 'SampleLabJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * @param {Array<Record<string, any>>} pLabs
	 * @param {Array<Record<string, any>>} pCurrentSampleLabJoins
	 * @param {Record<string, any>} pSample
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} pRowIndex
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_syncSampleLabJoins(pLabs, pCurrentSampleLabJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLabJoins) ? pCurrentSampleLabJoins.slice() : [ ];
		const tmpSampleLabJoins = [ ];
		for (const tmpLab of pLabs || [])
		{
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLab == tmpLab.IDLab);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLabJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLabJoinRecord ||
				{
					GUIDSampleLabJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLab: tmpLab.IDLab,
					Received: 0,
				}));
			tmpNewJoin.GUIDSampleLabJoin += `-${tmpLab.IDLab}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLabJoin)
			{
				tmpNewJoin.GUIDSampleLabJoin = this.pict.getUUID();
			}
			tmpSampleLabJoins.push(tmpNewJoin);
		}
		return tmpSampleLabJoins;
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pRecord)
		{
			pRecord = pInput.PictForm.Multiple ? [] : { };
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLabAddress, pRecord);
		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		let tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLabJoins))
		{
			if (tmpSampleLabJoins)
			{
				this.log.error(`MaterialsLabSelectorInputType: SampleLabJoins at address ${tmpSampleLabJoinsAddress} is not an array`, { tmpSampleLabJoins });
			}
			tmpSampleLabJoins = [ ];
		}
		tmpSampleLabJoins = this._syncSampleLabJoins(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpSampleLabJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress, tmpSampleLabJoins);
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLabJoinsAddress = pInput.PictForm.SampleLabJoinAddress || `${tmpLabAddress}_SampleJoins`;
		const tmpSampleLabJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLabJoinsAddress);
		if (Array.isArray(tmpSampleLabJoins))
		{
			if (!tmpEntityData.SampleLabJoin || typeof tmpEntityData.SampleLabJoin !== 'object' || Array.isArray(tmpEntityData.SampleLabJoin))
			{
				tmpEntityData.SampleLabJoin = { };
			}
			for (const tmpSampleLabJoin of tmpSampleLabJoins)
			{
				tmpEntityData.SampleLabJoin[tmpSampleLabJoin.GUIDSampleLabJoin] = tmpSampleLabJoin;
			}
		}
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			// Labs are customer-scoped (row-level auth), not project-scoped — just sort by Name.
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
		applyLabPriorityIDs(this.pict, pConfigOptions, pInput, pRowIndex, pView);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = MaterialsLabSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89,"./_LabRouting.js":159,"./_ScopedEntityData.js":162}],93:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorLineItemDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'LineItem'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple != null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple != null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = MaterialsSelectorLineItemDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":87}],94:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsLineItemPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'LineItem',
};

/**
 * The LineItem picker (beast B4 — a JOIN cascade): the Picker-stack port of MaterialsLineItemSelector,
 * mirroring the legacy provider 1:1 on the MaterialsCascadePicker base. Multi-select by default;
 * selecting line items reconciles the sibling SampleLineItemJoin array (reuse-by-IDLineItem so server
 * ids and the entered RepresentedQuantity survive re-selection) and stamps the display-only
 * `LineItemUnits` onto each join row for the tabular units column. On the bound sample's SampleChanged
 * it re-derives value + joins from the DB; the ProjectEntityDataRecords sweep projects the joins
 * (display fields stripped) into _EntityData.
 */
class PictProviderInputTypeMaterialsLineItemPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/**
	 * Project scoping + Name sort, ported from the legacy hook: the legacy scoped to the BOUND SAMPLE's
	 * project first (document project as fallback), so the base broker's document-project LineItem clause
	 * is suppressed for the super call and the sample-preferred clause applied here (existing clauses
	 * paren-wrapped so it ANDs the whole set, like the legacy).
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}}
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpPriorFlag = tmpPictForm.disableProjectFilteringForEntity;
		tmpPictForm.disableProjectFilteringForEntity = true;
		let tmpSplit;
		try
		{
			tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		}
		finally
		{
			tmpPictForm.disableProjectFilteringForEntity = tmpPriorFlag;
		}
		const tmpFilters = tmpSplit.Filters;
		if (!tmpPictForm.disableProjectFilteringForEntity)
		{
			const tmpSample = this._getBoundSampleRecord(pView, pInput);
			const tmpProjectID = tmpSample?.IDProject || this.pict.AppData.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID > 0)
			{
				if (tmpFilters.length > 0)
				{
					//FIXME: handle existing sort instructions (FSF)
					tmpFilters.unshift('FOP~0~(~0');
					tmpFilters.push('FCP~0~)~0');
				}
				tmpFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
		}
		tmpFilters.push('FSF~Name~ASC~0');
		return tmpSplit;
	}

	/** Init: legacy defaults (multi-select, ItemCode EntityTag) + the configured family tracking GUID. */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyLineItemDefaults(pInput);
		const tmpUnjoinedSelection = this._hasUnjoinedSelection(pView, pInput, pValue);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
		}
		if (tmpUnjoinedSelection)
		{
			this._recommitSeededSelection(pView, pInput, pTransactionGUID);
		}
		return tmpResult;
	}

	/**
	 * Whether the document arrived holding line items but none of their join rows: what a document created
	 * already populated looks like (ex. Sample Creation opened from a sample-plan row). Read before the load
	 * hydrates the value, since hydration builds the join rows without running the selection's trigger group.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_hasUnjoinedSelection(pView, pInput, pValue)
	{
		if (!pView || typeof pView.getMarshalDestinationObject !== 'function' || this._splitPickerValues(pValue, pInput).length < 1)
		{
			return false;
		}
		const tmpJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${this._getRecordAddress(pInput, null)}_SampleJoins`;
		const tmpHeldJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		return !(Array.isArray(tmpHeldJoins) && tmpHeldJoins.length > 0);
	}

	/**
	 * Commit the loaded line items once the load settles, the way a pick lands them, so the selection's
	 * trigger group fills the join rows' table and the item codes. Only for a sample that hasn't been saved:
	 * a saved sample's document already carries its joins, so reopening a form never re-commits.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {string} pTransactionGUID
	 */
	_recommitSeededSelection(pView, pInput, pTransactionGUID)
	{
		if (!pTransactionGUID || typeof pView.registerOnTransactionCompleteCallback !== 'function')
		{
			return;
		}
		pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
		{
			const tmpSample = this._getBoundSampleRecord(pView, pInput);
			if (!tmpSample || Number(tmpSample.IDSample) > 0)
			{
				return;
			}
			const tmpValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, null, ''));
			if (this._splitPickerValues(tmpValue, pInput).length < 1)
			{
				return;
			}
			this._setValueAndCommit(pView, pInput, tmpValue, null);
		});
	}

	/** Tabular twin of the init. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyLineItemDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
		}
		return tmpResult;
	}

	/** A sample can represent several line items (multi-select), tag on ItemCode. @param {Record<string, any>} pInput */
	_applyLineItemDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
	}

	/**
	 * Reconcile the selected LineItems against the existing SampleLineItemJoins: reuse matches (by
	 * IDLineItem — preserving server ids + the entered RepresentedQuantity), synthesize new (GUID minted
	 * off the document + salt + IDLineItem; saved-vs-unsaved sample keying), drop deselected, then stamp
	 * the display-only units column. Ported 1:1.
	 * @param {Array<Record<string, any>>} pLineItems @param {Array<Record<string, any>>} pCurrentSampleLineItemJoins
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex @return {Array<Record<string, any>>}
	 */
	_syncSampleLineItemJoins(pLineItems, pCurrentSampleLineItemJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLineItemJoins) ? pCurrentSampleLineItemJoins.slice() : [ ];
		const tmpSampleLineItemJoins = [ ];
		for (const tmpLineItem of pLineItems || [])
		{
			if (!tmpLineItem || typeof tmpLineItem !== 'object')
			{
				continue;
			}
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLineItem == tmpLineItem.IDLineItem);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLineItemJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLineItemJoinRecord ||
				{
					GUIDSampleLineItemJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLIJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLineItem: tmpLineItem.IDLineItem,
					RepresentedQuantity: '0.000',
				}));
			tmpNewJoin.GUIDSampleLineItemJoin += `-${tmpLineItem.IDLineItem}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLineItemJoin)
			{
				tmpNewJoin.GUIDSampleLineItemJoin = this.pict.getUUID();
			}
			tmpSampleLineItemJoins.push(tmpNewJoin);
		}
		this._stampJoinDisplayFields(tmpSampleLineItemJoins, pLineItems);
		return tmpSampleLineItemJoins;
	}

	/**
	 * Stamp a display-only flat `LineItemUnits` onto each join row (the LineItem's unit, matched by
	 * IDLineItem) so the tabular Rep Qty Units column reads it directly as plain text — a 2nd
	 * EntityDisplay on the same LineItem doesn't render. NOT a SampleLineItemJoin column —
	 * `_syncRecordsToEntityData` MUST strip it or the upsert breaks. Ported 1:1.
	 * @param {Array<Record<string, any>>} pSampleLineItemJoins
	 * @param {Array<Record<string, any>>} pLineItems - The selected LineItem records (carry `Units`).
	 */
	_stampJoinDisplayFields(pSampleLineItemJoins, pLineItems)
	{
		if (!Array.isArray(pSampleLineItemJoins))
		{
			return;
		}
		const tmpUnitsByLineItem = { };
		for (const tmpLineItem of (pLineItems || [ ]))
		{
			if (tmpLineItem && tmpLineItem.IDLineItem != null)
			{
				tmpUnitsByLineItem[tmpLineItem.IDLineItem] = tmpLineItem.Units;
			}
		}
		for (const tmpJoin of pSampleLineItemJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && tmpUnitsByLineItem[tmpJoin.IDLineItem] != null)
			{
				tmpJoin.LineItemUnits = tmpUnitsByLineItem[tmpJoin.IDLineItem];
			}
		}
	}

	/**
	 * A de-selected LineItem takes its `SampleLineItemJoin` with it. Picker twin of the selector hook.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpRecordAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLineItem)))
			{
				tmpRemovals.push({ Entity: 'SampleLineItemJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * The LineItem cascade — the port of the legacy `_onRecordRefresh`: reconcile the SampleLineItemJoin
	 * array beside the record (clear → drop all joins), repaint dependents in-section, then super (the
	 * family bus fan-out). A cleared picker hands the seam `{}`/`[]` — normalized to "no line items"
	 * like the legacy's falsy-record branch.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpLineItems = Array.isArray(pRecord) ? pRecord :
			((pRecord && typeof pRecord === 'object' && Object.keys(pRecord).length > 0) ? [ pRecord ] : [ ]);
		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		let tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLineItemJoins))
		{
			if (tmpSampleLineItemJoins)
			{
				this.log.error(`MaterialsLineItemPicker: SampleLineItemJoins at address ${tmpSampleLineItemJoinsAddress} is not an array`, { tmpSampleLineItemJoins });
			}
			tmpSampleLineItemJoins = [ ];
		}
		tmpSampleLineItemJoins = this._syncSampleLineItemJoins(tmpLineItems, tmpSampleLineItemJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress, tmpSampleLineItemJoins);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * SampleChanged starts this input's sample-level load, so it is handled while the event is raised.
	 * @return {Array<string>}
	 */
	_getTriggerTimeEventTypes()
	{
		return [ 'SampleChanged' ];
	}

	/**
	 * Family + save-sweep events — ported 1:1 from the legacy `_handleEvent`:
	 *   - SampleChanged (tracking-matched): re-derive this selector from the DB — load the sample's
	 *     SampleLineItemJoins, land them at the join address, and commit the joined line-item ids as the
	 *     value (the programmatic set re-runs the provider loop, so the join reconcile rides the same
	 *     path a user pick does). No/invalid sample resets the joins. The fence op is registered only
	 *     when a fetch actually runs (the legacy registered before its IDSample check and leaked the op —
	 *     unreachable-hang family, same reasoned-divergence lineage as B2's clear-reset).
	 *   - ProjectEntityDataRecords: project the joins (+ any sibling DocumentPolyJoin) into the sweep
	 *     target.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpSampleLineItemJoinAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			const tmpRefreshEvent = `SampleLineItemJoinRefresh-${this.pict.getUUID()}`;
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLineItemJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no line items". Treating it as an empty set and writing
				// that through overwrites the persisted selection on a transient network error -- and the
				// document auto-save then persists the loss with no user action. Abort instead: leave both the
				// joins address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLineItemPicker: failed to load SampleLineItemJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLineItemValue = pRecords.map((pJoin) => pJoin.IDLineItem).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex, ''));
				if (tmpLineItemValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLineItemJoin', ValueField: 'IDLineItem', JoinAddress: tmpSampleLineItemJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLineItemPicker' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLineItemPicker: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLineItemJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale; the outgoing sample's
				// joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					this._setValueAndCommit(pView, pInput, tmpLineItemValue, pRowIndex);
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLineItemAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpTarget && typeof tmpTarget === 'object' && !Array.isArray(tmpTarget))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Project the SampleLineItemJoin array into the entity-data collection (keyed by
	 * GUIDSampleLineItemJoin), stripping the display-only unit fields that are not join columns (they
	 * would break the upsert). The plural counterpart of the base _syncRecordToEntityData (the LineItem
	 * CATALOG record itself never projects; the joins are the created data). Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLineItemAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		if (Array.isArray(tmpSampleLineItemJoins))
		{
			if (!tmpEntityData.SampleLineItemJoin || typeof tmpEntityData.SampleLineItemJoin !== 'object' || Array.isArray(tmpEntityData.SampleLineItemJoin))
			{
				tmpEntityData.SampleLineItemJoin = { };
			}
			for (const tmpSampleLineItemJoin of tmpSampleLineItemJoins)
			{
				const tmpPersistedJoin = { ...tmpSampleLineItemJoin };
				// Display-only fields (current + legacy attempts) — NOT SampleLineItemJoin columns; would break the upsert.
				delete tmpPersistedJoin.LineItemUnits;
				delete tmpPersistedJoin.IDLineItemUnits;
				delete tmpPersistedJoin.RepQtyUnits;
				tmpEntityData.SampleLineItemJoin[tmpPersistedJoin.GUIDSampleLineItemJoin] = tmpPersistedJoin;
			}
		}
	}

	/**
	 * The bound Sample record: ask the family over the bus (PushRecord into TempData), falling back to
	 * the conventional SampleAddress. Ported 1:1 (pView may be absent on a BaseFilter-closure call —
	 * the bus path needs no view).
	 * @param {Object|null} pView @param {Record<string, any>} pInput @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			if (!pView || typeof pView.getMarshalDestinationObject !== 'function')
			{
				return null;
			}
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = PictProviderInputTypeMaterialsLineItemPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86,"./_ScopedEntityData.js":162}],95:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

class MaterialsLineItemSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'LineItem'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleLineItemJoinAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			const tmpRefreshEvent = `SampleLineItemJoinRefresh-${this.pict.getUUID()}`;
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLineItemJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no line items". Treating it as an empty set and writing
				// that through overwrites the persisted selection on a transient network error -- and the
				// document auto-save then persists the loss with no user action. Abort instead: leave both the
				// joins address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLineItemSelectorInputType: failed to load SampleLineItemJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLineItemValue = pRecords.map((pJoin) => pJoin.IDLineItem).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex, ''));
				if (tmpLineItemValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLineItemJoin', ValueField: 'IDLineItem', JoinAddress: tmpSampleLineItemJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLineItemSelectorInputType' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLineItemSelectorInputType: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLineItemJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale. It routes through
				// setDataByInput, which enters onDataChange looking exactly like a user de-selection -- but the
				// outgoing sample's joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpLineItemValue);
					}
					else
					{
						pView.setDataByInput(pInput, tmpLineItemValue);
					}
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLineItemAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * A de-selected LineItem takes its `SampleLineItemJoin` with it. The joins are keyed by
	 * `IDLineItem`, which is also what this input's value list holds.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLineItem)))
			{
				tmpRemovals.push({ Entity: 'SampleLineItemJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * @param {Array<Record<string, any>>} pLineItems
	 * @param {Array<Record<string, any>>} pCurrentSampleLineItemJoins
	 * @param {Record<string, any>} pSample
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} pRowIndex
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_syncSampleLineItemJoins(pLineItems, pCurrentSampleLineItemJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLineItemJoins) ? pCurrentSampleLineItemJoins.slice() : [ ];
		const tmpSampleLineItemJoins = [ ];
		for (const tmpLineItem of pLineItems || [])
		{
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLineItem == tmpLineItem.IDLineItem);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLineItemJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLineItemJoinRecord ||
				{
					GUIDSampleLineItemJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLIJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLineItem: tmpLineItem.IDLineItem,
					RepresentedQuantity: '0.000',
				}));
			tmpNewJoin.GUIDSampleLineItemJoin += `-${tmpLineItem.IDLineItem}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLineItemJoin)
			{
				tmpNewJoin.GUIDSampleLineItemJoin = this.pict.getUUID();
			}
			tmpSampleLineItemJoins.push(tmpNewJoin);
		}
		this._stampJoinDisplayFields(tmpSampleLineItemJoins, pLineItems);
		return tmpSampleLineItemJoins;
	}

	/**
	 * Stamp a display-only flat `LineItemUnits` onto each join row (the LineItem's unit, matched by IDLineItem) so the
	 * tabular Rep Qty Units column reads it directly as plain text — a 2nd EntityDisplay on the same LineItem doesn't
	 * render. NOT a SampleLineItemJoin column — `_syncRecordsToEntityData` MUST strip it or the upsert breaks.
	 *
	 * @param {Array<Record<string, any>>} pSampleLineItemJoins
	 * @param {Array<Record<string, any>>} pLineItems - The selected LineItem records (carry `Units`).
	 */
	_stampJoinDisplayFields(pSampleLineItemJoins, pLineItems)
	{
		if (!Array.isArray(pSampleLineItemJoins))
		{
			return;
		}
		const tmpUnitsByLineItem = { };
		for (const tmpLineItem of (pLineItems || [ ]))
		{
			if (tmpLineItem && tmpLineItem.IDLineItem != null)
			{
				tmpUnitsByLineItem[tmpLineItem.IDLineItem] = tmpLineItem.Units;
			}
		}
		for (const tmpJoin of pSampleLineItemJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && tmpUnitsByLineItem[tmpJoin.IDLineItem] != null)
			{
				tmpJoin.LineItemUnits = tmpUnitsByLineItem[tmpJoin.IDLineItem];
			}
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pRecord)
		{
			pRecord = pInput.PictForm.Multiple ? [] : { };
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLineItemAddress, pRecord);
		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		let tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLineItemJoins))
		{
			if (tmpSampleLineItemJoins)
			{
				this.log.error(`MaterialsLineItemSelectorInputType: SampleLineItemJoins at address ${tmpSampleLineItemJoinsAddress} is not an array`, { tmpSampleLineItemJoins });
			}
			tmpSampleLineItemJoins = [ ];
		}
		tmpSampleLineItemJoins = this._syncSampleLineItemJoins(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpSampleLineItemJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress, tmpSampleLineItemJoins);
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		if (Array.isArray(tmpSampleLineItemJoins))
		{
			if (!tmpEntityData.SampleLineItemJoin || typeof tmpEntityData.SampleLineItemJoin !== 'object' || Array.isArray(tmpEntityData.SampleLineItemJoin))
			{
				tmpEntityData.SampleLineItemJoin = { };
			}
			for (const tmpSampleLineItemJoin of tmpSampleLineItemJoins)
			{
				const tmpPersistedJoin = { ...tmpSampleLineItemJoin };
				// Display-only fields (current + legacy attempts) — NOT SampleLineItemJoin columns; would break the upsert.
				delete tmpPersistedJoin.LineItemUnits;
				delete tmpPersistedJoin.IDLineItemUnits;
				delete tmpPersistedJoin.RepQtyUnits;
				tmpEntityData.SampleLineItemJoin[tmpPersistedJoin.GUIDSampleLineItemJoin] = tmpPersistedJoin;
			}
		}
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'ItemCode', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			const tmpSample = this._getBoundSampleRecord(pView, pInput);
			const tmpProjectID = tmpSample?.IDProject || this.pict.AppData.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID > 0)
			{
				if (pFilters.length > 0)
				{
					//FIXME: handle existing sort instructions (FSF)
					pFilters.unshift('FOP~0~(~0');
					pFilters.push('FCP~0~)~0');
				}
				//TODO: do we want to support disabling this filter?
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = MaterialsLineItemSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89,"./_ScopedEntityData.js":162}],96:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

class MaterialsPlantSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'ProductionPlant';
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Name' ];
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			// ProductionPlants are customer-scoped (row-level auth), not project-scoped — just sort by Name.
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
	}
}

module.exports = MaterialsPlantSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89}],97:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorSampleDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Sample'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.SelectedSample.QRCode || 'N/A',
				this.SelectedSample.Name || ('Unnamed Sample #' + this.SelectedSample.GUIDSample),
			);
		}
		else
		{
			tmpDisplayTemplate = this.SelectedSample.Name || ('Unnamed Material #' + this.SelectedSample.IDMaterial);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Build the QR Code Image and prepend it to the input element.
	 * @param {HTMLSelectElement} tmpInputSelectElement The input element.
	 */
	buildPrependedQRCodeImage(tmpInputSelectElement)
	{
		if (this.SelectedSample && !this.appliedQRCodeAlready)
		{
			const tmpCanvas = this.pict.providers.QRCodeProvider.create(this.SelectedSample.QRCode);
			const tmpElement = `<figure class="image mr-2 is-64x64"><img src="${tmpCanvas}" alt="QR Code" /></figure>`;
			// find the parent .column element
			const tmpParentElement = tmpInputSelectElement.closest('.column');
			if (tmpParentElement)
			{
				// prepend the QR Code Image
				tmpParentElement.insertAdjacentHTML('afterbegin', tmpElement);
				tmpParentElement.classList.add('is-flex');
				tmpParentElement.classList.add('is-align-items-center');
				this.appliedQRCodeAlready = true;
			}
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the Material for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Sample record yet, get it and store it
			if (!this.SelectedSample || this.SelectedSample.GUIDSample !== pValue)
			{
				try
				{
					const tmpSample = await this.pict.providers.SampleProvider.getSampleByGUID(pValue);
					this.SelectedSample = tmpSample;
				}
				catch (e)
				{
					this.pict.log.error(`Error fetching Sample with ID ${ pValue }: ${ e }`);
					this.SelectedSample =
					{
						IDMaterial: pValue,
						Name: 'Unkown Material',
					};
				}
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
			// for PDF view, we want to prepend the QRCode Image to the display, if we have one
			this.buildPrependedQRCodeImage(tmpInputSelectElement);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = MaterialsSelectorSampleDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":87}],98:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libFilterToggleUI = require('./_FilterToggleUI.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsSamplePicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Opt into the app save-data lifecycle so onBeforeSaveDataAsync (the SampleSequencing stamp, run
	// before the _EntityData projection sweep) actually fires — legacy parity (the MES Sample selector
	// set AutoSaveDataWithApp too).
	AutoSaveDataWithApp: true,
	// The sample selector creates samples by default; a field opts out via PictForm.AllowEntityCreation.
	AllowEntityCreation: true,
	Entity: 'Sample',
	// How long the first save waits for the device position of a sample created on this form.
	CreationPositionSaveWaitMS: 5000,
};

/**
 * The capture coordinates in a position from the GeoProvider, or null when it holds no usable fix.
 * @param {any} pPosition - `{ CaptureLatitude, CaptureLongitude }` from GeoProvider.getGeoCoords, or null
 * @return {{ CaptureLatitude: number, CaptureLongitude: number }|null}
 */
function readCapturePosition(pPosition)
{
	if (!pPosition || typeof pPosition !== 'object')
	{
		return null;
	}
	const tmpLatitude = Number(pPosition.CaptureLatitude);
	const tmpLongitude = Number(pPosition.CaptureLongitude);
	if (!Number.isFinite(tmpLatitude) || !Number.isFinite(tmpLongitude) || (tmpLatitude === 0 && tmpLongitude === 0))
	{
		return null;
	}
	return { CaptureLatitude: tmpLatitude, CaptureLongitude: tmpLongitude };
}

/**
 * Whether a sample record still needs its creating device's position: a sample the server does not have
 * yet, with no capture coordinates of its own (a seeded or configured record may bring them).
 * @param {any} pRecord
 * @return {boolean}
 */
function needsCapturePosition(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord) || !pRecord.GUIDSample)
	{
		return false;
	}
	if (Number(pRecord.IDSample) > 0)
	{
		return false;
	}
	return !readCapturePosition(pRecord);
}

/**
 * The Sample picker (beast B2 — THE HUB): the Picker-stack port of MaterialsSampleSelector, mirroring
 * the legacy provider 1:1 on the MaterialsCascadePicker base. The sample owns the family's tracking
 * identity; its cascade drives the DocumentPolyJoin synthesis, the spec-year scope, the auto-generated
 * Sample Name, and the form's data requirements; its save hook stamps naming/numbering before the
 * _EntityData projection sweep. Creation (type-to-create) synthesizes a QR-coded, project-bound record.
 */
class PictProviderInputTypeMaterialsSamplePicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/**
	 * A sample is ALWAYS tracked by GUIDSample (legacy hard override — even with creation configured
	 * off, the value identity stays the GUID).
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || 'GUIDSample';
	}

	/**
	 * The synthesized sample: the base mint (document GUID + stanza + salt), then the sample-specific
	 * enrichment — project binding, creating user, designated time, and a fresh QR code. Ported 1:1
	 * (including the legacy '-S-' fallback for a GenerateGUID-opted-out record).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>}
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			tmpRecord = { GUIDSample: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		if (this.pict.AppData.DocumentData?.ReportData?.IDProject > 0)
		{
			tmpRecord.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		}
		tmpRecord.CreatingIDUser = this.pict.AppData.CurrentUser?.UserID;
		tmpRecord.DesignatedTime = new Date().toISOString();
		tmpRecord.QRCode = this.pict.providers.QRCodeProvider.generateNewQRCode(tmpRecord);
		return tmpRecord;
	}

	/**
	 * Create the sample (base), then ask for the creating device's position so the new sample carries
	 * where it was taken (Sample.CaptureLatitude/CaptureLongitude, copied onto its "Sample created" log).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string|null} [pRowIndex]
	 * @return {any} the synthesized identity value (or null when nothing synthesized)
	 */
	_handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		const tmpValue = super._handleDefaultRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		if (tmpValue)
		{
			this._captureCreationPosition(pView, pInput, pRowIndex);
		}
		return tmpValue;
	}

	/**
	 * The creation-time position lookups still waiting for an answer, by GUIDSample.
	 * @return {Map<string, Promise<void>>}
	 */
	_creationPositionLookups()
	{
		if (!this._pendingCreationPositions)
		{
			/** @type {Map<string, Promise<void>>} */
			this._pendingCreationPositions = new Map();
		}
		return this._pendingCreationPositions;
	}

	/**
	 * Ask the GeoProvider (the iPad's native location, else the browser's, which may prompt) where the
	 * device is, and stamp the answer on the sample just created. Only an interactive form asks, and only
	 * for a sample with no server row and no coordinates of its own. A refusal, an error or no answer
	 * leaves the coordinates unset (0 on the server). The device answers offline too, so an iPad saving
	 * offline keeps the position in the document until it syncs.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_captureCreationPosition(pView, pInput, pRowIndex)
	{
		const tmpGeoProvider = this.pict.providers?.GeoProvider;
		if (!this.pict.AppData?.Interactive || !tmpGeoProvider || typeof tmpGeoProvider.getGeoCoords !== 'function')
		{
			return;
		}
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
		if (!needsCapturePosition(tmpRecord))
		{
			return;
		}
		const tmpGUIDSample = tmpRecord.GUIDSample;
		const tmpLookups = this._creationPositionLookups();
		/** @type {Promise<void>} */
		const tmpLookup = Promise.resolve()
			.then(() => tmpGeoProvider.getGeoCoords())
			.catch((pError) =>
			{
				this.pict.log.info(`No device position for new sample ${tmpGUIDSample}: ${pError?.message || pError}`);
				return null;
			})
			.then((pPosition) =>
			{
				// A save closes the lookup: a late answer must not change a sample that was already saved.
				if (tmpLookups.get(tmpGUIDSample) !== tmpLookup)
				{
					return;
				}
				tmpLookups.delete(tmpGUIDSample);
				this._stampCapturePosition(pView, tmpRecordAddress, tmpGUIDSample, pPosition);
			});
		tmpLookups.set(tmpGUIDSample, tmpLookup);
	}

	/**
	 * Put the device position on the held sample, if it is still the sample the lookup was for and it has
	 * not gained a server row or coordinates in the meantime.
	 * @param {Object} pView @param {string} pRecordAddress @param {string} pGUIDSample @param {any} pPosition
	 */
	_stampCapturePosition(pView, pRecordAddress, pGUIDSample, pPosition)
	{
		const tmpPosition = readCapturePosition(pPosition);
		if (!tmpPosition)
		{
			return;
		}
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), pRecordAddress);
		if (!needsCapturePosition(tmpRecord) || tmpRecord.GUIDSample !== pGUIDSample)
		{
			return;
		}
		tmpRecord.CaptureLatitude = tmpPosition.CaptureLatitude;
		tmpRecord.CaptureLongitude = tmpPosition.CaptureLongitude;
	}

	/**
	 * Let the creation-time position lookups land before the save projects the sample, waiting at most
	 * `CreationPositionSaveWaitMS`, then close them so nothing a later answer brings reaches a later save.
	 * @return {Promise<void>}
	 */
	_settleCreationPositions()
	{
		const tmpLookups = this._creationPositionLookups();
		if (tmpLookups.size < 1)
		{
			return Promise.resolve();
		}
		const tmpWaitMS = Number(this.options?.CreationPositionSaveWaitMS);
		/** @type {ReturnType<typeof setTimeout>|null} */
		let tmpTimer = null;
		const tmpTimeout = new Promise((fResolve) =>
		{
			tmpTimer = setTimeout(fResolve, Number.isFinite(tmpWaitMS) ? tmpWaitMS : _DEFAULT_CONFIGURATION.CreationPositionSaveWaitMS);
		});
		return Promise.race([ Promise.all(Array.from(tmpLookups.values())), tmpTimeout ]).then(() =>
		{
			clearTimeout(tmpTimer);
			tmpLookups.clear();
		});
	}

	/**
	 * Init: default the QRCode EntityTag, wire the external Sample Search Panel, and mint/bind the
	 * family tracking GUID — the sample OWNS the tracking identity the sibling selectors bind from.
	 * Ported 1:1; the search-panel selection lands through the broker value-commit primitive instead
	 * of the legacy select2 DOM pokes.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		this._applyDisabledOnceSaved(pInput, pValue);
		this._applySampleLock(pInput, pValue);
		this._wireSampleSearchPanel(pView, pInput, null);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
		}
		else if (!this._getTrackingGUID(pInput))
		{
			const tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = tmpTrackingGUID;
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._paintSampleLock(pInput);
		return tmpResult;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		this._applyDisabledOnceSaved(pInput, pValue);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Wire the external Sample Search Panel to THIS picker: a panel selection stashes the record and
	 * lands it through the value-commit primitive. The panel's row is a fresh server read, so it is
	 * reconciled with the held record like an open refresh (a re-pick of the held sample keeps an
	 * unsaved edit to it) and pre-written to `__Record`, and the value is marked read so the fenced
	 * refresh short-circuits on it (no re-fetch); committing the GUID then runs the cascade + widget
	 * repaint on the standard path. (The legacy FIXME about the last-initialized selector winning still
	 * applies — one panel callback slot.)
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 */
	_wireSampleSearchPanel(pView, pInput, pRowIndex)
	{
		const tmpPanel = this.pict.views.HeadlightPaneSamples;
		if (!tmpPanel || typeof tmpPanel.setSampleSelectionCallback !== 'function')
		{
			return;
		}
		tmpPanel.setSampleSelectionCallback((pSample) =>
		{
			if (pInput.PictForm && pInput.PictForm.Disabled)
			{
				this.pict.log.info(`Sample search panel pick ignored: input ${pInput.Macro.RawHTMLID} is disabled.`);
				return;
			}
			this.pict.log.info(`Sample selected from the search panel: ${pSample?.GUIDSample} -> input ${pInput.Macro.RawHTMLID}`);
			this.pict.AppData.SelectedSample = pSample;
			const tmpIdentity = this._getRecordIdentity(pInput);
			const tmpValue = pSample[tmpIdentity];
			const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress,
				this._reconcileRefreshedRecord(pView, pInput, tmpHeld, pSample, tmpIdentity, tmpValue, pRowIndex));
			this._openRefreshes().add(this._openRefreshKey(pInput, tmpValue, pRowIndex));
			this._setValueAndCommit(pView, pInput, tmpValue, pRowIndex);
		});
	}

	/**
	 * Opt-in via PictForm.DisabledOnceSaved: disable this selector once it has a value AND the document has
	 * been persisted, so a saved selection can't be swapped; a brand-new (unsaved) form stays editable. Sets
	 * PictForm.Disabled before the picker mounts. Ported 1:1 from `MaterialsSampleSelector._applyDisabledOnceSaved`.
	 * @param {Record<string, any>} pInput @param {any} pValue - the selected sample's GUID, when one exists.
	 */
	_applyDisabledOnceSaved(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || !pInput.PictForm.DisabledOnceSaved)
		{
			return;
		}
		const tmpDocumentSaved = this.pict?.AppData?.DocumentData?.ReportData?.IDDocument > 0;
		if (pValue && tmpDocumentSaved)
		{
			pInput.PictForm.Disabled = true;
		}
	}

	/**
	 * The lock entries, keyed by document + input, so a second document opened in the same app starts locked again.
	 * @return {Map<string, { Locked: boolean, Input: Record<string, any> }>}
	 */
	_sampleLocks()
	{
		if (!this._sampleLockEntries)
		{
			this._sampleLockEntries = new Map();
		}
		return this._sampleLockEntries;
	}

	/** @param {string} pRawHTMLID @return {string} */
	_sampleLockKey(pRawHTMLID)
	{
		return `${this.pict?.AppData?.DocumentData?.ReportData?.GUIDDocument || ''}::${pRawHTMLID}`;
	}

	/**
	 * A visible Sample selector opens locked when it already holds a sample, so a stray click can't swap the
	 * sample and re-fill the fields that follow it; the lock button unlocks it for this session. An empty field
	 * opens unlocked. A field the manifest (or DisabledOnceSaved) already disables gets no lock, and
	 * `PictForm.LockUntilUnlocked: false` turns the lock off. Decided once per document, so a re-render keeps
	 * the user's choice.
	 * @param {Record<string, any>} pInput @param {any} pValue - the selected sample's GUID, when one exists.
	 */
	_applySampleLock(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || !pInput.Macro || pInput.PictForm.InputType !== 'MaterialsSampleSelector' || pInput.PictForm.LockUntilUnlocked === false)
		{
			return;
		}
		const tmpKey = this._sampleLockKey(pInput.Macro.RawHTMLID);
		let tmpEntry = this._sampleLocks().get(tmpKey);
		if (!tmpEntry)
		{
			if (pInput.PictForm.Disabled)
			{
				return;
			}
			tmpEntry = { Locked: !!pValue, Input: pInput };
			this._sampleLocks().set(tmpKey, tmpEntry);
		}
		tmpEntry.Input = pInput;
		if (tmpEntry.Locked)
		{
			pInput.PictForm.Disabled = true;
		}
	}

	/**
	 * Flip a Sample selector between locked and unlocked (the lock button's click handler).
	 * @param {string} pRawHTMLID
	 * @return {boolean} whether the field is now locked.
	 */
	toggleSampleLock(pRawHTMLID)
	{
		const tmpEntry = this._sampleLocks().get(this._sampleLockKey(pRawHTMLID));
		if (!tmpEntry)
		{
			return false;
		}
		tmpEntry.Locked = !tmpEntry.Locked;
		if (tmpEntry.Locked)
		{
			tmpEntry.Input.PictForm.Disabled = true;
		}
		else
		{
			delete tmpEntry.Input.PictForm.Disabled;
		}
		// The host id helper lives on the (untyped-to-tsc) pict-section-picker base.
		this._reflectDisabledState(tmpEntry.Input, /** @type {any} */ (this).getPickerHostID(pRawHTMLID));
		libFilterToggleUI.syncToggleDisabledState(this.pict, this.getSelectFilterToggleID(pRawHTMLID), libFilterToggleUI.isInputDisabled(tmpEntry.Input));
		this._paintSampleLock(tmpEntry.Input);
		return tmpEntry.Locked;
	}

	/**
	 * Paint the lock button and the Sample Search Panel button from the lock state. The button stays hidden on a
	 * field without a lock.
	 * @param {Record<string, any>} pInput
	 */
	_paintSampleLock(pInput)
	{
		const tmpRawHTMLID = pInput?.Macro?.RawHTMLID;
		const tmpEntry = tmpRawHTMLID ? this._sampleLocks().get(this._sampleLockKey(tmpRawHTMLID)) : null;
		if (!tmpEntry)
		{
			return;
		}
		const tmpControl = this._firstElement(`#SAMPLE-LOCK-CONTROL-${tmpRawHTMLID}`);
		const tmpButton = this._firstElement(`#SAMPLE-LOCK-${tmpRawHTMLID}`);
		const tmpPanelButton = this._firstElement(`#SAMPLE-PANEL-BUTTON-${tmpRawHTMLID}`);
		if (tmpControl && tmpControl.classList)
		{
			tmpControl.classList.remove('is-hidden');
		}
		if (tmpButton)
		{
			const tmpTitle = tmpEntry.Locked ? 'Locked so a stray click can\'t change the sample. Click to unlock.' : 'Click to lock the sample.';
			tmpButton.setAttribute('title', tmpTitle);
			tmpButton.setAttribute('aria-label', tmpTitle);
			tmpButton.setAttribute('aria-pressed', tmpEntry.Locked ? 'true' : 'false');
			const tmpIcon = tmpButton.querySelector ? tmpButton.querySelector('i') : null;
			if (tmpIcon)
			{
				tmpIcon.className = tmpEntry.Locked ? 'fas fa-lock' : 'fas fa-lock-open';
			}
		}
		if (tmpPanelButton)
		{
			tmpPanelButton.disabled = !!pInput.PictForm.Disabled;
		}
	}

	/**
	 * Save-lifecycle hook: let a new sample's device position land, then stamp naming + numbering (Name,
	 * LabControlNumber, Sequenced) on the Sample record, all BEFORE the base projects it into _EntityData
	 * (super), so the projected copy carries them. Delegates the naming to SampleSequencing; idempotent and
	 * fail-safe.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		this._settleCreationPositions().then(() =>
		{
			const tmpProvider = this.pict.providers?.SampleSequencing;
			if (!tmpProvider || typeof tmpProvider.applyBeforeSave !== 'function')
			{
				return super.onBeforeSaveDataAsync(fCallback);
			}
			tmpProvider.applyBeforeSave().then(() => super.onBeforeSaveDataAsync(fCallback)).catch((pError) =>
			{
				this.pict.log.error(`SampleSequencing stamp failed before save (continuing): ${pError?.message || pError}`);
				super.onBeforeSaveDataAsync(fCallback);
			});
		});
	}

	/**
	 * The Sample cascade — the port of the legacy `_onRecordRefresh`, fired from the seam after
	 * `__Record` lands (select, create, seed and clear paths):
	 *   1. synthesize/maintain the sibling DocumentPolyJoin (document linkage; template-minted GUID,
	 *      saved-vs-unsaved document key, IDRemote or the GUIDSample+_Dest_GUIDSample redirect);
	 *   2. repaint dependents in-section (marshalToView);
	 *   3. super — the family event bus (SampleChanged:<trackingGUID>:<address> + trigger group);
	 *   4. refresh the spec-year scope from the sample's project (resolver dedupes, fail-open);
	 *   5. live-refresh the auto-generated Sample Name (never clobbers a manual edit);
	 *   6. re-apply the form's data requirements for the new sample.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpSampleAddress = this._getRecordAddress(pInput, pRowIndex);
		/** @type {Record<string, any>|null} */
		let tmpSample = (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord)) ? pRecord : null;
		if (!tmpSample)
		{
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		if (tmpSample && typeof tmpSample === 'object' && Object.keys(tmpSample).length === 0)
		{
			// The seam hands a cleared picker `{}`; the legacy refresh handed a falsy record. Normalize so
			// the DocumentPolyJoin branch below sees "no sample", exactly like the legacy did.
			tmpSample = null;
		}
		const tmpSampleDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress);
		if (ScopedEntityData.referencesSample(tmpSample))
		{
			// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
			if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
			{
				tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
					{
						GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
						RemoteType: 'Sample',
						IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
						GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
						IDRemote: tmpSample.IDSample,
					}));
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
				{
					this._translateRecordTemplateFields(tmpDocumentPolyJoin);
				}
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			const tmpDocument = this.pict.AppData.DocumentData.ReportData;
			if (tmpDocument)
			{
				if (tmpDocument.IDDocument > 0)
				{
					tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
					delete tmpDocumentPolyJoin.GUIDDocument;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
					delete tmpDocumentPolyJoin.IDDocument;
				}
			}
			if (!tmpDocumentPolyJoin.IDRemote)
			{
				if (tmpSample.IDSample)
				{
					tmpDocumentPolyJoin.IDRemote = tmpSample.IDSample;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDSample = tmpSample.GUIDSample;
					tmpDocumentPolyJoin._Dest_GUIDSample = 'IDRemote';
					delete tmpDocumentPolyJoin.IDRemote;
				}
			}
		}
		else if (tmpDocumentPolyJoin && !tmpSample)
		{
			tmpDocumentPolyJoin = { };
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
		// Refresh spec-year scope from the sample's project. Resolver dedupes when the project hasn't
		// changed; fail-open paths inside the resolver handle bare contracts / empty stub sets / no
		// spec infra. Triggered here because providers don't receive the form's global event channel.
		this.pict.providers.SpecScopeResolver?.loadForSampleRecord?.(tmpSample);
		// Live-refresh the auto-generated Sample Name from the current source fields — only while the
		// user hasn't edited the (now editable) Name field, so a manual edit is never clobbered.
		if (this.pict.providers.SampleSequencing?.refreshSampleName?.())
		{
			if (typeof pView.marshalToView === 'function')
			{
				pView.marshalToView();
			}
		}
		this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, pRecord).catch((pError) =>
		{
			this.pict.log.error(`Error applying data requirements after sample refresh: ${pError.message || pError}`);
		});
	}

	/**
	 * Family + save-sweep events — ported 1:1 from the legacy `_handleEvent`:
	 *   - ProjectEntityDataRecords: project the sample + its DocumentPolyJoin into the sweep target
	 *     (the base sweep handler re-runs idempotently through super — same target, same GUID keys);
	 *   - targeted (tracking-GUID-matched): SampleStatusChanged stamps the status onto the record;
	 *     PushRecord copies the record to the requested address.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpSampleAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}

			return;
		}
		// global events above here; below are targetted events
		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (tmpEventType === 'SampleStatusChanged')
		{
			const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
			tmpRecord.Status = tmpEventPayload;
			return;
		}

		if (tmpEventType === 'PushRecord')
		{
			const tmpSampleAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
			this.pict.manifest.setValueAtAddress(this.pict, tmpEventPayload, tmpSampleRecord);
		}
	}
}

module.exports = PictProviderInputTypeMaterialsSamplePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86,"./_FilterToggleUI.js":158,"./_ScopedEntityData.js":162}],99:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerDisplayProvider = require('./PictProvider-InputType-PickerDisplay.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsSamplePickerDisplay',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The Sample Read/Print display (beast B5): PickerDisplay plus the one bespoke behavior the legacy
 * MaterialsSampleDisplay carried — a QR-CODE IMAGE prepended beside the display node (the printed form's
 * scannable sample link). Value resolution itself is the base's: `__Record`-first (a created-but-unsaved
 * sample exists ONLY there), then the GUID identity fetch, with the `[QRCode] Name` compound the shared
 * map configures.
 */
class PictProviderInputTypeMaterialsSamplePickerDisplay extends PickerDisplayProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/** Paint the display, then prepend the QR image for the resolved sample (non-tabular; once —
	 *  the legacy `appliedQRCodeAlready` latch). */
	async _paint(pView, pInput, pValue, pRowIndex)
	{
		const tmpPainted = await super._paint(pView, pInput, pValue, pRowIndex);
		if (tmpPainted && pValue && pRowIndex == null)
		{
			this._prependQRCodeImage(pView, pInput, pValue);
		}
		return tmpPainted;
	}

	/**
	 * The legacy buildPrependedQRCodeImage, ported: render the sample's QR code as a small figure before
	 * the display node's host column (Read + Print). The sample record comes from the local `__Record`
	 * snapshot — the same source the paint just resolved from; no snapshot (or no QR code) → no image.
	 * @param {object} pView @param {object} pInput @param {any} pValue
	 */
	_prependQRCodeImage(pView, pInput, pValue)
	{
		if (this.appliedQRCodeAlready || !this.pict.providers.QRCodeProvider)
		{
			return;
		}
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpIdentity = this._identityField(tmpPictForm);
		const tmpSample = this._localEntityRecords(pView, pInput, null).find((pRecord) => pRecord[tmpIdentity] == pValue);
		if (!tmpSample || !tmpSample.QRCode)
		{
			return;
		}
		const tmpElements = this.pict.ContentAssignment.getElement(this.getDisplayNodeID(pInput.Macro.RawHTMLID));
		if (!tmpElements || tmpElements.length < 1 || typeof tmpElements[0].closest !== 'function')
		{
			return;
		}
		const tmpParentElement = tmpElements[0].closest('.column');
		if (tmpParentElement)
		{
			const tmpFigure = document.createElement('figure');
			tmpFigure.className = 'image mr-2 is-64x64';
			const tmpImage = document.createElement('img');
			tmpImage.src = this.pict.providers.QRCodeProvider.create(tmpSample.QRCode);
			tmpImage.alt = 'QR Code';
			tmpFigure.append(tmpImage);
			tmpParentElement.prepend(tmpFigure);
			tmpParentElement.classList.add('is-flex');
			tmpParentElement.classList.add('is-align-items-center');
			this.appliedQRCodeAlready = true;
		}
	}
}

module.exports = PictProviderInputTypeMaterialsSamplePickerDisplay;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-PickerDisplay.js":118}],100:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

class MaterialsSampleInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Sample'; //TODO: use default options for this?
		pOptions.AllowEntityCreation = true; // can turn off via PictForm option of same name
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'GUIDSample';
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			//FIXME: need to get some kind of record uniqueness injected here
			tmpRecord = { GUIDSample: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		if (this.pict.AppData.DocumentData?.ReportData?.IDProject > 0)
		{
			tmpRecord.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		}
		tmpRecord.CreatingIDUser = this.pict.AppData.CurrentUser?.UserID;
		tmpRecord.DesignatedTime = new Date().toISOString();
		tmpRecord.QRCode = this.pict.providers.QRCodeProvider.generateNewQRCode(tmpRecord);
		return tmpRecord;
	}

	/**
	 * Opt-in via PictForm.DisabledOnceSaved: disable this selector once it has a value AND the document
	 * has been persisted, so a saved selection can't be swapped. A brand-new (unsaved) form stays editable.
	 * Sets PictForm.Disabled, which the template honors for both the <select> and the advanced
	 * Sample-Search-Panel button. Distinct from the document-level lock (ReportData.Locked), which freezes
	 * the whole form via the Read theme. A selector that is never editable sets PictForm.Disabled directly.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value (the selected sample's GUID, when one exists).
	 */
	_applyDisabledOnceSaved(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || !pInput.PictForm.DisabledOnceSaved)
		{
			return;
		}
		const tmpDocumentSaved = this.pict?.AppData?.DocumentData?.ReportData?.IDDocument > 0;
		if (pValue && tmpDocumentSaved)
		{
			pInput.PictForm.Disabled = true;
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		// Opt-in via PictForm.DisabledOnceSaved: a saved sample can't be swapped, a blank new form can.
		this._applyDisabledOnceSaved(pInput, pValue);
		//FIXME: this seems to assume there will only be a single sample selector on the page at a time................
		//       this should be wired up only when the user clicks the button to open the panel.
		// set the Sample selection callback for the Sample Search Panel
		this.pict.views.HeadlightPaneSamples.setSampleSelectionCallback((pSample) =>
		{
			this.pict.log.info('Sample selected:', pSample.GUIDSample);
			this.pict.log.info('Assigning Sample to the following input element:', pInput.Macro.RawHTMLID);
			this.pict.AppData.SelectedSample = pSample;
			document.getElementById(pInput.Macro.RawHTMLID)['value'] = pSample.GUIDSample;
			document.getElementById(pInput.Macro.RawHTMLID).dispatchEvent(new Event('change'));
			//FIXME: consolidate this with the base class..........
			// update the select2 element to show the selected sample
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			const tmpOption = document.createElement('option');
			tmpOption.value = pSample[this._getRecordIdentity(pInput)];
			tmpOption.text = this._formatRecordForDisplay(pSample, pInput);
			tmpOption.selected = true;
			// remove any existing options
			while (tmpSelectElement.firstChild)
			{
				tmpSelectElement.removeChild(tmpSelectElement.firstChild);
			}
			tmpSelectElement.appendChild(tmpOption);
			// trigger change to update select2
			$(tmpSelectElement).trigger('change');
		});
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = tmpTrackingGUID;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'QRCode';
		}
		// Honor PictForm.DisabledOnceSaved for tabular sample selectors too (see onInputInitialize).
		this._applyDisabledOnceSaved(pInput, pValue);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex);
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
			pInput.PictForm.SampleTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Save-lifecycle hook: stamp naming + numbering (Name, LabControlNumber, Sequenced) on the
	 * Sample record BEFORE the base class projects it into _EntityData (super), so the projected
	 * copy carries the stamped values. Delegates to the SampleSequencing provider; idempotent and
	 * fail-safe, so a stamp failure never blocks the save.
	 *
	 * @param {(pError?: Error) => void} fCallback
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpProvider = this.pict.providers?.SampleSequencing;
		if (!tmpProvider || typeof tmpProvider.applyBeforeSave !== 'function')
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}
		tmpProvider.applyBeforeSave().then(() => super.onBeforeSaveDataAsync(fCallback)).catch((pError) =>
		{
			this.pict.log.error(`SampleSequencing stamp failed before save (continuing): ${pError?.message || pError}`);
			super.onBeforeSaveDataAsync(fCallback);
		});
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpSampleAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		let tmpSample = pRecord;
		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		if (tmpSample && typeof tmpSample === 'object' && Object.keys(tmpSample).length === 0)
		{
			tmpSample = null;
		}
		const tmpSampleDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress);
		if (ScopedEntityData.referencesSample(tmpSample))
		{
			// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
			if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
			{
				tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
					{
						GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-S_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
						RemoteType: 'Sample',
						IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
						GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
						IDRemote: tmpSample.IDSample,
					}));
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
				{
					this._translateRecordTemplateFields(tmpDocumentPolyJoin);
				}
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			const tmpDocument = this.pict.AppData.DocumentData.ReportData;
			if (tmpDocument)
			{
				if (tmpDocument.IDDocument > 0)
				{
					tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
					delete tmpDocumentPolyJoin.GUIDDocument;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
					delete tmpDocumentPolyJoin.IDDocument;
				}
			}
			if (!tmpDocumentPolyJoin.IDRemote)
			{
				if (tmpSample.IDSample)
				{
					tmpDocumentPolyJoin.IDRemote = tmpSample.IDSample;
				}
				else
				{
					tmpDocumentPolyJoin.GUIDSample = tmpSample.GUIDSample;
					tmpDocumentPolyJoin._Dest_GUIDSample = 'IDRemote';
					delete tmpDocumentPolyJoin.IDRemote;
				}
			}
		}
		else if (tmpDocumentPolyJoin && !tmpSample)
		{
			tmpDocumentPolyJoin = { };
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		//TOOD: is this a good idea? this ensures any fields that use this record are updated immediately, if they are in the same section
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
		// Refresh spec-year scope from the sample's project. Resolver dedupes
		// when the project hasn't changed; fail-open paths inside the resolver
		// handle bare contracts / empty stub sets / no spec infra. Triggered
		// here (rather than via PictFormMetacontroller's global event channel,
		// which only routes to views) because providers don't receive those
		// events. See ~/dev/material_selectors_spec_year_audit.md §10.7 for
		// the wiring rationale.
		this.pict.providers.SpecScopeResolver?.loadForSampleRecord?.(tmpSample);
		// Live-refresh the auto-generated Sample Name from the current source fields (project / material /
		// date). Guarded so it only regenerates while the user hasn't edited the (now editable) Name field —
		// so it shows and tracks the fields early, yet a manual edit is never clobbered. Same bridge rationale
		// as SpecScopeResolver above: providers don't receive the form's global events.
		if (this.pict.providers.SampleSequencing?.refreshSampleName?.())
		{
			pView.marshalToView();
		}
		this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, pRecord).catch((pError) =>
		{
			this.pict.log.error(`Error applying data requirements after sample refresh: ${pError.message || pError}`);
		});
	}


	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpSampleAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpSampleAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}

			return;
		}
		// global events above here; below are targetted events
		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		if (tmpEventType === 'SampleStatusChanged')
		{
			const tmpRecordAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
			tmpRecord.Status = tmpEventPayload;
			return;
		}

		if (tmpEventType === 'PushRecord')
		{
			const tmpSampleAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
			this.pict.manifest.setValueAtAddress(this.pict, tmpEventPayload, tmpSampleRecord);
		}
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		let tmpName = pRecord.Name;
		if (!pRecord.Name)
		{
			if (!pRecord.LabControlNumber)
			{
				// A synthesized (not-yet-saved) sample has no IDSample; show "New Sample" rather than "#??".
				tmpName = pRecord.IDSample ? `Unnamed Sample #${pRecord.IDSample}` : 'New Sample';
			}
			else
			{
				tmpName = `LCN: ${pRecord.LabControlNumber}`;
			}
		}
		return tmpName;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'QRCode', 'Name' ];
	}
}

module.exports = MaterialsSampleInputType;
// Opt into the app save-data lifecycle so onBeforeSaveDataAsync (the SampleSequencing stamp, run
// before the _EntityData projection sweep) actually fires. NOT a framework default — sibling
// selectors that project records on save (Test, SampleTestResult) set this too.
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89,"./_ScopedEntityData.js":162}],101:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorTestDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}


	// NOTE: This all is duplicated from the base EntityDisplay class becuase we need to be able to pass IdentityField as 'Hash' for Tests, should refactor later

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders the static `...TABULAR-DATA-...` div, not a `...DROPDOWN-...` select2 node.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), pValue,
			{
				IdentityField: 'Hash',
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let tmpDisplayTemplate = '';
				if (tmpInputSelectElement.tagName === 'DIV')
				{
					tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
						tmpEntity[pInput.PictForm.EntityTag] || 'N/A',
						tmpDisplayName || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]),
						false,
						tmpEntity.EntityTagLast,
					);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
			}
			else
			{
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayName);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = MaterialsSelectorTestDisplayInputHandler;

},{"./PictProvider-InputType-MaterialsEntityDisplay.js":87}],102:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

class MaterialsTestInjectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord()
	{
		const tmpPayloadUUID = this.pict.getUUID();
		//FIXME: I think this event is busted - it works but not in a good way
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${tmpPayloadUUID}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: this is terrible
			const tmpSampleAddress = 'SampleID__Record';
			const tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			tmpSample = this.pict.manifest.getValueAtAddress(tmpViewMarshalDestinationObject, tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * @param {string} pTestHash - The test hash to register.
	 * @param {string} pSaltHash - The salt hash to register.
	 * @param {(pError?: Error) => void} [fCallback] - Optional callback function to be called after registration.
	 */
	registerTest(pTestHash, pSaltHash, fCallback)
	{
		if (!pTestHash)
		{
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		if (!this.pict.providers.DocumentDynamicSectionManager)
		{
			this.pict.log.error(`MaterialsTestInjectorInputType: DocumentDynamicSectionManager provider not available; cannot register test`, { pTestHash });
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		this.pict.providers.DocumentDynamicSectionManager.registerTest(pTestHash, pSaltHash, (pViews) =>
		{
			if (Array.isArray(pViews) && pViews.length > 0)
			{
				const tmpSample = this._getBoundSampleRecord();
				if (!tmpSample)
				{
					this.pict.log.warn(`Unable to look up sample record after test injection; skipping data requirement update`, { pTestHash });
					this.pict.PictApplication.solve();
					return;
				}
				this.pict.providers.DataRequirementsProvider.updateDataRequirementsForManifest(this.pict.views.PictFormMetacontroller.manifestDescription, () =>
				{
					this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, tmpSample).catch((pError) =>
					{
						this.pict.log.error(`Error applying data requirements after test injection: ${pError.message || pError}`);
					}).finally(() =>
					{
						this.pict.PictApplication.solve(); //FIXME: this may be a second solve, depending on the data requirements outcome
						if (typeof fCallback === 'function')
						{
							fCallback();
						}
					});
				}, [ pTestHash ]);
			}
		});
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'Hash';
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// kinda weird; we don't want to load the test record from the parent class, but we want most of the other parent behaviors
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// kinda weird; we don't want to load the test record from the parent class, but we want most of the other parent behaviors
		return true;
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		if (!pRecord.Name)
		{
			if (pRecord.Description)
			{
				return pRecord.Description;
			}
			if (pRecord.Hash)
			{
				return `Test Code ${pRecord.Hash}`;
			}
			return `Unnamed Test #${pRecord.IDTest ?? '??'}`;
		}
		return pRecord.Name;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Hash', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			//FIXME: care about wrapping sort instructions...
			if (pFilters.length > 0)
			{
				pFilters.unshift('FOP~0~(~0');
				pFilters.push('FCP~0~)~0');
			}
			pFilters.push('FBV~Active~EQ~1');
			pFilters.push('FBV~Injectable~EQ~1');
			return pFilters;
		};
	}
}

module.exports = MaterialsTestInjectorInputType;

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89}],103:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsTestInjectorPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'Test',
};

/**
 * The Test injector picker (beast B5): the Picker-stack port of MaterialsTestInjector, mirroring the
 * legacy provider 1:1 on the MaterialsCascadePicker base. A narrow selector: the user picks an ACTIVE,
 * INJECTABLE test (committed by Hash) and clicks the template's "Add Test" addon button, which calls
 * `registerTest` — DocumentDynamicSectionManager injects the test's form sections, then the data
 * requirements re-apply for the bound sample. The picked value is a section recipe, NOT form data:
 * `_refreshEntityRecord` is OPTED OUT (no `__Record` snapshot, no cascade — the legacy onDataChange
 * suppressed the record load the same way).
 */
class PictProviderInputTypeMaterialsTestInjectorPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any, PictApplication: any }} */
		this.pict;
	}

	/** An injectable Test commits by HASH — the section-registration key (legacy _getDefaultRecordIdentity).
	 *  @param {Record<string, any>} pInput @return {string} */
	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || 'Hash';
	}

	/**
	 * Mandatory injector scoping, ported from the legacy HandleSearchFilters: only Active, INJECTABLE
	 * tests are offered. Contextual filters paren-wrapped so the appended clauses AND the whole set.
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}}
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		const tmpFilters = tmpSplit.Filters;
		if (tmpFilters.length > 0)
		{
			tmpFilters.unshift('FOP~0~(~0');
			tmpFilters.push('FCP~0~)~0');
		}
		tmpFilters.push('FBV~Active~EQ~1');
		tmpFilters.push('FBV~Injectable~EQ~1');
		return tmpSplit;
	}

	/** Init: default the Hash EntityTag (ported 1:1). */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of the init. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * THE `__Record` OPT-OUT: the injector's value is a section recipe, not form data — the legacy
	 * onDataChange deliberately skipped the record load ("we don't want to load the test record"), so
	 * the broker's snapshot + cascade machinery is suppressed wholesale here.
	 */
	// eslint-disable-next-line no-unused-vars
	_refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		return;
	}

	/**
	 * The bound Sample record — ported VERBATIM, both legacy FIXMEs intact: the PushRecord tracking slot
	 * carries a fresh UUID no sample will ever match (busted-but-works), so resolution effectively rides
	 * the conventional-address fallback.
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord()
	{
		const tmpPayloadUUID = this.pict.getUUID();
		//FIXME: I think this event is busted - it works but not in a good way
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${tmpPayloadUUID}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: this is terrible
			const tmpSampleAddress = 'SampleID__Record';
			const tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
			tmpSample = this.pict.manifest.getValueAtAddress(tmpViewMarshalDestinationObject, tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * Inject the picked test's sections — the template's "Add Test" button target, ported 1:1:
	 * DocumentDynamicSectionManager registers the test (salted, so the same test can inject twice),
	 * then the data requirements recompute + re-apply for the bound sample, then the app re-solves.
	 * @param {string} pTestHash - The test hash to register.
	 * @param {string} pSaltHash - The salt hash to register.
	 * @param {(pError?: Error) => void} [fCallback] - Optional callback function to be called after registration.
	 */
	registerTest(pTestHash, pSaltHash, fCallback)
	{
		if (!pTestHash)
		{
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		if (!this.pict.providers.DocumentDynamicSectionManager)
		{
			this.pict.log.error(`MaterialsTestInjectorPicker: DocumentDynamicSectionManager provider not available; cannot register test`, { pTestHash });
			if (typeof fCallback === 'function')
			{
				fCallback();
			}
			return;
		}
		this.pict.providers.DocumentDynamicSectionManager.registerTest(pTestHash, pSaltHash, (pViews) =>
		{
			if (Array.isArray(pViews) && pViews.length > 0)
			{
				const tmpSample = this._getBoundSampleRecord();
				if (!tmpSample)
				{
					this.pict.log.warn(`Unable to look up sample record after test injection; skipping data requirement update`, { pTestHash });
					this.pict.PictApplication.solve();
					return;
				}
				this.pict.providers.DataRequirementsProvider.updateDataRequirementsForManifest(this.pict.views.PictFormMetacontroller.manifestDescription, () =>
				{
					this.pict.providers.DataRequirementsProvider.applyDataRequirements(this.pict.views.PictFormMetacontroller.manifestDescription, tmpSample).catch((pError) =>
					{
						this.pict.log.error(`Error applying data requirements after test injection: ${pError.message || pError}`);
					}).finally(() =>
					{
						this.pict.PictApplication.solve(); //FIXME: this may be a second solve, depending on the data requirements outcome
						if (typeof fCallback === 'function')
						{
							fCallback();
						}
					});
				}, [ pTestHash ]);
			}
		});
	}
}

module.exports = PictProviderInputTypeMaterialsTestInjectorPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86}],104:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const libLabRouting = require('./_LabRouting.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsTestLabPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	Entity: 'Lab',
};

/**
 * The per-test Lab picker (beast B4): the Picker-stack port of MaterialsTestLabSelector, mirroring the
 * legacy provider 1:1 on the MaterialsCascadePicker base.
 *
 * SIBLING of MaterialsLabPicker (NOT a subclass): both are thin layers with Entity:'Lab', but the BIND
 * TARGET differs — MaterialsLabPicker binds the sample's labs (SampleLabJoin); this one binds a single
 * TEST's lab (the row's TestInstance from the Test selector's triple). On a lab pick it DUAL-WRITES the
 * test's lab — `TestInstance.IDLab` (direct FK) and a `TestInstanceLabJoin` — and asks the sample's lab
 * selector to reconcile with the per-test labs (`SampleLabSync`, see _LabRouting). Single-select (one lab
 * per test).
 */
class PictProviderInputTypeMaterialsTestLabPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/** Labs are customer-scoped (row-level auth), sorted by Name — same as the sample lab picker.
	 *  @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 *  @return {{Filters: Array<string>, BackOffFilters: Array<string>}} */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		tmpSplit.Filters.push('FSF~Name~ASC~0');
		return tmpSplit;
	}

	/** Init: legacy defaults (single-select, Name EntityTag). */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Tabular init + the persisted-lab seed: the column binds to the nested TestInstance.IDLab, which a
	 * tabular cell does NOT marshal into pValue on (re)open — so a persisted/adopted lab renders blank.
	 * PUSH it via the value-commit primitive — which writes the value AND drives the fetch + widget
	 * paint, exactly like a fresh pick. Ported 1:1.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (libLabRouting.isUnsetLabID(pValue) && pRowIndex != null)
		{
			const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
			if (tmpTestInstance && tmpTestInstance.IDLab)
			{
				this._setValueAndCommit(pView, pInput, tmpTestInstance.IDLab, pRowIndex);
			}
			else
			{
				this._autoFillTestLab(pView, pInput, pRowIndex);
			}
		}
		return tmpResult;
	}

	/**
	 * Fill a row with the resolver's auto-fill answer (see LabScopeResolver.getAutoFillLabID). Only ever runs
	 * on a row that has no lab, so a persisted or user-chosen value is never overwritten; commits through the
	 * same primitive a user pick uses, so the join dual-write and the sample-lab sync ride along unchanged.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string} pRowIndex
	 */
	_autoFillTestLab(pView, pInput, pRowIndex)
	{
		libLabRouting.autoFillTestLab(this.pict, pInput, pRowIndex, pView,
			() => this._getRowTestInstance(pView, pInput, pRowIndex)?.IDLab,
			(pIDLab) => this._setValueAndCommit(pView, pInput, pIDLab, pRowIndex));
	}

	/** One lab per test (single-select), tag on Name. @param {Record<string, any>} pInput */
	_applyTestLabDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = false;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
	}

	/**
	 * The TestLab cascade — the port of the legacy `_onRecordRefresh`: dual-write the test's lab
	 * (TestInstance.IDLab + a TestInstanceLabJoin), ask the sample's labs to reconcile with the per-test
	 * labs, then the in-section repaint + the family bus (super). The row record IS the test triple.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpLab = Array.isArray(pRecord) ? pRecord[0] : pRecord;
		const tmpIDLab = tmpLab && tmpLab.IDLab;
		const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
		if (tmpTestInstance && tmpIDLab)
		{
			tmpTestInstance.IDLab = tmpIDLab;
			this._ensureTestInstanceLabJoin(pView, pInput, pRowIndex, tmpTestInstance, tmpLab);
		}
		libLabRouting.requestSampleLabSync(this.pict);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * The TestInstance for this row. The Testing-G2 table binds to the Test selector's triple collection
	 * (`${TestAddress}_Instances`), so the row record is `{ TestInstance, TestInstanceSampleJoin, ... }`.
	 * Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @return {Record<string, any>|null}
	 */
	_getRowTestInstance(pView, pInput, pRowIndex)
	{
		const tmpRowAddress = this._getRecordAddress(pInput, pRowIndex);
		// the lab address sits inside the row record; walk up to the row triple and read its TestInstance
		const tmpTripleAddress = pInput.PictForm.TestInstanceTripleAddress || tmpRowAddress.replace(/\.[^.]+$/, '');
		const tmpTriple = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTripleAddress);
		if (tmpTriple && tmpTriple.TestInstance && typeof tmpTriple.TestInstance === 'object')
		{
			return tmpTriple.TestInstance;
		}
		// fallback: the row record itself is/holds the TestInstance
		return (tmpTriple && typeof tmpTriple === 'object' && !Array.isArray(tmpTriple)) ? tmpTriple : null;
	}

	/**
	 * Create (or retarget) the TestInstanceLabJoin for this test instance, stored on the row triple at
	 * `_TestInstanceLabJoin` so the projection can sweep it into _EntityData. Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Record<string, any>} pTestInstance @param {Record<string, any>} pLab
	 */
	_ensureTestInstanceLabJoin(pView, pInput, pRowIndex, pTestInstance, pLab)
	{
		// Compose the row-triple sibling address (…_Instances[row]._TestInstanceLabJoin) directly. The record
		// address is the lab's own (…row.TestInstance.IDLab__Record), so stripping one segment lands INSIDE the
		// TestInstance — which drags the join into the TestInstance insert and breaks it with malformed SQL.
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpExisting = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		const tmpJoin = (tmpExisting && typeof tmpExisting === 'object' && !Array.isArray(tmpExisting)) ? tmpExisting : { };
		tmpJoin.IDLab = pLab.IDLab;
		if (pTestInstance.IDTestInstance > 0)
		{
			tmpJoin.IDTestInstance = pTestInstance.IDTestInstance;
			delete tmpJoin.GUIDTestInstance;
		}
		else if (pTestInstance.GUIDTestInstance)
		{
			tmpJoin.GUIDTestInstance = pTestInstance.GUIDTestInstance;
			delete tmpJoin.IDTestInstance;
		}
		if (!tmpJoin.GUIDTestInstanceLabJoin)
		{
			const tmpDocumentGUID = this.pict.manifest.getValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.GUIDDocument') || '';
			// Keyed off the test instance rather than a fresh UUID. There is one join per instance, so the
			// key has to be re-derivable - a re-mint that cannot reproduce it inserts a duplicate row
			// instead of upserting the existing one.
			let tmpTestKey = `ID${pTestInstance.IDTestInstance}`;
			if (pTestInstance.GUIDTestInstance)
			{
				tmpTestKey = String(pTestInstance.GUIDTestInstance).replace(`${tmpDocumentGUID}-`, '');
			}
			tmpJoin.GUIDTestInstanceLabJoin = `${tmpDocumentGUID}-TILJ-${tmpTestKey}`;
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress, tmpJoin);
	}

	/**
	 * Per-row save-time projection hook, dispatched by the base _handleEvent on the sweep. A lab picker
	 * creates no Lab reference record, so the base's creation-gated `__Record` projection is replaced
	 * with projecting this row's TestInstanceLabJoin (rows with no lab picked staged no join, so the
	 * sync no-ops on them). Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string')
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
	}

	/**
	 * Save-time projection: sweep this row's TestInstanceLabJoin into _EntityData. (TestInstance.IDLab
	 * itself rides the Test selector's TestInstance projection — we only own the join here.) Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}
		// Same composed row-triple sibling address as _ensureTestInstanceLabJoin (see the note there).
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		if (tmpJoin && typeof tmpJoin === 'object' && !Array.isArray(tmpJoin) && tmpJoin.GUIDTestInstanceLabJoin)
		{
			if (!tmpEntityData.TestInstanceLabJoin || typeof tmpEntityData.TestInstanceLabJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceLabJoin))
			{
				tmpEntityData.TestInstanceLabJoin = { };
			}
			tmpEntityData.TestInstanceLabJoin[tmpJoin.GUIDTestInstanceLabJoin] = tmpJoin;
		}
	}
}

module.exports = PictProviderInputTypeMaterialsTestLabPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86,"./_LabRouting.js":159}],105:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const libLabRouting = require('./_LabRouting.js');

/**
 * MaterialsTestLabSelector — per-row lab selector for the Testing table.
 *
 * SIBLING of MaterialsLabSelector (NOT a subclass): both are thin layers over MaterialsEntitySelector with
 * Entity:'Lab', so the lab UI (select2 / list / display) is shared base behavior. The difference is the BIND
 * TARGET — MaterialsLabSelector binds the sample's labs (SampleLabJoin); this one binds a single TEST's lab
 * (the row's TestInstance), so it stays a sibling off the base to avoid the 3-level super-entanglement on
 * onInputInitialize.
 *
 * On a lab pick it DUAL-WRITES the test's lab — `TestInstance.IDLab` (direct FK on the row's TestInstance) and
 * a `TestInstanceLabJoin` (IDTestInstance→IDLab) — and asks the sample's lab selector to reconcile with the
 * per-test labs (`SampleLabSync`, see _LabRouting). Single-select (one lab per test). Tabular: the row record is the test triple from
 * the Test selector (`{TestInstance, TestInstanceSampleJoin, DocumentPolyJoin}`), TestInstance carrying IDLab.
 */
/**
 * Install the pin-to-top resolver for a lab selector's select2 options, when the descriptor scopes by
 * `LabScope` and the LabScopeResolver is registered. The resolver answers with its preference ranking
 * (`LabScopeResolver.getPreferredLabIDs`); nothing is hidden.
 *
 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
 * @param {Object} pInput @param {number} [pRowIndex] @param {Object} [pView]
 */
function applyLabPriorityIDs(pPict, pConfigOptions, pInput, pRowIndex, pView)
{
	const tmpEngine = pPict.providers.EntityFilterEngine;
	const tmpResolver = pPict.providers.LabScopeResolver;
	if (!tmpEngine || !tmpResolver || pConfigOptions.GetPriorityIDs)
	{
		return;
	}
	const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
	if (!Array.isArray(tmpFilters))
	{
		return;
	}
	const tmpFilter = tmpFilters.find((pEntry) => pEntry && pEntry.LabScope);
	if (!tmpFilter)
	{
		return;
	}
	const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
	pConfigOptions.GetPriorityIDs = () =>
	{
		return tmpResolver.getPreferredLabIDs(tmpFilter.LabScope,
			{
				IDTest: tmpEngine._readLabScopeTestID(tmpFilter, pInput, tmpRowIndex, pView || null),
				SelectedLabIDs: libLabRouting.collectSelectedTestLabIDs(pPict),
			});
	};
}

class MaterialsTestLabSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab';
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * @param {Object} pView @param {Object} pGroup @param {Object} pRow @param {Object} pInput
	 * @param {any} pValue @param {string} pHTMLSelector @param {string} pTransactionGUID @return {boolean}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pGroup @param {Object} pInput @param {any} pValue
	 * @param {string} pHTMLSelector @param {number} pRowIndex @param {string} pTransactionGUID @return {any}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyTestLabDefaults(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		// The col binds to the nested TestInstance.IDLab, which a tabular cell does NOT marshal into pValue on
		// (re)open — so a persisted/adopted lab renders blank. Passing the id to super only reaches the fetch; it is
		// never written to the cell's storage, so it's lost on re-marshal. PUSH it via setData — which writes the
		// value AND drives the fetch + select2 paint, exactly like a fresh pick.
		if (libLabRouting.isUnsetLabID(pValue) && pRowIndex != null)
		{
			const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
			if (tmpTestInstance && tmpTestInstance.IDLab)
			{
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpTestInstance.IDLab);
			}
			else
			{
				this._autoFillTestLab(pView, pInput, pRowIndex);
			}
		}
		return tmpResult;
	}

	/**
	 * Fill a row with the resolver's auto-fill answer (see LabScopeResolver.getAutoFillLabID). Only ever runs on a
	 * row that has no lab, so a persisted or user-chosen value is never overwritten; committed through the same
	 * setData path a user pick uses, so the join dual-write and the sample-lab sync ride along unchanged.
	 * @param {Object} pView @param {Object} pInput @param {number|string} pRowIndex
	 */
	_autoFillTestLab(pView, pInput, pRowIndex)
	{
		libLabRouting.autoFillTestLab(this.pict, pInput, pRowIndex, pView,
			() => this._getRowTestInstance(pView, pInput, pRowIndex)?.IDLab,
			(pIDLab) => pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pIDLab));
	}

	/**
	 * One lab per test (single-select), tag on Name.
	 * @param {Object} pInput
	 */
	_applyTestLabDefaults(pInput)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = false;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Name';
		}
	}

	/**
	 * Lab list is customer-scoped (row-level auth), sorted by Name — same as the sample lab selector.
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView @param {Object} pInput @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Name' ];
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
		applyLabPriorityIDs(this.pict, pConfigOptions, pInput, pRowIndex, pView);
	}

	/**
	 * On a lab pick: dual-write the test's lab (TestInstance.IDLab + a TestInstanceLabJoin), then ask the sample's
	 * labs to reconcile with the per-test labs. The row record IS the test triple (TestInstance + joins).
	 * @param {Object} pView @param {Object} pInput @param {Object} pRecord @param {string} pRecordAddress
	 * @param {string} pTransactionGUID @param {number} [pRowIndex]
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLab = Array.isArray(pRecord) ? pRecord[0] : pRecord;
		const tmpIDLab = tmpLab && tmpLab.IDLab;
		const tmpTestInstance = this._getRowTestInstance(pView, pInput, pRowIndex);
		if (tmpTestInstance && tmpIDLab)
		{
			tmpTestInstance.IDLab = tmpIDLab;
			this._ensureTestInstanceLabJoin(pView, pInput, pRowIndex, tmpTestInstance, tmpLab);
		}
		libLabRouting.requestSampleLabSync(this.pict);
		const tmpLabAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLabAddress, pRecord || { });
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * The TestInstance for this row. The Testing-G2 table binds to the Test selector's triple collection
	 * (`${TestAddress}_Instances`), so the row record is `{ TestInstance, TestInstanceSampleJoin, ... }`.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @return {Record<string, any>|null}
	 */
	_getRowTestInstance(pView, pInput, pRowIndex)
	{
		const tmpRowAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		// the lab address sits inside the row record; walk up to the row triple and read its TestInstance
		const tmpTripleAddress = pInput.PictForm.TestInstanceTripleAddress || tmpRowAddress.replace(/\.[^.]+$/, '');
		const tmpTriple = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTripleAddress);
		if (tmpTriple && tmpTriple.TestInstance && typeof tmpTriple.TestInstance === 'object')
		{
			return tmpTriple.TestInstance;
		}
		// fallback: the row record itself is/holds the TestInstance
		return (tmpTriple && typeof tmpTriple === 'object' && !Array.isArray(tmpTriple)) ? tmpTriple : null;
	}

	/**
	 * Create (or retarget) the TestInstanceLabJoin for this test instance, stored on the row triple at
	 * `_TestInstanceLabJoin` so the projection can sweep it into _EntityData.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Record<string, any>} pTestInstance @param {Record<string, any>} pLab
	 */
	_ensureTestInstanceLabJoin(pView, pInput, pRowIndex, pTestInstance, pLab)
	{
		// Compose the row-triple sibling address (…_Instances[row]._TestInstanceLabJoin) directly. The record
		// address is the lab's own (…row.TestInstance.IDLab__Record), so stripping one segment lands INSIDE the
		// TestInstance — which drags the join into the TestInstance insert and breaks it with malformed SQL.
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpExisting = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		const tmpJoin = (tmpExisting && typeof tmpExisting === 'object' && !Array.isArray(tmpExisting)) ? tmpExisting : { };
		tmpJoin.IDLab = pLab.IDLab;
		if (pTestInstance.IDTestInstance > 0)
		{
			tmpJoin.IDTestInstance = pTestInstance.IDTestInstance;
			delete tmpJoin.GUIDTestInstance;
		}
		else if (pTestInstance.GUIDTestInstance)
		{
			tmpJoin.GUIDTestInstance = pTestInstance.GUIDTestInstance;
			delete tmpJoin.IDTestInstance;
		}
		if (!tmpJoin.GUIDTestInstanceLabJoin)
		{
			const tmpDocumentGUID = this.pict.manifest.getValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.GUIDDocument') || '';
			// Keyed off the test instance rather than a fresh UUID. There is one join per instance, so the
			// key has to be re-derivable - a re-mint that cannot reproduce it inserts a duplicate row
			// instead of upserting the existing one.
			let tmpTestKey = `ID${pTestInstance.IDTestInstance}`;
			if (pTestInstance.GUIDTestInstance)
			{
				tmpTestKey = String(pTestInstance.GUIDTestInstance).replace(`${tmpDocumentGUID}-`, '');
			}
			tmpJoin.GUIDTestInstanceLabJoin = `${tmpDocumentGUID}-TILJ-${tmpTestKey}`;
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress, tmpJoin);
	}

	/**
	 * Per-row save-time projection hook. The base dispatches this per row on the ProjectEntityDataRecords sweep
	 * (via onAfterEventTabularCompletion). A lab picker creates no Lab reference record, so we override the base
	 * (skipping its AllowEntityCreation-gated Lab upsert) and instead project this row's TestInstanceLabJoin into
	 * the shared _EntityData. Rows with no lab picked staged no join, so the sync no-ops on them.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleBaseSaveProjectionEvent(pView, pInput, pRowIndex, pEvent, pTransactionGUID)
	{
		if (typeof pEvent !== 'string')
		{
			return;
		}
		const tmpTarget = this._getProjectionTarget(pInput, pEvent);
		if (!tmpTarget)
		{
			return;
		}
		this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
	}

	/**
	 * Save-time projection: sweep this row's TestInstanceLabJoin into _EntityData. (TestInstance.IDLab itself
	 * rides the Test selector's TestInstance projection — we only own the join here.)
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}
		// Compose the row-triple sibling address (…_Instances[row]._TestInstanceLabJoin) directly. The record
		// address is the lab's own (…row.TestInstance.IDLab__Record), so stripping one segment lands INSIDE the
		// TestInstance — which drags the join into the TestInstance insert and breaks it with malformed SQL.
		const tmpJoinAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, '_TestInstanceLabJoin');
		const tmpJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinAddress);
		if (tmpJoin && typeof tmpJoin === 'object' && !Array.isArray(tmpJoin) && tmpJoin.GUIDTestInstanceLabJoin)
		{
			if (!tmpEntityData.TestInstanceLabJoin || typeof tmpEntityData.TestInstanceLabJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceLabJoin))
			{
				tmpEntityData.TestInstanceLabJoin = { };
			}
			tmpEntityData.TestInstanceLabJoin[tmpJoin.GUIDTestInstanceLabJoin] = tmpJoin;
		}
	}
}

module.exports = MaterialsTestLabSelectorInputType;
module.exports.default_configuration = { };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89,"./_LabRouting.js":159}],106:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsCascadePicker = require('./PictProvider-InputType-MaterialsCascadePicker.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsTestPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// The Test selector is THE save-projection driver: its onBeforeSaveDataAsync fires the
	// _EntityData sweep unconditionally (legacy parity), so it must ride the app save lifecycle.
	AutoSaveDataWithApp: true,
	Entity: 'Test',
};

/**
 * The Test picker (beast B3 — the projection DRIVER): the Picker-stack port of MaterialsTestSelector,
 * mirroring the 1030-line legacy provider 1:1 on the MaterialsCascadePicker base. Selecting tests
 * synthesizes a per-test THREE-RECORD TRIPLE — TestInstance / TestInstanceSampleJoin /
 * DocumentPolyJoin — reconciled by IDTest so server-assigned ids and downstream edits survive
 * re-selection; the single-select path keeps the legacy singular shapes (`_Instance` / `_SampleJoin` /
 * `_DocumentPolyJoin`, un-suffixed GUIDs). On a bound sample's SampleChanged it re-keys the joins and
 * soft-adopts the sample's PERSISTED tests from the DB (3-level REST walk). Its save hook drives the
 * ProjectEntityDataRecords sweep for the whole form.
 */
class PictProviderInputTypeMaterialsTestPicker extends MaterialsCascadePicker
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any, TempData: any }} */
		this.pict;
	}

	/**
	 * A Test is committed by its HASH (the legacy identity — not the id, not a GUID), so the picker's
	 * ValueField, the identity-aware `__Record` resolve (`FBL~Hash~INN`) and the local-record guard all
	 * key on it.
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		return pInput?.PictForm?.RecordIdentity || 'Hash';
	}

	/**
	 * Mandatory Test-catalog scoping, ported from the legacy HandleSearchFilters: only Active,
	 * non-Collection tests are selectable. Any contextual filters are paren-wrapped so the appended
	 * clauses AND against the whole set.
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}}
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpSplit = super.getContextualSearchFilters(pInput, pRowIndex, pView);
		const tmpFilters = tmpSplit.Filters;
		if (tmpFilters.length > 0)
		{
			tmpFilters.unshift('FOP~0~(~0');
			tmpFilters.push('FCP~0~)~0');
		}
		tmpFilters.push('FBV~Active~EQ~1');
		tmpFilters.push('FBV~Collection~EQ~0');
		return tmpSplit;
	}

	/** The (creation-opt-in) synthesized Test — legacy '-T-' GUID fallback preserved. */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			tmpRecord = { GUIDTest: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-T-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		return tmpRecord;
	}

	/** Init: default the Hash EntityTag + mint/configure the TEST-type tracking GUID (ported 1:1). */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, null, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = tmpTrackingGUID;
		}
		return tmpResult;
	}

	/** Tabular twin of the init (per-row TEST tracking GUIDs; the flag collapses to true). */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return tmpResult;
	}

	/**
	 * Whether this input is configured for multi-test selection: the non-Multiple path keeps the legacy
	 * SINGULAR data shapes (one TestInstance at `${addr}_Instance`, un-suffixed GUIDs); Multiple builds
	 * the keyed `_Instances` triple collection with per-test GUID suffixes.
	 * @param {Record<string, any>} pInput @return {boolean}
	 */
	_isMultiple(pInput)
	{
		return !!(pInput && pInput.PictForm && pInput.PictForm.Multiple);
	}

	/**
	 * Read the triple collection for this input/row, always as an array.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>}
	 */
	_getTestInstances(pView, pInput, pRowIndex)
	{
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		return Array.isArray(tmpTestInstances) ? tmpTestInstances : [ ];
	}

	/**
	 * A de-selected Test takes its whole triple with it. Picker twin of
	 * `MaterialsTestSelector._collectRemovedDependentRecords`.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpTriples = this._getTestInstances(pView, pInput, pRowIndex);
		if (tmpTriples.length < 1)
		{
			return [ ];
		}
		const tmpIdentity = this._getRecordIdentity(pInput);
		const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		const tmpRetainedIDTests = new Set();
		for (const tmpRecord of Array.isArray(tmpHeld) ? tmpHeld : [ tmpHeld ])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			if (pRetainedIdentities.has(String(tmpRecord[tmpIdentity])))
			{
				tmpRetainedIDTests.add(String(tmpRecord.IDTest));
			}
		}
		const tmpRemovals = [ ];
		for (const tmpTriple of tmpTriples)
		{
			const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
			if (!tmpTestInstance || typeof tmpTestInstance !== 'object')
			{
				continue;
			}
			if (tmpRetainedIDTests.has(String(tmpTestInstance.IDTest)))
			{
				continue;
			}
			tmpRemovals.push(...ScopedEntityData.collectTestInstanceUnit(tmpTriple));
		}
		return tmpRemovals;
	}

	/**
	 * Build (or reuse, matched by IDTest — preserving server ids + downstream edits) the
	 * TestInstance / TestInstanceSampleJoin / DocumentPolyJoin triple for one selected Test.
	 * Ported 1:1 (per-test GUID suffixes off one salt; saved-vs-unsaved document + sample keying).
	 * @param {Record<string, any>} pRecord @param {Array<any>} pCurrentInstances
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex
	 * @return {{ Name: string, TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }}
	 */
	_buildTestInstanceTriple(pRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		// Per-test GUID suffix so multiple instances built off one salt don't collide.
		const tmpGUIDSuffix = (pRecord && pRecord.IDTest != null) ? `-${pRecord.IDTest}` : '';
		const tmpTestHash = (pRecord && pRecord.Hash) || '';
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;

		const tmpExistingIndex = Array.isArray(pCurrentInstances) ? pCurrentInstances.findIndex((pTriple) => pTriple && pTriple.TestInstance && pTriple.TestInstance.IDTest == pRecord.IDTest) : -1;
		let tmpTestInstance;
		let tmpTestInstanceSampleJoin;
		let tmpDocumentPolyJoin;
		let tmpExistingTriple = null;
		if (tmpExistingIndex >= 0)
		{
			tmpExistingTriple = pCurrentInstances[tmpExistingIndex];
			pCurrentInstances.splice(tmpExistingIndex, 1);
			tmpTestInstance = tmpExistingTriple.TestInstance;
			tmpTestInstanceSampleJoin = tmpExistingTriple.TestInstanceSampleJoin;
			tmpDocumentPolyJoin = tmpExistingTriple.DocumentPolyJoin;
		}

		if (!tmpTestInstance)
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: pRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
			tmpTestInstance.GUIDTestInstance += tmpGUIDSuffix;
			tmpTestInstance.IDTest = pRecord.IDTest;
		}
		else
		{
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}${tmpGUIDSuffix}`;
			}
			tmpTestInstance.IDTest = pRecord.IDTest;
			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		if (!(tmpTestInstance.IDProject > 0) && tmpDocument && tmpDocument.IDProject > 0)
		{
			tmpTestInstance.IDProject = tmpDocument.IDProject;
		}
		if (pRecord && typeof pRecord === 'object')
		{
			if (pRecord.IDTest > 0)
			{
				tmpTestInstance.IDTest = pRecord.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (pRecord.GUIDTest)
			{
				tmpTestInstance.GUIDTest = pRecord.GUIDTest;
			}
		}

		if (!tmpDocumentPolyJoin)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${tmpSalt}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin += tmpGUIDSuffix;
			}
			tmpDocumentPolyJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
		}
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}

		if (!tmpTestInstanceSampleJoin)
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${tmpSalt}`,
				}));
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin += tmpGUIDSuffix;
			}
		}
		if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
		{
			if (tmpTestInstance.IDTestInstance > 0)
			{
				tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
				delete tmpTestInstanceSampleJoin.GUIDTestInstance;
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
			}
		}
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (pSample && typeof pSample === 'object')
		{
			if (pSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = pSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (pSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = pSample.GUIDSample;
			}
		}

		// Name is a display-only flat field for the tabular Test column; the wrapper is never persisted (the
		// projection writes TestInstance / TestInstanceSampleJoin / DocumentPolyJoin), so it needs no strip. A reused
		// triple keeps the row state other inputs park on it — the per-test lab selector's `_TestInstanceLabJoin`.
		return Object.assign({ }, tmpExistingTriple, { Name: (tmpTestInstance && tmpTestInstance.Name) || '', TestInstance: tmpTestInstance, TestInstanceSampleJoin: tmpTestInstanceSampleJoin, DocumentPolyJoin: tmpDocumentPolyJoin });
	}

	/**
	 * Diff the selected Tests against the existing triples: reuse matches (by IDTest), synthesize new,
	 * drop deselected. Ported 1:1.
	 * @param {Array<Record<string, any>>} pRecords @param {Array<any>} pCurrentInstances
	 * @param {Record<string, any>|null} pSample @param {Object} pView @param {Record<string, any>} pInput
	 * @param {number|string|null} pRowIndex @return {Array<any>}
	 */
	_syncTestInstances(pRecords, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		if (!Array.isArray(pCurrentInstances))
		{
			pCurrentInstances = [];
		}
		const tmpInstances = [ ];
		for (const tmpRecord of pRecords || [])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object')
			{
				continue;
			}
			tmpInstances.push(this._buildTestInstanceTriple(tmpRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex));
		}
		return tmpInstances;
	}

	/**
	 * Soft-adopt the bound Sample's PERSISTED tests from the DB on (re)open — the saved FormData triples
	 * can be stale client placeholders that were never persisted (the materials concierge creates the
	 * real TestInstances server-side). Walks TestInstanceSampleJoins(IDSample) → TestInstances → Tests,
	 * assembles each triple FROM the DB record (the DB TestInstanceLabJoin via `_attachAdoptedLabJoins`;
	 * DocumentPolyJoin left null for _buildTestInstanceTriple
	 * to synthesize against the doc), writes them at the instances address, then setDataByInput the
	 * hashes so the rebuild reconciles by IDTest and REUSES the adopted triples. Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Record<string, any>} pSampleRecord
	 */
	_loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, pSampleRecord)
	{
		const tmpRefreshEvent = `SampleTestAdopt-${this.pict.getUUID()}`;
		pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
		const fComplete = () => pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
		this.pict.HeadlightRestClient.getJSON(`TestInstanceSampleJoins/FilteredTo/FBV~IDSample~EQ~${pSampleRecord.IDSample}`, (pError, pJoins) =>
		{
			const tmpJoins = Array.isArray(pJoins) ? pJoins.filter((pJoin) => parseInt(pJoin.IDTestInstance, 10) > 0) : [];
			if (!tmpJoins.length)
			{
				fComplete();
				return;
			}
			const tmpIDTestInstances = [ ...new Set(tmpJoins.map((pJoin) => parseInt(pJoin.IDTestInstance, 10))) ];
			this.pict.HeadlightRestClient.getJSON(`TestInstances/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError2, pTestInstances) =>
			{
				const tmpTestInstances = Array.isArray(pTestInstances) ? pTestInstances.filter((pTestInstance) => parseInt(pTestInstance.IDTest, 10) > 0) : [];
				if (!tmpTestInstances.length)
				{
					fComplete();
					return;
				}
				const tmpIDTests = [ ...new Set(tmpTestInstances.map((pTestInstance) => parseInt(pTestInstance.IDTest, 10))) ];
				this.pict.HeadlightRestClient.getJSON(`Tests/FilteredTo/FBL~IDTest~INN~${tmpIDTests.join(',')}`, (pError3, pTests) =>
				{
					const tmpHashByTest = {};
					for (const tmpTest of Array.isArray(pTests) ? pTests : [])
					{
						if (tmpTest && tmpTest.Hash)
						{
							tmpHashByTest[tmpTest.IDTest] = tmpTest.Hash;
						}
					}
					const tmpJoinByTI = {};
					for (const tmpJoin of tmpJoins)
					{
						tmpJoinByTI[parseInt(tmpJoin.IDTestInstance, 10)] = tmpJoin;
					}
					const tmpAdopted = [];
					const tmpHashes = [];
					for (const tmpTestInstance of tmpTestInstances)
					{
						const tmpHash = tmpHashByTest[tmpTestInstance.IDTest];
						if (!tmpHash)
						{
							continue;
						}
						const tmpJoin = tmpJoinByTI[parseInt(tmpTestInstance.IDTestInstance, 10)] || {};
						tmpAdopted.push(
							{
								Name: tmpTestInstance.Name || `Sample Test for ${tmpHash}`,
								TestInstance: ScopedEntityData.adoptTestInstance(this.pict, tmpTestInstance),
								TestInstanceSampleJoin: { IDTestInstanceSampleJoin: tmpJoin.IDTestInstanceSampleJoin, GUIDTestInstanceSampleJoin: tmpJoin.GUIDTestInstanceSampleJoin, IDSample: tmpJoin.IDSample, IDTestInstance: tmpTestInstance.IDTestInstance },
								DocumentPolyJoin: null,
							});
						tmpHashes.push(tmpHash);
					}
					if (!tmpAdopted.length)
					{
						fComplete();
						return;
					}
					this._attachAdoptedLabJoins(tmpAdopted, this._getTestInstances(pView, pInput, pRowIndex), () =>
					{
						const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
						const tmpInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
						this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpInstancesAddress, tmpAdopted);
						ScopedEntityData.beginProgrammaticLoad(this.pict);
						try
						{
							pView.setDataByInput(pInput, tmpHashes.join(','));
						}
						finally
						{
							ScopedEntityData.endProgrammaticLoad(this.pict);
						}
						fComplete();
					});
				});
			});
		});
	}

	/**
	 * The triple the form held before adoption for the same test: matched on the TestInstance id, then its GUID,
	 * then the Test.
	 *
	 * @param {Record<string, any>} pTriple - An adopted triple.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @return {Record<string, any>|null} - The held triple, or null.
	 */
	_findHeldTriple(pTriple, pHeldInstances)
	{
		const tmpTestInstance = (pTriple && pTriple.TestInstance) || { };
		const tmpHeld = (Array.isArray(pHeldInstances) ? pHeldInstances : [ ]).filter((pHeldTriple) => pHeldTriple && pHeldTriple.TestInstance && typeof pHeldTriple.TestInstance === 'object');
		const tmpMatchers =
		[
			(pHeldTriple) => Number(tmpTestInstance.IDTestInstance) > 0 && Number(pHeldTriple.TestInstance.IDTestInstance) === Number(tmpTestInstance.IDTestInstance),
			(pHeldTriple) => !!tmpTestInstance.GUIDTestInstance && pHeldTriple.TestInstance.GUIDTestInstance === tmpTestInstance.GUIDTestInstance,
			(pHeldTriple) => Number(tmpTestInstance.IDTest) > 0 && Number(pHeldTriple.TestInstance.IDTest) === Number(tmpTestInstance.IDTest),
		];
		for (const fMatches of tmpMatchers)
		{
			const tmpMatch = tmpHeld.find(fMatches);
			if (tmpMatch)
			{
				return tmpMatch;
			}
		}
		return null;
	}

	/**
	 * Give each adopted triple the lab join the database holds for its TestInstance, so the per-test lab picker
	 * reuses the persisted row rather than minting one the (TestInstance, Lab) unique key refuses. Where a
	 * TestInstance has several, the one on its own lab wins. With no live row the triple keeps the lab join the form
	 * held for that test, and a failed read keeps every held one. Mirrors MaterialsTestSelector.
	 *
	 * @param {Array<Record<string, any>>} pAdopted - The triples assembled from the database.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @param {() => void} fDone - Called once, when every triple's lab join is settled.
	 */
	_attachAdoptedLabJoins(pAdopted, pHeldInstances, fDone)
	{
		const fCarryHeld = (pTriple) =>
		{
			const tmpHeld = this._findHeldTriple(pTriple, pHeldInstances);
			if (tmpHeld && tmpHeld._TestInstanceLabJoin && typeof tmpHeld._TestInstanceLabJoin === 'object')
			{
				pTriple._TestInstanceLabJoin = tmpHeld._TestInstanceLabJoin;
			}
		};
		let tmpSettled = false;
		const fSettle = () =>
		{
			if (tmpSettled)
			{
				return;
			}
			tmpSettled = true;
			fDone();
		};
		const tmpIDTestInstances = [ ...new Set(pAdopted.map((pTriple) => parseInt(pTriple.TestInstance.IDTestInstance, 10)).filter((pID) => pID > 0)) ];
		if (tmpIDTestInstances.length < 1)
		{
			pAdopted.forEach(fCarryHeld);
			return fSettle();
		}
		try
		{
			this.pict.HeadlightRestClient.getJSON(`TestInstanceLabJoins/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError, pLabJoins) =>
			{
				try
				{
					if (pError || !Array.isArray(pLabJoins))
					{
						pAdopted.forEach(fCarryHeld);
						return;
					}
					const tmpRowsByTestInstance = { };
					for (const tmpRow of pLabJoins)
					{
						if (!tmpRow || !(Number(tmpRow.IDTestInstanceLabJoin) > 0) || typeof tmpRow.GUIDTestInstanceLabJoin !== 'string')
						{
							continue;
						}
						const tmpKey = parseInt(tmpRow.IDTestInstance, 10);
						tmpRowsByTestInstance[tmpKey] = tmpRowsByTestInstance[tmpKey] || [ ];
						tmpRowsByTestInstance[tmpKey].push(tmpRow);
					}
					for (const tmpTriple of pAdopted)
					{
						const tmpRows = tmpRowsByTestInstance[parseInt(tmpTriple.TestInstance.IDTestInstance, 10)] || [ ];
						if (tmpRows.length < 1)
						{
							fCarryHeld(tmpTriple);
							continue;
						}
						const tmpRow = tmpRows.find((pRow) => Number(pRow.IDLab) === Number(tmpTriple.TestInstance.IDLab)) || tmpRows[0];
						if (tmpRows.length > 1 && this.log && typeof this.log.warn === 'function')
						{
							this.log.warn(`MaterialsTestPicker: TestInstance ${tmpTriple.TestInstance.IDTestInstance} has ${tmpRows.length} lab joins; adopting ${tmpRow.IDTestInstanceLabJoin} (lab ${tmpRow.IDLab}).`);
						}
						tmpTriple._TestInstanceLabJoin =
						{
							IDTestInstanceLabJoin: Number(tmpRow.IDTestInstanceLabJoin),
							GUIDTestInstanceLabJoin: tmpRow.GUIDTestInstanceLabJoin,
							IDTestInstance: Number(tmpRow.IDTestInstance),
							IDLab: Number(tmpRow.IDLab),
						};
					}
				}
				catch (pError2)
				{
					pAdopted.forEach((pTriple) =>
					{
						if (!pTriple._TestInstanceLabJoin)
						{
							fCarryHeld(pTriple);
						}
					});
				}
				finally
				{
					fSettle();
				}
			});
		}
		catch (pError)
		{
			pAdopted.forEach(fCarryHeld);
			fSettle();
		}
	}

	/**
	 * The Test cascade — the port of the legacy `_onRecordRefresh`. Multiple: reconcile the triple
	 * collection at `_Instances` (clear → []). Single: the legacy singular shapes. Then the in-section
	 * repaint + the family bus (super).
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		if (!this._isMultiple(pInput))
		{
			this._onRecordRefreshSingle(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
			return;
		}
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpCleared = !pRecord || (Array.isArray(pRecord) && pRecord.length === 0) ||
			(typeof pRecord === 'object' && !Array.isArray(pRecord) && Object.keys(pRecord).length === 0);
		if (tmpCleared)
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, [ ]);
			libLabRouting.requestSampleLabSync(this.pict);
			if (typeof pView.marshalToView === 'function')
			{
				pView.marshalToView();
			}
			super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
			return;
		}
		let tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		if (!Array.isArray(tmpTestInstances))
		{
			if (tmpTestInstances)
			{
				this.log.error(`MaterialsTestPicker: TestInstances at address ${tmpTestInstancesAddress} is not an array`, { tmpTestInstances });
			}
			tmpTestInstances = [ ];
		}
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		tmpTestInstances = this._syncTestInstances(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpTestInstances, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, tmpTestInstances);
		libLabRouting.requestSampleLabSync(this.pict);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * Single-select refresh: the legacy singular TestInstance / DocumentPolyJoin / TestInstanceSampleJoin
	 * objects (one each, un-suffixed GUIDs) at their historical addresses. Ported 1:1; a cleared picker
	 * ({} from the seam) resets all three.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onRecordRefreshSingle(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
		const tmpTestDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
		const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceSampleJoinAddress || `${tmpTestAddress}_SampleJoin`;
		/** @type {Record<string, any>|null} */
		let tmpRecord = null;
		if (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord) && Object.keys(pRecord).length > 0)
		{
			tmpRecord = pRecord;
		}
		else if (Array.isArray(pRecord) && pRecord.length > 0)
		{
			tmpRecord = pRecord[0];
		}
		if (!tmpRecord)
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, { });
			super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
			return;
		}
		const tmpTestHash = tmpRecord.Hash || '';
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
		let tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
		if (!tmpTestInstance || (typeof tmpTestInstance === 'object' && Object.keys(tmpTestInstance).length === 0))
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: tmpRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
		}
		else
		{
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
			tmpTestInstance.IDTest = tmpRecord.IDTest;
			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);

		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress);
		// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
		if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
		}
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		let tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!tmpTestInstanceSampleJoin || (typeof tmpTestInstanceSampleJoin === 'object' && Object.keys(tmpTestInstanceSampleJoin).length === 0))
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${this._getSalt(pView, pInput, pRowIndex)}`,
				}));
			if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
			{
				if (tmpTestInstance.IDTestInstance > 0)
				{
					tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
					delete tmpTestInstanceSampleJoin.GUIDTestInstance;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
				}
			}
			if (tmpSample && tmpSample.GUIDSample)
			{
				if (tmpSample.IDSample > 0)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
				}
			}

			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
		}
		if (tmpTest && typeof tmpTest === 'object')
		{
			if (tmpTest.IDTest > 0)
			{
				tmpTestInstance.IDTest = tmpTest.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (tmpTest.GUIDTest)
			{
				tmpTestInstance.GUIDTest = tmpTest.GUIDTest;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (tmpSample && typeof tmpSample === 'object')
		{
			if (tmpSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (tmpSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, tmpTestInstanceSampleJoin);
		// ensures any fields that use this record are updated immediately, if they are in the same section
		if (typeof pView.marshalToView === 'function')
		{
			pView.marshalToView();
		}
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
	}

	/**
	 * The bound Sample record: ask the family over the bus (PushRecord into TempData), falling back to
	 * the conventional SampleAddress. Ported 1:1.
	 * @param {Object} pView @param {Record<string, any>} pInput @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * THE PROJECTION DRIVER: unlike the creation-latched base, the Test selector fires the _EntityData
	 * sweep on EVERY save (legacy parity — every sibling projector rides this trigger).
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		this._entityCreationEnabled = true;
		return super.onBeforeSaveDataAsync(fCallback);
	}

	/**
	 * SampleChanged starts this input's sample-level load, so it is handled while the event is raised.
	 * @return {Array<string>}
	 */
	_getTriggerTimeEventTypes()
	{
		return [ 'SampleChanged' ];
	}

	/**
	 * Family + save-sweep events — ported 1:1: TestResultChanged (TEST-tracking-matched: stamp the
	 * result onto the instance(s)); GetTestHash (TEST-tracking-matched: write the hash to the payload
	 * address); SampleChanged (SAMPLE-tracking-matched: re-key the joins to the new sample; multi also
	 * soft-adopts its persisted tests); ProjectEntityDataRecords (project the triples).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'TestResultChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestResult = tmpEventPayload;

			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
				const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
			}
			return;
		}

		if (tmpEventType === 'GetTestHash')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
			const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
			const tmpTestRecord = Array.isArray(tmpTest) ? tmpTest[0] : tmpTest;
			const tmpTestHash = tmpTestRecord ? tmpTestRecord.Hash : null;
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload, tmpTestHash);
		}

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				return;
			}
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
				const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
				return;
			}
			if (tmpSampleRecord.IDSample)
			{
				this._loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, tmpSampleRecord);
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstanceSampleJoin = tmpTriple && tmpTriple.TestInstanceSampleJoin;
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
			}
			return;
		}
		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
				const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
				const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpDocumentPolyJoin = tmpTriple && tmpTriple.DocumentPolyJoin;
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
			}
		}
	}

	/**
	 * Project a TestInstance into the save-time comprehension with its TestResult held back. The result
	 * is staged when the user sets it (`_stageDeferredTestResult`), not from here. Both Test families
	 * route through the same primitive.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance record being projected.
	 * @param {Record<string, any>} pEntityData - The save-time `<Entity>.<GUID>` target.
	 */
	_projectTestInstanceDeferringResult(pTestInstance, pEntityData)
	{
		if (!ScopedEntityData.projectTestInstanceDeferringResult(pTestInstance, pEntityData))
		{
			this.pict.log.warn(`MaterialsTestPicker: could not project the test instance ${pTestInstance?.GUIDTestInstance}; it will not be saved.`);
		}
	}

	/**
	 * Stage the test result the user just entered for the workflow trigger that applies it
	 * (`PictForm.DeferredComprehensionContext`, default `OnEnteringState.Approved`).
	 *
	 * Staging happens at the edit rather than on the save sweep: the sweep writes what the form holds,
	 * which cannot tell a result the user cleared from one that was never entered, and would re-assert a
	 * standing leaf on every save. A cleared result stages as a clear — no result is a valid outcome.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance whose result changed.
	 * @param {Record<string, any>} pInput - The form input descriptor.
	 * @return {boolean} - True when the result was staged.
	 */
	_stageDeferredTestResult(pTestInstance, pInput)
	{
		const tmpGUID = pTestInstance && pTestInstance.GUIDTestInstance;
		if (!tmpGUID)
		{
			this.pict.log.warn('MaterialsTestPicker: a test result changed on an instance with no GUIDTestInstance; it cannot be staged for approval.');
			return false;
		}
		const tmpDeferredContext = ScopedEntityData.resolveDeferredContext(pInput, this.options?.DeferredComprehensionContext);
		return ScopedEntityData.stageDeferredValue(this.pict, tmpDeferredContext, 'TestInstance', tmpGUID, 'TestResult', pTestInstance.TestResult);
	}

	/**
	 * Project the triple records (keyed by their GUIDs) into the entity-data collection — the plural
	 * counterpart of the base _syncRecordToEntityData. Single + multi shapes ported 1:1 (the Test
	 * CATALOG record itself never projects; the triples are the created data).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 * @param {string} pTransactionGUID @param {Object} pTargetObject
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpTestAddress = this._getRecordAddress(pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		if (!this._isMultiple(pInput))
		{
			const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
			const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
			const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}
			return;
		}

		for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
		{
			if (!tmpTriple || typeof tmpTriple !== 'object')
			{
				continue;
			}
			const tmpTestInstance = tmpTriple.TestInstance;
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoin = tmpTriple.TestInstanceSampleJoin;
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}

			const tmpDocumentPolyJoin = tmpTriple.DocumentPolyJoin;
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpEntityData.DocumentPolyJoin || typeof tmpEntityData.DocumentPolyJoin !== 'object' || Array.isArray(tmpEntityData.DocumentPolyJoin))
				{
					tmpEntityData.DocumentPolyJoin = { };
				}
				tmpEntityData.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}
}

module.exports = PictProviderInputTypeMaterialsTestPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-MaterialsCascadePicker.js":86,"./_LabRouting.js":159,"./_ScopedEntityData.js":162}],107:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * Input type that lets a user remove a dynamically injected test section from a
 * form. Confirms via modal, then delegates to DocumentDynamicSectionManager to
 * tombstone the section registration, stage deletion of the underlying
 * TestInstance in the document's OnSave comprehension, and tear down the live
 * section views.
 */
class MaterialsTestSectionRemoverInputType extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Prompt for confirmation, then remove the dynamic section registered at the
	 * given hash along with its underlying TestInstance (deleted on form save).
	 *
	 * @param {string} pRegistrationHash - The __DynamicSectionData registration hash for the section.
	 */
	requestSectionRemoval(pRegistrationHash)
	{
		const tmpSectionManager = this.pict.providers.DocumentDynamicSectionManager;
		if (!tmpSectionManager)
		{
			this.pict.log.error(`MaterialsTestSectionRemoverInputType: DocumentDynamicSectionManager provider not available; cannot remove section.`, { pRegistrationHash });
			return;
		}
		const tmpRegistration = this.pict.AppData.DocumentData?.ReportData?.FormData?.__DynamicSectionData?.[pRegistrationHash];
		if (!tmpRegistration)
		{
			this.pict.log.error(`MaterialsTestSectionRemoverInputType: No dynamic section registration found for hash [${pRegistrationHash}]; cannot remove section.`);
			return;
		}
		const tmpTestLabel = tmpRegistration.TestHash ? ` ${tmpRegistration.TestHash}` : '';
		this.fable.HeadlightModal.spawnModal(
			{
				title: 'Remove Test',
				message: `Remove test${tmpTestLabel} and its section from this form? The test will be deleted from the sample when the form is saved.`,
				confirmText: 'Remove Test',
				confirmIcon: 'trash-alt',
				confirmColor: 'is-danger',
				cancelColor: 'is-danger is-soft',
			},
			() =>
			{
				tmpSectionManager.removeTestSection(pRegistrationHash);
			},
			null);
	}
}

module.exports = MaterialsTestSectionRemoverInputType;

},{"pict-section-form":587}],108:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');
const libLabRouting = require('./_LabRouting.js');

class MaterialsTestSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, null, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, null, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = tmpTrackingGUID;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'Hash';
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.TestTrackingGUID, 'TEST');
			return tmpResult;
		}
		let tmpTrackingGUID = this._getTrackingGUID(pInput, pRowIndex, 'TEST');
		if (!tmpTrackingGUID)
		{
			tmpTrackingGUID = this.pict.getUUID();
			this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID, 'TEST');
			pInput.PictForm.TestTrackingGUID = true; // different rows will have different values so avoid confusion
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getDefaultRecordIdentity(pInput)
	{
		return 'Hash';
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string} [pRowIndex]
	 */
	_getDefaultRecord(pView, pInput, pRowIndex)
	{
		let tmpRecord = super._getDefaultRecord(pView, pInput, pRowIndex);
		if (!tmpRecord)
		{
			//FIXME: need to get some kind of record uniqueness injected here
			tmpRecord = { GUIDTest: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-T-${this._getSalt(pView, pInput, pRowIndex)}` };
		}
		return tmpRecord;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'TestResultChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestResult = tmpEventPayload;

			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
				const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
				if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
				{
					tmpTestInstance.TestResult = tmpTestResult;
					this._stageDeferredTestResult(tmpTestInstance, pInput);
				}
			}
			return;
		}

		if (tmpEventType === 'GetTestHash')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex, 'TEST'))
			{
				return;
			}
			const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
			const tmpTestRecord = Array.isArray(tmpTest) ? tmpTest[0] : tmpTest;
			const tmpTestHash = tmpTestRecord ? tmpTestRecord.Hash : null;
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload, tmpTestHash);
		}

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				return;
			}
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
				const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
				return;
			}
			if (tmpSampleRecord.IDSample)
			{
				this._loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, tmpSampleRecord);
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpTestInstanceSampleJoin = tmpTriple && tmpTriple.TestInstanceSampleJoin;
				if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSampleRecord.IDSample;
					if (!tmpTestInstanceSampleJoin.IDSample)
					{
						tmpTestInstanceSampleJoin.GUIDSample = tmpSampleRecord.GUIDSample;
						delete tmpTestInstanceSampleJoin.IDSample;
					}
					else
					{
						delete tmpTestInstanceSampleJoin.GUIDSample;
					}
				}
			}
			return;
		}
		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			if (!this._isMultiple(pInput))
			{
				const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
				const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
				const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
				return;
			}
			for (const tmpTriple of this._getTestInstances(pView, pInput, pRowIndex))
			{
				const tmpDocumentPolyJoin = tmpTriple && tmpTriple.DocumentPolyJoin;
				if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
				{
					if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
					{
						tmpTarget.DocumentPolyJoin = { };
					}
					tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
				}
			}
		}
	}

	/**
	 * Whether this input is configured for multi-test selection. The non-Multiple (single-select) path keeps the
	 * legacy singular data shapes (one TestInstance object at ${addr}_Instance, un-suffixed GUIDs); the Multiple
	 * path builds the keyed _Instances triple collection with per-test GUID suffixes.
	 *
	 * @param {Object} pInput - The input object.
	 *
	 * @return {boolean}
	 */
	_isMultiple(pInput)
	{
		return !!(pInput && pInput.PictForm && pInput.PictForm.Multiple);
	}

	/**
	 * Read the TestInstance triple collection (TestInstance / TestInstanceSampleJoin / DocumentPolyJoin per
	 * selected Test) for this input/row, always as an array (empty when unset or malformed).
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} [pRowIndex] - The row index. If present, this is a tabular input.
	 *
	 * @return {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>}
	 */
	_getTestInstances(pView, pInput, pRowIndex)
	{
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		return Array.isArray(tmpTestInstances) ? tmpTestInstances : [ ];
	}

	/**
	 * A de-selected Test takes its whole triple with it — the `TestInstance`, its
	 * `TestInstanceSampleJoin` and its `DocumentPolyJoin` — none of which the base sees, because the
	 * value list holds Test identities and the triples are keyed by `IDTest`.
	 *
	 * The retained `IDTest` set is resolved from the records the input STILL holds, since those are
	 * the only place the identity-to-`IDTest` mapping exists before `_refreshRecord` replaces them.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpTriples = this._getTestInstances(pView, pInput, pRowIndex);
		if (tmpTriples.length < 1)
		{
			return [ ];
		}
		const tmpIdentity = this._getRecordIdentity(pInput);
		const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex));
		const tmpRetainedIDTests = new Set();
		for (const tmpRecord of Array.isArray(tmpHeld) ? tmpHeld : [ tmpHeld ])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			if (pRetainedIdentities.has(String(tmpRecord[tmpIdentity])))
			{
				tmpRetainedIDTests.add(String(tmpRecord.IDTest));
			}
		}
		const tmpRemovals = [ ];
		for (const tmpTriple of tmpTriples)
		{
			const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
			if (!tmpTestInstance || typeof tmpTestInstance !== 'object')
			{
				continue;
			}
			if (tmpRetainedIDTests.has(String(tmpTestInstance.IDTest)))
			{
				continue;
			}
			tmpRemovals.push(...ScopedEntityData.collectTestInstanceUnit(tmpTriple));
		}
		return tmpRemovals;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Build (or reuse) the TestInstance / TestInstanceSampleJoin / DocumentPolyJoin triple for a single selected
	 * Test record. When a matching triple already exists in pCurrentInstances (same IDTest) it is reused so any
	 * server-assigned ids and downstream edits are preserved; otherwise a fresh triple is synthesized with a
	 * per-test-unique GUID (suffixed with the test's IDTest, the way the Lab selector suffixes -${IDLab}).
	 *
	 * @param {Record<string, any>} pRecord - The selected Test record.
	 * @param {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>} pCurrentInstances - Existing triples to diff against (matches are spliced out).
	 * @param {Record<string, any>|null} pSample - The bound Sample record (or null).
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index. If present, this is a tabular input.
	 *
	 * @return {{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }}
	 */
	_buildTestInstanceTriple(pRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		// Per-test GUID suffix so multiple instances built off one salt don't collide.
		const tmpGUIDSuffix = (pRecord && pRecord.IDTest != null) ? `-${pRecord.IDTest}` : '';
		const tmpTestHash = (pRecord && pRecord.Hash) || '';
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;

		const tmpExistingIndex = Array.isArray(pCurrentInstances) ? pCurrentInstances.findIndex((pTriple) => pTriple && pTriple.TestInstance && pTriple.TestInstance.IDTest == pRecord.IDTest) : -1;
		let tmpTestInstance;
		let tmpTestInstanceSampleJoin;
		let tmpDocumentPolyJoin;
		let tmpExistingTriple = null;
		if (tmpExistingIndex >= 0)
		{
			tmpExistingTriple = pCurrentInstances[tmpExistingIndex];
			pCurrentInstances.splice(tmpExistingIndex, 1);
			tmpTestInstance = tmpExistingTriple.TestInstance;
			tmpTestInstanceSampleJoin = tmpExistingTriple.TestInstanceSampleJoin;
			tmpDocumentPolyJoin = tmpExistingTriple.DocumentPolyJoin;
		}

		if (!tmpTestInstance)
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: pRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
			tmpTestInstance.GUIDTestInstance += tmpGUIDSuffix;
			tmpTestInstance.IDTest = pRecord.IDTest;
		}
		else
		{
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}${tmpGUIDSuffix}`;
			}
			tmpTestInstance.IDTest = pRecord.IDTest;
			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		if (!(tmpTestInstance.IDProject > 0) && tmpDocument && tmpDocument.IDProject > 0)
		{
			tmpTestInstance.IDProject = tmpDocument.IDProject;
		}
		if (pRecord && typeof pRecord === 'object')
		{
			if (pRecord.IDTest > 0)
			{
				tmpTestInstance.IDTest = pRecord.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (pRecord.GUIDTest)
			{
				tmpTestInstance.GUIDTest = pRecord.GUIDTest;
			}
		}

		if (!tmpDocumentPolyJoin)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${tmpSalt}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
			if (!tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin = this.pict.getUUID();
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocumentPolyJoin += tmpGUIDSuffix;
			}
			tmpDocumentPolyJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
		}
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}

		if (!tmpTestInstanceSampleJoin)
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${tmpSalt}`,
				}));
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin += tmpGUIDSuffix;
			}
		}
		if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
		{
			if (tmpTestInstance.IDTestInstance > 0)
			{
				tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
				delete tmpTestInstanceSampleJoin.GUIDTestInstance;
			}
			else
			{
				tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
			}
		}
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (pSample && typeof pSample === 'object')
		{
			if (pSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = pSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (pSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = pSample.GUIDSample;
			}
		}

		// Name is a display-only flat field for the tabular Test column; the wrapper is never persisted (the projection
		// writes TestInstance / TestInstanceSampleJoin / DocumentPolyJoin), so it needs no strip. A reused triple keeps
		// the row state other inputs park on it — the per-test lab selector's `_TestInstanceLabJoin`.
		return Object.assign({ }, tmpExistingTriple, { Name: (tmpTestInstance && tmpTestInstance.Name) || '', TestInstance: tmpTestInstance, TestInstanceSampleJoin: tmpTestInstanceSampleJoin, DocumentPolyJoin: tmpDocumentPolyJoin });
	}

	/**
	 * Diff the currently-selected Tests against the existing TestInstance triples, reusing matched triples (same
	 * IDTest), synthesizing new ones for newly-selected tests, and dropping deselected ones. Mirrors the Lab
	 * selector's _syncSampleLabJoins, but each entry carries the full TestInstance/TestInstanceSampleJoin/
	 * DocumentPolyJoin triple rather than a single join.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The currently-selected Test records.
	 * @param {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>} pCurrentInstances - The existing triples to diff against.
	 * @param {Record<string, any>|null} pSample - The bound Sample record (or null).
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index. If present, this is a tabular input.
	 *
	 * @return {Array<{ TestInstance: Record<string, any>, TestInstanceSampleJoin: Record<string, any>, DocumentPolyJoin: (Record<string, any>|null) }>}
	 */
	_syncTestInstances(pRecords, pCurrentInstances, pSample, pView, pInput, pRowIndex)
	{
		if (!Array.isArray(pCurrentInstances))
		{
			pCurrentInstances = [];
		}
		const tmpInstances = [ ];
		for (const tmpRecord of pRecords || [])
		{
			if (!tmpRecord || typeof tmpRecord !== 'object')
			{
				continue;
			}
			tmpInstances.push(this._buildTestInstanceTriple(tmpRecord, pCurrentInstances, pSample, pView, pInput, pRowIndex));
		}
		return tmpInstances;
	}

	/**
	 * Soft-adopt the bound Sample's persisted tests from the DB on (re)open — mirrors the Lab/LineItem selectors'
	 * SampleChanged loaders (load persisted records by IDSample, set them as the current records, then setDataByInput
	 * so the rebuild reconciles by reusing them). The doc's saved FormData triples can be stale client placeholders
	 * that were never persisted — e.g. the materials concierge creates the real TestInstances (carrying IDLab)
	 * server-side without touching the doc, so the FormData keeps the user's original GUID-only triples. This walks
	 * TestInstanceSampleJoins(by IDSample) → TestInstances → Tests, assembles each triple FROM the DB record
	 * (TestInstance with its IDLab + IDTestInstance identity, the DB TISJ, the DB TestInstanceLabJoin via
	 * `_attachAdoptedLabJoins`; DocumentPolyJoin left null for
	 * _buildTestInstanceTriple to synthesize against the doc, since none is persisted), writes them at the instances
	 * address, then setDataByInput the hashes. _syncTestInstances reconciles by IDTest and REUSES the adopted triples,
	 * so per-test labs + identities reflect persisted state and SampleTestChange redraws the Testing section.
	 * Persisted state is authoritative on (re)open.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index (null for the non-tabular SampleTestIDs field).
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Record<string, any>} pSampleRecord - The bound Sample record (must carry a persisted IDSample).
	 */
	_loadSampleTests(pView, pInput, pRowIndex, pTransactionGUID, pSampleRecord)
	{
		const tmpRefreshEvent = `SampleTestAdopt-${this.pict.getUUID()}`;
		pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
		const fComplete = () => pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
		this.pict.HeadlightRestClient.getJSON(`TestInstanceSampleJoins/FilteredTo/FBV~IDSample~EQ~${pSampleRecord.IDSample}`, (pError, pJoins) =>
		{
			const tmpJoins = Array.isArray(pJoins) ? pJoins.filter((pJoin) => parseInt(pJoin.IDTestInstance, 10) > 0) : [];
			if (!tmpJoins.length)
			{
				fComplete();
				return;
			}
			const tmpIDTestInstances = [ ...new Set(tmpJoins.map((pJoin) => parseInt(pJoin.IDTestInstance, 10))) ];
			this.pict.HeadlightRestClient.getJSON(`TestInstances/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError2, pTestInstances) =>
			{
				const tmpTestInstances = Array.isArray(pTestInstances) ? pTestInstances.filter((pTestInstance) => parseInt(pTestInstance.IDTest, 10) > 0) : [];
				if (!tmpTestInstances.length)
				{
					fComplete();
					return;
				}
				const tmpIDTests = [ ...new Set(tmpTestInstances.map((pTestInstance) => parseInt(pTestInstance.IDTest, 10))) ];
				this.pict.HeadlightRestClient.getJSON(`Tests/FilteredTo/FBL~IDTest~INN~${tmpIDTests.join(',')}`, (pError3, pTests) =>
				{
					const tmpHashByTest = {};
					for (const tmpTest of Array.isArray(pTests) ? pTests : [])
					{
						if (tmpTest && tmpTest.Hash)
						{
							tmpHashByTest[tmpTest.IDTest] = tmpTest.Hash;
						}
					}
					const tmpJoinByTI = {};
					for (const tmpJoin of tmpJoins)
					{
						tmpJoinByTI[parseInt(tmpJoin.IDTestInstance, 10)] = tmpJoin;
					}
					const tmpAdopted = [];
					const tmpHashes = [];
					for (const tmpTestInstance of tmpTestInstances)
					{
						const tmpHash = tmpHashByTest[tmpTestInstance.IDTest];
						if (!tmpHash)
						{
							continue;
						}
						const tmpJoin = tmpJoinByTI[parseInt(tmpTestInstance.IDTestInstance, 10)] || {};
						tmpAdopted.push(
							{
								Name: tmpTestInstance.Name || `Sample Test for ${tmpHash}`,
								TestInstance: ScopedEntityData.adoptTestInstance(this.pict, tmpTestInstance),
								TestInstanceSampleJoin: { IDTestInstanceSampleJoin: tmpJoin.IDTestInstanceSampleJoin, GUIDTestInstanceSampleJoin: tmpJoin.GUIDTestInstanceSampleJoin, IDSample: tmpJoin.IDSample, IDTestInstance: tmpTestInstance.IDTestInstance },
								DocumentPolyJoin: null,
							});
						tmpHashes.push(tmpHash);
					}
					if (!tmpAdopted.length)
					{
						fComplete();
						return;
					}
					this._attachAdoptedLabJoins(tmpAdopted, this._getTestInstances(pView, pInput, pRowIndex), () =>
					{
						const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
						const tmpInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
						this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpInstancesAddress, tmpAdopted);
						ScopedEntityData.beginProgrammaticLoad(this.pict);
						try
						{
							pView.setDataByInput(pInput, tmpHashes.join(','));
						}
						finally
						{
							ScopedEntityData.endProgrammaticLoad(this.pict);
						}
						fComplete();
					});
				});
			});
		});
	}

	/**
	 * The triple the form held before adoption for the same test: matched on the TestInstance id, then its GUID,
	 * then the Test.
	 *
	 * @param {Record<string, any>} pTriple - An adopted triple.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @return {Record<string, any>|null} - The held triple, or null.
	 */
	_findHeldTriple(pTriple, pHeldInstances)
	{
		const tmpTestInstance = (pTriple && pTriple.TestInstance) || { };
		const tmpHeld = (Array.isArray(pHeldInstances) ? pHeldInstances : [ ]).filter((pHeldTriple) => pHeldTriple && pHeldTriple.TestInstance && typeof pHeldTriple.TestInstance === 'object');
		const tmpMatchers =
		[
			(pHeldTriple) => Number(tmpTestInstance.IDTestInstance) > 0 && Number(pHeldTriple.TestInstance.IDTestInstance) === Number(tmpTestInstance.IDTestInstance),
			(pHeldTriple) => !!tmpTestInstance.GUIDTestInstance && pHeldTriple.TestInstance.GUIDTestInstance === tmpTestInstance.GUIDTestInstance,
			(pHeldTriple) => Number(tmpTestInstance.IDTest) > 0 && Number(pHeldTriple.TestInstance.IDTest) === Number(tmpTestInstance.IDTest),
		];
		for (const fMatches of tmpMatchers)
		{
			const tmpMatch = tmpHeld.find(fMatches);
			if (tmpMatch)
			{
				return tmpMatch;
			}
		}
		return null;
	}

	/**
	 * Give each adopted triple the lab join the database holds for its TestInstance, so the per-test lab selector
	 * reuses the persisted row rather than minting a new one the (TestInstance, Lab) unique key refuses. Where a
	 * TestInstance has several, the one on its own lab wins. With no live row the triple keeps the lab join the form
	 * held for that test, and a failed read keeps every held one.
	 *
	 * @param {Array<Record<string, any>>} pAdopted - The triples assembled from the database.
	 * @param {Array<Record<string, any>>} pHeldInstances - The triples the form held before adoption.
	 * @param {() => void} fDone - Called once, when every triple's lab join is settled.
	 */
	_attachAdoptedLabJoins(pAdopted, pHeldInstances, fDone)
	{
		const fCarryHeld = (pTriple) =>
		{
			const tmpHeld = this._findHeldTriple(pTriple, pHeldInstances);
			if (tmpHeld && tmpHeld._TestInstanceLabJoin && typeof tmpHeld._TestInstanceLabJoin === 'object')
			{
				pTriple._TestInstanceLabJoin = tmpHeld._TestInstanceLabJoin;
			}
		};
		let tmpSettled = false;
		const fSettle = () =>
		{
			if (tmpSettled)
			{
				return;
			}
			tmpSettled = true;
			fDone();
		};
		const tmpIDTestInstances = [ ...new Set(pAdopted.map((pTriple) => parseInt(pTriple.TestInstance.IDTestInstance, 10)).filter((pID) => pID > 0)) ];
		if (tmpIDTestInstances.length < 1)
		{
			pAdopted.forEach(fCarryHeld);
			return fSettle();
		}
		try
		{
			this.pict.HeadlightRestClient.getJSON(`TestInstanceLabJoins/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}`, (pError, pLabJoins) =>
			{
				try
				{
					if (pError || !Array.isArray(pLabJoins))
					{
						pAdopted.forEach(fCarryHeld);
						return;
					}
					const tmpRowsByTestInstance = { };
					for (const tmpRow of pLabJoins)
					{
						if (!tmpRow || !(Number(tmpRow.IDTestInstanceLabJoin) > 0) || typeof tmpRow.GUIDTestInstanceLabJoin !== 'string')
						{
							continue;
						}
						const tmpKey = parseInt(tmpRow.IDTestInstance, 10);
						tmpRowsByTestInstance[tmpKey] = tmpRowsByTestInstance[tmpKey] || [ ];
						tmpRowsByTestInstance[tmpKey].push(tmpRow);
					}
					for (const tmpTriple of pAdopted)
					{
						const tmpRows = tmpRowsByTestInstance[parseInt(tmpTriple.TestInstance.IDTestInstance, 10)] || [ ];
						if (tmpRows.length < 1)
						{
							fCarryHeld(tmpTriple);
							continue;
						}
						const tmpRow = tmpRows.find((pRow) => Number(pRow.IDLab) === Number(tmpTriple.TestInstance.IDLab)) || tmpRows[0];
						if (tmpRows.length > 1 && this.log && typeof this.log.warn === 'function')
						{
							this.log.warn(`MaterialsTestSelector: TestInstance ${tmpTriple.TestInstance.IDTestInstance} has ${tmpRows.length} lab joins; adopting ${tmpRow.IDTestInstanceLabJoin} (lab ${tmpRow.IDLab}).`);
						}
						tmpTriple._TestInstanceLabJoin =
						{
							IDTestInstanceLabJoin: Number(tmpRow.IDTestInstanceLabJoin),
							GUIDTestInstanceLabJoin: tmpRow.GUIDTestInstanceLabJoin,
							IDTestInstance: Number(tmpRow.IDTestInstance),
							IDLab: Number(tmpRow.IDLab),
						};
					}
				}
				catch (pError2)
				{
					pAdopted.forEach((pTriple) =>
					{
						if (!pTriple._TestInstanceLabJoin)
						{
							fCarryHeld(pTriple);
						}
					});
				}
				finally
				{
					fSettle();
				}
			});
		}
		catch (pError)
		{
			pAdopted.forEach(fCarryHeld);
			fSettle();
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		if (!this._isMultiple(pInput))
		{
			this._onRecordRefreshSingle(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
			return;
		}
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		if (!pRecord || (Array.isArray(pRecord) && pRecord.length === 0))
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, [ ]);
			libLabRouting.requestSampleLabSync(this.pict);
			pView.marshalToView();
			super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
			return;
		}
		let tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		if (!Array.isArray(tmpTestInstances))
		{
			if (tmpTestInstances)
			{
				this.log.error(`MaterialsTestSelectorInputType: TestInstances at address ${tmpTestInstancesAddress} is not an array`, { tmpTestInstances });
			}
			tmpTestInstances = [ ];
		}
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		tmpTestInstances = this._syncTestInstances(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpTestInstances, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress, tmpTestInstances);
		libLabRouting.requestSampleLabSync(this.pict);
		//TOOD: is this a good idea? this ensures any fields that use this record are updated immediately, if they are in the same section
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * Single-select (non-Multiple) record refresh. Writes the legacy singular TestInstance / DocumentPolyJoin /
	 * TestInstanceSampleJoin objects (one each) at the ${addr}_Instance / ${addr}_DocumentPolyJoin /
	 * ${addr}_SampleJoin addresses with un-suffixed GUIDs, matching the historical single-record data shape.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefreshSingle(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
		const tmpTestDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpTestAddress}_DocumentPolyJoin`;
		const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceSampleJoinAddress || `${tmpTestAddress}_SampleJoin`;
		if (!pRecord || (Array.isArray(pRecord) && pRecord.length === 0))
		{
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, { });
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, { });
			return;
		}
		const tmpTestHash = pRecord.Hash || '';
		const tmpSalt = this._getSalt(pView, pInput, pRowIndex);
		const tmpTest = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestAddress);
		//FIXME: do these need special tabular handling?
		let tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
		if (!tmpTestInstance || (typeof tmpTestInstance === 'object' && Object.keys(tmpTestInstance).length === 0))
		{
			tmpTestInstance = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceRecord ||
				{
					GUIDTestInstance: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI-${tmpSalt}`,
					IDTest: pRecord.IDTest,
				}));
			if (tmpTestInstance && typeof tmpTestInstance === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstance);
			}
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}
		}
		else
		{
			// Ensure GUID is set - use existing or generate new
			if (!tmpTestInstance.GUIDTestInstance)
			{
				tmpTestInstance.GUIDTestInstance = `${this.pict.parseTemplate('{~D:AppData.DocumentData.ReportData.GUIDDocument~}', this.pict)}-TI-${tmpSalt}`;
			}

			tmpTestInstance.IDTest = pRecord.IDTest;

			this._translateRecordTemplateFields(tmpTestInstance);
		}
		if (!tmpTestInstance.Name)
		{
			tmpTestInstance.Name = `Sample Test for ${tmpTestHash}`;
		}
		//NOTE: need to set this here in case it is used in the TestInstanceSampleJoin default record template
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);

		let tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress);
		// A held join with no RemoteType is a stub left by a clear; rebuild it rather than stamp it.
		if (!tmpDocumentPolyJoin || typeof tmpDocumentPolyJoin !== 'object' || !tmpDocumentPolyJoin.RemoteType)
		{
			tmpDocumentPolyJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultDocumentPolyJoinRecord ||
				{
					GUIDDocumentPolyJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TI_DPJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					RemoteType: 'TestInstance',
					IDDocument: `{~D:AppData.DocumentData.ReportData.IDDocument~}`,
					GUIDDocument: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}`,
					GUIDTestInstance: tmpTestInstance.GUIDTestInstance,
					_Dest_GUIDTestInstance: 'IDRemote',
				}));
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpDocumentPolyJoin);
			}
		}
		const tmpDocument = this.pict.AppData.DocumentData.ReportData;
		if (tmpDocument)
		{
			if (tmpDocument.IDDocument > 0)
			{
				tmpDocumentPolyJoin.IDDocument = tmpDocument.IDDocument;
				delete tmpDocumentPolyJoin.GUIDDocument;
			}
			else
			{
				tmpDocumentPolyJoin.GUIDDocument = tmpDocument.GUIDDocument;
				delete tmpDocumentPolyJoin.IDDocument;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestDocumentPolyJoinAddress, tmpDocumentPolyJoin);
		let tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!tmpTestInstanceSampleJoin || (typeof tmpTestInstanceSampleJoin === 'object' && Object.keys(tmpTestInstanceSampleJoin).length === 0))
		{
			tmpTestInstanceSampleJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultTestInstanceSampleJoinRecord ||
				{
					GUIDTestInstanceSampleJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-TISJ-${this._getSalt(pView, pInput, pRowIndex)}`,
				}));
			if (tmpTestInstance && tmpTestInstance.GUIDTestInstance)
			{
				if (tmpTestInstance.IDTestInstance > 0)
				{
					tmpTestInstanceSampleJoin.IDTestInstance = tmpTestInstance.IDTestInstance;
					delete tmpTestInstanceSampleJoin.GUIDTestInstance;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDTestInstance = tmpTestInstance.GUIDTestInstance;
				}
			}
			if (tmpSample && tmpSample.GUIDSample)
			{
				if (tmpSample.IDSample > 0)
				{
					tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				}
				else
				{
					tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
				}
			}

			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object')
			{
				this._translateRecordTemplateFields(tmpTestInstanceSampleJoin);
			}
			if (!tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin)
			{
				tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin = this.pict.getUUID();
			}
		}
		if (tmpTest && typeof tmpTest === 'object')
		{
			if (tmpTest.IDTest > 0)
			{
				tmpTestInstance.IDTest = tmpTest.IDTest;
				delete tmpTestInstance.GUIDTest;
			}
			else if (tmpTest.GUIDTest)
			{
				tmpTestInstance.GUIDTest = tmpTest.GUIDTest;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress, tmpTestInstance);
		//FIXME: should these use GUIDs to connect the records for offline? probably, but not sure how that'll work e2e
		if (tmpSample && typeof tmpSample === 'object')
		{
			if (tmpSample.IDSample > 0)
			{
				tmpTestInstanceSampleJoin.IDSample = tmpSample.IDSample;
				delete tmpTestInstanceSampleJoin.GUIDSample;
			}
			else if (tmpSample.GUIDSample)
			{
				tmpTestInstanceSampleJoin.GUIDSample = tmpSample.GUIDSample;
			}
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress, tmpTestInstanceSampleJoin);
		//TOOD: is this a good idea? this ensures any fields that use this record are updated immediately, if they are in the same section
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (!this._isScopedEntityDataEnabled())
		{
			this.pict.manifest.setValueAtAddress(this.pict, 'AppData.DocumentData.ReportData.FormData._EntityData', { });
		}
		const tmpEvent = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			this._sanitizeProjectedComprehensions();
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/**
	 * Project a TestInstance into the save-time comprehension with its TestResult held back. The result
	 * is staged when the user sets it (`_stageDeferredTestResult`), not from here. Both Test families
	 * route through the same primitive.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance record being projected.
	 * @param {Record<string, any>} pEntityData - The save-time `<Entity>.<GUID>` target.
	 */
	_projectTestInstanceDeferringResult(pTestInstance, pEntityData)
	{
		if (!ScopedEntityData.projectTestInstanceDeferringResult(pTestInstance, pEntityData))
		{
			this.pict.log.warn(`MaterialsTestSelector: could not project the test instance ${pTestInstance?.GUIDTestInstance}; it will not be saved.`);
		}
	}

	/**
	 * Stage the test result the user just entered for the workflow trigger that applies it
	 * (`PictForm.DeferredComprehensionContext`, default `OnEnteringState.Approved`).
	 *
	 * Staging happens at the edit rather than on the save sweep: the sweep writes what the form holds,
	 * which cannot tell a result the user cleared from one that was never entered, and would re-assert a
	 * standing leaf on every save. A cleared result stages as a clear — no result is a valid outcome.
	 *
	 * @param {Record<string, any>} pTestInstance - The TestInstance whose result changed.
	 * @param {Object} pInput - The form input descriptor.
	 * @return {boolean} - True when the result was staged.
	 */
	_stageDeferredTestResult(pTestInstance, pInput)
	{
		const tmpGUID = pTestInstance && pTestInstance.GUIDTestInstance;
		if (!tmpGUID)
		{
			this.pict.log.warn('MaterialsTestSelector: a test result changed on an instance with no GUIDTestInstance; it cannot be staged for approval.');
			return false;
		}
		const tmpDeferredContext = ScopedEntityData.resolveDeferredContext(pInput, this.options?.DeferredComprehensionContext);
		return ScopedEntityData.stageDeferredValue(this.pict, tmpDeferredContext, 'TestInstance', tmpGUID, 'TestResult', pTestInstance.TestResult);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpTestAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		if (!this._isMultiple(pInput))
		{
			const tmpTestInstanceAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instance`;
			const tmpTestInstance = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceAddress);
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoinAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_SampleJoin`;
			const tmpTestInstanceSampleJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstanceSampleJoinAddress);
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}
			return;
		}

		const tmpTestInstancesAddress = pInput.PictForm.TestInstanceAddress || `${tmpTestAddress}_Instances`;
		const tmpTestInstances = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpTestInstancesAddress);
		if (!Array.isArray(tmpTestInstances))
		{
			return;
		}
		for (const tmpTriple of tmpTestInstances)
		{
			if (!tmpTriple || typeof tmpTriple !== 'object')
			{
				continue;
			}
			const tmpTestInstance = tmpTriple.TestInstance;
			if (tmpTestInstance && typeof tmpTestInstance === 'object' && !Array.isArray(tmpTestInstance) && tmpTestInstance.GUIDTestInstance)
			{
				this._projectTestInstanceDeferringResult(tmpTestInstance, tmpEntityData);
			}

			const tmpTestInstanceSampleJoin = tmpTriple.TestInstanceSampleJoin;
			if (tmpTestInstanceSampleJoin && typeof tmpTestInstanceSampleJoin === 'object' && !Array.isArray(tmpTestInstanceSampleJoin) && tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin && ScopedEntityData.referencesSample(tmpTestInstanceSampleJoin))
			{
				if (!tmpEntityData.TestInstanceSampleJoin || typeof tmpEntityData.TestInstanceSampleJoin !== 'object' || Array.isArray(tmpEntityData.TestInstanceSampleJoin))
				{
					tmpEntityData.TestInstanceSampleJoin = { };
				}
				tmpEntityData.TestInstanceSampleJoin[tmpTestInstanceSampleJoin.GUIDTestInstanceSampleJoin] = tmpTestInstanceSampleJoin;
			}

			const tmpDocumentPolyJoin = tmpTriple.DocumentPolyJoin;
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin) && tmpDocumentPolyJoin.GUIDDocumentPolyJoin)
			{
				if (!tmpEntityData.DocumentPolyJoin || typeof tmpEntityData.DocumentPolyJoin !== 'object' || Array.isArray(tmpEntityData.DocumentPolyJoin))
				{
					tmpEntityData.DocumentPolyJoin = { };
				}
				tmpEntityData.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * @param {Record<string, any>} pRecord
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	_getRecordDisplayName(pRecord, pInput)
	{
		if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
		{
			return '#INVALID#';
		}
		if (!pRecord.Name)
		{
			if (pRecord.Description)
			{
				return pRecord.Description;
			}
			if (pRecord.Hash)
			{
				return `Test Code ${pRecord.Hash}`;
			}
			return `Unnamed Test #${pRecord.IDTest ?? '??'}`;
		}
		return pRecord.Name;
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'Hash', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			if (pFilters.length > 0)
			{
				pFilters.unshift('FOP~0~(~0');
				pFilters.push('FCP~0~)~0');
			}
			pFilters.push('FBV~Active~EQ~1');
			pFilters.push('FBV~Collection~EQ~0');
			return pFilters;
		};
	}
}

module.exports = MaterialsTestSelectorInputType;
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89,"./_LabRouting.js":159,"./_ScopedEntityData.js":162}],109:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MIXSPECIFICATION-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedMixSpecification.Code || 'N/A',
				this.pict.AppData.SelectedMixSpecification.Description || ('Unnamed MixSpecification #' + this.pict.AppData.SelectedMixSpecification.IDMixSpecification),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedMixSpecification.Description || ('Unnamed MixSpecification #' + this.pict.AppData.SelectedMixSpecification.IDMixSpecification);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the MixSpecification for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the MixSpecification record yet, get it and store it
			if (!this.pict.AppData.SelectedMixSpecification)
			{
				const tmpResult = await this.pict.providers.MixSpecificationProvider.getMixSpecificationByID(pValue);
				this.pict.AppData.SelectedMixSpecification = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],110:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MIXSPECIFICATION-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MIXSPECIFICATION-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('MixSpecification',
				{
					SearchFields: [ 'Code', 'Description' ],
					SearchFallbackPlaceholder: 'Select a Mix Specification by code or description...',
					GetRecordUserFacingID: (pMaterial) => pMaterial.ItemCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the MixSpecification for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected MixSpecification and set it as the selected MixSpecification on the data object
			const tmpMixSpecification = await this.pict.providers.MixSpecificationProvider.getMixSpecificationByID(pValue);
			this.pict.AppData.SelectedMixSpecification = tmpMixSpecification;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedMixSpecification.IDMixSpecification;
			tmpOption.text = `${this.pict.AppData.SelectedMixSpecification.Code || 'N/A'}|~|${this.pict.AppData.SelectedMixSpecification.Description || ('Unnamed MixSpecification #' + this.pict.AppData.SelectedMixSpecification.IDMixSpecification)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],111:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** HIGH-LEVEL NOTES ABOUT BEHAVIOR
 * FOR DATA MANAGEMENT:
 * 	- FOR NON-SETS (Document joined observations array, either in full, or filtered by some criteria such as type or label):
 * 		- The input hash stored is the namespace that is registered in the MediaRegistry for the set of observations that we want to display in the deck.
 *  	- If, we don't find a match for the namespace on load, we assume it's a new collection that needs to be created and we create a new namespace and store it.
 * 			- Attempt to apply any filters that were passed in through options to try to find a matching set of observations to display from the document collection - no results would show an empty message.
 * 		- Else, if not filters are set, then we fallback to all document observations case, where we just display all image observations that are associated with the document in the deck.
 * 			- Additionally, there is an "excludeObservationSets" option that can be set to exclude any observations that are part of an observation set from being displayed in the deck (the "negative"/"orphan" set case).
 * 	- FOR OBSERVATION-SETS (Records in the database that are bound to IDObservationSet values):
 * 		- The IDObservationSet is stored as the value of the hidden input (either by default value, by new creation on first addition, or by selector choice)
 * 		and the namespace for that observation set is stored in the dynamic GUID map for the input hash so that we can look up the relevant observations to display in the deck.
 * FOR INTERACTIVE RENDERING:
 * - The deck layout can be configured through options, and can support different display styles such as 'thumbnail', or 'list'.
 * - We will support two types of display (but only need thumbnail/list for V1, the others are for future use):
 *  - Thumbnail: The default view which is basically the same Observation Image Set template layout we've had before.
 *  - List: The list layout of the observations, which can be useful for displaying more details about each observation in a more compact format. Makes reordering vertical instead of horizontal.
 *  - Details: shows a "media card" for each observation in the set, which can display more information and metadata about the observation in a more visually appealing way. This can be useful for observations that have rich media or a lot of details to show.
 * FOR PRINT RENDERING:
 * - In print mode, we support all the previous templates through the Media Card Builder, including "minimalist", "embed", and "default" layouts, which can be configured through options.
 * - The "embed" layout will attempt to embed the actual media content directly in the card for supported types such as images and PDFs, which can be useful for users who want to see the content of the media directly in print without having to go to a separate media section or open each media item individually.
 * FUTURE PROOFING:
 *  - Would like to make this work for ANY observation type, not locked down to Media types - could provide observation editing through modals.
*/

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const MediaCardBuilder = require('./../../../media-detail-cards/source/MediaCardBuilder.js');
const libUserMarkdown = require('./_UserMarkdown.js');

class ObservationCardDeck extends PictSectionInputExtension
{
	/**
	 * @param {Object} pFable - The Fable application instance.
	 * @param {Object} pOptions - The provider options.
	 * @param {string} pServiceHash - The service hash for this provider registration.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pdfjsLib = null;
		// commonly used DOM markers for the deck elements and cards within the deck to make it easier to manage the DOM manipulation for the deck
		this.cardClassName = 'observation-card';
		this.cardAttributeId = 'data-observation-id';
		this.deckClassName = 'observation-card-deck';
		this.deckIsDocumentListAttribute = 'data-deck-is-full-document-list';
		this.deckIsExcludedSetAttribute = 'data-deck-is-excluding-observation-sets';
		this.deckIsFilteredDocumentListAttribute = 'data-deck-is-filtered-document-list';
		this.deckIsObservationSetAttribute = 'data-deck-is-observation-set';
		this.deckInputHashAttribute = 'data-input-hash';
		this.deckViewHashAttribute = 'data-view-hash';
		this.packageTypeSelectorMap = {
			'AllDocumentLists': `.${this.deckClassName}[${this.deckIsDocumentListAttribute}="true"]`, // this includes all filtered lists and 'AllNegativeDocumentLists' since those are subsets of the document lists, aka, everthing NOT an Observation Set
			'AllNegativeDocumentLists': `.${this.deckClassName}[${this.deckIsExcludedSetAttribute}="true"]`,
			'AllObservationSets': `.${this.deckClassName}[${this.deckIsObservationSetAttribute}="true"]`,
		};
		// observation types that are considered "actionable" for filtered decks — quick capture and upload always produce one of these types,
		// so decks filtered by these types can safely allow Add/Remove/QuickCapture actions
		this.actionableObservationTypes = [ 'Legacy Image', 'Legacy Video', 'Legacy Audio', 'File' ];
		// additional options that only this provider should be providing (not configurable by users) that are necessary for the functionality of the deck and to manage some of the edge cases with the deck content and rendering
		this.cacheBusterAttemptTimers = [ 5000, 20000 ];
		// print rendering has no other backstop: the rasterizer only force-terminates the whole page. This bounds each
		// INDIVIDUAL pdf.js operation (document load, page load, page raster) so a stalled artifact cannot hang the
		// document. It is deliberately not a per-attachment budget — total time must stay free to scale with page count.
		this.embeddedPDFOperationTimeoutMS = 30000;
		// print rendering waits on the creator-name lookup (resolveCreatorNamesForDeck), so bound it too
		this.creatorNameLookupTimeoutMS = 10000;
		this.customCSSInjected = false;
		this.draggableConfigurationForDeck = {};
		// default options for the deck, can be overridden by passing in options through the Pict descriptor configuration for the input, or through the observation set configuration if using observation sets to manage the deck content
		this.defaultConfiguration = {
			appendNewCardToStartOfDeck: false, // option to append new cards to the start of the deck instead of the end when they are added (e.g. through quick capture or other means)
			customEmptyStateMessage: 'No items have been added to this collection.',
			customEmptyStateMessageForPrint: 'No items to display.', // option to set a custom empty state message for print view that is different from the interactive view message, which can be useful if the default message doesn't make sense in the context of printing or if we want to provide more specific instructions for users in print view
			customIconClassForQuickCaptureButton: '', // option to set a custom icon class for the quick capture button (e.g. "fa-camera" or "fas fa-camera"), if not set, it will default to a camera circle icon
			customTextForQuickCaptureButton: '', // option to set custom text for the quick capture button, if not set, it will default to "Quick Capture"
			deckLayout: 'thumbnail', // default layout style for the deck (can be 'thumbnail', 'list', or 'details')
			deckLayoutForPrint: 'default', // default layout style for the deck in print view (can be 'default', or 'minimalist' for a more compact card style)
			preventEmbeddingPDFsForPrint: false, // when true, prevents PDFs from being embedded (rendered page-by-page via pdf.js) in the deck in print view — by default PDFs are embedded so users can see the content directly in the printed output without navigating to a separate media section
			excludeObservationSets: false, // option to exclude observations that are part of an observation set from being displayed in the deck (only applicable when not using observation sets to manage the deck content)
			alwaysExcludeObservationSets: false, // when true, forces excludeObservationSets to always be active and disables the user toggle — used for decks that structurally represent the orphan/negative set (e.g. Inspection Photos)
			hideIndexTags: false, // option to hide the index tags that show up on top of the card thumbnails
			hideFiltersInHeader: false, // option to hide the filter tags in the header of the deck
			hideQuickCapture: false, // option to hide the quick capture button for adding new observations to the deck
			indexTagScope: 'local', // option to configure the scope of the index tags on card - can be "local" (default) or "document" (note: "global" might eventually be a third option later if we have a server provided index that is consistent across all clients)
			preventAddingCards: false, // flag to prevent adding new cards to the deck when true (used for print view and can be configured for interactive view as well through options)
			preventCrossDeckDragging: true, // (TODO: FALSE is not implimented yet!) flag to prevent dragging and dropping cards between different decks (true until we can account for filtering)
			preventReorderingCards: false, // flag to prevent reordering of cards in the deck when true (used for print view and can be configured for interactive view as well through options)
			preventRemovingCards: false, // flag to prevent removing cards from the deck when true (used for print view and can be configured for interactive view as well through options)
			sortOrder: 'custom', // use the media registry by default (for now)
			useObservationSet: false, // flag to indicate whether we are using Observation Sets to manage the observations in the deck, or if we are just using a flat list of observations from the MediaRegistry
			useObservationSetSelector: false, // flag to indicate whether to show the observation set selector in the header of the deck when using observation sets to manage the content in the deck
			requireExplicitSetCreation: false, // when true (and useObservationSetSelector is true), the deck will NOT auto-create a set on Add/QuickCapture clicks — the user must explicitly create a set via "Create New Set" first, and Add/QuickCapture buttons are hidden until a set is selected
			filters: { Include: {}, Exclude: {} }, // default filters for the deck, used to filter observations displayed based on different criteria such as observation type, label types, etc.
		};
		// default options for when we were routed here from an old "ObservationImageSet", "ObservationStandardSet", or "MediaDetailCards" InputType with legacy configuration options that we want to attempt to map to the new configuration options for the deck to preserve backwards compatibility with existing forms that use those input types
		this.patchedConfiguration = {
			ObservationCardDeck: {}, // this is just a placeholder to make it easier to check
			ObservationImageSet: {
				deckLayout: 'thumbnail',
				useObservationSet: true,
				useObservationSetSelector: false,
				filters: { Include: { ObservationTypes: [ 'Legacy Image', 'File' ] } },
			},
			// "ObservationSet" is the MTIWHA InputType name (maps to InputType-ObservationSet.js template);
			// "ObservationStandardSet" is the provider name (PictProvider-InputType-ObservationStandardSet.js).
			// Both aliases are needed because pInput.PictForm.InputType can be either value depending on context.
			ObservationSet: {
				deckLayout: 'thumbnail',
				useObservationSet: true,
				useObservationSetSelector: true,
				requireExplicitSetCreation: true,
				filters: { Include: { ObservationTypes: this.actionableObservationTypes } },
			},
			ObservationStandardSet: {
				deckLayout: 'thumbnail',
				useObservationSet: true,
				useObservationSetSelector: true,
				requireExplicitSetCreation: true,
				filters: { Include: { ObservationTypes: this.actionableObservationTypes } },
			},
			// "MediaDetailCards" is the legacy InputType that previously had its own provider and template.
			// It now routes through ObservationCardDeck via template redirect (same pattern as ObservationImageSet).
			// (Note: an earlier "MediaCards" entry existed here by mistake — no form ever used that InputType name.)
			MediaDetailCards: {
				deckLayout: 'details',
				useObservationSet: false,
				useObservationSetSelector: false,
				excludeObservationSets: false,
				filters: { Include: { ObservationTypes: this.actionableObservationTypes } },
			},
		};
		/** @type {Pict} */
		this.pict;
		this.pict.TemplateProvider.addTemplate('Observation-Description-Popover', /*html*/`<div class="px-2 py-1">{~D:Record.Description~}</div>`);
		this.pict.AppData.ObservationCardDeckProvider =
		{
			dynamicGUIDMap: {}, // separate map to store dynamic GUIDs for each input hash for better management and to avoid conflicts with the main GUID map used for other purposes in the application
			dynamicSettingsMap: {}, // separate map to store dynamic settings (including filters) for each input hash
			customHandleObservationSetCreateSetButtonClick: null, // custom handler for the create set button, set via setCustomHandleObservationSetCreateSetButtonClick()
			customOnAfterObservationSetCreated: null, // callback invoked after a new observation set is created via the modal (receives: pSavedSet, pInput)
			customOnAfterObservationSetChanged: null, // callback invoked after an observation is added to or removed from an observation set (receives: pInput, pIDObservation, pObservationSet)
			documentContextCallback: null, // callback invoked after observation set content changes for broader document-level side effects (e.g. orphan observation recalculation)
			customHandleSearchFiltersForSelector: null, // optional custom filter callback for the set selector's Select2 AJAX query (receives: pFilters[], returns: pFilters[])
			customOnAfterMarshal: null, // callback invoked after the CardDeck finishes marshalling and rendering cards for an input (receives: pInput, pObservationList)
			settingsOverridesByInputAddress: {}, // map of input Address → CardDeckSettings overrides, merged in setCurrentSettingsForInput after pSettings but before persisted overrides
			documentScopeEmptyState: false, // flag set by the custom search filter when document scope is active but no sets exist yet — used by processResults to show a contextual empty message
			userNameCache: {}, // map of IDUser → display name, populated by resolveCreatorNamesForDeck() for the details view and print cards
		};
		// fallback in-memory store for user-toggled overrides (e.g. excludeObservationSets) used when no FormData root is available yet.
		// The persisted store lives at FormData.ObservationCardDeckOverrides so it survives save/reload alongside MediaRegistryStore.
		this._inMemoryOverridesStore = {};
		// cache of IDObservationSet → saved Name, populated lazily on first header render.
		// Values are Promises while the fetch is in flight, then resolved strings, so concurrent callers share a single request.
		/** @type {Object<string, string|Promise<string>>} */
		this._observationSetNameCache = {};
		// caches for managing the state of the deck content and rendering to account for some of the edge cases with the deck such as multiple decks on the same form,
		// multiple views with the same deck, and keeping the content up to date when changes are made to the observations in the document through other means outside of the deck (e.g. through the observation panels, quick capture, etc.)
		/**
		 * @type {Promise<any>[]}
		 */
		this.renderPromises = [];
		/**
		 * @type {Promise<any>[]}
		 */
		this.marshalPromises = [];
		this._isRemarshalInProgress = false;
		this._previousObservationSetIDs = {};
		/**
		 * @type {any[]}
		 */
		this.registeredDependencyInputHashList = [];
		// tracks Add/QuickCapture buttons that have been put into an `is-loading` state pending the
		// completion of a panel-driven add flow. If the user dismisses the panel without completing
		// the flow (X button, escape, background click, etc.), the panel's closeHandler calls
		// clearPendingAddButtonLoadingState() to ensure these don't get stuck in the loading state.
		/** @type {Set<HTMLElement>} */
		this._pendingAddButtonElements = new Set();
		// Per-input re-entrancy guard for the async print-view deck build (buildCardDeckCardsForPrintView).
		// The form solve/marshal cycle can invoke the build more than once for the same input during a single
		// PDF render; because the build awaits pdf.js, overlapping runs would interleave their appends and
		// duplicate embedded PDFs. This flag lets a build-in-flight short-circuit later overlapping calls.
		/** @type {Object<string, boolean>} */
		this._printBuildInFlight = {};
	}

	/**
	 * Whether the current document is locked (read-only).
	 * @returns {boolean}
	 */
	get isDocumentLocked()
	{
		return !!this.pict.AppData?.DocumentData?.ReportData?.Locked;
	}

	/**
	 * Whether the current user has edit permissions on the document.
	 * @returns {boolean}
	 */
	get canEditDocument()
	{
		return !!this.pict.AppData?.DocumentData?.ReportData?.CanEdit;
	}

	/**
	 * Returns the root object used to persist user-toggled deck overrides across save/reload.
	 * Lives under FormData (like MediaRegistryStore) so it is saved with the document, and falls back to an
	 * in-memory object when no FormData root is available (e.g. unit tests, pre-document-init bootstrap).
	 * @returns {Object} - The persisted override store object, keyed by input hash.
	 */
	getPersistedOverridesStore()
	{
		const formData = this.pict.AppData?.DocumentData?.ReportData?.FormData;
		if (!formData)
		{
			return this._inMemoryOverridesStore;
		}
		if (!formData.ObservationCardDeckOverrides)
		{
			formData.ObservationCardDeckOverrides = {};
		}
		return formData.ObservationCardDeckOverrides;
	}

	/**
	 * Returns the persisted overrides for a given input (or null if none saved).
	 * @param {Object} pInput - The input object (used to access the input hash).
	 * @returns {Object|null}
	 */
	getPersistedOverridesForInput(pInput)
	{
		const store = this.getPersistedOverridesStore();
		return store[pInput.Hash] || null;
	}

	/**
	 * Writes a single override key/value to the persisted overrides store for a given input.
	 * @param {Object} pInput - The input object (used to access the input hash).
	 * @param {string} pOverrideKey - The override field name (e.g. 'excludeObservationSets').
	 * @param {any} pOverrideValue - The override value to persist.
	 */
	setPersistedOverrideForInput(pInput, pOverrideKey, pOverrideValue)
	{
		const store = this.getPersistedOverridesStore();
		if (!store[pInput.Hash])
		{
			store[pInput.Hash] = {};
		}
		store[pInput.Hash][pOverrideKey] = pOverrideValue;
	}

	getHiddenInputHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}
	getLabelHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#LABEL-FOR-${pInputHTMLID}`;
	}
	getCardDeckContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-CONTAINER-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderFilterContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-FILTERS-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderExcludeObservationSetHiddenInputHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetSelectorContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-CONTAINER-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetCreateButtonHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-CREATE-BUTTON-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetEditButtonHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#EDIT-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetSelectorHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderObservationSetDisplayHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-${pInputHTMLID}`;
	}
	getCardDeckContentHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-CONTENT-FOR-${pInputHTMLID}`;
	}
	getCardDeckContainerEmptyMessageHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#EMPTY-MESSAGE-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderActionsContainerHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-ACTIONS-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderActionsButtonAddHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-ACTIONS-ADD-BUTTON-FOR-${pInputHTMLID}`;
	}
	getCardDeckHeaderActionsButtonQuickCaptureHTMLID(/** @type {string} */ pInputHTMLID)
	{
		return `#CARD-DECK-HEADER-ACTIONS-QUICK-CAPTURE-BUTTON-FOR-${pInputHTMLID}`;
	}

	/**
	 * Updates the text content of the empty message element for a given input's card deck.
	 * @param {Object} pInput - The input object.
	 * @param {string} pMessage - The message to display.
	 */
	updateEmptyMessageText(pInput, pMessage)
	{
		const emptyMessageElement = document.querySelector(this.getCardDeckContainerEmptyMessageHTMLID(pInput.Macro.RawHTMLID));
		if (emptyMessageElement)
		{
			const textSpan = emptyMessageElement.querySelector('.icon-text');
			if (textSpan)
			{
				textSpan.textContent = pMessage;
			}
		}
	}

	/**
	 * Function to build a consistent namespace string for a card deck based on input hash, observation set ID, and whether it is temporary.
	 * @param {string} pInputHash - The hash of the input element.
	 * @param {string|number|null} [pIDObservationSet=null] - The ID of the observation set, if applicable.
	 * @param {boolean} [isTemporary=false] - Flag indicating if the card deck is temporary - for Observation Set that have not yet been saved (we only save a new pristine set up user action taken, not form load).
	 * @returns {string} - The constructed namespace string or an error string if inputs are invalid.
	 */
	buildNamespaceForCardDeck(pInputHash, pIDObservationSet = null, isTemporary = false)
	{
		if (isTemporary && !pIDObservationSet)
		{
			return `TEMP-CardDeck-For-IDObservationSet-${pInputHash}`;
		}
		else if (pIDObservationSet)
		{
			return `CardDeck-For-IDObservationSet-${pIDObservationSet}`;
		}
		else if (pInputHash)
		{
			return `CardDeck-For-${pInputHash}`;
		}
		else
		{
			this.pict.log.error(`Cannot build namespace for card deck without either a valid input hash or IDObservationSet. Received input hash: ${ pInputHash }, IDObservationSet: ${ pIDObservationSet }, isTemporary: ${ isTemporary }`);
			return 'ERROR-Invalid-Namespace-For-CardDeck';
		}
	}

	/**
	 * Drains a queue of promises, logging any errors, then empties the queue.
	 * @param {Promise<any>[]} queue - The promise queue to drain.
	 * @param {string} label - A label for error messages to identify which queue failed.
	 */
	async _drainPromiseQueue(queue, label)
	{
		for (const p of queue)
		{
			try
			{
				await p;
			}
			catch (error)
			{
				this.pict.log.error(`Error in ${label}: ${ error }`);
			}
		}
		queue.length = 0;
	}

	/**
	 * Function that can be awaited by other functions to ensure that this input type has finished rendering.
	 */
	async completeRender()
	{
		await this._drainPromiseQueue(this.renderPromises, 'PictProvider-InputType-ObservationCardDeck');
	}

	/**
	 * Function that can be awaited to ensure that all pending marshal operations (triggered by reMarshalAllViewsWithCardDecks) have completed.
	 * This is used to serialize view refreshes so that multiple card deck instances don't race over shared state.
	 */
	async waitForPendingMarshals()
	{
		await this._drainPromiseQueue(this.marshalPromises, 'pending marshal');
	}

	/**
	 * This is a callback for external functions to call when they want to trigger a refresh of the card decks that are displaying a specific observation,
	 * such as when an observation is added or removed from the document through other means outside of the deck (e.g. through the observation panels, quick capture, etc.)
	 * to ensure that the content in the deck stays up to date and reflects the current state of the document.
	 * @param {string} pIDObservation - The ID of the observation that was added, removed, or updated.
	 * @param {string} action - The type of action that triggered the refresh, which can be 'add', 'remove', or 'update', and can be used to determine how to refresh the deck content (e.g. whether to add a new card, remove an existing card, or update the content of an existing card).
	 * @param {any[]} pUpdatedObservationList - The updated list of observations in the document, used to refresh the deck content accurately.
	 * @param {string} source - The source of the action that triggered the refresh, which can be used for logging or to determine if certain decks should be refreshed based on where the action originated from (e.g. if the action came from the observation panels, we might want to refresh all decks, but if it came from a specific deck, we might only want to refresh that deck).
	 * @return {Promise<void>}
	 */
	async refreshCardDecks(pIDObservation, action, pUpdatedObservationList, source)
	{
		if (!this.pict.AppData?.DocumentData)
		{
			this.pict.log.warn('No document data found. Skipping refreshCardDecks.');
			return;
		}
		if (this.isDocumentLocked)
		{
			this.pict.log.warn('Document is locked. Skipping refreshCardDecks.');
			return;
		}
		// we need basic info to even attempt to find the cards to update, so if we don't have that, we should log a warning and exit the function to avoid unnecessary processing and potential errors
		if (!pIDObservation || !action || !source)
		{
			this.pict.log.warn(`refreshCardDecks called with invalid parameters. pIDObservation: ${pIDObservation}, action: ${action}, pUpdatedObservationList: ${pUpdatedObservationList}, source: ${source}`);
			return;
		}
		if (!pUpdatedObservationList || !Array.isArray(pUpdatedObservationList))
		{
			this.pict.log.warn(`refreshCardDecks called without a valid updated observation list. This should be the latest state of the DocumentRecord.Observations array.`);
			return;
		}
		// make sure we're using the latest list of observations from the document to ensure that any changes are reflected accurately in the deck content
		this.pict.AppData.DocumentData.ReportData.Observations = pUpdatedObservationList;
		await this.pict.providers.MediaRegistry.refreshDocumentObservations(pUpdatedObservationList);
		// refresh both document-list decks and observation-set decks, since an add/remove action can affect either type
		await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllDocumentLists', true);
		await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllObservationSets', true);
		return;
	}

	/**
	 * Function to register a promise that pdf rendering depends on.
	 * @param {Promise<any>} dependency - The promise we want to add to the dependency set.
	 */
	registerRenderDependency(dependency)
	{
		if (!this.pict.AppData.Interactive && dependency instanceof Promise)
		{
			this.renderPromises.push(dependency);
		}
	}

	/**
	 * Function to remove the initial loading message from the deck elements once content is loaded (we default to showing a loading message on the empty container message that is displayed when the deck is empty or prior to content being loaded).
	 * @param {Object} pInput - The input object containing the deck elements.
	 * @param {Object} pInput.Macro - The macro object for the input, which contains the raw HTML ID used to find the relevant deck content area element in the DOM to remove the loading message from.
	 * @param {string} pInput.Macro.RawHTMLID - The raw HTML ID of the input, used to find the relevant deck content area element in the DOM to remove the loading message from.
	 */
	removeInitialLoadingMessage(pInput)
	{
		const cardDeckContentAreaHTMLID = this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID);
		const cardDeckContentAreaElement = document.querySelector(cardDeckContentAreaHTMLID);
		if (cardDeckContentAreaElement)
		{
			const loadingMessageElement = cardDeckContentAreaElement.querySelector('.initial-loading-message');
			if (loadingMessageElement)
			{
				loadingMessageElement.remove();
			}
		}
	}

	/**
	 * Parse the legacy "key:value,key:value" string from PictForm.InputExtra into an options object
	 * for MediaCardBuilder. Carried over from the removed MediaDetailCards provider so legacy form
	 * configs (cardTheme, cardSize, ordinalScope, etc.) still flow through on print.
	 * @param {string} pInputExtraString - The stringy configuration data from the PictForm.InputExtra field
	 * @return {Object} - The processed configuration options
	 */
	processPictDescriptorConfigurationOptions(pInputExtraString)
	{
		if (!pInputExtraString || pInputExtraString.length === 0)
		{
			return {};
		}
		const newConfigOptions = {};
		const tmpConfig = pInputExtraString.split(',').map((item) => item.trim());
		tmpConfig.forEach((item) =>
		{
			const [ key, value ] = item.split(':').map((part) => part.trim());
			if (key && value)
			{
				if (value === 'true' || value === 'false')
				{
					newConfigOptions[key] = value === 'true';
				}
				else
				{
					newConfigOptions[key] = value;
				}
			}
		});
		return newConfigOptions;
	}

	/**
	 * Function to handle rendering of the deck in print view for variable templates. In print view, we want to render the content of the deck in a way that is optimized for printing,
	 * which may include showing more details about each observation and adjusting the layout to fit better on a printed page. We will also hide interactive elements such as buttons
	 * and popovers in print mode. The rendering logic will adjust based on the selected layout style for print view, which can be configured through options.
	 *
	 * TODO: Rename this to "ObservationCardPrintBuilder" (or similar) and refactor to support any observation type —
	 *       non-media observations should render with thumbnail placeholders rather than being filtered out by
	 *       curateMediaObservationList. This would replace the prevention logic added for non-media types and let the
	 *       print builder be a general-purpose observation card renderer. Deferring until current fixes are shipped.
	 *       When this refactor happens, also update the bridge element conditions provider's _hasRenderableMediaArtifact()
	 *       filter in bridgeinspection-elementconditions-provider.js to align with the builder's acceptance logic.
	 *
	 * @param {Object} pView - the view object for the input, which contains information about the current view and can be used to determine if we are in print view or not
	 * @param {Object} pInput - the input object for which we are rendering the deck, which contains information about the input and can be used to get the current settings and filters for the deck
	 * @param {string} pNamespace - the namespace for the deck content, which can be used to look up the relevant observations from the MediaRegistry to display in the deck
	 * @param {any[]} pObservationList - the list of observations to be rendered in the deck, which can be filtered and sorted based on the current settings and filters for the deck
	 */
	async buildCardDeckCardsForPrintView(pView, pInput, pNamespace, pObservationList)
	{
		// Re-entrancy guard. The form's solve/marshal cycle can call this multiple times for the same input
		// during one PDF render. The build is async (pdf.js rasterizes embedded PDFs page-by-page), so
		// overlapping runs each clear-then-append and interleave their canvases — duplicating embedded PDFs
		// in the output. While a build for this input is in flight, skip later overlapping calls: print data
		// is static, so the in-flight build already reflects the final content. (Interactive mode doesn't need
		// this because buildObservationCardDeck reconciles via a DOM diff instead of appending.)
		if (this._printBuildInFlight[pInput.Hash])
		{
			return;
		}
		this._printBuildInFlight[pInput.Hash] = true;
		try
		{
			await this._buildCardDeckCardsForPrintView(pView, pInput, pNamespace, pObservationList);
		}
		finally
		{
			this._printBuildInFlight[pInput.Hash] = false;
		}
	}

	/**
	 * Inner implementation of the print-view deck build. Always invoke via buildCardDeckCardsForPrintView,
	 * which guards against re-entrant/overlapping builds for the same input.
	 * @param {Object} pView - the view object for the input
	 * @param {Object} pInput - the input object for which we are rendering the deck
	 * @param {string} pNamespace - the namespace for the deck content
	 * @param {any[]} pObservationList - the list of observations to be rendered in the deck
	 */
	async _buildCardDeckCardsForPrintView(pView, pInput, pNamespace, pObservationList)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const displayStyle = currentSettings?.deckLayoutForPrint || 'default';
		const cardDeckContentAreaHTMLID = this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID);
		const cardDeckContentAreaElement = document.querySelector(cardDeckContentAreaHTMLID);
		// if we can't find the container element for the deck, we have a problem and can't render the deck, so we should log an error and bail out of the function to avoid further issues
		if (!cardDeckContentAreaElement)
		{
			this.pict.log.error(`Card deck container not found for HTML ID: ${cardDeckContentAreaHTMLID}`);
			return;
		}
		// Reset the content area before (re)building. Unlike the interactive buildObservationCardDeck (which diffs cards
		// against the DOM and is idempotent), the print builder only appends — so a second marshal pass during PDF
		// generation would otherwise tack on a duplicate copy of every card / embedded PDF.
		cardDeckContentAreaElement.innerHTML = '';
		// Determine whether PDFs should be fully embedded (rendered page-by-page via pdf.js).
		// By default PDFs are embedded unless the form explicitly opts out via preventEmbeddingPDFsForPrint.
		// The minimalist layout always embeds regardless of the setting.
		const willEmbedPDFs = !currentSettings?.preventEmbeddingPDFsForPrint || displayStyle === 'minimalist';
		const embeddedPDFIds = new Set(
			willEmbedPDFs ?
				pObservationList
					.filter((/** @type {any} */ o) => o?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf')
					.map((/** @type {any} */ o) => o.IDObservation) :
				[],
		);

		// Shared config for building thumbnail cards via MediaCardBuilder
		const pictConfigOptions = this.processPictDescriptorConfigurationOptions(pInput?.PictForm?.InputExtra || '');
		const blendedConfigOptions = { ...{
			cardTheme: pictConfigOptions?.cardTheme || displayStyle,
			cardSize: pictConfigOptions?.cardSize || (displayStyle === 'minimalist' ? 'half' : ''),
			ordinalScope: pictConfigOptions?.ordinalScope || (displayStyle === 'minimalist' ? 'global' : ''),
			landscapeMode: this.pict.AppData?.DocumentData?.ReportData?.ReportOptions?.Meta?.orientation === 'landscape',
			isPrintView: !this.pict.AppData.Interactive,
			// cached creator names render directly; the rest are back-filled by resolveCreatorNamesForDeck
			userNameMap: this.pict.AppData.ObservationCardDeckProvider.userNameCache,
			// Disable the default DesignatedTime sort inside MediaCardBuilder.buildCards() so that the
			// user's saved drag/reorder sequence (already reflected in pObservationList) is preserved.
			// Without this, curateMediaObservationList re-sorts the batch by date and destroys the custom order.
			sortBy: null,
			sortOrder: null,
		}, ...pictConfigOptions };

		// Walk observations IN ORDER so that embedded PDFs and thumbnail cards are interleaved
		// at their correct positions — preserving the user's custom sort/drag order.
		let thumbnailBatch = [];
		let batchIndex = 0;

		/**
		 * Flush any accumulated thumbnail-card observations into a wrapper div appended to the container.
		 * Uses MediaCardBuilder.buildCards with a temporary target element.
		 */
		const flushThumbnailBatch = () =>
		{
			if (!thumbnailBatch.length)
			{
				return;
			}
			const batchWrapper = document.createElement('div');
			const batchId = `${pInput.Macro.RawHTMLID}-print-batch-${batchIndex++}`;
			batchWrapper.id = batchId;
			cardDeckContentAreaElement.appendChild(batchWrapper);
			const mediaCardBuilder = new MediaCardBuilder();
			mediaCardBuilder.buildCards(thumbnailBatch, { ...blendedConfigOptions, target: batchId });
			thumbnailBatch = [];
		};

		for (const obs of pObservationList)
		{
			if (embeddedPDFIds.has(obs.IDObservation))
			{
				// Flush any preceding thumbnail cards before inserting the embedded PDF
				flushThumbnailBatch();
				await this.buildEmbeddedPDFsForPrintView([ obs ], cardDeckContentAreaElement);
			}
			else
			{
				thumbnailBatch.push(obs);
			}
		}
		// Flush any remaining thumbnail cards after the last embedded PDF
		flushThumbnailBatch();
	}

	/**
	 * Races a promise against a timeout so a stalled dependency cannot hang print rendering indefinitely.
	 *
	 * @param {Promise<any>} pPromise - The promise to bound.
	 * @param {number} pTimeoutMS - Milliseconds to wait before rejecting.
	 * @param {string} pLabel - Description of the awaited work, used in the timeout message.
	 * @return {Promise<any>} - The promise result, or a rejection if the timeout elapsed first.
	 */
	async _withTimeout(pPromise, pTimeoutMS, pLabel)
	{
		let tmpTimeoutID;
		try
		{
			return await Promise.race(
				[
					pPromise,
					new Promise((resolve, reject) =>
					{
						tmpTimeoutID = setTimeout(() => reject(new Error(`${pLabel} timed out after ${pTimeoutMS} ms.`)), pTimeoutMS);
					}),
				]);
		}
		finally
		{
			clearTimeout(tmpTimeoutID);
		}
	}

	/**
	 * Builds the print-view stand-in shown where an embedded PDF could not be rendered, so a missing
	 * attachment is visible in the printed output rather than silently absent.
	 *
	 * @param {string} pObservationName - Display name of the observation the attachment belongs to.
	 * @param {number} [pRenderedPageCount] - Pages that rendered before the failure, so a partial embed reads correctly.
	 * @return {HTMLDivElement} - The placeholder element.
	 */
	buildEmbeddedPDFErrorPlaceholder(pObservationName, pRenderedPageCount)
	{
		const tmpContainer = document.createElement('div');
		tmpContainer.style['break-inside'] = 'avoid';
		tmpContainer.style['margin-bottom'] = '10px';
		tmpContainer.style['padding'] = '10px';
		tmpContainer.style['border'] = '2px solid grey';
		const tmpLabel = document.createElement('b');
		tmpLabel.style.fontSize = '15px';
		tmpLabel.textContent = pRenderedPageCount > 0 ?
			`Observation: ${ pObservationName } - the remaining pages of this attachment could not be displayed.` :
			`Observation: ${ pObservationName } - attachment could not be displayed.`;
		tmpContainer.appendChild(tmpLabel);
		return tmpContainer;
	}

	/**
	 * Resolve pdf.js on first use. Only the PDF templates load it, so the interactive form never pays for it.
	 * @returns {any} the pdf.js library, or null when the page did not load it
	 */
	resolvePDFJS()
	{
		// @ts-ignore
		const tmpPDFJS = globalThis.pdfjsLib;
		if (!this.pdfjsLib && tmpPDFJS)
		{
			tmpPDFJS.GlobalWorkerOptions.workerSrc = './pdfjs-dist/build/pdf.worker.mjs';
			this.pdfjsLib = tmpPDFJS;
		}
		return this.pdfjsLib;
	}

	/**
	 * Function to build embedded PDFs in the deck for print view when the deck is configured to embed PDFs directly in print view instead of linking to them.
	 * @param {any[]} pdfs - the list of observation objects whose files are PDFs to be embedded into the print view
	 * @param {Element} containerElement - the container element for the deck content area where the embedded PDFs will be rendered
	 */
	async buildEmbeddedPDFsForPrintView(pdfs, containerElement)
	{
		if (!this.resolvePDFJS())
		{
			throw new Error(`Currently the ObservationCardDeck InputType provider requires pdfjs to be loaded in the DOM, but it isn't.`);
		}
		if (!pdfs.length || !containerElement)
		{
			return;
		}
		const embedTemplate = document.createElement('div');
		for (const o of pdfs)
		{
			const obsName = o?.Name?.length > 60 ? o.Name.substring(0, 60) + '...' : o.Name;
			const tmpIDArtifact = o?.Details?.File?.[0]?.IDArtifact;
			const tmpVersion = o?.Details?.File?.[0]?.Version;
			const tmpMediaURL = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
			//@ts-ignore
			const task = this.pdfjsLib.getDocument(tmpMediaURL);
			let tmpRenderedPageCount = 0;
			try
			{
				const pdf = await this._withTimeout(task.promise, this.embeddedPDFOperationTimeoutMS, `Loading embedded PDF ${tmpMediaURL}`);
				const pageTotal = pdf.numPages;
				for (let i = 0; i < pageTotal; i++)
				{
					const page = await this._withTimeout(pdf.getPage(i + 1), this.embeddedPDFOperationTimeoutMS, `Loading page ${i + 1} of embedded PDF ${tmpMediaURL}`);
					const viewport = page.getViewport({ scale: 2 });
					const container = document.createElement('div');
					container.style['margin-bottom'] = '10px';
					// Build the page header from DOM nodes — obsName is the user-supplied observation/file name, so avoid HTML-string injection
					const headerLabel = document.createElement('span');
					headerLabel.style.fontSize = '15px';
					const headerBold = document.createElement('b');
					headerBold.textContent = `Observation: ${ obsName } - Page ${ i + 1 }`;
					headerLabel.appendChild(headerBold);
					container.appendChild(headerLabel);
					container.style['break-inside'] = 'avoid';
					const canvas = document.createElement( 'canvas' );
					canvas.style.display = 'block';
					canvas.style['position'] = 'absolute';
					canvas.style['left'] = '0px';
					canvas.style['margin-left'] = '20px';
					const scaleFactor = (window.innerWidth - 60) / viewport.width;
					canvas.style.width = `${ scaleFactor * viewport.width }px`;
					canvas.style.height = `${ scaleFactor * viewport.height }px`;
					container.style['height'] = `${ (scaleFactor * viewport.height) + 20 }px`;
					canvas.style.border = '2px solid grey';
					const context = canvas.getContext('2d');
					canvas.height = viewport.height;
					canvas.width = viewport.width;
					await this._withTimeout(page.render({ canvasContext: context, viewport: viewport }).promise, this.embeddedPDFOperationTimeoutMS, `Rendering page ${i + 1} of embedded PDF ${tmpMediaURL}`);
					container.appendChild(canvas);
					embedTemplate.appendChild(container);
					tmpRenderedPageCount++;
				}
			}
			catch (pError)
			{
				this.pict.log.error(`[ObservationCardDeck] Could not embed PDF ${tmpMediaURL} in print view: ${pError.message || pError}`,
					{
						IDObservation: o?.IDObservation,
						IDArtifact: tmpIDArtifact,
						Version: tmpVersion,
					});
				embedTemplate.appendChild(this.buildEmbeddedPDFErrorPlaceholder(obsName, tmpRenderedPageCount));
				Promise.resolve(task.destroy()).catch((pDestroyError) =>
				{
					this.pict.log.warn(`[ObservationCardDeck] Failed to release the pdf.js task for ${tmpMediaURL}: ${pDestroyError.message || pDestroyError}`);
				});
			}
		}
		// update the styles for the content area to allow the embedded PDFs to break into multiple pages when we have a lot of them,
		// and to avoid awkward blank spaces at the bottom of pages when the PDF viewer is too large to fit on one page but gets cut off instead of breaking onto the next page
		containerElement['style']['break-inside'] = 'auto';
		if (containerElement.parentElement)
		{
			containerElement.parentElement['style']['break-inside'] = 'auto';
		}
		containerElement.appendChild(embedTemplate);
		return true;
	}

	/**
	 * Toggle the deck style for the observation card deck.
	 * @param {string} id - the ID of the element to toggle the deck style for
	 * @param {string} style - the style to apply to the deck
	 */
	toggleDeckStyle(id, style)
	{
		/** @type {HTMLElement} */
		const element = /** @type {HTMLElement} */ (document.getElementById(id));
		if (!element)
		{
			this.pict.log.error(`Could not find element with ID ${ id } to toggle deck style.`);
			return;
		}
		element.classList.remove('observation-deck-style-thumbnail', 'observation-deck-style-cards', 'observation-deck-style-list', 'observation-deck-style-details');
		element.classList.add(`observation-deck-style-${style}`);
		// toggle active state on the buttons
		const buttons = element.parentElement.querySelectorAll('button');
		buttons.forEach((btn)=>
		{
			btn.classList.remove('is-active');
			if (btn.dataset.deckStyle === style)
			{
				btn.classList.add('is-active');
			}
		});
	}

	/**
	 * Build the modifier (filter/observation set) tags for the observation card deck header. These are little color (red, green, blue, or gray) coded tags
	 * that show up in the header next to the label to indicate which modifications are currently applied to the deck. This is helpful because the deck can be
	 * configured to show different subset lists of document observations based on different filters applied, or it may be an Observation Set, so it can be easy for
	 * users to forget which modifiers are currently applied, especially if they navigate away from the page and come back later. These tags provide a quick visual
	 * reference for users to understand what they're looking at in the deck. Optionally, this UI can be configured to be hidden through options if users find it overwhelming or distracting.
	 * @param {Object} pView - the pict-view instance hosting the input (used to look up bound form metadata)
	 * @param {Object} pInput - the input object for which to build the modifier tags (used to get the raw HTML ID for the input, which we use to find the container element for the header and to store the current modifiers in a data attribute on the input element)
	 * @param {boolean} hideModifiersInHeader - flag to indicate whether we should hide the modifier tags in the header based on options (if true, we won't build or show any modifier tags, even if there are modifiers applied)
	 * @returns {string} - the HTML string for the modifier tags to be inserted into the header
	 */
	/**
	 * Builds the icon + label pair used by the deck header tags and toggles as DOM nodes rather than an
	 * HTML string. Emits no whitespace between the two spans, matching the markup this replaced.
	 * @param {string} pIconClasses - classes for the <i> element (e.g. 'fa fa-fw fa-toggle-on has-text-link')
	 * @param {string} pLabelText - the label text
	 * @param {string} [pIconSpanExtraClasses] - extra classes for the icon <span>, beyond 'icon'
	 * @param {string} [pLabelSpanClasses] - classes for the label <span>; omit for a bare <span>
	 * @return {DocumentFragment}
	 */
	buildIconLabelNodes(pIconClasses, pLabelText, pIconSpanExtraClasses, pLabelSpanClasses)
	{
		const tmpFragment = document.createDocumentFragment();
		const tmpIconSpan = document.createElement('span');
		tmpIconSpan.className = pIconSpanExtraClasses ? `icon ${ pIconSpanExtraClasses }` : 'icon';
		const tmpIcon = document.createElement('i');
		tmpIcon.className = pIconClasses;
		tmpIconSpan.appendChild(tmpIcon);
		const tmpLabelSpan = document.createElement('span');
		if (pLabelSpanClasses)
		{
			tmpLabelSpan.className = pLabelSpanClasses;
		}
		tmpLabelSpan.textContent = pLabelText;
		tmpFragment.appendChild(tmpIconSpan);
		tmpFragment.appendChild(tmpLabelSpan);
		return tmpFragment;
	}

	buildFilterTagsForCardDeckHeader(pView, pInput, hideModifiersInHeader = false)
	{
		if (hideModifiersInHeader)
		{
			return '';
		}
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const tagDisplayLimit = 3; // max number of tags to show in the header before we switch to showing a summary tag instead
		const hasModifiersApplied = this.hasFiltersApplied(pInput);

		// if we don't have any modifiers to show, we should show a tag that indicates that we're showing all document observations so that users have some context for what they're looking at in the deck instead of just seeing an empty header with no tags and wondering if something is broken
		if (!hasModifiersApplied)
		{
			const headerContainer = this.getCardDeckHeaderFilterContainerHTMLID(pInput.Macro.RawHTMLID);
			const headerContainerElement = document.querySelector(headerContainer);
			if (!headerContainerElement)
			{
				this.pict.log.error(`Could not find header container element with ID ${ headerContainer } to build modifier tags for header.`);
				return '';
			}
			headerContainerElement.innerHTML = '';
			headerContainerElement.classList.add('is-flex', 'is-align-items-center', 'gap-1');
			const tag = document.createElement('span');
			tag.classList.add('tag', 'pl-1', 'is-primary', 'is-light');
			tag.appendChild(this.buildIconLabelNodes('fa fa-fw fa-file', 'All Document Observations', 'mr-0', 'icon-text'));
			headerContainerElement.appendChild(tag);

			// only show the exclude observation sets toggle if there are other card decks on the form that use observation sets, otherwise it's not relevant
			const isAlwaysExcluding = !!currentSettings.alwaysExcludeObservationSets;
			if (!isAlwaysExcluding)
			{
				// Only show the toggle when other set-based decks exist on the form — otherwise there are
				// no sets to exclude and the button would be meaningless.
				const hasObservationSetDecks = Object.values(this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap).some((settings) => settings.useObservationSet);
				if (!hasObservationSetDecks)
				{
					return '';
				}
			}
			// add a toggle switch for excluding observation sets so users can flip between views in real time
			const isExcluding = !!currentSettings.excludeObservationSets;
			const toggleButton = document.createElement('button');
			toggleButton.type = 'button';
			toggleButton.classList.add('button', 'is-ghost', 'is-flex', 'is-align-items-center', 'gap-1', 'ml-1', 'px-2');
			toggleButton.style.fontSize = '0.85em';
			toggleButton.style.whiteSpace = 'nowrap';
			toggleButton.style.textDecoration = 'none';
			toggleButton.setAttribute('data-input-hash', pInput.Hash);
			toggleButton.setAttribute('data-raw-html-id', pInput.Macro.RawHTMLID);
			toggleButton.setAttribute('data-excluding', isExcluding ? 'true' : 'false');
			if (isAlwaysExcluding)
			{
				// Locked on — show as permanently active with no click handler
				toggleButton.appendChild(this.buildIconLabelNodes('fa fa-fw fa-toggle-on has-text-link', 'Exclude Observation Sets'));
				toggleButton.setAttribute('disabled', 'disabled');
				toggleButton.style.opacity = '0.7';
				toggleButton.style.cursor = 'default';
			}
			else
			{
				toggleButton.appendChild(this.buildIconLabelNodes(`fa fa-fw ${ isExcluding ? 'fa-toggle-on has-text-link' : 'fa-toggle-off has-text-grey' }`, 'Exclude Observation Sets'));
				toggleButton.addEventListener('click', () => this.handleExcludeObservationSetsToggle(toggleButton));
			}
			headerContainerElement.appendChild(toggleButton);
			return '';
		}
		// make a deep copy of the filters so we don't mutate the original object when we manipulate the label types for display
		const filterCopy = JSON.parse(JSON.stringify(currentFilters));
		const headerContainer = this.getCardDeckHeaderFilterContainerHTMLID(pInput.Macro.RawHTMLID);
		/**
		 * @type {HTMLSpanElement[]}
		 */
		const tmpFiltersTags = [];
		/** @type {HTMLElement} */
		const headerContainerElement = document.querySelector(headerContainer);
		if (!headerContainerElement)
		{
			this.pict.log.error(`Could not find header container element with ID ${ headerContainer } to build modifier tags for header.`);
			return '';
		}
		headerContainerElement.classList.add('is-flex', 'is-align-items-left', 'gap-1');
		// for each modifier type (include/exclude), we want to create a tag for each modifier that is applied, and color code it green for include and red for exclude.
		let modifierCount = 0;
		Object.entries(filterCopy).forEach(([ type ])=>
		{
			// skip the internal default-filter flag — it's not a real filter direction
			if (type === '_isDefaultTypeFilter')
			{
				return;
			}
			const joinType = type; // include or exclude
			for (let [ key, value ] of Object.entries(filterCopy[type]))
			{
				// Label Types are nested objects and we need to pull out the tags to be [LabelType]: [LabelValue1, LabelValue2] instead of just showing the raw object in the tag, which isn't helpful for users to understand what the modifier is
				if (key === 'LabelTypes')
				{
					value = value.map((/** @type {any} */ v)=>
					{
						for (const [ labelType, labelValues ] of Object.entries(v))
						{
							if (labelType.toLowerCase() === 'type')
							{
								v.Type = labelValues;
							}
							else if (labelType.toLowerCase() === 'value')
							{
								v.Values = labelValues;
							}
						}
						return `${ v.Type }: ${ v.Values.join(', ') }`;
					});
				}
				else
				{
					value = Array.isArray(value) ? value?.join(', ') : value;
					const tmpKey = key === 'ObservationTypes' ? 'Type' : key; // just to make it a little more user friendly in the tag
					const tmpValue = value.replace(/Legacy\s*/g, ''); // strip all "Legacy " prefixes from observation type names for cleaner display (e.g. "Legacy Image" → "Image")
					value = `${ tmpKey }: ${ tmpValue }`;
				}
				modifierCount++;
				const tag = document.createElement('span');
				tag.classList.add('tag', 'pl-1', 'mr-1', joinType.toLowerCase() === 'include' ? 'is-success' : 'is-danger', 'is-light');
				const tagIconWrapper = document.createElement('span');
				tagIconWrapper.classList.add('icon', 'mr-0');
				const tagIcon = document.createElement('i');
				tagIcon.classList.add('fa', 'fa-fw', joinType.toLowerCase() === 'include' ? 'fa-plus-circle' : 'fa-minus-circle');
				tagIconWrapper.appendChild(tagIcon);
				const tagText = document.createElement('span');
				tagText.classList.add('icon-text');
				// value is derived from user-influenced filter/label data — set as text, not markup
				tagText.textContent = modifierCount > tagDisplayLimit ? `${ modifierCount }+ modifiers applied` : value;
				tag.appendChild(tagIconWrapper);
				tag.appendChild(tagText);
				tmpFiltersTags.push(tag);
			}
		});
		// clear out any existing tags in the header container before we add the new ones so we don't end up with duplicates when the modifiers change
		headerContainerElement.innerHTML = '';
		// if we have more than tagDisplayLimit modifier tags, we should just show a summary tag instead of overwhelming the user with a million tags in the header
		// we will show them the summary of modifiers on hover with a tooltip for more info
		if (modifierCount > tagDisplayLimit)
		{
			const summaryTag = document.createElement('span');
			summaryTag.classList.add('tag', 'pl-1', 'is-info', 'is-light');
			const summaryIconWrapper = document.createElement('span');
			summaryIconWrapper.classList.add('icon', 'mr-0');
			const summaryIcon = document.createElement('i');
			summaryIcon.classList.add('fa', 'fa-fw', 'fa-info-circle');
			summaryIcon.setAttribute('tooltip', tmpFiltersTags.map((tag) => tag.innerText).join(', '));
			summaryIconWrapper.appendChild(summaryIcon);
			const summaryText = document.createElement('span');
			summaryText.classList.add('icon-text');
			summaryText.textContent = `${ modifierCount } modifiers applied`;
			summaryTag.appendChild(summaryIconWrapper);
			summaryTag.appendChild(summaryText);
			headerContainerElement.appendChild(summaryTag);
		}
		else
		{
			tmpFiltersTags.forEach((tag)=>
			{
				headerContainerElement.appendChild(tag);
			});
		}
		// When alwaysExcludeObservationSets is set, append the locked-on toggle after the filter tags
		// so it's always visible regardless of which filters are applied.
		if (currentSettings.alwaysExcludeObservationSets)
		{
			const toggleButton = document.createElement('button');
			toggleButton.type = 'button';
			toggleButton.classList.add('button', 'is-ghost', 'is-flex', 'is-align-items-center', 'gap-1', 'ml-1', 'px-2');
			toggleButton.style.fontSize = '0.85em';
			toggleButton.style.whiteSpace = 'nowrap';
			toggleButton.style.textDecoration = 'none';
			toggleButton.style.opacity = '0.7';
			toggleButton.style.cursor = 'default';
			toggleButton.setAttribute('disabled', 'disabled');
			toggleButton.setAttribute('data-excluding', 'true');
			toggleButton.appendChild(this.buildIconLabelNodes('fa fa-fw fa-toggle-on has-text-link', 'Exclude Observation Sets'));
			headerContainerElement.appendChild(toggleButton);
		}
		return '';
	}

	/**
	 * Returns the MediaRegistry namespaces for observation set card decks that are currently rendered on the DOM.
	 * This is used to scope the "exclude observation sets" logic so that only observations visible in other set-based decks
	 * on the form are excluded, rather than excluding observations from every set in the NamespaceObservationSetMap.
	 * @returns {Array<string>} - Array of MediaRegistry namespace strings for observation set decks on the DOM.
	 */
	getObservationSetNamespacesOnDOM()
	{
		if (typeof document === 'undefined')
		{
			return [];
		}
		const namespaces = [];
		const setDecksOnDOM = document.querySelectorAll(this.packageTypeSelectorMap['AllObservationSets']);
		for (const deckElement of setDecksOnDOM)
		{
			const inputHash = deckElement.getAttribute(this.deckInputHashAttribute);
			if (!inputHash)
			{
				continue;
			}
			// get the RawHTMLID from the container element's ID (format: CARD-DECK-CONTAINER-FOR-{RawHTMLID})
			const containerElement = deckElement.closest('[id^="CARD-DECK-CONTAINER-FOR-"]');
			if (!containerElement)
			{
				continue;
			}
			const rawHTMLID = containerElement.id.replace('CARD-DECK-CONTAINER-FOR-', '');
			// read the IDObservationSet from the hidden input element
			const hiddenInput = /** @type {HTMLInputElement} */ (document.getElementById(rawHTMLID));
			const tmpIDObservationSet = hiddenInput?.value ? parseInt(hiddenInput.value) : null;
			// build the namespace the same way the marshal flow does
			if (tmpIDObservationSet)
			{
				namespaces.push(this.buildNamespaceForCardDeck(inputHash, tmpIDObservationSet));
			}
			else
			{
				// temporary set that hasn't been saved yet
				namespaces.push(this.buildNamespaceForCardDeck(inputHash, null, true));
			}
		}
		return namespaces;
	}

	/**
	 * Resolves the list of set-based deck namespaces to use when filtering observations for an exclude-sets deck.
	 * Prefers DOM-discovered set decks (accurate to what is currently rendered on this form), but falls back to the
	 * persisted NamespaceObservationSetMap when the DOM list is empty — this is important on cold reload, where
	 * document-list decks can marshal before set-based decks have applied their DOM marker attributes. Without the
	 * fallback, the deck would rebuild the registry with the full (unfiltered) document observation list on every reload.
	 * @returns {Array<string>|null} - An array of namespaces, or null to signal "use everything in NamespaceObservationSetMap".
	 */
	getObservationSetNamespacesForExcludeFiltering()
	{
		const domNamespaces = this.getObservationSetNamespacesOnDOM();
		if (domNamespaces.length)
		{
			return domNamespaces;
		}
		// null signals to MediaRegistry.getDocumentObservationsExcludingCurrentSets to use all persisted set namespaces
		return null;
	}

	/**
	 * Handles the toggle for excluding observation sets from the card deck. This is called when the user clicks the "Exclude Observation Sets" toggle button in the header.
	 * It updates the dynamic settings for the deck and triggers a remarshal to refresh the deck contents in real time.
	 * @param {HTMLButtonElement} pToggleButton - The toggle button element that was clicked.
	 */
	handleExcludeObservationSetsToggle(pToggleButton)
	{
		const inputHash = pToggleButton.getAttribute('data-input-hash');
		const rawHTMLID = pToggleButton.getAttribute('data-raw-html-id');
		// look up the view hash from the deck container at click time (it may not be available at build time)
		const deckContainerElement = rawHTMLID ? document.querySelector(`${this.getCardDeckContainerHTMLID(rawHTMLID)} .${this.deckClassName}`) : null;
		const viewHash = deckContainerElement?.getAttribute(this.deckViewHashAttribute);
		if (!inputHash || !viewHash || !rawHTMLID)
		{
			this.pict.log.error('Could not find input hash, view hash, or raw HTML ID on the exclude observation sets toggle element. Cannot toggle setting.');
			return;
		}
		const currentSettings = this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[inputHash];
		if (!currentSettings)
		{
			this.pict.log.error(`Could not find settings for input hash ${inputHash}. Cannot toggle excludeObservationSets.`);
			return;
		}
		// flip the current state
		const newValue = pToggleButton.getAttribute('data-excluding') !== 'true';
		const tmpView = this.pict.views[viewHash];
		const pInput = tmpView?.getInputFromHash(inputHash);
		// persist the override to FormData so it survives save/reload and remarshals within this session
		if (pInput)
		{
			this.setPersistedOverrideForInput(pInput, 'excludeObservationSets', newValue);
		}
		currentSettings.excludeObservationSets = newValue;
		// update the exclude hidden input so it stays in sync with the toggle state for reference
		const hiddenInputElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderExcludeObservationSetHiddenInputHTMLID(rawHTMLID))?.[0];
		if (hiddenInputElement)
		{
			hiddenInputElement.value = newValue ? 'true' : 'false';
		}
		// show a loading indicator immediately so the user sees feedback during the multi-second async rebuild:
		// clear the deck body, drop in the spinner, and mark the toggle button as loading
		this.showLoadingStateForDeck(rawHTMLID);
		pToggleButton.classList.add('is-loading');
		pToggleButton.setAttribute('disabled', 'disabled');
		if (tmpView && pInput)
		{
			// dataChanged() triggers marshalToView() (which rebuilds the deck) and notifies FormPersistence for autosave
			tmpView.dataChanged(inputHash);
		}
		// explicitly trigger a document autosave so the FormData-persisted override reaches the server even when
		// no bound input value actually changed (dataChanged only dirties the input record via Informary)
		if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument && this.pict.providers?.DocumentProvider?.handleSave)
		{
			this.pict.providers.DocumentProvider.handleSave(true);
		}
	}

	/**
	 * Clears the deck body and injects the initial loading spinner, signaling to the user that a rebuild is in flight.
	 * Used when the deck content is about to change due to a user action (e.g. toggling excludeObservationSets) so there is visible feedback during the async rebuild.
	 * @param {string} pInputHTMLID - The raw HTML ID of the deck input.
	 */
	showLoadingStateForDeck(pInputHTMLID)
	{
		const cardDeckContentAreaElement = document.querySelector(this.getCardDeckContentHTMLID(pInputHTMLID));
		if (cardDeckContentAreaElement)
		{
			const tmpLoadingMessage = document.createElement('span');
			tmpLoadingMessage.className = 'initial-loading-message';
			const tmpSpinnerIcon = document.createElement('i');
			tmpSpinnerIcon.className = 'fa fa-fw fa-circle-notch fa-spin';
			tmpLoadingMessage.appendChild(tmpSpinnerIcon);
			// this container is looked up from the DOM, not freshly created, so clear it as the assignment did
			cardDeckContentAreaElement.textContent = '';
			cardDeckContentAreaElement.appendChild(tmpLoadingMessage);
		}
	}

	/**
	 * Build the observation card deck for a given input.
	 * @param {Object} pView - the view object for which to build the observation card deck (used to get the current view hash for storing in data attributes on the cards for reference in interactivity, and for logging purposes)
	 * @param {Object} pInput - the input object for which to build the observation card deck (used to get the raw HTML ID for the input, which we use to find the container element for the deck and to store the current namespace for the deck in a data attribute on the input element)
	 * @param {string} pNamespace - the namespace for the observation list
	 * @param {any[]} pObservationList - the list of observations to display in the card deck
	 */
	buildObservationCardDeck(pView, pInput, pNamespace, pObservationList)
	{
		const deckContent = this.pict.ContentAssignment.getElement(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const deckContainerElement = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID) + (` .${this.deckClassName}`))?.[0];

		if (!deckContent || !deckContainerElement)
		{
			this.pict.log.error(`Could not find deck container elements for input with HTML ID ${pInput.Macro.RawHTMLID}. Cannot build observation card deck.`);
			return;
		}
		// apply the deck layout style as a class to the container for styling purposes (default is 'thumbnail', but can be configured through options to be 'thumbnail', 'list', or 'details')
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const deckLayout = currentSettings?.deckLayout || 'thumbnail';
		deckContent.classList.add(`observation-deck-style-${deckLayout}`);
		// sync the toggle button active state to match the configured deck layout (template defaults to thumbnail being active)
		if (deckLayout !== 'thumbnail')
		{
			const toggleButtons = deckContainerElement.querySelectorAll('.observation-card-deck-style-toggle button');
			toggleButtons.forEach((/** @type {HTMLElement} */ btn) =>
			{
				btn.classList.remove('is-active');
				if (btn.dataset.deckStyle === deckLayout)
				{
					btn.classList.add('is-active');
				}
			});
		}
		// container marker attributes (view/input hash + deck type markers) are applied by prepareUIBeforeBuildingCardDeck via applyDeckContainerMarkerAttributes
		// surgical DOM diff: only add/remove cards that actually changed to avoid flickering existing images
		const desiredIDs = pObservationList.map((/** @type {any} */ o) => String(o.IDObservation));
		const existingCards = Array.from(deckContent.querySelectorAll(`.${this.cardClassName}`));
		const existingIDMap = new Map();
		for (const card of existingCards)
		{
			existingIDMap.set(card.getAttribute(this.cardAttributeId), card);
		}
		// remove cards that are no longer in the observation list
		for (const [ id, card ] of existingIDMap)
		{
			if (!desiredIDs.includes(id))
			{
				card.remove();
				existingIDMap.delete(id);
			}
		}
		// add new cards and reorder all cards to match pObservationList
		let previousSibling = null;
		for (const [ index, observation ] of pObservationList.entries())
		{
			const obsID = String(observation.IDObservation);
			let card = existingIDMap.get(obsID);
			if (!card)
			{
				// new card — build and make individually draggable
				card = this.buildObservationCard(pView, pInput, observation, index);
				this.pict.providers.DraggableUtil.makeElementDraggable(card, this.draggableConfigurationForDeck);
			}
			// position the card correctly (move existing or insert new)
			const nextSibling = previousSibling ? previousSibling.nextSibling : deckContent.firstChild;
			if (card !== nextSibling)
			{
				deckContent.insertBefore(card, nextSibling);
			}
			previousSibling = card;
		}
		// on first render (deck was empty), initialize draggable on the full collection
		if (existingCards.length === 0)
		{
			_Pict.providers.DraggableUtil.initializeDraggableCollection(deckContent, this.draggableConfigurationForDeck);
		}
		// update index numbers and remove loading skeletons
		this.updateIndexNumbersOnUIForDeck(pInput, pObservationList);
		this.removeInitialLoadingMessage(pInput);
	}

	/**
	 * Function to update the index numbers that show up on top of the card thumbnails in the deck based on the current order of the observations in the deck on the DOM.
	 * @param {Object} pInput - the input object for which to update the index numbers (used to get the raw HTML ID for the input, which we use to find the card elements in the deck and to get the current options for the deck)
	 * @param {any[]} [pOrderedIDObservationList] - the list of observation IDs in the current order they are displayed in the deck, which we can use to update the index numbers on the cards to reflect their current position in the deck (if not provided, we will just use the order of the card elements in the DOM to update the index numbers)
	*/
	updateIndexNumbersOnUIForDeck(pInput, pOrderedIDObservationList)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const indexTagScope = currentSettings.indexTagScope || 'local';
		// only update local indices when the scope is 'local' — document-scoped decks will be handled by updateDocumentIndexNumbers below
		if (indexTagScope === 'local')
		{
			const cardElements = document.querySelectorAll(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID) + ` .${this.cardClassName}`);
			cardElements.forEach((card, index) =>
			{
				const obsID = card.getAttribute(this.cardAttributeId);
				const obsIndex = pOrderedIDObservationList?.length ? pOrderedIDObservationList.findIndex((/** @type {any} */ o) => o.IDObservation == obsID) : index;
				if (obsIndex !== -1)
				{
					const indexTag = card.querySelector('.card-index');
					if (indexTag)
					{
						indexTag.textContent = (obsIndex + 1).toString();
					}
				}
			});
		}
		// always run the document-level index update — it will only affect decks configured with indexTagScope: 'document'
		this.updateDocumentIndexNumbers();
	}

	/**
	 * Resolves the current settings for a deck by looking up the input hash stored on the deck's parent container element.
	 * @param {Element} pDeckBodyElement - a `.observation-card-deck-body` element
	 * @returns {Object|null} - the settings object for the deck's input, or null if the input could not be resolved
	 */
	_getSettingsForDeckElement(pDeckBodyElement)
	{
		const deckContainer = pDeckBodyElement?.closest(`.${this.deckClassName}`);
		if (!deckContainer)
		{
			return null;
		}
		const inputHash = deckContainer.getAttribute(this.deckInputHashAttribute);
		if (!inputHash)
		{
			return null;
		}
		return this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[inputHash] || null;
	}

	/**
	 * Updates index numbers across ALL card decks on the page that are configured with `indexTagScope: 'document'`.
	 * Cards are numbered sequentially based on their visual DOM order from top to bottom of the page.
	 */
	updateDocumentIndexNumbers()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const allDeckBodies = document.querySelectorAll('.observation-card-deck-body');
		if (!allDeckBodies.length)
		{
			return;
		}
		let documentIndex = 1;
		allDeckBodies.forEach((deckBody) =>
		{
			const settings = this._getSettingsForDeckElement(deckBody);
			const indexTagScope = settings?.indexTagScope || 'local';
			if (indexTagScope !== 'document')
			{
				return;
			}
			const cardElements = deckBody.querySelectorAll(`.${this.cardClassName}`);
			cardElements.forEach((card) =>
			{
				const indexTag = card.querySelector('.card-index');
				if (indexTag)
				{
					indexTag.textContent = documentIndex.toString();
				}
				documentIndex++;
			});
		});
	}

	/**
	 * Set the observations for the deck based on a provided list of observations. This will overwrite any existing observations in the deck.
	 * NOTE: This is only used for Interactive mode, there is a separate function for building the deck in Print called "buildCardDeckCardsForPrintView()"
	 * @param {any} pView - the pict-view instance hosting the input
	 * @param {any} pInput - the input object for which to build the observation card
	 * @param {Object} pObservation - the observation object to set for the deck (should have the necessary properties for display in the deck)
	 * @param {number} pIndex - the index of the observation in the deck (used to determine the ordinal number for display)
	 * @returns {HTMLElement|undefined} - returns the card template of the observation
	 */
	buildObservationCard(pView, pInput, pObservation, pIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			this.pict.log.error(`Attempted to build an observation card for a non-interactive document, which is not supported. Please use the buildCardDeckCardsForPrintView function for rendering the deck in print view instead, which is optimized for non-interactive documents.`);
			return;
		}
		if (pObservation?.IDObservation === undefined)
		{
			this.pict.log.error(`Observation object is missing IDObservation property or it is undefined. Cannot build card for observation: ${ JSON.stringify(pObservation) }`);
			return;
		}
		// don't add duplicates
		if (document.querySelector(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID) + ` .${this.cardClassName}[${this.cardAttributeId}="${pObservation.IDObservation}"]`))
		{
			return;
		}
		const cardElement = document.createElement('div');
		cardElement.setAttribute(this.cardAttributeId, pObservation.IDObservation);
		cardElement.classList.add(this.cardClassName);
		cardElement.innerHTML = this.buildObservationCardMarkup(pView, pInput, pObservation, pIndex);
		return cardElement;
	}

	/**
	 * Builds an observation card's inner markup: the compact layout (thumbnail and list deck styles) and the details layout, toggled by CSS.
	 * @param {any} pView - the pict-view instance hosting the input
	 * @param {any} pInput - the input the card belongs to
	 * @param {Object} pObservation - the observation the card shows
	 * @param {number} pIndex - the card's position in the deck (shown as its ordinal)
	 * @returns {string} - the card's inner markup
	 */
	buildObservationCardMarkup(pView, pInput, pObservation, pIndex)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const tmpOrdinal = pIndex + 1; /* we want the number in the UI to be local to the set, not the Ordinal itself since that can be global and not reflect the current order in the deck if there are other sets of observations in the document */

		const MAX_DESCRIPTION_LENGTH = 250;

		const hasDescription = typeof pObservation.Description === 'string' && pObservation.Description.trim() !== '';
		let shortDescription = '';
		let fullDescription = '';
		let useReadMore = false;

		if (hasDescription)
		{
			fullDescription = libUserMarkdown.escapeHTML(pObservation.Description);
			if (pObservation.Description.length > MAX_DESCRIPTION_LENGTH)
			{
				shortDescription = libUserMarkdown.escapeHTML(pObservation.Description.slice(0, MAX_DESCRIPTION_LENGTH)) + '...';
				useReadMore = true;
			}
			else
			{
				shortDescription = fullDescription;
			}
		}

		let removeButtonTemplate = '';
		// if the document is locked, we can still show the image, but we can't remove it from the set
		if (!currentSettings.preventRemovingCards && !this.isDocumentLocked && this.canEditDocument)
		{
			removeButtonTemplate = `<button type="button" class="delete card-delete"
				onclick="_Pict.providers.ObservationCardDeckProvider.removeCardFromDeck('${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })"></button>`;
		}

		// format designated time and creator name for the details view
		const tmpDesignatedDate = pObservation.DesignatedTime ? new Date(pObservation.DesignatedTime).toLocaleDateString() : '';
		const tmpDesignatedTime = pObservation.DesignatedTime ? new Date(pObservation.DesignatedTime).toLocaleTimeString() : '';
		// resolve creator name from the user name cache (populated asynchronously by resolveCreatorNamesForDeck)
		const userNameCache = this.pict.AppData.ObservationCardDeckProvider?.userNameCache || {};
		const tmpCreatorName = userNameCache[pObservation.CreatingIDUser] || '';

		// Compact layout — used by thumbnail and list deck styles (toggled purely via CSS)
		const compactLayout =
		`<article class="media card-layout-compact" style="position: relative;">
			<span class="${ currentSettings.hideIndexTags ? 'is-hidden' : '' } card-index badge is-info">${ tmpOrdinal }</span>
			${ removeButtonTemplate }
			<figure class="image ${this.cardClassName}-content has-background-text-soft is-128x128 media-left">
				<img loading="lazy" class="photo-image is-clickable" height="128px" width="128px" src="/1.0/Observation/${ pObservation.IDObservation }/Image/Thumbnail-Dense?t=${ new Date().getTime() }"
					onclick="_Pict.providers.ObservationCardDeckProvider.handleClickForCardThumbnail(event, '${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })" />
			</figure>
			<div class="media-content">
				<div class="content pr-5">
					<strong class="title is-size-6">${ libUserMarkdown.escapeHTML(pObservation.Name || `Observation #${pObservation.IDObservation}`) }</strong>
					<p class="subtitle is-size-7 has-text-text-30">
						${ shortDescription || '<i class="has-text-text-50">No description</i>' }
						${ useReadMore ? `<a href="javascript:void(0);" onclick="_Pict.providers.ObservationCardDeckProvider.handleClickForCardThumbnail(event, '${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })">Read More</a>` : '' }
					</p>
				</div>
				<span class="${ currentSettings.preventReorderingCards ? 'is-hidden' : '' } card-drag-handle icon has-text-text-50">
					<i class="fa fa-fw fa-grip"></i>
				</span>
			</div>
		</article>`;

		// Build label tags for the details view from the raw observation Labels object
		let labelTagsHtml = '';
		if (pObservation.Labels && typeof pObservation.Labels === 'object')
		{
			const MAX_LABEL_TAGS = 6; // truncate to first few to keep the card compact
			let tagCount = 0;
			let truncated = false;
			const tagParts = [];
			for (const [ labelTypeKey, labelObjects ] of Object.entries(pObservation.Labels))
			{
				if (labelTypeKey === 'SAVE') continue;
				const items = Array.isArray(labelObjects) ? labelObjects : [ labelObjects ];
				for (const labelObj of items)
				{
					if (!labelObj?.Tag || !labelObj.Tag.length) continue;
					if (tagCount >= MAX_LABEL_TAGS)
					{
						truncated = true; break;
					}
					tagParts.push(`<span class="tag is-small is-rounded tag-outlined-primary">${ libUserMarkdown.escapeHTML(labelTypeKey) }: ${ libUserMarkdown.escapeHTML(labelObj.Tag) }</span>`);
					tagCount++;
				}
				if (truncated) break;
			}
			if (tagParts.length)
			{
				labelTagsHtml = `
				<div class="card-details-row">
					<div class="card-details-field" style="grid-column: span 2;">
						<div class="title is-7 has-text-text-50 mb-1">Labels</div>
						<div class="card-details-labels">${ tagParts.join(' ') }${ truncated ? '<span class="tag is-small is-rounded has-text-text-50">...</span>' : '' }</div>
					</div>
				</div>`;
			}
		}

		// Details layout — postcard-style with image on the left and observation metadata on the right (similar to print standard card)
		const detailsLayout =
		`<article class="card-layout-details" style="position: relative;">
			<span class="${ currentSettings.hideIndexTags ? 'is-hidden' : '' } card-index badge is-info">${ tmpOrdinal }</span>
			${ removeButtonTemplate }
			<span class="${ currentSettings.preventReorderingCards ? 'is-hidden' : '' } card-drag-handle icon has-text-text-50">
				<i class="fa fa-fw fa-grip"></i>
			</span>
			<div class="card-details-grid">
				<figure class="card-details-image has-background-text-soft">
					<img loading="lazy" class="photo-image is-clickable" src="/1.0/Observation/${ pObservation.IDObservation }/Image/Preview?t=${ new Date().getTime() }"
						onclick="_Pict.providers.ObservationCardDeckProvider.handleClickForCardThumbnail(event, '${ pView.Hash }', '${ pInput.Hash }', ${ pObservation.IDObservation })" />
				</figure>
				<div class="card-details-metadata">
					<div class="card-details-header has-background-text-soft px-3 py-2">
						<strong class="title is-6 mb-0">${ libUserMarkdown.escapeHTML(pObservation.Name || `Observation #${pObservation.IDObservation}`) }</strong>
						<span class="subtitle is-7 has-text-text-30">#${ pObservation.IDObservation }</span>
					</div>
					<div class="card-details-body px-3 py-2">
						<div class="card-details-row">
							<div class="card-details-field">
								<div class="title is-7 has-text-text-50 mb-1">Created by</div>
								<div class="subtitle is-7 card-details-creator-name" data-creator-id="${ pObservation.CreatingIDUser || '' }">${ libUserMarkdown.escapeHTML(tmpCreatorName) || 'N/A' }</div>
							</div>
							<div class="card-details-field">
								<div class="title is-7 has-text-text-50 mb-1">Designated Time</div>
								<div class="subtitle is-7">${ tmpDesignatedDate }${ tmpDesignatedTime ? ' at ' + tmpDesignatedTime : '' }</div>
							</div>
						</div>
						<div class="card-details-row">
							<div class="card-details-field" style="grid-column: span 2;">
								<div class="title is-7 has-text-text-50 mb-1">Description</div>
								<div class="subtitle is-7">${ fullDescription || '<span class="has-text-text-50">No description provided</span>' }</div>
							</div>
						</div>
						${ labelTagsHtml }
					</div>
				</div>
			</div>
		</article>`;

		return compactLayout + detailsLayout;
	}

	/**
	 * Rebuild every card showing the given observation, so a change saved elsewhere (the Observation Details panel's Edit details, a File selector Rename)
	 * shows without reopening the form. Each card element stays in place, keeping its drag listeners and position; a deck marshal can't do this, because it
	 * keeps cards that are already on the deck as they are. Called by ObservationProvider.applyUpdatedObservation.
	 * @param {Object} pObservation - the observation record the server returned
	 */
	refreshObservationCards(pObservation)
	{
		if (!pObservation || !pObservation.IDObservation || !this.pict.AppData.Interactive)
		{
			return;
		}
		const tmpCards = document.querySelectorAll(`.${this.deckClassName} .${this.cardClassName}[${this.cardAttributeId}="${pObservation.IDObservation}"]`);
		for (const tmpCard of tmpCards)
		{
			const tmpDeck = tmpCard.closest(`.${this.deckClassName}`);
			const tmpView = this.pict.views[tmpDeck.getAttribute(this.deckViewHashAttribute)];
			const tmpInput = tmpView ? tmpView.getInputFromHash(tmpDeck.getAttribute(this.deckInputHashAttribute)) : null;
			if (!tmpInput)
			{
				continue;
			}
			const tmpIndex = (parseInt(tmpCard.querySelector('.card-index')?.textContent, 10) || 1) - 1;
			tmpCard.innerHTML = this.buildObservationCardMarkup(tmpView, tmpInput, pObservation, tmpIndex);
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.log.info(`Marshaling data to form for Observation Card Deck input with value: ${ pValue } and HTML selector: ${ pHTMLSelector }`);
		const tmpMarshalPromise = this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
		.catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		this.marshalPromises.push(tmpMarshalPromise);
		// EVERY marshal gates print rendering. This used to register only the first marshal per input hash, on the
		// assumption that it already covered the deck build — it does not. prepareUIBeforeBuildingCardDeck fires the
		// async print build separately, so a later marshal's build could begin after completeRender() had already
		// drained, and the rasterizer would snapshot an empty deck. registerRenderDependency is a no-op in interactive
		// mode, so this only accumulates across the finite marshal cycle of a print render.
		if (!this.registeredDependencyInputHashList.includes(pInput.Hash))
		{
			this.registeredDependencyInputHashList.push(pInput.Hash);
		}
		this.registerRenderDependency(tmpMarshalPromise);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Custom CSS injection for the observation card deck. This is needed to apply specific styles to the deck and its cards that are not covered by the primary CSS collection, especially during development when we are iterating on the design and functionality of the deck and may need to make frequent updates to the styles without worrying about caching issues. We will eventually migrate these styles to the primary CSS collection, but for now this allows us to develop the functionality and styles in parallel.
	 * @param {Object} currentSettings - the current settings for the deck, which can be used to conditionally apply styles based on the configuration of the deck (ex: different styles for print view vs interactive view, or based on the selected display style for the deck)
	 */
	injectCustomCSS(currentSettings)
	{
		if (this.customCSSInjected || document.getElementById('ObservationCardDeck-Styles')) return;

		const styleElement = document.createElement('style');
		styleElement.id = 'ObservationCardDeck-Styles';
		styleElement.textContent = /*CSS*/`
			/* Observation Card Deck (Collection) specific styles */
			.observation-card-deck {
				/* NOTE: Would be nice if we could add an extension for Bulma cards instead of this duplication... */
				/* duplication of the ".card" class from Bulma, but renamed to avoid confusion with our Card elements inside the deck which aren't necessarily Bulma cards and to allow for more customization specific to the deck container itself */
				--bulma-card-color: var(--bulma-text);
				--bulma-card-background-color: var(--bulma-scheme-main);
				--bulma-card-shadow: var(--bulma-shadow);
				--bulma-card-radius: 0.75rem;
				--bulma-card-header-background-color: transparent;
				--bulma-card-header-color: var(--bulma-text-strong);
				--bulma-card-header-padding: 0.75rem 1rem;
				--bulma-card-header-shadow: 0 0.125em 0.25em hsla(var(--bulma-scheme-h), var(--bulma-scheme-s), var(--bulma-scheme-invert-l), 0.1);
				--bulma-card-header-weight: var(--bulma-weight-bold);
				--bulma-card-content-background-color: transparent;
				--bulma-card-content-padding: 1.5rem;
				--bulma-card-media-margin: var(--bulma-block-spacing);
				background-color: var(--bulma-card-background-color);
				border-radius: var(--bulma-card-radius);
				box-shadow: var(--bulma-card-shadow);
				color: var(--bulma-card-color);
				max-width: 100%;
				position: relative;
				margin-top: 0.5rem;
				margin-bottom: 0.5rem;
			}
			/* initialization message to show that something is happening */
			.observation-card-deck .initial-loading-message {
				vertical-align: middle;
				color: var(--bulma-text-soft);
				text-align: center;
				width: 100%;
				display: block;
				font-size: 3.25rem;
				padding: 2rem 0 1rem 0;
			}
			/* specific styles for the observation cards inside the deck */
			.observation-card-deck .observation-card .card-delete {
				display: none;
			}
			.observation-card-deck .observation-card:hover .card-delete {
				display: block;
			}
			.observation-card-deck.deck-filters-applied .observation-card .card-delete,
			.observation-card-deck.deck-filters-applied .observation-card:hover .card-delete {
				display: none;
			}
			.observation-card-deck .observation-card .badge.card-index {
				position: absolute; 
				top: 12px; 
				left: -4px; 
				z-index: 1; 
				right: auto;
			}
			.observation-card-deck .observation-card .card-delete {
				position: absolute; 
				top: 2px; 
				right: 2px; 
				z-index: 1;
				background-color: var(--bulma-danger-50);
				opacity: 0.8;
			}
			.observation-card-deck .observation-card-deck-header {
				border-start-start-radius: var(--bulma-card-radius);
				border-start-end-radius: var(--bulma-card-radius);
				background-color: var(--bulma-card-header-background-color);
				align-items: stretch;
				box-shadow: var(--bulma-card-header-shadow);
				display: flex;
				padding: var(--bulma-card-header-padding);
				position: relative;
				z-index: 1;
				justify-content: space-between;
				flex-wrap: wrap;
				gap: 0.5rem;
				font-weight: var(--bulma-card-header-weight);
				color: var(--bulma-card-header-color);
			}
			.observation-card-deck .observation-card-deck-header .card-deck-header-actions {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				vertical-align: middle;
			}
			.observation-card-deck .observation-card-deck-header .card-deck-header-filters {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				vertical-align: middle;
				/* this is to allow the filter tags to wrap to a new line if there are too many to fit in the header, instead of overflowing and breaking the layout */
				flex-wrap: wrap;
				max-width: 100%;
				justify-content: flex-start;
				flex-grow: 1; /* allow the filters container to grow and take up available space when it wraps */
				/* we also want to make sure that the filters don't get pushed down below the header on smaller screens, so we can set a min-width on the header to prevent that from happening */
				min-width: 300px;
				/* and we want to make sure that the filters don't get too squished on smaller screens, so we can set a max-width on the filters container to prevent that from happening */
				max-width: 100%;
				/* if there are a lot of filters and they wrap to a new line, we want to add some spacing between the header and the filters to visually separate them, so we can add a margin-top to the filters container when it wraps */
				margin-top: 0.5rem;
			}
			.observation-card-deck .observation-card-deck-header .card-deck-header-observation-set-selector {
				display: block;
				align-items: center;
				vertical-align: middle;
				max-width: 100%;
				font-size: 0.9rem;
				flex-grow: 1; /* allow the filters container to grow and take up available space when it wraps */
			}
			.observation-card-deck .observation-card-deck-body,
			.observation-card-deck .observation-card-deck-empty-message {
				gap: calc(var(--bulma-column-gap) * 0.5);
				padding: calc(var(--bulma-column-gap) * 0.75);
				display: flex;
				flex-wrap: wrap;
				position: relative;
				background-color: var(--bulma-background);
				justify-content: flex-start;
				align-items: flex-start;
				border: 1px solid var(--bulma-border);
				border-bottom-left-radius: var(--bulma-card-radius);
				border-bottom-right-radius: var(--bulma-card-radius);
				border-top: none;
				/* no forced min-height — cards dictate the height naturally.
				   The empty-message sibling handles its own min-height when the body is :empty.
				   The initial-loading-message spinner has its own padding to prevent full collapse during load. */
				/* transition for when hovering over cards and the deck resizes due to description popovers showing up and changing the size of the cards */
				transition: all 0.3s ease;
				/* this is to prevent the deck from jumping around when we hover over cards and the popovers show up and change the size of the cards, by allowing the deck to grow in height instead of overflowing and causing a scrollbar to appear */
				overflow: visible;
			}
			.observation-card-deck .observation-card-deck-body:empty {
				display: none;
			}
			.observation-card-deck .observation-card-deck-body:not(:empty) + .observation-card-deck-empty-message {
				display: none;
			}
			.observation-card-deck .observation-card-deck-body:empty + .observation-card-deck-empty-message {
				display: flex;
				align-items: center;
				justify-content: center;
				color: var(--bulma-text-50);
				min-height: 75px;
				font-size: 0.875rem;
			}
			/* Observation Card (Item) specific styles */
			@keyframes observationCardFadeIn {
				from { opacity: 0; }
				to { opacity: 1; }
			}
			.observation-card {
				border: 3px solid transparent;
				border-radius: 6px;
				width: calc(128px + (3px * 2)); /* thumbnail size + border */
				animation: observationCardFadeIn 0.25s ease-in;
			}
			.observation-card img {
				opacity: 1;
				transition: opacity 0.25s ease-in;
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
			.observation-card:hover {
				border: 3px solid var(--bulma-primary);
			}
			.observation-card .card-layout-compact {
				margin: 0;
			}
			.observation-card .observation-card-content-inner {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 0.5rem;
			}
			.observation-deck-style-thumbnail .observation-card {
				width: calc(128px + (3px * 2)); /* thumbnail size + border */
			}
			.observation-deck-style-list .observation-card {
				width: 100%;
			}
			.observation-card-deck .media-content {
				display: none;
			}
			.observation-deck-style-list figure.is-128x128 {
				display: flex;
				align-items: flex-start;
				gap: 1rem;
				height: 64px;
				width: 64px;
			}
			.observation-deck-style-list .media {
				border: 1px solid var(--bulma-border);
				padding: 0.5rem;
				border-radius: 4px;
			}
			.observation-deck-style-list .media-content {
				display: block;
			}
			.observation-card-deck .observation-card .media-content .card-drag-handle {
				position: absolute;
				right: 5px;
				top: 50%;
				transform: translateY(-50%);
				z-index: 1;
			}
			.observation-deck-style-list .card-observation-read-more-button {
				display: none;
			}

			/* Details layout — postcard-style view: hide by default, show only in details mode */
			.observation-card-deck .card-layout-details {
				display: none;
			}
			.observation-deck-style-details .card-layout-details {
				display: block;
			}
			.observation-deck-style-details .card-layout-compact {
				display: none;
			}
			.observation-deck-style-details .observation-card {
				width: 100%;
			}
			.card-details-grid {
				display: grid;
				grid-template-columns: 300px 1fr;
				border: 1px solid var(--bulma-border);
				border-radius: 6px;
				overflow: hidden;
				min-height: 300px;
			}
			.card-details-image {
				margin: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				overflow: hidden;
			}
			.card-details-image img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
			.card-details-header {
				display: flex;
				align-items: baseline;
				gap: 0.5rem;
				border-bottom: 1px solid var(--bulma-border);
			}
			.card-details-row {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 0.5rem;
				margin-bottom: 0.5rem;
			}
			.card-details-row:last-child {
				margin-bottom: 0;
			}
			.card-details-labels {
				display: flex;
				flex-wrap: wrap;
				gap: 0.25rem;
			}
			.tag.tag-outlined-primary {
				background-color: transparent;
				border: 1px solid var(--bulma-primary);
				color: var(--bulma-primary);
			}
			.observation-deck-style-details .card-layout-details .card-drag-handle {
				position: absolute;
				right: 0.75rem;
				top: 0.75rem;
				z-index: 1;
			}

			.observation-card-deck-style-toggle .button.is-ghost {
				color: var(--bulma-text-soft);
			}
			.observation-card-deck-style-toggle .button.is-ghost.is-active {
				color: var(--bulma-text);
			}

			/* Print Only types for PDF viewer */
			.for-print-only .observation-card-deck,
			.for-print-only .observation-card-deck .observation-card-deck-body {
				display: block;
				padding: 0;
				border: none;
				border-radius: 0;
				gap: 0;
				background-color: transparent;
				min-height: auto;
				transition: none;
				overflow: visible;
				page-break-inside: auto;
				box-shadow: none;
				width: 100%;
				max-width: none;
			}
			.for-print-only .observation-card-deck .observation-card {
				page-break-inside: avoid;
				border: none;
				border-radius: 0;
				width: auto;
				margin-bottom: 1rem;
			}
			/* TODO: we might want to show the filters in the header for print as well, but for now we'll hide the header entirely for print since the filters are more for interactive use and don't make as much sense in a static format like PDF */
			.for-print-only .observation-card-deck .observation-card-deck-header {
				display: none;
			}
			.for-print-only .observation-card-deck .observation-card-deck-empty-message {
				border-radius: 5px;
				border: none;
			}
			`;
		document.head.appendChild(styleElement);
		this.customCSSInjected = true;
	};

	/**
	 * Attempts to get the observation set for the deck based on the passed value (expected to be only the Observation Set ID),
	 * or if no passed value, then it will attempt to find the observation set based on the input hash as the namespace.
	 * If that doesn't work, it will attempt to create a new observation set based on the document observations and any filters provided in options.
	 * Finally, it will build the observation card deck based on the observation set it found or created.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		if (!this.pict.AppData.DocumentData)
		{
			this.pict.log.error('Document data or document ID is missing from AppData. Cannot marshal data to form for Observation Card Deck.');
			return;
		}
		// always start by making sure our MediaRegistry is up to date with the latest document observation list (in case anything was added externally, etc)
		this.pict.providers.MediaRegistry.updateRegistryFromFormData();
		// blend the default and current settings passed in from PictForm.
		// Persisted user overrides (FormData.ObservationCardDeckOverrides) are applied last inside setCurrentSettingsForInput
		// so toggled preferences like excludeObservationSets survive save/reload and Edit→Print view switches.
		const currentSettings = this.setCurrentSettingsForInput(pInput, pInput?.PictForm?.CardDeckSettings);
		// Keep the exclude hidden input in sync with the resolved setting
		const excludeHiddenInput = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderExcludeObservationSetHiddenInputHTMLID(pInput.Macro.RawHTMLID))?.[0];
		if (excludeHiddenInput)
		{
			excludeHiddenInput.value = currentSettings.excludeObservationSets ? 'true' : 'false';
		}
		this.injectCustomCSS(currentSettings);
		// If we are using sets, we need to check the hidden value or prepare for the possibility of not having a value if the user hasn't selected/created an observation set yet.
		// The selector in the header is optional, and new pristine selectors that are using sets will have a temporary namespace until the first observation is add, which creates the set ID.
		// NOTE: Filters are not used for the IDObservationSet case, because we assume that if an IDObservationSet is provided, then the user has already applied any necessary filters to create that set, and they want to see that specific set in the deck.
		// If we apply additional filters on top of that, we might end up with an empty deck or a different set of observations than the user intended to display.
		currentSettings.useObservationSet ? await this.handleOnDataMarshalForObservationSetCase(pView, pInput, pValue) : await this.handleOnDataMarshalForObservationListCase(pView, pInput);
	}

	/**
	 * Toggles the visibility of the "Add" and "Quick Capture" buttons in the header of the card deck based on the config settings.
	 * @param {Object} pInput - The input object for which to toggle the visibility of the header buttons (used to get the raw HTML ID for the input, which we use to find the header button elements)
	 */
	toggleVisibilityForAddCardHeaderButtons(pInput)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const addButton = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderActionsButtonAddHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const quickCaptureButton = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderActionsButtonQuickCaptureHTMLID(pInput.Macro.RawHTMLID))?.[0];
		// when requireExplicitSetCreation is enabled, check whether a set is currently selected —
		// if not, hide Add/QuickCapture so the user must go through "Create New Set" first
		let hasSelectedSet = true;
		if (currentSettings?.requireExplicitSetCreation && currentSettings?.useObservationSetSelector)
		{
			const tmpHiddenValue = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID))?.[0]?.value;
			hasSelectedSet = !isNaN(parseInt(tmpHiddenValue));
		}
		// show the add/qc buttons in the header if we're not preventing adding cards and the document isn't locked and is editable
		const canAddCards = !currentSettings?.preventAddingCards && !this.isDocumentLocked && this.canEditDocument && (!this.hasFiltersApplied(pInput) || this.hasActionableFilters(pInput));
		if (canAddCards)
		{
			if (addButton)
			{
				addButton.classList.remove('is-hidden', 'is-skeleton');
			}
			if (quickCaptureButton)
			{
				quickCaptureButton.classList.remove('is-hidden', 'is-skeleton');
			}
			// when the buttons are visible but no set is selected, show them as disabled instead of hiding
			// so the user can see the actions are available once they create/select a set
			if (!hasSelectedSet)
			{
				addButton?.setAttribute('disabled', 'disabled');
				quickCaptureButton?.setAttribute('disabled', 'disabled');
			}
			else
			{
				addButton?.removeAttribute('disabled');
				quickCaptureButton?.removeAttribute('disabled');
			}
		}
		else
		{
			if (addButton)
			{
				addButton.classList.add('is-hidden');
			}
			if (quickCaptureButton)
			{
				quickCaptureButton.classList.add('is-hidden');
			}
		}
	}

	/**
	 * Handles adjusting the header UI depending on which settings are enabled for the deck, such as showing/hiding the filter tags or the observation set selector
	 * in the header based on whether we're using sets or just a filtered list of observations, and based on the specific settings for what to show in the header.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pNamespace - The namespace for the deck.
	 */
	handleHeaderContentForCardDeck(pView, pInput, pNamespace)
	{
		// if we are using sets, we do some additional set up in the header
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		const usingSets = currentSettings.useObservationSet;
		const usingSetSelector = currentSettings.useObservationSetSelector;
		const tmpIDObservationSet = usingSets && !pNamespace.startsWith('TEMP-') ? parseInt(pNamespace.split('-').pop()) : null;
		const headerFilterContainer = this.getCardDeckHeaderFilterContainerHTMLID(pInput.Macro.RawHTMLID);
		const headerSetSelectorContainer = this.getCardDeckHeaderObservationSetSelectorContainerHTMLID(pInput.Macro.RawHTMLID);
		const headerStaticObservationSetDisplayContainer = this.getCardDeckHeaderObservationSetDisplayHTMLID(pInput.Macro.RawHTMLID);
		// first let's hide everything, then add back what we need based on the settings
		this.pict.ContentAssignment.addClass(headerFilterContainer, 'is-hidden');
		this.pict.ContentAssignment.addClass(headerSetSelectorContainer, 'is-hidden');
		this.pict.ContentAssignment.addClass(headerStaticObservationSetDisplayContainer, 'is-hidden');

		if (usingSets && usingSetSelector)
		{
			this.buildSetSelectorOptionForCurrentObservationSetID(pInput, tmpIDObservationSet);
			this.pict.ContentAssignment.removeClass(headerSetSelectorContainer, 'is-hidden');
		}
		else if (usingSets)
		{
			// Prefer the user-given Name (pre-populated in the set-name cache by handleOnDataMarshalForObservationSetCase),
			// falling back to "Observation Set {id}" for unnamed/auto-timestamped sets so users don't see ugly default labels.
			const tmpLabel = this.getDisplayLabelForObservationSet(tmpIDObservationSet);
			// Show a pencil-edit affordance when the user can actually rename the set — hidden for locked or read-only documents,
			// and for brand-new (not-yet-saved) sets that don't have an ID to save under yet.
			const canRename = !!tmpIDObservationSet && !this.isDocumentLocked && this.canEditDocument;
			let renameButtonHTML = '';
			if (canRename)
			{
				const renameOnClick = `_Pict.providers.ObservationCardDeckProvider.handleInlineRenameSetClick('${pInput.Macro.RawHTMLID}', ${tmpIDObservationSet})`;
				renameButtonHTML = `<button type="button" class="button is-ghost is-small p-0 ml-1" title="Rename Observation Set" style="height: auto; min-height: 0;" onclick="${renameOnClick}"><span class="icon is-small"><i class="fa fa-fw fa-pencil"></i></span></button>`;
			}
			const staticContent =
			`<div class="tag mt-2 pl-1">
				<span class="icon mr-0">
					<i class="fa fa-fw fa-layer-group"></i>
				</span>
				<span class="icon-text">${tmpLabel}</span>
				${renameButtonHTML}
			</div>`;
			// clear the display container and replace the content with the new static content template
			const tmpDisplayContainer = this.pict.ContentAssignment.getElement(headerStaticObservationSetDisplayContainer)?.[0];
			if (tmpDisplayContainer)
			{
				tmpDisplayContainer.innerHTML = '';
				tmpDisplayContainer.insertAdjacentHTML('beforeend', staticContent);
				this.pict.ContentAssignment.removeClass(headerStaticObservationSetDisplayContainer, 'is-hidden');
			}
		}
		else
		{
			this.buildFilterTagsForCardDeckHeader(pView, pInput, currentSettings?.hideFiltersInHeader);
			this.pict.ContentAssignment.removeClass(headerFilterContainer, 'is-hidden');
			// Apply the deck-filters-applied CSS marker to hide card delete buttons when non-label filters are active.
			// Label-only filtered decks are actionable (we can auto-apply labels), so delete buttons remain visible.
			const deckContainerElement = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID) + (` .${this.deckClassName}`))?.[0];
			if (deckContainerElement)
			{
				if (this.hasFiltersApplied(pInput) && !this.hasActionableFilters(pInput))
				{
					deckContainerElement.classList.add('deck-filters-applied');
				}
				else
				{
					deckContainerElement.classList.remove('deck-filters-applied');
				}
			}
		}
		this.toggleVisibilityForAddCardHeaderButtons(pInput);
	}

	/**
	 * Prepares the UI before building the card deck. This includes setting up any necessary headers, selectors, and draggable configurations based on the current settings and observation list.
	 * Also handles the branching paths between Interactive and Print views to make sure we are only building the necessary elements for each view based on their specific needs and use cases.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pNameSpace - The namespace for the deck.
	 * @param {any[]} pObservationList - The list of observations to display in the deck.
	 */
	prepareUIBeforeBuildingCardDeck(pView, pInput, pNameSpace, pObservationList)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		// this will handle the branching paths of what to show in the header of the card deck
		this.handleHeaderContentForCardDeck(pView, pInput, pNameSpace);
		// tag the deck container with the marker attributes used by cross-deck lookups (e.g. getObservationSetNamespacesOnDOM)
		// before handing off to either the interactive or print builder — print decks also need these markers so
		// persisted excludeObservationSets can resolve set membership when rendering PDFs.
		this.applyDeckContainerMarkerAttributes(pView, pInput, currentSettings);
		// handle which view we are going into, templates are built differently for each since Interactive has more dynamic functionality and options,
		// while Print is optimized for static display and performance for large decks in PDF view, so we want to make sure we are only building the necessary elements for each view
		if (this.pict.AppData.Interactive)
		{
			this.setDraggableConfigurationForDeck(pInput, currentSettings, pNameSpace);
			this.buildObservationCardDeck(pView, pInput, pNameSpace, pObservationList);
			// asynchronously resolve creator names for the details view — cards render immediately with placeholders,
			// and the creator name cells are back-filled once the lookup completes
			this.resolveCreatorNamesForDeck(pInput, pObservationList);
		}
		else
		{
			// The print build is async — pdf.js fetches each embedded PDF artifact and rasterizes it page by page — and it
			// clears the deck container before it appends. It MUST gate the render: prepareForPrintingAsync() sets
			// window.status='ready_to_print' as soon as completeRender() drains, and the rasterizer snapshots on that
			// signal, so leaving the build unregistered captures an empty Media section.
			this.registerRenderDependency(this.buildCardDeckCardsForPrintView(pView, pInput, pNameSpace, pObservationList));
			// print cards render before the name lookup returns, so back-fill them too — registered so the PDF waits for it
			this.registerRenderDependency(this.resolveCreatorNamesForDeck(pInput, pObservationList));
		}
		// Safety net: always remove the initial loading spinner after deck building completes.
		// buildObservationCardDeck calls removeInitialLoadingMessage internally, but if it bails early
		// (e.g. container elements not yet in the DOM on the synchronous useObservationSet NaN path),
		// the spinner would persist indefinitely. This explicit call ensures it is always cleared.
		this.removeInitialLoadingMessage(pInput);
		// invoke the custom after-marshal callback if registered (e.g. bridge defect photo count label update on initial load / set selection)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterMarshal === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.customOnAfterMarshal(pInput, pObservationList);
		}
	}

	/**
	 * Asynchronously resolves creator display names for observations in the deck. Collects unique CreatingIDUser values
	 * that are not already cached, fetches them via UserProvider.getUsersByIDList, and back-fills any rendered creator
	 * name cells (interactive `.card-details-creator-name`, print `.media-card-creator-name`) with the resolved names.
	 * @param {Object} pInput - The input object.
	 * @param {Array} pObservationList - The list of observations to resolve names for.
	 */
	async resolveCreatorNamesForDeck(pInput, pObservationList)
	{
		if (!pObservationList || !pObservationList.length) return;
		const cache = this.pict.AppData.ObservationCardDeckProvider.userNameCache;
		// collect unique user IDs that aren't already cached
		const uncachedIDs = [ ...new Set(
			pObservationList
				.map((obs) => obs.CreatingIDUser)
				.filter((id) => id && !cache[id]),
		) ];
		if (uncachedIDs.length > 0 && this.pict.providers.UserProvider)
		{
			try
			{
				const userRecords = await this._withTimeout(this.pict.providers.UserProvider.getUsersByIDList(uncachedIDs), this.creatorNameLookupTimeoutMS, 'Creator name lookup');
				if (userRecords && Array.isArray(userRecords))
				{
					for (const user of userRecords)
					{
						cache[user.IDUser] = `${user.NameFirst || ''} ${user.NameLast || ''}`.trim() || 'N/A';
					}
				}
			}
			catch (err)
			{
				this.pict.log.warn('[ObservationCardDeck] Failed to resolve creator names:', err);
			}
		}
		// back-fill any rendered creator name placeholders in this deck
		const deckContent = document.getElementById(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID).replace('#', ''));
		if (!deckContent) return;
		const creatorCells = deckContent.querySelectorAll('.card-details-creator-name[data-creator-id], .media-card-creator-name[data-creator-id]');
		creatorCells.forEach((/** @type {HTMLElement} */ cell) =>
		{
			const userId = cell.getAttribute('data-creator-id');
			if (userId && cache[userId])
			{
				cell.textContent = cache[userId];
			}
		});
	}

	/**
	 * Applies the deck-type marker attributes (observation-set, document-list, filtered, excluded-set) and the view/input hash attributes
	 * to the deck container element. Shared by both the interactive and print rendering paths so cross-deck lookups work in both modes.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pCurrentSettings - The resolved settings for the deck.
	 */
	applyDeckContainerMarkerAttributes(pView, pInput, pCurrentSettings)
	{
		const deckContainerElement = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID) + (` .${this.deckClassName}`))?.[0];
		if (!deckContainerElement)
		{
			return;
		}
		deckContainerElement.setAttribute(this.deckViewHashAttribute, pView.Hash);
		deckContainerElement.setAttribute(this.deckInputHashAttribute, pInput.Hash);
		if (pCurrentSettings?.useObservationSet)
		{
			deckContainerElement.setAttribute(this.deckIsObservationSetAttribute, 'true');
			return;
		}
		deckContainerElement.setAttribute(this.deckIsDocumentListAttribute, 'true');
		if (this.hasFiltersApplied(pInput))
		{
			deckContainerElement.setAttribute(this.deckIsFilteredDocumentListAttribute, 'true');
		}
		if (pCurrentSettings?.excludeObservationSets)
		{
			deckContainerElement.setAttribute(this.deckIsExcludedSetAttribute, 'true');
		}
		else
		{
			deckContainerElement.removeAttribute(this.deckIsExcludedSetAttribute);
		}
	}

	/**
	 * Handles the case where we are not using observation sets. In this case, we will just apply any filters provided in the options to the full list of observations from the registry
	 * and build the deck based on that filtered list, and we will update the deck dynamically as the filters change by reapplying the filters to the full list of observations and rebuilding
	 * the deck on each filter change.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @returns {Promise<void>} - Returns a promise that resolves when the data has been marshaled and the deck has been built.
	 */
	async handleOnDataMarshalForObservationListCase(pView, pInput)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		// if we're not using observation sets, then we will just apply any filters provided in the options to the full list of observations from the registry and build the deck based on that filtered list, and we will update the deck dynamically as the filters change by reapplying the filters to the full list of observations and rebuilding the deck on each filter change
		let tmpCurrentObservationList;
		// Prefer DOM-discovered set decks (accurate for the current form) but fall back to the persisted NamespaceObservationSetMap
		// so exclude filtering still applies on cold reload before set decks have set their marker attributes —
		// otherwise the registry gets rebuilt with the full, unfiltered document list and the saved 6-item state reverts to 7.
		const excludeNamespaces = currentSettings.excludeObservationSets ? this.getObservationSetNamespacesForExcludeFiltering() : null;
		if (this._isRemarshalInProgress)
		{
			// During remarshal, use the authoritative local observation list that was already
			// updated by refreshCardDecks — avoids stale API re-fetch
			const localObservations = this.pict.AppData.DocumentData.ReportData.Observations || [];
			if (currentSettings.excludeObservationSets)
			{
				const currentSetObservationIDs = new Set();
				// Use DOM-discovered namespaces when available, otherwise all persisted set namespaces
				const namespacesToCheck = excludeNamespaces || Object.keys(this.pict.AppData.MediaRegistryStore?.NamespaceObservationSetMap || {});
				for (const namespace of namespacesToCheck)
				{
					const setObservations = await this.pict.providers.MediaRegistry.getMediaSet(namespace);
					for (const o of setObservations)
					{
						currentSetObservationIDs.add(o.IDObservation);
					}
				}
				tmpCurrentObservationList = localObservations.filter((/** @type {any} */ o) => !currentSetObservationIDs.has(o.IDObservation));
			}
			else
			{
				tmpCurrentObservationList = localObservations;
			}
		}
		else
		{
			tmpCurrentObservationList = currentSettings.excludeObservationSets ? await this.pict.providers.MediaRegistry.getDocumentObservationsExcludingCurrentSets(excludeNamespaces) : await this.pict.providers.MediaRegistry.getDocumentObservations();
		}
		const tmpNamespaceFromInputHash = this.buildNamespaceForCardDeck(pInput.Hash);
		this.pict.log.info(`Marshaling data to form for Observation Card Deck using input hash as namespace: ${pInput.Hash}`);
		let observationListFromRegistry = await this.pict.providers.MediaRegistry.getMediaSet(tmpNamespaceFromInputHash);
		// Preserve Ordinal values from the registry onto the local observation list
		// so that any user-defined ordering (e.g. from drag-and-drop) is not lost during remarshal
		if (observationListFromRegistry && observationListFromRegistry.length)
		{
			const registryOrdinalMap = new Map();
			for (const regObs of observationListFromRegistry)
			{
				if (regObs.Ordinal !== undefined)
				{
					registryOrdinalMap.set(regObs.IDObservation, regObs.Ordinal);
				}
			}
			if (registryOrdinalMap.size)
			{
				const knownObservations = [];
				const newObservations = [];
				for (const obs of tmpCurrentObservationList)
				{
					if (registryOrdinalMap.has(obs.IDObservation))
					{
						obs.Ordinal = registryOrdinalMap.get(obs.IDObservation);
						knownObservations.push(obs);
					}
					else
					{
						newObservations.push(obs);
					}
				}
				knownObservations.sort((a, b) => a.Ordinal - b.Ordinal);
				if (currentSettings.appendNewCardToStartOfDeck)
				{
					tmpCurrentObservationList = [ ...newObservations, ...knownObservations ];
				}
				else
				{
					tmpCurrentObservationList = [ ...knownObservations, ...newObservations ];
				}
			}
		}
		// set the current filters (or default ones) passed in from Pict config — filters now live as a sub-object of settings (CardDeckSettings.filters)
		const tmpFilters = this.setCurrentFiltersForInput(pInput, { ...this.patchedConfiguration[pInput?.PictForm?.InputType]?.filters, ...(pInput?.PictForm?.CardDeckSettings?.filters || this.defaultConfiguration.filters) });
		// if we find an existing observation list in the registry for this namespace, we need to compare it to the current document observations to see if there have been any changes (observations added or removed)
		// since the last time we marshaled data to the form for this input and update the registry if needed before we build the deck, because we want to make sure we are working with the most up to date data
		// from the document when we build the deck
		if (observationListFromRegistry && observationListFromRegistry.length)
		{
			const addedObservationIDs = [];
			const removedObservationIDs = [];
			// new observations added to the document, not yet in the registry set for this namespace
			for (const obs of tmpCurrentObservationList)
			{
				if (!observationListFromRegistry.find((/** @type {any} */ o) => o.IDObservation === obs.IDObservation))
				{
					this.pict.log.info(`Observation with ID ${obs.IDObservation} is in the document observations but not in the registry set for namespace ${tmpNamespaceFromInputHash}. Adding it to the registry set.`);
					if (currentSettings.appendNewCardToStartOfDeck)
					{
						observationListFromRegistry.unshift(obs);
					}
					else
					{
						observationListFromRegistry.push(obs);
					}
					addedObservationIDs.push(obs.IDObservation);
				}
			}
			// observations removed from the document, but still in the registry set for this namespace
			for (const obs of [ ...observationListFromRegistry ])
			{
				if (!tmpCurrentObservationList.find((/** @type {any} */ o) => o.IDObservation === obs.IDObservation))
				{
					this.pict.log.info(`Observation with ID ${obs.IDObservation} is in the registry set for namespace ${tmpNamespaceFromInputHash} but not in the document observations. Removing it from the registry set.`);
					observationListFromRegistry = observationListFromRegistry.filter((/** @type {any} */ o) => o.IDObservation !== obs.IDObservation);
					removedObservationIDs.push(obs.IDObservation);
				}
			}
			// if there were any additions or removals, we need to update the registry with the new list for that namespace so that it's up to date for the next time we marshal data to the form for this input
			if (addedObservationIDs.length || removedObservationIDs.length)
			{
				let updatedObservationList = [];
				this.pict.log.info(`Updated observation list for namespace ${tmpNamespaceFromInputHash}. Added: ${addedObservationIDs.join(', ')}, Removed: ${removedObservationIDs.join(', ')}`);
				updatedObservationList = this.pict.providers.ObservationProvider.handleFilteringObservationsInList(tmpFilters, tmpCurrentObservationList);
				updatedObservationList = await this.pict.providers.MediaRegistry.registerMediaSet(tmpNamespaceFromInputHash, updatedObservationList);
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceFromInputHash, updatedObservationList);
				return;
			}
			else
			{
				this.pict.log.info(`Existing observation list for namespace ${tmpNamespaceFromInputHash} contains ${observationListFromRegistry.length} observations.`);
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceFromInputHash, observationListFromRegistry);
				return;
			}
		}
		else
		{
			this.pict.log.warn(`No observation set found in MediaRegistry for namespace observation list at hash: ${pInput.Hash}. Will attempt to create new namespace and compile observation list based on options and document observations.`);
			const tmpObservationList = this.pict.providers.ObservationProvider.handleFilteringObservationsInList(tmpFilters, tmpCurrentObservationList);
			observationListFromRegistry = await this.pict.providers.MediaRegistry.registerMediaSet(tmpNamespaceFromInputHash, tmpObservationList);
			this.pict.log.info(`Registered new media set in MediaRegistry for namespace ${tmpNamespaceFromInputHash} with ${observationListFromRegistry.length} observations after filtering.`);
			this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceFromInputHash, observationListFromRegistry);
			return;
		}
	}

	/**
	 * Handles the case where we are using observation sets for the deck, which means we expect the value passed in to be the ID of the observation set we want to display in the deck,
	 * so we need to get that set from the registry and build the deck based on that set. If we don't have a valid ID passed in, then we will wait until we have an ID to pull the set
	 * and build the deck, which will happen when the user adds their first observation and we create a new set for them based on the input hash as the namespace and the current document observations.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled, expected to be the ID of the observation set to display in the deck.
	 * @returns {Promise<void>} - A promise that resolves when the deck has been built based on the observation set, or if we are waiting for an ID to be provided, it will resolve immediately and we will build the deck later when we have an ID to work with.
	 */
	async handleOnDataMarshalForObservationSetCase(pView, pInput, pValue)
	{
		// if we are using observation sets, then we expect the value passed in to be the ID of the observation set we want to display in the deck, so we need to get that set from the registry and build the deck based on that set
		const tmpIDObservationSet = parseInt(pValue);
		// the "empty"/"temp" set case where we don't have a valid observation set ID provided yet, which will be the case when the user first adds the deck to the form and hasn't added any observations to it yet,
		// so we don't have an observation set created for it yet since sets are created based on the input hash as the namespace once the first observation is added to the deck.
		if (isNaN(tmpIDObservationSet))
		{
			this.pict.log.info(`No valid Observation Set ID provided for input ${pInput.Macro.RawHTMLID}. Value received: ${pValue}. Will attempt to build deck with a temp ID until an image is added and we can generate a proper Observation Set record.`);
			const currentSettings = this.getCurrentSettingsForInput(pInput);
			const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInput.Hash, null, true);
			// Register an empty observation list for the temp namespace — no API call needed since there's no
			// real ObservationSet record yet.  The previous call to registerMediaSetByIDObservationSet(ns, [])
			// passed [] which is truthy, bypassing the falsy guard and calling loadSetObservations([]) which
			// hit the server at /1.0/ObservationSet/ with an empty ID, producing a "record not found" error
			// on every marshal cycle.
			this.pict.providers.MediaRegistry.registerMediaSet(tmpNamespaceForIDObservationSet, []);
			// Yield to the browser before touching the DOM — unlike the non-NaN set path and the
			// non-set observation list path (both of which do async API work that naturally defers
			// DOM manipulation), this NaN path is fully synchronous.  When the framework calls
			// onDataMarshalToForm during the initial render cycle, the section template may not
			// have been flushed to the DOM yet, so buildObservationCardDeck can't find its container
			// elements and bails.  A single await on a resolved promise yields to the microtask
			// queue, giving the browser a chance to commit the pending template HTML before we
			// attempt to query and manipulate the deck elements.
			await Promise.resolve();
			this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceForIDObservationSet, []);
			// Show a contextual empty message when using the set selector with no set selected
			if (currentSettings.useObservationSetSelector)
			{
				this.updateEmptyMessageText(pInput, 'No observation set is currently selected.');
			}
			this.handleObservationSetEditButtonStateOnChange(pInput);
			return;
		}
		// if we have a set id, we're good to go, we can pull the observations for that set from the registry and build the deck, if not,
		// we'll wait until we have an ID to pull the set and build the deck, which will happen when the user adds their first observation
		// and we create a new set for them based on the input hash as the namespace and the current document observations
		else
		{
			const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInput.Hash, tmpIDObservationSet);
			this.pict.log.info(`Marshaling data to form for Observation Card Deck with provided Observation Set ID: ${tmpIDObservationSet}`);
			// Populate dynamicGUIDMap during marshal so other decks' Select2 processResults
			// wrappers can detect this set as "in use" on initial form load — not just after
			// user interaction.  Without this, reopening a saved form leaves the GUID map empty
			// until a user manually changes a selector, allowing duplicate set selection.
			this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID] = tmpIDObservationSet;
			// Populate the set-name cache before rendering so the header selector/static label use the saved Name on first paint
			// and survive subsequent re-renders without flashing the "Observation Set {id}" fallback back over the correct name.
			await this.fetchObservationSetName(tmpIDObservationSet);
			// this will fetch or create a namespace for the observation set based on the ID and return the observations in that set for us to render in the deck
			let observationListFromRegistry = await this.pict.providers.MediaRegistry.getObservationSetByNamespace(tmpNamespaceForIDObservationSet);
			// if we don't find any observations in the registry for that namespace, then we need to create the namespace and register the observation set based on the ID provided, then fetch the list again to build the deck
			const currentSettings = this.getCurrentSettingsForInput(pInput);
			if (observationListFromRegistry && observationListFromRegistry.length)
			{
				this.pict.log.info(`Found existing observation set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet} with ${observationListFromRegistry.length} observations.`);
				// If appendNewCardToStartOfDeck is enabled, detect new observations by comparing against
				// the previously tracked set of IDs and move them to the front of the list
				if (currentSettings.appendNewCardToStartOfDeck && this._previousObservationSetIDs?.[tmpNamespaceForIDObservationSet])
				{
					const previousIDs = this._previousObservationSetIDs[tmpNamespaceForIDObservationSet];
					const existingObs = observationListFromRegistry.filter((/** @type {any} */ o) => previousIDs.has(o.IDObservation));
					const newObs = observationListFromRegistry.filter((/** @type {any} */ o) => !previousIDs.has(o.IDObservation));
					if (newObs.length)
					{
						observationListFromRegistry = [ ...newObs, ...existingObs ];
					}
				}
				// Track current IDs so the next remarshal can detect new additions
				this._previousObservationSetIDs[tmpNamespaceForIDObservationSet] = new Set(observationListFromRegistry.map((/** @type {any} */ o) => o.IDObservation));
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceForIDObservationSet, observationListFromRegistry);
				this.handleObservationSetEditButtonStateOnChange(pInput);
				return;
			}
			else
			{
				this.pict.log.warn(`No observation set found in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet}. Will attempt to create new namespace and compile observation list based on observation set ${tmpIDObservationSet}.`);
				observationListFromRegistry = await this.pict.providers.MediaRegistry.registerMediaSetByIDObservationSet(tmpNamespaceForIDObservationSet, tmpIDObservationSet);
				this.pict.log.info(`Registered new media set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet} with ${observationListFromRegistry.length} observations from observation set ID ${tmpIDObservationSet}.`);
				// Establish baseline IDs on first render so subsequent remarshals can detect new additions
				this._previousObservationSetIDs[tmpNamespaceForIDObservationSet] = new Set(observationListFromRegistry.map((/** @type {any} */ o) => o.IDObservation));
				this.prepareUIBeforeBuildingCardDeck(pView, pInput, tmpNamespaceForIDObservationSet, observationListFromRegistry);
				this.handleObservationSetEditButtonStateOnChange(pInput);
				return;
			}
		}
	}

	/**
	 * Sets the draggable configuration for the deck based on the current settings for the input, and registers the onDrop event handler to update the order of the cards in the registry when a card is dropped in a new position in the deck.
	 * @param {Object} pInput - The input object containing the macro and raw HTML ID.
	 * @param {Object} currentSettings - The current settings for the deck, which can be used to conditionally enable or disable dragging and dropping of cards based on the configuration of the deck (ex: preventing reordering of cards will disable dragging and dropping for reordering, but we may still want to allow dragging and dropping for moving cards between decks if we build that functionality in the future, so we can use different settings to control those different behaviors).
	 * @param {string} pNamespace - The namespace for the observation set associated with this deck, which is used to pull the list of observations from the registry and update the registry with the new order when cards are reordered in the deck.
	 */
	setDraggableConfigurationForDeck(pInput, currentSettings, pNamespace)
	{
		if (currentSettings.preventReorderingCards)
		{
			this.pict.log.info(`Card deck for input ${pNamespace} is set to prevent reordering of cards. Draggable configuration will not be applied to the deck.`);
			this.draggableConfigurationForDeck = { disabled: true };
			return;
		}
		this.draggableConfigurationForDeck = {
			limitToOwnCollection: true || currentSettings.preventCrossDeckDragging, // NOTE: Must be true until we build cross-apply filtering - see options above for more details
			disabled: this.isDocumentLocked || !this.canEditDocument || currentSettings.preventReorderingCards,
			elementSelector: `.${this.cardClassName}`,
			onDrop: async (/** @type {any} */ pItem, /** @type {any} */ pEvent) =>
			{
				const deckContainer = this.pict.ContentAssignment.getElement(this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID))?.[0];
				const currentObservationList = await this.pict.providers.MediaRegistry.getMediaSet(pNamespace);
				if (!deckContainer)
				{
					this.pict.log.error(`Could not find card deck container for input ${pNamespace} when handling drop event for card reordering. HTML ID used to query: ${this.getCardDeckContainerHTMLID(pInput.Macro.RawHTMLID)}. Cannot update card order in registry.`);
					return;
				}
				// update the MediaRegistry order based on the new order of the cards in the deck after the drop is completed
				const cardElements = deckContainer.querySelectorAll(`.${this.cardClassName}`);
				// get the array of ids in order
				const newOrderArray = Array.from(cardElements)
				.map((card) =>
				{
					const observationID = card.getAttribute(this.cardAttributeId);
					return parseInt(observationID);
				})
				.filter((id) => !isNaN(id));
				const newOrderList = [];
				// loop through the new order array and build a new ordered list of observation objects based on the new order of ids
				for (const [ i, obsID ] of newOrderArray.entries())
				{
					const obs = currentObservationList.find((/** @type {any} */ o) => o.IDObservation == obsID);
					// reset the ordinal for all obs and use the new order we pass in
					if (obs)
					{
						obs.Ordinal = i + 1;
						newOrderList.push(obs);
					}
				}
				this.pict.providers.MediaRegistry.registerMediaSet(pNamespace, newOrderList);
				_Pict.providers.ObservationCardDeckProvider.updateIndexNumbersOnUIForDeck(pInput, newOrderList);
				this.pict.log.info(`Cards reordered in deck for input ${pNamespace}.`);
			},
		};
	}

	/**
	 * Returns a Set of observation set IDs that are currently assigned to other card deck selectors on the form,
	 * excluding the given input's own set. Used to disable already-in-use options in the select2 dropdown.
	 *
	 * Validates that each entry's hidden input still exists in the DOM before including it.
	 * When a containing row (e.g. a bridge defect) is removed, the hidden input is destroyed
	 * but the dynamicGUIDMap entry can linger — without this check, deleted rows' sets stay
	 * permanently marked as "in use" in the remaining selectors.
	 * @param {Object} pInput - The input object (used to identify the current deck via RawHTMLID).
	 * @returns {Set<number>} - Set of IDObservationSet values in use by other decks.
	 */
	getObservationSetIDsInUseByOtherDecks(pInput)
	{
		const inUseIDs = new Set();
		const guidMap = this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap;
		for (const [ rawHTMLID, idObservationSet ] of Object.entries(guidMap))
		{
			if (rawHTMLID !== pInput.Macro.RawHTMLID && idObservationSet)
			{
				// Verify the hidden input still exists in the DOM — if the containing
				// row (e.g. a bridge defect) was deleted, the input is gone and
				// this entry is stale.
				const hiddenInput = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(rawHTMLID))?.[0];
				if (hiddenInput)
				{
					inUseIDs.add(Number(idObservationSet));
				}
				else
				{
					// Prune the stale entry so it doesn't accumulate across sessions
					delete guidMap[rawHTMLID];
				}
			}
		}
		return inUseIDs;
	}

	/**
	 * Returns the fallback display label used before the real saved Name has been fetched.
	 * @param {string|number|null} pIDObservationSet - The observation set ID, or null for a brand-new (unsaved) set.
	 * @returns {string}
	 */
	getFallbackObservationSetLabel(pIDObservationSet)
	{
		return pIDObservationSet ? `Observation Set ${pIDObservationSet}` : 'New Observation Set';
	}

	/**
	 * Returns the cached saved Name for an observation set, or null if no resolved value is in the cache yet.
	 * Pending in-flight fetches (Promise values) are treated as uncached so callers fall back to the placeholder label.
	 * @param {string|number|null} pIDObservationSet - The observation set ID to look up.
	 * @returns {string|null}
	 */
	getCachedObservationSetName(pIDObservationSet)
	{
		if (!pIDObservationSet)
		{
			return null;
		}
		const cached = this._observationSetNameCache[String(pIDObservationSet)];
		return typeof cached === 'string' ? cached : null;
	}

	/**
	 * Detects Names that were auto-generated by createNewObservationSetForCardDeck / handleConfirmCreateSetModal —
	 * both of those append a Date.toLocaleString()-style "(M/D/YYYY, H:MM:SS AM)" timestamp to the set label.
	 * Names matching that signature are ugly to show to users, so the UI treats them as "unnamed" and falls back to "Observation Set {id}".
	 *
	 * The match is anchored to the start of the string so that names with a meaningful prefix
	 * (e.g. "Elevation Photo (5/23/2025, 11:48:24 AM)") are preserved as-is in the UI.
	 * Only names that consist *entirely* of a timestamp are treated as auto-generated.
	 * @param {string|null|undefined} pName - The set Name to check.
	 * @returns {boolean}
	 */
	isAutoGeneratedSetName(pName)
	{
		if (!pName || !String(pName).trim())
		{
			return true;
		}
		return /^\s*\(?\s*\d{1,2}\/\d{1,2}\/\d{2,4},?\s+\d{1,2}:\d{1,2}(:\d{1,2})?\s*(AM|PM)?\s*\)?\s*$/i.test(pName);
	}

	/**
	 * Returns the label to show in the deck header for an observation set: the user-given Name when set, or "Observation Set {id}" otherwise.
	 * Names detected as auto-generated by isAutoGeneratedSetName are treated as unset so users don't see timestamp noise in the header.
	 * @param {string|number|null} pIDObservationSet - The observation set ID.
	 * @returns {string}
	 */
	getDisplayLabelForObservationSet(pIDObservationSet)
	{
		const cachedName = this.getCachedObservationSetName(pIDObservationSet);
		if (cachedName && !this.isAutoGeneratedSetName(cachedName))
		{
			return cachedName;
		}
		return this.getFallbackObservationSetLabel(pIDObservationSet);
	}

	/**
	 * Fetches the saved Name for an observation set (cached by ID). Returns the fallback label on failure so callers always get a usable string.
	 * @param {string|number} pIDObservationSet - The observation set ID to look up.
	 * @returns {Promise<string>} - Resolves to the saved Name, or the fallback "Observation Set {id}" label if the fetch fails.
	 */
	async fetchObservationSetName(pIDObservationSet)
	{
		if (!pIDObservationSet)
		{
			return this.getFallbackObservationSetLabel(pIDObservationSet);
		}
		const cacheKey = String(pIDObservationSet);
		const cached = this._observationSetNameCache[cacheKey];
		if (cached)
		{
			return cached;
		}
		const tmpPromise = (async () =>
		{
			try
			{
				const tmpSet = await this.pict.providers.ObservationSetProvider.loadSet(pIDObservationSet);
				const tmpName = tmpSet?.Name || this.getFallbackObservationSetLabel(pIDObservationSet);
				this._observationSetNameCache[cacheKey] = tmpName;
				return tmpName;
			}
			catch (error)
			{
				this.pict.log.error(`Error loading observation set ${pIDObservationSet} for label: ${error}`);
				delete this._observationSetNameCache[cacheKey];
				return this.getFallbackObservationSetLabel(pIDObservationSet);
			}
		})();
		this._observationSetNameCache[cacheKey] = tmpPromise;
		return tmpPromise;
	}

	/**
	 * Builds the option element for the current observation set ID and updates the select element with it.
	 * @param {Object} pInput - The input object containing the macro and raw HTML ID.
	 * @param {string|number} tmpIDObservationSet - The ID of the current observation set.
	 */
	buildSetSelectorOptionForCurrentObservationSetID(pInput, tmpIDObservationSet)
	{
		// update the selector with the current IDObservationSet value so that if the user changes the filters and we need to re-render the deck,
		// we know which observation set ID to pull from the registry to get the updated list of observations to render in the deck based on the selected filters
		const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetSelectorHTMLID(pInput.Macro.RawHTMLID))?.[0];
		if (!tmpSelectElement)
		{
			this.pict.log.error(`Could not find select element for observation set selector with HTML ID ${this.getCardDeckHeaderObservationSetSelectorHTMLID(pInput.Macro.RawHTMLID)}. Cannot update selector value for Observation Set ID ${tmpIDObservationSet}.`);
			this.removeInitialLoadingMessage(pInput);
			return;
		}
		// only create and select an option when we have a valid observation set ID —
		// when NaN (no set yet), leave the selector on the empty placeholder so it renders
		// as "Select a set..." and the user must explicitly create or pick one
		const hasValidSetID = !isNaN(Number(tmpIDObservationSet)) && tmpIDObservationSet !== null;
		if (hasValidSetID)
		{
			// build the prefilled value for the select dropdown.
			// Prefer the user-given Name (pre-populated in the set-name cache before render) and fall back to "Observation Set {id}"
			// for unnamed/auto-timestamped sets so re-renders stay stable and users don't see ugly defaults.
			const tmpOption = tmpSelectElement.querySelector(`[value="${tmpIDObservationSet}"]`) || document.createElement('option');
			tmpOption.value = tmpIDObservationSet;
			tmpOption.text = this.getDisplayLabelForObservationSet(tmpIDObservationSet);
			tmpOption.selected = true;
			if (!tmpSelectElement.querySelector(`[value="${tmpIDObservationSet}"]`))
			{
				tmpSelectElement.appendChild(tmpOption);
			}
		}
		else
		{
			// ensure the placeholder <option value=""> is selected so Select2 shows "Select a set..."
			const tmpPlaceholderOption = tmpSelectElement.querySelector('option[value=""]');
			if (tmpPlaceholderOption)
			{
				tmpPlaceholderOption.selected = true;
			}
		}
		// initialize the select2 dropdown on the selector element if it's available, which will handle the searching and selecting of different observation sets to display in the deck
		// if the user wants to switch to a different set
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpConfigOptions = {
				Input: pInput,
				SearchFallbackPlaceholder: `Select Observation Set...`,
				ApplySort: true,
				Disabled: this.isDocumentLocked || !this.canEditDocument,
				HandleSearchFilters: (/** @type {string[]} */ pFilters) =>
				{
					const customFilter = this.pict.AppData.ObservationCardDeckProvider.customHandleSearchFiltersForSelector;
					if (typeof customFilter === 'function')
					{
						return customFilter(pFilters);
					}
					if (this.pict.AppData?.DocumentData?.ReportData?.IDProject)
					{
						pFilters.push('FBV~IDProject~EQ~' + this.pict.AppData?.DocumentData?.ReportData?.IDProject);
					}
					return pFilters;
				},
			};
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('ObservationSet', tmpConfigOptions);
			// Override noResults to show a contextual message when document scope filter is
			// active but no sets exist on this document yet, instead of generic "No results found."
			const providerAppData = this.pict.AppData.ObservationCardDeckProvider;
			tmpSelectOptions.language = Object.assign({}, tmpSelectOptions.language, {
				noResults: () =>
				{
					if (providerAppData?.documentScopeEmptyState)
					{
						return 'No sets created in this document yet';
					}
					return 'No results found.';
				},
			});
			// Wrap processResults to disable observation sets already in use by other card decks
			const originalProcessResults = tmpSelectOptions.ajax.processResults;
			tmpSelectOptions.ajax.processResults = (/** @type {any} */ data, /** @type {any} */ params) =>
			{
				const pageInfo = originalProcessResults(data, params);
				const inUseIDs = this.getObservationSetIDsInUseByOtherDecks(pInput);
				for (const result of pageInfo.results)
				{
					if (inUseIDs.has(Number(result.id)))
					{
						result.disabled = true;
						result.text = result.text + ' (in use)';
					}
				}
				return pageInfo;
			};
			window['jQuery'](tmpSelectElement).select2(tmpSelectOptions);
			// when no valid set ID, explicitly clear Select2's internal selection so it shows the placeholder
			// (Select2 can cache stale selections from prior initializations on the same DOM element)
			if (!hasValidSetID)
			{
				window['jQuery'](tmpSelectElement).val('').trigger('change.select2');
			}
		}
	}

	/**
	 * Sets the current settings for the given input in the dynamicSettings, which is used to store the configuration settings for each input separately so that we can apply different configurations to different decks on the same page if needed.
	 * @param {Object} pInput - The input object to set the settings for (used to access the input hash for storing in the dynamicSettings).
	 * @param {Object} pSettings - The settings object to set for the given input, see defaultConfiguration for the structure of this object and what settings are available to be set for each input.
	 */
	setCurrentSettingsForInput(pInput, pSettings)
	{
		const tmpSettings = JSON.parse(JSON.stringify(Object.assign({}, this.defaultConfiguration, this.patchedConfiguration[pInput?.PictForm?.InputType], pSettings)));
		// guard: normalize indexTagScope to 'local' if it's not a recognized value
		if (tmpSettings.indexTagScope !== 'local' && tmpSettings.indexTagScope !== 'document')
		{
			tmpSettings.indexTagScope = 'local';
		}
		// apply address-based overrides registered by consuming views (e.g. bridge element conditions)
		// These take precedence over patchedConfiguration and pSettings but yield to persisted user overrides.
		const addressOverrides = this.pict.AppData.ObservationCardDeckProvider?.settingsOverridesByInputAddress?.[pInput?.Address];
		if (addressOverrides)
		{
			Object.assign(tmpSettings, JSON.parse(JSON.stringify(addressOverrides)));
		}
		// apply any persisted user-toggled overrides (from FormData) so they survive save/reload and remarshals within a session
		const persistedOverrides = this.getPersistedOverridesForInput(pInput);
		if (persistedOverrides)
		{
			Object.assign(tmpSettings, persistedOverrides);
		}
		// alwaysExcludeObservationSets is a structural override that cannot be toggled by the user —
		// force excludeObservationSets on AFTER all other merges so nothing can turn it off.
		if (tmpSettings.alwaysExcludeObservationSets)
		{
			tmpSettings.excludeObservationSets = true;
		}
		this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[pInput.Hash] = tmpSettings;
		return tmpSettings;
	}

	/**
	 * Gets the current settings for the given input from the dynamicSettings, or returns the default settings if no settings are set for that input.
	 * @param {Object} pInput - The input object to get the settings for (used to access the input hash for looking up in the dynamicSettings).
	 * @returns {Object} - The settings object for the given input, either from the dynamicSettings or the default settings if no settings are set.
	 */
	getCurrentSettingsForInput(pInput)
	{
		return this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[pInput.Hash] || this.defaultConfiguration;
	}

	/**
	 * Sets the current filters for the given input as a sub-object of the input's settings. This keeps all deck configuration in one collection
	 * while still allowing filters to be set independently from other settings.
	 * @param {Object} pInput - The input object to set the filters for (used to access the input hash for storing in the settings).
	 * @param {Object} filters - The filters object to set for the given input, which should have the structure of { Include: { ObservationTypes: [], LabelTypes: [] }, Exclude: { ObservationTypes: [], LabelTypes: [] } } or a subset of those properties depending on what filters are being applied.
	 */
	setCurrentFiltersForInput(pInput, filters)
	{
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		// When no Include ObservationTypes are explicitly configured, default to the supported media
		// types so that non-media observations (e.g. Weather) don't leak into the deck display.
		// Mark with _isDefaultTypeFilter so hasFiltersApplied can distinguish injected defaults from
		// explicit user/config filters — the default should not trigger filter tag rendering in the header.
		if (!filters?.Include?.ObservationTypes?.length)
		{
			if (!filters.Include)
			{
 filters.Include = {};
			}
			filters.Include.ObservationTypes = [ ...this.actionableObservationTypes ];
			filters._isDefaultTypeFilter = true;
		}
		else
		{
			delete filters._isDefaultTypeFilter;
		}
		currentSettings.filters = filters;
		this.pict.AppData.ObservationCardDeckProvider.dynamicSettingsMap[pInput.Hash] = currentSettings;
		return filters;
	}

	/**
	 * Checks whether the given input's deck has filters applied and those filters are all "actionable" —
	 * meaning we can safely allow Add/Remove/QuickCapture on the deck because:
	 * - ObservationType filters (if any) only include media types that quick capture/upload naturally produces
	 * - LabelType filters (if any) can be auto-applied to new observations
	 * - No Description filters are present (not supported)
	 * @param {Object} pInput - The input object to check filters for.
	 * @returns {boolean} - True if filters are applied and all are actionable.
	 */
	hasActionableFilters(pInput)
	{
		if (!this.hasFiltersApplied(pInput))
		{
			return false;
		}
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		for (const filterDirection of [ 'Include', 'Exclude' ])
		{
			if (currentFilters[filterDirection]?.Descriptions?.length)
			{
				return false;
			}
			const obsTypes = currentFilters[filterDirection]?.ObservationTypes;
			if (obsTypes?.length && !obsTypes.every((/** @type {any} */ t) => this.actionableObservationTypes.includes(t)))
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * Checks whether a single observation's ObservationType passes the deck's Include/Exclude ObservationType filters.
	 * Returns true when no ObservationType filters are configured (i.e. unrestricted decks always pass).
	 * Used as a gate before adding observations to filtered decks so that mismatched types are rejected
	 * with a user-visible warning instead of silently disappearing from the deck.
	 * @param {Object} pInput - The input object whose current filters should be checked.
	 * @param {Object} pObservation - The observation record (must have an `ObservationType` field).
	 * @returns {boolean} True if the observation is allowed by the filters, false if it should be rejected.
	 */
	observationMatchesTypeFilter(pInput, pObservation)
	{
		if (!pObservation?.ObservationType)
		{
			return true; // no type to check — allow
		}
		// When no explicit filters are configured, default to only allowing the supported media types
		// (Legacy Image, Legacy Video, Legacy Audio, File). We haven't built e2e support for other
		// observation types yet, so this prevents users from depending on unsupported types.
		if (!this.hasFiltersApplied(pInput))
		{
			return this.actionableObservationTypes.includes(pObservation.ObservationType);
		}
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const includeTypes = currentFilters?.Include?.ObservationTypes;
		if (includeTypes?.length && !includeTypes.includes(pObservation.ObservationType))
		{
			return false; // observation type not in the Include list
		}
		const excludeTypes = currentFilters?.Exclude?.ObservationTypes;
		if (excludeTypes?.length && excludeTypes.includes(pObservation.ObservationType))
		{
			return false; // observation type is in the Exclude list
		}
		return true;
	}

	/**
	 * Shows a transient user-facing warning when an observation's type doesn't match the deck's filter.
	 * Uses the Headlight notification system if available, otherwise falls back to a console warning.
	 * @param {Object} pInput - The input object (used for deck name context).
	 * @param {string} pObservationType - The observation's type that was rejected.
	 */
	showFilterMismatchWarning(pInput, pObservationType)
	{
		const deckName = pInput?.Name || 'this deck';
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const allowedTypes = currentFilters?.Include?.ObservationTypes || [];
		const allowedLabel = (allowedTypes.length ? allowedTypes : this.actionableObservationTypes).map((/** @type {string} */ t) => t.replace(/^Legacy\s*/, '')).join(', ');
		const displayType = pObservationType.replace(/^Legacy\s*/, '');
		const message = `Cannot add "${displayType}" observation to ${deckName} — this deck only accepts: ${allowedLabel}.`;
		// Use the Headlight notification/toast system if available, otherwise fall back to a basic alert
		if (this.pict?.views?.HeadlightNotifications?.addNotification)
		{
			this.pict.views.HeadlightNotifications.addNotification({ message: message, type: 'warning', duration: 5000 });
		}
		else if (this.pict?.providers?.Informary?.addWarning)
		{
			this.pict.providers.Informary.addWarning(message);
		}
		else
		{
			this.pict.log.warn(message);
		}
	}

	/**
	 * Applies the Include LabelType filters from the deck's current filter configuration to a newly created observation,
	 * so that it matches the filter criteria and appears in the filtered deck. Only applies labels that are not already
	 * present on the observation. Persists the updated observation to the server.
	 * @param {Object} pInput - The input object to get the filters from.
	 * @param {Object} pObservationRecord - The observation record to apply labels to.
	 */
	async applyFilterLabelsToObservation(pInput, pObservationRecord)
	{
		const currentFilters = this.getCurrentFiltersForInput(pInput);
		const includeLabelFilters = currentFilters?.Include?.LabelTypes;
		if (!includeLabelFilters?.length)
		{
			return;
		}
		// Build the Tags array as tag value strings — the API expects Tags as string values (not IDs or objects)
		const existingTags = Array.isArray(pObservationRecord.Tags) ? pObservationRecord.Tags.filter((/** @type {any} */ t) => t != null) : [];
		/**
		 * @type {any[]}
		 */
		const tagsToAdd = [];
		for (const labelFilter of includeLabelFilters)
		{
			for (const tagValue of labelFilter.Values)
			{
				if (!existingTags.includes(tagValue) && !tagsToAdd.includes(tagValue))
				{
					tagsToAdd.push(tagValue);
				}
			}
		}
		if (!tagsToAdd.length)
		{
			return;
		}
		pObservationRecord.Tags = [ ...existingTags, ...tagsToAdd ];
		await this.pict.providers.ObservationProvider.updateObservation(pObservationRecord, () =>
		{
			this.pict.log.info(`Applied filter labels to observation ${pObservationRecord.IDObservation}: Tags=${pObservationRecord.Tags}`);
		});
	}

	/**
	 * Gets the current filters for the given input from the settings, or returns an empty object if no filters are set for that input.
	 * @param {Object} pInput - The input object to get the filters for (used to access the input hash for looking up in the settings).
	 * @returns {Object} - The filters object for the given input from the settings, or an empty object if no filters are set.
	 */
	getCurrentFiltersForInput(pInput)
	{
		return this.getCurrentSettingsForInput(pInput).filters || {};
	}

	/**
	 * Returns true if the given input's deck has any Include or Exclude filters applied (non-empty filter keys).
	 * When only the default actionable-type filter has been injected (marked by `_isDefaultTypeFilter`),
	 * this returns false so that UI paths (header tags, exclude-sets toggle) treat the deck as unfiltered.
	 * The injected defaults still apply at the data-filtering level — callers that need the raw filter
	 * arrays (e.g. `observationMatchesTypeFilter`) read them directly from `getCurrentFiltersForInput`.
	 * @param {Object} pInput - The input object to check filters for.
	 * @returns {boolean}
	 */
	hasFiltersApplied(pInput)
	{
		const currentFilters = this.getCurrentFiltersForInput(pInput);

		// When the only populated filter is the injected default ObservationTypes (matching the
		// actionableObservationTypes list exactly), treat as "no filters" for UI purposes — the toggle,
		// header tags, and add-button visibility should behave as if the deck is unfiltered.
		// The defaults still gate observations at the data level via observationMatchesTypeFilter.
		// We check both the `_isDefaultTypeFilter` flag AND a content-based comparison so the detection
		// survives code paths that deep-clone or re-spread settings without preserving the flag.
		const isDefaultOnly = this._isOnlyDefaultTypeFilter(currentFilters);
		if (isDefaultOnly)
		{
			return false;
		}

		return Object.keys(currentFilters).some((key) =>
		{
			if (key === '_isDefaultTypeFilter')
			{
				return false;
			}
			const val = currentFilters[key];
			return val && typeof val === 'object' && Object.keys(val).length > 0;
		});
	}

	/**
	 * Returns true when the given filters object contains ONLY the injected default ObservationTypes
	 * (matching `actionableObservationTypes` exactly) and no other explicit filter criteria.
	 * Uses a flag-first check for speed, then falls back to a content comparison so deep-cloned
	 * or re-spread filter objects are still recognized as defaults.
	 * @param {Object} currentFilters - The filters object from getCurrentFiltersForInput.
	 * @returns {boolean}
	 */
	_isOnlyDefaultTypeFilter(currentFilters)
	{
		if (!currentFilters)
		{
			return true;
		} // no filters at all

		// Quick check: if there are any Exclude entries with values, this is not default-only
		if (currentFilters.Exclude && Object.keys(currentFilters.Exclude).some((k) => currentFilters.Exclude[k]?.length > 0))
		{
			return false;
		}
		// Quick check: if there are Include entries beyond ObservationTypes, this is not default-only
		if (currentFilters.Include)
		{
			const includeKeys = Object.keys(currentFilters.Include);
			if (includeKeys.some((k) => k !== 'ObservationTypes' && currentFilters.Include[k]?.length > 0))
			{
				return false;
			}
		}

		// Flag-based check: if the flag was set by setCurrentFiltersForInput and survived, trust it
		if (currentFilters._isDefaultTypeFilter)
		{
			return true;
		}

		// Content-based fallback: compare Include.ObservationTypes to actionableObservationTypes
		const includeTypes = currentFilters.Include?.ObservationTypes;
		if (!includeTypes?.length)
		{
			return true; // no Include types at all — treat as default (empty/unfiltered)
		}
		// Match if the Include types are exactly the actionable defaults (same items, same order)
		if (includeTypes.length !== this.actionableObservationTypes.length)
		{
			return false;
		}
		return includeTypes.every((/** @type {string} */ t, /** @type {number} */ i) => t === this.actionableObservationTypes[i]);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object (NOTE: Doesn't work on buttons)
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {boolean}
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		// Read the newly selected value from the set selector dropdown (where the user made their choice).
		// Only fall back to the hidden input when the selector element doesn't exist (non-selector cases).
		// When the selector exists, always trust its value — an empty string means the user cleared the selection.
		const tmpSelectorElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetSelectorHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const tmpInputSelectValue = tmpSelectorElement ? tmpSelectorElement.value : this.pict.ContentAssignment.readContent(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID));
		// Write the new value to both the hidden input and the form data address so the value is persisted
		this.pict.ContentAssignment.assignContent(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpInputSelectValue);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		// Keep the dynamicGUIDMap up to date so other deck selectors know which sets are in use
		if (tmpSelectorElement && tmpInputSelectValue)
		{
			this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID] = tmpInputSelectValue;
		}
		else if (tmpSelectorElement)
		{
			delete this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID];
		}
		// Only notify the framework of a data change when the resolved value actually differs from
		// the value that was passed in.  Previously, dataChanged() was called unconditionally which
		// triggered a full marshalToView() cycle on every onDataRequest invocation — even when the
		// value hadn't changed.  When a new defect row is added with an empty Observation Set value,
		// the marshal→request→dataChanged→marshal cycle would repeat indefinitely, causing an
		// infinite loop that locked up the browser.
		if (tmpInputSelectValue !== pValue)
		{
			pView.dataChanged(pInput.Hash);
			this.pict.log.info(`Observation Set selection changed for input ${pInput.Macro.RawHTMLID}. New value: ${tmpInputSelectValue}. Updating deck to reflect new selection.`);
			this.updateDeckForObservationSetSelectionChange(pInput, tmpInputSelectValue);
		}
		this.handleObservationSetEditButtonStateOnChange(pInput);
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * @param {any} pInput - The input object.
	 * @param {string} tmpInputSelectValue - The new value selected in the observation set selector.
	 */
	async updateDeckForObservationSetSelectionChange(pInput, tmpInputSelectValue)
	{
		const tmpParsedID = parseInt(tmpInputSelectValue);
		// Handle the "cleared" case — user cleared the selector, so reset the deck to an empty state
		if (!tmpInputSelectValue || isNaN(tmpParsedID))
		{
			this.pict.log.info(`Observation Set selector cleared for input ${pInput.Macro.RawHTMLID}. Resetting deck to empty state.`);
			const cardDeckContentElement = document.querySelector(this.getCardDeckContentHTMLID(pInput.Macro.RawHTMLID));
			if (cardDeckContentElement)
			{
				cardDeckContentElement.innerHTML = '';
			}
			this.updateEmptyMessageText(pInput, 'No observation set is currently selected.');
			this.toggleVisibilityForAddCardHeaderButtons(pInput);
			return;
		}
		// Restore the default empty message before building the deck with the new set
		const currentSettings = this.getCurrentSettingsForInput(pInput);
		this.updateEmptyMessageText(pInput, currentSettings.customEmptyStateMessage);
		const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInput.Hash, tmpParsedID);
		try
		{
			// Populate the set-name cache before rendering so the header label uses the saved Name on first paint
			await this.fetchObservationSetName(tmpParsedID);
			let observationListFromRegistry = await this.pict.providers.MediaRegistry.getObservationSetByNamespace(tmpNamespaceForIDObservationSet);
			if (observationListFromRegistry && observationListFromRegistry.length)
			{
				this.pict.log.info(`Found existing observation set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet} with ${observationListFromRegistry.length} observations. Updating deck to display this set.`);
			}
			else
			{
				// Set not yet in registry — fetch it from the server and register it so the deck can display it
				this.pict.log.info(`No observation set in MediaRegistry for namespace ${tmpNamespaceForIDObservationSet}. Fetching and registering set ${tmpParsedID}.`);
				observationListFromRegistry = await this.pict.providers.MediaRegistry.registerMediaSetByIDObservationSet(tmpNamespaceForIDObservationSet, tmpParsedID);
			}
			this.prepareUIBeforeBuildingCardDeck(this.pict.views[pInput.ViewHash], pInput, tmpNamespaceForIDObservationSet, observationListFromRegistry);
		}
		catch (error)
		{
			this.pict.log.error(`Error updating deck for observation set selection change (namespace: ${tmpNamespaceForIDObservationSet}): ${error}.`);
		}
	}

	/**
	 * Handles the click event for the manage set button.
	 * @param {string} pRawID - The id of the hidden input element.
	 * @param {string} pViewHash - The hash of the view.
	 * @param {string} pInputHash - The hash of the input.
	 */
	async handleObservationSetEditButtonClick(pRawID, pViewHash, pInputHash)
	{
		// set the button to loading state
		const tmpButton = document.querySelector(this.getCardDeckHeaderObservationSetEditButtonHTMLID(pRawID));
		if (tmpButton)
		{
			tmpButton.classList.add('is-loading');
		}
		// handle the empty message display
		let tmpSetId = 0;
		// check if the user has selected a new set name from the dropdown or an existing set
		const tmpEl = document.querySelector(this.getCardDeckHeaderObservationSetSelectorHTMLID(pRawID));
		if (!(tmpEl instanceof HTMLSelectElement))
		{
			// set the button to normal state
			if (tmpButton)
			{
				tmpButton.classList.remove('is-loading');
			}
			return;
		}
		const tmpSelectedValue = tmpEl.value;
		if (tmpSelectedValue && !isNaN(parseInt(tmpSelectedValue)))
		{
			tmpSetId = parseInt(tmpSelectedValue);
		}
		this.pict.fable.services.HeadlightPanels.applyUIHighlight(this.getCardDeckContentHTMLID(pRawID));
		// open the image panel for the user to select images
		this.pict.views.ObservationSet.handleFormManageSetButtonClick(tmpSetId, () =>
		{
			// set the button to normal state
			if (tmpButton)
			{
				tmpButton.classList.remove('is-loading');
			}
			this.pict.views.ObservationSet.handlePanelAddObservationButtonClick(null);
		});
	}

	/**
	 * Handles the click event for the create set button. Opens a modal with a name input and optional next-action selector.
	 * @param {string} pRawID - The raw HTML ID of the hidden input element.
	 * @param {string} pViewHash - The view hash for resolving the input context.
	 * @param {string} pInputHash - The input hash for resolving the input context.
	 */
	async handleObservationSetCreateSetButtonClick(pRawID, pViewHash, pInputHash)
	{
		const inputEl = this.pict.ContentAssignment.getElement(`#${ pRawID }`)?.[0];
		if (!inputEl)
		{
			this.pict.log.warn('Could not find obs set input for create set modal.');
			return;
		}
		// store context so the confirm handler can resolve the correct view/input
		this._pendingCreateSetContext = { rawID: pRawID, viewHash: pViewHash, inputHash: pInputHash };
		// get the previously saved user preferences for the next action to take after the set is created
		const tmpNextAction = this.pict.views.HeadlightPaneSettings.readUserPreference('ObservationSetNextAction') || '';
		this.nextActionAfterCreate = tmpNextAction;
		// if we have a custom handler, use it instead of the default modal
		if (this.pict.AppData.ObservationCardDeckProvider.customHandleObservationSetCreateSetButtonClick)
		{
			const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(pRawID));
			if (tmpCreateButton)
			{
				tmpCreateButton.classList.add('is-loading');
			}
			await this.pict.AppData.ObservationCardDeckProvider.customHandleObservationSetCreateSetButtonClick(pRawID, tmpNextAction);
			if (tmpCreateButton)
			{
				tmpCreateButton.classList.remove('is-loading');
			}
			return;
		}
		// build modal body with set name input
		const modalBodyTemplate = /*html*/`
			<div class="columns is-mobile">
				<div class="column">
					<div class="field">
						<label class="label">Set Name</label>
						<div class="control">
							<input class="input is-fullwidth" id="ObservationSetCreateNameInput" type="text" value="New Observation Set" placeholder="New Observation Set" onfocus="this.select()" />
						</div>
					</div>
				</div>
			</div>`;
		// build modal footer with next-action selector on the left and action buttons on the right
		const modalFooterTemplate = /*html*/`
			<div class="columns is-flex-grow-1 is-vcentered">
				<div class="column">
					<div class="field">
						<div class="control select is-fullwidth">
							<select id="CreateSetNextActionSelect">
								<option value="" ${ !tmpNextAction ? 'selected' : '' }>Pick an action (optional)</option>
								<option value="manage" ${ tmpNextAction === 'manage' ? 'selected' : '' }>Manage Set</option>
								<option value="capture" ${ tmpNextAction === 'capture' ? 'selected' : '' }>Quick Capture</option>
							</select>
						</div>
					</div>
				</div>
				<div class="column is-narrow">
					<div class="buttons is-right">
						<button type="button" class="button is-link is-soft" onclick="_Pict.providers.ObservationCardDeckProvider.handleCancelCreateSetModal()">
							<span class="icon"><i class="fas fa-fw fa-times"></i></span>
							<span>Cancel</span>
						</button>
						<button type="button" class="button is-link" onclick="_Pict.providers.ObservationCardDeckProvider.handleConfirmCreateSetModal()">
							<span class="icon"><i class="fas fa-fw fa-plus"></i></span>
							<span>Create New Set</span>
						</button>
					</div>
				</div>
			</div>`;
		this.fable.HeadlightModal.spawnModal({
			title: 'Create Observation Set',
			modalBodyTemplate: modalBodyTemplate,
			modalFooterTemplate: modalFooterTemplate,
			hideModalFooter: false,
			disableBackgroundClickToClose: true,
		});
		// set the button to loading state
		const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(pRawID));
		if (tmpCreateButton)
		{
			tmpCreateButton.classList.add('is-loading');
		}
	}

	/**
	 * Handles the cancel action for the create set modal. Dismisses the modal and removes the loading state from the create button.
	 */
	handleCancelCreateSetModal()
	{
		this.fable.HeadlightModal.dismissModals();
		if (this._pendingCreateSetContext)
		{
			const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(this._pendingCreateSetContext.rawID));
			if (tmpCreateButton)
			{
				tmpCreateButton.classList.remove('is-loading');
			}
			this._pendingCreateSetContext = null;
		}
	}

	/**
	 * Handles the confirm action for the create set modal. Creates the set, updates the selector and deck, then applies the selected next action.
	 */
	async handleConfirmCreateSetModal()
	{
		if (!this._pendingCreateSetContext)
		{
			this.pict.log.error('No pending create set context found. Cannot create set.');
			return;
		}
		const { rawID, viewHash, inputHash } = this._pendingCreateSetContext;
		// read the set name from the modal input
		const tmpNameInput = /** @type {HTMLInputElement} */ (document.getElementById('ObservationSetCreateNameInput'));
		const tmpName = tmpNameInput?.value?.trim() || 'New Observation Set (' + new Date().toLocaleString() + ')';
		// read the next action selection and persist the preference
		const tmpNextActionSelect = /** @type {HTMLSelectElement} */ (document.getElementById('CreateSetNextActionSelect'));
		const tmpNextAction = tmpNextActionSelect?.value || '';
		this.nextActionAfterCreate = tmpNextAction;
		this.pict.views.HeadlightPaneSettings.updateUserPreferences('ObservationSetNextAction', tmpNextAction);
		// create and save the new observation set
		const tmpProjectId = this.pict.AppData?.DocumentData?.ReportData?.IDProject || null;
		const tmpNewSet = this.pict.providers.ObservationSetProvider.createSet(tmpName, tmpProjectId);
		let savedSet;
		try
		{
			savedSet = await this.pict.providers.ObservationSetProvider.saveSet(tmpNewSet);
		}
		catch (error)
		{
			this.pict.log.error(`Error creating observation set: ${error}`);
			this.handleCancelCreateSetModal();
			return;
		}
		const pView = this.pict.views[viewHash];
		const pInput = pView?.getInputFromHash(inputHash);
		// seed the set-name cache so header labels resolve immediately without a follow-up network fetch
		if (savedSet?.IDObservationSet && savedSet?.Name)
		{
			this._observationSetNameCache[String(savedSet.IDObservationSet)] = savedSet.Name;
		}
		// update the GUID map and hidden input with the new set ID
		this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[rawID] = savedSet.IDObservationSet;
		this.pict.ContentAssignment.assignContent(this.getHiddenInputHTMLID(rawID), savedSet.IDObservationSet);
		// update the select2 dropdown with the new set option
		const tmpSelectElement = document.querySelector(this.getCardDeckHeaderObservationSetSelectorHTMLID(rawID));
		if (tmpSelectElement && window['jQuery'])
		{
			const newOption = new Option(savedSet.Name, `${ savedSet.IDObservationSet }`, true, true);
			window['jQuery'](tmpSelectElement).append(newOption).trigger('change');
		}
		// marshal the form data so the new value is persisted
		if (pView && pInput)
		{
			pView.dataChanged(pInput.Hash);
		}
		// invoke the custom post-create callback if registered (e.g. bridge defect sequence number increment)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetCreated === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetCreated(savedSet, pInput);
		}
		// auto-save the document if applicable
		if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument)
		{
			this.pict.providers.DocumentProvider.handleSave(true);
		}
		// update the deck to display the new (empty) set
		if (pInput)
		{
			await this.updateDeckForObservationSetSelectionChange(pInput, `${ savedSet.IDObservationSet }`);
			this.handleObservationSetEditButtonStateOnChange(pInput);
		}
		// dismiss the modal and clear loading state
		this.fable.HeadlightModal.dismissModals();
		const tmpCreateButton = document.querySelector(this.getCardDeckHeaderObservationSetCreateButtonHTMLID(rawID));
		if (tmpCreateButton)
		{
			tmpCreateButton.classList.remove('is-loading');
		}
		this._pendingCreateSetContext = null;
		// apply the next action if one was selected
		if (tmpNextAction === 'manage')
		{
			this.handleObservationSetEditButtonClick(rawID, viewHash, inputHash);
		}
		else if (tmpNextAction === 'capture')
		{
			// programmatically trigger the quick capture file input
			const tmpQuickCaptureLabel = document.querySelector(this.getCardDeckHeaderActionsButtonQuickCaptureHTMLID(rawID));
			const tmpFileInput = /** @type {HTMLInputElement} */ (tmpQuickCaptureLabel?.querySelector('input[type="file"]'));
			if (tmpFileInput)
			{
				tmpFileInput.click();
			}
		}
	}

	/**
	 * Sets a custom handler for the create set button click event.
	 * @param {Function} pFunction - The custom handler function.
	 */
	setCustomHandleObservationSetCreateSetButtonClick(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customHandleObservationSetCreateSetButtonClick = pFunction;
	}

	/**
	 * Sets a custom callback invoked after a new observation set is created via the create set modal.
	 * Useful for external components that need to perform additional actions after set creation (e.g. incrementing sequence numbers).
	 * @param {Function} pFunction - Callback receiving (pSavedSet, pInput).
	 */
	setCustomOnAfterObservationSetCreated(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetCreated = pFunction;
	}

	/**
	 * Sets a custom callback invoked after an observation is added to or removed from an observation set.
	 * Useful for external components that need to react to set content changes (e.g. updating photo count labels).
	 * @param {Function} pFunction - Callback receiving (pInput, pIDObservation, pObservationSet).
	 */
	setCustomOnAfterObservationSetChanged(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged = pFunction;
	}

	/**
	 * Sets a document-level context callback invoked after observation set content changes.
	 * Useful for triggering broader document recalculations (e.g. orphan observation list reorganization).
	 * @param {Function} pFunction - Callback receiving no arguments.
	 */
	setDocumentContextCallback(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.documentContextCallback = pFunction;
	}

	/**
	 * Sets a custom HandleSearchFilters callback for the observation set selector's Select2 AJAX query.
	 * When provided, this replaces the default project-scoped filter. The callback receives the current
	 * filter array and should return the modified filter array.
	 * @param {((pFilters: string[]) => string[]) | null} pFunction - The custom filter callback, or null to reset.
	 */
	setCustomHandleSearchFiltersForSelector(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customHandleSearchFiltersForSelector = pFunction;
	}

	/**
	 * Sets a custom callback invoked after the CardDeck finishes marshalling and rendering cards for an input.
	 * Useful for external components that need to react to deck content after the DOM is populated (e.g. updating photo count labels on initial load or set selection).
	 * @param {Function} pFunction - Callback receiving (pInput, pObservationList).
	 */
	setCustomOnAfterMarshal(pFunction)
	{
		this.pict.AppData.ObservationCardDeckProvider.customOnAfterMarshal = pFunction;
	}

	/**
	 * Opens the inline rename modal for an observation set attached to a non-selector card deck.
	 * Triggered by the pencil icon rendered next to the static set label.
	 * @param {string} pRawHTMLID - The raw HTML ID of the deck input, used to locate the display container on confirm.
	 * @param {number|string} pIDObservationSet - The set to rename.
	 */
	async handleInlineRenameSetClick(pRawHTMLID, pIDObservationSet)
	{
		if (!pIDObservationSet || this.isDocumentLocked || !this.canEditDocument)
		{
			return;
		}
		let tmpSet;
		try
		{
			tmpSet = await this.pict.providers.ObservationSetProvider.loadSet(pIDObservationSet);
		}
		catch (error)
		{
			this.pict.log.error(`Error loading observation set ${pIDObservationSet} for rename: ${error}`);
			return;
		}
		if (!tmpSet)
		{
			this.pict.log.error(`No observation set record returned for ID ${pIDObservationSet}. Cannot open rename modal.`);
			return;
		}
		// If the stored name is auto-generated (timestamped), start with an empty input so the user isn't renaming the timestamp
		const tmpInitialValue = this.isAutoGeneratedSetName(tmpSet.Name) ? '' : (tmpSet.Name || '');
		const tmpFallbackLabel = this.getFallbackObservationSetLabel(pIDObservationSet);
		this._pendingRenameSetContext = { rawHTMLID: pRawHTMLID, idObservationSet: pIDObservationSet, setRecord: tmpSet };
		const tmpInitialValueEscaped = tmpInitialValue.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		const tmpFallbackEscaped = tmpFallbackLabel.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		const modalBodyTemplate = /*html*/`
			<div class="columns is-mobile">
				<div class="column">
					<div class="field">
						<label class="label">Set Name</label>
						<div class="control">
							<input class="input is-fullwidth" id="ObservationSetRenameInput" type="text" value="${tmpInitialValueEscaped}" placeholder="${tmpFallbackEscaped}" onfocus="this.select()" />
						</div>
						<p class="help">Leave blank to keep the default "${tmpFallbackEscaped}" label.</p>
					</div>
				</div>
			</div>`;
		const modalFooterTemplate = /*html*/`
			<div class="buttons is-right is-flex-grow-1">
				<button type="button" class="button is-link is-soft" onclick="_Pict.providers.ObservationCardDeckProvider.handleCancelRenameSetModal()">
					<span class="icon"><i class="fas fa-fw fa-times"></i></span>
					<span>Cancel</span>
				</button>
				<button type="button" class="button is-link" onclick="_Pict.providers.ObservationCardDeckProvider.handleConfirmRenameSetModal()">
					<span class="icon"><i class="fas fa-fw fa-check"></i></span>
					<span>Save</span>
				</button>
			</div>`;
		this.fable.HeadlightModal.spawnModal({
			title: 'Rename Observation Set',
			modalBodyTemplate: modalBodyTemplate,
			modalFooterTemplate: modalFooterTemplate,
			hideModalFooter: false,
			disableBackgroundClickToClose: true,
		});
	}

	/**
	 * Handles the cancel action for the rename set modal. Dismisses the modal and clears pending context.
	 */
	handleCancelRenameSetModal()
	{
		this.fable.HeadlightModal.dismissModals();
		this._pendingRenameSetContext = null;
	}

	/**
	 * Handles the confirm action for the rename set modal. Saves the new name to the server, updates the set-name cache,
	 * and refreshes the header label so the change is reflected immediately without requiring a full remarshal.
	 */
	async handleConfirmRenameSetModal()
	{
		if (!this._pendingRenameSetContext)
		{
			this.pict.log.error('No pending rename set context found. Cannot save rename.');
			return;
		}
		const { rawHTMLID, idObservationSet, setRecord } = this._pendingRenameSetContext;
		const tmpInput = /** @type {HTMLInputElement} */ (document.getElementById('ObservationSetRenameInput'));
		const tmpNewName = tmpInput?.value?.trim() || '';
		// Empty input → keep the previously-stored Name unchanged; display logic will still show the fallback label if it's auto-generated
		const tmpNameToSave = tmpNewName || setRecord.Name || this.getFallbackObservationSetLabel(idObservationSet);
		// Short-circuit if nothing actually changed
		if (tmpNameToSave === setRecord.Name)
		{
			this.handleCancelRenameSetModal();
			return;
		}
		setRecord.Name = tmpNameToSave;
		try
		{
			await this.pict.providers.ObservationSetProvider.saveSet(setRecord);
		}
		catch (error)
		{
			this.pict.log.error(`Error saving renamed observation set ${idObservationSet}: ${error}`);
			this.handleCancelRenameSetModal();
			return;
		}
		// Update the cache so any subsequent re-render uses the new name synchronously
		this._observationSetNameCache[String(idObservationSet)] = tmpNameToSave;
		// Refresh the header label directly so the change appears without waiting for a full marshal cycle
		const tmpDisplayContainer = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetDisplayHTMLID(rawHTMLID))?.[0];
		const tmpTextSpan = tmpDisplayContainer?.querySelector('.icon-text');
		if (tmpTextSpan)
		{
			tmpTextSpan.textContent = this.getDisplayLabelForObservationSet(idObservationSet);
		}
		this.fable.HeadlightModal.dismissModals();
		this._pendingRenameSetContext = null;
	}

	/**
	 * Handle the state of the edit button based on the hidden input value.
	 * @param {Object} pInput - The input object.
	 */
	handleObservationSetEditButtonStateOnChange(pInput)
	{
		const tmpHiddenElement = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID))?.[0];
		const tmpValue = tmpHiddenElement instanceof HTMLInputElement && tmpHiddenElement.value;
		const tmpEditButton = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetEditButtonHTMLID(pInput.Macro.RawHTMLID))?.[0];
		if (!tmpValue)
		{
			tmpEditButton?.setAttribute('disabled', 'disabled');
		}
		else
		{
			tmpEditButton?.removeAttribute('disabled');
		}
	}

	/**
	 * Handles the the inline add button click event for the given input.
	 * This event is triggered when the user clicks the inline add button for an input.
	 * @param {Object} event - The event object.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {boolean} pQuickCaptureButton - Whether the button clicked was the quick capture button.
	 */
	async handleAddNewCardToDeckButtonEvent(event, pViewHash, pInputHash, pQuickCaptureButton = false)
	{
		const currentSettings = this.getCurrentSettingsForInput(this.pict.views[pViewHash].getInputFromHash(pInputHash));
		// The raw event target — for the Add button, this can be a child of the button (the icon
		// <span> or <i>) depending on where the click actually landed; for Quick Capture, this is
		// always the <input type="file"> (since the change event fires on the input).
		/** @type {HTMLElement} */
		const tmpRawEventTarget = event.target;
		// The visible button surface that should receive the `is-loading` class. Resolve via
		// event.currentTarget (the element the listener is attached to via onclick/onchange) when
		// it already has the .button class; otherwise climb to the nearest .button so the loading
		// state always lands on the visible button — for Quick Capture this is the wrapping <label>.
		/** @type {HTMLElement} */
		const currentButtonElement = (event.currentTarget && event.currentTarget.classList?.contains('button')) ? event.currentTarget : (tmpRawEventTarget?.closest?.('.button') || event.currentTarget || tmpRawEventTarget);
		let tmpView = this.pict.views[pViewHash];
		let tmpInput = tmpView.getInputFromHash(pInputHash);
		currentButtonElement.classList.add('is-loading');
		// track for panel-close cleanup — only the panel-opening (non-quick-capture) path can leave
		// this stuck if the user dismisses the panel without completing the add flow, but it's safe
		// to track quick capture too since handleAddCardToNewSetRecord/the upload path always reaches
		// its callback and unregisters synchronously after removing the class.
		this._pendingAddButtonElements.add(currentButtonElement);

		if (!currentSettings?.useObservationSet && this.hasFiltersApplied(tmpInput) && !this.hasActionableFilters(tmpInput))
		{
			this.pict.log.warn('Cannot add new observation through the card deck when non-label filters are applied on a non-set based deck.');
			currentButtonElement.classList.remove('is-loading');
			this._pendingAddButtonElements.delete(currentButtonElement);
			return false;
		}
		// for the Obeservation Set Path
		if (currentSettings.useObservationSet)
		{
			// if we are using observation sets, we need to make sure we have an observation set to add the new observation to,
			// since the set is what manages the list of observations that are displayed in the deck and the filters that are applied to those observations,
			// so if we don't have a set to add the new observation to, then we won't be able to display it in the deck or apply any filters to it
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getCardDeckHeaderObservationSetSelectorHTMLID(tmpInput.Macro.RawHTMLID))?.[0];
			let currentObservationSetID = isNaN(parseInt(tmpSelectElement?.value)) ? null : parseInt(tmpSelectElement?.value);
			// If the selector element doesn't exist (useObservationSetSelector is false), fall back to the hidden input
			// which always contains the IDObservationSet from the initial data marshal
			if (!currentObservationSetID)
			{
				const tmpHiddenInputValue = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(tmpInput.Macro.RawHTMLID))?.[0]?.value;
				currentObservationSetID = isNaN(parseInt(tmpHiddenInputValue)) ? null : parseInt(tmpHiddenInputValue);
			}
			let currentObservationSet = currentObservationSetID ? await this.pict.providers.ObservationSetProvider.loadSet(currentObservationSetID) : null;
			// if there's no set id yet, we have to go create one before we can begin adding images
			if (!currentObservationSetID && !currentObservationSet)
			{
				// when requireExplicitSetCreation is enabled, block the auto-create fallback — the user
				// must use "Create New Set" (which goes through the custom handler) before adding images
				if (currentSettings.requireExplicitSetCreation)
				{
					this.pict.log.warn('Cannot add observation — no set is selected and requireExplicitSetCreation is enabled. Use "Create New Set" first.');
					currentButtonElement.classList.remove('is-loading');
					this._pendingAddButtonElements.delete(currentButtonElement);
					return false;
				}
				this.pict.log.info('No Observation Set ID found, creating a new one.');
				const newSet = await this.createNewObservationSetForCardDeck(pViewHash, pInputHash);
				currentObservationSetID = newSet.IDObservationSet;
				currentObservationSet = newSet;
				// get the temp namespace so we can clear it out now (garbage collection effort)
				const tmpNamespaceForTempIDObservationSet = this.buildNamespaceForCardDeck(pInputHash, null, true);
				// check the media registry to see find the TEMP namespace we created for this input hash when we first built the deck, and if it exists, we need to update that namespace to point to the new set ID and pull the observations for that set so that we can update the deck with the correct set of observations based on the new set ID
				await this.pict.providers.MediaRegistry.clearNamespace(tmpNamespaceForTempIDObservationSet);
				// update the card deck header selector with the new set ID so that it's selected and we can pull the correct set from the registry to display in the deck
				const tmpNamespaceForNewIDObservationSet = this.buildNamespaceForCardDeck(pInputHash, currentObservationSetID);
				await this.pict.providers.MediaRegistry.registerMediaSetByIDObservationSet(tmpNamespaceForNewIDObservationSet, currentObservationSetID);
				this.handleHeaderContentForCardDeck(tmpView, tmpInput, tmpNamespaceForNewIDObservationSet);
				// update the views so we have the latest state of elements to inject the image into
				tmpView = this.pict.views[pViewHash];
				tmpInput = tmpView.getInputFromHash(pInputHash);
			}
			// set the IDObservationSet for the image panel so that interactions there will apply to the current set
			this.pict.views.ObservationSet.setObservationSetID(currentObservationSet.IDObservationSet);
			this.pict.views.ObservationSet.ActiveObservationSet = currentObservationSet;

			// Quick capture will bypass the observation selection panel and just add the captured image directly to the set and deck,
			// while the regular add button will open the observation panel for the user to select/search/upload images to add to the set and deck
			if (pQuickCaptureButton)
			{
				// quickCaptureImage expects the underlying <input type="file">, not the wrapping
				// <label class="button"> that currentButtonElement now resolves to.
				const tmpFileInput = /** @type {HTMLInputElement} */ (tmpRawEventTarget);
				this.pict.views.ObservationCreateMedia.quickCaptureImage(tmpFileInput, { IDDocument: this.pict?.AppData?.DocumentData?.ReportData?.IDDocument },
					async (/** @type {any[]} */ observationInfos) =>
					{
						await this.handleAddCardToNewSetRecord(pViewHash, pInputHash, observationInfos);
						currentButtonElement.classList.remove('is-loading');
						this._pendingAddButtonElements.delete(currentButtonElement);
						tmpFileInput.value = ''; // reset the file input so that the same file can be uploaded again if needed
					});
			}
			else
			{
				this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open',
					() =>
					{
						// start at the upload tab
						this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation');
						// 'add-to-set' is the recognized CSS mode that triggers the green banner and add-mode UI
						this.pict.views.HeadlightPaneObservations.setObservationPanelTarget(tmpView.Hash, tmpInput.Hash, this.pict.views.ObservationSet.ActiveObservationSet?.Name || tmpInput.Name, 'add-to-set');
						this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Observation Set';
						this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Observation Set';
						/** @type {(observationInfos: Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>) => Promise<void>} */
						this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = async (observationInfos) =>
						{
							await this.handleAddCardToNewSetRecord(pViewHash, pInputHash, observationInfos);
							currentButtonElement.classList.remove('is-loading');
							this._pendingAddButtonElements.delete(currentButtonElement);
						};
					});
			}
			return true;
		}
		// For the Document List Path (non-set decks, with or without label-only filters)
		if (pQuickCaptureButton)
		{
			// quickCaptureImage expects the underlying <input type="file">, not the wrapping
			// <label class="button"> that currentButtonElement now resolves to.
			const tmpFileInput = /** @type {HTMLInputElement} */ (tmpRawEventTarget);
			this.pict.views.ObservationCreateMedia.quickCaptureImage(tmpFileInput, { IDDocument: this.pict?.AppData?.DocumentData?.ReportData?.IDDocument },
				async (/** @type {any[]} */ observationInfos) =>
				{
					// The new observation is already in DocumentData.ReportData.Observations (added by quickCaptureImage).
					// Gate: reject observations whose type doesn't match the deck's ObservationType filters.
					const validObservations = observationInfos.filter((obsInfo) =>
					{
						const obsRecord = obsInfo.Observation ||
							this.pict.AppData?.DocumentData?.ReportData?.Observations?.find((/** @type {any} */ o) => o.IDObservation == obsInfo.IDObservation);
						if (obsRecord && !this.observationMatchesTypeFilter(tmpInput, obsRecord))
						{
							this.pict.log.warn(`Observation ${obsInfo.IDObservation} (type "${obsRecord.ObservationType}") does not match the deck's ObservationType filter — skipping.`);
							this.showFilterMismatchWarning(tmpInput, obsRecord.ObservationType);
							return false;
						}
						return true;
					});
					// If label-only filters are active, auto-apply the Include labels so the new observation matches the filter criteria.
					for (const obsInfo of validObservations)
					{
						if (obsInfo.Observation && this.hasActionableFilters(tmpInput))
						{
							await this.applyFilterLabelsToObservation(tmpInput, obsInfo.Observation);
						}
					}
					// Refresh the MediaRegistry's document observations and remarshal all document-list decks to pick it up.
					await this.pict.providers.MediaRegistry.refreshDocumentObservations(this.pict.AppData.DocumentData.ReportData.Observations);
					for (const obsInfo of validObservations)
					{
						await this.reMarshalAllViewsWithCardDecks(obsInfo.IDObservation, 'AllDocumentLists', true);
					}
					currentButtonElement.classList.remove('is-loading');
					this._pendingAddButtonElements.delete(currentButtonElement);
					tmpFileInput.value = '';
				});
		}
		else
		{
			// open the observation panel for the user to select/search/upload images to add to the document
			tmpView.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open',
				async () =>
				{
					// start at the upload tab
					this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation');
					tmpView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(tmpView.Hash, tmpInput?.Hash, tmpInput?.Name, 'add-to-document');
					this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Document';
					this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Document';
					/** @type {(observationInfos: Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>) => Promise<void>} */
					this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = async (observationInfos) =>
					{
						// Gate: reject observations whose type doesn't match the deck's ObservationType filters.
						const validObservations = observationInfos.filter((obsInfo) =>
						{
							const obsRecord = obsInfo.Observation ||
								this.pict.AppData?.DocumentData?.ReportData?.Observations?.find((/** @type {any} */ o) => o.IDObservation == obsInfo.IDObservation);
							if (obsRecord && !this.observationMatchesTypeFilter(tmpInput, obsRecord))
							{
								this.pict.log.warn(`Observation ${obsInfo.IDObservation} (type "${obsRecord.ObservationType}") does not match the deck's ObservationType filter — skipping.`);
								this.showFilterMismatchWarning(tmpInput, obsRecord.ObservationType);
								return false;
							}
							return true;
						});
						// If label-only filters are active, auto-apply the Include labels so the new observation matches the filter criteria.
						for (const obsInfo of validObservations)
						{
							if (obsInfo.Observation && this.hasActionableFilters(tmpInput))
							{
								await this.applyFilterLabelsToObservation(tmpInput, obsInfo.Observation);
							}
						}
						await this.pict.providers.MediaRegistry.refreshDocumentObservations(this.pict.AppData.DocumentData.ReportData.Observations);
						for (const obsInfo of validObservations)
						{
							await this.reMarshalAllViewsWithCardDecks(obsInfo.IDObservation, 'AllDocumentLists', true);
						}
						currentButtonElement.classList.remove('is-loading');
						this._pendingAddButtonElements.delete(currentButtonElement);
					};
				});
		}
		return true;
	}

	/**
	 * Clear the "is-loading" state from any Add or QuickCapture buttons that opened a panel-driven
	 * add flow but never completed it. This is called from HeadlightPaneObservations.closeHandler()
	 * when the user dismisses the Observations panel (X button, escape, background click, toggle).
	 *
	 * The button only gets removed from the tracking set after a successful completion of the
	 * add flow (where its onAfterCallback fires), so anything still in the set at panel-close time
	 * is by definition stuck. Defensive: we'd rather show a button as not-loading momentarily
	 * than leave it semi-permanently stuck for the user.
	 * @returns {void}
	 */
	clearPendingAddButtonLoadingState()
	{
		if (!this._pendingAddButtonElements || this._pendingAddButtonElements.size === 0)
		{
			return;
		}
		for (const tmpButtonElement of this._pendingAddButtonElements)
		{
			tmpButtonElement?.classList?.remove('is-loading');
		}
		this._pendingAddButtonElements.clear();
	}

	/**
	 * Handles the process of adding a card to the deck and the corresponding observation to the active observation set when a new observation is added through the card deck UI, including adding the observation to the set if it's not already in there and removing the card from any decks that are configured to exclude the set that the observation was added to.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {Array<{ IDObservation: number | string, Observation?: any, FileDetails?: { } }>} pObservations - An array of objects containing information about the observations that were added through the card deck UI, including their IDs and any additional details that may be needed for processing.
	 */
	async handleAddCardToNewSetRecord(pViewHash, pInputHash, pObservations)
	{
		if (!this.pict.views.ObservationSet.ActiveObservationSet)
		{
			this.pict.log.warn('No active observation set to add observation to.');
			return;
		}
		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView?.getInputFromHash(pInputHash);
		const tmpIDObservationSet = this.pict.views.ObservationSet.ActiveObservationSet.IDObservationSet;
		for (const tmpObservation of pObservations)
		{
			if (!tmpObservation.IDObservation)
			{
				this.pict.log.warn('Observation info is missing IDObservation:', tmpObservation);
				continue;
			}
			// Gate: reject observations whose type doesn't match the deck's ObservationType filters.
			// Resolve the full observation record from the callback payload, the document list, or a fresh API fetch.
			const tmpObsRecord = tmpObservation.Observation ||
				this.pict.AppData?.DocumentData?.ReportData?.Observations?.find((/** @type {any} */ o) => o.IDObservation == tmpObservation.IDObservation);
			if (tmpInput && tmpObsRecord && !this.observationMatchesTypeFilter(tmpInput, tmpObsRecord))
			{
				this.pict.log.warn(`Observation ${tmpObservation.IDObservation} (type "${tmpObsRecord.ObservationType}") does not match the deck's ObservationType filter — skipping.`);
				this.showFilterMismatchWarning(tmpInput, tmpObsRecord.ObservationType);
				continue;
			}
			// if the observation is not already in the active set, add it to the set before we add the card to the deck
			if (!this.pict.views.ObservationSet.ActiveObservationSet.Observations.find((/** @type {any} */ obs) => obs.IDObservation === tmpObservation.IDObservation))
			{
				await this.pict.views.ObservationSet.addObservationToSet(tmpObservation.IDObservation);
			}
			// refresh the MediaRegistry namespace for the active observation set so addCardToDeck can find the newly added observation
			if (tmpIDObservationSet)
			{
				await this.pict.providers.MediaRegistry.updateNamespacesByIDObservationSet(tmpIDObservationSet);
			}
			// after we add the observation to the set, we can add the card to the deck
			await this.addCardToDeck(pViewHash, pInputHash, tmpObservation.IDObservation)
			.then(async () =>
			{
				this.pict.log.info(`Added card to deck for observation ID ${tmpObservation.IDObservation} after adding observation to set.`);
				// for all other non-sets based decks, we need refresh the decks so they pick up the new image in the document observation list update
				await this.reMarshalAllViewsWithCardDecks(tmpObservation.IDObservation, 'AllDocumentLists', true);
			})
			.catch((error) =>
			{
				this.pict.log.error(`Error adding card to deck for observation ID ${tmpObservation.IDObservation}: ${error}`);
				return;
			});
		}
		// remarshal all observation-set-backed decks so any other decks showing this set also reflect the new observation(s)
		if (tmpIDObservationSet && pObservations.length)
		{
			await this.reMarshalAllViewsWithCardDecks(pObservations[pObservations.length - 1].IDObservation, 'AllObservationSets', true);
		}
		// invoke the custom observation set changed callback if registered (e.g. bridge defect photo count label update)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged(tmpInput, pObservations[pObservations.length - 1]?.IDObservation, this.pict.views.ObservationSet.ActiveObservationSet);
		}
		// invoke the document context callback if registered (e.g. orphan observation recalculation)
		if (typeof this.pict.AppData.ObservationCardDeckProvider.documentContextCallback === 'function')
		{
			this.pict.AppData.ObservationCardDeckProvider.documentContextCallback();
		}
	}

	/**
	 * Remarshals all views that have card decks in them based on the given observation ID and package type, which is used to trigger a refresh of the decks in those views so that
	 * they can pick up any changes to the observations (ex: new image added to an observation, observation added/removed from the document, etc.) and update the cards in the deck
	 * accordingly, and optionally runs a cache busting function for the images in those decks if needed.
	 * @param {number|string} pIDObservation - The ID of the observation that was changed and is being used as the basis for determining which decks need to be refreshed.
	 * @param {string} pPackType - The package type that is used to determine which views have card decks that may need to be refreshed based on the observation change.
	 * @param {boolean} pRunCacheBust - Whether to run the cache busting function for the images in the decks that are being refreshed, which may be needed if the observation change involves an update to an existing image rather than just adding a new image or adding/removing an observation from the document.
	 */
	async reMarshalAllViewsWithCardDecks(pIDObservation, pPackType, pRunCacheBust = false)
	{
		const allPotentialDecksToReMarshal = document.querySelectorAll(this.packageTypeSelectorMap[pPackType]);
		if (!allPotentialDecksToReMarshal.length)
		{
			this.pict.log.info('No card decks found to refresh.');
			return;
		}
		// for each view that has a card deck, we'll remarshal that view (rather than individual inputs)
		/**
		 * @type {any[]}
		 */
		const viewsToRefresh = [];
		allPotentialDecksToReMarshal.forEach((deck) =>
		{
			const viewHash = deck.getAttribute(this.deckViewHashAttribute);
			if (viewHash)
			{
				if (!viewsToRefresh.includes(viewHash))
				{
					viewsToRefresh.push(viewHash);
				}
			}
		});
		if (viewsToRefresh.length)
		{
			for (const viewHash of viewsToRefresh)
			{
				const tmpView = this.pict.views[viewHash];
				if (tmpView)
				{
					this._isRemarshalInProgress = true;
					tmpView.marshalToView();
					// wait for all async card deck marshal work to complete before moving to the next view,
					// preventing concurrent rebuilds from racing over shared MediaRegistry state
					await this.waitForPendingMarshals();
					this._isRemarshalInProgress = false;
					if (pRunCacheBust && pIDObservation)
					{
						await this.pict.providers.ObservationProvider.cacheBustObsImages(pIDObservation, this.cacheBusterAttemptTimers);
					}
				}
			}
		}
	}

	/**
	 * Handles the click event for a card thumbnail in the deck.
	 * @param {Event} event - The click event object.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {number} pIDObservation - The observation ID associated with the clicked thumbnail.
	 */
	handleClickForCardThumbnail(event, pViewHash, pInputHash, pIDObservation)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		const currentSettings = this.getCurrentSettingsForInput(this.pict.views[pViewHash].getInputFromHash(pInputHash));
		// if there's a custom callback defined for when clicking on a thumbnail in the deck, use that, otherwise fall back to the default behavior of opening the image panel with the observation details
		if (currentSettings.onClickThumbnailClickCallback && typeof currentSettings.onClickThumbnailClickCallback === 'function')
		{
			currentSettings.onClickThumbnailClickCallback(event, this.pict.views[pViewHash], this.pict.views[pViewHash].getInputFromHash(pInputHash), pIDObservation);
		}
		else
		{
			// for the annotation workflow path, we want to open the observation detail view in the side panel when clicking on a thumbnail, and if the ObservationSubImageSelector view is active,
			// we want to set the intent for that view so that it knows to update based on interactions in the observation detail view
			if (this.pict?.views?.ObservationSubImageSelector?.intent)
			{
				const parentID = event.target instanceof HTMLElement && event.target.parentElement?.parentElement?.id;
				const obsSetMappedID = parentID?.replace('IMAGE-CONTAINER-FOR-', '') || 0;
				if (obsSetMappedID)
				{
					this.pict.fable.services.HeadlightPanels.applyUIHighlight(`#${ parentID?.replace('IMAGE-CONTAINER-FOR-', 'ELEMENT-CONTAINER-FOR-') }`);
					this.pict.log.info('Found ObservationSet ID: ', obsSetMappedID);
					this.pict.views.ObservationSubImageSelector.intent =
					{
						type: 'ObservationSet',
						IDObservationSet: this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[obsSetMappedID],
					};
				}
			}
			this.pict.views.HeadlightPaneObservations.showObservationDetailView(event, pIDObservation, null);
		}
	}

	/**
	 * Adds a card to the deck for the given observation ID.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {number|string} pIDObservation - The observation ID.
	 * @return {Promise<void>}
	 */
	async addCardToDeck(pViewHash, pInputHash, pIDObservation)
	{
		if (!pIDObservation)
		{
			this.pict.log.warn('No observation ID provided. Cannot add card to deck.');
			return Promise.reject(new Error('No observation ID provided. Cannot add card to deck.'));
		}
		if (!pViewHash || !pInputHash)
		{
			this.pict.log.warn('No view hash or input hash provided. Cannot add card to deck.');
			return Promise.reject(new Error('No view hash or input hash provided. Cannot add card to deck.'));
		}
		const tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.warn(`View with hash ${pViewHash} not found. Cannot add card to deck.`);
			return Promise.reject(new Error(`View with hash ${pViewHash} not found. Cannot add card to deck.`));
		}
		const tmpInput = tmpView.getInputFromHash(pInputHash);
		if (!tmpInput)
		{
			this.pict.log.warn(`Input with hash ${pInputHash} not found in view ${pViewHash}. Cannot add card to deck.`);
			return Promise.reject(new Error(`Input with hash ${pInputHash} not found in view ${pViewHash}. Cannot add card to deck.`));
		}
		const tmpCurrentSettings = this.getCurrentSettingsForInput(tmpInput);
		// disable adding cards if the setting is enabled for the deck
		if (tmpCurrentSettings.preventAddingCards)
		{
			return;
		}
		const deckContainer = this.pict.ContentAssignment.getElement(this.getCardDeckContentHTMLID(tmpInput.Macro.RawHTMLID))?.[0];
		if (tmpInput && deckContainer)
		{
			let tmpObservationRecord;
			// check sets for the observation before we add it to the deck, since if we're using sets to manage the lists of observations that are displayed in the deck
			if (tmpCurrentSettings.useObservationSet)
			{
				const tmpIDObservationSet = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(tmpInput.Macro.RawHTMLID))?.[0]?.value;
				const tmpNamespaceForIDObservationSet = this.buildNamespaceForCardDeck(pInputHash, tmpIDObservationSet);
				const tmpObservationSetList = await this.pict.providers.MediaRegistry.getMediaSet(tmpNamespaceForIDObservationSet);
				tmpObservationRecord = tmpObservationSetList.find((/** @type {any} */ obs) => obs.IDObservation == pIDObservation);
				if (!tmpObservationRecord)
				{
					this.pict.log.error(`Could not find observation with ID ${pIDObservation} in the observation set for input ${tmpInput.Macro.RawHTMLID}. Cannot add card to deck.`);
					return Promise.reject(new Error(`Could not find observation with ID ${pIDObservation} in the observation set for input ${tmpInput.Macro.RawHTMLID}. Cannot add card to deck.`));
				}
			}
			else
			{
				const currentFilters = this.getCurrentFiltersForInput(tmpInput);
				if (currentFilters && Object.keys(currentFilters).length)
				{
					tmpObservationRecord = this.pict.AppData.DocumentData.ReportData.Observations.find((/** @type {any} */ obs) => obs.IDObservation == pIDObservation);
				}
				if (!tmpObservationRecord)
				{
					this.pict.log.error(`Could not find observation with ID ${pIDObservation} in document observations. Cannot add card to deck.`);
					return Promise.reject(new Error(`Could not find observation with ID ${pIDObservation} in document observations. Cannot add card to deck.`));
				}
			}

			return Promise.resolve(tmpObservationRecord);
		}
	}

	/**
	 * Removes a card from the deck for the given observation ID.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @param {string|number} pIDObservation - The observation ID.
	 * @return {Promise<void>}
	 */
	async removeCardFromDeck(pViewHash, pInputHash, pIDObservation)
	{
		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView.getInputFromHash(pInputHash);
		const tmpCurrentSettings = this.getCurrentSettingsForInput(tmpInput);
		// disabled removing cards if the setting is enabled for the deck
		if (tmpCurrentSettings.preventRemovingCards)
		{
			return;
		}
		if (tmpInput)
		{
			if (this.isDocumentLocked || !this.canEditDocument)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'This document is locked. You cannot remove images from the set.',
					type: 'is-warning',
				});
				return;
			}
			this.pict.log.info(`Removing observation ${pIDObservation} from set for input ${tmpInput.Macro.RawHTMLID}.`);
			// NOTE: We intentionally are not doing confirmation prompt for sets as a UX choice - we want to encourage users to add/remove images to the set, so we want to make it easy to remove them.
			// for sets vs non-sets
			const tmpSetID = this.pict.ContentAssignment.getElement(this.getHiddenInputHTMLID(tmpInput.Macro.RawHTMLID))?.[0]?.value;
			if (tmpCurrentSettings.useObservationSet && tmpSetID)
			{
				let tmpSet = await this.pict.providers.ObservationSetProvider.loadSet(tmpSetID);
				const tmpObservation = tmpSet.Observations.find((/** @type {any} */ pObservation) => pObservation.IDObservation == pIDObservation);
				if (!tmpObservation)
				{
					this.pict.log.error(`Could not find observation with ID ${pIDObservation} in observation set with ID ${tmpSetID}. Cannot remove card from deck.`);
					return;
				}
				tmpSet = await this.pict.providers.ObservationSetProvider.removeObservation(tmpSet, tmpObservation).catch((/** @type {any} */ error) =>
				{
					this.pict.log.error(`Error removing observation with ID ${pIDObservation} from observation set with ID ${tmpSetID}: ${error}`);
					throw error;
				});
				this.pict.providers.ObservationSetProvider.saveSet(tmpSet);
				// invoke the custom observation set changed callback if registered (e.g. bridge defect photo count label update)
				if (typeof this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged === 'function')
				{
					this.pict.AppData.ObservationCardDeckProvider.customOnAfterObservationSetChanged(tmpInput, pIDObservation, tmpSet);
				}
				// invoke the document context callback if registered (e.g. orphan observation recalculation)
				if (typeof this.pict.AppData.ObservationCardDeckProvider.documentContextCallback === 'function')
				{
					this.pict.AppData.ObservationCardDeckProvider.documentContextCallback();
				}
			}
			else
			{
				// remove this observation from the document observation list (which will update if they save)
				this.pict.AppData.DocumentData.ReportData.Observations = this.pict.AppData.DocumentData.ReportData.Observations.filter((/** @type {any} */ obs) => obs.IDObservation != pIDObservation);
				this.pict.providers.MediaRegistry.refreshDocumentObservations(this.pict.AppData.DocumentData.ReportData.Observations);
			}
			// refresh the decks so they pick up the removed image in the document observation list update
			await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllDocumentLists', false);
			// also remarshal all observation-set-backed decks so the deck that just had the observation
			// removed (and any other decks showing the same set) reflect the change — without this,
			// useObservationSet decks (which are marked with data-deck-is-observation-set, not
			// data-deck-is-document-list) would never be re-rendered and the removed card would
			// remain visible in the UI
			await this.reMarshalAllViewsWithCardDecks(pIDObservation, 'AllObservationSets', false);
		}
	}

	/**
	 * This will create a new Observation Set if one doesn't already exist for this input.
	 * @param {string} pViewHash - The view hash.
	 * @param {string} pInputHash - The input hash.
	 * @return {Promise<*>}
	 */
	async createNewObservationSetForCardDeck(pViewHash, pInputHash)
	{
		return new Promise(async (resolve, reject) =>
		{
			this.pict.log.info('Creating a new Observation Set');

			const pView = this.pict.views[pViewHash];
			const pInput = pView.getInputFromHash(pInputHash);
			// make a new set if we don't have a value yet (should only be done the first time per form load)
			const tmpLabel = document.querySelector(this.getLabelHTMLID(pInput.Macro.RawHTMLID))['innerText'] || 'New Observation Set';
			const tmpName = tmpLabel + ' (' + new Date().toLocaleString() + ')';
			const tmpProjectId = this.pict.AppData?.DocumentData?.ReportData?.IDProject || null;
			// create a new observation set
			const tmpNewSet = this.pict.providers.ObservationSetProvider.createSet(tmpName, tmpProjectId);
			// and save the new set
			try
			{
				const pResult = await this.pict.providers.ObservationSetProvider.saveSet(tmpNewSet);
				// collect the new set ID and update the map
				this.pict.AppData.ObservationCardDeckProvider.dynamicGUIDMap[pInput.Macro.RawHTMLID] = pResult.IDObservationSet;
				// set the IDObservationSet value for the hidden input so that it gets saved in the FormData and we can reference it later when adding observations to the set
				this.pict.ContentAssignment.assignContent(this.getHiddenInputHTMLID(pInput.Macro.RawHTMLID), pResult.IDObservationSet);
				// marshal the form to data so that it saves properly in the FormData
				pView.dataChanged(pInput.Hash);
				// if it's a document, we should auto-save the document now too
				if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument)
				{
					this.pict.providers.DocumentProvider.handleSave(true);
				}
				this.pict.log.info('New Observation Set created successfully. Created Set ID: ' + pResult.IDObservationSet);
				resolve(pResult);
			}
			catch (pError)
			{
				this.pict.log.error(`Error in createNewObservationSetForCardDeck: ${pError}`);
				resolve(false);
			}
		});
	}
}

module.exports = ObservationCardDeck;

},{"./../../../media-detail-cards/source/MediaCardBuilder.js":302,"./_UserMarkdown.js":170,"pict-section-form":587}],112:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const libUserMarkdown = require('./_UserMarkdown.js');

/**
 * A record's photo, kept as an image observation: the field's value is that observation's IDObservation (0 = no
 * photo). PictForm.PhotoEntity names the record's entity (e.g. Location), whose API routes own the photo:
 *
 *   POST {Entity}/{IDRecord}/Photo?FileName=...  uploads the image and links it to the record, answers { IDObservation }
 *   GET  {Entity}/{IDRecord}/Photo/Preview       the saved record's photo
 *
 * The observation is never read or written directly, and the upload needs a saved record. So Add photo / Replace
 * photo only holds the chosen image (shown from the browser) until the form saves; the record's save then calls
 * savePendingPhoto once it has an ID, which for a new record means after it is created. Remove photo drops a held
 * image and puts 0 in the field, which the save writes. Neither Replace nor Remove deletes the old observation.
 *
 * With PictForm.ReadOnly the photo shows without the buttons.
 */
class ObservationPhotoInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {Record<string, { Entity: string, IDRecord: number }>} per field (by RawHTMLID): whose photo it is */
		this._fields = {};
		/** @type {Record<string, { File: File, PreviewURL: string }>} by photoKey: an image chosen here, waiting for the record to save */
		this._pendingPhotos = {};
		/** @type {Record<number, string>} IDObservation -> object URL of an image uploaded from here, shown while it is processed */
		this._localPreviews = {};
	}

	getInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getPreviewHTMLID(pInputHTMLID)
	{
		return `#PHOTO-PREVIEW-FOR-${pInputHTMLID}`;
	}

	getControlsHTMLID(pInputHTMLID)
	{
		return `#PHOTO-CONTROLS-FOR-${pInputHTMLID}`;
	}

	getFileInputHTMLID(pInputHTMLID)
	{
		return `#PHOTO-FILE-INPUT-FOR-${pInputHTMLID}`;
	}

	getAddLabelHTMLID(pInputHTMLID)
	{
		return `#PHOTO-ADD-LABEL-FOR-${pInputHTMLID}`;
	}

	getRemoveButtonHTMLID(pInputHTMLID)
	{
		return `#PHOTO-REMOVE-FOR-${pInputHTMLID}`;
	}

	getStatusHTMLID(pInputHTMLID)
	{
		return `#PHOTO-STATUS-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {any} pValue - a field value
	 * @return {number} the IDObservation it holds, or 0 when it holds none
	 */
	static idObservationOf(pValue)
	{
		const tmpID = Number(pValue);
		return (Number.isFinite(tmpID) && (tmpID > 0)) ? tmpID : 0;
	}

	/**
	 * @param {string} pSelector
	 * @return {HTMLElement|null} the first element the selector finds
	 */
	_element(pSelector)
	{
		const tmpElements = this.pict.ContentAssignment.getElement(pSelector);
		if (Array.isArray(tmpElements) && (tmpElements.length > 0) && (tmpElements[0] instanceof HTMLElement))
		{
			return tmpElements[0];
		}
		return null;
	}

	/**
	 * @param {string} pSelector
	 * @param {boolean} pShown
	 */
	_setShown(pSelector, pShown)
	{
		const tmpElement = this._element(pSelector);
		if (!tmpElement)
		{
			return;
		}
		if (pShown)
		{
			this.pict.ContentAssignment.removeClass(tmpElement, 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.addClass(tmpElement, 'is-hidden');
		}
	}

	/**
	 * @param {string} pPath - an API path, e.g. Location/5/Photo/Preview
	 * @return {string} its full URL
	 */
	apiURL(pPath)
	{
		const tmpRestClient = this.pict.fable.services && this.pict.fable.services.HeadlightRestClient;
		if (tmpRestClient && (typeof tmpRestClient.formatUrl === 'function'))
		{
			try
			{
				return tmpRestClient.formatUrl(pPath);
			}
			catch (pError)
			{
				// fall through to the relative URL
			}
		}
		return `/1.0/${pPath}`;
	}

	/**
	 * @param {string} pEntity - e.g. Location
	 * @param {number} pIDRecord - the saved record; the route finds its photo from the record
	 * @return {string} the URL of the record's preview-sized photo
	 */
	photoURL(pEntity, pIDRecord)
	{
		return this.apiURL(`${encodeURIComponent(pEntity)}/${Number(pIDRecord)}/Photo/Preview`);
	}

	/**
	 * Remember whose photo a field holds: the entity, and the record's ID read from the field's sibling ID{Entity}
	 * (0 while the record is new).
	 *
	 * @param {Object} pInput
	 * @param {Object} [pView] - the form view, to read the record from
	 * @return {{ Entity: string, IDRecord: number }}
	 */
	rememberField(pInput, pView)
	{
		const tmpEntity = (pInput.PictForm && pInput.PictForm.PhotoEntity) || '';
		let tmpIDRecord = 0;
		const tmpAddress = String(pInput.Address || '');
		if (tmpEntity && pView && (typeof pView.getMarshalDestinationObject === 'function'))
		{
			const tmpSplit = tmpAddress.lastIndexOf('.');
			const tmpIDAddress = `${(tmpSplit >= 0) ? tmpAddress.substring(0, tmpSplit + 1) : ''}ID${tmpEntity}`;
			tmpIDRecord = ObservationPhotoInputHandler.idObservationOf(this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpIDAddress));
		}
		const tmpField = { Entity: tmpEntity, IDRecord: tmpIDRecord };
		this._fields[pInput.Macro.RawHTMLID] = tmpField;
		return tmpField;
	}

	/**
	 * Show a message under the photo, or clear it.
	 *
	 * @param {string} pInputHTMLID
	 * @param {string} [pMessage] - '' or omitted clears it
	 * @param {boolean} [pIsError]
	 */
	setStatus(pInputHTMLID, pMessage, pIsError)
	{
		const tmpStatus = this._element(this.getStatusHTMLID(pInputHTMLID));
		if (!tmpStatus)
		{
			return;
		}
		this.pict.ContentAssignment.assignContent(tmpStatus, libUserMarkdown.escapeHTML(pMessage || ''));
		if (pIsError)
		{
			this.pict.ContentAssignment.addClass(tmpStatus, 'is-danger');
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpStatus, 'is-danger');
		}
		this._setShown(this.getStatusHTMLID(pInputHTMLID), !!pMessage);
	}

	/**
	 * @param {string} pEntity
	 * @param {number} pIDRecord - 0 for a record not yet created
	 * @return {string} the key a held image is kept under
	 */
	static photoKey(pEntity, pIDRecord)
	{
		return `${pEntity}:${Number(pIDRecord) || 0}`;
	}

	/**
	 * @param {File} pFile
	 * @return {string} an object URL showing the file, or '' when the browser cannot make one
	 */
	_previewURLFor(pFile)
	{
		try
		{
			return ((typeof URL !== 'undefined') && (typeof URL.createObjectURL === 'function')) ? URL.createObjectURL(pFile) : '';
		}
		catch (pError)
		{
			return '';
		}
	}

	/**
	 * Draw the field for a value: the photo (or "No photo." when read-only), and Add photo / Replace photo plus
	 * Remove photo when editable. An image waiting for the save shows in place of the saved one.
	 *
	 * @param {string} pInputHTMLID
	 * @param {any} pValue - the IDObservation, or 0
	 * @param {boolean} [pReadOnly]
	 */
	showPhoto(pInputHTMLID, pValue, pReadOnly)
	{
		const tmpIDObservation = ObservationPhotoInputHandler.idObservationOf(pValue);
		const tmpField = this._fields[pInputHTMLID] || { Entity: '', IDRecord: 0 };
		const tmpPending = pReadOnly ? null : this._pendingPhotos[ObservationPhotoInputHandler.photoKey(tmpField.Entity, tmpField.IDRecord)];
		const tmpHasPhoto = !!(tmpIDObservation || tmpPending);
		const tmpPreview = this._element(this.getPreviewHTMLID(pInputHTMLID));
		if (tmpPreview)
		{
			let tmpPreviewHTML = '';
			// a held or just-uploaded image shows from the browser; a saved one through the record's photo route
			let tmpSource = '';
			if (tmpPending)
			{
				tmpSource = tmpPending.PreviewURL;
			}
			else if (tmpIDObservation)
			{
				tmpSource = this._localPreviews[tmpIDObservation] ||
					((tmpField.Entity && tmpField.IDRecord) ? this.photoURL(tmpField.Entity, tmpField.IDRecord) : '');
			}
			if (tmpSource)
			{
				// A just-uploaded image can take a moment to process; say so instead of showing a broken image.
				tmpPreviewHTML = /*HTML*/`<img src="${libUserMarkdown.escapeHTML(tmpSource)}" alt="Photo" style="display: block; max-width: 100%; max-height: 240px; border-radius: 6px;" onerror="this.classList.add('is-hidden'); this.nextElementSibling.classList.remove('is-hidden');" />` +
					/*HTML*/`<p class="help is-hidden">The photo is saved. Its preview will show here once it has been processed.</p>`;
			}
			else if (tmpPending)
			{
				tmpPreviewHTML = /*HTML*/`<div class="input is-static has-text-text-60"><em>${libUserMarkdown.escapeHTML(tmpPending.File.name || 'Photo')} will be uploaded when you save.</em></div>`;
			}
			else if (pReadOnly && !tmpIDObservation)
			{
				tmpPreviewHTML = /*HTML*/`<div class="input is-static has-text-text-60"><em>No photo.</em></div>`;
			}
			this.pict.ContentAssignment.assignContent(tmpPreview, tmpPreviewHTML);
			this._setShown(this.getPreviewHTMLID(pInputHTMLID), !!tmpPreviewHTML);
		}
		this._setShown(this.getControlsHTMLID(pInputHTMLID), !pReadOnly);
		const tmpAddLabel = this._element(this.getAddLabelHTMLID(pInputHTMLID));
		if (tmpAddLabel)
		{
			this.pict.ContentAssignment.assignContent(tmpAddLabel, tmpHasPhoto ? 'Replace photo' : 'Add photo');
		}
		this._setShown(this.getRemoveButtonHTMLID(pInputHTMLID), tmpHasPhoto);
	}

	/**
	 * Put a value in the field's hidden input and tell the form it changed.
	 *
	 * @param {string} pInputHTMLID
	 * @param {number} pIDObservation - 0 for no photo
	 */
	setValue(pInputHTMLID, pIDObservation)
	{
		const tmpHidden = this._element(this.getInputHTMLID(pInputHTMLID));
		if (!(tmpHidden instanceof HTMLInputElement))
		{
			return;
		}
		this.pict.ContentAssignment.setAttribute(tmpHidden, 'value', String(pIDObservation));
		tmpHidden.value = String(pIDObservation);
		tmpHidden.dispatchEvent(new Event('change', { bubbles: true }));
	}

	/**
	 * Upload an image through the record's photo route, which creates the observation and links it to the record.
	 *
	 * @param {string} pEntity - e.g. Location
	 * @param {number} pIDRecord - the saved record
	 * @param {File} pFile
	 * @return {Promise<number>} the new IDObservation, or 0 when it could not be uploaded
	 */
	async uploadPhoto(pEntity, pIDRecord, pFile)
	{
		const tmpRestClient = this.pict.fable.services && this.pict.fable.services.HeadlightRestClient;
		const tmpIDRecord = ObservationPhotoInputHandler.idObservationOf(pIDRecord);
		if (!pEntity || !tmpIDRecord || !tmpRestClient || (typeof tmpRestClient.postBinary !== 'function'))
		{
			this.pict.log.error('ObservationPhoto: there is no saved record, PhotoEntity or HeadlightRestClient, so the photo cannot be uploaded.');
			return 0;
		}
		const tmpUploadTracking = this.pict.providers.UploadTracking;
		const tmpUploadID = tmpUploadTracking ? tmpUploadTracking.trackUpload() : null;
		try
		{
			const tmpBody = await new Promise((fResolve, fReject) =>
			{
				tmpRestClient.postBinary(`${encodeURIComponent(pEntity)}/${tmpIDRecord}/Photo?FileName=${encodeURIComponent(pFile.name || '')}`, pFile, pFile.type,
					(pError, pBody) => (pError ? fReject(pError) : fResolve(pBody)));
			});
			const tmpResult = (typeof tmpBody === 'string') ? JSON.parse(tmpBody) : tmpBody;
			if (tmpResult && tmpResult.Error)
			{
				throw new Error(tmpResult.Error.message || tmpResult.Error);
			}
			return ObservationPhotoInputHandler.idObservationOf(tmpResult && tmpResult.IDObservation);
		}
		catch (pError)
		{
			this.pict.log.error(`ObservationPhoto: the photo could not be uploaded: ${(pError && pError.message) || pError}`);
			return 0;
		}
		finally
		{
			if (tmpUploadTracking)
			{
				tmpUploadTracking.untrackUpload(tmpUploadID);
			}
		}
	}

	/**
	 * Called by the record's save once the record has an ID: upload the image held for it, if any. A new record's
	 * image is held under ID 0, so pass that as pHeldForIDRecord and the created ID as pIDRecord.
	 *
	 * @param {string} pEntity - e.g. Location
	 * @param {number} pHeldForIDRecord - the ID the form had when the image was chosen (0 for a new record)
	 * @param {number} pIDRecord - the saved record's ID
	 * @return {Promise<number|null>} the new IDObservation; 0 when the upload failed; null when no image was held
	 */
	async savePendingPhoto(pEntity, pHeldForIDRecord, pIDRecord)
	{
		const tmpKey = ObservationPhotoInputHandler.photoKey(pEntity, pHeldForIDRecord);
		const tmpPending = this._pendingPhotos[tmpKey];
		if (!tmpPending)
		{
			return null;
		}
		delete this._pendingPhotos[tmpKey];
		const tmpIDObservation = await this.uploadPhoto(pEntity, pIDRecord, tmpPending.File);
		if (tmpIDObservation && tmpPending.PreviewURL)
		{
			this._localPreviews[tmpIDObservation] = tmpPending.PreviewURL;
		}
		return tmpIDObservation;
	}

	/**
	 * Add photo / Replace photo: hold the chosen image until the record saves.
	 *
	 * @param {string} pInputHTMLID
	 * @return {Promise<boolean>} true when an image is now held
	 */
	async handlePhotoSelection(pInputHTMLID)
	{
		const tmpFileInput = this._element(this.getFileInputHTMLID(pInputHTMLID));
		if (!(tmpFileInput instanceof HTMLInputElement) || !tmpFileInput.files || (tmpFileInput.files.length < 1))
		{
			return false;
		}
		const tmpFile = tmpFileInput.files[0];
		// clear the chooser so picking the same file again still fires a change
		tmpFileInput.value = '';
		if (!/^image\//i.test(tmpFile.type || ''))
		{
			this.setStatus(pInputHTMLID, 'Choose an image file.', true);
			return false;
		}
		const tmpField = this._fields[pInputHTMLID] || { Entity: '', IDRecord: 0 };
		this._pendingPhotos[ObservationPhotoInputHandler.photoKey(tmpField.Entity, tmpField.IDRecord)] = { File: tmpFile, PreviewURL: this._previewURLFor(tmpFile) };
		this.setStatus(pInputHTMLID, 'The photo will be uploaded when you save.');
		// the value itself only changes when the upload links the photo; this marks the form as changed
		const tmpHidden = this._element(this.getInputHTMLID(pInputHTMLID));
		this.setValue(pInputHTMLID, ObservationPhotoInputHandler.idObservationOf(tmpHidden instanceof HTMLInputElement ? tmpHidden.value : 0));
		this.showPhoto(pInputHTMLID, tmpHidden instanceof HTMLInputElement ? tmpHidden.value : 0, false);
		return true;
	}

	/**
	 * Remove photo: drop any held image and unlink the photo from the record (the observation itself is kept).
	 *
	 * @param {string} pInputHTMLID
	 */
	handleRemovePhoto(pInputHTMLID)
	{
		const tmpField = this._fields[pInputHTMLID] || { Entity: '', IDRecord: 0 };
		delete this._pendingPhotos[ObservationPhotoInputHandler.photoKey(tmpField.Entity, tmpField.IDRecord)];
		this.setStatus(pInputHTMLID);
		this.setValue(pInputHTMLID, 0);
		this.showPhoto(pInputHTMLID, 0, false);
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The field's value.
	 * @param {Object} [pView] - The form view, to find the record's ID.
	 */
	handleInputValue(pInput, pValue, pView)
	{
		const tmpInputHTMLID = pInput.Macro.RawHTMLID;
		this.rememberField(pInput, pView);
		const tmpHidden = this._element(this.getInputHTMLID(tmpInputHTMLID));
		const tmpIDObservation = ObservationPhotoInputHandler.idObservationOf(pValue);
		if (tmpHidden instanceof HTMLInputElement)
		{
			tmpHidden.value = String(tmpIDObservation);
		}
		this.showPhoto(tmpInputHTMLID, tmpIDObservation, !!(pInput.PictForm && pInput.PictForm.ReadOnly));
	}

	/**
	 * A freshly opened form starts with no held image, so one chosen on an abandoned form is never uploaded.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpField = this.rememberField(pInput, pView);
		delete this._pendingPhotos[ObservationPhotoInputHandler.photoKey(tmpField.Entity, tmpField.IDRecord)];
		this.handleInputValue(pInput, pValue, pView);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, pView);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = ObservationPhotoInputHandler;

},{"./_UserMarkdown.js":170,"pict-section-form":587}],113:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#OBSERVATIONTYPE-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Observation Type for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Observation Type record yet, get it and store it
			if (!this.pict.AppData.SelectedObservationType || this.pict.AppData.SelectedObservationType.length < 1)
			{
				const tmpResult = await this.pict.providers.ObservationTypeSelector._getObservationTypeByID(pValue);
				this.pict.AppData.SelectedObservationType = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedObservationType?.DisplayName);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],114:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @typedef {import('./PictProvider-Select2Util.js')} Select2UtilProvider */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/** @return {Select2UtilProvider} */
	get Select2Util()
	{
		return this.pict.providers.Select2Util;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#OBSERVATIONTYPE-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#OBSERVATIONTYPE-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	async initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			// TODO:
			// 	This was copied from Observation-View-Search and is how the current panels search handles things.
			//	It currently returns 25 ObservationManifests for IDCustomer=0 (the first 25 rows of the table).
			//  It needs to be filtering by the user's IDCustomer, combining customer and project types, found in
			// 		ObservationManifests and ProjectObservationManifestJoin, respectively.
			// 	That combination is tricky, however, because ProjectObservationManifestJoin is not a true SQL join:
			//		there is no foreign key or reference to IDObservationManifest, only an ObservationManifestName.
			//		If we include ProjectObservationManifestJoin, what ID do we save when the user chooses those?
			//		Also, rows in ProjectObservationManifestJoin don't have matching rows in ObservationManifests.
			//			For example, IDCustomer=1 has many ProjectObservationManifestJoin rows, but no
			//			ObservationManifests rows.
			// 	To add Project types, we'll need a endpoint that puts together project + customer types,
			//		and there seems like there's going to be some work to make that possible.
			this.initializeSelect2Plugin({
				dropdownCssClass: 'theme-dark has-sticky-option',
				placeholder: 'Select an Observation Type...',
				ElementID: this.getSelectInputHTMLID(pInput.Macro.RawHTMLID).replace('#', ''),
				// ParentID: 'ObservationSearch-SearchEntry',
				URL: 'ObservationManifests',
				IDField: 'Name',
				TextField: 'DisplayName',
				StickyOption: { id: 'Legacy Image', text: 'Image' },
			}, () => null);
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			// dropdownParent: $('#' + pOptions.ParentID),
			// dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			// selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			allowClear: true,
			width: '100%',
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change.select2');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the ObservationType for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected ObservationType and set it as the selected ObservationType on the data object
			const tmpObservationType = await this._getObservationTypeByID(pValue);
			this.pict.AppData.SelectedObservationType = tmpObservationType;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedObservationType.IDObservationManifest;
			tmpOption.text = `${this.pict.AppData.SelectedObservationType.DisplayName || ('Unnamed Observation Type #' + this.pict.AppData.SelectedObservationType.IDSObservationType)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	async _getObservationTypeByID(pID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pID)
			{
				this.pict.log.error('No Observation Type ID provided.');
				return reject(new Error('No Observation Type ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`ObservationManifest/${pID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Observation Type: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	async _getProjectObservationManifestJoins(projectID)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`ProjectObservationManifestJoins/By/IDProject/${projectID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Project Observation Type Joins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],115:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.isValid = false;
	}

	/**
	 * Converts the number to a phone number format.
	 * @param {string} pValue - The markdown content.
	 * @return {string} - The HTML content.
	 */
	convertToPhoneNumber(pValue)
	{
		let tmpContent = '';
		const pattern = /^\(\d{3}\) \d{3}-\d{4}$/;
		if (pValue)
		{
			if (pattern.test(pValue))
			{
				tmpContent = pValue;
				this.isValid = true;
			}
			else
			{
				// strip out any non-numeric characters, including dashes and parenthesses
				const tmpPhoneNumber = pValue.replace(/\D/g, '');
				// be smart about the phone number format based on the length of the number
				if (tmpPhoneNumber.length === 7)
				{
					tmpContent = `${tmpPhoneNumber.substring(0, 3)}-${tmpPhoneNumber.substring(3, 7)}`;
					this.isValid = true;
				}
				else if (tmpPhoneNumber.length === 10)
				{
					tmpContent = `(${tmpPhoneNumber.substring(0, 3)}) ${tmpPhoneNumber.substring(3, 6)}-${tmpPhoneNumber.substring(6, 10)}`;
					this.isValid = true;
				}
				else if (tmpPhoneNumber.length === 11)
				{
					tmpContent = `+${tmpPhoneNumber.substring(0, 1)} (${tmpPhoneNumber.substring(1, 4)}) ${tmpPhoneNumber.substring(4, 7)}-${tmpPhoneNumber.substring(7, 11)}`;
					this.isValid = true;
				}
				else
				{
					tmpContent = pValue;
					this.isValid = false;
				}
			}
		}
		return tmpContent;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.convertToPhoneNumber(pValue);
		this.pict.ContentAssignment.assignContent('#' + pInput.Macro.RawHTMLID, tmpContent);
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, 0, this.isValid);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.convertToPhoneNumber(pValue);
		this.pict.ContentAssignment.assignContent(('#' + pInput.Macro.RawHTMLID + '-' + pRowIndex), tmpContent);
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, this.isValid);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],116:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.onChangeCallbacks = [];

		// add the ".is-hidden" class to the type selector by default
		this.pict.MetaTemplate.addPattern('{~ShowTypeSelector:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject?.PictForm?.InputExtra?.includes('Show Type Selector')) ? '' : 'is-hidden';
		});
	}

	getPhysicalAssetSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}-Asset`;
	}

	getAssetTypeSelectInput(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}-Type`;
	}

	getPhysicalAssetHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}-Asset`;
	}

	getAssetTypeHiddenInput(pInputHTMLID)
	{
		return `#${pInputHTMLID}-Type`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PHYSICALASSET-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PHYSICALASSET-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Adds an onChange callback to the input handler.
	 * @param {function} pCallback The callback function.
	 */
	addOnChangeCallback(pCallback)
	{
		if (!pCallback || typeof pCallback !== 'function')
		{
			this.pict.log.error('Invalid onChangeCallback provided.');
			return;
		}
		// check if the callback is already in the list
		if (this.onChangeCallbacks.indexOf(pCallback) > -1)
		{
			this.pict.log.warn('onChangeCallback already exists in the list.');
			return;
		}
		this.onChangeCallbacks.push(pCallback);
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.getElement(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
		this.pict.ContentAssignment.addClass(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
		this.pict.ContentAssignment.removeClass(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {number} pTypeFilter The state fitler string.
	 */
	initializeSelect2(pInput, pTypeFilter)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpAssetTypeSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('AssetType',
				{
					Input: pInput,
					SearchFields: [ 'AssetNumber', 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Select an Asset Type...',
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID)).select2(tmpAssetTypeSelectOptions);
			}

			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('PhysicalAsset',
				{
					Input: pInput,
					SearchFields: [ 'AssetNumber', 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: `Select a Physical Asset by name or code...`,
					HandleSearchFilters: (pFilters) =>
					{
						if (!pTypeFilter)
						{
							return pFilters;
						}
						pFilters.push(`FBV~IDAssetType~EQ~${pTypeFilter}`);

						return pFilters;
					},
					GetRecordUserFacingID: (pPhysicalasset) => pPhysicalasset.AssetNumber || 'N/A',
				});
			window['jQuery'](this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		const rawHTMLID = pInput.Macro.RawHTMLID;
		const assetHiddenInput = $(this.getPhysicalAssetHiddenInputHTMLID(rawHTMLID));
		const assetTypeHiddenInput = $(this.getAssetTypeHiddenInput(rawHTMLID));
		assetHiddenInput.attr('data-i-datum', `${pInput.DataAddress}.Asset`);
		assetTypeHiddenInput.attr('data-i-datum', `${pInput.DataAddress}.AssetType`);
		if (pInput.Default)
		{
			this.assetType = pInput.Default;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		if (this.assetType && !pValue.AssetType)
		{
			const assetTypes = await this.pict.providers.PhysicalAssetProvider.getPhysicalAssetTypeByName(this.pict.AppData?.CurrentUser?.CustomerID, this.assetType);
			if (assetTypes && assetTypes.length > 0)
			{
				pValue.AssetType = assetTypes[0].IDAssetType;
			}
		}

		const tmpAssetInputSelectElements = this.pict.ContentAssignment.getElement(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID));
		const tmpAssetInputAssetTypeSelectElements = this.pict.ContentAssignment.getElement(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID));
		if ((!tmpAssetInputSelectElements || tmpAssetInputSelectElements.length < 1) && (!tmpAssetInputAssetTypeSelectElements || tmpAssetInputAssetTypeSelectElements.length < 1))
		{
			return false;
		}

		await this.updateDataFields(pInput, pValue);

		// get the configuration for the current user to filter the Physicalasset search results (by State, etc.)
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.pict.AppData?.CurrentUser?.CustomerID, async (pConfig) =>
		{
			let assetType;
			if (Number.isNaN(parseInt(this.assetType)))
			{
				assetType = await this.pict.providers.PhysicalAssetProvider.getPhysicalAssetTypeByName(this.pict.AppData?.CurrentUser?.CustomerID, this.assetType);
			}
			else
			{
				assetType = this.assetType ? await this.pict.providers.PhysicalAssetProvider.getAssetTypeByID(this.assetType) : null;
			}
			this.initializeSelect2(pInput, assetType?.IDAssetType);
			this.removeLoadingSkeleton(pInput);
		});
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		let tmpInputSelectAssetValue = $(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID)).val();
		const tmpInputSelectAssetTypeValue = $(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID)).val();
		if (pValue.AssetType != tmpInputSelectAssetTypeValue)
		{
			tmpInputSelectAssetValue = '';
		}
		const tmpInputValues = {
			AssetType: tmpInputSelectAssetTypeValue,
			Asset: tmpInputSelectAssetValue,
		};
		this.pict.ContentAssignment.assignContent(this.getPhysicalAssetHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpInputSelectAssetValue.toString());
		this.pict.ContentAssignment.assignContent(this.getAssetTypeHiddenInput(pInput.Macro.RawHTMLID), tmpInputSelectAssetTypeValue.toString());
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputValues, pHTMLSelector);
	}

	async updateDataFields(pInput, pValue)
	{
		// if we have a value (ID), go fetch the Physicalasset for display (Name, etc.)
		if (pValue && (pValue.hasOwnProperty('Asset') || pValue.hasOwnProperty('AssetType')))
		{
			const assetType = pValue.AssetType;
			const asset = pValue.Asset;
			// get the value of the selected Physicalasset and set it as the selected Physicalasset on the data object
			const tmpPhysicalasset = asset ? await this.pict.providers.PhysicalAssetProvider.getPhysicalAssetByID(asset) : null;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getPhysicalAssetSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			if (!tmpSelectElement)
			{
				return false;
			}

			if (tmpPhysicalasset?.IDAssetType == assetType)
			{
				tmpOption.value = tmpPhysicalasset.IDPhysicalAsset;
				tmpOption.text = `${tmpPhysicalasset.AssetNumber || 'N/A'}|~|${tmpPhysicalasset.Name || ('Unnamed Physicalasset #' + this.pict.AppData.SelectedPhysicalasset.IDPhysicalasset)}`;
				tmpOption.selected = true;
				tmpSelectElement.appendChild(tmpOption);
			}
			else
			{
				tmpOption.value = ``;
				tmpOption.text = ``;
				tmpOption.selected = true;
				tmpSelectElement.appendChild(tmpOption);
				this.pict.ContentAssignment.assignContent(this.getPhysicalAssetHiddenInputHTMLID(pInput.Macro.RawHTMLID), '');
			}

			// get the value of the selected Physicalasset and set it as the selected Physicalasset on the data object
			const tmpPhysicalAssetType = assetType ? await this.pict.providers.PhysicalAssetProvider.getAssetTypeByID(assetType) : null;
			// build the prefilled value for the select2 dropdown
			const tmpAssetTypeOption = document.createElement('option');
			const tmpAssetTypeSelectElement = this.pict.ContentAssignment.getElement(this.getAssetTypeSelectInput(pInput.Macro.RawHTMLID))[0];
			if (!tmpAssetTypeSelectElement)
			{
				tmpOption.value = ``;
				tmpOption.text = ``;
				tmpOption.selected = true;
				tmpSelectElement.appendChild(tmpOption);
				this.pict.ContentAssignment.assignContent(this.getAssetTypeHiddenInput(pInput.Macro.RawHTMLID), '');
			}
			else
			{
				tmpAssetTypeOption.value = tmpPhysicalAssetType.IDAssetType;
				tmpAssetTypeOption.text = `${tmpPhysicalAssetType.Name}`;
				tmpAssetTypeOption.selected = true;
				tmpAssetTypeSelectElement.appendChild(tmpAssetTypeOption);
			}

			this.assetType = assetType;
		}
		else
		{
			this.pict.log.info('No Physicalasset selected.');
		}
	}

	/**
	 * Handles the data change event for a select input in the PictProviderInputSelect class.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.onChangeCallbacks.length > 0)
		{
			this.onChangeCallbacks.forEach((pCallback) =>
			{
				pCallback(pView, pInput, pValue, pHTMLSelector);
			});
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],117:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

// The pict-section-form input-type adapter from pict-section-picker (host-agnostic). This Headlight
// subclass supplies the HOST-SPECIFIC context the module deliberately knows nothing about: project
// scoping for project-resident entities + the spec-set floor on the lab axis. It is the
// select2-free replacement for EntitySelectorMultiple — same Entity/Multiple descriptor config, but
// rendered by the pict-native picker.
const PictInputTypePicker = require('pict-section-picker/form').PictInputTypePicker;
// The values a descriptor's picker paints as "nothing selected" — handed to the widget via _resolveEmptyValues
// and used to keep `__Record` in step with what the control shows.
const libPickerEmptyValues = require('./_PickerEmptyValues.js');
// Reads by a non-simple identity share an in-flight request with any other selector reading the same row.
const libSharedEntityRead = require('./_SharedEntityRead.js');

// Headlight override CSS for the Picker — injected once (higher CSSMap priority than pict-section-picker's
// base `.pps` block so it wins, and the selectors out-specify the base rules regardless). Theme-aware via
// --bulma-*/--theme-color-* tokens (light + dark inherit for free). Three concerns:
//   1. Disabled parity (PictForm.Disabled) — a greyed, non-interactive box matching the sibling disabled
//      inputs, using the exact --bulma-input-disabled-* palette (headlight-styles/bulma-extended.scss):
//      borderless (the disabled border token equals the fill), light-gray fill, muted text/placeholder,
//      chevron and clear/chip × hidden (a visible chevron on a disabled control was a Select2 quirk). Scoped to a
//      `data-disabled` host marker the broker sets per field, so it never restyles a genuine ReadOnly
//      picker (whose interactive widget also carries `.pps-readonly`); the dropdown stays hidden even
//      under a stray keyboard-open.
//   2. EntityTag pill (Edit theme) — the pill color follows SELECTION so selected items scan at a glance:
//      UNSELECTED dropdown options keep pict-section-picker's muted base `.pps-tag`; SELECTED options
//      (`.pps-option.pps-selected`) + the in-field chips (`.pps-chip`) / single value (`.pps-valuebox`)
//      get a solid brand pill with near-white text. A color transition is set for the fade, but note the
//      dropdown re-renders its option list on select, so the smooth toggle-fade only shows where the
//      element persists (a class-toggle in PSP `_renderList` would make it fully animate — publish-gated).
//      (Read/Print `.select2-*` pill keeps its own bulma-print look, unchanged.)
//   3. Blank-display fallback — a selection with no display text and no record ID to label it by (an entity
//      record with no name reads `Document #282` instead; see _labelBlankEntityOption) shows a faded marker
//      so a user/developer can spot it: Edit paints nothing into the text spans, so an :empty::after
//      supplies it; Read/Print paints the `.picker-display-empty` span (see PickerDisplay).
//   4. Placeholder color — align the picker's empty-state placeholder to Bulma's faded --bulma-input-
//      placeholder-color so it matches native inputs (PSP's default --theme-color-text-muted read darker).
//   5. Split-pill chip (Edit) — an in-field chip whose EntityTag leads is fused into ONE pill: the chip
//      drops its left/top/bottom padding and the leading `.pps-tag` fills the left flush + full-height
//      with squared right corners, so it reads as a single pill split in half (dark entity | light value).
//      Scoped via :has(> .pps-tag:first-child) so tagless chips + the dropdown options are untouched.
//   6. Addons flush (Bulma has-addons, e.g. the Sample template's search-panel button): Bulma squares the
//      touching corners of ITS controls (.input/.button/.select) only — the picker's .pps-control keeps
//      rounded corners against the addon button. Square the touching edge on both sides.
//   7. Validation state — InputValidation marks the field's `.control.control-status` wrapper is-danger /
//      is-success; Bulma only recolors native .input/.textarea from it, so the picker's .pps-control border
//      follows the same state (the Select2 twin is in headlight-styles bulma-control-status.scss).
//   8. Solver background color — ColorInputBackground / ColorInputBackgroundTabular set an inline
//      background-color on the host (it carries the ControlAttr), which PSP's opaque .pps-control would hide;
//      the control inherits it instead, and goes back to its own fill once the inline color is cleared.
const _HEADLIGHT_PICKER_OVERRIDES_CSS = /*css*/`
.pps-form-host[data-disabled="true"] { pointer-events: none; }
.pps-form-host[data-disabled="true"] .pps-control {
	background: var(--bulma-input-disabled-background-color);
	border-color: var(--bulma-input-disabled-border-color);
	box-shadow: none;
	color: var(--bulma-input-disabled-color);
	cursor: not-allowed;
}
.pps-form-host[data-disabled="true"] .pps-control:hover { border-color: var(--bulma-input-disabled-border-color); box-shadow: none; }
.pps-form-host[data-disabled="true"] .pps-value { color: var(--bulma-input-disabled-color); }
.pps-form-host[data-disabled="true"] .pps-value.pps-placeholder,
.pps-form-host[data-disabled="true"] .pps-chips-ph { color: var(--bulma-input-disabled-placeholder-color); }
.pps-form-host[data-disabled="true"] .pps-chevron,
.pps-form-host[data-disabled="true"] .pps-clear,
.pps-form-host[data-disabled="true"] .pps-chip-x { display: none; }
.pps-form-host[data-disabled="true"] .pps-pop,
.pps-form-host[data-disabled="true"] .pps-backdrop { display: none; }
.pps-tag { transition: background-color 0.15s ease, color 0.15s ease; }
.pps-chip .pps-tag,
.pps-valuebox .pps-tag,
.pps-option.pps-selected .pps-tag {
	background: var(--theme-color-brand-primary, #156dd1);
	color: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, #ffffff);
}
.pps-chip:has(> .pps-tag:first-child) { padding-top: 0; padding-bottom: 0; padding-left: 0; }
.pps-chip:has(> .pps-tag:first-child) > .pps-tag:first-child {
	align-self: stretch;
	padding: 0.2rem 0.45rem;
	border-radius: 6px 0 0 6px;
}
.pps-value:empty::after,
.pps-chip-text:empty::after,
.pps-option-label:empty::after { content: 'no text provided'; font-style: italic; opacity: 0.55; }
.picker-display-empty { font-style: italic; opacity: 0.55; }
.pps-value.pps-placeholder,
.pps-chips-ph { color: var(--bulma-input-placeholder-color, var(--bulma-text-weak)); }
.field.has-addons .control:not(:last-child) .pps-control {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.field.has-addons .control:not(:first-child) .pps-control {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}
.control.control-status.is-danger .pps-control { border-color: var(--bulma-danger); }
.control.control-status.is-success .pps-control { border-color: var(--bulma-success); }
.pps-form-host[style*="background-color"] > .pps,
.pps-form-host[style*="background-color"] .pps-control { background-color: inherit; }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Picker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

// R2 port-forward map for the specialized per-entity selectors (LabSelector, PlantSelector, …) —
// their Entity is provider-hardcoded, not in the descriptor. Shared with PictProvider-InputType-
// PickerDisplay so the Edit picker and the Read/Print display infer the entity identically.
const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');
const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');
// Shared with PictProvider-InputType-PickerDisplay so Edit and Read/Print both ignore a static select's Entity.
const libStaticSelectEntity = require('./_StaticSelectEntity.js');
const libEntityOptionSource = require('./_EntityOptionSource.js');
const libFilterToggleUI = require('./_FilterToggleUI.js');
const libLabRouting = require('./_LabRouting.js');
const libEntityDisplayName = require('./_EntityDisplayName.js');

// Spec-set floors — the SpecScopeResolver getter + FoxHound id-field per entity. Kept in lockstep
// with the MES's SPEC_SET_AXIS (defined in-broker to avoid coupling to the retiring MES module).
// Materials, tests and pay items narrow through their DynamicFilters entries; the lab axis is the
// one remaining set-membership floor.
const _SPEC_SET_AXIS =
{
	Lab: { getter: 'getAllowedLabIDs', field: 'IDLab' },
};

class PictProviderInputTypePicker extends PictInputTypePicker
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
		// Inherited fable-service member the duplicate-pict-provider type chain hides from tsc.
		/** @type {Record<string, any>} */
		this.options;
		// Host-app onChange subscriptions (the legacy per-selector addOnChangeCallback API — e.g. the
		// bridge depth-soundings view re-solves when its BridgeSelector field changes). One broker serves
		// every InputType, so each entry may carry an InputType filter.
		/** @type {Array<{Callback: Function, InputType: (string|null)}>} */
		this.onChangeCallbacks = [];
	}

	/**
	 * Subscribe to committed selections, ported from the legacy selector providers' addOnChangeCallback
	 * (BridgeSelector et al.). The callback receives (pView, pInput, pValue, pHTMLSelector). Because the
	 * Picker broker serves every InputType, pass pInputTypeFilter (e.g. 'BridgeSelector') to hear only
	 * that InputType's fields; omit it to hear every picker field.
	 * @param {Function} pCallback @param {string} [pInputTypeFilter]
	 */
	addOnChangeCallback(pCallback, pInputTypeFilter)
	{
		if (!pCallback || typeof pCallback !== 'function')
		{
			this.pict.log.error('Invalid onChangeCallback provided.');
			return;
		}
		// Lazy init: test harnesses build the provider via Object.create (no constructor run).
		if (!Array.isArray(this.onChangeCallbacks)) { this.onChangeCallbacks = []; }
		if (this.onChangeCallbacks.some((pEntry) => pEntry.Callback === pCallback))
		{
			this.pict.log.warn('onChangeCallback already exists in the list.');
			return;
		}
		this.onChangeCallbacks.push({ Callback: pCallback, InputType: pInputTypeFilter || null });
	}

	/** Fire any subscribed onChange callbacks whose InputType filter matches this input (legacy parity:
	 *  fired ahead of the rest of the change handling, args (pView, pInput, pValue, pHTMLSelector)). */
	_fireOnChangeCallbacks(pView, pInput, pValue, pHTMLSelector)
	{
		if (!Array.isArray(this.onChangeCallbacks) || this.onChangeCallbacks.length < 1) { return; }
		const tmpInputType = pInput?.PictForm?.InputType;
		this.onChangeCallbacks.forEach((pEntry) =>
		{
			if (pEntry.InputType && pEntry.InputType !== tmpInputType) { return; }
			try { pEntry.Callback(pView, pInput, pValue, pHTMLSelector); }
			catch (pError) { this.pict.log.error(`Picker onChangeCallback threw for [${pInput?.Hash}]:`, pError); }
		});
	}

	/**
	 * Map the EntitySelectorMultiple descriptor vocabulary onto the picker's, so migrating a schema is
	 * just an InputType change: IdentityField → ValueField, EntityDisplayField → TextField (+ search it).
	 *
	 * @param {Record<string, any>} pInput @param {string} pHostSelector @param {Function} fOnChange
	 * @return {Record<string, any>}
	 */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		libStaticSelectEntity.dropStaticSelectEntity(pInput && pInput.PictForm);
		const tmpConfig = super._buildPickerConfig(pInput, pHostSelector, fOnChange);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		// R2 port-forward: a specialized selector (LabSelector, PlantSelector, …) hardcodes its Entity and display
		// config in its legacy provider. Infer them from the InputType BEFORE the generic (non-entity) Select
		// fallback below, which would otherwise treat an entity-less descriptor as a static option list. A
		// descriptor naming the same Entity still gets the map's config (legacy ignored the descriptor's Entity);
		// display config the descriptor sets itself wins. See _SPECIALIZED_SELECTOR_MAP.
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType];
		if (tmpSpecialized && (!tmpConfig.Entity || tmpConfig.Entity === tmpSpecialized.Entity))
		{
			tmpConfig.Entity = tmpSpecialized.Entity;
			if (!tmpConfig.TextField && !tmpPictForm.EntityDisplayField && tmpSpecialized.TextField) { tmpConfig.TextField = tmpSpecialized.TextField; }
			if (!tmpConfig.SearchFields && Array.isArray(tmpSpecialized.SearchFields)) { tmpConfig.SearchFields = tmpSpecialized.SearchFields.slice(); }
			if (!tmpConfig.EntityTag && tmpSpecialized.EntityTag) { tmpConfig.EntityTag = tmpSpecialized.EntityTag; }
		}
		// The config map's placeholder applies whenever the descriptor sets none, Entity or not (legacy parity).
		// Test the descriptor: PSP's adapter always pre-fills a default Placeholder.
		if (!tmpPictForm.Placeholder && tmpSpecialized?.Placeholder) { tmpConfig.Placeholder = tmpSpecialized.Placeholder; }
		if (!tmpConfig.ValueField && tmpPictForm.IdentityField) { tmpConfig.ValueField = tmpPictForm.IdentityField; }
		if (!tmpConfig.TextField && tmpPictForm.EntityDisplayField) { tmpConfig.TextField = tmpPictForm.EntityDisplayField; }
		if (!tmpConfig.SearchFields && tmpConfig.TextField) { tmpConfig.SearchFields = [ tmpConfig.TextField ]; }
		// Composed, disambiguated display for User pickers — mirror the recordset entity-filter "list entry"
		// (name + email/login) so a FORM's assignee / created-by picker reads the same as the list filters,
		// instead of one ambiguous field. Applies to every app's User pickers; a schema can override by
		// setting its own PictForm.TextTemplate. (The per-entity template should eventually live on Stricture.)
		if (tmpConfig.Entity === 'User' && !tmpConfig.TextTemplate)
		{
			this._registerUserListEntryTemplates();
			tmpConfig.TextTemplate = '{~DWTF:Record.NameFull:HL-EntityListEntry-User-NameParts~} ({~DWTF:Record.Email:HL-EntityListEntry-User-Login~})';
			// Make the disambiguators searchable too (so you can type an email/login, not just a name).
			if (!tmpPictForm.SearchFields)
			{
				tmpConfig.SearchFields = [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ];
			}
		}

		// A–Z like legacy: every select2 entity selector sorted by its label (Select2Util `FSF~<field>~ASC~0`).
		// PictForm.Sort (else the config map's Sort) names another field or `false` opts out; a dotted label path cannot be sorted server-side.
		if (tmpConfig.Entity && tmpConfig.Sort === undefined)
		{
			let tmpSortField = tmpPictForm.Sort;
			if (tmpSortField === undefined && tmpSpecialized && (tmpConfig.Entity === tmpSpecialized.Entity))
			{
				tmpSortField = tmpSpecialized.Sort;
			}
			if (tmpSortField === undefined) { tmpSortField = tmpConfig.TextField || ((tmpConfig.Entity === 'User') ? 'NameFirst' : 'Name'); }
			if (tmpSortField && !String(tmpSortField).includes('.')) { tmpConfig.Sort = tmpSortField; }
		}

		// Generic (non-entity) Select path — map the legacy SelectOptions / SelectOptionsPickList
		// vocabulary onto the picker so a Select / Option / Select2 / Select2Multiple field migrates to
		// InputType 'Picker' with no data edits. Skipped when an Entity (server path) or a native
		// Options array is already in play.
		if (!tmpConfig.Entity && (!Array.isArray(tmpConfig.Options) || tmpConfig.Options.length === 0))
		{
			this._applyGenericSelectSource(tmpConfig, pInput);
		}
		// Hide the search box on short STATIC option lists (<= 3 items) — a Yes/No/Maybe or Left/Center/Right
		// picker doesn't need one. Only when the descriptor didn't set Searchable explicitly, and only for the
		// resolved static Options path (entity pickers + dynamic picklists always server-search, so leave those).
		// AllowCustomValues keeps it too: the search box is the only place to type a new value.
		if (!tmpConfig.Entity && !tmpConfig.DataProvider && tmpPictForm.Searchable === undefined && !tmpPictForm.AllowCustomValues && Array.isArray(tmpConfig.Options))
		{
			tmpConfig.Searchable = (tmpConfig.Options.length > 3);
		}
		// AllowCustomValues (select2 `tags`) → the picker's creatable OnCreate: a typed value matching
		// no option becomes a "Create <term>" row committing the raw string as both value and label.
		if (tmpPictForm.AllowCustomValues && !tmpConfig.OnCreate)
		{
			tmpConfig.OnCreate = (pTerm) => ({ Value: pTerm, Text: pTerm });
		}
		this._applyFacetCreate(tmpConfig, pInput);
		this._applyCustomValueMemory(tmpConfig, pInput);
		if (this._isMultiplePicker(tmpPictForm))
		{
			tmpConfig.Mode = 'multi';
		}
		// Clearable parity (found live on the B1 fixture): every legacy select2 path defaulted
		// allowClear TRUE (Select2Util `?? true`, generic Select unconditional), but neither PSP's
		// form adapter nor this broker mapped it — so a migrated single picker had NO user-facing
		// clear (writing '' became unreachable, an MVP-rule functional loss). Same default + same
		// descriptor override (PictForm.AllowClear: false). PSP applies it in single mode only
		// (multi clears chip-by-chip, as before).
		if (tmpConfig.AllowClear === undefined)
		{
			// The config map's AllowClear sits between the two (legacy BridgeSelector was never clearable).
			tmpConfig.AllowClear = tmpPictForm.AllowClear ?? tmpSpecialized?.AllowClear ?? true;
		}
		// Tabular: thread the row context into the per-row BaseFilter closure (plan §5.3). The tabular mount
		// override stashes { pView, pRowIndex } transiently around this build (see _withTabularContext), so
		// capture them here — once per row, at build time — and each row's search then narrows by its OWN
		// FromRowField / per-row Show-All. Non-tabular keeps super's row-less BaseFilter (pRowIndex null → the
		// engine's per-row paths no-op, exactly as before).
		const tmpTabCtx = this._activeTabularContext;
		if (tmpTabCtx && tmpTabCtx.pRowIndex != null)
		{
			const tmpRowIndex = tmpTabCtx.pRowIndex;
			const tmpRowView = tmpTabCtx.pView;
			tmpConfig.BaseFilter = () => this.getContextualSearchFilters(pInput, tmpRowIndex, tmpRowView);
		}
		// Legacy ProjectSelector pinned the document's own project to the top of its list (GetPinnedItem).
		if (tmpPictForm.InputType === 'ProjectSelector' && !tmpConfig.PriorityValues)
		{
			const tmpDocumentProjectID = this._getDocumentProjectID();
			if (tmpDocumentProjectID) { tmpConfig.PriorityValues = [ tmpDocumentProjectID ]; }
		}
		// Pin-to-top for lab pickers: float the project's own labs above the rest of the first browse page
		// without removing anything. PSP resolves this once per data-provider closure, which createEntityPicker
		// rebuilds on every marshal-driven re-mount — so a changed anchor (a new parent lab, a new test) is
		// picked up on the next marshal rather than sticking for the session.
		this._applyLabPriorityValues(tmpConfig, pInput, tmpTabCtx);
		this._applyEmptyListLabel(tmpConfig, pInput, tmpTabCtx);
		this._applyIDMatchLabel(tmpConfig);
		// Minimum-search-length parity: legacy select2 gated searches at `MinimumInputLengthForSearch`
		// (per-input, with a HeadlightPanels global fallback; Select2Util `?? ?? 0`). Only set it when
		// non-zero so the PSP default (0 = always query) stands for the common case.
		const tmpMinSearch = tmpPictForm.MinimumInputLengthForSearch ??
			this.pict.views?.HeadlightPanels?.MinimumInputLengthForSearch ??
			0;
		if (tmpMinSearch)
		{
			tmpConfig.MinimumSearchLength = tmpMinSearch;
		}
		// PSP's default ResolveValue reads `<Entity>/<value>`, which finds a record by its numeric id only, so a
		// value committed under another identity (GUIDSample, a Test Hash) would paint as its raw value.
		const tmpIdentity = tmpConfig.Entity ? this._getRecordIdentity(pInput) : null;
		if (tmpIdentity && (tmpIdentity !== `ID${tmpConfig.Entity}`) && (typeof tmpConfig.ResolveValue !== 'function'))
		{
			const tmpResolveView = tmpTabCtx ? tmpTabCtx.pView : null;
			const tmpResolveRow = (tmpTabCtx && tmpTabCtx.pRowIndex != null) ? tmpTabCtx.pRowIndex : null;
			tmpConfig.ResolveValue = (pValue) => this._resolveIdentityOption(tmpConfig, pInput, tmpIdentity, tmpResolveView, tmpResolveRow, pValue);
		}
		// Not a pict-section-picker option: _presentEntityOption labels a nameless record with it.
		if (tmpConfig.Entity && pInput && pInput.Name)
		{
			tmpConfig.FieldLabel = pInput.Name;
		}
		return tmpConfig;
	}

	/**
	 * Label a held value whose record identity is not the numeric `ID<Entity>`: from the `__Record` the form
	 * already holds when it matches, else read by identity — the order PickerDisplay resolves the same value in.
	 * Composed by pict-section-picker's own option builder, so the label matches the value's dropdown row.
	 *
	 * @param {Record<string, any>} pConfig - the picker config (Entity, TextField, EntityTag, join settings).
	 * @param {Record<string, any>} pInput @param {string} pIdentityField
	 * @param {Object|null} pView - the form view, when the picker was mounted by one.
	 * @param {number|string|null} pRowIndex @param {any} pValue
	 * @return {Promise<Record<string, any>|null>} the option `{ Value, Text, Record[, Tag][, Tags] }`, or null.
	 */
	_resolveIdentityOption(pConfig, pInput, pIdentityField, pView, pRowIndex, pValue)
	{
		const tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (pValue === undefined || pValue === null || pValue === '' || !tmpProvider || (typeof tmpProvider._composeOption !== 'function'))
		{
			return Promise.resolve(null);
		}
		const tmpHeld = this._findHeldRecord(pView, pInput, pIdentityField, pValue, pRowIndex);
		const tmpLookup = tmpHeld ? Promise.resolve(Object.assign({}, tmpHeld)) : this._resolveEntityRecordByIdentity(pConfig.Entity, pIdentityField, pValue);
		const tmpJoinConfig = tmpProvider._resolveJoinConfig(pConfig);
		return tmpLookup
			.then((pRecord) =>
			{
				if (!pRecord)
				{
					return null;
				}
				const tmpFK = tmpJoinConfig ? pRecord[tmpJoinConfig.FKColumn] : null;
				if (tmpFK === undefined || tmpFK === null || tmpFK === '')
				{
					return pRecord;
				}
				return new Promise((resolve) =>
				{
					this.pict.EntityProvider.getEntity(tmpJoinConfig.Entity, tmpFK, (pJoinError, pJoinRecord) =>
					{
						if (!pJoinError && pJoinRecord)
						{
							pRecord.JoinRecord = pJoinRecord;
							pRecord.JoinName = pJoinRecord[tmpJoinConfig.DisplayField];
						}
						resolve(pRecord);
					});
				});
			})
			.then((pRecord) => (pRecord ? tmpProvider._composeOption(pRecord, pIdentityField, pConfig.TextField || 'Name', tmpJoinConfig,
				pConfig.EntityTag || false, pConfig.TextTemplate || false, Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false) : null))
			.catch((pError) =>
			{
				this.pict.log.warn(`Picker [${pConfig.Entity}]: could not label [${pValue}]: ${pError?.message || pError}`);
				return null;
			});
	}

	/**
	 * The held `__Record` (or, for a multi picker, the held record in its array) whose identity is pValue.
	 * @param {Object|null} pView @param {Record<string, any>} pInput @param {string} pIdentityField @param {any} pValue
	 * @param {number|string|null} pRowIndex
	 * @return {Record<string, any>|null}
	 */
	_findHeldRecord(pView, pInput, pIdentityField, pValue, pRowIndex)
	{
		if (!pView || (typeof pView.getMarshalDestinationObject !== 'function'))
		{
			return null;
		}
		const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		const tmpCandidates = Array.isArray(tmpHeld) ? tmpHeld : [ tmpHeld ];
		return tmpCandidates.find((pRecord) => pRecord && (typeof pRecord === 'object') && (pRecord[pIdentityField] == pValue)) || null;
	}

	/**
	 * Install the lab pin-to-top resolver on a picker config, when the descriptor scopes by `LabScope` and the
	 * LabScopeResolver is registered. The resolver answers with the labs belonging to the project (its district
	 * lab, its unit lab — whatever the manifest's `LabAffinity` rules name), in rule order. Empty when the form
	 * configures no affinity, which leaves the picker exactly as it was.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @param {{pView: Object, pRowIndex: number|string}|null} [pTabularContext] - the row context when tabular.
	 */
	_applyLabPriorityValues(pConfig, pInput, pTabularContext)
	{
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		const tmpResolver = this.pict.providers.LabScopeResolver;
		if (!tmpEngine || !tmpResolver || pConfig.PriorityValues)
		{
			return;
		}
		const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpFilters))
		{
			return;
		}
		const tmpFilter = tmpFilters.find((pEntry) => pEntry && pEntry.LabScope);
		if (!tmpFilter)
		{
			return;
		}
		const tmpRowIndex = (pTabularContext && pTabularContext.pRowIndex != null) ? pTabularContext.pRowIndex : null;
		const tmpRowView = (pTabularContext && pTabularContext.pView) ? pTabularContext.pView : null;
		pConfig.PriorityValues = () =>
		{
			return tmpResolver.getPreferredLabIDs(tmpFilter.LabScope,
				{
					IDTest: tmpEngine._readLabScopeTestID(tmpFilter, pInput, tmpRowIndex, tmpRowView),
					SelectedLabIDs: libLabRouting.collectSelectedTestLabIDs(this.pict),
				});
		};
	}

	/**
	 * Run a tabular mount with { pView, pRowIndex } stashed on the instance so the synchronous
	 * _buildPickerConfig call inside it can capture the row into the per-row BaseFilter closure (plan §5.3).
	 * Mounts are synchronous and one-row-at-a-time, so a transient instance field is race-free; restored in
	 * a finally (nesting-safe) so a single (non-tabular) mount never sees a stale row. The mounted value
	 * rides along for _applyCustomValueMemory.
	 * @param {Object} pView @param {number|string} pRowIndex @param {Function} fCallback @param {any} [pValue] @return {any}
	 */
	_withTabularContext(pView, pRowIndex, fCallback, pValue)
	{
		const tmpPrior = this._activeTabularContext || null;
		this._activeTabularContext = { pView, pRowIndex, pValue };
		try { return fCallback(); }
		finally { this._activeTabularContext = tmpPrior; }
	}

	/**
	 * Whether this picker is multi-select — the single rule both the widget Mode and the `__Record`
	 * payload shape (array vs object) resolve from, so the two can't disagree.
	 *
	 * Port-forwarded legacy multi InputTypes infer it from their NAME: `Select2Multiple` (multi keyed off
	 * the InputType name in the Select provider) and `EntitySelectorMultiple` (whose provider hardcoded
	 * Multiple: true) carry no `PictForm.Multiple` flag; their templates render via the Picker but keep
	 * the original InputType, so a field needs no manifest edit to stay multi.
	 *
	 * @param {Record<string, any>} pPictForm @return {boolean}
	 */
	_isMultiplePicker(pPictForm)
	{
		if (!pPictForm) { return false; }
		return !!pPictForm.Multiple || pPictForm.InputType === 'Select2Multiple' || pPictForm.InputType === 'EntitySelectorMultiple';
	}

	/**
	 * Mount the picker view, then route an entity picker's search results and its saved-value resolve
	 * through _presentEntityOption, so a record with no name reads `Document #282` in the dropdown, in the
	 * chip a pick leaves, and when a saved form reloads. createPicker re-assigns a fresh DataProvider and
	 * ResolveValue on every mount, so the wrap is re-applied each time rather than stacked.
	 *
	 * @param {string} pPickerHash @param {Record<string, any>} pConfig @return {any} The picker view.
	 */
	_instantiatePicker(pPickerHash, pConfig)
	{
		const tmpView = super._instantiatePicker(pPickerHash, pConfig);
		if (!tmpView?.options || !pConfig?.Entity)
		{
			return tmpView;
		}
		const fLabel = (pOption) => this._presentEntityOption(pOption, pConfig);
		const fDataProvider = tmpView.options.DataProvider;
		if (typeof fDataProvider === 'function')
		{
			tmpView.options.DataProvider = (pSearchTerm, pPage) => Promise.resolve(fDataProvider(pSearchTerm, pPage)).then((pResult) =>
			{
				if (!pResult || !Array.isArray(pResult.results))
				{
					return pResult;
				}
				return Object.assign({}, pResult, { results: pResult.results.map(fLabel) });
			});
		}
		const fResolveValue = tmpView.options.ResolveValue;
		if (typeof fResolveValue === 'function')
		{
			tmpView.options.ResolveValue = (pValue) => Promise.resolve(fResolveValue(pValue)).then(fLabel);
		}
		return tmpView;
	}

	/**
	 * An entity option as this picker shows it in the dropdown, in the chip a pick leaves and when a saved value
	 * reloads: a blank label reads `<entity label> #<record ID>` (_labelBlankEntityOption).
	 *
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {Record<string, any>} pConfig - the picker config.
	 * @return {Record<string, any>} The option, or a copy of it.
	 */
	_presentEntityOption(pOption, pConfig)
	{
		return this._labelBlankEntityOption(pOption, pConfig.Entity, pConfig.FieldLabel);
	}

	/**
	 * An entity option whose label is blank takes `<entity label> #<record ID>` as its label (`Document #282`,
	 * `Contractor #3456`), the same text PickerDisplay paints for it in Read/Print. A tag of its own is kept.
	 *
	 * @param {Record<string, any>} pOption - a picker option `{ Value, Text, Record[, Tag][, Tags] }`.
	 * @param {string} pEntity - the picker's entity, naming the record's ID column.
	 * @param {string} [pFieldLabel] - the field's label, which names an Organization's role.
	 * @return {Record<string, any>} The option, or a labelled copy of it.
	 */
	_labelBlankEntityOption(pOption, pEntity, pFieldLabel)
	{
		if (!pOption || (typeof pOption !== 'object'))
		{
			return pOption;
		}
		const tmpText = (pOption.Text === undefined || pOption.Text === null) ? '' : String(pOption.Text);
		if (tmpText.trim() !== '')
		{
			return pOption;
		}
		const tmpRecordID = pOption.Record ? pOption.Record[`ID${pEntity}`] : undefined;
		const tmpID = (tmpRecordID === undefined || tmpRecordID === null || tmpRecordID === '') ? pOption.Value : tmpRecordID;
		const tmpLabel = libEntityDisplayName.unnamedEntityLabel(pEntity, tmpID, pFieldLabel);
		if (tmpLabel === '')
		{
			return pOption;
		}
		return Object.assign({}, pOption, { Text: tmpLabel });
	}

	/**
	 * Source a picker from a managed code-list vocabulary (`_VocabularySelectorMap` — SampleStatus and
	 * friends). The referencing record persists the vocabulary's CODE, and the table is small enough to
	 * read whole, so this wires a local-filtering DataProvider over the loaded rows rather than the
	 * remote-search entity path. Both the descriptor's own `SelectOptionsEntity` and a
	 * vocabulary-mapped InputType route here; a customer with no rows (or a failed read) falls back to
	 * the static `PictForm.SelectOptions` the map installs, matching the legacy Select-family provider.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {boolean} - True when this picker is vocabulary-backed and the source was installed.
	 */
	_applyVocabularySource(pConfig, pInput)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (!tmpPictForm.SelectOptionsEntity)
		{
			return false;
		}
		const tmpPageSize = tmpPictForm.PageSize || 100;
		const fLoad = () => libEntityOptionSource.resolveOptionsAsync(this, pInput);
		pConfig.DataProvider = (pSearchTerm, pPage) =>
		{
			const tmpPage = pPage || 1;
			return fLoad().then((pOptions) =>
			{
				const tmpTerm = String(pSearchTerm || '').toLowerCase();
				const tmpMatches = tmpTerm ?
					pOptions.filter((pOption) => String(pOption.text || '').toLowerCase().includes(tmpTerm) || String(pOption.id || '').toLowerCase().includes(tmpTerm)) :
					pOptions;
				const tmpStart = (tmpPage - 1) * tmpPageSize;
				return {
					results: tmpMatches.slice(tmpStart, tmpStart + tmpPageSize).map((pOption) => ({ Value: pOption.id, Text: pOption.text })),
					hasMore: (tmpStart + tmpPageSize) < tmpMatches.length,
				};
			});
		};
		// A code retired from the managed list still has to render on an existing record, so an
		// unresolved value labels as its own code rather than blank.
		pConfig.ResolveValue = (pValue) => fLoad().then((pOptions) =>
		{
			const tmpMatch = pOptions.find((pOption) => pOption.id === pValue);
			return tmpMatch ?
				{ Value: tmpMatch.id, Text: tmpMatch.text } :
				{ Value: pValue, Text: (pValue === null || pValue === undefined) ? '' : String(pValue) };
		});
		return true;
	}

	/**
	 * Source a non-entity picker's options from the legacy Select descriptor vocabulary, so a
	 * Select / Option / Select2 / Select2Multiple field becomes InputType 'Picker' with no data edits.
	 * Mirrors PictProvider-InputType-Select: a static `PictForm.SelectOptions` array, a precomputed
	 * `SelectOptionsPickList` (DynamicMetaLists.getList), or a Dynamic picklist (paged + filtered via a
	 * DataProvider, exactly as the select2 dynamicLocalPaginationAdapter did). The Select provider's
	 * `{ id, text }` option shape is mapped to the picker's `{ Value, Text }`.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {void}
	 */
	_applyGenericSelectSource(pConfig, pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpToOption = (pItem) => ({ Value: pItem.id, Text: pItem.text });
		if (this._applyVocabularySource(pConfig, pInput))
		{
			return;
		}
		const tmpPickList = tmpPictForm.SelectOptionsPickList;
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if (tmpPickList && tmpMetaLists)
		{
			const fPickListDataProvider = this._createDynamicPickListDataProvider(pInput);
			if (fPickListDataProvider)
			{
				pConfig.DataProvider = fPickListDataProvider;
				return;
			}
			// Precomputed picklist: resolve the full list into static Options. The config is rebuilt on every
			// marshal-driven re-mount, so a Facet rule narrows it by the rest of the row after each solve.
			if (typeof tmpMetaLists.hasList === 'function' && tmpMetaLists.hasList(tmpPickList))
			{
				pConfig.Options = this._applyFacetRules(pInput, tmpMetaLists.getList(tmpPickList) || []).map(tmpToOption);
				return;
			}
		}
		// Static inline options.
		if (Array.isArray(tmpPictForm.SelectOptions))
		{
			pConfig.Options = tmpPictForm.SelectOptions.map(tmpToOption);
		}
	}

	/**
	 * A DataProvider over the input's Dynamic `SelectOptionsPickList`: page + filter through getList on every search
	 * (startIndex / maxResults / filterString / searchFields), matching the old select2 dynamicLocalPaginationAdapter.
	 * The list's `{ id, text }` rows map to the picker's `{ Value, Text }`.
	 *
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {((pSearchTerm: string, pPage: number) => Promise<Record<string, any>>)|null} null when the input names no Dynamic picklist.
	 */
	_createDynamicPickListDataProvider(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpPickList = tmpPictForm.SelectOptionsPickList;
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if (!tmpPickList || !tmpMetaLists || !tmpMetaLists.listDefinitions || !tmpMetaLists.listDefinitions[tmpPickList] || !tmpMetaLists.listDefinitions[tmpPickList].Dynamic)
		{
			return null;
		}
		const tmpPageSize = tmpPictForm.PageSize || 100;
		const tmpSearchFields = String(tmpPictForm.DistillingDisplay || '').split(',').map((pField) => pField.trim()).filter((pField) => pField !== '');
		return (pSearchTerm, pPage) =>
		{
			const tmpPage = pPage || 1;
			const tmpRows = tmpMetaLists.getList(tmpPickList,
				{
					startIndex: (tmpPage - 1) * tmpPageSize,
					maxResults: tmpPageSize,
					filterString: String(pSearchTerm || '').toLowerCase(),
					searchFields: tmpSearchFields,
				}) || [];
			return Promise.resolve({ results: tmpRows.map((pItem) => ({ Value: pItem.id, Text: pItem.text })), hasMore: tmpRows.length >= tmpPageSize });
		};
	}

	/**
	 * Narrow a picklist by the input's pict-section-form Facet ListFilterRules (sibling values in the same
	 * tabular row, or the same view outside a table). Inputs without a Facet rule are returned unchanged:
	 * the picker has never applied ListFilterRules, so other rule types stay dormant rather than changing
	 * existing forms.
	 *
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @param {Array<{ id: string, text: string }>} pList - the picklist entries.
	 * @return {Array<{ id: string, text: string }>}
	 */
	_applyFacetRules(pInput, pList)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpContext = this._activeTabularContext;
		if (!tmpDistilling || (typeof tmpDistilling.getFacetRule !== 'function') || !tmpDistilling.getFacetRule(pInput) || !tmpContext || !tmpContext.pView)
		{
			return pList;
		}
		return tmpDistilling.filterList(tmpContext.pView, pInput, pList, (tmpContext.pRowIndex == null) ? undefined : tmpContext.pRowIndex);
	}

	/**
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {Record<string, any>|null} the input's pict-section-form Facet rule, if it has one.
	 */
	_getFacetRule(pInput)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		if (!tmpDistilling || (typeof tmpDistilling.getFacetRule !== 'function'))
		{
			return null;
		}
		return tmpDistilling.getFacetRule(pInput);
	}

	/**
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {boolean} whether the input has a Facet rule and the Pict-Input-FacetFilter provider, which clears its
	 * value when a sibling change leaves it invalid (unless the rule sets ClearInvalid false).
	 */
	_isClearedByFacetFilter(pInput)
	{
		const tmpRule = this._getFacetRule(pInput);
		const tmpProviders = (pInput && pInput.PictForm && Array.isArray(pInput.PictForm.Providers)) ? pInput.PictForm.Providers : [];
		return !!tmpRule && (tmpRule.ClearInvalid !== false) && tmpProviders.includes('Pict-Input-FacetFilter');
	}

	/**
	 * On a Facet input that allows custom values and reads a global join list (JoinListAddressGlobal),
	 * "Create <term>" first adds a provisional record to that join list (see _addProvisionalFacetRecord), so
	 * FacetFilter treats the new value as consistent with its siblings when it commits. When no record can be
	 * added the cleaned, re-cased term commits as a plain custom value. A join list in form data is never
	 * written, since the form data is saved with the document.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {void}
	 */
	_applyFacetCreate(pConfig, pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpContext = this._activeTabularContext;
		if (!tmpPictForm.AllowCustomValues || pConfig.Entity || pConfig.DataProvider || (typeof pConfig.OnCreate !== 'function'))
		{
			return;
		}
		const tmpRule = this._getFacetRule(pInput);
		if (!tmpRule || !tmpRule.JoinListAddressGlobal || !tmpContext || !tmpContext.pView)
		{
			return;
		}
		const tmpView = tmpContext.pView;
		const tmpRowIndex = (tmpContext.pRowIndex == null) ? undefined : tmpContext.pRowIndex;
		const fCreate = pConfig.OnCreate;
		pConfig.OnCreate = (pTerm) =>
		{
			const tmpValue = this._addProvisionalFacetRecord(tmpView, pInput, tmpRowIndex, pTerm);
			return fCreate((tmpValue === null) ? pTerm : tmpValue);
		};
	}

	/**
	 * Add a provisional record for a value typed into a Facet input: the constraining siblings' values (the
	 * preceding ones under NarrowBy Preceding, every other one otherwise; '' when empty), the rule's static
	 * Facets values (a literal Value compared with EQ), the term at the input's own JoinListValueAddress, and
	 * `Provisional: true`. A sibling value the join list does not hold is written as it stands, so FacetFilter
	 * keeps it. The term is trimmed, its whitespace collapsed, and re-cased to a spelling the join list already
	 * holds at that address, whether or not a record is added. The pick lists built from the join list are then
	 * rebuilt. Nothing is added when a record already agrees with the non-empty values, or when the rule reads no
	 * global join list.
	 *
	 * @param {Object} pView - the view the input is in.
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @param {number|string|undefined} pRowIndex - the tabular row, undefined outside a table.
	 * @param {any} pTerm - the typed term.
	 * @return {string|null} the value to commit, or null when the input reads no global join list.
	 */
	_addProvisionalFacetRecord(pView, pInput, pRowIndex, pTerm)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpRule = this._getFacetRule(pInput);
		const fClean = (pValue) => String(pValue ?? '').trim().replace(/\s+/g, ' ');
		const tmpTerm = fClean(pTerm);
		if (!tmpRule || !tmpRule.JoinListValueAddress || (tmpTerm === ''))
		{
			return null;
		}
		const tmpJoinList = this._getWritableFacetJoinList(pView, tmpRule, false);
		if (!tmpJoinList)
		{
			return null;
		}
		const tmpManifest = this.pict.manifest;
		const fValueAt = (pRecord, pAddress) => tmpManifest.getValueAtAddress(pRecord, pAddress);
		const tmpLowerTerm = tmpTerm.toLowerCase();
		const tmpSameSpelling = tmpJoinList.find((pRecord) =>
		{
			const tmpExisting = fValueAt(pRecord, tmpRule.JoinListValueAddress);
			return !tmpDistilling.isEmptyFacetValue(tmpExisting) && (fClean(tmpExisting).toLowerCase() === tmpLowerTerm);
		});
		const tmpValue = tmpSameSpelling ? String(fValueAt(tmpSameSpelling, tmpRule.JoinListValueAddress)) : tmpTerm;
		const tmpSiblings = tmpDistilling.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpOwnIndex = tmpSiblings.findIndex((pSibling) => pSibling.Input === pInput);
		// Same constraining-sibling rule as ListDistilling.getFacetMatchingRecords.
		const tmpPrecedingOnly = (tmpRule.NarrowBy === 'Preceding') && (tmpOwnIndex >= 0);
		const tmpParents = tmpSiblings.filter((pSibling, pIndex) => (pSibling.Input !== pInput) && !(tmpPrecedingOnly && (pIndex > tmpOwnIndex)));
		const tmpStaticParts = this._getStaticFacetParts(tmpRule);
		const tmpParentParts = tmpParents.map((pParent) => ({ Address: pParent.Rule.JoinListValueAddress, Value: tmpDistilling.isEmptyFacetValue(pParent.Value) ? '' : pParent.Value }));
		const tmpOwnPart = { Address: tmpRule.JoinListValueAddress, Value: tmpValue };
		const tmpConstraints = tmpStaticParts.concat(tmpParentParts.filter((pPart) => pPart.Value !== ''), [ tmpOwnPart ]);
		const tmpCovered = tmpJoinList.some((pRecord) => tmpConstraints.every((pPart) =>
		{
			const tmpExisting = fValueAt(pRecord, pPart.Address);
			return String(tmpDistilling.isEmptyFacetValue(tmpExisting) ? '' : tmpExisting) === String(pPart.Value);
		}));
		if (tmpCovered)
		{
			return tmpValue;
		}
		const tmpTarget = this._getWritableFacetJoinList(pView, tmpRule, true);
		if (!tmpTarget)
		{
			return tmpValue;
		}
		const tmpRecord = {};
		tmpStaticParts.concat(tmpParentParts, [ tmpOwnPart ]).forEach((pPart) => tmpManifest.setValueAtAddress(tmpRecord, pPart.Address, pPart.Value));
		tmpRecord.Provisional = true;
		tmpTarget.push(tmpRecord);
		this._rebuildPickListsFromSource(tmpRule.JoinListAddress);
		return tmpValue;
	}

	/**
	 * A Facet rule's static constraints: Facets entries with a literal Value (no ValueAddress) compared with EQ.
	 * @param {Record<string, any>} pRule - the input's Facet rule.
	 * @return {Array<{ Address: string, Value: any }>}
	 */
	_getStaticFacetParts(pRule)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpFacets = Array.isArray(pRule.Facets) ? pRule.Facets : [];
		// Same EQ test as ListDistilling.compareFacetValue.
		return tmpFacets
			.filter((pFacet) => pFacet && pFacet.JoinListValueAddress && !('ValueAddress' in pFacet) && !tmpDistilling.isEmptyFacetValue(pFacet.Value) && (!pFacet.Operator || (pFacet.Operator === 'EQ')))
			.map((pFacet) => ({ Address: pFacet.JoinListValueAddress, Value: pFacet.Value }));
	}

	/**
	 * The array a global Facet rule (JoinListAddressGlobal) reads its join list from, for adding records to.
	 * One that is not set yet reads as a new empty array; with pCreate it is first created as an empty array in
	 * application state (AppData, Pict, Bundle), so application state changes only when a record is added.
	 * Null for a join list in form data, or when the rule would not see a record pushed onto the returned array
	 * (a keyed object, or an address that cannot be created).
	 *
	 * @param {Object} pView - the view the input is in.
	 * @param {Record<string, any>} pRule - the input's Facet rule.
	 * @param {boolean} pCreate - whether to create a join list that is not set yet.
	 * @return {Array<any>|null}
	 */
	_getWritableFacetJoinList(pView, pRule, pCreate)
	{
		if (!pRule.JoinListAddressGlobal)
		{
			return null;
		}
		const tmpManifest = this.pict.manifest;
		const tmpApplicationState = { Fable: this.pict, Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle };
		const tmpCurrent = tmpManifest.getValueAtAddress(tmpApplicationState, pRule.JoinListAddress);
		if ((tmpCurrent === undefined) || (tmpCurrent === null))
		{
			if (!pCreate)
			{
				return [];
			}
			tmpManifest.setValueAtAddress(tmpApplicationState, pRule.JoinListAddress, []);
		}
		// The same address space ListDistilling.getFacetJoinList reads a global join list from.
		const tmpRead = tmpManifest.getValueAtAddress(Object.assign({ View: pView }, tmpApplicationState), pRule.JoinListAddress);
		return Array.isArray(tmpRead) ? tmpRead : null;
	}

	/**
	 * Rebuild every DynamicMetaLists pick list whose source is the given application-state address.
	 * @param {string} pSourceAddress - a ListSourceAddress read with ListSourceAddressGlobal.
	 * @return {void}
	 */
	_rebuildPickListsFromSource(pSourceAddress)
	{
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if (!tmpMetaLists || !tmpMetaLists.listDefinitions || (typeof tmpMetaLists.rebuildListByHash !== 'function'))
		{
			return;
		}
		for (const tmpHash of Object.keys(tmpMetaLists.listDefinitions))
		{
			const tmpDefinition = tmpMetaLists.listDefinitions[tmpHash];
			if (tmpDefinition && tmpDefinition.ListSourceAddressGlobal && (tmpDefinition.ListSourceAddress === pSourceAddress))
			{
				tmpMetaLists.rebuildListByHash(tmpHash);
			}
		}
	}

	/**
	 * Keep an AllowCustomValues field's own custom values in its dropdown, as legacy select2 did (PD-4487): a
	 * bound value missing from the source list, or one created through OnCreate, stays offered after it is
	 * cleared. Legacy injected an `<option>` that lived until the list was rebuilt or the form re-rendered, so
	 * the memory resets when the source list changes (a City list after a new State) and on re-initialize.
	 * A filled list replaced by a different one (another list, or none: a new State with no Cities yet) is such a
	 * rebuild: select2 lost the bound value with its options there, so a bound value the new list lacks is not
	 * carried over but cleared once the mount is done. An empty list filling in is a first load, not a rebuild.
	 * A Facet input the FacetFilter provider clears never takes that clear (FacetFilter owns clearing there):
	 * its list changes with every sibling choice, so each new list is treated as a first load.
	 * Static Options only; entity and dynamic-picklist pickers never allowed creation here.
	 *
	 * @param {Record<string, any>} pConfig - the picker config being built (mutated in place).
	 * @param {Record<string, any>} pInput - the form input descriptor.
	 * @return {void}
	 */
	_applyCustomValueMemory(pConfig, pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (!tmpPictForm.AllowCustomValues || pConfig.Entity || pConfig.DataProvider || !Array.isArray(pConfig.Options))
		{
			return;
		}
		const tmpContext = this._activeTabularContext;
		const tmpKey = this._getCustomValueMemoryKey(pInput, tmpContext ? tmpContext.pRowIndex : null);
		if (!tmpKey)
		{
			return;
		}
		const tmpSourceValues = pConfig.Options.map((pOption) => String(pOption.Value));
		const tmpSignature = tmpSourceValues.join('\u0000');
		if (!this._customValueMemory)
		{
			/** @type {Record<string, { Signature: string, SourceValues: Set<string>, Values: Array<string> }>} */
			this._customValueMemory = {};
		}
		const tmpEntry = this._customValueMemory[tmpKey];
		const tmpRebuilt = !!tmpEntry && (tmpEntry.Signature !== tmpSignature) && (tmpEntry.SourceValues.size > 0) && !this._isClearedByFacetFilter(pInput);
		if (!tmpEntry || tmpEntry.Signature !== tmpSignature)
		{
			this._customValueMemory[tmpKey] = { Signature: tmpSignature, SourceValues: new Set(tmpSourceValues), Values: [] };
		}
		if (tmpContext)
		{
			const tmpCandidates = this._getCustomValueCandidates(pInput, tmpContext.pValue);
			if (tmpRebuilt)
			{
				const tmpKept = tmpCandidates.filter((pValue) => this._customValueMemory[tmpKey].SourceValues.has(pValue));
				if (tmpKept.length < tmpCandidates.length)
				{
					this._queueCustomValueClear(tmpContext.pView, pInput, tmpContext.pRowIndex, tmpKept);
				}
			}
			else
			{
				tmpCandidates.forEach((pValue) => this._rememberCustomValue(tmpKey, pValue));
			}
		}
		const fCreate = pConfig.OnCreate;
		if (typeof fCreate === 'function')
		{
			pConfig.OnCreate = (pTerm) =>
			{
				const tmpRecord = fCreate(pTerm);
				if (tmpRecord && tmpRecord.Value !== undefined && tmpRecord.Value !== null)
				{
					this._rememberCustomValue(tmpKey, String(tmpRecord.Value));
				}
				return tmpRecord;
			};
		}
		const tmpRemembered = this._customValueMemory[tmpKey].Values;
		if (tmpRemembered.length > 0)
		{
			pConfig.Options = tmpRemembered.slice().reverse().map((pValue) => ({ Value: pValue, Text: pValue })).concat(pConfig.Options);
		}
	}

	/**
	 * The custom-value memory slot for a field: its Hash, plus the row for a tabular field (legacy kept one
	 * `<select>` per row, and Facet rules can give each row its own list).
	 * @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] @return {string|null}
	 */
	_getCustomValueMemoryKey(pInput, pRowIndex)
	{
		if (!pInput || !pInput.Hash)
		{
			return null;
		}
		return (pRowIndex == null) ? pInput.Hash : `${pInput.Hash}#${pRowIndex}`;
	}

	/**
	 * The bound values worth remembering: each csv part of a multi picker, the whole value of a single one (a
	 * single value may itself contain a comma), and never a blank or an unset sentinel.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {Array<string>}
	 */
	_getCustomValueCandidates(pInput, pValue)
	{
		if (this._isMultiplePicker(pInput.PictForm || {}))
		{
			return this._splitPickerValues(pValue, pInput);
		}
		if (pValue === undefined || pValue === null || typeof pValue === 'object')
		{
			return [];
		}
		const tmpValue = String(pValue);
		if (tmpValue.trim() === '' || libPickerEmptyValues.isEmptyValue(pInput, tmpValue))
		{
			return [];
		}
		return [ tmpValue ];
	}

	/**
	 * Commit what a rebuilt list still offers of a field's bound value (a multi keeps its surviving parts; a
	 * single falls back to its Default, as the DistilledInput handler does). Queued, because the rebuild runs
	 * inside the sibling's change pass, and committing there would nest a second provider pass.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex @param {Array<string>} pKept
	 */
	_queueCustomValueClear(pView, pInput, pRowIndex, pKept)
	{
		const tmpValue = this._isMultiplePicker(pInput.PictForm || {}) ? pKept.join(',') : (pInput.Default ?? '');
		queueMicrotask(() => this._setValueAndCommit(pView, pInput, tmpValue, pRowIndex));
	}

	/** Remember one custom value in a memory slot, unless the slot's source list already offers it. @param {string} pKey @param {string} pValue */
	_rememberCustomValue(pKey, pValue)
	{
		const tmpEntry = this._customValueMemory && this._customValueMemory[pKey];
		if (!tmpEntry || tmpEntry.SourceValues.has(pValue) || tmpEntry.Values.includes(pValue))
		{
			return;
		}
		tmpEntry.Values.push(pValue);
	}

	/** Drop a field's remembered custom values: a re-initialized input starts from its source list, as a re-rendered select2 did.
	 *  @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex] */
	_forgetCustomValues(pInput, pRowIndex)
	{
		const tmpKey = this._getCustomValueMemoryKey(pInput, pRowIndex);
		if (tmpKey && this._customValueMemory)
		{
			delete this._customValueMemory[tmpKey];
		}
	}

	/** Register the User list-entry display fall-back templates (name parts; login when email is empty). Idempotent. */
	_registerUserListEntryTemplates()
	{
		if (this._userListEntryTemplatesRegistered) { return; }
		this._userListEntryTemplatesRegistered = true;
		this.pict.TemplateProvider.addTemplate('HL-EntityListEntry-User-NameParts', '{~D:Record.NameFirst~} {~D:Record.NameLast~}');
		this.pict.TemplateProvider.addTemplate('HL-EntityListEntry-User-Login', '{~D:Record.LoginID~}');
	}

	/**
	 * The entity this picker targets: the descriptor's own Entity, else the entity the specialized
	 * selector's provider hardcodes (R2 port-forward — see _SPECIALIZED_SELECTOR_MAP), else the entity
	 * this provider was configured with. Every place that scopes by entity (contextual filters, sample
	 * spec-year priming) resolves through here so a migrated specialized selector scopes exactly as its
	 * descriptor-carried generic cousin would.
	 *
	 * The provider-option leg mirrors `MaterialsEntitySelector._getEntity` and is what serves an
	 * InputType the map does not name — the `MaterialsHidden*` family, which carries no descriptor
	 * `Entity` and which `MaterialsCascadePicker.onInputInitialize` branches on by name.
	 *
	 * @param {Record<string, any>} pPictForm @return {string|undefined}
	 */
	_resolveEntity(pPictForm)
	{
		libStaticSelectEntity.dropStaticSelectEntity(pPictForm);
		if (pPictForm && pPictForm.Entity)
		{
			return pPictForm.Entity;
		}
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[pPictForm && pPictForm.InputType];
		if (tmpSpecialized && tmpSpecialized.Entity)
		{
			return tmpSpecialized.Entity;
		}
		return (this.options && this.options.Entity) || undefined;
	}

	/**
	 * Headlight contextual scoping, ported in spirit from
	 * PictProvider-InputType-EntitySelectorMultiple.localHandleSearchFilters: extra FoxHound stanzas
	 * AND-applied to the entity search. The picker module calls this on every search via its BaseFilter
	 * hook; the module stays host-agnostic, the host knows about projects + spec years.
	 *
	 * Row context (pRowIndex, pView) enables per-row `FromRowField` / `LabScope` and per-row `__ShowAll`
	 * for tabular pickers — captured into the per-row BaseFilter closure by the tabular mount override
	 * (plan §5.3). A non-tabular picker passes neither (treated as null).
	 *
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex] @param {Object} [pView]
	 * @return {{Filters: Array<string>, BackOffFilters: Array<string>}} The pict-section-picker 1.9.0
	 *   BaseFilter split: mandatory clauses + the preferred (auto-widen-on-empty) back-off clauses.
	 */
	getContextualSearchFilters(pInput, pRowIndex, pView)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpEntity = this._resolveEntity(tmpPictForm);
		const tmpFilters = [];
		const tmpBackoff = [];
		const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
		const tmpView = pView || null;
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		// The engine reads StaticFilters / ShowAllToggle off the descriptor, so hand it the config-map defaults too.
		const tmpFilterInput = this._withMapFilterDefaults(pInput);
		// Show-All override, read once (per-row when tabular). Drops the back-off list + the non-mandatory
		// scope clauses (the spec-set floor unless SpecYearMandatory, and the engine's SamplePlan/Through/Lab scopes).
		const tmpOverridden = !!(tmpEngine && tmpEngine.isFilterOverridden(tmpFilterInput, tmpRowIndex));

		// Project scoping for project-resident entities. Off-switches: PictForm.disableProjectFilteringForEntity,
		// or the config map's DisableProjectFiltering (a specialized selector whose legacy provider never scoped).
		const tmpProjectEntityList = [ 'LineItem', 'BidItem' ];
		const tmpScopingDisabled = tmpPictForm.disableProjectFilteringForEntity || _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.DisableProjectFiltering;
		if (!tmpScopingDisabled && tmpProjectEntityList.includes(tmpEntity))
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID) { tmpFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`); }
		}

		// Customer state scoping (legacy BridgeSelector): only the customer's configured state(s).
		if (_SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.CustomerStateFilter)
		{
			const tmpStateClause = this._getCustomerStateClause();
			if (tmpStateClause) { tmpFilters.push(tmpStateClause); }
		}

		// Spec-set floor — ported faithfully from MES.localHandleSearchFilters. Gated by Show-All UNLESS
		// PictForm.SpecYearMandatory; routed to the back-off list when PictForm.SpecYearBackOff. The
		// resolver getter returns null on the fail-open paths (no contract FK / empty set / no join
		// rows) — leave unfiltered then.
		if (!tmpPictForm.DisableSpecYearSiloing && this.pict.providers.SpecScopeResolver)
		{
			const tmpAxis = _SPEC_SET_AXIS[tmpEntity];
			// Lab is the only axis here, and its floor must be read family-expanded: spec-set membership is
			// declared per FAMILY, so raw IDLab membership empties one level or the other (see
			// _LabRouting.resolveSpecSetLabFloor).
			const tmpAllowed = tmpAxis ? libLabRouting.resolveSpecSetLabFloor(this.pict) : null;
			if (tmpAllowed && tmpAllowed.size > 0 && (tmpPictForm.SpecYearMandatory || !tmpOverridden))
			{
				(tmpPictForm.SpecYearBackOff ? tmpBackoff : tmpFilters).push(`FBL~${tmpAxis.field}~INN~${Array.from(tmpAllowed).join(',')}`);
			}
		}

		// Descriptor-level Static/Dynamic scope filters via the extracted engine (StaticFilters, DynamicFilters
		// FromField / per-row FromRowField / SamplePlan / Through / Lab). The engine appends mandatory clauses
		// to tmpFilters and `BackOff: true` clauses to tmpBackoff. Row context threads per-row FromRowField /
		// LabScope (plan §5.3).
		if (tmpEngine)
		{
			tmpEngine.applyStaticFilters(tmpFilters, tmpFilterInput, tmpBackoff);
			tmpEngine.applyDynamicFilters(tmpFilters, tmpFilterInput, tmpRowIndex, tmpView, tmpBackoff);
		}

		// Fold in any descriptor-level scope hook (e.g. the recordset entity filter base's GetContextScopeFilter).
		const tmpBase = super.getContextualSearchFilters(pInput);
		if (tmpBase) { tmpFilters.push(Array.isArray(tmpBase) ? tmpBase.filter(Boolean).join('~') : tmpBase); }

		// The `{ Filters, BackOffFilters }` split is pict-section-picker 1.9.0's BaseFilter contract: both
		// sets apply together, and an EMPTY first page auto-retries once WITHOUT the back-off set — the
		// legacy getOptionsAjax auto-widen (§5.6), restored. Show-All drops the back-off set entirely
		// (legacy parity); the mandatory set survives.
		return {
			Filters: tmpFilters.filter(Boolean),
			BackOffFilters: tmpOverridden ? [] : tmpBackoff.filter(Boolean),
		};
	}

	/**
	 * The descriptor with its config-map filter defaults (StaticFilters, ShowAllToggle) filled in where it sets
	 * none: MaterialSelector's top-level-only filter and its toggle. A copy, and Picker-path only; the legacy
	 * Select2Util shares the filter engine and must not see the defaults before its type flips.
	 * @param {Record<string, any>} pInput @return {Record<string, any>}
	 */
	_withMapFilterDefaults(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType];
		if (!tmpSpecialized) { return pInput; }
		const tmpDefaults = {};
		if (tmpPictForm.StaticFilters === undefined && tmpSpecialized.StaticFilters) { tmpDefaults.StaticFilters = tmpSpecialized.StaticFilters; }
		if (tmpPictForm.ShowAllToggle === undefined && tmpSpecialized.ShowAllToggle !== undefined) { tmpDefaults.ShowAllToggle = tmpSpecialized.ShowAllToggle; }
		if (Object.keys(tmpDefaults).length < 1) { return pInput; }
		return Object.assign({}, pInput, { PictForm: Object.assign({}, tmpPictForm, tmpDefaults) });
	}

	/**
	 * Word the marker on a row found by its ID (pict-section-picker 1.9.9 `IDMatchLabel`) the way a record with
	 * no name is labelled, so a Producer field reads `Producer #3456`, not `Organization #3456`. Entity and
	 * FieldLabel are read from the config when the marker is drawn.
	 *
	 * @param {Record<string, any>} pConfig - The picker config being built; left alone if it sets its own IDMatchLabel.
	 */
	_applyIDMatchLabel(pConfig)
	{
		if (pConfig.IDMatchLabel !== undefined)
		{
			return;
		}
		pConfig.IDMatchLabel = (pRecord, pID) => libEntityDisplayName.unnamedEntityLabel(pConfig.Entity, pID, pConfig.FieldLabel);
	}

	/**
	 * Give the picker an EmptyLabel function (pict-section-picker 1.9.8) that explains an empty list its own
	 * scope narrowed. It reads the config's BaseFilter when the list renders empty, so a BaseFilter a subclass
	 * sets after this call, or a scope that changed since the last search, is the one checked.
	 *
	 * @param {Record<string, any>} pConfig - The picker config being built; left alone if it sets its own EmptyLabel.
	 * @param {Record<string, any>} pInput - The descriptor.
	 * @param {{pRowIndex?: number, pView?: Object}|null} pTabularContext - The row being mounted, for a tabular picker.
	 */
	_applyEmptyListLabel(pConfig, pInput, pTabularContext)
	{
		if (pConfig.EmptyLabel !== undefined)
		{
			return;
		}
		const tmpRowIndex = (pTabularContext && pTabularContext.pRowIndex != null) ? pTabularContext.pRowIndex : null;
		pConfig.EmptyLabel = () => this.getEmptyListLabel(pInput, pConfig, tmpRowIndex);
	}

	/**
	 * The empty-list wording the Select2 dropdowns used (PictProvider-Select2Util noResults), for an entity picker
	 * whose BaseFilter currently narrows the search: the field's FilteredNoResultsMessage, else a "Show all" hint
	 * while the field offers an override that is off, else "No matches with the current filter.". Blank (the
	 * module's own "No matches") when nothing narrowed it, and for pick-list, custom-provider and local pickers.
	 *
	 * @param {Record<string, any>} pInput - The descriptor.
	 * @param {Record<string, any>} pConfig - The picker config (Entity, BaseFilter, DataProvider, PickListDataProvider).
	 * @param {number|null} [pRowIndex] - The row of a tabular picker, for its own Show all state.
	 * @return {string}
	 */
	getEmptyListLabel(pInput, pConfig, pRowIndex)
	{
		if (!pConfig || !pConfig.Entity || pConfig.DataProvider || pConfig.PickListDataProvider)
		{
			return '';
		}
		let tmpScope = pConfig.BaseFilter;
		if (typeof tmpScope === 'function')
		{
			try
			{
				tmpScope = tmpScope();
			}
			catch (pError)
			{
				return '';
			}
		}
		if (!this._scopeNarrows(tmpScope))
		{
			return '';
		}
		const tmpFilterInput = this._withMapFilterDefaults(pInput);
		const tmpPictForm = (tmpFilterInput && tmpFilterInput.PictForm) || {};
		if (tmpPictForm.FilteredNoResultsMessage)
		{
			return tmpPictForm.FilteredNoResultsMessage;
		}
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		const tmpOffersShowAll = !!(tmpPictForm.ShowAllToggle || tmpPictForm.OverrideField);
		const tmpRowIndex = (pRowIndex === undefined) ? null : pRowIndex;
		if (tmpOffersShowAll && !(tmpEngine && tmpEngine.isFilterOverridden(tmpFilterInput, tmpRowIndex)))
		{
			return 'No matches with the current filter — turn on "Show all" to see everything.';
		}
		return 'No matches with the current filter.';
	}

	/**
	 * Whether a resolved BaseFilter value (a stanza string, an array of them, or the `{ Filters, BackOffFilters }`
	 * split) holds at least one clause.
	 * @param {any} pScope @return {boolean}
	 */
	_scopeNarrows(pScope)
	{
		const fHasClause = (pPart) => Array.isArray(pPart) ? pPart.some(Boolean) : !!pPart;
		if (pScope && typeof pScope === 'object' && !Array.isArray(pScope))
		{
			return fHasClause(pScope.Filters) || fHasClause(pScope.BackOffFilters);
		}
		return fHasClause(pScope);
	}

	/**
	 * The customer's state clause for a state-scoped selector (legacy BridgeSelector), from ConfigurationProvider's
	 * `StateAbbreviation`: one state (`FBV~State~EQ`), several (`FBL~State~INN`), or none (unscoped). Cached per
	 * customer, because the lookup logs on every call and this runs on every search.
	 * @return {string|null}
	 */
	_getCustomerStateClause()
	{
		const tmpCustomerID = this.pict.AppData?.CurrentUser?.CustomerID;
		const tmpProvider = this.pict.providers.ConfigurationProvider;
		if (!tmpCustomerID || !tmpProvider || typeof tmpProvider.getConfigurationByScope !== 'function') { return null; }
		this._customerStateClauses = this._customerStateClauses || {};
		if (!(tmpCustomerID in this._customerStateClauses))
		{
			const tmpConfig = tmpProvider.getConfigurationByScope(tmpCustomerID);
			const tmpState = (tmpConfig && !(tmpConfig instanceof Error)) ? tmpConfig.StateAbbreviation : null;
			let tmpClause = null;
			if (Array.isArray(tmpState) && tmpState.length > 0) { tmpClause = `FBL~State~INN~${tmpState.map((pState) => encodeURIComponent(pState)).join(',')}`; }
			else if (tmpState && !Array.isArray(tmpState)) { tmpClause = `FBV~State~EQ~${encodeURIComponent(tmpState)}`; }
			this._customerStateClauses[tmpCustomerID] = tmpClause;
		}
		return this._customerStateClauses[tmpCustomerID];
	}

	// --- Show-All filter override (beast MVP, §8.7) — the user's escape hatch from an over-narrow filter ---

	/** The integrated "Show All" toggle element id for this picker. Broker-namespaced so it never collides
	 *  with a legacy MES toggle during coexistence. @param {string} pInputHTMLID @param {number|string} [pRowIndex] */
	getSelectFilterToggleID(pInputHTMLID, pRowIndex)
	{
		return `#PICKER-FILTER-TOGGLE-${pInputHTMLID}${(pRowIndex != null) ? `-${pRowIndex}` : ''}`;
	}

	/**
	 * Flip the "Show All" override for this picker. State persists at `<key>__ShowAll` (non-tabular) or
	 * `<key>__ShowAll_<rowIndex>` (tabular, per-row) — the same address `EntityFilterEngine.isFilterOverridden`
	 * reads in getContextualSearchFilters — so the NEXT search drops (or re-applies) the back-off + non-mandatory
	 * scope clauses. Ported from MES.toggleFilterOverride. No forced re-search is needed: PSP drops its loaded
	 * pages when the dropdown closes, and its backdrop swallows the click that closes it, so the toggle is only
	 * ever actuated while closed — the next open re-queries and re-resolves BaseFilter against the state written
	 * here. (Through PSP 1.9.0 this called a public reload() to punch through a cache that outlived the close.)
	 * @param {string} pInputHTMLID @param {string} pKey - DataAddress (non-tabular) or input Hash (tabular per-row)
	 * @param {number|string} [pRowIndex]
	 */
	toggleFilterOverride(pInputHTMLID, pKey, pRowIndex)
	{
		// A read-only / disabled picker paints the toggle inert (_FilterToggleUI) — swallow the click rather
		// than writing override state and re-composing filters for a field whose value cannot change.
		if (libFilterToggleUI.isToggleDisabled(this.pict, this.getSelectFilterToggleID(pInputHTMLID, pRowIndex))) { return; }
		const tmpSuffix = (pRowIndex != null) ? `__ShowAll_${pRowIndex}` : '__ShowAll';
		const tmpAddress = `AppData.DocumentData.ReportData.FormData.${pKey}${tmpSuffix}`;
		const tmpNewState = !this.pict.manifest.getValueByHash(this.pict, tmpAddress);
		this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpNewState);
		this._updateFilterToggleIcon(pInputHTMLID, tmpNewState, pRowIndex);
	}

	/** Repaint the toggle icon to reflect the current override state. Ported from MES._updateFilterToggleIcon.
	 *  @param {string} pInputHTMLID @param {boolean} pState @param {number|string} [pRowIndex] */
	_updateFilterToggleIcon(pInputHTMLID, pState, pRowIndex)
	{
		if (!this.pict?.ContentAssignment) { return; }
		const tmpIcon = pState ? 'fa-toggle-on' : 'fa-toggle-off';
		this.pict.ContentAssignment.assignContent(`${this.getSelectFilterToggleID(pInputHTMLID, pRowIndex)} > .icon`, `<i class="fas ${tmpIcon}"></i>`);
	}

	/**
	 * Three concerns on a committed selection:
	 *   1. Spec-year scope from the picked sample, ported from EntitySelectorMultiple.onDataChange: when a
	 *      Sample is selected, prime the SpecScopeResolver so the pickers it gates narrow.
	 *      Single-project resolver, so for a multi-select we take the first identifier (and warn).
	 *   2. Populate the field's `__Record` slot (see _refreshEntityRecord).
	 *   3. Re-sync the Required state and live validation (see _syncRequiredStateAfterCommit).
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._fireOnChangeCallbacks(pView, pInput, pValue, pHTMLSelector);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (this._resolveEntity(tmpPictForm) === 'Sample' && pValue && this.pict.providers.SpecScopeResolver)
		{
			const tmpIdentifiers = (typeof pValue === 'string' ? pValue.split(',') : (Array.isArray(pValue) ? pValue : []))
				.map((pVal) => String(pVal).trim()).filter((pVal) => pVal.length > 0);
			if (tmpIdentifiers.length > 1)
			{
				this.pict.log.warn(`Picker [${pInput?.Hash}]: multi-sample selection with spec-year scope active — using the first sample (${tmpIdentifiers[0]}) as the scope source. Picker has ${tmpIdentifiers.length} samples selected.`);
			}
			if (tmpIdentifiers.length > 0)
			{
				const tmpIdentityField = tmpPictForm.IdentityField || 'IDSample';
				this.pict.providers.SpecScopeResolver.loadForSampleByIdentifier?.(tmpIdentifiers[0], tmpIdentityField);
			}
		}
		this._publishSelectedProject(pInput, pValue);
		this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID);
		// The picker id helpers live on the (untyped-to-tsc) pict-section-picker base.
		const tmpSelf = /** @type {any} */ (this);
		this._syncRequiredStateAfterCommit(pInput, pInput.Macro.HTMLSelector, tmpSelf.getPickerHostID(pInput.Macro.RawHTMLID));
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of onDataChange's record refresh + Required re-sync — the record lands at the row's own address. */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._fireOnChangeCallbacks(pView, pInput, pValue, pHTMLSelector);
		this._refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex);
		const tmpSelf = /** @type {any} */ (this);
		this._syncRequiredStateAfterCommit(pInput, tmpSelf.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex), tmpSelf.getTabularPickerHostID(pInput.Macro.RawHTMLID, pRowIndex));
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/** Load-path twin of onDataChange's SelectedProject publish: legacy ProjectSelector set it on every marshal. */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._publishSelectedProject(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Legacy ProjectSelector parity: publish the chosen Project as `AppData.SelectedProject`, which LADOTD
	 * sample names read (SampleSequencing.buildSampleName → ExternalProjectID). Like legacy, an empty value
	 * leaves it as-is and tabular never publishes. The latest request wins if lookups settle out of order.
	 * @param {Record<string, any>} pInput @param {any} pValue
	 * @return {Promise<void>|void}
	 */
	_publishSelectedProject(pInput, pValue)
	{
		if (!pInput || !pInput.PictForm || pInput.PictForm.InputType !== 'ProjectSelector') { return; }
		const tmpProjectID = this._splitPickerValues(pValue, pInput)[0];
		if (!tmpProjectID || !this.pict.EntityProvider) { return; }
		const tmpRequest = this._selectedProjectRequest = {};
		return this._resolveEntityRecord('Project', tmpProjectID, pInput).then((pProject) =>
		{
			if (pProject && this._selectedProjectRequest === tmpRequest) { this.pict.AppData.SelectedProject = pProject; }
		});
	}

	// --- Entity __Record population ---

	/**
	 * The `__Record` address for this input/row, ported from MaterialsEntitySelector so a port-forwarded
	 * field's record lands at the SAME address its consumers already read. pSuffix supports the sibling
	 * slots the cascade family keeps next to the record (`__Salt`, `_DocumentPolyJoin` — legacy parity:
	 * an explicit PictForm.RecordAddress wins regardless of suffix).
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex] @param {string} [pSuffix] @return {string}
	 */
	_getRecordAddress(pInput, pRowIndex, pSuffix = '__Record')
	{
		if (pInput.PictForm?.RecordAddress) { return pInput.PictForm.RecordAddress; }
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + pSuffix;
		}
		return `${pInput.DataAddress || pInput.Hash}${pSuffix}`;
	}

	/**
	 * The committed picker value as a list of entity ids: multi commits csv (PSP's _commit joins the
	 * array), single commits the bare id, a cleared picker commits ''.
	 *
	 * An unset SENTINEL drops out alongside the blanks (pInput given): a pristine `DataType: Number`
	 * field marshals in as manyfest's DataType default 0, which the widget paints as its placeholder —
	 * so `__Record` must read as cleared too, not fetch the entity #0 that does not exist.
	 * @param {any} pValue @param {Record<string, any>} [pInput] @return {Array<string>}
	 */
	_splitPickerValues(pValue, pInput)
	{
		const tmpValues = Array.isArray(pValue) ? pValue : String(pValue ?? '').split(',');
		return tmpValues.map((pEntry) => String(pEntry).trim()).filter((pEntry) =>
			(pEntry.length > 0) && !(pInput && libPickerEmptyValues.isEmptyValue(pInput, pEntry)));
	}

	/** The widget's `EmptyValues` from the shared Headlight rule, so the control, `__Record` and Read/Print agree. */
	_resolveEmptyValues(pInput)
	{
		return libPickerEmptyValues.resolveEmptyValues(pInput);
	}

	/**
	 * The committed VALUE address for this input/row (not `__Record`): the slot the marshal binds the picker to.
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex] @return {string}
	 */
	_getPickerValueAddress(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.PictForm?.InformaryDataAddress || pInput.DataAddress || pInput.Hash;
	}

	/**
	 * Whether the committed value moved on while a record lookup was in flight. A value nobody has written
	 * yet is no evidence either way, so it never counts as stale.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null|undefined} pRowIndex
	 * @param {Array<string>} pRequestedValues - The split values the lookup was issued for.
	 * @return {boolean}
	 */
	_isStaleEntityRecordRefresh(pView, pInput, pRowIndex, pRequestedValues)
	{
		const tmpCurrentValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getPickerValueAddress(pInput, pRowIndex));
		if (tmpCurrentValue === undefined || tmpCurrentValue === null)
		{
			return false;
		}
		const tmpCurrent = new Set(this._splitPickerValues(tmpCurrentValue, pInput));
		const tmpRequested = new Set(pRequestedValues);
		if (tmpCurrent.size !== tmpRequested.size)
		{
			return true;
		}
		for (const tmpValue of tmpRequested)
		{
			if (!tmpCurrent.has(tmpValue))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * One entity record for a picker value, resolved through the SAME path PSP resolves the display label
	 * with (EntityProvider.getEntity, which reads its recordCache first). The picker's own dropdown load
	 * caches every option's full record, so a selection is normally a cache hit costing no round-trip; a
	 * genuine miss (a value outside the loaded set, or one past the cache's 30s TTL) fetches. Resolves
	 * null on failure — the caller keeps whatever record is already there (offline-tolerant, as the MES's
	 * backfill is).
	 *
	 * Identity-aware (beast B2): a creation-family field commits its GUID identity (e.g. `GUIDSample`),
	 * which EntityProvider.getEntity cannot look up (it fetches by numeric id) — those route through the
	 * legacy MES `_refreshRecord` fetch shape instead (`FBL~<identity>~INN~<value>`).
	 * @param {string} pEntity @param {string} pValue @param {Record<string, any>} [pInput]
	 * @return {Promise<Record<string, any>|null>}
	 */
	_resolveEntityRecord(pEntity, pValue, pInput)
	{
		const tmpIdentity = pInput ? this._getRecordIdentity(pInput) : `ID${pEntity}`;
		if (tmpIdentity !== `ID${pEntity}`)
		{
			return this._resolveEntityRecordByIdentity(pEntity, tmpIdentity, pValue);
		}
		return new Promise((resolve) =>
		{
			this.pict.EntityProvider.getEntity(pEntity, pValue, (pError, pRecord) =>
			{
				if (pError || !libSharedEntityRead.isEntityRecord(pEntity, pRecord))
				{
					this.pict.log.warn(`Picker [${pEntity}]: record lookup failed for [${pValue}]: ${pError?.message || pError || pRecord?.Error || 'no record returned'}`);
					return resolve(null);
				}
				return resolve(pRecord);
			});
		});
	}

	/**
	 * Fetch a record by a NON-simple identity field (the legacy MES `_refreshRecord` System-2 shape), through the
	 * shared read MES uses, so concurrent reads of one row share a request and an empty or placeholder identity
	 * is never read. Resolves null on failure/no-match — same keep-prior-record semantics as the getEntity path.
	 * @param {string} pEntity @param {string} pIdentityField @param {string} pValue
	 * @return {Promise<Record<string, any>|null>}
	 */
	_resolveEntityRecordByIdentity(pEntity, pIdentityField, pValue)
	{
		return new Promise((resolve) =>
		{
			if (libSharedEntityRead.isEmptyIdentityValue(pIdentityField, pValue))
			{
				return resolve(null);
			}
			if (!this.pict.HeadlightRestClient)
			{
				this.pict.log.warn(`Picker [${pEntity}]: no HeadlightRestClient — cannot resolve by [${pIdentityField}].`);
				return resolve(null);
			}
			libSharedEntityRead.readJSON(this.pict, `${pEntity}s/FilteredTo/FBL~${pIdentityField}~INN~${encodeURIComponent(pValue)}`, { ReuseResult: false }, (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords) || pRecords.length < 1)
				{
					this.pict.log.warn(`Picker [${pEntity}]: record lookup by ${pIdentityField} failed for [${pValue}]: ${pError?.message || pError || 'no records found'}`);
					return resolve(null);
				}
				if (pRecords.length > 1)
				{
					this.pict.log.warn(`Picker [${pEntity}]: multiple records with ${pIdentityField} = [${pValue}]; using the first.`);
				}
				return resolve(pRecords[0]);
			});
		});
	}

	/**
	 * Populate `<DataAddress>__Record` with the full entity record(s) behind the committed value — the
	 * write the legacy MaterialsEntitySelector did on selection and the port-forwarded picker dropped
	 * (PSP fetches a record to render the label but keeps only {Value, Text, Tag}). Without it every
	 * autofill-receiver PostSolver, compound display and PDF field reads an empty record.
	 *
	 * Timing: the lookup is async, so the write is fenced with a transaction async-op — registered
	 * SYNCHRONOUSLY here, before the form view's finalizeTransaction runs in its `finally`. That holds the
	 * transaction, and therefore the AutofillTriggerGroup PostSolvers that read `__Record`, open until the
	 * record has landed: no race, no one-save lag. Same fence Pict-Provider-Input-EntityBundleRequest uses
	 * for its fetches. Registered even on the cache-hit path — the promise still settles a microtask late,
	 * and a uniform fence beats a write whose visibility depends on cache luck.
	 *
	 * See docs/Picker-EntityRecord-Timing.md.
	 *
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {string} [pTransactionGUID] @param {number|string} [pRowIndex]
	 * @return {Promise<any>|void} resolves once the record has landed (the tests await it).
	 */
	_refreshEntityRecord(pView, pInput, pValue, pTransactionGUID, pRowIndex)
	{
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		// A non-entity picker (a static / picklist Select port-forward) has no record to hold.
		if (!tmpEntity || !pView || typeof pView.getMarshalDestinationObject !== 'function') { return; }
		const tmpMultiple = this._isMultiplePicker(pInput.PictForm);
		const tmpRecordAddress = this._getRecordAddress(pInput, pRowIndex);
		const fWriteRecord = (pRecord) => this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress, pRecord);
		const tmpValues = this._splitPickerValues(pValue, pInput);

		// Cleared: reset the slot synchronously (no fetch) so nothing downstream reads the previous record.
		if (tmpValues.length < 1)
		{
			const tmpCleared = tmpMultiple ? [] : { };
			fWriteRecord(tmpCleared);
			// Fire the cascade seam on clear too (a subclass may clear dependent joins / receivers). Sync path:
			// the writes land in this same dataChanged cycle, before finalizeTransaction — no fence needed.
			this._onEntityRecordCascade(pView, pInput, tmpCleared, pRowIndex, pTransactionGUID);
			return;
		}
		if (!this.pict.EntityProvider)
		{
			this.pict.log.warn(`Picker [${pInput.Hash}]: no EntityProvider registered — cannot populate [${tmpRecordAddress}].`);
			return;
		}

		// Unique per (field, row, change) so concurrent pickers in one transaction can't cross-complete.
		const tmpOperationHash = `PickerRecordRefresh-${tmpEntity}-${tmpRecordAddress}-${this.pict.getUUID()}`;
		const tmpFenced = !!pTransactionGUID && typeof pView.registerEventTransactionAsyncOperation === 'function';
		if (tmpFenced) { pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpOperationHash); }
		return Promise.all(tmpValues.map((pEntityValue) => this._resolveEntityRecord(tmpEntity, pEntityValue, pInput)))
			.then((pRecords) =>
			{
				// The value moved on while the lookups were in flight; the refresh for the current value owns the record.
				if (this._isStaleEntityRecordRefresh(pView, pInput, pRowIndex, tmpValues))
				{
					return undefined;
				}
				const tmpResolved = pRecords.filter((pRecord) => !!pRecord);
				let tmpWritten;
				if (tmpMultiple)
				{
					// A failed lookup keeps the record the form holds for that value, as a failed single lookup does.
					const tmpIdentity = this._getRecordIdentity(pInput);
					tmpWritten = tmpValues.map((pEntityValue, pIndex) => pRecords[pIndex] || this._findHeldRecord(pView, pInput, tmpIdentity, pEntityValue, pRowIndex)).filter((pRecord) => !!pRecord);
					fWriteRecord(tmpWritten);
				}
				else if (tmpResolved.length > 0)
				{
					const tmpHeld = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
					tmpWritten = this._reconcileRefreshedRecord(pView, pInput, tmpHeld, tmpResolved[0], this._getRecordIdentity(pInput), tmpValues[0], pRowIndex);
					fWriteRecord(tmpWritten);
				}
				else
				{
					// Every lookup failed — keep any prior record, else normalize the empty slot to {}.
					tmpWritten = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRecordAddress);
					if (!tmpWritten) { tmpWritten = { }; fWriteRecord(tmpWritten); }
				}
				// Fire the cascade seam AFTER __Record lands and INSIDE the fence; return its result so the
				// transaction awaits an async cascade before its PostSolvers run (see _onEntityRecordCascade).
				return this._onEntityRecordCascade(pView, pInput, tmpWritten, pRowIndex, pTransactionGUID);
			})
			.catch((pError) =>
			{
				this.pict.log.error(`Picker [${pInput.Hash}]: error populating [${tmpRecordAddress}]: ${pError.message || pError}`);
			})
			.finally(() =>
			{
				if (tmpFenced) { pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpOperationHash); }
			});
	}

	/**
	 * The per-InputType CASCADE seam for the MaterialsEntitySelector "beast" migration (plan §8.8).
	 *
	 * Fired right AFTER `__Record` is written and — on the select path — INSIDE the fenced transaction,
	 * so a subclass's cascade FormData writes (join records, `_EntityData` projection, dependent-field
	 * fills) inherit the exact land-before-transaction-complete guarantee the `__Record` fix proved (the
	 * select-path caller `return`s this so the fence awaits an async cascade before its PostSolvers run).
	 * Also fired on the clear path (synchronously) so a subclass can clear dependent state.
	 *
	 * The base broker is a NO-OP — a plain entity Picker has no cascade, so existing migrated fields are
	 * unaffected. `MaterialsCascadePicker` and the bespoke `Materials*Picker` subclasses override this to
	 * reproduce the legacy MES `_onRecordRefresh` behavior. Return a Promise to make the transaction wait.
	 *
	 * @param {Object} pView - the dynamic-form view.
	 * @param {Record<string, any>} pInput - the field descriptor.
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord - what was just written to `__Record`
	 *   (an object in single mode, an array in multi mode, `{}`/`[]` on clear).
	 * @param {number|string} [pRowIndex] - the row index for a tabular picker.
	 * @param {string} [pTransactionGUID] - the active transaction (for a subclass that needs to fence its own async work).
	 * @return {void|Promise<any>}
	 */
	// eslint-disable-next-line no-unused-vars
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		// No-op default. The beast (§8.8) overrides this.
	}

	/**
	 * Choose what a single-record refresh writes. The base takes the server row; `MaterialsCascadePicker`
	 * reconciles it against the record the form already holds.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {any} pHeldRecord - the record at the address when the row arrived.
	 * @param {Record<string, any>} pFetchedRecord - the server row.
	 * @param {string} pIdentityField @param {any} pValue @param {number|string|null} [pRowIndex]
	 * @return {Record<string, any>} the record to write.
	 */
	// eslint-disable-next-line no-unused-vars
	_reconcileRefreshedRecord(pView, pInput, pHeldRecord, pFetchedRecord, pIdentityField, pValue, pRowIndex)
	{
		return pFetchedRecord;
	}

	/**
	 * The per-InputType SELECTION-CLEARED seam, fired before any pathway blanks this field's value and
	 * `__Record` — the user clear, the anchor-change clear and the autofill-scope vet all route here.
	 *
	 * The base broker is a NO-OP: a plain entity Picker creates nothing, so it has nothing to tombstone
	 * and no salt to rotate. `MaterialsCascadePicker` overrides it to stage the scoped-EntityData
	 * tombstone and mint a fresh `__Salt`.
	 *
	 * @param {Object} pView - the dynamic-form view.
	 * @param {Record<string, any>} pInput - the field descriptor.
	 * @param {number|string|null} [pRowIndex] - the row index for a tabular picker.
	 */
	// eslint-disable-next-line no-unused-vars
	_handleEntitySelectionCleared(pView, pInput, pRowIndex)
	{
		// No-op default. MaterialsCascadePicker overrides this.
	}

	// --- Programmatic value commit + declarative defaults (beast B1, plan §8.8) ---

	/**
	 * Commit a PROGRAMMATIC value (a resolved Default, a cascade's reverse-seed, a creation flow) the way
	 * a user selection would land it, without double-driving the form cycle:
	 *   1. `setDataByInput` / `setDataTabularByHash` — the framework's programmatic set: writes the model
	 *      and runs this input's provider loop inside a fenced transaction, so the broker's own
	 *      `onDataChange` populates `__Record` and fires the cascade seam with the same
	 *      land-before-PostSolvers guarantee a user pick gets. (It does NOT solve/marshal — same as the
	 *      legacy MES `_setResolvedDefault`, whose select2 repainted via its own change plumbing.)
	 *   2. Sync the hidden informary input, so a later whole-form marshal-from-view cannot clobber the
	 *      model with the stale pre-commit DOM value.
	 *   3. `setValue` on the mounted picker widget — DISPLAY only (PSP's setValue deliberately fires no
	 *      OnChange). Routing through PSP's OnChange/_commit instead would call dataChanged a second
	 *      time: a double transaction + a double record refresh.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue
	 * @param {number|string|null} [pRowIndex]
	 */
	_setValueAndCommit(pView, pInput, pValue, pRowIndex)
	{
		if (pRowIndex != null)
		{
			if (typeof pView.setDataTabularByHash === 'function')
			{
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pValue);
			}
		}
		else if (typeof pView.setDataByInput === 'function')
		{
			pView.setDataByInput(pInput, pValue);
		}
		this._syncCommittedValueDOM(pInput, pValue, pRowIndex);
	}

	/**
	 * Steps 2–3 of _setValueAndCommit on their own: sync the hidden informary input + repaint the
	 * mounted widget (display-only) for a value the MODEL already holds. Used by the cascade family
	 * when it rewrites the committed value MID provider-loop (e.g. `__NEW__` → the synthesized GUID),
	 * where re-driving setDataByInput would nest a second provider pass.
	 * @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} [pRowIndex]
	 */
	_syncCommittedValueDOM(pInput, pValue, pRowIndex)
	{
		// The picker id helpers live on the (untyped-to-tsc) pict-section-picker base; reach them via a cast.
		const tmpSelf = /** @type {any} */ (this);
		const tmpCSV = Array.isArray(pValue) ? pValue.join(',') : ((pValue === undefined || pValue === null) ? '' : pValue);
		const tmpHiddenSelector = (pRowIndex != null) ? tmpSelf.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex) : pInput.Macro.HTMLSelector;
		const tmpPickerHash = (pRowIndex != null) ? tmpSelf.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex) : tmpSelf.getPickerHash(pInput.Macro.RawHTMLID);
		if (this.pict.ContentAssignment)
		{
			this.pict.ContentAssignment.assignContent(tmpHiddenSelector, tmpCSV);
		}
		const tmpPickerView = this.pict.views && this.pict.views[tmpPickerHash];
		if (tmpPickerView && typeof tmpPickerView.setValue === 'function')
		{
			tmpPickerView.setValue(pValue);
		}
	}

	/**
	 * The field the picker's committed value identifies a record by — PSP's ValueField. Mirrors the MES
	 * `_getRecordIdentity` (minus the creation-GUID branch, which arrives with the creation primitives
	 * in B2 Sample).
	 * @param {Record<string, any>} pInput @return {string}
	 */
	_getRecordIdentity(pInput)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		return tmpPictForm.RecordIdentity || tmpPictForm.IdentityField || `ID${this._resolveEntity(tmpPictForm) || ''}`;
	}

	/**
	 * True when this InputType gets the legacy MES defaults-on-empty behavior (see the map's
	 * `MaterialsFamily` flag). GATE, not vestige: enabling descriptor Defaults base-wide would make
	 * already-shipped generic Select→Picker fields carrying a `Default` suddenly self-populate on new
	 * forms — a data-result change. A bespoke cascade subclass may override to opt in directly.
	 *
	 * The `MaterialsHidden*` leg is membership, not a widening: those InputTypes are served by the same
	 * providers and carry a descriptor `Default` as their normal shape (the generated test-slot
	 * descriptors are `Default: '<test hash>'`), so the map's omission of them dropped a behaviour the
	 * legacy applied. `_clearsOnAnchorChange` already reads the same membership.
	 * @param {Record<string, any>} pInput @return {boolean}
	 */
	_appliesConfiguredDefaults(pInput)
	{
		const tmpInputType = pInput?.PictForm?.InputType || '';
		if (tmpInputType.startsWith('MaterialsHidden'))
		{
			return true;
		}
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpInputType];
		return !!(tmpSpecialized && tmpSpecialized.MaterialsFamily);
	}

	/**
	 * True when a declarative `Default` should be applied to the picker. Ported from the MES: a new form's
	 * marshal destination holds a DEFINED '' at the address, so manyfest's getValueByHash does NOT
	 * substitute the descriptor Default (it only does so for `undefined`) — pValue arrives '' and we apply
	 * it ourselves. Also fires when pValue DID arrive as the raw Default token (from an undefined address)
	 * for a by-field default, so the token can be resolved to an id; a by-id value already IS the record id
	 * and must not re-apply.
	 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
	 */
	_shouldApplyConfiguredDefault(pInput, pValue)
	{
		if (!this._appliesConfiguredDefaults(pInput))
		{
			return false;
		}
		if (pInput.Default == null || pInput.Default === '')
		{
			return false;
		}
		if (pValue == null || pValue === '')
		{
			return true;
		}
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		return (pValue === pInput.Default && !!tmpField && tmpField !== this._getRecordIdentity(pInput));
	}

	/**
	 * Apply `pInput.Default` to an empty picker (ported from the MES). `PictForm.DefaultField` names a
	 * NON-identity field to match on (e.g. `Hash`) so the default is portable across customers —
	 * `Default:"ACPT"` + `DefaultField:"Hash"` resolves the customer's ACPT SampleType by its id via one
	 * read. Without a DefaultField (or when it IS the identity) the Default is already the id and is set
	 * directly. The commit closes the value-gate so this does not re-fire; a re-entrancy latch dedupes
	 * concurrent init passes while the read is in flight.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_applyConfiguredDefault(pView, pInput, pRowIndex)
	{
		if (pInput._DefaultResolving)
		{
			return;
		}
		const tmpField = pInput.PictForm ? pInput.PictForm.DefaultField : null;
		if (!tmpField || tmpField === this._getRecordIdentity(pInput))
		{
			this._setResolvedDefault(pView, pInput, pRowIndex, pInput.Default);
			return;
		}
		const tmpEntity = this._resolveEntity((pInput && pInput.PictForm) || {});
		if (!tmpEntity || !this.pict.HeadlightRestClient)
		{
			return;
		}
		pInput._DefaultResolving = true;
		this.pict.HeadlightRestClient.getJSON(`${tmpEntity}s/FilteredTo/FBV~${tmpField}~EQ~${encodeURIComponent(pInput.Default)}/0/1`, (pError, pRows) =>
		{
			pInput._DefaultResolving = false;
			const tmpRecord = (!pError && Array.isArray(pRows)) ? pRows[0] : null;
			if (tmpRecord)
			{
				this._setResolvedDefault(pView, pInput, pRowIndex, tmpRecord[this._getRecordIdentity(pInput)]);
			}
		});
	}

	/**
	 * Land a resolved default through the value-commit primitive (record refresh + cascade + repaint).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex @param {any} pValue
	 */
	_setResolvedDefault(pView, pInput, pRowIndex, pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '')
		{
			return;
		}
		this._setValueAndCommit(pView, pInput, pValue, pRowIndex);
	}

	/** The document's own project id (`ReportData.Project.IDProject`, else `ReportData.IDProject`), or null. @return {number|string|null} */
	_getDocumentProjectID()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		const tmpIDProject = tmpReportData?.Project?.IDProject || tmpReportData?.IDProject;
		return (Number(tmpIDProject) > 0) ? tmpIDProject : null;
	}

	/**
	 * Legacy ProjectSelector parity: an empty project field on an editable document takes the document's project,
	 * which saves the field and publishes `AppData.SelectedProject` for sample naming. A descriptor Default wins.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 * @return {string|null} - The committed project id, or null when nothing was committed.
	 */
	_applyDocumentProjectDefault(pView, pInput, pValue, pRowIndex)
	{
		if (!pInput || !pInput.PictForm || pInput.PictForm.InputType !== 'ProjectSelector')
		{
			return null;
		}
		if ((pInput.Default != null && pInput.Default !== '') || (pValue != null && pValue !== ''))
		{
			return null;
		}
		const tmpIDProject = this._getDocumentProjectID();
		if (!tmpIDProject || this.pict.AppData.DocumentData.ReportData.Locked)
		{
			return null;
		}
		this._setResolvedDefault(pView, pInput, pRowIndex, String(tmpIDProject));
		return String(tmpIDProject);
	}

	/**
	 * Wire the Bridge Search Panel to this picker (legacy BridgeSelector parity): a panel pick lands through the
	 * value-commit primitive, so the record refresh, cascade and repaint take the standard path. One callback
	 * slot, as legacy: the last BridgeSelector initialized wins.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} pRowIndex
	 */
	_wireBridgeSearchPanel(pView, pInput, pRowIndex)
	{
		const tmpPanel = this.pict.views.HeadlightPaneBridges;
		if (!tmpPanel || typeof tmpPanel.setBridgeSelectionCallback !== 'function')
		{
			return;
		}
		tmpPanel.setBridgeSelectionCallback((pBridge) =>
		{
			if (pBridge && pBridge.IDBridge) { this._setValueAndCommit(pView, pInput, pBridge.IDBridge, pRowIndex); }
		});
	}

	/** Apply a declarative Default (MES-family fields) before the mount, mirroring MES.onInputInitialize:
	 *  pValue is blanked so the mount never renders a raw unresolved token; the async resolve lands
	 *  through _setValueAndCommit. BridgeSelector also claims the Bridge Search Panel here. */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._forgetCustomValues(pInput, null);
		const tmpProjectDefault = this._applyDocumentProjectDefault(pView, pInput, pValue, null);
		if (tmpProjectDefault !== null)
		{
			pValue = tmpProjectDefault;
		}
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			this._applyConfiguredDefault(pView, pInput, null);
			pValue = '';
		}
		if (pInput?.PictForm?.InputType === 'BridgeSelector')
		{
			this._wireBridgeSearchPanel(pView, pInput, null);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/** Tabular twin of onInputInitialize's default application and Bridge Search Panel wiring. */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._forgetCustomValues(pInput, pRowIndex);
		const tmpProjectDefault = this._applyDocumentProjectDefault(pView, pInput, pValue, pRowIndex);
		if (tmpProjectDefault !== null)
		{
			pValue = tmpProjectDefault;
		}
		if (this._shouldApplyConfiguredDefault(pInput, pValue))
		{
			this._applyConfiguredDefault(pView, pInput, pRowIndex);
			pValue = '';
		}
		if (pInput?.PictForm?.InputType === 'BridgeSelector')
		{
			this._wireBridgeSearchPanel(pView, pInput, pRowIndex);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	// --- Disabled-state parity (BUG-2) + open-dropdown re-render guard (BUG-1 interim) ---

	/** Register the Headlight Picker override CSS once (idempotent), above pict-section-picker's base block. */
	_ensureHeadlightPickerCSS()
	{
		if (this._headlightPickerCSSInjected) { return; }
		const tmpCSSMap = this.pict && this.pict.CSSMap;
		if (tmpCSSMap && typeof tmpCSSMap.addCSS === 'function')
		{
			tmpCSSMap.addCSS('Headlight-Picker-Overrides-CSS', _HEADLIGHT_PICKER_OVERRIDES_CSS, 600);
			if (typeof tmpCSSMap.injectCSS === 'function') { tmpCSSMap.injectCSS(); }
			this._headlightPickerCSSInjected = true;
		}
	}

	/**
	 * Reflect the descriptor's `PictForm.Disabled` onto the picker host as a `data-disabled` marker (BUG-2).
	 * pict-section-picker has no Disabled concept — its form-input maps only ReadOnly, which additionally
	 * strips the border + chevron — so a port-forwarded Disabled field would otherwise render as a fully
	 * interactive picker. The marker drives the greyed, non-interactive override CSS (chevron hidden),
	 * matching the sibling disabled inputs. Re-applied on every (re)mount because a full picker render
	 * rebuilds the widget DOM inside the host.
	 * @param {Record<string, any>} pInput @param {string} pHostSelector
	 */
	_reflectDisabledState(pInput, pHostSelector)
	{
		const tmpDisabled = !!(pInput && pInput.PictForm && pInput.PictForm.Disabled);
		const tmpElement = this.pict.ContentAssignment && this.pict.ContentAssignment.getElement(pHostSelector);
		const tmpHost = tmpElement && tmpElement[0];
		if (!tmpHost || typeof tmpHost.setAttribute !== 'function') { return; }
		if (tmpDisabled) { tmpHost.setAttribute('data-disabled', 'true'); }
		else if (typeof tmpHost.removeAttribute === 'function') { tmpHost.removeAttribute('data-disabled'); }
	}

	/** @param {string} pSelector @return {any} the first element the selector matches, or null. */
	_firstElement(pSelector)
	{
		const tmpElements = this.pict.ContentAssignment && this.pict.ContentAssignment.getElement(pSelector);
		return (tmpElements && tmpElements[0]) || null;
	}

	/**
	 * Reflect the descriptor's `PictForm.Required` onto the parts of the field the template can't reach
	 * (the template already marks the value input `data-required`): the value input's `data-empty-values`
	 * — this picker's unset sentinels, since an unset Number picker marshals in as 0, which InputValidation's
	 * value check would otherwise count as a selection — and `aria-required` on the widget's combobox.
	 * Re-applied after every (re)mount and commit because a picker render rebuilds the combobox.
	 * @param {Record<string, any>} pInput @param {string} pValueInputSelector @param {string} pHostSelector
	 */
	_reflectRequiredState(pInput, pValueInputSelector, pHostSelector)
	{
		const tmpRequired = !!(pInput && pInput.PictForm && pInput.PictForm.Required);
		const tmpValueInput = this._firstElement(pValueInputSelector);
		if (tmpValueInput && typeof tmpValueInput.setAttribute === 'function')
		{
			if (tmpRequired)
			{
				tmpValueInput.setAttribute('data-empty-values', JSON.stringify(this._resolveEmptyValues(pInput).map(String)));
			}
			else
			{
				tmpValueInput.removeAttribute('data-empty-values');
			}
		}
		const tmpHost = this._firstElement(pHostSelector);
		const tmpCombobox = (tmpHost && typeof tmpHost.querySelector === 'function') ? tmpHost.querySelector('[role="combobox"]') : null;
		if (!tmpCombobox)
		{
			return;
		}
		if (tmpRequired)
		{
			tmpCombobox.setAttribute('aria-required', 'true');
		}
		else
		{
			tmpCombobox.removeAttribute('aria-required');
		}
	}

	/**
	 * After a commit: re-apply the Required state the commit's render wiped, and — once the form has been
	 * submitted (`show-validation`) — revalidate the field, because a picker commit writes the value input
	 * without firing the DOM event InputValidation's form-level listener waits for.
	 * @param {Record<string, any>} pInput @param {string} pValueInputSelector @param {string} pHostSelector
	 */
	_syncRequiredStateAfterCommit(pInput, pValueInputSelector, pHostSelector)
	{
		this._reflectRequiredState(pInput, pValueInputSelector, pHostSelector);
		const tmpValidation = this.pict.providers && this.pict.providers.InputValidation;
		if (!tmpValidation || typeof tmpValidation.revalidateInputElement !== 'function')
		{
			return;
		}
		const tmpValueInput = this._firstElement(pValueInputSelector);
		if (!tmpValueInput || tmpValueInput.getAttribute('data-required') !== 'true')
		{
			return;
		}
		if (typeof tmpValueInput.closest !== 'function' || !tmpValueInput.closest('.show-validation'))
		{
			return;
		}
		tmpValidation.revalidateInputElement(tmpValueInput);
	}

	/**
	 * True when a picker is already mounted, its dropdown is OPEN, and its widget DOM is still present —
	 * i.e. the user is mid-interaction and this is a marshal re-render, not a section teardown.
	 *
	 * On a marshal-driven re-render (RenderMethod 'replace') we skip the destructive re-mount while the
	 * dropdown is open: the committed value is already reflected in the open picker, and skipping preserves
	 * the search box's text + focus mid-multi-pick (a full re-render rebuilds the search input empty). The
	 * DOM-presence check still lets a genuine teardown re-mount. (This originally also worked around a
	 * pre-1.9.0 position:fixed dropdown that detached on re-render; PSP 1.9.0's absolute/portal anchoring
	 * removed that failure mode, so the search/focus preservation is now the sole reason to keep the skip.)
	 * @param {string} pPickerHash @return {boolean}
	 */
	_isOpenAndMounted(pPickerHash)
	{
		const tmpView = this.pict.views && this.pict.views[pPickerHash];
		if (!tmpView || !tmpView._open) { return false; }
		if (typeof document === 'undefined') { return false; }
		return !!document.getElementById(`PPS_${pPickerHash}`);
	}

	/**
	 * Paint the Show-All toggle icon from the persisted override state on (re)mount — a full picker render
	 * rebuilds the field DOM, so the icon (default `fa-toggle-off` in the template) must be re-synced. No-op
	 * unless the field opts in via PictForm.ShowAllToggle or its config-map entry. Mirrors MES.onInputInitialize's icon sync.
	 * @param {Record<string, any>} pInput @param {number|string} [pRowIndex]
	 */
	_syncShowAllIcon(pInput, pRowIndex)
	{
		if (!libFilterToggleUI.isToggleVisible(pInput)) { return; }
		const tmpEngine = this.pict.providers.EntityFilterEngine;
		const tmpState = !!(tmpEngine && tmpEngine.isFilterOverridden(this._withMapFilterDefaults(pInput), (pRowIndex == null) ? undefined : pRowIndex));
		this._updateFilterToggleIcon(pInput.Macro.RawHTMLID, tmpState, pRowIndex);
		// The render-time macro already painted a manifest-declared Disabled; this catches a descriptor
		// disabled AFTER render, and re-paints it over the rebuilt field DOM a full picker render leaves.
		libFilterToggleUI.syncToggleDisabledState(this.pict, this.getSelectFilterToggleID(pInput.Macro.RawHTMLID, pRowIndex), libFilterToggleUI.isInputDisabled(pInput));
	}

	// --- Dynamic-filter dependent clearing (the legacy MES onAfterEventCompletion port, §9 parity) ---
	// When an ANCHOR field a picker depends on (PictForm.DynamicFilters[].TriggerGroupHash) changes, the
	// value already selected here may no longer belong to the new anchor. The engine narrows the OPTION
	// list per query, but only this pathway clears an already-committed stale value. Ported verbatim from
	// MaterialsEntitySelector (deleted in the §9 wave) and gated to the MES family like the legacy was —
	// generic entity pickers with TriggerGroupHash never auto-cleared legacy-side, so enabling it
	// base-wide would be a data-result change (the same reasoning as the _appliesConfiguredDefaults gate).

	/** True when this InputType inherits the legacy MES anchor-change clearing. @param {Record<string, any>} pInput */
	_clearsOnAnchorChange(pInput)
	{
		const tmpInputType = pInput?.PictForm?.InputType || '';
		return this._appliesConfiguredDefaults(pInput)
			|| tmpInputType === 'MaterialsEntitySelector'
			|| tmpInputType.startsWith('MaterialsHidden');
	}

	/**
	 * The shared clear decision: a TriggerGroup event from one of this input's DynamicFilters anchors
	 * clears the dependent value — unless the field opted into `PictForm.SmartClear`, which keeps the
	 * value when illegality can't be PROVEN (see _isSelectionIllegalForFilter).
	 * @param {Object} pView @param {Record<string, any>} pInput @param {string} pEvent
	 * @param {number|string|null} pRowIndex
	 */
	_maybeClearForDynamicFilter(pView, pInput, pEvent, pRowIndex)
	{
		if (!this._clearsOnAnchorChange(pInput)) { return; }
		const tmpMatchedFilter = (pRowIndex == null)
			? this._matchedDynamicFilterForEvent(pInput, pEvent)
			: this._matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex);
		if (tmpMatchedFilter && (!pInput.PictForm?.SmartClear || this._isSelectionIllegalForFilter(pView, pInput, tmpMatchedFilter, pRowIndex)))
		{
			this._clearForDynamicFilter(pView, pInput, (pRowIndex == null) ? null : pRowIndex);
		}
	}

	/**
	 * Pure: does a global event target one of this input's DynamicFilters?
	 * Returns the matching filter entry, or null. Self-emitted events are ignored.
	 * @param {Record<string, any>} pInput @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEvent(pInput, pEvent)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters)) { return null; }
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup') { return null; }
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash) { return null; }
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Tabular sibling of `_matchedDynamicFilterForEvent`. A tabular anchor fires a ROW-SCOPED event
	 * (`TriggerGroup:<hash>:RecordRefresh:<emitter>:<rowIndex>:<uuid>`); the global broadcast delivers it
	 * to EVERY row, so a dependent column must act on its OWN row only — otherwise changing one row's
	 * anchor would wipe valid selections in every other row. A global (non-row-scoped) event has a UUID
	 * in slot [4], which parseInt yields NaN for, so it never matches here.
	 * @param {Record<string, any>} pInput @param {string} pEvent @param {number|string} pRowIndex
	 * @return {object|null}
	 */
	_matchedDynamicFilterForEventTabular(pInput, pEvent, pRowIndex)
	{
		const tmpDynamicFilters = pInput && pInput.PictForm ? pInput.PictForm.DynamicFilters : null;
		if (!Array.isArray(tmpDynamicFilters)) { return null; }
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup') { return null; }
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		const tmpEventRowIndex = parseInt(tmpParts[4], 10);
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash) { return null; }
		if (isNaN(tmpEventRowIndex) || tmpEventRowIndex !== Number(pRowIndex)) { return null; }
		return tmpDynamicFilters.find((pFilter) => pFilter && pFilter.TriggerGroupHash === tmpGroupHash) || null;
	}

	/**
	 * Smart-clear gate (opt-in via `PictForm.SmartClear`). Returns true only when this picker's resolved
	 * record is DEFINITIVELY illegal for the changed anchor — the record carries the filter's `Field` and
	 * its value no longer equals the anchor's current value. When the record isn't resolved yet, lacks the
	 * FK, or the anchor is unset, illegality can't be proven, so we keep the value: this avoids clobbering a
	 * just-autofilled selection during sample projection, and preserves a user override that sits outside
	 * the filter.
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {object} pFilter - the matched DynamicFilters entry (`{ Field, FromField | FromRowField, … }`).
	 * @param {number|string|null} [pRowIndex]
	 * @return {boolean} true only when the current selection is provably illegal for pFilter.
	 */
	_isSelectionIllegalForFilter(pView, pInput, pFilter, pRowIndex)
	{
		if (!pFilter || !pFilter.Field) { return false; }
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex));
		if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord) || !(pFilter.Field in tmpRecord))
		{
			return false;
		}
		let tmpAnchorValue;
		if (pFilter.FromRowField && pRowIndex != null && pInput.PictForm && pInput.PictForm.InformaryContainerAddress)
		{
			const tmpRowAddress = this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pFilter.FromRowField);
			tmpAnchorValue = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRowAddress);
		}
		else if (pFilter.FromField)
		{
			tmpAnchorValue = this.pict.manifest.getValueByHash(this.pict, pFilter.FromField);
		}
		else
		{
			return false;
		}
		// An unset anchor imposes no constraint (applyDynamicFilters omits it), so nothing is illegal.
		const tmpAnchorNormalized = (tmpAnchorValue === null || tmpAnchorValue === undefined) ? '' : String(tmpAnchorValue).trim();
		if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0') { return false; }
		return String(tmpRecord[pFilter.Field]) !== tmpAnchorNormalized;
	}

	/**
	 * Reset this picker's value and its resolved-record companion (`__Record`), committed through
	 * _setValueAndCommit so the model, the hidden informary input and the mounted widget all reflect the
	 * cleared state (the legacy select2 val(null) + re-marshal, in Picker terms). `__Record` is reset to
	 * an EMPTY OBJECT (not deleted) to match the selector convention — record flows write fields into it
	 * and assume it is always an object. The next dropdown open re-fetches with the updated DynamicFilters
	 * (the new anchor value).
	 *
	 * Routed through `_handleEntitySelectionCleared` FIRST, so a programmatic clear of a creation-enabled
	 * field mints its tombstone and re-salts exactly like a user clear does — reusing the `__Salt` would
	 * make a later re-add upsert into the soft-deleted row.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 */
	_clearForDynamicFilter(pView, pInput, pRowIndex)
	{
		try
		{
			this._handleEntitySelectionCleared(pView, pInput, pRowIndex);
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._getRecordAddress(pInput, pRowIndex), {});
			this._setValueAndCommit(pView, pInput, pInput.Default ?? '', pRowIndex);
			this.pict.log.info(`DynamicFilter: cleared dependent input [${pInput.Hash}]${pRowIndex != null ? ` row ${pRowIndex}` : ''} after its anchor changed.`);
		}
		catch (pError)
		{
			this.pict.log.error(`DynamicFilter: failed to clear dependent input [${pInput && pInput.Hash}]: ${pError}`);
		}
	}

	/**
	 * Pure: does a global event correspond to an AUTOFILL into this input (an AutofillTriggerGroup entry
	 * whose TriggerGroupHash matches the event)? Self-emitted events, and entries flagged
	 * `AllowInvalidProjection` (record-projection sources whose out-of-scope values are legitimate), are
	 * skipped.
	 * @param {Record<string, any>} pInput @param {string} pEvent
	 * @return {object|null}
	 */
	_matchedAutofillGroupForEvent(pInput, pEvent)
	{
		let tmpGroups = (pInput && pInput.PictForm) ? pInput.PictForm.AutofillTriggerGroup : null;
		if (!tmpGroups) { return null; }
		if (!Array.isArray(tmpGroups)) { tmpGroups = [ tmpGroups ]; }
		const tmpParts = (typeof pEvent === 'string' ? pEvent : '').split(':');
		if (tmpParts[0] !== 'TriggerGroup') { return null; }
		const tmpGroupHash = tmpParts[1];
		const tmpEmitterHash = tmpParts[3];
		if ((pInput.Hash || pInput.DataAddress) === tmpEmitterHash) { return null; }
		return tmpGroups.find((pGroup) => pGroup && pGroup.TriggerGroupHash === tmpGroupHash && !pGroup.AllowInvalidProjection) || null;
	}

	/**
	 * Vet this picker's current value against its own Through DynamicFilters and suppress it when it is
	 * PROVABLY not a legal option — the selected `ThroughSelect` id is absent from the resolved allowed
	 * set for the current anchor. Fail-open everywhere else (no anchor, unprimed scope, no value → keep).
	 * Async because query-strategy Through slices load on demand — which also means it runs after the
	 * synchronous autofill has landed the value. Opt-in via PictForm.VetAutofillScope.
	 * @param {Object} pView @param {Record<string, any>} pInput @param {number|string|null} [pRowIndex]
	 * @return {Promise<void>}
	 */
	async _vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex)
	{
		const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
		const tmpResolver = this.pict.providers.ThroughScopeResolver;
		if (!Array.isArray(tmpFilters) || !tmpResolver) { return; }
		const tmpThroughFilters = tmpFilters.filter((pFilter) => pFilter && pFilter.Through && pFilter.ThroughSelect && pFilter.FromField);
		if (!tmpThroughFilters.length) { return; }
		const tmpDestination = pView.getMarshalDestinationObject();
		for (const tmpFilter of tmpThroughFilters)
		{
			const tmpAnchor = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			const tmpAnchorNormalized = (tmpAnchor === null || tmpAnchor === undefined) ? '' : String(tmpAnchor).trim();
			if (tmpAnchorNormalized === '' || tmpAnchorNormalized === '0') { continue; }
			const tmpRecord = this.pict.manifest.getValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex));
			let tmpSelected = (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord[tmpFilter.ThroughSelect] : null;
			if ((tmpSelected === null || tmpSelected === undefined || tmpSelected === '') && pRowIndex == null)
			{
				tmpSelected = this.pict.manifest.getValueAtAddress(tmpDestination, pInput.DataAddress);
			}
			if (tmpSelected === null || tmpSelected === undefined || tmpSelected === '' || Number(tmpSelected) === 0) { continue; }
			await tmpResolver.primeThroughSlice(tmpFilter, tmpAnchor);
			const tmpAllowed = tmpResolver.getThroughIDs(tmpFilter, tmpAnchor);
			// Fail-open backstop: an empty allowed set means the scope could not be resolved (sparse or missing
			// join data, or a failed prime) — that is "cannot constrain", not "everything is illegal". Clearing
			// on it would nuke a legitimately-chosen value. A genuinely-scoped anchor returns a non-empty set
			// and still clears an out-of-scope value below.
			if (!tmpAllowed || typeof tmpAllowed.has !== 'function' || tmpAllowed.size === 0)
			{
				continue;
			}
			if (!tmpAllowed.has(Number(tmpSelected)))
			{
				this._clearForDynamicFilter(pView, pInput, pRowIndex);
				return;
			}
		}
	}

	/**
	 * True while a record-refresh cascade is fanning out — a LOAD is authoritative, so persisted values
	 * must display rather than be re-vetted against the current filter scope. The counter lives on the
	 * pict instance under the name `MaterialsEntitySelector` sets, so a cascade fired by either family
	 * suppresses the vet in the other while both run on one form.
	 * @return {boolean}
	 */
	_isHydrating()
	{
		return !!this.pict._MaterialsEntityHydrationDepth;
	}

	/** The anchor-change event pathway (the legacy MES onAfterEventCompletion, ported): dependent clear +
	 *  autofill-scope vetting + idempotent scope re-priming for the new anchor. */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._maybeClearForDynamicFilter(pView, pInput, pEvent, null);
		if (pInput.PictForm?.VetAutofillScope && !this._isHydrating() && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, null).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		// Warm any query-strategy Through slice / lab scope for the new anchor value so a dependent
		// picker's INN clause resolves synchronously once it is opened. Both are idempotent (keyed
		// re-fetch only on change).
		this.pict.providers.ThroughScopeResolver?.primeQueryScopesFromForm?.();
		this.pict.providers.LabScopeResolver?.primeFromForm?.();
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/** Tabular twin: act on this row's own anchor events only (see _matchedDynamicFilterForEventTabular). */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._maybeClearForDynamicFilter(pView, pInput, pEvent, pRowIndex);
		if (pInput.PictForm?.VetAutofillScope && !this._isHydrating() && this._matchedAutofillGroupForEvent(pInput, pEvent))
		{
			this._vetAutofilledValueAgainstFilters(pView, pInput, pRowIndex).catch((pError) =>
			{
				this.pict.log.error(`Autofill scope vet failed (value kept): ${pError?.message || pError}`);
			});
		}
		this.pict.providers.ThroughScopeResolver?.primeQueryScopesFromForm?.();
		this.pict.providers.LabScopeResolver?.primeFromForm?.();
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/** Override the mount: guard the destructive open re-render (BUG-1) + stamp the disabled marker (BUG-2)
	 *  and the Required state + sync the Show-All toggle icon. */
	_mountPicker(pView, pInput, pValue, pHostSelector, pPickerHash, fOnChange)
	{
		this._ensureHeadlightPickerCSS();
		if (this._isOpenAndMounted(pPickerHash)) { return true; }
		// A null row keeps the BaseFilter row-less while giving _applyFacetRules the view.
		const tmpMounted = this._withTabularContext(pView, null, () => super._mountPicker(pView, pInput, pValue, pHostSelector, pPickerHash, fOnChange), pValue);
		if (tmpMounted)
		{
			this._reflectDisabledState(pInput, pHostSelector);
			this._reflectRequiredState(pInput, pInput.Macro.HTMLSelector, pHostSelector);
			this._syncShowAllIcon(pInput);
		}
		return tmpMounted;
	}

	/** Tabular twin of _mountPicker. */
	_mountPickerTabular(pView, pInput, pValue, pRowIndex)
	{
		this._ensureHeadlightPickerCSS();
		// The tabular id helpers live on the (untyped-to-tsc) pict-section-picker base; reach them via a cast.
		const tmpSelf = /** @type {any} */ (this);
		const tmpHash = tmpSelf.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex);
		if (this._isOpenAndMounted(tmpHash)) { return true; }
		// Stash the row context so the _buildPickerConfig inside the super mount captures it into this row's
		// BaseFilter closure (plan §5.3). The arrow preserves super binding.
		const tmpMounted = this._withTabularContext(pView, pRowIndex, () => super._mountPickerTabular(pView, pInput, pValue, pRowIndex), pValue);
		if (tmpMounted)
		{
			const tmpHostSelector = tmpSelf.getTabularPickerHostID(pInput.Macro.RawHTMLID, pRowIndex);
			this._reflectDisabledState(pInput, tmpHostSelector);
			this._reflectRequiredState(pInput, tmpSelf.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex), tmpHostSelector);
			this._syncShowAllIcon(pInput, pRowIndex);
		}
		return tmpMounted;
	}
}

module.exports = PictProviderInputTypePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./_EntityDisplayName.js":155,"./_EntityOptionSource.js":157,"./_FilterToggleUI.js":158,"./_LabRouting.js":159,"./_PickerEmptyValues.js":160,"./_SharedEntityRead.js":164,"./_SpecializedSelectorMap.js":165,"./_StaticSelectEntity.js":166,"./_VocabularySelectorMap.js":171,"pict-section-picker/form":710}],118:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
// R2: shared with the Picker broker so a specialized selector's provider-hardcoded Entity resolves
// identically for the Read/Print display as it does for the Edit picker.
const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');
// Managed code lists (SampleStatus, …): the Read/Print label comes from the same table the Edit picker
// reads, so a status curated by the customer is not shown as its bare code here.
const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');
const libTestResultOptions = require('./_TestResultOptions.js');
const libTestResultsSummary = require('./_TestResultsSummary.js');
// Shared with the Picker broker so Read/Print ignores a static select's Entity exactly as Edit does.
const libStaticSelectEntity = require('./_StaticSelectEntity.js');
const libEntityOptionSource = require('./_EntityOptionSource.js');
// The SAME "what counts as unset" rule the EDIT picker applies — shared rather than re-derived so
// Read/Print cannot drift from Edit, the failure mode this provider family keeps hitting.
const libPickerEmptyValues = require('./_PickerEmptyValues.js');
// The SAME display-name resolution order the legacy Select2Util chain applies (dotted paths, the
// Name-less User table) — shared so flipping a forward onto this provider is a no-visual-change move.
const libEntityDisplayName = require('./_EntityDisplayName.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

/**
 * PickerDisplay — the non-interactive Read/Print display for InputType 'Picker' (and the legacy
 * InputTypes port-forwarded onto it). ONE provider serves BOTH themes: it resolves the field's stored
 * value to its display markup — a static `SelectOptions` label, or an entity's name (Entity path), with
 * an optional EntityTag badge — and paints it into the `PICKER-DISPLAY-FOR` node the Read/Print templates
 * render. Read and Print differ only in the TEMPLATE that styles that node (Read = a locked control;
 * Print = static PDF text), so no second provider is needed — mirrors how `EntityDisplay` serves both.
 *
 * This lets the Picker stack own its own read/print display, so the legacy `Option` / `EntityDisplay`
 * display providers can eventually be decommissioned (plan §9). Value resolution is kept output-identical
 * to the legacy providers so flipping the forwards is a no-visual-change move:
 *   - static: the same `SelectOptions`/`SelectOptionsPickList` lookup as `Select.handlePDFDisplay`;
 *   - entity: the entity NAME + optional EntityTag badge, matching `EntityDisplay(Multiple)`'s compound
 *     output — but resolved through pict-section-picker's `createEntityResolveValue` (NOT
 *     `Select2Util.getEntityAsync`), so this provider carries no Select2Util dependency at decommission.
 *
 * NOTE (plan §9 cleanup): the compound markup deliberately keeps the legacy `.select2-*-entity-selection`
 * / `.tag.select2-entity-tag` class names so bulma-print.scss styles it identically in Read + PDF today.
 * When select2 CSS is retired, rename those classes here AND in bulma-print.scss in lockstep (they are
 * plain strings this provider owns — there is no code dependency on Select2Util).
 */
class PickerDisplayProvider extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/** @param {string} pRawHTMLID @return {string} */
	getDisplayNodeID(pRawHTMLID)
	{
		return `#PICKER-DISPLAY-FOR-${pRawHTMLID}`;
	}

	/** @param {string} pRawHTMLID @param {number|string} pRowIndex @return {string} */
	getTabularDisplayNodeID(pRawHTMLID, pRowIndex)
	{
		return `#PICKER-DISPLAY-TABULAR-DATA-${pRawHTMLID}-${pRowIndex}`;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Fire-and-forget: the entity path is async, and the base class hook is synchronous (same shape as
		// EntityDisplay's FIXME). The node is painted whenever the resolve settles.
		this._paint(pView, pInput, pValue, null).catch((pError) => this.pict.log.error(`PickerDisplay paint error: ${pError}`));
		// Read/Print paint test results here instead of through SampleTestAcceptance, so the summary is asked from here too.
		if (libTestResultOptions.TEST_RESULT_INPUT_TYPES.indexOf(pInput?.PictForm?.InputType) >= 0)
		{
			libTestResultsSummary.requestSummaryRefresh(this.pict, pView);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._paint(pView, pInput, pValue, pRowIndex).catch((pError) => this.pict.log.error(`PickerDisplay paint error: ${pError}`));
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Resolve the value → display markup and paint it into the Read/Print display node (no-op when the node
	 * is absent, e.g. the Edit theme).
	 * @param {object} pView @param {object} pInput @param {any} pValue @param {number|string|null} pRowIndex
	 * @return {Promise<boolean>}
	 */
	async _paint(pView, pInput, pValue, pRowIndex)
	{
		const tmpNodeID = pRowIndex != null ?
			this.getTabularDisplayNodeID(pInput.Macro.RawHTMLID, pRowIndex) :
			this.getDisplayNodeID(pInput.Macro.RawHTMLID);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpNodeID);
		if (!tmpElements || tmpElements.length < 1)
		{
			return false;
		}
		const tmpHTML = await this._buildDisplayHTML(pInput, pValue, pView, pRowIndex);
		this.pict.ContentAssignment.assignContent(tmpElements[0], tmpHTML);
		return true;
	}

	/** Whether this field holds multiple values — the legacy multi InputTypes, or an explicit `Multiple`. */
	_isMulti(pPictForm)
	{
		return !!(pPictForm.Multiple || pPictForm.InputType === 'Select2Multiple' || pPictForm.InputType === 'EntitySelectorMultiple');
	}

	/** Split the stored value into parts (multi = CSV). Unset → []. */
	_valueParts(pPictForm, pValue)
	{
		if (pValue === null || pValue === undefined || pValue === '')
		{
			return [];
		}
		if (this._isMulti(pPictForm))
		{
			return String(pValue).split(',').map((pPart) => pPart.trim()).filter((pPart) => pPart !== '');
		}
		return [ pValue ];
	}

	/**
	 * The field's PictForm, augmented for a specialized selector (LabSelector, …) whose Entity is
	 * provider-hardcoded rather than descriptor-carried: inject the inferred Entity + display field from
	 * the shared map so the entity-resolve path fires exactly as it would for a descriptor that carries
	 * Entity. A descriptor naming the map's own Entity still takes the map's display config (legacy ignored
	 * the descriptor's Entity); a non-specialized InputType, or one naming a different Entity, is untouched.
	 * @param {object} pInput @return {Record<string, any>}
	 */
	_resolvedPictForm(pInput)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput);
		// Static result codes: the acceptance input stamps these in its own initialize hooks, which never
		// run in Read/Print, so without this the display prints the raw code (PEND) instead of Pending.
		libTestResultOptions.applyTestResultOptions(pInput);
		libStaticSelectEntity.dropStaticSelectEntity(pInput && pInput.PictForm);
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		const tmpSpecialized = _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType];
		if (!tmpSpecialized || (tmpPictForm.Entity && tmpPictForm.Entity !== tmpSpecialized.Entity)) { return tmpPictForm; }
		return Object.assign({}, tmpPictForm,
		{
			Entity: tmpSpecialized.Entity,
			TextField: tmpPictForm.TextField || tmpPictForm.EntityDisplayField || tmpSpecialized.TextField,
			EntityTag: tmpPictForm.EntityTag || tmpSpecialized.EntityTag,
			RecordIdentity: tmpPictForm.RecordIdentity || tmpSpecialized.RecordIdentity,
			// A multi-by-default selector (Lab/LineItem) gets Multiple from its EDIT provider's init at
			// runtime — which never runs in Read/Print, so the map carries it (?? keeps an explicit false).
			Multiple: tmpPictForm.Multiple ?? tmpSpecialized.Multiple,
		});
	}

	/**
	 * The field the committed value identifies its record by — mirrors the broker/cascade identity
	 * precedence (a GUID/Hash-identity selector like Sample or Test carries its RecordIdentity through
	 * the shared map, so the display resolves the SAME way the Edit picker committed).
	 * @param {object} pPictForm @return {string}
	 */
	_identityField(pPictForm)
	{
		return pPictForm.RecordIdentity || pPictForm.IdentityField || `ID${pPictForm.Entity || ''}`;
	}

	/**
	 * The field's `__Record` address — the broker's address scheme replicated (an explicit
	 * PictForm.RecordAddress wins; tabular composes through Informary).
	 * @param {object} pInput @param {number|string|null} pRowIndex @return {string}
	 */
	_recordAddress(pInput, pRowIndex)
	{
		if (pInput.PictForm?.RecordAddress)
		{
			return pInput.PictForm.RecordAddress;
		}
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress) + '__Record';
		}
		return `${pInput.DataAddress || pInput.Hash}__Record`;
	}

	/**
	 * The locally persisted `__Record` snapshot(s) for this field, always as an array (multi persists an
	 * array, single an object). Saved forms persist `__Record` beside the value, and a created-but-unsaved
	 * record exists ONLY here — so the display resolves from it first, before any fetch.
	 * @param {object} pView @param {object} pInput @param {number|string|null} pRowIndex
	 * @return {Array<Record<string, any>>}
	 */
	_localEntityRecords(pView, pInput, pRowIndex)
	{
		if (!pView || typeof pView.getMarshalDestinationObject !== 'function')
		{
			return [];
		}
		const tmpRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._recordAddress(pInput, pRowIndex));
		if (Array.isArray(tmpRecord))
		{
			return tmpRecord.filter((pEntry) => pEntry && typeof pEntry === 'object');
		}
		return (tmpRecord && typeof tmpRecord === 'object' && Object.keys(tmpRecord).length > 0) ? [ tmpRecord ] : [];
	}

	/**
	 *`{ name, tag }` straight off a full entity record (the `__Record` / identity-fetch paths): name from
	 * the display field, tag from EntityTag — including the legacy `<Field>:date` tag format.
	 * @param {Record<string, any>} pRecord @param {object} pPictForm @param {string} [pFieldLabel]
	 * @return {{name:string, tag:any}}
	 */
	_recordParts(pRecord, pPictForm, pFieldLabel)
	{
		// No fallback thunk: the TextField branch never calls one, so the blank case is labelled here instead.
		let tmpName = libEntityDisplayName.resolveEntityDisplayName(pPictForm.Entity, pRecord, pPictForm);
		if (tmpName === undefined || tmpName === null || String(tmpName).trim() === '')
		{
			tmpName = this._unnamedLabel(pPictForm, pRecord, undefined, pFieldLabel);
		}
		let tmpTag = null;
		if (pPictForm.EntityTag)
		{
			let tmpTagField = pPictForm.EntityTag;
			const tmpIsDate = tmpTagField.includes(':date');
			if (tmpIsDate)
			{
				tmpTagField = tmpTagField.replace(':date', '');
			}
			tmpTag = pRecord[tmpTagField];
			if (tmpIsDate && tmpTag && this.pict.Dates?.dayJS)
			{
				tmpTag = this.pict.Dates.dayJS(tmpTag).format('YYYY-MM-DD');
			}
			if (tmpTag === undefined || tmpTag === null || tmpTag === '')
			{
				tmpTag = null;
			}
		}
		return { name: (tmpName === undefined || tmpName === null) ? '' : String(tmpName), tag: tmpTag };
	}

	/**
	 * Build the display HTML for the stored value(s): plain comma-joined label(s) for static / untagged
	 * entity fields, or the compound `[tag] name` markup (comma-joined for multi) when an EntityTag is
	 * configured — output-identical to EntityDisplay(Multiple). Empty value → ''. pView/pRowIndex (when
	 * the caller has them) enable the `__Record`-first resolve.
	 * @param {object} pInput @param {any} pValue @param {object} [pView] @param {number|string|null} [pRowIndex]
	 * @return {Promise<string>}
	 */
	async _buildDisplayHTML(pInput, pValue, pView, pRowIndex)
	{
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpParts = await this._resolveParts(pInput, pValue, pView, pRowIndex);
		if (tmpParts.length < 1)
		{
			return '';
		}
		// Compound tag+name only when an EntityTag is configured (entity fields); everything else is a
		// plain, comma-joined label list (the current, verified behavior).
		if (tmpPictForm.Entity && tmpPictForm.EntityTag)
		{
			const tmpMulti = this._isMulti(tmpPictForm);
			const tmpTagLast = !!tmpPictForm.EntityTagLast;
			// A configured-but-empty tag paints no badge at all — per part, so a mixed list still tags the
			// records that have one. The bare name is exactly what an untagged entity descriptor renders,
			// which also keeps the badge-compensating print padding on .select2-single-entity-selection off
			// a field with no badge to compensate for. Every tag path normalizes ''/undefined to null, so a
			// numeric 0 stays a real tag.
			return tmpParts.map((pPart) => (pPart.tag == null) ?
				this._nameHTML(pPart.name) :
				this._compoundDisplayHTML(pPart.tag, this._nameHTML(pPart.name), tmpMulti, tmpTagLast)).join(', ');
		}
		return tmpParts.map((pPart) => this._nameHTML(pPart.name)).join(', ');
	}

	/**
	 * The name an entity record with no display name paints: `<entity label> #<record ID>` (`Document #282`),
	 * the same label the Edit picker gives it. The record's own ID column wins over pFallbackID; '' when
	 * neither is set, which leaves _nameHTML's faded marker.
	 * @param {object} pPictForm @param {Record<string, any>|undefined} pRecord @param {any} pFallbackID
	 * @param {string} [pFieldLabel] - the field's label, which names an Organization's role.
	 * @return {string}
	 */
	_unnamedLabel(pPictForm, pRecord, pFallbackID, pFieldLabel)
	{
		const tmpRecordID = pRecord ? pRecord[`ID${pPictForm.Entity}`] : undefined;
		const tmpID = (tmpRecordID === undefined || tmpRecordID === null || tmpRecordID === '') ? pFallbackID : tmpRecordID;
		return libEntityDisplayName.unnamedEntityLabel(pPictForm.Entity, tmpID, pFieldLabel);
	}

	/**
	 * A display name, substituting a faded "no text provided" marker for a blank/missing value so a
	 * user/developer can spot bad data (a static option with no text, or an entity name with no ID to label
	 * it by) rather than an invisible gap. Non-blank names pass through unchanged.
	 * @param {any} pName @return {string}
	 */
	_nameHTML(pName)
	{
		if (pName === undefined || pName === null || String(pName).trim() === '')
		{
			return '<span class="picker-display-empty">no text provided</span>';
		}
		return String(pName);
	}

	/**
	 * Resolve each stored value to `{ name, tag }`. Entity fields resolve System-1-first: the persisted
	 * `__Record` snapshot whose identity matches the value (covers created-but-unsaved records, which no
	 * fetch can serve, and costs nothing for saved forms); then a NON-simple identity (GUID/Hash — the
	 * cascade family) fetches the legacy `FBL~<identity>~INN` shape through the broker; a plain numeric
	 * identity rides pict-section-picker's `createEntityResolveValue` (the original path). Static fields
	 * resolve their option label (tag null).
	 * @param {object} pInput @param {any} pValue @param {object} [pView] @param {number|string|null} [pRowIndex]
	 * @return {Promise<Array<{name:string, tag:any}>>}
	 */
	async _resolveParts(pInput, pValue, pView, pRowIndex)
	{
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpValues = this._valueParts(tmpPictForm, pValue);
		if (tmpValues.length < 1)
		{
			return [];
		}
		// Unset sentinels (a pristine Number descriptor marshals in as manyfest's DataType default 0)
		// resolve to nothing, exactly as the edit picker paints its placeholder for them — there is no
		// entity #0 to fetch, and a bare "0" in a PDF reads as a bug. Static option lists keep the
		// widget's escape hatch below: a sentinel that IS a real option is a genuine selection.
		const tmpIsSentinel = (pValuePart) => libPickerEmptyValues.isEmptyValue(pInput, pValuePart);
		if (tmpPictForm.Entity)
		{
			const tmpEntityValues = tmpValues.filter((pValuePart) => !tmpIsSentinel(pValuePart));
			if (tmpEntityValues.length < 1)
			{
				return [];
			}
			const tmpIdentity = this._identityField(tmpPictForm);
			const tmpLocalRecords = this._localEntityRecords(pView, pInput, pRowIndex == null ? null : pRowIndex);
			const tmpResolver = (tmpIdentity === `ID${tmpPictForm.Entity}`) ? this._entityResolver(tmpPictForm) : null;
			const tmpFieldLabel = pInput && pInput.Name;
			return Promise.all(tmpEntityValues.map((pValuePart) =>
			{
				const tmpLocal = tmpLocalRecords.find((pRecord) => pRecord[tmpIdentity] == pValuePart);
				if (tmpLocal)
				{
					return Promise.resolve(this._recordParts(tmpLocal, tmpPictForm, tmpFieldLabel));
				}
				if (!tmpResolver)
				{
					return this._resolveEntityByIdentity(tmpPictForm, tmpIdentity, pValuePart, tmpFieldLabel);
				}
				return this._resolveEntity(tmpResolver, tmpPictForm, pValuePart, tmpFieldLabel);
			}));
		}
		const tmpOptions = await this._resolveStaticOptions(tmpPictForm);
		return tmpValues
			.filter((pValuePart) => !tmpIsSentinel(pValuePart) || tmpOptions.some((pOption) => String(pOption.id) === String(pValuePart)))
			.map((pValuePart) => ({ name: this._resolveOptionLabel(tmpOptions, pValuePart), tag: null }));
	}

	/**
	 * value → `{ name, tag }` by a NON-simple identity (GUID/Hash), through the broker's legacy-shape
	 * fetch (`FBL~<identity>~INN`) — getEntity/createEntityResolveValue can only look up by numeric id.
	 * No match (e.g. an unsaved GUID with no local snapshot) degrades to the raw value, like the id path.
	 * @param {object} pPictForm @param {string} pIdentityField @param {any} pValue @param {string} [pFieldLabel]
	 * @return {Promise<{name:string, tag:any}>}
	 */
	async _resolveEntityByIdentity(pPictForm, pIdentityField, pValue, pFieldLabel)
	{
		const tmpBroker = this.pict.providers.Picker;
		if (!tmpBroker || typeof tmpBroker._resolveEntityRecordByIdentity !== 'function')
		{
			this.pict.log.warn('PickerDisplay: the Picker broker is not registered; cannot resolve by identity.');
			return { name: String(pValue), tag: null };
		}
		const tmpRecord = await tmpBroker._resolveEntityRecordByIdentity(pPictForm.Entity, pIdentityField, pValue);
		if (!tmpRecord)
		{
			return { name: String(pValue), tag: null };
		}
		return this._recordParts(tmpRecord, pPictForm, pFieldLabel);
	}

	/**
	 * Build a pict-section-picker entity `ResolveValue(value) => Promise<{Text, Tag, ...}>` from the
	 * descriptor vocab (IdentityField → ValueField, EntityDisplayField → TextField, Join* / EntityTag
	 * passed through). Replaces the Select2Util.getEntityAsync resolve. Null when the picker provider
	 * isn't registered.
	 * @param {object} pPictForm @return {((pValue:any) => Promise<any>)|null}
	 */
	_entityResolver(pPictForm)
	{
		const tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpProvider || typeof tmpProvider.createEntityResolveValue !== 'function')
		{
			this.pict.log.warn('PickerDisplay: the Pict-Section-Picker provider is not registered; cannot resolve entity display names.');
			return null;
		}
		return tmpProvider.createEntityResolveValue(
		{
			Entity: pPictForm.Entity,
			ValueField: pPictForm.ValueField || pPictForm.IdentityField,
			TextField: pPictForm.TextField || pPictForm.EntityDisplayField,
			TextTemplate: pPictForm.TextTemplate,
			JoinEntity: pPictForm.JoinEntity,
			JoinField: pPictForm.JoinField,
			JoinEntityValueField: pPictForm.JoinEntityValueField,
			JoinEntityDisplayField: pPictForm.JoinEntityDisplayField,
			JoinEntityFirst: pPictForm.JoinEntityFirst,
			JoinSeparator: pPictForm.JoinSeparator,
			EntityTag: pPictForm.EntityTag,
			EntityTags: pPictForm.EntityTags,
		});
	}

	/**
	 * Whether the picker's own flat `pRecord[TextField]` provably cannot produce this descriptor's label,
	 * so the display has to resolve the name locally: a DOTTED display field, or a `User` with none
	 * configured (that table has no `Name` column, which is what the picker defaults to). Narrow on
	 * purpose — a TextTemplate or a JoinEntity compound is the picker's to compose, and recomputing
	 * locally would drop it.
	 * @param {object} pPictForm @return {boolean}
	 */
	_needsLocalNameResolution(pPictForm)
	{
		if (pPictForm.TextTemplate || pPictForm.JoinEntity)
		{
			return false;
		}
		const tmpDisplayField = pPictForm.TextField || pPictForm.EntityDisplayField;
		if (tmpDisplayField)
		{
			return tmpDisplayField.includes('.');
		}
		return pPictForm.Entity === 'User';
	}

	/**
	 * value (id) → `{ name, tag }` via the picker's ResolveValue. Missing entity, a failed read or a resolve
	 * error → the raw value as the name with no tag (never throws — the display degrades gracefully).
	 * @param {((pValue:any) => Promise<any>)|null} pResolver @param {object} pPictForm @param {any} pValue
	 * @param {string} [pFieldLabel]
	 * @return {Promise<{name:string, tag:any}>}
	 */
	async _resolveEntity(pResolver, pPictForm, pValue, pFieldLabel)
	{
		try
		{
			const tmpResolved = pResolver ? await pResolver(pValue) : null;
			if (!tmpResolved || (tmpResolved.Record && !libSharedEntityRead.isEntityRecord(pPictForm.Entity, tmpResolved.Record)))
			{
				return { name: String(pValue), tag: null };
			}
			// The picker composes its Text with a FLAT `pRecord[TextField]` (defaulting to 'Name'), which
			// cannot serve a dotted display field or the Name-less User table — so for those two shapes the
			// label is recomputed here off the record the resolve carries back. Same helper as the __Record
			// path, so all three entity paths in this provider agree.
			if (tmpResolved.Record && this._needsLocalNameResolution(pPictForm))
			{
				return this._recordParts(tmpResolved.Record, pPictForm, pFieldLabel);
			}
			const tmpName = (tmpResolved.Text !== undefined && tmpResolved.Text !== null && String(tmpResolved.Text).trim() !== '') ?
				tmpResolved.Text :
				this._unnamedLabel(pPictForm, tmpResolved.Record, pValue, pFieldLabel);
			const tmpTag = (tmpResolved.Tag !== undefined && tmpResolved.Tag !== null && tmpResolved.Tag !== '') ? tmpResolved.Tag : null;
			return { name: tmpName, tag: tmpTag };
		}
		catch (pError)
		{
			this.pict.log.warn(`PickerDisplay: could not resolve ${pPictForm.Entity} #${pValue} for display.`, pError);
			return { name: String(pValue), tag: null };
		}
	}

	/**
	 * The compound `[tag] name` markup for one entity value — output-identical to Select2Util's
	 * buildSelect2CompoundDisplayTemplate (styled by bulma-print.scss in Read + PDF), but built here so the
	 * provider carries no Select2Util code dependency. See the class NOTE re: the §9 class-name rename.
	 * @param {any} pTag @param {any} pName @param {boolean} pMultiple @param {boolean} pTagAtEnd @return {string}
	 */
	_compoundDisplayHTML(pTag, pName, pMultiple, pTagAtEnd)
	{
		const tmpName = `<span class="select2-entity-name">${pName === undefined || pName === null ? '' : pName}</span>`;
		const tmpTag = `<span class="tag select2-entity-tag">${pTag}</span>`;
		const tmpInner = pTagAtEnd ? `${tmpName}${tmpTag}` : `${tmpTag}${tmpName}`;
		return `<span class="select2-${pMultiple ? 'multiple' : 'single'}-entity-selection">${tmpInner}</span>`;
	}

	/**
	 * The option set to label a non-entity value with: a managed vocabulary's rows when the field is
	 * backed by one (falling back to its static list for a customer with no rows), else the static set.
	 * @param {object} pPictForm @return {Promise<Array<{id:any, text:string}>>}
	 */
	async _resolveStaticOptions(pPictForm)
	{
		if (pPictForm.SelectOptionsEntity)
		{
			return libEntityOptionSource.resolveOptionsAsync(this, { PictForm: pPictForm });
		}
		return this._staticOptions(pPictForm);
	}

	/**
	 * The static option set for a non-entity field: the inline `SelectOptions`, or a resolved
	 * `SelectOptionsPickList` (mirrors PictProvider-InputType-Select.handlePDFDisplay).
	 * @param {object} pPictForm @return {Array<{id:any, text:string}>}
	 */
	_staticOptions(pPictForm)
	{
		let tmpData = Array.isArray(pPictForm.SelectOptions) ? pPictForm.SelectOptions : null;
		const tmpMetaLists = this.pict.providers.DynamicMetaLists;
		if ((!tmpData || tmpData.length < 1) && pPictForm.SelectOptionsPickList && tmpMetaLists &&
			typeof tmpMetaLists.hasList === 'function' && tmpMetaLists.hasList(pPictForm.SelectOptionsPickList))
		{
			tmpData = tmpMetaLists.getList(pPictForm.SelectOptionsPickList);
		}
		return tmpData || [];
	}

	/** value → the matching option's text; falls back to the raw value when it isn't in the set. */
	_resolveOptionLabel(pOptions, pValue)
	{
		const tmpMatch = pOptions.find((pOption) => String(pOption.id) === String(pValue));
		return tmpMatch ? tmpMatch.text : String(pValue);
	}
}

module.exports = PickerDisplayProvider;

},{"./_EntityDisplayName.js":155,"./_EntityOptionSource.js":157,"./_PickerEmptyValues.js":160,"./_SharedEntityRead.js":164,"./_SpecializedSelectorMap.js":165,"./_StaticSelectEntity.js":166,"./_TestResultOptions.js":168,"./_TestResultsSummary.js":169,"./_VocabularySelectorMap.js":171,"pict-section-form":587}],119:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PLANT-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Plant for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Plant record yet, get it and store it
			if (!this.pict.AppData.SelectedPlant || this.pict.AppData.SelectedPlant.length < 1)
			{
				const tmpResult = await this.pict.providers.PlantProvider.getPlantByID(pValue);
				this.pict.AppData.SelectedPlant = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedPlant?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],120:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PLANT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PLANT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('ProductionPlant',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Plant...',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Plant for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Plant and set it as the selected Plant on the data object
			const tmpPlant = await this.pict.providers.PlantProvider.getPlantByID(pValue);
			this.pict.AppData.SelectedPlant = tmpPlant;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedPlant.IDProductionPlant;
			tmpOption.text = this.pict.AppData.SelectedPlant.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],121:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class PrecompiledFileSelectorInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getToggleInputHTMLID(pInputHTMLID)
	{
		return `#TOGGLE-FOR-${pInputHTMLID}`;
	}

	getHiddenInputHTMLID(pInputHTMLID)
	{
		return `#PREVIOUS-VALUE-${pInputHTMLID}`;
	}

	getDisplayInputHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	getToggleableContainerHTMLID(pInputHTMLID)
	{
		return `#TOGGLE-CONTAINER-FOR-${pInputHTMLID}`;
	}

	getClearButtonHTMLID(pInputHTMLID)
	{
		return `#CLEAR-BUTTON-FOR-${pInputHTMLID}`;
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// get current visible value
		const tmpInputElements = this.pict.ContentAssignment.getElement('#' + pInput.Macro.RawHTMLID);
		if (!Array.isArray(tmpInputElements) || tmpInputElements.length < 1)
		{
			return false;
		}
		const tmpInputElement = tmpInputElements[0];
		if (!(tmpInputElement instanceof HTMLInputElement))
		{
			return false;
		}
		const currentValue = tmpInputElement.value;
		// update hidden input value
		const tmpHiddenElements = this.pict.ContentAssignment.getElement('#' + pInput.Macro.RawHTMLID);
		if (!Array.isArray(tmpHiddenElements) || tmpHiddenElements.length < 1)
		{
			return false;
		}
		const tmpHiddenElement = tmpHiddenElements[0];
		if (!(tmpHiddenElement instanceof HTMLInputElement))
		{
			return false;
		}
		tmpInputElement.value = '0';
		if (parseInt(currentValue) > 0)
		{
			// we don't clear values here, so we can remember the previous value
			tmpHiddenElement.value = currentValue;
		}
		this.handleDisplayInputValue(pInput, currentValue);
		// update the clear button visibility
		this.handleClearButtonVisbility(pInput, currentValue);

		// update visible input value
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the visibility of the clear button based on the input value.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be set.
	 */
	handleClearButtonVisbility(pInput, pValue)
	{
		const tmpClearButtonElements = this.pict.ContentAssignment.getElement(this.getClearButtonHTMLID(pInput.Macro.RawHTMLID));
		if (Array.isArray(tmpClearButtonElements) && tmpClearButtonElements.length > 0)
		{
			const tmpClearButtonElement = tmpClearButtonElements[0];
			if (tmpClearButtonElement instanceof HTMLButtonElement)
			{
				tmpClearButtonElement.style.visibility = pValue && Number(pValue) !== 0 && !isNaN(Number(pValue)) ? 'visible' : 'hidden';
			}
		}
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be set.
	 * @param {boolean} [setInputVisibility=false] - Whether to set the input visibility.
	 */
	async handleInputValue(pInput, pValue, setInputVisibility = false)
	{
		const tmpInputElements = this.pict.ContentAssignment.getElement('#' + pInput.Macro.RawHTMLID);
		if (Array.isArray(tmpInputElements) && tmpInputElements.length > 0)
		{
			const tmpInputElement = tmpInputElements[0];
			if (tmpInputElement instanceof HTMLDivElement)
			{
				if (setInputVisibility)
				{
					this.pict.ContentAssignment.setAttribute(tmpInputElement, 'visibility', 'visible');
				}
				else
				{
					this.pict.ContentAssignment.setAttribute(tmpInputElement, 'visibility', 'hidden');
				}
				// set the input value to the ID
				this.pict.ContentAssignment.assignContent(tmpInputElement, pValue);
			}
		}
	}

	/**
	 * Handles the display of the input value in the Pict provider.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be displayed.
	 * @return {Promise<void>} - A promise that resolves when the display is updated.
	 */
	async handleDisplayInputValue(pInput, pValue)
	{
		const tmpDisplayElements = this.pict.ContentAssignment.getElement(this.getDisplayInputHTMLID(pInput.Macro.RawHTMLID));
		if (Array.isArray(tmpDisplayElements) && tmpDisplayElements.length > 0)
		{
			const tmpDisplayElement = tmpDisplayElements[0];
			if (tmpDisplayElement instanceof HTMLDivElement)
			{
				if (pValue && Number(pValue) !== 0 && !isNaN(Number(pValue)))
				{
					// look up the observation to get the Name and Description
					const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pValue);
					if (tmpObservation)
					{
						const tmpName = tmpObservation.Name || `Unnamed Observation #${pValue}`;
						const tmpDescription = tmpObservation.Description || 'No description available';
						// set the input value to the ID and Name in a predefined format
						const tmpValue = `<span class="tag has-background-text-90 mr-2">#${pValue}</span> <strong class="mr-1">${tmpName}</strong> - <em class="ml-1">${tmpDescription}</em>`;
						this.pict.ContentAssignment.assignContent(tmpDisplayElement, tmpValue);
					}
				}
				else
				{
					this.pict.ContentAssignment.assignContent(tmpDisplayElement, '');
				}
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true);
		this.handleDisplayInputValue(pInput, pValue);
		this.handleClearButtonVisbility(pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true);
		this.handleDisplayInputValue(pInput, pValue);
		this.handleClearButtonVisbility(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputNumericValue = this.pict.ContentAssignment.readContent(pInput.Macro.RawHTMLID);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputNumericValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputNumericValue, pHTMLSelector);
	}
}

module.exports = PrecompiledFileSelectorInputHandler;

},{"pict-section-form":587}],122:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCER-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Producer for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Producer record yet, get it and store it
			if (!this.pict.AppData.SelectedProducer || this.pict.AppData.SelectedProducer.length < 1)
			{
				const tmpResult = await this.pict.providers.ProducerProvider.getProducerByID(pValue);
				this.pict.AppData.SelectedProducer = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedProducer?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],123:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCER-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCER-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Organization',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Producer...',
					GetRecordName: (pOrg) => `${pOrg.Name || ('Unnamed Producer #' + pOrg.IDOrganization)}`,
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Producer for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Producer and set it as the selected Producer on the data object
			const tmpProducer = await this.pict.providers.ProducerProvider.getProducerByID(pValue);
			this.pict.AppData.SelectedProducer = tmpProducer;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedProducer.IDOrganization;
			tmpOption.text = this.pict.AppData.SelectedProducer.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],124:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCT-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Product for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Product record yet, get it and store it
			if (!this.pict.AppData.SelectedProduct || this.pict.AppData.SelectedProduct.length < 1)
			{
				const tmpResult = await this.pict.providers.ProductProvider.getProductByID(pValue);
				this.pict.AppData.SelectedProduct = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedProduct?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],125:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PRODUCT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PRODUCT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Product',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Product...',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Product for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Product and set it as the selected Product on the data object
			const tmpProduct = await this.pict.providers.ProductProvider.getProductByID(pValue);
			this.pict.AppData.SelectedProduct = tmpProduct;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedProduct.IDProduct;
			tmpOption.text = this.pict.AppData.SelectedProduct.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],126:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PROJECT-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Project for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Project record yet, get it and store it
			if (!this.pict.AppData.SelectedProject || this.pict.AppData.SelectedProject.length < 1)
			{
				const tmpResult = await this.pict.providers.ProjectProvider.getProjectByID(pValue);
				this.pict.AppData.SelectedProject = tmpResult;
			}
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, this.pict.AppData?.SelectedProject?.Name);
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],127:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#PROJECT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#PROJECT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 *
	 * @param {object} pInput - The input object.
	 * @param {number} [pRowIndex] - The row index for tabular data (optional).
	 */
	addLoadingSkeleton(pInput, pRowIndex)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		if (pRowIndex != null)
		{
			this.pict.ContentAssignment.getElement(this.getTabularSelectInputID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
			this.pict.ContentAssignment.addClass(this.getTabularSelectInputID(pInput.Macro.RawHTMLID), 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
			this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
		}
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Project',
				{
					Input: pInput,
					SearchFallbackPlaceholder: 'Select a Project...',
					Disabled: pInput.PictForm.Disabled || false,
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
					GetPinnedItem: () =>
					{
						const tmpMyProject = this.pict.AppData?.DocumentData?.ReportData?.Project?.IDProject;
						if (!tmpMyProject)
						{
							return null;
						}
						const pinnedItem =
						{
							id: tmpMyProject,
							text: window._Pict.AppData?.DocumentData?.ReportData?.Project?.Name || ('Unnamed Project #' + tmpMyProject),
						};
						return pinnedItem;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.Default == null)
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.Project?.IDProject;
			if (tmpProjectID != null)
			{
				pInput.Default = String(tmpProjectID);
			}
		}
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm && pInput.Default == null)
		{
			const tmpProjectID = this.pict.AppData?.DocumentData?.ReportData?.Project?.IDProject;
			if (tmpProjectID)
			{
				pInput.Default = String(tmpProjectID);
			}
		}
		this.addLoadingSkeleton(pInput, pRowIndex);
		// initialize the select2 plugin
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Project for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Project and set it as the selected Project on the data object
			const tmpProject = await this.pict.providers.ProjectProvider.getProjectByID(pValue);
			this.pict.AppData.SelectedProject = tmpProject;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedProject.IDProject;
			tmpOption.text = this.pict.AppData.SelectedProject.Name;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],128:[function(require,module,exports){
// Headlight `RichText` input provider — the markdown editor from pict-section-form (edit mode) paired
// with rendered-markdown view mode, wrapped with the shared inline View/Edit presentation
// behavior (see EditorBase). PSF does not auto-register this provider (its editor dep is an opt-in), so
// the Headlight bundle registers it under the hash `Pict-Input-RichText` that the templates'
// DefaultInputExtensions reference.
const RichTextInput = require('pict-section-form').RichTextInput;
const { buildEditorInputProvider } = require('./PictProvider-InputType-EditorBase.js');
const libUserMarkdown = require('./_UserMarkdown.js');
const libTestResultsSummary = require('./_TestResultsSummary.js');

// The markdown editor builds its CodeMirror surface from `window.CodeMirrorModules` and has no loader
// of its own — without it it renders an EMPTY slot and throws nothing, which reads as "there is no way
// to edit". The bundle is ~1.1MB, so rather than script-tag it into every document we fetch it on the
// first edit (the same lazy shape the Diagram editor uses). Override the URL per app via provider
// options; set it to null to opt out entirely when a host already loads CodeMirror.
const _DEFAULT_CODEMIRROR_URL = './codemirror-bundle.js';

/** The markdown editor's CodeMirror globals are set by the vendor bundle, so they are not on the Window type. */
const _codeMirrorLoaded = () => !!(/** @type {any} */ (globalThis).CodeMirrorModules);

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Input-RichText',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Join the app save-data lifecycle so EditorBase.onBeforeSaveDataAsync fires — it flushes an editor
	// left open at save time into FormData (the per-keystroke marshal is deferred to View, so without
	// this a Save-while-editing would persist the pre-edit value). NOT a framework default.
	AutoSaveDataWithApp: true,

	CodeMirrorVendorURL: _DEFAULT_CODEMIRROR_URL,
};

const EditorProviderBase = buildEditorInputProvider(RichTextInput, _DEFAULT_CONFIGURATION);

class PictProviderInputTypeRichText extends EditorProviderBase
{
	/**
	 * A RichText value is text a user typed (a test remark), so its View / Read / Print rendering goes
	 * through the hardened renderer, the same one LIMS and the sample panel use. PSF's own uses a plain
	 * `marked.parse`, which puts typed HTML (an `onerror` attribute, a `javascript:` link) into the
	 * page of whoever reads the remark.
	 *
	 * @param {string} pMarkdown - the stored remark.
	 * @return {string} - the rendered HTML.
	 */
	_renderMarkdown(pMarkdown)
	{
		return libUserMarkdown.renderUserMarkdown(pMarkdown, this.log);
	}

	/**
	 * The markdown editor's live preview re-renders the typed text on every keystroke through
	 * pict-section-content, which has no way to escape HTML -- so a remark carrying an `onerror`
	 * attribute ran in the browser of whoever opened it for editing. The preview is off; the View
	 * toggle shows the formatted remark through the hardened renderer above.
	 *
	 * @param {Object} pInput @param {any} pValue @param {Object} pInst
	 * @return {Object} - the markdown editor's view options.
	 */
	_buildEditorOptions(pInput, pValue, pInst)
	{
		return Object.assign(super._buildEditorOptions(pInput, pValue, pInst), { EnableRichPreview: false });
	}

	/**
	 * PSF records every keystroke's content as the instance's `lastValue`, so it is the remark as typed
	 * even after a whole-form marshal has reset the hidden input. See EditorBase._reassertHiddenInputValue.
	 *
	 * @param {Record<string, any>} pInstance
	 * @return {string|undefined}
	 */
	_getOpenEditorValue(pInstance)
	{
		return (pInstance && (typeof pInstance.lastValue === 'string')) ? pInstance.lastValue : undefined;
	}

	/**
	 * Belt-and-braces content seed for the mounted editor.
	 *
	 * PSF's own hand-off (stash the content in AppData, pass the address as `ContentDataAddress`) does
	 * work — verified live: the address resolves and carries the right content. But it only takes
	 * effect if the editor actually built a segment editor, which requires CodeMirror to be on the
	 * page (`window.CodeMirrorModules`). Writing segment 0 directly after render costs nothing and
	 * makes the content independent of that indirection.
	 *
	 * NOTE: this does NOT rescue a missing CodeMirror — with no segment editors the editor renders an
	 * empty slot and this no-ops (setSegmentContent warns "index out of range"). Serving the CodeMirror
	 * bundle is the actual requirement; see the report definition's index.html.
	 *
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {Function} fCallback
	 */
	/**
	 * Resolve `window.CodeMirrorModules`, fetching the vendor bundle once if the host has not already
	 * loaded it. The promise is cached so N fields on a page share a single fetch.
	 * @return {Promise<void>}
	 */
	_ensureCodeMirror()
	{
		if ((typeof window === 'undefined') || _codeMirrorLoaded())
		{
			return Promise.resolve();
		}
		if (this._codeMirrorLoadPromise)
		{
			return this._codeMirrorLoadPromise;
		}
		const tmpURL = (this.options && ('CodeMirrorVendorURL' in this.options)) ?
			this.options.CodeMirrorVendorURL : _DEFAULT_CODEMIRROR_URL;
		if (!tmpURL)
		{
			return Promise.resolve();
		}
		this._codeMirrorLoadPromise = new Promise((fResolve) =>
		{
			const tmpScript = document.createElement('script');
			tmpScript.src = tmpURL;
			tmpScript.async = true;
			// Resolve either way — a failed load leaves the editor empty, which the caller already
			// handles, and blocking the mount on a vendor fetch would be worse.
			tmpScript.onload = () => fResolve();
			tmpScript.onerror = () =>
			{
				if (this.log)
				{
					this.log.error(`[Pict-Input-RichText] CodeMirror bundle failed to load from ${tmpURL} — the editor will render empty.`);
				}
				fResolve();
			};
			document.head.appendChild(tmpScript);
		});
		return this._codeMirrorLoadPromise;
	}

	/**
	 * Warm the CodeMirror bundle in the BACKGROUND as soon as a field initializes, so the first click on
	 * Edit does not block on a cold ~1.1MB fetch (the "significant delay on a clean form" — once cached,
	 * later edits are instant, which is why it was not reproducible after the first). The fetch is
	 * promise-cached in `_ensureCodeMirror`, so N fields share one load and this is safe to call per
	 * field. Scheduled on idle (falling back to a short timeout) so it never competes with first paint.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if ((typeof window !== 'undefined') && !_codeMirrorLoaded())
		{
			const tmpWarm = () =>
			{
				// Fire-and-forget; a failed fetch is already handled where the editor mounts.
				this._ensureCodeMirror();
			};
			if (typeof window.requestIdleCallback === 'function')
			{
				window.requestIdleCallback(tmpWarm, { timeout: 2000 });
			}
			else
			{
				setTimeout(tmpWarm, 0);
			}
		}
		return tmpResult;
	}

	/**
	 * An empty TEST remark prints nothing, rather than an "(empty)" box. Hidden only in Print (the
	 * editor container carries `pict-editor-print` there — on screen the empty state is a hint to add
	 * remarks instead), only when empty, and only for a remarks field attached to a test acceptance
	 * input, so every other RichText field keeps its own empty state in the PDF.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._syncEmptyTestRemarkInPrint(pInput, pValue);
		return tmpResult;
	}

	/** A test remark edit redraws the test results summary, which shows the remark beside the result. */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (this._isTestRemarksField(pInput))
		{
			libTestResultsSummary.requestSummaryRefresh(this.pict, pView);
		}
		return tmpResult;
	}

	/** @param {Object} pInput @param {any} pValue */
	_syncEmptyTestRemarkInPrint(pInput, pValue)
	{
		if ((typeof document === 'undefined') || !pInput || !pInput.Macro)
		{
			return;
		}
		const tmpEditor = document.getElementById(`PICT-EDITOR-FOR-${pInput.Macro.RawHTMLID}`);
		if (!tmpEditor || !tmpEditor.classList.contains('pict-editor-print') || !this._isTestRemarksField(pInput))
		{
			return;
		}
		// Same emptiness rule PSF uses to decide on its "(empty)" placeholder.
		const tmpContent = this._resolveContent(pInput, pValue);
		const tmpEmpty = !tmpContent || (String(tmpContent).trim().length < 1);
		const tmpColumn = tmpEditor.closest('.column');
		if (tmpColumn)
		{
			tmpColumn.classList.toggle('is-hidden', tmpEmpty);
		}
	}

	/**
	 * A test remarks field shares its group with a SampleTestAcceptance input. That group only ever holds
	 * the test's hidden selector, its result and its remarks, so this is exact — and it survives a
	 * container form's hash salting, because the pair's group is salted together.
	 * @param {Object} pInput @return {boolean}
	 */
	_isTestRemarksField(pInput)
	{
		const tmpGroup = pInput && pInput.PictForm && pInput.PictForm.Group;
		const tmpManifest = this.pict.views.PictFormMetacontroller && this.pict.views.PictFormMetacontroller.manifestDescription;
		if (!tmpGroup || !tmpManifest || !tmpManifest.Descriptors)
		{
			return false;
		}
		return Object.values(tmpManifest.Descriptors).some((pDescriptor) =>
			((pDescriptor.PictForm || {}).Group === tmpGroup) && ((pDescriptor.PictForm || {}).InputType === 'SampleTestAcceptance'));
	}

	_mountEdit(pView, pInput, pValue, fCallback)
	{
		// CodeMirror must be present BEFORE the editor renders — it reads window.CodeMirrorModules
		// while building its segments, and silently produces nothing when they are missing. The warm-up
		// in onInputInitialize usually has it ready by now; this awaits it only if not.
		if ((typeof window !== 'undefined') && !_codeMirrorLoaded())
		{
			this._ensureCodeMirror().then(() => this._doMountEdit(pView, pInput, pValue, fCallback));
			return;
		}
		return this._doMountEdit(pView, pInput, pValue, fCallback);
	}

	/**
	 * Focus the first markdown segment with the caret at the end of the existing remark.
	 * @param {string} pRawHTMLID
	 */
	_focusEditor(pRawHTMLID)
	{
		const tmpEditorViewClass = _codeMirrorLoaded() ? /** @type {any} */ (globalThis).CodeMirrorModules.EditorView : null;
		const tmpContainer = document.getElementById(this.getEditorContainerID(pRawHTMLID));
		const tmpContent = tmpContainer ? tmpContainer.querySelector('.cm-content') : null;
		const tmpEditorView = (tmpEditorViewClass && tmpContent) ? tmpEditorViewClass.findFromDOM(tmpContent) : null;
		if (!tmpEditorView)
		{
			return;
		}
		tmpEditorView.focus();
		tmpEditorView.dispatch({ selection: { anchor: tmpEditorView.state.doc.length }, scrollIntoView: true });
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {Function} fCallback
	 */
	_doMountEdit(pView, pInput, pValue, fCallback)
	{
		const tmpContent = this._resolveContent(pInput, pValue);
		return super._mountEdit(pView, pInput, pValue, (pError) =>
		{
			if (!pError && tmpContent)
			{
				try
				{
					const tmpInstance = this._instances[pInput.Hash];
					const tmpEditorView = tmpInstance && tmpInstance.viewInstance;
					if (tmpEditorView && (typeof tmpEditorView.setSegmentContent === 'function'))
					{
						tmpEditorView.setSegmentContent(0, tmpContent);
					}
				}
				catch (pSeedError)
				{
					if (this.log)
					{
						this.log.warn('[Pict-Input-RichText] could not seed editor content',
							{ error: pSeedError.message, inputHash: pInput && pInput.Hash });
					}
				}
			}
			if (typeof fCallback === 'function')
			{
				fCallback(pError);
			}
		});
	}
}

module.exports = PictProviderInputTypeRichText;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-EditorBase.js":71,"./_TestResultsSummary.js":169,"./_UserMarkdown.js":170,"pict-section-form":587}],129:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity selector does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Build the display template for the selected value.
	 * @param {string} pTagType The tag type.
	 * @return {string} The display template.
	 */
	buildSelectedDisplayTemplate(pTagType)
	{
		let tmpDisplayTemplate = '';
		// for selection that are a mix of ID and Name, we need to display both with a template
		if (pTagType === 'DIV')
		{
			tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
				this.pict.AppData.SelectedSample.QRCode || 'N/A',
				this.pict.AppData.SelectedSample.Name || ('Unnamed Sample #' + this.pict.AppData.SelectedSample.IDSample),
			);
		}
		else
		{
			tmpDisplayTemplate = this.pict.AppData.SelectedSample.Name || ('Unnamed Sample #' + this.pict.AppData.SelectedSample.IDSample);
		}
		return tmpDisplayTemplate;
	}

	/**
	 * Build the QR Code Image and prepend it to the input element.
	 * @param {HTMLSelectElement} tmpInputSelectElement The input element.
	 */
	buildPrependedQRCodeImage(tmpInputSelectElement)
	{
		if (this.pict.AppData.SelectedSample)
		{
			const tmpCanvas = this.pict.providers.QRCodeProvider.create(this.pict.AppData.SelectedSample.QRCode);
			const tmpElement = `<figure class="image mr-2 is-64x64"><img src="${tmpCanvas}" alt="QR Code" /></figure>`;
			// find the parent .column element
			const tmpParentElement = tmpInputSelectElement.closest('.column');
			if (tmpParentElement)
			{
				// prepend the QR Code Image
				tmpParentElement.insertAdjacentHTML('afterbegin', tmpElement);
				tmpParentElement.classList.add('is-flex');
				tmpParentElement.classList.add('is-align-items-center');
			}
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		let tmpDisplayTemplate = '';
		// if we have a value (ID), go fetch the Sample for display (Name, etc.)
		if (pValue)
		{
			// if we don't have the Sample record yet, get it and store it
			if (!this.pict.AppData.SelectedSample)
			{
				const tmpResult = await this.pict.providers.SampleProvider.getSampleByID(pValue);
				this.pict.AppData.SelectedSample = tmpResult;
			}
			// build the display template based on the HTML Tag Type
			tmpDisplayTemplate = this.buildSelectedDisplayTemplate(tmpInputSelectElement.tagName);
			// for PDF view, we want to prepend the QRCode Image to the display, if we have one
			this.buildPrependedQRCodeImage(tmpInputSelectElement);
		}
		this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],130:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @typedef {import('./PictProvider-Select2Util.js')} Select2UtilProvider */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

// NOTE: This entity display does not support Tabular Data at this time.
class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/** @return {Select2UtilProvider} */
	get Select2Util()
	{
		return this.pict.providers.Select2Util;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} pInput The input object.
	 */
	addLoadingSkeleton(pInput)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${pInput.Macro.RawHTMLID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} pInput The input object.
	 */
	removeLoadingSkeleton(pInput)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${pInput.Macro.RawHTMLID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), 'is-hidden');
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 */
	initializeSelect2(pInput)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.Select2Util.getOptionsAjax('Sample',
				{
					Input: pInput,
					SearchFields: [ 'Name', 'QRCode' ],
					SearchFallbackPlaceholder: 'Select a Sample by name or code...',
					Disabled: pInput.PictForm.Disabled || false,
					GetRecordUserFacingID: (pSample) => pSample.QRCode || 'N/A',
					HandleSearchFilters: (pFilters) =>
					{
						// always ensure we have a sort by Name ascending
						if (!pFilters.length || !pFilters.includes('FSF'))
						{
							pFilters.push('FSF~Name~ASC~0');
						}
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).data('select2'))
			{
				// TODO: Remove me later, this is a temp log for debugging
				window['jQuery'](this.getSelectInputHTMLID(pInput.Macro.RawHTMLID)).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.addLoadingSkeleton(pInput);
		// initialize the select2 plugin
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		// if we have a value (ID), go fetch the Sample for display (Name, etc.)
		if (pValue)
		{
			// get the value of the selected Sample and set it as the selected Sample on the data object
			const tmpSample = await this.pict.providers.SampleProvider.getSampleByID(pValue);
			this.pict.AppData.SelectedSample = tmpSample;
			// build the prefilled value for the select2 dropdown
			const tmpOption = document.createElement('option');
			const tmpSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID))[0];
			tmpOption.value = this.pict.AppData.SelectedSample.IDSample;
			tmpOption.text = `${this.pict.AppData.SelectedSample.QRCode || 'N/A'}|~|${this.pict.AppData.SelectedSample.Name || ('Unnamed Sample #' + this.pict.AppData.SelectedSample.IDSample)}`;
			tmpOption.selected = true;
			tmpSelectElement.appendChild(tmpOption);
		}
		this.removeLoadingSkeleton(pInput);
		this.initializeSelect2(pInput);
		// set the Sample selection callback for the Sample Search Panel
		this.pict.views.HeadlightPaneSamples.setSampleSelectionCallback((pSample) =>
		{
			this.pict.log.info('Sample selected:', pSample.IDSample);
			this.pict.log.info('Assigning Sample to the following input element:', pInput.Macro.RawHTMLID);
			this.pict.AppData.SelectedSample = pSample;
			// NOTE: ContentAssignment is failing to set this value for some reason, should investigate later
			document.getElementById(pInput.Macro.RawHTMLID)['value'] = pSample.IDSample;
			document.getElementById(pInput.Macro.RawHTMLID).dispatchEvent(new Event('change'));
		});
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Refresh spec-year scope when the user picks a different sample. The
	 * picker stores the IDSample value (numeric); the resolver fetches the
	 * sample by ID and walks Sample → Project to seed the scope. Resolver
	 * dedupes when the project hasn't changed and fails open on bare
	 * contracts / empty stub sets.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.providers.SpecScopeResolver?.loadForSampleByIdentifier?.(pValue, 'IDSample');
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],131:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerProvider = require('./PictProvider-InputType-Picker.js');

const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');
const libSampleStatusRollup = require('./_SampleStatusRollup.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'SampleStatusPicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * Sample-status picker — the Picker-stack port of the legacy SampleStatusSelector (a Select-family
 * subclass; this class mirrors it 1:1 for diff-review).
 *
 * The vocabulary comes from the customer-managed `SampleStatus` table through the base broker's
 * vocabulary source (`_VocabularySelectorMap`), which commits the status CODE — what `Sample.Status`
 * stores — and falls back to a built-in list for a customer with no rows. On top of that this class
 * carries the legacy provider's cross-widget behavior: it derives a new sample status from the test
 * results reported on the event bus, seeds from a linked sample's status, and announces its own
 * changes as `SampleStatusChanged`.
 *
 * Tracking GUIDs use the SAME `MATERIALS-ENTITY-TRACKING-GUID-…` element ids as the legacy templates,
 * so a migrated field still binds to a still-legacy sibling Sample selector during a phased rollout.
 */
class PictProviderInputTypeSampleStatusPicker extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	getTrackingGUIDID(pInputHTMLID, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}`;
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {string} pEvent @param {string} pTransactionGUID @return {boolean}
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number} pRowIndex @param {string} pEvent @param {string} pTransactionGUID @return {boolean}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		// The test-result event is bound to the TEST, so its tracking GUID cannot be validated against
		// the sample's here — the aggregate it triggers below is what carries the sample's GUID.
		if (tmpEventType === 'TestResultChanged')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
			{
				if (pInput.PictForm.Disabled !== true)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), '__TestResultAggregate', []);
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestStatusAggregate:${this._getTrackingGUID(pInput, pRowIndex)}:__TestResultAggregate`);
				}
			});
		}

		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (tmpEventType === 'TestStatusAggregate')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			const tmpStatusGroup = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (!Array.isArray(tmpStatusGroup))
			{
				return;
			}
			const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pInput, pRowIndex));
			const tmpNewStatus = this._computeNewSampleStatusFromTestResults(tmpStatusGroup, tmpCurrentStatus, pInput);
			if (tmpNewStatus)
			{
				this._setValueAndCommit(pView, pInput, tmpNewStatus, pRowIndex);
			}
			return;
		}
		if (tmpEventType === 'SampleChanged')
		{
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (tmpSampleRecord && typeof tmpSampleRecord === 'object' && !Array.isArray(tmpSampleRecord) && tmpSampleRecord.Status)
			{
				const tmpValueAddress = this._getValueAddress(pInput, pRowIndex);
				const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpValueAddress);
				const tmpPickedStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), libSampleStatusRollup.getPickedStatusAddress(tmpValueAddress));
				if (tmpCurrentStatus !== tmpSampleRecord.Status && !libSampleStatusRollup.keepsFieldStatusOnSampleLoad(tmpCurrentStatus, pInput.PictForm?.KeepSavedStatuses, tmpPickedStatus))
				{
					this._setValueAndCommit(pView, pInput, tmpSampleRecord.Status, pRowIndex);
				}
			}
			return;
		}
	}

	/**
	 * The marshal-relative address this field's status code lives at.
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string}
	 */
	_getValueAddress(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.DataAddress;
	}

	/**
	 * The shared roll-up (`_SampleStatusRollup.js`), with this field's `PictForm.UnfinishedTestResults`.
	 * @param {Array<string>} pTestResultsArray @param {string} pSampleStatus @param {Record<string, any>} [pInput]
	 * @return {string | null}
	 */
	_computeNewSampleStatusFromTestResults(pTestResultsArray, pSampleStatus, pInput)
	{
		const tmpNewSampleStatus = libSampleStatusRollup.computeSampleStatusFromTestResults(pTestResultsArray, pSampleStatus, { UnfinishedTestResults: pInput && pInput.PictForm && pInput.PictForm.UnfinishedTestResults });
		if (tmpNewSampleStatus)
		{
			this.pict.log.info(`SampleStatusPicker: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
		}
		return tmpNewSampleStatus;
	}

	/**
	 * A person picked a status (the picker's OnChange): record it beside the value so a later sample load keeps it.
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 */
	_commit(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpResult = super._commit(pView, pInput, pValue, pHTMLSelector);
		this._recordPickedStatus(pView, this._getValueAddress(pInput, null));
		return tmpResult;
	}

	/**
	 * A person picked a status in a tabular row: record it beside the row's value.
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHiddenID @param {number} pRowIndex
	 */
	_commitTabular(pView, pInput, pValue, pHiddenID, pRowIndex)
	{
		const tmpResult = super._commitTabular(pView, pInput, pValue, pHiddenID, pRowIndex);
		this._recordPickedStatus(pView, this._getValueAddress(pInput, pRowIndex));
		return tmpResult;
	}

	/** @param {Object} pView @param {string} pValueAddress */
	_recordPickedStatus(pView, pValueAddress)
	{
		const tmpData = pView.getMarshalDestinationObject();
		this.pict.manifest.setValueAtAddress(tmpData, libSampleStatusRollup.getPickedStatusAddress(pValueAddress), this.pict.manifest.getValueAtAddress(tmpData, pValueAddress));
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
		}
		return tmpResult;
	}

	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpResult = super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
		}
		return tmpResult;
	}

	/** @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string} */
	_getTrackingGUID(pInput, pRowIndex)
	{
		if (pRowIndex == null && pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			return pInput.PictForm.SampleTrackingGUID;
		}
		return /** @type {string} */ (this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex)));
	}

	/** @param {Object} pInput @param {number|string|null} pRowIndex @param {string} pTrackingGUID */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex), pTrackingGUID);
	}

	/**
	 * Inherit the tracking GUID of the sample descriptor this status belongs to, so the sample's
	 * events reach this field. Searches the row's own group first (tabular), then the global manifest.
	 *
	 * @param {Object} pView @param {Object} pGroup @param {Object} pInput @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (pRowIndex != null)
		{
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.pict.log.error('SampleStatusPicker: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.pict.log.error('SampleStatusPicker: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.pict.log.warn('SampleStatusPicker: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = PictProviderInputTypeSampleStatusPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-Picker.js":117,"./_SampleStatusRollup.js":161,"./_VocabularySelectorMap.js":171}],132:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const SelectInputTypeProvider = require('./PictProvider-InputType-Select.js');

const libVocabularySelectorMap = require('./_VocabularySelectorMap.js');
const libSampleStatusRollup = require('./_SampleStatusRollup.js');

const DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS = libVocabularySelectorMap.DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS;

/**
 * Sample-status selector. The vocabulary lives in the customer-managed `SampleStatus` table and is
 * resolved through the Select base class's entity-backed option source (Hash -> the code stored in
 * `Sample.Status`, Name -> the label, ordered by Ordinal). A customer with no SampleStatus rows falls
 * back to DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS, so the input works before any list is curated.
 */
class SampleStatusSelectorInputType extends SelectInputTypeProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Point the input at the managed SampleStatus vocabulary and install the fallback list. A schema
	 * that carries its own SelectOptions / SelectOptionsEntity keeps them.
	 *
	 * @param {Object} pInput - The input object.
	 */
	_applySampleStatusOptionSource(pInput)
	{
		libVocabularySelectorMap.applyVocabularySource(pInput, 'SampleStatusSelector');
	}

	/**
	 * The option list this input is actually rendering - the managed vocabulary once it has loaded,
	 * otherwise the fallback. Used to label the non-interactive Read / PDF nodes.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {Function} [fOnLoaded] - Invoked once if the vocabulary is still loading, so the caller can repaint.
	 * @return {Array<{id: any, text: string}>} - The resolved option list.
	 */
	_getResolvedStatusOptions(pInput, fOnLoaded)
	{
		const tmpEntityOptions = this.resolveEntitySelectOptions(pInput, fOnLoaded);
		if (Array.isArray(tmpEntityOptions) && tmpEntityOptions.length > 0)
		{
			return tmpEntityOptions;
		}
		return (Array.isArray(pInput?.PictForm?.SelectOptions) && pInput.PictForm.SelectOptions.length > 0) ?
			pInput.PictForm.SelectOptions :
			DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-STATUS-SELECT-FOR-${pInputHTMLID}`;
	}

	getDisplayInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-STATUS-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-STATUS-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-STATUS-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-STATUS-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTrackingGUIDID(pInputHTMLID, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		//TODO: are there cases where we want to auto-set this based on test results? Probably based on a config flag, and only if there isn't an existing value set.
		//      Maybe put a refresh button??? Or hash things and check for the hash changing? Think about it
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		//TODO: are there cases where we want to auto-set this based on test results? Probably based on a config flag, and only if there isn't an existing value set.
		//      Maybe put a refresh button??? Or hash things and check for the hash changing? Think about it
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		//TODO: since the test reult event is bound to the test, we can't validate its tracking GUID against the sample's tracking GUID here
		//      do we want to daisy-chain this event through thest to pick up the sample tracking GUID?
		if (tmpEventType === 'TestResultChanged')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
			{
				if (pInput.PictForm.Disabled !== true)
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), '__TestResultAggregate', []);
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestStatusAggregate:${this._getTrackingGUID(pInput, pRowIndex)}:__TestResultAggregate`);
				}
			});
		}

		if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (tmpEventType === 'TestStatusAggregate')
		{
			if (pInput.PictForm?.AutoUpdate === false || pInput.PictForm?.AutoUpdate === 'false')
			{
				return;
			}
			const tmpStatusGroupAddress = tmpEventPayload;
			const tmpStatusGroup = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpStatusGroupAddress);
			if (!Array.isArray(tmpStatusGroup))
			{
				return;
			}
			let tmpAddress;
			if (pRowIndex != null)
			{
				tmpAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			else
			{
				tmpAddress = pInput.DataAddress;
			}
			const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress);
			const tmpNewStatus = this._computeNewSampleStatusFromTestResults(tmpStatusGroup, tmpCurrentStatus, pInput);
			if (tmpNewStatus)
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress, tmpNewStatus);
				pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
				pView.dataChanged(pInput.Hash);
			}
			return;
		}
		if (tmpEventType === 'SampleChanged')
		{
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (tmpSampleRecord && typeof tmpSampleRecord === 'object' && !Array.isArray(tmpSampleRecord) && tmpSampleRecord.Status)
			{
				let tmpAddress;
				if (pRowIndex != null)
				{
					tmpAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
				}
				else
				{
					tmpAddress = pInput.DataAddress;
				}
				const tmpCurrentStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress);
				const tmpPickedStatus = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), libSampleStatusRollup.getPickedStatusAddress(tmpAddress));
				if (tmpCurrentStatus !== tmpSampleRecord.Status && !libSampleStatusRollup.keepsFieldStatusOnSampleLoad(tmpCurrentStatus, pInput.PictForm?.KeepSavedStatuses, tmpPickedStatus))
				{
					this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpAddress, tmpSampleRecord.Status);
					pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
				}
			}
			return;
		}
	}

	/**
	 * The shared roll-up (`_SampleStatusRollup.js`), with this field's `PictForm.UnfinishedTestResults`.
	 * @param {Array<string>} pTestResultsArray @param {string} pSampleStatus @param {Record<string, any>} [pInput]
	 * @return {string | null}
	 */
	_computeNewSampleStatusFromTestResults(pTestResultsArray, pSampleStatus, pInput)
	{
		const tmpNewSampleStatus = libSampleStatusRollup.computeSampleStatusFromTestResults(pTestResultsArray, pSampleStatus, { UnfinishedTestResults: pInput && pInput.PictForm && pInput.PictForm.UnfinishedTestResults });
		if (tmpNewSampleStatus)
		{
			this.pict.log.info(`SampleStatusSelector: updating sample status to ${tmpNewSampleStatus} based on test results.`, { pTestResultsArray, pSampleStatus });
		}
		return tmpNewSampleStatus;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// for PDF and locked/read-only views, we need to set the display text as well
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			const tmpPrintSelector = this.getDisplayInputHTMLID(pInput.Macro.RawHTMLID);
			const fRepaint = () => this.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
			const tmpOption = this._getResolvedStatusOptions(pInput, fRepaint).find((pOption) => pOption.id === pValue);
			const tmpDisplayText = tmpOption ? tmpOption.text : pValue;
			this.pict.ContentAssignment.assignContent(tmpPrintSelector, tmpDisplayText);
		}
		return tmpResult;
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applySampleStatusOptionSource(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		//TODO: plumb the test result into the configured address
		// for PDF and locked/read-only views, we need to set the display text as well
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			const tmpPrintSelector = this.getTabularDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex);
			const fRepaint = () => this.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
			const tmpOption = this._getResolvedStatusOptions(pInput, fRepaint).find((pOption) => pOption.id === pValue);
			const tmpDisplayText = tmpOption ? tmpOption.text : pValue;
			this.pict.ContentAssignment.assignContent(tmpPrintSelector, tmpDisplayText);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * A person picked a status in the select: record it beside the value so a later sample load keeps it.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the super method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpResult = super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
		this._recordPickedStatus(pView, pInput.DataAddress);
		return tmpResult;
	}

	/**
	 * A person picked a status in a tabular select: record it beside the row's value.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the super method.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpResult = super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
		this._recordPickedStatus(pView, pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress));
		return tmpResult;
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {string} pValueAddress - The field's marshal-relative value address.
	 */
	_recordPickedStatus(pView, pValueAddress)
	{
		const tmpData = pView.getMarshalDestinationObject();
		this.pict.manifest.setValueAtAddress(tmpData, libSampleStatusRollup.getPickedStatusAddress(pValueAddress), this.pict.manifest.getValueAtAddress(tmpData, pValueAddress));
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
		}
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm?.EmitStatusChange !== false)
		{
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`SampleStatusChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
		}
	}

	_getTrackingGUID(pInput, pRowIndex)
	{
		if (pRowIndex == null && pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			return pInput.PictForm.SampleTrackingGUID;
		}
		return this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex));
	}

	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex), pTrackingGUID);
	}

	/**
	 * Searches for the sample descriptor that this test result should be bound to and inherits its tracking GUID if needed.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		// modalities:
		//
		// single global sample
		// tabular row-based tests
		// tabular row-based sample and tests

		if (pRowIndex != null)
		{
			// tabular
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('SampleStatusSelector: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		// check sibling Descriptors for a sample descriptor
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('SampleStatusSelector: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.SampleTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, null);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('SampleStatusSelector: could not find sibling sample descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = SampleStatusSelectorInputType;

module.exports.DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS = DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS;

},{"./PictProvider-InputType-Select.js":137,"./_SampleStatusRollup.js":161,"./_VocabularySelectorMap.js":171}],133:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerProvider = require('./PictProvider-InputType-Picker.js');

const libTestResultOptions = require('./_TestResultOptions.js');
const libTestResultsSummary = require('./_TestResultsSummary.js');

/** Length of the longest shared trailing run of two strings. */
const commonSuffixLength = (pLeft, pRight) =>
{
	let tmpCount = 0;
	while (tmpCount < pLeft.length && tmpCount < pRight.length &&
		pLeft[pLeft.length - 1 - tmpCount] === pRight[pRight.length - 1 - tmpCount])
	{
		tmpCount++;
	}
	return tmpCount;
};

/**
 * The result control is deliberately partial-width: a full-bleed control reads as its own region, which
 * is the confusion this input exists to remove. `min-width: 0` keeps the picker from forcing the flex
 * row wider than its column.
 *
 * The remarks field is a SEPARATE descriptor rendering its own column below this one, so by default the
 * two stack with ~90px between the picker and the editor. The `test-acceptance-*` rules close that gap
 * and lift the editor's View/Edit switch into the result row, right-aligned: the editor is positioned,
 * and its switch is taken out of flow with `bottom: 100%` so it lands in the space just above — the
 * result row, once the padding between the two columns is removed.
 *
 * The empty-state hint replaces pict-section-form's hardcoded "(empty)" (RichText `_mountView`, no config
 * hook). It is CSS rather than a DOM swap because PSF re-renders the view on every View/Edit switch, which
 * would overwrite injected text; `::before` survives that. Scoped to test remarks, so other RichText
 * fields and the Print theme keep their own empty state.
 */
const _TEST_ACCEPTANCE_CSS = /*css*/`
.test-acceptance-result { flex: 0 1 22rem; min-width: 0; }
.test-acceptance-remarks-toggle { white-space: nowrap; }
.test-acceptance-column { padding-bottom: 0; }
.test-acceptance-remarks { padding-top: 0; }
.test-acceptance-remarks .pict-editor { position: relative; padding-top: 0.5rem; }
.test-acceptance-remarks .pict-editor-controls { position: absolute; right: 0; bottom: 100%; margin-bottom: 0.25rem; }
.test-acceptance-remarks .pict-section-form-richtext-view.is-empty { font-size: 0; }
.test-acceptance-remarks .pict-section-form-richtext-view.is-empty::before { content: "No remarks yet — choose Edit to add notes. Markdown formatting such as bold, lists and links is supported."; font-size: 0.95rem; line-height: 1.55; }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'SampleTestAcceptance',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
	// Join the save-data lifecycle so onBeforeSaveDataAsync fires (MarkNewTestsInProgress).
	AutoSaveDataWithApp: true,
};

/**
 * Unified test acceptance input — the Picker-stack port of the legacy SampleTestResult (a Select-family
 * subclass; this class mirrors it 1:1 for diff-review) plus the remarks disclosure.
 *
 * The test result and its remark render as one control at the end of the test's own section instead of
 * an appended "Test Results" section. The remark itself stays a sibling `RichText` descriptor — the
 * markdown editor owns its own descriptor identity — and this provider owns the disclosure that shows
 * and hides it, keyed by `PictForm.RemarksInputHash`.
 *
 * Tracking GUIDs use the SAME `MATERIALS-ENTITY-TRACKING-GUID-TEST-…` element ids as the legacy
 * templates, so a migrated field still binds to a still-legacy sibling Test selector during a phased
 * rollout.
 *
 * Cross-provider contract: SampleStatusPicker / SampleStatusSelector listen for `TestResultChanged` and
 * collect values through `TestStatusAggregate` to derive the sample's status. Both must keep firing in
 * the same shape or sample status auto-derivation silently stops.
 */
class PictProviderInputTypeSampleTestAcceptance extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
		/**
		 * Explicit user choices only, so a render does not collapse an editor the user opened. Absent =
		 * no choice made, and the disclosure follows the stored remark. Never populated from a computed
		 * value: caching the first marshal's answer would freeze a transient read in place.
		 * @type {Record<string, boolean>}
		 */
		this._remarksUserOverride = {};
	}

	/**
	 * @param {string} pInputHTMLID @param {number|string|null} [pRowIndex] @param {string} [pType='TEST']
	 * @return {string}
	 */
	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType = 'TEST')
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/** Stamp the static result options unless the schema supplied its own. Shared with PickerDisplay,
	 *  which renders this field in Read and Print. */
	_applyTestResultOptions(pInput)
	{
		libTestResultOptions.applyTestResultOptions(pInput, true);
	}

	/** Register the acceptance layout CSS once (idempotent), above the Picker override block. */
	_ensureTestAcceptanceCSS()
	{
		if (this._testAcceptanceCSSInjected)
		{
			return;
		}
		const tmpCSSMap = this.pict && this.pict.CSSMap;
		if (tmpCSSMap && typeof tmpCSSMap.addCSS === 'function')
		{
			tmpCSSMap.addCSS('Headlight-SampleTestAcceptance-CSS', _TEST_ACCEPTANCE_CSS, 610);
			if (typeof tmpCSSMap.injectCSS === 'function')
			{
 tmpCSSMap.injectCSS();
			}
			this._testAcceptanceCSSInjected = true;
		}
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._ensureTestAcceptanceCSS();
		this._applyTestResultOptions(pInput);
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// Also applied here, not just on marshal: the column renders visible by default, so waiting for
		// the marshal leaves a collapsed editor briefly on screen.
		this._syncRemarksDisclosure(pView, pInput, null);
		return tmpResult;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._ensureTestAcceptanceCSS();
		this._applyTestResultOptions(pInput);
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._syncRemarksDisclosure(pView, pInput, pRowIndex);
		return tmpResult;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._applyTestResultOptions(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._syncRemarksDisclosure(pView, pInput, null);
		libTestResultsSummary.requestSummaryRefresh(this.pict, pView);
		return tmpResult;
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._applyTestResultOptions(pInput);
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		const tmpResult = super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._syncRemarksDisclosure(pView, pInput, pRowIndex);
		return tmpResult;
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
		libTestResultsSummary.requestSummaryRefresh(this.pict, pView);
		return tmpResult;
	}

	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpResult = super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
		return tmpResult;
	}

	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pValue @param {string} pHTMLSelector
	 * @param {number|string|null} pRowIndex @param {string} pEvent @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}
		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload, tmpExtraData ] = pEvent.split(':');

		//FIXME: needs revision to work with multi-sample forms (carried over from SampleTestResult).
		if (tmpEventType === 'TestStatusAggregate')
		{
			const tmpDestination = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (Array.isArray(tmpDestination))
			{
				tmpDestination.push(this._getCommittedValue(pView, pInput, pRowIndex));
			}
		}

		if (tmpEventType === 'SetTestResultByHash')
		{
			const tmpChangedTestHash = tmpTrackingGUID;
			const tmpEvent = `GetTestHash:${this._getTrackingGUID(pInput, pRowIndex)}:_GetTestHashResponse.${pInput.Hash}`;
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent);
			const tmpMarshalDestination = pView.getMarshalDestinationObject();
			const tmpTestHash = tmpMarshalDestination._GetTestHashResponse?.[pInput.Hash];
			if (tmpTestHash)
			{
				delete tmpMarshalDestination._GetTestHashResponse[pInput.Hash];
				if (Object.keys(tmpMarshalDestination._GetTestHashResponse).length === 0)
				{
					delete tmpMarshalDestination._GetTestHashResponse;
				}
			}
			if (tmpTestHash !== tmpChangedTestHash)
			{
				return;
			}
			this._setValueAndCommit(pView, pInput, tmpEventPayload, pRowIndex);
			if (tmpExtraData)
			{
				this.pict.manifest.setValueAtAddress(this.pict, tmpExtraData, true);
			}
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${tmpEventPayload}`);
		}

		if (tmpEventType === 'MarkNewTestsInProgress' && pInput.PictForm && pInput.PictForm.MarkTestsInProgressOnSave && pInput.PictForm.MarkTestsInProgressOnSave !== 'false')
		{
			const tmpTestResult = this._getCommittedValue(pView, pInput, pRowIndex);
			if (!tmpTestResult || tmpTestResult === 'N/A')
			{
				this._setValueAndCommit(pView, pInput, 'PROG', pRowIndex);
			}
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpEvent = 'MarkNewTestsInProgress';
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}

	/** The currently committed result code, read from the marshal destination. */
	_getCommittedValue(pView, pInput, pRowIndex)
	{
		return this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), this._getValueAddress(pInput, pRowIndex));
	}

	/**
	 * The marshal-relative address this field's result code lives at.
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string}
	 */
	_getValueAddress(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return this.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
		}
		return pInput.DataAddress;
	}

	// --- Remarks disclosure ---------------------------------------------------------------------

	/**
	 * The marshal-relative address the remark lives at. Defaults to the sibling test instance's Notes,
	 * which is where the generated TestInstanceRemarks descriptor wrote it before this input existed.
	 *
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @return {string}
	 */
	_getRemarksAddress(pInput, pRowIndex)
	{
		const tmpPictForm = (pInput && pInput.PictForm) || {};
		if (tmpPictForm.RemarksAddress)
		{
			return tmpPictForm.RemarksAddress;
		}
		const tmpRemarksInput = this._getRemarksInput(pInput);
		if (tmpRemarksInput)
		{
			if (pRowIndex != null)
			{
				return this.pict.providers.Informary.getComposedContainerAddress(tmpRemarksInput.PictForm.InformaryContainerAddress, pRowIndex, tmpRemarksInput.PictForm.InformaryDataAddress);
			}
			return tmpRemarksInput.DataAddress;
		}
		return null;
	}

	/**
	 * The sibling remarks descriptor this input's disclosure controls, named by `PictForm.RemarksInputHash`.
	 * @param {Object} pInput @return {Object|null}
	 */
	_getRemarksInput(pInput)
	{
		const tmpRemarksHash = pInput?.PictForm?.RemarksInputHash;
		if (!tmpRemarksHash)
		{
			return null;
		}
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors)
		{
			return null;
		}
		const tmpDescriptors = Object.values(tmpGlobalManifest.Descriptors);
		// Standalone form: the configured hash IS the descriptor's hash.
		for (const tmpDescriptor of tmpDescriptors)
		{
			if (tmpDescriptor.Hash === tmpRemarksHash)
			{
				return tmpDescriptor;
			}
		}
		// Container form: each test is injected through createDistinctManifest, which salts every
		// descriptor hash (SampleTestResult -> SampleTestResult_<salt>_<test>) but leaves RemarksInputHash
		// alone, since it is a plain string value and not a hash reference the salter knows about. The
		// pair still shares a group, so resolve there instead of giving up.
		const tmpGroup = pInput?.PictForm?.Group;
		if (!tmpGroup)
		{
			return null;
		}
		const tmpInGroup = tmpDescriptors.filter((pDescriptor) => ((pDescriptor.PictForm || {}).Group === tmpGroup) &&
			((pDescriptor.PictForm || {}).InputType === 'RichText'));
		if (tmpInGroup.length < 1)
		{
			return null;
		}
		const tmpPrefixed = tmpInGroup.filter((pDescriptor) => String(pDescriptor.Hash || '').startsWith(tmpRemarksHash));
		const tmpPool = (tmpPrefixed.length > 0) ? tmpPrefixed : tmpInGroup;
		if (tmpPool.length === 1)
		{
			return tmpPool[0];
		}
		// Several result/remark pairs can share one group. Both halves of a pair carry the same salt and
		// test hash, so the longest shared trailing run picks this input's own remarks field.
		let tmpBest = null;
		let tmpBestLength = -1;
		for (const tmpDescriptor of tmpPool)
		{
			const tmpLength = commonSuffixLength(String(pInput.Hash || ''), String(tmpDescriptor.Hash || ''));
			if (tmpLength > tmpBestLength)
			{
				tmpBestLength = tmpLength;
				tmpBest = tmpDescriptor;
			}
		}
		return tmpBest;
	}

	/** Stable key for one field's disclosure state (tabular rows each get their own). */
	_getRemarksStateKey(pInput, pRowIndex)
	{
		return (pRowIndex != null) ? `${pInput.Hash}-${pRowIndex}` : pInput.Hash;
	}

	/**
	 * The rendered column of the sibling remarks descriptor. Resolved through that descriptor's own
	 * hidden value input, which the editor body always emits under its RawHTMLID.
	 *
	 * @param {Object} pInput @param {number|string|null} pRowIndex @return {HTMLElement|null}
	 */
	_getRemarksColumnElement(pInput, pRowIndex)
	{
		const tmpRemarksInput = this._getRemarksInput(pInput);
		if (!tmpRemarksInput)
		{
			return null;
		}
		let tmpElement = null;
		if (tmpRemarksInput.Macro && tmpRemarksInput.Macro.RawHTMLID)
		{
			let tmpHTMLID = `#${tmpRemarksInput.Macro.RawHTMLID}`;
			if (pRowIndex != null)
			{
				tmpHTMLID = `${tmpHTMLID}-${pRowIndex}`;
			}
			const tmpFound = this.pict.ContentAssignment.getElement(tmpHTMLID);
			tmpElement = Array.isArray(tmpFound) ? tmpFound[0] : tmpFound;
		}
		if (!tmpElement)
		{
			// A container form's injected descriptors carry no Macro — that is added to the view's own
			// copies, not to the manifest the metacontroller holds. Element ids still follow the
			// `<view>-FormInput-<Hash>` convention, so fall back to matching on that.
			const tmpSuffix = (pRowIndex != null) ?
				`FormInput-${tmpRemarksInput.Hash}-${pRowIndex}` :
				`FormInput-${tmpRemarksInput.Hash}`;
			const tmpMatches = this.pict.ContentAssignment.getElement(`[id$="${tmpSuffix}"]`);
			tmpElement = Array.isArray(tmpMatches) ? tmpMatches[0] : tmpMatches;
		}
		if (!tmpElement || typeof tmpElement.closest !== 'function')
		{
			return null;
		}
		return tmpElement.closest('.column');
	}

	/**
	 * Show or hide the remarks editor. Called from the disclosure control in the template.
	 *
	 * @param {string} pInputHash - The acceptance descriptor's Hash.
	 * @param {number|string} [pRowIndex]
	 */
	toggleRemarks(pInputHash, pRowIndex)
	{
		const tmpInput = this._getInputByHash(pInputHash);
		if (!tmpInput)
		{
			this.log.warn('SampleTestAcceptance: no descriptor to toggle remarks for.', { pInputHash });
			return;
		}
		const tmpKey = this._getRemarksStateKey(tmpInput, pRowIndex);
		const tmpOpen = !this._isRemarksOpen(tmpInput, pRowIndex);
		this._remarksUserOverride[tmpKey] = tmpOpen;
		this._applyRemarksOpen(tmpInput, pRowIndex, tmpOpen);
	}

	/**
	 * Re-apply the disclosure after a marshal. A render wipes DOM classes, so the open state lives on the
	 * provider and is re-applied here rather than being read back off the element.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 */
	_syncRemarksDisclosure(pView, pInput, pRowIndex)
	{
		// Some older test schemas carry a result with no remarks field at all. A disclosure that opens
		// nothing reads as a broken control, so hide it rather than wire it to empty.
		if (!this._getRemarksInput(pInput))
		{
			this._setRemarksToggleVisible(pInput, pRowIndex, false);
			return;
		}
		const tmpKey = this._getRemarksStateKey(pInput, pRowIndex);
		// Recomputed every marshal: a user choice wins, otherwise follow the stored remark so a remark
		// that arrives later (autofill, a solver, a reloaded document) is never left hidden.
		const tmpOpen = (typeof this._remarksUserOverride[tmpKey] === 'boolean') ?
			this._remarksUserOverride[tmpKey] :
			this._shouldOpenRemarks(pView, pInput, pRowIndex);
		this._applyRemarksOpen(pInput, pRowIndex, tmpOpen);
	}

	/** Current disclosure state: the user's choice when they have made one, else the stored remark. */
	_isRemarksOpen(pInput, pRowIndex)
	{
		const tmpKey = this._getRemarksStateKey(pInput, pRowIndex);
		if (typeof this._remarksUserOverride[tmpKey] === 'boolean')
		{
			return this._remarksUserOverride[tmpKey];
		}
		const tmpColumn = this._getRemarksColumnElement(pInput, pRowIndex);
		return tmpColumn ? !tmpColumn.classList.contains('is-hidden') : false;
	}

	/**
	 * Whether the remarks editor should open on first marshal. Today: only when a remark is already
	 * stored. The "remarks required per result code" flag, when it lands, feeds this one predicate.
	 *
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex @return {boolean}
	 */
	_shouldOpenRemarks(pView, pInput, pRowIndex)
	{
		const tmpRemarksAddress = this._getRemarksAddress(pInput, pRowIndex);
		if (!tmpRemarksAddress)
		{
			return false;
		}
		const tmpRemark = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpRemarksAddress);
		return (typeof tmpRemark === 'string') && (tmpRemark.trim() !== '');
	}

	/** The disclosure control's element id for this field. */
	_getRemarksToggleID(pInput, pRowIndex)
	{
		if (pRowIndex != null)
		{
			return `#TEST-ACCEPTANCE-REMARKS-TOGGLE-${pInput.Macro.RawHTMLID}-${pRowIndex}`;
		}
		return `#TEST-ACCEPTANCE-REMARKS-TOGGLE-${pInput.Macro.RawHTMLID}`;
	}

	/**
	 * The disclosure control for this field. The click path reaches the provider through
	 * `_getInputByHash`, which returns the metacontroller's descriptor — and on a container form that
	 * copy carries no Macro. Fall back to the `...-FormInput-<Hash>` id convention, as the remarks
	 * column lookup does, rather than dereferencing Macro.
	 *
	 * @param {Object} pInput @param {number|string|null} pRowIndex @return {HTMLElement|null}
	 */
	_getRemarksToggleElement(pInput, pRowIndex)
	{
		let tmpFound = null;
		if (pInput && pInput.Macro && pInput.Macro.RawHTMLID)
		{
			tmpFound = this.pict.ContentAssignment.getElement(this._getRemarksToggleID(pInput, pRowIndex));
		}
		else if (pInput && pInput.Hash)
		{
			const tmpSuffix = (pRowIndex != null) ? `FormInput-${pInput.Hash}-${pRowIndex}` : `FormInput-${pInput.Hash}`;
			tmpFound = this.pict.ContentAssignment.getElement(`[id^="TEST-ACCEPTANCE-REMARKS-TOGGLE-"][id$="${tmpSuffix}"]`);
		}
		return (Array.isArray(tmpFound) ? tmpFound[0] : tmpFound) || null;
	}

	/** @param {Object} pInput @param {number|string|null} pRowIndex @param {boolean} pVisible */
	_setRemarksToggleVisible(pInput, pRowIndex, pVisible)
	{
		const tmpToggle = this._getRemarksToggleElement(pInput, pRowIndex);
		if (tmpToggle)
		{
			tmpToggle.classList.toggle('is-hidden', !pVisible);
		}
	}

	/** @param {Object} pInput @param {number|string|null} pRowIndex @param {boolean} pOpen */
	_applyRemarksOpen(pInput, pRowIndex, pOpen)
	{
		const tmpColumn = this._getRemarksColumnElement(pInput, pRowIndex);
		const tmpToggle = this._getRemarksToggleElement(pInput, pRowIndex);
		if (tmpColumn)
		{
			tmpColumn.classList.toggle('is-hidden', !pOpen);
			// Pull the editor up under the result row and lift its View/Edit switch into it. Only under
			// the standard layout — the vertical template stacks differently and is left alone.
			const tmpOwnColumn = tmpToggle && (typeof tmpToggle.closest === 'function') ? tmpToggle.closest('.column') : null;
			if (tmpOwnColumn && tmpOwnColumn.classList.contains('test-acceptance-column'))
			{
				tmpColumn.classList.add('test-acceptance-remarks');
			}
		}
		const tmpChevron = tmpToggle && tmpToggle.querySelector('i');
		if (tmpChevron)
		{
			tmpChevron.className = pOpen ? 'fas fa-fw fa-chevron-down' : 'fas fa-fw fa-chevron-right';
		}
	}

	/** @param {string} pInputHash @return {Object|null} */
	_getInputByHash(pInputHash)
	{
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors)
		{
			return null;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.Hash === pInputHash)
			{
				return tmpDescriptor;
			}
		}
		return null;
	}

	// --- Tracking GUID binding (ported from SampleTestResult) ------------------------------------

	/**
	 * @param {Object} pInput @param {number|string|null} [pRowIndex] @param {string} [pType='TEST']
	 * @return {string|null}
	 */
	_getTrackingGUID(pInput, pRowIndex, pType = 'TEST')
	{
		if (pRowIndex == null)
		{
			if (pType === 'TEST' && pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
			{
				return pInput.PictForm.TestTrackingGUID;
			}
			if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
			{
				return pInput.PictForm.SampleTrackingGUID;
			}
		}
		const tmpGUID = this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType));
		if (typeof tmpGUID === 'string' && tmpGUID.length > 0)
		{
			return tmpGUID;
		}
		return null;
	}

	/**
	 * @param {Object} pInput @param {number|string|null} pRowIndex @param {string} pTrackingGUID
	 * @param {string} [pType='TEST']
	 */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType = 'TEST')
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	/**
	 * Inherit the tracking GUID of the test descriptor this result belongs to, so the test's events reach
	 * this field. Searches the row's own group first (tabular), then the global manifest.
	 *
	 * @param {Object} pView @param {Object} pGroup @param {Object} pInput @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}

		if (pRowIndex != null)
		{
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('SampleTestAcceptance: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}

		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('SampleTestAcceptance: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('SampleTestAcceptance: could not find sibling test descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = PictProviderInputTypeSampleTestAcceptance;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;
module.exports.DEFAULT_TEST_RESULT_OPTIONS = libTestResultOptions.DEFAULT_TEST_RESULT_OPTIONS;

},{"./PictProvider-InputType-Picker.js":117,"./_TestResultOptions.js":168,"./_TestResultsSummary.js":169}],134:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const SelectInputTypeProvider = require('./PictProvider-InputType-Select.js');
const { DEFAULT_TEST_RESULT_OPTIONS } = require('./_TestResultOptions.js');

class SampleTestResultInputType extends SelectInputTypeProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SAMPLE-TEST-RESULT-SELECT-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SAMPLE-TEST-RESULT-SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	getTrackingGUIDID(pInputHTMLID, pRowIndex, pType)
	{
		const tmpType = pType ? `${pType}-` : '';
		if (pRowIndex != null)
		{
			return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}-${pRowIndex}`;
		}
		return `#MATERIALS-ENTITY-TRACKING-GUID-${tmpType}${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = {};
		}
		if (!pInput.PictForm.SelectOptions || !Array.isArray(pInput.PictForm.SelectOptions))
		{
			pInput.PictForm.SelectOptions = DEFAULT_TEST_RESULT_OPTIONS;
		}
		//TODO: any custom logic for loading test result codes / etc. here?
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = {};
		}
		if (!pInput.PictForm.SelectOptions || !Array.isArray(pInput.PictForm.SelectOptions))
		{
			pInput.PictForm.SelectOptions = DEFAULT_TEST_RESULT_OPTIONS;
		}
		//TODO: any custom logic for loading test result codes / etc. here?
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput);
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		//TODO: plumb the test result into the configured address
		return tmpResult;
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex);
		//TODO: plumb the test result into the configured address
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput)}:${pValue}`);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput, pRowIndex)}:${pValue}`);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload, tmpExtraData ] = pEvent.split(':');

		//FIXME: needs revision to work with multi-sample forms
		if (tmpEventType === 'TestStatusAggregate')
		{
			const tmpDestination = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			if (Array.isArray(tmpDestination))
			{
				let tmpTestResult;
				if (pRowIndex != null)
				{
					tmpTestResult = this.pict.ContentAssignment.readContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex));
				}
				else
				{
					tmpTestResult = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
				}
				tmpDestination.push(tmpTestResult);
			}
		}

		if (tmpEventType === 'SetTestResultByHash')
		{
			const tmpChangedTestHash = tmpTrackingGUID;
			const tmpEvent = `GetTestHash:${this._getTrackingGUID(pInput, pRowIndex)}:_GetTestHashResponse.${pInput.Hash}`;
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent);
			const tmpMarshalDestination = pView.getMarshalDestinationObject();
			const tmpTestHash = tmpMarshalDestination._GetTestHashResponse?.[pInput.Hash];
			if (tmpTestHash)
			{
				delete tmpMarshalDestination._GetTestHashResponse[pInput.Hash];
				if (Object.keys(tmpMarshalDestination._GetTestHashResponse).length === 0)
				{
					delete tmpMarshalDestination._GetTestHashResponse;
				}
			}
			if (tmpTestHash !== tmpChangedTestHash)
			{
				return;
			}
			const tmpSuccessMarkerAddress = tmpExtraData;
			if (pRowIndex != null)
			{
				pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpEventPayload);
				pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
			}
			else
			{
				pView.setDataByInput(pInput, tmpEventPayload);
				pView.manualMarshalDataToViewByInput(pInput);
			}
			if (tmpSuccessMarkerAddress)
			{
				this.pict.manifest.setValueAtAddress(this.pict, tmpSuccessMarkerAddress, true);
			}
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TestResultChanged:${this._getTrackingGUID(pInput)}:${tmpEventPayload}`);
		}

		if (tmpEventType === 'MarkNewTestsInProgress' && pInput.PictForm && pInput.PictForm.MarkTestsInProgressOnSave && pInput.PictForm.MarkTestsInProgressOnSave !== 'false')
		{
			let tmpDataAddress = pInput.DataAddress;
			if (pRowIndex != null)
			{
				tmpDataAddress = pView.pict.providers.Informary.getComposedContainerAddress(pInput.PictForm.InformaryContainerAddress, pRowIndex, pInput.PictForm.InformaryDataAddress);
			}
			let tmpTestResult = pView.sectionManifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDataAddress);
			if (pRowIndex != null)
			{
				tmpTestResult = this.pict.ContentAssignment.readContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex));
			}
			else
			{
				tmpTestResult = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
			}
			if (!tmpTestResult || tmpTestResult === 'N/A')
			{
				tmpTestResult = 'PROG';
				if (pRowIndex != null)
				{
					pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpTestResult);
					pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
				}
				else
				{
					pView.setDataByInput(pInput, tmpTestResult);
					pView.manualMarshalDataToViewByInput(pInput);
				}
			}
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		const tmpEvent = 'MarkNewTestsInProgress';
		const tmpTransactionGUID = this.pict.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(tmpEvent, tmpTransactionGUID);
		this.pict.views.PictFormMetacontroller.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
		{
			super.onBeforeSaveDataAsync(fCallback);
		});
		this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
	}


	/**
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 * @param {string} [pType='TEST'] - Default to TEST since that is the only local type we care about here.
	 *
	 * @returns {string|null}
	 */
	_getTrackingGUID(pInput, pRowIndex, pType = 'TEST')
	{
		if (pRowIndex == null)
		{
			switch (pType)
			{
			case 'TEST':
				if (pInput.PictForm?.TestTrackingGUID && pInput.PictForm.TestTrackingGUID != true)
				{
					return pInput.PictForm.TestTrackingGUID;
				}
			default:
				if (pInput.PictForm?.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
				{
					return pInput.PictForm.SampleTrackingGUID;
				}
			}
		}
		const tmpGUID = this.pict.ContentAssignment.readContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType));
		if (typeof tmpGUID === 'string' && tmpGUID.length > 0)
		{
			return tmpGUID;
		}
		return null;
	}

	/**
	 * @param {Object} pInput
	 * @param {number|null} pRowIndex
	 * @param {string} pTrackingGUID
	 * @param {string} [pType='TEST'] - Default to TEST since that is the only local type we care about here.
	 *
	 * @return {void}
	 */
	_setTrackingGUID(pInput, pRowIndex, pTrackingGUID, pType = 'TEST')
	{
		this.pict.ContentAssignment.assignContent(this.getTrackingGUIDID(pInput.Macro.RawHTMLID, pRowIndex, pType), pTrackingGUID);
	}

	/**
	 * Searches for the sample descriptor that this test result should be bound to and inherits its tracking GUID if needed.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_bindTrackingGUIDIfNeeded(pView, pGroup, pInput, pRowIndex)
	{
		if (this._getTrackingGUID(pInput, pRowIndex))
		{
			return;
		}
		// modalities:
		//
		// single global sample
		// tabular row-based tests
		// tabular row-based sample and tests

		if (pRowIndex != null)
		{
			// tabular
			const tmpLocalManifest = pGroup.supportingManifest;
			if (!tmpLocalManifest || typeof tmpLocalManifest !== 'object' || Array.isArray(tmpLocalManifest))
			{
				this.log.error('SampleTestResultSelector: invalid supporting manifest on group.', { pGroup });
			}
			else
			{
				for (const tmpDescriptor of Object.values(tmpLocalManifest.elementDescriptors))
				{
					if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
					{
						const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor, pRowIndex);
						if (tmpTrackingGUID)
						{
							this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
							return;
						}
					}
				}
			}
		}
		// check sibling Descriptors for a sample descriptor
		const tmpGlobalManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		if (!tmpGlobalManifest || !tmpGlobalManifest.Descriptors || typeof tmpGlobalManifest.Descriptors !== 'object' || Array.isArray(tmpGlobalManifest.Descriptors))
		{
			this.log.error('SampleTestResultSelector: invalid global manifest on metacontroller.', { pGroup });
			return;
		}
		for (const tmpDescriptor of Object.values(tmpGlobalManifest.Descriptors))
		{
			if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TestTrackingGUID)
			{
				const tmpTrackingGUID = this._getTrackingGUID(tmpDescriptor);
				if (tmpTrackingGUID)
				{
					this._setTrackingGUID(pInput, pRowIndex, tmpTrackingGUID);
					return;
				}
			}
		}
		if (!this._getTrackingGUID(pInput, pRowIndex))
		{
			this.log.warn('SampleTestResultSelector: could not find sibling test descriptor to bind tracking GUID from.');
		}
	}
}

module.exports = SampleTestResultInputType;
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-InputType-Select.js":137,"./_TestResultOptions.js":168}],135:[function(require,module,exports){
const PickerProvider = require('./PictProvider-InputType-Picker.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'SampleTypePicker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * Sample-type picker (beast B1) — the Picker-stack port of the legacy SampleTypeSelector (a
 * MaterialsEntitySelector subclass; this class mirrors it 1:1 for diff-review). Reuses the base broker
 * (Entity=SampleType via the specialized-selector map) and keeps the sample's two type columns in sync
 * through the cascade seam: the modern `IDSampleType` FK (set by the standard autofill) and the legacy
 * `MaterialType` code. On forward selection it mirrors the picked type's `Hash` onto `MaterialType`;
 * when seeding from a linked sample it prefers `IDSampleType` and falls back to resolving the
 * `MaterialType` code to a SampleType so pre-backfill samples still display (and pick up the FK on the
 * next save). Declarative defaults (`Default:"ACPT"` + `DefaultField:"Hash"`) come from the base broker
 * via the map's MaterialsFamily flag.
 */
class PictProviderInputTypeSampleTypePicker extends PickerProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Record<string, any>|null} Hash -> SampleType record, lazily loaded for the reverse fallback. */
		this._sampleTypesByHash = null;
		/** @type {boolean} true while the map request is in flight; kept separate from the map so an unloaded map stays null. */
		this._sampleTypeMapLoading = false;
		/** @type {Array<{View: Object, Input: Object, RowIndex: number|string|null}>} inputs that initialized mid-load and owe a seed. */
		this._sampleTypeMapWaiters = [];
		/** @type {boolean} re-entrancy guard so a fallback-driven commit does not re-seed mid-seed. */
		this._fallbackSeeding = false;
	}

	/** @param {Object} pInput @return {string} marshal-relative address of the sample's legacy MaterialType code. */
	_sampleMaterialTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleMaterialTypeAddress || 'SampleID__Record.MaterialType';
	}
	/** @param {Object} pInput @return {string} marshal-relative address of the sample's IDSampleType FK. */
	_sampleIDSampleTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleIDSampleTypeAddress || 'SampleID__Record.IDSampleType';
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._loadSampleTypeMap(pView, pInput, null);
		// The legacy seed fired via the init-time record refresh; the broker has no init-time cascade, so
		// attempt it directly — its own gates (sample already carries the FK / no legacy code) make it a no-op
		// everywhere it should not run.
		this._seedSampleTypeFromMaterialType(pView, pInput, null);
		return tmpResult;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._loadSampleTypeMap(pView, pInput, pRowIndex);
		this._seedSampleTypeFromMaterialType(pView, pInput, pRowIndex);
		return tmpResult;
	}

	/**
	 * Legacy re-ran the seed on every marshal (MES _onDataMarshalToForm → _onRecordRefresh), which is what
	 * caught a linked sample record landing after init. The seed's own gates keep it a no-op otherwise.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._seedSampleTypeFromMaterialType(pView, pInput, null);
		return tmpResult;
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// @ts-ignore — inherited through the PSP chain tsc cannot see.
		const tmpResult = super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		this._seedSampleTypeFromMaterialType(pView, pInput, pRowIndex);
		return tmpResult;
	}

	/**
	 * Lazily cache Hash -> SampleType for the current customer (row-level auth scopes the read).
	 *
	 * The load is async and the caller seeds immediately after calling this, so EVERY input that initializes
	 * while the request is in flight is queued and re-seeded when it lands — not just the first. The map
	 * itself stays `null` until it is real (the in-flight state is tracked separately), so the emptiness
	 * guard in `_seedSampleTypeFromMaterialType` means what it says: a seed during the window is suppressed
	 * rather than resolving against an empty map and silently giving up. The waiter carries its row index so
	 * a tabular picker replays against the row it initialized on.
	 *
	 * @param {Object} [pView] @param {Object} [pInput] the picker to re-seed once the map loads.
	 * @param {number|string|null} [pRowIndex] row the picker initialized on, for the tabular case.
	 */
	_loadSampleTypeMap(pView, pInput, pRowIndex)
	{
		if (this._sampleTypesByHash || !this.pict?.HeadlightRestClient)
		{
			return;
		}
		// The provider family is commonly instantiated via Object.create in harnesses and by the broker, so
		// do not assume the constructor ran.
		if (!Array.isArray(this._sampleTypeMapWaiters))
		{
			this._sampleTypeMapWaiters = [];
		}
		if (pView && pInput)
		{
			this._sampleTypeMapWaiters.push({ View: pView, Input: pInput, RowIndex: (pRowIndex === undefined) ? null : pRowIndex });
		}
		if (this._sampleTypeMapLoading)
		{
			return;
		}
		this._sampleTypeMapLoading = true;
		this.pict.HeadlightRestClient.getJSON('SampleTypes/FilteredTo/FSF~IDSampleType~ASC~0/0/500', (pError, pTypes) =>
		{
			this._sampleTypeMapLoading = false;
			const tmpWaiters = this._sampleTypeMapWaiters;
			this._sampleTypeMapWaiters = [];
			if (pError || !Array.isArray(pTypes))
			{
				// Reset to null (not an empty map) so the next onInputInitialize retries rather than being
				// stuck resolving against a map that will never fill.
				this._sampleTypesByHash = null;
				return;
			}
			const tmpMap = {};
			for (const tmpType of pTypes)
			{
				if (tmpType && tmpType.Hash)
				{
					tmpMap[tmpType.Hash] = tmpType;
				}
			}
			this._sampleTypesByHash = tmpMap;
			for (const tmpWaiter of tmpWaiters)
			{
				this._seedSampleTypeFromMaterialType(tmpWaiter.View, tmpWaiter.Input, tmpWaiter.RowIndex);
			}
		});
	}

	/**
	 * The cascade twin of the legacy `_onRecordRefresh`: fired after `__Record` lands (select and clear).
	 * @param {Object} pView @param {Record<string, any>} pInput
	 * @param {Record<string, any>|Array<Record<string, any>>} pRecord
	 * @param {number|string} [pRowIndex] @param {string} [pTransactionGUID]
	 */
	_onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID)
	{
		super._onEntityRecordCascade(pView, pInput, pRecord, pRowIndex, pTransactionGUID);
		if (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord) && pRecord.IDSampleType)
		{
			// Forward: mirror the picked type's Hash onto the sample's legacy MaterialType column.
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._sampleMaterialTypeAddress(pInput), pRecord.Hash || '');
			return;
		}
		this._seedSampleTypeFromMaterialType(pView, pInput, pRowIndex);
	}

	/**
	 * Reverse fallback: when nothing is selected and the bound sample has no IDSampleType but carries a
	 * legacy MaterialType code, resolve it to a SampleType, seed the picker, and backfill the FK in-form.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} [pRowIndex]
	 */
	_seedSampleTypeFromMaterialType(pView, pInput, pRowIndex)
	{
		if (this._fallbackSeeding || !this._sampleTypesByHash || !pView || typeof pView.getMarshalDestinationObject !== 'function')
		{
			return;
		}
		const tmpDestination = pView.getMarshalDestinationObject();
		// Only seed an EMPTY picker (found live: this seam fires from init and the async map-load too,
		// where a value may already be committed). The legacy provider reached the same outcome
		// structurally — its seed was only ever entered from a record refresh whose record had no
		// IDSampleType, and a valued picker's init refresh takes the forward-mirror branch instead —
		// so without this gate a stale legacy code would hijack a real selection on reload.
		const tmpValueAddress = this._getRecordAddress(pInput, pRowIndex).replace(/__Record$/, '');
		if (this.pict.manifest.getValueAtAddress(tmpDestination, tmpValueAddress))
		{
			return;
		}
		const tmpExistingID = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput));
		if (tmpExistingID)
		{
			return;
		}
		const tmpMaterialType = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleMaterialTypeAddress(pInput));
		const tmpResolved = tmpMaterialType ? this._sampleTypesByHash[tmpMaterialType] : null;
		if (!tmpResolved)
		{
			return;
		}
		this._fallbackSeeding = true;
		try
		{
			// Backfill the FK + pre-seed __Record synchronously from the map (offline-tolerant: the commit's
			// record refresh re-resolves the same id and, on a failed lookup, keeps this pre-seeded record),
			// then land the picker value through the value-commit primitive — model write + fenced provider
			// loop (record refresh → cascade, whose forward branch re-mirrors MaterialType idempotently) +
			// widget repaint.
			this.pict.manifest.setValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput), tmpResolved.IDSampleType);
			this.pict.manifest.setValueAtAddress(tmpDestination, this._getRecordAddress(pInput, pRowIndex), tmpResolved);
			this._setValueAndCommit(pView, pInput, tmpResolved.IDSampleType, pRowIndex);
		}
		finally
		{
			this._fallbackSeeding = false;
		}
	}
}

module.exports = PictProviderInputTypeSampleTypePicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"./PictProvider-InputType-Picker.js":117}],136:[function(require,module,exports){
const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');

/**
 * Sample-type picker. Reuses the generic entity selector (Entity=SampleType) but keeps the sample's two
 * type columns in sync: the modern `IDSampleType` FK (set by the standard autofill) and the legacy
 * `MaterialType` code. On forward selection it mirrors the picked type's `Hash` onto `MaterialType`; when
 * seeding from a linked sample it prefers `IDSampleType` and falls back to resolving the `MaterialType`
 * code to a SampleType so pre-backfill samples still display (and pick up the FK on the next save).
 */
class SampleTypeSelectorInputType extends MaterialsEntityInputType
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = {};
		}
		if (!pOptions.Entity)
		{
 pOptions.Entity = 'SampleType';
		}
		super(pFable, pOptions, pServiceHash);
		/** @type {Record<string, any>|null} Hash -> SampleType record, lazily loaded for the reverse fallback. */
		this._sampleTypesByHash = null;
		/** @type {boolean} true while the map request is in flight; kept separate from the map so an unloaded map stays null. */
		this._sampleTypeMapLoading = false;
		/** @type {Array<{View: Object, Input: Object}>} inputs that initialized mid-load and owe a seed when the map lands. */
		this._sampleTypeMapWaiters = [];
		/** @type {boolean} re-entrancy guard so a fallback-driven re-marshal does not re-seed. */
		this._fallbackSeeding = false;
	}

	/** @param {Object} pInput @return {string} marshal-relative address of the sample's legacy MaterialType code. */
	_sampleMaterialTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleMaterialTypeAddress || 'SampleID__Record.MaterialType';
	}
	/** @param {Object} pInput @return {string} marshal-relative address of the sample's IDSampleType FK. */
	_sampleIDSampleTypeAddress(pInput)
	{
		return pInput?.PictForm?.SampleIDSampleTypeAddress || 'SampleID__Record.IDSampleType';
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		this._loadSampleTypeMap(pView, pInput);
		return tmpResult;
	}

	/**
	 * Lazily cache Hash -> SampleType for the current customer (row-level auth scopes the read).
	 *
	 * The load is async and the reverse-seed fires during init, so EVERY input that initializes while the
	 * request is in flight is queued and re-seeded when it lands — not just the first. The map itself stays
	 * `null` until it is real (the in-flight state is tracked separately), so the emptiness guard in
	 * `_seedSampleTypeFromMaterialType` means what it says: a seed during the window is suppressed rather
	 * than resolving against an empty map and silently giving up. An input arriving after the map is already
	 * loaded is seeded immediately — the init-time attempt that would otherwise cover it only runs off a
	 * record refresh, so a second form in the same session would never resolve.
	 *
	 * @param {Object} [pView] @param {Object} [pInput] the picker to seed once the map is available.
	 */
	_loadSampleTypeMap(pView, pInput)
	{
		if (!this.pict?.HeadlightRestClient)
		{
			return;
		}
		if (this._sampleTypesByHash)
		{
			if (pView && pInput)
			{
				this._seedSampleTypeFromMaterialType(pView, pInput);
			}
			return;
		}
		// The provider family is commonly instantiated via Object.create in harnesses and by the broker, so
		// do not assume the constructor ran.
		if (!Array.isArray(this._sampleTypeMapWaiters))
		{
			this._sampleTypeMapWaiters = [];
		}
		if (pView && pInput)
		{
			this._sampleTypeMapWaiters.push({ View: pView, Input: pInput });
		}
		if (this._sampleTypeMapLoading)
		{
			return;
		}
		this._sampleTypeMapLoading = true;
		this.pict.HeadlightRestClient.getJSON('SampleTypes/FilteredTo/FSF~IDSampleType~ASC~0/0/500', (pError, pTypes) =>
		{
			this._sampleTypeMapLoading = false;
			const tmpWaiters = this._sampleTypeMapWaiters;
			this._sampleTypeMapWaiters = [];
			if (pError || !Array.isArray(pTypes))
			{
				// Reset to null (not an empty map) so the next onInputInitialize retries rather than being
				// stuck resolving against a map that will never fill.
				this._sampleTypesByHash = null;
				return;
			}
			const tmpMap = {};
			for (const tmpType of pTypes)
			{
				if (tmpType && tmpType.Hash)
				{
					tmpMap[tmpType.Hash] = tmpType;
				}
			}
			this._sampleTypesByHash = tmpMap;
			for (const tmpWaiter of tmpWaiters)
			{
				this._seedSampleTypeFromMaterialType(tmpWaiter.View, tmpWaiter.Input);
			}
		});
	}

	/**
	 * @param {Object} pView @param {Object} pInput @param {any} pRecord @param {string} pRecordAddress
	 * @param {string} pTransactionGUID @param {number} [pRowIndex]
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
		if (pRecord && typeof pRecord === 'object' && !Array.isArray(pRecord) && pRecord.IDSampleType)
		{
			// Forward: mirror the picked type's Hash onto the sample's legacy MaterialType column.
			this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), this._sampleMaterialTypeAddress(pInput), pRecord.Hash || '');
			return;
		}
		this._seedSampleTypeFromMaterialType(pView, pInput, pRecordAddress, pRowIndex);
	}

	/**
	 * Reverse fallback: when nothing is selected and the bound sample has no IDSampleType but carries a
	 * legacy MaterialType code, resolve it to a SampleType, seed the picker, and backfill the FK in-form.
	 * @param {Object} pView @param {Object} pInput @param {string} [pRecordAddress] @param {number} [pRowIndex]
	 */
	_seedSampleTypeFromMaterialType(pView, pInput, pRecordAddress, pRowIndex)
	{
		if (this._fallbackSeeding || !this._sampleTypesByHash)
		{
			return;
		}
		const tmpDestination = pView.getMarshalDestinationObject();
		const tmpExistingID = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput));
		if (tmpExistingID)
		{
			return;
		}
		const tmpMaterialType = this.pict.manifest.getValueAtAddress(tmpDestination, this._sampleMaterialTypeAddress(pInput));
		const tmpResolved = tmpMaterialType ? this._sampleTypesByHash[tmpMaterialType] : null;
		if (!tmpResolved)
		{
			return;
		}
		const tmpRecordAddress = pRecordAddress || this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpValueAddress = tmpRecordAddress.replace(/__Record$/, '');
		this._fallbackSeeding = true;
		try
		{
			this.pict.manifest.setValueAtAddress(tmpDestination, this._sampleIDSampleTypeAddress(pInput), tmpResolved.IDSampleType);
			this.pict.manifest.setValueAtAddress(tmpDestination, tmpValueAddress, tmpResolved.IDSampleType);
			this.pict.manifest.setValueAtAddress(tmpDestination, tmpRecordAddress, tmpResolved);
			if (typeof pView.marshalToView === 'function')
			{
				pView.marshalToView();
			}
		}
		finally
		{
			this._fallbackSeeding = false;
		}
	}
}

module.exports = SampleTypeSelectorInputType;

},{"./PictProvider-InputType-MaterialsEntitySelector.js":89}],137:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

const libEntityOptionSource = require('./_EntityOptionSource.js');

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {Record<string, {Loaded: boolean, Options: Array<{id: any, text: string}>, Callbacks: Array<Function>}>} Shared entity-backed option sets, keyed by entity + field config. */
		this._entitySelectOptionCache = {};
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			window['jQuery'].fn.select2.amd.define('select2/data/dynamicLocalPaginationAdapter',
				[
					'select2/data/array',
					'select2/utils',
				],
				function(ArrayAdapter, Utils)
				{
					function DynamicLocalPaginationAdapter($element, options)
					{
						// @ts-ignore — __super__ is injected by Select2's Utils.Extend
						DynamicLocalPaginationAdapter.__super__.constructor.call(this, $element, options);
					}
					Utils.Extend(DynamicLocalPaginationAdapter, ArrayAdapter);

					DynamicLocalPaginationAdapter.prototype.query = function(params, callback)
					{
						//TODO: customizable
						const pageSize = 100;

						if (!('page' in params))
						{
							params.page = 1;
						}
						const term = (params.term || '').toLowerCase();
						/** @type {any} */
						const tmpSelf = this;
						const results = tmpSelf.options.options.DynamicMetaLists.getList(tmpSelf.options.options.Input.PictForm.SelectOptionsPickList,
							{
								startIndex: (params.page - 1) * pageSize,
								maxResults: pageSize,
								filterString: term,
								searchFields: (tmpSelf.options.options.Input.PictForm.DistillingDisplay || '').split(',').filter((f) => f.trim() !== ''),
							});
						callback(
						{
							results,
							pagination:
							{
								more: results.length >= pageSize,
							},
						});
					};

					return DynamicLocalPaginationAdapter;
				});
		}
	}

	/**
	 * Temporary loading skeleton for the input element.
	 * @param {object} inputID The input id.
	 */
	addLoadingSkeleton(inputID, rawID)
	{
		if (!this.pict?.AppData?.Interactive || this.pict?.AppData?.DocumentData?.ReportData?.Locked)
		{
			return;
		}
		const tmpLoadingBox = document.createElement('div');
		tmpLoadingBox.id = `LOADING-${rawID}`;
		tmpLoadingBox.classList.add('input', 'is-skeleton');
		tmpLoadingBox.style.left = '0';
		tmpLoadingBox.style.position = 'absolute';
		tmpLoadingBox.style.opacity = '0.5';
		this.pict.ContentAssignment.getElement(inputID)[0]?.parentElement?.appendChild(tmpLoadingBox);
		this.pict.ContentAssignment.addClass(inputID, 'is-hidden');
	}

	/**
	 * Remove the loading skeleton from the input element.
	 * @param {object} inputID The input id.
	 */
	removeLoadingSkeleton(inputID, rawID)
	{
		const tmpLoadingBox = this.pict.ContentAssignment.getElement(`#LOADING-${rawID}`);
		if (tmpLoadingBox && tmpLoadingBox.length > 0)
		{
			tmpLoadingBox[0].remove();
		}
		this.pict.ContentAssignment.removeClass(inputID, 'is-hidden');
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a select input element in PDF display.
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @return {string} - The generated HTML ID for the select input element in PDF display.
	 */
	getSelectPDFDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular select input ID based on the provided input HTML ID and row index.
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular select input ID.
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select input ID for PDF display based on the provided input HTML ID and row index.
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @return {string} - The generated tabular select input ID for PDF display.
	 */
	getTabularSelectPDFDisplayHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-TABULAR-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select dropdown ID based on the input HTML ID and row index.
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @return {string} - The generated tabular select dropdown ID.
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Resolve an entity-backed option list for this input (see `_EntityOptionSource`), kicking off the
	 * shared load on first ask. Returns null while the load is in flight, when the input is not
	 * entity-backed, and when the customer has no rows - in each case the caller keeps whatever static
	 * `PictForm.SelectOptions` fallback the input carries.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {Function} [fOnLoaded] - Invoked once, after an in-flight load resolves, so the caller can repaint.
	 * @return {Array<{id: any, text: string}>|null} - The option list, or null to fall back.
	 */
	resolveEntitySelectOptions(pInput, fOnLoaded)
	{
		return libEntityOptionSource.resolveOptions(this, pInput, fOnLoaded);
	}

	/**
	 * Build the selection list for a select input.
	 * @param {HTMLElement} pInputSelectElement - The select element.
	 * @param {Array} pListData - The list data.
	 * @param {Object} pInput - The input object.
	 * @param {Array<string>} pValues - The input value.
	 * @return {Array} - The filtered list data.
	 */
	rebuildSelectionList(pInputSelectElement, pListData, pInput, pValues)
	{
		// HAX
		pInputSelectElement.innerHTML = '';

		if (pInputSelectElement && pListData && Array.isArray(pListData))
		{
			if (pListData.length === 0)
			{
				// add the empty list option
				const pOption = document.createElement('option');
				pOption.value = '';
				pOption.text = 'No options available';
				pInputSelectElement.appendChild(pOption);
			}
			else
			{
				// add the placeholder option
				const pOption = document.createElement('option');
				pOption.value = '';
				pOption.text = this.pict.AppData.Interactive ? (pInput?.PictForm?.Placeholder || 'Select...') : '';
				pInputSelectElement.appendChild(pOption);

				for (let i = 0; i < pListData.length; i++)
				{
					// check if the passed value matches this option, and set the selected property
					pListData[i].selected = (pValues.find((v) => v == pListData[i].id) != null);
					// add the option to the select element
					const pOption = document.createElement('option');
					pOption.value = pListData[i].id;
					pOption.text = pListData[i].text;
					pOption.selected = pListData[i].selected;
					pInputSelectElement.appendChild(pOption);
				}
			}
		}
		return pListData;
	}

	/**
	 * Refreshes the select list for a dynamic input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {Array<string>|string} pValues - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {boolean} isTabular - Whether the context is tabular or not.
	 * @param {number|null} pRowIndex - The row index for tabular context (null for non-tabular context).
	 * @return {boolean|Array} - Returns false if the input element is not found, otherwise returns the filtered list data.
	 */
	refreshSelectList(pView, pGroup, pRow, pInput, pValues, pHTMLSelector, isTabular = false, pRowIndex = null)
	{
		if (typeof pValues === 'string')
		{
			pValues = pValues.split(',').filter((v) => v.trim() !== '');
		}
		const methodNameByContext = isTabular ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex));
		let tmpListData = pInput.PictForm?.SelectOptions;

		// Entity-backed vocabularies (PictForm.SelectOptionsEntity) win over the static list when the
		// customer has rows; an empty table or a failed read leaves the static SelectOptions in place.
		const tmpEntityOptions = this.resolveEntitySelectOptions(pInput, () =>
		{
			this.refreshSelectList(pView, pGroup, pRow, pInput, pValues, pHTMLSelector, isTabular, pRowIndex);
			const tmpReloadedElement = this.pict.ContentAssignment.getElement(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex));
			if (window['jQuery'] && tmpReloadedElement && tmpReloadedElement.length > 0)
			{
				window['jQuery'](tmpReloadedElement[0]).trigger('change.select2');
			}
		});
		if (Array.isArray(tmpEntityOptions) && tmpEntityOptions.length > 0)
		{
			tmpListData = tmpEntityOptions;
		}

		if (pInput.PictForm.SelectOptionsPickList)
		{
			if (this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic)
			{
				return false;
			}
			if (this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
			{
				tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
			}
		}

		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElement || tmpInputSelectElement.length < 1)
		{
			return false;
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData);

		tmpInputSelectElement = tmpInputSelectElement[0];

		return this.rebuildSelectionList(tmpInputSelectElement, tmpListData, pInput, pValues);
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, false, null);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 * NOTE: The tabular version uses a different select element/id for the dropdown selection by design.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.pict.providers.DynamicInput)
		{
			this.pict.providers.DynamicInput.registerIgnoredEventHash('change.select2');
		}
		this._onInputInitialize(pView, pGroup, null, pInput, pValue, pHTMLSelector, true, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Internal method to initialize the input element for both regular and tabular contexts.
	 * @private
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object|null} pRow - The row object (null for tabular context).
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {boolean} isTabular - Whether the context is tabular or not.
	 * @param {number|null} pRowIndex - The row index for tabular context (null for non-tabular context).
	 */
	_onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, isTabular = false, pRowIndex = null)
	{
		const methodNameByContext = isTabular ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// add loading skeleton while we initialize the select2 plugin and load the options list, since this can take a moment and we want to avoid the user interacting with an uninitialized select element
		this.addLoadingSkeleton(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		// if this is a multiple select, we need to add the 'multiple' attribute to the select element and add the 'is-multiple' class to the wrapper for Bulma styling purposes
		const tmpIsMultiple = pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true;
		if (tmpIsMultiple)
		{
			this.pict.ContentAssignment.setAttribute(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex), 'multiple', 'multiple');
			// from the select tag, find the parent wrapper div with class '.control.select' so we can add the 'is-multiple' class to it (for Bulma styling purposes)
			const tmpSelectWrapper = document.querySelector(`${this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)}`)?.parentElement;
			if (tmpSelectWrapper && tmpSelectWrapper.classList.contains('select') && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
			window['jQuery'](this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex)).empty(); // remove placeholder
		}
		// ensure we use the right value format for multiple vs. single select inputs
		const tmpValues = tmpIsMultiple ? (pValue && typeof(pValue) === 'string' ? pValue.split(',') : []) : pValue ? [ pValue ] : [];
		// handle the case where the options list is coming from a dynamic pick list that needs to be loaded asynchronously
		this.refreshSelectList(pView, pGroup, pRow, pInput, tmpValues, pHTMLSelector, isTabular, pRowIndex);
	}

	/**
	 * Initialize the Select2 plugin for the input element.
	 * @param {object} pInput The input object.
	 * @param {boolean} isTabular Whether the input is tabular.
	 * @param {number} [pRowIndex] The row index for tabluar rows.
	 */
	initializeSelect2(pInput, isTabular = false, pRowIndex)
	{
		if (this.pict.AppData.Interactive === false)
		{
			// if the app is not interactive, we don't need to initialize the select2 plugin
			return;
		}
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			// tabular vs. non-tabular context
			const methodNameByContext = isTabular ? 'getTabularSelectDropdownID' : 'getSelectInputHTMLID';
			const tmpSelectElementSelector = this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex);
			// if the select2 plugin is not already initialized, initialize it now
			if (tmpSelectElementSelector && !window['jQuery'](tmpSelectElementSelector).data('select2'))
			{
				// NOTE: Select2 Option Documentation: https://select2.org/configuration/options-api
				const tmpSelectOptions = {
					allowClear: true,
					disabled: pInput.PictForm.Disabled,
					multiple: pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true,
					placeholder: this.pict.AppData.Interactive ? (pInput?.PictForm?.Placeholder || 'Select...') : '',
					width: '100%',
					tags: pInput.PictForm.AllowCustomValues,
					dropdownCssClass: pInput.PictForm.AllowCustomValues ? 'has-custom-options' : '',
					Disabled: pInput.PictForm.Disabled || false,
					createTag: function(params)
					{
						const term = params.term.trim();
						if (term === '')
						{
							return null;
						}
						return {
							id: term,
							text: term,
							newTag: true,
						};
					},
				};
				if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic)
				{
					tmpSelectOptions.ajax = {}; // necessary for custom data adapter to be used
					tmpSelectOptions.dataAdapter = $.fn.select2.amd.require('select2/data/dynamicLocalPaginationAdapter');
					// plumbing necessary context for the adapter since it doesn't have access to pict
					tmpSelectOptions.Input = pInput;
					tmpSelectOptions.DynamicMetaLists = this.pict.providers.DynamicMetaLists; //FIXME: ...
				}
				// initialize the select2 plugin on the select element
				window['jQuery'](tmpSelectElementSelector).select2(tmpSelectOptions);
			}
		}
	}

	/**
	 * Handles the marshalling of data to the form for select input types, including setting the selected options on the select element and refreshing the options list if necessary.
	 * @param {object} pView The view object.
	 * @param {object} pGroup The group object.
	 * @param {object} pInput The input object.
	 * @param {string} pHTMLSelector The HTML selector.
	 * @param {number} pRowIndex The row index for tabular context.
	 * @param {boolean} isTabular Whether the context is tabular or not.
	 * @param {HTMLSelectElement} tmpInputSelectElement The select input element to set the options and values on.
	 * @param {boolean} tmpIsMultiple Whether the select input allows multiple selections or not.
	 * @param {Array<string>} tmpValues The input values to set on the select element.
	 */
	_onDataMarshalToForm(pView, pGroup, pInput, pHTMLSelector, pRowIndex, isTabular = false, tmpInputSelectElement, tmpIsMultiple, tmpValues)
	{
		// TODO: Consolidated a lot of the excess to this method so we can abstract/remove it proplery when we migrate to initalizing select2 in onInitialize and only refreshing the options list in onDataMarshalToForm,
		// but for now we need to ensure the select2 plugin is initialized before we set the options and values because of how "AllowCustomValues" works (since it relies on the "createTag" option in select2 which needs to be set at initialization),
		// and we also need to handle the case where the options list is coming from a dynamic pick list that needs to be loaded asynchronously, so we have some extra plumbing here to handle those cases for now.
		const tmpDynamicValues = pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.listDefinitions[pInput.PictForm.SelectOptionsPickList]?.Dynamic;
		let tmpChanged = false;
		for (const tmpValue of tmpValues)
		{
			let tmpValueSelected = false;

			//FIXME: this only works for initialization; it does nothing after select2 takes over
			for (let i = 0; i < tmpInputSelectElement.options.length; i++)
			{
				if (tmpInputSelectElement.options[i].value === tmpValue)
				{
					tmpInputSelectElement.options[i].selected = true;
					if (!tmpIsMultiple)
					{
						tmpInputSelectElement.selectedIndex = i;
						tmpChanged = true;
					}
					tmpValueSelected = true;
					break;
				}
			}

			if (tmpValue && !tmpValueSelected)
			{
				if (pInput.PictForm?.AllowCustomValues || tmpDynamicValues)
				{
					// if the value is not found in the select options, add it as a custom value
					const tmpOption = document.createElement('option');
					const tmpOptionInfo = pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList, { extractRootKey: tmpValue })[0];
					tmpOption.value = tmpOptionInfo?.id ?? tmpValue;
					tmpOption.text = tmpOptionInfo?.text ?? tmpValue;
					tmpOption.selected = true;
					tmpInputSelectElement.appendChild(tmpOption);
					tmpChanged = true;
				}
				else if (!tmpIsMultiple)
				{
					tmpInputSelectElement.selectedIndex = -1;
					tmpChanged = true;
					this.pict.log.error(`The value [${tmpValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
				}
			}
		}
		// only refresh the select list if custom values are not allowed (we don't want to lose custom values)
		if (!pInput.PictForm?.AllowCustomValues)
		{
			const tmpRow = pView.getRow(pInput.PictForm.GroupIndex, pRowIndex);
			this.refreshSelectList(pView, pGroup, tmpRow, pInput, tmpValues, pHTMLSelector, isTabular, pRowIndex);
		}
		// TODO: This needs to be moved to onInitialize and cleaned up, but for now we need to ensure the select2 plugin is initialized before we set the options and values
		// NOTE: There needs to be some adjustments to "allowCustomValues" to continue to work.
		this.initializeSelect2(pInput, isTabular, pRowIndex);
		// if we need to push change to Select2 but don't want it trigger the change event (which can cause issues with cascading selects),
		// we can trigger the 'change.select2' event which will update the Select2 UI without triggering the change event handlers
		if (tmpIsMultiple)
		{
			const tmpCurrentSelection = new Set($(tmpInputSelectElement).val() || []);
			if (tmpValues.length !== tmpCurrentSelection.size)
			{
				$(tmpInputSelectElement).val(tmpValues);
				tmpChanged = true;
			}
			else
			{
				for (const tmpValue of tmpValues)
				{
					if (!tmpCurrentSelection.has(tmpValue))
					{
						$(tmpInputSelectElement).val(tmpValues);
						tmpChanged = true;
						break;
					}
				}
			}
		}
		else
		{
			const tmpCurrentValue = $(tmpInputSelectElement).val();
			if (tmpValues.length === 0 && tmpCurrentValue != null || tmpCurrentValue != tmpValues[0])
			{
				$(tmpInputSelectElement).val(tmpValues.length > 0 ? tmpValues[0] : null);
				tmpChanged = true;
			}
		}
		if (tmpChanged)
		{
			$(tmpInputSelectElement).trigger('change.select2');
		}
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpIsMultiple = pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true;
		const tmpValues = tmpIsMultiple ? (pValue && typeof(pValue) === 'string' ? pValue.split(',') : []) : pValue ? [ pValue ] : [];
		// When there is no live <select> to drive, render the selected option's label into
		// the static DISPLAY-FOR node instead. This covers the non-interactive PDF view AND
		// the Read (locked) theme, whose Tier-2.5 a11y treatment renders a static display node
		// rather than a `<select disabled>`. In Edit the DISPLAY-FOR id is absent, so the
		// assignContent inside handlePDFDisplay is a harmless no-op.
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (this.pict.AppData.Interactive === false || !tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			this.handlePDFDisplay(pInput, pValue, null, false, tmpValues);
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		this._onDataMarshalToForm(pView, pGroup, pInput, pHTMLSelector, null, false, tmpInputSelectElements[0], tmpIsMultiple, tmpValues);
		this.removeLoadingSkeleton(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID), pInput.Macro.RawHTMLID);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpIsMultiple = pInput.PictForm.InputType === 'Select2Multiple' || pInput.PictForm.Multiple == true;
		const tmpValues = tmpIsMultiple ? (pValue && typeof(pValue) === 'string' ? pValue.split(',') : []) : pValue ? [ pValue ] : [];
		// As with the standard case: when there is no live <select> (PDF view or the Read
		// theme's static display node), render the label into the DISPLAY-TABULAR-FOR node.
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		if (this.pict.AppData.Interactive === false || !tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			this.handlePDFDisplay(pInput, pValue, pRowIndex, true, tmpValues);
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		this._onDataMarshalToForm(pView, pGroup, pInput, pHTMLSelector, pRowIndex, true, tmpInputSelectElements[0], tmpIsMultiple, tmpValues);
		this.removeLoadingSkeleton(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex), pInput.Macro.RawHTMLID);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the display of the select input value for PDF view.
	 * TODO: This will go away when we migrate the initialization to be on the onInitialize event instead of onDataMarshalToForm, but for now,
	 * abstracting the mess to make it easier to remove later.
	 *
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be displayed.
	 * @param {number} pRowIndex - The row index for tabular context.
	 * @param {boolean} isTabular - Whether the context is tabular or not.
	 * @param {Array<string>} tmpValues - The array of values to be displayed.
	 */
	handlePDFDisplay(pInput, pValue, pRowIndex, isTabular = false, tmpValues)
	{
		const methodNameByContext = isTabular ? 'getTabularSelectPDFDisplayHTMLID' : 'getSelectPDFDisplayHTMLID';
		// set the display value
		const tmpDisplayValues = [];
		let tmpDefaultData = pInput.PictForm.SelectOptions;

		// Entity-backed vocabularies label the Read / PDF nodes from the loaded rows, matching Edit. This
		// path never runs refreshSelectList, so it is usually what STARTS the load — repaint once it
		// lands, otherwise a managed-only code would be stuck showing as its raw code here.
		const tmpEntityOptions = this.resolveEntitySelectOptions(pInput, () => this.handlePDFDisplay(pInput, pValue, pRowIndex, isTabular, tmpValues));
		if (Array.isArray(tmpEntityOptions) && tmpEntityOptions.length > 0)
		{
			tmpDefaultData = tmpEntityOptions;
		}

		// When the input is backed by a dynamic picklist (SelectOptionsPickList) rather than a
		// static SelectOptions array, resolve the option set from the DynamicMetaLists provider —
		// the same source the Edit/marshal paths use. Without this the Read (locked) and PDF
		// display nodes stay blank for picklist-backed Select2 inputs, since SelectOptions is empty.
		if ((!tmpDefaultData || tmpDefaultData.length < 1) &&
			pInput.PictForm.SelectOptionsPickList &&
			this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpDefaultData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		for (let i=0; i<tmpValues.length; i++)
		{
			// find the text value for the selected value (by id)
			const tmpIndex = (tmpDefaultData && tmpDefaultData.length > 0) ?
				tmpDefaultData.findIndex((tmpSelection) => tmpSelection.id == tmpValues[i]) :
				-1;
			if (tmpIndex > -1)
			{
				tmpDisplayValues.push(tmpDefaultData[tmpIndex].text);
			}
			else if (pInput.PictForm.AllowCustomValues || pInput.PictForm.SelectOptionsEntity)
			{
				// Custom / free-entry values have no option row; show the raw value so a
				// picklist-backed or custom selection still renders in Read and PDF views. An
				// entity-backed vocabulary gets the same treatment: a stored code that has been
				// retired from the managed list still renders as its code rather than blank.
				tmpDisplayValues.push(tmpValues[i]);
			}
		}
		this.pict.ContentAssignment.assignContent(this[methodNameByContext](pInput.Macro.RawHTMLID, pRowIndex), tmpDisplayValues.join(', '));
		return;
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Special handling for filters inputs, do not remove.
		if (pView.Hash === 'PSRSFilterProxyView')
		{
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.InformaryDataAddress.replace('StringArrayValue', 'Values'), pValue ? pValue.split(',') : []);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"./_EntityOptionSource.js":157,"pict-section-form":587}],138:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class SignatureInputHandler extends PictSectionInputExtension
{
	/**
	 * @param {any} pFable
	 * @param {Record<string, any> | undefined} pOptions
	 * @param {string | undefined} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Modal drawing state (active only while the modal is open)
		/** @type {HTMLCanvasElement | null} */
		this._canvas = null;
		/** @type {CanvasRenderingContext2D | null} */
		this._ctx = null;
		/** @type {boolean} */
		this._isDrawing = false;
		/** @type {number} */
		this._lastX = 0;
		/** @type {number} */
		this._lastY = 0;
		/** @type {number} */
		this._strokePointCount = 0;
		/** @type {number} - current smoothed line width for pressure/velocity tapering */
		this._currentWidth = 2;
		/** @type {number} - timestamp of the last pointer move for velocity calculation */
		this._lastTime = 0;

		// Tracks whether user cleared the canvas (reset to pristine on apply)
		/** @type {boolean} */
		this._cleared = false;

		// Undo/Redo stacks (stored as canvas data URLs)
		/** @type {string[]} */
		this._undoStack = [];
		/** @type {string[]} */
		this._redoStack = [];

		// Current modal settings
		/** @type {string} */
		this._inkColor = '#000000';
		/** @type {number} */
		this._penThickness = 2;
		/** @type {boolean} */
		this._printName = true;
		/** @type {boolean} */
		this._printTitle = true;
		/** @type {boolean} */
		this._printDate = true;
		/** @type {string} */
		this._dateFormat = 'MM/DD/YYYY hh:mm A';
		/** @type {string} */
		this._timezone = 'UTC';

		// Track which input the modal is editing
		/** @type {string} */
		this._activeInputHTMLID = '';
		/** @type {string} */
		this._activeInputHash = '';
		/** @type {boolean} */
		this._activeIsTabular = false;
		/** @type {number | string | null} */
		this._activeRowIndex = null;

		// Bound event handlers (for cleanup)
		/** @type {((e: PointerEvent) => void) | null} */
		this._boundPointerDown = null;
		/** @type {((e: PointerEvent) => void) | null} */
		this._boundPointerMove = null;
		/** @type {((e: PointerEvent) => void) | null} */
		this._boundPointerUp = null;
	}

	// ── Element ID helpers ───────────────────────────────────────────

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 */
	getPreviewHTMLID(pInputHTMLID)
	{
		return `#SIGNATURE-PREVIEW-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string | number} pRowIndex - The row index if this is a tabular input
	 */
	getTabularPreviewHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-SIGNATURE-PREVIEW-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 */
	getInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string | number | undefined} pRowIndex - The row index if this is a tabular input
	 */
	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	injectCustomCSS()
	{
		if (document.getElementById('SignatureInputCustomStyles')) return;

		const style = document.createElement('style');
		style.id = 'SignatureInputCustomStyles';
		style.textContent = /*css*/`
			.signature-preview-image {
				border: 1px dashed hsl(0,0%,80%);
				border-radius: 4px;
				width: 100%;
				height: 120px;
				aspect-ratio: 5 / 1;
				object-fit: contain;
				object-position: center;
				background: transparent;
			}
			.signature-preview-image[disabled] {
				opacity: 0.6;
				cursor: not-allowed;
			}
			.signature-preview-image.print-only-signature-preview {
				border: none;
			}
			.signature-edit-button {
				position: absolute;
				top: 4px;
				right: 4px;
				z-index:1;
			}
			.signature-preview-container {
				position: relative;
				cursor: pointer;
			}
			.signature-preview-container.is-danger .signature-preview-image {
				border-color: var(--bulma-danger);
			}
			.signature-preview-container.is-success .signature-preview-image {
				border-color: var(--bulma-success);
			}
			/* Toolbar buttons intentionally inherit the default themed Bulma .button styling
			   so they follow light/dark; no hardcoded background (which didn't spin with the theme). */
		`;
		document.head.appendChild(style);
	}

	// ── Placeholder image generation ─────────────────────────────────

	/**
	 * Generates a transparent PNG with dim "add signature" text for the pristine state.
	 * @returns {string} data URL of the placeholder PNG
	 */
	generatePlaceholderImage()
	{
		const tmpCanvas = document.createElement('canvas');
		tmpCanvas.width = 400;
		tmpCanvas.height = 120;
		const tmpCtx = tmpCanvas.getContext('2d');

		if (tmpCtx)
		{
			// transparent background (default)
			tmpCtx.clearRect(0, 0, tmpCanvas.width, tmpCanvas.height);

			// dim placeholder text
			tmpCtx.fillStyle = 'rgba(180, 180, 180, 0.6)';
			tmpCtx.font = 'italic 15px sans-serif';
			tmpCtx.textAlign = 'center';
			tmpCtx.textBaseline = 'middle';
			tmpCtx.fillText('add signature', tmpCanvas.width / 2, tmpCanvas.height / 2);
		}

		return tmpCanvas.toDataURL('image/png');
	}

	// ── Preview management ───────────────────────────────────────────

	/**
	 * Sets the preview image src to either the stored value or the placeholder.
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string} pValue - base64 encoded PNG value (or empty)
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {any} [pRowIndex] - The row index if this is a tabular input
	 */
	updatePreviewImage(pInputHTMLID, pValue, isTabular = false, pRowIndex = null)
	{
		const tmpSelector = isTabular ? this.getTabularPreviewHTMLID(pInputHTMLID, pRowIndex) : this.getPreviewHTMLID(pInputHTMLID);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpSelector);

		if (Array.isArray(tmpElements) && tmpElements.length > 0)
		{
			const tmpImg = tmpElements[0];
			if (tmpImg instanceof HTMLImageElement)
			{
				if (pValue)
				{
					// Value is stored as raw base64; add the data URI prefix for display
					tmpImg.src = pValue.startsWith('data:') ? pValue : `data:image/png;base64,${pValue}`;
				}
				else
				{
					tmpImg.src = this.generatePlaceholderImage();
				}
			}
		}
	}

	/**
	 * Updates the hidden input value and dispatches a change event.
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input to update
	 * @param {string} pValue - base64 string (without data URI prefix)
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {any} [pRowIndex] - The row index if this is a tabular input
	 */
	updateHiddenInputValue(pInputHTMLID, pValue, isTabular = false, pRowIndex = null)
	{
		const tmpSelector = isTabular ? this.getTabularInputHTMLID(pInputHTMLID, pRowIndex) : this.getInputHTMLID(pInputHTMLID);
		const tmpElements = this.pict.ContentAssignment.getElement(tmpSelector);

		if (Array.isArray(tmpElements) && tmpElements.length > 0)
		{
			const tmpInput = tmpElements[0];
			if (tmpInput instanceof HTMLInputElement)
			{
				this.pict.ContentAssignment.assignContent(tmpSelector, pValue);
				const event = new Event('change', { bubbles: true });
				tmpInput.dispatchEvent(event);
			}
		}
	}

	// ── Canvas settings from PictForm ────────────────────────────────

	/**
	 * Reads CanvasSettings from the PictForm input descriptor using direct view/input lookup.
	 * @param {string} pViewHash - The view hash for direct lookup
	 * @param {string} pInputHash - The input hash to look up
	 * @returns {{ InkColor: string, PenThickness: number, PrintName: boolean, PrintTitle: boolean, PrintDate: boolean, DateFormat: string, Timezone: string }}
	 */
	getCanvasSettings(pViewHash, pInputHash)
	{
		const tmpDefaultTimezone = this.fable.options?.Timezone || this.pict.AppData?.CurrentUser?.Timezone || new Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
		const tmpDefaults = { InkColor: '#000000', PenThickness: 2, PrintName: true, PrintTitle: true, PrintDate: true, DateFormat: 'MM/DD/YYYY hh:mm A', Timezone: tmpDefaultTimezone };

		const tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.getInputFromHash) return tmpDefaults;

		const tmpInput = tmpView.getInputFromHash(pInputHash);
		if (!tmpInput?.PictForm?.CanvasSettings) return tmpDefaults;

		return {
			InkColor: tmpInput.PictForm.CanvasSettings.InkColor || tmpDefaults.InkColor,
			PenThickness: tmpInput.PictForm.CanvasSettings.PenThickness || tmpDefaults.PenThickness,
			PrintName: tmpInput.PictForm.CanvasSettings.hasOwnProperty('PrintName') ? tmpInput.PictForm.CanvasSettings.PrintName : tmpDefaults.PrintName,
			PrintTitle: tmpInput.PictForm.CanvasSettings.hasOwnProperty('PrintTitle') ? tmpInput.PictForm.CanvasSettings.PrintTitle : tmpDefaults.PrintTitle,
			PrintDate: tmpInput.PictForm.CanvasSettings.hasOwnProperty('PrintDate') ? tmpInput.PictForm.CanvasSettings.PrintDate : tmpDefaults.PrintDate,
			DateFormat: tmpInput.PictForm.CanvasSettings.DateFormat || tmpDefaults.DateFormat,
			Timezone: tmpInput.PictForm.CanvasSettings.Timezone || tmpDefaults.Timezone,
		};
	}

	// ── Named color map ──────────────────────────────────────────────

	/**
	 * Resolves a color name or hex value to a hex code for use on the canvas.
	 * @param {string} pColor - The color name or hex code from the configuration
	 * @returns {string} hex color code (e.g. "#FF0000")
	 */
	resolveColor(pColor)
	{
		if (!pColor) return '#000000';

		// If it's already a hex code, return it directly
		if (pColor.startsWith('#')) return pColor;

		/** @type {Record<string, string>} */
		const tmpColorMap = {
			'black': '#000000',
			'blue': '#0000FF',
			'royal blue': '#4169E1',
			'royalblue': '#4169E1',
			'red': '#FF0000',
			'dark blue': '#00008B',
			'darkblue': '#00008B',
			'navy': '#000080',
			'green': '#008000',
			'dark green': '#006400',
			'purple': '#800080',
			'brown': '#8B4513',
			'gold': '#FFD700',
			'gray': '#808080',
			'grey': '#808080',
		};

		return tmpColorMap[pColor.toLowerCase()] || pColor;
	}

	// ── Modal / Canvas ───────────────────────────────────────────────

	/**
	 * Opens the signature drawing modal.
	 * @param {string} pInputHTMLID - The HTML ID of the hidden input this signature is for
	 * @param {string} pViewHash - The view hash for looking up canvas settings
	 * @param {string} pInputHash - The input hash for looking up canvas settings
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {any} [pRowIndex] - The row index if this is a tabular input
	 * @param {boolean} [pDisabled=false] - Whether the input is disabled
	 */
	openSignatureModal(pInputHTMLID, pViewHash, pInputHash, isTabular = false, pRowIndex = null, pDisabled = false)
	{
		if (pDisabled) return;

		// Store active context
		this._activeInputHTMLID = pInputHTMLID;
		this._activeInputHash = pInputHash;
		this._activeIsTabular = isTabular;
		this._activeRowIndex = pRowIndex;

		// Read configuration
		const tmpSettings = this.getCanvasSettings(pViewHash, pInputHash);
		this._inkColor = this.resolveColor(tmpSettings.InkColor);
		this._penThickness = tmpSettings.PenThickness;
		this._printName = tmpSettings.PrintName;
		this._printTitle = tmpSettings.PrintTitle;
		this._printDate = tmpSettings.PrintDate;
		this._dateFormat = tmpSettings.DateFormat;
		this._timezone = tmpSettings.Timezone;

		// Reset undo/redo stacks
		this._undoStack = [];
		this._redoStack = [];

		// Read current value so we can pre-populate the canvas
		const tmpInputSelector = isTabular ? this.getTabularInputHTMLID(pInputHTMLID, pRowIndex) : this.getInputHTMLID(pInputHTMLID);
		const tmpInputElements = this.pict.ContentAssignment.getElement(tmpInputSelector);
		let tmpCurrentValue = '';
		if (Array.isArray(tmpInputElements) && tmpInputElements.length > 0 && tmpInputElements[0] instanceof HTMLInputElement)
		{
			tmpCurrentValue = tmpInputElements[0].value || '';
		}

		// Size the modal canvas from the preview area — match its rendered height directly
		// so the signing area is visually consistent with the preview.
		const tmpPreviewSelector = isTabular ? this.getTabularPreviewHTMLID(pInputHTMLID, pRowIndex) : this.getPreviewHTMLID(pInputHTMLID);
		const tmpPreviewElements = this.pict.ContentAssignment.getElement(tmpPreviewSelector);
		let tmpCanvasWidth = 600;
		let tmpCanvasHeight = 120;
		if (Array.isArray(tmpPreviewElements) && tmpPreviewElements.length > 0 && tmpPreviewElements[0] instanceof HTMLElement)
		{
			const tmpPreviewRect = tmpPreviewElements[0].getBoundingClientRect();
			if (tmpPreviewRect.width > 0)
			{
				tmpCanvasWidth = Math.round(tmpPreviewRect.width * 2);
			}
			if (tmpPreviewRect.height > 0)
			{
				tmpCanvasHeight = Math.round(tmpPreviewRect.height);
			}
		}

		// Build watermark overlay HTML (hidden when editing an existing signature, shown after clear)
		const tmpUser = this.pict.AppData?.CurrentUser;
		let tmpWatermarkInnerHTML = '';

		// Bottom-left: title (bold) + bullet + name
		const tmpWatermarkTitle = this._printTitle ? (tmpUser?.Title || '').trim() : '';
		const tmpWatermarkName = this._printName ? ((tmpUser?.NameFirst || '') + ' ' + (tmpUser?.NameLast || '')).trim() : '';
		const tmpWatermarkParts = [];
		if (tmpWatermarkTitle) tmpWatermarkParts.push(`<strong style="color: rgba(200,200,200,0.6);">${tmpWatermarkTitle}</strong>`);
		if (tmpWatermarkName) tmpWatermarkParts.push(tmpWatermarkName);
		if (tmpWatermarkParts.length > 0)
		{
			tmpWatermarkInnerHTML += `<span style="position:absolute; bottom:8px; left:10px; font:11px sans-serif; color:rgba(200,200,200,0.6); pointer-events:none;">${tmpWatermarkParts.join(' &bull; ')}</span>`;
		}

		// Bottom-right: timestamp placeholder
		if (this._printDate)
		{
			tmpWatermarkInnerHTML += `<span style="position:absolute; bottom:8px; right:10px; font:11px sans-serif; color:rgba(200,200,200,0.6); pointer-events:none;">timestamp</span>`;
		}

		// Signature line / watermark divider
		tmpWatermarkInnerHTML += `<div style="position:absolute; bottom:25px; left:8px; right:8px; height:0; border-top:1px solid rgba(180,180,180,0.5); pointer-events:none;"></div>`;

		const tmpWatermarkHTML = `<div id="SignatureModal-WatermarkOverlay" style="pointer-events:none;${tmpCurrentValue ? ' display:none;' : ''}">${tmpWatermarkInnerHTML}</div>`;

		const tmpModalBodyTemplate = /*HTML*/`
			<div class="signature-modal-body">
				<div class="signature-toolbar level is-mobile mb-3">
					<div class="level-left">
						<div class="level-item">
							<div class="field has-addons mb-0">
								<p class="control">
									<button type="button" class="button is-small" id="SignatureModal-Undo" title="Undo" aria-label="Undo last stroke"
										onclick="_Pict.providers.SignatureProvider.handleUndo();">
										<span class="icon is-small"><i class="fas fa-undo"></i></span>
									</button>
								</p>
								<p class="control">
									<button type="button" class="button is-small" id="SignatureModal-Redo" title="Redo" aria-label="Redo last stroke"
										onclick="_Pict.providers.SignatureProvider.handleRedo();">
										<span class="icon is-small"><i class="fas fa-redo"></i></span>
									</button>
								</p>
								<p class="control">
									<button type="button" class="button is-small" id="SignatureModal-Clear" title="Clear"
										onclick="_Pict.providers.SignatureProvider.handleClear();">
										<span class="icon is-small"><i class="fas fa-eraser"></i></span>
										<span>Clear</span>
									</button>
								</p>
							</div>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">
							<label class="label is-small pr-2" for="SignatureModal-PenThickness">Thickness</label>
							<input type="range" id="SignatureModal-PenThickness" class="slider" min="1" max="8" step="1" value="${this._penThickness}"
										oninput="_Pict.providers.SignatureProvider.handleThicknessChange(this.value);" />
						</div>
						<div class="level-item">
							<label class="label is-small pr-2" for="SignatureModal-InkColor">Ink Color</label>
							<input type="color" id="SignatureModal-InkColor" class="input is-small" value="${this._inkColor}"
								style="width:36px; cursor:pointer; padding:2px;"
								oninput="_Pict.providers.SignatureProvider.handleColorChange(this.value);" />
						</div>
					</div>
				</div>
				<div style="position:relative;">
					<canvas id="SignatureModal-Canvas"
						role="img" aria-label="Signature drawing area"
						style="border:1px solid hsl(0,0%,86%); border-radius:4px; cursor:crosshair; touch-action:none; width:100%; height:${tmpCanvasHeight}px; display:block; background:#fff;"
						width="${tmpCanvasWidth}" height="${tmpCanvasHeight}">
					</canvas>
					${tmpWatermarkHTML}
				</div>
			</div>`;

		// Use the field's label text as the modal title
		const tmpLabelElement = document.querySelector(`label[for="${pInputHTMLID}"]`);
		const tmpModalTitle = (tmpLabelElement && tmpLabelElement.textContent) ? tmpLabelElement.textContent.trim() : 'Signature';

		this.fable.HeadlightModal.spawnModal(
			{
				title: tmpModalTitle,
				modalBodyTemplate: tmpModalBodyTemplate,
				confirmText: 'Apply',
				cancelText: 'Cancel',
			},
			// On Apply
			() =>
			{
				this.applySignature();
			},
			// On Cancel (discard)
			null,
		);

		// Use a short timeout to ensure the modal DOM is ready before initializing the canvas
		setTimeout(() => this.initializeCanvas(tmpCurrentValue), 100);
	}

	/**
	 * Initializes the canvas within the modal, sets up drawing events, and loads existing signature data.
	 * @param {string} pExistingValue - base64 value of an existing signature (or empty)
	 */
	initializeCanvas(pExistingValue)
	{
		const tmpCanvasElement = document.getElementById('SignatureModal-Canvas');
		if (!tmpCanvasElement || !(tmpCanvasElement instanceof HTMLCanvasElement))
		{
			this.pict.log.error('[SignatureProvider] Could not find signature canvas in modal.');
			return;
		}
		this._canvas = tmpCanvasElement;
		this._ctx = this._canvas.getContext('2d');

		if (!this._ctx)
		{
			this.pict.log.error('[SignatureProvider] Could not get 2D context from canvas.');
			return;
		}

		// Scale canvas internal resolution by devicePixelRatio for crisp rendering on retina displays
		const tmpRect = this._canvas.getBoundingClientRect();
		const tmpDPR = window.devicePixelRatio || 1;
		if (tmpRect.width > 0)
		{
			this._canvas.width = tmpRect.width * tmpDPR;
			this._canvas.height = (tmpRect.height || 200) * tmpDPR;
			this._ctx.scale(tmpDPR, tmpDPR);
		}
		// Set initial drawing style
		this._ctx.lineCap = 'round';
		this._ctx.lineJoin = 'round';
		this._ctx.strokeStyle = this._inkColor;
		this._ctx.lineWidth = this._penThickness;
		this._ctx.imageSmoothingEnabled = true;

		// Fill with white background
		this._ctx.fillStyle = '#ffffff';
		this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);

		// Load existing signature if we have one
		if (pExistingValue)
		{
			const tmpImage = new Image();
			tmpImage.onload = () =>
			{
				if (!this._ctx || !this._canvas) return;
				// Bypass the DPR scale transform to draw at native canvas resolution
				this._ctx.save();
				this._ctx.setTransform(1, 0, 0, 1, 0, 0);
				this._ctx.drawImage(tmpImage, 0, 0, this._canvas.width, this._canvas.height);
				this._ctx.restore();
				this.pushUndoState();
			};
			tmpImage.src = pExistingValue.startsWith('data:') ? pExistingValue : `data:image/png;base64,${pExistingValue}`;
		}
		else
		{
			this.pushUndoState();
		}

		// Bind pointer events for mouse and touch drawing
		this._boundPointerDown = (/** @type {PointerEvent} */ e) => this.onPointerDown(e);
		this._boundPointerMove = (/** @type {PointerEvent} */ e) => this.onPointerMove(e);
		this._boundPointerUp = (/** @type {PointerEvent} */ e) => this.onPointerUp(e);

		this._canvas.addEventListener('pointerdown', this._boundPointerDown);
		this._canvas.addEventListener('pointermove', this._boundPointerMove);
		this._canvas.addEventListener('pointerup', this._boundPointerUp);
		this._canvas.addEventListener('pointerleave', this._boundPointerUp);
	}

	// ── Drawing events ───────────────────────────────────────────────

	/**
	 * @param {PointerEvent} pEvent - The pointer event for pointerdown, used to start drawing on the canvas
	 */
	onPointerDown(pEvent)
	{
		if (!this._ctx || !this._canvas) return;
		pEvent.preventDefault();
		this._isDrawing = true;
		this._cleared = false;
		this._strokePointCount = 0;
		this._currentWidth = this._penThickness;
		this._lastTime = Date.now();
		const tmpPos = this.getCanvasPosition(pEvent);
		this._lastX = tmpPos.x;
		this._lastY = tmpPos.y;

		this._ctx.strokeStyle = this._inkColor;
		this._ctx.lineWidth = this._penThickness;
		this._ctx.beginPath();
		this._ctx.moveTo(this._lastX, this._lastY);
	}

	/**
	 * @param {PointerEvent} pEvent - The pointer event for pointermove, used to draw on the canvas.
	 * Uses quadratic Bézier curves through midpoints for smooth, natural-looking strokes.
	 */
	onPointerMove(pEvent)
	{
		if (!this._isDrawing || !this._ctx || !this._canvas) return;
		pEvent.preventDefault();

		const tmpPos = this.getCanvasPosition(pEvent);
		this._strokePointCount++;

		// ── Pressure / velocity-based width tapering ─────────────────
		const tmpMinWidth = this._penThickness * 0.3;
		const tmpMaxWidth = this._penThickness * 1.6;
		let tmpTargetWidth = this._penThickness;

		if (pEvent.pressure && pEvent.pressure > 0 && pEvent.pressure < 1)
		{
			// Hardware pressure available (stylus / Apple Pencil / pressure-capable trackpad)
			tmpTargetWidth = tmpMinWidth + (tmpMaxWidth - tmpMinWidth) * pEvent.pressure;
		}
		else
		{
			// No hardware pressure — derive from pointer velocity (faster = thinner)
			const tmpNow = Date.now();
			const tmpDt = tmpNow - this._lastTime;
			this._lastTime = tmpNow;

			if (tmpDt > 0)
			{
				const tmpDx = tmpPos.x - this._lastX;
				const tmpDy = tmpPos.y - this._lastY;
				const tmpDist = Math.sqrt(tmpDx * tmpDx + tmpDy * tmpDy);
				const tmpVelocity = tmpDist / tmpDt; // px per ms

				// Map velocity to width: slow strokes are thick, fast strokes are thin
				const tmpVelocityFactor = Math.min(tmpVelocity / 1.5, 1);
				tmpTargetWidth = tmpMaxWidth - (tmpMaxWidth - tmpMinWidth) * tmpVelocityFactor;
			}
		}

		// Smooth the width transition to avoid sudden jumps between segments
		this._currentWidth += (tmpTargetWidth - this._currentWidth) * 0.3;
		this._ctx.lineWidth = this._currentWidth;

		// ── Bézier midpoint smoothing ────────────────────────────────
		// Calculate the midpoint between the previous position and the current position
		const tmpMidX = (this._lastX + tmpPos.x) / 2;
		const tmpMidY = (this._lastY + tmpPos.y) / 2;

		// Draw a quadratic Bézier curve from the current path position to the midpoint,
		// using the previous position as the control point. This produces smooth C1-continuous
		// curves that join seamlessly at each midpoint.
		this._ctx.strokeStyle = this._inkColor;
		this._ctx.quadraticCurveTo(this._lastX, this._lastY, tmpMidX, tmpMidY);
		this._ctx.stroke();

		// Continue the path from the midpoint so the next segment connects smoothly
		this._ctx.beginPath();
		this._ctx.moveTo(tmpMidX, tmpMidY);

		this._lastX = tmpPos.x;
		this._lastY = tmpPos.y;
	}

	/**
	 * @param {PointerEvent} pEvent - The pointer event for pointerup or pointerleave
	 */
	onPointerUp(pEvent)
	{
		if (!this._isDrawing || !this._ctx) return;
		// Draw a final segment to the last known position so the stroke tip isn't clipped
		this._ctx.lineTo(this._lastX, this._lastY);
		this._ctx.stroke();
		this._isDrawing = false;
		this.pushUndoState();
	}

	/**
	 * Calculates the position relative to the canvas element.
	 * @param {PointerEvent} pEvent - The pointer event containing clientX and clientY
	 * @returns {{ x: number, y: number }}
	 */
	getCanvasPosition(pEvent)
	{
		if (!this._canvas) return { x: 0, y: 0 };
		const tmpRect = this._canvas.getBoundingClientRect();
		return {
			x: pEvent.clientX - tmpRect.left,
			y: pEvent.clientY - tmpRect.top,
		};
	}

	// ── Undo / Redo / Clear ──────────────────────────────────────────

	pushUndoState()
	{
		if (!this._canvas) return;
		this._undoStack.push(this._canvas.toDataURL('image/png'));
		// New action clears the redo stack
		this._redoStack = [];
	}

	handleUndo()
	{
		if (!this._canvas || this._undoStack.length <= 1) return;
		// Move the current state to the redo stack
		const tmpCurrent = this._undoStack.pop();
		if (tmpCurrent) this._redoStack.push(tmpCurrent);
		// Restore the previous state
		const tmpPrevious = this._undoStack[this._undoStack.length - 1];
		if (tmpPrevious) this.restoreCanvasFromDataURL(tmpPrevious);
	}

	handleRedo()
	{
		if (!this._canvas || this._redoStack.length < 1) return;
		const tmpState = this._redoStack.pop();
		if (!tmpState) return;
		this._undoStack.push(tmpState);
		this.restoreCanvasFromDataURL(tmpState);
	}

	handleClear()
	{
		if (!this._ctx || !this._canvas) return;
		this._ctx.fillStyle = '#ffffff';
		this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
		this._cleared = true;
		// Re-show the watermark overlay so the user sees the guides on the fresh canvas
		const tmpOverlay = document.getElementById('SignatureModal-WatermarkOverlay');
		if (tmpOverlay) tmpOverlay.style.display = '';
		this.pushUndoState();
	}

	/**
	 * Restores the canvas from a saved data URL.
	 * @param {string} pDataURL - The data URL to restore from
	 */
	restoreCanvasFromDataURL(pDataURL)
	{
		const tmpImage = new Image();
		tmpImage.onload = () =>
		{
			if (!this._ctx || !this._canvas) return;
			// Bypass the DPR scale transform to draw the snapshot pixel-for-pixel
			this._ctx.save();
			this._ctx.setTransform(1, 0, 0, 1, 0, 0);
			this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
			this._ctx.drawImage(tmpImage, 0, 0);
			this._ctx.restore();
		};
		tmpImage.src = pDataURL;
	}

	// ── Toolbar handlers ─────────────────────────────────────────────

	/**
	 * @param {string} pValue
	 */
	handleThicknessChange(pValue)
	{
		this._penThickness = parseInt(pValue, 10) || 2;
	}

	/**
	 * @param {string} pValue
	 */
	handleColorChange(pValue)
	{
		this._inkColor = pValue;
	}

	// ── Apply signature ──────────────────────────────────────────────

	/**
	 * Called when the user clicks "Apply" in the modal. Encodes the canvas to
	 * base64 PNG, writes it to the hidden input, and updates the preview image.
	 */
	applySignature()
	{
		if (!this._canvas || !this._ctx) return;

		// If the canvas was cleared, reset to pristine state
		if (this._cleared)
		{
			this.updateHiddenInputValue(this._activeInputHTMLID, '', this._activeIsTabular, this._activeRowIndex);
			this.updatePreviewImage(this._activeInputHTMLID, '', this._activeIsTabular, this._activeRowIndex);
			this.cleanupCanvasState();
			return;
		}

		// Use CSS-pixel dimensions for positioning (the DPR scale transform maps these to device pixels)
		const tmpDPR = window.devicePixelRatio || 1;
		const tmpW = this._canvas.width / tmpDPR;
		const tmpH = this._canvas.height / tmpDPR;

		// Draw signature line / watermark divider
		const tmpLineY = tmpH - 23;
		this._ctx.save();
		this._ctx.strokeStyle = 'rgba(180, 180, 180, 0.6)';
		this._ctx.lineWidth = 1;
		this._ctx.beginPath();
		this._ctx.moveTo(8, tmpLineY);
		this._ctx.lineTo(tmpW - 8, tmpLineY);
		this._ctx.stroke();
		this._ctx.restore();

		// Stamp identity and timestamp onto the canvas
		const tmpUser = this.pict.AppData?.CurrentUser;
		const tmpTitle = this._printTitle ? (tmpUser?.Title || '').trim() : '';
		const tmpPrintedName = this._printName ? ((tmpUser?.NameFirst || '') + ' ' + (tmpUser?.NameLast || '')).trim() : '';

		// Bottom-left: title (bold) + bullet + name
		const tmpIdentityParts = [];
		if (tmpTitle) tmpIdentityParts.push({ text: tmpTitle, bold: true });
		if (tmpPrintedName) tmpIdentityParts.push({ text: tmpPrintedName, bold: false });

		if (tmpIdentityParts.length > 0)
		{
			this._ctx.save();
			this._ctx.fillStyle = 'rgba(80, 80, 80, 0.7)';
			this._ctx.textAlign = 'left';
			this._ctx.textBaseline = 'bottom';

			let tmpX = 8;
			const tmpY = tmpH - 6;

			for (let i = 0; i < tmpIdentityParts.length; i++)
			{
				if (i > 0)
				{
					// Draw bullet divider between parts
					this._ctx.font = '11px sans-serif';
					this._ctx.fillText(' \u2022 ', tmpX, tmpY);
					tmpX += this._ctx.measureText(' \u2022 ').width;
				}
				this._ctx.font = tmpIdentityParts[i].bold ? 'bold 11px sans-serif' : '11px sans-serif';
				this._ctx.fillText(tmpIdentityParts[i].text, tmpX, tmpY);
				tmpX += this._ctx.measureText(tmpIdentityParts[i].text).width;
			}

			this._ctx.restore();
		}

		// Bottom-right: timestamp of signing
		const tmpTimestamp = this._printDate ? this.pict.providers.FlatpickrUtilProvider.formatDateWithTimezone('now', this._dateFormat, this._timezone) : '';
		if (tmpTimestamp)
		{
			this._ctx.save();
			this._ctx.font = '11px sans-serif';
			this._ctx.fillStyle = 'rgba(80, 80, 80, 0.7)';
			this._ctx.textAlign = 'right';
			this._ctx.textBaseline = 'bottom';
			this._ctx.fillText(tmpTimestamp, tmpW - 8, tmpH - 6);
			this._ctx.restore();
		}

		// Get the raw base64 data (strip the data URI prefix for storage)
		const tmpDataURL = this._canvas.toDataURL('image/png');
		const tmpBase64 = tmpDataURL.replace(/^data:image\/png;base64,/, '');
		// Write to hidden input
		this.updateHiddenInputValue(this._activeInputHTMLID, tmpBase64, this._activeIsTabular, this._activeRowIndex);
		// Update the preview image
		this.updatePreviewImage(this._activeInputHTMLID, tmpBase64, this._activeIsTabular, this._activeRowIndex);

		this.cleanupCanvasState();
	}

	/**
	 * Resets internal canvas/modal state after the modal closes.
	 */
	cleanupCanvasState()
	{
		if (this._canvas)
		{
			if (this._boundPointerDown) this._canvas.removeEventListener('pointerdown', this._boundPointerDown);
			if (this._boundPointerMove) this._canvas.removeEventListener('pointermove', this._boundPointerMove);
			if (this._boundPointerUp)
			{
				this._canvas.removeEventListener('pointerup', this._boundPointerUp);
				this._canvas.removeEventListener('pointerleave', this._boundPointerUp);
			}
		}

		this._canvas = null;
		this._ctx = null;
		this._isDrawing = false;
		this._cleared = false;
		this._undoStack = [];
		this._redoStack = [];
		this._activeInputHTMLID = '';
		this._activeInputHash = '';
		this._activeIsTabular = false;
		this._activeRowIndex = null;
	}

	// ── Standard lifecycle hooks ─────────────────────────────────────

	/**
	 * Handles displaying the signature value (or placeholder) when the form loads.
	 * @param {any} pInput - The input descriptor object
	 * @param {string} pValue - base64 encoded PNG value
	 * @param {boolean} [isTabular=false] - Whether this input is within a tabular section
	 * @param {number|string|null} [pRowIndex] - The row index if this is a tabular input
	 * @returns {void}
	 */
	handleInputValue(pInput, pValue, isTabular = false, pRowIndex = null)
	{
		this.updatePreviewImage(pInput.Macro.RawHTMLID, pValue, isTabular, pRowIndex);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pRow - The row object containing the input (if applicable)
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue 	- The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pRowIndex - The row index if this input is within a tabular section
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pRow - The row object containing the input (if applicable)
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, false);
		this.injectCustomCSS();
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pGroup - The group object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {any} pRowIndex - The row index if this input is within a tabular section
	 * @param {any} pTransactionGUID - The transaction GUID for this form load (if applicable)
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.handleInputValue(pInput, pValue, true, pRowIndex);
		this.injectCustomCSS();
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(pInput.Macro.RawHTMLID);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpValue, pHTMLSelector);
	}

	/**
	 * @param {any} pView - The view object containing the input
	 * @param {any} pInput - The input descriptor object
	 * @param {any} pValue - The current value for the input (base64 encoded PNG)
	 * @param {any} pHTMLSelector - The CSS selector for the input's HTML element
	 * @param {number} pRowIndex - The row index if this input is within a tabular section
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = SignatureInputHandler;

},{"pict-section-form":587}],139:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class StationInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { HeadlightStationing: import('../../../../service/headlight-stationing-service/types/Headlight-Stationing') }} */
		this.fable;
		/** @type {Pict} */
		this.pict;
	}

	getStationHiddenInputHTMLID(pInputHTMLID)
	{
		return `#${pInputHTMLID}`;
	}

	getStationDisplayInputHTMLID(pInputHTMLID)
	{
		return `#STATION-INPUT-FOR-${pInputHTMLID}`;
	}

	getTabularStationHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularStationDisplayInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#STATION-TABULAR-FOR-${pInputHTMLID}-${pRowIndex}`;
	}

	getValueRepresentations(pValue)
	{
		let tmpNumericValue;
		let tmpContent;
		if (isNaN(pValue))
		{
			tmpContent = pValue;
			tmpNumericValue = this.fable.HeadlightStationing.fromStationValue(pValue);
		}
		else
		{
			tmpNumericValue = pValue;
			tmpContent = this.fable.HeadlightStationing.toStationValue(tmpNumericValue);
		}
		return [ tmpNumericValue, tmpContent ];
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pValue)
		{
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(pValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		this.pict.ContentAssignment.assignContent(this.getStationDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getStationHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpNumericValue);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, tmpNumericValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the input in the row columns.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pValue)
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(pValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpNumericValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		this.pict.ContentAssignment.assignContent(this.getTabularStationDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getTabularStationHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpNumericValue);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, tmpNumericValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(this.getStationDisplayInputHTMLID(pInput.Macro.RawHTMLID));
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(tmpValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataRequest(pView, pInput, tmpValue, pHTMLSelector);
		}
		this.pict.ContentAssignment.assignContent(this.getStationDisplayInputHTMLID(pInput.Macro.RawHTMLID), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getStationHiddenInputHTMLID(pInput.Macro.RawHTMLID), tmpNumericValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(this.getTabularStationDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
		const [ tmpNumericValue, tmpStringValue ] = this.getValueRepresentations(tmpValue);
		if (isNaN(tmpNumericValue))
		{
			return super.onDataRequestTabular(pView, pInput, tmpValue, pHTMLSelector, pRowIndex);
		}
		this.pict.ContentAssignment.assignContent(this.getTabularStationDisplayInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpStringValue);
		this.pict.ContentAssignment.assignContent(this.getTabularStationHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpNumericValue);

		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = StationInputHandler;

},{"pict-section-form":587}],140:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @type {typeof import('pict-section-form').PictInputExtensionProvider} */
const PictSectionInputExtension_TabGroupSelector = require('pict-section-form/source/providers/inputs/Pict-Provider-Input-TabGroupSelector.js');

const libTabPrintHostCSS = require('./_TabPrintHostCSS.js');

class TabGroupSelectorInputHandler extends PictSectionInputExtension_TabGroupSelector
{
	/**
	 * @param {Object} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * Last tab the user actually selected, keyed `<viewHash>::<inputHash>`.
		 *
		 * WHY THIS EXISTS: the base provider restores the active tab purely from the
		 * input's DATA value, so ANY path that blanks it drops the user back to the
		 * default tab. On the LADOTD Sample Creation form that surfaced as "every time
		 * I manually add a test it switches tabs back" -- adding a test fires an
		 * AutofillTriggerGroup whose PostSolvers re-render the section, and the tab
		 * would snap to `DefaultTabGroupHash` mid-edit. It also took the select2
		 * dropdown down with it (the widget's element is detached by the re-render,
		 * so a subsequent open threw "Cannot read properties of null (reading 'query')").
		 *
		 * Deliberately in-memory only: this is UI position, not form data. It is NOT a
		 * replacement for the stored value -- selectTabByViewHash still writes that, so
		 * the tab survives a genuine reload. This only wins when the two disagree,
		 * which is exactly the re-render case.
		 *
		 * @type {Object<string, string>}
		 */
		this.SelectedTabByInput = {};

		// Shared with TabSectionSelector -- see _TabPrintHostCSS.js for why this registers here and
		// injects at init rather than doing both in the constructor.
		libTabPrintHostCSS.registerPrintHostCSS(this.pict);
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @return {string}
	 */
	getSelectedTabKey(pViewHash, pInputHash)
	{
		return `${pViewHash}::${pInputHash}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		// Before the print early-return on purpose: the print-host rule is exactly what the PDF needs.
		libTabPrintHostCSS.injectPrintHostCSS(this.pict);

		if (!this.pict.AppData.Interactive && pInput.PictForm?.Exclusive !== true)
		{
			// show all tabs in print mode unless Exclusive is set to true
			return;
		}

		// Prefer the tab the user last picked over whatever is in the data value, so a
		// re-render mid-edit cannot yank them back to the default tab. Fed in as pValue
		// so the base provider's precedence (DefaultFromData -> DefaultTabGroupHash ->
		// first tab) is untouched; it also re-writes the value, repairing the data.
		// Honours an explicit `DefaultFromData: false`, which means "always start on the
		// configured default" and is nobody's idea of a remembered tab.
		let tmpValue = pValue;
		if (pInput?.PictForm?.DefaultFromData !== false)
		{
			const tmpRemembered = this.SelectedTabByInput[this.getSelectedTabKey(pView?.Hash, pInput?.Hash)];
			// Only if it is still a real member of this input's tab set -- the manifest
			// can change under a long-lived page.
			if (tmpRemembered && Array.isArray(pInput?.PictForm?.TabGroupSet) && pInput.PictForm.TabGroupSet.includes(tmpRemembered))
			{
				tmpValue = tmpRemembered;
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpValue, pHTMLTabSelector, pTransactionGUID);
	}

	/**
	 * Tier-3 (Half A) a11y: after the base provider swaps the visible tab/group
	 * via CSS classes, mirror the same state into ARIA so assistive tech
	 * announces the tabs as a real tablist. We deliberately do NOT add roving
	 * tabindex or arrow-key navigation (Half B) — every tab stays natively
	 * Tab-focusable, which is already WCAG 2.x keyboard-operable.
	 *
	 * `role="tablist"`/`role="tab"`/`role="presentation"` are emitted statically
	 * by templates/InputType-TabGroupSelector.js; only the stateful bits
	 * (aria-selected) and the cross-element relationships (tab <-> group panel,
	 * whose id carries the runtime view formID) are set here. Idempotent: runs
	 * once on init and again on every tab switch.
	 *
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabHash
	 *
	 * @return {boolean}
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabHash)
	{
		const tmpResult = super.selectTabByViewHash(pViewHash, pInputHash, pTabHash);
		if (tmpResult === false)
		{
			return tmpResult;
		}

		// Remember the selection so a later re-render restores it (see the constructor).
		this.SelectedTabByInput[this.getSelectedTabKey(pViewHash, pInputHash)] = pTabHash;

		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView ? tmpView.getInputFromHash(pInputHash) : null;
		if (!tmpInput || !Array.isArray(tmpInput?.PictForm?.TabGroupSet))
		{
			return tmpResult;
		}

		for (let i = 0; i < tmpInput.PictForm.TabGroupSet.length; i++)
		{
			const tmpTabGroupHash = tmpInput.PictForm.TabGroupSet[i];
			const tmpTabID = `TAB-${tmpTabGroupHash}-${tmpInput.Macro.RawHTMLID}`;
			const tmpTabSelector = `#${tmpTabID} a`;
			const tmpPanelSelector = this.getGroupSelector(tmpView, tmpTabGroupHash);
			const tmpIsActive = (tmpTabGroupHash === pTabHash);

			// State: the active tab is the selected one.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-selected', tmpIsActive ? 'true' : 'false');
			// Relationship: tab controls its group panel; panel is a tabpanel labelled by its tab.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-controls', tmpPanelSelector.replace(/^#/, ''));
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'role', 'tabpanel');
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'aria-labelledby', tmpTabID);
		}

		return tmpResult;
	}
}

module.exports = TabGroupSelectorInputHandler;

},{"./_TabPrintHostCSS.js":167,"pict-section-form/source/providers/inputs/Pict-Provider-Input-TabGroupSelector.js":622}],141:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/** @type {typeof import('pict-section-form').PictInputExtensionProvider} */
const PictSectionInputExtension_TabSectionSelector = require('pict-section-form/source/providers/inputs/Pict-Provider-Input-TabSectionSelector.js');

const libTabPrintHostCSS = require('./_TabPrintHostCSS.js');

class TabSectionSelectorInputHandler extends PictSectionInputExtension_TabSectionSelector
{
	/**
	 * @param {Object} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Shared with TabGroupSelector -- see _TabPrintHostCSS.js for why this registers here and
		// injects at init rather than doing both in the constructor.
		libTabPrintHostCSS.registerPrintHostCSS(this.pict);
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		// Before the print early-return on purpose: the print-host rule is exactly what the PDF needs.
		libTabPrintHostCSS.injectPrintHostCSS(this.pict);

		if (!this.pict.AppData.Interactive && pInput.PictForm?.Exclusive !== true)
		{
			// show all tabs in print mode unless Exclusive is set to true
			return;
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}

	/**
	 * Tier-3 (Half A) a11y: after the base provider swaps the visible tab/panel
	 * via CSS classes, mirror the same state into ARIA so assistive tech
	 * announces the tabs as a real tablist. We deliberately do NOT add roving
	 * tabindex or arrow-key navigation (Half B) — every tab stays natively
	 * Tab-focusable, which is already WCAG 2.x keyboard-operable.
	 *
	 * `role="tablist"`/`role="tab"`/`role="presentation"` are emitted statically
	 * by templates/InputType-TabSectionSelector.js; only the stateful bits
	 * (aria-selected) and the cross-element relationships (tab <-> panel, whose
	 * panel id carries the runtime metacontroller UUID) are set here. Idempotent:
	 * runs once on init and again on every tab switch.
	 *
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabViewHash
	 *
	 * @return {boolean}
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabViewHash)
	{
		const tmpResult = super.selectTabByViewHash(pViewHash, pInputHash, pTabViewHash);
		if (tmpResult === false)
		{
			return tmpResult;
		}

		const tmpView = this.pict.views[pViewHash];
		const tmpInput = tmpView ? tmpView.getInputFromHash(pInputHash) : null;
		if (!tmpInput || !Array.isArray(tmpInput?.PictForm?.TabSectionSet))
		{
			return tmpResult;
		}

		for (let i = 0; i < tmpInput.PictForm.TabSectionSet.length; i++)
		{
			const tmpTabSectionHash = tmpInput.PictForm.TabSectionSet[i];
			const tmpTabID = `TAB-${tmpTabSectionHash}-${tmpInput.Macro.RawHTMLID}`;
			const tmpTabSelector = `#${tmpTabID} a`;
			const tmpPanelSelector = this.getSectionSelector(tmpTabSectionHash);
			const tmpIsActive = (tmpTabSectionHash === pTabViewHash);

			// State: the active tab is the selected one.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-selected', tmpIsActive ? 'true' : 'false');
			// Relationship: tab controls its panel; panel is a tabpanel labelled by its tab.
			this.pict.ContentAssignment.setAttribute(tmpTabSelector, 'aria-controls', tmpPanelSelector.replace(/^#/, ''));
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'role', 'tabpanel');
			this.pict.ContentAssignment.setAttribute(tmpPanelSelector, 'aria-labelledby', tmpTabID);
		}

		return tmpResult;
	}
}

module.exports = TabSectionSelectorInputHandler;

},{"./_TabPrintHostCSS.js":167,"pict-section-form/source/providers/inputs/Pict-Provider-Input-TabSectionSelector.js":623}],142:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Updates the rows attribute of the textarea based on the content.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be used for calculating rows.
	 * @param {number} [pRowIndex] - Row index when the textarea is a tabular cell; omit for standard inputs.
	 */
	updateTextAreaRows(pView, pInput, pValue, pRowIndex)
	{
		// Tabular textareas render with a per-row id suffix ("{RawHTMLID}-{rowIndex}",
		// per the InputType-TextArea tabular template); standard inputs use the bare
		// RawHTMLID. Match the suffix here or the lookup misses every tabular cell.
		const tmpHTMLID = (pRowIndex != null) ? `${pInput.Macro.RawHTMLID}-${pRowIndex}` : pInput.Macro.RawHTMLID;
		const textarea = document.getElementById(tmpHTMLID);
		if (!textarea)
		{
			// Expected during early render: a marshal can fire before a section's
			// (or row's) textarea DOM exists yet. Auto-grow re-applies on the next
			// marshal once it's present, so this is a benign skip — trace, not error.
			this.pict.log.trace(`[TextAreaProvider] Textarea [${tmpHTMLID}] not in DOM yet; skipping auto-grow.`);
			return;
		}
		const scrollHeight = textarea.scrollHeight;
		const minHeight = 50; // Minimum height in pixels (about 2 rows)
		const maxHeight = 300; // Maximum height in pixels (about 12 rows)
		const newHeight = Math.max(minHeight, Math.min(scrollHeight, maxHeight));
		textarea.setAttribute('style', `height: ${newHeight}px;`);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.updateTextAreaRows(pView, pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.updateTextAreaRows(pView, pInput, pValue, pRowIndex);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @return {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @return {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],143:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * Class names used by the validation UI. Centralized so the consolidated
 * styling helper can target the right classes in one place.
 *
 * @readonly
 */
const VALIDATION_CLASSES = Object.freeze({
	DANGER: 'is-danger',
	SUCCESS: 'is-success',
	VALIDATION_TEXT: 'validation-text',
	HELP_DANGER_TEXT: 'has-text-danger',
});

/** Delay (ms) before fading the success state on always-active validation. */
const SUCCESS_FADE_DELAY_MS = 2500;

/**
 * CustomInputHandler — drives the UI side of input validation for any
 * dynamic input whose template wires this provider in via PictForm.
 *
 * Responsibilities:
 *   - Resolve which validation rules apply for an input from the manifest
 *     config (PictForm) and the live DOM element, and keep the element's
 *     HTML5 validation attributes (`required`, `aria-required`) in sync.
 *   - Apply / remove the success / danger styling on the control.
 *   - Inject a human-readable validation message into the help-text wrapper.
 *
 * Visibility gating:
 *   Hidden inputs (on inactive tabs, conditionally hidden by other selections,
 *   etc.) do NOT enforce validation. They get their `required` attribute
 *   cleared at runtime so the browser/framework's `checkValidity()` returns
 *   true, and any stale danger styling / validation-text is scrubbed off.
 *   "Hidden" here means CSS display:none / visibility:hidden on the element
 *   or any ancestor. Inputs scrolled below the viewport remain enforced.
 */
class CustomInputHandler extends PictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Resolve the live HTMLInputElement for a given selector, or null if absent.
	 *
	 * @param {string} pHTMLSelector
	 * @return {HTMLInputElement|null}
	 */
	resolveInputElement(pHTMLSelector)
	{
		const tmpInputList = this.pict.ContentAssignment.getElement(pHTMLSelector);
		return (tmpInputList && tmpInputList.length > 0) ? tmpInputList[0] : null;
	}

	/**
	 * Resolve the "real" styling target for validation UI.
	 *
	 * Pict-section-form passes the *canonical* (data-bearing) input
	 * selector to our lifecycle hooks — e.g. for Station/DateTime/Date/Time
	 * that's the hidden input that holds the form value, not the visible
	 * input the user actually types into. Native `checkValidity()` on a
	 * `type="hidden"` (or otherwise CSS-hidden) input is barred and
	 * returns true even when empty, so styling against the canonical
	 * silently no-ops.
	 *
	 * This resolver returns the canonical when it's already the visible
	 * required input; otherwise it walks up to the nearest scope
	 * (`.control.control-status` → `.field` → `.column` → parent) and
	 * returns the first visible `[required]` sibling there. Signature-style
	 * inputs (hidden-only, data-validation-surface) fall back to the
	 * canonical since there is no visible required sibling to find.
	 *
	 * @param {string} pHTMLSelector
	 * @return {HTMLInputElement|null}
	 */
	resolveStylingTargetInput(pHTMLSelector)
	{
		const tmpCanonical = this.resolveInputElement(pHTMLSelector);
		if (!tmpCanonical)
		{
			return null;
		}
		// If the canonical isn't a hidden data-bearer, use it directly.
		if (!this._isHiddenDataBearer(tmpCanonical))
		{
			return tmpCanonical;
		}
		// Hidden data-bearer: walk outward looking for a visible required
		// sibling. The scope priority (control → field → column → parent)
		// matches the typical InputType template layering — most data
		// bearers live next to their visible sibling inside the same
		// control wrapper, but Station-style templates keep the hidden
		// bearer at the column level.
		if (typeof tmpCanonical.closest !== 'function')
		{
			return tmpCanonical;
		}
		const tmpScopes = [
			tmpCanonical.closest('.control.control-status'),
			tmpCanonical.closest('.field'),
			tmpCanonical.closest('.column'),
			tmpCanonical.parentElement,
		];
		const tmpSelector = 'input[required]:not([type="hidden"]):not(.is-hidden), select[required], textarea[required]';
		for (let i = 0; i < tmpScopes.length; i++)
		{
			const tmpScope = tmpScopes[i];
			if (!tmpScope || typeof tmpScope.querySelector !== 'function')
			{
				continue;
			}
			const tmpVisible = /** @type {HTMLInputElement|null} */ (tmpScope.querySelector(tmpSelector));
			if (tmpVisible && tmpVisible !== tmpCanonical)
			{
				return tmpVisible;
			}
		}
		return tmpCanonical;
	}

	/**
	 * True when the element is currently rendered to the user (i.e. not
	 * `display:none` / `visibility:hidden` on itself or any ancestor, and
	 * still attached to the DOM). Elements below the viewport count as visible.
	 *
	 * Note: this walks ancestors via getComputedStyle, which is the most
	 * robust check across tab containers, conditionally-rendered wrappers,
	 * and Bulma `is-hidden` style toggles.
	 *
	 * @param {Element|null|undefined} pElement
	 * @return {boolean}
	 */
	isInputVisibleToUser(pElement)
	{
		if (!pElement || pElement.nodeType !== 1)
		{
			return false;
		}
		if (!pElement.isConnected)
		{
			return false;
		}
		// Validation-surface indirection: an input may declare an alternate
		// user-visible element that represents it on screen (e.g. Signature
		// puts `required` on a CSS-hidden <input> while the actual visible
		// surface is a sibling <img>/<button>). When `data-validation-surface`
		// is set, check that element's visibility instead.
		const tmpSurfaceID = (pElement.getAttribute && pElement.getAttribute('data-validation-surface')) || null;
		if (tmpSurfaceID)
		{
			const tmpSurface = document.getElementById(tmpSurfaceID);
			if (tmpSurface)
			{
				return this._walkAncestorVisibility(tmpSurface);
			}
		}
		// Select2 indirection: when Select2 takes over a native <select>, it
		// hides the underlying element (aria-hidden="true", positioned
		// off-screen, class="select2-hidden-accessible") and renders its own
		// visible widget as a `.select2-container` sibling. The native select
		// is logically present and "visible to the user" — just via the
		// container surface. Without this, Pass 3 of applyFormSubmissionStyling
		// short-circuits on every Select2-managed required <select> and
		// never flags empty ones as invalid.
		if (pElement.tagName === 'SELECT' && pElement.classList && pElement.classList.contains('select2-hidden-accessible'))
		{
			const tmpContainer = this._findSelect2ContainerFor(/** @type {HTMLSelectElement} */ (pElement));
			if (tmpContainer)
			{
				return this._walkAncestorVisibility(tmpContainer);
			}
		}
		return this._walkAncestorVisibility(pElement);
	}

	/**
	 * Locate the `.select2-container` widget that Select2 injected for a
	 * given native `<select>`. Select2 normally places it as the immediate
	 * next sibling, but defensive code walks both the sibling chain and the
	 * parent's children to handle layouts that wrap the container.
	 *
	 * @param {HTMLSelectElement} pSelect
	 * @return {Element|null}
	 * @private
	 */
	_findSelect2ContainerFor(pSelect)
	{
		if (!pSelect || pSelect.nodeType !== 1)
		{
			return null;
		}
		let tmpSibling = pSelect.nextElementSibling;
		while (tmpSibling)
		{
			if (tmpSibling.classList && tmpSibling.classList.contains('select2-container'))
			{
				return tmpSibling;
			}
			tmpSibling = tmpSibling.nextElementSibling;
		}
		if (pSelect.parentElement && typeof pSelect.parentElement.querySelector === 'function')
		{
			return pSelect.parentElement.querySelector('.select2-container');
		}
		return null;
	}

	/**
	 * Internal: walk the ancestor chain checking for display:none,
	 * visibility:hidden/collapse, and aria-hidden="true". Returns false if
	 * any ancestor (or the element itself) is hidden by any of those.
	 *
	 * @param {Element} pElement
	 * @return {boolean}
	 * @private
	 */
	_walkAncestorVisibility(pElement)
	{
		let tmpCurrent = /** @type {Element|null} */ (pElement);
		while (tmpCurrent && tmpCurrent.nodeType === 1)
		{
			const tmpStyle = (typeof window !== 'undefined' && window.getComputedStyle) ? window.getComputedStyle(tmpCurrent) : null;
			if (tmpStyle)
			{
				if (tmpStyle.display === 'none')
				{
					return false;
				}
				if (tmpStyle.visibility === 'hidden' || tmpStyle.visibility === 'collapse')
				{
					return false;
				}
			}
			if (tmpCurrent.getAttribute && tmpCurrent.getAttribute('aria-hidden') === 'true')
			{
				return false;
			}
			if (tmpCurrent === document.body)
			{
				break;
			}
			tmpCurrent = tmpCurrent.parentElement;
		}
		return true;
	}

	/**
	 * Sync `required` and `aria-required` on a live DOM element so that the
	 * browser's native validity check (and any framework that consults it)
	 * matches what the user can actually see and interact with.
	 *
	 * @param {HTMLInputElement|null} pElement
	 * @param {boolean} pShouldBeRequired
	 * @return {void}
	 */
	syncRequiredAttributes(pElement, pShouldBeRequired)
	{
		if (!pElement)
		{
			return;
		}
		if (pShouldBeRequired)
		{
			if (!pElement.required)
			{
				pElement.required = true;
			}
			if (pElement.getAttribute('aria-required') !== 'true')
			{
				pElement.setAttribute('aria-required', 'true');
			}
			// Stamp the persistent marker so the pre-submit sweep can find
			// this field even after a future visibility-driven strip flips
			// `required` and `aria-required` back off.
			if (pElement.getAttribute('data-required') !== 'true')
			{
				pElement.setAttribute('data-required', 'true');
			}
		}
		else
		{
			if (pElement.required)
			{
				pElement.required = false;
			}
			if (pElement.hasAttribute('aria-required'))
			{
				pElement.removeAttribute('aria-required');
			}
			// data-required is intentionally NOT removed here — it persists
			// across visibility flips. The only place it should be cleared
			// is when the manifest itself no longer marks the field
			// required, which happens in setValidationInputAttributes when
			// PictForm explicitly says Required: false.
		}
	}

	/**
	 * Walk every "manifest says this is required" input within a form
	 * element and resync its live HTML5 / ARIA required attributes against
	 * current visibility. Strips `required` / `aria-required` /
	 * `aria-invalid` from hidden fields so the browser's checkValidity()
	 * (or any `:invalid` selector consumer) doesn't flag them, and
	 * restores `required` / `aria-required` on visible fields that may
	 * have had them stripped during an earlier hidden state.
	 *
	 * Call this immediately before `formElement.checkValidity()` or a
	 * `:invalid` query in any form-submission flow.
	 *
	 * @param {HTMLElement|null} pFormElement
	 * @return {void}
	 */
	preSubmitVisibilitySweep(pFormElement)
	{
		if (!pFormElement || typeof pFormElement.querySelectorAll !== 'function')
		{
			return;
		}
		// We query data-required (the persistent manifest marker) instead
		// of `[required]` because hidden fields may have already had their
		// `required` attribute stripped — we still need to find them to
		// decide whether to restore.
		const tmpManagedInputs = pFormElement.querySelectorAll('[data-required="true"]');
		for (let i = 0; i < tmpManagedInputs.length; i++)
		{
			const tmpInput = /** @type {HTMLInputElement} */ (tmpManagedInputs[i]);
			const tmpIsVisible = this.isInputVisibleToUser(tmpInput);
			this.syncRequiredAttributes(tmpInput, tmpIsVisible);
			if (!tmpIsVisible)
			{
				// A previously-shown error on a now-hidden field is stale —
				// clear aria-invalid + any leftover is-danger styling so it
				// doesn't lie to AT or paint a tab the user can't see.
				this.syncAriaInvalidAttribute(tmpInput, false);
				const tmpControl = this.resolveControlElement(tmpInput);
				this.clearValidationStyling(tmpControl);
				this.clearValidationHelpText(tmpControl);
			}
		}
	}

	/**
	 * Apply validation styling across an entire form after a submission
	 * attempt. Centralizes everything the validation UI needs to do:
	 *
	 *   - Walk `:invalid` inputs and stamp `is-danger` on the closest
	 *     `.control.control-status` wrapper (uses closest() so flatpickr or
	 *     other providers that wrap the input still find the right
	 *     ancestor).
	 *   - Walk `:valid` inputs and clear validity classes from the same
	 *     wrapper.
	 *   - Mirror the class onto any `.select2-container` sibling within the
	 *     wrapper — Bulma's `.is-danger` styling targets the native
	 *     `.input` / `.select` and doesn't reach Select2's replacement widget.
	 *   - Value-check any `[data-required="true"]` inputs that are CSS-
	 *     hidden or `type="hidden"` (e.g. Signature, which puts `required`
	 *     on a data-bearing input behind an `<img>` surface). Native
	 *     `:invalid` doesn't apply to these so we have to inspect `.value`
	 *     directly.
	 *   - Keep `aria-invalid` in sync on all affected inputs.
	 *
	 * Call this *after* `preSubmitVisibilitySweep()` (which has already
	 * stripped `required` from hidden fields so they don't get flagged).
	 *
	 * Returns true when every visible field passes validation (native +
	 * data-required hidden-bearer checks), so callers can use the return
	 * value as the gate decision and don't need to re-scan the form.
	 *
	 * @param {HTMLElement|null} pFormElement
	 * @return {boolean} true if form passes all visible validations.
	 */
	applyFormSubmissionStyling(pFormElement)
	{
		if (!pFormElement || typeof pFormElement.querySelectorAll !== 'function')
		{
			return true;
		}

		// Wire up the form-level live revalidation listener so subsequent
		// user edits to any input promote a previously-red wrapper to green
		// (or back to red if the user clears a required field) without
		// waiting for another submit. Idempotent — only attaches once.
		this.attachLiveRevalidation(pFormElement);

		let tmpFormIsValid = true;

		const tmpLengthLimited = pFormElement.querySelectorAll('[minlength], [maxlength]');
		for (let i = 0; i < tmpLengthLimited.length; i++)
		{
			const tmpInput = tmpLengthLimited[i];
			if (this.isInputVisibleToUser(tmpInput))
			{
				this.syncLengthValidity(tmpInput);
			}
			else if (typeof (/** @type {HTMLInputElement} */ (tmpInput)).setCustomValidity === 'function')
			{
				(/** @type {HTMLInputElement} */ (tmpInput)).setCustomValidity('');
			}
		}

		// Pass 1: anything failing native HTML5 validation. Catches required
		// fields that are empty, pattern/email/min/max mismatches, etc.
		const tmpInvalidElements = pFormElement.querySelectorAll(':invalid');
		for (let i = 0; i < tmpInvalidElements.length; i++)
		{
			this._applyValidityToWrapperAndKin(/** @type {HTMLElement} */ (tmpInvalidElements[i]), false);
			tmpFormIsValid = false;
		}

		// Pass 2: clear styling from anything that's now valid. Has to run
		// unconditionally so previously-flagged fields go back to green.
		const tmpValidElements = pFormElement.querySelectorAll(':valid');
		for (let i = 0; i < tmpValidElements.length; i++)
		{
			this._applyValidityToWrapperAndKin(/** @type {HTMLElement} */ (tmpValidElements[i]), true);
		}

		// Pass 3: walk every manifest-required input authoritatively. This
		// is the most reliable layer of the three because it doesn't rely
		// on `:valid` / `:invalid` — which silently skip
		//   - `type="hidden"` (always barred)
		//   - `readonly` inputs (flatpickr makes its bound input readonly
		//     by default, so Date/Time/DateTime never match either pseudo)
		//   - inputs with `disabled` (also barred)
		// We inspect `.value` (or `.checked` for checkboxes) directly and
		// apply styling to the right wrapper. Runs last so it overrides
		// any (mis)styling from Pass 1/2 for these fields.
		const tmpDataRequired = pFormElement.querySelectorAll('[data-required="true"]');
		for (let i = 0; i < tmpDataRequired.length; i++)
		{
			const tmpInput = /** @type {HTMLInputElement} */ (tmpDataRequired[i]);
			const tmpIsHiddenBearer = this._isHiddenDataBearer(tmpInput);

			// Visibility gate. For hidden bearers, use the surface/wrapper
			// indirection (the input itself is always CSS-hidden). For
			// visible inputs, check the input directly.
			let tmpIsVisible;
			if (tmpIsHiddenBearer)
			{
				const tmpVisibilityTarget = this._resolveVisibilityTargetForHiddenBearer(tmpInput);
				tmpIsVisible = tmpVisibilityTarget ? this._walkAncestorVisibility(tmpVisibilityTarget) : true;
			}
			else
			{
				tmpIsVisible = this.isInputVisibleToUser(tmpInput);
			}

			if (!tmpIsVisible)
			{
				// Field is on an inactive tab / conditionally hidden — scrub
				// any leftover styling, don't block submit, don't flag.
				const tmpControl = this.resolveControlElement(tmpInput);
				this.clearValidationStyling(tmpControl);
				this.clearValidationHelpText(tmpControl);
				this.syncAriaInvalidAttribute(tmpInput, false);
				continue;
			}

			// Determine "logical validity" — for checkboxes, "checked";
			// otherwise a non-empty, non-sentinel value.
			const tmpHasValue = this._hasRequiredValue(tmpInput);
			// Pass 3 is the authoritative required-field walk. Unlike
			// Pass 1/2 (which walk every :valid element including optional
			// fields), this pass only touches inputs the manifest marked as
			// required — so a non-empty value here unambiguously means
			// "requirement satisfied" and should paint green regardless of
			// prior state. Override the default "only mark success if was
			// danger" gate.
			this._applyValidityToWrapperAndKin(tmpInput, tmpHasValue, { onlyMarkSuccessIfWasDanger: false });
			if (!tmpHasValue)
			{
				tmpFormIsValid = false;
			}
		}

		return tmpFormIsValid;
	}

	/**
	 * Re-apply validity styling for a single input element using DOM state
	 * alone. Used by the form-level live revalidation listener so that the
	 * moment a user corrects a previously-flagged field, the wrapper
	 * promotes from `is-danger` back to `is-success` — without waiting for
	 * another Submit click. The "you fixed it" semantics also mean that
	 * clearing a required field that had passed before flips back to
	 * `is-danger` immediately.
	 *
	 * Validity is read from the DOM:
	 *   - Checkbox + required → `checked`
	 *   - Manifest-required (`data-required="true"`) with no native `required`
	 *     attribute on the DOM element (Select2-managed `<select>`), or a
	 *     hidden data-bearer (Signature, Picker) → a non-empty `.value` that
	 *     isn't one of its `data-empty-values`
	 *   - Anything else → `element.checkValidity()`
	 *
	 * Inputs that are not currently visible to the user (inactive tab,
	 * conditionally hidden) have their styling scrubbed and don't get
	 * flagged — the styling shouldn't lie about a field the user can't
	 * see and can't act on.
	 *
	 * @param {Element|null} pElement
	 * @return {void}
	 */
	revalidateInputElement(pElement)
	{
		if (!pElement || pElement.nodeType !== 1)
		{
			return;
		}
		if (!this.pict || !this.pict.AppData || !this.pict.AppData.Interactive)
		{
			return;
		}

		// Translate hidden data-bearer inputs (e.g. Station's hidden bearer,
		// Signature's <input type="hidden">) to their visible required
		// sibling so styling lands on the user-facing field.
		const tmpResolved = (pElement.id && typeof this.resolveStylingTargetInput === 'function') ?
			this.resolveStylingTargetInput('#' + pElement.id) :
			null;
		const tmpTarget = tmpResolved || /** @type {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} */ (pElement);
		if (!tmpTarget || !tmpTarget.tagName)
		{
			return;
		}

		if (!this.isInputVisibleToUser(tmpTarget))
		{
			const tmpControl = this.resolveControlElement(tmpTarget);
			this.clearValidationStyling(tmpControl);
			this.clearValidationHelpText(tmpControl);
			this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (tmpTarget), false);
			return;
		}

		const tmpHasNativeRequired = tmpTarget.hasAttribute && tmpTarget.hasAttribute('required');
		const tmpHasDataRequired = tmpTarget.getAttribute && tmpTarget.getAttribute('data-required') === 'true';
		let tmpIsValid;
		if (tmpTarget.type === 'checkbox' && tmpTarget.required)
		{
			tmpIsValid = !!tmpTarget.checked;
		}
		else if (tmpHasDataRequired && (!tmpHasNativeRequired || this._isHiddenDataBearer(/** @type {HTMLInputElement} */ (tmpTarget))))
		{
			// Manifest-required but native validity can't judge it: the DOM
			// doesn't carry `required` (Select2-managed <select>), or it is a
			// hidden data-bearer, which constraint validation skips. Inspect
			// the value directly — that's the authoritative signal.
			tmpIsValid = this._hasRequiredValue(/** @type {HTMLInputElement} */ (tmpTarget));
		}
		else if (typeof tmpTarget.checkValidity === 'function')
		{
			this.syncLengthValidity(tmpTarget);
			tmpIsValid = tmpTarget.checkValidity();
		}
		else
		{
			tmpIsValid = true;
		}

		this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (tmpTarget), !tmpIsValid);
		// Use the default `onlyMarkSuccessIfWasDanger: true` semantics —
		// only promote to green when the wrapper had previously been red
		// ("you fixed it"). Pass 3 of the bulk submit uses unconditional
		// promotion via an explicit option, but for live edits we don't
		// want every keystroke on an unrelated valid field to suddenly
		// paint green out of nowhere.
		this._applyValidityToWrapperAndKin(/** @type {HTMLElement} */ (tmpTarget), tmpIsValid);

		// Mirror to addon sibling (e.g. unit pill on numeric inputs) so it
		// tracks the same color as the wrapper.
		const tmpControl = this.resolveControlElement(tmpTarget);
		if (tmpControl)
		{
			const tmpAddon = tmpControl.nextElementSibling;
			if (tmpAddon && tmpAddon.classList && tmpAddon.classList.contains('addon'))
			{
				this.applyValidityClasses(/** @type {HTMLElement} */ (tmpAddon), tmpIsValid, { onlyMarkSuccessIfWasDanger: true });
			}
		}
	}

	/**
	 * Attach a delegated input/change/blur listener at the form level so
	 * every input the user touches gets revalidated against the latest
	 * state. Idempotent — re-attaching on the same form is a no-op. The
	 * handler is gated on `form.show-validation` so we don't paint
	 * validation colors on initial page load; only after the first Submit
	 * attempt (which adds `show-validation`) does live feedback kick in.
	 *
	 * Uses a single delegated listener rather than per-input wiring so any
	 * input type — including those whose templates don't list
	 * InputValidation in `DefaultInputExtensions` — gets covered. Capture
	 * phase so it runs even when child providers stop propagation.
	 *
	 * @param {HTMLElement|null} pFormElement
	 * @return {void}
	 */
	attachLiveRevalidation(pFormElement)
	{
		if (!pFormElement || pFormElement.nodeType !== 1)
		{
			return;
		}
		if (pFormElement.dataset && pFormElement.dataset.inputValidationLiveAttached === 'true')
		{
			return;
		}
		if (pFormElement.dataset)
		{
			pFormElement.dataset.inputValidationLiveAttached = 'true';
		}

		const tmpProvider = this;
		const tmpHandler = function(pEvent)
		{
			if (!pFormElement.classList || !pFormElement.classList.contains('show-validation'))
			{
				return;
			}
			const tmpTarget = pEvent.target;
			if (!tmpTarget || !tmpTarget.tagName)
			{
				return;
			}
			if (tmpTarget.tagName !== 'INPUT' && tmpTarget.tagName !== 'SELECT' && tmpTarget.tagName !== 'TEXTAREA')
			{
				return;
			}
			tmpProvider.revalidateInputElement(tmpTarget);
		};

		// Capture phase so the listener fires even if a provider on a
		// child element calls stopPropagation. `blur` doesn't bubble so we
		// listen for it on capture too (or could use focusout; capture is
		// simpler and works cross-browser).
		pFormElement.addEventListener('input', tmpHandler, true);
		pFormElement.addEventListener('change', tmpHandler, true);
		pFormElement.addEventListener('blur', tmpHandler, true);

		// Also bind via jQuery when available. Select2 dispatches selection
		// changes via `$(select).trigger('change')`, which goes through
		// jQuery's own event bus and does NOT fire native addEventListener
		// listeners. Without this jQuery hook, picking a value in a Select2
		// dropdown wouldn't trigger live revalidation. Pict-Section-Form's
		// other providers similarly trigger via jQuery for some inputs.
		const tmpJQuery = (typeof window !== 'undefined' && (window.$ || window.jQuery)) || null;
		if (tmpJQuery)
		{
			tmpJQuery(pFormElement).on('input.inputValidationLive change.inputValidationLive blur.inputValidationLive', function(pEvent)
			{
				tmpHandler(pEvent);
			});
		}
	}

	/**
	 * For a hidden data-bearer input, return the element whose visibility
	 * actually represents "is this field on screen?" — preferring an
	 * explicit `data-validation-surface` pointer, falling back to the
	 * closest `.control.control-status` wrapper, finally the parent.
	 *
	 * @param {HTMLInputElement} pInput
	 * @return {Element|null}
	 * @private
	 */
	_resolveVisibilityTargetForHiddenBearer(pInput)
	{
		if (!pInput || pInput.nodeType !== 1)
		{
			return null;
		}
		const tmpSurfaceID = pInput.getAttribute && pInput.getAttribute('data-validation-surface');
		if (tmpSurfaceID)
		{
			const tmpSurface = document.getElementById(tmpSurfaceID);
			if (tmpSurface)
			{
				return tmpSurface;
			}
		}
		if (typeof pInput.closest === 'function')
		{
			const tmpControl = pInput.closest('.control.control-status');
			if (tmpControl)
			{
				return tmpControl;
			}
		}
		return pInput.parentElement;
	}

	/**
	 * Internal: apply or clear validity classes on the input's
	 * `.control.control-status` wrapper (via its validation surface for a
	 * hidden data-bearer), mirror onto any Select2 container sibling, and sync
	 * `aria-invalid` on the input itself and any combobox in the wrapper.
	 *
	 * Two semantic modes, controlled by `pOptions.onlyMarkSuccessIfWasDanger`:
	 *
	 *   - `true` (default) — submit-style "you fixed it" semantics. Only
	 *     promotes a wrapper to `is-success` when it had been flagged
	 *     `is-danger`. Used by Pass 1/2 of `applyFormSubmissionStyling`,
	 *     which walks every `:valid` element — including non-required
	 *     fields like an empty optional input that happens to match
	 *     `:valid`. Without this gate the form would get a "generic green
	 *     tick" on every passing field, which the test at "does NOT add
	 *     is-success when the input was not previously danger" guards
	 *     against and which matches the single-input submit-style behavior
	 *     in `handleValidationInputStyling`.
	 *
	 *   - `false` — unconditional promotion. Used by Pass 3 of
	 *     `applyFormSubmissionStyling`, which walks only
	 *     `[data-required="true"]` inputs. For an authoritatively-required
	 *     field, a non-empty value IS success and the user should see green
	 *     ("you've satisfied this requirement"), regardless of whether the
	 *     wrapper had ever been red. This is the form-wide "report card"
	 *     behavior on submit: required fields are explicitly green-or-red.
	 *
	 * @param {HTMLElement} pElement
	 * @param {boolean} pIsValid
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.onlyMarkSuccessIfWasDanger] - Defaults to true.
	 * @return {void}
	 * @private
	 */
	_applyValidityToWrapperAndKin(pElement, pIsValid, pOptions)
	{
		const tmpOptions = pOptions || { onlyMarkSuccessIfWasDanger: true };
		const tmpControl = this._findControlStatusWrapper(pElement);
		const tmpTarget = tmpControl || (pElement.classList && pElement.classList.contains('input') ? pElement : null);

		if (tmpTarget)
		{
			this.applyValidityClasses(/** @type {HTMLElement} */ (tmpTarget), pIsValid, tmpOptions);
		}

		// Select2 replaces the native <select> with its own container that
		// Bulma's class-based styling doesn't reach. Mirror the validity
		// class onto every Select2 container inside this control so the
		// user-visible widget reflects the state. Same promotion semantics
		// (option flag) apply to the mirror as to the control wrapper.
		if (tmpControl && typeof tmpControl.querySelectorAll === 'function')
		{
			const tmpSelect2Containers = tmpControl.querySelectorAll('.select2-container');
			for (let i = 0; i < tmpSelect2Containers.length; i++)
			{
				this.applyValidityClasses(/** @type {HTMLElement} */ (tmpSelect2Containers[i]), pIsValid, tmpOptions);
			}
			// A custom widget's focusable combobox is what assistive tech reads, not the input behind it.
			const tmpComboboxes = tmpControl.querySelectorAll('[role="combobox"]');
			for (let i = 0; i < tmpComboboxes.length; i++)
			{
				this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (tmpComboboxes[i]), !pIsValid);
			}
		}

		// Sync aria-invalid on the input itself when applicable.
		if (pElement.tagName === 'INPUT' || pElement.tagName === 'SELECT' || pElement.tagName === 'TEXTAREA')
		{
			this.syncAriaInvalidAttribute(/** @type {HTMLInputElement} */ (pElement), !pIsValid);
		}
	}

	/**
	 * True when an input is functionally hidden — either `type="hidden"` or
	 * its computed style is display:none — meaning native constraint
	 * validation (`:invalid`) won't apply to it and we have to inspect its
	 * value directly for required-ness.
	 *
	 * @param {HTMLInputElement} pElement
	 * @return {boolean}
	 * @private
	 */
	_isHiddenDataBearer(pElement)
	{
		if (!pElement || pElement.tagName !== 'INPUT')
		{
			return false;
		}
		if (pElement.type === 'hidden')
		{
			return true;
		}
		// Bulma's is-hidden class sets display:none. Other CSS-driven hides
		// (custom classes, inline style) are covered by the computed style
		// check.
		const tmpStyle = (typeof window !== 'undefined' && window.getComputedStyle) ?
			window.getComputedStyle(pElement) :
			null;
		if (tmpStyle && tmpStyle.display === 'none')
		{
			return true;
		}
		return false;
	}

	/**
	 * Sync `aria-invalid` on a live DOM element. Pass `true` to mark the
	 * input as invalid (announces "invalid entry" via screen readers), or
	 * `false` to clear the attribute entirely. We intentionally remove the
	 * attribute on valid state rather than setting aria-invalid="false" — the
	 * latter announces "valid" on every keystroke for live-validation
	 * inputs, which is noisy. ARIA's default semantic when the attribute is
	 * absent is "not yet validated / no judgment", which is what we want.
	 *
	 * @param {HTMLInputElement|null} pElement
	 * @param {boolean} pIsInvalid - true → mark invalid, false → clear.
	 * @return {void}
	 */
	syncAriaInvalidAttribute(pElement, pIsInvalid)
	{
		if (!pElement)
		{
			return;
		}
		if (pIsInvalid)
		{
			if (pElement.getAttribute('aria-invalid') !== 'true')
			{
				pElement.setAttribute('aria-invalid', 'true');
			}
		}
		else if (pElement.hasAttribute('aria-invalid'))
		{
			pElement.removeAttribute('aria-invalid');
		}
	}

	/**
	 * Programmatically pair an input to its help-text wrapper via
	 * `aria-describedby`. The wrapper holds both the Description text and
	 * any injected validation-text, so screen readers announce both as part
	 * of the input. Idempotent — safe to call repeatedly.
	 *
	 * Looks up the wrapper via the same parent-of-parent traversal we use
	 * for validation-text injection, so it stays consistent with the actual
	 * markup the templates emit.
	 *
	 * @param {HTMLInputElement|null} pInputElement
	 * @return {void}
	 */
	linkInputToHelpText(pInputElement)
	{
		if (!pInputElement || !pInputElement.id)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(pInputElement);
		if (!tmpControl)
		{
			return;
		}
		const tmpHelpWrapper = tmpControl.parentElement && tmpControl.parentElement.parentElement ?
			tmpControl.parentElement.parentElement.querySelector('.help') :
			null;
		if (!tmpHelpWrapper)
		{
			return;
		}
		const tmpHelpID = tmpHelpWrapper.id || ('HELP-FOR-' + pInputElement.id);
		if (!tmpHelpWrapper.id)
		{
			tmpHelpWrapper.id = tmpHelpID;
		}
		const tmpExisting = pInputElement.getAttribute('aria-describedby') || '';
		// Preserve any other tokens an upstream template may have already set.
		if (!tmpExisting.split(/\s+/).includes(tmpHelpID))
		{
			pInputElement.setAttribute('aria-describedby', tmpExisting ? `${tmpExisting} ${tmpHelpID}`.trim() : tmpHelpID);
		}
	}

	/**
	 * Locate the "control" wrapper used for is-danger / is-success styling.
	 * Walks the ancestor chain via closest() so deeply-nested inputs (e.g.
	 * flatpickr-wrapped pickers, Station provider's masked input) still find
	 * the right wrapper rather than only checking the direct parent.
	 * Falls back to the input element itself when it carries the `input`
	 * class but has no .control.control-status ancestor.
	 *
	 * @param {HTMLInputElement} pElement
	 * @return {HTMLElement|null}
	 */
	resolveControlElement(pElement)
	{
		if (!pElement)
		{
			return null;
		}
		const tmpControl = this._findControlStatusWrapper(pElement);
		if (tmpControl)
		{
			return tmpControl;
		}
		if (pElement.classList && pElement.classList.contains('input'))
		{
			return pElement;
		}
		return null;
	}

	/**
	 * The `.control.control-status` wrapper that carries an input's validity classes: its own ancestor,
	 * or — for a hidden value input rendered apart from its visible widget — the one around its
	 * `data-validation-surface`.
	 *
	 * @param {Element} pElement
	 * @return {HTMLElement|null}
	 * @private
	 */
	_findControlStatusWrapper(pElement)
	{
		if (!pElement || typeof pElement.closest !== 'function')
		{
			return null;
		}
		const tmpOwnControl = /** @type {HTMLElement|null} */ (pElement.closest('.control.control-status'));
		if (tmpOwnControl)
		{
			return tmpOwnControl;
		}
		const tmpSurfaceID = pElement.getAttribute && pElement.getAttribute('data-validation-surface');
		const tmpSurface = tmpSurfaceID ? document.getElementById(tmpSurfaceID) : null;
		if (tmpSurface && typeof tmpSurface.closest === 'function')
		{
			return /** @type {HTMLElement|null} */ (tmpSurface.closest('.control.control-status'));
		}
		return null;
	}

	/**
	 * True when a manifest-required input holds a real value: `checked` for a checkbox, otherwise a
	 * non-empty value that is not one of the sentinels the input declares in `data-empty-values` (e.g. a
	 * picker whose unset Number value marshals in as "0").
	 *
	 * @param {HTMLInputElement} pElement
	 * @return {boolean}
	 * @private
	 */
	_hasRequiredValue(pElement)
	{
		if (pElement.type === 'checkbox')
		{
			return pElement.checked;
		}
		const tmpValue = (pElement.value == null) ? '' : String(pElement.value);
		if (tmpValue.length < 1)
		{
			return false;
		}
		return !this._readDeclaredEmptyValues(pElement).includes(tmpValue);
	}

	/**
	 * The values an input declares as "empty" through its `data-empty-values` JSON array, as strings. A
	 * missing or malformed attribute declares none.
	 *
	 * @param {Element} pElement
	 * @return {Array<string>}
	 * @private
	 */
	_readDeclaredEmptyValues(pElement)
	{
		const tmpRaw = pElement.getAttribute ? pElement.getAttribute('data-empty-values') : null;
		if (!tmpRaw)
		{
			return [];
		}
		try
		{
			const tmpParsed = JSON.parse(tmpRaw);
			return Array.isArray(tmpParsed) ? tmpParsed.map(String) : [];
		}
		catch (pError)
		{
			return [];
		}
	}

	/**
	 * The length limit a text value breaks, judged from the value and the element's `minlength` /
	 * `maxlength` attributes. An empty value breaks neither; `required` covers that.
	 *
	 * @param {Element|null} pElement
	 * @return {'short'|'long'|null}
	 * @private
	 */
	_readLengthViolation(pElement)
	{
		const tmpElement = /** @type {HTMLInputElement|HTMLTextAreaElement|null} */ (pElement);
		if (!tmpElement || typeof tmpElement.getAttribute !== 'function' || typeof tmpElement.value !== 'string' || tmpElement.value.length < 1)
		{
			return null;
		}
		const tmpMinLength = parseInt(tmpElement.getAttribute('minlength'), 10);
		if (!isNaN(tmpMinLength) && tmpElement.value.length < tmpMinLength)
		{
			return 'short';
		}
		const tmpMaxLength = parseInt(tmpElement.getAttribute('maxlength'), 10);
		if (!isNaN(tmpMaxLength) && tmpElement.value.length > tmpMaxLength)
		{
			return 'long';
		}
		return null;
	}

	/**
	 * Carry a broken `minlength` / `maxlength` into the element's custom validity, so `checkValidity()`,
	 * `:invalid` and the Submit gate see it. Browsers apply the two attributes only to text the user typed,
	 * and the form writes each value back into its input after a change, which drops the browser's own check.
	 *
	 * @param {Element|null} pElement
	 * @return {void}
	 */
	syncLengthValidity(pElement)
	{
		const tmpElement = /** @type {HTMLInputElement|HTMLTextAreaElement|null} */ (pElement);
		if (!tmpElement || typeof tmpElement.setCustomValidity !== 'function' || typeof tmpElement.hasAttribute !== 'function')
		{
			return;
		}
		if (!tmpElement.hasAttribute('minlength') && !tmpElement.hasAttribute('maxlength'))
		{
			return;
		}
		const tmpViolation = this._readLengthViolation(tmpElement);
		tmpElement.setCustomValidity(tmpViolation ? this._buildLengthMessage(tmpElement, tmpViolation) : '');
	}

	/**
	 * @param {HTMLInputElement|HTMLTextAreaElement} pElement
	 * @param {'short'|'long'} pViolation
	 * @return {string}
	 * @private
	 */
	_buildLengthMessage(pElement, pViolation)
	{
		if (pViolation === 'short')
		{
			return `Please lengthen this text to at least ${pElement.getAttribute('minlength')} characters`;
		}
		return `Please shorten this text to no more than ${pElement.getAttribute('maxlength')} characters`;
	}

	/**
	 * Resolve the validation rules that apply to a given input, taking both
	 * the manifest config (PictForm) and any HTML attributes already on the
	 * DOM into account, and synchronize the element's `required` /
	 * `aria-required` attributes to reflect visibility.
	 *
	 * Visibility rule: if the element exists but is not visible to the user,
	 * return an empty rules object so callers treat the input as having no
	 * active validation — the field cannot fail a check the user can't see.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @return {Record<string, any>} The validation rules.
	 */
	setValidationInputAttributes(pInput, pValue, pHTMLSelector)
	{
		const tmpRules = {};
		const tmpElement = this.resolveInputElement(pHTMLSelector);
		const tmpPictForm = (pInput && pInput.PictForm) ? pInput.PictForm : null;

		// Determine what the manifest wants for this input. When PictForm is
		// present, treat it as authoritative — "required-ness is determined
		// by the manifest config" per project semantics. Only fall back to
		// inspecting the DOM when no manifest config was passed in at all.
		const tmpWantsRequired = tmpPictForm ?
			!!tmpPictForm.Required :
			!!(tmpElement && tmpElement.required);

		// Visibility short-circuit. We do this BEFORE returning rules so we
		// can also strip the DOM-level `required` attribute, which keeps the
		// browser's checkValidity() honest at submit time.
		if (tmpElement && !this.isInputVisibleToUser(tmpElement))
		{
			this.syncRequiredAttributes(tmpElement, false);
			return tmpRules;
		}

		// Keep the DOM in sync with what the manifest says about this input.
		// This also adds aria-required for accessibility on every required field.
		if (tmpElement)
		{
			this.syncRequiredAttributes(tmpElement, tmpWantsRequired);
			// Manifest is the source of truth for the persistent marker.
			// If the manifest is present AND explicitly says not required,
			// strip data-required so the pre-submit sweep doesn't try to
			// re-mark this field. (Visibility-driven syncs above preserve
			// the marker — only an explicit manifest negative clears it.)
			if (tmpPictForm && !tmpWantsRequired && tmpElement.hasAttribute('data-required'))
			{
				tmpElement.removeAttribute('data-required');
			}
		}

		if (tmpWantsRequired)
		{
			tmpRules.required = true;
		}

		// For each remaining rule, prefer the manifest value when present.
		// Fall back to the DOM value only when the element actually has the
		// attribute set — relying on the IDL property's truthiness is unsafe
		// because browsers (and JSDOM) expose non-spec defaults like 524288
		// for maxLength when the attribute isn't authored.
		const tmpMinNumber = this._pickRuleValue(tmpPictForm, 'MinNumber', tmpElement, 'min', 'min');
		if (tmpMinNumber !== undefined)
		{
		tmpRules.min = tmpMinNumber;
		}

		const tmpMaxNumber = this._pickRuleValue(tmpPictForm, 'MaxNumber', tmpElement, 'max', 'max');
		if (tmpMaxNumber !== undefined)
		{
		tmpRules.max = tmpMaxNumber;
		}

		const tmpStep = this._pickRuleValue(tmpPictForm, 'StepNumber', tmpElement, 'step', 'step');
		if (tmpStep !== undefined)
		{
		tmpRules.step = tmpStep;
		}

		const tmpMinLength = this._pickRuleValue(tmpPictForm, 'MinLength', tmpElement, 'minLength', 'minlength');
		if (tmpMinLength !== undefined)
		{
		tmpRules.minlength = tmpMinLength;
		}

		const tmpMaxLength = this._pickRuleValue(tmpPictForm, 'MaxLength', tmpElement, 'maxLength', 'maxlength');
		if (tmpMaxLength !== undefined)
		{
		tmpRules.maxlength = tmpMaxLength;
		}

		const tmpPattern = this._pickRuleValue(tmpPictForm, 'Pattern', tmpElement, 'pattern', 'pattern');
		if (tmpPattern !== undefined)
		{
		tmpRules.pattern = tmpPattern;
		}

		return tmpRules;
	}

	/**
	 * Pick a rule value, manifest first then DOM. Returns undefined when
	 * neither side has a meaningful value (so callers can omit the key
	 * entirely from the rules object).
	 *
	 * @param {object|null} pPictForm - Manifest config, if any.
	 * @param {string} pManifestKey - Key on PictForm to read.
	 * @param {HTMLInputElement|null} pElement - Live DOM element, if any.
	 * @param {string} pDomKey - IDL property name on the element.
	 * @param {string} pAttributeName - HTML attribute name (used with hasAttribute to detect "actually set").
	 * @return {any}
	 */
	_pickRuleValue(pPictForm, pManifestKey, pElement, pDomKey, pAttributeName)
	{
		if (pPictForm && pPictForm[pManifestKey] !== undefined && pPictForm[pManifestKey] !== null)
		{
			return pPictForm[pManifestKey];
		}
		if (pElement && pElement.hasAttribute && pElement.hasAttribute(pAttributeName))
		{
			return pElement[pDomKey];
		}
		return undefined;
	}

	/**
	 * True if any validation rules apply to this input right now (taking the
	 * visibility gate into account, since setValidationInputAttributes does).
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @return {boolean}
	 */
	hasInputValidation(pInput, pValue, pHTMLSelector)
	{
		const tmpRules = this.setValidationInputAttributes(pInput, pValue, pHTMLSelector);
		return Object.keys(tmpRules).length > 0;
	}

	/**
	 * Apply / remove validity classes on a control wrapper. Shared by both
	 * the submit-style and change-style validation flows so the class-swap
	 * logic lives in one place.
	 *
	 * @param {HTMLElement|null} pControl - The control wrapper or input itself.
	 * @param {boolean} pIsValid - Whether the input is currently valid.
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.clearBoth] - Strip both classes regardless of validity (e.g. empty input on change).
	 * @param {boolean} [pOptions.fadeSuccess] - Remove the success class after SUCCESS_FADE_DELAY_MS.
	 * @param {boolean} [pOptions.onlyMarkSuccessIfWasDanger] - Submit-style behavior: only add is-success when the field had been marked is-danger.
	 * @return {void}
	 */
	applyValidityClasses(pControl, pIsValid, pOptions)
	{
		if (!pControl)
		{
			return;
		}
		const tmpOptions = pOptions || {};
		if (tmpOptions.clearBoth)
		{
			pControl.classList.remove(VALIDATION_CLASSES.SUCCESS);
			pControl.classList.remove(VALIDATION_CLASSES.DANGER);
			return;
		}
		if (pIsValid)
		{
			if (tmpOptions.onlyMarkSuccessIfWasDanger)
			{
				if (pControl.classList.contains(VALIDATION_CLASSES.DANGER))
				{
					pControl.classList.add(VALIDATION_CLASSES.SUCCESS);
				}
			}
			else
			{
				pControl.classList.add(VALIDATION_CLASSES.SUCCESS);
			}
			pControl.classList.remove(VALIDATION_CLASSES.DANGER);
		}
		else
		{
			pControl.classList.remove(VALIDATION_CLASSES.SUCCESS);
			pControl.classList.add(VALIDATION_CLASSES.DANGER);
		}
		if (tmpOptions.fadeSuccess && pControl.classList.contains(VALIDATION_CLASSES.SUCCESS))
		{
			setTimeout(() =>
			{
				pControl.classList.remove(VALIDATION_CLASSES.SUCCESS);
			}, SUCCESS_FADE_DELAY_MS);
		}
	}

	/**
	 * Clear all validation styling on a control wrapper plus any addon sibling.
	 * Used when an input transitions from visible→hidden so it doesn't leave
	 * a stale red highlight behind on a tab the user can no longer see.
	 *
	 * @param {HTMLElement|null} pControl
	 * @return {void}
	 */
	clearValidationStyling(pControl)
	{
		if (!pControl)
		{
			return;
		}
		this.applyValidityClasses(pControl, true, { clearBoth: true });
		const tmpAddon = pControl.nextElementSibling;
		if (tmpAddon && tmpAddon.classList.contains('addon'))
		{
			this.applyValidityClasses(/** @type {HTMLElement} */ (tmpAddon), true, { clearBoth: true });
		}
	}

	/**
	 * Strip the validation-text node from the help wrapper, if present.
	 *
	 * @param {HTMLElement|null} pControl
	 * @return {void}
	 */
	clearValidationHelpText(pControl)
	{
		if (!pControl)
		{
			return;
		}
		// Tier 5: drop any aria-errormessage pointing at a validation-text
		// node we're clearing, so AT never references a dangling id. Scope
		// the sweep to this field so we don't disturb other inputs.
		const tmpErrorScope = (typeof pControl.closest === 'function' && pControl.closest('.field')) || pControl;
		if (tmpErrorScope && typeof tmpErrorScope.querySelectorAll === 'function')
		{
			const tmpReferers = tmpErrorScope.querySelectorAll('[aria-errormessage]');
			for (let i = 0; i < tmpReferers.length; i++)
			{
				tmpReferers[i].removeAttribute('aria-errormessage');
			}
		}
		const tmpHelpWrapper = pControl.parentElement && pControl.parentElement.parentElement ?
			pControl.parentElement.parentElement.querySelector('.help') :
			null;
		if (!tmpHelpWrapper)
		{
			return;
		}
		const tmpExisting = tmpHelpWrapper.querySelector('.' + VALIDATION_CLASSES.VALIDATION_TEXT);
		if (tmpExisting)
		{
			tmpExisting.remove();
		}
	}

	/**
	 * Handle the validation class swapping for the input (submit-style flow).
	 * If the input is not visible to the user, this no-ops and proactively
	 * scrubs any stale danger styling so a previously-visible field that
	 * got hidden doesn't leave error UI on a tab the user can't see.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @return {void}
	 */
	handleValidationInputStyling(pInput, pValue, pHTMLSelector, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			// if we're not in interactive mode, we don't want to show the validation UI
			return;
		}
		// Use the styling-target resolver so hidden data-bearer inputs
		// (Station, DateTime, Date, Time) are translated to their visible
		// required sibling. Without this, the canonical selector points at
		// a type=hidden input that's barred from native validation, and
		// styling silently no-ops on every keystroke.
		const tmpInput = this.resolveStylingTargetInput(pHTMLSelector);
		if (!tmpInput)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(tmpInput);

		if (!this.isInputVisibleToUser(tmpInput))
		{
			// Field is not currently visible to the user — clean up any prior
			// styling and bail without applying new danger state.
			this.clearValidationStyling(tmpControl);
			this.clearValidationHelpText(tmpControl);
			this.syncAriaInvalidAttribute(tmpInput, false);
			return;
		}

		this.syncLengthValidity(tmpInput);
		// NOTE: For checkboxes, we only check validity if the field is required, otherwise an unchecked checkbox will always be invalid but that's not the desired behavior
		const tmpIsValid = (tmpInput.type === 'checkbox' && tmpInput.required) ? tmpInput.checked : tmpInput.checkValidity();

		this.syncAriaInvalidAttribute(tmpInput, !tmpIsValid);

		// if we can't find the control element, there's not much else we can do
		if (!tmpControl)
		{
			this.pict.log.warn('Could not find the control element for input validation styling.');
			return;
		}

		this.applyValidityClasses(tmpControl, tmpIsValid, { onlyMarkSuccessIfWasDanger: true });
		const tmpAddon = tmpControl.nextElementSibling;
		if (tmpAddon && tmpAddon.classList.contains('addon'))
		{
			this.applyValidityClasses(/** @type {HTMLElement} */ (tmpAddon), tmpIsValid, { onlyMarkSuccessIfWasDanger: true });
		}
	}

	/**
	 * Build the validation message text string for the input - could be more
	 * than one error, so we join them.
	 *
	 * @param {HTMLInputElement} pInputElement
	 * @return {string}
	 */
	buildValidationMessageTextString(pInputElement)
	{
		const tmpMessageParts = [];
		if (pInputElement.validity.valid)
		{
			return '';
		}
		if (pInputElement.validity.valueMissing)
		{
			tmpMessageParts.push('This field is required');
		}
		if (pInputElement.validity.typeMismatch)
		{
			tmpMessageParts.push('Please enter a value of the correct type');
		}
		if (pInputElement.validity.patternMismatch)
		{
			tmpMessageParts.push(`Please match the requested format <format>${pInputElement.pattern}</format>`);
		}
		const tmpLengthViolation = this._readLengthViolation(pInputElement);
		if (pInputElement.validity.tooLong || tmpLengthViolation === 'long')
		{
			tmpMessageParts.push(this._buildLengthMessage(pInputElement, 'long'));
		}
		if (pInputElement.validity.tooShort || tmpLengthViolation === 'short')
		{
			tmpMessageParts.push(this._buildLengthMessage(pInputElement, 'short'));
		}
		if (pInputElement.min && pInputElement.max && (pInputElement.validity.rangeUnderflow || pInputElement.validity.rangeOverflow))
		{
			tmpMessageParts.push(`Please enter a value between ${pInputElement.min} and ${pInputElement.max}`);
		}
		else if (pInputElement.validity.rangeUnderflow)
		{
			tmpMessageParts.push(`Please increase the value to at least ${pInputElement.min}`);
		}
		else if (pInputElement.validity.rangeOverflow)
		{
			tmpMessageParts.push(`Please decrease the value to less than or equal to ${pInputElement.max}`);
		}
		if (pInputElement.validity.stepMismatch)
		{
			if (pInputElement.step == '1')
			{
				tmpMessageParts.push('Please enter a valid whole number.');
			}
			else
			{
				tmpMessageParts.push('Please enter a valid value with the correct decimal precision. The allowed step value is ' + pInputElement.step);
			}
		}
		return tmpMessageParts.length ? tmpMessageParts.join('; ') : '';
	}

	/**
	 * Handle the validation UI for the input on a per-change basis (live
	 * feedback as the user types/picks). Differs from
	 * `handleValidationInputStyling` in that it trusts the caller's
	 * `pValidResult` rather than calling `checkValidity()`, and fades the
	 * success class after a short delay.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} [pRowIndex]
	 * @param {boolean} [pValidResult]
	 * @return {void}
	 */
	handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, pValidResult = false)
	{
		if (!this.pict.AppData.Interactive)
		{
			// if we're not in interactive mode, we don't want to show the validation UI
			return;
		}
		const tmpInput = this.resolveStylingTargetInput(pHTMLSelector);
		if (!tmpInput)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(tmpInput) || tmpInput;

		if (!this.isInputVisibleToUser(tmpInput))
		{
			this.clearValidationStyling(tmpControl);
			this.syncAriaInvalidAttribute(tmpInput, false);
			return;
		}

		if (!pValue)
		{
			// Empty value means no judgment yet — clear both class state and
			// aria-invalid so screen readers don't carry over a stale verdict.
			this.applyValidityClasses(tmpControl, true, { clearBoth: true });
			this.syncAriaInvalidAttribute(tmpInput, false);
			return;
		}
		this.syncAriaInvalidAttribute(tmpInput, !pValidResult);
		this.applyValidityClasses(tmpControl, !!pValidResult, { fadeSuccess: true });
	}

	/**
	 * Handle the injection of validation help text into the input's help
	 * text wrapper. No-ops + scrubs prior help text when the input is hidden.
	 *
	 * @param {object} pInput
	 * @param {string} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @return {void}
	 */
	handleValidationHelpTextElementUpdate(pInput, pValue, pHTMLSelector, pRowIndex)
	{
		if (!this.pict.AppData.Interactive)
		{
			// if we're not in interactive mode, we don't want to show the validation UI
			return;
		}
		const tmpInput = this.resolveStylingTargetInput(pHTMLSelector);
		if (!tmpInput)
		{
			return;
		}
		const tmpControl = this.resolveControlElement(tmpInput);

		if (!this.isInputVisibleToUser(tmpInput))
		{
			this.clearValidationHelpText(tmpControl);
			return;
		}

		// if we can't find the control element, there's not much else we can do
		if (!tmpControl)
		{
			this.pict.log.warn('Could not find the control element for input validation help text injection.');
			return;
		}
		const tmpHelpWrapper = tmpControl.parentElement && tmpControl.parentElement.parentElement ?
			tmpControl.parentElement.parentElement.querySelector('.help') :
			null;
		if (!tmpHelpWrapper)
		{
			return;
		}

		// Remove any previous validation-text node before injecting a fresh one.
		const tmpExisting = tmpHelpWrapper.querySelector('.' + VALIDATION_CLASSES.VALIDATION_TEXT);
		if (tmpExisting)
		{
			tmpExisting.remove();
		}

		const tmpIsValid = tmpInput.type === 'checkbox' ? tmpInput.checked : tmpInput.checkValidity();
		if (tmpIsValid)
		{
			// if the input is valid, we don't need to show any validation text.
			// Drop the aria-errormessage pointer too so AT doesn't reference a
			// node we just removed (Tier 5).
			tmpInput.removeAttribute('aria-errormessage');
			return;
		}

		const tmpValidationTextMessage = this.buildValidationMessageTextString(tmpInput);
		const tmpValidationTextElement = document.createElement('div');
		tmpValidationTextElement.classList.add(VALIDATION_CLASSES.VALIDATION_TEXT);
		tmpValidationTextElement.classList.add(VALIDATION_CLASSES.HELP_DANGER_TEXT);
		// role="alert" makes screen readers announce the message when the
		// node is inserted. assertive live region + atomic so the full
		// message reads as one unit even when parts get rewritten in place.
		tmpValidationTextElement.setAttribute('role', 'alert');
		tmpValidationTextElement.setAttribute('aria-live', 'assertive');
		tmpValidationTextElement.setAttribute('aria-atomic', 'true');
		// Tier 5: point the input at the message node via aria-errormessage.
		// The node id derives from the input's own id (which already encodes
		// the tabular row key, so rows don't collide). AT only honours
		// aria-errormessage when aria-invalid="true" is also present —
		// syncAriaInvalidAttribute manages that in the styling flow.
		if (tmpInput.id)
		{
			const tmpMessageID = 'VALIDATION-MESSAGE-FOR-' + tmpInput.id;
			tmpValidationTextElement.id = tmpMessageID;
			tmpInput.setAttribute('aria-errormessage', tmpMessageID);
		}
		tmpHelpWrapper.insertAdjacentElement('afterbegin', tmpValidationTextElement);
		tmpValidationTextElement.innerHTML = tmpValidationTextMessage || '';
	}

	/**
	 * Fires when an input is first rendered into the DOM. We use it to wire
	 * the input to its help-text wrapper via aria-describedby so screen
	 * readers announce the description (and any later-injected validation
	 * message) as part of the input.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pRow
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.linkInputToHelpText(this.resolveInputElement(pHTMLSelector));
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Fires when a tabular input is first rendered. Same aria-describedby
	 * wiring as onInputInitialize, applied per row.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.linkInputToHelpText(this.resolveInputElement(pHTMLSelector));
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.hasInputValidation(pInput, pValue, pHTMLSelector))
		{
			this.handleValidationInputStyling(pInput, pValue, pHTMLSelector, 0);
			this.handleValidationHelpTextElementUpdate(pInput, pValue, pHTMLSelector, 0);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number} pRowIndex
	 * @param {string} pTransactionGUID
	 * @return {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.hasInputValidation(pInput, pValue, pHTMLSelector))
		{
			this.handleValidationInputStyling(pInput, pValue, pHTMLSelector, pRowIndex);
			this.handleValidationHelpTextElementUpdate(pInput, pValue, pHTMLSelector, pRowIndex);
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"pict-section-form":587}],144:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const LAB_PAGE_SIZE = 500;

/**
 * @typedef {Object} LabAffinityRule
 * @property {string} LabField - the Lab column matched against (e.g. 'Name', 'ExternalLabID').
 * @property {string} Pattern - a regular expression with `{KeyName}` placeholders filled from the project keys.
 * @property {Array<string>} [Requires] - project key names that must resolve before the rule is evaluated.
 * @property {string} [Flags] - regular-expression flags (default 'i').
 */

/**
 * @typedef {Object} LabAffinityConfiguration
 * @property {Record<string, Array<string>>} ProjectKeys - key name → ordered `Project.CustomProperties` keys; first non-empty wins.
 * @property {Array<LabAffinityRule>} Rules - ordered; the order is the pin-to-top priority order.
 * @property {string} [ProjectRecordAddress] - form address of an already-loaded Project record, read before falling back to REST.
 */

/**
 * LabScopeResolver — resolves which labs a materials Sample form's lab dropdowns may offer, and which of
 * them the user most likely wants.
 *
 * The lab model is two-level: a PARENT lab is the routing destination an engineer ships a sample to, and its
 * CHILD labs are the benches that actually run tests. `ProjectLabJoin` names parents; `TestLabJoin` and
 * `LabTestDefault` name children. The two selectors therefore answer different questions:
 *
 *   - the SAMPLE-level selector offers PARENT labs (`getSampleLabIDs`) — the project's labs, else the parents
 *     of every lab that can run the selected tests.
 *   - a PER-TEST selector offers LEAF labs (`getTestLabIDs`) — a lab with no children is itself a leaf and
 *     stays selectable, while a parent named by `TestLabJoin` resolves to its children (assigning a test to a
 *     parent only defers the routing decision). Only test capability narrows it; an empty result is the
 *     honest answer ("no lab here for this test") and is recoverable through Show All.
 *
 * Everything else is a preference, and preferences rank rather than narrow. `getPreferredLabIDs` orders a
 * test's capable labs: first those in the project's own lab families — named by the manifest's `LabAffinity`
 * rules from project metadata (see {@link LabAffinityConfiguration}) and by `ProjectLabJoin`, unioned — then the
 * `LabTestDefault` labs (material + sample type), which disagree with `TestLabJoin` too often to narrow.
 * `getAutoFillLabID` fills the top of that ranking, so the value filled is the first one the dropdown pins.
 *
 * Perf: one batched prime per (project, test-set, material, sample-type). The lab catalog and the project's
 * affinity resolve once each and survive later primes. Every selector then reads the caches SYNCHRONOUSLY at
 * filter-assembly time; no per-selector network.
 *
 * Consumers:
 *   resolver.primeFromForm()                      // app load + cascade (awaited in the transport seam)
 *   resolver.getSampleLabIDs()                    // sync: Set<number> | null
 *   resolver.getTestLabIDs(pIDTest, pContext)     // sync: Set<number> | null
 *   resolver.getTestLabDefaultIDs(pIDTest)        // sync: Set<number> | null  (ranking axis)
 *   resolver.getPreferredLabIDs(pScope, pContext) // sync: Array<number>       (pin-to-top order)
 *   resolver.getAutoFillLabID(pIDTest)            // sync: number              (0 = nothing to fill)
 *   resolver.getParentLabID(pIDLab)               // sync: number              (root of, or self)
 */
class LabScopeResolver extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		/** @type {Map<number, Record<string, any>>} the customer lab catalog, by IDLab */
		this._Labs = new Map();
		/** @type {Map<number, Set<number>>} IDLab → its child IDLab set */
		this._ChildrenByParent = new Map();
		this._LabsLoaded = false;
		/** @type {Set<number>|null} the project's PARENT labs (null = not loaded / none → fail-open) */
		this._ProjectRootLabs = null;
		/** @type {Map<string, Set<number>>} per-test capable labs, keyed by IDTest string */
		this._TestLabs = new Map();
		/** @type {Map<string, Set<number>>} per-test material/sample-type default labs, keyed by IDTest string */
		this._TestLabDefaults = new Map();
		/** @type {Array<number>} affinity-matched PARENT lab ids, in rule order */
		this._AffinityRootIDs = [];
		this._AffinityProjectID = 0;
		this._Loaded = false;
		/** @type {string|null} the key of the most recent prime requested */
		this._PrimeKey = null;
		/** @type {string|null} the key whose rows the caches actually hold */
		this._LoadedKey = null;
		/** @type {Promise<void>|null} */
		this._PrimePromise = null;
		/** @type {Record<string, any>|null} */
		this._Configuration = null;
	}

	// --- configuration -------------------------------------------------------------------------------

	/**
	 * The prime-time configuration: this provider's own options layered over the first `LabScope` entry found
	 * in the loaded manifest's descriptors. Priming happens before any picker composes a filter, so the
	 * resolver reads the manifest itself rather than waiting to be handed the entry (mirrors
	 * SpecScopeResolver's descriptor walk).
	 *
	 * @return {Record<string, any>}
	 */
	_getConfiguration()
	{
		if (this._Configuration)
		{
			return this._Configuration;
		}
		const tmpConfiguration = Object.assign({}, this._findManifestLabScopeEntry() || {}, this.options || {});
		this._Configuration = tmpConfiguration;
		return tmpConfiguration;
	}

	/**
	 * The first `LabScope` DynamicFilters entry in the loaded manifest. Entries carrying a `LabAffinity`
	 * block win over those that do not, so a form whose per-test entry holds the affinity config is found
	 * regardless of descriptor order.
	 *
	 * @return {Record<string, any>|null}
	 */
	_findManifestLabScopeEntry()
	{
		const tmpManifest = this.pict?.views?.PictFormMetacontroller?.manifestDescription;
		if (!tmpManifest || !tmpManifest.Descriptors)
		{
			return null;
		}
		/** @type {Record<string, any>|null} */
		let tmpFallback = null;
		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors))
		{
			const tmpFilters = tmpDescriptor?.PictForm?.DynamicFilters;
			if (!Array.isArray(tmpFilters))
			{
				continue;
			}
			for (const tmpFilter of tmpFilters)
			{
				if (!tmpFilter || !tmpFilter.LabScope)
				{
					continue;
				}
				if (tmpFilter.LabAffinity)
				{
					return tmpFilter;
				}
				if (!tmpFallback)
				{
					tmpFallback = tmpFilter;
				}
			}
		}
		return tmpFallback;
	}

	// --- form reads ----------------------------------------------------------------------------------

	/**
	 * The form address of the sample's project id. Overridable via this provider's options.
	 * @return {number}
	 */
	_readProjectID()
	{
		const tmpAddress = this._getConfiguration().ProjectAddress || 'AppData.DocumentData.ReportData.FormData.SampleID__Record.IDProject';
		const tmpValue = this.pict.manifest.getValueAtAddress(this.pict, tmpAddress);
		const tmpID = parseInt(tmpValue, 10);
		return tmpID > 0 ? tmpID : 0;
	}

	/**
	 * The selected tests' IDTest values, read from the Test selector's TestInstance triples.
	 * @return {Array<number>}
	 */
	_readTestIDs()
	{
		const tmpAddress = this._getConfiguration().TestInstancesAddress || 'AppData.DocumentData.ReportData.FormData.SampleTestIDs__Record_Instances';
		const tmpInstances = this.pict.manifest.getValueAtAddress(this.pict, tmpAddress);
		if (!Array.isArray(tmpInstances))
		{
			return [];
		}
		const tmpSet = new Set();
		for (const tmpTriple of tmpInstances)
		{
			const tmpIDTest = parseInt(tmpTriple && tmpTriple.TestInstance && tmpTriple.TestInstance.IDTest, 10);
			if (tmpIDTest > 0)
			{
				tmpSet.add(tmpIDTest);
			}
		}
		return Array.from(tmpSet);
	}

	/**
	 * The sample's material, driving the `LabTestDefault` axis. Absent config (or an unset value) leaves that
	 * axis unloaded, which reads as "no constraint".
	 * @return {number}
	 */
	_readMaterialID()
	{
		const tmpAddress = this._getConfiguration().MaterialFromField;
		if (!tmpAddress)
		{
			return 0;
		}
		const tmpID = parseInt(this.pict.manifest.getValueByHash(this.pict, tmpAddress), 10);
		return tmpID > 0 ? tmpID : 0;
	}

	/**
	 * The sample's sample-type code (`LabTestDefault.SampleType` is a short code, not an id).
	 * @return {string}
	 */
	_readSampleType()
	{
		const tmpAddress = this._getConfiguration().SampleTypeFromField;
		if (!tmpAddress)
		{
			return '';
		}
		const tmpValue = this.pict.manifest.getValueByHash(this.pict, tmpAddress);
		return (tmpValue === null || tmpValue === undefined) ? '' : String(tmpValue).trim();
	}

	// --- lab tree ------------------------------------------------------------------------------------

	/**
	 * The parent of a lab, or the lab itself when it is already a root. A parent pointer that references a
	 * lab outside the catalog (or the lab itself) is treated as "no parent" rather than followed.
	 * @param {number|string} pIDLab
	 * @return {number}
	 */
	getParentLabID(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return 0;
		}
		const tmpLab = this._Labs.get(tmpIDLab);
		const tmpParent = tmpLab ? (parseInt(tmpLab.IDLabParent, 10) || 0) : 0;
		if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
		{
			return tmpIDLab;
		}
		return tmpParent;
	}

	/**
	 * Whether a lab is a leaf — it has no children, so a test assigned to it needs no further routing. A lab
	 * absent from the catalog counts as a leaf so an unloaded tree never hides an option.
	 * @param {number|string} pIDLab
	 * @return {boolean}
	 */
	isLeafLab(pIDLab)
	{
		const tmpIDLab = parseInt(String(pIDLab), 10);
		if (!(tmpIDLab > 0))
		{
			return false;
		}
		const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
		return !tmpChildren || tmpChildren.size < 1;
	}

	/**
	 * Resolve a set of labs to the leaves a test can actually be assigned to: a leaf stays, a parent is
	 * replaced by its children. Falls back to the input when the resolution empties it (a catalog that has
	 * not loaded), so this never removes the only options a caller had.
	 * @param {Set<number>|undefined|null} pLabIDs
	 * @return {Set<number>|null}
	 */
	_resolveToLeaves(pLabIDs)
	{
		if (!pLabIDs || pLabIDs.size < 1)
		{
			return null;
		}
		const tmpLeaves = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
			if (tmpChildren && tmpChildren.size > 0)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpLeaves.add(tmpChild);
				}
				continue;
			}
			tmpLeaves.add(tmpIDLab);
		}
		return (tmpLeaves.size > 0) ? tmpLeaves : new Set(pLabIDs);
	}

	/**
	 * The parent labs this project prefers, most-preferred first: those the `LabAffinity` rules match from the
	 * project's metadata (in rule order), then those `ProjectLabJoin` names. The sources are unioned — either
	 * alone is enough, and a lab both name ranks at its first appearance.
	 * @return {Array<number>}
	 */
	_getPreferredRootIDs()
	{
		const tmpRoots = [];
		for (const tmpRoot of [ ...this._AffinityRootIDs, ...(this._ProjectRootLabs || []) ])
		{
			if (tmpRoots.indexOf(tmpRoot) < 0)
			{
				tmpRoots.push(tmpRoot);
			}
		}
		return tmpRoots;
	}

	/**
	 * Order within one preference tier: `LabTestDefault` labs first, then labs another test on this sample
	 * already uses (so the sample picks up no extra lab it does not need), then by Name, then by id.
	 * @param {Array<number>} pLabIDs
	 * @param {Set<number>} pDefaultIDs
	 * @param {Set<number>} pSelectedIDs - labs the sample's other tests are already assigned to.
	 * @return {Array<number>}
	 */
	_rankWithinTier(pLabIDs, pDefaultIDs, pSelectedIDs)
	{
		const tmpName = (pIDLab) => String((this._Labs.get(pIDLab) || {}).Name || '');
		const tmpFirst = (pSet, pLeft, pRight) => (pSet.has(pLeft) ? 0 : 1) - (pSet.has(pRight) ? 0 : 1);
		return pLabIDs.slice().sort((pLeft, pRight) =>
		{
			return tmpFirst(pDefaultIDs, pLeft, pRight) || tmpFirst(pSelectedIDs, pLeft, pRight) ||
				tmpName(pLeft).localeCompare(tmpName(pRight)) || (pLeft - pRight);
		});
	}

	/**
	 * The distinct parent labs standing over a set of labs.
	 * @param {Set<number>|Array<number>} pLabIDs
	 * @return {Set<number>}
	 */
	_rootsOf(pLabIDs)
	{
		const tmpRoots = new Set();
		for (const tmpIDLab of (pLabIDs || []))
		{
			const tmpRoot = this.getParentLabID(tmpIDLab);
			if (tmpRoot > 0)
			{
				tmpRoots.add(tmpRoot);
			}
		}
		return tmpRoots;
	}

	// --- scope getters -------------------------------------------------------------------------------

	/**
	 * Allowed labs for the SHARED / sample-level selector — PARENT labs, because a sample ships to a parent
	 * and its tests are routed to that parent's benches afterwards. The project's own labs answer when it has
	 * any; otherwise the parents of every lab that can run a selected test.
	 * @return {Set<number>|null} null when neither axis has data (fail-open).
	 */
	getSampleLabIDs()
	{
		if (!this._Loaded)
		{
			return null;
		}
		if (this._ProjectRootLabs && this._ProjectRootLabs.size > 0)
		{
			return this._ProjectRootLabs;
		}
		const tmpRoots = new Set();
		for (const tmpTestLabs of this._TestLabs.values())
		{
			for (const tmpRoot of this._rootsOf(tmpTestLabs))
			{
				tmpRoots.add(tmpRoot);
			}
		}
		return (tmpRoots.size > 0) ? tmpRoots : null;
	}

	/**
	 * Allowed labs for a per-test selector — the LEAF labs that can actually run this test (`TestLabJoin`,
	 * resolved to leaves). Capability is the ONLY mandatory axis, because it is the only one where an empty
	 * result is informative: "no lab performs this test" is a fact, where every other narrowing is a
	 * preference. Project locality and the material defaults rank instead (see getPreferredLabIDs).
	 *
	 * Leaf grain is an invariant of this selector, not a property of one axis: a test is assigned to a bench,
	 * never to a lab that would only route it onward. A lab missing from the catalog counts as a leaf, so an
	 * unloaded tree filters nothing.
	 * @param {number|string} pIDTest
	 * @return {Set<number>|null} null when this test has no capability rows at all (fail-open).
	 */
	getTestLabIDs(pIDTest)
	{
		if (!this._Loaded)
		{
			return null;
		}
		const tmpTestLabs = this._resolveToLeaves(this._TestLabs.get(String(pIDTest)));
		if (!tmpTestLabs)
		{
			return null;
		}
		return this._keepLeaves(tmpTestLabs);
	}

	/**
	 * Drop any lab that routes further — a parent with benches beneath it. Its benches, when they qualify,
	 * are already in the set beside it.
	 * @param {Set<number>} pLabIDs
	 * @return {Set<number>}
	 */
	_keepLeaves(pLabIDs)
	{
		const tmpLeaves = new Set();
		for (const tmpIDLab of pLabIDs)
		{
			if (this.isLeafLab(tmpIDLab))
			{
				tmpLeaves.add(tmpIDLab);
			}
		}
		return tmpLeaves;
	}

	/**
	 * The material + sample-type default labs for a test (`LabTestDefault`), resolved to leaves. A RANKING
	 * axis only (see getPreferredLabIDs): it disagrees with `TestLabJoin` too often to narrow.
	 * @param {number|string} pIDTest
	 * @return {Set<number>|null} null when the axis has no rows for this test (no constraint).
	 */
	getTestLabDefaultIDs(pIDTest)
	{
		if (!this._Loaded)
		{
			return null;
		}
		return this._resolveToLeaves(this._TestLabDefaults.get(String(pIDTest)));
	}

	/**
	 * The labs to float to the top of a selector, most-preferred first. Never removes anything; callers pin,
	 * they do not filter.
	 *
	 *   'Sample' → the preferred parent labs the sample-level selector offers.
	 *   'Test'   → the capable benches in tiers: those in a preferred family, family by family in
	 *              `_getPreferredRootIDs` order, then the remaining `LabTestDefault` labs. Within a tier a
	 *              `LabTestDefault` lab leads, then a lab the sample's other tests already use, and Name
	 *              breaks ties, so the order is stable when nothing expresses a stronger preference.
	 * @param {string} [pScope] - 'Sample' (parent labs) or 'Test' (leaf labs).
	 * @param {{ IDTest?: number|string, SelectedLabIDs?: Array<number|string> }} [pContext]
	 * @return {Array<number>}
	 */
	getPreferredLabIDs(pScope, pContext)
	{
		if (!this._Loaded)
		{
			return [];
		}
		const tmpRoots = this._getPreferredRootIDs();
		if (pScope !== 'Test')
		{
			const tmpAllowedRoots = this._applySpecSetFloor(this.getSampleLabIDs());
			return tmpRoots.filter((pID) => !tmpAllowedRoots || tmpAllowedRoots.has(pID));
		}
		const tmpIDTest = pContext && pContext.IDTest;
		const tmpAllowed = this._applySpecSetFloor(this.getTestLabIDs(tmpIDTest));
		if (!tmpAllowed || tmpAllowed.size < 1)
		{
			return [];
		}
		const tmpDefaults = this.getTestLabDefaultIDs(tmpIDTest) || new Set();
		const tmpSelected = new Set(((pContext && pContext.SelectedLabIDs) || []).map((pID) => parseInt(pID, 10)));
		const tmpRanked = [];
		for (const tmpRoot of tmpRoots)
		{
			const tmpFamily = Array.from(tmpAllowed).filter((pID) => this.getParentLabID(pID) === tmpRoot && tmpRanked.indexOf(pID) < 0);
			tmpRanked.push(...this._rankWithinTier(tmpFamily, tmpDefaults, tmpSelected));
		}
		const tmpDefaultTier = Array.from(tmpAllowed).filter((pID) => tmpDefaults.has(pID) && tmpRanked.indexOf(pID) < 0);
		tmpRanked.push(...this._rankWithinTier(tmpDefaultTier, tmpDefaults, tmpSelected));
		return tmpRanked;
	}

	/**
	 * The lab to fill into an empty per-test selector, or 0 when there is nothing to fill. A test only one lab
	 * can run fills with that lab; otherwise the top of the `getPreferredLabIDs` ranking fills, so the value
	 * written is the first one the dropdown pins. A row with neither a preferred nor a `LabTestDefault`
	 * candidate stays blank.
	 *
	 * The spec-set floor is applied here even though the dropdown's filter does not carry it (the picker adds
	 * that clause itself), so the value written is one the dropdown would have offered — without it, a customer
	 * running two field-lab generations could be auto-filled into the retired one.
	 * @param {number|string} pIDTest
	 * @param {{ SelectedLabIDs?: Array<number|string> }} [pContext] - the labs the sample's other tests use.
	 * @return {number}
	 */
	getAutoFillLabID(pIDTest, pContext)
	{
		const tmpAllowed = this._applySpecSetFloor(this.getTestLabIDs(pIDTest));
		if (!tmpAllowed || tmpAllowed.size < 1)
		{
			return 0;
		}
		if (tmpAllowed.size === 1)
		{
			return Array.from(tmpAllowed)[0];
		}
		return this.getPreferredLabIDs('Test', { IDTest: pIDTest, SelectedLabIDs: pContext && pContext.SelectedLabIDs })[0] || 0;
	}

	/**
	 * The spec-set lab floor, expanded across the lab family: a lab is admitted when IT is in
	 * `LabTestSpecificationSetJoin`, when its PARENT is, or when any of its CHILDREN is.
	 *
	 * Membership is declared at the FAMILY level: the set names the parent labs and their benches come along,
	 * which is why the join is small relative to the lab catalog. Down-expansion is therefore the primary
	 * direction and the one the data is authored for. Up-expansion covers the rest: a set may also name a
	 * bench directly, and a bench-only entry must not strip the parent that the sample-level selector offers
	 * (that is the case `narrowLabsToSpecSet` in the materials app guards, noting "a parent survives whenever
	 * one of its children does, so narrowing the child labs never strips the district heading the user selects
	 * through"). Raw membership does neither, which empties whichever level the set was not authored at.
	 *
	 * The floor's real job — separating parallel lab generations mid-rename — is preserved either way, because
	 * generations differ by FAMILY: expanding within a family never reaches across to the other one.
	 *
	 * @return {Set<number>|null} null when the join has no coverage (no floor at all).
	 */
	getSpecSetLabFloor()
	{
		const tmpAdmitted = this.pict?.providers?.SpecScopeResolver?.getAllowedLabIDs?.();
		if (!tmpAdmitted || tmpAdmitted.size < 1)
		{
			return null;
		}
		const tmpFloor = new Set(tmpAdmitted);
		for (const tmpIDLab of tmpAdmitted)
		{
			const tmpParent = this.getParentLabID(tmpIDLab);
			if (tmpParent > 0)
			{
				tmpFloor.add(tmpParent);
			}
			const tmpChildren = this._ChildrenByParent.get(tmpIDLab);
			if (tmpChildren)
			{
				for (const tmpChild of tmpChildren)
				{
					tmpFloor.add(tmpChild);
				}
			}
		}
		return tmpFloor;
	}

	/**
	 * Narrow a candidate set to the labs the project's material specification set admits
	 * (`LabTestSpecificationSetJoin`, resolved by SpecScopeResolver).
	 *
	 * This is the ONLY thing that separates lab generations which are otherwise identical: a customer
	 * mid-rename runs two parallel field-lab trees whose members share a name stem AND an `ExternalLabID`
	 * (`District 02 Gang 202` and `District 02 Unit 202` are both coded `02-202`), so neither the naming
	 * rules nor the capability tables can tell them apart — only spec-set membership can.
	 *
	 * Applied where a lab is CHOSEN (auto-fill, pin order), not where the dropdown's filter is composed:
	 * the picker already layers the same floor as its own clause, and repeating it in the INN list would
	 * only lengthen the URL. Returns the intersection EVEN WHEN EMPTY — no admitted candidate means the
	 * caller must decline, not fall back to a lab from the retired generation.
	 *
	 * @param {Set<number>|null} pLabIDs
	 * @return {Set<number>|null}
	 */
	_applySpecSetFloor(pLabIDs)
	{
		if (!pLabIDs)
		{
			return pLabIDs;
		}
		const tmpAllowed = this.getSpecSetLabFloor();
		if (!tmpAllowed || tmpAllowed.size < 1)
		{
			return pLabIDs;
		}
		return this._intersect([ pLabIDs, tmpAllowed ]);
	}

	/**
	 * @param {Array<Set<number>>} pSets
	 * @return {Set<number>}
	 */
	_intersect(pSets)
	{
		const tmpResult = new Set(pSets[0]);
		for (let i = 1; i < pSets.length; i++)
		{
			for (const tmpValue of Array.from(tmpResult))
			{
				if (!pSets[i].has(tmpValue))
				{
					tmpResult.delete(tmpValue);
				}
			}
		}
		return tmpResult;
	}

	// --- priming -------------------------------------------------------------------------------------

	/**
	 * Prime (or re-prime) the caches from the form's current project, test set, material and sample type.
	 * Idempotent and de-duped — a no-op when the key is unchanged. Fire-and-forget; the transport awaits it
	 * before a dependent picker reads, so the getters resolve synchronously.
	 *
	 * Primes overlap whenever the test set changes faster than a prime completes, and the older one can land
	 * last. Only the current prime may write the caches or clear the in-flight marker — otherwise the newest
	 * test is dropped from the caches and the resolver reports itself settled for a key it never loaded.
	 * @return {Promise<void>}
	 */
	primeFromForm()
	{
		const tmpProject = this._readProjectID();
		const tmpTests = this._readTestIDs().sort((a, b) => a - b);
		const tmpMaterial = this._readMaterialID();
		const tmpSampleType = this._readSampleType();
		const tmpKey = `${tmpProject}|${tmpTests.join(',')}|${tmpMaterial}|${tmpSampleType}`;
		if (this._LoadedKey === tmpKey && !this._PrimePromise)
		{
			return Promise.resolve();
		}
		if (this._PrimePromise && this._PrimeKey === tmpKey)
		{
			return this._PrimePromise;
		}
		this._PrimeKey = tmpKey;
		const tmpPrime = this._load(tmpProject, tmpTests, tmpMaterial, tmpSampleType, tmpKey)
			.catch((pErr) =>
			{
				this.pict?.log?.warn(`[LabScopeResolver] prime failed (${tmpKey}): ${pErr?.message || pErr}`);
				if (this._PrimeKey === tmpKey)
				{
					this._LoadedKey = tmpKey;
				}
			})
			.finally(() =>
			{
				this._Loaded = true;
				if (this._PrimePromise === tmpPrime)
				{
					this._PrimePromise = null;
				}
			});
		this._PrimePromise = tmpPrime;
		return tmpPrime;
	}

	/**
	 * Whether a prime is still loading — the synchronous getters are answering from the previous key's caches.
	 * @return {boolean}
	 */
	isPriming()
	{
		return !!this._PrimePromise;
	}

	/**
	 * @param {number} pProjectID
	 * @param {Array<number>} pTestIDs
	 * @param {number} pMaterialID
	 * @param {string} pSampleType
	 * @param {string} pKey - the prime key this load answers; its rows are dropped if a newer prime superseded it.
	 * @return {Promise<void>}
	 */
	async _load(pProjectID, pTestIDs, pMaterialID, pSampleType, pKey)
	{
		await this._loadLabCatalog();
		// TestLabJoin rows are active-only: no DateEnd, or one still in the future.
		const tmpActiveTestLabFilter = `FBL~IDTest~INN~${pTestIDs.join(',')}~FOP~0~(~0~FBV~DateEnd~GT~${new Date().toISOString()}~FBVOR~DateEnd~EQ~~FCP~0~)~0`;
		const tmpProjectRead = (pProjectID > 0) ?
			this._readAllPages('ProjectLabJoins/Lite', `FBV~IDProject~EQ~${pProjectID}`) :
			Promise.resolve([]);
		const tmpTestLabRead = (pTestIDs.length > 0) ?
			this._readAllPages('TestLabJoins/Lite', tmpActiveTestLabFilter) :
			Promise.resolve([]);
		const [ tmpProjectRows, tmpTestLabRows, tmpLabDefaultRows ] = await Promise.all([
			tmpProjectRead,
			tmpTestLabRead,
			this._readLabTestDefaults(pTestIDs, pMaterialID, pSampleType),
		]);
		if (this._PrimeKey !== pKey)
		{
			return;
		}
		// ProjectLabJoin names PARENT labs. Normalize through the catalog anyway so a customer that joins a
		// child instead still scopes to the right family. NB: ProjectLabJoin has NO Deleted column — foxhound's
		// automatic soft-delete predicate is schema-driven, so it correctly adds nothing here, and a hand-written
		// Deleted clause would error the read (→ empty → silent fail-open).
		this._ProjectRootLabs = this._rootsOf(this._distinctPositive(tmpProjectRows.map((pRow) => pRow.IDLab)));
		this._TestLabs = this._indexByTest(tmpTestLabRows);
		this._TestLabDefaults = this._indexByTest(tmpLabDefaultRows);
		await this._loadAffinity(pProjectID);
		if (this._PrimeKey === pKey)
		{
			this._LoadedKey = pKey;
		}
	}

	/**
	 * The customer's lab catalog — read in full (not the Lite projection, which emits only `ID*`/`GUID*`
	 * columns and so carries neither the names nor the codes the affinity rules match on). Loaded once per
	 * session: the tree does not move while a form is open.
	 *
	 * The sort clause is also what makes this a legal paged read — meadow-endpoints exposes no bare
	 * `s/:Begin/:Cap`, only `s/FilteredTo/:Filter/:Begin/:Cap`, so a paged read needs a stanza.
	 * @return {Promise<void>}
	 */
	async _loadLabCatalog()
	{
		if (this._LabsLoaded)
		{
			return;
		}
		const tmpRows = await this._readAllPages('Labs', 'FSF~Name~ASC~0');
		this._Labs = new Map();
		this._ChildrenByParent = new Map();
		for (const tmpRow of tmpRows)
		{
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDLab > 0)
			{
				this._Labs.set(tmpIDLab, tmpRow);
			}
		}
		for (const tmpLab of this._Labs.values())
		{
			const tmpIDLab = parseInt(tmpLab.IDLab, 10);
			const tmpParent = parseInt(tmpLab.IDLabParent, 10) || 0;
			if (!(tmpParent > 0) || tmpParent === tmpIDLab || !this._Labs.has(tmpParent))
			{
				continue;
			}
			let tmpChildren = this._ChildrenByParent.get(tmpParent);
			if (!tmpChildren)
			{
				tmpChildren = new Set();
				this._ChildrenByParent.set(tmpParent, tmpChildren);
			}
			tmpChildren.add(tmpIDLab);
		}
		this._LabsLoaded = true;
	}

	/**
	 * `LabTestDefault` rows for the sample's material and sample type, restricted to the selected tests. Skipped
	 * entirely without a material — the table is keyed on it, and an unrestricted read is tens of thousands of
	 * rows.
	 * @param {Array<number>} pTestIDs @param {number} pMaterialID @param {string} pSampleType
	 * @return {Promise<Array<any>>}
	 */
	_readLabTestDefaults(pTestIDs, pMaterialID, pSampleType)
	{
		if (!(pMaterialID > 0) || pTestIDs.length < 1)
		{
			return Promise.resolve([]);
		}
		const tmpClauses = [ `FBV~IDMaterial~EQ~${pMaterialID}`, `FBL~IDTest~INN~${pTestIDs.join(',')}` ];
		if (pSampleType)
		{
			tmpClauses.push(`FBV~SampleType~EQ~${encodeURIComponent(pSampleType)}`);
		}
		return this._readAllPages('LabTestDefaults/Lite', tmpClauses.join('~'));
	}

	/**
	 * @param {Array<any>} pRows - rows carrying IDTest + IDLab.
	 * @return {Map<string, Set<number>>}
	 */
	_indexByTest(pRows)
	{
		const tmpIndex = new Map();
		for (const tmpRow of pRows)
		{
			const tmpIDTest = (tmpRow.IDTest === null || tmpRow.IDTest === undefined) ? '' : String(tmpRow.IDTest).trim();
			const tmpIDLab = parseInt(tmpRow.IDLab, 10);
			if (tmpIDTest === '' || !(tmpIDLab > 0))
			{
				continue;
			}
			let tmpSet = tmpIndex.get(tmpIDTest);
			if (!tmpSet)
			{
				tmpSet = new Set();
				tmpIndex.set(tmpIDTest, tmpSet);
			}
			tmpSet.add(tmpIDLab);
		}
		return tmpIndex;
	}

	// --- affinity ------------------------------------------------------------------------------------

	/**
	 * Resolve which of the customer's parent labs belong to this project, from the `LabAffinity` rules. Cached
	 * per project. Every step fails open to "no affinity", which costs the pin-to-top ordering and nothing else.
	 * @param {number} pProjectID
	 * @return {Promise<void>}
	 */
	async _loadAffinity(pProjectID)
	{
		if (this._AffinityProjectID === pProjectID)
		{
			return;
		}
		this._AffinityRootIDs = [];
		this._AffinityProjectID = pProjectID;
		const tmpAffinity = this._getConfiguration().LabAffinity;
		if (!tmpAffinity || !Array.isArray(tmpAffinity.Rules) || !(pProjectID > 0))
		{
			return;
		}
		try
		{
			const tmpProject = await this._loadProjectRecord(pProjectID, tmpAffinity);
			const tmpKeys = this._resolveAffinityKeys(tmpAffinity, this._readCustomProperties(tmpProject));
			this._AffinityRootIDs = this._matchAffinityRules(tmpAffinity, tmpKeys);
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[LabScopeResolver] affinity resolve failed (fail-open): ${pError?.message || pError}`);
		}
	}

	/**
	 * The Project record carrying `CustomProperties`. Prefers a record the form already holds (the project
	 * selector's `__Record` companion) over a REST read.
	 * @param {number} pProjectID @param {LabAffinityConfiguration} pAffinity
	 * @return {Promise<Record<string, any>|null>}
	 */
	async _loadProjectRecord(pProjectID, pAffinity)
	{
		if (pAffinity.ProjectRecordAddress)
		{
			const tmpRecord = this.pict.manifest.getValueAtAddress(this.pict, pAffinity.ProjectRecordAddress);
			if (tmpRecord && typeof tmpRecord === 'object' && tmpRecord.CustomProperties)
			{
				return tmpRecord;
			}
		}
		return this._getJSON(`Project/${pProjectID}`);
	}

	/**
	 * `CustomProperties` as an object, whether it arrives parsed or as a JSON string.
	 * @param {Record<string, any>|null} pProject
	 * @return {Record<string, any>}
	 */
	_readCustomProperties(pProject)
	{
		const tmpRaw = pProject ? pProject.CustomProperties : null;
		if (!tmpRaw)
		{
			return {};
		}
		if (typeof tmpRaw !== 'string')
		{
			return tmpRaw;
		}
		try
		{
			return JSON.parse(tmpRaw) || {};
		}
		catch (pError)
		{
			return {};
		}
	}

	/**
	 * Resolve each configured affinity key to its first non-empty project value. A value that is all digits and
	 * numerically zero is the customer's "unassigned" sentinel and counts as unset.
	 * @param {LabAffinityConfiguration} pAffinity @param {Record<string, any>} pProperties
	 * @return {Record<string, string>}
	 */
	_resolveAffinityKeys(pAffinity, pProperties)
	{
		/** @type {Record<string, string>} */
		const tmpKeys = {};
		const tmpProjectKeys = pAffinity.ProjectKeys || {};
		for (const tmpName of Object.keys(tmpProjectKeys))
		{
			const tmpCandidates = Array.isArray(tmpProjectKeys[tmpName]) ? tmpProjectKeys[tmpName] : [ tmpProjectKeys[tmpName] ];
			for (const tmpCandidate of tmpCandidates)
			{
				const tmpRaw = pProperties[tmpCandidate];
				const tmpValue = (tmpRaw === null || tmpRaw === undefined) ? '' : String(tmpRaw).trim();
				if (tmpValue === '' || (/^\d+$/.test(tmpValue) && Number(tmpValue) === 0))
				{
					continue;
				}
				tmpKeys[tmpName] = tmpValue;
				break;
			}
		}
		return tmpKeys;
	}

	/**
	 * The parent labs matched by the affinity rules, in rule order (which is the pin priority order).
	 * @param {LabAffinityConfiguration} pAffinity @param {Record<string, string>} pKeys
	 * @return {Array<number>}
	 */
	_matchAffinityRules(pAffinity, pKeys)
	{
		const tmpMatched = [];
		for (const tmpRule of pAffinity.Rules)
		{
			if (!tmpRule || !tmpRule.LabField || !tmpRule.Pattern)
			{
				continue;
			}
			const tmpRequires = Array.isArray(tmpRule.Requires) ? tmpRule.Requires : Object.keys(pKeys);
			if (tmpRequires.some((pRequired) => !pKeys[pRequired]))
			{
				continue;
			}
			let tmpExpression;
			try
			{
				tmpExpression = new RegExp(this._interpolatePattern(tmpRule.Pattern, pKeys), tmpRule.Flags || 'i');
			}
			catch (pError)
			{
				this.pict?.log?.warn(`[LabScopeResolver] LabAffinity rule pattern is not a valid expression: ${tmpRule.Pattern}`);
				continue;
			}
			for (const tmpLab of this._Labs.values())
			{
				const tmpIDLab = parseInt(tmpLab.IDLab, 10);
				// Affinity names the routing destination, so only parents are matched; children inherit.
				if (this.getParentLabID(tmpIDLab) !== tmpIDLab || tmpMatched.indexOf(tmpIDLab) > -1)
				{
					continue;
				}
				if (tmpExpression.test(String(tmpLab[tmpRule.LabField] === null || tmpLab[tmpRule.LabField] === undefined ? '' : tmpLab[tmpRule.LabField])))
				{
					tmpMatched.push(tmpIDLab);
				}
			}
		}
		return tmpMatched;
	}

	/**
	 * Fill `{KeyName}` placeholders in a rule pattern. An all-digits value interpolates as `0*<digits>` with
	 * leading zeros stripped, so one pattern matches both `District 02 Lab` and `District 2 Lab` and the
	 * customer's project metadata does not have to agree with its lab names on zero-padding. Anything else is
	 * escaped and matched literally.
	 * @param {string} pPattern @param {Record<string, string>} pKeys
	 * @return {string}
	 */
	_interpolatePattern(pPattern, pKeys)
	{
		return String(pPattern).replace(/\{([A-Za-z0-9_]+)\}/g, (pMatch, pName) =>
		{
			const tmpValue = pKeys[pName];
			if (tmpValue === undefined)
			{
				return pMatch;
			}
			if (/^\d+$/.test(tmpValue))
			{
				return `0*${String(Number(tmpValue))}`;
			}
			return tmpValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		});
	}

	// --- plumbing ------------------------------------------------------------------------------------

	/**
	 * App-load hook — prime from the loaded form. PictProvider defaults AutoLoadDataWithApp true.
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			this.primeFromForm().catch(() =>
			{
				// Priming already logs its own failure and marks itself loaded (fail-open); nothing to add here.
			}).finally(() =>
			{
				fCallback();
			});
		});
	}

	/**
	 * @param {string} pEntityRoute - pluralized route incl. projection, e.g. 'TestLabJoins/Lite'.
	 * @param {string} pFilter - meadow filter stanza.
	 * @return {Promise<Array<any>>}
	 */
	async _readAllPages(pEntityRoute, pFilter)
	{
		const tmpRows = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpPage = await this._getJSON(`${pEntityRoute}/FilteredTo/${pFilter}/${tmpOffset}/${LAB_PAGE_SIZE}`);
			if (!Array.isArray(tmpPage) || tmpPage.length === 0)
			{
				break;
			}
			for (const tmpRow of tmpPage)
			{
				tmpRows.push(tmpRow);
			}
			if (tmpPage.length < LAB_PAGE_SIZE)
			{
				break;
			}
			tmpOffset += LAB_PAGE_SIZE;
		}
		return tmpRows;
	}

	/**
	 * @param {Array<any>} pValues
	 * @return {Array<number>}
	 */
	_distinctPositive(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of pValues)
		{
			const tmpNumber = parseInt(tmpValue, 10);
			if (tmpNumber > 0)
			{
				tmpSet.add(tmpNumber);
			}
		}
		return Array.from(tmpSet);
	}

	/**
	 * @param {string} pUrl
	 * @return {Promise<any>}
	 */
	_getJSON(pUrl)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pUrl, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = LabScopeResolver;

},{"pict-provider":552}],145:[function(require,module,exports){
const PictProvider = require('pict-provider');

class MediaRegistryProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.OrphanObservationList = [];
		this.DefectObservationMap = {};
		this.BridgeElementSectionMap = {};
		this.BridgeElementSectionList = [];
		// Document observations load once per page; explicit refreshes re-read them.
		this._documentObservationsLoaded = false;
		/** @type {Promise<void>|null} the in-flight server refresh, shared by concurrent callers */
		this._documentObservationsRefresh = null;

		/**
		* @type {import('pict') & import('fable') &
		* {
		*   HeadlightRestClient: import('headlight-rest-client'),
		* }}
		*/
		this.pict;
		/** @type {import('log')} */
		this.pict.log;
		/** @type {import('fable')} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {any} */
		this.AppData;

		this.AppData.MediaRegistryStore = this.AppData.DocumentData?.ReportData?.FormData?.MediaRegistryStore || { NamespaceObservationSetMap: {}, Namespaces: {} };
	}

	/**
	 * Updates the AppData Registry to match the FormData Registry.
	 */
	updateRegistryFromFormData()
	{
		this.AppData.MediaRegistryStore = this.AppData.DocumentData?.ReportData?.FormData?.MediaRegistryStore || { NamespaceObservationSetMap: {}, Namespaces: {} };
	}

	/**
	 * Updates the FormData Registry to match the AppData Registry.
	 */
	_updateFormDataRegistry()
	{
		if (!this.AppData.DocumentData?.ReportData?.FormData)
		{
			return;
		}
		this.AppData.DocumentData.ReportData.FormData.MediaRegistryStore = this.AppData.MediaRegistryStore;
	}

	/**
	 * Adds a set of observations to the media registry. Preserves any existing ordinals.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Array} observations - the observations to register.
	 */
	registerMediaSet(namespace, observations)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		if (!observations)
		{
			this.pict.log.error('No observations provided to media registry provider, returning early.');
			return;
		}

		// If the namespace is not already in the registry, add it.
		if (!this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
		}

		for (const o of observations)
		{
			if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation])
			{
				// Add an entry for the observation under the correct namespace.
				this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation] =
				{
					IDObservation: o.IDObservation,
					ObservationType: o.ObservationType,
					CreateDate: o.CreateDate,
				};
			}
			else if (o.Ordinal)
			{
				this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal = o.Ordinal;
			}
		}

		// Clear out any "old" keys that should no longer be present in the set.
		const newIDs = observations.map((o) => o.IDObservation);
		for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
		{
			if (!newIDs.includes(parseInt(id)))
			{
				delete this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id];
			}
		}

		// Update the ordinals so that any observation without an ordinal gets one.
		this._updateOrdinalsForNamespace(namespace);

		// Save the changes to the form data.
		this._updateFormDataRegistry();

		return this._getFullConstructedRegistrySetFromArray(namespace, observations);
	}

	/**
	 * Adds a set of observation ids to the media registry. Preserves any existing ordinals.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Array} observationIDs - the IDs of the observations to register.
	 */
	async registerMediaSetByIDList(namespace, observationIDs)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		if (!observationIDs)
		{
			this.pict.log.error('No observations provided to media registry provider, returning early.');
			return;
		}
		try
		{
			return this.registerMediaSet(namespace, await this.pict.providers.ObservationProvider.getObservationByIDList(observationIDs));
		}
		catch (err)
		{
			this.pict.log.error('Error fetching Observations: ', err.message);
		}
	}

	/**
	 * Adds an observation set to the media registry using its id to look up the observations. Preserves any existing ordinals.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Number} IDObservationSet - the ID of the observation set to register.
	 */
	async registerMediaSetByIDObservationSet(namespace, IDObservationSet)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		if (!IDObservationSet)
		{
			this.pict.log.error('No IDObservationSet provided to media registry provider, clearing namespace and returning early.');
			this.clearNamespace(namespace);
			return;
		}
		try
		{
			this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace] = IDObservationSet;
			return this.registerMediaSet(namespace, await this.pict.providers.ObservationSetProvider.loadSetObservations(IDObservationSet));
		}
		catch (err)
		{
			this.pict.log.error('Error fetching Observations: ', err.message);
		}
	}

	/**
	 * Updates the registry copies of any namespaces attached to a specific observation set id.
	 * @param {Number} IDObservationSet - The id of the observation set we are updating namespaces for.
	 * @param {Array} [observations] - Optional, can pass a set of observations if we already have them to prevent needing to look them up with a network call.
	 */
	async updateNamespacesByIDObservationSet(IDObservationSet, observations)
	{
		if (!IDObservationSet)
		{
			this.pict.log.error('No IDObservationSet provided to media registry provider, returning early.');
			return;
		}
		let observationList = observations || [];
		if (!observations)
		{
			try
			{
				observationList = await this.pict.providers.ObservationSetProvider.loadSetObservations(IDObservationSet);
			}
			catch (err)
			{
				this.pict.log('Error fetching observation set: ', err.message);
				return;
			}
		}
		for (const namespace of Object.keys(this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap))
		{
			if (this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace] == IDObservationSet)
			{
				return this.registerMediaSet(namespace, observationList);
			}
		}
	}

	/**
	 * Clears any registry data from this namespace.
	 * @param {String} namespace - namespace we are clearing out.
	 */
	async clearNamespace(namespace)
	{
		if (this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
		}
		if (this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace])
		{
			delete this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace];
		}
	}

	/**
	 * Adds a new single observation to a registry under a namespace.
	 * @param {String} namespace - namespace of the observation.
	 * @param {Object} observation - the observation to add to the namespace.
	 *
	 * @returns {Object} The registry entry that was created, or the existing one if it is already present.
	 */
	_addRegistryEntry(namespace, observation)
	{
		// If this observation is already registered, return the existing entry.
		if (this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace]?.[observation.IDObservation])
		{
			return this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace]?.[observation.IDObservation];
		}
		// If the namespace is not already in the registry, add it.
		if (!this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
		}

		// Add an entry for the observation under the correct namespace.
		this.pict.AppData.MediaRegistryStore.Namespaces[namespace][observation.IDObservation] =
		{
			IDObservation: observation.IDObservation,
			ObservationType: observation.ObservationType,
			CreateDate: observation.CreateDate,
		};

		// Update the ordinals so that any observation without an ordinal gets one.
		this._updateOrdinalsForNamespace(namespace);

		// Save the change to the form data.
		this._updateFormDataRegistry();

		return this.pict.AppData.MediaRegistryStore.Namespaces[namespace][observation.IDObservation];
	}

	/**
	 * Adds a new single observation to a registry under a namespace.
	 * @param {String} namespace  - namespace of the observation.
	 * @param {Number} IDObservation - the ID of the observation being added.
	 *
	 * @returns {Promise<Object>} The registry entry that was created, or the existing one if it is already present.
	 */
	async _addRegistryEntryByID(namespace, IDObservation)
	{
		try
		{
			return this._addRegistryEntry(namespace, await this.pict.providers.ObservationProvider.getObservationByID(IDObservation));
		}
		catch (err)
		{
			this.pict.log.error('Error fetching observation: ', err.message);
			return {};
		}
	}

	/**
	 * Updates the ordinals of any observations within a namespace with no ordinals (preserves existing ordinals).
	 * @param {String} namespace - namespace of the observations.
	 */
	_updateOrdinalsForNamespace(namespace)
	{
		// Get the observation array presorted by Ordinal and CreateDate.
		const observationArray = this._getConstructedRegistrySet(namespace);
		const maxOrdinalsByType = {};
		for (const o of observationArray)
		{
			if (!o.Ordinal)
			{
				if (!maxOrdinalsByType[o.ObservationType])
				{
					o.Ordinal = 1;
				}
				else
				{
					o.Ordinal = maxOrdinalsByType[o.ObservationType] + 1;
				}
				this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal = o.Ordinal;
			}
			maxOrdinalsByType[o.ObservationType] = o.Ordinal;
		}
	}

	/**
	 * Turns the object structured in the registry for a namespace into a sorted array and returns it.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Array} The sorted array of Observations.
	 */
	_getConstructedRegistrySet(namespace)
	{
		if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
			return [];
		}
		const observationArr = [];
		for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
		{
			observationArr.push(this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id]);
		}
		return observationArr.sort((a, b) =>
		{
			// Sort first based on ordinal.
			if (a.Ordinal < b.Ordinal)
			{
				return -1;
			}
			if (b.Ordinal < a.Ordinal)
			{
				return 1;
			}
			// If one doesn't have an ordinal, prefer the one that does.
			if (a.Ordinal && !b.Ordinal)
			{
				return -1;
			}
			if (!a.Ordinal && b.Ordinal)
			{
				return 1;
			}
			// Sort whatever's left based on date.
			return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
		});
	}

	/**
	 * Turns the object structured in the registry for a namespace into a sorted array and returns it. Also fetches the full observations and decorates them with the registry values.
	 * This is the non async version that can be called when you already have the observations array.
	 * @param {String} namespace - namespace of the observations.
	 * @param {Array} observations - if we already have the observations, we don't need to fetch them again so they are passed into this method.
	 *
	 * @returns {Array} The sorted array of Observations.
	 */
	_getFullConstructedRegistrySetFromArray(namespace, observations)
	{
		if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
			return [];
		}
		const observationArr = [];
		const fullObservations = observations;
		if (!fullObservations)
		{
			this.pict.log.error('No Observations fetched as yet, returning just what is in registry.');
			for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
			{
				observationArr.push(this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id]);
			}
		}
		else
		{
			for (const o of fullObservations)
			{
				o.Ordinal = this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal;
				observationArr.push(o);
			}
		}

		return observationArr.sort((a, b) =>
		{
			// Sort first based on ordinal.
			if (a.Ordinal < b.Ordinal)
			{
				return -1;
			}
			if (b.Ordinal < a.Ordinal)
			{
				return 1;
			}
			// If one doesn't have an ordinal, prefer the one that does.
			if (a.Ordinal && !b.Ordinal)
			{
				return -1;
			}
			if (!a.Ordinal && b.Ordinal)
			{
				return 1;
			}
			// Sort whatever's left based on date.
			return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
		});
	}

	/**
	 * Turns the object structured in the registry for a namespace into a sorted array and returns it. Also fetches the full observations and decorates them with the registry values.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Promise<Array>} The sorted array of Observations.
	 */
	async _getFullConstructedRegistrySet(namespace)
	{
		if (!this.pict.AppData.MediaRegistryStore.Namespaces[namespace])
		{
			this.pict.AppData.MediaRegistryStore.Namespaces[namespace] = {};
			return [];
		}
		const observationArr = [];
		try
		{
			const fullObservations = await this.pict.providers.ObservationProvider.getObservationByIDList(Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]) || []);
			for (const o of fullObservations)
			{
				o.Ordinal = this.pict.AppData.MediaRegistryStore.Namespaces[namespace][o.IDObservation].Ordinal;
				observationArr.push(o);
			}
		}
		catch (err)
		{
			this.pict.log.error('Error fetching full observations, returning just what is in registry.', err.message);
			for (const id of Object.keys(this.pict.AppData.MediaRegistryStore.Namespaces[namespace]))
			{
				observationArr.push(this.pict.AppData.MediaRegistryStore.Namespaces[namespace][id]);
			}
		}

		return observationArr.sort((a, b) =>
		{
			// Sort first based on ordinal.
			if (a.Ordinal < b.Ordinal)
			{
				return -1;
			}
			if (b.Ordinal < a.Ordinal)
			{
				return 1;
			}
			// If one doesn't have an ordinal, prefer the one that does.
			if (a.Ordinal && !b.Ordinal)
			{
				return -1;
			}
			if (!a.Ordinal && b.Ordinal)
			{
				return 1;
			}
			// Sort whatever's left based on date.
			return new Date(a.CreateDate).getTime() - new Date(b.CreateDate).getTime();
		});
	}

	/**
	 * Fetches an entry from the media registry using its namespace and id.
	 * @param {String} namespace - namespace to look for the observation in.
	 * @param {Number} IDObservation - the observation we are looking up.
	 *
	 * @returns {Object} The matching registry entry.
	 */
	_getRegistryEntry(namespace, IDObservation)
	{
		return this.pict.AppData.MediaRegistryStore.Namespaces?.[namespace]?.[IDObservation] || {};
	}

	/**
	 * Retrieves the ordinal that should be assigned to an observation within a given namespace. Will generate one if the registry entry does not exist.
	 * @param {String} namespace - namespace of the observation.
	 * @param {Number} IDObservation - the ID of the observation we are checking the ordinal of.
	 *
	 * @returns {Promise<Number>} The ordinal for the observation.
	 */
	async getOrdinal(namespace, IDObservation)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		const entry = this._getRegistryEntry(namespace, IDObservation);
		if (entry.Ordinal)
		{
			return entry.Ordinal;
		}
		const newEntry = await this._addRegistryEntryByID(namespace, IDObservation);
		return newEntry.Ordinal;
	}

	/**
	 * Returns the array of observations that are part of this set with the additional registry fields (like ordinal) decorated on them.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Promise<Array>} The array of observations that are part of this set with the additional registry fields (like ordinal) decorated on them.
	 */
	async getMediaSet(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}

		return await this._getFullConstructedRegistrySet(namespace);
	}

	/**
	 * Returns the id of the observation set attached to a namespace (if one exists).
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Number} The IDObservationSet for the given namespace.
	 */
	getObservationSetIDByNamespace(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		return this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace];
	}

	/**
	 * Returns the array of observations in the observation set attached to a namespace (if one exists). It will be decorated with fields from the registry and be sorted by ordinal.
	 * @param {String} namespace - namespace of the observations.
	 *
	 * @returns {Promise<Array>} The full Observation Set for the given namespace.
	 */
	async getObservationSetByNamespace(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		const IDObservationSet = this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap[namespace];
		if (!IDObservationSet)
		{
			this.pict.log.warn('No ObservationSet is registered to this namespace.');
			return [];
		}
		await this.registerMediaSetByIDObservationSet(namespace, IDObservationSet);
		return await this.getMediaSet(namespace);
	}

	/**
	 * Method for refreshing the registry namespace for the 'global' set of photos on a document.
	 * @param {Array} [pObservations] - optional, if we already have the observations we can pass them in to avoid an unnecessary network call to fetch them again (or to avoid using a cached set)
	 */
	async refreshDocumentObservations(pObservations)
	{
		if (pObservations)
		{
			// When observations are passed directly (as full objects), register them
			// without re-fetching from the API — they are already the latest state.
			this.registerMediaSet('DocumentObservations', pObservations);
			this._documentObservationsLoaded = true;
			return;
		}
		// Single-flight: several card decks marshaling at once share one document read.
		if (this._documentObservationsRefresh)
		{
			return this._documentObservationsRefresh;
		}
		this._documentObservationsRefresh = (async () =>
		{
			try
			{
				const documentRecord = await this.pict.providers.DocumentProvider.getDocument(this.AppData.DocumentData.ReportData.IDDocument);
				await this.registerMediaSetByIDList('DocumentObservations', documentRecord.Observations);
			}
			catch (err)
			{
				this.pict.log.error('Error fetching document record, will default to observations listed on the local document: ', err.message);
				this.registerMediaSet('DocumentObservations', this.AppData.DocumentData.ReportData.Observations);
			}
			this._documentObservationsLoaded = true;
		})().finally(() =>
		{
			this._documentObservationsRefresh = null;
		});
		return this._documentObservationsRefresh;
	}

	/**
	 * Load the document's observation set once. The loaded document already carries the full
	 * observation objects, so no request is needed; the server is only read when the document
	 * holds bare ids. Call refreshDocumentObservations to re-read after a change.
	 * @return {Promise<void>}
	 */
	primeDocumentObservations()
	{
		if (this._documentObservationsLoaded)
		{
			return Promise.resolve();
		}
		const tmpLocalObservations = this.AppData.DocumentData?.ReportData?.Observations;
		if (Array.isArray(tmpLocalObservations) && tmpLocalObservations.every((o) => o && (typeof o === 'object') && ('IDObservation' in o)))
		{
			return this.refreshDocumentObservations(tmpLocalObservations);
		}
		return this.refreshDocumentObservations();
	}

	/**
	 * Method that returns the 'global' set of photos on a document decorated with any fields from the registry.
	 * Loads the set on first use; mutation paths refresh it explicitly.
	 */
	async getDocumentObservations()
	{
		await this.primeDocumentObservations();
		return this.getMediaSet('DocumentObservations');
	}

	/**
	 * Method that returns the 'global' set of photos on a document decorated with any fields from the registry, excluding any that are already included in any of the namespaces attached to observation sets (like card decks that are using observation sets.)
	 * This is useful for when you want to show the user all of the photos on a document that are not already being used in a specific way on the form.
	 * @param {Array<string>} [pNamespacesToExclude] - Optional array of specific namespaces to exclude from. When provided, only observations in these namespaces are excluded. When omitted, all namespaces in NamespaceObservationSetMap are used.
	 */
	async getDocumentObservationsExcludingCurrentSets(pNamespacesToExclude)
	{
		await this.primeDocumentObservations();
		const documentObservations = await this.getMediaSet('DocumentObservations');
		const currentSetObservationIDs = new Set();
		const namespacesToCheck = pNamespacesToExclude || Object.keys(this.pict.AppData.MediaRegistryStore.NamespaceObservationSetMap);
		for (const namespace of namespacesToCheck)
		{
			const setObservations = await this.getMediaSet(namespace);
			for (const o of setObservations)
			{
				currentSetObservationIDs.add(o.IDObservation);
			}
		}
		return documentObservations.filter((o) => !currentSetObservationIDs.has(o.IDObservation));
	}

	/**
	 * Returns the array of observations that are part of this set with just the decorated registry fields (does not fetch the full observations.)
	 * @param {String} namespace - namespace of the observations.
	 * @returns {Array} The array of observations that are part of this set with only the registry fields (like ordinal) on them.
	*/
	getMediaSetPartial(namespace)
	{
		if (!namespace)
		{
			this.pict.log.error('No namespace was provided to media registry provider, returning early.');
			return;
		}
		return this._getConstructedRegistrySet(namespace);
	}
}

module.exports = MediaRegistryProvider;

},{"pict-provider":552}],146:[function(require,module,exports){
/* eslint-disable indent */
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * NumberScrollLock - Prevents mouse wheel events from incrementing/decrementing
 * the value of number inputs. This is enabled by default for all Number and
 * PreciseNumber inputs to avoid accidental value changes while scrolling.
 *
 * To re-enable mouse wheel scrolling on a specific input, set the following
 * in the PictForm configuration for that input:
 *
 *   "AllowMouseWheelScroll": true
 */
class NumberScrollLock extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Attach a wheel event listener to the input element that prevents
	 * scroll-based value changes while the input is focused.
	 *
	 * @param {HTMLInputElement} pElement - The input element to protect.
	 */
	attachScrollLock(pElement)
	{
		if (!pElement) return;

		pElement.addEventListener('wheel', (pEvent) =>
		{
			// Only prevent the default behavior when the input is focused,
			// so that normal page scrolling is unaffected when the input
			// is not active.
			if (document.activeElement === pElement)
			{
				pEvent.preventDefault();
			}
		}, { passive: false });
	}

	/**
	 * Called when a standard (non-tabular) input is initialized.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pRow - The row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector for the input.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Allow opting back in to wheel scroll via PictForm config
		if (pInput?.PictForm?.AllowMouseWheelScroll)
		{
			return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}

		const tmpElement = this.pict.ContentAssignment.getElement(pHTMLSelector)?.[0];
		this.attachScrollLock(tmpElement);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Called when a tabular input is initialized.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector for the input.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// Allow opting back in to wheel scroll via PictForm config
		if (pInput?.PictForm?.AllowMouseWheelScroll)
		{
			return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}

		// Append the row-specific data attribute to the base selector.
		// The base pHTMLSelector does not include the row index, so we
		// match the pattern used by the view's dataChangedTabular flow.
		const tmpRowSelector = pHTMLSelector + `[data-i-index="${pRowIndex}"]`;
		const tmpElement = this.pict.ContentAssignment.getElement(tmpRowSelector)?.[0];
		this.attachScrollLock(tmpElement);

		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = NumberScrollLock;

},{"pict-section-form":587}],147:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;
const marked = require('marked');

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Converts markdown content to HTML.
	 * @param {string} pValue - The markdown content.
	 * @return {string} - The HTML content.
	 */
	convertMarkdownToQRCodeImage(pValue)
	{
		let tmpContent = '';
		if (pValue)
		{
			tmpContent = marked.parse(pValue, { async: false });
		}
		return tmpContent;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.convertMarkdownToQRCodeImage(pValue);
		this.pict.ContentAssignment.assignContent('#' + pInput.Macro.RawHTMLID, tmpContent);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.convertMarkdownToQRCodeImage(pValue);
		this.pict.ContentAssignment.assignContent(('#' + pInput.Macro.RawHTMLID + '-' + pRowIndex), tmpContent);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"marked":506,"pict-section-form":587}],148:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

// Largest denominator a row's widths keep exactly (as fractions); rows needing a finer one are split in whole percent.
const PROPORTIONAL_MAX_DENOMINATOR = 24;

class ResponsiveUIAdjustmentProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		this.defaultColumnCount = 12;
		// NOTE: The default column count is set to 12, which is the standard for Bulma CSS framework.
		// This can be adjusted based on the application's requirements, but Bulma supports up to 12 columns by default, so we'll need to expand the Bulma styling collection if we want to support more than that.
		this.activeColumnCount = this.defaultColumnCount;

		/** @type {(pInput: any) => boolean} */
		this._layoutExcludedInputCheck = (pInput) => this.isProportionalRowWidthMode() && this.isLayoutExcludedColumn(pInput);
		this.registerLayoutExcludedInputCheck();

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('Headlight-ProportionalColumns-CSS', this.getProportionalColumnCSS(), 500);
		}
	}

	/**
	 * Proportional row widths apply to the document forms (Dynamic Form / Materials Form), which carry a default
	 * form manifest; other apps built on this bundle keep the legacy per-field `is-N` classes.
	 *
	 * @return {Boolean}
	 */
	isProportionalRowWidthMode()
	{
		return Boolean(this.pict && this.pict.settings && this.pict.settings.MyDefaultFormManifest && this.pict.settings.MyDefaultFormManifest.Descriptors);
	}

	/**
	 * Hand isLayoutExcludedColumn to pict-section-form's Record layout, so its row widths leave hidden and
	 * zero-width inputs out. Idempotent; a no-op when the layout provider or its hook is missing.
	 */
	registerLayoutExcludedInputCheck()
	{
		const tmpRecordLayout = this.pict && this.pict.providers && this.pict.providers['Pict-Layout-Record'];
		if (tmpRecordLayout && (typeof tmpRecordLayout.registerLayoutExcludedInputCheck === 'function'))
		{
			tmpRecordLayout.registerLayoutExcludedInputCheck(this._layoutExcludedInputCheck);
		}
	}

	/**
	 * The share of its row an input takes, from pict-section-form's Record layout (its row grouping, raw widths
	 * and offsets, with layout-excluded inputs taking none).
	 *
	 * @param {Object} pInput - an input descriptor, as handed to {~ColumnWidth:~}
	 * @return {{Auto: boolean, Excluded: boolean, Width: RowShare|null, Offset: RowShare|null, Classes: string}|null} -
	 *   null when the legacy per-field classes apply (not a document form, or no Record-layout row for the input);
	 *   Auto when no visible input in the row sets a Width; otherwise the input's shares of the row and the
	 *   classes that size it
	 */
	getProportionalRowWidths(pInput)
	{
		if (!this.isProportionalRowWidthMode() || !pInput || !pInput.PictForm)
		{
			return null;
		}
		const tmpPictForm = pInput.PictForm;
		const tmpView = this.pict.views[tmpPictForm.ViewHash];
		if (!tmpView || (typeof tmpView.getRow !== 'function') || isNaN(tmpPictForm.GroupIndex) || isNaN(tmpPictForm.RowIndex))
		{
			return null;
		}
		const tmpRow = tmpView.getRow(tmpPictForm.GroupIndex, tmpPictForm.RowIndex);
		if (!tmpRow || !Array.isArray(tmpRow.Inputs) || !tmpRow.Inputs.includes(pInput) || !(tmpRow.WidthTotalRaw > 0))
		{
			return null;
		}
		const tmpRowHasWidth = tmpRow.Inputs.some((pRowInput) => pRowInput.PictForm && pRowInput.PictForm.Width && !pRowInput.PictForm.LayoutExcluded);
		if (!tmpRowHasWidth)
		{
			return { Auto: true, Excluded: false, Width: null, Offset: null, Classes: '' };
		}
		if (tmpPictForm.LayoutExcluded)
		{
			return { Auto: false, Excluded: true, Width: null, Offset: null, Classes: '' };
		}
		const tmpShare = this.allocateRowShares(tmpRow)[tmpRow.Inputs.indexOf(pInput)];
		const tmpClasses = [];
		if (tmpShare.Width)
		{
			tmpClasses.push(`hl-col-${tmpShare.Width.Numerator}-${tmpShare.Width.Denominator}`);
		}
		if (tmpShare.Offset)
		{
			tmpClasses.push(`hl-col-offset-${tmpShare.Offset.Numerator}-${tmpShare.Offset.Denominator}`);
		}
		return { Auto: false, Excluded: false, Width: tmpShare.Width, Offset: tmpShare.Offset, Classes: tmpClasses.join(' ') };
	}

	/**
	 * @typedef {Object} RowShare
	 * @property {number} Numerator
	 * @property {number} Denominator - reduced; at most PROPORTIONAL_MAX_DENOMINATOR, or 100 for a whole-percent share
	 */

	/**
	 * Each row input's width and offset as a reduced fraction of a pict-section-form row. The fractions are exact
	 * when every one reduces to a denominator of PROPORTIONAL_MAX_DENOMINATOR or less (thirds stay thirds);
	 * otherwise the row is split in whole percent by largest remainder. Either way the row totals exactly 1.
	 *
	 * @param {{Inputs: Array<Object>}} pRow - a Record-layout row after template generation
	 * @return {Array<{Width: RowShare|null, Offset: RowShare|null}>} - one entry per row input, in row order; null for a zero share
	 */
	allocateRowShares(pRow)
	{
		const fGCD = (pA, pB) => (pB ? fGCD(pB, pA % pB) : pA);
		const fReduce = (pNumerator, pDenominator) =>
		{
			if (!pNumerator)
			{
				return null;
			}
			const tmpDivisor = fGCD(pNumerator, pDenominator);
			return { Numerator: pNumerator / tmpDivisor, Denominator: pDenominator / tmpDivisor };
		};
		const tmpParts = [];
		pRow.Inputs.forEach((pRowInput, pIndex) =>
		{
			const tmpPictForm = pRowInput.PictForm || {};
			tmpParts.push({ Index: pIndex, Key: 'Width', Raw: tmpPictForm.RawWidth || 0 });
			tmpParts.push({ Index: pIndex, Key: 'Offset', Raw: tmpPictForm.RawWidthOffset || 0 });
		});
		const tmpResult = pRow.Inputs.map(() => ({ Width: null, Offset: null }));

		const tmpScale = [ 1, 2, 4, 5, 10, 100 ].find((pScale) => tmpParts.every((pPart) => Math.abs((pPart.Raw * pScale) - Math.round(pPart.Raw * pScale)) < 1e-9));
		if (tmpScale)
		{
			const tmpTotal = tmpParts.reduce((pSum, pPart) => pSum + Math.round(pPart.Raw * tmpScale), 0);
			const tmpExact = tmpParts.map((pPart) => fReduce(Math.round(pPart.Raw * tmpScale), tmpTotal));
			if ((tmpTotal > 0) && tmpExact.every((pShare) => !pShare || (pShare.Denominator <= PROPORTIONAL_MAX_DENOMINATOR)))
			{
				tmpParts.forEach((pPart, pIndex) =>
				{
					tmpResult[pPart.Index][pPart.Key] = tmpExact[pIndex];
				});
				return tmpResult;
			}
		}

		const tmpRawTotal = tmpParts.reduce((pSum, pPart) => pSum + pPart.Raw, 0);
		let tmpAllocated = 0;
		for (const tmpPart of tmpParts)
		{
			tmpPart.Exact = tmpPart.Raw / tmpRawTotal * 100;
			tmpPart.Percent = Math.floor(tmpPart.Exact);
			tmpAllocated += tmpPart.Percent;
		}
		const tmpByRemainder = tmpParts.filter((pPart) => pPart.Exact > pPart.Percent).sort((pA, pB) => (pB.Exact - pB.Percent) - (pA.Exact - pA.Percent));
		for (let i = 0; (i < tmpByRemainder.length) && (tmpAllocated < 100); i++)
		{
			tmpByRemainder[i].Percent++;
			tmpAllocated++;
		}
		for (const tmpPart of tmpParts)
		{
			tmpResult[tmpPart.Index][tmpPart.Key] = fReduce(tmpPart.Percent, 100);
		}
		return tmpResult;
	}

	/**
	 * The stylesheet behind the classes {~ColumnWidth:~} emits for proportional rows: `hl-col-N-D` (width) and
	 * `hl-col-offset-N-D` for every reduced fraction with a denominator up to PROPORTIONAL_MAX_DENOMINATOR, and
	 * every whole percent, inside Bulma's own column breakpoint so rows still stack on mobile.
	 *
	 * @return {string}
	 */
	getProportionalColumnCSS()
	{
		const fGCD = (pA, pB) => (pB ? fGCD(pB, pA % pB) : pA);
		const tmpFractions = new Map();
		const tmpDenominators = [];
		for (let d = 1; d <= PROPORTIONAL_MAX_DENOMINATOR; d++)
		{
			tmpDenominators.push(d);
		}
		tmpDenominators.push(100);
		for (const tmpDenominator of tmpDenominators)
		{
			for (let n = 1; n <= tmpDenominator; n++)
			{
				const tmpDivisor = fGCD(n, tmpDenominator);
				tmpFractions.set(`${n / tmpDivisor}-${tmpDenominator / tmpDivisor}`, Number((n / tmpDenominator * 100).toFixed(4)));
			}
		}
		const tmpRules = [];
		for (const [ tmpKey, tmpPercent ] of tmpFractions)
		{
			tmpRules.push(`.columns > .column.hl-col-${tmpKey} { flex: none; width: ${tmpPercent}%; }`);
			tmpRules.push(`.columns > .column.hl-col-offset-${tmpKey} { margin-inline-start: ${tmpPercent}%; }`);
		}
		return `@media screen and (min-width: 769px), print {\n${tmpRules.join('\n')}\n}\n`;
	}

	/**
	 * Set the active column count for responsive UI adjustments
	 * @param {Number} pColumnCount - The number of columns to set
	 * @return {Number} - The active column count after setting
	 */
	setActiveColumnCount(pColumnCount)
	{
		if (typeof pColumnCount !== 'number' || pColumnCount <= 0)
		{
			this.pict.log.error('Invalid column count provided.');
			throw new Error('Invalid column count provided.');
		}
		// if the column count is greater than the default, we need to adjust it to the default until we can expand the Bulma styling collection
		if (pColumnCount > this.defaultColumnCount)
		{
			this.pict.log.warn(`Requested column count ${pColumnCount} exceeds default column count ${this.defaultColumnCount}. Adjusting to default.`);
			this.pict.log.warn(`DEVELOPER NOTE: Bulma styling collection will need to be expanded to support more than ${this.defaultColumnCount} columns.`);
			pColumnCount = this.defaultColumnCount;
		}
		this.activeColumnCount = pColumnCount;
		return this.activeColumnCount;
	}

	/**
	 * Get the current active column count for responsive UI adjustments
	 * @return {Number} - The current active column count
	 */
	getActiveColumnCount()
	{
		return this.activeColumnCount;
	}

	/**
	 * Reset the active column count to the default value
	 * @return {Number} - The active column count after reset
	 */
	resetActiveColumnCount()
	{
		this.activeColumnCount = this.defaultColumnCount;
		return this.activeColumnCount;
	}

	/**
	 * Determine whether a column should be excluded from the row layout math.
	 *
	 * An excluded column is layout-neutral: it is dropped from every width sum / normalization
	 * so the remaining visible columns fill the row as if it were not present, and the
	 * {~ColumnWidth:~} macro renders it taking no horizontal space.
	 *
	 * A column is excluded when ANY of:
	 *   - its PictForm.Width is explicitly zero (parseFloat === 0) — the deliberate "no space" signal,
	 *   - it is a hidden input type (InputType === 'Hidden' or starting with 'MaterialsHidden'), OR
	 *   - it carries a truthy PictForm.Hidden flag (the Materials input types honor this to hide a field).
	 *
	 * A column with NO Width set (undefined/null/'') is NOT excluded on the width axis — it is a
	 * normal visible column that defaults to a width of 1 elsewhere. Only an explicit zero counts.
	 *
	 * @param {Object} pColumn - The column descriptor to test
	 * @return {Boolean} - Returns true when the column should not occupy layout space
	 */
	isLayoutExcludedColumn(pColumn)
	{
		if (!pColumn || !pColumn.PictForm)
		{
			return false;
		}
		const tmpInputType = pColumn.PictForm.InputType;
		if (typeof tmpInputType === 'string' && (tmpInputType === 'Hidden' || tmpInputType.startsWith('MaterialsHidden')))
		{
			return true;
		}
		// The Materials input types honor an explicit PictForm.Hidden flag to hide a field; treat it as layout-excluded too.
		if (pColumn.PictForm.Hidden)
		{
			return true;
		}
		// Distinguish an explicit zero Width (excluded) from an unset Width (a normal, visible un-widthed column).
		const tmpWidth = pColumn.PictForm.Width;
		if (tmpWidth !== undefined && tmpWidth !== null && tmpWidth !== '' && parseFloat(tmpWidth) === 0)
		{
			return true;
		}
		return false;
	}

	/**
	 * Check if the row has any columns with a PictForm.Width set and if they exceed the active column count
	 * @param {Object[]} pRowObject - The Pict row object containing columns to check
	 * @return {Boolean} - Returns true if the row has columns exceeding the active column count, false otherwise
	 */
	checkForOvercrowdingInRow(pRowObject)
	{
		// Check if the row has any columns with a PictForm.Width set and if they exceed the active column count
		// Layout-excluded columns (explicit zero width / hidden inputs) take no space, so they are not counted.
		const totalWidth = pRowObject.reduce((acc, column) =>
		{
			if (this.isLayoutExcludedColumn(column))
			{
				return acc;
			}
			return acc + (column.PictForm.Width ? parseFloat(column.PictForm.Width) : 1);
		}, 0);
		if (totalWidth > this.activeColumnCount)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.warn(`Row columns exceed active column count of ${this.activeColumnCount}. Will adjust columns accordingly.`);
			}
			return true;
		}
		return false;
	}

	/**
	 * Map all rows by their sections and mark each group holding a row whose widths overrun the active column count
	 * @return {Boolean} - Returns true if the mapping was successful
	 */
	mapAllRowsBySections(pDescriptors, pSections)
	{
		if (!pDescriptors || typeof pDescriptors !== 'object')
		{
			this.pict.log.error('Invalid descriptors provided for mapping rows by sections.');
			throw new Error('Invalid descriptors provided for mapping rows by sections.');
		}
		const tmpColumns = pDescriptors;
		// map the column by their Section and Row
		const tmpRowsBySection = {};
		Object.values(tmpColumns).forEach((column) =>
		{
			if (!column.PictForm || !column.PictForm.Section)
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.pict.log.warn(`Column ${column.Name} does not have a valid Section defined. Skipping.`);
				}
				return;
			}
			const tmpRowOrdinal = column.PictForm.Row || '1'; // default to row 1 if not defined
			// Objects, not arrays: rows are keyed by Row as written ("1.5", "8.0"), which are not array indexes.
			if (!tmpRowsBySection[column.PictForm.Section])
			{
				tmpRowsBySection[column.PictForm.Section] = {};
			}
			if (!tmpRowsBySection[column.PictForm.Section][column.PictForm.Group])
			{
				tmpRowsBySection[column.PictForm.Section][column.PictForm.Group] = {};
			}
			if (!tmpRowsBySection[column.PictForm.Section][column.PictForm.Group][tmpRowOrdinal])
			{
				tmpRowsBySection[column.PictForm.Section][column.PictForm.Group][tmpRowOrdinal] = [];
			}
			tmpRowsBySection[column.PictForm.Section][column.PictForm.Group][tmpRowOrdinal].push(column);
		});
		// now we need to adjust the columns for each row based on the active column count
		for (const section in tmpRowsBySection)
		{
			if (Object.prototype.hasOwnProperty.call(tmpRowsBySection, section))
			{
				// now we need to iterate over each row in the section and adjust the columns based on the active column count
				if (!tmpRowsBySection[section] || !Object.keys(tmpRowsBySection[section]).length)
				{
					if (this.pict.LogNoisiness > 2)
					{
						this.pict.log.warn(`Section ${section} does not have any rows defined. Skipping adjustment.`);
					}
					continue;
				}

				for (const group in tmpRowsBySection[section])
				{
					if (Object.prototype.hasOwnProperty.call(tmpRowsBySection[section], group))
					{
						const groupObject = tmpRowsBySection[section][group];

						for (const row in groupObject)
						{
							if (Object.prototype.hasOwnProperty.call(groupObject, row))
							{
								const rowObject = groupObject[row];
								// check if the row overcrowded before we do any adjustments, so we can update the parent "columns" wrapper
								if (this.checkForOvercrowdingInRow(rowObject))
								{
									if (this.pict.LogNoisiness > 2)
									{
										this.pict.log.warn(`Row ${row} in section ${section} is overcrowded. Adjusting columns.`);
									}
									// NOTE: we mark the entire group as overcrowded, so we can adjust the parent "columns" wrappers
									// This doesn't negatively impact any non-overcrowded rows, as they will be balanced with Bulma classes, however,
									// it would be better to mark the row itself as overcrowded, but that would require a change in the PictForm structure
									this.markGroupAsOvercrowded(rowObject, pSections, section, group);
								}
							}
						}
						// now we need to set the adjusted rows back to the section
						tmpRowsBySection[section][group] = Object.values(groupObject).flat();
					}
				}
				// now we need to set the adjusted rows back to the section
				tmpRowsBySection[section] = Object.values(tmpRowsBySection[section]).map((group) =>
				{
					return Object.values(group).flat();
				});
			}
		}
		// temp log the adjusted rows by section
		if (this.pict.LogNoisiness > 2)
		{
			this.pict.log.info('Adjusted rows by section:', tmpRowsBySection);
		}
		return true;
	}

	/**
	 * Mark the row as overcrowded by adding a PictForm property
	 * @param {Object[]} pRowObject - The Pict row object containing columns to mark as overcrowded
	 * @param {Object} pSectionsObject - The Pict sections object containing the section information
	 * @param {String} pSectionName - The name of the section containing the row
	 * @param {String} pGroupName - The name of the group containing the row
	 * @return {Object} - The modified group object with overcrowded columns marked
	 */
	markGroupAsOvercrowded(pRowObject, pSectionsObject, pSectionName, pGroupName)
	{
		// mark the row as overcrowded by adding a PictForm property
		if (!pRowObject || !Array.isArray(pRowObject))
		{
			this.pict.log.error('Invalid row object provided for marking as overcrowded.');
			throw new Error('Invalid row object provided for marking as overcrowded.');
		}
		if (!pSectionsObject || typeof pSectionsObject !== 'object')
		{
			this.pict.log.error('Invalid sections object provided for marking as overcrowded.');
			throw new Error('Invalid sections object provided for marking as overcrowded.');
		}
		if (!pSectionName || typeof pSectionName !== 'string')
		{
			this.pict.log.error('Invalid section name provided for marking as overcrowded.');
			pSectionName = 'UNSET_SECTION'; // fallback to default section name if not provided
		}
		if (!pGroupName || typeof pGroupName !== 'string')
		{
			this.pict.log.error('Invalid group name provided for marking as overcrowded.');
			pGroupName = 'UNSET_GROUP'; // fallback to default group name if not provided
		}
		// find the section and group in the sections object
		const tmpSection = pSectionsObject.find((section) => section.Hash === pSectionName);
		if (!tmpSection)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.warn(`Section ${pSectionName} not found in sections object.`);
			}
			return {};
		}
		const pGroupObject = tmpSection.Groups.find((group) => group.Hash === pGroupName);
		if (!pGroupObject)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.warn(`Group ${pGroupName} not found in section ${pSectionName}.`);
			}
			return {};
		}
		// now we need to mark the row as overcrowded by adding a PictForm property
		if (!pGroupObject._OvercrowdedColumns)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info(`Marking group ${pGroupName} in section ${pSectionName} as overcrowded.`);
			}
			pGroupObject._OvercrowdedColumns = true;
		}
		else
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.pict.log.info(`Group ${pGroupName} in section ${pSectionName} is already marked as overcrowded.`);
			}
		}
		// check if the row is overcrowded and set the _OvercrowdedColumns property
		return pGroupObject;
	}

	/**
	 * Called after the provider is initialized, this method will adjust the UI based on the active column count
	 * @param {Function} [pCallback] - Optional callback to execute after initialization
	 * @return {Promise} - A promise that resolves when the initialization is complete
	 * @async
	 */
	onInitializeAsync(pCallback)
	{
		// don't break if sub-dynamic forms are using the correct pattern yet
		if (!this.pict || !this.pict.settings || !this.pict.settings.MyDefaultFormManifest || !this.pict.settings.MyDefaultFormManifest.Descriptors)
		{
			this.pict.log.warn('Pict settings or descriptors are not properly initialized to run ResponsiveUIAdjustmentProvider.');
			// if the callback is provided, we can call it to continue the initialization process
			if (typeof pCallback === 'function')
			{
				return pCallback();
			}
			return Promise.resolve();
		}
		// set the active column count based on the Pict settings, if available
		this.pict.log.info('ResponsiveUIAdjustmentProvider initialized with active column count:', this.activeColumnCount);
		this.registerLayoutExcludedInputCheck();
		// column widths come from getProportionalRowWidths; this pass only marks overcrowded groups
		this.mapAllRowsBySections(this.pict.settings?.MyDefaultFormManifest?.Descriptors, this.pict.settings?.MyDefaultFormManifest?.Sections);

		// add a resize event listener to the window to adjust the UI elements when the window is resized
		const resizeDebounce = 100; // debounce time in milliseconds
		let resizeTimeout;
		// NOTE: We use a debounce to prevent excessive calls to the resize handler, which can be expensive in terms of performance
		window.addEventListener('resize', () =>
		{
			if (resizeTimeout)
			{
				clearTimeout(resizeTimeout);
			}
			resizeTimeout = setTimeout(() =>
			{
				this.onWindowResize();
			}, resizeDebounce);
		});
		this.pict.log.info('ResponsiveUIAdjustmentProvider: Window resize event listener added.');
		// also, let's run it once to adjust the UI elements immediately
		this.onWindowResize();

		if (typeof pCallback === 'function')
		{
			return pCallback();
		}
		return Promise.resolve();
	}

	/**
	 * Called when the window is resized, this method will adjust all the labels to be a consistent height across all columns in the row
	 * @return {void}
	 */
	onWindowResize()
	{
		// go through all sections and groups, and adjust the label heights to be consistent for all columns in the row
		this.pict.log.info('ResponsiveUIAdjustmentProvider: Window resized, adjusting UI elements.');
		const allColumnRows = document.querySelectorAll('.columns:not(.is-hidden)');
		allColumnRows.forEach((row) =>
		{
			const columns = row.querySelectorAll('.column');
			if (columns.length > 0)
			{
				let maxHeight = 0;
				// find the maximum height of the labels in the columns
				columns.forEach((column) =>
				{
					const label = column.querySelector('label');
					if (label && label.offsetHeight > maxHeight)
					{
						maxHeight = label.offsetHeight;
					}
				});
				// if the maximum height is greater than 0, we can set the height of all labels to the maximum height
				if (maxHeight > 0)
				{
					columns.forEach((column) =>
					{
						const label = column.querySelector('label');
						if (label)
						{
							label.style.height = `${maxHeight}px`;
						}
					});
				}
			}
		});
		// A group can cross the "big enough to warrant an inline/modal choice"
		// threshold purely because the window got shorter, so ride this already
		// debounced resize pass rather than registering another listener.
		// NOTE: refreshEntryModeToggleVisibility must never call back into
		// prepareAnyExtraTableControls -- that would recurse through here.
		const tmpTableControls = this.pict.providers['Bulma-TableControls'];
		if (tmpTableControls && (typeof tmpTableControls.refreshEntryModeToggleVisibility === 'function'))
		{
			tmpTableControls.refreshEntryModeToggleVisibility();
		}
	}
}
module.exports = ResponsiveUIAdjustmentProvider;

},{"pict-provider":552}],149:[function(require,module,exports){

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const EntityFilterEngineProvider = require('./PictProvider-EntityFilterEngine.js');
// The display-name resolution order, shared with the Picker stack's Read/Print display so the
// Select2 -> Picker migration cannot change what a field paints.
const libEntityDisplayName = require('./_EntityDisplayName.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

/**
 * @typedef {Object} Select2AjaxOptions
 * @property {number} [PageSize] - The number of items to get per page. Default is 50.
 * @property {Object} [Input] - The input object. Some defaults or fallbacks will be pulled from this if provided.
 * @property {string[]} [SearchFields] - The fields to search for the search term in. Default is ['Name'].
 * @property {(record: any) => string} [GetRecordID] - A function to get the record ID from the entity. Default is the database ID.
 * @property {(record: any) => string} [GetRecordName] - A function to get the record name from the entity. This is what is shown in the search results and selection. Defaults to Record.Name.
 * @property {(record: any) => string} [GetRecordUserFacingID] - A function to get the user facing record ID from the entity record. If provided, will decorate the selection with this ID (in addition to the name).
 * @property {() => Select2Item} [GetPinnedItem] - A function to get the pinned item. If provided, will be the first item in the list.
 * @property {() => Array<any>} [GetPriorityIDs] - Ids floated to the top of the first browse page, most-preferred first. Nothing is removed and a search term suppresses the reorder.
 * @property {(pFilters: string[], pParams: any, pBackoff?: string[]) => string[]} [HandleSearchFilters] - A function to handle the search filters. Return the (mandatory) filters to be used; push any back-off-able clauses into pBackoff. pParams is the Select2 params object for the search.
 * @property {string} [URLPrefix] - Optional prefix prepended to the entity REST path.
 * @property {number} [MinimumInputLengthForSearch] - The minimum input length for search. Default is from panels view, or ultimate fallback of 2.
 * @property {boolean} [Tags] - Whether or not to allow free-entry / dynamic option creation.
 * @property {boolean} [AllowClear] - Whether or not to allow clearing the selection. Default is true.
 * @property {string} [SearchPlaceholder] - The placeholder for the search input. Placeholder from input.PictForm is preferred over this.
 * @property {string} [SearchFallbackPlaceholder] - The fallback placeholder for the search input. Default is `Select ${pEntityType} records...`.
 * @property {string} [Width] - The width of the select2 input. Default is '100%'.
 * @property {boolean} [ApplySort] - Should sorting be applied to the filtering.
 * @property {string} [JoinEntity] - An Entity to Join to.
 * @property {boolean} [JoinEntityFirst] - Whether the Joined Entities name should come first. Defaults to true.
 * @property {string} [JoinField] - The field to join to on the Entity. default is ID<Entity>.
 * @property {boolean} [Disabled] - Whether the select is disabled.
 * @property {boolean} [Multiple] - Whether the select allows multiple selections.
 * @property {string} [EntityDisplayField] - An alternate field to use when displaying an entity.
 * @property {string} [JoinEntityDisplayField] - An alternate field to use when displaying the joined entity.
 * @property {boolean} [EntityTagLast] - Whether the entity tag should be displayed last in the display template, if an EntityTag is used.
 * @property {number} [RowIndex] - For a tabular column picker: this row's index, so a DynamicFilters `FromRowField` resolves against this row's sibling cell.
 * @property {Object} [View] - For a tabular column picker: the form view, providing the marshal destination a `FromRowField` reads from.
 */

/**
 * @typedef {Object} Select2Item
 * @property {string} id - The ID of the item.
 * @property {string} text - The display text of the item.
 */

/**
 * @typedef {Object} EntityDisplayResult
 * @property {Record<string, any>} Record - The entity record, exactly as the server returned it.
 * @property {string} DisplayName - The display text computed for the record.
 */

class Select2UtilProvider extends EntityFilterEngineProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * A save writes records server-side (the document's comprehension), so reads kept from before it are dropped.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		libSharedEntityRead.invalidate(this.pict);
		return super.onBeforeSaveDataAsync(fCallback);
	}

	/**
	 * Drops reads taken while the save was in flight.
	 * @param {(pError?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		libSharedEntityRead.invalidate(this.pict);
		return super.onAfterSaveDataAsync(fCallback);
	}

	/**
	 * @typedef {Object} ReadRequest
	 * @property {string} url - The URL to issue the request against.
	 * @property {'GET'|'POST'} method - The HTTP method to use.
	 * @property {Object|null} body - The JSON body for a POST `/Query` request, or null for a GET.
	 */

	/**
	 * Convert a meadow GET read URL into either a passthrough GET or, when the URL
	 * exceeds `pThreshold`, an equivalent `POST <prefix><Entity>s/Query` request so a
	 * large IN-list filter doesn't blow the URI length limit. The POST body envelope
	 * maps onto the same GET read handlers (meadow-endpoints `/Query`); mode is selected
	 * by `{ Count, Distinct, Lite }` flags with precedence Count > Distinct > Lite > Reads.
	 *
	 * Pure: no `this.pict` / DOM / select2, so it is unit-tested directly. Short URLs pass
	 * through as GET to preserve response caching for the common case. Any URL that can't be
	 * parsed (no `/FilteredTo/` segment) falls back to a GET passthrough (fail-safe).
	 *
	 * Encoding: the GET router URL-decodes the `:Filter` / `:ExtraColumns` / `:Columns` path
	 * params once before the handler reads `params.*`, so those segments are `decodeURIComponent`'d
	 * into the body — a `LK~%25term%25` path segment becomes the `LK~%term%` the handler would see.
	 *
	 * @param {string} pURL - The meadow GET read URL (e.g. `<prefix><Entity>s/Lite/FilteredTo/<filter>/<begin>/<cap>`).
	 * @param {number} [pThreshold=1800] - URL length at/under which the GET is passed through unchanged.
	 * @return {ReadRequest} The request descriptor.
	 */
	_buildReadRequest(pURL, pThreshold)
	{
		const tmpThreshold = pThreshold ?? 1800;
		if (!pURL || pURL.length <= tmpThreshold)
		{
			return { url: pURL, method: 'GET', body: null };
		}
		// Robust parse (not one fragile regex): split on the FilteredTo delimiter; the head carries
		// the entity + read-mode segments, the tail carries the filter and optional /begin/cap.
		const tmpParts = pURL.split('/FilteredTo/');
		if (tmpParts.length !== 2)
		{
			return { url: pURL, method: 'GET', body: null };
		}
		const tmpHead = tmpParts[0];
		const tmpTail = tmpParts[1];

		// From the tail, peel a trailing /<digits>/<digits> as Begin/Cap; the remainder is the Filter
		// (meadow filters use `~`, never a literal `/`, so re-joining any interior slashes is safe).
		let tmpFilterSegment = tmpTail;
		let tmpBegin = null;
		let tmpCap = null;
		const tmpTailSegments = tmpTail.split('/').filter((pSegment) => pSegment.length > 0);
		if (tmpTailSegments.length >= 2 &&
			/^\d+$/.test(tmpTailSegments[tmpTailSegments.length - 2]) &&
			/^\d+$/.test(tmpTailSegments[tmpTailSegments.length - 1]))
		{
			tmpCap = parseInt(tmpTailSegments.pop(), 10);
			tmpBegin = parseInt(tmpTailSegments.pop(), 10);
			tmpFilterSegment = tmpTailSegments.join('/');
		}

		// From the head, peel the trailing read-mode segment(s). The head is
		// `<prefix><Entity>s` optionally followed by `/Lite`, `/LiteExtended/<cols>`,
		// `/Distinct/<cols>`, or `/Count`. Everything to the left of the mode is the
		// entity path; the POST endpoint is `<entity-path>/Query`.
		const tmpHeadSegments = tmpHead.split('/');
		const tmpBody = {};
		let tmpEntitySegmentCount = tmpHeadSegments.length;
		const tmpLast = tmpHeadSegments[tmpHeadSegments.length - 1];
		const tmpSecondLast = tmpHeadSegments[tmpHeadSegments.length - 2];
		if (tmpLast === 'Lite')
		{
			tmpBody.Lite = true;
			tmpEntitySegmentCount = tmpHeadSegments.length - 1;
		}
		else if (tmpLast === 'Count')
		{
			tmpBody.Count = true;
			tmpEntitySegmentCount = tmpHeadSegments.length - 1;
		}
		else if (tmpSecondLast === 'LiteExtended')
		{
			tmpBody.Lite = true;
			tmpBody.ExtraColumns = decodeURIComponent(tmpLast);
			tmpEntitySegmentCount = tmpHeadSegments.length - 2;
		}
		else if (tmpSecondLast === 'Distinct')
		{
			tmpBody.Distinct = true;
			tmpBody.Columns = decodeURIComponent(tmpLast);
			tmpEntitySegmentCount = tmpHeadSegments.length - 2;
		}
		const tmpEntityPath = tmpHeadSegments.slice(0, tmpEntitySegmentCount).join('/');

		tmpBody.Filter = decodeURIComponent(tmpFilterSegment);
		// Count ignores pagination (it counts the whole filtered query); every other mode forwards it.
		if (!tmpBody.Count && tmpBegin !== null)
		{
			tmpBody.Begin = tmpBegin;
			tmpBody.Cap = tmpCap;
		}

		return { url: `${tmpEntityPath}/Query`, method: 'POST', body: tmpBody };
	}

	/**
	 * Float a set of ids to the front of an option list, in the order given, leaving everything else in place.
	 * Ids absent from the page are skipped rather than synthesized — the page is already scoped, so an id that
	 * did not survive the filters must not be reintroduced by the ordering.
	 *
	 * @param {Array<{id: any}>} pOptions - the composed option list for this page.
	 * @param {Array<any>} pPriorityIDs - ids to float, most-preferred first.
	 * @return {Array<{id: any}>} The reordered list (a new array; the input is not mutated).
	 */
	applyPriorityOrder(pOptions, pPriorityIDs)
	{
		if (!Array.isArray(pOptions) || !Array.isArray(pPriorityIDs) || pPriorityIDs.length < 1)
		{
			return pOptions;
		}
		const tmpPinned = [];
		for (const tmpID of pPriorityIDs)
		{
			const tmpMatch = pOptions.find((pOption) => String(pOption.id) === String(tmpID));
			if (tmpMatch && tmpPinned.indexOf(tmpMatch) < 0)
			{
				tmpPinned.push(tmpMatch);
			}
		}
		if (tmpPinned.length < 1)
		{
			return pOptions;
		}
		return tmpPinned.concat(pOptions.filter((pOption) => tmpPinned.indexOf(pOption) < 0));
	}

	/**
	 * Helper to standardize building select2 options objects.
	 *
	 * @param {string} pEntityType - The entity type to get options for.
	 * @param {Select2AjaxOptions} pOptions - The options to use when getting the options.
	 *
	 * @return {import('select2').Options} - The options for select2.
	 */
	getOptionsAjax(pEntityType, pOptions)
	{
		const pageSize = pOptions.PageSize || 50;
		const input = pOptions.Input || {};
		const tmpProvider = this;
		// url() receives Select2 query params; transport() receives the ajax-OPTIONS object (a
		// different object). Bridge the page-1 mandatory-only fallback URL keyed by the full URL url()
		// returns (= options.url in transport), read and cleared once per request.
		const tmpBackoffFallbacks = {};
		// Set per query by url(): did a SCOPE filter (beyond the search term) apply? Drives the filter-aware
		// no-results message so the user learns a filter zeroed the picker and can reach for "Show all".
		let tmpScopeFilterApplied = false;
		const searchFields = pOptions.SearchFields || (pEntityType === 'User' ? [ 'NameFirst', 'NameLast' ] : [ 'Name' ]);
		const getUserFacingRecordID = pOptions.GetRecordUserFacingID || (() => null);
		const recordToID = pOptions.GetRecordID ?? ((pEntity) => pEntity[`ID${pEntityType}`]);
		const recordToText = pOptions.GetRecordName ?? ((pEntity) =>
		{
			let baseName = pOptions.EntityDisplayField ? pEntity[pOptions.EntityDisplayField] : pEntityType === 'User' ? `${ pEntity.NameFirst } ${ pEntity.NameLast }` : pEntity.Name || `Unnamed ${pEntityType} #${pEntity[`ID${pEntityType}`]}`;
			if (pEntity.JoinName)
			{
				baseName = pOptions.JoinEntityFirst ? `${ pEntity.JoinName } - ${ baseName }` : `${ baseName } - ${ pEntity.JoinName }`;
			}
			const recordID = getUserFacingRecordID(pEntity);
			// Suppress the tag pill when it's identical to the name (e.g. Labs whose code IS their name) —
			// the compound would render a redundant "(X) X". Fall through to the bare name (matches the PDF).
			if (recordID && String(recordID).trim() !== String(baseName).trim())
			{
				return `${recordID}|~|${baseName}`;
			}
			return baseName;
		});
		const getPinnedItem = pOptions.GetPinnedItem ?? (() => null);
		// Pin-to-top: ids floated above the rest of the first BROWSE page, in the given order. Nothing is
		// removed, and a search term defers entirely to natural relevance so a pin never hides a typed-for
		// record — the same contract pict-section-picker's PriorityValues carries on the Picker stack.
		const getPriorityIDs = pOptions.GetPriorityIDs ?? (() => []);
		const handleSearchFilters = pOptions.HandleSearchFilters ?? ((pFilters, pParams) => pFilters);
		// NOTE: Select2 Option Documentation: https://select2.org/configuration/options-api
		/** @type {import('select2').Options} */
		const tmpSelectOptions =
		{
			minimumInputLength: pOptions.MinimumInputLengthForSearch ?? this.pict.views.HeadlightPanels?.MinimumInputLengthForSearch ?? 0,
			tags: pOptions.Tags ?? false,
			allowClear: pOptions.AllowClear ?? true,
			placeholder: pOptions.SearchPlaceholder || input.PictForm?.Placeholder || pOptions.SearchFallbackPlaceholder || `Select ${pEntityType} records...`,
			width: pOptions.Width ?? '100%',
			disabled: pOptions.Disabled ?? false,
			multiple: pOptions.Multiple ?? false,
			language:
			{
				searching: function()
				{
					return 'Searching...';
				},
				noResults: function()
				{
					if (tmpScopeFilterApplied)
					{
						return input.PictForm?.FilteredNoResultsMessage ||
							(input.PictForm?.OverrideField ?
								'No matches with the current filter — turn on "Show all" to see everything.' :
								'No matches with the current filter.');
					}
					return 'No results found.';
				},
				loadingMore: function()
				{
					return 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			escapeMarkup: function(text)
			{
				if (text && text.includes('|~|'))
				{
					const tempNumber = text.split('|~|')[0]?.trim();
					const tempName = text.split('|~|')[1]?.trim();
					return _Pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(tempNumber, tempName, pOptions.Multiple, pOptions.EntityTagLast);
				}
				return text;
			},
			ajax:
			{
				cache: true,
				method: 'GET',
				url: function(params)
				{
					const page = params.page || 1;
					const tmpSortClause = searchFields.map((f) => `FSF~${ f }~ASC~0`).join('~');
					const buildURL = (pFilterList) =>
					{
						let tmpURL = `${pOptions.URLPrefix || ''}${pEntityType}s/`;
						if (pFilterList.length > 0)
						{
							tmpURL += pOptions?.ApplySort ? `FilteredTo/${pFilterList.join('~')}~${tmpSortClause}/` : `FilteredTo/${pFilterList.join('~')}/`;
						}
						else if (pOptions?.ApplySort)
						{
							tmpURL += `FilteredTo/${tmpSortClause}/`;
						}
						tmpURL += `${(page - 1) * pageSize}/${pageSize}`;
						return tmpURL;
					};
					// Mandatory filters (search term, intrinsic subclass scope, project scope) always apply.
					// Back-off-able filters (BackOff static/dynamic, spec-year) collect separately so the
					// transport can drop them on an empty-result retry, and the override drops them up-front.
					let filters = [];
					const tmpBackoff = [];
					if (params.term && searchFields.length > 0)
					{
						const tmpTerms = params.term.split(' ').map((pTerm) => pTerm.trim()).filter((pTerm) => pTerm.length > 0);
						if (tmpTerms.length > 0)
						{
							filters = tmpTerms.flatMap((tmpTerm) =>
							{
								const tmpFieldFilters = searchFields.map((pField) => `FBVOR~${pField}~LK~${encodeURIComponent(`%${tmpTerm}%`)}%25`);
								tmpFieldFilters.unshift('FOP~0~(~0');
								tmpFieldFilters.push('FCP~0~)~0');
								return tmpFieldFilters;
							});
						}
					}
					filters = handleSearchFilters(filters, params, tmpBackoff) || filters;
					tmpProvider.applyStaticFilters(filters, input, tmpBackoff);
					// pOptions.RowIndex / pOptions.View are set for tabular columns (see
					// MaterialsEntitySelector.initializeSelect2) so FromRowField narrows per-row.
					tmpProvider.applyDynamicFilters(filters, input, pOptions.RowIndex, pOptions.View, tmpBackoff);
					// pOptions.RowIndex must be threaded here too: a tabular picker persists its Show All
					// state per row (<Hash>__ShowAll_<row>), so reading the flat address left every
					// per-row toggle inert on this path.
					const tmpEffectiveBackoff = tmpProvider.isFilterOverridden(input, pOptions.RowIndex) ? [] : tmpBackoff;
					// A scope filter applied if any clause is not a search-term clause (FBVOR/FOP/FCP), or a
					// back-off clause is in effect — read by noResults to explain an empty/zeroed picker.
					tmpScopeFilterApplied = tmpEffectiveBackoff.length > 0 || filters.some((tmpClause) => tmpClause.indexOf('FBVOR~') !== 0 && tmpClause.indexOf('FOP~') !== 0 && tmpClause.indexOf('FCP~') !== 0);
					// Mandatory-only fallback the transport retries when the fully-filtered query is empty.
					// page-1 fallback is recorded against the returned full URL just below (read in transport).
					const tmpFullURL = buildURL(filters.concat(tmpEffectiveBackoff));
					if (tmpEffectiveBackoff.length > 0 && page === 1)
					{
						tmpBackoffFallbacks[tmpFullURL] = buildURL(filters);
					}
					return tmpFullURL;
				},
				xhrFields:
				{
					withCredentials: true,
				},
				dataType: 'json',
				transport: (params, success, failure) =>
				{
					let aborted = false;
					let tmpActiveRequest = null;
					const tmpFallbackURL = tmpBackoffFallbacks[params.url];
					delete tmpBackoffFallbacks[params.url];
					// Decorate a response with JoinEntity display names (when configured) and resolve.
					const finishWithResponse = async (pResponse) =>
					{
						if (pOptions?.JoinEntity && pResponse?.[0]?.hasOwnProperty(pOptions.JoinField))
						{
							const ids = [];
							for (const r of pResponse)
							{
								if (r[pOptions.JoinField])
								{
									ids.push(r[pOptions.JoinField]);
								}
							}
							if (ids.length)
							{
								try
								{
									const joinedEntities = await this.getEntitySetAsync(pOptions?.JoinEntity, `FBL~ID${ pOptions?.JoinEntity }~INN~${ ids.join(',') }`);
									if (joinedEntities?.length)
									{
										const idMap = {};
										for (const j of joinedEntities)
										{
											idMap[j[`ID${ pOptions?.JoinEntity }`]] = j;
										}
										const newResponse = [];
										for (const r of pResponse)
										{
											const joinEntityObj = idMap[r[pOptions.JoinField]];
											let joinName = null;
											if (joinEntityObj)
											{
												if (pOptions.JoinEntityDisplayField)
												{
													joinName = joinEntityObj[pOptions.JoinEntityDisplayField];
												}
												else if (pOptions.JoinEntity === 'User')
												{
													joinName = `${joinEntityObj.NameFirst} ${joinEntityObj.NameLast}`;
												}
												else
												{
													joinName = joinEntityObj.Name || '';
												}
											}
											r.JoinName = joinName;
											newResponse.push(r);
										}
										pResponse = newResponse;
									}
								}
								catch (e)
								{
									console.log(`Error fetching joined ${ pOptions?.JoinEntity }:`, e);
									return failure();
								}
							}
						}
						if (!aborted)
						{
							success(pResponse || []);
						}
					};
					const fetchURL = (pURL, fOnBody, fOnError) =>
					{
						// Oversized read URLs (large IN-list filters) fall back to POST /Query so they
						// don't blow the URI length limit; short URLs stay GET to preserve caching.
						const tmpReq = this._buildReadRequest(pURL);
						const tmpHandler = (pError, pResponse) =>
						{
							if (pError || pResponse?.Error)
							{
								console.log(`Error fetching ${ pURL }:`, pError || pResponse?.Error);
								return fOnError();
							}
							fOnBody(pResponse);
						};
						if (tmpReq.method === 'POST')
						{
							tmpActiveRequest = this.pict.HeadlightRestClient.postJSON(tmpReq.url, tmpReq.body, tmpHandler);
						}
						else
						{
							tmpActiveRequest = this.pict.HeadlightRestClient.getJSON(tmpReq.url, tmpHandler);
						}
					};
					fetchURL(params.url, (pResponse) =>
					{
						// Back-off: a fully-filtered FIRST page that returns nothing retries without the
						// back-off-able filters, so the picker shows its full set instead of an empty dropdown.
						// Only the first page backs off — on later pages an empty body means "no more results",
						// not "the filter emptied it", so retrying there would surface out-of-filter rows.
						if (Array.isArray(pResponse) && pResponse.length === 0 && tmpFallbackURL)
						{
							fetchURL(tmpFallbackURL, (pFallback) => finishWithResponse(pFallback), failure);
							return;
						}
						finishWithResponse(pResponse);
					}, failure);

					return { abort: () =>
					{
						aborted = true;
						if (tmpActiveRequest)
						{
							tmpActiveRequest.abort();
						}
					} };
				},
				processResults: function(data, params)
				{
					let formattedData = [];
					const pageSize = 50;
					params.page = params.page || 1;
					if (data && data.length > 0)
					{
						formattedData = data.map((pItem) =>
						{
							const item =
							{
								id: recordToID(pItem),
								text: recordToText(pItem),
							};
							return item;
						});
						if (params.page === 1)
						{
							if (!params.term)
							{
								formattedData = tmpProvider.applyPriorityOrder(formattedData, getPriorityIDs());
							}
							const pinnedItem = getPinnedItem();
							if (pinnedItem)
							{
								formattedData = formattedData.filter((pItem) => pItem.id != pinnedItem.id);
								formattedData.unshift(pinnedItem);
							}
						}
					}
					const pageInfo =
					{
						results: formattedData,
						pagination:
						{
							more: data.length >= pageSize,
						},
					};
					return pageInfo;
				},
			},
		};
		return tmpSelectOptions;
	}

	/**
	 * Fetch a single entity record. The record is returned exactly as the server sent it; callers that also
	 * need display text use getEntityWithDisplayAsync (record snapshots held in form data are persisted
	 * verbatim, so nothing may be decorated onto a fetched record here).
	 *
	 * Identical lookups share one request, and a found record is reused for a short window
	 * (`_SharedEntityRead`); pass `BypassCache` to skip the reuse window (a request already in flight is still shared).
	 *
	 * @param {string} pEntity - The entity type to get.
	 * @param {number|string} pIDEntity - The ID of the entity to get
	 * @param {Record<string, any>} pOptions - Options for getting the entity.
	 *
	 * @return {Promise<Record<string, any>>} - The entity record.
	 */
	async getEntityAsync(pEntity, pIDEntity, pOptions = {})
	{
		return new Promise((resolve, reject) =>
		{
			const tmpIdentityField = pOptions.IdentityField || `ID${pEntity}`;
			if (libSharedEntityRead.isEmptyIdentityValue(tmpIdentityField, pIDEntity))
			{
				return reject(new Error(`No ${pEntity} found with ${tmpIdentityField} = ${pIDEntity}`));
			}
			const tmpURL = `${pEntity}s/FilteredTo/FBV~${tmpIdentityField}~EQ~${encodeURIComponent(pIDEntity)}`;
			libSharedEntityRead.readJSON(this.pict, tmpURL, { ReuseResult: !pOptions.BypassCache }, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				if (pResult.length < 1)
				{
					return reject(new Error(`No ${pEntity} found with ${tmpIdentityField} = ${pIDEntity}`));
				}
				if (pResult.length > 1)
				{
					this.pict.log.warn(`Multiple ${pEntity} records found with ${tmpIdentityField} = ${pIDEntity}, returning the first result.`);
				}
				resolve(pResult[0]);
			});
		});
	}

	/**
	 * Fetch a single entity record along with the display text for it.
	 *
	 * @param {string} pEntity - The entity type to get.
	 * @param {number|string} pIDEntity - The ID of the entity to get
	 * @param {Record<string, any>} pOptions - Options for getting the entity.
	 *
	 * @return {Promise<EntityDisplayResult>} - The entity record and its display name.
	 */
	async getEntityWithDisplayAsync(pEntity, pIDEntity, pOptions = {})
	{
		const tmpRecord = await this.getEntityAsync(pEntity, pIDEntity, pOptions);
		return { Record: tmpRecord, DisplayName: await this.getEntityDisplayNameAsync(pEntity, tmpRecord, pOptions) };
	}

	/**
	 * Resolve the display text for an entity record, loading the configured JoinEntity when one applies.
	 *
	 * @param {string} pEntity - The entity type the record belongs to.
	 * @param {Record<string, any>} pRecord - The entity record.
	 * @param {Record<string, any>} pOptions - Options for the display name (EntityDisplayField, JoinEntity, ...).
	 *
	 * @return {Promise<string>} - The display name for the record.
	 */
	async getEntityDisplayNameAsync(pEntity, pRecord, pOptions = {})
	{
		const tmpDisplayName = this.buildEntityDisplayName(pEntity, pRecord, pOptions);
		if (pOptions.JoinEntity && pRecord?.[pOptions.JoinField])
		{
			const tmpJoinedRecord = await this.getEntityAsync(pOptions.JoinEntity, pRecord[pOptions.JoinField]);
			const tmpJoinedDisplayName = this.buildEntityDisplayName(pOptions.JoinEntity, tmpJoinedRecord, { EntityDisplayField: pOptions.JoinEntityDisplayField });
			return pOptions.JoinEntityFirst ? `${ tmpJoinedDisplayName } - ${ tmpDisplayName }` : `${ tmpDisplayName } - ${ tmpJoinedDisplayName }`;
		}
		return tmpDisplayName;
	}

	/**
	 * Compute the display text for an entity record. Pure -- the record is never written to.
	 *
	 * @param {string} pEntity - The entity type the record belongs to.
	 * @param {Record<string, any>} pRecord - The entity record.
	 * @param {Record<string, any>} pOptions - Options for the display name (EntityDisplayField).
	 *
	 * @return {string} - The display name for the record.
	 */
	buildEntityDisplayName(pEntity, pRecord, pOptions = {})
	{
		// The resolution order (dotted paths, the Name-less User table, …) lives in the shared helper so the
		// Picker stack's Read/Print display resolves identically; this chain's only addition is the legacy
		// "Unnamed <Entity> #<id>" placeholder for a record with nothing to show.
		return libEntityDisplayName.resolveEntityDisplayName(pEntity, pRecord, pOptions,
			() => `Unnamed ${pEntity} #${pRecord[`ID${pEntity}`]}`);
	}

	/**
	 * @param {string} pEntity - The entity type to get.
	 * @param {string} pFilter - The filter to apply to the entity set.
	 *
	 * @return {Promise<Array<Record<string, any>>>} - The entity record.
	 */
	async getEntitySetAsync(pEntity, pFilter)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySet(pEntity, pFilter, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pResult);
			});
		});
	}

	/**
	 * Builds a Select2 display template with tag and name. Supports both singluar and multiple displays.
	 * The tag can be placed at the start or end as an additional option.
	 *
	 * @param {string} pTag - The tag to display.
	 * @param {string} pName - The name to display.
	 * @param {boolean} [pMultiple=false] - Whether this is for multiple selection.
	 * @param {boolean} [pTagAtEnd=false] - Whether to put the tag at the end.
	 * @return {string} - The HTML template string.
	 */
	buildSelect2CompoundDisplayTemplate(pTag, pName, pMultiple = false, pTagAtEnd = false)
	{
		return (
			`<span class="select2-${pMultiple ? 'multiple' : 'single'}-entity-selection">
				${pTagAtEnd ? `<span class="select2-entity-name">${pName}</span><span class="tag select2-entity-tag">${pTag}</span>` : `<span class="tag select2-entity-tag">${pTag}</span><span class="select2-entity-name">${pName}</span>`}
			</span>`
		);
	}
}

module.exports = Select2UtilProvider;
// Joins the app save-data lifecycle so a save drops the shared entity reads (onBefore/onAfterSaveDataAsync).
module.exports.default_configuration = { AutoSaveDataWithApp: true };

},{"./PictProvider-EntityFilterEngine.js":64,"./_EntityDisplayName.js":155,"./_SharedEntityRead.js":164}],150:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const SPEC_SCOPE_PAGE_SIZE = 500;

// Resolved-scope persistence (localStorage). Bump the version segment when the
// entry shape changes — old entries are then simply never read again.
const SPEC_SCOPE_CACHE_PREFIX = 'HeadlightSpecScope:2:';
const SPEC_SCOPE_CACHE_TTL_SECONDS = 6 * 60 * 60;

/**
 * One plan entry at the grain every picker cascades over.
 * @typedef {{ SampleType: string, IDLineItem: number, IDMaterial: number, IDTest: number }} PlanEntry
 */

/**
 * The source a project's plan entries were resolved from.
 * @typedef {('Plan'|'Template'|'Union'|'None')} PlanEntrySource
 */

/**
 * SpecScopeResolver — shared Pict provider that resolves the plan entries
 * governing a project's material / test / line-item pickers, and caches the
 * result so downstream input providers can consult it without each picker
 * re-fetching.
 *
 * A plan entry is (IDLineItem, IDMaterial, IDTest, SampleType). Two tables hold
 * entries at exactly that grain, and the project picks between them:
 *
 *   - Plan     — ProjectLineItemMaterialTest for the project. What it WILL sample.
 *   - Template — PayItemMaterialTestRequirement for the contract's material spec
 *                set, joined to the project's LineItems on IDPayItem. What the
 *                specification REQUIRES. Used when the project has no plan rows.
 *
 * The choice is per project, never per line item: a half-planned project must
 * not mix sources, because a user could not tell which rule applied to which row.
 * `getSource()` reports which one answered.
 *
 * Enforcement is cascade narrowing, not membership. Choose a line item and the
 * material picker narrows; choose a material and the test picker narrows; sample
 * type narrows both. Consumed by the EntityFilterEngine `SamplePlanScope` filter
 * — see docs/Filters.md.
 *
 * Fail-open throughout: no source, no set, no plan, or a line item with
 * IDPayItem = 0 produces no narrowing, silently. Every getter returns null in
 * that state so consumers leave their list unfiltered.
 *
 * Online, the template comes from the platform endpoint
 * `TestSpecificationSet/PlanEntries/ForProject/:IDProject`. In the bundle path
 * the LineItem and PayItemMaterialTestRequirement rows are fetched directly and
 * joined client-side, because the bundle transport has no server to do it.
 *
 * The lab axis rides along here (labs joined to the material spec set via
 * LabTestSpecificationSetJoin). It is a different mechanism that happens to need
 * the same contract read.
 *
 * The RESOLVED scope persists in localStorage (plan entries per project,
 * material parent pairs per customer) so repeat loads skip the reads entirely —
 * only Project/Contract are re-fetched, and the cached entry is honored only
 * when it resolves to the same spec set and is inside the TTL (default 6h).
 * Configure via manifest/option `SpecScopeCache: { Enabled, TTLSeconds }`; call
 * clearScopeCache() to force a cold load. Storage failures and quota exhaustion
 * fail open to a normal full load.
 *
 * Consumers:
 *   resolver.loadForProject(IDProject)      // call once per view load
 *   resolver.getSamplePlanLineItemIDs(...)  // Set<number> | null
 *   resolver.getSamplePlanMaterialIDs(...)  // Set<number> | null
 *   resolver.getSamplePlanTestIDs(...)      // Set<number> | null
 *   resolver.getSource()                    // PlanEntrySource
 *   resolver.getAllowedLabIDs()             // Set<number> | null
 */
class SpecScopeResolver extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		// Customer-wide material parent map for parent/child filter expansion. Persists across
		// project loads (the tree is per-customer, not per-project) — reloads on a customer switch.
		/** @type {{ IDCustomer: number, ParentOf: Map<number, number>, ChildrenOf: Map<number, number[]> }|null} */
		this._MaterialHierarchy = null;
		this._resetScope();
	}

	_resetScope()
	{
		this._Scope =
		{
			IDProject: null,
			IDContract: null,
			MaterialSetID: 0,
			AllowedLabIDs: null,
			HasLabCoverage: false,
			SamplePlanCombos: null,
			HasSamplePlan: false,
			/** @type {PlanEntrySource} */
			Source: 'None',
			Loaded: false,
			LoadPromise: null,
		};
	}

	/**
	 * Resolve the scope for a given project. Safe to call repeatedly — returns
	 * the cached result for the same project. Caller should await this before
	 * any picker that consults the resolver renders.
	 *
	 * @param {number|string} pIDProject
	 * @return {Promise<object>} scope snapshot
	 */
	async loadForProject(pIDProject)
	{
		const IDProject = typeof pIDProject === 'number' ? pIDProject : (parseInt(String(pIDProject), 10) || 0);
		if (this._Scope.IDProject === IDProject && this._Scope.Loaded)
		{
			return this._Scope;
		}
		if (this._Scope.IDProject === IDProject && this._Scope.LoadPromise)
		{
			return this._Scope.LoadPromise;
		}
		this._resetScope();
		this._Scope.IDProject = IDProject;
		if (!(IDProject > 0))
		{
			this._Scope.Loaded = true;
			return this._Scope;
		}
		this._Scope.LoadPromise = this._doLoad(IDProject)
			.then(async (pScope) =>
			{
				// After the main resolve converges (cache / bundle / per-entity reads), floor the lab axis off the
				// resolved material spec set — one small read, independent of which path produced the scope.
				await this._loadLabScope();
				return pScope;
			})
			.catch((err) =>
			{
				this.pict?.log?.warn(`[SpecScopeResolver] Failed to resolve scope for project ${IDProject}: ${err?.message || err}`);
				return this._Scope;
			});
		return this._Scope.LoadPromise;
	}

	async _doLoad(IDProject)
	{
		const tmpNeedsSamplePlan = this._needsSamplePlan();
		const tmpCacheConfig = this._resolveCacheConfig();

		const project = await this._getJSON(`Project/${IDProject}`);
		const tmpIDCustomer = project?.IDCustomer || this.pict?.AppData?.CurrentUser?.IDCustomer || 0;
		if (project?.IDContract > 0)
		{
			const contract = await this._getJSON(`Contract/${project.IDContract}`);
			this._Scope.IDContract = contract?.IDContract || project.IDContract;
			// Two-tier resolution: direct IDTestSpecificationSet FK, else a fallback that
			// matches a set by Year. The platform endpoint applies the same rule; the two
			// must not drift.
			this._Scope.MaterialSetID = await this._resolveSetID(contract, 'MaterialIDTestSpecificationSet', 'MaterialsSpecificationYear');
		}

		if (tmpNeedsSamplePlan && !(await this._resolvePlanEntries(IDProject, tmpIDCustomer, tmpCacheConfig)))
		{
			const tmpResolved = await this._loadSamplePlan(IDProject);
			this._applyPlanEntries(tmpResolved.Combos, tmpResolved.Source);
			if (tmpCacheConfig.Enabled)
			{
				this._writeProjectScopeCache(IDProject);
			}
		}

		// Material parent map for parent/child filter expansion — loaded once per customer
		// when a material dimension is in play. The expand helpers fail open (no-op) if it
		// did not load, so the gate need not be exhaustive.
		if (this._needsMaterialHierarchy() && tmpIDCustomer > 0)
		{
			await this._loadMaterialHierarchy(tmpIDCustomer);
		}

		this._Scope.Loaded = true;
		return this._Scope;
	}

	/**
	 * Try the two cheap paths to a project's plan entries — the persisted scope cache,
	 * then one bundle execution — and report whether either answered. A bundle failure
	 * falls through to the per-entity reads, which remain the offline-proven final path.
	 *
	 * @param {number} pIDProject
	 * @param {number} pIDCustomer
	 * @param {{ Enabled: boolean, TTLSeconds: number }} pCacheConfig
	 * @return {Promise<boolean>} true when the scope now carries resolved plan entries.
	 */
	async _resolvePlanEntries(pIDProject, pIDCustomer, pCacheConfig)
	{
		const tmpCached = pCacheConfig.Enabled ? this._readProjectScopeCache(pIDProject, pCacheConfig) : null;
		if (tmpCached && tmpCached.MaterialSetID === this._Scope.MaterialSetID && tmpCached.HasSamplePlanData)
		{
			this._applySamplePlanFromCache(tmpCached);
			return true;
		}
		if (!this._resolveBundleConfig().Enabled)
		{
			return false;
		}
		const tmpBundleClient = this._getEntityBundleClient();
		if (!tmpBundleClient)
		{
			return false;
		}
		try
		{
			const tmpSteps = this._buildScopeBundleSteps(pIDProject, pIDCustomer, this._Scope.MaterialSetID);
			const tmpBundleResult = await tmpBundleClient.executeBundle(tmpSteps);
			this._applyScopeBundleData(tmpBundleResult.Data, pIDCustomer);
			if (pCacheConfig.Enabled)
			{
				this._writeProjectScopeCache(pIDProject);
			}
			return true;
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Bundle scope load failed (${pError?.message || pError}); falling back to entity reads.`);
			return false;
		}
	}

	/**
	 * Install a resolved entry list on the scope.
	 *
	 * @param {Array<PlanEntry>} pCombos
	 * @param {PlanEntrySource} pSource
	 */
	_applyPlanEntries(pCombos, pSource)
	{
		this._Scope.SamplePlanCombos = pCombos;
		this._Scope.Source = pSource;
		this._Scope.HasSamplePlan = pCombos.length > 0;
	}

	/**
	 * Load (once per customer) the material parent map used for parent/child filter expansion.
	 * Materials form a shallow tree via IDMaterialParent; the whole customer's
	 * IDMaterial->IDMaterialParent is cached so ancestor/descendant walks are sync + in-memory.
	 * Cached across project loads; reloads only on a customer switch. Lite read (two ids),
	 * offline-servable like the other resolver reads.
	 *
	 * @param {number} pIDCustomer
	 * @return {Promise<void>}
	 */
	async _loadMaterialHierarchy(pIDCustomer)
	{
		const tmpIDCustomer = parseInt(String(pIDCustomer), 10) || 0;
		if (!(tmpIDCustomer > 0) || (this._MaterialHierarchy && this._MaterialHierarchy.IDCustomer === tmpIDCustomer))
		{
			return;
		}
		if (this._primeMaterialHierarchyFromCache(tmpIDCustomer))
		{
			return;
		}
		const tmpCacheConfig = this._resolveCacheConfig();
		const tmpCacheKey = `${SPEC_SCOPE_CACHE_PREFIX}MaterialHierarchy:${tmpIDCustomer}`;
		const tmpRows = await this._readAllPages('Materials/Lite', `FBV~IDCustomer~EQ~${tmpIDCustomer}`);
		const tmpPairs = [];
		for (const tmpRow of tmpRows)
		{
			const tmpID = parseInt(tmpRow.IDMaterial, 10) || 0;
			if (tmpID > 0)
			{
				tmpPairs.push([ tmpID, parseInt(tmpRow.IDMaterialParent, 10) || 0 ]);
			}
		}
		this._MaterialHierarchy = this._buildMaterialHierarchy(tmpIDCustomer, tmpPairs);
		if (tmpCacheConfig.Enabled)
		{
			this._writeCacheEntry(tmpCacheKey, { TS: Date.now(), Pairs: tmpPairs });
		}
	}

	/**
	 * Build the hierarchy maps from [IDMaterial, IDMaterialParent] pairs.
	 *
	 * @param {number} pIDCustomer
	 * @param {Array<Array<number>>} pPairs
	 * @return {{ IDCustomer: number, ParentOf: Map<number, number>, ChildrenOf: Map<number, number[]> }}
	 */
	_buildMaterialHierarchy(pIDCustomer, pPairs)
	{
		const tmpParentOf = new Map();
		const tmpChildrenOf = new Map();
		for (const tmpPair of pPairs)
		{
			const tmpID = parseInt(String(tmpPair[0]), 10) || 0;
			if (!(tmpID > 0))
			{
				continue;
			}
			const tmpParent = parseInt(String(tmpPair[1]), 10) || 0;
			tmpParentOf.set(tmpID, tmpParent);
			if (tmpParent > 0)
			{
				const tmpSiblings = tmpChildrenOf.get(tmpParent);
				if (tmpSiblings)
				{
					tmpSiblings.push(tmpID);
				}
				else
				{
					tmpChildrenOf.set(tmpParent, [ tmpID ]);
				}
			}
		}
		return { IDCustomer: pIDCustomer, ParentOf: tmpParentOf, ChildrenOf: tmpChildrenOf };
	}

	/**
	 * Populate the in-memory hierarchy for a customer without any network:
	 * no-op when already resident, else from the persisted pairs cache.
	 *
	 * @param {number} pIDCustomer
	 * @return {boolean} true when the hierarchy is now resident for pIDCustomer.
	 */
	_primeMaterialHierarchyFromCache(pIDCustomer)
	{
		if (this._MaterialHierarchy && this._MaterialHierarchy.IDCustomer === pIDCustomer)
		{
			return true;
		}
		const tmpCacheConfig = this._resolveCacheConfig();
		if (!tmpCacheConfig.Enabled)
		{
			return false;
		}
		const tmpCached = this._readCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}MaterialHierarchy:${pIDCustomer}`, tmpCacheConfig.TTLSeconds);
		if (tmpCached && Array.isArray(tmpCached.Pairs))
		{
			this._MaterialHierarchy = this._buildMaterialHierarchy(pIDCustomer, tmpCached.Pairs);
			return true;
		}
		return false;
	}

	/**
	 * Resolve the resolved-scope cache configuration. Persistence is on by
	 * default with a conservative TTL — spec-set membership, sampling plans and
	 * the material tree change rarely. Override via manifest-level or provider
	 * option `SpecScopeCache: { Enabled, TTLSeconds }` (manifest wins). Tests
	 * and exotic hosts can inject a storage backend via
	 * `SpecScopeCache.Storage` (any localStorage-shaped object).
	 *
	 * @return {{ Enabled: boolean, TTLSeconds: number }}
	 */
	_resolveCacheConfig()
	{
		const tmpManifest = this.pict?.views?.PictFormMetacontroller?.manifestDescription;
		const tmpSources =
		[
			tmpManifest && tmpManifest.SpecScopeCache,
			(this.options || {}).SpecScopeCache,
		];
		const tmpResolveField = (pField, pType, pDefault) =>
		{
			for (const tmpSource of tmpSources)
			{
				if (tmpSource && typeof tmpSource[pField] === pType)
				{
					return tmpSource[pField];
				}
			}
			return pDefault;
		};
		return {
			Enabled: tmpResolveField('Enabled', 'boolean', true),
			TTLSeconds: tmpResolveField('TTLSeconds', 'number', SPEC_SCOPE_CACHE_TTL_SECONDS),
		};
	}

	/**
	 * @return {Storage|null} the persistence backend, or null when unavailable
	 * (non-browser host, sandboxed frame) — every cache path fails open on null.
	 */
	_cacheStorage()
	{
		const tmpInjected = this.options && this.options.SpecScopeCache && this.options.SpecScopeCache.Storage;
		if (tmpInjected)
		{
			return tmpInjected;
		}
		try
		{
			return (typeof localStorage !== 'undefined') ? localStorage : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * Read one cache entry; expired or unparsable entries are deleted and
	 * treated as a miss.
	 *
	 * @param {string} pKey
	 * @param {number} pTTLSeconds
	 * @return {Record<string, any>|null}
	 */
	_readCacheEntry(pKey, pTTLSeconds)
	{
		const tmpStorage = this._cacheStorage();
		if (!tmpStorage)
		{
			return null;
		}
		try
		{
			const tmpRaw = tmpStorage.getItem(pKey);
			if (!tmpRaw)
			{
				return null;
			}
			const tmpEntry = JSON.parse(tmpRaw);
			if (!tmpEntry || typeof tmpEntry.TS !== 'number' || (Date.now() - tmpEntry.TS) > (pTTLSeconds * 1000))
			{
				tmpStorage.removeItem(pKey);
				return null;
			}
			return tmpEntry;
		}
		catch (pError)
		{
			try
			{
				tmpStorage.removeItem(pKey);
			}
			catch (pRemoveError)
			{
				// fail open
			}
			return null;
		}
	}

	/**
	 * Write one cache entry. On a quota failure, evict all spec-scope entries
	 * and retry once; a second failure is swallowed (cache is best-effort).
	 *
	 * @param {string} pKey
	 * @param {Record<string, any>} pEntry
	 */
	_writeCacheEntry(pKey, pEntry)
	{
		const tmpStorage = this._cacheStorage();
		if (!tmpStorage)
		{
			return;
		}
		const tmpSerialized = JSON.stringify(pEntry);
		try
		{
			tmpStorage.setItem(pKey, tmpSerialized);
		}
		catch (pError)
		{
			this.clearScopeCache();
			try
			{
				tmpStorage.setItem(pKey, tmpSerialized);
			}
			catch (pRetryError)
			{
				this.pict?.log?.warn(`[SpecScopeResolver] Scope cache write failed for ${pKey}: ${pRetryError?.message || pRetryError}`);
			}
		}
	}

	/**
	 * Remove every persisted spec-scope entry (all versions' project scopes and
	 * material hierarchies). Public so QA/debug tooling can force a cold load.
	 */
	clearScopeCache()
	{
		const tmpStorage = this._cacheStorage();
		if (!tmpStorage)
		{
			return;
		}
		try
		{
			const tmpKeys = [];
			for (let i = 0; i < tmpStorage.length; i++)
			{
				const tmpKey = tmpStorage.key(i);
				if (tmpKey && tmpKey.startsWith('HeadlightSpecScope:'))
				{
					tmpKeys.push(tmpKey);
				}
			}
			for (const tmpKey of tmpKeys)
			{
				tmpStorage.removeItem(tmpKey);
			}
		}
		catch (pError)
		{
			// fail open
		}
	}

	/**
	 * @param {number} pIDProject
	 * @param {{ TTLSeconds: number }} pCacheConfig
	 * @return {Record<string, any>|null} the cached project scope entry, or null.
	 */
	_readProjectScopeCache(pIDProject, pCacheConfig)
	{
		return this._readCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}Project:${pIDProject}`, pCacheConfig.TTLSeconds);
	}

	/**
	 * Persist the currently-resolved scope for a project. Plan entries are stored as
	 * [SampleType, IDLineItem, IDMaterial, IDTest] quads; HasSamplePlanData
	 * distinguishes "entries resolved (possibly empty)" from "never loaded" so a
	 * plan-scoped form can't hit an entry-less cache row.
	 *
	 * @param {number} pIDProject
	 */
	_writeProjectScopeCache(pIDProject)
	{
		const tmpCombos = this._Scope.SamplePlanCombos;
		this._writeCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}Project:${pIDProject}`,
		{
			TS: Date.now(),
			MaterialSetID: this._Scope.MaterialSetID || 0,
			Source: this._Scope.Source,
			HasSamplePlanData: Array.isArray(tmpCombos),
			SP: Array.isArray(tmpCombos) ? tmpCombos.map((pCombo) => [ pCombo.SampleType, pCombo.IDLineItem, pCombo.IDMaterial, pCombo.IDTest ]) : null,
		});
	}

	/**
	 * @param {Record<string, any>} pCachedEntry - entry with SP quads.
	 */
	_applySamplePlanFromCache(pCachedEntry)
	{
		this._applyPlanEntries(this._planEntriesFromRows(pCachedEntry.SP || [], (pQuad) => (
			{
				SampleType: pQuad[0],
				IDLineItem: pQuad[1],
				IDMaterial: pQuad[2],
				IDTest: pQuad[3],
			})), pCachedEntry.Source || 'None');
	}

	/**
	 * Resolve the bundle-execution configuration for cold loads. On by default;
	 * `SpecScopeBundle: { Enabled: false }` (manifest wins over provider
	 * options) pins the resolver to its per-entity reads.
	 *
	 * @return {{ Enabled: boolean }}
	 */
	_resolveBundleConfig()
	{
		const tmpManifest = this.pict?.views?.PictFormMetacontroller?.manifestDescription;
		const tmpSources =
		[
			tmpManifest && tmpManifest.SpecScopeBundle,
			(this.options || {}).SpecScopeBundle,
		];
		for (const tmpSource of tmpSources)
		{
			if (tmpSource && typeof tmpSource.Enabled === 'boolean')
			{
				return { Enabled: tmpSource.Enabled };
			}
		}
		return { Enabled: true };
	}

	/**
	 * @return {import('./PictProvider-EntityBundleClient.js')|null} the shared
	 * EntityBundleClient, self-registering it when the host app hasn't.
	 */
	_getEntityBundleClient()
	{
		if (this.pict?.providers?.EntityBundleClient)
		{
			return this.pict.providers.EntityBundleClient;
		}
		if (typeof this.pict?.addProvider === 'function')
		{
			this.pict.addProvider('EntityBundleClient', {}, require('./PictProvider-EntityBundleClient.js'));
			return this.pict.providers.EntityBundleClient || null;
		}
		return null;
	}

	/**
	 * Build the bundle steps equivalent to this load's per-entity reads: the project's
	 * plan rows, and the LineItem + PayItemMaterialTestRequirement rows the template
	 * fallback joins when there are none. Both are fetched unconditionally because the
	 * bundle is one round trip and the source choice happens client-side in
	 * _applyScopeBundleData. The customer Material step is omitted when the hierarchy is
	 * already resident or primeable from cache.
	 *
	 * @param {number} pIDProject
	 * @param {number} pIDCustomer
	 * @param {number} pMaterialSetID
	 * @return {Array<Record<string, any>>}
	 */
	_buildScopeBundleSteps(pIDProject, pIDCustomer, pMaterialSetID)
	{
		const tmpSteps =
		[
			{ Entity: 'ProjectLineItemMaterialTest', Filter: `FBV~IDProject~EQ~${pIDProject}`, Destination: 'Bundle.ProjectLineItemMaterialTest', AllRecords: true, Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'SampleType' ] } },
			{ Entity: 'LineItem', Filter: `FBV~IDProject~EQ~${pIDProject}`, Destination: 'Bundle.LineItem', AllRecords: true, Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'IDPayItem' ] } },
		];
		if (pMaterialSetID > 0)
		{
			// Narrowed to the pay items this project's line items actually name (PJU-chained off the
			// step above). The requirement rows the join can never reach are 41x the ones it can —
			// 61,480 set-wide against 1,487 for a large project on set 30 — and they are fetched on
			// every cold scope load, including the offline replay. The set filter stays alongside it:
			// a pay item can be named by a requirement row belonging to another set (set 32 carries
			// 318 rows against set 30's pay items), and only the set clause excludes those.
			tmpSteps.push(
				{
					Entity: 'PayItemMaterialTestRequirement',
					Filter: `FBV~IDTestSpecificationSet~EQ~${pMaterialSetID}~FBL~IDPayItem~INN~{~PJU:,^IDPayItem^Bundle.LineItem~}`,
					Destination: 'Bundle.PayItemMaterialTestRequirement',
					AllRecords: true,
					Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'IDPayItem', 'SampleType' ] },
				});
		}
		if (this._needsMaterialHierarchy() && pIDCustomer > 0 && !this._primeMaterialHierarchyFromCache(pIDCustomer))
		{
			tmpSteps.push({ Entity: 'Material', Filter: `FBV~IDCustomer~EQ~${pIDCustomer}`, Destination: 'Bundle.Material', AllRecords: true, Projection: { Mode: 'LiteExtended', ExtraColumns: [ 'IDMaterialParent' ] } });
		}
		return tmpSteps;
	}

	/**
	 * Marshal executed-bundle data into the scope, applying the source choice locally:
	 * the project's own plan rows when it has any, else the template joined on IDPayItem.
	 *
	 * @param {Record<string, Array<any>>} pData - executed-bundle data keyed by entity.
	 * @param {number} pIDCustomer
	 */
	_applyScopeBundleData(pData, pIDCustomer)
	{
		if (Array.isArray(pData.Material) && pIDCustomer > 0)
		{
			const tmpPairs = [];
			for (const tmpRow of pData.Material)
			{
				const tmpID = parseInt(tmpRow.IDMaterial, 10) || 0;
				if (tmpID > 0)
				{
					tmpPairs.push([ tmpID, parseInt(tmpRow.IDMaterialParent, 10) || 0 ]);
				}
			}
			this._MaterialHierarchy = this._buildMaterialHierarchy(pIDCustomer, tmpPairs);
			if (this._resolveCacheConfig().Enabled)
			{
				this._writeCacheEntry(`${SPEC_SCOPE_CACHE_PREFIX}MaterialHierarchy:${pIDCustomer}`, { TS: Date.now(), Pairs: tmpPairs });
			}
		}
		const tmpPlanRows = pData.ProjectLineItemMaterialTest || [];
		if (tmpPlanRows.length > 0)
		{
			this._applyPlanEntries(this._planEntriesFromRows(tmpPlanRows), 'Plan');
			return;
		}
		this._applyPlanEntries(
			this._joinTemplateEntries(pData.LineItem || [], pData.PayItemMaterialTestRequirement || []),
			this._Scope.MaterialSetID > 0 ? 'Template' : 'None');
	}

	/**
	 * Join specification requirements to a project's line items on IDPayItem — the
	 * client-side half of the template source, for the bundle transport that has no
	 * server to do it. Mirrors the platform endpoint's join, including its exclusions:
	 * a line item with no pay item contributes nothing (and so does not constrain
	 * itself), and a requirement with a zero material or test id is a plan defect
	 * rather than a scope fact.
	 *
	 * @param {Array<Record<string, any>>} pLineItems
	 * @param {Array<Record<string, any>>} pRequirements
	 * @return {Array<PlanEntry>} distinct on (IDLineItem, IDMaterial, IDTest, SampleType).
	 */
	_joinTemplateEntries(pLineItems, pRequirements)
	{
		/** @type {Map<number, Array<number>>} */
		const tmpLineItemIDsByPayItem = new Map();
		for (const tmpRow of pLineItems)
		{
			const tmpIDLineItem = parseInt(tmpRow.IDLineItem, 10) || 0;
			const tmpIDPayItem = parseInt(tmpRow.IDPayItem, 10) || 0;
			if (!(tmpIDLineItem > 0) || !(tmpIDPayItem > 0))
			{
				continue;
			}
			if (!tmpLineItemIDsByPayItem.has(tmpIDPayItem))
			{
				tmpLineItemIDsByPayItem.set(tmpIDPayItem, []);
			}
			tmpLineItemIDsByPayItem.get(tmpIDPayItem).push(tmpIDLineItem);
		}
		const tmpSeen = new Set();
		const tmpEntries = [];
		for (const tmpRow of pRequirements)
		{
			const tmpIDMaterial = parseInt(tmpRow.IDMaterial, 10) || 0;
			const tmpIDTest = parseInt(tmpRow.IDTest, 10) || 0;
			if (!(tmpIDMaterial > 0) || !(tmpIDTest > 0))
			{
				continue;
			}
			const tmpSampleType = tmpRow.SampleType || '';
			for (const tmpIDLineItem of (tmpLineItemIDsByPayItem.get(parseInt(tmpRow.IDPayItem, 10) || 0) || []))
			{
				const tmpKey = `${tmpIDLineItem}|${tmpIDMaterial}|${tmpIDTest}|${tmpSampleType}`;
				if (tmpSeen.has(tmpKey))
				{
					continue;
				}
				tmpSeen.add(tmpKey);
				tmpEntries.push({ SampleType: tmpSampleType, IDLineItem: tmpIDLineItem, IDMaterial: tmpIDMaterial, IDTest: tmpIDTest });
			}
		}
		return tmpEntries;
	}

	/**
	 * Ancestor material IDs (walk IDMaterialParent up), excluding self. Empty when no hierarchy
	 * is loaded (fail-open — no expansion). Cycle-guarded.
	 *
	 * @param {number|string} pIDMaterial
	 * @return {Set<number>}
	 */
	getMaterialAncestorIDs(pIDMaterial)
	{
		const tmpResult = new Set();
		if (!this._MaterialHierarchy)
		{
			return tmpResult;
		}
		let tmpCurrent = parseInt(String(pIDMaterial), 10) || 0;
		let tmpGuard = 0;
		while (tmpCurrent > 0 && tmpGuard++ < 64)
		{
			const tmpParent = this._MaterialHierarchy.ParentOf.get(tmpCurrent) || 0;
			if (!(tmpParent > 0) || tmpResult.has(tmpParent))
			{
				break;
			}
			tmpResult.add(tmpParent);
			tmpCurrent = tmpParent;
		}
		return tmpResult;
	}

	/**
	 * Descendant material IDs (walk children down, transitive), excluding self. Empty when no
	 * hierarchy is loaded (fail-open). Cycle-guarded by the visited set.
	 *
	 * @param {number|string} pIDMaterial
	 * @return {Set<number>}
	 */
	getMaterialDescendantIDs(pIDMaterial)
	{
		const tmpResult = new Set();
		if (!this._MaterialHierarchy)
		{
			return tmpResult;
		}
		const tmpStack = [ parseInt(String(pIDMaterial), 10) || 0 ];
		while (tmpStack.length > 0)
		{
			const tmpChildren = this._MaterialHierarchy.ChildrenOf.get(tmpStack.pop());
			if (!tmpChildren)
			{
				continue;
			}
			for (const tmpChild of tmpChildren)
			{
				if (!tmpResult.has(tmpChild))
				{
					tmpResult.add(tmpChild);
					tmpStack.push(tmpChild);
				}
			}
		}
		return tmpResult;
	}

	/**
	 * Expand material anchors UP: the anchors plus all their ancestors. Used when a selected
	 * material is PUSHED as a filter to another input — the parent categories match too, so a
	 * leaf selection surfaces records bound to its category. Accepts a Set, array, comma-joined
	 * id string (a Multiple selector's value), or a single id; returns the union as a Set.
	 *
	 * @param {Iterable<number|string>|string|number} pIDs
	 * @return {Set<number>}
	 */
	expandMaterialAnchorsUp(pIDs)
	{
		const tmpResult = new Set();
		for (const tmpID of this._coerceMaterialIDList(pIDs))
		{
			tmpResult.add(tmpID);
			for (const tmpAncestor of this.getMaterialAncestorIDs(tmpID))
			{
				tmpResult.add(tmpAncestor);
			}
		}
		return tmpResult;
	}

	/**
	 * Expand an allowed material set DOWN: the set plus all descendants. Used when a dropdown
	 * filters its items by a material set — an item bound to one of the materials OR any child
	 * material is allowed. Accepts a Set, array, comma-joined id string, or a single id.
	 *
	 * @param {Iterable<number|string>|string|number} pIDs
	 * @return {Set<number>}
	 */
	expandMaterialSetDown(pIDs)
	{
		const tmpResult = new Set();
		for (const tmpID of this._coerceMaterialIDList(pIDs))
		{
			tmpResult.add(tmpID);
			for (const tmpDescendant of this.getMaterialDescendantIDs(tmpID))
			{
				tmpResult.add(tmpDescendant);
			}
		}
		return tmpResult;
	}

	/**
	 * Normalize a Set / array / comma-joined string / number into an array of positive ints.
	 *
	 * @param {Iterable<number|string>|string|number} pIDs
	 * @return {number[]}
	 */
	_coerceMaterialIDList(pIDs)
	{
		if (pIDs === null || pIDs === undefined)
		{
			return [];
		}
		let tmpRaw;
		if (typeof pIDs === 'string')
		{
			tmpRaw = pIDs.split(',');
		}
		else if (typeof pIDs === 'number')
		{
			tmpRaw = [ pIDs ];
		}
		else
		{
			tmpRaw = Array.from(pIDs);
		}
		const tmpResult = [];
		for (const tmpValue of tmpRaw)
		{
			const tmpID = parseInt(String(tmpValue).trim(), 10) || 0;
			if (tmpID > 0)
			{
				tmpResult.push(tmpID);
			}
		}
		return tmpResult;
	}

	/**
	 * Whether any descriptor on the loaded form carries a DynamicFilters entry matching
	 * a predicate. Returns false when no manifest is available.
	 *
	 * @param {(pFilter: Record<string, any>) => boolean} fPredicate
	 * @return {boolean}
	 */
	_hasDynamicFilter(fPredicate)
	{
		const tmpDescriptors = this.pict?.views?.PictFormMetacontroller?.manifestDescription?.Descriptors;
		if (!tmpDescriptors)
		{
			return false;
		}
		for (const tmpDescriptor of Object.values(tmpDescriptors))
		{
			const tmpFilters = tmpDescriptor?.PictForm?.DynamicFilters;
			if (Array.isArray(tmpFilters) && tmpFilters.some((pFilter) => !!pFilter && fPredicate(pFilter)))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * Whether the loaded form has a plan-scoped selector — a descriptor with a
	 * SamplePlanScope entry in its PictForm.DynamicFilters. Gates the plan-entry reads so
	 * forms that don't use them pay nothing.
	 *
	 * @return {boolean}
	 */
	_needsSamplePlan()
	{
		return this._hasDynamicFilter((pFilter) => !!pFilter.SamplePlanScope);
	}

	/**
	 * Whether any filter on the form expands a material anchor through the material tree
	 * — the plan scopes, and a Through hop keyed on IDMaterial.
	 *
	 * @return {boolean}
	 */
	_needsMaterialHierarchy()
	{
		return this._needsSamplePlan() || this._hasDynamicFilter((pFilter) => !!pFilter.Through && pFilter.ThroughKey === 'IDMaterial');
	}

	/**
	 * Resolve the project's plan entries from the per-entity reads. The project's own
	 * ProjectLineItemMaterialTest rows win when it has any; otherwise the platform
	 * derives the template from the contract's specification set. Uses the
	 * LiteExtended/SampleType projection — Lite carries the IDs but not the SampleType
	 * Hash; LiteExtended/SampleType adds it while staying offline-servable.
	 *
	 * @param {number} pIDProject
	 * @return {Promise<{ Combos: Array<PlanEntry>, Source: PlanEntrySource }>}
	 */
	async _loadSamplePlan(pIDProject)
	{
		const tmpRows = await this._readAllPages('ProjectLineItemMaterialTests/LiteExtended/SampleType', `FBV~IDProject~EQ~${pIDProject}`);
		if (tmpRows.length > 0)
		{
			return { Combos: this._planEntriesFromRows(tmpRows), Source: 'Plan' };
		}
		return this._loadTemplateEntries(pIDProject);
	}

	/**
	 * Ask the platform for the specification template governing a project with no plan.
	 * Fails open on a missing or erroring endpoint — a client running ahead of the
	 * platform must leave its pickers unnarrowed, not blank them.
	 *
	 * @param {number} pIDProject
	 * @return {Promise<{ Combos: Array<PlanEntry>, Source: PlanEntrySource }>}
	 */
	async _loadTemplateEntries(pIDProject)
	{
		try
		{
			const tmpResponse = await this._getJSON(`TestSpecificationSet/PlanEntries/ForProject/${pIDProject}`);
			return {
				Combos: this._planEntriesFromRows(tmpResponse?.Entries || []),
				Source: tmpResponse?.Source || 'None',
			};
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Plan-entry template load failed for project ${pIDProject} (fail-open): ${pError?.message || pError}`);
			return { Combos: [], Source: 'None' };
		}
	}

	/**
	 * Normalize rows from any transport into plan entries.
	 *
	 * @param {Array<any>} pRows
	 * @param {(pRow: any) => Record<string, any>} [fPick] - maps a row onto the four fields.
	 * @return {Array<PlanEntry>}
	 */
	_planEntriesFromRows(pRows, fPick)
	{
		return pRows.map((pRow) =>
		{
			const tmpRow = fPick ? fPick(pRow) : pRow;
			return {
				SampleType: tmpRow.SampleType || '',
				IDLineItem: parseInt(tmpRow.IDLineItem, 10) || 0,
				IDMaterial: parseInt(tmpRow.IDMaterial, 10) || 0,
				IDTest: parseInt(tmpRow.IDTest, 10) || 0,
			};
		});
	}

	/**
	 * Resolve the allowed IDs for one plan axis (pField), narrowed by whatever
	 * upstream keys are supplied in pKeys. An absent / empty / zero key does not
	 * narrow on that axis (so the top of the cascade returns the whole plan set).
	 * Returns null when no plan is loaded — the fail-open signal.
	 *
	 * @param {('IDLineItem'|'IDMaterial'|'IDTest')} pField
	 * @param {{SampleType?:string, IDLineItem?:number, IDMaterial?:number, IDTest?:number}} pKeys
	 * @return {Set<number>|null}
	 */
	_samplePlanIDs(pField, pKeys)
	{
		if (!this._Scope.HasSamplePlan || !Array.isArray(this._Scope.SamplePlanCombos))
		{
			return null;
		}
		// Normalize each provided key to a Set of accepted values. A Multiple selector
		// (e.g. the LineItem picker) hands a comma-joined list like "12,34", so a key may
		// accept several values (union/IN). An absent / empty / zero key does not narrow.
		const tmpKeySets = {};
		for (const tmpKey of Object.keys(pKeys))
		{
			const tmpRaw = pKeys[tmpKey];
			if (tmpRaw === null || tmpRaw === undefined || tmpRaw === '' || tmpRaw === 0)
			{
				continue;
			}
			const tmpValues = String(tmpRaw).split(',').map((pValue) => pValue.trim()).filter((pValue) => pValue !== '' && pValue !== '0');
			if (tmpValues.length === 0)
			{
				continue;
			}
			if (tmpKey === 'SampleType')
			{
				tmpKeySets[tmpKey] = new Set(tmpValues);
				continue;
			}
			// Numeric axes (IDLineItem / IDMaterial / IDTest). A non-numeric anchor — e.g. a hash-keyed Test
			// selector handing "D5249v1" — would parseInt to NaN and match no plan combo, wrongly constraining the
			// dependent dropdown to none. Drop non-numeric values; if none remain, this axis simply does not narrow
			// (the same fail-open as an absent / empty / zero key) rather than blanking the dropdown.
			const tmpNumeric = tmpValues.map((pValue) => parseInt(pValue, 10)).filter((pValue) => !Number.isNaN(pValue));
			if (tmpNumeric.length === 0)
			{
				continue;
			}
			tmpKeySets[tmpKey] = new Set(tmpNumeric);
		}
		const tmpResult = new Set();
		for (const tmpCombo of this._Scope.SamplePlanCombos)
		{
			let tmpMatch = true;
			for (const tmpKey of Object.keys(tmpKeySets))
			{
				const tmpComboValue = (tmpKey === 'SampleType') ? String(tmpCombo.SampleType) : tmpCombo[tmpKey];
				if (!tmpKeySets[tmpKey].has(tmpComboValue))
				{
					tmpMatch = false;
					break;
				}
			}
			if (tmpMatch && tmpCombo[pField] > 0)
			{
				tmpResult.add(tmpCombo[pField]);
			}
		}
		return tmpResult;
	}

	/**
	 * Allowed LineItem IDs from the sampling plan, narrowed by SampleType and/or
	 * the selected Material / Test (bidirectional plan cross-filter). Null when no
	 * plan (fail-open).
	 *
	 * @param {string} [pSampleType]
	 * @param {number} [pIDMaterial]
	 * @param {number} [pIDTest]
	 * @return {Set<number>|null}
	 */
	getSamplePlanLineItemIDs(pSampleType, pIDMaterial, pIDTest)
	{
		return this._samplePlanIDs('IDLineItem', { SampleType: pSampleType, IDMaterial: pIDMaterial, IDTest: pIDTest });
	}

	/**
	 * Allowed Material IDs from the sampling plan, narrowed by SampleType and/or
	 * the selected LineItem / Test (bidirectional plan cross-filter). Null when no
	 * plan (fail-open).
	 *
	 * @param {string} [pSampleType]
	 * @param {number} [pIDLineItem]
	 * @param {number} [pIDTest]
	 * @return {Set<number>|null}
	 */
	getSamplePlanMaterialIDs(pSampleType, pIDLineItem, pIDTest)
	{
		return this._samplePlanIDs('IDMaterial', { SampleType: pSampleType, IDLineItem: pIDLineItem, IDTest: pIDTest });
	}

	/**
	 * Allowed Test IDs from the sampling plan, narrowed by SampleType, LineItem,
	 * and/or Material. Null when no plan (fail-open).
	 *
	 * @param {string} [pSampleType]
	 * @param {number} [pIDLineItem]
	 * @param {number} [pIDMaterial]
	 * @return {Set<number>|null}
	 */
	getSamplePlanTestIDs(pSampleType, pIDLineItem, pIDMaterial)
	{
		return this._samplePlanIDs('IDTest', { SampleType: pSampleType, IDLineItem: pIDLineItem, IDMaterial: pIDMaterial });
	}

	/**
	 * Resolve a contract's specification-set reference. Two-tiered: the direct
	 * IDTestSpecificationSet FK wins; when it's unset, fall back to matching a
	 * TestSpecificationSet by the contract's spec Year. Returns 0 when neither
	 * referent is set (the template source then does not apply).
	 *
	 * @param {Record<string, any>} pContract
	 * @param {string} pIDField - direct set-ID field, e.g. 'MaterialIDTestSpecificationSet'.
	 * @param {string} pYearField - specification-year field, e.g. 'MaterialsSpecificationYear'.
	 * @return {Promise<number>}
	 */
	async _resolveSetID(pContract, pIDField, pYearField)
	{
		const tmpDirectID = parseInt(pContract?.[pIDField], 10) || 0;
		if (tmpDirectID > 0)
		{
			return tmpDirectID;
		}
		const tmpYearValue = pContract?.[pYearField];
		if (tmpYearValue == null)
		{
			return 0;
		}
		const tmpYear = String(tmpYearValue).trim();
		if (tmpYear === '' || tmpYear === '0')
		{
			return 0;
		}
		// A year is NOT unique: a customer may run a provisional set alongside the live one for the same year.
		// Nothing on TestSpecificationSet distinguishes them, so take the lowest id — the earliest set for the
		// year — and say so when the year is ambiguous rather than resolving it silently.
		const tmpSets = await this._readAllPages('TestSpecificationSets/LiteExtended/Year', `FBV~Year~EQ~${encodeURIComponent(tmpYear)}~FSF~IDTestSpecificationSet~ASC~0`);
		if (tmpSets.length > 1)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Specification year ${tmpYear} matches ${tmpSets.length} specification sets; using the lowest id (${tmpSets[0]?.IDTestSpecificationSet}). Set the contract's ${pIDField} to resolve this explicitly.`);
		}
		return parseInt(tmpSets[0]?.IDTestSpecificationSet, 10) || 0;
	}

	/**
	 * Page through a filtered meadow read until exhausted. Plain FilteredTo
	 * reads (no Count/aggregate route) so the offline client can serve them
	 * from synced entity data.
	 *
	 * @param {string} pEntityRoute - pluralized route incl. projection, e.g. 'PayItems/Lite'.
	 * @param {string} pFilter - meadow filter stanza, e.g. 'FBV~IDTestSpecificationSet~EQ~12'.
	 * @return {Promise<Array<any>>}
	 */
	async _readAllPages(pEntityRoute, pFilter)
	{
		const tmpRows = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpPage = await this._getJSON(`${pEntityRoute}/FilteredTo/${pFilter}/${tmpOffset}/${SPEC_SCOPE_PAGE_SIZE}`);
			if (!Array.isArray(tmpPage) || tmpPage.length === 0)
			{
				break;
			}
			for (const tmpRow of tmpPage)
			{
				tmpRows.push(tmpRow);
			}
			if (tmpPage.length < SPEC_SCOPE_PAGE_SIZE)
			{
				break;
			}
			tmpOffset += SPEC_SCOPE_PAGE_SIZE;
		}
		return tmpRows;
	}

	/**
	 * @param {Array<any>} pValues
	 * @return {Array<number>} distinct positive integers.
	 */
	_distinctPositive(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of pValues)
		{
			const tmpNumber = parseInt(tmpValue, 10);
			if (tmpNumber > 0)
			{
				tmpSet.add(tmpNumber);
			}
		}
		return Array.from(tmpSet);
	}

	_getJSON(pUrl)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pUrl, (err, body) =>
			{
				if (err)
				{
					return reject(err);
				}
				resolve(body);
			});
		});
	}

	/**
	 * @return {Set<number>|null} Allowed lab IDs — labs joined to the material spec set via
	 * LabTestSpecificationSetJoin — when the set has lab-join coverage, else null (no constraint).
	 */
	getAllowedLabIDs()
	{
		return this._Scope.HasLabCoverage ? this._Scope.AllowedLabIDs : null;
	}

	/**
	 * Floor the lab axis to labs joined to the resolved material spec set (LabTestSpecificationSetJoin). Fails open:
	 * on no set, empty coverage, or a read error, getAllowedLabIDs returns null and the lab picker is unconstrained.
	 * @return {Promise<void>}
	 */
	async _loadLabScope()
	{
		const tmpSetID = this._Scope.MaterialSetID;
		if (!(tmpSetID > 0))
		{
			return;
		}
		try
		{
			const tmpRows = await this._readAllPages('LabTestSpecificationSetJoins/Lite', `FBV~IDTestSpecificationSet~EQ~${tmpSetID}`);
			this._Scope.AllowedLabIDs = new Set(this._distinctPositive(tmpRows.map((pRow) => pRow.IDLab)));
			this._Scope.HasLabCoverage = this._Scope.AllowedLabIDs.size > 0;
		}
		catch (pError)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Lab scope load failed (fail-open): ${pError?.message || pError}`);
		}
	}

	/**
	 * @return {PlanEntrySource} which source answered for the loaded project. No picker
	 * reads this; it is what answers "why can't I pick this".
	 */
	getSource()
	{
		return this._Scope.Source;
	}

	/**
	 * @return {boolean} True when resolver has completed its load attempt.
	 */
	isLoaded()
	{
		return this._Scope.Loaded;
	}

	/**
	 * App-load hook — auto-prime scope from whatever sample/project the
	 * loaded form points at. Fires automatically because PictProvider
	 * defaults `AutoLoadDataWithApp: true`. We don't override that flag,
	 * so we participate in the load cycle without host-app changes.
	 *
	 * Resolution strategy (mirrors Materials-Form-Manager.js:605-626 for
	 * the manifest walk, then falls back to legacy + document-level addresses):
	 *
	 *   1. Walk manifest descriptors for a sample-bearing InputType
	 *      (SampleSelector / MaterialsSampleSelector / MaterialsHiddenSampleSelector,
	 *      plus EntitySelector / EntitySelectorMultiple with Entity='Sample').
	 *   2. First match wins. If a __Record companion exists at
	 *      `<DataAddress>__Record`, forward via loadForSampleRecord (no
	 *      extra REST). Else read the bare value and forward via
	 *      loadForSampleByIdentifier with the descriptor's IdentityField.
	 *   3. Hard-coded legacy fallback: `SampleID__Record`.
	 *   4. Final fallback: `ReportData.IDProject` → loadForProject.
	 *   5. No suitable signal: silently skip (host apps that already call
	 *      loadForProject explicitly continue to work; resolver dedupes).
	 *
	 * Failure here is non-fatal — the resolver fails open and pickers
	 * see the full catalog.
	 *
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			this._resolveSpecScopeFromForm().catch((err) =>
			{
				this.pict?.log?.warn(`[SpecScopeResolver] Auto-resolve on app load failed: ${err?.message || err}`);
			}).finally(() =>
			{
				fCallback();
			});
		});
	}

	/**
	 * @return {Promise<void>}
	 */
	async _resolveSpecScopeFromForm()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		const tmpFormData = tmpReportData?.FormData;
		const tmpInfo = this._findSampleDescriptorInfo();
		if (tmpInfo && tmpFormData)
		{
			const tmpRecord = this.pict.manifest.getValueAtAddress(tmpFormData, `${tmpInfo.dataAddress}__Record`);
			if (tmpRecord && tmpRecord.IDProject > 0)
			{
				await this.loadForSampleRecord(tmpRecord);
				return;
			}
			const tmpValue = this.pict.manifest.getValueAtAddress(tmpFormData, tmpInfo.dataAddress);
			if (tmpValue)
			{
				await this.loadForSampleByIdentifier(tmpValue, tmpInfo.identityField);
				return;
			}
		}
		// Legacy fallback. Older forms without a discoverable sample-selector
		// descriptor sometimes still maintain a SampleID__Record companion.
		const tmpLegacyRecord = tmpFormData ? this.pict.manifest.getValueAtAddress(tmpFormData, 'SampleID__Record') : null;
		if (tmpLegacyRecord && tmpLegacyRecord.IDProject > 0)
		{
			await this.loadForSampleRecord(tmpLegacyRecord);
			return;
		}
		// Final fallback: document-level project. Forms with no sample concept
		// at all (e.g. document-level reports) still get scope from this path.
		const tmpDocProjectID = parseInt(tmpReportData?.IDProject, 10) || 0;
		if (tmpDocProjectID > 0)
		{
			await this.loadForProject(tmpDocProjectID);
		}
	}

	/**
	 * @return {{ dataAddress: string, identityField: string }|null}
	 */
	_findSampleDescriptorInfo()
	{
		const tmpManifest = this.pict.views?.PictFormMetacontroller?.manifestDescription;
		if (!tmpManifest || !tmpManifest.Descriptors)
		{
			return null;
		}
		const SAMPLE_INPUT_TYPES = new Set(
			[ 'SampleSelector', 'MaterialsSampleSelector', 'MaterialsHiddenSampleSelector' ]);
		// Materials* selectors store GUIDSample by default (see
		// _getDefaultRecordIdentity in PictProvider-InputType-MaterialsSampleSelector.js
		// line 28). SampleSelector and EntitySelector default to IDSample.
		const MATERIALS_SAMPLE_SELECTORS = new Set(
			[ 'MaterialsSampleSelector', 'MaterialsHiddenSampleSelector' ]);
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpManifest.Descriptors))
		{
			const tmpInputType = tmpDescriptor.PictForm?.InputType;
			const tmpEntity = tmpDescriptor.PictForm?.Entity;
			const tmpIsExplicit = SAMPLE_INPUT_TYPES.has(tmpInputType);
			const tmpIsGeneric = (tmpInputType === 'EntitySelector' || tmpInputType === 'EntitySelectorMultiple') && tmpEntity === 'Sample';
			if (tmpIsExplicit || tmpIsGeneric)
			{
				let tmpIdentityField = tmpDescriptor.PictForm?.IdentityField;
				if (!tmpIdentityField)
				{
					tmpIdentityField = MATERIALS_SAMPLE_SELECTORS.has(tmpInputType) ? 'GUIDSample' : 'IDSample';
				}
				return {
					dataAddress: tmpDescriptor.DataAddress || tmpKey,
					identityField: tmpIdentityField,
				};
			}
		}
		return null;
	}

	/**
	 * Convenience for callers that already have a Sample record in hand
	 * (e.g. MaterialsSampleSelector after _onRecordRefresh). Pulls IDProject
	 * off the record and forwards to loadForProject. No-op when the record
	 * is missing or doesn't carry a populated IDProject.
	 *
	 * @param {Record<string, any>} pSampleRecord
	 * @return {Promise<object>} the scope snapshot
	 */
	loadForSampleRecord(pSampleRecord)
	{
		const tmpIDProject = parseInt(pSampleRecord?.IDProject, 10) || 0;
		if (!(tmpIDProject > 0))
		{
			return Promise.resolve(this._Scope);
		}
		return this.loadForProject(tmpIDProject);
	}

	/**
	 * Convenience for callers that have a Sample identifier (typically
	 * IDSample, sometimes GUIDSample for not-yet-saved samples). Fetches
	 * the matching Sample row by the named identity field and forwards
	 * to loadForSampleRecord.
	 *
	 * Selectors that store IDSample (SampleSelector, EntitySelector with
	 * default IdentityField) call with `pIdentityField='IDSample'`.
	 * MaterialsSampleSelector stores GUIDSample but it has the record in
	 * hand, so it uses loadForSampleRecord directly. EntitySelector with a
	 * non-default IdentityField passes that through.
	 *
	 * @param {string|number} pSampleIdentifier
	 * @param {string} [pIdentityField='IDSample']
	 * @return {Promise<object>} the scope snapshot
	 */
	async loadForSampleByIdentifier(pSampleIdentifier, pIdentityField = 'IDSample')
	{
		if (pSampleIdentifier === null || pSampleIdentifier === undefined || pSampleIdentifier === '' || pSampleIdentifier === 'null')
		{
			return this._Scope;
		}
		try
		{
			const tmpRows = await this._getJSON(`Samples/FilteredTo/FBV~${pIdentityField}~EQ~${encodeURIComponent(pSampleIdentifier)}`);
			const tmpRecord = Array.isArray(tmpRows) ? tmpRows[0] : tmpRows;
			return this.loadForSampleRecord(tmpRecord);
		}
		catch (err)
		{
			this.pict?.log?.warn(`[SpecScopeResolver] Failed to fetch Sample (${pIdentityField}=${pSampleIdentifier}): ${err?.message || err}`);
			return this._Scope;
		}
	}
}

module.exports = SpecScopeResolver;

},{"./PictProvider-EntityBundleClient.js":63,"pict-provider":552}],151:[function(require,module,exports){

const libPictTemplate = require('pict-template');

class PictTemplateProviderHumanCount extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HumanCount:', '~}');
	}

	/**
	 * Format count as human-readable text (ex. 135k, 257M).
	 *
	 * @param {number} count - Count to summarize.
	 * @param {number} [dp] - Number of decimal places to display.
	 *
	 * @return {string} Human-readable text.
	 */
	humanFileSize(count, dp = 1)
	{
		const thresh = 1000;

		if (Math.abs(count) < thresh)
		{
			return String(count);
		}

		const units = [ 'k', 'M', 'B' ];
		let u = -1;
		const r = 10 ** dp;

		do
		{
			count /= thresh;
			++u;
		}
		while (Math.round(Math.abs(count) * r) / r >= thresh && u < units.length - 1);


		return count.toFixed(dp) + units[u];
	}

	render(pTemplateHash, pRecord, pContextArray)
	{
		const [ tmpHash, tmpPrecision ] = pTemplateHash.trim().split('^');
		const tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fHumanCount]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fHumanCount]::[${tmpHash}]`);
		}

		let tmpValue;
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray);
		}
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined'))
		{
			return '';
		}
		return this.humanFileSize(tmpValue, tmpPrecision ? parseInt(tmpPrecision) : 1);
	}
}

module.exports = PictTemplateProviderHumanCount;

},{"pict-template":731}],152:[function(require,module,exports){
// Resolver behind the `{~LinkTarget:Record~}` macro used by the Link InputType templates.
// Kept as a plain module (not a pict-template class) so the whitelist logic is unit-testable
// without standing up the bundle.

const _VALID_LINK_TARGETS = [ '_blank', '_self', '_parent', '_top' ];

/**
 * Resolve a descriptor's PictForm.LinkTarget into anchor attributes.
 *
 * The return value is spliced into raw markup, so the author's string is never echoed through --
 * only whitelisted targets are emitted. Absent or out-of-domain values yield '' (no attribute),
 * preserving the same-tab default rather than rendering target="".
 *
 * @param {any} pDescriptor - The form descriptor (the `Record` the macro resolves).
 * @return {string} The attribute fragment, or '' when no target applies.
 */
const resolveLinkTargetAttributes = (pDescriptor) =>
{
	const tmpTarget = pDescriptor?.PictForm?.LinkTarget;
	if (typeof tmpTarget !== 'string')
	{
		return '';
	}
	const tmpNormalizedTarget = tmpTarget.trim().toLowerCase();
	if (_VALID_LINK_TARGETS.indexOf(tmpNormalizedTarget) < 0)
	{
		return '';
	}
	// A new browsing context needs the rel guard against reverse tabnabbing.
	return (tmpNormalizedTarget === '_blank') ? 'target="_blank" rel="noopener noreferrer"' : `target="${tmpNormalizedTarget}"`;
};

module.exports = { resolveLinkTargetAttributes: resolveLinkTargetAttributes, VALID_LINK_TARGETS: _VALID_LINK_TARGETS };

},{}],153:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictProvider = require('pict-provider');

const THROUGH_PAGE_SIZE = 500;

/**
 * @typedef {object} ThroughFilterConfig
 * @property {string} Through - bridge entity (singular; the route pluralizes it), e.g. 'OrganizationMaterialJoin'.
 * @property {string} ThroughKey - bridge column matched against the live anchor value, e.g. 'IDMaterial'.
 * @property {string} ThroughSelect - bridge column projected into the IN-list, e.g. 'IDOrganization'.
 * @property {string} [FromField] - manifest address of the anchor value (the picked upstream sibling).
 * @property {string} Field - the filtered picker's own column the INN clause targets, e.g. 'IDOrganization'.
 * @property {('map'|'query')} Strategy - 'map' lazy-loads the whole bridge once; 'query' fetches per-anchor slices.
 * @property {string} [ThroughFilter] - extra static bridge scope, ANDed in. No default: soft-deleted rows are
 *   excluded server-side (foxhound adds the predicate for any schema carrying a Deleted column).
 * @property {string} [ThroughProjection] - read projection (default 'Lite').
 */

/**
 * ThroughScopeResolver — generic indirect ("chained") filter resolver. Lets a
 * picker narrow by a relationship that has no direct FK on the filtered entity,
 * by hopping through a bridge table. A DynamicFilters entry of the shape
 * {@link ThroughFilterConfig} narrows `Field` to the `ThroughSelect` values
 * found in `Through` where `ThroughKey` equals the live anchor at `FromField`.
 *
 * Both strategies resolve to a SYNCHRONOUS id-set read at filter-assembly time
 * (Select2Util.applyDynamicFilters is synchronous):
 *
 *   - 'map'   — lazy-load the whole bridge once (per Through+scope), build
 *               Map<ThroughKey → Set<ThroughSelect>> + the union of all selects,
 *               cache. For small bridge tables. Primed on app load for every
 *               map-Through on the loaded form. With no anchor, the union set is
 *               returned (the "only rows that participate at all" relevance case).
 *   - 'query' — fetch only `Through WHERE ThroughKey = anchor` on demand and
 *               cache the slice keyed by the anchor value. For large bridge
 *               tables where a wholesale load is too costly (e.g.
 *               OrganizationMaterialJoin, ~52k rows). Primed by Select2Util's
 *               transport (the async seam) right before the dependent read.
 *
 * Fail-open like SpecScopeResolver: an unloaded slice / empty result returns
 * null, so the dispatch omits the clause and the picker shows its full set
 * (recoverable via Show All regardless).
 *
 * Consumers:
 *   resolver.primeMapScope(filter)             // app load (map only)
 *   resolver.primeThroughSlice(filter, anchor) // transport, await (query only)
 *   resolver.getThroughIDs(filter, anchor)     // sync: Set<number> | null
 */
class ThroughScopeResolver extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		/** @type {Record<string, { Loaded: boolean, LoadPromise: Promise<void>|null, Forward: Map<string, Set<number>>, AllSelects: Set<number> }>} */
		this._MapScopes = {};
		/** @type {Record<string, { Slices: Map<string, Set<number>>, Pending: Map<string, Promise<void>> }>} */
		this._QueryScopes = {};
	}

	/**
	 * Cache key for a Through filter — the bridge entity, the directed key→select
	 * pair, and the static scope. Same for both strategies (a filter only uses one).
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @return {string}
	 */
	_cacheKey(pFilter)
	{
		return `${pFilter.Through}|${pFilter.ThroughKey}>${pFilter.ThroughSelect}|${pFilter.ThroughFilter || ''}`;
	}

	/**
	 * Synchronous allowed-id lookup for a Through filter at an anchor value.
	 * Returns Set<number> when resolved, or null (fail-open) when not yet loaded
	 * or the config is incomplete.
	 *
	 *   - map, no anchor  → union of all selects (relevance: rows that participate).
	 *   - map, anchor     → the anchor's select set (empty Set when the anchor maps to none).
	 *   - query, no anchor→ null (query needs an anchor to have fetched a slice).
	 *   - query, anchor   → the cached slice, or null until primeThroughSlice resolves.
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @param {string|number} pAnchorValue
	 * @return {Set<number>|null}
	 */
	getThroughIDs(pFilter, pAnchorValue)
	{
		if (!pFilter || !pFilter.Through || !pFilter.ThroughKey || !pFilter.ThroughSelect)
		{
			return null;
		}
		const tmpAnchor = (pAnchorValue === null || pAnchorValue === undefined) ? '' : String(pAnchorValue).trim();
		const tmpHasAnchor = (tmpAnchor !== '' && tmpAnchor !== '0');
		if (pFilter.Strategy === 'map')
		{
			const tmpScope = this._MapScopes[this._cacheKey(pFilter)];
			if (!tmpScope || !tmpScope.Loaded)
			{
				return null;
			}
			if (!tmpHasAnchor)
			{
				return tmpScope.AllSelects;
			}
			return tmpScope.Forward.get(tmpAnchor) || new Set();
		}
		// query
		if (!tmpHasAnchor)
		{
			return null;
		}
		const tmpScope = this._QueryScopes[this._cacheKey(pFilter)];
		const tmpSlice = tmpScope ? tmpScope.Slices.get(tmpAnchor) : undefined;
		return tmpSlice || null;
	}

	/**
	 * Ensure the query-strategy slice for (filter, anchor) is loaded + cached.
	 * Idempotent and de-duped per anchor (concurrent calls share one fetch). No-op
	 * for the map strategy (those prime on app load). Awaited by the transport
	 * before the dependent picker reads, so getThroughIDs resolves synchronously.
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @param {string|number} pAnchorValue
	 * @return {Promise<void>}
	 */
	async primeThroughSlice(pFilter, pAnchorValue)
	{
		if (!pFilter || pFilter.Strategy !== 'query' || !pFilter.Through || !pFilter.ThroughKey || !pFilter.ThroughSelect)
		{
			return;
		}
		const tmpAnchor = (pAnchorValue === null || pAnchorValue === undefined) ? '' : String(pAnchorValue).trim();
		if (tmpAnchor === '' || tmpAnchor === '0')
		{
			return;
		}
		const tmpKey = this._cacheKey(pFilter);
		const tmpScope = this._QueryScopes[tmpKey] || (this._QueryScopes[tmpKey] = { Slices: new Map(), Pending: new Map() });
		if (tmpScope.Slices.has(tmpAnchor))
		{
			return;
		}
		if (tmpScope.Pending.has(tmpAnchor))
		{
			return tmpScope.Pending.get(tmpAnchor);
		}
		const tmpPromise = this._loadSlice(pFilter, tmpAnchor)
			.then((pSet) => { tmpScope.Slices.set(tmpAnchor, pSet); })
			.catch((pErr) =>
			{
				this.pict?.log?.warn(`[ThroughScopeResolver] slice load failed ${tmpKey}=${tmpAnchor}: ${pErr?.message || pErr}`);
				tmpScope.Slices.set(tmpAnchor, new Set());
			})
			.finally(() => { tmpScope.Pending.delete(tmpAnchor); });
		tmpScope.Pending.set(tmpAnchor, tmpPromise);
		return tmpPromise;
	}

	/**
	 * @param {ThroughFilterConfig} pFilter
	 * @param {string} pAnchor
	 * @return {Promise<Set<number>>}
	 */
	async _loadSlice(pFilter, pAnchor)
	{
		const tmpRoute = `${pFilter.Through}s/${pFilter.ThroughProjection || 'Lite'}`;
		const tmpClauses = [ `FBV~${pFilter.ThroughKey}~EQ~${encodeURIComponent(pAnchor)}` ];
		if (pFilter.ThroughFilter)
		{
			tmpClauses.unshift(pFilter.ThroughFilter);
		}
		const tmpRows = await this._readAllPages(tmpRoute, tmpClauses.join('~'));
		return new Set(this._distinctPositive(tmpRows.map((pRow) => pRow[pFilter.ThroughSelect])));
	}

	/**
	 * Ensure the map-strategy scope for a filter is fully loaded + indexed. Safe
	 * to call repeatedly; de-dupes via the in-flight LoadPromise.
	 *
	 * @param {ThroughFilterConfig} pFilter
	 * @return {Promise<void>}
	 */
	async primeMapScope(pFilter)
	{
		if (!pFilter || pFilter.Strategy !== 'map' || !pFilter.Through || !pFilter.ThroughKey || !pFilter.ThroughSelect)
		{
			return;
		}
		const tmpKey = this._cacheKey(pFilter);
		const tmpExisting = this._MapScopes[tmpKey];
		if (tmpExisting && tmpExisting.Loaded)
		{
			return;
		}
		if (tmpExisting && tmpExisting.LoadPromise)
		{
			return tmpExisting.LoadPromise;
		}
		const tmpScope = this._MapScopes[tmpKey] = { Loaded: false, LoadPromise: null, Forward: new Map(), AllSelects: new Set() };
		tmpScope.LoadPromise = this._loadMap(pFilter, tmpScope)
			.then(() => { tmpScope.Loaded = true; })
			.catch((pErr) =>
			{
				this.pict?.log?.warn(`[ThroughScopeResolver] map load failed ${tmpKey}: ${pErr?.message || pErr}`);
				tmpScope.Loaded = true;
			});
		return tmpScope.LoadPromise;
	}

	/**
	 * @param {ThroughFilterConfig} pFilter
	 * @param {{ Forward: Map<string, Set<number>>, AllSelects: Set<number> }} pScope
	 * @return {Promise<void>}
	 */
	async _loadMap(pFilter, pScope)
	{
		const tmpRoute = `${pFilter.Through}s/${pFilter.ThroughProjection || 'Lite'}`;
		// Sorted, not merely scoped: this pages the WHOLE bridge, and a paged read with no ORDER BY can
		// repeat or skip rows between pages. It also supplies the filter stanza the paged route requires —
		// meadow-endpoints exposes no bare `s/:Begin/:Cap`.
		const tmpFilter = pFilter.ThroughFilter || `FSF~${pFilter.ThroughKey}~ASC~0`;
		const tmpRows = await this._readAllPages(tmpRoute, tmpFilter);
		for (const tmpRow of tmpRows)
		{
			const tmpKeyVal = (tmpRow[pFilter.ThroughKey] === null || tmpRow[pFilter.ThroughKey] === undefined) ? '' : String(tmpRow[pFilter.ThroughKey]).trim();
			const tmpSelectVal = parseInt(tmpRow[pFilter.ThroughSelect], 10);
			if (tmpKeyVal === '' || !(tmpSelectVal > 0))
			{
				continue;
			}
			let tmpSet = pScope.Forward.get(tmpKeyVal);
			if (!tmpSet)
			{
				tmpSet = new Set();
				pScope.Forward.set(tmpKeyVal, tmpSet);
			}
			tmpSet.add(tmpSelectVal);
			pScope.AllSelects.add(tmpSelectVal);
		}
	}

	/**
	 * App-load hook — prime every map-strategy Through on the loaded form so the
	 * synchronous getThroughIDs resolves on the first render. PictProvider
	 * defaults AutoLoadDataWithApp true, so this participates without host changes.
	 * Failure is non-fatal (fail-open). Query-strategy filters are not primed here
	 * (they load per-anchor in the transport).
	 *
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return super.onAfterLoadDataAsync((pError) =>
		{
			if (pError)
			{
				return fCallback(pError);
			}
			this._primeScopesFromForm().catch((pErr) =>
			{
				this.pict?.log?.warn(`[ThroughScopeResolver] app-load prime failed: ${pErr?.message || pErr}`);
			}).finally(() => fCallback());
		});
	}

	/**
	 * @return {Promise<void>}
	 */
	async _primeMapScopesFromForm()
	{
		const tmpSeen = new Set();
		const tmpMapFilters = [];
		for (const tmpFilter of this._collectThroughFilters())
		{
			if (tmpFilter.Strategy !== 'map')
			{
				continue;
			}
			const tmpKey = this._cacheKey(tmpFilter);
			if (tmpSeen.has(tmpKey))
			{
				continue;
			}
			tmpSeen.add(tmpKey);
			tmpMapFilters.push(tmpFilter);
		}
		await Promise.all(tmpMapFilters.map((pFilter) => this.primeMapScope(pFilter)));
	}

	/**
	 * Prime both map and query scopes for the loaded form.
	 *
	 * @return {Promise<void>}
	 */
	async _primeScopesFromForm()
	{
		await Promise.all([ this._primeMapScopesFromForm(), this._primeQueryScopesFromForm() ]);
	}

	/**
	 * Prime the query-strategy slice for every query-Through filter on the form at
	 * its current anchor value. Called on app load (pre-filled anchors) and via
	 * primeQueryScopesFromForm whenever the cascade changes an anchor.
	 *
	 * @return {Promise<void>}
	 */
	async _primeQueryScopesFromForm()
	{
		const tmpJobs = [];
		for (const tmpFilter of this._collectThroughFilters())
		{
			if (tmpFilter.Strategy !== 'query' || !tmpFilter.FromField)
			{
				continue;
			}
			const tmpAnchor = this.pict.manifest.getValueByHash(this.pict, tmpFilter.FromField);
			tmpJobs.push(this.primeThroughSlice(tmpFilter, tmpAnchor));
		}
		await Promise.all(tmpJobs);
	}

	/**
	 * Public fire-and-forget entry the cascade calls when an anchor changes, so the
	 * dependent picker's query slice is warm before it is opened. Swallows errors.
	 *
	 * @return {Promise<void>}
	 */
	primeQueryScopesFromForm()
	{
		return this._primeQueryScopesFromForm().catch((pErr) =>
		{
			this.pict?.log?.warn(`[ThroughScopeResolver] query prime failed: ${pErr?.message || pErr}`);
		});
	}

	/**
	 * Collect every Through filter entry across the loaded form's descriptors.
	 *
	 * @return {Array<ThroughFilterConfig>}
	 */
	_collectThroughFilters()
	{
		const tmpDescriptors = this.pict?.views?.PictFormMetacontroller?.manifestDescription?.Descriptors;
		const tmpOut = [];
		if (!tmpDescriptors)
		{
			return tmpOut;
		}
		for (const tmpDescriptor of Object.values(tmpDescriptors))
		{
			const tmpFilters = tmpDescriptor?.PictForm?.DynamicFilters;
			if (!Array.isArray(tmpFilters))
			{
				continue;
			}
			for (const tmpFilter of tmpFilters)
			{
				if (tmpFilter && tmpFilter.Through && tmpFilter.ThroughKey && tmpFilter.ThroughSelect)
				{
					tmpOut.push(tmpFilter);
				}
			}
		}
		return tmpOut;
	}

	/**
	 * Page through a filtered meadow read until exhausted. Mirrors
	 * SpecScopeResolver — plain FilteredTo paging so the offline client can serve
	 * from synced entity data.
	 *
	 * @param {string} pEntityRoute - pluralized route incl. projection, e.g. 'OrganizationMaterialJoins/Lite'.
	 * @param {string} pFilter - meadow filter stanza.
	 * @return {Promise<Array<any>>}
	 */
	async _readAllPages(pEntityRoute, pFilter)
	{
		const tmpRows = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpPage = await this._getJSON(`${pEntityRoute}/FilteredTo/${pFilter}/${tmpOffset}/${THROUGH_PAGE_SIZE}`);
			if (!Array.isArray(tmpPage) || tmpPage.length === 0)
			{
				break;
			}
			for (const tmpRow of tmpPage)
			{
				tmpRows.push(tmpRow);
			}
			if (tmpPage.length < THROUGH_PAGE_SIZE)
			{
				break;
			}
			tmpOffset += THROUGH_PAGE_SIZE;
		}
		return tmpRows;
	}

	/**
	 * @param {Array<any>} pValues
	 * @return {Array<number>} distinct positive integers.
	 */
	_distinctPositive(pValues)
	{
		const tmpSet = new Set();
		for (const tmpValue of pValues)
		{
			const tmpNumber = parseInt(tmpValue, 10);
			if (tmpNumber > 0)
			{
				tmpSet.add(tmpNumber);
			}
		}
		return Array.from(tmpSet);
	}

	/**
	 * @param {string} pUrl
	 * @return {Promise<any>}
	 */
	_getJSON(pUrl)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pUrl, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ThroughScopeResolver;

},{"pict-provider":552}],154:[function(require,module,exports){
/**
 * The pristine-emission baseline behind delta emission.
 *
 * The save sweep collects every participating input's `__Record` and sibling join records into a
 * `<Context>.<Entity>.<GUID>` comprehension. Historically that whole collection was emitted, which
 * asserts load-time server state with last-writer-wins semantics — a document edited offline and
 * synced days later re-asserts its load snapshot over everything written in between.
 *
 * The baseline is the same collection, taken once the load transaction has settled: the
 * comprehension the form WOULD emit with no user action. Emission is then the difference between
 * the two, so a save carries what the user changed and nothing else.
 *
 * Capturing it by re-running the sweep — rather than by watching record writes — is what makes it
 * total. Roughly 40% of record mutations are plain property assignment on an object held by
 * reference, several writers are declarative (a trigger-group receiver whose `DataAddress` is
 * inside a `__Record`) and never enter this bundle at all, and some run server-side before the form
 * renders. No interception layer sees those. The sweep sees whatever they left behind, because it
 * reads state rather than observing writers.
 *
 * @module _EntityDataBaseline
 */

const libEntityFieldClassification = require('./_EntityFieldClassification.json');
const libScopedEntityData = require('./_ScopedEntityData.js');
const libSharedEntityRead = require('./_SharedEntityRead.js');

/** Where the baseline rides. Inside FormData so it survives an offline save/reload cycle. */
const FORMDATA_ADDRESS = 'AppData.DocumentData.ReportData.FormData';
/** The FormData key the baseline lives under; the writeback walk must not rewrite its leaves. */
const BASELINE_KEY = '__EntityDataBaseline';
const BASELINE_ADDRESS = libScopedEntityData.ENTITY_DATA_BASELINE_ADDRESS;

/** Columns the database and the meadow layer own; never a user change, never emitted. */
const AUDIT_COLUMNS = new Set(libEntityFieldClassification.AuditColumns || [ ]);

/** The per-entity identity / data column lists, generated from `lib/headlight_model`. */
const ENTITY_COLUMNS = libEntityFieldClassification.Entities || { };

/**
 * The field marking a record for deletion. Tombstones bypass the change test entirely — a delete is
 * an event the form minted deliberately, never something a diff should have to infer.
 */
const DELETED_FIELD = 'Deleted';

/**
 * References an update is refused without, by entity. See `isAlwaysEmittedReference` for how each
 * entry was established; everything not listed here is emitted only when it changed.
 */
const REQUIRED_REFERENCES =
{
	DocumentPolyJoin: [ 'IDDocument' ],
	Document: [ 'IDProject' ],
};

/**
 * A field name meadow reads as a directive rather than a column (`_GUID<Entity>` for an exact GUID
 * reference, `_Dest_` to retarget a foreign key). They are not columns, so the column filter must
 * not drop them, and they are not user data, so the change test must not run over them — they ride
 * along with whatever record they qualify.
 *
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field is a meadow directive.
 */
function isDirectiveField(pFieldName)
{
	return typeof pFieldName === 'string' && (pFieldName.startsWith('_Dest_') || pFieldName.startsWith('_GUID'));
}

/**
 * A reference to ANOTHER entity's row, carried by GUID rather than by id.
 *
 * This is how a comprehension resolves a foreign key to a row that may not exist yet — the applier
 * sorts entities into dependency order by reading exactly these fields, so a `TestInstanceSampleJoin`
 * carrying `GUIDTestInstance`, or a `DocumentPolyJoin` carrying `GUIDSample`, is asserting the join's
 * subject. The model does not list them as columns of the entity they appear on, so they must be
 * recognised by shape or the column filter drops the foreign key and the row lands unattached.
 *
 * @param {string} pEntity - The entity the field appears on.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field points at another entity's row.
 */
function isCrossEntityReferenceField(pEntity, pFieldName)
{
	if (typeof pFieldName !== 'string')
	{
		return false;
	}
	if (pFieldName.indexOf('_Via_GUID') >= 0)
	{
		return true;
	}
	if (isIdentityField(pEntity, pFieldName))
	{
		return false;
	}
	return (/^GUID[A-Z]/).test(pFieldName) || (/^ID[A-Z]/).test(pFieldName);
}

/**
 * The generated column classification for an entity, or null when the model does not know it.
 *
 * @param {string} pEntity - The entity name.
 * @return {{ I: Array<string>, D: Array<string>, N?: Array<string> }|null} - The classification, or null.
 */
function getEntityClassification(pEntity)
{
	const tmpClassification = ENTITY_COLUMNS[pEntity];
	return (tmpClassification && typeof tmpClassification === 'object') ? tmpClassification : null;
}

/**
 * Is this field one of the entity's identity columns (`ID<Entity>` / `GUID<Entity>`)?
 *
 * Identity is carried on every record that survives the delta, because it is what the upsert
 * resolves the row by — it is never itself "a change the user made".
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field identifies the row.
 */
function isIdentityField(pEntity, pFieldName)
{
	const tmpClassification = getEntityClassification(pEntity);
	if (tmpClassification)
	{
		return tmpClassification.I.indexOf(pFieldName) >= 0;
	}
	return pFieldName === `ID${pEntity}` || pFieldName === `GUID${pEntity}`;
}

/**
 * Is this field an audit column?
 *
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the database owns the field.
 */
function isAuditField(pFieldName)
{
	return AUDIT_COLUMNS.has(pFieldName);
}

/**
 * Does this field participate in the change test — a real data column the user could have moved?
 *
 * Identity, audit, directives and `Deleted` are all excluded. So is any field the model does not
 * list as a column of this entity, which is how display-only stamps written onto a persisted join
 * shape (`SampleLineItemJoin.LineItemUnits` is the live case) stay out of both the diff and the
 * payload. An entity the model does not know falls back to "anything not otherwise excluded", so an
 * unmodelled projection target still emits rather than silently emitting nothing.
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field is comparable user data.
 */
function isComparableField(pEntity, pFieldName)
{
	if (typeof pFieldName !== 'string' || pFieldName.length < 1)
	{
		return false;
	}
	if (pFieldName === DELETED_FIELD || isDirectiveField(pFieldName) || isAuditField(pFieldName) || isIdentityField(pEntity, pFieldName))
	{
		return false;
	}
	if (isCrossEntityReferenceField(pEntity, pFieldName))
	{
		return true;
	}
	const tmpClassification = getEntityClassification(pEntity);
	if (!tmpClassification)
	{
		return true;
	}
	return tmpClassification.D.indexOf(pFieldName) >= 0;
}

/**
 * The references a write is refused without, by entity, even when they did not change. Everything
 * else — every other `ID<Entity>` / `GUID<Entity>` — is compared and emitted only when it moved.
 *
 * Both entries were established against QA with
 * `api/headlight/tools/probe-reference-field-requirements.js` (2026-09-23), which drove updates with
 * and without the unchanged references, at level 4 and level 1, over every entity these forms write:
 *
 * - `DocumentPolyJoin.IDDocument` — an update without it is refused, "Document not found, or you do
 *   not have rights to access this document", at both levels. The row's authorization reads it.
 * - `Document.IDProject` — an update is accepted without it; a CREATE is refused, "Cannot verify
 *   project membership: no IDProject was provided". A created record has no baseline and projects
 *   whole anyway, so this entry is belt and braces rather than load-bearing.
 *
 * Every other entity probed (`Sample`, `SampleLineItemJoin`, `SampleLabJoin`, `TestInstance`,
 * `TestInstanceSampleJoin`, `TestInstanceLabJoin`) accepted the update with no references at all.
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the reference must ride every write.
 */
function isAlwaysEmittedReference(pEntity, pFieldName)
{
	if (!isCrossEntityReferenceField(pEntity, pFieldName))
	{
		return false;
	}
	const tmpRequired = REQUIRED_REFERENCES[pEntity];
	return !!tmpRequired && (tmpRequired.indexOf(pFieldName) >= 0);
}

/**
 * Does this field survive into an emitted record at all?
 *
 * Audit columns never do. Everything else does: identity because the upsert needs it, directives
 * because they qualify the identity, and data columns when they changed.
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field may be emitted.
 */
function isEmittableField(pEntity, pFieldName)
{
	if (typeof pFieldName !== 'string' || pFieldName.length < 1)
	{
		return false;
	}
	if (isAuditField(pFieldName))
	{
		return false;
	}
	if (pFieldName === DELETED_FIELD || isDirectiveField(pFieldName) || isIdentityField(pEntity, pFieldName) || isCrossEntityReferenceField(pEntity, pFieldName))
	{
		return true;
	}
	const tmpClassification = getEntityClassification(pEntity);
	if (!tmpClassification)
	{
		return true;
	}
	return tmpClassification.D.indexOf(pFieldName) >= 0;
}

/**
 * Whether a record carries a server-assigned identity, and is therefore server state rather than
 * something this form minted.
 *
 * Only such records may seed the baseline: a freshly synthesized record that has never been saved
 * has no baseline by definition, and treating one as its own baseline would suppress the very
 * emission that creates the row.
 *
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>} pRecord - The record.
 * @return {boolean} - True when the row exists server-side.
 */
function hasServerIdentity(pEntity, pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	const tmpIdentity = pRecord[`ID${pEntity}`];
	if (tmpIdentity === null || typeof tmpIdentity === 'undefined' || tmpIdentity === '')
	{
		return false;
	}
	return Number(tmpIdentity) > 0;
}

/**
 * Is this leaf a tombstone rather than an upsert?
 *
 * @param {Record<string, any>} pRecord - The comprehension leaf.
 * @return {boolean} - True when the record asserts a delete.
 */
function isTombstoneRecord(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	const tmpDeleted = pRecord[DELETED_FIELD];
	return tmpDeleted === 1 || tmpDeleted === '1' || tmpDeleted === true;
}

/**
 * Is this field a numeric data column of the entity?
 *
 * @param {string} pEntity - The entity name.
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the model stores the field as a number.
 */
function isNumericField(pEntity, pFieldName)
{
	const tmpClassification = getEntityClassification(pEntity);
	return !!(tmpClassification && Array.isArray(tmpClassification.N) && tmpClassification.N.indexOf(pFieldName) >= 0);
}

/**
 * Compare two field values the way the wire does.
 *
 * REST hands numerics back as strings often enough that a strict compare would report a change on
 * every reload, so scalars compare loosely; null, undefined and empty string are one state, because
 * the three "empty" spellings move between the marshal, the fetch and the manifest with no user
 * involvement. Objects and arrays compare structurally. A numeric column compares by value when both
 * sides parse as numbers, because a decimal comes back at its column scale (`"1.000"`) while the form
 * holds what was typed (`"1"`).
 *
 * @param {any} pLeft - The baseline value.
 * @param {any} pRight - The current value.
 * @param {string} [pEntity] - The entity the field belongs to.
 * @param {string} [pFieldName] - The field name.
 * @return {boolean} - True when the values differ.
 */
function valuesDiffer(pLeft, pRight, pEntity, pFieldName)
{
	const tmpLeftEmpty = (pLeft === null || typeof pLeft === 'undefined' || pLeft === '');
	const tmpRightEmpty = (pRight === null || typeof pRight === 'undefined' || pRight === '');
	if (tmpLeftEmpty || tmpRightEmpty)
	{
		return tmpLeftEmpty !== tmpRightEmpty;
	}
	if (typeof pLeft === 'object' || typeof pRight === 'object')
	{
		return JSON.stringify(pLeft) !== JSON.stringify(pRight);
	}
	if (pEntity && pFieldName && isNumericField(pEntity, pFieldName))
	{
		const tmpLeftNumber = Number(pLeft);
		const tmpRightNumber = Number(pRight);
		if (Number.isFinite(tmpLeftNumber) && Number.isFinite(tmpRightNumber))
		{
			return tmpLeftNumber !== tmpRightNumber;
		}
	}
	// eslint-disable-next-line eqeqeq
	return pLeft != pRight;
}

/**
 * Reduce one emitted record to the fields that actually changed, plus the identity the upsert needs.
 *
 * A record with no baseline is one the form created, and projects whole — once. After its first
 * save it has a baseline and diffs like any other.
 *
 * A reference is compared like any other column and ships only when it moved, except for the few
 * `REQUIRED_REFERENCES` a write is refused without.
 *
 * A field the baseline carries and the record no longer does is NOT read as a clear. The record
 * builders drop keys constantly as they re-key a row between its GUID and ID forms, and a rebuild
 * that returns a narrower wrapper drops keys it never owned; none of those are a user clearing a
 * value. A value the user actually cleared arrives as an empty value, which does compare as a
 * change.
 *
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>|null} pBaseline - The baseline record, or null when there is none.
 * @param {Record<string, any>} pRecord - The record as the sweep collected it.
 * @return {Record<string, any>|null} - The record to emit, or null when nothing changed.
 */
function computeRecordDelta(pEntity, pBaseline, pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return null;
	}
	// A tombstone the baseline already carries was applied by an earlier save. Re-emitting it sends
	// the applier back to delete a row that is already gone.
	if (isTombstoneRecord(pRecord))
	{
		if (isTombstoneRecord(pBaseline))
		{
			return null;
		}
		return pRecord;
	}
	// The row this GUID named was deleted, so what sits here now is a new row with no history to
	// diff against - it has to project whole, exactly as a never-saved record does.
	const tmpBaseline = isTombstoneRecord(pBaseline) ? null : pBaseline;
	const tmpIdentityFields = { };
	const tmpChangedFields = { };
	let tmpChangedCount = 0;
	for (const tmpField of Object.keys(pRecord))
	{
		if (!isEmittableField(pEntity, tmpField))
		{
			continue;
		}
		if (!isComparableField(pEntity, tmpField))
		{
			tmpIdentityFields[tmpField] = pRecord[tmpField];
			continue;
		}
		const tmpChanged = (!tmpBaseline || valuesDiffer(tmpBaseline[tmpField], pRecord[tmpField], pEntity, tmpField));
		if (isAlwaysEmittedReference(pEntity, tmpField))
		{
			tmpIdentityFields[tmpField] = pRecord[tmpField];
			if (tmpChanged)
			{
				++tmpChangedCount;
			}
			continue;
		}
		if (tmpChanged)
		{
			tmpChangedFields[tmpField] = pRecord[tmpField];
			++tmpChangedCount;
		}
	}
	if (!tmpBaseline)
	{
		return Object.assign(tmpIdentityFields, tmpChangedFields);
	}
	if (tmpChangedCount < 1)
	{
		return null;
	}
	return Object.assign(tmpIdentityFields, tmpChangedFields);
}

/**
 * Strip a record down to what may be stored as a baseline: emittable fields only, so the baseline
 * and the emission are compared on the same terms. Object values (JSON columns) are copied: a
 * baseline sharing the form's live object moves with every edit inside it, so the edit never diffs.
 *
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>} pRecord - The record to reduce.
 * @return {Record<string, any>} - The reduced record.
 */
function reduceRecordForBaseline(pEntity, pRecord)
{
	const tmpReduced = { };
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return tmpReduced;
	}
	for (const tmpField of Object.keys(pRecord))
	{
		if (isEmittableField(pEntity, tmpField))
		{
			const tmpValue = pRecord[tmpField];
			tmpReduced[tmpField] = (tmpValue && typeof tmpValue === 'object') ? JSON.parse(JSON.stringify(tmpValue)) : tmpValue;
		}
	}
	return tmpReduced;
}

/**
 * The stored baseline tree, shaped exactly like the comprehension it is compared against
 * (`<Context>.<Entity>.<GUID>`) so a bad emission can be read against it directly.
 *
 * @param {Object} pPict - The pict instance.
 * @param {boolean} [pCreate] - Create the store when it is absent.
 * @return {Record<string, any>|null} - The store, or null when it does not exist and was not created.
 */
function getBaselineStore(pPict, pCreate)
{
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpStore = pPict.manifest.getValueAtAddress(pPict, BASELINE_ADDRESS);
	if (tmpStore && typeof tmpStore === 'object' && !Array.isArray(tmpStore))
	{
		return tmpStore;
	}
	if (!pCreate || typeof pPict.manifest.setValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpCreated = { };
	pPict.manifest.setValueAtAddress(pPict, BASELINE_ADDRESS, tmpCreated);
	return tmpCreated;
}

/**
 * Read one baseline record.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {Record<string, any>|null} - The baseline record, or null when there is none.
 */
function readBaselineRecord(pPict, pContext, pEntity, pGUID)
{
	const tmpStore = getBaselineStore(pPict, false);
	if (!tmpStore)
	{
		return null;
	}
	const tmpContextNode = tmpStore[pContext];
	if (!tmpContextNode || typeof tmpContextNode !== 'object')
	{
		return null;
	}
	const tmpBucket = tmpContextNode[pEntity];
	if (!tmpBucket || typeof tmpBucket !== 'object')
	{
		return null;
	}
	const tmpRecord = tmpBucket[pGUID];
	return (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord)) ? tmpRecord : null;
}

/**
 * Write one baseline record.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pRecord - The record to store.
 * @return {boolean} - True when the record was stored.
 */
function writeBaselineRecord(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pContext || !pEntity || !pGUID)
	{
		return false;
	}
	const tmpStore = getBaselineStore(pPict, true);
	if (!tmpStore)
	{
		return false;
	}
	if (!tmpStore[pContext] || typeof tmpStore[pContext] !== 'object' || Array.isArray(tmpStore[pContext]))
	{
		tmpStore[pContext] = { };
	}
	if (!tmpStore[pContext][pEntity] || typeof tmpStore[pContext][pEntity] !== 'object' || Array.isArray(tmpStore[pContext][pEntity]))
	{
		tmpStore[pContext][pEntity] = { };
	}
	tmpStore[pContext][pEntity][pGUID] = reduceRecordForBaseline(pEntity, pRecord);
	return true;
}

/**
 * Whether a record has a change staged under a context that the server has not applied yet.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {boolean} - True when a leaf for the record is staged.
 */
function isRecordStaged(pPict, pContext, pEntity, pGUID)
{
	let tmpStaged = libScopedEntityData.resolveDestination(pPict);
	for (const tmpPart of `${pContext}.${pEntity}`.split('.'))
	{
		tmpStaged = (tmpStaged && typeof tmpStaged === 'object') ? tmpStaged[tmpPart] : null;
	}
	return !!(tmpStaged && typeof tmpStaged === 'object' && tmpStaged[pGUID]);
}

/**
 * Seed the baseline from a settled load sweep.
 *
 * Only records carrying a server identity are stored. A record the form synthesized during the load
 * — an init auto-create, a join minted for a row that has none — is not server state; baselining it
 * would suppress the very emission that creates the row.
 *
 * The first capture of a session REPLACES the contexts the sweep produced wholesale, because at that
 * point the sweep is the authority on the server state the form loaded. Contexts it did not touch are
 * left alone. Every render transaction schedules a capture, and the sweep reads the form's live
 * records, so a later one also reads the user's unsaved edits: refreshing an existing entry from it
 * would make the next save drop the edit. Later captures therefore only add records the session has
 * never baselined, and a baselined record moves only with a save's fold.
 *
 * Neither path may baseline a record with a change staged under the context: the form holds that change
 * and the server does not, so it would read as already written and the next save's prune would drop it.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Map<string, Record<string, any>>} pContextRoots - The `<Entity>.<GUID>` roots the sweep filled, by context.
 * @return {number} - How many records were baselined.
 */
function captureBaselineFromSweep(pPict, pContextRoots)
{
	if (!pContextRoots || typeof pContextRoots.forEach !== 'function')
	{
		return 0;
	}
	const tmpStore = getBaselineStore(pPict, true);
	if (!tmpStore)
	{
		return 0;
	}
	const tmpSession = getCaptureSession(pPict, tmpStore);
	if (tmpSession)
	{
		return addUnknownRecordsToBaseline(pPict, tmpSession, pContextRoots);
	}
	let tmpCount = 0;
	let tmpCarriedCount = 0;
	pContextRoots.forEach((pContextRoot, pContext) =>
	{
		const tmpPrevious = (tmpStore[pContext] && typeof tmpStore[pContext] === 'object') ? tmpStore[pContext] : { };
		tmpStore[pContext] = { };
		if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
		{
			return;
		}
		for (const tmpEntity of Object.keys(pContextRoot))
		{
			const tmpBucket = pContextRoot[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!hasServerIdentity(tmpEntity, tmpRecord) || isTombstoneRecord(tmpRecord))
				{
					// The sweep cannot prove this record, so it cannot refresh its baseline - but it must not
					// destroy one either. A `DocumentPolyJoin` or `TestInstanceLabJoin` is never re-fetched, so
					// the post-save fold is the only thing that will ever baseline it; wiping here would make it
					// project whole on every save for the life of the document. Carrying it forward is safe for
					// exactly these records: nothing but this form writes them.
					continue;
				}
				if (isRecordStaged(pPict, pContext, tmpEntity, tmpGUID))
				{
					// Left to the carry-forward below, or to project whole when it has no baseline yet.
					continue;
				}
				if (!tmpStore[pContext][tmpEntity] || typeof tmpStore[pContext][tmpEntity] !== 'object')
				{
					tmpStore[pContext][tmpEntity] = { };
				}
				tmpStore[pContext][tmpEntity][tmpGUID] = reduceRecordForBaseline(tmpEntity, tmpRecord);
				++tmpCount;
			}
		}
		// Absence from the sweep is not evidence of removal: the test-instance triple and the join
		// collections hydrate asynchronously, so a record can simply not have arrived yet. Anything the
		// sweep could not re-derive keeps the baseline it had - a stale entry for a record the form truly
		// dropped is inert, because a record the form no longer holds is never emitted either.
		for (const tmpEntity of Object.keys(tmpPrevious))
		{
			const tmpPreviousBucket = tmpPrevious[tmpEntity];
			if (!tmpPreviousBucket || typeof tmpPreviousBucket !== 'object')
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpPreviousBucket))
			{
				if (tmpStore[pContext][tmpEntity] && tmpStore[pContext][tmpEntity][tmpGUID])
				{
					continue;
				}
				if (!tmpStore[pContext][tmpEntity] || typeof tmpStore[pContext][tmpEntity] !== 'object')
				{
					tmpStore[pContext][tmpEntity] = { };
				}
				tmpStore[pContext][tmpEntity][tmpGUID] = tmpPreviousBucket[tmpGUID];
				++tmpCarriedCount;
			}
		}
	});
	const tmpNewSession = { Store: tmpStore, Known: new Set() };
	markStoredRecordsKnown(tmpNewSession, tmpStore);
	getBaselineAppState(pPict).CaptureSession = tmpNewSession;
	if (pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: capture stored ${tmpCount} record(s) and carried ${tmpCarriedCount} the sweep could not prove.`);
	}
	return tmpCount;
}

/**
 * The key a baseline record is known by within a capture session.
 *
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {string} - The key.
 */
function getBaselineRecordKey(pContext, pEntity, pGUID)
{
	return `${pContext}\n${pEntity}\n${pGUID}`;
}

/**
 * The capture session a first load capture opened on this baseline store, or null when there is none.
 *
 * Keyed on the store object: opening a document, or reopening this one, hands FormData a new store,
 * and the new store's first capture refreshes from the server state that load fetched.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>|null} pStore - The baseline store.
 * @return {{ Store: Record<string, any>, Known: Set<string> }|null} - The session, or null.
 */
function getCaptureSession(pPict, pStore)
{
	const tmpAppState = getBaselineAppState(pPict);
	const tmpSession = tmpAppState ? tmpAppState.CaptureSession : null;
	return (tmpSession && pStore && tmpSession.Store === pStore) ? tmpSession : null;
}

/**
 * Whether a first load capture has already seeded the current baseline store.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when later captures only add records.
 */
function hasCaptureSession(pPict)
{
	return !!getCaptureSession(pPict, getBaselineStore(pPict, false));
}

/**
 * Mark every record the store holds as known to the session.
 *
 * @param {{ Store: Record<string, any>, Known: Set<string> }} pSession - The capture session.
 * @param {Record<string, any>} pStore - The baseline store.
 * @return {void}
 */
function markStoredRecordsKnown(pSession, pStore)
{
	for (const tmpContext of Object.keys(pStore))
	{
		const tmpContextNode = pStore[tmpContext];
		if (!tmpContextNode || typeof tmpContextNode !== 'object' || Array.isArray(tmpContextNode))
		{
			continue;
		}
		for (const tmpEntity of Object.keys(tmpContextNode))
		{
			const tmpBucket = tmpContextNode[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				pSession.Known.add(getBaselineRecordKey(tmpContext, tmpEntity, tmpGUID));
			}
		}
	}
}

/**
 * A capture after the session's first: baseline only records the session has never known, the ones
 * that hydrated late, and leave every known record's baseline where the load or a save put it.
 *
 * A record a save released (a failed PUT clears the store; an unapplied record is dropped) stays known,
 * so it keeps projecting whole instead of being re-seeded from the form's unsaved state.
 *
 * @param {Object} pPict - The pict instance.
 * @param {{ Store: Record<string, any>, Known: Set<string> }} pSession - The capture session.
 * @param {Map<string, Record<string, any>>} pContextRoots - The `<Entity>.<GUID>` roots the sweep filled, by context.
 * @return {number} - How many records were added.
 */
function addUnknownRecordsToBaseline(pPict, pSession, pContextRoots)
{
	markStoredRecordsKnown(pSession, pSession.Store);
	let tmpAdded = 0;
	let tmpKnown = 0;
	pContextRoots.forEach((pContextRoot, pContext) =>
	{
		if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
		{
			return;
		}
		for (const tmpEntity of Object.keys(pContextRoot))
		{
			const tmpBucket = pContextRoot[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!hasServerIdentity(tmpEntity, tmpRecord) || isTombstoneRecord(tmpRecord))
				{
					continue;
				}
				const tmpKey = getBaselineRecordKey(pContext, tmpEntity, tmpGUID);
				if (pSession.Known.has(tmpKey))
				{
					++tmpKnown;
					continue;
				}
				pSession.Known.add(tmpKey);
				if (isRecordStaged(pPict, pContext, tmpEntity, tmpGUID))
				{
					continue;
				}
				writeBaselineRecord(pPict, pContext, tmpEntity, tmpGUID, tmpRecord);
				++tmpAdded;
			}
		}
	});
	if (pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: later capture added ${tmpAdded} record(s) first seen after the load and left ${tmpKnown} known record(s) as the load or a save baselined them.`);
	}
	return tmpAdded;
}

/**
 * Re-baseline named records from what the form holds now, for a path that has just replaced them
 * with a fresh server row (the "out of date" refresh), so the server's own values do not read as a
 * user edit. Only those records move; every other record keeps its baseline, unsaved edits included.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The entity name.
 * @param {Array<string>} pGUIDs - The external GUIDs of the replaced records.
 * @return {number} - How many baseline records were refreshed.
 */
function refreshBaselineRecords(pPict, pEntity, pGUIDs)
{
	if (!pEntity || !Array.isArray(pGUIDs) || pGUIDs.length < 1)
	{
		return 0;
	}
	const tmpContextRoots = runProjectionSweepToScratch(pPict);
	if (!tmpContextRoots)
	{
		return 0;
	}
	const tmpStore = getBaselineStore(pPict, true);
	if (!tmpStore)
	{
		return 0;
	}
	const tmpSession = getCaptureSession(pPict, tmpStore);
	const tmpGUIDs = new Set(pGUIDs);
	let tmpCount = 0;
	tmpContextRoots.forEach((pContextRoot, pContext) =>
	{
		libScopedEntityData.sanitizeContextRoot(pContextRoot);
		const tmpBucket = (pContextRoot && typeof pContextRoot === 'object') ? pContextRoot[pEntity] : null;
		if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
		{
			return;
		}
		for (const tmpGUID of Object.keys(tmpBucket))
		{
			const tmpRecord = tmpBucket[tmpGUID];
			if (!tmpGUIDs.has(tmpGUID) || !hasServerIdentity(pEntity, tmpRecord) || isTombstoneRecord(tmpRecord))
			{
				continue;
			}
			writeBaselineRecord(pPict, pContext, pEntity, tmpGUID, tmpRecord);
			if (tmpSession)
			{
				tmpSession.Known.add(getBaselineRecordKey(pContext, pEntity, tmpGUID));
			}
			++tmpCount;
		}
	});
	if (pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: re-baselined ${tmpCount} ${pEntity} record(s) from a server refresh.`);
	}
	return tmpCount;
}

/**
 * @typedef {Object} RecordRefreshDecision
 * @property {'replace'|'adopt'|'keep'} Action - `replace`: take the row, baseline untouched. `adopt`: take
 *   the row and move `Fields` into the baseline. `keep`: hold on to the form's record.
 * @property {Array<string>} Fields - For `adopt`, the fields that move into the baseline; for `keep`, the fields in conflict.
 * @property {string} Reason - Why, for the log line.
 */

/**
 * Decide how a server row that is about to replace a record the form holds may be taken.
 *
 * Only the load capture that opens a session may set a record's baseline. A later refresh of the same
 * record — the open-time re-fetch landing after another render already captured — would otherwise leave
 * the baseline on the snapshot the document last saved, and every field another actor moved since would
 * ship as a user edit. So the refresh reconciles the baseline itself, but never at the cost of a change
 * the server does not have yet:
 *
 * - a leaf still staged for this record under the context (an offline save, or one armed after a failed
 *   apply) or a newest logged outcome that failed: keep the held record;
 * - a field the row would overwrite where the held value differs from the baseline (an edit not yet
 *   saved): keep the held record;
 * - otherwise adopt the row, and move into the baseline exactly the fields the server moved, plus any
 *   field the form already holds at the server's value (copied in after the capture), which would
 *   otherwise be sent again.
 *
 * A record with no baseline has nothing stale to correct and is replaced as before.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The context the record projects under.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pHeldRecord - The record the form holds now.
 * @param {Record<string, any>} pFetchedRecord - The server row about to replace it.
 * @return {RecordRefreshDecision} - The decision.
 */
function classifyRecordRefresh(pPict, pContext, pEntity, pGUID, pHeldRecord, pFetchedRecord)
{
	/** @type {RecordRefreshDecision} */
	const tmpReplace = { Action: 'replace', Fields: [ ], Reason: 'no baseline to reconcile' };
	if (!pGUID || !pHeldRecord || typeof pHeldRecord !== 'object' || Array.isArray(pHeldRecord) || !pFetchedRecord || typeof pFetchedRecord !== 'object' || Array.isArray(pFetchedRecord))
	{
		return tmpReplace;
	}
	const tmpBaseline = readBaselineRecord(pPict, pContext, pEntity, pGUID);
	if (!tmpBaseline || isTombstoneRecord(tmpBaseline))
	{
		return tmpReplace;
	}
	const tmpDestination = libScopedEntityData.resolveDestination(pPict);
	if (isRecordStaged(pPict, pContext, pEntity, pGUID))
	{
		return { Action: 'keep', Fields: [ ], Reason: `a change is still staged under ${pContext}` };
	}
	const tmpLog = (tmpDestination && Array.isArray(tmpDestination.ExecutionLog)) ? tmpDestination.ExecutionLog : [ ];
	let tmpLatestOutcome = null;
	for (const tmpEntry of tmpLog)
	{
		if (!tmpEntry || typeof tmpEntry !== 'object' || tmpEntry.TriggerKey !== pContext)
		{
			continue;
		}
		const tmpOutcome = readLogEntryOutcomes(tmpEntry).get(`${pEntity} ${pGUID}`);
		if (tmpOutcome)
		{
			tmpLatestOutcome = tmpOutcome;
		}
	}
	if (tmpLatestOutcome && tmpLatestOutcome.Failed)
	{
		return { Action: 'keep', Fields: [ ], Reason: 'the server logged its last save as not applied' };
	}
	const tmpConflicts = [ ];
	const tmpMoved = [ ];
	const tmpAlreadyHeld = [ ];
	for (const tmpField of Object.keys(pFetchedRecord))
	{
		if (!isEmittableField(pEntity, tmpField) || !isComparableField(pEntity, tmpField))
		{
			continue;
		}
		if (!valuesDiffer(pHeldRecord[tmpField], pFetchedRecord[tmpField], pEntity, tmpField))
		{
			if (valuesDiffer(tmpBaseline[tmpField], pFetchedRecord[tmpField], pEntity, tmpField))
			{
				tmpAlreadyHeld.push(tmpField);
			}
			continue;
		}
		if (valuesDiffer(tmpBaseline[tmpField], pHeldRecord[tmpField], pEntity, tmpField))
		{
			tmpConflicts.push(tmpField);
		}
		else
		{
			tmpMoved.push(tmpField);
		}
	}
	if (tmpConflicts.length > 0)
	{
		return { Action: 'keep', Fields: tmpConflicts, Reason: `the row would overwrite unsaved changes to ${tmpConflicts.join(', ')}` };
	}
	const tmpReasons = [ ];
	if (tmpMoved.length > 0)
	{
		tmpReasons.push(`the server moved ${tmpMoved.join(', ')}`);
	}
	if (tmpAlreadyHeld.length > 0)
	{
		tmpReasons.push(`the form already held the server's ${tmpAlreadyHeld.join(', ')}`);
	}
	return { Action: 'adopt', Fields: tmpMoved.concat(tmpAlreadyHeld), Reason: tmpReasons.length > 0 ? tmpReasons.join('; ') : 'the row matches the baseline' };
}

/**
 * Move the named fields of a server row into a record's baseline, leaving every other field as it was.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pFetchedRecord - The server row.
 * @param {Array<string>} pFields - The fields to move.
 * @return {boolean} - True when the baseline changed.
 */
function adoptRefreshedFields(pPict, pContext, pEntity, pGUID, pFetchedRecord, pFields)
{
	const tmpBaseline = readBaselineRecord(pPict, pContext, pEntity, pGUID);
	if (!tmpBaseline || !Array.isArray(pFields) || pFields.length < 1)
	{
		return false;
	}
	const tmpMerged = Object.assign({ }, tmpBaseline);
	for (const tmpField of pFields)
	{
		tmpMerged[tmpField] = pFetchedRecord[tmpField];
	}
	return writeBaselineRecord(pPict, pContext, pEntity, pGUID, tmpMerged);
}

/**
 * Fold a completed save's emission into the baseline, so the next save diffs against what was
 * actually written rather than re-asserting it.
 *
 * Called from `onAfterSaveDataAsync`, which the save waterfall only reaches when every earlier step
 * succeeded — so reaching here is the client's evidence that the document PUT carrying this
 * comprehension went through. That gate is the reason the fold is not done at prune time: advancing
 * the baseline over a save that then failed would make the retry emit nothing and lose the edit.
 *
 * Unlike the load capture this does NOT require a server identity: a record the form just created
 * has none until the document is reloaded, and it is exactly the record that must stop re-emitting
 * in full on every subsequent save.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Map<string, Record<string, any>>} pContextRoots - The emitted `<Entity>.<GUID>` roots, by context.
 * @return {number} - How many records were folded in.
 */
function foldEmissionIntoBaseline(pPict, pContextRoots)
{
	const tmpFolded = [];
	if (!pContextRoots || typeof pContextRoots.forEach !== 'function')
	{
		return 0;
	}
	let tmpCount = 0;
	pContextRoots.forEach((pContextRoot, pContext) =>
	{
		if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
		{
			return;
		}
		for (const tmpEntity of Object.keys(pContextRoot))
		{
			const tmpBucket = pContextRoot[tmpEntity];
			if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
				{
					continue;
				}
				if (isTombstoneRecord(tmpRecord))
				{
					writeBaselineRecord(pPict, pContext, tmpEntity, tmpGUID, reduceRecordForBaseline(tmpEntity, tmpRecord));
				tmpFolded.push(`${pContext}/${tmpEntity}#tombstone`);
				++tmpCount;
				continue;
				}
				const tmpExisting = readBaselineRecord(pPict, pContext, tmpEntity, tmpGUID);
				// A record folded over a tombstone is a re-add at the same GUID, so it replaces rather than
				// merges - carrying the tombstone's fields forward would leave `Deleted` in the baseline.
				const tmpPrior = isTombstoneRecord(tmpExisting) ? { } : (tmpExisting || { });
				const tmpMerged = Object.assign({ }, tmpPrior, reduceRecordForBaseline(tmpEntity, tmpRecord));
				writeBaselineRecord(pPict, pContext, tmpEntity, tmpGUID, tmpMerged);
				tmpFolded.push(`${pContext}/${tmpEntity}`);
				++tmpCount;
			}
		}
	});
	if (pPict && pPict.log && typeof pPict.log.trace === 'function')
	{
		pPict.log.trace(`EntityDataBaseline: folded ${tmpCount} record(s) into the baseline: ${tmpFolded.join(', ') || 'none'}.`);
	}
	return tmpCount;
}

/**
 * Forget one baseline record — a deleted row has no baseline, and a GUID re-added after a tombstone
 * must project whole again rather than diff against the row it replaced.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {boolean} - True when a record was removed.
 */
function dropBaselineRecord(pPict, pContext, pEntity, pGUID)
{
	const tmpStore = getBaselineStore(pPict, false);
	if (!tmpStore || !tmpStore[pContext] || !tmpStore[pContext][pEntity])
	{
		return false;
	}
	if (!Object.prototype.hasOwnProperty.call(tmpStore[pContext][pEntity], pGUID))
	{
		return false;
	}
	delete tmpStore[pContext][pEntity][pGUID];
	return true;
}

/** Where a save's emitted context roots accumulate between the providers and the document PUT. */
const PENDING_EMISSION_MARKER = '_EntityDataPendingEmission';

/**
 * Record a context root this save is going to carry, for the single fold that happens before the PUT.
 *
 * Every provider on the form runs its own sweep and its own prune over the SAME context root, so the
 * fold cannot live in the provider: the first provider to fold would advance the baseline, and the
 * next provider's prune would then find every record unchanged and DELETE it from the root - sending
 * an empty comprehension while the baseline claimed it had been written. The prune is only idempotent
 * across providers while the baseline stays still.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {Record<string, any>} pContextRoot - The pruned `<Entity>.<GUID>` root.
 * @return {void}
 */
function recordPendingEmission(pPict, pContext, pContextRoot)
{
	if (!pPict || typeof pPict !== 'object')
	{
		return;
	}
	if (!pPict[PENDING_EMISSION_MARKER] || typeof pPict[PENDING_EMISSION_MARKER].set !== 'function')
	{
		pPict[PENDING_EMISSION_MARKER] = new Map();
	}
	pPict[PENDING_EMISSION_MARKER].set(pContext, pContextRoot);
}

/**
 * Fold everything this save is carrying into the baseline, once, and forget it.
 *
 * Called from the document save immediately before the PUT: the baseline lives in `FormData` and
 * `FormData` is snapshotted into the PUT body, so folding afterwards leaves the new baseline in memory
 * only and a reload starts from the stale one.
 *
 * @param {Object} pPict - The pict instance.
 * @return {number} - How many records were folded.
 */
function foldPendingEmission(pPict)
{
	const tmpPending = pPict && pPict[PENDING_EMISSION_MARKER];
	if (!tmpPending || typeof tmpPending.forEach !== 'function')
	{
		return 0;
	}
	const tmpCount = foldEmissionIntoBaseline(pPict, tmpPending);
	delete pPict[PENDING_EMISSION_MARKER];
	return tmpCount;
}

/**
 * The context roots this save is carrying, as `[ context, root ]` pairs. Taken before the fold, which
 * forgets them, so the records the PUT sends can still be worked on after the baseline has copied them.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Array<[string, Record<string, any>]>} - The pending roots.
 */
function getPendingEmissionRoots(pPict)
{
	const tmpPending = pPict && pPict[PENDING_EMISSION_MARKER];
	if (!tmpPending || typeof tmpPending.forEach !== 'function')
	{
		return [ ];
	}
	return Array.from(tmpPending.entries());
}

/**
 * @param {any} pValue
 * @return {boolean} - True for a plain object (not null, not an array).
 */
function isPlainObject(pValue)
{
	return !!pValue && typeof pValue === 'object' && !Array.isArray(pValue);
}

/**
 * Lay a form's copy of a JSON column over the server's copy.
 *
 * A form binds only some keys inside a JSON column, and the server stores the column whole, so the
 * form's object alone would drop every key it never loaded. Keys the form holds win, nested objects
 * merge key by key, arrays and scalars replace. A blank, null or missing form value keeps the server's
 * value: a form field the record never filled in reads as empty, which is not the user clearing it.
 *
 * @param {Record<string, any>} pServerValue - The column as the server holds it.
 * @param {Record<string, any>} pFormValue - The column as the form holds it.
 * @return {Record<string, any>} - A new merged object; neither input is changed.
 */
function mergeObjectOverServer(pServerValue, pFormValue)
{
	const tmpMerged = isPlainObject(pServerValue) ? JSON.parse(JSON.stringify(pServerValue)) : { };
	if (!isPlainObject(pFormValue))
	{
		return tmpMerged;
	}
	for (const tmpKey of Object.keys(pFormValue))
	{
		const tmpValue = pFormValue[tmpKey];
		if (tmpValue === null || typeof tmpValue === 'undefined' || tmpValue === '')
		{
			continue;
		}
		if (isPlainObject(tmpValue))
		{
			tmpMerged[tmpKey] = mergeObjectOverServer(tmpMerged[tmpKey], tmpValue);
			continue;
		}
		tmpMerged[tmpKey] = (typeof tmpValue === 'object') ? JSON.parse(JSON.stringify(tmpValue)) : tmpValue;
	}
	return tmpMerged;
}

/**
 * Read the one server row a held record names, by id when it has one, otherwise by GUID.
 *
 * @param {Object} pPict - The pict instance (owns HeadlightRestClient).
 * @param {string} pEntity - The entity name.
 * @param {Record<string, any>} pRecord - The emitted record.
 * @param {(pError: any, pRow: ?Record<string, any>) => void} fCallback - The row, or null when the server has none.
 */
function readServerRow(pPict, pEntity, pRecord, fCallback)
{
	const tmpID = Number(pRecord[`ID${pEntity}`]);
	if (tmpID > 0)
	{
		return libSharedEntityRead.readJSON(pPict, `${pEntity}/${tmpID}`, { ReuseResult: false }, (pError, pRow) =>
		{
			if (pError)
			{
				return fCallback(pError, null);
			}
			return fCallback(null, (isPlainObject(pRow) && Number(pRow[`ID${pEntity}`]) > 0) ? pRow : null);
		});
	}
	const tmpGUID = pRecord[`GUID${pEntity}`];
	if (libSharedEntityRead.isEmptyIdentityValue(`GUID${pEntity}`, tmpGUID))
	{
		return fCallback(null, null);
	}
	libSharedEntityRead.readJSON(pPict, `${pEntity}s/FilteredTo/FBV~GUID${pEntity}~EQ~${encodeURIComponent(tmpGUID)}/0/2`, { ReuseResult: false }, (pError, pRows) =>
	{
		if (pError)
		{
			return fCallback(pError, null);
		}
		return fCallback(null, (Array.isArray(pRows) && pRows.length === 1) ? pRows[0] : null);
	});
}

/**
 * Before the PUT, merge every JSON-object field the save carries over the server's copy of it, so a
 * form that binds only part of a column cannot drop the rest. Runs after the fold: the baseline keeps
 * the form's own view, which is what the next save's prune compares against.
 *
 * A record the server does not have yet goes as the form built it. When the server copy cannot be
 * read, the object field is left out of this save and the record's baseline dropped, so the next save
 * sends it again rather than either losing the edit or sending a partial column.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Array<[string, Record<string, any>]>} pRoots - The roots `getPendingEmissionRoots` returned.
 * @param {(pCounts: { Merged: number, Withheld: number }) => void} fDone - Called once with what happened.
 */
function mergePendingObjectFieldsWithServer(pPict, pRoots, fDone)
{
	const tmpCounts = { Merged: 0, Withheld: 0 };
	const tmpTasks = [ ];
	for (const [ tmpContext, tmpContextRoot ] of (pRoots || [ ]))
	{
		if (!isPlainObject(tmpContextRoot))
		{
			continue;
		}
		for (const tmpEntity of Object.keys(tmpContextRoot))
		{
			const tmpBucket = tmpContextRoot[tmpEntity];
			if (!isPlainObject(tmpBucket))
			{
				continue;
			}
			for (const tmpGUID of Object.keys(tmpBucket))
			{
				const tmpRecord = tmpBucket[tmpGUID];
				if (!isPlainObject(tmpRecord) || isTombstoneRecord(tmpRecord))
				{
					continue;
				}
				const tmpObjectFields = Object.keys(tmpRecord).filter((pField) => isPlainObject(tmpRecord[pField]));
				if (tmpObjectFields.length < 1)
				{
					continue;
				}
				tmpTasks.push((fNext) =>
				{
					readServerRow(pPict, tmpEntity, tmpRecord, (pError, pRow) =>
					{
						if (pError)
						{
							for (const tmpField of tmpObjectFields)
							{
								delete tmpRecord[tmpField];
							}
							dropBaselineRecord(pPict, tmpContext, tmpEntity, tmpGUID);
							++tmpCounts.Withheld;
							if (pPict && pPict.log && typeof pPict.log.warn === 'function')
							{
								pPict.log.warn(`EntityDataBaseline: could not read ${tmpEntity}/${tmpGUID} to merge ${tmpObjectFields.join(', ')}; left out of this save, sent again on the next.`);
							}
							return fNext();
						}
						if (!pRow)
						{
							return fNext();
						}
						for (const tmpField of tmpObjectFields)
						{
							let tmpServerValue = pRow[tmpField];
							if (typeof tmpServerValue === 'string')
							{
								try
								{
									tmpServerValue = JSON.parse(tmpServerValue);
								}
								catch (pParseError)
								{
									tmpServerValue = null;
								}
							}
							tmpRecord[tmpField] = mergeObjectOverServer(tmpServerValue, tmpRecord[tmpField]);
						}
						++tmpCounts.Merged;
						return fNext();
					});
				});
			}
		}
	}
	runTasksWithConcurrency(tmpTasks, 4, () => fDone(tmpCounts));
}

/**
 * Discard the whole baseline.
 *
 * Used when a save fails. The baseline is folded forward BEFORE the PUT so it rides the same payload
 * as the comprehension it describes; if that PUT does not land, the baseline is claiming records were
 * written that may not have been. Clearing makes the retry project everything whole, which is the safe
 * direction - over-emitting costs a redundant upsert, under-emitting loses the record.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when a baseline was present and has been cleared.
 */
function clearBaseline(pPict)
{
	const tmpStore = getBaselineStore(pPict, false);
	if (!tmpStore)
	{
		return false;
	}
	for (const tmpContext of Object.keys(tmpStore))
	{
		delete tmpStore[tmpContext];
	}
	return true;
}

/**
 * Whether a baseline has been captured at all on this document.
 *
 * Until it has, every record projects whole — which is the pre-delta behaviour, and the correct
 * fallback: a missing baseline must never be read as "nothing changed".
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when a baseline exists.
 */
function hasBaseline(pPict)
{
	const tmpStore = getBaselineStore(pPict, false);
	return !!(tmpStore && Object.keys(tmpStore).length > 0);
}

/**
 * Narrow one context root from a state assertion to a change record.
 *
 * The sweep has just keyed every participating input's whole record into `pContextRoot`. This is the
 * one place that decides what actually ships, and it is the right place because it already walks
 * every projected leaf and because the decision needs the record, not the writer — sibling inputs
 * write into each other's records constantly, so dirtiness is a property of the fields, not of the
 * owning input's own events.
 *
 * Per leaf: sanitize as before, then diff against the baseline the settled load sweep captured.
 * Unchanged records are removed from the tree entirely, which is what makes an untouched save emit
 * an empty comprehension. Records with no baseline — ones this form created — project whole.
 * Tombstones pass through untouched; a delete is a minted event, not an inferred one.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The context this root hangs under.
 * @param {Record<string, any>} pContextRoot - The context root to narrow in place.
 * @return {{ Emitted: number, Suppressed: number }} - How many records shipped and how many were dropped.
 */
function pruneContextRootToDelta(pPict, pContext, pContextRoot)
{
	const tmpCounts = { Emitted: 0, Suppressed: 0 };
	const tmpEmittedDetail = [];
	if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
	{
		if (pPict && pPict.log && typeof pPict.log.trace === 'function')
		{
		pPict.log.trace(`EntityDataBaseline: ${pContext} emitting ${tmpCounts.Emitted}, suppressed ${tmpCounts.Suppressed} — ${tmpEmittedDetail.join(', ') || 'nothing'}.`);
		}
		return tmpCounts;
	}
	for (const tmpEntity of Object.keys(pContextRoot))
	{
		const tmpBucket = pContextRoot[tmpEntity];
		if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
		{
			continue;
		}
		for (const tmpGUID of Object.keys(tmpBucket))
		{
			const tmpRecord = tmpBucket[tmpGUID];
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			const tmpSanitized = libScopedEntityData.sanitizeRecord(tmpRecord);
			const tmpUnemittableReason = libScopedEntityData.getUnemittableReason(tmpEntity, tmpGUID, tmpSanitized);
			if (tmpUnemittableReason)
			{
				delete tmpBucket[tmpGUID];
				const tmpMessage = `EntityDataBaseline: dropped ${pContext}.${tmpEntity}.${tmpGUID} from the save because ${tmpUnemittableReason}.`;
				if (pPict && pPict.log && typeof pPict.log.warn === 'function')
				{
					pPict.log.warn(tmpMessage);
				}
				else
				{
					console.warn(tmpMessage);
				}
				continue;
			}
			const tmpBaseline = readBaselineRecord(pPict, pContext, tmpEntity, tmpGUID);
			const tmpDelta = computeRecordDelta(tmpEntity, tmpBaseline, tmpSanitized);
			if (!tmpDelta)
			{
				delete tmpBucket[tmpGUID];
				++tmpCounts.Suppressed;
				continue;
			}
			tmpEmittedDetail.push(`${tmpEntity}${tmpBaseline ? '(changed)' : '(NO BASELINE)'}`);
			tmpBucket[tmpGUID] = tmpDelta;
			++tmpCounts.Emitted;
		}
		if (Object.keys(tmpBucket).length < 1)
		{
			delete pContextRoot[tmpEntity];
		}
	}
	return tmpCounts;
}

/**
 * The sweep event both input families answer by projecting their records. The address half is
 * legacy-ledger vestige on the scoped path — the projectors resolve their own destination — but the
 * event string is matched whole by several subclasses, so it is reproduced verbatim.
 */
const PROJECTION_SWEEP_EVENT = 'ProjectEntityDataRecords:AppData.DocumentData.ReportData.FormData._EntityData';

/** The AppData key the baseline's session state lives under: beside `DocumentData`, so the document save never carries it. */
const APP_STATE_KEY = 'EntityDataBaseline';

/**
 * The baseline's session state: the capture session, and the render transactions a load-settled
 * capture is already scheduled on (so N inputs schedule one).
 *
 * @param {Object} pPict - The pict instance.
 * @return {{ CaptureSession: ?{ Store: Record<string, any>, Known: Set<string> }, ScheduledTransactions: Record<string, boolean> }|null} - The state, or null without a pict.
 */
function getBaselineAppState(pPict)
{
	if (!pPict || typeof pPict !== 'object')
	{
		return null;
	}
	if (!pPict.AppData || typeof pPict.AppData !== 'object')
	{
		pPict.AppData = { };
	}
	const tmpState = pPict.AppData[APP_STATE_KEY];
	if (!tmpState || typeof tmpState !== 'object')
	{
		pPict.AppData[APP_STATE_KEY] = { CaptureSession: null, ScheduledTransactions: { } };
	}
	return pPict.AppData[APP_STATE_KEY];
}

/**
 * Run the save-time projection sweep into a scratch tree and hand back what it collected, without
 * touching the document's own EntityData.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Map<string, Record<string, any>>|null} - The `<Entity>.<GUID>` roots by context, or null when the sweep could not run.
 */
function runProjectionSweepToScratch(pPict)
{
	const tmpMetacontroller = pPict && pPict.views && pPict.views.PictFormMetacontroller;
	if (!tmpMetacontroller || typeof tmpMetacontroller.triggerGlobalInputEvent !== 'function')
	{
		return null;
	}
	let tmpContextRoots = null;
	libScopedEntityData.beginBaselineSweep(pPict);
	try
	{
		const tmpTransactionGUID = (typeof pPict.getUUID === 'function') ? pPict.getUUID() : `baseline-${Date.now()}`;
		if (pPict.TransactionTracking && typeof pPict.TransactionTracking.registerTransaction === 'function')
		{
			pPict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		tmpMetacontroller.triggerGlobalInputEvent(PROJECTION_SWEEP_EVENT, tmpTransactionGUID);
		if (typeof tmpMetacontroller.finalizeTransaction === 'function')
		{
			tmpMetacontroller.finalizeTransaction(tmpTransactionGUID);
		}
	}
	finally
	{
		// The sweep is synchronous for every projector in the family: each reads records already in
		// FormData and keys them into the target. Ending the redirect in `finally` guarantees the
		// document's own EntityData is never left shadowed if one of them throws.
		tmpContextRoots = libScopedEntityData.endBaselineSweep(pPict);
	}
	return tmpContextRoots || null;
}

/** How deep the identity writeback will walk FormData before giving up. */
const IDENTITY_WALK_MAX_DEPTH = 14;

/**
 * Write the row ids the server resolved back onto the records this form holds.
 *
 * The client mints GUIDs and the server resolves them to rows, so until the ids come back the form
 * has no way to know its records exist - which is what `hasServerIdentity` asks before a record may
 * seed a baseline. Without this the gate can never pass for a record the form minted and nothing
 * re-fetches, so it re-emits whole on every save forever.
 *
 * Walks `FormData` rather than re-running the projection sweep: the sweep is an event round-trip
 * through the metacontroller, and this runs inside the save lifecycle where a nested transaction is
 * not guaranteed to resolve. A record is matched on its own `GUID<Entity>`, so nesting and array
 * position do not matter, and an id already present is left alone.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, Record<string, number>>} pIdentities - Entity -> external GUID -> row id.
 * @return {number} - How many records learned their id.
 */
function applyResolvedIdentities(pPict, pIdentities)
{
	if (!pIdentities || typeof pIdentities !== 'object' || Array.isArray(pIdentities))
	{
		return 0;
	}
	const tmpEntities = Object.keys(pIdentities);
	if (tmpEntities.length < 1)
	{
		return 0;
	}
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function')
	{
		return 0;
	}
	const tmpFormData = pPict.manifest.getValueAtAddress(pPict, FORMDATA_ADDRESS);
	if (!tmpFormData || typeof tmpFormData !== 'object')
	{
		return 0;
	}

	let tmpCount = 0;
	const tmpSeen = new Set();
	const tmpStack = [ { Node: tmpFormData, Depth: 0 } ];
	while (tmpStack.length > 0)
	{
		const tmpFrame = tmpStack.pop();
		const tmpNode = tmpFrame.Node;
		if (!tmpNode || typeof tmpNode !== 'object' || tmpSeen.has(tmpNode) || tmpFrame.Depth > IDENTITY_WALK_MAX_DEPTH)
		{
			continue;
		}
		tmpSeen.add(tmpNode);

		if (!Array.isArray(tmpNode))
		{
			// A record carries a GUID for itself AND for everything it references - a DocumentPolyJoin
			// holds both `GUIDDocumentPolyJoin` and `GUIDSample`. Its own entity is the most specific
			// name it matches, because a join's name contains the names of what it joins; writing the
			// others would put a foreign id on the record and emit it as a column the table lacks.
			let tmpOwnEntity = null;
			let tmpOwnIdentity = 0;
			for (const tmpEntity of tmpEntities)
			{
				const tmpGUID = tmpNode[`GUID${tmpEntity}`];
				if (typeof tmpGUID !== 'string' || tmpGUID.length < 1)
				{
					continue;
				}
				const tmpIdentity = Number(pIdentities[tmpEntity][tmpGUID]);
				if (!(tmpIdentity > 0))
				{
					continue;
				}
				if (!tmpOwnEntity || tmpEntity.length > tmpOwnEntity.length)
				{
					tmpOwnEntity = tmpEntity;
					tmpOwnIdentity = tmpIdentity;
				}
			}
			if (tmpOwnEntity && !hasServerIdentity(tmpOwnEntity, tmpNode))
			{
				tmpNode[`ID${tmpOwnEntity}`] = tmpOwnIdentity;
				++tmpCount;
			}
		}

		for (const tmpKey of Object.keys(tmpNode))
		{
			// The baseline is a record store of its own; rewriting its leaves would change what the
			// next emission diffs against.
			if (tmpKey === BASELINE_KEY)
			{
				continue;
			}
			const tmpChild = tmpNode[tmpKey];
			if (tmpChild && typeof tmpChild === 'object')
			{
				tmpStack.push({ Node: tmpChild, Depth: tmpFrame.Depth + 1 });
			}
		}
	}
	return tmpCount;
}

/** How many held-identity reads are in flight at once. */
const HELD_IDENTITY_READ_CONCURRENCY = 4;

/** Keys a held-record walk never descends into: the legacy ledger and the baseline store. */
const HELD_RECORD_SKIPPED_KEYS = new Set([ '_EntityData', BASELINE_KEY ]);

/** The join whose table's unique key (document, remote type, remote row) makes a natural-key match unambiguous. */
const DOCUMENT_JOIN_ENTITY = 'DocumentPolyJoin';

/** Remote types a held document join may be matched to a live join by. */
const DOCUMENT_JOIN_NATURAL_KEY_TYPES = new Set([ 'Sample', 'TestInstance' ]);

/** The join whose table's unique key (TestInstance, Lab) makes a natural-key match unambiguous. */
const LAB_JOIN_ENTITY = 'TestInstanceLabJoin';

/**
 * Whether the document is frozen: rendered read-only, or locked. A frozen document keeps its saved
 * snapshot, so nothing may refresh or rewrite the records it holds.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when the document is not interactive or is locked.
 */
function isDocumentFrozen(pPict)
{
	const tmpAppData = pPict && pPict.AppData;
	if (!tmpAppData || !tmpAppData.Interactive)
	{
		return true;
	}
	const tmpDocument = tmpAppData.DocumentData && tmpAppData.DocumentData.ReportData;
	return !!(tmpDocument && tmpDocument.Locked);
}

/**
 * Whether saves go to the device's local store rather than the server, so server reads do not apply.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True on the local offline transport.
 */
function isLocalDocumentTransport(pPict)
{
	const tmpService = pPict && pPict.services && pPict.services.HeadlightDocumentService;
	return !!(tmpService && typeof tmpService.isLocalDocumentTransport === 'function' && tmpService.isLocalDocumentTransport());
}

/**
 * Every entity record the form holds in FormData, outside the legacy ledger and the baseline store,
 * each tagged with the entity it names itself as.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Array<{ Entity: string, Record: Record<string, any> }>} - The held records.
 */
function collectHeldRecords(pPict)
{
	const tmpHeld = [ ];
	const tmpFormData = pPict.manifest.getValueAtAddress(pPict, FORMDATA_ADDRESS);
	const tmpSeen = new Set();
	const tmpStack = [ { Node: tmpFormData, Depth: 0 } ];
	while (tmpStack.length > 0)
	{
		const tmpFrame = tmpStack.pop();
		const tmpNode = tmpFrame.Node;
		if (!tmpNode || typeof tmpNode !== 'object' || tmpSeen.has(tmpNode) || tmpFrame.Depth > IDENTITY_WALK_MAX_DEPTH)
		{
			continue;
		}
		tmpSeen.add(tmpNode);
		if (!Array.isArray(tmpNode))
		{
			const tmpEntity = libScopedEntityData.resolveRecordEntity(tmpNode);
			if (tmpEntity)
			{
				tmpHeld.push({ Entity: tmpEntity, Record: tmpNode });
			}
		}
		for (const tmpKey of Object.keys(tmpNode))
		{
			if (HELD_RECORD_SKIPPED_KEYS.has(tmpKey))
			{
				continue;
			}
			const tmpChild = tmpNode[tmpKey];
			if (tmpChild && typeof tmpChild === 'object')
			{
				tmpStack.push({ Node: tmpChild, Depth: tmpFrame.Depth + 1 });
			}
		}
	}
	return tmpHeld;
}

/**
 * Run callback-style tasks with at most `pLimit` in flight, then call `fDone` exactly once.
 *
 * @param {Array<(fNext: () => void) => void>} pTasks - The tasks.
 * @param {number} pLimit - The concurrency cap.
 * @param {() => void} fDone - Called once every task has settled.
 */
function runTasksWithConcurrency(pTasks, pLimit, fDone)
{
	if (pTasks.length < 1)
	{
		return fDone();
	}
	let tmpNext = 0;
	let tmpFinished = 0;
	const fLaunch = () =>
	{
		if (tmpNext >= pTasks.length)
		{
			return;
		}
		const tmpTask = pTasks[tmpNext++];
		let tmpSettled = false;
		const fSettle = () =>
		{
			if (tmpSettled)
			{
				return;
			}
			tmpSettled = true;
			tmpFinished++;
			if (tmpFinished === pTasks.length)
			{
				return fDone();
			}
			fLaunch();
		};
		try
		{
			tmpTask(fSettle);
		}
		catch (pError)
		{
			fSettle();
		}
	};
	for (let i = 0; i < Math.min(pLimit, pTasks.length); i++)
	{
		fLaunch();
	}
}

/**
 * The id of the one live row carrying a GUID, or 0 when the read failed, found nothing, or was ambiguous.
 * Render transactions settle together, so identical reads share one request (`_SharedEntityRead`).
 *
 * @param {Object} pPict - The pict instance (owns HeadlightRestClient).
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The external GUID.
 * @param {(pID: number) => void} fCallback - Called once with the id or 0.
 */
function readLiveRowID(pPict, pEntity, pGUID, fCallback)
{
	if (libSharedEntityRead.isEmptyIdentityValue(`GUID${pEntity}`, pGUID))
	{
		return fCallback(0);
	}
	libSharedEntityRead.readJSON(pPict, `${pEntity}s/FilteredTo/FBV~GUID${pEntity}~EQ~${encodeURIComponent(pGUID)}/0/2`, { ReuseResult: false }, (pError, pRows) =>
	{
		if (pError || !Array.isArray(pRows) || pRows.length !== 1)
		{
			return fCallback(0);
		}
		const tmpID = Number(pRows[0] && pRows[0][`ID${pEntity}`]);
		return fCallback(tmpID > 0 ? tmpID : 0);
	});
}

/**
 * Stamp resolved row ids onto the held records they belong to, matching each record on its OWN entity.
 *
 * A join carries the GUIDs of what it joins beside its own, so matching on any `GUID<X>` would put a
 * foreign id on it; `resolveRecordEntity` names the one entity the record is.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, Record<string, number>>} pResolved - Entity -> GUID -> row id.
 * @return {number} - How many records learned their id.
 */
function stampHeldIdentities(pPict, pResolved)
{
	let tmpCount = 0;
	for (const tmpItem of collectHeldRecords(pPict))
	{
		const tmpBucket = pResolved[tmpItem.Entity];
		const tmpGUID = tmpItem.Record[`GUID${tmpItem.Entity}`];
		if (!tmpBucket || typeof tmpGUID !== 'string' || !(tmpBucket[tmpGUID] > 0) || hasServerIdentity(tmpItem.Entity, tmpItem.Record))
		{
			continue;
		}
		tmpItem.Record[`ID${tmpItem.Entity}`] = tmpBucket[tmpGUID];
		++tmpCount;
	}
	return tmpCount;
}

/**
 * Point every held record carrying `pFromGUID` at a different row: its GUID and its id.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The entity name.
 * @param {string} pFromGUID - The GUID the held records carry now.
 * @param {string} pToGUID - The live row's GUID.
 * @param {number} pToID - The live row's id.
 * @return {number} - How many held records were rewritten.
 */
function rewriteHeldRecordIdentity(pPict, pEntity, pFromGUID, pToGUID, pToID)
{
	const tmpGUIDField = `GUID${pEntity}`;
	let tmpCount = 0;
	for (const tmpItem of collectHeldRecords(pPict))
	{
		if (tmpItem.Entity === pEntity && tmpItem.Record[tmpGUIDField] === pFromGUID)
		{
			tmpItem.Record[tmpGUIDField] = pToGUID;
			tmpItem.Record[`ID${pEntity}`] = pToID;
			++tmpCount;
		}
	}
	return tmpCount;
}

/**
 * Point held document joins whose own GUID names no row at the live join for the same document,
 * remote type and remote row. That triple is the table's unique key, so the match is the only one
 * possible; a remote row the form cannot resolve to an id, or a live join another held record already
 * carries, is left alone.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pRestClient - The REST client.
 * @param {Array<Record<string, any>>} pUnresolved - Held document joins with no live row under their GUID.
 * @param {Record<string, Record<string, number>>} pKnownIdentities - Entity -> GUID -> row id, to resolve a join's remote row.
 * @param {(pAdopted: number) => void} fCallback - Called once with how many joins were adopted.
 */
function adoptDocumentJoinsByNaturalKey(pPict, pRestClient, pUnresolved, pKnownIdentities, fCallback)
{
	const tmpDocument = pPict.AppData && pPict.AppData.DocumentData && pPict.AppData.DocumentData.ReportData;
	const tmpIDDocument = Number(tmpDocument && tmpDocument.IDDocument);
	const tmpCandidates = [ ];
	for (const tmpRecord of pUnresolved)
	{
		if (!tmpRecord || !DOCUMENT_JOIN_NATURAL_KEY_TYPES.has(tmpRecord.RemoteType))
		{
			continue;
		}
		let tmpIDRemote = Number(tmpRecord.IDRemote);
		if (!(tmpIDRemote > 0))
		{
			const tmpRemoteGUID = tmpRecord[`GUID${tmpRecord.RemoteType}`];
			const tmpKnown = pKnownIdentities[tmpRecord.RemoteType];
			tmpIDRemote = (tmpKnown && typeof tmpRemoteGUID === 'string') ? Number(tmpKnown[tmpRemoteGUID]) : 0;
		}
		if (tmpIDRemote > 0)
		{
			tmpCandidates.push({ GUID: tmpRecord[`GUID${DOCUMENT_JOIN_ENTITY}`], Key: `${tmpRecord.RemoteType}:${tmpIDRemote}` });
		}
	}
	if (!(tmpIDDocument > 0) || tmpCandidates.length < 1)
	{
		return fCallback(0);
	}
	const fSafeCallback = (pAdopted) =>
	{
		fCallback(pAdopted);
	};
	try
	{
		pRestClient.getJSON(`${DOCUMENT_JOIN_ENTITY}s/FilteredTo/FBV~IDDocument~EQ~${tmpIDDocument}/0/500`, (pError, pRows) =>
		{
			let tmpAdopted = 0;
			try
			{
				if (pError || !Array.isArray(pRows))
				{
					return;
				}
				const tmpLiveByKey = new Map();
				for (const tmpRow of pRows)
				{
					if (!tmpRow || !(Number(tmpRow.IDDocumentPolyJoin) > 0) || typeof tmpRow.GUIDDocumentPolyJoin !== 'string')
					{
						continue;
					}
					const tmpKey = `${tmpRow.RemoteType}:${Number(tmpRow.IDRemote)}`;
					tmpLiveByKey.set(tmpKey, tmpLiveByKey.has(tmpKey) ? null : tmpRow);
				}
				const tmpHeldGUIDs = new Set(collectHeldRecords(pPict)
					.filter((pItem) => pItem.Entity === DOCUMENT_JOIN_ENTITY)
					.map((pItem) => pItem.Record[`GUID${DOCUMENT_JOIN_ENTITY}`]));
				for (const tmpCandidate of tmpCandidates)
				{
					const tmpRow = tmpLiveByKey.get(tmpCandidate.Key);
					if (!tmpRow || tmpHeldGUIDs.has(tmpRow.GUIDDocumentPolyJoin))
					{
						continue;
					}
					tmpHeldGUIDs.add(tmpRow.GUIDDocumentPolyJoin);
					if (rewriteHeldRecordIdentity(pPict, DOCUMENT_JOIN_ENTITY, tmpCandidate.GUID, tmpRow.GUIDDocumentPolyJoin, Number(tmpRow.IDDocumentPolyJoin)) > 0)
					{
						++tmpAdopted;
					}
				}
			}
			finally
			{
				fSafeCallback(tmpAdopted);
			}
		});
	}
	catch (pError)
	{
		fSafeCallback(0);
	}
}

/**
 * Point held TestInstance lab joins whose own GUID names no row at the live lab join for the same
 * TestInstance and Lab. That pair is the table's unique key, so the match is the only one possible; a
 * TestInstance the form cannot resolve to an id, a live join another held record already carries, or a
 * pair with more than one live row is left alone.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pRestClient - The REST client.
 * @param {Array<Record<string, any>>} pUnresolved - Held lab joins with no live row under their GUID.
 * @param {Record<string, Record<string, number>>} pKnownIdentities - Entity -> GUID -> row id, to resolve a join's TestInstance.
 * @param {(pAdopted: number) => void} fCallback - Called once with how many lab joins were adopted.
 */
function adoptLabJoinsByNaturalKey(pPict, pRestClient, pUnresolved, pKnownIdentities, fCallback)
{
	const tmpKnownTestInstances = pKnownIdentities.TestInstance || { };
	const tmpCandidates = [ ];
	for (const tmpRecord of pUnresolved)
	{
		if (!tmpRecord)
		{
			continue;
		}
		let tmpIDTestInstance = Number(tmpRecord.IDTestInstance);
		if (!(tmpIDTestInstance > 0) && typeof tmpRecord.GUIDTestInstance === 'string')
		{
			tmpIDTestInstance = Number(tmpKnownTestInstances[tmpRecord.GUIDTestInstance]);
		}
		const tmpIDLab = Number(tmpRecord.IDLab);
		if (tmpIDTestInstance > 0 && tmpIDLab > 0)
		{
			tmpCandidates.push({ GUID: tmpRecord[`GUID${LAB_JOIN_ENTITY}`], Key: `${tmpIDTestInstance}:${tmpIDLab}`, IDTestInstance: tmpIDTestInstance });
		}
	}
	if (tmpCandidates.length < 1)
	{
		return fCallback(0);
	}
	let tmpCalled = false;
	const fSafeCallback = (pAdopted) =>
	{
		if (tmpCalled)
		{
			return;
		}
		tmpCalled = true;
		fCallback(pAdopted);
	};
	const tmpIDTestInstances = [ ...new Set(tmpCandidates.map((pCandidate) => pCandidate.IDTestInstance)) ];
	try
	{
		pRestClient.getJSON(`${LAB_JOIN_ENTITY}s/FilteredTo/FBL~IDTestInstance~INN~${tmpIDTestInstances.join(',')}/0/500`, (pError, pRows) =>
		{
			let tmpAdopted = 0;
			try
			{
				if (pError || !Array.isArray(pRows))
				{
					return;
				}
				const tmpLiveByKey = new Map();
				for (const tmpRow of pRows)
				{
					if (!tmpRow || !(Number(tmpRow.IDTestInstanceLabJoin) > 0) || typeof tmpRow.GUIDTestInstanceLabJoin !== 'string')
					{
						continue;
					}
					const tmpKey = `${Number(tmpRow.IDTestInstance)}:${Number(tmpRow.IDLab)}`;
					tmpLiveByKey.set(tmpKey, tmpLiveByKey.has(tmpKey) ? null : tmpRow);
				}
				const tmpHeldGUIDs = new Set(collectHeldRecords(pPict)
					.filter((pItem) => pItem.Entity === LAB_JOIN_ENTITY)
					.map((pItem) => pItem.Record[`GUID${LAB_JOIN_ENTITY}`]));
				for (const tmpCandidate of tmpCandidates)
				{
					const tmpRow = tmpLiveByKey.get(tmpCandidate.Key);
					if (!tmpRow || tmpHeldGUIDs.has(tmpRow.GUIDTestInstanceLabJoin))
					{
						continue;
					}
					tmpHeldGUIDs.add(tmpRow.GUIDTestInstanceLabJoin);
					if (rewriteHeldRecordIdentity(pPict, LAB_JOIN_ENTITY, tmpCandidate.GUID, tmpRow.GUIDTestInstanceLabJoin, Number(tmpRow.IDTestInstanceLabJoin)) > 0)
					{
						++tmpAdopted;
					}
				}
			}
			finally
			{
				fSafeCallback(tmpAdopted);
			}
		});
	}
	catch (pError)
	{
		fSafeCallback(0);
	}
}

/**
 * Resolve the row ids of records the form holds without one, before the load baseline is captured.
 *
 * A record an earlier form version saved, or whose id never came back, carries only its GUID, so the
 * delta has no baseline for it and the first save re-sends it whole. Reading each such GUID's live row
 * and stamping the id makes it baselined like any other record. A held document join or TestInstance
 * lab join whose own GUID names no row is pointed at the live row for the same natural key. Only live
 * rows are adopted: a failed read, a missing row or a deleted one changes nothing.
 *
 * Meant to run once the load has settled, so it sees every record the loaders created or replaced.
 * Calls `fDone` exactly once: after every read has returned, or at once when there is nothing to read.
 * Skipped for a frozen document, on the local offline transport, and without a REST client.
 *
 * @param {Object} pPict - The pict instance.
 * @param {() => void} [fDone] - Called once, when the held records are settled.
 * @return {boolean} - True when reads were started.
 */
function resolveHeldIdentities(pPict, fDone)
{
	let tmpFinished = false;
	const fFinish = (pMessage) =>
	{
		if (tmpFinished)
		{
			return;
		}
		tmpFinished = true;
		if (pMessage && pPict && pPict.log && typeof pPict.log.info === 'function')
		{
			pPict.log.info(pMessage);
		}
		if (typeof fDone === 'function')
		{
			fDone();
		}
	};
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function' || isDocumentFrozen(pPict) || isLocalDocumentTransport(pPict))
	{
		fFinish(null);
		return false;
	}
	const tmpRestClient = pPict.HeadlightRestClient;
	if (!tmpRestClient || typeof tmpRestClient.getJSON !== 'function')
	{
		fFinish(null);
		return false;
	}

	const tmpKnown = { };
	const tmpPending = new Map();
	for (const tmpItem of collectHeldRecords(pPict))
	{
		const tmpGUID = tmpItem.Record[`GUID${tmpItem.Entity}`];
		if (typeof tmpGUID !== 'string' || tmpGUID.length < 1)
		{
			continue;
		}
		if (hasServerIdentity(tmpItem.Entity, tmpItem.Record))
		{
			if (!tmpKnown[tmpItem.Entity])
			{
				tmpKnown[tmpItem.Entity] = { };
			}
			tmpKnown[tmpItem.Entity][tmpGUID] = Number(tmpItem.Record[`ID${tmpItem.Entity}`]);
			continue;
		}
		const tmpKey = `${tmpItem.Entity} ${tmpGUID}`;
		if (!tmpPending.has(tmpKey))
		{
			tmpPending.set(tmpKey, { Entity: tmpItem.Entity, GUID: tmpGUID, Records: [ ] });
		}
		tmpPending.get(tmpKey).Records.push(tmpItem.Record);
	}
	if (tmpPending.size < 1)
	{
		fFinish(null);
		return false;
	}

	/** @type {Record<string, Record<string, number>>} */
	const tmpResolved = { };
	const tmpUnresolvedJoins = [ ];
	const tmpUnresolvedLabJoins = [ ];
	const tmpTasks = Array.from(tmpPending.values()).map((pItem) => (fNext) =>
	{
		readLiveRowID(pPict, pItem.Entity, pItem.GUID, (pID) =>
		{
			if (pID > 0)
			{
				if (!tmpResolved[pItem.Entity])
				{
					tmpResolved[pItem.Entity] = { };
				}
				tmpResolved[pItem.Entity][pItem.GUID] = pID;
			}
			else if (pItem.Entity === DOCUMENT_JOIN_ENTITY)
			{
				tmpUnresolvedJoins.push(...pItem.Records);
			}
			else if (pItem.Entity === LAB_JOIN_ENTITY)
			{
				tmpUnresolvedLabJoins.push(...pItem.Records);
			}
			fNext();
		});
	});
	try
	{
		runTasksWithConcurrency(tmpTasks, HELD_IDENTITY_READ_CONCURRENCY, () =>
		{
			try
			{
				const tmpStamped = stampHeldIdentities(pPict, tmpResolved);
				/** @type {Record<string, Record<string, number>>} */
				const tmpKnownIdentities = { };
				for (const tmpSource of [ tmpKnown, tmpResolved ])
				{
					for (const tmpEntity of Object.keys(tmpSource))
					{
						tmpKnownIdentities[tmpEntity] = Object.assign(tmpKnownIdentities[tmpEntity] || { }, tmpSource[tmpEntity]);
					}
				}
				adoptDocumentJoinsByNaturalKey(pPict, tmpRestClient, tmpUnresolvedJoins, tmpKnownIdentities, (pAdoptedJoins) =>
				{
					try
					{
						adoptLabJoinsByNaturalKey(pPict, tmpRestClient, tmpUnresolvedLabJoins, tmpKnownIdentities, (pAdoptedLabJoins) =>
						{
							const tmpTotal = tmpStamped + pAdoptedJoins + pAdoptedLabJoins;
							fFinish(tmpTotal > 0 ? `EntityDataBaseline: adopted the row ids of ${tmpStamped} held record(s), ${pAdoptedJoins} document join(s) and ${pAdoptedLabJoins} lab join(s) before the load baseline.` : null);
						});
					}
					catch (pError)
					{
						fFinish(`EntityDataBaseline: held-identity adoption stopped early, records keep what they held: ${pError.message || pError}`);
					}
				});
			}
			catch (pError)
			{
				fFinish(`EntityDataBaseline: held-identity adoption stopped early, records keep what they held: ${pError.message || pError}`);
			}
		});
	}
	catch (pError)
	{
		fFinish(`EntityDataBaseline: held-identity reads could not start: ${pError.message || pError}`);
	}
	return true;
}

/**
 * Capture the baseline now: sweep, sanitize, store.
 *
 * @param {Object} pPict - The pict instance.
 * @return {number} - How many records were baselined.
 */
function captureBaselineNow(pPict)
{
	const tmpContextRoots = runProjectionSweepToScratch(pPict);
	if (!tmpContextRoots)
	{
		return 0;
	}
	tmpContextRoots.forEach((pContextRoot) =>
	{
		libScopedEntityData.sanitizeContextRoot(pContextRoot);
	});
	return captureBaselineFromSweep(pPict, tmpContextRoots);
}

/**
 * Schedule the load-settled baseline capture on a render transaction, once however many inputs ask.
 *
 * The render transaction is the settle signal: `onAfterRender` opens it, every record fetch in both
 * families fences on it (`registerEventTransactionAsyncOperation`), and its completion callback runs
 * only once all of them have drained. Capturing there rather than at init is what makes the baseline
 * current server state — `PictForm.RefreshOnOpen` defaults to true, so a form open re-fetches and
 * replaces `__Record` wholesale, and a baseline taken before that lands would read every field
 * another actor changed since the last save as a user edit. The held-identity reads
 * (`resolveHeldIdentities`) start in that callback, so they see every record the loaders created or
 * replaced, and the capture waits for them.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pView - The dynamic-form view (owns the transaction API).
 * @param {string} pTransactionGUID - The render transaction.
 * @return {boolean} - True when this call scheduled the capture.
 */
function scheduleLoadBaselineCapture(pPict, pView, pTransactionGUID)
{
	if (!pPict || !pView || !pTransactionGUID || typeof pView.registerOnTransactionCompleteCallback !== 'function')
	{
		return false;
	}
	const tmpScheduled = getBaselineAppState(pPict).ScheduledTransactions;
	if (tmpScheduled[pTransactionGUID])
	{
		return false;
	}
	tmpScheduled[pTransactionGUID] = true;
	pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
	{
		delete tmpScheduled[pTransactionGUID];
		let tmpCaptured = false;
		const fCaptureAndRelease = () =>
		{
			if (tmpCaptured)
			{
				return;
			}
			tmpCaptured = true;
			try
			{
				const tmpFirstCapture = !hasCaptureSession(pPict);
				const tmpCount = captureBaselineNow(pPict);
				if (pPict.log && typeof pPict.log.trace === 'function')
				{
					pPict.log.trace(tmpFirstCapture ?
						`EntityDataBaseline: captured ${tmpCount} record(s) once the load settled.` :
						`EntityDataBaseline: captured ${tmpCount} record(s) first seen on a later render; records already baselined keep their values.`);
				}
			}
			catch (pError)
			{
				if (pPict.log && typeof pPict.log.error === 'function')
				{
					pPict.log.error(`EntityDataBaseline: load capture failed, records will project whole this session: ${pError.message || pError}`);
				}
			}
			try
			{
				releaseUnappliedRecords(pPict, pPict.manifest.getValueAtAddress(pPict, libScopedEntityData.DOCUMENT_ENTITY_DATA_ADDRESS));
			}
			catch (pError)
			{
				if (pPict.log && typeof pPict.log.error === 'function')
				{
					pPict.log.error(`EntityDataBaseline: could not read the server's unapplied records on load: ${pError.message || pError}`);
				}
			}
		};
		try
		{
			resolveHeldIdentities(pPict, fCaptureAndRelease);
		}
		catch (pError)
		{
			if (pPict.log && typeof pPict.log.error === 'function')
			{
				pPict.log.error(`EntityDataBaseline: could not start the held-identity reads: ${pError.message || pError}`);
			}
			fCaptureAndRelease();
		}
	});
	return true;
}

/**
 * The `<Entity>.<GUID>` keys of every record a log entry carried, and whether this entry failed each one.
 *
 * An error naming an entity but no record failed every record of that entity in the entry; an error naming
 * neither failed the whole entry, as a push-order abort does.
 *
 * @param {Record<string, any>} pEntry - One `ExecutionLog` entry.
 * @return {Map<string, { Entity: string, GUID: string, Failed: boolean }>} - Per-record outcome, keyed by entity and GUID.
 */
function readLogEntryOutcomes(pEntry)
{
	const tmpOutcomes = new Map();
	const tmpErrors = Array.isArray(pEntry.Errors) ? pEntry.Errors : [ ];
	const tmpFailedRecords = new Set();
	const tmpFailedEntities = new Set();
	let tmpAllFailed = false;
	for (const tmpError of tmpErrors)
	{
		if (!tmpError || typeof tmpError !== 'object')
		{
			continue;
		}
		if (tmpError.Entity && tmpError.GUID)
		{
			tmpFailedRecords.add(`${tmpError.Entity} ${tmpError.GUID}`);
		}
		else if (tmpError.Entity)
		{
			tmpFailedEntities.add(tmpError.Entity);
		}
		else
		{
			tmpAllFailed = true;
		}
	}
	const tmpComprehension = (pEntry.Comprehension && typeof pEntry.Comprehension === 'object') ? pEntry.Comprehension : { };
	for (const tmpEntity of Object.keys(tmpComprehension))
	{
		const tmpBucket = tmpComprehension[tmpEntity];
		if (!tmpBucket || typeof tmpBucket !== 'object')
		{
			continue;
		}
		const tmpGUIDs = Array.isArray(tmpBucket)
			? tmpBucket.map((pRecord) => pRecord && pRecord[`GUID${tmpEntity}`]).filter((pGUID) => !!pGUID)
			: Object.keys(tmpBucket);
		for (const tmpGUID of tmpGUIDs)
		{
			const tmpKey = `${tmpEntity} ${tmpGUID}`;
			const tmpFailed = tmpAllFailed || tmpFailedEntities.has(tmpEntity) || tmpFailedRecords.has(tmpKey);
			tmpOutcomes.set(tmpKey, { Entity: tmpEntity, GUID: String(tmpGUID), Failed: tmpFailed });
		}
	}
	for (const tmpKey of tmpFailedRecords)
	{
		if (!tmpOutcomes.has(tmpKey))
		{
			// Entity names carry no spaces; GUIDs can, so only the first space separates them.
			const tmpSeparator = tmpKey.indexOf(' ');
			tmpOutcomes.set(tmpKey, { Entity: tmpKey.substring(0, tmpSeparator), GUID: tmpKey.substring(tmpSeparator + 1), Failed: true });
		}
	}
	return tmpOutcomes;
}

/**
 * Release every record the server logged as not applied, so the next save re-emits it.
 *
 * The baseline is folded before the PUT, so a record the server then refused already reads as written.
 * The server's `ExecutionLog` is the source of record for what landed: a record counts as unapplied when
 * its newest appearance under `OnSave` is a failure. Dropping its baseline makes it project whole again on
 * the next save, whenever that is. The log is only read here, never written.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>|string} [pEntityData] - The document's `EntityData`, as an object or its JSON.
 * @return {number} - How many baseline records were released.
 */
function releaseUnappliedRecords(pPict, pEntityData)
{
	let tmpEntityData = pEntityData;
	if (typeof tmpEntityData === 'string')
	{
		try
		{
			tmpEntityData = JSON.parse(tmpEntityData);
		}
		catch (pError)
		{
			return 0;
		}
	}
	const tmpLog = (tmpEntityData && typeof tmpEntityData === 'object' && Array.isArray(tmpEntityData.ExecutionLog)) ? tmpEntityData.ExecutionLog : null;
	if (!tmpLog)
	{
		return 0;
	}
	const tmpContext = libScopedEntityData.DEFAULT_CONTEXT;
	const tmpLatest = new Map();
	for (const tmpEntry of tmpLog)
	{
		if (!tmpEntry || typeof tmpEntry !== 'object' || tmpEntry.TriggerKey !== tmpContext)
		{
			continue;
		}
		for (const [ tmpKey, tmpOutcome ] of readLogEntryOutcomes(tmpEntry))
		{
			tmpLatest.set(tmpKey, tmpOutcome);
		}
	}
	const tmpReleased = [ ];
	for (const tmpOutcome of tmpLatest.values())
	{
		if (tmpOutcome.Failed && dropBaselineRecord(pPict, tmpContext, tmpOutcome.Entity, tmpOutcome.GUID))
		{
			tmpReleased.push(`${tmpOutcome.Entity}/${tmpOutcome.GUID}`);
		}
	}
	if (tmpReleased.length > 0 && pPict && pPict.log && typeof pPict.log.info === 'function')
	{
		pPict.log.info(`EntityDataBaseline: the server did not apply ${tmpReleased.length} record(s); the next save sends them again: ${tmpReleased.join(', ')}.`);
	}
	return tmpReleased.length;
}

module.exports =
{
	BASELINE_ADDRESS,
	PROJECTION_SWEEP_EVENT,
	pruneContextRootToDelta,
	runProjectionSweepToScratch,
	captureBaselineNow,
	applyResolvedIdentities,
	isDocumentFrozen,
	resolveHeldIdentities,
	scheduleLoadBaselineCapture,
	DELETED_FIELD,
	isDirectiveField,
	isCrossEntityReferenceField,
	getEntityClassification,
	isIdentityField,
	isAuditField,
	isNumericField,
	isComparableField,
	isEmittableField,
	hasServerIdentity,
	isTombstoneRecord,
	valuesDiffer,
	computeRecordDelta,
	reduceRecordForBaseline,
	getBaselineStore,
	readBaselineRecord,
	writeBaselineRecord,
	dropBaselineRecord,
	captureBaselineFromSweep,
	refreshBaselineRecords,
	isAlwaysEmittedReference,
	classifyRecordRefresh,
	adoptRefreshedFields,
	foldEmissionIntoBaseline,
	clearBaseline,
	recordPendingEmission,
	foldPendingEmission,
	getPendingEmissionRoots,
	mergeObjectOverServer,
	mergePendingObjectFieldsWithServer,
	hasBaseline,
	collectHeldRecords,
	releaseUnappliedRecords,
};

},{"./_EntityFieldClassification.json":156,"./_ScopedEntityData.js":162,"./_SharedEntityRead.js":164}],155:[function(require,module,exports){
/**
 * The ONE entity display-name resolution order, shared by the legacy Select2Util display chain and the
 * Picker stack's Read/Print display so the Select2 → Picker migration cannot change what a field paints.
 *
 * Two record shapes are why this can never be a flat `pRecord[Field]` read:
 *
 *   - **User.** The table carries no `Name` column (NameFirst, NameLast, Phone, Email, LoginID, …), so an
 *     `Entity: 'User'` descriptor with no display field — the shared LADOTD "Sampled By" / "Created By"
 *     header fields, injected into ~152 forms — reads undefined and paints blank.
 *   - **A dotted display field** (`MixMetadata.MixName`). `pRecord['MixMetadata.MixName']` is undefined;
 *     the path has to be walked hop by hop.
 *
 * The two callers differ ONLY in what they show when the record has nothing, which is what lets one
 * implementation serve both: Select2Util passes its legacy `Unnamed <Entity> #<id>` placeholder as
 * pUnnamedFallback, while PickerDisplay passes none, takes '' and paints unnamedEntityLabel's
 * `<Entity> #<id>` itself — the Picker stack's label for a record with no name, shared with the Edit
 * picker so both read the same.
 *
 * @module _EntityDisplayName
 */

/**
 * Walk a dotted path across a record, hasOwnProperty-guarded at each hop. A missing hop yields null
 * rather than throwing.
 *
 * @param {Record<string, any>} pRecord - The entity record.
 * @param {string} pPath - The dotted field path.
 * @return {any}
 */
function resolveDottedValue(pRecord, pPath)
{
	let tmpValue = /** @type {any} */ (pRecord);
	for (const tmpField of pPath.split('.'))
	{
		if (!tmpValue || !Object.prototype.hasOwnProperty.call(tmpValue, tmpField))
		{
			return null;
		}
		tmpValue = tmpValue[tmpField];
	}
	return tmpValue;
}

/**
 * A User's display name, composed from the name parts the table actually has. Joins only the parts that
 * are present, so a record missing both yields '' — and the caller's fallback — rather than the literal
 * "undefined undefined" the legacy template produced.
 *
 * @param {Record<string, any>} pRecord - The User record.
 * @return {string}
 */
function composeUserName(pRecord)
{
	return [ pRecord.NameFirst, pRecord.NameLast ]
		.filter((pPart) => (pPart !== undefined && pPart !== null && String(pPart).trim() !== ''))
		.join(' ');
}

/**
 * The display text for an entity record. Pure — the record is never written to.
 *
 * @param {string} pEntity - The entity type the record belongs to.
 * @param {Record<string, any>} pRecord - The entity record.
 * @param {Record<string, any>} [pOptions] - Display config; TextField or EntityDisplayField names the
 *   display field (a dotted path is walked).
 * @param {() => string} [pUnnamedFallback] - What to show when the record has nothing; omitted = ''.
 *
 * @return {any} - The display text.
 */
function resolveEntityDisplayName(pEntity, pRecord, pOptions = {}, pUnnamedFallback)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return '';
	}
	const fFallback = () => ((typeof pUnnamedFallback === 'function') ? pUnnamedFallback() : '');
	const tmpDisplayField = pOptions.TextField || pOptions.EntityDisplayField;
	if (tmpDisplayField && tmpDisplayField.includes('.'))
	{
		return resolveDottedValue(pRecord, tmpDisplayField) || fFallback();
	}
	if (tmpDisplayField)
	{
		// No fallback on this branch, matching the legacy chain: an explicitly named field that is empty
		// stays empty rather than being replaced by a placeholder.
		return pRecord[tmpDisplayField];
	}
	if (pEntity === 'User')
	{
		return composeUserName(pRecord) || fFallback();
	}
	return pRecord.Name || fFallback();
}

/**
 * The noun for an Organization, which plays a different role on each field (Producer, Contractor, Source, …):
 * a one-word field label names the role, a longer label that mentions a producer reads `Producer`, and
 * anything else reads `Organization`.
 *
 * @param {string} [pFieldLabel] - The label of the field showing the record.
 * @return {string}
 */
function organizationLabel(pFieldLabel)
{
	const tmpLabel = String(pFieldLabel || '').trim();
	if (/^[A-Za-z]+$/.test(tmpLabel))
	{
		return tmpLabel;
	}
	if (/producer/i.test(tmpLabel))
	{
		return 'Producer';
	}
	return 'Organization';
}

/**
 * The user-facing noun for an entity: the table name split into words (`MixSpecification` →
 * `Mix Specification`), or for an Organization the role its field label names (organizationLabel).
 *
 * @param {string} pEntity - The entity type.
 * @param {string} [pFieldLabel] - The label of the field showing the record.
 * @return {string}
 */
function entityLabel(pEntity, pFieldLabel)
{
	if (pEntity === 'Organization')
	{
		return organizationLabel(pFieldLabel);
	}
	return String(pEntity || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

/**
 * What a record with no display name shows in its place: `<entity label> #<record ID>`, e.g.
 * `Document #37945` or `Contractor #3456`. '' when there is no ID to show.
 *
 * @param {string} pEntity - The entity type.
 * @param {any} pID - The record's ID.
 * @param {string} [pFieldLabel] - The label of the field showing the record.
 * @return {string}
 */
function unnamedEntityLabel(pEntity, pID, pFieldLabel)
{
	if (pID === undefined || pID === null || String(pID).trim() === '')
	{
		return '';
	}
	return `${entityLabel(pEntity, pFieldLabel)} #${pID}`;
}

module.exports = { resolveEntityDisplayName, entityLabel, unnamedEntityLabel };

},{}],156:[function(require,module,exports){
module.exports={"AuditColumns":["CreateDate","CreatingIDUser","UpdateDate","UpdatingIDUser","DeleteDate","DeletingIDUser","ExternalSyncDate","IDCustomer"],"Entities":{"AcademyContent":{"I":["IDAcademyContent","GUIDAcademyContent"],"D":["Deleted","Hash","Title","Content"],"N":[]},"AcademyContentArchive":{"I":["IDAcademyContentArchive","GUIDAcademyContentArchive"],"D":["Deleted","Hash","Title","Content"],"N":[]},"AcademyLearningProgression":{"I":["IDAcademyLearningProgression","GUIDAcademyLearningProgression"],"D":["Deleted","Name","Description"],"N":[]},"AcademyLearningProgressionRole":{"I":["IDAcademyLearningProgressionRole","GUIDAcademyLearningProgressionRole"],"D":["Deleted","IDAcademyLearningProgression","Role"],"N":["IDAcademyLearningProgression"]},"AcademyLesson":{"I":["IDAcademyLesson","GUIDAcademyLesson"],"D":["Deleted","Hash","Address","Type","Name","Description","MinutesRequired","Difficulty"],"N":["MinutesRequired","Difficulty"]},"AcademyLessonAcademyObjectiveJoin":{"I":["IDAcademyLessonAcademyObjectiveJoin","GUIDAcademyLessonAcademyObjectiveJoin"],"D":["Deleted","IDAcademyLesson","IDAcademyObjective"],"N":["IDAcademyLesson","IDAcademyObjective"]},"AcademyLessonUserJoin":{"I":["IDAcademyLessonUserJoin","GUIDAcademyLessonUserJoin"],"D":["Deleted","IDAcademyLesson","IDUser","Completion","Completed","State"],"N":["IDAcademyLesson","IDUser","Completion"]},"AcademyObjective":{"I":["IDAcademyObjective","GUIDAcademyObjective"],"D":["Deleted","IDAcademyLearningProgression","Name","Description"],"N":["IDAcademyLearningProgression"]},"AcademySubscription":{"I":["IDAcademySubscription","GUIDAcademySubscription"],"D":["Hash","Ordinal","Title","Description","Location","ConfigurationJSON"],"N":["Ordinal"]},"AcademyTips":{"I":["IDAcademyTips","GUIDAcademyTips"],"D":["Deleted","Application","Hash","UXHash","Title","Tip"],"N":[]},"Account":{"I":["IDAccount","GUIDAccount"],"D":["Deleted","Name","Hash","Description","IDAccountType","EntityName","IDEntity","Balance","Pending"],"N":["IDAccountType","IDEntity","Balance","Pending"]},"AccountBudget":{"I":["IDAccountBudget","GUIDAccountBudget"],"D":["Deleted","Hash","BudgetedAmount","SpentAmount","IDAccount","Mapped","SourceIDAccount","PriorityGroup","PriorityWeight"],"N":["BudgetedAmount","SpentAmount","IDAccount","SourceIDAccount","PriorityWeight"]},"AccountEntityJoin":{"I":["IDAccountEntityJoin","GUIDAccountEntityJoin"],"D":["Deleted","IDAccount","EntityType","IDEntity"],"N":["IDAccount","IDEntity"]},"AccountLedger":{"I":["IDAccountLedger","GUIDAccountLedger"],"D":["Deleted","IDAccount","IDPaymentTransaction","Deposit","Withdrawal","Balance","Pending","TransactionTime","TransactionOrdinal"],"N":["IDAccount","IDPaymentTransaction","Deposit","Withdrawal","Balance","TransactionOrdinal"]},"AccountType":{"I":["IDAccountType","GUIDAccountType"],"D":["Deleted","Name","Hash","EntityName","Description","Unit","FundingType"],"N":[]},"AppArtifact":{"I":["IDAppArtifact","GUIDAppArtifact"],"D":["Deleted","IDProject","Type","AppHash","IDArtifact"],"N":["IDProject","IDArtifact"]},"AppData":{"I":["IDAppData","GUIDAppData"],"D":["Deleted","IDProject","Type","Title","Description","Datum","AppHash"],"N":["IDProject"]},"AppProcessLock":{"I":["IDAppProcessLock","GUIDSession"],"D":["Name","StartDate","Locked","TimeoutInSeconds","ReleaseDate"],"N":["TimeoutInSeconds"]},"Apps":{"I":["IDApplication"],"D":["ClientID","Secret","IDUser","Name"],"N":["IDUser"]},"Artifact":{"I":["IDArtifact","GUIDArtifact"],"D":["Deleted","ArtifactType","Datum","Version","Invalid","IDDevice","Sync"],"N":["Version","IDDevice"]},"ArtifactType":{"I":["IDArtifactType","GUIDArtifactType"],"D":["Deleted","Name","Schemata"],"N":[]},"ArtifactTypeSpecification":{"I":["IDArtifactTypeSpecification","GUIDArtifactTypeSpecification"],"D":["Deleted","IDArtifactType","Name","CountMinimum","CountMaximum","Required"],"N":["IDArtifactType","CountMinimum","CountMaximum"]},"AssetClassification":{"I":["IDAssetClassification","GUIDAssetClassification"],"D":["Deleted","Name","Description"],"N":[]},"AssetType":{"I":["IDAssetType","GUIDAssetType"],"D":["Deleted","Name","Description"],"N":[]},"AssetTypeManifest":{"I":["IDAssetTypeManifest","GUIDAssetTypeManifest"],"D":["Deleted","IDAssetType","Version","ManifestJSON"],"N":["IDAssetType","Version"]},"AxiomEntitySet":{"I":["IDAxiomEntitySet","GUIDAxiomEntitySet"],"D":["Deleted","SetScope"],"N":[]},"BidItem":{"I":["IDBidItem","GUIDBidItem"],"D":["Deleted","Name","Description","Quantity","Units","CostPerUnit","IDContract","IDProject","IDPayItem","IDOrganization"],"N":["Quantity","CostPerUnit","IDContract","IDProject","IDPayItem","IDOrganization"]},"BidItemOrganizationJoin":{"I":["IDBidItemOrganizationJoin","GUIDBidItemOrganizationJoin"],"D":["DisadvantagedBusiness","IDBidItem","IDOrganization"],"N":["IDBidItem","IDOrganization"]},"Certification":{"I":["IDCertification","GUIDCertification"],"D":["Deleted","Notes","CertifiedOn","CertifiedStartDate","CertifiedEndDate","IDCertificationType","URL"],"N":["IDCertificationType"]},"CertificationEntityPolyJoin":{"I":["IDCertificationEntityPolyJoin","GUIDCertificationEntityPolyJoin"],"D":["Deleted","IDCertification","EntityType","IDEntity"],"N":["IDCertification","IDEntity"]},"CertificationType":{"I":["IDCertificationType","GUIDCertificationType"],"D":["Deleted","Name","Hash","Verb","Description"],"N":[]},"CertificationTypeCertifiedEntityPolyJoin":{"I":["IDCertificationTypeCertifiedEntityPolyJoin","GUIDCertificationTypeCertifiedEntityPolyJoin"],"D":["Deleted","IDCertificationType","EntityType","IDEntity","Note"],"N":["IDCertificationType","IDEntity"]},"ChangeOrder":{"I":["IDChangeOrder","GUIDChangeOrder"],"D":["Deleted","ChangeNumber","Amount","Description","ReasonCode","DateOfChange","ApprovedByDate","Status","AdditionalDays","FormIDDocument","Remarks","IDContract","IDProject"],"N":["Amount","AdditionalDays","FormIDDocument","IDContract","IDProject"]},"Comment":{"I":["IDComment","GUIDComment"],"D":["IDParent","Deleted","Comment","CommentHtml","Metadata"],"N":["IDParent"]},"ConfigEntry":{"I":["IDConfigEntry","GUIDConfigEntry"],"D":["NamespaceKey","NamespaceValue","LevelContext","LevelContextID","Address","ConfigValue"],"N":["LevelContextID"]},"ConfigFragment":{"I":["IDConfigFragment","GUIDConfigFragment"],"D":["Deleted","Type","Hash","FragmentJSON"],"N":[]},"Contact":{"I":["IDContact","GUIDContact"],"D":["Deleted","NameFirst","NameLast","NameFull","Title","IDOrganization","Email","Phone"],"N":["IDOrganization"]},"ContactOrganizationJoin":{"I":["IDContactOrganizationJoin","GUIDContactOrganizationJoin"],"D":["Deleted","IDContact","IDOrganization","Active"],"N":["IDContact","IDOrganization"]},"ContextDataRequirementSetJoin":{"I":["IDContextDataRequirementSetJoin","GUIDContextDataRequirementSetJoin"],"D":["Deleted","IDDataRequirementSet","Type","Context","OptionsJSON"],"N":["IDDataRequirementSet"]},"Contract":{"I":["IDContract","GUIDContract"],"D":["Deleted","Name","Description","PrimaryProjectNumber","CountyProjectNumber","StateProjectNumber","FederalProjectNumber","Status","DBEStructure","RouteNumber","HighwayNumber","PavingMaterial","StationBegin","TerminusBegin","StationEnd","TerminusEnd","TotalBidAmount","NetChangeOrderAmount","VendorAccountCode","ItemSpecificationYear","MaterialsSpecificationYear","ItemIDTestSpecificationSet","MaterialIDTestSpecificationSet","IDOrganization","ExternalContractID","IDContractType","EstimatedCompletionDate"],"N":["TotalBidAmount","NetChangeOrderAmount","ItemIDTestSpecificationSet","MaterialIDTestSpecificationSet","IDOrganization","IDContractType"]},"ContractDate":{"I":["IDContractDate","GUIDContractDate"],"D":["Deleted","Name","Hash","Date","IDContract"],"N":["IDContract"]},"ContractType":{"I":["IDContractType","GUIDContractType"],"D":["Deleted","Name","Hash","Description","SettingsJSON"],"N":[]},"ContractTypeDefaultDate":{"I":["IDContractTypeDefaultDate","GUIDContractTypeDefaultDate"],"D":["Deleted","Name","Hash","IDContractType"],"N":["IDContractType"]},"ContractTypeDefaultFunding":{"I":["IDContractTypeDefaultFunding","GUIDContractTypeDefaultFunding"],"D":["Deleted","IDFundingSource","IDFundingCategory","IDContractType"],"N":["IDFundingSource","IDFundingCategory","IDContractType"]},"Core":{"I":["IDCore","GUIDCore"],"D":["Deleted","IDLot","IDSublot","IDSample","IDContract","LPSyncDate","HLSyncDate","QRCode","SublotName"],"N":["IDLot","IDSublot","IDSample","IDContract"]},"CoreResult":{"I":["IDCoreResult","GUIDCoreResult"],"D":["Deleted","IDCore","ResultPassed","ResultData","LPSyncDate","HLSyncDate"],"N":["IDCore"]},"Customer":{"I":["IDCustomer","GUIDCustomer"],"D":["Deleted","Name","Code","Enabled","CustomProperties","Timezone"],"N":[]},"CustomerModuleJoin":{"I":["IDCustomerModuleJoin","GUIDCustomerModuleJoin"],"D":["ModuleHash","IDProgram","StartDate","EndDate","SettingsJSON"],"N":["IDProgram"]},"Dashboard":{"I":["IDDashboard","GUIDDashboard"],"D":["Deleted","Hash","Name","Description","RecordSet","Icon","Accent","CustomerVisible","Category","Ordinal","IsDefault","UserCustomized","DataSourceJSON"],"N":["Ordinal"]},"DashboardAdoptionHeatmap":{"I":["IDDashboardAdoptionHeatmap","GUIDDashboardAdoptionHeatmap"],"D":["Deleted","IDUser","PeriodMonth","ObservationCount"],"N":["IDUser","ObservationCount"]},"DashboardApprovalStat":{"I":["IDDashboardApprovalStat","GUIDDashboardApprovalStat"],"D":["Deleted","DocumentType","SubmittedCount","ApprovedCount","RejectedCount","ReturnedCount","AvgTurnaroundDays"],"N":["SubmittedCount","ApprovedCount","RejectedCount","ReturnedCount","AvgTurnaroundDays"]},"DashboardApprovalTransition":{"I":["IDDashboardApprovalTransition","GUIDDashboardApprovalTransition"],"D":["Deleted","FromStatus","ToStatus","RecordCount","AvgDays"],"N":["RecordCount","AvgDays"]},"DashboardCustomerSummary":{"I":["IDDashboardCustomerSummary","GUIDDashboardCustomerSummary"],"D":["Deleted","ProjectsActive","ProjectsTotal","UsersActive","UsersDisabled","ObservationsTotal","DocumentsTotal","DocumentsPending","DocumentsApproved","DocumentsRejected","SamplesTotal","ContractsTotal","InspectionsTotal","PhysicalAssetsTotal","CertificationsTotal","ElectronicSignatures","OrganizationsTotal","EquipmentTotal","ObsMissingGeo","StaleUsers","StuckDocuments","EmptyProjects","SessionsTotal"],"N":["ProjectsActive","ProjectsTotal","UsersActive","UsersDisabled","ObservationsTotal","DocumentsTotal","DocumentsPending","DocumentsApproved","DocumentsRejected","SamplesTotal","ContractsTotal","InspectionsTotal","PhysicalAssetsTotal","CertificationsTotal","ElectronicSignatures","OrganizationsTotal","EquipmentTotal","ObsMissingGeo","StaleUsers","StuckDocuments","EmptyProjects","SessionsTotal"]},"DashboardDailyTrend":{"I":["IDDashboardDailyTrend","GUIDDashboardDailyTrend"],"D":["Deleted","PeriodDate","MetricType","DimensionValue","RecordCount","UniqueCount"],"N":["RecordCount","UniqueCount"]},"DashboardDistribution":{"I":["IDDashboardDistribution","GUIDDashboardDistribution"],"D":["Deleted","Category","Label","Sublabel","RecordCount"],"N":["RecordCount"]},"DashboardModuleAdoption":{"I":["IDDashboardModuleAdoption","GUIDDashboardModuleAdoption"],"D":["Deleted","ModuleName","RecordCount","Active"],"N":["RecordCount"]},"DashboardPendingDocument":{"I":["IDDashboardPendingDocument","GUIDDashboardPendingDocument"],"D":["Deleted","IDDocument","Name","Status","DaysPending","DocumentCreateDate"],"N":["IDDocument","DaysPending"]},"DashboardProjectStat":{"I":["IDDashboardProjectStat","GUIDDashboardProjectStat"],"D":["Deleted","IDProject","UserCount","ObservationCount","DocumentCount","SampleCount","RecentObservations30d","ApprovedDocuments","AssignedUsers","ActiveUsers30d","ChangeOrderCount","ChangeOrderTotalAmount","TotalBidAmount"],"N":["IDProject","UserCount","ObservationCount","DocumentCount","SampleCount","RecentObservations30d","ApprovedDocuments","AssignedUsers","ActiveUsers30d","ChangeOrderCount","ChangeOrderTotalAmount","TotalBidAmount"]},"DashboardUserStat":{"I":["IDDashboardUserStat","GUIDDashboardUserStat"],"D":["Deleted","IDUser","SessionCount","SessionCount30d","ObservationCount","DocumentCount","ApprovalCount","LastLoginDate","RecencyDays"],"N":["IDUser","SessionCount","SessionCount30d","ObservationCount","DocumentCount","ApprovalCount","RecencyDays"]},"DataRequirement":{"I":["IDDataRequirement","GUIDDataRequirement"],"D":["Deleted","InputHash","Type","Value","OptionsJSON"],"N":[]},"DataRequirementOutcome":{"I":["IDDataRequirementOutcome","GUIDDataRequirementOutcome"],"D":["Deleted","IDDataRequirement","Class","Value","MessageTemplate"],"N":["IDDataRequirement"]},"DataRequirementSet":{"I":["IDDataRequirementSet","GUIDDataRequirementSet"],"D":["Deleted","Name","Description"],"N":[]},"DataRequirementSetDataRequirementJoin":{"I":["IDDataRequirementSetDataRequirementJoin","GUIDDataRequirementSetDataRequirementJoin"],"D":["Deleted","IDDataRequirementSet","IDDataRequirement"],"N":["IDDataRequirementSet","IDDataRequirement"]},"DataSet":{"I":["IDDataSet","GUIDDataSet"],"D":["Deleted","Name","Status","Description","MetadataJSON"],"N":[]},"Device":{"I":["IDDevice","GUIDDevice"],"D":["Deleted","Name","UUID","Descriptor"],"N":[]},"DeviceSynchronizationLog":{"I":["IDDeviceDeviceSynchronizationLog","GUIDDeviceDeviceSynchronizationLog"],"D":["CreateDateDeviceSynchronizationLog","IDDevice","Completed"],"N":["IDDevice"]},"Document":{"I":["IDDocument","GUIDDocument"],"D":["Deleted","Name","Description","IDDevice","IDProject","DocumentType","DocumentDate","Status","Version","AppHash","Timezone","Shift","StateName","StateStep","Locked","Form","FormDataJSON","EntityDataJSON","SequenceNumber","ExternalSyncGUID","StaleUserActions"],"N":["IDDevice","IDProject","Version","StateStep","SequenceNumber"]},"DocumentAccessJoin":{"I":["IDDocumentAccessJoin","GUIDDocumentAccessJoin"],"D":["Deleted","IDDocument","DocumentType","IDRole","IDTeam","AccessKind","GrantRule"],"N":["IDDocument","IDRole","IDTeam"]},"DocumentApprovalLog":{"I":["IDDocumentApprovalLog","GUIDDocumentApprovalLog"],"D":["Deleted","IDDocument","IDElectronicSignature","Status","Action","StateStep","AfterStatus","IsApproval","InvalidatesApproval"],"N":["IDDocument","IDElectronicSignature","StateStep"]},"DocumentApprovalState":{"I":["IDDocumentApprovalState","GUIDDocumentApprovalState"],"D":["Deleted","Hash","Name"],"N":[]},"DocumentApprovalStep":{"I":["IDDocumentApprovalStep","GUIDDocumentApprovalStep"],"D":["Deleted","IDDocumentApprovalState","Ordinal","IDProject","IDRole","IncludeHigherRoles","PerformLock"],"N":["IDDocumentApprovalState","Ordinal","IDProject","IDRole"]},"DocumentApprovalWorkflow":{"I":["IDDocumentApprovalWorkflow"],"D":["FromStatus","EdgeOptions","ToStatus","Name","IDProject"],"N":["IDProject"]},"DocumentArchive":{"I":["IDDocumentArchive","GUIDDocumentArchive","GUIDDocument"],"D":["IDDocument","Deleted","Name","Description","IDDevice","IDProject","DocumentType","DocumentDate","Status","Version","SnapshotJSON","AppHash","Timezone","Shift","StateName","StateStep","Locked","Form","FormDataJSON","SequenceNumber","ExternalSyncGUID","StaleUserActions"],"N":["IDDocument","IDDevice","IDProject","Version","StateStep","SequenceNumber"]},"DocumentArtifact":{"I":["IDDocumentArtifact","GUIDDocumentArtifact"],"D":["Deleted","Type","Version","Datum"],"N":["Version"]},"DocumentArtifactDocumentJoin":{"I":["IDDocumentArtifactDocumentJoin","GUIDDocumentArtifactDocumentJoin"],"D":["Deleted","IDDocumentArtifact","IDDocument"],"N":["IDDocumentArtifact","IDDocument"]},"DocumentCommentJoin":{"I":["IDDocumentCommentJoin","GUIDDocumentCommentJoin"],"D":["IDDocument","IDComment"],"N":["IDDocument","IDComment"]},"DocumentElectronicSignatureJoin":{"I":["IDDocumentElectronicSignatureJoin","GUIDDocumentElectronicSignatureJoin"],"D":["IDDocument","IDElectronicSignature"],"N":["IDDocument","IDElectronicSignature"]},"DocumentManifest":{"I":["IDDocumentManifest","GUIDDocumentManifest"],"D":["Deleted","Name"],"N":[]},"DocumentMetadata":{"I":["IDDocumentMetadata","GUIDDocumentMetadata"],"D":["MetadataJSON","IDDocument"],"N":["IDDocument"]},"DocumentObservationJoin":{"I":["IDDocumentObservationJoin","GUIDDocumentObservationJoin"],"D":["Deleted","IDDocument","IDObservation"],"N":["IDDocument","IDObservation"]},"DocumentPolyJoin":{"I":["IDDocumentPolyJoin","GUIDDocumentPolyJoin"],"D":["IDDocument","RemoteType","IDRemote","Ordinal","Name"],"N":["IDDocument","IDRemote","Ordinal"]},"DocumentRequirementSpecification":{"I":["IDDocumentRequirementSpecification","GUIDDocumentRequirementSpecification"],"D":["Deleted","IDDocument","IDObservationManifest","Name","CountMinimum","CountMaximum","Required"],"N":["IDDocument","IDObservationManifest","CountMinimum","CountMaximum"]},"ElectronicSignature":{"I":["IDElectronicSignature","GUIDElectronicSignature"],"D":["Deleted","Signer","IDContact","IDArtifact","SignatureType","Approved"],"N":["IDContact","IDArtifact"]},"ElectronicSignatureCommentJoin":{"I":["IDElectronicSignatureCommentJoin","GUIDElectronicSignatureCommentJoin"],"D":["IDElectronicSignature","IDComment"],"N":["IDElectronicSignature","IDComment"]},"EmailRule":{"I":["IDEmailRule","GUIDEmailRule"],"D":["IDClonedRule","Enabled","DocumentType","Projects","Status","Handler","Config"],"N":["IDClonedRule"]},"EmailRuleSchedule":{"I":["IDEmailRuleSchedule","GUIDEmailRuleSchedule"],"D":["IDEmailRule","DayOfMonth","DayOfWeek","HourOfDay"],"N":["IDEmailRule","DayOfMonth","DayOfWeek","HourOfDay"]},"EntityEntitlement":{"I":["IDEntityEntitlement","GUIDEntityEntitlement"],"D":["NamespaceKey","NamespaceValue","LevelContext","LevelContextID","Address","ConfigValue"],"N":["LevelContextID"]},"EntityLog":{"I":["IDEntityLog","GUIDEntityLog"],"D":["EntityType","IDEntity","ChangesSnapshot","ChangeSource"],"N":["IDEntity"]},"Equipment":{"I":["IDEquipment","GUIDEquipment"],"D":["Deleted","Name","Description","Notes","SpecificationYear","Code","Status","ExternalEquipmentID"],"N":["SpecificationYear"]},"EquipmentOrganizationJoin":{"I":["IDEquipmentOrganizationJoin","GUIDEquipmentOrganizationJoin"],"D":["Deleted","IDEquipment","IDOrganization","Active"],"N":["IDEquipment","IDOrganization"]},"ExclusionAxiom":{"I":["IDExclusionAxiom","GUIDExclusionAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"ExclusionAxiomAxiomEntitySetJoin":{"I":["IDExclusionAxiomAxiomEntitySetJoin","GUIDExclusionAxiomAxiomEntitySetJoin"],"D":["Deleted","IDExclusionAxiom","IDAxiomEntitySet"],"N":["IDExclusionAxiom","IDAxiomEntitySet"]},"FIPSCounty":{"I":["IDFIPSCounty","GUIDFIPSCounty"],"D":["Deleted","Code","Name","IDFIPSState"],"N":["IDFIPSState"]},"FIPSState":{"I":["IDFIPSState","GUIDFIPSState"],"D":["Deleted","Code","PostalAbbreviation","Name"],"N":[]},"Flight":{"I":["IDFlight","GUIDFlight"],"D":["Deleted","Title","Type","MetadataJSON","Processed","Confidence","UserVerification"],"N":["Confidence"]},"FlightLog":{"I":["IDFlightLog","GUIDFlightLog"],"D":["Deleted","Hash","LogEntryTime","Status","Text","IDFlight","IDObservation"],"N":["IDFlight","IDObservation"]},"FlightObservationJoin":{"I":["IDFlightObservationJoin","GUIDFlightObservationJoin"],"D":["Deleted","IDFlight","IDObservation"],"N":["IDFlight","IDObservation"]},"FlightProcessingParameter":{"I":["IDFlightProcessingParameter","GUIDFlightProcessingParameter"],"D":["Deleted","IDFlight","ParametersJSON"],"N":["IDFlight"]},"Fund":{"I":["IDFund","GUIDFund"],"D":["Deleted","Name","Hash","Description","OriginalBalance","TotalCommitted","CommittedBalance","Balance","TotalPendingCharge","ExternalAccountID","CostCenter","Active"],"N":["OriginalBalance","TotalCommitted","CommittedBalance","Balance","TotalPendingCharge"]},"FundDocumentJoin":{"I":["IDFundDocumentJoin","GUIDFundDocumentJoin"],"D":["Deleted","IDFund","Amount","PurchaseOrderNumber","IDDocument"],"N":["IDFund","Amount","IDDocument"]},"FundProjectJoin":{"I":["IDFundProjectJoin","GUIDFundProjectJoin"],"D":["Deleted","IDFund","IDProject"],"N":["IDFund","IDProject"]},"FundingCategory":{"I":["IDFundingCategory","GUIDFundingCategory"],"D":["Deleted","Name","Code","Type","Description"],"N":[]},"FundingCategoryProjectJoin":{"I":["IDFundingCategoryProjectJoin","GUIDFundingCategoryProjectJoin"],"D":["Deleted","IDFundingCategory","IDProject"],"N":["IDFundingCategory","IDProject"]},"FundingSource":{"I":["IDFundingSource","GUIDFundingSource"],"D":["Deleted","Name","Hash","Description","Balance","FundingSourceAccountCode","Type"],"N":["Balance"]},"FundingSourceFundJoin":{"I":["IDFundingSourceFundJoin","GUIDFundingSourceFundJoin"],"D":["Deleted","IDFundingSource","IDFund","Sequence","Weight","DepleteBeforeContinue","PurchaseOrderNumber"],"N":["IDFundingSource","IDFund","Weight"]},"FundingSourceFundingCategoryJoin":{"I":["IDFundingSourceFundingCategoryJoin","GUIDFundingSourceFundingCategoryJoin"],"D":["Deleted","IDFundingSource","IDFundingCategory"],"N":["IDFundingSource","IDFundingCategory"]},"FundingSourceProjectJoin":{"I":["IDFundingSourceProjectJoin","GUIDFundingSourceProjectJoin"],"D":["Deleted","IDFundingSource","IDProject","Ordinal","Sequence","Weight","Code","CategoryNumber","IDFundingCategory","ExternalAccountID","PurchaseOrderNumber","FundCap","ProjectFundCap","PendingAmountCharged","ApprovedAmountCharged"],"N":["IDFundingSource","IDProject","Ordinal","Weight","IDFundingCategory","FundCap","ProjectFundCap","PendingAmountCharged","ApprovedAmountCharged"]},"InclusionAxiom":{"I":["IDInclusionAxiom","GUIDInclusionAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"InclusionAxiomAxiomEntitySetJoin":{"I":["IDInclusionAxiomAxiomEntitySetJoin","GUIDInclusionAxiomAxiomEntitySetJoin"],"D":["Deleted","IDInclusionAxiom","IDAxiomEntitySet"],"N":["IDInclusionAxiom","IDAxiomEntitySet"]},"Inspection":{"I":["IDInspection","GUIDInspection"],"D":["Deleted","IDInspectionStatus","StatusDisplay","IDInspectionType","TypeDisplay","StartDate","EndDate","DeadlineDate","ScheduledStartDate","Name","Description","IDProject"],"N":["IDInspectionStatus","IDInspectionType","IDProject"]},"InspectionDocumentJoin":{"I":["IDInspectionDocumentJoin","GUIDInspectionDocumentJoin"],"D":["Deleted","IDInspection","IDDocument","IncludeOnDossier","Ordinal"],"N":["IDInspection","IDDocument","Ordinal"]},"InspectionEventLog":{"I":["IDInspectionEventLog","GUIDInspectionEventLog"],"D":["Deleted","IDInspection","Event","IDUser","Datum"],"N":["IDInspection","IDUser"]},"InspectionPhysicalAssetJoin":{"I":["IDInspectionPhysicalAssetJoin","GUIDInspectionPhysicalAssetJoin"],"D":["Deleted","IDInspection","IDPhysicalAsset"],"N":["IDInspection","IDPhysicalAsset"]},"InspectionStatus":{"I":["IDInspectionStatus","GUIDInspectionStatus"],"D":["Deleted","Code","Description","Ordinal"],"N":["Ordinal"]},"InspectionType":{"I":["IDInspectionType","GUIDInspectionType"],"D":["Deleted","Name","Description"],"N":[]},"InspectionTypeReportNamedInstanceJoin":{"I":["IDInspectionTypeReportNamedInstanceJoin","GUIDInspectionTypeReportNamedInstanceJoin"],"D":["Deleted","IDInspectionType","IDReportNamedInstance","Required","Ordinal"],"N":["IDInspectionType","IDReportNamedInstance","Ordinal"]},"InspectionUserJoin":{"I":["IDInspectionUserJoin","GUIDInspectionUserJoin"],"D":["Deleted","IDInspection","IDUser"],"N":["IDInspection","IDUser"]},"IntegrationAdapter":{"I":["IDIntegrationAdapter","GUIDIntegrationAdapter"],"D":["Deleted","CompletionTime","Name","Status","RecordCount","Progress","Datum"],"N":["RecordCount","Progress"]},"IntegrationAdapterEvent":{"I":["IDIntegrationAdapterEvent","GUIDIntegrationAdapterEvent"],"D":["IDIntegrationAdapter","Deleted","CompletionTime","Name","Status","RecordCount","Progress","Datum"],"N":["IDIntegrationAdapter","RecordCount","Progress"]},"InternalMessaging":{"I":["IDMessage","GUIDMessage"],"D":["Deleted","Subject","MessageText","FromID","ToID","HasRead","MetaDataJSON"],"N":["FromID","ToID"]},"Job":{"I":["IDJob","GUIDJob"],"D":["Deleted","AssignedTime","AssignedWorkerID","CompletionTime","Type","ParametersJSON","OutputJSON","OutputMetadataJSON","Logs","Status","ParentIDJob"],"N":["ParentIDJob"]},"JobDependency":{"I":["IDJobDependency","GUIDJobDependency"],"D":["AssignedTime","FromIDJob","FromJobType","ToIDJob","ToJobType"],"N":["FromIDJob","ToIDJob"]},"JobPolyJoin":{"I":["IDJobPolyJoin","GUIDJobPolyJoin"],"D":["Deleted","EntityType","IDEntity","IDJob"],"N":["IDEntity","IDJob"]},"JobType":{"I":["IDJobType","GUIDJobType"],"D":["Deleted","Hash","Name","Description","IDStage"],"N":["IDStage"]},"Lab":{"I":["IDLab","GUIDLab"],"D":["Deleted","Name","IDOrganization","IDOrganizationAddress","ExternalOrganization","Notes","IDLabParent","ExternalLabID","BypassReceived","AggregateTo"],"N":["IDOrganization","IDOrganizationAddress","IDLabParent","BypassReceived"]},"LabMaterialAssignment":{"I":["IDLabMaterialAssignment","GUIDLabMaterialAssignment"],"D":["Deleted","IDLab","IDLabParent","IDMaterial","SampleType","ProductGroup"],"N":["IDLab","IDLabParent","IDMaterial"]},"LabTeamJoin":{"I":["IDLabTeamJoin","GUIDLabTeamJoin"],"D":["Deleted","IDLab","IDTeam","IDRole","SupportKind"],"N":["IDLab","IDTeam","IDRole"]},"LabTestApproval":{"I":["IDLabTestApproval","GUIDLabTestApproval"],"D":["Deleted","IDLab","IDTest","DateStart","DateEnd","Notes"],"N":["IDLab","IDTest"]},"LabTestDefault":{"I":["IDLabTestDefault","GUIDLabTestDefault"],"D":["Deleted","IDLab","IDMaterial","IDTest","SampleType","StartStatus","RequiredAssign","Autofinalize","DefinedTest","TestRuns"],"N":["IDLab","IDMaterial","IDTest","StartStatus","TestRuns"]},"LabTestSpecificationSetJoin":{"I":["IDLabTestSpecificationSetJoin","GUIDLabTestSpecificationSetJoin"],"D":["Deleted","IDLab","IDTestSpecificationSet"],"N":["IDLab","IDTestSpecificationSet"]},"LabUserJoin":{"I":["IDLabUserJoin","GUIDLabUserJoin"],"D":["IDLab","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"],"N":["IDLab","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"]},"LabUserMaterialJoin":{"I":["IDLabUserMaterialJoin","GUIDLabUserMaterialJoin"],"D":["IDLab","IDUser","IDMaterial","IDRole","FirstContact"],"N":["IDLab","IDUser","IDMaterial","IDRole"]},"LatestSampleByLog":{"I":["GUIDSample","GUIDSampleLog"],"D":["IDSample","Deleted","SampleCreateDate","SampleCreatingIDUser","SampleUpdateDate","SampleUpdatingIDUser","SampleDeleted","SampleDeleteDate","SampleDeletingIDUser","SampleExternalSyncDate","DesignatedTime","QRCode","SampleCaptureLatitude","SampleCaptureLongitude","Name","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","Notes","Status","LabControlNumber","LabReferenceNumber","ProductName","MaterialType","IDOrganization","IDMixDesign","ManufacturerCode","IntendedUse","BuyUSA","ReceivedFrom","GeographicalArea","Station","Offset","RepresentedQuantity","SampledQuantity","SampledQuantityUnits","RepresentedQuantityUnits","Units","RequestedBy","SampleExternalSyncGUID","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser","Datum","IDSampleLog","SampleLogCreateDate","SampleLogCreatingIDUser","SampleLogUpdateDate","SampleLogUpdatingIDUser","SampleLogDeleted","SampleLogDeleteDate","SampleLogExternalSyncDate","SampleLogCaptureLatitude","SampleLogCaptureLongitude","CaptureDate","FromStatus","ToStatus","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Ordinal","Received","IDLab","SampleLogNotes","SampleLogExternalSyncGUID"],"N":["IDSample","SampleCreatingIDUser","SampleUpdatingIDUser","SampleDeletingIDUser","SampleCaptureLatitude","SampleCaptureLongitude","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","IDOrganization","IDMixDesign","RepresentedQuantity","SampledQuantity","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser","IDSampleLog","SampleLogCreatingIDUser","SampleLogUpdatingIDUser","SampleLogCaptureLatitude","SampleLogCaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Ordinal","IDLab"]},"Layer":{"I":["IDLayer","GUIDLayer"],"D":["Deleted","Name","Type","BoundingUnits","BoundingLeft","BoundingRight","BoundingTop","BoundingBottom","IDLayerSet"],"N":["BoundingLeft","BoundingRight","BoundingTop","BoundingBottom","IDLayerSet"]},"LayerSet":{"I":["IDLayerSet","GUIDLayerSet"],"D":["Deleted","Title"],"N":[]},"LineItem":{"I":["IDLineItem","GUIDLineItem"],"D":["Name","Description","Notes","Units","SpecificationYear","ItemCode","ItemNumber","CostPerUnit","ExpectedQuantity","ContractorReportedQuantity","ActualQuantity","ContractQuantity","InstalledQuantity","ChangeOrderQuantity","ChangeOrderQuantityPending","Tax","ChangeOrderNumber","FundingCategory","IDFundingCategory","Status","ProposalIdentifier","PercentComplete","CategoryNumber","Retainage","ImprovementType","DeliveryDate","Deleted","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject","FHWAEligible"],"N":["SpecificationYear","CostPerUnit","ExpectedQuantity","ContractorReportedQuantity","ActualQuantity","ContractQuantity","InstalledQuantity","ChangeOrderQuantity","ChangeOrderQuantityPending","Tax","IDFundingCategory","PercentComplete","Retainage","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject"]},"LineItemChangeOrder":{"I":["IDLineItemChangeOrder","GUIDLineItemChangeOrder"],"D":["Deleted","ChangeNumber","Name","Description","Notes","Units","Amount","CommitmentNumber","ItemNumber","Quantity","CostPerUnit","ChangeQuantity","AdditionalDays","CommitmentChangeStatus","ReasonCode","DateOfChange","ApprovedByDate","CommitmentChangeAmount","Tax","FormIDDocument","IDLineItem","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject","IDChangeOrder","IDFundingCategory","CategoryNumber"],"N":["Amount","CostPerUnit","ChangeQuantity","AdditionalDays","CommitmentChangeAmount","Tax","FormIDDocument","IDLineItem","ParentIDLineItem","IDPayItem","IDBidItem","IDContract","IDProject","IDChangeOrder","IDFundingCategory"]},"LineItemExternalSystemMapping":{"I":["IDLineItemExternalSystemMapping","GUIDLineItemExternalSystemMapping"],"D":["Deleted","IDLineItem","ExternalSystemHash","ExternalSystemGUID","ExternalSyncDirection","IDProject"],"N":["IDLineItem","IDProject"]},"LineItemLotJoin":{"I":["IDLineItemLotJoin","GUIDLineItemLotJoin"],"D":["IDLot","IDLineItem"],"N":["IDLot","IDLineItem"]},"LineItemOrganizationJoin":{"I":["IDLineItemOrganizationJoin","GUIDLineItemOrganizationJoin"],"D":["DisadvantagedBusiness","IDLineItem","IDOrganization"],"N":["IDLineItem","IDOrganization"]},"ListDefault":{"I":["IDListDefault","GUIDListDefault"],"D":["Deleted","NamespaceKey","NamespaceValue","IDProject","Hash","Value","IDListDefaultType"],"N":["IDProject","IDListDefaultType"]},"ListDefaultListDefaultJoin":{"I":["IDListDefaultListDefaultJoin","GUIDListDefaultListDefaultJoin"],"D":["Deleted","ScopeIDListDefault","IDListDefault"],"N":["ScopeIDListDefault","IDListDefault"]},"ListDefaultType":{"I":["IDListDefaultType","GUIDListDefaultType"],"D":["Deleted","Name","Description","NamespaceKey","NamespaceValue"],"N":[]},"Location":{"I":["IDLocation","GUIDLocation"],"D":["Deleted","Type","Name","Description","QRCode","Address","ExternalLocationID","ParentIDLocation","City","State","Zip","Phone","Latitude","Longitude"],"N":["ParentIDLocation","Latitude","Longitude"]},"Lot":{"I":["IDLot","GUIDLot"],"D":["Deleted","StartDate","FormData","IDMixDesign","IDContract","ValidationSequence","LPSyncDate","HLSyncDate","Name"],"N":["IDMixDesign","IDContract","ValidationSequence"]},"ManifestSchema":{"I":["IDManifestSchema","GUIDManifestSchema"],"D":["Deleted","Hash","Type","SubType","Title","Version","Description","Manifest","IDArtifact"],"N":["Version","IDArtifact"]},"ManifestSchemaManifestSchemaPartialJoin":{"I":["IDManifestSchemaManifestSchemaPartialJoin","GUIDManifestSchemaManifestSchemaPartialJoin"],"D":["IDManifestSchema","IDManifestSchemaPartial","Ordinal"],"N":["IDManifestSchema","IDManifestSchemaPartial","Ordinal"]},"ManifestSchemaPartial":{"I":["IDManifestSchemaPartial","GUIDManifestSchemaPartial"],"D":["Deleted","Hash","Type","Title","Ordinal","Version","Description","ManifestPartial"],"N":["Ordinal","Version"]},"ManifestSet":{"I":["IDManifestSet","GUIDManifestSet"],"D":["Deleted","Hash","Type","SubType"],"N":[]},"ManifestSetManifestSchemaJoin":{"I":["IDManifestSetManifestSchemaJoin","GUIDManifestSetManifestSchemaJoin"],"D":["IDManifestSet","IDManifestSchema","Ordinal"],"N":["IDManifestSet","IDManifestSchema","Ordinal"]},"ManifestSetManifestSetJoin":{"I":["IDManifestSetManifestSetJoin","GUIDManifestSetManifestSetJoin"],"D":["IDManifestSet","IncludedIDManifestSet","Ordinal"],"N":["IDManifestSet","IncludedIDManifestSet","Ordinal"]},"Material":{"I":["IDMaterial","GUIDMaterial"],"D":["Deleted","Name","NameAbbreviated","Type","Description","CatalogCode","UnitsMetric","UnitsImperial","Active","BrandNameRequired","MaterialCode","IDMaterialParent","Category","CategoryName","ItemSection","ItemCode"],"N":["IDMaterialParent","Category"]},"MaterialLineItemJoin":{"I":["IDMaterialLineItemJoin","GUIDMaterialLineItemJoin"],"D":["Deleted","IDLineItem","IDMaterial","ConversionFactor","ApprovedSourceRequired","SpecialInstructions","Units","SampleRate","RequiredSampleCount","SampleFrequency","Quantity"],"N":["IDLineItem","IDMaterial","ConversionFactor","SampleRate","RequiredSampleCount","SampleFrequency","Quantity"]},"MaterialManifestSetJoin":{"I":["IDMaterialManifestSetJoin","GUIDMaterialManifestSetJoin"],"D":["IDMaterial","IDManifestSet","Ordinal"],"N":["IDMaterial","IDManifestSet","Ordinal"]},"MaterialPayItemJoin":{"I":["IDMaterialPayItemJoin","GUIDMaterialPayItemJoin"],"D":["Deleted","Approved","DefaultConversionFactor","DefaultRate","DefaultFrequency","SpecialInstructions","IDPayItem","IDMaterial"],"N":["DefaultConversionFactor","DefaultRate","DefaultFrequency","IDPayItem","IDMaterial"]},"MaterialRecordOfMaterialEntryJoin":{"I":["IDMaterialRecordOfMaterialEntryJoin","GUIDMaterialRecordOfMaterialEntryJoin"],"D":["Deleted","IDMaterial","IDRecordOfMaterialEntry"],"N":["IDMaterial","IDRecordOfMaterialEntry"]},"MaterializedProjection":{"I":["IDMaterializedProjection","GUIDMaterializedProjection"],"D":["Deleted","ProjectionName","PhysicalTableName","ProjectionClass","MeadowSchemaJSON","SourceType","SourceDescriptor","SourceConfigJSON","Description","SourceAddress","TargetAddress","OperationType","OperationDefHash","CompiledOperationHash","RefreshEnabled","RefreshCron","RefreshIntervalMinutes","RefreshGroup","RefreshOrdinal","LastRefreshDate","LastRefreshStatus","UserCustomized"],"N":["RefreshIntervalMinutes","RefreshOrdinal"]},"MaterializedProjectionArchive":{"I":["IDMaterializedProjectionArchive","GUIDMaterializedProjectionArchive"],"D":["Deleted","IDMaterializedProjection","IDMaterializedProjectionVersion","ArchiveSequence","SourceTableName","ArchiveTableName","SchemaHash","Status","Reason","RetentionDate","RestoredDate","PrunedDate"],"N":["IDMaterializedProjection","IDMaterializedProjectionVersion","ArchiveSequence"]},"MaterializedProjectionIngestRun":{"I":["IDMaterializedProjectionIngestRun","GUIDMaterializedProjectionIngestRun"],"D":["Deleted","IDMaterializedProjection","BeaconWorkItemGUID","StartDate","EndDate","Status","SourceType","SourceDescriptor","RowsRead","RowsWritten","RowsSkipped","RowsErrored","ErrorSummaryJSON","StatsJSON","IDMaterializedProjectionPipelineRun","StageSequence","RunHash","OperationDefHash"],"N":["IDMaterializedProjection","RowsRead","RowsWritten","RowsSkipped","RowsErrored","IDMaterializedProjectionPipelineRun","StageSequence"]},"MaterializedProjectionPipelineRun":{"I":["IDMaterializedProjectionPipelineRun","GUIDMaterializedProjectionPipelineRun"],"D":["Deleted","PipelineName","GrossStatus","StageCount","StagesSucceeded","StagesFailed","CurrentStageSequence","StopOnFailure","StartDate","EndDate","PlanJSON","FailedStage","BeaconAction","ErrorCode","Reason","StatsJSON"],"N":["StageCount","StagesSucceeded","StagesFailed","CurrentStageSequence","ErrorCode"]},"MaterializedProjectionVersion":{"I":["IDMaterializedProjectionVersion","GUIDMaterializedProjectionVersion"],"D":["Deleted","IDMaterializedProjection","VersionSequence","SchemaHash","MeadowSchemaJSON","ChangeNotes"],"N":["IDMaterializedProjection","VersionSequence"]},"MixDesign":{"I":["IDMixDesign","GUIDMixDesign"],"D":["Deleted","MixMetadata","IDMaterial","MaterialCode","IDOrganization","LPSyncDate","HLSyncDate","MixID","Name","Description","Formula","IDMixType"],"N":["IDMaterial","IDOrganization","IDMixType"]},"MixDesignApproval":{"I":["IDMixDesignApproval","GUIDMixDesignApproval"],"D":["Deleted","IDMixDesign","IDContract","IDProject","LPSyncDate","HLSyncDate"],"N":["IDMixDesign","IDContract","IDProject"]},"MixSpecification":{"I":["IDMixSpecification","GUIDMixSpecification"],"D":["Deleted","Name","Description","Code","MaterialType","EffectiveDate","ExpirationDate","ApprovalDate","ApprovingIDUser"],"N":["ApprovingIDUser"]},"MixSpecificationMaterialJoin":{"I":["IDMixSpecificationMaterialJoin","GUIDMixSpecificationMaterialJoin"],"D":["Deleted","IDMixSpecification","IDMaterial"],"N":["IDMixSpecification","IDMaterial"]},"MixSpecificationOrganizationMaterialJoin":{"I":["IDMixSpecificationOrganizationMaterialJoin","GUIDMixSpecificationOrganizationMaterialJoin"],"D":["Deleted","Approved","Comments","MaterialType","IDMixSpecification","IDMaterial","IDOrganization","StartDate","EndDate"],"N":["IDMixSpecification","IDMaterial","IDOrganization"]},"MixType":{"I":["IDMixType","GUIDMixType"],"D":["Deleted","Name","Code","Description","Active","ApprovingAgency","MetaDataJSON","IDMaterial","MetaData"],"N":["IDMaterial"]},"Module":{"I":["IDModule","GUIDModule"],"D":["Deleted","Name","Ordinal","Management","ModuleHash","ModuleType","ConfigurationJSON"],"N":["Ordinal"]},"ModuleConfigurationProjectJoin":{"I":["IDModuleConfigurationProjectJoin","GUIDModuleConfigurationProjectJoin"],"D":["Deleted","IDProject","ModuleHash","ConfigurationJSON"],"N":["IDProject"]},"Notification":{"I":["IDNotification","GUIDNotification"],"D":["IDNotificationRule","RecipientIDUser","NotificationMessage","Unread","NotificationType"],"N":["IDNotificationRule","RecipientIDUser"]},"NotificationDeliveryRule":{"I":["IDNotificationDeliveryRule","GUIDNotificationDeliveryRule"],"D":["Deleted","NotificationRule","DeliveryMethod","Address"],"N":["NotificationRule"]},"NotificationRule":{"I":["IDNotificationRule","GUIDNotificationRule"],"D":["RecipientIDUser","Entity","Filter"],"N":["RecipientIDUser"]},"Observation":{"I":["IDObservation","GUIDObservation"],"D":["Deleted","Name","Description","DesignatedTime","IDDevice","ObservationType","Status","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","IDProject","Priority","Version","SpritePage","AppHash","StateName","StateStep","Locked","Transcoded","ExternalSyncGUID"],"N":["IDDevice","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","IDProject","Version","SpritePage","StateStep"]},"ObservationApprovalLog":{"I":["IDObservationApprovalLog","GUIDObservationApprovalLog"],"D":["Deleted","IDObservation","IDElectronicSignature","Status","Action","StateStep","AfterStatus","IsApproval"],"N":["IDObservation","IDElectronicSignature","StateStep"]},"ObservationApprovalState":{"I":["IDObservationApprovalState","GUIDObservationApprovalState"],"D":["Deleted","Hash","Name"],"N":[]},"ObservationApprovalStep":{"I":["IDObservationApprovalStep","GUIDObservationApprovalStep"],"D":["Deleted","IDObservationApprovalState","Ordinal","ObservationType","IDProject","IDRole","IncludeHigherRoles","PerformLock"],"N":["IDObservationApprovalState","Ordinal","IDProject","IDRole"]},"ObservationApprovalWorkflow":{"I":["IDObservationApprovalWorkflow"],"D":["FromStatus","EdgeOptions","ToStatus","Name","IDProject"],"N":["IDProject"]},"ObservationArchive":{"I":["IDObservationArchive","GUIDObservationArchive","GUIDObservation"],"D":["IDObservation","Deleted","Name","Description","DesignatedTime","IDDevice","ObservationType","Status","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","IDProject","Priority","Version","SpritePage","SnapshotJSON","AppHash","StateName","StateStep","Locked","Transcoded","ExternalSyncGUID"],"N":["IDObservation","IDDevice","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","IDProject","Version","SpritePage","StateStep"]},"ObservationArtifactJoin":{"I":["IDObservationArtifactJoin","GUIDObservationArtifactJoin"],"D":["Deleted","IDObservation","IDArtifact","IDObservationRequirementSpecification"],"N":["IDObservation","IDArtifact","IDObservationRequirementSpecification"]},"ObservationCommentJoin":{"I":["IDObservationCommentJoin","GUIDObservationCommentJoin"],"D":["IDObservation","IDComment"],"N":["IDObservation","IDComment"]},"ObservationDataSetJoin":{"I":["IDObservationDataSetJoin","GUIDObservationDataSetJoin"],"D":["Deleted","IDObservation","IDDataSet"],"N":["IDObservation","IDDataSet"]},"ObservationDocumentStatistics":{"I":["IDObservationDocumentStatistics","GUIDObservationDocumentStatistics"],"D":["IDObservation","DocumentCount","ApprovedDocumentCount","RejectedDocumentCount"],"N":["IDObservation","DocumentCount","ApprovedDocumentCount","RejectedDocumentCount"]},"ObservationElectronicSignatureJoin":{"I":["IDObservationElectronicSignatureJoin","GUIDObservationElectronicSignatureJoin"],"D":["IDObservation","IDElectronicSignature"],"N":["IDObservation","IDElectronicSignature"]},"ObservationExtraMetadata":{"I":["IDObservationExtraMetadata","GUIDObservationExtraMetadata"],"D":["Deleted","IDObservation","Hash","Value","Datum"],"N":["IDObservation"]},"ObservationExtraMetadataAggregation":{"I":["IDObservationExtraMetadataAggregation","GUIDObservationExtraMetadataAggregation"],"D":["Deleted","IDObservation","Metadata"],"N":["IDObservation"]},"ObservationExtraMetadataHashDescription":{"I":["IDObservationExtraMetadataHashDescription","GUIDObservationExtraMetadataHashDescription"],"D":["Deleted","Hash","Title","Description","Metadata"],"N":[]},"ObservationLayerJoin":{"I":["IDObservationLayerJoin","GUIDObservationLayerJoin"],"D":["Deleted","IDObservation","IDLayer"],"N":["IDObservation","IDLayer"]},"ObservationManifest":{"I":["IDObservationManifest","GUIDObservationManifest"],"D":["Deleted","Name","DisplayName","SettingsJSON","Category"],"N":[]},"ObservationOrganizationJoin":{"I":["IDObservationOrganizationJoin","GUIDObservationOrganizationJoin"],"D":["IDObservation","IDOrganization"],"N":["IDObservation","IDOrganization"]},"ObservationRequirementSpecification":{"I":["IDObservationRequirementSpecification","GUIDObservationRequirementSpecification"],"D":["Deleted","IDArtifactType","IDObservationManifest","Name","CountMinimum","CountMaximum","Required","DefaultJSON"],"N":["IDArtifactType","IDObservationManifest","CountMinimum","CountMaximum"]},"ObservationSet":{"I":["IDObservationSet","GUIDObservationSet"],"D":["Deleted","Name","Description","DesignatedTime","IDProject"],"N":["IDProject"]},"ObservationSetObservationJoin":{"I":["IDObservationSetObservationJoin","GUIDObservationSetObservationJoin"],"D":["Deleted","IDObservationSet","IDObservation"],"N":["IDObservationSet","IDObservation"]},"ObservationSyncUpdate":{"I":["IDObservationSyncUpdate"],"D":["IDObservation","OriginalUpdateDate","IDDevice"],"N":["IDObservation","IDDevice"]},"ObservationTag":{"I":["IDObservationTag","GUIDObservationTag"],"D":["Tag","TagType","Description","IDOrganization","IDBidItem","IDLineItem","Global"],"N":["IDOrganization","IDBidItem","IDLineItem"]},"ObservationTagJoin":{"I":["IDObservationTagJoin","GUIDObservationTagJoin"],"D":["IDObservation","Tag","TagType","IDObservationTag"],"N":["IDObservation","IDObservationTag"]},"ObservationTagProjectJoin":{"I":["IDObservationTagProjectJoin","GUIDObservationTagProjectJoin"],"D":["Tag","TagType","IDProject","IDObservationTag","IDOrganization"],"N":["IDProject","IDObservationTag","IDOrganization"]},"Organization":{"I":["IDOrganization","GUIDOrganization"],"D":["Deleted","Name","DisadvantagedBusiness","Approved","Address","ExternalOrganizationID","City","State","Zip","Phone","Email","Type","VendorCode","FederalTaxCode"],"N":[]},"OrganizationAddress":{"I":["IDOrganizationAddress","GUIDOrganizationAddress"],"D":["Deleted","IDOrganization","LocationName","LocationType","Address","City","State","Zip","Phone","Email","Latitude","Longitude"],"N":["IDOrganization","Latitude","Longitude"]},"OrganizationApprovedTransactions":{"I":["IDOrganizationApprovedTransactions","GUIDOrganizationApprovedTransactions"],"D":["IDOrganization","IDProject","Approved"],"N":["IDOrganization","IDProject"]},"OrganizationDisadvantagedBusinessTransactions":{"I":["IDOrganizationDisadvantagedBusinessTransactions","GUIDOrganizationDisadvantagedBusinessTransactions"],"D":["IDOrganization","DisadvantagedBusiness"],"N":["IDOrganization"]},"OrganizationMaterialJoin":{"I":["IDOrganizationMaterialJoin","GUIDOrganizationMaterialJoin"],"D":["Deleted","IDOrganization","IDMaterial","EffectiveDate","ExpirationDate","ApprovedStatusType","SourceType"],"N":["IDOrganization","IDMaterial"]},"OverrideAxiom":{"I":["IDOverrideAxiom","GUIDOverrideAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"OverrideAxiomAxiomEntitySetJoin":{"I":["IDOverrideAxiomAxiomEntitySetJoin","GUIDOverrideAxiomAxiomEntitySetJoin"],"D":["Deleted","IDOverrideAxiom","IDAxiomEntitySet"],"N":["IDOverrideAxiom","IDAxiomEntitySet"]},"PayItem":{"I":["IDPayItem","GUIDPayItem"],"D":["Deleted","Name","Description","FunctionalClass","Units","Amount","SpecificationYear","IDTestSpecificationSet","Section","ItemCode","ExtendedJSON","ExternalPayItemID","FHWAEligible"],"N":["Amount","IDTestSpecificationSet"]},"PayItemMaterialTestRequirement":{"I":["IDPayItemMaterialTestRequirement","GUIDPayItemMaterialTestRequirement"],"D":["Deleted","IDTestSpecificationSet","IDPayItem","IDMaterial","IDTest","SampleType","SampleFrequency","SampleUnit"],"N":["IDTestSpecificationSet","IDPayItem","IDMaterial","IDTest","SampleFrequency"]},"PayItemTestSpecificationSetJoin":{"I":["IDPayItemTestSpecificationSetJoin","GUIDPayItemTestSpecificationSetJoin"],"D":["Deleted","IDPayItem","IDTestSpecificationSet"],"N":["IDPayItem","IDTestSpecificationSet"]},"Payment":{"I":["IDPayment","GUIDPayment"],"D":["Deleted","Hash","Code","Name","Description","PaymentDate","PeriodStartDate","PeriodEndDate","EntityName","IDEntity","SourceIDAccount","DestinationIDAccount","QuantityApproved","FundingApproved","Approved"],"N":["IDEntity","SourceIDAccount","DestinationIDAccount"]},"PaymentEntry":{"I":["IDPaymentEntry","GUIDPaymentEntry"],"D":["Deleted","IDPayment","Name","Description","Quantity","Unit","PricePerUnit","PriceAdjustment","WithheldAmount","CalculatedAmount","IDPaymentTransaction","IDPaymentEntryType","EntityName","IDEntity","QuantityApproved","FundingApproved","EntryDate"],"N":["IDPayment","Quantity","PricePerUnit","PriceAdjustment","WithheldAmount","CalculatedAmount","IDPaymentTransaction","IDPaymentEntryType","IDEntity"]},"PaymentEntryFunding":{"I":["IDPaymentEntryFunding","GUIDPaymentEntryFunding"],"D":["Deleted","Name","Description","IDPaymentEntry","IDAccount","IDPaymentTransaction","Amount","MappingReasoning","UserComment"],"N":["IDPaymentEntry","IDAccount","IDPaymentTransaction","Amount"]},"PaymentEntryObservationJoin":{"I":["IDPaymentEntryObservationJoin","GUIDPaymentEntryObservationJoin"],"D":["Deleted","IDPaymentEntry","IDObservation"],"N":["IDPaymentEntry","IDObservation"]},"PaymentEntryType":{"I":["IDPaymentEntryType","GUIDPaymentEntryType"],"D":["Deleted","Name","Hash","Description"],"N":[]},"PaymentFundingSnapshot":{"I":["IDPaymentFundingSnapshot","GUIDPaymentFundingSnapshot"],"D":["Deleted","PartialPaymentIDDocument","ScenarioJSON"],"N":["PartialPaymentIDDocument"]},"PaymentFundingSnapshotHistory":{"I":["IDPaymentFundingSnapshotHistory","GUIDPaymentFundingSnapshotHistory","GUIDPaymentFundingSnapshot"],"D":["IDPaymentFundingSnapshot","Deleted","PartialPaymentIDDocument","ScenarioJSON"],"N":["IDPaymentFundingSnapshot","PartialPaymentIDDocument"]},"PaymentTransaction":{"I":["IDPaymentTransaction","GUIDPaymentTransaction"],"D":["Deleted","IDSourceAccount","IDDestinationAccount","IDPayment","TransactionAmount","Pending","TransactionTime","Voided","VoidTime"],"N":["IDSourceAccount","IDDestinationAccount","IDPayment","TransactionAmount"]},"PermDocumentUser":{"I":["IDPermDocumentUser","GUIDPermDocumentUser"],"D":["IDDocument","IDUser","ComputedDate"],"N":["IDDocument","IDUser"]},"PermProjectUser":{"I":["IDPermProjectUser","GUIDPermProjectUser"],"D":["IDProject","IDUser"],"N":["IDProject","IDUser"]},"PermUserRole":{"I":["IDPermUserRole","GUIDPermUserRole"],"D":["IDUser","IDRole","SourceRule","ComputedDate"],"N":["IDUser","IDRole"]},"PhysicalAsset":{"I":["IDPhysicalAsset","GUIDPhysicalAsset"],"D":["Deleted","Name","Description","OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDAssetClassification","IDAssetType","ParentIDPhysicalAsset","ManifestVersion","ExternalSyncGUID","AssetNumber","YearBuilt","IDFIPSState","IDFIPSCounty"],"N":["OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDAssetClassification","IDAssetType","ParentIDPhysicalAsset","ManifestVersion","IDFIPSState","IDFIPSCounty"]},"PhysicalAssetArtifactJoin":{"I":["IDPhysicalAssetArtifactJoin","GUIDPhysicalAssetArtifactJoin"],"D":["IDPhysicalAsset","IDArtifact"],"N":["IDPhysicalAsset","IDArtifact"]},"PhysicalAssetBridgeJoin":{"I":["IDPhysicalAssetBridgeJoin","GUIDPhysicalAssetBridgeJoin"],"D":["IDPhysicalAsset","IDBridge"],"N":["IDPhysicalAsset","IDBridge"]},"PhysicalAssetDataSnapshot":{"I":["IDPhysicalAssetDataSnapshot","GUIDPhysicalAssetDataSnapshot"],"D":["Deleted","IDPhysicalAsset","Type","SubType","EffectiveDate","PublicationDate","Source","SourceVersion","SnapshotJSON"],"N":["IDPhysicalAsset"]},"PhysicalAssetDataSummary":{"I":["IDPhysicalAssetDataSummary","GUIDPhysicalAssetDataSummary"],"D":["Deleted","IDPhysicalAsset","Type","SubType","EffectiveDate","Source","SummaryJSON","ManifestGUID"],"N":["IDPhysicalAsset"]},"PhysicalAssetDefect":{"I":["IDPhysicalAssetDefect","GUIDPhysicalAssetDefect"],"D":["Deleted","Code","Name","Description","Notes","PrimaryDocumentationURL","StateDescriptionsJSON"],"N":[]},"PhysicalAssetElement":{"I":["IDPhysicalAssetElement","GUIDPhysicalAssetElement"],"D":["Deleted","Name","Description","Quantity","Units","OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDPhysicalAsset","IDAssetType","IDPhysicalAssetMaterial","IDPhysicalAssetElementType","ManifestVersion","ExternalSyncGUID"],"N":["Quantity","OriginLatitude","OriginLongitude","BoundingMinLatitude","BoundingMaxLatitude","BoundingMinLongitude","BoundingMaxLongitude","IDPhysicalAsset","IDAssetType","IDPhysicalAssetMaterial","IDPhysicalAssetElementType","ManifestVersion"]},"PhysicalAssetElementCondition":{"I":["IDPhysicalAssetElementCondition","GUIDPhysicalAssetElementCondition"],"D":["Deleted","IDPhysicalAssetElement","IDPhysicalAsset","EffectiveDate","PublicationDate","Year","Source","TotalQuantity","QuantitiesJSON"],"N":["IDPhysicalAssetElement","IDPhysicalAsset","TotalQuantity"]},"PhysicalAssetElementPhysicalAssetDefectJoin":{"I":["IDPhysicalAssetElementPhysicalAssetDefectJoin","GUIDPhysicalAssetElementPhysicalAssetDefectJoin"],"D":["Deleted","IDPhysicalAssetElement","IDPhysicalAssetDefect","Year","TotalQuantity","QuantitiesJSON"],"N":["IDPhysicalAssetElement","IDPhysicalAssetDefect","TotalQuantity"]},"PhysicalAssetElementType":{"I":["IDPhysicalAssetElementType","GUIDPhysicalAssetElementType"],"D":["Deleted","Code","Section","SectionCode","Name","Unit","Clarification","IDPhysicalAssetMaterial"],"N":["IDPhysicalAssetMaterial"]},"PhysicalAssetElementTypePhysicalAssetDefectJoin":{"I":["IDPhysicalAssetElementTypePhysicalAssetDefectJoin","GUIDPhysicalAssetElementTypePhysicalAssetDefectJoin"],"D":["Deleted","IDPhysicalAssetElementType","IDPhysicalAssetDefect"],"N":["IDPhysicalAssetElementType","IDPhysicalAssetDefect"]},"PhysicalAssetMaterial":{"I":["IDPhysicalAssetMaterial","GUIDPhysicalAssetMaterial"],"D":["Deleted","IDMaterial","Code","Material","Description"],"N":["IDMaterial"]},"PhysicalAssetMetadata":{"I":["IDPhysicalAssetMetadata","GUIDPhysicalAssetMetadata"],"D":["Deleted","IDPhysicalAsset","IDPhysicalAssetElement","MetadataSetGUID","DataDate","Source","Quantity","Units","Value","Address","MetadataValue"],"N":["IDPhysicalAsset","IDPhysicalAssetElement","Quantity"]},"PhysicalAssetPhysicalAssetDefectJoin":{"I":["IDPhysicalAssetPhysicalAssetDefectJoin","GUIDPhysicalAssetPhysicalAssetDefectJoin"],"D":["IDPhysicalAsset","IDPhysicalAssetDefect"],"N":["IDPhysicalAsset","IDPhysicalAssetDefect"]},"PhysicalAssetPolyJoin":{"I":["IDPhysicalAssetPolyJoin","GUIDPhysicalAssetPolyJoin"],"D":["IDPhysicalAsset","RemoteType","IDRemote"],"N":["IDPhysicalAsset","IDRemote"]},"PlantMixApproval":{"I":["IDPlantMixApproval","GUIDPlantMixApproval"],"D":["Deleted","IDMixDesign","IDOrganization","ApprovalDate","ExpirationDate","LPSyncDate","HLSyncDate"],"N":["IDMixDesign","IDOrganization"]},"Product":{"I":["IDProduct","GUIDProduct"],"D":["Deleted","Name","ManufacturerCode","AcceptanceMethod","ProductCategory","CatalogCode","EffectiveDate","ExpirationDate","Comments","MetadataJSON","IDMaterial","IDOrganization","Metadata"],"N":["IDMaterial","IDOrganization"]},"ProductionPlant":{"I":["IDProductionPlant","GUIDProductionPlant"],"D":["Deleted","Name","IDOrganization","IDOrganizationAddress","Notes","ExternalProductionPlantID"],"N":["IDOrganization","IDOrganizationAddress"]},"ProductionPlantMaterialApproval":{"I":["IDProductionPlantMaterialApproval","GUIDProductionPlantMaterialApproval"],"D":["Deleted","IDMaterial","IDMixSpecification","IDProductionPlant","StartDate","EndDate","Notes"],"N":["IDMaterial","IDMixSpecification","IDProductionPlant"]},"Program":{"I":["IDProgram","GUIDProgram"],"D":["Deleted","Name","Description"],"N":[]},"Project":{"I":["IDProject","GUIDProject"],"D":["Deleted","ExternalSyncGUID","Name","Description","Latitude","Longitude","CustomProperties","IDProjectType","IDContract","Timezone","Status","ExternalProjectID","CostPerDay","OriginalContractedDays","ContractedDays","CompletedDays","PercentComplete","PercentCompleteByDays","IDOrganization","PurchaseOrderNumber","ImprovementTypeCode","InitialContractAmount","CurrentTotalContractAmount","CurrentTotalContractPaid","PaidDays"],"N":["Latitude","Longitude","IDProjectType","IDContract","CostPerDay","OriginalContractedDays","ContractedDays","CompletedDays","PercentComplete","PercentCompleteByDays","IDOrganization","InitialContractAmount","CurrentTotalContractAmount","CurrentTotalContractPaid","PaidDays"]},"ProjectContactJoin":{"I":["IDProjectContactJoin","GUIDProjectContactJoin"],"D":["IDProject","IDContact"],"N":["IDProject","IDContact"]},"ProjectDashboardJoin":{"I":["IDProjectDashboardJoin","GUIDProjectDashboardJoin"],"D":["IDProject","ConfigurationJSON"],"N":["IDProject"]},"ProjectDate":{"I":["IDProjectDate","GUIDProjectDate"],"D":["Deleted","Name","Hash","Date","IDProject"],"N":["IDProject"]},"ProjectEquipmentJoin":{"I":["IDProjectEquipmentJoin","GUIDProjectEquipmentJoin"],"D":["IDEquipment","IDOrganization","IDProject"],"N":["IDEquipment","IDOrganization","IDProject"]},"ProjectFile":{"I":["IDProjectFile","GUIDProjectFile"],"D":["Deleted","Name","Description","FileType","IDProject","IDProjectFileFolder","IDObservation","IDArtifact","ArtifactVersion"],"N":["IDProject","IDProjectFileFolder","IDObservation","IDArtifact","ArtifactVersion"]},"ProjectFileFolder":{"I":["IDProjectFileFolder","GUIDProjectFileFolder"],"D":["Deleted","Name","Description","IDProject","ParentIDProjectFileFolder"],"N":["IDProject","ParentIDProjectFileFolder"]},"ProjectLabJoin":{"I":["IDProjectLabJoin","GUIDProjectLabJoin"],"D":["IDProject","IDLab"],"N":["IDProject","IDLab"]},"ProjectLineItemMaterialTest":{"I":["IDProjectLineItemMaterialTest","GUIDProjectLineItemMaterialTest"],"D":["Deleted","IDTest","IDMaterial","IDLineItem","IDProject","Intent","ErrorOmission","ErrorOmissionDetail","TestDescription","SampleDescription","SamplingInstructions","SamplingRequirements","SampleSize","SampleUnits","Remarks","Rate","Frequency","Units","ManualUnits","ComputedRequiredSampleCount","ManualRequiredSampleCount","ComputedPlannedSampleCount","ManualPlannedSampleCount","CreatedSampleCount","PassingSampleCount","FailingSampleCount","ConversionFactor","IDLab","SampleType","SamplingPeriod","CertificateRequired","TestsNotRequired","ExternalSyncGUID"],"N":["IDTest","IDMaterial","IDLineItem","IDProject","ErrorOmission","SampleSize","Rate","Frequency","ComputedRequiredSampleCount","ManualRequiredSampleCount","ComputedPlannedSampleCount","ManualPlannedSampleCount","CreatedSampleCount","PassingSampleCount","FailingSampleCount","ConversionFactor","IDLab"]},"ProjectObservationManifestJoin":{"I":["IDProjectObservationManifestJoin","GUIDProjectObservationManifestJoin"],"D":["ObservationManifestName","Priority","Ordinal","Spreadsheet","Journal","IDProject"],"N":["Priority","Ordinal","IDProject"]},"ProjectObservationManifestModuleJoin":{"I":["IDProjectObservationManifestModuleJoin","GUIDProjectObservationManifestModuleJoin"],"D":["ModuleHash","IDProjectObservationManifestJoin","Enabled","Creatable"],"N":["IDProjectObservationManifestJoin"]},"ProjectOffice":{"I":["IDProjectOffice","GUIDProjectOffice"],"D":["Deleted","OfficeCode","Name","Address","City","State","Zip","Phone"],"N":[]},"ProjectOrganizationJoin":{"I":["IDProjectOrganizationJoin","GUIDProjectOrganizationJoin"],"D":["Deleted","DisadvantagedBusiness","IDProject","IDOrganization"],"N":["IDProject","IDOrganization"]},"ProjectSelectList":{"I":["IDProjectSelectList"],"D":["Deleted","ListType","Value","IDProject"],"N":["IDProject"]},"ProjectTagType":{"I":["IDProjectTagType","GUIDProjectTagType"],"D":["TagType","Name","Ordinal","IDProject"],"N":["Ordinal","IDProject"]},"ProjectType":{"I":["IDProjectType","GUIDProjectType"],"D":["Name","Hash","Description","SettingsJSON","Ordinal","IDProgram"],"N":["Ordinal","IDProgram"]},"ProjectTypeDefaultDate":{"I":["IDProjectTypeDefaultDate","GUIDProjectTypeDefaultDate"],"D":["Deleted","Name","Hash","IDProjectType"],"N":["IDProjectType"]},"ProjectUserDeviceSync":{"I":["IDProjectUserDeviceSync","GUIDProjectUserDeviceSync"],"D":["IDProject","IDUser","IDDevice","ModuleHash","SyncBackToDate"],"N":["IDProject","IDUser","IDDevice"]},"ProjectUserJoin":{"I":["IDProjectUserJoin","GUIDProjectUserJoin"],"D":["IDProject","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"],"N":["IDProject","IDUser","IDRole","SynthesizedIDRole","SynthesizedIDRoleContext"]},"RecordExtendedSchemaData":{"I":["IDRecordExtendedSchemaData","GUIDRecordExtendedSchemaData"],"D":["Deleted","EntityType","IDEntity","DataJSON"],"N":["IDEntity"]},"RecordOfMaterial":{"I":["IDRecordOfMaterial","GUIDRecordOfMaterial"],"D":["Deleted","IDProject","Notes"],"N":["IDProject"]},"RecordOfMaterialEntry":{"I":["IDRecordOfMaterialEntry","GUIDRecordOfMaterialEntry"],"D":["Deleted","IDProject","IDRecordOfMaterial","IDBidItem","IDLineItem","Notes"],"N":["IDProject","IDRecordOfMaterial","IDBidItem","IDLineItem"]},"RecordOfMaterialEntryArchive":{"I":["IDRecordOfMaterialEntryArchive","GUIDRecordOfMaterialEntryArchive"],"D":["Deleted","IDRecordOfMaterialEntry","RecordOfMaterialEntry"],"N":["IDRecordOfMaterialEntry"]},"ReportArchetype":{"I":["IDReportArchetype","GUIDReportArchetype"],"D":["Deleted","Archetype","OptionsJSON","Description"],"N":[]},"ReportNamedInstance":{"I":["IDReportNamedInstance","GUIDReportNamedInstance"],"D":["Deleted","Name","Hash","Ordinal","OptionsJSON","IDReportArchetype","DefaultReport"],"N":["Ordinal","IDReportArchetype"]},"ReportNamedInstanceManifestSchemaJoin":{"I":["IDReportNamedInstanceManifestSchemaJoin","GUIDReportNamedInstanceManifestSchemaJoin"],"D":["IDReportNamedInstance","IDManifestSchema","Ordinal"],"N":["IDReportNamedInstance","IDManifestSchema","Ordinal"]},"ReportNamedInstanceProjectJoin":{"I":["IDReportNamedInstanceProjectJoin","GUIDReportNamedInstanceProjectJoin"],"D":["IDReportNamedInstance","IDProject","Ordinal","IDProgram"],"N":["IDReportNamedInstance","IDProject","Ordinal","IDProgram"]},"Role":{"I":["IDRole","GUIDRole"],"D":["LinkedIDUser","Deleted","Name","PermissionLevel","Type","Description","LevelOrdinal"],"N":["LinkedIDUser","LevelOrdinal"]},"RoleContextMembership":{"I":["IDRoleContextMembership","GUIDRoleContextMembership"],"D":["IDRole","Context","IDContext"],"N":["IDRole","IDContext"]},"RoleEdge":{"I":["IDRoleEdge","GUIDRoleEdge"],"D":["Deleted","ParentIDRole","ChildIDRole"],"N":["ParentIDRole","ChildIDRole"]},"RoleExclusionAxiomJoin":{"I":["IDRoleExclusionAxiomJoin","GUIDRoleExclusionAxiomJoin"],"D":["Deleted","IDExclusionAxiom","IDRole"],"N":["IDExclusionAxiom","IDRole"]},"RoleInclusionAxiomJoin":{"I":["IDRolInclusioneAxiomJoin","GUIDRoleInclusionAxiomJoin"],"D":["Deleted","IDInclusionAxiom","IDRole"],"N":["IDInclusionAxiom","IDRole"]},"RoleModuleJoin":{"I":["IDRoleModuleJoin","GUIDRoleModuleJoin"],"D":["ModuleHash","IDRole"],"N":["IDRole"]},"RoleObservationManifestJoin":{"I":["IDRoleObservationManifestJoin","GUIDRoleObservationManifestJoin"],"D":["Deleted","IDRole","ObservationManifestName"],"N":["IDRole"]},"RoleOverrideAxiomJoin":{"I":["IDRolOverrideeAxiomJoin","GUIDRoleOverrideAxiomJoin"],"D":["Deleted","IDOverrideAxiom","IDRole"],"N":["IDOverrideAxiom","IDRole"]},"RolePermission":{"I":["IDRolePermission","GUIDRolePermission"],"D":["Hash","Allowed","IDRole","Context","IDContext"],"N":["IDRole","IDContext"]},"RoleReportNamedInstanceJoin":{"I":["IDRoleReportNamedInstanceJoin","GUIDRoleReportNamedInstanceJoin"],"D":["Deleted","IDRole","IDReportNamedInstance"],"N":["IDRole","IDReportNamedInstance"]},"RoleScopeAxiomJoin":{"I":["IDRoleScopeAxiomJoin","GUIDRoleScopeAxiomJoin"],"D":["Deleted","IDScopeAxiom","IDRole"],"N":["IDScopeAxiom","IDRole"]},"Sample":{"I":["IDSample","GUIDSample"],"D":["DesignatedTime","Deleted","QRCode","CaptureLatitude","CaptureLongitude","Name","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","Notes","Status","LabControlNumber","LabReferenceNumber","ProductName","MaterialType","IDOrganization","IDMixDesign","ManufacturerCode","IntendedUse","BuyUSA","ReceivedFrom","GeographicalArea","Station","Offset","RepresentedQuantity","SampledQuantity","SampledQuantityUnits","RepresentedQuantityUnits","Units","RequestedBy","ExternalSyncGUID","IDSampleType","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser","Datum","Locked","Sequenced"],"N":["CaptureLatitude","CaptureLongitude","IDProject","ParentIDSample","IDMaterial","IDProductionPlant","IDLineItem","IDOrganization","IDMixDesign","RepresentedQuantity","SampledQuantity","IDSampleType","IDProduct","SampledByIDUser","WitnessIDUser","AuthorizedIDUser","CMSIDUser"]},"SampleLabJoin":{"I":["IDSampleLabJoin","GUIDSampleLabJoin"],"D":["Deleted","IDLab","IDSample","Received"],"N":["IDLab","IDSample"]},"SampleLineItemJoin":{"I":["IDSampleLineItemJoin","GUIDSampleLineItemJoin"],"D":["Deleted","IDLineItem","IDSample","RepresentedQuantity"],"N":["IDLineItem","IDSample","RepresentedQuantity"]},"SampleLocationJoin":{"I":["IDSampleLocationJoin","GUIDSampleLocationJoin"],"D":["Deleted","IDSample","IDLocation"],"N":["IDSample","IDLocation"]},"SampleLog":{"I":["IDSampleLog","GUIDSampleLog"],"D":["Deleted","IDSample","CaptureDate","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Notes","Ordinal","Received","IDLab","ExternalSyncGUID","IDLocation","FromStatus","ToStatus"],"N":["IDSample","CaptureLatitude","CaptureLongitude","UserLatitude","UserLongitude","AlignmentStation","AlignmentOffset","Ordinal","IDLab","IDLocation"]},"SampleStatus":{"I":["IDSampleStatus","GUIDSampleStatus"],"D":["Deleted","Name","Hash","Description","Category","Ordinal","MetadataJSON"],"N":["Ordinal"]},"SampleType":{"I":["IDSampleType","GUIDSampleType"],"D":["Deleted","Name","Hash","Description","Category","MetadataJSON","Metadata"],"N":[]},"ScopeAxiom":{"I":["IDScopeAxiom","GUIDScopeAxiom"],"D":["Deleted","Verb","ValueAddress","ComparisonOperator","ValueSet","Allowed","FilterJSON"],"N":[]},"ScopeAxiomAxiomEntitySetJoin":{"I":["IDScopeAxiomAxiomEntitySetJoin","GUIDScopeAxiomAxiomEntitySetJoin"],"D":["Deleted","IDScopeAxiom","IDAxiomEntitySet"],"N":["IDScopeAxiom","IDAxiomEntitySet"]},"SentEmail":{"I":["IDSentEmail"],"D":["Source","EventStreamOffset","IDEmailSource","Handler","Email","Parameters","IDMailgun"],"N":["EventStreamOffset","IDEmailSource"]},"Stage":{"I":["IDStage","GUIDStage"],"D":["Deleted","Hash","Name","Description"],"N":[]},"Stockpile":{"I":["IDStockpile","GUIDStockpile"],"D":["Deleted","Name","Hash","Description"],"N":[]},"StockpileProjectJoin":{"I":["IDStockpileProjectJoin","GUIDStockpileProjectJoin"],"D":["Deleted","IDStockpile","IDProject"],"N":["IDStockpile","IDProject"]},"SubLot":{"I":["IDSubLot","GUIDSubLot"],"D":["Deleted","SubLotMetadata","IDLot","IDCore","IDMixDesign","IDContract","LPSyncDate","HLSyncDate","Name"],"N":["IDLot","IDCore","IDMixDesign","IDContract"]},"SyncLog":{"I":["IDLog","GUIDLog"],"D":["Task","SyncDate"],"N":[]},"Team":{"I":["IDTeam","GUIDTeam"],"D":["Deleted","Name","Hash","Description","ParentIDTeam"],"N":["ParentIDTeam"]},"TeamUserJoin":{"I":["IDTeamUserJoin","GUIDTeamUserJoin"],"D":["Deleted","IDTeam","IDUser","IDRole"],"N":["IDTeam","IDUser","IDRole"]},"Test":{"I":["IDTest","GUIDTest"],"D":["Deleted","Name","Description","Hash","Notes","Active","Standalone","Injectable","Collection","SmallQuantityExempt"],"N":[]},"TestCollectionJoin":{"I":["IDTestCollectionJoin","GUIDTestCollectionJoin"],"D":["Deleted","IDTest","IncludedIDTest"],"N":["IDTest","IncludedIDTest"]},"TestData":{"I":["IDTestData","GUIDTestData"],"D":["Deleted","DisplayName","IDTest","Type","Required","Ordinal","TestLength","TestExpression"],"N":["IDTest","Ordinal"]},"TestInstance":{"I":["IDTestInstance","GUIDTestInstance"],"D":["Deleted","IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem","Name","Notes","StartDate","EstimatedCompletionDate","ActualCompletionDate","ExternalSyncGUID","Status","StatusMessage","SampleTestNumber","TestResult"],"N":["IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem"]},"TestInstanceData":{"I":["IDTestInstanceData","GUIDTestInstanceData"],"D":["Deleted","IDTestInstance","Value","Comments","Valid","ExternalSyncGUID","Ordinal"],"N":["IDTestInstance","Ordinal"]},"TestInstanceDataArchive":{"I":["IDTestInstanceDataArchive","GUIDTestInstanceDataArchive"],"D":["Deleted","IDTestInstanceData","TestInstanceData"],"N":["IDTestInstanceData"]},"TestInstanceDocumentJoin":{"I":["IDTestInstanceDocumentJoin","GUIDTestInstanceDocumentJoin"],"D":["Deleted","IDTestInstance","IDDocument"],"N":["IDTestInstance","IDDocument"]},"TestInstanceLabJoin":{"I":["IDTestInstanceLabJoin","GUIDTestInstanceLabJoin"],"D":["Deleted","IDTestInstance","IDLab"],"N":["IDTestInstance","IDLab"]},"TestInstanceSampleJoin":{"I":["IDTestInstanceSampleJoin","GUIDTestInstanceSampleJoin"],"D":["Deleted","IDTestInstance","IDSample"],"N":["IDTestInstance","IDSample"]},"TestLabJoin":{"I":["IDTestLabJoin","GUIDTestLabJoin"],"D":["Deleted","IDLab","IDLabParent","IDTest","DateEnd","QualificationType","QualificationMethod","QualificationAuthorization"],"N":["IDLab","IDLabParent","IDTest"]},"TestManifestSchemaJoin":{"I":["IDTestManifestSchemaJoin","GUIDTestManifestSchemaJoin"],"D":["Deleted","IDTest","IDManifestSchema"],"N":["IDTest","IDManifestSchema"]},"TestPlan":{"I":["IDTestPlan","GUIDTestPlan"],"D":["Deleted","IDProject","Description","DateStart","DateEnd"],"N":["IDProject"]},"TestRecordOfMaterialEntryJoin":{"I":["IDTestRecordOfMaterialEntryJoin","GUIDTestRecordOfMaterialEntryJoin"],"D":["Deleted","IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem","IDRecordOfMaterialEntry","TestCount","Name","Notes"],"N":["IDTestPlan","IDTest","IDLab","IDProject","IDBidItem","IDLineItem","IDRecordOfMaterialEntry","TestCount"]},"TestSpecification":{"I":["IDTestSpecification","GUIDTestSpecification"],"D":["Deleted","Name","IDTestSpecificationSet","Description"],"N":["IDTestSpecificationSet"]},"TestSpecificationMaterialJoin":{"I":["IDTestSpecificationMaterialJoin","GUIDTestSpecificationMaterialJoin"],"D":["Deleted","IDMaterial","IDTestSpecification","MaterialCode","SpecialInstructions","Year"],"N":["IDMaterial","IDTestSpecification"]},"TestSpecificationMaterialTestJoin":{"I":["IDTestSpecificationMaterialTestJoin","GUIDTestSpecificationMaterialTestJoin"],"D":["Deleted","IDTestSpecification","IDMaterial","IDTest"],"N":["IDTestSpecification","IDMaterial","IDTest"]},"TestSpecificationRequirement":{"I":["IDTestSpecificationRequirement","GUIDTestSpecificationRequirement"],"D":["Deleted","IDTestSpecification","IDTest","Name","Ordinal","OperationType","ValueMinimum","ValueMaximum","ComputationTemplate","OutcomeType","OutcomeTargets","ComputationSuccessOutcome","ComputationFailureOutcome","PrecompiledSolver"],"N":["IDTestSpecification","IDTest"]},"TestSpecificationSet":{"I":["IDTestSpecificationSet","GUIDTestSpecificationSet"],"D":["Deleted","Name","Year"],"N":["Year"]},"TestSpecificationSetTestJoin":{"I":["IDTestSpecificationSetTestJoin","GUIDTestSpecificationSetTestJoin"],"D":["Deleted","IDTestSpecificationSet","IDTest"],"N":["IDTestSpecificationSet","IDTest"]},"TestStep":{"I":["IDTestStep","GUIDTestStep"],"D":["Deleted","Name","Notes","Computed","ComputationTemplate","Important"],"N":[]},"Tokens":{"I":["IDToken","GUIDToken"],"D":["ClientID","UserID","Type","Value","Expiration"],"N":[]},"UploadBatch":{"I":["IDUploadBatch","GUIDUploadBatch"],"D":["Deleted","Name","Status","Description","MetadataJSON"],"N":[]},"UploadFile":{"I":["IDUploadFile","GUIDUploadFile"],"D":["Name","FileType","Category","Bytes","Latitude","Longitude","UploadStartTime","UploadCompletionTime","Status","Priority","MetadataJSON","IDUploadBatch","IDDevice"],"N":["Bytes","Priority","IDUploadBatch","IDDevice"]},"UploadFileObservationJoin":{"I":["IDUploadFileObservationJoin","GUIDUploadFileObservationJoin"],"D":["IDUploadFile","IDObservation"],"N":["IDUploadFile","IDObservation"]},"UploadFileUploadBatchJoin":{"I":["IDUploadFileUploadBatchJoin","GUIDUploadFileUploadBatchJoin"],"D":["IDUploadFile","IDUploadBatch"],"N":["IDUploadFile","IDUploadBatch"]},"User":{"I":["IDUser","GUIDUser"],"D":["Deleted","ExternalSyncGUID","NameFirst","NameLast","Phone","Email","LoginID","LoginPassword","PasswordResetKey","IDRole","Title","Classification","IDProjectOffice","EmailPending","UIHash","Timezone","Shift","SettingsJSON","LastSessionID","LastLoginTime","Disabled","PersistentPassword"],"N":["IDRole","IDProjectOffice"]},"UserAction":{"I":["IDUserAction","GUIDUserAction"],"D":["Deleted","IDDevice","AppName","AppVersion","Action","ActionPayload"],"N":["IDDevice"]},"UserContextRole":{"I":["IDUserContextRole","GUIDUserContextRole"],"D":["IDUser","Context","IDContext","IDRole","StartDate","ExpirationDate","ExpirationIDRole","SynthesizedIDRole"],"N":["IDUser","IDContext","IDRole","ExpirationIDRole","SynthesizedIDRole"]},"UserEntityAction":{"I":["IDUserEntityAction","GUIDUserEntityAction"],"D":["IDUser","EntityType","IDEntity","Action","Tags"],"N":["IDUser","IDEntity"]},"UserExclusionAxiomJoin":{"I":["IDUserExclusionAxiomJoin","GUIDUserExclusionAxiomJoin"],"D":["Deleted","IDExclusionAxiom","IDUser"],"N":["IDExclusionAxiom","IDUser"]},"UserInclusionAxiomJoin":{"I":["IDRolInclusioneAxiomJoin","GUIDUserInclusionAxiomJoin"],"D":["Deleted","IDInclusionAxiom","IDUser"],"N":["IDInclusionAxiom","IDUser"]},"UserOverrideAxiomJoin":{"I":["IDRolOverrideeAxiomJoin","GUIDUserOverrideAxiomJoin"],"D":["Deleted","IDOverrideAxiom","IDUser"],"N":["IDOverrideAxiom","IDUser"]},"UserPermission":{"I":["IDUserPermission","GUIDUserPermission"],"D":["Hash","Allowed","IDUser","Context","IDContext"],"N":["IDUser","IDContext"]},"UserRoleJoin":{"I":["IDUserRoleJoin","GUIDUserRoleJoin"],"D":["IDRole","IDUser","ProxyIDRole"],"N":["IDRole","IDUser","ProxyIDRole"]},"UserScopeAxiomJoin":{"I":["IDUserScopeAxiomJoin","GUIDUserScopeAxiomJoin"],"D":["Deleted","IDScopeAxiom","IDUser"],"N":["IDScopeAxiom","IDUser"]},"UserSessionHistory":{"I":["IDUserSessionHistory","GUIDUserSessionHistory"],"D":["Deleted","SessionID","IDUser","ImpersonatedIDUser","ImpersonationDate","ImpersonationChained","OriginatingSessionID"],"N":["IDUser","ImpersonatedIDUser"]},"WorkflowEdge":{"I":["IDWorkflowEdge","GUIDWorkflowEdge"],"D":["Deleted","FromJobType","ToJobType","RulesJSON"],"N":[]}}}

},{}],157:[function(require,module,exports){
/**
 * Shared loader for small, customer-managed vocabularies that render as an option list rather than a
 * searchable entity picker - `SampleStatus` is the first of these.
 *
 * A vocabulary table holds tens of rows, is read in full, and stores a short code (not a database id)
 * on the record that references it, so the remote-search entity path is the wrong shape for it. An
 * input opts in through its descriptor:
 *
 *   PictForm.SelectOptionsEntity          - the entity name (e.g. 'SampleStatus').
 *   PictForm.SelectOptionsEntityValueField - the column persisted as the value (default ID<Entity>).
 *   PictForm.SelectOptionsEntityTextField  - the column shown as the label (default Name).
 *   PictForm.SelectOptionsEntitySortField  - the column the list is ordered by (default ID<Entity>).
 *   PictForm.SelectOptionsEntityFilter     - optional extra FoxHound stanza, ANDed into the read.
 *   PictForm.SelectOptionsEntityCap        - optional row cap (default 500).
 *
 * The load is shared per (entity + field config) across every input on the page. A customer with no
 * rows - and a read that fails - resolves to null, which every caller treats as "keep the static
 * PictForm.SelectOptions fallback", so an uncurated customer still gets a working list.
 *
 * @module _EntityOptionSource
 */

/** @typedef {{ id: any, text: string }} EntityOption */

const DEFAULT_ROW_CAP = 500;

/**
 * Cache key for one entity-backed option set. Inputs sharing an entity and field config share a load.
 *
 * @param {Object} pInput - The form input descriptor.
 * @return {string|null} - The cache key, or null when the input is not entity-backed.
 */
function getCacheKey(pInput)
{
	const tmpEntity = pInput && pInput.PictForm && pInput.PictForm.SelectOptionsEntity;
	if (!tmpEntity)
	{
		return null;
	}
	const tmpPictForm = pInput.PictForm;
	return [
		tmpEntity,
		tmpPictForm.SelectOptionsEntityValueField || `ID${tmpEntity}`,
		tmpPictForm.SelectOptionsEntityTextField || 'Name',
		tmpPictForm.SelectOptionsEntitySortField || `ID${tmpEntity}`,
		tmpPictForm.SelectOptionsEntityFilter || '',
		tmpPictForm.SelectOptionsEntityCap || DEFAULT_ROW_CAP,
	].join('|');
}

/**
 * The provider-scoped cache bag, created on first use.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @return {Record<string, {Loaded: boolean, Options: Array<EntityOption>, Callbacks: Array<Function>}>}
 */
function getCache(pProvider)
{
	if (!pProvider._entitySelectOptionCache)
	{
		pProvider._entitySelectOptionCache = {};
	}
	return pProvider._entitySelectOptionCache;
}

/**
 * Start the shared read for an entity-backed vocabulary. A failed read deletes the cache entry so the
 * next ask retries rather than being pinned to an empty list forever.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @param {Object} pInput - The form input descriptor.
 * @param {string} pCacheKey - The key from {@link getCacheKey}.
 * @return {void}
 */
function startLoad(pProvider, pInput, pCacheKey)
{
	const tmpCache = getCache(pProvider);
	const tmpPictForm = pInput.PictForm;
	const tmpEntity = tmpPictForm.SelectOptionsEntity;
	const tmpValueField = tmpPictForm.SelectOptionsEntityValueField || `ID${tmpEntity}`;
	const tmpTextField = tmpPictForm.SelectOptionsEntityTextField || 'Name';
	const tmpSortField = tmpPictForm.SelectOptionsEntitySortField || `ID${tmpEntity}`;
	const tmpCap = tmpPictForm.SelectOptionsEntityCap || DEFAULT_ROW_CAP;
	const tmpFilter = tmpPictForm.SelectOptionsEntityFilter ? `${tmpPictForm.SelectOptionsEntityFilter}~` : '';

	// meadow-endpoints pluralizes a scope by appending 's' - SampleStatus is served at SampleStatuss.
	pProvider.pict.HeadlightRestClient.getJSON(`${tmpEntity}s/FilteredTo/${tmpFilter}FSF~${tmpSortField}~ASC~0/0/${tmpCap}`, (pError, pRecords) =>
	{
		const tmpEntry = tmpCache[pCacheKey];
		if (!tmpEntry)
		{
			return;
		}
		if (pError || !Array.isArray(pRecords))
		{
			// Drop the entry so the next ask retries, but still release anyone waiting - an awaiting
			// caller (the Picker's DataProvider) would otherwise hang instead of using its fallback.
			pProvider.pict.log.warn(`EntityOptionSource: option load failed for [${tmpEntity}]: ${(pError && pError.message) || pError}`);
			delete tmpCache[pCacheKey];
			for (const fFailureCallback of tmpEntry.Callbacks)
			{
				try
				{
					fFailureCallback([]);
				}
				catch (pCallbackError)
				{
					pProvider.pict.log.error(`EntityOptionSource: repaint failed for [${tmpEntity}]: ${(pCallbackError && pCallbackError.message) || pCallbackError}`);
				}
			}
			return;
		}
		tmpEntry.Options = pRecords
			.filter((pRecord) => pRecord && (pRecord[tmpValueField] !== undefined) && (pRecord[tmpValueField] !== null) && (pRecord[tmpValueField] !== ''))
			.map((pRecord) => ({ id: pRecord[tmpValueField], text: pRecord[tmpTextField] || String(pRecord[tmpValueField]) }));
		tmpEntry.Loaded = true;
		const tmpCallbacks = tmpEntry.Callbacks;
		tmpEntry.Callbacks = [];
		for (const fCallback of tmpCallbacks)
		{
			try
			{
				fCallback(tmpEntry.Options);
			}
			catch (pCallbackError)
			{
				pProvider.pict.log.error(`EntityOptionSource: repaint failed for [${tmpEntity}]: ${(pCallbackError && pCallbackError.message) || pCallbackError}`);
			}
		}
	});
}

/**
 * Synchronously resolve the entity-backed option list, kicking off the shared load on first ask.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @param {Object} pInput - The form input descriptor.
 * @param {Function} [fOnLoaded] - Invoked once with the options after an in-flight load resolves.
 * @return {Array<EntityOption>|null} - The options, or null when the caller should use its static fallback.
 */
function resolveOptions(pProvider, pInput, fOnLoaded)
{
	const tmpCacheKey = getCacheKey(pInput);
	if (!tmpCacheKey || !pProvider || !pProvider.pict || !pProvider.pict.HeadlightRestClient)
	{
		return null;
	}
	const tmpCache = getCache(pProvider);
	const tmpEntry = tmpCache[tmpCacheKey];
	if (tmpEntry && tmpEntry.Loaded)
	{
		return (tmpEntry.Options.length > 0) ? tmpEntry.Options : null;
	}
	if (tmpEntry)
	{
		if (typeof fOnLoaded === 'function')
		{
			tmpEntry.Callbacks.push(fOnLoaded);
		}
		return null;
	}
	tmpCache[tmpCacheKey] = { Loaded: false, Options: [], Callbacks: (typeof fOnLoaded === 'function') ? [ fOnLoaded ] : [] };
	startLoad(pProvider, pInput, tmpCacheKey);
	return null;
}

/**
 * Promise form for callers (the Picker's async DataProvider) that can await the vocabulary. Resolves
 * to the static `PictForm.SelectOptions` fallback when the customer has no rows or the read failed.
 *
 * @param {Object} pProvider - The input-type provider (must expose `pict`).
 * @param {Object} pInput - The form input descriptor.
 * @return {Promise<Array<EntityOption>>} - The vocabulary, or the descriptor's static fallback.
 */
function resolveOptionsAsync(pProvider, pInput)
{
	const tmpFallback = (pInput && pInput.PictForm && Array.isArray(pInput.PictForm.SelectOptions)) ? pInput.PictForm.SelectOptions : [];
	return new Promise((fResolve) =>
	{
		const tmpResolved = resolveOptions(pProvider, pInput, (pOptions) =>
		{
			fResolve((pOptions && pOptions.length > 0) ? pOptions : tmpFallback);
		});
		if (Array.isArray(tmpResolved))
		{
			fResolve((tmpResolved.length > 0) ? tmpResolved : tmpFallback);
			return;
		}
		// Not entity-backed at all (no cache key / no REST client) - nothing will call back.
		if (!getCacheKey(pInput) || !pProvider || !pProvider.pict || !pProvider.pict.HeadlightRestClient)
		{
			fResolve(tmpFallback);
		}
	});
}

module.exports = { getCacheKey, resolveOptions, resolveOptionsAsync, DEFAULT_ROW_CAP };

},{}],158:[function(require,module,exports){
/**
 * The one implementation of the inline "Show All" toggle's DISABLED state, shared by the two entity-selector
 * families that render the toggle: the select2 `MaterialsEntitySelector` tree and the pict-section-picker
 * `Picker` broker. Neither family shares a base class (one extends `PictInputExtensionProvider`, the other
 * `PictInputTypePicker`), so this module — not inheritance — is what keeps their behaviour identical, and
 * keeps `headlight-dynamic-form` and `materials-form` from drifting.
 *
 * Why: a read-only / disabled selector still painted a live-looking toggle. Clicking it wrote override state
 * and re-ran the whole filter composition for a field whose value cannot change — wasted round trips, and a
 * control that reads as actionable when nothing can come of it. Disabled fields now paint the toggle inert
 * and swallow the click.
 *
 * The disabled state is applied twice on purpose: the `{~FilterToggleDisabled:~}` macro paints the class at
 * first render (no enabled→disabled flash), and `syncToggleDisabledState` re-applies it at input-initialize
 * so a descriptor disabled AFTER render — `MaterialsSampleSelector`'s `DisabledOnceSaved` is the live case —
 * is still caught.
 */

const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');

/** Class the templates/macro and the runtime sync both key off. */
const DISABLED_CLASS = 'hl-filter-toggle-disabled';

/** Stashes the template's own title while disabled, so the restore doesn't hardcode it. */
const TITLE_STASH_ATTRIBUTE = 'data-filter-toggle-title';

const DISABLED_TITLE = 'Show all is unavailable — this field is read-only';

/* Inert ghost-button paint. `a.button.<class>` (0,2,1) outranks Bulma's `.button.is-ghost` (0,2,0)
   regardless of injection order, which a bare `.<class>` would lose to. Pointer events stay ON so the
   explanatory title still shows on hover — the click itself is swallowed in toggleFilterOverride. */
const _FILTER_TOGGLE_DISABLED_CSS = /*css*/`
a.button.${DISABLED_CLASS},
a.button.${DISABLED_CLASS}:hover,
a.button.${DISABLED_CLASS}:focus {
	color: var(--bulma-text-weak);
	opacity: var(--bulma-button-disabled-opacity, 0.5);
	cursor: not-allowed;
	text-decoration: none;
	box-shadow: none;
}
`;

/* In a table cell the toggle floats beside the picker, and the picker's positioned host paints over a non-positioned
   float and takes its clicks; lifting the toggle into its own stacking layer keeps it clickable. */
const _FILTER_TOGGLE_TABULAR_CSS = /*css*/`
a.button.hl-tabular-filter-toggle {
	position: relative;
	z-index: 1;
}
`;

/**
 * True when the descriptor is read-only, by either flag Headlight uses: `PictForm.Disabled` (the entity
 * selectors, and the `{~Disabled:~}` macro's own source) or `PictForm.ReadOnly` (ObjectEditor / PSP).
 * @param {Record<string, any>} pInput - the input descriptor @return {boolean}
 */
const isInputDisabled = (pInput) =>
{
	const tmpPictForm = pInput && pInput.PictForm ? pInput.PictForm : null;
	if (!tmpPictForm)
	{
		return false;
	}
	return !!(tmpPictForm.Disabled || tmpPictForm.ReadOnly);
};

/**
 * Register the inert-toggle CSS with the pict CSSMap, and write it out once the page can take it.
 *
 * Registration and injection are separate on purpose. `addCSS` only ever RAISES the CSSMap's dirty flag,
 * so registering at bundle-attach time is free; `injectCSS` LOWERS it whether or not the target style
 * element exists yet, so calling it during bootstrap could quietly drop this fragment until something
 * else re-dirtied the map. Bootstrap registers (`pInjectNow` omitted); the input-initialize sync — by
 * which point the page is built — injects.
 *
 * @param {any} pPict @param {boolean} [pInjectNow] @return {boolean} true once the CSS is registered
 */
const ensureFilterToggleCSS = (pPict, pInjectNow) =>
{
	if (!pPict)
	{
		return false;
	}
	const tmpCSSMap = pPict.CSSMap;
	if (!tmpCSSMap || typeof tmpCSSMap.addCSS !== 'function')
	{
		return false;
	}
	if (!pPict._HeadlightFilterToggleCSSRegistered)
	{
		tmpCSSMap.addCSS('Headlight-FilterToggle-Disabled-CSS', _FILTER_TOGGLE_DISABLED_CSS + _FILTER_TOGGLE_TABULAR_CSS, 500);
		pPict._HeadlightFilterToggleCSSRegistered = true;
	}
	if (pInjectNow && !pPict._HeadlightFilterToggleCSSInjected && typeof tmpCSSMap.injectCSS === 'function')
	{
		tmpCSSMap.injectCSS();
		pPict._HeadlightFilterToggleCSSInjected = true;
	}
	return true;
};

/** Resolve the toggle anchor for a `#ID` selector, or null when it isn't rendered. */
const _getToggleElement = (pPict, pToggleSelector) =>
{
	const tmpAssignment = pPict ? pPict.ContentAssignment : null;
	if (!tmpAssignment || typeof tmpAssignment.getElement !== 'function')
	{
		return null;
	}
	const tmpElements = tmpAssignment.getElement(pToggleSelector);
	const tmpToggle = tmpElements && tmpElements[0];
	return (tmpToggle && typeof tmpToggle.setAttribute === 'function') ? tmpToggle : null;
};

/**
 * Paint the toggle anchor's disabled state. The anchor carries no `href`, so it is not keyboard-focusable
 * and needs no tabindex — `aria-disabled` is what announces it.
 * @param {any} pPict @param {string} pToggleSelector - `#SOME-FILTER-TOGGLE-ID` @param {boolean} pDisabled
 * @return {boolean} true when an anchor was found and painted
 */
const syncToggleDisabledState = (pPict, pToggleSelector, pDisabled) =>
{
	const tmpToggle = _getToggleElement(pPict, pToggleSelector);
	if (!tmpToggle)
	{
		return false;
	}
	ensureFilterToggleCSS(pPict, true);
	if (pDisabled)
	{
		if (tmpToggle.classList)
		{
			tmpToggle.classList.add(DISABLED_CLASS);
		}
		if (!tmpToggle.hasAttribute(TITLE_STASH_ATTRIBUTE))
		{
			tmpToggle.setAttribute(TITLE_STASH_ATTRIBUTE, tmpToggle.getAttribute('title') || '');
		}
		tmpToggle.setAttribute('aria-disabled', 'true');
		tmpToggle.setAttribute('title', DISABLED_TITLE);
		return true;
	}
	if (tmpToggle.classList)
	{
		tmpToggle.classList.remove(DISABLED_CLASS);
	}
	tmpToggle.removeAttribute('aria-disabled');
	if (tmpToggle.hasAttribute(TITLE_STASH_ATTRIBUTE))
	{
		tmpToggle.setAttribute('title', tmpToggle.getAttribute(TITLE_STASH_ATTRIBUTE) || '');
		tmpToggle.removeAttribute(TITLE_STASH_ATTRIBUTE);
	}
	return true;
};

/**
 * The click guard. Read off the rendered anchor rather than the descriptor because the inline `onclick`
 * hands `toggleFilterOverride` only an HTML id — and because both the render-time macro (class) and the
 * init-time sync (aria) mark the same element, so the guard holds before init has run.
 * @param {any} pPict @param {string} pToggleSelector @return {boolean}
 */
const isToggleDisabled = (pPict, pToggleSelector) =>
{
	const tmpToggle = _getToggleElement(pPict, pToggleSelector);
	if (!tmpToggle)
	{
		return false;
	}
	if (typeof tmpToggle.getAttribute === 'function' && tmpToggle.getAttribute('aria-disabled') === 'true')
	{
		return true;
	}
	return !!(tmpToggle.classList && tmpToggle.classList.contains(DISABLED_CLASS));
};

/**
 * Whether the inline "Show All" toggle shows: the descriptor's own `PictForm.ShowAllToggle`, else its
 * specialized-selector config-map entry's (MaterialSelector's top-level-only filter comes with the toggle).
 * @param {Record<string, any>} pInput - the input descriptor (the template macro passes its Record) @return {boolean}
 */
const isToggleVisible = (pInput) =>
{
	const tmpPictForm = pInput && pInput.PictForm ? pInput.PictForm : null;
	if (!tmpPictForm)
	{
		return false;
	}
	return !!(tmpPictForm.ShowAllToggle ?? _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.ShowAllToggle);
};

module.exports = { DISABLED_CLASS, DISABLED_TITLE, isInputDisabled, isToggleVisible, ensureFilterToggleCSS, syncToggleDisabledState, isToggleDisabled };

},{"./_SpecializedSelectorMap.js":165}],159:[function(require,module,exports){
/**
 * Shared lab-routing helpers for the per-test lab selectors — the Picker-stack `MaterialsTestLabPicker` and the
 * legacy select2 `MaterialsTestLabSelector`, which differ in how they mount but route labs identically.
 *
 * Two concerns live here:
 *
 *   - **promotion.** The per-test labs also tell the sample where to ship. A sample ships to a PARENT lab, so
 *     the sample-level selector holds the parent of each test's lab (a lab with no parent stands for itself).
 *     Labs held only because a test promoted them are tracked, so they leave again once no test calls for
 *     them; a lab the user chose is never removed.
 *   - **auto-fill.** A test row that arrives with no lab takes the resolver's answer — the only lab that can
 *     run the test, else the top of its preference ranking — and stays blank when there is none. Never
 *     overwrites a value that is already there.
 *
 * @module _LabRouting
 */

const SAMPLE_LAB_SYNC_EVENT = 'SampleLabSync';
const DEFAULT_TEST_INSTANCES_ADDRESS = 'AppData.DocumentData.ReportData.FormData.SampleTestIDs__Record_Instances';

/**
 * The lab id the sample-level selector should hold for a lab picked against a test: its parent, or itself when
 * it has none. Falls back to the record's own `IDLabParent` when the resolver has not primed, and to the lab
 * itself when neither answers — promotion must never drop the selection.
 *
 * @param {Object} pPict - the pict instance (reads `providers.LabScopeResolver`).
 * @param {Record<string, any>} pLab - the picked Lab record.
 * @return {number} The IDLab to promote, or 0 when there is nothing to promote.
 */
function resolveSampleLabID(pPict, pLab)
{
	const tmpIDLab = parseInt(pLab && pLab.IDLab, 10);
	if (!(tmpIDLab > 0))
	{
		return 0;
	}
	const tmpResolved = parseInt(pPict?.providers?.LabScopeResolver?.getParentLabID?.(tmpIDLab), 10);
	if (tmpResolved > 0)
	{
		return tmpResolved;
	}
	const tmpRecordParent = parseInt(pLab.IDLabParent, 10);
	return (tmpRecordParent > 0) ? tmpRecordParent : tmpIDLab;
}

/**
 * A lab selection value (csv, array or empty) as trimmed id strings, blanks dropped.
 *
 * @param {any} pValue
 * @return {Array<string>}
 */
function parseLabIDList(pValue)
{
	if (pValue === null || pValue === undefined || pValue === '')
	{
		return [];
	}
	const tmpEntries = Array.isArray(pValue) ? pValue : String(pValue).split(',');
	return tmpEntries.map((pEntry) => String(pEntry).trim()).filter((pEntry) => pEntry.length > 0);
}

/**
 * The sample-level labs the per-test labs call for right now: the parent of each row's lab, in row order.
 *
 * @param {Object} pPict - the pict instance.
 * @param {Array<Record<string, any>>} pTriples - the Test selector's TestInstance triples.
 * @return {Array<string>}
 */
function collectPromotedSampleLabIDs(pPict, pTriples)
{
	const tmpWanted = [];
	for (const tmpTriple of (Array.isArray(pTriples) ? pTriples : []))
	{
		const tmpTestInstance = tmpTriple && tmpTriple.TestInstance;
		const tmpIDLab = parseInt(tmpTestInstance && tmpTestInstance.IDLab, 10);
		if (!(tmpIDLab > 0))
		{
			continue;
		}
		const tmpRecord = tmpTestInstance.IDLab__Record;
		const tmpLab = (tmpRecord && parseInt(tmpRecord.IDLab, 10) === tmpIDLab) ? tmpRecord : { IDLab: tmpIDLab };
		const tmpSampleLabID = String(resolveSampleLabID(pPict, tmpLab));
		if (tmpWanted.indexOf(tmpSampleLabID) < 0)
		{
			tmpWanted.push(tmpSampleLabID);
		}
	}
	return tmpWanted;
}

/**
 * The labs the sample's tests are assigned to right now, in row order — the ranking prefers them so a row
 * does not add a lab to the sample when one already in use can run its test.
 *
 * @param {Object} pPict - the pict instance.
 * @return {Array<number>}
 */
function collectSelectedTestLabIDs(pPict)
{
	const tmpTriples = pPict?.manifest?.getValueAtAddress?.(pPict, DEFAULT_TEST_INSTANCES_ADDRESS);
	const tmpSelected = [];
	for (const tmpTriple of (Array.isArray(tmpTriples) ? tmpTriples : []))
	{
		const tmpIDLab = parseInt(tmpTriple && tmpTriple.TestInstance && tmpTriple.TestInstance.IDLab, 10);
		if (tmpIDLab > 0 && tmpSelected.indexOf(tmpIDLab) < 0)
		{
			tmpSelected.push(tmpIDLab);
		}
	}
	return tmpSelected;
}

/**
 * Reconcile the sample-level lab selection with the labs the tests call for. A called-for lab missing from the
 * selection is added and recorded as promoted; a promoted lab no test calls for any more is removed; a lab the
 * user chose is never touched, and one the user removed stops counting as promoted.
 *
 * @param {Array<string>} pSelection - the current selection, in order.
 * @param {Array<string>} pPromoted - the part of the selection promotion put there.
 * @param {Array<string>} pWanted - the labs the tests call for now.
 * @return {{ Selection: Array<string>, Promoted: Array<string> }}
 */
function reconcileSampleLabs(pSelection, pPromoted, pWanted)
{
	const tmpWanted = new Set(pWanted);
	const tmpPromoted = new Set(pPromoted.filter((pID) => pSelection.indexOf(pID) > -1));
	const tmpSelection = pSelection.filter((pID) => !tmpPromoted.has(pID) || tmpWanted.has(pID));
	const tmpStillPromoted = Array.from(tmpPromoted).filter((pID) => tmpWanted.has(pID));
	for (const tmpID of pWanted)
	{
		if (tmpSelection.indexOf(tmpID) < 0)
		{
			tmpSelection.push(tmpID);
			tmpStillPromoted.push(tmpID);
		}
	}
	return { Selection: tmpSelection, Promoted: tmpStillPromoted };
}

/**
 * Bring a sample-level lab selector in line with the per-test labs (see reconcileSampleLabs). Reads the test
 * triples from `PictForm.TestInstancesAddress` (default: the Test selector's) and keeps the promoted set in the
 * form data at `pPromotedAddress`, so a retraction still knows what it may remove after a reopen. A document
 * saved before that set existed carries none, so nothing on it counts as promoted and nothing is removed.
 *
 * @param {Object} pPict - the pict instance.
 * @param {Record<string, any>} pInput - the sample-level lab selector's descriptor.
 * @param {Object} pDestination - the view's marshal destination object.
 * @param {string} pPromotedAddress - where the promoted set lives, relative to pDestination.
 * @param {any} pCurrentValue - the selector's current value.
 * @return {string|null} The new selection csv, or null when it is unchanged.
 */
function syncSampleLabSelection(pPict, pInput, pDestination, pPromotedAddress, pCurrentValue)
{
	const tmpTriplesAddress = (pInput && pInput.PictForm && pInput.PictForm.TestInstancesAddress) || DEFAULT_TEST_INSTANCES_ADDRESS;
	const tmpTriples = pPict.manifest.getValueAtAddress(pPict, tmpTriplesAddress);
	const tmpSelection = parseLabIDList(pCurrentValue);
	const tmpResult = reconcileSampleLabs(tmpSelection, parseLabIDList(pPict.manifest.getValueAtAddress(pDestination, pPromotedAddress)), collectPromotedSampleLabIDs(pPict, tmpTriples));
	pPict.manifest.setValueAtAddress(pDestination, pPromotedAddress, tmpResult.Promoted.join(','));
	const tmpNextValue = tmpResult.Selection.join(',');
	return (tmpNextValue === tmpSelection.join(',')) ? null : tmpNextValue;
}

/**
 * Ask the sample-level lab selector to reconcile with the per-test labs. The per-test selectors hold no
 * reference to that input, so they broadcast; it owns its value and join array. Sent on every change to the
 * per-test labs — a clear, a re-pick or a removed test has to retract as surely as a pick promotes.
 *
 * @param {Object} pPict - the pict instance.
 * @return {void}
 */
function requestSampleLabSync(pPict)
{
	pPict?.views?.PictFormMetacontroller?.triggerGlobalInputEvent?.(SAMPLE_LAB_SYNC_EVENT);
}

/**
 * Whether a per-test lab selector should auto-fill. Opt out per descriptor with `PictForm.AutoFillLab: false`;
 * on by default, since a row whose lab is uniquely determined has nothing for the user to decide.
 *
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @return {boolean}
 */
function isAutoFillEnabled(pInput)
{
	return (pInput && pInput.PictForm) ? (pInput.PictForm.AutoFillLab !== false) : true;
}

/**
 * Whether a lab value names no lab: anything that isn't a positive lab id, including the 0 older documents store.
 *
 * @param {any} pValue - a lab id, as number or string.
 * @return {boolean}
 */
function isUnsetLabID(pValue)
{
	return !(parseInt(pValue, 10) > 0);
}

/**
 * The descriptor's per-test `LabScope` filter entry, which carries the axis addresses the resolver needs.
 *
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @return {Record<string, any>|null}
 */
function getTestLabScopeFilter(pInput)
{
	const tmpFilters = (pInput && pInput.PictForm) ? pInput.PictForm.DynamicFilters : null;
	if (!Array.isArray(tmpFilters))
	{
		return null;
	}
	for (const tmpFilter of tmpFilters)
	{
		if (tmpFilter && tmpFilter.LabScope === 'Test')
		{
			return tmpFilter;
		}
	}
	return null;
}

/**
 * The lab to fill into an empty per-test selector for a row, or 0 when there is nothing to fill. Resolves the
 * row's test through the same resolver the filters and pins use, so the auto-filled value is by construction
 * the first one the dropdown would have offered.
 *
 * @param {Object} pPict - the pict instance (reads `providers.LabScopeResolver` / `providers.EntityFilterEngine`).
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @param {number|string|null} pRowIndex - the tabular row index.
 * @param {Object} pView - the form view (provides the marshal destination for the row read).
 * @return {number}
 */
function resolveAutoFillLabID(pPict, pInput, pRowIndex, pView)
{
	const tmpResolver = pPict?.providers?.LabScopeResolver;
	const tmpEngine = pPict?.providers?.EntityFilterEngine;
	if (!tmpResolver || !tmpEngine || !isAutoFillEnabled(pInput))
	{
		return 0;
	}
	// Show All means "let me pick anything" — filling a value under it would contradict the request.
	if (tmpEngine.isFilterOverridden(pInput, pRowIndex))
	{
		return 0;
	}
	const tmpFilter = getTestLabScopeFilter(pInput);
	if (!tmpFilter)
	{
		return 0;
	}
	const tmpIDTest = tmpEngine._readLabScopeTestID(tmpFilter, pInput, pRowIndex, pView);
	if (!tmpIDTest)
	{
		return 0;
	}
	return parseInt(tmpResolver.getAutoFillLabID(tmpIDTest, { SelectedLabIDs: collectSelectedTestLabIDs(pPict) }), 10) || 0;
}

/**
 * Fill an empty per-test selector row, waiting out a resolver prime that is still loading the row's test.
 *
 * The Testing table re-renders as soon as the test set changes, while the resolver re-primes for the new set
 * asynchronously — so the newest row is evaluated against caches that do not yet know its test, and nothing
 * revisits it. When the first attempt finds nothing and a prime is in flight, retry once it lands, provided
 * the row still holds the same test and is still empty.
 *
 * @param {Object} pPict - the pict instance.
 * @param {Record<string, any>} pInput - the form input descriptor.
 * @param {number|string} pRowIndex - the tabular row index.
 * @param {Object} pView - the form view.
 * @param {() => any} fReadRowLab - reads the row's current lab.
 * @param {(pIDLab: number) => void} fCommit - commits a lab through the selector's pick path.
 * @return {void}
 */
function autoFillTestLab(pPict, pInput, pRowIndex, pView, fReadRowLab, fCommit)
{
	const tmpIDLab = resolveAutoFillLabID(pPict, pInput, pRowIndex, pView);
	if (tmpIDLab > 0)
	{
		fCommit(tmpIDLab);
		return;
	}
	const tmpResolver = pPict?.providers?.LabScopeResolver;
	const tmpEngine = pPict?.providers?.EntityFilterEngine;
	const tmpFilter = getTestLabScopeFilter(pInput);
	if (!tmpResolver || !tmpEngine || !tmpFilter || typeof tmpResolver.primeFromForm !== 'function' || typeof tmpResolver.isPriming !== 'function')
	{
		return;
	}
	const tmpIDTest = tmpEngine._readLabScopeTestID(tmpFilter, pInput, pRowIndex, pView);
	if (!tmpIDTest)
	{
		return;
	}
	const tmpPrime = tmpResolver.primeFromForm();
	if (!tmpResolver.isPriming())
	{
		return;
	}
	tmpPrime.then(() =>
	{
		if (String(tmpEngine._readLabScopeTestID(tmpFilter, pInput, pRowIndex, pView)) !== String(tmpIDTest))
		{
			return;
		}
		if (!isUnsetLabID(fReadRowLab()))
		{
			return;
		}
		const tmpRetryIDLab = resolveAutoFillLabID(pPict, pInput, pRowIndex, pView);
		if (tmpRetryIDLab > 0)
		{
			fCommit(tmpRetryIDLab);
		}
	}).catch((pError) =>
	{
		pPict?.log?.warn?.(`[LabRouting] deferred lab auto-fill failed for row ${pRowIndex}: ${pError?.message || pError}`);
	});
}

/**
 * The spec-set lab floor both selector stacks apply to a Lab picker, family-expanded when the
 * LabScopeResolver is available to supply the lab tree.
 *
 * `LabTestSpecificationSetJoin` declares membership at the FAMILY level — the set names parent labs and
 * their benches are allowed through them — so raw `IDLab` membership empties any list of benches, and a
 * set that also names a bench directly empties the parent-level list. Falls back to raw membership when
 * no resolver is registered, which is the pre-existing behavior.
 *
 * @param {Object} pPict - the pict instance.
 * @return {Set<number>|null} The admitted lab ids, or null for no floor.
 */
function resolveSpecSetLabFloor(pPict)
{
	const tmpExpanded = pPict?.providers?.LabScopeResolver?.getSpecSetLabFloor?.();
	if (tmpExpanded)
	{
		return tmpExpanded;
	}
	return pPict?.providers?.SpecScopeResolver?.getAllowedLabIDs?.() || null;
}

module.exports =
{
	SAMPLE_LAB_SYNC_EVENT,
	resolveSampleLabID,
	parseLabIDList,
	collectPromotedSampleLabIDs,
	collectSelectedTestLabIDs,
	reconcileSampleLabs,
	syncSampleLabSelection,
	requestSampleLabSync,
	isAutoFillEnabled,
	isUnsetLabID,
	getTestLabScopeFilter,
	resolveAutoFillLabID,
	autoFillTestLab,
	resolveSpecSetLabFloor,
};

},{}],160:[function(require,module,exports){
/**
 * The one rule for "which stored values does a Picker field paint as NOTHING SELECTED?", shared by the
 * edit broker, its cascade subclass, and the Read/Print display provider so they cannot drift.
 *
 * Why the rule exists: a pict-section-form marshal reads values through manyfest's getValueByHash, which
 * substitutes the descriptor default for any address the model does not hold yet — and, with no explicit
 * `Default`, that is manyfest's per-DataType default. String gets '', but Number/Integer/Float get 0. So
 * a pristine `{ DataType: 'Number', InputType: 'Picker' }` field — an entity FK, virtually always —
 * marshals in as 0, and the picker would paint a literal "0" as though the user had chosen something.
 * There is no entity #0; it reads as a bug. Treating it as unset is DISPLAY-side only: the stored value
 * is left alone, so 0-means-unset stays a valid pattern for solvers, exports, and the API.
 *
 * A descriptor overrides with `PictForm.EmptyValues` — its own sentinel list, or `[]` to opt out and
 * show the raw 0.
 *
 * pict-section-picker owns the base rule (its form adapter feeds the list to the widget as its
 * `EmptyValues` option, which is what actually suppresses the paint). Headlight extends it for the
 * Materials family, and the broker hands the result to the widget through the adapter's
 * `_resolveEmptyValues` seam, so the control, `__Record` and Read/Print all resolve it here. Requires
 * pict-section-picker >= 1.9.4.
 */
const libPSPResolveEmptyValues = require('pict-section-picker/form').resolveEmptyValues;
const _SPECIALIZED_SELECTOR_MAP = require('./_SpecializedSelectorMap.js');

/**
 * The descriptor's own `PictForm.EmptyValues` wins; else a Materials-family InputType treats 0 as unset
 * whatever its DataType (legacy MES read `pValue == ''`), and the stored literals "null" / "undefined" too
 * (legacy MES skipped them; MaterialsCascadePicker._isClearedPickerValue reads them as a clear); else PSP's
 * per-DataType rule.
 * @param {Record<string, any>} pInput @return {Array<any>}
 */
const resolveEmptyValues = (pInput) =>
{
	const tmpPictForm = (pInput && pInput.PictForm) || {};
	if (!Array.isArray(tmpPictForm.EmptyValues) && _SPECIALIZED_SELECTOR_MAP[tmpPictForm.InputType]?.MaterialsFamily)
	{
		return [ 0, 'null', 'undefined' ];
	}
	return libPSPResolveEmptyValues(pInput);
};

/**
 * True when a single stored value is one of this descriptor's unset sentinels. String-compared, so the
 * numeric 0 and the "0" that comes back off the hidden informary input are the same thing.
 * @param {Record<string, any>} pInput @param {any} pValue @return {boolean}
 */
const isEmptyValue = (pInput, pValue) =>
	resolveEmptyValues(pInput).some((pEmpty) => String(pEmpty) === String(pValue));

module.exports = { resolveEmptyValues, isEmptyValue };

},{"./_SpecializedSelectorMap.js":165,"pict-section-picker/form":710}],161:[function(require,module,exports){
/**
 * Derive a sample's status from its tests' result codes: the rule the SampleStatusPicker and the
 * SampleStatusSelector both apply when their form collects `TestStatusAggregate`. A sample is never moved to a
 * "higher" status automatically, and a manually-terminal status (voided / preauthorized / failed) is never
 * overwritten.
 */

/**
 * @param {string|Array<string>|undefined} pCodes - a list of codes, or a comma-separated string of them
 * @return {Array<string>} the trimmed, non-empty codes
 */
function normalizeCodeList(pCodes)
{
	const tmpList = Array.isArray(pCodes) ? pCodes : String(pCodes || '').split(',');
	return tmpList.map((pCode) => String(pCode).trim()).filter((pCode) => pCode.length > 0);
}

/**
 * @param {string|Array<string>|undefined} pUnfinishedTestResults - a field's `PictForm.UnfinishedTestResults`
 * @return {Array<string>} the result codes that count as a test that isn't finished
 */
function normalizeUnfinishedTestResults(pUnfinishedTestResults)
{
	return normalizeCodeList(pUnfinishedTestResults);
}

/**
 * Where a field keeps the status a person last picked: beside its own value, so it saves with the form.
 *
 * @param {string} pValueAddress - the field's marshal-relative value address
 * @return {string} the address of the picked status
 */
function getPickedStatusAddress(pValueAddress)
{
	return `${pValueAddress}__PickedStatus`;
}

/**
 * Whether the field keeps its own status when the sample record loads, rather than taking the sample's. A field opts
 * in with `PictForm.KeepSavedStatuses`: it then keeps a status a person picked, whatever it is, plus any status the
 * list names (e.g. Passed, Failed), which covers forms saved before picks were recorded. Any other value, a default
 * included, still follows the sample.
 *
 * @param {string} pFieldStatus - the field's current status code
 * @param {string|Array<string>|undefined} pKeepSavedStatuses - the field's `PictForm.KeepSavedStatuses`
 * @param {string} [pPickedStatus] - the status a person last picked in this field, if any
 * @return {boolean} true to leave the field alone
 */
function keepsFieldStatusOnSampleLoad(pFieldStatus, pKeepSavedStatuses, pPickedStatus)
{
	if (!pFieldStatus || pKeepSavedStatuses === undefined || pKeepSavedStatuses === null || pKeepSavedStatuses === false)
	{
		return false;
	}
	return (pFieldStatus === pPickedStatus) || normalizeCodeList(pKeepSavedStatuses).includes(pFieldStatus);
}

/**
 * @param {Array<string>} pTestResults - each test's result code, '' for a test with none yet
 * @param {string} pSampleStatus - the field's current status code
 * @param {{ UnfinishedTestResults?: string|Array<string> }} [pOptions] - UnfinishedTestResults: result codes that
 *   count as a test that isn't finished (e.g. `SQTY`, a deviation a person must judge), so they never roll up
 *   to Passed on their own
 * @return {string|null} the new status code, or null to leave the field alone
 */
function computeSampleStatusFromTestResults(pTestResults, pSampleStatus, pOptions)
{
	const tmpUnfinished = normalizeUnfinishedTestResults(pOptions && pOptions.UnfinishedTestResults);
	let tmpSeenPendingTest = false;
	let tmpSeenEmptyTest = false;
	let tmpSeenFinalizedTest = false;
	let tmpSeenFailingTest = false;
	let tmpSeenPassingTest = false;
	for (const tmpTestResult of pTestResults)
	{
		if (!tmpTestResult)
		{
			tmpSeenPendingTest = true;
			tmpSeenEmptyTest = true;
			break;
		}
		// A result that still needs a person: the test ran, so the sample is in testing, and a failure elsewhere still counts.
		if (tmpUnfinished.includes(tmpTestResult))
		{
			tmpSeenPendingTest = true;
			tmpSeenFinalizedTest = true;
			continue;
		}
		if (tmpTestResult.startsWith('FAI'))
		{
			tmpSeenFailingTest = true;
			tmpSeenFinalizedTest = true;
		}
		if (tmpTestResult.startsWith('PAS'))
		{
			tmpSeenPassingTest = true;
			tmpSeenFinalizedTest = true;
		}
	}
	if (tmpSeenFailingTest)
	{
		if (!pSampleStatus || pSampleStatus != 'VOID' && pSampleStatus != 'PREA' && pSampleStatus != 'FAIL' && pSampleStatus != 'FAIC')
		{
			return 'FAIL';
		}
	}
	else if (tmpSeenPendingTest)
	{
		// Only unfinished results left: Passed was a person's call on them, so it stays.
		if (!tmpSeenEmptyTest && ((pSampleStatus == 'PASS') || (pSampleStatus == 'PASC')))
		{
			return null;
		}
		const tmpNewSampleStatus = tmpSeenFinalizedTest ? 'TEST' : 'PEND';
		if (!pSampleStatus || pSampleStatus != 'VOID' && pSampleStatus != 'PREA' && pSampleStatus != 'FAIL' && pSampleStatus != 'FAIC' && pSampleStatus != tmpNewSampleStatus)
		{
			return tmpNewSampleStatus;
		}
	}
	else if (tmpSeenPassingTest)
	{
		if (!pSampleStatus || pSampleStatus == 'N/A' || pSampleStatus == 'LOGD' || pSampleStatus == 'RECV' || pSampleStatus == 'INFO' || pSampleStatus == 'PEND' || pSampleStatus == 'TEST' || pSampleStatus == 'TSTR')
		{
			return 'PASS';
		}
	}
	return null;
}

module.exports = { computeSampleStatusFromTestResults, normalizeUnfinishedTestResults, keepsFieldStatusOnSampleLoad, getPickedStatusAddress };

},{}],162:[function(require,module,exports){
/**
 * Scoped `Document.EntityData` comprehension emission — the shared primitives behind the
 * `UseScopedEntityData` rollout flag.
 *
 * The legacy path projects created records into `FormData._EntityData` as a flat
 * `[Entity][GUID]` ledger and lets the browser-side `FormEntityCreator` apply it. The scoped
 * path writes each record straight into the document's own `EntityData` under a trigger-context
 * key — `OnSave.<Entity>.<GUID>`, `OnEnteringState.Approved.<Entity>.<GUID>` — which the server
 * applies (api/headlight on document update, approvals on approval action). WHEN a record is
 * applied is encoded ONLY by which context it is nested under, so scheduling is configuration
 * (`PictForm.ComprehensionContext`), not provider code.
 *
 * Writes route through `DynamicFormSolverBehaviors.addComprehensionEntity` — the one shared
 * comprehension writer, also used by the solver path and `DocumentDynamicSectionManager` — so
 * every producer emits the same shape.
 *
 * @module _ScopedEntityData
 */

/** The context a save-time record lands under when an input declares none. */
const DEFAULT_CONTEXT = 'OnSave';

/**
 * The context a deferred value lands under when an input declares none.
 *
 * Keyed on the status the document enters rather than the action that took it there: a workflow whose
 * every step is `Approve` applies an action-keyed value at the FIRST step and again at each one after
 * it. Requires an API and approvals service carrying `OnEnteringState` (0.43.162 or later); an older
 * one strips the deferred value with the rest of the trigger's deny-listed columns.
 */
const DEFAULT_DEFERRED_CONTEXT = 'OnEnteringState.Approved';

/**
 * The trigger keys a comprehension nests under, and how many address parts each takes before the
 * entity buckets begin. `OnSave` stages for the next document save and is drained once applied; the
 * others stage for a workflow transition, name the action or status they fire on, and stand until
 * that transition happens — so a leaf under one of them outlives many saves.
 *
 * Every walk of the tree reads this rather than naming the keys it knows, so adding a trigger is one
 * entry here. Mirrors `SPECIAL_TABLES_KEYS` in `headlight-comprehension-processor` and its copy in
 * `api/headlight`.
 */
const TRIGGER_CONTEXT_DEPTH = Object.freeze({ OnSave: 1, OnApprovalAction: 2, OnEnteringState: 2 });

/** The trigger keys that stage for a workflow transition rather than for the next save. */
const DEFERRED_TRIGGERS = Object.freeze([ 'OnApprovalAction', 'OnEnteringState' ]);

/**
 * The deprecated deferred trigger. The server still applies it, so documents already carrying one keep
 * working; a form that stages under another trigger takes its leaves with it rather than leaving a
 * second copy that applies on the first approval step.
 */
const LEGACY_DEFERRED_TRIGGER = 'OnApprovalAction';

/** Fallback comprehension destination when the solver-behaviors provider is unavailable. */
const DOCUMENT_ENTITY_DATA_ADDRESS = 'AppData.DocumentData.ReportData.EntityData';

/**
 * Read one `UseScopedEntityData` setting. Strings are honored because the value is authored in
 * JSON form config, where a boolean often arrives quoted — and an opt-out that silently failed to
 * take would leave a form on the legacy path with no signal.
 *
 * @param {any} pValue - The configured value.
 * @return {boolean|null} - The setting, or null when the value expresses no opinion.
 */
function readFlagValue(pValue)
{
	if (typeof pValue === 'boolean')
	{
		return pValue;
	}
	if (typeof pValue === 'string')
	{
		const tmpNormalized = pValue.trim().toLowerCase();
		if (tmpNormalized === 'false')
		{
			return false;
		}
		if (tmpNormalized === 'true')
		{
			return true;
		}
	}
	return null;
}

/**
 * Whether the scoped-emission path is active. ONE flag drives both the inputs' emission target and
 * the `FormEntityCreator` skip — the two paths must never run together, so this resolves from a
 * single name: the form manifest wins (either direction) over the app-level setting. Scoped emission
 * is the DEFAULT; only an explicit `false` holds a form on the legacy
 * `FormData._EntityData` + browser-side-apply path.
 *
 * Default-on is a QA-shakedown posture, not a prod decision. It is safe here only because the
 * server-side apply now archives an applied `OnSave` subtree into `EntityData.ExecutionLog` and
 * guards re-application on a content hash; without that, a stored subtree replays on EVERY Document
 * update and reverts whatever wrote to those entities since the last form save. A branch build cut
 * for stage or release picks this default up, so the prod posture is a decision that has to be taken
 * before that cut, not inherited from this line.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when inputs should emit scoped comprehensions and FEC should stand down.
 */
function isEnabled(pPict)
{
	const tmpSettings = (pPict && pPict.settings) || { };
	const tmpManifest = tmpSettings.MyDefaultFormManifest;
	const tmpManifestFlag = readFlagValue(tmpManifest && tmpManifest.UseScopedEntityData);
	if (tmpManifestFlag !== null)
	{
		return tmpManifestFlag;
	}
	const tmpApplicationFlag = readFlagValue(tmpSettings.UseScopedEntityData);
	if (tmpApplicationFlag !== null)
	{
		return tmpApplicationFlag;
	}
	return true;
}

/**
 * The pict flag an input sets once it has actually emitted scoped, and `FormEntityCreator` reads
 * before running its legacy apply.
 *
 * The two paths must never run over the same save. Both sides resolving `isEnabled` is not enough
 * on its own: they agree only if they are the SAME module, and a second installed copy of this
 * bundle (or a stale build of one half) puts them back out of step with no signal — the ledger
 * reads empty, and the diff-delete takes that for "every document-owned record was removed".
 * This is the runtime cross-check for that.
 */
const ACTIVE_MARKER = '_ScopedEntityDataActive';

/**
 * Record that an input emitted scoped on this save.
 *
 * @param {Object} pPict - The pict instance.
 */
function markActive(pPict)
{
	if (pPict && typeof pPict === 'object')
	{
		pPict[ACTIVE_MARKER] = true;
	}
}

/**
 * Whether an input has emitted scoped comprehensions on this pict.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True when the scoped path is live.
 */
function isMarkedActive(pPict)
{
	return !!(pPict && typeof pPict === 'object' && pPict[ACTIVE_MARKER]);
}

/**
 * Context roots the picker family projected into on this save, kept on the pict rather than on a
 * provider: every Materials provider's save hook can drive a sweep, and the provider that prunes last
 * must also prune what other providers' inputs projected, or its sweep re-sends their records whole.
 */
const NOTED_PROJECTION_ROOTS_MARKER = '_ScopedEntityDataNotedProjectionRoots';

/**
 * Note a context root an input projected into, for whichever provider sanitizes after the sweep.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {Record<string, any>} pContextRoot - The root the input wrote into.
 */
function noteProjectionRoot(pPict, pContext, pContextRoot)
{
	if (!pPict || typeof pPict !== 'object' || !pContextRoot || typeof pContextRoot !== 'object')
	{
		return;
	}
	if (!(pPict[NOTED_PROJECTION_ROOTS_MARKER] instanceof Map))
	{
		pPict[NOTED_PROJECTION_ROOTS_MARKER] = new Map();
	}
	pPict[NOTED_PROJECTION_ROOTS_MARKER].set(pContext, pContextRoot);
}

/**
 * Take (and clear) the context roots noted since the last sanitize pass.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Array<[string, Record<string, any>]>} - `[context, root]` pairs; empty when none were noted.
 */
function takeNotedProjectionRoots(pPict)
{
	if (!pPict || typeof pPict !== 'object' || !(pPict[NOTED_PROJECTION_ROOTS_MARKER] instanceof Map))
	{
		return [];
	}
	const tmpNoted = [ ...pPict[NOTED_PROJECTION_ROOTS_MARKER].entries() ];
	pPict[NOTED_PROJECTION_ROOTS_MARKER].clear();
	return tmpNoted;
}

/**
 * Resolve the trigger context an input emits under.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {string} [pDefaultContext] - The provider's default when the input declares none.
 * @return {string} - The comprehension context (a dotted address, e.g. `OnApprovalAction.Approve`).
 */
function resolveContext(pInput, pDefaultContext)
{
	const tmpConfigured = pInput && pInput.PictForm && pInput.PictForm.ComprehensionContext;
	if (typeof tmpConfigured === 'string' && tmpConfigured.length > 0)
	{
		return tmpConfigured;
	}
	return pDefaultContext || DEFAULT_CONTEXT;
}

/**
 * Field-name prefixes that mark a meadow directive rather than a column. `_Dest_` composes with the
 * field it redirects, so the destination directive for an exact-GUID reference is `_Dest_` +
 * `_GUID<Entity>` — `_Dest__GUID<Entity>`, a double underscore the transient-state test would
 * otherwise eat, silently retargeting the foreign key.
 */
const MEADOW_DIRECTIVE_PREFIXES = [ '_Dest_', '_GUID' ];

/**
 * Is a field transient entity-selector UI state rather than something to persist?
 *
 * Selectors marshal `<Field>__Salt` / `<Field>__Record` siblings alongside their value; carried into
 * a comprehension they reach meadow's INSERT column list and diverge the column/value counts.
 *
 * @param {string} pFieldName - The record field name.
 * @return {boolean} - True when the field is UI state and must not be persisted.
 */
function isTransientFormField(pFieldName)
{
	if (typeof pFieldName !== 'string' || !pFieldName.includes('__'))
	{
		return false;
	}
	for (const tmpPrefix of MEADOW_DIRECTIVE_PREFIXES)
	{
		if (pFieldName.startsWith(tmpPrefix))
		{
			return false;
		}
	}
	return true;
}

/**
 * Strip transient entity-selector UI state from a record before it is persisted. Mirrors
 * `FormEntityCreator.sanitizeComprehension` at the record level.
 *
 * @param {Record<string, any>} pRecord - The record to sanitize.
 * @return {Record<string, any>} - A clone with the UI-state fields removed.
 */
/**
 * Whether a field is an id column carrying a value no id column can hold.
 *
 * The selectors use a placeholder for "the user asked for a new one" (`__NEW__`) and put it in the
 * record's own id slot until the server resolves a real one. It is interface state, not data: an
 * upsert resolves the row by GUID and then compares the id it found against the id the record
 * carries, so a placeholder that outlives the create makes every later save of that record fail with
 * `Default identifier does not match GUID record` - permanently, because the row now exists.
 *
 * Only strings that are not numbers at all are dropped. `0`, `''` and `'57004'` are left exactly as
 * they were: they reach the column as a number, and changing that would change what a save means.
 *
 * @param {string} pFieldName - the field name.
 * @param {any} pValue - the field value.
 * @return {boolean} - True when the field must not be emitted.
 */
function isUnresolvedIdentityField(pFieldName, pValue)
{
	if (typeof pFieldName !== 'string' || !(/^ID[A-Z]/).test(pFieldName))
	{
		return false;
	}
	if (typeof pValue !== 'string')
	{
		return false;
	}
	return !Number.isFinite(Number(pValue));
}

function sanitizeRecord(pRecord)
{
	const tmpSanitized = { };
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return tmpSanitized;
	}
	for (const tmpField of Object.keys(pRecord))
	{
		if (isTransientFormField(tmpField))
		{
			continue;
		}
		if (isUnresolvedIdentityField(tmpField, pRecord[tmpField]))
		{
			continue;
		}
		tmpSanitized[tmpField] = pRecord[tmpField];
	}
	return tmpSanitized;
}

/**
 * The pict-level marker naming the scratch tree a baseline sweep is collecting into.
 *
 * The baseline is captured by re-running the ordinary save sweep at load, so every projector — both
 * input families, the subclass cascades, the deferred TestResult split — must land in the scratch
 * rather than in the document. Redirecting the single destination resolver is what achieves that:
 * everything downstream (context roots, entity buckets, record writes) already routes through it.
 */
const BASELINE_SWEEP_MARKER = '_ScopedEntityDataBaselineSweep';

/**
 * Begin a baseline sweep: subsequent comprehension writes land in a fresh scratch tree instead of
 * the document's own EntityData.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Record<string, any>} - The scratch tree the sweep will fill.
 */
function beginBaselineSweep(pPict)
{
	const tmpSweep = { Scratch: { }, Contexts: new Map() };
	if (pPict && typeof pPict === 'object')
	{
		pPict[BASELINE_SWEEP_MARKER] = tmpSweep;
	}
	return tmpSweep;
}

/**
 * The in-flight baseline sweep, or null when none is running.
 *
 * @param {Object} pPict - The pict instance.
 * @return {{ Scratch: Record<string, any>, Contexts: Map<string, Record<string, any>> }|null} - The sweep, or null.
 */
function getBaselineSweepTarget(pPict)
{
	if (!pPict || typeof pPict !== 'object')
	{
		return null;
	}
	const tmpSweep = pPict[BASELINE_SWEEP_MARKER];
	return (tmpSweep && typeof tmpSweep === 'object' && tmpSweep.Scratch) ? tmpSweep : null;
}

/**
 * End a baseline sweep and hand back what it collected, as the (context -> context root) pairs the
 * projectors actually resolved. The pairs are what the caller needs: a context is a DOTTED address
 * (`OnApprovalAction.Approve`), so the collected tree cannot be walked back into contexts and entity
 * buckets by shape alone.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Map<string, Record<string, any>>|null} - The collected roots by context, or null when no sweep was running.
 */
function endBaselineSweep(pPict)
{
	const tmpSweep = getBaselineSweepTarget(pPict);
	if (pPict && typeof pPict === 'object')
	{
		delete pPict[BASELINE_SWEEP_MARKER];
	}
	return tmpSweep ? tmpSweep.Contexts : null;
}

/**
 * Resolve the object comprehensions are written into. Prefers the solver-behaviors provider's own
 * destination (configured on the metacontroller as `comprehensionDestinationAddress`, which the
 * configurable application points at `Document.EntityData`) so scoped writes and solver writes
 * always land in the same place.
 *
 * @param {Object} pPict - The pict instance.
 * @return {Record<string, any>|null} - The destination object, or null when none can be resolved.
 */
function resolveDestination(pPict)
{
	const tmpBaselineSweep = getBaselineSweepTarget(pPict);
	if (tmpBaselineSweep)
	{
		return tmpBaselineSweep.Scratch;
	}
	const tmpBehaviors = pPict && pPict.providers && pPict.providers.DynamicFormSolverBehaviors;
	if (tmpBehaviors && typeof tmpBehaviors.resolveComprehensionDestination === 'function')
	{
		const tmpResolved = tmpBehaviors.resolveComprehensionDestination();
		if (tmpResolved && typeof tmpResolved === 'object' && !Array.isArray(tmpResolved))
		{
			return tmpResolved;
		}
	}
	if (!pPict || !pPict.manifest || typeof pPict.manifest.getValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpEntityData = pPict.manifest.getValueAtAddress(pPict, DOCUMENT_ENTITY_DATA_ADDRESS);
	if (tmpEntityData && typeof tmpEntityData === 'object' && !Array.isArray(tmpEntityData))
	{
		return tmpEntityData;
	}
	if (typeof pPict.manifest.setValueAtAddress !== 'function')
	{
		return null;
	}
	const tmpCreated = { };
	pPict.manifest.setValueAtAddress(pPict, DOCUMENT_ENTITY_DATA_ADDRESS, tmpCreated);
	return tmpCreated;
}

/**
 * Walk (creating as it goes) `pNode -> <context parts>` and hand back the node the entity buckets
 * hang from.
 *
 * @param {Record<string, any>} pNode - The node to walk from.
 * @param {string} pContext - The dotted context address.
 * @return {Record<string, any>} - The context node.
 */
function walkContext(pNode, pContext)
{
	let tmpCursor = pNode;
	for (const tmpPart of String(pContext).split('.'))
	{
		if (tmpPart.length < 1)
		{
			continue;
		}
		if (!tmpCursor[tmpPart] || typeof tmpCursor[tmpPart] !== 'object' || Array.isArray(tmpCursor[tmpPart]))
		{
			tmpCursor[tmpPart] = { };
		}
		tmpCursor = tmpCursor[tmpPart];
	}
	return tmpCursor;
}

/**
 * The node a context's records are keyed under, as `<Entity>.<GUID>`.
 *
 * That is the SAME shape as the legacy flat `_EntityData` ledger, which is what makes the scoped
 * conversion a retarget rather than a rewrite: hand this node to a projector written against the
 * flat ledger and it produces a correct scoped comprehension, unchanged.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The dotted context address.
 * @return {Record<string, any>|null} - The context root, or null when no destination resolves.
 */
function resolveContextRoot(pPict, pContext)
{
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return null;
	}
	const tmpContext = pContext || DEFAULT_CONTEXT;
	const tmpRoot = walkContext(tmpDestination, tmpContext);
	const tmpBaselineSweep = getBaselineSweepTarget(pPict);
	if (tmpBaselineSweep)
	{
		tmpBaselineSweep.Contexts.set(tmpContext, tmpRoot);
	}
	return tmpRoot;
}

/**
 * Walk (creating as it goes) `Destination -> <context parts> -> <Entity>` and hand back the
 * entity bucket.
 *
 * @param {Record<string, any>} pDestination - The comprehension destination object.
 * @param {string} pContext - The dotted context address.
 * @param {string} pEntity - The entity name.
 * @return {Record<string, any>} - The entity bucket, keyed by external GUID.
 */
function resolveEntityBucket(pDestination, pContext, pEntity)
{
	const tmpCursor = walkContext(pDestination, pContext);
	if (!tmpCursor[pEntity] || typeof tmpCursor[pEntity] !== 'object' || Array.isArray(tmpCursor[pEntity]))
	{
		tmpCursor[pEntity] = { };
	}
	return tmpCursor[pEntity];
}

/**
 * Replace every `<Entity>.<GUID>` leaf under a context root with a sanitized CLONE.
 *
 * The projectors key the form's LIVE record objects into the comprehension by reference, and this
 * tree is saved with the document — so the transient `__` UI state has to come off, and it has to
 * come off a copy, because the form goes on rendering from the original. This is the scoped
 * counterpart of the pass `FormEntityCreator` used to run over the ledger at apply time.
 *
 * @param {Record<string, any>} pContextRoot - The context root to sanitize in place.
 * @return {boolean} - True when a root was walked.
 */
function sanitizeContextRoot(pContextRoot)
{
	if (!pContextRoot || typeof pContextRoot !== 'object' || Array.isArray(pContextRoot))
	{
		return false;
	}
	for (const tmpEntity of Object.keys(pContextRoot))
	{
		const tmpBucket = pContextRoot[tmpEntity];
		if (!tmpBucket || typeof tmpBucket !== 'object' || Array.isArray(tmpBucket))
		{
			continue;
		}
		for (const tmpGUID of Object.keys(tmpBucket))
		{
			const tmpRecord = tmpBucket[tmpGUID];
			if (!tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
			{
				continue;
			}
			tmpBucket[tmpGUID] = sanitizeRecord(tmpRecord);
		}
	}
	return true;
}

/**
 * Write one record into `<Context>.<Entity>.<GUID>`, replacing whatever leaf was there.
 *
 * The leaf is dropped before the write because `addComprehensionEntity` ACCUMULATES properties on
 * an existing (Context, Entity, GUID) — so a re-added record would otherwise inherit the `Deleted`
 * flag from a tombstone, or fields the form has since dropped.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} pRecord - The record to write (sanitized here).
 * @return {boolean} - True when the record was written.
 */
function writeRecord(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pContext || !pEntity || !pGUID)
	{
		return false;
	}
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return false;
	}
	const tmpBucket = resolveEntityBucket(tmpDestination, pContext, pEntity);
	delete tmpBucket[pGUID];

	const tmpSanitized = sanitizeRecord(pRecord);
	const tmpBehaviors = pPict && pPict.providers && pPict.providers.DynamicFormSolverBehaviors;
	if (tmpBehaviors && typeof tmpBehaviors.addComprehensionEntity === 'function' && !getBaselineSweepTarget(pPict))
	{
		for (const tmpField of Object.keys(tmpSanitized))
		{
			tmpBehaviors.addComprehensionEntity(pContext, pEntity, pGUID, tmpField, tmpSanitized[tmpField]);
		}
		return true;
	}
	tmpBucket[pGUID] = tmpSanitized;
	return true;
}

/**
 * Mint a tombstone: the minimal record the server-side pre-pass needs to resolve the row by GUID
 * and delete it. The safety property is the ORDERING on the apply path, not the adapter:
 * `applyComprehensionSubtree` runs `partitionTombstones` first and splits every `Deleted`-carrying
 * record out of the upsert subtree, so this leaf never reaches the adapter as an update. The
 * adapter itself does NOT strip `Deleted` -- it honours it as a delete, and `PerformDeletes`
 * defaults on -- so a tombstone routed anywhere that skips the partition pass still deletes.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {boolean} - True when the tombstone was written.
 */
function writeTombstone(pPict, pContext, pEntity, pGUID)
{
	const tmpRecord = { Deleted: 1 };
	tmpRecord[`GUID${pEntity}`] = pGUID;
	return writeRecord(pPict, pContext, pEntity, pGUID, tmpRecord);
}

/**
 * Whether a record is known to exist server-side, so a tombstone for it cannot delete a phantom.
 * Evidence, in order: a server-assigned `ID<Entity>` on the record itself; the legacy root ledger
 * a `FormEntityCreator`-era save left behind; a leaf a prior scoped save wrote under this context.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context the record is emitted under.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} [pRecord] - (optional) The in-memory record.
 * @return {boolean} - True when the record has been persisted.
 */
function isPersistedGUID(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pGUID)
	{
		return false;
	}
	if (pRecord && typeof pRecord === 'object' && pRecord[`ID${pEntity}`])
	{
		return true;
	}
	// A save folds every record it emitted into the baseline. Offline that is the only evidence there
	// is: no response comes back, so no row id is ever written onto the record, and the delta prune
	// takes the leaf out of the tree as soon as a later save finds it unchanged.
	if (pPict && pPict.manifest && typeof pPict.manifest.getValueAtAddress === 'function')
	{
		const tmpBaseline = pPict.manifest.getValueAtAddress(pPict, ENTITY_DATA_BASELINE_ADDRESS);
		const tmpBaselineContext = (tmpBaseline && typeof tmpBaseline === 'object') ? tmpBaseline[pContext || DEFAULT_CONTEXT] : null;
		const tmpBaselineBucket = (tmpBaselineContext && typeof tmpBaselineContext === 'object') ? tmpBaselineContext[pEntity] : null;
		if (tmpBaselineBucket && typeof tmpBaselineBucket === 'object' && tmpBaselineBucket[pGUID])
		{
			return true;
		}
	}
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return false;
	}
	const tmpRootBucket = tmpDestination[pEntity];
	if (tmpRootBucket && typeof tmpRootBucket === 'object' && tmpRootBucket[pGUID])
	{
		return true;
	}
	let tmpCursor = tmpDestination;
	for (const tmpPart of String(pContext || DEFAULT_CONTEXT).split('.'))
	{
		if (tmpPart.length < 1)
		{
			continue;
		}
		tmpCursor = tmpCursor[tmpPart];
		if (!tmpCursor || typeof tmpCursor !== 'object')
		{
			return false;
		}
	}
	const tmpScopedBucket = tmpCursor[pEntity];
	return !!(tmpScopedBucket && typeof tmpScopedBucket === 'object' && tmpScopedBucket[pGUID]);
}

/**
 * The document record the form is editing. `DOCUMENT_ENTITY_DATA_ADDRESS` is this plus `.EntityData`.
 */
const DOCUMENT_RECORD_ADDRESS = 'AppData.DocumentData.ReportData';

/**
 * Where the delta baseline rides. Inside `FormData` so it survives an offline save and reload;
 * `_EntityDataBaseline` owns the contents and reads the address from here so there is one of it.
 */
const ENTITY_DATA_BASELINE_ADDRESS = `${DOCUMENT_RECORD_ADDRESS}.FormData.__EntityDataBaseline`;

/**
 * The pict-level counter marking a PROGRAMMATIC value write — a load, an adoption, a cascade — as
 * opposed to a user edit. It is deliberately the same name the autofill-scope vet already suppresses
 * on, so a load driven by either input family is seen as a load by both.
 */
const PROGRAMMATIC_LOAD_MARKER = '_MaterialsEntityHydrationDepth';

/**
 * Mark the start of a programmatic value write. `pict-section-form`'s `setDataByInput` routes
 * straight into `onDataChange`, so a loader that seeds a value is indistinguishable from a user
 * edit at the provider seam — and the removal routes read exactly that seam. Pair with
 * `endProgrammaticLoad` in a `finally`.
 *
 * @param {Object} pPict - The pict instance.
 */
function beginProgrammaticLoad(pPict)
{
	if (pPict && typeof pPict === 'object')
	{
		pPict[PROGRAMMATIC_LOAD_MARKER] = (pPict[PROGRAMMATIC_LOAD_MARKER] || 0) + 1;
	}
}

/**
 * Close a `beginProgrammaticLoad` scope.
 *
 * @param {Object} pPict - The pict instance.
 */
function endProgrammaticLoad(pPict)
{
	if (pPict && typeof pPict === 'object' && pPict[PROGRAMMATIC_LOAD_MARKER] > 0)
	{
		pPict[PROGRAMMATIC_LOAD_MARKER]--;
	}
}

/**
 * Whether a programmatic value write is in flight.
 *
 * @param {Object} pPict - The pict instance.
 * @return {boolean} - True while a load, adoption or cascade is driving the value.
 */
function isProgrammaticLoad(pPict)
{
	return !!(pPict && typeof pPict === 'object' && pPict[PROGRAMMATIC_LOAD_MARKER]);
}

/**
 * Drop every staged leaf for one record, in every trigger context.
 *
 * A record can be staged under more than one context — a TestInstance saves under `OnSave` while its
 * `TestResult` waits under `OnEnteringState.Approved`. Tombstoning it in one context alone would leave
 * the other leaf to be applied later as an UPSERT, and an upsert creates: the row the user removed
 * would come back at approval time. The approvals path has no owner GUID, so its tombstones are
 * skipped wholesale — leaving the leaf is the only thing that can go wrong there, so it must go.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {number} - How many leaves were dropped.
 */
function dropRecordLeaves(pPict, pEntity, pGUID)
{
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination || !pEntity || !pGUID)
	{
		return 0;
	}
	let tmpDropped = 0;
	forEachContextRoot(tmpDestination, (pContextRoot) =>
	{
		const tmpBucket = pContextRoot[pEntity];
		if (tmpBucket && typeof tmpBucket === 'object' && !Array.isArray(tmpBucket) && Object.prototype.hasOwnProperty.call(tmpBucket, pGUID))
		{
			delete tmpBucket[pGUID];
			tmpDropped++;
		}
	});
	if (tmpDropped > 0)
	{
		scrubEmptyContainers(tmpDestination);
	}
	return tmpDropped;
}

/**
 * Walk every node entity buckets hang from: each trigger context, and the destination root itself,
 * which carries the legacy flat ledger.
 *
 * @param {Record<string, any>} pDestination - The comprehension destination.
 * @param {(pContextRoot: Record<string, any>, pTrigger: string|null, pContextKey: string|null) => void} fCallback - Called per node.
 * @return {void}
 */
function forEachContextRoot(pDestination, fCallback)
{
	if (!pDestination || typeof pDestination !== 'object' || Array.isArray(pDestination))
	{
		return;
	}
	fCallback(pDestination, null, null);
	for (const tmpTrigger of Object.keys(TRIGGER_CONTEXT_DEPTH))
	{
		const tmpTriggerNode = pDestination[tmpTrigger];
		if (!tmpTriggerNode || typeof tmpTriggerNode !== 'object' || Array.isArray(tmpTriggerNode))
		{
			continue;
		}
		if (TRIGGER_CONTEXT_DEPTH[tmpTrigger] === 1)
		{
			fCallback(tmpTriggerNode, tmpTrigger, null);
			continue;
		}
		for (const tmpContextKey of Object.keys(tmpTriggerNode))
		{
			const tmpContextRoot = tmpTriggerNode[tmpContextKey];
			if (tmpContextRoot && typeof tmpContextRoot === 'object' && !Array.isArray(tmpContextRoot))
			{
				fCallback(tmpContextRoot, tmpTrigger, tmpContextKey);
			}
		}
	}
}

/**
 * Drop the containers a removal emptied: an entity bucket holding no records, a context holding no
 * entities, a trigger holding no contexts. An empty bucket applies nothing, but it reads as staged
 * intent to anything that walks the tree, and it rides every save and every sync.
 *
 * The destination root is left alone — its own keys are the triggers, the execution log and the
 * legacy ledger, none of which this may prune.
 *
 * @param {Record<string, any>} pDestination - The comprehension destination.
 * @return {void}
 */
function scrubEmptyContainers(pDestination)
{
	if (!pDestination || typeof pDestination !== 'object' || Array.isArray(pDestination))
	{
		return;
	}
	for (const tmpTrigger of Object.keys(TRIGGER_CONTEXT_DEPTH))
	{
		const tmpTriggerNode = pDestination[tmpTrigger];
		if (!tmpTriggerNode || typeof tmpTriggerNode !== 'object' || Array.isArray(tmpTriggerNode))
		{
			continue;
		}
		const tmpContexts = (TRIGGER_CONTEXT_DEPTH[tmpTrigger] === 1) ? [ [ null, tmpTriggerNode ] ] : Object.entries(tmpTriggerNode);
		for (const [ tmpContextKey, tmpContextRoot ] of tmpContexts)
		{
			if (!tmpContextRoot || typeof tmpContextRoot !== 'object' || Array.isArray(tmpContextRoot))
			{
				continue;
			}
			for (const tmpEntity of Object.keys(tmpContextRoot))
			{
				const tmpBucket = tmpContextRoot[tmpEntity];
				if (tmpBucket && typeof tmpBucket === 'object' && !Array.isArray(tmpBucket) && Object.keys(tmpBucket).length < 1)
				{
					delete tmpContextRoot[tmpEntity];
				}
			}
			if (tmpContextKey !== null && Object.keys(tmpContextRoot).length < 1)
			{
				delete tmpTriggerNode[tmpContextKey];
			}
		}
		if (Object.keys(tmpTriggerNode).length < 1)
		{
			delete pDestination[tmpTrigger];
		}
	}
}

/** Why a removal did not stage a tombstone (or that it did). */
const TOMBSTONE_OUTCOME = Object.freeze(
	{
		Staged: 'staged',
		NoGUID: 'no-guid',
		Unpersisted: 'unpersisted',
		NotOwned: 'not-owned',
	});

/**
 * The rows a selector correlates to its selection, and so the only entity types a removal may delete. Each
 * selector declares its own (see `_collectRemovedDependentRecords`); this set is the assertion that none of
 * them ever hands the gate a reference record such as a Lab, Test or Material.
 */
const DOCUMENT_OWNED_ENTITIES = new Set([ 'TestInstance', 'TestInstanceSampleJoin', 'TestInstanceLabJoin', 'SampleLabJoin', 'SampleLineItemJoin', 'DocumentPolyJoin' ]);

/**
 * Stage a tombstone for a removed record.
 *
 * The record must be one of the rows a selector owns (`DOCUMENT_OWNED_ENTITIES`), and it must have been
 * written (`isPersistedGUID`): tombstoning something the server has never seen asks it to delete a phantom.
 *
 * This is the single entry point every removal route uses, so the Select2 and Picker families cannot
 * drift apart on what "removed" means.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {Record<string, any>} [pRecord] - (optional) The in-memory record.
 * @return {string} - One of `TOMBSTONE_OUTCOME`.
 */
function writeTombstoneIfDeletable(pPict, pContext, pEntity, pGUID, pRecord)
{
	if (!pEntity || typeof pGUID !== 'string' || pGUID.length < 1)
	{
		return TOMBSTONE_OUTCOME.NoGUID;
	}
	if (!DOCUMENT_OWNED_ENTITIES.has(pEntity))
	{
		return TOMBSTONE_OUTCOME.NotOwned;
	}
	// Asked before the leaves go, because a leaf a prior save wrote is one of the answers.
	const tmpPersisted = isPersistedGUID(pPict, pContext, pEntity, pGUID, pRecord);
	// The leaves go either way. A record the user removed has no staged intent left, and one staged for
	// a trigger would otherwise upsert the row back the next time the document reaches it.
	dropRecordLeaves(pPict, pEntity, pGUID);
	if (!tmpPersisted)
	{
		return TOMBSTONE_OUTCOME.Unpersisted;
	}
	return writeTombstone(pPict, pContext, pEntity, pGUID) ? TOMBSTONE_OUTCOME.Staged : TOMBSTONE_OUTCOME.NoGUID;
}

/**
 * Stage tombstones for a set of removed records.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The comprehension context.
 * @param {Array<{ Entity: string, Record: Record<string, any> }>} pRemovals - The removed records.
 * @return {{ Staged: Array<string>, Unpersisted: number, Refused: Array<string> }} - What happened, for the caller to log.
 */
function tombstoneRemovedRecords(pPict, pContext, pRemovals)
{
	const tmpResult = { Staged: [ ], Unpersisted: 0, Refused: [ ] };
	if (!Array.isArray(pRemovals))
	{
		return tmpResult;
	}
	for (const tmpRemoval of pRemovals)
	{
		const tmpEntity = tmpRemoval && tmpRemoval.Entity;
		const tmpRecord = tmpRemoval && tmpRemoval.Record;
		if (!tmpEntity || !tmpRecord || typeof tmpRecord !== 'object' || Array.isArray(tmpRecord))
		{
			continue;
		}
		const tmpGUID = tmpRecord[`GUID${tmpEntity}`];
		const tmpOutcome = writeTombstoneIfDeletable(pPict, pContext, tmpEntity, tmpGUID, tmpRecord);
		if (tmpOutcome === TOMBSTONE_OUTCOME.Staged)
		{
			tmpResult.Staged.push(`${tmpEntity}:${tmpGUID}`);
		}
		else if (tmpOutcome === TOMBSTONE_OUTCOME.Unpersisted)
		{
			tmpResult.Unpersisted++;
		}
		else if (tmpOutcome === TOMBSTONE_OUTCOME.NotOwned)
		{
			tmpResult.Refused.push(`${tmpEntity}:${tmpGUID}`);
		}
	}
	if (tmpResult.Refused.length > 0 && pPict && pPict.log && typeof pPict.log.warn === 'function')
	{
		pPict.log.warn(`ScopedEntityData: refused to delete ${tmpResult.Refused.length} record(s) the document does not own: ${tmpResult.Refused.join(', ')}.`);
	}
	return tmpResult;
}

/**
 * The entity a record names ITSELF as, from its `GUID<Entity>` fields.
 *
 * A record carries its own GUID alongside the GUIDs of the rows it points at — a
 * `TestInstanceSampleJoin` holds `GUIDTestInstanceSampleJoin`, `GUIDTestInstance` and `GUIDSample`.
 * The self field is the LONGEST such name: a join's entity name is built by concatenating the names
 * of what it joins, so it is always a superstring of the references beside it. `GUIDDocument` is
 * never a self field on these records, and a `_Dest_GUID<X>` sibling marks `GUID<X>` as a foreign-key
 * redirect rather than an identity.
 *
 * @param {Record<string, any>} pRecord - The candidate record.
 * @return {string} - The entity name, or '' when the object is not an entity record.
 */
function resolveRecordEntity(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return '';
	}
	let tmpEntity = '';
	for (const tmpField of Object.keys(pRecord))
	{
		if (!tmpField.startsWith('GUID') || tmpField.length < 5)
		{
			continue;
		}
		const tmpCandidate = tmpField.substring(4);
		if (tmpCandidate === 'Document' || Object.prototype.hasOwnProperty.call(pRecord, `_Dest_GUID${tmpCandidate}`))
		{
			continue;
		}
		if (typeof pRecord[tmpField] !== 'string' || pRecord[tmpField].length < 1)
		{
			continue;
		}
		if (tmpCandidate.length > tmpEntity.length)
		{
			tmpEntity = tmpCandidate;
		}
	}
	return tmpEntity;
}

/** The slots of a Test selection's triple that hold rows it owns, and the entity each holds. */
const TEST_INSTANCE_UNIT_SLOTS = [ [ 'TestInstance', 'TestInstance' ], [ 'TestInstanceSampleJoin', 'TestInstanceSampleJoin' ], [ 'DocumentPolyJoin', 'DocumentPolyJoin' ], [ '_TestInstanceLabJoin', 'TestInstanceLabJoin' ] ];

/**
 * The rows a Test selection owns: its TestInstance, the instance's sample join, the document's link to it, and the
 * per-test lab picker's lab join. Read from the triple's own slots, never by walking it, so the reference records
 * its pickers display (`IDLab__Record`, the Test) can never be taken for one of its rows.
 *
 * @param {Record<string, any>} pTriple - A `{ TestInstance, TestInstanceSampleJoin, DocumentPolyJoin, _TestInstanceLabJoin }` triple.
 * @return {Array<{ Entity: string, Record: Record<string, any> }>} - The owned rows the triple holds.
 */
function collectTestInstanceUnit(pTriple)
{
	const tmpUnit = [ ];
	if (!pTriple || typeof pTriple !== 'object' || Array.isArray(pTriple))
	{
		return tmpUnit;
	}
	for (const [ tmpSlot, tmpEntity ] of TEST_INSTANCE_UNIT_SLOTS)
	{
		const tmpRecord = pTriple[tmpSlot];
		if (tmpRecord && typeof tmpRecord === 'object' && !Array.isArray(tmpRecord))
		{
			tmpUnit.push({ Entity: tmpEntity, Record: tmpRecord });
		}
	}
	return tmpUnit;
}

/**
 * The rows the selectors in one table row own, asked of each selector rather than read off the row: the row also
 * holds the reference records its pickers display, and those are never a row delete's to remove.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Object} pView - The dynamic-form view owning the row.
 * @param {Record<string, any>} pGroup - The tabular group descriptor.
 * @param {number|string} pRowIndex - The row about to be deleted.
 * @return {Array<{ Entity: string, Record: Record<string, any> }>} - Every selector's owned rows.
 */
function collectRowSelectorRemovals(pPict, pView, pGroup, pRowIndex)
{
	const tmpRemovals = [ ];
	const tmpDescriptors = (pGroup && pGroup.supportingManifest && pGroup.supportingManifest.elementDescriptors) || { };
	if (!pView || typeof pView.getInputProviderList !== 'function')
	{
		return tmpRemovals;
	}
	for (const tmpInput of Object.values(tmpDescriptors))
	{
		for (const tmpProviderHash of pView.getInputProviderList(tmpInput) || [ ])
		{
			const tmpProvider = pPict && pPict.providers && pPict.providers[tmpProviderHash];
			if (tmpProvider && typeof tmpProvider._collectRemovedDependentRecords === 'function')
			{
				tmpRemovals.push(...tmpProvider._collectRemovedDependentRecords(pView, tmpInput, pRowIndex, new Set()));
			}
		}
	}
	return tmpRemovals;
}

/**
 * A persisted TestInstance as a Test selector adopts it on open, in the shape its triple builder later produces
 * (the project filled from the document when the row lacks one), so a load baseline taken before the builder runs
 * already matches what the first save projects.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>} pRow - The TestInstance row as the server returned it.
 * @return {Record<string, any>} - The adopted TestInstance record.
 */
function adoptTestInstance(pPict, pRow)
{
	const tmpInstance = { IDTestInstance: pRow.IDTestInstance, GUIDTestInstance: pRow.GUIDTestInstance, IDTest: pRow.IDTest, IDLab: pRow.IDLab, Name: pRow.Name };
	const tmpIDProject = (Number(pRow.IDProject) > 0) ? pRow.IDProject : pPict?.AppData?.DocumentData?.ReportData?.IDProject;
	if (Number(tmpIDProject) > 0)
	{
		tmpInstance.IDProject = tmpIDProject;
	}
	return tmpInstance;
}

/**
 * Split a TestInstance into the part that saves now and the TestResult that must wait for the
 * approval action. A test result is a reviewed outcome: it must not reach the row when the
 * document is merely saved. Shared by both Test inputs so the Select2 and Picker families cannot
 * disagree on result timing.
 *
 * @param {Record<string, any>} pTestInstance - The TestInstance record.
 * @return {{ Record: Record<string, any>, TestResult: any }} - The save-time record and the held-back result (undefined when there is none to defer).
 */
function splitDeferredTestResult(pTestInstance)
{
	if (!pTestInstance || typeof pTestInstance !== 'object' || !Object.prototype.hasOwnProperty.call(pTestInstance, 'TestResult'))
	{
		return { Record: pTestInstance, TestResult: undefined };
	}
	const tmpProjected = Object.assign({ }, pTestInstance);
	const tmpTestResult = tmpProjected.TestResult;
	delete tmpProjected.TestResult;
	if (tmpTestResult == null || tmpTestResult === '')
	{
		return { Record: tmpProjected, TestResult: undefined };
	}
	return { Record: tmpProjected, TestResult: tmpTestResult };
}

/**
 * Whether a deferred context is one a trigger can find again.
 *
 * It must name a trigger and exactly one action or status (`OnEnteringState.Approved`). The parts are
 * split on `.` here and the server looks the status up as a single key, so a status that contains one
 * would nest into a branch nothing reads.
 *
 * @param {Object} pPict - The pict instance, for the log line.
 * @param {string} pContext - The candidate context.
 * @return {string} - The context, or '' when it may not be used.
 */
function validateDeferredContext(pPict, pContext)
{
	const tmpParts = String(pContext || '').split('.').filter((pPart) => pPart.length > 0);
	if (tmpParts.length === 2 && DEFERRED_TRIGGERS.indexOf(tmpParts[0]) >= 0)
	{
		return tmpParts.join('.');
	}
	if (pPict && pPict.log && typeof pPict.log.warn === 'function')
	{
		pPict.log.warn(`ScopedEntityData: [${pContext}] is not a usable deferred context — it must name a trigger (${DEFERRED_TRIGGERS.join(' / ')}) and one action or status, with no dot inside it.`);
	}
	return '';
}

/**
 * Resolve the context a DEFERRED value (today: a TestInstance's TestResult) is applied under.
 * `PictForm.DeferredComprehensionContext` selects it; the default stages it for the approval
 * action, which is where a reviewed outcome belongs.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {string} [pDefaultContext] - The provider's default when the input declares none.
 * @return {string} - The comprehension context, or '' when neither the configured nor the default one is usable.
 */
function resolveDeferredContext(pInput, pDefaultContext)
{
	const tmpConfigured = pInput && pInput.PictForm && pInput.PictForm.DeferredComprehensionContext;
	if (typeof tmpConfigured === 'string' && tmpConfigured.length > 0)
	{
		return validateDeferredContext(pInput, tmpConfigured);
	}
	return validateDeferredContext(pInput, pDefaultContext || DEFAULT_DEFERRED_CONTEXT);
}

/**
 * Stage one field of a record for a workflow trigger to apply, at the moment the user changed it.
 *
 * The leaf is the form's standing intent for that field: the server copies it onto the row when the
 * document reaches the trigger and leaves it in place for the next time it does. It is written here,
 * at the edit, rather than re-derived on every save sweep — which is what makes a cleared value stage
 * as a clear, and what keeps a save where the user touched nothing from re-asserting it.
 *
 * A cleared value stages as a clear rather than dropping the leaf: no result is a valid outcome to
 * push, and dropping it would leave a previously applied result standing on the row.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pContext - The dotted trigger context, e.g. `OnEnteringState.Approved`.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @param {string} pField - The column being staged.
 * @param {any} pValue - The value the trigger should apply; `''` for a cleared one.
 * @return {boolean} - True when the value was staged.
 */
function stageDeferredValue(pPict, pContext, pEntity, pGUID, pField, pValue)
{
	if (!pEntity || !pField || typeof pGUID !== 'string' || pGUID.length < 1)
	{
		return false;
	}
	if (isProgrammaticLoad(pPict))
	{
		return false;
	}
	const tmpContext = validateDeferredContext(pPict, pContext);
	if (!tmpContext)
	{
		return false;
	}
	const tmpDestination = resolveDestination(pPict);
	if (!tmpDestination)
	{
		return false;
	}
	const tmpBucket = resolveEntityBucket(tmpDestination, tmpContext, pEntity);
	const tmpExisting = (tmpBucket[pGUID] && typeof tmpBucket[pGUID] === 'object' && !Array.isArray(tmpBucket[pGUID])) ? tmpBucket[pGUID] : { };
	const tmpRecord = Object.assign({ }, tmpExisting);
	tmpRecord[`GUID${pEntity}`] = pGUID;
	tmpRecord[pField] = (pValue === null || typeof pValue === 'undefined') ? '' : pValue;
	if (!writeRecord(pPict, tmpContext, pEntity, pGUID, tmpRecord))
	{
		return false;
	}
	dropSupersededDeferredLeaf(pPict, tmpDestination, tmpContext, pEntity, pGUID);
	return true;
}

/**
 * Take a record's leaf out of the deprecated deferred trigger once it is staged under another one.
 *
 * A document that carries both applies the deprecated leaf on every approval ACTION and the current
 * one when the document enters the state — two writes from one intent, the earlier of them at the
 * wrong moment. The form that just staged the value owns it, so the old copy goes with it.
 *
 * @param {Object} pPict - The pict instance.
 * @param {Record<string, any>} pDestination - The comprehension destination.
 * @param {string} pContext - The context just staged under.
 * @param {string} pEntity - The entity name.
 * @param {string} pGUID - The record's external GUID.
 * @return {number} - How many superseded leaves were dropped.
 */
function dropSupersededDeferredLeaf(pPict, pDestination, pContext, pEntity, pGUID)
{
	if (String(pContext).split('.')[0] === LEGACY_DEFERRED_TRIGGER)
	{
		return 0;
	}
	const tmpLegacyRoot = pDestination[LEGACY_DEFERRED_TRIGGER];
	if (!tmpLegacyRoot || typeof tmpLegacyRoot !== 'object' || Array.isArray(tmpLegacyRoot))
	{
		return 0;
	}
	let tmpDropped = 0;
	for (const tmpKey of Object.keys(tmpLegacyRoot))
	{
		const tmpBucket = tmpLegacyRoot[tmpKey] && tmpLegacyRoot[tmpKey][pEntity];
		if (tmpBucket && typeof tmpBucket === 'object' && !Array.isArray(tmpBucket) && Object.prototype.hasOwnProperty.call(tmpBucket, pGUID))
		{
			delete tmpBucket[pGUID];
			tmpDropped++;
		}
	}
	if (tmpDropped > 0)
	{
		scrubEmptyContainers(pDestination);
		if (pPict && pPict.log && typeof pPict.log.info === 'function')
		{
			pPict.log.info(`ScopedEntityData: moved ${pEntity} ${pGUID} off the deprecated ${LEGACY_DEFERRED_TRIGGER} trigger and onto ${pContext}.`);
		}
	}
	return tmpDropped;
}

/**
 * Project a TestInstance into a save-time comprehension target with its TestResult held back.
 *
 * A test result is a reviewed outcome: it must not reach the TestInstance row when the document is
 * merely saved, only when the workflow reaches the trigger it was staged for. Everything else on the
 * record still saves normally, so the row (and its joins) are created on save as before.
 *
 * The result itself is staged by `stageDeferredValue` at the moment the user sets it. A sweep can only
 * write what the form holds, which cannot tell a result the user cleared from one that was never
 * entered, and would re-assert a standing leaf on every save the document makes.
 *
 * Shared by both Test inputs (the Select2 `MaterialsTestSelector` and the PSP
 * `MaterialsTestPicker`) so the two families cannot disagree on when a result reaches the row.
 *
 * @param {Record<string, any>} pTestInstance - The TestInstance record.
 * @param {Record<string, any>} pTargetEntityData - The save-time `<Entity>.<GUID>` target.
 * @return {boolean} - False when the record could not be projected (the caller warns).
 */
function projectTestInstanceDeferringResult(pTestInstance, pTargetEntityData)
{
	const tmpGUID = pTestInstance && pTestInstance.GUIDTestInstance;
	if (!tmpGUID || !pTargetEntityData || typeof pTargetEntityData !== 'object' || Array.isArray(pTargetEntityData))
	{
		return false;
	}
	if (!pTargetEntityData.TestInstance || typeof pTargetEntityData.TestInstance !== 'object' || Array.isArray(pTargetEntityData.TestInstance))
	{
		pTargetEntityData.TestInstance = { };
	}
	pTargetEntityData.TestInstance[tmpGUID] = splitDeferredTestResult(pTestInstance).Record;
	return true;
}

/**
 * Whether a row's `Deleted` column marks it soft-deleted.
 *
 * @param {any} pValue - The `Deleted` value as a read returned it.
 * @return {boolean} - True when set.
 */
function isSoftDeletedFlag(pValue)
{
	return pValue === 1 || pValue === true || pValue === '1' || pValue === 'true';
}

/**
 * Which held joins name a row that exists and is soft-deleted, and the selection left without them.
 *
 * Only positive evidence drops a join: its GUID read back with `includeDeleted`, and every row that came
 * back deleted. A live row, a missing row or a failed read keeps the join. A selected value is removed
 * only when no kept join still carries it.
 *
 * The joins are read once, when the call is made, and never modified. They can change while the reads
 * are in flight, so a caller that writes the outcome back applies `DeletedValues` to the joins and value
 * it holds at that point (`applySoftDeletedDrop`) instead of writing `Joins` and `Value`.
 *
 * @param {Object} pPict - The pict instance.
 * @param {string} pEntity - The join entity, e.g. `SampleLineItemJoin`.
 * @param {string} pValueField - The column the selection lists, e.g. `IDLineItem`.
 * @param {Array<Record<string, any>>} pJoins - The held joins.
 * @param {any} pValue - The current selection value (comma-separated ids).
 * @param {(pResult: { Dropped: Array<string>, DeletedValues: Record<string, string>, Checked: Array<string>, Joins: Array<Record<string, any>>, Value: string }) => void} fCallback - Called once.
 *   `Dropped` lists the deleted GUIDs, `DeletedValues` maps each to the `pValueField` its row held,
 *   `Checked` lists the GUIDs read, and `Joins` / `Value` are the call-time joins and value with the drop applied.
 */
function resolveSoftDeletedJoins(pPict, pEntity, pValueField, pJoins, pValue, fCallback)
{
	const tmpGUIDField = `GUID${pEntity}`;
	const tmpJoins = Array.isArray(pJoins) ? pJoins.slice() : [ ];
	const tmpValue = (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue);
	const tmpCandidates = tmpJoins.filter((pJoin) => pJoin && typeof pJoin[tmpGUIDField] === 'string' && pJoin[tmpGUIDField].length > 0);
	const tmpChecked = tmpCandidates.map((pJoin) => pJoin[tmpGUIDField]);
	const tmpRestClient = pPict && pPict.HeadlightRestClient;
	const fUnchanged = (pChecked) => fCallback({ Dropped: [ ], DeletedValues: { }, Checked: pChecked, Joins: tmpJoins, Value: tmpValue });
	if (tmpCandidates.length < 1 || !tmpRestClient || typeof tmpRestClient.getJSON !== 'function')
	{
		return fUnchanged([ ]);
	}
	/** @type {Record<string, string>} */
	const tmpDeletedValues = { };
	let tmpRemaining = tmpCandidates.length;
	const fSettle = () =>
	{
		--tmpRemaining;
		if (tmpRemaining > 0)
		{
			return;
		}
		const tmpDropped = Object.keys(tmpDeletedValues);
		if (tmpDropped.length < 1)
		{
			return fUnchanged(tmpChecked);
		}
		const tmpApplied = applySoftDeletedDrop(pEntity, pValueField, tmpJoins, tmpValue, { DeletedValues: tmpDeletedValues, Checked: tmpChecked });
		return fCallback({ Dropped: tmpDropped, DeletedValues: tmpDeletedValues, Checked: tmpChecked, Joins: tmpApplied.Joins, Value: tmpApplied.Value });
	};
	for (const tmpJoin of tmpCandidates)
	{
		const tmpGUID = tmpJoin[tmpGUIDField];
		try
		{
			tmpRestClient.getJSON(`${pEntity}s/FilteredTo/FBV~${tmpGUIDField}~EQ~${encodeURIComponent(tmpGUID)}/0/5?includeDeleted=true`, (pError, pRows) =>
			{
				if (!pError && Array.isArray(pRows) && pRows.length > 0 && pRows.every((pRow) => pRow && isSoftDeletedFlag(pRow.Deleted)))
				{
					const tmpRowValue = pRows.map((pRow) => pRow[pValueField]).find((pRowValue) => pRowValue !== null && typeof pRowValue !== 'undefined' && pRowValue !== '');
					tmpDeletedValues[tmpGUID] = String(tmpRowValue ?? tmpJoin[pValueField] ?? '');
				}
				fSettle();
			});
		}
		catch (pError)
		{
			fSettle();
		}
	}
}

/**
 * A soft-delete drop (`resolveSoftDeletedJoins`) applied to the joins and selection an input holds now.
 *
 * A join goes when its GUID was read back deleted, or when it has no row id, was not among the joins read,
 * and lists a value a deleted row held: the same link minted again under another GUID while the reads were
 * in flight, which no user action asked for. A join with a row id, or one read back live, stays. A value
 * goes when a deleted row held it and no kept join lists it. Once applied, applying it again changes nothing.
 *
 * @param {string} pEntity - The join entity, e.g. `SampleLineItemJoin`.
 * @param {string} pValueField - The column the selection lists, e.g. `IDLineItem`.
 * @param {any} pJoins - The joins held now.
 * @param {any} pValue - The selection value held now (comma-separated ids).
 * @param {{ DeletedValues: Record<string, string>, Checked?: Array<string> }} pResolved - From
 *   `resolveSoftDeletedJoins`: per deleted GUID the `pValueField` its row held, and the GUIDs that were read.
 * @return {{ Changed: boolean, ValueChanged: boolean, Removed: Array<string>, Joins: Array<Record<string, any>>, Value: string }}
 *   `Removed` lists the GUIDs of the joins taken out. When nothing changes, `Joins` is `pJoins` itself (or
 *   `[ ]`) and `Value` is `pValue` as a string.
 */
function applySoftDeletedDrop(pEntity, pValueField, pJoins, pValue, pResolved)
{
	const tmpGUIDField = `GUID${pEntity}`;
	const tmpIDField = `ID${pEntity}`;
	const tmpDeletedValueMap = (pResolved && pResolved.DeletedValues) || { };
	const tmpDeletedGUIDs = new Set(Object.keys(tmpDeletedValueMap));
	const tmpDeletedValues = new Set(Object.values(tmpDeletedValueMap).map(String).filter((pEntry) => pEntry.length > 0));
	const tmpChecked = new Set((pResolved && Array.isArray(pResolved.Checked)) ? pResolved.Checked : [ ]);
	const tmpJoins = Array.isArray(pJoins) ? pJoins : [ ];
	const tmpValue = Array.isArray(pValue) ? pValue.join(',') : String(pValue ?? '');
	const isReminted = (pJoin) => !tmpChecked.has(pJoin[tmpGUIDField]) && !(Number(pJoin[tmpIDField]) > 0) && tmpDeletedValues.has(String(pJoin[pValueField]));
	const isDropped = (pJoin) => !!(pJoin && typeof pJoin === 'object') && (tmpDeletedGUIDs.has(pJoin[tmpGUIDField]) || isReminted(pJoin));
	const tmpKept = tmpJoins.filter((pJoin) => !isDropped(pJoin));
	const tmpRemoved = tmpJoins.filter(isDropped).map((pJoin) => pJoin[tmpGUIDField]);
	const tmpKeptValues = new Set(tmpKept.map((pJoin) => String(pJoin && pJoin[pValueField])));
	const tmpParts = tmpValue.split(',').map((pPart) => pPart.trim()).filter((pPart) => pPart.length > 0);
	const tmpNextParts = tmpParts.filter((pPart) => !tmpDeletedValues.has(pPart) || tmpKeptValues.has(pPart));
	const tmpValueChanged = tmpNextParts.length !== tmpParts.length;
	if (tmpRemoved.length < 1 && !tmpValueChanged)
	{
		return { Changed: false, ValueChanged: false, Removed: [ ], Joins: tmpJoins, Value: tmpValue };
	}
	return { Changed: true, ValueChanged: tmpValueChanged, Removed: tmpRemoved, Joins: tmpKept, Value: tmpValueChanged ? tmpNextParts.join(',') : tmpValue };
}

/**
 * The held records an input may keep once its selection has narrowed: those whose `pValueField` is
 * still listed in `pValue`. The records back the value (an autofill can re-derive the value from them),
 * so a record left behind for a value that was dropped puts that value back.
 *
 * @param {any} pRecords - The held records: an array for a Multiple input, else a single record.
 * @param {string} pValueField - The field the selection lists, e.g. `IDLineItem`.
 * @param {any} pValue - The selection value (comma-separated ids).
 * @return {any} - The kept records, in the same shape; a dropped single record becomes `{ }`. When nothing
 *   is removed the very same value comes back, so a caller can skip the write.
 */
function pruneRecordsToValue(pRecords, pValueField, pValue)
{
	const tmpKept = new Set(String(pValue ?? '').split(',').map((pPart) => pPart.trim()).filter((pPart) => pPart.length > 0));
	const isKept = (pRecord) => !!(pRecord && typeof pRecord === 'object' && tmpKept.has(String(pRecord[pValueField])));
	if (Array.isArray(pRecords))
	{
		const tmpFiltered = pRecords.filter(isKept);
		return (tmpFiltered.length === pRecords.length) ? pRecords : tmpFiltered;
	}
	if (pRecords && typeof pRecords === 'object')
	{
		return isKept(pRecords) ? pRecords : { };
	}
	return pRecords;
}

/**
 * Whether a record names a sample, by server id or by the GUID of one the same save creates. Answers
 * for a selected sample and for a join that hangs from one alike.
 *
 * @param {any} pRecord - The sample, or a join carrying `IDSample` / `GUIDSample`.
 * @return {boolean} - True when a sample is named.
 */
function referencesSample(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	if (Number(pRecord.IDSample) > 0)
	{
		return true;
	}
	return (typeof pRecord.GUIDSample === 'string' && pRecord.GUIDSample.length > 0);
}

/**
 * @param {any} pValue - The value to test.
 * @return {boolean} - True for a string with something other than whitespace in it.
 */
function isNonEmptyString(pValue)
{
	return (typeof pValue === 'string' && pValue.trim().length > 0);
}

/**
 * Why a projected leaf must not ship, or '' when it may.
 *
 * The applier stamps the key onto the record as its `GUID<Entity>`, so a leaf keyed by no usable GUID
 * is inserted as a row nothing can address again. A `DocumentPolyJoin` with no `RemoteType`, or with
 * nothing naming the record it joins, is inserted as a row with no parent. A tombstone carries only its
 * GUID and the delete, so the parent rule does not apply to one.
 *
 * @param {string} pEntity - The entity bucket the leaf sits in.
 * @param {string} pGUID - The key the leaf sits under.
 * @param {Record<string, any>} pRecord - The leaf.
 * @return {string} - The reason, or '' when the leaf may be emitted.
 */
function getUnemittableReason(pEntity, pGUID, pRecord)
{
	if (!isNonEmptyString(pGUID) || pGUID === 'undefined' || pGUID === 'null')
	{
		return `it is keyed by '${pGUID}'`;
	}
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return '';
	}
	if (pEntity !== 'DocumentPolyJoin' || isSoftDeletedFlag(pRecord.Deleted))
	{
		return '';
	}
	const tmpRemoteType = pRecord.RemoteType;
	if (!isNonEmptyString(tmpRemoteType))
	{
		return 'it has no RemoteType';
	}
	if (Number(pRecord.IDRemote) > 0)
	{
		return '';
	}
	if (pRecord[`_Dest_GUID${tmpRemoteType}`] && isNonEmptyString(pRecord[`GUID${tmpRemoteType}`]))
	{
		return '';
	}
	if (pRecord[`_Dest__GUID${tmpRemoteType}`] && isNonEmptyString(pRecord[`_GUID${tmpRemoteType}`]))
	{
		return '';
	}
	return `it names no ${tmpRemoteType} to join`;
}

module.exports =
{
	DEFAULT_CONTEXT,
	DEFAULT_DEFERRED_CONTEXT,
	TRIGGER_CONTEXT_DEPTH,
	DEFERRED_TRIGGERS,
	LEGACY_DEFERRED_TRIGGER,
	DOCUMENT_ENTITY_DATA_ADDRESS,
	DOCUMENT_RECORD_ADDRESS,
	ENTITY_DATA_BASELINE_ADDRESS,
	validateDeferredContext,
	stageDeferredValue,
	forEachContextRoot,
	scrubEmptyContainers,
	TOMBSTONE_OUTCOME,
	DOCUMENT_OWNED_ENTITIES,
	readFlagValue,
	isEnabled,
	ACTIVE_MARKER,
	markActive,
	isMarkedActive,
	noteProjectionRoot,
	takeNotedProjectionRoots,
	resolveContext,
	resolveDeferredContext,
	isTransientFormField,
	sanitizeRecord,
	isUnresolvedIdentityField,
	resolveDestination,
	resolveContextRoot,
	resolveEntityBucket,
	sanitizeContextRoot,
	BASELINE_SWEEP_MARKER,
	beginBaselineSweep,
	getBaselineSweepTarget,
	endBaselineSweep,
	writeRecord,
	writeTombstone,
	writeTombstoneIfDeletable,
	tombstoneRemovedRecords,
	dropRecordLeaves,
	isPersistedGUID,
	resolveRecordEntity,
	collectTestInstanceUnit,
	collectRowSelectorRemovals,
	adoptTestInstance,
	resolveSoftDeletedJoins,
	applySoftDeletedDrop,
	pruneRecordsToValue,
	beginProgrammaticLoad,
	endProgrammaticLoad,
	isProgrammaticLoad,
	splitDeferredTestResult,
	projectTestInstanceDeferringResult,
	referencesSample,
	getUnemittableReason,
};

},{}],163:[function(require,module,exports){
/**
 * The record a document was created with, for a field that mints its own entity when it opens.
 *
 * A host that creates a document already populated (ex. a sample-plan row opening Sample Creation for
 * one line item, material and sample type) writes the new entity's starting fields at the field's
 * `__Record` address. Minting the new record starts from those fields instead of replacing them, so
 * the open-time cascade shows them and the save writes them. Only a record with no identity counts:
 * one carrying a GUID or a database ID is a selection, and minting never adopts a selection.
 *
 * Used by both families' `_handleDefaultRecord` (MaterialsEntitySelector and MaterialsCascadePicker).
 *
 * @module _SeedRecord
 */

/**
 * @param {any} pRecord - what the document holds at the field's `__Record` address
 * @param {string} pEntity - the field's entity (ex. 'Sample')
 * @param {string} [pIdentityField] - the field's record identity, when it isn't GUID<Entity> or ID<Entity>
 * @return {Record<string, any>|null} a copy of the seed to start the new record from, or null
 */
function getUnsavedSeedRecord(pRecord, pEntity, pIdentityField)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord) || Object.keys(pRecord).length < 1)
	{
		return null;
	}
	if (pRecord[`GUID${pEntity}`] || (Number(pRecord[`ID${pEntity}`]) > 0))
	{
		return null;
	}
	if (pIdentityField && pRecord[pIdentityField])
	{
		return null;
	}
	return JSON.parse(JSON.stringify(pRecord));
}

module.exports = { getUnsavedSeedRecord };

},{}],164:[function(require,module,exports){
/**
 * One read per URL for idempotent entity GETs issued by many inputs at once.
 *
 * A form load marshals every input several times, and every marshal re-resolves the records its inputs
 * display, so the same `<Entity>s/FilteredTo/...` URL is requested by dozens of inputs within a few
 * milliseconds. Two layers keep that to one request:
 *
 *   - In flight: a caller asking for a URL that is already being fetched waits on that request.
 *     Always on - callers issuing the same GET at the same moment would receive the same rows anyway.
 *   - Result reuse (opt-in, `ReuseResult`): a non-empty response is kept for RESULT_TTL_MS and handed
 *     to later callers. Empty responses and errors are never kept, so a record created mid-session is
 *     found on the next read.
 *
 * Every caller receives its own copy of the rows: callers write fetched records straight into form data.
 * `invalidate` drops both layers (a request already in flight still answers its own waiters); the save
 * lifecycle calls it so nothing read before a save is served after it.
 *
 * State is per pict instance.
 *
 * @module _SharedEntityRead
 */

/** Matches pict's EntityProvider record cache (Pict-Meadow-EntityProvider.js initializeCache). */
const RESULT_TTL_MS = 30000;

/**
 * @typedef {Object} SharedReadEntry
 * @property {Array<(pError: any, pBody?: any) => void>} Waiters
 * @property {number} Generation
 */

/**
 * @typedef {Object} SharedReadState
 * @property {Map<string, SharedReadEntry>} InFlight
 * @property {Map<string, { Body: any, StoredAt: number }>} Results
 * @property {number} Generation
 */

/** @type {WeakMap<Object, SharedReadState>} */
const _States = new WeakMap();

/**
 * @param {Object} pPict
 * @return {SharedReadState}
 */
function getState(pPict)
{
	let tmpState = _States.get(pPict);
	if (!tmpState)
	{
		tmpState = { InFlight: new Map(), Results: new Map(), Generation: 0 };
		_States.set(pPict, tmpState);
	}
	return tmpState;
}

/**
 * @param {any} pBody
 * @return {any}
 */
function copyBody(pBody)
{
	return (pBody && typeof pBody === 'object') ? JSON.parse(JSON.stringify(pBody)) : pBody;
}

/**
 * GET a URL through `pict.HeadlightRestClient.getJSON`, sharing the request with identical concurrent callers.
 *
 * @param {Object} pPict - The pict instance (owns HeadlightRestClient).
 * @param {string} pURL - The request URL, exactly as it would be passed to getJSON.
 * @param {{ ReuseResult?: boolean }} pOptions - ReuseResult: accept a kept response younger than RESULT_TTL_MS.
 * @param {(pError: any, pBody?: any) => void} fCallback - getJSON-shaped callback; the body is the caller's own copy.
 */
function readJSON(pPict, pURL, pOptions, fCallback)
{
	const tmpState = getState(pPict);
	if (pOptions && pOptions.ReuseResult)
	{
		const tmpKept = tmpState.Results.get(pURL);
		if (tmpKept && (Date.now() - tmpKept.StoredAt) < RESULT_TTL_MS)
		{
			return fCallback(null, copyBody(tmpKept.Body));
		}
	}
	const tmpPending = tmpState.InFlight.get(pURL);
	if (tmpPending)
	{
		tmpPending.Waiters.push(fCallback);
		return;
	}
	/** @type {SharedReadEntry} */
	const tmpEntry = { Waiters: [ fCallback ], Generation: tmpState.Generation };
	tmpState.InFlight.set(pURL, tmpEntry);
	pPict.HeadlightRestClient.getJSON(pURL, (pError, pBody) =>
	{
		if (tmpState.InFlight.get(pURL) === tmpEntry)
		{
			tmpState.InFlight.delete(pURL);
		}
		const tmpHasRows = Array.isArray(pBody) ? pBody.length > 0 : (pBody && typeof pBody === 'object');
		if (!pError && tmpHasRows && tmpEntry.Generation === tmpState.Generation)
		{
			tmpState.Results.set(pURL, { Body: copyBody(pBody), StoredAt: Date.now() });
		}
		for (const fWaiter of tmpEntry.Waiters)
		{
			fWaiter(pError, pError ? pBody : copyBody(pBody));
		}
	});
}

/**
 * Drop kept responses and detach in-flight requests, so every later read goes to the server.
 *
 * @param {Object} pPict - The pict instance.
 */
function invalidate(pPict)
{
	const tmpState = getState(pPict);
	tmpState.Results.clear();
	tmpState.InFlight.clear();
	tmpState.Generation++;
}

/** Meadow's schema default for an unset GUID column; no row is ever looked up by it. */
const PLACEHOLDER_GUID = '0x0000000000000000';

/**
 * Whether an identity value names no record: empty, a database id of 0 (ids start at 1), or the
 * placeholder GUID. A comma list is empty only when every member is.
 *
 * @param {string} pIdentityField - The column the value is matched on (e.g. IDUser, GUIDSample, Hash).
 * @param {any} pValue - The value, or a comma-separated list of values.
 * @return {boolean}
 */
function isEmptyIdentityValue(pIdentityField, pValue)
{
	if (pValue === null || pValue === undefined)
	{
		return true;
	}
	const tmpIsDatabaseID = /^ID[A-Z]/.test(String(pIdentityField || ''));
	const tmpIsGUID = /^GUID[A-Z]/.test(String(pIdentityField || ''));
	return String(pValue).split(',').every((pPart) =>
	{
		const tmpPart = pPart.trim();
		return tmpPart === '' || (tmpIsDatabaseID && Number(tmpPart) === 0) || (tmpIsGUID && tmpPart === PLACEHOLDER_GUID);
	});
}

/**
 * Whether a read by ID returned the record asked for. pict's EntityProvider.getEntity hands the server's error
 * reply (`{ Error, ErrorCode }`) back in the record's place, so a reply without its own `ID<Entity>` is a failed
 * read.
 *
 * @param {string} pEntity - The entity type that was read.
 * @param {any} pRecord - The reply.
 * @return {boolean}
 */
function isEntityRecord(pEntity, pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord))
	{
		return false;
	}
	const tmpIdentityField = `ID${pEntity}`;
	return !isEmptyIdentityValue(tmpIdentityField, pRecord[tmpIdentityField]);
}

module.exports = { readJSON, invalidate, isEmptyIdentityValue, isEntityRecord, RESULT_TTL_MS };

},{}],165:[function(require,module,exports){
/**
 * R2 port-forward map for the specialized per-entity selectors (LabSelector, PlantSelector, …).
 *
 * Each such InputType hardcodes its Entity (+ search/display config) in its own
 * PictProvider-InputType-<X>Selector provider (via Select2Util.getOptionsAjax), NOT the descriptor.
 * This lifts that config so the broker (Picker) and Read/Print (PickerDisplay) render it as a generic
 * entity Picker with no manifest edit. Compound (PhysicalAsset) + non-standard (ObservationType) excluded.
 * `MaterialsFamily: true` opts an entry into legacy MES behavior: defaults-on-empty (Picker._shouldApplyConfiguredDefault)
 * and a stored 0 painting as unset whatever the DataType (_PickerEmptyValues).
 */
module.exports =
{
	// Plain entity + Name display, single-field search.
	LabSelector: { Entity: 'Lab', TextField: 'Name', Placeholder: 'Select a Lab...' },
	PlantSelector: { Entity: 'ProductionPlant', TextField: 'Name', Placeholder: 'Select a Plant...' },
	ProducerSelector: { Entity: 'Organization', TextField: 'Name', Placeholder: 'Select a Producer...' },
	ProductSelector: { Entity: 'Product', TextField: 'Name', Placeholder: 'Select a Product...' },
	ProjectSelector: { Entity: 'Project', TextField: 'Name', Placeholder: 'Select a Project...' },
	// + EntityTag (the provider's user-facing ID) badge + multi-field search.
	// MaterialSelector is a generic Material picker: top-level materials only until Show All (legacy toggleMaterialFilter).
	// StaticFilters / ShowAllToggle here are descriptor defaults; a descriptor's own value wins.
	// Tag/search = MaterialCode, a DELIBERATE divergence from legacy (which used ItemCode): Doug's call, so a
	// migrated field matches the MaterialsEntitySelector Material pickers on the Test / Sample-creation forms.
	MaterialSelector: { Entity: 'Material', TextField: 'Name', SearchFields: [ 'Name', 'MaterialCode' ], EntityTag: 'MaterialCode', Placeholder: 'Select a Material...',
		StaticFilters: [ { Field: 'IDMaterialParent', Value: '0', BackOff: true } ], ShowAllToggle: true },
	SampleSelector: { Entity: 'Sample', TextField: 'Name', SearchFields: [ 'Name', 'QRCode' ], EntityTag: 'QRCode', Placeholder: 'Select a Sample by name or code...' },
	// DisableProjectFiltering: legacy LineItemSelector never project-scoped (only EntitySelector did).
	LineItemSelector: { Entity: 'LineItem', TextField: 'Name', SearchFields: [ 'ItemCode', 'Name' ], EntityTag: 'ItemCode', Placeholder: 'Select a Line Item by name or code...', DisableProjectFiltering: true },
	// BridgeSelector: never clearable, and scoped to the customer's configured state(s), as its legacy provider was.
	// Labelled by Name with a StructureNumber tag, as legacy was: bridges are named ("3648 | WAITOTARA BRIDGE"),
	// and a blank Name is rare — 0 of 400 across four ID-ordered windows of the 1,039,581-row table. (An
	// earlier pass here mislabelled the field BY StructureNumber on the strength of a sample sorted
	// `FSF~Name~ASC~0`, which puts every blank-named row first; that measured the sort, not the data.)
	BridgeSelector: { Entity: 'Bridge', TextField: 'Name', SearchFields: [ 'StructureNumber', 'Name' ], EntityTag: 'StructureNumber', Placeholder: 'Select a Bridge by name or code...',
		AllowClear: false, CustomerStateFilter: true },
	// MixSpecification tag = Code (the legacy getter read a nonexistent ItemCode -> always N/A). Label =
	// Description, as legacy's selected value and Read/PDF showed ("[Code] Description"); Name is often blank.
	MixSpecificationSelector: { Entity: 'MixSpecification', TextField: 'Description', SearchFields: [ 'Code', 'Description' ], EntityTag: 'Code', Placeholder: 'Select a Mix Specification by code or description...' },
	// MES-family cascade ports (waves 5-9): config here; the cascade/creation/projection logic lives in the
	// matching PictProvider-InputType-Materials*Picker. RecordIdentity carries the non-numeric (GUID/Hash)
	// commit identity to PickerDisplay; Multiple mirrors the Edit providers' default so Read/Print CSV-splits
	// (a descriptor-explicit Multiple still wins).
	MaterialsPlantSelector: { Entity: 'ProductionPlant', TextField: 'Name', Placeholder: 'Select a Plant...', MaterialsFamily: true },
	SampleTypeSelector: { Entity: 'SampleType', TextField: 'Name', Placeholder: 'Select a Sample Type...', MaterialsFamily: true },
	MaterialsSampleSelector: { Entity: 'Sample', TextField: 'Name', SearchFields: [ 'QRCode', 'Name' ], EntityTag: 'QRCode', Placeholder: 'Select a Sample...', MaterialsFamily: true, RecordIdentity: 'GUIDSample' },
	MaterialsTestSelector: { Entity: 'Test', TextField: 'Name', SearchFields: [ 'Hash', 'Name' ], EntityTag: 'Hash', Placeholder: 'Select a Test...', MaterialsFamily: true, RecordIdentity: 'Hash' },
	MaterialsLabSelector: { Entity: 'Lab', TextField: 'Name', Placeholder: 'Select a Lab...', MaterialsFamily: true, Multiple: true },
	// No EntityTag: Read/Print show the name only, as MaterialsLineItemDisplay did; Edit tags on ItemCode through MaterialsLineItemPicker's defaults.
	MaterialsLineItemSelector: { Entity: 'LineItem', TextField: 'Name', SearchFields: [ 'ItemCode', 'Name' ], Placeholder: 'Select a Line Item...', MaterialsFamily: true, Multiple: true },
	MaterialsTestLabSelector: { Entity: 'Lab', TextField: 'Name', Placeholder: 'Select a Lab...', MaterialsFamily: true },
	// No EntityTag: Read/Print show the test name only, as MaterialsTestDisplay did; Edit tags on Hash through MaterialsTestInjectorPicker's
	// default. Sort: Hash keeps the legacy list order (select2 sorted by the provider's SearchFields, Hash first).
	MaterialsTestInjector: { Entity: 'Test', TextField: 'Name', SearchFields: [ 'Hash', 'Name' ], Sort: 'Hash', Placeholder: 'Select a Test to add...', MaterialsFamily: true, RecordIdentity: 'Hash' },
	// The base selector: each descriptor names its own Entity and display config, so the entry carries only the family
	// flag, plus DisableProjectFiltering because the legacy base never project-scoped a LineItem.
	MaterialsEntitySelector: { MaterialsFamily: true, DisableProjectFiltering: true },
};

},{}],166:[function(require,module,exports){
/**
 * The port-forwarded static selects never read a descriptor `Entity`, in one place so the Edit and the
 * Read/Print stacks cannot disagree.
 *
 * `Option`, `Select2` and `Select2Multiple` render through the Picker broker (Edit) and `PickerDisplay`
 * (Read/Print), both of which treat a truthy `PictForm.Entity` as a remote entity search. The legacy select
 * providers ignored that key, so manifests carry stray values (`"Entity": "1"` beside a static
 * `SelectOptions`) that would otherwise empty the list and print raw codes. An explicit `Picker` keeps its
 * Entity: that is the entity opt-in.
 */

/** InputTypes whose descriptor `Entity` this module drops. */
const STATIC_SELECT_INPUT_TYPES = [ 'Option', 'Select2', 'Select2Multiple' ];

/**
 * Remove a stray `Entity` from a static-select descriptor. Leaves every other InputType untouched.
 *
 * @param {Record<string, any>} pPictForm - The form input descriptor's PictForm.
 * @return {boolean} - True when the descriptor is a static select.
 */
function dropStaticSelectEntity(pPictForm)
{
	if (!pPictForm || STATIC_SELECT_INPUT_TYPES.indexOf(pPictForm.InputType) < 0)
	{
		return false;
	}
	if ('Entity' in pPictForm)
	{
		delete pPictForm.Entity;
	}
	return true;
}

module.exports = { STATIC_SELECT_INPUT_TYPES, dropStaticSelectEntity };

},{}],167:[function(require,module,exports){
/**
 * The PDF rule shared by both tab InputTypes.
 *
 * Neither Print template emits a tab strip, but the group hosting the selector still renders its
 * wrapper, so every tabbed section reserved an empty band (12-30px depending on width) above its
 * content. The Print templates mark their hidden input; this collapses the group around it -- and
 * the whole section when the tab host is all that section holds.
 *
 * `Pict-Input-TabGroupSelector` and `Pict-Input-TabSectionSelector` extend different pict-section-form
 * providers and share no base class, so a module is what keeps the two in step -- same reasoning as
 * _FilterToggleUI.js.
 *
 * The class name says "group" for the same reason it always did: it shipped that way, and the marker
 * is matched only by the rule below. It covers BOTH tab InputTypes.
 */

/** @type {String} */
const _PrintHostMarkerClass = 'pict-tab-group-print-host';

/**
 * `:only-child` twice -- on the columns row and on the input -- so this collapses a group ONLY when
 * that hidden input is the entire content. A manifest that puts other descriptors alongside the tab
 * selector keeps them. A renderer without `:has()` drops the rule and gets the old spacing back, so
 * this cannot regress a PDF.
 *
 * @type {String}
 */
const _PrintHostGroupCSS = `.pict-form-group:has(> .section-content > .columns:only-child > .${_PrintHostMarkerClass}:only-child) { display: none; }`;

/**
 * Some manifests host the selector in a section of its own -- ProjectTransition's `Tabs` section is
 * nothing but `UI.ActiveTab`. Collapsing the group there leaves the section's own `<h2>` behind, so
 * the PDF gets a heading ("Sections") with nothing under it, which is worse than the blank band.
 *
 * `:only-of-type` on the group is what keeps this narrow: it matches a section whose ONLY group is
 * the tab host. Measured both ways -- ProjectTransition's Tabs section collapses (48px -> 0), and
 * Sample Creation 391's Testing section matches ZERO because it has three groups.
 *
 * @type {String}
 */
const _PrintHostSectionCSS = `.pict-form-section:has(> .pict-form-group:only-of-type > .section-content > .columns:only-child > .${_PrintHostMarkerClass}:only-child) { display: none; }`;

/** @type {String} */
const _PrintHostCSS = `${_PrintHostGroupCSS} ${_PrintHostSectionCSS}`;

/** @type {String} */
const _PrintHostCSSHash = 'Headlight-Input-TabSelector-PrintHost';

/**
 * Register the fragment WITHOUT injecting it.
 *
 * CSSMap.addCSS raises the dirty flag while injectCSS lowers it whether or not a style element
 * exists yet, so injecting at construction can silently drop the fragment. Register early, inject
 * at init. Re-registering under the same hash is harmless, so both providers may call this.
 *
 * @param {Object} pPict - The Pict instance.
 *
 * @return {void}
 */
function registerPrintHostCSS(pPict)
{
	pPict.CSSMap.addCSS(_PrintHostCSSHash, _PrintHostCSS, 1002, 'Pict-Input-TabSelector');
}

/**
 * Inject whatever is registered. Call this ABOVE a provider's non-interactive early return -- the
 * PDF is the one path that needs this rule.
 *
 * @param {Object} pPict - The Pict instance.
 *
 * @return {void}
 */
function injectPrintHostCSS(pPict)
{
	pPict.CSSMap.injectCSS();
}

module.exports = {
	PrintHostMarkerClass: _PrintHostMarkerClass,
	PrintHostCSS: _PrintHostCSS,
	PrintHostGroupCSS: _PrintHostGroupCSS,
	PrintHostSectionCSS: _PrintHostSectionCSS,
	PrintHostCSSHash: _PrintHostCSSHash,
	registerPrintHostCSS,
	injectPrintHostCSS,
};

},{}],168:[function(require,module,exports){
/**
 * The test-result code list, in one place so the Edit and the Read/Print stacks cannot disagree.
 *
 * Test results are NOT a customer-managed vocabulary — there is no TestResult table — so they are a
 * static option array taking the Picker broker's generic (non-entity) select path, rather than an entry
 * in `_VocabularySelectorMap`.
 *
 * Both stacks must stamp it: `SampleTestAcceptance` renders the field in Edit, but `PickerDisplay`
 * renders it in Read and Print, and that provider never runs the acceptance input's initialize hooks.
 * Without the options on the descriptor, the display has nothing to map the stored code through and
 * prints the raw `PEND` instead of `Pending`.
 */

/** @type {Array<{id: string, text: string}>} */
const DEFAULT_TEST_RESULT_OPTIONS =
[
	{ 'id': 'N/A', 'text': 'N/A' },
	{ 'id': 'PROG', 'text': 'In Progress' },
	{ 'id': 'PEND', 'text': 'Pending' },
	{ 'id': 'FAIL', 'text': 'Failed' },
	{ 'id': 'FAIC', 'text': 'Failed with Comments' },
	{ 'id': 'PASS', 'text': 'Passed' },
	{ 'id': 'PASC', 'text': 'Passed with Comments' },
	{ 'id': 'SQTY', 'text': 'Small Quantity' },
	{ 'id': 'VOID', 'text': 'Voided' },
];

/** InputTypes whose options this module owns. */
const TEST_RESULT_INPUT_TYPES = [ 'SampleTestAcceptance' ];

/**
 * Stamp the default result codes onto an acceptance descriptor. Never overwrites a schema-supplied
 * `SelectOptions`, and leaves every other InputType untouched.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {boolean} [pForce] - Stamp regardless of InputType (the Edit provider knows it owns the field).
 * @return {boolean} - True when this descriptor carries the test-result option set.
 */
function applyTestResultOptions(pInput, pForce)
{
	if (!pInput)
	{
		return false;
	}
	if (!pInput.PictForm)
	{
		pInput.PictForm = {};
	}
	if (!pForce && TEST_RESULT_INPUT_TYPES.indexOf(pInput.PictForm.InputType) < 0)
	{
		return false;
	}
	if (!pInput.PictForm.SelectOptions || !Array.isArray(pInput.PictForm.SelectOptions))
	{
		pInput.PictForm.SelectOptions = DEFAULT_TEST_RESULT_OPTIONS;
	}
	return true;
}

/**
 * The display text for a stored test-result code.
 *
 * @param {string} pCode - The stored code, such as `PASC`.
 * @return {string} - Its text, or the value itself when it isn't a known code.
 */
function getTestResultLabel(pCode)
{
	const tmpOption = DEFAULT_TEST_RESULT_OPTIONS.find((pOption) => pOption.id === pCode);
	return tmpOption ? tmpOption.text : pCode;
}

module.exports = { DEFAULT_TEST_RESULT_OPTIONS, TEST_RESULT_INPUT_TYPES, applyTestResultOptions, getTestResultLabel };

},{}],169:[function(require,module,exports){
/**
 * Read-only "Test Results Summary" for forms that carry `SampleTestAcceptance` inputs: one row per test with
 * its name, result and remarks, so a reviewer can scan the outcome before taking an approval action.
 *
 * Everything is read from the form's own data (the paired test selector's `__Record`, the result code and the
 * remarks address), never fetched, so it works on an offline device.
 */

const libTestResultOptions = require('./_TestResultOptions.js');
const libUserMarkdown = require('./_UserMarkdown.js');

const TEST_SELECTOR_INPUT_TYPES = [ 'MaterialsHiddenTestSelector', 'MaterialsTestSelector', 'MaterialsTestPicker' ];

const REMARKS_PREVIEW_LENGTH = 160;

// pict-section-form gives each section's container this id (no per-render UUID), so it is a stable link target.
const SECTION_CONTAINER_ID_PREFIX = 'Pict-Form-Container-';

/**
 * @typedef {Object} TestResultsSummaryRow
 * @property {string} TestName - The test's display name.
 * @property {string} ResultCode - The stored result code, or '' when unset.
 * @property {string} ResultText - The result's display text, or '' when unset.
 * @property {string} Remarks - The remarks as plain text, or ''.
 * @property {string} SectionAnchorID - Element id of the test's form section, or '' when there is none to link to.
 */

/**
 * @typedef {Object} TestResultsSummaryContext
 * @property {Record<string, any>} Descriptors - The form's descriptors.
 * @property {Array<Record<string, any>>} [Sections] - The form's sections, used for a fallback test name.
 * @property {Record<string, any>} Data - The marshal destination (the form data).
 * @property {(pObject: any, pAddress: string) => any} getValueAtAddress - Address resolver (pict manifest).
 * @property {(pInput: Record<string, any>) => string|null} [getRemarksAddress] - The acceptance provider's remarks resolver.
 * @property {Document} [Document] - Used to flatten markdown remarks to text.
 */

/**
 * @param {any} pValue
 * @return {boolean}
 */
function isFilled(pValue)
{
	return (pValue !== null) && (typeof(pValue) !== 'undefined') && (String(pValue).trim() !== '');
}

/**
 * @param {Record<string, any>} pInput - The acceptance descriptor.
 * @param {any} pCode - The stored code.
 * @return {string}
 */
function getResultText(pInput, pCode)
{
	if (!isFilled(pCode))
	{
		return '';
	}
	const tmpOptions = pInput?.PictForm?.SelectOptions;
	if (Array.isArray(tmpOptions))
	{
		const tmpOption = tmpOptions.find((pOption) => pOption && pOption.id === pCode);
		if (tmpOption && tmpOption.text)
		{
			return String(tmpOption.text);
		}
	}
	return String(libTestResultOptions.getTestResultLabel(pCode));
}

/**
 * Remarks are user-typed markdown; flatten them through the hardened renderer into an inert document so the
 * summary shows readable text with no markup and nothing executable.
 *
 * @param {any} pMarkdown
 * @param {Document} [pDocument]
 * @return {string}
 */
function getRemarksText(pMarkdown, pDocument)
{
	if (!isFilled(pMarkdown))
	{
		return '';
	}
	let tmpText = String(pMarkdown);
	const TmpDOMParser = pDocument?.defaultView?.DOMParser;
	if (TmpDOMParser)
	{
		const tmpHTML = libUserMarkdown.renderUserMarkdown(tmpText);
		tmpText = new TmpDOMParser().parseFromString(tmpHTML, 'text/html').body.textContent || '';
	}
	tmpText = tmpText.replace(/\s+/g, ' ').trim();
	if (tmpText.length > REMARKS_PREVIEW_LENGTH)
	{
		tmpText = `${tmpText.slice(0, REMARKS_PREVIEW_LENGTH - 1).trimEnd()}…`;
	}
	return tmpText;
}

/**
 * @param {TestResultsSummaryContext} pContext
 * @param {Record<string, any>} pInput - The acceptance descriptor.
 * @param {Array<Record<string, any>>} pDescriptors
 * @return {string}
 */
function getTestName(pContext, pInput, pDescriptors)
{
	const tmpTrackingGUID = pInput.PictForm.TestTrackingGUID;
	if (tmpTrackingGUID && tmpTrackingGUID !== true)
	{
		const tmpSelector = pDescriptors.find((pDescriptor) => pDescriptor?.PictForm?.TestTrackingGUID === tmpTrackingGUID &&
			TEST_SELECTOR_INPUT_TYPES.indexOf(pDescriptor.PictForm.InputType) >= 0);
		if (tmpSelector && tmpSelector.DataAddress)
		{
			const tmpName = pContext.getValueAtAddress(pContext.Data, `${tmpSelector.DataAddress}__Record.Name`);
			// A placeholder test record is named after its hash; the section heading reads better.
			if (isFilled(tmpName) && String(tmpName) !== String(tmpTrackingGUID))
			{
				return String(tmpName);
			}
		}
	}
	const tmpSection = (pContext.Sections || []).find((pSection) => pSection && pSection.Hash === pInput.PictForm.Section);
	if (tmpSection && isFilled(tmpSection.Name))
	{
		return String(tmpSection.Name);
	}
	if (tmpTrackingGUID && tmpTrackingGUID !== true)
	{
		return String(tmpTrackingGUID);
	}
	return String(pInput.Name || pInput.Hash || '');
}

/**
 * One row per non-tabular `SampleTestAcceptance` input, in manifest order.
 *
 * @param {TestResultsSummaryContext} pContext
 * @return {Array<TestResultsSummaryRow>}
 */
function collectTestResults(pContext)
{
	const tmpDescriptors = Object.values(pContext.Descriptors || {});
	const tmpRows = [];
	for (const tmpInput of tmpDescriptors)
	{
		const tmpPictForm = tmpInput?.PictForm;
		if (!tmpPictForm || libTestResultOptions.TEST_RESULT_INPUT_TYPES.indexOf(tmpPictForm.InputType) < 0)
		{
			continue;
		}
		if (tmpPictForm.InformaryContainerAddress || !tmpInput.DataAddress)
		{
			continue;
		}
		const tmpCode = pContext.getValueAtAddress(pContext.Data, tmpInput.DataAddress);
		const tmpRemarksAddress = pContext.getRemarksAddress ? pContext.getRemarksAddress(tmpInput) : null;
		const tmpRemarks = tmpRemarksAddress ? pContext.getValueAtAddress(pContext.Data, tmpRemarksAddress) : null;
		tmpRows.push(
			{
				TestName: getTestName(pContext, tmpInput, tmpDescriptors),
				ResultCode: isFilled(tmpCode) ? String(tmpCode) : '',
				ResultText: getResultText(tmpInput, tmpCode),
				Remarks: getRemarksText(tmpRemarks, pContext.Document),
				SectionAnchorID: tmpPictForm.Section ? `${SECTION_CONTAINER_ID_PREFIX}${tmpPictForm.Section}` : '',
			});
	}
	return tmpRows;
}

/**
 * The summary shows once any test has a result.
 *
 * @param {Array<TestResultsSummaryRow>} pRows
 * @return {boolean}
 */
function hasAnyResult(pRows)
{
	return pRows.some((pRow) => pRow.ResultCode !== '');
}

/**
 * @param {string} pCode
 * @return {string} - Bulma tag modifiers for the result.
 */
function getResultTagClass(pCode)
{
	switch (pCode)
	{
	case 'PASS':
	case 'PASC':
		return 'is-success is-soft';
	case 'FAIL':
	case 'FAIC':
		return 'is-danger is-soft';
	case 'PROG':
	case 'PEND':
		return 'is-warning is-soft';
	default:
		return '';
	}
}

/**
 * @param {Document} pDocument
 * @param {string} pTag
 * @param {string} [pClass]
 * @param {string} [pText]
 * @return {HTMLElement}
 */
function createElement(pDocument, pTag, pClass, pText)
{
	const tmpElement = pDocument.createElement(pTag);
	if (pClass)
	{
		tmpElement.className = pClass;
	}
	if (typeof(pText) === 'string')
	{
		tmpElement.textContent = pText;
	}
	return tmpElement;
}

/**
 * @param {Document} pDocument
 * @param {Array<TestResultsSummaryRow>} pRows
 * @return {HTMLElement}
 */
function buildSummaryElement(pDocument, pRows)
{
	const tmpFilledCount = pRows.filter((pRow) => pRow.ResultCode !== '').length;

	const tmpBox = createElement(pDocument, 'div', 'test-results-summary');
	const tmpHeading = createElement(pDocument, 'div', 'test-results-summary-heading');
	tmpHeading.append(createElement(pDocument, 'h2', 'title is-6 mb-0', 'Test Results Summary'));
	tmpHeading.append(createElement(pDocument, 'span', 'is-size-7 has-text-grey', `${tmpFilledCount} of ${pRows.length} ${pRows.length === 1 ? 'test has a result' : 'tests have results'}`));
	tmpBox.append(tmpHeading);

	const tmpScroller = createElement(pDocument, 'div', 'table-container');
	const tmpTable = createElement(pDocument, 'table', 'table is-fullwidth is-narrow');
	const tmpHeadRow = createElement(pDocument, 'tr');
	for (const tmpLabel of [ 'Test', 'Result', 'Remarks' ])
	{
		tmpHeadRow.append(createElement(pDocument, 'th', '', tmpLabel));
	}
	const tmpHead = createElement(pDocument, 'thead');
	tmpHead.append(tmpHeadRow);
	tmpTable.append(tmpHead);

	const tmpBody = createElement(pDocument, 'tbody');
	for (const tmpRow of pRows)
	{
		const tmpTR = createElement(pDocument, 'tr');
		const tmpNameCell = createElement(pDocument, 'td', 'test-results-summary-name');
		if (tmpRow.SectionAnchorID && pDocument.getElementById(tmpRow.SectionAnchorID))
		{
			const tmpLink = createElement(pDocument, 'a', '', tmpRow.TestName);
			// A bare fragment is what the PDF printer turns into an in-document jump (no URL, so no session token).
			// On screen the page's <base href> would send it to another URL, so the click scrolls instead.
			tmpLink.setAttribute('href', `#${tmpRow.SectionAnchorID}`);
			tmpLink.addEventListener('click', (pEvent) =>
			{
				const tmpTarget = pDocument.getElementById(tmpRow.SectionAnchorID);
				if (!tmpTarget || pEvent.button !== 0 || pEvent.metaKey || pEvent.ctrlKey || pEvent.shiftKey || pEvent.altKey)
				{
					return;
				}
				pEvent.preventDefault();
				tmpTarget.scrollIntoView({ block: 'start' });
			});
			tmpNameCell.append(tmpLink);
		}
		else
		{
			tmpNameCell.textContent = tmpRow.TestName;
		}
		tmpTR.append(tmpNameCell);
		const tmpResultCell = createElement(pDocument, 'td', 'test-results-summary-result');
		if (tmpRow.ResultCode)
		{
			tmpResultCell.append(createElement(pDocument, 'span', `tag ${getResultTagClass(tmpRow.ResultCode)}`.trim(), tmpRow.ResultText));
		}
		else
		{
			tmpResultCell.append(createElement(pDocument, 'span', 'has-text-grey', '—'));
		}
		tmpTR.append(tmpResultCell);
		tmpTR.append(createElement(pDocument, 'td', 'test-results-summary-remarks', tmpRow.Remarks));
		tmpBody.append(tmpTR);
	}
	tmpTable.append(tmpBody);
	tmpScroller.append(tmpTable);
	tmpBox.append(tmpScroller);
	return tmpBox;
}

/**
 * Ask the app's test results summary view, when it registered one, to redraw from this form view's data.
 *
 * @param {Record<string, any>} pPict
 * @param {Record<string, any>} pView - The form section view the change or marshal came from.
 */
function requestSummaryRefresh(pPict, pView)
{
	const tmpSummary = pPict && pPict.views && pPict.views.TestResultsSummary;
	if (tmpSummary && pView && typeof pView.getMarshalDestinationObject === 'function')
	{
		tmpSummary.requestRefresh(pView.getMarshalDestinationObject());
	}
}

module.exports = { collectTestResults, hasAnyResult, buildSummaryElement, getRemarksText, getResultTagClass, requestSummaryRefresh };

},{"./_TestResultOptions.js":168,"./_UserMarkdown.js":170}],170:[function(require,module,exports){
/**
 * Rendering for markdown a *user* typed -- a remark, a note, a comment -- as opposed to the markdown
 * we author ourselves in a manifest (an Instructions block) or ship in a file.
 *
 * Two differences from a plain `marked.parse()`:
 *
 * - raw HTML in the source is shown as literal text instead of being parsed as markup, so a remark
 *   cannot put a script tag or an event handler into the page of whoever reads it -- including the
 *   text after an inline `<kbd>` / `<code>` / `<pre>` / `<script>` tag, which marked passes through
 *   unescaped (see walkTokens below);
 * - links are limited to http(s) / mailto / tel / relative targets (not protocol-relative `//host`),
 *   and open in a new tab so a reader is not navigated away from a form they are part way through
 *   filling in;
 * - an image is drawn only from an absolute http(s) URL on someone else's host. An `<img>` fires a GET
 *   the moment the remark renders, with the reader's session cookie when it points at the page's own
 *   host or another Headlight host -- `![x](/1.0/Authentication/Impersonate/123)` would log a
 *   super-user out of their own session just by opening the ticket. Any other image is shown as a
 *   link labelled with its alt text (when the link rules allow it) or as its alt text.
 *
 * marked does none of this on its own: since v5 it has no sanitizer, and its `cleanUrl()` only encodes
 * a URI -- it does not reject `javascript:`.
 *
 * This lives beside the providers (and is deep-required by the web apps the same way
 * `_VocabularySelectorMap.js` is) so every screen that shows a remark renders it identically.
 */
// report_definitions reports/HeadLight-ATM/headlight-document/source/atm-user-markdown.js carries a copy of these rules for the ATM report -- change both together.

const libMarked = require('marked');

/** @type {Record<string, string>} */
const _HTMLEntityMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#039;' };

/** Protocols a user-authored remark is allowed to link to. */
const _SafeLinkProtocolPattern = /^(?:https?:\/\/|mailto:|tel:|\/|\.{1,2}\/|#)/i;
/**
 * A protocol-relative href (`//host/...`; browsers read `\` as `/` in an http(s) URL, so `/\host` is
 * one too). It names another host while looking like a relative path, so it is never a link or image.
 */
const _ProtocolRelativePattern = /^[/\\]{2}/;
/** The only hrefs an `<img>` may load: absolute http(s). Relative paths are the page's own origin. */
const _AbsoluteImageURLPattern = /^https?:\/\//i;
/** Browsers drop ASCII tab and newline anywhere in a URL, so `/\t/host` is `//host` by the time it loads. */
const _URLWhitespacePattern = /[\t\n\r]/g;

/** @type {Record<string, string>} */
const _TextEntityMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' };
/** Unescaped specials, leaving existing entity references alone (so applying it twice is harmless). */
const _TextEscapePattern = /[<>"']|&(?!(?:#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g;

/**
 * Escapes a value for use as HTML text or as an attribute value.
 *
 * @param {any} pValue - the value to escape.
 * @return {String} - the escaped value, or an empty string for null/undefined.
 */
function escapeHTML(pValue)
{
	if ((pValue === null) || (typeof(pValue) === 'undefined'))
	{
		return '';
	}
	return String(pValue).replace(/[&<>"']/g, (pCharacter) => _HTMLEntityMap[pCharacter]);
}

/**
 * Escapes text that marked may already have escaped, without double-escaping its entities -- the same
 * rule marked uses for text, so ordinary text comes out exactly as it did.
 *
 * @param {any} pText - text from a marked token.
 * @return {String} - safe HTML text.
 */
function escapeTextIdempotent(pText)
{
	if ((pText === null) || (typeof(pText) === 'undefined'))
	{
		return '';
	}
	return String(pText).replace(_TextEscapePattern, (pCharacter) => _TextEntityMap[pCharacter]);
}

/**
 * The href as a browser will read it: trimmed, with the tabs and newlines a browser drops removed.
 *
 * @param {any} pHref - the href from the markdown source.
 * @return {String}
 */
function _normalizeHref(pHref)
{
	return (typeof(pHref) === 'string') ? pHref.replace(_URLWhitespacePattern, '').trim() : '';
}

/**
 * Returns the trimmed href when it points somewhere a remark is allowed to link to, otherwise null.
 *
 * @param {any} pHref - the href from the markdown source.
 * @return {String|null}
 */
function safeURL(pHref)
{
	const tmpHref = _normalizeHref(pHref);
	if (_ProtocolRelativePattern.test(tmpHref))
	{
		return null;
	}
	return _SafeLinkProtocolPattern.test(tmpHref) ? tmpHref : null;
}

/**
 * The host the page is served from, read at call time; '' where there is no page (node, tests).
 *
 * @return {String} - the lower-cased hostname without a trailing dot.
 */
function _currentHostname()
{
	try
	{
		const tmpLocation = /** @type {any} */ (globalThis).location;
		const tmpHostname = (tmpLocation && (typeof(tmpLocation.hostname) === 'string')) ? tmpLocation.hostname : '';
		return tmpHostname.toLowerCase().replace(/\.$/, '');
	}
	catch (pError)
	{
		return '';
	}
}

/**
 * Returns the URL to draw when an image may be loaded the moment a remark renders, otherwise null.
 *
 * Only an absolute http(s) URL with no credentials, on a host that is not the page's own, not a
 * Headlight host (`/1.0/*` there runs with the reader's session), not localhost and not an IP literal
 * (a reader's browser reaching into their own network). Relative and protocol-relative paths are the
 * page's own origin, where the API lives, so they never load.
 *
 * @param {any} pHref - the image href from the markdown source.
 * @return {String|null}
 */
function safeImageURL(pHref)
{
	const tmpHref = _normalizeHref(pHref);
	if (!_AbsoluteImageURLPattern.test(tmpHref) || (typeof(URL) !== 'function'))
	{
		return null;
	}
	let tmpURL;
	try
	{
		tmpURL = new URL(tmpHref);
	}
	catch (pError)
	{
		return null;
	}
	if (((tmpURL.protocol !== 'https:') && (tmpURL.protocol !== 'http:')) || tmpURL.username || tmpURL.password)
	{
		return null;
	}
	const tmpHostname = tmpURL.hostname.toLowerCase().replace(/\.+$/, '');
	if (!tmpHostname)
	{
		return null;
	}
	// The URL parser has already turned every IPv4 spelling (hex, octal, a bare number) into a dotted
	// quad, and a host whose last label is all digits is never a name.
	const tmpLastLabel = tmpHostname.split('.').pop() || '';
	if ((tmpHostname.charAt(0) === '[') || /^(?:0x[0-9a-f]*|\d+)$/i.test(tmpLastLabel))
	{
		return null;
	}
	if ((tmpHostname === 'localhost') || /\.localhost$/.test(tmpHostname))
	{
		return null;
	}
	if ((tmpHostname === 'headlight.com') || /\.headlight\.com$/.test(tmpHostname))
	{
		return null;
	}
	const tmpCurrentHostname = _currentHostname();
	if (tmpCurrentHostname && (tmpHostname === tmpCurrentHostname))
	{
		return null;
	}
	return tmpURL.href;
}

// Styling for a rendered remark. Registered with the pict CSS map rather than an app stylesheet so
// every app that loads this provider gets it without a per-app css copy (there are ten copies of
// headlight-panels.css in the tree already).
const RemarksCSS = /*css*/`
.hl-md-remarks.content > :last-child { margin-bottom: 0; }
.hl-md-remarks.content p { margin-bottom: 0.5em; }
.hl-md-remarks.content h1,
.hl-md-remarks.content h2,
.hl-md-remarks.content h3,
.hl-md-remarks.content h4,
.hl-md-remarks.content h5,
.hl-md-remarks.content h6 { font-size: 1.1em; margin-top: 0; margin-bottom: 0.25em; color: inherit; }
.hl-md-remarks.content ul,
.hl-md-remarks.content ol { margin-top: 0.25em; margin-bottom: 0.5em; }
.hl-md-remarks.content table { margin-top: 0.25em; margin-bottom: 0.5em; }
.hl-md-remarks.content img { max-width: 100%; }
/* A remark also sits on dark surfaces (the sample panel), so headings, bold text and quotes take the text color around them rather than Bulma's fixed dark ones. */
.hl-md-remarks.content strong { color: inherit; }
.hl-md-remarks.content blockquote
{
	background-color: transparent;
	color: inherit;
	border-left: 3px solid currentColor;
	border-left-color: color-mix(in srgb, currentColor 35%, transparent);
	padding: 0.25em 0 0.25em 0.75em;
	margin-bottom: 0.5em;
}
.hl-md-remarks-collapse summary { display: block; list-style: none; }
.hl-md-remarks-collapse summary::-webkit-details-marker { display: none; }
.hl-md-remarks-collapse:not([open]) .hl-md-remarks-text
{
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.hl-md-remarks-collapse.is-truncated summary { cursor: pointer; }
.hl-md-remarks-collapse.is-truncated summary::after
{
	content: "Read more";
	display: block;
	margin-top: 0.25em;
	font-size: 0.85em;
	color: var(--bulma-link, #3273dc);
}
.hl-md-remarks-collapse.is-truncated[open] summary::after { content: "Read less"; }
`;

const _CollapseSelector = '.hl-md-remarks-collapse';
const _CollapseTextSelector = '.hl-md-remarks-collapse .hl-md-remarks-text';
/** Set on a collapsible remark whose text runs past the clamp; it is what shows Read more. */
const _TruncatedClass = 'is-truncated';
/** @type {WeakSet<any>} */
const _WatchedDocuments = new WeakSet();

/**
 * Marks a collapsible remark as truncated when its clamped text runs past the clamp, so Read more
 * shows only when there is more to read.
 *
 * @param {any} pCollapse - the `details.hl-md-remarks-collapse` element.
 * @return {Boolean} - whether the remark is marked truncated afterwards.
 */
function updateRemarkTruncation(pCollapse)
{
	if (!pCollapse || !pCollapse.classList)
	{
		return false;
	}
	// An open remark is unclamped and measures as fitting, so it keeps its mark until it closes.
	if (pCollapse.open)
	{
		return pCollapse.classList.contains(_TruncatedClass);
	}
	const tmpText = pCollapse.querySelector('.hl-md-remarks-text');
	// A remark on a tab that isn't showing has no layout yet; it is measured once it gets one.
	if (!tmpText || (tmpText.clientHeight === 0))
	{
		return pCollapse.classList.contains(_TruncatedClass);
	}
	const tmpTruncated = ((tmpText.scrollHeight - tmpText.clientHeight) > 1);
	pCollapse.classList.toggle(_TruncatedClass, tmpTruncated);
	return tmpTruncated;
}

/**
 * The clamped remark text elements in and under a node.
 *
 * @param {any} pNode - a DOM node.
 * @return {Array<any>}
 */
function getRemarkTextElements(pNode)
{
	if (!pNode || (pNode.nodeType !== 1))
	{
		return [];
	}
	const tmpElements = Array.from(pNode.querySelectorAll(_CollapseTextSelector));
	if (pNode.matches(_CollapseTextSelector))
	{
		tmpElements.push(pNode);
	}
	return tmpElements;
}

/**
 * Keeps every collapsible remark in a document marked truncated or not as it renders, resizes or
 * goes from hidden to shown, and stops a click from opening a remark that already fits. Safe to
 * call more than once; does nothing where there is no DOM.
 *
 * @param {any} [pDocument] - the document to watch; defaults to the global one.
 * @return {Boolean} - true when the document is being watched.
 */
function watchRemarksTruncation(pDocument)
{
	const tmpDocument = pDocument || ((typeof(document) !== 'undefined') ? document : null);
	const tmpWindow = tmpDocument ? tmpDocument.defaultView : null;
	if (!tmpWindow || (typeof(tmpWindow.ResizeObserver) !== 'function') || (typeof(tmpWindow.MutationObserver) !== 'function'))
	{
		return false;
	}
	if (_WatchedDocuments.has(tmpDocument))
	{
		return true;
	}
	_WatchedDocuments.add(tmpDocument);

	const tmpResizeObserver = new tmpWindow.ResizeObserver((pEntries) =>
	{
		for (const tmpEntry of pEntries)
		{
			updateRemarkTruncation(tmpEntry.target.closest(_CollapseSelector));
		}
	});
	const tmpMutationObserver = new tmpWindow.MutationObserver((pRecords) =>
	{
		for (const tmpRecord of pRecords)
		{
			for (const tmpNode of Array.from(tmpRecord.removedNodes))
			{
				for (const tmpText of getRemarkTextElements(tmpNode))
				{
					tmpResizeObserver.unobserve(tmpText);
				}
			}
			for (const tmpNode of Array.from(tmpRecord.addedNodes))
			{
				for (const tmpText of getRemarkTextElements(tmpNode))
				{
					tmpResizeObserver.observe(tmpText);
				}
			}
		}
	});
	tmpMutationObserver.observe(tmpDocument.documentElement, { childList: true, subtree: true });
	for (const tmpText of getRemarkTextElements(tmpDocument.documentElement))
	{
		tmpResizeObserver.observe(tmpText);
	}

	tmpDocument.addEventListener('click', (pEvent) =>
	{
		const tmpTarget = pEvent.target;
		if (!tmpTarget || (typeof(tmpTarget.closest) !== 'function') || tmpTarget.closest('a'))
		{
			return;
		}
		const tmpSummary = tmpTarget.closest(`${ _CollapseSelector } > summary`);
		if (tmpSummary && !tmpSummary.parentElement.open && !tmpSummary.parentElement.classList.contains(_TruncatedClass))
		{
			pEvent.preventDefault();
		}
	});
	return true;
}

/** @type {any} Built on first use; marked instances are reusable and stateless across parses. */
let _UserContentMarked = null;
/** So an unusable marked is reported once, not once per remark on the page. */
let _MarkedUnusableReported = false;
/** How many links the render is inside, so an image in link text does not become a link in a link. */
let _LinkDepth = 0;

/**
 * The hardened marked instance.
 *
 * @return {any}
 */
function getUserContentMarked()
{
	if (_UserContentMarked)
	{
		return _UserContentMarked;
	}
	if (typeof(libMarked.Marked) !== 'function')
	{
		// The Marked class arrived in marked 5, and the renderer overrides below are the object-argument
		// form from marked 13+. An older marked resolves here silently -- it has neither -- and every
		// remark then falls back to its escaped source, which looks like the feature simply not working.
		// marked is a transitive dependency in several places and no lockfile is committed, so the
		// version a build resolves is whatever hoisting produced: say so by name rather than throwing a
		// bare TypeError per remark.
		throw new Error('markdown remarks need marked 13 or newer (no Marked class found on the resolved marked); declare "marked": "^14.1.2" in the package this file resolves from');
	}
	_UserContentMarked = new libMarked.Marked(
		{
			gfm: true,
			// A remark is typed into a textarea or a markdown editor, where pressing Enter means a
			// line break. Sample notes in particular arrive as labelled lines ("Producer Supplier
			// Code: ...\nPlant ID: ..."), which markdown's default paragraph folding would run
			// together into one line -- worse than the raw text it replaces.
			breaks: true,
			// After an inline <pre> / <code> / <kbd> / <script> tag marked is in its "raw block" state,
			// and the text up to the closing tag reaches the output unescaped -- so
			// `<kbd><img/src=x onerror=...></kbd>` (an <img> its tag pattern does not recognise as HTML)
			// would run. Escape every leaf text token; text marked already escaped is left as it is.
			walkTokens: function(/** @type {any} */ pToken)
			{
				if (pToken && (pToken.type === 'text') && !pToken.tokens && (typeof(pToken.text) === 'string'))
				{
					pToken.text = escapeTextIdempotent(pToken.text);
				}
			},
			renderer:
			{
				// `this` here is marked's renderer, so these have to be function expressions to
				// reach `this.parser`.
				html: function(pToken)
				{
					return escapeHTML(pToken.text);
				},
				link: function(pToken)
				{
					let tmpText = '';
					_LinkDepth++;
					try
					{
						tmpText = this.parser.parseInline(pToken.tokens);
					}
					finally
					{
						_LinkDepth--;
					}
					const tmpHref = safeURL(pToken.href);
					if (!tmpHref)
					{
						return tmpText;
					}
					const tmpTitle = pToken.title ? ` title="${ escapeHTML(pToken.title) }"` : '';
					return `<a href="${ escapeHTML(tmpHref) }"${ tmpTitle } target="_blank" rel="noopener noreferrer">${ tmpText }</a>`;
				},
				image: function(pToken)
				{
					// marked hands over the alt text already escaped.
					const tmpAlt = escapeTextIdempotent(pToken.text);
					const tmpTitle = pToken.title ? ` title="${ escapeHTML(pToken.title) }"` : '';
					const tmpSource = safeImageURL(pToken.href);
					if (tmpSource)
					{
						return `<img class="image" src="${ escapeHTML(tmpSource) }" alt="${ tmpAlt }"${ tmpTitle }>`;
					}
					// Not drawn: offer it as a link the reader chooses to follow, unless it is already inside one.
					const tmpHref = (_LinkDepth > 0) ? null : safeURL(pToken.href);
					if (!tmpHref)
					{
						return tmpAlt;
					}
					return `<a href="${ escapeHTML(tmpHref) }"${ tmpTitle } target="_blank" rel="noopener noreferrer">${ tmpAlt.trim() ? tmpAlt : 'image' }</a>`;
				},
			},
		});
	return _UserContentMarked;
}

/**
 * Converts markdown a user typed to display HTML. Returns an empty string when there is nothing to
 * show; falls back to the escaped source if marked throws, so a malformed remark still reads.
 *
 * @param {any} pMarkdown - the remark source.
 * @param {any} [pLog] - optional fable log to report a parse failure to.
 * @return {String}
 */
function renderUserMarkdown(pMarkdown, pLog)
{
	if ((pMarkdown === null) || (typeof(pMarkdown) === 'undefined') || (pMarkdown === ''))
	{
		return '';
	}
	const tmpMarkdown = (typeof(pMarkdown) === 'string') ? pMarkdown : String(pMarkdown);
	try
	{
		return String(getUserContentMarked().parse(tmpMarkdown));
	}
	catch (pError)
	{
		// Escaped source is a safe degradation -- the remark still reads, just unformatted -- so this
		// never takes a screen down. It is reported once so it is findable in a console full of noise.
		if (pLog && !_MarkedUnusableReported)
		{
			_MarkedUnusableReported = true;
			pLog.error(`Markdown remarks are rendering as plain text: ${pError.message}`, pError);
		}
		return escapeHTML(tmpMarkdown);
	}
}

module.exports = { renderUserMarkdown: renderUserMarkdown, escapeHTML: escapeHTML, safeURL: safeURL, safeImageURL: safeImageURL, RemarksCSS: RemarksCSS, updateRemarkTruncation: updateRemarkTruncation, watchRemarksTruncation: watchRemarksTruncation };

},{"marked":506}],171:[function(require,module,exports){
/**
 * Managed-vocabulary map for the specialized code-list selectors (SampleStatusSelector, …).
 *
 * A vocabulary is a small, customer-curated code list stored in its own table, whose CODE (not its
 * database id) is what the referencing record persists — `Sample.Status` holds `'PASS'`, not an
 * `IDSampleStatus`. It is read in full and rendered as an option list, so it takes neither the
 * remote-search entity path (see `_SpecializedSelectorMap`) nor a purely static option array.
 *
 * Both stacks read this one definition: the legacy Select-family provider
 * (`PictProvider-InputType-SampleStatusSelector`) and the `Picker` broker's generic option source, so
 * the two render the same list from the same table with the same fallback.
 *
 * Per entry:
 *   Entity    — the vocabulary table (also the meadow scope; the route pluralizes to `<Entity>s`).
 *   ValueField — the column persisted onto the referencing record.
 *   TextField  — the column shown as the label.
 *   SortField  — the column the list is ordered by.
 *   Fallback   — options used when the customer has curated no rows, so the input works uncurated.
 */

/**
 * Fallback sample statuses. Deliberately smaller than the SiteManager set LADOTD runs on (which also
 * carries PREA / TSTR / PASC / FAIC / N/A) — a customer needing those manages them in SampleStatus.
 * @type {Array<{id: string, text: string}>}
 */
const DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS =
[
	{ 'id': 'LOGD', 'text': 'Logged' },
	{ 'id': 'RECV', 'text': 'Received' },
	{ 'id': 'PEND', 'text': 'Pending' },
	{ 'id': 'TEST', 'text': 'In Testing' },
	{ 'id': 'PASS', 'text': 'Passed' },
	{ 'id': 'FAIL', 'text': 'Failed' },
	{ 'id': 'INFO', 'text': 'Info' },
	{ 'id': 'VOID', 'text': 'Voided' },
];

/** @type {Record<string, {Entity: string, ValueField: string, TextField: string, SortField: string, Fallback: Array<{id: string, text: string}>}>} */
const VOCABULARY_SELECTOR_MAP =
{
	SampleStatusSelector:
	{
		Entity: 'SampleStatus',
		ValueField: 'Hash',
		TextField: 'Name',
		SortField: 'Ordinal',
		Fallback: DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS,
	},
};

/**
 * Stamp an input descriptor with its vocabulary's option source, so the shared entity option loader
 * picks it up. Never overwrites a schema-supplied `SelectOptions` / `SelectOptionsEntity`.
 *
 * @param {Object} pInput - The form input descriptor.
 * @param {string} [pInputType] - InputType override; defaults to the descriptor's own.
 * @return {boolean} - True when this input is vocabulary-backed.
 */
function applyVocabularySource(pInput, pInputType)
{
	if (!pInput)
	{
		return false;
	}
	if (!pInput.PictForm)
	{
		pInput.PictForm = {};
	}
	const tmpVocabulary = VOCABULARY_SELECTOR_MAP[pInputType || pInput.PictForm.InputType];
	if (!tmpVocabulary)
	{
		return false;
	}
	if (!Array.isArray(pInput.PictForm.SelectOptions))
	{
		pInput.PictForm.SelectOptions = tmpVocabulary.Fallback;
	}
	if (!pInput.PictForm.SelectOptionsEntity)
	{
		pInput.PictForm.SelectOptionsEntity = tmpVocabulary.Entity;
		pInput.PictForm.SelectOptionsEntityValueField = pInput.PictForm.SelectOptionsEntityValueField || tmpVocabulary.ValueField;
		pInput.PictForm.SelectOptionsEntityTextField = pInput.PictForm.SelectOptionsEntityTextField || tmpVocabulary.TextField;
		pInput.PictForm.SelectOptionsEntitySortField = pInput.PictForm.SelectOptionsEntitySortField || tmpVocabulary.SortField;
	}
	return true;
}

module.exports = { VOCABULARY_SELECTOR_MAP, DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS, applyVocabularySource };

},{}],172:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="DATE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-calendar fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-calendar fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<div
							id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Date {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="DATE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Date',
			DefaultInputExtensions: [ 'InputValidation', 'DatePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Date (using DatePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="DATE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Date',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="DATE-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],173:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime (using DateTimePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar-clock fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType DateTime (using DateTimePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-DateTime',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-calendar-clock fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-calendar-clock fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-calendar-clock fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType DateTime (using DateTimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-DateTime',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-calendar-clock fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<div
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-DateTime',
			DefaultInputExtensions: [ 'InputValidation', 'DateTimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType DateTime (using DateTimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-DateTime',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],174:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autocomplete="off"
							value=""
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autocomplete="off"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-InformaryAddress-Input',
			Template: /*HTML-Partial*/`
					data-i-index="{~D:Context[2].Key~}"
					onchange="_Pict.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="text"
				class="input"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
				value=""
			/>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],175:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			Template: /*HTML-Parital*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0 {~HideInPDF:Record~}">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Number',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Number',
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0 {~HideInPDF:Record~}">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Number',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],176:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-PreciseNumber',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-PreciseNumber',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-PreciseNumber',
			DefaultInputExtensions: [ 'InputValidation', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber', {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-PreciseNumber',
			Template: /*HTML*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-PreciseNumber',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],177:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-String',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Required:Record~}
							{~Disabled:Record~}
							{~MinLength:Record~}
							{~MaxLength:Record~}
							{~Pattern:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autocomplete="off"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-String',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Required:Record~}
									{~Disabled:Record~}
									{~MinLength:Record~}
									{~MaxLength:Record~}
									{~Pattern:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autocomplete="off"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-String',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Required:Record~}
						{~Disabled:Record~}
						{~MinLength:Record~}
						{~MaxLength:Record~}
						{~Pattern:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-String',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-String',
			Template: /*HTM-Partial*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-String',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-String',
			Template: /*HTML*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-String',
			Template: /*HTML-Partial*/`
			<!-- DataType String {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-String',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],178:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time (using TimePickerProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label for="{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="TIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							onchange="{~D:Record.Macro.DataRequestFunction~}"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-clock-desk fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-clock-desk fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Time (using TimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="TIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Time',
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="TIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-clock-desk fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="TIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-clock-desk fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-clock-desk fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Time (using TimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="TIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Time',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<input class="input"
					{~D:Record.Macro.ControlAttr~}
					id="TIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					{~D:Record.Macro.HTMLName~}
					readonly aria-readonly="true"
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-clock-desk fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InputFullProperties~}
						value=""
					/>
					<div class="control">
						<div
							id="TIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML*/`
			<!-- DataType Time {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<div
								id="{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-DataType-Time',
			DefaultInputExtensions: [ 'InputValidation', 'TimePickerProvider' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Time (using TimePickerProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="TIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-DataType-Time',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="TIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],179:[function(require,module,exports){
/*
	Body markup for the Diagram and RichText editor input types, assembled per presentation by the
	{~EditorBody:<Theme>~} macro (see HeadlightDynamicInputsBundle.js). Both types share this markup —
	they differ only in the display slot's class and their provider hash, both derived from the InputType.

	The field edits INLINE: a View/Edit segmented switch flips between the static view and the live
	editor in place (the provider only toggles `is-editing`; the CSS does the rest). The inactive segment
	is a soft link, the active one solid — they read as one control. Read and Print always render the
	static view (no switch, no edit affordance); Print additionally drops the view's border (see the
	`pict-editor-print` class) so the PDF is clean.

	Every editable field opens and closes through that switch, which is what makes the exported value
	reliable: the close path commits. There is deliberately no "always editing" presentation (a field
	with no close event has no natural point to export from) and no floating "compact" modal one (removed
	2026-07-22 — the inline editor has its own toolbar, so the modal was bug surface without a need). There
	is also no dedicated "Clear" control (added then removed 2026-07-22): Excalidraw's own nav menu carries
	a "reset the canvas" action, which is deliberate-and-buried where a toolbar button was easy to mis-hit.

	Two ids are load-bearing and must not change:
	  - id="DISPLAY-FOR-{RawHTMLID}" — the PSF provider mounts view/edit content there.
	  - id="PICT-EDITOR-FOR-{RawHTMLID}" — the provider toggles `is-editing` on this container.
*/

/** @param {string} pInputType @return {string} The PSF display-slot class for this editor type. */
const displayClass = (pInputType) => `pict-section-form-${pInputType.toLowerCase()}`;

/** The View | Edit segmented switch. Each segment names its target mode (not a flip), so it reads as an
 *  on-page mode switch. Both segments are `is-link is-soft`; CSS promotes the ACTIVE one to solid link
 *  (keyed off the container's `is-editing`), so the pair reads as soft-inactive / solid-active. */
const _modeSwitch = (pInputType) => /*HTML*/`
			<div class="buttons has-addons pict-editor-switch">
				<button type="button" class="button is-small is-link is-soft pict-editor-switch-view" {~Disabled:Record~}
					onclick="_Pict.providers['Pict-Input-${pInputType}'].setEditorMode('{~D:Record.Hash~}', '{~D:Record.Macro.RawHTMLID~}', 'view')">
					<span class="icon"><i class="fas fa-fw fa-eye"></i></span><span>View</span>
				</button>
				<button type="button" class="button is-small is-link is-soft pict-editor-switch-edit" {~Disabled:Record~}
					onclick="_Pict.providers['Pict-Input-${pInputType}'].setEditorMode('{~D:Record.Hash~}', '{~D:Record.Macro.RawHTMLID~}', 'edit')">
					<span class="icon"><i class="fas fa-fw fa-pen"></i></span><span>Edit</span>
				</button>
			</div>`;

/**
 * Build the body markup for one editor presentation.
 *
 * @param {object} pOptions
 * @param {string} pOptions.Theme - 'Edit' | 'Read' | 'Print'.
 * @param {string} pOptions.InputType - 'Diagram' | 'RichText'.
 * @return {string} The (unparsed) body template.
 */
function buildEditorBody(pOptions)
{
	const tmpInputType = pOptions.InputType;
	// Read/Print are always the static view — the editor chrome means nothing there.
	const tmpLocked = (pOptions.Theme !== 'Edit');
	// Print drops the view border for a clean PDF; Read keeps it (an on-screen affordance).
	const tmpContainerClass = (pOptions.Theme === 'Print') ? 'pict-editor pict-editor-print' : 'pict-editor';

	// The change handler lets informary marshal the exported value into FormData; drop it in the
	// read-only theme where nothing changes (matching the HTML/Markdown templates).
	const tmpChangeHandler = tmpLocked ? '' : '{~D:Record.Macro.InputChangeHandler~}';

	// The explicit id is REQUIRED, not decoration: the provider writes the exported value back with
	// document.getElementById(RawHTMLID) and returns silently when it finds nothing — so without it the
	// editor works, shows content, and saves absolutely nothing. InputFullProperties supplies the
	// informary binding (data-i-form / data-i-datum / name) but NOT the id.
	return /*HTML*/`
		<input type="hidden" tabindex="-1" id="{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~} ${tmpChangeHandler} value="">
		<div id="PICT-EDITOR-FOR-{~D:Record.Macro.RawHTMLID~}" class="${tmpContainerClass}">
			${tmpLocked ? '' : /*HTML*/`<div class="pict-editor-controls">${_modeSwitch(tmpInputType)}</div>`}
			<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="${displayClass(tmpInputType)}"></div>
		</div>
		${tmpLocked ? '' : /*HTML*/`<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>`}`;
}

module.exports = { buildEditorBody, displayClass };

},{}],180:[function(require,module,exports){
/*
	Template set builder for the Diagram and RichText editor input types.

	Both editors render the same wrapper — a labeled column whose body (the toggle + editor/view slot)
	is chosen per field at render time by the `{~EditorBody:<Theme>~}` macro; see EditorBodies.js for the
	markup and HeadlightDynamicInputsBundle.js for the macro that fills it in.

	STANDARD and VERTICAL only. These types have no Tabular entries on purpose: the pict-section-form
	provider throws inside a tabular row (N Excalidraw/CodeMirror instances per row is a performance
	landmine), so there is nothing to render there. RecordSet reuses the Tabular templates, so it is
	unsupported for the same reason — Standard and Vertical are the supported layouts.
*/

/** The single-record wrapper. The body macro fills in the presentation for this theme. */
const _buildStandardTemplate = (pInputType, pTheme) => /*HTML*/`
		<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
		<div class="column {~ColumnWidth:Record~}${pTheme === 'Print' ? ' {~HideInPDF:Record~}' : ''}">
			<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
			{~EditorBody:${pTheme}~}
		</div>`;

/** The label-left vertical wrapper, matching the HTML/Markdown vertical layout. */
const _buildVerticalTemplate = (pInputType, pTheme) => /*HTML*/`
		<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
		<div class="pict-form-vertical-input column ${pTheme === 'Print' ? 'pb-1 {~HideInPDF:Record~}' : 'pb-3'}">
			<div class="columns is-mobile is-vcentered">
				<div class="column">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				</div>
				<div class="column description-text">{~D:Record.Description~}</div>
				<div class="column">
					{~EditorBody:${pTheme}~}
				</div>
			</div>
		</div>`;

/**
 * Build the Edit/Read/Print template entries for an editor input type.
 * @param {string} pInputType - 'Diagram' or 'RichText'.
 * @return {{ Edit: Array<object>, Read: Array<object>, Print: Array<object> }}
 */
function buildEditorTemplates(pInputType)
{
	const tmpThemeEntries = (pTheme) => (
		[
			{
				HashPostfix: `-Template-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ `Pict-Input-${pInputType}` ],
				Template: _buildStandardTemplate(pInputType, pTheme),
			},
			{
				HashPostfix: `-VerticalTemplate-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ `Pict-Input-${pInputType}` ],
				Template: _buildVerticalTemplate(pInputType, pTheme),
			},
		]);
	return {
		Edit: tmpThemeEntries('Edit'),
		Read: tmpThemeEntries('Read'),
		Print: tmpThemeEntries('Print'),
	};
}

module.exports = { buildEditorTemplates };

},{}],181:[function(require,module,exports){
// work smarter, not harder.
const _IntentionallyIdenticalTemplatesForAllThemes =
[
	// Form Container wrapper templates
	{
		// NOTE: intentionally empty -- instead we are using FormHeader view injected at #Headlight-View-Header
		HashPostfix: '-Template-Form-Container-Header',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Form-Container-Wrap-Prefix',
		Template: /*HTML*/`
		<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`,
	},
	{
		HashPostfix: '-Template-Form-Container',
		Template: /*HTML*/`
			<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`,
	},
	{
		// NOTE: intentionally empty -- we don't use these currently, but they are overloaded to reduce template comments in the DOM
		HashPostfix: '-Template-Wrap-Prefix',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Wrap-Postfix',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Form-Container-Custom',
		Template: /*HTML*/`
			<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`,
	},
	{
		HashPostfix: '-Template-Form-Container-Wrap-Postfix',
		Template: /*HTML*/`
		</div>`,
	},
	// Form Section, Group, Row templates
	{
		HashPostfix: '-Template-Section-Prefix',
		Template: /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<section id="SECTION-{~D:Context[0].formID~}" class="pict-form-section container {~D:Record.CSSClass~}" data-i-section-hash="{~D:Record.Hash~}">
			<h2 class="section-header {~ShowSectionTitle:Record~}">{~D:Record.Name~}</h2>`,
	},
	{
		HashPostfix: '-Template-Group-Prefix',
		Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="pict-form-group container {~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-content">`,
	},
	{
		HashPostfix: '-Template-Row-Prefix',
		Template: /*HTML*/`
					<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
					<div class="columns {~ColumnsOvercrowded:Record~}">`,
	},
	{
		HashPostfix: '-Template-Row-Postfix',
		Template: /*HTML*/`
					</div>
					<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
	{
		HashPostfix: '-Template-Group-Postfix',
		Template: /*HTML*/`
				</div>
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
	{
		HashPostfix: '-Template-Section-Postfix',
		Template: /*HTML*/`
		</section>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
];

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: _IntentionallyIdenticalTemplatesForAllThemes,
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: _IntentionallyIdenticalTemplatesForAllThemes,
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [ ..._IntentionallyIdenticalTemplatesForAllThemes,
		// NOTE: optional "HideInPDF" and "ShowTitleInPDF" classes added for sections
		{
			HashPostfix: '-Template-Section-Prefix',
			Template: /*HTML*/`
			<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<section id="SECTION-{~D:Context[0].formID~}" class="pict-form-section container {~D:Record.CSSClass~} {~HideInPDF:Record~}" data-i-section-hash="{~D:Record.Hash~}">
				<h2 class="section-header {~ShowSectionTitle:Record~} {~ShowTitleInPDF:Record~}">{~D:Record.Name~}</h2>`,
		},
		// NOTE: optional "HideInPDF" and "ShowTitleInPDF" classes added for groups
		{
			HashPostfix: '-Template-Group-Prefix',
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="pict-form-group container {~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~} {~ShowTitleInPDF:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-content">`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],182:[function(require,module,exports){
/*
	Body markup for both Geolocation input types, in both presentations.

	A geolocation field renders one of two presentations:

	  FULL (default)  — address search + editable lat/long + readout + labeled action buttons
	                    (plus the inline map on the WithMap variant).
	  COMPACT         — a single readout bar with icon buttons; the picker moves into an Edit modal
	                    (the inline map, on the WithMap variant, still renders below it).

	`Compact` is a PictForm option, so a Standard field and a Record Set record can each choose
	either one. A Tabular TABLE is always compact — a full picker cannot fit a table cell — which
	the `{~GeolocationBody:~}` pattern enforces before calling in here.

	Both presentations bind the SAME way, so the choice is purely presentational:
	  - Single-record: two informary-bound lat/long inputs (`LATITUDE-FOR-<id>` / `LONGITUDE-FOR-<id>`),
	    visible number inputs in full, `type="hidden"` data-bearers in compact.
	  - Tabular/Record Set: the two hidden informary inputs written by the Begin partial are the only
	    bound elements in either presentation. Full mode adds *unbound* editor inputs that the provider
	    syncs to them, so the proven tabular data path is untouched.

	Everything is keyed by an "instance id": the field's rawHTMLID for a single-record field, or
	`<rawHTMLID>-<rowKey>` for a tabular/record-set row. Keeping that one convention lets the
	address-search DOM helpers (GEO-ADDRESS-INPUT-<id> / GEO-ADDRESS-RESULTS-<id>) serve both.
*/

const GEO_PROVIDER = '_Pict.providers.GeolocationSelector';

// The ordered ids every row-aware provider method needs (view hash, group index, input index, row
// key, rawHTMLID) — mirrors the tabular action handlers' signature.
const ROW_ARGS = `'{~D:Context[0].Hash~}','{~D:Context[2].Group~}','{~D:Record.PictForm.InputIndex~}','{~D:Context[2].Key~}','{~D:Record.Macro.RawHTMLID~}'`;

/**
 * Resolve the per-context ids and provider call strings. Single-record fields address the provider
 * by instance id; tabular rows go through the row-aware methods, which also marshal the row.
 * @param {boolean} pTabular - True for a tabular/record-set cell body.
 * @param {boolean} pHasMap - True for the GeolocationSelectorWithMap variant.
 * @return {object} The id + handler fragments used to assemble a body.
 */
const _context = (pTabular, pHasMap) =>
{
	// The instance id: rawHTMLID, suffixed with the row key inside a tabular/record-set row.
	const tmpID = pTabular ?
		'{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}' :
		'{~D:Record.Macro.RawHTMLID~}';
	return {
		ID: tmpID,
		// Readout element id. Tabular reuses the id the compact cell has always used, so the Begin
		// partial's `data-validation-surface` pointer resolves in either presentation.
		DisplayID: pTabular ? `GEO-DISPLAY-TABULAR-${tmpID}` : `GEO-DISPLAY-FOR-${tmpID}`,
		// Lat/long inputs. Single-record: the informary-bound pair. Tabular: unbound editors the
		// provider syncs to the hidden bound pair written by the Begin partial.
		LatitudeID: pTabular ? `GEO-RS-LAT-${tmpID}` : `LATITUDE-FOR-${tmpID}`,
		LongitudeID: pTabular ? `GEO-RS-LONG-${tmpID}` : `LONGITUDE-FOR-${tmpID}`,
		Search: pTabular ? `${GEO_PROVIDER}.searchAddressTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.searchAddress('${tmpID}')`,
		UseMyLocation: pTabular ? `${GEO_PROVIDER}.onUseMyLocationTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.onUseMyLocation('${tmpID}')`,
		Clear: pTabular ? `${GEO_PROVIDER}.clearValueTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.clearValue('${tmpID}')`,
		EditModal: pTabular ? `${GEO_PROVIDER}.openEditModalTabular(${ROW_ARGS})` : `${GEO_PROVIDER}.openEditModal('${tmpID}', ${pHasMap})`,
		// A tabular row's editor inputs are not informary-bound, so they need an explicit commit.
		CoordinateEdit: pTabular ? `${GEO_PROVIDER}.onRowCoordinateEdit(${ROW_ARGS})` : '',
	};
};

// --- Shared fragments ------------------------------------------------------------------------

/** Address search box + the results container the provider fills with clickable rows. */
const _searchField = (pContext) => /*HTML*/`
	<div class="field has-addons geo-search-field">
		<div class="control is-expanded">
			<input id="GEO-ADDRESS-INPUT-${pContext.ID}" class="input" type="text" placeholder="Search an address or place…" autocomplete="off" {~Disabled:Record~}
				onkeydown="if(event.key==='Enter'){event.preventDefault();${pContext.Search};}" />
		</div>
		<div class="control">
			<button type="button" class="button is-soft" {~Disabled:Record~} onclick="${pContext.Search}">
				<span class="icon"><i class="fas fa-search"></i></span><span class="is-hidden-mobile">Search</span>
			</button>
		</div>
	</div>
	<div id="GEO-ADDRESS-RESULTS-${pContext.ID}"></div>`;

/**
 * One editable coordinate column. `pAttributes` carries the informary macros for a single-record
 * field; a tabular row passes its own change handler instead (its binding lives in hidden inputs).
 */
const _coordinateColumn = (pID, pLabel, pAttributes) => /*HTML*/`
		<div class="column">
			<label for="${pID}" class="label is-small">${pLabel}</label>
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<input id="${pID}" type="number" class="input has-text-right" step="any" placeholder="0" onfocus="this.select()"
						${pAttributes} autocomplete="off" />
					<span class="icon is-small is-left"><i class="fas fa-map-marker-alt"></i></span>
				</p>
			</div>
		</div>`;

/**
 * The editable Latitude/Longitude pair. Plain `.columns` (no `is-mobile`) so Bulma stacks them into
 * full-width rows on a phone, which is what the narrow layout needs.
 */
const _coordinateColumns = (pContext, pTabular) =>
{
	// A tabular row's editors are unbound, so they commit through the provider; a single-record
	// field's inputs ARE the informary binding. `required` belongs on the bound element only — a
	// tabular row's requiredness would live on its hidden Begin-partial inputs, not on these.
	const tmpAttributes = pTabular ?
		`{~Disabled:Record~} onchange="${pContext.CoordinateEdit}"` :
		'{~Required:Record~} {~Disabled:Record~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}';
	return /*HTML*/`
	<div class="columns geo-coordinate-columns">
${_coordinateColumn(pContext.LatitudeID, 'Latitude', tmpAttributes)}
${_coordinateColumn(pContext.LongitudeID, 'Longitude', tmpAttributes)}
	</div>`;
};

/**
 * Read-only coordinate pair for a single-record field's Read/Print themes (kept side-by-side in
 * Print). Single-record only — these carry the informary binding, which a tabular row already has
 * on its hidden Begin-partial inputs.
 */
const _staticCoordinateColumns = (pContext, pPrint) =>
{
	const tmpTag = (pID, pLabel) => (pPrint ? /*HTML*/`
		<div class="column">
			<label for="${pID}" class="label is-small">${pLabel}</label>
			<div class="field mb-0">
				<div class="control">
					<div id="${pID}" class="input is-static" {~D:Record.Macro.InputFullProperties~}></div>
				</div>
			</div>
		</div>` : /*HTML*/`
		<div class="column">
			<label for="${pID}" class="label is-small">${pLabel}</label>
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<input id="${pID}" type="number" class="input has-text-right" step="any"
						{~D:Record.Macro.InputFullProperties~} readonly aria-readonly="true" />
					<span class="icon is-small is-left"><i class="fas fa-map-marker-alt"></i></span>
				</p>
			</div>
		</div>`);
	return /*HTML*/`
	<div class="columns ${pPrint ? 'is-mobile' : ''} geo-coordinate-columns">
${tmpTag(pContext.LatitudeID, 'Latitude')}
${tmpTag(pContext.LongitudeID, 'Longitude')}
	</div>`;
};

/**
 * Readout + action buttons. On a phone the CSS drops the buttons to their own full-width row and
 * splits them 50/50, which is why the readout and the buttons stay separate flex children here.
 */
const _actionLevel = (pContext) => /*HTML*/`
	<div class="level is-mobile mt-1 geo-action-level">
		<div class="level-left geo-readout">
			<span class="icon has-text-primary"><i class="fa fa-location-dot"></i></span>
			<span id="${pContext.DisplayID}" class="has-text-grey ml-1">No location set</span>
		</div>
		<div class="level-right">
			<div class="buttons are-small mb-0 geo-action-buttons">
				<button type="button" class="button is-link" {~Disabled:Record~} onclick="${pContext.UseMyLocation}">
					<span class="icon"><i class="fa fa-location-crosshairs"></i></span><span>Use My Location</span>
				</button>
				<button type="button" class="button is-link is-soft" {~Disabled:Record~} onclick="${pContext.Clear}">
					<span class="icon"><i class="fa fa-eraser"></i></span><span>Clear</span>
				</button>
			</div>
		</div>
	</div>`;

/**
 * The compact bar: a read-only readout with Get-Location / Edit / Clear icon buttons.
 *
 * For a single-record field the two informary-bound inputs live INSIDE this control as hidden
 * data-bearers pointing at the readout via `data-validation-surface` — the same arrangement
 * InputType-Signature uses, so the validation provider resolves visibility and paints is-danger on
 * a wrapper the user can actually see. A tabular row's bearers are already in the Begin partial.
 */
const _compactBar = (pContext, pTabular, pLocked) =>
{
	const tmpBearers = pTabular ? '' : /*HTML*/`
			<input id="${pContext.LatitudeID}" type="hidden" tabindex="-1"
				{~Required:Record~} {~Disabled:Record~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}
				data-validation-surface="${pContext.DisplayID}" ${pLocked ? 'readonly aria-readonly="true" ' : ''}value="" />
			<input id="${pContext.LongitudeID}" type="hidden" tabindex="-1"
				{~Required:Record~} {~Disabled:Record~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}
				data-validation-surface="${pContext.DisplayID}" ${pLocked ? 'readonly aria-readonly="true" ' : ''}value="" />`;
	// A locked readout sets the pin inline beside the coordinates, the same way the full-size
	// readout does. NOT Bulma's has-icons-left: that absolutely positions the icon and reserves room
	// with padding-left, which `.input.is-static` then zeroes out — dropping the pin on top of the
	// coordinates in the Read and Print/PDF themes.
	if (pLocked)
	{
		return /*HTML*/`
	<div class="field mb-0 geo-compact-bar">
		<div class="control">${tmpBearers}
			<span class="icon has-text-primary"><i class="fa fa-location-dot"></i></span>
			<span id="${pContext.DisplayID}" class="ml-1"></span>
		</div>
	</div>`;
	}
	return /*HTML*/`
	<div class="field has-addons mb-0 geo-compact-bar">
		<div class="control is-expanded control-status has-icons-left">${tmpBearers}
			<span class="icon is-left"><i class="fa fa-location-dot"></i></span>
			<div id="${pContext.DisplayID}" class="input" readonly></div>
		</div>
		<div class="control"><button type="button" class="button is-link" title="Use my location" aria-label="Use my location"
			{~Disabled:Record~} onclick="${pContext.UseMyLocation}"><span class="icon"><i class="fa fa-location-crosshairs"></i></span></button></div>
		<div class="control"><button type="button" class="button is-link" title="Edit location" aria-label="Edit location"
			{~Disabled:Record~} onclick="${pContext.EditModal}"><span class="icon"><i class="fa fa-pen-to-square"></i></span></button></div>
		<div class="control"><button type="button" class="button is-link is-soft" title="Clear location" aria-label="Clear location"
			{~Disabled:Record~} onclick="${pContext.Clear}"><span class="icon"><i class="fa fa-eraser"></i></span></button></div>
	</div>`;
};

// --- Map hosts -------------------------------------------------------------------------------

/**
 * Live map host. Single-record fields mount into it as soon as it scrolls into view; record-set
 * rows keep theirs hidden until the provider confirms the group really is a RecordSet (a Tabular
 * table has no room for a per-row map and uses the Edit modal's map instead).
 */
const _liveMapHost = (pContext, pTabular, pLocked) => (pTabular ? /*HTML*/`
	<div id="GEO-RS-MAP-FOR-${pContext.ID}" ${pLocked ? 'data-geo-locked="true" ' : ''}class="mt-2" style="display: none; min-height: 280px; z-index: 1;"></div>` : /*HTML*/`
	<div id="MAP-CONTAINER-FOR-${pContext.ID}" class="mt-2"></div>`);

/** Print/PDF map: a static image the renderer can wait for (a live Leaflet map under-fills the frame). */
const _staticMapImage = (pContext, pTabular) => (pTabular ? /*HTML*/`
	<img id="GEO-RS-MAPIMG-FOR-${pContext.ID}" alt="Map of the selected location" class="mt-2" style="width: 100%; height: auto; max-height: 360px; object-fit: cover; border-radius: 6px; display: none;" />` : /*HTML*/`
	<img id="MAP-IMG-FOR-${pContext.ID}" alt="Map of the selected location" class="mt-2" style="width: 100%; height: auto; max-height: 420px; object-fit: cover; border-radius: 6px; display: none;" />`);

// --- Body assembly ---------------------------------------------------------------------------

/**
 * Build the body markup for one geolocation presentation.
 *
 * @param {object} pOptions
 * @param {string} pOptions.Theme - 'Edit' | 'Read' | 'Print'.
 * @param {boolean} pOptions.Compact - True for the compact bar presentation.
 * @param {boolean} pOptions.HasMap - True for the GeolocationSelectorWithMap variant.
 * @param {boolean} pOptions.Tabular - True for a tabular/record-set cell body.
 * @return {string} The (unparsed) body template.
 */
function buildGeolocationBody(pOptions)
{
	const tmpContext = _context(pOptions.Tabular, pOptions.HasMap);
	const tmpPrint = (pOptions.Theme === 'Print');
	const tmpLocked = (pOptions.Theme !== 'Edit');
	// The compact/full choice shapes the *editable* presentation. A locked tabular row always falls
	// back to the readout bar: the picker chrome (search box, editable coordinates) means nothing in
	// Read/Print, and the readout plus the map already carry the whole value.
	const tmpUseCompactBar = pOptions.Compact || (pOptions.Tabular && tmpLocked);
	let tmpBody = '';

	if (tmpUseCompactBar)
	{
		tmpBody += _compactBar(tmpContext, pOptions.Tabular, tmpLocked);
	}
	else if (tmpLocked)
	{
		tmpBody += _staticCoordinateColumns(tmpContext, tmpPrint);
	}
	else
	{
		tmpBody += _searchField(tmpContext);
		tmpBody += _coordinateColumns(tmpContext, pOptions.Tabular);
		tmpBody += _actionLevel(tmpContext);
	}

	if (pOptions.HasMap)
	{
		tmpBody += tmpPrint ? _staticMapImage(tmpContext, pOptions.Tabular) : _liveMapHost(tmpContext, pOptions.Tabular, tmpLocked);
	}
	// The help line only makes sense next to the controls it describes.
	if (!tmpUseCompactBar && !tmpLocked)
	{
		tmpBody += /*HTML*/`
	<p class="help">Search an address, type coordinates${pOptions.HasMap ? ', or click the map / drag the marker' : ''} to set the location. It saves with the form.</p>`;
	}
	return tmpBody;
}

module.exports = { buildGeolocationBody };

},{}],183:[function(require,module,exports){
/*
	Template set builder for both Geolocation input types.

	`GeolocationSelector` and `GeolocationSelectorWithMap` render the same control — the map variant
	just adds a map — so both input types are built from this one place. The presentation (full picker
	vs compact bar) is chosen per field at render time by the `{~GeolocationBody:<Theme>~}` macro; see
	GeolocationBodies.js for the markup and HeadlightDynamicInputsBundle.js for the selection rules.

	The tabular Begin partial is the one piece that must stay literal HTML: the framework assembles a
	tabular cell as Begin + Mid + InformaryAddress + End, and the InformaryAddress partial injects
	`data-i-index` + `onchange` into whatever tag Begin leaves open. So Begin writes the two hidden
	informary inputs (latitude fully, longitude left open) and everything else lives in the body.
*/

/*
	The value binds as two informary hidden inputs with nested sub-addresses
	(<InformaryDataAddress>.Latitude / .Longitude), producing Container[row].<Field> = {Latitude,
	Longitude} — identical to the single-record shape. These stay the ONLY bound elements in a
	tabular/record-set cell in either presentation; the full picker's visible coordinate boxes are
	unbound editors the provider syncs to these.

	`data-validation-surface` points at the readout, which keeps the same id in both presentations,
	so the validation provider can resolve a visible surface for these hidden data-bearers.
*/
const _buildTabularBegin = (pInputType) => /*HTML*/`
	<!-- InputType ${pInputType} Tabular {~D:Record.Hash~} {~D:Record.DataType~} -->
	<input type="hidden" tabindex="-1"
		id="GEO-LAT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
		data-i-form="{~D:Context[0].formID~}"
		data-i-datum="{~D:Record.PictForm.InformaryDataAddress~}.Latitude"
		data-i-container="{~D:Record.PictForm.InformaryContainerAddress~}"
		data-i-index="{~D:Context[2].Key~}"
		data-validation-surface="GEO-DISPLAY-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
		value="" />
	<input type="hidden" tabindex="-1"
		id="GEO-LONG-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
		data-i-form="{~D:Context[0].formID~}"
		data-i-datum="{~D:Record.PictForm.InformaryDataAddress~}.Longitude"
		data-i-container="{~D:Record.PictForm.InformaryContainerAddress~}"
		data-validation-surface="GEO-DISPLAY-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"`;

/** The single-record wrapper. The body macro fills in the presentation for this theme. */
const _buildStandardTemplate = (pInputType, pTheme) => /*HTML*/`
	<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
	<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}${pTheme === 'Print' ? ' {~HideInPDF:Record~}' : ''} geolocation-input">
		<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
		{~GeolocationBody:${pTheme}~}
	</div>`;

/**
 * Build the Edit/Read/Print template entries for a Geolocation input type.
 * @param {string} pInputType - 'GeolocationSelector' or 'GeolocationSelectorWithMap'.
 * @return {{ Edit: Array<object>, Read: Array<object>, Print: Array<object> }}
 */
function buildGeolocationTemplates(pInputType)
{
	const tmpTabularBegin = _buildTabularBegin(pInputType);
	const tmpThemeEntries = (pTheme) => (
		[
			{
				HashPostfix: `-Template-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ 'GeolocationSelector' ],
				Template: _buildStandardTemplate(pInputType, pTheme),
			},
			{
				HashPostfix: `-TabularTemplate-Begin-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ 'GeolocationSelector' ],
				Template: tmpTabularBegin,
			},
			{
				// Closes the longitude input the Begin partial left open, then the cell body.
				HashPostfix: `-TabularTemplate-End-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ 'GeolocationSelector' ],
				Template: /*HTML*/`
		value="" />
	<div class="geolocation-input">{~GeolocationBody:${pTheme}~}</div>`,
			},
		]);
	return {
		Edit: tmpThemeEntries('Edit'),
		Read: tmpThemeEntries('Read'),
		Print: tmpThemeEntries('Print'),
	};
}

module.exports = { buildGeolocationTemplates };

},{}],184:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<p class="control control-status">
							<span class="control-status-icon"></span>
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="checkbox"
								class="is-checkbox"
								{~D:Record.Macro.ControlAttr~}
								{~Required:Record~}
								{~Disabled:Record~}
								{~D:Record.Macro.InputFullProperties~}
								{~D:Record.Macro.InputChangeHandler~}
								value=""
							/>
							<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
						</p>
					</label>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-checkbox-with-label pb-1 mb-0 mt-2 {~ColumnAlignment:Record~}">
							<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
								<p class="control control-status">
									<span class="control-status-icon"></span>
									<input
										id="{~D:Record.Macro.RawHTMLID~}"
										type="checkbox"
										class="is-checkbox"
										{~D:Record.Macro.ControlAttr~}
										{~Required:Record~}
										{~Disabled:Record~}
										{~D:Record.Macro.InputFullProperties~}
										{~D:Record.Macro.InputChangeHandler~}
										value=""
									/>
								</p>
							</label>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
							value=""
						/>
						<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
					</p>
				</label>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
							value=""
						/>
						<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
					</label>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="checkbox"
									class="is-checkbox"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
									value=""
								/>
							</label>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}
							disabled="disabled"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
							value=""
						/>
						<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
					</p>
				</label>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
					</label>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="checkbox"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
						</label>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="checkbox"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
				</label>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],185:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "BridgeSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Bridge) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "BridgeSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			// BESPOKE, not a bare reference: it reproduces the Picker Edit chrome and keeps the legacy Bridge
			// Search Panel buttons, which the truth template dropped — losing them orphans the panel, whose
			// selection callback the broker still wires (_wireBridgeSearchPanel). Two buttons, as legacy: a
			// labelled one on mobile and an icon-only one above it. No Show All toggle, because the legacy
			// BridgeSelector had none and its customer-state scope is mandatory.
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (+ bridge panel addon) -->
				<div class="column {~ColumnWidth:Record~}">
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						{~Required:Record~}
						data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
						value=""
					/>
					<div class="field">
						<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
							</p>
							<p class="control is-hidden-tablet is-fullwidth">
								<button class="button is-link addons-stack-mobile" type="button" onclick="_Pict.views.HeadlightPaneBridges.openBridgePanelFromAdvancedButton(event)">
									<span class="icon is-small">
										<i class="fas fa-bars-filter"></i>
									</span>
									<span>Search Bridges</span>
								</button>
							</p>
							<p class="control is-hidden-mobile">
								<button class="button is-link" type="button" onclick="_Pict.views.HeadlightPaneBridges.openBridgePanelFromAdvancedButton(event)">
									<span class="icon is-small">
										<i class="fas fa-bars-filter"></i>
									</span>
								</button>
							</p>
						</div>
						<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: BridgeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-BridgeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],186:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Chart',
			DefaultInputExtensions: [ 'Pict-Input-Chart' ],
			Template: /*HTML*/`
			<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-input-chart" style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block; padding: 0.75rem;">
				<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<!-- ChartHeight (pixels) sets the plot area; min-height so the default of 0
				     is a no-op and Chart.js keeps its own 2:1 sizing. Must match the base
				     template in pict-section-form -- these themed copies OVERRIDE it. -->
				<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;">
					<canvas {~D:Record.Macro.ControlAttr~} id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.InputFullProperties~}></canvas>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],187:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				class="input is-hidden"
				tabindex="-1"
				{~Required:Record~}
				{~Disabled:Record~}
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			/>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				class="input is-hidden"
				disabled="disabled"
				{~D:Record.Macro.InputFullProperties~}
				value=""
			/>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-CloneAction',
			Template: /*HTML*/`
			<!-- Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				class="input is-hidden"
				disabled="disabled"
				{~D:Record.Macro.InputFullProperties~}
				value=""
			/>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],188:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<style>
				input[type="color" i]::-webkit-color-swatch,
				input[type="color" i]::-moz-color-swatch {
					border: 0;
					border-radius: 0.25rem;
				}
			</style>
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="color"
							class="input py-0"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							value="#ffffff"
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-palette fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="color"
									class="input py-0"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									value="#ffffff"
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-palette fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="color"
						class="input py-0"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
						value="#ffffff"
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-palette fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							aria-readonly="true"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input"
									aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
				value="" />
			<div
				id="DISPLAY-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input"
				aria-readonly="true"
				{~D:Record.Macro.ControlAttr~}
			></div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
				value="" />
			<div
				id="DISPLAY-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],189:[function(require,module,exports){
// Headlight templates for the PSF `Diagram` (Excalidraw) InputType. Standard + Vertical across
// Edit/Read/Print; the shared builder and the {~EditorBody:~} macro own the presentation. Tabular is
// unsupported by design (the provider throws). See EditorTemplates.js / EditorBodies.js.
const { buildEditorTemplates } = require('./EditorTemplates.js');

module.exports = buildEditorTemplates('Diagram');

},{"./EditorTemplates.js":180}],190:[function(require,module,exports){
// TODO: Is this a valid input type? Should it be removed or renamed? Investigate.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			// TODO: Make a Document Date Provider to update the document object and the header date
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field mb-0">
					<label for="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value="{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}"
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value="{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}"
						/>
					</p>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						>{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],191:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="email"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-envelope fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="email"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-envelope fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EmailAddress (using EmailAddressProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="email"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EmailAddress',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-envelope fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using EmailAddressProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="email"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-envelope fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="email"
									class="input"
									readonly aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-envelope fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EmailAddress (using EmailAddressProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="email"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EmailAddress',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-envelope fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- DataType EmailAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML*/`
			<!-- InputType EmailAddress (using 'EmailAddressProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EmailAddress',
			DefaultInputExtensions: [ 'EmailAddressProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EmailAddress (using EmailAddressProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EmailAddress',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],192:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							type="text"
							class="input {~ColumnAlignment:Record~}"
							placeholder="{~Placeholder:Record~}"
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
							autocomplete="off"
							value=""
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntityDisplay',
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
					<input
						id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
						autocomplete="off"
						value=""
					/>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<div
					id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			Template: /*HTML-Partial*/`
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-EntityDisplay`,
			DefaultInputExtensions: [ 'EntityDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType EntityDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntityDisplay',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],193:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "EntitySelector" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "EntitySelector" in the manifest -- no manifest edit is needed;
	the broker maps its Entity / IdentityField / EntityDisplayField onto the picker; PickerDisplay
	resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],194:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "EntitySelectorMultiple" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "EntitySelectorMultiple" in the manifest -- no manifest edit is needed;
	the broker maps its Entity descriptor and infers multi-select from the InputType name;
	PickerDisplay resolves the entity names (+ EntityTag badges) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],195:[function(require,module,exports){
// TODO: This input type only has tabular for Edit theme? Feels incomplete. Investigate later if this is actually used.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ExistingDisabledByDefault',
			DefaultInputExtensions: [ 'InputValidation', 'ExistingDisabledByDefault' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ExistingDisabledByDefault {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control control-status">
				<span class="control-status-icon"></span>
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~Required:Record~}
					{~Disabled:Record~}
					placeholder="{~Placeholder:Record~}"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ExistingDisabledByDefault',
			Template: /*HTML-Partial*/`
					value=""
				/>
			</p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		/* NOTE: Remove me and add your own templates here for the Read theme */
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		/* NOTE: Remove me and add your own templates here for the Print theme */
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],196:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="file is-link">
							<label class="file-label">
								<input
									id="FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="file-input"
									type="file"
									name="resume"
									onchange="{~P~}.providers.FileSelector.handleFileSelection('{~D:Record.Macro.RawHTMLID~}', false);"
								/>
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-upload"></i>
									</span>
									<span class="file-label"> Upload a file</span>
								</span>
							</label>
							<button type="button" class="button is-link ml-1" onclick="{~P~}.providers.FileSelector.openObservationSearchPanel('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false);">
								<span class="icon">
									<i class="fas fa-fw fa-paperclip"></i>
								</span>
								<span>Select Observation</span>
							</button>
						</div>
						<!-- the loading indicator, shown while the file is being processed -->
						<div id="LOADING-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-skeleton is-hidden" style="height: 40px;">Loading...</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status is-expanded">
					<input
						id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="file is-link">
						<label class="file-label">
							<input
								id="TABULAR-FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
								class="file-input"
								type="file"
								name="resume"
								onchange="{~P~}.providers.FileSelector.handleFileSelection('{~D:Record.Macro.RawHTMLID~}', true, {~D:Context[2].Key~});"
							/>
							<span class="file-cta">
								<span class="file-icon">
									<i class="fas fa-upload"></i>
								</span>
								<span class="file-label"> Upload a file</span>
							</span>
						</label>
						<button type="button" class="button is-link ml-1" onclick="{~P~}.providers.FileSelector.openObservationSearchPanel('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~});">
							<span class="icon">
								<i class="fas fa-fw fa-paperclip"></i>
							</span>
							<span>Select Observation</span>
						</button>
					</div>
					<!-- the loading indicator, shown while the file is being processed -->
					<div id="TABULAR-LOADING-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-skeleton is-hidden" style="height: 40px;">Loading...</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-fullwidth">
							<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
						</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control control-status is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-expanded">
						<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
					</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} (does not print) -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-fullwidth">
							<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
						</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="control control-status is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-fullwidth">
						<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
					</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],197:[function(require,module,exports){
// The no-map Geolocation variant. Markup is shared with the map variant — see GeolocationTemplates.js.
const { buildGeolocationTemplates } = require('./GeolocationTemplates.js');

module.exports = buildGeolocationTemplates('GeolocationSelector');

},{"./GeolocationTemplates.js":183}],198:[function(require,module,exports){
// The map Geolocation variant. Markup is shared with the no-map variant — see GeolocationTemplates.js.
const { buildGeolocationTemplates } = require('./GeolocationTemplates.js');

module.exports = buildGeolocationTemplates('GeolocationSelectorWithMap');

},{"./GeolocationTemplates.js":183}],199:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],200:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "LabSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Lab) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "LabSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LabSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LabSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],201:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "LineItemSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (LineItem) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "LineItemSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: LineItemSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-LineItemSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],202:[function(require,module,exports){
// Headlight templates for the PSF `Link` InputType. PSF ships bare defaults (no Bulma wrapper,
// no Read/Print variants); these add the house style across Edit/Read/Print for Standard, Vertical,
// and Tabular layouts. (RecordSet reuses the Tabular entries — it is not a separate template axis.)
//
// Contract preserved from pict-section-form's Link provider (Pict-Provider-Input-Link.js):
//   - Standard/Vertical: the anchor MUST carry id="INPUT-FOR-{RawHTMLID}" — onDataMarshalToForm
//     sets its `href` there. Visible text is the field Name (the Name is the link caption).
//   - Tabular: the anchor MUST carry id="TABULAR-DATA-{RawHTMLID}-{rowIndex}" — onDataMarshalToFormTabular
//     sets `href` there. `{~D:Context[2].Key~}` resolves to the row index.
//   - The hidden input carries the informary binding; Link is display-only for its URL, so there is
//     no change handler (matching PSF — the value arrives from data/solvers, not from editing the anchor).
//   - Every anchor carries {~LinkTarget:Record~}, which emits target/rel when the descriptor sets
//     PictForm.LinkTarget. Absent, it emits nothing (same-tab default). All nine anchors must keep
//     it in lockstep across Edit/Read/Print -- the template tests enforce that.
//   - The Tabular Begin/End split is deliberate: Begin opens the hidden input tag and leaves it
//     unclosed after the informary macros so the framework's Mid partial can inject binding attributes;
//     End closes it and renders the anchor. Do not close the input inside Begin.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
					<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
					<span>{~D:Record.Name~}</span>
				</a>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
							<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
							<span>{~D:Record.Name~}</span>
						</a>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Link',
			Template: /*HTML-Partial*/` value="">
			<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-link" {~D:Record.Macro.HTMLName~} {~LinkTarget:Record~}>{~D:Record.Name~}</a>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
					<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
					<span>{~D:Record.Name~}</span>
				</a>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
							<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
							<span>{~D:Record.Name~}</span>
						</a>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Link',
			Template: /*HTML-Partial*/` value="">
			<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-link" {~D:Record.Macro.HTMLName~} {~LinkTarget:Record~}>{~D:Record.Name~}</a>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
					<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
					<span>{~D:Record.Name~}</span>
				</a>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-link" {~LinkTarget:Record~}>
							<span class="icon"><i class="fas fa-fw fa-external-link-alt"></i></span>
							<span>{~D:Record.Name~}</span>
						</a>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Link',
			DefaultInputExtensions: [ 'Pict-Input-Link' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Link',
			Template: /*HTML-Partial*/` value="">
			<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pict-section-form-link" {~D:Record.Macro.HTMLName~} {~LinkTarget:Record~}>{~D:Record.Name~}</a>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],203:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No Markdown content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No Markdown content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No Markdown content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No Markdown content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No Markdown content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Markdown',
			DefaultInputExtensions: [ 'Bulma-Markdown' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No Markdown content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],204:[function(require,module,exports){
/**
 * InputType `MarkdownDisplay` -- a labelled, read-only field that renders the markdown held in its
 * value. Use it for a remark a user typed; use InputType `Markdown` for static markdown authored in
 * the manifest (an Instructions block), which is what that one's templates are gated for.
 *
 * Like `Markdown`, this has no Tabular templates: the display element is addressed per input, not
 * per row.
 */
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
					<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MarkdownDisplay',
			DefaultInputExtensions: [ 'Bulma-MarkdownDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MarkdownDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div {~D:Record.Macro.ControlAttr~} class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="content hl-md-remarks pict-section-form-markdown"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],205:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MaterialSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Material) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MaterialSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],206:[function(require,module,exports){
/* DEVELOPER NOTE:
	Select2 -> pict-section-picker port-forward (Wave 10): the base "MaterialsEntitySelector" EDIT theme renders
	via the Picker stack, attaching MaterialsEntityPicker (the Materials cascade base, with the legacy base's list
	order, search, labels and placeholder). The Edit variants are BESPOKE reproductions of the Picker chrome (not
	bare references) because this selector keeps the tracking-GUID slot the family binds to. Element ids match the
	Picker templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the provider mounts unchanged. READ / PRINT
	render via PickerDisplay.
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'MaterialsEntityPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsEntitySelector; Applied InputType: Picker (+ tracking) -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsEntityPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsEntitySelector',
			DefaultInputExtensions: [ 'MaterialsEntityPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsEntitySelector; Applied InputType: Picker (tabular) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsEntitySelector',
			DefaultInputExtensions: [ 'MaterialsEntityPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsEntityPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   Rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes): resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsEntitySelector; Applied InputType: Picker (read display) -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsEntitySelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsEntitySelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsEntitySelector; Applied InputType: Picker (print display) -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsEntitySelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsEntitySelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsEntitySelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],207:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLabSelector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLabSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],208:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemPicker' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemPicker' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemPicker' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLineItemSelector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenLineItemSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenLineItemSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],209:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
				/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}
				value=""
				/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenSampleSelector',
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenSampleSelector',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],210:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],211:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestPicker' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestPicker' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestPicker' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestSelector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],212:[function(require,module,exports){
/* DEVELOPER NOTE:
	Beast B4 migration port-forward (Select2 -> pict-section-picker): the "MaterialsLabSelector" EDIT
	theme now renders via the Picker stack, attaching MaterialsLabPicker (the SampleLabJoin reconcile +
	SampleLabAdd promotion target). The Edit variants are BESPOKE reproductions of the Picker chrome
	(not bare references) because this selector carries surface the shared templates lack: the tracking-
	GUID slot and the {~HCS:Record.PictForm.Hidden~} hide wrapper. Element ids match the Picker
	templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the provider mounts unchanged. READ / PRINT
	now render via PickerDisplay (B5 display port).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (+ tracking + Hidden wrap) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsLabPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (tabular) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			DefaultInputExtensions: [ 'MaterialsLabPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsLabPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLabSelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],213:[function(require,module,exports){
/* DEVELOPER NOTE:
	Beast B4 migration port-forward (Select2 -> pict-section-picker): the "MaterialsLineItemSelector"
	EDIT theme now renders via the Picker stack, attaching MaterialsLineItemPicker (the
	SampleLineItemJoin reconcile + the display-only units stamp). The Edit variants are BESPOKE
	reproductions of the Picker chrome (not bare references) because this selector carries surface the
	shared templates lack: the tracking-GUID slot and the {~HCS:Record.PictForm.Hidden~} hide wrapper.
	Element ids match the Picker templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the provider
	mounts unchanged. READ / PRINT now render via PickerDisplay (B5 display port).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'MaterialsLineItemPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLineItemSelector; Applied InputType: Picker (+ tracking + Hidden wrap) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsLineItemPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLineItemSelector; Applied InputType: Picker (tabular) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLineItemSelector',
			DefaultInputExtensions: [ 'MaterialsLineItemPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsLineItemPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLineItemSelector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLineItemSelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLineItemSelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsLineItemSelector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsLineItemSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsLineItemSelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsLineItemSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],214:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MaterialsPlantSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (ProductionPlant) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MaterialsPlantSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsPlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsPlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],215:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-qrcode"></i>
					</span>
					<span class="icon-text">No QR code available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">No QR code available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-qrcode"></i>
					</span>
					<span class="icon-text">No QR code available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">No QR code available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-qrcode"></i>
					</span>
					<span class="icon-text">No QR code available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsQRCodeDisplay',
			DefaultInputExtensions: [ 'Bulma-MaterialsQRCodeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsQRCodeDisplay {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">No QR code available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-qrcode has-text-centered {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],216:[function(require,module,exports){
/* DEVELOPER NOTE:
	Beast B2 migration port-forward (Select2 -> pict-section-picker): the "MaterialsSampleSelector"
	EDIT theme now renders via the Picker stack, attaching MaterialsSamplePicker — the cascade subclass
	carrying the Sample hub logic (creation, DocumentPolyJoin, tracking family, save stamp+projection).
	The MAIN Edit template is BESPOKE (not a bare reference): it reproduces the Picker Edit chrome and
	adds the legacy Sample Search Panel addon button (losing it would orphan the panel). The tabular +
	vertical variants reference the shared Picker templates (which carry the tracking-GUID slot).
	READ / PRINT now render via MaterialsSamplePickerDisplay (B5 display port: __Record-first GUID resolve + the QR-code image prepend).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker (+ sample panel addon) -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsSamplePicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="field has-addons has-addons-right mb-0">
						<p class="control control-status is-expanded">
							<span class="control-status-icon"></span>
							<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
						</p>
						<p id="SAMPLE-LOCK-CONTROL-{~D:Record.Macro.RawHTMLID~}" class="control is-hidden">
							<button id="SAMPLE-LOCK-{~D:Record.Macro.RawHTMLID~}" class="button" type="button" aria-pressed="false" onclick="_Pict.providers.MaterialsSamplePicker.toggleSampleLock('{~D:Record.Macro.RawHTMLID~}')">
								<span class="icon is-small">
									<i class="fas fa-lock-open"></i>
								</span>
							</button>
						</p>
						<p class="control">
							<button id="SAMPLE-PANEL-BUTTON-{~D:Record.Macro.RawHTMLID~}" class="button is-link" type="button" {~Disabled:Record~} onclick="_Pict.views.HeadlightPaneSamples.openSamplePanelFromAdvancedButton(event)">
								<span class="icon is-small">
									<i class="fas fa-bars-filter"></i>
								</span>
							</button>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSamplePicker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's MaterialsSamplePickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same MaterialsSamplePickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSamplePickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsSampleSelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],217:[function(require,module,exports){
/* DEVELOPER NOTE:
	Beast B5 migration port-forward (Select2 -> pict-section-picker): the "MaterialsTestInjector" EDIT
	theme now renders via the Picker stack, attaching MaterialsTestInjectorPicker (Active+Injectable
	scoping, Hash identity, the __Record OPT-OUT, registerTest section injection). The Edit variants
	are BESPOKE reproductions of the Picker chrome carrying the "Add Test" ADDON BUTTON, which reads
	the committed Hash from the Picker's hidden informary input (the legacy read the select element).
	Element ids match the Picker templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the provider
	mounts unchanged. READ / PRINT now render via PickerDisplay (B5 display port, Hash identity).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestInjector; Applied InputType: Picker (+ Add Test addon) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsTestInjectorPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="field has-addons has-addons-right mb-0">
						<p class="control control-status is-expanded">
							<span class="control-status-icon"></span>
							<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
						</p>
						<p class="control">
							<button
								id="ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="button is-link"
								type="button"
								onclick="{~P~}.providers.MaterialsTestInjectorPicker.registerTest({~P~}.ContentAssignment.readContent('#{~D:Record.Macro.RawHTMLID~}'),
									{~P~}.providers.MaterialsTestInjectorPicker._generateSaltStr())">

								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span>Add Test</span>
							</button>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestInjector; Applied InputType: Picker (tabular + Add Test addon) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsTestInjectorPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
				<p class="control">
					<button
						id="ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-link"
						type="button"
						onclick="{~P~}.providers.MaterialsTestInjectorPicker.registerTest({~P~}.ContentAssignment.readContent('#PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}'),
							{~P~}.providers.MaterialsTestInjectorPicker._generateSaltStr())">

						<span class="icon">
							<i class="fa fa-fw fa-plus"></i>
						</span>
						<span>Add Test</span>
					</button>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestInjector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestInjector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestInjector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestInjector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestInjector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestInjector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],218:[function(require,module,exports){
/* DEVELOPER NOTE:
	Beast B4 migration port-forward (Select2 -> pict-section-picker): the "MaterialsTestLabSelector"
	EDIT theme now renders via the Picker stack, attaching MaterialsTestLabPicker (the per-test lab
	dual-write + TestInstanceLabJoin + SampleLabAdd promotion). The Edit variants are BESPOKE
	reproductions of the Picker chrome (not bare references) because this selector carries surface the
	shared templates lack: the tracking-GUID slot and the {~HCS:Record.PictForm.Hidden~} hide wrapper.
	Element ids match the Picker templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the provider
	mounts unchanged. READ / PRINT now render via PickerDisplay (B5 display port).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'MaterialsTestLabPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestLabSelector; Applied InputType: Picker (+ tracking + Hidden wrap) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsTestLabPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsTestLabSelector',
			DefaultInputExtensions: [ 'MaterialsTestLabPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestLabSelector; Applied InputType: Picker (tabular) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestLabSelector',
			DefaultInputExtensions: [ 'MaterialsTestLabPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsTestLabPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestLabSelector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestLabSelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestLabSelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestLabSelector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestLabSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestLabSelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestLabSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],219:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			DefaultInputExtensions: [ 'MaterialsTestSectionRemover' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} -->
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} pt-0 pb-0">
				<a id="SECTION-REMOVER-FOR-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost has-text-danger is-pulled-right p-0 is-size-7"
					title="Remove this test and its section from the form"
					onclick="{~P~}.providers.MaterialsTestSectionRemover.requestSectionRemoval('{~D:Record.PictForm.SectionRemovalHash~}')">
					<span class="icon"><i class="fas fa-trash-alt"></i></span><span class="icon-text">Remove Test</span>
				</a>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} (not available in read mode) -->
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSectionRemover`,
			Template: /*HTML*/`
			<!-- InputType MaterialsTestSectionRemover {~D:Record.Hash~} (not rendered in print mode) -->
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],220:[function(require,module,exports){
/* DEVELOPER NOTE:
	Beast B3 migration port-forward (Select2 -> pict-section-picker): the "MaterialsTestSelector" EDIT
	theme now renders via the Picker stack, attaching MaterialsTestPicker (the triple engine + the save-
	projection driver). ALL Edit variants are BESPOKE reproductions of the Picker chrome (not bare
	references) because this selector carries surface the shared templates don't: the SECOND (TEST-typed)
	tracking-GUID slot and the {~HCS:Record.PictForm.Hidden~} hide wrapper (MaterialsHidden-style
	fields). Element ids match the Picker templates exactly (PICKER-FOR- / PICKER-TABULAR-), so the
	provider mounts unchanged. READ / PRINT now render via PickerDisplay (B5 display port, Hash identity).
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'MaterialsTestPicker' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestSelector; Applied InputType: Picker (+ TEST tracking + Hidden wrap) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsTestPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestPicker' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestSelector; Applied InputType: Picker (tabular) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~Required:Record~}
						data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestSelector',
			DefaultInputExtensions: [ 'MaterialsTestPicker' ],
			Template: /*HTML-Partial*/`
						value="" />
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.MaterialsTestPicker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host"></span>
				</p>
			</div>
			<p class="help"></p>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state.
	   B5 display port: rendered by the Picker stack's PickerDisplay (PICKER-DISPLAY-* nodes) instead of
	   the legacy Materials*Display — resolve is __Record-first, then identity-aware. */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestSelector; Applied InputType: Picker (read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestSelector; Applied InputType: Picker (tabular read display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="field mb-0">
				<p class="control">
					<div
						id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestSelector',
			Template: /*HTML-Partial*/`
					></div>
				</p>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents (same PickerDisplay resolve; PDF-static node). */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- Provided InputType: MaterialsTestSelector; Applied InputType: Picker (print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsTestSelector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- Provided InputType: MaterialsTestSelector; Applied InputType: Picker (tabular print display) -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			{~HCS:Record.PictForm.Hidden:1~}
			<div
				id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsTestSelector',
			Template: /*HTML-Partial*/`
			></div>
			{~HCE:Record.PictForm.Hidden:1~}
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],221:[function(require,module,exports){
// The MediaDetailCards InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.MediaDetailCards applies the correct settings
// (deckLayout: 'details', filters for actionable observation types) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MediaDetailCards',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MediaDetailCards; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MediaDetailCards',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MediaDetailCards; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MediaDetailCards',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MediaDetailCards; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],222:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "MixSpecificationSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (MixSpecification) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "MixSpecificationSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: MixSpecificationSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MixSpecificationSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],223:[function(require,module,exports){
// Themed metatemplates for InputType 'ObjectEditor' (pict-section-form's ObjectEditor input, which
// embeds pict-section-objecteditor as an interactive JSON tree). Mirrors InputType-Picker.js's Bulma
// chrome (column / field / label / help) so the editor inherits Headlight's form styling instead of the
// minimal base template, whose bare "<span>Name:</span>" sat inline-left of the tree inside the flex
// .columns row. The control is the host div the ObjectEditor provider mounts the tree into; the element
// ids + ControlAttr match what Pict-Provider-Input-ObjectEditor expects (DISPLAY-FOR-<RawHTMLID>).
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive tree for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div class="field">
							<div class="control">
								<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME — locked/read-only. The same tree renders non-editable (Editable:false via PictForm.ReadOnly). */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor (read) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME — non-interactive PDF. Same host; the tree paints read-only. */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor (print) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],224:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- set selector for non-sets use case or for when showSetSelector option is true (used instead of filters above) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-selector {~Show:Record.PictForm.CardDeckSettings.useObservationSetSelector~}">
								<div class="field has-addons has-addons-right has-addons-left is-fullwidth mr-1 mb-0">
									<p class="control">
										<button
											id="EDIT-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											class="button is-link"
											type="button"
											disabled
											onclick="_Pict.providers.ObservationCardDeckProvider.handleObservationSetEditButtonClick('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}')"
											>
											<span class="icon">
												<i class="fa fa-fw fa-cog"></i>
											</span>
										</button>
									</p>
									<p class="control control-status select is-fullwidth">
										<span class="control-status-icon"></span>
										<select
											id="CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											{~Required:Record~}
											{~Disabled:Record~}
											onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
										>
											<option value="">Select a set...</option>
										</select>
									</p>
									<p class="control">
										<button
											id="CREATE-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											class="button is-link"
											type="button"
											onclick="_Pict.providers.ObservationCardDeckProvider.handleObservationSetCreateSetButtonClick('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}')"
										>
											<span class="icon">
												<i class="fa fa-fw fa-plus"></i>
											</span>
											<span>Create New Set</span>
										</button>
									</p>
								</div>
							</div>
							<!-- Action buttons for the card deck -->
							<div id="CARD-DECK-HEADER-ACTIONS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-actions">
								<div class="buttons has-addons observation-card-deck-style-toggle mr-1 mb-0">
									<button type="button" 
										class="button is-active" 
										title="Thumbnail" 
										data-deck-style="thumbnail" 
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'thumbnail')">
										<span class="icon">
											<i class="fa fa-fw fa-th"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="List"
										data-deck-style="list"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'list')">
										<span class="icon">
											<i class="fa fa-fw fa-list"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="Details"
										data-deck-style="details"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'details')">
										<span class="icon">
											<i class="fa fa-fw fa-id-card"></i>
										</span>
									</button>
								</div>
								<div class="buttons has-addons mb-0 {~Hide:Record.PictForm.CardDeckSettings.preventAddingCards~}">
									<button type="button"
										id="CARD-DECK-HEADER-ACTIONS-ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
										class="button is-link is-skeleton" 
										title="Add" 
										data-deck-action="add" 
										onclick="_Pict.providers.ObservationCardDeckProvider.handleAddNewCardToDeckButtonEvent(event, '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false)">
										<span class="icon">
											<i class="fa fa-fw fa-plus"></i>
										</span>
										<span class="icon-text">Add</span>
									</button>
									<!-- Quick capture button - actually a file input styled as a button -->
									<label
										id="CARD-DECK-HEADER-ACTIONS-QUICK-CAPTURE-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
										class="button is-clickable is-link is-skeleton"
										style="border-left: 1px solid var(--bulma-border);"
									>
										<input
											title="Quick Capture - Take a photo with your device's camera"
											type="file"
											class="file-input"
											name="user"
											capture="environment"
											accept="image/*"
											onchange="_Pict.providers.ObservationCardDeckProvider.handleAddNewCardToDeckButtonEvent(event, '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true)"
										/>
											<div class="{~Hide:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~} mr-2">
												<i class="fas fa-fw fa-camera"></i>
											</div>
											<div class="{~Show:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~} mr-2">
												<i class="fa fa-fw {~D:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~}"></i>
											</div>
											<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}">Quick Capture</span>
											<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}">{~D:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}</span>
									</label>
								</div>
							</div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<p class="control control-status">
							<span class="control-status-icon"></span>
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}><span class="initial-loading-message"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">No items have been added to this collection.</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}</span>
								</div>
							</div>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- Action buttons for the card deck -->
							<div id="CARD-DECK-HEADER-ACTIONS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-actions">
								<div class="buttons has-addons observation-card-deck-style-toggle mr-1 mb-0">
									<button type="button" 
										class="button is-active" 
										title="Thumbnail" 
										data-deck-style="thumbnail" 
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'thumbnail')">
										<span class="icon">
											<i class="fa fa-fw fa-th"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="List"
										data-deck-style="list"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'list')">
										<span class="icon">
											<i class="fa fa-fw fa-list"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="Details"
										data-deck-style="details"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'details')">
										<span class="icon">
											<i class="fa fa-fw fa-id-card"></i>
										</span>
									</button>
								</div>
							</div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<p class="control">
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}><span class="initial-loading-message"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">No items have been added to this collection.</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}</span>
								</div>
							</div>
						</p>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} for-print-only" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<div class="control">
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage:No items have been added to this collection.~}</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],225:[function(require,module,exports){
// The ObservationImageSet InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.ObservationImageSet applies the correct settings
// (useObservationSet: true, filters for 'Legacy Image' type) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationImageSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationImageSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],226:[function(require,module,exports){
/*
	A record's photo, kept as an image observation (see PictProvider-InputType-ObservationPhoto.js). The hidden input
	holds the IDObservation; the provider fills the preview and sets the button labels.
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationPhoto',
			DefaultInputExtensions: [ 'ObservationPhoto' ],
			Template: /*HTML*/`
			<!-- InputType ObservationPhoto {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<!-- dynamically filled with the photo, if the record has one -->
					<div id="PHOTO-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}" class="mb-2 is-hidden"></div>
					<div {~D:Record.Macro.ControlAttr~} id="PHOTO-CONTROLS-FOR-{~D:Record.Macro.RawHTMLID~}" class="field is-grouped">
						<div class="control file is-link is-small">
							<label class="file-label">
								<input
									id="PHOTO-FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="file-input"
									type="file"
									accept="image/*"
									onchange="{~P~}.providers.ObservationPhoto.handlePhotoSelection('{~D:Record.Macro.RawHTMLID~}');"
								/>
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-camera" aria-hidden="true"></i>
									</span>
									<span id="PHOTO-ADD-LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" class="file-label">Add photo</span>
								</span>
							</label>
						</div>
						<div class="control">
							<button id="PHOTO-REMOVE-FOR-{~D:Record.Macro.RawHTMLID~}" type="button" class="button is-small is-danger is-light is-hidden" onclick="{~P~}.providers.ObservationPhoto.handleRemovePhoto('{~D:Record.Macro.RawHTMLID~}');">
								<span class="icon">
									<i class="fas fa-trash" aria-hidden="true"></i>
								</span>
								<span>Remove photo</span>
							</button>
						</div>
					</div>
					<p id="PHOTO-STATUS-FOR-{~D:Record.Macro.RawHTMLID~}" class="help is-hidden" role="status"></p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationPhoto',
			DefaultInputExtensions: [ 'ObservationPhoto' ],
			Template: /*HTML*/`
			<!-- InputType ObservationPhoto {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<!-- dynamically filled with the photo, or "No photo." -->
					<div id="PHOTO-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}">
						<div class="input is-static has-text-text-60"><em>No photo.</em></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],227:[function(require,module,exports){
// The ObservationSet InputType now routes through the ObservationCardDeck template and provider.
// The CardDeck's patchedConfiguration.ObservationStandardSet applies the correct settings
// (useObservationSet: true, useObservationSetSelector: true) automatically when this InputType is detected.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationSet',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ObservationSet; Applied InputType: ObservationCardDeck -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-ObservationCardDeck~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],228:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeSelector' ],
			Template: /*HTML*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="OBSERVATIONTYPE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="OBSERVATIONTYPE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select an observation type...</option>
						</select>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		// TODO: Build missing template for Tabular mode
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="OBSERVATIONTYPE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="OBSERVATIONTYPE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ObservationTypeSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="OBSERVATIONTYPE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-ObservationTypeSelector`,
			DefaultInputExtensions: [ 'ObservationTypeDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ObservationTypeSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="OBSERVATIONTYPE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ObservationTypeSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],229:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "Option" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "Option" in the manifest -- no manifest edit is needed;
	the broker maps its static SelectOptions / SelectOptionsPickList onto the picker, and
	PickerDisplay resolves the same option label for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Option; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Option',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Option; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Option',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],230:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="tel"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-phone fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="tel"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-phone fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="tel"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-phone fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="tel"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-phone fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="tel"
									class="input"
									readonly aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-phone fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="tel"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-phone fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- DataType PhoneNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],231:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetSelector' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<span class="control-status-icon"></span>
								<select
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									{~Required:Record~}
									{~Disabled:Record~}
									onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
								>
									<option value="">Select an asset type...</option>
								</select>
							</p>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<span class="control-status-icon"></span>
								<select
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
								>
									<option value="">Select an asset...</option>
								</select>
							</p>
						</div>
					</div>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetDisplay' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									class="input"
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
								></div>
							</p>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
								></div>
							</p>
						</div>
					</div>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetDisplay' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<div class="control">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									class="input is-static"
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<div class="control">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],232:[function(require,module,exports){
// Themed metatemplates for InputType 'Picker' (pict-section-picker via the Headlight Picker provider).
// Mirrors InputType-EntitySelectorMultiple.js's Bulma chrome (column / field / label / help) so the
// picker inherits Headlight's form styling + the row's flex alignment — only the control differs: a
// host element the picker renders into, where the <select> used to be.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
			<!-- InputType Picker {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.Picker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
			<!-- InputType Picker {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<div class="field">
							<p class="control control-status">
								<span class="control-status-icon"></span>
								<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			// Tabular (one picker per RecordSet row). Split Begin/End so the row's informary attributes
			// inject into the hidden input; the picker provider mounts into the PICKER-TABULAR host below.
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							{~Required:Record~}
							data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
							value="" />
						<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
							title="Show all (ignore filters)"
							onclick="_Pict.providers.Picker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
							<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
						</a>
						<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~} data-i-index="{~D:Context[2].Key~}"></span>
					</p>
				</div>`,
		},
	],
	/* READ THEME — locked / non-interactive in-browser state. A static resolved-value display painted by
	   the PickerDisplay provider (not the interactive picker), styled as a locked control. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType Picker (read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- InputType Picker (read display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-3">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="field">
								<p class="control">
									<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
								</p>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control">
						<div
							id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}
							disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			Template: /*HTML-Partial*/`
						></div>
					</p>
				</div>`,
		},
	],
	/* PRINT THEME — non-interactive PDF. Same resolved value, painted by PickerDisplay into a static node
	   styled for PDF output (independent of the Read theme's locked-control look). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType Picker (print display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- InputType Picker (print display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular print display) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div
					id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static wrap-selections-for-print"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],233:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "PlantSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (ProductionPlant) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "PlantSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: PlantSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PlantSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],234:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input {~ColumnAlignment:Record~} pr-3"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							disabled
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input {~ColumnAlignment:Record~} pr-3"
									{~D:Record.Macro.ControlAttr~}
									type="text"
									tabindex="-1"
									readonly
									disabled
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input {~ColumnAlignment:Record~} pr-3"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						type="text"
						tabindex="-1"
						readonly
						disabled
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input {~ColumnAlignment:Record~} pr-3"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							disabled
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<input
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~} pr-3"
									{~D:Record.Macro.ControlAttr~}
									tabindex="-1"
									readonly
									disabled
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input {~ColumnAlignment:Record~} pr-3"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						type="text"
						tabindex="-1"
						readonly
						disabled
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							value=""
						/>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<div
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						class="input is-static {~ColumnAlignment:Record~}"
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],235:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`
			<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="PREVIOUS-VALUE-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
			 />
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
			 />
			<div class="column {~ColumnWidth:Record~}" id="PARENT-FOR-{~D:Record.Macro.RawHTMLID~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-checkbox-with-label pb-3 mb-0 has-addons has-addons-right {~ColumnAlignment:Record~}">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							style="padding-right: 40px;"
							disabled="disabled"
							placeholder="{~Placeholder:Record~}"
							autocomplete="off"
							value=""
						></div>
					</p>
					<p class="control">
						<button
							id="CLEAR-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-ghost"
							type="button"
							style="position: absolute; right: 0; width: 40px; visiblity: hidden;"
							onclick="
								const ele = {~P~}.ContentAssignment.getElement('#{~D:Record.Macro.RawHTMLID~}')[0];
								if (ele)
								{
									ele.value = '';
									{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}');
								}"
						>
							<span class="icon">
								<i class="fa fa-fw fa-times"></i>
							</span>
						</button>
					</p>
					<p class="control">
						<button
							id="EDIT-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-link"
							type="button"
							onclick="{~P~}.views.HeadlightPaneObservations.selectObservations({
								SingleSelect: true,
								FileType: 'application/pdf',
								UIFocusViewHash: '{~D:Record.Hash~}',
								UIFocusInputName: 'Precompiled PDF',
								SearchActionLabel: 'Select'
							},
							(obsInfos) =>
							{
								if (obsInfos.length > 0)
								{
									const ele = {~P~}.ContentAssignment.getElement('#{~D:Record.Macro.RawHTMLID~}')[0];
									if (ele)
									{
										ele.value = obsInfos[0].IDObservation;
										{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}');
									}
								}
							})"
						>
							<span class="icon">
								<i class="fa fa-fw fa-paperclip"></i>
							</span>
							<span>Attach PDF</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`
			<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="PREVIOUS-VALUE-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
			 />
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
			 />
			<div class="column {~ColumnWidth:Record~}" id="PARENT-FOR-{~D:Record.Macro.RawHTMLID~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-checkbox-with-label pb-2 mb-0 has-addons has-addons-right {~ColumnAlignment:Record~}">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							style="padding-right: 40px;"
							disabled="disabled"
							autocomplete="off"
							value=""
						></div>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} (does not print) -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],236:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "ProducerSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Organization) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "ProducerSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProducerSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProducerSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],237:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "ProductSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Product) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "ProductSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProductSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProductSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],238:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "ProjectSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach
	PickerDisplay. Every theme includes the matching Picker template by reference (single source of the
	picker markup).
	This is a SPECIALIZED selector: its Entity (Project) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "ProjectSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name (+ EntityTag badge) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: ProjectSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ProjectSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],239:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							{~D:Record.Macro.InputFullProperties~}
							readonly
							disabled
							tabindex="-1"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									{~D:Record.Macro.InputFullProperties~}
									readonly
									disabled
									tabindex="-1"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly
						disabled
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							class="input {~ColumnAlignment:Record~}"
							readonly
							aria-readonly="true"
							{~D:Record.Macro.InputFullProperties~}
							value=""
							tabindex="-1"
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									class="input {~ColumnAlignment:Record~}"
									readonly
									aria-readonly="true"
									{~D:Record.Macro.InputFullProperties~}
									value=""
									tabindex="-1"
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						class="input {~ColumnAlignment:Record~}"
						readonly
						aria-readonly="true"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						readonly
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],240:[function(require,module,exports){
// Headlight templates for the PSF `RichText` (markdown editor) InputType. Standard + Vertical across
// Edit/Read/Print; the shared builder and the {~EditorBody:~} macro own the presentation. Tabular is
// unsupported by design (the provider throws). See EditorTemplates.js / EditorBodies.js.
const { buildEditorTemplates } = require('./EditorTemplates.js');

module.exports = buildEditorTemplates('RichText');

},{"./EditorTemplates.js":180}],241:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleHiddenStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="SAMPLE-STATUS-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<input
				id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenStatusSelector',
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>
			<div
				style="display: none;"
				id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenStatusSelector',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],242:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleHiddenTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
				/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					class="input"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenTestResult',
			Template: /*HTML-Partial*/`
					value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleHiddenTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleHiddenTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display:none;"
				id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleHiddenTestResult',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],243:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select a sample...</option>
						</select>
					</p>
					<p class="control">
						<button class="button is-link" type="button" onclick="_Pict.views.HeadlightPaneSamples.openSamplePanelFromAdvancedButton(event)">
							<span class="icon is-small">
								<i class="fas fa-bars-filter"></i>
							</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleSelector',
			DefaultInputExtensions: [ 'SampleSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="SAMPLE-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleSelector',
			DefaultInputExtensions: [ 'SampleSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="SAMPLE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleSelector`,
			DefaultInputExtensions: [ 'SampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="SAMPLE-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],244:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-STATUS-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-STATUS-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="SAMPLE-STATUS-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleStatusSelector',
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-STATUS-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-STATUS-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-STATUS-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleStatusSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-STATUS-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleStatusSelector`,
			DefaultInputExtensions: [ 'SampleStatusSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleStatusSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="SAMPLE-STATUS-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleStatusSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],245:[function(require,module,exports){
// Themed metatemplates for InputType 'SampleTestAcceptance' — the unified test acceptance control.
// Mirrors InputType-Picker.js's Bulma chrome (column / field / label / help) since this IS a picker, and
// adds the Remarks disclosure that shows and hides the sibling RichText remarks field.
//
// Deliberately group-weight, not section-weight: this block closes out the test above it, so it carries
// no section header treatment. The "Test Results" heading it replaced is what read as a new test.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column test-acceptance-column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="is-flex is-align-items-flex-end">
						<p class="control control-status test-acceptance-result">
							<span class="control-status-icon"></span>
							<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
						</p>
						<a id="TEST-ACCEPTANCE-REMARKS-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
							class="button is-small is-ghost test-acceptance-remarks-toggle ml-2"
							title="Show or hide remarks"
							onclick="_Pict.providers.SampleTestAcceptance.toggleRemarks('{~D:Record.Hash~}')">
							<span class="icon"><i class="fas fa-fw fa-chevron-right"></i></span><span class="icon-text">Remarks</span>
						</a>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<div class="field">
							<div class="is-flex is-align-items-flex-end">
								<p class="control control-status test-acceptance-result">
									<span class="control-status-icon"></span>
									<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
								</p>
								<a id="TEST-ACCEPTANCE-REMARKS-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
									class="button is-small is-ghost test-acceptance-remarks-toggle ml-2"
									title="Show or hide remarks"
									onclick="_Pict.providers.SampleTestAcceptance.toggleRemarks('{~D:Record.Hash~}')">
									<span class="icon"><i class="fas fa-fw fa-chevron-right"></i></span><span class="icon-text">Remarks</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							{~Required:Record~}
							data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML-Partial*/`
							value="" />
						<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~} data-i-index="{~D:Context[2].Key~}"></span>
					</p>
				</div>`,
		},
	],
	/* READ THEME — locked in-browser state, painted by the PickerDisplay provider. The remarks field
	   renders through its own descriptor, so there is no disclosure here. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (read display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular read) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<p class="control">
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="PICKER-TABULAR-DISPLAY-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
				</p>`,
		},
	],
	/* PRINT THEME — non-interactive, for PDF documents. */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (print) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (print, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular print) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<p class="control">
					<input
						id="PICKER-TABULAR-DISPLAY-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input is-static"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
				</p>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],246:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<label for="SAMPLE-TEST-RESULT-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="SAMPLE-TEST-RESULT-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="SAMPLE-TEST-RESULT-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="SAMPLE-TEST-RESULT-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="SAMPLE-TEST-RESULT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="SAMPLE-TEST-RESULT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-SampleTestResult`,
			DefaultInputExtensions: [ 'SampleTestResult' ],
			Template: /*HTML-Partial*/`
			<!-- InputType SampleTestResult {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="SAMPLE-TEST-RESULT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestResult',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],247:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "SampleTypeSelector" input type now renders via
	the "Picker" stack across ALL themes. EDIT attaches the SampleTypePicker provider — the thin Picker
	subclass carrying this selector's SampleType<->legacy-MaterialType cascade (forward Hash mirror +
	reverse seed; see PictProvider-InputType-SampleTypePicker) — READ / PRINT attach PickerDisplay. Every
	theme includes the matching Picker template by reference (single source of the picker markup).
	This is a SPECIALIZED selector: its Entity (SampleType) is hardcoded in its provider, NOT the
	descriptor, so the broker infers it from the InputType via _SPECIALIZED_SELECTOR_MAP (see
	PictProvider-InputType-Picker). The field keeps InputType "SampleTypeSelector" in the manifest -- no manifest
	edit is needed; PickerDisplay resolves the entity name for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'SampleTypePicker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: SampleTypeSelector; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTypeSelector',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],248:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "Select2" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "Select2" in the manifest -- no manifest edit is needed;
	the broker maps its static SelectOptions / SelectOptionsPickList onto the picker, and
	PickerDisplay resolves the same option label for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],249:[function(require,module,exports){
/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "Select2Multiple" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "Select2Multiple" in the manifest -- no manifest edit is needed;
	the broker maps its static SelectOptions and infers multi-select from the InputType name;
	PickerDisplay resolves the option labels for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: Select2Multiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Select2Multiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],250:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded signature-preview-container">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							{~Disabled:Record~}
							data-validation-surface="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
							{~Disabled:Record~}
							onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
						/>
						<button
							type="button"
							class="button is-small is-link signature-edit-button"
							title="Edit Signature" aria-label="Edit signature"
							{~Disabled:Record~}
							onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
						>
							<span class="icon is-small"><i class="fas fa-pen"></i></span>
						</button>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status is-expanded signature-preview-container">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~Required:Record~}
									{~Disabled:Record~}
									data-validation-surface="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
									value=""
								/>
								<img
									id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="signature-preview-image" alt="Signature preview"
									{~Disabled:Record~}
									onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
								/>
								<button
									type="button"
									class="button is-small is-link signature-edit-button"
									title="Edit Signature" aria-label="Edit signature"
									{~Disabled:Record~}
									onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
								>
									<span class="icon is-small"><i class="fas fa-pen"></i></span>
								</button>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field mb-0">
				<p class="control control-status is-expanded signature-preview-container">
					<span class="control-status-icon"></span>
					<input
						id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						{~D:Record.Macro.InformaryTabular~}
						{~Required:Record~}
						{~Disabled:Record~}
						data-validation-surface="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
						value=""
					/>
					<img
						id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="signature-preview-image" alt="Signature preview"
						{~Disabled:Record~}
						onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~}, {~D:Record.PictForm.Disabled~});"
					/>
					<button
						type="button"
						class="button is-small is-link signature-edit-button"
						title="Edit Signature" aria-label="Edit signature"
						{~Disabled:Record~}
						onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~}, {~D:Record.PictForm.Disabled~});"
					>
						<span class="icon is-small"><i class="fas fa-pen"></i></span>
					</button>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						{~D:Record.Macro.InputFullProperties~}
						{~Required:Record~}
						{~Disabled:Record~}
						value=""
					/>
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control is-expanded">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
						/>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~Required:Record~}
							{~Disabled:Record~}
							value=""
						/>
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.InformaryTabular~}
					{~Required:Record~}
					{~Disabled:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
					value=""
				/>
				<img
					id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="signature-preview-image" alt="Signature preview"
				/>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						{~D:Record.Macro.InputFullProperties~}
						{~Required:Record~}
						{~Disabled:Record~}
						value=""
					/>
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control is-expanded">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image print-only-signature-preview" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~Required:Record~}
							{~Disabled:Record~}
							value=""
						/>
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image print-only-signature-preview" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="control is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.InformaryTabular~}
					{~Required:Record~}
					{~Disabled:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
					value=""
				/>
				<img
					id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="signature-preview-image print-only-signature-preview" alt="Signature preview"
				/>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],251:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<p class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<p class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<div class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],252:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							{~D:Record.Macro.InputFullProperties~}
							readonly
							tabindex="-1"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									{~D:Record.Macro.InputFullProperties~}
									readonly
									tabindex="-1"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="{~D:Record.DataType~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							readonly
							{~D:Record.Macro.InputFullProperties~}
							value=""
							tabindex="-1"
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="{~D:Record.DataType~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									readonly
									{~D:Record.Macro.InputFullProperties~}
									value=""
									tabindex="-1"
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="{~D:Record.DataType~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						readonly
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StaticText',
			Template: /*HTML*/`
			<!-- InputType StaticText {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						readonly
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticText',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],253:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="field has-addons has-addons-right mb-0">
						<p class="control control-status has-icons-left is-expanded">
							<span class="control-status-icon"></span>
							<input
								id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								type="text"
								class="input {~ColumnAlignment:Record~}"
								{~D:Record.Macro.ControlAttr~}
								{~Required:Record~}
								{~Disabled:Record~}
								placeholder="{~Placeholder:Record~}"
								onchange="{~D:Record.Macro.DataRequestFunction~}"
								autocomplete="off"
								value=""
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-sign-post fa-xs"></i>
							</span>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									autocomplete="off"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-sign-post fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						placeholder="{~Placeholder:Record~}"
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-sign-post fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-sign-post fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-sign-post fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="STATION-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<p class="control has-icons-left">
				<input
					id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input {~ColumnAlignment:Record~}"
					{~D:Record.Macro.ControlAttr~}
					readonly aria-readonly="true"
					{~D:Record.Macro.HTMLName~}
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-sign-post fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- DataType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="text"
				class="input {~ColumnAlignment:Record~}"
				readonly aria-readonly="true"
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static {~ColumnAlignment:Record~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],254:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-building fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-building fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-building fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StreetAddress',
			Template: /*HTML*/`
			<!-- InputType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-building fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									{~D:Record.Macro.InputChangeHandler~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-building fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
			<!-- InputType StreetAddress  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-building fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StreetAddress',
			Template: /*HTML*/`
			<!-- DataType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-StreetAddress',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
			<!-- InputType StreetAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StreetAddress',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],255:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="column px-0 {~ColumnWidth:Record~}">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 >
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabGroupName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="column px-0 {~ColumnWidth:Record~}">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 />
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabGroupName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<input
				class="pict-tab-group-print-host"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			 >
			<!-- NOTE: Intentionally empty in PRINT mode. The marker class lets the provider's CSS
			     collapse the host group, which would otherwise reserve an empty band in the PDF. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],256:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabSectionSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="container">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 />
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabSectionName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabSectionSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="container">
				<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabSectionName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabSectionSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<input
				class="pict-tab-group-print-host"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			 />
			<!-- NOTE: Intentionally empty in PRINT mode. The marker class lets the provider's CSS
			     collapse the host group, which would otherwise reserve an empty band in the PDF. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabSectionSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],257:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup', {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				 	type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}
					`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
					value="">
				<div
					id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
				></div>
			</p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
									readonly
									value=""
								></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
					value="">
				<div
					id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value="">
							<div
								id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
								{~D:Record.Macro.ControlAttr~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
				value="">
			<div
				id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],258:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<textarea
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							rows="2"
							{~Required:Record~}
							{~Disabled:Record~}
							{~MinLength:Record~}
							{~MaxLength:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
						></textarea>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML*/`
				<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-3">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="field">
								<p class="control control-status">
									<span class="control-status-icon"></span>
									<textarea
										id="{~D:Record.Macro.RawHTMLID~}"
										class="textarea"
										{~D:Record.Macro.ControlAttr~}
										placeholder="{~Placeholder:Record~}"
										rows="2"
										{~Required:Record~}
										{~Disabled:Record~}
										{~MinLength:Record~}
										{~MaxLength:Record~}
										{~D:Record.Macro.InputFullProperties~}
										{~D:Record.Macro.InputChangeHandler~}
									></textarea>
								</p>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<textarea
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~MinLength:Record~}
						{~MaxLength:Record~}
						placeholder="{~Placeholder:Record~}"
						rows="2"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
					></textarea>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<textarea
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							rows="2"
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
						></textarea>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<textarea
									id="{~D:Record.Macro.RawHTMLID~}"
									class="textarea"
									{~D:Record.Macro.ControlAttr~}
									rows="2"
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
								></textarea>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<textarea
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="textarea"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				rows="2"
				readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			></textarea>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<div
								id="{~D:Record.Macro.RawHTMLID~}"
								class="textarea is-static"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="textarea is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],259:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- InputType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							{~Min:Record~}
							{~Max:Record~}
							{~Step:Record~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~SelectOnFocus:Record~}
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help">{~D:Record.Description~}</p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber', 'NumberScrollLock' ],
			Template: /*HTML*/`
			<!-- DataType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									placeholder="{~Placeholder:Record~}"
									{~Min:Record~}
									{~Max:Record~}
									{~Step:Record~}
									{~Required:Record~}
									{~Disabled:Record~}
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~SelectOnFocus:Record~}
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber', 'NumberScrollLock' ],
			Template: /*HTML-Partial*/`
			<!-- InputType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status is-expanded">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						placeholder="{~Placeholder:Record~}"
						{~Min:Record~}
						{~Max:Record~}
						{~Step:Record~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						{~SelectOnFocus:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-UpdateAwareNumber',
			Template: /*HTML*/`
			<!-- InputType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="number"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber' ],
			Template: /*HTML*/`
			<!-- DataType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input cell pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="number"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
			<!-- UpdateAwareNumber Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="number"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-UpdateAwareNumber',
			Template: /*HTML*/`
			<!-- UpdateAwareNumber Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-DataType-UpdateAwareNumber',
			DefaultInputExtensions: [ 'InputValidation', 'UpdateAwareNumber' ],
			Template: /*HTML*/`
			<!-- DataType UpdateAwareNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input cell pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
			<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-UpdateAwareNumber',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],260:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">
					<!-- Opt-in top add bar (Group.EntryControls.Position 'top'/'both'); renders nothing otherwise -->
					{~EntryAddBarTop:Record~}`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
					<div class="section-content has-text-right {~HideBottomEntryControls:Record~}" data-recordset-controls="add-set">
						{~EntryModeToggleButton:Record~}
						<button class="button is-link"
							id="RECORDSET-ADD-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
							data-max-sets="{~D:Record.MaximumRowCount~}"
							data-min-sets="{~D:Record.MinimumRowCount~}"
							type="button"
							onclick="_Pict.providers['Bulma-RecordSetControls'].handleAddEntryButtonClickEvents(event, '{~D:Context[0].Hash~}', '{~D:Record.GroupIndex~}');"
						>
							<span class="icon">
								<i class="fas fa-plus"></i>
							</span>
							<span>Add new set</span>
						</button>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			// Scroll anchor for "Finish and go to Record". Row-ExtraPrefix is the only
			// slot rendered against the {Value, Key, Group} row record, so it is the
			// only place Record.Key / Record.Group resolve.
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->
						<span class="recordset-entry-anchor is-sr-only" data-recordset-group-index="{~D:Record.Group~}" data-recordset-row-index="{~D:Record.Key~}"></span>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->
			<div class="PictSectionForm-RecordSet-Controls buttons is-right {~HideRecordSetControls:Record~}" data-recordset-controls="manage-set">
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('Delete', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-trash"></i>
					</span>
					<span>Delete</span>
				</a>
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('MoveUp', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-arrow-up"></i>
					</span>
					<span>Up</span>
				</a>
				<a class="button is-link" onclick="_Pict.providers['Bulma-RecordSetControls'].handleRecordSetMenuButtonEvent('MoveDown', '{~D:Context[0].Hash~}', {~D:Record.Group~},'{~D:Record.Key~}');">
					<span class="icon">
						<i class="fas fa-arrow-down"></i>
					</span>
					<span>Down</span>
				</a>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content" style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
							<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content" style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-RecordSetTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-RecordSetControls' ],
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~} {~ShowTitleInPDF:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-recordset-wrapper {~HideRecordSetControls:Record~}">`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Group-Postfix',
			Template: /*HTML*/`
			<!-- Form RecordSet Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				</div>
			</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Prefix',
			Template: /*HTML*/`
					<div class="RecordSetEntry section-content"  style="display: grid; border-bottom: 1px solid var(--bulma-border);">
					<!-- RecordSetTemplateRow-Prefix -->`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Prefix',
			Template: /*HTML*/`
						<div class="column {~ColumnWidth:Record~}">
							<!-- RecordSetTemplateCell-Prefix -->
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record~}</label>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Cell-Postfix',
			Template: /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>`,
		},
		{
			HashPostfix: '-RecordSetTemplate-Row-Postfix',
			Template: /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],261:[function(require,module,exports){
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-table-wrapper mb-2 {~HideTableControls:Record~}">
					<!-- Opt-in top add bar (Group.EntryControls.Position 'top'/'both'); renders nothing otherwise -->
					{~EntryAddBarTop:Record~}
					<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container"
						onscroll="_Pict.providers['Bulma-TableControls'].updateSliderFromScrollTableEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)">
						<table id="TABLE-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
							<thead>
								<tr>
									{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
									<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
									<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~} {~TabularHeaderAlignment:Record~}">
										<span class="label {~HideLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</span>
										{~UnitsTabularHeader:Record~}
									</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPostfix -->
									<th class="extra-table-column" data-table-controls="menu"></th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRowHeader-ExtraPostfix~}
								</tr>
							</thead>
							<tbody>`,
		},
		/*
		 * BEGIN Tabular Template Extra Header Rows
		 * Used for stacked/clustered headers (the Group's `Headers` config).
		 * Each entry in Headers is one ADDITIONAL header row stacked above the
		 * default column-name row. Cells carry { Label, ColumnSpan, CSSClass }.
		 */
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderRow-Prefix',
			'Template': /*HTML*/`
								<tr class="pict-tabular-extra-header-row">`,
		},
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderRow-Postfix',
			'Template': /*HTML*/`
								</tr>`,
		},
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderCell',
			'Template': /*HTML*/`
									<th colspan="{~D:Record.ColumnSpan~}" class="pict-tabular-extra-header-cell {~D:Record.CSSClass~}">{~D:Record.Label~}</th>`,
		},
		/*
		 * END Tabular Template Extra Header Rows
		 */

		/*
		 * BEGIN Tabular Template Row Label Columns
		 * Used for left-side label columns (the Group's `RowLabels` config).
		 * Header cell renders one <th> per RowLabels entry. Per-row cell renders
		 * one <td> per RowLabels entry; rowspans collapse consecutive equal
		 * values when `Cluster: true`. Skipped cells emit nothing (a real <td>
		 * upstream has already covered them via rowspan).
		 */
		{
			'HashPostfix': '-TabularTemplate-RowLabel-HeaderCell',
			'Template': /*HTML*/`
									<th class="pict-row-label-header">{~D:Record.Name~}</th>`,
		},
		{
			'HashPostfix': '-TabularTemplate-RowLabel-Cell',
			'Template': /*HTML*/`
									<td rowspan="{~D:Record.RowSpan~}" class="pict-row-label">{~D:Record.RenderedLabel~}</td>`,
		},
		{
			'HashPostfix': '-TabularTemplate-RowLabel-Cell-Skipped',
			'Template': ``,
		},
		/*
		 * END Tabular Template Row Label Columns
		 */

		/*
		 * BEGIN Entry-modal field cells
		 * Used ONLY by the opt-in "add in a dialog" flow
		 * (Group.EntryControls.Mode === 'modal'), which composes a stacked,
		 * labeled one-record template out of the SAME tabular input
		 * metatemplates the grid uses -- see
		 * PictProvider-Bulma-TableControls.buildModalRowTemplate. The grid's own
		 * cell templates emit bare <td>s, which are invalid inside the modal's
		 * <div> and carry no labels (those live in the <th>s), so they cannot be
		 * reused directly the way the RecordSet layout's can.
		 *
		 * NOTE: deliberately no {~D:Record.Macro.HTMLForID~}. That macro resolves
		 * to an id tabular inputs never emit (they use
		 * TABULAR-DATA-{RawHTMLID}-{Key}), so a `for` attribute would dangle.
		 */
		{
			HashPostfix: '-TabularTemplate-ModalCell-Prefix',
			Template: /*HTML*/`
					<div class="column {~EntryModalCellClass:Record~}">
						<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</label>
						{~UnitsTabularHeader:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-ModalCell-Postfix',
			Template: /*HTML*/`
						<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
					</div>`,
		},
		/*
		 * END Entry-modal field cells
		 */

		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
								<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
									{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
									<td  data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPostfix -->
									<td class="extra-table-column" data-table-controls="menu">
										<button
											id="TABLE-MENU-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Group~}-{~D:Record.Key~}"
											class="button is-link is-outlined"
											type="button"
											aria-haspopup="true"
											aria-label="Row actions"
											onmouseover="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '{~D:Context[0].UUID~}', '{~D:Context[0].Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}', event)"
											onclick="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '{~D:Context[0].UUID~}', '{~D:Context[0].Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}', event)">
											<span class="icon is-small">
												<i class="fas fa-ellipsis" aria-hidden="true"></i>
											</span>
										</button>
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix-TableMenu',
			Template: /*HTML*/`
				<!-- TabularTemplate-RowHeader-ExtraPostfix-TableMenu -->
				<ul class="list-menu">
					<li class="list-menu-item">
						<a class="delete-table-row-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('Delete', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-trash" aria-hidden="true"></i>
							</span>
							<span>Delete</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a class="move-table-row-up-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('MoveUp', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-arrow-up" aria-hidden="true"></i>
							</span>
							<span>Move Up</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a class="move-table-row-down-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('MoveDown', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-arrow-down" aria-hidden="true"></i>
							</span>
							<span>Move Down</span>
						</a>
					</li>
				</ul>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRow-ExtraPostfix~}
								</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
								<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
								<!-- empty message row - auto hidden by CSS -->
								<tr class="table-emtpy-row">
									<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
										<span class="icon">
											<i class="fa fa-fw fa-info-circle"></i>
										</span>
										<span class="icon-text">{~TabularEmptyMessage:Record:No rows have been added.~}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- NOTE: Columns are required here for the flexible scroll slider and add button -->
					<div class="columns is-vcentered is-mobile p-0 m-0 {~HideBottomEntryControls:Record~}">
						<div class="column ml-6 p-0 mb-3">
							<div id="TABLE-SLIDER-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="field is-hidden" data-table-controls="scroll-slider">
								<input
									id="TABLE-SLIDER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
									class="slider"
									type="range"
									min="0"
									max="100"
									value="0"
									oninput="_Pict.providers['Bulma-TableControls'].updateScrollTableFromSliderEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)"
									/>
							</div>
						</div>
						<div class="column mx-3 px-0 pt-0 has-text-right is-narrow">
							<button type="button" id="TABLE-TOGGLE-EXTRA-COLUMN-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
								data-table-controls="toggle-extra-column"
								class="button is-link is-outlined mr-2 {~HideMenuColumnToggle:Record~}"
								onclick="_Pict.providers['Bulma-TableControls'].handleToggleExtraColumnButtonClickEvents(event, '{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}')">
								<span class="icon">
									<i class="fas fa-eye" aria-hidden="true"></i>
								</span>
								<span> Hide Menu Column</span>
							</button>
							{~EntryModeToggleButton:Record~}
							<button type="button" id="TABLE-ADD-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
								data-table-controls="add-row"
								data-max-rows="{~D:Record.MaximumRowCount~}"
								data-min-rows="{~D:Record.MinimumRowCount~}"
								class="button is-link"
								onclick="_Pict.providers['Bulma-TableControls'].handleAddEntryButtonClickEvents(event, '{~D:Context[0].Hash~}', '{~D:Record.GroupIndex~}')">
								<span class="icon">
									<i class="fas fa-plus" aria-hidden="true"></i>
								</span>
								<span> Add new row</span>
							</button>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-table-wrapper mb-2 {~HideTableControls:Record~}">
					<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container"
						onscroll="_Pict.providers['Bulma-TableControls'].updateSliderFromScrollTableEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)">
						<table id="TABLE-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
							<thead>
								<tr>
									{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
									<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
									<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~} {~TabularHeaderAlignment:Record~}">
										<span class="label {~HideLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</span>
										{~UnitsTabularHeader:Record~}
									</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRowHeader-ExtraPostfix~}
								</tr>
							</thead>
							<tbody>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
								<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
									{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
									<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRow-ExtraPostfix~}
								</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
								<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
								<!-- empty message row - auto hidden by CSS -->
								<tr class="table-emtpy-row">
									<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
										<span class="icon">
											<i class="fa fa-fw fa-info-circle"></i>
										</span>
										<span class="icon-text">{~TabularEmptyMessage:Record:No data available.~}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- NOTE: Columns are required here for the flexible scroll slider and add button -->
					<div class="columns is-vcentered is-mobile m-0 p-0">
						<div class="column ml-6 p-0 mb-3">
							<div id="TABLE-SLIDER-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="field is-hidden">
								<input
									id="TABLE-SLIDER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
									class="slider"
									type="range"
									min="0"
									max="100"
									value="0"
									oninput="_Pict.providers['Bulma-TableControls'].updateTableControlsFromSliderEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)"
									/>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~} {~ShowTitleInPDF:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<!-- NOTE: We preserve the overflow behavior of the table container to prevent PDFs from becoming distorted - wide tables will need to provide an alternate print layout -->
				<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container mb-2">
					<table class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
						<thead>
							<tr>
								{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
								<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
								<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~} {~TabularHeaderAlignment:Record~}" style="vertical-align: bottom">
									<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
									{~UnitsTabularHeader:Record~}
								</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
								<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
								<!-- TabularTemplateRowHeader-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
								{~T:TabularTemplateRowHeader-ExtraPostfix~}
							</tr>
						</thead>
						<tbody>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
							<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
								{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
								<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="is-vcentered {~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
								</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
								<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
								<!-- TabularTemplateRow-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
								{~T:TabularTemplateRow-ExtraPostfix~}
							</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
							<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
							<!-- empty message row - auto hidden by CSS -->
							<tr class="table-emtpy-row">
								<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text">{~TabularEmptyMessage:Record:No data available.~}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;

},{}],262:[function(require,module,exports){
// TODO: Remove the need for this file by scanning the templates directory
// and generating the index automatically.

module.exports = [
	/* require('./_empty.js'), */
	require('./DataType-Date.js'),
	require('./DataType-DateTime.js'),
	require('./DataType-Default.js'),
	require('./DataType-Number.js'),
	require('./DataType-PreciseNumber.js'),
	require('./DataType-String.js'),
	require('./DataType-Time.js'),
	require('./Form-Container.js'),
	require('./InputType-Boolean.js'),
	require('./InputType-BridgeSelector.js'),
	require('./InputType-Color.js'),
	require('./InputType-Chart.js'),
	require('./InputType-EmailAddress.js'),
	require('./InputType-EntityDisplay.js'),
	require('./InputType-EntitySelector.js'),
	require('./InputType-EntitySelectorMultiple.js'),
	require('./InputType-FileSelector.js'),
	require('./InputType-ObservationPhoto.js'),
	require('./InputType-GeolocationSelector.js'),
	require('./InputType-GeolocationSelectorWithMap.js'),
	require('./InputType-CloneAction.js'),
	require('./InputType-Diagram.js'),
	require('./InputType-HTML.js'),
	require('./InputType-LabSelector.js'),
	require('./InputType-Link.js'),
	require('./InputType-LineItemSelector.js'),
	require('./InputType-Markdown.js'),
	require('./InputType-MarkdownDisplay.js'),
	require('./InputType-MaterialSelector.js'),
	require('./InputType-MaterialsEntitySelector.js'),
	require('./InputType-SampleTypeSelector.js'),
	require('./InputType-MaterialsHiddenSampleSelector.js'),
	require('./InputType-MaterialsHiddenTestInjector.js'),
	require('./InputType-MaterialsHiddenTestSelector.js'),
	require('./InputType-MaterialsHiddenLineItemSelector.js'),
	require('./InputType-MaterialsSampleSelector.js'),
	require('./InputType-MaterialsQRCodeDisplay.js'),
	require('./InputType-MaterialsTestInjector.js'),
	require('./InputType-MaterialsTestSectionRemover.js'),
	require('./InputType-MaterialsTestSelector.js'),
	require('./InputType-MaterialsLineItemSelector.js'),
	require('./InputType-MaterialsLabSelector.js'),
	require('./InputType-MaterialsTestLabSelector.js'),
	require('./InputType-MaterialsPlantSelector.js'),
	require('./InputType-MaterialsHiddenLabSelector.js'),
	require('./InputType-MediaDetailCards.js'),
	require('./InputType-MixSpecificationSelector.js'),
	require('./InputType-ObjectEditor.js'),
	require('./InputType-ObservationImageSet.js'),
	require('./InputType-ObservationSet.js'),
	require('./InputType-ObservationCardDeck.js'),
	require('./InputType-ObservationTypeSelector.js'),
	require('./InputType-Option.js'),
	require('./InputType-PhoneNumber.js'),
	require('./InputType-PhysicalAssetSelector.js'),
	require('./InputType-Picker.js'),
	require('./InputType-SampleTestAcceptance.js'),
	require('./InputType-PlantSelector.js'),
	require('./InputType-PreciseNumberReadOnly.js'),
	require('./InputType-PrecompiledFileSelector.js'),
	require('./InputType-ProducerSelector.js'),
	require('./InputType-ProductSelector.js'),
	require('./InputType-ProjectSelector.js'),
	require('./InputType-ReadOnly.js'),
	require('./InputType-RichText.js'),
	require('./InputType-SampleHiddenStatusSelector.js'),
	require('./InputType-SampleHiddenTestResult.js'),
	require('./InputType-SampleSelector.js'),
	require('./InputType-SampleStatusSelector.js'),
	require('./InputType-SampleTestResult.js'),
	require('./InputType-Select2.js'),
	require('./InputType-Select2Multiple.js'),
	require('./InputType-Signature.js'),
	require('./InputType-StaticLabel.js'),
	require('./InputType-StaticText.js'),
	require('./InputType-Station.js'),
	require('./InputType-StreetAddress.js'),
	require('./InputType-TabGroupSelector.js'),
	require('./InputType-TabSectionSelector.js'),
	require('./InputType-TextArea.js'),
	require('./InputType-UpdateAwareNumber.js'),
	require('./Recordset-Group.js'),
	require('./Tabular-Group.js'),

	// questionable templates that may not be used
	require('./InputType-ExistingDisabledByDefault.js'),
	require('./InputType-DocumentDate.js'),
	require('./InputType-TemplatedEntityLookup.js'),
];

},{"./DataType-Date.js":172,"./DataType-DateTime.js":173,"./DataType-Default.js":174,"./DataType-Number.js":175,"./DataType-PreciseNumber.js":176,"./DataType-String.js":177,"./DataType-Time.js":178,"./Form-Container.js":181,"./InputType-Boolean.js":184,"./InputType-BridgeSelector.js":185,"./InputType-Chart.js":186,"./InputType-CloneAction.js":187,"./InputType-Color.js":188,"./InputType-Diagram.js":189,"./InputType-DocumentDate.js":190,"./InputType-EmailAddress.js":191,"./InputType-EntityDisplay.js":192,"./InputType-EntitySelector.js":193,"./InputType-EntitySelectorMultiple.js":194,"./InputType-ExistingDisabledByDefault.js":195,"./InputType-FileSelector.js":196,"./InputType-GeolocationSelector.js":197,"./InputType-GeolocationSelectorWithMap.js":198,"./InputType-HTML.js":199,"./InputType-LabSelector.js":200,"./InputType-LineItemSelector.js":201,"./InputType-Link.js":202,"./InputType-Markdown.js":203,"./InputType-MarkdownDisplay.js":204,"./InputType-MaterialSelector.js":205,"./InputType-MaterialsEntitySelector.js":206,"./InputType-MaterialsHiddenLabSelector.js":207,"./InputType-MaterialsHiddenLineItemSelector.js":208,"./InputType-MaterialsHiddenSampleSelector.js":209,"./InputType-MaterialsHiddenTestInjector.js":210,"./InputType-MaterialsHiddenTestSelector.js":211,"./InputType-MaterialsLabSelector.js":212,"./InputType-MaterialsLineItemSelector.js":213,"./InputType-MaterialsPlantSelector.js":214,"./InputType-MaterialsQRCodeDisplay.js":215,"./InputType-MaterialsSampleSelector.js":216,"./InputType-MaterialsTestInjector.js":217,"./InputType-MaterialsTestLabSelector.js":218,"./InputType-MaterialsTestSectionRemover.js":219,"./InputType-MaterialsTestSelector.js":220,"./InputType-MediaDetailCards.js":221,"./InputType-MixSpecificationSelector.js":222,"./InputType-ObjectEditor.js":223,"./InputType-ObservationCardDeck.js":224,"./InputType-ObservationImageSet.js":225,"./InputType-ObservationPhoto.js":226,"./InputType-ObservationSet.js":227,"./InputType-ObservationTypeSelector.js":228,"./InputType-Option.js":229,"./InputType-PhoneNumber.js":230,"./InputType-PhysicalAssetSelector.js":231,"./InputType-Picker.js":232,"./InputType-PlantSelector.js":233,"./InputType-PreciseNumberReadOnly.js":234,"./InputType-PrecompiledFileSelector.js":235,"./InputType-ProducerSelector.js":236,"./InputType-ProductSelector.js":237,"./InputType-ProjectSelector.js":238,"./InputType-ReadOnly.js":239,"./InputType-RichText.js":240,"./InputType-SampleHiddenStatusSelector.js":241,"./InputType-SampleHiddenTestResult.js":242,"./InputType-SampleSelector.js":243,"./InputType-SampleStatusSelector.js":244,"./InputType-SampleTestAcceptance.js":245,"./InputType-SampleTestResult.js":246,"./InputType-SampleTypeSelector.js":247,"./InputType-Select2.js":248,"./InputType-Select2Multiple.js":249,"./InputType-Signature.js":250,"./InputType-StaticLabel.js":251,"./InputType-StaticText.js":252,"./InputType-Station.js":253,"./InputType-StreetAddress.js":254,"./InputType-TabGroupSelector.js":255,"./InputType-TabSectionSelector.js":256,"./InputType-TemplatedEntityLookup.js":257,"./InputType-TextArea.js":258,"./InputType-UpdateAwareNumber.js":259,"./Recordset-Group.js":260,"./Tabular-Group.js":261}],263:[function(require,module,exports){
// This is just a placeholder file for the 'Base' theme which is the Default Theme for all Pict templates.
// View source the file at `../../../../pict-section-form/source/providers/dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js`

module.exports = (
	{
		TemplatePrefix: 'Pict-MT-Base',
		Templates: [],
	}
);

},{}],264:[function(require,module,exports){
// This is just a placeholder file for the 'Edit' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Edit theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Edit',
		Templates: [],
	}
);

},{}],265:[function(require,module,exports){
// This is just a placeholder file for the 'Print' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Print theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Print',
		Templates: [],
	}
);

},{}],266:[function(require,module,exports){
// This is just a placeholder file for the 'Read' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Read theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Read',
		Templates: [],
	}
);

},{}],267:[function(require,module,exports){
/* eslint-disable quotes */
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('headlight-configurable-application').Fable} Fable */

const libPictView = require('pict-view');

// Static image assets inlined as data URIs so they work in both online
// and offline (iOS WKWebView) contexts without relying on relative paths
// that single-file capture can't resolve for dynamically-rendered templates.
//TODO: this is to support offline but is a bit hard to support - see if we can make this more robust
const HASHES_PNG_DATA_URI = 'data:image/png;base64,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';
const LOGO_GRAY_PNG_DATA_URI = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAADVoAAAJyCAMAAAC4gmpFAAAACXBIWXMAAAsSAAALEgHS3X78AAAAM1BMVEVHcExUVltUVltUVltUVltUVltUVltUVltUVltUVltUVltUVltUVltUVltUVltUVltUVlsicckWAAAAEHRSTlMAoCDQ8BBgQIDAMOBQsJBwxX5mXwAAPbpJREFUGBnswYtiokgCQNFLQYkxOJn//8pNS4yIwna6Z6ZfiREtfN5zMo4V4rRppoSIblkDPUXbIEmSJOlPGUeYxS/TEt2VNrR91yJJkiTpZxkHmsXutUL3afHYNS2SJEmS/pVxiOplFtF924ZFhyRJkqRvMgYr13mFBIu8b5EkSZIEGcPEPI9I/3qeNEiSJEnKGGL2+oT0i7ZdI0mSJN27jP2VoUT6Q7vdtkiSJEl3LWNfZSiR3lUX2xZJkiTpjmXsJ5Ql0ofado0kSZJ0vzL2ER8C0k6LokGSJEm6V4E9TPqAtNv8IYtIkiRJdyrjU6EskfZQT2skSZKku5TzmafNDGkfkxD7DkmSJOkOBXaL86xC2lPeV0iSJEl3KGOnclshDdF9QZIkSbo7Bbs8ZUjDhDy0SJIkSXcm8LGYZUhDzfsZkiRJ0p3J+FDs5kgHqMMaSZIk6a5kfGSWRaTD9M9IkiRJ9yTwgdk6Ih0oy5AkSZLuSc77ZusK6WDTBkmSJOmO5Lxrtq6QjjBtkCRJku5Hzntm6wrpKNMGSZIk6W7kvGO2rpCONG2QJEmS7kXOn2brCuloUzZIkiRJ9yHnD7F4QEqg6LZIkiRJdyHnd7F7QEoi9lskSZKkexD43WaOlMg2IEmSJN2DjN88ZUjJLEKLJEmSdPsCvyozpHTmGyRJkqQ7kPOL2E2QEpp2WyRJkqSbF/jFtEJKqpshSZIk3byMnz1lSIkttkiSJEm3LucnYTNBSqxkgyRJknTjcn4ynSElV4QWSZIk6bYV/FAVSCPokSRJkm5czn/iZoI0gqLbIkmSJN20gv88BKRRdLFFkiRJumWBf4WANI4qR5IkSbppgX89Io1lGpAkSZJuWeAfZY40mh5JkiTplgX+EZDG8xSQJEmSbljgu7JEGlGPJEmSdMMC302QxvQUkCRJkm5X4JuQI42qR5IkSbpdgW96pHHlEUmSJOlmBd7EHGlc1QxJkiTpZhW8mWVII9sgSZIk3aycN0WONLK83yJJkiTdqMBXs4g0ujWSJEnSrQp8VSCNL0eSJEm6VTlfFTnS6CbFGkmSJOk2BWAWkU7gBUmSJOlGBaBAOoUcSZIk6UblQJEjncCkWCNJkiTdpAAhIp1EQJIkSbpNAeZIp/GCJEmSdJsCdEinMY9IkiRJNynAK9KJlEiSJEk3KRAqpBMJSJIkSTcpUCCdSoskSZJ0kwIB6VRKJEmSpJsUyJBOZoYkSZJ0iwIt0skEJEmSpFtUxEekk9kgSZIk3aIQkE6nQZIkSbpFISKdzhRJkiTpFoUN0ukEJEmSpFsUkE4oIkmSJN2ikCFJkiRJOk5AOqUSSZIk6QYFJEmSJElHCmskSZIkSccJcyRJkiRJxwlIkiRJko4UkE6pR5IkSbpBAemUApIkSdINCkiSJEmSjhSQJEmSJB0pIEmSJEk6UkCSJEmSdKSAJEmSJOlIAUmSJEnSkQKSJEmSpCMFJEmSJElHCkiSJEmSjhSQJEmSJB0pIEmSJEk6UkCSJEmSdKSAJEmSJOlIAUmSJEnSkQKSJEmSpCMFJEmSJElHCkiSJEmSjhSQJEmSJB0pIEmSJEk6UkCSJEmSdKSAJEmSJOlIAUmSJEnSkQKSJEmSpCMFJEmSJElHCkiSJEmSjhSQJEmSJB0pIEmSJEk6UkCSJEmSdKSAJEmSJOlIAUmSJEnSkQKSJEmSpCMFJEmSJElHCkiSJEmSjhSQJEmSJB0pIEmSJEk6UkCSJEmSdKSAJEmSJOlIAUmSJEnSkQKSJEmSpCMFJEmSJElHCkiSJEmSjhSQJEmSJB2pQOfX8IcSSZIkSdejQKdWR+ihXAFdy/tegRiIG+ImRMa1bYk5kiRJkg6W/Y1Ooe2I63JFvuQAs7CJXWQcTdMBs2bOKaxWSJIkSbcn+xuNqO1WZbmiazleLMM2ktxzz3fZEyewWiFJkiTdnuxvNILFJK6LtmtJbFZsI0k99/wre2J8qxWSJEnS7cn+RgnVcVUWbdcynklXkc5iy39iN2d0qxWSJEnS7SlQEnVclUXbsGHFuNZxMSeVuueHdoYkSZKkg+RTdKQmsFpvNmzWW06hy9oJicQVP2kpGNtmgyRJknR7CnS4OvZFt+SV0+oKEmlf+MW2jUiSJEkarkAHqWNfLLsNZ7HOS5LY8Ks2i0iSJEkarkCDNbFbdhvOaEsSTcNv1jEiSZIkabACDdEu/2qXvHJm6xhJYMsf2ogkSZKkwQq0ryZ2Tcszl6AggXbNH9ZdhSRJkqShCrSHOvZ9wysXY/EXxyt4R4EkSZKkwQL6RL3t15vXVcMl6RYcb8k71kiSJEkarEA71A+h3Sy4QBVHe+55R7fNkSRJkjRQPkUfaPK2WTctF6ktOVax5l2RMW02SJIkSbenQO9ZxL7hlcvVtZHjtC+8a91VSJIkSRqmQL9rl4/NdsuFyzlSzge2SJIkSRqoQL/YhkVHzeXrAsfZ8IFHJEmSJA1UoP+0eVdzLZqCo7RLPlAXFdevfODiNa+866Hk4r02SDqBv7lazSuSdGcK9N02LDquSLuYc4ycD22RJEmSNEyBoN4+Ni1XpuMoHR+KSJIkSRqm4O61+WZDzdWJHKPe8KEeSZIkScME7tui//LyZck1KjjGAx9rF0iSJEkapOCObZtN98y1Wk44QsMOEUmSJEmDFNyrbdO3XLWm5HAbdghIkiRJGqTgLm2bvuXaRQ7XduywXFdIkiRJGqDg/mybvuUGrGYcbMlOD0iSJEkaouDObJu+5TZkHC6u2SUgSZIkaYjAPVn0XxbrlhvRcLgNO7VIkiRJGiJwN9rVl+1zxw1ZcKi2Y6dljSRJkqQBCu5DvX1YcmtmHGrJJx6QJEmSNEDgHmw3m37JzWk5VOQTLZIkSZIGKLh5i2rZcpM6DlWs2a1HkiRJ0gAFt63ePmyfuVEZB6o3fKJ5QJIkSdL+AresWW76JTer4UCRTy2QJEmStL/Azaq7L69rblrNYXo+9YgkSZKk/QVuVLPcfOm4cZHD9HxqhSRJkqT9BW5R3X15XXP7Vhym41MFkiRJkvZXcHsWefaFu1BykLblU8sJkiRJkvZWcGueJ9std6LgIIE9NCWSJEmS9lVwU+pi3TfcjbbgEC17iEiSJEnaW+CGLJabVccdaThIzx5WSJIkSdpbwc3YrrdbtIeOPRRIkiRJ2lvBbai3Wcf9aUqGqzfsYTlBkiRJ0r4Ct6BeZX2H9hPZywJJkiRJ+yq4fm2brbhPPQfo2UuHJEmSpH0VXLu2XaMhOvZSIkmSJGlfBdetyV+4YwUHyNhLjyRJkqR9FVyzpmu4a23BcA17aR+QJEmStKeC69V0DXeufWCwlv10SJIkSdpXwbVquoa71zFcx56aEkmSJEn7CVyn5vW1QdQM1rOnFZIkSZL2VHCNmq5BbyKDdeypRJIkSdKeCq5Pm72ig2XsqUeSJEnSngquTduu0b96BmvYU44kSZKkPRVcl7pYoWPU7Gs5QZIkSdJ+Aldlla3QTzqGiuxtgSRJkqT9FFyR56xDv8gYasXeJkiSJEnaT+BqNK99h45VsrceSZIkSfspuBJt9or+0DFUz95KJEmSJO2n4CrUxbZFf2oZ0eoBSZIkSXsJXINtt2rRe2oGathbiyRJkqT9FFy+dtOgD0SGqdlfhyRJkqT9BC5dvXppUCqRARZIkiRJ2kvgwm27FfpYwTArBpggSZIkaS+Bi9ZuFh3aoWWYkgEikiRJkvYSuGTdukZJdQywRpIkSdJeCi7XolyiT3QMkzFAjyRJkqS9BC7WartEn8kYpkWSJElSeoELtVivUHodAzRIkiRJ2kvgMq22S7SHnEFaJEmSJI0gcIkW6xXay5JBOgZpkCRJkrSPwAVabZdoFCskSZIkjSBwcdr1Cu2tZoiSQSKSJEmS9hG4NM/rJdpfZIiSQdZIkiRJ2kfgstSbvkWjWTFIgSRJkqR9FFyURV+jEeUM0hZcq+6V/Twwkn7FJ3Lel73ymQdG8sp+OiSdwivDTDNG8spAOZJ0bwouyWqLBooMsWSQ9oFr1bKnB0ayajjQkk89MJIGSZekYaAHRtIgSfpE4HLUrys01JoRdUiSJEnaR+BiLLoGjathoBpJkiRJeyi4FN0WHaBkTBFJkiRJeyi4DHVYo0OsHtjfCkmSJEljCFyEdrJG4ysZKCJJkiRpD4FL0KyX6ARKBlojSZIkaQ+BC9C9tuhALQOsGKhEkiRJ0h4C57f8gg7WMaYVkiRJkvYQOLd6vUYn0iJJkiRpDIEzW0yW6FQ6BuqQJEmStIfAeS3CEh1lwYhaJEmSJO2h4KyeixYdZ8LeGgarKyRJ0h0p+aFB0v4Kzum5b9FFi0iSpNtW0gfihvWc3zzw1WJC0dJl+RJJuxScUd+jUyqQJEn6Rwx9iJuS73JK3jUHcr6a1LFou6xB0rsKzme5RseL7K1lsFWJJEm6NbPNtG0f+SpnfxXk8NB2fVcskfSbgrNZrlEC6ykjKpEkSbckFNO2ZEJZcqDIV5OmL5oWST8UnEkd1ujEOqTxTafcif9xjOmUK/I/jjKdclnqyHc9UK6g7dAN+ptL9D/OKcy/zCKUJFBCsXjsmpb9lA/sr3nlEA8lZ/U/fvc3Z9W88q6/uTOvDQebbTOIG3oo2oadCs6jnizRqWUM1iFJN6fiZw/wAG1HT5e1HdKNilk7izyR0pxQLB6bBukWxTK8zPkm503xsHjsmpaPFJxFPVmiNErGlCFJdyHyzQNttyr7fIl0U2axfmQccx6228emRbotVZbDnF/NCcW2WfO+gnOoJ0uUyOqBfbVIkj4RKYHJYtb2XYt0C2bFNjJnPBUU22aNdDNivin4QD7rinXHOwrOoJ4s0Rl0DNYhSXdpTg5taPsG6aqFahsJjC6fddtJg3QLYr6ZskPF9Llo+UPB6dWTJboSLZJ0vyI5D4vHrmmRrlLMtnMCp1FBUSxbpGv39DLlM0/1dMXvCk4vX6JzaJEkDTYnFIvYN0jXplw/clqRx+dJg3TNZk1W8Z+m77Ku5asY4iYr+VdFWy75VcHJLdcooY59dRygjUjS3ZvDdhv7FulqxCzGB07viU2+RrpaT9mEf9Tbx5r/tDTwWr3kFd/N6Vb8ouDUlmuUUsuoOiRJX1XAtulbpGsQquUjZzIntmukqxSnGf9o26yv+V3NZrmd890027T8pODElmt0JiskScfIZ2z7GunSzV7/ouJ8YoztGun6xC7nu7Zd84E1r5s535QhLvmh4LSee3Qu5YrhCiRJP+QUs80S6YKVYTLhzGKM7RrpysyyyDf14ws7NCy7ijexni35T+Cknnt0XVokST+rwuRhgnSpyoeHkgsQZ48l0lWZrSPfNN0zu62zLd9U6xn/KTilRY+Sa0okSadU0hXbFunylKHkUsQYmg7pasRmzjf9K59q28mMN1U9W/KPghNahC06nx5JUhoVPGcd0mUJ/QOXpCxXK6QrEbs5b+q8YR/rYl3xVbWILd8FTqcuW3RteiRJ73n6KwtIFyT+9dcTF2b6WCJdh82cN/WkYT/LyYI384J/FJxOvkSSpJvxxHPWIV2ISRe4PDGWry3S5ZvMeFNPlnwz6/lFXHdZwy+WcTHnq7Jf8U3BySzX6KxaJElJPfFctEgXoNzMuEyhmy2RLl3oeFNPlny3feBXU3jYNn3LD+2srvhqGpa8CZzK8xqNIrKnjgPkSJI+9tRPkc4u/vUw51LNJ09Il66seDNdsks+65/4yXLCNw3fBE5k0aNxrBnTEknSDtX0sUI6r2oSuGTZPCJdtKrkzarmE1X2EPlh2fNm/sSbwGnUPZIk3aJYPASk84nzInLZ8m6GdMl63ixWfK7sIj88b3nzEvkqcBrTDp3ZAknSKMowRTqXqs+5ePN1iXS5JpE3JfuYP/CTVc1XVc5XgZNY1ejcJhykRZL0iWqaz5DOIf5VVFyB6mGNdLEib1ZL9hICP7SPvNlEoOAUFls0mpJRdUiSPjWnWyGd3KwJXIknpEs1iXxVZ7xjteJNDOU28o+enzw/RqBatVBwAnWPxrN6QJJ0dtOs6ZBO6ymbIOlYW94UKz7W0jCd8l2+4Sdt5KscCJzAtEPnF5EkjagMFdIpxSxD0tHCnK/qLZ9YrfiuKvnJuuWrWEFgfNsaXYA1B1khSdpLVfyFdDqz7glJx6t4U7R8ZlXz3ZSftbx5gcDo2hW6YiWSpD2FPCKdSLWeIymBLW/WfG7Ldw0/63mTQ2B0mxZJku7CvJ8hncRTUSEpgRD5atHxuZL3tFu+qkoCY+saNKqc/XRIksZWTSZIJ5BlSEqi4E3F4RreZBSMrM7QuJYT9pJxkBJJ0gCz6RekkcWiRFIaLW9aDtfzJiMwsmmLrtoKSdIQIYtIo4pdiaREAl/VS/bQ8K52wVctgXFtayRJuitPXUQa0ayfIymVOV9F9hBzvuv5VcdXVSwYVd0hSdKdmS9iizSW2bpCUiqBNz17eAh81/GrkjchMKqiQ5eiQZJ0GvPJDGkks3WFpGQib0o+Nwl899zyq55vAmNqV+jatUiShorrGdIoZusKSamt+EyYz/hHxruygjFl6AQWc0bUIUkarKpnS6T0ZusKSQn17JRNeTN5mfOvruM3Od8UjKh5RScwQZJ0aap6tkRKbbaukJRSYKeS7+b8a7Hld8sJbwIjypAk6U5V6xlSYrN1haSzagIfCYzneYkuR4Mk6ZSq9Qwpqdm6QtJZrV5bPhIYT4ZuQY0k6RBVE5ESiusKSYkVDPD8ZcU7Sr4JjOa5Q7cgIkk6yLyLSMnErkJSai1vInuZdHysDIwmQ5KkuzbvkJLp5kgayYa9FLyr582qYCzPPTqNiCTpMs2fe6Q0sjmS0mse+KrhA6sVX5UPfBOnK94ReJMXjCXr0Wmsp+xhhSTp5J66L0gpTKecUsOqhC7jTQY0U9oK6QbVFRC27NKsn/hmEzr+lPFmWTCS5x5dlHKFJOnkwmSNdLyq4DTari/ahq9W/OIV/jfbZs20RLopka/m/2OnrK54U20X/KktgQUFI8l6dBtWJdIA655dphkJvJLaZs5prXs+9cApbNeMbd2zl2lGAq98LG6AjBA5oVmxRGfxyn42c463KBjVbFUxvsVjt+zYYQm8vs5i91pxibJXdlk/kcArA7zyoQcSeJ6wS04K/Yq9PJBAv2IvD6TT86aq2aWb8F1eNvxuNuGrjoJxPPfoRpRIQ3QNOz2QQENqD5xY1/CZipPoGsbWNezngQQaPtbwjxj6EJdzTmIdW3QODft5IIHJK2OKzZyR1dvYb7+wjyWwjvWci7NkpykpNAzQ8KEHEihXjG/VsJcHElg17OWBdAreBHZb5ZFviobfRd7EdWAcEyRJRwmcRJxxh9pmvVps//faP7eMruqQjjSdM6r6ebPp1y37Wz5vv/QLpBvQ8GbLJzK+i1N+V/NmQ2AUiwZJ0lG2nEbkfjXP/cuX5XPNuOZ/IR3lKWdMzTLrawbrnrdfuhrp2rVbvooVu9UN320Cvwpzvlp0BEaRo0tTIumqzCKnUXPfunW/ee1axhQqpCPMMkb0/OV13XKY7stmuUC6cg1vXvhExnfVI7/qeRMhMIZ6jU6nYB8rJF2VyInMA3ev+fKyfq4ZzyogHSxmjKZevfQdx1hvXxukq9bz5imw27Lju7zkZzHnzRoCY5ihE2qRdIPWnMocwbLfLBvGUmVIB9tERlKvslXLsZrX1wbpirXPvOn5xGvNdwU/yyu+ajoIjKFGt6NH0hnEklNZo2/Wr+tnRjKfIh2oemIkXbZqSaF53bRI12vCm6fAbu0j38UpP4QNb3IgMIJFhyTpKBknU0b03bL/8sw4piXSQeKKcTRfvrSkUr+saqRr1TS8KfnEc8t3m8B/Hiu+amsgMIIcSdJxWk4nQ//q+i/PjKKISIeYVoyh3rx2pLTqtkjXquNNWfGJDd9Vj/yrzHnT8lVgBD2SpOPknE6Jfuj6Lw0jiA9IB6hyxrDNahLrFpsa6To1DW9Wgd2aLd/lJd/FgjfNmq8K0tu2SHdvinSM8oGhtpuSw+SxRT90r3kfSS6UDdJQcVWRXj2tGUEdtznSVWpKvqoWfOLlL74rGr6Z5rzpeFOQXo8uUINOKntAOkLJYP2EQ2XoF3XMA8kVDdJQmyfSW/Q1o2jbp5cK6Qp1qylfzZ97dupWU76J0xVfTXPedA1vAsnVNZKk47wwWN1yqBb9qv3y2pJanCINVD6RXrftGMvzZIF0jVYL3jw9sdu25rtNACZT3rSvfFOQ3MMCnVTHqHIknVyYM9SWZRY5TL5Bv2m6kJPYdN0hDbIhveWaES3jNke6QmVd8VU2WfNNm/FNzy/acsU3Rd8wmfFN3/JNQXINOq2WUS0nSDq1OYMFWD5xmGpTo9+07VNGYuUr0hBPGanVkzWjatvpFOn6LCd8M3t45k234l0N/5nM+KZf8l1Bcj2SpON0OUMtIHKoF/Sn53JbkVSZ10j7iy8VibWTJWNbdV2FdHXWYcqbLOvZy1+Bb557/hFIrWmRJB0l5gy16GDDoXL0jqZbkFaPNMBDRWKL9ZLxrSc10vVZPfPNUx74XHwIfPPc869AahMkSccpGewR6BYcqJqhd3RhQVJxirS3EEhsEVpOYTmpka5P/8w38/DEZ6q+5Jvnnv8EUmuRJB3nhcE2fPXIoQr0njY0JLWJSPvqSWwRWk5jOVkgXZ/+mW+q7KFkl/BQVHzz3PNDQWL1BknScWYMVW/4qgscaIve1barJxKqVi3SfsoH0lqEllNZxsUc6er0fcY3JaFr+EDo/+IfXc9PAok9oIvUIOlqzCJDbXlTc6g4Q+/rt6S0CUj7CaRVh5bTacsa6fo8b2q+Kx8eJrynmv/1xHf18gs/CyQWkCQdp2OwR75pOFSHPrBakFDVI+2lLEmqnrSc0nJSI12fumv4RzkrskngZ7HKiiLnH4vJml8UJNYiSTpOO2Wohm96DtWiD7RxMSedpy8d0h4CaeVLTms5qyukq9O9Tl4qvquAOsZ1l0EfyELkiX/VxXbJrwrSqjfo5OqKMbURSacU5gy1bfkmcKj5lw69rw11RTo90h7KkqSWa05tOUG6Rs/x+Yn/VDDlHdtuxe8CaUV0epFRdUg6qYLBAt8taw41Rx/pJiT0FJA+NyGp5zWnt+6RrlHbf3lmt+Z10fGHgrR6JEnHKRlswT8eOFSNPrTczEhnskL6TMhJaVG0nMFz9oR0jTq+VMuKD9TbrOM9gbQKJEnHeWWotuMfgUPNI/rQ+pl0NhHpMz0p1WXLWRQLpOvUfdlsnmv+VD8vN33HuwJpLZEkHaWqGCrnXwsOlqGPFQuSqXKkT8QnUgpLzqMta6RrVfebdf/c1Pynee7Xm37NRwqSqjskSUcJDNbwr66NHKhcow+1M9LJkT6Rk9J2zbksn5Cu2BJe+V+IfJUvgWd2KUgqbpAkHWUbGKje8J/lEwfKY4s+tOympBIna6SdchKqM87neZ4jXbmuYT+BpCKSpKPMIkNt+eGRg2Voh9WCZHKknSaRhELLGa1qpHsRSGqNJOkokcEiPzQcrEW7lCRTBqRdchJq1pxT+4h0LwJJ9UiSjrJmsJ4f2gWHytEuy45kKqQdQklCDef13CDdiUBSObpQEUlXIZYM1bT85JFDVRXa5bUmlSXSDhUJdR1n1iDdiUBSS3Sh1ki6ChmDTfhZw8Fe0C7tI6lUE6SPbUmnfuXcug7pPgRSapEkHaVlsJafNRwsRzs9t6RSIn2oiqRTtJzda410FwIpdUiSjpIzVLvkFw2Hqkq0U0sqeUD6yAvptCvOry2Q7kIgpQKdQ0TSrSgrhsr51YSDlWindUsqc6SP5KTTcgm2NdI9KEipReewniLpONkrl6FksI5ftRMOtUW7tZFEaqQPVAXJtGsuQTtBugcFkiSWXIiXOQPVG361XFccKM6WaJd1jKQx/9IhvevliWQKLkNfV0i3L5BSiSTpCGHOUA/8bsvBCrRbSypzpPflJFMvuQxtgXQHAimt0A3qkXQqcwZr+F3kYC9ot74mkRrpXVVFMkXLhdjWSLcvIEm6GB2D9fxuw8HmAe3UzkhkHpDe80I6ay5Fu0W6fQFJ0qWIOUMtWn7XtRxsjnarSaVAek9OMtuOi/GAdPsCKeVIkg5XMljFn3IOVqPduoZESqR3zCqS6bkcywXSzQuktESSdLgXBmv5U8fB5gHttiWRV6R3dCTT1lyQHOnmBSRJl2LGUO2SPzUcrkC79SRSlUh/ykgm55L0SDcvIEm6ELPIUEve0S44WIl2a59JJEP6QyxJZsMlabdIt65AknQhOgZ7rHlH5GB5bNFOjyTSIv2hJJl2yUVZZ+yvQ7pCBZKkC9FOGarmPT2Hy9Bu9d+kMX9pkX4TSCbnsjRIty4gSboMYc5QW97V1BysRJ/YkkiJ9LsXktkg6bQCkqTLUDBYw/seONgr+kRDIhuk381JpV0i6bQCkqTLUDLYhvcFDlZVaLcNiWRIvylJJkfSiQUkSZfhlaEWHe9rOdwL2q1bkEaJ9JuMZDoknVhAknQRqoqhIh9YthwsR594JJEZ0q8iyTRIOrFASgFJ0oECgwU+suRgVYl260gkIv2qI5WmRdKJFaQUGyRJh9kGBqo3fCRyuLJBOzUFaXxBP3koOdZrw3WLkVR6JJ1agSTpEswiQ2350IbDbdFu7WJOEtNXpJ8FkinQSB6QPlAgSboEkcEeaz7SLeYcKs6WaKdH0ihfkX6WkUyDRlIifSCQUkSSdJg1gzV87JHDFWi3FYnMkH7WkErbIunUClLaIEkn8DfHWq24MLFkqG3Lx7rAwbZot4JEAtLPAqkEJJ1cgfSJDEnjyxgssEP9NweLoUO7LCeksUH62ZxUWqSP/Y+r9z8uUSClBknSQVoGW7BLw+HmaLeGNCLSTwLJ9Eg6uUBKU3QOEUlXL2eoRccuPYer0W6RNDZIP4kk0yLp5AIprdE5bJB07cqKoR7ZKXC4eUA7ZaRRIv1kSjIdkk4ukNIcSdIhSgbbsNOy5nBztNOKRCLSDw2pNEg6vUBSEUnSAV4Yql6y2wOH69BOLYkEpB8yUimQdHqBpAKSpOHCnKG2fCJwuDyiXToSiUhjaJF0egVJ9ehCTVbopBYTxlOiWzNnsLhmt8VfHC5DOy3mJLFB+qEklXKFpJMrSCqgC9Wi0ypeGU+Jbk2XM1TPJ7o2crByjXaZkMZkhTSCFZJOL5BUhiRpsJgzVNPymSWHy9FOkTRapP8EJF21QFIBSdJgJYNN+NQjR6jQLmuk5CLJNEg6vUBSEUnSYC8MtuBTDUd4Qbt0pBGQJN2KQFolkqShZgzVdnyqXXC4HO2SkUZE+s8USVctkNYUSdJAs8hQOXt45HBVhaTTakhlgaQzCKT1BUnSQB2DNeyh4QgB7dCRSEBKb4KkMwikNUOnt0bSVWsZqm7YQ8MRtmiHlkQi0r8mSLpqgbRiRCc3R9I1C3OG2rKXhsPFGZJOqkXSVQskVqJbE5A0qoLBInuZcIQCSZK0v0BiAd2aiKRRlQzWs5eWI2zRDg2SJP0ikNgLkqRBXhlq0bKXZc3hYkDjy5DSWyHpDAKJzSOSpAGqiqEq9rTlCHMkXacSSWcQSC1Dl6hE0oUKDNayp8gRaiRJ0t4CqbVIkgbYMlS7ZE8bjjAPSDqhNalMkHQGgdRyJEn7C5GhcvbVtRxhjqQTmpNKi6QzKEitWi+RJO1rzmAde8s5whpJ+t0kcD4rpAtWkFyBJGlv65KB6g176wKHKzctkvSrvOR8VkgXLJDcFp3WDEnXK5YM9cD+Go6RIUmS9hRILs7QSW0ZVUDSiDIGa9hfu+AIJZIkaU+B9Ap0SyKSRtQy2IYBIkfII5JOpkHSVStIb4skaU85g/3FyZQtkiRpL4H0YokuzwxJF2hWcclekHSFSiSdQWAEa3R5tki6QAUXLUeSJO0nMII8IknaxwsXraqQJEl7CYygypAk7SHMuWwvaFwl0ggCkk4vMIYtkqQ9zLlwMzSuFdIIIpJOLzCG+QydzpRRTZE0mo4LF2foXWuk1HokXbXAKF7R6TSMqkHSaHIuXYHeNUe6YFMknV5gFE8RXZgeSRen4uJtkXR9GiSdXmAcObowAUkX54WLF2doTB3SvzqSaZB0eoFxbJAkfWbG5YvoHTMSaZH+lZHMFEmnFxhHNUGStNsscvlq9I4t0iULSDq9gpHENboNEySNpOMKzL90aDQLpP+0D6QS0WhWpDFFN6dgJHGyRjehLZE0jnbKFZg/oz9kpDF5RfpXRzqzJRrJijSm6OYExhLRiWTso0HShYlzrsEajadA+qEmmcBNapAuWcFY4mSNLsj0FelmvHKslguQcRXKTYt+F0mjRfohkswGSSdXMJq4RpJG0XATSq5Dhv6wyZGSK0gmrpB0aoHRxAmSpI+9ch1K9IeWNHqkH1qSWXKTCqRLFhhPF9ENaJE0iqriOuQR/a5CSq8kmTk3qUW6ZIHxVDm6ARWSRhG4Fhn6TUkiDdIPK9IpkXRqgRFtAroYJZIuy5Zr0aLf9KRRI/2kJZ0pt6hDumSBEVU9OoEWSVcoRK5Fjn4TSCMi/aQjnY5blCFdssCYnko0vgpJV2jO1agq9KuMNFZIP2tIpkPSqQVGtUHXLiBpFGuuxwv6VSCNEulnK5KJgRvUIF2ywKjmT+jKRSSNIZZcjxz9IkbS6JF+VpJOgaQTC4zrJaALUSLpgmRckWqGfhZIpEX6WU86LbenQbpogXFVJZKkP7VckwL9LCONukP6WUc6ObenQLpogZGVFRpXRNIVyrkmW/SzjDQi0i/almSqGTenRbpogbGtIhpVYFRTJI1gVnFN4gz9pCWNiPSrQDodN6dDumiBsVVTdBEiB2mQNIKC69KhH2YVaayQftWSTsvNyZAuWmB0eYUuwQZJl+OF69KiHyKJbJB+1ZPOPHBrGqSLFhjfKiBJ+lmYc13mAf2nI426Q/pVQ0JzbkyLdNkC46tKdL0aJKU359rM0X9y0nhA+t2CdGpuTId02QInUE7ReHpGNUVSeh3Xpkb/qkikRfrdI+nMA7elR7psgVOYlmg0gf1kSLoYOddmHtE/XkikR/pdR0JzbkuBdNkCJ7GNSJL+VXF9MvSPGYk0SL9rSGjDbVkiXbbASVQFulIBScm9cH1K9N0skkaD9Id2QTqx5JbUHdJlC5xGOUVntuYgEUnJzbg+eUTfFCTSI/3pkYTW3JIHpAsXOJFphc5rjqQLMYtcoQx9syWRgPSnhoSeIjckIF24glNZzZZoDBFJV6ZjsBXHa544RoveVAVp1BukPzXbinTyltvRIl24glOpFrFFI9jkjGiGpOTaKQMtthwvcpR8g756eSKNhwXSOx5IaEN62xUDNE+kskS6cAUnM29adE6hY7gtklKLjwxVPXO8djHnCNWmRsRHEmmQ3tPMSKdarkltzRBTUtkiXbrA6ZQZOqeIpIuQMdiCFCJHeUEwI5Ue6T09KUXOrCWVgHTpAif0NEGSVDLUoiOFwFFyBBsSWbRI72m3JBQnnFWYk0qLdOkCpzSboORaxpQhKbVXhooksaw5RlWiSSSRCul9DSlFzmpOKu0S6dIVnFQ3W6LEKvaUIekjDyVD/Y8DVQVDBdJ44Chlw93LSWWB9L6elOJkzRltIokskS5e4KSq9QxJum+BodolaTQcZcvdK0sSWXRI72u3pNRFzmcWSeUR6eIFTqtaR3RNIpIS2zJUTiIbjhJn3LtAKhXSRxpSqnLO55VkaqSLFzixqovoPBoOsEFSWiEy1IZEupajFNy5siSVBdJH+pqUpoFziTmpbJEuX+DU5l1ECc3Y1xRJF2DOUO2SVHKO8sKdC6Sy6JA+0m5J6pFzmVWk0iBdvsDJzbuI0tkyqoCktNYMtSSZjqPMA3dtUpJKjvSxCUnlFWeyIZke6fIFTm/eRXQGgQNEJCUVS4Z6JJma48y5ZzGSTI/0saYlqVXkLCaRVJ5bpMsXOIN5F9HpRSSdX8ZQdU06DUepuWd5JJXnFmmHgqSqKWcRSeYR6QoEzmHeRZRIZEwRSWm1DLUloQlHmQfu12xKMhOkXZaklVecwSSSSl0jXYHAWcy7iNLYsLfIYAFJaeUM9UhCLccpuF89ybQN0i7tM2mtAqcXSWaGdA0C5zHvIjq1gKRzm1UMVNcktKw5SsndeipJpkDa7YG0qpKTm0aSqZGuQeBM5l1Ely8iKamCoR5IastR8sidmmUkUy+Rdls2pFX+xYnFDck0HdI1CJzLvIvotHoG2yApqReGakgqcpyM+xQb0tm2SJ/ISSxMOK1pRTJbpKsQOJv5ZIaOl7G3gKQzC3OG6kmq5zgl92kzJ50M6TN1S2LdjFMqc5Jp10hXIXA+cT1DF65BUkpzhtq2JNUuOMord2nyRDpNh/SplsSqdeR0YkE6W6TrEDijal2hE2oYbIqklDqGakjskaNUFXdoNiOhDulz65bEqi5yMtNIMvUW6ToEzqkqJuh0pkg6s5yhehJrOM4L92e2JqGmQdpDS2rzLnIik5x0ti3SdQic1+wvdJySMbVISqhiqEVLYk3NUXLuTmwqEsqR9rFuSW3ecRqzjoQypCsROLOQRXQiJYNVSErohaEqknvgKFXJnYndnITaGmkvLcnNs8gJxKwinecO6UoEzu2pi+hSRSSlNGOoBckFjlNyX2I3J6UWaT/rluSeusj4ukhCGdK1CJzdfDJDpxEZKCApoVlkoEVHcguOs+WuxG5OSos10p4y0pt3kbFlcxJ67pCuReD84nqCDlUyQEDSOXUMVZFe13KUOOOOxG5OUgXSvuqG9OZdYFzZEyllSFcj8P/24EAxUWtRoOjmwAFidNL//8tUxggIvPa2r522k0QEjOJe6wZsNyW6SQOSZtQy1p4FHJgm43Fs8h2zqmuks/UsYBc2LCl5YU59j3Q3AjehfIpoeSUjBSTNJ+4Yqe1ZwDPTdDyMoonMq0c6X/3KArZ5znKSF+ZUvSHdj8BtKPINukRkhJqRciTNJ2GslCXUTBMDD+Llacu8XmukEbKKJWySyEKSF2aVtUj3I3AjYpOjC5wYoWakFknzKRjrxBLamml2PIS4S5hbgjRG+8wiXvoNS4jpC7Nqj0h3JONWbGmzFi2qfONRhJwv1pR8om/4qTzwZUrO0/ToAm9bxmkPLGJgmopHUGQpczv2jFMyTv3EQkqWF9B/vKY7lrAjvjK7TRKZ1wnpnmTcjpf95oBuSltwp2LJF3vhMzU/lxZ8mZLzDDUab5sxUsoyAtPsfu1Zu/gUmF3bMVLJOCVLKdHXyFhI8lT3zCtvtsyrq5HuSeCG7JocjRQZoWCkLZJmExirZhmHiml2rF2RB+aXtEgj1T0LKb6VkRnF3WbLvKrvSHclcEu2m11Eo5xYUEDSfDpGqmoW8sQ0PesWdk+R+XUV0mhvLUsp8y2z2Q4pc3vuke5Kxm1J81CjxWwOjBGRNJsQGaljKfWGSdLYsl7xKbCEqkcarw2RpUSe+po5hOd0y9zqN6T7knFjYkyO6HyBMTpGiUiazY6xnisWcmKihNWK6SmwiOdXpAvURWAxBaGvmSqmJfOreqQ7k3Fzynbo0bkiYwyMcsqQNJemYJzqxFL6/Y5JioZ1CsMzC6nfkC7y1u9YTkHoa6aI6alkAc+vSHcm4/bsqt0rWkRglBxJc4kFI3Us55lpUlZp2xUspeqRLtNuWFRB1g4tF4rpqWQJ9RvSvQncoG3yFNBZIqPUjNIiaS4JYz2znJ6JtqzO5luWFSzmuUe60GFgWXEzJAWXKJLncssSqhPS3cm4SUW7e0VnCIxSviHpa7SMVbOc6hem+c66bLIusmU53R7pYq+7lGVtIUtPB0YJu1N8YiFpjXR3ArdpmzwFNLuGUQokzSVlpK5lQTXTpKxHyHdZHiJLqo5IExxbFhdD/pxsI2fafEu/JZGlHGuk+xO4VUV4QZ+KjLJD0tfYbBmpZkk502y3rEEsyl32bZNuWVjaIk3QDhVXEF+y5/RbHvhEUe6yPOxYTn1EukMZN2vLU3JAHztljBJbzlcgaS4ZYw0sqc2ZJnDXYoinvG2fgS3LO9ZIkxxyrmTHBurYDOmB/4ghnuJhB2xZUntCukcZN6yg71o0p4C0sCLhI/UTMyiZW2Cakk90gXHaNOUzTc97Sj7WM1FX8qGm5y9FwlnqJ2ZQ8qEEKPhNRlFwHd0RfYWS8wRmEErOc+QiTRm4noIScmo4FvwhgRCBjB1Lq/KWy+SBjyTMoeRdR/6tZFlJyUf6hhmUXFFTcpam5wZl3LSyDTX6QM44AyMkSOMlJR8pmUPJrSmZW4x8aqh5T8nCYuRDQ81fkpKzlMyh5Na0DfoSJVcUI+c5cplfnwqurYCCL1BWXCgtWF7Ju478W8myCj5UM4eSK3rhPEPNDQrctvi0C+h9LeMEJElXVQ0t0nSnPQ9iqJDuU+DWpeEFzaZmhARJ0lTlAWkG7VDxEF5fke5U4OZtk7RA7wiMUzJCgyRpoqFCmkWfVzyA1wHpXmXcgR359x79TGSclhF2SJKmeR2QZnLYsH77AeluBe5CGsqIZrDlfAFJ0jTdgDSbw4G12wek+5VxH7a0SYP+bcNYmwPnikiSJtkHpBk1bFi1fWiR7lfGvYgx7Wv0Tx1jdZytRJI0xT60SHNq2LBi+9Ai3bHA/SiedgH9Q2SshLPVSJIm2IcWaV7NgfXahxbpngXuSfotiegHJ8bKOVuCJOly+9Aiza05sFb70CLdtcB9eRnKiCZoOVuDJOlibdEiza85sE5daJHuW8ad2VK9vKI/RcZqOdsOSdKl9qFFWkJDv2V9Xgekexe4O9vkOUd/ODHWlnMFJEmX2ocWaRlNXrE6/YB09wJ3KG6ec/S7htEKzhSRJF1oH1qkpRzylpU5/Ip0/zLuUoyxbRA7Rhs4U4Ik6TJ1aJGWc4jHHStSpQ3SCgTuVNw85+gCgTPVSJIu8vrWIi2pDa+sxz6vkdYgcLfi5jnnwRWMl3CmEknSJY4D0sLa4chadOGAtAoZdyzG2DZonMCZCiRJ41WhQVreMTtuWYNhj7QSgbsWN8955HGVjBc5T0CSNF6bN0jXUOV77l/bvCKtReDOxc1QRh5VzQUKzhKRJI1WNwek6ziEV+5d1xyQViNw97bl8C3wmCIXGDhLgiRprONbi3Qt7XCouGfVsG+R1iOwAtvwLdnwiE5cIHCWGknSOO3bEemamn7P/ar7V6Q1CazDS/5U8HhaLpBwlhJJ0ihdUyNdV98duVPV8NYjrUrGWhRkbcOD2XKBlrMUSJJGqEKDdH3HUO+4Q3X/irQyGesRY581PQ9kwyW231s+t0GSNELdn5C+woFjyb2pQoO0OhlrsqV8zWseRsdFAmc45UiSzlWFBumrHJui4K70SYO0Phkr88IpHVoeQ8lFEs5QIkk612vWIH2d/q3rt9yNOjkgrVFgdXab4VvgIdRcJHKGFknSefZvQ4v0pZqk5060h7cD0iplrNCWb3XXsH4JF+k5Q1sgSTpDFboO6au1bSgKbl+VHZHWKmOdCvpN1bNyTcElYmz5zCZHkvS5KksapFvQv/Wh4LZVWXJEWq2Mtdryre4aVm3HZQKfOuVIkj71mh2RbkVNFyO3q8qSI9KKZaxYQb+pelYrcKGET5VIkj7zmgwt0g1pmjxGblOVJUekVctYtS3f9unQsk6RC8Ujn2kLJEkfqbJmGJBuTNPkMXJ72i45Iq1cxtrt4PW5Yo0SLvTGpwokSR9ou+SIdIuapggFt2WfNkjrl/EAXnhOTwdWpy65zPbXno8VSJLeV3cN0s2qSd5euB2vedchPYCMhxDJ6+2+Z11KLpU1fKxEkvSOalP1SDftwK95GrkFbdcMNdJDyHgUO7519dCyIgWXavlEnyJJ+pmuPv2KdPP6I9sk5au9Pn9HehgZDyTd0A0VaxG4WOj42NsWSdJ/dPXQIt2JirA7Rb7OPh2GCulxZDyWlKx7rliFyMV231s+ssmRJP1LVw8t0j3pX9lkXeQr7Lf7vkN6KBmPZgtZ91xx/xIuV7R8JCJJ+lGb9hXSHTrAJusi17Xf7vtXpEeT8YC2kHXPFXcucrnAh/oUSdKf2kM89Uh36wCb7PuOa+nqU/+K9IAyHtMWsu654p71KRfr+NDbFknSb+ohO/Q0SPftAL9mxduWpe2f+wrpUWU8rC380tVDy52KkcvF0PO+TY4kPbr9ps0OPdJa9E1D0ycFi2kP8dT/ivS4Mh5auqHO9z33KDBF1vC+iCQ9rLbP2uLY9uyR1uYAb0XZ95G51bGvWxqkh5bx6Aq+7Z9PB+5OwhRFw/uagrvXJty8np/rjty8lvf1NY+o5iukvKvmi6X8ra+5cbHhN1lLeuB3R27EEY3S8qMa/URdQ9icknbLPPb9t2PNG7cg1tyYmi8V35hBzQ1KuUXJL+g3Vfdct9yVp4IJqhPvis8s53hEkiR9vRjKoW23XG6fD312QNKfkl/Qn+p833M/fmGSt5r35BuWczwiSZJuRhFPedvsGKNmYEgPSPqH5Bf0tzbt65a7sMmZpP+V9yQvLOd4RJIk3ZxNF0+QAAU/U0WIDVmbHpD0Uxn6QSRkdd4euH0903S8K0WSJD2YAzV/eON/Cv7U9vzuBG9I+kCG/qUgb7p46rltCdPEzYGf22ZIkqRHVyNpnAz91xZo075uuVmxYKKMd3x/QZIkSdI4Gfq5SMj2z33dcpMKpup4R4okSZKkkdISvatIQt7u4tBzc9qSidKh42fyZ5Z0OiFJkiStT4Y+tiNk++e+brkpKZM1/FSBJEmSpLEy9LkdIdv38dRzK7YZk6VJy3+FFEmSJEljZeg8O6B6CseaW5Aw3fbAT+RIkiRJGi0t0dnykMQy2QzDwNcKT8yh5SdyFnU6IUmSJK1PhkYq2FDFITv0fJmBOcRtxb/lGyRJkiSNlqELbIFvVRyyQ88XCN+YRcd/RCRJkiSNl6FLbYFvVRz67MB1Fcyj6Gv+KY9IkiRJGi9Dk2z5Tb7ftFlbcyVlwUxO/EtEkiRJ0gXSEk1XhCzE8lR0ZZmEnkXFYctciqLmR2XB0k4nJEmSpPXJ0Gy2FJBBzcBAzRJCfnphPt9Dz982OZIkSZIukaHZFfzuiZqBrG175rKJ1Y5Zbes3/hLrHEmSJEmXyNBiCn6TPVFFBvqEmsvFkMS3nB0zK44D/+/0giRJkqSLJL+g66kiWQsDtD3nCTGe6rLdspTXgT8kL1zB8YgkSZK0Pskv6Kvsc2DgfwZ+MAR+E080O5bXfe+BUBRcw/GIJEmStD7JL+jhvRbElOs4HpEkSZLWJ0N6QZIkSdIkAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAUmSJEnSRAFJkiRJ0kQBSZIkSdJEAemaeiRJkqQVCkjXlCBJkiStUECSJEmSNFGokCRJkiRNEyKSJEmSpGkCkiRJkqSJAtI19UiSJEkrFCLSFbVIkiRJKxQaJEmSJEnThB7pemokSZKkNQoJkiRJkqRpQot0PQOSJEnSGoUe6Xp6JEmSpDUK1EhXkyBJkiStUeCIdDU1kiRJ0hoFviFdyx5JkiRplQIt0rX0SJIkSasUOCBdS0SSJElapQA10pVkSJIkSauUwYB0HdUJSZIkaZUCBKTr6JAkSZLWKYX2lCNdQ98hSZIkrVIAOqSrGJAkSZLWKQMi0jXsOyRJkqR1CsCAdA1bJEmSpJUKQNshXcEeSZIkaaUCvxmQltf1SJIkSSuV8pvmlCMt7dghSZIkrVTG7zZIS6tOSJIkSWsV+F2FtLQNkiRJ0mql/G5IMqRl7QckSZKktQr8T4+0rLpHkiRJWq3A/9Qt0qJ6JEmSpPUK/KFFWlJdI0mSJK1X4A9Ni7SgHkmSJGnFAn9qkZZT10iSJEkrFvhT0yItpkeSJElas8D/OyEtpa6RJEmS1izl/3VJhrSMw4AkSZK0ZoG/1EjL6HskSZKkVUv5y0CGtIDq1CNJkiStWsrfkiRFml84IkmSJK1b4G/tCWl+XYUkSZK0cik/6PIEaWZV1yNJkiStXMqP+iRFmlc4IkmSJK1dxo/aiDSv1wFJkiRp9QL/cBiQ5rTPkCRJktYv5Z/qGJBmUxU1kiRJ0vql/MtQF0hzCd+RJEmSHkDCv22aLdI8jkckSZKkR5DwH5scaRavA5IkSdJDSPmPto9IM9j3SJIkSY8h5b+6PiJNtg89kiRJ0mMI/EQzIE21Dy2SJEnSg0j4qeQFaZJ9aJEkSZIeReCnhh5pin1okSRJkh5Gys/VfUS62D60SJIkSY8j5R1dH5EuVA8tkiRJ0gNJeU+XHXKkS7y2PZIkSdIjSXlXU/Yp0njHE5IkSdJjSXlfy5AhjVSFA5IkSdKDSflAf8oTpFH2xXckSZKkR5PyoTo75Ejn67saSZIk6eGkfKxJ04B0pirseyRJkqTHk/KJvim+50jn6LojkiRJ0iNK+FwsU6RPtUmFJEmS9JgSzlFkEeljx65FkiRJelAJ5ylPW6T3dd97JEmSpIeVcKaYnrZIP1f3NZIkSdIDSzhbTE9bpP+q+xpJkiTpoSWMENPTFumfXvMaSZIk6cGljNCf+r7PkP5SZfuhQ5IkSXp0CWOFbReRftcNFZIkSZIg4QJF0UX06Lp6aJEkSZL0u4TLbPqkQA+rPTzXLZIkSZL+lHC5IolvW/Ro6ng89UiSJEn6QcI0MZR1QoEeQNsfi6w/IEmSJOnfEuYRA1q1tkeSJEnSe/4PdwbNp0n88DoAAAAASUVORK5CYII=';

class FormHeader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		/** @type {Fable} */
		this.fable = pFable;
	}
}

module.exports = FormHeader;

module.exports.default_configuration =
{
	ViewIdentifier: "FormHeader",
	DefaultRenderable: "Form-Header",
	DefaultDestinationAddress: "#Headlight-View-Header",
	AutoRender: false,
	CSS: /*css*/``,
	Templates: [
		// NOTE: This is the header for the entire form. It is not a section or group. It does not respect theme changes... so print view tweaks need to be done via CSS.
		{
			Hash: 'Form-Header',
			Template: /*HTML*/`
			<!-- Pict Form Header Container -->
			<div id="Headlight-Dynamic-Header-Container">
				<div id="HeadLight-Branding-ColorSwatches" class="column pt-1 pr-0 pb-0 pl-0 has-text-centered">
					<img class="image" width="300" style="margin:auto" src="${HASHES_PNG_DATA_URI}" alt="HeadLight Branding Color Swatches">
				</div>
				<section class="form-header-content">
					<div class="columns is-mobile is-vcentered">
						<div class="column" id="Document-Logo-Wrapper">
							<img class="image"
								style="max-height: 75px"
								src="/1.0/Customer/SecondaryLogo/{~D:AppData.DocumentData.ReportData.IDCustomer~}?SessionToken={~D:AppData.DocumentData.SessionToken~}"
								alt="Logo"
								onerror="this.onerror = null; this.src = '${LOGO_GRAY_PNG_DATA_URI}'" />
						</div>
						<div class="column has-col-span-3 has-text-right">
							<h1 class="title is-5">{~DWTF:AppData.DocumentData.ReportData.ReportOptions.Meta.reportTitle:Form-Header-Document-Name~}</h1>
							<h2 class="subtitle is-7 mb-0">{~D:AppData.DocumentData.ReportData.Project.Name~}</h2>
							<div class="is-size-7 has-text-grey">
								<span id="Headlight-Dyanmic-Header-Shift">{~TIfAbs:Form-Header-Night-Shift:AppData:AppData.DocumentData.ReportData.Shift^==^Night~}</span>
								<span id="Headlight-Dyanmic-Header-DocumentDate">{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^dddd, MMMM Do YYYY^~}</span>
							</div>
							<div class="is-size-7 has-text-grey">Form #{~D:AppData.DocumentData.ReportData.SequenceNumber~}</div>
							<div id="Document-Program-Title" class="is-size-7 title m-0 p-0">{~D:AppData.DocumentData.ReportData.ProgramName~}</div>
						</div>
					</div>
				</section>
			</div>`,
		},
		{
			Hash: 'Form-Header-Document-Name',
			Template: /*html*/`{~D:AppData.DocumentData.ReportData.Name~}`,
		},
		{
			Hash: 'Form-Header-Night-Shift',
			Template: /*html*/`
			<i class="fas fa-fw fa-moon"></i> Night Shift - `,
		},
	],
	Renderables: [
		{
			RenderableHash: "Form-Header",
			TemplateHash: "Form-Header",
			DestinationAddress: "#Headlight-View-Header",
		},
	],
};

},{"pict-view":733}],268:[function(require,module,exports){
/* eslint-disable quotes */
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('headlight-configurable-application').Fable} Fable */

const libPictLeafletView = require('pict-section-leaflet');

class GeolocationSelector extends libPictLeafletView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		/** @type {Fable} */
		this.fable = pFable;
		/** @type {import('leaflet').Map} */
		this.leaflet = null;
		/** @type {any} */
		this.options;
		/** @type {string} */
		this.rawHTMLID;
	}

	/**
	 * Returns the HTML ID for the map based on the input HTML ID.
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @return {string} - The HTML ID for the map.
	 */
	getMapHTMLID(pInputHTMLID)
	{
		return `MAP-FOR-${pInputHTMLID}`;
	}

	getInitialMapLocation()
	{
		let tmpLocation = null;
		if (this.pict.AppData?.DocumentData?.ReportData?.Project?.Latitude && this.pict.AppData?.DocumentData?.ReportData?.Project?.Longitude)
		{
			const tmpLat = Number(this.pict.AppData.DocumentData.ReportData.Project.Latitude);
			const tmpLng = Number(this.pict.AppData.DocumentData.ReportData.Project.Longitude);
			tmpLocation = {
				lat: tmpLat,
				lng: tmpLng,
			};
		}
		return tmpLocation;
	}

	/**
	 * Called before the view is rendered.
	 * This method sets up options for leaflet initialization.
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		this.options.LeafletDestinationAddress = this.getMapHTMLID(this.rawHTMLID);
		const initialCenter = this.getInitialMapLocation();
		if (initialCenter)
		{
			//FIXME: need to remove state from the view (if it is shared)
			this.leafletInitialCenter = initialCenter;
		}
		// set the flag based on the input type
		//FIXME: need to address this now that the record is no longer plumbed in here
		//this.options.hideLeafletMap = pRecord.PictForm.InputType !== 'GeolocationSelectorWithMap';
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Called after the view is rendered.
	 * The method stores leaflet data after initialization for the provider to access
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		if (!this.pict.AppData.LeafletMapsData)
		{
			this.pict.AppData.LeafletMapsData = {};
		}
		this.pict.AppData.LeafletMapsData[this.rawHTMLID] = {
			map: this.leaflet,
			RawHTMLID: this.rawHTMLID,
			destinationAddress: this.options.LeafletDestinationAddress,
			hideMap: this.options.hideLeafletMap,
			marker: null,
			location: {
				Latitude: '',
				Longitude: '',
			},
		};
	}

	/**
	 * Called after the Leaflet map is initialized.
	 * This method is responsible for loading the map tiles and setting up the initial view.
	 * @return {void}
	 */
	onAfterInitializeLeaflet()
	{
		// Load tiles
		const libLeaflet = window.L;
		// using this.leaflet only works here because this is called during super.onAfterRender
		// https tiles (avoids mixed-content when the report is served over https) + the canonical host.
		this.tileLayer = libLeaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		{
			maxZoom: 19,
			attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
		}).addTo( this.leaflet );
	}
}

module.exports = GeolocationSelector;

module.exports.default_configuration =
{
	ViewIdentifier: "GeolocationSelector",
	DefaultRenderable: "GeolocationSelector",
	DefaultDestinationAddress: "#GeolocationSelector-Container",
	AutoRender: false,
	CSS: /*css*/``,
	Templates: [
		{
			Hash: "GeolocationSelector",
			Template: /*html*/`
			<div id="MAP-FOR-{~D:Record.Macro.RawHTMLID~}" style="min-height: 320px; z-index: 1;"></div>
			`,
		},
	],
	Renderables: [
		{
			RenderableHash: "GeolocationSelector",
			TemplateHash: "GeolocationSelector",
			DestinationAddress: "#GeolocationSelector-Container",
		},
	],
};

},{"pict-section-leaflet":669}],269:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('headlight-configurable-application').Fable} Fable */

const libPictView = require('pict-view');

const libTestResultsSummary = require('../providers/_TestResultsSummary.js');

const SUMMARY_ELEMENT_ID = 'Headlight-View-TestResultsSummary';

// Remarks report every keystroke; redraw once typing pauses.
const REFRESH_DEBOUNCE_MS = 150;

/**
 * Read-only test results summary drawn between the form header and the form body, on screen and in the PDF.
 * It stays hidden until a test has a result.
 *
 * `SampleTestAcceptance` asks for a refresh whenever it marshals or changes, and the RichText provider when a
 * test remark changes; the refresh is debounced so a full-form marshal draws once.
 */
class TestResultsSummary extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict = pFable;
		/** @type {Fable} */
		this.fable = pFable;

		/** @type {Record<string, any>|null} */
		this._marshalDestination = null;
		/** @type {ReturnType<typeof setTimeout>|null} */
		this._refreshTimer = null;
	}

	/**
	 * Schedule a redraw from the given form data.
	 *
	 * @param {Record<string, any>} pMarshalDestination - The form data the acceptance inputs read from.
	 */
	requestRefresh(pMarshalDestination)
	{
		if (pMarshalDestination && typeof(pMarshalDestination) === 'object')
		{
			this._marshalDestination = pMarshalDestination;
		}
		if (this._refreshTimer)
		{
			clearTimeout(this._refreshTimer);
			this._refreshTimer = null;
		}
		// The PDF rasterizer prints as soon as the form reports ready, so a printed render draws now.
		if (this.pict.AppData && this.pict.AppData.Interactive === false)
		{
			this.refreshSummary();
			return;
		}
		this._refreshTimer = setTimeout(() =>
		{
			this._refreshTimer = null;
			this.refreshSummary();
		}, REFRESH_DEBOUNCE_MS);
	}

	/**
	 * Redraw now.
	 */
	refreshSummary()
	{
		if (typeof(document) === 'undefined' || !this._marshalDestination)
		{
			return;
		}
		const tmpHost = this._getHostElement();
		if (!tmpHost)
		{
			return;
		}
		tmpHost.replaceChildren();

		const tmpManifest = this.pict.views.PictFormMetacontroller?.manifestDescription;
		const tmpAcceptance = this.pict.providers.SampleTestAcceptance;
		const tmpRows = libTestResultsSummary.collectTestResults(
			{
				Descriptors: tmpManifest?.Descriptors || {},
				Sections: tmpManifest?.Sections || [],
				Data: this._marshalDestination,
				getValueAtAddress: (pObject, pAddress) => this.pict.manifest.getValueAtAddress(pObject, pAddress),
				// @ts-ignore - provider-private resolver, reused so the summary reads the same remarks the input shows
				getRemarksAddress: tmpAcceptance && tmpAcceptance._getRemarksAddress ? (pInput) => tmpAcceptance._getRemarksAddress(pInput, null) : null,
				Document: document,
			});
		if (!libTestResultsSummary.hasAnyResult(tmpRows))
		{
			tmpHost.classList.add('is-hidden');
			return;
		}
		tmpHost.append(libTestResultsSummary.buildSummaryElement(document, tmpRows));
		tmpHost.classList.remove('is-hidden');
	}

	/**
	 * The summary's own element, created after the form header (or before the form body) on first use.
	 *
	 * @return {HTMLElement|null}
	 */
	_getHostElement()
	{
		const tmpExisting = document.getElementById(SUMMARY_ELEMENT_ID);
		if (tmpExisting)
		{
			return tmpExisting;
		}
		const tmpHeader = document.getElementById('Headlight-View-Header');
		const tmpFormContainer = document.getElementById('Pict-Form-Container');
		if (!tmpHeader && !tmpFormContainer)
		{
			return null;
		}
		const tmpHost = document.createElement('div');
		tmpHost.id = SUMMARY_ELEMENT_ID;
		tmpHost.className = 'is-hidden';
		if (tmpHeader)
		{
			tmpHeader.after(tmpHost);
		}
		else
		{
			tmpFormContainer.before(tmpHost);
		}
		return tmpHost;
	}
}

module.exports = TestResultsSummary;

module.exports.default_configuration =
{
	ViewIdentifier: 'TestResultsSummary',
	AutoRender: false,
	CSS: /*css*/`
#Headlight-View-TestResultsSummary .test-results-summary { margin: 0.75rem 0 1.25rem; padding: 0.75rem 1rem; }
#Headlight-View-TestResultsSummary .test-results-summary-heading { display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; margin-bottom: 0.5rem; }
#Headlight-View-TestResultsSummary .table { background-color: transparent; }
#Headlight-View-TestResultsSummary .test-results-summary-result { white-space: nowrap; }
#Headlight-View-TestResultsSummary .test-results-summary-remarks { max-width: 40ch; }
`,
	Templates: [],
	Renderables: [],
};

},{"../providers/_TestResultsSummary.js":169,"pict-view":733}],270:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');
const libPictSectionModal = require('pict-section-modal');
const libHeadlightModalAdapter = require('./HeadlightModalAdapter.js');

/**
 * HeadlightModal
 *
 * Confirmation / dialog / loader broker for Headlight. This used to hand-build Bulma
 * `.modal` / `.modal-card` DOM; it now drives the pict-section-modal (PSM) view's
 * `show()` API, which gives the shared overlay, Escape/focus/ARIA, transitions and
 * CSS-variable theming for free.
 *
 * The public surface (spawnModal / spawnMiniModal / addLoader / dismissLoader /
 * dismissModals / freezeBodyScroll / unfreezeBodyScroll, plus the mutable
 * confirmCallback / cancelCallback slots) is preserved so the ~25 call sites and the
 * `_Pict.fable.HeadlightModal.*()` onclick strings embedded in their template HTML keep
 * working unchanged.
 *
 * Option translation lives in the pure `HeadlightModalAdapter`; everything impure — the
 * PSM call, live-DOM append + autofocus + `<style>` injection in onOpen, the
 * callback<->dismiss bridge, the body scroll-lock, and the singleton dismiss — lives here.
 */
class HeadlightModalFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment'), views: object, CSSMap: object }}
		 */
		this.fable;
		// store this for the "jump to top" issue that may occur when modals are dismissed
		this.lastScrollPosition = 0;

		this.serviceType = 'HeadlightModal';

		this.loaderActive = false;

		// Pure legacy-options -> PSM-options translator (no DOM / Fable deps).
		this._adapter = new libHeadlightModalAdapter();
		// The panel-close "MiniModal" preset, exposed on the instance so views can spread it:
		//   spawnMiniModal({ ...this.fable.HeadlightModal.MiniModalPreset, message: '...' }, cb)
		this.MiniModalPreset = libHeadlightModalAdapter.MiniModalPreset;
		// The live PSM dialog element for the current modal (singleton), or null.
		this._activeDialog = null;

		// default configuration for the modal
		this.configDefault = {
			modalId: 'Headlight-Utility-Modal',
			modalBodyId: 'Headlight-Utility-Modal-Body',
			modalHeaderId: 'Headlight-Utility-Modal-Header',
			modalFooterId: 'Headlight-Utility-Modal-Footer',
			modalCardTemplate: null,
			modalHeaderTemplate: null,
			modalBodyTemplate: null,
			modalFooterTemplate: null,
			modalCustomCSS: null,
			hideModalBackground: false,
			hideModalHeader: false,
			hideModalBody: false,
			hideModalFooter: false,
			title: 'Confirmation',
			message: 'Are you sure?',
			confirmText: 'Okay',
			confirmIcon: 'check',
			confirmColor: 'is-link',
			cancelText: 'Cancel',
			cancelIcon: 'times',
			cancelColor: 'is-link is-soft',
			style: 'small',
			enableBackgroundScrolling: false,
			disableBackgroundClickToClose: false,
		};
		this.configActive = Object.assign({}, this.configDefault);
		// default callbacks for the modal
		this.confirmCallback = () =>
		{
			this.dismissModals();
		};
		this.cancelCallback = () =>
		{
			this.dismissModals();
		};
	}

	/**
	 * Resolve the pict-section-modal view, registering it as a singleton on first use if
	 * the host app hasn't already. Tolerates both registration names in use (canonical
	 * 'Pict-Section-Modal', and the form-editor's 'PictSectionModal'). Mirrors
	 * Headlight-Popover-Service so the modal stays a drop-in service.
	 *
	 * @returns {Object|false} The PSM view instance, or false if unavailable.
	 */
	_getModal()
	{
		if (!this.fable || !this.fable.views)
		{
			this.fable.log.error('HeadlightModalFableService: pict-section-modal is unavailable (no views registry)');
			return false;
		}
		let tmpModal = this.fable.views['Pict-Section-Modal'] || this.fable.views['PictSectionModal'];
		if (!tmpModal && typeof this.fable.addViewSingleton === 'function')
		{
			this.fable.addViewSingleton('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
			tmpModal = this.fable.views['Pict-Section-Modal'];
		}
		if (!tmpModal)
		{
			this.fable.log.error('HeadlightModalFableService: could not resolve the Pict-Section-Modal view');
			return false;
		}
		return tmpModal;
	}

	/**
	 * Generic modal creation utility. Signature preserved from the legacy service; the
	 * options object is translated to a PSM `show()` call. See HeadlightModalAdapter for
	 * the option mapping.
	 *
	 * @param {object} configOptions - Behaviors/parts of the modal to customize/override.
	 * @param {function} [confirmCallback] - Called on confirm.
	 * @param {function} [cancelCallback] - Called on cancel.
	 * @return {void}
	 */
	spawnModal(configOptions = {}, confirmCallback, cancelCallback)
	{
		this._spawn(Object.assign({}, this.configDefault, configOptions), confirmCallback, cancelCallback, { mini: false });
	}

	/**
	 * Mini modal creation utility — the compact panel-close confirmation. Signature
	 * preserved. NOTE: the legacy first-arg-is-a-function misuse (three call sites passed
	 * `spawnMiniModal(() => {...})`) is normalized here so the confirm action fires.
	 *
	 * @param {object|function} pConfigOptions
	 * @param {function} [confirmCallback]
	 * @param {function} [cancelCallback]
	 * @return {void}
	 */
	spawnMiniModal(pConfigOptions = {}, confirmCallback, cancelCallback)
	{
		// Legacy bug fix: a function passed as the first arg is really the confirm callback.
		if (typeof pConfigOptions === 'function')
		{
			cancelCallback = confirmCallback;
			confirmCallback = pConfigOptions;
			pConfigOptions = {};
		}
		if (!pConfigOptions)
		{
			pConfigOptions = {};
		}

		// mini structural defaults (the brand + offset come from the caller / MiniModalPreset)
		pConfigOptions.message = pConfigOptions.message || 'Close panel?';
		pConfigOptions.subtext = pConfigOptions.subtext || 'Any unsaved changes may be lost.';
		pConfigOptions.confirmText = pConfigOptions.confirmText || 'Confirm';
		pConfigOptions.confirmIcon = pConfigOptions.confirmIcon || 'fa-check-circle';
		pConfigOptions.confirmColor = pConfigOptions.confirmColor || '';
		pConfigOptions.cancelText = pConfigOptions.cancelText || 'Cancel';
		pConfigOptions.cancelIcon = pConfigOptions.cancelIcon || 'fa-times-circle';
		pConfigOptions.cancelColor = (pConfigOptions.cancelColor !== undefined && pConfigOptions.cancelColor !== null) ? pConfigOptions.cancelColor : 'is-light';
		pConfigOptions.disableBackgroundClickToClose = true;
		// The mini is a compact colored card — no title/header bar (parity with the legacy
		// .modal-card-mini dropdown, which had none).
		if (pConfigOptions.hideModalHeader === undefined || pConfigOptions.hideModalHeader === null)
		{
			pConfigOptions.hideModalHeader = true;
		}

		this._spawn(Object.assign({}, this.configDefault, pConfigOptions), confirmCallback, cancelCallback, { mini: true });
	}

	/**
	 * Anchored, backdrop-less menu (e.g. the navbar download menu). Wraps PSM's
	 * `dropdown()` in ContentHTML mode, which gives anchor positioning, auto-flip,
	 * click-outside / Escape dismissal and viewport clamping — replacing the old
	 * `spawnModal({ modalCardTemplate, hideModalBackground })` + hand-rolled
	 * getBoundingClientRect positioning + document click-outside closer.
	 *
	 * @param {HTMLElement|string|object} pAnchor - element, selector, or rect
	 * @param {string} pContentHTML - the menu markup (onclick strings preserved verbatim)
	 * @param {object} [pOptions] - passed through to PSM dropdown (align, position, className, maxWidth, ...)
	 * @returns {Promise<*>|false}
	 */
	spawnAnchoredMenu(pAnchor, pContentHTML, pOptions)
	{
		const tmpModal = this._getModal();
		if (!tmpModal)
		{
			return false;
		}
		if (this.fable.CSSMap && typeof this.fable.CSSMap.injectCSS === 'function')
		{
			this.fable.CSSMap.injectCSS();
		}
		const tmpOptions = Object.assign({ className: 'headlight-modal-menu' }, pOptions || {});
		tmpOptions.ContentHTML = pContentHTML;
		return tmpModal.dropdown(pAnchor, tmpOptions);
	}

	/**
	 * Dismiss the open anchored menu / dropdown (e.g. to toggle it closed from its
	 * own trigger button). Modals-only — never touches toasts/tooltips.
	 * @returns {void}
	 */
	dismissAnchoredMenu()
	{
		const tmpModal = this.fable.views && (this.fable.views['Pict-Section-Modal'] || this.fable.views['PictSectionModal']);
		if (tmpModal && typeof tmpModal.dismissDropdowns === 'function')
		{
			tmpModal.dismissDropdowns();
		}
	}

	/**
	 * Shared spawn path for spawnModal / spawnMiniModal.
	 * @param {object} pConfig - fully merged config
	 * @param {function} [pConfirmCallback]
	 * @param {function} [pCancelCallback]
	 * @param {object} pContext - { mini: boolean }
	 * @private
	 */
	_spawn(pConfig, pConfirmCallback, pCancelCallback, pContext)
	{
		this.configActive = pConfig;

		// Singleton: dismiss any existing modal first.
		this.dismissModals();

		// Wire callbacks (kept as instance methods so embedded onclick strings resolve).
		if (pConfirmCallback)
		{
			this.confirmCallback = async () =>
			{
				try
				{
					await pConfirmCallback();
				}
				catch (e)
				{
					console.error('Error in modal Confirm callback: ', e);
				}
				this.dismissModals();
			};
		}
		if (pCancelCallback)
		{
			this.cancelCallback = async () =>
			{
				try
				{
					await pCancelCallback();
				}
				catch (e)
				{
					console.error('Error in modal Cancel callback: ', e);
				}
				this.dismissModals();
			};
		}

		const tmpModal = this._getModal();
		if (!tmpModal)
		{
			return;
		}

		// PSM's view CSS is registered but only injected on render; it never renders
		// through the normal cycle, so inject explicitly (mirrors Headlight-Popover).
		if (this.fable.CSSMap && typeof this.fable.CSSMap.injectCSS === 'function')
		{
			this.fable.CSSMap.injectCSS();
		}

		const tmpPlan = this._adapter.translate(pConfig, pContext);

		const tmpShowOptions =
		{
			title: tmpPlan.title,
			content: tmpPlan.content,
			// Footer buttons are Bulma .button elements inside `content` (so FontAwesome
			// icons + the onclick->confirmCallback/cancelCallback coupling survive); PSM's
			// own button array stays empty.
			buttons: [],
			closeable: tmpPlan.closeable,
			onOpen: (pDialog) => { this._onDialogOpen(pDialog, tmpPlan, pConfig); },
			onClose: () => { this._onDialogClose(); },
		};
		if (tmpPlan.width)
		{
			tmpShowOptions.width = tmpPlan.width;
		}

		// Freeze background scroll (unless the caller opted out) BEFORE showing.
		if (tmpPlan.freezeScroll)
		{
			this.freezeBodyScroll();
		}

		tmpModal.show(tmpShowOptions);
	}

	/**
	 * Post-open DOM work PSM can't do from a string `content`: stamp our classes, append
	 * any live-element templates, inject custom CSS, position a mini modal, and restore the
	 * legacy autofocus (PSM focuses the first button; forms want the first input).
	 * @private
	 */
	_onDialogOpen(pDialog, pPlan, pConfig)
	{
		this._activeDialog = pDialog;

		// Classes (z-index for panels is handled by psm-modal.scss via the body navbar
		// class; these drive the wide/mini/brand looks).
		if (pPlan.className)
		{
			let tmpClasses = pPlan.className.split(/\s+/);
			for (let i = 0; i < tmpClasses.length; i++)
			{
				if (tmpClasses[i]) { pDialog.classList.add(tmpClasses[i]); }
			}
		}

		let tmpBody = pDialog.querySelector('.pict-modal-dialog-body');

		// Live-element templates (rare — most templates are HTML strings handled in content).
		if (tmpBody)
		{
			if (pPlan.cardElement) { this._appendElement(tmpBody, pConfig.modalCardTemplate); }
			if (pPlan.headerElement) { this._appendElement(tmpBody, pConfig.modalHeaderTemplate); }
			if (pPlan.bodyElement) { this._appendElement(tmpBody, pConfig.modalBodyTemplate); }
			if (pPlan.footerElement) { this._appendElement(tmpBody, pConfig.modalFooterTemplate); }
		}

		// Default footer as a real .pict-modal-dialog-footer band — a sibling of the body,
		// so the buttons sit below the (scrollable) body instead of overlapping its content.
		if (pPlan.footerContent)
		{
			let tmpFooter = document.createElement('div');
			tmpFooter.className = 'pict-modal-dialog-footer';
			tmpFooter.innerHTML = pPlan.footerContent;
			pDialog.appendChild(tmpFooter);
		}

		// Custom CSS as a <style> (textContent, never parsed as HTML — no injection surface).
		if (pPlan.customCSS)
		{
			let tmpStyle = document.createElement('style');
			tmpStyle.textContent = pPlan.customCSS;
			pDialog.appendChild(tmpStyle);
		}

		// Mini modal: anchor top-right below the navbar. Inline styles beat PSM's centering.
		// Drop the transform transition so it fades in place instead of sliding in from the
		// centered origin (which read as a top-left slide).
		if (pPlan.topOffset)
		{
			pDialog.style.position = 'fixed';
			pDialog.style.top = pPlan.topOffset;
			pDialog.style.right = '8px';
			pDialog.style.left = 'auto';
			pDialog.style.bottom = 'auto';
			pDialog.style.transform = 'none';
			pDialog.style.margin = '0';
			pDialog.style.transition = 'opacity var(--pict-modal-transition-duration, 0.18s) ease';
		}

		// Restore legacy autofocus: first visible, enabled input/textarea in the body.
		if (pPlan.focusFirstInput && tmpBody)
		{
			let tmpInput = tmpBody.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');
			if (tmpInput)
			{
				tmpInput.focus();
				if (typeof tmpInput.select === 'function') { tmpInput.select(); }
			}
		}
	}

	/**
	 * PSM fired onClose (button click routed through our callbacks, or ×/Escape/overlay
	 * dismiss). PSM has already removed the dialog; reset our state. User callbacks are NOT
	 * run here — the footer buttons run them directly; ×/Escape/overlay are a plain dismiss
	 * (parity with the legacy background-click).
	 * @private
	 */
	_onDialogClose()
	{
		this._activeDialog = null;
		this._resetAfterClose();
	}

	/**
	 * Reset callbacks to their dismiss-only defaults and release the scroll lock.
	 * Idempotent.
	 * @private
	 */
	_resetAfterClose()
	{
		this.confirmCallback = () =>
		{
			this.dismissModals();
		};
		this.cancelCallback = () =>
		{
			this.dismissModals();
		};
		if (typeof document !== 'undefined' && document.body && document.body.style.position === 'fixed')
		{
			this.unfreezeBodyScroll();
		}
	}

	/**
	 * Append a live DOM element (nodeType 1) into a parent. String templates never reach
	 * here — the adapter folds those into `content`.
	 * @private
	 */
	_appendElement(pParent, pContent)
	{
		if (pContent && typeof pContent === 'object' && pContent.nodeType === 1)
		{
			pParent.appendChild(pContent);
		}
	}

	addLoader(message)
	{
		if (!this.loaderActive)
		{
			this.loaderActive = true;

			const tmpLoader = document.createElement('div');
			tmpLoader.id = 'modal-service-loader';
			tmpLoader.className = 'modal is-active';

			const tmpBg = document.createElement('div');
			tmpBg.className = 'modal-background delayed-fade-in-bg';
			tmpLoader.appendChild(tmpBg);

			const tmpContent = document.createElement('div');
			tmpContent.className = 'modal-content';
			tmpContent.style.backgroundColor = 'rgba(1, 1, 1, 0)';

			const tmpSplash = document.createElement('div');
			tmpSplash.className = 'is-loading-splash delayed-fade-in';
			tmpSplash.style.zIndex = '25';
			tmpSplash.style.backgroundColor = 'rgba(1, 1, 1, 0)';

			const tmpTitle = document.createElement('h1');
			tmpTitle.className = 'title';
			tmpTitle.textContent = message || 'Loading...';

			tmpSplash.appendChild(tmpTitle);
			tmpContent.appendChild(tmpSplash);
			tmpLoader.appendChild(tmpContent);
			document.body.appendChild(tmpLoader);
		}
	}

	dismissLoader()
	{
		document.querySelectorAll('#modal-service-loader')?.forEach?.(l => l.remove());
		this.loaderActive = false;
	}

	/**
	* Dismiss the currently open modal (singleton). Dismisses the PSM dialog — whose
	* onClose resets our state — and falls back to a direct reset when no dialog is tracked.
	* @return {void}
	*/
	dismissModals()
	{
		const tmpDialog = this._activeDialog;
		this._activeDialog = null;

		if (tmpDialog && typeof tmpDialog._dismiss === 'function' && !tmpDialog._dismissed)
		{
			// PSM removes the node and fires onClose -> _onDialogClose -> _resetAfterClose.
			tmpDialog._dismiss(null);
			return;
		}

		// No live dialog to dismiss (or already dismissed): reset directly.
		this._resetAfterClose();
	}

	/**
	* Fix the body background so that it's not scrollable when a modal is open.
	* @return {void}
	*/
	freezeBodyScroll()
	{
		this.lastScrollPosition = window.scrollY;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${this.lastScrollPosition}px`;
		document.body.style.overflow = 'hidden';
		document.body.style.width = '100%';
	}

	/**
	* Reset the body background so that it's scrollable when a modal is closed.
	* @return {void}
	*/
	unfreezeBodyScroll()
	{
		const tmpScrollPosition = this.lastScrollPosition;
		document.body.style.position = '';
		document.body.style.top = '';
		//this is required to ensure that sticky headers stick
		document.body.style.overflow = 'visible';
		document.body.style.width = '';
		window.scrollTo(0, tmpScrollPosition);
		// reset for next time
		this.lastScrollPosition = 0;
	}
}

module.exports = HeadlightModalFableService;
module.exports.default_configuration = {};
// Re-export so callers can `spawnMiniModal({ ...HeadlightModal.MiniModalPreset, message })`.
module.exports.MiniModalPreset = libHeadlightModalAdapter.MiniModalPreset;

},{"./HeadlightModalAdapter.js":271,"fable-serviceproviderbase":438,"pict-section-modal":690}],271:[function(require,module,exports){
/**
 * HeadlightModalAdapter
 *
 * Pure, framework-free translation between the legacy HeadlightModal option shape
 * (`spawnModal` / `spawnMiniModal` `configOptions`) and the Pict-Section-Modal (PSM)
 * `show()` API. Kept dependency-free (no Pict, no DOM) so it is unit-testable in
 * isolation — mirrors `HeadlightToastAdapter`.
 *
 * Division of labour: this class only DECIDES the PSM option shape and builds HTML
 * strings. The broker (`Headlight-Modal-Service`) owns everything impure — the PSM
 * call, live-DOM append + autofocus + `<style>` injection in `onOpen`, the
 * callback<->promise bridge, the body scroll-lock, and the singleton dismiss.
 *
 * Why the footer is built as HTML `content` (not PSM's `buttons[]`): PSM escapes
 * button labels (`Pict-Modal-Window._escapeHTML`), so FontAwesome icons cannot ride
 * in a `buttons[]` Label, and consumer-supplied footer templates already embed
 * `onclick="_Pict.fable.HeadlightModal.confirmCallback()"`. Emitting a Bulma-button
 * footer into `content` (with `buttons: []` passed to PSM) preserves the icons, the
 * onclick coupling, and the exact look — PSM still owns the shell (overlay, header,
 * ×, Escape, focus, theming). The broker keeps `confirmCallback`/`cancelCallback`
 * alive so those onclick strings resolve unchanged.
 */

// The global the embedded footer onclick strings resolve to — identical to the legacy
// service so consumer-supplied footer templates keep working verbatim.
const SERVICE_GLOBAL = '_Pict.fable.HeadlightModal';

/**
 * The panel-close "MiniModal" look + behaviour, lifted OUT of the service so each
 * calling view passes it explicitly: `spawnMiniModal({ ...MiniModalPreset, message }, ...)`.
 * (Was previously copy-pasted across the headlight_panels views.)
 */
const MiniModalPreset =
{
	modalTopOffset: '65px',
	modalBackgroundColor: 'has-background-primary-80',
	modalTextColor: 'has-text-primary-20',
	confirmColor: 'is-primary',
	cancelColor: 'is-soft is-primary',
};

class HeadlightModalAdapter
{
	/**
	 * Escape HTML special characters for safe embedding of plain-text values.
	 * @param {string} pText
	 * @returns {string}
	 */
	escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	/**
	 * True when the value is a live DOM element. Checked structurally (nodeType === 1)
	 * so this stays pure — no `document`/`HTMLElement` reference needed.
	 * @param {*} pValue
	 * @returns {boolean}
	 */
	isElement(pValue)
	{
		return !!(pValue && typeof pValue === 'object' && pValue.nodeType === 1);
	}

	/**
	 * Map a legacy Bulma button color string onto the emphasis the footer button
	 * should carry. De-emphasized markers (`is-soft`/`is-light`) win over `primary`/
	 * `link` so a "soft link" cancel stays neutral; `danger` always wins.
	 * @param {string} pColor
	 * @returns {'danger'|'primary'|null}
	 */
	mapButtonEmphasis(pColor)
	{
		let tmpColor = (typeof pColor === 'string') ? pColor : '';
		if (/(^|\s)(is-)?danger(\s|$)/.test(tmpColor))
		{
			return 'danger';
		}
		if (/(^|\s)is-(soft|light)(\s|$)/.test(tmpColor))
		{
			return null;
		}
		if (/(^|\s)(is-)?(primary|link)(\s|$)/.test(tmpColor))
		{
			return 'primary';
		}
		return null;
	}

	/**
	 * Build a single Bulma footer button whose onclick resolves to the broker's
	 * kept-alive callback method. `pIconClass` is the FontAwesome glyph class WITHOUT
	 * the `fas fa-fw ` prefix (e.g. `fa-check` or `fa-check-circle`); pass null/'' for none.
	 * @param {string} pHash - 'confirm' | 'cancel' (drives the onclick method + button id suffix)
	 * @param {string} pText
	 * @param {string} pIconClass
	 * @param {string} pColorClass - raw legacy Bulma color class(es), applied verbatim to the button
	 * @param {string} [pFooterId] - optional id prefix for the button (legacy parity)
	 * @returns {string}
	 */
	buildButtonHTML(pHash, pText, pIconClass, pColorClass, pFooterId)
	{
		let tmpMethod = (pHash === 'confirm') ? 'confirmCallback' : 'cancelCallback';
		let tmpColor = (typeof pColorClass === 'string') ? pColorClass : '';
		let tmpIdAttr = pFooterId ? ' id="' + this.escapeHTML(pFooterId) + '-Button-' + (pHash === 'confirm' ? 'Confirm' : 'Cancel') + '"' : '';
		let tmpIconHTML = '';
		if (pIconClass)
		{
			// Normalize: accept 'fa-check' or bare 'check' (legacy confirmIcon default is 'check').
			let tmpGlyph = (/^fa-/.test(pIconClass)) ? pIconClass : ('fa-' + pIconClass);
			tmpIconHTML = '<span class="icon"><i class="fas fa-fw ' + this.escapeHTML(tmpGlyph) + '"></i></span>';
		}
		return '<button type="button"' + tmpIdAttr + ' class="button ' + this.escapeHTML(tmpColor) + '"' +
			' onclick="' + SERVICE_GLOBAL + '.' + tmpMethod + '()">' +
			tmpIconHTML +
			'<span> ' + this.escapeHTML(pText) + ' </span>' +
			'</button>';
	}

	/**
	 * Build the default confirm/cancel footer buttons (cancel then confirm). Returned WITHOUT
	 * a layout wrapper — the broker drops these into a real `.pict-modal-dialog-footer` band
	 * (PSM styles it as a flex/justify-end/border-top row that sits below the scrollable body),
	 * so the legacy `.columns` negative margins that used to pull the footer up into the body
	 * are gone.
	 * @param {object} pConfig - merged config (confirmText/Icon/Color, cancelText/Icon/Color, modalFooterId)
	 * @returns {string}
	 */
	buildDefaultFooterHTML(pConfig)
	{
		let tmpCancel = this.buildButtonHTML('cancel', pConfig.cancelText, pConfig.cancelIcon, pConfig.cancelColor, pConfig.modalFooterId);
		let tmpConfirm = this.buildButtonHTML('confirm', pConfig.confirmText, pConfig.confirmIcon, pConfig.confirmColor, pConfig.modalFooterId);
		return tmpCancel + tmpConfirm;
	}

	/**
	 * Build the default message body (legacy: a div at font-size 1.3rem).
	 * @param {string} pMessage
	 * @returns {string}
	 */
	buildMessageBodyHTML(pMessage)
	{
		return '<div style="font-size:1.3rem">' + this.escapeHTML(pMessage) + '</div>';
	}

	/**
	 * Build the mini-modal body: bold message + small italic subtext.
	 * @param {string} pMessage
	 * @param {string} pSubtext
	 * @param {string} [pTextColor] - optional Bulma text-color helper class
	 * @returns {string}
	 */
	buildMiniBodyHTML(pMessage, pSubtext, pTextColor)
	{
		let tmpColor = pTextColor ? (' ' + this.escapeHTML(pTextColor)) : '';
		let tmpStrongColor = pTextColor ? (' class="' + this.escapeHTML(pTextColor) + '"') : '';
		return '<p><strong' + tmpStrongColor + '>' + this.escapeHTML(pMessage) + '</strong></p>' +
			'<p class="is-size-7' + tmpColor + '"><em>' + this.escapeHTML(pSubtext) + '</em></p>';
	}

	/**
	 * Build the mini-modal footer (legacy: `.buttons.is-right.mt-2`, cancel then confirm).
	 * @param {object} pConfig
	 * @returns {string}
	 */
	buildMiniFooterHTML(pConfig)
	{
		let tmpCancel = this.buildButtonHTML('cancel', pConfig.cancelText, pConfig.cancelIcon, pConfig.cancelColor);
		let tmpConfirm = this.buildButtonHTML('confirm', pConfig.confirmText, pConfig.confirmIcon, pConfig.confirmColor);
		return '<div class="buttons is-right mt-2">' + tmpCancel + tmpConfirm + '</div>';
	}

	/**
	 * Map the legacy `style` to a PSM dialog width + wide className.
	 * @param {string} pStyle - 'small' | 'wide'
	 * @returns {{ width: (string|undefined), wideClass: (string|null) }}
	 */
	mapStyle(pStyle)
	{
		if (pStyle === 'wide')
		{
			return { width: undefined, wideClass: 'headlight-modal-wide' };
		}
		return { width: undefined, wideClass: null };
	}

	/**
	 * Translate a merged legacy config into a PSM `show()` plan the broker executes.
	 *
	 * String templates are assembled into `content` here. Live-HTMLElement templates
	 * are only FLAGGED (bodyElement/footerElement/cardElement/headerElement) — the broker
	 * appends the actual node in `onOpen` (it has the DOM; this class must not).
	 *
	 * @param {object} pConfig - merged config (defaults already applied by the service)
	 * @param {object} [pContext] - { mini: boolean }
	 * @returns {object} plan
	 */
	translate(pConfig, pContext)
	{
		let tmpConfig = pConfig || {};
		let tmpIsMini = !!(pContext && pContext.mini);

		let tmpStyle = this.mapStyle(tmpConfig.style);
		let tmpClassNames = ['headlight-modal'];
		if (tmpStyle.wideClass) { tmpClassNames.push(tmpStyle.wideClass); }
		if (tmpIsMini) { tmpClassNames.push('headlight-mini-modal'); }
		if (tmpConfig.modalBackgroundColor) { tmpClassNames.push(tmpConfig.modalBackgroundColor); }
		if (tmpConfig.modalTextColor) { tmpClassNames.push(tmpConfig.modalTextColor); }

		let tmpPlan =
		{
			primitive: 'show',
			title: '',
			content: '',
			buttons: [],
			// closeable governs BOTH PSM's × and the overlay/Escape dismiss. Legacy
			// `disableBackgroundClickToClose` (and every mini modal) means "must click a
			// button" -> not closeable. Otherwise closeable (background-click parity).
			closeable: !tmpConfig.disableBackgroundClickToClose,
			width: tmpStyle.width,
			className: tmpClassNames.join(' '),
			freezeScroll: !tmpConfig.enableBackgroundScrolling,
			focusFirstInput: true,
			customCSS: tmpConfig.modalCustomCSS || null,
			hideBackground: !!tmpConfig.hideModalBackground,
			topOffset: tmpConfig.modalTopOffset || null,
			// Default (non-mini, non-custom) footer buttons — the broker renders these in a
			// real .pict-modal-dialog-footer band (below the body), not inside the body content.
			footerContent: '',
			// Live-element flags — the broker appends these nodes in onOpen.
			cardElement: this.isElement(tmpConfig.modalCardTemplate),
			headerElement: this.isElement(tmpConfig.modalHeaderTemplate),
			bodyElement: this.isElement(tmpConfig.modalBodyTemplate),
			footerElement: this.isElement(tmpConfig.modalFooterTemplate),
			// Bucket E: a backdrop-less positioned card is really an anchored popover.
			// Flagged so the service (or a later phase) can route it to dropdown().
			isAnchoredCard: !!(tmpConfig.hideModalBackground && tmpConfig.modalCardTemplate),
		};

		// --- Full-card override: the card owns all chrome; PSM header suppressed. ---
		if (tmpConfig.modalCardTemplate)
		{
			tmpPlan.title = '';
			tmpPlan.content = tmpPlan.cardElement ? '' : String(tmpConfig.modalCardTemplate);
			return tmpPlan;
		}

		let tmpContentParts = [];

		// --- Header: PSM title when default; custom header template goes into content. ---
		if (!tmpConfig.hideModalHeader)
		{
			if (tmpConfig.modalHeaderTemplate)
			{
				if (!tmpPlan.headerElement) { tmpContentParts.push(String(tmpConfig.modalHeaderTemplate)); }
			}
			else
			{
				tmpPlan.title = (typeof tmpConfig.title === 'string') ? tmpConfig.title : '';
			}
		}

		// --- Body ---
		if (!tmpConfig.hideModalBody)
		{
			if (tmpConfig.modalBodyTemplate)
			{
				if (!tmpPlan.bodyElement) { tmpContentParts.push(String(tmpConfig.modalBodyTemplate)); }
			}
			else if (tmpIsMini)
			{
				tmpContentParts.push(this.buildMiniBodyHTML(tmpConfig.message, tmpConfig.subtext, tmpConfig.modalTextColor));
			}
			else
			{
				tmpContentParts.push(this.buildMessageBodyHTML(tmpConfig.message));
			}
		}

		// --- Footer ---
		// Custom footer templates and the mini footer stay IN the body content (the mini's
		// footer shares the colored card; custom footers are the caller's own markup). The
		// DEFAULT footer goes into footerContent so the broker renders it as a proper band.
		if (!tmpConfig.hideModalFooter)
		{
			if (tmpConfig.modalFooterTemplate)
			{
				if (!tmpPlan.footerElement) { tmpContentParts.push(String(tmpConfig.modalFooterTemplate)); }
			}
			else if (tmpIsMini)
			{
				tmpContentParts.push(this.buildMiniFooterHTML(tmpConfig));
			}
			else
			{
				tmpPlan.footerContent = this.buildDefaultFooterHTML(tmpConfig);
			}
		}

		tmpPlan.content = tmpContentParts.join('');
		return tmpPlan;
	}
}

module.exports = HeadlightModalAdapter;
module.exports.MiniModalPreset = MiniModalPreset;
module.exports.SERVICE_GLOBAL = SERVICE_GLOBAL;

},{}],272:[function(require,module,exports){
/**
 * Headlight Popover CSS
 *
 * Re-skins the pict-section-modal dropdown surface used by the HeadlightPopover
 * service (migrated off Tippy.js). Ported from the former `bulma-tippy`
 * dropdown / dropdown-dark themes, re-scoped under the wrapper's className and
 * driven by Bulma theme tokens so it follows the active light/dark theme.
 *
 * The service opens popovers via `modal.dropdown({ ContentHTML })`, which adds
 * the `pict-modal-dropdown--content` modifier (padding: 0, max-width uncapped).
 * These rules restore the menu chrome the old Tippy `dropdown` theme provided.
 */
module.exports = /*css*/`
/* Restore the inner padding the --content modifier zeroes out, and lift the
   popover above host chrome. PSM's dropdown is position:fixed at z-index 1025,
   but Headlight-Panels' shell stacks up to ~1060 (side panels 1040, navbar
   1050, navbar+10 1060), which would occlude the menu. Tippy previously used
   9999; match it so the popover clears all panel chrome as before. */
.pict-modal-dropdown.headlight-popover
{
	padding: 0.25rem;
	z-index: 9999;
}

/* Action menus rendered inside the popover template (<ul class="list-menu">). */
.headlight-popover .list-menu
{
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.headlight-popover .list-menu-item
{
	padding: 0;
	margin: 0;
}

.headlight-popover .list-menu-item a
{
	display: flex;
	align-items: center;
	padding: 0.5rem 1rem;
	color: var(--bulma-text);
	text-decoration: none;
}

.headlight-popover .list-menu-item:hover
{
	background-color: var(--bulma-background);
}

.headlight-popover .list-menu-item:hover a
{
	color: var(--bulma-primary);
}

/* Dark variant (legacy Tippy theme 'dropdown-dark'). Overrides the dropdown
   surface tokens + the list-menu hover colors. Declared after the light rules
   so it wins at equal specificity when both classes are on the element. */
.pict-modal-dropdown.headlight-popover-dark
{
	--pict-modal-dropdown-bg: var(--bulma-black-ter);
	--pict-modal-dropdown-fg: var(--bulma-white);
	--pict-modal-dropdown-border: var(--bulma-black-ter);
}

.headlight-popover-dark .list-menu-item a
{
	color: var(--bulma-primary-85);
}

.headlight-popover-dark .list-menu-item:hover
{
	background-color: var(--bulma-primary-20);
}

.headlight-popover-dark .list-menu-item:hover a
{
	color: var(--bulma-primary-85);
}
`;

},{}],273:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');
const libPictSectionModal = require('pict-section-modal');
const libHeadlightPopoverCSS = require('./Headlight-Popover-Service-CSS.js');

/**
 * HeadlightPopover
 *
 * Anchored, click-triggered popovers rendered from a Pict template hash. This
 * used to wrap Tippy.js; it now drives the pict-section-modal (PSM) dropdown in
 * `ContentHTML` mode, which gives click-outside / Escape dismissal, auto-flip,
 * viewport clamping and scroll/resize repositioning without a third-party dep.
 *
 * A caller that passes Tippy's `trigger` with `mouseenter` (entity summaries do)
 * gets Tippy's hover behaviour back: shown after `delay` while hovered, closed
 * when the pointer leaves the anchor and the popover, and kept open once the
 * anchor is clicked or focused until a click elsewhere.
 *
 * The public API (createPopover / hidePopover / showPopover / hideAll) is
 * preserved so existing call sites are untouched.
 */
class HeadlightPopoverFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }}} */
		this.fable;
		this.serviceType = 'HeadlightPopover';

		// Legacy Tippy "theme" names mapped onto wrapper CSS classes that re-skin
		// the PSM dropdown surface (see Headlight-Popover-Service-CSS.js). Only
		// 'dropdown' and 'dropdown-dark' are used by consumers.
		this.themeClassMap = {
			'dropdown': 'headlight-popover',
			'dropdown-dark': 'headlight-popover headlight-popover-dark',
		};

		// Former Tippy default; used when a caller doesn't specify maxWidth.
		this.defaultMaxWidth = '350px';

		// Hover popovers (trigger includes 'mouseenter'): how long the pointer may be off both the anchor and the
		// popover, crossing between them, before it closes.
		this.hoverCloseGraceMS = 120;

		// Register the wrapper's CSS once, so the popover surface is themed even
		// in apps that never render the PSM view directly.
		if (this.fable && this.fable.CSSMap && typeof this.fable.CSSMap.addCSS === 'function')
		{
			this.fable.CSSMap.addCSS('Headlight-Popover-CSS', libHeadlightPopoverCSS, 500);
		}
	}

	/**
	 * @description Resolves the pict-section-modal view, registering it as a
	 *   singleton on first use if the host app hasn't already. Popover consumers
	 *   live in apps (e.g. headlight_panels) that don't register PSM themselves,
	 *   so the wrapper self-registers to stay a drop-in service.
	 * @returns {Object|null} The PSM view instance, or null if unavailable.
	 */
	_getModal()
	{
		if (!this.fable || !this.fable.views)
		{
			this.fable.log.error('HeadlightPopoverFableService: pict-section-modal is unavailable (no views registry)');
			return false;
		}
		let tmpModal = this.fable.views['Pict-Section-Modal'];
		if (!tmpModal && typeof this.fable.addViewSingleton === 'function')
		{
			this.fable.addViewSingleton('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
			tmpModal = this.fable.views['Pict-Section-Modal'];
		}
		if (!tmpModal)
		{
			this.fable.log.error('HeadlightPopoverFableService: could not resolve the Pict-Section-Modal view');
			return false;
		}
		return tmpModal;
	}

	/**
	 * @description Maps a legacy popover configuration onto PSM dropdown options.
	 * @param {Object} pConfiguration - The createPopover configuration.
	 * @returns {Object} Options for modal.dropdown().
	 */
	_mapDropdownOptions(pConfiguration)
	{
		const tmpTheme = pConfiguration.theme || 'dropdown';
		const tmpOptions =
		{
			className: this.themeClassMap[tmpTheme] || this.themeClassMap['dropdown'],
		};

		// maxWidth: Tippy accepted a number (px) or a CSS string.
		if (pConfiguration.maxWidth)
		{
			tmpOptions.maxWidth = (typeof pConfiguration.maxWidth === 'number')
				? pConfiguration.maxWidth + 'px'
				: pConfiguration.maxWidth;
		}
		else
		{
			tmpOptions.maxWidth = this.defaultMaxWidth;
		}

		// placement (Tippy) -> align / position (PSM), best-effort. PSM has no
		// true left/right side placement, so those fall back to auto-flip below/
		// above (documented gap). Only 'top*' forces above; everything else keeps
		// PSM's auto-flip. A trailing '-end' aligns to the anchor's right edge.
		const tmpPlacement = pConfiguration.placement || '';
		if (tmpPlacement.indexOf('top') === 0)
		{
			tmpOptions.position = 'above';
		}
		tmpOptions.align = (tmpPlacement.indexOf('-end') > -1) ? 'right' : 'left';
		if (pConfiguration.align)
		{
			tmpOptions.align = pConfiguration.align;
		}

		return tmpOptions;
	}

	/**
	 * @description Creates (and immediately opens) a popover from a Pict template.
	 * @param {Object} pConfiguration - Configuration for the popover
	 * @param {string} pConfiguration.PopoverTemplateHash - The template hash for the popover content
	 * @param {string} pConfiguration.PopoverDestinationAddress - The ID of the element to anchor the popover to
	 * @param {Object} pConfiguration.PopoverTemplateRecord - The record to use for the template
	 * @returns {boolean} - Returns true if the popover was created successfully, false otherwise
	 */
	createPopover(pConfiguration)
	{
		if (!pConfiguration)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No configuration provided');
			return false;
		}
		if (!pConfiguration.PopoverTemplateHash)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No template hash provided (should be a Pict-TemplateHash string)');
			return false;
		}
		if (!pConfiguration.PopoverDestinationAddress)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No destination address provided (should be an ID string)');
			return false;
		}
		// if they passed over an element, warn them it should be an id
		if (typeof pConfiguration.PopoverDestinationAddress === 'object')
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: PopoverDestinationAddress should be passed an ID, not an element object');
			return false;
		}
		// if they passed an id with a leading #, remove it
		if (pConfiguration.PopoverDestinationAddress.startsWith('#'))
		{
			pConfiguration.PopoverDestinationAddress = pConfiguration.PopoverDestinationAddress.substring(1);
			this.fable.log.warn('HeadlightPopoverFableService: createPopover: PopoverDestinationAddress should not have a leading #, removing it');
		}
		// find the anchor element by ID
		const tmpAnchorElement = document.getElementById(pConfiguration.PopoverDestinationAddress);
		if (!tmpAnchorElement)
		{
			this.fable.log.error('HeadlightPopoverFableService: createPopover: No anchor element found');
			return false;
		}

		const tmpModal = this._getModal();
		if (!tmpModal)
		{
			return false;
		}

		// Render the template to HTML and hand it to the dropdown verbatim.
		const tmpRecord = pConfiguration.PopoverTemplateRecord;
		// @ts-ignore - parseTemplateByHash is provided by the pict instance
		const tmpContentHTML = this.fable.parseTemplateByHash(pConfiguration.PopoverTemplateHash, tmpRecord);

		const tmpOptions = this._mapDropdownOptions(pConfiguration);
		tmpOptions.ContentHTML = tmpContentHTML;

		// Ensure the PSM + wrapper CSS is present (the modal view is never
		// rendered through the normal cycle, so inject explicitly).
		if (this.fable.CSSMap && typeof this.fable.CSSMap.injectCSS === 'function')
		{
			this.fable.CSSMap.injectCSS();
		}

		if (this._isHoverTrigger(pConfiguration.trigger))
		{
			this._openHoverPopover(tmpModal, tmpAnchorElement, tmpOptions, pConfiguration.delay);
			return true;
		}
		tmpModal.dropdown(tmpAnchorElement, tmpOptions);
		return true;
	}

	/**
	 * @param {string} [pTrigger] - A Tippy-style trigger list, e.g. 'mouseenter focusin click'.
	 * @returns {boolean} true when the popover should follow the pointer (Tippy's `mouseenter` trigger)
	 */
	_isHoverTrigger(pTrigger)
	{
		return (typeof pTrigger === 'string') && (pTrigger.split(/\s+/).indexOf('mouseenter') > -1);
	}

	/**
	 * @param {number|Array<number>} [pDelay] - Tippy-style delay: ms, or [show, hide].
	 * @returns {number} the show delay in ms
	 */
	_showDelay(pDelay)
	{
		const tmpDelay = Array.isArray(pDelay) ? pDelay[0] : pDelay;
		return Math.max(0, Number(tmpDelay) || 0);
	}

	/**
	 * Hover state for an anchor, with its listeners attached once (as Tippy attached its triggers to the anchor):
	 * - pressing or focusing the anchor pins the popover, which then stays until a click elsewhere or Escape;
	 * - otherwise it closes once the pointer has left both the anchor and the popover.
	 * @param {HTMLElement} pAnchor
	 * @returns {{ Hovered: boolean, HoverStart: number, Pinned: boolean, Menu: ?HTMLElement, Timer: any }}
	 */
	_hoverState(pAnchor)
	{
		if (pAnchor._headlightPopoverHover)
		{
			return pAnchor._headlightPopoverHover;
		}
		let tmpHovered = true;
		try
		{
			// The first call comes from the anchor's own mouseover, before these listeners exist.
			tmpHovered = pAnchor.matches(':hover');
		}
		catch (pError)
		{
			tmpHovered = true;
		}
		const tmpState = { Hovered: tmpHovered, HoverStart: Date.now(), Pinned: false, Menu: null, Timer: null };
		pAnchor._headlightPopoverHover = tmpState;
		pAnchor.addEventListener('mouseenter', () =>
		{
			tmpState.Hovered = true;
			tmpState.HoverStart = Date.now();
		});
		pAnchor.addEventListener('mouseleave', () =>
		{
			tmpState.Hovered = false;
			this._scheduleHoverClose(pAnchor);
		});
		const fPin = () =>
		{
			tmpState.Pinned = true;
		};
		pAnchor.addEventListener('mousedown', fPin);
		pAnchor.addEventListener('focusin', fPin);
		return tmpState;
	}

	/**
	 * Open a hover popover: right away when pinned, otherwise after the show delay and only if the pointer is still
	 * on the anchor.
	 * @param {Object} pModal - the PSM view
	 * @param {HTMLElement} pAnchor
	 * @param {Object} pOptions - modal.dropdown() options
	 * @param {number|Array<number>} [pDelay]
	 */
	_openHoverPopover(pModal, pAnchor, pOptions, pDelay)
	{
		const tmpState = this._hoverState(pAnchor);
		clearTimeout(tmpState.Timer);
		const fOpen = () =>
		{
			if (!tmpState.Pinned && !tmpState.Hovered)
			{
				return;
			}
			if (tmpState.Menu && tmpState.Menu.isConnected && !tmpState.Menu._dismissed)
			{
				return;
			}
			const tmpOnClose = pOptions.onClose;
			pOptions.onClose = (pResult) =>
			{
				tmpState.Menu = null;
				tmpState.Pinned = false;
				if (typeof tmpOnClose === 'function')
				{
					tmpOnClose(pResult);
				}
			};
			pModal.dropdown(pAnchor, pOptions);
			// PSM appends the menu to <body> synchronously.
			const tmpMenu = document.body.lastElementChild;
			if (!tmpMenu || !tmpMenu.classList.contains('pict-modal-dropdown'))
			{
				return;
			}
			tmpState.Menu = tmpMenu;
			tmpMenu._headlightPopoverHovered = false;
			tmpMenu.addEventListener('mouseenter', () =>
			{
				tmpMenu._headlightPopoverHovered = true;
			});
			tmpMenu.addEventListener('mouseleave', () =>
			{
				tmpMenu._headlightPopoverHovered = false;
				this._scheduleHoverClose(pAnchor);
			});
			// Clicking inside (selecting text, following a link) pins it too.
			tmpMenu.addEventListener('mousedown', () =>
			{
				tmpState.Pinned = true;
			});
		};
		const tmpWait = tmpState.Pinned ? 0 : (this._showDelay(pDelay) - (Date.now() - tmpState.HoverStart));
		if (tmpWait > 0)
		{
			tmpState.Timer = setTimeout(fOpen, tmpWait);
			return;
		}
		fOpen();
	}

	/**
	 * Close an unpinned hover popover once the pointer is off both the anchor and the popover. The short grace lets
	 * the pointer cross the gap from the anchor into the popover (Tippy's interactive border).
	 * @param {HTMLElement} pAnchor
	 */
	_scheduleHoverClose(pAnchor)
	{
		const tmpState = pAnchor._headlightPopoverHover;
		if (!tmpState)
		{
			return;
		}
		clearTimeout(tmpState.Timer);
		tmpState.Timer = setTimeout(() =>
		{
			const tmpMenu = tmpState.Menu;
			if (tmpState.Pinned || tmpState.Hovered || !tmpMenu || tmpMenu._headlightPopoverHovered)
			{
				return;
			}
			const tmpModal = this.fable.views && this.fable.views['Pict-Section-Modal'];
			// PSM keeps one dropdown open; only close it if it is still this anchor's.
			if (tmpModal && tmpMenu.isConnected && !tmpMenu._dismissed)
			{
				tmpModal.dismissDropdowns();
			}
		}, this.hoverCloseGraceMS);
	}

	/**
	 * @description Manual "show" hook. Retained for API compatibility; with the
	 *   PSM dropdown a popover opens on createPopover(), so there is no separate
	 *   show step. No external callers use this.
	 * @returns {Boolean}
	 */
	showPopover()
	{
		this.fable.log.warn('HeadlightPopoverFableService: showPopover is a no-op; popovers open on createPopover()');
		return false;
	}

	/**
	 * @description Hides the open popover (PSM keeps a single dropdown open at a
	 *   time, so this dismisses whichever popover is showing). Arguments are
	 *   accepted for API compatibility but ignored.
	 * @returns {Boolean}
	 */
	hidePopover()
	{
		const tmpModal = this.fable.views && this.fable.views['Pict-Section-Modal'];
		if (!tmpModal)
		{
			return false;
		}
		tmpModal.dismissDropdowns();
		return true;
	}

	/**
	 * @description Hides all popovers created by this service.
	 * @returns {Boolean}
	 */
	hideAll()
	{
		const tmpModal = this.fable.views && this.fable.views['Pict-Section-Modal'];
		if (!tmpModal)
		{
			return false;
		}
		tmpModal.dismissDropdowns();
		return true;
	}
}

module.exports = HeadlightPopoverFableService;
module.exports.default_configuration = {};

},{"./Headlight-Popover-Service-CSS.js":272,"fable-serviceproviderbase":438,"pict-section-modal":690}],274:[function(require,module,exports){
/**
 * headlight-qrcode-web — attach HeadLight QR scanning, printing and form inputs to a pict app.
 *
 *     const HeadlightQRCodeBundle = require('headlight-qrcode-web');
 *     new HeadlightQRCodeBundle(pict).attach({ HeadlightQR: { EntitySource, DestinationResolver, Wedge: { Enabled: true } } });
 *
 * Plain pict-section-form apps get the `QRCode` input under the default template prefixes; HeadLight
 * apps on the Bulma themes pass `TemplatePrefixes` for their Edit/Read/Print themes.
 */

const libLabels = require('./labels/Label-Renderer.js');

/** @type {Record<string, any>} */
const providers =
{
	'HeadlightQR': require('./providers/Pict-Provider-HeadlightQR.js'),
	'HeadlightQR-Input': require('./providers/Pict-Provider-HeadlightQR-Input.js'),
};

/** @type {Record<string, any>} */
const views =
{
	'HeadlightQR-ModeBar': require('./views/PictView-HeadlightQR-ModeBar.js'),
	'HeadlightQR-Camera': require('./views/PictView-HeadlightQR-Camera.js'),
	'HeadlightQR-ResultSheet': require('./views/PictView-HeadlightQR-ResultSheet.js'),
	'HeadlightQR-PrintDialog': require('./views/PictView-HeadlightQR-PrintDialog.js'),
};

const templates = require('./templates/InputType-QRCode.js');

/** Default prefixes: plain pict-section-form editable and read-only template sets. */
const DEFAULT_TEMPLATE_PREFIXES =
{
	Edit: [ 'Pict-MT-Base' ],
	Read: [ 'Pict-Forms-ReadOnly' ],
	Print: [],
};

/** Prefixes for HeadLight apps using headlight-dynamic-inputs-bundle themes. */
const HEADLIGHT_THEME_PREFIXES =
{
	Edit: [ 'PictProvider-Theme-Edit' ],
	Read: [ 'PictProvider-Theme-Read' ],
	Print: [ 'PictProvider-Theme-Print' ],
};

const INPUT_CSS = /*css*/`
.hlqr-input { margin: 0.5rem 0 1rem; }
.hlqr-input-label { display: block; font-weight: 600; margin-bottom: 0.35rem; }
.hlqr-input-body { display: flex; gap: 1rem; align-items: flex-start; flex-wrap: wrap; }
.hlqr-input-image { line-height: 0; }
.hlqr-input-image svg { display: block; }
.hlqr-input-empty { display: flex; align-items: center; justify-content: center; border: 1px dashed var(--theme-color-border-default, #c5ccd3); border-radius: 6px; font-size: 0.8rem; line-height: 1.2; opacity: 0.7; text-align: center; }
.hlqr-input-controls { flex: 1 1 14rem; min-width: 12rem; }
.hlqr-input-text { width: 100%; padding: 0.4rem 0.55rem; border: 1px solid var(--theme-color-border-default, #c5ccd3); border-radius: 6px; font-family: ui-monospace, Menlo, Consolas, monospace; }
.hlqr-input-value { font-family: ui-monospace, Menlo, Consolas, monospace; word-break: break-all; }
.hlqr-input-buttons { display: flex; flex-wrap: wrap; gap: 0.4rem; margin-top: 0.5rem; }
.hlqr-input-button { border: 1px solid var(--theme-color-border-default, #c5ccd3); background: transparent; color: inherit; border-radius: 6px; padding: 0.3rem 0.75rem; cursor: pointer; font-size: 0.85rem; }
.hlqr-input-message { font-size: 0.85rem; margin-top: 0.35rem; color: #b91c1c; }
`;

class HeadlightQRCodeBundle
{
	static getProviderMap()
	{
		return providers;
	}

	static getViewMap()
	{
		return views;
	}

	/** @return {{ Edit: Array<any>, Read: Array<any>, Print: Array<any> }} */
	static getTemplates()
	{
		return templates;
	}

	/**
	 * @param {any} pPict
	 */
	constructor(pPict)
	{
		this.pict = pPict;
	}

	/**
	 * Register providers, views, input templates and styles.
	 *
	 * @param {Object} [pOptions]
	 * @param {Object} [pOptions.HeadlightQR] - Options for the HeadlightQR provider.
	 * @param {Record<string, Object>} [pOptions.Views] - Options per view hash.
	 * @param {{ Edit?: Array<string>, Read?: Array<string>, Print?: Array<string> }} [pOptions.TemplatePrefixes]
	 * @return {any} the HeadlightQR provider
	 */
	attach(pOptions)
	{
		const tmpOptions = pOptions || {};
		this.pict.addProviderSingleton('HeadlightQR', tmpOptions.HeadlightQR || {}, providers.HeadlightQR);
		this.pict.addProviderSingleton('HeadlightQR-Input', {}, providers['HeadlightQR-Input']);
		for (const [ tmpHash, tmpView ] of Object.entries(views))
		{
			this.pict.addViewSingleton(tmpHash, (tmpOptions.Views && tmpOptions.Views[tmpHash]) || {}, tmpView);
		}
		this.injectTemplates(tmpOptions.TemplatePrefixes || DEFAULT_TEMPLATE_PREFIXES);
		this.pict.CSSMap.addCSS('HeadlightQR-Input', INPUT_CSS);
		this.pict.CSSMap.addCSS('HeadlightQR-Labels', libLabels.LABEL_CSS);
		return this.pict.providers.HeadlightQR;
	}

	/**
	 * @param {{ Edit?: Array<string>, Read?: Array<string>, Print?: Array<string> }} pPrefixes
	 */
	injectTemplates(pPrefixes)
	{
		// Templates are added one by one: injectTemplateSet would also re-add every pict-section-form
		// default under the prefix, overwriting a host theme's own templates.
		const tmpDynamicInput = this.pict.providers.DynamicInput;
		for (const tmpTheme of [ 'Edit', 'Read', 'Print' ])
		{
			for (const tmpPrefix of (pPrefixes[tmpTheme] || []))
			{
				for (const tmpTemplate of templates[tmpTheme])
				{
					const tmpHash = `${tmpPrefix}${tmpTemplate.HashPostfix}`;
					this.pict.TemplateProvider.addTemplate(tmpHash, tmpTemplate.Template);
					if (tmpDynamicInput)
					{
						for (const tmpExtension of tmpTemplate.DefaultInputExtensions)
						{
							tmpDynamicInput.addDefaultInputProvider(tmpHash, tmpExtension);
						}
					}
				}
			}
		}
	}
}

module.exports = HeadlightQRCodeBundle;
module.exports.DEFAULT_TEMPLATE_PREFIXES = DEFAULT_TEMPLATE_PREFIXES;
module.exports.HEADLIGHT_THEME_PREFIXES = HEADLIGHT_THEME_PREFIXES;
module.exports.RestEntitySource = require('./entity-sources/Rest-Entity-Source.js');
module.exports.Labels = libLabels;
module.exports.MediaPresets = require('./labels/Label-Media-Presets.js');
module.exports.QRMatrix = require('./rendering/QR-Matrix.js');
module.exports.WedgeBurstDetector = require('./scanning/Wedge-Burst-Detector.js');
module.exports.ScanGeolocation = require('./scanning/Scan-Geolocation.js');

},{"./entity-sources/Rest-Entity-Source.js":275,"./labels/Label-Media-Presets.js":276,"./labels/Label-Renderer.js":277,"./providers/Pict-Provider-HeadlightQR-Input.js":279,"./providers/Pict-Provider-HeadlightQR.js":280,"./rendering/QR-Matrix.js":281,"./scanning/Scan-Geolocation.js":283,"./scanning/Wedge-Burst-Detector.js":284,"./templates/InputType-QRCode.js":286,"./views/PictView-HeadlightQR-Camera.js":287,"./views/PictView-HeadlightQR-ModeBar.js":288,"./views/PictView-HeadlightQR-PrintDialog.js":289,"./views/PictView-HeadlightQR-ResultSheet.js":290}],275:[function(require,module,exports){
/**
 * Entity source backed by the HeadLight API, read as the signed-in user.
 *
 * Reads include soft-deleted rows (`includeDeleted=true`, honoured by the API's read routes), so a
 * scan of a label whose record was deleted can say so instead of "not found".
 */

/**
 * @typedef {Object} EntityRequest
 * @property {import('headlight-qrcode/source/Headlight-QRCode-EntityRegistry.js').EntityDefinition} Definition
 * @property {'qr'|'guid'|'id'} Key
 * @property {string} Value
 * @property {boolean} [IncludeDeleted]
 */

class RestEntitySource
{
	/**
	 * @param {Object} pOptions
	 * @param {(pURL: string) => Promise<any>} pOptions.getJSON - Reads an API path relative to /1.0/, e.g. HeadlightRestClient.getJSON.
	 * @param {number} [pOptions.MaxRows] - Rows read per lookup (duplicates beyond this are not seen). Default 10.
	 */
	constructor(pOptions)
	{
		this.getJSON = pOptions.getJSON;
		this.maxRows = pOptions.MaxRows || 10;
	}

	/**
	 * @param {EntityRequest} pRequest
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	async find(pRequest)
	{
		const tmpDefinition = pRequest.Definition;
		const tmpDeleted = pRequest.IncludeDeleted ? '?includeDeleted=true' : '';
		if (pRequest.Key === 'id')
		{
			const tmpRecord = await this.getJSON(`${tmpDefinition.Entity}/${encodeURIComponent(pRequest.Value)}${tmpDeleted}`);
			return (tmpRecord && !tmpRecord.Error && tmpRecord[tmpDefinition.IDColumn]) ? [ tmpRecord ] : [];
		}
		const tmpColumn = (pRequest.Key === 'guid') ? tmpDefinition.GUIDColumn : tmpDefinition.Column;
		if (!tmpColumn)
		{
			return [];
		}
		const tmpFilter = `FBV~${tmpColumn}~EQ~${encodeURIComponent(pRequest.Value)}`;
		const tmpRows = await this.getJSON(`${tmpDefinition.Entity}s/FilteredTo/${tmpFilter}/0/${this.maxRows}${tmpDeleted}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	/**
	 * @param {number} pIDUser
	 * @return {Promise<string|null>}
	 */
	async getUserName(pIDUser)
	{
		if (!pIDUser)
		{
			return null;
		}
		try
		{
			const tmpUser = await this.getJSON(`User/${encodeURIComponent(pIDUser)}?includeDeleted=true`);
			if (tmpUser && !tmpUser.Error && (tmpUser.NameFirst || tmpUser.NameLast))
			{
				return `${tmpUser.NameFirst || ''} ${tmpUser.NameLast || ''}`.trim();
			}
		}
		catch (pError)
		{
			return null;
		}
		return null;
	}
}

module.exports = RestEntitySource;

},{}],276:[function(require,module,exports){
/**
 * Label media HeadLight customers print on. All dimensions in millimetres.
 *
 * Roll media print one label per page; sheet media lay labels out on a Letter page.
 * Sheet geometry follows Avery's published templates for the 5160/5163/5164 family
 * (the 52xx weatherproof stock shares the same layout).
 */

/**
 * @typedef {Object} MediaPreset
 * @property {string} Id
 * @property {string} Name
 * @property {'Roll'|'Sheet'} Kind
 * @property {boolean} [Continuous] - Cut from a continuous roll, not die-cut: a finished label image prints at the top rather than centred.
 * @property {number} LabelWidthMM
 * @property {number} LabelHeightMM
 * @property {number} DPI - Printer resolution, for whole-dot module sizing.
 * @property {'Side'|'Stack'} Layout - Code beside the text, or above it.
 * @property {number} [MarginMM] - Inner margin of each label.
 * @property {number} [PageWidthMM] - Sheets only.
 * @property {number} [PageHeightMM] - Sheets only.
 * @property {number} [Columns]
 * @property {number} [Rows]
 * @property {number} [TopMM]
 * @property {number} [LeftMM]
 * @property {number} [PitchXMM]
 * @property {number} [PitchYMM]
 */

const INCH = 25.4;

/** @type {Array<MediaPreset>} */
const MEDIA_PRESETS =
[
	{ Id: 'brother-62x100', Name: 'Brother QL 62 mm continuous, cut at 100 mm (DK-2205)', Kind: 'Roll', Continuous: true, LabelWidthMM: 62, LabelHeightMM: 100, DPI: 300, Layout: 'Stack', MarginMM: 3 },
	{ Id: 'brother-62x29', Name: 'Brother QL 62 × 29 mm address label (DK-1209)', Kind: 'Roll', LabelWidthMM: 62, LabelHeightMM: 29, DPI: 300, Layout: 'Side', MarginMM: 1.5 },
	{ Id: 'dymo-30370', Name: 'Dymo LabelWriter 30370 (54 × 59 mm)', Kind: 'Roll', LabelWidthMM: 54, LabelHeightMM: 59, DPI: 300, Layout: 'Stack', MarginMM: 2.5 },
	{ Id: 'square-52', Name: 'Square 52 × 52 mm', Kind: 'Roll', LabelWidthMM: 52, LabelHeightMM: 52, DPI: 203, Layout: 'Stack', MarginMM: 2 },
	{ Id: 'zebra-4x6', Name: 'Zebra 4″ × 6″ (GK420t and similar, 203 dpi)', Kind: 'Roll', LabelWidthMM: 4 * INCH, LabelHeightMM: 6 * INCH, DPI: 203, Layout: 'Stack', MarginMM: 4 },
	{ Id: 'avery-5160', Name: 'Avery 5160 / 5260 — 1″ × 2⅝″, 30 per sheet', Kind: 'Sheet', LabelWidthMM: 2.625 * INCH, LabelHeightMM: 1 * INCH, DPI: 600, Layout: 'Side', MarginMM: 1.5, PageWidthMM: 8.5 * INCH, PageHeightMM: 11 * INCH, Columns: 3, Rows: 10, TopMM: 0.5 * INCH, LeftMM: 0.1875 * INCH, PitchXMM: 2.75 * INCH, PitchYMM: 1 * INCH },
	{ Id: 'avery-5163', Name: 'Avery 5163 / 5263 — 2″ × 4″, 10 per sheet', Kind: 'Sheet', LabelWidthMM: 4 * INCH, LabelHeightMM: 2 * INCH, DPI: 600, Layout: 'Side', MarginMM: 3, PageWidthMM: 8.5 * INCH, PageHeightMM: 11 * INCH, Columns: 2, Rows: 5, TopMM: 0.5 * INCH, LeftMM: 0.15625 * INCH, PitchXMM: 4.1875 * INCH, PitchYMM: 2 * INCH },
	{ Id: 'avery-5164', Name: 'Avery 5164 / 5264 — 3⅓″ × 4″, 6 per sheet', Kind: 'Sheet', LabelWidthMM: 4 * INCH, LabelHeightMM: (10 / 3) * INCH, DPI: 600, Layout: 'Stack', MarginMM: 4, PageWidthMM: 8.5 * INCH, PageHeightMM: 11 * INCH, Columns: 2, Rows: 3, TopMM: 0.5 * INCH, LeftMM: 0.15625 * INCH, PitchXMM: 4.1875 * INCH, PitchYMM: (10 / 3) * INCH },
];

/**
 * @param {string} pId
 * @return {MediaPreset|null}
 */
function getMediaPreset(pId)
{
	return MEDIA_PRESETS.find((pPreset) => pPreset.Id === pId) || null;
}

module.exports =
{
	MEDIA_PRESETS,
	getMediaPreset,
};

},{}],277:[function(require,module,exports){
/**
 * Lay out QR labels in millimetres for a media preset.
 *
 * The code is sized to a whole number of printer dots per module, so a thermal printer never has
 * to split a module across dots. HTML output is used for browser printing (vector, the driver
 * rasterises); canvas output is used for native bridges that need an image.
 */

const libMatrix = require('../rendering/QR-Matrix.js');

const POINTS_PER_MM = 72 / 25.4;
const GAP_MM = 2;

/**
 * @typedef {Object} LabelContent
 * @property {string} Payload - Text encoded in the code.
 * @property {Array<string>} [Lines] - Text printed beside or under the code; the first line is emphasised.
 * @property {string} [Image] - A finished label image (data URL), printed fitted to the label instead of laying out Payload and Lines.
 * @property {number} [ImageWidth] - The image's pixel size; when its orientation differs from the label's, it is turned a quarter.
 * @property {number} [ImageHeight]
 */

/**
 * @typedef {Object} LabelPlan
 * @property {import('../rendering/QR-Matrix.js').QRMatrix} Matrix
 * @property {number} ModuleMM
 * @property {number} CodeMM - Printed width of the code including its quiet zone.
 * @property {number} DotsPerModule
 * @property {number} FontPT
 * @property {Array<{ Code: string, Message: string }>} Warnings
 */

/**
 * @param {import('./Label-Media-Presets.js').MediaPreset} pPreset
 * @param {LabelContent} pLabel
 * @param {Object} [pOptions]
 * @param {'L'|'M'|'Q'|'H'} [pOptions.ErrorCorrection]
 * @param {number} [pOptions.MinModuleMM] - Below this a warning is raised. Defaults to 0.5.
 * @return {LabelPlan}
 */
function planLabel(pPreset, pLabel, pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpMinModuleMM = tmpOptions.MinModuleMM || 0.5;
	const tmpMatrix = libMatrix.createMatrix(pLabel.Payload, { ErrorCorrection: tmpOptions.ErrorCorrection || 'Q' });
	const tmpTotalModules = tmpMatrix.Size + (2 * libMatrix.QUIET_ZONE_MODULES);
	const tmpMargin = pPreset.MarginMM || 2;
	const tmpInnerWidth = pPreset.LabelWidthMM - (2 * tmpMargin);
	const tmpInnerHeight = pPreset.LabelHeightMM - (2 * tmpMargin);
	const tmpLineCount = Math.max(1, (pLabel.Lines || []).length);

	let tmpCodeSpace = 0;
	if (pPreset.Layout === 'Side')
	{
		tmpCodeSpace = Math.min(tmpInnerHeight, tmpInnerWidth * 0.5);
	}
	else
	{
		const tmpTextReserve = Math.min(tmpInnerHeight * 0.4, tmpLineCount * 4.5);
		tmpCodeSpace = Math.min(tmpInnerWidth, tmpInnerHeight - tmpTextReserve - GAP_MM);
	}

	const tmpDots = Math.max(1, Math.floor((tmpCodeSpace / tmpTotalModules) * pPreset.DPI / 25.4));
	const tmpModuleMM = (tmpDots * 25.4) / pPreset.DPI;
	const tmpCodeMM = tmpModuleMM * tmpTotalModules;

	const tmpTextHeight = (pPreset.Layout === 'Side') ? tmpInnerHeight : (tmpInnerHeight - tmpCodeMM - GAP_MM);
	const tmpLineHeightMM = Math.min(tmpTextHeight / tmpLineCount, 4.5);
	const tmpFontPT = Math.max(5, Math.round((tmpLineHeightMM * POINTS_PER_MM * 0.78) * 10) / 10);

	const tmpWarnings = [];
	if (tmpModuleMM < tmpMinModuleMM)
	{
		tmpWarnings.push({ Code: 'ModuleTooSmall', Message: `Each square prints at ${tmpModuleMM.toFixed(2)} mm; phones need at least ${tmpMinModuleMM} mm. Use larger labels or a shorter code.` });
	}
	if (tmpLineHeightMM < 2.2)
	{
		tmpWarnings.push({ Code: 'TextTooSmall', Message: 'The text lines will print very small on this label.' });
	}
	return { Matrix: tmpMatrix, ModuleMM: tmpModuleMM, CodeMM: tmpCodeMM, DotsPerModule: tmpDots, FontPT: tmpFontPT, Warnings: tmpWarnings };
}

/**
 * @param {number} pValue
 * @return {string}
 */
function mm(pValue)
{
	return `${Math.round(pValue * 1000) / 1000}mm`;
}

/**
 * One label as HTML, sized in millimetres.
 *
 * @param {import('./Label-Media-Presets.js').MediaPreset} pPreset
 * @param {LabelContent} pLabel
 * @param {Object} [pOptions] - Passed to planLabel.
 * @return {{ HTML: string, Plan: LabelPlan }}
 */
function renderLabelHTML(pPreset, pLabel, pOptions)
{
	if (pLabel.Image)
	{
		return { HTML: renderImageLabelHTML(pPreset, pLabel), Plan: null };
	}
	const tmpPlan = planLabel(pPreset, pLabel, pOptions);
	const tmpSVG = libMatrix.toSVG(tmpPlan.Matrix, { Width: mm(tmpPlan.CodeMM) });
	const tmpLines = (pLabel.Lines || []).map((pLine, pIndex) =>
		`<div class="hlqr-label-line${pIndex === 0 ? ' hlqr-label-line--first' : ''}">${libMatrix.escapeXML(pLine)}</div>`).join('');
	const tmpHTML = `<div class="hlqr-label hlqr-label--${pPreset.Layout === 'Side' ? 'side' : 'stack'}" style="width:${mm(pPreset.LabelWidthMM)};height:${mm(pPreset.LabelHeightMM)};padding:${mm(pPreset.MarginMM || 2)};">`
		+ `<div class="hlqr-label-code">${tmpSVG}</div>`
		+ `<div class="hlqr-label-text" style="font-size:${tmpPlan.FontPT}pt;">${tmpLines}</div>`
		+ `</div>`;
	return { HTML: tmpHTML, Plan: tmpPlan };
}

/**
 * @param {import('./Label-Media-Presets.js').MediaPreset} pPreset
 * @param {LabelContent} pLabel
 * @return {boolean} true when the image fits better turned a quarter
 */
function isImageTurned(pPreset, pLabel)
{
	if (!pLabel.ImageWidth || !pLabel.ImageHeight || (pLabel.ImageWidth === pLabel.ImageHeight) || (pPreset.LabelWidthMM === pPreset.LabelHeightMM))
	{
		return false;
	}
	return (pLabel.ImageWidth > pLabel.ImageHeight) !== (pPreset.LabelWidthMM > pPreset.LabelHeightMM);
}

/**
 * A finished label image, fitted inside the label's margins.
 *
 * @param {import('./Label-Media-Presets.js').MediaPreset} pPreset
 * @param {LabelContent} pLabel
 * @return {string}
 */
function renderImageLabelHTML(pPreset, pLabel)
{
	const tmpMargin = pPreset.MarginMM || 2;
	const tmpInnerWidth = pPreset.LabelWidthMM - (2 * tmpMargin);
	const tmpInnerHeight = pPreset.LabelHeightMM - (2 * tmpMargin);
	const tmpSource = libMatrix.escapeXML(pLabel.Image);
	const tmpImage = isImageTurned(pPreset, pLabel)
		? `<img src="${tmpSource}" alt="" style="position:absolute;left:50%;top:50%;width:${mm(tmpInnerHeight)};height:${mm(tmpInnerWidth)};object-fit:contain;transform:translate(-50%,-50%) rotate(90deg);">`
		: `<img src="${tmpSource}" alt="" style="width:100%;height:100%;object-fit:contain;${pPreset.Continuous ? 'object-position:center top;' : ''}">`;
	return `<div class="hlqr-label hlqr-label--image" style="width:${mm(pPreset.LabelWidthMM)};height:${mm(pPreset.LabelHeightMM)};padding:${mm(tmpMargin)};">`
		+ `<div class="hlqr-label-image">${tmpImage}</div></div>`;
}

/**
 * A complete print job: pages of labels plus the `@page` rule for the media.
 *
 * @param {import('./Label-Media-Presets.js').MediaPreset} pPreset
 * @param {Array<LabelContent>} pLabels
 * @param {Object} [pOptions]
 * @param {number} [pOptions.StartIndex] - Sheets only: first cell to use on the first sheet (0-based), for partly used sheets.
 * @return {{ HTML: string, PageCSS: string, Plans: Array<LabelPlan> }}
 */
function renderPrintJob(pPreset, pLabels, pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpPlans = [];
	const tmpRendered = pLabels.map((pLabel) =>
	{
		const tmpLabel = renderLabelHTML(pPreset, pLabel, tmpOptions);
		if (tmpLabel.Plan)
		{
			tmpPlans.push(tmpLabel.Plan);
		}
		return tmpLabel.HTML;
	});

	if (pPreset.Kind !== 'Sheet')
	{
		const tmpPages = tmpRendered.map((pHTML) => `<div class="hlqr-print-page" style="width:${mm(pPreset.LabelWidthMM)};height:${mm(pPreset.LabelHeightMM)};">${pHTML}</div>`).join('');
		return { HTML: tmpPages, PageCSS: `@page { size: ${mm(pPreset.LabelWidthMM)} ${mm(pPreset.LabelHeightMM)}; margin: 0; }`, Plans: tmpPlans };
	}

	const tmpPerSheet = pPreset.Columns * pPreset.Rows;
	const tmpStart = Math.max(0, Math.min(tmpPerSheet - 1, tmpOptions.StartIndex || 0));
	const tmpSheets = [];
	let tmpCells = [];
	let tmpCellIndex = tmpStart;
	for (const tmpHTML of tmpRendered)
	{
		const tmpColumn = tmpCellIndex % pPreset.Columns;
		const tmpRow = Math.floor(tmpCellIndex / pPreset.Columns);
		tmpCells.push(`<div class="hlqr-sheet-cell" style="left:${mm(pPreset.LeftMM + (tmpColumn * pPreset.PitchXMM))};top:${mm(pPreset.TopMM + (tmpRow * pPreset.PitchYMM))};">${tmpHTML}</div>`);
		tmpCellIndex++;
		if (tmpCellIndex >= tmpPerSheet)
		{
			tmpSheets.push(tmpCells.join(''));
			tmpCells = [];
			tmpCellIndex = 0;
		}
	}
	if (tmpCells.length > 0)
	{
		tmpSheets.push(tmpCells.join(''));
	}
	const tmpHTML = tmpSheets.map((pCells) => `<div class="hlqr-print-page hlqr-print-sheet" style="width:${mm(pPreset.PageWidthMM)};height:${mm(pPreset.PageHeightMM)};">${pCells}</div>`).join('');
	return { HTML: tmpHTML, PageCSS: `@page { size: ${mm(pPreset.PageWidthMM)} ${mm(pPreset.PageHeightMM)}; margin: 0; }`, Plans: tmpPlans };
}

/**
 * One label drawn at the printer's resolution, for native print bridges that take an image.
 *
 * @param {import('./Label-Media-Presets.js').MediaPreset} pPreset
 * @param {LabelContent} pLabel
 * @param {Object} [pOptions] - Passed to planLabel.
 * @param {Document} [pDocument] - Defaults to the global document.
 * @return {HTMLCanvasElement}
 */
function renderLabelCanvas(pPreset, pLabel, pOptions, pDocument)
{
	const tmpDocument = pDocument || document;
	const tmpPlan = planLabel(pPreset, pLabel, pOptions);
	const tmpDotsPerMM = pPreset.DPI / 25.4;
	const tmpCanvas = tmpDocument.createElement('canvas');
	tmpCanvas.width = Math.round(pPreset.LabelWidthMM * tmpDotsPerMM);
	tmpCanvas.height = Math.round(pPreset.LabelHeightMM * tmpDotsPerMM);
	const tmpContext = tmpCanvas.getContext('2d');
	tmpContext.fillStyle = '#fff';
	tmpContext.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);

	const tmpMargin = Math.round((pPreset.MarginMM || 2) * tmpDotsPerMM);
	const tmpCodeDots = Math.round(tmpPlan.CodeMM * tmpDotsPerMM);
	libMatrix.drawToCanvas(tmpContext, tmpPlan.Matrix, tmpMargin, tmpMargin, tmpPlan.DotsPerModule);

	const tmpFontPixels = Math.round(tmpPlan.FontPT / 72 * pPreset.DPI);
	const tmpLineHeight = Math.round(tmpFontPixels * 1.25);
	let tmpTextX = tmpMargin;
	let tmpTextY = tmpMargin + tmpCodeDots + Math.round(GAP_MM * tmpDotsPerMM);
	let tmpTextWidth = tmpCanvas.width - (2 * tmpMargin);
	if (pPreset.Layout === 'Side')
	{
		tmpTextX = tmpMargin + tmpCodeDots + Math.round(GAP_MM * tmpDotsPerMM);
		tmpTextY = tmpMargin;
		tmpTextWidth = tmpCanvas.width - tmpTextX - tmpMargin;
	}
	tmpContext.fillStyle = '#000';
	tmpContext.textBaseline = 'top';
	(pLabel.Lines || []).forEach((pLine, pIndex) =>
	{
		tmpContext.font = `${pIndex === 0 ? '700 ' : ''}${tmpFontPixels}px -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`;
		tmpContext.fillText(fitText(tmpContext, String(pLine), tmpTextWidth), tmpTextX, tmpTextY + (pIndex * tmpLineHeight));
	});
	return tmpCanvas;
}

/**
 * @param {CanvasRenderingContext2D} pContext
 * @param {string} pText
 * @param {number} pWidth
 * @return {string} the text, shortened with an ellipsis to fit
 */
function fitText(pContext, pText, pWidth)
{
	if (pContext.measureText(pText).width <= pWidth)
	{
		return pText;
	}
	let tmpText = pText;
	while (tmpText.length > 1 && pContext.measureText(`${tmpText}…`).width > pWidth)
	{
		tmpText = tmpText.slice(0, -1);
	}
	return `${tmpText}…`;
}

/** Styles for labels on screen and in print. */
const LABEL_CSS = `
.hlqr-label { box-sizing: border-box; display: flex; gap: ${GAP_MM}mm; background: #fff; color: #000; overflow: hidden; font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
.hlqr-label--side { flex-direction: row; align-items: center; }
.hlqr-label--stack { flex-direction: column; align-items: center; }
.hlqr-label-code { flex: 0 0 auto; line-height: 0; }
.hlqr-label-text { flex: 1 1 auto; min-width: 0; line-height: 1.2; }
.hlqr-label--stack .hlqr-label-text { width: 100%; text-align: center; }
.hlqr-label-line { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.hlqr-label-line--first { font-weight: 700; }
.hlqr-label-image { position: relative; width: 100%; height: 100%; overflow: hidden; }
.hlqr-print-page { position: relative; overflow: hidden; break-after: page; page-break-after: always; background: #fff; }
.hlqr-sheet-cell { position: absolute; }
`;

module.exports =
{
	planLabel,
	isImageTurned,
	renderLabelHTML,
	renderPrintJob,
	renderLabelCanvas,
	LABEL_CSS,
};

},{"../rendering/QR-Matrix.js":281}],278:[function(require,module,exports){
/**
 * Send a print job to the device.
 *
 * Browsers: the job is placed in a print-only area of the current page and `window.print()` is
 * called once its label images have decoded, so no pop-up blocker or new tab is involved.
 * Native shells (Fieldbook iOS, smartforms): each label is rasterised at the printer's resolution
 * and handed to the bridge's `printImage`.
 */

const PRINT_AREA_ID = 'HeadlightQR-PrintArea';
const PRINT_STYLE_ID = 'HeadlightQR-PrintStyle';

/**
 * @param {Document} pDocument
 * @return {HTMLElement}
 */
function ensurePrintArea(pDocument)
{
	let tmpArea = pDocument.getElementById(PRINT_AREA_ID);
	if (!tmpArea)
	{
		tmpArea = pDocument.createElement('div');
		tmpArea.id = PRINT_AREA_ID;
		tmpArea.setAttribute('aria-hidden', 'true');
		pDocument.body.appendChild(tmpArea);
	}
	return tmpArea;
}

/**
 * @param {Document} pDocument
 * @param {string} pPageCSS - The `@page` rule for this job.
 */
function setPrintStyle(pDocument, pPageCSS)
{
	let tmpStyle = pDocument.getElementById(PRINT_STYLE_ID);
	if (!tmpStyle)
	{
		tmpStyle = pDocument.createElement('style');
		tmpStyle.id = PRINT_STYLE_ID;
		pDocument.head.appendChild(tmpStyle);
	}
	tmpStyle.textContent = `
@media screen { #${PRINT_AREA_ID} { display: none; } }
@media print
{
	html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; min-width: 0 !important; }
	body > *:not(#${PRINT_AREA_ID}) { display: none !important; }
	#${PRINT_AREA_ID} { display: block !important; }
	#${PRINT_AREA_ID}, #${PRINT_AREA_ID} * { visibility: visible !important; }
	#${PRINT_AREA_ID} * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
${pPageCSS}`;
}

/**
 * Resolve once every image in the element has loaded and decoded (or failed).
 *
 * Labels are `<img src="data:...">`. A freshly assigned src is decoded asynchronously, so printing straight
 * after `innerHTML` snapshots an empty image the first time; the second print only works because the browser
 * has cached the decoded image by then.
 *
 * @param {HTMLElement} pElement
 * @return {Promise<void>}
 */
function waitForImages(pElement)
{
	if (!pElement || typeof pElement.querySelectorAll !== 'function')
	{
		return Promise.resolve();
	}
	const tmpImages = Array.from(pElement.querySelectorAll('img'));
	return Promise.all(tmpImages.map((pImage) =>
	{
		if (typeof pImage.decode === 'function')
		{
			// A broken image rejects; print what we have rather than nothing.
			return pImage.decode().catch(() => undefined);
		}
		if (pImage.complete)
		{
			return undefined;
		}
		return new Promise((fResolve) =>
		{
			pImage.addEventListener('load', fResolve, { once: true });
			pImage.addEventListener('error', fResolve, { once: true });
		});
	})).then(() => undefined);
}

/**
 * Print HTML labels through the browser, once the label images are ready to paint.
 *
 * @param {string} pHTML - Output of Label-Renderer.renderPrintJob.
 * @param {string} pPageCSS
 * @param {Window} [pWindow]
 * @return {Promise<void>}
 */
async function printHTML(pHTML, pPageCSS, pWindow)
{
	const tmpWindow = pWindow || window;
	const tmpDocument = tmpWindow.document;
	setPrintStyle(tmpDocument, pPageCSS);
	const tmpArea = ensurePrintArea(tmpDocument);
	tmpArea.innerHTML = pHTML;
	await waitForImages(tmpArea);
	tmpWindow.print();
}

/**
 * Print rasterised labels through a native bridge that implements `printImage`.
 *
 * @param {{ printImage: (pOptions: { jobName: string, base64Image: string }) => Promise<any> }} pBridge
 * @param {Array<string>} pImages - Data URLs, one per label.
 * @param {string} [pJobName]
 * @return {Promise<Array<any>>}
 */
async function printNative(pBridge, pImages, pJobName)
{
	const tmpResults = [];
	for (const tmpImage of pImages)
	{
		tmpResults.push(await pBridge.printImage({ jobName: pJobName || 'HeadLight label', base64Image: tmpImage }));
	}
	return tmpResults;
}

module.exports =
{
	PRINT_AREA_ID,
	printHTML,
	printNative,
};

},{}],279:[function(require,module,exports){
/**
 * pict-section-form extension for the `QRCode` input type.
 *
 * Manifest options (descriptor `PictForm`):
 * - `QREntity` — registry entity the value belongs to. Default `Sample`.
 * - `QRSize` — on-screen image size in px. Default 140.
 * - `QRActions` — Edit-theme buttons: any of `Scan`, `Generate`, `Print`. Default `[ 'Print' ]`.
 * - `QRLabelLines` — data addresses (relative to the form's AppData) printed under the code.
 * - `QRProjectAddress` — data address of the project id, used when minting a new code.
 *
 * Per-input state lives in the DOM (keyed by the input's RawHTMLID), never on this provider,
 * because one provider instance serves every QRCode input on the page.
 */

const libPictSectionForm = require('pict-section-form');
const libInputExtension = libPictSectionForm.PictInputExtensionProvider;

class HeadlightQRInput extends libInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	/**
	 * @param {any} pInput
	 * @return {{ Entity: string, Size: number, Actions: Array<string>, LabelLines: Array<string> }}
	 */
	getConfig(pInput)
	{
		const tmpForm = (pInput && pInput.PictForm) || {};
		return {
			Entity: tmpForm.QREntity || 'Sample',
			Size: tmpForm.QRSize || 140,
			Actions: Array.isArray(tmpForm.QRActions) ? tmpForm.QRActions : [ 'Print' ],
			LabelLines: Array.isArray(tmpForm.QRLabelLines) ? tmpForm.QRLabelLines : [],
		};
	}

	/**
	 * @param {string} pRawHTMLID
	 * @param {string} pPrefix
	 * @return {HTMLElement|null}
	 */
	element(pRawHTMLID, pPrefix)
	{
		return (typeof document !== 'undefined') ? document.getElementById(`${pPrefix}${pRawHTMLID}`) : null;
	}

	/**
	 * @param {any} pInput
	 * @param {any} pValue
	 * @param {string} [pRawHTMLID] - Defaults to the input's own; tabular rows pass theirs.
	 */
	paint(pInput, pValue, pRawHTMLID)
	{
		const tmpProvider = this.pict.providers.HeadlightQR;
		const tmpRawHTMLID = pRawHTMLID || (pInput.Macro && pInput.Macro.RawHTMLID);
		const tmpConfig = this.getConfig(pInput);
		const tmpImage = this.element(tmpRawHTMLID, 'HLQR-IMAGE-');
		const tmpValueElement = this.element(tmpRawHTMLID, 'HLQR-VALUE-');
		const tmpValue = (pValue === null || pValue === undefined) ? '' : String(pValue).trim();

		if (tmpImage)
		{
			if (tmpProvider && tmpValue)
			{
				try
				{
					tmpImage.innerHTML = tmpProvider.renderSVG(tmpProvider.encode(tmpConfig.Entity, tmpValue), { SizePX: tmpConfig.Size, Title: `${tmpConfig.Entity} code ${tmpValue}` });
				}
				catch (pError)
				{
					tmpImage.innerHTML = '';
					this.pict.log.warn(`QRCode input ${pInput.Hash} could not render "${tmpValue}": ${pError.message || pError}`);
				}
			}
			else
			{
				tmpImage.innerHTML = `<div class="hlqr-input-empty" style="width:${tmpConfig.Size}px;height:${tmpConfig.Size}px;">No code yet</div>`;
			}
		}
		if (tmpValueElement)
		{
			tmpValueElement.textContent = tmpValue;
		}

		const tmpButtons = this.element(tmpRawHTMLID, 'HLQR-BUTTONS-');
		if (tmpButtons)
		{
			for (const tmpButton of Array.from(tmpButtons.querySelectorAll('[data-hlqr-action]')))
			{
				const tmpAction = tmpButton.getAttribute('data-hlqr-action');
				let tmpVisible = tmpConfig.Actions.includes(tmpAction);
				if (tmpAction === 'Print' && !tmpValue)
				{
					tmpVisible = false;
				}
				if (tmpAction === 'Generate' && tmpValue)
				{
					tmpVisible = false;
				}
				/** @type {HTMLElement} */ (tmpButton).hidden = !tmpVisible;
			}
		}
	}

	/**
	 * @param {any} pInput
	 * @param {string} pMessage
	 */
	setMessage(pInput, pMessage)
	{
		const tmpElement = this.element(pInput.Macro.RawHTMLID, 'HLQR-MESSAGE-');
		if (tmpElement)
		{
			tmpElement.textContent = pMessage || '';
		}
	}

	/**
	 * Write a value to the form data and show it in the input's own field (setDataByInput only
	 * updates the data and fires onDataChange).
	 *
	 * @param {any} pView
	 * @param {any} pInput
	 * @param {string} pValue
	 * @param {string} pTransactionGUID
	 */
	setValue(pView, pInput, pValue, pTransactionGUID)
	{
		pView.setDataByInput(pInput, pValue);
		if (typeof pView.manualMarshalDataToViewByInput === 'function')
		{
			pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
		}
		this.paint(pInput, pValue);
	}

	/**
	 * A new code in the customer's format. HeadLight apps mint through the HeadlightQRCodeHash service
	 * (which holds the signed-in customer's profile); elsewhere (the testbed) through HeadlightQR.
	 * `PictForm.QRProjectAddress` points at the project id in AppData, when the form has one.
	 *
	 * @param {any} pInput
	 * @return {string}
	 */
	mintCode(pInput)
	{
		const tmpAppData = this.pict.AppData || {};
		const tmpSession = tmpAppData.Session || {};
		const tmpCurrentUser = tmpAppData.CurrentUser || {};
		const tmpProjectAddress = pInput && pInput.PictForm && pInput.PictForm.QRProjectAddress;
		const tmpIDProject = tmpProjectAddress ? this.pict.manifest.getValueAtAddress(tmpAppData, tmpProjectAddress) : tmpSession.IDProject;
		const tmpContext =
		{
			IDProject: tmpIDProject,
			IDUser: tmpCurrentUser.UserID || tmpSession.UserID,
			ExternalSyncGUID: (tmpAppData.FullUserRecord && tmpAppData.FullUserRecord.ExternalSyncGUID) || tmpSession.ExternalSyncGUID,
			CustomerID: tmpCurrentUser.CustomerID,
			TimeZone: tmpCurrentUser.Timezone || tmpSession.TimeZone,
		};
		const tmpHashService = this.pict.fable.services && this.pict.fable.services.HeadlightQRCodeHash;
		if (tmpHashService && typeof tmpHashService.mintForCustomer === 'function')
		{
			return tmpHashService.mintForCustomer(tmpContext);
		}
		return this.pict.providers.HeadlightQR.mint(tmpContext);
	}

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.paint(pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.paint(pInput, pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.paint(pInput, pValue);
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpProvider = this.pict.providers.HeadlightQR;
		const tmpConfig = this.getConfig(pInput);
		const tmpValue = (pValue === null || pValue === undefined) ? '' : String(pValue).trim();
		if (!tmpProvider)
		{
			return super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}

		if (pEvent === 'qr-print' && tmpValue)
		{
			const tmpLines = [ tmpValue ].concat(tmpConfig.LabelLines.map((pAddress) => this.pict.manifest.getValueAtAddress(this.pict.AppData, pAddress)).filter((pLine) => pLine !== undefined && pLine !== null && pLine !== '').map(String));
			tmpProvider.printLabels([ { Entity: tmpConfig.Entity, Value: tmpValue, Lines: tmpLines } ]);
		}
		else if (pEvent === 'qr-generate' && !tmpValue)
		{
			const tmpCode = this.mintCode(pInput);
			this.setValue(pView, pInput, tmpCode, pTransactionGUID);
		}
		else if (pEvent === 'qr-scan')
		{
			const tmpOperation = `HeadlightQR-Scan-${pInput.Hash}`;
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpOperation);
			const tmpDefinition = tmpProvider.getEntityDefinition(tmpConfig.Entity);
			tmpProvider.scanOnce({ Accept: [ tmpConfig.Entity ], RawEntities: [ tmpConfig.Entity ], Label: `Scan a ${tmpDefinition ? tmpDefinition.Label : 'code'}` })
				.then((pResolution) =>
				{
					if (!pResolution)
					{
						return;
					}
					const tmpScanned = (pResolution.Record && tmpDefinition && pResolution.Record[tmpDefinition.Column]) || pResolution.Decoded.Value;
					if (pResolution.Status === 'Deleted')
					{
						this.setMessage(pInput, 'That label belongs to a deleted record.');
						return;
					}
					this.setMessage(pInput, '');
					this.setValue(pView, pInput, tmpScanned, pTransactionGUID);
				})
				.catch((pError) =>
				{
					this.setMessage(pInput, 'Scanning failed. Try again, or type the code.');
					this.pict.log.error(`QRCode input ${pInput.Hash} scan failed: ${pError.message || pError}`);
				})
				.finally(() =>
				{
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpOperation);
				});
		}
		return super.onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = HeadlightQRInput;
module.exports.default_configuration = Object.assign({}, libInputExtension.default_configuration || {}, { ProviderIdentifier: 'HeadlightQR-Input' });

},{"pict-section-form":587}],280:[function(require,module,exports){
/**
 * HeadlightQR — the one provider apps, panels, views and form inputs use for QR codes.
 *
 * Decodes and encodes payloads, mints codes in the customer's format, resolves a scan to a record
 * (including deleted ones), renders codes and labels, prints, and owns the scanning modes:
 *
 * - GoTo: the default; a scan shows what was scanned without navigating anywhere by itself.
 * - Pick: a field or picker asked for a code; only its entity types are accepted.
 * - Session: a job such as Receive or Put away; action cards are only acted on here.
 *
 * Handlers form a stack: the most recent handler sees a scan first and may decline it. GoTo handlers always sit
 * below Pick and Session ones, whatever order they were added in.
 */

const libPictProvider = require('pict-provider');
const libHeadlightQRCode = require('headlight-qrcode');

const libMatrix = require('../rendering/QR-Matrix.js');
const libPresets = require('../labels/Label-Media-Presets.js');
const libLabels = require('../labels/Label-Renderer.js');
const libPrint = require('../printing/Print-Transport.js');
const WedgeScanSource = require('../scanning/Wedge-Scan-Source.js');
const libScanGeolocation = require('../scanning/Scan-Geolocation.js');

const PRESET_STORAGE_KEY = 'HeadlightQR-MediaPreset';
const SCAN_LOG_LIMIT = 200;

/**
 * @typedef {Object} QRResolution
 * @property {'Found'|'Deleted'|'NotFound'|'Rejected'|'Action'|'Empty'|'Unresolved'} Status
 * @property {import('headlight-qrcode/source/Headlight-QRCode-Codec.js').Decoded} Decoded
 * @property {string} [Entity]
 * @property {Record<string, any>} [Record]
 * @property {number} [DuplicateCount] - Other live records sharing the code (reported to operations, not shown to users).
 * @property {string} [DeletedByName]
 * @property {string} [Reason]
 */

/**
 * @typedef {Object} ScanHandler
 * @property {string} Hash
 * @property {'GoTo'|'Pick'|'Session'} Mode
 * @property {string} [Label] - Shown in the mode bar, e.g. "Receiving at D02 Lab".
 * @property {Array<string>} [Accept] - Entity types this handler takes.
 * @property {Array<string>} [RawEntities] - How to read an unwrapped code while this handler is active.
 * @property {string} [Workflow] - Action-card workflow this handler owns, e.g. `cart`.
 * @property {Array<string>} [Workflows] - Several workflows, for a session that answers more than one set of cards.
 * @property {(pResolution: QRResolution, pScan: Partial<ScanEvent>) => (boolean|void|Promise<boolean|void>)} onScan - Return false to let the next handler try.
 *   The scan is recorded (and its tone played) once a handler takes it, so start slow work without awaiting it.
 */

/**
 * @typedef {Object} ScanEvent
 * @property {string} ID
 * @property {string} Time - ISO timestamp.
 * @property {'wedge'|'camera'|'manual'|'native'} Source
 * @property {string} Raw
 * @property {string} Mode
 * @property {string} [Handler]
 * @property {string} [Status]
 * @property {QRResolution} [Resolution]
 * @property {{ Latitude: number, Longitude: number, AccuracyMeters: number, FixTime: string }|null} [Geolocation]
 */

const _DefaultConfiguration =
{
	ProviderIdentifier: 'HeadlightQR',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,

	Environment: null,
	Configuration: {},
	CustomProperties: {},
	Entities: {},
	DefaultRawEntities: [ 'Sample' ],
	ErrorCorrection: 'Q',
	MinModuleMM: 0.5,
	DefaultMediaPreset: 'brother-62x100',
	Wedge: { Enabled: false },
	CaptureGeolocation: false,
	Feedback: { Sound: true, Vibrate: true },
};

class HeadlightQRProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		const tmpEnvironment = this.options.Environment || ((typeof window !== 'undefined' && window.location) ? libHeadlightQRCode.Hosts.getEnvironmentForPage({ Protocol: window.location.protocol, Hostname: window.location.hostname, ServerURL: window._OfflineServerBaseURL }) : 'Production');
		this.core = new libHeadlightQRCode(this.fable, { Entities: this.options.Entities, Configuration: this.options.Configuration, CustomProperties: this.options.CustomProperties, Environment: tmpEnvironment });

		/** @type {any} Entity source: `{ find(request), getUserName?(id) }`. */
		this.entitySource = this.options.EntitySource || null;
		/** @type {Array<ScanHandler>} */
		this.handlers = [];
		/** @type {Record<string, (pDecoded: any) => void>} workflow entry points, keyed `workflow/verb` */
		this.actionEntries = {};
		/** @type {Array<ScanEvent>} */
		this.scanLog = [];
		/** @type {Array<(pType: string, pDetail: any) => void>} */
		this.listeners = [];
		this.lastGeolocation = null;
		this.scanCounter = 0;
		this.wedge = null;
		this.pendingScanOnce = null;
		/** @type {string|null} the customer's default label stock (QRCodes/Printing configuration) */
		this.customerMediaPresetID = null;
		/** @type {Promise<any>|null} */
		this.customerPrintSettingsLoad = null;
	}

	onAfterInitialize()
	{
		if (this.options.Wedge && this.options.Wedge.Enabled)
		{
			this.enableWedge(this.options.Wedge);
		}
		if (this.options.CaptureGeolocation)
		{
			this.refreshGeolocation();
		}
		return super.onAfterInitialize();
	}

	// ---- Codes ------------------------------------------------------------

	/** @return {import('headlight-qrcode/source/Headlight-QRCode-Profiles.js').QRProfile} */
	getProfile()
	{
		return this.core.profile;
	}

	/**
	 * Switch customer configuration at runtime (e.g. after login, or in a testbed).
	 *
	 * @param {Object} pConfiguration
	 * @param {Object} [pCustomProperties]
	 * @param {number|string} [pIDCustomer] - Picks the default when nothing is configured.
	 */
	setCustomerConfiguration(pConfiguration, pCustomProperties, pIDCustomer)
	{
		this.core.setCustomerConfiguration(pConfiguration, pCustomProperties, pIDCustomer);
		this.notify('profile', this.core.profile);
	}

	/**
	 * Use a profile resolved elsewhere (e.g. the HeadlightQRCodeHash service's, loaded at sign-in).
	 *
	 * @param {any} pProfile - A resolved profile (headlight-qrcode Profiles.resolveProfile output).
	 */
	useProfile(pProfile)
	{
		if (pProfile && pProfile.CodeFormat)
		{
			this.core.profile = pProfile;
			this.notify('profile', this.core.profile);
		}
	}

	/** @return {string} */
	getEnvironment()
	{
		return this.core.environment;
	}

	/** @param {string} pEnvironment */
	setEnvironment(pEnvironment)
	{
		this.core.environment = pEnvironment;
	}

	decode(pText)
	{
		return this.core.decode(pText);
	}

	encode(pEntity, pValue, pOptions)
	{
		return this.core.encode(pEntity, pValue, pOptions);
	}

	encodeAction(pWorkflow, pVerb, pArguments)
	{
		return this.core.encodeAction(pWorkflow, pVerb, pArguments);
	}

	/**
	 * @param {import('headlight-qrcode/source/Headlight-QRCode-Minter.js').MintContext} pContext
	 * @return {string}
	 */
	mint(pContext)
	{
		return this.core.mint(pContext);
	}

	/** @return {Array<any>} */
	listEntities()
	{
		return this.core.registry.listEntities();
	}

	getEntityDefinition(pEntity)
	{
		return this.core.registry.getEntity(pEntity);
	}

	// ---- Resolution -------------------------------------------------------

	/**
	 * Decode a scan and find the record it points to.
	 *
	 * Live records win over deleted ones. When several live records share a code the most recently
	 * updated is used and the duplicate is reported to operations (a `duplicate` event and a warning
	 * log), never to the person scanning.
	 *
	 * @param {string} pText
	 * @param {Object} [pContext]
	 * @param {Array<string>} [pContext.Accept]
	 * @param {Array<string>} [pContext.RawEntities]
	 * @return {Promise<QRResolution>}
	 */
	async resolve(pText, pContext)
	{
		const tmpContext = pContext || {};
		const tmpDecoded = this.decode(pText);
		if (tmpDecoded.Kind === 'Empty')
		{
			return { Status: 'Empty', Decoded: tmpDecoded };
		}
		if (tmpDecoded.Kind === 'Action')
		{
			return { Status: 'Action', Decoded: tmpDecoded };
		}
		if (tmpDecoded.Entity && tmpContext.Accept && !tmpContext.Accept.includes(tmpDecoded.Entity))
		{
			return { Status: 'Rejected', Decoded: tmpDecoded, Entity: tmpDecoded.Entity, Reason: 'WrongEntity' };
		}
		if (!this.entitySource)
		{
			return { Status: 'Unresolved', Decoded: tmpDecoded, Entity: tmpDecoded.Entity || undefined };
		}

		let tmpCandidates = tmpDecoded.Entity ? [ tmpDecoded.Entity ] : (tmpContext.RawEntities || this.options.DefaultRawEntities);
		if (!tmpDecoded.Entity && tmpContext.Accept)
		{
			tmpCandidates = tmpCandidates.filter((pEntity) => tmpContext.Accept.includes(pEntity));
		}
		const tmpValues = [ tmpDecoded.Value ];
		if (tmpDecoded.Raw !== tmpDecoded.Value)
		{
			tmpValues.push(tmpDecoded.Raw);
		}

		let tmpDeleted = null;
		for (const tmpEntity of tmpCandidates)
		{
			const tmpDefinition = this.core.registry.getEntity(tmpEntity);
			if (!tmpDefinition)
			{
				continue;
			}
			for (const tmpValue of tmpValues)
			{
				const tmpRows = await this.entitySource.find({ Definition: tmpDefinition, Key: tmpDecoded.Key, Value: tmpValue, IncludeDeleted: true });
				const tmpLive = tmpRows.filter((pRow) => !pRow.Deleted);
				if (tmpLive.length > 0)
				{
					tmpLive.sort((pA, pB) => String(pB.UpdateDate || '').localeCompare(String(pA.UpdateDate || '')));
					if (tmpLive.length > 1)
					{
						this.reportDuplicate(tmpDefinition.Entity, tmpValue, tmpLive);
					}
					return { Status: 'Found', Decoded: tmpDecoded, Entity: tmpDefinition.Entity, Record: tmpLive[0], DuplicateCount: tmpLive.length - 1 };
				}
				if (!tmpDeleted && tmpRows.length > 0)
				{
					tmpRows.sort((pA, pB) => String(pB.DeleteDate || '').localeCompare(String(pA.DeleteDate || '')));
					tmpDeleted = { Entity: tmpDefinition.Entity, Record: tmpRows[0] };
				}
			}
		}
		if (tmpDeleted)
		{
			let tmpDeletedBy = null;
			if (typeof this.entitySource.getUserName === 'function')
			{
				tmpDeletedBy = await this.entitySource.getUserName(tmpDeleted.Record.DeletingIDUser);
			}
			return { Status: 'Deleted', Decoded: tmpDecoded, Entity: tmpDeleted.Entity, Record: tmpDeleted.Record, DeletedByName: tmpDeletedBy || undefined };
		}
		return { Status: 'NotFound', Decoded: tmpDecoded, Entity: tmpDecoded.Entity || undefined };
	}

	/**
	 * @param {string} pEntity
	 * @param {string} pValue
	 * @param {Array<Record<string, any>>} pRecords
	 */
	reportDuplicate(pEntity, pValue, pRecords)
	{
		const tmpDefinition = this.core.registry.getEntity(pEntity);
		const tmpIDs = pRecords.map((pRecord) => pRecord[tmpDefinition.IDColumn]);
		this.log.warn(`HeadlightQR: ${pRecords.length} live ${pEntity} records share the code "${pValue}" (IDs ${tmpIDs.join(', ')}); using the most recently updated.`);
		this.notify('duplicate', { Entity: pEntity, Value: pValue, IDs: tmpIDs });
	}

	/**
	 * Display summary of a record for the result sheet: the entity source may supply one.
	 *
	 * @param {string} pEntity
	 * @param {Record<string, any>} pRecord
	 * @return {{ Title: string, Status?: string, Fields: Array<{ Label: string, Value: any }> }}
	 */
	describeRecord(pEntity, pRecord)
	{
		if (this.entitySource && typeof this.entitySource.describe === 'function')
		{
			const tmpSummary = this.entitySource.describe(pEntity, pRecord);
			if (tmpSummary)
			{
				return tmpSummary;
			}
		}
		const tmpDefinition = this.core.registry.getEntity(pEntity) || {};
		const tmpTitle = (pRecord && (pRecord[tmpDefinition.NameColumn] || pRecord[tmpDefinition.Column] || pRecord[tmpDefinition.GUIDColumn])) || 'Untitled';
		const tmpFields = [];
		if (tmpDefinition.Column && pRecord && pRecord[tmpDefinition.Column])
		{
			tmpFields.push({ Label: 'Code', Value: pRecord[tmpDefinition.Column] });
		}
		return { Title: String(tmpTitle), Status: pRecord && pRecord.Status, Fields: tmpFields };
	}

	/**
	 * Where a found record can be opened, from the app's `DestinationResolver` option.
	 *
	 * @param {QRResolution} pResolution
	 * @return {Promise<{ Destinations: Array<{ Label: string, URL?: string, onSelect?: () => void }>, Blocked?: { Reason: string, Message: string } }>}
	 */
	async getDestinations(pResolution)
	{
		if (typeof this.options.DestinationResolver !== 'function')
		{
			return { Destinations: [] };
		}
		const tmpRouting = await this.options.DestinationResolver(pResolution);
		return tmpRouting || { Destinations: [] };
	}

	// ---- Rendering and printing -------------------------------------------

	/**
	 * @param {string} pPayload
	 * @param {Object} [pOptions] - `{ SizePX, Width, Title, ErrorCorrection }`
	 * @return {string} SVG markup
	 */
	renderSVG(pPayload, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpMatrix = libMatrix.createMatrix(pPayload, { ErrorCorrection: tmpOptions.ErrorCorrection || this.options.ErrorCorrection });
		return libMatrix.toSVG(tmpMatrix, { Width: tmpOptions.Width || (tmpOptions.SizePX ? `${tmpOptions.SizePX}px` : undefined), Title: tmpOptions.Title });
	}

	/**
	 * @param {string} pPayload
	 * @param {Object} [pOptions]
	 * @return {import('../rendering/QR-Matrix.js').QRMatrix}
	 */
	measure(pPayload, pOptions)
	{
		return libMatrix.createMatrix(pPayload, { ErrorCorrection: (pOptions && pOptions.ErrorCorrection) || this.options.ErrorCorrection });
	}

	/** @return {Array<import('../labels/Label-Media-Presets.js').MediaPreset>} */
	getMediaPresets()
	{
		return libPresets.MEDIA_PRESETS;
	}

	/**
	 * The stock Print uses: the one picked in Print options on this device, else the default.
	 *
	 * @return {import('../labels/Label-Media-Presets.js').MediaPreset}
	 */
	getDeviceMediaPreset()
	{
		let tmpID = null;
		try
		{
			tmpID = window.localStorage.getItem(PRESET_STORAGE_KEY);
		}
		catch (pError)
		{
			tmpID = null;
		}
		return libPresets.getMediaPreset(tmpID) || this.getDefaultMediaPreset();
	}

	/**
	 * The stock for a device that hasn't picked one: the customer's default, else the app's.
	 *
	 * @return {import('../labels/Label-Media-Presets.js').MediaPreset}
	 */
	getDefaultMediaPreset()
	{
		return libPresets.getMediaPreset(this.customerMediaPresetID) || libPresets.getMediaPreset(this.options.DefaultMediaPreset) || libPresets.MEDIA_PRESETS[0];
	}

	/** @return {boolean} true when this device has picked its own stock in Print options */
	hasDeviceMediaPreset()
	{
		try
		{
			return !!libPresets.getMediaPreset(window.localStorage.getItem(PRESET_STORAGE_KEY));
		}
		catch (pError)
		{
			return false;
		}
	}

	/** Go back to the default stock on this device. */
	clearDeviceMediaPreset()
	{
		try
		{
			window.localStorage.removeItem(PRESET_STORAGE_KEY);
		}
		catch (pError)
		{
			// Blocked storage: nothing was remembered.
		}
	}

	/**
	 * @param {Object} [pSettings] - The customer's `QRCodes/Printing` configuration: `{ DefaultMediaPreset }`.
	 */
	setCustomerPrintSettings(pSettings)
	{
		const tmpID = pSettings && pSettings.DefaultMediaPreset;
		this.customerMediaPresetID = libPresets.getMediaPreset(tmpID) ? tmpID : null;
	}

	/**
	 * Load the customer's print settings once. A failed read leaves the app default in place and is retried next time.
	 *
	 * @param {{ getJSON: (pPath: string, fCallback: (pError: any, pResult: any) => void) => void }} pRestClient
	 * @return {Promise<void>}
	 */
	loadCustomerPrintSettings(pRestClient)
	{
		if (!pRestClient || (typeof pRestClient.getJSON !== 'function'))
		{
			return Promise.resolve();
		}
		if (!this.customerPrintSettingsLoad)
		{
			const tmpLoad = new Promise((fResolve) =>
			{
				pRestClient.getJSON('Configuration/For/QRCodes/Printing', (pError, pResult) => fResolve((pError || !pResult || pResult.Error) ? null : pResult));
			}).then((pSettings) =>
			{
				if (pSettings)
				{
					this.setCustomerPrintSettings(pSettings);
				}
				else if (this.customerPrintSettingsLoad === tmpLoad)
				{
					this.customerPrintSettingsLoad = null;
				}
			});
			this.customerPrintSettingsLoad = tmpLoad;
		}
		return this.customerPrintSettingsLoad;
	}

	/** @param {string} pPresetID */
	setDeviceMediaPreset(pPresetID)
	{
		try
		{
			window.localStorage.setItem(PRESET_STORAGE_KEY, pPresetID);
		}
		catch (pError)
		{
			// Private windows and blocked storage: the choice just isn't remembered.
		}
	}

	/**
	 * Labels for entity records: payload from the customer's envelope plus text lines.
	 *
	 * @param {Array<{ Entity: string, Value: string, Lines?: Array<string> }>} pItems
	 * @return {Array<import('../labels/Label-Renderer.js').LabelContent>}
	 */
	buildLabels(pItems)
	{
		return pItems.map((pItem) =>
		{
			if (pItem.Image)
			{
				return { Payload: pItem.Payload || '', Image: pItem.Image, ImageWidth: pItem.ImageWidth, ImageHeight: pItem.ImageHeight };
			}
			return { Payload: pItem.Payload || this.encode(pItem.Entity, pItem.Value), Lines: pItem.Lines || [ pItem.Value ] };
		});
	}

	/**
	 * @param {Array<{ Entity?: string, Value?: string, Payload?: string, Lines?: Array<string> }>} pItems
	 * @param {Object} [pOptions] - `{ PresetID, StartIndex }`
	 * @return {{ HTML: string, PageCSS: string, Plans: Array<any>, Preset: any }}
	 */
	previewLabels(pItems, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpPreset = libPresets.getMediaPreset(tmpOptions.PresetID) || this.getDeviceMediaPreset();
		const tmpJob = libLabels.renderPrintJob(tmpPreset, this.buildLabels(pItems), { ErrorCorrection: this.options.ErrorCorrection, MinModuleMM: this.options.MinModuleMM, StartIndex: tmpOptions.StartIndex });
		return Object.assign({ Preset: tmpPreset }, tmpJob);
	}

	/**
	 * Open the print dialog (stock choice + true-size preview); printing happens on its Print click.
	 *
	 * @param {Array<{ Entity?: string, Value?: string, Payload?: string, Lines?: Array<string> }>} pItems
	 * @param {Object} [pOptions] - `{ Title }`
	 */
	openPrintDialog(pItems, pOptions)
	{
		const tmpDialog = this.pict.views['HeadlightQR-PrintDialog'];
		if (!tmpDialog)
		{
			throw new Error('HeadlightQR-PrintDialog view is not registered.');
		}
		tmpDialog.open(pItems, pOptions);
	}

	/**
	 * One label rasterised at the printer's resolution (what native bridges receive).
	 *
	 * @param {{ Entity?: string, Value?: string, Payload?: string, Lines?: Array<string> }} pItem
	 * @param {Object} [pOptions] - `{ PresetID }`
	 * @return {HTMLCanvasElement}
	 */
	renderLabelCanvas(pItem, pOptions)
	{
		const tmpPreset = libPresets.getMediaPreset(pOptions && pOptions.PresetID) || this.getDeviceMediaPreset();
		return libLabels.renderLabelCanvas(tmpPreset, this.buildLabels([ pItem ])[0], { ErrorCorrection: this.options.ErrorCorrection, MinModuleMM: this.options.MinModuleMM });
	}

	/**
	 * Print labels. Must be called from inside a user's click for browser printing.
	 *
	 * @param {Array<{ Entity?: string, Value?: string, Payload?: string, Lines?: Array<string> }>} pItems
	 * @param {Object} [pOptions] - `{ PresetID, StartIndex, Transport: 'auto'|'browser'|'native' }`
	 * @return {Promise<{ Transport: string, Plans: Array<any> }>}
	 */
	async printLabels(pItems, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpPreset = libPresets.getMediaPreset(tmpOptions.PresetID) || this.getDeviceMediaPreset();
		const tmpBridge = this.getNativeBridge();
		const tmpUseNative = (tmpOptions.Transport === 'native') || (tmpOptions.Transport !== 'browser' && tmpBridge && tmpBridge.hasNativeSupport());
		if (tmpUseNative && tmpBridge)
		{
			const tmpLabels = this.buildLabels(pItems);
			const tmpImages = tmpLabels.map((pLabel) => pLabel.Image || libLabels.renderLabelCanvas(tmpPreset, pLabel, { ErrorCorrection: this.options.ErrorCorrection, MinModuleMM: this.options.MinModuleMM }).toDataURL('image/png'));
			await libPrint.printNative(tmpBridge, tmpImages, 'HeadLight labels');
			return { Transport: 'native', Plans: [] };
		}
		const tmpJob = this.previewLabels(pItems, Object.assign({}, tmpOptions, { PresetID: tmpPreset.Id }));
		await libPrint.printHTML(tmpJob.HTML, tmpJob.PageCSS);
		return { Transport: 'browser', Plans: tmpJob.Plans };
	}

	/**
	 * @return {any} the app's NativeBridge service/provider when it can print, else null
	 */
	getNativeBridge()
	{
		const tmpBridge = (this.pict.providers && this.pict.providers.NativeBridge) || (this.fable.servicesMap && this.fable.servicesMap.NativeBridge && Object.values(this.fable.servicesMap.NativeBridge)[0]) || null;
		if (tmpBridge && typeof tmpBridge.printImage === 'function' && typeof tmpBridge.hasNativeSupport === 'function')
		{
			return tmpBridge;
		}
		return null;
	}

	// ---- Scanning ---------------------------------------------------------

	/**
	 * @param {import('../scanning/Wedge-Burst-Detector.js').WedgeOptions} [pDetectorOptions]
	 */
	enableWedge(pDetectorOptions)
	{
		if (!this.wedge)
		{
			this.wedge = new WedgeScanSource(
				{
					Detector: pDetectorOptions,
					onScan: (pText, pDetails) => this.handleWedgeScan(pText, pDetails),
				});
		}
		this.wedge.enable();
		this.notify('mode', this.getScanState());
	}

	disableWedge()
	{
		if (this.wedge)
		{
			this.wedge.disable();
		}
		this.notify('mode', this.getScanState());
	}

	/**
	 * Turn the keyboard scanner on while a scan session needs it, in an app that otherwise leaves it off.
	 * @return {() => void} release; the scanner goes back off when the last holder releases, unless the app had it on
	 */
	holdWedge()
	{
		if (!this._wedgeHolds)
		{
			this._wedgeOnBeforeHolds = this.isWedgeEnabled();
			if (!this._wedgeOnBeforeHolds)
			{
				this.enableWedge(this.options.Wedge);
			}
		}
		this._wedgeHolds = (this._wedgeHolds || 0) + 1;
		let tmpReleased = false;
		return () =>
		{
			if (tmpReleased)
			{
				return;
			}
			tmpReleased = true;
			this._wedgeHolds--;
			if (this._wedgeHolds === 0 && !this._wedgeOnBeforeHolds)
			{
				this.disableWedge();
			}
		};
	}

	/** @return {boolean} */
	isWedgeEnabled()
	{
		return !!(this.wedge && this.wedge.enabled);
	}

	/**
	 * @param {string} pText
	 * @param {any} pDetails
	 */
	handleWedgeScan(pText, pDetails)
	{
		if (pDetails && pDetails.Pick && pDetails.PickElement)
		{
			const tmpDecoded = this.decode(pText);
			const tmpElement = /** @type {any} */ (pDetails.PickElement);
			tmpElement.value = (tmpDecoded.Kind === 'Entity') ? tmpDecoded.Value : tmpDecoded.Raw;
			tmpElement.dispatchEvent(new Event('change', { bubbles: true }));
			this.recordScan({ Source: 'wedge', Raw: pText, Mode: 'Pick', Handler: 'focused-field', Status: 'Picked' });
			return;
		}
		this.receiveScan(pText, { Source: 'wedge' });
	}

	/**
	 * Add a scan handler on top of the stack. A GoTo handler goes on top of the other GoTo handlers but stays below
	 * any open Pick or Session, so an app default registered late (scan to open) can't take a cart's scans.
	 *
	 * @param {ScanHandler} pHandler
	 * @return {() => void} removes the handler
	 */
	pushScanHandler(pHandler)
	{
		let tmpIndex = this.handlers.length;
		if (pHandler.Mode === 'GoTo')
		{
			while (tmpIndex > 0 && this.handlers[tmpIndex - 1].Mode !== 'GoTo')
			{
				tmpIndex--;
			}
		}
		this.handlers.splice(tmpIndex, 0, pHandler);
		this.notify('mode', this.getScanState());
		return () =>
		{
			const tmpIndex = this.handlers.indexOf(pHandler);
			if (tmpIndex >= 0)
			{
				this.handlers.splice(tmpIndex, 1);
				this.notify('mode', this.getScanState());
			}
		};
	}

	/**
	 * Register what an action card does when no session owns its workflow, e.g. `cart/open` starts the cart.
	 *
	 * @param {string} pWorkflow
	 * @param {string} pVerb
	 * @param {(pDecoded: any) => void} fEntry
	 */
	registerActionEntry(pWorkflow, pVerb, fEntry)
	{
		this.actionEntries[`${pWorkflow}/${pVerb}`] = fEntry;
	}

	/**
	 * @return {{ Mode: string, Label: string, Handler: string|null, Wedge: boolean }}
	 */
	getScanState()
	{
		const tmpTop = this.handlers[this.handlers.length - 1];
		return {
			Mode: tmpTop ? tmpTop.Mode : 'Idle',
			Label: tmpTop ? (tmpTop.Label || '') : '',
			Handler: tmpTop ? tmpTop.Hash : null,
			Wedge: this.isWedgeEnabled(),
		};
	}

	/**
	 * Feed a scan from any source through decoding, resolution and the handler stack.
	 *
	 * @param {string} pText
	 * @param {{ Source?: 'wedge'|'camera'|'manual'|'native' }} [pOptions]
	 * @return {Promise<ScanEvent>}
	 */
	async receiveScan(pText, pOptions)
	{
		const tmpSource = (pOptions && pOptions.Source) || 'manual';
		const tmpDecoded = this.decode(pText);
		const tmpState = this.getScanState();

		if (tmpDecoded.Kind === 'Action')
		{
			for (let i = this.handlers.length - 1; i >= 0; i--)
			{
				const tmpHandler = this.handlers[i];
				if ((tmpHandler.Workflow && tmpHandler.Workflow === tmpDecoded.Workflow) || (Array.isArray(tmpHandler.Workflows) && tmpHandler.Workflows.includes(tmpDecoded.Workflow)))
				{
					const tmpResolution = { Status: 'Action', Decoded: tmpDecoded };
					const tmpEvent = this.recordScan({ Source: tmpSource, Raw: pText, Mode: tmpHandler.Mode, Handler: tmpHandler.Hash, Status: 'Action', Resolution: tmpResolution });
					await tmpHandler.onScan(tmpResolution, tmpEvent);
					return tmpEvent;
				}
			}
			const tmpEntry = this.actionEntries[`${tmpDecoded.Workflow}/${tmpDecoded.Verb}`];
			if (tmpEntry)
			{
				const tmpEvent = this.recordScan({ Source: tmpSource, Raw: pText, Mode: tmpState.Mode, Handler: 'action-entry', Status: 'Action', Resolution: { Status: 'Action', Decoded: tmpDecoded } });
				tmpEntry(tmpDecoded);
				return tmpEvent;
			}
			const tmpResolution = { Status: 'Rejected', Decoded: tmpDecoded, Reason: 'ActionOutOfContext' };
			const tmpEvent = this.recordScan({ Source: tmpSource, Raw: pText, Mode: tmpState.Mode, Handler: null, Status: 'ActionOutOfContext', Resolution: tmpResolution });
			this.notify('unhandled', tmpEvent);
			return tmpEvent;
		}

		// One lookup per way of reading the code, however many handlers decline it, and one recorded scan (one tone).
		const tmpResolutions = new Map();
		const fResolve = async (pAccept, pRawEntities) =>
		{
			const tmpKey = JSON.stringify([ pAccept || null, pRawEntities || null ]);
			if (!tmpResolutions.has(tmpKey))
			{
				tmpResolutions.set(tmpKey, await this.resolve(pText, { Accept: pAccept, RawEntities: pRawEntities }));
			}
			return tmpResolutions.get(tmpKey);
		};
		for (let i = this.handlers.length - 1; i >= 0; i--)
		{
			const tmpHandler = this.handlers[i];
			const tmpResolution = await fResolve(tmpHandler.Accept, tmpHandler.RawEntities);
			const tmpDraft = { Source: tmpSource, Raw: pText, Mode: tmpHandler.Mode, Handler: tmpHandler.Hash, Status: tmpResolution.Status, Resolution: tmpResolution };
			const tmpHandled = await tmpHandler.onScan(tmpResolution, tmpDraft);
			if (tmpHandled !== false)
			{
				return this.recordScan(tmpDraft);
			}
		}

		const tmpResolution = await fResolve(undefined, undefined);
		const tmpEvent = this.recordScan({ Source: tmpSource, Raw: pText, Mode: 'Idle', Handler: null, Status: tmpResolution.Status, Resolution: tmpResolution });
		this.notify('unhandled', tmpEvent);
		return tmpEvent;
	}

	/**
	 * Open the camera for a single scan in Pick mode.
	 *
	 * @param {Object} [pOptions] - `{ Accept, RawEntities, Label }`
	 * @return {Promise<QRResolution|null>} null when cancelled
	 */
	scanOnce(pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpCamera = this.pict.views['HeadlightQR-Camera'];
		return new Promise((fResolve) =>
		{
			let tmpSettled = false;
			const fRemove = this.pushScanHandler(
				{
					Hash: 'scan-once',
					Mode: 'Pick',
					Label: tmpOptions.Label || 'Scan a code',
					Accept: tmpOptions.Accept,
					RawEntities: tmpOptions.RawEntities,
					onScan: (pResolution) =>
					{
						if (pResolution.Status === 'Rejected')
						{
							this.notify('feedback', { Status: 'Rejected', Resolution: pResolution });
							return true;
						}
						fFinish(pResolution);
						return true;
					},
				});
			const fFinish = (pResult) =>
			{
				if (tmpSettled)
				{
					return;
				}
				tmpSettled = true;
				fRemove();
				if (tmpCamera)
				{
					tmpCamera.close();
				}
				fResolve(pResult);
			};
			if (tmpCamera)
			{
				tmpCamera.open({ Title: tmpOptions.Label || 'Scan a code', onCancel: () => fFinish(null) });
			}
		});
	}

	/**
	 * @param {Partial<ScanEvent>} pEvent
	 * @return {ScanEvent}
	 */
	recordScan(pEvent)
	{
		this.scanCounter++;
		const tmpEvent = Object.assign({ ID: `scan-${this.scanCounter}`, Time: new Date().toISOString(), Geolocation: this.options.CaptureGeolocation ? this.lastGeolocation : null }, pEvent);
		this.scanLog.unshift(tmpEvent);
		if (this.scanLog.length > SCAN_LOG_LIMIT)
		{
			this.scanLog.pop();
		}
		this.giveFeedback(tmpEvent.Status);
		this.notify('scan', tmpEvent);
		if (this.options.CaptureGeolocation)
		{
			this.refreshGeolocation();
		}
		return tmpEvent;
	}

	/**
	 * Keep a recent location fix so scans can carry one without waiting on the GPS. Never asks for permission.
	 * @return {Promise<void>}
	 */
	refreshGeolocation()
	{
		return libScanGeolocation.getPositionIfPermitted().then((pPosition) =>
		{
			if (pPosition)
			{
				this.lastGeolocation = { Latitude: pPosition.Latitude, Longitude: pPosition.Longitude, AccuracyMeters: pPosition.Accuracy, FixTime: new Date().toISOString() };
			}
		});
	}

	/**
	 * A short tone and vibration so a scanner user knows the scan landed without looking.
	 *
	 * @param {string} pStatus
	 */
	giveFeedback(pStatus)
	{
		const tmpGood = [ 'Found', 'Action', 'Picked' ].includes(pStatus);
		const tmpFeedback = this.options.Feedback || {};
		if (tmpFeedback.Vibrate && typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function')
		{
			navigator.vibrate(tmpGood ? 40 : [ 60, 60, 60 ]);
		}
		if (tmpFeedback.Sound && typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext))
		{
			try
			{
				this.audioContext = this.audioContext || new (window.AudioContext || window.webkitAudioContext)();
				const tmpOscillator = this.audioContext.createOscillator();
				const tmpGain = this.audioContext.createGain();
				tmpOscillator.frequency.value = tmpGood ? 1320 : 330;
				tmpGain.gain.value = 0.05;
				tmpOscillator.connect(tmpGain);
				tmpGain.connect(this.audioContext.destination);
				tmpOscillator.start();
				tmpOscillator.stop(this.audioContext.currentTime + (tmpGood ? 0.08 : 0.25));
			}
			catch (pError)
			{
				// Audio is optional feedback.
			}
		}
	}

	// ---- Events -----------------------------------------------------------

	/**
	 * @param {(pType: string, pDetail: any) => void} fListener - Types: scan, mode, unhandled, duplicate, feedback, profile.
	 * @return {() => void} unsubscribe
	 */
	subscribe(fListener)
	{
		this.listeners.push(fListener);
		return () =>
		{
			this.listeners = this.listeners.filter((pListener) => pListener !== fListener);
		};
	}

	/**
	 * @param {string} pType
	 * @param {any} pDetail
	 */
	notify(pType, pDetail)
	{
		for (const tmpListener of this.listeners.slice())
		{
			try
			{
				tmpListener(pType, pDetail);
			}
			catch (pError)
			{
				this.log.error(`HeadlightQR listener failed on ${pType}: ${pError.message || pError}`);
			}
		}
	}
}

module.exports = HeadlightQRProvider;
module.exports.default_configuration = _DefaultConfiguration;

},{"../labels/Label-Media-Presets.js":276,"../labels/Label-Renderer.js":277,"../printing/Print-Transport.js":278,"../rendering/QR-Matrix.js":281,"../scanning/Scan-Geolocation.js":283,"../scanning/Wedge-Scan-Source.js":285,"headlight-qrcode":19,"pict-provider":552}],281:[function(require,module,exports){
/**
 * QR symbol generation and vector/raster output.
 *
 * Wraps node-qrcode's encoder only for the module matrix; drawing is done here so every output
 * (screen SVG, print SVG in millimetres, printer-resolution canvas) uses whole modules, a 4-module
 * quiet zone and pure black on white.
 */

const libQRCode = require('qrcode');

const QUIET_ZONE_MODULES = 4;

/**
 * @typedef {Object} QRMatrix
 * @property {number} Size - Modules per side, without the quiet zone.
 * @property {number} Version
 * @property {string} ErrorCorrection - L, M, Q or H.
 * @property {Array<string>} Modes - Encoding modes used (Numeric, Alphanumeric, Byte…).
 * @property {number} Length - Payload length in characters.
 * @property {(pRow: number, pColumn: number) => boolean} isDark
 */

/**
 * @param {string} pPayload
 * @param {Object} [pOptions]
 * @param {'L'|'M'|'Q'|'H'} [pOptions.ErrorCorrection] - Defaults to Q.
 * @return {QRMatrix}
 */
function createMatrix(pPayload, pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpLevel = tmpOptions.ErrorCorrection || 'Q';
	const tmpSymbol = libQRCode.create(String(pPayload), { errorCorrectionLevel: tmpLevel });
	const tmpModules = tmpSymbol.modules;
	return {
		Size: tmpModules.size,
		Version: tmpSymbol.version,
		ErrorCorrection: tmpLevel,
		Modes: Array.from(new Set(tmpSymbol.segments.map((pSegment) => pSegment.mode.id))),
		Length: String(pPayload).length,
		isDark: (pRow, pColumn) => !!tmpModules.get(pRow, pColumn),
	};
}

/**
 * Build one SVG path covering all dark modules (one `h` run per horizontal stretch).
 *
 * @param {QRMatrix} pMatrix
 * @param {number} pOffset - Quiet zone in modules.
 * @return {string}
 */
function buildPath(pMatrix, pOffset)
{
	let tmpPath = '';
	for (let tmpRow = 0; tmpRow < pMatrix.Size; tmpRow++)
	{
		let tmpColumn = 0;
		while (tmpColumn < pMatrix.Size)
		{
			if (!pMatrix.isDark(tmpRow, tmpColumn))
			{
				tmpColumn++;
				continue;
			}
			const tmpStart = tmpColumn;
			while (tmpColumn < pMatrix.Size && pMatrix.isDark(tmpRow, tmpColumn))
			{
				tmpColumn++;
			}
			tmpPath += `M${tmpStart + pOffset} ${tmpRow + pOffset}h${tmpColumn - tmpStart}v1h-${tmpColumn - tmpStart}z`;
		}
	}
	return tmpPath;
}

/**
 * @param {QRMatrix} pMatrix
 * @param {Object} [pOptions]
 * @param {string} [pOptions.Width] - CSS length for width and height, e.g. `24.6mm` or `160px`. Defaults to the module count in px.
 * @param {string} [pOptions.Title] - Accessible title.
 * @param {number} [pOptions.QuietZone] - Modules; defaults to 4.
 * @return {string} an `<svg>` element
 */
function toSVG(pMatrix, pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpQuietZone = (typeof tmpOptions.QuietZone === 'number') ? tmpOptions.QuietZone : QUIET_ZONE_MODULES;
	const tmpTotal = pMatrix.Size + (2 * tmpQuietZone);
	const tmpWidth = tmpOptions.Width || `${tmpTotal}px`;
	const tmpTitle = tmpOptions.Title ? `<title>${escapeXML(tmpOptions.Title)}</title>` : '';
	return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${tmpTotal} ${tmpTotal}" width="${tmpWidth}" height="${tmpWidth}" shape-rendering="crispEdges" role="img">${tmpTitle}<rect width="${tmpTotal}" height="${tmpTotal}" fill="#fff"/><path d="${buildPath(pMatrix, tmpQuietZone)}" fill="#000"/></svg>`;
}

/**
 * Draw the symbol (with quiet zone) onto a canvas context at whole pixels per module.
 *
 * @param {CanvasRenderingContext2D} pContext
 * @param {QRMatrix} pMatrix
 * @param {number} pX
 * @param {number} pY
 * @param {number} pPixelsPerModule - Integer.
 */
function drawToCanvas(pContext, pMatrix, pX, pY, pPixelsPerModule)
{
	const tmpScale = Math.max(1, Math.floor(pPixelsPerModule));
	const tmpTotal = (pMatrix.Size + (2 * QUIET_ZONE_MODULES)) * tmpScale;
	pContext.imageSmoothingEnabled = false;
	pContext.fillStyle = '#fff';
	pContext.fillRect(pX, pY, tmpTotal, tmpTotal);
	pContext.fillStyle = '#000';
	for (let tmpRow = 0; tmpRow < pMatrix.Size; tmpRow++)
	{
		for (let tmpColumn = 0; tmpColumn < pMatrix.Size; tmpColumn++)
		{
			if (pMatrix.isDark(tmpRow, tmpColumn))
			{
				pContext.fillRect(pX + ((tmpColumn + QUIET_ZONE_MODULES) * tmpScale), pY + ((tmpRow + QUIET_ZONE_MODULES) * tmpScale), tmpScale, tmpScale);
			}
		}
	}
}

/**
 * @param {string} pText
 * @return {string}
 */
function escapeXML(pText)
{
	return String(pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

module.exports =
{
	QUIET_ZONE_MODULES,
	createMatrix,
	toSVG,
	drawToCanvas,
	escapeXML,
};

},{"qrcode":744}],282:[function(require,module,exports){
/**
 * Camera scanning through html5-qrcode, mounted into any element.
 *
 * Continuous mode keeps the camera running and reports each new code; a code seen again within
 * RepeatSuppressMS is ignored, so holding a label in front of the camera reports it once.
 */

const RepeatSuppressMS = 1500;

class CameraScanSource
{
	/**
	 * @param {Object} pOptions
	 * @param {string} pOptions.ElementID - Id of the element the camera preview renders into.
	 * @param {(pText: string) => void} pOptions.onScan
	 * @param {(pError: any) => void} [pOptions.onError]
	 */
	constructor(pOptions)
	{
		this.elementID = pOptions.ElementID;
		this.onScan = pOptions.onScan;
		this.onError = pOptions.onError || (() => {});
		this.scanner = null;
		this.running = false;
		this.lastText = '';
		this.lastTime = 0;
	}

	/**
	 * @return {boolean} true when the browser can open a camera at all
	 */
	static isSupported()
	{
		return (typeof navigator !== 'undefined') && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
	}

	/**
	 * @return {Promise<void>}
	 */
	async start()
	{
		if (this.running)
		{
			return;
		}
		const { Html5Qrcode, Html5QrcodeSupportedFormats } = require('html5-qrcode');
		this.scanner = new Html5Qrcode(this.elementID, { verbose: false, formatsToSupport: [ Html5QrcodeSupportedFormats.QR_CODE ] });
		const tmpBox = (pWidth, pHeight) =>
		{
			const tmpSide = Math.floor(Math.min(pWidth, pHeight) * 0.7);
			return { width: tmpSide, height: tmpSide };
		};
		try
		{
			await this.scanner.start({ facingMode: 'environment' }, { fps: 15, qrbox: tmpBox }, (pText) => this.handleText(pText), () => {});
			this.running = true;
		}
		catch (pError)
		{
			this.scanner = null;
			this.onError(pError);
			throw pError;
		}
	}

	/**
	 * @param {string} pText
	 */
	handleText(pText)
	{
		const tmpNow = Date.now();
		if (pText === this.lastText && (tmpNow - this.lastTime) < RepeatSuppressMS)
		{
			this.lastTime = tmpNow;
			return;
		}
		this.lastText = pText;
		this.lastTime = tmpNow;
		this.onScan(pText);
	}

	/**
	 * @return {Promise<void>}
	 */
	async stop()
	{
		if (!this.scanner)
		{
			return;
		}
		const tmpScanner = this.scanner;
		this.scanner = null;
		this.running = false;
		try
		{
			await tmpScanner.stop();
			tmpScanner.clear();
		}
		catch (pError)
		{
			this.onError(pError);
		}
	}
}

module.exports = CameraScanSource;

},{"html5-qrcode":479}],283:[function(require,module,exports){
/**
 * Where a scan happened, when the browser will say without asking.
 *
 * Never prompts: a position is read only when geolocation permission is already granted. Anything
 * else (no API, prompt or denied state, timeout, error) resolves to null, so callers can always
 * await it before writing a record.
 */

/**
 * @typedef {Object} ScanPosition
 * @property {number} Latitude
 * @property {number} Longitude
 * @property {number} [Accuracy] - Metres.
 */

const DEFAULT_TIMEOUT_MS = 4000;
const DEFAULT_MAXIMUM_AGE_MS = 60000;

/**
 * @param {Object} [pOptions]
 * @param {number} [pOptions.TimeoutMS] - Give up after this long. Default 4 s.
 * @param {number} [pOptions.MaximumAgeMS] - Accept a cached fix this old. Default 60 s.
 * @param {any} [pOptions.Navigator] - For tests; defaults to the global navigator.
 * @return {Promise<ScanPosition|null>}
 */
async function getPositionIfPermitted(pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpNavigator = tmpOptions.Navigator || ((typeof navigator !== 'undefined') ? navigator : null);
	if (!tmpNavigator || !tmpNavigator.geolocation || !tmpNavigator.permissions || typeof tmpNavigator.permissions.query !== 'function')
	{
		return null;
	}
	let tmpState = null;
	try
	{
		tmpState = (await tmpNavigator.permissions.query({ name: 'geolocation' })).state;
	}
	catch (pError)
	{
		return null;
	}
	if (tmpState !== 'granted')
	{
		return null;
	}
	const tmpTimeout = Number(tmpOptions.TimeoutMS) || DEFAULT_TIMEOUT_MS;
	return new Promise((fResolve) =>
	{
		let tmpDone = false;
		const fFinish = (pValue) =>
		{
			if (!tmpDone)
			{
				tmpDone = true;
				fResolve(pValue);
			}
		};
		setTimeout(() => fFinish(null), tmpTimeout + 250);
		try
		{
			tmpNavigator.geolocation.getCurrentPosition(
				(pPosition) =>
				{
					const tmpCoordinates = pPosition && pPosition.coords;
					if (!tmpCoordinates || !Number.isFinite(tmpCoordinates.latitude) || !Number.isFinite(tmpCoordinates.longitude))
					{
						fFinish(null);
						return;
					}
					fFinish({ Latitude: tmpCoordinates.latitude, Longitude: tmpCoordinates.longitude, Accuracy: tmpCoordinates.accuracy });
				},
				() => fFinish(null),
				{ enableHighAccuracy: false, timeout: tmpTimeout, maximumAge: (tmpOptions.MaximumAgeMS === undefined) ? DEFAULT_MAXIMUM_AGE_MS : tmpOptions.MaximumAgeMS });
		}
		catch (pError)
		{
			fFinish(null);
		}
	});
}

module.exports =
{
	getPositionIfPermitted,
};

},{}],284:[function(require,module,exports){
/**
 * Recognises a keyboard-emulating ("wedge") barcode scanner by the shape of its keystrokes.
 *
 * Scanners type a whole code in a burst of a few milliseconds per key and end it with Enter or Tab;
 * people don't. A burst is accepted when its mean key interval is under MaxMeanIntervalMS and no
 * single gap exceeds MaxGapMS. A scanner programmed with a Prefix character is recognised by the
 * prefix alone, with no timing involved.
 *
 * Pure logic: feed it key names and timestamps; the DOM binding lives in Wedge-Scan-Source.
 */

/**
 * @typedef {Object} WedgeOptions
 * @property {number} [MaxMeanIntervalMS] - Default 35.
 * @property {number} [MaxGapMS] - Largest single gap inside a burst. Default 80.
 * @property {number} [MinLength] - Default 3.
 * @property {Array<string>} [Terminators] - Key names that end a scan. Default Enter and Tab.
 * @property {string|null} [Prefix] - Optional character the scanner sends first.
 */

/**
 * @typedef {Object} WedgeKeyResult
 * @property {'none'|'buffering'|'complete'} State
 * @property {boolean} Consume - True when the key belongs to a recognised scan and should not reach the page.
 * @property {string} [Value] - The scanned text, when State is complete.
 * @property {number} [MeanIntervalMS]
 */

class WedgeBurstDetector
{
	/**
	 * @param {WedgeOptions} [pOptions]
	 */
	constructor(pOptions)
	{
		const tmpOptions = pOptions || {};
		this.maxMeanInterval = tmpOptions.MaxMeanIntervalMS || 35;
		this.maxGap = tmpOptions.MaxGapMS || 80;
		this.minLength = tmpOptions.MinLength || 3;
		this.terminators = tmpOptions.Terminators || [ 'Enter', 'Tab' ];
		this.prefix = tmpOptions.Prefix || null;
		this.reset();
	}

	reset()
	{
		/** @type {Array<string>} */
		this.buffer = [];
		/** @type {Array<number>} */
		this.times = [];
		this.inPrefixScan = false;
	}

	/**
	 * @param {string} pKey - KeyboardEvent.key
	 * @param {number} pTime - Milliseconds (event.timeStamp or performance.now()).
	 * @return {WedgeKeyResult}
	 */
	handleKey(pKey, pTime)
	{
		if (this.prefix && pKey === this.prefix)
		{
			this.reset();
			this.inPrefixScan = true;
			return { State: 'buffering', Consume: true };
		}

		if (this.terminators.includes(pKey))
		{
			return this._complete(pTime);
		}

		if (typeof pKey !== 'string' || pKey.length !== 1)
		{
			if (!this.inPrefixScan && pKey !== 'Shift')
			{
				this.reset();
			}
			return { State: this.inPrefixScan ? 'buffering' : 'none', Consume: this.inPrefixScan };
		}

		if (!this.inPrefixScan && this.times.length > 0 && (pTime - this.times[this.times.length - 1]) > this.maxGap)
		{
			this.reset();
		}
		this.buffer.push(pKey);
		this.times.push(pTime);
		return { State: 'buffering', Consume: this.inPrefixScan };
	}

	/**
	 * @param {number} pTime
	 * @return {WedgeKeyResult}
	 */
	_complete(pTime)
	{
		const tmpValue = this.buffer.join('');
		const tmpWasPrefixScan = this.inPrefixScan;
		const tmpTimes = this.times.slice();
		this.reset();

		if (tmpWasPrefixScan)
		{
			return tmpValue.length > 0 ? { State: 'complete', Consume: true, Value: tmpValue } : { State: 'none', Consume: true };
		}
		if (tmpValue.length < this.minLength)
		{
			return { State: 'none', Consume: false };
		}
		const tmpIntervals = [];
		for (let i = 1; i < tmpTimes.length; i++)
		{
			tmpIntervals.push(tmpTimes[i] - tmpTimes[i - 1]);
		}
		tmpIntervals.push(pTime - tmpTimes[tmpTimes.length - 1]);
		const tmpMean = tmpIntervals.reduce((pSum, pValue) => pSum + pValue, 0) / tmpIntervals.length;
		const tmpLargest = Math.max(...tmpIntervals);
		if (tmpMean <= this.maxMeanInterval && tmpLargest <= this.maxGap)
		{
			return { State: 'complete', Consume: true, Value: tmpValue, MeanIntervalMS: tmpMean };
		}
		return { State: 'none', Consume: false, MeanIntervalMS: tmpMean };
	}
}

module.exports = WedgeBurstDetector;

},{}],285:[function(require,module,exports){
/**
 * Listens for keyboard-wedge scanner bursts on the page.
 *
 * - Listens in the capture phase, so a scan is seen before the focused field's own handlers.
 * - When a burst completes, the terminator key is suppressed (no accidental form submit) and the
 *   characters the scanner already typed into the focused field are removed.
 * - A focused element marked `data-headlight-qr-pick` owns the scan: its value becomes the decoded
 *   code and it fires `change`, instead of the scan going to the page's scan handlers.
 * - Elements marked `data-headlight-qr-wedge="ignore"` (and password fields) are never touched.
 */

const WedgeBurstDetector = require('./Wedge-Burst-Detector.js');

class WedgeScanSource
{
	/**
	 * @param {Object} pOptions
	 * @param {(pText: string, pDetails: { Target: Element|null, Pick: boolean, PickElement: Element|null, MeanIntervalMS?: number }) => void} pOptions.onScan
	 * @param {import('./Wedge-Burst-Detector.js').WedgeOptions} [pOptions.Detector]
	 * @param {Document} [pOptions.Document]
	 */
	constructor(pOptions)
	{
		this.onScan = pOptions.onScan;
		this.document = pOptions.Document || (typeof document !== 'undefined' ? document : null);
		this.detector = new WedgeBurstDetector(pOptions.Detector);
		this.enabled = false;
		/** @type {Array<{ Key: string, Time: number, State: string }>} recent keys, for diagnostics */
		this.recentKeys = [];
		this._handleKeyDown = (pEvent) => this.handleKeyDown(pEvent);
	}

	enable()
	{
		if (this.enabled || !this.document)
		{
			return;
		}
		this.document.addEventListener('keydown', this._handleKeyDown, true);
		this.enabled = true;
	}

	disable()
	{
		if (!this.enabled || !this.document)
		{
			return;
		}
		this.document.removeEventListener('keydown', this._handleKeyDown, true);
		this.detector.reset();
		this.enabled = false;
	}

	/**
	 * @param {KeyboardEvent} pEvent
	 */
	handleKeyDown(pEvent)
	{
		const tmpTarget = /** @type {any} */ (pEvent.target);
		if (tmpTarget && tmpTarget.closest && (tmpTarget.closest('[data-headlight-qr-wedge="ignore"]') || tmpTarget.type === 'password'))
		{
			this.detector.reset();
			return;
		}
		const tmpTime = (typeof pEvent.timeStamp === 'number' && pEvent.timeStamp > 0) ? pEvent.timeStamp : Date.now();
		const tmpResult = this.detector.handleKey(pEvent.key, tmpTime);
		this.recentKeys.push({ Key: pEvent.key, Time: tmpTime, State: tmpResult.State });
		if (this.recentKeys.length > 60)
		{
			this.recentKeys.shift();
		}
		if (tmpResult.Consume)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (tmpResult.State !== 'complete')
		{
			return;
		}

		const tmpPickElement = (tmpTarget && tmpTarget.closest) ? tmpTarget.closest('[data-headlight-qr-pick]') : null;
		this.removeTypedText(tmpTarget, tmpResult.Value);
		this.onScan(tmpResult.Value, { Target: tmpTarget || null, Pick: !!tmpPickElement, PickElement: tmpPickElement, MeanIntervalMS: tmpResult.MeanIntervalMS });
	}

	/**
	 * Remove the scanned characters the scanner typed into an editable field before the burst was recognised.
	 *
	 * @param {any} pTarget
	 * @param {string} pValue
	 */
	removeTypedText(pTarget, pValue)
	{
		if (!pTarget || typeof pTarget.value !== 'string' || !pValue)
		{
			return;
		}
		if (pTarget.value.endsWith(pValue))
		{
			pTarget.value = pTarget.value.slice(0, pTarget.value.length - pValue.length);
		}
	}
}

module.exports = WedgeScanSource;

},{"./Wedge-Burst-Detector.js":284}],286:[function(require,module,exports){
/**
 * Templates for the `QRCode` input type, by theme. The bundle injects them under whatever
 * template prefixes the host app uses (plain pict-section-form or the HeadLight Bulma themes).
 *
 * Buttons carry only the input hash; the value is read by the provider, never put into markup.
 */

const _EditTemplate = /*HTML*/`
<!-- InputType QRCode {~D:Record.Hash~} -->
<div class="hlqr-input" {~D:Record.Macro.ControlAttr~}>
	<label class="hlqr-input-label" for="HLQR-TEXT-{~D:Record.Macro.RawHTMLID~}">{~D:Record.Name~}</label>
	<div class="hlqr-input-body">
		<div class="hlqr-input-image" id="HLQR-IMAGE-{~D:Record.Macro.RawHTMLID~}"></div>
		<div class="hlqr-input-controls">
			<input type="text" class="hlqr-input-text" id="HLQR-TEXT-{~D:Record.Macro.RawHTMLID~}" data-headlight-qr-pick="{~D:Record.Hash~}" autocomplete="off" placeholder="Scan or type a code" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
			<div class="hlqr-input-buttons" id="HLQR-BUTTONS-{~D:Record.Macro.RawHTMLID~}">
				<button type="button" class="hlqr-input-button" data-hlqr-action="Scan" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-scan')">Scan</button>
				<button type="button" class="hlqr-input-button" data-hlqr-action="Generate" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-generate')">New code</button>
				<button type="button" class="hlqr-input-button" data-hlqr-action="Print" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-print')">Print label</button>
			</div>
			<div class="hlqr-input-message" id="HLQR-MESSAGE-{~D:Record.Macro.RawHTMLID~}" aria-live="polite"></div>
		</div>
	</div>
</div>
`;

const _ReadTemplate = /*HTML*/`
<!-- InputType QRCode {~D:Record.Hash~} -->
<div class="hlqr-input hlqr-input--read" {~D:Record.Macro.ControlAttr~}>
	<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
	<span class="hlqr-input-label">{~D:Record.Name~}</span>
	<div class="hlqr-input-body">
		<div class="hlqr-input-image" id="HLQR-IMAGE-{~D:Record.Macro.RawHTMLID~}"></div>
		<div class="hlqr-input-controls">
			<div class="hlqr-input-value" id="HLQR-VALUE-{~D:Record.Macro.RawHTMLID~}"></div>
			<div class="hlqr-input-buttons" id="HLQR-BUTTONS-{~D:Record.Macro.RawHTMLID~}">
				<button type="button" class="hlqr-input-button" data-hlqr-action="Print" onclick="{~P~}.views['{~D:Context[0].Hash~}'].inputEvent('{~D:Record.Hash~}', 'qr-print')">Print label</button>
			</div>
		</div>
	</div>
</div>
`;

const _PrintTemplate = /*HTML*/`
<!-- InputType QRCode {~D:Record.Hash~} -->
<div class="hlqr-input hlqr-input--print" {~D:Record.Macro.ControlAttr~}>
	<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
	<span class="hlqr-input-label">{~D:Record.Name~}</span>
	<div class="hlqr-input-body">
		<div class="hlqr-input-image" id="HLQR-IMAGE-{~D:Record.Macro.RawHTMLID~}"></div>
		<div class="hlqr-input-value" id="HLQR-VALUE-{~D:Record.Macro.RawHTMLID~}"></div>
	</div>
</div>
`;

/**
 * @param {string} pTemplate
 * @return {Array<{ HashPostfix: string, DefaultInputExtensions: Array<string>, Template: string }>}
 */
function forInputType(pTemplate)
{
	return [ '-Template-Input-InputType-QRCode', '-VerticalTemplate-Input-InputType-QRCode' ].map((pPostfix) =>
		({ HashPostfix: pPostfix, DefaultInputExtensions: [ 'HeadlightQR-Input' ], Template: pTemplate }));
}

module.exports =
{
	Edit: forInputType(_EditTemplate),
	Read: forInputType(_ReadTemplate),
	Print: forInputType(_PrintTemplate),
};

},{}],287:[function(require,module,exports){
/**
 * Camera scanner, as a modal or embedded in a page.
 *
 * Every code the camera reads goes to HeadlightQR.receiveScan, so the active scan mode decides
 * what happens; the camera itself has no opinion about entities.
 */

const libPictView = require('pict-view');
const CameraScanSource = require('../scanning/Camera-Scan-Source.js');
const libMatrix = require('../rendering/QR-Matrix.js');

const MODAL_ID = 'HeadlightQR-CameraModal';

const _DefaultConfiguration =
{
	ViewIdentifier: 'HeadlightQR-Camera',
	AutoRender: false,
	CSS: /*css*/`
.hlqr-camera-modal { position: fixed; inset: 0; z-index: 1200; display: flex; align-items: center; justify-content: center; background: rgba(15, 23, 42, 0.7); }
.hlqr-camera-card { width: min(92vw, 480px); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2933); border-radius: 10px; overflow: hidden; box-shadow: 0 10px 40px rgba(0,0,0,0.4); }
.hlqr-camera-head { display: flex; align-items: center; justify-content: space-between; padding: 0.75rem 1rem; font-weight: 600; }
.hlqr-camera-reader { width: 100%; min-height: 240px; background: #000; }
.hlqr-camera-foot { padding: 0.6rem 1rem; font-size: 0.85rem; min-height: 2.2rem; }
.hlqr-camera-button { border: 1px solid var(--theme-color-border-default, #d5dbe1); background: transparent; color: inherit; border-radius: 6px; padding: 0.3rem 0.8rem; cursor: pointer; }
`,
};

class HeadlightQRCamera extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultConfiguration, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
		this.source = null;
		this.onCancel = null;
		this.embeddedID = null;
	}

	/**
	 * Open the camera in a modal.
	 *
	 * @param {Object} [pOptions] - `{ Title, onCancel }`
	 * @return {Promise<void>}
	 */
	async open(pOptions)
	{
		const tmpOptions = pOptions || {};
		await this.close();
		this.onCancel = tmpOptions.onCancel || null;
		const tmpModal = document.createElement('div');
		tmpModal.id = MODAL_ID;
		tmpModal.className = 'hlqr-camera-modal';
		tmpModal.setAttribute('role', 'dialog');
		tmpModal.setAttribute('aria-modal', 'true');
		tmpModal.innerHTML = `<div class="hlqr-camera-card">`
			+ `<div class="hlqr-camera-head"><span>${libMatrix.escapeXML(tmpOptions.Title || 'Scan a code')}</span><button type="button" class="hlqr-camera-button" data-hlqr-camera-cancel>Cancel</button></div>`
			+ `<div id="${MODAL_ID}-Reader" class="hlqr-camera-reader"></div>`
			+ `<div class="hlqr-camera-foot" id="${MODAL_ID}-Status">Point the camera at the code.</div></div>`;
		document.body.appendChild(tmpModal);
		tmpModal.querySelector('[data-hlqr-camera-cancel]').addEventListener('click', () => this.cancel());
		await this.startSource(`${MODAL_ID}-Reader`, `${MODAL_ID}-Status`);
	}

	/**
	 * Run the camera inside an element already on the page (continuous session scanning).
	 *
	 * @param {string} pElementID
	 * @return {Promise<void>}
	 */
	async openEmbedded(pElementID)
	{
		await this.close();
		this.embeddedID = pElementID;
		await this.startSource(pElementID, null);
	}

	/**
	 * @param {string} pReaderID
	 * @param {string|null} pStatusID
	 */
	async startSource(pReaderID, pStatusID)
	{
		const tmpProvider = this.pict.providers.HeadlightQR;
		if (!CameraScanSource.isSupported())
		{
			this.setStatus(pStatusID, 'This browser can\'t open a camera here. Camera scanning needs HTTPS (or localhost).');
			return;
		}
		this.source = new CameraScanSource(
			{
				ElementID: pReaderID,
				onScan: (pText) => tmpProvider.receiveScan(pText, { Source: 'camera' }),
				onError: (pError) => this.setStatus(pStatusID, `The camera couldn't start: ${(pError && pError.message) || pError}`),
			});
		try
		{
			await this.source.start();
		}
		catch (pError)
		{
			this.source = null;
		}
	}

	/**
	 * @param {string|null} pStatusID
	 * @param {string} pMessage
	 */
	setStatus(pStatusID, pMessage)
	{
		if (!pStatusID)
		{
			return;
		}
		const tmpElement = document.getElementById(pStatusID);
		if (tmpElement)
		{
			tmpElement.textContent = pMessage;
		}
	}

	cancel()
	{
		const tmpOnCancel = this.onCancel;
		this.onCancel = null;
		this.close();
		if (tmpOnCancel)
		{
			tmpOnCancel();
		}
	}

	/**
	 * @return {Promise<void>}
	 */
	async close()
	{
		if (this.source)
		{
			const tmpSource = this.source;
			this.source = null;
			await tmpSource.stop();
		}
		const tmpModal = (typeof document !== 'undefined') ? document.getElementById(MODAL_ID) : null;
		if (tmpModal)
		{
			tmpModal.remove();
		}
		this.embeddedID = null;
	}

	/** @return {boolean} */
	isOpen()
	{
		return !!this.source;
	}
}

module.exports = HeadlightQRCamera;
module.exports.default_configuration = _DefaultConfiguration;

},{"../rendering/QR-Matrix.js":281,"../scanning/Camera-Scan-Source.js":282,"pict-view":733}],288:[function(require,module,exports){
/**
 * The scan mode indicator: always shows which mode a scan will land in.
 *
 * Idle and Go to are a small "Scanner ready" chip; Pick and Session are a full-width coloured bar
 * naming the job, so a lab tech can see from across the bench what the next scan will do.
 */

const libPictView = require('pict-view');
const libMatrix = require('../rendering/QR-Matrix.js');

const _MODE_LABELS =
{
	Idle: 'Scanner idle',
	GoTo: 'Scan to open',
	Pick: 'Scanning into a field',
	Session: 'Scanning job in progress',
};

const _STATUS_TEXT =
{
	Found: 'Found',
	Deleted: 'Deleted',
	NotFound: 'Not recognised',
	Rejected: 'Not accepted here',
	ActionOutOfContext: 'Card not for this screen',
	Action: 'Card',
	Picked: 'Filled in',
	Unresolved: 'Read',
	Empty: 'Empty scan',
};

const _DefaultConfiguration =
{
	ViewIdentifier: 'HeadlightQR-ModeBar',
	DefaultDestinationAddress: '#HeadlightQR-ModeBar',
	AutoRender: false,
	CSS: /*css*/`
.hlqr-modebar { display: flex; align-items: center; gap: 0.75rem; padding: 0.4rem 0.9rem; border-radius: 6px; font-size: 0.9rem; background: var(--theme-color-background-panel, #f4f6f8); color: var(--theme-color-text-primary, #1f2933); border: 1px solid var(--theme-color-border-default, #d5dbe1); }
.hlqr-modebar--Pick { background: #1d4ed8; color: #fff; border-color: #1d4ed8; }
.hlqr-modebar--Session { background: #b45309; color: #fff; border-color: #b45309; font-weight: 600; font-size: 1rem; padding: 0.6rem 1rem; }
.hlqr-modebar-mode { text-transform: uppercase; letter-spacing: 0.06em; font-size: 0.75rem; font-weight: 700; }
.hlqr-modebar-label { flex: 1 1 auto; }
.hlqr-modebar-chip { font-size: 0.75rem; padding: 0.1rem 0.5rem; border-radius: 999px; background: rgba(0,0,0,0.08); white-space: nowrap; }
.hlqr-modebar-chip--ok { background: #15803d; color: #fff; }
.hlqr-modebar-chip--warn { background: #b91c1c; color: #fff; }
`,
};

class HeadlightQRModeBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultConfiguration, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
		this.lastScan = null;
		this.unsubscribe = null;
	}

	onAfterInitialize()
	{
		const tmpProvider = this.pict.providers.HeadlightQR;
		if (tmpProvider && !this.unsubscribe)
		{
			this.unsubscribe = tmpProvider.subscribe((pType, pDetail) =>
			{
				if (pType === 'scan')
				{
					this.lastScan = pDetail;
				}
				if (pType === 'scan' || pType === 'mode')
				{
					this.paint();
				}
			});
		}
		return super.onAfterInitialize();
	}

	/**
	 * @param {string} [pDestinationAddress]
	 */
	paint(pDestinationAddress)
	{
		const tmpProvider = this.pict.providers.HeadlightQR;
		if (!tmpProvider)
		{
			return;
		}
		const tmpAddress = pDestinationAddress || this.options.DefaultDestinationAddress;
		const tmpState = tmpProvider.getScanState();
		const tmpMode = tmpState.Mode;
		const tmpLabel = tmpState.Label || _MODE_LABELS[tmpMode] || '';
		let tmpLastChip = '';
		if (this.lastScan)
		{
			const tmpGood = [ 'Found', 'Action', 'Picked' ].includes(this.lastScan.Status);
			tmpLastChip = `<span class="hlqr-modebar-chip ${tmpGood ? 'hlqr-modebar-chip--ok' : 'hlqr-modebar-chip--warn'}">Last scan: ${libMatrix.escapeXML(_STATUS_TEXT[this.lastScan.Status] || this.lastScan.Status || '')}</span>`;
		}
		const tmpWedgeChip = `<span class="hlqr-modebar-chip">${tmpState.Wedge ? 'Scanner ready' : 'Scanner off'}</span>`;
		const tmpHTML = `<div class="hlqr-modebar hlqr-modebar--${tmpMode}" role="status" aria-live="polite">`
			+ `<span class="hlqr-modebar-mode">${libMatrix.escapeXML(tmpMode === 'Session' ? 'Job' : tmpMode)}</span>`
			+ `<span class="hlqr-modebar-label">${libMatrix.escapeXML(tmpLabel)}</span>`
			+ `${tmpLastChip}${tmpWedgeChip}</div>`;
		this.pict.ContentAssignment.assignContent(tmpAddress, tmpHTML);
	}
}

module.exports = HeadlightQRModeBar;
module.exports.default_configuration = _DefaultConfiguration;

},{"../rendering/QR-Matrix.js":281,"pict-view":733}],289:[function(require,module,exports){
/**
 * Print options dialog: choose the label stock, see the labels at true size with any size warnings, print.
 *
 * Printing happens in the dialog's own Print click, so the browser's print call is always inside a
 * user gesture. The chosen stock becomes this device's stock for Print.
 */

const libPictView = require('pict-view');
const libMatrix = require('../rendering/QR-Matrix.js');

const DIALOG_ID = 'HeadlightQR-PrintDialog';

const _DefaultConfiguration =
{
	ViewIdentifier: 'HeadlightQR-PrintDialog',
	AutoRender: false,
	CSS: /*css*/`
.hlqr-print-backdrop { position: fixed; inset: 0; z-index: 1180; display: flex; align-items: center; justify-content: center; background: rgba(15, 23, 42, 0.55); }
.hlqr-print-card { width: min(94vw, 760px); max-height: 92vh; display: flex; flex-direction: column; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2933); border-radius: 10px; box-shadow: 0 10px 40px rgba(0,0,0,0.4); }
.hlqr-print-head { display: flex; flex-wrap: wrap; gap: 0.6rem 1rem; align-items: center; padding: 0.9rem 1.1rem; border-bottom: 1px solid var(--theme-color-border-default, #d5dbe1); }
.hlqr-print-head h2 { font-size: 1.05rem; margin: 0; flex: 1 1 auto; }
.hlqr-print-head label { font-size: 0.85rem; display: inline-flex; gap: 0.4rem; align-items: center; }
.hlqr-print-head label[hidden] { display: none; }
.hlqr-print-head select, .hlqr-print-head input { padding: 0.3rem 0.45rem; border: 1px solid var(--theme-color-border-default, #c5ccd3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: inherit; }
.hlqr-print-plan { padding: 0.5rem 1.1rem 0; font-size: 0.85rem; opacity: 0.85; }
.hlqr-print-warning { padding: 0.25rem 1.1rem 0; font-size: 0.85rem; color: #b91c1c; }
.hlqr-print-preview { flex: 1 1 auto; overflow: auto; padding: 1rem 1.1rem; display: flex; flex-direction: column; gap: 0.8rem; align-items: flex-start; background: repeating-linear-gradient(45deg, rgba(0,0,0,0.04), rgba(0,0,0,0.04) 10px, transparent 10px, transparent 20px); }
.hlqr-print-preview .hlqr-print-page { box-shadow: 0 1px 4px rgba(0,0,0,0.25); }
.hlqr-print-foot { display: flex; justify-content: flex-end; gap: 0.5rem; padding: 0.8rem 1.1rem; border-top: 1px solid var(--theme-color-border-default, #d5dbe1); }
.hlqr-print-button { border: 1px solid var(--theme-color-border-default, #c5ccd3); background: transparent; color: inherit; border-radius: 6px; padding: 0.45rem 1rem; cursor: pointer; }
.hlqr-print-button--primary { background: #1d4ed8; border-color: #1d4ed8; color: #fff; font-weight: 600; }
`,
};

class HeadlightQRPrintDialog extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultConfiguration, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
		this.items = [];
		this.presetID = '';
		this.startIndex = 0;
		this.title = '';
	}

	/**
	 * @param {Array<{ Entity?: string, Value?: string, Payload?: string, Lines?: Array<string> }>} pItems
	 * @param {Object} [pOptions] - `{ Title }`
	 */
	open(pItems, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpProvider = this.pict.providers.HeadlightQR;
		this.items = pItems || [];
		this.presetID = tmpProvider.getDeviceMediaPreset().Id;
		this.startIndex = 0;
		this.title = tmpOptions.Title || ((this.items.length === 1) ? 'Print label' : `Print ${this.items.length} labels`);
		this.close();
		const tmpBackdrop = document.createElement('div');
		tmpBackdrop.id = DIALOG_ID;
		tmpBackdrop.className = 'hlqr-print-backdrop';
		tmpBackdrop.setAttribute('role', 'dialog');
		tmpBackdrop.setAttribute('aria-modal', 'true');
		const tmpDefaultID = tmpProvider.getDefaultMediaPreset().Id;
		const tmpPresets = tmpProvider.getMediaPresets().map((pPreset) => `<option value="${libMatrix.escapeXML(pPreset.Id)}"${pPreset.Id === this.presetID ? ' selected' : ''}>${libMatrix.escapeXML(pPreset.Name)}${pPreset.Id === tmpDefaultID ? ' (default)' : ''}</option>`).join('');
		tmpBackdrop.innerHTML = `<div class="hlqr-print-card">`
			+ `<div class="hlqr-print-head"><h2>${libMatrix.escapeXML(this.title)}</h2>`
			+ `<label>Label stock <select data-hlqr-print="preset">${tmpPresets}</select></label>`
			+ `<label data-hlqr-print="start-wrap">Start at label <input type="number" min="1" value="1" style="width:4.5rem" data-hlqr-print="start"></label></div>`
			+ `<div class="hlqr-print-plan" data-hlqr-print="plan"></div><div data-hlqr-print="warnings"></div>`
			+ `<div class="hlqr-print-preview" data-hlqr-print="preview"></div>`
			+ `<div class="hlqr-print-foot"><button type="button" class="hlqr-print-button" data-hlqr-print="cancel">Cancel</button>`
			+ `<button type="button" class="hlqr-print-button hlqr-print-button--primary" data-hlqr-print="print">Print</button></div></div>`;
		document.body.appendChild(tmpBackdrop);
		tmpBackdrop.addEventListener('change', (pEvent) => this.handleChange(pEvent));
		tmpBackdrop.addEventListener('click', (pEvent) => this.handleClick(pEvent, tmpBackdrop));
		this.refresh();
	}

	/**
	 * @param {Event} pEvent
	 */
	handleChange(pEvent)
	{
		const tmpTarget = /** @type {HTMLInputElement} */ (pEvent.target);
		const tmpRole = tmpTarget.getAttribute('data-hlqr-print');
		if (tmpRole === 'preset')
		{
			this.presetID = tmpTarget.value;
		}
		if (tmpRole === 'start')
		{
			this.startIndex = Math.max(0, (parseInt(tmpTarget.value, 10) || 1) - 1);
		}
		this.refresh();
	}

	/**
	 * @param {MouseEvent} pEvent
	 * @param {HTMLElement} pBackdrop
	 */
	handleClick(pEvent, pBackdrop)
	{
		const tmpTarget = /** @type {HTMLElement} */ (pEvent.target);
		const tmpRole = tmpTarget.getAttribute('data-hlqr-print');
		if (tmpTarget === pBackdrop || tmpRole === 'cancel')
		{
			this.close();
			return;
		}
		if (tmpRole === 'print')
		{
			const tmpProvider = this.pict.providers.HeadlightQR;
			// The stock picked here is what Print uses on this device; picking the default follows the customer's default again.
			if (this.presetID === tmpProvider.getDefaultMediaPreset().Id)
			{
				tmpProvider.clearDeviceMediaPreset();
			}
			else
			{
				tmpProvider.setDeviceMediaPreset(this.presetID);
			}
			tmpProvider.printLabels(this.items, { PresetID: this.presetID, StartIndex: this.startIndex });
			this.close();
		}
	}

	refresh()
	{
		const tmpDialog = document.getElementById(DIALOG_ID);
		if (!tmpDialog)
		{
			return;
		}
		const tmpProvider = this.pict.providers.HeadlightQR;
		try
		{
			const tmpJob = tmpProvider.previewLabels(this.items, { PresetID: this.presetID, StartIndex: this.startIndex });
			const tmpPlan = tmpJob.Plans[0];
			const tmpStartWrap = tmpDialog.querySelector('[data-hlqr-print="start-wrap"]');
			tmpStartWrap.hidden = (tmpJob.Preset.Kind !== 'Sheet');
			tmpDialog.querySelector('[data-hlqr-print="plan"]').textContent = tmpPlan ? `Each QR square prints at ${tmpPlan.ModuleMM.toFixed(2)} mm; the code is ${tmpPlan.CodeMM.toFixed(1)} mm wide.` : '';
			const tmpWarnings = Array.from(new Set(tmpJob.Plans.flatMap((pPlan) => pPlan.Warnings.map((pWarning) => pWarning.Message))));
			tmpDialog.querySelector('[data-hlqr-print="warnings"]').innerHTML = tmpWarnings.map((pMessage) => `<div class="hlqr-print-warning">${libMatrix.escapeXML(pMessage)}</div>`).join('');
			tmpDialog.querySelector('[data-hlqr-print="preview"]').innerHTML = tmpJob.HTML;
		}
		catch (pError)
		{
			tmpDialog.querySelector('[data-hlqr-print="warnings"]').innerHTML = `<div class="hlqr-print-warning">${libMatrix.escapeXML(pError.message || pError)}</div>`;
		}
	}

	close()
	{
		const tmpExisting = (typeof document !== 'undefined') ? document.getElementById(DIALOG_ID) : null;
		if (tmpExisting)
		{
			tmpExisting.remove();
		}
	}
}

module.exports = HeadlightQRPrintDialog;
module.exports.default_configuration = _DefaultConfiguration;

},{"../rendering/QR-Matrix.js":281,"pict-view":733}],290:[function(require,module,exports){
/**
 * What a "Go to" scan shows: the record, where it can be opened, or why nothing was found.
 *
 * It never navigates by itself. Where a record opens comes from the app's destination resolver
 * (`HeadlightQR` option `DestinationResolver`), so the same sheet works in every app.
 */

const libPictView = require('pict-view');
const libMatrix = require('../rendering/QR-Matrix.js');

const SHEET_ID = 'HeadlightQR-ResultSheet';

const _DefaultConfiguration =
{
	ViewIdentifier: 'HeadlightQR-ResultSheet',
	AutoRender: false,
	CSS: /*css*/`
.hlqr-sheet-backdrop { position: fixed; inset: 0; z-index: 1150; display: flex; align-items: flex-end; justify-content: center; background: rgba(15, 23, 42, 0.45); }
.hlqr-sheet { width: min(100vw, 560px); max-height: 85vh; overflow: auto; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2933); border-radius: 12px 12px 0 0; padding: 1.1rem 1.25rem 1.25rem; box-shadow: 0 -8px 30px rgba(0,0,0,0.3); }
@media (min-width: 700px) { .hlqr-sheet-backdrop { align-items: center; } .hlqr-sheet { border-radius: 12px; } }
.hlqr-sheet-kicker { font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.06em; opacity: 0.7; }
.hlqr-sheet-title { font-size: 1.25rem; font-weight: 700; margin: 0.15rem 0 0.5rem; word-break: break-word; }
.hlqr-sheet-message { margin: 0.25rem 0 0.75rem; line-height: 1.4; }
.hlqr-sheet-fields { display: grid; grid-template-columns: max-content 1fr; gap: 0.25rem 0.9rem; margin: 0.5rem 0 1rem; font-size: 0.9rem; }
.hlqr-sheet-fields dt { opacity: 0.7; }
.hlqr-sheet-fields dd { margin: 0; word-break: break-word; }
.hlqr-sheet-actions { display: flex; flex-wrap: wrap; gap: 0.5rem; }
.hlqr-sheet-button { border: 1px solid var(--theme-color-border-default, #c5ccd3); background: transparent; color: inherit; border-radius: 6px; padding: 0.45rem 0.9rem; cursor: pointer; font-size: 0.9rem; }
.hlqr-sheet-button--primary { background: #1d4ed8; border-color: #1d4ed8; color: #fff; font-weight: 600; }
.hlqr-sheet-pill { display: inline-block; font-size: 0.75rem; padding: 0.1rem 0.5rem; border-radius: 999px; background: rgba(0,0,0,0.08); margin-left: 0.4rem; vertical-align: middle; }
.hlqr-sheet-pill--deleted { background: #b91c1c; color: #fff; }
`,
};

/**
 * @param {any} pValue
 * @return {string}
 */
function escape(pValue)
{
	return libMatrix.escapeXML(pValue === null || pValue === undefined ? '' : String(pValue));
}

/**
 * @param {string} pISO
 * @return {string}
 */
function formatDate(pISO)
{
	const tmpDate = new Date(pISO);
	if (!pISO || isNaN(tmpDate.getTime()))
	{
		return 'an unknown date';
	}
	return tmpDate.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

class HeadlightQRResultSheet extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultConfiguration, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
		/** @type {Array<any>} */
		this.currentDestinations = [];
	}

	/**
	 * @param {import('../providers/Pict-Provider-HeadlightQR.js').QRResolution} pResolution
	 * @return {Promise<void>}
	 */
	async show(pResolution)
	{
		const tmpProvider = this.pict.providers.HeadlightQR;
		const tmpDefinition = pResolution.Entity ? tmpProvider.getEntityDefinition(pResolution.Entity) : null;
		const tmpNoun = tmpDefinition ? tmpDefinition.Label : 'code';
		let tmpBody = '';
		this.currentDestinations = [];

		switch (pResolution.Status)
		{
			case 'Found':
			{
				const tmpSummary = tmpProvider.describeRecord(pResolution.Entity, pResolution.Record);
				const tmpRouting = await tmpProvider.getDestinations(pResolution);
				this.currentDestinations = tmpRouting.Destinations || [];
				const tmpFields = (tmpSummary.Fields || []).map((pField) => `<dt>${escape(pField.Label)}</dt><dd>${escape(pField.Value)}</dd>`).join('');
				const tmpStatusPill = tmpSummary.Status ? `<span class="hlqr-sheet-pill">${escape(tmpSummary.Status)}</span>` : '';
				const tmpBlocked = tmpRouting.Blocked ? `<p class="hlqr-sheet-message">${escape(tmpRouting.Blocked.Message)}</p>` : '';
				const tmpButtons = this.currentDestinations.map((pDestination, pIndex) =>
					`<button type="button" class="hlqr-sheet-button${pIndex === 0 ? ' hlqr-sheet-button--primary' : ''}" data-hlqr-destination="${pIndex}">${escape(pDestination.Label)}</button>`).join('');
				tmpBody = `<div class="hlqr-sheet-kicker">${escape(tmpNoun)}</div>`
					+ `<div class="hlqr-sheet-title">${escape(tmpSummary.Title)}${tmpStatusPill}</div>`
					+ tmpBlocked
					+ (tmpFields ? `<dl class="hlqr-sheet-fields">${tmpFields}</dl>` : '')
					+ `<div class="hlqr-sheet-actions">${tmpButtons}<button type="button" class="hlqr-sheet-button" data-hlqr-close>Close</button></div>`;
				break;
			}
			case 'Deleted':
			{
				const tmpSummary = tmpProvider.describeRecord(pResolution.Entity, pResolution.Record);
				const tmpWho = pResolution.DeletedByName ? ` by ${escape(pResolution.DeletedByName)}` : '';
				tmpBody = `<div class="hlqr-sheet-kicker">${escape(tmpNoun)}</div>`
					+ `<div class="hlqr-sheet-title">${escape(tmpSummary.Title)}<span class="hlqr-sheet-pill hlqr-sheet-pill--deleted">Deleted</span></div>`
					+ `<p class="hlqr-sheet-message">This ${escape(tmpNoun)} was deleted on ${escape(formatDate(pResolution.Record.DeleteDate))}${tmpWho}. The label is still readable, but the record is no longer in use.</p>`
					+ `<div class="hlqr-sheet-actions"><button type="button" class="hlqr-sheet-button" data-hlqr-close>Close</button></div>`;
				break;
			}
			case 'Rejected':
			{
				const tmpMessage = (pResolution.Reason === 'ActionOutOfContext')
					? `That card is for the "${escape(pResolution.Decoded.Workflow)}" job. Start that job first, then scan the card again.`
					: `That's a ${escape(tmpNoun)}, which this screen doesn't take.`;
				tmpBody = `<div class="hlqr-sheet-title">Not accepted here</div><p class="hlqr-sheet-message">${tmpMessage}</p>`
					+ `<div class="hlqr-sheet-actions"><button type="button" class="hlqr-sheet-button" data-hlqr-close>Close</button></div>`;
				break;
			}
			case 'Unresolved':
			{
				tmpBody = `<div class="hlqr-sheet-title">Code read</div><p class="hlqr-sheet-message"><code>${escape(pResolution.Decoded.Value || pResolution.Decoded.Raw)}</code></p>`
					+ `<div class="hlqr-sheet-actions"><button type="button" class="hlqr-sheet-button" data-hlqr-close>Close</button></div>`;
				break;
			}
			default:
			{
				const tmpCode = (pResolution.Decoded && (pResolution.Decoded.Value || pResolution.Decoded.Raw)) || '';
				tmpBody = `<div class="hlqr-sheet-title">Nothing found</div>`
					+ `<p class="hlqr-sheet-message">We couldn't find anything with the code <code>${escape(tmpCode)}</code>. Check the label isn't damaged, or search for it by hand.</p>`
					+ `<div class="hlqr-sheet-actions"><button type="button" class="hlqr-sheet-button" data-hlqr-close>Close</button></div>`;
			}
		}

		this.close();
		const tmpBackdrop = document.createElement('div');
		tmpBackdrop.id = SHEET_ID;
		tmpBackdrop.className = 'hlqr-sheet-backdrop';
		tmpBackdrop.innerHTML = `<div class="hlqr-sheet" role="dialog" aria-modal="true">${tmpBody}</div>`;
		tmpBackdrop.addEventListener('click', (pEvent) =>
		{
			const tmpTarget = /** @type {HTMLElement} */ (pEvent.target);
			if (tmpTarget === tmpBackdrop || tmpTarget.hasAttribute('data-hlqr-close'))
			{
				this.close();
				return;
			}
			const tmpIndex = tmpTarget.getAttribute('data-hlqr-destination');
			if (tmpIndex !== null)
			{
				this.go(this.currentDestinations[Number(tmpIndex)]);
			}
		});
		document.body.appendChild(tmpBackdrop);
		const tmpFirstButton = tmpBackdrop.querySelector('button');
		if (tmpFirstButton)
		{
			tmpFirstButton.focus();
		}
	}

	/**
	 * @param {{ Label: string, URL?: string, onSelect?: () => void }} pDestination
	 */
	go(pDestination)
	{
		if (!pDestination)
		{
			return;
		}
		this.close();
		if (typeof pDestination.onSelect === 'function')
		{
			pDestination.onSelect();
			return;
		}
		if (pDestination.URL)
		{
			window.location.assign(pDestination.URL);
		}
	}

	close()
	{
		const tmpExisting = (typeof document !== 'undefined') ? document.getElementById(SHEET_ID) : null;
		if (tmpExisting)
		{
			tmpExisting.remove();
		}
	}
}

module.exports = HeadlightQRResultSheet;
module.exports.default_configuration = _DefaultConfiguration;

},{"../rendering/QR-Matrix.js":281,"pict-view":733}],291:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');

class HeadlightModalFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') } & { EntityProvider: any, HeadlightPopover: any, addTemplate: any, TemplateProvider: any, HeadlightRestClient: any, MetaTemplate: any, manifest: any, resolveStateFromAddress: any, ManifestPackagingService: any, parseTemplate: any }}}
		 */
		this.fable;

		this.serviceType = 'QuickSummaries';

        this.typeConfig = {};
        this.dateFormat = 'YYYY-MM-DD';
        this.decimalPrecision = 2;
		/** @type {Record<string, Array<Function>>} - entity type -> addRecordDecorator functions */
		this.recordDecorators = {};
        this.typeIconMap =
        {
            'LineItem': 'list-tree',
            'Project': 'folder-open',
            'Sample': 'qr-code',
            'User': 'user',
            'Document': 'file-lines',
            'TestInstance': 'microscope',
            'Test': 'clipboard-list-check',
            'Location': 'location-dot',
            'ProductionPlant': 'industry',
            'MixDesign': 'vial',
            'Material': 'boxes-packing',
            'Supplier': 'truck-fast',
            'Producer': 'tractor',
            'Bridge': 'bridge',
        };
        this.fable.MetaTemplate.addPattern('{~QuickSummary:', '~}', (pHash, pData) =>
		{
            const tokens = pHash?.split('^');
            if (tokens.length !== 2)
            {
                console.log('[QuickSummariesService] Cannot render quick summary, missing either an entity or an ID.');
                return '';
            }
			const value = !isNaN(tokens[1]) ? tokens[1] : this.fable.resolveStateFromAddress(tokens[1], pData);
            const type = tokens[0];
            const uuid = this.fable.getUUID();
            return /*html*/`
                <button
                    type="button"
                    class="button is-ghost has-text-info p-0 m-0 is-inline-block"
                    style="font-size: inherit; line-height: inherit;"
                    id="${ type }-${ uuid }"
                    aria-haspopup="true"
                    onmouseover="_Pict.fable.services.HeadlightQuickSummaries.spawnQuickSummary({ ID: ${ value }, parentID: '${ type }-${ uuid }', type: '${ type }'})"
                    onclick="_Pict.fable.services.HeadlightQuickSummaries.spawnQuickSummary({ ID: ${ value }, parentID: '${ type }-${ uuid }', type: '${ type }'})">
                    <i class="fas fa-${ this.typeIconMap[type] || 'circle-info' }" aria-hidden="true"></i>
                </button>
            `;
		});
	}

    _linkBuilder(type, field, record, template)
    {
        const baseURL = window.location.origin.includes('localhost') ? window.location.origin.replaceAll(window.location.origin.split('.')[1], 'qa.headlight.com') : window.location.origin;
        if (type == 'Document')
        {
            template = template || `https://links${ baseURL.replaceAll(baseURL.split('.')[0], '') }/document/{~D:Record.${ field }~}`;
        }
        else
        {
            template = template || `https://home${ baseURL.replaceAll(baseURL.split('.')[0], '') }/customer/{~D:Record.IDCustomer~}/master-list/${ type.toLowerCase() }/{~D:Record.${ field }~}`;
        }
        if (template)
        {
            return this.fable.parseTemplate(template, record);
        }
        return '';
    }

    applyTypeConfig(tc)
    {
        this.typeConfig = Object.assign(this.typeConfig, tc);
    }

    addManifestForType(type, manifest)
    {
        this.typeConfig[type] = manifest;
    }

    _getTypeSchema(type)
    {
		return new Promise((resolve, reject) =>
		{
			this.fable.HeadlightRestClient.getJSON(`${ type }/Schema`, (pError, pBody) =>
			{
				if (pError)
				{
					this.fable.log.error(`Error getting schema: `, pError);
					return reject(pError);
				}
                if (!pBody?.MeadowSchema?.Schema)
                {
                    pBody.MeadowSchema = 
                    {
                        Schema: []
                    };
                    // If no meadow schema, jimmy the properties into the same format to make consumption easier.
                    for (const p of Object.keys(pBody.properties))
                    {
                        pBody.MeadowSchema.Schema.push(
                        {
                            Column: p,
                            Type: pBody.properties[p].type
                        });
                    }
                }
				resolve(pBody?.MeadowSchema?.Schema);
			});
		});
    }

    async _generateDefaultManifest(type)
    {
        const schema = await this._getTypeSchema(type);
        const tempManifest = 
        {
            Scope: `${ type }-Summary`,
	        TitleTemplate: this._getHumanReadableFieldName(type),
            Descriptors: {}
        };
        for (const field of schema)
        {
            const f = field.Column;
            // Ignore IDs and delete auditing fields plus any fields configured to exclude.
            if (f == `ID${ type }` || f == `GUID${ type }` || f.startsWith('Delet'))
            {
                continue;
            }

            // Resolve IDs
            else if (f.includes('ID') && f.split('ID')?.['1'] && !f.includes('GUID'))
            {
                const cleanedField = '_' + f.replaceAll('ID', '');
                tempManifest.Descriptors[cleanedField] =
                {
                    Hash: cleanedField,
                    Name: this._getHumanReadableFieldName(f)
                };
            }
            else if (f.includes('Date') || f.includes('Time') || field.Type.includes('Date') || field.Type.includes('Time'))
            {
                tempManifest.Descriptors[`${ f }_Formatted`] =
                {
                    Hash: `${ f }_Formatted`,
                    Name: this._getHumanReadableFieldName(f),
                    DataType: 'DateTime',
                    HeadlightSummary:
                    {
                        DateFormat: this.dateFormat
                    }
                };
            }
            else if (['number', 'Decimal'].includes(field.Type))
            {
                tempManifest.Descriptors[`${ f }_Formatted`] =
                {
                    Hash: `${ f }_Formatted`,
                    Name: this._getHumanReadableFieldName(f),
                    DataType: 'PreciseNumber',
                    HeadlightSummary:
                    {
                        DecimalPrecision: 2
                    }
                };
            }
            else
            {
                tempManifest.Descriptors[f] =
                {
                    Hash: f,
                    Name: this._getHumanReadableFieldName(f),
                };
            }
        }
        return tempManifest;
    }

    async _getEntity(type, ID, full, displayFields)
    {
        return await new Promise((resolve, reject) => 
        {
            this.fable.EntityProvider.getEntity(type, ID, (err, res) =>
            {
                if (err || res.Error)
                {
                    return resolve('');
                }
                if (full)
                {
                    return resolve(res);
                }
                if (displayFields)
                {
                    const displayStrings = [];
                    displayFields.forEach((f) =>
                    {
                        displayStrings.push(res[f] || '');   
                    });
                    return resolve(displayStrings.join(' '));
                }
                if (type == 'User')
                {
                    return resolve(`${ res.NameFirst || '' } ${ res.NameLast || '' }`);
                }
                resolve(res.Name || res.QRcode || res[`GUID${ type }`] || '');
            })
        });
    }

	async processRecord(type, record, action = 'Summary', typeConfig = this.typeConfig)
    {
        const decoratedRecord = {};
        if (typeConfig[type]?.Descriptors)
        {
            for (let k of Object.keys(typeConfig[type].Descriptors))
            {
                if (k.includes('JSON'))
                {
                    record[k] = 'JSON Object';
                }
            }
        }
        for (const f of Object.keys(record))
        {
            if (f == `ID${ type }`)
            {
                continue;
            }
            else if (f.includes('ID') && f.split('ID')?.['1'] && !f.includes('GUID'))
            {
                // Resolve IDs
                const cleanedField = '_' + f.replaceAll('ID', '');
                if (record[f])
                {
                    try
                    {
                        decoratedRecord[cleanedField] = await this._getEntity(f.split('ID')[1], record[f], false, typeConfig[type]?.Descriptors?.[cleanedField]?.[`Headlight${ action }`]?.DisplayFields);
                        decoratedRecord[`${ cleanedField }_Link`] = this._linkBuilder(f.split('ID')[1], f, record, typeConfig[type]?.Descriptors?.[cleanedField]?.[`Headlight${ action }`]?.LinkTemplate);
                        continue;
                    }
                    catch (e)
                    {
                        console.log('Error fetching record: ', e);
                    }
                }
                decoratedRecord[cleanedField] = 'N/A';
            }
            else if (typeConfig[type]?.Descriptors?.[`${ f }_Formatted`]?.DataType == 'DateTime')
            {
                const tmpDateFormat = typeConfig[type]?.Descriptors?.[f]?.[`Headlight${ action }`]?.DateFormat
                    || typeConfig[type]?.Descriptors?.[`${ f }_Formatted`]?.[`Headlight${ action }`]?.DateFormat
                    || this.dateFormat;
                decoratedRecord[`${ f }_Formatted`] = record[f] ? this.fable.Dates.dayJS(record[f]).format(tmpDateFormat) : 'N/A';
            }
            else if (typeConfig[type]?.Descriptors?.[`${ f }_Formatted`]?.DataType == 'PreciseNumber')
            {

                let tmpRoundingMethod = this.fable.Math.roundHalfUp;
                if (typeConfig[type]?.Descriptors?.[f]?.[`Headlight${ action }`]?.RoundingMethod)
                {
                    try
                    {
                        tmpRoundingMethod = parseInt(typeConfig[type].Descriptors[f][`Headlight${ action }`].RoundingMethod);
                    }
                    catch(pError)
                    {
                        this.log.error(`Error parsing rounding method: `, pError);
                    }
                }
                decoratedRecord[`${ f }_Formatted`] = this.fable.Math.toFixedPrecise(record[f], typeConfig[type]?.Descriptors?.[f]?.[`Headlight${ action }`]?.DecimalPrecision || this.decimalPrecision, tmpRoundingMethod) || 0;
            }
            else if (f.includes('JSON') || (record[f] && typeof record[f] == 'object'))
            {
                decoratedRecord[f] = 'JSON Object';
            }
            else
            {
                decoratedRecord[f] = (parseInt(f) && record[f] == 0) ? 0 : (record[f] || 'N/A');
            }
        }
        return decoratedRecord;
    }

	/**
	 * Register a function that adjusts an entity's summary record before it renders, e.g. to show a value the stored
	 * record doesn't hold yet. Decorators run in registration order; one that throws is skipped.
	 *
	 * @param {string} pType - The entity type, e.g. `TestInstance`.
	 * @param {(pSummaryRecord: Record<string, any>, pRecord: Record<string, any>) => (Record<string, any>|void|Promise<Record<string, any>|void>)} fDecorator -
	 *   Gets the summary record (as processRecord built it) and the entity record; returns the summary record to use, or nothing to keep the one it was given.
	 */
	addRecordDecorator(pType, fDecorator)
	{
		if (!pType || (typeof fDecorator !== 'function'))
		{
			return;
		}
		if (!this.recordDecorators[pType])
		{
			this.recordDecorators[pType] = [];
		}
		this.recordDecorators[pType].push(fDecorator);
	}

	/**
	 * @param {string} pType
	 * @param {Record<string, any>} pSummaryRecord
	 * @param {Record<string, any>} pRecord
	 * @return {Promise<Record<string, any>>}
	 */
	async _applyRecordDecorators(pType, pSummaryRecord, pRecord)
	{
		let tmpSummaryRecord = pSummaryRecord;
		for (const fDecorator of (this.recordDecorators[pType] || []))
		{
			try
			{
				tmpSummaryRecord = (await fDecorator(tmpSummaryRecord, pRecord)) || tmpSummaryRecord;
			}
			catch (pError)
			{
				this.log.warn(`[QuickSummariesService] A ${ pType } summary decorator failed: ${ pError && pError.message }`);
			}
		}
		return tmpSummaryRecord;
	}

    _buildDefaultTemplate(manifest, type, record)
    {
        let outputTemplate = ``;
        for (const k of Object.keys(manifest.Descriptors))
        {
            outputTemplate += /*html*/`
                <div class="detail-wrapper px-2 py-1" style="border-bottom: 1px dashed var(--bulma-border);">
                    <div class="is-size-7 has-text-text-50">${ manifest.Descriptors[k].Name }</div>
                    <div class="is-size-6">${ k.startsWith('_') && record[`${ k }_Link`] ? `<span class="icon has-text-info"><i class="fas fa-external-link-alt"></i></span> <a target="_blank" class="p-0 has-text-info is-underlined is-inline" href="{~D:Record.${ k }_Link~}">` : '' }${ manifest.Descriptors[k]?.HeadlightSummary?.ValueTemplate || `{~D:Record.${ k }:N/A~}`}${ k.startsWith('_') ? `</a>` : '' }</div>
                </div>
            `;
        }
        return /*html*/`
        <div class="has-text-centered has-background-info has-text-info-100 p-1"><b>${ manifest.TitleTemplate || this._getHumanReadableFieldName(type) } Summary</b></div>
        <aside class="mt-1" style="max-height: 50vh; overflow-y: auto;">${ outputTemplate }</aside>`;
    }

    /**
	 * @description Creates a popover of the entity record for a particular entity
	 * @param {Object} pOptions - Options for the quick summary.
	 * @param {string} pOptions.type - The entity type being summarized.
     * @param {number} pOptions.ID - The ID of the entity, can be used instead of passing a record.
     * @param {string} pOptions.record - An entity record, can be passed instead of the ID to avoid having to look up the base record.
	 * @param {string} pOptions.parentID - The ID of the element to anchor the popover to.
     * @param {object} pOptions.popoverOptions - Options to pass on to the popover service.
	 */
    async spawnQuickSummary(pOptions)
    {
        if (!pOptions.type || !pOptions.parentID)
        {
            // Need the entity type and a parent element to continue.
            return;
        }
        if (!pOptions.ID && !pOptions.record)
        {
            // Need either a record ID or a record to continue.
            return;
        }
        // If no manifest is set, try to load the manifest from the db.
        if (!this.typeConfig[pOptions.type])
        {
            await this.fable.ManifestPackagingService.loadQuickSummaryManifests([pOptions.type]);
        }
        // If there was still no manifest in the db, create one using the schema endpoint.
        if (!this.typeConfig[pOptions.type])
        {
            this.typeConfig[pOptions.type] = await this._generateDefaultManifest(pOptions.type);
        }
        try
        {
            const tmpRecord = pOptions.record || await this._getEntity(pOptions.type, pOptions.ID, true);
            const localRecord = await this._applyRecordDecorators(pOptions.type, await this.processRecord(pOptions.type, tmpRecord), tmpRecord);
            if (this.typeConfig[pOptions.type]?.Template)
            {
                this.fable.TemplateProvider.addTemplate('Quick-Summary-Temporary-Template', this.typeConfig[pOptions.type]?.Template);
            }
            else
            {
                this.fable.TemplateProvider.addTemplate('Quick-Summary-Temporary-Template', this._buildDefaultTemplate(this.typeConfig[pOptions.type], pOptions.type, localRecord));
            }
            this.fable.HeadlightPopover.createPopover(Object.assign({
                PopoverDestinationAddress: pOptions.parentID,
                PopoverTemplateHash: 'Quick-Summary-Temporary-Template',
                PopoverTemplateRecord: localRecord,
                theme: 'dropdown',
                placement: 'left',
                maxWidth: '800px',
                delay: [ 500, 0 ], // delay showing the menu to allow for click events to propagate, avoid accidental hover displays, etc.
                // Hovering shows the summary and moving off closes it; clicking the icon keeps it open until a click elsewhere.
                trigger: 'mouseenter focusin click',
            }, pOptions.popoverOptions || {}));
        }
        catch (e)
        {
            console.log('Error fetching record: ', e);
            console.log('Passed Options :', pOptions);
            return;
        }
    }

	_getHumanReadableEntityName(pEntity)
	{
		return pEntity.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
	}

	_getHumanReadableFieldName(field, type)
	{
        if (field.includes('JSON'))
        {
            field = field.replaceAll('JSON', '');
        }
        if (this.typeConfig[type]?.Descriptors?.[field]?.Name)
        {
            return this.typeConfig[type].Descriptors[field].Name;
        }
		if (field === `ID${ type }`)
		{
			return `${ this._getHumanReadableEntityName(type) } Unique Database ID`;
		}
		if (field === `GUID${this.options.Entity}`)
		{
			return `${ this._getHumanReadableEntityName(type) } Unique Identifier`;
		}
		if (field === 'CreatingIDUser')
		{
			return 'Created By User';
		}
		if (field === 'CreateDate')
		{
			return 'Date Created';
		}
		if (field === 'UpdatingIDUser')
		{
			return 'Last Updated By User';
		}
		if (field === 'UpdateDate')
		{
			return 'Date Last Updated';
		}
		if (field.startsWith('ID'))
		{
			return this._getHumanReadableEntityName(field.split('ID')[1]);
		}
		if (field.startsWith('ParentID'))
		{
			return 'Parent ' + this._getHumanReadableEntityName(field.split('ID')[1]);
		}
        if (field.startsWith('ChildID'))
		{
			return 'Child ' + this._getHumanReadableEntityName(field.split('ID')[1]);
		}
		return field.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
	}
}

module.exports = HeadlightModalFableService;
module.exports.default_configuration = {};

},{"fable-serviceproviderbase":438}],292:[function(require,module,exports){

const libPictView = require('pict-view');

// The pict-section-picker view hash for the "Link a Form Definition" control. Doubles as the id of
// the DOM element it mounts into, and as the key createPicker reuses across repaints.
const RNI_PICKER_HASH = 'PF-RNI-Picker';
// AppData address the picker reads/writes its selection through.
const RNI_PICKER_VALUE_ADDRESS = 'AppData.ProjectForms.LinkIDReportNamedInstance';

class ReportNamedInstanceProjectForms extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// Project list state
		this._Projects = [];
		this._IsLoadingProjects = false;
		this._ProjectSearchTerm = '';
		this._ProjectSearchDebounceTimer = null;
		this._ProjectsLoadToken = 0;

		// Selected project state
		this._SelectedProject = null;

		// Join records for the selected project
		this._ProjectJoins = [];
		this._IsLoadingJoins = false;
		this._JoinsLoadToken = 0;
		this._IsRepairingDaily = false;

		// Available RNIs for linking
		this._AvailableRNIs = [];
		this._IsLoadingRNIs = false;

		// LIMS Concierge gate config for the selected project (L5 only).
		// Populated lazily after project selection; null while loading or unread.
		this._ConciergeConfig = null;
		this._IsLoadingConciergeConfig = false;

		// Bulk-add modal state (driven by the injected FormGroups option; null when not provided => hidden).
		const tmpFormGroups = (this.options && this.options.FormGroups) || null;
		this._BulkAddSelectedGroup = (tmpFormGroups && Object.keys(tmpFormGroups)[0]) || null;
		this._BulkAddCandidates = [];
	}

	// ---- Top-level navigation entry ----

	onNavigate()
	{
		this._SelectedProject = null;
		this._ProjectJoins = [];
		this._Projects = [];

		// Home for the picker's ValueAddress; reset so a selection from a previous visit cannot be
		// read back as a pending link on this one. Null, not 0 — the picker renders any non-null
		// bound value as its label, so a numeric 0 would paint a literal "0" over the placeholder.
		if (!this.AppData.ProjectForms) { this.AppData.ProjectForms = {}; }
		this.AppData.ProjectForms.LinkIDReportNamedInstance = null;

		this.render('PF-Main-Container', this.options.DefaultDestinationAddress);
		this._loadProjects();
	}

	// ---- Project list ----

	_buildProjectSearchFilter(pSearchTerm)
	{
		const tmpTerm = (pSearchTerm || '').trim();
		if (!tmpTerm)
		{
			return 'FBV~IDProject~GT~0~FSF~Name~ASC~0';
		}

		const tmpEncodedLike = encodeURIComponent(`%${tmpTerm}%`);
		const tmpIsNumeric = /^\d+$/.test(tmpTerm);

		if (tmpIsNumeric)
		{
			return `FOP~0~(~0~FBV~Name~LK~${tmpEncodedLike}~FBVOR~IDProject~EQ~${tmpTerm}~FCP~0~)~0~FSF~Name~ASC~0`;
		}

		return `FBV~Name~LK~${tmpEncodedLike}~FSF~Name~ASC~0`;
	}

	_loadProjects()
	{
		this._IsLoadingProjects = true;
		this._renderProjectList();

		const tmpToken = ++this._ProjectsLoadToken;
		const tmpFilter = this._buildProjectSearchFilter(this._ProjectSearchTerm);

		this.pict.HeadlightRestClient.getJSON(
			`Projects/FilteredTo/${tmpFilter}/0/100`,
			(pError, pBody) =>
			{
				if (tmpToken !== this._ProjectsLoadToken) { return; }

				this._IsLoadingProjects = false;

				if (pError)
				{
					this.pict.log.error(`Error loading projects: ${pError}`);
					this._Projects = [];
				}
				else
				{
					this._Projects = Array.isArray(pBody) ? pBody : [];
				}

				this._renderProjectList();
			}
		);
	}

	selectProject(pIDProject)
	{
		const tmpProject = this._Projects.find((pP) => pP.IDProject === pIDProject);
		if (!tmpProject) { return; }

		this._SelectedProject = tmpProject;
		this._ProjectJoins = [];
		this._AvailableRNIs = [];
		this._ConciergeConfig = null;

		this._renderSelectedProjectHeader();
		this._loadJoinsForProject(pIDProject);
		this._loadAvailableRNIs();
		if (this._isL5User())
		{
			this._loadLIMSConciergeConfig(pIDProject);
		}
		this._refreshL5Sections();
	}

	deselectProject()
	{
		this._SelectedProject = null;
		this._ProjectJoins = [];
		this._AvailableRNIs = [];
		this._ConciergeConfig = null;

		this._clearRNIPicker();
		this._renderRNIPicker();
		this._renderSelectedProjectHeader();
		this._renderJoinsTable();
		this._refreshL5Sections();
	}

	/**
	 * IDCustomer of the currently selected project, or 0 if none / malformed.
	 *
	 * Why: super-admin users have read access across customers, so we cannot
	 * derive customer scope from `AppData.CurrentUser.CustomerID` for any
	 * project-scoped operation — that would either pull no records (if filter
	 * is honored) or all customers' records (depending on row-level auth).
	 * The project record is the authoritative source of customer scope.
	 */
	_getSelectedProjectIDCustomer()
	{
		if (!this._SelectedProject) { return 0; }
		const tmpID = parseInt(this._SelectedProject.IDCustomer, 10);
		return Number.isFinite(tmpID) && tmpID > 0 ? tmpID : 0;
	}

	// ---- Joins for selected project ----

	_loadJoinsForProject(pIDProject)
	{
		this._IsLoadingJoins = true;
		this._renderJoinsTable();

		const tmpToken = ++this._JoinsLoadToken;

		this.pict.HeadlightRestClient.getJSON(
			`ReportNamedInstanceProjectJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}/0/500`,
			(pError, pBody) =>
			{
				if (tmpToken !== this._JoinsLoadToken)
				{
					return;
				}

				this._IsLoadingJoins = false;

				if (pError)
				{
					this.pict.log.error(`Error loading project joins: ${pError}`);
					this._ProjectJoins = [];
				}
				else
				{
					this._ProjectJoins = Array.isArray(pBody) ? pBody : [];
				}

				// Resolve RNI names for each join
				this._resolveRNIMetadata(() =>
				{
					if (tmpToken !== this._JoinsLoadToken)
					{
						return;
					}

					this._renderJoinsTable();
					// LIMS warning depends on the joins-with-resolved-names list.
					this._renderLIMSConciergeStatus();
				});
			}
		);
	}

	/**
	 * Decorate each join in `_ProjectJoins` with `_RNIName`, `_RNIHash` and `_RNIFormOnly`.
	 *
	 * Reads the whole set through the list endpoint rather than per-ID: the singular
	 * ReportNamedInstance read runs `Read-PostOperation`, not `Reads-PostOperation`, so it never
	 * merges the archetype defaults into `Options` — `Options.FormOnly` is only trustworthy here.
	 *
	 * @param {() => void} fCallback
	 */
	_resolveRNIMetadata(fCallback)
	{
		if (this._ProjectJoins.length === 0)
		{
			return fCallback();
		}

		const tmpIDList = [];
		for (let i = 0; i < this._ProjectJoins.length; i++)
		{
			const tmpID = this._ProjectJoins[i].IDReportNamedInstance;
			if (tmpID > 0 && tmpIDList.indexOf(tmpID) < 0)
			{
				tmpIDList.push(tmpID);
			}
		}

		const fDecorate = (pRNIByID) =>
		{
			for (let i = 0; i < this._ProjectJoins.length; i++)
			{
				const tmpJoin = this._ProjectJoins[i];
				const tmpRNI = pRNIByID[tmpJoin.IDReportNamedInstance];

				if (tmpRNI)
				{
					tmpJoin._RNIName = tmpRNI.Name || `RNI ${tmpRNI.IDReportNamedInstance}`;
					tmpJoin._RNIHash = tmpRNI.Hash || '';
					tmpJoin._RNIFormOnly = !!(tmpRNI.Options && tmpRNI.Options.FormOnly);
				}
				else if (tmpJoin.IDReportNamedInstance > 0)
				{
					tmpJoin._RNIName = `RNI ${tmpJoin.IDReportNamedInstance}`;
					tmpJoin._RNIHash = '';
					tmpJoin._RNIFormOnly = false;
				}
				else
				{
					tmpJoin._RNIName = '(Unassigned)';
					tmpJoin._RNIHash = '';
					tmpJoin._RNIFormOnly = false;
				}
			}

			return fCallback();
		};

		if (tmpIDList.length === 0)
		{
			return fDecorate({});
		}

		this.pict.HeadlightRestClient.getJSON(
			`ReportNamedInstances/FilteredTo/FBL~IDReportNamedInstance~INN~${tmpIDList.join(',')}/0/${tmpIDList.length}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error resolving form definitions for the linked joins: ${pError}`);
					return fDecorate({});
				}

				const tmpRNIByID = {};
				const tmpRecords = Array.isArray(pBody) ? pBody : [];
				for (let i = 0; i < tmpRecords.length; i++)
				{
					tmpRNIByID[tmpRecords[i].IDReportNamedInstance] = tmpRecords[i];
				}

				return fDecorate(tmpRNIByID);
			}
		);
	}

	// ---- My Daily (first row of ReportNamedInstancesByProject) ----

	/**
	 * The join whose form Fieldbook web and iOS treat as the project's daily report.
	 *
	 * ReportNamedInstancesByProject issues no ORDER BY and its handler pins element [0] before
	 * alphabetizing the rest, so the daily is whichever row the IDProject index yields first —
	 * in practice the lowest IDReportNamedInstanceProjectJoin.
	 *
	 * @return {object?} the daily join record, or null when the project has no joins
	 */
	_getMyDailyJoin()
	{
		let tmpDaily = null;
		for (let i = 0; i < this._ProjectJoins.length; i++)
		{
			const tmpJoin = this._ProjectJoins[i];
			if (!tmpDaily || tmpJoin.IDReportNamedInstanceProjectJoin < tmpDaily.IDReportNamedInstanceProjectJoin)
			{
				tmpDaily = tmpJoin;
			}
		}
		return tmpDaily;
	}

	/** Joins parked on a non-positive IDReportNamedInstance by an interrupted `makeMyDaily` swap. */
	_getParkedJoins()
	{
		return this._ProjectJoins.filter((pJ) => !(pJ.IDReportNamedInstance > 0));
	}

	/**
	 * Write a single join's IDReportNamedInstance, sending only the writable columns.
	 *
	 * @param {object} pJoin
	 * @param {number} pIDReportNamedInstance
	 * @param {(pError?: Error) => void} fCallback
	 */
	_writeJoinReportNamedInstance(pJoin, pIDReportNamedInstance, fCallback)
	{
		const tmpPayload = {
			IDReportNamedInstanceProjectJoin: pJoin.IDReportNamedInstanceProjectJoin,
			IDReportNamedInstance: pIDReportNamedInstance,
			IDProject: pJoin.IDProject,
			IDCustomer: pJoin.IDCustomer,
			IDProgram: pJoin.IDProgram,
			Ordinal: pJoin.Ordinal
		};

		this.pict.HeadlightRestClient.updateEntity('ReportNamedInstanceProjectJoin', tmpPayload, fCallback);
	}

	/**
	 * Make the given join the project's My Daily report by swapping its IDReportNamedInstance with
	 * the one held by the lowest-ID join.
	 *
	 * AK_ReportNamedInstanceProjectJoin is UNIQUE on (IDReportNamedInstance, IDProject) and the table
	 * has no soft delete, so the two values cannot be exchanged directly — the lowest-ID row is
	 * parked on -1 for the duration of the swap.
	 *
	 * @param {number} pIDJoin
	 */
	makeMyDaily(pIDJoin)
	{
		if (!this._SelectedProject || this._IsRepairingDaily)
		{
			return;
		}

		const tmpTarget = this._ProjectJoins.find((pJ) => pJ.IDReportNamedInstanceProjectJoin === pIDJoin);
		if (!tmpTarget)
		{
			return;
		}

		const tmpCurrent = this._getMyDailyJoin();
		if (!tmpCurrent || tmpCurrent.IDReportNamedInstanceProjectJoin === tmpTarget.IDReportNamedInstanceProjectJoin)
		{
			this._showNotification('That form is already the My Daily report.', 'info');
			return;
		}

		if (tmpTarget._RNIFormOnly)
		{
			this._showNotification('Forms cannot be the My Daily report.', 'warning');
			return;
		}

		if (!(tmpTarget.IDReportNamedInstance > 0) || !(tmpCurrent.IDReportNamedInstance > 0))
		{
			this._showNotification('A previous swap left a join unassigned. Reload and resolve that first.', 'danger');
			return;
		}

		const tmpTargetName = tmpTarget._RNIName || `RNI ${tmpTarget.IDReportNamedInstance}`;
		const tmpCurrentName = tmpCurrent._RNIName || `RNI ${tmpCurrent.IDReportNamedInstance}`;
		const tmpPrompt = `"${tmpTargetName}" will become the My Daily report for this project, swapping places with "${tmpCurrentName}".`;

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm(tmpPrompt,
				{
					title: 'Change My Daily report?',
					confirmLabel: 'Make My Daily',
					cancelLabel: 'Cancel'
				}).then((pOk) =>
				{
					if (pOk)
					{
						this._executeMyDailySwap(tmpCurrent, tmpTarget, tmpTargetName);
					}
				});
		}
		else if ((typeof window !== 'undefined') && window.confirm(tmpPrompt))
		{
			this._executeMyDailySwap(tmpCurrent, tmpTarget, tmpTargetName);
		}
	}

	/**
	 * @param {object} pCurrentDailyJoin - the lowest-ID join, which holds the My Daily slot
	 * @param {object} pTargetJoin - the join whose form should become My Daily
	 * @param {string} pTargetName - display name for notifications
	 */
	_executeMyDailySwap(pCurrentDailyJoin, pTargetJoin, pTargetName)
	{
		const tmpIDProject = this._SelectedProject.IDProject;
		const tmpIDDailyJoin = pCurrentDailyJoin.IDReportNamedInstanceProjectJoin;
		const tmpTargetIDRNI = pTargetJoin.IDReportNamedInstance;
		const tmpDisplacedIDRNI = pCurrentDailyJoin.IDReportNamedInstance;

		this._IsRepairingDaily = true;
		const tmpRow = document.getElementById(`PF-Row-${pTargetJoin.IDReportNamedInstanceProjectJoin}`);
		if (tmpRow)
		{
			tmpRow.classList.add('is-loading');
		}

		const fFinish = (pError, pMessage, pType) =>
		{
			this._IsRepairingDaily = false;
			if (tmpRow)
			{
				tmpRow.classList.remove('is-loading');
			}
			if (pError)
			{
				this.pict.log.error(`Error changing My Daily on project ${tmpIDProject}: ${pError}`);
			}
			this._showNotification(pMessage, pType);
			this._loadJoinsForProject(tmpIDProject);
		};

		this._writeJoinReportNamedInstance(pCurrentDailyJoin, -1, (pParkError) =>
		{
			if (pParkError)
			{
				return fFinish(pParkError, 'Could not start the swap. Nothing was changed.', 'danger');
			}

			this._writeJoinReportNamedInstance(pTargetJoin, tmpDisplacedIDRNI, (pMoveError) =>
			{
				if (pMoveError)
				{
					return this._writeJoinReportNamedInstance(pCurrentDailyJoin, tmpDisplacedIDRNI, (pRollbackError) =>
					{
						if (pRollbackError)
						{
							return fFinish(pMoveError, `Swap failed and could not be rolled back. Join ${tmpIDDailyJoin} is unassigned and must be set back to form ${tmpDisplacedIDRNI}.`, 'danger');
						}
						return fFinish(pMoveError, 'Swap failed. The original order was restored.', 'danger');
					});
				}

				this._writeJoinReportNamedInstance(pCurrentDailyJoin, tmpTargetIDRNI, (pAssignError) =>
				{
					if (pAssignError)
					{
						return fFinish(pAssignError, `Swap incomplete. Join ${tmpIDDailyJoin} is unassigned and must be set to form ${tmpTargetIDRNI}.`, 'danger');
					}
					return fFinish(null, `"${pTargetName}" is now the My Daily report.`, 'success');
				});
			});
		});
	}

	_renderMyDailyStatus()
	{
		const tmpStatus = document.getElementById('PF-Daily-Status');
		if (!tmpStatus)
		{
			return;
		}

		if (this._IsLoadingJoins || this._ProjectJoins.length === 0)
		{
			tmpStatus.innerHTML = '';
			return;
		}

		const tmpParked = this._getParkedJoins();
		if (tmpParked.length > 0)
		{
			const tmpIDs = tmpParked.map((pJ) => pJ.IDReportNamedInstanceProjectJoin).join(', ');
			tmpStatus.innerHTML = /*html*/`
				<div class="notification is-danger is-soft py-2 px-3 mb-3">
					<span class="icon"><i class="fas fa-triangle-exclamation"></i></span>
					Join ${this._escapeHTML(tmpIDs)} has no form assigned, which means an earlier My Daily swap did not finish.
					Assign a form to it before changing the My Daily report again.
				</div>`;
			return;
		}

		const tmpDaily = this._getMyDailyJoin();
		if (!tmpDaily)
		{
			tmpStatus.innerHTML = '';
			return;
		}

		const tmpDailyName = this._escapeHTML(tmpDaily._RNIName || `RNI ${tmpDaily.IDReportNamedInstance}`);

		if (tmpDaily._RNIFormOnly)
		{
			tmpStatus.innerHTML = /*html*/`
				<div class="notification is-warning is-soft py-2 px-3 mb-3">
					<span class="icon"><i class="fas fa-triangle-exclamation"></i></span>
					<strong>${tmpDailyName}</strong> holds the My Daily slot but is a form, and forms cannot be a daily report.
					Use <em>Make My Daily</em> on a report row to fix it.
				</div>`;
			return;
		}

		tmpStatus.innerHTML = /*html*/`
			<div class="notification is-info is-soft py-2 px-3 mb-3">
				<span class="icon"><i class="fas fa-sun"></i></span>
				<strong>${tmpDailyName}</strong> is the My Daily report for this project.
			</div>`;
	}

	_loadAvailableRNIs()
	{
		this._IsLoadingRNIs = true;

		// Scope to the selected project's customer so super-admin users do not see
		// other customers' RNIs in the link-form dropdown.
		const tmpIDCustomer = this._getSelectedProjectIDCustomer();
		if (!tmpIDCustomer)
		{
			this._IsLoadingRNIs = false;
			this._AvailableRNIs = [];
			this._renderRNIPicker();
			return;
		}

		this.pict.HeadlightRestClient.getJSON(
			`ReportNamedInstances/FilteredTo/FBV~IDCustomer~EQ~${tmpIDCustomer}~FSF~Name~ASC~0/0/500`,
			(pError, pBody) =>
			{
				this._IsLoadingRNIs = false;

				if (pError)
				{
					this.pict.log.warn(`Could not load RNIs: ${pError}`);
					this._AvailableRNIs = [];
				}
				else
				{
					this._AvailableRNIs = Array.isArray(pBody) ? pBody : [];
				}

				this._renderRNIPicker();
			}
		);
	}

	// ---- Pull in default forms ----

	/**
	 * Order candidates so a report — never a FormOnly form — is written first.
	 *
	 * On a project with no joins the first row written takes the My Daily slot, and a best-effort
	 * guess at which report that should be is the lowest-numbered one: a customer's daily report is
	 * almost always among the first RNIs created for them. `makeMyDaily` repairs a wrong guess.
	 *
	 * @param {Array<object>} pRNIs
	 * @return {Array<object>} a new, deterministically ordered array
	 */
	_orderJoinCandidates(pRNIs)
	{
		return pRNIs.slice().sort((pA, pB) =>
		{
			const tmpAIsForm = (pA.Options && pA.Options.FormOnly) ? 1 : 0;
			const tmpBIsForm = (pB.Options && pB.Options.FormOnly) ? 1 : 0;

			if (tmpAIsForm !== tmpBIsForm)
			{
				return tmpAIsForm - tmpBIsForm;
			}

			return pA.IDReportNamedInstance - pB.IDReportNamedInstance;
		});
	}

	/**
	 * Link a set of forms to a project in one request.
	 *
	 * The bulk create endpoint walks the array with `async.eachSeries`, so join records are inserted
	 * strictly in the order given — which is what decides the My Daily report.
	 *
	 * @param {Array<object>} pPayloads - join records, in the order they should be created
	 * @param {(pError?: Error) => void} fCallback
	 */
	_createJoins(pPayloads, fCallback)
	{
		this.pict.HeadlightRestClient.postJSON('ReportNamedInstanceProjectJoins', pPayloads, fCallback);
	}

	pullInDefaultForms()
	{
		if (!this._SelectedProject) { return; }

		const tmpIDProject = this._SelectedProject.IDProject;
		const tmpBtn = document.getElementById('PF-Defaults-Button');
		if (tmpBtn) { tmpBtn.classList.add('is-loading'); }

		// Fetch customer-level default ReportNamedInstances directly.
		// We cannot use ReportNamedInstancesByProject here because that endpoint
		// returns the already-linked join records when any exist, rather than
		// the customer defaults we want to pull in.
		const tmpIDCustomer = this._getSelectedProjectIDCustomer();
		if (!tmpIDCustomer)
		{
			if (tmpBtn) { tmpBtn.classList.remove('is-loading'); }
			this._showNotification('Could not determine customer for this project.', 'danger');
			return;
		}

		this.pict.HeadlightRestClient.getJSON(
			`ReportNamedInstances/FilteredTo/FBV~IDCustomer~EQ~${tmpIDCustomer}~FBV~DefaultReport~EQ~1~FSF~IDReportNamedInstance~ASC~0/0/100`,
			(pError, pBody) =>
			{
				if (pError)
				{
					if (tmpBtn) { tmpBtn.classList.remove('is-loading'); }
					this.pict.log.error(`Error loading default forms: ${pError}`);
					this._showNotification('Error loading default forms. Please try again.', 'danger');
					return;
				}

				const tmpDefaults = Array.isArray(pBody) ? pBody : [];
				if (tmpDefaults.length === 0)
				{
					if (tmpBtn) { tmpBtn.classList.remove('is-loading'); }
					this._showNotification('No default forms found for this project.', 'info');
					return;
				}

				// Filter out forms already linked
				const tmpExistingIDs = new Set(this._ProjectJoins.map((pJ) => pJ.IDReportNamedInstance));
				const tmpToAdd = this._orderJoinCandidates(tmpDefaults.filter((pD) => !tmpExistingIDs.has(pD.IDReportNamedInstance)));

				if (tmpToAdd.length === 0)
				{
					if (tmpBtn) { tmpBtn.classList.remove('is-loading'); }
					this._showNotification('All default forms are already linked to this project.', 'info');
					return;
				}

				const tmpTotal = tmpToAdd.length;
				const tmpOrdinalBase = this._ProjectJoins.length;
				const tmpPayloads = tmpToAdd.map((pRNI, pIndex) =>
				{
					return {
						IDReportNamedInstance: pRNI.IDReportNamedInstance,
						IDProject: tmpIDProject,
						IDCustomer: tmpIDCustomer,
						IDProgram: 0,
						Ordinal: tmpOrdinalBase + pIndex
					};
				});

				this._createJoins(tmpPayloads, (pUpsertError) =>
				{
					if (tmpBtn) { tmpBtn.classList.remove('is-loading'); }

					if (pUpsertError)
					{
						this.pict.log.error(`Error linking default forms to project ${tmpIDProject}: ${pUpsertError}`);
						this._showNotification('Error linking default forms. Some may have been linked — check the list below.', 'danger');
					}
					else
					{
						this._showNotification(`Successfully linked ${tmpTotal} default form${tmpTotal > 1 ? 's' : ''}.`, 'success');
					}

					this._loadJoinsForProject(tmpIDProject);
				});
			}
		);
	}

	removeAllJoins()
	{
		if (!this._SelectedProject || this._ProjectJoins.length === 0) { return; }

		const tmpIDProject = this._SelectedProject.IDProject;
		const tmpBtn = document.getElementById('PF-RemoveAll-Button');
		if (tmpBtn) { tmpBtn.classList.add('is-loading'); }

		const tmpIDJoins = this._ProjectJoins.map((pJ) => pJ.IDReportNamedInstanceProjectJoin);
		const tmpTotal = tmpIDJoins.length;
		let tmpCompleted = 0;
		let tmpErrors = 0;

		// Order is irrelevant here — every row goes away, so nothing establishes a My Daily.
		const fOnDeleted = (pDelError) =>
		{
			if (pDelError)
			{
				tmpErrors++;
				this.pict.log.error(`Error deleting join: ${pDelError}`);
			}

			if (++tmpCompleted < tmpTotal)
			{
				return;
			}

			if (tmpBtn) { tmpBtn.classList.remove('is-loading'); }

			if (tmpErrors > 0)
			{
				this._showNotification(`Removed ${tmpTotal - tmpErrors} of ${tmpTotal} forms (${tmpErrors} failed).`, 'warning');
			}
			else
			{
				this._showNotification('All form links removed.', 'info');
			}

			this._loadJoinsForProject(tmpIDProject);
		};

		for (let i = 0; i < tmpTotal; i++)
		{
			this.pict.HeadlightRestClient.deleteEntity('ReportNamedInstanceProjectJoin', tmpIDJoins[i], fOnDeleted);
		}
	}

	// ---- Add / Remove join records ----

	addFormToProject()
	{
		if (!this._SelectedProject) { return; }

		const tmpIDRNI = this._selectedLinkIDRNI();
		if (!tmpIDRNI)
		{
			this._showNotification('Please select a form definition.', 'warning');
			return;
		}

		// Check for duplicate
		const tmpExisting = this._ProjectJoins.find((pJ) => pJ.IDReportNamedInstance === tmpIDRNI);
		if (tmpExisting)
		{
			this._showNotification('This form is already linked to this project.', 'warning');
			return;
		}

		const tmpIDCustomer = this._getSelectedProjectIDCustomer();
		if (!tmpIDCustomer)
		{
			this._showNotification('Could not determine customer for this project.', 'danger');
			return;
		}

		// Seed-on-first-customize: while this project is inheriting the customer default forms (no joins of its
		// own), adding one form would break inheritance in the field apps and drop the rest. Materialize the
		// defaults first and include the selected form, so nothing disappears. (Mirrors "Customize Defaults" and
		// the observation-type editor's "+ Add".)
		if (this._ProjectJoins.length === 0)
		{
			this._addFormWithDefaults(tmpIDRNI, tmpIDCustomer);
			return;
		}

		const tmpPayload = {
			IDReportNamedInstance: tmpIDRNI,
			IDProject: this._SelectedProject.IDProject,
			IDCustomer: tmpIDCustomer,
			IDProgram: 0,
			Ordinal: this._ProjectJoins.length
		};

		const tmpAddBtn = document.getElementById('PF-Add-Button');
		if (tmpAddBtn) { tmpAddBtn.classList.add('is-loading'); }

		this.pict.HeadlightRestClient.createEntity('ReportNamedInstanceProjectJoin', tmpPayload, (pError, pBody) =>
		{
			if (tmpAddBtn) { tmpAddBtn.classList.remove('is-loading'); }

			if (pError)
			{
				this.pict.log.error(`Error creating project join: ${pError}`);
				this._showNotification('Error linking form. Please try again.', 'danger');
				return;
			}

			this._showNotification('Form linked successfully!', 'success');
			this._clearRNIPicker();
			this._loadJoinsForProject(this._SelectedProject.IDProject);
		});
	}

	/**
	 * Add a form to a project that is still inheriting the customer defaults: materialize the customer default
	 * forms FIRST, then include the explicitly-selected form, in ONE bulk create — so starting to customize
	 * doesn't silently drop the inherited set. The defaults keep their inherited order (preserving which report
	 * becomes My Daily); the selected form is appended only when it is not already one of the defaults.
	 *
	 * @param {number} pIDReportNamedInstance - the form the user picked to add
	 * @param {number} pIDCustomer - the project's customer
	 */
	_addFormWithDefaults(pIDReportNamedInstance, pIDCustomer)
	{
		const tmpIDProject = this._SelectedProject.IDProject;
		const tmpAddBtn = document.getElementById('PF-Add-Button');
		if (tmpAddBtn) { tmpAddBtn.classList.add('is-loading'); }

		this.pict.HeadlightRestClient.getJSON(
			`ReportNamedInstances/FilteredTo/FBV~IDCustomer~EQ~${pIDCustomer}~FBV~DefaultReport~EQ~1~FSF~IDReportNamedInstance~ASC~0/0/100`,
			(pError, pBody) =>
			{
				// Best-effort: if the defaults can't be fetched, still add the one selected form (never block it).
				const tmpDefaults = (!pError && Array.isArray(pBody)) ? this._orderJoinCandidates(pBody) : [];
				const tmpIDs = tmpDefaults.map((pRNI) => pRNI.IDReportNamedInstance);
				if (tmpIDs.indexOf(pIDReportNamedInstance) < 0) { tmpIDs.push(pIDReportNamedInstance); }

				const tmpPayloads = tmpIDs.map((pID, pIndex) =>
				{
					return {
						IDReportNamedInstance: pID,
						IDProject: tmpIDProject,
						IDCustomer: pIDCustomer,
						IDProgram: 0,
						Ordinal: pIndex
					};
				});

				this._createJoins(tmpPayloads, (pUpsertError) =>
				{
					if (tmpAddBtn) { tmpAddBtn.classList.remove('is-loading'); }

					if (pUpsertError)
					{
						this.pict.log.error(`Error linking form (with defaults) to project ${tmpIDProject}: ${pUpsertError}`);
						this._showNotification('Error linking form. Please try again.', 'danger');
						return;
					}

					this._showNotification((tmpDefaults.length > 0)
						? 'Form linked — the customer default forms were pulled in too, so nothing was lost.'
						: 'Form linked successfully!', 'success');
					this._clearRNIPicker();
					this._loadJoinsForProject(tmpIDProject);
				});
			}
		);
	}

	removeJoin(pIDJoin)
	{
		if (!pIDJoin) { return; }

		const tmpRow = document.getElementById(`PF-Row-${pIDJoin}`);
		if (tmpRow) { tmpRow.classList.add('is-loading'); }

		this.pict.HeadlightRestClient.deleteEntity('ReportNamedInstanceProjectJoin', pIDJoin,
			(pDelError) =>
			{
				if (tmpRow) { tmpRow.classList.remove('is-loading'); }

				if (pDelError)
				{
					this.pict.log.error(`Error deleting join: ${pDelError}`);
					this._showNotification('Error removing form link.', 'danger');
					return;
				}

				this._showNotification('Form link removed.', 'info');
				this._loadJoinsForProject(this._SelectedProject.IDProject);
			}
		);
	}

	// ---- L5 / LIMS Concierge gate ----

	_isL5User()
	{
		return !!(this.AppData && this.AppData.CurrentUser && Number(this.AppData.CurrentUser.UserRoleIndex) >= 5 && this.AppData.CurrentUser.CustomerID == 1);
	}

	/** The injected materials FORM_GROUPS map (empty object when the host did not provide it). */
	_formGroups()
	{
		return (this.options && this.options.FormGroups) || {};
	}

	/** Whether the bulk-add feature is available (the host injected a non-empty FormGroups map). */
	_hasFormGroups()
	{
		const tmpGroups = this._formGroups();
		return !!tmpGroups && (Object.keys(tmpGroups).length > 0);
	}

	/** Injected LIMS-form predicate (materials-form-manager.isLIMSForm); a no-op (false) when not provided. */
	_isLIMSForm(pHashOrName)
	{
		return (this.options && (typeof this.options.IsLIMSForm === 'function')) ? !!this.options.IsLIMSForm(pHashOrName) : false;
	}

	/**
	 * Show or hide the L5-only sections (LIMS Concierge box, Bulk Add Forms button)
	 * based on the current user's role and whether a project is selected.
	 */
	_refreshL5Sections()
	{
		const tmpL5 = this._isL5User();
		const tmpHasSelection = !!this._SelectedProject;
		const tmpConciergeBox = document.getElementById('PF-LIMS-Concierge-Section');
		const tmpBulkButton = document.getElementById('PF-BulkAdd-Button');
		if (tmpConciergeBox)
		{
			tmpConciergeBox.classList.toggle('is-hidden', !(tmpL5 && tmpHasSelection));
		}
		if (tmpBulkButton)
		{
			// Bulk-add also requires the injected FormGroups (materials-form-manager); hidden without them.
			tmpBulkButton.classList.toggle('is-hidden', !(tmpL5 && tmpHasSelection && this._hasFormGroups()));
		}
	}

	/**
	 * Read the project-level ConciergeDefaults/Sample config for the current project
	 * and update the LIMS Concierge section UI.
	 *
	 * Uses POST /Configuration/Get with an explicit Project LevelContext (rather than the
	 * IDProject GET shortcut, which is User-level cascade and would not surface what's
	 * actually stored at Project level).
	 *
	 * @param {number} pIDProject
	 */
	_loadLIMSConciergeConfig(pIDProject)
	{
		this._IsLoadingConciergeConfig = true;
		this._renderLIMSConciergeStatus();

		this.pict.HeadlightRestClient.postJSON(
			'Configuration/Get',
			{
				NamespaceKey: 'ConciergeDefaults',
				NamespaceValue: 'Sample',
				LevelContext: 'Project',
				LevelContextID: pIDProject,
			},
			(pError, pBody) =>
			{
				this._IsLoadingConciergeConfig = false;
				if (pError)
				{
					this.pict.log.warn(`Could not load ConciergeDefaults config for project ${pIDProject}: ${pError}`);
					this._ConciergeConfig = {};
				}
				else if (pBody && typeof pBody === 'object' && pBody.Config && typeof pBody.Config === 'object')
				{
					this._ConciergeConfig = pBody.Config;
				}
				else if (pBody && typeof pBody === 'object')
				{
					this._ConciergeConfig = pBody;
				}
				else
				{
					this._ConciergeConfig = {};
				}
				this._renderLIMSConciergeStatus();
			}
		);
	}

	/**
	 * Read the current config, flip Enabled, and write back. Configuration/Put is full-key
	 * overwrite — preserve everything else (Hashes, CreatePerLab, etc.) by reading first.
	 */
	onLIMSConciergeToggle()
	{
		if (!this._SelectedProject) { return; }
		if (!this._isL5User())
		{
			this._showNotification('Only platform administrators can change this setting.', 'warning');
			return;
		}
		const tmpSwitch = document.getElementById('PF-LIMS-Concierge-Toggle');
		if (!tmpSwitch) { return; }
		// The switch is a button, so it carries no implicit checked state — it reports the state it is
		// currently painting via aria-checked, and a click asks for the opposite.
		const tmpDesired = (tmpSwitch.getAttribute('aria-checked') !== 'true');
		const tmpIDProject = this._SelectedProject.IDProject;

		// Paint the requested state immediately, and lock the control while the write is in flight.
		this._paintConciergeSwitch(tmpDesired);
		tmpSwitch.disabled = true;

		const tmpExisting = (this._ConciergeConfig && typeof this._ConciergeConfig === 'object') ? this._ConciergeConfig : {};
		const tmpNewConfig = Object.assign({}, tmpExisting, { Enabled: tmpDesired });

		this.pict.HeadlightRestClient.postJSON(
			`Configuration/Put/ConciergeDefaults/Sample/Project/${tmpIDProject}`,
			{ Config: tmpNewConfig },
			(pError) =>
			{
				tmpSwitch.disabled = false;
				if (pError)
				{
					this.pict.log.error(`Error writing ConciergeDefaults config for project ${tmpIDProject}: ${pError}`);
					this._showNotification('Could not save LIMS Concierge setting. Configuration/Put requires platform admin.', 'danger');
					// Revert the switch to the previously known state.
					this._paintConciergeSwitch(!tmpDesired);
					return;
				}
				this._ConciergeConfig = tmpNewConfig;
				this._showNotification(`LIMS Concierge ${tmpDesired ? 'enabled' : 'disabled'} for this project.`, 'success');
				this._renderLIMSConciergeStatus();
			}
		);
	}

	/**
	 * Paint the concierge switch for a boolean state.
	 *
	 * The control is a `.button.is-toggle` (headlight-styles), which shows the "on" icon upright when
	 * `.is-active` and rotates it 180deg otherwise; `aria-checked` carries the same state to assistive
	 * tech and is what `onLIMSConciergeToggle` reads back. Deliberately no text label — the wording
	 * used to flip between "Enabled"/"Disabled" on the control itself, which read as a command rather
	 * than a state. The status line below the title is the readout now.
	 *
	 * @param {boolean} pEnabled
	 */
	_paintConciergeSwitch(pEnabled)
	{
		const tmpSwitch = document.getElementById('PF-LIMS-Concierge-Toggle');
		if (!tmpSwitch) { return; }
		tmpSwitch.classList.toggle('is-active', !!pEnabled);
		tmpSwitch.setAttribute('aria-checked', pEnabled ? 'true' : 'false');
	}

	_renderLIMSConciergeStatus()
	{
		const tmpSection = document.getElementById('PF-LIMS-Concierge-Section');
		if (!tmpSection) { return; }
		const tmpStatusText = document.getElementById('PF-LIMS-Concierge-Status');
		const tmpToggle = document.getElementById('PF-LIMS-Concierge-Toggle');
		const tmpWarning = document.getElementById('PF-LIMS-Concierge-Warning');
		if (!tmpStatusText || !tmpToggle || !tmpWarning) { return; }

		if (this._IsLoadingConciergeConfig)
		{
			tmpStatusText.textContent = 'Loading…';
			tmpToggle.disabled = true;
			tmpWarning.classList.add('is-hidden');
			return;
		}

		const tmpEnabled = this._ConciergeConfig && this._ConciergeConfig.Enabled === true;
		const tmpExplicit = this._ConciergeConfig && typeof this._ConciergeConfig.Enabled === 'boolean';
		this._paintConciergeSwitch(!!tmpEnabled);
		tmpToggle.disabled = false;
		if (tmpExplicit)
		{
			tmpStatusText.textContent = `Project-level setting: ${tmpEnabled ? 'Enabled' : 'Disabled'}.`;
		}
		else
		{
			tmpStatusText.textContent = 'Not explicitly set; disabled.';
		}

		// Warn if Enabled=true but no LIMS forms are joined.
		const tmpHasLIMSJoin = this._ProjectJoins.some((pJ) => this._isLIMSForm(pJ._RNIHash || '') || this._isLIMSForm(pJ._RNIName || ''));
		if (tmpEnabled && !tmpHasLIMSJoin && !this._IsLoadingJoins)
		{
			tmpWarning.classList.remove('is-hidden');
		}
		else
		{
			tmpWarning.classList.add('is-hidden');
		}
	}

	// ---- Bulk-add modal (form-group driven) ----

	openBulkAddModal()
	{
		if (!this._SelectedProject) { return; }
		if (!this._isL5User())
		{
			this._showNotification('Only platform administrators can use bulk add.', 'warning');
			return;
		}
		const tmpModal = document.getElementById('PF-BulkAdd-Modal');
		if (!tmpModal) { return; }
		tmpModal.classList.add('is-active');
		this._renderBulkAddGroupOptions();
		this._renderBulkAddCandidateList();
	}

	closeBulkAddModal()
	{
		const tmpModal = document.getElementById('PF-BulkAdd-Modal');
		if (tmpModal) { tmpModal.classList.remove('is-active'); }
	}

	onBulkAddGroupChange()
	{
		const tmpSelect = document.getElementById('PF-BulkAdd-Group-Select');
		if (!tmpSelect) { return; }
		this._BulkAddSelectedGroup = tmpSelect.value || null;
		this._renderBulkAddCandidateList();
	}

	toggleAllBulkAddRows(pCheck)
	{
		const tmpInputs = document.querySelectorAll('#PF-BulkAdd-List input[type="checkbox"]');
		tmpInputs.forEach((pInput) =>
		{
			pInput.checked = !!pCheck;
		});
	}

	_renderBulkAddGroupOptions()
	{
		const tmpSelect = document.getElementById('PF-BulkAdd-Group-Select');
		const tmpDescription = document.getElementById('PF-BulkAdd-Group-Description');
		if (!tmpSelect) { return; }
		const tmpGroups = this._formGroups();
		const tmpKeys = Object.keys(tmpGroups);
		if (tmpKeys.length === 0)
		{
			tmpSelect.innerHTML = '<option value="">(no groups defined)</option>';
			if (tmpDescription) { tmpDescription.textContent = ''; }
			return;
		}
		if (!this._BulkAddSelectedGroup || !tmpGroups[this._BulkAddSelectedGroup])
		{
			this._BulkAddSelectedGroup = tmpKeys[0];
		}
		let tmpHTML = '';
		for (const tmpKey of tmpKeys)
		{
			const tmpGroup = tmpGroups[tmpKey];
			const tmpSelected = tmpKey === this._BulkAddSelectedGroup ? ' selected' : '';
			tmpHTML += `<option value="${this._escapeHTML(tmpKey)}"${tmpSelected}>${this._escapeHTML(tmpGroup.Name || tmpKey)}</option>`;
		}
		tmpSelect.innerHTML = tmpHTML;
		if (tmpDescription)
		{
			const tmpActive = tmpGroups[this._BulkAddSelectedGroup];
			tmpDescription.textContent = tmpActive ? (tmpActive.Description || '') : '';
		}
	}

	_renderBulkAddCandidateList()
	{
		const tmpList = document.getElementById('PF-BulkAdd-List');
		if (!tmpList) { return; }
		const tmpGroups = this._formGroups();
		const tmpGroup = this._BulkAddSelectedGroup ? tmpGroups[this._BulkAddSelectedGroup] : null;
		if (!tmpGroup || typeof tmpGroup.getMembers !== 'function')
		{
			tmpList.innerHTML = '<p class="has-text-grey-light">Select a form group to see candidates.</p>';
			this._BulkAddCandidates = [];
			return;
		}
		const tmpExistingIDs = new Set(this._ProjectJoins.map((pJ) => pJ.IDReportNamedInstance));
		// Pass ConciergeConfig so the LIMS group unions in any RNI whose Hash is listed in
		// ConciergeDefaults/Sample.Hashes — i.e. the "extra forms" the materials API auto-creates
		// even when the GUID doesn't match the LIMS_GUID_PATTERNS heuristic.
		const tmpGroupMembers = tmpGroup.getMembers(this._AvailableRNIs, { ConciergeConfig: this._ConciergeConfig });
		const tmpCandidates = tmpGroupMembers.filter((pRNI) => !tmpExistingIDs.has(pRNI.IDReportNamedInstance));
		this._BulkAddCandidates = tmpCandidates;
		if (tmpCandidates.length === 0)
		{
			tmpList.innerHTML = '<p class="has-text-grey-light">No matching forms outside this project.</p>';
			return;
		}
		let tmpHTML = '';
		for (const tmpRNI of tmpCandidates)
		{
			const tmpLabel = tmpRNI.Name ? `${tmpRNI.Name} (${tmpRNI.Hash || tmpRNI.IDReportNamedInstance})` : `RNI ${tmpRNI.IDReportNamedInstance}`;
			tmpHTML += /*html*/`
				<label class="checkbox is-block mb-1">
					<input type="checkbox" data-id="${tmpRNI.IDReportNamedInstance}" checked />
					${this._escapeHTML(tmpLabel)}
					<small class="has-text-grey ml-2">${this._escapeHTML(tmpRNI.GUIDReportNamedInstance || '')}</small>
				</label>`;
		}
		tmpList.innerHTML = tmpHTML;
	}

	confirmBulkAdd()
	{
		if (!this._SelectedProject) { return; }
		const tmpInputs = Array.from(document.querySelectorAll('#PF-BulkAdd-List input[type="checkbox"]:checked'));
		if (tmpInputs.length === 0)
		{
			this._showNotification('No forms selected.', 'warning');
			return;
		}
		const tmpSelectedIDs = tmpInputs.map((pInput) => parseInt(pInput.getAttribute('data-id'), 10)).filter((id) => id > 0);
		if (tmpSelectedIDs.length === 0)
		{
			this._showNotification('No valid form IDs found in selection.', 'warning');
			return;
		}

		const tmpConfirmButton = document.getElementById('PF-BulkAdd-Confirm-Button');
		if (tmpConfirmButton) { tmpConfirmButton.classList.add('is-loading'); }

		const tmpIDProject = this._SelectedProject.IDProject;
		const tmpIDCustomer = this._getSelectedProjectIDCustomer();
		if (!tmpIDCustomer)
		{
			if (tmpConfirmButton) { tmpConfirmButton.classList.remove('is-loading'); }
			this._showNotification('Could not determine customer for this project.', 'danger');
			return;
		}

		const tmpSelected = new Set(tmpSelectedIDs);
		const tmpOrdered = this._orderJoinCandidates(this._BulkAddCandidates.filter((pRNI) => tmpSelected.has(pRNI.IDReportNamedInstance)));
		const tmpTotal = tmpOrdered.length;
		const tmpOrdinalBase = this._ProjectJoins.length;
		const tmpPayloads = tmpOrdered.map((pRNI, pIndex) =>
		{
			return {
				IDReportNamedInstance: pRNI.IDReportNamedInstance,
				IDProject: tmpIDProject,
				IDCustomer: tmpIDCustomer,
				IDProgram: 0,
				Ordinal: tmpOrdinalBase + pIndex,
			};
		});

		this._createJoins(tmpPayloads, (pUpsertError) =>
		{
			if (tmpConfirmButton) { tmpConfirmButton.classList.remove('is-loading'); }
			if (pUpsertError)
			{
				this.pict.log.error(`Error linking forms to project ${tmpIDProject}: ${pUpsertError}`);
				this._showNotification('Error linking forms. Some may have been linked — check the list below.', 'danger');
			}
			else
			{
				this._showNotification(`Linked ${tmpTotal} form${tmpTotal > 1 ? 's' : ''}.`, 'success');
			}
			this.closeBulkAddModal();
			this._loadJoinsForProject(tmpIDProject);
		});
	}

	// ---- Rendering helpers ----

	_renderProjectList()
	{
		const tmpListBody = document.getElementById('PF-Project-List-Body');
		if (!tmpListBody) { return; }

		if (this._IsLoadingProjects)
		{
			tmpListBody.innerHTML = `
				<tr>
					<td colspan="3" class="has-text-centered">
						<span class="icon"><i class="fas fa-spinner fa-spin"></i></span>
						Loading projects...
					</td>
				</tr>`;
			return;
		}

		const tmpHasSearch = !!(this._ProjectSearchTerm && this._ProjectSearchTerm.trim());

		if (this._Projects.length === 0)
		{
			tmpListBody.innerHTML = `
				<tr>
					<td colspan="3" class="has-text-centered has-text-grey-light">
						<span class="icon"><i class="fas fa-folder-open"></i></span>
						${tmpHasSearch ? 'No projects match your search.' : 'No projects found.'}
					</td>
				</tr>`;
			return;
		}

		let tmpHTML = '';
		for (let i = 0; i < this._Projects.length; i++)
		{
			const tmpP = this._Projects[i];
			const tmpIsSelected = this._SelectedProject && this._SelectedProject.IDProject === tmpP.IDProject;
			tmpHTML += `
				<tr class="pf-project-row${tmpIsSelected ? ' is-selected' : ''}"
					onclick="_Pict.views.ReportNamedInstanceProjectForms.selectProject(${tmpP.IDProject})">
					<td>${this._escapeHTML(tmpP.ExternalProjectID || '—')}</td>
					<td>
						<strong>${this._escapeHTML(tmpP.Name || '')}</strong>
						${tmpP.Description ? `<br><small class="has-text-grey">${this._escapeHTML(tmpP.Description)}</small>` : ''}
					</td>
					<td><small class="has-text-grey">${this._escapeHTML(tmpP.Status || '')}</small></td>
				</tr>`;
		}
		tmpListBody.innerHTML = tmpHTML;
	}

	_renderSelectedProjectHeader()
	{
		const tmpHeader = document.getElementById('PF-Selected-Project-Header');
		const tmpDetail = document.getElementById('PF-Detail-Panel');
		const tmpEmptyDetail = document.getElementById('PF-Empty-Detail');

		if (!tmpHeader || !tmpDetail || !tmpEmptyDetail) { return; }

		if (!this._SelectedProject)
		{
			tmpDetail.classList.add('is-hidden');
			tmpEmptyDetail.classList.remove('is-hidden');
			return;
		}

		tmpDetail.classList.remove('is-hidden');
		tmpEmptyDetail.classList.add('is-hidden');

		tmpHeader.innerHTML = `
			<div class="level">
				<div class="level-left">
					<div class="level-item">
						<div>
							<p class="title is-5 mb-1">
								<span class="icon"><i class="fas fa-diagram-project"></i></span>
								${this._escapeHTML(this._SelectedProject.Name || '')}
							</p>
							<p class="subtitle is-6 has-text-grey mb-0">
								ID: ${this._SelectedProject.IDProject}
								${this._SelectedProject.Description ? ` | ${this._escapeHTML(this._SelectedProject.Description)}` : ''}
							</p>
						</div>
					</div>
				</div>
				<div class="level-right">
					<div class="level-item">
						<button class="button is-small" onclick="_Pict.views.ReportNamedInstanceProjectForms.deselectProject()">
							<span class="icon"><i class="fas fa-xmark"></i></span>
							<span>Close</span>
						</button>
					</div>
				</div>
			</div>`;
	}

	_renderJoinsTable()
	{
		const tmpTableBody = document.getElementById('PF-Joins-Body');
		if (!tmpTableBody) { return; }

		this._renderMyDailyStatus();

		if (this._IsLoadingJoins)
		{
			tmpTableBody.innerHTML = `
				<tr>
					<td colspan="6" class="has-text-centered">
						<span class="icon"><i class="fas fa-spinner fa-spin"></i></span>
						Loading linked forms...
					</td>
				</tr>`;
			return;
		}

		if (this._ProjectJoins.length === 0)
		{
			tmpTableBody.innerHTML = `
				<tr>
					<td colspan="6" class="has-text-centered has-text-grey-light">
						<span class="icon"><i class="fas fa-link-slash"></i></span>
						No form definitions linked to this project.
					</td>
				</tr>`;
			return;
		}

		// Sort by Ordinal, falling back to join ID so equal Ordinals render in a stable order
		this._ProjectJoins.sort((pA, pB) =>
		{
			return ((pA.Ordinal || 0) - (pB.Ordinal || 0)) || (pA.IDReportNamedInstanceProjectJoin - pB.IDReportNamedInstanceProjectJoin);
		});

		const tmpDaily = this._getMyDailyJoin();
		const tmpIDDailyJoin = tmpDaily ? tmpDaily.IDReportNamedInstanceProjectJoin : 0;

		let tmpHTML = '';
		for (let i = 0; i < this._ProjectJoins.length; i++)
		{
			const tmpJoin = this._ProjectJoins[i];
			const tmpIsDaily = tmpJoin.IDReportNamedInstanceProjectJoin === tmpIDDailyJoin;

			let tmpTypeCell;
			if (tmpIsDaily)
			{
				tmpTypeCell = `
					<span class="tag is-info" title="Join ${tmpJoin.IDReportNamedInstanceProjectJoin} is the lowest for this project, so ReportNamedInstancesByProject returns it first">
						<span class="icon"><i class="fas fa-sun"></i></span>
						<span>Report (daily)</span>
					</span>`;
			}
			else if (tmpJoin._RNIFormOnly)
			{
				tmpTypeCell = '<span class="tag is-light" title="Options.FormOnly is set, so this cannot be the daily report">Form</span>';
			}
			else
			{
				tmpTypeCell = '<span class="tag is-light">Report</span>';
			}

			const tmpMakeDailyButton = (tmpIsDaily || tmpJoin._RNIFormOnly) ? '' : `
						<button class="button is-small is-info is-outlined mr-2"
							title="Make this the daily report Fieldbook offers first"
							onclick="_Pict.views.ReportNamedInstanceProjectForms.makeMyDaily(${tmpJoin.IDReportNamedInstanceProjectJoin})">
							<span class="icon"><i class="fas fa-sun"></i></span>
							<span>Make Daily</span>
						</button>`;

			tmpHTML += `
				<tr id="PF-Row-${tmpJoin.IDReportNamedInstanceProjectJoin}" draggable="true"
					class="${tmpIsDaily ? 'pf-daily-row' : ''}"
					data-join-id="${tmpJoin.IDReportNamedInstanceProjectJoin}" data-ordinal="${tmpJoin.Ordinal || 0}">
					<td class="pf-drag-handle"><span class="icon has-text-grey-light"><i class="fas fa-grip-vertical"></i></span></td>
					<td>${tmpJoin.IDReportNamedInstance}</td>
					<td>
						<strong>${this._escapeHTML(tmpJoin._RNIName || '')}</strong>
						${tmpJoin._RNIHash ? ` <code>${this._escapeHTML(tmpJoin._RNIHash)}</code>` : ''}
					</td>
					<td>${tmpTypeCell}</td>
					<td class="pf-ordinal-cell">${tmpJoin.Ordinal || 0}</td>
					<td class="has-text-right">
						${tmpMakeDailyButton}
						<button class="button is-small is-danger is-outlined"
							onclick="_Pict.views.ReportNamedInstanceProjectForms.removeJoin(${tmpJoin.IDReportNamedInstanceProjectJoin})">
							<span class="icon"><i class="fas fa-trash-can"></i></span>
							<span>Remove</span>
						</button>
					</td>
				</tr>`;
		}
		tmpTableBody.innerHTML = tmpHTML;
		this._initDragDrop();
	}

	_initDragDrop()
	{
		const tmpTableBody = document.getElementById('PF-Joins-Body');
		if (!tmpTableBody) { return; }

		let tmpDragRow = null;

		// Create a placeholder row that shows where the drop will land
		const tmpPlaceholder = document.createElement('tr');
		tmpPlaceholder.className = 'pf-drag-placeholder';
		tmpPlaceholder.innerHTML = '<td colspan="6"></td>';

		const tmpRemovePlaceholder = () =>
		{
			if (tmpPlaceholder.parentNode) { tmpPlaceholder.parentNode.removeChild(tmpPlaceholder); }
		};

		tmpTableBody.querySelectorAll('tr[draggable]').forEach((pRow) =>
		{
			pRow.addEventListener('dragstart', (pEvent) =>
			{
				tmpDragRow = pRow;
				pRow.classList.add('pf-dragging');
				pEvent.dataTransfer.effectAllowed = 'move';
			});

			pRow.addEventListener('dragend', () =>
			{
				if (tmpDragRow) { tmpDragRow.classList.remove('pf-dragging'); }
				tmpDragRow = null;
				tmpRemovePlaceholder();
			});

			pRow.addEventListener('dragover', (pEvent) =>
			{
				pEvent.preventDefault();
				pEvent.dataTransfer.dropEffect = 'move';
				if (!tmpDragRow || pRow === tmpDragRow) { return; }

				// Detect top or bottom half of the hovered row
				const tmpRect = pRow.getBoundingClientRect();
				const tmpMidpoint = tmpRect.top + (tmpRect.height / 2);
				const tmpIsAbove = pEvent.clientY < tmpMidpoint;

				if (tmpIsAbove)
				{
					pRow.parentNode.insertBefore(tmpPlaceholder, pRow);
				}
				else
				{
					pRow.parentNode.insertBefore(tmpPlaceholder, pRow.nextSibling);
				}
			});

			pRow.addEventListener('drop', (pEvent) =>
			{
				pEvent.preventDefault();
				if (!tmpDragRow || pRow === tmpDragRow) { tmpRemovePlaceholder(); return; }

				// Insert the dragged row where the placeholder is
				tmpPlaceholder.parentNode.insertBefore(tmpDragRow, tmpPlaceholder);
				tmpRemovePlaceholder();

				this._persistOrdinals();
			});
		});
	}

	_persistOrdinals()
	{
		const tmpTableBody = document.getElementById('PF-Joins-Body');
		if (!tmpTableBody) { return; }

		const tmpRows = Array.from(tmpTableBody.querySelectorAll('tr[data-join-id]'));
		const tmpUpdates = [];

		for (let i = 0; i < tmpRows.length; i++)
		{
			const tmpIDJoin = parseInt(tmpRows[i].getAttribute('data-join-id'), 10);
			const tmpJoin = this._ProjectJoins.find((pJ) => pJ.IDReportNamedInstanceProjectJoin === tmpIDJoin);

			if (tmpJoin)
			{
				tmpJoin.Ordinal = i;
			}
			tmpRows[i].setAttribute('data-ordinal', i);
			const tmpOrdinalCell = tmpRows[i].querySelector('.pf-ordinal-cell');
			if (tmpOrdinalCell)
			{
				tmpOrdinalCell.textContent = i;
			}

			tmpUpdates.push({ IDReportNamedInstanceProjectJoin: tmpIDJoin, Ordinal: i });
		}

		this.pict.HeadlightRestClient.putJSON(
			'ReportNamedInstanceProjectJoins',
			tmpUpdates,
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating ordinals: ${pError}`);
					this._showNotification('Error saving new order. Please try again.', 'warning');
				}
			}
		);
	}

	/** The pict-section-picker provider, or null when the host app did not register it. */
	_pickerProvider()
	{
		const tmpProvider = this.pict.providers && this.pict.providers['Pict-Section-Picker'];
		return (tmpProvider && (typeof tmpProvider.createPicker === 'function')) ? tmpProvider : null;
	}

	/** The mounted picker view, or null before it has been created. */
	_rniPickerView()
	{
		return (this.pict.views && this.pict.views[RNI_PICKER_HASH]) || null;
	}

	/** The IDReportNamedInstance currently chosen in the picker (0 when empty). */
	_selectedLinkIDRNI()
	{
		const tmpView = this._rniPickerView();
		if (!tmpView || (typeof tmpView.getValue !== 'function')) { return 0; }
		const tmpID = parseInt(tmpView.getValue(), 10);
		return Number.isFinite(tmpID) && tmpID > 0 ? tmpID : 0;
	}

	/** Empty the picker's selection (after a successful link, or when the project is deselected). */
	_clearRNIPicker()
	{
		const tmpView = this._rniPickerView();
		if (tmpView && (typeof tmpView.setValue === 'function')) { tmpView.setValue(null); }
	}

	/**
	 * Mount — or re-configure and repaint — the searchable form-definition picker.
	 *
	 * `_loadAvailableRNIs` already pulls the customer's whole RNI set, so this is a static-Options
	 * picker: search filters the loaded list client-side with no further requests. It replaces a
	 * native <select> that listed every form in one unfiltered, viewport-height dropdown.
	 *
	 * createPicker reconfigures and reuses an existing view of the same hash, so calling this on
	 * every load/repaint refreshes the option list in place.
	 */
	_renderRNIPicker()
	{
		const tmpProvider = this._pickerProvider();
		if (!tmpProvider) { return; }
		if (!document.getElementById(RNI_PICKER_HASH)) { return; }

		const tmpOptions = this._IsLoadingRNIs ? [] : this._AvailableRNIs.map((pRNI) =>
			({
				Value: pRNI.IDReportNamedInstance,
				Text: pRNI.Name || `RNI ${pRNI.IDReportNamedInstance}`,
				// The hash rides as a badge rather than inside the label, so searching "Name" is not
				// diluted by hash text while the hash still disambiguates same-named forms.
				Tag: pRNI.Hash || String(pRNI.IDReportNamedInstance),
			}));

		const tmpView = tmpProvider.createPicker(RNI_PICKER_HASH,
			{
				DestinationAddress: `#${RNI_PICKER_HASH}`,
				ValueAddress: RNI_PICKER_VALUE_ADDRESS,
				Searchable: true,
				AllowClear: true,
				ClearLabel: 'None',
				TagLast: true,
				Placeholder: this._IsLoadingRNIs ? 'Loading forms…' : 'Search form definitions…',
				Options: tmpOptions,
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	onProjectSearch(pValue)
	{
		this._ProjectSearchTerm = pValue || '';

		if (this._ProjectSearchDebounceTimer)
		{
			clearTimeout(this._ProjectSearchDebounceTimer);
		}
		this._ProjectSearchDebounceTimer = setTimeout(() =>
		{
			this._ProjectSearchDebounceTimer = null;
			this._loadProjects();
		}, 250);
	}

	_escapeHTML(pStr)
	{
		if (!pStr) { return ''; }
		return pStr.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	_showNotification(pMessage, pType)
	{
		const tmpContainer = document.getElementById('PF-Notification-Area');
		if (tmpContainer)
		{
			tmpContainer.innerHTML = /*html*/`
				<div class="notification is-${pType} is-soft">
					<button class="delete" onclick="this.parentElement.remove()"></button>
					${pMessage}
				</div>`;
			setTimeout(() =>
			{
				tmpContainer.innerHTML = '';
			}, 4000);
		}
	}

	onAfterRender()
	{
		super.onAfterRender();

		const tmpSearchInput = document.getElementById('PF-Project-Search');
		if (tmpSearchInput)
		{
			tmpSearchInput.addEventListener('input', (pEvent) =>
			{
				this.onProjectSearch(pEvent.target.value);
			});
		}

		// The main container render replaces the picker's mount element, so re-create the control into
		// the fresh node before anything can read a selection from it.
		this._renderRNIPicker();

		// Initial L5-section visibility for the freshly rendered DOM.
		this._refreshL5Sections();
	}
}

module.exports = ReportNamedInstanceProjectForms;

module.exports.default_configuration = (
{
	ViewIdentifier: 'ReportNamedInstanceProjectForms',

	DefaultRenderable: 'PF-Main-Container',
	DefaultDestinationAddress: '#FormEditor-Application-Container',

	AutoRender: false,

	CSS: /*css*/`
.pf-container
{
	display: flex;
	flex-direction: column;
	height: calc(100vh - 80px);
}
.pf-header
{
	padding: 16px 20px;
	background: var(--bulma-scheme-main-bis);
	border-bottom: 1px solid var(--bulma-border);
}
.pf-body
{
	flex: 1;
	display: flex;
	overflow: hidden;
}
.pf-sidebar
{
	width: 380px;
	min-width: 280px;
	border-right: 1px solid var(--bulma-border);
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.pf-sidebar-header
{
	padding: 12px 16px;
	border-bottom: 1px solid var(--bulma-border);
	background: var(--bulma-scheme-main-bis);
}
.pf-sidebar-list
{
	flex: 1;
	overflow-y: auto;
}
.pf-project-row
{
	cursor: pointer;
}
.pf-project-row:hover td
{
	background-color: var(--bulma-scheme-main-bis) !important;
}
/* --bulma-info-light is pinned to --bulma-info-90-l in BOTH schemes, so it stays near-white in
   dark mode while the row text goes near-white too (1.03:1 -- invisible). --bulma-info-soft and
   --bulma-info-bold are the self-inverting pair: 90%/20% lightness in light mode and 20%/90% in
   dark, so the highlight reads at ~7:1 either way. The color needs !important to beat Bulma's
   own .table tr.is-selected td { color: currentColor }, which is the more specific selector. */
.pf-project-row.is-selected td
{
	background-color: var(--bulma-info-soft) !important;
	color: var(--bulma-info-bold) !important;
}
.pf-detail
{
	flex: 1;
	overflow-y: auto;
	padding: 24px;
}
.pf-detail-content
{
	max-width: 800px;
}
.pf-empty-detail
{
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--bulma-text-soft);
}
.pf-add-section
{
	display: flex;
	align-items: flex-end;
	gap: 12px;
	margin-bottom: 1.5rem;
	flex-wrap: wrap;
}
.pf-add-section .field
{
	margin-bottom: 0;
	flex: 1;
	min-width: 250px;
}
/* The Link Form button sizes to its content; without this it is also a flex:1 field and takes half
   the row, leaving the picker — and so its dropdown — at half the width it could have. */
.pf-add-section .field.pf-add-action
{
	flex: 0 0 auto;
	min-width: 0;
}
.pf-drag-handle
{
	cursor: grab;
	user-select: none;
	text-align: center;
	width: 36px;
}
.pf-drag-handle:active
{
	cursor: grabbing;
}
tr.pf-dragging
{
	opacity: 0.3;
}
tr.pf-daily-row td
{
	background-color: var(--bulma-info-soft) !important;
	color: var(--bulma-info-bold) !important;
}
/* .has-text-grey is a fixed hsl(221,14%,48%) marked !important, so it ignores the row color above
   and drops to 1.8:1 on the dark soft background. Re-inherit the row color and carry the
   de-emphasis with opacity instead, which composites against whichever background the theme
   actually paints (~4.6:1 light, ~5.3:1 dark). */
.pf-project-row.is-selected td .has-text-grey,
tr.pf-daily-row td .has-text-grey
{
	color: inherit !important;
	opacity: 0.8;
}
/* A 3px bar with no text: it needs to read against the page in both schemes, which the soft fill
   does not manage (1.15:1 light, 2.18:1 dark). --bulma-info is 34% lightness in both, clearing
   the 3:1 non-text bar either way. */
tr.pf-drag-placeholder td
{
	background: var(--bulma-info) !important;
	height: 3px;
	padding: 0 !important;
	border: none !important;
}
.pf-bulkadd-list
{
	max-height: 400px;
	overflow-y: auto;
	padding: 8px 12px;
	border: 1px solid var(--bulma-border);
	border-radius: 4px;
	background: var(--bulma-scheme-main-bis);
}
/* LIMS Concierge switch. Uses the shared .button.is-toggle component (headlight-styles), which
   rotates the icon 180deg when inactive. Its colors are set explicitly here rather than via the
   is-success variant: that variant paints the off state with --bulma-success-weak, which is not
   defined in these apps, so the icon resolved to the inherited button color (white on the panel). */
/* .button.is-toggle is carried in the selectors on purpose: the shared component's own
   .button.is-toggle.is-active rule is more specific than a bare .pf-concierge-toggle.is-active
   and would otherwise repaint the on state back to --bulma-text. */
/* Flatten the button chrome so the switch reads as part of the card. The shared component clears
   background and border but not box-shadow, and Bulma's .button.is-active — which it also uses for
   "pressed" — zeroes the outer shadow. Since is-active here means "on", the stray shadow showed in
   the OFF state only. Killing it wins over the base/hover/focus shadows by specificity, so the
   keyboard focus ring is re-added as an outline below. */
.button.is-toggle.pf-concierge-toggle
{
	box-shadow: none;
	background: transparent;
}
.button.is-toggle.pf-concierge-toggle:focus-visible
{
	outline: 2px solid var(--bulma-link);
	outline-offset: 2px;
}
.button.is-toggle.pf-concierge-toggle i
{
	color: var(--bulma-text-weak);
}
.button.is-toggle.pf-concierge-toggle:not(.is-active):hover i
{
	color: var(--bulma-text-soft);
}
.button.is-toggle.pf-concierge-toggle.is-active i
{
	color: var(--bulma-success);
}
.button.is-toggle.pf-concierge-toggle[disabled]
{
	opacity: 0.5;
}
/* The picker paints its own control; the wrapper only needs to fill the field. */
.pf-rni-picker
{
	width: 100%;
}
/* Give the form NAME priority over the hash pill in the dropdown and in the selected value.
   PSP ships .pps-tag as flex:0 0 auto (never shrinks) while the label shrinks first, so a long name
   ellipsised while its hash stayed full width — backwards, since the name is what you search by.
   Anchored on the PPS_List_ / PPS_Value_ ids rather than a .pf-rni-picker descendant selector: the
   dropdown portals out to <body>, and those ids travel with it while a descendant selector would not.
   Scoped to this picker so other apps' pickers keep PSP's default balance. */
#PPS_List_PF-RNI-Picker .pps-option-label,
#PPS_Value_PF-RNI-Picker .pps-value
{
	flex: 1 1 auto;
}
/* Shrink factor 3 (vs the label's 1) so the hash yields first instead of the two splitting the
   overflow proportionally, plus a hard ceiling so a long hash can never take most of the row. At the
   normal content width both still render in full. */
#PPS_List_PF-RNI-Picker .pps-tag,
#PPS_Value_PF-RNI-Picker .pps-tag
{
	flex: 0 3 auto;
	min-width: 0;
	max-width: 45%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
`,

	Templates:
	[
		{
			Hash: 'PF-Main-Container-Template',
			Template: /*html*/`
<div class="pf-container">
	<div id="PF-Notification-Area"></div>
	<div class="pf-header">
		<h2 class="title is-5 mb-0">
			<span class="icon"><i class="fas fa-diagram-project"></i></span>
			Project Forms
		</h2>
		<p class="subtitle is-6 has-text-grey mb-0">
			Select a project to manage which form definitions are linked to it.
		</p>
	</div>
	<div class="pf-body">
		<div class="pf-sidebar">
			<div class="pf-sidebar-header">
				<div class="control has-icons-left">
					<input id="PF-Project-Search" class="input is-small" type="text" placeholder="Search projects..." />
					<span class="icon is-left"><i class="fas fa-search"></i></span>
				</div>
			</div>
			<div class="pf-sidebar-list">
				<table class="table is-fullwidth is-hoverable is-narrow">
					<thead>
						<tr>
							<th style="width:90px">Project #</th>
							<th>Project</th>
							<th style="width:70px">Status</th>
						</tr>
					</thead>
					<tbody id="PF-Project-List-Body">
						<tr>
							<td colspan="3" class="has-text-centered">
								<span class="icon"><i class="fas fa-spinner fa-spin"></i></span>
								Loading...
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div id="PF-Empty-Detail" class="pf-empty-detail">
			<div class="has-text-centered">
				<span class="icon is-large"><i class="fas fa-arrow-left fa-2x"></i></span>
				<p class="mt-3">Select a project from the list to manage its form definitions.</p>
			</div>
		</div>

		<div id="PF-Detail-Panel" class="pf-detail is-hidden">
			<div class="pf-detail-content">
				<div id="PF-Selected-Project-Header" class="mb-5"></div>

				<div id="PF-LIMS-Concierge-Section" class="box mb-4 is-hidden">
					<div class="level mb-1">
						<div class="level-left">
							<div class="level-item">
								<div>
									<p class="title is-6 mb-1" id="PF-LIMS-Concierge-Title">
										<span class="icon"><i class="fas fa-flask"></i></span>
										LIMS Concierge
									</p>
									<p class="subtitle is-7 has-text-grey mb-0" id="PF-LIMS-Concierge-Status">
										Loading…
									</p>
								</div>
							</div>
						</div>
						<div class="level-right">
							<div class="level-item">
								<button type="button" id="PF-LIMS-Concierge-Toggle"
									class="button is-toggle pf-concierge-toggle"
									role="switch" aria-checked="false" aria-labelledby="PF-LIMS-Concierge-Title"
									onclick="_Pict.views.ReportNamedInstanceProjectForms.onLIMSConciergeToggle()">
									<span class="icon is-large"><i class="fas fa-fw fa-toggle-large-on"></i></span>
								</button>
							</div>
						</div>
					</div>
					<p id="PF-LIMS-Concierge-Warning" class="help is-warning is-hidden mt-2">
						<span class="icon"><i class="fas fa-triangle-exclamation"></i></span>
						Concierge is enabled but no LIMS forms are joined to this project.
						The materials API will log a fatal on each sample sync until LIMS forms are added.
					</p>
				</div>

				<div class="pf-add-section">
					<div class="field">
						<label class="label" id="PF-RNI-Picker-Label">Link a Form Definition</label>
						<div class="control">
							<div id="PF-RNI-Picker" class="pf-rni-picker"></div>
						</div>
					</div>
					<div class="field pf-add-action">
						<div class="control">
							<button id="PF-Add-Button" class="button is-info"
								onclick="_Pict.views.ReportNamedInstanceProjectForms.addFormToProject()">
								<span class="icon"><i class="fas fa-plus"></i></span>
								<span>Link Form</span>
							</button>
						</div>
					</div>
				</div>

				<div class="level mb-4">
					<div class="level-left">
						<div class="level-item">
							<h5 class="title is-6 mb-0">
								<span class="icon"><i class="fas fa-file-lines"></i></span>
								Linked Form Definitions
							</h5>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">
							<button id="PF-BulkAdd-Button" class="button is-small is-link is-outlined is-hidden"
								onclick="_Pict.views.ReportNamedInstanceProjectForms.openBulkAddModal()">
								<span class="icon"><i class="fas fa-layer-group"></i></span>
								<span>Bulk Add Forms</span>
							</button>
						</div>
						<div class="level-item">
							<button id="PF-Defaults-Button" class="button is-small is-success is-outlined"
								onclick="_Pict.views.ReportNamedInstanceProjectForms.pullInDefaultForms()">
								<span class="icon"><i class="fas fa-download"></i></span>
								<span>Customize Defaults</span>
							</button>
						</div>
						<div class="level-item">
							<button id="PF-RemoveAll-Button" class="button is-small is-danger is-outlined"
								onclick="_Pict.views.ReportNamedInstanceProjectForms.removeAllJoins()">
								<span class="icon"><i class="fas fa-trash-can"></i></span>
								<span>Remove All</span>
							</button>
						</div>
					</div>
				</div>
				<div id="PF-Daily-Status"></div>
				<div class="table-container">
					<table class="table is-fullwidth is-hoverable is-striped">
						<thead>
							<tr>
								<th style="width:36px"></th>
								<th style="width:50px">RNI ID</th>
								<th>Form Definition</th>
								<th style="width:130px">Type</th>
								<th style="width:70px">Ordinal</th>
								<th class="has-text-right" style="width:240px">Actions</th>
							</tr>
						</thead>
						<tbody id="PF-Joins-Body">
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>

	<div id="PF-BulkAdd-Modal" class="modal">
		<div class="modal-background" onclick="_Pict.views.ReportNamedInstanceProjectForms.closeBulkAddModal()"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">
					<span class="icon"><i class="fas fa-layer-group"></i></span>
					Bulk Add Forms
				</p>
				<button class="delete" aria-label="close"
					onclick="_Pict.views.ReportNamedInstanceProjectForms.closeBulkAddModal()"></button>
			</header>
			<section class="modal-card-body">
				<div class="field">
					<label class="label">Form group</label>
					<div class="control">
						<div class="select is-fullwidth">
							<select id="PF-BulkAdd-Group-Select"
								onchange="_Pict.views.ReportNamedInstanceProjectForms.onBulkAddGroupChange()">
							</select>
						</div>
					</div>
					<p id="PF-BulkAdd-Group-Description" class="help has-text-grey"></p>
				</div>
				<div class="field">
					<div class="level mb-2">
						<div class="level-left">
							<div class="level-item">
								<p class="subtitle is-6 mb-0">Forms in this group not yet joined to the project</p>
							</div>
						</div>
						<div class="level-right">
							<div class="level-item">
								<button class="button is-small"
									onclick="_Pict.views.ReportNamedInstanceProjectForms.toggleAllBulkAddRows(true)">
									Select all
								</button>
								<button class="button is-small ml-2"
									onclick="_Pict.views.ReportNamedInstanceProjectForms.toggleAllBulkAddRows(false)">
									Clear
								</button>
							</div>
						</div>
					</div>
					<div id="PF-BulkAdd-List" class="pf-bulkadd-list">
						<p class="has-text-grey-light">Select a form group to see candidates.</p>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<button id="PF-BulkAdd-Confirm-Button" class="button is-primary"
					onclick="_Pict.views.ReportNamedInstanceProjectForms.confirmBulkAdd()">
					Add selected
				</button>
				<button class="button"
					onclick="_Pict.views.ReportNamedInstanceProjectForms.closeBulkAddModal()">
					Cancel
				</button>
			</footer>
		</div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PF-Main-Container',
			TemplateHash: 'PF-Main-Container-Template',
			RenderMethod: 'replace'
		}
	]
});

},{"pict-view":733}],293:[function(require,module,exports){
// headlight-report-project-assignment — shared pict-view that assigns report/form definitions
// (ReportNamedInstance) to projects via ReportNamedInstanceProjectJoin, with a searchable project list,
// linked-forms management (add / pull-in-defaults / drag-reorder / remove), My Daily designation and
// repair, an L5-only bulk-add modal, and a project-level LIMS-concierge gate.
//
// My Daily: ReportNamedInstancesByProject issues no ORDER BY and its handler pins element [0] before
// alphabetizing the rest, so the project's daily report is whichever join the IDProject index yields
// first — in practice the lowest IDReportNamedInstanceProjectJoin. The joins table badges that row and
// offers "Make My Daily" on the others, which swaps the two rows' IDReportNamedInstance values through
// a -1 parking write (AK_ReportNamedInstanceProjectJoin is UNIQUE on (IDReportNamedInstance, IDProject)
// with no soft delete). The table's own order is Ordinal, which no server code reads today.
//
// Host couplings are injected via the view's options:
//   - DefaultDestinationAddress : the container selector to render into (per host)
//   - FormGroups                : materials-form-manager FORM_GROUPS (enables the bulk-add modal; omit/null to hide it)
//   - IsLIMSForm                : materials-form-manager isLIMSForm(hashOrName) predicate (defaults to a no-op)
// Re-exports the view class and its default_configuration so a host can `addView` it directly.

const libReportNamedInstanceProjectAssignment = require('./ReportNamedInstance-ProjectAssignment.js');

module.exports = libReportNamedInstanceProjectAssignment;
module.exports.default_configuration = libReportNamedInstanceProjectAssignment.default_configuration;

},{"./ReportNamedInstance-ProjectAssignment.js":292}],294:[function(require,module,exports){
/**
 * headlight-sample-scanning — Scan Samples (move scanned samples into a location, one at a time or together)
 * for any pict app, plus the location tree and the reception status rule it uses.
 *
 *     const HeadlightSampleScanningBundle = require('headlight-sample-scanning');
 *     const tmpScanning = new HeadlightSampleScanningBundle(pict).attach();
 *     tmpScanning.connect({ notify, printLabel, camera });
 *     tmpScanning.open({ DestinationAddress: '#Somewhere' });
 *     tmpScanning.listen(pict.providers.HeadlightQR);   // scans while the panel is open; close() stops listening
 */

const SampleScanningProvider = require('./providers/Pict-Provider-SampleScanning.js');
const SampleScanningView = require('./views/PictView-SampleScanning.js');

class HeadlightSampleScanningBundle
{
	/**
	 * @param {any} pPict
	 */
	constructor(pPict)
	{
		this.pict = pPict;
	}

	/**
	 * Register the provider and view. Safe to call more than once.
	 *
	 * @param {Object} [pOptions]
	 * @param {Object} [pOptions.SampleScanning] - Provider options (`Store`, `Storage`, `RemoveFromCurrentLocation`).
	 * @param {Object} [pOptions.View] - View options (`DefaultDestinationAddress`).
	 * @return {SampleScanningProvider}
	 */
	attach(pOptions)
	{
		const tmpOptions = pOptions || {};
		if (!this.pict.providers.SampleScanning)
		{
			this.pict.addProviderSingleton('SampleScanning', tmpOptions.SampleScanning || {}, SampleScanningProvider);
		}
		if (!this.pict.views.SampleScanning)
		{
			this.pict.addViewSingleton('SampleScanning', tmpOptions.View || {}, SampleScanningView);
			// Attached after the app's first CSS injection, so the view's styles need injecting now.
			if ((typeof document !== 'undefined') && this.pict.CSSMap && (typeof this.pict.CSSMap.injectCSS === 'function'))
			{
				this.pict.CSSMap.injectCSS();
			}
		}
		return this.pict.providers.SampleScanning;
	}

	/**
	 * Register a second, separate cart under its own name: its own state, element IDs and templates, so it can be on
	 * screen beside the panels' Scan Samples (e.g. a sample's Location tab). Safe to call more than once.
	 *
	 *     const tmpCart = new HeadlightSampleScanningBundle(pict).attachInstance('SampleLocationCart', { SampleScanning: { Storage } });
	 *     tmpCart.connect({ notify, moved });
	 *     tmpCart.open({ DestinationAddress: '#Somewhere', SaveEachScan: false });
	 *
	 * @param {string} pName - the provider and view name, and the element/template prefix
	 * @param {Object} [pOptions]
	 * @param {Object} [pOptions.SampleScanning] - Provider options (`Store`, `Storage`, `RemoveFromCurrentLocation`).
	 * @return {SampleScanningProvider}
	 */
	attachInstance(pName, pOptions)
	{
		const tmpOptions = pOptions || {};
		if (!this.pict.providers[pName])
		{
			this.pict.addProviderSingleton(pName, Object.assign({}, tmpOptions.SampleScanning || {},
				{ ProviderIdentifier: pName, ViewHash: pName, IDPrefix: pName, ScanHandlerHash: pName }), SampleScanningProvider);
		}
		if (!this.pict.views[pName])
		{
			this.pict.addViewSingleton(pName, { ProviderHash: pName, IDPrefix: pName }, SampleScanningView);
			if ((typeof document !== 'undefined') && this.pict.CSSMap && (typeof this.pict.CSSMap.injectCSS === 'function'))
			{
				this.pict.CSSMap.injectCSS();
			}
		}
		return this.pict.providers[pName];
	}
}

module.exports = HeadlightSampleScanningBundle;
module.exports.SampleScanningProvider = SampleScanningProvider;
module.exports.SampleScanningView = SampleScanningView;
module.exports.AppSampleScanStore = require('./Sample-Scan-Store.js');
module.exports.LocationTree = require('./Location-Tree.js');
module.exports.SampleScanStatus = require('./Sample-Scan-Status.js');
module.exports.moveSampleToLocation = require('./Sample-Move.js').moveSampleToLocation;
module.exports.ActionCards = require('./Sample-Scan-Action-Cards.js').ACTION_CARDS;

},{"./Location-Tree.js":295,"./Sample-Move.js":296,"./Sample-Scan-Action-Cards.js":297,"./Sample-Scan-Status.js":298,"./Sample-Scan-Store.js":299,"./providers/Pict-Provider-SampleScanning.js":300,"./views/PictView-SampleScanning.js":301}],295:[function(require,module,exports){
/**
 * Location nesting through `Location.ParentIDLocation`: ancestors, descendants and cycle checks over
 * a customer's location list. Pure functions, so LIMS screens and tests share one walk.
 */

/**
 * @typedef {{ IDLocation: number, ParentIDLocation?: number, Name?: string }} LocationRecord
 */

/**
 * @param {Array<LocationRecord>} pLocations
 * @return {Map<number, LocationRecord>}
 */
function indexByID(pLocations)
{
	const tmpIndex = new Map();
	for (const tmpLocation of (Array.isArray(pLocations) ? pLocations : []))
	{
		if (tmpLocation && Number(tmpLocation.IDLocation))
		{
			tmpIndex.set(Number(tmpLocation.IDLocation), tmpLocation);
		}
	}
	return tmpIndex;
}

/**
 * The chain of parents above a location, outermost first. Stops at a missing parent or a loop.
 *
 * @param {number} pIDLocation
 * @param {Array<LocationRecord>} pLocations
 * @return {Array<LocationRecord>}
 */
function getAncestors(pIDLocation, pLocations)
{
	const tmpIndex = indexByID(pLocations);
	const tmpChain = [];
	const tmpSeen = new Set([ Number(pIDLocation) ]);
	let tmpCurrent = tmpIndex.get(Number(pIDLocation));
	while (tmpCurrent && Number(tmpCurrent.ParentIDLocation))
	{
		const tmpParentID = Number(tmpCurrent.ParentIDLocation);
		if (tmpSeen.has(tmpParentID) || !tmpIndex.has(tmpParentID))
		{
			break;
		}
		tmpSeen.add(tmpParentID);
		tmpCurrent = tmpIndex.get(tmpParentID);
		tmpChain.unshift(tmpCurrent);
	}
	return tmpChain;
}

/**
 * Every location nested anywhere below a location (not including it).
 *
 * @param {number} pIDLocation
 * @param {Array<LocationRecord>} pLocations
 * @return {Array<number>}
 */
function getDescendantIDs(pIDLocation, pLocations)
{
	const tmpChildren = new Map();
	for (const tmpLocation of indexByID(pLocations).values())
	{
		const tmpParentID = Number(tmpLocation.ParentIDLocation);
		if (tmpParentID)
		{
			if (!tmpChildren.has(tmpParentID))
			{
				tmpChildren.set(tmpParentID, []);
			}
			tmpChildren.get(tmpParentID).push(Number(tmpLocation.IDLocation));
		}
	}
	const tmpResult = [];
	const tmpSeen = new Set([ Number(pIDLocation) ]);
	const tmpQueue = [ Number(pIDLocation) ];
	while (tmpQueue.length > 0)
	{
		for (const tmpChildID of (tmpChildren.get(tmpQueue.shift()) || []))
		{
			if (!tmpSeen.has(tmpChildID))
			{
				tmpSeen.add(tmpChildID);
				tmpResult.push(tmpChildID);
				tmpQueue.push(tmpChildID);
			}
		}
	}
	return tmpResult;
}

/**
 * The locations directly inside a location.
 *
 * @param {number} pIDLocation
 * @param {Array<LocationRecord>} pLocations
 * @return {Array<LocationRecord>}
 */
function getChildren(pIDLocation, pLocations)
{
	return Array.from(indexByID(pLocations).values()).filter((pLocation) => Number(pLocation.ParentIDLocation) === Number(pIDLocation));
}

/**
 * True when putting a location inside the proposed parent would make it its own ancestor.
 *
 * @param {number} pIDLocation
 * @param {number} pProposedParentID
 * @param {Array<LocationRecord>} pLocations
 * @return {boolean}
 */
function wouldCreateCycle(pIDLocation, pProposedParentID, pLocations)
{
	const tmpParentID = Number(pProposedParentID);
	if (!tmpParentID || !Number(pIDLocation))
	{
		return false;
	}
	return (tmpParentID === Number(pIDLocation)) || getDescendantIDs(pIDLocation, pLocations).includes(tmpParentID);
}

/**
 * Every location in tree order: each top-level location (A-Z) followed by everything inside it, with its depth.
 * Locations caught in a parent loop come last, at the top level.
 *
 * @param {Array<LocationRecord>} pLocations
 * @return {Array<{ Location: LocationRecord, Depth: number }>}
 */
function getTreeOrder(pLocations)
{
	const tmpIndex = indexByID(pLocations);
	const tmpByName = (pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || ''), undefined, { numeric: true, sensitivity: 'base' });
	const tmpChildren = new Map();
	const tmpRoots = [];
	for (const tmpLocation of tmpIndex.values())
	{
		const tmpParentID = Number(tmpLocation.ParentIDLocation);
		if (tmpParentID && tmpIndex.has(tmpParentID) && tmpParentID !== Number(tmpLocation.IDLocation))
		{
			if (!tmpChildren.has(tmpParentID))
			{
				tmpChildren.set(tmpParentID, []);
			}
			tmpChildren.get(tmpParentID).push(tmpLocation);
		}
		else
		{
			tmpRoots.push(tmpLocation);
		}
	}
	const tmpOrder = [];
	const tmpVisited = new Set();
	const fVisit = (pLocation, pDepth) =>
	{
		const tmpID = Number(pLocation.IDLocation);
		if (tmpVisited.has(tmpID))
		{
			return;
		}
		tmpVisited.add(tmpID);
		tmpOrder.push({ Location: pLocation, Depth: pDepth });
		for (const tmpChild of (tmpChildren.get(tmpID) || []).sort(tmpByName))
		{
			fVisit(tmpChild, pDepth + 1);
		}
	};
	tmpRoots.sort(tmpByName).forEach((pLocation) => fVisit(pLocation, 0));
	Array.from(tmpIndex.values()).filter((pLocation) => !tmpVisited.has(Number(pLocation.IDLocation))).sort(tmpByName).forEach((pLocation) => fVisit(pLocation, 0));
	return tmpOrder;
}

module.exports =
{
	getAncestors,
	getDescendantIDs,
	getChildren,
	getTreeOrder,
	wouldCreateCycle,
};

},{}],296:[function(require,module,exports){
/**
 * Moving a sample into a location: the one move scanning and the sample forms (`web/providers/SampleProvider.js`
 * `recordStorageLocation`) both use, so a sample ends up in one place with a log entry however it was moved.
 */

const libSampleScanStatus = require('./Sample-Scan-Status.js');

/**
 * @typedef {Object} SampleMoveOptions
 * @property {boolean} [RemoveFromCurrentLocation] - Default true. False adds the location and keeps the others.
 * @property {import('./Sample-Scan-Status.js').ReceiveConfig|null} [ReceiveConfig] - Left out or null, the status isn't touched.
 * @property {Array<{ IDLocation: number }>} [CurrentLocations] - Where the sample is now, when the caller has already read it.
 * @property {{ CaptureLatitude?: number, CaptureLongitude?: number }|null} [Position]
 * @property {string|((pMove: { To: string, From: string }) => string)} [Notes] - The log entry: a fixed text, or one
 *     built from the location's name (To) and the names of the locations the sample was taken out of (From, '' when
 *     it wasn't in one). Default "Sample moved to <To>", or "Sample moved from <From> to <To>".
 * @property {Array<{ IDLocation: number, Name?: string }>} [Locations] - The customer's locations, when the caller has
 *     them, so the From names don't need reading.
 */

/**
 * @typedef {Object} SampleMoveResult
 * @property {Array<number>} PreviousIDLocations - The other locations it was in, newest first.
 * @property {string} PreviousStatus
 * @property {{ Status: string, Kept?: string }} StatusDecision - Status is the one set ('' for none).
 */

/**
 * Move a sample into a location: add it there, take it out of anywhere else, set any status the location
 * calls for, and log the move.
 *
 * @param {import('./Sample-Scan-Store.js').SampleScanStore} pStore
 * @param {{ IDSample: number, Status?: string }} pSample
 * @param {{ IDLocation: number, Name?: string, QRCode?: string, GUIDLocation?: string }} pLocation
 * @param {SampleMoveOptions} [pOptions]
 * @return {Promise<SampleMoveResult>}
 */
/**
 * @param {Array<string>} pNames
 * @return {string} "A", "A and B", or "A, B and C"
 */
function joinNames(pNames)
{
	if (pNames.length < 2)
	{
		return pNames[0] || '';
	}
	return `${pNames.slice(0, -1).join(', ')} and ${pNames[pNames.length - 1]}`;
}

/**
 * The names of the locations a sample is being taken out of, from the caller's list, else read through the store.
 * A name that can't be found is "location #<id>", so the log still says where the sample was.
 *
 * @param {import('./Sample-Scan-Store.js').SampleScanStore} pStore
 * @param {Array<number>} pIDLocations
 * @param {Array<{ IDLocation: number, Name?: string }>} [pLocations]
 * @return {Promise<Array<string>>}
 */
async function locationNames(pStore, pIDLocations, pLocations)
{
	const tmpNames = [];
	for (const tmpIDLocation of pIDLocations)
	{
		let tmpLocation = (pLocations || []).find((pLocation) => Number(pLocation.IDLocation) === Number(tmpIDLocation)) || null;
		if (!tmpLocation && (typeof pStore.getLocation === 'function'))
		{
			tmpLocation = await Promise.resolve().then(() => pStore.getLocation(tmpIDLocation)).catch(() => null);
		}
		tmpNames.push((tmpLocation && tmpLocation.Name) ? tmpLocation.Name : `location #${tmpIDLocation}`);
	}
	return tmpNames;
}

/**
 * @param {{ To: string, From: string }} pMove
 * @return {string} the default log entry
 */
function defaultNotes(pMove)
{
	return pMove.From ? `Sample moved from ${pMove.From} to ${pMove.To}` : `Sample moved to ${pMove.To}`;
}

async function moveSampleToLocation(pStore, pSample, pLocation, pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpCurrent = tmpOptions.CurrentLocations || await pStore.getSampleLocations(pSample.IDSample);
	if (!Array.isArray(tmpCurrent))
	{
		throw new Error('could not read where the sample is now');
	}
	const tmpPrevious = [];
	for (const tmpJoin of tmpCurrent)
	{
		const tmpIDLocation = tmpJoin && tmpJoin.IDLocation;
		if (tmpIDLocation && (tmpIDLocation !== pLocation.IDLocation) && !tmpPrevious.includes(tmpIDLocation))
		{
			tmpPrevious.push(tmpIDLocation);
		}
	}
	const tmpPreviousStatus = pSample.Status || '';

	await pStore.addSampleToLocation(pSample.IDSample, pLocation.IDLocation);
	if (tmpOptions.RemoveFromCurrentLocation !== false)
	{
		for (const tmpIDLocation of tmpPrevious)
		{
			await pStore.removeSampleFromLocation(pSample.IDSample, tmpIDLocation);
		}
	}

	const tmpDecision = tmpOptions.ReceiveConfig ? libSampleScanStatus.getStatusForMove(tmpOptions.ReceiveConfig, pLocation, tmpPreviousStatus) : { Status: '' };
	if (tmpDecision.Status)
	{
		await pStore.setSampleStatus(pSample.IDSample, tmpDecision.Status);
	}

	// The log says where the sample came from: the other locations it was in (newest first), not this one.
	let tmpNotes = tmpOptions.Notes;
	if (typeof tmpNotes !== 'string')
	{
		const fNotes = (typeof tmpNotes === 'function') ? tmpNotes : defaultNotes;
		tmpNotes = fNotes({ To: String(pLocation.Name || pLocation.IDLocation), From: joinNames(await locationNames(pStore, tmpPrevious, tmpOptions.Locations)) });
	}

	const tmpPosition = tmpOptions.Position || {};
	await pStore.createSampleLog(
		{
			IDSample: pSample.IDSample,
			IDLocation: pLocation.IDLocation,
			CaptureLatitude: tmpPosition.CaptureLatitude,
			CaptureLongitude: tmpPosition.CaptureLongitude,
			FromStatus: tmpDecision.Status ? tmpPreviousStatus : undefined,
			ToStatus: tmpDecision.Status || undefined,
			Notes: tmpNotes,
		});

	return { PreviousIDLocations: tmpPrevious, PreviousStatus: tmpPreviousStatus, StatusDecision: tmpDecision };
}

module.exports =
{
	moveSampleToLocation,
	joinNames,
};

},{"./Sample-Scan-Status.js":298}],297:[function(require,module,exports){
/**
 * The printable action cards Scan Samples understands. Their payloads are on labels already in use, so they
 * never change; only the wording printed under the code can.
 */

/**
 * @typedef {Object} ActionCard
 * @property {string} Hash
 * @property {string} Payload - What the QR code holds.
 * @property {string} Label - Button text, e.g. `Print "Move All" Code`.
 * @property {string} Footer - Printed under the code.
 * @property {string} Description - What scanning it does.
 * @property {string} Icon - Font Awesome class.
 */

/** @type {Array<ActionCard>} */
const ACTION_CARDS =
[
	{ Hash: 'collect', Payload: 'action/open/cart', Label: 'Print "Move Together" Code', Footer: 'Scan Samples: Move Together', Description: 'Opens Scan Samples and collects scanned samples, to move them together with Move all.', Icon: 'fa-cart-shopping' },
	{ Hash: 'save-each', Payload: 'action/receive/start', Label: 'Print "Save Each Scan" Code', Footer: 'Scan Samples: Save Each Scan', Description: 'Opens Scan Samples and saves each scanned sample to the location straight away.', Icon: 'fa-inbox-in' },
	{ Hash: 'submit', Payload: 'action/submit', Label: 'Print "Move All" Code', Footer: 'Move All / Finish', Description: 'Moves the collected samples to the location (Move all), or finishes a list of saved scans.', Icon: 'fa-cart-shopping-fast' },
	{ Hash: 'clear', Payload: 'action/clear', Label: 'Print "Clear" Code', Footer: 'Clear Scanned Samples', Description: 'Clears the scanned samples from the list.', Icon: 'fa-cart-circle-xmark' },
];

module.exports =
{
	ACTION_CARDS,
};

},{}],298:[function(require,module,exports){
/**
 * The status a sample takes when it is moved into a location, from the customer's `QRCodes` / `Receive` configuration:
 *
 *     { "StatusByLocation": { "<location QR code or GUID>": "RECV" }, "OnlySetFrom": [ "", "LOGD", "PEND" ] }
 *
 * `OnlySetFrom` lists the statuses a sample may be in for the location's status to apply ("" is no status), so
 * scanning a tested sample at a reception desk can't send it back to received. Without it, only samples with no
 * status yet are changed.
 */

const DEFAULT_ONLY_SET_FROM = [ '' ];

/**
 * @typedef {{ StatusByLocation?: Record<string, string>, OnlySetFrom?: Array<string> }} ReceiveConfig
 */

/**
 * @param {any} pStatus
 * @return {string}
 */
function normalizeStatus(pStatus)
{
	return String(pStatus ?? '').trim().toUpperCase();
}

/**
 * @param {ReceiveConfig} pConfig
 * @param {{ QRCode?: string, GUIDLocation?: string }} pLocation
 * @return {string} the status configured for the location, or ''
 */
function getConfiguredStatus(pConfig, pLocation)
{
	const tmpMap = (pConfig && pConfig.StatusByLocation && typeof pConfig.StatusByLocation === 'object') ? pConfig.StatusByLocation : {};
	if (!pLocation)
	{
		return '';
	}
	return String((pLocation.QRCode && tmpMap[pLocation.QRCode]) || (pLocation.GUIDLocation && tmpMap[pLocation.GUIDLocation]) || '');
}

/**
 * What to do with a sample's status when it is moved into a location.
 *
 * @param {ReceiveConfig} pConfig
 * @param {{ QRCode?: string, GUIDLocation?: string }} pLocation
 * @param {string} pCurrentStatus
 * @return {{ Status: string, Kept?: string }} Status is the one to set ('' for no change); Kept is the current
 *   status when the location has one configured but the sample is past the point where it applies.
 */
function getStatusForMove(pConfig, pLocation, pCurrentStatus)
{
	const tmpStatus = getConfiguredStatus(pConfig, pLocation);
	const tmpCurrent = normalizeStatus(pCurrentStatus);
	if (!tmpStatus || normalizeStatus(tmpStatus) === tmpCurrent)
	{
		return { Status: '' };
	}
	const tmpAllowed = (Array.isArray(pConfig?.OnlySetFrom) ? pConfig.OnlySetFrom : DEFAULT_ONLY_SET_FROM).map(normalizeStatus);
	if (!tmpAllowed.includes(tmpCurrent))
	{
		return { Status: '', Kept: String(pCurrentStatus) };
	}
	return { Status: tmpStatus };
}

module.exports =
{
	DEFAULT_ONLY_SET_FROM,
	getConfiguredStatus,
	getStatusForMove,
};

},{}],299:[function(require,module,exports){
/**
 * Reads and writes for sample scanning, through the host app's own providers so a move here is the same
 * move as anywhere else in the app (LocationProvider also keeps the sample's storage location current).
 *
 * A host can pass its own store with the same methods instead (tests do).
 */

/**
 * @typedef {Object} SampleScanStore
 * @property {() => Promise<Array<Object>>} listLocations - The customer's locations.
 * @property {(pIDLocation: number) => Promise<Object|null>} getLocation
 * @property {(pIDSample: number) => Promise<Array<{ IDLocation: number }>|null>} getSampleLocations - Where the sample is now, newest first; null when it can't be read.
 * @property {(pIDSample: number, pIDLocation: number) => Promise<any>} addSampleToLocation
 * @property {(pIDSample: number, pIDLocation: number) => Promise<any>} removeSampleFromLocation
 * @property {(pIDSample: number, pStatus: string) => Promise<void>} setSampleStatus - Writes only the status.
 * @property {(pLog: Object) => Promise<any>} createSampleLog
 * @property {() => Promise<{ CaptureLatitude?: number, CaptureLongitude?: number }|null>} getPosition - Never prompts.
 * @property {() => Promise<Object|null>} readReceiveConfig - `QRCodes` / `Receive`; null when it can't be read.
 */

class AppSampleScanStore
{
	/**
	 * @param {any} pPict
	 */
	constructor(pPict)
	{
		this.pict = pPict;
	}

	/**
	 * @param {string} pURL
	 * @return {Promise<any>} the body, or null on error
	 */
	getJSON(pURL)
	{
		return new Promise((fResolve) =>
		{
			this.pict.HeadlightRestClient.getJSON(pURL, (pError, pBody) => fResolve(pError ? null : pBody));
		});
	}

	async listLocations()
	{
		const tmpCached = this.pict.AppData && this.pict.AppData.Locations;
		if (Array.isArray(tmpCached) && tmpCached.length)
		{
			return tmpCached;
		}
		return this.pict.providers.LocationProvider.getAllLocations().catch(() => []);
	}

	getLocation(pIDLocation)
	{
		return this.pict.providers.LocationProvider.getLocationByID(Number(pIDLocation));
	}

	/**
	 * The sample's location joins, newest first; null when they can't be read.
	 * @param {number} pIDSample
	 * @return {Promise<Array<{ IDSampleLocationJoin: number, IDLocation: number }>|null>}
	 */
	async getSampleLocations(pIDSample)
	{
		const tmpBody = await this.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${Number(pIDSample)}~FSF~CreateDate~DESC~0`);
		return Array.isArray(tmpBody) ? tmpBody : null;
	}

	addSampleToLocation(pIDSample, pIDLocation)
	{
		return this.pict.providers.LocationProvider.addSampleToLocation(pIDSample, pIDLocation);
	}

	removeSampleFromLocation(pIDSample, pIDLocation)
	{
		return this.pict.providers.LocationProvider.removeSamplefromLocation(pIDSample, pIDLocation);
	}

	setSampleStatus(pIDSample, pStatus)
	{
		return new Promise((fResolve, fReject) =>
		{
			this.pict.HeadlightRestClient.putJSON('Sample', { IDSample: pIDSample, Status: pStatus }, (pError) =>
			{
				if (pError)
				{
					return fReject(pError);
				}
				fResolve();
			});
		});
	}

	createSampleLog(pLog)
	{
		return this.pict.providers.SampleLogProvider.createSampleLog(pLog);
	}

	async getPosition()
	{
		const tmpGeo = this.pict.providers.GeoProvider;
		if (!tmpGeo)
		{
			return null;
		}
		return tmpGeo.getGeoCoords({ NoPrompt: true }).catch(() => null);
	}

	readReceiveConfig()
	{
		return this.getJSON('Configuration/For/QRCodes/Receive');
	}
}

module.exports = AppSampleScanStore;

},{}],300:[function(require,module,exports){
/**
 * Scan Samples: move scanned samples into a location, either as each one is scanned (with Undo) or
 * collected and moved together. The location can be picked or scanned, and remembered on the device.
 *
 * The provider holds the state and does the writes; the `SampleScanning` view draws it into whatever
 * container the host gives it. Scans come from a `HeadlightQR` provider (`listen`, or `handleResolution` for one
 * resolution) or plain `handleScan` calls.
 */

const libPictProvider = require('pict-provider');
const libSampleScanStatus = require('../Sample-Scan-Status.js');
const libSampleMove = require('../Sample-Move.js');
const AppSampleScanStore = require('../Sample-Scan-Store.js');

const STORAGE_PREFIX = 'HeadlightScan-';
// Check Samples into Lab: the status every collected sample takes, and the log entry each one gets.
const RECEIVED_STATUS = 'RECV';
const RECEIVED_NOTES = 'Sample received at lab.';

/**
 * @typedef {Object} SampleScanHost
 * @property {(pToast: { message: string, type: 'is-info'|'is-success'|'is-warning'|'is-danger' }) => void} [notify]
 * @property {(pSample: Object) => any} [printLabel] - Shows a print button on collected samples.
 * @property {{ toggle: (pContainerID: string) => Promise<boolean>, isOpen: () => boolean }} [camera] - Shows the camera button.
 * @property {(pMove: { Location: Object, Moved: Array<Object>, Failed: Array<Object>, Via: 'move-all'|'scan' }) => void} [moved] -
 *     Called after samples are moved (Move all, or a scan saved right away), with the samples moved and any that could not be.
 * @property {(pMark: { Received: Array<Object>, Failed: Array<Object> }) => void} [received] - Called after Mark Samples
 *     Received, with the samples set to RECV and any that could not be.
 */

/**
 * @typedef {Object} SampleScan
 * @property {'Sample'|'Location'|'Action'|'Deleted'|'NotFound'} Kind
 * @property {string} [Entity] - For Deleted.
 * @property {Object} [Record] - The sample or location.
 * @property {'collect'|'save-each'|'submit'|'clear'} [Action]
 */

/**
 * @typedef {Object} ReceivedRow
 * @property {Object} Sample
 * @property {'working'|'ok'|'warn'|'error'|'undone'} State
 * @property {string} Message
 * @property {number} [IDLocation]
 * @property {Array<number>} [PreviousIDLocations]
 * @property {string} [PreviousStatus]
 * @property {string} [NewStatus]
 */

const _DefaultOptions =
{
	ProviderIdentifier: 'SampleScanning',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	// A move replaces the sample's current location; false keeps adding locations instead.
	RemoveFromCurrentLocation: true,
	// The view this provider draws with, and the prefix of the element IDs it uses. A second cart (attachInstance)
	// uses its own name for both, so it can be open beside the panels' Scan Samples.
	ViewHash: 'SampleScanning',
	IDPrefix: 'SampleScanning',
	// How this cart names itself to HeadlightQR while it listens.
	ScanHandlerHash: 'sample-scanning',
};

class SampleScanningProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultOptions, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
		/** @type {import('../Sample-Scan-Store.js').SampleScanStore} */
		this.store = (pOptions && pOptions.Store) || new AppSampleScanStore(this.pict);
		/** @type {{ getItem: (pKey: string) => string|null, setItem: (pKey: string, pValue: string) => void, removeItem: (pKey: string) => void }|null} */
		this.storage = (pOptions && pOptions.Storage) || null;
		/** @type {SampleScanHost} */
		this.host = {};
		/** Samples collected while "Save each scan right away" is off. */
		this.samples = [];
		/** @type {Array<number>} collected samples the user can't take out of the list (keepSample) */
		this.keptSampleIDs = [];
		/** @type {Object|null} the only location this session moves samples into (fixLocation) */
		this.fixedLocation = null;
		/** Check Samples into Lab is running. */
		this.markingReceived = false;
		/** @type {ReceivedRow[]} scans saved straight away, newest first */
		this.received = [];
		this.location = null;
		this.saveEachScan = false;
		this.rememberLocation = false;
		/** @type {Array<Object>|null} */
		this.locations = null;
		this._locationsLoading = null;
		/** @type {import('../Sample-Scan-Status.js').ReceiveConfig|null} */
		this.receiveConfig = null;
		this._receiveConfigLoading = null;
	}

	/**
	 * Wire the host's messages, label printing and camera. Call before open().
	 * @param {SampleScanHost} pHost
	 */
	connect(pHost)
	{
		this.host = pHost || {};
	}

	// ---- Lifecycle ------------------------------------------------------------

	/**
	 * Start a fresh scanning session.
	 * @param {Object} [pOptions]
	 * @param {boolean} [pOptions.SaveEachScan] - Left out, the device's last setting is kept.
	 * @param {string} [pOptions.DestinationAddress] - Where the view draws; defaults to the view's own.
	 */
	open(pOptions)
	{
		const tmpOptions = pOptions || {};
		this.samples = [];
		this.keptSampleIDs = [];
		this.fixedLocation = null;
		this.received = [];
		this.restoreDeviceSettings();
		if (typeof tmpOptions.SaveEachScan === 'boolean')
		{
			this.setSaveEachScan(tmpOptions.SaveEachScan, true);
		}
		this.loadLocations().then(() => this.refresh());
		this.loadReceiveConfig().then(() => this.refresh());
		const tmpView = this.view;
		if (tmpView)
		{
			tmpView.renderShell(tmpOptions.DestinationAddress);
		}
	}

	close()
	{
		this.stopListening();
		this.samples = [];
		this.keptSampleIDs = [];
		this.received = [];
		if (this.fixedLocation)
		{
			// A fixed location belonged to that session (a page's own location), never to the next one.
			this.fixedLocation = null;
			this.location = null;
		}
		this.forgetLocation();
	}

	/** After a finish, clear or Move all: drop the location, unless it is remembered on the device or fixed. */
	forgetLocation()
	{
		if (!this.rememberLocation && !this.fixedLocation)
		{
			this.location = null;
		}
	}

	/** @return {any} the view this provider draws with */
	get view()
	{
		return this.pict.views[this.options.ViewHash];
	}

	/** Redraw the settings and lists (not the camera). */
	refresh()
	{
		const tmpView = this.view;
		if (tmpView)
		{
			tmpView.renderBody();
		}
	}

	/**
	 * @param {string} pMessage
	 * @param {'is-info'|'is-success'|'is-warning'|'is-danger'} pType
	 */
	notify(pMessage, pType)
	{
		if (typeof this.host.notify === 'function')
		{
			this.host.notify({ message: pMessage, type: pType });
			return;
		}
		this.log.info(`[SampleScanning] ${pMessage}`);
	}

	// ---- Device settings ------------------------------------------------------

	/** @return {string} */
	get storageScope()
	{
		const tmpUser = (this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return String(tmpUser.CustomerID || tmpUser.IDCustomer || 'default');
	}

	/**
	 * @return {{ getItem: Function, setItem: Function, removeItem: Function }|null}
	 */
	getStorage()
	{
		if (this.storage)
		{
			return this.storage;
		}
		try
		{
			return (typeof window !== 'undefined' && window.localStorage) ? window.localStorage : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * @param {string} pKey
	 * @return {string|null}
	 */
	readSetting(pKey)
	{
		try
		{
			const tmpStorage = this.getStorage();
			return tmpStorage ? tmpStorage.getItem(`${STORAGE_PREFIX}${pKey}`) : null;
		}
		catch (pError)
		{
			return null;
		}
	}

	/**
	 * @param {string} pKey
	 * @param {string|null} pValue - null removes the setting
	 */
	writeSetting(pKey, pValue)
	{
		try
		{
			const tmpStorage = this.getStorage();
			if (!tmpStorage)
			{
				return;
			}
			if (pValue === null)
			{
				tmpStorage.removeItem(`${STORAGE_PREFIX}${pKey}`);
			}
			else
			{
				tmpStorage.setItem(`${STORAGE_PREFIX}${pKey}`, pValue);
			}
		}
		catch (pError)
		{
			// Private windows can refuse storage; the settings then last for this visit only.
		}
	}

	restoreDeviceSettings()
	{
		this.saveEachScan = (this.readSetting('SaveEachScan') === '1');
		const tmpRemembered = this.readSetting(`Location-${this.storageScope}`);
		this.rememberLocation = !!tmpRemembered;
		if (!tmpRemembered || (this.location && String(this.location.IDLocation) === tmpRemembered))
		{
			return;
		}
		const tmpFromList = (this.locations || []).find((pLocation) => String(pLocation.IDLocation) === tmpRemembered);
		if (tmpFromList)
		{
			this.location = tmpFromList;
			return;
		}
		Promise.resolve(this.store.getLocation(Number(tmpRemembered))).then((pLocation) =>
		{
			if (pLocation && pLocation.IDLocation && !this.location)
			{
				this.location = pLocation;
				this.refresh();
			}
		}).catch(() =>
		{
			this.writeSetting(`Location-${this.storageScope}`, null);
		});
	}

	/**
	 * @param {boolean} pOn
	 * @param {boolean} [pSkipRefresh]
	 */
	setSaveEachScan(pOn, pSkipRefresh)
	{
		this.saveEachScan = !!pOn;
		this.writeSetting('SaveEachScan', this.saveEachScan ? '1' : '0');
		if (!pSkipRefresh)
		{
			this.refresh();
		}
	}

	/**
	 * @param {boolean} pOn
	 */
	setRememberLocation(pOn)
	{
		if (this.fixedLocation)
		{
			return;
		}
		this.rememberLocation = !!pOn;
		this.writeSetting(`Location-${this.storageScope}`, (this.rememberLocation && this.location && this.location.IDLocation) ? String(this.location.IDLocation) : null);
		this.refresh();
	}

	// ---- Locations and configuration ------------------------------------------

	/** @return {Promise<Array<Object>>} */
	loadLocations()
	{
		if (this.locations)
		{
			return Promise.resolve(this.locations);
		}
		if (!this._locationsLoading)
		{
			this._locationsLoading = Promise.resolve(this.store.listLocations()).catch(() => []).then((pLocations) =>
			{
				this.locations = Array.isArray(pLocations) ? pLocations : [];
				this._locationsLoading = null;
				return this.locations;
			});
		}
		return this._locationsLoading;
	}

	/** @return {Promise<import('../Sample-Scan-Status.js').ReceiveConfig>} empty when there is none */
	loadReceiveConfig()
	{
		if (this.receiveConfig)
		{
			return Promise.resolve(this.receiveConfig);
		}
		if (!this._receiveConfigLoading)
		{
			this._receiveConfigLoading = Promise.resolve(this.store.readReceiveConfig()).catch(() => null).then((pConfig) =>
			{
				this._receiveConfigLoading = null;
				// Only a successful read is kept, so a network blip doesn't switch status updates off for the session.
				if (pConfig)
				{
					this.receiveConfig = (typeof pConfig === 'object') ? pConfig : {};
				}
				return pConfig || {};
			});
		}
		return this._receiveConfigLoading;
	}

	/**
	 * Use a location for the scans that follow.
	 * @param {Object|null} pLocation
	 */
	setLocation(pLocation)
	{
		if (this.fixedLocation)
		{
			return;
		}
		this.location = pLocation || null;
		if (this.rememberLocation)
		{
			this.writeSetting(`Location-${this.storageScope}`, (this.location && this.location.IDLocation) ? String(this.location.IDLocation) : null);
		}
		this.refresh();
	}

	/**
	 * Move samples only into this location for the rest of the session (e.g. a location's own page adding samples to
	 * it): the picker, a scanned location and the remember switch can't change it, and finishing keeps it.
	 * @param {Object} pLocation
	 */
	fixLocation(pLocation)
	{
		if (!pLocation || !pLocation.IDLocation)
		{
			return;
		}
		this.fixedLocation = null;
		this.setLocation(pLocation);
		this.fixedLocation = pLocation;
	}

	/**
	 * @param {string|number} pIDLocation - from the picker; empty clears the location
	 */
	pickLocation(pIDLocation)
	{
		const tmpLocation = (this.locations || []).find((pLocation) => String(pLocation.IDLocation) === String(pIDLocation));
		this.setLocation(tmpLocation || null);
	}

	/** @return {string} the status samples moved into the current location take, or '' */
	get locationStatus()
	{
		return this.location ? libSampleScanStatus.getConfiguredStatus(this.receiveConfig || {}, this.location) : '';
	}

	// ---- Scans ----------------------------------------------------------------

	/**
	 * @param {SampleScan} pScan
	 * @return {Promise<void>}
	 */
	async handleScan(pScan)
	{
		const tmpScan = pScan || { Kind: 'NotFound' };
		if (tmpScan.Kind === 'Action')
		{
			if (tmpScan.Action === 'save-each' || tmpScan.Action === 'collect')
			{
				this.setSaveEachScan(tmpScan.Action === 'save-each');
			}
			else if (tmpScan.Action === 'submit')
			{
				if (this.samples.length)
				{
					await this.moveAll();
				}
				else
				{
					this.finish();
				}
			}
			else if (tmpScan.Action === 'clear')
			{
				this.clear();
			}
			return;
		}
		if (tmpScan.Kind === 'Location' && tmpScan.Record && tmpScan.Record.IDLocation)
		{
			if (this.fixedLocation)
			{
				if (Number(tmpScan.Record.IDLocation) !== Number(this.fixedLocation.IDLocation))
				{
					this.notify(`Samples here can only go into ${this.fixedLocation.Name || 'this location'}.`, 'is-warning');
				}
				return;
			}
			if (!this.location || this.location.IDLocation !== tmpScan.Record.IDLocation)
			{
				this.setLocation(tmpScan.Record);
			}
			return;
		}
		if (tmpScan.Kind === 'Sample' && tmpScan.Record && tmpScan.Record.IDSample)
		{
			if (this.saveEachScan)
			{
				await this.receiveSample(tmpScan.Record);
			}
			else if (!this.samples.some((pSample) => pSample.IDSample === tmpScan.Record.IDSample))
			{
				this.samples.push(tmpScan.Record);
				this.refresh();
			}
			return;
		}
		if (tmpScan.Kind === 'Deleted')
		{
			this.notify(`That ${String(tmpScan.Entity || 'record').toLowerCase()} was deleted.`, 'is-warning');
			return;
		}
		this.notify('Nothing found for that code.', 'is-warning');
	}

	/**
	 * Take scans from a `HeadlightQR` provider while the panel is open: samples, locations (raw codes too) and the
	 * Scan Samples action cards. The keyboard scanner is held on meanwhile, even in apps that leave it off (forms).
	 * Safe to call again; the previous registration is replaced.
	 * @param {any} pHeadlightQR
	 */
	listen(pHeadlightQR)
	{
		this.stopListening();
		if (!pHeadlightQR || typeof pHeadlightQR.pushScanHandler !== 'function')
		{
			return;
		}
		this._removeScanHandler = pHeadlightQR.pushScanHandler(
			{
				Hash: this.options.ScanHandlerHash,
				Mode: 'Session',
				Label: 'Scan Samples',
				Workflows: [ 'cart', 'receive' ],
				Accept: [ 'Sample', 'Location' ],
				RawEntities: [ 'Sample', 'Location' ],
				onScan: (pResolution) =>
				{
					// Not awaited: a move can take seconds, and the scan's tone shouldn't wait for it.
					this.handleResolution(pResolution).catch((pError) => this.log.error(`Scan Samples could not handle a scan: ${(pError && pError.message) || pError}`));
					return true;
				},
			});
		this._releaseWedge = (typeof pHeadlightQR.holdWedge === 'function') ? pHeadlightQR.holdWedge() : null;
	}

	stopListening()
	{
		if (this._removeScanHandler)
		{
			this._removeScanHandler();
			this._removeScanHandler = null;
		}
		if (this._releaseWedge)
		{
			this._releaseWedge();
			this._releaseWedge = null;
		}
	}

	/**
	 * A `HeadlightQR` resolution.
	 * @param {{ Status: string, Entity?: string, Record?: Object, Decoded?: any }} pResolution
	 * @return {Promise<void>}
	 */
	handleResolution(pResolution)
	{
		return this.handleScan(SampleScanningProvider.fromResolution(pResolution));
	}

	/**
	 * @param {{ Status: string, Entity?: string, Record?: Object, Decoded?: any }} pResolution
	 * @return {SampleScan}
	 */
	static fromResolution(pResolution)
	{
		const tmpResolution = pResolution || { Status: '' };
		if (tmpResolution.Status === 'Found' && (tmpResolution.Entity === 'Sample' || tmpResolution.Entity === 'Location'))
		{
			return { Kind: tmpResolution.Entity, Record: tmpResolution.Record };
		}
		if (tmpResolution.Status === 'Action' && tmpResolution.Decoded)
		{
			const tmpWorkflow = String(tmpResolution.Decoded.Workflow || '').toLowerCase();
			const tmpVerb = String(tmpResolution.Decoded.Verb || '').toLowerCase();
			if (tmpWorkflow === 'receive')
			{
				return { Kind: 'Action', Action: 'save-each' };
			}
			if (tmpWorkflow === 'cart' && tmpVerb === 'submit')
			{
				return { Kind: 'Action', Action: 'submit' };
			}
			if (tmpWorkflow === 'cart' && tmpVerb === 'clear')
			{
				return { Kind: 'Action', Action: 'clear' };
			}
			if (tmpWorkflow === 'cart')
			{
				return { Kind: 'Action', Action: 'collect' };
			}
		}
		if (tmpResolution.Status === 'Deleted')
		{
			return { Kind: 'Deleted', Entity: tmpResolution.Entity, Record: tmpResolution.Record };
		}
		return { Kind: 'NotFound' };
	}

	// ---- Moves ----------------------------------------------------------------

	/**
	 * Move one sample into the location now, with any status the location sets.
	 * @param {Object} pSample
	 * @return {Promise<ReceivedRow|null>}
	 */
	async receiveSample(pSample)
	{
		const tmpLocation = this.location;
		if (!tmpLocation || !tmpLocation.IDLocation)
		{
			const tmpWarning = { Sample: pSample, State: 'warn', Message: 'Not saved: choose or scan a location first.' };
			this.received.unshift(tmpWarning);
			this.refresh();
			return tmpWarning;
		}
		const tmpExisting = this.received.find((pRow) => pRow.Sample.IDSample === pSample.IDSample && pRow.State === 'ok');
		if (tmpExisting && tmpExisting.IDLocation === tmpLocation.IDLocation)
		{
			this.notify(`${pSample.Name || pSample.QRCode} is already in ${tmpLocation.Name}.`, 'is-warning');
			return null;
		}
		/** @type {ReceivedRow} */
		const tmpRow = { Sample: pSample, State: 'working', Message: `Moving into ${tmpLocation.Name}…`, IDLocation: tmpLocation.IDLocation };
		this.received.unshift(tmpRow);
		this.refresh();
		try
		{
			const tmpPosition = await this.store.getPosition();
			const tmpMove = await libSampleMove.moveSampleToLocation(this.store, pSample, tmpLocation,
				{
					RemoveFromCurrentLocation: this.options.RemoveFromCurrentLocation,
					ReceiveConfig: await this.loadReceiveConfig(),
					Position: tmpPosition,
					Locations: await this.loadLocations(),
					Notes: SampleScanningProvider.receivedNotes,
				});
			tmpRow.PreviousIDLocations = tmpMove.PreviousIDLocations;
			tmpRow.PreviousStatus = tmpMove.PreviousStatus;
			tmpRow.NewStatus = tmpMove.StatusDecision.Status || undefined;
			tmpRow.State = 'ok';
			tmpRow.Message = `Moved into ${tmpLocation.Name}${SampleScanningProvider.describeStatusChange(tmpMove.StatusDecision)}.`;
		}
		catch (pError)
		{
			this.log.error(`Could not receive sample ${pSample.IDSample} into location ${tmpLocation.IDLocation}: ${(pError && pError.message) || pError}`);
			tmpRow.State = 'error';
			tmpRow.Message = 'Could not be moved. Scan it again to retry.';
		}
		this.refresh();
		this.reportMoved(tmpLocation, (tmpRow.State === 'ok') ? [ pSample ] : [], (tmpRow.State === 'ok') ? [] : [ pSample ], 'scan');
		return tmpRow;
	}

	/**
	 * The log entry for a scan saved right away.
	 * @param {{ To: string, From: string }} pMove - From is '' when the sample wasn't in a location
	 * @return {string}
	 */
	static receivedNotes(pMove)
	{
		return pMove.From ? `Sample received from ${pMove.From} into ${pMove.To}` : `Sample received into ${pMove.To}`;
	}

	/**
	 * The log entry for Move all (the panels' cart and a sample's Location tab).
	 * @param {{ To: string, From: string }} pMove - From is '' when the sample wasn't in a location
	 * @return {string}
	 */
	static movedNotes(pMove)
	{
		return pMove.From ? `Sample Location updated from ${pMove.From} to ${pMove.To}` : `Sample Location updated to ${pMove.To}`;
	}

	/**
	 * @param {{ Status: string, Kept?: string }} pStatus
	 * @return {string}
	 */
	static describeStatusChange(pStatus)
	{
		if (pStatus.Status)
		{
			return `; status set to ${pStatus.Status}`;
		}
		if (pStatus.Kept)
		{
			return `; status left as ${pStatus.Kept}`;
		}
		return '';
	}

	/**
	 * Put a moved sample back where it was, with its previous status.
	 * @param {number} pIDSample
	 * @return {Promise<void>}
	 */
	async undoReceive(pIDSample)
	{
		const tmpRow = this.received.find((pRow) => pRow.Sample.IDSample === Number(pIDSample) && pRow.State === 'ok');
		if (!tmpRow)
		{
			return;
		}
		tmpRow.State = 'working';
		tmpRow.Message = 'Undoing…';
		this.refresh();
		try
		{
			const tmpPrevious = (tmpRow.PreviousIDLocations || []).slice().reverse();
			for (const tmpIDLocation of tmpPrevious)
			{
				await this.store.addSampleToLocation(tmpRow.Sample.IDSample, tmpIDLocation);
			}
			if (!tmpPrevious.includes(tmpRow.IDLocation))
			{
				await this.store.removeSampleFromLocation(tmpRow.Sample.IDSample, tmpRow.IDLocation);
			}
			if (tmpRow.NewStatus)
			{
				await this.store.setSampleStatus(tmpRow.Sample.IDSample, tmpRow.PreviousStatus);
			}
			await this.store.createSampleLog(
				{
					IDSample: tmpRow.Sample.IDSample,
					IDLocation: tmpPrevious[tmpPrevious.length - 1],
					FromStatus: tmpRow.NewStatus || undefined,
					ToStatus: tmpRow.NewStatus ? tmpRow.PreviousStatus : undefined,
					Notes: 'Receive undone',
				});
			tmpRow.State = 'undone';
			tmpRow.Message = 'Undone: back where it was.';
		}
		catch (pError)
		{
			this.log.error(`Could not undo receiving sample ${tmpRow.Sample.IDSample}: ${(pError && pError.message) || pError}`);
			tmpRow.State = 'error';
			tmpRow.Message = 'Undo failed. Check the sample\'s location before trying again.';
		}
		this.refresh();
	}

	/** Clear the list of saved scans. Each one was already saved, so nothing is written. */
	finish()
	{
		const tmpCount = this.received.filter((pRow) => pRow.State === 'ok').length;
		if (this.received.length > 0)
		{
			this.notify(`Moved ${tmpCount} sample${tmpCount === 1 ? '' : 's'}.`, 'is-success');
		}
		this.received = [];
		this.forgetLocation();
		this.refresh();
	}

	/**
	 * Collect a sample the user can't take out of the list (no remove button, and Clear leaves it), e.g. the sample
	 * a page is about when it opens the cart to move that sample. It still moves with Move all.
	 * @param {Object} pSample
	 */
	keepSample(pSample)
	{
		if (!pSample || !pSample.IDSample)
		{
			return;
		}
		const tmpIDSample = Number(pSample.IDSample);
		if (!this.keptSampleIDs.includes(tmpIDSample))
		{
			this.keptSampleIDs.push(tmpIDSample);
		}
		if (!this.samples.some((pCollected) => Number(pCollected.IDSample) === tmpIDSample))
		{
			this.samples.push(pSample);
		}
		this.refresh();
	}

	/**
	 * @param {number|string} pIDSample
	 * @return {boolean} whether the sample is one the user can't take out of the list
	 */
	isKept(pIDSample)
	{
		return this.keptSampleIDs.includes(Number(pIDSample));
	}

	/**
	 * @param {number} pIDSample - a kept sample stays
	 */
	removeSample(pIDSample)
	{
		if (this.isKept(pIDSample))
		{
			return;
		}
		this.samples = this.samples.filter((pSample) => pSample.IDSample !== Number(pIDSample));
		this.refresh();
	}

	/** Clear the collected samples (all but the kept ones) and the list of saved scans. */
	clear()
	{
		this.forgetLocation();
		this.samples = this.samples.filter((pSample) => this.isKept(pSample.IDSample));
		this.received = [];
		this.refresh();
	}

	/**
	 * Move every collected sample into the location.
	 * @return {Promise<void>}
	 */
	async moveAll()
	{
		if (!this.location || !this.location.IDLocation || !this.samples.length)
		{
			if (this.samples.length)
			{
				this.notify('Choose or scan a location first.', 'is-warning');
			}
			this.refresh();
			return;
		}
		const tmpLocation = this.location;
		this.notify(`Moving ${this.samples.length} sample${this.samples.length === 1 ? '' : 's'} to ${tmpLocation.Name}…`, 'is-info');
		const tmpPosition = (await this.store.getPosition()) || {};
		const tmpReceiveConfig = await this.loadReceiveConfig();
		const tmpLocations = await this.loadLocations();
		const tmpFailed = [];
		let tmpStatusCount = 0;
		for (const tmpSample of this.samples)
		{
			try
			{
				const tmpMove = await libSampleMove.moveSampleToLocation(this.store, tmpSample, tmpLocation,
					{
						RemoveFromCurrentLocation: this.options.RemoveFromCurrentLocation,
						ReceiveConfig: tmpReceiveConfig,
						Position: { CaptureLatitude: tmpPosition.CaptureLatitude || tmpSample.CaptureLatitude, CaptureLongitude: tmpPosition.CaptureLongitude || tmpSample.CaptureLongitude },
						Locations: tmpLocations,
						Notes: SampleScanningProvider.movedNotes,
					});
				if (tmpMove.StatusDecision.Status)
				{
					tmpStatusCount++;
				}
			}
			catch (pError)
			{
				this.log.error(`Could not move sample ${tmpSample.IDSample} to location ${tmpLocation.IDLocation}: ${(pError && pError.message) || pError}`);
				tmpFailed.push(tmpSample);
			}
		}
		const tmpMovedCount = this.samples.length - tmpFailed.length;
		const tmpMoved = this.samples.filter((pSample) => !tmpFailed.includes(pSample));
		// Moved samples leave the list, so a second Move all can't move them again; failures stay to retry.
		this.samples = tmpFailed;
		const tmpStatusNote = tmpStatusCount ? ` (${tmpStatusCount} with a new status)` : '';
		if (tmpFailed.length === 0)
		{
			this.forgetLocation();
			this.notify(`Moved ${tmpMovedCount} sample${tmpMovedCount === 1 ? '' : 's'} to ${tmpLocation.Name}${tmpStatusNote}.`, 'is-success');
		}
		else
		{
			this.notify(`Moved ${tmpMovedCount}${tmpStatusNote}; ${tmpFailed.length} could not be moved and are still in the list.`, 'is-danger');
		}
		this.refresh();
		this.reportMoved(tmpLocation, tmpMoved, tmpFailed, 'move-all');
	}

	/**
	 * Check Samples into Lab: set every collected sample to RECV and log "Sample received at lab." on each. The samples
	 * stay collected (their status shows the change), so they can still be moved. A sample that can't be updated is
	 * reported and left as it was.
	 * @return {Promise<void>}
	 */
	async markReceived()
	{
		if (this.markingReceived || !this.samples.length)
		{
			return;
		}
		this.markingReceived = true;
		this.refresh();
		const tmpPosition = (await Promise.resolve(this.store.getPosition()).catch(() => null)) || {};
		const tmpReceived = [];
		const tmpFailed = [];
		for (const tmpSample of this.samples.slice())
		{
			const tmpPreviousStatus = tmpSample.Status || '';
			try
			{
				await this.store.setSampleStatus(tmpSample.IDSample, RECEIVED_STATUS);
				tmpSample.Status = RECEIVED_STATUS;
				await this.store.createSampleLog(
					{
						IDSample: tmpSample.IDSample,
						CaptureLatitude: tmpPosition.CaptureLatitude || tmpSample.CaptureLatitude,
						CaptureLongitude: tmpPosition.CaptureLongitude || tmpSample.CaptureLongitude,
						FromStatus: tmpPreviousStatus,
						ToStatus: RECEIVED_STATUS,
						Notes: RECEIVED_NOTES,
					});
				tmpReceived.push(tmpSample);
			}
			catch (pError)
			{
				this.log.error(`Could not mark sample ${tmpSample.IDSample} received: ${(pError && pError.message) || pError}`);
				tmpFailed.push(tmpSample);
			}
		}
		this.markingReceived = false;
		const tmpCount = tmpReceived.length;
		if (tmpFailed.length === 0)
		{
			this.notify(`Marked ${tmpCount} sample${tmpCount === 1 ? '' : 's'} received.`, 'is-success');
		}
		else
		{
			this.notify(`Marked ${tmpCount} received; ${tmpFailed.length} could not be updated.`, 'is-danger');
		}
		this.refresh();
		if (typeof this.host.received === 'function')
		{
			try
			{
				this.host.received({ Received: tmpReceived, Failed: tmpFailed });
			}
			catch (pError)
			{
				this.log.error(`Scan Samples' host could not handle samples marked received: ${(pError && pError.message) || pError}`);
			}
		}
	}

	/**
	 * Check in and move all: Check Samples into Lab, then Move all into the cart's location, as pressing the two
	 * buttons one after the other would. Needs a location and at least one sample.
	 * @return {Promise<void>}
	 */
	async checkInAndMoveAll()
	{
		if (this.markingReceived || !this.samples.length || !this.location || !this.location.IDLocation)
		{
			return;
		}
		await this.markReceived();
		await this.moveAll();
	}

	/**
	 * Tell the host which samples were just moved, when it asked to know.
	 * @param {Object} pLocation
	 * @param {Array<Object>} pMoved
	 * @param {Array<Object>} pFailed
	 * @param {'move-all'|'scan'} pVia - Move all, or a scan saved right away
	 */
	reportMoved(pLocation, pMoved, pFailed, pVia)
	{
		if (typeof this.host.moved !== 'function')
		{
			return;
		}
		try
		{
			this.host.moved({ Location: pLocation, Moved: pMoved, Failed: pFailed, Via: pVia });
		}
		catch (pError)
		{
			this.log.error(`Scan Samples' host could not handle a move: ${(pError && pError.message) || pError}`);
		}
	}

	/**
	 * @param {number} pIDSample
	 */
	printLabel(pIDSample)
	{
		const tmpSample = this.samples.find((pSample) => pSample.IDSample === Number(pIDSample));
		if (tmpSample && typeof this.host.printLabel === 'function')
		{
			this.host.printLabel(tmpSample);
		}
	}

	/**
	 * Open or close the host's camera in the camera box, showing the box only while the camera is open. The box is
	 * shown before the camera starts, since the scanner sizes its video to it.
	 * @return {Promise<void>}
	 */
	async toggleCamera()
	{
		if (this.host.camera)
		{
			const tmpView = this.view;
			if (tmpView && !this.host.camera.isOpen())
			{
				tmpView.showCamera(true);
			}
			const tmpOpen = await this.host.camera.toggle(`${this.options.IDPrefix}-CameraBox`);
			if (tmpView)
			{
				tmpView.showCamera((typeof tmpOpen === 'boolean') ? tmpOpen : this.host.camera.isOpen());
			}
			this.refresh();
		}
	}
}

module.exports = SampleScanningProvider;
module.exports.default_configuration = _DefaultOptions;
module.exports.RECEIVED_STATUS = RECEIVED_STATUS;
module.exports.RECEIVED_NOTES = RECEIVED_NOTES;

},{"../Sample-Move.js":296,"../Sample-Scan-Status.js":298,"../Sample-Scan-Store.js":299,"pict-provider":552}],301:[function(require,module,exports){
/**
 * Scan Samples, drawn into any container. The shell (with the camera box) is drawn once per session so a
 * running camera survives; the body (location, switches, lists) redraws on every change. The camera box shows only
 * while the camera is open.
 *
 * Colours come from the `--hl-scan-*` variables on `.hl-scan`, which default to the Bulma scheme variables. A host
 * with its own palette sets them, e.g. the panels' dark Scan Samples panel or a workspace tab:
 *
 *     #MyHost .hl-scan { --hl-scan-background: …; --hl-scan-text: …; --hl-scan-text-strong: …; --hl-scan-text-weak: …;
 *         --hl-scan-border: …; --hl-scan-border-weak: …; --hl-scan-head-background: …;
 *         --hl-scan-input-background: …; --hl-scan-input-text: …; --hl-scan-input-border: …; }
 */

const libPictView = require('pict-view');
const libLocationTree = require('../Location-Tree.js');

/**
 * The view's configuration for one cart. The default cart is `SampleScanning`; a second one (the bundle's
 * attachInstance) gets its own provider name and element/template prefix, so both can be on screen at once.
 *
 * @param {string} pProviderHash - the provider the view draws (its buttons reach it through providerRef)
 * @param {string} pPrefix - prefixes the element IDs and template hashes
 * @return {Object}
 */
function buildConfiguration(pProviderHash, pPrefix)
{
	return {
		ViewIdentifier: pPrefix,
		ProviderHash: pProviderHash,
		IDPrefix: pPrefix,
		DefaultRenderable: `${pPrefix}-Shell`,
		DefaultDestinationAddress: `#${pPrefix}-Container`,
		AutoRender: false,
		CSS: /*css*/`
/* The palette; a host overrides these on .hl-scan (see the view's comment). */
.hl-scan {
	--hl-scan-background: var(--bulma-scheme-main);
	--hl-scan-text: var(--bulma-text);
	--hl-scan-text-strong: var(--bulma-text-strong);
	--hl-scan-text-weak: var(--bulma-text-weak);
	--hl-scan-border: var(--bulma-border);
	--hl-scan-border-weak: var(--bulma-border-weak);
	--hl-scan-head-background: var(--bulma-scheme-main-bis);
	--hl-scan-input-background: var(--bulma-scheme-main);
	--hl-scan-input-text: var(--bulma-text-strong);
	--hl-scan-input-border: var(--bulma-border);
}
.hl-scan { background-color: var(--hl-scan-background); color: var(--hl-scan-text); }
.hl-scan .hl-scan-section { padding: 0.75rem; border-bottom: 1px solid var(--hl-scan-border); }
.hl-scan .hl-scan-label { display: block; font-weight: 600; margin-bottom: 0.25rem; color: var(--hl-scan-text-strong); }
.hl-scan .hl-scan-check { display: block; margin-top: 0.5rem; color: var(--hl-scan-text); }
.hl-scan .hl-scan-check:hover { color: var(--hl-scan-text-strong); }
.hl-scan .hl-scan-hint, .hl-scan .hl-scan-muted, .hl-scan .hl-scan-empty { color: var(--hl-scan-text-weak); font-size: 0.8rem; }
.hl-scan .hl-scan-hint { margin-top: 0.25rem; }
.hl-scan .hl-scan-fixed { display: flex; align-items: center; gap: 0.35rem; color: var(--hl-scan-text-strong); }
.hl-scan .hl-scan-hint b, .hl-scan .hl-scan-row b { color: var(--hl-scan-text-strong); }
.hl-scan .hl-scan-empty { padding: 0.75rem; }
.hl-scan .hl-scan-actions { display: flex; gap: 0.5rem; padding: 0.75rem; }
.hl-scan .hl-scan-list-head { display: flex; align-items: center; justify-content: space-between; padding: 0.5rem 0.75rem; font-weight: 600; color: var(--hl-scan-text-strong); background-color: var(--hl-scan-head-background); border-bottom: 1px solid var(--hl-scan-border); }
.hl-scan .hl-scan-row { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--hl-scan-border-weak); }
.hl-scan .hl-scan-row-body { flex-grow: 1; min-width: 0; }
.hl-scan .select select { background-color: var(--hl-scan-input-background); color: var(--hl-scan-input-text); border-color: var(--hl-scan-input-border); }
.hl-scan .select:not(.is-multiple):not(.is-loading)::after { border-color: var(--hl-scan-text-weak); }
.hl-scan .hl-scan-camera { max-height: 50vh; overflow-y: auto; border-bottom: 1px solid var(--hl-scan-border); }
.hl-scan .hl-scan-camera.is-hidden { display: none; }
@media screen and (max-width: 768px) { #${pPrefix}-CameraBox__scan_region > video { max-height: 180px; object-fit: cover; } }
`,
		Templates:
		[
			{
				Hash: `${pPrefix}-Shell`,
				Template: /*html*/`
					<div class="hl-scan">
						<div id="${pPrefix}-Settings"></div>
						<div id="${pPrefix}-Camera" class="hl-scan-camera is-hidden"><div id="${pPrefix}-CameraBox"></div></div>
						<div id="${pPrefix}-Lists"></div>
					</div>`,
			},
			{
				Hash: `${pPrefix}-Settings`,
				Template: /*html*/`{~D:Context[0].settingsHTML~}`,
			},
			{
				Hash: `${pPrefix}-Lists`,
				Template: /*html*/`{~D:Context[0].receivedHTML~}{~D:Context[0].collectedHeadHTML~}{~TS:${pPrefix}-Sample-Item:Context[0].collectedSamples~}`,
			},
			{
				Hash: `${pPrefix}-Sample-Item`,
				Template: /*html*/`
				<div class="hl-scan-row">
					{~D:Record._RemoveButton~}
					<div class="hl-scan-row-body">
						<div><b>{~D:Record.Name~}</b> <span class="hl-scan-muted is-size-7">{~D:Record.QRCode~}</span></div>
						<div class="is-size-7 hl-scan-muted">Status: {~D:Record.Status:None~} · Project: {~Entity:Project^Record.IDProject^${pPrefix}-Item-Project^~}</div>
						<div class="is-size-7 hl-scan-muted">Created {~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~} by {~Entity:User^Record.CreatingIDUser^${pPrefix}-Item-User^~}</div>
					</div>
					{~D:Record._PrintButton~}
				</div>`,
			},
			{
				Hash: `${pPrefix}-Item-User`,
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: `${pPrefix}-Item-Project`,
				Template: /*html*/`{~D:Record.Name~}`,
			},
		],
		Renderables:
		[
			{ RenderableHash: `${pPrefix}-Shell`, TemplateHash: `${pPrefix}-Shell`, RenderMethod: 'replace' },
			{ RenderableHash: `${pPrefix}-Settings`, TemplateHash: `${pPrefix}-Settings`, ContentDestinationAddress: `#${pPrefix}-Settings`, RenderMethod: 'replace' },
			{ RenderableHash: `${pPrefix}-Lists`, TemplateHash: `${pPrefix}-Lists`, ContentDestinationAddress: `#${pPrefix}-Lists`, RenderMethod: 'replace' },
		],
	};
}

const _DefaultConfiguration = buildConfiguration('SampleScanning', 'SampleScanning');

class SampleScanningView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = pOptions || {};
		const tmpProviderHash = tmpOptions.ProviderHash || 'SampleScanning';
		const tmpPrefix = tmpOptions.IDPrefix || tmpProviderHash;
		// A named cart builds its own templates and element IDs from its provider name and prefix. Those win over the
		// options, which pict has already merged the default cart's configuration into.
		const tmpNamed = (tmpProviderHash !== 'SampleScanning') || (tmpPrefix !== 'SampleScanning');
		super(pFable, tmpNamed ?
			Object.assign({}, tmpOptions, buildConfiguration(tmpProviderHash, tmpPrefix)) :
			Object.assign({}, _DefaultConfiguration, tmpOptions), pServiceHash);
		/** @type {any} */
		this.pict;
	}

	/** @return {any} */
	get scanning()
	{
		return this.pict.providers[this.options.ProviderHash];
	}

	/** @return {string} how the view's buttons reach the provider */
	get providerRef()
	{
		return `_Pict.providers['${this.options.ProviderHash}']`;
	}

	/** @return {string} */
	get prefix()
	{
		return this.options.IDPrefix;
	}

	/**
	 * Draw the whole view into a container; called once per session.
	 * @param {string} [pDestinationAddress]
	 */
	renderShell(pDestinationAddress)
	{
		this.render(`${this.prefix}-Shell`, pDestinationAddress || this.options.DefaultDestinationAddress);
		const tmpCamera = this.scanning && this.scanning.host && this.scanning.host.camera;
		this.showCamera(!!(tmpCamera && tmpCamera.isOpen()));
		this.renderBody();
	}

	/**
	 * Show or hide the camera box: shown only while the camera is open.
	 * @param {boolean} pShown
	 */
	showCamera(pShown)
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const tmpCamera = document.getElementById(`${this.prefix}-Camera`);
		if (tmpCamera)
		{
			tmpCamera.classList.toggle('is-hidden', !pShown);
		}
	}

	/** Redraw everything except the camera. */
	renderBody()
	{
		if (typeof document !== 'undefined' && !document.getElementById(`${this.prefix}-Settings`))
		{
			return;
		}
		this.render(`${this.prefix}-Settings`);
		// Async, so the sample rows' project and user names are looked up before they draw.
		this.renderAsync(`${this.prefix}-Lists`, () => {});
	}

	/**
	 * @param {any} pValue
	 * @return {string}
	 */
	escapeHTML(pValue)
	{
		return String(pValue ?? '').replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[pChar]));
	}

	/**
	 * The location picker, remember switch, save-each switch, status hint and camera button.
	 * @return {string}
	 */
	get settingsHTML()
	{
		const tmpScanning = this.scanning;
		const tmpLocation = tmpScanning.location;
		const tmpSelectedID = (tmpLocation && tmpLocation.IDLocation) ? String(tmpLocation.IDLocation) : '';
		const tmpOrder = libLocationTree.getTreeOrder(tmpScanning.locations || []);
		if (tmpSelectedID && !tmpOrder.some((pEntry) => String(pEntry.Location.IDLocation) === tmpSelectedID))
		{
			tmpOrder.unshift({ Location: tmpLocation, Depth: 0 });
		}
		const tmpOptions = tmpOrder.map((pEntry) =>
		{
			const tmpID = String(pEntry.Location.IDLocation);
			const tmpIndent = '   '.repeat(pEntry.Depth);
			return `<option value="${this.escapeHTML(tmpID)}"${tmpID === tmpSelectedID ? ' selected' : ''}>${tmpIndent}${this.escapeHTML(pEntry.Location.Name || `Location #${tmpID}`)}</option>`;
		}).join('');
		const tmpPlaceholder = (tmpScanning.locations === null) ? 'Loading locations…' : 'Choose a location, or scan one';
		const tmpStatus = tmpScanning.locationStatus;
		const tmpStatusHint = tmpStatus ? `<p class="hl-scan-hint">Samples moved here are set to <b>${this.escapeHTML(tmpStatus)}</b> unless they are already further along.</p>` : '';
		let tmpCamera = '';
		if (tmpScanning.host.camera)
		{
			const tmpLabel = tmpScanning.host.camera.isOpen() ? 'Close Camera' : 'Open Camera';
			tmpCamera = `<div class="hl-scan-actions"><button type="button" class="button is-primary is-fullwidth" onclick="${this.providerRef}.toggleCamera()">` +
				`<span class="icon mr-2"><i class="fas fa-fw fa-camera-viewfinder"></i></span><span>${tmpLabel}</span></button></div>`;
		}
		// A fixed location (fixLocation) is shown, not offered: no picker and no remember switch.
		const tmpLocationHTML = tmpScanning.fixedLocation ?
			`<span class="hl-scan-label">Location</span>
			<p id="${this.prefix}-Location" class="hl-scan-fixed"><span class="icon"><i class="fas fa-fw fa-location-dot"></i></span><b>${this.escapeHTML(tmpScanning.fixedLocation.Name || `Location #${tmpScanning.fixedLocation.IDLocation}`)}</b></p>
			<p class="hl-scan-hint">Samples are moved into this location.</p>` :
			`<label class="hl-scan-label" for="${this.prefix}-Location">Location</label>
			<div class="select is-fullwidth"><select id="${this.prefix}-Location" onchange="${this.providerRef}.pickLocation(this.value)">
				<option value="">${tmpPlaceholder}</option>${tmpOptions}
			</select></div>
			<label class="checkbox hl-scan-check"><input type="checkbox" ${tmpScanning.rememberLocation ? 'checked' : ''} onchange="${this.providerRef}.setRememberLocation(this.checked)"> Remember this location on this device</label>`;
		return `<div class="hl-scan-section">
			${tmpLocationHTML}
			<label class="checkbox hl-scan-check"><input type="checkbox" ${tmpScanning.saveEachScan ? 'checked' : ''} onchange="${this.providerRef}.setSaveEachScan(this.checked)"> Save each scan right away</label>
			<p class="hl-scan-hint">${tmpScanning.saveEachScan ? 'Each sample you scan is moved to the location as soon as it is scanned.' : 'Scanned samples are collected below; Move all moves them together.'}</p>
			${tmpStatusHint}
		</div>${tmpCamera}`;
	}

	/**
	 * The scans saved straight away, newest first.
	 * @return {string}
	 */
	get receivedHTML()
	{
		const tmpScanning = this.scanning;
		if (!tmpScanning.saveEachScan && tmpScanning.received.length === 0)
		{
			return '';
		}
		const tmpIcons =
		{
			working: '<i class="fas fa-fw fa-spinner fa-spin"></i>',
			ok: '<i class="fas fa-fw fa-circle-check has-text-success"></i>',
			warn: '<i class="fas fa-fw fa-triangle-exclamation has-text-warning"></i>',
			error: '<i class="fas fa-fw fa-circle-xmark has-text-danger"></i>',
			undone: '<i class="fas fa-fw fa-rotate-left"></i>',
		};
		const tmpRows = tmpScanning.received.map((pRow) =>
		{
			const tmpUndo = (pRow.State === 'ok') ? `<button type="button" class="button is-small" onclick="${this.providerRef}.undoReceive(${Number(pRow.Sample.IDSample)})">Undo</button>` : '';
			return `<div class="hl-scan-row">
				<span class="icon">${tmpIcons[pRow.State] || ''}</span>
				<div class="hl-scan-row-body">
					<div><b>${this.escapeHTML(pRow.Sample.Name || 'Sample')}</b> <span class="hl-scan-muted is-size-7">${this.escapeHTML(pRow.Sample.QRCode)}</span></div>
					<div class="is-size-7">${this.escapeHTML(pRow.Message)}</div>
				</div>
				${tmpUndo}
			</div>`;
		}).join('');
		const tmpEmpty = (tmpScanning.received.length === 0) ? '<p class="hl-scan-empty">Samples you scan appear here as they are saved.</p>' : '';
		const tmpFinish = (tmpScanning.received.length > 0) ? `<button type="button" class="button is-small" title="Clears this list; every scan is already saved" onclick="${this.providerRef}.finish()">Finish</button>` : '';
		return `<div class="hl-scan-list-head"><span>Saved</span>${tmpFinish}</div><div>${tmpRows}${tmpEmpty}</div>`;
	}

	/**
	 * The collected list's heading with Clear and Move all.
	 * @return {string}
	 */
	get collectedHeadHTML()
	{
		const tmpScanning = this.scanning;
		const tmpCount = tmpScanning.samples.length;
		if (tmpScanning.saveEachScan && tmpCount === 0)
		{
			return '';
		}
		// Clear leaves kept samples, so with only those there is nothing to clear.
		const tmpClearable = tmpScanning.samples.some((pSample) => !tmpScanning.isKept(pSample.IDSample));
		// Check in and move all is only offered once the cart has a location to move into.
		const tmpCheckInAndMove = tmpScanning.location ?
			`<button type="button" class="button is-small is-link" title="Checks every sample in the list into the lab, then moves them all here" onclick="${this.providerRef}.checkInAndMoveAll()" ${(tmpCount && !tmpScanning.markingReceived) ? '' : 'disabled'}>Check in and move all</button>` :
			'';
		const tmpTarget = tmpScanning.location ? ` to ${this.escapeHTML(tmpScanning.location.Name)}` : '';
		const tmpDisabled = (tmpCount && tmpScanning.location) ? '' : 'disabled';
		const tmpEmpty = (tmpCount === 0) ? '<p class="hl-scan-empty">Scan samples to collect them here.</p>' : '';
		return `<div class="hl-scan-list-head"><span>Collected (${tmpCount})</span>
				<span class="buttons are-small mb-0">
					<button type="button" class="button is-small" title="Removes everything from the list" onclick="${this.providerRef}.clear()" ${tmpClearable ? '' : 'disabled'}>Clear</button>
					<button type="button" class="button is-small is-info" title="Sets every sample in the list to RECV and logs it; they stay in the list" onclick="${this.providerRef}.markReceived()" ${(tmpCount && !tmpScanning.markingReceived) ? '' : 'disabled'}>Check Samples into Lab</button>
					<button type="button" class="button is-small is-success" onclick="${this.providerRef}.moveAll()" ${tmpDisabled}>Move all${tmpTarget}</button>
					${tmpCheckInAndMove}
				</span>
			</div>${tmpEmpty}`;
	}

	/**
	 * The collected samples, each with a remove button (none on a kept sample) and the host's print button when it
	 * prints labels.
	 * @return {Array<Object>}
	 */
	get collectedSamples()
	{
		const tmpScanning = this.scanning;
		const tmpCanPrint = (typeof tmpScanning.host.printLabel === 'function');
		return tmpScanning.samples.map((pSample) => Object.assign({}, pSample,
			{
				_RemoveButton: tmpScanning.isKept(pSample.IDSample) ? '' :
					`<button type="button" class="delete" title="Remove from the list" aria-label="Remove from the list" onclick="${this.providerRef}.removeSample(${Number(pSample.IDSample)})"></button>`,
				_PrintButton: tmpCanPrint ? `<button type="button" title="Print label" class="button is-small" onclick="${this.providerRef}.printLabel(${Number(pSample.IDSample)})"><span class="icon"><i class="fas fa-fw fa-print"></i></span></button>` : '',
			}));
	}
}

module.exports = SampleScanningView;
module.exports.default_configuration = _DefaultConfiguration;
module.exports.buildConfiguration = buildConfiguration;

},{"../Location-Tree.js":295,"pict-view":733}],302:[function(require,module,exports){
const libHosts = require('headlight-qrcode/source/Headlight-QRCode-Hosts.js');

/**
 * Escapes a value for use as HTML text or as an attribute value; null and undefined become ''.
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	if ((pValue === null) || (typeof(pValue) === 'undefined'))
	{
		return '';
	}
	return String(pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

class MediaCardBuilder
{
	constructor(pOptions = {})
	{
		// Default options can be set here
		const defaultOptions = {
			cardLayouts: {
				flexible: { rows: -1, columns: 2 }, // default card layout
				full: { rows: 1, columns: 2 }, // full card layout
				half: { rows: 2, columns: 2 }, // half card layout
				quarter: { rows: 4, columns: 2 }, // quarter card layout,
				minimalist: { rows: 2, columns: 1 }, // minimalist card layout
			},
			target: 'MediaDetailCards-Container', // target container for the media cards
			landscapeMode: false, // whether to use landscape mode for PDF generation
			cardSize: 'flexible', // default card size
			cardTheme: 'default', // default card theme ('default' and 'minimalist')
			sortOrder: 'asc', // default sort order
			sortBy: 'DesignatedTime', // default sort field
			ordinalPosition: 'left', // default ordinal location (left or right)
			ordinalPrefix: 'Photo ', // default ordinal prefix
			ordinalSuffix: ' - ', // what comes after the ordinal (by default, is placed before the title)
			ordinalScope: 'local', // default ordinal scope ("global" can be used for all instances of cards across the form)
			titleAlignment: 'center', // title alignment (left, center, right)
			titlePosition: 'below', // title location (above, below)
			hideOrdinal: false, // hide ordinal option
			hideTitle: false, // hide title option
			hideId: false, // hide ID option
			hideCreator: false, // hide creator option
			hideCreateDate: false, // hide create date option
			hideDescription: false, // hide description option
			hideMiniMap: false, // hide mini map option
			hideStationOffset: false, // hide station and offset row option
			hideLabels: false, // hide labels option
			hideExternalLink: false, // hide external link option
			userRecords: [], // user records provided from an external look up (used to build the userNameMap)
			userNameMap: {}, // map of user IDs to user names for display (userRecords entries are added on top)
			isPrintView: false, // whether to format for print view (hides buttons and interactive elements)
			primaryGroupByLabelType: null, // the primary label type to group by (if grouping by label types, this determines which label type is used for the mini map and external link display in the standard card template)
			secondaryGroupByLabelType: null, // the secondary label type to group by (if grouping by multiple label types, this determines which label type is used for the mini map and external link display in the standard card template when the primary label type is not available)
			disablePrimaryGroupByLabelTypePageBreaks: false, // whether to disable page breaks between primary groups when grouping by label types (only applies to PDF generation)
		};
		// Merge default options with any provided options
		this.options = { ...defaultOptions, ...pOptions };

		// DRY CSS classes to reduce tempalate duplication
		this.sharedLabelCSS = 'title is-7 has-text-text-50'; // default label classes for styling
		this.sharedDatumCSS = 'subtitle is-7 has-text-text'; // default datum classes for styling
		this.hideMeCSS = 'style="display: none;"'; // Inline style to hide elements (avoid css classes for simplicity)
		this.customCSSInjected = false; // flag to track whether component specific CSS has been injected into the document head
	}

	/**
	 * Inject CSS styles for the media cards into the document head, using options to set dynamic values such as card and image heights based on the PDF page height and landscape mode setting
	 * @param {Object} tmpOptions - the options to use for setting dynamic CSS values
	 * @return {void}
	 */
	injectCCSS(tmpOptions = {})
	{
		// Only inject CSS once, even if buildCards is called multiple times
		if (this.customCSSInjected || document.getElementById('MediaCardBuilder-Styles')) return;

		const styleElement = document.createElement('style');
		styleElement.id = 'MediaCardBuilder-Styles';
		styleElement.innerHTML = /*CSS*/`
			:root {
				--pdf-page-height: ${tmpOptions.landscapeMode ? 700: 950}px; /* Default PDF page height */
			}
			.media-card-wrapper .media-card-image {
				width: auto;
				object-fit: contain;
				margin: 0 auto;
				max-height: calc(var(--pdf-page-height) - 2rem);
			}
			.media-card-wrapper .media-card-description-text {
				line-height: normal;
			}
			/* Card height is a fixed height based on the PDF page height divided by the number of rows */
			.card-height-is-1-out-of-1 {
				height: calc(var(--pdf-page-height) / 1);
			}
			.card-height-is-1-out-of-2 {
				height: calc(var(--pdf-page-height) / 2);
			}
			.card-height-is-1-out-of-4 {
				height: calc(var(--pdf-page-height) / 4);
			}
			/* Image height is a max-height to allow for responsive images */
			.image-height-is-1-out-of-1 {
				max-height: calc(var(--pdf-page-height) / 1);
			}
			.image-height-is-1-out-of-2 {
				max-height: calc(var(--pdf-page-height) / 2);
			}
			.image-height-is-1-out-of-4 {
				max-height: calc(var(--pdf-page-height) / 4);
			}
			/* Card heights have to be tweaked for minimalist theme card sizes */
			.media-card-wrapper.media-card-theme_minimalist .card-height-is-1-out-of-1 {
				height: calc((var(--pdf-page-height) / 1) - 2rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .card-height-is-1-out-of-2 {
				height: calc((var(--pdf-page-height) / 2) - 2rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .card-height-is-1-out-of-4 {
				height: calc((var(--pdf-page-height) / 4) - 2rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .image-height-is-1-out-of-1 {
				height: calc((var(--pdf-page-height) / 1) - ${tmpOptions.hideDescription ? 4 : 6 }rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .image-height-is-1-out-of-2 {
				height: calc((var(--pdf-page-height) / 2) - ${tmpOptions.hideDescription ? 4 : 6 }rem);
			}
			.media-card-wrapper.media-card-theme_minimalist .image-height-is-1-out-of-4 {
				height: calc((var(--pdf-page-height) / 4) - ${tmpOptions.hideDescription ? 4 : 6 }rem);
			}`;
		document.head.appendChild(styleElement);
		this.customCSSInjected = true;
	}

	/**
	 * Build the media cards for the given observations and options
	 * @param {Array} pObservations - the observations to build the media cards for
	 * @param {Object} [pOptions] - the options to use for building the media cards (optional)
	 * @return {boolean}
	 */
	buildCards(pObservations = [], pOptions = {})
	{
		const tmpOptions = { ...this.options, ...pOptions };
		this.injectCCSS(tmpOptions);
		tmpOptions.userNameMap = this.buildUserNameMap(tmpOptions);
		let cardListTemplate = '';
		const mediaList = this.curateMediaObservationList(pObservations, tmpOptions);
		// if we have primary or secondary grouping by label types, we want to add dividers between the groups in the UI, so we need to build the HTML for the cards in a way that allows us to insert those dividers
		if ((tmpOptions.primaryGroupByLabelType || tmpOptions.secondaryGroupByLabelType) && !tmpOptions.hideGroupByLabelTypeHeaders)
		{
			// we need to keep track of the current group values as we loop through the media list to know when to insert dividers
			let currentPrimaryGroup = null;
			let currentSecondaryGroup = null;
			cardListTemplate = mediaList.map((mediaData, index) =>
			{
				// force page breaks for primary labels to ensure groups stay together in the PDF view
				let pageBreakClass = index !== 0 ? 'has-page-break-before' : '';
				let dividerTemplate = '';
				// if we have a new primary group, we need to insert a divider for the new primary group
				if (tmpOptions.primaryGroupByLabelType && mediaData._PrimaryGroupByLabel !== currentPrimaryGroup)
				{
					currentPrimaryGroup = mediaData._PrimaryGroupByLabel;
					dividerTemplate += /*HTML*/`
					<div class="cell is-col-span-full ${ pOptions?.disablePrimaryGroupByLabelTypePageBreaks ? '' : pageBreakClass}">
						<div class="notification is-primary mb-1 mt-1 p-2">
							<span class="icon">
								<i class="fa fa-fw fa-tag"></i>
							</span>
							<strong>${ tmpOptions.primaryGroupByLabelType }: ${ currentPrimaryGroup || '-None-' }</strong>
						</div>
					</div>`;
				}
				// if we have a new secondary group, we need to insert a divider for the new secondary group
				if (tmpOptions.secondaryGroupByLabelType)
				{
					const secondaryGroupValue = mediaData.Labels?.[tmpOptions.secondaryGroupByLabelType]?.[0]?.Tag || undefined;
					if (secondaryGroupValue !== currentSecondaryGroup)
					{
						currentSecondaryGroup = secondaryGroupValue;
						dividerTemplate += /*HTML*/`
						<div class="cell is-col-span-full">
							<div class="notification is-soft mb-1 mt-1 p-1">
								<span class="icon">
									<i class="fa fa-fw fa-tags"></i>
								</span>
								<strong>${ tmpOptions.secondaryGroupByLabelType }: ${ currentSecondaryGroup || '-None-' }</strong>
							</div>
						</div>`;
					}
				}
				// build the card template for the media data and add the divider template before it if necessary
				return dividerTemplate + this.buildCard(mediaData);
			}).join('');
		}
		else 
		{
			cardListTemplate = mediaList.map((mediaData) => this.buildCard(mediaData)).join('');
		}
		// insert the card list template into the target container in the DOM
		const tmpElementQuery = tmpOptions.target.startsWith('#') ? tmpOptions.target : `#${tmpOptions.target}`; // allow for target to be passed in with or without the # prefix, but default to using an ID selector for simplicity and specificity
		const containerElement = document.querySelector(tmpElementQuery);
		if (!containerElement)
		{
			console.warn(`MediaCardBuilder: Target container with ID "${tmpOptions.target}" not found.`);
			return false;
		}
		// If there are no media cards to display, show an empty message
		if (!cardListTemplate || !cardListTemplate.length)
		{
			containerElement.innerHTML =
			`<div class="notification has-text-centered empty-message">
				<span class="icon">
					<i class="fa fa-fw fa-info-circle"></i>
				</span>
				<span>No media has been added yet.</span>
			</div>`;
			return true;
		}
		containerElement.innerHTML = /*HTML*/`
		<div class="fixed-grid has-1-cols" style="wdith: 100%;">
			<div class="grid" style="gap: 0.25rem">${cardListTemplate}</div>
		</div>`;
		return true;
	}

	/**
	 * Map user IDs to display names: the caller's userNameMap, plus (overriding) any userRecords
	 * @param {Object} [pOptions] - the build options (userNameMap and/or userRecords)
	 * @return {Object} - map of IDUser to display name
	 */
	buildUserNameMap(pOptions = {})
	{
		return (pOptions.userRecords || []).reduce((acc, user) =>
		{
			acc[user.IDUser] = user.NameFirst + ' ' + user.NameLast;
			return acc;
		}, { ...pOptions.userNameMap });
	}

	/**
	 * Use a standard card template for the media card
	 * @param {Object} mediaData - the media data for the card
	 * @return {string} - the HTML string for the standard media card
	 */
	useStandardCardTemplate(mediaData)
	{
		let mediaElement;
		// If the media type is video or audio, adjust the media element accordingly
		if (mediaData._MediaType === 'video')
		{
			mediaElement = /*HTML*/`
			<figure data-observation-id="${mediaData.IDObservation}" style="padding: 1rem;">
				<video class="media-card-video ${mediaData._ImageHeightClass}" controls="" style="width: 100%;" playsinline>
					<source src="/1.0/Artifact/Media/${ mediaData._ArtifactId }/${ mediaData._Version }" type="video/mp4">
				</video>
			</figure>`;
		}
		else if (mediaData._MediaType === 'audio')
		{
			mediaElement = /*HTML*/`
			<figure data-observation-id="${mediaData.IDObservation}" style="padding: 1rem;">
				<audio class="media-card-audio ${mediaData._ImageHeightClass}" controls="" style="width: 100%;" playsinline>
					<source src="/1.0/Artifact/Media/${ mediaData._ArtifactId }/${ mediaData._Version }" type="audio/mp3">
				</audio>
			</figure>`;
		}
		else // default to image (all observations have a fallback image)
		{
			mediaElement = /*HTML*/`
			<figure data-observation-id="${mediaData.IDObservation}">
				<img class="image media-card-image ${mediaData._ImageHeightClass}"
					src="${mediaData._ImageSource || ''}" 
					alt="Observation #${mediaData.IDObservation}" 
					onerror="this.onerror = null; this.src='./images/no-image-light.png'"
				/>
			</figure>`;
		}
		return /*HTML*/`
		<!-- Standard card template for media cards -->
		<div class="cell" style="break-inside: avoid;">
			<div class="fixed-grid media-card-wrapper ${mediaData._CardColumnClass} media-card-theme_standard">
				<a class="anchor" id="MEDIA-CARD-FOR-${mediaData.IDObservation}"></a>
				<div class="grid is-gap-0 is-clipped ${mediaData._CardHeightClass}">
					<div class="cell has-background-text-soft p-0">
							${mediaElement}
						</figure>
					</div>
					<div class="cell pb-3">
						<div class="fixed-grid has-1-cols mb-3">
							<div class="grid has-background-text-soft" style="gap: 0.5rem;">
								<div class="cell">
									<p ${ mediaData._HideTitle ? this.hideMeCSS : ''} class="title is-7 mt-2 ml-2">${escapeHTML(mediaData.Name)}</p>
									<p class="${this.sharedDatumCSS} mb-2 ml-2">
										<span ${ mediaData._HideId ? this.hideMeCSS : ''}>#${mediaData.IDObservation || ''}</span>
										<a ${ mediaData._HideExternalLink ? this.hideMeCSS : ''} class="is-size-7 is-pulled-right" href="${mediaData._ExternalLinkHref || ''}" target="_blank">
											<span>Open in Fieldbook</span>
										</a>
									</p>
								</div>
								<div ${ mediaData._HideMiniMap ? this.hideMeCSS : ''} class="cell is-col-from-end-1 p-0 has-background-text-85" style="align-content: center;">
									<figure class="image mini-map-image">
										<img style="width: auto; float: right" onerror="this.onerror = null; this.src='./images/no-location-data-light.png'" src="${mediaData._MiniMapImage || ''}" />
									</figure>
								</div>
							</div>
						</div>
						<div class="fixed-grid has-2-cols">
							<div class="grid pl-3 pb-3 mb-0">
								<div ${ mediaData._HideCreator ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Created by</div>
									<div class="${this.sharedDatumCSS} media-card-creator-name" data-creator-id="${mediaData.CreatingIDUser || ''}">${mediaData._CreatorName || 'N/A'}</div>
								</div>
								<div ${ mediaData._HideCreateDate ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Created on</div>
									<div class="${this.sharedDatumCSS}">${new Date(mediaData.DesignatedTime).toLocaleDateString()} at ${new Date(mediaData.DesignatedTime).toLocaleTimeString()}</div>
								</div>
								<div ${ mediaData._HideDescription ? this.hideMeCSS : ''} class="cell is-col-span-2">
									<div class="${this.sharedLabelCSS} media-card-description-text">Description</div>
									<div class="${this.sharedDatumCSS}" style="display: inline-flex; flex-wrap: wrap;">
										${escapeHTML(mediaData.Description) || '<span class="has-text-text-50">No description provided</span>'}
									</div>
								</div>
								<div ${ mediaData._HideStationOffset || !mediaData._HasStationOffsetRow ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Station</div>
									<div class="${this.sharedDatumCSS}">${escapeHTML(mediaData.AlignmentStation) || 'N/A'}</div>
								</div>
								<div ${ mediaData._HideStationOffset || !mediaData._HasStationOffsetRow ? this.hideMeCSS : ''} class="cell">
									<div class="${this.sharedLabelCSS}">Offset</div>
									<div class="${this.sharedDatumCSS}">${escapeHTML(mediaData.AlignmentOffset) || 'N/A'}</div>
								</div>
								${ this.buildLabelSection(mediaData) }
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>`;
	}
	
	/**
	 * Use a minimalist card layout for the media card
	 * @param {Object} mediaData - the media data for the card
	 * @return {string} - the HTML string for the minimalist media card
	 */
	useMinimalistCardTemplate(mediaData)
	{
		// Build the ordinal and it's wrapping content for the minimalist card - will be "left" or "right" positions
		const buildOrdinal = () => 
		{
			return /*HTML*/`
				<span ${ mediaData._HideOrdinal ? this.hideMeCSS : ''} class="media-card-ordinal-prefix">
					${mediaData._OrdinalPrefix || ''}
				</span>
				<span ${ mediaData._HideOrdinal || mediaData._HideGlobalOrdinal ? this.hideMeCSS : ''} class="media-card-global-ordinal">
					${mediaData._GlobalOrdinal || ''}
				</span>
				<span ${ mediaData._HideOrdinal || mediaData._HideLocalOrdinal ? this.hideMeCSS : ''} class="media-card-local-ordinal">
					${mediaData.Ordinal || ''}
				</span>
				<span ${ mediaData._HideOrdinal ? this.hideMeCSS : ''} class="media-card-ordinal-suffix">
					${mediaData._OrdinalSuffix || ''}
				</span>
			`;
		}
		// Build the header for the minimalist card which can be in two different positions - "above" or "below" the image
		const buildHeader = () => 
		{
			return /*HTML*/`
				<div class="is-flex title is-7 mt-1 mb-0 ${ tmpAlignment }">
					<div class="is-flex-grow-1">
						${ mediaData._OrdinalPosition === 'left' ? buildOrdinal() : '' }
						<span ${ mediaData._HideTitle ? this.hideMeCSS : ''} class="media-card-title">
							${escapeHTML(mediaData.Name)}
						</span>
						${ mediaData._OrdinalPosition !== 'left' ? buildOrdinal() : '' }
					</div>
				</div>
			`;
		}

		// Translate the title/description alignment to a CSS class
		let tmpAlignment = '';
		switch(mediaData?._TitleAlignment?.toLowerCase()) {
			case 'left':
				tmpAlignment =  'has-text-left';
				break;
			case 'right':
				tmpAlignment =  'has-text-right';
				break;
			default:
				tmpAlignment =  'has-text-centered';
		}

		return /*HTML*/`
		<!-- Minimalist card template for media cards -->
		<div class="cell" style="break-inside: avoid;">
			<div class="fixed-grid media-card-wrapper has-1-cols media-card-theme_minimalist">
				<a class="anchor" id="MEDIA-CARD-FOR-${mediaData.IDObservation}"></a>
				<div class="grid is-gap-0 is-clipped mt-2 ${mediaData._CardHeightClass}">
					<div class="cell">
						${ mediaData._TitlePosition == 'above' ? buildHeader() : '' }
						<figure data-observation-id="${mediaData.IDObservation}">
							<img class="image media-card-image ${mediaData._ImageHeightClass}"
								src="${mediaData._ImageSource || ''}" 
								alt="Observation #${mediaData.IDObservation}" 
								onerror="this.onerror = null; this.src='./images/no-image-light.png'"
							/>
						</figure>
						${ mediaData._TitlePosition !== 'above' ? buildHeader() : '' }
						<div ${ mediaData._HideDescription ? this.hideMeCSS : ''} class="media-card-description-text is-size-7 ${tmpAlignment}">${escapeHTML(mediaData._TrimmedDescription)}</div>
					</div>
				</div>
			</div>
		</div>`;
	}

	/**
	 * Build a single media card HTML structure based on the card size and media data
	 * @param {Object} mediaData - the media data for the card
	 * @return {string} - the HTML string for the media card
	 */
	buildCard(mediaData)
	{
		switch (mediaData._CardTheme) {
			case 'minimalist':
				return this.useMinimalistCardTemplate(mediaData);
			default:
				return this.useStandardCardTemplate(mediaData);
		}
	}

	/**
	 * Build the labels section for the media card
	 * @param {Object} mediaData - the media data containing labels
	 * @return {string} - the HTML string for the labels section
	 */
	buildLabelSection(mediaData)
	{
		// Build the HTML for the labels section
		if (!mediaData._HasLabelsToDisplay)
		{
			return '';
		}
		let returnHtml = '';
		const labelGroups = mediaData._LabelGroups || [];
		// If there are no label groups, return an empty string
		if (!labelGroups || !labelGroups.length)
		{
			return '';
		}
		// Map through the label groups to create the HTML for each group
		const labelHtml = labelGroups.map((group) =>
		{
			// For each group, build the HTML for the labels
			let tagGroupHtml = '';
			const valuesHtml = group.Values.map((value) => /*HTML*/`<span class="is-size-7">${escapeHTML(value.Value)}</span>`).join(', ');
			// Create the HTML for the group with its labels
			tagGroupHtml = /*HTML*/`
			<div ${ mediaData._HideLabels ? this.hideMeCSS : ''} class="column">
				<div class="${this.sharedLabelCSS}">${escapeHTML(group.Key)}</div>
				<div class="${this.sharedDatumCSS}">${valuesHtml}</div>
			</div>`;
			return tagGroupHtml;
		}).join('');
		// Wrap the labels in a fixed grid container
		returnHtml = /*HTML*/`
		<div class="cell is-col-span-2">
			<div class="columns is-multiline">
				${labelHtml}
			</div>
		</div>`;
		return returnHtml;
	}

	/**
	 * Build the mini map image URL for the observation
	 * @param {Object} pObservation - the observation data to build the mini map image
	 * @return {string} - the URL for the mini map image or 'null'
	 */
	buildMiniMapImage(pObservation)
	{
		let hasValidCaptureGeoLocation = false;
		let hasValidUserGeoLocation = false;
		// check if the observation has a valid capture or user geolocation
		if (pObservation?.CaptureLatitude && pObservation?.CaptureLongitude)
		{
			hasValidCaptureGeoLocation = this.isValidLatitude(pObservation?.CaptureLatitude) &&
			this.isValidLongitude(pObservation?.CaptureLongitude) &&
			(Number(pObservation?.CaptureLatitude) !== 0 && Number(pObservation?.CaptureLongitude) !== 0);
		}
		if (pObservation?.UserLatitude && pObservation?.UserLongitude)
		{
			hasValidUserGeoLocation = this.isValidLatitude(pObservation?.UserLatitude) && this.isValidLongitude(pObservation?.UserLongitude) && (Number(pObservation?.UserLatitude) !== 0 && Number(pObservation?.UserLongitude) !== 0);
		}
		return hasValidCaptureGeoLocation || hasValidUserGeoLocation ? `/1.0/Observation/Map/For/${pObservation.IDObservation}` : `null`;
	}

	/**
	 * Trim the text to a maximum length and add ellipsis if it exceeds the length
	 * @param {string} text - the text to trim
	 * @param {number} maxLength - the maximum length of the text
	 * @return {string} - the trimmed text with ellipsis if it exceeds the maxLength
	 */
	trimText(text, maxLength = 500)
	{
		if (!text || typeof text !== 'string' || text.length <= maxLength)
		{
			return text;
		}
		return text.substring(0, maxLength) + '...';
	}

	/**
	 * Curate a list of observations into renderable media card data. Supports Image, Video,
	 * Audio, and File observation types. File observations (PDFs, documents, etc.) are rendered
	 * as thumbnail cards using the standard observation image endpoint.
	 * @param {Array} pObservations - the observations to build media cards for
	 * @param {Object} [pOptions] - the options to use for filtering and formatting the observations (optional)
	 * @return {Array} - the curated observations ready for card rendering
	 */
	curateMediaObservationList(pObservations, pOptions)
	{
		if (!pObservations || !pObservations.length)
		{
			return [];
		}
		// filter out observations that are not images
		let tmpObservations = pObservations.reduce((pFiltered, pObs) =>
		{
			let isMediaType = false;
			// determine if the observation has an image, video, or audio artifact
			if (pObs?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video')
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.Video[0].IDArtifact; // set the artifact ID for the video
				pObs._MediaType = !pOptions.isPrintView ? 'video' : 'image'; // if in print view, treat video as image
				pObs._Version = pObs.Details.Video[0].Version;
			} 
			if (pObs?.Details?.Audio?.[0]?.ArtifactType?.toLowerCase() === 'audio')
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.Audio[0].IDArtifact; // set the artifact ID for the audio
				pObs._MediaType = !pOptions.isPrintView ? 'audio' : 'image'; // if in print view, treat audio as image
				pObs._Version = pObs.Details.Audio[0].Version;
			}
			if (pObs?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image')
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.Image[0].IDArtifact; // set the artifact ID for the image
				pObs._MediaType = 'image';
				pObs._Version = pObs.Details.Image[0].Version;
			}
			// File observations (PDFs, documents, etc.) — render as thumbnail cards using the
			// standard observation image endpoint which returns a server-generated preview image.
			// Only matched when no higher-priority media type (Video/Audio/Image) was detected,
			// so an observation that has both an Image and a File detail won't be double-counted.
			if (!isMediaType && pObs?.Details?.File?.[0])
			{
				isMediaType = true;
				pObs._ArtifactId = pObs.Details.File[0].IDArtifact;
				pObs._MediaType = 'image'; // always use the thumbnail representation for file types
				pObs._Version = pObs.Details.File[0].Version;
			}
			if (isMediaType)
			{
				pObs._CardSize = pOptions?.cardSize; // set the card size based on options
				pObs._CardTheme = pOptions?.cardTheme; // set the card theme based on options
				// process the extra image details for the isolated observation card view
				pObs._ImageSource = `/1.0/Observation/${ pObs.IDObservation }/Image/Standard`;
				// flags passed from the configuration options
				pObs._HideTitle = pOptions?.hideTitle;
				pObs._HideId = pOptions?.hideId;
				pObs._HideCreator = pOptions?.hideCreator;
				pObs._HideCreateDate = pOptions?.hideCreateDate;
				pObs._HideDescription = pOptions?.hideDescription;
				// if the description is not hidden, we need to trim it to a maximum length
				if (!pObs?._HideDescription && pObs?.Description)
				{
					pObs._TrimmedDescription = this.trimText(pObs.Description, 425);
				}
				pObs._HideMiniMap = pOptions?.hideMiniMap;
				// build the mini map image URL based on the observation data
				if (!pObs?._HideMiniMap)
				{
					pObs._MiniMapImage = this.buildMiniMapImage(pObs);
				}
				// look up the user name from the map we built earlier
				pObs._CreatorName = escapeHTML(pOptions?.userNameMap?.[pObs.CreatingIDUser]) || '<span class="has-text-text-50">Name not provided</span>';
				// set the column class for the card based on the template options
				pObs._CardColumnClass = `has-${ pOptions?.cardLayouts?.[pOptions?.cardSize]?.columns || 2 }-cols`;
				// set the row class for the card based on the template options
				const tmpRowsCount = pOptions?.cardLayouts?.[pOptions?.cardSize]?.rows;
				pObs._CardHeightClass = tmpRowsCount > 0 ? `card-height-is-1-out-of-${ tmpRowsCount }` : '';
				pObs._ImageHeightClass = tmpRowsCount > 0 ? `image-height-is-1-out-of-${ tmpRowsCount }` : '';
				// show the station and offset row if the configuration option is set and the values are not empty
				if (!pOptions?.hideStationOffset)
				{
					pObs._HideStationOffset = pOptions?.hideStationOffset;
					pObs._HasStationOffsetRow = (pObs?.AlignmentStation?.length && Number(pObs?.AlignmentStation) !== 0) || (pObs?.AlignmentOffset?.length && Number(pObs?.AlignmentOffset) !== 0) ? 1 : 0;
				}
				// show the labels for the observation if the configuration option is set
				if (!pOptions?.hideLabels)
				{
					// show the labels if they are available (if we have keys other than "SAVE" in the Labels object)
					pObs._HasLabelsToDisplay = Object.keys(pObs?.Labels).filter((key) => key !== 'SAVE').length > 0 ? 1 : 0;
					// if we have labels, we need to process them into a format that can be used in the view
					if (pObs._HasLabelsToDisplay)
					{
						const tmpLabelList = {};
						// loop through the labels and add them to the label list
						Object.entries(pObs.Labels || {}).forEach(([ labelTypeKey, labelObjects ]) =>
						{
							// skip the SAVE key as it is not a label we want to display
							if (labelTypeKey === 'SAVE')
							{
								return;
							}
							// if the value is not an array, we need to convert it to an array
							if (!Array.isArray(labelObjects))
							{
								labelObjects = [ labelObjects ];
							}
							// if the label type is not in the list, we need to add it
							if (!tmpLabelList[labelTypeKey])
							{
								tmpLabelList[labelTypeKey] = [];
							}
							for (const labelObject of labelObjects)
							{
								// if the label object has a value, we need to add it to the list
								if (labelObject?.Tag && labelObject.Tag.length)
								{
									tmpLabelList[labelTypeKey].push({
										Value: labelObject.Tag,
									});
								}
							}
						});
						// convert the label list to an array of objects with Key and Values properties
						pObs._LabelGroups = tmpLabelList ? Object.entries(tmpLabelList).map(([ key, values ]) => ({ Key: key, Values: values })) : [];
					}
				}
				// if the configuration option is set, we need show the external link to the observation in Fieldbook
				pObs._HideExternalLink = pOptions?.hideExternalLink;
				pObs._ExternalLinkHref = `${ this.buildLinksUrl() }/#/project/${ pObs.IDProject }/journal/list/observation/${ pObs.IDObservation }`;

				// NOTE: These config options below are limited to the "minimalist" card type for now
				pObs._HideOrdinal = pOptions?.hideOrdinal;
				pObs._HideLocalOrdinal = pOptions?.ordinalScope === 'global';
				pObs._HideGlobalOrdinal = pOptions?.ordinalScope !== 'global';
				pObs._OrdinalPrefix = pOptions?.ordinalPrefix || '';
				pObs._OrdinalSuffix = pOptions?.ordinalSuffix || '';
				pObs._OrdinalPosition = pOptions?.ordinalPosition || 'left';
				pObs._TitlePosition = pOptions?.titlePosition || 'below';
				pObs._TitleAlignment = pOptions?.titleAlignment || 'left';

				// add the observation to the filtered list
				pFiltered.push(pObs);
			}
			return pFiltered;
		}, []);
		// primary grouping (ex: Elements)
		if (pOptions?.primaryGroupByLabelType)
		{
			// set the primary label type flag on each observation for use in the card template
			tmpObservations.forEach((obs) => {
				const primaryLabel = obs.Labels?.[pOptions.primaryGroupByLabelType]?.[0];
				obs._PrimaryGroupByLabel = primaryLabel ? primaryLabel.Tag : '-None-';
				// if we have a secondary grouping, set the secondary label type flag on each observation for use in the card template
				if (pOptions?.secondaryGroupByLabelType)
				{
					const secondaryLabel = obs.Labels?.[pOptions.secondaryGroupByLabelType]?.[0];
					obs._SecondaryGroupByLabel = secondaryLabel ? secondaryLabel.Tag : '-None-';
				}
			});
			// if we are grouping by a label type, we want to sort the observations by that label first so that they are grouped together in the UI
			// we want to put '-None-' groups at the end, so we use localeCompare which will sort them after all other values
			tmpObservations.sort((a, b) => {
			 	const aPrimary = a._PrimaryGroupByLabel;
			 	const bPrimary = b._PrimaryGroupByLabel;
				// if secondary grouping is enabled, we want to sort by the secondary label within the primary groups
				if (pOptions?.secondaryGroupByLabelType) {
					const aSecondary = a._SecondaryGroupByLabel;
					const bSecondary = b._SecondaryGroupByLabel;
					if (aPrimary === bPrimary) {
						if (aSecondary === bSecondary) {
							return 0;
						}
						return aSecondary.localeCompare(bSecondary);
					}
				}
			 	return aPrimary.localeCompare(bPrimary);
			});
			// if we have '-None-' groups, we want to move them to the end of the list after sorting so that they don't break up the groups with actual labels
			const noneGroupObservations = tmpObservations.filter(obs => obs._PrimaryGroupByLabel === '-None-');
			const otherGroupObservations = tmpObservations.filter(obs => obs._PrimaryGroupByLabel !== '-None-');
			tmpObservations = [ ...otherGroupObservations, ...noneGroupObservations ];
			
			// for clarification in the configuration, we will remove the other sort options since we are grouping by a label type to avoid confusion
			pOptions.sortBy = null;
			pOptions.sortOrder = null;
			return tmpObservations;
		}
		else {
			// sort the observations by the configured sort order and field
			return this.sortObservationsByKey(tmpObservations, pOptions?.sortBy, pOptions?.sortOrder);
		}
	}

	/**
	 * This method is used to validate if a passed string is a valid latitude geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLatitude('24.034345') => '24.034345'
	 */
	isValidLatitude = (value) =>
	{
		const latReg = RegExp(/^(\+|-)?(?:90(?:(?:\.0{0,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = latReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Latitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * This method is used to validate if a passed string is a valid longitude geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLongitude('24.034345') => '24.034345'
	 */
	isValidLongitude = (value) =>
	{
		const longReg = RegExp(/^(\+|-)?(?:180(?:(?:\.0{0,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = longReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Longitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * The links URL for the page's environment, from the shared host rule in headlight-qrcode.
	 * @return {string} - The links URL for the current environment.
	 */
	buildLinksUrl()
	{
		const tmpLocation = (typeof window !== 'undefined' && window.location) ? window.location : {};
		return libHosts.getLinksBaseURL(libHosts.getEnvironmentForPage({ Protocol: tmpLocation.protocol, Hostname: tmpLocation.hostname, ServerURL: (typeof window !== 'undefined') ? window._OfflineServerBaseURL : undefined }));
	}

	/**
	 * Sorts the observations by a given key and order
	 * @param {Array} pObservations - The observations to sort
	 * @param {String} pSortBy - The key to sort by
	 * @param {String} pSortOrder - The order to sort by (asc or desc)
	 * @return {Array} - The sorted observations
	 */
	sortObservationsByKey(pObservations, pSortBy, pSortOrder)
	{
		if (!pObservations || !pObservations.length)
		{
			return pObservations;
		}
		if (!pSortBy)
		{
			console.info('No sort key provided - returning unsorted observations.');
			return pObservations;
		}
		// TODO: Add support for Labels and Datums
		const tmpSortOrder = pSortOrder && pSortOrder.toLowerCase() === 'desc' ? -1 : 1;
		const tmpSortedObservations = pObservations.sort((a, b) =>
		{
			const aValue = a[pSortBy];
			const bValue = b[pSortBy];
			if (aValue < bValue)
			{
				return -1 * tmpSortOrder;
			}
			if (aValue > bValue)
			{
				return 1 * tmpSortOrder;
			}
			return 0;
		});
		return tmpSortedObservations;
	}

	/**
	 * This function handles the global ordinal numbering for media cards on the DOM after everything is loaded.
	 */
	handleGlobalOrdinalNumbering()
	{
		// scrape the UI and reapply global ordinals from top to bottom
		$('.media-card-wrapper .media-card-global-ordinal').each((index, element) =>
		{
			$(element).text(index + 1);
		});
	}
}

module.exports = MediaCardBuilder;

},{"headlight-qrcode/source/Headlight-QRCode-Hosts.js":16}],303:[function(require,module,exports){
/**
 * Creates a simple deferred promise
 */
class Deferred {
	constructor() {
		this.promise = new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}
}

/**
 * A simple abstraction of sending RPC messages across an event bus and receiving responses.
 * This is intended to be used to communicate with the native side of the application.
 * Users of this class are expected to tell this how to post messages and tell it when a message was received.
 * The means in which messages are sent and received are not defined here and should be implemented by the user.
 */
class EventRPCBridge {
	/** @type {Object<string, Deferred>} */
	_callbackDefermentMap = {};
	/**
	 * @type {function({method: string, callbackId: string, payload: any}): void}
	 */
	_postMessage;

	/**
	 * A unique key to "namespace" our messages.
	 * Right now this is put in just to be sure that if there are 2 bridges on the same bus the messages don't get mixed up.
	 * It's not actually needed as of this moment, more of a safety rail for the future.
	 * @type {string}
	 * @private
	 */
	_RPCKey = Math.random().toString(36).substring(2);
	_messageId = 0;

	/**
	 *
	 * @param {{
	 *     postMessage: function({method: string, callbackId: string, payload: any}): void
	 * }} options
	 */
	constructor(
		options
	) {
		this._postMessage = options.postMessage;
	}

	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} payload
	 * @return {Promise<unknown>}
	 */
	async invokeRPCMethod(method, payload) {
		const callbackId = this._createCallbackId();
		// register our deferment on our callbacks to be called later
		const deferment = new Deferred();
		this._callbackDefermentMap[callbackId] = deferment;

		// send the message to the native side
		this._postMessage({
			method,
			callbackId,
			payload,
		});

		return deferment.promise;
	}

	/**
	 * Resolves or rejects the original caller's promise. Should be called when a method complete message is received from the other side of the bridge.
	 *
	 * @param {{
	 *    callbackId: string,
	 *    result?: any,
	 *    error?: any,
	 *    message?: string,
	 * }} message
	 */
	onRPCMethodComplete(message) {
		if(!message) {
			console.error('EventRPCBridge Received invalid message: message is falsy', message);
			return;
		}
		if(!message.callbackId) {
			console.error('EventRPCBridge Received invalid message: no callbackId', message);
			return;
		}

		const deferment = this._callbackDefermentMap[message.callbackId];
		if(!deferment) {
			console.error('EventRPCBridge Received invalid message: callbackId is not in our deferment map, unresolvable', message);
			return;
		}

		if (message.error) {
			deferment.reject(new Error(message.message || message.error));
		} else {
			deferment.resolve(message.result);
		}
		delete this._callbackDefermentMap[message.callbackId];
	}

	/**
	 * Creates a callback ID which is guaranteed to be unique in this context
	 *
	 * @return {string}
	 * @private
	 */
	_createCallbackId() {
		if(Object.keys(this._callbackDefermentMap).length > 20) {
			console.warn('There are a lot of outstanding RPC calls. This may be indicative of a problem');
		}

		this._messageId++;
		return `${this._RPCKey}-${this._messageId}`;
	}
}

module.exports = {
	EventRPCBridge
}
},{}],304:[function(require,module,exports){
const {EventRPCBridge} = require('../EventRPCBridge');


const MSG_TYPES = {
	PING: 'Cordova_RPCPing',
	PONG: 'Cordova_RPCPong',
	INVOKE: 'Cordova_RPCInvoke',
	INVOKE_COMPLETE: 'Cordova_RPCComplete',
}


let hasBridge = false;
// a cordova bridge is only possible in an iframe environment (we have a window.parent)
if(window.parent && window.self !== window.top) {
	console.log('Have window parent, waiting for parent bridge.');
	/*
	 Because we dont know if the window.parent is a native application and has a cordova bridge we need to
	 do some verification:

	 This is like a server PING -> PONG request to see if the bridge is there.

	 1. Client "connects" by listening for messages
	 2. Client sends "RPCPing" message to parent
	 3. Server listens for "RPCPing" and sends "RPCPong" message back
	 4. Client knows it's connected and can start sending messages

	 Its like sonar with a specific signature
	 */

	// listen for PONG responses
	window.addEventListener('message', function(e) {
		const type = e?.data?.type;

		// if we get a ping message from the parent or get our pong back then we know were ready
		// this is a sonar ping to see if the bridge is there
		if(type === MSG_TYPES.PING) {
			window.parent.postMessage({
				type: MSG_TYPES.PONG,
			}, '*');
			console.log('Forms cordova bridge ready');
			hasBridge = true;
		} else if(type === MSG_TYPES.PONG) {
			console.log('Forms cordova bridge ready');
			hasBridge = true;
		}
	}, false);

	// send out a PING and see if we can get a pong back, the hosting application should also send out a ping when its ready
	window.parent.postMessage({
		type: MSG_TYPES.PING,
	}, '*');
}


/**
 * CordovaNativeBridge is a class that provides a way to call native methods from a webview.
 * Communication is done through the postMessage API using the EventRPCBridge.
 */
class CordovaNativeBridge {
	/**
	 * @type {EventRPCBridge}
	 * @private
	 */
	_eventBridge;

	constructor() {
		if(!window.parent) {
			console.error('No native message message handler found but native bridge was constructed. This is likely indicative of an problem');
		}

		this._eventBridge = new EventRPCBridge({
			postMessage: this._postMessage.bind(this),
		});

		this._listenForRPCMessages();
	}

	/**
	 * Listens for messages from the native side of the bridge and forwards them to the event bridge handler
	 * @private
	 */
	_listenForRPCMessages() {
		window.addEventListener('message', (event) => {
			console.log('Message received', event);
			const detail = event.data;
			if(detail && detail.type === MSG_TYPES.INVOKE_COMPLETE) {
				this._eventBridge.onRPCMethodComplete(detail);
			}
		});
	}

	_postMessage(message) {
		if(!window.parent) {
			throw new Error('Cannot post message to parent window, no parent window found');
		}
		window.parent.postMessage({
			type: MSG_TYPES.INVOKE,
			message: message,
		}, '*');
	}



	/**
	 * Invoke the native method with the given arguments.
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	async invokeNativeMethod(method, args) {
		return this._eventBridge.invokeRPCMethod(method, args);
	}
}

CordovaNativeBridge.supported = () => {
	return Boolean(hasBridge);
}

module.exports = {
	CordovaNativeBridge
};
},{"../EventRPCBridge":303}],305:[function(require,module,exports){
const {EventRPCBridge} = require('../EventRPCBridge');

/**
 * A bridge to interact with the Webkit message handler which is used to communicate with the native side on iOS applications.
 * Applications should register a WKScriptMessageHandler called "shared" which will be used to communicate with the native side.
 * To send data back to this bridge, the native side should post a message to the window with the event name "nativeMethodComplete"
 */
class WebkitSharedNativeBridge {
	/**
	 * @type {EventRPCBridge}
	 * @private
	 */
	_eventBridge;

	constructor() {
		if(!window.webkit?.messageHandlers?.shared) {
			console.error('No native message message handler found but native bridge was constructed. This is likely indicative of an problem');
		}

		this._eventBridge = new EventRPCBridge({
			postMessage: this._postMessage.bind(this),
		});

		this._listenForRPCMessages();
	}

	/**
	 * Begins listening for the native method complete event which should be fired by the native side.
	 * This is how we know when a native method has completed and get its results
	 * @private
	 */
	_listenForRPCMessages() {
		console.log('Attaching native method complete event listener');
		window.addEventListener('nativeMethodComplete', 
		(event) => {
			const detail = event.detail;
			if(detail) {
				this._eventBridge.onRPCMethodComplete(detail);
			}
		});
	}

	_postMessage(message) {
		const messageBus = window.webkit?.messageHandlers?.shared;
		if(messageBus && messageBus.postMessage) {
			messageBus.postMessage({
				objcMethod: message.method,
				callbackId: message.callbackId,
				params: message.payload,
			});
		} else {
			throw new Error('Could not post message due to missing webkit message handler')
		}
	}


	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	async invokeNativeMethod(method, args) {
		return this._eventBridge.invokeRPCMethod(method, args);
	}
}

WebkitSharedNativeBridge.supported = () => {
	return Boolean(window.webkit?.messageHandlers?.shared?.postMessage);
}


module.exports = {
	WebkitSharedNativeBridge,
}
},{"../EventRPCBridge":303}],306:[function(require,module,exports){
const {CordovaNativeBridge} = require("./bridges/CordovaNativeBridge");
const {WebkitSharedNativeBridge} = require("./bridges/WebkitSharedNativeBridge");

/**
 * The contract of a native bridge function
 */
class NativeBridge {

	constructor(){}

	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	invokeNativeMethod(method, args) {
		throw new Error('NativeBridge not active');
	}
}

/**
 * Gets the available native bridge class
 * @return {NativeBridge|null}
 */
function getAvailableNativeBridgeClass() {
	if(CordovaNativeBridge.supported()) {
		// @ts-ignore
		return CordovaNativeBridge;
	} else if(WebkitSharedNativeBridge.supported()) {
		// @ts-ignore
		return WebkitSharedNativeBridge;
	}

	return null;
}


let cachedStatusResponse = null;
/**
 * @type {NativeBridge|null}
 */
let existingBridge = null;

/**
 *
 * @return {NativeBridge}
 */
function getBridge() {
	if(!existingBridge) {
		const BridgeClass = getAvailableNativeBridgeClass();
		if (!BridgeClass) {
			throw new Error('No native bridge available');
		}
		// @ts-ignore
		existingBridge = new BridgeClass();
	}
	return existingBridge;
}

const libFableService = require('fable-serviceproviderbase');

class NativeBridgeFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }}}
		 */
		this.fable;

		this.serviceType = 'NativeBridge';

	}

	/**
	 * Checks if native functions are available.
	 *
	 * @return {*|boolean}
	 */
	hasNativeSupport() {
		return getAvailableNativeBridgeClass() !== null;
	}

	/**
	 * Prints image
	 * @param {object} options
	 * @param {string} [options.jobName] - Title of the print job
	 * @param {string} options.base64Image - Base64 encoded image
	 * @return {Promise}
	 */
	async printImage(options) {
		const supported = await this.methodSupported('printImage');
		if(!supported) {
			window.alert('This app version does not support printing. Please update your application to the latest version.');
			return Promise.reject('Native print not supported');
		}
		return await getBridge().invokeNativeMethod('printImage', {
			jobName: options.jobName || 'Print Image',
			base64Image: options.base64Image,
		});
	}

	/**
	 * Gets the location coordinates from a native app.
	 * @return {Promise}
	 */
    async getLocation() {
		const supported = await this.methodSupported('getLocation');
		if(!supported) {
			return Promise.reject('Native location not supported');
		}
	   return await getBridge().invokeNativeMethod('getLocation', {});
    }

	/**
	 * Gets the bridge status details, once fetched they will not be fetched again.
	 * This gives you version numbers and other details about the native bridge.
	 *
	 * If the bridge doesn't exist then you get bridgeVersion: 0 and appVersion: ''
	 *
	 * @return {Promise<{
	 *     bridgeVersion: number,
	 *     appVersion: string,
	 * 	   supports: array,
	 *     intent?: {
	 *         action: string,
	 *         data: string,
	 *     }
	 * }>}
	 */
	async status() {
		if(getAvailableNativeBridgeClass() == null) {
			return {
				bridgeVersion: 0,
				appVersion: '',
				supports: ['status', 'hasNativeSupport']
			}
		}

		if(!cachedStatusResponse) {
			cachedStatusResponse = await getBridge().invokeNativeMethod('status', {});
		}

		cachedStatusResponse.supports = ['status', 'hasNativeSupport'];

		if (cachedStatusResponse.bridgeVersion >= 1)
		{
			cachedStatusResponse.supports.push('printImage');
		}
		if (cachedStatusResponse.bridgeVersion >= 2)
		{
			cachedStatusResponse.supports.push('getLocation');
		}

		return cachedStatusResponse;
	}

	/**
	 * Method to check if a method is supported by the native bridge.
	 * @param {String} method - name of the method we are checking support for. 
	 */
	async methodSupported(method)
	{
		const status = await this.status();
		return status.supports.includes(method);
	}
}

module.exports = NativeBridgeFableService;
module.exports.default_configuration = {};
},{"./bridges/CordovaNativeBridge":304,"./bridges/WebkitSharedNativeBridge":305,"fable-serviceproviderbase":438}],307:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/**
 * FIXME: figure out how to flow these types through in a more sane way...
 * @typedef {import('pict') & import('fable') &
 * {
 *   HeadlightRestClient: import('headlight-rest-client'),
 *   MetaTemplate: any, // import('fable').MetaTemplate,
 *   views: { PictFormMetacontroller: import('pict-section-form').PictFormMetacontroller },
 *   fable: import('fable'),
 * }} Pict
 */

/** @typedef {import('fable')} Fable */
/** @typedef {(pError?: (Error | String)) => void} HybridErrorCallback */

/**
 * Pict Login view.
 */
class HeadlightLogin extends libPictViewClass
{
	/**
	 * @param {import('fable')} pFable - The fable instance.
	 * @param {any} [pOptions] - The view options.
	 * @param {any} [pServiceHash] - The fable service instance hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/**
		 * FIXME: figure out how to flow these types through in a more sane way...
		 * @type {import('pict') & import('fable') &
		 * {
		 *   MetaTemplate: any, // import('fable').MetaTemplate,
		 *   views: { PictFormMetacontroller: any },
		 *   fable: import('fable'),
		 *   TransactionTracking: any, //FIXME: correct type
		 *   PictApplication: import('pict-application') & {
		 *     onBeforeLogin?: () => Promise<void>,
		 *     onBeforeLogout?: () => Promise<void>,
		 *     onInteractiveLogin?: () => Promise<void>,
		 *     onInteractiveLogout?: () => Promise<void>,
		 *     onAfterInteractiveLogin?: () => Promise<void>,
		 *   },
		 *   RestClient: any,
		 * }}
		 */
		this.pict;

		/** @type {Fable} */
		this.fable;

		/** @type {any} */
		this.options;
	}

	/**
	 * Handle view initialization.
	 *
	 * TODO: consider pre-populating the username if user selected 'Remember Me'
	 */
	onInitialize()
	{
		this.LoginUserName = '';
		this.LoginPassword = '';
		this.LoginTitle = '';
		this.LoginTitleStyles = '';
		this.LoginWallpaperStyles = 'background-color: var(--bulma-grey-darker);';
		this.LoginWallpaperImageList = [];
		this.LoginWallpaperImageListDuration = 5000;
		return super.onInitialize();
	}

	/**
	 * A method to pass in custom styles to the login modal.
	 * @param {Object} pOptions 
	 */
	customizeLoginPage(pOptions)
	{
		this.LoginTitle = pOptions?.title;
		this.LoginTitleStyles = pOptions?.titleStyles;
		this.LoginWallpaperStyles = pOptions?.wallpaperStyles;
		this.LoginWallpaperImageList = pOptions?.wallpaperImageList;

		this.renderAsync(null, null, null, () =>
		{
			this.pict.log.info('Customized login page with title and wallpaper');
		});
	}

	/**
	 * A method to pass in custom styles to the login modal.
	 * @param {Object} pOptions
	 */
	customizeLogoutPage(pOptions)
	{
		this.LoginTitle = pOptions?.title;
		this.LoginTitleStyles = pOptions?.titleStyles;
		this.LoginWallpaperStyles = pOptions?.wallpaperStyles;
		this.LoginWallpaperImageList = pOptions?.wallpaperImageList;
		if (pOptions?.closePanelsOnLogout)
		{
			this.pict.views.HeadlightPanels.closeAllPanels();
		}
		this.show();
	}

	/**
	 * Show the login view.
	 */
	show()
	{
		this.render();
		this.pict.ContentAssignment.addClass(this.options.DefaultDestinationAddress, 'active');
		this.pict.ContentAssignment.removeClass(this.options.DefaultDestinationAddress, 'is-hidden');
	}

	/**
	 * Show the result of a login attempt.
	 *
	 * @param {string} [pMessageType] - The type of message to show.
	 */
	handleLoginMessages(pMessageType)
	{
		// clear all messages first
		this.pict.ContentAssignment.addClass('#Login_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Success', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Invalid', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Failed', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Reset', 'is-hidden');

		// then turn on the type we passed
		if (pMessageType === 'login-error')
		{
			this.pict.ContentAssignment.removeClass('#Login_Error', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Invalid', 'is-hidden');
		}
		else if (pMessageType === 'password-reset-success')
		{
			this.pict.ContentAssignment.removeClass('#PasswordReset_Success', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Reset', 'is-hidden');
		}
		else if (pMessageType === 'password-reset-error')
		{
			this.pict.ContentAssignment.removeClass('#PasswordReset_Error', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Failed', 'is-hidden');
		}
		else
		{
			// do nothing for now - can be for additional statuses
		}
	}

	get loggedInStatus()
	{
		if (!this.AppData.hasOwnProperty('CurrentUser'))
		{
			return false;
		}
		if (!this.AppData.CurrentUser.hasOwnProperty('LoggedIn'))
		{
			return false;
		}
		return (this.AppData.CurrentUser.LoggedIn);
	}

	/**
	 * Check if the user is authenticated.
	 *
	 * @param {(pError: (Error | String | null), pSuccess: Boolean) => void} callback - error-first callback to notify on loggedin status (error, true|false)
	 */
	isUserLoggedIn(callback)
	{
		this.pict.RestClient.getJSON('/1.0/CheckSession', (pError, pResponse, pBody) =>
		{
			if (pError || !pBody.LoggedIn)
			{
				// this.AppData.CurrentUser = undefined;
				if (pError)
				{
					this.pict.log.error(`session check failed: ${pError.message || pError}`, { Stack: pError.stack, Response: pBody });
				}
				else
				{
					this.pict.log.trace('user not logged in, no session found', { Response: pBody });
				}
				callback(null, false);
				return;
			}
			// already logged in
			this.AppData.CurrentUser = pBody;
			callback(null, true);
		});
	}

	/**
	 * Handle the login form submission.
	 *
	 * @param {UIEvent} event - The event that triggered the login.
	 */
	login(event)
	{
		if (typeof (this.pict.PictApplication.onBeforeLogin) === 'function')
		{
			this.pict.PictApplication.onBeforeLogin();
		}
		// prevent the standard page refresh on a form > submit action
		event.preventDefault();

		const tmpHeadlightAuthenticateBody = (
			{
				UserName: this.pict.ContentAssignment.readContent('#Headlight_LoginID'),
				Password: this.pict.ContentAssignment.readContent('#Headlight_Password')
			});

		const tmpAuthenticateRequestOptions = (
			{
				url: '/1.0/Authenticate',
				body: tmpHeadlightAuthenticateBody
			});

		this.pict.RestClient.postJSON(tmpAuthenticateRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError || !pBody || !pBody.LoggedIn)
				{
					this.pict.log.error(`authentication failed: ${pError}`, pError);
					this.handleLoginMessages('login-error');

					return;
				}
				this.AppData.CurrentUser = pBody;
				this.pict.ContentAssignment.removeClass(this.options.DefaultDestinationAddress, 'is-active');
				this.pict.ContentAssignment.addClass(this.options.DefaultDestinationAddress, 'is-hidden');
				this.pict.log.info(`Authenticated: `, pBody);

				// hide modal after login
				this.pict.ContentAssignment.removeClass('#LoginModal', 'is-active');
				// clear out any messages in the modal
				this.handleLoginMessages();

				if (typeof this.pict.PictApplication.loginAsync === 'function')
				{
					this.pict.PictApplication.loginAsync((pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error in Application loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
						}
						else
						{
							this.pict.log.info(`Application loginAsync completed successfully`);
						}
					});
				}
				if (typeof (this.pict.PictApplication.onInteractiveLogin) === 'function')
				{
					const res = this.pict.PictApplication.onInteractiveLogin();
					if (res && res.then && res.catch) // Promise duck typing - this is sucky, formalize this better
					{
						// just ensure we don't crash the app if the promise fails
						res.catch((pError) =>
						{
							this.pict.log.error(`Error in Application's onInteractiveLogin: ${pError.message || pError}`, { Stack: pError.stack });
						});
					}
				}
			});
	}

	/**
	 * Lifecycle event after the view renders.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object.
	 */
	onAfterRender(pRenderable)
	{
		const eventBindings = document.querySelectorAll(pRenderable.ContentDestinationAddress + ' *[data-event-bind]');
		for (let elem of eventBindings)
		{
			const [ event, handler ] = (elem.getAttribute('data-event-bind') || '').split(':');

			if (!event)
			{
				this.pict.log.error('No event specified for event binding for element', elem);
				continue;
			}

			const handlerFn = this[handler];

			if (!handlerFn)
			{
				this.pict.log.error('No handler function found for event binding for element', elem);
				continue;
			}

			elem.addEventListener(event, handlerFn.bind(this));
		}
		// handle the login wallpaper image list transitions if a list is provided
		this.handleImageListTransistions();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * @param {UIEvent} event - the event that triggered the logout
	 */
	logout(event)
	{
		if (typeof this.pict.PictApplication.onBeforeLogout === 'function')
		{
			this.pict.PictApplication.onBeforeLogout();
		}
		this.pict.RestClient.getJSON('/1.0/Deauthenticate', (pError, pResponse, pBody) =>
		{
			if (pError || !pBody || !pBody.Success)
			{
				this.pict.log.error(`Problem logging out: ${pError.message || pError}`, { Stack: pError.stack, Response: pBody });
				return;
			}

			this.pict.log.info(`Logged out successfully.`,{ Response: pBody });
			if (typeof this.pict.PictApplication.loginAsync === 'function')
			{
				this.pict.PictApplication.loginAsync((pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error in Application loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else
					{
						this.pict.log.info(`Application loginAsync completed successfully`);
					}
				});
			}
			if (typeof (this.pict.PictApplication.onInteractiveLogout) === 'function')
			{
				// TODO: should we call this even if logout failed?
				const res = this.pict.PictApplication.onInteractiveLogout();
				if (res && res.then && res.catch) // Promise duck typing - this is sucky, formalize this better
				{
					// just ensure we don't crash the app if the promise fails
					res.catch((pError) =>
					{
						this.pict.log.error(`Error in Application onInteractiveLogout: ${pError.message || pError}`, { Stack: pError.stack });
					});
				}
			}
		});
	}

	/**
	 * Handle the image list transitions for the login wallpaper.
	 * @spec get the list of images from the context and set the background image to the element for 5 seconds, then fade/transition to the next image, in a loop
	 * @return {void}
	 */
	handleImageListTransistions()
	{
		let nextIndex = 1;
		// get the list of images from the context
		// for each image in the list, set the background image to the element for 5 seconds, then fade/transition to the next image, in a loop
		if (this.LoginWallpaperImageList && this.LoginWallpaperImageList.length > 0)
		{
			const imageElement = document.getElementById('LoginModal-Wallpaper');
			if (imageElement)
			{
				// set the initial transition effects
				imageElement.style.backgroundSize = 'cover';
				imageElement.style.backgroundPosition = 'center';
				imageElement.style.transition = 'background-image 1s ease-in-out';
				// set the next image after 5 seconds
				setInterval(() =>
				{
					// set the current image to the next image
					imageElement.style.backgroundImage = `url(${this.LoginWallpaperImageList[nextIndex]})`;
					// set the next index to the next index + 1, or 0 if it is at the end of the list
					nextIndex = (nextIndex + 1) % this.LoginWallpaperImageList.length;
				}, this.LoginWallpaperImageListDuration || 5000);
			}
			else
			{
				this.pict.log.warn('Unable to find additional image elements for wallpaper transition');
			}
		}
		else
		{
			this.pict.log.info('No additional images found for wallpaper transition');
		}
	}

	/**
	 * @spec abstraction of document object manipulation to check the 'type' attribute of the password input field
	 * @return {boolean} value of " 'type' of the password input field is 'password' "
	 */
	isPasswordFieldProtected()
	{
		return document.getElementById('Headlight_Password').getAttribute('type') === 'password';
	}

	/**
	 * Toggle the password visibility when the user clicks on the eye icon
	 */
	togglePasswordInput()
	{
		if (this.isPasswordFieldProtected())
		{
			this.pict.ContentAssignment.addClass('#Password-Toggle-Icon', 'fa-eye');
			this.pict.ContentAssignment.removeClass('#Password-Toggle-Icon', 'fa-eye-slash');
			document.getElementById('Headlight_Password').setAttribute('type', 'text');
		}
		else
		{
			this.pict.ContentAssignment.removeClass('#Password-Toggle-Icon', 'fa-eye');
			this.pict.ContentAssignment.addClass('#Password-Toggle-Icon', 'fa-eye-slash');
			document.getElementById('Headlight_Password').setAttribute('type', 'password');
		}
	}

	/**
	 * @spec take the current 'username' value and trigger a "reset password" email if the user has a match
	 */
	handleForgotPassword()
	{
		const loginName = this.pict.ContentAssignment.readContent('#Headlight_LoginID');
		const formElement = this.pict.ContentAssignment.getElement('form');
		// prompt the user to enter a user name as it can not be empty to do a reset password
		if ((formElement && formElement.length) && !loginName)
		{
			formElement[0].reportValidity();
			return;
		}
		this.pict.RestClient.getJSON('/1.0/User/ForgotPassword/' + loginName, (pError, pResponse, pBody) =>
		{
			if (pError || !pBody || !pBody.Success)
			{
				this.pict.log.error(`Problem with password recovery request for ${loginName}: ${pError?.message || pError}`, { Stack: pError?.stack, Response: pBody });
				this.handleLoginMessages('password-reset-error');
			}
			else
			{
				this.pict.log.info(`Successfully generated a reset password email for login name '${loginName}': ${pBody.length} `, { Response: pBody });
				this.handleLoginMessages('password-reset-success');
			}
		});
	}

	closeForgotPasswordMessage()
	{
		this.pict.ContentAssignment.addClass('#Login_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Success', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container', 'is-hidden');
	}
}

module.exports = HeadlightLogin;

module.exports.default_configuration = (
{
	ViewIdentifier: "HeadlightLogin",
	RenderOnLoad: false,
	AutoRender: false,
	DefaultRenderable: "HeadlightLogin-Standard",
	DefaultDestinationAddress: "#HeadlightLogin-Standard-Wrap",
	CSS: /*css*/ ``,
	Templates: [
		{
			Hash: "HeadlightLogin-Standard-Wrap",
			Template: /*html*/`
			<section id="HeadlightLogin-Standard-Wrap">
				{~T:HeadlightLogin-Standard-MaterialDesign~}
			</section>
			`			
		},
		{
			Hash: "HeadlightLogin-Standard-MaterialDesign",
			Template: /*html*/`
			<div class="modal is-active" id="LoginModal">
			  	<div id="LoginModal-Wallpaper" class="modal-background" style="{~D:Context[0].LoginWallpaperStyles~}"></div>
				<h1 id="LoginModal-Title" class="title is-size-1 has-text-white px-2" style="{~D:Context[0].LoginTitleStyles~}">{~D:Context[0].LoginTitle~}</h1>
				<form role="login-form" data-event-bind="submit:login">
					<div class="modal-content">
						<div class="box pt-0 pr-6 pb-6 pl-6">
							<div class="container has-text-centered">
								<img src="./images/hashes.png" width="350px" alt="color-hashes" />
							</div>
							<div class="container has-text-centered my-5">
								<img src="./images/HeadLight-logo_gray.png" width="300px" alt="HeadLight" />
							</div>
							<div class="field">
								<p class="control has-icons-left">
									<input id="Headlight_LoginID" required class="input" type="text" name="username" placeholder="Username" value="{~D:Context[0].LoginUserName~}">
									<span class="icon is-small is-left">
										<i class="fas fa-user"></i>
									</span>
								</p>
							</div>
							<div class="field">
								<p class="control has-icons-left has-icons-right">
									<input id="Headlight_Password" required class="input" name="password" type="password" role="input-password" autocomplete="current-password" placeholder="Password" value="{~D:Context[0].LoginPassword~}">
									<span class="icon is-small is-left">
										<i class="fas fa-lock"></i>
									</span>
									<span class="icon is-small is-right is-clickable" data-event-bind="click:togglePasswordInput">
										<i id="Password-Toggle-Icon" class="fas fa-eye-slash"></i>
									</span>
								</p>
							</div>
							<div class="container has-text-centered">
								<div id="Login_Error" class="notification is-hidden is-danger is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Invalid" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
									<i class="fas fa-exclamation-circle mr-1"></i>
										Invalid username or password
								</div>
								<div id="PasswordReset_Error" class="notification is-hidden is-danger is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Failed" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
									<i class="fas fa-exclamation-circle mr-1"></i>
										Password recovery failed
								</div>
								<div id="PasswordReset_Success" class="notification is-hidden is-warning is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Reset" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
										If an account is associated with this username, then password recovery instructions have been sent to the connected email.
								</div>
							</div>
							<div class="columns">
								<div class="column">							
									<button id="Login-ForgotPassword-Button" type="button" class="button is-ghost" data-event-bind="click:handleForgotPassword">Forgot Password?</button>
								</div>
								<div class="column">
									<div class="buttons is-right">
										<button type="submit" class="button is-link">Login</button>
									</div>
								</div>
							</div>
						</div>
						<div class="container has-text-centered has-text-white is-size-7">By clicking Login you are agreeing to our <a target="_blank" class="link has-text-warning" href="https://fieldbook.qa.headlight.com/Assets/templates/terms-of-service.html">Terms and Conditions</a>.</div>
					</div>
				</form>
			</div>`
		}
	],
	Renderables: [
		{
			RenderableHash: "HeadlightLogin-Standard",
			TemplateHash: "HeadlightLogin-Standard-MaterialDesign",
			DestinationAddress: "#HeadlightLogin-Standard-Wrap"
		}
	]
});

},{"pict-view":733}],308:[function(require,module,exports){
const PictViewClass = require('pict-view');

// Available signature font styles. Form authors pick one via
// `MyDefaultFormManifest.SignatureSectionFontStyle`. Only the font for the
// selected style is fetched at render time.
const SIGNATURE_FONT_STYLES = {
	Default: { FontFamily: 'Rock Salt', URLParam: 'Rock+Salt', CSSClass: 'hl-signature-font-default' },
	Cursive: { FontFamily: 'Corinthia', URLParam: 'Corinthia', CSSClass: 'hl-signature-font-cursive' },
	Serif: { FontFamily: 'Merriweather', URLParam: 'Merriweather', CSSClass: 'hl-signature-font-serif' },
	'Sans-serif': { FontFamily: 'Cabin', URLParam: 'Cabin', CSSClass: 'hl-signature-font-sans-serif' },
};

// Approval actions that sign a document as its submitter: the first signature row.
const SUBMISSION_ACTIONS = [ 'submit', 'complete' ];
// Statuses no further signature follows, so the "more signatures may appear" note is hidden.
const FINAL_STATUSES = [ 'approved', 'completed' ];

class HeadlightSignatures extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// TODO: Port this over to Pict, don't leave it here
		// Example: {~DateFormatTZ:AppData.Date^MM/YYYY^AppData.DocumentData.Timezone^~}
		this.pict.MetaTemplate.addPattern('{~DateFormatTZ:', '~}', (pHash, pData, fCallback) =>
		{
			let tmpHash = pHash.trim();
			let tmpData = (typeof (pData) === 'object') ? pData : {};
			let tmpDateValueSet = tmpHash.split('^');

			let date = pData.UpdateDate; // NOTE: using instead of 'tmpDataValueSet[0]' for now (needs a "Record" look up)
			let format = tmpDateValueSet[1] || '';
			let timezone = tmpDateValueSet[2] ? this.pict.resolveStateFromAddress(tmpDateValueSet[2]) : null

			let tmpDayJS = pFable.Dates.dayJS.utc(date);
			try
			{
				if (timezone)
				{
					tmpDayJS = tmpDayJS.tz(timezone);
				}
				else
				{
					try
					{
						tmpDayJS = tmpDayJS.tz(pFable.Dates.dayJS.tz.guess());
					}
					catch (pError)
					{
						this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
					}
				}
			}
			catch
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(pFable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
			return tmpDayJS.format(format);
		});

		this.SignatureData = {
			SignaturesList: [],
			IsApproved: false,
			IsFinal: false,
			Font: SIGNATURE_FONT_STYLES.Default,
			Options: {
				HideSectionHeader: false,
				ShowTitles: true,
				HideDates: false,
				CustomLabels: []
			}
		};
	}

	/**
	 * Resolve the configured signature font style from the manifest.
	 * Form authors set this via `MyDefaultFormManifest.SignatureSectionFontStyle`
	 * before the form is published — it is read once per render and not expected
	 * to change while a form is in active use.
	 *
	 * @returns {{ FontFamily: string, URLParam: string, CSSClass: string }}
	 */
	resolveSignatureFontStyle()
	{
		const tmpConfiguredStyle = this.pict?.settings?.MyDefaultFormManifest?.SignatureSectionFontStyle;
		if (!tmpConfiguredStyle)
		{
			return SIGNATURE_FONT_STYLES.Default;
		}
		const tmpNormalized = String(tmpConfiguredStyle).toLowerCase();
		const tmpMatchedKey = Object.keys(SIGNATURE_FONT_STYLES).find((pKey) => pKey.toLowerCase() === tmpNormalized);
		if (tmpMatchedKey)
		{
			return SIGNATURE_FONT_STYLES[tmpMatchedKey];
		}
		this.pict.log.warn(`Unknown SignatureSectionFontStyle "${tmpConfiguredStyle}"; falling back to Default. Valid options: ${Object.keys(SIGNATURE_FONT_STYLES).join(', ')}.`);
		return SIGNATURE_FONT_STYLES.Default;
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		try {
			// Built fresh on every render: the section is redrawn in place when an approval action changes the status.
			this.SignatureData.SignaturesList = [];
			this.SignatureData.Font = this.resolveSignatureFontStyle();
			if (!this.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				this.pict.log.error('Signature section cannot be rendered without a valid Document ID');
				return;
			}
			// The rows follow the Draft / Submit / Approve / Reject workflow: the latest submission, plus the latest
			// approval once the document is approved. A one-step workflow whose only action is Complete (LADOTD Sample
			// Creation) signs with that action in place of Submit.

			// the approval flag adds the approver's row; the final flag hides the disclaimer
			this.SignatureData.IsApproved = this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'approved';
			this.SignatureData.IsFinal = FINAL_STATUSES.includes(this.AppData?.DocumentData?.ReportData?.Status.toLowerCase());
			// no need to show anything if we are in draft/reject
			if (this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'draft' || this.AppData?.DocumentData?.ReportData?.Status.toLowerCase() === 'rejected')
			{
				return;
			}
			const reversedLogList = (this.AppData?.DocumentData?.ReportData?.ApprovalActions || []).slice().reverse();
			// if we are approved, add the approval log to the list
			if (this.SignatureData.IsApproved)
			{
				const approvalLog = reversedLogList.find((l) => l.Action.toLowerCase() === 'approve');
				if (approvalLog)
				{
					approvalLog.Label = this.formatSignatureLabel(approvalLog);
					this.SignatureData.SignaturesList.unshift(approvalLog);
				}
			}
			// for submitted/reviewed, we know we're not in Draft/Reject/Approved if we are here
			const submitLog = reversedLogList.find((l) => SUBMISSION_ACTIONS.includes(l.Action.toLowerCase()));
			if (submitLog)
			{
				submitLog.Label = this.formatSignatureLabel(submitLog);
				this.SignatureData.SignaturesList.unshift(submitLog);
			}
		}
		catch (exception)
		{
			this.pict.log.error(`Signature section cannot be rendered, ${exception}`);
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		super.onAfterRenderAsync((pError) =>
		{
			// if approved (or otherwise final), remove the note
			if (this.SignatureData.IsFinal)
			{
				this.pict.ContentAssignment.addClass('#HeadlightSignatures-Disclaimer', 'is-hidden');
			}
			else if (this.SignatureData.SignaturesList.length)
			{
				this.pict.ContentAssignment.assignContent('#HeadlightSignatures-Disclaimer-Message', 'More signatures may appear as individuals sign this document.');
			}
			// config options to hide/show titles and dates
			if (!this.SignatureData.Options.ShowTitles)
			{
				this.pict.ContentAssignment.addClass('[data-signature-title]', 'is-hidden');
			}
			if (this.SignatureData.Options.HideDates)
			{
				this.pict.ContentAssignment.addClass('[data-signature-date]', 'is-hidden');
			}
			if (this.SignatureData.Options.HideSectionHeader)
			{
				this.pict.ContentAssignment.addClass('#HeadlightSignatures-Header', 'is-hidden');
			}
			return fCallback(pError);
		}, pRenderable);
	}

	/**
	 * Format the signature label based on the action and status
	 * @param {Object} pLogObject
	 * @returns {string}
	 * @memberof HeadlightSignatures
	 */
	formatSignatureLabel(pLogObject)
	{
		//TODO: read from config and only use this default if no config is set
		const action = pLogObject.Action
			.replace(/submit/i, 'Submitted')
			.replace(/\bcomplete\b/i, 'Completed')
			.replace(/approve/i, 'Approved')
			.replace(/reject/i, 'Rejected')
			.replace(/review/i, 'Reviewed');

		let label = `${action} By`;

		if (Object.keys(this.SignatureData.Options.CustomLabels).length > 0)
		{
			const labelObj = this.SignatureData.Options.CustomLabels.find((l) => l.status === pLogObject.Status);
			if (labelObj)
			{
				label = labelObj.label;
			}
		}
		return label;
	}

}

module.exports = HeadlightSignatures;
module.exports.default_configuration =
{
	ViewIdentifier: 'HeadlightSignatures',
	RenderOnLoad: false,
	AutoRender: false,
	DefaultRenderable: 'HeadlightSignatures',
	DefaultDestinationAddress: '#Headlight-View-Signatures',
	CSS: /*css*/`
		.hl-signature-written {
			font-optical-sizing: auto;
			font-weight: normal;
			font-style: normal;
			font-size: var(--bulma-size-4);
		}
		.hl-signature-font-default { font-family: "Rock Salt", cursive; }
		.hl-signature-font-cursive { font-family: "Corinthia", cursive; font-size: calc(var(--bulma-size-4) * 2.25); line-height: 0.75; }
		.hl-signature-font-serif { font-family: "Merriweather", serif; }
		.hl-signature-font-sans-serif { font-family: "Cabin", sans-serif; }
		.hl-signature-print {
			font-size: var(--bulma-size-7);
		}`,
	Templates:
	[
		{
			Hash: 'HeadlightSignatures',
			Template: /*html*/`
			<section style="break-inside:avoid">
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
				<link href="https://fonts.googleapis.com/css2?family={~D:Context[0].SignatureData.Font.URLParam~}&display=swap" rel="stylesheet" />
				<h2 id="HeadlightSignatures-Header" class="section-header">Signatures</h2>
				<div id="HeadlightSignatures-Content" class="container">
					{~TS:HeadlightSignatures-Row:Context[0].SignatureData.SignaturesList~}
				</div>
				<div class="columns m-2">
					<div class="column is-12">
						<div id="HeadlightSignatures-Disclaimer" class="notification has-text-centered empty-message">
							<span class="icon">
								<i class="fas fa-fw fa-signature"></i>
							</span>
							<span id="HeadlightSignatures-Disclaimer-Message" class="is-italic">Signatures will appear when individuals change the status of this document.</span>
						</div>
					</div>
				</div>
			</section>
`,
		},
		{
			Hash: 'HeadlightSignatures-Row',
			Template: /*html*/`
			<div class="columns m-5 mb-1" data-sign-key="Row" data-log-after-status="{~D:Record.AfterStatus~}">
				<div class="column" data-signature-name>
					<label class="label">{~D:Record.Label~}</label>
					<div class="hl-signature-written {~D:Context[0].SignatureData.Font.CSSClass~}" style="border-bottom: 1px solid #666;">{~E:User^Record.CreatingIDUser^HeadlightSignatures-Row-Name~}</div>
					<span class="hl-signature-print">{~E:User^Record.CreatingIDUser^HeadlightSignatures-Row-Name~}</span>
				</div>
				<div class="column" data-signature-title>
					<label class="label">Title / Qualification</label>
					<span>{~E:User^Record.CreatingIDUser^HeadlightSignatures-Row-Title~}</span>
				</div>
				<div class="column" data-signature-date>
					<label class="label">Date</label>
					<span>{~DateFormatTZ:Record.UpdateDate^MMMM DD, YYYY - hh:mm a^AppData.DocumentData.ReportData.Timezone~}</span>
				</div>
			</div>
`,
		},
		{
			Hash: 'HeadlightSignatures-Row-Name',
			Template: /*html*/`
			{~D:Record.NameFirst~} {~D:Record.NameLast~}
`,
		},
		{
			Hash: 'HeadlightSignatures-Row-Title',
			Template: /*html*/`
			{~D:Record.Title~}
`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'HeadlightSignatures',
			TemplateHash: 'HeadlightSignatures',
			DestinationAddress: '#Headlight-View-Signatures'
		},
	]
};

},{"pict-view":733}],309:[function(require,module,exports){
module.exports = require('./lib/difflib');

},{"./lib/difflib":310}],310:[function(require,module,exports){
// Generated by CoffeeScript 2.6.1
(function() {
  /*
  Module difflib -- helpers for computing deltas between objects.

  Function getCloseMatches(word, possibilities, n=3, cutoff=0.6):
      Use SequenceMatcher to return list of the best "good enough" matches.

  Function contextDiff(a, b):
      For two lists of strings, return a delta in context diff format.

  Function ndiff(a, b):
      Return a delta: the difference between `a` and `b` (lists of strings).

  Function restore(delta, which):
      Return one of the two sequences that generated an ndiff delta.

  Function unifiedDiff(a, b):
      For two lists of strings, return a delta in unified diff format.

  Class SequenceMatcher:
      A flexible class for comparing pairs of sequences of any type.

  Class Differ:
      For producing human-readable deltas from sequences of lines of text.
  */
  var Differ, Heap, IS_CHARACTER_JUNK, IS_LINE_JUNK, SequenceMatcher, _any, _arrayCmp, _calculateRatio, _countLeading, _formatRangeContext, _formatRangeUnified, _has, assert, contextDiff, floor, getCloseMatches, max, min, ndiff, restore, unifiedDiff,
    indexOf = [].indexOf;

  // Requires
  ({floor, max, min} = Math);

  Heap = require('heap');

  assert = require('assert');

  // Helper functions
  _calculateRatio = function(matches, length) {
    if (length) {
      return 2.0 * matches / length;
    } else {
      return 1.0;
    }
  };

  _arrayCmp = function(a, b) {
    var i, l, la, lb, ref;
    [la, lb] = [a.length, b.length];
    for (i = l = 0, ref = min(la, lb); (0 <= ref ? l < ref : l > ref); i = 0 <= ref ? ++l : --l) {
      if (a[i] < b[i]) {
        return -1;
      }
      if (a[i] > b[i]) {
        return 1;
      }
    }
    return la - lb;
  };

  _has = function(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  };

  _any = function(items) {
    var item, l, len;
    for (l = 0, len = items.length; l < len; l++) {
      item = items[l];
      if (item) {
        return true;
      }
    }
    return false;
  };

  SequenceMatcher = class SequenceMatcher {
    /*
    SequenceMatcher is a flexible class for comparing pairs of sequences of
    any type, so long as the sequence elements are hashable.  The basic
    algorithm predates, and is a little fancier than, an algorithm
    published in the late 1980's by Ratcliff and Obershelp under the
    hyperbolic name "gestalt pattern matching".  The basic idea is to find
    the longest contiguous matching subsequence that contains no "junk"
    elements (R-O doesn't address junk).  The same idea is then applied
    recursively to the pieces of the sequences to the left and to the right
    of the matching subsequence.  This does not yield minimal edit
    sequences, but does tend to yield matches that "look right" to people.

    SequenceMatcher tries to compute a "human-friendly diff" between two
    sequences.  Unlike e.g. UNIX(tm) diff, the fundamental notion is the
    longest *contiguous* & junk-free matching subsequence.  That's what
    catches peoples' eyes.  The Windows(tm) windiff has another interesting
    notion, pairing up elements that appear uniquely in each sequence.
    That, and the method here, appear to yield more intuitive difference
    reports than does diff.  This method appears to be the least vulnerable
    to synching up on blocks of "junk lines", though (like blank lines in
    ordinary text files, or maybe "<P>" lines in HTML files).  That may be
    because this is the only method of the 3 that has a *concept* of
    "junk" <wink>.

    Example, comparing two strings, and considering blanks to be "junk":

    >>> isjunk = (c) -> c is ' '
    >>> s = new SequenceMatcher(isjunk,
                                'private Thread currentThread;',
                                'private volatile Thread currentThread;')

    .ratio() returns a float in [0, 1], measuring the "similarity" of the
    sequences.  As a rule of thumb, a .ratio() value over 0.6 means the
    sequences are close matches:

    >>> s.ratio().toPrecision(3)
    '0.866'

    If you're only interested in where the sequences match,
    .getMatchingBlocks() is handy:

    >>> for [a, b, size] in s.getMatchingBlocks()
    ...   console.log("a[#{a}] and b[#{b}] match for #{size} elements");
    a[0] and b[0] match for 8 elements
    a[8] and b[17] match for 21 elements
    a[29] and b[38] match for 0 elements

    Note that the last tuple returned by .get_matching_blocks() is always a
    dummy, (len(a), len(b), 0), and this is the only case in which the last
    tuple element (number of elements matched) is 0.

    If you want to know how to change the first sequence into the second,
    use .get_opcodes():

    >>> for [op, a1, a2, b1, b2] in s.getOpcodes()
    ...   console.log "#{op} a[#{a1}:#{a2}] b[#{b1}:#{b2}]"
    equal a[0:8] b[0:8]
    insert a[8:8] b[8:17]
    equal a[8:29] b[17:38]

    See the Differ class for a fancy human-friendly file differencer, which
    uses SequenceMatcher both to compare sequences of lines, and to compare
    sequences of characters within similar (near-matching) lines.

    See also function getCloseMatches() in this module, which shows how
    simple code building on SequenceMatcher can be used to do useful work.

    Timing:  Basic R-O is cubic time worst case and quadratic time expected
    case.  SequenceMatcher is quadratic time for the worst case and has
    expected-case behavior dependent in a complicated way on how many
    elements the sequences have in common; best case time is linear.

    Methods:

    constructor(isjunk=null, a='', b='')
        Construct a SequenceMatcher.

    setSeqs(a, b)
        Set the two sequences to be compared.

    setSeq1(a)
        Set the first sequence to be compared.

    setSeq2(b)
        Set the second sequence to be compared.

    findLongestMatch(alo, ahi, blo, bhi)
        Find longest matching block in a[alo:ahi] and b[blo:bhi].

    getMatchingBlocks()
        Return list of triples describing matching subsequences.

    getOpcodes()
        Return list of 5-tuples describing how to turn a into b.

    ratio()
        Return a measure of the sequences' similarity (float in [0,1]).

    quickRatio()
        Return an upper bound on .ratio() relatively quickly.

    realQuickRatio()
        Return an upper bound on ratio() very quickly.
    */
    constructor(isjunk1, a = '', b = '', autojunk = true) {
      this.isjunk = isjunk1;
      this.autojunk = autojunk;
      /*
      Construct a SequenceMatcher.

      Optional arg isjunk is null (the default), or a one-argument
      function that takes a sequence element and returns true iff the
      element is junk.  Null is equivalent to passing "(x) -> 0", i.e.
      no elements are considered to be junk.  For example, pass
          (x) -> x in ' \t'
      if you're comparing lines as sequences of characters, and don't
      want to synch up on blanks or hard tabs.

      Optional arg a is the first of two sequences to be compared.  By
      default, an empty string.  The elements of a must be hashable.  See
      also .setSeqs() and .setSeq1().

      Optional arg b is the second of two sequences to be compared.  By
      default, an empty string.  The elements of b must be hashable. See
      also .setSeqs() and .setSeq2().

      Optional arg autojunk should be set to false to disable the
      "automatic junk heuristic" that treats popular elements as junk
      (see module documentation for more information).
      */
      // Members:
      // a
      //      first sequence
      // b
      //      second sequence; differences are computed as "what do
      //      we need to do to 'a' to change it into 'b'?"
      // b2j
      //      for x in b, b2j[x] is a list of the indices (into b)
      //      at which x appears; junk elements do not appear
      // fullbcount
      //      for x in b, fullbcount[x] == the number of times x
      //      appears in b; only materialized if really needed (used
      //      only for computing quickRatio())
      // matchingBlocks
      //      a list of [i, j, k] triples, where a[i...i+k] == b[j...j+k];
      //      ascending & non-overlapping in i and in j; terminated by
      //      a dummy (len(a), len(b), 0) sentinel
      // opcodes
      //      a list of [tag, i1, i2, j1, j2] tuples, where tag is
      //      one of
      //          'replace'   a[i1...i2] should be replaced by b[j1...j2]
      //          'delete'    a[i1...i2] should be deleted
      //          'insert'    b[j1...j2] should be inserted
      //          'equal'     a[i1...i2] == b[j1...j2]
      // isjunk
      //      a user-supplied function taking a sequence element and
      //      returning true iff the element is "junk" -- this has
      //      subtle but helpful effects on the algorithm, which I'll
      //      get around to writing up someday <0.9 wink>.
      //      DON'T USE!  Only __chainB uses this.  Use isbjunk.
      // isbjunk
      //      for x in b, isbjunk(x) == isjunk(x) but much faster;
      //      DOES NOT WORK for x in a!
      // isbpopular
      //      for x in b, isbpopular(x) is true iff b is reasonably long
      //      (at least 200 elements) and x accounts for more than 1 + 1% of
      //      its elements (when autojunk is enabled).
      //      DOES NOT WORK for x in a!
      this.a = this.b = null;
      this.setSeqs(a, b);
    }

    setSeqs(a, b) {
      /* 
      Set the two sequences to be compared. 

      >>> s = new SequenceMatcher()
      >>> s.setSeqs('abcd', 'bcde')
      >>> s.ratio()
      0.75
      */
      this.setSeq1(a);
      return this.setSeq2(b);
    }

    setSeq1(a) {
      /* 
      Set the first sequence to be compared. 

      The second sequence to be compared is not changed.

      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
      >>> s.ratio()
      0.75
      >>> s.setSeq1('bcde')
      >>> s.ratio()
      1.0

      SequenceMatcher computes and caches detailed information about the
      second sequence, so if you want to compare one sequence S against
      many sequences, use .setSeq2(S) once and call .setSeq1(x)
      repeatedly for each of the other sequences.

      See also setSeqs() and setSeq2().
      */
      if (a === this.a) {
        return;
      }
      this.a = a;
      return this.matchingBlocks = this.opcodes = null;
    }

    setSeq2(b) {
      /*
      Set the second sequence to be compared. 

      The first sequence to be compared is not changed.

      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
      >>> s.ratio()
      0.75
      >>> s.setSeq2('abcd')
      >>> s.ratio()
      1.0

      SequenceMatcher computes and caches detailed information about the
      second sequence, so if you want to compare one sequence S against
      many sequences, use .setSeq2(S) once and call .setSeq1(x)
      repeatedly for each of the other sequences.

      See also setSeqs() and setSeq1().
      */
      if (b === this.b) {
        return;
      }
      this.b = b;
      this.matchingBlocks = this.opcodes = null;
      this.fullbcount = null;
      return this._chainB();
    }

    // For each element x in b, set b2j[x] to a list of the indices in
    // b where x appears; the indices are in increasing order; note that
    // the number of times x appears in b is b2j[x].length ...
    // when @isjunk is defined, junk elements don't show up in this
    // map at all, which stops the central findLongestMatch method
    // from starting any matching block at a junk element ...
    // also creates the fast isbjunk function ...
    // b2j also does not contain entries for "popular" elements, meaning
    // elements that account for more than 1 + 1% of the total elements, and
    // when the sequence is reasonably large (>= 200 elements); this can
    // be viewed as an adaptive notion of semi-junk, and yields an enormous
    // speedup when, e.g., comparing program files with hundreds of
    // instances of "return null;" ...
    // note that this is only called when b changes; so for cross-product
    // kinds of matches, it's best to call setSeq2 once, then setSeq1
    // repeatedly
    _chainB() {
      var b, b2j, elt, i, indices, isjunk, junk, l, len, n, ntest, popular;
      // Because isjunk is a user-defined function, and we test
      // for junk a LOT, it's important to minimize the number of calls.
      // Before the tricks described here, __chainB was by far the most
      // time-consuming routine in the whole module!  If anyone sees
      // Jim Roskind, thank him again for profile.py -- I never would
      // have guessed that.
      // The first trick is to build b2j ignoring the possibility
      // of junk.  I.e., we don't call isjunk at all yet.  Throwing
      // out the junk later is much cheaper than building b2j "right"
      // from the start.
      b = this.b;
      this.b2j = b2j = new Map();
      for (i = l = 0, len = b.length; l < len; i = ++l) {
        elt = b[i];
        if (!b2j.has(elt)) {
          b2j.set(elt, []);
        }
        indices = b2j.get(elt);
        indices.push(i);
      }
      // Purge junk elements
      junk = new Map();
      isjunk = this.isjunk;
      if (isjunk) {
        b2j.forEach(function(idxs, elt) {
          if (isjunk(elt)) {
            junk.set(elt, true);
            return b2j.delete(elt);
          }
        });
      }
      // Purge popular elements that are not junk
      popular = new Map();
      n = b.length;
      if (this.autojunk && n >= 200) {
        ntest = floor(n / 100) + 1;
        b2j.forEach(function(idxs, elt) {
          if (idxs.length > ntest) {
            popular.set(elt, true);
            return b2j.delete(elt);
          }
        });
      }
      // Now for x in b, isjunk(x) == x in junk, but the latter is much faster.
      // Sicne the number of *unique* junk elements is probably small, the
      // memory burden of keeping this set alive is likely trivial compared to
      // the size of b2j.
      this.isbjunk = function(b) {
        return junk.has(b);
      };
      return this.isbpopular = function(b) {
        return popular.has(b);
      };
    }

    findLongestMatch(alo, ahi, blo, bhi) {
      var a, b, b2j, besti, bestj, bestsize, i, isbjunk, j, j2len, jlist, k, l, len, m, newj2len, ref, ref1;
      /* 
      Find longest matching block in a[alo...ahi] and b[blo...bhi].  

      If isjunk is not defined:

      Return [i,j,k] such that a[i...i+k] is equal to b[j...j+k], where
          alo <= i <= i+k <= ahi
          blo <= j <= j+k <= bhi
      and for all [i',j',k'] meeting those conditions,
          k >= k'
          i <= i'
          and if i == i', j <= j'

      In other words, of all maximal matching blocks, return one that
      starts earliest in a, and of all those maximal matching blocks that
      start earliest in a, return the one that starts earliest in b.

      >>> isjunk = (x) -> x is ' '
      >>> s = new SequenceMatcher(isjunk, ' abcd', 'abcd abcd')
      >>> s.findLongestMatch(0, 5, 0, 9)
      [1, 0, 4]

      >>> s = new SequenceMatcher(null, 'ab', 'c')
      >>> s.findLongestMatch(0, 2, 0, 1)
      [0, 0, 0]
      */
      // CAUTION:  stripping common prefix or suffix would be incorrect.
      // E.g.,
      //    ab
      //    acab
      // Longest matching block is "ab", but if common prefix is
      // stripped, it's "a" (tied with "b").  UNIX(tm) diff does so
      // strip, so ends up claiming that ab is changed to acab by
      // inserting "ca" in the middle.  That's minimal but unintuitive:
      // "it's obvious" that someone inserted "ac" at the front.
      // Windiff ends up at the same place as diff, but by pairing up
      // the unique 'b's and then matching the first two 'a's.
      [a, b, b2j, isbjunk] = [this.a, this.b, this.b2j, this.isbjunk];
      [besti, bestj, bestsize] = [alo, blo, 0];
      // find longest junk-free match
      // during an iteration of the loop, j2len[j] = length of longest
      // junk-free match ending with a[i-1] and b[j]
      j2len = {};
      for (i = l = ref = alo, ref1 = ahi; (ref <= ref1 ? l < ref1 : l > ref1); i = ref <= ref1 ? ++l : --l) {
        // look at all instances of a[i] in b; note that because
        // b2j has no junk keys, the loop is skipped if a[i] is junk
        newj2len = {};
        jlist = [];
        if (b2j.has(a[i])) {
          jlist = b2j.get(a[i]);
        }
        for (m = 0, len = jlist.length; m < len; m++) {
          j = jlist[m];
          if (j < blo) {
            // a[i] matches b[j]
            continue;
          }
          if (j >= bhi) {
            break;
          }
          k = newj2len[j] = (j2len[j - 1] || 0) + 1;
          if (k > bestsize) {
            [besti, bestj, bestsize] = [i - k + 1, j - k + 1, k];
          }
        }
        j2len = newj2len;
      }
      // Extend the best by non-junk elements on each end.  In particular,
      // "popular" non-junk elements aren't in b2j, which greatly speeds
      // the inner loop above, but also means "the best" match so far
      // doesn't contain any junk *or* popular non-junk elements.
      while (besti > alo && bestj > blo && !isbjunk(b[bestj - 1]) && a[besti - 1] === b[bestj - 1]) {
        [besti, bestj, bestsize] = [besti - 1, bestj - 1, bestsize + 1];
      }
      while (besti + bestsize < ahi && bestj + bestsize < bhi && !isbjunk(b[bestj + bestsize]) && a[besti + bestsize] === b[bestj + bestsize]) {
        bestsize++;
      }
      // Now that we have a wholly interesting match (albeit possibly
      // empty!), we may as well suck up the matching junk on each
      // side of it too.  Can't think of a good reason not to, and it
      // saves post-processing the (possibly considerable) expense of
      // figuring out what to do with it.  In the case of an empty
      // interesting match, this is clearly the right thing to do,
      // because no other kind of match is possible in the regions.
      while (besti > alo && bestj > blo && isbjunk(b[bestj - 1]) && a[besti - 1] === b[bestj - 1]) {
        [besti, bestj, bestsize] = [besti - 1, bestj - 1, bestsize + 1];
      }
      while (besti + bestsize < ahi && bestj + bestsize < bhi && isbjunk(b[bestj + bestsize]) && a[besti + bestsize] === b[bestj + bestsize]) {
        bestsize++;
      }
      return [besti, bestj, bestsize];
    }

    getMatchingBlocks() {
      var ahi, alo, bhi, blo, i, i1, i2, j, j1, j2, k, k1, k2, l, la, lb, len, matchingBlocks, nonAdjacent, queue, x;
      if (this.matchingBlocks) {
        /*
        Return list of triples describing matching subsequences.

        Each triple is of the form [i, j, n], and means that
        a[i...i+n] == b[j...j+n].  The triples are monotonically increasing in
        i and in j.  it's also guaranteed that if
        [i, j, n] and [i', j', n'] are adjacent triples in the list, and
        the second is not the last triple in the list, then i+n != i' or
        j+n != j'.  IOW, adjacent triples never describe adjacent equal
        blocks.

        The last triple is a dummy, [a.length, b.length, 0], and is the only
        triple with n==0.

        >>> s = new SequenceMatcher(null, 'abxcd', 'abcd')
        >>> s.getMatchingBlocks()
        [[0, 0, 2], [3, 2, 2], [5, 4, 0]]

        */
        return this.matchingBlocks;
      }
      [la, lb] = [this.a.length, this.b.length];
      // This is most naturally expressed as a recursive algorithm, but
      // at least one user bumped into extreme use cases that exceeded
      // the recursion limit on their box.  So, now we maintain a list
      // ('queue`) of blocks we still need to look at, and append partial
      // results to `matching_blocks` in a loop; the matches are sorted
      // at the end.
      queue = [[0, la, 0, lb]];
      matchingBlocks = [];
      while (queue.length) {
        [alo, ahi, blo, bhi] = queue.pop();
        [i, j, k] = x = this.findLongestMatch(alo, ahi, blo, bhi);
        // a[alo...i] vs b[blo...j] unknown
        // a[i...i+k] same as b[j...j+k]
        // a[i+k...ahi] vs b[j+k...bhi] unknown
        if (k) {
          matchingBlocks.push(x);
          if (alo < i && blo < j) {
            queue.push([alo, i, blo, j]);
          }
          if (i + k < ahi && j + k < bhi) {
            queue.push([i + k, ahi, j + k, bhi]);
          }
        }
      }
      matchingBlocks.sort(_arrayCmp);
      // It's possible that we have adjacent equal blocks in the
      // matching_blocks list now. 
      i1 = j1 = k1 = 0;
      nonAdjacent = [];
      for (l = 0, len = matchingBlocks.length; l < len; l++) {
        [i2, j2, k2] = matchingBlocks[l];
        // Is this block adjacent to i1, j1, k1?
        if (i1 + k1 === i2 && j1 + k1 === j2) {
          // Yes, so collapse them -- this just increases the length of
          // the first block by the length of the second, and the first
          // block so lengthened remains the block to compare against.
          k1 += k2;
        } else {
          // Not adjacent.  Remember the first block (k1==0 means it's
          // the dummy we started with), and make the second block the
          // new block to compare against.
          if (k1) {
            nonAdjacent.push([i1, j1, k1]);
          }
          [i1, j1, k1] = [i2, j2, k2];
        }
      }
      if (k1) {
        nonAdjacent.push([i1, j1, k1]);
      }
      nonAdjacent.push([la, lb, 0]);
      return this.matchingBlocks = nonAdjacent;
    }

    getOpcodes() {
      var ai, answer, bj, i, j, l, len, ref, size, tag;
      if (this.opcodes) {
        /* 
        Return list of 5-tuples describing how to turn a into b.

        Each tuple is of the form [tag, i1, i2, j1, j2].  The first tuple
        has i1 == j1 == 0, and remaining tuples have i1 == the i2 from the
        tuple preceding it, and likewise for j1 == the previous j2.

        The tags are strings, with these meanings:

        'replace':  a[i1...i2] should be replaced by b[j1...j2]
        'delete':   a[i1...i2] should be deleted.
                    Note that j1==j2 in this case.
        'insert':   b[j1...j2] should be inserted at a[i1...i1].
                    Note that i1==i2 in this case.
        'equal':    a[i1...i2] == b[j1...j2]

        >>> s = new SequenceMatcher(null, 'qabxcd', 'abycdf')
        >>> s.getOpcodes()
        [ [ 'delete'  , 0 , 1 , 0 , 0 ] ,
          [ 'equal'   , 1 , 3 , 0 , 2 ] ,
          [ 'replace' , 3 , 4 , 2 , 3 ] ,
          [ 'equal'   , 4 , 6 , 3 , 5 ] ,
          [ 'insert'  , 6 , 6 , 5 , 6 ] ]
        */
        return this.opcodes;
      }
      i = j = 0;
      this.opcodes = answer = [];
      ref = this.getMatchingBlocks();
      for (l = 0, len = ref.length; l < len; l++) {
        [ai, bj, size] = ref[l];
        // invariant:  we've pumped out correct diffs to change
        // a[0...i] into b[0...j], and the next matching block is
        // a[ai...ai+size] == b[bj...bj+size].  So we need to pump
        // out a diff to change a[i:ai] into b[j...bj], pump out
        // the matching block, and move [i,j] beyond the match
        tag = '';
        if (i < ai && j < bj) {
          tag = 'replace';
        } else if (i < ai) {
          tag = 'delete';
        } else if (j < bj) {
          tag = 'insert';
        }
        if (tag) {
          answer.push([tag, i, ai, j, bj]);
        }
        [i, j] = [ai + size, bj + size];
        // the list of matching blocks is terminated by a
        // sentinel with size 0
        if (size) {
          answer.push(['equal', ai, i, bj, j]);
        }
      }
      return answer;
    }

    getGroupedOpcodes(n = 3) {
      /* 
      Isolate change clusters by eliminating ranges with no changes.

      Return a list groups with upto n lines of context.
      Each group is in the same format as returned by get_opcodes().

      >>> a = [1...40].map(String)
      >>> b = a.slice()
      >>> b[8...8] = 'i'
      >>> b[20] += 'x'
      >>> b[23...28] = []
      >>> b[30] += 'y'
      >>> s = new SequenceMatcher(null, a, b)
      >>> s.getGroupedOpcodes()
      [ [ [ 'equal'  , 5 , 8  , 5 , 8 ],
          [ 'insert' , 8 , 8  , 8 , 9 ],
          [ 'equal'  , 8 , 11 , 9 , 12 ] ],
        [ [ 'equal'   , 16 , 19 , 17 , 20 ],
          [ 'replace' , 19 , 20 , 20 , 21 ],
          [ 'equal'   , 20 , 22 , 21 , 23 ],
          [ 'delete'  , 22 , 27 , 23 , 23 ],
          [ 'equal'   , 27 , 30 , 23 , 26 ] ],
        [ [ 'equal'   , 31 , 34 , 27 , 30 ],
          [ 'replace' , 34 , 35 , 30 , 31 ],
          [ 'equal'   , 35 , 38 , 31 , 34 ] ] ]
      */
      var codes, group, groups, i1, i2, j1, j2, l, len, nn, tag;
      codes = this.getOpcodes();
      if (!codes.length) {
        codes = [['equal', 0, 1, 0, 1]];
      }
      // Fixup leading and trailing groups if they show no changes.
      if (codes[0][0] === 'equal') {
        [tag, i1, i2, j1, j2] = codes[0];
        codes[0] = [tag, max(i1, i2 - n), i2, max(j1, j2 - n), j2];
      }
      if (codes[codes.length - 1][0] === 'equal') {
        [tag, i1, i2, j1, j2] = codes[codes.length - 1];
        codes[codes.length - 1] = [tag, i1, min(i2, i1 + n), j1, min(j2, j1 + n)];
      }
      nn = n + n;
      groups = [];
      group = [];
      for (l = 0, len = codes.length; l < len; l++) {
        [tag, i1, i2, j1, j2] = codes[l];
        // End the current group and start a new one whenever
        // there is a large range with no changes.
        if (tag === 'equal' && i2 - i1 > nn) {
          group.push([tag, i1, min(i2, i1 + n), j1, min(j2, j1 + n)]);
          groups.push(group);
          group = [];
          [i1, j1] = [max(i1, i2 - n), max(j1, j2 - n)];
        }
        group.push([tag, i1, i2, j1, j2]);
      }
      if (group.length && !(group.length === 1 && group[0][0] === 'equal')) {
        groups.push(group);
      }
      return groups;
    }

    ratio() {
      /*
      Return a measure of the sequences' similarity (float in [0,1]).

      Where T is the total number of elements in both sequences, and
      M is the number of matches, this is 2.0*M / T.
      Note that this is 1 if the sequences are identical, and 0 if
      they have nothing in common.

      .ratio() is expensive to compute if you haven't already computed
      .getMatchingBlocks() or .getOpcodes(), in which case you may
      want to try .quickRatio() or .realQuickRatio() first to get an
      upper bound.

      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
      >>> s.ratio()
      0.75
      >>> s.quickRatio()
      0.75
      >>> s.realQuickRatio()
      1.0
      */
      var l, len, match, matches, ref;
      matches = 0;
      ref = this.getMatchingBlocks();
      for (l = 0, len = ref.length; l < len; l++) {
        match = ref[l];
        matches += match[2];
      }
      return _calculateRatio(matches, this.a.length + this.b.length);
    }

    quickRatio() {
      var avail, elt, fullbcount, l, len, len1, m, matches, numb, ref, ref1;
      /*
      Return an upper bound on ratio() relatively quickly.

      This isn't defined beyond that it is an upper bound on .ratio(), and
      is faster to compute.
      */
      // viewing a and b as multisets, set matches to the cardinality
      // of their intersection; this counts the number of matches
      // without regard to order, so is clearly an upper bound
      if (!this.fullbcount) {
        this.fullbcount = fullbcount = {};
        ref = this.b;
        for (l = 0, len = ref.length; l < len; l++) {
          elt = ref[l];
          fullbcount[elt] = (fullbcount[elt] || 0) + 1;
        }
      }
      fullbcount = this.fullbcount;
      // avail[x] is the number of times x appears in 'b' less the
      // number of times we've seen it in 'a' so far ... kinda
      avail = {};
      matches = 0;
      ref1 = this.a;
      for (m = 0, len1 = ref1.length; m < len1; m++) {
        elt = ref1[m];
        if (_has(avail, elt)) {
          numb = avail[elt];
        } else {
          numb = fullbcount[elt] || 0;
        }
        avail[elt] = numb - 1;
        if (numb > 0) {
          matches++;
        }
      }
      return _calculateRatio(matches, this.a.length + this.b.length);
    }

    realQuickRatio() {
      /*
      Return an upper bound on ratio() very quickly.

      This isn't defined beyond that it is an upper bound on .ratio(), and
      is faster to compute than either .ratio() or .quickRatio().
      */
      var la, lb;
      [la, lb] = [this.a.length, this.b.length];
      // can't have more matches than the number of elements in the
      // shorter sequence
      return _calculateRatio(min(la, lb), la + lb);
    }

  };

  getCloseMatches = function(word, possibilities, n = 3, cutoff = 0.6) {
    var l, len, len1, m, result, results, s, score, x;
    /*
    Use SequenceMatcher to return list of the best "good enough" matches.

    word is a sequence for which close matches are desired (typically a
    string).

    possibilities is a list of sequences against which to match word
    (typically a list of strings).

    Optional arg n (default 3) is the maximum number of close matches to
    return.  n must be > 0.

    Optional arg cutoff (default 0.6) is a float in [0, 1].  Possibilities
    that don't score at least that similar to word are ignored.

    The best (no more than n) matches among the possibilities are returned
    in a list, sorted by similarity score, most similar first.

    >>> getCloseMatches('appel', ['ape', 'apple', 'peach', 'puppy'])
    ['apple', 'ape']
    >>> KEYWORDS = require('coffee-script').RESERVED
    >>> getCloseMatches('wheel', KEYWORDS)
    ['when', 'while']
    >>> getCloseMatches('accost', KEYWORDS)
    ['const']
    */
    if (!(n > 0)) {
      throw new Error(`n must be > 0: (${n})`);
    }
    if (!((0.0 <= cutoff && cutoff <= 1.0))) {
      throw new Error(`cutoff must be in [0.0, 1.0]: (${cutoff})`);
    }
    result = [];
    s = new SequenceMatcher();
    s.setSeq2(word);
    for (l = 0, len = possibilities.length; l < len; l++) {
      x = possibilities[l];
      s.setSeq1(x);
      if (s.realQuickRatio() >= cutoff && s.quickRatio() >= cutoff && s.ratio() >= cutoff) {
        result.push([s.ratio(), x]);
      }
    }
    // Move the best scorers to head of list
    result = Heap.nlargest(result, n, _arrayCmp);
    results = [];
    for (m = 0, len1 = result.length; m < len1; m++) {
      [score, x] = result[m];
      // Strip scores for the best n matches
      results.push(x);
    }
    return results;
  };

  _countLeading = function(line, ch) {
    /*
    Return number of `ch` characters at the start of `line`.

    >>> _countLeading('   abc', ' ')
    3
    */
    var i, n;
    [i, n] = [0, line.length];
    while (i < n && line[i] === ch) {
      i++;
    }
    return i;
  };

  Differ = class Differ {
    /*
    Differ is a class for comparing sequences of lines of text, and
    producing human-readable differences or deltas.  Differ uses
    SequenceMatcher both to compare sequences of lines, and to compare
    sequences of characters within similar (near-matching) lines.

    Each line of a Differ delta begins with a two-letter code:

        '- '    line unique to sequence 1
        '+ '    line unique to sequence 2
        '  '    line common to both sequences
        '? '    line not present in either input sequence

    Lines beginning with '? ' attempt to guide the eye to intraline
    differences, and were not present in either input sequence.  These lines
    can be confusing if the sequences contain tab characters.

    Note that Differ makes no claim to produce a *minimal* diff.  To the
    contrary, minimal diffs are often counter-intuitive, because they synch
    up anywhere possible, sometimes accidental matches 100 pages apart.
    Restricting synch points to contiguous matches preserves some notion of
    locality, at the occasional cost of producing a longer diff.

    Example: Comparing two texts.

    >>> text1 = ['1. Beautiful is better than ugly.\n',
    ...   '2. Explicit is better than implicit.\n',
    ...   '3. Simple is better than complex.\n',
    ...   '4. Complex is better than complicated.\n']
    >>> text1.length
    4
    >>> text2 = ['1. Beautiful is better than ugly.\n',
    ...   '3.   Simple is better than complex.\n',
    ...   '4. Complicated is better than complex.\n',
    ...   '5. Flat is better than nested.\n']

    Next we instantiate a Differ object:

    >>> d = new Differ()

    Note that when instantiating a Differ object we may pass functions to
    filter out line and character 'junk'.

    Finally, we compare the two:

    >>> result = d.compare(text1, text2)
    [ '  1. Beautiful is better than ugly.\n',
      '- 2. Explicit is better than implicit.\n',
      '- 3. Simple is better than complex.\n',
      '+ 3.   Simple is better than complex.\n',
      '?   ++\n',
      '- 4. Complex is better than complicated.\n',
      '?          ^                     ---- ^\n',
      '+ 4. Complicated is better than complex.\n',
      '?         ++++ ^                      ^\n',
      '+ 5. Flat is better than nested.\n' ]

    Methods:

    constructor(linejunk=null, charjunk=null)
        Construct a text differencer, with optional filters.
    compare(a, b)
        Compare two sequences of lines; generate the resulting delta.
    */
    constructor(linejunk1, charjunk1) {
      this.linejunk = linejunk1;
      this.charjunk = charjunk1;
    }

    /*
    Construct a text differencer, with optional filters.

    The two optional keyword parameters are for filter functions:

    - `linejunk`: A function that should accept a single string argument,
      and return true iff the string is junk. The module-level function
      `IS_LINE_JUNK` may be used to filter out lines without visible
      characters, except for at most one splat ('#').  It is recommended
      to leave linejunk null. 

    - `charjunk`: A function that should accept a string of length 1. The
      module-level function `IS_CHARACTER_JUNK` may be used to filter out
      whitespace characters (a blank or tab; **note**: bad idea to include
      newline in this!).  Use of IS_CHARACTER_JUNK is recommended.
    */
    compare(a, b) {
      /*
      Compare two sequences of lines; generate the resulting delta.

      Each sequence must contain individual single-line strings ending with
      newlines. Such sequences can be obtained from the `readlines()` method
      of file-like objects.  The delta generated also consists of newline-
      terminated strings, ready to be printed as-is via the writeline()
      method of a file-like object.

      Example:

      >>> d = new Differ
      >>> d.compare(['one\n', 'two\n', 'three\n'],
      ...           ['ore\n', 'tree\n', 'emu\n'])
      [ '- one\n',
        '?  ^\n',
        '+ ore\n',
        '?  ^\n',
        '- two\n',
        '- three\n',
        '?  -\n',
        '+ tree\n',
        '+ emu\n' ]
      */
      var ahi, alo, bhi, blo, cruncher, g, l, len, len1, line, lines, m, ref, tag;
      cruncher = new SequenceMatcher(this.linejunk, a, b);
      lines = [];
      ref = cruncher.getOpcodes();
      for (l = 0, len = ref.length; l < len; l++) {
        [tag, alo, ahi, blo, bhi] = ref[l];
        switch (tag) {
          case 'replace':
            g = this._fancyReplace(a, alo, ahi, b, blo, bhi);
            break;
          case 'delete':
            g = this._dump('-', a, alo, ahi);
            break;
          case 'insert':
            g = this._dump('+', b, blo, bhi);
            break;
          case 'equal':
            g = this._dump(' ', a, alo, ahi);
            break;
          default:
            throw new Error(`unknow tag (${tag})`);
        }
        for (m = 0, len1 = g.length; m < len1; m++) {
          line = g[m];
          lines.push(line);
        }
      }
      return lines;
    }

    _dump(tag, x, lo, hi) {
      var i, l, ref, ref1, results;
      results = [];
      for (i = l = ref = lo, ref1 = hi; (ref <= ref1 ? l < ref1 : l > ref1); i = ref <= ref1 ? ++l : --l) {
        /*
        Generate comparison results for a same-tagged range.
        */
        results.push(`${tag} ${x[i]}`);
      }
      return results;
    }

    _plainReplace(a, alo, ahi, b, blo, bhi) {
      var first, g, l, len, len1, line, lines, m, ref, second;
      assert(alo < ahi && blo < bhi);
      // dump the shorter block first -- reduces the burden on short-term
      // memory if the blocks are of very different sizes
      if (bhi - blo < ahi - alo) {
        first = this._dump('+', b, blo, bhi);
        second = this._dump('-', a, alo, ahi);
      } else {
        first = this._dump('-', a, alo, ahi);
        second = this._dump('+', b, blo, bhi);
      }
      lines = [];
      ref = [first, second];
      for (l = 0, len = ref.length; l < len; l++) {
        g = ref[l];
        for (m = 0, len1 = g.length; m < len1; m++) {
          line = g[m];
          lines.push(line);
        }
      }
      return lines;
    }

    _fancyReplace(a, alo, ahi, b, blo, bhi) {
      var aelt, ai, ai1, ai2, atags, belt, bestRatio, besti, bestj, bj, bj1, bj2, btags, cruncher, cutoff, eqi, eqj, i, j, l, la, lb, len, len1, len2, len3, len4, line, lines, m, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, t, tag;
      /*
      When replacing one block of lines with another, search the blocks
      for *similar* lines; the best-matching pair (if any) is used as a
      synch point, and intraline difference marking is done on the
      similar pair. Lots of work, but often worth it.

      Example:
      >>> d = new Differ
      >>> d._fancyReplace(['abcDefghiJkl\n'], 0, 1,
      ...                 ['abcdefGhijkl\n'], 0, 1)
      [ '- abcDefghiJkl\n',
        '?    ^  ^  ^\n',
        '+ abcdefGhijkl\n',
        '?    ^  ^  ^\n' ]
      */
      // don't synch up unless the lines have a similarity score of at
      // least cutoff; best_ratio tracks the best score seen so far
      [bestRatio, cutoff] = [0.74, 0.75];
      cruncher = new SequenceMatcher(this.charjunk);
      [eqi, eqj] = [
        null,
        null // 1st indices of equal lines (if any)
      ];
      lines = [];
// search for the pair that matches best without being identical
// (identical lines must be junk lines, & we don't want to synch up
// on junk -- unless we have to)
      for (j = l = ref = blo, ref1 = bhi; (ref <= ref1 ? l < ref1 : l > ref1); j = ref <= ref1 ? ++l : --l) {
        bj = b[j];
        cruncher.setSeq2(bj);
        for (i = m = ref2 = alo, ref3 = ahi; (ref2 <= ref3 ? m < ref3 : m > ref3); i = ref2 <= ref3 ? ++m : --m) {
          ai = a[i];
          if (ai === bj) {
            if (eqi === null) {
              [eqi, eqj] = [i, j];
            }
            continue;
          }
          cruncher.setSeq1(ai);
          // computing similarity is expensive, so use the quick
          // upper bounds first -- have seen this speed up messy
          // compares by a factor of 3.
          // note that ratio() is only expensive to compute the first
          // time it's called on a sequence pair; the expensive part
          // of the computation is cached by cruncher
          if (cruncher.realQuickRatio() > bestRatio && cruncher.quickRatio() > bestRatio && cruncher.ratio() > bestRatio) {
            [bestRatio, besti, bestj] = [cruncher.ratio(), i, j];
          }
        }
      }
      if (bestRatio < cutoff) {
        // no non-identical "pretty close" pair
        if (eqi === null) {
          ref4 = this._plainReplace(a, alo, ahi, b, blo, bhi);
          // no identical pair either -- treat it as a straight replace
          for (o = 0, len = ref4.length; o < len; o++) {
            line = ref4[o];
            lines.push(line);
          }
          return lines;
        }
        // no close pair, but an identical pair -- synch up on that
        [besti, bestj, bestRatio] = [eqi, eqj, 1.0];
      } else {
        // there's a close pair, so forget the identical pair (if any)
        eqi = null;
      }
      ref5 = this._fancyHelper(a, alo, besti, b, blo, bestj);
      // a[besti] very similar to b[bestj]; eqi is null iff they're not
      // identical

      // pump out diffs from before the synch point
      for (p = 0, len1 = ref5.length; p < len1; p++) {
        line = ref5[p];
        lines.push(line);
      }
      // do intraline marking on the synch pair
      [aelt, belt] = [a[besti], b[bestj]];
      if (eqi === null) {
        // pump out a '-', '?', '+', '?' quad for the synched lines
        atags = btags = '';
        cruncher.setSeqs(aelt, belt);
        ref6 = cruncher.getOpcodes();
        for (q = 0, len2 = ref6.length; q < len2; q++) {
          [tag, ai1, ai2, bj1, bj2] = ref6[q];
          [la, lb] = [ai2 - ai1, bj2 - bj1];
          switch (tag) {
            case 'replace':
              atags += Array(la + 1).join('^');
              btags += Array(lb + 1).join('^');
              break;
            case 'delete':
              atags += Array(la + 1).join('-');
              break;
            case 'insert':
              btags += Array(lb + 1).join('+');
              break;
            case 'equal':
              atags += Array(la + 1).join(' ');
              btags += Array(lb + 1).join(' ');
              break;
            default:
              throw new Error(`unknow tag (${tag})`);
          }
        }
        ref7 = this._qformat(aelt, belt, atags, btags);
        for (r = 0, len3 = ref7.length; r < len3; r++) {
          line = ref7[r];
          lines.push(line);
        }
      } else {
        // the synch pair is identical
        lines.push('  ' + aelt);
      }
      ref8 = this._fancyHelper(a, besti + 1, ahi, b, bestj + 1, bhi);
      // pump out diffs from after the synch point
      for (t = 0, len4 = ref8.length; t < len4; t++) {
        line = ref8[t];
        lines.push(line);
      }
      return lines;
    }

    _fancyHelper(a, alo, ahi, b, blo, bhi) {
      var g;
      g = [];
      if (alo < ahi) {
        if (blo < bhi) {
          g = this._fancyReplace(a, alo, ahi, b, blo, bhi);
        } else {
          g = this._dump('-', a, alo, ahi);
        }
      } else if (blo < bhi) {
        g = this._dump('+', b, blo, bhi);
      }
      return g;
    }

    _qformat(aline, bline, atags, btags) {
      /*
      Format "?" output and deal with leading tabs.

      Example:

      >>> d = new Differ
      >>> d._qformat('\tabcDefghiJkl\n', '\tabcdefGhijkl\n',
      [ '- \tabcDefghiJkl\n',
        '? \t ^ ^  ^\n',
        '+ \tabcdefGhijkl\n',
        '? \t ^ ^  ^\n' ]
      */
      var common, lines;
      lines = [];
      // Can hurt, but will probably help most of the time.
      common = min(_countLeading(aline, '\t'), _countLeading(bline, '\t'));
      common = min(common, _countLeading(atags.slice(0, common), ' '));
      common = min(common, _countLeading(btags.slice(0, common), ' '));
      atags = atags.slice(common).replace(/\s+$/, '');
      btags = btags.slice(common).replace(/\s+$/, '');
      lines.push('- ' + aline);
      if (atags.length) {
        lines.push(`? ${Array(common + 1).join('\t')}${atags}\n`);
      }
      lines.push('+ ' + bline);
      if (btags.length) {
        lines.push(`? ${Array(common + 1).join('\t')}${btags}\n`);
      }
      return lines;
    }

  };

  // With respect to junk, an earlier version of ndiff simply refused to
  // *start* a match with a junk element.  The result was cases like this:
  //     before: private Thread currentThread;
  //     after:  private volatile Thread currentThread;
  // If you consider whitespace to be junk, the longest contiguous match
  // not starting with junk is "e Thread currentThread".  So ndiff reported
  // that "e volatil" was inserted between the 't' and the 'e' in "private".
  // While an accurate view, to people that's absurd.  The current version
  // looks for matching blocks that are entirely junk-free, then extends the
  // longest one of those as far as possible but only with matching junk.
  // So now "currentThread" is matched, then extended to suck up the
  // preceding blank; then "private" is matched, and extended to suck up the
  // following blank; then "Thread" is matched; and finally ndiff reports
  // that "volatile " was inserted before "Thread".  The only quibble
  // remaining is that perhaps it was really the case that " volatile"
  // was inserted after "private".  I can live with that <wink>.
  IS_LINE_JUNK = function(line, pat = /^\s*#?\s*$/) {
    /*
    Return 1 for ignorable line: iff `line` is blank or contains a single '#'.

    Examples:

    >>> IS_LINE_JUNK('\n')
    true
    >>> IS_LINE_JUNK('  #   \n')
    true
    >>> IS_LINE_JUNK('hello\n')
    false
    */
    return pat.test(line);
  };

  IS_CHARACTER_JUNK = function(ch, ws = ' \t') {
    /*
    Return 1 for ignorable character: iff `ch` is a space or tab.

    Examples:
    >>> IS_CHARACTER_JUNK(' ').should.be.true
    true
    >>> IS_CHARACTER_JUNK('\t').should.be.true
    true
    >>> IS_CHARACTER_JUNK('\n').should.be.false
    false
    >>> IS_CHARACTER_JUNK('x').should.be.false
    false
    */
    return indexOf.call(ws, ch) >= 0;
  };

  _formatRangeUnified = function(start, stop) {
    var beginning, length;
    /*
    Convert range to the "ed" format'
    */
    // Per the diff spec at http://www.unix.org/single_unix_specification/
    beginning = start + 1; // lines start numbering with one
    length = stop - start;
    if (length === 1) {
      return `${beginning}`;
    }
    if (!length) { // empty ranges begin at line just before the range
      beginning--;
    }
    return `${beginning},${length}`;
  };

  unifiedDiff = function(a, b, {fromfile, tofile, fromfiledate, tofiledate, n, lineterm} = {}) {
    var file1Range, file2Range, first, fromdate, group, i1, i2, j1, j2, l, last, len, len1, len2, len3, len4, line, lines, m, o, p, q, ref, ref1, ref2, ref3, started, tag, todate;
    /*
    Compare two sequences of lines; generate the delta as a unified diff.

    Unified diffs are a compact way of showing line changes and a few
    lines of context.  The number of context lines is set by 'n' which
    defaults to three.

    By default, the diff control lines (those with ---, +++, or @@) are
    created with a trailing newline.  

    For inputs that do not have trailing newlines, set the lineterm
    argument to "" so that the output will be uniformly newline free.

    The unidiff format normally has a header for filenames and modification
    times.  Any or all of these may be specified using strings for
    'fromfile', 'tofile', 'fromfiledate', and 'tofiledate'.
    The modification times are normally expressed in the ISO 8601 format.

    Example:

    >>> unifiedDiff('one two three four'.split(' '),
    ...             'zero one tree four'.split(' '), {
    ...               fromfile: 'Original'
    ...               tofile: 'Current',
    ...               fromfiledate: '2005-01-26 23:30:50',
    ...               tofiledate: '2010-04-02 10:20:52',
    ...               lineterm: ''
    ...             })
    [ '--- Original\t2005-01-26 23:30:50',
      '+++ Current\t2010-04-02 10:20:52',
      '@@ -1,4 +1,4 @@',
      '+zero',
      ' one',
      '-two',
      '-three',
      '+tree',
      ' four' ]

    */
    if (fromfile == null) {
      fromfile = '';
    }
    if (tofile == null) {
      tofile = '';
    }
    if (fromfiledate == null) {
      fromfiledate = '';
    }
    if (tofiledate == null) {
      tofiledate = '';
    }
    if (n == null) {
      n = 3;
    }
    if (lineterm == null) {
      lineterm = '\n';
    }
    lines = [];
    started = false;
    ref = (new SequenceMatcher(null, a, b)).getGroupedOpcodes();
    for (l = 0, len = ref.length; l < len; l++) {
      group = ref[l];
      if (!started) {
        started = true;
        fromdate = fromfiledate ? `\t${fromfiledate}` : '';
        todate = tofiledate ? `\t${tofiledate}` : '';
        lines.push(`--- ${fromfile}${fromdate}${lineterm}`);
        lines.push(`+++ ${tofile}${todate}${lineterm}`);
      }
      [first, last] = [group[0], group[group.length - 1]];
      file1Range = _formatRangeUnified(first[1], last[2]);
      file2Range = _formatRangeUnified(first[3], last[4]);
      lines.push(`@@ -${file1Range} +${file2Range} @@${lineterm}`);
      for (m = 0, len1 = group.length; m < len1; m++) {
        [tag, i1, i2, j1, j2] = group[m];
        if (tag === 'equal') {
          ref1 = a.slice(i1, i2);
          for (o = 0, len2 = ref1.length; o < len2; o++) {
            line = ref1[o];
            lines.push(' ' + line);
          }
          continue;
        }
        if (tag === 'replace' || tag === 'delete') {
          ref2 = a.slice(i1, i2);
          for (p = 0, len3 = ref2.length; p < len3; p++) {
            line = ref2[p];
            lines.push('-' + line);
          }
        }
        if (tag === 'replace' || tag === 'insert') {
          ref3 = b.slice(j1, j2);
          for (q = 0, len4 = ref3.length; q < len4; q++) {
            line = ref3[q];
            lines.push('+' + line);
          }
        }
      }
    }
    return lines;
  };

  _formatRangeContext = function(start, stop) {
    var beginning, length;
    /*
    Convert range to the "ed" format'
    */
    // Per the diff spec at http://www.unix.org/single_unix_specification/
    beginning = start + 1; // lines start numbering with one
    length = stop - start;
    if (!length) { // empty ranges begin at line just before the range
      beginning--;
    }
    if (length <= 1) {
      return `${beginning}`;
    }
    return `${beginning},${beginning + length - 1}`;
  };

  // See http://www.unix.org/single_unix_specification/
  contextDiff = function(a, b, {fromfile, tofile, fromfiledate, tofiledate, n, lineterm} = {}) {
    var _, file1Range, file2Range, first, fromdate, group, i1, i2, j1, j2, l, last, len, len1, len2, len3, len4, line, lines, m, o, p, prefix, q, ref, ref1, ref2, started, tag, todate;
    /*
    Compare two sequences of lines; generate the delta as a context diff.

    Context diffs are a compact way of showing line changes and a few
    lines of context.  The number of context lines is set by 'n' which
    defaults to three.

    By default, the diff control lines (those with *** or ---) are
    created with a trailing newline.  This is helpful so that inputs
    created from file.readlines() result in diffs that are suitable for
    file.writelines() since both the inputs and outputs have trailing
    newlines.

    For inputs that do not have trailing newlines, set the lineterm
    argument to "" so that the output will be uniformly newline free.

    The context diff format normally has a header for filenames and
    modification times.  Any or all of these may be specified using
    strings for 'fromfile', 'tofile', 'fromfiledate', and 'tofiledate'.
    The modification times are normally expressed in the ISO 8601 format.
    If not specified, the strings default to blanks.

    Example:
    >>> a = ['one\n', 'two\n', 'three\n', 'four\n']
    >>> b = ['zero\n', 'one\n', 'tree\n', 'four\n']
    >>> contextDiff(a, b, {fromfile: 'Original', tofile: 'Current'})
    [ '*** Original\n',
      '--- Current\n',
      '***************\n',
      '*** 1,4 ****\n',
      '  one\n',
      '! two\n',
      '! three\n',
      '  four\n',
      '--- 1,4 ----\n',
      '+ zero\n',
      '  one\n',
      '! tree\n',
      '  four\n' ]
    */
    if (fromfile == null) {
      fromfile = '';
    }
    if (tofile == null) {
      tofile = '';
    }
    if (fromfiledate == null) {
      fromfiledate = '';
    }
    if (tofiledate == null) {
      tofiledate = '';
    }
    if (n == null) {
      n = 3;
    }
    if (lineterm == null) {
      lineterm = '\n';
    }
    prefix = {
      insert: '+ ',
      delete: '- ',
      replace: '! ',
      equal: '  '
    };
    started = false;
    lines = [];
    ref = (new SequenceMatcher(null, a, b)).getGroupedOpcodes();
    for (l = 0, len = ref.length; l < len; l++) {
      group = ref[l];
      if (!started) {
        started = true;
        fromdate = fromfiledate ? `\t${fromfiledate}` : '';
        todate = tofiledate ? `\t${tofiledate}` : '';
        lines.push(`*** ${fromfile}${fromdate}${lineterm}`);
        lines.push(`--- ${tofile}${todate}${lineterm}`);
        [first, last] = [group[0], group[group.length - 1]];
        lines.push('***************' + lineterm);
        file1Range = _formatRangeContext(first[1], last[2]);
        lines.push(`*** ${file1Range} ****${lineterm}`);
        if (_any((function() {
          var len1, m, results;
          results = [];
          for (m = 0, len1 = group.length; m < len1; m++) {
            [tag, _, _, _, _] = group[m];
            results.push(tag === 'replace' || tag === 'delete');
          }
          return results;
        })())) {
          for (m = 0, len1 = group.length; m < len1; m++) {
            [tag, i1, i2, _, _] = group[m];
            if (tag !== 'insert') {
              ref1 = a.slice(i1, i2);
              for (o = 0, len2 = ref1.length; o < len2; o++) {
                line = ref1[o];
                lines.push(prefix[tag] + line);
              }
            }
          }
        }
        file2Range = _formatRangeContext(first[3], last[4]);
        lines.push(`--- ${file2Range} ----${lineterm}`);
        if (_any((function() {
          var len3, p, results;
          results = [];
          for (p = 0, len3 = group.length; p < len3; p++) {
            [tag, _, _, _, _] = group[p];
            results.push(tag === 'replace' || tag === 'insert');
          }
          return results;
        })())) {
          for (p = 0, len3 = group.length; p < len3; p++) {
            [tag, _, _, j1, j2] = group[p];
            if (tag !== 'delete') {
              ref2 = b.slice(j1, j2);
              for (q = 0, len4 = ref2.length; q < len4; q++) {
                line = ref2[q];
                lines.push(prefix[tag] + line);
              }
            }
          }
        }
      }
    }
    return lines;
  };

  ndiff = function(a, b, linejunk, charjunk = IS_CHARACTER_JUNK) {
    /*
    Compare `a` and `b` (lists of strings); return a `Differ`-style delta.

    Optional keyword parameters `linejunk` and `charjunk` are for filter
    functions (or None):

    - linejunk: A function that should accept a single string argument, and
      return true iff the string is junk.  The default is null, and is
      recommended; 

    - charjunk: A function that should accept a string of length 1. The
      default is module-level function IS_CHARACTER_JUNK, which filters out
      whitespace characters (a blank or tab; note: bad idea to include newline
      in this!).

    Example:
    >>> a = ['one\n', 'two\n', 'three\n']
    >>> b = ['ore\n', 'tree\n', 'emu\n']
    >>> ndiff(a, b)
    [ '- one\n',
      '?  ^\n',
      '+ ore\n',
      '?  ^\n',
      '- two\n',
      '- three\n',
      '?  -\n',
      '+ tree\n',
      '+ emu\n' ]
    */
    return (new Differ(linejunk, charjunk)).compare(a, b);
  };

  restore = function(delta, which) {
    /*
    Generate one of the two sequences that generated a delta.

    Given a `delta` produced by `Differ.compare()` or `ndiff()`, extract
    lines originating from file 1 or 2 (parameter `which`), stripping off line
    prefixes.

    Examples:
    >>> a = ['one\n', 'two\n', 'three\n']
    >>> b = ['ore\n', 'tree\n', 'emu\n']
    >>> diff = ndiff(a, b)
    >>> restore(diff, 1)
    [ 'one\n',
      'two\n',
      'three\n' ]
    >>> restore(diff, 2)
    [ 'ore\n',
      'tree\n',
      'emu\n' ]
    */
    var l, len, line, lines, prefixes, ref, tag;
    tag = {
      1: '- ',
      2: '+ '
    }[which];
    if (!tag) {
      throw new Error(`unknow delta choice (must be 1 or 2): ${which}`);
    }
    prefixes = ['  ', tag];
    lines = [];
    for (l = 0, len = delta.length; l < len; l++) {
      line = delta[l];
      if (ref = line.slice(0, 2), indexOf.call(prefixes, ref) >= 0) {
        lines.push(line.slice(2));
      }
    }
    return lines;
  };

  // exports to global
  exports._arrayCmp = _arrayCmp;

  exports.SequenceMatcher = SequenceMatcher;

  exports.getCloseMatches = getCloseMatches;

  exports._countLeading = _countLeading;

  exports.Differ = Differ;

  exports.IS_LINE_JUNK = IS_LINE_JUNK;

  exports.IS_CHARACTER_JUNK = IS_CHARACTER_JUNK;

  exports._formatRangeUnified = _formatRangeUnified;

  exports.unifiedDiff = unifiedDiff;

  exports._formatRangeContext = _formatRangeContext;

  exports.contextDiff = contextDiff;

  exports.ndiff = ndiff;

  exports.restore = restore;

}).call(this);

},{"assert":326,"heap":467}],311:[function(require,module,exports){
var asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');

},{"./asn1/api":312,"./asn1/base":314,"./asn1/constants":318,"./asn1/decoders":320,"./asn1/encoders":323,"bn.js":325}],312:[function(require,module,exports){
var asn1 = require('../asn1');
var inherits = require('inherits');

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = require('vm').runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

},{"../asn1":311,"inherits":495,"vm":822}],313:[function(require,module,exports){
var inherits = require('inherits');
var Reporter = require('../base').Reporter;
var Buffer = require('buffer').Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

},{"../base":314,"buffer":364,"inherits":495}],314:[function(require,module,exports){
var base = exports;

base.Reporter = require('./reporter').Reporter;
base.DecoderBuffer = require('./buffer').DecoderBuffer;
base.EncoderBuffer = require('./buffer').EncoderBuffer;
base.Node = require('./node');

},{"./buffer":313,"./node":315,"./reporter":316}],315:[function(require,module,exports){
var Reporter = require('../base').Reporter;
var EncoderBuffer = require('../base').EncoderBuffer;
var DecoderBuffer = require('../base').DecoderBuffer;
var assert = require('minimalistic-assert');

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"../base":314,"minimalistic-assert":524}],316:[function(require,module,exports){
var inherits = require('inherits');

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

},{"inherits":495}],317:[function(require,module,exports){
var constants = require('../constants');

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);

},{"../constants":318}],318:[function(require,module,exports){
var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');

},{"./der":317}],319:[function(require,module,exports){
var inherits = require('inherits');

var asn1 = require('../../asn1');
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}

},{"../../asn1":311,"inherits":495}],320:[function(require,module,exports){
var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');

},{"./der":319,"./pem":321}],321:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var DERDecoder = require('./der');

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

},{"./der":319,"buffer":364,"inherits":495}],322:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var asn1 = require('../../asn1');
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}

},{"../../asn1":311,"buffer":364,"inherits":495}],323:[function(require,module,exports){
var encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');

},{"./der":322,"./pem":324}],324:[function(require,module,exports){
var inherits = require('inherits');

var DEREncoder = require('./der');

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

},{"./der":322,"inherits":495}],325:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
      i++;
    }

    // Clear words above the requested width so the result stays below 2 ** width
    for (; i < this.length; i++) {
      this.words[i] = 0;
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    if (num === 0) {
      this.length = 1;
      this._normSign();
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.mod.abs();

    var half = num.abs().iushrn(1);
    var r2 = num.words[0] & 1;
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up, away from zero
    var up = new BN(1);
    up.negative = this.negative ^ num.negative;
    return dm.div.iadd(up);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":335}],326:[function(require,module,exports){
(function (global){(function (){
'use strict';

var objectAssign = require('object.assign/polyfill')();

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = require('util/');
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"object.assign/polyfill":530,"util/":329}],327:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],328:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],329:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./support/isBuffer":328,"_process":736,"inherits":327}],330:[function(require,module,exports){
(function (process,setImmediate){(function (){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.async = {}));
})(this, (function (exports) { 'use strict';

    /**
     * Creates a continuation function with some arguments already applied.
     *
     * Useful as a shorthand when combined with other control flow functions. Any
     * arguments passed to the returned function are added to the arguments
     * originally passed to apply.
     *
     * @name apply
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {Function} fn - The function you want to eventually apply all
     * arguments to. Invokes with (arguments...).
     * @param {...*} arguments... - Any number of arguments to automatically apply
     * when the continuation is called.
     * @returns {Function} the partially-applied function
     * @example
     *
     * // using apply
     * async.parallel([
     *     async.apply(fs.writeFile, 'testfile1', 'test1'),
     *     async.apply(fs.writeFile, 'testfile2', 'test2')
     * ]);
     *
     *
     * // the same process without using apply
     * async.parallel([
     *     function(callback) {
     *         fs.writeFile('testfile1', 'test1', callback);
     *     },
     *     function(callback) {
     *         fs.writeFile('testfile2', 'test2', callback);
     *     }
     * ]);
     *
     * // It's possible to pass any number of additional arguments when calling the
     * // continuation:
     *
     * node> var fn = async.apply(sys.puts, 'one');
     * node> fn('two', 'three');
     * one
     * two
     * three
     */
    function apply(fn, ...args) {
        return (...callArgs) => fn(...args,...callArgs);
    }

    function initialParams (fn) {
        return function (...args/*, callback*/) {
            var callback = args.pop();
            return fn.call(this, args, callback);
        };
    }

    /* istanbul ignore file */

    var hasQueueMicrotask = typeof queueMicrotask === 'function' && queueMicrotask;
    var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
    var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

    function fallback(fn) {
        setTimeout(fn, 0);
    }

    function wrap(defer) {
        return (fn, ...args) => defer(() => fn(...args));
    }

    var _defer$1;

    if (hasQueueMicrotask) {
        _defer$1 = queueMicrotask;
    } else if (hasSetImmediate) {
        _defer$1 = setImmediate;
    } else if (hasNextTick) {
        _defer$1 = process.nextTick;
    } else {
        _defer$1 = fallback;
    }

    var setImmediate$1 = wrap(_defer$1);

    /**
     * Take a sync function and make it async, passing its return value to a
     * callback. This is useful for plugging sync functions into a waterfall,
     * series, or other async functions. Any arguments passed to the generated
     * function will be passed to the wrapped function (except for the final
     * callback argument). Errors thrown will be passed to the callback.
     *
     * If the function passed to `asyncify` returns a Promise, that promises's
     * resolved/rejected state will be used to call the callback, rather than simply
     * the synchronous return value.
     *
     * This also means you can asyncify ES2017 `async` functions.
     *
     * @name asyncify
     * @static
     * @memberOf module:Utils
     * @method
     * @alias wrapSync
     * @category Util
     * @param {Function} func - The synchronous function, or Promise-returning
     * function to convert to an {@link AsyncFunction}.
     * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
     * invoked with `(args..., callback)`.
     * @example
     *
     * // passing a regular synchronous function
     * async.waterfall([
     *     async.apply(fs.readFile, filename, "utf8"),
     *     async.asyncify(JSON.parse),
     *     function (data, next) {
     *         // data is the result of parsing the text.
     *         // If there was a parsing error, it would have been caught.
     *     }
     * ], callback);
     *
     * // passing a function returning a promise
     * async.waterfall([
     *     async.apply(fs.readFile, filename, "utf8"),
     *     async.asyncify(function (contents) {
     *         return db.model.create(contents);
     *     }),
     *     function (model, next) {
     *         // `model` is the instantiated model object.
     *         // If there was an error, this function would be skipped.
     *     }
     * ], callback);
     *
     * // es2017 example, though `asyncify` is not needed if your JS environment
     * // supports async functions out of the box
     * var q = async.queue(async.asyncify(async function(file) {
     *     var intermediateStep = await processFile(file);
     *     return await somePromise(intermediateStep)
     * }));
     *
     * q.push(files);
     */
    function asyncify(func) {
        if (isAsync(func)) {
            return function (...args/*, callback*/) {
                const callback = args.pop();
                const promise = func.apply(this, args);
                return handlePromise(promise, callback)
            }
        }

        return initialParams(function (args, callback) {
            var result;
            try {
                result = func.apply(this, args);
            } catch (e) {
                return callback(e);
            }
            // if result is Promise object
            if (result && typeof result.then === 'function') {
                return handlePromise(result, callback)
            } else {
                callback(null, result);
            }
        });
    }

    function handlePromise(promise, callback) {
        return promise.then(value => {
            invokeCallback(callback, null, value);
        }, err => {
            invokeCallback(callback, err && (err instanceof Error || err.message) ? err : new Error(err));
        });
    }

    function invokeCallback(callback, error, value) {
        try {
            callback(error, value);
        } catch (err) {
            setImmediate$1(e => { throw e }, err);
        }
    }

    function isAsync(fn) {
        return fn[Symbol.toStringTag] === 'AsyncFunction';
    }

    function isAsyncGenerator(fn) {
        return fn[Symbol.toStringTag] === 'AsyncGenerator';
    }

    function isAsyncIterable(obj) {
        return typeof obj[Symbol.asyncIterator] === 'function';
    }

    function wrapAsync(asyncFn) {
        if (typeof asyncFn !== 'function') throw new Error('expected a function')
        return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
    }

    // conditionally promisify a function.
    // only return a promise if a callback is omitted
    function awaitify (asyncFn, arity) {
        if (!arity) arity = asyncFn.length;
        if (!arity) throw new Error('arity is undefined')
        function awaitable (...args) {
            if (typeof args[arity - 1] === 'function') {
                return asyncFn.apply(this, args)
            }

            return new Promise((resolve, reject) => {
                args[arity - 1] = (err, ...cbArgs) => {
                    if (err) return reject(err)
                    resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
                };
                asyncFn.apply(this, args);
            })
        }

        return awaitable
    }

    function applyEach$1 (eachfn) {
        return function applyEach(fns, ...callArgs) {
            const go = awaitify(function (callback) {
                var that = this;
                return eachfn(fns, (fn, cb) => {
                    wrapAsync(fn).apply(that, callArgs.concat(cb));
                }, callback);
            });
            return go;
        };
    }

    function _asyncMap(eachfn, arr, iteratee, callback) {
        arr = arr || [];
        var results = [];
        var counter = 0;
        var _iteratee = wrapAsync(iteratee);

        return eachfn(arr, (value, _, iterCb) => {
            var index = counter++;
            _iteratee(value, (err, v) => {
                results[index] = v;
                iterCb(err);
            });
        }, err => {
            callback(err, results);
        });
    }

    function isArrayLike(value) {
        return value &&
            typeof value.length === 'number' &&
            value.length >= 0 &&
            value.length % 1 === 0;
    }

    // A temporary value used to identify if the loop should be broken.
    // See #1064, #1293
    const breakLoop = {};

    function once(fn) {
        function wrapper (...args) {
            if (fn === null) return;
            var callFn = fn;
            fn = null;
            callFn.apply(this, args);
        }
        Object.assign(wrapper, fn);
        return wrapper
    }

    function getIterator (coll) {
        return coll[Symbol.iterator] && coll[Symbol.iterator]();
    }

    function createArrayIterator(coll) {
        var i = -1;
        var len = coll.length;
        return function next() {
            return ++i < len ? {value: coll[i], key: i} : null;
        }
    }

    function createES2015Iterator(iterator) {
        var i = -1;
        return function next() {
            var item = iterator.next();
            if (item.done)
                return null;
            i++;
            return {value: item.value, key: i};
        }
    }

    function createObjectIterator(obj) {
        var okeys = obj ? Object.keys(obj) : [];
        var i = -1;
        var len = okeys.length;
        return function next() {
            var key = okeys[++i];
            if (key === '__proto__') {
                return next();
            }
            return i < len ? {value: obj[key], key} : null;
        };
    }

    function createIterator(coll) {
        if (isArrayLike(coll)) {
            return createArrayIterator(coll);
        }

        var iterator = getIterator(coll);
        return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
    }

    function onlyOnce(fn) {
        return function (...args) {
            if (fn === null) throw new Error("Callback was already called.");
            var callFn = fn;
            fn = null;
            callFn.apply(this, args);
        };
    }

    // for async generators
    function asyncEachOfLimit(generator, limit, iteratee, callback) {
        let done = false;
        let canceled = false;
        let awaiting = false;
        let running = 0;
        let idx = 0;

        function replenish() {
            //console.log('replenish')
            if (running >= limit || awaiting || done) return
            //console.log('replenish awaiting')
            awaiting = true;
            generator.next().then(({value, done: iterDone}) => {
                //console.log('got value', value)
                if (canceled || done) return
                awaiting = false;
                if (iterDone) {
                    done = true;
                    if (running <= 0) {
                        //console.log('done nextCb')
                        callback(null);
                    }
                    return;
                }
                running++;
                iteratee(value, idx, iterateeCallback);
                idx++;
                replenish();
            }).catch(handleError);
        }

        function iterateeCallback(err, result) {
            //console.log('iterateeCallback')
            running -= 1;
            if (canceled) return
            if (err) return handleError(err)

            if (err === false) {
                done = true;
                canceled = true;
                return
            }

            if (result === breakLoop || (done && running <= 0)) {
                done = true;
                //console.log('done iterCb')
                return callback(null);
            }
            replenish();
        }

        function handleError(err) {
            if (canceled) return
            awaiting = false;
            done = true;
            callback(err);
        }

        replenish();
    }

    var eachOfLimit$2 = (limit) => {
        return (obj, iteratee, callback) => {
            callback = once(callback);
            if (limit <= 0) {
                throw new RangeError('concurrency limit cannot be less than 1')
            }
            if (!obj) {
                return callback(null);
            }
            if (isAsyncGenerator(obj)) {
                return asyncEachOfLimit(obj, limit, iteratee, callback)
            }
            if (isAsyncIterable(obj)) {
                return asyncEachOfLimit(obj[Symbol.asyncIterator](), limit, iteratee, callback)
            }
            var nextElem = createIterator(obj);
            var done = false;
            var canceled = false;
            var running = 0;
            var looping = false;

            function iterateeCallback(err, value) {
                if (canceled) return
                running -= 1;
                if (err) {
                    done = true;
                    callback(err);
                }
                else if (err === false) {
                    done = true;
                    canceled = true;
                }
                else if (value === breakLoop || (done && running <= 0)) {
                    done = true;
                    return callback(null);
                }
                else if (!looping) {
                    replenish();
                }
            }

            function replenish () {
                looping = true;
                while (running < limit && !done) {
                    var elem = nextElem();
                    if (elem === null) {
                        done = true;
                        if (running <= 0) {
                            callback(null);
                        }
                        return;
                    }
                    running += 1;
                    iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
                }
                looping = false;
            }

            replenish();
        };
    };

    /**
     * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name eachOfLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.eachOf]{@link module:Collections.eachOf}
     * @alias forEachOfLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each
     * item in `coll`. The `key` is the item's key, or index in the case of an
     * array.
     * Invoked with (item, key, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachOfLimit(coll, limit, iteratee, callback) {
        return eachOfLimit$2(limit)(coll, wrapAsync(iteratee), callback);
    }

    var eachOfLimit$1 = awaitify(eachOfLimit, 4);

    // eachOf implementation optimized for array-likes
    function eachOfArrayLike(coll, iteratee, callback) {
        callback = once(callback);
        var index = 0,
            completed = 0,
            {length} = coll,
            canceled = false;
        if (length === 0) {
            callback(null);
        }

        function iteratorCallback(err, value) {
            if (err === false) {
                canceled = true;
            }
            if (canceled === true) return
            if (err) {
                callback(err);
            } else if ((++completed === length) || value === breakLoop) {
                callback(null);
            }
        }

        for (; index < length; index++) {
            iteratee(coll[index], index, onlyOnce(iteratorCallback));
        }
    }

    // a generic version of eachOf which can handle array, object, and iterator cases.
    function eachOfGeneric (coll, iteratee, callback) {
        return eachOfLimit$1(coll, Infinity, iteratee, callback);
    }

    /**
     * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
     * to the iteratee.
     *
     * @name eachOf
     * @static
     * @memberOf module:Collections
     * @method
     * @alias forEachOf
     * @category Collection
     * @see [async.each]{@link module:Collections.each}
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each
     * item in `coll`.
     * The `key` is the item's key, or index in the case of an array.
     * Invoked with (item, key, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * // dev.json is a file containing a valid json object config for dev environment
     * // dev.json is a file containing a valid json object config for test environment
     * // prod.json is a file containing a valid json object config for prod environment
     * // invalid.json is a file with a malformed json object
     *
     * let configs = {}; //global variable
     * let validConfigFileMap = {dev: 'dev.json', test: 'test.json', prod: 'prod.json'};
     * let invalidConfigFileMap = {dev: 'dev.json', test: 'test.json', invalid: 'invalid.json'};
     *
     * // asynchronous function that reads a json file and parses the contents as json object
     * function parseFile(file, key, callback) {
     *     fs.readFile(file, "utf8", function(err, data) {
     *         if (err) return calback(err);
     *         try {
     *             configs[key] = JSON.parse(data);
     *         } catch (e) {
     *             return callback(e);
     *         }
     *         callback();
     *     });
     * }
     *
     * // Using callbacks
     * async.forEachOf(validConfigFileMap, parseFile, function (err) {
     *     if (err) {
     *         console.error(err);
     *     } else {
     *         console.log(configs);
     *         // configs is now a map of JSON data, e.g.
     *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
     *     }
     * });
     *
     * //Error handing
     * async.forEachOf(invalidConfigFileMap, parseFile, function (err) {
     *     if (err) {
     *         console.error(err);
     *         // JSON parse error exception
     *     } else {
     *         console.log(configs);
     *     }
     * });
     *
     * // Using Promises
     * async.forEachOf(validConfigFileMap, parseFile)
     * .then( () => {
     *     console.log(configs);
     *     // configs is now a map of JSON data, e.g.
     *     // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
     * }).catch( err => {
     *     console.error(err);
     * });
     *
     * //Error handing
     * async.forEachOf(invalidConfigFileMap, parseFile)
     * .then( () => {
     *     console.log(configs);
     * }).catch( err => {
     *     console.error(err);
     *     // JSON parse error exception
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.forEachOf(validConfigFileMap, parseFile);
     *         console.log(configs);
     *         // configs is now a map of JSON data, e.g.
     *         // { dev: //parsed dev.json, test: //parsed test.json, prod: //parsed prod.json}
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * //Error handing
     * async () => {
     *     try {
     *         let result = await async.forEachOf(invalidConfigFileMap, parseFile);
     *         console.log(configs);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // JSON parse error exception
     *     }
     * }
     *
     */
    function eachOf(coll, iteratee, callback) {
        var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
        return eachOfImplementation(coll, wrapAsync(iteratee), callback);
    }

    var eachOf$1 = awaitify(eachOf, 3);

    /**
     * Produces a new collection of values by mapping each value in `coll` through
     * the `iteratee` function. The `iteratee` is called with an item from `coll`
     * and a callback for when it has finished processing. Each of these callbacks
     * takes 2 arguments: an `error`, and the transformed item from `coll`. If
     * `iteratee` passes an error to its callback, the main `callback` (for the
     * `map` function) is immediately called with the error.
     *
     * Note, that since this function applies the `iteratee` to each item in
     * parallel, there is no guarantee that the `iteratee` functions will complete
     * in order. However, the results array will be in the same order as the
     * original `coll`.
     *
     * If `map` is passed an Object, the results will be an Array.  The results
     * will roughly be in the order of the original Objects' keys (but this can
     * vary across JavaScript engines).
     *
     * @name map
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with the transformed item.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Results is an Array of the
     * transformed items from the `coll`. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     * // file4.txt does not exist
     *
     * const fileList = ['file1.txt','file2.txt','file3.txt'];
     * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
     *
     * // asynchronous function that returns the file size in bytes
     * function getFileSizeInBytes(file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.map(fileList, getFileSizeInBytes, function(err, results) {
     *     if (err) {
     *         console.log(err);
     *     } else {
     *         console.log(results);
     *         // results is now an array of the file size in bytes for each file, e.g.
     *         // [ 1000, 2000, 3000]
     *     }
     * });
     *
     * // Error Handling
     * async.map(withMissingFileList, getFileSizeInBytes, function(err, results) {
     *     if (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     } else {
     *         console.log(results);
     *     }
     * });
     *
     * // Using Promises
     * async.map(fileList, getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     *     // results is now an array of the file size in bytes for each file, e.g.
     *     // [ 1000, 2000, 3000]
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.map(withMissingFileList, getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.map(fileList, getFileSizeInBytes);
     *         console.log(results);
     *         // results is now an array of the file size in bytes for each file, e.g.
     *         // [ 1000, 2000, 3000]
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let results = await async.map(withMissingFileList, getFileSizeInBytes);
     *         console.log(results);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function map (coll, iteratee, callback) {
        return _asyncMap(eachOf$1, coll, iteratee, callback)
    }
    var map$1 = awaitify(map, 3);

    /**
     * Applies the provided arguments to each function in the array, calling
     * `callback` after all functions have completed. If you only provide the first
     * argument, `fns`, then it will return a function which lets you pass in the
     * arguments as if it were a single function call. If more arguments are
     * provided, `callback` is required while `args` is still optional. The results
     * for each of the applied async functions are passed to the final callback
     * as an array.
     *
     * @name applyEach
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s
     * to all call with the same arguments
     * @param {...*} [args] - any number of separate arguments to pass to the
     * function.
     * @param {Function} [callback] - the final argument should be the callback,
     * called when all functions have completed processing.
     * @returns {AsyncFunction} - Returns a function that takes no args other than
     * an optional callback, that is the result of applying the `args` to each
     * of the functions.
     * @example
     *
     * const appliedFn = async.applyEach([enableSearch, updateSchema], 'bucket')
     *
     * appliedFn((err, results) => {
     *     // results[0] is the results for `enableSearch`
     *     // results[1] is the results for `updateSchema`
     * });
     *
     * // partial application example:
     * async.each(
     *     buckets,
     *     async (bucket) => async.applyEach([enableSearch, updateSchema], bucket)(),
     *     callback
     * );
     */
    var applyEach = applyEach$1(map$1);

    /**
     * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
     *
     * @name eachOfSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.eachOf]{@link module:Collections.eachOf}
     * @alias forEachOfSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * Invoked with (item, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachOfSeries(coll, iteratee, callback) {
        return eachOfLimit$1(coll, 1, iteratee, callback)
    }
    var eachOfSeries$1 = awaitify(eachOfSeries, 3);

    /**
     * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
     *
     * @name mapSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.map]{@link module:Collections.map}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with the transformed item.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Results is an array of the
     * transformed items from the `coll`. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapSeries (coll, iteratee, callback) {
        return _asyncMap(eachOfSeries$1, coll, iteratee, callback)
    }
    var mapSeries$1 = awaitify(mapSeries, 3);

    /**
     * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
     *
     * @name applyEachSeries
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.applyEach]{@link module:ControlFlow.applyEach}
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s to all
     * call with the same arguments
     * @param {...*} [args] - any number of separate arguments to pass to the
     * function.
     * @param {Function} [callback] - the final argument should be the callback,
     * called when all functions have completed processing.
     * @returns {AsyncFunction} - A function, that when called, is the result of
     * appling the `args` to the list of functions.  It takes no args, other than
     * a callback.
     */
    var applyEachSeries = applyEach$1(mapSeries$1);

    const PROMISE_SYMBOL = Symbol('promiseCallback');

    function promiseCallback () {
        let resolve, reject;
        function callback (err, ...args) {
            if (err) return reject(err)
            resolve(args.length > 1 ? args : args[0]);
        }

        callback[PROMISE_SYMBOL] = new Promise((res, rej) => {
            resolve = res,
            reject = rej;
        });

        return callback
    }

    /**
     * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
     * their requirements. Each function can optionally depend on other functions
     * being completed first, and each function is run as soon as its requirements
     * are satisfied.
     *
     * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
     * will stop. Further tasks will not execute (so any other functions depending
     * on it will not run), and the main `callback` is immediately called with the
     * error.
     *
     * {@link AsyncFunction}s also receive an object containing the results of functions which
     * have completed so far as the first argument, if they have dependencies. If a
     * task function has no dependencies, it will only be passed a callback.
     *
     * @name auto
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Object} tasks - An object. Each of its properties is either a
     * function or an array of requirements, with the {@link AsyncFunction} itself the last item
     * in the array. The object's key of a property serves as the name of the task
     * defined by that property, i.e. can be used when specifying requirements for
     * other tasks. The function receives one or two arguments:
     * * a `results` object, containing the results of the previously executed
     *   functions, only passed if the task has any dependencies,
     * * a `callback(err, result)` function, which must be called when finished,
     *   passing an `error` (which can be `null`) and the result of the function's
     *   execution.
     * @param {number} [concurrency=Infinity] - An optional `integer` for
     * determining the maximum number of tasks that can be run in parallel. By
     * default, as many as possible.
     * @param {Function} [callback] - An optional callback which is called when all
     * the tasks have been completed. It receives the `err` argument if any `tasks`
     * pass an error to their callback. Results are always returned; however, if an
     * error occurs, no further `tasks` will be performed, and the results object
     * will only contain partial results. Invoked with (err, results).
     * @returns {Promise} a promise, if a callback is not passed
     * @example
     *
     * //Using Callbacks
     * async.auto({
     *     get_data: function(callback) {
     *         // async code to get some data
     *         callback(null, 'data', 'converted to array');
     *     },
     *     make_folder: function(callback) {
     *         // async code to create a directory to store a file in
     *         // this is run at the same time as getting the data
     *         callback(null, 'folder');
     *     },
     *     write_file: ['get_data', 'make_folder', function(results, callback) {
     *         // once there is some data and the directory exists,
     *         // write the data to a file in the directory
     *         callback(null, 'filename');
     *     }],
     *     email_link: ['write_file', function(results, callback) {
     *         // once the file is written let's email a link to it...
     *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
     *     }]
     * }, function(err, results) {
     *     if (err) {
     *         console.log('err = ', err);
     *     }
     *     console.log('results = ', results);
     *     // results = {
     *     //     get_data: ['data', 'converted to array']
     *     //     make_folder; 'folder',
     *     //     write_file: 'filename'
     *     //     email_link: { file: 'filename', email: 'user@example.com' }
     *     // }
     * });
     *
     * //Using Promises
     * async.auto({
     *     get_data: function(callback) {
     *         console.log('in get_data');
     *         // async code to get some data
     *         callback(null, 'data', 'converted to array');
     *     },
     *     make_folder: function(callback) {
     *         console.log('in make_folder');
     *         // async code to create a directory to store a file in
     *         // this is run at the same time as getting the data
     *         callback(null, 'folder');
     *     },
     *     write_file: ['get_data', 'make_folder', function(results, callback) {
     *         // once there is some data and the directory exists,
     *         // write the data to a file in the directory
     *         callback(null, 'filename');
     *     }],
     *     email_link: ['write_file', function(results, callback) {
     *         // once the file is written let's email a link to it...
     *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
     *     }]
     * }).then(results => {
     *     console.log('results = ', results);
     *     // results = {
     *     //     get_data: ['data', 'converted to array']
     *     //     make_folder; 'folder',
     *     //     write_file: 'filename'
     *     //     email_link: { file: 'filename', email: 'user@example.com' }
     *     // }
     * }).catch(err => {
     *     console.log('err = ', err);
     * });
     *
     * //Using async/await
     * async () => {
     *     try {
     *         let results = await async.auto({
     *             get_data: function(callback) {
     *                 // async code to get some data
     *                 callback(null, 'data', 'converted to array');
     *             },
     *             make_folder: function(callback) {
     *                 // async code to create a directory to store a file in
     *                 // this is run at the same time as getting the data
     *                 callback(null, 'folder');
     *             },
     *             write_file: ['get_data', 'make_folder', function(results, callback) {
     *                 // once there is some data and the directory exists,
     *                 // write the data to a file in the directory
     *                 callback(null, 'filename');
     *             }],
     *             email_link: ['write_file', function(results, callback) {
     *                 // once the file is written let's email a link to it...
     *                 callback(null, {'file':results.write_file, 'email':'user@example.com'});
     *             }]
     *         });
     *         console.log('results = ', results);
     *         // results = {
     *         //     get_data: ['data', 'converted to array']
     *         //     make_folder; 'folder',
     *         //     write_file: 'filename'
     *         //     email_link: { file: 'filename', email: 'user@example.com' }
     *         // }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function auto(tasks, concurrency, callback) {
        if (typeof concurrency !== 'number') {
            // concurrency is optional, shift the args.
            callback = concurrency;
            concurrency = null;
        }
        callback = once(callback || promiseCallback());
        var numTasks = Object.keys(tasks).length;
        if (!numTasks) {
            return callback(null);
        }
        if (!concurrency) {
            concurrency = numTasks;
        }

        var results = {};
        var runningTasks = 0;
        var canceled = false;
        var hasError = false;

        var listeners = Object.create(null);

        var readyTasks = [];

        // for cycle detection:
        var readyToCheck = []; // tasks that have been identified as reachable
        // without the possibility of returning to an ancestor task
        var uncheckedDependencies = {};

        Object.keys(tasks).forEach(key => {
            var task = tasks[key];
            if (!Array.isArray(task)) {
                // no dependencies
                enqueueTask(key, [task]);
                readyToCheck.push(key);
                return;
            }

            var dependencies = task.slice(0, task.length - 1);
            var remainingDependencies = dependencies.length;
            if (remainingDependencies === 0) {
                enqueueTask(key, task);
                readyToCheck.push(key);
                return;
            }
            uncheckedDependencies[key] = remainingDependencies;

            dependencies.forEach(dependencyName => {
                if (!tasks[dependencyName]) {
                    throw new Error('async.auto task `' + key +
                        '` has a non-existent dependency `' +
                        dependencyName + '` in ' +
                        dependencies.join(', '));
                }
                addListener(dependencyName, () => {
                    remainingDependencies--;
                    if (remainingDependencies === 0) {
                        enqueueTask(key, task);
                    }
                });
            });
        });

        checkForDeadlocks();
        processQueue();

        function enqueueTask(key, task) {
            readyTasks.push(() => runTask(key, task));
        }

        function processQueue() {
            if (canceled) return
            if (readyTasks.length === 0 && runningTasks === 0) {
                return callback(null, results);
            }
            while(readyTasks.length && runningTasks < concurrency) {
                var run = readyTasks.shift();
                run();
            }

        }

        function addListener(taskName, fn) {
            var taskListeners = listeners[taskName];
            if (!taskListeners) {
                taskListeners = listeners[taskName] = [];
            }

            taskListeners.push(fn);
        }

        function taskComplete(taskName) {
            var taskListeners = listeners[taskName] || [];
            taskListeners.forEach(fn => fn());
            processQueue();
        }


        function runTask(key, task) {
            if (hasError) return;

            var taskCallback = onlyOnce((err, ...result) => {
                runningTasks--;
                if (err === false) {
                    canceled = true;
                    return
                }
                if (result.length < 2) {
                    [result] = result;
                }
                if (err) {
                    var safeResults = {};
                    Object.keys(results).forEach(rkey => {
                        safeResults[rkey] = results[rkey];
                    });
                    safeResults[key] = result;
                    hasError = true;
                    listeners = Object.create(null);
                    if (canceled) return
                    callback(err, safeResults);
                } else {
                    results[key] = result;
                    taskComplete(key);
                }
            });

            runningTasks++;
            var taskFn = wrapAsync(task[task.length - 1]);
            if (task.length > 1) {
                taskFn(results, taskCallback);
            } else {
                taskFn(taskCallback);
            }
        }

        function checkForDeadlocks() {
            // Kahn's algorithm
            // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
            // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
            var currentTask;
            var counter = 0;
            while (readyToCheck.length) {
                currentTask = readyToCheck.pop();
                counter++;
                getDependents(currentTask).forEach(dependent => {
                    if (--uncheckedDependencies[dependent] === 0) {
                        readyToCheck.push(dependent);
                    }
                });
            }

            if (counter !== numTasks) {
                throw new Error(
                    'async.auto cannot execute tasks due to a recursive dependency'
                );
            }
        }

        function getDependents(taskName) {
            var result = [];
            Object.keys(tasks).forEach(key => {
                const task = tasks[key];
                if (Array.isArray(task) && task.indexOf(taskName) >= 0) {
                    result.push(key);
                }
            });
            return result;
        }

        return callback[PROMISE_SYMBOL]
    }

    var FN_ARGS = /^(?:async\s)?(?:function)?\s*(?:\w+\s*)?\(([^)]+)\)(?:\s*{)/;
    var ARROW_FN_ARGS = /^(?:async\s)?\s*(?:\(\s*)?((?:[^)=\s]\s*)*)(?:\)\s*)?=>/;
    var FN_ARG_SPLIT = /,/;
    var FN_ARG = /(=.+)?(\s*)$/;

    function stripComments(string) {
        let stripped = '';
        let index = 0;
        let endBlockComment = string.indexOf('*/');
        while (index < string.length) {
            if (string[index] === '/' && string[index+1] === '/') {
                // inline comment
                let endIndex = string.indexOf('\n', index);
                index = (endIndex === -1) ? string.length : endIndex;
            } else if ((endBlockComment !== -1) && (string[index] === '/') && (string[index+1] === '*')) {
                // block comment
                let endIndex = string.indexOf('*/', index);
                if (endIndex !== -1) {
                    index = endIndex + 2;
                    endBlockComment = string.indexOf('*/', index);
                } else {
                    stripped += string[index];
                    index++;
                }
            } else {
                stripped += string[index];
                index++;
            }
        }
        return stripped;
    }

    function parseParams(func) {
        const src = stripComments(func.toString());
        let match = src.match(FN_ARGS);
        if (!match) {
            match = src.match(ARROW_FN_ARGS);
        }
        if (!match) throw new Error('could not parse args in autoInject\nSource:\n' + src)
        let [, args] = match;
        return args
            .replace(/\s/g, '')
            .split(FN_ARG_SPLIT)
            .map((arg) => arg.replace(FN_ARG, '').trim());
    }

    /**
     * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
     * tasks are specified as parameters to the function, after the usual callback
     * parameter, with the parameter names matching the names of the tasks it
     * depends on. This can provide even more readable task graphs which can be
     * easier to maintain.
     *
     * If a final callback is specified, the task results are similarly injected,
     * specified as named parameters after the initial error parameter.
     *
     * The autoInject function is purely syntactic sugar and its semantics are
     * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
     *
     * @name autoInject
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.auto]{@link module:ControlFlow.auto}
     * @category Control Flow
     * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
     * the form 'func([dependencies...], callback). The object's key of a property
     * serves as the name of the task defined by that property, i.e. can be used
     * when specifying requirements for other tasks.
     * * The `callback` parameter is a `callback(err, result)` which must be called
     *   when finished, passing an `error` (which can be `null`) and the result of
     *   the function's execution. The remaining parameters name other tasks on
     *   which the task is dependent, and the results from those tasks are the
     *   arguments of those parameters.
     * @param {Function} [callback] - An optional callback which is called when all
     * the tasks have been completed. It receives the `err` argument if any `tasks`
     * pass an error to their callback, and a `results` object with any completed
     * task results, similar to `auto`.
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * //  The example from `auto` can be rewritten as follows:
     * async.autoInject({
     *     get_data: function(callback) {
     *         // async code to get some data
     *         callback(null, 'data', 'converted to array');
     *     },
     *     make_folder: function(callback) {
     *         // async code to create a directory to store a file in
     *         // this is run at the same time as getting the data
     *         callback(null, 'folder');
     *     },
     *     write_file: function(get_data, make_folder, callback) {
     *         // once there is some data and the directory exists,
     *         // write the data to a file in the directory
     *         callback(null, 'filename');
     *     },
     *     email_link: function(write_file, callback) {
     *         // once the file is written let's email a link to it...
     *         // write_file contains the filename returned by write_file.
     *         callback(null, {'file':write_file, 'email':'user@example.com'});
     *     }
     * }, function(err, results) {
     *     console.log('err = ', err);
     *     console.log('email_link = ', results.email_link);
     * });
     *
     * // If you are using a JS minifier that mangles parameter names, `autoInject`
     * // will not work with plain functions, since the parameter names will be
     * // collapsed to a single letter identifier.  To work around this, you can
     * // explicitly specify the names of the parameters your task function needs
     * // in an array, similar to Angular.js dependency injection.
     *
     * // This still has an advantage over plain `auto`, since the results a task
     * // depends on are still spread into arguments.
     * async.autoInject({
     *     //...
     *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
     *         callback(null, 'filename');
     *     }],
     *     email_link: ['write_file', function(write_file, callback) {
     *         callback(null, {'file':write_file, 'email':'user@example.com'});
     *     }]
     *     //...
     * }, function(err, results) {
     *     console.log('err = ', err);
     *     console.log('email_link = ', results.email_link);
     * });
     */
    function autoInject(tasks, callback) {
        var newTasks = {};

        Object.keys(tasks).forEach(key => {
            var taskFn = tasks[key];
            var params;
            var fnIsAsync = isAsync(taskFn);
            var hasNoDeps =
                (!fnIsAsync && taskFn.length === 1) ||
                (fnIsAsync && taskFn.length === 0);

            if (Array.isArray(taskFn)) {
                params = [...taskFn];
                taskFn = params.pop();

                newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
            } else if (hasNoDeps) {
                // no dependencies, use the function as-is
                newTasks[key] = taskFn;
            } else {
                params = parseParams(taskFn);
                if ((taskFn.length === 0 && !fnIsAsync) && params.length === 0) {
                    throw new Error("autoInject task functions require explicit parameters.");
                }

                // remove callback param
                if (!fnIsAsync) params.pop();

                newTasks[key] = params.concat(newTask);
            }

            function newTask(results, taskCb) {
                var newArgs = params.map(name => results[name]);
                newArgs.push(taskCb);
                wrapAsync(taskFn)(...newArgs);
            }
        });

        return auto(newTasks, callback);
    }

    // Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
    // used for queues. This implementation assumes that the node provided by the user can be modified
    // to adjust the next and last properties. We implement only the minimal functionality
    // for queue support.
    class DLL {
        constructor() {
            this.head = this.tail = null;
            this.length = 0;
        }

        removeLink(node) {
            if (node.prev) node.prev.next = node.next;
            else this.head = node.next;
            if (node.next) node.next.prev = node.prev;
            else this.tail = node.prev;

            node.prev = node.next = null;
            this.length -= 1;
            return node;
        }

        empty () {
            while(this.head) this.shift();
            return this;
        }

        insertAfter(node, newNode) {
            newNode.prev = node;
            newNode.next = node.next;
            if (node.next) node.next.prev = newNode;
            else this.tail = newNode;
            node.next = newNode;
            this.length += 1;
        }

        insertBefore(node, newNode) {
            newNode.prev = node.prev;
            newNode.next = node;
            if (node.prev) node.prev.next = newNode;
            else this.head = newNode;
            node.prev = newNode;
            this.length += 1;
        }

        unshift(node) {
            if (this.head) this.insertBefore(this.head, node);
            else setInitial(this, node);
        }

        push(node) {
            if (this.tail) this.insertAfter(this.tail, node);
            else setInitial(this, node);
        }

        shift() {
            return this.head && this.removeLink(this.head);
        }

        pop() {
            return this.tail && this.removeLink(this.tail);
        }

        toArray() {
            return [...this]
        }

        *[Symbol.iterator] () {
            var cur = this.head;
            while (cur) {
                yield cur.data;
                cur = cur.next;
            }
        }

        remove (testFn) {
            var curr = this.head;
            while(curr) {
                var {next} = curr;
                if (testFn(curr)) {
                    this.removeLink(curr);
                }
                curr = next;
            }
            return this;
        }
    }

    function setInitial(dll, node) {
        dll.length = 1;
        dll.head = dll.tail = node;
    }

    function queue$1(worker, concurrency, payload) {
        if (concurrency == null) {
            concurrency = 1;
        }
        else if(concurrency === 0) {
            throw new RangeError('Concurrency must not be zero');
        }

        var _worker = wrapAsync(worker);
        var numRunning = 0;
        var workersList = [];
        const events = {
            error: [],
            drain: [],
            saturated: [],
            unsaturated: [],
            empty: []
        };

        function on (event, handler) {
            events[event].push(handler);
        }

        function once (event, handler) {
            const handleAndRemove = (...args) => {
                off(event, handleAndRemove);
                handler(...args);
            };
            events[event].push(handleAndRemove);
        }

        function off (event, handler) {
            if (!event) return Object.keys(events).forEach(ev => events[ev] = [])
            if (!handler) return events[event] = []
            events[event] = events[event].filter(ev => ev !== handler);
        }

        function trigger (event, ...args) {
            events[event].forEach(handler => handler(...args));
        }

        var processingScheduled = false;
        function _insert(data, insertAtFront, rejectOnError, callback) {
            if (callback != null && typeof callback !== 'function') {
                throw new Error('task callback must be a function');
            }
            q.started = true;

            var res, rej;
            function promiseCallback (err, ...args) {
                // we don't care about the error, let the global error handler
                // deal with it
                if (err) return rejectOnError ? rej(err) : res()
                if (args.length <= 1) return res(args[0])
                res(args);
            }

            var item = q._createTaskItem(
                data,
                rejectOnError ? promiseCallback :
                    (callback || promiseCallback)
            );

            if (insertAtFront) {
                q._tasks.unshift(item);
            } else {
                q._tasks.push(item);
            }

            if (!processingScheduled) {
                processingScheduled = true;
                setImmediate$1(() => {
                    processingScheduled = false;
                    q.process();
                });
            }

            if (rejectOnError || !callback) {
                return new Promise((resolve, reject) => {
                    res = resolve;
                    rej = reject;
                })
            }
        }

        function _createCB(tasks) {
            return function (err, ...args) {
                numRunning -= 1;

                for (var i = 0, l = tasks.length; i < l; i++) {
                    var task = tasks[i];

                    var index = workersList.indexOf(task);
                    if (index === 0) {
                        workersList.shift();
                    } else if (index > 0) {
                        workersList.splice(index, 1);
                    }

                    task.callback(err, ...args);

                    if (err != null) {
                        trigger('error', err, task.data);
                    }
                }

                if (numRunning <= (q.concurrency - q.buffer) ) {
                    trigger('unsaturated');
                }

                if (q.idle()) {
                    trigger('drain');
                }
                q.process();
            };
        }

        function _maybeDrain(data) {
            if (data.length === 0 && q.idle()) {
                // call drain immediately if there are no tasks
                setImmediate$1(() => trigger('drain'));
                return true
            }
            return false
        }

        const eventMethod = (name) => (handler) => {
            if (!handler) {
                return new Promise((resolve, reject) => {
                    once(name, (err, data) => {
                        if (err) return reject(err)
                        resolve(data);
                    });
                })
            }
            off(name);
            on(name, handler);

        };

        var isProcessing = false;
        var q = {
            _tasks: new DLL(),
            _createTaskItem (data, callback) {
                return {
                    data,
                    callback
                };
            },
            *[Symbol.iterator] () {
                yield* q._tasks[Symbol.iterator]();
            },
            concurrency,
            payload,
            buffer: concurrency / 4,
            started: false,
            paused: false,
            push (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, false, false, callback))
                }
                return _insert(data, false, false, callback);
            },
            pushAsync (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, false, true, callback))
                }
                return _insert(data, false, true, callback);
            },
            kill () {
                off();
                q._tasks.empty();
            },
            unshift (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, true, false, callback))
                }
                return _insert(data, true, false, callback);
            },
            unshiftAsync (data, callback) {
                if (Array.isArray(data)) {
                    if (_maybeDrain(data)) return
                    return data.map(datum => _insert(datum, true, true, callback))
                }
                return _insert(data, true, true, callback);
            },
            remove (testFn) {
                q._tasks.remove(testFn);
            },
            process () {
                // Avoid trying to start too many processing operations. This can occur
                // when callbacks resolve synchronously (#1267).
                if (isProcessing) {
                    return;
                }
                isProcessing = true;
                while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                    var tasks = [], data = [];
                    var l = q._tasks.length;
                    if (q.payload) l = Math.min(l, q.payload);
                    for (var i = 0; i < l; i++) {
                        var node = q._tasks.shift();
                        tasks.push(node);
                        workersList.push(node);
                        data.push(node.data);
                    }

                    numRunning += 1;

                    if (q._tasks.length === 0) {
                        trigger('empty');
                    }

                    if (numRunning === q.concurrency) {
                        trigger('saturated');
                    }

                    var cb = onlyOnce(_createCB(tasks));
                    _worker(data, cb);
                }
                isProcessing = false;
            },
            length () {
                return q._tasks.length;
            },
            running () {
                return numRunning;
            },
            workersList () {
                return workersList;
            },
            idle() {
                return q._tasks.length + numRunning === 0;
            },
            pause () {
                q.paused = true;
            },
            resume () {
                if (q.paused === false) { return; }
                q.paused = false;
                setImmediate$1(q.process);
            }
        };
        // define these as fixed properties, so people get useful errors when updating
        Object.defineProperties(q, {
            saturated: {
                writable: false,
                value: eventMethod('saturated')
            },
            unsaturated: {
                writable: false,
                value: eventMethod('unsaturated')
            },
            empty: {
                writable: false,
                value: eventMethod('empty')
            },
            drain: {
                writable: false,
                value: eventMethod('drain')
            },
            error: {
                writable: false,
                value: eventMethod('error')
            },
        });
        return q;
    }

    /**
     * Creates a `cargo` object with the specified payload. Tasks added to the
     * cargo will be processed altogether (up to the `payload` limit). If the
     * `worker` is in progress, the task is queued until it becomes available. Once
     * the `worker` has completed some tasks, each callback of those tasks is
     * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
     * for how `cargo` and `queue` work.
     *
     * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
     * at a time, cargo passes an array of tasks to a single worker, repeating
     * when the worker is finished.
     *
     * @name cargo
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.queue]{@link module:ControlFlow.queue}
     * @category Control Flow
     * @param {AsyncFunction} worker - An asynchronous function for processing an array
     * of queued tasks. Invoked with `(tasks, callback)`.
     * @param {number} [payload=Infinity] - An optional `integer` for determining
     * how many tasks should be processed per round; if omitted, the default is
     * unlimited.
     * @returns {module:ControlFlow.QueueObject} A cargo object to manage the tasks. Callbacks can
     * attached as certain properties to listen for specific events during the
     * lifecycle of the cargo and inner queue.
     * @example
     *
     * // create a cargo object with payload 2
     * var cargo = async.cargo(function(tasks, callback) {
     *     for (var i=0; i<tasks.length; i++) {
     *         console.log('hello ' + tasks[i].name);
     *     }
     *     callback();
     * }, 2);
     *
     * // add some items
     * cargo.push({name: 'foo'}, function(err) {
     *     console.log('finished processing foo');
     * });
     * cargo.push({name: 'bar'}, function(err) {
     *     console.log('finished processing bar');
     * });
     * await cargo.push({name: 'baz'});
     * console.log('finished processing baz');
     */
    function cargo$1(worker, payload) {
        return queue$1(worker, 1, payload);
    }

    /**
     * Creates a `cargoQueue` object with the specified payload. Tasks added to the
     * cargoQueue will be processed together (up to the `payload` limit) in `concurrency` parallel workers.
     * If the all `workers` are in progress, the task is queued until one becomes available. Once
     * a `worker` has completed some tasks, each callback of those tasks is
     * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
     * for how `cargo` and `queue` work.
     *
     * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
     * at a time, and [`cargo`]{@link module:ControlFlow.cargo} passes an array of tasks to a single worker,
     * the cargoQueue passes an array of tasks to multiple parallel workers.
     *
     * @name cargoQueue
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.queue]{@link module:ControlFlow.queue}
     * @see [async.cargo]{@link module:ControlFLow.cargo}
     * @category Control Flow
     * @param {AsyncFunction} worker - An asynchronous function for processing an array
     * of queued tasks. Invoked with `(tasks, callback)`.
     * @param {number} [concurrency=1] - An `integer` for determining how many
     * `worker` functions should be run in parallel.  If omitted, the concurrency
     * defaults to `1`.  If the concurrency is `0`, an error is thrown.
     * @param {number} [payload=Infinity] - An optional `integer` for determining
     * how many tasks should be processed per round; if omitted, the default is
     * unlimited.
     * @returns {module:ControlFlow.QueueObject} A cargoQueue object to manage the tasks. Callbacks can
     * attached as certain properties to listen for specific events during the
     * lifecycle of the cargoQueue and inner queue.
     * @example
     *
     * // create a cargoQueue object with payload 2 and concurrency 2
     * var cargoQueue = async.cargoQueue(function(tasks, callback) {
     *     for (var i=0; i<tasks.length; i++) {
     *         console.log('hello ' + tasks[i].name);
     *     }
     *     callback();
     * }, 2, 2);
     *
     * // add some items
     * cargoQueue.push({name: 'foo'}, function(err) {
     *     console.log('finished processing foo');
     * });
     * cargoQueue.push({name: 'bar'}, function(err) {
     *     console.log('finished processing bar');
     * });
     * cargoQueue.push({name: 'baz'}, function(err) {
     *     console.log('finished processing baz');
     * });
     * cargoQueue.push({name: 'boo'}, function(err) {
     *     console.log('finished processing boo');
     * });
     */
    function cargo(worker, concurrency, payload) {
        return queue$1(worker, concurrency, payload);
    }

    /**
     * Reduces `coll` into a single value using an async `iteratee` to return each
     * successive step. `memo` is the initial state of the reduction. This function
     * only operates in series.
     *
     * For performance reasons, it may make sense to split a call to this function
     * into a parallel map, and then use the normal `Array.prototype.reduce` on the
     * results. This function is for situations where each step in the reduction
     * needs to be async; if you can get the data before reducing it, then it's
     * probably a good idea to do so.
     *
     * @name reduce
     * @static
     * @memberOf module:Collections
     * @method
     * @alias inject
     * @alias foldl
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {*} memo - The initial state of the reduction.
     * @param {AsyncFunction} iteratee - A function applied to each item in the
     * array to produce the next step in the reduction.
     * The `iteratee` should complete with the next state of the reduction.
     * If the iteratee completes with an error, the reduction is stopped and the
     * main `callback` is immediately called with the error.
     * Invoked with (memo, item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result is the reduced value. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     * // file4.txt does not exist
     *
     * const fileList = ['file1.txt','file2.txt','file3.txt'];
     * const withMissingFileList = ['file1.txt','file2.txt','file3.txt', 'file4.txt'];
     *
     * // asynchronous function that computes the file size in bytes
     * // file size is added to the memoized value, then returned
     * function getFileSizeInBytes(memo, file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, memo + stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.reduce(fileList, 0, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // 6000
     *         // which is the sum of the file sizes of the three files
     *     }
     * });
     *
     * // Error Handling
     * async.reduce(withMissingFileList, 0, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     } else {
     *         console.log(result);
     *     }
     * });
     *
     * // Using Promises
     * async.reduce(fileList, 0, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     *     // 6000
     *     // which is the sum of the file sizes of the three files
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.reduce(withMissingFileList, 0, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.reduce(fileList, 0, getFileSizeInBytes);
     *         console.log(result);
     *         // 6000
     *         // which is the sum of the file sizes of the three files
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let result = await async.reduce(withMissingFileList, 0, getFileSizeInBytes);
     *         console.log(result);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function reduce(coll, memo, iteratee, callback) {
        callback = once(callback);
        var _iteratee = wrapAsync(iteratee);
        return eachOfSeries$1(coll, (x, i, iterCb) => {
            _iteratee(memo, x, (err, v) => {
                memo = v;
                iterCb(err);
            });
        }, err => callback(err, memo));
    }
    var reduce$1 = awaitify(reduce, 4);

    /**
     * Version of the compose function that is more natural to read. Each function
     * consumes the return value of the previous function. It is the equivalent of
     * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
     *
     * Each function is executed with the `this` binding of the composed function.
     *
     * @name seq
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.compose]{@link module:ControlFlow.compose}
     * @category Control Flow
     * @param {...AsyncFunction} functions - the asynchronous functions to compose
     * @returns {Function} a function that composes the `functions` in order
     * @example
     *
     * // Requires lodash (or underscore), express3 and dresende's orm2.
     * // Part of an app, that fetches cats of the logged user.
     * // This example uses `seq` function to avoid overnesting and error
     * // handling clutter.
     * app.get('/cats', function(request, response) {
     *     var User = request.models.User;
     *     async.seq(
     *         User.get.bind(User),  // 'User.get' has signature (id, callback(err, data))
     *         function(user, fn) {
     *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
     *         }
     *     )(req.session.user_id, function (err, cats) {
     *         if (err) {
     *             console.error(err);
     *             response.json({ status: 'error', message: err.message });
     *         } else {
     *             response.json({ status: 'ok', message: 'Cats found', data: cats });
     *         }
     *     });
     * });
     */
    function seq(...functions) {
        var _functions = functions.map(wrapAsync);
        return function (...args) {
            var that = this;

            var cb = args[args.length - 1];
            if (typeof cb == 'function') {
                args.pop();
            } else {
                cb = promiseCallback();
            }

            reduce$1(_functions, args, (newargs, fn, iterCb) => {
                fn.apply(that, newargs.concat((err, ...nextargs) => {
                    iterCb(err, nextargs);
                }));
            },
            (err, results) => cb(err, ...results));

            return cb[PROMISE_SYMBOL]
        };
    }

    /**
     * Creates a function which is a composition of the passed asynchronous
     * functions. Each function consumes the return value of the function that
     * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
     * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
     *
     * If the last argument to the composed function is not a function, a promise
     * is returned when you call it.
     *
     * Each function is executed with the `this` binding of the composed function.
     *
     * @name compose
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {...AsyncFunction} functions - the asynchronous functions to compose
     * @returns {Function} an asynchronous function that is the composed
     * asynchronous `functions`
     * @example
     *
     * function add1(n, callback) {
     *     setTimeout(function () {
     *         callback(null, n + 1);
     *     }, 10);
     * }
     *
     * function mul3(n, callback) {
     *     setTimeout(function () {
     *         callback(null, n * 3);
     *     }, 10);
     * }
     *
     * var add1mul3 = async.compose(mul3, add1);
     * add1mul3(4, function (err, result) {
     *     // result now equals 15
     * });
     */
    function compose(...args) {
        return seq(...args.reverse());
    }

    /**
     * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
     *
     * @name mapLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.map]{@link module:Collections.map}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with the transformed item.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Results is an array of the
     * transformed items from the `coll`. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapLimit (coll, limit, iteratee, callback) {
        return _asyncMap(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var mapLimit$1 = awaitify(mapLimit, 4);

    /**
     * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
     *
     * @name concatLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.concat]{@link module:Collections.concat}
     * @category Collection
     * @alias flatMapLimit
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
     * which should use an array as its result. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is an array
     * containing the concatenated results of the `iteratee` function. Invoked with
     * (err, results).
     * @returns A Promise, if no callback is passed
     */
    function concatLimit(coll, limit, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return mapLimit$1(coll, limit, (val, iterCb) => {
            _iteratee(val, (err, ...args) => {
                if (err) return iterCb(err);
                return iterCb(err, args);
            });
        }, (err, mapResults) => {
            var result = [];
            for (var i = 0; i < mapResults.length; i++) {
                if (mapResults[i]) {
                    result = result.concat(...mapResults[i]);
                }
            }

            return callback(err, result);
        });
    }
    var concatLimit$1 = awaitify(concatLimit, 4);

    /**
     * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
     * the concatenated list. The `iteratee`s are called in parallel, and the
     * results are concatenated as they return. The results array will be returned in
     * the original order of `coll` passed to the `iteratee` function.
     *
     * @name concat
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @alias flatMap
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
     * which should use an array as its result. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is an array
     * containing the concatenated results of the `iteratee` function. Invoked with
     * (err, results).
     * @returns A Promise, if no callback is passed
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * let directoryList = ['dir1','dir2','dir3'];
     * let withMissingDirectoryList = ['dir1','dir2','dir3', 'dir4'];
     *
     * // Using callbacks
     * async.concat(directoryList, fs.readdir, function(err, results) {
     *    if (err) {
     *        console.log(err);
     *    } else {
     *        console.log(results);
     *        // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
     *    }
     * });
     *
     * // Error Handling
     * async.concat(withMissingDirectoryList, fs.readdir, function(err, results) {
     *    if (err) {
     *        console.log(err);
     *        // [ Error: ENOENT: no such file or directory ]
     *        // since dir4 does not exist
     *    } else {
     *        console.log(results);
     *    }
     * });
     *
     * // Using Promises
     * async.concat(directoryList, fs.readdir)
     * .then(results => {
     *     console.log(results);
     *     // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
     * }).catch(err => {
     *      console.log(err);
     * });
     *
     * // Error Handling
     * async.concat(withMissingDirectoryList, fs.readdir)
     * .then(results => {
     *     console.log(results);
     * }).catch(err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     *     // since dir4 does not exist
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.concat(directoryList, fs.readdir);
     *         console.log(results);
     *         // [ 'file1.txt', 'file2.txt', 'file3.txt', 'file4.txt', file5.txt ]
     *     } catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let results = await async.concat(withMissingDirectoryList, fs.readdir);
     *         console.log(results);
     *     } catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *         // since dir4 does not exist
     *     }
     * }
     *
     */
    function concat(coll, iteratee, callback) {
        return concatLimit$1(coll, Infinity, iteratee, callback)
    }
    var concat$1 = awaitify(concat, 3);

    /**
     * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
     *
     * @name concatSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.concat]{@link module:Collections.concat}
     * @category Collection
     * @alias flatMapSeries
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
     * The iteratee should complete with an array an array of results.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is an array
     * containing the concatenated results of the `iteratee` function. Invoked with
     * (err, results).
     * @returns A Promise, if no callback is passed
     */
    function concatSeries(coll, iteratee, callback) {
        return concatLimit$1(coll, 1, iteratee, callback)
    }
    var concatSeries$1 = awaitify(concatSeries, 3);

    /**
     * Returns a function that when called, calls-back with the values provided.
     * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
     * [`auto`]{@link module:ControlFlow.auto}.
     *
     * @name constant
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {...*} arguments... - Any number of arguments to automatically invoke
     * callback with.
     * @returns {AsyncFunction} Returns a function that when invoked, automatically
     * invokes the callback with the previous given arguments.
     * @example
     *
     * async.waterfall([
     *     async.constant(42),
     *     function (value, next) {
     *         // value === 42
     *     },
     *     //...
     * ], callback);
     *
     * async.waterfall([
     *     async.constant(filename, "utf8"),
     *     fs.readFile,
     *     function (fileData, next) {
     *         //...
     *     }
     *     //...
     * ], callback);
     *
     * async.auto({
     *     hostname: async.constant("https://server.net/"),
     *     port: findFreePort,
     *     launchServer: ["hostname", "port", function (options, cb) {
     *         startServer(options, cb);
     *     }],
     *     //...
     * }, callback);
     */
    function constant$1(...args) {
        return function (...ignoredArgs/*, callback*/) {
            var callback = ignoredArgs.pop();
            return callback(null, ...args);
        };
    }

    function _createTester(check, getResult) {
        return (eachfn, arr, _iteratee, cb) => {
            var testPassed = false;
            var testResult;
            const iteratee = wrapAsync(_iteratee);
            eachfn(arr, (value, _, callback) => {
                iteratee(value, (err, result) => {
                    if (err || err === false) return callback(err);

                    if (check(result) && !testResult) {
                        testPassed = true;
                        testResult = getResult(true, value);
                        return callback(null, breakLoop);
                    }
                    callback();
                });
            }, err => {
                if (err) return cb(err);
                cb(null, testPassed ? testResult : getResult(false));
            });
        };
    }

    /**
     * Returns the first value in `coll` that passes an async truth test. The
     * `iteratee` is applied in parallel, meaning the first iteratee to return
     * `true` will fire the detect `callback` with that result. That means the
     * result might not be the first item in the original `coll` (in terms of order)
     * that passes the test.

     * If order within the original `coll` is important, then look at
     * [`detectSeries`]{@link module:Collections.detectSeries}.
     *
     * @name detect
     * @static
     * @memberOf module:Collections
     * @method
     * @alias find
     * @category Collections
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
     * The iteratee must complete with a boolean value as its result.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the `iteratee` functions have finished.
     * Result will be the first item in the array that passes the truth test
     * (iteratee) or the value `undefined` if none passed. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists,
     *    function(err, result) {
     *        console.log(result);
     *        // dir1/file1.txt
     *        // result now equals the first file in the list that exists
     *    }
     *);
     *
     * // Using Promises
     * async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists)
     * .then(result => {
     *     console.log(result);
     *     // dir1/file1.txt
     *     // result now equals the first file in the list that exists
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.detect(['file3.txt','file2.txt','dir1/file1.txt'], fileExists);
     *         console.log(result);
     *         // dir1/file1.txt
     *         // result now equals the file in the list that exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function detect(coll, iteratee, callback) {
        return _createTester(bool => bool, (res, item) => item)(eachOf$1, coll, iteratee, callback)
    }
    var detect$1 = awaitify(detect, 3);

    /**
     * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name detectLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.detect]{@link module:Collections.detect}
     * @alias findLimit
     * @category Collections
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
     * The iteratee must complete with a boolean value as its result.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the `iteratee` functions have finished.
     * Result will be the first item in the array that passes the truth test
     * (iteratee) or the value `undefined` if none passed. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function detectLimit(coll, limit, iteratee, callback) {
        return _createTester(bool => bool, (res, item) => item)(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var detectLimit$1 = awaitify(detectLimit, 4);

    /**
     * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
     *
     * @name detectSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.detect]{@link module:Collections.detect}
     * @alias findSeries
     * @category Collections
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
     * The iteratee must complete with a boolean value as its result.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the `iteratee` functions have finished.
     * Result will be the first item in the array that passes the truth test
     * (iteratee) or the value `undefined` if none passed. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function detectSeries(coll, iteratee, callback) {
        return _createTester(bool => bool, (res, item) => item)(eachOfLimit$2(1), coll, iteratee, callback)
    }

    var detectSeries$1 = awaitify(detectSeries, 3);

    function consoleFunc(name) {
        return (fn, ...args) => wrapAsync(fn)(...args, (err, ...resultArgs) => {
            /* istanbul ignore else */
            if (typeof console === 'object') {
                /* istanbul ignore else */
                if (err) {
                    /* istanbul ignore else */
                    if (console.error) {
                        console.error(err);
                    }
                } else if (console[name]) { /* istanbul ignore else */
                    resultArgs.forEach(x => console[name](x));
                }
            }
        })
    }

    /**
     * Logs the result of an [`async` function]{@link AsyncFunction} to the
     * `console` using `console.dir` to display the properties of the resulting object.
     * Only works in Node.js or in browsers that support `console.dir` and
     * `console.error` (such as FF and Chrome).
     * If multiple arguments are returned from the async function,
     * `console.dir` is called on each argument in order.
     *
     * @name dir
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} function - The function you want to eventually apply
     * all arguments to.
     * @param {...*} arguments... - Any number of arguments to apply to the function.
     * @example
     *
     * // in a module
     * var hello = function(name, callback) {
     *     setTimeout(function() {
     *         callback(null, {hello: name});
     *     }, 1000);
     * };
     *
     * // in the node repl
     * node> async.dir(hello, 'world');
     * {hello: 'world'}
     */
    var dir = consoleFunc('dir');

    /**
     * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
     * the order of operations, the arguments `test` and `iteratee` are switched.
     *
     * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
     *
     * @name doWhilst
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.whilst]{@link module:ControlFlow.whilst}
     * @category Control Flow
     * @param {AsyncFunction} iteratee - A function which is called each time `test`
     * passes. Invoked with (callback).
     * @param {AsyncFunction} test - asynchronous truth test to perform after each
     * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
     * non-error args from the previous callback of `iteratee`.
     * @param {Function} [callback] - A callback which is called after the test
     * function has failed and repeated execution of `iteratee` has stopped.
     * `callback` will be passed an error and any arguments passed to the final
     * `iteratee`'s callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if no callback is passed
     */
    function doWhilst(iteratee, test, callback) {
        callback = onlyOnce(callback);
        var _fn = wrapAsync(iteratee);
        var _test = wrapAsync(test);
        var results;

        function next(err, ...args) {
            if (err) return callback(err);
            if (err === false) return;
            results = args;
            _test(...args, check);
        }

        function check(err, truth) {
            if (err) return callback(err);
            if (err === false) return;
            if (!truth) return callback(null, ...results);
            _fn(next);
        }

        return check(null, true);
    }

    var doWhilst$1 = awaitify(doWhilst, 3);

    /**
     * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
     * argument ordering differs from `until`.
     *
     * @name doUntil
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
     * @category Control Flow
     * @param {AsyncFunction} iteratee - An async function which is called each time
     * `test` fails. Invoked with (callback).
     * @param {AsyncFunction} test - asynchronous truth test to perform after each
     * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
     * non-error args from the previous callback of `iteratee`
     * @param {Function} [callback] - A callback which is called after the test
     * function has passed and repeated execution of `iteratee` has stopped. `callback`
     * will be passed an error and any arguments passed to the final `iteratee`'s
     * callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if no callback is passed
     */
    function doUntil(iteratee, test, callback) {
        const _test = wrapAsync(test);
        return doWhilst$1(iteratee, (...args) => {
            const cb = args.pop();
            _test(...args, (err, truth) => cb (err, !truth));
        }, callback);
    }

    function _withoutIndex(iteratee) {
        return (value, index, callback) => iteratee(value, callback);
    }

    /**
     * Applies the function `iteratee` to each item in `coll`, in parallel.
     * The `iteratee` is called with an item from the list, and a callback for when
     * it has finished. If the `iteratee` passes an error to its `callback`, the
     * main `callback` (for the `each` function) is immediately called with the
     * error.
     *
     * Note, that since this function applies `iteratee` to each item in parallel,
     * there is no guarantee that the iteratee functions will complete in order.
     *
     * @name each
     * @static
     * @memberOf module:Collections
     * @method
     * @alias forEach
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to
     * each item in `coll`. Invoked with (item, callback).
     * The array index is not passed to the iteratee.
     * If you need the index, use `eachOf`.
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * const fileList = [ 'dir1/file2.txt', 'dir2/file3.txt', 'dir/file5.txt'];
     * const withMissingFileList = ['dir1/file1.txt', 'dir4/file2.txt'];
     *
     * // asynchronous function that deletes a file
     * const deleteFile = function(file, callback) {
     *     fs.unlink(file, callback);
     * };
     *
     * // Using callbacks
     * async.each(fileList, deleteFile, function(err) {
     *     if( err ) {
     *         console.log(err);
     *     } else {
     *         console.log('All files have been deleted successfully');
     *     }
     * });
     *
     * // Error Handling
     * async.each(withMissingFileList, deleteFile, function(err){
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     *     // since dir4/file2.txt does not exist
     *     // dir1/file1.txt could have been deleted
     * });
     *
     * // Using Promises
     * async.each(fileList, deleteFile)
     * .then( () => {
     *     console.log('All files have been deleted successfully');
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.each(fileList, deleteFile)
     * .then( () => {
     *     console.log('All files have been deleted successfully');
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     *     // since dir4/file2.txt does not exist
     *     // dir1/file1.txt could have been deleted
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         await async.each(files, deleteFile);
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         await async.each(withMissingFileList, deleteFile);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *         // since dir4/file2.txt does not exist
     *         // dir1/file1.txt could have been deleted
     *     }
     * }
     *
     */
    function eachLimit$2(coll, iteratee, callback) {
        return eachOf$1(coll, _withoutIndex(wrapAsync(iteratee)), callback);
    }

    var each = awaitify(eachLimit$2, 3);

    /**
     * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
     *
     * @name eachLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.each]{@link module:Collections.each}
     * @alias forEachLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The array index is not passed to the iteratee.
     * If you need the index, use `eachOfLimit`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachLimit(coll, limit, iteratee, callback) {
        return eachOfLimit$2(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
    }
    var eachLimit$1 = awaitify(eachLimit, 4);

    /**
     * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
     *
     * Note, that unlike [`each`]{@link module:Collections.each}, this function applies iteratee to each item
     * in series and therefore the iteratee functions will complete in order.

     * @name eachSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.each]{@link module:Collections.each}
     * @alias forEachSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each
     * item in `coll`.
     * The array index is not passed to the iteratee.
     * If you need the index, use `eachOfSeries`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called when all
     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
     * @returns {Promise} a promise, if a callback is omitted
     */
    function eachSeries(coll, iteratee, callback) {
        return eachLimit$1(coll, 1, iteratee, callback)
    }
    var eachSeries$1 = awaitify(eachSeries, 3);

    /**
     * Wrap an async function and ensure it calls its callback on a later tick of
     * the event loop.  If the function already calls its callback on a next tick,
     * no extra deferral is added. This is useful for preventing stack overflows
     * (`RangeError: Maximum call stack size exceeded`) and generally keeping
     * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
     * contained. ES2017 `async` functions are returned as-is -- they are immune
     * to Zalgo's corrupting influences, as they always resolve on a later tick.
     *
     * @name ensureAsync
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} fn - an async function, one that expects a node-style
     * callback as its last argument.
     * @returns {AsyncFunction} Returns a wrapped function with the exact same call
     * signature as the function passed in.
     * @example
     *
     * function sometimesAsync(arg, callback) {
     *     if (cache[arg]) {
     *         return callback(null, cache[arg]); // this would be synchronous!!
     *     } else {
     *         doSomeIO(arg, callback); // this IO would be asynchronous
     *     }
     * }
     *
     * // this has a risk of stack overflows if many results are cached in a row
     * async.mapSeries(args, sometimesAsync, done);
     *
     * // this will defer sometimesAsync's callback if necessary,
     * // preventing stack overflows
     * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
     */
    function ensureAsync(fn) {
        if (isAsync(fn)) return fn;
        return function (...args/*, callback*/) {
            var callback = args.pop();
            var sync = true;
            args.push((...innerArgs) => {
                if (sync) {
                    setImmediate$1(() => callback(...innerArgs));
                } else {
                    callback(...innerArgs);
                }
            });
            fn.apply(this, args);
            sync = false;
        };
    }

    /**
     * Returns `true` if every element in `coll` satisfies an async test. If any
     * iteratee call returns `false`, the main `callback` is immediately called.
     *
     * @name every
     * @static
     * @memberOf module:Collections
     * @method
     * @alias all
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collection in parallel.
     * The iteratee must complete with a boolean result value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result will be either `true` or `false`
     * depending on the values of the async tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file5.txt'];
     * const withMissingFileList = ['file1.txt','file2.txt','file4.txt'];
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.every(fileList, fileExists, function(err, result) {
     *     console.log(result);
     *     // true
     *     // result is true since every file exists
     * });
     *
     * async.every(withMissingFileList, fileExists, function(err, result) {
     *     console.log(result);
     *     // false
     *     // result is false since NOT every file exists
     * });
     *
     * // Using Promises
     * async.every(fileList, fileExists)
     * .then( result => {
     *     console.log(result);
     *     // true
     *     // result is true since every file exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * async.every(withMissingFileList, fileExists)
     * .then( result => {
     *     console.log(result);
     *     // false
     *     // result is false since NOT every file exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.every(fileList, fileExists);
     *         console.log(result);
     *         // true
     *         // result is true since every file exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * async () => {
     *     try {
     *         let result = await async.every(withMissingFileList, fileExists);
     *         console.log(result);
     *         // false
     *         // result is false since NOT every file exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function every(coll, iteratee, callback) {
        return _createTester(bool => !bool, res => !res)(eachOf$1, coll, iteratee, callback)
    }
    var every$1 = awaitify(every, 3);

    /**
     * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
     *
     * @name everyLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.every]{@link module:Collections.every}
     * @alias allLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collection in parallel.
     * The iteratee must complete with a boolean result value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result will be either `true` or `false`
     * depending on the values of the async tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function everyLimit(coll, limit, iteratee, callback) {
        return _createTester(bool => !bool, res => !res)(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var everyLimit$1 = awaitify(everyLimit, 4);

    /**
     * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
     *
     * @name everySeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.every]{@link module:Collections.every}
     * @alias allSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collection in series.
     * The iteratee must complete with a boolean result value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result will be either `true` or `false`
     * depending on the values of the async tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function everySeries(coll, iteratee, callback) {
        return _createTester(bool => !bool, res => !res)(eachOfSeries$1, coll, iteratee, callback)
    }
    var everySeries$1 = awaitify(everySeries, 3);

    function filterArray(eachfn, arr, iteratee, callback) {
        var truthValues = new Array(arr.length);
        eachfn(arr, (x, index, iterCb) => {
            iteratee(x, (err, v) => {
                truthValues[index] = !!v;
                iterCb(err);
            });
        }, err => {
            if (err) return callback(err);
            var results = [];
            for (var i = 0; i < arr.length; i++) {
                if (truthValues[i]) results.push(arr[i]);
            }
            callback(null, results);
        });
    }

    function filterGeneric(eachfn, coll, iteratee, callback) {
        var results = [];
        eachfn(coll, (x, index, iterCb) => {
            iteratee(x, (err, v) => {
                if (err) return iterCb(err);
                if (v) {
                    results.push({index, value: x});
                }
                iterCb(err);
            });
        }, err => {
            if (err) return callback(err);
            callback(null, results
                .sort((a, b) => a.index - b.index)
                .map(v => v.value));
        });
    }

    function _filter(eachfn, coll, iteratee, callback) {
        var filter = isArrayLike(coll) ? filterArray : filterGeneric;
        return filter(eachfn, coll, wrapAsync(iteratee), callback);
    }

    /**
     * Returns a new array of all the values in `coll` which pass an async truth
     * test. This operation is performed in parallel, but the results array will be
     * in the same order as the original.
     *
     * @name filter
     * @static
     * @memberOf module:Collections
     * @method
     * @alias select
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
     * with a boolean argument once it has completed. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     *
     * const files = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.filter(files, fileExists, function(err, results) {
     *    if(err) {
     *        console.log(err);
     *    } else {
     *        console.log(results);
     *        // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
     *        // results is now an array of the existing files
     *    }
     * });
     *
     * // Using Promises
     * async.filter(files, fileExists)
     * .then(results => {
     *     console.log(results);
     *     // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
     *     // results is now an array of the existing files
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.filter(files, fileExists);
     *         console.log(results);
     *         // [ 'dir1/file1.txt', 'dir2/file3.txt' ]
     *         // results is now an array of the existing files
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function filter (coll, iteratee, callback) {
        return _filter(eachOf$1, coll, iteratee, callback)
    }
    var filter$1 = awaitify(filter, 3);

    /**
     * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name filterLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.filter]{@link module:Collections.filter}
     * @alias selectLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
     * with a boolean argument once it has completed. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback provided
     */
    function filterLimit (coll, limit, iteratee, callback) {
        return _filter(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var filterLimit$1 = awaitify(filterLimit, 4);

    /**
     * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
     *
     * @name filterSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.filter]{@link module:Collections.filter}
     * @alias selectSeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
     * with a boolean argument once it has completed. Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results)
     * @returns {Promise} a promise, if no callback provided
     */
    function filterSeries (coll, iteratee, callback) {
        return _filter(eachOfSeries$1, coll, iteratee, callback)
    }
    var filterSeries$1 = awaitify(filterSeries, 3);

    /**
     * Calls the asynchronous function `fn` with a callback parameter that allows it
     * to call itself again, in series, indefinitely.

     * If an error is passed to the callback then `errback` is called with the
     * error, and execution stops, otherwise it will never be called.
     *
     * @name forever
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {AsyncFunction} fn - an async function to call repeatedly.
     * Invoked with (next).
     * @param {Function} [errback] - when `fn` passes an error to it's callback,
     * this function will be called, and execution stops. Invoked with (err).
     * @returns {Promise} a promise that rejects if an error occurs and an errback
     * is not passed
     * @example
     *
     * async.forever(
     *     function(next) {
     *         // next is suitable for passing to things that need a callback(err [, whatever]);
     *         // it will result in this function being called again.
     *     },
     *     function(err) {
     *         // if next is called with a value in its first parameter, it will appear
     *         // in here as 'err', and execution will stop.
     *     }
     * );
     */
    function forever(fn, errback) {
        var done = onlyOnce(errback);
        var task = wrapAsync(ensureAsync(fn));

        function next(err) {
            if (err) return done(err);
            if (err === false) return;
            task(next);
        }
        return next();
    }
    var forever$1 = awaitify(forever, 2);

    /**
     * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
     *
     * @name groupByLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.groupBy]{@link module:Collections.groupBy}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a `key` to group the value under.
     * Invoked with (value, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Result is an `Object` whoses
     * properties are arrays of values which returned the corresponding key.
     * @returns {Promise} a promise, if no callback is passed
     */
    function groupByLimit(coll, limit, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return mapLimit$1(coll, limit, (val, iterCb) => {
            _iteratee(val, (err, key) => {
                if (err) return iterCb(err);
                return iterCb(err, {key, val});
            });
        }, (err, mapResults) => {
            var result = {};
            // from MDN, handle object having an `hasOwnProperty` prop
            var {hasOwnProperty} = Object.prototype;

            for (var i = 0; i < mapResults.length; i++) {
                if (mapResults[i]) {
                    var {key} = mapResults[i];
                    var {val} = mapResults[i];

                    if (hasOwnProperty.call(result, key)) {
                        result[key].push(val);
                    } else {
                        result[key] = [val];
                    }
                }
            }

            return callback(err, result);
        });
    }

    var groupByLimit$1 = awaitify(groupByLimit, 4);

    /**
     * Returns a new object, where each value corresponds to an array of items, from
     * `coll`, that returned the corresponding key. That is, the keys of the object
     * correspond to the values passed to the `iteratee` callback.
     *
     * Note: Since this function applies the `iteratee` to each item in parallel,
     * there is no guarantee that the `iteratee` functions will complete in order.
     * However, the values for each key in the `result` will be in the same order as
     * the original `coll`. For Objects, the values will roughly be in the order of
     * the original Objects' keys (but this can vary across JavaScript engines).
     *
     * @name groupBy
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a `key` to group the value under.
     * Invoked with (value, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Result is an `Object` whoses
     * properties are arrays of values which returned the corresponding key.
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * const files = ['dir1/file1.txt','dir2','dir4']
     *
     * // asynchronous function that detects file type as none, file, or directory
     * function detectFile(file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(null, 'none');
     *         }
     *         callback(null, stat.isDirectory() ? 'directory' : 'file');
     *     });
     * }
     *
     * //Using callbacks
     * async.groupBy(files, detectFile, function(err, result) {
     *     if(err) {
     *         console.log(err);
     *     } else {
     *	       console.log(result);
     *         // {
     *         //     file: [ 'dir1/file1.txt' ],
     *         //     none: [ 'dir4' ],
     *         //     directory: [ 'dir2']
     *         // }
     *         // result is object containing the files grouped by type
     *     }
     * });
     *
     * // Using Promises
     * async.groupBy(files, detectFile)
     * .then( result => {
     *     console.log(result);
     *     // {
     *     //     file: [ 'dir1/file1.txt' ],
     *     //     none: [ 'dir4' ],
     *     //     directory: [ 'dir2']
     *     // }
     *     // result is object containing the files grouped by type
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.groupBy(files, detectFile);
     *         console.log(result);
     *         // {
     *         //     file: [ 'dir1/file1.txt' ],
     *         //     none: [ 'dir4' ],
     *         //     directory: [ 'dir2']
     *         // }
     *         // result is object containing the files grouped by type
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function groupBy (coll, iteratee, callback) {
        return groupByLimit$1(coll, Infinity, iteratee, callback)
    }

    /**
     * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
     *
     * @name groupBySeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.groupBy]{@link module:Collections.groupBy}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a `key` to group the value under.
     * Invoked with (value, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. Result is an `Object` whose
     * properties are arrays of values which returned the corresponding key.
     * @returns {Promise} a promise, if no callback is passed
     */
    function groupBySeries (coll, iteratee, callback) {
        return groupByLimit$1(coll, 1, iteratee, callback)
    }

    /**
     * Logs the result of an `async` function to the `console`. Only works in
     * Node.js or in browsers that support `console.log` and `console.error` (such
     * as FF and Chrome). If multiple arguments are returned from the async
     * function, `console.log` is called on each argument in order.
     *
     * @name log
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} function - The function you want to eventually apply
     * all arguments to.
     * @param {...*} arguments... - Any number of arguments to apply to the function.
     * @example
     *
     * // in a module
     * var hello = function(name, callback) {
     *     setTimeout(function() {
     *         callback(null, 'hello ' + name);
     *     }, 1000);
     * };
     *
     * // in the node repl
     * node> async.log(hello, 'world');
     * 'hello world'
     */
    var log = consoleFunc('log');

    /**
     * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name mapValuesLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.mapValues]{@link module:Collections.mapValues}
     * @category Collection
     * @param {Object} obj - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - A function to apply to each value and key
     * in `coll`.
     * The iteratee should complete with the transformed value as its result.
     * Invoked with (value, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. `result` is a new object consisting
     * of each key from `obj`, with each transformed value on the right-hand side.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapValuesLimit(obj, limit, iteratee, callback) {
        callback = once(callback);
        var newObj = {};
        var _iteratee = wrapAsync(iteratee);
        return eachOfLimit$2(limit)(obj, (val, key, next) => {
            _iteratee(val, key, (err, result) => {
                if (err) return next(err);
                newObj[key] = result;
                next(err);
            });
        }, err => callback(err, newObj));
    }

    var mapValuesLimit$1 = awaitify(mapValuesLimit, 4);

    /**
     * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
     *
     * Produces a new Object by mapping each value of `obj` through the `iteratee`
     * function. The `iteratee` is called each `value` and `key` from `obj` and a
     * callback for when it has finished processing. Each of these callbacks takes
     * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
     * passes an error to its callback, the main `callback` (for the `mapValues`
     * function) is immediately called with the error.
     *
     * Note, the order of the keys in the result is not guaranteed.  The keys will
     * be roughly in the order they complete, (but this is very engine-specific)
     *
     * @name mapValues
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Object} obj - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each value and key
     * in `coll`.
     * The iteratee should complete with the transformed value as its result.
     * Invoked with (value, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. `result` is a new object consisting
     * of each key from `obj`, with each transformed value on the right-hand side.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     * // file4.txt does not exist
     *
     * const fileMap = {
     *     f1: 'file1.txt',
     *     f2: 'file2.txt',
     *     f3: 'file3.txt'
     * };
     *
     * const withMissingFileMap = {
     *     f1: 'file1.txt',
     *     f2: 'file2.txt',
     *     f3: 'file4.txt'
     * };
     *
     * // asynchronous function that returns the file size in bytes
     * function getFileSizeInBytes(file, key, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.mapValues(fileMap, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // result is now a map of file size in bytes for each file, e.g.
     *         // {
     *         //     f1: 1000,
     *         //     f2: 2000,
     *         //     f3: 3000
     *         // }
     *     }
     * });
     *
     * // Error handling
     * async.mapValues(withMissingFileMap, getFileSizeInBytes, function(err, result) {
     *     if (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     } else {
     *         console.log(result);
     *     }
     * });
     *
     * // Using Promises
     * async.mapValues(fileMap, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     *     // result is now a map of file size in bytes for each file, e.g.
     *     // {
     *     //     f1: 1000,
     *     //     f2: 2000,
     *     //     f3: 3000
     *     // }
     * }).catch (err => {
     *     console.log(err);
     * });
     *
     * // Error Handling
     * async.mapValues(withMissingFileMap, getFileSizeInBytes)
     * .then( result => {
     *     console.log(result);
     * }).catch (err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.mapValues(fileMap, getFileSizeInBytes);
     *         console.log(result);
     *         // result is now a map of file size in bytes for each file, e.g.
     *         // {
     *         //     f1: 1000,
     *         //     f2: 2000,
     *         //     f3: 3000
     *         // }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // Error Handling
     * async () => {
     *     try {
     *         let result = await async.mapValues(withMissingFileMap, getFileSizeInBytes);
     *         console.log(result);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function mapValues(obj, iteratee, callback) {
        return mapValuesLimit$1(obj, Infinity, iteratee, callback)
    }

    /**
     * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
     *
     * @name mapValuesSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.mapValues]{@link module:Collections.mapValues}
     * @category Collection
     * @param {Object} obj - A collection to iterate over.
     * @param {AsyncFunction} iteratee - A function to apply to each value and key
     * in `coll`.
     * The iteratee should complete with the transformed value as its result.
     * Invoked with (value, key, callback).
     * @param {Function} [callback] - A callback which is called when all `iteratee`
     * functions have finished, or an error occurs. `result` is a new object consisting
     * of each key from `obj`, with each transformed value on the right-hand side.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback is passed
     */
    function mapValuesSeries(obj, iteratee, callback) {
        return mapValuesLimit$1(obj, 1, iteratee, callback)
    }

    /**
     * Caches the results of an async function. When creating a hash to store
     * function results against, the callback is omitted from the hash and an
     * optional hash function can be used.
     *
     * **Note: if the async function errs, the result will not be cached and
     * subsequent calls will call the wrapped function.**
     *
     * If no hash function is specified, the first argument is used as a hash key,
     * which may work reasonably if it is a string or a data type that converts to a
     * distinct string. Note that objects and arrays will not behave reasonably.
     * Neither will cases where the other arguments are significant. In such cases,
     * specify your own hash function.
     *
     * The cache of results is exposed as the `memo` property of the function
     * returned by `memoize`.
     *
     * @name memoize
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} fn - The async function to proxy and cache results from.
     * @param {Function} hasher - An optional function for generating a custom hash
     * for storing results. It has all the arguments applied to it apart from the
     * callback, and must be synchronous.
     * @returns {AsyncFunction} a memoized version of `fn`
     * @example
     *
     * var slow_fn = function(name, callback) {
     *     // do something
     *     callback(null, result);
     * };
     * var fn = async.memoize(slow_fn);
     *
     * // fn can now be used as if it were slow_fn
     * fn('some name', function() {
     *     // callback
     * });
     */
    function memoize(fn, hasher = v => v) {
        var memo = Object.create(null);
        var queues = Object.create(null);
        var _fn = wrapAsync(fn);
        var memoized = initialParams((args, callback) => {
            var key = hasher(...args);
            if (key in memo) {
                setImmediate$1(() => callback(null, ...memo[key]));
            } else if (key in queues) {
                queues[key].push(callback);
            } else {
                queues[key] = [callback];
                _fn(...args, (err, ...resultArgs) => {
                    // #1465 don't memoize if an error occurred
                    if (!err) {
                        memo[key] = resultArgs;
                    }
                    var q = queues[key];
                    delete queues[key];
                    for (var i = 0, l = q.length; i < l; i++) {
                        q[i](err, ...resultArgs);
                    }
                });
            }
        });
        memoized.memo = memo;
        memoized.unmemoized = fn;
        return memoized;
    }

    /* istanbul ignore file */

    /**
     * Calls `callback` on a later loop around the event loop. In Node.js this just
     * calls `process.nextTick`.  In the browser it will use `setImmediate` if
     * available, otherwise `setTimeout(callback, 0)`, which means other higher
     * priority events may precede the execution of `callback`.
     *
     * This is used internally for browser-compatibility purposes.
     *
     * @name nextTick
     * @static
     * @memberOf module:Utils
     * @method
     * @see [async.setImmediate]{@link module:Utils.setImmediate}
     * @category Util
     * @param {Function} callback - The function to call on a later loop around
     * the event loop. Invoked with (args...).
     * @param {...*} args... - any number of additional arguments to pass to the
     * callback on the next tick.
     * @example
     *
     * var call_order = [];
     * async.nextTick(function() {
     *     call_order.push('two');
     *     // call_order now equals ['one','two']
     * });
     * call_order.push('one');
     *
     * async.setImmediate(function (a, b, c) {
     *     // a, b, and c equal 1, 2, and 3
     * }, 1, 2, 3);
     */
    var _defer;

    if (hasNextTick) {
        _defer = process.nextTick;
    } else if (hasSetImmediate) {
        _defer = setImmediate;
    } else {
        _defer = fallback;
    }

    var nextTick = wrap(_defer);

    var _parallel = awaitify((eachfn, tasks, callback) => {
        var results = isArrayLike(tasks) ? [] : {};

        eachfn(tasks, (task, key, taskCb) => {
            wrapAsync(task)((err, ...result) => {
                if (result.length < 2) {
                    [result] = result;
                }
                results[key] = result;
                taskCb(err);
            });
        }, err => callback(err, results));
    }, 3);

    /**
     * Run the `tasks` collection of functions in parallel, without waiting until
     * the previous function has completed. If any of the functions pass an error to
     * its callback, the main `callback` is immediately called with the value of the
     * error. Once the `tasks` have completed, the results are passed to the final
     * `callback` as an array.
     *
     * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
     * parallel execution of code.  If your tasks do not use any timers or perform
     * any I/O, they will actually be executed in series.  Any synchronous setup
     * sections for each task will happen one after the other.  JavaScript remains
     * single-threaded.
     *
     * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
     * execution of other tasks when a task fails.
     *
     * It is also possible to use an object instead of an array. Each property will
     * be run as a function and the results will be passed to the final `callback`
     * as an object instead of an array. This can be a more readable way of handling
     * results from {@link async.parallel}.
     *
     * @name parallel
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
     * [async functions]{@link AsyncFunction} to run.
     * Each async function can complete with any number of optional `result` values.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed successfully. This function gets a results array
     * (or object) containing all the result arguments passed to the task callbacks.
     * Invoked with (err, results).
     * @returns {Promise} a promise, if a callback is not passed
     *
     * @example
     *
     * //Using Callbacks
     * async.parallel([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ], function(err, results) {
     *     console.log(results);
     *     // results is equal to ['one','two'] even though
     *     // the second function had a shorter timeout.
     * });
     *
     * // an example using an object instead of an array
     * async.parallel({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }, function(err, results) {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * });
     *
     * //Using Promises
     * async.parallel([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ]).then(results => {
     *     console.log(results);
     *     // results is equal to ['one','two'] even though
     *     // the second function had a shorter timeout.
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // an example using an object instead of an array
     * async.parallel({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }).then(results => {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * //Using async/await
     * async () => {
     *     try {
     *         let results = await async.parallel([
     *             function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 'one');
     *                 }, 200);
     *             },
     *             function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 'two');
     *                 }, 100);
     *             }
     *         ]);
     *         console.log(results);
     *         // results is equal to ['one','two'] even though
     *         // the second function had a shorter timeout.
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // an example using an object instead of an array
     * async () => {
     *     try {
     *         let results = await async.parallel({
     *             one: function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 1);
     *                 }, 200);
     *             },
     *            two: function(callback) {
     *                 setTimeout(function() {
     *                     callback(null, 2);
     *                 }, 100);
     *            }
     *         });
     *         console.log(results);
     *         // results is equal to: { one: 1, two: 2 }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function parallel(tasks, callback) {
        return _parallel(eachOf$1, tasks, callback);
    }

    /**
     * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name parallelLimit
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.parallel]{@link module:ControlFlow.parallel}
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
     * [async functions]{@link AsyncFunction} to run.
     * Each async function can complete with any number of optional `result` values.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed successfully. This function gets a results array
     * (or object) containing all the result arguments passed to the task callbacks.
     * Invoked with (err, results).
     * @returns {Promise} a promise, if a callback is not passed
     */
    function parallelLimit(tasks, limit, callback) {
        return _parallel(eachOfLimit$2(limit), tasks, callback);
    }

    /**
     * A queue of tasks for the worker function to complete.
     * @typedef {Iterable} QueueObject
     * @memberOf module:ControlFlow
     * @property {Function} length - a function returning the number of items
     * waiting to be processed. Invoke with `queue.length()`.
     * @property {boolean} started - a boolean indicating whether or not any
     * items have been pushed and processed by the queue.
     * @property {Function} running - a function returning the number of items
     * currently being processed. Invoke with `queue.running()`.
     * @property {Function} workersList - a function returning the array of items
     * currently being processed. Invoke with `queue.workersList()`.
     * @property {Function} idle - a function returning false if there are items
     * waiting or being processed, or true if not. Invoke with `queue.idle()`.
     * @property {number} concurrency - an integer for determining how many `worker`
     * functions should be run in parallel. This property can be changed after a
     * `queue` is created to alter the concurrency on-the-fly.
     * @property {number} payload - an integer that specifies how many items are
     * passed to the worker function at a time. only applies if this is a
     * [cargo]{@link module:ControlFlow.cargo} object
     * @property {AsyncFunction} push - add a new task to the `queue`. Calls `callback`
     * once the `worker` has finished processing the task. Instead of a single task,
     * a `tasks` array can be submitted. The respective callback is used for every
     * task in the list. Invoke with `queue.push(task, [callback])`,
     * @property {AsyncFunction} unshift - add a new task to the front of the `queue`.
     * Invoke with `queue.unshift(task, [callback])`.
     * @property {AsyncFunction} pushAsync - the same as `q.push`, except this returns
     * a promise that rejects if an error occurs.
     * @property {AsyncFunction} unshiftAsync - the same as `q.unshift`, except this returns
     * a promise that rejects if an error occurs.
     * @property {Function} remove - remove items from the queue that match a test
     * function.  The test function will be passed an object with a `data` property,
     * and a `priority` property, if this is a
     * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
     * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
     * `function ({data, priority}) {}` and returns a Boolean.
     * @property {Function} saturated - a function that sets a callback that is
     * called when the number of running workers hits the `concurrency` limit, and
     * further tasks will be queued.  If the callback is omitted, `q.saturated()`
     * returns a promise for the next occurrence.
     * @property {Function} unsaturated - a function that sets a callback that is
     * called when the number of running workers is less than the `concurrency` &
     * `buffer` limits, and further tasks will not be queued. If the callback is
     * omitted, `q.unsaturated()` returns a promise for the next occurrence.
     * @property {number} buffer - A minimum threshold buffer in order to say that
     * the `queue` is `unsaturated`.
     * @property {Function} empty - a function that sets a callback that is called
     * when the last item from the `queue` is given to a `worker`. If the callback
     * is omitted, `q.empty()` returns a promise for the next occurrence.
     * @property {Function} drain - a function that sets a callback that is called
     * when the last item from the `queue` has returned from the `worker`. If the
     * callback is omitted, `q.drain()` returns a promise for the next occurrence.
     * @property {Function} error - a function that sets a callback that is called
     * when a task errors. Has the signature `function(error, task)`. If the
     * callback is omitted, `error()` returns a promise that rejects on the next
     * error.
     * @property {boolean} paused - a boolean for determining whether the queue is
     * in a paused state.
     * @property {Function} pause - a function that pauses the processing of tasks
     * until `resume()` is called. Invoke with `queue.pause()`.
     * @property {Function} resume - a function that resumes the processing of
     * queued tasks when the queue is paused. Invoke with `queue.resume()`.
     * @property {Function} kill - a function that removes the `drain` callback and
     * empties remaining tasks from the queue forcing it to go idle. No more tasks
     * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
     *
     * @example
     * const q = async.queue(worker, 2)
     * q.push(item1)
     * q.push(item2)
     * q.push(item3)
     * // queues are iterable, spread into an array to inspect
     * const items = [...q] // [item1, item2, item3]
     * // or use for of
     * for (let item of q) {
     *     console.log(item)
     * }
     *
     * q.drain(() => {
     *     console.log('all done')
     * })
     * // or
     * await q.drain()
     */

    /**
     * Creates a `queue` object with the specified `concurrency`. Tasks added to the
     * `queue` are processed in parallel (up to the `concurrency` limit). If all
     * `worker`s are in progress, the task is queued until one becomes available.
     * Once a `worker` completes a `task`, that `task`'s callback is called.
     *
     * @name queue
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {AsyncFunction} worker - An async function for processing a queued task.
     * If you want to handle errors from an individual task, pass a callback to
     * `q.push()`. Invoked with (task, callback).
     * @param {number} [concurrency=1] - An `integer` for determining how many
     * `worker` functions should be run in parallel.  If omitted, the concurrency
     * defaults to `1`.  If the concurrency is `0`, an error is thrown.
     * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can be
     * attached as certain properties to listen for specific events during the
     * lifecycle of the queue.
     * @example
     *
     * // create a queue object with concurrency 2
     * var q = async.queue(function(task, callback) {
     *     console.log('hello ' + task.name);
     *     callback();
     * }, 2);
     *
     * // assign a callback
     * q.drain(function() {
     *     console.log('all items have been processed');
     * });
     * // or await the end
     * await q.drain()
     *
     * // assign an error callback
     * q.error(function(err, task) {
     *     console.error('task experienced an error');
     * });
     *
     * // add some items to the queue
     * q.push({name: 'foo'}, function(err) {
     *     console.log('finished processing foo');
     * });
     * // callback is optional
     * q.push({name: 'bar'});
     *
     * // add some items to the queue (batch-wise)
     * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
     *     console.log('finished processing item');
     * });
     *
     * // add some items to the front of the queue
     * q.unshift({name: 'bar'}, function (err) {
     *     console.log('finished processing bar');
     * });
     */
    function queue (worker, concurrency) {
        var _worker = wrapAsync(worker);
        return queue$1((items, cb) => {
            _worker(items[0], cb);
        }, concurrency, 1);
    }

    // Binary min-heap implementation used for priority queue.
    // Implementation is stable, i.e. push time is considered for equal priorities
    class Heap {
        constructor() {
            this.heap = [];
            this.pushCount = Number.MIN_SAFE_INTEGER;
        }

        get length() {
            return this.heap.length;
        }

        empty () {
            this.heap = [];
            return this;
        }

        percUp(index) {
            let p;

            while (index > 0 && smaller(this.heap[index], this.heap[p=parent(index)])) {
                let t = this.heap[index];
                this.heap[index] = this.heap[p];
                this.heap[p] = t;

                index = p;
            }
        }

        percDown(index) {
            let l;

            while ((l=leftChi(index)) < this.heap.length) {
                if (l+1 < this.heap.length && smaller(this.heap[l+1], this.heap[l])) {
                    l = l+1;
                }

                if (smaller(this.heap[index], this.heap[l])) {
                    break;
                }

                let t = this.heap[index];
                this.heap[index] = this.heap[l];
                this.heap[l] = t;

                index = l;
            }
        }

        push(node) {
            node.pushCount = ++this.pushCount;
            this.heap.push(node);
            this.percUp(this.heap.length-1);
        }

        unshift(node) {
            return this.heap.push(node);
        }

        shift() {
            let [top] = this.heap;

            this.heap[0] = this.heap[this.heap.length-1];
            this.heap.pop();
            this.percDown(0);

            return top;
        }

        toArray() {
            return [...this];
        }

        *[Symbol.iterator] () {
            for (let i = 0; i < this.heap.length; i++) {
                yield this.heap[i].data;
            }
        }

        remove (testFn) {
            let j = 0;
            for (let i = 0; i < this.heap.length; i++) {
                if (!testFn(this.heap[i])) {
                    this.heap[j] = this.heap[i];
                    j++;
                }
            }

            this.heap.splice(j);

            for (let i = parent(this.heap.length-1); i >= 0; i--) {
                this.percDown(i);
            }

            return this;
        }
    }

    function leftChi(i) {
        return (i<<1)+1;
    }

    function parent(i) {
        return ((i+1)>>1)-1;
    }

    function smaller(x, y) {
        if (x.priority !== y.priority) {
            return x.priority < y.priority;
        }
        else {
            return x.pushCount < y.pushCount;
        }
    }

    /**
     * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
     * completed in ascending priority order.
     *
     * @name priorityQueue
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.queue]{@link module:ControlFlow.queue}
     * @category Control Flow
     * @param {AsyncFunction} worker - An async function for processing a queued task.
     * If you want to handle errors from an individual task, pass a callback to
     * `q.push()`.
     * Invoked with (task, callback).
     * @param {number} concurrency - An `integer` for determining how many `worker`
     * functions should be run in parallel.  If omitted, the concurrency defaults to
     * `1`.  If the concurrency is `0`, an error is thrown.
     * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are three
     * differences between `queue` and `priorityQueue` objects:
     * * `push(task, priority, [callback])` - `priority` should be a number. If an
     *   array of `tasks` is given, all tasks will be assigned the same priority.
     * * `pushAsync(task, priority, [callback])` - the same as `priorityQueue.push`,
     *   except this returns a promise that rejects if an error occurs.
     * * The `unshift` and `unshiftAsync` methods were removed.
     */
    function priorityQueue(worker, concurrency) {
        // Start with a normal queue
        var q = queue(worker, concurrency);

        var {
            push,
            pushAsync
        } = q;

        q._tasks = new Heap();
        q._createTaskItem = ({data, priority}, callback) => {
            return {
                data,
                priority,
                callback
            };
        };

        function createDataItems(tasks, priority) {
            if (!Array.isArray(tasks)) {
                return {data: tasks, priority};
            }
            return tasks.map(data => { return {data, priority}; });
        }

        // Override push to accept second parameter representing priority
        q.push = function(data, priority = 0, callback) {
            return push(createDataItems(data, priority), callback);
        };

        q.pushAsync = function(data, priority = 0, callback) {
            return pushAsync(createDataItems(data, priority), callback);
        };

        // Remove unshift functions
        delete q.unshift;
        delete q.unshiftAsync;

        return q;
    }

    /**
     * Runs the `tasks` array of functions in parallel, without waiting until the
     * previous function has completed. Once any of the `tasks` complete or pass an
     * error to its callback, the main `callback` is immediately called. It's
     * equivalent to `Promise.race()`.
     *
     * @name race
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
     * to run. Each function can complete with an optional `result` value.
     * @param {Function} callback - A callback to run once any of the functions have
     * completed. This function gets an error or result from the first function that
     * completed. Invoked with (err, result).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * async.race([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ],
     * // main callback
     * function(err, result) {
     *     // the result will be equal to 'two' as it finishes earlier
     * });
     */
    function race(tasks, callback) {
        callback = once(callback);
        if (!Array.isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
        if (!tasks.length) return callback();
        for (var i = 0, l = tasks.length; i < l; i++) {
            wrapAsync(tasks[i])(callback);
        }
    }

    var race$1 = awaitify(race, 2);

    /**
     * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
     *
     * @name reduceRight
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.reduce]{@link module:Collections.reduce}
     * @alias foldr
     * @category Collection
     * @param {Array} array - A collection to iterate over.
     * @param {*} memo - The initial state of the reduction.
     * @param {AsyncFunction} iteratee - A function applied to each item in the
     * array to produce the next step in the reduction.
     * The `iteratee` should complete with the next state of the reduction.
     * If the iteratee completes with an error, the reduction is stopped and the
     * main `callback` is immediately called with the error.
     * Invoked with (memo, item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result is the reduced value. Invoked with
     * (err, result).
     * @returns {Promise} a promise, if no callback is passed
     */
    function reduceRight (array, memo, iteratee, callback) {
        var reversed = [...array].reverse();
        return reduce$1(reversed, memo, iteratee, callback);
    }

    /**
     * Wraps the async function in another function that always completes with a
     * result object, even when it errors.
     *
     * The result object has either the property `error` or `value`.
     *
     * @name reflect
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} fn - The async function you want to wrap
     * @returns {Function} - A function that always passes null to it's callback as
     * the error. The second argument to the callback will be an `object` with
     * either an `error` or a `value` property.
     * @example
     *
     * async.parallel([
     *     async.reflect(function(callback) {
     *         // do some stuff ...
     *         callback(null, 'one');
     *     }),
     *     async.reflect(function(callback) {
     *         // do some more stuff but error ...
     *         callback('bad stuff happened');
     *     }),
     *     async.reflect(function(callback) {
     *         // do some more stuff ...
     *         callback(null, 'two');
     *     })
     * ],
     * // optional callback
     * function(err, results) {
     *     // values
     *     // results[0].value = 'one'
     *     // results[1].error = 'bad stuff happened'
     *     // results[2].value = 'two'
     * });
     */
    function reflect(fn) {
        var _fn = wrapAsync(fn);
        return initialParams(function reflectOn(args, reflectCallback) {
            args.push((error, ...cbArgs) => {
                let retVal = {};
                if (error) {
                    retVal.error = error;
                }
                if (cbArgs.length > 0){
                    var value = cbArgs;
                    if (cbArgs.length <= 1) {
                        [value] = cbArgs;
                    }
                    retVal.value = value;
                }
                reflectCallback(null, retVal);
            });

            return _fn.apply(this, args);
        });
    }

    /**
     * A helper function that wraps an array or an object of functions with `reflect`.
     *
     * @name reflectAll
     * @static
     * @memberOf module:Utils
     * @method
     * @see [async.reflect]{@link module:Utils.reflect}
     * @category Util
     * @param {Array|Object|Iterable} tasks - The collection of
     * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
     * @returns {Array} Returns an array of async functions, each wrapped in
     * `async.reflect`
     * @example
     *
     * let tasks = [
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         // do some more stuff but error ...
     *         callback(new Error('bad stuff happened'));
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ];
     *
     * async.parallel(async.reflectAll(tasks),
     * // optional callback
     * function(err, results) {
     *     // values
     *     // results[0].value = 'one'
     *     // results[1].error = Error('bad stuff happened')
     *     // results[2].value = 'two'
     * });
     *
     * // an example using an object instead of an array
     * let tasks = {
     *     one: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         callback('two');
     *     },
     *     three: function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'three');
     *         }, 100);
     *     }
     * };
     *
     * async.parallel(async.reflectAll(tasks),
     * // optional callback
     * function(err, results) {
     *     // values
     *     // results.one.value = 'one'
     *     // results.two.error = 'two'
     *     // results.three.value = 'three'
     * });
     */
    function reflectAll(tasks) {
        var results;
        if (Array.isArray(tasks)) {
            results = tasks.map(reflect);
        } else {
            results = {};
            Object.keys(tasks).forEach(key => {
                results[key] = reflect.call(this, tasks[key]);
            });
        }
        return results;
    }

    function reject$2(eachfn, arr, _iteratee, callback) {
        const iteratee = wrapAsync(_iteratee);
        return _filter(eachfn, arr, (value, cb) => {
            iteratee(value, (err, v) => {
                cb(err, !v);
            });
        }, callback);
    }

    /**
     * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
     *
     * @name reject
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.filter]{@link module:Collections.filter}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - An async truth test to apply to each item in
     * `coll`.
     * The should complete with a boolean value as its `result`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     *
     * const fileList = ['dir1/file1.txt','dir2/file3.txt','dir3/file6.txt'];
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.reject(fileList, fileExists, function(err, results) {
     *    // [ 'dir3/file6.txt' ]
     *    // results now equals an array of the non-existing files
     * });
     *
     * // Using Promises
     * async.reject(fileList, fileExists)
     * .then( results => {
     *     console.log(results);
     *     // [ 'dir3/file6.txt' ]
     *     // results now equals an array of the non-existing files
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let results = await async.reject(fileList, fileExists);
     *         console.log(results);
     *         // [ 'dir3/file6.txt' ]
     *         // results now equals an array of the non-existing files
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function reject (coll, iteratee, callback) {
        return reject$2(eachOf$1, coll, iteratee, callback)
    }
    var reject$1 = awaitify(reject, 3);

    /**
     * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name rejectLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.reject]{@link module:Collections.reject}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {Function} iteratee - An async truth test to apply to each item in
     * `coll`.
     * The should complete with a boolean value as its `result`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function rejectLimit (coll, limit, iteratee, callback) {
        return reject$2(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var rejectLimit$1 = awaitify(rejectLimit, 4);

    /**
     * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
     *
     * @name rejectSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.reject]{@link module:Collections.reject}
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {Function} iteratee - An async truth test to apply to each item in
     * `coll`.
     * The should complete with a boolean value as its `result`.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback is passed
     */
    function rejectSeries (coll, iteratee, callback) {
        return reject$2(eachOfSeries$1, coll, iteratee, callback)
    }
    var rejectSeries$1 = awaitify(rejectSeries, 3);

    function constant(value) {
        return function () {
            return value;
        }
    }

    /**
     * Attempts to get a successful response from `task` no more than `times` times
     * before returning an error. If the task is successful, the `callback` will be
     * passed the result of the successful task. If all attempts fail, the callback
     * will be passed the error and result (if any) of the final attempt.
     *
     * @name retry
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @see [async.retryable]{@link module:ControlFlow.retryable}
     * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
     * object with `times` and `interval` or a number.
     * * `times` - The number of attempts to make before giving up.  The default
     *   is `5`.
     * * `interval` - The time to wait between retries, in milliseconds.  The
     *   default is `0`. The interval may also be specified as a function of the
     *   retry count (see example).
     * * `errorFilter` - An optional synchronous function that is invoked on
     *   erroneous result. If it returns `true` the retry attempts will continue;
     *   if the function returns `false` the retry flow is aborted with the current
     *   attempt's error and result being returned to the final callback.
     *   Invoked with (err).
     * * If `opts` is a number, the number specifies the number of times to retry,
     *   with the default interval of `0`.
     * @param {AsyncFunction} task - An async function to retry.
     * Invoked with (callback).
     * @param {Function} [callback] - An optional callback which is called when the
     * task has succeeded, or after the final failed attempt. It receives the `err`
     * and `result` arguments of the last attempt at completing the `task`. Invoked
     * with (err, results).
     * @returns {Promise} a promise if no callback provided
     *
     * @example
     *
     * // The `retry` function can be used as a stand-alone control flow by passing
     * // a callback, as shown below:
     *
     * // try calling apiMethod 3 times
     * async.retry(3, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod 3 times, waiting 200 ms between each retry
     * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod 10 times with exponential backoff
     * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
     * async.retry({
     *   times: 10,
     *   interval: function(retryCount) {
     *     return 50 * Math.pow(2, retryCount);
     *   }
     * }, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod the default 5 times no delay between each retry
     * async.retry(apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // try calling apiMethod only when error condition satisfies, all other
     * // errors will abort the retry control flow and return to final callback
     * async.retry({
     *   errorFilter: function(err) {
     *     return err.message === 'Temporary error'; // only retry on a specific error
     *   }
     * }, apiMethod, function(err, result) {
     *     // do something with the result
     * });
     *
     * // to retry individual methods that are not as reliable within other
     * // control flow functions, use the `retryable` wrapper:
     * async.auto({
     *     users: api.getUsers.bind(api),
     *     payments: async.retryable(3, api.getPayments.bind(api))
     * }, function(err, results) {
     *     // do something with the results
     * });
     *
     */
    const DEFAULT_TIMES = 5;
    const DEFAULT_INTERVAL = 0;

    function retry(opts, task, callback) {
        var options = {
            times: DEFAULT_TIMES,
            intervalFunc: constant(DEFAULT_INTERVAL)
        };

        if (arguments.length < 3 && typeof opts === 'function') {
            callback = task || promiseCallback();
            task = opts;
        } else {
            parseTimes(options, opts);
            callback = callback || promiseCallback();
        }

        if (typeof task !== 'function') {
            throw new Error("Invalid arguments for async.retry");
        }

        var _task = wrapAsync(task);

        var attempt = 1;
        function retryAttempt() {
            _task((err, ...args) => {
                if (err === false) return
                if (err && attempt++ < options.times &&
                    (typeof options.errorFilter != 'function' ||
                        options.errorFilter(err))) {
                    setTimeout(retryAttempt, options.intervalFunc(attempt - 1));
                } else {
                    callback(err, ...args);
                }
            });
        }

        retryAttempt();
        return callback[PROMISE_SYMBOL]
    }

    function parseTimes(acc, t) {
        if (typeof t === 'object') {
            acc.times = +t.times || DEFAULT_TIMES;

            acc.intervalFunc = typeof t.interval === 'function' ?
                t.interval :
                constant(+t.interval || DEFAULT_INTERVAL);

            acc.errorFilter = t.errorFilter;
        } else if (typeof t === 'number' || typeof t === 'string') {
            acc.times = +t || DEFAULT_TIMES;
        } else {
            throw new Error("Invalid arguments for async.retry");
        }
    }

    /**
     * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
     * wraps a task and makes it retryable, rather than immediately calling it
     * with retries.
     *
     * @name retryable
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.retry]{@link module:ControlFlow.retry}
     * @category Control Flow
     * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
     * options, exactly the same as from `retry`, except for a `opts.arity` that
     * is the arity of the `task` function, defaulting to `task.length`
     * @param {AsyncFunction} task - the asynchronous function to wrap.
     * This function will be passed any arguments passed to the returned wrapper.
     * Invoked with (...args, callback).
     * @returns {AsyncFunction} The wrapped function, which when invoked, will
     * retry on an error, based on the parameters specified in `opts`.
     * This function will accept the same parameters as `task`.
     * @example
     *
     * async.auto({
     *     dep1: async.retryable(3, getFromFlakyService),
     *     process: ["dep1", async.retryable(3, function (results, cb) {
     *         maybeProcessData(results.dep1, cb);
     *     })]
     * }, callback);
     */
    function retryable (opts, task) {
        if (!task) {
            task = opts;
            opts = null;
        }
        let arity = (opts && opts.arity) || task.length;
        if (isAsync(task)) {
            arity += 1;
        }
        var _task = wrapAsync(task);
        return initialParams((args, callback) => {
            if (args.length < arity - 1 || callback == null) {
                args.push(callback);
                callback = promiseCallback();
            }
            function taskFn(cb) {
                _task(...args, cb);
            }

            if (opts) retry(opts, taskFn, callback);
            else retry(taskFn, callback);

            return callback[PROMISE_SYMBOL]
        });
    }

    /**
     * Run the functions in the `tasks` collection in series, each one running once
     * the previous function has completed. If any functions in the series pass an
     * error to its callback, no more functions are run, and `callback` is
     * immediately called with the value of the error. Otherwise, `callback`
     * receives an array of results when `tasks` have completed.
     *
     * It is also possible to use an object instead of an array. Each property will
     * be run as a function, and the results will be passed to the final `callback`
     * as an object instead of an array. This can be a more readable way of handling
     *  results from {@link async.series}.
     *
     * **Note** that while many implementations preserve the order of object
     * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
     * explicitly states that
     *
     * > The mechanics and order of enumerating the properties is not specified.
     *
     * So if you rely on the order in which your series of functions are executed,
     * and want this to work on all platforms, consider using an array.
     *
     * @name series
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
     * [async functions]{@link AsyncFunction} to run in series.
     * Each function can complete with any number of optional `result` values.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed. This function gets a results array (or object)
     * containing all the result arguments passed to the `task` callbacks. Invoked
     * with (err, result).
     * @return {Promise} a promise, if no callback is passed
     * @example
     *
     * //Using Callbacks
     * async.series([
     *     function(callback) {
     *         setTimeout(function() {
     *             // do some async task
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             // then do another async task
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ], function(err, results) {
     *     console.log(results);
     *     // results is equal to ['one','two']
     * });
     *
     * // an example using objects instead of arrays
     * async.series({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             // do some async task
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             // then do another async task
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }, function(err, results) {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * });
     *
     * //Using Promises
     * async.series([
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'one');
     *         }, 200);
     *     },
     *     function(callback) {
     *         setTimeout(function() {
     *             callback(null, 'two');
     *         }, 100);
     *     }
     * ]).then(results => {
     *     console.log(results);
     *     // results is equal to ['one','two']
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // an example using an object instead of an array
     * async.series({
     *     one: function(callback) {
     *         setTimeout(function() {
     *             // do some async task
     *             callback(null, 1);
     *         }, 200);
     *     },
     *     two: function(callback) {
     *         setTimeout(function() {
     *             // then do another async task
     *             callback(null, 2);
     *         }, 100);
     *     }
     * }).then(results => {
     *     console.log(results);
     *     // results is equal to: { one: 1, two: 2 }
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * //Using async/await
     * async () => {
     *     try {
     *         let results = await async.series([
     *             function(callback) {
     *                 setTimeout(function() {
     *                     // do some async task
     *                     callback(null, 'one');
     *                 }, 200);
     *             },
     *             function(callback) {
     *                 setTimeout(function() {
     *                     // then do another async task
     *                     callback(null, 'two');
     *                 }, 100);
     *             }
     *         ]);
     *         console.log(results);
     *         // results is equal to ['one','two']
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * // an example using an object instead of an array
     * async () => {
     *     try {
     *         let results = await async.parallel({
     *             one: function(callback) {
     *                 setTimeout(function() {
     *                     // do some async task
     *                     callback(null, 1);
     *                 }, 200);
     *             },
     *            two: function(callback) {
     *                 setTimeout(function() {
     *                     // then do another async task
     *                     callback(null, 2);
     *                 }, 100);
     *            }
     *         });
     *         console.log(results);
     *         // results is equal to: { one: 1, two: 2 }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function series(tasks, callback) {
        return _parallel(eachOfSeries$1, tasks, callback);
    }

    /**
     * Returns `true` if at least one element in the `coll` satisfies an async test.
     * If any iteratee call returns `true`, the main `callback` is immediately
     * called.
     *
     * @name some
     * @static
     * @memberOf module:Collections
     * @method
     * @alias any
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collections in parallel.
     * The iteratee should complete with a boolean `result` value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the iteratee functions have finished.
     * Result will be either `true` or `false` depending on the values of the async
     * tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // dir1 is a directory that contains file1.txt, file2.txt
     * // dir2 is a directory that contains file3.txt, file4.txt
     * // dir3 is a directory that contains file5.txt
     * // dir4 does not exist
     *
     * // asynchronous function that checks if a file exists
     * function fileExists(file, callback) {
     *    fs.access(file, fs.constants.F_OK, (err) => {
     *        callback(null, !err);
     *    });
     * }
     *
     * // Using callbacks
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists,
     *    function(err, result) {
     *        console.log(result);
     *        // true
     *        // result is true since some file in the list exists
     *    }
     *);
     *
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists,
     *    function(err, result) {
     *        console.log(result);
     *        // false
     *        // result is false since none of the files exists
     *    }
     *);
     *
     * // Using Promises
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists)
     * .then( result => {
     *     console.log(result);
     *     // true
     *     // result is true since some file in the list exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists)
     * .then( result => {
     *     console.log(result);
     *     // false
     *     // result is false since none of the files exists
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir3/file5.txt'], fileExists);
     *         console.log(result);
     *         // true
     *         // result is true since some file in the list exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     * async () => {
     *     try {
     *         let result = await async.some(['dir1/missing.txt','dir2/missing.txt','dir4/missing.txt'], fileExists);
     *         console.log(result);
     *         // false
     *         // result is false since none of the files exists
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function some(coll, iteratee, callback) {
        return _createTester(Boolean, res => res)(eachOf$1, coll, iteratee, callback)
    }
    var some$1 = awaitify(some, 3);

    /**
     * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
     *
     * @name someLimit
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.some]{@link module:Collections.some}
     * @alias anyLimit
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collections in parallel.
     * The iteratee should complete with a boolean `result` value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the iteratee functions have finished.
     * Result will be either `true` or `false` depending on the values of the async
     * tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function someLimit(coll, limit, iteratee, callback) {
        return _createTester(Boolean, res => res)(eachOfLimit$2(limit), coll, iteratee, callback)
    }
    var someLimit$1 = awaitify(someLimit, 4);

    /**
     * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
     *
     * @name someSeries
     * @static
     * @memberOf module:Collections
     * @method
     * @see [async.some]{@link module:Collections.some}
     * @alias anySeries
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
     * in the collections in series.
     * The iteratee should complete with a boolean `result` value.
     * Invoked with (item, callback).
     * @param {Function} [callback] - A callback which is called as soon as any
     * iteratee returns `true`, or after all the iteratee functions have finished.
     * Result will be either `true` or `false` depending on the values of the async
     * tests. Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     */
    function someSeries(coll, iteratee, callback) {
        return _createTester(Boolean, res => res)(eachOfSeries$1, coll, iteratee, callback)
    }
    var someSeries$1 = awaitify(someSeries, 3);

    /**
     * Sorts a list by the results of running each `coll` value through an async
     * `iteratee`.
     *
     * @name sortBy
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {AsyncFunction} iteratee - An async function to apply to each item in
     * `coll`.
     * The iteratee should complete with a value to use as the sort criteria as
     * its `result`.
     * Invoked with (item, callback).
     * @param {Function} callback - A callback which is called after all the
     * `iteratee` functions have finished, or an error occurs. Results is the items
     * from the original `coll` sorted by the values returned by the `iteratee`
     * calls. Invoked with (err, results).
     * @returns {Promise} a promise, if no callback passed
     * @example
     *
     * // bigfile.txt is a file that is 251100 bytes in size
     * // mediumfile.txt is a file that is 11000 bytes in size
     * // smallfile.txt is a file that is 121 bytes in size
     *
     * // asynchronous function that returns the file size in bytes
     * function getFileSizeInBytes(file, callback) {
     *     fs.stat(file, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         callback(null, stat.size);
     *     });
     * }
     *
     * // Using callbacks
     * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes,
     *     function(err, results) {
     *         if (err) {
     *             console.log(err);
     *         } else {
     *             console.log(results);
     *             // results is now the original array of files sorted by
     *             // file size (ascending by default), e.g.
     *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     *         }
     *     }
     * );
     *
     * // By modifying the callback parameter the
     * // sorting order can be influenced:
     *
     * // ascending order
     * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], function(file, callback) {
     *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
     *         if (getFileSizeErr) return callback(getFileSizeErr);
     *         callback(null, fileSize);
     *     });
     * }, function(err, results) {
     *         if (err) {
     *             console.log(err);
     *         } else {
     *             console.log(results);
     *             // results is now the original array of files sorted by
     *             // file size (ascending by default), e.g.
     *             // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     *         }
     *     }
     * );
     *
     * // descending order
     * async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], function(file, callback) {
     *     getFileSizeInBytes(file, function(getFileSizeErr, fileSize) {
     *         if (getFileSizeErr) {
     *             return callback(getFileSizeErr);
     *         }
     *         callback(null, fileSize * -1);
     *     });
     * }, function(err, results) {
     *         if (err) {
     *             console.log(err);
     *         } else {
     *             console.log(results);
     *             // results is now the original array of files sorted by
     *             // file size (ascending by default), e.g.
     *             // [ 'bigfile.txt', 'mediumfile.txt', 'smallfile.txt']
     *         }
     *     }
     * );
     *
     * // Error handling
     * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes,
     *     function(err, results) {
     *         if (err) {
     *             console.log(err);
     *             // [ Error: ENOENT: no such file or directory ]
     *         } else {
     *             console.log(results);
     *         }
     *     }
     * );
     *
     * // Using Promises
     * async.sortBy(['mediumfile.txt','smallfile.txt','bigfile.txt'], getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     *     // results is now the original array of files sorted by
     *     // file size (ascending by default), e.g.
     *     // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     * }).catch( err => {
     *     console.log(err);
     * });
     *
     * // Error handling
     * async.sortBy(['mediumfile.txt','smallfile.txt','missingfile.txt'], getFileSizeInBytes)
     * .then( results => {
     *     console.log(results);
     * }).catch( err => {
     *     console.log(err);
     *     // [ Error: ENOENT: no such file or directory ]
     * });
     *
     * // Using async/await
     * (async () => {
     *     try {
     *         let results = await async.sortBy(['bigfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
     *         console.log(results);
     *         // results is now the original array of files sorted by
     *         // file size (ascending by default), e.g.
     *         // [ 'smallfile.txt', 'mediumfile.txt', 'bigfile.txt']
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * })();
     *
     * // Error handling
     * async () => {
     *     try {
     *         let results = await async.sortBy(['missingfile.txt','mediumfile.txt','smallfile.txt'], getFileSizeInBytes);
     *         console.log(results);
     *     }
     *     catch (err) {
     *         console.log(err);
     *         // [ Error: ENOENT: no such file or directory ]
     *     }
     * }
     *
     */
    function sortBy (coll, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return map$1(coll, (x, iterCb) => {
            _iteratee(x, (err, criteria) => {
                if (err) return iterCb(err);
                iterCb(err, {value: x, criteria});
            });
        }, (err, results) => {
            if (err) return callback(err);
            callback(null, results.sort(comparator).map(v => v.value));
        });

        function comparator(left, right) {
            var a = left.criteria, b = right.criteria;
            return a < b ? -1 : a > b ? 1 : 0;
        }
    }
    var sortBy$1 = awaitify(sortBy, 3);

    /**
     * Sets a time limit on an asynchronous function. If the function does not call
     * its callback within the specified milliseconds, it will be called with a
     * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
     *
     * @name timeout
     * @static
     * @memberOf module:Utils
     * @method
     * @category Util
     * @param {AsyncFunction} asyncFn - The async function to limit in time.
     * @param {number} milliseconds - The specified time limit.
     * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
     * to timeout Error for more information..
     * @returns {AsyncFunction} Returns a wrapped function that can be used with any
     * of the control flow functions.
     * Invoke this function with the same parameters as you would `asyncFunc`.
     * @example
     *
     * function myFunction(foo, callback) {
     *     doAsyncTask(foo, function(err, data) {
     *         // handle errors
     *         if (err) return callback(err);
     *
     *         // do some stuff ...
     *
     *         // return processed data
     *         return callback(null, data);
     *     });
     * }
     *
     * var wrapped = async.timeout(myFunction, 1000);
     *
     * // call `wrapped` as you would `myFunction`
     * wrapped({ bar: 'bar' }, function(err, data) {
     *     // if `myFunction` takes < 1000 ms to execute, `err`
     *     // and `data` will have their expected values
     *
     *     // else `err` will be an Error with the code 'ETIMEDOUT'
     * });
     */
    function timeout(asyncFn, milliseconds, info) {
        var fn = wrapAsync(asyncFn);

        return initialParams((args, callback) => {
            var timedOut = false;
            var timer;

            function timeoutCallback() {
                var name = asyncFn.name || 'anonymous';
                var error  = new Error('Callback function "' + name + '" timed out.');
                error.code = 'ETIMEDOUT';
                if (info) {
                    error.info = info;
                }
                timedOut = true;
                callback(error);
            }

            args.push((...cbArgs) => {
                if (!timedOut) {
                    callback(...cbArgs);
                    clearTimeout(timer);
                }
            });

            // setup timer and call original function
            timer = setTimeout(timeoutCallback, milliseconds);
            fn(...args);
        });
    }

    function range(size) {
        var result = Array(size);
        while (size--) {
            result[size] = size;
        }
        return result;
    }

    /**
     * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
     * time.
     *
     * @name timesLimit
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.times]{@link module:ControlFlow.times}
     * @category Control Flow
     * @param {number} count - The number of times to run the function.
     * @param {number} limit - The maximum number of async operations at a time.
     * @param {AsyncFunction} iteratee - The async function to call `n` times.
     * Invoked with the iteration index and a callback: (n, next).
     * @param {Function} callback - see [async.map]{@link module:Collections.map}.
     * @returns {Promise} a promise, if no callback is provided
     */
    function timesLimit(count, limit, iteratee, callback) {
        var _iteratee = wrapAsync(iteratee);
        return mapLimit$1(range(count), limit, _iteratee, callback);
    }

    /**
     * Calls the `iteratee` function `n` times, and accumulates results in the same
     * manner you would use with [map]{@link module:Collections.map}.
     *
     * @name times
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.map]{@link module:Collections.map}
     * @category Control Flow
     * @param {number} n - The number of times to run the function.
     * @param {AsyncFunction} iteratee - The async function to call `n` times.
     * Invoked with the iteration index and a callback: (n, next).
     * @param {Function} callback - see {@link module:Collections.map}.
     * @returns {Promise} a promise, if no callback is provided
     * @example
     *
     * // Pretend this is some complicated async factory
     * var createUser = function(id, callback) {
     *     callback(null, {
     *         id: 'user' + id
     *     });
     * };
     *
     * // generate 5 users
     * async.times(5, function(n, next) {
     *     createUser(n, function(err, user) {
     *         next(err, user);
     *     });
     * }, function(err, users) {
     *     // we should now have 5 users
     * });
     */
    function times (n, iteratee, callback) {
        return timesLimit(n, Infinity, iteratee, callback)
    }

    /**
     * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
     *
     * @name timesSeries
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.times]{@link module:ControlFlow.times}
     * @category Control Flow
     * @param {number} n - The number of times to run the function.
     * @param {AsyncFunction} iteratee - The async function to call `n` times.
     * Invoked with the iteration index and a callback: (n, next).
     * @param {Function} callback - see {@link module:Collections.map}.
     * @returns {Promise} a promise, if no callback is provided
     */
    function timesSeries (n, iteratee, callback) {
        return timesLimit(n, 1, iteratee, callback)
    }

    /**
     * A relative of `reduce`.  Takes an Object or Array, and iterates over each
     * element in parallel, each step potentially mutating an `accumulator` value.
     * The type of the accumulator defaults to the type of collection passed in.
     *
     * @name transform
     * @static
     * @memberOf module:Collections
     * @method
     * @category Collection
     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
     * @param {*} [accumulator] - The initial state of the transform.  If omitted,
     * it will default to an empty Object or Array, depending on the type of `coll`
     * @param {AsyncFunction} iteratee - A function applied to each item in the
     * collection that potentially modifies the accumulator.
     * Invoked with (accumulator, item, key, callback).
     * @param {Function} [callback] - A callback which is called after all the
     * `iteratee` functions have finished. Result is the transformed accumulator.
     * Invoked with (err, result).
     * @returns {Promise} a promise, if no callback provided
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     *
     * // helper function that returns human-readable size format from bytes
     * function formatBytes(bytes, decimals = 2) {
     *   // implementation not included for brevity
     *   return humanReadbleFilesize;
     * }
     *
     * const fileList = ['file1.txt','file2.txt','file3.txt'];
     *
     * // asynchronous function that returns the file size, transformed to human-readable format
     * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
     * function transformFileSize(acc, value, key, callback) {
     *     fs.stat(value, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         acc[key] = formatBytes(stat.size);
     *         callback(null);
     *     });
     * }
     *
     * // Using callbacks
     * async.transform(fileList, transformFileSize, function(err, result) {
     *     if(err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
     *     }
     * });
     *
     * // Using Promises
     * async.transform(fileList, transformFileSize)
     * .then(result => {
     *     console.log(result);
     *     // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * (async () => {
     *     try {
     *         let result = await async.transform(fileList, transformFileSize);
     *         console.log(result);
     *         // [ '1000 Bytes', '1.95 KB', '2.93 KB' ]
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * })();
     *
     * @example
     *
     * // file1.txt is a file that is 1000 bytes in size
     * // file2.txt is a file that is 2000 bytes in size
     * // file3.txt is a file that is 3000 bytes in size
     *
     * // helper function that returns human-readable size format from bytes
     * function formatBytes(bytes, decimals = 2) {
     *   // implementation not included for brevity
     *   return humanReadbleFilesize;
     * }
     *
     * const fileMap = { f1: 'file1.txt', f2: 'file2.txt', f3: 'file3.txt' };
     *
     * // asynchronous function that returns the file size, transformed to human-readable format
     * // e.g. 1024 bytes = 1KB, 1234 bytes = 1.21 KB, 1048576 bytes = 1MB, etc.
     * function transformFileSize(acc, value, key, callback) {
     *     fs.stat(value, function(err, stat) {
     *         if (err) {
     *             return callback(err);
     *         }
     *         acc[key] = formatBytes(stat.size);
     *         callback(null);
     *     });
     * }
     *
     * // Using callbacks
     * async.transform(fileMap, transformFileSize, function(err, result) {
     *     if(err) {
     *         console.log(err);
     *     } else {
     *         console.log(result);
     *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
     *     }
     * });
     *
     * // Using Promises
     * async.transform(fileMap, transformFileSize)
     * .then(result => {
     *     console.log(result);
     *     // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
     * }).catch(err => {
     *     console.log(err);
     * });
     *
     * // Using async/await
     * async () => {
     *     try {
     *         let result = await async.transform(fileMap, transformFileSize);
     *         console.log(result);
     *         // { f1: '1000 Bytes', f2: '1.95 KB', f3: '2.93 KB' }
     *     }
     *     catch (err) {
     *         console.log(err);
     *     }
     * }
     *
     */
    function transform (coll, accumulator, iteratee, callback) {
        if (arguments.length <= 3 && typeof accumulator === 'function') {
            callback = iteratee;
            iteratee = accumulator;
            accumulator = Array.isArray(coll) ? [] : {};
        }
        callback = once(callback || promiseCallback());
        var _iteratee = wrapAsync(iteratee);

        eachOf$1(coll, (v, k, cb) => {
            _iteratee(accumulator, v, k, cb);
        }, err => callback(err, accumulator));
        return callback[PROMISE_SYMBOL]
    }

    /**
     * It runs each task in series but stops whenever any of the functions were
     * successful. If one of the tasks were successful, the `callback` will be
     * passed the result of the successful task. If all tasks fail, the callback
     * will be passed the error and result (if any) of the final attempt.
     *
     * @name tryEach
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing functions to
     * run, each function is passed a `callback(err, result)` it must call on
     * completion with an error `err` (which can be `null`) and an optional `result`
     * value.
     * @param {Function} [callback] - An optional callback which is called when one
     * of the tasks has succeeded, or all have failed. It receives the `err` and
     * `result` arguments of the last attempt at completing the `task`. Invoked with
     * (err, results).
     * @returns {Promise} a promise, if no callback is passed
     * @example
     * async.tryEach([
     *     function getDataFromFirstWebsite(callback) {
     *         // Try getting the data from the first website
     *         callback(err, data);
     *     },
     *     function getDataFromSecondWebsite(callback) {
     *         // First website failed,
     *         // Try getting the data from the backup website
     *         callback(err, data);
     *     }
     * ],
     * // optional callback
     * function(err, results) {
     *     Now do something with the data.
     * });
     *
     */
    function tryEach(tasks, callback) {
        var error = null;
        var result;
        return eachSeries$1(tasks, (task, taskCb) => {
            wrapAsync(task)((err, ...args) => {
                if (err === false) return taskCb(err);

                if (args.length < 2) {
                    [result] = args;
                } else {
                    result = args;
                }
                error = err;
                taskCb(err ? null : {});
            });
        }, () => callback(error, result));
    }

    var tryEach$1 = awaitify(tryEach);

    /**
     * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
     * unmemoized form. Handy for testing.
     *
     * @name unmemoize
     * @static
     * @memberOf module:Utils
     * @method
     * @see [async.memoize]{@link module:Utils.memoize}
     * @category Util
     * @param {AsyncFunction} fn - the memoized function
     * @returns {AsyncFunction} a function that calls the original unmemoized function
     */
    function unmemoize(fn) {
        return (...args) => {
            return (fn.unmemoized || fn)(...args);
        };
    }

    /**
     * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
     * stopped, or an error occurs.
     *
     * @name whilst
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {AsyncFunction} test - asynchronous truth test to perform before each
     * execution of `iteratee`. Invoked with (callback).
     * @param {AsyncFunction} iteratee - An async function which is called each time
     * `test` passes. Invoked with (callback).
     * @param {Function} [callback] - A callback which is called after the test
     * function has failed and repeated execution of `iteratee` has stopped. `callback`
     * will be passed an error and any arguments passed to the final `iteratee`'s
     * callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if no callback is passed
     * @example
     *
     * var count = 0;
     * async.whilst(
     *     function test(cb) { cb(null, count < 5); },
     *     function iter(callback) {
     *         count++;
     *         setTimeout(function() {
     *             callback(null, count);
     *         }, 1000);
     *     },
     *     function (err, n) {
     *         // 5 seconds have passed, n = 5
     *     }
     * );
     */
    function whilst(test, iteratee, callback) {
        callback = onlyOnce(callback);
        var _fn = wrapAsync(iteratee);
        var _test = wrapAsync(test);
        var results = [];

        function next(err, ...rest) {
            if (err) return callback(err);
            results = rest;
            if (err === false) return;
            _test(check);
        }

        function check(err, truth) {
            if (err) return callback(err);
            if (err === false) return;
            if (!truth) return callback(null, ...results);
            _fn(next);
        }

        return _test(check);
    }
    var whilst$1 = awaitify(whilst, 3);

    /**
     * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
     * stopped, or an error occurs. `callback` will be passed an error and any
     * arguments passed to the final `iteratee`'s callback.
     *
     * The inverse of [whilst]{@link module:ControlFlow.whilst}.
     *
     * @name until
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @see [async.whilst]{@link module:ControlFlow.whilst}
     * @category Control Flow
     * @param {AsyncFunction} test - asynchronous truth test to perform before each
     * execution of `iteratee`. Invoked with (callback).
     * @param {AsyncFunction} iteratee - An async function which is called each time
     * `test` fails. Invoked with (callback).
     * @param {Function} [callback] - A callback which is called after the test
     * function has passed and repeated execution of `iteratee` has stopped. `callback`
     * will be passed an error and any arguments passed to the final `iteratee`'s
     * callback. Invoked with (err, [results]);
     * @returns {Promise} a promise, if a callback is not passed
     *
     * @example
     * const results = []
     * let finished = false
     * async.until(function test(cb) {
     *     cb(null, finished)
     * }, function iter(next) {
     *     fetchPage(url, (err, body) => {
     *         if (err) return next(err)
     *         results = results.concat(body.objects)
     *         finished = !!body.next
     *         next(err)
     *     })
     * }, function done (err) {
     *     // all pages have been fetched
     * })
     */
    function until(test, iteratee, callback) {
        const _test = wrapAsync(test);
        return whilst$1((cb) => _test((err, truth) => cb (err, !truth)), iteratee, callback);
    }

    /**
     * Runs the `tasks` array of functions in series, each passing their results to
     * the next in the array. However, if any of the `tasks` pass an error to their
     * own callback, the next function is not executed, and the main `callback` is
     * immediately called with the error.
     *
     * @name waterfall
     * @static
     * @memberOf module:ControlFlow
     * @method
     * @category Control Flow
     * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
     * to run.
     * Each function should complete with any number of `result` values.
     * The `result` values will be passed as arguments, in order, to the next task.
     * @param {Function} [callback] - An optional callback to run once all the
     * functions have completed. This will be passed the results of the last task's
     * callback. Invoked with (err, [results]).
     * @returns {Promise} a promise, if a callback is omitted
     * @example
     *
     * async.waterfall([
     *     function(callback) {
     *         callback(null, 'one', 'two');
     *     },
     *     function(arg1, arg2, callback) {
     *         // arg1 now equals 'one' and arg2 now equals 'two'
     *         callback(null, 'three');
     *     },
     *     function(arg1, callback) {
     *         // arg1 now equals 'three'
     *         callback(null, 'done');
     *     }
     * ], function (err, result) {
     *     // result now equals 'done'
     * });
     *
     * // Or, with named functions:
     * async.waterfall([
     *     myFirstFunction,
     *     mySecondFunction,
     *     myLastFunction,
     * ], function (err, result) {
     *     // result now equals 'done'
     * });
     * function myFirstFunction(callback) {
     *     callback(null, 'one', 'two');
     * }
     * function mySecondFunction(arg1, arg2, callback) {
     *     // arg1 now equals 'one' and arg2 now equals 'two'
     *     callback(null, 'three');
     * }
     * function myLastFunction(arg1, callback) {
     *     // arg1 now equals 'three'
     *     callback(null, 'done');
     * }
     */
    function waterfall (tasks, callback) {
        callback = once(callback);
        if (!Array.isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
        if (!tasks.length) return callback();
        var taskIndex = 0;

        function nextTask(args) {
            var task = wrapAsync(tasks[taskIndex++]);
            task(...args, onlyOnce(next));
        }

        function next(err, ...args) {
            if (err === false) return
            if (err || taskIndex === tasks.length) {
                return callback(err, ...args);
            }
            nextTask(args);
        }

        nextTask([]);
    }

    var waterfall$1 = awaitify(waterfall);

    /**
     * An "async function" in the context of Async is an asynchronous function with
     * a variable number of parameters, with the final parameter being a callback.
     * (`function (arg1, arg2, ..., callback) {}`)
     * The final callback is of the form `callback(err, results...)`, which must be
     * called once the function is completed.  The callback should be called with a
     * Error as its first argument to signal that an error occurred.
     * Otherwise, if no error occurred, it should be called with `null` as the first
     * argument, and any additional `result` arguments that may apply, to signal
     * successful completion.
     * The callback must be called exactly once, ideally on a later tick of the
     * JavaScript event loop.
     *
     * This type of function is also referred to as a "Node-style async function",
     * or a "continuation passing-style function" (CPS). Most of the methods of this
     * library are themselves CPS/Node-style async functions, or functions that
     * return CPS/Node-style async functions.
     *
     * Wherever we accept a Node-style async function, we also directly accept an
     * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
     * In this case, the `async` function will not be passed a final callback
     * argument, and any thrown error will be used as the `err` argument of the
     * implicit callback, and the return value will be used as the `result` value.
     * (i.e. a `rejected` of the returned Promise becomes the `err` callback
     * argument, and a `resolved` value becomes the `result`.)
     *
     * Note, due to JavaScript limitations, we can only detect native `async`
     * functions and not transpilied implementations.
     * Your environment must have `async`/`await` support for this to work.
     * (e.g. Node > v7.6, or a recent version of a modern browser).
     * If you are using `async` functions through a transpiler (e.g. Babel), you
     * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
     * because the `async function` will be compiled to an ordinary function that
     * returns a promise.
     *
     * @typedef {Function} AsyncFunction
     * @static
     */


    var index = {
        apply,
        applyEach,
        applyEachSeries,
        asyncify,
        auto,
        autoInject,
        cargo: cargo$1,
        cargoQueue: cargo,
        compose,
        concat: concat$1,
        concatLimit: concatLimit$1,
        concatSeries: concatSeries$1,
        constant: constant$1,
        detect: detect$1,
        detectLimit: detectLimit$1,
        detectSeries: detectSeries$1,
        dir,
        doUntil,
        doWhilst: doWhilst$1,
        each,
        eachLimit: eachLimit$1,
        eachOf: eachOf$1,
        eachOfLimit: eachOfLimit$1,
        eachOfSeries: eachOfSeries$1,
        eachSeries: eachSeries$1,
        ensureAsync,
        every: every$1,
        everyLimit: everyLimit$1,
        everySeries: everySeries$1,
        filter: filter$1,
        filterLimit: filterLimit$1,
        filterSeries: filterSeries$1,
        forever: forever$1,
        groupBy,
        groupByLimit: groupByLimit$1,
        groupBySeries,
        log,
        map: map$1,
        mapLimit: mapLimit$1,
        mapSeries: mapSeries$1,
        mapValues,
        mapValuesLimit: mapValuesLimit$1,
        mapValuesSeries,
        memoize,
        nextTick,
        parallel,
        parallelLimit,
        priorityQueue,
        queue,
        race: race$1,
        reduce: reduce$1,
        reduceRight,
        reflect,
        reflectAll,
        reject: reject$1,
        rejectLimit: rejectLimit$1,
        rejectSeries: rejectSeries$1,
        retry,
        retryable,
        seq,
        series,
        setImmediate: setImmediate$1,
        some: some$1,
        someLimit: someLimit$1,
        someSeries: someSeries$1,
        sortBy: sortBy$1,
        timeout,
        times,
        timesLimit,
        timesSeries,
        transform,
        tryEach: tryEach$1,
        unmemoize,
        until,
        waterfall: waterfall$1,
        whilst: whilst$1,

        // aliases
        all: every$1,
        allLimit: everyLimit$1,
        allSeries: everySeries$1,
        any: some$1,
        anyLimit: someLimit$1,
        anySeries: someSeries$1,
        find: detect$1,
        findLimit: detectLimit$1,
        findSeries: detectSeries$1,
        flatMap: concat$1,
        flatMapLimit: concatLimit$1,
        flatMapSeries: concatSeries$1,
        forEach: each,
        forEachSeries: eachSeries$1,
        forEachLimit: eachLimit$1,
        forEachOf: eachOf$1,
        forEachOfSeries: eachOfSeries$1,
        forEachOfLimit: eachOfLimit$1,
        inject: reduce$1,
        foldl: reduce$1,
        foldr: reduceRight,
        select: filter$1,
        selectLimit: filterLimit$1,
        selectSeries: filterSeries$1,
        wrapSync: asyncify,
        during: whilst$1,
        doDuring: doWhilst$1
    };

    exports.all = every$1;
    exports.allLimit = everyLimit$1;
    exports.allSeries = everySeries$1;
    exports.any = some$1;
    exports.anyLimit = someLimit$1;
    exports.anySeries = someSeries$1;
    exports.apply = apply;
    exports.applyEach = applyEach;
    exports.applyEachSeries = applyEachSeries;
    exports.asyncify = asyncify;
    exports.auto = auto;
    exports.autoInject = autoInject;
    exports.cargo = cargo$1;
    exports.cargoQueue = cargo;
    exports.compose = compose;
    exports.concat = concat$1;
    exports.concatLimit = concatLimit$1;
    exports.concatSeries = concatSeries$1;
    exports.constant = constant$1;
    exports.default = index;
    exports.detect = detect$1;
    exports.detectLimit = detectLimit$1;
    exports.detectSeries = detectSeries$1;
    exports.dir = dir;
    exports.doDuring = doWhilst$1;
    exports.doUntil = doUntil;
    exports.doWhilst = doWhilst$1;
    exports.during = whilst$1;
    exports.each = each;
    exports.eachLimit = eachLimit$1;
    exports.eachOf = eachOf$1;
    exports.eachOfLimit = eachOfLimit$1;
    exports.eachOfSeries = eachOfSeries$1;
    exports.eachSeries = eachSeries$1;
    exports.ensureAsync = ensureAsync;
    exports.every = every$1;
    exports.everyLimit = everyLimit$1;
    exports.everySeries = everySeries$1;
    exports.filter = filter$1;
    exports.filterLimit = filterLimit$1;
    exports.filterSeries = filterSeries$1;
    exports.find = detect$1;
    exports.findLimit = detectLimit$1;
    exports.findSeries = detectSeries$1;
    exports.flatMap = concat$1;
    exports.flatMapLimit = concatLimit$1;
    exports.flatMapSeries = concatSeries$1;
    exports.foldl = reduce$1;
    exports.foldr = reduceRight;
    exports.forEach = each;
    exports.forEachLimit = eachLimit$1;
    exports.forEachOf = eachOf$1;
    exports.forEachOfLimit = eachOfLimit$1;
    exports.forEachOfSeries = eachOfSeries$1;
    exports.forEachSeries = eachSeries$1;
    exports.forever = forever$1;
    exports.groupBy = groupBy;
    exports.groupByLimit = groupByLimit$1;
    exports.groupBySeries = groupBySeries;
    exports.inject = reduce$1;
    exports.log = log;
    exports.map = map$1;
    exports.mapLimit = mapLimit$1;
    exports.mapSeries = mapSeries$1;
    exports.mapValues = mapValues;
    exports.mapValuesLimit = mapValuesLimit$1;
    exports.mapValuesSeries = mapValuesSeries;
    exports.memoize = memoize;
    exports.nextTick = nextTick;
    exports.parallel = parallel;
    exports.parallelLimit = parallelLimit;
    exports.priorityQueue = priorityQueue;
    exports.queue = queue;
    exports.race = race$1;
    exports.reduce = reduce$1;
    exports.reduceRight = reduceRight;
    exports.reflect = reflect;
    exports.reflectAll = reflectAll;
    exports.reject = reject$1;
    exports.rejectLimit = rejectLimit$1;
    exports.rejectSeries = rejectSeries$1;
    exports.retry = retry;
    exports.retryable = retryable;
    exports.select = filter$1;
    exports.selectLimit = filterLimit$1;
    exports.selectSeries = filterSeries$1;
    exports.seq = seq;
    exports.series = series;
    exports.setImmediate = setImmediate$1;
    exports.some = some$1;
    exports.someLimit = someLimit$1;
    exports.someSeries = someSeries$1;
    exports.sortBy = sortBy$1;
    exports.timeout = timeout;
    exports.times = times;
    exports.timesLimit = timesLimit;
    exports.timesSeries = timesSeries;
    exports.transform = transform;
    exports.tryEach = tryEach$1;
    exports.unmemoize = unmemoize;
    exports.until = until;
    exports.waterfall = waterfall$1;
    exports.whilst = whilst$1;
    exports.wrapSync = asyncify;

    Object.defineProperty(exports, '__esModule', { value: true });

}));

}).call(this)}).call(this,require('_process'),require("timers").setImmediate)

},{"_process":736,"timers":815}],331:[function(require,module,exports){
(function (global){(function (){
'use strict';

var possibleNames = require('possible-typed-array-names');

var g = typeof globalThis === 'undefined' ? global : globalThis;

/** @type {import('.')} */
module.exports = function availableTypedArrays() {
	var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			// @ts-expect-error
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"possible-typed-array-names":734}],332:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],333:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
      i++;
    }

    // Clear words above the requested width so the result stays below 2 ** width
    for (; i < this.length; i++) {
      this.words[i] = 0;
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    if (num === 0) {
      this.length = 1;
      this._normSign();
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.mod.abs();

    var half = num.abs().iushrn(1);
    var r2 = num.words[0] & 1;
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up, away from zero
    var up = new BN(1);
    up.negative = this.negative ^ num.negative;
    return dm.div.iadd(up);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":335}],334:[function(require,module,exports){
var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = require('crypto');
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}

},{"crypto":335}],335:[function(require,module,exports){

},{}],336:[function(require,module,exports){
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = require('safe-buffer').Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES

},{"safe-buffer":788}],337:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')
var GHASH = require('./ghash')
var xor = require('buffer-xor')
var incr32 = require('./incr32')

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher

},{"./aes":336,"./ghash":341,"./incr32":342,"buffer-xor":365,"cipher-base":374,"inherits":495,"safe-buffer":788}],338:[function(require,module,exports){
var ciphers = require('./encrypter')
var deciphers = require('./decrypter')
var modes = require('./modes/list.json')

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"./decrypter":339,"./encrypter":340,"./modes/list.json":350}],339:[function(require,module,exports){
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var MODES = require('./modes')
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

},{"./aes":336,"./authCipher":337,"./modes":349,"./streamCipher":352,"cipher-base":374,"evp_bytestokey":436,"inherits":495,"safe-buffer":788}],340:[function(require,module,exports){
var MODES = require('./modes')
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

},{"./aes":336,"./authCipher":337,"./modes":349,"./streamCipher":352,"cipher-base":374,"evp_bytestokey":436,"inherits":495,"safe-buffer":788}],341:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH

},{"safe-buffer":788}],342:[function(require,module,exports){
function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32

},{}],343:[function(require,module,exports){
var xor = require('buffer-xor')

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}

},{"buffer-xor":365}],344:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var xor = require('buffer-xor')

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}

},{"buffer-xor":365,"safe-buffer":788}],345:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":788}],346:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":788}],347:[function(require,module,exports){
var xor = require('buffer-xor')
var Buffer = require('safe-buffer').Buffer
var incr32 = require('../incr32')

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

},{"../incr32":342,"buffer-xor":365,"safe-buffer":788}],348:[function(require,module,exports){
exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}

},{}],349:[function(require,module,exports){
var modeModules = {
  ECB: require('./ecb'),
  CBC: require('./cbc'),
  CFB: require('./cfb'),
  CFB8: require('./cfb8'),
  CFB1: require('./cfb1'),
  OFB: require('./ofb'),
  CTR: require('./ctr'),
  GCM: require('./ctr')
}

var modes = require('./list.json')

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes

},{"./cbc":343,"./cfb":344,"./cfb1":345,"./cfb8":346,"./ctr":347,"./ecb":348,"./list.json":350,"./ofb":351}],350:[function(require,module,exports){
module.exports={
  "aes-128-ecb": {
    "cipher": "AES",
    "key": 128,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-192-ecb": {
    "cipher": "AES",
    "key": 192,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-256-ecb": {
    "cipher": "AES",
    "key": 256,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-128-cbc": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-192-cbc": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-256-cbc": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes128": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes192": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes256": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-128-cfb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-192-cfb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-256-cfb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-128-cfb8": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-192-cfb8": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-256-cfb8": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-128-cfb1": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-192-cfb1": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-256-cfb1": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-128-ofb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-192-ofb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-256-ofb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-128-ctr": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-192-ctr": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-256-ctr": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-128-gcm": {
    "cipher": "AES",
    "key": 128,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-192-gcm": {
    "cipher": "AES",
    "key": 192,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-256-gcm": {
    "cipher": "AES",
    "key": 256,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  }
}

},{}],351:[function(require,module,exports){
(function (Buffer){(function (){
var xor = require('buffer-xor')

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":364,"buffer-xor":365}],352:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher

},{"./aes":336,"cipher-base":374,"inherits":495,"safe-buffer":788}],353:[function(require,module,exports){
var DES = require('browserify-des')
var aes = require('browserify-aes/browser')
var aesModes = require('browserify-aes/modes')
var desModes = require('browserify-des/modes')
var ebtk = require('evp_bytestokey')

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"browserify-aes/browser":338,"browserify-aes/modes":349,"browserify-des":354,"browserify-des/modes":355,"evp_bytestokey":436}],354:[function(require,module,exports){
var CipherBase = require('cipher-base')
var des = require('des.js')
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}

},{"cipher-base":374,"des.js":396,"inherits":495,"safe-buffer":788}],355:[function(require,module,exports){
exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}

},{}],356:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var randomBytes = require('randombytes');
var Buffer = require('safe-buffer').Buffer;

function getr(priv) {
	var len = priv.modulus.byteLength();
	var r;
	do {
		r = new BN(randomBytes(len));
	} while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
	return r;
}

function blind(priv) {
	var r = getr(priv);
	var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
	return { blinder: blinder, unblinder: r.invm(priv.modulus) };
}

function crt(msg, priv) {
	var blinds = blind(priv);
	var len = priv.modulus.byteLength();
	var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
	var c1 = blinded.toRed(BN.mont(priv.prime1));
	var c2 = blinded.toRed(BN.mont(priv.prime2));
	var qinv = priv.coefficient;
	var p = priv.prime1;
	var q = priv.prime2;
	var m1 = c1.redPow(priv.exponent1).fromRed();
	var m2 = c2.redPow(priv.exponent2).fromRed();
	var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
	return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len);
}
crt.getr = getr;

module.exports = crt;

},{"bn.js":333,"randombytes":771,"safe-buffer":788}],357:[function(require,module,exports){
'use strict';

module.exports = require('./browser/algorithms.json');

},{"./browser/algorithms.json":358}],358:[function(require,module,exports){
module.exports={
  "sha224WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "RSA-SHA224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha256WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "RSA-SHA256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha384WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "RSA-SHA384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    "sign": "rsa",
    "hash": "sha1",
    "id": "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    "sign": "ecdsa",
    "hash": "sha1",
    "id": ""
  },
  "sha256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "DSA-SHA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-SHA1": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-WITH-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-WITH-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-WITH-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-WITH-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-RIPEMD160": {
    "sign": "dsa",
    "hash": "rmd160",
    "id": ""
  },
  "ripemd160WithRSA": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "RSA-RIPEMD160": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "md5WithRSAEncryption": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  },
  "RSA-MD5": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  }
}

},{}],359:[function(require,module,exports){
module.exports={
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
}

},{}],360:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var createHash = require('create-hash');
var stream = require('readable-stream');
var inherits = require('inherits');
var sign = require('./sign');
var verify = require('./verify');

var algorithms = require('./algorithms.json');
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex');
  algorithms[key.toLowerCase()] = algorithms[key];
});

function Sign(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hashType = data.hash;
  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Sign, stream.Writable);

Sign.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Sign.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Sign.prototype.sign = function signMethod(key, enc) {
  this.end();
  var hash = this._hash.digest();
  var sig = sign(hash, key, this._hashType, this._signType, this._tag);

  return enc ? sig.toString(enc) : sig;
};

function Verify(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Verify, stream.Writable);

Verify.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Verify.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Verify.prototype.verify = function verifyMethod(key, sig, enc) {
  var sigBuffer = typeof sig === 'string' ? Buffer.from(sig, enc) : sig;

  this.end();
  var hash = this._hash.digest();
  return verify(sigBuffer, hash, key, this._signType, this._tag);
};

function createSign(algorithm) {
  return new Sign(algorithm);
}

function createVerify(algorithm) {
  return new Verify(algorithm);
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
};

},{"./algorithms.json":358,"./sign":361,"./verify":362,"create-hash":389,"inherits":495,"readable-stream":784,"safe-buffer":788}],361:[function(require,module,exports){
'use strict';

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer;
var createHmac = require('create-hmac');
var crt = require('browserify-rsa');
var EC = require('elliptic').ec;
var BN = require('bn.js');
var parseKeys = require('parse-asn1');
var curves = require('./curves.json');

var RSA_PKCS1_PADDING = 1;

function sign(hash, key, hashType, signType, tag) {
  var priv = parseKeys(key);
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
    return ecSign(hash, priv);
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong private key type'); }
    return dsaSign(hash, priv, hashType);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
  if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) { throw new Error('illegal or unsupported padding mode'); }

  hash = Buffer.concat([tag, hash]);
  var len = priv.modulus.byteLength();
  var pad = [0, 1];
  while (hash.length + pad.length + 1 < len) { pad.push(0xff); }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) { pad.push(hash[i]); }

  var out = crt(pad, priv);
  return out;
}

function ecSign(hash, priv) {
  var curveId = curves[priv.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + priv.curve.join('.')); }

  var curve = new EC(curveId);
  var key = curve.keyFromPrivate(priv.privateKey);
  var out = key.sign(hash);

  return Buffer.from(out.toDER());
}

function dsaSign(hash, priv, algo) {
  var x = priv.params.priv_key;
  var p = priv.params.p;
  var q = priv.params.q;
  var g = priv.params.g;
  var r = new BN(0);
  var k;
  var H = bits2int(hash, q).mod(q);
  var s = false;
  var kv = getKey(x, q, hash, algo);
  while (s === false) {
    k = makeKey(q, kv, algo);
    r = makeR(g, k, p, q);
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
    if (s.cmpn(0) === 0) {
      s = false;
      r = new BN(0);
    }
  }
  return toDER(r, s);
}

function toDER(r, s) {
  r = r.toArray();
  s = s.toArray();

  // Pad values
  if (r[0] & 0x80) { r = [0].concat(r); }
  if (s[0] & 0x80) { s = [0].concat(s); }

  var total = r.length + s.length + 4;
  var res = [
    0x30, total, 0x02, r.length
  ];
  res = res.concat(r, [0x02, s.length], s);
  return Buffer.from(res);
}

function getKey(x, q, hash, algo) {
  x = Buffer.from(x.toArray());
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length);
    x = Buffer.concat([zeros, x]);
  }
  var hlen = hash.length;
  var hbits = bits2octets(hash, q);
  var v = Buffer.alloc(hlen);
  v.fill(1);
  var k = Buffer.alloc(hlen);
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  return { k: k, v: v };
}

function bits2int(obits, q) {
  var bits = new BN(obits);
  var shift = (obits.length << 3) - q.bitLength();
  if (shift > 0) { bits.ishrn(shift); }
  return bits;
}

function bits2octets(bits, q) {
  bits = bits2int(bits, q);
  bits = bits.mod(q);
  var out = Buffer.from(bits.toArray());
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length);
    out = Buffer.concat([zeros, out]);
  }
  return out;
}

function makeKey(q, kv, algo) {
  var t;
  var k;

  do {
    t = Buffer.alloc(0);

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest();
      t = Buffer.concat([t, kv.v]);
    }

    k = bits2int(t, q);
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest();
    kv.v = createHmac(algo, kv.k).update(kv.v).digest();
  } while (k.cmp(q) !== -1);

  return k;
}

function makeR(g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}

module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;

},{"./curves.json":359,"bn.js":333,"browserify-rsa":356,"create-hmac":391,"elliptic":409,"parse-asn1":536,"safe-buffer":788}],362:[function(require,module,exports){
'use strict';

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer;
var BN = require('bn.js');
var EC = require('elliptic').ec;
var parseKeys = require('parse-asn1');
var curves = require('./curves.json');

function verify(sig, hash, key, signType, tag) {
  var pub = parseKeys(key);
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }
    return ecVerify(sig, hash, pub);
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong public key type'); }
    return dsaVerify(sig, hash, pub);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }

  hash = Buffer.concat([tag, hash]);
  var len = pub.modulus.byteLength();
  var pad = [1];
  var padNum = 0;
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff);
    padNum += 1;
  }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) {
    pad.push(hash[i]);
  }
  pad = Buffer.from(pad);
  var red = BN.mont(pub.modulus);
  sig = new BN(sig).toRed(red);

  sig = sig.redPow(new BN(pub.publicExponent));
  sig = Buffer.from(sig.fromRed().toArray());
  var out = padNum < 8 ? 1 : 0;
  len = Math.min(sig.length, pad.length);
  if (sig.length !== pad.length) { out = 1; }

  i = -1;
  while (++i < len) { out |= sig[i] ^ pad[i]; }
  return out === 0;
}

function ecVerify(sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.')); }

  var curve = new EC(curveId);
  var pubkey = pub.data.subjectPrivateKey.data;

  return curve.verify(hash, sig, pubkey);
}

function dsaVerify(sig, hash, pub) {
  var p = pub.data.p;
  var q = pub.data.q;
  var g = pub.data.g;
  var y = pub.data.pub_key;
  var unpacked = parseKeys.signature.decode(sig, 'der');
  var s = unpacked.s;
  var r = unpacked.r;
  checkValue(s, q);
  checkValue(r, q);
  var montp = BN.mont(p);
  var w = s.invm(q);
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q);
  return v.cmp(r) === 0;
}

function checkValue(b, q) {
  if (b.cmpn(0) <= 0) { throw new Error('invalid sig'); }
  if (b.cmp(q) >= 0) { throw new Error('invalid sig'); }
}

module.exports = verify;

},{"./curves.json":359,"bn.js":333,"elliptic":409,"parse-asn1":536,"safe-buffer":788}],363:[function(require,module,exports){
arguments[4][335][0].apply(exports,arguments)
},{"dup":335}],364:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"base64-js":332,"buffer":364,"ieee754":494}],365:[function(require,module,exports){
(function (Buffer){(function (){
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":364}],366:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);

},{"./functionApply":368,"./functionCall":369,"./reflectApply":371,"function-bind":441}],367:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $apply = require('./functionApply');
var actualApply = require('./actualApply');

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};

},{"./actualApply":366,"./functionApply":368,"function-bind":441}],368:[function(require,module,exports){
'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;

},{}],369:[function(require,module,exports){
'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;

},{}],370:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $TypeError = require('es-errors/type');

var $call = require('./functionCall');
var $actualApply = require('./actualApply');

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};

},{"./actualApply":366,"./functionCall":369,"es-errors/type":432,"function-bind":441}],371:[function(require,module,exports){
'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],372:[function(require,module,exports){
'use strict';

var setFunctionLength = require('set-function-length');

var $defineProperty = require('es-define-property');

var callBindBasic = require('call-bind-apply-helpers');
var applyBind = require('call-bind-apply-helpers/applyBind');

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		adjustedLength > 0 ? adjustedLength : 0,
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"call-bind-apply-helpers":370,"call-bind-apply-helpers/applyBind":367,"es-define-property":426,"set-function-length":790}],373:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBindBasic = require('call-bind-apply-helpers');

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};

},{"call-bind-apply-helpers":370,"get-intrinsic":443}],374:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var Transform = require('stream').Transform;
var StringDecoder = require('string_decoder').StringDecoder;
var inherits = require('inherits');
var toBuffer = require('to-buffer');

function CipherBase(hashMode) {
	Transform.call(this);
	this.hashMode = typeof hashMode === 'string';
	if (this.hashMode) {
		this[hashMode] = this._finalOrDigest;
	} else {
		this['final'] = this._finalOrDigest;
	}
	if (this._final) {
		this.__final = this._final;
		this._final = null;
	}
	this._decoder = null;
	this._encoding = null;
}
inherits(CipherBase, Transform);

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	var bufferData = toBuffer(data, inputEnc); // asserts correct input type
	var outData = this._update(bufferData);
	if (this.hashMode) {
		return this;
	}

	if (outputEnc) {
		outData = this._toString(outData, outputEnc);
	}

	return outData;
};

CipherBase.prototype.setAutoPadding = function () {};
CipherBase.prototype.getAuthTag = function () {
	throw new Error('trying to get auth tag in unsupported state');
};

CipherBase.prototype.setAuthTag = function () {
	throw new Error('trying to set auth tag in unsupported state');
};

CipherBase.prototype.setAAD = function () {
	throw new Error('trying to set aad in unsupported state');
};

CipherBase.prototype._transform = function (data, _, next) {
	var err;
	try {
		if (this.hashMode) {
			this._update(data);
		} else {
			this.push(this._update(data));
		}
	} catch (e) {
		err = e;
	} finally {
		next(err);
	}
};
CipherBase.prototype._flush = function (done) {
	var err;
	try {
		this.push(this.__final());
	} catch (e) {
		err = e;
	}

	done(err);
};
CipherBase.prototype._finalOrDigest = function (outputEnc) {
	var outData = this.__final() || Buffer.alloc(0);
	if (outputEnc) {
		outData = this._toString(outData, outputEnc, true);
	}
	return outData;
};

CipherBase.prototype._toString = function (value, enc, fin) {
	if (!this._decoder) {
		this._decoder = new StringDecoder(enc);
		this._encoding = enc;
	}

	if (this._encoding !== enc) {
		throw new Error('can’t switch encodings');
	}

	var out = this._decoder.write(value);
	if (fin) {
		out += this._decoder.end();
	}

	return out;
};

module.exports = CipherBase;

},{"inherits":495,"safe-buffer":788,"stream":799,"string_decoder":814,"to-buffer":816}],375:[function(require,module,exports){
/*

The MIT License (MIT)

Original Library
  - Copyright (c) Marak Squires

Additional functionality
 - Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var colors = {};
module['exports'] = colors;

colors.themes = {};

var util = require('util');
var ansiStyles = colors.styles = require('./styles');
var defineProps = Object.defineProperties;
var newLineRegex = new RegExp(/[\r\n]+/g);

colors.supportsColor = require('./system/supports-colors').supportsColor;

if (typeof colors.enabled === 'undefined') {
  colors.enabled = colors.supportsColor() !== false;
}

colors.enable = function() {
  colors.enabled = true;
};

colors.disable = function() {
  colors.enabled = false;
};

colors.stripColors = colors.strip = function(str) {
  return ('' + str).replace(/\x1B\[\d+m/g, '');
};

// eslint-disable-next-line no-unused-vars
var stylize = colors.stylize = function stylize(str, style) {
  if (!colors.enabled) {
    return str+'';
  }

  var styleMap = ansiStyles[style];

  // Stylize should work for non-ANSI styles, too
  if(!styleMap && style in colors){
    // Style maps like trap operate as functions on strings;
    // they don't have properties like open or close.
    return colors[style](str);
  }

  return styleMap.open + str + styleMap.close;
};

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
var escapeStringRegexp = function(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }
  return str.replace(matchOperatorsRe, '\\$&');
};

function build(_styles) {
  var builder = function builder() {
    return applyStyle.apply(builder, arguments);
  };
  builder._styles = _styles;
  // __proto__ is used because we must return a function, but there is
  // no way to create a function with a different prototype.
  builder.__proto__ = proto;
  return builder;
}

var styles = (function() {
  var ret = {};
  ansiStyles.grey = ansiStyles.gray;
  Object.keys(ansiStyles).forEach(function(key) {
    ansiStyles[key].closeRe =
      new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
    ret[key] = {
      get: function() {
        return build(this._styles.concat(key));
      },
    };
  });
  return ret;
})();

var proto = defineProps(function colors() {}, styles);

function applyStyle() {
  var args = Array.prototype.slice.call(arguments);

  var str = args.map(function(arg) {
    // Use weak equality check so we can colorize null/undefined in safe mode
    if (arg != null && arg.constructor === String) {
      return arg;
    } else {
      return util.inspect(arg);
    }
  }).join(' ');

  if (!colors.enabled || !str) {
    return str;
  }

  var newLinesPresent = str.indexOf('\n') != -1;

  var nestedStyles = this._styles;

  var i = nestedStyles.length;
  while (i--) {
    var code = ansiStyles[nestedStyles[i]];
    str = code.open + str.replace(code.closeRe, code.open) + code.close;
    if (newLinesPresent) {
      str = str.replace(newLineRegex, function(match) {
        return code.close + match + code.open;
      });
    }
  }

  return str;
}

colors.setTheme = function(theme) {
  if (typeof theme === 'string') {
    console.log('colors.setTheme now only accepts an object, not a string.  ' +
      'If you are trying to set a theme from a file, it is now your (the ' +
      'caller\'s) responsibility to require the file.  The old syntax ' +
      'looked like colors.setTheme(__dirname + ' +
      '\'/../themes/generic-logging.js\'); The new syntax looks like '+
      'colors.setTheme(require(__dirname + ' +
      '\'/../themes/generic-logging.js\'));');
    return;
  }
  for (var style in theme) {
    (function(style) {
      colors[style] = function(str) {
        if (typeof theme[style] === 'object') {
          var out = str;
          for (var i in theme[style]) {
            out = colors[theme[style][i]](out);
          }
          return out;
        }
        return colors[theme[style]](str);
      };
    })(style);
  }
};

function init() {
  var ret = {};
  Object.keys(styles).forEach(function(name) {
    ret[name] = {
      get: function() {
        return build([name]);
      },
    };
  });
  return ret;
}

var sequencer = function sequencer(map, str) {
  var exploded = str.split('');
  exploded = exploded.map(map);
  return exploded.join('');
};

// custom formatter methods
colors.trap = require('./custom/trap');
colors.zalgo = require('./custom/zalgo');

// maps
colors.maps = {};
colors.maps.america = require('./maps/america')(colors);
colors.maps.zebra = require('./maps/zebra')(colors);
colors.maps.rainbow = require('./maps/rainbow')(colors);
colors.maps.random = require('./maps/random')(colors);

for (var map in colors.maps) {
  (function(map) {
    colors[map] = function(str) {
      return sequencer(colors.maps[map], str);
    };
  })(map);
}

defineProps(colors, init());

},{"./custom/trap":376,"./custom/zalgo":377,"./maps/america":378,"./maps/rainbow":379,"./maps/random":380,"./maps/zebra":381,"./styles":382,"./system/supports-colors":384,"util":821}],376:[function(require,module,exports){
module['exports'] = function runTheTrap(text, options) {
  var result = '';
  text = text || 'Run the trap, drop the bass';
  text = text.split('');
  var trap = {
    a: ['\u0040', '\u0104', '\u023a', '\u0245', '\u0394', '\u039b', '\u0414'],
    b: ['\u00df', '\u0181', '\u0243', '\u026e', '\u03b2', '\u0e3f'],
    c: ['\u00a9', '\u023b', '\u03fe'],
    d: ['\u00d0', '\u018a', '\u0500', '\u0501', '\u0502', '\u0503'],
    e: ['\u00cb', '\u0115', '\u018e', '\u0258', '\u03a3', '\u03be', '\u04bc',
      '\u0a6c'],
    f: ['\u04fa'],
    g: ['\u0262'],
    h: ['\u0126', '\u0195', '\u04a2', '\u04ba', '\u04c7', '\u050a'],
    i: ['\u0f0f'],
    j: ['\u0134'],
    k: ['\u0138', '\u04a0', '\u04c3', '\u051e'],
    l: ['\u0139'],
    m: ['\u028d', '\u04cd', '\u04ce', '\u0520', '\u0521', '\u0d69'],
    n: ['\u00d1', '\u014b', '\u019d', '\u0376', '\u03a0', '\u048a'],
    o: ['\u00d8', '\u00f5', '\u00f8', '\u01fe', '\u0298', '\u047a', '\u05dd',
      '\u06dd', '\u0e4f'],
    p: ['\u01f7', '\u048e'],
    q: ['\u09cd'],
    r: ['\u00ae', '\u01a6', '\u0210', '\u024c', '\u0280', '\u042f'],
    s: ['\u00a7', '\u03de', '\u03df', '\u03e8'],
    t: ['\u0141', '\u0166', '\u0373'],
    u: ['\u01b1', '\u054d'],
    v: ['\u05d8'],
    w: ['\u0428', '\u0460', '\u047c', '\u0d70'],
    x: ['\u04b2', '\u04fe', '\u04fc', '\u04fd'],
    y: ['\u00a5', '\u04b0', '\u04cb'],
    z: ['\u01b5', '\u0240'],
  };
  text.forEach(function(c) {
    c = c.toLowerCase();
    var chars = trap[c] || [' '];
    var rand = Math.floor(Math.random() * chars.length);
    if (typeof trap[c] !== 'undefined') {
      result += trap[c][rand];
    } else {
      result += c;
    }
  });
  return result;
};

},{}],377:[function(require,module,exports){
// please no
module['exports'] = function zalgo(text, options) {
  text = text || '   he is here   ';
  var soul = {
    'up': [
      '̍', '̎', '̄', '̅',
      '̿', '̑', '̆', '̐',
      '͒', '͗', '͑', '̇',
      '̈', '̊', '͂', '̓',
      '̈', '͊', '͋', '͌',
      '̃', '̂', '̌', '͐',
      '̀', '́', '̋', '̏',
      '̒', '̓', '̔', '̽',
      '̉', 'ͣ', 'ͤ', 'ͥ',
      'ͦ', 'ͧ', 'ͨ', 'ͩ',
      'ͪ', 'ͫ', 'ͬ', 'ͭ',
      'ͮ', 'ͯ', '̾', '͛',
      '͆', '̚',
    ],
    'down': [
      '̖', '̗', '̘', '̙',
      '̜', '̝', '̞', '̟',
      '̠', '̤', '̥', '̦',
      '̩', '̪', '̫', '̬',
      '̭', '̮', '̯', '̰',
      '̱', '̲', '̳', '̹',
      '̺', '̻', '̼', 'ͅ',
      '͇', '͈', '͉', '͍',
      '͎', '͓', '͔', '͕',
      '͖', '͙', '͚', '̣',
    ],
    'mid': [
      '̕', '̛', '̀', '́',
      '͘', '̡', '̢', '̧',
      '̨', '̴', '̵', '̶',
      '͜', '͝', '͞',
      '͟', '͠', '͢', '̸',
      '̷', '͡', ' ҉',
    ],
  };
  var all = [].concat(soul.up, soul.down, soul.mid);

  function randomNumber(range) {
    var r = Math.floor(Math.random() * range);
    return r;
  }

  function isChar(character) {
    var bool = false;
    all.filter(function(i) {
      bool = (i === character);
    });
    return bool;
  }


  function heComes(text, options) {
    var result = '';
    var counts;
    var l;
    options = options || {};
    options['up'] =
      typeof options['up'] !== 'undefined' ? options['up'] : true;
    options['mid'] =
      typeof options['mid'] !== 'undefined' ? options['mid'] : true;
    options['down'] =
      typeof options['down'] !== 'undefined' ? options['down'] : true;
    options['size'] =
      typeof options['size'] !== 'undefined' ? options['size'] : 'maxi';
    text = text.split('');
    for (l in text) {
      if (isChar(l)) {
        continue;
      }
      result = result + text[l];
      counts = {'up': 0, 'down': 0, 'mid': 0};
      switch (options.size) {
        case 'mini':
          counts.up = randomNumber(8);
          counts.mid = randomNumber(2);
          counts.down = randomNumber(8);
          break;
        case 'maxi':
          counts.up = randomNumber(16) + 3;
          counts.mid = randomNumber(4) + 1;
          counts.down = randomNumber(64) + 3;
          break;
        default:
          counts.up = randomNumber(8) + 1;
          counts.mid = randomNumber(6) / 2;
          counts.down = randomNumber(8) + 1;
          break;
      }

      var arr = ['up', 'mid', 'down'];
      for (var d in arr) {
        var index = arr[d];
        for (var i = 0; i <= counts[index]; i++) {
          if (options[index]) {
            result = result + soul[index][randomNumber(soul[index].length)];
          }
        }
      }
    }
    return result;
  }
  // don't summon him
  return heComes(text, options);
};


},{}],378:[function(require,module,exports){
module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    if (letter === ' ') return letter;
    switch (i%3) {
      case 0: return colors.red(letter);
      case 1: return colors.white(letter);
      case 2: return colors.blue(letter);
    }
  };
};

},{}],379:[function(require,module,exports){
module['exports'] = function(colors) {
  // RoY G BiV
  var rainbowColors = ['red', 'yellow', 'green', 'blue', 'magenta'];
  return function(letter, i, exploded) {
    if (letter === ' ') {
      return letter;
    } else {
      return colors[rainbowColors[i++ % rainbowColors.length]](letter);
    }
  };
};


},{}],380:[function(require,module,exports){
module['exports'] = function(colors) {
  var available = ['underline', 'inverse', 'grey', 'yellow', 'red', 'green',
    'blue', 'white', 'cyan', 'magenta', 'brightYellow', 'brightRed',
    'brightGreen', 'brightBlue', 'brightWhite', 'brightCyan', 'brightMagenta'];
  return function(letter, i, exploded) {
    return letter === ' ' ? letter :
      colors[
          available[Math.round(Math.random() * (available.length - 2))]
      ](letter);
  };
};

},{}],381:[function(require,module,exports){
module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    return i % 2 === 0 ? letter : colors.inverse(letter);
  };
};

},{}],382:[function(require,module,exports){
/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

var styles = {};
module['exports'] = styles;

var codes = {
  reset: [0, 0],

  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],

  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  grey: [90, 39],

  brightRed: [91, 39],
  brightGreen: [92, 39],
  brightYellow: [93, 39],
  brightBlue: [94, 39],
  brightMagenta: [95, 39],
  brightCyan: [96, 39],
  brightWhite: [97, 39],

  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgGray: [100, 49],
  bgGrey: [100, 49],

  bgBrightRed: [101, 49],
  bgBrightGreen: [102, 49],
  bgBrightYellow: [103, 49],
  bgBrightBlue: [104, 49],
  bgBrightMagenta: [105, 49],
  bgBrightCyan: [106, 49],
  bgBrightWhite: [107, 49],

  // legacy styles for colors pre v1.0.0
  blackBG: [40, 49],
  redBG: [41, 49],
  greenBG: [42, 49],
  yellowBG: [43, 49],
  blueBG: [44, 49],
  magentaBG: [45, 49],
  cyanBG: [46, 49],
  whiteBG: [47, 49],

};

Object.keys(codes).forEach(function(key) {
  var val = codes[key];
  var style = styles[key] = [];
  style.open = '\u001b[' + val[0] + 'm';
  style.close = '\u001b[' + val[1] + 'm';
});

},{}],383:[function(require,module,exports){
(function (process){(function (){
/*
MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

'use strict';

module.exports = function(flag, argv) {
  argv = argv || process.argv;

  var terminatorPos = argv.indexOf('--');
  var prefix = /^-{1,2}/.test(flag) ? '' : '--';
  var pos = argv.indexOf(prefix + flag);

  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

}).call(this)}).call(this,require('_process'))

},{"_process":736}],384:[function(require,module,exports){
(function (process){(function (){
/*
The MIT License (MIT)

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

'use strict';

var os = require('os');
var hasFlag = require('./has-flag.js');

var env = process.env;

var forceColor = void 0;
if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false')) {
  forceColor = false;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true')
           || hasFlag('color=always')) {
  forceColor = true;
}
if ('FORCE_COLOR' in env) {
  forceColor = env.FORCE_COLOR.length === 0
    || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3,
  };
}

function supportsColor(stream) {
  if (forceColor === false) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full')
      || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor !== true) {
    return 0;
  }

  var min = forceColor ? 1 : 0;

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first
    // Windows release that supports 256 colors. Windows 10 build 14931 is the
    // first release that supports 16m/TrueColor.
    var osRelease = os.release().split('.');
    if (Number(process.versions.node.split('.')[0]) >= 8
        && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function(sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return (/^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0
    );
  }

  if ('TERM_PROGRAM' in env) {
    var version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return version >= 3 ? 3 : 2;
      case 'Hyper':
        return 3;
      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  if (env.TERM === 'dumb') {
    return min;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

module.exports = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr),
};

}).call(this)}).call(this,require('_process'))

},{"./has-flag.js":383,"_process":736,"os":531}],385:[function(require,module,exports){
//
// Remark: Requiring this file will use the "safe" colors API,
// which will not touch String.prototype.
//
//   var colors = require('colors/safe');
//   colors.red("foo")
//
//
var colors = require('./lib/colors');
module['exports'] = colors;

},{"./lib/colors":375}],386:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('buffer').Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

},{"buffer":364}],387:[function(require,module,exports){
(function (Buffer){(function (){
var elliptic = require('elliptic')
var BN = require('bn.js')

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"bn.js":388,"buffer":364,"elliptic":409}],388:[function(require,module,exports){
arguments[4][325][0].apply(exports,arguments)
},{"buffer":335,"dup":325}],389:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var MD5 = require('md5.js')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Base = require('cipher-base')

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}

},{"cipher-base":374,"inherits":495,"md5.js":515,"ripemd160":785,"sha.js":792}],390:[function(require,module,exports){
var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}

},{"md5.js":515}],391:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Legacy = require('./legacy')
var Base = require('cipher-base')
var Buffer = require('safe-buffer').Buffer
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')

var sha = require('sha.js')

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}

},{"./legacy":392,"cipher-base":374,"create-hash/md5":390,"inherits":495,"ripemd160":785,"safe-buffer":788,"sha.js":792}],392:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var Base = require('cipher-base')

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac

},{"cipher-base":374,"inherits":495,"safe-buffer":788}],393:[function(require,module,exports){
'use strict';

// eslint-disable-next-line no-multi-assign
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require('randombytes');

// eslint-disable-next-line no-multi-assign
exports.createHash = exports.Hash = require('create-hash');

// eslint-disable-next-line no-multi-assign
exports.createHmac = exports.Hmac = require('create-hmac');

var algos = require('browserify-sign/algos');
var algoKeys = Object.keys(algos);
var hashes = [
	'sha1',
	'sha224',
	'sha256',
	'sha384',
	'sha512',
	'md5',
	'rmd160'
].concat(algoKeys);

exports.getHashes = function () {
	return hashes;
};

var p = require('pbkdf2');
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;

var aes = require('browserify-cipher');

exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;

var dh = require('diffie-hellman');

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;

var sign = require('browserify-sign');

exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;

exports.createECDH = require('create-ecdh');

var publicEncrypt = require('public-encrypt');

exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;

// the least I can do is make error messages for the rest of the node.js/crypto api.
// [
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error('sorry, ' + name + ' is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
//   };
// });

var rf = require('randomfill');

exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;

exports.createCredentials = function () {
	throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};

exports.constants = {
	DH_CHECK_P_NOT_SAFE_PRIME: 2,
	DH_CHECK_P_NOT_PRIME: 1,
	DH_UNABLE_TO_CHECK_GENERATOR: 4,
	DH_NOT_SUITABLE_GENERATOR: 8,
	NPN_ENABLED: 1,
	ALPN_ENABLED: 1,
	RSA_PKCS1_PADDING: 1,
	RSA_SSLV23_PADDING: 2,
	RSA_NO_PADDING: 3,
	RSA_PKCS1_OAEP_PADDING: 4,
	RSA_X931_PADDING: 5,
	RSA_PKCS1_PSS_PADDING: 6,
	POINT_CONVERSION_COMPRESSED: 2,
	POINT_CONVERSION_UNCOMPRESSED: 4,
	POINT_CONVERSION_HYBRID: 6
};

},{"browserify-cipher":353,"browserify-sign":360,"browserify-sign/algos":357,"create-ecdh":387,"create-hash":389,"create-hmac":391,"diffie-hellman":402,"pbkdf2":538,"public-encrypt":737,"randombytes":771,"randomfill":772}],394:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_customParseFormat=t()}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d/,r=/\d\d/,i=/\d\d?/,o=/\d*[^-_:/,()\s\d]+/,s={},a=function(e){return(e=+e)+(e>68?1900:2e3)};var f=function(e){return function(t){this[e]=+t}},h=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],u=function(e){var t=s[e];return t&&(t.indexOf?t:t.s.concat(t.f))},d=function(e,t){var n,r=s.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},c={A:[o,function(e){this.afternoon=d(e,!1)}],a:[o,function(e){this.afternoon=d(e,!0)}],Q:[n,function(e){this.month=3*(e-1)+1}],S:[n,function(e){this.milliseconds=100*+e}],SS:[r,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[i,f("seconds")],ss:[i,f("seconds")],m:[i,f("minutes")],mm:[i,f("minutes")],H:[i,f("hours")],h:[i,f("hours")],HH:[i,f("hours")],hh:[i,f("hours")],D:[i,f("day")],DD:[r,f("day")],Do:[o,function(e){var t=s.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],w:[i,f("week")],ww:[r,f("week")],M:[i,f("month")],MM:[r,f("month")],MMM:[o,function(e){var t=u("months"),n=(u("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[o,function(e){var t=u("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,f("year")],YY:[r,function(e){this.year=a(e)}],YYYY:[/\d{4}/,f("year")],Z:h,ZZ:h};function l(n){var r,i;r=n,i=s&&s.formats;for(var o=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=o.length,f=0;f<a;f+=1){var h=o[f],u=c[h],d=u&&u[0],l=u&&u[1];o[f]=l?{regex:d,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=o[n];if("string"==typeof i)r+=i.length;else{var s=i.regex,f=i.parser,h=e.slice(r),u=s.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(a=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,o=e.args;this.$u=r;var a=o[1];if("string"==typeof a){var f=!0===o[2],h=!0===o[3],u=f||h,d=o[2];h&&(d=o[2]),s=this.$locale(),!f&&d&&(s=n.Ls[d]),this.$d=function(e,t,n,r){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var i=l(t)(e),o=i.year,s=i.month,a=i.day,f=i.hours,h=i.minutes,u=i.seconds,d=i.milliseconds,c=i.zone,m=i.week,M=new Date,Y=a||(o||s?1:M.getDate()),p=o||M.getFullYear(),v=0;o&&!s||(v=s>0?s-1:M.getMonth());var D,w=f||0,g=h||0,y=u||0,L=d||0;return c?new Date(Date.UTC(p,v,Y,w,g,y,L+60*c.offset*1e3)):n?new Date(Date.UTC(p,v,Y,w,g,y,L)):(D=new Date(p,v,Y,w,g,y,L),m&&(D=r(D).week(m).toDate()),D)}catch(e){return new Date("")}}(t,a,r,n),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),s={}}else if(a instanceof Array)for(var c=a.length,m=1;m<=c;m+=1){o[1]=a[m-1];var M=n.apply(this,o);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===c&&(this.$d=new Date(""))}else i.call(this,e)}}}));
},{}],395:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');

var gopd = require('gopd');

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

},{"es-define-property":426,"es-errors/syntax":431,"es-errors/type":432,"gopd":448}],396:[function(require,module,exports){
'use strict';

exports.utils = require('./des/utils');
exports.Cipher = require('./des/cipher');
exports.DES = require('./des/des');
exports.CBC = require('./des/cbc');
exports.EDE = require('./des/ede');

},{"./des/cbc":397,"./des/cipher":398,"./des/des":399,"./des/ede":400,"./des/utils":401}],397:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};

},{"inherits":495,"minimalistic-assert":524}],398:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
  this.padding = options.padding !== false
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};

},{"minimalistic-assert":524}],399:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var utils = require('./utils');
var Cipher = require('./cipher');

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  if (this.padding === false) {
    return false;
  }

  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  if (this.padding === false) {
    return buffer;
  }

  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};

},{"./cipher":398,"./utils":401,"inherits":495,"minimalistic-assert":524}],400:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var Cipher = require('./cipher');
var DES = require('./des');

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"./cipher":398,"./des":399,"inherits":495,"minimalistic-assert":524}],401:[function(require,module,exports){
'use strict';

exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};

},{}],402:[function(require,module,exports){
(function (Buffer){(function (){
var generatePrime = require('./lib/generatePrime')
var primes = require('./lib/primes.json')

var DH = require('./lib/dh')

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

}).call(this)}).call(this,require("buffer").Buffer)

},{"./lib/dh":403,"./lib/generatePrime":404,"./lib/primes.json":405,"buffer":364}],403:[function(require,module,exports){
(function (Buffer){(function (){
var BN = require('bn.js');
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require('./generatePrime');
var randomBytes = require('randombytes');
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"./generatePrime":404,"bn.js":406,"buffer":364,"miller-rabin":522,"randombytes":771}],404:[function(require,module,exports){
var randomBytes = require('randombytes');
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require('bn.js');
var TWENTYFOUR = new BN(24);
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}

},{"bn.js":406,"miller-rabin":522,"randombytes":771}],405:[function(require,module,exports){
module.exports={
    "modp1": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
    },
    "modp2": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
    },
    "modp5": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
    },
    "modp14": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
    },
    "modp15": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
    },
    "modp16": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
    },
    "modp17": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
    },
    "modp18": {
        "gen": "02",
        "prime": "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"
    }
}
},{}],406:[function(require,module,exports){
arguments[4][325][0].apply(exports,arguments)
},{"buffer":335,"dup":325}],407:[function(require,module,exports){
'use strict';

/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (typeof module !== 'undefined') {
  module.exports = dijkstra;
}

},{}],408:[function(require,module,exports){
'use strict';

var callBind = require('call-bind-apply-helpers');
var gOPD = require('gopd');

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;

},{"call-bind-apply-helpers":370,"gopd":448}],409:[function(require,module,exports){
'use strict';

var elliptic = exports;

elliptic.version = require('../package.json').version;
elliptic.utils = require('./elliptic/utils');
elliptic.rand = require('brorand');
elliptic.curve = require('./elliptic/curve');
elliptic.curves = require('./elliptic/curves');

// Protocols
elliptic.ec = require('./elliptic/ec');
elliptic.eddsa = require('./elliptic/eddsa');

},{"../package.json":425,"./elliptic/curve":412,"./elliptic/curves":415,"./elliptic/ec":416,"./elliptic/eddsa":419,"./elliptic/utils":423,"brorand":334}],410:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

},{"../utils":423,"bn.js":424}],411:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"../utils":423,"./base":410,"bn.js":424,"inherits":495}],412:[function(require,module,exports){
'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');

},{"./base":410,"./edwards":411,"./mont":413,"./short":414}],413:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var utils = require('../utils');

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};

},{"../utils":423,"./base":410,"bn.js":424,"inherits":495}],414:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

},{"../utils":423,"./base":410,"bn.js":424,"inherits":495}],415:[function(require,module,exports){
'use strict';

var curves = exports;

var hash = require('hash.js');
var curve = require('./curve');
var utils = require('./utils');

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = require('./precomputed/secp256k1');
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});

},{"./curve":412,"./precomputed/secp256k1":422,"./utils":423,"hash.js":454}],416:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var HmacDRBG = require('hmac-drbg');
var utils = require('../utils');
var curves = require('../curves');
var rand = require('brorand');
var assert = utils.assert;

var KeyPair = require('./key');
var Signature = require('./signature');

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
  var byteLength;
  if (BN.isBN(msg) || typeof msg === 'number') {
    msg = new BN(msg, 16);
    byteLength = msg.byteLength();
  } else if (typeof msg === 'object') {
    // BN assumes an array-like input and asserts length
    byteLength = msg.length;
    msg = new BN(msg, 16);
  } else {
    // BN converts the value to string
    var str = msg.toString();
    // HEX encoding
    byteLength = (str.length + 1) >>> 1;
    msg = new BN(str, 16);
  }
  // Allow overriding
  if (typeof bitLength !== 'number') {
    bitLength = byteLength * 8;
  }
  var delta = bitLength - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
    assert(typeof msg === 'object' && msg && typeof msg.length === 'number',
      'Expected message to be an array-like, a hex string, or a BN instance');
    assert((msg.length >>> 0) === msg.length); // non-negative 32-bit integer
    for (var i = 0; i < msg.length; i++) assert((msg[i] & 255) === msg[i]);
  }

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(msg, false, options.msgBitLength);

  // Would fail further checks, but let's make the error message clear
  assert(!msg.isNeg(), 'Can not sign a negative message');

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Recheck nonce to be bijective to msg
  assert((new BN(nonce)).eq(msg), 'Can not sign message');

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc, options) {
  if (!options)
    options = {};

  msg = this._truncateToN(msg, false, options.msgBitLength);
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

},{"../curves":415,"../utils":423,"./key":417,"./signature":418,"bn.js":424,"brorand":334,"hmac-drbg":469}],417:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature, options) {
  return this.ec.verify(msg, signature, this, undefined, options);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

},{"../utils":423,"bn.js":424}],418:[function(require,module,exports){
'use strict';

var BN = require('bn.js');

var utils = require('../utils');
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  if(buf[p.place] === 0x00) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};

},{"../utils":423,"bn.js":424}],419:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var curves = require('../curves');
var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require('./key');
var Signature = require('./signature');

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) {
    return false;
  }
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};

},{"../curves":415,"../utils":423,"./key":420,"./signature":421,"hash.js":454}],420:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;

},{"../utils":423}],421:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;

},{"../utils":423,"bn.js":424}],422:[function(require,module,exports){
module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};

},{}],423:[function(require,module,exports){
'use strict';

var utils = exports;
var BN = require('bn.js');
var minAssert = require('minimalistic-assert');
var minUtils = require('minimalistic-crypto-utils');

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  var i;
  for (i = 0; i < naf.length; i += 1) {
    naf[i] = 0;
  }

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;


},{"bn.js":424,"minimalistic-assert":524,"minimalistic-crypto-utils":525}],424:[function(require,module,exports){
arguments[4][325][0].apply(exports,arguments)
},{"buffer":335,"dup":325}],425:[function(require,module,exports){
module.exports={
  "name": "elliptic",
  "version": "6.6.1",
  "description": "EC cryptography",
  "main": "lib/elliptic.js",
  "files": [
    "lib"
  ],
  "scripts": {
    "lint": "eslint lib test",
    "lint:fix": "npm run lint -- --fix",
    "unit": "istanbul test _mocha --reporter=spec test/index.js",
    "test": "npm run lint && npm run unit",
    "version": "grunt dist && git add dist/"
  },
  "repository": {
    "type": "git",
    "url": "git@github.com:indutny/elliptic"
  },
  "keywords": [
    "EC",
    "Elliptic",
    "curve",
    "Cryptography"
  ],
  "author": "Fedor Indutny <fedor@indutny.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/indutny/elliptic/issues"
  },
  "homepage": "https://github.com/indutny/elliptic",
  "devDependencies": {
    "brfs": "^2.0.2",
    "coveralls": "^3.1.0",
    "eslint": "^7.6.0",
    "grunt": "^1.2.1",
    "grunt-browserify": "^5.3.0",
    "grunt-cli": "^1.3.2",
    "grunt-contrib-connect": "^3.0.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-uglify": "^5.0.0",
    "grunt-mocha-istanbul": "^5.0.2",
    "grunt-saucelabs": "^9.0.1",
    "istanbul": "^0.4.5",
    "mocha": "^8.0.1"
  },
  "dependencies": {
    "bn.js": "^4.11.9",
    "brorand": "^1.1.0",
    "hash.js": "^1.0.0",
    "hmac-drbg": "^1.0.1",
    "inherits": "^2.0.4",
    "minimalistic-assert": "^1.0.1",
    "minimalistic-crypto-utils": "^1.0.1"
  }
}

},{}],426:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{}],427:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],428:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],429:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],430:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],431:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],432:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],433:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],434:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Object;

},{}],435:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

},{}],436:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var MD5 = require('md5.js')

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey

},{"md5.js":515,"safe-buffer":788}],437:[function(require,module,exports){
module.exports={
    "name": "fable-serviceproviderbase",
    "version": "3.0.19",
    "description": "Simple base classes for fable services.",
    "main": "source/Fable-ServiceProviderBase.js",
    "scripts": {
        "start": "node source/Fable-ServiceProviderBase.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p . --noEmit"
    },
    "types": "types/source/Fable-ServiceProviderBase.d.ts",
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase.git"
    },
    "keywords": [
        "entity",
        "behavior"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
    "devDependencies": {
        "@types/mocha": "^10.0.10",
        "fable": "^3.1.62",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    }
}

},{}],438:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":437}],439:[function(require,module,exports){
'use strict';

var isCallable = require('is-callable');

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */
var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */
var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */
var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

/** @type {(x: unknown) => x is readonly unknown[]} */
function isArray(x) {
    return toStr.call(x) === '[object Array]';
}

/** @type {import('.')._internal} */
module.exports = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (isArray(list)) {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

},{"is-callable":497}],440:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],441:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":440}],442:[function(require,module,exports){
'use strict';

/** @type {GeneratorFunctionConstructor | false} */
var cached;

/** @type {import('./index.js')} */
module.exports = function getGeneratorFunction() {
	if (typeof cached === 'undefined') {
		try {
			// eslint-disable-next-line no-new-func
			cached = Function('return function* () {}')().constructor;
		} catch (e) {
			cached = false;
		}
	}
	return cached;
};


},{}],443:[function(require,module,exports){
'use strict';

var undefined;

var $Object = require('es-object-atoms');

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var abs = require('math-intrinsics/abs');
var floor = require('math-intrinsics/floor');
var max = require('math-intrinsics/max');
var min = require('math-intrinsics/min');
var pow = require('math-intrinsics/pow');
var round = require('math-intrinsics/round');
var sign = require('math-intrinsics/sign');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = require('gopd');
var $defineProperty = require('es-define-property');

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = require('get-proto');
var $ObjectGPO = require('get-proto/Object.getPrototypeOf');
var $ReflectGPO = require('get-proto/Reflect.getPrototypeOf');

var $apply = require('call-bind-apply-helpers/functionApply');
var $call = require('call-bind-apply-helpers/functionCall');

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"call-bind-apply-helpers/functionApply":368,"call-bind-apply-helpers/functionCall":369,"es-define-property":426,"es-errors":428,"es-errors/eval":427,"es-errors/range":429,"es-errors/ref":430,"es-errors/syntax":431,"es-errors/type":432,"es-errors/uri":433,"es-object-atoms":434,"function-bind":441,"get-proto":446,"get-proto/Object.getPrototypeOf":444,"get-proto/Reflect.getPrototypeOf":445,"gopd":448,"has-symbols":450,"hasown":466,"math-intrinsics/abs":507,"math-intrinsics/floor":508,"math-intrinsics/max":510,"math-intrinsics/min":511,"math-intrinsics/pow":512,"math-intrinsics/round":513,"math-intrinsics/sign":514}],444:[function(require,module,exports){
'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;

},{"es-object-atoms":434}],445:[function(require,module,exports){
'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;

},{}],446:[function(require,module,exports){
'use strict';

var reflectGetProto = require('./Reflect.getPrototypeOf');
var originalGetProto = require('./Object.getPrototypeOf');

var getDunderProto = require('dunder-proto/get');

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;

},{"./Object.getPrototypeOf":444,"./Reflect.getPrototypeOf":445,"dunder-proto/get":408}],447:[function(require,module,exports){
'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;

},{}],448:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"./gOPD":447}],449:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;

},{"es-define-property":426}],450:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":451}],451:[function(require,module,exports){
'use strict';

/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],452:[function(require,module,exports){
'use strict';

var hasSymbols = require('has-symbols/shams');

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

},{"has-symbols/shams":451}],453:[function(require,module,exports){
'use strict'
var Buffer = require('safe-buffer').Buffer
var Transform = require('stream').Transform
var inherits = require('inherits')

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

var useUint8Array = typeof Uint8Array !== 'undefined'
var useArrayBuffer = typeof ArrayBuffer !== 'undefined' &&
  typeof Uint8Array !== 'undefined' &&
  ArrayBuffer.isView &&
  (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT)

function toBuffer (data, encoding) {
  // No need to do anything for exact instance
  // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
  if (data instanceof Buffer) return data

  // Convert strings to Buffer
  if (typeof data === 'string') return Buffer.from(data, encoding)

  /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */
  if (useArrayBuffer && ArrayBuffer.isView(data)) {
    if (data.byteLength === 0) return Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
    var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength)
    // Recheck result size, as offset/length doesn't work on Node.js <5.10
    // We just go to Uint8Array case if this fails
    if (res.byteLength === data.byteLength) return res
  }

  /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */
  if (useUint8Array && data instanceof Uint8Array) return Buffer.from(data)

  /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */
  if (
    Buffer.isBuffer(data) &&
    data.constructor &&
    typeof data.constructor.isBuffer === 'function' &&
    data.constructor.isBuffer(data)
  ) {
    return Buffer.from(data)
  }

  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.')
}

HashBase.prototype.update = function (data, encoding) {
  if (this._finalized) throw new Error('Digest already called')

  data = toBuffer(data, encoding) // asserts correct input type

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase

},{"inherits":495,"safe-buffer":788,"stream":799}],454:[function(require,module,exports){
var hash = exports;

hash.utils = require('./hash/utils');
hash.common = require('./hash/common');
hash.sha = require('./hash/sha');
hash.ripemd = require('./hash/ripemd');
hash.hmac = require('./hash/hmac');

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"./hash/common":455,"./hash/hmac":456,"./hash/ripemd":457,"./hash/sha":458,"./hash/utils":465}],455:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};

},{"./utils":465,"minimalistic-assert":524}],456:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

},{"./utils":465,"minimalistic-assert":524}],457:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var common = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

},{"./common":455,"./utils":465}],458:[function(require,module,exports){
'use strict';

exports.sha1 = require('./sha/1');
exports.sha224 = require('./sha/224');
exports.sha256 = require('./sha/256');
exports.sha384 = require('./sha/384');
exports.sha512 = require('./sha/512');

},{"./sha/1":459,"./sha/224":460,"./sha/256":461,"./sha/384":462,"./sha/512":463}],459:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":455,"../utils":465,"./common":464}],460:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var SHA256 = require('./256');

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};


},{"../utils":465,"./256":461}],461:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');
var assert = require('minimalistic-assert');

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":455,"../utils":465,"./common":464,"minimalistic-assert":524}],462:[function(require,module,exports){
'use strict';

var utils = require('../utils');

var SHA512 = require('./512');

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

},{"../utils":465,"./512":463}],463:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var assert = require('minimalistic-assert');

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

},{"../common":455,"../utils":465,"minimalistic-assert":524}],464:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;

},{"../utils":465}],465:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"inherits":495,"minimalistic-assert":524}],466:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":441}],467:[function(require,module,exports){
module.exports = require('./lib/heap');

},{"./lib/heap":468}],468:[function(require,module,exports){
// Generated by CoffeeScript 1.8.0
(function() {
  var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;

  floor = Math.floor, min = Math.min;


  /*
  Default comparison function to be used
   */

  defaultCmp = function(x, y) {
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  };


  /*
  Insert item x in list a, and keep it sorted assuming a is sorted.
  
  If x is already in a, insert it to the right of the rightmost x.
  
  Optional args lo (default 0) and hi (default a.length) bound the slice
  of a to be searched.
   */

  insort = function(a, x, lo, hi, cmp) {
    var mid;
    if (lo == null) {
      lo = 0;
    }
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (lo < 0) {
      throw new Error('lo must be non-negative');
    }
    if (hi == null) {
      hi = a.length;
    }
    while (lo < hi) {
      mid = floor((lo + hi) / 2);
      if (cmp(x, a[mid]) < 0) {
        hi = mid;
      } else {
        lo = mid + 1;
      }
    }
    return ([].splice.apply(a, [lo, lo - lo].concat(x)), x);
  };


  /*
  Push item onto heap, maintaining the heap invariant.
   */

  heappush = function(array, item, cmp) {
    if (cmp == null) {
      cmp = defaultCmp;
    }
    array.push(item);
    return _siftdown(array, 0, array.length - 1, cmp);
  };


  /*
  Pop the smallest item off the heap, maintaining the heap invariant.
   */

  heappop = function(array, cmp) {
    var lastelt, returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    lastelt = array.pop();
    if (array.length) {
      returnitem = array[0];
      array[0] = lastelt;
      _siftup(array, 0, cmp);
    } else {
      returnitem = lastelt;
    }
    return returnitem;
  };


  /*
  Pop and return the current smallest value, and add the new item.
  
  This is more efficient than heappop() followed by heappush(), and can be
  more appropriate when using a fixed size heap. Note that the value
  returned may be larger than item! That constrains reasonable use of
  this routine unless written as part of a conditional replacement:
      if item > array[0]
        item = heapreplace(array, item)
   */

  heapreplace = function(array, item, cmp) {
    var returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    returnitem = array[0];
    array[0] = item;
    _siftup(array, 0, cmp);
    return returnitem;
  };


  /*
  Fast version of a heappush followed by a heappop.
   */

  heappushpop = function(array, item, cmp) {
    var _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (array.length && cmp(array[0], item) < 0) {
      _ref = [array[0], item], item = _ref[0], array[0] = _ref[1];
      _siftup(array, 0, cmp);
    }
    return item;
  };


  /*
  Transform list into a heap, in-place, in O(array.length) time.
   */

  heapify = function(array, cmp) {
    var i, _i, _j, _len, _ref, _ref1, _results, _results1;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    _ref1 = (function() {
      _results1 = [];
      for (var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--){ _results1.push(_j); }
      return _results1;
    }).apply(this).reverse();
    _results = [];
    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
      i = _ref1[_i];
      _results.push(_siftup(array, i, cmp));
    }
    return _results;
  };


  /*
  Update the position of the given item in the heap.
  This function should be called every time the item is being modified.
   */

  updateItem = function(array, item, cmp) {
    var pos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    pos = array.indexOf(item);
    if (pos === -1) {
      return;
    }
    _siftdown(array, 0, pos, cmp);
    return _siftup(array, pos, cmp);
  };


  /*
  Find the n largest elements in a dataset.
   */

  nlargest = function(array, n, cmp) {
    var elem, result, _i, _len, _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    result = array.slice(0, n);
    if (!result.length) {
      return result;
    }
    heapify(result, cmp);
    _ref = array.slice(n);
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      elem = _ref[_i];
      heappushpop(result, elem, cmp);
    }
    return result.sort(cmp).reverse();
  };


  /*
  Find the n smallest elements in a dataset.
   */

  nsmallest = function(array, n, cmp) {
    var elem, i, los, result, _i, _j, _len, _ref, _ref1, _results;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (n * 10 <= array.length) {
      result = array.slice(0, n).sort(cmp);
      if (!result.length) {
        return result;
      }
      los = result[result.length - 1];
      _ref = array.slice(n);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elem = _ref[_i];
        if (cmp(elem, los) < 0) {
          insort(result, elem, 0, null, cmp);
          result.pop();
          los = result[result.length - 1];
        }
      }
      return result;
    }
    heapify(array, cmp);
    _results = [];
    for (i = _j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; i = 0 <= _ref1 ? ++_j : --_j) {
      _results.push(heappop(array, cmp));
    }
    return _results;
  };

  _siftdown = function(array, startpos, pos, cmp) {
    var newitem, parent, parentpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    newitem = array[pos];
    while (pos > startpos) {
      parentpos = (pos - 1) >> 1;
      parent = array[parentpos];
      if (cmp(newitem, parent) < 0) {
        array[pos] = parent;
        pos = parentpos;
        continue;
      }
      break;
    }
    return array[pos] = newitem;
  };

  _siftup = function(array, pos, cmp) {
    var childpos, endpos, newitem, rightpos, startpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    endpos = array.length;
    startpos = pos;
    newitem = array[pos];
    childpos = 2 * pos + 1;
    while (childpos < endpos) {
      rightpos = childpos + 1;
      if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) {
        childpos = rightpos;
      }
      array[pos] = array[childpos];
      pos = childpos;
      childpos = 2 * pos + 1;
    }
    array[pos] = newitem;
    return _siftdown(array, startpos, pos, cmp);
  };

  Heap = (function() {
    Heap.push = heappush;

    Heap.pop = heappop;

    Heap.replace = heapreplace;

    Heap.pushpop = heappushpop;

    Heap.heapify = heapify;

    Heap.updateItem = updateItem;

    Heap.nlargest = nlargest;

    Heap.nsmallest = nsmallest;

    function Heap(cmp) {
      this.cmp = cmp != null ? cmp : defaultCmp;
      this.nodes = [];
    }

    Heap.prototype.push = function(x) {
      return heappush(this.nodes, x, this.cmp);
    };

    Heap.prototype.pop = function() {
      return heappop(this.nodes, this.cmp);
    };

    Heap.prototype.peek = function() {
      return this.nodes[0];
    };

    Heap.prototype.contains = function(x) {
      return this.nodes.indexOf(x) !== -1;
    };

    Heap.prototype.replace = function(x) {
      return heapreplace(this.nodes, x, this.cmp);
    };

    Heap.prototype.pushpop = function(x) {
      return heappushpop(this.nodes, x, this.cmp);
    };

    Heap.prototype.heapify = function() {
      return heapify(this.nodes, this.cmp);
    };

    Heap.prototype.updateItem = function(x) {
      return updateItem(this.nodes, x, this.cmp);
    };

    Heap.prototype.clear = function() {
      return this.nodes = [];
    };

    Heap.prototype.empty = function() {
      return this.nodes.length === 0;
    };

    Heap.prototype.size = function() {
      return this.nodes.length;
    };

    Heap.prototype.clone = function() {
      var heap;
      heap = new Heap();
      heap.nodes = this.nodes.slice(0);
      return heap;
    };

    Heap.prototype.toArray = function() {
      return this.nodes.slice(0);
    };

    Heap.prototype.insert = Heap.prototype.push;

    Heap.prototype.top = Heap.prototype.peek;

    Heap.prototype.front = Heap.prototype.peek;

    Heap.prototype.has = Heap.prototype.contains;

    Heap.prototype.copy = Heap.prototype.clone;

    return Heap;

  })();

  (function(root, factory) {
    if (typeof define === 'function' && define.amd) {
      return define([], factory);
    } else if (typeof exports === 'object') {
      return module.exports = factory();
    } else {
      return root.Heap = factory();
    }
  })(this, function() {
    return Heap;
  });

}).call(this);

},{}],469:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var utils = require('minimalistic-crypto-utils');
var assert = require('minimalistic-assert');

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};

},{"hash.js":454,"minimalistic-assert":524,"minimalistic-crypto-utils":525}],470:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraImpl = void 0;
var AbstractCameraCapability = (function () {
    function AbstractCameraCapability(name, track) {
        this.name = name;
        this.track = track;
    }
    AbstractCameraCapability.prototype.isSupported = function () {
        if (!this.track.getCapabilities) {
            return false;
        }
        return this.name in this.track.getCapabilities();
    };
    AbstractCameraCapability.prototype.apply = function (value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = { advanced: [constraint] };
        return this.track.applyConstraints(constraints);
    };
    AbstractCameraCapability.prototype.value = function () {
        var settings = this.track.getSettings();
        if (this.name in settings) {
            var settingValue = settings[this.name];
            return settingValue;
        }
        return null;
    };
    return AbstractCameraCapability;
}());
var AbstractRangeCameraCapability = (function (_super) {
    __extends(AbstractRangeCameraCapability, _super);
    function AbstractRangeCameraCapability(name, track) {
        return _super.call(this, name, track) || this;
    }
    AbstractRangeCameraCapability.prototype.min = function () {
        return this.getCapabilities().min;
    };
    AbstractRangeCameraCapability.prototype.max = function () {
        return this.getCapabilities().max;
    };
    AbstractRangeCameraCapability.prototype.step = function () {
        return this.getCapabilities().step;
    };
    AbstractRangeCameraCapability.prototype.apply = function (value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = { advanced: [constraint] };
        return this.track.applyConstraints(constraints);
    };
    AbstractRangeCameraCapability.prototype.getCapabilities = function () {
        this.failIfNotSupported();
        var capabilities = this.track.getCapabilities();
        var capability = capabilities[this.name];
        return {
            min: capability.min,
            max: capability.max,
            step: capability.step,
        };
    };
    AbstractRangeCameraCapability.prototype.failIfNotSupported = function () {
        if (!this.isSupported()) {
            throw new Error("".concat(this.name, " capability not supported"));
        }
    };
    return AbstractRangeCameraCapability;
}(AbstractCameraCapability));
var ZoomFeatureImpl = (function (_super) {
    __extends(ZoomFeatureImpl, _super);
    function ZoomFeatureImpl(track) {
        return _super.call(this, "zoom", track) || this;
    }
    return ZoomFeatureImpl;
}(AbstractRangeCameraCapability));
var TorchFeatureImpl = (function (_super) {
    __extends(TorchFeatureImpl, _super);
    function TorchFeatureImpl(track) {
        return _super.call(this, "torch", track) || this;
    }
    return TorchFeatureImpl;
}(AbstractCameraCapability));
var CameraCapabilitiesImpl = (function () {
    function CameraCapabilitiesImpl(track) {
        this.track = track;
    }
    CameraCapabilitiesImpl.prototype.zoomFeature = function () {
        return new ZoomFeatureImpl(this.track);
    };
    CameraCapabilitiesImpl.prototype.torchFeature = function () {
        return new TorchFeatureImpl(this.track);
    };
    return CameraCapabilitiesImpl;
}());
var RenderedCameraImpl = (function () {
    function RenderedCameraImpl(parentElement, mediaStream, callbacks) {
        this.isClosed = false;
        this.parentElement = parentElement;
        this.mediaStream = mediaStream;
        this.callbacks = callbacks;
        this.surface = this.createVideoElement(this.parentElement.clientWidth);
        parentElement.append(this.surface);
    }
    RenderedCameraImpl.prototype.createVideoElement = function (width) {
        var videoElement = document.createElement("video");
        videoElement.style.width = "".concat(width, "px");
        videoElement.style.display = "block";
        videoElement.muted = true;
        videoElement.setAttribute("muted", "true");
        videoElement.playsInline = true;
        return videoElement;
    };
    RenderedCameraImpl.prototype.setupSurface = function () {
        var _this = this;
        this.surface.onabort = function () {
            throw "RenderedCameraImpl video surface onabort() called";
        };
        this.surface.onerror = function () {
            throw "RenderedCameraImpl video surface onerror() called";
        };
        var onVideoStart = function () {
            var videoWidth = _this.surface.clientWidth;
            var videoHeight = _this.surface.clientHeight;
            _this.callbacks.onRenderSurfaceReady(videoWidth, videoHeight);
            _this.surface.removeEventListener("playing", onVideoStart);
        };
        this.surface.addEventListener("playing", onVideoStart);
        this.surface.srcObject = this.mediaStream;
        this.surface.play();
    };
    RenderedCameraImpl.create = function (parentElement, mediaStream, options, callbacks) {
        return __awaiter(this, void 0, void 0, function () {
            var renderedCamera, aspectRatioConstraint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        renderedCamera = new RenderedCameraImpl(parentElement, mediaStream, callbacks);
                        if (!options.aspectRatio) return [3, 2];
                        aspectRatioConstraint = {
                            aspectRatio: options.aspectRatio
                        };
                        return [4, renderedCamera.getFirstTrackOrFail().applyConstraints(aspectRatioConstraint)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        renderedCamera.setupSurface();
                        return [2, renderedCamera];
                }
            });
        });
    };
    RenderedCameraImpl.prototype.failIfClosed = function () {
        if (this.isClosed) {
            throw "The RenderedCamera has already been closed.";
        }
    };
    RenderedCameraImpl.prototype.getFirstTrackOrFail = function () {
        this.failIfClosed();
        if (this.mediaStream.getVideoTracks().length === 0) {
            throw "No video tracks found";
        }
        return this.mediaStream.getVideoTracks()[0];
    };
    RenderedCameraImpl.prototype.pause = function () {
        this.failIfClosed();
        this.surface.pause();
    };
    RenderedCameraImpl.prototype.resume = function (onResumeCallback) {
        this.failIfClosed();
        var $this = this;
        var onVideoResume = function () {
            setTimeout(onResumeCallback, 200);
            $this.surface.removeEventListener("playing", onVideoResume);
        };
        this.surface.addEventListener("playing", onVideoResume);
        this.surface.play();
    };
    RenderedCameraImpl.prototype.isPaused = function () {
        this.failIfClosed();
        return this.surface.paused;
    };
    RenderedCameraImpl.prototype.getSurface = function () {
        this.failIfClosed();
        return this.surface;
    };
    RenderedCameraImpl.prototype.getRunningTrackCapabilities = function () {
        return this.getFirstTrackOrFail().getCapabilities();
    };
    RenderedCameraImpl.prototype.getRunningTrackSettings = function () {
        return this.getFirstTrackOrFail().getSettings();
    };
    RenderedCameraImpl.prototype.applyVideoConstraints = function (constraints) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if ("aspectRatio" in constraints) {
                    throw "Changing 'aspectRatio' in run-time is not yet supported.";
                }
                return [2, this.getFirstTrackOrFail().applyConstraints(constraints)];
            });
        });
    };
    RenderedCameraImpl.prototype.close = function () {
        if (this.isClosed) {
            return Promise.resolve();
        }
        var $this = this;
        return new Promise(function (resolve, _) {
            var tracks = $this.mediaStream.getVideoTracks();
            var tracksToClose = tracks.length;
            var tracksClosed = 0;
            $this.mediaStream.getVideoTracks().forEach(function (videoTrack) {
                $this.mediaStream.removeTrack(videoTrack);
                videoTrack.stop();
                ++tracksClosed;
                if (tracksClosed >= tracksToClose) {
                    $this.isClosed = true;
                    $this.parentElement.removeChild($this.surface);
                    resolve();
                }
            });
        });
    };
    RenderedCameraImpl.prototype.getCapabilities = function () {
        return new CameraCapabilitiesImpl(this.getFirstTrackOrFail());
    };
    return RenderedCameraImpl;
}());
var CameraImpl = (function () {
    function CameraImpl(mediaStream) {
        this.mediaStream = mediaStream;
    }
    CameraImpl.prototype.render = function (parentElement, options, callbacks) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, RenderedCameraImpl.create(parentElement, this.mediaStream, options, callbacks)];
            });
        });
    };
    CameraImpl.create = function (videoConstraints) {
        return __awaiter(this, void 0, void 0, function () {
            var constraints, mediaStream;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!navigator.mediaDevices) {
                            throw "navigator.mediaDevices not supported";
                        }
                        constraints = {
                            audio: false,
                            video: videoConstraints
                        };
                        return [4, navigator.mediaDevices.getUserMedia(constraints)];
                    case 1:
                        mediaStream = _a.sent();
                        return [2, new CameraImpl(mediaStream)];
                }
            });
        });
    };
    return CameraImpl;
}());
exports.CameraImpl = CameraImpl;

},{}],471:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraFactory = void 0;
var core_impl_1 = require("./core-impl");
var CameraFactory = (function () {
    function CameraFactory() {
    }
    CameraFactory.failIfNotSupported = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!navigator.mediaDevices) {
                    throw "navigator.mediaDevices not supported";
                }
                return [2, new CameraFactory()];
            });
        });
    };
    CameraFactory.prototype.create = function (videoConstraints) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, core_impl_1.CameraImpl.create(videoConstraints)];
            });
        });
    };
    return CameraFactory;
}());
exports.CameraFactory = CameraFactory;

},{"./core-impl":470}],472:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraPermissions = void 0;
var CameraPermissions = (function () {
    function CameraPermissions() {
    }
    CameraPermissions.hasPermissions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var devices, _i, devices_1, device;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, navigator.mediaDevices.enumerateDevices()];
                    case 1:
                        devices = _a.sent();
                        for (_i = 0, devices_1 = devices; _i < devices_1.length; _i++) {
                            device = devices_1[_i];
                            if (device.kind === "videoinput" && device.label) {
                                return [2, true];
                            }
                        }
                        return [2, false];
                }
            });
        });
    };
    return CameraPermissions;
}());
exports.CameraPermissions = CameraPermissions;

},{}],473:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraRetriever = void 0;
var strings_1 = require("../strings");
var CameraRetriever = (function () {
    function CameraRetriever() {
    }
    CameraRetriever.retrieve = function () {
        if (navigator.mediaDevices) {
            return CameraRetriever.getCamerasFromMediaDevices();
        }
        var mst = MediaStreamTrack;
        if (MediaStreamTrack && mst.getSources) {
            return CameraRetriever.getCamerasFromMediaStreamTrack();
        }
        return CameraRetriever.rejectWithError();
    };
    CameraRetriever.rejectWithError = function () {
        var errorMessage = strings_1.Html5QrcodeStrings.unableToQuerySupportedDevices();
        if (!CameraRetriever.isHttpsOrLocalhost()) {
            errorMessage = strings_1.Html5QrcodeStrings.insecureContextCameraQueryError();
        }
        return Promise.reject(errorMessage);
    };
    CameraRetriever.isHttpsOrLocalhost = function () {
        if (location.protocol === "https:") {
            return true;
        }
        var host = location.host.split(":")[0];
        return host === "127.0.0.1" || host === "localhost";
    };
    CameraRetriever.getCamerasFromMediaDevices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var closeActiveStreams, mediaStream, devices, results, _i, devices_1, device;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        closeActiveStreams = function (stream) {
                            var tracks = stream.getVideoTracks();
                            for (var _i = 0, tracks_1 = tracks; _i < tracks_1.length; _i++) {
                                var track = tracks_1[_i];
                                track.enabled = false;
                                track.stop();
                                stream.removeTrack(track);
                            }
                        };
                        return [4, navigator.mediaDevices.getUserMedia({ audio: false, video: true })];
                    case 1:
                        mediaStream = _a.sent();
                        return [4, navigator.mediaDevices.enumerateDevices()];
                    case 2:
                        devices = _a.sent();
                        results = [];
                        for (_i = 0, devices_1 = devices; _i < devices_1.length; _i++) {
                            device = devices_1[_i];
                            if (device.kind === "videoinput") {
                                results.push({
                                    id: device.deviceId,
                                    label: device.label
                                });
                            }
                        }
                        closeActiveStreams(mediaStream);
                        return [2, results];
                }
            });
        });
    };
    CameraRetriever.getCamerasFromMediaStreamTrack = function () {
        return new Promise(function (resolve, _) {
            var callback = function (sourceInfos) {
                var results = [];
                for (var _i = 0, sourceInfos_1 = sourceInfos; _i < sourceInfos_1.length; _i++) {
                    var sourceInfo = sourceInfos_1[_i];
                    if (sourceInfo.kind === "video") {
                        results.push({
                            id: sourceInfo.id,
                            label: sourceInfo.label
                        });
                    }
                }
                resolve(results);
            };
            var mst = MediaStreamTrack;
            mst.getSources(callback);
        });
    };
    return CameraRetriever;
}());
exports.CameraRetriever = CameraRetriever;

},{"../strings":483}],474:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Html5QrcodeShim = void 0;
var zxing_html5_qrcode_decoder_1 = require("./zxing-html5-qrcode-decoder");
var native_bar_code_detector_1 = require("./native-bar-code-detector");
var Html5QrcodeShim = (function () {
    function Html5QrcodeShim(requestedFormats, useBarCodeDetectorIfSupported, verbose, logger) {
        this.EXECUTIONS_TO_REPORT_PERFORMANCE = 100;
        this.executions = 0;
        this.executionResults = [];
        this.wasPrimaryDecoderUsedInLastDecode = false;
        this.verbose = verbose;
        if (useBarCodeDetectorIfSupported
            && native_bar_code_detector_1.BarcodeDetectorDelegate.isSupported()) {
            this.primaryDecoder = new native_bar_code_detector_1.BarcodeDetectorDelegate(requestedFormats, verbose, logger);
            this.secondaryDecoder = new zxing_html5_qrcode_decoder_1.ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger);
        }
        else {
            this.primaryDecoder = new zxing_html5_qrcode_decoder_1.ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger);
        }
    }
    Html5QrcodeShim.prototype.decodeAsync = function (canvas) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4, this.getDecoder().decodeAsync(canvas)];
                    case 2: return [2, _a.sent()];
                    case 3:
                        this.possiblyLogPerformance(startTime);
                        return [7];
                    case 4: return [2];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.decodeRobustlyAsync = function (canvas) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, this.primaryDecoder.decodeAsync(canvas)];
                    case 2: return [2, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        if (this.secondaryDecoder) {
                            return [2, this.secondaryDecoder.decodeAsync(canvas)];
                        }
                        throw error_1;
                    case 4:
                        this.possiblyLogPerformance(startTime);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.getDecoder = function () {
        if (!this.secondaryDecoder) {
            return this.primaryDecoder;
        }
        if (this.wasPrimaryDecoderUsedInLastDecode === false) {
            this.wasPrimaryDecoderUsedInLastDecode = true;
            return this.primaryDecoder;
        }
        this.wasPrimaryDecoderUsedInLastDecode = false;
        return this.secondaryDecoder;
    };
    Html5QrcodeShim.prototype.possiblyLogPerformance = function (startTime) {
        if (!this.verbose) {
            return;
        }
        var executionTime = performance.now() - startTime;
        this.executionResults.push(executionTime);
        this.executions++;
        this.possiblyFlushPerformanceReport();
    };
    Html5QrcodeShim.prototype.possiblyFlushPerformanceReport = function () {
        if (this.executions < this.EXECUTIONS_TO_REPORT_PERFORMANCE) {
            return;
        }
        var sum = 0;
        for (var _i = 0, _a = this.executionResults; _i < _a.length; _i++) {
            var executionTime = _a[_i];
            sum += executionTime;
        }
        var mean = sum / this.executionResults.length;
        console.log("".concat(mean, " ms for ").concat(this.executionResults.length, " last runs."));
        this.executions = 0;
        this.executionResults = [];
    };
    return Html5QrcodeShim;
}());
exports.Html5QrcodeShim = Html5QrcodeShim;

},{"./native-bar-code-detector":480,"./zxing-html5-qrcode-decoder":492}],475:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clip = exports.isNullOrUndefined = exports.BaseLoggger = exports.Html5QrcodeErrorFactory = exports.Html5QrcodeErrorTypes = exports.Html5QrcodeResultFactory = exports.QrcodeResultFormat = exports.Html5QrcodeConstants = exports.Html5QrcodeScanType = exports.isValidHtml5QrcodeSupportedFormats = exports.DecodedTextType = exports.Html5QrcodeSupportedFormats = void 0;
var Html5QrcodeSupportedFormats;
(function (Html5QrcodeSupportedFormats) {
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["QR_CODE"] = 0] = "QR_CODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["AZTEC"] = 1] = "AZTEC";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODABAR"] = 2] = "CODABAR";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_39"] = 3] = "CODE_39";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_93"] = 4] = "CODE_93";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_128"] = 5] = "CODE_128";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["DATA_MATRIX"] = 6] = "DATA_MATRIX";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["MAXICODE"] = 7] = "MAXICODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["ITF"] = 8] = "ITF";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_13"] = 9] = "EAN_13";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_8"] = 10] = "EAN_8";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["PDF_417"] = 11] = "PDF_417";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_14"] = 12] = "RSS_14";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_A"] = 14] = "UPC_A";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_E"] = 15] = "UPC_E";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})(Html5QrcodeSupportedFormats = exports.Html5QrcodeSupportedFormats || (exports.Html5QrcodeSupportedFormats = {}));
var html5QrcodeSupportedFormatsTextMap = new Map([
    [Html5QrcodeSupportedFormats.QR_CODE, "QR_CODE"],
    [Html5QrcodeSupportedFormats.AZTEC, "AZTEC"],
    [Html5QrcodeSupportedFormats.CODABAR, "CODABAR"],
    [Html5QrcodeSupportedFormats.CODE_39, "CODE_39"],
    [Html5QrcodeSupportedFormats.CODE_93, "CODE_93"],
    [Html5QrcodeSupportedFormats.CODE_128, "CODE_128"],
    [Html5QrcodeSupportedFormats.DATA_MATRIX, "DATA_MATRIX"],
    [Html5QrcodeSupportedFormats.MAXICODE, "MAXICODE"],
    [Html5QrcodeSupportedFormats.ITF, "ITF"],
    [Html5QrcodeSupportedFormats.EAN_13, "EAN_13"],
    [Html5QrcodeSupportedFormats.EAN_8, "EAN_8"],
    [Html5QrcodeSupportedFormats.PDF_417, "PDF_417"],
    [Html5QrcodeSupportedFormats.RSS_14, "RSS_14"],
    [Html5QrcodeSupportedFormats.RSS_EXPANDED, "RSS_EXPANDED"],
    [Html5QrcodeSupportedFormats.UPC_A, "UPC_A"],
    [Html5QrcodeSupportedFormats.UPC_E, "UPC_E"],
    [Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION, "UPC_EAN_EXTENSION"]
]);
var DecodedTextType;
(function (DecodedTextType) {
    DecodedTextType[DecodedTextType["UNKNOWN"] = 0] = "UNKNOWN";
    DecodedTextType[DecodedTextType["URL"] = 1] = "URL";
})(DecodedTextType = exports.DecodedTextType || (exports.DecodedTextType = {}));
function isValidHtml5QrcodeSupportedFormats(format) {
    return Object.values(Html5QrcodeSupportedFormats).includes(format);
}
exports.isValidHtml5QrcodeSupportedFormats = isValidHtml5QrcodeSupportedFormats;
var Html5QrcodeScanType;
(function (Html5QrcodeScanType) {
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_CAMERA"] = 0] = "SCAN_TYPE_CAMERA";
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_FILE"] = 1] = "SCAN_TYPE_FILE";
})(Html5QrcodeScanType = exports.Html5QrcodeScanType || (exports.Html5QrcodeScanType = {}));
var Html5QrcodeConstants = (function () {
    function Html5QrcodeConstants() {
    }
    Html5QrcodeConstants.GITHUB_PROJECT_URL = "https://github.com/mebjas/html5-qrcode";
    Html5QrcodeConstants.SCAN_DEFAULT_FPS = 2;
    Html5QrcodeConstants.DEFAULT_DISABLE_FLIP = false;
    Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED = true;
    Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE = [
        Html5QrcodeScanType.SCAN_TYPE_CAMERA,
        Html5QrcodeScanType.SCAN_TYPE_FILE
    ];
    return Html5QrcodeConstants;
}());
exports.Html5QrcodeConstants = Html5QrcodeConstants;
var QrcodeResultFormat = (function () {
    function QrcodeResultFormat(format, formatName) {
        this.format = format;
        this.formatName = formatName;
    }
    QrcodeResultFormat.prototype.toString = function () {
        return this.formatName;
    };
    QrcodeResultFormat.create = function (format) {
        if (!html5QrcodeSupportedFormatsTextMap.has(format)) {
            throw "".concat(format, " not in html5QrcodeSupportedFormatsTextMap");
        }
        return new QrcodeResultFormat(format, html5QrcodeSupportedFormatsTextMap.get(format));
    };
    return QrcodeResultFormat;
}());
exports.QrcodeResultFormat = QrcodeResultFormat;
var Html5QrcodeResultFactory = (function () {
    function Html5QrcodeResultFactory() {
    }
    Html5QrcodeResultFactory.createFromText = function (decodedText) {
        var qrcodeResult = {
            text: decodedText
        };
        return {
            decodedText: decodedText,
            result: qrcodeResult
        };
    };
    Html5QrcodeResultFactory.createFromQrcodeResult = function (qrcodeResult) {
        return {
            decodedText: qrcodeResult.text,
            result: qrcodeResult
        };
    };
    return Html5QrcodeResultFactory;
}());
exports.Html5QrcodeResultFactory = Html5QrcodeResultFactory;
var Html5QrcodeErrorTypes;
(function (Html5QrcodeErrorTypes) {
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["UNKWOWN_ERROR"] = 0] = "UNKWOWN_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["IMPLEMENTATION_ERROR"] = 1] = "IMPLEMENTATION_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["NO_CODE_FOUND_ERROR"] = 2] = "NO_CODE_FOUND_ERROR";
})(Html5QrcodeErrorTypes = exports.Html5QrcodeErrorTypes || (exports.Html5QrcodeErrorTypes = {}));
var Html5QrcodeErrorFactory = (function () {
    function Html5QrcodeErrorFactory() {
    }
    Html5QrcodeErrorFactory.createFrom = function (error) {
        return {
            errorMessage: error,
            type: Html5QrcodeErrorTypes.UNKWOWN_ERROR
        };
    };
    return Html5QrcodeErrorFactory;
}());
exports.Html5QrcodeErrorFactory = Html5QrcodeErrorFactory;
var BaseLoggger = (function () {
    function BaseLoggger(verbose) {
        this.verbose = verbose;
    }
    BaseLoggger.prototype.log = function (message) {
        if (this.verbose) {
            console.log(message);
        }
    };
    BaseLoggger.prototype.warn = function (message) {
        if (this.verbose) {
            console.warn(message);
        }
    };
    BaseLoggger.prototype.logError = function (message, isExperimental) {
        if (this.verbose || isExperimental === true) {
            console.error(message);
        }
    };
    BaseLoggger.prototype.logErrors = function (errors) {
        if (errors.length === 0) {
            throw "Logger#logError called without arguments";
        }
        if (this.verbose) {
            console.error(errors);
        }
    };
    return BaseLoggger;
}());
exports.BaseLoggger = BaseLoggger;
function isNullOrUndefined(obj) {
    return (typeof obj === "undefined") || obj === null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function clip(value, minValue, maxValue) {
    if (value > maxValue) {
        return maxValue;
    }
    if (value < minValue) {
        return minValue;
    }
    return value;
}
exports.clip = clip;

},{}],476:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Html5QrcodeScanner = void 0;
var core_1 = require("./core");
var html5_qrcode_1 = require("./html5-qrcode");
var strings_1 = require("./strings");
var image_assets_1 = require("./image-assets");
var storage_1 = require("./storage");
var ui_1 = require("./ui");
var permissions_1 = require("./camera/permissions");
var scan_type_selector_1 = require("./ui/scanner/scan-type-selector");
var torch_button_1 = require("./ui/scanner/torch-button");
var file_selection_ui_1 = require("./ui/scanner/file-selection-ui");
var base_1 = require("./ui/scanner/base");
var camera_selection_ui_1 = require("./ui/scanner/camera-selection-ui");
var camera_zoom_ui_1 = require("./ui/scanner/camera-zoom-ui");
var Html5QrcodeScannerStatus;
(function (Html5QrcodeScannerStatus) {
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_DEFAULT"] = 0] = "STATUS_DEFAULT";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_WARNING"] = 2] = "STATUS_WARNING";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_REQUESTING_PERMISSION"] = 3] = "STATUS_REQUESTING_PERMISSION";
})(Html5QrcodeScannerStatus || (Html5QrcodeScannerStatus = {}));
function toHtml5QrcodeCameraScanConfig(config) {
    return {
        fps: config.fps,
        qrbox: config.qrbox,
        aspectRatio: config.aspectRatio,
        disableFlip: config.disableFlip,
        videoConstraints: config.videoConstraints
    };
}
function toHtml5QrcodeFullConfig(config, verbose) {
    return {
        formatsToSupport: config.formatsToSupport,
        useBarCodeDetectorIfSupported: config.useBarCodeDetectorIfSupported,
        experimentalFeatures: config.experimentalFeatures,
        verbose: verbose
    };
}
var Html5QrcodeScanner = (function () {
    function Html5QrcodeScanner(elementId, config, verbose) {
        this.lastMatchFound = null;
        this.cameraScanImage = null;
        this.fileScanImage = null;
        this.fileSelectionUi = null;
        this.elementId = elementId;
        this.config = this.createConfig(config);
        this.verbose = verbose === true;
        if (!document.getElementById(elementId)) {
            throw "HTML Element with id=".concat(elementId, " not found");
        }
        this.scanTypeSelector = new scan_type_selector_1.ScanTypeSelector(this.config.supportedScanTypes);
        this.currentScanType = this.scanTypeSelector.getDefaultScanType();
        this.sectionSwapAllowed = true;
        this.logger = new core_1.BaseLoggger(this.verbose);
        this.persistedDataManager = new storage_1.PersistedDataManager();
        if (config.rememberLastUsedCamera !== true) {
            this.persistedDataManager.reset();
        }
    }
    Html5QrcodeScanner.prototype.render = function (qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        this.lastMatchFound = null;
        this.qrCodeSuccessCallback
            = function (decodedText, result) {
                if (qrCodeSuccessCallback) {
                    qrCodeSuccessCallback(decodedText, result);
                }
                else {
                    if (_this.lastMatchFound === decodedText) {
                        return;
                    }
                    _this.lastMatchFound = decodedText;
                    _this.setHeaderMessage(strings_1.Html5QrcodeScannerStrings.lastMatch(decodedText), Html5QrcodeScannerStatus.STATUS_SUCCESS);
                }
            };
        this.qrCodeErrorCallback =
            function (errorMessage, error) {
                if (qrCodeErrorCallback) {
                    qrCodeErrorCallback(errorMessage, error);
                }
            };
        var container = document.getElementById(this.elementId);
        if (!container) {
            throw "HTML Element with id=".concat(this.elementId, " not found");
        }
        container.innerHTML = "";
        this.createBasicLayout(container);
        this.html5Qrcode = new html5_qrcode_1.Html5Qrcode(this.getScanRegionId(), toHtml5QrcodeFullConfig(this.config, this.verbose));
    };
    Html5QrcodeScanner.prototype.pause = function (shouldPauseVideo) {
        if ((0, core_1.isNullOrUndefined)(shouldPauseVideo) || shouldPauseVideo !== true) {
            shouldPauseVideo = false;
        }
        this.getHtml5QrcodeOrFail().pause(shouldPauseVideo);
    };
    Html5QrcodeScanner.prototype.resume = function () {
        this.getHtml5QrcodeOrFail().resume();
    };
    Html5QrcodeScanner.prototype.getState = function () {
        return this.getHtml5QrcodeOrFail().getState();
    };
    Html5QrcodeScanner.prototype.clear = function () {
        var _this = this;
        var emptyHtmlContainer = function () {
            var mainContainer = document.getElementById(_this.elementId);
            if (mainContainer) {
                mainContainer.innerHTML = "";
                _this.resetBasicLayout(mainContainer);
            }
        };
        if (this.html5Qrcode) {
            return new Promise(function (resolve, reject) {
                if (!_this.html5Qrcode) {
                    resolve();
                    return;
                }
                if (_this.html5Qrcode.isScanning) {
                    _this.html5Qrcode.stop().then(function (_) {
                        if (!_this.html5Qrcode) {
                            resolve();
                            return;
                        }
                        _this.html5Qrcode.clear();
                        emptyHtmlContainer();
                        resolve();
                    }).catch(function (error) {
                        if (_this.verbose) {
                            _this.logger.logError("Unable to stop qrcode scanner", error);
                        }
                        reject(error);
                    });
                }
                else {
                    _this.html5Qrcode.clear();
                    emptyHtmlContainer();
                    resolve();
                }
            });
        }
        return Promise.resolve();
    };
    Html5QrcodeScanner.prototype.getRunningTrackCapabilities = function () {
        return this.getHtml5QrcodeOrFail().getRunningTrackCapabilities();
    };
    Html5QrcodeScanner.prototype.getRunningTrackSettings = function () {
        return this.getHtml5QrcodeOrFail().getRunningTrackSettings();
    };
    Html5QrcodeScanner.prototype.applyVideoConstraints = function (videoConstaints) {
        return this.getHtml5QrcodeOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5QrcodeScanner.prototype.getHtml5QrcodeOrFail = function () {
        if (!this.html5Qrcode) {
            throw "Code scanner not initialized.";
        }
        return this.html5Qrcode;
    };
    Html5QrcodeScanner.prototype.createConfig = function (config) {
        if (config) {
            if (!config.fps) {
                config.fps = core_1.Html5QrcodeConstants.SCAN_DEFAULT_FPS;
            }
            if (config.rememberLastUsedCamera !== (!core_1.Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED)) {
                config.rememberLastUsedCamera
                    = core_1.Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED;
            }
            if (!config.supportedScanTypes) {
                config.supportedScanTypes
                    = core_1.Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE;
            }
            return config;
        }
        return {
            fps: core_1.Html5QrcodeConstants.SCAN_DEFAULT_FPS,
            rememberLastUsedCamera: core_1.Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED,
            supportedScanTypes: core_1.Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE
        };
    };
    Html5QrcodeScanner.prototype.createBasicLayout = function (parent) {
        parent.style.position = "relative";
        parent.style.padding = "0px";
        parent.style.border = "1px solid silver";
        this.createHeader(parent);
        var qrCodeScanRegion = document.createElement("div");
        var scanRegionId = this.getScanRegionId();
        qrCodeScanRegion.id = scanRegionId;
        qrCodeScanRegion.style.width = "100%";
        qrCodeScanRegion.style.minHeight = "100px";
        qrCodeScanRegion.style.textAlign = "center";
        parent.appendChild(qrCodeScanRegion);
        if (scan_type_selector_1.ScanTypeSelector.isCameraScanType(this.currentScanType)) {
            this.insertCameraScanImageToScanRegion();
        }
        else {
            this.insertFileScanImageToScanRegion();
        }
        var qrCodeDashboard = document.createElement("div");
        var dashboardId = this.getDashboardId();
        qrCodeDashboard.id = dashboardId;
        qrCodeDashboard.style.width = "100%";
        parent.appendChild(qrCodeDashboard);
        this.setupInitialDashboard(qrCodeDashboard);
    };
    Html5QrcodeScanner.prototype.resetBasicLayout = function (mainContainer) {
        mainContainer.style.border = "none";
    };
    Html5QrcodeScanner.prototype.setupInitialDashboard = function (dashboard) {
        this.createSection(dashboard);
        this.createSectionControlPanel();
        if (this.scanTypeSelector.hasMoreThanOneScanType()) {
            this.createSectionSwap();
        }
    };
    Html5QrcodeScanner.prototype.createHeader = function (dashboard) {
        var header = document.createElement("div");
        header.style.textAlign = "left";
        header.style.margin = "0px";
        dashboard.appendChild(header);
        var libraryInfo = new ui_1.LibraryInfoContainer();
        libraryInfo.renderInto(header);
        var headerMessageContainer = document.createElement("div");
        headerMessageContainer.id = this.getHeaderMessageContainerId();
        headerMessageContainer.style.display = "none";
        headerMessageContainer.style.textAlign = "center";
        headerMessageContainer.style.fontSize = "14px";
        headerMessageContainer.style.padding = "2px 10px";
        headerMessageContainer.style.margin = "4px";
        headerMessageContainer.style.borderTop = "1px solid #f6f6f6";
        header.appendChild(headerMessageContainer);
    };
    Html5QrcodeScanner.prototype.createSection = function (dashboard) {
        var section = document.createElement("div");
        section.id = this.getDashboardSectionId();
        section.style.width = "100%";
        section.style.padding = "10px 0px 10px 0px";
        section.style.textAlign = "left";
        dashboard.appendChild(section);
    };
    Html5QrcodeScanner.prototype.createCameraListUi = function (scpCameraScanRegion, requestPermissionContainer, requestPermissionButton) {
        var $this = this;
        $this.showHideScanTypeSwapLink(false);
        $this.setHeaderMessage(strings_1.Html5QrcodeScannerStrings.cameraPermissionRequesting());
        var createPermissionButtonIfNotExists = function () {
            if (!requestPermissionButton) {
                $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
            }
        };
        html5_qrcode_1.Html5Qrcode.getCameras().then(function (cameras) {
            $this.persistedDataManager.setHasPermission(true);
            $this.showHideScanTypeSwapLink(true);
            $this.resetHeaderMessage();
            if (cameras && cameras.length > 0) {
                scpCameraScanRegion.removeChild(requestPermissionContainer);
                $this.renderCameraSelection(cameras);
            }
            else {
                $this.setHeaderMessage(strings_1.Html5QrcodeScannerStrings.noCameraFound(), Html5QrcodeScannerStatus.STATUS_WARNING);
                createPermissionButtonIfNotExists();
            }
        }).catch(function (error) {
            $this.persistedDataManager.setHasPermission(false);
            if (requestPermissionButton) {
                requestPermissionButton.disabled = false;
            }
            else {
                createPermissionButtonIfNotExists();
            }
            $this.setHeaderMessage(error, Html5QrcodeScannerStatus.STATUS_WARNING);
            $this.showHideScanTypeSwapLink(true);
        });
    };
    Html5QrcodeScanner.prototype.createPermissionButton = function (scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        var requestPermissionButton = base_1.BaseUiElementFactory
            .createElement("button", this.getCameraPermissionButtonId());
        requestPermissionButton.innerText
            = strings_1.Html5QrcodeScannerStrings.cameraPermissionTitle();
        requestPermissionButton.addEventListener("click", function () {
            requestPermissionButton.disabled = true;
            $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton);
        });
        requestPermissionContainer.appendChild(requestPermissionButton);
    };
    Html5QrcodeScanner.prototype.createPermissionsUi = function (scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        if (scan_type_selector_1.ScanTypeSelector.isCameraScanType(this.currentScanType)
            && this.persistedDataManager.hasCameraPermissions()) {
            permissions_1.CameraPermissions.hasPermissions().then(function (hasPermissions) {
                if (hasPermissions) {
                    $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer);
                }
                else {
                    $this.persistedDataManager.setHasPermission(false);
                    $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
                }
            }).catch(function (_) {
                $this.persistedDataManager.setHasPermission(false);
                $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
            });
            return;
        }
        this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
    };
    Html5QrcodeScanner.prototype.createSectionControlPanel = function () {
        var section = document.getElementById(this.getDashboardSectionId());
        var sectionControlPanel = document.createElement("div");
        section.appendChild(sectionControlPanel);
        var scpCameraScanRegion = document.createElement("div");
        scpCameraScanRegion.id = this.getDashboardSectionCameraScanRegionId();
        scpCameraScanRegion.style.display
            = scan_type_selector_1.ScanTypeSelector.isCameraScanType(this.currentScanType)
                ? "block" : "none";
        sectionControlPanel.appendChild(scpCameraScanRegion);
        var requestPermissionContainer = document.createElement("div");
        requestPermissionContainer.style.textAlign = "center";
        scpCameraScanRegion.appendChild(requestPermissionContainer);
        if (this.scanTypeSelector.isCameraScanRequired()) {
            this.createPermissionsUi(scpCameraScanRegion, requestPermissionContainer);
        }
        this.renderFileScanUi(sectionControlPanel);
    };
    Html5QrcodeScanner.prototype.renderFileScanUi = function (parent) {
        var showOnRender = scan_type_selector_1.ScanTypeSelector.isFileScanType(this.currentScanType);
        var $this = this;
        var onFileSelected = function (file) {
            if (!$this.html5Qrcode) {
                throw "html5Qrcode not defined";
            }
            if (!scan_type_selector_1.ScanTypeSelector.isFileScanType($this.currentScanType)) {
                return;
            }
            $this.setHeaderMessage(strings_1.Html5QrcodeScannerStrings.loadingImage());
            $this.html5Qrcode.scanFileV2(file, true)
                .then(function (html5qrcodeResult) {
                $this.resetHeaderMessage();
                $this.qrCodeSuccessCallback(html5qrcodeResult.decodedText, html5qrcodeResult);
            })
                .catch(function (error) {
                $this.setHeaderMessage(error, Html5QrcodeScannerStatus.STATUS_WARNING);
                $this.qrCodeErrorCallback(error, core_1.Html5QrcodeErrorFactory.createFrom(error));
            });
        };
        this.fileSelectionUi = file_selection_ui_1.FileSelectionUi.create(parent, showOnRender, onFileSelected);
    };
    Html5QrcodeScanner.prototype.renderCameraSelection = function (cameras) {
        var _this = this;
        var $this = this;
        var scpCameraScanRegion = document.getElementById(this.getDashboardSectionCameraScanRegionId());
        scpCameraScanRegion.style.textAlign = "center";
        var cameraZoomUi = camera_zoom_ui_1.CameraZoomUi.create(scpCameraScanRegion, false);
        var renderCameraZoomUiIfSupported = function (cameraCapabilities) {
            var zoomCapability = cameraCapabilities.zoomFeature();
            if (!zoomCapability.isSupported()) {
                return;
            }
            cameraZoomUi.setOnCameraZoomValueChangeCallback(function (zoomValue) {
                zoomCapability.apply(zoomValue);
            });
            var defaultZoom = 1;
            if (_this.config.defaultZoomValueIfSupported) {
                defaultZoom = _this.config.defaultZoomValueIfSupported;
            }
            defaultZoom = (0, core_1.clip)(defaultZoom, zoomCapability.min(), zoomCapability.max());
            cameraZoomUi.setValues(zoomCapability.min(), zoomCapability.max(), defaultZoom, zoomCapability.step());
            cameraZoomUi.show();
        };
        var cameraSelectUi = camera_selection_ui_1.CameraSelectionUi.create(scpCameraScanRegion, cameras);
        var cameraActionContainer = document.createElement("span");
        var cameraActionStartButton = base_1.BaseUiElementFactory.createElement("button", base_1.PublicUiElementIdAndClasses.CAMERA_START_BUTTON_ID);
        cameraActionStartButton.innerText
            = strings_1.Html5QrcodeScannerStrings.scanButtonStartScanningText();
        cameraActionContainer.appendChild(cameraActionStartButton);
        var cameraActionStopButton = base_1.BaseUiElementFactory.createElement("button", base_1.PublicUiElementIdAndClasses.CAMERA_STOP_BUTTON_ID);
        cameraActionStopButton.innerText
            = strings_1.Html5QrcodeScannerStrings.scanButtonStopScanningText();
        cameraActionStopButton.style.display = "none";
        cameraActionStopButton.disabled = true;
        cameraActionContainer.appendChild(cameraActionStopButton);
        var torchButton;
        var createAndShowTorchButtonIfSupported = function (cameraCapabilities) {
            if (!cameraCapabilities.torchFeature().isSupported()) {
                if (torchButton) {
                    torchButton.hide();
                }
                return;
            }
            if (!torchButton) {
                torchButton = torch_button_1.TorchButton.create(cameraActionContainer, cameraCapabilities.torchFeature(), { display: "none", marginLeft: "5px" }, function (errorMessage) {
                    $this.setHeaderMessage(errorMessage, Html5QrcodeScannerStatus.STATUS_WARNING);
                });
            }
            else {
                torchButton.updateTorchCapability(cameraCapabilities.torchFeature());
            }
            torchButton.show();
        };
        scpCameraScanRegion.appendChild(cameraActionContainer);
        var resetCameraActionStartButton = function (shouldShow) {
            if (!shouldShow) {
                cameraActionStartButton.style.display = "none";
            }
            cameraActionStartButton.innerText
                = strings_1.Html5QrcodeScannerStrings
                    .scanButtonStartScanningText();
            cameraActionStartButton.style.opacity = "1";
            cameraActionStartButton.disabled = false;
            if (shouldShow) {
                cameraActionStartButton.style.display = "inline-block";
            }
        };
        cameraActionStartButton.addEventListener("click", function (_) {
            cameraActionStartButton.innerText
                = strings_1.Html5QrcodeScannerStrings.scanButtonScanningStarting();
            cameraSelectUi.disable();
            cameraActionStartButton.disabled = true;
            cameraActionStartButton.style.opacity = "0.5";
            if (_this.scanTypeSelector.hasMoreThanOneScanType()) {
                $this.showHideScanTypeSwapLink(false);
            }
            $this.resetHeaderMessage();
            var cameraId = cameraSelectUi.getValue();
            $this.persistedDataManager.setLastUsedCameraId(cameraId);
            $this.html5Qrcode.start(cameraId, toHtml5QrcodeCameraScanConfig($this.config), $this.qrCodeSuccessCallback, $this.qrCodeErrorCallback)
                .then(function (_) {
                cameraActionStopButton.disabled = false;
                cameraActionStopButton.style.display = "inline-block";
                resetCameraActionStartButton(false);
                var cameraCapabilities = $this.html5Qrcode.getRunningTrackCameraCapabilities();
                if (_this.config.showTorchButtonIfSupported === true) {
                    createAndShowTorchButtonIfSupported(cameraCapabilities);
                }
                if (_this.config.showZoomSliderIfSupported === true) {
                    renderCameraZoomUiIfSupported(cameraCapabilities);
                }
            })
                .catch(function (error) {
                $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                resetCameraActionStartButton(true);
                $this.setHeaderMessage(error, Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if (cameraSelectUi.hasSingleItem()) {
            cameraActionStartButton.click();
        }
        cameraActionStopButton.addEventListener("click", function (_) {
            if (!$this.html5Qrcode) {
                throw "html5Qrcode not defined";
            }
            cameraActionStopButton.disabled = true;
            $this.html5Qrcode.stop()
                .then(function (_) {
                if (_this.scanTypeSelector.hasMoreThanOneScanType()) {
                    $this.showHideScanTypeSwapLink(true);
                }
                cameraSelectUi.enable();
                cameraActionStartButton.disabled = false;
                cameraActionStopButton.style.display = "none";
                cameraActionStartButton.style.display = "inline-block";
                if (torchButton) {
                    torchButton.reset();
                    torchButton.hide();
                }
                cameraZoomUi.removeOnCameraZoomValueChangeCallback();
                cameraZoomUi.hide();
                $this.insertCameraScanImageToScanRegion();
            }).catch(function (error) {
                cameraActionStopButton.disabled = false;
                $this.setHeaderMessage(error, Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if ($this.persistedDataManager.getLastUsedCameraId()) {
            var cameraId = $this.persistedDataManager.getLastUsedCameraId();
            if (cameraSelectUi.hasValue(cameraId)) {
                cameraSelectUi.setValue(cameraId);
                cameraActionStartButton.click();
            }
            else {
                $this.persistedDataManager.resetLastUsedCameraId();
            }
        }
    };
    Html5QrcodeScanner.prototype.createSectionSwap = function () {
        var $this = this;
        var TEXT_IF_CAMERA_SCAN_SELECTED = strings_1.Html5QrcodeScannerStrings.textIfCameraScanSelected();
        var TEXT_IF_FILE_SCAN_SELECTED = strings_1.Html5QrcodeScannerStrings.textIfFileScanSelected();
        var section = document.getElementById(this.getDashboardSectionId());
        var switchContainer = document.createElement("div");
        switchContainer.style.textAlign = "center";
        var switchScanTypeLink = base_1.BaseUiElementFactory.createElement("span", this.getDashboardSectionSwapLinkId());
        switchScanTypeLink.style.textDecoration = "underline";
        switchScanTypeLink.style.cursor = "pointer";
        switchScanTypeLink.innerText
            = scan_type_selector_1.ScanTypeSelector.isCameraScanType(this.currentScanType)
                ? TEXT_IF_CAMERA_SCAN_SELECTED : TEXT_IF_FILE_SCAN_SELECTED;
        switchScanTypeLink.addEventListener("click", function () {
            if (!$this.sectionSwapAllowed) {
                if ($this.verbose) {
                    $this.logger.logError("Section swap called when not allowed");
                }
                return;
            }
            $this.resetHeaderMessage();
            $this.fileSelectionUi.resetValue();
            $this.sectionSwapAllowed = false;
            if (scan_type_selector_1.ScanTypeSelector.isCameraScanType($this.currentScanType)) {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "none";
                $this.fileSelectionUi.show();
                switchScanTypeLink.innerText = TEXT_IF_FILE_SCAN_SELECTED;
                $this.currentScanType = core_1.Html5QrcodeScanType.SCAN_TYPE_FILE;
                $this.insertFileScanImageToScanRegion();
            }
            else {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "block";
                $this.fileSelectionUi.hide();
                switchScanTypeLink.innerText = TEXT_IF_CAMERA_SCAN_SELECTED;
                $this.currentScanType = core_1.Html5QrcodeScanType.SCAN_TYPE_CAMERA;
                $this.insertCameraScanImageToScanRegion();
                $this.startCameraScanIfPermissionExistsOnSwap();
            }
            $this.sectionSwapAllowed = true;
        });
        switchContainer.appendChild(switchScanTypeLink);
        section.appendChild(switchContainer);
    };
    Html5QrcodeScanner.prototype.startCameraScanIfPermissionExistsOnSwap = function () {
        var _this = this;
        var $this = this;
        if (this.persistedDataManager.hasCameraPermissions()) {
            permissions_1.CameraPermissions.hasPermissions().then(function (hasPermissions) {
                if (hasPermissions) {
                    var permissionButton = document.getElementById($this.getCameraPermissionButtonId());
                    if (!permissionButton) {
                        _this.logger.logError("Permission button not found, fail;");
                        throw "Permission button not found";
                    }
                    permissionButton.click();
                }
                else {
                    $this.persistedDataManager.setHasPermission(false);
                }
            }).catch(function (_) {
                $this.persistedDataManager.setHasPermission(false);
            });
            return;
        }
    };
    Html5QrcodeScanner.prototype.resetHeaderMessage = function () {
        var messageDiv = document.getElementById(this.getHeaderMessageContainerId());
        messageDiv.style.display = "none";
    };
    Html5QrcodeScanner.prototype.setHeaderMessage = function (messageText, scannerStatus) {
        if (!scannerStatus) {
            scannerStatus = Html5QrcodeScannerStatus.STATUS_DEFAULT;
        }
        var messageDiv = this.getHeaderMessageDiv();
        messageDiv.innerText = messageText;
        messageDiv.style.display = "block";
        switch (scannerStatus) {
            case Html5QrcodeScannerStatus.STATUS_SUCCESS:
                messageDiv.style.background = "rgba(106, 175, 80, 0.26)";
                messageDiv.style.color = "#477735";
                break;
            case Html5QrcodeScannerStatus.STATUS_WARNING:
                messageDiv.style.background = "rgba(203, 36, 49, 0.14)";
                messageDiv.style.color = "#cb2431";
                break;
            case Html5QrcodeScannerStatus.STATUS_DEFAULT:
            default:
                messageDiv.style.background = "rgba(0, 0, 0, 0)";
                messageDiv.style.color = "rgb(17, 17, 17)";
                break;
        }
    };
    Html5QrcodeScanner.prototype.showHideScanTypeSwapLink = function (shouldDisplay) {
        if (this.scanTypeSelector.hasMoreThanOneScanType()) {
            if (shouldDisplay !== true) {
                shouldDisplay = false;
            }
            this.sectionSwapAllowed = shouldDisplay;
            this.getDashboardSectionSwapLink().style.display
                = shouldDisplay ? "inline-block" : "none";
        }
    };
    Html5QrcodeScanner.prototype.insertCameraScanImageToScanRegion = function () {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.cameraScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.cameraScanImage);
            return;
        }
        this.cameraScanImage = new Image;
        this.cameraScanImage.onload = function (_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.cameraScanImage);
        };
        this.cameraScanImage.width = 64;
        this.cameraScanImage.style.opacity = "0.8";
        this.cameraScanImage.src = image_assets_1.ASSET_CAMERA_SCAN;
        this.cameraScanImage.alt = strings_1.Html5QrcodeScannerStrings.cameraScanAltText();
    };
    Html5QrcodeScanner.prototype.insertFileScanImageToScanRegion = function () {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.fileScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.fileScanImage);
            return;
        }
        this.fileScanImage = new Image;
        this.fileScanImage.onload = function (_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.fileScanImage);
        };
        this.fileScanImage.width = 64;
        this.fileScanImage.style.opacity = "0.8";
        this.fileScanImage.src = image_assets_1.ASSET_FILE_SCAN;
        this.fileScanImage.alt = strings_1.Html5QrcodeScannerStrings.fileScanAltText();
    };
    Html5QrcodeScanner.prototype.clearScanRegion = function () {
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        qrCodeScanRegion.innerHTML = "";
    };
    Html5QrcodeScanner.prototype.getDashboardSectionId = function () {
        return "".concat(this.elementId, "__dashboard_section");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionCameraScanRegionId = function () {
        return "".concat(this.elementId, "__dashboard_section_csr");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLinkId = function () {
        return base_1.PublicUiElementIdAndClasses.SCAN_TYPE_CHANGE_ANCHOR_ID;
    };
    Html5QrcodeScanner.prototype.getScanRegionId = function () {
        return "".concat(this.elementId, "__scan_region");
    };
    Html5QrcodeScanner.prototype.getDashboardId = function () {
        return "".concat(this.elementId, "__dashboard");
    };
    Html5QrcodeScanner.prototype.getHeaderMessageContainerId = function () {
        return "".concat(this.elementId, "__header_message");
    };
    Html5QrcodeScanner.prototype.getCameraPermissionButtonId = function () {
        return base_1.PublicUiElementIdAndClasses.CAMERA_PERMISSION_BUTTON_ID;
    };
    Html5QrcodeScanner.prototype.getCameraScanRegion = function () {
        return document.getElementById(this.getDashboardSectionCameraScanRegionId());
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLink = function () {
        return document.getElementById(this.getDashboardSectionSwapLinkId());
    };
    Html5QrcodeScanner.prototype.getHeaderMessageDiv = function () {
        return document.getElementById(this.getHeaderMessageContainerId());
    };
    return Html5QrcodeScanner;
}());
exports.Html5QrcodeScanner = Html5QrcodeScanner;

},{"./camera/permissions":472,"./core":475,"./html5-qrcode":477,"./image-assets":478,"./storage":482,"./strings":483,"./ui":484,"./ui/scanner/base":485,"./ui/scanner/camera-selection-ui":486,"./ui/scanner/camera-zoom-ui":487,"./ui/scanner/file-selection-ui":488,"./ui/scanner/scan-type-selector":489,"./ui/scanner/torch-button":490}],477:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Html5Qrcode = void 0;
var core_1 = require("./core");
var strings_1 = require("./strings");
var utils_1 = require("./utils");
var code_decoder_1 = require("./code-decoder");
var factories_1 = require("./camera/factories");
var retriever_1 = require("./camera/retriever");
var state_manager_1 = require("./state-manager");
var Constants = (function (_super) {
    __extends(Constants, _super);
    function Constants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Constants.DEFAULT_WIDTH = 300;
    Constants.DEFAULT_WIDTH_OFFSET = 2;
    Constants.FILE_SCAN_MIN_HEIGHT = 300;
    Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING = 100;
    Constants.MIN_QR_BOX_SIZE = 50;
    Constants.SHADED_LEFT = 1;
    Constants.SHADED_RIGHT = 2;
    Constants.SHADED_TOP = 3;
    Constants.SHADED_BOTTOM = 4;
    Constants.SHADED_REGION_ELEMENT_ID = "qr-shaded-region";
    Constants.VERBOSE = false;
    Constants.BORDER_SHADER_DEFAULT_COLOR = "#ffffff";
    Constants.BORDER_SHADER_MATCH_COLOR = "rgb(90, 193, 56)";
    return Constants;
}(core_1.Html5QrcodeConstants));
var InternalHtml5QrcodeConfig = (function () {
    function InternalHtml5QrcodeConfig(config, logger) {
        this.logger = logger;
        this.fps = Constants.SCAN_DEFAULT_FPS;
        if (!config) {
            this.disableFlip = Constants.DEFAULT_DISABLE_FLIP;
        }
        else {
            if (config.fps) {
                this.fps = config.fps;
            }
            this.disableFlip = config.disableFlip === true;
            this.qrbox = config.qrbox;
            this.aspectRatio = config.aspectRatio;
            this.videoConstraints = config.videoConstraints;
        }
    }
    InternalHtml5QrcodeConfig.prototype.isMediaStreamConstraintsValid = function () {
        if (!this.videoConstraints) {
            this.logger.logError("Empty videoConstraints", true);
            return false;
        }
        return utils_1.VideoConstraintsUtil.isMediaStreamConstraintsValid(this.videoConstraints, this.logger);
    };
    InternalHtml5QrcodeConfig.prototype.isShadedBoxEnabled = function () {
        return !(0, core_1.isNullOrUndefined)(this.qrbox);
    };
    InternalHtml5QrcodeConfig.create = function (config, logger) {
        return new InternalHtml5QrcodeConfig(config, logger);
    };
    return InternalHtml5QrcodeConfig;
}());
var Html5Qrcode = (function () {
    function Html5Qrcode(elementId, configOrVerbosityFlag) {
        this.element = null;
        this.canvasElement = null;
        this.scannerPausedUiElement = null;
        this.hasBorderShaders = null;
        this.borderShaders = null;
        this.qrMatch = null;
        this.renderedCamera = null;
        this.qrRegion = null;
        this.context = null;
        this.lastScanImageFile = null;
        this.isScanning = false;
        if (!document.getElementById(elementId)) {
            throw "HTML Element with id=".concat(elementId, " not found");
        }
        this.elementId = elementId;
        this.verbose = false;
        var experimentalFeatureConfig;
        var configObject;
        if (typeof configOrVerbosityFlag == "boolean") {
            this.verbose = configOrVerbosityFlag === true;
        }
        else if (configOrVerbosityFlag) {
            configObject = configOrVerbosityFlag;
            this.verbose = configObject.verbose === true;
            experimentalFeatureConfig = configObject.experimentalFeatures;
        }
        this.logger = new core_1.BaseLoggger(this.verbose);
        this.qrcode = new code_decoder_1.Html5QrcodeShim(this.getSupportedFormats(configOrVerbosityFlag), this.getUseBarCodeDetectorIfSupported(configObject), this.verbose, this.logger);
        this.foreverScanTimeout;
        this.shouldScan = true;
        this.stateManagerProxy = state_manager_1.StateManagerFactory.create();
    }
    Html5Qrcode.prototype.start = function (cameraIdOrConfig, configuration, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!cameraIdOrConfig) {
            throw "cameraIdOrConfig is required";
        }
        if (!qrCodeSuccessCallback
            || typeof qrCodeSuccessCallback != "function") {
            throw "qrCodeSuccessCallback is required and should be a function.";
        }
        var qrCodeErrorCallbackInternal;
        if (qrCodeErrorCallback) {
            qrCodeErrorCallbackInternal = qrCodeErrorCallback;
        }
        else {
            qrCodeErrorCallbackInternal
                = this.verbose ? this.logger.log : function () { };
        }
        var internalConfig = InternalHtml5QrcodeConfig.create(configuration, this.logger);
        this.clearElement();
        var videoConstraintsAvailableAndValid = false;
        if (internalConfig.videoConstraints) {
            if (!internalConfig.isMediaStreamConstraintsValid()) {
                this.logger.logError("'videoConstraints' is not valid 'MediaStreamConstraints, "
                    + "it will be ignored.'", true);
            }
            else {
                videoConstraintsAvailableAndValid = true;
            }
        }
        var areVideoConstraintsEnabled = videoConstraintsAvailableAndValid;
        var element = document.getElementById(this.elementId);
        var rootElementWidth = element.clientWidth
            ? element.clientWidth : Constants.DEFAULT_WIDTH;
        element.style.position = "relative";
        this.shouldScan = true;
        this.element = element;
        var $this = this;
        var toScanningStateChangeTransaction = this.stateManagerProxy.startTransition(state_manager_1.Html5QrcodeScannerState.SCANNING);
        return new Promise(function (resolve, reject) {
            var videoConstraints = areVideoConstraintsEnabled
                ? internalConfig.videoConstraints
                : $this.createVideoConstraints(cameraIdOrConfig);
            if (!videoConstraints) {
                toScanningStateChangeTransaction.cancel();
                reject("videoConstraints should be defined");
                return;
            }
            var cameraRenderingOptions = {};
            if (!areVideoConstraintsEnabled || internalConfig.aspectRatio) {
                cameraRenderingOptions.aspectRatio = internalConfig.aspectRatio;
            }
            var renderingCallbacks = {
                onRenderSurfaceReady: function (viewfinderWidth, viewfinderHeight) {
                    $this.setupUi(viewfinderWidth, viewfinderHeight, internalConfig);
                    $this.isScanning = true;
                    $this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallbackInternal);
                }
            };
            factories_1.CameraFactory.failIfNotSupported().then(function (factory) {
                factory.create(videoConstraints).then(function (camera) {
                    return camera.render(_this.element, cameraRenderingOptions, renderingCallbacks)
                        .then(function (renderedCamera) {
                        $this.renderedCamera = renderedCamera;
                        toScanningStateChangeTransaction.execute();
                        resolve(null);
                    })
                        .catch(function (error) {
                        toScanningStateChangeTransaction.cancel();
                        reject(error);
                    });
                }).catch(function (error) {
                    toScanningStateChangeTransaction.cancel();
                    reject(strings_1.Html5QrcodeStrings.errorGettingUserMedia(error));
                });
            }).catch(function (_) {
                toScanningStateChangeTransaction.cancel();
                reject(strings_1.Html5QrcodeStrings.cameraStreamingNotSupported());
            });
        });
    };
    Html5Qrcode.prototype.pause = function (shouldPauseVideo) {
        if (!this.stateManagerProxy.isStrictlyScanning()) {
            throw "Cannot pause, scanner is not scanning.";
        }
        this.stateManagerProxy.directTransition(state_manager_1.Html5QrcodeScannerState.PAUSED);
        this.showPausedState();
        if ((0, core_1.isNullOrUndefined)(shouldPauseVideo) || shouldPauseVideo !== true) {
            shouldPauseVideo = false;
        }
        if (shouldPauseVideo && this.renderedCamera) {
            this.renderedCamera.pause();
        }
    };
    Html5Qrcode.prototype.resume = function () {
        if (!this.stateManagerProxy.isPaused()) {
            throw "Cannot result, scanner is not paused.";
        }
        if (!this.renderedCamera) {
            throw "renderedCamera doesn't exist while trying resume()";
        }
        var $this = this;
        var transitionToScanning = function () {
            $this.stateManagerProxy.directTransition(state_manager_1.Html5QrcodeScannerState.SCANNING);
            $this.hidePausedState();
        };
        if (!this.renderedCamera.isPaused()) {
            transitionToScanning();
            return;
        }
        this.renderedCamera.resume(function () {
            transitionToScanning();
        });
    };
    Html5Qrcode.prototype.getState = function () {
        return this.stateManagerProxy.getState();
    };
    Html5Qrcode.prototype.stop = function () {
        var _this = this;
        if (!this.stateManagerProxy.isScanning()) {
            throw "Cannot stop, scanner is not running or paused.";
        }
        var toStoppedStateTransaction = this.stateManagerProxy.startTransition(state_manager_1.Html5QrcodeScannerState.NOT_STARTED);
        this.shouldScan = false;
        if (this.foreverScanTimeout) {
            clearTimeout(this.foreverScanTimeout);
        }
        var removeQrRegion = function () {
            if (!_this.element) {
                return;
            }
            var childElement = document.getElementById(Constants.SHADED_REGION_ELEMENT_ID);
            if (childElement) {
                _this.element.removeChild(childElement);
            }
        };
        var $this = this;
        return this.renderedCamera.close().then(function () {
            $this.renderedCamera = null;
            if ($this.element) {
                $this.element.removeChild($this.canvasElement);
                $this.canvasElement = null;
            }
            removeQrRegion();
            if ($this.qrRegion) {
                $this.qrRegion = null;
            }
            if ($this.context) {
                $this.context = null;
            }
            toStoppedStateTransaction.execute();
            $this.hidePausedState();
            $this.isScanning = false;
            return Promise.resolve();
        });
    };
    Html5Qrcode.prototype.scanFile = function (imageFile, showImage) {
        return this.scanFileV2(imageFile, showImage)
            .then(function (html5qrcodeResult) { return html5qrcodeResult.decodedText; });
    };
    Html5Qrcode.prototype.scanFileV2 = function (imageFile, showImage) {
        var _this = this;
        if (!imageFile || !(imageFile instanceof File)) {
            throw "imageFile argument is mandatory and should be instance "
                + "of File. Use 'event.target.files[0]'.";
        }
        if ((0, core_1.isNullOrUndefined)(showImage)) {
            showImage = true;
        }
        if (!this.stateManagerProxy.canScanFile()) {
            throw "Cannot start file scan - ongoing camera scan";
        }
        return new Promise(function (resolve, reject) {
            _this.possiblyCloseLastScanImageFile();
            _this.clearElement();
            _this.lastScanImageFile = URL.createObjectURL(imageFile);
            var inputImage = new Image;
            inputImage.onload = function () {
                var imageWidth = inputImage.width;
                var imageHeight = inputImage.height;
                var element = document.getElementById(_this.elementId);
                var containerWidth = element.clientWidth
                    ? element.clientWidth : Constants.DEFAULT_WIDTH;
                var containerHeight = Math.max(element.clientHeight ? element.clientHeight : imageHeight, Constants.FILE_SCAN_MIN_HEIGHT);
                var config = _this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
                if (showImage) {
                    var visibleCanvas = _this.createCanvasElement(containerWidth, containerHeight, "qr-canvas-visible");
                    visibleCanvas.style.display = "inline-block";
                    element.appendChild(visibleCanvas);
                    var context_1 = visibleCanvas.getContext("2d");
                    if (!context_1) {
                        throw "Unable to get 2d context from canvas";
                    }
                    context_1.canvas.width = containerWidth;
                    context_1.canvas.height = containerHeight;
                    context_1.drawImage(inputImage, 0, 0, imageWidth, imageHeight, config.x, config.y, config.width, config.height);
                }
                var padding = Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING;
                var hiddenImageWidth = Math.max(inputImage.width, config.width);
                var hiddenImageHeight = Math.max(inputImage.height, config.height);
                var hiddenCanvasWidth = hiddenImageWidth + 2 * padding;
                var hiddenCanvasHeight = hiddenImageHeight + 2 * padding;
                var hiddenCanvas = _this.createCanvasElement(hiddenCanvasWidth, hiddenCanvasHeight);
                element.appendChild(hiddenCanvas);
                var context = hiddenCanvas.getContext("2d");
                if (!context) {
                    throw "Unable to get 2d context from canvas";
                }
                context.canvas.width = hiddenCanvasWidth;
                context.canvas.height = hiddenCanvasHeight;
                context.drawImage(inputImage, 0, 0, imageWidth, imageHeight, padding, padding, hiddenImageWidth, hiddenImageHeight);
                try {
                    _this.qrcode.decodeRobustlyAsync(hiddenCanvas)
                        .then(function (result) {
                        resolve(core_1.Html5QrcodeResultFactory.createFromQrcodeResult(result));
                    })
                        .catch(reject);
                }
                catch (exception) {
                    reject("QR code parse error, error = ".concat(exception));
                }
            };
            inputImage.onerror = reject;
            inputImage.onabort = reject;
            inputImage.onstalled = reject;
            inputImage.onsuspend = reject;
            inputImage.src = URL.createObjectURL(imageFile);
        });
    };
    Html5Qrcode.prototype.clear = function () {
        this.clearElement();
    };
    Html5Qrcode.getCameras = function () {
        return retriever_1.CameraRetriever.retrieve();
    };
    Html5Qrcode.prototype.getRunningTrackCapabilities = function () {
        return this.getRenderedCameraOrFail().getRunningTrackCapabilities();
    };
    Html5Qrcode.prototype.getRunningTrackSettings = function () {
        return this.getRenderedCameraOrFail().getRunningTrackSettings();
    };
    Html5Qrcode.prototype.getRunningTrackCameraCapabilities = function () {
        return this.getRenderedCameraOrFail().getCapabilities();
    };
    Html5Qrcode.prototype.applyVideoConstraints = function (videoConstaints) {
        if (!videoConstaints) {
            throw "videoConstaints is required argument.";
        }
        else if (!utils_1.VideoConstraintsUtil.isMediaStreamConstraintsValid(videoConstaints, this.logger)) {
            throw "invalid videoConstaints passed, check logs for more details";
        }
        return this.getRenderedCameraOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5Qrcode.prototype.getRenderedCameraOrFail = function () {
        if (this.renderedCamera == null) {
            throw "Scanning is not in running state, call this API only when"
                + " QR code scanning using camera is in running state.";
        }
        return this.renderedCamera;
    };
    Html5Qrcode.prototype.getSupportedFormats = function (configOrVerbosityFlag) {
        var allFormats = [
            core_1.Html5QrcodeSupportedFormats.QR_CODE,
            core_1.Html5QrcodeSupportedFormats.AZTEC,
            core_1.Html5QrcodeSupportedFormats.CODABAR,
            core_1.Html5QrcodeSupportedFormats.CODE_39,
            core_1.Html5QrcodeSupportedFormats.CODE_93,
            core_1.Html5QrcodeSupportedFormats.CODE_128,
            core_1.Html5QrcodeSupportedFormats.DATA_MATRIX,
            core_1.Html5QrcodeSupportedFormats.MAXICODE,
            core_1.Html5QrcodeSupportedFormats.ITF,
            core_1.Html5QrcodeSupportedFormats.EAN_13,
            core_1.Html5QrcodeSupportedFormats.EAN_8,
            core_1.Html5QrcodeSupportedFormats.PDF_417,
            core_1.Html5QrcodeSupportedFormats.RSS_14,
            core_1.Html5QrcodeSupportedFormats.RSS_EXPANDED,
            core_1.Html5QrcodeSupportedFormats.UPC_A,
            core_1.Html5QrcodeSupportedFormats.UPC_E,
            core_1.Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
        ];
        if (!configOrVerbosityFlag
            || typeof configOrVerbosityFlag == "boolean") {
            return allFormats;
        }
        if (!configOrVerbosityFlag.formatsToSupport) {
            return allFormats;
        }
        if (!Array.isArray(configOrVerbosityFlag.formatsToSupport)) {
            throw "configOrVerbosityFlag.formatsToSupport should be undefined "
                + "or an array.";
        }
        if (configOrVerbosityFlag.formatsToSupport.length === 0) {
            throw "Atleast 1 formatsToSupport is needed.";
        }
        var supportedFormats = [];
        for (var _i = 0, _a = configOrVerbosityFlag.formatsToSupport; _i < _a.length; _i++) {
            var format = _a[_i];
            if ((0, core_1.isValidHtml5QrcodeSupportedFormats)(format)) {
                supportedFormats.push(format);
            }
            else {
                this.logger.warn("Invalid format: ".concat(format, " passed in config, ignoring."));
            }
        }
        if (supportedFormats.length === 0) {
            throw "None of formatsToSupport match supported values.";
        }
        return supportedFormats;
    };
    Html5Qrcode.prototype.getUseBarCodeDetectorIfSupported = function (config) {
        if ((0, core_1.isNullOrUndefined)(config)) {
            return true;
        }
        if (!(0, core_1.isNullOrUndefined)(config.useBarCodeDetectorIfSupported)) {
            return config.useBarCodeDetectorIfSupported !== false;
        }
        if ((0, core_1.isNullOrUndefined)(config.experimentalFeatures)) {
            return true;
        }
        var experimentalFeatures = config.experimentalFeatures;
        if ((0, core_1.isNullOrUndefined)(experimentalFeatures.useBarCodeDetectorIfSupported)) {
            return true;
        }
        return experimentalFeatures.useBarCodeDetectorIfSupported !== false;
    };
    Html5Qrcode.prototype.validateQrboxSize = function (viewfinderWidth, viewfinderHeight, internalConfig) {
        var _this = this;
        var qrboxSize = internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        var validateMinSize = function (size) {
            if (size < Constants.MIN_QR_BOX_SIZE) {
                throw "minimum size of 'config.qrbox' dimension value is"
                    + " ".concat(Constants.MIN_QR_BOX_SIZE, "px.");
            }
        };
        var correctWidthBasedOnRootElementSize = function (configWidth) {
            if (configWidth > viewfinderWidth) {
                _this.logger.warn("`qrbox.width` or `qrbox` is larger than the"
                    + " width of the root element. The width will be truncated"
                    + " to the width of root element.");
                configWidth = viewfinderWidth;
            }
            return configWidth;
        };
        validateMinSize(qrDimensions.width);
        validateMinSize(qrDimensions.height);
        qrDimensions.width = correctWidthBasedOnRootElementSize(qrDimensions.width);
    };
    Html5Qrcode.prototype.validateQrboxConfig = function (qrboxSize) {
        if (typeof qrboxSize === "number") {
            return;
        }
        if (typeof qrboxSize === "function") {
            return;
        }
        if (qrboxSize.width === undefined || qrboxSize.height === undefined) {
            throw "Invalid instance of QrDimensions passed for "
                + "'config.qrbox'. Both 'width' and 'height' should be set.";
        }
    };
    Html5Qrcode.prototype.toQrdimensions = function (viewfinderWidth, viewfinderHeight, qrboxSize) {
        if (typeof qrboxSize === "number") {
            return { width: qrboxSize, height: qrboxSize };
        }
        else if (typeof qrboxSize === "function") {
            try {
                return qrboxSize(viewfinderWidth, viewfinderHeight);
            }
            catch (error) {
                throw new Error("qrbox config was passed as a function but it failed with "
                    + "unknown error" + error);
            }
        }
        return qrboxSize;
    };
    Html5Qrcode.prototype.setupUi = function (viewfinderWidth, viewfinderHeight, internalConfig) {
        if (internalConfig.isShadedBoxEnabled()) {
            this.validateQrboxSize(viewfinderWidth, viewfinderHeight, internalConfig);
        }
        var qrboxSize = (0, core_1.isNullOrUndefined)(internalConfig.qrbox) ?
            { width: viewfinderWidth, height: viewfinderHeight } : internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        if (qrDimensions.height > viewfinderHeight) {
            this.logger.warn("[Html5Qrcode] config.qrbox has height that is"
                + "greater than the height of the video stream. Shading will be"
                + " ignored");
        }
        var shouldShadingBeApplied = internalConfig.isShadedBoxEnabled()
            && qrDimensions.height <= viewfinderHeight;
        var defaultQrRegion = {
            x: 0,
            y: 0,
            width: viewfinderWidth,
            height: viewfinderHeight
        };
        var qrRegion = shouldShadingBeApplied
            ? this.getShadedRegionBounds(viewfinderWidth, viewfinderHeight, qrDimensions)
            : defaultQrRegion;
        var canvasElement = this.createCanvasElement(qrRegion.width, qrRegion.height);
        var contextAttributes = { willReadFrequently: true };
        var context = canvasElement.getContext("2d", contextAttributes);
        context.canvas.width = qrRegion.width;
        context.canvas.height = qrRegion.height;
        this.element.append(canvasElement);
        if (shouldShadingBeApplied) {
            this.possiblyInsertShadingElement(this.element, viewfinderWidth, viewfinderHeight, qrDimensions);
        }
        this.createScannerPausedUiElement(this.element);
        this.qrRegion = qrRegion;
        this.context = context;
        this.canvasElement = canvasElement;
    };
    Html5Qrcode.prototype.createScannerPausedUiElement = function (rootElement) {
        var scannerPausedUiElement = document.createElement("div");
        scannerPausedUiElement.innerText = strings_1.Html5QrcodeStrings.scannerPaused();
        scannerPausedUiElement.style.display = "none";
        scannerPausedUiElement.style.position = "absolute";
        scannerPausedUiElement.style.top = "0px";
        scannerPausedUiElement.style.zIndex = "1";
        scannerPausedUiElement.style.background = "rgba(9, 9, 9, 0.46)";
        scannerPausedUiElement.style.color = "#FFECEC";
        scannerPausedUiElement.style.textAlign = "center";
        scannerPausedUiElement.style.width = "100%";
        rootElement.appendChild(scannerPausedUiElement);
        this.scannerPausedUiElement = scannerPausedUiElement;
    };
    Html5Qrcode.prototype.scanContext = function (qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (this.stateManagerProxy.isPaused()) {
            return Promise.resolve(false);
        }
        return this.qrcode.decodeAsync(this.canvasElement)
            .then(function (result) {
            qrCodeSuccessCallback(result.text, core_1.Html5QrcodeResultFactory.createFromQrcodeResult(result));
            _this.possiblyUpdateShaders(true);
            return true;
        }).catch(function (error) {
            _this.possiblyUpdateShaders(false);
            var errorMessage = strings_1.Html5QrcodeStrings.codeParseError(error);
            qrCodeErrorCallback(errorMessage, core_1.Html5QrcodeErrorFactory.createFrom(errorMessage));
            return false;
        });
    };
    Html5Qrcode.prototype.foreverScan = function (internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!this.shouldScan) {
            return;
        }
        if (!this.renderedCamera) {
            return;
        }
        var videoElement = this.renderedCamera.getSurface();
        var widthRatio = videoElement.videoWidth / videoElement.clientWidth;
        var heightRatio = videoElement.videoHeight / videoElement.clientHeight;
        if (!this.qrRegion) {
            throw "qrRegion undefined when localMediaStream is ready.";
        }
        var sWidthOffset = this.qrRegion.width * widthRatio;
        var sHeightOffset = this.qrRegion.height * heightRatio;
        var sxOffset = this.qrRegion.x * widthRatio;
        var syOffset = this.qrRegion.y * heightRatio;
        this.context.drawImage(videoElement, sxOffset, syOffset, sWidthOffset, sHeightOffset, 0, 0, this.qrRegion.width, this.qrRegion.height);
        var triggerNextScan = function () {
            _this.foreverScanTimeout = setTimeout(function () {
                _this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback);
            }, _this.getTimeoutFps(internalConfig.fps));
        };
        this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback)
            .then(function (isSuccessfull) {
            if (!isSuccessfull && internalConfig.disableFlip !== true) {
                _this.context.translate(_this.context.canvas.width, 0);
                _this.context.scale(-1, 1);
                _this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback)
                    .finally(function () {
                    triggerNextScan();
                });
            }
            else {
                triggerNextScan();
            }
        }).catch(function (error) {
            _this.logger.logError("Error happend while scanning context", error);
            triggerNextScan();
        });
    };
    Html5Qrcode.prototype.createVideoConstraints = function (cameraIdOrConfig) {
        if (typeof cameraIdOrConfig == "string") {
            return { deviceId: { exact: cameraIdOrConfig } };
        }
        else if (typeof cameraIdOrConfig == "object") {
            var facingModeKey = "facingMode";
            var deviceIdKey = "deviceId";
            var allowedFacingModeValues_1 = { "user": true, "environment": true };
            var exactKey = "exact";
            var isValidFacingModeValue = function (value) {
                if (value in allowedFacingModeValues_1) {
                    return true;
                }
                else {
                    throw "config has invalid 'facingMode' value = "
                        + "'".concat(value, "'");
                }
            };
            var keys = Object.keys(cameraIdOrConfig);
            if (keys.length !== 1) {
                throw "'cameraIdOrConfig' object should have exactly 1 key,"
                    + " if passed as an object, found ".concat(keys.length, " keys");
            }
            var key = Object.keys(cameraIdOrConfig)[0];
            if (key !== facingModeKey && key !== deviceIdKey) {
                throw "Only '".concat(facingModeKey, "' and '").concat(deviceIdKey, "' ")
                    + " are supported for 'cameraIdOrConfig'";
            }
            if (key === facingModeKey) {
                var facingMode = cameraIdOrConfig.facingMode;
                if (typeof facingMode == "string") {
                    if (isValidFacingModeValue(facingMode)) {
                        return { facingMode: facingMode };
                    }
                }
                else if (typeof facingMode == "object") {
                    if (exactKey in facingMode) {
                        if (isValidFacingModeValue(facingMode["".concat(exactKey)])) {
                            return {
                                facingMode: {
                                    exact: facingMode["".concat(exactKey)]
                                }
                            };
                        }
                    }
                    else {
                        throw "'facingMode' should be string or object with"
                            + " ".concat(exactKey, " as key.");
                    }
                }
                else {
                    var type_1 = (typeof facingMode);
                    throw "Invalid type of 'facingMode' = ".concat(type_1);
                }
            }
            else {
                var deviceId = cameraIdOrConfig.deviceId;
                if (typeof deviceId == "string") {
                    return { deviceId: deviceId };
                }
                else if (typeof deviceId == "object") {
                    if (exactKey in deviceId) {
                        return {
                            deviceId: { exact: deviceId["".concat(exactKey)] }
                        };
                    }
                    else {
                        throw "'deviceId' should be string or object with"
                            + " ".concat(exactKey, " as key.");
                    }
                }
                else {
                    var type_2 = (typeof deviceId);
                    throw "Invalid type of 'deviceId' = ".concat(type_2);
                }
            }
        }
        var type = (typeof cameraIdOrConfig);
        throw "Invalid type of 'cameraIdOrConfig' = ".concat(type);
    };
    Html5Qrcode.prototype.computeCanvasDrawConfig = function (imageWidth, imageHeight, containerWidth, containerHeight) {
        if (imageWidth <= containerWidth
            && imageHeight <= containerHeight) {
            var xoffset = (containerWidth - imageWidth) / 2;
            var yoffset = (containerHeight - imageHeight) / 2;
            return {
                x: xoffset,
                y: yoffset,
                width: imageWidth,
                height: imageHeight
            };
        }
        else {
            var formerImageWidth = imageWidth;
            var formerImageHeight = imageHeight;
            if (imageWidth > containerWidth) {
                imageHeight = (containerWidth / imageWidth) * imageHeight;
                imageWidth = containerWidth;
            }
            if (imageHeight > containerHeight) {
                imageWidth = (containerHeight / imageHeight) * imageWidth;
                imageHeight = containerHeight;
            }
            this.logger.log("Image downsampled from "
                + "".concat(formerImageWidth, "X").concat(formerImageHeight)
                + " to ".concat(imageWidth, "X").concat(imageHeight, "."));
            return this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
        }
    };
    Html5Qrcode.prototype.clearElement = function () {
        if (this.stateManagerProxy.isScanning()) {
            throw "Cannot clear while scan is ongoing, close it first.";
        }
        var element = document.getElementById(this.elementId);
        if (element) {
            element.innerHTML = "";
        }
    };
    Html5Qrcode.prototype.possiblyUpdateShaders = function (qrMatch) {
        if (this.qrMatch === qrMatch) {
            return;
        }
        if (this.hasBorderShaders
            && this.borderShaders
            && this.borderShaders.length) {
            this.borderShaders.forEach(function (shader) {
                shader.style.backgroundColor = qrMatch
                    ? Constants.BORDER_SHADER_MATCH_COLOR
                    : Constants.BORDER_SHADER_DEFAULT_COLOR;
            });
        }
        this.qrMatch = qrMatch;
    };
    Html5Qrcode.prototype.possiblyCloseLastScanImageFile = function () {
        if (this.lastScanImageFile) {
            URL.revokeObjectURL(this.lastScanImageFile);
            this.lastScanImageFile = null;
        }
    };
    Html5Qrcode.prototype.createCanvasElement = function (width, height, customId) {
        var canvasWidth = width;
        var canvasHeight = height;
        var canvasElement = document.createElement("canvas");
        canvasElement.style.width = "".concat(canvasWidth, "px");
        canvasElement.style.height = "".concat(canvasHeight, "px");
        canvasElement.style.display = "none";
        canvasElement.id = (0, core_1.isNullOrUndefined)(customId)
            ? "qr-canvas" : customId;
        return canvasElement;
    };
    Html5Qrcode.prototype.getShadedRegionBounds = function (width, height, qrboxSize) {
        if (qrboxSize.width > width || qrboxSize.height > height) {
            throw "'config.qrbox' dimensions should not be greater than the "
                + "dimensions of the root HTML element.";
        }
        return {
            x: (width - qrboxSize.width) / 2,
            y: (height - qrboxSize.height) / 2,
            width: qrboxSize.width,
            height: qrboxSize.height
        };
    };
    Html5Qrcode.prototype.possiblyInsertShadingElement = function (element, width, height, qrboxSize) {
        if ((width - qrboxSize.width) < 1 || (height - qrboxSize.height) < 1) {
            return;
        }
        var shadingElement = document.createElement("div");
        shadingElement.style.position = "absolute";
        var rightLeftBorderSize = (width - qrboxSize.width) / 2;
        var topBottomBorderSize = (height - qrboxSize.height) / 2;
        shadingElement.style.borderLeft
            = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderRight
            = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderTop
            = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderBottom
            = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.boxSizing = "border-box";
        shadingElement.style.top = "0px";
        shadingElement.style.bottom = "0px";
        shadingElement.style.left = "0px";
        shadingElement.style.right = "0px";
        shadingElement.id = "".concat(Constants.SHADED_REGION_ELEMENT_ID);
        if ((width - qrboxSize.width) < 11
            || (height - qrboxSize.height) < 11) {
            this.hasBorderShaders = false;
        }
        else {
            var smallSize = 5;
            var largeSize = 40;
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, false);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, false);
            this.hasBorderShaders = true;
        }
        element.append(shadingElement);
    };
    Html5Qrcode.prototype.insertShaderBorders = function (shaderElem, width, height, top, bottom, side, isLeft) {
        var elem = document.createElement("div");
        elem.style.position = "absolute";
        elem.style.backgroundColor = Constants.BORDER_SHADER_DEFAULT_COLOR;
        elem.style.width = "".concat(width, "px");
        elem.style.height = "".concat(height, "px");
        if (top !== null) {
            elem.style.top = "".concat(top, "px");
        }
        if (bottom !== null) {
            elem.style.bottom = "".concat(bottom, "px");
        }
        if (isLeft) {
            elem.style.left = "".concat(side, "px");
        }
        else {
            elem.style.right = "".concat(side, "px");
        }
        if (!this.borderShaders) {
            this.borderShaders = [];
        }
        this.borderShaders.push(elem);
        shaderElem.appendChild(elem);
    };
    Html5Qrcode.prototype.showPausedState = function () {
        if (!this.scannerPausedUiElement) {
            throw "[internal error] scanner paused UI element not found";
        }
        this.scannerPausedUiElement.style.display = "block";
    };
    Html5Qrcode.prototype.hidePausedState = function () {
        if (!this.scannerPausedUiElement) {
            throw "[internal error] scanner paused UI element not found";
        }
        this.scannerPausedUiElement.style.display = "none";
    };
    Html5Qrcode.prototype.getTimeoutFps = function (fps) {
        return 1000 / fps;
    };
    return Html5Qrcode;
}());
exports.Html5Qrcode = Html5Qrcode;

},{"./camera/factories":471,"./camera/retriever":473,"./code-decoder":474,"./core":475,"./state-manager":481,"./strings":483,"./utils":491}],478:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_CLOSE_ICON_16PX = exports.ASSET_INFO_ICON_16PX = exports.ASSET_FILE_SCAN = exports.ASSET_CAMERA_SCAN = void 0;
var SVG_XML_PREFIX = "data:image/svg+xml;base64,";
exports.ASSET_CAMERA_SCAN = SVG_XML_PREFIX + "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";
exports.ASSET_FILE_SCAN = SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OS4wMTggNTkuMDE4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1OS4wMTggNTkuMDE4IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJtNTguNzQxIDU0LjgwOS01Ljk2OS02LjI0NGExMC43NCAxMC43NCAwIDAgMCAyLjgyLTcuMjVjMC01Ljk1My00Ljg0My0xMC43OTYtMTAuNzk2LTEwLjc5NlMzNCAzNS4zNjEgMzQgNDEuMzE0IDM4Ljg0MyA1Mi4xMSA0NC43OTYgNTIuMTFjMi40NDEgMCA0LjY4OC0uODI0IDYuNDk5LTIuMTk2bDYuMDAxIDYuMjc3YS45OTguOTk4IDAgMCAwIDEuNDE0LjAzMiAxIDEgMCAwIDAgLjAzMS0xLjQxNHpNMzYgNDEuMzE0YzAtNC44NSAzLjk0Ni04Ljc5NiA4Ljc5Ni04Ljc5NnM4Ljc5NiAzLjk0NiA4Ljc5NiA4Ljc5Ni0zLjk0NiA4Ljc5Ni04Ljc5NiA4Ljc5NlMzNiA0Ni4xNjQgMzYgNDEuMzE0ek0xMC40MzEgMTYuMDg4YzAgMy4wNyAyLjQ5OCA1LjU2OCA1LjU2OSA1LjU2OHM1LjU2OS0yLjQ5OCA1LjU2OS01LjU2OGMwLTMuMDcxLTIuNDk4LTUuNTY5LTUuNTY5LTUuNTY5cy01LjU2OSAyLjQ5OC01LjU2OSA1LjU2OXptOS4xMzggMGMwIDEuOTY4LTEuNjAyIDMuNTY4LTMuNTY5IDMuNTY4cy0zLjU2OS0xLjYwMS0zLjU2OS0zLjU2OCAxLjYwMi0zLjU2OSAzLjU2OS0zLjU2OSAzLjU2OSAxLjYwMSAzLjU2OSAzLjU2OXoiLz48cGF0aCBkPSJtMzAuODgyIDI4Ljk4NyA5LjE4LTEwLjA1NCAxMS4yNjIgMTAuMzIzYTEgMSAwIDAgMCAxLjM1MS0xLjQ3NWwtMTItMTFhMSAxIDAgMCAwLTEuNDE0LjA2M2wtOS43OTQgMTAuNzI3LTQuNzQzLTQuNzQzYTEuMDAzIDEuMDAzIDAgMCAwLTEuMzY4LS4wNDRMNi4zMzkgMzcuNzY4YTEgMSAwIDEgMCAxLjMyMiAxLjUwMWwxNi4zMTMtMTQuMzYyIDcuMzE5IDcuMzE4YS45OTkuOTk5IDAgMSAwIDEuNDE0LTEuNDE0bC0xLjgyNS0xLjgyNHoiLz48cGF0aCBkPSJNMzAgNDYuNTE4SDJ2LTQyaDU0djI4YTEgMSAwIDEgMCAyIDB2LTI5YTEgMSAwIDAgMC0xLTFIMWExIDEgMCAwIDAtMSAxdjQ0YTEgMSAwIDAgMCAxIDFoMjlhMSAxIDAgMSAwIDAtMnoiLz48L3N2Zz4=";
exports.ASSET_INFO_ICON_16PX = SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NjAgNDYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NjAgNDYwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjMwIDBDMTAyLjk3NSAwIDAgMTAyLjk3NSAwIDIzMHMxMDIuOTc1IDIzMCAyMzAgMjMwIDIzMC0xMDIuOTc0IDIzMC0yMzBTMzU3LjAyNSAwIDIzMCAwem0zOC4zMzMgMzc3LjM2YzAgOC42NzYtNy4wMzQgMTUuNzEtMTUuNzEgMTUuNzFoLTQzLjEwMWMtOC42NzYgMC0xNS43MS03LjAzNC0xNS43MS0xNS43MVYyMDIuNDc3YzAtOC42NzYgNy4wMzMtMTUuNzEgMTUuNzEtMTUuNzFoNDMuMTAxYzguNjc2IDAgMTUuNzEgNy4wMzMgMTUuNzEgMTUuNzFWMzc3LjM2ek0yMzAgMTU3Yy0yMS41MzkgMC0zOS0xNy40NjEtMzktMzlzMTcuNDYxLTM5IDM5LTM5IDM5IDE3LjQ2MSAzOSAzOS0xNy40NjEgMzktMzkgMzl6Ii8+PC9zdmc+";
exports.ASSET_CLOSE_ICON_16PX = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAQgAAAEIBarqQRAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAE1SURBVDiNfdI7S0NBEAXgLya1otFgpbYSbISAgpXYi6CmiH9KCAiChaVga6OiWPgfRDQ+0itaGVNosXtluWwcuMzePfM4M3sq8lbHBubwg1dc4m1E/J/N4ghDPOIsfk/4xiEao5KX0McFljN4C9d4QTPXuY99jP3DsIoDPGM6BY5i5yI5R7O4q+ImFkJY2DCh3cAH2klyB+9J1xUMMAG7eCh1a+Mr+k48b5diXrFVwwLuS+BJ9MfR7+G0FHOHhTHhnXNWS87VDF4pcnfQK4Ep7XScNLmPTZgURNKKYENYWDpzW1BhscS1WHS8CDgURFJQrWcoF3c13KKbgg1BYQfy8xZWEzTTw1QZbAoKu8FqJnktdu5hcVSHmchiILzzuaDQvjBzV2m8yohCE1jHfPx/xhU+y4G/D75ELlRJsSYAAAAASUVORK5CYII=";

},{}],479:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Html5QrcodeScanType = exports.Html5QrcodeScannerState = exports.Html5QrcodeSupportedFormats = exports.Html5QrcodeScanner = exports.Html5Qrcode = void 0;
var html5_qrcode_1 = require("./html5-qrcode");
Object.defineProperty(exports, "Html5Qrcode", { enumerable: true, get: function () { return html5_qrcode_1.Html5Qrcode; } });
var html5_qrcode_scanner_1 = require("./html5-qrcode-scanner");
Object.defineProperty(exports, "Html5QrcodeScanner", { enumerable: true, get: function () { return html5_qrcode_scanner_1.Html5QrcodeScanner; } });
var core_1 = require("./core");
Object.defineProperty(exports, "Html5QrcodeSupportedFormats", { enumerable: true, get: function () { return core_1.Html5QrcodeSupportedFormats; } });
var state_manager_1 = require("./state-manager");
Object.defineProperty(exports, "Html5QrcodeScannerState", { enumerable: true, get: function () { return state_manager_1.Html5QrcodeScannerState; } });
var core_2 = require("./core");
Object.defineProperty(exports, "Html5QrcodeScanType", { enumerable: true, get: function () { return core_2.Html5QrcodeScanType; } });

},{"./core":475,"./html5-qrcode":477,"./html5-qrcode-scanner":476,"./state-manager":481}],480:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarcodeDetectorDelegate = void 0;
var core_1 = require("./core");
var BarcodeDetectorDelegate = (function () {
    function BarcodeDetectorDelegate(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [core_1.Html5QrcodeSupportedFormats.QR_CODE, "qr_code"],
            [core_1.Html5QrcodeSupportedFormats.AZTEC, "aztec"],
            [core_1.Html5QrcodeSupportedFormats.CODABAR, "codabar"],
            [core_1.Html5QrcodeSupportedFormats.CODE_39, "code_39"],
            [core_1.Html5QrcodeSupportedFormats.CODE_93, "code_93"],
            [core_1.Html5QrcodeSupportedFormats.CODE_128, "code_128"],
            [core_1.Html5QrcodeSupportedFormats.DATA_MATRIX, "data_matrix"],
            [core_1.Html5QrcodeSupportedFormats.ITF, "itf"],
            [core_1.Html5QrcodeSupportedFormats.EAN_13, "ean_13"],
            [core_1.Html5QrcodeSupportedFormats.EAN_8, "ean_8"],
            [core_1.Html5QrcodeSupportedFormats.PDF_417, "pdf417"],
            [core_1.Html5QrcodeSupportedFormats.UPC_A, "upc_a"],
            [core_1.Html5QrcodeSupportedFormats.UPC_E, "upc_e"]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!BarcodeDetectorDelegate.isSupported()) {
            throw "Use html5qrcode.min.js without edit, Use "
                + "BarcodeDetectorDelegate only if it isSupported();";
        }
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createBarcodeDetectorFormats(requestedFormats);
        this.detector = new BarcodeDetector(formats);
        if (!this.detector) {
            throw "BarcodeDetector detector not supported";
        }
    }
    BarcodeDetectorDelegate.isSupported = function () {
        if (!("BarcodeDetector" in window)) {
            return false;
        }
        var dummyDetector = new BarcodeDetector({ formats: ["qr_code"] });
        return typeof dummyDetector !== "undefined";
    };
    BarcodeDetectorDelegate.prototype.decodeAsync = function (canvas) {
        return __awaiter(this, void 0, void 0, function () {
            var barcodes, largestBarcode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.detector.detect(canvas)];
                    case 1:
                        barcodes = _a.sent();
                        if (!barcodes || barcodes.length === 0) {
                            throw "No barcode or QR code detected.";
                        }
                        largestBarcode = this.selectLargestBarcode(barcodes);
                        return [2, {
                                text: largestBarcode.rawValue,
                                format: core_1.QrcodeResultFormat.create(this.toHtml5QrcodeSupportedFormats(largestBarcode.format)),
                                debugData: this.createDebugData()
                            }];
                }
            });
        });
    };
    BarcodeDetectorDelegate.prototype.selectLargestBarcode = function (barcodes) {
        var largestBarcode = null;
        var maxArea = 0;
        for (var _i = 0, barcodes_1 = barcodes; _i < barcodes_1.length; _i++) {
            var barcode = barcodes_1[_i];
            var area = barcode.boundingBox.width * barcode.boundingBox.height;
            if (area > maxArea) {
                maxArea = area;
                largestBarcode = barcode;
            }
        }
        if (!largestBarcode) {
            throw "No largest barcode found";
        }
        return largestBarcode;
    };
    BarcodeDetectorDelegate.prototype.createBarcodeDetectorFormats = function (requestedFormats) {
        var formats = [];
        for (var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++) {
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) {
                formats.push(this.formatMap.get(requestedFormat));
            }
            else {
                this.logger.warn("".concat(requestedFormat, " is not supported by")
                    + "BarcodeDetectorDelegate");
            }
        }
        return { formats: formats };
    };
    BarcodeDetectorDelegate.prototype.toHtml5QrcodeSupportedFormats = function (barcodeDetectorFormat) {
        if (!this.reverseFormatMap.has(barcodeDetectorFormat)) {
            throw "reverseFormatMap doesn't have ".concat(barcodeDetectorFormat);
        }
        return this.reverseFormatMap.get(barcodeDetectorFormat);
    };
    BarcodeDetectorDelegate.prototype.createReverseFormatMap = function () {
        var result = new Map();
        this.formatMap.forEach(function (value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    BarcodeDetectorDelegate.prototype.createDebugData = function () {
        return { decoderName: "BarcodeDetector" };
    };
    return BarcodeDetectorDelegate;
}());
exports.BarcodeDetectorDelegate = BarcodeDetectorDelegate;

},{"./core":475}],481:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateManagerFactory = exports.StateManagerProxy = exports.Html5QrcodeScannerState = void 0;
var Html5QrcodeScannerState;
(function (Html5QrcodeScannerState) {
    Html5QrcodeScannerState[Html5QrcodeScannerState["UNKNOWN"] = 0] = "UNKNOWN";
    Html5QrcodeScannerState[Html5QrcodeScannerState["NOT_STARTED"] = 1] = "NOT_STARTED";
    Html5QrcodeScannerState[Html5QrcodeScannerState["SCANNING"] = 2] = "SCANNING";
    Html5QrcodeScannerState[Html5QrcodeScannerState["PAUSED"] = 3] = "PAUSED";
})(Html5QrcodeScannerState = exports.Html5QrcodeScannerState || (exports.Html5QrcodeScannerState = {}));
var StateManagerImpl = (function () {
    function StateManagerImpl() {
        this.state = Html5QrcodeScannerState.NOT_STARTED;
        this.onGoingTransactionNewState = Html5QrcodeScannerState.UNKNOWN;
    }
    StateManagerImpl.prototype.directTransition = function (newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.state = newState;
    };
    StateManagerImpl.prototype.startTransition = function (newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.onGoingTransactionNewState = newState;
        return this;
    };
    StateManagerImpl.prototype.execute = function () {
        if (this.onGoingTransactionNewState
            === Html5QrcodeScannerState.UNKNOWN) {
            throw "Transaction is already cancelled, cannot execute().";
        }
        var tempNewState = this.onGoingTransactionNewState;
        this.onGoingTransactionNewState = Html5QrcodeScannerState.UNKNOWN;
        this.directTransition(tempNewState);
    };
    StateManagerImpl.prototype.cancel = function () {
        if (this.onGoingTransactionNewState
            === Html5QrcodeScannerState.UNKNOWN) {
            throw "Transaction is already cancelled, cannot cancel().";
        }
        this.onGoingTransactionNewState = Html5QrcodeScannerState.UNKNOWN;
    };
    StateManagerImpl.prototype.getState = function () {
        return this.state;
    };
    StateManagerImpl.prototype.failIfTransitionOngoing = function () {
        if (this.onGoingTransactionNewState
            !== Html5QrcodeScannerState.UNKNOWN) {
            throw "Cannot transition to a new state, already under transition";
        }
    };
    StateManagerImpl.prototype.validateTransition = function (newState) {
        switch (this.state) {
            case Html5QrcodeScannerState.UNKNOWN:
                throw "Transition from unknown is not allowed";
            case Html5QrcodeScannerState.NOT_STARTED:
                this.failIfNewStateIs(newState, [Html5QrcodeScannerState.PAUSED]);
                break;
            case Html5QrcodeScannerState.SCANNING:
                break;
            case Html5QrcodeScannerState.PAUSED:
                break;
        }
    };
    StateManagerImpl.prototype.failIfNewStateIs = function (newState, disallowedStatesToTransition) {
        for (var _i = 0, disallowedStatesToTransition_1 = disallowedStatesToTransition; _i < disallowedStatesToTransition_1.length; _i++) {
            var disallowedState = disallowedStatesToTransition_1[_i];
            if (newState === disallowedState) {
                throw "Cannot transition from ".concat(this.state, " to ").concat(newState);
            }
        }
    };
    return StateManagerImpl;
}());
var StateManagerProxy = (function () {
    function StateManagerProxy(stateManager) {
        this.stateManager = stateManager;
    }
    StateManagerProxy.prototype.startTransition = function (newState) {
        return this.stateManager.startTransition(newState);
    };
    StateManagerProxy.prototype.directTransition = function (newState) {
        this.stateManager.directTransition(newState);
    };
    StateManagerProxy.prototype.getState = function () {
        return this.stateManager.getState();
    };
    StateManagerProxy.prototype.canScanFile = function () {
        return this.stateManager.getState() === Html5QrcodeScannerState.NOT_STARTED;
    };
    StateManagerProxy.prototype.isScanning = function () {
        return this.stateManager.getState() !== Html5QrcodeScannerState.NOT_STARTED;
    };
    StateManagerProxy.prototype.isStrictlyScanning = function () {
        return this.stateManager.getState() === Html5QrcodeScannerState.SCANNING;
    };
    StateManagerProxy.prototype.isPaused = function () {
        return this.stateManager.getState() === Html5QrcodeScannerState.PAUSED;
    };
    return StateManagerProxy;
}());
exports.StateManagerProxy = StateManagerProxy;
var StateManagerFactory = (function () {
    function StateManagerFactory() {
    }
    StateManagerFactory.create = function () {
        return new StateManagerProxy(new StateManagerImpl());
    };
    return StateManagerFactory;
}());
exports.StateManagerFactory = StateManagerFactory;

},{}],482:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistedDataManager = void 0;
var PersistedDataFactory = (function () {
    function PersistedDataFactory() {
    }
    PersistedDataFactory.createDefault = function () {
        return {
            hasPermission: false,
            lastUsedCameraId: null
        };
    };
    return PersistedDataFactory;
}());
var PersistedDataManager = (function () {
    function PersistedDataManager() {
        this.data = PersistedDataFactory.createDefault();
        var data = localStorage.getItem(PersistedDataManager.LOCAL_STORAGE_KEY);
        if (!data) {
            this.reset();
        }
        else {
            this.data = JSON.parse(data);
        }
    }
    PersistedDataManager.prototype.hasCameraPermissions = function () {
        return this.data.hasPermission;
    };
    PersistedDataManager.prototype.getLastUsedCameraId = function () {
        return this.data.lastUsedCameraId;
    };
    PersistedDataManager.prototype.setHasPermission = function (hasPermission) {
        this.data.hasPermission = hasPermission;
        this.flush();
    };
    PersistedDataManager.prototype.setLastUsedCameraId = function (lastUsedCameraId) {
        this.data.lastUsedCameraId = lastUsedCameraId;
        this.flush();
    };
    PersistedDataManager.prototype.resetLastUsedCameraId = function () {
        this.data.lastUsedCameraId = null;
        this.flush();
    };
    PersistedDataManager.prototype.reset = function () {
        this.data = PersistedDataFactory.createDefault();
        this.flush();
    };
    PersistedDataManager.prototype.flush = function () {
        localStorage.setItem(PersistedDataManager.LOCAL_STORAGE_KEY, JSON.stringify(this.data));
    };
    PersistedDataManager.LOCAL_STORAGE_KEY = "HTML5_QRCODE_DATA";
    return PersistedDataManager;
}());
exports.PersistedDataManager = PersistedDataManager;

},{}],483:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryInfoStrings = exports.Html5QrcodeScannerStrings = exports.Html5QrcodeStrings = void 0;
var Html5QrcodeStrings = (function () {
    function Html5QrcodeStrings() {
    }
    Html5QrcodeStrings.codeParseError = function (exception) {
        return "QR code parse error, error = ".concat(exception);
    };
    Html5QrcodeStrings.errorGettingUserMedia = function (error) {
        return "Error getting userMedia, error = ".concat(error);
    };
    Html5QrcodeStrings.onlyDeviceSupportedError = function () {
        return "The device doesn't support navigator.mediaDevices , only "
            + "supported cameraIdOrConfig in this case is deviceId parameter "
            + "(string).";
    };
    Html5QrcodeStrings.cameraStreamingNotSupported = function () {
        return "Camera streaming not supported by the browser.";
    };
    Html5QrcodeStrings.unableToQuerySupportedDevices = function () {
        return "Unable to query supported devices, unknown error.";
    };
    Html5QrcodeStrings.insecureContextCameraQueryError = function () {
        return "Camera access is only supported in secure context like https "
            + "or localhost.";
    };
    Html5QrcodeStrings.scannerPaused = function () {
        return "Scanner paused";
    };
    return Html5QrcodeStrings;
}());
exports.Html5QrcodeStrings = Html5QrcodeStrings;
var Html5QrcodeScannerStrings = (function () {
    function Html5QrcodeScannerStrings() {
    }
    Html5QrcodeScannerStrings.scanningStatus = function () {
        return "Scanning";
    };
    Html5QrcodeScannerStrings.idleStatus = function () {
        return "Idle";
    };
    Html5QrcodeScannerStrings.errorStatus = function () {
        return "Error";
    };
    Html5QrcodeScannerStrings.permissionStatus = function () {
        return "Permission";
    };
    Html5QrcodeScannerStrings.noCameraFoundErrorStatus = function () {
        return "No Cameras";
    };
    Html5QrcodeScannerStrings.lastMatch = function (decodedText) {
        return "Last Match: ".concat(decodedText);
    };
    Html5QrcodeScannerStrings.codeScannerTitle = function () {
        return "Code Scanner";
    };
    Html5QrcodeScannerStrings.cameraPermissionTitle = function () {
        return "Request Camera Permissions";
    };
    Html5QrcodeScannerStrings.cameraPermissionRequesting = function () {
        return "Requesting camera permissions...";
    };
    Html5QrcodeScannerStrings.noCameraFound = function () {
        return "No camera found";
    };
    Html5QrcodeScannerStrings.scanButtonStopScanningText = function () {
        return "Stop Scanning";
    };
    Html5QrcodeScannerStrings.scanButtonStartScanningText = function () {
        return "Start Scanning";
    };
    Html5QrcodeScannerStrings.torchOnButton = function () {
        return "Switch On Torch";
    };
    Html5QrcodeScannerStrings.torchOffButton = function () {
        return "Switch Off Torch";
    };
    Html5QrcodeScannerStrings.torchOnFailedMessage = function () {
        return "Failed to turn on torch";
    };
    Html5QrcodeScannerStrings.torchOffFailedMessage = function () {
        return "Failed to turn off torch";
    };
    Html5QrcodeScannerStrings.scanButtonScanningStarting = function () {
        return "Launching Camera...";
    };
    Html5QrcodeScannerStrings.textIfCameraScanSelected = function () {
        return "Scan an Image File";
    };
    Html5QrcodeScannerStrings.textIfFileScanSelected = function () {
        return "Scan using camera directly";
    };
    Html5QrcodeScannerStrings.selectCamera = function () {
        return "Select Camera";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseImage = function () {
        return "Choose Image";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseAnother = function () {
        return "Choose Another";
    };
    Html5QrcodeScannerStrings.fileSelectionNoImageSelected = function () {
        return "No image choosen";
    };
    Html5QrcodeScannerStrings.anonymousCameraPrefix = function () {
        return "Anonymous Camera";
    };
    Html5QrcodeScannerStrings.dragAndDropMessage = function () {
        return "Or drop an image to scan";
    };
    Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages = function () {
        return "Or drop an image to scan (other files not supported)";
    };
    Html5QrcodeScannerStrings.zoom = function () {
        return "zoom";
    };
    Html5QrcodeScannerStrings.loadingImage = function () {
        return "Loading image...";
    };
    Html5QrcodeScannerStrings.cameraScanAltText = function () {
        return "Camera based scan";
    };
    Html5QrcodeScannerStrings.fileScanAltText = function () {
        return "Fule based scan";
    };
    return Html5QrcodeScannerStrings;
}());
exports.Html5QrcodeScannerStrings = Html5QrcodeScannerStrings;
var LibraryInfoStrings = (function () {
    function LibraryInfoStrings() {
    }
    LibraryInfoStrings.poweredBy = function () {
        return "Powered by ";
    };
    LibraryInfoStrings.reportIssues = function () {
        return "Report issues";
    };
    return LibraryInfoStrings;
}());
exports.LibraryInfoStrings = LibraryInfoStrings;

},{}],484:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryInfoContainer = void 0;
var image_assets_1 = require("./image-assets");
var strings_1 = require("./strings");
var LibraryInfoDiv = (function () {
    function LibraryInfoDiv() {
        this.infoDiv = document.createElement("div");
    }
    LibraryInfoDiv.prototype.renderInto = function (parent) {
        this.infoDiv.style.position = "absolute";
        this.infoDiv.style.top = "10px";
        this.infoDiv.style.right = "10px";
        this.infoDiv.style.zIndex = "2";
        this.infoDiv.style.display = "none";
        this.infoDiv.style.padding = "5pt";
        this.infoDiv.style.border = "1px solid #171717";
        this.infoDiv.style.fontSize = "10pt";
        this.infoDiv.style.background = "rgb(0 0 0 / 69%)";
        this.infoDiv.style.borderRadius = "5px";
        this.infoDiv.style.textAlign = "center";
        this.infoDiv.style.fontWeight = "400";
        this.infoDiv.style.color = "white";
        this.infoDiv.innerText = strings_1.LibraryInfoStrings.poweredBy();
        var projectLink = document.createElement("a");
        projectLink.innerText = "ScanApp";
        projectLink.href = "https://scanapp.org";
        projectLink.target = "new";
        projectLink.style.color = "white";
        this.infoDiv.appendChild(projectLink);
        var breakElemFirst = document.createElement("br");
        var breakElemSecond = document.createElement("br");
        this.infoDiv.appendChild(breakElemFirst);
        this.infoDiv.appendChild(breakElemSecond);
        var reportIssueLink = document.createElement("a");
        reportIssueLink.innerText = strings_1.LibraryInfoStrings.reportIssues();
        reportIssueLink.href = "https://github.com/mebjas/html5-qrcode/issues";
        reportIssueLink.target = "new";
        reportIssueLink.style.color = "white";
        this.infoDiv.appendChild(reportIssueLink);
        parent.appendChild(this.infoDiv);
    };
    LibraryInfoDiv.prototype.show = function () {
        this.infoDiv.style.display = "block";
    };
    LibraryInfoDiv.prototype.hide = function () {
        this.infoDiv.style.display = "none";
    };
    return LibraryInfoDiv;
}());
var LibraryInfoIcon = (function () {
    function LibraryInfoIcon(onTapIn, onTapOut) {
        this.isShowingInfoIcon = true;
        this.onTapIn = onTapIn;
        this.onTapOut = onTapOut;
        this.infoIcon = document.createElement("img");
    }
    LibraryInfoIcon.prototype.renderInto = function (parent) {
        var _this = this;
        this.infoIcon.alt = "Info icon";
        this.infoIcon.src = image_assets_1.ASSET_INFO_ICON_16PX;
        this.infoIcon.style.position = "absolute";
        this.infoIcon.style.top = "4px";
        this.infoIcon.style.right = "4px";
        this.infoIcon.style.opacity = "0.6";
        this.infoIcon.style.cursor = "pointer";
        this.infoIcon.style.zIndex = "2";
        this.infoIcon.style.width = "16px";
        this.infoIcon.style.height = "16px";
        this.infoIcon.onmouseover = function (_) { return _this.onHoverIn(); };
        this.infoIcon.onmouseout = function (_) { return _this.onHoverOut(); };
        this.infoIcon.onclick = function (_) { return _this.onClick(); };
        parent.appendChild(this.infoIcon);
    };
    LibraryInfoIcon.prototype.onHoverIn = function () {
        if (this.isShowingInfoIcon) {
            this.infoIcon.style.opacity = "1";
        }
    };
    LibraryInfoIcon.prototype.onHoverOut = function () {
        if (this.isShowingInfoIcon) {
            this.infoIcon.style.opacity = "0.6";
        }
    };
    LibraryInfoIcon.prototype.onClick = function () {
        if (this.isShowingInfoIcon) {
            this.isShowingInfoIcon = false;
            this.onTapIn();
            this.infoIcon.src = image_assets_1.ASSET_CLOSE_ICON_16PX;
            this.infoIcon.style.opacity = "1";
        }
        else {
            this.isShowingInfoIcon = true;
            this.onTapOut();
            this.infoIcon.src = image_assets_1.ASSET_INFO_ICON_16PX;
            this.infoIcon.style.opacity = "0.6";
        }
    };
    return LibraryInfoIcon;
}());
var LibraryInfoContainer = (function () {
    function LibraryInfoContainer() {
        var _this = this;
        this.infoDiv = new LibraryInfoDiv();
        this.infoIcon = new LibraryInfoIcon(function () {
            _this.infoDiv.show();
        }, function () {
            _this.infoDiv.hide();
        });
    }
    LibraryInfoContainer.prototype.renderInto = function (parent) {
        this.infoDiv.renderInto(parent);
        this.infoIcon.renderInto(parent);
    };
    return LibraryInfoContainer;
}());
exports.LibraryInfoContainer = LibraryInfoContainer;

},{"./image-assets":478,"./strings":483}],485:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUiElementFactory = exports.PublicUiElementIdAndClasses = void 0;
var PublicUiElementIdAndClasses = (function () {
    function PublicUiElementIdAndClasses() {
    }
    PublicUiElementIdAndClasses.ALL_ELEMENT_CLASS = "html5-qrcode-element";
    PublicUiElementIdAndClasses.CAMERA_PERMISSION_BUTTON_ID = "html5-qrcode-button-camera-permission";
    PublicUiElementIdAndClasses.CAMERA_START_BUTTON_ID = "html5-qrcode-button-camera-start";
    PublicUiElementIdAndClasses.CAMERA_STOP_BUTTON_ID = "html5-qrcode-button-camera-stop";
    PublicUiElementIdAndClasses.TORCH_BUTTON_ID = "html5-qrcode-button-torch";
    PublicUiElementIdAndClasses.CAMERA_SELECTION_SELECT_ID = "html5-qrcode-select-camera";
    PublicUiElementIdAndClasses.FILE_SELECTION_BUTTON_ID = "html5-qrcode-button-file-selection";
    PublicUiElementIdAndClasses.ZOOM_SLIDER_ID = "html5-qrcode-input-range-zoom";
    PublicUiElementIdAndClasses.SCAN_TYPE_CHANGE_ANCHOR_ID = "html5-qrcode-anchor-scan-type-change";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON = "html5-qrcode-button-torch-on";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF = "html5-qrcode-button-torch-off";
    return PublicUiElementIdAndClasses;
}());
exports.PublicUiElementIdAndClasses = PublicUiElementIdAndClasses;
var BaseUiElementFactory = (function () {
    function BaseUiElementFactory() {
    }
    BaseUiElementFactory.createElement = function (elementType, elementId) {
        var element = (document.createElement(elementType));
        element.id = elementId;
        element.classList.add(PublicUiElementIdAndClasses.ALL_ELEMENT_CLASS);
        if (elementType === "button") {
            element.setAttribute("type", "button");
        }
        return element;
    };
    return BaseUiElementFactory;
}());
exports.BaseUiElementFactory = BaseUiElementFactory;

},{}],486:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraSelectionUi = void 0;
var base_1 = require("./base");
var strings_1 = require("../../strings");
var CameraSelectionUi = (function () {
    function CameraSelectionUi(cameras) {
        this.selectElement = base_1.BaseUiElementFactory
            .createElement("select", base_1.PublicUiElementIdAndClasses.CAMERA_SELECTION_SELECT_ID);
        this.cameras = cameras;
        this.options = [];
    }
    CameraSelectionUi.prototype.render = function (parentElement) {
        var cameraSelectionContainer = document.createElement("span");
        cameraSelectionContainer.style.marginRight = "10px";
        var numCameras = this.cameras.length;
        if (numCameras === 0) {
            throw new Error("No cameras found");
        }
        if (numCameras === 1) {
            cameraSelectionContainer.style.display = "none";
        }
        else {
            var selectCameraString = strings_1.Html5QrcodeScannerStrings.selectCamera();
            cameraSelectionContainer.innerText
                = "".concat(selectCameraString, " (").concat(this.cameras.length, ")  ");
        }
        var anonymousCameraId = 1;
        for (var _i = 0, _a = this.cameras; _i < _a.length; _i++) {
            var camera = _a[_i];
            var value = camera.id;
            var name_1 = camera.label == null ? value : camera.label;
            if (!name_1 || name_1 === "") {
                name_1 = [
                    strings_1.Html5QrcodeScannerStrings.anonymousCameraPrefix(),
                    anonymousCameraId++
                ].join(" ");
            }
            var option = document.createElement("option");
            option.value = value;
            option.innerText = name_1;
            this.options.push(option);
            this.selectElement.appendChild(option);
        }
        cameraSelectionContainer.appendChild(this.selectElement);
        parentElement.appendChild(cameraSelectionContainer);
    };
    CameraSelectionUi.prototype.disable = function () {
        this.selectElement.disabled = true;
    };
    CameraSelectionUi.prototype.isDisabled = function () {
        return this.selectElement.disabled === true;
    };
    CameraSelectionUi.prototype.enable = function () {
        this.selectElement.disabled = false;
    };
    CameraSelectionUi.prototype.getValue = function () {
        return this.selectElement.value;
    };
    CameraSelectionUi.prototype.hasValue = function (value) {
        for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
            var option = _a[_i];
            if (option.value === value) {
                return true;
            }
        }
        return false;
    };
    CameraSelectionUi.prototype.setValue = function (value) {
        if (!this.hasValue(value)) {
            throw new Error("".concat(value, " is not present in the camera list."));
        }
        this.selectElement.value = value;
    };
    CameraSelectionUi.prototype.hasSingleItem = function () {
        return this.cameras.length === 1;
    };
    CameraSelectionUi.prototype.numCameras = function () {
        return this.cameras.length;
    };
    CameraSelectionUi.create = function (parentElement, cameras) {
        var cameraSelectUi = new CameraSelectionUi(cameras);
        cameraSelectUi.render(parentElement);
        return cameraSelectUi;
    };
    return CameraSelectionUi;
}());
exports.CameraSelectionUi = CameraSelectionUi;

},{"../../strings":483,"./base":485}],487:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraZoomUi = void 0;
var base_1 = require("./base");
var strings_1 = require("../../strings");
var CameraZoomUi = (function () {
    function CameraZoomUi() {
        this.onChangeCallback = null;
        this.zoomElementContainer = document.createElement("div");
        this.rangeInput = base_1.BaseUiElementFactory.createElement("input", base_1.PublicUiElementIdAndClasses.ZOOM_SLIDER_ID);
        this.rangeInput.type = "range";
        this.rangeText = document.createElement("span");
        this.rangeInput.min = "1";
        this.rangeInput.max = "5";
        this.rangeInput.value = "1";
        this.rangeInput.step = "0.1";
    }
    CameraZoomUi.prototype.render = function (parentElement, renderOnCreate) {
        this.zoomElementContainer.style.display
            = renderOnCreate ? "block" : "none";
        this.zoomElementContainer.style.padding = "5px 10px";
        this.zoomElementContainer.style.textAlign = "center";
        parentElement.appendChild(this.zoomElementContainer);
        this.rangeInput.style.display = "inline-block";
        this.rangeInput.style.width = "50%";
        this.rangeInput.style.height = "5px";
        this.rangeInput.style.background = "#d3d3d3";
        this.rangeInput.style.outline = "none";
        this.rangeInput.style.opacity = "0.7";
        var zoomString = strings_1.Html5QrcodeScannerStrings.zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        this.rangeText.style.marginRight = "10px";
        var $this = this;
        this.rangeInput.addEventListener("input", function () { return $this.onValueChange(); });
        this.rangeInput.addEventListener("change", function () { return $this.onValueChange(); });
        this.zoomElementContainer.appendChild(this.rangeInput);
        this.zoomElementContainer.appendChild(this.rangeText);
    };
    CameraZoomUi.prototype.onValueChange = function () {
        var zoomString = strings_1.Html5QrcodeScannerStrings.zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        if (this.onChangeCallback) {
            this.onChangeCallback(parseFloat(this.rangeInput.value));
        }
    };
    CameraZoomUi.prototype.setValues = function (minValue, maxValue, defaultValue, step) {
        this.rangeInput.min = minValue.toString();
        this.rangeInput.max = maxValue.toString();
        this.rangeInput.step = step.toString();
        this.rangeInput.value = defaultValue.toString();
        this.onValueChange();
    };
    CameraZoomUi.prototype.show = function () {
        this.zoomElementContainer.style.display = "block";
    };
    CameraZoomUi.prototype.hide = function () {
        this.zoomElementContainer.style.display = "none";
    };
    CameraZoomUi.prototype.setOnCameraZoomValueChangeCallback = function (onChangeCallback) {
        this.onChangeCallback = onChangeCallback;
    };
    CameraZoomUi.prototype.removeOnCameraZoomValueChangeCallback = function () {
        this.onChangeCallback = null;
    };
    CameraZoomUi.create = function (parentElement, renderOnCreate) {
        var cameraZoomUi = new CameraZoomUi();
        cameraZoomUi.render(parentElement, renderOnCreate);
        return cameraZoomUi;
    };
    return CameraZoomUi;
}());
exports.CameraZoomUi = CameraZoomUi;

},{"../../strings":483,"./base":485}],488:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSelectionUi = void 0;
var strings_1 = require("../../strings");
var base_1 = require("./base");
var FileSelectionUi = (function () {
    function FileSelectionUi(parentElement, showOnRender, onFileSelected) {
        this.fileBasedScanRegion = this.createFileBasedScanRegion();
        this.fileBasedScanRegion.style.display
            = showOnRender ? "block" : "none";
        parentElement.appendChild(this.fileBasedScanRegion);
        var fileScanLabel = document.createElement("label");
        fileScanLabel.setAttribute("for", this.getFileScanInputId());
        fileScanLabel.style.display = "inline-block";
        this.fileBasedScanRegion.appendChild(fileScanLabel);
        this.fileSelectionButton
            = base_1.BaseUiElementFactory.createElement("button", base_1.PublicUiElementIdAndClasses.FILE_SELECTION_BUTTON_ID);
        this.setInitialValueToButton();
        this.fileSelectionButton.addEventListener("click", function (_) {
            fileScanLabel.click();
        });
        fileScanLabel.append(this.fileSelectionButton);
        this.fileScanInput
            = base_1.BaseUiElementFactory.createElement("input", this.getFileScanInputId());
        this.fileScanInput.type = "file";
        this.fileScanInput.accept = "image/*";
        this.fileScanInput.style.display = "none";
        fileScanLabel.appendChild(this.fileScanInput);
        var $this = this;
        this.fileScanInput.addEventListener("change", function (e) {
            if (e == null || e.target == null) {
                return;
            }
            var target = e.target;
            if (target.files && target.files.length === 0) {
                return;
            }
            var fileList = target.files;
            var file = fileList[0];
            var fileName = file.name;
            $this.setImageNameToButton(fileName);
            onFileSelected(file);
        });
        var dragAndDropMessage = this.createDragAndDropMessage();
        this.fileBasedScanRegion.appendChild(dragAndDropMessage);
        this.fileBasedScanRegion.addEventListener("dragenter", function (event) {
            $this.fileBasedScanRegion.style.border
                = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragleave", function (event) {
            $this.fileBasedScanRegion.style.border
                = $this.fileBasedScanRegionDefaultBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragover", function (event) {
            $this.fileBasedScanRegion.style.border
                = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("drop", function (event) {
            event.stopPropagation();
            event.preventDefault();
            $this.fileBasedScanRegion.style.border
                = $this.fileBasedScanRegionDefaultBorder();
            var dataTransfer = event.dataTransfer;
            if (dataTransfer) {
                var files = dataTransfer.files;
                if (!files || files.length === 0) {
                    return;
                }
                var isAnyFileImage = false;
                for (var i = 0; i < files.length; ++i) {
                    var file = files.item(i);
                    if (!file) {
                        continue;
                    }
                    var imageType = /image.*/;
                    if (!file.type.match(imageType)) {
                        continue;
                    }
                    isAnyFileImage = true;
                    var fileName = file.name;
                    $this.setImageNameToButton(fileName);
                    onFileSelected(file);
                    dragAndDropMessage.innerText
                        = strings_1.Html5QrcodeScannerStrings.dragAndDropMessage();
                    break;
                }
                if (!isAnyFileImage) {
                    dragAndDropMessage.innerText
                        = strings_1.Html5QrcodeScannerStrings
                            .dragAndDropMessageOnlyImages();
                }
            }
        });
    }
    FileSelectionUi.prototype.hide = function () {
        this.fileBasedScanRegion.style.display = "none";
        this.fileScanInput.disabled = true;
    };
    FileSelectionUi.prototype.show = function () {
        this.fileBasedScanRegion.style.display = "block";
        this.fileScanInput.disabled = false;
    };
    FileSelectionUi.prototype.isShowing = function () {
        return this.fileBasedScanRegion.style.display === "block";
    };
    FileSelectionUi.prototype.resetValue = function () {
        this.fileScanInput.value = "";
        this.setInitialValueToButton();
    };
    FileSelectionUi.prototype.createFileBasedScanRegion = function () {
        var fileBasedScanRegion = document.createElement("div");
        fileBasedScanRegion.style.textAlign = "center";
        fileBasedScanRegion.style.margin = "auto";
        fileBasedScanRegion.style.width = "80%";
        fileBasedScanRegion.style.maxWidth = "600px";
        fileBasedScanRegion.style.border
            = this.fileBasedScanRegionDefaultBorder();
        fileBasedScanRegion.style.padding = "10px";
        fileBasedScanRegion.style.marginBottom = "10px";
        return fileBasedScanRegion;
    };
    FileSelectionUi.prototype.fileBasedScanRegionDefaultBorder = function () {
        return "6px dashed #ebebeb";
    };
    FileSelectionUi.prototype.fileBasedScanRegionActiveBorder = function () {
        return "6px dashed rgb(153 151 151)";
    };
    FileSelectionUi.prototype.createDragAndDropMessage = function () {
        var dragAndDropMessage = document.createElement("div");
        dragAndDropMessage.innerText
            = strings_1.Html5QrcodeScannerStrings.dragAndDropMessage();
        dragAndDropMessage.style.fontWeight = "400";
        return dragAndDropMessage;
    };
    FileSelectionUi.prototype.setImageNameToButton = function (imageFileName) {
        var MAX_CHARS = 20;
        if (imageFileName.length > MAX_CHARS) {
            var start8Chars = imageFileName.substring(0, 8);
            var length_1 = imageFileName.length;
            var last8Chars = imageFileName.substring(length_1 - 8, length_1);
            imageFileName = "".concat(start8Chars, "....").concat(last8Chars);
        }
        var newText = strings_1.Html5QrcodeScannerStrings.fileSelectionChooseAnother()
            + " - "
            + imageFileName;
        this.fileSelectionButton.innerText = newText;
    };
    FileSelectionUi.prototype.setInitialValueToButton = function () {
        var initialText = strings_1.Html5QrcodeScannerStrings.fileSelectionChooseImage()
            + " - "
            + strings_1.Html5QrcodeScannerStrings.fileSelectionNoImageSelected();
        this.fileSelectionButton.innerText = initialText;
    };
    FileSelectionUi.prototype.getFileScanInputId = function () {
        return "html5-qrcode-private-filescan-input";
    };
    FileSelectionUi.create = function (parentElement, showOnRender, onFileSelected) {
        var button = new FileSelectionUi(parentElement, showOnRender, onFileSelected);
        return button;
    };
    return FileSelectionUi;
}());
exports.FileSelectionUi = FileSelectionUi;

},{"../../strings":483,"./base":485}],489:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanTypeSelector = void 0;
var core_1 = require("../../core");
var ScanTypeSelector = (function () {
    function ScanTypeSelector(supportedScanTypes) {
        this.supportedScanTypes = this.validateAndReturnScanTypes(supportedScanTypes);
    }
    ScanTypeSelector.prototype.getDefaultScanType = function () {
        return this.supportedScanTypes[0];
    };
    ScanTypeSelector.prototype.hasMoreThanOneScanType = function () {
        return this.supportedScanTypes.length > 1;
    };
    ScanTypeSelector.prototype.isCameraScanRequired = function () {
        for (var _i = 0, _a = this.supportedScanTypes; _i < _a.length; _i++) {
            var scanType = _a[_i];
            if (ScanTypeSelector.isCameraScanType(scanType)) {
                return true;
            }
        }
        return false;
    };
    ScanTypeSelector.isCameraScanType = function (scanType) {
        return scanType === core_1.Html5QrcodeScanType.SCAN_TYPE_CAMERA;
    };
    ScanTypeSelector.isFileScanType = function (scanType) {
        return scanType === core_1.Html5QrcodeScanType.SCAN_TYPE_FILE;
    };
    ScanTypeSelector.prototype.validateAndReturnScanTypes = function (supportedScanTypes) {
        if (!supportedScanTypes || supportedScanTypes.length === 0) {
            return core_1.Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE;
        }
        var maxExpectedValues = core_1.Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE.length;
        if (supportedScanTypes.length > maxExpectedValues) {
            throw "Max ".concat(maxExpectedValues, " values expected for ")
                + "supportedScanTypes";
        }
        for (var _i = 0, supportedScanTypes_1 = supportedScanTypes; _i < supportedScanTypes_1.length; _i++) {
            var scanType = supportedScanTypes_1[_i];
            if (!core_1.Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE
                .includes(scanType)) {
                throw "Unsupported scan type ".concat(scanType);
            }
        }
        return supportedScanTypes;
    };
    return ScanTypeSelector;
}());
exports.ScanTypeSelector = ScanTypeSelector;

},{"../../core":475}],490:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TorchButton = void 0;
var strings_1 = require("../../strings");
var base_1 = require("./base");
var TorchController = (function () {
    function TorchController(torchCapability, buttonController, onTorchActionFailureCallback) {
        this.isTorchOn = false;
        this.torchCapability = torchCapability;
        this.buttonController = buttonController;
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
    }
    TorchController.prototype.isTorchEnabled = function () {
        return this.isTorchOn;
    };
    TorchController.prototype.flipState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isTorchOnExpected, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.buttonController.disable();
                        isTorchOnExpected = !this.isTorchOn;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.torchCapability.apply(isTorchOnExpected)];
                    case 2:
                        _a.sent();
                        this.updateUiBasedOnLatestSettings(this.torchCapability.value(), isTorchOnExpected);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.propagateFailure(isTorchOnExpected, error_1);
                        this.buttonController.enable();
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    TorchController.prototype.updateUiBasedOnLatestSettings = function (isTorchOn, isTorchOnExpected) {
        if (isTorchOn === isTorchOnExpected) {
            this.buttonController.setText(isTorchOnExpected
                ? strings_1.Html5QrcodeScannerStrings.torchOffButton()
                : strings_1.Html5QrcodeScannerStrings.torchOnButton());
            this.isTorchOn = isTorchOnExpected;
        }
        else {
            this.propagateFailure(isTorchOnExpected);
        }
        this.buttonController.enable();
    };
    TorchController.prototype.propagateFailure = function (isTorchOnExpected, error) {
        var errorMessage = isTorchOnExpected
            ? strings_1.Html5QrcodeScannerStrings.torchOnFailedMessage()
            : strings_1.Html5QrcodeScannerStrings.torchOffFailedMessage();
        if (error) {
            errorMessage += "; Error = " + error;
        }
        this.onTorchActionFailureCallback(errorMessage);
    };
    TorchController.prototype.reset = function () {
        this.isTorchOn = false;
    };
    return TorchController;
}());
var TorchButton = (function () {
    function TorchButton(torchCapability, onTorchActionFailureCallback) {
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
        this.torchButton
            = base_1.BaseUiElementFactory.createElement("button", base_1.PublicUiElementIdAndClasses.TORCH_BUTTON_ID);
        this.torchController = new TorchController(torchCapability, this, onTorchActionFailureCallback);
    }
    TorchButton.prototype.render = function (parentElement, torchButtonOptions) {
        var _this = this;
        this.torchButton.innerText
            = strings_1.Html5QrcodeScannerStrings.torchOnButton();
        this.torchButton.style.display = torchButtonOptions.display;
        this.torchButton.style.marginLeft = torchButtonOptions.marginLeft;
        var $this = this;
        this.torchButton.addEventListener("click", function (_) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, $this.torchController.flipState()];
                    case 1:
                        _a.sent();
                        if ($this.torchController.isTorchEnabled()) {
                            $this.torchButton.classList.remove(base_1.PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF);
                            $this.torchButton.classList.add(base_1.PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON);
                        }
                        else {
                            $this.torchButton.classList.remove(base_1.PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON);
                            $this.torchButton.classList.add(base_1.PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF);
                        }
                        return [2];
                }
            });
        }); });
        parentElement.appendChild(this.torchButton);
    };
    TorchButton.prototype.updateTorchCapability = function (torchCapability) {
        this.torchController = new TorchController(torchCapability, this, this.onTorchActionFailureCallback);
    };
    TorchButton.prototype.getTorchButton = function () {
        return this.torchButton;
    };
    TorchButton.prototype.hide = function () {
        this.torchButton.style.display = "none";
    };
    TorchButton.prototype.show = function () {
        this.torchButton.style.display = "inline-block";
    };
    TorchButton.prototype.disable = function () {
        this.torchButton.disabled = true;
    };
    TorchButton.prototype.enable = function () {
        this.torchButton.disabled = false;
    };
    TorchButton.prototype.setText = function (text) {
        this.torchButton.innerText = text;
    };
    TorchButton.prototype.reset = function () {
        this.torchButton.innerText = strings_1.Html5QrcodeScannerStrings.torchOnButton();
        this.torchController.reset();
    };
    TorchButton.create = function (parentElement, torchCapability, torchButtonOptions, onTorchActionFailureCallback) {
        var button = new TorchButton(torchCapability, onTorchActionFailureCallback);
        button.render(parentElement, torchButtonOptions);
        return button;
    };
    return TorchButton;
}());
exports.TorchButton = TorchButton;

},{"../../strings":483,"./base":485}],491:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoConstraintsUtil = void 0;
var VideoConstraintsUtil = (function () {
    function VideoConstraintsUtil() {
    }
    VideoConstraintsUtil.isMediaStreamConstraintsValid = function (videoConstraints, logger) {
        if (typeof videoConstraints !== "object") {
            var typeofVideoConstraints = typeof videoConstraints;
            logger.logError("videoConstraints should be of type object, the "
                + "object passed is of type ".concat(typeofVideoConstraints, "."), true);
            return false;
        }
        var bannedKeys = [
            "autoGainControl",
            "channelCount",
            "echoCancellation",
            "latency",
            "noiseSuppression",
            "sampleRate",
            "sampleSize",
            "volume"
        ];
        var bannedkeysSet = new Set(bannedKeys);
        var keysInVideoConstraints = Object.keys(videoConstraints);
        for (var _i = 0, keysInVideoConstraints_1 = keysInVideoConstraints; _i < keysInVideoConstraints_1.length; _i++) {
            var key = keysInVideoConstraints_1[_i];
            if (bannedkeysSet.has(key)) {
                logger.logError("".concat(key, " is not supported videoConstaints."), true);
                return false;
            }
        }
        return true;
    };
    return VideoConstraintsUtil;
}());
exports.VideoConstraintsUtil = VideoConstraintsUtil;

},{}],492:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZXingHtml5QrcodeDecoder = void 0;
var ZXing = require("../third_party/zxing-js.umd");
var core_1 = require("./core");
var ZXingHtml5QrcodeDecoder = (function () {
    function ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [core_1.Html5QrcodeSupportedFormats.QR_CODE, ZXing.BarcodeFormat.QR_CODE],
            [core_1.Html5QrcodeSupportedFormats.AZTEC, ZXing.BarcodeFormat.AZTEC],
            [core_1.Html5QrcodeSupportedFormats.CODABAR, ZXing.BarcodeFormat.CODABAR],
            [core_1.Html5QrcodeSupportedFormats.CODE_39, ZXing.BarcodeFormat.CODE_39],
            [core_1.Html5QrcodeSupportedFormats.CODE_93, ZXing.BarcodeFormat.CODE_93],
            [
                core_1.Html5QrcodeSupportedFormats.CODE_128,
                ZXing.BarcodeFormat.CODE_128
            ],
            [
                core_1.Html5QrcodeSupportedFormats.DATA_MATRIX,
                ZXing.BarcodeFormat.DATA_MATRIX
            ],
            [
                core_1.Html5QrcodeSupportedFormats.MAXICODE,
                ZXing.BarcodeFormat.MAXICODE
            ],
            [core_1.Html5QrcodeSupportedFormats.ITF, ZXing.BarcodeFormat.ITF],
            [core_1.Html5QrcodeSupportedFormats.EAN_13, ZXing.BarcodeFormat.EAN_13],
            [core_1.Html5QrcodeSupportedFormats.EAN_8, ZXing.BarcodeFormat.EAN_8],
            [core_1.Html5QrcodeSupportedFormats.PDF_417, ZXing.BarcodeFormat.PDF_417],
            [core_1.Html5QrcodeSupportedFormats.RSS_14, ZXing.BarcodeFormat.RSS_14],
            [
                core_1.Html5QrcodeSupportedFormats.RSS_EXPANDED,
                ZXing.BarcodeFormat.RSS_EXPANDED
            ],
            [core_1.Html5QrcodeSupportedFormats.UPC_A, ZXing.BarcodeFormat.UPC_A],
            [core_1.Html5QrcodeSupportedFormats.UPC_E, ZXing.BarcodeFormat.UPC_E],
            [
                core_1.Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
                ZXing.BarcodeFormat.UPC_EAN_EXTENSION
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!ZXing) {
            throw "Use html5qrcode.min.js without edit, ZXing not found.";
        }
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createZXingFormats(requestedFormats);
        var hints = new Map();
        hints.set(ZXing.DecodeHintType.POSSIBLE_FORMATS, formats);
        hints.set(ZXing.DecodeHintType.TRY_HARDER, false);
        this.hints = hints;
    }
    ZXingHtml5QrcodeDecoder.prototype.decodeAsync = function (canvas) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                resolve(_this.decode(canvas));
            }
            catch (error) {
                reject(error);
            }
        });
    };
    ZXingHtml5QrcodeDecoder.prototype.decode = function (canvas) {
        var zxingDecoder = new ZXing.MultiFormatReader(this.verbose, this.hints);
        var luminanceSource = new ZXing.HTMLCanvasElementLuminanceSource(canvas);
        var binaryBitmap = new ZXing.BinaryBitmap(new ZXing.HybridBinarizer(luminanceSource));
        var result = zxingDecoder.decode(binaryBitmap);
        return {
            text: result.text,
            format: core_1.QrcodeResultFormat.create(this.toHtml5QrcodeSupportedFormats(result.format)),
            debugData: this.createDebugData()
        };
    };
    ZXingHtml5QrcodeDecoder.prototype.createReverseFormatMap = function () {
        var result = new Map();
        this.formatMap.forEach(function (value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    ZXingHtml5QrcodeDecoder.prototype.toHtml5QrcodeSupportedFormats = function (zxingFormat) {
        if (!this.reverseFormatMap.has(zxingFormat)) {
            throw "reverseFormatMap doesn't have ".concat(zxingFormat);
        }
        return this.reverseFormatMap.get(zxingFormat);
    };
    ZXingHtml5QrcodeDecoder.prototype.createZXingFormats = function (requestedFormats) {
        var zxingFormats = [];
        for (var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++) {
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) {
                zxingFormats.push(this.formatMap.get(requestedFormat));
            }
            else {
                this.logger.logError("".concat(requestedFormat, " is not supported by")
                    + "ZXingHtml5QrcodeShim");
            }
        }
        return zxingFormats;
    };
    ZXingHtml5QrcodeDecoder.prototype.createDebugData = function () {
        return { decoderName: "zxing-js" };
    };
    return ZXingHtml5QrcodeDecoder;
}());
exports.ZXingHtml5QrcodeDecoder = ZXingHtml5QrcodeDecoder;

},{"../third_party/zxing-js.umd":493,"./core":475}],493:[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ZXing = {}));
}(this, (function (exports) { 'use strict';

    function isNullOrUndefined(obj) {
        return obj === null || obj === undefined;
    }

    /*
     * Copyright 2008 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /* global Reflect, Promise */

    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    function fixProto(target, prototype) {
        var setPrototypeOf = Object.setPrototypeOf;
        setPrototypeOf ? setPrototypeOf(target, prototype) : (target.__proto__ = prototype);
    }

    function fixStack(target, fn) {
        if (fn === void 0) {
            fn = target.constructor;
        }
        var captureStackTrace = Error.captureStackTrace;
        captureStackTrace && captureStackTrace(target, fn);
    }

    var CustomError = (function (_super) {
        __extends(CustomError, _super);
        function CustomError(message) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            Object.defineProperty(_this, 'name', {
                value: _newTarget.name,
                enumerable: false
            });
            fixProto(_this, _newTarget.prototype);
            fixStack(_this);
            return _this;
        }
        
        return CustomError;
    })(Error);

    /**
     * Custom Error class of type Exception.
     */
    class Exception extends CustomError {
        /**
         * Allows Exception to be constructed directly
         * with some message and prototype definition.
         */
        constructor(message = undefined) {
            super(message);
            this.message = message;
        }
        getKind() {
            const ex = this.constructor;
            return ex.kind;
        }
    }
    /**
     * It's typed as string so it can be extended and overriden.
     */
    Exception.kind = 'Exception';

    /**
     * Custom Error class of type Exception.
     */
    class ArgumentException extends Exception {
    }
    ArgumentException.kind = 'ArgumentException';

    /**
     * Custom Error class of type Exception.
     */
    class IllegalArgumentException extends Exception {
    }
    IllegalArgumentException.kind = 'IllegalArgumentException';

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    class BinaryBitmap {
        constructor(binarizer) {
            this.binarizer = binarizer;
            if (binarizer === null) {
                throw new IllegalArgumentException('Binarizer must be non-null.');
            }
        }
        /**
         * @return The width of the bitmap.
         */
        getWidth() {
            return this.binarizer.getWidth();
        }
        /**
         * @return The height of the bitmap.
         */
        getHeight() {
            return this.binarizer.getHeight();
        }
        /**
         * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
         * cached data. Callers should assume this method is expensive and call it as seldom as possible.
         * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
         *
         * @param y The row to fetch, which must be in [0, bitmap height)
         * @param row An optional preallocated array. If null or too small, it will be ignored.
         *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
         * @return The array of bits for this row (true means black).
         * @throws NotFoundException if row can't be binarized
         */
        getBlackRow(y /*int*/, row) {
            return this.binarizer.getBlackRow(y, row);
        }
        /**
         * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
         * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
         * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
         * fetched using getBlackRow(), so don't mix and match between them.
         *
         * @return The 2D array of bits for the image (true means black).
         * @throws NotFoundException if image can't be binarized to make a matrix
         */
        getBlackMatrix() {
            // The matrix is created on demand the first time it is requested, then cached. There are two
            // reasons for this:
            // 1. This work will never be done if the caller only installs 1D Reader objects, or if a
            //    1D Reader finds a barcode before the 2D Readers run.
            // 2. This work will only be done once even if the caller installs multiple 2D Readers.
            if (this.matrix === null || this.matrix === undefined) {
                this.matrix = this.binarizer.getBlackMatrix();
            }
            return this.matrix;
        }
        /**
         * @return Whether this bitmap can be cropped.
         */
        isCropSupported() {
            return this.binarizer.getLuminanceSource().isCropSupported();
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */
        crop(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            const newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * @return Whether this bitmap supports counter-clockwise rotation.
         */
        isRotateSupported() {
            return this.binarizer.getLuminanceSource().isRotateSupported();
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */
        rotateCounterClockwise() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */
        rotateCounterClockwise45() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /*@Override*/
        toString() {
            try {
                return this.getBlackMatrix().toString();
            }
            catch (e /*: NotFoundException*/) {
                return '';
            }
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class ChecksumException extends Exception {
        static getChecksumInstance() {
            return new ChecksumException();
        }
    }
    ChecksumException.kind = 'ChecksumException';

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This class hierarchy provides a set of methods to convert luminance data to 1 bit data.
     * It allows the algorithm to vary polymorphically, for example allowing a very expensive
     * thresholding technique for servers and a fast one for mobile. It also permits the implementation
     * to vary, e.g. a JNI version for Android and a Java fallback version for other platforms.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class Binarizer {
        constructor(source) {
            this.source = source;
        }
        getLuminanceSource() {
            return this.source;
        }
        getWidth() {
            return this.source.getWidth();
        }
        getHeight() {
            return this.source.getHeight();
        }
    }

    class System {
        // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
        /**
         * Makes a copy of a array.
         */
        static arraycopy(src, srcPos, dest, destPos, length) {
            // TODO: better use split or set?
            while (length--) {
                dest[destPos++] = src[srcPos++];
            }
        }
        /**
         * Returns the current time in milliseconds.
         */
        static currentTimeMillis() {
            return Date.now();
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class IndexOutOfBoundsException extends Exception {
    }
    IndexOutOfBoundsException.kind = 'IndexOutOfBoundsException';

    /**
     * Custom Error class of type Exception.
     */
    class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
        constructor(index = undefined, message = undefined) {
            super(message);
            this.index = index;
            this.message = message;
        }
    }
    ArrayIndexOutOfBoundsException.kind = 'ArrayIndexOutOfBoundsException';

    class Arrays {
        /**
         * Assigns the specified int value to each element of the specified array
         * of ints.
         *
         * @param a the array to be filled
         * @param val the value to be stored in all elements of the array
         */
        static fill(a, val) {
            for (let i = 0, len = a.length; i < len; i++)
                a[i] = val;
        }
        /**
         * Assigns the specified int value to each element of the specified
         * range of the specified array of ints.  The range to be filled
         * extends from index {@code fromIndex}, inclusive, to index
         * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
         * range to be filled is empty.)
         *
         * @param a the array to be filled
         * @param fromIndex the index of the first element (inclusive) to be
         *        filled with the specified value
         * @param toIndex the index of the last element (exclusive) to be
         *        filled with the specified value
         * @param val the value to be stored in all elements of the array
         * @throws IllegalArgumentException if {@code fromIndex > toIndex}
         * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
         *         {@code toIndex > a.length}
         */
        static fillWithin(a, fromIndex, toIndex, val) {
            Arrays.rangeCheck(a.length, fromIndex, toIndex);
            for (let i = fromIndex; i < toIndex; i++)
                a[i] = val;
        }
        /**
         * Checks that {@code fromIndex} and {@code toIndex} are in
         * the range and throws an exception if they aren't.
         */
        static rangeCheck(arrayLength, fromIndex, toIndex) {
            if (fromIndex > toIndex) {
                throw new IllegalArgumentException('fromIndex(' + fromIndex + ') > toIndex(' + toIndex + ')');
            }
            if (fromIndex < 0) {
                throw new ArrayIndexOutOfBoundsException(fromIndex);
            }
            if (toIndex > arrayLength) {
                throw new ArrayIndexOutOfBoundsException(toIndex);
            }
        }
        static asList(...args) {
            return args;
        }
        static create(rows, cols, value) {
            let arr = Array.from({ length: rows });
            return arr.map(x => Array.from({ length: cols }).fill(value));
        }
        static createInt32Array(rows, cols, value) {
            let arr = Array.from({ length: rows });
            return arr.map(x => Int32Array.from({ length: cols }).fill(value));
        }
        static equals(first, second) {
            if (!first) {
                return false;
            }
            if (!second) {
                return false;
            }
            if (!first.length) {
                return false;
            }
            if (!second.length) {
                return false;
            }
            if (first.length !== second.length) {
                return false;
            }
            for (let i = 0, length = first.length; i < length; i++) {
                if (first[i] !== second[i]) {
                    return false;
                }
            }
            return true;
        }
        static hashCode(a) {
            if (a === null) {
                return 0;
            }
            let result = 1;
            for (const element of a) {
                result = 31 * result + element;
            }
            return result;
        }
        static fillUint8Array(a, value) {
            for (let i = 0; i !== a.length; i++) {
                a[i] = value;
            }
        }
        static copyOf(original, newLength) {
            return original.slice(0, newLength);
        }
        static copyOfUint8Array(original, newLength) {
            if (original.length <= newLength) {
                const newArray = new Uint8Array(newLength);
                newArray.set(original);
                return newArray;
            }
            return original.slice(0, newLength);
        }
        static copyOfRange(original, from, to) {
            const newLength = to - from;
            const copy = new Int32Array(newLength);
            System.arraycopy(original, from, copy, 0, newLength);
            return copy;
        }
        /*
        * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
        * for the new element.
        * Parameters:
        *     ar - A sorted array
        *     el - An element to search for
        *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
        *        a negative number  if a is less than b;
        *        0 if a is equal to b;
        *        a positive number of a is greater than b.
        * The array may contain duplicate elements. If there are more than one equal elements in the array,
        * the returned value can be the index of any one of the equal elements.
        *
        * http://jsfiddle.net/aryzhov/pkfst550/
        */
        static binarySearch(ar, el, comparator) {
            if (undefined === comparator) {
                comparator = Arrays.numberComparator;
            }
            let m = 0;
            let n = ar.length - 1;
            while (m <= n) {
                const k = (n + m) >> 1;
                const cmp = comparator(el, ar[k]);
                if (cmp > 0) {
                    m = k + 1;
                }
                else if (cmp < 0) {
                    n = k - 1;
                }
                else {
                    return k;
                }
            }
            return -m - 1;
        }
        static numberComparator(a, b) {
            return a - b;
        }
    }

    /**
     * Ponyfill for Java's Integer class.
     */
    class Integer {
        static numberOfTrailingZeros(i) {
            let y;
            if (i === 0)
                return 32;
            let n = 31;
            y = i << 16;
            if (y !== 0) {
                n -= 16;
                i = y;
            }
            y = i << 8;
            if (y !== 0) {
                n -= 8;
                i = y;
            }
            y = i << 4;
            if (y !== 0) {
                n -= 4;
                i = y;
            }
            y = i << 2;
            if (y !== 0) {
                n -= 2;
                i = y;
            }
            return n - ((i << 1) >>> 31);
        }
        static numberOfLeadingZeros(i) {
            // HD, Figure 5-6
            if (i === 0) {
                return 32;
            }
            let n = 1;
            if (i >>> 16 === 0) {
                n += 16;
                i <<= 16;
            }
            if (i >>> 24 === 0) {
                n += 8;
                i <<= 8;
            }
            if (i >>> 28 === 0) {
                n += 4;
                i <<= 4;
            }
            if (i >>> 30 === 0) {
                n += 2;
                i <<= 2;
            }
            n -= i >>> 31;
            return n;
        }
        static toHexString(i) {
            return i.toString(16);
        }
        static toBinaryString(intNumber) {
            return String(parseInt(String(intNumber), 2));
        }
        // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
        // Returns:
        // the number of one-bits in the two's complement binary representation of the specified int value.
        static bitCount(i) {
            // HD, Figure 5-2
            i = i - ((i >>> 1) & 0x55555555);
            i = (i & 0x33333333) + ((i >>> 2) & 0x33333333);
            i = (i + (i >>> 4)) & 0x0f0f0f0f;
            i = i + (i >>> 8);
            i = i + (i >>> 16);
            return i & 0x3f;
        }
        static truncDivision(dividend, divisor) {
            return Math.trunc(dividend / divisor);
        }
        /**
         * Converts A string to an integer.
         * @param s A string to convert into a number.
         * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
         */
        static parseInt(num, radix = undefined) {
            return parseInt(num, radix);
        }
    }
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;

    /**
     * <p>A simple, fast array of bits, represented compactly by an array of ints internally.</p>
     *
     * @author Sean Owen
     */
    class BitArray /*implements Cloneable*/ {
        // For testing only
        constructor(size /*int*/, bits) {
            if (undefined === size) {
                this.size = 0;
                this.bits = new Int32Array(1);
            }
            else {
                this.size = size;
                if (undefined === bits || null === bits) {
                    this.bits = BitArray.makeArray(size);
                }
                else {
                    this.bits = bits;
                }
            }
        }
        getSize() {
            return this.size;
        }
        getSizeInBytes() {
            return Math.floor((this.size + 7) / 8);
        }
        ensureCapacity(size /*int*/) {
            if (size > this.bits.length * 32) {
                const newBits = BitArray.makeArray(size);
                System.arraycopy(this.bits, 0, newBits, 0, this.bits.length);
                this.bits = newBits;
            }
        }
        /**
         * @param i bit to get
         * @return true iff bit i is set
         */
        get(i /*int*/) {
            return (this.bits[Math.floor(i / 32)] & (1 << (i & 0x1F))) !== 0;
        }
        /**
         * Sets bit i.
         *
         * @param i bit to set
         */
        set(i /*int*/) {
            this.bits[Math.floor(i / 32)] |= 1 << (i & 0x1F);
        }
        /**
         * Flips bit i.
         *
         * @param i bit to set
         */
        flip(i /*int*/) {
            this.bits[Math.floor(i / 32)] ^= 1 << (i & 0x1F);
        }
        /**
         * @param from first bit to check
         * @return index of first bit that is set, starting from the given index, or size if none are set
         *  at or beyond this given index
         * @see #getNextUnset(int)
         */
        getNextSet(from /*int*/) {
            const size = this.size;
            if (from >= size) {
                return size;
            }
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while (currentBits === 0) {
                if (++bitsOffset === length) {
                    return size;
                }
                currentBits = bits[bitsOffset];
            }
            const result = (bitsOffset * 32) + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * @param from index to start looking for unset bit
         * @return index of next unset bit, or {@code size} if none are unset until the end
         * @see #getNextSet(int)
         */
        getNextUnset(from /*int*/) {
            const size = this.size;
            if (from >= size) {
                return size;
            }
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = ~bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while (currentBits === 0) {
                if (++bitsOffset === length) {
                    return size;
                }
                currentBits = ~bits[bitsOffset];
            }
            const result = (bitsOffset * 32) + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * Sets a block of 32 bits, starting at bit i.
         *
         * @param i first bit to set
         * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
         * corresponds to bit i, the next-least-significant to i+1, and so on.
         */
        setBulk(i /*int*/, newBits /*int*/) {
            this.bits[Math.floor(i / 32)] = newBits;
        }
        /**
         * Sets a range of bits.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         */
        setRange(start /*int*/, end /*int*/) {
            if (end < start || start < 0 || end > this.size) {
                throw new IllegalArgumentException();
            }
            if (end === start) {
                return;
            }
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for (let i = firstInt; i <= lastInt; i++) {
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit);
                bits[i] |= mask;
            }
        }
        /**
         * Clears all bits (sets to false).
         */
        clear() {
            const max = this.bits.length;
            const bits = this.bits;
            for (let i = 0; i < max; i++) {
                bits[i] = 0;
            }
        }
        /**
         * Efficient method to check if a range of bits is set, or not set.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         * @param value if true, checks that bits in range are set, otherwise checks that they are not set
         * 
         * @return true iff all bits are set or not set in range, according to value argument
         * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
         */
        isRange(start /*int*/, end /*int*/, value) {
            if (end < start || start < 0 || end > this.size) {
                throw new IllegalArgumentException();
            }
            if (end === start) {
                return true; // empty range matches
            }
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for (let i = firstInt; i <= lastInt; i++) {
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit) & 0xFFFFFFFF;
                // TYPESCRIPTPORT: & 0xFFFFFFFF added to discard anything after 32 bits, as ES has 53 bits
                // Return false if we're looking for 1s and the masked bits[i] isn't all 1s (is: that,
                // equals the mask, or we're looking for 0s and the masked portion is not all 0s
                if ((bits[i] & mask) !== (value ? mask : 0)) {
                    return false;
                }
            }
            return true;
        }
        appendBit(bit) {
            this.ensureCapacity(this.size + 1);
            if (bit) {
                this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 0x1F);
            }
            this.size++;
        }
        /**
         * Appends the least-significant bits, from value, in order from most-significant to
         * least-significant. For example, appending 6 bits from 0x000001E will append the bits
         * 0, 1, 1, 1, 1, 0 in that order.
         *
         * @param value {@code int} containing bits to append
         * @param numBits bits from value to append
         */
        appendBits(value /*int*/, numBits /*int*/) {
            if (numBits < 0 || numBits > 32) {
                throw new IllegalArgumentException('Num bits must be between 0 and 32');
            }
            this.ensureCapacity(this.size + numBits);
            // const appendBit = this.appendBit;
            for (let numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--) {
                this.appendBit(((value >> (numBitsLeft - 1)) & 0x01) === 1);
            }
        }
        appendBitArray(other) {
            const otherSize = other.size;
            this.ensureCapacity(this.size + otherSize);
            // const appendBit = this.appendBit;
            for (let i = 0; i < otherSize; i++) {
                this.appendBit(other.get(i));
            }
        }
        xor(other) {
            if (this.size !== other.size) {
                throw new IllegalArgumentException('Sizes don\'t match');
            }
            const bits = this.bits;
            for (let i = 0, length = bits.length; i < length; i++) {
                // The last int could be incomplete (i.e. not have 32 bits in
                // it) but there is no problem since 0 XOR 0 == 0.
                bits[i] ^= other.bits[i];
            }
        }
        /**
         *
         * @param bitOffset first bit to start writing
         * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
         *  of the internal representation, which is exposed by {@link #getBitArray()}
         * @param offset position in array to start writing
         * @param numBytes how many bytes to write
         */
        toBytes(bitOffset /*int*/, array, offset /*int*/, numBytes /*int*/) {
            for (let i = 0; i < numBytes; i++) {
                let theByte = 0;
                for (let j = 0; j < 8; j++) {
                    if (this.get(bitOffset)) {
                        theByte |= 1 << (7 - j);
                    }
                    bitOffset++;
                }
                array[offset + i] = /*(byte)*/ theByte;
            }
        }
        /**
         * @return underlying array of ints. The first element holds the first 32 bits, and the least
         *         significant bit is bit 0.
         */
        getBitArray() {
            return this.bits;
        }
        /**
         * Reverses all bits in the array.
         */
        reverse() {
            const newBits = new Int32Array(this.bits.length);
            // reverse all int's first
            const len = Math.floor((this.size - 1) / 32);
            const oldBitsLen = len + 1;
            const bits = this.bits;
            for (let i = 0; i < oldBitsLen; i++) {
                let x = bits[i];
                x = ((x >> 1) & 0x55555555) | ((x & 0x55555555) << 1);
                x = ((x >> 2) & 0x33333333) | ((x & 0x33333333) << 2);
                x = ((x >> 4) & 0x0f0f0f0f) | ((x & 0x0f0f0f0f) << 4);
                x = ((x >> 8) & 0x00ff00ff) | ((x & 0x00ff00ff) << 8);
                x = ((x >> 16) & 0x0000ffff) | ((x & 0x0000ffff) << 16);
                newBits[len - i] = /*(int)*/ x;
            }
            // now correct the int's if the bit size isn't a multiple of 32
            if (this.size !== oldBitsLen * 32) {
                const leftOffset = oldBitsLen * 32 - this.size;
                let currentInt = newBits[0] >>> leftOffset;
                for (let i = 1; i < oldBitsLen; i++) {
                    const nextInt = newBits[i];
                    currentInt |= nextInt << (32 - leftOffset);
                    newBits[i - 1] = currentInt;
                    currentInt = nextInt >>> leftOffset;
                }
                newBits[oldBitsLen - 1] = currentInt;
            }
            this.bits = newBits;
        }
        static makeArray(size /*int*/) {
            return new Int32Array(Math.floor((size + 31) / 32));
        }
        /*@Override*/
        equals(o) {
            if (!(o instanceof BitArray)) {
                return false;
            }
            const other = o;
            return this.size === other.size && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/
        hashCode() {
            return 31 * this.size + Arrays.hashCode(this.bits);
        }
        /*@Override*/
        toString() {
            let result = '';
            for (let i = 0, size = this.size; i < size; i++) {
                if ((i & 0x07) === 0) {
                    result += ' ';
                }
                result += this.get(i) ? 'X' : '.';
            }
            return result;
        }
        /*@Override*/
        clone() {
            return new BitArray(this.size, this.bits.slice());
        }
    }

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing {*/
    /**
     * Encapsulates a type of hint that a caller may pass to a barcode reader to help it
     * more quickly or accurately decode it. It is up to implementations to decide what,
     * if anything, to do with the information that is supplied.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     * @see Reader#decode(BinaryBitmap,java.util.Map)
     */
    var DecodeHintType;
    (function (DecodeHintType) {
        /**
         * Unspecified, application-specific hint. Maps to an unspecified {@link Object}.
         */
        DecodeHintType[DecodeHintType["OTHER"] = 0] = "OTHER"; /*(Object.class)*/
        /**
         * Image is a pure monochrome image of a barcode. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */
        DecodeHintType[DecodeHintType["PURE_BARCODE"] = 1] = "PURE_BARCODE"; /*(Void.class)*/
        /**
         * Image is known to be of one of a few possible formats.
         * Maps to a {@link List} of {@link BarcodeFormat}s.
         */
        DecodeHintType[DecodeHintType["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS"; /*(List.class)*/
        /**
         * Spend more time to try to find a barcode; optimize for accuracy, not speed.
         * Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */
        DecodeHintType[DecodeHintType["TRY_HARDER"] = 3] = "TRY_HARDER"; /*(Void.class)*/
        /**
         * Specifies what character encoding to use when decoding, where applicable (type String)
         */
        DecodeHintType[DecodeHintType["CHARACTER_SET"] = 4] = "CHARACTER_SET"; /*(String.class)*/
        /**
         * Allowed lengths of encoded data -- reject anything else. Maps to an {@code Int32Array}.
         */
        DecodeHintType[DecodeHintType["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS"; /*(Int32Array.class)*/
        /**
         * Assume Code 39 codes employ a check digit. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */
        DecodeHintType[DecodeHintType["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT"; /*(Void.class)*/
        /**
         * Assume the barcode is being processed as a GS1 barcode, and modify behavior as needed.
         * For example this affects FNC1 handling for Code 128 (aka GS1-128). Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */
        DecodeHintType[DecodeHintType["ASSUME_GS1"] = 7] = "ASSUME_GS1"; /*(Void.class)*/
        /**
         * If true, return the start and end digits in a Codabar barcode instead of stripping them. They
         * are alpha, whereas the rest are numeric. By default, they are stripped, but this causes them
         * to not be. Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */
        DecodeHintType[DecodeHintType["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END"; /*(Void.class)*/
        /**
         * The caller needs to be notified via callback when a possible {@link ResultPoint}
         * is found. Maps to a {@link ResultPointCallback}.
         */
        DecodeHintType[DecodeHintType["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK"; /*(ResultPointCallback.class)*/
        /**
         * Allowed extension lengths for EAN or UPC barcodes. Other formats will ignore this.
         * Maps to an {@code Int32Array} of the allowed extension lengths, for example [2], [5], or [2, 5].
         * If it is optional to have an extension, do not set this hint. If this is set,
         * and a UPC or EAN barcode is found but an extension is not, then no result will be returned
         * at all.
         */
        DecodeHintType[DecodeHintType["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS"; /*(Int32Array.class)*/
        // End of enumeration values.
        /**
         * Data type the hint is expecting.
         * Among the possible values the {@link Void} stands out as being used for
         * hints that do not expect a value to be supplied (flag hints). Such hints
         * will possibly have their value ignored, or replaced by a
         * {@link Boolean#TRUE}. Hint suppliers should probably use
         * {@link Boolean#TRUE} as directed by the actual hint documentation.
         */
        // private valueType: Class<?>
        // DecodeHintType(valueType: Class<?>) {
        //   this.valueType = valueType
        // }
        // public getValueType(): Class<?> {
        //   return valueType
        // }
    })(DecodeHintType || (DecodeHintType = {}));
    var DecodeHintType$1 = DecodeHintType;

    /**
     * Custom Error class of type Exception.
     */
    class FormatException extends Exception {
        static getFormatInstance() {
            return new FormatException();
        }
    }
    FormatException.kind = 'FormatException';

    /*import java.util.HashMap;*/
    /*import java.util.Map;*/
    var CharacterSetValueIdentifiers;
    (function (CharacterSetValueIdentifiers) {
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp437"] = 0] = "Cp437";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_1"] = 1] = "ISO8859_1";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_2"] = 2] = "ISO8859_2";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_3"] = 3] = "ISO8859_3";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_4"] = 4] = "ISO8859_4";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_5"] = 5] = "ISO8859_5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_6"] = 6] = "ISO8859_6";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_7"] = 7] = "ISO8859_7";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_8"] = 8] = "ISO8859_8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_9"] = 9] = "ISO8859_9";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_10"] = 10] = "ISO8859_10";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_11"] = 11] = "ISO8859_11";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_13"] = 12] = "ISO8859_13";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_14"] = 13] = "ISO8859_14";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_15"] = 14] = "ISO8859_15";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_16"] = 15] = "ISO8859_16";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["SJIS"] = 16] = "SJIS";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1250"] = 17] = "Cp1250";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1251"] = 18] = "Cp1251";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1252"] = 19] = "Cp1252";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1256"] = 20] = "Cp1256";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UTF8"] = 22] = "UTF8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ASCII"] = 23] = "ASCII";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Big5"] = 24] = "Big5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["GB18030"] = 25] = "GB18030";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["EUC_KR"] = 26] = "EUC_KR";
    })(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
    /**
     * Encapsulates a Character Set ECI, according to "Extended Channel Interpretations" 5.3.1.1
     * of ISO 18004.
     *
     * @author Sean Owen
     */
    class CharacterSetECI {
        constructor(valueIdentifier, valuesParam, name, ...otherEncodingNames) {
            this.valueIdentifier = valueIdentifier;
            this.name = name;
            if (typeof valuesParam === 'number') {
                this.values = Int32Array.from([valuesParam]);
            }
            else {
                this.values = valuesParam;
            }
            this.otherEncodingNames = otherEncodingNames;
            CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
            CharacterSetECI.NAME_TO_ECI.set(name, this);
            const values = this.values;
            for (let i = 0, length = values.length; i !== length; i++) {
                const v = values[i];
                CharacterSetECI.VALUES_TO_ECI.set(v, this);
            }
            for (const otherName of otherEncodingNames) {
                CharacterSetECI.NAME_TO_ECI.set(otherName, this);
            }
        }
        // CharacterSetECI(value: number /*int*/) {
        //   this(new Int32Array {value})
        // }
        // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
        //   this.values = new Int32Array {value}
        //   this.otherEncodingNames = otherEncodingNames
        // }
        // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
        //   this.values = values
        //   this.otherEncodingNames = otherEncodingNames
        // }
        getValueIdentifier() {
            return this.valueIdentifier;
        }
        getName() {
            return this.name;
        }
        getValue() {
            return this.values[0];
        }
        /**
         * @param value character set ECI value
         * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
         *   unsupported
         * @throws FormatException if ECI value is invalid
         */
        static getCharacterSetECIByValue(value /*int*/) {
            if (value < 0 || value >= 900) {
                throw new FormatException('incorect value');
            }
            const characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
            if (undefined === characterSet) {
                throw new FormatException('incorect value');
            }
            return characterSet;
        }
        /**
         * @param name character set ECI encoding name
         * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
         *   but unsupported
         */
        static getCharacterSetECIByName(name) {
            const characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
            if (undefined === characterSet) {
                throw new FormatException('incorect value');
            }
            return characterSet;
        }
        equals(o) {
            if (!(o instanceof CharacterSetECI)) {
                return false;
            }
            const other = o;
            return this.getName() === other.getName();
        }
    }
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = new Map();
    CharacterSetECI.VALUES_TO_ECI = new Map();
    CharacterSetECI.NAME_TO_ECI = new Map();
    // Enum name is a Java encoding valid for java.lang and java.io
    // TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
    // (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
    // later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
    CharacterSetECI.Cp437 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp437, Int32Array.from([0, 2]), 'Cp437');
    CharacterSetECI.ISO8859_1 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_1, Int32Array.from([1, 3]), 'ISO-8859-1', 'ISO88591', 'ISO8859_1');
    CharacterSetECI.ISO8859_2 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_2, 4, 'ISO-8859-2', 'ISO88592', 'ISO8859_2');
    CharacterSetECI.ISO8859_3 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_3, 5, 'ISO-8859-3', 'ISO88593', 'ISO8859_3');
    CharacterSetECI.ISO8859_4 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_4, 6, 'ISO-8859-4', 'ISO88594', 'ISO8859_4');
    CharacterSetECI.ISO8859_5 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_5, 7, 'ISO-8859-5', 'ISO88595', 'ISO8859_5');
    CharacterSetECI.ISO8859_6 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_6, 8, 'ISO-8859-6', 'ISO88596', 'ISO8859_6');
    CharacterSetECI.ISO8859_7 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_7, 9, 'ISO-8859-7', 'ISO88597', 'ISO8859_7');
    CharacterSetECI.ISO8859_8 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_8, 10, 'ISO-8859-8', 'ISO88598', 'ISO8859_8');
    CharacterSetECI.ISO8859_9 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_9, 11, 'ISO-8859-9', 'ISO88599', 'ISO8859_9');
    CharacterSetECI.ISO8859_10 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_10, 12, 'ISO-8859-10', 'ISO885910', 'ISO8859_10');
    CharacterSetECI.ISO8859_11 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_11, 13, 'ISO-8859-11', 'ISO885911', 'ISO8859_11');
    CharacterSetECI.ISO8859_13 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_13, 15, 'ISO-8859-13', 'ISO885913', 'ISO8859_13');
    CharacterSetECI.ISO8859_14 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_14, 16, 'ISO-8859-14', 'ISO885914', 'ISO8859_14');
    CharacterSetECI.ISO8859_15 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_15, 17, 'ISO-8859-15', 'ISO885915', 'ISO8859_15');
    CharacterSetECI.ISO8859_16 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_16, 18, 'ISO-8859-16', 'ISO885916', 'ISO8859_16');
    CharacterSetECI.SJIS = new CharacterSetECI(CharacterSetValueIdentifiers.SJIS, 20, 'SJIS', 'Shift_JIS');
    CharacterSetECI.Cp1250 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1250, 21, 'Cp1250', 'windows-1250');
    CharacterSetECI.Cp1251 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1251, 22, 'Cp1251', 'windows-1251');
    CharacterSetECI.Cp1252 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1252, 23, 'Cp1252', 'windows-1252');
    CharacterSetECI.Cp1256 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1256, 24, 'Cp1256', 'windows-1256');
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI(CharacterSetValueIdentifiers.UnicodeBigUnmarked, 25, 'UnicodeBigUnmarked', 'UTF-16BE', 'UnicodeBig');
    CharacterSetECI.UTF8 = new CharacterSetECI(CharacterSetValueIdentifiers.UTF8, 26, 'UTF8', 'UTF-8');
    CharacterSetECI.ASCII = new CharacterSetECI(CharacterSetValueIdentifiers.ASCII, Int32Array.from([27, 170]), 'ASCII', 'US-ASCII');
    CharacterSetECI.Big5 = new CharacterSetECI(CharacterSetValueIdentifiers.Big5, 28, 'Big5');
    CharacterSetECI.GB18030 = new CharacterSetECI(CharacterSetValueIdentifiers.GB18030, 29, 'GB18030', 'GB2312', 'EUC_CN', 'GBK');
    CharacterSetECI.EUC_KR = new CharacterSetECI(CharacterSetValueIdentifiers.EUC_KR, 30, 'EUC_KR', 'EUC-KR');

    /**
     * Custom Error class of type Exception.
     */
    class UnsupportedOperationException extends Exception {
    }
    UnsupportedOperationException.kind = 'UnsupportedOperationException';

    /**
     * Responsible for en/decoding strings.
     */
    class StringEncoding {
        /**
         * Decodes some Uint8Array to a string format.
         */
        static decode(bytes, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customDecoder) {
                return this.customDecoder(bytes, encodingName);
            }
            // Increases browser support.
            if (typeof TextDecoder === 'undefined' || this.shouldDecodeOnFallback(encodingName)) {
                return this.decodeFallback(bytes, encodingName);
            }
            return new TextDecoder(encodingName).decode(bytes);
        }
        /**
         * Checks if the decoding method should use the fallback for decoding
         * once Node TextDecoder doesn't support all encoding formats.
         *
         * @param encodingName
         */
        static shouldDecodeOnFallback(encodingName) {
            return !StringEncoding.isBrowser() && encodingName === 'ISO-8859-1';
        }
        /**
         * Encodes some string into a Uint8Array.
         */
        static encode(s, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customEncoder) {
                return this.customEncoder(s, encodingName);
            }
            // Increases browser support.
            if (typeof TextEncoder === 'undefined') {
                return this.encodeFallback(s);
            }
            // TextEncoder only encodes to UTF8 by default as specified by encoding.spec.whatwg.org
            return new TextEncoder().encode(s);
        }
        static isBrowser() {
            return (typeof window !== 'undefined' && {}.toString.call(window) === '[object Window]');
        }
        /**
         * Returns the string value from some encoding character set.
         */
        static encodingName(encoding) {
            return typeof encoding === 'string'
                ? encoding
                : encoding.getName();
        }
        /**
         * Returns character set from some encoding character set.
         */
        static encodingCharacterSet(encoding) {
            if (encoding instanceof CharacterSetECI) {
                return encoding;
            }
            return CharacterSetECI.getCharacterSetECIByName(encoding);
        }
        /**
         * Runs a fallback for the native decoding funcion.
         */
        static decodeFallback(bytes, encoding) {
            const characterSet = this.encodingCharacterSet(encoding);
            if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
                let s = '';
                for (let i = 0, length = bytes.length; i < length; i++) {
                    let h = bytes[i].toString(16);
                    if (h.length < 2) {
                        h = '0' + h;
                    }
                    s += '%' + h;
                }
                return decodeURIComponent(s);
            }
            if (characterSet.equals(CharacterSetECI.UnicodeBigUnmarked)) {
                return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
            }
            throw new UnsupportedOperationException(`Encoding ${this.encodingName(encoding)} not supported by fallback.`);
        }
        static isDecodeFallbackSupported(characterSet) {
            return characterSet.equals(CharacterSetECI.UTF8) ||
                characterSet.equals(CharacterSetECI.ISO8859_1) ||
                characterSet.equals(CharacterSetECI.ASCII);
        }
        /**
         * Runs a fallback for the native encoding funcion.
         *
         * @see https://stackoverflow.com/a/17192845/4367683
         */
        static encodeFallback(s) {
            const encodedURIstring = btoa(unescape(encodeURIComponent(s)));
            const charList = encodedURIstring.split('');
            const uintArray = [];
            for (let i = 0; i < charList.length; i++) {
                uintArray.push(charList[i].charCodeAt(0));
            }
            return new Uint8Array(uintArray);
        }
    }

    /*
     * Copyright (C) 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * Common string-related functions.
     *
     * @author Sean Owen
     * @author Alex Dupre
     */
    class StringUtils {
        // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
        // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
        static castAsNonUtf8Char(code, encoding = null) {
            // ISO 8859-1 is the Java default as UTF-8 is JavaScripts
            // you can see this method as a Java version of String.fromCharCode
            const e = encoding ? encoding.getName() : this.ISO88591;
            // use passed format (fromCharCode will return UTF8 encoding)
            return StringEncoding.decode(new Uint8Array([code]), e);
        }
        /**
         * @param bytes bytes encoding a string, whose encoding should be guessed
         * @param hints decode hints if applicable
         * @return name of guessed encoding; at the moment will only guess one of:
         *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
         *  default encoding if none of these can possibly be correct
         */
        static guessEncoding(bytes, hints) {
            if (hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.CHARACTER_SET)) {
                return hints.get(DecodeHintType$1.CHARACTER_SET).toString();
            }
            // For now, merely tries to distinguish ISO-8859-1, UTF-8 and Shift_JIS,
            // which should be by far the most common encodings.
            const length = bytes.length;
            let canBeISO88591 = true;
            let canBeShiftJIS = true;
            let canBeUTF8 = true;
            let utf8BytesLeft = 0;
            // int utf8LowChars = 0
            let utf2BytesChars = 0;
            let utf3BytesChars = 0;
            let utf4BytesChars = 0;
            let sjisBytesLeft = 0;
            // int sjisLowChars = 0
            let sjisKatakanaChars = 0;
            // int sjisDoubleBytesChars = 0
            let sjisCurKatakanaWordLength = 0;
            let sjisCurDoubleBytesWordLength = 0;
            let sjisMaxKatakanaWordLength = 0;
            let sjisMaxDoubleBytesWordLength = 0;
            // int isoLowChars = 0
            // int isoHighChars = 0
            let isoHighOther = 0;
            const utf8bom = bytes.length > 3 &&
                bytes[0] === /*(byte) */ 0xEF &&
                bytes[1] === /*(byte) */ 0xBB &&
                bytes[2] === /*(byte) */ 0xBF;
            for (let i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++) {
                const value = bytes[i] & 0xFF;
                // UTF-8 stuff
                if (canBeUTF8) {
                    if (utf8BytesLeft > 0) {
                        if ((value & 0x80) === 0) {
                            canBeUTF8 = false;
                        }
                        else {
                            utf8BytesLeft--;
                        }
                    }
                    else if ((value & 0x80) !== 0) {
                        if ((value & 0x40) === 0) {
                            canBeUTF8 = false;
                        }
                        else {
                            utf8BytesLeft++;
                            if ((value & 0x20) === 0) {
                                utf2BytesChars++;
                            }
                            else {
                                utf8BytesLeft++;
                                if ((value & 0x10) === 0) {
                                    utf3BytesChars++;
                                }
                                else {
                                    utf8BytesLeft++;
                                    if ((value & 0x08) === 0) {
                                        utf4BytesChars++;
                                    }
                                    else {
                                        canBeUTF8 = false;
                                    }
                                }
                            }
                        }
                    } // else {
                    // utf8LowChars++
                    // }
                }
                // ISO-8859-1 stuff
                if (canBeISO88591) {
                    if (value > 0x7F && value < 0xA0) {
                        canBeISO88591 = false;
                    }
                    else if (value > 0x9F) {
                        if (value < 0xC0 || value === 0xD7 || value === 0xF7) {
                            isoHighOther++;
                        } // else {
                        // isoHighChars++
                        // }
                    } // else {
                    // isoLowChars++
                    // }
                }
                // Shift_JIS stuff
                if (canBeShiftJIS) {
                    if (sjisBytesLeft > 0) {
                        if (value < 0x40 || value === 0x7F || value > 0xFC) {
                            canBeShiftJIS = false;
                        }
                        else {
                            sjisBytesLeft--;
                        }
                    }
                    else if (value === 0x80 || value === 0xA0 || value > 0xEF) {
                        canBeShiftJIS = false;
                    }
                    else if (value > 0xA0 && value < 0xE0) {
                        sjisKatakanaChars++;
                        sjisCurDoubleBytesWordLength = 0;
                        sjisCurKatakanaWordLength++;
                        if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) {
                            sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
                        }
                    }
                    else if (value > 0x7F) {
                        sjisBytesLeft++;
                        // sjisDoubleBytesChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength++;
                        if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) {
                            sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
                        }
                    }
                    else {
                        // sjisLowChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength = 0;
                    }
                }
            }
            if (canBeUTF8 && utf8BytesLeft > 0) {
                canBeUTF8 = false;
            }
            if (canBeShiftJIS && sjisBytesLeft > 0) {
                canBeShiftJIS = false;
            }
            // Easy -- if there is BOM or at least 1 valid not-single byte character (and no evidence it can't be UTF-8), done
            if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) {
                return StringUtils.UTF8;
            }
            // Easy -- if assuming Shift_JIS or at least 3 valid consecutive not-ascii characters (and no evidence it can't be), done
            if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) {
                return StringUtils.SHIFT_JIS;
            }
            // Distinguishing Shift_JIS and ISO-8859-1 can be a little tough for short words. The crude heuristic is:
            // - If we saw
            //   - only two consecutive katakana chars in the whole text, or
            //   - at least 10% of bytes that could be "upper" not-alphanumeric Latin1,
            // - then we conclude Shift_JIS, else ISO-8859-1
            if (canBeISO88591 && canBeShiftJIS) {
                return (sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2) || isoHighOther * 10 >= length
                    ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
            }
            // Otherwise, try in order ISO-8859-1, Shift JIS, UTF-8 and fall back to default platform encoding
            if (canBeISO88591) {
                return StringUtils.ISO88591;
            }
            if (canBeShiftJIS) {
                return StringUtils.SHIFT_JIS;
            }
            if (canBeUTF8) {
                return StringUtils.UTF8;
            }
            // Otherwise, we take a wild guess with platform encoding
            return StringUtils.PLATFORM_DEFAULT_ENCODING;
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */
        static format(append, ...args) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%')
                    return '%';
                if (args[++i] === undefined)
                    return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch (p4) {
                    case 's':
                        val = args[i];
                        break;
                    case 'c':
                        val = args[i][0];
                        break;
                    case 'f':
                        val = parseFloat(args[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(args[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(args[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(args[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */
                let ch = p1 && (p1[0] + '') === '0' ? '0' : ' '; /* isnull? */
                while (val.length < size)
                    val = p0 !== undefined ? val + ch : ch + val; /* isminus? */
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return append.replace(regex, callback);
        }
        /**
         *
         */
        static getBytes(str, encoding) {
            return StringEncoding.encode(str, encoding);
        }
        /**
         * Returns the charcode at the specified index or at index zero.
         */
        static getCharCode(str, index = 0) {
            return str.charCodeAt(index);
        }
        /**
         * Returns char for given charcode
         */
        static getCharAt(charCode) {
            return String.fromCharCode(charCode);
        }
    }
    StringUtils.SHIFT_JIS = CharacterSetECI.SJIS.getName(); // "SJIS"
    StringUtils.GB2312 = 'GB2312';
    StringUtils.ISO88591 = CharacterSetECI.ISO8859_1.getName(); // "ISO8859_1"
    StringUtils.EUC_JP = 'EUC_JP';
    StringUtils.UTF8 = CharacterSetECI.UTF8.getName(); // "UTF8"
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8; // "UTF8"//Charset.defaultCharset().name()
    StringUtils.ASSUME_SHIFT_JIS = false;

    class StringBuilder {
        constructor(value = '') {
            this.value = value;
        }
        enableDecoding(encoding) {
            this.encoding = encoding;
            return this;
        }
        append(s) {
            if (typeof s === 'string') {
                this.value += s.toString();
            }
            else if (this.encoding) {
                // use passed format (fromCharCode will return UTF8 encoding)
                this.value += StringUtils.castAsNonUtf8Char(s, this.encoding);
            }
            else {
                // correctly converts from UTF-8, but not other encodings
                this.value += String.fromCharCode(s);
            }
            return this;
        }
        appendChars(str, offset, len) {
            for (let i = offset; offset < offset + len; i++) {
                this.append(str[i]);
            }
            return this;
        }
        length() {
            return this.value.length;
        }
        charAt(n) {
            return this.value.charAt(n);
        }
        deleteCharAt(n) {
            this.value = this.value.substr(0, n) + this.value.substring(n + 1);
        }
        setCharAt(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
        }
        substring(start, end) {
            return this.value.substring(start, end);
        }
        /**
         * @note helper method for RSS Expanded
         */
        setLengthToZero() {
            this.value = '';
        }
        toString() {
            return this.value;
        }
        insert(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + c.length);
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Represents a 2D matrix of bits. In function arguments below, and throughout the common
     * module, x is the column position, and y is the row position. The ordering is always x, y.
     * The origin is at the top-left.</p>
     *
     * <p>Internally the bits are represented in a 1-D array of 32-bit ints. However, each row begins
     * with a new int. This is done intentionally so that we can copy out a row into a BitArray very
     * efficiently.</p>
     *
     * <p>The ordering of bits is row-major. Within each int, the least significant bits are used first,
     * meaning they represent lower x values. This is compatible with BitArray's implementation.</p>
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class BitMatrix /*implements Cloneable*/ {
        /**
         * Creates an empty square {@link BitMatrix}.
         *
         * @param dimension height and width
         */
        // public constructor(dimension: number /*int*/) {
        //   this(dimension, dimension)
        // }
        /**
         * Creates an empty {@link BitMatrix}.
         *
         * @param width bit matrix width
         * @param height bit matrix height
         */
        // public constructor(width: number /*int*/, height: number /*int*/) {
        //   if (width < 1 || height < 1) {
        //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
        //   }
        //   this.width = width
        //   this.height = height
        //   this.rowSize = (width + 31) / 32
        //   bits = new int[rowSize * height];
        // }
        constructor(width /*int*/, height /*int*/, rowSize /*int*/, bits) {
            this.width = width;
            this.height = height;
            this.rowSize = rowSize;
            this.bits = bits;
            if (undefined === height || null === height) {
                height = width;
            }
            this.height = height;
            if (width < 1 || height < 1) {
                throw new IllegalArgumentException('Both dimensions must be greater than 0');
            }
            if (undefined === rowSize || null === rowSize) {
                rowSize = Math.floor((width + 31) / 32);
            }
            this.rowSize = rowSize;
            if (undefined === bits || null === bits) {
                this.bits = new Int32Array(this.rowSize * this.height);
            }
        }
        /**
         * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
         *
         * @function parse
         * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
         * @return {@link BitMatrix} representation of image
         */
        static parseFromBooleanArray(image) {
            const height = image.length;
            const width = image[0].length;
            const bits = new BitMatrix(width, height);
            for (let i = 0; i < height; i++) {
                const imageI = image[i];
                for (let j = 0; j < width; j++) {
                    if (imageI[j]) {
                        bits.set(j, i);
                    }
                }
            }
            return bits;
        }
        /**
         *
         * @function parse
         * @param stringRepresentation
         * @param setString
         * @param unsetString
         */
        static parseFromString(stringRepresentation, setString, unsetString) {
            if (stringRepresentation === null) {
                throw new IllegalArgumentException('stringRepresentation cannot be null');
            }
            const bits = new Array(stringRepresentation.length);
            let bitsPos = 0;
            let rowStartPos = 0;
            let rowLength = -1;
            let nRows = 0;
            let pos = 0;
            while (pos < stringRepresentation.length) {
                if (stringRepresentation.charAt(pos) === '\n' ||
                    stringRepresentation.charAt(pos) === '\r') {
                    if (bitsPos > rowStartPos) {
                        if (rowLength === -1) {
                            rowLength = bitsPos - rowStartPos;
                        }
                        else if (bitsPos - rowStartPos !== rowLength) {
                            throw new IllegalArgumentException('row lengths do not match');
                        }
                        rowStartPos = bitsPos;
                        nRows++;
                    }
                    pos++;
                }
                else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
                    pos += setString.length;
                    bits[bitsPos] = true;
                    bitsPos++;
                }
                else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
                    pos += unsetString.length;
                    bits[bitsPos] = false;
                    bitsPos++;
                }
                else {
                    throw new IllegalArgumentException('illegal character encountered: ' + stringRepresentation.substring(pos));
                }
            }
            // no EOL at end?
            if (bitsPos > rowStartPos) {
                if (rowLength === -1) {
                    rowLength = bitsPos - rowStartPos;
                }
                else if (bitsPos - rowStartPos !== rowLength) {
                    throw new IllegalArgumentException('row lengths do not match');
                }
                nRows++;
            }
            const matrix = new BitMatrix(rowLength, nRows);
            for (let i = 0; i < bitsPos; i++) {
                if (bits[i]) {
                    matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
                }
            }
            return matrix;
        }
        /**
         * <p>Gets the requested bit, where true means black.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         * @return value of given bit in matrix
         */
        get(x /*int*/, y /*int*/) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            return ((this.bits[offset] >>> (x & 0x1f)) & 1) !== 0;
        }
        /**
         * <p>Sets the given bit to true.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */
        set(x /*int*/, y /*int*/) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] |= (1 << (x & 0x1f)) & 0xFFFFFFFF;
        }
        unset(x /*int*/, y /*int*/) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] &= ~((1 << (x & 0x1f)) & 0xFFFFFFFF);
        }
        /**
         * <p>Flips the given bit.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */
        flip(x /*int*/, y /*int*/) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] ^= ((1 << (x & 0x1f)) & 0xFFFFFFFF);
        }
        /**
         * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
         * mask bit is set.
         *
         * @param mask XOR mask
         */
        xor(mask) {
            if (this.width !== mask.getWidth() || this.height !== mask.getHeight()
                || this.rowSize !== mask.getRowSize()) {
                throw new IllegalArgumentException('input matrix dimensions do not match');
            }
            const rowArray = new BitArray(Math.floor(this.width / 32) + 1);
            const rowSize = this.rowSize;
            const bits = this.bits;
            for (let y = 0, height = this.height; y < height; y++) {
                const offset = y * rowSize;
                const row = mask.getRow(y, rowArray).getBitArray();
                for (let x = 0; x < rowSize; x++) {
                    bits[offset + x] ^= row[x];
                }
            }
        }
        /**
         * Clears all bits (sets to false).
         */
        clear() {
            const bits = this.bits;
            const max = bits.length;
            for (let i = 0; i < max; i++) {
                bits[i] = 0;
            }
        }
        /**
         * <p>Sets a square region of the bit matrix to true.</p>
         *
         * @param left The horizontal position to begin at (inclusive)
         * @param top The vertical position to begin at (inclusive)
         * @param width The width of the region
         * @param height The height of the region
         */
        setRegion(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            if (top < 0 || left < 0) {
                throw new IllegalArgumentException('Left and top must be nonnegative');
            }
            if (height < 1 || width < 1) {
                throw new IllegalArgumentException('Height and width must be at least 1');
            }
            const right = left + width;
            const bottom = top + height;
            if (bottom > this.height || right > this.width) {
                throw new IllegalArgumentException('The region must fit inside the matrix');
            }
            const rowSize = this.rowSize;
            const bits = this.bits;
            for (let y = top; y < bottom; y++) {
                const offset = y * rowSize;
                for (let x = left; x < right; x++) {
                    bits[offset + Math.floor(x / 32)] |= ((1 << (x & 0x1f)) & 0xFFFFFFFF);
                }
            }
        }
        /**
         * A fast method to retrieve one row of data from the matrix as a BitArray.
         *
         * @param y The row to retrieve
         * @param row An optional caller-allocated BitArray, will be allocated if null or too small
         * @return The resulting BitArray - this reference should always be used even when passing
         *         your own row
         */
        getRow(y /*int*/, row) {
            if (row === null || row === undefined || row.getSize() < this.width) {
                row = new BitArray(this.width);
            }
            else {
                row.clear();
            }
            const rowSize = this.rowSize;
            const bits = this.bits;
            const offset = y * rowSize;
            for (let x = 0; x < rowSize; x++) {
                row.setBulk(x * 32, bits[offset + x]);
            }
            return row;
        }
        /**
         * @param y row to set
         * @param row {@link BitArray} to copy from
         */
        setRow(y /*int*/, row) {
            System.arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
        }
        /**
         * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
         */
        rotate180() {
            const width = this.getWidth();
            const height = this.getHeight();
            let topRow = new BitArray(width);
            let bottomRow = new BitArray(width);
            for (let i = 0, length = Math.floor((height + 1) / 2); i < length; i++) {
                topRow = this.getRow(i, topRow);
                bottomRow = this.getRow(height - 1 - i, bottomRow);
                topRow.reverse();
                bottomRow.reverse();
                this.setRow(i, bottomRow);
                this.setRow(height - 1 - i, topRow);
            }
        }
        /**
         * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
         *
         * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
         */
        getEnclosingRectangle() {
            const width = this.width;
            const height = this.height;
            const rowSize = this.rowSize;
            const bits = this.bits;
            let left = width;
            let top = height;
            let right = -1;
            let bottom = -1;
            for (let y = 0; y < height; y++) {
                for (let x32 = 0; x32 < rowSize; x32++) {
                    const theBits = bits[y * rowSize + x32];
                    if (theBits !== 0) {
                        if (y < top) {
                            top = y;
                        }
                        if (y > bottom) {
                            bottom = y;
                        }
                        if (x32 * 32 < left) {
                            let bit = 0;
                            while (((theBits << (31 - bit)) & 0xFFFFFFFF) === 0) {
                                bit++;
                            }
                            if ((x32 * 32 + bit) < left) {
                                left = x32 * 32 + bit;
                            }
                        }
                        if (x32 * 32 + 31 > right) {
                            let bit = 31;
                            while ((theBits >>> bit) === 0) {
                                bit--;
                            }
                            if ((x32 * 32 + bit) > right) {
                                right = x32 * 32 + bit;
                            }
                        }
                    }
                }
            }
            if (right < left || bottom < top) {
                return null;
            }
            return Int32Array.from([left, top, right - left + 1, bottom - top + 1]);
        }
        /**
         * This is useful in detecting a corner of a 'pure' barcode.
         *
         * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
         */
        getTopLeftOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = 0;
            while (bitsOffset < bits.length && bits[bitsOffset] === 0) {
                bitsOffset++;
            }
            if (bitsOffset === bits.length) {
                return null;
            }
            const y = bitsOffset / rowSize;
            let x = (bitsOffset % rowSize) * 32;
            const theBits = bits[bitsOffset];
            let bit = 0;
            while (((theBits << (31 - bit)) & 0xFFFFFFFF) === 0) {
                bit++;
            }
            x += bit;
            return Int32Array.from([x, y]);
        }
        getBottomRightOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = bits.length - 1;
            while (bitsOffset >= 0 && bits[bitsOffset] === 0) {
                bitsOffset--;
            }
            if (bitsOffset < 0) {
                return null;
            }
            const y = Math.floor(bitsOffset / rowSize);
            let x = Math.floor(bitsOffset % rowSize) * 32;
            const theBits = bits[bitsOffset];
            let bit = 31;
            while ((theBits >>> bit) === 0) {
                bit--;
            }
            x += bit;
            return Int32Array.from([x, y]);
        }
        /**
         * @return The width of the matrix
         */
        getWidth() {
            return this.width;
        }
        /**
         * @return The height of the matrix
         */
        getHeight() {
            return this.height;
        }
        /**
         * @return The row size of the matrix
         */
        getRowSize() {
            return this.rowSize;
        }
        /*@Override*/
        equals(o) {
            if (!(o instanceof BitMatrix)) {
                return false;
            }
            const other = o;
            return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize &&
                Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/
        hashCode() {
            let hash = this.width;
            hash = 31 * hash + this.width;
            hash = 31 * hash + this.height;
            hash = 31 * hash + this.rowSize;
            hash = 31 * hash + Arrays.hashCode(this.bits);
            return hash;
        }
        /**
         * @return string representation using "X" for set and " " for unset bits
         */
        /*@Override*/
        // public toString(): string {
        //   return toString(": "X, "  ")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @return string representation of entire matrix utilizing given strings
         */
        // public toString(setString: string = "X ", unsetString: string = "  "): string {
        //   return this.buildToString(setString, unsetString, "\n")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @param lineSeparator newline character in string representation
         * @return string representation of entire matrix utilizing given strings and line separator
         * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
         */
        // @Deprecated
        toString(setString = 'X ', unsetString = '  ', lineSeparator = '\n') {
            return this.buildToString(setString, unsetString, lineSeparator);
        }
        buildToString(setString, unsetString, lineSeparator) {
            let result = new StringBuilder();
            // result.append(lineSeparator);
            for (let y = 0, height = this.height; y < height; y++) {
                for (let x = 0, width = this.width; x < width; x++) {
                    result.append(this.get(x, y) ? setString : unsetString);
                }
                result.append(lineSeparator);
            }
            return result.toString();
        }
        /*@Override*/
        clone() {
            return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class NotFoundException extends Exception {
        static getNotFoundInstance() {
            return new NotFoundException();
        }
    }
    NotFoundException.kind = 'NotFoundException';

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This Binarizer implementation uses the old ZXing global histogram approach. It is suitable
     * for low-end mobile devices which don't have enough CPU or memory to use a local thresholding
     * algorithm. However, because it picks a global black point, it cannot handle difficult shadows
     * and gradients.
     *
     * Faster mobile devices and all desktop applications should probably use HybridBinarizer instead.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */
    class GlobalHistogramBinarizer extends Binarizer {
        constructor(source) {
            super(source);
            this.luminances = GlobalHistogramBinarizer.EMPTY;
            this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
        }
        // Applies simple sharpening to the row data to improve performance of the 1D Readers.
        /*@Override*/
        getBlackRow(y /*int*/, row) {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            if (row === undefined || row === null || row.getSize() < width) {
                row = new BitArray(width);
            }
            else {
                row.clear();
            }
            this.initArrays(width);
            const localLuminances = source.getRow(y, this.luminances);
            const localBuckets = this.buckets;
            for (let x = 0; x < width; x++) {
                localBuckets[(localLuminances[x] & 0xff) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
            }
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            if (width < 3) {
                // Special case for very small images
                for (let x = 0; x < width; x++) {
                    if ((localLuminances[x] & 0xff) < blackPoint) {
                        row.set(x);
                    }
                }
            }
            else {
                let left = localLuminances[0] & 0xff;
                let center = localLuminances[1] & 0xff;
                for (let x = 1; x < width - 1; x++) {
                    const right = localLuminances[x + 1] & 0xff;
                    // A simple -1 4 -1 box filter with a weight of 2.
                    if (((center * 4) - left - right) / 2 < blackPoint) {
                        row.set(x);
                    }
                    left = center;
                    center = right;
                }
            }
            return row;
        }
        // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
        /*@Override*/
        getBlackMatrix() {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            const matrix = new BitMatrix(width, height);
            // Quickly calculates the histogram by sampling four rows from the image. This proved to be
            // more robust on the blackbox tests than sampling a diagonal as we used to do.
            this.initArrays(width);
            const localBuckets = this.buckets;
            for (let y = 1; y < 5; y++) {
                const row = Math.floor((height * y) / 5);
                const localLuminances = source.getRow(row, this.luminances);
                const right = Math.floor((width * 4) / 5);
                for (let x = Math.floor(width / 5); x < right; x++) {
                    const pixel = localLuminances[x] & 0xff;
                    localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
                }
            }
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            // We delay reading the entire image luminance until the black point estimation succeeds.
            // Although we end up reading four rows twice, it is consistent with our motto of
            // "fail quickly" which is necessary for continuous scanning.
            const localLuminances = source.getMatrix();
            for (let y = 0; y < height; y++) {
                const offset = y * width;
                for (let x = 0; x < width; x++) {
                    const pixel = localLuminances[offset + x] & 0xff;
                    if (pixel < blackPoint) {
                        matrix.set(x, y);
                    }
                }
            }
            return matrix;
        }
        /*@Override*/
        createBinarizer(source) {
            return new GlobalHistogramBinarizer(source);
        }
        initArrays(luminanceSize /*int*/) {
            if (this.luminances.length < luminanceSize) {
                this.luminances = new Uint8ClampedArray(luminanceSize);
            }
            const buckets = this.buckets;
            for (let x = 0; x < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++) {
                buckets[x] = 0;
            }
        }
        static estimateBlackPoint(buckets) {
            // Find the tallest peak in the histogram.
            const numBuckets = buckets.length;
            let maxBucketCount = 0;
            let firstPeak = 0;
            let firstPeakSize = 0;
            for (let x = 0; x < numBuckets; x++) {
                if (buckets[x] > firstPeakSize) {
                    firstPeak = x;
                    firstPeakSize = buckets[x];
                }
                if (buckets[x] > maxBucketCount) {
                    maxBucketCount = buckets[x];
                }
            }
            // Find the second-tallest peak which is somewhat far from the tallest peak.
            let secondPeak = 0;
            let secondPeakScore = 0;
            for (let x = 0; x < numBuckets; x++) {
                const distanceToBiggest = x - firstPeak;
                // Encourage more distant second peaks by multiplying by square of distance.
                const score = buckets[x] * distanceToBiggest * distanceToBiggest;
                if (score > secondPeakScore) {
                    secondPeak = x;
                    secondPeakScore = score;
                }
            }
            // Make sure firstPeak corresponds to the black peak.
            if (firstPeak > secondPeak) {
                const temp = firstPeak;
                firstPeak = secondPeak;
                secondPeak = temp;
            }
            // If there is too little contrast in the image to pick a meaningful black point, throw rather
            // than waste time trying to decode the image, and risk false positives.
            if (secondPeak - firstPeak <= numBuckets / 16) {
                throw new NotFoundException();
            }
            // Find a valley between them that is low and closer to the white peak.
            let bestValley = secondPeak - 1;
            let bestValleyScore = -1;
            for (let x = secondPeak - 1; x > firstPeak; x--) {
                const fromFirst = x - firstPeak;
                const score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
                if (score > bestValleyScore) {
                    bestValley = x;
                    bestValleyScore = score;
                }
            }
            return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
        }
    }
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([0]);

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This class implements a local thresholding algorithm, which while slower than the
     * GlobalHistogramBinarizer, is fairly efficient for what it does. It is designed for
     * high frequency images of barcodes with black data on white backgrounds. For this application,
     * it does a much better job than a global blackpoint with severe shadows and gradients.
     * However it tends to produce artifacts on lower frequency images and is therefore not
     * a good general purpose binarizer for uses outside ZXing.
     *
     * This class extends GlobalHistogramBinarizer, using the older histogram approach for 1D readers,
     * and the newer local approach for 2D readers. 1D decoding using a per-row histogram is already
     * inherently local, and only fails for horizontal gradients. We can revisit that problem later,
     * but for now it was not a win to use local blocks for 1D.
     *
     * This Binarizer is the default for the unit tests and the recommended class for library users.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class HybridBinarizer extends GlobalHistogramBinarizer {
        constructor(source) {
            super(source);
            this.matrix = null;
        }
        /**
         * Calculates the final BitMatrix once for all requests. This could be called once from the
         * constructor instead, but there are some advantages to doing it lazily, such as making
         * profiling easier, and not doing heavy lifting when callers don't expect it.
         */
        /*@Override*/
        getBlackMatrix() {
            if (this.matrix !== null) {
                return this.matrix;
            }
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
                const luminances = source.getMatrix();
                let subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) {
                    subWidth++;
                }
                let subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) {
                    subHeight++;
                }
                const blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
                const newMatrix = new BitMatrix(width, height);
                HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
                this.matrix = newMatrix;
            }
            else {
                // If the image is too small, fall back to the global histogram approach.
                this.matrix = super.getBlackMatrix();
            }
            return this.matrix;
        }
        /*@Override*/
        createBinarizer(source) {
            return new HybridBinarizer(source);
        }
        /**
         * For each block in the image, calculate the average black point using a 5x5 grid
         * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
         * on the last pixels in the row/column which are also used in the previous block).
         */
        static calculateThresholdForBlock(luminances, subWidth /*int*/, subHeight /*int*/, width /*int*/, height /*int*/, blackPoints, matrix) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            for (let y = 0; y < subHeight; y++) {
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) {
                    yoffset = maxYOffset;
                }
                const top = HybridBinarizer.cap(y, 2, subHeight - 3);
                for (let x = 0; x < subWidth; x++) {
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) {
                        xoffset = maxXOffset;
                    }
                    const left = HybridBinarizer.cap(x, 2, subWidth - 3);
                    let sum = 0;
                    for (let z = -2; z <= 2; z++) {
                        const blackRow = blackPoints[top + z];
                        sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
                    }
                    const average = sum / 25;
                    HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
                }
            }
        }
        static cap(value /*int*/, min /*int*/, max /*int*/) {
            return value < min ? min : value > max ? max : value;
        }
        /**
         * Applies a single threshold to a block of pixels.
         */
        static thresholdBlock(luminances, xoffset /*int*/, yoffset /*int*/, threshold /*int*/, stride /*int*/, matrix) {
            for (let y = 0, offset = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset += stride) {
                for (let x = 0; x < HybridBinarizer.BLOCK_SIZE; x++) {
                    // Comparison needs to be <= so that black == 0 pixels are black even if the threshold is 0.
                    if ((luminances[offset + x] & 0xFF) <= threshold) {
                        matrix.set(xoffset + x, yoffset + y);
                    }
                }
            }
        }
        /**
         * Calculates a single black point for each block of pixels and saves it away.
         * See the following thread for a discussion of this algorithm:
         *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
         */
        static calculateBlackPoints(luminances, subWidth /*int*/, subHeight /*int*/, width /*int*/, height /*int*/) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            // tslint:disable-next-line:whitespace
            const blackPoints = new Array(subHeight); // subWidth
            for (let y = 0; y < subHeight; y++) {
                blackPoints[y] = new Int32Array(subWidth);
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) {
                    yoffset = maxYOffset;
                }
                for (let x = 0; x < subWidth; x++) {
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) {
                        xoffset = maxXOffset;
                    }
                    let sum = 0;
                    let min = 0xFF;
                    let max = 0;
                    for (let yy = 0, offset = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width) {
                        for (let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++) {
                            const pixel = luminances[offset + xx] & 0xFF;
                            sum += pixel;
                            // still looking for good contrast
                            if (pixel < min) {
                                min = pixel;
                            }
                            if (pixel > max) {
                                max = pixel;
                            }
                        }
                        // short-circuit min/max tests once dynamic range is met
                        if (max - min > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                            // finish the rest of the rows quickly
                            for (yy++, offset += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width) {
                                for (let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++) {
                                    sum += luminances[offset + xx] & 0xFF;
                                }
                            }
                        }
                    }
                    // The default estimate is the average of the values in the block.
                    let average = sum >> (HybridBinarizer.BLOCK_SIZE_POWER * 2);
                    if (max - min <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // The default assumption is that the block is light/background. Since no estimate for
                        // the level of dark pixels exists locally, use half the min for the block.
                        average = min / 2;
                        if (y > 0 && x > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            const averageNeighborBlackPoint = (blackPoints[y - 1][x] + (2 * blackPoints[y][x - 1]) + blackPoints[y - 1][x - 1]) / 4;
                            if (min < averageNeighborBlackPoint) {
                                average = averageNeighborBlackPoint;
                            }
                        }
                    }
                    blackPoints[y][x] = average;
                }
            }
            return blackPoints;
        }
    }
    // This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
    // So this is the smallest dimension in each axis we can accept.
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER; // ...0100...00
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1; // ...0011...11
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing {*/
    /**
     * The purpose of this class hierarchy is to abstract different bitmap implementations across
     * platforms into a standard interface for requesting greyscale luminance values. The interface
     * only provides immutable methods; therefore crop and rotation create copies. This is to ensure
     * that one Reader does not modify the original luminance source and leave it in an unknown state
     * for other Readers in the chain.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class LuminanceSource {
        constructor(width /*int*/, height /*int*/) {
            this.width = width;
            this.height = height;
        }
        /**
         * @return The width of the bitmap.
         */
        getWidth() {
            return this.width;
        }
        /**
         * @return The height of the bitmap.
         */
        getHeight() {
            return this.height;
        }
        /**
         * @return Whether this subclass supports cropping.
         */
        isCropSupported() {
            return false;
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */
        crop(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            throw new UnsupportedOperationException('This luminance source does not support cropping.');
        }
        /**
         * @return Whether this subclass supports counter-clockwise rotation.
         */
        isRotateSupported() {
            return false;
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */
        rotateCounterClockwise() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 90 degrees.');
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */
        rotateCounterClockwise45() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 45 degrees.');
        }
        /*@Override*/
        toString() {
            const row = new Uint8ClampedArray(this.width);
            let result = new StringBuilder();
            for (let y = 0; y < this.height; y++) {
                const sourceRow = this.getRow(y, row);
                for (let x = 0; x < this.width; x++) {
                    const luminance = sourceRow[x] & 0xFF;
                    let c;
                    if (luminance < 0x40) {
                        c = '#';
                    }
                    else if (luminance < 0x80) {
                        c = '+';
                    }
                    else if (luminance < 0xC0) {
                        c = '.';
                    }
                    else {
                        c = ' ';
                    }
                    result.append(c);
                }
                result.append('\n');
            }
            return result.toString();
        }
    }

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing {*/
    /**
     * A wrapper implementation of {@link LuminanceSource} which inverts the luminances it returns -- black becomes
     * white and vice versa, and each value becomes (255-value).
     *
     * @author Sean Owen
     */
    class InvertedLuminanceSource extends LuminanceSource {
        constructor(delegate) {
            super(delegate.getWidth(), delegate.getHeight());
            this.delegate = delegate;
        }
        /*@Override*/
        getRow(y /*int*/, row) {
            const sourceRow = this.delegate.getRow(y, row);
            const width = this.getWidth();
            for (let i = 0; i < width; i++) {
                sourceRow[i] = /*(byte)*/ (255 - (sourceRow[i] & 0xFF));
            }
            return sourceRow;
        }
        /*@Override*/
        getMatrix() {
            const matrix = this.delegate.getMatrix();
            const length = this.getWidth() * this.getHeight();
            const invertedMatrix = new Uint8ClampedArray(length);
            for (let i = 0; i < length; i++) {
                invertedMatrix[i] = /*(byte)*/ (255 - (matrix[i] & 0xFF));
            }
            return invertedMatrix;
        }
        /*@Override*/
        isCropSupported() {
            return this.delegate.isCropSupported();
        }
        /*@Override*/
        crop(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
        }
        /*@Override*/
        isRotateSupported() {
            return this.delegate.isRotateSupported();
        }
        /**
         * @return original delegate {@link LuminanceSource} since invert undoes itself
         */
        /*@Override*/
        invert() {
            return this.delegate;
        }
        /*@Override*/
        rotateCounterClockwise() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
        }
        /*@Override*/
        rotateCounterClockwise45() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
        }
    }

    /**
     * @deprecated Moving to @zxing/browser
     */
    class HTMLCanvasElementLuminanceSource extends LuminanceSource {
        constructor(canvas) {
            super(canvas.width, canvas.height);
            this.canvas = canvas;
            this.tempCanvasElement = null;
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
        }
        static makeBufferFromCanvasImageData(canvas) {
            const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
            return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
        }
        static toGrayscaleBuffer(imageBuffer, width, height) {
            const grayscaleBuffer = new Uint8ClampedArray(width * height);
            for (let i = 0, j = 0, length = imageBuffer.length; i < length; i += 4, j++) {
                let gray;
                const alpha = imageBuffer[i + 3];
                // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
                // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
                // barcode image. Force any such pixel to be white:
                if (alpha === 0) {
                    gray = 0xFF;
                }
                else {
                    const pixelR = imageBuffer[i];
                    const pixelG = imageBuffer[i + 1];
                    const pixelB = imageBuffer[i + 2];
                    // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                    // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                    // 0x200 >> 10 is 0.5, it implements rounding.
                    gray = (306 * pixelR +
                        601 * pixelG +
                        117 * pixelB +
                        0x200) >> 10;
                }
                grayscaleBuffer[j] = gray;
            }
            return grayscaleBuffer;
        }
        getRow(y /*int*/, row) {
            if (y < 0 || y >= this.getHeight()) {
                throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            }
            const width = this.getWidth();
            const start = y * width;
            if (row === null) {
                row = this.buffer.slice(start, start + width);
            }
            else {
                if (row.length < width) {
                    row = new Uint8ClampedArray(width);
                }
                // The underlying raster of image consists of bytes with the luminance values
                // TODO: can avoid set/slice?
                row.set(this.buffer.slice(start, start + width));
            }
            return row;
        }
        getMatrix() {
            return this.buffer;
        }
        isCropSupported() {
            return true;
        }
        crop(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            super.crop(left, top, width, height);
            return this;
        }
        /**
         * This is always true, since the image is a gray-scale image.
         *
         * @return true
         */
        isRotateSupported() {
            return true;
        }
        rotateCounterClockwise() {
            this.rotate(-90);
            return this;
        }
        rotateCounterClockwise45() {
            this.rotate(-45);
            return this;
        }
        getTempCanvasElement() {
            if (null === this.tempCanvasElement) {
                const tempCanvasElement = this.canvas.ownerDocument.createElement('canvas');
                tempCanvasElement.width = this.canvas.width;
                tempCanvasElement.height = this.canvas.height;
                this.tempCanvasElement = tempCanvasElement;
            }
            return this.tempCanvasElement;
        }
        rotate(angle) {
            const tempCanvasElement = this.getTempCanvasElement();
            const tempContext = tempCanvasElement.getContext('2d');
            const angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
            // Calculate and set new dimensions for temp canvas
            const width = this.canvas.width;
            const height = this.canvas.height;
            const newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
            const newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
            tempCanvasElement.width = newWidth;
            tempCanvasElement.height = newHeight;
            // Draw at center of temp canvas to prevent clipping of image data
            tempContext.translate(newWidth / 2, newHeight / 2);
            tempContext.rotate(angleRadians);
            tempContext.drawImage(this.canvas, width / -2, height / -2);
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
            return this;
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;

    /**
     * @deprecated Moving to @zxing/browser
     *
     * Video input device metadata containing the id and label of the device if available.
     */
    class VideoInputDevice {
        /**
         * Creates an instance of VideoInputDevice.
         *
         * @param {string} deviceId the video input device id
         * @param {string} label the label of the device if available
         */
        constructor(deviceId, label, groupId) {
            this.deviceId = deviceId;
            this.label = label;
            /** @inheritdoc */
            this.kind = 'videoinput';
            this.groupId = groupId || undefined;
        }
        /** @inheritdoc */
        toJSON() {
            return {
                kind: this.kind,
                groupId: this.groupId,
                deviceId: this.deviceId,
                label: this.label,
            };
        }
    }

    var __awaiter = ((globalThis || global || self || window || undefined) && (globalThis || global || self || window || undefined).__awaiter) || function (thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Base class for browser code reader.
     */
    class BrowserCodeReader {
        /**
         * Creates an instance of BrowserCodeReader.
         * @param {Reader} reader The reader instance to decode the barcode
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
         *
         * @memberOf BrowserCodeReader
         */
        constructor(reader, timeBetweenScansMillis = 500, _hints) {
            this.reader = reader;
            this.timeBetweenScansMillis = timeBetweenScansMillis;
            this._hints = _hints;
            /**
             * This will break the loop.
             */
            this._stopContinuousDecode = false;
            /**
             * This will break the loop.
             */
            this._stopAsyncDecode = false;
            /**
             * Delay time between decode attempts made by the scanner.
             */
            this._timeBetweenDecodingAttempts = 0;
        }
        /**
         * If navigator is present.
         */
        get hasNavigator() {
            return typeof navigator !== 'undefined';
        }
        /**
         * If mediaDevices under navigator is supported.
         */
        get isMediaDevicesSuported() {
            return this.hasNavigator && !!navigator.mediaDevices;
        }
        /**
         * If enumerateDevices under navigator is supported.
         */
        get canEnumerateDevices() {
            return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
        }
        /** Time between two decoding tries in milli seconds. */
        get timeBetweenDecodingAttempts() {
            return this._timeBetweenDecodingAttempts;
        }
        /**
         * Change the time span the decoder waits between two decoding tries.
         *
         * @param {number} millis Time between two decoding tries in milli seconds.
         */
        set timeBetweenDecodingAttempts(millis) {
            this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
        }
        /**
         * Sets the hints.
         */
        set hints(hints) {
            this._hints = hints || null;
        }
        /**
         * Sets the hints.
         */
        get hints() {
            return this._hints;
        }
        /**
         * Lists all the available video input devices.
         */
        listVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.hasNavigator) {
                    throw new Error('Can\'t enumerate devices, navigator is not present.');
                }
                if (!this.canEnumerateDevices) {
                    throw new Error('Can\'t enumerate devices, method not supported.');
                }
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const videoDevices = [];
                for (const device of devices) {
                    const kind = device.kind === 'video' ? 'videoinput' : device.kind;
                    if (kind !== 'videoinput') {
                        continue;
                    }
                    const deviceId = device.deviceId || device.id;
                    const label = device.label || `Video device ${videoDevices.length + 1}`;
                    const groupId = device.groupId;
                    const videoDevice = { deviceId, label, kind, groupId };
                    videoDevices.push(videoDevice);
                }
                return videoDevices;
            });
        }
        /**
         * Obtain the list of available devices with type 'videoinput'.
         *
         * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `listVideoInputDevices` instead.
         */
        getVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function* () {
                const devices = yield this.listVideoInputDevices();
                return devices.map(d => new VideoInputDevice(d.deviceId, d.label));
            });
        }
        /**
         * Let's you find a device using it's Id.
         */
        findDeviceById(deviceId) {
            return __awaiter(this, void 0, void 0, function* () {
                const devices = yield this.listVideoInputDevices();
                if (!devices) {
                    return null;
                }
                return devices.find(x => x.deviceId === deviceId);
            });
        }
        /**
         * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeOnceFromVideoDevice` instead.
         */
        decodeFromInputVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield this.decodeOnceFromVideoDevice(deviceId, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeOnceFromVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function* () {
                this.reset();
                let videoConstraints;
                if (!deviceId) {
                    videoConstraints = { facingMode: 'environment' };
                }
                else {
                    videoConstraints = { deviceId: { exact: deviceId } };
                }
                const constraints = { video: videoConstraints };
                return yield this.decodeOnceFromConstraints(constraints, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param constraints the media stream constraints to get s valid media stream to decode from
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeOnceFromConstraints(constraints, videoSource) {
            return __awaiter(this, void 0, void 0, function* () {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeOnceFromStream(stream, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeOnceFromStream(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function* () {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                const result = yield this.decodeOnce(video);
                return result;
            });
        }
        /**
         * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeFromVideoDevice` instead.
         */
        decodeFromInputVideoDeviceContinuously(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield this.decodeFromVideoDevice(deviceId, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         */
        decodeFromVideoDevice(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function* () {
                let videoConstraints;
                if (!deviceId) {
                    videoConstraints = { facingMode: 'environment' };
                }
                else {
                    videoConstraints = { deviceId: { exact: deviceId } };
                }
                const constraints = { video: videoConstraints };
                return yield this.decodeFromConstraints(constraints, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeFromConstraints(constraints, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function* () {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeFromStream(stream, videoSource, callbackFn);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeFromStream(stream, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function* () {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                return yield this.decodeContinuously(video, callbackFn);
            });
        }
        /**
         * Breaks the decoding loop.
         */
        stopAsyncDecode() {
            this._stopAsyncDecode = true;
        }
        /**
         * Breaks the decoding loop.
         */
        stopContinuousDecode() {
            this._stopContinuousDecode = true;
        }
        /**
         * Sets the new stream and request a new decoding-with-delay.
         *
         * @param stream The stream to be shown in the video element.
         * @param decodeFn A callback for the decode method.
         */
        attachStreamToVideo(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function* () {
                const videoElement = this.prepareVideoElement(videoSource);
                this.addVideoSource(videoElement, stream);
                this.videoElement = videoElement;
                this.stream = stream;
                yield this.playVideoOnLoadAsync(videoElement);
                return videoElement;
            });
        }
        /**
         *
         * @param videoElement
         */
        playVideoOnLoadAsync(videoElement) {
            return new Promise((resolve, reject) => this.playVideoOnLoad(videoElement, () => resolve()));
        }
        /**
         * Binds listeners and callbacks to the videoElement.
         *
         * @param element
         * @param callbackFn
         */
        playVideoOnLoad(element, callbackFn) {
            this.videoEndedListener = () => this.stopStreams();
            this.videoCanPlayListener = () => this.tryPlayVideo(element);
            element.addEventListener('ended', this.videoEndedListener);
            element.addEventListener('canplay', this.videoCanPlayListener);
            element.addEventListener('playing', callbackFn);
            // if canplay was already fired, we won't know when to play, so just give it a try
            this.tryPlayVideo(element);
        }
        /**
         * Checks if the given video element is currently playing.
         */
        isVideoPlaying(video) {
            return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
        }
        /**
         * Just tries to play the video and logs any errors.
         * The play call is only made is the video is not already playing.
         */
        tryPlayVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isVideoPlaying(videoElement)) {
                    console.warn('Trying to play video that is already playing.');
                    return;
                }
                try {
                    yield videoElement.play();
                }
                catch (_a) {
                    console.warn('It was not possible to play the video.');
                }
            });
        }
        /**
         * Searches and validates a media element.
         */
        getMediaElement(mediaElementId, type) {
            const mediaElement = document.getElementById(mediaElementId);
            if (!mediaElement) {
                throw new ArgumentException(`element with id '${mediaElementId}' not found`);
            }
            if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) {
                throw new ArgumentException(`element with id '${mediaElementId}' must be an ${type} element`);
            }
            return mediaElement;
        }
        /**
         * Decodes the barcode from an image.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeFromImage(source, url) {
            if (!source && !url) {
                throw new ArgumentException('either imageElement with a src set or an url must be provided');
            }
            if (url && !source) {
                return this.decodeFromImageUrl(url);
            }
            return this.decodeFromImageElement(source);
        }
        /**
         * Decodes the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */
        decodeFromVideo(source, url) {
            if (!source && !url) {
                throw new ArgumentException('Either an element with a src set or an URL must be provided');
            }
            if (url && !source) {
                return this.decodeFromVideoUrl(url);
            }
            return this.decodeFromVideoElement(source);
        }
        /**
         * Decodes continuously the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @experimental
         */
        decodeFromVideoContinuously(source, url, callbackFn) {
            if (undefined === source && undefined === url) {
                throw new ArgumentException('Either an element with a src set or an URL must be provided');
            }
            if (url && !source) {
                return this.decodeFromVideoUrlContinuously(url, callbackFn);
            }
            return this.decodeFromVideoElementContinuously(source, callbackFn);
        }
        /**
         * Decodes something from an image HTML element.
         */
        decodeFromImageElement(source) {
            if (!source) {
                throw new ArgumentException('An image element must be provided.');
            }
            this.reset();
            const element = this.prepareImageElement(source);
            this.imageElement = element;
            let task;
            if (this.isImageLoaded(element)) {
                task = this.decodeOnce(element, false, true);
            }
            else {
                task = this._decodeOnLoadImage(element);
            }
            return task;
        }
        /**
         * Decodes something from an image HTML element.
         */
        decodeFromVideoElement(source) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideo(element);
        }
        /**
         * Decodes something from an image HTML element.
         */
        decodeFromVideoElementContinuously(source, callbackFn) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideoContinuously(element, callbackFn);
        }
        /**
         * Sets up the video source so it can be decoded when loaded.
         *
         * @param source The video source element.
         */
        _decodeFromVideoElementSetup(source) {
            if (!source) {
                throw new ArgumentException('A video element must be provided.');
            }
            this.reset();
            const element = this.prepareVideoElement(source);
            // defines the video element before starts decoding
            this.videoElement = element;
            return element;
        }
        /**
         * Decodes an image from a URL.
         */
        decodeFromImageUrl(url) {
            if (!url) {
                throw new ArgumentException('An URL must be provided.');
            }
            this.reset();
            const element = this.prepareImageElement();
            this.imageElement = element;
            const decodeTask = this._decodeOnLoadImage(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         */
        decodeFromVideoUrl(url) {
            if (!url) {
                throw new ArgumentException('An URL must be provided.');
            }
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElement(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         *
         * @experimental
         */
        decodeFromVideoUrlContinuously(url, callbackFn) {
            if (!url) {
                throw new ArgumentException('An URL must be provided.');
            }
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
            element.src = url;
            return decodeTask;
        }
        _decodeOnLoadImage(element) {
            return new Promise((resolve, reject) => {
                this.imageLoadedListener = () => this.decodeOnce(element, false, true).then(resolve, reject);
                element.addEventListener('load', this.imageLoadedListener);
            });
        }
        _decodeOnLoadVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function* () {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                return yield this.decodeOnce(videoElement);
            });
        }
        _decodeOnLoadVideoContinuously(videoElement, callbackFn) {
            return __awaiter(this, void 0, void 0, function* () {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                this.decodeContinuously(videoElement, callbackFn);
            });
        }
        isImageLoaded(img) {
            // During the onload event, IE correctly identifies any images that
            // weren’t downloaded as not complete. Others should too. Gecko-based
            // browsers act like NS4 in that they report this incorrectly.
            if (!img.complete) {
                return false;
            }
            // However, they do have two very useful properties: naturalWidth and
            // naturalHeight. These give the true size of the image. If it failed
            // to load, either of these should be zero.
            if (img.naturalWidth === 0) {
                return false;
            }
            // No other way of checking: assume it’s ok.
            return true;
        }
        prepareImageElement(imageSource) {
            let imageElement;
            if (typeof imageSource === 'undefined') {
                imageElement = document.createElement('img');
                imageElement.width = 200;
                imageElement.height = 200;
            }
            if (typeof imageSource === 'string') {
                imageElement = this.getMediaElement(imageSource, 'img');
            }
            if (imageSource instanceof HTMLImageElement) {
                imageElement = imageSource;
            }
            return imageElement;
        }
        /**
         * Sets a HTMLVideoElement for scanning or creates a new one.
         *
         * @param videoSource The HTMLVideoElement to be set.
         */
        prepareVideoElement(videoSource) {
            let videoElement;
            if (!videoSource && typeof document !== 'undefined') {
                videoElement = document.createElement('video');
                videoElement.width = 200;
                videoElement.height = 200;
            }
            if (typeof videoSource === 'string') {
                videoElement = this.getMediaElement(videoSource, 'video');
            }
            if (videoSource instanceof HTMLVideoElement) {
                videoElement = videoSource;
            }
            // Needed for iOS 11
            videoElement.setAttribute('autoplay', 'true');
            videoElement.setAttribute('muted', 'true');
            videoElement.setAttribute('playsinline', 'true');
            return videoElement;
        }
        /**
         * Tries to decode from the video input until it finds some value.
         */
        decodeOnce(element, retryIfNotFound = true, retryIfChecksumOrFormatError = true) {
            this._stopAsyncDecode = false;
            const loop = (resolve, reject) => {
                if (this._stopAsyncDecode) {
                    reject(new NotFoundException('Video stream has ended before any code could be detected.'));
                    this._stopAsyncDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    resolve(result);
                }
                catch (e) {
                    const ifNotFound = retryIfNotFound && e instanceof NotFoundException;
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
                    if (ifNotFound || ifChecksumOrFormat) {
                        // trying again
                        return setTimeout(loop, this._timeBetweenDecodingAttempts, resolve, reject);
                    }
                    reject(e);
                }
            };
            return new Promise((resolve, reject) => loop(resolve, reject));
        }
        /**
         * Continuously decodes from video input.
         */
        decodeContinuously(element, callbackFn) {
            this._stopContinuousDecode = false;
            const loop = () => {
                if (this._stopContinuousDecode) {
                    this._stopContinuousDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    callbackFn(result, null);
                    setTimeout(loop, this.timeBetweenScansMillis);
                }
                catch (e) {
                    callbackFn(null, e);
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const isNotFound = e instanceof NotFoundException;
                    if (isChecksumOrFormatError || isNotFound) {
                        // trying again
                        setTimeout(loop, this._timeBetweenDecodingAttempts);
                    }
                }
            };
            loop();
        }
        /**
         * Gets the BinaryBitmap for ya! (and decodes it)
         */
        decode(element) {
            // get binary bitmap for decode function
            const binaryBitmap = this.createBinaryBitmap(element);
            return this.decodeBitmap(binaryBitmap);
        }
        /**
         * Returns true if media element is indeed a {@link HtmlVideoElement}.
         */
        _isHTMLVideoElement(mediaElement) {
            const potentialVideo = mediaElement;
            return potentialVideo.videoWidth !== 0;
        }
        /**
         * Overwriting this allows you to manipulate the next frame in anyway
         * you want before decode.
         */
        drawFrameOnCanvas(
            srcElement, dimensions, canvasElementContext) {
            if (!dimensions) {
                dimensions = {
                    sx: 0,
                    sy: 0,
                    sWidth: srcElement.videoWidth,
                    sHeight: srcElement.videoHeight,
                    dx: 0,
                    dy: 0,
                    dWidth: srcElement.videoWidth,
                    dHeight: srcElement.videoHeight};
            }
            if (!canvasElementContext) {
                canvasElementContext = this.captureCanvasContext;
            }
            canvasElementContext.drawImage(
                srcElement,
                dimensions.sx,
                dimensions.sy,
                dimensions.sWidth,
                dimensions.sHeight,
                dimensions.dx,
                dimensions.dy,
                dimensions.dWidth,
                dimensions.dHeight);
        }
        /**
         * Ovewriting this allows you to manipulate the snapshot image in anyway
         *  you want before decode.
         */
        drawImageOnCanvas(
            srcElement,
            dimensions,
            canvasElementContext = this.captureCanvasContext) {
            if (!dimensions) {
                dimensions = {
                    sx: 0,
                    sy: 0,
                    sWidth: srcElement.naturalWidth,
                    sHeight: srcElement.naturalHeight,
                    dx: 0,
                    dy: 0,
                    dWidth: srcElement.naturalWidth,
                    dHeight: srcElement.naturalHeight
                };
            }
            if (!canvasElementContext) {
                canvasElementContext = this.captureCanvasContext;
            }
            canvasElementContext.drawImage(
                srcElement,
                dimensions.sx,
                dimensions.sy,
                dimensions.sWidth,
                dimensions.sHeight,
                dimensions.dx,
                dimensions.dy,
                dimensions.dWidth,
                dimensions.dHeight);
        }
        /**
         * Creates a binaryBitmap based in some image source.
         *
         * @param mediaElement HTML element containing drawable image source.
         */
        createBinaryBitmap(mediaElement) {
            const ctx = this.getCaptureCanvasContext(mediaElement);
            if (this._isHTMLVideoElement(mediaElement)) {
                this.drawFrameOnCanvas(mediaElement);
            } else {
                this.drawImageOnCanvas(mediaElement);
            }
            const canvas = this.getCaptureCanvas(mediaElement);
            const luminanceSource = new HTMLCanvasElementLuminanceSource(canvas);
            const hybridBinarizer = new HybridBinarizer(luminanceSource);

            return new BinaryBitmap(hybridBinarizer);
        }

        getCaptureCanvasContext(mediaElement) {
            if (!this.captureCanvasContext) {
                const elem = this.getCaptureCanvas(mediaElement);
                const ctx = elem.getContext('2d');
                this.captureCanvasContext = ctx;
            }
            return this.captureCanvasContext;
        }
        getCaptureCanvas(mediaElement) {
            if (!this.captureCanvas) {
                const elem = this.createCaptureCanvas(mediaElement);
                this.captureCanvas = elem;
            }
            return this.captureCanvas;
        }
        /**
         * Call the encapsulated readers decode
         */
        decodeBitmap(binaryBitmap) {
            return this.reader.decode(binaryBitmap, this._hints);
        }
        /**
         * 🖌 Prepares the canvas for capture and scan frames.
         */
        createCaptureCanvas(mediaElement) {
            if (typeof document === 'undefined') {
                this._destroyCaptureCanvas();
                return null;
            }
            const canvasElement = document.createElement('canvas');
            let width;
            let height;
            if (typeof mediaElement !== 'undefined') {
                if (mediaElement instanceof HTMLVideoElement) {
                    width = mediaElement.videoWidth;
                    height = mediaElement.videoHeight;
                }
                else if (mediaElement instanceof HTMLImageElement) {
                    width = mediaElement.naturalWidth || mediaElement.width;
                    height = mediaElement.naturalHeight || mediaElement.height;
                }
            }
            canvasElement.style.width = width + 'px';
            canvasElement.style.height = height + 'px';
            canvasElement.width = width;
            canvasElement.height = height;
            return canvasElement;
        }
        /**
         * Stops the continuous scan and cleans the stream.
         */
        stopStreams() {
            if (this.stream) {
                this.stream.getVideoTracks().forEach(t => t.stop());
                this.stream = undefined;
            }
            if (this._stopAsyncDecode === false) {
                this.stopAsyncDecode();
            }
            if (this._stopContinuousDecode === false) {
                this.stopContinuousDecode();
            }
        }
        /**
         * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
         *
         * @memberOf BrowserCodeReader
         */
        reset() {
            // stops the camera, preview and scan 🔴
            this.stopStreams();
            // clean and forget about HTML elements
            this._destroyVideoElement();
            this._destroyImageElement();
            this._destroyCaptureCanvas();
        }
        _destroyVideoElement() {
            if (!this.videoElement) {
                return;
            }
            // first gives freedon to the element 🕊
            if (typeof this.videoEndedListener !== 'undefined') {
                this.videoElement.removeEventListener('ended', this.videoEndedListener);
            }
            if (typeof this.videoPlayingEventListener !== 'undefined') {
                this.videoElement.removeEventListener('playing', this.videoPlayingEventListener);
            }
            if (typeof this.videoCanPlayListener !== 'undefined') {
                this.videoElement.removeEventListener('loadedmetadata', this.videoCanPlayListener);
            }
            // then forgets about that element 😢
            this.cleanVideoSource(this.videoElement);
            this.videoElement = undefined;
        }
        _destroyImageElement() {
            if (!this.imageElement) {
                return;
            }
            // first gives freedon to the element 🕊
            if (undefined !== this.imageLoadedListener) {
                this.imageElement.removeEventListener('load', this.imageLoadedListener);
            }
            // then forget about that element 😢
            this.imageElement.src = undefined;
            this.imageElement.removeAttribute('src');
            this.imageElement = undefined;
        }
        /**
         * Cleans canvas references 🖌
         */
        _destroyCaptureCanvas() {
            // then forget about that element 😢
            this.captureCanvasContext = undefined;
            this.captureCanvas = undefined;
        }
        /**
         * Defines what the videoElement src will be.
         *
         * @param videoElement
         * @param stream
         */
        addVideoSource(videoElement, stream) {
            // Older browsers may not have `srcObject`
            try {
                // @note Throws Exception if interrupted by a new loaded request
                videoElement.srcObject = stream;
            }
            catch (err) {
                // @note Avoid using this in new browsers, as it is going away.
                videoElement.src = URL.createObjectURL(stream);
            }
        }
        /**
         * Unbinds a HTML video src property.
         *
         * @param videoElement
         */
        cleanVideoSource(videoElement) {
            try {
                videoElement.srcObject = null;
            }
            catch (err) {
                videoElement.src = '';
            }
            this.videoElement.removeAttribute('src');
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates the result of decoding a barcode within an image.</p>
     *
     * @author Sean Owen
     */
    class Result {
        // public constructor(private text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format) {
        //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
        // }
        // public constructor(text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format,
        //               long timestamp) {
        //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
        //        resultPoints, format, timestamp)
        // }
        constructor(text, rawBytes, numBits = rawBytes == null ? 0 : 8 * rawBytes.length, resultPoints, format, timestamp = System.currentTimeMillis()) {
            this.text = text;
            this.rawBytes = rawBytes;
            this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.timestamp = timestamp;
            this.text = text;
            this.rawBytes = rawBytes;
            if (undefined === numBits || null === numBits) {
                this.numBits = (rawBytes === null || rawBytes === undefined) ? 0 : 8 * rawBytes.length;
            }
            else {
                this.numBits = numBits;
            }
            this.resultPoints = resultPoints;
            this.format = format;
            this.resultMetadata = null;
            if (undefined === timestamp || null === timestamp) {
                this.timestamp = System.currentTimeMillis();
            }
            else {
                this.timestamp = timestamp;
            }
        }
        /**
         * @return raw text encoded by the barcode
         */
        getText() {
            return this.text;
        }
        /**
         * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
         */
        getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */
        getNumBits() {
            return this.numBits;
        }
        /**
         * @return points related to the barcode in the image. These are typically points
         *         identifying finder patterns or the corners of the barcode. The exact meaning is
         *         specific to the type of barcode that was decoded.
         */
        getResultPoints() {
            return this.resultPoints;
        }
        /**
         * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
         */
        getBarcodeFormat() {
            return this.format;
        }
        /**
         * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
         *   {@code null}. This contains optional metadata about what was detected about the barcode,
         *   like orientation.
         */
        getResultMetadata() {
            return this.resultMetadata;
        }
        putMetadata(type, value) {
            if (this.resultMetadata === null) {
                this.resultMetadata = new Map();
            }
            this.resultMetadata.set(type, value);
        }
        putAllMetadata(metadata) {
            if (metadata !== null) {
                if (this.resultMetadata === null) {
                    this.resultMetadata = metadata;
                }
                else {
                    this.resultMetadata = new Map(metadata);
                }
            }
        }
        addResultPoints(newPoints) {
            const oldPoints = this.resultPoints;
            if (oldPoints === null) {
                this.resultPoints = newPoints;
            }
            else if (newPoints !== null && newPoints.length > 0) {
                const allPoints = new Array(oldPoints.length + newPoints.length);
                System.arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
                System.arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
                this.resultPoints = allPoints;
            }
        }
        getTimestamp() {
            return this.timestamp;
        }
        /*@Override*/
        toString() {
            return this.text;
        }
    }

    /*
     * Direct port to TypeScript of ZXing by Adrian Toșcă
     */
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing {*/
    /**
     * Enumerates barcode formats known to this package. Please keep alphabetized.
     *
     * @author Sean Owen
     */
    var BarcodeFormat;
    (function (BarcodeFormat) {
        /** Aztec 2D barcode format. */
        BarcodeFormat[BarcodeFormat["AZTEC"] = 0] = "AZTEC";
        /** CODABAR 1D format. */
        BarcodeFormat[BarcodeFormat["CODABAR"] = 1] = "CODABAR";
        /** Code 39 1D format. */
        BarcodeFormat[BarcodeFormat["CODE_39"] = 2] = "CODE_39";
        /** Code 93 1D format. */
        BarcodeFormat[BarcodeFormat["CODE_93"] = 3] = "CODE_93";
        /** Code 128 1D format. */
        BarcodeFormat[BarcodeFormat["CODE_128"] = 4] = "CODE_128";
        /** Data Matrix 2D barcode format. */
        BarcodeFormat[BarcodeFormat["DATA_MATRIX"] = 5] = "DATA_MATRIX";
        /** EAN-8 1D format. */
        BarcodeFormat[BarcodeFormat["EAN_8"] = 6] = "EAN_8";
        /** EAN-13 1D format. */
        BarcodeFormat[BarcodeFormat["EAN_13"] = 7] = "EAN_13";
        /** ITF (Interleaved Two of Five) 1D format. */
        BarcodeFormat[BarcodeFormat["ITF"] = 8] = "ITF";
        /** MaxiCode 2D barcode format. */
        BarcodeFormat[BarcodeFormat["MAXICODE"] = 9] = "MAXICODE";
        /** PDF417 format. */
        BarcodeFormat[BarcodeFormat["PDF_417"] = 10] = "PDF_417";
        /** QR Code 2D barcode format. */
        BarcodeFormat[BarcodeFormat["QR_CODE"] = 11] = "QR_CODE";
        /** RSS 14 */
        BarcodeFormat[BarcodeFormat["RSS_14"] = 12] = "RSS_14";
        /** RSS EXPANDED */
        BarcodeFormat[BarcodeFormat["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
        /** UPC-A 1D format. */
        BarcodeFormat[BarcodeFormat["UPC_A"] = 14] = "UPC_A";
        /** UPC-E 1D format. */
        BarcodeFormat[BarcodeFormat["UPC_E"] = 15] = "UPC_E";
        /** UPC/EAN extension format. Not a stand-alone format. */
        BarcodeFormat[BarcodeFormat["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
    })(BarcodeFormat || (BarcodeFormat = {}));
    var BarcodeFormat$1 = BarcodeFormat;

    /*namespace com.google.zxing {*/
    /**
     * Represents some type of metadata about the result of the decoding that the decoder
     * wishes to communicate back to the caller.
     *
     * @author Sean Owen
     */
    var ResultMetadataType;
    (function (ResultMetadataType) {
        /**
         * Unspecified, application-specific metadata. Maps to an unspecified {@link Object}.
         */
        ResultMetadataType[ResultMetadataType["OTHER"] = 0] = "OTHER";
        /**
         * Denotes the likely approximate orientation of the barcode in the image. This value
         * is given as degrees rotated clockwise from the normal, upright orientation.
         * For example a 1D barcode which was found by reading top-to-bottom would be
         * said to have orientation "90". This key maps to an {@link Integer} whose
         * value is in the range [0,360).
         */
        ResultMetadataType[ResultMetadataType["ORIENTATION"] = 1] = "ORIENTATION";
        /**
         * <p>2D barcode formats typically encode text, but allow for a sort of 'byte mode'
         * which is sometimes used to encode binary data. While {@link Result} makes available
         * the complete raw bytes in the barcode for these formats, it does not offer the bytes
         * from the byte segments alone.</p>
         *
         * <p>This maps to a {@link java.util.List} of byte arrays corresponding to the
         * raw bytes in the byte segments in the barcode, in order.</p>
         */
        ResultMetadataType[ResultMetadataType["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
        /**
         * Error correction level used, if applicable. The value type depends on the
         * format, but is typically a String.
         */
        ResultMetadataType[ResultMetadataType["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
        /**
         * For some periodicals, indicates the issue number as an {@link Integer}.
         */
        ResultMetadataType[ResultMetadataType["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
        /**
         * For some products, indicates the suggested retail price in the barcode as a
         * formatted {@link String}.
         */
        ResultMetadataType[ResultMetadataType["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
        /**
         * For some products, the possible country of manufacture as a {@link String} denoting the
         * ISO country code. Some map to multiple possible countries, like "US/CA".
         */
        ResultMetadataType[ResultMetadataType["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
        /**
         * For some products, the extension text
         */
        ResultMetadataType[ResultMetadataType["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
        /**
         * PDF417-specific metadata
         */
        ResultMetadataType[ResultMetadataType["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * sequence number is given with it.
         */
        ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * parity is given with it.
         */
        ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
    })(ResultMetadataType || (ResultMetadataType = {}));
    var ResultMetadataType$1 = ResultMetadataType;

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing.common {*/
    /*import java.util.List;*/
    /**
     * <p>Encapsulates the result of decoding a matrix of bits. This typically
     * applies to 2D barcode formats. For now it contains the raw bytes obtained,
     * as well as a String interpretation of those bytes, if applicable.</p>
     *
     * @author Sean Owen
     */
    class DecoderResult {
        // public constructor(rawBytes: Uint8Array,
        //                      text: string,
        //                      List<Uint8Array> byteSegments,
        //                      String ecLevel) {
        //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
        // }
        constructor(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber = -1, structuredAppendParity = -1) {
            this.rawBytes = rawBytes;
            this.text = text;
            this.byteSegments = byteSegments;
            this.ecLevel = ecLevel;
            this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
            this.structuredAppendParity = structuredAppendParity;
            this.numBits = (rawBytes === undefined || rawBytes === null) ? 0 : 8 * rawBytes.length;
        }
        /**
         * @return raw bytes representing the result, or {@code null} if not applicable
         */
        getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */
        getNumBits() {
            return this.numBits;
        }
        /**
         * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
         * @since 3.3.0
         */
        setNumBits(numBits /*int*/) {
            this.numBits = numBits;
        }
        /**
         * @return text representation of the result
         */
        getText() {
            return this.text;
        }
        /**
         * @return list of byte segments in the result, or {@code null} if not applicable
         */
        getByteSegments() {
            return this.byteSegments;
        }
        /**
         * @return name of error correction level used, or {@code null} if not applicable
         */
        getECLevel() {
            return this.ecLevel;
        }
        /**
         * @return number of errors corrected, or {@code null} if not applicable
         */
        getErrorsCorrected() {
            return this.errorsCorrected;
        }
        setErrorsCorrected(errorsCorrected /*Integer*/) {
            this.errorsCorrected = errorsCorrected;
        }
        /**
         * @return number of erasures corrected, or {@code null} if not applicable
         */
        getErasures() {
            return this.erasures;
        }
        setErasures(erasures /*Integer*/) {
            this.erasures = erasures;
        }
        /**
         * @return arbitrary additional metadata
         */
        getOther() {
            return this.other;
        }
        setOther(other) {
            this.other = other;
        }
        hasStructuredAppend() {
            return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
        }
        getStructuredAppendParity() {
            return this.structuredAppendParity;
        }
        getStructuredAppendSequenceNumber() {
            return this.structuredAppendSequenceNumber;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */
    class AbstractGenericGF {
        /**
         * @return 2 to the power of a in GF(size)
         */
        exp(a) {
            return this.expTable[a];
        }
        /**
         * @return base 2 log of a in GF(size)
         */
        log(a /*int*/) {
            if (a === 0) {
                throw new IllegalArgumentException();
            }
            return this.logTable[a];
        }
        /**
         * Implements both addition and subtraction -- they are the same in GF(size).
         *
         * @return sum/difference of a and b
         */
        static addOrSubtract(a /*int*/, b /*int*/) {
            return a ^ b;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Represents a polynomial whose coefficients are elements of a GF.
     * Instances of this class are immutable.</p>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     */
    class GenericGFPoly {
        /**
         * @param field the {@link GenericGF} instance representing the field to use
         * to perform computations
         * @param coefficients coefficients as ints representing elements of GF(size), arranged
         * from most significant (highest-power term) coefficient to least significant
         * @throws IllegalArgumentException if argument is null or empty,
         * or if leading coefficient is 0 and this is not a
         * constant polynomial (that is, it is not the monomial "0")
         */
        constructor(field, coefficients) {
            if (coefficients.length === 0) {
                throw new IllegalArgumentException();
            }
            this.field = field;
            const coefficientsLength = coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = 1;
                while (firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0) {
                    firstNonZero++;
                }
                if (firstNonZero === coefficientsLength) {
                    this.coefficients = Int32Array.from([0]);
                }
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            }
            else {
                this.coefficients = coefficients;
            }
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */
        getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */
        isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */
        getCoefficient(degree /*int*/) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */
        evaluateAt(a /*int*/) {
            if (a === 0) {
                // Just return the x^0 coefficient
                return this.getCoefficient(0);
            }
            const coefficients = this.coefficients;
            let result;
            if (a === 1) {
                // Just the sum of the coefficients
                result = 0;
                for (let i = 0, length = coefficients.length; i !== length; i++) {
                    const coefficient = coefficients[i];
                    result = AbstractGenericGF.addOrSubtract(result, coefficient);
                }
                return result;
            }
            result = coefficients[0];
            const size = coefficients.length;
            const field = this.field;
            for (let i = 1; i < size; i++) {
                result = AbstractGenericGF.addOrSubtract(field.multiply(a, result), coefficients[i]);
            }
            return result;
        }
        addOrSubtract(other) {
            if (!this.field.equals(other.field)) {
                throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            }
            if (this.isZero()) {
                return other;
            }
            if (other.isZero()) {
                return this;
            }
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                const temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for (let i = lengthDiff; i < largerCoefficients.length; i++) {
                sumDiff[i] = AbstractGenericGF.addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            }
            return new GenericGFPoly(this.field, sumDiff);
        }
        multiply(other) {
            if (!this.field.equals(other.field)) {
                throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            }
            if (this.isZero() || other.isZero()) {
                return this.field.getZero();
            }
            const aCoefficients = this.coefficients;
            const aLength = aCoefficients.length;
            const bCoefficients = other.coefficients;
            const bLength = bCoefficients.length;
            const product = new Int32Array(aLength + bLength - 1);
            const field = this.field;
            for (let i = 0; i < aLength; i++) {
                const aCoeff = aCoefficients[i];
                for (let j = 0; j < bLength; j++) {
                    product[i + j] = AbstractGenericGF.addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
                }
            }
            return new GenericGFPoly(field, product);
        }
        multiplyScalar(scalar /*int*/) {
            if (scalar === 0) {
                return this.field.getZero();
            }
            if (scalar === 1) {
                return this;
            }
            const size = this.coefficients.length;
            const field = this.field;
            const product = new Int32Array(size);
            const coefficients = this.coefficients;
            for (let i = 0; i < size; i++) {
                product[i] = field.multiply(coefficients[i], scalar);
            }
            return new GenericGFPoly(field, product);
        }
        multiplyByMonomial(degree /*int*/, coefficient /*int*/) {
            if (degree < 0) {
                throw new IllegalArgumentException();
            }
            if (coefficient === 0) {
                return this.field.getZero();
            }
            const coefficients = this.coefficients;
            const size = coefficients.length;
            const product = new Int32Array(size + degree);
            const field = this.field;
            for (let i = 0; i < size; i++) {
                product[i] = field.multiply(coefficients[i], coefficient);
            }
            return new GenericGFPoly(field, product);
        }
        divide(other) {
            if (!this.field.equals(other.field)) {
                throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            }
            if (other.isZero()) {
                throw new IllegalArgumentException('Divide by 0');
            }
            const field = this.field;
            let quotient = field.getZero();
            let remainder = this;
            const denominatorLeadingTerm = other.getCoefficient(other.getDegree());
            const inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
            while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
                const degreeDifference = remainder.getDegree() - other.getDegree();
                const scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
                const term = other.multiplyByMonomial(degreeDifference, scale);
                const iterationQuotient = field.buildMonomial(degreeDifference, scale);
                quotient = quotient.addOrSubtract(iterationQuotient);
                remainder = remainder.addOrSubtract(term);
            }
            return [quotient, remainder];
        }
        /*@Override*/
        toString() {
            let result = '';
            for (let degree = this.getDegree(); degree >= 0; degree--) {
                let coefficient = this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result += ' - ';
                        coefficient = -coefficient;
                    }
                    else {
                        if (result.length > 0) {
                            result += ' + ';
                        }
                    }
                    if (degree === 0 || coefficient !== 1) {
                        const alphaPower = this.field.log(coefficient);
                        if (alphaPower === 0) {
                            result += '1';
                        }
                        else if (alphaPower === 1) {
                            result += 'a';
                        }
                        else {
                            result += 'a^';
                            result += alphaPower;
                        }
                    }
                    if (degree !== 0) {
                        if (degree === 1) {
                            result += 'x';
                        }
                        else {
                            result += 'x^';
                            result += degree;
                        }
                    }
                }
            }
            return result;
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class ArithmeticException extends Exception {
    }
    ArithmeticException.kind = 'ArithmeticException';

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */
    class GenericGF extends AbstractGenericGF {
        /**
         * Create a representation of GF(size) using the given primitive polynomial.
         *
         * @param primitive irreducible polynomial whose coefficients are represented by
         *  the bits of an int, where the least-significant bit represents the constant
         *  coefficient
         * @param size the size of the field
         * @param b the factor b in the generator polynomial can be 0- or 1-based
         *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
         *  In most cases it should be 1, but for QR code it is 0.
         */
        constructor(primitive /*int*/, size /*int*/, generatorBase /*int*/) {
            super();
            this.primitive = primitive;
            this.size = size;
            this.generatorBase = generatorBase;
            const expTable = new Int32Array(size);
            let x = 1;
            for (let i = 0; i < size; i++) {
                expTable[i] = x;
                x *= 2; // we're assuming the generator alpha is 2
                if (x >= size) {
                    x ^= primitive;
                    x &= size - 1;
                }
            }
            this.expTable = expTable;
            const logTable = new Int32Array(size);
            for (let i = 0; i < size - 1; i++) {
                logTable[expTable[i]] = i;
            }
            this.logTable = logTable;
            // logTable[0] == 0 but this should never be used
            this.zero = new GenericGFPoly(this, Int32Array.from([0]));
            this.one = new GenericGFPoly(this, Int32Array.from([1]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        /**
         * @return the monomial representing coefficient * x^degree
         */
        buildMonomial(degree /*int*/, coefficient /*int*/) {
            if (degree < 0) {
                throw new IllegalArgumentException();
            }
            if (coefficient === 0) {
                return this.zero;
            }
            const coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new GenericGFPoly(this, coefficients);
        }
        /**
         * @return multiplicative inverse of a
         */
        inverse(a /*int*/) {
            if (a === 0) {
                throw new ArithmeticException();
            }
            return this.expTable[this.size - this.logTable[a] - 1];
        }
        /**
         * @return product of a and b in GF(size)
         */
        multiply(a /*int*/, b /*int*/) {
            if (a === 0 || b === 0) {
                return 0;
            }
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
        }
        getSize() {
            return this.size;
        }
        getGeneratorBase() {
            return this.generatorBase;
        }
        /*@Override*/
        toString() {
            return ('GF(0x' + Integer.toHexString(this.primitive) + ',' + this.size + ')');
        }
        equals(o) {
            return o === this;
        }
    }
    GenericGF.AZTEC_DATA_12 = new GenericGF(0x1069, 4096, 1); // x^12 + x^6 + x^5 + x^3 + 1
    GenericGF.AZTEC_DATA_10 = new GenericGF(0x409, 1024, 1); // x^10 + x^3 + 1
    GenericGF.AZTEC_DATA_6 = new GenericGF(0x43, 64, 1); // x^6 + x + 1
    GenericGF.AZTEC_PARAM = new GenericGF(0x13, 16, 1); // x^4 + x + 1
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(0x012d, 256, 1); // x^8 + x^5 + x^3 + x^2 + 1
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;

    /**
     * Custom Error class of type Exception.
     */
    class ReedSolomonException extends Exception {
    }
    ReedSolomonException.kind = 'ReedSolomonException';

    /**
     * Custom Error class of type Exception.
     */
    class IllegalStateException extends Exception {
    }
    IllegalStateException.kind = 'IllegalStateException';

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Implements Reed-Solomon decoding, as the name implies.</p>
     *
     * <p>The algorithm will not be explained here, but the following references were helpful
     * in creating this implementation:</p>
     *
     * <ul>
     * <li>Bruce Maggs.
     * <a href="http://www.cs.cmu.edu/afs/cs.cmu.edu/project/pscico-guyb/realworld/www/rs_decode.ps">
     * "Decoding Reed-Solomon Codes"</a> (see discussion of Forney's Formula)</li>
     * <li>J.I. Hall. <a href="www.mth.msu.edu/~jhall/classes/codenotes/GRS.pdf">
     * "Chapter 5. Generalized Reed-Solomon Codes"</a>
     * (see discussion of Euclidean algorithm)</li>
     * </ul>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     * @author sanfordsquires
     */
    class ReedSolomonDecoder {
        constructor(field) {
            this.field = field;
        }
        /**
         * <p>Decodes given set of received codewords, which include both data and error-correction
         * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
         * in the input.</p>
         *
         * @param received data and error-correction codewords
         * @param twoS number of error-correction codewords available
         * @throws ReedSolomonException if decoding fails for any reason
         */
        decode(received, twoS /*int*/) {
            const field = this.field;
            const poly = new GenericGFPoly(field, received);
            const syndromeCoefficients = new Int32Array(twoS);
            let noError = true;
            for (let i = 0; i < twoS; i++) {
                const evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
                syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
                if (evalResult !== 0) {
                    noError = false;
                }
            }
            if (noError) {
                return;
            }
            const syndrome = new GenericGFPoly(field, syndromeCoefficients);
            const sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
            const sigma = sigmaOmega[0];
            const omega = sigmaOmega[1];
            const errorLocations = this.findErrorLocations(sigma);
            const errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
            for (let i = 0; i < errorLocations.length; i++) {
                const position = received.length - 1 - field.log(errorLocations[i]);
                if (position < 0) {
                    throw new ReedSolomonException('Bad error location');
                }
                received[position] = GenericGF.addOrSubtract(received[position], errorMagnitudes[i]);
            }
        }
        runEuclideanAlgorithm(a, b, R /*int*/) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                const temp = a;
                a = b;
                b = temp;
            }
            const field = this.field;
            let rLast = a;
            let r = b;
            let tLast = field.getZero();
            let t = field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while (r.getDegree() >= (R / 2 | 0)) {
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) {
                    // Oops, Euclidean algorithm already terminated?
                    throw new ReedSolomonException('r_{i-1} was zero');
                }
                r = rLastLast;
                let q = field.getZero();
                const denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                const dltInverse = field.inverse(denominatorLeadingTerm);
                while (r.getDegree() >= rLast.getDegree() && !r.isZero()) {
                    const degreeDiff = r.getDegree() - rLast.getDegree();
                    const scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                    r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).addOrSubtract(tLastLast);
                if (r.getDegree() >= rLast.getDegree()) {
                    throw new IllegalStateException('Division algorithm failed to reduce polynomial?');
                }
            }
            const sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) {
                throw new ReedSolomonException('sigmaTilde(0) was zero');
            }
            const inverse = field.inverse(sigmaTildeAtZero);
            const sigma = t.multiplyScalar(inverse);
            const omega = r.multiplyScalar(inverse);
            return [sigma, omega];
        }
        findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            const numErrors = errorLocator.getDegree();
            if (numErrors === 1) { // shortcut
                return Int32Array.from([errorLocator.getCoefficient(1)]);
            }
            const result = new Int32Array(numErrors);
            let e = 0;
            const field = this.field;
            for (let i = 1; i < field.getSize() && e < numErrors; i++) {
                if (errorLocator.evaluateAt(i) === 0) {
                    result[e] = field.inverse(i);
                    e++;
                }
            }
            if (e !== numErrors) {
                throw new ReedSolomonException('Error locator degree does not match number of roots');
            }
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocations) {
            // This is directly applying Forney's Formula
            const s = errorLocations.length;
            const result = new Int32Array(s);
            const field = this.field;
            for (let i = 0; i < s; i++) {
                const xiInverse = field.inverse(errorLocations[i]);
                let denominator = 1;
                for (let j = 0; j < s; j++) {
                    if (i !== j) {
                        // denominator = field.multiply(denominator,
                        //    GenericGF.addOrSubtract(1, field.multiply(errorLocations[j], xiInverse)))
                        // Above should work but fails on some Apple and Linux JDKs due to a Hotspot bug.
                        // Below is a funny-looking workaround from Steven Parkes
                        const term = field.multiply(errorLocations[j], xiInverse);
                        const termPlus1 = (term & 0x1) === 0 ? term | 1 : term & ~1;
                        denominator = field.multiply(denominator, termPlus1);
                    }
                }
                result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                if (field.getGeneratorBase() !== 0) {
                    result[i] = field.multiply(result[i], xiInverse);
                }
            }
            return result;
        }
    }

    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // import java.util.Arrays;
    var Table;
    (function (Table) {
        Table[Table["UPPER"] = 0] = "UPPER";
        Table[Table["LOWER"] = 1] = "LOWER";
        Table[Table["MIXED"] = 2] = "MIXED";
        Table[Table["DIGIT"] = 3] = "DIGIT";
        Table[Table["PUNCT"] = 4] = "PUNCT";
        Table[Table["BINARY"] = 5] = "BINARY";
    })(Table || (Table = {}));
    /**
     * <p>The main class which implements Aztec Code decoding -- as opposed to locating and extracting
     * the Aztec Code from an image.</p>
     *
     * @author David Olivier
     */
    class Decoder {
        decode(detectorResult) {
            this.ddata = detectorResult;
            let matrix = detectorResult.getBits();
            let rawbits = this.extractBits(matrix);
            let correctedBits = this.correctBits(rawbits);
            let rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
            let result = Decoder.getEncodedData(correctedBits);
            let decoderResult = new DecoderResult(rawBytes, result, null, null);
            decoderResult.setNumBits(correctedBits.length);
            return decoderResult;
        }
        // This method is used for testing the high-level encoder
        static highLevelDecode(correctedBits) {
            return this.getEncodedData(correctedBits);
        }
        /**
         * Gets the string encoded in the aztec code bits
         *
         * @return the decoded string
         */
        static getEncodedData(correctedBits) {
            let endIndex = correctedBits.length;
            let latchTable = Table.UPPER; // table most recently latched to
            let shiftTable = Table.UPPER; // table to use for the next read
            let result = '';
            let index = 0;
            while (index < endIndex) {
                if (shiftTable === Table.BINARY) {
                    if (endIndex - index < 5) {
                        break;
                    }
                    let length = Decoder.readCode(correctedBits, index, 5);
                    index += 5;
                    if (length === 0) {
                        if (endIndex - index < 11) {
                            break;
                        }
                        length = Decoder.readCode(correctedBits, index, 11) + 31;
                        index += 11;
                    }
                    for (let charCount = 0; charCount < length; charCount++) {
                        if (endIndex - index < 8) {
                            index = endIndex; // Force outer loop to exit
                            break;
                        }
                        const code = Decoder.readCode(correctedBits, index, 8);
                        result += /*(char)*/ StringUtils.castAsNonUtf8Char(code);
                        index += 8;
                    }
                    // Go back to whatever mode we had been in
                    shiftTable = latchTable;
                }
                else {
                    let size = shiftTable === Table.DIGIT ? 4 : 5;
                    if (endIndex - index < size) {
                        break;
                    }
                    let code = Decoder.readCode(correctedBits, index, size);
                    index += size;
                    let str = Decoder.getCharacter(shiftTable, code);
                    if (str.startsWith('CTRL_')) {
                        // Table changes
                        // ISO/IEC 24778:2008 prescribes ending a shift sequence in the mode from which it was invoked.
                        // That's including when that mode is a shift.
                        // Our test case dlusbs.png for issue #642 exercises that.
                        latchTable = shiftTable; // Latch the current mode, so as to return to Upper after U/S B/S
                        shiftTable = Decoder.getTable(str.charAt(5));
                        if (str.charAt(6) === 'L') {
                            latchTable = shiftTable;
                        }
                    }
                    else {
                        result += str;
                        // Go back to whatever mode we had been in
                        shiftTable = latchTable;
                    }
                }
            }
            return result;
        }
        /**
         * gets the table corresponding to the char passed
         */
        static getTable(t) {
            switch (t) {
                case 'L':
                    return Table.LOWER;
                case 'P':
                    return Table.PUNCT;
                case 'M':
                    return Table.MIXED;
                case 'D':
                    return Table.DIGIT;
                case 'B':
                    return Table.BINARY;
                case 'U':
                default:
                    return Table.UPPER;
            }
        }
        /**
         * Gets the character (or string) corresponding to the passed code in the given table
         *
         * @param table the table used
         * @param code the code of the character
         */
        static getCharacter(table, code) {
            switch (table) {
                case Table.UPPER:
                    return Decoder.UPPER_TABLE[code];
                case Table.LOWER:
                    return Decoder.LOWER_TABLE[code];
                case Table.MIXED:
                    return Decoder.MIXED_TABLE[code];
                case Table.PUNCT:
                    return Decoder.PUNCT_TABLE[code];
                case Table.DIGIT:
                    return Decoder.DIGIT_TABLE[code];
                default:
                    // Should not reach here.
                    throw new IllegalStateException('Bad table');
            }
        }
        /**
         * <p>Performs RS error correction on an array of bits.</p>
         *
         * @return the corrected array
         * @throws FormatException if the input contains too many errors
         */
        correctBits(rawbits) {
            let gf;
            let codewordSize;
            if (this.ddata.getNbLayers() <= 2) {
                codewordSize = 6;
                gf = GenericGF.AZTEC_DATA_6;
            }
            else if (this.ddata.getNbLayers() <= 8) {
                codewordSize = 8;
                gf = GenericGF.AZTEC_DATA_8;
            }
            else if (this.ddata.getNbLayers() <= 22) {
                codewordSize = 10;
                gf = GenericGF.AZTEC_DATA_10;
            }
            else {
                codewordSize = 12;
                gf = GenericGF.AZTEC_DATA_12;
            }
            let numDataCodewords = this.ddata.getNbDatablocks();
            let numCodewords = rawbits.length / codewordSize;
            if (numCodewords < numDataCodewords) {
                throw new FormatException();
            }
            let offset = rawbits.length % codewordSize;
            let dataWords = new Int32Array(numCodewords);
            for (let i = 0; i < numCodewords; i++, offset += codewordSize) {
                dataWords[i] = Decoder.readCode(rawbits, offset, codewordSize);
            }
            try {
                let rsDecoder = new ReedSolomonDecoder(gf);
                rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
            }
            catch (ex) {
                throw new FormatException(ex);
            }
            // Now perform the unstuffing operation.
            // First, count how many bits are going to be thrown out as stuffing
            let mask = (1 << codewordSize) - 1;
            let stuffedBits = 0;
            for (let i = 0; i < numDataCodewords; i++) {
                let dataWord = dataWords[i];
                if (dataWord === 0 || dataWord === mask) {
                    throw new FormatException();
                }
                else if (dataWord === 1 || dataWord === mask - 1) {
                    stuffedBits++;
                }
            }
            // Now, actually unpack the bits and remove the stuffing
            let correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
            let index = 0;
            for (let i = 0; i < numDataCodewords; i++) {
                let dataWord = dataWords[i];
                if (dataWord === 1 || dataWord === mask - 1) {
                    // next codewordSize-1 bits are all zeros or all ones
                    correctedBits.fill(dataWord > 1, index, index + codewordSize - 1);
                    // Arrays.fill(correctedBits, index, index + codewordSize - 1, dataWord > 1);
                    index += codewordSize - 1;
                }
                else {
                    for (let bit = codewordSize - 1; bit >= 0; --bit) {
                        correctedBits[index++] = (dataWord & (1 << bit)) !== 0;
                    }
                }
            }
            return correctedBits;
        }
        /**
         * Gets the array of bits from an Aztec Code matrix
         *
         * @return the array of bits
         */
        extractBits(matrix) {
            let compact = this.ddata.isCompact();
            let layers = this.ddata.getNbLayers();
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let rawbits = new Array(this.totalBitsInLayer(layers, compact));
            if (compact) {
                for (let i = 0; i < alignmentMap.length; i++) {
                    alignmentMap[i] = i;
                }
            }
            else {
                let matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision((Integer.truncDivision(baseMatrixSize, 2) - 1), 15);
                let origCenter = baseMatrixSize / 2;
                let center = Integer.truncDivision(matrixSize, 2);
                for (let i = 0; i < origCenter; i++) {
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            for (let i = 0, rowOffset = 0; i < layers; i++) {
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                // The top-left most point of this layer is <low, low> (not including alignment lines)
                let low = i * 2;
                // The bottom-right most point of this layer is <high, high> (not including alignment lines)
                let high = baseMatrixSize - 1 - low;
                // We pull bits from the two 2 x rowSize columns and two rowSize x 2 rows
                for (let j = 0; j < rowSize; j++) {
                    let columnOffset = j * 2;
                    for (let k = 0; k < 2; k++) {
                        // left column
                        rawbits[rowOffset + columnOffset + k] =
                            matrix.get(alignmentMap[low + k], alignmentMap[low + j]);
                        // bottom row
                        rawbits[rowOffset + 2 * rowSize + columnOffset + k] =
                            matrix.get(alignmentMap[low + j], alignmentMap[high - k]);
                        // right column
                        rawbits[rowOffset + 4 * rowSize + columnOffset + k] =
                            matrix.get(alignmentMap[high - k], alignmentMap[high - j]);
                        // top row
                        rawbits[rowOffset + 6 * rowSize + columnOffset + k] =
                            matrix.get(alignmentMap[high - j], alignmentMap[low + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            return rawbits;
        }
        /**
         * Reads a code of given length and at given index in an array of bits
         */
        static readCode(rawbits, startIndex, length) {
            let res = 0;
            for (let i = startIndex; i < startIndex + length; i++) {
                res <<= 1;
                if (rawbits[i]) {
                    res |= 0x01;
                }
            }
            return res;
        }
        /**
         * Reads a code of length 8 in an array of bits, padding with zeros
         */
        static readByte(rawbits, startIndex) {
            let n = rawbits.length - startIndex;
            if (n >= 8) {
                return Decoder.readCode(rawbits, startIndex, 8);
            }
            return Decoder.readCode(rawbits, startIndex, n) << (8 - n);
        }
        /**
         * Packs a bit array into bytes, most significant bit first
         */
        static convertBoolArrayToByteArray(boolArr) {
            let byteArr = new Uint8Array((boolArr.length + 7) / 8);
            for (let i = 0; i < byteArr.length; i++) {
                byteArr[i] = Decoder.readByte(boolArr, 8 * i);
            }
            return byteArr;
        }
        totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Decoder.UPPER_TABLE = [
        'CTRL_PS', ' ', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
        'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'CTRL_LL', 'CTRL_ML', 'CTRL_DL', 'CTRL_BS'
    ];
    Decoder.LOWER_TABLE = [
        'CTRL_PS', ' ', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
        'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'CTRL_US', 'CTRL_ML', 'CTRL_DL', 'CTRL_BS'
    ];
    Decoder.MIXED_TABLE = [
        // Module parse failed: Octal literal in strict mode (50:29)
        // so number string were scaped
        'CTRL_PS', ' ', '\\1', '\\2', '\\3', '\\4', '\\5', '\\6', '\\7', '\b', '\t', '\n',
        '\\13', '\f', '\r', '\\33', '\\34', '\\35', '\\36', '\\37', '@', '\\', '^', '_',
        '`', '|', '~', '\\177', 'CTRL_LL', 'CTRL_UL', 'CTRL_PL', 'CTRL_BS'
    ];
    Decoder.PUNCT_TABLE = [
        '', '\r', '\r\n', '. ', ', ', ': ', '!', '"', '#', '$', '%', '&', '\'', '(', ')',
        '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '[', ']', '{', '}', 'CTRL_UL'
    ];
    Decoder.DIGIT_TABLE = [
        'CTRL_PS', ' ', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.', 'CTRL_UL', 'CTRL_US'
    ];

    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing.common.detector {*/
    /**
     * General math-related and numeric utility functions.
     */
    class MathUtils {
        constructor() { }
        /**
         * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
         * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
         * differ slightly from {@link Math#round(float)} in that half rounds down for negative
         * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
         *
         * @param d real value to round
         * @return nearest {@code int}
         */
        static round(d /*float*/) {
            if (NaN === d)
                return 0;
            if (d <= Number.MIN_SAFE_INTEGER)
                return Number.MIN_SAFE_INTEGER;
            if (d >= Number.MAX_SAFE_INTEGER)
                return Number.MAX_SAFE_INTEGER;
            return /*(int) */ (d + (d < 0.0 ? -0.5 : 0.5)) | 0;
        }
        // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */
        static distance(aX /*float|int*/, aY /*float|int*/, bX /*float|int*/, bY /*float|int*/) {
            const xDiff = aX - bX;
            const yDiff = aY - bY;
            return /*(float) */ Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        }
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */
        // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
        //   const xDiff = aX - bX
        //   const yDiff = aY - bY
        //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        // }
        /**
         * @param array values to sum
         * @return sum of values in array
         */
        static sum(array) {
            let count = 0;
            for (let i = 0, length = array.length; i !== length; i++) {
                const a = array[i];
                count += a;
            }
            return count;
        }
    }

    /**
     * Ponyfill for Java's Float class.
     */
    class Float {
        /**
         * SincTS has no difference between int and float, there's all numbers,
         * this is used only to polyfill Java code.
         */
        static floatToIntBits(f) {
            return f;
        }
    }
    /**
     * The float max value in JS is the number max value.
     */
    Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates a point of interest in an image containing a barcode. Typically, this
     * would be the location of a finder pattern or the corner of the barcode, for example.</p>
     *
     * @author Sean Owen
     */
    class ResultPoint {
        constructor(x, y) {
            this.x = x;
            this.y = y;
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
        /*@Override*/
        equals(other) {
            if (other instanceof ResultPoint) {
                const otherPoint = other;
                return this.x === otherPoint.x && this.y === otherPoint.y;
            }
            return false;
        }
        /*@Override*/
        hashCode() {
            return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
        }
        /*@Override*/
        toString() {
            return '(' + this.x + ',' + this.y + ')';
        }
        /**
         * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
         * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
         *
         * @param patterns array of three {@code ResultPoint} to order
         */
        static orderBestPatterns(patterns) {
            // Find distances between pattern centers
            const zeroOneDistance = this.distance(patterns[0], patterns[1]);
            const oneTwoDistance = this.distance(patterns[1], patterns[2]);
            const zeroTwoDistance = this.distance(patterns[0], patterns[2]);
            let pointA;
            let pointB;
            let pointC;
            // Assume one closest to other two is B; A and C will just be guesses at first
            if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
                pointB = patterns[0];
                pointA = patterns[1];
                pointC = patterns[2];
            }
            else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
                pointB = patterns[1];
                pointA = patterns[0];
                pointC = patterns[2];
            }
            else {
                pointB = patterns[2];
                pointA = patterns[0];
                pointC = patterns[1];
            }
            // Use cross product to figure out whether A and C are correct or flipped.
            // This asks whether BC x BA has a positive z component, which is the arrangement
            // we want for A, B, C. If it's negative, then we've got it flipped around and
            // should swap A and C.
            if (this.crossProductZ(pointA, pointB, pointC) < 0.0) {
                const temp = pointA;
                pointA = pointC;
                pointC = temp;
            }
            patterns[0] = pointA;
            patterns[1] = pointB;
            patterns[2] = pointC;
        }
        /**
         * @param pattern1 first pattern
         * @param pattern2 second pattern
         * @return distance between two points
         */
        static distance(pattern1, pattern2) {
            return MathUtils.distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
        }
        /**
         * Returns the z component of the cross product between vectors BC and BA.
         */
        static crossProductZ(pointA, pointB, pointC) {
            const bX = pointB.x;
            const bY = pointB.y;
            return ((pointC.x - bX) * (pointA.y - bY)) - ((pointC.y - bY) * (pointA.x - bX));
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates the result of detecting a barcode in an image. This includes the raw
     * matrix of black/white pixels corresponding to the barcode, and possibly points of interest
     * in the image, like the location of finder patterns or corners of the barcode in the image.</p>
     *
     * @author Sean Owen
     */
    class DetectorResult {
        constructor(bits, points) {
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }

    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Extends {@link DetectorResult} with more information specific to the Aztec format,
     * like the number of layers and whether it's compact.</p>
     *
     * @author Sean Owen
     */
    class AztecDetectorResult extends DetectorResult {
        constructor(bits, points, compact, nbDatablocks, nbLayers) {
            super(bits, points);
            this.compact = compact;
            this.nbDatablocks = nbDatablocks;
            this.nbLayers = nbLayers;
        }
        getNbLayers() {
            return this.nbLayers;
        }
        getNbDatablocks() {
            return this.nbDatablocks;
        }
        isCompact() {
            return this.compact;
        }
    }

    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>
     * Detects a candidate barcode-like rectangular region within an image. It
     * starts around the center of the image, increases the size of the candidate
     * region until it finds a white rectangular region. By keeping track of the
     * last black points it encountered, it determines the corners of the barcode.
     * </p>
     *
     * @author David Olivier
     */
    class WhiteRectangleDetector {
        // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
        //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
        // }
        /**
         * @param image barcode image to find a rectangle in
         * @param initSize initial size of search area around center
         * @param x x position of search center
         * @param y y position of search center
         * @throws NotFoundException if image is too small to accommodate {@code initSize}
         */
        constructor(image, initSize /*int*/, x /*int*/, y /*int*/) {
            this.image = image;
            this.height = image.getHeight();
            this.width = image.getWidth();
            if (undefined === initSize || null === initSize) {
                initSize = WhiteRectangleDetector.INIT_SIZE;
            }
            if (undefined === x || null === x) {
                x = image.getWidth() / 2 | 0;
            }
            if (undefined === y || null === y) {
                y = image.getHeight() / 2 | 0;
            }
            const halfsize = initSize / 2 | 0;
            this.leftInit = x - halfsize;
            this.rightInit = x + halfsize;
            this.upInit = y - halfsize;
            this.downInit = y + halfsize;
            if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) {
                throw new NotFoundException();
            }
        }
        /**
         * <p>
         * Detects a candidate barcode-like rectangular region within an image. It
         * starts around the center of the image, increases the size of the candidate
         * region until it finds a white rectangular region.
         * </p>
         *
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         * @throws NotFoundException if no Data Matrix Code can be found
         */
        detect() {
            let left = this.leftInit;
            let right = this.rightInit;
            let up = this.upInit;
            let down = this.downInit;
            let sizeExceeded = false;
            let aBlackPointFoundOnBorder = true;
            let atLeastOneBlackPointFoundOnBorder = false;
            let atLeastOneBlackPointFoundOnRight = false;
            let atLeastOneBlackPointFoundOnBottom = false;
            let atLeastOneBlackPointFoundOnLeft = false;
            let atLeastOneBlackPointFoundOnTop = false;
            const width = this.width;
            const height = this.height;
            while (aBlackPointFoundOnBorder) {
                aBlackPointFoundOnBorder = false;
                // .....
                // .   |
                // .....
                let rightBorderNotWhite = true;
                while ((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width) {
                    rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
                    if (rightBorderNotWhite) {
                        right++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnRight = true;
                    }
                    else if (!atLeastOneBlackPointFoundOnRight) {
                        right++;
                    }
                }
                if (right >= width) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // .   .
                // .___.
                let bottomBorderNotWhite = true;
                while ((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height) {
                    bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
                    if (bottomBorderNotWhite) {
                        down++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnBottom = true;
                    }
                    else if (!atLeastOneBlackPointFoundOnBottom) {
                        down++;
                    }
                }
                if (down >= height) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // |   .
                // .....
                let leftBorderNotWhite = true;
                while ((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0) {
                    leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
                    if (leftBorderNotWhite) {
                        left--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnLeft = true;
                    }
                    else if (!atLeastOneBlackPointFoundOnLeft) {
                        left--;
                    }
                }
                if (left < 0) {
                    sizeExceeded = true;
                    break;
                }
                // .___.
                // .   .
                // .....
                let topBorderNotWhite = true;
                while ((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0) {
                    topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
                    if (topBorderNotWhite) {
                        up--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnTop = true;
                    }
                    else if (!atLeastOneBlackPointFoundOnTop) {
                        up--;
                    }
                }
                if (up < 0) {
                    sizeExceeded = true;
                    break;
                }
                if (aBlackPointFoundOnBorder) {
                    atLeastOneBlackPointFoundOnBorder = true;
                }
            }
            if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
                const maxSize = right - left;
                let z = null;
                for (let i = 1; z === null && i < maxSize; i++) {
                    z = this.getBlackPointOnSegment(left, down - i, left + i, down);
                }
                if (z == null) {
                    throw new NotFoundException();
                }
                let t = null;
                // go down right
                for (let i = 1; t === null && i < maxSize; i++) {
                    t = this.getBlackPointOnSegment(left, up + i, left + i, up);
                }
                if (t == null) {
                    throw new NotFoundException();
                }
                let x = null;
                // go down left
                for (let i = 1; x === null && i < maxSize; i++) {
                    x = this.getBlackPointOnSegment(right, up + i, right - i, up);
                }
                if (x == null) {
                    throw new NotFoundException();
                }
                let y = null;
                // go up left
                for (let i = 1; y === null && i < maxSize; i++) {
                    y = this.getBlackPointOnSegment(right, down - i, right - i, down);
                }
                if (y == null) {
                    throw new NotFoundException();
                }
                return this.centerEdges(y, z, x, t);
            }
            else {
                throw new NotFoundException();
            }
        }
        getBlackPointOnSegment(aX /*float*/, aY /*float*/, bX /*float*/, bY /*float*/) {
            const dist = MathUtils.round(MathUtils.distance(aX, aY, bX, bY));
            const xStep = (bX - aX) / dist;
            const yStep = (bY - aY) / dist;
            const image = this.image;
            for (let i = 0; i < dist; i++) {
                const x = MathUtils.round(aX + i * xStep);
                const y = MathUtils.round(aY + i * yStep);
                if (image.get(x, y)) {
                    return new ResultPoint(x, y);
                }
            }
            return null;
        }
        /**
         * recenters the points of a constant distance towards the center
         *
         * @param y bottom most point
         * @param z left most point
         * @param x right most point
         * @param t top most point
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         */
        centerEdges(y, z, x, t) {
            //
            //       t            t
            //  z                      x
            //        x    OR    z
            //   y                    y
            //
            const yi = y.getX();
            const yj = y.getY();
            const zi = z.getX();
            const zj = z.getY();
            const xi = x.getX();
            const xj = x.getY();
            const ti = t.getX();
            const tj = t.getY();
            const CORR = WhiteRectangleDetector.CORR;
            if (yi < this.width / 2.0) {
                return [
                    new ResultPoint(ti - CORR, tj + CORR),
                    new ResultPoint(zi + CORR, zj + CORR),
                    new ResultPoint(xi - CORR, xj - CORR),
                    new ResultPoint(yi + CORR, yj - CORR)
                ];
            }
            else {
                return [
                    new ResultPoint(ti + CORR, tj + CORR),
                    new ResultPoint(zi + CORR, zj - CORR),
                    new ResultPoint(xi - CORR, xj + CORR),
                    new ResultPoint(yi - CORR, yj - CORR)
                ];
            }
        }
        /**
         * Determines whether a segment contains a black point
         *
         * @param a          min value of the scanned coordinate
         * @param b          max value of the scanned coordinate
         * @param fixed      value of fixed coordinate
         * @param horizontal set to true if scan must be horizontal, false if vertical
         * @return true if a black point has been found, else false.
         */
        containsBlackPoint(a /*int*/, b /*int*/, fixed /*int*/, horizontal) {
            const image = this.image;
            if (horizontal) {
                for (let x = a; x <= b; x++) {
                    if (image.get(x, fixed)) {
                        return true;
                    }
                }
            }
            else {
                for (let y = a; y <= b; y++) {
                    if (image.get(fixed, y)) {
                        return true;
                    }
                }
            }
            return false;
        }
    }
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * Implementations of this class can, given locations of finder patterns for a QR code in an
     * image, sample the right points in the image to reconstruct the QR code, accounting for
     * perspective distortion. It is abstracted since it is relatively expensive and should be allowed
     * to take advantage of platform-specific optimized implementations, like Sun's Java Advanced
     * Imaging library, but which may not be available in other environments such as J2ME, and vice
     * versa.
     *
     * The implementation used can be controlled by calling {@link #setGridSampler(GridSampler)}
     * with an instance of a class which implements this interface.
     *
     * @author Sean Owen
     */
    class GridSampler {
        /**
         * <p>Checks a set of points that have been transformed to sample points on an image against
         * the image's dimensions to see if the point are even within the image.</p>
         *
         * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
         * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
         * patterns in an image where the QR Code runs all the way to the image border.</p>
         *
         * <p>For efficiency, the method will check points from either end of the line until one is found
         * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
         *
         * @param image image into which the points should map
         * @param points actual points in x1,y1,...,xn,yn form
         * @throws NotFoundException if an endpoint is lies outside the image boundaries
         */
        static checkAndNudgePoints(image, points) {
            const width = image.getWidth();
            const height = image.getHeight();
            // Check and nudge points from start until we see some that are OK:
            let nudged = true;
            for (let offset = 0; offset < points.length && nudged; offset += 2) {
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) {
                    throw new NotFoundException();
                }
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                }
                else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                }
                else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
            // Check and nudge points from end:
            nudged = true;
            for (let offset = points.length - 2; offset >= 0 && nudged; offset -= 2) {
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) {
                    throw new NotFoundException();
                }
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                }
                else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                }
                else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing.common {*/
    /**
     * <p>This class implements a perspective transform in two dimensions. Given four source and four
     * destination points, it will compute the transformation implied between them. The code is based
     * directly upon section 3.4.2 of George Wolberg's "Digital Image Warping"; see pages 54-56.</p>
     *
     * @author Sean Owen
     */
    class PerspectiveTransform {
        constructor(a11 /*float*/, a21 /*float*/, a31 /*float*/, a12 /*float*/, a22 /*float*/, a32 /*float*/, a13 /*float*/, a23 /*float*/, a33 /*float*/) {
            this.a11 = a11;
            this.a21 = a21;
            this.a31 = a31;
            this.a12 = a12;
            this.a22 = a22;
            this.a32 = a32;
            this.a13 = a13;
            this.a23 = a23;
            this.a33 = a33;
        }
        static quadrilateralToQuadrilateral(x0 /*float*/, y0 /*float*/, x1 /*float*/, y1 /*float*/, x2 /*float*/, y2 /*float*/, x3 /*float*/, y3 /*float*/, x0p /*float*/, y0p /*float*/, x1p /*float*/, y1p /*float*/, x2p /*float*/, y2p /*float*/, x3p /*float*/, y3p /*float*/) {
            const qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
            const sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
            return sToQ.times(qToS);
        }
        transformPoints(points) {
            const max = points.length;
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            for (let i = 0; i < max; i += 2) {
                const x = points[i];
                const y = points[i + 1];
                const denominator = a13 * x + a23 * y + a33;
                points[i] = (a11 * x + a21 * y + a31) / denominator;
                points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        transformPointsWithValues(xValues, yValues) {
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            const n = xValues.length;
            for (let i = 0; i < n; i++) {
                const x = xValues[i];
                const y = yValues[i];
                const denominator = a13 * x + a23 * y + a33;
                xValues[i] = (a11 * x + a21 * y + a31) / denominator;
                yValues[i] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        static squareToQuadrilateral(x0 /*float*/, y0 /*float*/, x1 /*float*/, y1 /*float*/, x2 /*float*/, y2 /*float*/, x3 /*float*/, y3 /*float*/) {
            const dx3 = x0 - x1 + x2 - x3;
            const dy3 = y0 - y1 + y2 - y3;
            if (dx3 === 0.0 && dy3 === 0.0) {
                // Affine
                return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0.0, 0.0, 1.0);
            }
            else {
                const dx1 = x1 - x2;
                const dx2 = x3 - x2;
                const dy1 = y1 - y2;
                const dy2 = y3 - y2;
                const denominator = dx1 * dy2 - dx2 * dy1;
                const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1.0);
            }
        }
        static quadrilateralToSquare(x0 /*float*/, y0 /*float*/, x1 /*float*/, y1 /*float*/, x2 /*float*/, y2 /*float*/, x3 /*float*/, y3 /*float*/) {
            // Here, the adjoint serves as the inverse:
            return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
        }
        buildAdjoint() {
            // Adjoint is the transpose of the cofactor matrix:
            return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
        }
        times(other) {
            return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @author Sean Owen
     */
    class DefaultGridSampler extends GridSampler {
        /*@Override*/
        sampleGrid(image, dimensionX /*int*/, dimensionY /*int*/, p1ToX /*float*/, p1ToY /*float*/, p2ToX /*float*/, p2ToY /*float*/, p3ToX /*float*/, p3ToY /*float*/, p4ToX /*float*/, p4ToY /*float*/, p1FromX /*float*/, p1FromY /*float*/, p2FromX /*float*/, p2FromY /*float*/, p3FromX /*float*/, p3FromY /*float*/, p4FromX /*float*/, p4FromY /*float*/) {
            const transform = PerspectiveTransform.quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
            return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
        }
        /*@Override*/
        sampleGridWithTransform(image, dimensionX /*int*/, dimensionY /*int*/, transform) {
            if (dimensionX <= 0 || dimensionY <= 0) {
                throw new NotFoundException();
            }
            const bits = new BitMatrix(dimensionX, dimensionY);
            const points = new Float32Array(2 * dimensionX);
            for (let y = 0; y < dimensionY; y++) {
                const max = points.length;
                const iValue = y + 0.5;
                for (let x = 0; x < max; x += 2) {
                    points[x] = (x / 2) + 0.5;
                    points[x + 1] = iValue;
                }
                transform.transformPoints(points);
                // Quick check to see if points transformed to something inside the image
                // sufficient to check the endpoints
                GridSampler.checkAndNudgePoints(image, points);
                try {
                    for (let x = 0; x < max; x += 2) {
                        if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) {
                            // Black(-ish) pixel
                            bits.set(x / 2, y);
                        }
                    }
                }
                catch (aioobe /*: ArrayIndexOutOfBoundsException*/) {
                    // This feels wrong, but, sometimes if the finder patterns are misidentified, the resulting
                    // transform gets "twisted" such that it maps a straight line of points to a set of points
                    // whose endpoints are in bounds, but others are not. There is probably some mathematical
                    // way to detect this about the transformation that I don't know yet.
                    // This results in an ugly runtime exception despite our clever checks above -- can't have
                    // that. We could check each point's coordinates but that feels duplicative. We settle for
                    // catching and wrapping ArrayIndexOutOfBoundsException.
                    throw new NotFoundException();
                }
            }
            return bits;
        }
    }

    class GridSamplerInstance {
        /**
         * Sets the implementation of GridSampler used by the library. One global
         * instance is stored, which may sound problematic. But, the implementation provided
         * ought to be appropriate for the entire platform, and all uses of this library
         * in the whole lifetime of the JVM. For instance, an Android activity can swap in
         * an implementation that takes advantage of native platform libraries.
         *
         * @param newGridSampler The platform-specific object to install.
         */
        static setGridSampler(newGridSampler) {
            GridSamplerInstance.gridSampler = newGridSampler;
        }
        /**
         * @return the current implementation of GridSampler
         */
        static getInstance() {
            return GridSamplerInstance.gridSampler;
        }
    }
    GridSamplerInstance.gridSampler = new DefaultGridSampler();

    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    class Point {
        constructor(x, y) {
            this.x = x;
            this.y = y;
        }
        toResultPoint() {
            return new ResultPoint(this.getX(), this.getY());
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
    }
    /**
     * Encapsulates logic that can detect an Aztec Code in an image, even if the Aztec Code
     * is rotated or skewed, or partially obscured.
     *
     * @author David Olivier
     * @author Frank Yellin
     */
    class Detector {
        constructor(image) {
            this.EXPECTED_CORNER_BITS = new Int32Array([
                0xee0,
                0x1dc,
                0x83b,
                0x707,
            ]);
            this.image = image;
        }
        detect() {
            return this.detectMirror(false);
        }
        /**
         * Detects an Aztec Code in an image.
         *
         * @param isMirror if true, image is a mirror-image of original
         * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
         * @throws NotFoundException if no Aztec Code can be found
         */
        detectMirror(isMirror) {
            // 1. Get the center of the aztec matrix
            let pCenter = this.getMatrixCenter();
            // 2. Get the center points of the four diagonal points just outside the bull's eye
            //  [topRight, bottomRight, bottomLeft, topLeft]
            let bullsEyeCorners = this.getBullsEyeCorners(pCenter);
            if (isMirror) {
                let temp = bullsEyeCorners[0];
                bullsEyeCorners[0] = bullsEyeCorners[2];
                bullsEyeCorners[2] = temp;
            }
            // 3. Get the size of the matrix and other parameters from the bull's eye
            this.extractParameters(bullsEyeCorners);
            // 4. Sample the grid
            let bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
            // 5. Get the corners of the matrix.
            let corners = this.getMatrixCornerPoints(bullsEyeCorners);
            return new AztecDetectorResult(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
        }
        /**
         * Extracts the number of data layers and data blocks from the layer around the bull's eye.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @throws NotFoundException in case of too many errors or invalid parameters
         */
        extractParameters(bullsEyeCorners) {
            if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) ||
                !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) {
                throw new NotFoundException();
            }
            let length = 2 * this.nbCenterLayers;
            // Get the bits around the bull's eye
            let sides = new Int32Array([
                this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
                this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
                this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
                this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length) // Top
            ]);
            // bullsEyeCorners[shift] is the corner of the bulls'eye that has three
            // orientation marks.
            // sides[shift] is the row/column that goes from the corner with three
            // orientation marks to the corner with two.
            this.shift = this.getRotation(sides, length);
            // Flatten the parameter bits into a single 28- or 40-bit long
            let parameterData = 0;
            for (let i = 0; i < 4; i++) {
                let side = sides[(this.shift + i) % 4];
                if (this.compact) {
                    // Each side of the form ..XXXXXXX. where Xs are parameter data
                    parameterData <<= 7;
                    parameterData += (side >> 1) & 0x7F;
                }
                else {
                    // Each side of the form ..XXXXX.XXXXX. where Xs are parameter data
                    parameterData <<= 10;
                    parameterData += ((side >> 2) & (0x1f << 5)) + ((side >> 1) & 0x1F);
                }
            }
            // Corrects parameter data using RS.  Returns just the data portion
            // without the error correction.
            let correctedData = this.getCorrectedParameterData(parameterData, this.compact);
            if (this.compact) {
                // 8 bits:  2 bits layers and 6 bits data blocks
                this.nbLayers = (correctedData >> 6) + 1;
                this.nbDataBlocks = (correctedData & 0x3F) + 1;
            }
            else {
                // 16 bits:  5 bits layers and 11 bits data blocks
                this.nbLayers = (correctedData >> 11) + 1;
                this.nbDataBlocks = (correctedData & 0x7FF) + 1;
            }
        }
        getRotation(sides, length) {
            // In a normal pattern, we expect to See
            //   **    .*             D       A
            //   *      *
            //
            //   .      *
            //   ..    ..             C       B
            //
            // Grab the 3 bits from each of the sides the form the locator pattern and concatenate
            // into a 12-bit integer.  Start with the bit at A
            let cornerBits = 0;
            sides.forEach((side, idx, arr) => {
                // XX......X where X's are orientation marks
                let t = ((side >> (length - 2)) << 1) + (side & 1);
                cornerBits = (cornerBits << 3) + t;
            });
            // for (var side in sides) {
            //     // XX......X where X's are orientation marks
            //     var t = ((side >> (length - 2)) << 1) + (side & 1);
            //     cornerBits = (cornerBits << 3) + t;
            // }
            // Mov the bottom bit to the top, so that the three bits of the locator pattern at A are
            // together.  cornerBits is now:
            //  3 orientation bits at A || 3 orientation bits at B || ... || 3 orientation bits at D
            cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
            // The result shift indicates which element of BullsEyeCorners[] goes into the top-left
            // corner. Since the four rotation values have a Hamming distance of 8, we
            // can easily tolerate two errors.
            for (let shift = 0; shift < 4; shift++) {
                if (Integer.bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift]) <= 2) {
                    return shift;
                }
            }
            throw new NotFoundException();
        }
        /**
         * Corrects the parameter bits using Reed-Solomon algorithm.
         *
         * @param parameterData parameter bits
         * @param compact true if this is a compact Aztec code
         * @throws NotFoundException if the array contains too many errors
         */
        getCorrectedParameterData(parameterData, compact) {
            let numCodewords;
            let numDataCodewords;
            if (compact) {
                numCodewords = 7;
                numDataCodewords = 2;
            }
            else {
                numCodewords = 10;
                numDataCodewords = 4;
            }
            let numECCodewords = numCodewords - numDataCodewords;
            let parameterWords = new Int32Array(numCodewords);
            for (let i = numCodewords - 1; i >= 0; --i) {
                parameterWords[i] = parameterData & 0xF;
                parameterData >>= 4;
            }
            try {
                let rsDecoder = new ReedSolomonDecoder(GenericGF.AZTEC_PARAM);
                rsDecoder.decode(parameterWords, numECCodewords);
            }
            catch (ignored) {
                throw new NotFoundException();
            }
            // Toss the error correction.  Just return the data as an integer
            let result = 0;
            for (let i = 0; i < numDataCodewords; i++) {
                result = (result << 4) + parameterWords[i];
            }
            return result;
        }
        /**
         * Finds the corners of a bull-eye centered on the passed point.
         * This returns the centers of the diagonal points just outside the bull's eye
         * Returns [topRight, bottomRight, bottomLeft, topLeft]
         *
         * @param pCenter Center point
         * @return The corners of the bull-eye
         * @throws NotFoundException If no valid bull-eye can be found
         */
        getBullsEyeCorners(pCenter) {
            let pina = pCenter;
            let pinb = pCenter;
            let pinc = pCenter;
            let pind = pCenter;
            let color = true;
            for (this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++) {
                let pouta = this.getFirstDifferent(pina, color, 1, -1);
                let poutb = this.getFirstDifferent(pinb, color, 1, 1);
                let poutc = this.getFirstDifferent(pinc, color, -1, 1);
                let poutd = this.getFirstDifferent(pind, color, -1, -1);
                // d      a
                //
                // c      b
                if (this.nbCenterLayers > 2) {
                    let q = (this.distancePoint(poutd, pouta) * this.nbCenterLayers) / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
                    if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) {
                        break;
                    }
                }
                pina = pouta;
                pinb = poutb;
                pinc = poutc;
                pind = poutd;
                color = !color;
            }
            if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) {
                throw new NotFoundException();
            }
            this.compact = this.nbCenterLayers === 5;
            // Expand the square by .5 pixel in each direction so that we're on the border
            // between the white square and the black square
            let pinax = new ResultPoint(pina.getX() + 0.5, pina.getY() - 0.5);
            let pinbx = new ResultPoint(pinb.getX() + 0.5, pinb.getY() + 0.5);
            let pincx = new ResultPoint(pinc.getX() - 0.5, pinc.getY() + 0.5);
            let pindx = new ResultPoint(pind.getX() - 0.5, pind.getY() - 0.5);
            // Expand the square so that its corners are the centers of the points
            // just outside the bull's eye.
            return this.expandSquare([pinax, pinbx, pincx, pindx], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
        }
        /**
         * Finds a candidate center point of an Aztec code from an image
         *
         * @return the center point
         */
        getMatrixCenter() {
            let pointA;
            let pointB;
            let pointC;
            let pointD;
            // Get a white rectangle that can be the border of the matrix in center bull's eye or
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            }
            catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case, surely in the bull's eye, we try to expand the rectangle.
                let cx = this.image.getWidth() / 2;
                let cy = this.image.getHeight() / 2;
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Compute the center of the rectangle
            let cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            let cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            // Redetermine the white rectangle starting from previously computed center.
            // This will ensure that we end up with a white rectangle in center bull's eye
            // in order to compute a more accurate center.
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image, 15, cx, cy).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            }
            catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case we try to expand the rectangle.
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Recompute the center of the rectangle
            cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            return new Point(cx, cy);
        }
        /**
         * Gets the Aztec code corners from the bull's eye corners and the parameters.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @return the array of aztec code corners
         */
        getMatrixCornerPoints(bullsEyeCorners) {
            return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
        }
        /**
         * Creates a BitMatrix by sampling the provided image.
         * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
         * diagonal just outside the bull's eye.
         */
        sampleGrid(image, topLeft, topRight, bottomRight, bottomLeft) {
            let sampler = GridSamplerInstance.getInstance();
            let dimension = this.getDimension();
            let low = dimension / 2 - this.nbCenterLayers;
            let high = dimension / 2 + this.nbCenterLayers;
            return sampler.sampleGrid(image, dimension, dimension, low, low, // topleft
            high, low, // topright
            high, high, // bottomright
            low, high, // bottomleft
            topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Samples a line.
         *
         * @param p1   start point (inclusive)
         * @param p2   end point (exclusive)
         * @param size number of bits
         * @return the array of bits as an int (first bit is high-order bit of result)
         */
        sampleLine(p1, p2, size) {
            let result = 0;
            let d = this.distanceResultPoint(p1, p2);
            let moduleSize = d / size;
            let px = p1.getX();
            let py = p1.getY();
            let dx = moduleSize * (p2.getX() - p1.getX()) / d;
            let dy = moduleSize * (p2.getY() - p1.getY()) / d;
            for (let i = 0; i < size; i++) {
                if (this.image.get(MathUtils.round(px + i * dx), MathUtils.round(py + i * dy))) {
                    result |= 1 << (size - i - 1);
                }
            }
            return result;
        }
        /**
         * @return true if the border of the rectangle passed in parameter is compound of white points only
         *         or black points only
         */
        isWhiteOrBlackRectangle(p1, p2, p3, p4) {
            let corr = 3;
            p1 = new Point(p1.getX() - corr, p1.getY() + corr);
            p2 = new Point(p2.getX() - corr, p2.getY() - corr);
            p3 = new Point(p3.getX() + corr, p3.getY() - corr);
            p4 = new Point(p4.getX() + corr, p4.getY() + corr);
            let cInit = this.getColor(p4, p1);
            if (cInit === 0) {
                return false;
            }
            let c = this.getColor(p1, p2);
            if (c !== cInit) {
                return false;
            }
            c = this.getColor(p2, p3);
            if (c !== cInit) {
                return false;
            }
            c = this.getColor(p3, p4);
            return c === cInit;
        }
        /**
         * Gets the color of a segment
         *
         * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
         */
        getColor(p1, p2) {
            let d = this.distancePoint(p1, p2);
            let dx = (p2.getX() - p1.getX()) / d;
            let dy = (p2.getY() - p1.getY()) / d;
            let error = 0;
            let px = p1.getX();
            let py = p1.getY();
            let colorModel = this.image.get(p1.getX(), p1.getY());
            let iMax = Math.ceil(d);
            for (let i = 0; i < iMax; i++) {
                px += dx;
                py += dy;
                if (this.image.get(MathUtils.round(px), MathUtils.round(py)) !== colorModel) {
                    error++;
                }
            }
            let errRatio = error / d;
            if (errRatio > 0.1 && errRatio < 0.9) {
                return 0;
            }
            return (errRatio <= 0.1) === colorModel ? 1 : -1;
        }
        /**
         * Gets the coordinate of the first point with a different color in the given direction
         */
        getFirstDifferent(init, color, dx, dy) {
            let x = init.getX() + dx;
            let y = init.getY() + dy;
            while (this.isValid(x, y) && this.image.get(x, y) === color) {
                x += dx;
                y += dy;
            }
            x -= dx;
            y -= dy;
            while (this.isValid(x, y) && this.image.get(x, y) === color) {
                x += dx;
            }
            x -= dx;
            while (this.isValid(x, y) && this.image.get(x, y) === color) {
                y += dy;
            }
            y -= dy;
            return new Point(x, y);
        }
        /**
         * Expand the square represented by the corner points by pushing out equally in all directions
         *
         * @param cornerPoints the corners of the square, which has the bull's eye at its center
         * @param oldSide the original length of the side of the square in the target bit matrix
         * @param newSide the new length of the size of the square in the target bit matrix
         * @return the corners of the expanded square
         */
        expandSquare(cornerPoints, oldSide, newSide) {
            let ratio = newSide / (2.0 * oldSide);
            let dx = cornerPoints[0].getX() - cornerPoints[2].getX();
            let dy = cornerPoints[0].getY() - cornerPoints[2].getY();
            let centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2.0;
            let centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2.0;
            let result0 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result2 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            dx = cornerPoints[1].getX() - cornerPoints[3].getX();
            dy = cornerPoints[1].getY() - cornerPoints[3].getY();
            centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2.0;
            centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2.0;
            let result1 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result3 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            let results = [result0, result1, result2, result3];
            return results;
        }
        isValid(x, y) {
            return x >= 0 && x < this.image.getWidth() && y > 0 && y < this.image.getHeight();
        }
        isValidPoint(point) {
            let x = MathUtils.round(point.getX());
            let y = MathUtils.round(point.getY());
            return this.isValid(x, y);
        }
        distancePoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        distanceResultPoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        getDimension() {
            if (this.compact) {
                return 4 * this.nbLayers + 11;
            }
            if (this.nbLayers <= 4) {
                return 4 * this.nbLayers + 15;
            }
            return 4 * this.nbLayers + 2 * (Integer.truncDivision((this.nbLayers - 4), 8) + 1) + 15;
        }
    }

    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode Aztec codes in an image.
     *
     * @author David Olivier
     */
    class AztecReader {
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         */
        decode(image, hints = null) {
            let exception = null;
            let detector = new Detector(image.getBlackMatrix());
            let points = null;
            let decoderResult = null;
            try {
                let detectorResult = detector.detectMirror(false);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            }
            catch (e) {
                exception = e;
            }
            if (decoderResult == null) {
                try {
                    let detectorResult = detector.detectMirror(true);
                    points = detectorResult.getPoints();
                    this.reportFoundResultPoints(hints, points);
                    decoderResult = new Decoder().decode(detectorResult);
                }
                catch (e) {
                    if (exception != null) {
                        throw exception;
                    }
                    throw e;
                }
            }
            let result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, BarcodeFormat$1.AZTEC, System.currentTimeMillis());
            let byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) {
                result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            }
            let ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) {
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            }
            return result;
        }
        reportFoundResultPoints(hints, points) {
            if (hints != null) {
                let rpcb = hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (rpcb != null) {
                    points.forEach((point, idx, arr) => {
                        rpcb.foundPossibleResultPoint(point);
                    });
                }
            }
        }
        // @Override
        reset() {
            // do nothing
        }
    }

    /**
     * Aztec Code reader to use from browser.
     *
     * @class BrowserAztecCodeReader
     * @extends {BrowserCodeReader}
     */
    class BrowserAztecCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserAztecCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         *
         * @memberOf BrowserAztecCodeReader
         */
        constructor(timeBetweenScansMillis = 500) {
            super(new AztecReader(), timeBetweenScansMillis);
        }
    }

    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */
    class OneDReader {
        /*
        @Override
        public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
          return decode(image, null);
        }
        */
        // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            try {
                return this.doDecode(image, hints);
            }
            catch (nfe) {
                const tryHarder = hints && (hints.get(DecodeHintType$1.TRY_HARDER) === true);
                if (tryHarder && image.isRotateSupported()) {
                    const rotatedImage = image.rotateCounterClockwise();
                    const result = this.doDecode(rotatedImage, hints);
                    // Record that we found it rotated 90 degrees CCW / 270 degrees CW
                    const metadata = result.getResultMetadata();
                    let orientation = 270;
                    if (metadata !== null && (metadata.get(ResultMetadataType$1.ORIENTATION) === true)) {
                        // But if we found it reversed in doDecode(), add in that result here:
                        orientation = (orientation + metadata.get(ResultMetadataType$1.ORIENTATION) % 360);
                    }
                    result.putMetadata(ResultMetadataType$1.ORIENTATION, orientation);
                    // Update result points
                    const points = result.getResultPoints();
                    if (points !== null) {
                        const height = rotatedImage.getHeight();
                        for (let i = 0; i < points.length; i++) {
                            points[i] = new ResultPoint(height - points[i].getY() - 1, points[i].getX());
                        }
                    }
                    return result;
                }
                else {
                    throw new NotFoundException();
                }
            }
        }
        // @Override
        reset() {
            // do nothing
        }
        /**
         * We're going to examine rows from the middle outward, searching alternately above and below the
         * middle, and farther out each time. rowStep is the number of rows between each successive
         * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
         * middle + rowStep, then middle - (2 * rowStep), etc.
         * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
         * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
         * image if "trying harder".
         *
         * @param image The image to decode
         * @param hints Any hints that were requested
         * @return The contents of the decoded barcode
         * @throws NotFoundException Any spontaneous errors which occur
         */
        doDecode(image, hints) {
            const width = image.getWidth();
            const height = image.getHeight();
            let row = new BitArray(width);
            const tryHarder = hints && (hints.get(DecodeHintType$1.TRY_HARDER) === true);
            const rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
            let maxLines;
            if (tryHarder) {
                maxLines = height; // Look at the whole image, not just the center
            }
            else {
                maxLines = 15; // 15 rows spaced 1/32 apart is roughly the middle half of the image
            }
            const middle = Math.trunc(height / 2);
            for (let x = 0; x < maxLines; x++) {
                // Scanning from the middle out. Determine which row we're looking at next:
                const rowStepsAboveOrBelow = Math.trunc((x + 1) / 2);
                const isAbove = (x & 0x01) === 0; // i.e. is x even?
                const rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
                if (rowNumber < 0 || rowNumber >= height) {
                    // Oops, if we run off the top or bottom, stop
                    break;
                }
                // Estimate black point for this row and load it:
                try {
                    row = image.getBlackRow(rowNumber, row);
                }
                catch (ignored) {
                    continue;
                }
                // While we have the image data in a BitArray, it's fairly cheap to reverse it in place to
                // handle decoding upside down barcodes.
                for (let attempt = 0; attempt < 2; attempt++) {
                    if (attempt === 1) { // trying again?
                        row.reverse(); // reverse the row and continue
                        // This means we will only ever draw result points *once* in the life of this method
                        // since we want to avoid drawing the wrong points after flipping the row, and,
                        // don't want to clutter with noise from every single row scan -- just the scans
                        // that start on the center line.
                        if (hints && (hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK) === true)) {
                            const newHints = new Map();
                            hints.forEach((hint, key) => newHints.set(key, hint));
                            newHints.delete(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                            hints = newHints;
                        }
                    }
                    try {
                        // Look for a barcode
                        const result = this.decodeRow(rowNumber, row, hints);
                        // We found our barcode
                        if (attempt === 1) {
                            // But it was upside down, so note that
                            result.putMetadata(ResultMetadataType$1.ORIENTATION, 180);
                            // And remember to flip the result points horizontally.
                            const points = result.getResultPoints();
                            if (points !== null) {
                                points[0] = new ResultPoint(width - points[0].getX() - 1, points[0].getY());
                                points[1] = new ResultPoint(width - points[1].getX() - 1, points[1].getY());
                            }
                        }
                        return result;
                    }
                    catch (re) {
                        // continue -- just couldn't decode this row
                    }
                }
            }
            throw new NotFoundException();
        }
        /**
         * Records the size of successive runs of white and black pixels in a row, starting at a given point.
         * The values are recorded in the given array, and the number of runs recorded is equal to the size
         * of the array. If the row starts on a white pixel at the given start point, then the first count
         * recorded is the run of white pixels starting from that point; likewise it is the count of a run
         * of black pixels if the row begin on a black pixels at that point.
         *
         * @param row row to count from
         * @param start offset into row to start at
         * @param counters array into which to record counts
         * @throws NotFoundException if counters cannot be filled entirely from row before running out
         *  of pixels
         */
        static recordPattern(row, start, counters) {
            const numCounters = counters.length;
            for (let index = 0; index < numCounters; index++)
                counters[index] = 0;
            const end = row.getSize();
            if (start >= end) {
                throw new NotFoundException();
            }
            let isWhite = !row.get(start);
            let counterPosition = 0;
            let i = start;
            while (i < end) {
                if (row.get(i) !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (++counterPosition === numCounters) {
                        break;
                    }
                    else {
                        counters[counterPosition] = 1;
                        isWhite = !isWhite;
                    }
                }
                i++;
            }
            // If we read fully the last section of pixels and filled up our counters -- or filled
            // the last counter but ran off the side of the image, OK. Otherwise, a problem.
            if (!(counterPosition === numCounters || (counterPosition === numCounters - 1 && i === end))) {
                throw new NotFoundException();
            }
        }
        static recordPatternInReverse(row, start, counters) {
            // This could be more efficient I guess
            let numTransitionsLeft = counters.length;
            let last = row.get(start);
            while (start > 0 && numTransitionsLeft >= 0) {
                if (row.get(--start) !== last) {
                    numTransitionsLeft--;
                    last = !last;
                }
            }
            if (numTransitionsLeft >= 0) {
                throw new NotFoundException();
            }
            OneDReader.recordPattern(row, start + 1, counters);
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white values matches a given
         * target pattern. This is reported as the ratio of the total variance from the expected pattern
         * proportions across all pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */
        static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            const numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for (let i = 0; i < numCounters; i++) {
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) {
                // If we don't even have one pixel per unit of bar width, assume this is too small
                // to reliably match, so fail:
                return Number.POSITIVE_INFINITY;
            }
            const unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for (let x = 0; x < numCounters; x++) {
                const counter = counters[x];
                const scaledPattern = pattern[x] * unitBarWidth;
                const variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) {
                    return Number.POSITIVE_INFINITY;
                }
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }

    /**
     * <p>Decodes Code 128 barcodes.</p>
     *
     * @author Sean Owen
     */
    class Code128Reader extends OneDReader {
        static findStartPattern(row) {
            const width = row.getSize();
            const rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let counters = Int32Array.from([0, 0, 0, 0, 0, 0]);
            let patternStart = rowOffset;
            let isWhite = false;
            const patternLength = 6;
            for (let i = rowOffset; i < width; i++) {
                if (row.get(i) !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition === (patternLength - 1)) {
                        let bestVariance = Code128Reader.MAX_AVG_VARIANCE;
                        let bestMatch = -1;
                        for (let startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++) {
                            const variance = OneDReader.patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                            if (variance < bestVariance) {
                                bestVariance = variance;
                                bestMatch = startCode;
                            }
                        }
                        // Look for whitespace before start pattern, >= 50% of width of start pattern
                        if (bestMatch >= 0 &&
                            row.isRange(Math.max(0, patternStart - (i - patternStart) / 2), patternStart, false)) {
                            return Int32Array.from([patternStart, i, bestMatch]);
                        }
                        patternStart += counters[0] + counters[1];
                        counters = counters.slice(2, counters.length - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            throw new NotFoundException();
        }
        static decodeCode(row, counters, rowOffset) {
            OneDReader.recordPattern(row, rowOffset, counters);
            let bestVariance = Code128Reader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            for (let d = 0; d < Code128Reader.CODE_PATTERNS.length; d++) {
                const pattern = Code128Reader.CODE_PATTERNS[d];
                const variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = d;
                }
            }
            // TODO We're overlooking the fact that the STOP pattern has 7 values, not 6.
            if (bestMatch >= 0) {
                return bestMatch;
            }
            else {
                throw new NotFoundException();
            }
        }
        decodeRow(rowNumber, row, hints) {
            const convertFNC1 = hints && (hints.get(DecodeHintType$1.ASSUME_GS1) === true);
            const startPatternInfo = Code128Reader.findStartPattern(row);
            const startCode = startPatternInfo[2];
            let currentRawCodesIndex = 0;
            const rawCodes = new Uint8Array(20);
            rawCodes[currentRawCodesIndex++] = startCode;
            let codeSet;
            switch (startCode) {
                case Code128Reader.CODE_START_A:
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                case Code128Reader.CODE_START_B:
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                case Code128Reader.CODE_START_C:
                    codeSet = Code128Reader.CODE_CODE_C;
                    break;
                default:
                    throw new FormatException();
            }
            let done = false;
            let isNextShifted = false;
            let result = '';
            let lastStart = startPatternInfo[0];
            let nextStart = startPatternInfo[1];
            const counters = Int32Array.from([0, 0, 0, 0, 0, 0]);
            let lastCode = 0;
            let code = 0;
            let checksumTotal = startCode;
            let multiplier = 0;
            let lastCharacterWasPrintable = true;
            let upperMode = false;
            let shiftUpperMode = false;
            while (!done) {
                const unshift = isNextShifted;
                isNextShifted = false;
                // Save off last code
                lastCode = code;
                // Decode another code from image
                code = Code128Reader.decodeCode(row, counters, nextStart);
                rawCodes[currentRawCodesIndex++] = code;
                // Remember whether the last code was printable or not (excluding CODE_STOP)
                if (code !== Code128Reader.CODE_STOP) {
                    lastCharacterWasPrintable = true;
                }
                // Add to checksum computation (if not CODE_STOP of course)
                if (code !== Code128Reader.CODE_STOP) {
                    multiplier++;
                    checksumTotal += multiplier * code;
                }
                // Advance to where the next code will to start
                lastStart = nextStart;
                nextStart += counters.reduce((previous, current) => previous + current, 0);
                // Take care of illegal start codes
                switch (code) {
                    case Code128Reader.CODE_START_A:
                    case Code128Reader.CODE_START_B:
                    case Code128Reader.CODE_START_C:
                        throw new FormatException();
                }
                switch (codeSet) {
                    case Code128Reader.CODE_CODE_A:
                        if (code < 64) {
                            if (shiftUpperMode === upperMode) {
                                result += String.fromCharCode((' '.charCodeAt(0) + code));
                            }
                            else {
                                result += String.fromCharCode((' '.charCodeAt(0) + code + 128));
                            }
                            shiftUpperMode = false;
                        }
                        else if (code < 96) {
                            if (shiftUpperMode === upperMode) {
                                result += String.fromCharCode((code - 64));
                            }
                            else {
                                result += String.fromCharCode((code + 64));
                            }
                            shiftUpperMode = false;
                        }
                        else {
                            // Don't let CODE_STOP, which always appears, affect whether whether we think the last
                            // code was printable or not.
                            if (code !== Code128Reader.CODE_STOP) {
                                lastCharacterWasPrintable = false;
                            }
                            switch (code) {
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) {
                                            // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                            // is FNC1 then this is GS1-128. We add the symbology identifier.
                                            result += ']C1';
                                        }
                                        else {
                                            // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                            result += String.fromCharCode(29);
                                        }
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    // do nothing?
                                    break;
                                case Code128Reader.CODE_FNC_4_A:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    }
                                    else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    }
                                    else {
                                        shiftUpperMode = true;
                                    }
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_B:
                        if (code < 96) {
                            if (shiftUpperMode === upperMode) {
                                result += String.fromCharCode((' '.charCodeAt(0) + code));
                            }
                            else {
                                result += String.fromCharCode((' '.charCodeAt(0) + code + 128));
                            }
                            shiftUpperMode = false;
                        }
                        else {
                            if (code !== Code128Reader.CODE_STOP) {
                                lastCharacterWasPrintable = false;
                            }
                            switch (code) {
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) {
                                            // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                            // is FNC1 then this is GS1-128. We add the symbology identifier.
                                            result += ']C1';
                                        }
                                        else {
                                            // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                            result += String.fromCharCode(29);
                                        }
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    // do nothing?
                                    break;
                                case Code128Reader.CODE_FNC_4_B:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    }
                                    else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    }
                                    else {
                                        shiftUpperMode = true;
                                    }
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_C:
                        if (code < 100) {
                            if (code < 10) {
                                result += '0';
                            }
                            result += code;
                        }
                        else {
                            if (code !== Code128Reader.CODE_STOP) {
                                lastCharacterWasPrintable = false;
                            }
                            switch (code) {
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) {
                                            // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                            // is FNC1 then this is GS1-128. We add the symbology identifier.
                                            result += ']C1';
                                        }
                                        else {
                                            // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                            result += String.fromCharCode(29);
                                        }
                                    }
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                }
                // Unshift back to another code set if we were shifted
                if (unshift) {
                    codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
                }
            }
            const lastPatternSize = nextStart - lastStart;
            // Check for ample whitespace following pattern, but, to do this we first need to remember that
            // we fudged decoding CODE_STOP since it actually has 7 bars, not 6. There is a black bar left
            // to read off. Would be slightly better to properly read. Here we just skip it:
            nextStart = row.getNextUnset(nextStart);
            if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) {
                throw new NotFoundException();
            }
            // Pull out from sum the value of the penultimate check code
            checksumTotal -= multiplier * lastCode;
            // lastCode is the checksum then:
            if (checksumTotal % 103 !== lastCode) {
                throw new ChecksumException();
            }
            // Need to pull out the check digits from string
            const resultLength = result.length;
            if (resultLength === 0) {
                // false positive
                throw new NotFoundException();
            }
            // Only bother if the result had at least one character, and if the checksum digit happened to
            // be a printable character. If it was just interpreted as a control code, nothing to remove.
            if (resultLength > 0 && lastCharacterWasPrintable) {
                if (codeSet === Code128Reader.CODE_CODE_C) {
                    result = result.substring(0, resultLength - 2);
                }
                else {
                    result = result.substring(0, resultLength - 1);
                }
            }
            const left = (startPatternInfo[1] + startPatternInfo[0]) / 2.0;
            const right = lastStart + lastPatternSize / 2.0;
            const rawCodesSize = rawCodes.length;
            const rawBytes = new Uint8Array(rawCodesSize);
            for (let i = 0; i < rawCodesSize; i++) {
                rawBytes[i] = rawCodes[i];
            }
            const points = [new ResultPoint(left, rowNumber), new ResultPoint(right, rowNumber)];
            return new Result(result, rawBytes, 0, points, BarcodeFormat$1.CODE_128, new Date().getTime());
        }
    }
    Code128Reader.CODE_PATTERNS = [
        Int32Array.from([2, 1, 2, 2, 2, 2]),
        Int32Array.from([2, 2, 2, 1, 2, 2]),
        Int32Array.from([2, 2, 2, 2, 2, 1]),
        Int32Array.from([1, 2, 1, 2, 2, 3]),
        Int32Array.from([1, 2, 1, 3, 2, 2]),
        Int32Array.from([1, 3, 1, 2, 2, 2]),
        Int32Array.from([1, 2, 2, 2, 1, 3]),
        Int32Array.from([1, 2, 2, 3, 1, 2]),
        Int32Array.from([1, 3, 2, 2, 1, 2]),
        Int32Array.from([2, 2, 1, 2, 1, 3]),
        Int32Array.from([2, 2, 1, 3, 1, 2]),
        Int32Array.from([2, 3, 1, 2, 1, 2]),
        Int32Array.from([1, 1, 2, 2, 3, 2]),
        Int32Array.from([1, 2, 2, 1, 3, 2]),
        Int32Array.from([1, 2, 2, 2, 3, 1]),
        Int32Array.from([1, 1, 3, 2, 2, 2]),
        Int32Array.from([1, 2, 3, 1, 2, 2]),
        Int32Array.from([1, 2, 3, 2, 2, 1]),
        Int32Array.from([2, 2, 3, 2, 1, 1]),
        Int32Array.from([2, 2, 1, 1, 3, 2]),
        Int32Array.from([2, 2, 1, 2, 3, 1]),
        Int32Array.from([2, 1, 3, 2, 1, 2]),
        Int32Array.from([2, 2, 3, 1, 1, 2]),
        Int32Array.from([3, 1, 2, 1, 3, 1]),
        Int32Array.from([3, 1, 1, 2, 2, 2]),
        Int32Array.from([3, 2, 1, 1, 2, 2]),
        Int32Array.from([3, 2, 1, 2, 2, 1]),
        Int32Array.from([3, 1, 2, 2, 1, 2]),
        Int32Array.from([3, 2, 2, 1, 1, 2]),
        Int32Array.from([3, 2, 2, 2, 1, 1]),
        Int32Array.from([2, 1, 2, 1, 2, 3]),
        Int32Array.from([2, 1, 2, 3, 2, 1]),
        Int32Array.from([2, 3, 2, 1, 2, 1]),
        Int32Array.from([1, 1, 1, 3, 2, 3]),
        Int32Array.from([1, 3, 1, 1, 2, 3]),
        Int32Array.from([1, 3, 1, 3, 2, 1]),
        Int32Array.from([1, 1, 2, 3, 1, 3]),
        Int32Array.from([1, 3, 2, 1, 1, 3]),
        Int32Array.from([1, 3, 2, 3, 1, 1]),
        Int32Array.from([2, 1, 1, 3, 1, 3]),
        Int32Array.from([2, 3, 1, 1, 1, 3]),
        Int32Array.from([2, 3, 1, 3, 1, 1]),
        Int32Array.from([1, 1, 2, 1, 3, 3]),
        Int32Array.from([1, 1, 2, 3, 3, 1]),
        Int32Array.from([1, 3, 2, 1, 3, 1]),
        Int32Array.from([1, 1, 3, 1, 2, 3]),
        Int32Array.from([1, 1, 3, 3, 2, 1]),
        Int32Array.from([1, 3, 3, 1, 2, 1]),
        Int32Array.from([3, 1, 3, 1, 2, 1]),
        Int32Array.from([2, 1, 1, 3, 3, 1]),
        Int32Array.from([2, 3, 1, 1, 3, 1]),
        Int32Array.from([2, 1, 3, 1, 1, 3]),
        Int32Array.from([2, 1, 3, 3, 1, 1]),
        Int32Array.from([2, 1, 3, 1, 3, 1]),
        Int32Array.from([3, 1, 1, 1, 2, 3]),
        Int32Array.from([3, 1, 1, 3, 2, 1]),
        Int32Array.from([3, 3, 1, 1, 2, 1]),
        Int32Array.from([3, 1, 2, 1, 1, 3]),
        Int32Array.from([3, 1, 2, 3, 1, 1]),
        Int32Array.from([3, 3, 2, 1, 1, 1]),
        Int32Array.from([3, 1, 4, 1, 1, 1]),
        Int32Array.from([2, 2, 1, 4, 1, 1]),
        Int32Array.from([4, 3, 1, 1, 1, 1]),
        Int32Array.from([1, 1, 1, 2, 2, 4]),
        Int32Array.from([1, 1, 1, 4, 2, 2]),
        Int32Array.from([1, 2, 1, 1, 2, 4]),
        Int32Array.from([1, 2, 1, 4, 2, 1]),
        Int32Array.from([1, 4, 1, 1, 2, 2]),
        Int32Array.from([1, 4, 1, 2, 2, 1]),
        Int32Array.from([1, 1, 2, 2, 1, 4]),
        Int32Array.from([1, 1, 2, 4, 1, 2]),
        Int32Array.from([1, 2, 2, 1, 1, 4]),
        Int32Array.from([1, 2, 2, 4, 1, 1]),
        Int32Array.from([1, 4, 2, 1, 1, 2]),
        Int32Array.from([1, 4, 2, 2, 1, 1]),
        Int32Array.from([2, 4, 1, 2, 1, 1]),
        Int32Array.from([2, 2, 1, 1, 1, 4]),
        Int32Array.from([4, 1, 3, 1, 1, 1]),
        Int32Array.from([2, 4, 1, 1, 1, 2]),
        Int32Array.from([1, 3, 4, 1, 1, 1]),
        Int32Array.from([1, 1, 1, 2, 4, 2]),
        Int32Array.from([1, 2, 1, 1, 4, 2]),
        Int32Array.from([1, 2, 1, 2, 4, 1]),
        Int32Array.from([1, 1, 4, 2, 1, 2]),
        Int32Array.from([1, 2, 4, 1, 1, 2]),
        Int32Array.from([1, 2, 4, 2, 1, 1]),
        Int32Array.from([4, 1, 1, 2, 1, 2]),
        Int32Array.from([4, 2, 1, 1, 1, 2]),
        Int32Array.from([4, 2, 1, 2, 1, 1]),
        Int32Array.from([2, 1, 2, 1, 4, 1]),
        Int32Array.from([2, 1, 4, 1, 2, 1]),
        Int32Array.from([4, 1, 2, 1, 2, 1]),
        Int32Array.from([1, 1, 1, 1, 4, 3]),
        Int32Array.from([1, 1, 1, 3, 4, 1]),
        Int32Array.from([1, 3, 1, 1, 4, 1]),
        Int32Array.from([1, 1, 4, 1, 1, 3]),
        Int32Array.from([1, 1, 4, 3, 1, 1]),
        Int32Array.from([4, 1, 1, 1, 1, 3]),
        Int32Array.from([4, 1, 1, 3, 1, 1]),
        Int32Array.from([1, 1, 3, 1, 4, 1]),
        Int32Array.from([1, 1, 4, 1, 3, 1]),
        Int32Array.from([3, 1, 1, 1, 4, 1]),
        Int32Array.from([4, 1, 1, 1, 3, 1]),
        Int32Array.from([2, 1, 1, 4, 1, 2]),
        Int32Array.from([2, 1, 1, 2, 1, 4]),
        Int32Array.from([2, 1, 1, 2, 3, 2]),
        Int32Array.from([2, 3, 3, 1, 1, 1, 2]),
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;

    /**
     * <p>Decodes Code 39 barcodes. Supports "Full ASCII Code 39" if USE_CODE_39_EXTENDED_MODE is set.</p>
     *
     * @author Sean Owen
     * @see Code93Reader
     */
    class Code39Reader extends OneDReader {
        /**
         * Creates a reader that assumes all encoded data is data, and does not treat the final
         * character as a check digit. It will not decoded "extended Code 39" sequences.
         */
        // public Code39Reader() {
        //   this(false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit.
         * It will not decoded "extended Code 39" sequences.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         */
        // public Code39Reader(boolean usingCheckDigit) {
        //   this(usingCheckDigit, false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit,
         * or optionally attempt to decode "extended Code 39" sequences that are used to encode
         * the full ASCII character set.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
         * text.
         */
        constructor(usingCheckDigit = false, extendedMode = false) {
            super();
            this.usingCheckDigit = usingCheckDigit;
            this.extendedMode = extendedMode;
            this.decodeRowResult = '';
            this.counters = new Int32Array(9);
        }
        decodeRow(rowNumber, row, hints) {
            let theCounters = this.counters;
            theCounters.fill(0);
            this.decodeRowResult = '';
            let start = Code39Reader.findAsteriskPattern(row, theCounters);
            // Read off white space
            let nextStart = row.getNextSet(start[1]);
            let end = row.getSize();
            let decodedChar;
            let lastStart;
            do {
                Code39Reader.recordPattern(row, nextStart, theCounters);
                let pattern = Code39Reader.toNarrowWidePattern(theCounters);
                if (pattern < 0) {
                    throw new NotFoundException();
                }
                decodedChar = Code39Reader.patternToChar(pattern);
                this.decodeRowResult += decodedChar;
                lastStart = nextStart;
                for (let counter of theCounters) {
                    nextStart += counter;
                }
                // Read off white space
                nextStart = row.getNextSet(nextStart);
            } while (decodedChar !== '*');
            this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
            // Look for whitespace after pattern:
            let lastPatternSize = 0;
            for (let counter of theCounters) {
                lastPatternSize += counter;
            }
            let whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
            // If 50% of last pattern size, following last pattern, is not whitespace, fail
            // (but if it's whitespace to the very end of the image, that's OK)
            if (nextStart !== end && (whiteSpaceAfterEnd * 2) < lastPatternSize) {
                throw new NotFoundException();
            }
            if (this.usingCheckDigit) {
                let max = this.decodeRowResult.length - 1;
                let total = 0;
                for (let i = 0; i < max; i++) {
                    total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i));
                }
                if (this.decodeRowResult.charAt(max) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) {
                    throw new ChecksumException();
                }
                this.decodeRowResult = this.decodeRowResult.substring(0, max);
            }
            if (this.decodeRowResult.length === 0) {
                // false positive
                throw new NotFoundException();
            }
            let resultString;
            if (this.extendedMode) {
                resultString = Code39Reader.decodeExtended(this.decodeRowResult);
            }
            else {
                resultString = this.decodeRowResult;
            }
            let left = (start[1] + start[0]) / 2.0;
            let right = lastStart + lastPatternSize / 2.0;
            return new Result(resultString, null, 0, [new ResultPoint(left, rowNumber), new ResultPoint(right, rowNumber)], BarcodeFormat$1.CODE_39, new Date().getTime());
        }
        static findAsteriskPattern(row, counters) {
            let width = row.getSize();
            let rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let isWhite = false;
            let patternLength = counters.length;
            for (let i = rowOffset; i < width; i++) {
                if (row.get(i) !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition === patternLength - 1) {
                        // Look for whitespace before start pattern, >= 50% of width of start pattern
                        if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING &&
                            row.isRange(Math.max(0, patternStart - Math.floor((i - patternStart) / 2)), patternStart, false)) {
                            return [patternStart, i];
                        }
                        patternStart += counters[0] + counters[1];
                        counters.copyWithin(0, 2, 2 + counterPosition - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            throw new NotFoundException();
        }
        // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
        // per image when using some of our blackbox images.
        static toNarrowWidePattern(counters) {
            let numCounters = counters.length;
            let maxNarrowCounter = 0;
            let wideCounters;
            do {
                let minCounter = 0x7fffffff;
                for (let counter of counters) {
                    if (counter < minCounter && counter > maxNarrowCounter) {
                        minCounter = counter;
                    }
                }
                maxNarrowCounter = minCounter;
                wideCounters = 0;
                let totalWideCountersWidth = 0;
                let pattern = 0;
                for (let i = 0; i < numCounters; i++) {
                    let counter = counters[i];
                    if (counter > maxNarrowCounter) {
                        pattern |= 1 << (numCounters - 1 - i);
                        wideCounters++;
                        totalWideCountersWidth += counter;
                    }
                }
                if (wideCounters === 3) {
                    // Found 3 wide counters, but are they close enough in width?
                    // We can perform a cheap, conservative check to see if any individual
                    // counter is more than 1.5 times the average:
                    for (let i = 0; i < numCounters && wideCounters > 0; i++) {
                        let counter = counters[i];
                        if (counter > maxNarrowCounter) {
                            wideCounters--;
                            // totalWideCountersWidth = 3 * average, so this checks if counter >= 3/2 * average
                            if ((counter * 2) >= totalWideCountersWidth) {
                                return -1;
                            }
                        }
                    }
                    return pattern;
                }
            } while (wideCounters > 3);
            return -1;
        }
        static patternToChar(pattern) {
            for (let i = 0; i < Code39Reader.CHARACTER_ENCODINGS.length; i++) {
                if (Code39Reader.CHARACTER_ENCODINGS[i] === pattern) {
                    return Code39Reader.ALPHABET_STRING.charAt(i);
                }
            }
            if (pattern === Code39Reader.ASTERISK_ENCODING) {
                return '*';
            }
            throw new NotFoundException();
        }
        static decodeExtended(encoded) {
            let length = encoded.length;
            let decoded = '';
            for (let i = 0; i < length; i++) {
                let c = encoded.charAt(i);
                if (c === '+' || c === '$' || c === '%' || c === '/') {
                    let next = encoded.charAt(i + 1);
                    let decodedChar = '\0';
                    switch (c) {
                        case '+':
                            // +A to +Z map to a to z
                            if (next >= 'A' && next <= 'Z') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                        case '$':
                            // $A to $Z map to control codes SH to SB
                            if (next >= 'A' && next <= 'Z') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                        case '%':
                            // %A to %E map to control codes ESC to US
                            if (next >= 'A' && next <= 'E') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                            }
                            else if (next >= 'F' && next <= 'J') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                            }
                            else if (next >= 'K' && next <= 'O') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                            }
                            else if (next >= 'P' && next <= 'T') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                            }
                            else if (next === 'U') {
                                decodedChar = '\0';
                            }
                            else if (next === 'V') {
                                decodedChar = '@';
                            }
                            else if (next === 'W') {
                                decodedChar = '`';
                            }
                            else if (next === 'X' || next === 'Y' || next === 'Z') {
                                decodedChar = '\x7f';
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                        case '/':
                            // /A to /O map to ! to , and /Z maps to :
                            if (next >= 'A' && next <= 'O') {
                                decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                            }
                            else if (next === 'Z') {
                                decodedChar = ':';
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                    }
                    decoded += decodedChar;
                    // bump up i again since we read two characters
                    i++;
                }
                else {
                    decoded += c;
                }
            }
            return decoded;
        }
    }
    Code39Reader.ALPHABET_STRING = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%';
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow,
     * with 1s representing "wide" and 0s representing narrow.
     */
    Code39Reader.CHARACTER_ENCODINGS = [
        0x034, 0x121, 0x061, 0x160, 0x031, 0x130, 0x070, 0x025, 0x124, 0x064,
        0x109, 0x049, 0x148, 0x019, 0x118, 0x058, 0x00D, 0x10C, 0x04C, 0x01C,
        0x103, 0x043, 0x142, 0x013, 0x112, 0x052, 0x007, 0x106, 0x046, 0x016,
        0x181, 0x0C1, 0x1C0, 0x091, 0x190, 0x0D0, 0x085, 0x184, 0x0C4, 0x0A8,
        0x0A2, 0x08A, 0x02A // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 0x094;

    /**
     * <p>Decodes ITF barcodes.</p>
     *
     * @author Tjieco
     */
    class ITFReader extends OneDReader {
        constructor() {
            // private static W = 3; // Pixel width of a 3x wide line
            // private static w = 2; // Pixel width of a 2x wide line
            // private static N = 1; // Pixed width of a narrow line
            super(...arguments);
            // Stores the actual narrow line width of the image being decoded.
            this.narrowLineWidth = -1;
        }
        // See ITFWriter.PATTERNS
        /*
      
        /!**
         * Patterns of Wide / Narrow lines to indicate each digit
         *!/
        */
        decodeRow(rowNumber, row, hints) {
            // Find out where the Middle section (payload) starts & ends
            let startRange = this.decodeStart(row);
            let endRange = this.decodeEnd(row);
            let result = new StringBuilder();
            ITFReader.decodeMiddle(row, startRange[1], endRange[0], result);
            let resultString = result.toString();
            let allowedLengths = null;
            if (hints != null) {
                allowedLengths = hints.get(DecodeHintType$1.ALLOWED_LENGTHS);
            }
            if (allowedLengths == null) {
                allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
            }
            // To avoid false positives with 2D barcodes (and other patterns), make
            // an assumption that the decoded string must be a 'standard' length if it's short
            let length = resultString.length;
            let lengthOK = false;
            let maxAllowedLength = 0;
            for (let value of allowedLengths) {
                if (length === value) {
                    lengthOK = true;
                    break;
                }
                if (value > maxAllowedLength) {
                    maxAllowedLength = value;
                }
            }
            if (!lengthOK && length > maxAllowedLength) {
                lengthOK = true;
            }
            if (!lengthOK) {
                throw new FormatException();
            }
            const points = [new ResultPoint(startRange[1], rowNumber), new ResultPoint(endRange[0], rowNumber)];
            let resultReturn = new Result(resultString, null, // no natural byte representation for these barcodes
            0, points, BarcodeFormat$1.ITF, new Date().getTime());
            return resultReturn;
        }
        /*
        /!**
         * @param row          row of black/white values to search
         * @param payloadStart offset of start pattern
         * @param resultString {@link StringBuilder} to append decoded chars to
         * @throws NotFoundException if decoding could not complete successfully
         *!/*/
        static decodeMiddle(row, payloadStart, payloadEnd, resultString) {
            // Digits are interleaved in pairs - 5 black lines for one digit, and the
            // 5
            // interleaved white lines for the second digit.
            // Therefore, need to scan 10 lines and then
            // split these into two arrays
            let counterDigitPair = new Int32Array(10); // 10
            let counterBlack = new Int32Array(5); // 5
            let counterWhite = new Int32Array(5); // 5
            counterDigitPair.fill(0);
            counterBlack.fill(0);
            counterWhite.fill(0);
            while (payloadStart < payloadEnd) {
                // Get 10 runs of black/white.
                OneDReader.recordPattern(row, payloadStart, counterDigitPair);
                // Split them into each array
                for (let k = 0; k < 5; k++) {
                    let twoK = 2 * k;
                    counterBlack[k] = counterDigitPair[twoK];
                    counterWhite[k] = counterDigitPair[twoK + 1];
                }
                let bestMatch = ITFReader.decodeDigit(counterBlack);
                resultString.append(bestMatch.toString());
                bestMatch = this.decodeDigit(counterWhite);
                resultString.append(bestMatch.toString());
                counterDigitPair.forEach(function (counterDigit) {
                    payloadStart += counterDigit;
                });
            }
        }
        /*/!**
         * Identify where the start of the middle / payload section starts.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'start block' and end of
         *         'start block'
         *!/*/
        decodeStart(row) {
            let endStart = ITFReader.skipWhiteSpace(row);
            let startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
            // Determine the width of a narrow line in pixels. We can do this by
            // getting the width of the start pattern and dividing by 4 because its
            // made up of 4 narrow lines.
            this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
            this.validateQuietZone(row, startPattern[0]);
            return startPattern;
        }
        /*/!**
         * The start & end patterns must be pre/post fixed by a quiet zone. This
         * zone must be at least 10 times the width of a narrow line.  Scan back until
         * we either get to the start of the barcode or match the necessary number of
         * quiet zone pixels.
         *
         * Note: Its assumed the row is reversed when using this method to find
         * quiet zone after the end pattern.
         *
         * ref: http://www.barcode-1.net/i25code.html
         *
         * @param row bit array representing the scanned barcode.
         * @param startPattern index into row of the start or end pattern.
         * @throws NotFoundException if the quiet zone cannot be found
         *!/*/
        validateQuietZone(row, startPattern) {
            let quietCount = this.narrowLineWidth * 10; // expect to find this many pixels of quiet zone
            // if there are not so many pixel at all let's try as many as possible
            quietCount = quietCount < startPattern ? quietCount : startPattern;
            for (let i = startPattern - 1; quietCount > 0 && i >= 0; i--) {
                if (row.get(i)) {
                    break;
                }
                quietCount--;
            }
            if (quietCount !== 0) {
                // Unable to find the necessary number of quiet zone pixels.
                throw new NotFoundException();
            }
        }
        /*
        /!**
         * Skip all whitespace until we get to the first black line.
         *
         * @param row row of black/white values to search
         * @return index of the first black line.
         * @throws NotFoundException Throws exception if no black lines are found in the row
         *!/*/
        static skipWhiteSpace(row) {
            const width = row.getSize();
            const endStart = row.getNextSet(0);
            if (endStart === width) {
                throw new NotFoundException();
            }
            return endStart;
        }
        /*/!**
         * Identify where the end of the middle / payload section ends.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'end block' and end of 'end
         *         block'
         *!/*/
        decodeEnd(row) {
            // For convenience, reverse the row and then
            // search from 'the start' for the end block
            row.reverse();
            try {
                let endStart = ITFReader.skipWhiteSpace(row);
                let endPattern;
                try {
                    endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
                }
                catch (error) {
                    if (error instanceof NotFoundException) {
                        endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
                    }
                }
                // The start & end patterns must be pre/post fixed by a quiet zone. This
                // zone must be at least 10 times the width of a narrow line.
                // ref: http://www.barcode-1.net/i25code.html
                this.validateQuietZone(row, endPattern[0]);
                // Now recalculate the indices of where the 'endblock' starts & stops to
                // accommodate
                // the reversed nature of the search
                let temp = endPattern[0];
                endPattern[0] = row.getSize() - endPattern[1];
                endPattern[1] = row.getSize() - temp;
                return endPattern;
            }
            finally {
                // Put the row back the right way.
                row.reverse();
            }
        }
        /*
        /!**
         * @param row       row of black/white values to search
         * @param rowOffset position to start search
         * @param pattern   pattern of counts of number of black and white pixels that are
         *                  being searched for as a pattern
         * @return start/end horizontal offset of guard pattern, as an array of two
         *         ints
         * @throws NotFoundException if pattern is not found
         *!/*/
        static findGuardPattern(row, rowOffset, pattern) {
            let patternLength = pattern.length;
            let counters = new Int32Array(patternLength);
            let width = row.getSize();
            let isWhite = false;
            let counterPosition = 0;
            let patternStart = rowOffset;
            counters.fill(0);
            for (let x = rowOffset; x < width; x++) {
                if (row.get(x) !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition === patternLength - 1) {
                        if (OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) {
                            return [patternStart, x];
                        }
                        patternStart += counters[0] + counters[1];
                        System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            throw new NotFoundException();
        }
        /*/!**
         * Attempts to decode a sequence of ITF black/white lines into single
         * digit.
         *
         * @param counters the counts of runs of observed black/white/black/... values
         * @return The decoded digit
         * @throws NotFoundException if digit cannot be decoded
         *!/*/
        static decodeDigit(counters) {
            let bestVariance = ITFReader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            let max = ITFReader.PATTERNS.length;
            for (let i = 0; i < max; i++) {
                let pattern = ITFReader.PATTERNS[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                }
                else if (variance === bestVariance) {
                    // if we find a second 'best match' with the same variance, we can not reliably report to have a suitable match
                    bestMatch = -1;
                }
            }
            if (bestMatch >= 0) {
                return bestMatch % 10;
            }
            else {
                throw new NotFoundException();
            }
        }
    }
    ITFReader.PATTERNS = [
        Int32Array.from([1, 1, 2, 2, 1]),
        Int32Array.from([2, 1, 1, 1, 2]),
        Int32Array.from([1, 2, 1, 1, 2]),
        Int32Array.from([2, 2, 1, 1, 1]),
        Int32Array.from([1, 1, 2, 1, 2]),
        Int32Array.from([2, 1, 2, 1, 1]),
        Int32Array.from([1, 2, 2, 1, 1]),
        Int32Array.from([1, 1, 1, 2, 2]),
        Int32Array.from([2, 1, 1, 2, 1]),
        Int32Array.from([1, 2, 1, 2, 1]),
        Int32Array.from([1, 1, 3, 3, 1]),
        Int32Array.from([3, 1, 1, 1, 3]),
        Int32Array.from([1, 3, 1, 1, 3]),
        Int32Array.from([3, 3, 1, 1, 1]),
        Int32Array.from([1, 1, 3, 1, 3]),
        Int32Array.from([3, 1, 3, 1, 1]),
        Int32Array.from([1, 3, 3, 1, 1]),
        Int32Array.from([1, 1, 1, 3, 3]),
        Int32Array.from([3, 1, 1, 3, 1]),
        Int32Array.from([1, 3, 1, 3, 1]) // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    /* /!** Valid ITF lengths. Anything longer than the largest value is also allowed. *!/*/
    ITFReader.DEFAULT_ALLOWED_LENGTHS = [6, 8, 10, 12, 14];
    /*/!**
     * Start/end guard pattern.
     *
     * Note: The end pattern is reversed because the row is reversed before
     * searching for the END_PATTERN
     *!/*/
    ITFReader.START_PATTERN = Int32Array.from([1, 1, 1, 1]);
    ITFReader.END_PATTERN_REVERSED = [
        Int32Array.from([1, 1, 2]),
        Int32Array.from([1, 1, 3]) // 3x
    ];

    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */
    class AbstractUPCEANReader extends OneDReader {
        constructor() {
            super(...arguments);
            this.decodeRowStringBuffer = '';
        }

        static findStartGuardPattern(row) {
            let foundStart = false;
            let startRange;
            let nextStart = 0;
            let counters = Int32Array.from([0, 0, 0]);
            while (!foundStart) {
                counters = Int32Array.from([0, 0, 0]);
                startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
                let start = startRange[0];
                nextStart = startRange[1];
                let quietStart = start - (nextStart - start);
                if (quietStart >= 0) {
                    foundStart = row.isRange(quietStart, start, false);
                }
            }
            return startRange;
        }
        static checkChecksum(s) {
            return AbstractUPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0)
                return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return AbstractUPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for (let i = length - 1; i >= 0; i -= 2) {
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) {
                    throw new FormatException();
                }
                sum += digit;
            }
            sum *= 3;
            for (let i = length - 2; i >= 0; i -= 2) {
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) {
                    throw new FormatException();
                }
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
        static decodeEnd(row, endStart) {
            return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
        }
        /**
         * @throws NotFoundException
         */
        static findGuardPatternWithoutCounters(row, rowOffset, whiteFirst, pattern) {
            return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
        }
        /**
         * @param row row of black/white values to search
         * @param rowOffset position to start search
         * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
         * pixel counts, otherwise, it is interpreted as black/white/black/...
         * @param pattern pattern of counts of number of black and white pixels that are being
         * searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints
         * @throws NotFoundException if pattern is not found
         */
        static findGuardPattern(row, rowOffset, whiteFirst, pattern, counters) {
            let width = row.getSize();
            rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let patternLength = pattern.length;
            let isWhite = whiteFirst;
            for (let x = rowOffset; x < width; x++) {
                if (row.get(x) !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition === patternLength - 1) {
                        if (OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) {
                            return Int32Array.from([patternStart, x]);
                        }
                        patternStart += counters[0] + counters[1];
                        let slice = counters.slice(2, counters.length - 1);
                        for (let i = 0; i < counterPosition - 1; i++) {
                            counters[i] = slice[i];
                        }
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            throw new NotFoundException();
        }
        static decodeDigit(row, counters, rowOffset, patterns) {
            this.recordPattern(row, rowOffset, counters);
            let bestVariance = this.MAX_AVG_VARIANCE;
            let bestMatch = -1;
            let max = patterns.length;
            for (let i = 0; i < max; i++) {
                let pattern = patterns[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                }
            }
            if (bestMatch >= 0) {
                return bestMatch;
            }
            else {
                throw new NotFoundException();
            }
        }
    }
    // These two values are critical for determining how permissive the decoding will be.
    // We've arrived at these values through a lot of trial and error. Setting them any higher
    // lets false positives creep in quickly.
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    /**
     * Start/end guard pattern.
     */
    AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([1, 1, 1]);
    /**
     * Pattern marking the middle of a UPC/EAN pattern, separating the two halves.
     */
    AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([1, 1, 1, 1, 1]);
    /**
     * end guard pattern.
     */
    AbstractUPCEANReader.END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]);
    /**
     * "Odd", or "L" patterns used to encode UPC/EAN digits.
     */
    AbstractUPCEANReader.L_PATTERNS = [
        Int32Array.from([3, 2, 1, 1]),
        Int32Array.from([2, 2, 2, 1]),
        Int32Array.from([2, 1, 2, 2]),
        Int32Array.from([1, 4, 1, 1]),
        Int32Array.from([1, 1, 3, 2]),
        Int32Array.from([1, 2, 3, 1]),
        Int32Array.from([1, 1, 1, 4]),
        Int32Array.from([1, 3, 1, 2]),
        Int32Array.from([1, 2, 1, 3]),
        Int32Array.from([3, 1, 1, 2]),
    ];

    /**
     * @see UPCEANExtension2Support
     */
    class UPCEANExtension5Support {
        constructor() {
            this.CHECK_DIGIT_ENCODINGS = [0x18, 0x14, 0x12, 0x11, 0x0C, 0x06, 0x03, 0x0A, 0x09, 0x05];
            this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) {
                extensionResult.putAllMetadata(extensionData);
            }
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for (let x = 0; x < 5 && rowOffset < end; x++) {
                let bestMatch = AbstractUPCEANReader.decodeDigit(
                    row,
                    counters,
                    rowOffset,
                    AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode(('0'.charCodeAt(0) + bestMatch % 10));
                for (let counter of counters) {
                    rowOffset += counter;
                }
                if (bestMatch >= 10) {
                    lgPatternFound |= 1 << (4 - x);
                }
                if (x !== 4) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 5) {
                throw new NotFoundException();
            }
            let checkDigit = this.determineCheckDigit(lgPatternFound);
            if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) {
                throw new NotFoundException();
            }
            return rowOffset;
        }
        static extensionChecksum(s) {
            let length = s.length;
            let sum = 0;
            for (let i = length - 2; i >= 0; i -= 2) {
                sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            }
            sum *= 3;
            for (let i = length - 1; i >= 0; i -= 2) {
                sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            }
            sum *= 3;
            return sum % 10;
        }
        determineCheckDigit(lgPatternFound) {
            for (let d = 0; d < 10; d++) {
                if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d]) {
                    return d;
                }
            }
            throw new NotFoundException();
        }
        static parseExtensionString(raw) {
            if (raw.length !== 5) {
                return null;
            }
            let value = UPCEANExtension5Support.parseExtension5String(raw);
            if (value == null) {
                return null;
            }
            return new Map([[ResultMetadataType$1.SUGGESTED_PRICE, value]]);
        }
        static parseExtension5String(raw) {
            let currency;
            switch (raw.charAt(0)) {
                case '0':
                    currency = '£';
                    break;
                case '5':
                    currency = '$';
                    break;
                case '9':
                    // Reference: http://www.jollytech.com
                    switch (raw) {
                        case '90000':
                            // No suggested retail price
                            return null;
                        case '99991':
                            // Complementary
                            return '0.00';
                        case '99990':
                            return 'Used';
                    }
                    // Otherwise... unknown currency?
                    currency = '';
                    break;
                default:
                    currency = '';
                    break;
            }
            let rawAmount = parseInt(raw.substring(1));
            let unitsString = (rawAmount / 100).toString();
            let hundredths = rawAmount % 100;
            let hundredthsString = hundredths < 10 ? '0' + hundredths : hundredths.toString(); // fixme
            return currency + unitsString + '.' + hundredthsString;
        }
    }

    /**
     * @see UPCEANExtension5Support
     */
    class UPCEANExtension2Support {
        constructor() {
            this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) {
                extensionResult.putAllMetadata(extensionData);
            }
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let checkParity = 0;
            for (let x = 0; x < 2 && rowOffset < end; x++) {
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode(('0'.charCodeAt(0) + bestMatch % 10));
                for (let counter of counters) {
                    rowOffset += counter;
                }
                if (bestMatch >= 10) {
                    checkParity |= 1 << (1 - x);
                }
                if (x !== 1) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 2) {
                throw new NotFoundException();
            }
            if (parseInt(resultString.toString()) % 4 !== checkParity) {
                throw new NotFoundException();
            }
            return rowOffset;
        }
        static parseExtensionString(raw) {
            if (raw.length !== 2) {
                return null;
            }
            return new Map([[ResultMetadataType$1.ISSUE_NUMBER, parseInt(raw)]]);
        }
    }

    class UPCEANExtensionSupport {
        static decodeRow(rowNumber, row, rowOffset) {
            let extensionStartRange = AbstractUPCEANReader.findGuardPattern(
                row,
                rowOffset,
                false,
                this.EXTENSION_START_PATTERN,
                new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
            try {
                // return null;
                let fiveSupport = new UPCEANExtension5Support();
                return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
            }
            catch (err) {
                // return null;
                let twoSupport = new UPCEANExtension2Support();
                return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
            }
        }
    }
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([1, 1, 2]);

    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */
    class UPCEANReader extends AbstractUPCEANReader {
        constructor() {
            super();
            this.decodeRowStringBuffer = '';
            UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map(arr => Int32Array.from(arr));
            for (let i = 10; i < 20; i++) {
                let widths = UPCEANReader.L_PATTERNS[i - 10];
                let reversedWidths = new Int32Array(widths.length);
                for (let j = 0; j < widths.length; j++) {
                    reversedWidths[j] = widths[widths.length - j - 1];
                }
                UPCEANReader.L_AND_G_PATTERNS[i] = reversedWidths;
            }
        }
        decodeRow(rowNumber, row, hints) {
            let startGuardRange = UPCEANReader.findStartGuardPattern(row);
            let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((startGuardRange[0] + startGuardRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
            let endStart = budello.rowOffset;
            let result = budello.resultString;
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint(endStart, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let endRange = this.decodeEnd(row, endStart);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((endRange[0] + endRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            // Make sure there is a quiet zone at least as big as the end pattern after the barcode. The
            // spec might want more whitespace, but in practice this is the maximum we can count on.
            let end = endRange[1];
            let quietEnd = end + (end - endRange[0]);
            if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) {
                throw new NotFoundException();
            }
            let resultString = result.toString();
            // UPC/EAN should never be less than 8 chars anyway
            if (resultString.length < 8) {
                throw new FormatException();
            }
            if (!UPCEANReader.checkChecksum(resultString)) {
                throw new ChecksumException();
            }
            let left = (startGuardRange[1] + startGuardRange[0]) / 2.0;
            let right = (endRange[1] + endRange[0]) / 2.0;
            let format = this.getBarcodeFormat();
            let resultPoint = [new ResultPoint(left, rowNumber), new ResultPoint(right, rowNumber)];
            let decodeResult = new Result(resultString, null, 0, resultPoint, format, new Date().getTime());
            let extensionLength = 0;
            try {
                let extensionResult = UPCEANExtensionSupport.decodeRow(rowNumber, row, endRange[1]);
                decodeResult.putMetadata(ResultMetadataType$1.UPC_EAN_EXTENSION, extensionResult.getText());
                decodeResult.putAllMetadata(extensionResult.getResultMetadata());
                decodeResult.addResultPoints(extensionResult.getResultPoints());
                extensionLength = extensionResult.getText().length;
            }
            catch (ignoreError) {}
            let allowedExtensions = hints == null ? null : hints.get(DecodeHintType$1.ALLOWED_EAN_EXTENSIONS);
            if (allowedExtensions != null) {
                let valid = false;
                for (let length in allowedExtensions) {
                    if (extensionLength.toString() === length) { // check me
                        valid = true;
                        break;
                    }
                }
                if (!valid) {
                    throw new NotFoundException();
                }
            }
            return decodeResult;
        }
        decodeEnd(row, endStart) {
            return UPCEANReader.findGuardPattern(
                row, endStart, false, UPCEANReader.START_END_PATTERN,
                new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0));
        }
        static checkChecksum(s) {
            return UPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0)
                return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return UPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for (let i = length - 1; i >= 0; i -= 2) {
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) {
                    throw new FormatException();
                }
                sum += digit;
            }
            sum *= 3;
            for (let i = length - 2; i >= 0; i -= 2) {
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) {
                    throw new FormatException();
                }
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
    }

    /**
     * <p>Implements decoding of the EAN-13 format.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */
    class EAN13Reader extends UPCEANReader {
        constructor() {
            super();
            this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for (let x = 0; x < 6 && rowOffset < end; x++) {
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode(('0'.charCodeAt(0) + bestMatch % 10));
                for (let counter of counters) {
                    rowOffset += counter;
                }
                if (bestMatch >= 10) {
                    lgPatternFound |= 1 << (5 - x);
                }
            }
            resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
            let middleRange = UPCEANReader.findGuardPattern(
                row,
                rowOffset,
                true,
                UPCEANReader.MIDDLE_PATTERN,
                new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for (let x = 0; x < 6 && rowOffset < end; x++) {
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode(('0'.charCodeAt(0) + bestMatch));
                for (let counter of counters) {
                    rowOffset += counter;
                }
            }
            return { rowOffset, resultString };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_13;
        }
        static determineFirstDigit(resultString, lgPatternFound) {
            for (let d = 0; d < 10; d++) {
                if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d]) {
                    resultString = String.fromCharCode(('0'.charCodeAt(0) + d)) + resultString;
                    return resultString;
                }
            }
            throw new NotFoundException();
        }
    }
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [0x00, 0x0B, 0x0D, 0xE, 0x13, 0x19, 0x1C, 0x15, 0x16, 0x1A];

    /**
     * <p>Implements decoding of the EAN-8 format.</p>
     *
     * @author Sean Owen
     */
    class EAN8Reader extends UPCEANReader {
        constructor() {
            super();
            this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
        }
        decodeMiddle(row, startRange, resultString) {
            const counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            for (let x = 0; x < 4 && rowOffset < end; x++) {
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode(('0'.charCodeAt(0) + bestMatch));
                for (let counter of counters) {
                    rowOffset += counter;
                }
            }
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for (let x = 0; x < 4 && rowOffset < end; x++) {
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode(('0'.charCodeAt(0) + bestMatch));
                for (let counter of counters) {
                    rowOffset += counter;
                }
            }
            return { rowOffset, resultString };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_8;
        }
    }

    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author sam2332 (Sam Rudloff)
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCAReader.java
     *
     * @experimental
     */
    class UPCAReader extends UPCEANReader {
        constructor() {
            super(...arguments);
            this.ean13Reader = new EAN13Reader();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_A;
        }
        // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            return this.maybeReturnResult(this.ean13Reader.decode(image));
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
        }
        // @Override
        decodeMiddle(row, startRange, resultString) {
            return this.ean13Reader.decodeMiddle(row, startRange, resultString);
        }
        maybeReturnResult(result) {
            let text = result.getText();
            if (text.charAt(0) === '0') {
                let upcaResult = new Result(text.substring(1), null, null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                if (result.getResultMetadata() != null) {
                    upcaResult.putAllMetadata(result.getResultMetadata());
                }
                return upcaResult;
            }
            else {
                throw new NotFoundException();
            }
        }
        reset() {
            this.ean13Reader.reset();
        }
    }

    /**
     * <p>Implements decoding of the UPC-E format.</p>
     * <p><a href="http://www.barcodeisland.com/upce.phtml">This</a> is a great reference for
     * UPC-E information.</p>
     *
     * @author Sean Owen
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCEReader.java
     *
     * @experimental
     */
    /* final */ class UPCEReader extends UPCEANReader {
        constructor() {
            super();
            this.decodeMiddleCounters = new Int32Array(4);
        }
        /**
         * @throws NotFoundException
         */
        // @Override
        decodeMiddle(row, startRange, result) {
            const counters = this.decodeMiddleCounters.map(x => x);
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            const end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for (let x = 0; x < 6 && rowOffset < end; x++) {
                const bestMatch = UPCEReader.decodeDigit(
                    row, counters, rowOffset, UPCEReader.L_AND_G_PATTERNS);
                result += String.fromCharCode(('0'.charCodeAt(0) + (bestMatch % 10)));
                for (let counter of counters) {
                    rowOffset += counter;
                }
                if (bestMatch >= 10) {
                    lgPatternFound |= (1 << (5 - x));
                }
            }
            let resultString = UPCEReader.determineNumSysAndCheckDigit(
                result, lgPatternFound);
            return {rowOffset, resultString};
        }
        /**
         * @throws NotFoundException
         */
        // @Override
        decodeEnd(row, endStart) {
            return UPCEReader.findGuardPatternWithoutCounters(
                row, endStart, true, UPCEReader.MIDDLE_END_PATTERN);
        }
        /**
         * @throws FormatException
         */
        // @Override
        checkChecksum(s) {
            return UPCEANReader.checkChecksum(UPCEReader.convertUPCEtoUPCA(s));
        }
        /**
         * @throws NotFoundException
         */
        static determineNumSysAndCheckDigit(resultString, lgPatternFound) {
            for (let numSys = 0; numSys <= 1; numSys++) {
                for (let d = 0; d < 10; d++) {
                    if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d]) {
                        let prefix = String.fromCharCode('0'.charCodeAt(0) + numSys);
                        let suffix = String.fromCharCode('0'.charCodeAt(0) + d);
                        return prefix + resultString + suffix;
                    }
                }
            }
            throw NotFoundException.getNotFoundInstance();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_E;
        }
        /**
         * Expands a UPC-E value back into its full, equivalent UPC-A code value.
         *
         * @param upce UPC-E code as string of digits
         * @return equivalent UPC-A code as string of digits
         */
        static convertUPCEtoUPCA(upce) {
            // the following line is equivalent to upce.getChars(1, 7, upceChars, 0);
            const upceChars = upce.slice(1, 7).split('').map(x => x.charCodeAt(0));
            const result = new StringBuilder( /*12*/);
            result.append(upce.charAt(0));
            let lastChar = upceChars[5];
            switch (lastChar) {
                case 0:
                case 1:
                case 2:
                    result.appendChars(upceChars, 0, 2);
                    result.append(lastChar);
                    result.append('0000');
                    result.appendChars(upceChars, 2, 3);
                    break;
                case 3:
                    result.appendChars(upceChars, 0, 3);
                    result.append('00000');
                    result.appendChars(upceChars, 3, 2);
                    break;
                case 4:
                    result.appendChars(upceChars, 0, 4);
                    result.append('00000');
                    result.append(upceChars[4]);
                    break;
                default:
                    result.appendChars(upceChars, 0, 5);
                    result.append('0000');
                    result.append(lastChar);
                    break;
            }
            // Only append check digit in conversion if supplied
            if (upce.length >= 8) {
                result.append(upce.charAt(7));
            }
            return result.toString();
        }
    }
    /**
     * The pattern that marks the middle, and end, of a UPC-E pattern.
     * There is no "second half" to a UPC-E barcode.
     */
    UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]);
    // For an UPC-E barcode, the final digit is represented by the parities used
    // to encode the middle six digits, according to the table below.
    //
    //                Parity of next 6 digits
    //    Digit   0     1     2     3     4     5
    //       0    Even   Even  Even Odd  Odd   Odd
    //       1    Even   Even  Odd  Even Odd   Odd
    //       2    Even   Even  Odd  Odd  Even  Odd
    //       3    Even   Even  Odd  Odd  Odd   Even
    //       4    Even   Odd   Even Even Odd   Odd
    //       5    Even   Odd   Odd  Even Even  Odd
    //       6    Even   Odd   Odd  Odd  Even  Even
    //       7    Even   Odd   Even Odd  Even  Odd
    //       8    Even   Odd   Even Odd  Odd   Even
    //       9    Even   Odd   Odd  Even Odd   Even
    //
    // The encoding is represented by the following array, which is a bit pattern
    // using Odd = 0 and Even = 1. For example, 5 is represented by:
    //
    //              Odd Even Even Odd Odd Even
    // in binary:
    //                0    1    1   0   0    1   == 0x19
    //
    /**
     * See {@link #L_AND_G_PATTERNS}; these values similarly represent patterns of
     * even-odd parity encodings of digits that imply both the number system (0 or 1)
     * used, and the check digit.
     */
    UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([0x38, 0x34, 0x32, 0x31, 0x2C, 0x26, 0x23, 0x2A, 0x29, 0x25]),
        Int32Array.from([0x07, 0x0B, 0x0D, 0x0E, 0x13, 0x19, 0x1C, 0x15, 0x16, 0x1A]),
    ];

    /**
     * <p>A reader that can read all available UPC/EAN formats. If a caller wants to try to
     * read all such formats, it is most efficient to use this implementation rather than invoke
     * individual readers.</p>
     *
     * @author Sean Owen
     */
    class MultiFormatUPCEANReader extends OneDReader {
        constructor(hints) {
            super();
            let possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            let readers = [];
            if (!isNullOrUndefined(possibleFormats)) {
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_13) > -1) {
                    readers.push(new EAN13Reader());
                }
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_A) > -1) {
                    readers.push(new UPCAReader());
                }
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_8) > -1) {
                    readers.push(new EAN8Reader());
                }
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_E) > -1) {
                    readers.push(new UPCEReader());
                }
            } else {
                // No hints provided.
                readers.push(new EAN13Reader());
                readers.push(new UPCAReader());
                readers.push(new EAN8Reader());
                readers.push(new UPCEReader());
            }
            this.readers = readers;
        }
        decodeRow(rowNumber, row, hints) {
            for (let reader of this.readers) {
                try {
                    // const result: Result = reader.decodeRow(rowNumber, row, startGuardPattern, hints);
                    const result = reader.decodeRow(rowNumber, row, hints);
                    // Special case: a 12-digit code encoded in UPC-A is identical to a "0"
                    // followed by those 12 digits encoded as EAN-13. Each will recognize such a code,
                    // UPC-A as a 12-digit string and EAN-13 as a 13-digit string starting with "0".
                    // Individually these are correct and their readers will both read such a code
                    // and correctly call it EAN-13, or UPC-A, respectively.
                    //
                    // In this case, if we've been looking for both types, we'd like to call it
                    // a UPC-A code. But for efficiency we only run the EAN-13 decoder to also read
                    // UPC-A. So we special case it here, and convert an EAN-13 result to a UPC-A
                    // result if appropriate.
                    //
                    // But, don't return UPC-A if UPC-A was not a requested format!
                    const ean13MayBeUPCA = result.getBarcodeFormat() === BarcodeFormat$1.EAN_13 &&
                        result.getText().charAt(0) === '0';
                    // @SuppressWarnings("unchecked")
                    const possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
                    const canReturnUPCA = possibleFormats == null || possibleFormats.includes(BarcodeFormat$1.UPC_A);
                    if (ean13MayBeUPCA && canReturnUPCA) {
                        const rawBytes = result.getRawBytes();
                        // Transfer the metadata across
                        const resultUPCA = new Result(
                            result.getText().substring(1),
                            rawBytes,
                            (rawBytes ? rawBytes.length : null),
                            result.getResultPoints(),
                            BarcodeFormat$1.UPC_A);
                        resultUPCA.putAllMetadata(result.getResultMetadata());
                        return resultUPCA;
                    }
                    return result;
                }
                catch (err) {
                    // continue;
                }
            }
            throw new NotFoundException();
        }
        reset() {
            for (let reader of this.readers) {
                reader.reset();
            }
        }
    }

    // import Integer from '../../util/Integer';
    // import Float from '../../util/Float';
    class AbstractRSSReader extends OneDReader {
        constructor() {
            super();
            this.decodeFinderCounters = new Int32Array(4);
            this.dataCharacterCounters = new Int32Array(8);
            this.oddRoundingErrors = new Array(4);
            this.evenRoundingErrors = new Array(4);
            this.oddCounts = new Array(this.dataCharacterCounters.length / 2);
            this.evenCounts = new Array(this.dataCharacterCounters.length / 2);
        }
        getDecodeFinderCounters() {
            return this.decodeFinderCounters;
        }
        getDataCharacterCounters() {
            return this.dataCharacterCounters;
        }
        getOddRoundingErrors() {
            return this.oddRoundingErrors;
        }
        getEvenRoundingErrors() {
            return this.evenRoundingErrors;
        }
        getOddCounts() {
            return this.oddCounts;
        }
        getEvenCounts() {
            return this.evenCounts;
        }
        parseFinderValue(counters, finderPatterns) {
            for (let value = 0; value < finderPatterns.length; value++) {
                if (OneDReader.patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) {
                    return value;
                }
            }
            throw new NotFoundException();
        }
        /**
         * @param array values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */
        static count(array) {
            return MathUtils.sum(new Int32Array(array));
        }
        static increment(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for (let i = 1; i < array.length; i++) {
                if (errors[i] > biggestError) {
                    biggestError = errors[i];
                    index = i;
                }
            }
            array[index]++;
        }
        static decrement(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for (let i = 1; i < array.length; i++) {
                if (errors[i] < biggestError) {
                    biggestError = errors[i];
                    index = i;
                }
            }
            array[index]--;
        }
        static isFinderPattern(counters) {
            let firstTwoSum = counters[0] + counters[1];
            let sum = firstTwoSum + counters[2] + counters[3];
            let ratio = firstTwoSum / sum;
            if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
                // passes ratio test in spec, but see if the counts are unreasonable
                let minCounter = Number.MAX_SAFE_INTEGER;
                let maxCounter = Number.MIN_SAFE_INTEGER;
                for (let counter of counters) {
                    if (counter > maxCounter) {
                        maxCounter = counter;
                    }
                    if (counter < minCounter) {
                        minCounter = counter;
                    }
                }
                return maxCounter < 10 * minCounter;
            }
            return false;
        }
    }
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12.0;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14.0;

    class DataCharacter {
        constructor(value, checksumPortion) {
            this.value = value;
            this.checksumPortion = checksumPortion;
        }
        getValue() {
            return this.value;
        }
        getChecksumPortion() {
            return this.checksumPortion;
        }
        toString() {
            return this.value + '(' + this.checksumPortion + ')';
        }
        equals(o) {
            if (!(o instanceof DataCharacter)) {
                return false;
            }
            const that = o;
            return this.value === that.value && this.checksumPortion === that.checksumPortion;
        }
        hashCode() {
            return this.value ^ this.checksumPortion;
        }
    }

    class FinderPattern {
        constructor(value, startEnd, start, end, rowNumber) {
            this.value = value;
            this.startEnd = startEnd;
            this.value = value;
            this.startEnd = startEnd;
            this.resultPoints = new Array();
            this.resultPoints.push(new ResultPoint(start, rowNumber));
            this.resultPoints.push(new ResultPoint(end, rowNumber));
        }
        getValue() {
            return this.value;
        }
        getStartEnd() {
            return this.startEnd;
        }
        getResultPoints() {
            return this.resultPoints;
        }
        equals(o) {
            if (!(o instanceof FinderPattern)) {
                return false;
            }
            const that = o;
            return this.value === that.value;
        }
        hashCode() {
            return this.value;
        }
    }

    /**
     * RSS util functions.
     */
    class RSSUtils {
        constructor() { }
        static getRSSvalue(widths, maxWidth, noNarrow) {
            let n = 0;
            for (let width of widths) {
                n += width;
            }
            let val = 0;
            let narrowMask = 0;
            let elements = widths.length;
            for (let bar = 0; bar < elements - 1; bar++) {
                let elmWidth;
                for (elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)) {
                    let subVal = RSSUtils.combins(n - elmWidth - 1, elements - bar - 2);
                    if (noNarrow && (narrowMask === 0) && (n - elmWidth - (elements - bar - 1) >= elements - bar - 1)) {
                        subVal -= RSSUtils.combins(n - elmWidth - (elements - bar), elements - bar - 2);
                    }
                    if (elements - bar - 1 > 1) {
                        let lessVal = 0;
                        for (let mxwElement = n - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--) {
                            lessVal += RSSUtils.combins(n - elmWidth - mxwElement - 1, elements - bar - 3);
                        }
                        subVal -= lessVal * (elements - 1 - bar);
                    }
                    else if (n - elmWidth > maxWidth) {
                        subVal--;
                    }
                    val += subVal;
                }
                n -= elmWidth;
            }
            return val;
        }
        static combins(n, r) {
            let maxDenom;
            let minDenom;
            if (n - r > r) {
                minDenom = r;
                maxDenom = n - r;
            }
            else {
                minDenom = n - r;
                maxDenom = r;
            }
            let val = 1;
            let j = 1;
            for (let i = n; i > maxDenom; i--) {
                val *= i;
                if (j <= minDenom) {
                    val /= j;
                    j++;
                }
            }
            while ((j <= minDenom)) {
                val /= j;
                j++;
            }
            return val;
        }
    }

    class BitArrayBuilder {
        static buildBitArray(pairs) {
            let charNumber = (pairs.length * 2) - 1;
            if (pairs[pairs.length - 1].getRightChar() == null) {
                charNumber -= 1;
            }
            let size = 12 * charNumber;
            let binary = new BitArray(size);
            let accPos = 0;
            let firstPair = pairs[0];
            let firstValue = firstPair.getRightChar().getValue();
            for (let i = 11; i >= 0; --i) {
                if ((firstValue & (1 << i)) != 0) {
                    binary.set(accPos);
                }
                accPos++;
            }
            for (let i = 1; i < pairs.length; ++i) {
                let currentPair = pairs[i];
                let leftValue = currentPair.getLeftChar().getValue();
                for (let j = 11; j >= 0; --j) {
                    if ((leftValue & (1 << j)) != 0) {
                        binary.set(accPos);
                    }
                    accPos++;
                }
                if (currentPair.getRightChar() != null) {
                    let rightValue = currentPair.getRightChar().getValue();
                    for (let j = 11; j >= 0; --j) {
                        if ((rightValue & (1 << j)) != 0) {
                            binary.set(accPos);
                        }
                        accPos++;
                    }
                }
            }
            return binary;
        }
    }

    class BlockParsedResult {
        constructor(finished, decodedInformation) {
            if (decodedInformation) {
                this.decodedInformation = null;
            }
            else {
                this.finished = finished;
                this.decodedInformation = decodedInformation;
            }
        }
        getDecodedInformation() {
            return this.decodedInformation;
        }
        isFinished() {
            return this.finished;
        }
    }

    class DecodedObject {
        constructor(newPosition) {
            this.newPosition = newPosition;
        }
        getNewPosition() {
            return this.newPosition;
        }
    }

    class DecodedChar extends DecodedObject {
        constructor(newPosition, value) {
            super(newPosition);
            this.value = value;
        }
        getValue() {
            return this.value;
        }
        isFNC1() {
            return this.value === DecodedChar.FNC1;
        }
    }
    DecodedChar.FNC1 = '$';

    class DecodedInformation extends DecodedObject {
        constructor(newPosition, newString, remainingValue) {
            super(newPosition);
            if (remainingValue) {
                this.remaining = true;
                this.remainingValue = this.remainingValue;
            }
            else {
                this.remaining = false;
                this.remainingValue = 0;
            }
            this.newString = newString;
        }
        getNewString() {
            return this.newString;
        }
        isRemaining() {
            return this.remaining;
        }
        getRemainingValue() {
            return this.remainingValue;
        }
    }

    class DecodedNumeric extends DecodedObject {
        constructor(newPosition, firstDigit, secondDigit) {
            super(newPosition);
            if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) {
                throw new FormatException();
            }
            this.firstDigit = firstDigit;
            this.secondDigit = secondDigit;
        }
        getFirstDigit() {
            return this.firstDigit;
        }
        getSecondDigit() {
            return this.secondDigit;
        }
        getValue() {
            return this.firstDigit * 10 + this.secondDigit;
        }
        isFirstDigitFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1;
        }
        isSecondDigitFNC1() {
            return this.secondDigit === DecodedNumeric.FNC1;
        }
        isAnyFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
        }
    }
    DecodedNumeric.FNC1 = 10;

    class FieldParser {
        constructor() {
        }
        static parseFieldsInGeneralPurpose(rawInformation) {
            if (!rawInformation) {
                return null;
            }
            // Processing 2-digit AIs
            if (rawInformation.length < 2) {
                throw new NotFoundException();
            }
            let firstTwoDigits = rawInformation.substring(0, 2);
            for (let dataLength of FieldParser.TWO_DIGIT_DATA_LENGTH) {
                if (dataLength[0] === firstTwoDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
                        return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
                    }
                    return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
                }
            }
            if (rawInformation.length < 3) {
                throw new NotFoundException();
            }
            let firstThreeDigits = rawInformation.substring(0, 3);
            for (let dataLength of FieldParser.THREE_DIGIT_DATA_LENGTH) {
                if (dataLength[0] === firstThreeDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
                        return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
                    }
                    return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
                }
            }
            for (let dataLength of FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH) {
                if (dataLength[0] === firstThreeDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
                        return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                    }
                    return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
                }
            }
            if (rawInformation.length < 4) {
                throw new NotFoundException();
            }
            let firstFourDigits = rawInformation.substring(0, 4);
            for (let dataLength of FieldParser.FOUR_DIGIT_DATA_LENGTH) {
                if (dataLength[0] === firstFourDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
                        return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                    }
                    return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
                }
            }
            throw new NotFoundException();
        }
        static processFixedAI(aiSize, fieldSize, rawInformation) {
            if (rawInformation.length < aiSize) {
                throw new NotFoundException();
            }
            let ai = rawInformation.substring(0, aiSize);
            if (rawInformation.length < aiSize + fieldSize) {
                throw new NotFoundException();
            }
            let field = rawInformation.substring(aiSize, aiSize + fieldSize);
            let remaining = rawInformation.substring(aiSize + fieldSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
        static processVariableAI(aiSize, variableFieldSize, rawInformation) {
            let ai = rawInformation.substring(0, aiSize);
            let maxSize;
            if (rawInformation.length < aiSize + variableFieldSize) {
                maxSize = rawInformation.length;
            }
            else {
                maxSize = aiSize + variableFieldSize;
            }
            let field = rawInformation.substring(aiSize, maxSize);
            let remaining = rawInformation.substring(maxSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
    }
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
        ['00', 18],
        ['01', 14],
        ['02', 14],
        ['10', FieldParser.VARIABLE_LENGTH, 20],
        ['11', 6],
        ['12', 6],
        ['13', 6],
        ['15', 6],
        ['17', 6],
        ['20', 2],
        ['21', FieldParser.VARIABLE_LENGTH, 20],
        ['22', FieldParser.VARIABLE_LENGTH, 29],
        ['30', FieldParser.VARIABLE_LENGTH, 8],
        ['37', FieldParser.VARIABLE_LENGTH, 8],
        // internal company codes
        ['90', FieldParser.VARIABLE_LENGTH, 30],
        ['91', FieldParser.VARIABLE_LENGTH, 30],
        ['92', FieldParser.VARIABLE_LENGTH, 30],
        ['93', FieldParser.VARIABLE_LENGTH, 30],
        ['94', FieldParser.VARIABLE_LENGTH, 30],
        ['95', FieldParser.VARIABLE_LENGTH, 30],
        ['96', FieldParser.VARIABLE_LENGTH, 30],
        ['97', FieldParser.VARIABLE_LENGTH, 3],
        ['98', FieldParser.VARIABLE_LENGTH, 30],
        ['99', FieldParser.VARIABLE_LENGTH, 30],
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
        // Same format as above
        ['240', FieldParser.VARIABLE_LENGTH, 30],
        ['241', FieldParser.VARIABLE_LENGTH, 30],
        ['242', FieldParser.VARIABLE_LENGTH, 6],
        ['250', FieldParser.VARIABLE_LENGTH, 30],
        ['251', FieldParser.VARIABLE_LENGTH, 30],
        ['253', FieldParser.VARIABLE_LENGTH, 17],
        ['254', FieldParser.VARIABLE_LENGTH, 20],
        ['400', FieldParser.VARIABLE_LENGTH, 30],
        ['401', FieldParser.VARIABLE_LENGTH, 30],
        ['402', 17],
        ['403', FieldParser.VARIABLE_LENGTH, 30],
        ['410', 13],
        ['411', 13],
        ['412', 13],
        ['413', 13],
        ['414', 13],
        ['420', FieldParser.VARIABLE_LENGTH, 20],
        ['421', FieldParser.VARIABLE_LENGTH, 15],
        ['422', 3],
        ['423', FieldParser.VARIABLE_LENGTH, 15],
        ['424', 3],
        ['425', 3],
        ['426', 3],
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        // Same format as above
        ['310', 6],
        ['311', 6],
        ['312', 6],
        ['313', 6],
        ['314', 6],
        ['315', 6],
        ['316', 6],
        ['320', 6],
        ['321', 6],
        ['322', 6],
        ['323', 6],
        ['324', 6],
        ['325', 6],
        ['326', 6],
        ['327', 6],
        ['328', 6],
        ['329', 6],
        ['330', 6],
        ['331', 6],
        ['332', 6],
        ['333', 6],
        ['334', 6],
        ['335', 6],
        ['336', 6],
        ['340', 6],
        ['341', 6],
        ['342', 6],
        ['343', 6],
        ['344', 6],
        ['345', 6],
        ['346', 6],
        ['347', 6],
        ['348', 6],
        ['349', 6],
        ['350', 6],
        ['351', 6],
        ['352', 6],
        ['353', 6],
        ['354', 6],
        ['355', 6],
        ['356', 6],
        ['357', 6],
        ['360', 6],
        ['361', 6],
        ['362', 6],
        ['363', 6],
        ['364', 6],
        ['365', 6],
        ['366', 6],
        ['367', 6],
        ['368', 6],
        ['369', 6],
        ['390', FieldParser.VARIABLE_LENGTH, 15],
        ['391', FieldParser.VARIABLE_LENGTH, 18],
        ['392', FieldParser.VARIABLE_LENGTH, 15],
        ['393', FieldParser.VARIABLE_LENGTH, 18],
        ['703', FieldParser.VARIABLE_LENGTH, 30],
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
        // Same format as above
        ['7001', 13],
        ['7002', FieldParser.VARIABLE_LENGTH, 30],
        ['7003', 10],
        ['8001', 14],
        ['8002', FieldParser.VARIABLE_LENGTH, 20],
        ['8003', FieldParser.VARIABLE_LENGTH, 30],
        ['8004', FieldParser.VARIABLE_LENGTH, 30],
        ['8005', 6],
        ['8006', 18],
        ['8007', FieldParser.VARIABLE_LENGTH, 30],
        ['8008', FieldParser.VARIABLE_LENGTH, 12],
        ['8018', 18],
        ['8020', FieldParser.VARIABLE_LENGTH, 25],
        ['8100', 6],
        ['8101', 10],
        ['8102', 2],
        ['8110', FieldParser.VARIABLE_LENGTH, 70],
        ['8200', FieldParser.VARIABLE_LENGTH, 70],
    ];

    class GeneralAppIdDecoder {
        constructor(information) {
            this.buffer = new StringBuilder();
            this.information = information;
        }
        decodeAllCodes(buff, initialPosition) {
            let currentPosition = initialPosition;
            let remaining = null;
            do {
                let info = this.decodeGeneralPurposeField(currentPosition, remaining);
                let parsedFields = FieldParser.parseFieldsInGeneralPurpose(info.getNewString());
                if (parsedFields != null) {
                    buff.append(parsedFields);
                }
                if (info.isRemaining()) {
                    remaining = '' + info.getRemainingValue();
                }
                else {
                    remaining = null;
                }
                if (currentPosition === info.getNewPosition()) { // No step forward!
                    break;
                }
                currentPosition = info.getNewPosition();
            } while (true);
            return buff.toString();
        }
        isStillNumeric(pos) {
            // It's numeric if it still has 7 positions
            // and one of the first 4 bits is "1".
            if (pos + 7 > this.information.getSize()) {
                return pos + 4 <= this.information.getSize();
            }
            for (let i = pos; i < pos + 3; ++i) {
                if (this.information.get(i)) {
                    return true;
                }
            }
            return this.information.get(pos + 3);
        }
        decodeNumeric(pos) {
            if (pos + 7 > this.information.getSize()) {
                let numeric = this.extractNumericValueFromBitArray(pos, 4);
                if (numeric === 0) {
                    return new DecodedNumeric(this.information.getSize(), DecodedNumeric.FNC1, DecodedNumeric.FNC1);
                }
                return new DecodedNumeric(this.information.getSize(), numeric - 1, DecodedNumeric.FNC1);
            }
            let numeric = this.extractNumericValueFromBitArray(pos, 7);
            let digit1 = (numeric - 8) / 11;
            let digit2 = (numeric - 8) % 11;
            return new DecodedNumeric(pos + 7, digit1, digit2);
        }
        extractNumericValueFromBitArray(pos, bits) {
            return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
        }
        static extractNumericValueFromBitArray(information, pos, bits) {
            let value = 0;
            for (let i = 0; i < bits; ++i) {
                if (information.get(pos + i)) {
                    value |= 1 << (bits - i - 1);
                }
            }
            return value;
        }
        decodeGeneralPurposeField(pos, remaining) {
            // this.buffer.setLength(0);
            this.buffer.setLengthToZero();
            if (remaining != null) {
                this.buffer.append(remaining);
            }
            this.current.setPosition(pos);
            let lastDecoded = this.parseBlocks();
            if (lastDecoded != null && lastDecoded.isRemaining()) {
                return new DecodedInformation(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
            }
            return new DecodedInformation(this.current.getPosition(), this.buffer.toString());
        }
        parseBlocks() {
            let isFinished;
            let result;
            do {
                let initialPosition = this.current.getPosition();
                if (this.current.isAlpha()) {
                    result = this.parseAlphaBlock();
                    isFinished = result.isFinished();
                }
                else if (this.current.isIsoIec646()) {
                    result = this.parseIsoIec646Block();
                    isFinished = result.isFinished();
                }
                else { // it must be numeric
                    result = this.parseNumericBlock();
                    isFinished = result.isFinished();
                }
                let positionChanged = initialPosition !== this.current.getPosition();
                if (!positionChanged && !isFinished) {
                    break;
                }
            } while (!isFinished);
            return result.getDecodedInformation();
        }
        parseNumericBlock() {
            while (this.isStillNumeric(this.current.getPosition())) {
                let numeric = this.decodeNumeric(this.current.getPosition());
                this.current.setPosition(numeric.getNewPosition());
                if (numeric.isFirstDigitFNC1()) {
                    let information;
                    if (numeric.isSecondDigitFNC1()) {
                        information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    }
                    else {
                        information = new DecodedInformation(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
                    }
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getFirstDigit());
                if (numeric.isSecondDigitFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getSecondDigit());
            }
            if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
                this.current.setAlpha();
                this.current.incrementPosition(4);
            }
            return new BlockParsedResult(false);
        }
        parseIsoIec646Block() {
            while (this.isStillIsoIec646(this.current.getPosition())) {
                let iso = this.decodeIsoIec646(this.current.getPosition());
                this.current.setPosition(iso.getNewPosition());
                if (iso.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(iso.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            }
            else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) {
                    this.current.incrementPosition(5);
                }
                else {
                    this.current.setPosition(this.information.getSize());
                }
                this.current.setAlpha();
            }
            return new BlockParsedResult(false);
        }
        parseAlphaBlock() {
            while (this.isStillAlpha(this.current.getPosition())) {
                let alpha = this.decodeAlphanumeric(this.current.getPosition());
                this.current.setPosition(alpha.getNewPosition());
                if (alpha.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information); // end of the char block
                }
                this.buffer.append(alpha.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            }
            else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) {
                    this.current.incrementPosition(5);
                }
                else {
                    this.current.setPosition(this.information.getSize());
                }
                this.current.setIsoIec646();
            }
            return new BlockParsedResult(false);
        }
        isStillIsoIec646(pos) {
            if (pos + 5 > this.information.getSize()) {
                return false;
            }
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) {
                return true;
            }
            if (pos + 7 > this.information.getSize()) {
                return false;
            }
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 116) {
                return true;
            }
            if (pos + 8 > this.information.getSize()) {
                return false;
            }
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            return eightBitValue >= 232 && eightBitValue < 253;
        }
        decodeIsoIec646(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) {
                return new DecodedChar(pos + 5, DecodedChar.FNC1);
            }
            if (fiveBitValue >= 5 && fiveBitValue < 15) {
                return new DecodedChar(pos + 5, ('0' + (fiveBitValue - 5)));
            }
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 90) {
                return new DecodedChar(pos + 7, ('' + (sevenBitValue + 1)));
            }
            if (sevenBitValue >= 90 && sevenBitValue < 116) {
                return new DecodedChar(pos + 7, ('' + (sevenBitValue + 7)));
            }
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            let c;
            switch (eightBitValue) {
                case 232:
                    c = '!';
                    break;
                case 233:
                    c = '"';
                    break;
                case 234:
                    c = '%';
                    break;
                case 235:
                    c = '&';
                    break;
                case 236:
                    c = '\'';
                    break;
                case 237:
                    c = '(';
                    break;
                case 238:
                    c = ')';
                    break;
                case 239:
                    c = '*';
                    break;
                case 240:
                    c = '+';
                    break;
                case 241:
                    c = ',';
                    break;
                case 242:
                    c = '-';
                    break;
                case 243:
                    c = '.';
                    break;
                case 244:
                    c = '/';
                    break;
                case 245:
                    c = ':';
                    break;
                case 246:
                    c = ';';
                    break;
                case 247:
                    c = '<';
                    break;
                case 248:
                    c = '=';
                    break;
                case 249:
                    c = '>';
                    break;
                case 250:
                    c = '?';
                    break;
                case 251:
                    c = '_';
                    break;
                case 252:
                    c = ' ';
                    break;
                default:
                    throw new FormatException();
            }
            return new DecodedChar(pos + 8, c);
        }
        isStillAlpha(pos) {
            if (pos + 5 > this.information.getSize()) {
                return false;
            }
            // We now check if it's a valid 5-bit value (0..9 and FNC1)
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) {
                return true;
            }
            if (pos + 6 > this.information.getSize()) {
                return false;
            }
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            return sixBitValue >= 16 && sixBitValue < 63; // 63 not included
        }
        decodeAlphanumeric(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) {
                return new DecodedChar(pos + 5, DecodedChar.FNC1);
            }
            if (fiveBitValue >= 5 && fiveBitValue < 15) {
                return new DecodedChar(pos + 5, ('0' + (fiveBitValue - 5)));
            }
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            if (sixBitValue >= 32 && sixBitValue < 58) {
                return new DecodedChar(pos + 6, ('' + (sixBitValue + 33)));
            }
            let c;
            switch (sixBitValue) {
                case 58:
                    c = '*';
                    break;
                case 59:
                    c = ',';
                    break;
                case 60:
                    c = '-';
                    break;
                case 61:
                    c = '.';
                    break;
                case 62:
                    c = '/';
                    break;
                default:
                    throw new IllegalStateException('Decoding invalid alphanumeric value: ' + sixBitValue);
            }
            return new DecodedChar(pos + 6, c);
        }
        isAlphaTo646ToAlphaLatch(pos) {
            if (pos + 1 > this.information.getSize()) {
                return false;
            }
            for (let i = 0; i < 5 && i + pos < this.information.getSize(); ++i) {
                if (i === 2) {
                    if (!this.information.get(pos + 2)) {
                        return false;
                    }
                }
                else if (this.information.get(pos + i)) {
                    return false;
                }
            }
            return true;
        }
        isAlphaOr646ToNumericLatch(pos) {
            // Next is alphanumeric if there are 3 positions and they are all zeros
            if (pos + 3 > this.information.getSize()) {
                return false;
            }
            for (let i = pos; i < pos + 3; ++i) {
                if (this.information.get(i)) {
                    return false;
                }
            }
            return true;
        }
        isNumericToAlphaNumericLatch(pos) {
            // Next is alphanumeric if there are 4 positions and they are all zeros, or
            // if there is a subset of this just before the end of the symbol
            if (pos + 1 > this.information.getSize()) {
                return false;
            }
            for (let i = 0; i < 4 && i + pos < this.information.getSize(); ++i) {
                if (this.information.get(pos + i)) {
                    return false;
                }
            }
            return true;
        }
    }

    class AbstractExpandedDecoder {
        constructor(information) {
            this.information = information;
            this.generalDecoder = new GeneralAppIdDecoder(information);
        }
        getInformation() {
            return this.information;
        }
        getGeneralDecoder() {
            return this.generalDecoder;
        }
    }

    class AI01decoder extends AbstractExpandedDecoder {
        constructor(information) {
            super(information);
        }
        encodeCompressedGtin(buf, currentPos) {
            buf.append('(01)');
            let initialPosition = buf.length();
            buf.append('9');
            this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
        }
        encodeCompressedGtinWithoutAI(buf, currentPos, initialBufferPosition) {
            for (let i = 0; i < 4; ++i) {
                let currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i, 10);
                if (currentBlock / 100 === 0) {
                    buf.append('0');
                }
                if (currentBlock / 10 === 0) {
                    buf.append('0');
                }
                buf.append(currentBlock);
            }
            AI01decoder.appendCheckDigit(buf, initialBufferPosition);
        }
        static appendCheckDigit(buf, currentPos) {
            let checkDigit = 0;
            for (let i = 0; i < 13; i++) {
                // let digit = buf.charAt(i + currentPos) - '0';
                // To be checked
                let digit = buf.charAt(i + currentPos).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - (checkDigit % 10);
            if (checkDigit === 10) {
                checkDigit = 0;
            }
            buf.append(checkDigit);
        }
    }
    AI01decoder.GTIN_SIZE = 40;

    class AI01AndOtherAIs extends AI01decoder {
        // the second one is the encodation method, and the other two are for the variable length
        constructor(information) {
            super(information);
        }
        parseInformation() {
            let buff = new StringBuilder();
            buff.append('(01)');
            let initialGtinPosition = buff.length();
            let firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
            buff.append(firstGtinDigit);
            this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
            return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
        }
    }
    AI01AndOtherAIs.HEADER_SIZE = 1 + 1 + 2; // first bit encodes the linkage flag,

    class AnyAIDecoder extends AbstractExpandedDecoder {
        constructor(information) {
            super(information);
        }
        parseInformation() {
            let buf = new StringBuilder();
            return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
        }
    }
    AnyAIDecoder.HEADER_SIZE = 2 + 1 + 2;

    class AI01weightDecoder extends AI01decoder {
        constructor(information) {
            super(information);
        }
        encodeCompressedWeight(buf, currentPos, weightSize) {
            let originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
            this.addWeightCode(buf, originalWeightNumeric);
            let weightNumeric = this.checkWeight(originalWeightNumeric);
            let currentDivisor = 100000;
            for (let i = 0; i < 5; ++i) {
                if (weightNumeric / currentDivisor === 0) {
                    buf.append('0');
                }
                currentDivisor /= 10;
            }
            buf.append(weightNumeric);
        }
    }

    class AI013x0xDecoder extends AI01weightDecoder {
        constructor(information) {
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) {
                throw new NotFoundException();
            }
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
    }
    AI013x0xDecoder.HEADER_SIZE = 4 + 1;
    AI013x0xDecoder.WEIGHT_SIZE = 15;

    class AI013103decoder extends AI013x0xDecoder {
        constructor(information) {
            super(information);
        }
        addWeightCode(buf, weight) {
            buf.append('(3103)');
        }
        checkWeight(weight) {
            return weight;
        }
    }

    class AI01320xDecoder extends AI013x0xDecoder {
        constructor(information) {
            super(information);
        }
        addWeightCode(buf, weight) {
            if (weight < 10000) {
                buf.append('(3202)');
            }
            else {
                buf.append('(3203)');
            }
        }
        checkWeight(weight) {
            if (weight < 10000) {
                return weight;
            }
            return weight - 10000;
        }
    }

    class AI01392xDecoder extends AI01decoder {
        constructor(information) {
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) {
                throw new NotFoundException();
            }
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
            buf.append('(392');
            buf.append(lastAIdigit);
            buf.append(')');
            let decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
            buf.append(decodedInformation.getNewString());
            return buf.toString();
        }
    }
    AI01392xDecoder.HEADER_SIZE = 5 + 1 + 2;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;

    class AI01393xDecoder extends AI01decoder {
        constructor(information) {
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) {
                throw new NotFoundException();
            }
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
            buf.append('(393');
            buf.append(lastAIdigit);
            buf.append(')');
            let firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
            if (firstThreeDigits / 100 == 0) {
                buf.append('0');
            }
            if (firstThreeDigits / 10 == 0) {
                buf.append('0');
            }
            buf.append(firstThreeDigits);
            let generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
            buf.append(generalInformation.getNewString());
            return buf.toString();
        }
    }
    AI01393xDecoder.HEADER_SIZE = 5 + 1 + 2;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;

    class AI013x0x1xDecoder extends AI01weightDecoder {
        constructor(information, firstAIdigits, dateCode) {
            super(information);
            this.dateCode = dateCode;
            this.firstAIdigits = firstAIdigits;
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) {
                throw new NotFoundException();
            }
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
            this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
        encodeCompressedDate(buf, currentPos) {
            let numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
            if (numericDate == 38400) {
                return;
            }
            buf.append('(');
            buf.append(this.dateCode);
            buf.append(')');
            let day = numericDate % 32;
            numericDate /= 32;
            let month = numericDate % 12 + 1;
            numericDate /= 12;
            let year = numericDate;
            if (year / 10 == 0) {
                buf.append('0');
            }
            buf.append(year);
            if (month / 10 == 0) {
                buf.append('0');
            }
            buf.append(month);
            if (day / 10 == 0) {
                buf.append('0');
            }
            buf.append(day);
        }
        addWeightCode(buf, weight) {
            buf.append('(');
            buf.append(this.firstAIdigits);
            buf.append(weight / 100000);
            buf.append(')');
        }
        checkWeight(weight) {
            return weight % 100000;
        }
    }
    AI013x0x1xDecoder.HEADER_SIZE = 7 + 1;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;

    function createDecoder(information) {
        try {
            if (information.get(1)) {
                return new AI01AndOtherAIs(information);
            }
            if (!information.get(2)) {
                return new AnyAIDecoder(information);
            }
            let fourBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 4);
            switch (fourBitEncodationMethod) {
                case 4: return new AI013103decoder(information);
                case 5: return new AI01320xDecoder(information);
            }
            let fiveBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 5);
            switch (fiveBitEncodationMethod) {
                case 12: return new AI01392xDecoder(information);
                case 13: return new AI01393xDecoder(information);
            }
            let sevenBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 7);
            switch (sevenBitEncodationMethod) {
                case 56: return new AI013x0x1xDecoder(information, '310', '11');
                case 57: return new AI013x0x1xDecoder(information, '320', '11');
                case 58: return new AI013x0x1xDecoder(information, '310', '13');
                case 59: return new AI013x0x1xDecoder(information, '320', '13');
                case 60: return new AI013x0x1xDecoder(information, '310', '15');
                case 61: return new AI013x0x1xDecoder(information, '320', '15');
                case 62: return new AI013x0x1xDecoder(information, '310', '17');
                case 63: return new AI013x0x1xDecoder(information, '320', '17');
            }
        }
        catch (e) {
            console.log(e);
            throw new IllegalStateException('unknown decoder: ' + information);
        }
    }

    class ExpandedPair {
        constructor(leftChar, rightChar, finderPatter, mayBeLast) {
            this.leftchar = leftChar;
            this.rightchar = rightChar;
            this.finderpattern = finderPatter;
            this.maybeLast = mayBeLast;
        }
        mayBeLast() {
            return this.maybeLast;
        }
        getLeftChar() {
            return this.leftchar;
        }
        getRightChar() {
            return this.rightchar;
        }
        getFinderPattern() {
            return this.finderpattern;
        }
        mustBeLast() {
            return this.rightchar == null;
        }
        toString() {
            return '[ ' + this.leftchar + ', ' + this.rightchar + ' : ' + (this.finderpattern == null ? 'null' : this.finderpattern.getValue()) + ' ]';
        }
        static equals(o1, o2) {
            if (!(o1 instanceof ExpandedPair)) {
                return false;
            }
            return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) &&
                ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) &&
                ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
        }
        static equalsOrNull(o1, o2) {
            return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
        }
        hashCode() {
            // return ExpandedPair.hashNotNull(leftChar) ^ hashNotNull(rightChar) ^ hashNotNull(finderPattern);
            let value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
            return value;
        }
    }

    class ExpandedRow {
        constructor(pairs, rowNumber, wasReversed) {
            this.pairs = pairs;
            this.rowNumber = rowNumber;
            this.wasReversed = wasReversed;
        }
        getPairs() {
            return this.pairs;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        isReversed() {
            return this.wasReversed;
        }
        // check implementation
        isEquivalent(otherPairs) {
            return this.checkEqualitity(this, otherPairs);
        }
        // @Override
        toString() {
            return '{ ' + this.pairs + ' }';
        }
        /**
         * Two rows are equal if they contain the same pairs in the same order.
         */
        // @Override
        // check implementation
        equals(o1, o2) {
            if (!(o1 instanceof ExpandedRow)) {
                return false;
            }
            return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
        }
        checkEqualitity(pair1, pair2) {
            if (!pair1 || !pair2)
                return;
            let result;
            pair1.forEach((e1, i) => {
                pair2.forEach(e2 => {
                    if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) {
                        result = true;
                    }
                });
            });
            return result;
        }
    }

    // import java.util.ArrayList;
    // import java.util.Iterator;
    // import java.util.List;
    // import java.util.Map;
    // import java.util.Collections;
    class RSSExpandedReader extends AbstractRSSReader {
        constructor(verbose) {
            super(...arguments);
            this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
            this.rows = new Array();
            this.startEnd = [2];
            this.verbose = (verbose === true);
        }
        decodeRow(rowNumber, row, hints) {
            // Rows can start with even pattern in case in prev rows there where odd number of patters.
            // So lets try twice
            // this.pairs.clear();
            this.pairs.length = 0;
            this.startFromEven = false;
            try {
                return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
            }
            catch (e) {
                // OK
                if (this.verbose) {
                    console.log(e);
                }
            }
            this.pairs.length = 0;
            this.startFromEven = true;
            return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        }
        reset() {
            this.pairs.length = 0;
            this.rows.length = 0;
        }
        // Not private for testing
        decodeRow2pairs(rowNumber, row) {
            let done = false;
            while (!done) {
                try {
                    this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
                }
                catch (error) {
                    if (error instanceof NotFoundException) {
                        if (!this.pairs.length) {
                            throw new NotFoundException();
                        }
                        // exit this loop when retrieveNextPair() fails and throws
                        done = true;
                    }
                }
            }
            // TODO: verify sequence of finder patterns as in checkPairSequence()
            if (this.checkChecksum()) {
                return this.pairs;
            }
            let tryStackedDecode;
            if (this.rows.length) {
                tryStackedDecode = true;
            }
            else {
                tryStackedDecode = false;
            }
            // let tryStackedDecode = !this.rows.isEmpty();
            this.storeRow(rowNumber, false); // TODO: deal with reversed rows
            if (tryStackedDecode) {
                // When the image is 180-rotated, then rows are sorted in wrong direction.
                // Try twice with both the directions.
                let ps = this.checkRowsBoolean(false);
                if (ps != null) {
                    return ps;
                }
                ps = this.checkRowsBoolean(true);
                if (ps != null) {
                    return ps;
                }
            }
            throw new NotFoundException();
        }
        // Need to Verify
        checkRowsBoolean(reverse) {
            // Limit number of rows we are checking
            // We use recursive algorithm with pure complexity and don't want it to take forever
            // Stacked barcode can have up to 11 rows, so 25 seems reasonable enough
            if (this.rows.length > 25) {
                this.rows.length = 0; // We will never have a chance to get result, so clear it
                return null;
            }
            this.pairs.length = 0;
            if (reverse) {
                this.rows = this.rows.reverse();
                // Collections.reverse(this.rows);
            }
            let ps = null;
            try {
                ps = this.checkRows(new Array(), 0);
            }
            catch (e) {
                // OK
                if (this.verbose) {
                    console.log(e);
                }
            }
            if (reverse) {
                this.rows = this.rows.reverse();
                // Collections.reverse(this.rows);
            }
            return ps;
        }
        // Try to construct a valid rows sequence
        // Recursion is used to implement backtracking
        checkRows(collectedRows, currentRow) {
            for (let i = currentRow; i < this.rows.length; i++) {
                let row = this.rows[i];
                this.pairs.length = 0;
                for (let collectedRow of collectedRows) {
                    this.pairs.push(collectedRow.getPairs());
                }
                this.pairs.push(row.getPairs());
                if (!RSSExpandedReader.isValidSequence(this.pairs)) {
                    continue;
                }
                if (this.checkChecksum()) {
                    return this.pairs;
                }
                let rs = new Array(collectedRows);
                rs.push(row);
                try {
                    // Recursion: try to add more rows
                    return this.checkRows(rs, i + 1);
                }
                catch (e) {
                    // We failed, try the next candidate
                    if (this.verbose) {
                        console.log(e);
                    }
                }
            }
            throw new NotFoundException();
        }
        // Whether the pairs form a valid find pattern sequence,
        // either complete or a prefix
        static isValidSequence(pairs) {
            for (let sequence of RSSExpandedReader.FINDER_PATTERN_SEQUENCES) {
                if (pairs.length > sequence.length) {
                    continue;
                }
                let stop = true;
                for (let j = 0; j < pairs.length; j++) {
                    if (pairs[j].getFinderPattern().getValue() != sequence[j]) {
                        stop = false;
                        break;
                    }
                }
                if (stop) {
                    return true;
                }
            }
            return false;
        }
        storeRow(rowNumber, wasReversed) {
            // Discard if duplicate above or below; otherwise insert in order by row number.
            let insertPos = 0;
            let prevIsSame = false;
            let nextIsSame = false;
            while (insertPos < this.rows.length) {
                let erow = this.rows[insertPos];
                if (erow.getRowNumber() > rowNumber) {
                    nextIsSame = erow.isEquivalent(this.pairs);
                    break;
                }
                prevIsSame = erow.isEquivalent(this.pairs);
                insertPos++;
            }
            if (nextIsSame || prevIsSame) {
                return;
            }
            // When the row was partially decoded (e.g. 2 pairs found instead of 3),
            // it will prevent us from detecting the barcode.
            // Try to merge partial rows
            // Check whether the row is part of an allready detected row
            if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) {
                return;
            }
            this.rows.push(insertPos, new ExpandedRow(this.pairs, rowNumber, wasReversed));
            this.removePartialRows(this.pairs, this.rows);
        }
        // Remove all the rows that contains only specified pairs
        removePartialRows(pairs, rows) {
            // for (Iterator<ExpandedRow> iterator = rows.iterator(); iterator.hasNext();) {
            //   ExpandedRow r = iterator.next();
            //   if (r.getPairs().size() == pairs.size()) {
            //     continue;
            //   }
            //   boolean allFound = true;
            //   for (ExpandedPair p : r.getPairs()) {
            //     boolean found = false;
            //     for (ExpandedPair pp : pairs) {
            //       if (p.equals(pp)) {
            //         found = true;
            //         break;
            //       }
            //     }
            //     if (!found) {
            //       allFound = false;
            //       break;
            //     }
            //   }
            //   if (allFound) {
            //     // 'pairs' contains all the pairs from the row 'r'
            //     iterator.remove();
            //   }
            // }
            for (let row of rows) {
                if (row.getPairs().length === pairs.length) {
                    continue;
                }
                for (let p of row.getPairs()) {
                    for (let pp of pairs) {
                        if (ExpandedPair.equals(p, pp)) {
                            break;
                        }
                    }
                }
            }
        }
        // Returns true when one of the rows already contains all the pairs
        static isPartialRow(pairs, rows) {
            for (let r of rows) {
                let allFound = true;
                for (let p of pairs) {
                    let found = false;
                    for (let pp of r.getPairs()) {
                        if (p.equals(pp)) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        allFound = false;
                        break;
                    }
                }
                if (allFound) {
                    // the row 'r' contain all the pairs from 'pairs'
                    return true;
                }
            }
            return false;
        }
        // Only used for unit testing
        getRows() {
            return this.rows;
        }
        // Not private for unit testing
        static constructResult(pairs) {
            let binary = BitArrayBuilder.buildBitArray(pairs);
            let decoder = createDecoder(binary);
            let resultingString = decoder.parseInformation();
            let firstPoints = pairs[0].getFinderPattern().getResultPoints();
            let lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
            let points = [firstPoints[0], firstPoints[1], lastPoints[0], lastPoints[1]];
            return new Result(resultingString, null, null, points, BarcodeFormat$1.RSS_EXPANDED, null);
        }
        checkChecksum() {
            let firstPair = this.pairs.get(0);
            let checkCharacter = firstPair.getLeftChar();
            let firstCharacter = firstPair.getRightChar();
            if (firstCharacter == null) {
                return false;
            }
            let checksum = firstCharacter.getChecksumPortion();
            let s = 2;
            for (let i = 1; i < this.pairs.size(); ++i) {
                let currentPair = this.pairs.get(i);
                checksum += currentPair.getLeftChar().getChecksumPortion();
                s++;
                let currentRightChar = currentPair.getRightChar();
                if (currentRightChar != null) {
                    checksum += currentRightChar.getChecksumPortion();
                    s++;
                }
            }
            checksum %= 211;
            let checkCharacterValue = 211 * (s - 4) + checksum;
            return checkCharacterValue == checkCharacter.getValue();
        }
        static getNextSecondBar(row, initialPos) {
            let currentPos;
            if (row.get(initialPos)) {
                currentPos = row.getNextUnset(initialPos);
                currentPos = row.getNextSet(currentPos);
            }
            else {
                currentPos = row.getNextSet(initialPos);
                currentPos = row.getNextUnset(currentPos);
            }
            return currentPos;
        }
        // not private for testing
        retrieveNextPair(row, previousPairs, rowNumber) {
            let isOddPattern = previousPairs.length % 2 == 0;
            if (this.startFromEven) {
                isOddPattern = !isOddPattern;
            }
            let pattern;
            let keepFinding = true;
            let forcedOffset = -1;
            do {
                this.findNextPair(row, previousPairs, forcedOffset);
                pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
                if (pattern == null) {
                    forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
                }
                else {
                    keepFinding = false;
                }
            } while (keepFinding);
            // When stacked symbol is split over multiple rows, there's no way to guess if this pair can be last or not.
            // boolean mayBeLast = checkPairSequence(previousPairs, pattern);
            let leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
            if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) {
                throw new NotFoundException();
            }
            let rightChar;
            try {
                rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
            }
            catch (e) {
                rightChar = null;
                if (this.verbose) {
                    console.log(e);
                }
            }
            return new ExpandedPair(leftChar, rightChar, pattern, true);
        }
        isEmptyPair(pairs) {
            if (pairs.length === 0) {
                return true;
            }
            return false;
        }
        findNextPair(row, previousPairs, forcedOffset) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let rowOffset;
            if (forcedOffset >= 0) {
                rowOffset = forcedOffset;
            }
            else if (this.isEmptyPair(previousPairs)) {
                rowOffset = 0;
            }
            else {
                let lastPair = previousPairs[previousPairs.length - 1];
                rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
            }
            let searchingEvenPair = previousPairs.length % 2 != 0;
            if (this.startFromEven) {
                searchingEvenPair = !searchingEvenPair;
            }
            let isWhite = false;
            while (rowOffset < width) {
                isWhite = !row.get(rowOffset);
                if (!isWhite) {
                    break;
                }
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for (let x = rowOffset; x < width; x++) {
                if (row.get(x) != isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition == 3) {
                        if (searchingEvenPair) {
                            RSSExpandedReader.reverseCounters(counters);
                        }
                        if (RSSExpandedReader.isFinderPattern(counters)) {
                            this.startEnd[0] = patternStart;
                            this.startEnd[1] = x;
                            return;
                        }
                        if (searchingEvenPair) {
                            RSSExpandedReader.reverseCounters(counters);
                        }
                        patternStart += counters[0] + counters[1];
                        counters[0] = counters[2];
                        counters[1] = counters[3];
                        counters[2] = 0;
                        counters[3] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            throw new NotFoundException();
        }
        static reverseCounters(counters) {
            let length = counters.length;
            for (let i = 0; i < length / 2; ++i) {
                let tmp = counters[i];
                counters[i] = counters[length - i - 1];
                counters[length - i - 1] = tmp;
            }
        }
        parseFoundFinderPattern(row, rowNumber, oddPattern) {
            // Actually we found elements 2-5.
            let firstCounter;
            let start;
            let end;
            if (oddPattern) {
                // If pattern number is odd, we need to locate element 1 *before* the current block.
                let firstElementStart = this.startEnd[0] - 1;
                // Locate element 1
                while (firstElementStart >= 0 && !row.get(firstElementStart)) {
                    firstElementStart--;
                }
                firstElementStart++;
                firstCounter = this.startEnd[0] - firstElementStart;
                start = firstElementStart;
                end = this.startEnd[1];
            }
            else {
                // If pattern number is even, the pattern is reversed, so we need to locate element 1 *after* the current block.
                start = this.startEnd[0];
                end = row.getNextUnset(this.startEnd[1] + 1);
                firstCounter = end - this.startEnd[1];
            }
            // Make 'counters' hold 1-4
            let counters = this.getDecodeFinderCounters();
            System.arraycopy(counters, 0, counters, 1, counters.length - 1);
            counters[0] = firstCounter;
            let value;
            try {
                value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
            }
            catch (e) {
                return null;
            }
            // return new FinderPattern(value, new int[] { start, end }, start, end, rowNumber});
            return new FinderPattern(value, [start, end], start, end, rowNumber);
        }
        decodeDataCharacter(row, pattern, isOddPattern, leftChar) {
            let counters = this.getDataCharacterCounters();
            for (let x = 0; x < counters.length; x++) {
                counters[x] = 0;
            }
            if (leftChar) {
                RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            }
            else {
                RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
                // reverse it
                for (let i = 0, j = counters.length - 1; i < j; i++, j--) {
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            } // counters[] has the pixels of the module
            let numModules = 17; // left and right data characters have all the same length
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            // Sanity check: element width for pattern and the character should match
            let expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15.0;
            if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) {
                throw new NotFoundException();
            }
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for (let i = 0; i < counters.length; i++) {
                let value = 1.0 * counters[i] / elementWidth;
                let count = value + 0.5; // Round
                if (count < 1) {
                    if (value < 0.3) {
                        throw new NotFoundException();
                    }
                    count = 1;
                }
                else if (count > 8) {
                    if (value > 8.7) {
                        throw new NotFoundException();
                    }
                    count = 8;
                }
                let offset = i / 2;
                if ((i & 0x01) == 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                }
                else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(numModules);
            let weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for (let i = oddCounts.length - 1; i >= 0; i--) {
                if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                    let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i];
                    oddChecksumPortion += oddCounts[i] * weight;
                }
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            // int evenSum = 0;
            for (let i = evenCounts.length - 1; i >= 0; i--) {
                if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                    let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i + 1];
                    evenChecksumPortion += evenCounts[i] * weight;
                }
                // evenSum += evenCounts[i];
            }
            let checksumPortion = oddChecksumPortion + evenChecksumPortion;
            if ((oddSum & 0x01) != 0 || oddSum > 13 || oddSum < 4) {
                throw new NotFoundException();
            }
            let group = (13 - oddSum) / 2;
            let oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
            let evenWidest = 9 - oddWidest;
            let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
            let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
            let tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
            let gSum = RSSExpandedReader.GSUM[group];
            let value = vOdd * tEven + vEven + gSum;
            return new DataCharacter(value, checksumPortion);
        }
        static isNotA1left(pattern, isOddPattern, leftChar) {
            // A1: pattern.getValue is 0 (A), and it's an oddPattern, and it is a left char
            return !(pattern.getValue() == 0 && isOddPattern && leftChar);
        }
        adjustOddEvenCounts(numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            if (oddSum > 13) {
                decrementOdd = true;
            }
            else if (oddSum < 4) {
                incrementOdd = true;
            }
            let incrementEven = false;
            let decrementEven = false;
            if (evenSum > 13) {
                decrementEven = true;
            }
            else if (evenSum < 4) {
                incrementEven = true;
            }
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) == 1;
            let evenParityBad = (evenSum & 0x01) == 0;
            if (mismatch == 1) {
                if (oddParityBad) {
                    if (evenParityBad) {
                        throw new NotFoundException();
                    }
                    decrementOdd = true;
                }
                else {
                    if (!evenParityBad) {
                        throw new NotFoundException();
                    }
                    decrementEven = true;
                }
            }
            else if (mismatch == -1) {
                if (oddParityBad) {
                    if (evenParityBad) {
                        throw new NotFoundException();
                    }
                    incrementOdd = true;
                }
                else {
                    if (!evenParityBad) {
                        throw new NotFoundException();
                    }
                    incrementEven = true;
                }
            }
            else if (mismatch == 0) {
                if (oddParityBad) {
                    if (!evenParityBad) {
                        throw new NotFoundException();
                    }
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    }
                    else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                }
                else {
                    if (evenParityBad) {
                        throw new NotFoundException();
                    }
                    // Nothing to do!
                }
            }
            else {
                throw new NotFoundException();
            }
            if (incrementOdd) {
                if (decrementOdd) {
                    throw new NotFoundException();
                }
                RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) {
                RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (incrementEven) {
                if (decrementEven) {
                    throw new NotFoundException();
                }
                RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) {
                RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
            }
        }
    }
    RSSExpandedReader.SYMBOL_WIDEST = [7, 5, 4, 3, 1];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [4, 20, 52, 104, 204];
    RSSExpandedReader.GSUM = [0, 348, 1388, 2948, 3988];
    RSSExpandedReader.FINDER_PATTERNS = [
        Int32Array.from([1, 8, 4, 1]),
        Int32Array.from([3, 6, 4, 1]),
        Int32Array.from([3, 4, 6, 1]),
        Int32Array.from([3, 2, 8, 1]),
        Int32Array.from([2, 6, 5, 1]),
        Int32Array.from([2, 2, 9, 1]) // F
    ];
    RSSExpandedReader.WEIGHTS = [
        [1, 3, 9, 27, 81, 32, 96, 77],
        [20, 60, 180, 118, 143, 7, 21, 63],
        [189, 145, 13, 39, 117, 140, 209, 205],
        [193, 157, 49, 147, 19, 57, 171, 91],
        [62, 186, 136, 197, 169, 85, 44, 132],
        [185, 133, 188, 142, 4, 12, 36, 108],
        [113, 128, 173, 97, 80, 29, 87, 50],
        [150, 28, 84, 41, 123, 158, 52, 156],
        [46, 138, 203, 187, 139, 206, 196, 166],
        [76, 17, 51, 153, 37, 111, 122, 155],
        [43, 129, 176, 106, 107, 110, 119, 146],
        [16, 48, 144, 10, 30, 90, 59, 177],
        [109, 116, 137, 200, 178, 112, 125, 164],
        [70, 210, 208, 202, 184, 130, 179, 115],
        [134, 191, 151, 31, 93, 68, 204, 190],
        [148, 22, 66, 198, 172, 94, 71, 2],
        [6, 18, 54, 162, 64, 192, 154, 40],
        [120, 149, 25, 75, 14, 42, 126, 167],
        [79, 26, 78, 23, 69, 207, 199, 175],
        [103, 98, 83, 38, 114, 131, 182, 124],
        [161, 61, 183, 127, 170, 88, 53, 159],
        [55, 165, 73, 8, 24, 72, 5, 15],
        [45, 135, 194, 160, 58, 174, 100, 89]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_C],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_F],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_F, RSSExpandedReader.FINDER_PAT_F],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_D],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_E],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_F, RSSExpandedReader.FINDER_PAT_F],
        [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_F, RSSExpandedReader.FINDER_PAT_F],
    ];
    RSSExpandedReader.MAX_PAIRS = 11;

    class Pair extends DataCharacter {
        constructor(value, checksumPortion, finderPattern) {
            super(value, checksumPortion);
            this.count = 0;
            this.finderPattern = finderPattern;
        }
        getFinderPattern() {
            return this.finderPattern;
        }
        getCount() {
            return this.count;
        }
        incrementCount() {
            this.count++;
        }
    }

    class RSS14Reader extends AbstractRSSReader {
        constructor() {
            super(...arguments);
            this.possibleLeftPairs = [];
            this.possibleRightPairs = [];
        }
        decodeRow(rowNumber, row, hints) {
            const leftPair = this.decodePair(row, false, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
            row.reverse();
            let rightPair = this.decodePair(row, true, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
            row.reverse();
            for (let left of this.possibleLeftPairs) {
                if (left.getCount() > 1) {
                    for (let right of this.possibleRightPairs) {
                        if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) {
                            return RSS14Reader.constructResult(left, right);
                        }
                    }
                }
            }
            throw new NotFoundException();
        }
        static addOrTally(possiblePairs, pair) {
            if (pair == null) {
                return;
            }
            let found = false;
            for (let other of possiblePairs) {
                if (other.getValue() === pair.getValue()) {
                    other.incrementCount();
                    found = true;
                    break;
                }
            }
            if (!found) {
                possiblePairs.push(pair);
            }
        }
        reset() {
            this.possibleLeftPairs.length = 0;
            this.possibleRightPairs.length = 0;
        }
        static constructResult(leftPair, rightPair) {
            let symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
            let text = new String(symbolValue).toString();
            let buffer = new StringBuilder();
            for (let i = 13 - text.length; i > 0; i--) {
                buffer.append('0');
            }
            buffer.append(text);
            let checkDigit = 0;
            for (let i = 0; i < 13; i++) {
                let digit = buffer.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += ((i & 0x01) === 0) ? 3 * digit : digit;
            }
            checkDigit = 10 - (checkDigit % 10);
            if (checkDigit === 10) {
                checkDigit = 0;
            }
            buffer.append(checkDigit.toString());
            let leftPoints = leftPair.getFinderPattern().getResultPoints();
            let rightPoints = rightPair.getFinderPattern().getResultPoints();
            return new Result(buffer.toString(), null, 0, [leftPoints[0], leftPoints[1], rightPoints[0], rightPoints[1]], BarcodeFormat$1.RSS_14, new Date().getTime());
        }
        static checkChecksum(leftPair, rightPair) {
            let checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
            let targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
            if (targetCheckValue > 72) {
                targetCheckValue--;
            }
            if (targetCheckValue > 8) {
                targetCheckValue--;
            }
            return checkValue === targetCheckValue;
        }
        decodePair(row, right, rowNumber, hints) {
            try {
                let startEnd = this.findFinderPattern(row, right);
                let pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
                let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (resultPointCallback != null) {
                    let center = (startEnd[0] + startEnd[1]) / 2.0;
                    if (right) {
                        // row is actually reversed
                        center = row.getSize() - 1 - center;
                    }
                    resultPointCallback.foundPossibleResultPoint(new ResultPoint(center, rowNumber));
                }
                let outside = this.decodeDataCharacter(row, pattern, true);
                let inside = this.decodeDataCharacter(row, pattern, false);
                return new Pair(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
            }
            catch (err) {
                return null;
            }
        }
        decodeDataCharacter(row, pattern, outsideChar) {
            let counters = this.getDataCharacterCounters();
            for (let x = 0; x < counters.length; x++) {
                counters[x] = 0;
            }
            if (outsideChar) {
                OneDReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            }
            else {
                OneDReader.recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
                // reverse it
                for (let i = 0, j = counters.length - 1; i < j; i++, j--) {
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            }
            let numModules = outsideChar ? 16 : 15;
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for (let i = 0; i < counters.length; i++) {
                let value = counters[i] / elementWidth;
                let count = Math.floor(value + 0.5);
                if (count < 1) {
                    count = 1;
                }
                else if (count > 8) {
                    count = 8;
                }
                let offset = Math.floor(i / 2);
                if ((i & 0x01) === 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                }
                else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(outsideChar, numModules);
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for (let i = oddCounts.length - 1; i >= 0; i--) {
                oddChecksumPortion *= 9;
                oddChecksumPortion += oddCounts[i];
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            let evenSum = 0;
            for (let i = evenCounts.length - 1; i >= 0; i--) {
                evenChecksumPortion *= 9;
                evenChecksumPortion += evenCounts[i];
                evenSum += evenCounts[i];
            }
            let checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
            if (outsideChar) {
                if ((oddSum & 0x01) !== 0 || oddSum > 12 || oddSum < 4) {
                    throw new NotFoundException();
                }
                let group = (12 - oddSum) / 2;
                let oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, false);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, true);
                let tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.OUTSIDE_GSUM[group];
                return new DataCharacter(vOdd * tEven + vEven + gSum, checksumPortion);
            }
            else {
                if ((evenSum & 0x01) !== 0 || evenSum > 10 || evenSum < 4) {
                    throw new NotFoundException();
                }
                let group = (10 - evenSum) / 2;
                let oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
                let tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.INSIDE_GSUM[group];
                return new DataCharacter(vEven * tOdd + vOdd + gSum, checksumPortion);
            }
        }
        findFinderPattern(row, rightFinderPattern) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let isWhite = false;
            let rowOffset = 0;
            while (rowOffset < width) {
                isWhite = !row.get(rowOffset);
                if (rightFinderPattern === isWhite) {
                    // Will encounter white first when searching for right finder pattern
                    break;
                }
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for (let x = rowOffset; x < width; x++) {
                if (row.get(x) !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition === 3) {
                        if (AbstractRSSReader.isFinderPattern(counters)) {
                            return [patternStart, x];
                        }
                        patternStart += counters[0] + counters[1];
                        counters[0] = counters[2];
                        counters[1] = counters[3];
                        counters[2] = 0;
                        counters[3] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            throw new NotFoundException();
        }
        parseFoundFinderPattern(row, rowNumber, right, startEnd) {
            // Actually we found elements 2-5
            let firstIsBlack = row.get(startEnd[0]);
            let firstElementStart = startEnd[0] - 1;
            // Locate element 1
            while (firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart)) {
                firstElementStart--;
            }
            firstElementStart++;
            const firstCounter = startEnd[0] - firstElementStart;
            // Make 'counters' hold 1-4
            const counters = this.getDecodeFinderCounters();
            const copy = new Int32Array(counters.length);
            System.arraycopy(counters, 0, copy, 1, counters.length - 1);
            copy[0] = firstCounter;
            const value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
            let start = firstElementStart;
            let end = startEnd[1];
            if (right) {
                // row is actually reversed
                start = row.getSize() - 1 - start;
                end = row.getSize() - 1 - end;
            }
            return new FinderPattern(value, [firstElementStart, startEnd[1]], start, end, rowNumber);
        }
        adjustOddEvenCounts(outsideChar, numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            let incrementEven = false;
            let decrementEven = false;
            if (outsideChar) {
                if (oddSum > 12) {
                    decrementOdd = true;
                }
                else if (oddSum < 4) {
                    incrementOdd = true;
                }
                if (evenSum > 12) {
                    decrementEven = true;
                }
                else if (evenSum < 4) {
                    incrementEven = true;
                }
            }
            else {
                if (oddSum > 11) {
                    decrementOdd = true;
                }
                else if (oddSum < 5) {
                    incrementOdd = true;
                }
                if (evenSum > 10) {
                    decrementEven = true;
                }
                else if (evenSum < 4) {
                    incrementEven = true;
                }
            }
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) === (outsideChar ? 1 : 0);
            let evenParityBad = (evenSum & 0x01) === 1;
            if (mismatch === 1) {
                if (oddParityBad) {
                    if (evenParityBad) {
                        throw new NotFoundException();
                    }
                    decrementOdd = true;
                }
                else {
                    if (!evenParityBad) {
                        throw new NotFoundException();
                    }
                    decrementEven = true;
                }
            }
            else if (mismatch === -1) {
                if (oddParityBad) {
                    if (evenParityBad) {
                        throw new NotFoundException();
                    }
                    incrementOdd = true;
                }
                else {
                    if (!evenParityBad) {
                        throw new NotFoundException();
                    }
                    incrementEven = true;
                }
            }
            else if (mismatch === 0) {
                if (oddParityBad) {
                    if (!evenParityBad) {
                        throw new NotFoundException();
                    }
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    }
                    else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                }
                else {
                    if (evenParityBad) {
                        throw new NotFoundException();
                    }
                    // Nothing to do!
                }
            }
            else {
                throw new NotFoundException();
            }
            if (incrementOdd) {
                if (decrementOdd) {
                    throw new NotFoundException();
                }
                AbstractRSSReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) {
                AbstractRSSReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (incrementEven) {
                if (decrementEven) {
                    throw new NotFoundException();
                }
                AbstractRSSReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) {
                AbstractRSSReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
            }
        }
    }
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [1, 10, 34, 70, 126];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [4, 20, 48, 81];
    RSS14Reader.OUTSIDE_GSUM = [0, 161, 961, 2015, 2715];
    RSS14Reader.INSIDE_GSUM = [0, 336, 1036, 1516];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [8, 6, 4, 3, 1];
    RSS14Reader.INSIDE_ODD_WIDEST = [2, 4, 6, 8];
    RSS14Reader.FINDER_PATTERNS = [
        Int32Array.from([3, 8, 2, 1]),
        Int32Array.from([3, 5, 5, 1]),
        Int32Array.from([3, 3, 7, 1]),
        Int32Array.from([3, 1, 9, 1]),
        Int32Array.from([2, 7, 4, 1]),
        Int32Array.from([2, 5, 6, 1]),
        Int32Array.from([2, 3, 8, 1]),
        Int32Array.from([1, 5, 7, 1]),
        Int32Array.from([1, 3, 9, 1]),
    ];

    /**
     * @author Daniel Switkin <dswitkin@google.com>
     * @author Sean Owen
     */
    class MultiFormatOneDReader extends OneDReader {
        constructor(hints, verbose) {
            super();
            this.readers = [];
            this.verbose = (verbose === true);
            const possibleFormats = !hints ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const useCode39CheckDigit = hints && hints.get(DecodeHintType$1.ASSUME_CODE_39_CHECK_DIGIT) !== undefined;
            if (possibleFormats) {
                if (possibleFormats.includes(BarcodeFormat$1.EAN_13) ||
                    possibleFormats.includes(BarcodeFormat$1.UPC_A) ||
                    possibleFormats.includes(BarcodeFormat$1.EAN_8) ||
                    possibleFormats.includes(BarcodeFormat$1.UPC_E)) {
                    this.readers.push(new MultiFormatUPCEANReader(hints));
                }
                if (possibleFormats.includes(BarcodeFormat$1.CODE_39)) {
                    this.readers.push(new Code39Reader(useCode39CheckDigit));
                }
                // if (possibleFormats.includes(BarcodeFormat.CODE_93)) {
                //    this.readers.push(new Code93Reader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.CODE_128)) {
                    this.readers.push(new Code128Reader());
                }
                if (possibleFormats.includes(BarcodeFormat$1.ITF)) {
                    this.readers.push(new ITFReader());
                }
                // if (possibleFormats.includes(BarcodeFormat.CODABAR)) {
                //    this.readers.push(new CodaBarReader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.RSS_14)) {
                    this.readers.push(new RSS14Reader());
                }
                if (possibleFormats.includes(BarcodeFormat$1.RSS_EXPANDED)) {
                    this.readers.push(new RSSExpandedReader(this.verbose));
                }
            } else {
                // Case when no hints were provided -> add all.
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code39Reader());
                // this.readers.push(new CodaBarReader());
                // this.readers.push(new Code93Reader());
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code128Reader());
                this.readers.push(new ITFReader());
                this.readers.push(new RSS14Reader());
                this.readers.push(new RSSExpandedReader(this.verbose));
            }
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            for (let i = 0; i < this.readers.length; i++) {
                try {
                    return this.readers[i].decodeRow(rowNumber, row, hints);
                }
                catch (re) {
                    // continue
                }
            }
            throw new NotFoundException();
        }
        // @Override
        reset() {
            this.readers.forEach(reader => reader.reset());
        }
    }

    /**
     * @deprecated Moving to @zxing/browser
     *
     * Barcode reader reader to use from browser.
     */
    class BrowserBarcodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserBarcodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         * @param {Map<DecodeHintType, any>} hints
         */
        constructor(timeBetweenScansMillis = 500, hints) {
            super(new MultiFormatOneDReader(hints), timeBetweenScansMillis, hints);
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */
    class ECBlocks {
        constructor(ecCodewords, ecBlocks1, ecBlocks2) {
            this.ecCodewords = ecCodewords;
            this.ecBlocks = [ecBlocks1];
            ecBlocks2 && this.ecBlocks.push(ecBlocks2);
        }
        getECCodewords() {
            return this.ecCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the Data Matrix code version's format.</p>
     */
    class ECB {
        constructor(count, dataCodewords) {
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /**
     * The Version object encapsulates attributes about a particular
     * size Data Matrix Code.
     *
     * @author bbrown@google.com (Brian Brown)
     */
    class Version {
        constructor(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks) {
            this.versionNumber = versionNumber;
            this.symbolSizeRows = symbolSizeRows;
            this.symbolSizeColumns = symbolSizeColumns;
            this.dataRegionSizeRows = dataRegionSizeRows;
            this.dataRegionSizeColumns = dataRegionSizeColumns;
            this.ecBlocks = ecBlocks;
            // Calculate the total number of codewords
            let total = 0;
            const ecCodewords = ecBlocks.getECCodewords();
            const ecbArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecbArray) {
                total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            }
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getSymbolSizeRows() {
            return this.symbolSizeRows;
        }
        getSymbolSizeColumns() {
            return this.symbolSizeColumns;
        }
        getDataRegionSizeRows() {
            return this.dataRegionSizeRows;
        }
        getDataRegionSizeColumns() {
            return this.dataRegionSizeColumns;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
        /**
         * <p>Deduces version information from Data Matrix dimensions.</p>
         *
         * @param numRows Number of rows in modules
         * @param numColumns Number of columns in modules
         * @return Version for a Data Matrix Code of those dimensions
         * @throws FormatException if dimensions do correspond to a valid Data Matrix size
         */
        static getVersionForDimensions(numRows, numColumns) {
            if ((numRows & 0x01) !== 0 || (numColumns & 0x01) !== 0) {
                throw new FormatException();
            }
            for (let version of Version.VERSIONS) {
                if (version.symbolSizeRows === numRows && version.symbolSizeColumns === numColumns) {
                    return version;
                }
            }
            throw new FormatException();
        }
        //  @Override
        toString() {
            return '' + this.versionNumber;
        }
        /**
         * See ISO 16022:2006 5.5.1 Table 7
         */
        static buildVersions() {
            return [
                new Version(1, 10, 10, 8, 8, new ECBlocks(5, new ECB(1, 3))),
                new Version(2, 12, 12, 10, 10, new ECBlocks(7, new ECB(1, 5))),
                new Version(3, 14, 14, 12, 12, new ECBlocks(10, new ECB(1, 8))),
                new Version(4, 16, 16, 14, 14, new ECBlocks(12, new ECB(1, 12))),
                new Version(5, 18, 18, 16, 16, new ECBlocks(14, new ECB(1, 18))),
                new Version(6, 20, 20, 18, 18, new ECBlocks(18, new ECB(1, 22))),
                new Version(7, 22, 22, 20, 20, new ECBlocks(20, new ECB(1, 30))),
                new Version(8, 24, 24, 22, 22, new ECBlocks(24, new ECB(1, 36))),
                new Version(9, 26, 26, 24, 24, new ECBlocks(28, new ECB(1, 44))),
                new Version(10, 32, 32, 14, 14, new ECBlocks(36, new ECB(1, 62))),
                new Version(11, 36, 36, 16, 16, new ECBlocks(42, new ECB(1, 86))),
                new Version(12, 40, 40, 18, 18, new ECBlocks(48, new ECB(1, 114))),
                new Version(13, 44, 44, 20, 20, new ECBlocks(56, new ECB(1, 144))),
                new Version(14, 48, 48, 22, 22, new ECBlocks(68, new ECB(1, 174))),
                new Version(15, 52, 52, 24, 24, new ECBlocks(42, new ECB(2, 102))),
                new Version(16, 64, 64, 14, 14, new ECBlocks(56, new ECB(2, 140))),
                new Version(17, 72, 72, 16, 16, new ECBlocks(36, new ECB(4, 92))),
                new Version(18, 80, 80, 18, 18, new ECBlocks(48, new ECB(4, 114))),
                new Version(19, 88, 88, 20, 20, new ECBlocks(56, new ECB(4, 144))),
                new Version(20, 96, 96, 22, 22, new ECBlocks(68, new ECB(4, 174))),
                new Version(21, 104, 104, 24, 24, new ECBlocks(56, new ECB(6, 136))),
                new Version(22, 120, 120, 18, 18, new ECBlocks(68, new ECB(6, 175))),
                new Version(23, 132, 132, 20, 20, new ECBlocks(62, new ECB(8, 163))),
                new Version(24, 144, 144, 22, 22, new ECBlocks(62, new ECB(8, 156), new ECB(2, 155))),
                new Version(25, 8, 18, 6, 16, new ECBlocks(7, new ECB(1, 5))),
                new Version(26, 8, 32, 6, 14, new ECBlocks(11, new ECB(1, 10))),
                new Version(27, 12, 26, 10, 24, new ECBlocks(14, new ECB(1, 16))),
                new Version(28, 12, 36, 10, 16, new ECBlocks(18, new ECB(1, 22))),
                new Version(29, 16, 36, 14, 16, new ECBlocks(24, new ECB(1, 32))),
                new Version(30, 16, 48, 14, 22, new ECBlocks(28, new ECB(1, 49)))
            ];
        }
    }
    Version.VERSIONS = Version.buildVersions();

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @author bbrown@google.com (Brian Brown)
     */
    class BitMatrixParser {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
         */
        constructor(bitMatrix) {
            const dimension = bitMatrix.getHeight();
            if (dimension < 8 || dimension > 144 || (dimension & 0x01) !== 0) {
                throw new FormatException();
            }
            this.version = BitMatrixParser.readVersion(bitMatrix);
            this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
            this.readMappingMatrix = new BitMatrix(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
        }
        getVersion() {
            return this.version;
        }
        /**
         * <p>Creates the version object based on the dimension of the original bit matrix from
         * the datamatrix code.</p>
         *
         * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
         *
         * @param bitMatrix Original {@link BitMatrix} including alignment patterns
         * @return {@link Version} encapsulating the Data Matrix Code's "version"
         * @throws FormatException if the dimensions of the mapping matrix are not valid
         * Data Matrix dimensions.
         */
        static readVersion(bitMatrix) {
            const numRows = bitMatrix.getHeight();
            const numColumns = bitMatrix.getWidth();
            return Version.getVersionForDimensions(numRows, numColumns);
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
         * in the correct order in order to reconstitute the codewords bytes contained within the
         * Data Matrix Code.</p>
         *
         * @return bytes encoded within the Data Matrix Code
         * @throws FormatException if the exact number of bytes expected is not read
         */
        readCodewords() {
            const result = new Int8Array(this.version.getTotalCodewords());
            let resultOffset = 0;
            let row = 4;
            let column = 0;
            const numRows = this.mappingBitMatrix.getHeight();
            const numColumns = this.mappingBitMatrix.getWidth();
            let corner1Read = false;
            let corner2Read = false;
            let corner3Read = false;
            let corner4Read = false;
            // Read all of the codewords
            do {
                // Check the four corner cases
                if ((row === numRows) && (column === 0) && !corner1Read) {
                    result[resultOffset++] = this.readCorner1(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner1Read = true;
                }
                else if ((row === numRows - 2) && (column === 0) && ((numColumns & 0x03) !== 0) && !corner2Read) {
                    result[resultOffset++] = this.readCorner2(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner2Read = true;
                }
                else if ((row === numRows + 4) && (column === 2) && ((numColumns & 0x07) === 0) && !corner3Read) {
                    result[resultOffset++] = this.readCorner3(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner3Read = true;
                }
                else if ((row === numRows - 2) && (column === 0) && ((numColumns & 0x07) === 4) && !corner4Read) {
                    result[resultOffset++] = this.readCorner4(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner4Read = true;
                }
                else {
                    // Sweep upward diagonally to the right
                    do {
                        if ((row < numRows) && (column >= 0) && !this.readMappingMatrix.get(column, row)) {
                            result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        }
                        row -= 2;
                        column += 2;
                    } while ((row >= 0) && (column < numColumns));
                    row += 1;
                    column += 3;
                    // Sweep downward diagonally to the left
                    do {
                        if ((row >= 0) && (column < numColumns) && !this.readMappingMatrix.get(column, row)) {
                            result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        }
                        row += 2;
                        column -= 2;
                    } while ((row < numRows) && (column >= 0));
                    row += 3;
                    column += 1;
                }
            } while ((row < numRows) || (column < numColumns));
            if (resultOffset !== this.version.getTotalCodewords()) {
                throw new FormatException();
            }
            return result;
        }
        /**
         * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
         *
         * @param row Row to read in the mapping matrix
         * @param column Column to read in the mapping matrix
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return value of the given bit in the mapping matrix
         */
        readModule(row, column, numRows, numColumns) {
            // Adjust the row and column indices based on boundary wrapping
            if (row < 0) {
                row += numRows;
                column += 4 - ((numRows + 4) & 0x07);
            }
            if (column < 0) {
                column += numColumns;
                row += 4 - ((numColumns + 4) & 0x07);
            }
            this.readMappingMatrix.set(column, row);
            return this.mappingBitMatrix.get(column, row);
        }
        /**
         * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
         *
         * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
         *
         * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the utah shape
         */
        readUtah(row, column, numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(row - 2, column - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row - 2, column - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row - 1, column, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row, column - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row, column - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(row, column, numRows, numColumns)) {
                currentByte |= 1;
            }
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 1.</p>
         *
         * <p>See ISO 16022:2006, Figure F.3</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 1
         */
        readCorner1(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 2.</p>
         *
         * <p>See ISO 16022:2006, Figure F.4</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 2
         */
        readCorner2(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 4, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 3.</p>
         *
         * <p>See ISO 16022:2006, Figure F.5</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 3
         */
        readCorner3(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 3, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 4.</p>
         *
         * <p>See ISO 16022:2006, Figure F.6</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 4
         */
        readCorner4(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) {
                currentByte |= 1;
            }
            return currentByte;
        }
        /**
         * <p>Extracts the data region from a {@link BitMatrix} that contains
         * alignment patterns.</p>
         *
         * @param bitMatrix Original {@link BitMatrix} with alignment patterns
         * @return BitMatrix that has the alignment patterns removed
         */
        extractDataRegion(bitMatrix) {
            const symbolSizeRows = this.version.getSymbolSizeRows();
            const symbolSizeColumns = this.version.getSymbolSizeColumns();
            if (bitMatrix.getHeight() !== symbolSizeRows) {
                throw new IllegalArgumentException('Dimension of bitMatrix must match the version size');
            }
            const dataRegionSizeRows = this.version.getDataRegionSizeRows();
            const dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
            const numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
            const numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
            const sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
            const sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
            const bitMatrixWithoutAlignment = new BitMatrix(sizeDataRegionColumn, sizeDataRegionRow);
            for (let dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow) {
                const dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
                for (let dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn) {
                    const dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
                    for (let i = 0; i < dataRegionSizeRows; ++i) {
                        const readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i;
                        const writeRowOffset = dataRegionRowOffset + i;
                        for (let j = 0; j < dataRegionSizeColumns; ++j) {
                            const readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                            if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                                const writeColumnOffset = dataRegionColumnOffset + j;
                                bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                            }
                        }
                    }
                }
            }
            return bitMatrixWithoutAlignment;
        }
    }

    /**
     * <p>Encapsulates a block of data within a Data Matrix Code. Data Matrix Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */
    class DataBlock {
        constructor(numDataCodewords, codewords) {
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the Data Matrix Code
         * @param version version of the Data Matrix Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         Data Matrix Code
         */
        static getDataBlocks(rawCodewords, version) {
            // Figure out the number and size of data blocks used by this version
            const ecBlocks = version.getECBlocks();
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecBlockArray) {
                totalBlocks += ecBlock.getCount();
            }
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (let ecBlock of ecBlockArray) {
                for (let i = 0; i < ecBlock.getCount(); i++) {
                    const numDataCodewords = ecBlock.getDataCodewords();
                    const numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
                    result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
                }
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 less byte. Figure out where these start.
            // TODO(bbrown): There is only one case where there is a difference for Data Matrix for size 144
            const longerBlocksTotalCodewords = result[0].codewords.length;
            // int shorterBlocksTotalCodewords = longerBlocksTotalCodewords - 1;
            const longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
            const shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
            // The last elements of result may be 1 element shorter for 144 matrix
            // first fill out as many elements as all of them have minus 1
            let rawCodewordsOffset = 0;
            for (let i = 0; i < shorterBlocksNumDataCodewords; i++) {
                for (let j = 0; j < numResultBlocks; j++) {
                    result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
                }
            }
            // Fill out the last data block in the longer ones
            const specialVersion = version.getVersionNumber() === 24;
            const numLongerBlocks = specialVersion ? 8 : numResultBlocks;
            for (let j = 0; j < numLongerBlocks; j++) {
                result[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
            }
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for (let i = longerBlocksNumDataCodewords; i < max; i++) {
                for (let j = 0; j < numResultBlocks; j++) {
                    const jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
                    const iOffset = specialVersion && jOffset > 7 ? i - 1 : i;
                    result[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
                }
            }
            if (rawCodewordsOffset !== rawCodewords.length) {
                throw new IllegalArgumentException();
            }
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>This provides an easy abstraction to read bits at a time from a sequence of bytes, where the
     * number of bits read is not often a multiple of 8.</p>
     *
     * <p>This class is thread-safe but not reentrant -- unless the caller modifies the bytes array
     * it passed in, in which case all bets are off.</p>
     *
     * @author Sean Owen
     */
    class BitSource {
        /**
         * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
         * Bits are read within a byte from most-significant to least-significant bit.
         */
        constructor(bytes) {
            this.bytes = bytes;
            this.byteOffset = 0;
            this.bitOffset = 0;
        }
        /**
         * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
         */
        getBitOffset() {
            return this.bitOffset;
        }
        /**
         * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
         */
        getByteOffset() {
            return this.byteOffset;
        }
        /**
         * @param numBits number of bits to read
         * @return int representing the bits read. The bits will appear as the least-significant
         *         bits of the int
         * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
         */
        readBits(numBits /*int*/) {
            if (numBits < 1 || numBits > 32 || numBits > this.available()) {
                throw new IllegalArgumentException('' + numBits);
            }
            let result = 0;
            let bitOffset = this.bitOffset;
            let byteOffset = this.byteOffset;
            const bytes = this.bytes;
            // First, read remainder from current byte
            if (bitOffset > 0) {
                const bitsLeft = 8 - bitOffset;
                const toRead = numBits < bitsLeft ? numBits : bitsLeft;
                const bitsToNotRead = bitsLeft - toRead;
                const mask = (0xFF >> (8 - toRead)) << bitsToNotRead;
                result = (bytes[byteOffset] & mask) >> bitsToNotRead;
                numBits -= toRead;
                bitOffset += toRead;
                if (bitOffset === 8) {
                    bitOffset = 0;
                    byteOffset++;
                }
            }
            // Next read whole bytes
            if (numBits > 0) {
                while (numBits >= 8) {
                    result = (result << 8) | (bytes[byteOffset] & 0xFF);
                    byteOffset++;
                    numBits -= 8;
                }
                // Finally read a partial byte
                if (numBits > 0) {
                    const bitsToNotRead = 8 - numBits;
                    const mask = (0xFF >> bitsToNotRead) << bitsToNotRead;
                    result = (result << numBits) | ((bytes[byteOffset] & mask) >> bitsToNotRead);
                    bitOffset += numBits;
                }
            }
            this.bitOffset = bitOffset;
            this.byteOffset = byteOffset;
            return result;
        }
        /**
         * @return number of bits that can be read successfully
         */
        available() {
            return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
        }
    }

    var Mode;
    (function (Mode) {
        Mode[Mode["PAD_ENCODE"] = 0] = "PAD_ENCODE";
        Mode[Mode["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
        Mode[Mode["C40_ENCODE"] = 2] = "C40_ENCODE";
        Mode[Mode["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
        Mode[Mode["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
        Mode[Mode["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
        Mode[Mode["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
    })(Mode || (Mode = {}));
    /**
     * <p>Data Matrix Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one Data Matrix Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 16022:2006, 5.2.1 - 5.2.9.2</p>
     *
     * @author bbrown@google.com (Brian Brown)
     * @author Sean Owen
     */
    class DecodedBitStreamParser {
        static decode(bytes) {
            const bits = new BitSource(bytes);
            const result = new StringBuilder();
            const resultTrailer = new StringBuilder();
            const byteSegments = new Array();
            let mode = Mode.ASCII_ENCODE;
            do {
                if (mode === Mode.ASCII_ENCODE) {
                    mode = this.decodeAsciiSegment(bits, result, resultTrailer);
                }
                else {
                    switch (mode) {
                        case Mode.C40_ENCODE:
                            this.decodeC40Segment(bits, result);
                            break;
                        case Mode.TEXT_ENCODE:
                            this.decodeTextSegment(bits, result);
                            break;
                        case Mode.ANSIX12_ENCODE:
                            this.decodeAnsiX12Segment(bits, result);
                            break;
                        case Mode.EDIFACT_ENCODE:
                            this.decodeEdifactSegment(bits, result);
                            break;
                        case Mode.BASE256_ENCODE:
                            this.decodeBase256Segment(bits, result, byteSegments);
                            break;
                        default:
                            throw new FormatException();
                    }
                    mode = Mode.ASCII_ENCODE;
                }
            } while (mode !== Mode.PAD_ENCODE && bits.available() > 0);
            if (resultTrailer.length() > 0) {
                result.append(resultTrailer.toString());
            }
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, null);
        }
        /**
         * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
         */
        static decodeAsciiSegment(bits, result, resultTrailer) {
            let upperShift = false;
            do {
                let oneByte = bits.readBits(8);
                if (oneByte === 0) {
                    throw new FormatException();
                }
                else if (oneByte <= 128) { // ASCII data (ASCII value + 1)
                    if (upperShift) {
                        oneByte += 128;
                        // upperShift = false;
                    }
                    result.append(String.fromCharCode(oneByte - 1));
                    return Mode.ASCII_ENCODE;
                }
                else if (oneByte === 129) { // Pad
                    return Mode.PAD_ENCODE;
                }
                else if (oneByte <= 229) { // 2-digit data 00-99 (Numeric Value + 130)
                    const value = oneByte - 130;
                    if (value < 10) { // pad with '0' for single digit values
                        result.append('0');
                    }
                    result.append('' + value);
                }
                else {
                    switch (oneByte) {
                        case 230: // Latch to C40 encodation
                            return Mode.C40_ENCODE;
                        case 231: // Latch to Base 256 encodation
                            return Mode.BASE256_ENCODE;
                        case 232: // FNC1
                            result.append(String.fromCharCode(29)); // translate as ASCII 29
                            break;
                        case 233: // Structured Append
                        case 234: // Reader Programming
                            // Ignore these symbols for now
                            // throw ReaderException.getInstance();
                            break;
                        case 235: // Upper Shift (shift to Extended ASCII)
                            upperShift = true;
                            break;
                        case 236: // 05 Macro
                            result.append('[)>\u001E05\u001D');
                            resultTrailer.insert(0, '\u001E\u0004');
                            break;
                        case 237: // 06 Macro
                            result.append('[)>\u001E06\u001D');
                            resultTrailer.insert(0, '\u001E\u0004');
                            break;
                        case 238: // Latch to ANSI X12 encodation
                            return Mode.ANSIX12_ENCODE;
                        case 239: // Latch to Text encodation
                            return Mode.TEXT_ENCODE;
                        case 240: // Latch to EDIFACT encodation
                            return Mode.EDIFACT_ENCODE;
                        case 241: // ECI Character
                            // TODO(bbrown): I think we need to support ECI
                            // throw ReaderException.getInstance();
                            // Ignore this symbol for now
                            break;
                        default:
                            // Not to be used in ASCII encodation
                            // but work around encoders that end with 254, latch back to ASCII
                            if (oneByte !== 254 || bits.available() !== 0) {
                                throw new FormatException();
                            }
                            break;
                    }
                }
            } while (bits.available() > 0);
            return Mode.ASCII_ENCODE;
        }
        /**
         * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
         */
        static decodeC40Segment(bits, result) {
            // Three C40 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with C40 doesn't work in the 4 value scenario all the time
            let upperShift = false;
            const cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) {
                    return;
                }
                const firstByte = bits.readBits(8);
                if (firstByte === 254) { // Unlatch codeword
                    return;
                }
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for (let i = 0; i < 3; i++) {
                    const cValue = cValues[i];
                    switch (shift) {
                        case 0:
                            if (cValue < 3) {
                                shift = cValue + 1;
                            }
                            else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                                const c40char = this.C40_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                }
                                else {
                                    result.append(c40char);
                                }
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            }
                            else {
                                result.append(String.fromCharCode(cValue));
                            }
                            shift = 0;
                            break;
                        case 2:
                            if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                                const c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                }
                                else {
                                    result.append(c40char);
                                }
                            }
                            else {
                                switch (cValue) {
                                    case 27: // FNC1
                                        result.append(String.fromCharCode(29)); // translate as ASCII 29
                                        break;
                                    case 30: // Upper Shift
                                        upperShift = true;
                                        break;
                                    default:
                                        throw new FormatException();
                                }
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 224));
                                upperShift = false;
                            }
                            else {
                                result.append(String.fromCharCode(cValue + 96));
                            }
                            shift = 0;
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            } while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
         */
        static decodeTextSegment(bits, result) {
            // Three Text values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with Text doesn't work in the 4 value scenario all the time
            let upperShift = false;
            let cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) {
                    return;
                }
                const firstByte = bits.readBits(8);
                if (firstByte === 254) { // Unlatch codeword
                    return;
                }
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for (let i = 0; i < 3; i++) {
                    const cValue = cValues[i];
                    switch (shift) {
                        case 0:
                            if (cValue < 3) {
                                shift = cValue + 1;
                            }
                            else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                                const textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                }
                                else {
                                    result.append(textChar);
                                }
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            }
                            else {
                                result.append(String.fromCharCode(cValue));
                            }
                            shift = 0;
                            break;
                        case 2:
                            // Shift 2 for Text is the same encoding as C40
                            if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                }
                                else {
                                    result.append(textChar);
                                }
                            }
                            else {
                                switch (cValue) {
                                    case 27: // FNC1
                                        result.append(String.fromCharCode(29)); // translate as ASCII 29
                                        break;
                                    case 30: // Upper Shift
                                        upperShift = true;
                                        break;
                                    default:
                                        throw new FormatException();
                                }
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                }
                                else {
                                    result.append(textChar);
                                }
                                shift = 0;
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            } while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.7
         */
        static decodeAnsiX12Segment(bits, result) {
            // Three ANSI X12 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            const cValues = [];
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) {
                    return;
                }
                const firstByte = bits.readBits(8);
                if (firstByte === 254) { // Unlatch codeword
                    return;
                }
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for (let i = 0; i < 3; i++) {
                    const cValue = cValues[i];
                    switch (cValue) {
                        case 0: // X12 segment terminator <CR>
                            result.append('\r');
                            break;
                        case 1: // X12 segment separator *
                            result.append('*');
                            break;
                        case 2: // X12 sub-element separator >
                            result.append('>');
                            break;
                        case 3: // space
                            result.append(' ');
                            break;
                        default:
                            if (cValue < 14) { // 0 - 9
                                result.append(String.fromCharCode(cValue + 44));
                            }
                            else if (cValue < 40) { // A - Z
                                result.append(String.fromCharCode(cValue + 51));
                            }
                            else {
                                throw new FormatException();
                            }
                            break;
                    }
                }
            } while (bits.available() > 0);
        }
        static parseTwoBytes(firstByte, secondByte, result) {
            let fullBitValue = (firstByte << 8) + secondByte - 1;
            let temp = Math.floor(fullBitValue / 1600);
            result[0] = temp;
            fullBitValue -= temp * 1600;
            temp = Math.floor(fullBitValue / 40);
            result[1] = temp;
            result[2] = fullBitValue - temp * 40;
        }
        /**
         * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
         */
        static decodeEdifactSegment(bits, result) {
            do {
                // If there is only two or less bytes left then it will be encoded as ASCII
                if (bits.available() <= 16) {
                    return;
                }
                for (let i = 0; i < 4; i++) {
                    let edifactValue = bits.readBits(6);
                    // Check for the unlatch character
                    if (edifactValue === 0x1F) { // 011111
                        // Read rest of byte, which should be 0, and stop
                        const bitsLeft = 8 - bits.getBitOffset();
                        if (bitsLeft !== 8) {
                            bits.readBits(bitsLeft);
                        }
                        return;
                    }
                    if ((edifactValue & 0x20) === 0) { // no 1 in the leading (6th) bit
                        edifactValue |= 0x40; // Add a leading 01 to the 6 bit binary value
                    }
                    result.append(String.fromCharCode(edifactValue));
                }
            } while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.9 and Annex B, B.2
         */
        static decodeBase256Segment(bits, result, byteSegments) {
            // Figure out how long the Base 256 Segment is.
            let codewordPosition = 1 + bits.getByteOffset(); // position is 1-indexed
            const d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            let count;
            if (d1 === 0) { // Read the remainder of the symbol
                count = bits.available() / 8 | 0;
            }
            else if (d1 < 250) {
                count = d1;
            }
            else {
                count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
            }
            // We're seeing NegativeArraySizeException errors from users.
            if (count < 0) {
                throw new FormatException();
            }
            const bytes = new Uint8Array(count);
            for (let i = 0; i < count; i++) {
                // Have seen this particular error in the wild, such as at
                // http://www.bcgen.com/demo/IDAutomationStreamingDataMatrix.aspx?MODE=3&D=Fred&PFMT=3&PT=F&X=0.3&O=0&LM=0.2
                if (bits.available() < 8) {
                    throw new FormatException();
                }
                bytes[i] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            }
            byteSegments.push(bytes);
            try {
                result.append(StringEncoding.decode(bytes, StringUtils.ISO88591));
            }
            catch (uee) {
                throw new IllegalStateException('Platform does not support required encoding: ' + uee.message);
            }
        }
        /**
         * See ISO 16022:2006, Annex B, B.2
         */
        static unrandomize255State(randomizedBase256Codeword, base256CodewordPosition) {
            const pseudoRandomNumber = ((149 * base256CodewordPosition) % 255) + 1;
            const tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
            return tempVariable >= 0 ? tempVariable : tempVariable + 256;
        }
    }
    /**
     * See ISO 16022:2006, Annex C Table C.1
     * The C40 Basic Character Set (*'s used for placeholders for the shift values)
     */
    DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
        '*', '*', '*', ' ', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
        '!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.',
        '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_'
    ];
    /**
     * See ISO 16022:2006, Annex C Table C.2
     * The Text Basic Character Set (*'s used for placeholders for the shift values)
     */
    DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
        '*', '*', '*', ' ', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
        'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
    ];
    // Shift 2 for Text is the same encoding as C40
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
        '`', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '{', '|', '}', '~', String.fromCharCode(127)
    ];

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>The main class which implements Data Matrix Code decoding -- as opposed to locating and extracting
     * the Data Matrix Code from an image.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */
    class Decoder$1 {
        constructor() {
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.DATA_MATRIX_FIELD_256);
        }
        /**
         * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
         * to mean a black module.</p>
         *
         * @param bits booleans representing white/black Data Matrix Code modules
         * @return text and bytes encoded within the Data Matrix Code
         * @throws FormatException if the Data Matrix Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */
        decode(bits) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser(bits);
            const version = parser.getVersion();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock.getDataBlocks(codewords, version);
            // Count total number of data bytes
            let totalBytes = 0;
            for (let db of dataBlocks) {
                totalBytes += db.getNumDataCodewords();
            }
            const resultBytes = new Uint8Array(totalBytes);
            const dataBlocksCount = dataBlocks.length;
            // Error-correct and copy data blocks together into a stream of bytes
            for (let j = 0; j < dataBlocksCount; j++) {
                const dataBlock = dataBlocks[j];
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for (let i = 0; i < numDataCodewords; i++) {
                    // De-interlace data blocks.
                    resultBytes[i * dataBlocksCount + j] = codewordBytes[i];
                }
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser.decode(resultBytes);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */
        correctErrors(codewordBytes, numDataCodewords) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF;
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            }
            catch (ignored /* ReedSolomonException */) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for (let i = 0; i < numDataCodewords; i++) {
                codewordBytes[i] = codewordsInts[i];
            }
        }
    }

    /**
     * <p>Encapsulates logic that can detect a Data Matrix Code in an image, even if the Data Matrix Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */
    class Detector$1 {
        constructor(image) {
            this.image = image;
            this.rectangleDetector = new WhiteRectangleDetector(this.image);
        }
        /**
         * <p>Detects a Data Matrix Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
         * @throws NotFoundException if no Data Matrix Code can be found
         */
        detect() {
            const cornerPoints = this.rectangleDetector.detect();
            let points = this.detectSolid1(cornerPoints);
            points = this.detectSolid2(points);
            points[3] = this.correctTopRight(points);
            if (!points[3]) {
                throw new NotFoundException();
            }
            points = this.shiftToModuleCenter(points);
            const topLeft = points[0];
            const bottomLeft = points[1];
            const bottomRight = points[2];
            const topRight = points[3];
            let dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
            let dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
            if ((dimensionTop & 0x01) === 1) {
                dimensionTop += 1;
            }
            if ((dimensionRight & 0x01) === 1) {
                dimensionRight += 1;
            }
            if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) {
                // The matrix is square
                dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
            }
            let bits = Detector$1.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
            return new DetectorResult(bits, [topLeft, bottomLeft, bottomRight, topRight]);
        }
        static shiftPoint(point, to, div) {
            let x = (to.getX() - point.getX()) / (div + 1);
            let y = (to.getY() - point.getY()) / (div + 1);
            return new ResultPoint(point.getX() + x, point.getY() + y);
        }
        static moveAway(point, fromX, fromY) {
            let x = point.getX();
            let y = point.getY();
            if (x < fromX) {
                x -= 1;
            }
            else {
                x += 1;
            }
            if (y < fromY) {
                y -= 1;
            }
            else {
                y += 1;
            }
            return new ResultPoint(x, y);
        }
        /**
         * Detect a solid side which has minimum transition.
         */
        detectSolid1(cornerPoints) {
            // 0  2
            // 1  3
            let pointA = cornerPoints[0];
            let pointB = cornerPoints[1];
            let pointC = cornerPoints[3];
            let pointD = cornerPoints[2];
            let trAB = this.transitionsBetween(pointA, pointB);
            let trBC = this.transitionsBetween(pointB, pointC);
            let trCD = this.transitionsBetween(pointC, pointD);
            let trDA = this.transitionsBetween(pointD, pointA);
            // 0..3
            // :  :
            // 1--2
            let min = trAB;
            let points = [pointD, pointA, pointB, pointC];
            if (min > trBC) {
                min = trBC;
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            }
            if (min > trCD) {
                min = trCD;
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            if (min > trDA) {
                points[0] = pointC;
                points[1] = pointD;
                points[2] = pointA;
                points[3] = pointB;
            }
            return points;
        }
        /**
         * Detect a second solid side next to first solid side.
         */
        detectSolid2(points) {
            // A..D
            // :  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // Transition detection on the edge is not stable.
            // To safely detect, shift the points to the module center.
            let tr = this.transitionsBetween(pointA, pointD);
            let pointBs = Detector$1.shiftPoint(pointB, pointC, (tr + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (tr + 1) * 4);
            let trBA = this.transitionsBetween(pointBs, pointA);
            let trCD = this.transitionsBetween(pointCs, pointD);
            // 0..3
            // |  :
            // 1--2
            if (trBA < trCD) {
                // solid sides: A-B-C
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            }
            else {
                // solid sides: B-C-D
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            return points;
        }
        /**
         * Calculates the corner position of the white top right module.
         */
        correctTopRight(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // shift points for safe transition detection.
            let trTop = this.transitionsBetween(pointA, pointD);
            let trRight = this.transitionsBetween(pointB, pointD);
            let pointAs = Detector$1.shiftPoint(pointA, pointB, (trRight + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (trTop + 1) * 4);
            trTop = this.transitionsBetween(pointAs, pointD);
            trRight = this.transitionsBetween(pointCs, pointD);
            let candidate1 = new ResultPoint(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
            let candidate2 = new ResultPoint(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
            if (!this.isValid(candidate1)) {
                if (this.isValid(candidate2)) {
                    return candidate2;
                }
                return null;
            }
            if (!this.isValid(candidate2)) {
                return candidate1;
            }
            let sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
            let sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
            if (sumc1 > sumc2) {
                return candidate1;
            }
            else {
                return candidate2;
            }
        }
        /**
         * Shift the edge points to the module center.
         */
        shiftToModuleCenter(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // calculate pseudo dimensions
            let dimH = this.transitionsBetween(pointA, pointD) + 1;
            let dimV = this.transitionsBetween(pointC, pointD) + 1;
            // shift points for safe dimension detection
            let pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, dimH * 4);
            //  calculate more precise dimensions
            dimH = this.transitionsBetween(pointAs, pointD) + 1;
            dimV = this.transitionsBetween(pointCs, pointD) + 1;
            if ((dimH & 0x01) === 1) {
                dimH += 1;
            }
            if ((dimV & 0x01) === 1) {
                dimV += 1;
            }
            // WhiteRectangleDetector returns points inside of the rectangle.
            // I want points on the edges.
            let centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
            let centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
            pointA = Detector$1.moveAway(pointA, centerX, centerY);
            pointB = Detector$1.moveAway(pointB, centerX, centerY);
            pointC = Detector$1.moveAway(pointC, centerX, centerY);
            pointD = Detector$1.moveAway(pointD, centerX, centerY);
            let pointBs;
            let pointDs;
            // shift points to the center of each modules
            pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            pointAs = Detector$1.shiftPoint(pointAs, pointD, dimH * 4);
            pointBs = Detector$1.shiftPoint(pointB, pointA, dimV * 4);
            pointBs = Detector$1.shiftPoint(pointBs, pointC, dimH * 4);
            pointCs = Detector$1.shiftPoint(pointC, pointD, dimV * 4);
            pointCs = Detector$1.shiftPoint(pointCs, pointB, dimH * 4);
            pointDs = Detector$1.shiftPoint(pointD, pointC, dimV * 4);
            pointDs = Detector$1.shiftPoint(pointDs, pointA, dimH * 4);
            return [pointAs, pointBs, pointCs, pointDs];
        }
        isValid(p) {
            return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
        }
        static sampleGrid(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
         */
        transitionsBetween(from, to) {
            // See QR Code Detector, sizeOfBlackWhiteBlackRun()
            let fromX = Math.trunc(from.getX());
            let fromY = Math.trunc(from.getY());
            let toX = Math.trunc(to.getX());
            let toY = Math.trunc(to.getY());
            let steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            let dx = Math.abs(toX - fromX);
            let dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            let ystep = fromY < toY ? 1 : -1;
            let xstep = fromX < toX ? 1 : -1;
            let transitions = 0;
            let inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
            for (let x = fromX, y = fromY; x !== toX; x += xstep) {
                let isBlack = this.image.get(steep ? y : x, steep ? x : y);
                if (isBlack !== inBlack) {
                    transitions++;
                    inBlack = isBlack;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) {
                        break;
                    }
                    y += ystep;
                    error -= dx;
                }
            }
            return transitions;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This implementation can detect and decode Data Matrix codes in an image.
     *
     * @author bbrown@google.com (Brian Brown)
     */
    class DataMatrixReader {
        constructor() {
            this.decoder = new Decoder$1();
        }
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         * @throws ChecksumException if error correction fails
         */
        // @Override
        // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
        //   return decode(image, null);
        // }
        // @Override
        decode(image, hints = null) {
            let decoderResult;
            let points;
            if (hints != null && hints.has(DecodeHintType$1.PURE_BARCODE)) {
                const bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decode(bits);
                points = DataMatrixReader.NO_POINTS;
            }
            else {
                const detectorResult = new Detector$1(image.getBlackMatrix()).detect();
                decoderResult = this.decoder.decode(detectorResult.getBits());
                points = detectorResult.getPoints();
            }
            const rawBytes = decoderResult.getRawBytes();
            const result = new Result(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, BarcodeFormat$1.DATA_MATRIX, System.currentTimeMillis());
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) {
                result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            }
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) {
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            }
            return result;
        }
        // @Override
        reset() {
            // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
         */
        static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack == null || rightBottomBlack == null) {
                throw new NotFoundException();
            }
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            const bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            const right = rightBottomBlack[0];
            const matrixWidth = (right - left + 1) / moduleSize;
            const matrixHeight = (bottom - top + 1) / moduleSize;
            if (matrixWidth <= 0 || matrixHeight <= 0) {
                throw new NotFoundException();
            }
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = moduleSize / 2;
            top += nudge;
            left += nudge;
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for (let y = 0; y < matrixHeight; y++) {
                const iOffset = top + y * moduleSize;
                for (let x = 0; x < matrixWidth; x++) {
                    if (image.get(left + x * moduleSize, iOffset)) {
                        bits.set(x, y);
                    }
                }
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const width = image.getWidth();
            let x = leftTopBlack[0];
            const y = leftTopBlack[1];
            while (x < width && image.get(x, y)) {
                x++;
            }
            if (x === width) {
                throw new NotFoundException();
            }
            const moduleSize = x - leftTopBlack[0];
            if (moduleSize === 0) {
                throw new NotFoundException();
            }
            return moduleSize;
        }
    }
    DataMatrixReader.NO_POINTS = [];

    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */
    class BrowserDatamatrixCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */
        constructor(timeBetweenScansMillis = 500) {
            super(new DataMatrixReader(), timeBetweenScansMillis);
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    var ErrorCorrectionLevelValues;
    (function (ErrorCorrectionLevelValues) {
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["L"] = 0] = "L";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["M"] = 1] = "M";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["Q"] = 2] = "Q";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["H"] = 3] = "H";
    })(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.5.1. This enum encapsulates the four error correction levels
     * defined by the QR code standard.</p>
     *
     * @author Sean Owen
     */
    class ErrorCorrectionLevel {
        constructor(value, stringValue, bits /*int*/) {
            this.value = value;
            this.stringValue = stringValue;
            this.bits = bits;
            ErrorCorrectionLevel.FOR_BITS.set(bits, this);
            ErrorCorrectionLevel.FOR_VALUE.set(value, this);
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        static fromString(s) {
            switch (s) {
                case 'L': return ErrorCorrectionLevel.L;
                case 'M': return ErrorCorrectionLevel.M;
                case 'Q': return ErrorCorrectionLevel.Q;
                case 'H': return ErrorCorrectionLevel.H;
                default: throw new ArgumentException(s + 'not available');
            }
        }
        toString() {
            return this.stringValue;
        }
        equals(o) {
            if (!(o instanceof ErrorCorrectionLevel)) {
                return false;
            }
            const other = o;
            return this.value === other.value;
        }
        /**
         * @param bits int containing the two bits encoding a QR Code's error correction level
         * @return ErrorCorrectionLevel representing the encoded error correction level
         */
        static forBits(bits /*int*/) {
            if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) {
                throw new IllegalArgumentException();
            }
            return ErrorCorrectionLevel.FOR_BITS.get(bits);
        }
    }
    ErrorCorrectionLevel.FOR_BITS = new Map();
    ErrorCorrectionLevel.FOR_VALUE = new Map();
    /** L = ~7% correction */
    ErrorCorrectionLevel.L = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.L, 'L', 0x01);
    /** M = ~15% correction */
    ErrorCorrectionLevel.M = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.M, 'M', 0x00);
    /** Q = ~25% correction */
    ErrorCorrectionLevel.Q = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.Q, 'Q', 0x03);
    /** H = ~30% correction */
    ErrorCorrectionLevel.H = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.H, 'H', 0x02);

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates a QR Code's format information, including the data mask used and
     * error correction level.</p>
     *
     * @author Sean Owen
     * @see DataMask
     * @see ErrorCorrectionLevel
     */
    class FormatInformation {
        constructor(formatInfo /*int*/) {
            // Bits 3,4
            this.errorCorrectionLevel = ErrorCorrectionLevel.forBits((formatInfo >> 3) & 0x03);
            // Bottom 3 bits
            this.dataMask = /*(byte) */ (formatInfo & 0x07);
        }
        static numBitsDiffering(a /*int*/, b /*int*/) {
            return Integer.bitCount(a ^ b);
        }
        /**
         * @param maskedFormatInfo1 format info indicator, with mask still applied
         * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
         *  to establish best match
         * @return information about the format it specifies, or {@code null}
         *  if doesn't seem to match any known pattern
         */
        static decodeFormatInformation(maskedFormatInfo1 /*int*/, maskedFormatInfo2 /*int*/) {
            const formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
            if (formatInfo !== null) {
                return formatInfo;
            }
            // Should return null, but, some QR codes apparently
            // do not mask this info. Try again by actually masking the pattern
            // first
            return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
        }
        static doDecodeFormatInformation(maskedFormatInfo1 /*int*/, maskedFormatInfo2 /*int*/) {
            // Find the int in FORMAT_INFO_DECODE_LOOKUP with fewest bits differing
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestFormatInfo = 0;
            for (const decodeInfo of FormatInformation.FORMAT_INFO_DECODE_LOOKUP) {
                const targetInfo = decodeInfo[0];
                if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) {
                    // Found an exact match
                    return new FormatInformation(decodeInfo[1]);
                }
                let bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
                if (bitsDifference < bestDifference) {
                    bestFormatInfo = decodeInfo[1];
                    bestDifference = bitsDifference;
                }
                if (maskedFormatInfo1 !== maskedFormatInfo2) {
                    // also try the other option
                    bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
                    if (bitsDifference < bestDifference) {
                        bestFormatInfo = decodeInfo[1];
                        bestDifference = bitsDifference;
                    }
                }
            }
            // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits
            // differing means we found a match
            if (bestDifference <= 3) {
                return new FormatInformation(bestFormatInfo);
            }
            return null;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getDataMask() {
            return this.dataMask;
        }
        /*@Override*/
        hashCode() {
            return (this.errorCorrectionLevel.getBits() << 3) | this.dataMask;
        }
        /*@Override*/
        equals(o) {
            if (!(o instanceof FormatInformation)) {
                return false;
            }
            const other = o;
            return this.errorCorrectionLevel === other.errorCorrectionLevel &&
                this.dataMask === other.dataMask;
        }
    }
    FormatInformation.FORMAT_INFO_MASK_QR = 0x5412;
    /**
     * See ISO 18004:2006, Annex C, Table C.1
     */
    FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([0x5412, 0x00]),
        Int32Array.from([0x5125, 0x01]),
        Int32Array.from([0x5E7C, 0x02]),
        Int32Array.from([0x5B4B, 0x03]),
        Int32Array.from([0x45F9, 0x04]),
        Int32Array.from([0x40CE, 0x05]),
        Int32Array.from([0x4F97, 0x06]),
        Int32Array.from([0x4AA0, 0x07]),
        Int32Array.from([0x77C4, 0x08]),
        Int32Array.from([0x72F3, 0x09]),
        Int32Array.from([0x7DAA, 0x0A]),
        Int32Array.from([0x789D, 0x0B]),
        Int32Array.from([0x662F, 0x0C]),
        Int32Array.from([0x6318, 0x0D]),
        Int32Array.from([0x6C41, 0x0E]),
        Int32Array.from([0x6976, 0x0F]),
        Int32Array.from([0x1689, 0x10]),
        Int32Array.from([0x13BE, 0x11]),
        Int32Array.from([0x1CE7, 0x12]),
        Int32Array.from([0x19D0, 0x13]),
        Int32Array.from([0x0762, 0x14]),
        Int32Array.from([0x0255, 0x15]),
        Int32Array.from([0x0D0C, 0x16]),
        Int32Array.from([0x083B, 0x17]),
        Int32Array.from([0x355F, 0x18]),
        Int32Array.from([0x3068, 0x19]),
        Int32Array.from([0x3F31, 0x1A]),
        Int32Array.from([0x3A06, 0x1B]),
        Int32Array.from([0x24B4, 0x1C]),
        Int32Array.from([0x2183, 0x1D]),
        Int32Array.from([0x2EDA, 0x1E]),
        Int32Array.from([0x2BED, 0x1F]),
    ];

    /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */
    class ECBlocks$1 {
        constructor(ecCodewordsPerBlock /*int*/, ...ecBlocks) {
            this.ecCodewordsPerBlock = ecCodewordsPerBlock;
            this.ecBlocks = ecBlocks;
        }
        getECCodewordsPerBlock() {
            return this.ecCodewordsPerBlock;
        }
        getNumBlocks() {
            let total = 0;
            const ecBlocks = this.ecBlocks;
            for (const ecBlock of ecBlocks) {
                total += ecBlock.getCount();
            }
            return total;
        }
        getTotalECCodewords() {
            return this.ecCodewordsPerBlock * this.getNumBlocks();
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }

    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the QR code version's format.</p>
     */
    class ECB$1 {
        constructor(count /*int*/, dataCodewords /*int*/) {
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * See ISO 18004:2006 Annex D
     *
     * @author Sean Owen
     */
    class Version$1 {
        constructor(versionNumber /*int*/, alignmentPatternCenters, ...ecBlocks) {
            this.versionNumber = versionNumber;
            this.alignmentPatternCenters = alignmentPatternCenters;
            this.ecBlocks = ecBlocks;
            let total = 0;
            const ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
            const ecbArray = ecBlocks[0].getECBlocks();
            for (const ecBlock of ecbArray) {
                total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            }
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getAlignmentPatternCenters() {
            return this.alignmentPatternCenters;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getDimensionForVersion() {
            return 17 + 4 * this.versionNumber;
        }
        getECBlocksForLevel(ecLevel) {
            return this.ecBlocks[ecLevel.getValue()];
            // TYPESCRIPTPORT: original was using ordinal, and using the order of levels as defined in ErrorCorrectionLevel enum (LMQH)
            // I will use the direct value from ErrorCorrectionLevelValues enum which in typescript goes to a number
        }
        /**
         * <p>Deduces version information purely from QR Code dimensions.</p>
         *
         * @param dimension dimension in modules
         * @return Version for a QR Code of that dimension
         * @throws FormatException if dimension is not 1 mod 4
         */
        static getProvisionalVersionForDimension(dimension /*int*/) {
            if (dimension % 4 !== 1) {
                throw new FormatException();
            }
            try {
                return this.getVersionForNumber((dimension - 17) / 4);
            }
            catch (ignored /*: IllegalArgumentException*/) {
                throw new FormatException();
            }
        }
        static getVersionForNumber(versionNumber /*int*/) {
            if (versionNumber < 1 || versionNumber > 40) {
                throw new IllegalArgumentException();
            }
            return Version$1.VERSIONS[versionNumber - 1];
        }
        static decodeVersionInformation(versionBits /*int*/) {
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestVersion = 0;
            for (let i = 0; i < Version$1.VERSION_DECODE_INFO.length; i++) {
                const targetVersion = Version$1.VERSION_DECODE_INFO[i];
                // Do the version info bits match exactly? done.
                if (targetVersion === versionBits) {
                    return Version$1.getVersionForNumber(i + 7);
                }
                // Otherwise see if this is the closest to a real version info bit string
                // we have seen so far
                const bitsDifference = FormatInformation.numBitsDiffering(versionBits, targetVersion);
                if (bitsDifference < bestDifference) {
                    bestVersion = i + 7;
                    bestDifference = bitsDifference;
                }
            }
            // We can tolerate up to 3 bits of error since no two version info codewords will
            // differ in less than 8 bits.
            if (bestDifference <= 3) {
                return Version$1.getVersionForNumber(bestVersion);
            }
            // If we didn't find a close enough match, fail
            return null;
        }
        /**
         * See ISO 18004:2006 Annex E
         */
        buildFunctionPattern() {
            const dimension = this.getDimensionForVersion();
            const bitMatrix = new BitMatrix(dimension);
            // Top left finder pattern + separator + format
            bitMatrix.setRegion(0, 0, 9, 9);
            // Top right finder pattern + separator + format
            bitMatrix.setRegion(dimension - 8, 0, 8, 9);
            // Bottom left finder pattern + separator + format
            bitMatrix.setRegion(0, dimension - 8, 9, 8);
            // Alignment patterns
            const max = this.alignmentPatternCenters.length;
            for (let x = 0; x < max; x++) {
                const i = this.alignmentPatternCenters[x] - 2;
                for (let y = 0; y < max; y++) {
                    if ((x === 0 && (y === 0 || y === max - 1)) || (x === max - 1 && y === 0)) {
                        // No alignment patterns near the three finder patterns
                        continue;
                    }
                    bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
                }
            }
            // Vertical timing pattern
            bitMatrix.setRegion(6, 9, 1, dimension - 17);
            // Horizontal timing pattern
            bitMatrix.setRegion(9, 6, dimension - 17, 1);
            if (this.versionNumber > 6) {
                // Version info, top right
                bitMatrix.setRegion(dimension - 11, 0, 3, 6);
                // Version info, bottom left
                bitMatrix.setRegion(0, dimension - 11, 6, 3);
            }
            return bitMatrix;
        }
        /*@Override*/
        toString() {
            return '' + this.versionNumber;
        }
    }
    /**
       * See ISO 18004:2006 Annex D.
       * Element i represents the raw version bits that specify version i + 7
       */
    Version$1.VERSION_DECODE_INFO = Int32Array.from([
        0x07C94, 0x085BC, 0x09A99, 0x0A4D3, 0x0BBF6,
        0x0C762, 0x0D847, 0x0E60D, 0x0F928, 0x10B78,
        0x1145D, 0x12A17, 0x13532, 0x149A6, 0x15683,
        0x168C9, 0x177EC, 0x18EC4, 0x191E1, 0x1AFAB,
        0x1B08E, 0x1CC1A, 0x1D33F, 0x1ED75, 0x1F250,
        0x209D5, 0x216F0, 0x228BA, 0x2379F, 0x24B0B,
        0x2542E, 0x26A64, 0x27541, 0x28C69
    ]);
    /**
       * See ISO 18004:2006 6.5.1 Table 9
       */
    Version$1.VERSIONS = [
        new Version$1(1, new Int32Array(0), new ECBlocks$1(7, new ECB$1(1, 19)), new ECBlocks$1(10, new ECB$1(1, 16)), new ECBlocks$1(13, new ECB$1(1, 13)), new ECBlocks$1(17, new ECB$1(1, 9))),
        new Version$1(2, Int32Array.from([6, 18]), new ECBlocks$1(10, new ECB$1(1, 34)), new ECBlocks$1(16, new ECB$1(1, 28)), new ECBlocks$1(22, new ECB$1(1, 22)), new ECBlocks$1(28, new ECB$1(1, 16))),
        new Version$1(3, Int32Array.from([6, 22]), new ECBlocks$1(15, new ECB$1(1, 55)), new ECBlocks$1(26, new ECB$1(1, 44)), new ECBlocks$1(18, new ECB$1(2, 17)), new ECBlocks$1(22, new ECB$1(2, 13))),
        new Version$1(4, Int32Array.from([6, 26]), new ECBlocks$1(20, new ECB$1(1, 80)), new ECBlocks$1(18, new ECB$1(2, 32)), new ECBlocks$1(26, new ECB$1(2, 24)), new ECBlocks$1(16, new ECB$1(4, 9))),
        new Version$1(5, Int32Array.from([6, 30]), new ECBlocks$1(26, new ECB$1(1, 108)), new ECBlocks$1(24, new ECB$1(2, 43)), new ECBlocks$1(18, new ECB$1(2, 15), new ECB$1(2, 16)), new ECBlocks$1(22, new ECB$1(2, 11), new ECB$1(2, 12))),
        new Version$1(6, Int32Array.from([6, 34]), new ECBlocks$1(18, new ECB$1(2, 68)), new ECBlocks$1(16, new ECB$1(4, 27)), new ECBlocks$1(24, new ECB$1(4, 19)), new ECBlocks$1(28, new ECB$1(4, 15))),
        new Version$1(7, Int32Array.from([6, 22, 38]), new ECBlocks$1(20, new ECB$1(2, 78)), new ECBlocks$1(18, new ECB$1(4, 31)), new ECBlocks$1(18, new ECB$1(2, 14), new ECB$1(4, 15)), new ECBlocks$1(26, new ECB$1(4, 13), new ECB$1(1, 14))),
        new Version$1(8, Int32Array.from([6, 24, 42]), new ECBlocks$1(24, new ECB$1(2, 97)), new ECBlocks$1(22, new ECB$1(2, 38), new ECB$1(2, 39)), new ECBlocks$1(22, new ECB$1(4, 18), new ECB$1(2, 19)), new ECBlocks$1(26, new ECB$1(4, 14), new ECB$1(2, 15))),
        new Version$1(9, Int32Array.from([6, 26, 46]), new ECBlocks$1(30, new ECB$1(2, 116)), new ECBlocks$1(22, new ECB$1(3, 36), new ECB$1(2, 37)), new ECBlocks$1(20, new ECB$1(4, 16), new ECB$1(4, 17)), new ECBlocks$1(24, new ECB$1(4, 12), new ECB$1(4, 13))),
        new Version$1(10, Int32Array.from([6, 28, 50]), new ECBlocks$1(18, new ECB$1(2, 68), new ECB$1(2, 69)), new ECBlocks$1(26, new ECB$1(4, 43), new ECB$1(1, 44)), new ECBlocks$1(24, new ECB$1(6, 19), new ECB$1(2, 20)), new ECBlocks$1(28, new ECB$1(6, 15), new ECB$1(2, 16))),
        new Version$1(11, Int32Array.from([6, 30, 54]), new ECBlocks$1(20, new ECB$1(4, 81)), new ECBlocks$1(30, new ECB$1(1, 50), new ECB$1(4, 51)), new ECBlocks$1(28, new ECB$1(4, 22), new ECB$1(4, 23)), new ECBlocks$1(24, new ECB$1(3, 12), new ECB$1(8, 13))),
        new Version$1(12, Int32Array.from([6, 32, 58]), new ECBlocks$1(24, new ECB$1(2, 92), new ECB$1(2, 93)), new ECBlocks$1(22, new ECB$1(6, 36), new ECB$1(2, 37)), new ECBlocks$1(26, new ECB$1(4, 20), new ECB$1(6, 21)), new ECBlocks$1(28, new ECB$1(7, 14), new ECB$1(4, 15))),
        new Version$1(13, Int32Array.from([6, 34, 62]), new ECBlocks$1(26, new ECB$1(4, 107)), new ECBlocks$1(22, new ECB$1(8, 37), new ECB$1(1, 38)), new ECBlocks$1(24, new ECB$1(8, 20), new ECB$1(4, 21)), new ECBlocks$1(22, new ECB$1(12, 11), new ECB$1(4, 12))),
        new Version$1(14, Int32Array.from([6, 26, 46, 66]), new ECBlocks$1(30, new ECB$1(3, 115), new ECB$1(1, 116)), new ECBlocks$1(24, new ECB$1(4, 40), new ECB$1(5, 41)), new ECBlocks$1(20, new ECB$1(11, 16), new ECB$1(5, 17)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(5, 13))),
        new Version$1(15, Int32Array.from([6, 26, 48, 70]), new ECBlocks$1(22, new ECB$1(5, 87), new ECB$1(1, 88)), new ECBlocks$1(24, new ECB$1(5, 41), new ECB$1(5, 42)), new ECBlocks$1(30, new ECB$1(5, 24), new ECB$1(7, 25)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(7, 13))),
        new Version$1(16, Int32Array.from([6, 26, 50, 74]), new ECBlocks$1(24, new ECB$1(5, 98), new ECB$1(1, 99)), new ECBlocks$1(28, new ECB$1(7, 45), new ECB$1(3, 46)), new ECBlocks$1(24, new ECB$1(15, 19), new ECB$1(2, 20)), new ECBlocks$1(30, new ECB$1(3, 15), new ECB$1(13, 16))),
        new Version$1(17, Int32Array.from([6, 30, 54, 78]), new ECBlocks$1(28, new ECB$1(1, 107), new ECB$1(5, 108)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(1, 47)), new ECBlocks$1(28, new ECB$1(1, 22), new ECB$1(15, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(17, 15))),
        new Version$1(18, Int32Array.from([6, 30, 56, 82]), new ECBlocks$1(30, new ECB$1(5, 120), new ECB$1(1, 121)), new ECBlocks$1(26, new ECB$1(9, 43), new ECB$1(4, 44)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(1, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(19, 15))),
        new Version$1(19, Int32Array.from([6, 30, 58, 86]), new ECBlocks$1(28, new ECB$1(3, 113), new ECB$1(4, 114)), new ECBlocks$1(26, new ECB$1(3, 44), new ECB$1(11, 45)), new ECBlocks$1(26, new ECB$1(17, 21), new ECB$1(4, 22)), new ECBlocks$1(26, new ECB$1(9, 13), new ECB$1(16, 14))),
        new Version$1(20, Int32Array.from([6, 34, 62, 90]), new ECBlocks$1(28, new ECB$1(3, 107), new ECB$1(5, 108)), new ECBlocks$1(26, new ECB$1(3, 41), new ECB$1(13, 42)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(5, 25)), new ECBlocks$1(28, new ECB$1(15, 15), new ECB$1(10, 16))),
        new Version$1(21, Int32Array.from([6, 28, 50, 72, 94]), new ECBlocks$1(28, new ECB$1(4, 116), new ECB$1(4, 117)), new ECBlocks$1(26, new ECB$1(17, 42)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(19, 16), new ECB$1(6, 17))),
        new Version$1(22, Int32Array.from([6, 26, 50, 74, 98]), new ECBlocks$1(28, new ECB$1(2, 111), new ECB$1(7, 112)), new ECBlocks$1(28, new ECB$1(17, 46)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(16, 25)), new ECBlocks$1(24, new ECB$1(34, 13))),
        new Version$1(23, Int32Array.from([6, 30, 54, 78, 102]), new ECBlocks$1(30, new ECB$1(4, 121), new ECB$1(5, 122)), new ECBlocks$1(28, new ECB$1(4, 47), new ECB$1(14, 48)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(16, 15), new ECB$1(14, 16))),
        new Version$1(24, Int32Array.from([6, 28, 54, 80, 106]), new ECBlocks$1(30, new ECB$1(6, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(6, 45), new ECB$1(14, 46)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(16, 25)), new ECBlocks$1(30, new ECB$1(30, 16), new ECB$1(2, 17))),
        new Version$1(25, Int32Array.from([6, 32, 58, 84, 110]), new ECBlocks$1(26, new ECB$1(8, 106), new ECB$1(4, 107)), new ECBlocks$1(28, new ECB$1(8, 47), new ECB$1(13, 48)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(13, 16))),
        new Version$1(26, Int32Array.from([6, 30, 58, 86, 114]), new ECBlocks$1(28, new ECB$1(10, 114), new ECB$1(2, 115)), new ECBlocks$1(28, new ECB$1(19, 46), new ECB$1(4, 47)), new ECBlocks$1(28, new ECB$1(28, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(33, 16), new ECB$1(4, 17))),
        new Version$1(27, Int32Array.from([6, 34, 62, 90, 118]), new ECBlocks$1(30, new ECB$1(8, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(22, 45), new ECB$1(3, 46)), new ECBlocks$1(30, new ECB$1(8, 23), new ECB$1(26, 24)), new ECBlocks$1(30, new ECB$1(12, 15), new ECB$1(28, 16))),
        new Version$1(28, Int32Array.from([6, 26, 50, 74, 98, 122]), new ECBlocks$1(30, new ECB$1(3, 117), new ECB$1(10, 118)), new ECBlocks$1(28, new ECB$1(3, 45), new ECB$1(23, 46)), new ECBlocks$1(30, new ECB$1(4, 24), new ECB$1(31, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(31, 16))),
        new Version$1(29, Int32Array.from([6, 30, 54, 78, 102, 126]), new ECBlocks$1(30, new ECB$1(7, 116), new ECB$1(7, 117)), new ECBlocks$1(28, new ECB$1(21, 45), new ECB$1(7, 46)), new ECBlocks$1(30, new ECB$1(1, 23), new ECB$1(37, 24)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(26, 16))),
        new Version$1(30, Int32Array.from([6, 26, 52, 78, 104, 130]), new ECBlocks$1(30, new ECB$1(5, 115), new ECB$1(10, 116)), new ECBlocks$1(28, new ECB$1(19, 47), new ECB$1(10, 48)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(25, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(25, 16))),
        new Version$1(31, Int32Array.from([6, 30, 56, 82, 108, 134]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(3, 116)), new ECBlocks$1(28, new ECB$1(2, 46), new ECB$1(29, 47)), new ECBlocks$1(30, new ECB$1(42, 24), new ECB$1(1, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(28, 16))),
        new Version$1(32, Int32Array.from([6, 34, 60, 86, 112, 138]), new ECBlocks$1(30, new ECB$1(17, 115)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(10, 24), new ECB$1(35, 25)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(35, 16))),
        new Version$1(33, Int32Array.from([6, 30, 58, 86, 114, 142]), new ECBlocks$1(30, new ECB$1(17, 115), new ECB$1(1, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(21, 47)), new ECBlocks$1(30, new ECB$1(29, 24), new ECB$1(19, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(46, 16))),
        new Version$1(34, Int32Array.from([6, 34, 62, 90, 118, 146]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(6, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(44, 24), new ECB$1(7, 25)), new ECBlocks$1(30, new ECB$1(59, 16), new ECB$1(1, 17))),
        new Version$1(35, Int32Array.from([6, 30, 54, 78, 102, 126, 150]), new ECBlocks$1(30, new ECB$1(12, 121), new ECB$1(7, 122)), new ECBlocks$1(28, new ECB$1(12, 47), new ECB$1(26, 48)), new ECBlocks$1(30, new ECB$1(39, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(41, 16))),
        new Version$1(36, Int32Array.from([6, 24, 50, 76, 102, 128, 154]), new ECBlocks$1(30, new ECB$1(6, 121), new ECB$1(14, 122)), new ECBlocks$1(28, new ECB$1(6, 47), new ECB$1(34, 48)), new ECBlocks$1(30, new ECB$1(46, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(2, 15), new ECB$1(64, 16))),
        new Version$1(37, Int32Array.from([6, 28, 54, 80, 106, 132, 158]), new ECBlocks$1(30, new ECB$1(17, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(29, 46), new ECB$1(14, 47)), new ECBlocks$1(30, new ECB$1(49, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(24, 15), new ECB$1(46, 16))),
        new Version$1(38, Int32Array.from([6, 32, 58, 84, 110, 136, 162]), new ECBlocks$1(30, new ECB$1(4, 122), new ECB$1(18, 123)), new ECBlocks$1(28, new ECB$1(13, 46), new ECB$1(32, 47)), new ECBlocks$1(30, new ECB$1(48, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(42, 15), new ECB$1(32, 16))),
        new Version$1(39, Int32Array.from([6, 26, 54, 82, 110, 138, 166]), new ECBlocks$1(30, new ECB$1(20, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(40, 47), new ECB$1(7, 48)), new ECBlocks$1(30, new ECB$1(43, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(10, 15), new ECB$1(67, 16))),
        new Version$1(40, Int32Array.from([6, 30, 58, 86, 114, 142, 170]), new ECBlocks$1(30, new ECB$1(19, 118), new ECB$1(6, 119)), new ECBlocks$1(28, new ECB$1(18, 47), new ECB$1(31, 48)), new ECBlocks$1(30, new ECB$1(34, 24), new ECB$1(34, 25)), new ECBlocks$1(30, new ECB$1(20, 15), new ECB$1(61, 16)))
    ];

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    var DataMaskValues;
    (function (DataMaskValues) {
        DataMaskValues[DataMaskValues["DATA_MASK_000"] = 0] = "DATA_MASK_000";
        DataMaskValues[DataMaskValues["DATA_MASK_001"] = 1] = "DATA_MASK_001";
        DataMaskValues[DataMaskValues["DATA_MASK_010"] = 2] = "DATA_MASK_010";
        DataMaskValues[DataMaskValues["DATA_MASK_011"] = 3] = "DATA_MASK_011";
        DataMaskValues[DataMaskValues["DATA_MASK_100"] = 4] = "DATA_MASK_100";
        DataMaskValues[DataMaskValues["DATA_MASK_101"] = 5] = "DATA_MASK_101";
        DataMaskValues[DataMaskValues["DATA_MASK_110"] = 6] = "DATA_MASK_110";
        DataMaskValues[DataMaskValues["DATA_MASK_111"] = 7] = "DATA_MASK_111";
    })(DataMaskValues || (DataMaskValues = {}));
    /**
     * <p>Encapsulates data masks for the data bits in a QR code, per ISO 18004:2006 6.8. Implementations
     * of this class can un-mask a raw BitMatrix. For simplicity, they will unmask the entire BitMatrix,
     * including areas used for finder patterns, timing patterns, etc. These areas should be unused
     * after the point they are unmasked anyway.</p>
     *
     * <p>Note that the diagram in section 6.8.1 is misleading since it indicates that i is column position
     * and j is row position. In fact, as the text says, i is row position and j is column position.</p>
     *
     * @author Sean Owen
     */
    class DataMask {
        // See ISO 18004:2006 6.8.1
        constructor(value, isMasked) {
            this.value = value;
            this.isMasked = isMasked;
        }
        // End of enum constants.
        /**
         * <p>Implementations of this method reverse the data masking process applied to a QR Code and
         * make its bits ready to read.</p>
         *
         * @param bits representation of QR Code bits
         * @param dimension dimension of QR Code, represented by bits, being unmasked
         */
        unmaskBitMatrix(bits, dimension /*int*/) {
            for (let i = 0; i < dimension; i++) {
                for (let j = 0; j < dimension; j++) {
                    if (this.isMasked(i, j)) {
                        bits.flip(j, i);
                    }
                }
            }
        }
    }
    DataMask.values = new Map([
        /**
         * 000: mask bits for which (x + y) mod 2 == 0
         */
        [DataMaskValues.DATA_MASK_000, new DataMask(DataMaskValues.DATA_MASK_000, (i /*int*/, j /*int*/) => { return ((i + j) & 0x01) === 0; })],
        /**
         * 001: mask bits for which x mod 2 == 0
         */
        [DataMaskValues.DATA_MASK_001, new DataMask(DataMaskValues.DATA_MASK_001, (i /*int*/, j /*int*/) => { return (i & 0x01) === 0; })],
        /**
         * 010: mask bits for which y mod 3 == 0
         */
        [DataMaskValues.DATA_MASK_010, new DataMask(DataMaskValues.DATA_MASK_010, (i /*int*/, j /*int*/) => { return j % 3 === 0; })],
        /**
         * 011: mask bits for which (x + y) mod 3 == 0
         */
        [DataMaskValues.DATA_MASK_011, new DataMask(DataMaskValues.DATA_MASK_011, (i /*int*/, j /*int*/) => { return (i + j) % 3 === 0; })],
        /**
         * 100: mask bits for which (x/2 + y/3) mod 2 == 0
         */
        [DataMaskValues.DATA_MASK_100, new DataMask(DataMaskValues.DATA_MASK_100, (i /*int*/, j /*int*/) => { return ((Math.floor(i / 2) + Math.floor(j / 3)) & 0x01) === 0; })],
        /**
         * 101: mask bits for which xy mod 2 + xy mod 3 == 0
         * equivalently, such that xy mod 6 == 0
         */
        [DataMaskValues.DATA_MASK_101, new DataMask(DataMaskValues.DATA_MASK_101, (i /*int*/, j /*int*/) => { return (i * j) % 6 === 0; })],
        /**
         * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that xy mod 6 < 3
         */
        [DataMaskValues.DATA_MASK_110, new DataMask(DataMaskValues.DATA_MASK_110, (i /*int*/, j /*int*/) => { return ((i * j) % 6) < 3; })],
        /**
         * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that (x + y + xy mod 3) mod 2 == 0
         */
        [DataMaskValues.DATA_MASK_111, new DataMask(DataMaskValues.DATA_MASK_111, (i /*int*/, j /*int*/) => { return ((i + j + ((i * j) % 3)) & 0x01) === 0; })],
    ]);

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @author Sean Owen
     */
    class BitMatrixParser$1 {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is not >= 21 and 1 mod 4
         */
        constructor(bitMatrix) {
            const dimension = bitMatrix.getHeight();
            if (dimension < 21 || (dimension & 0x03) !== 1) {
                throw new FormatException();
            }
            this.bitMatrix = bitMatrix;
        }
        /**
         * <p>Reads format information from one of its two locations within the QR Code.</p>
         *
         * @return {@link FormatInformation} encapsulating the QR Code's format info
         * @throws FormatException if both format information locations cannot be parsed as
         * the valid encoding of format information
         */
        readFormatInformation() {
            if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== undefined) {
                return this.parsedFormatInfo;
            }
            // Read top-left format info bits
            let formatInfoBits1 = 0;
            for (let i = 0; i < 6; i++) {
                formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
            }
            // .. and skip a bit in the timing pattern ...
            formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            for (let j = 5; j >= 0; j--) {
                formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
            }
            // Read the top-right/bottom-left pattern too
            const dimension = this.bitMatrix.getHeight();
            let formatInfoBits2 = 0;
            const jMin = dimension - 7;
            for (let j = dimension - 1; j >= jMin; j--) {
                formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
            }
            for (let i = dimension - 8; i < dimension; i++) {
                formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
            }
            this.parsedFormatInfo = FormatInformation.decodeFormatInformation(formatInfoBits1, formatInfoBits2);
            if (this.parsedFormatInfo !== null) {
                return this.parsedFormatInfo;
            }
            throw new FormatException();
        }
        /**
         * <p>Reads version information from one of its two locations within the QR Code.</p>
         *
         * @return {@link Version} encapsulating the QR Code's version
         * @throws FormatException if both version information locations cannot be parsed as
         * the valid encoding of version information
         */
        readVersion() {
            if (this.parsedVersion !== null && this.parsedVersion !== undefined) {
                return this.parsedVersion;
            }
            const dimension = this.bitMatrix.getHeight();
            const provisionalVersion = Math.floor((dimension - 17) / 4);
            if (provisionalVersion <= 6) {
                return Version$1.getVersionForNumber(provisionalVersion);
            }
            // Read top-right version info: 3 wide by 6 tall
            let versionBits = 0;
            const ijMin = dimension - 11;
            for (let j = 5; j >= 0; j--) {
                for (let i = dimension - 9; i >= ijMin; i--) {
                    versionBits = this.copyBit(i, j, versionBits);
                }
            }
            let theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            // Hmm, failed. Try bottom left: 6 wide by 3 tall
            versionBits = 0;
            for (let i = 5; i >= 0; i--) {
                for (let j = dimension - 9; j >= ijMin; j--) {
                    versionBits = this.copyBit(i, j, versionBits);
                }
            }
            theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            throw new FormatException();
        }
        copyBit(i /*int*/, j /*int*/, versionBits /*int*/) {
            const bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
            return bit ? (versionBits << 1) | 0x1 : versionBits << 1;
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
         * correct order in order to reconstruct the codewords bytes contained within the
         * QR Code.</p>
         *
         * @return bytes encoded within the QR Code
         * @throws FormatException if the exact number of bytes expected is not read
         */
        readCodewords() {
            const formatInfo = this.readFormatInformation();
            const version = this.readVersion();
            // Get the data mask for the format used in this QR Code. This will exclude
            // some bits from reading as we wind through the bit matrix.
            const dataMask = DataMask.values.get(formatInfo.getDataMask());
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
            const functionPattern = version.buildFunctionPattern();
            let readingUp = true;
            const result = new Uint8Array(version.getTotalCodewords());
            let resultOffset = 0;
            let currentByte = 0;
            let bitsRead = 0;
            // Read columns in pairs, from right to left
            for (let j = dimension - 1; j > 0; j -= 2) {
                if (j === 6) {
                    // Skip whole column with vertical alignment pattern
                    // saves time and makes the other code proceed more cleanly
                    j--;
                }
                // Read alternatingly from bottom to top then top to bottom
                for (let count = 0; count < dimension; count++) {
                    const i = readingUp ? dimension - 1 - count : count;
                    for (let col = 0; col < 2; col++) {
                        // Ignore bits covered by the function pattern
                        if (!functionPattern.get(j - col, i)) {
                            // Read a bit
                            bitsRead++;
                            currentByte <<= 1;
                            if (this.bitMatrix.get(j - col, i)) {
                                currentByte |= 1;
                            }
                            // If we've made a whole byte, save it off
                            if (bitsRead === 8) {
                                result[resultOffset++] = /*(byte) */ currentByte;
                                bitsRead = 0;
                                currentByte = 0;
                            }
                        }
                    }
                }
                readingUp = !readingUp; // readingUp ^= true; // readingUp = !readingUp; // switch directions
            }
            if (resultOffset !== version.getTotalCodewords()) {
                throw new FormatException();
            }
            return result;
        }
        /**
         * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
         */
        remask() {
            if (this.parsedFormatInfo === null) {
                return; // We have no format information, and have no data mask
            }
            const dataMask = DataMask.values[this.parsedFormatInfo.getDataMask()];
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        }
        /**
         * Prepare the parser for a mirrored operation.
         * This flag has effect only on the {@link #readFormatInformation()} and the
         * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
         * {@link #mirror()} method should be called.
         *
         * @param mirror Whether to read version and format information mirrored.
         */
        setMirror(isMirror) {
            this.parsedVersion = null;
            this.parsedFormatInfo = null;
            this.isMirror = isMirror;
        }
        /** Mirror the bit matrix in order to attempt a second reading. */
        mirror() {
            const bitMatrix = this.bitMatrix;
            for (let x = 0, width = bitMatrix.getWidth(); x < width; x++) {
                for (let y = x + 1, height = bitMatrix.getHeight(); y < height; y++) {
                    if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
                        bitMatrix.flip(y, x);
                        bitMatrix.flip(x, y);
                    }
                }
            }
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates a block of data within a QR Code. QR Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author Sean Owen
     */
    class DataBlock$1 {
        constructor(numDataCodewords /*int*/, codewords) {
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When QR Codes use multiple data blocks, they are actually interleaved.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the QR Code
         * @param version version of the QR Code
         * @param ecLevel error-correction level of the QR Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         QR Code
         */
        static getDataBlocks(rawCodewords, version, ecLevel) {
            if (rawCodewords.length !== version.getTotalCodewords()) {
                throw new IllegalArgumentException();
            }
            // Figure out the number and size of data blocks used by this version and
            // error correction level
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (const ecBlock of ecBlockArray) {
                totalBlocks += ecBlock.getCount();
            }
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (const ecBlock of ecBlockArray) {
                for (let i = 0; i < ecBlock.getCount(); i++) {
                    const numDataCodewords = ecBlock.getDataCodewords();
                    const numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
                    result[numResultBlocks++] = new DataBlock$1(numDataCodewords, new Uint8Array(numBlockCodewords));
                }
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 more byte. Figure out where these start.
            const shorterBlocksTotalCodewords = result[0].codewords.length;
            let longerBlocksStartAt = result.length - 1;
            // TYPESCRIPTPORT: check length is correct here
            while (longerBlocksStartAt >= 0) {
                const numCodewords = result[longerBlocksStartAt].codewords.length;
                if (numCodewords === shorterBlocksTotalCodewords) {
                    break;
                }
                longerBlocksStartAt--;
            }
            longerBlocksStartAt++;
            const shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
            // The last elements of result may be 1 element longer
            // first fill out as many elements as all of them have
            let rawCodewordsOffset = 0;
            for (let i = 0; i < shorterBlocksNumDataCodewords; i++) {
                for (let j = 0; j < numResultBlocks; j++) {
                    result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
                }
            }
            // Fill out the last data block in the longer ones
            for (let j = longerBlocksStartAt; j < numResultBlocks; j++) {
                result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
            }
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for (let i = shorterBlocksNumDataCodewords; i < max; i++) {
                for (let j = 0; j < numResultBlocks; j++) {
                    const iOffset = j < longerBlocksStartAt ? i : i + 1;
                    result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
                }
            }
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    var ModeValues;
    (function (ModeValues) {
        ModeValues[ModeValues["TERMINATOR"] = 0] = "TERMINATOR";
        ModeValues[ModeValues["NUMERIC"] = 1] = "NUMERIC";
        ModeValues[ModeValues["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
        ModeValues[ModeValues["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
        ModeValues[ModeValues["BYTE"] = 4] = "BYTE";
        ModeValues[ModeValues["ECI"] = 5] = "ECI";
        ModeValues[ModeValues["KANJI"] = 6] = "KANJI";
        ModeValues[ModeValues["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
        ModeValues[ModeValues["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
        /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */
        ModeValues[ModeValues["HANZI"] = 9] = "HANZI";
    })(ModeValues || (ModeValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.4.1, Tables 2 and 3. This enum encapsulates the various modes in which
     * data can be encoded to bits in the QR code standard.</p>
     *
     * @author Sean Owen
     */
    class Mode$1 {
        constructor(value, stringValue, characterCountBitsForVersions, bits /*int*/) {
            this.value = value;
            this.stringValue = stringValue;
            this.characterCountBitsForVersions = characterCountBitsForVersions;
            this.bits = bits;
            Mode$1.FOR_BITS.set(bits, this);
            Mode$1.FOR_VALUE.set(value, this);
        }
        /**
         * @param bits four bits encoding a QR Code data mode
         * @return Mode encoded by these bits
         * @throws IllegalArgumentException if bits do not correspond to a known mode
         */
        static forBits(bits /*int*/) {
            const mode = Mode$1.FOR_BITS.get(bits);
            if (undefined === mode) {
                throw new IllegalArgumentException();
            }
            return mode;
        }
        /**
         * @param version version in question
         * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
         *         count of characters that will follow encoded in this Mode
         */
        getCharacterCountBits(version) {
            const versionNumber = version.getVersionNumber();
            let offset;
            if (versionNumber <= 9) {
                offset = 0;
            }
            else if (versionNumber <= 26) {
                offset = 1;
            }
            else {
                offset = 2;
            }
            return this.characterCountBitsForVersions[offset];
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        equals(o) {
            if (!(o instanceof Mode$1)) {
                return false;
            }
            const other = o;
            return this.value === other.value;
        }
        toString() {
            return this.stringValue;
        }
    }
    Mode$1.FOR_BITS = new Map();
    Mode$1.FOR_VALUE = new Map();
    Mode$1.TERMINATOR = new Mode$1(ModeValues.TERMINATOR, 'TERMINATOR', Int32Array.from([0, 0, 0]), 0x00); // Not really a mode...
    Mode$1.NUMERIC = new Mode$1(ModeValues.NUMERIC, 'NUMERIC', Int32Array.from([10, 12, 14]), 0x01);
    Mode$1.ALPHANUMERIC = new Mode$1(ModeValues.ALPHANUMERIC, 'ALPHANUMERIC', Int32Array.from([9, 11, 13]), 0x02);
    Mode$1.STRUCTURED_APPEND = new Mode$1(ModeValues.STRUCTURED_APPEND, 'STRUCTURED_APPEND', Int32Array.from([0, 0, 0]), 0x03); // Not supported
    Mode$1.BYTE = new Mode$1(ModeValues.BYTE, 'BYTE', Int32Array.from([8, 16, 16]), 0x04);
    Mode$1.ECI = new Mode$1(ModeValues.ECI, 'ECI', Int32Array.from([0, 0, 0]), 0x07); // character counts don't apply
    Mode$1.KANJI = new Mode$1(ModeValues.KANJI, 'KANJI', Int32Array.from([8, 10, 12]), 0x08);
    Mode$1.FNC1_FIRST_POSITION = new Mode$1(ModeValues.FNC1_FIRST_POSITION, 'FNC1_FIRST_POSITION', Int32Array.from([0, 0, 0]), 0x05);
    Mode$1.FNC1_SECOND_POSITION = new Mode$1(ModeValues.FNC1_SECOND_POSITION, 'FNC1_SECOND_POSITION', Int32Array.from([0, 0, 0]), 0x09);
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */
    Mode$1.HANZI = new Mode$1(ModeValues.HANZI, 'HANZI', Int32Array.from([8, 10, 12]), 0x0D);

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*import java.io.UnsupportedEncodingException;*/
    /*import java.util.ArrayList;*/
    /*import java.util.Collection;*/
    /*import java.util.List;*/
    /*import java.util.Map;*/
    /**
     * <p>QR Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one QR Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 18004:2006, 6.4.3 - 6.4.7</p>
     *
     * @author Sean Owen
     */
    class DecodedBitStreamParser$1 {
        static decode(bytes, version, ecLevel, hints) {
            const bits = new BitSource(bytes);
            let result = new StringBuilder();
            const byteSegments = new Array(); // 1
            // TYPESCRIPTPORT: I do not use constructor with size 1 as in original Java means capacity and the array length is checked below
            let symbolSequence = -1;
            let parityData = -1;
            try {
                let currentCharacterSetECI = null;
                let fc1InEffect = false;
                let mode;
                do {
                    // While still another segment to read...
                    if (bits.available() < 4) {
                        // OK, assume we're done. Really, a TERMINATOR mode should have been recorded here
                        mode = Mode$1.TERMINATOR;
                    }
                    else {
                        const modeBits = bits.readBits(4);
                        mode = Mode$1.forBits(modeBits); // mode is encoded by 4 bits
                    }
                    switch (mode) {
                        case Mode$1.TERMINATOR:
                            break;
                        case Mode$1.FNC1_FIRST_POSITION:
                        case Mode$1.FNC1_SECOND_POSITION:
                            // We do little with FNC1 except alter the parsed result a bit according to the spec
                            fc1InEffect = true;
                            break;
                        case Mode$1.STRUCTURED_APPEND:
                            if (bits.available() < 16) {
                                throw new FormatException();
                            }
                            // sequence number and parity is added later to the result metadata
                            // Read next 8 bits (symbol sequence #) and 8 bits (data: parity), then continue
                            symbolSequence = bits.readBits(8);
                            parityData = bits.readBits(8);
                            break;
                        case Mode$1.ECI:
                            // Count doesn't apply to ECI
                            const value = DecodedBitStreamParser$1.parseECIValue(bits);
                            currentCharacterSetECI = CharacterSetECI.getCharacterSetECIByValue(value);
                            if (currentCharacterSetECI === null) {
                                throw new FormatException();
                            }
                            break;
                        case Mode$1.HANZI:
                            // First handle Hanzi mode which does not start with character count
                            // Chinese mode contains a sub set indicator right after mode indicator
                            const subset = bits.readBits(4);
                            const countHanzi = bits.readBits(mode.getCharacterCountBits(version));
                            if (subset === DecodedBitStreamParser$1.GB2312_SUBSET) {
                                DecodedBitStreamParser$1.decodeHanziSegment(bits, result, countHanzi);
                            }
                            break;
                        default:
                            // "Normal" QR code modes:
                            // How many characters will follow, encoded in this mode?
                            const count = bits.readBits(mode.getCharacterCountBits(version));
                            switch (mode) {
                                case Mode$1.NUMERIC:
                                    DecodedBitStreamParser$1.decodeNumericSegment(bits, result, count);
                                    break;
                                case Mode$1.ALPHANUMERIC:
                                    DecodedBitStreamParser$1.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                                    break;
                                case Mode$1.BYTE:
                                    DecodedBitStreamParser$1.decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints);
                                    break;
                                case Mode$1.KANJI:
                                    DecodedBitStreamParser$1.decodeKanjiSegment(bits, result, count);
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            break;
                    }
                } while (mode !== Mode$1.TERMINATOR);
            }
            catch (iae /*: IllegalArgumentException*/) {
                // from readBits() calls
                throw new FormatException();
            }
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
        }
        /**
         * See specification GBT 18284-2000
         */
        static decodeHanziSegment(bits, result, count /*int*/) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) {
                throw new FormatException();
            }
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as GB2312 afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while (count > 0) {
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = (((twoBytes / 0x060) << 8) & 0xFFFFFFFF) | (twoBytes % 0x060);
                if (assembledTwoBytes < 0x003BF) {
                    // In the 0xA1A1 to 0xAAFE range
                    assembledTwoBytes += 0x0A1A1;
                }
                else {
                    // In the 0xB0A1 to 0xFAFE range
                    assembledTwoBytes += 0x0A6A1;
                }
                buffer[offset] = /*(byte) */ ((assembledTwoBytes >> 8) & 0xFF);
                buffer[offset + 1] = /*(byte) */ (assembledTwoBytes & 0xFF);
                offset += 2;
                count--;
            }
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.GB2312));
                // TYPESCRIPTPORT: TODO: implement GB2312 decode. StringView from MDN could be a starting point
            }
            catch (ignored /*: UnsupportedEncodingException*/) {
                throw new FormatException(ignored);
            }
        }
        static decodeKanjiSegment(bits, result, count /*int*/) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) {
                throw new FormatException();
            }
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as Shift_JIS afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while (count > 0) {
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = (((twoBytes / 0x0C0) << 8) & 0xFFFFFFFF) | (twoBytes % 0x0C0);
                if (assembledTwoBytes < 0x01F00) {
                    // In the 0x8140 to 0x9FFC range
                    assembledTwoBytes += 0x08140;
                }
                else {
                    // In the 0xE040 to 0xEBBF range
                    assembledTwoBytes += 0x0C140;
                }
                buffer[offset] = /*(byte) */ (assembledTwoBytes >> 8);
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes;
                offset += 2;
                count--;
            }
            // Shift_JIS may not be supported in some environments:
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.SHIFT_JIS));
                // TYPESCRIPTPORT: TODO: implement SHIFT_JIS decode. StringView from MDN could be a starting point
            }
            catch (ignored /*: UnsupportedEncodingException*/) {
                throw new FormatException(ignored);
            }
        }
        static decodeByteSegment(bits, result, count /*int*/, currentCharacterSetECI, byteSegments, hints) {
            // Don't crash trying to read more bits than we have available.
            if (8 * count > bits.available()) {
                throw new FormatException();
            }
            const readBytes = new Uint8Array(count);
            for (let i = 0; i < count; i++) {
                readBytes[i] = /*(byte) */ bits.readBits(8);
            }
            let encoding;
            if (currentCharacterSetECI === null) {
                // The spec isn't clear on this mode; see
                // section 6.4.5: t does not say which encoding to assuming
                // upon decoding. I have seen ISO-8859-1 used as well as
                // Shift_JIS -- without anything like an ECI designator to
                // give a hint.
                encoding = StringUtils.guessEncoding(readBytes, hints);
            }
            else {
                encoding = currentCharacterSetECI.getName();
            }
            try {
                result.append(StringEncoding.decode(readBytes, encoding));
            }
            catch (ignored /*: UnsupportedEncodingException*/) {
                throw new FormatException(ignored);
            }
            byteSegments.push(readBytes);
        }
        static toAlphaNumericChar(value /*int*/) {
            if (value >= DecodedBitStreamParser$1.ALPHANUMERIC_CHARS.length) {
                throw new FormatException();
            }
            return DecodedBitStreamParser$1.ALPHANUMERIC_CHARS[value];
        }
        static decodeAlphanumericSegment(bits, result, count /*int*/, fc1InEffect) {
            // Read two characters at a time
            const start = result.length();
            while (count > 1) {
                if (bits.available() < 11) {
                    throw new FormatException();
                }
                const nextTwoCharsBits = bits.readBits(11);
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(nextTwoCharsBits % 45));
                count -= 2;
            }
            if (count === 1) {
                // special case: one character left
                if (bits.available() < 6) {
                    throw new FormatException();
                }
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(bits.readBits(6)));
            }
            // See section 6.4.8.1, 6.4.8.2
            if (fc1InEffect) {
                // We need to massage the result a bit if in an FNC1 mode:
                for (let i = start; i < result.length(); i++) {
                    if (result.charAt(i) === '%') {
                        if (i < result.length() - 1 && result.charAt(i + 1) === '%') {
                            // %% is rendered as %
                            result.deleteCharAt(i + 1);
                        }
                        else {
                            // In alpha mode, % should be converted to FNC1 separator 0x1D
                            result.setCharAt(i, String.fromCharCode(0x1D));
                        }
                    }
                }
            }
        }
        static decodeNumericSegment(bits, result, count /*int*/) {
            // Read three digits at a time
            while (count >= 3) {
                // Each 10 bits encodes three digits
                if (bits.available() < 10) {
                    throw new FormatException();
                }
                const threeDigitsBits = bits.readBits(10);
                if (threeDigitsBits >= 1000) {
                    throw new FormatException();
                }
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(threeDigitsBits % 10));
                count -= 3;
            }
            if (count === 2) {
                // Two digits left over to read, encoded in 7 bits
                if (bits.available() < 7) {
                    throw new FormatException();
                }
                const twoDigitsBits = bits.readBits(7);
                if (twoDigitsBits >= 100) {
                    throw new FormatException();
                }
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(twoDigitsBits % 10));
            }
            else if (count === 1) {
                // One digit left over to read
                if (bits.available() < 4) {
                    throw new FormatException();
                }
                const digitBits = bits.readBits(4);
                if (digitBits >= 10) {
                    throw new FormatException();
                }
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(digitBits));
            }
        }
        static parseECIValue(bits) {
            const firstByte = bits.readBits(8);
            if ((firstByte & 0x80) === 0) {
                // just one byte
                return firstByte & 0x7F;
            }
            if ((firstByte & 0xC0) === 0x80) {
                // two bytes
                const secondByte = bits.readBits(8);
                return (((firstByte & 0x3F) << 8) & 0xFFFFFFFF) | secondByte;
            }
            if ((firstByte & 0xE0) === 0xC0) {
                // three bytes
                const secondThirdBytes = bits.readBits(16);
                return (((firstByte & 0x1F) << 16) & 0xFFFFFFFF) | secondThirdBytes;
            }
            throw new FormatException();
        }
    }
    /**
     * See ISO 18004:2006, 6.4.4 Table 5
     */
    DecodedBitStreamParser$1.ALPHANUMERIC_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
    DecodedBitStreamParser$1.GB2312_SUBSET = 1;
    // function Uint8ArrayToString(a: Uint8Array): string {
    //     const CHUNK_SZ = 0x8000;
    //     const c = new StringBuilder();
    //     for (let i = 0, length = a.length; i < length; i += CHUNK_SZ) {
    //         c.append(String.fromCharCode.apply(null, a.subarray(i, i + CHUNK_SZ)));
    //     }
    //     return c.toString();
    // }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * Meta-data container for QR Code decoding. Instances of this class may be used to convey information back to the
     * decoding caller. Callers are expected to process this.
     *
     * @see com.google.zxing.common.DecoderResult#getOther()
     */
    class QRCodeDecoderMetaData {
        constructor(mirrored) {
            this.mirrored = mirrored;
        }
        /**
         * @return true if the QR Code was mirrored.
         */
        isMirrored() {
            return this.mirrored;
        }
        /**
         * Apply the result points' order correction due to mirroring.
         *
         * @param points Array of points to apply mirror correction to.
         */
        applyMirroredCorrection(points) {
            if (!this.mirrored || points === null || points.length < 3) {
                return;
            }
            const bottomLeft = points[0];
            points[0] = points[2];
            points[2] = bottomLeft;
            // No need to 'fix' top-left and alignment pattern.
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*import java.util.Map;*/
    /**
     * <p>The main class which implements QR Code decoding -- as opposed to locating and extracting
     * the QR Code from an image.</p>
     *
     * @author Sean Owen
     */
    class Decoder$2 {
        constructor() {
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
        }
        // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(image, null)
        // }
        /**
         * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
         * "true" is taken to mean a black module.</p>
         *
         * @param image booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */
        decodeBooleanArray(image, hints) {
            return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(image), hints);
        }
        // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(bits, null)
        // }
        /**
         * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
         *
         * @param bits booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */
        decodeBitMatrix(bits, hints) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser$1(bits);
            let ex = null;
            try {
                return this.decodeBitMatrixParser(parser, hints);
            }
            catch (e /*: FormatException, ChecksumException*/) {
                ex = e;
            }
            try {
                // Revert the bit matrix
                parser.remask();
                // Will be attempting a mirrored reading of the version and format info.
                parser.setMirror(true);
                // Preemptively read the version.
                parser.readVersion();
                // Preemptively read the format information.
                parser.readFormatInformation();
                /*
                 * Since we're here, this means we have successfully detected some kind
                 * of version and format information when mirrored. This is a good sign,
                 * that the QR code may be mirrored, and we should try once more with a
                 * mirrored content.
                 */
                // Prepare for a mirrored reading.
                parser.mirror();
                const result = this.decodeBitMatrixParser(parser, hints);
                // Success! Notify the caller that the code was mirrored.
                result.setOther(new QRCodeDecoderMetaData(true));
                return result;
            }
            catch (e /*FormatException | ChecksumException*/) {
                // Throw the exception from the original reading
                if (ex !== null) {
                    throw ex;
                }
                throw e;
            }
        }
        decodeBitMatrixParser(parser, hints) {
            const version = parser.readVersion();
            const ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock$1.getDataBlocks(codewords, version, ecLevel);
            // Count total number of data bytes
            let totalBytes = 0;
            for (const dataBlock of dataBlocks) {
                totalBytes += dataBlock.getNumDataCodewords();
            }
            const resultBytes = new Uint8Array(totalBytes);
            let resultOffset = 0;
            // Error-correct and copy data blocks together into a stream of bytes
            for (const dataBlock of dataBlocks) {
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for (let i = 0; i < numDataCodewords; i++) {
                    resultBytes[resultOffset++] = codewordBytes[i];
                }
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser$1.decode(resultBytes, version, ecLevel, hints);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */
        correctErrors(codewordBytes, numDataCodewords /*int*/) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // TYPESCRIPTPORT: not realy necessary to transform to ints? could redesign everything to work with unsigned bytes?
            // const codewordsInts = new Int32Array(numCodewords)
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            }
            catch (ignored /*: ReedSolomonException*/) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for (let i = 0; i < numDataCodewords; i++) {
                codewordBytes[i] = /*(byte) */ codewordsInts[i];
            }
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates an alignment pattern, which are the smaller square patterns found in
     * all but the simplest QR Codes.</p>
     *
     * @author Sean Owen
     */
    class AlignmentPattern extends ResultPoint {
        constructor(posX /*float*/, posY /*float*/, estimatedModuleSize /*float*/) {
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
        }
        /**
         * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */
        aboutEquals(moduleSize /*float*/, i /*float*/, j /*float*/) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
         */
        combineEstimate(i /*float*/, j /*float*/, newModuleSize /*float*/) {
            const combinedX = (this.getX() + j) / 2.0;
            const combinedY = (this.getY() + i) / 2.0;
            const combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2.0;
            return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*import java.util.ArrayList;*/
    /*import java.util.List;*/
    /**
     * <p>This class attempts to find alignment patterns in a QR Code. Alignment patterns look like finder
     * patterns but are smaller and appear at regular intervals throughout the image.</p>
     *
     * <p>At the moment this only looks for the bottom-right alignment pattern.</p>
     *
     * <p>This is mostly a simplified copy of {@link FinderPatternFinder}. It is copied,
     * pasted and stripped down here for maximum performance but does unfortunately duplicate
     * some code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.</p>
     *
     * @author Sean Owen
     */
    class AlignmentPatternFinder {
        /**
         * <p>Creates a finder that will look in a portion of the whole image.</p>
         *
         * @param image image to search
         * @param startX left column from which to start searching
         * @param startY top row from which to start searching
         * @param width width of region to search
         * @param height height of region to search
         * @param moduleSize estimated module size so far
         */
        constructor(image, startX /*int*/, startY /*int*/, width /*int*/, height /*int*/, moduleSize /*float*/, resultPointCallback) {
            this.image = image;
            this.startX = startX;
            this.startY = startY;
            this.width = width;
            this.height = height;
            this.moduleSize = moduleSize;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = []; // new Array<any>(5))
            // TYPESCRIPTPORT: array initialization without size as the length is checked below
            this.crossCheckStateCount = new Int32Array(3);
        }
        /**
         * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
         * it's pretty performance-critical and so is written to be fast foremost.</p>
         *
         * @return {@link AlignmentPattern} if found
         * @throws NotFoundException if not found
         */
        find() {
            const startX = this.startX;
            const height = this.height;
            const width = this.width;
            const maxJ = startX + width;
            const middleI = this.startY + (height / 2);
            // We are looking for black/white/black modules in 1:1:1 ratio
            // this tracks the number of black/white/black modules seen so far
            const stateCount = new Int32Array(3);
            const image = this.image;
            for (let iGen = 0; iGen < height; iGen++) {
                // Search from middle outwards
                const i = middleI + ((iGen & 0x01) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                let j = startX;
                // Burn off leading white pixels before anything else; if we start in the middle of
                // a white run, it doesn't make sense to count its length, since we don't know if the
                // white run continued to the left of the start point
                while (j < maxJ && !image.get(j, i)) {
                    j++;
                }
                let currentState = 0;
                while (j < maxJ) {
                    if (image.get(j, i)) {
                        // Black pixel
                        if (currentState === 1) { // Counting black pixels
                            stateCount[1]++;
                        }
                        else { // Counting white pixels
                            if (currentState === 2) { // A winner?
                                if (this.foundPatternCross(stateCount)) { // Yes
                                    const confirmed = this.handlePossibleCenter(stateCount, i, j);
                                    if (confirmed !== null) {
                                        return confirmed;
                                    }
                                }
                                stateCount[0] = stateCount[2];
                                stateCount[1] = 1;
                                stateCount[2] = 0;
                                currentState = 1;
                            }
                            else {
                                stateCount[++currentState]++;
                            }
                        }
                    }
                    else { // White pixel
                        if (currentState === 1) { // Counting black pixels
                            currentState++;
                        }
                        stateCount[currentState]++;
                    }
                    j++;
                }
                if (this.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
                    if (confirmed !== null) {
                        return confirmed;
                    }
                }
            }
            // Hmm, nothing we saw was observed and confirmed twice. If we had
            // any guess at all, return it.
            if (this.possibleCenters.length !== 0) {
                return this.possibleCenters[0];
            }
            throw new NotFoundException();
        }
        /**
         * Given a count of black/white/black pixels just seen and an end position,
         * figures the location of the center of this black/white/black run.
         */
        static centerFromEnd(stateCount, end /*int*/) {
            return (end - stateCount[2]) - stateCount[1] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
         *         used by alignment patterns to be considered a match
         */
        foundPatternCross(stateCount) {
            const moduleSize = this.moduleSize;
            const maxVariance = moduleSize / 2.0;
            for (let i = 0; i < 3; i++) {
                if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) {
                    return false;
                }
            }
            return true;
        }
        /**
         * <p>After a horizontal scan finds a potential alignment pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * alignment pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where an alignment pattern was detected
         * @param centerJ center of the section that appears to cross an alignment pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
         */
        crossCheckVertical(startI /*int*/, centerJ /*int*/, maxCount /*int*/, originalStateCountTotal /*int*/) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.crossCheckStateCount;
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            // Start counting up from center
            let i = startI;
            while (i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount) {
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) {
                return NaN;
            }
            while (i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount) {
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) {
                return NaN;
            }
            // Now also count down from center
            i = startI + 1;
            while (i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount) {
                stateCount[1]++;
                i++;
            }
            if (i === maxI || stateCount[1] > maxCount) {
                return NaN;
            }
            while (i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount) {
                stateCount[2]++;
                i++;
            }
            if (stateCount[2] > maxCount) {
                return NaN;
            }
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) {
                return NaN;
            }
            return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will see if this pattern had been
         * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
         * found the alignment pattern.</p>
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where alignment pattern may be found
         * @param j end of possible alignment pattern in row
         * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
         */
        handlePossibleCenter(stateCount, i /*int*/, j /*int*/) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            const centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
            const centerI = this.crossCheckVertical(i, /*(int) */ centerJ, 2 * stateCount[1], stateCountTotal);
            if (!isNaN(centerI)) {
                const estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3.0;
                for (const center of this.possibleCenters) {
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                        return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                    }
                }
                // Hadn't found this before; save it
                const point = new AlignmentPattern(centerJ, centerI, estimatedModuleSize);
                this.possibleCenters.push(point);
                if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) {
                    this.resultPointCallback.foundPossibleResultPoint(point);
                }
            }
            return null;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates a finder pattern, which are the three square patterns found in
     * the corners of QR Codes. It also encapsulates a count of similar finder patterns,
     * as a convenience to the finder's bookkeeping.</p>
     *
     * @author Sean Owen
     */
    class FinderPattern$1 extends ResultPoint {
        // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
        //   this(posX, posY, estimatedModuleSize, 1)
        // }
        constructor(posX /*float*/, posY /*float*/, estimatedModuleSize /*float*/, count /*int*/) {
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
            this.count = count;
            if (undefined === count) {
                this.count = 1;
            }
        }
        getEstimatedModuleSize() {
            return this.estimatedModuleSize;
        }
        getCount() {
            return this.count;
        }
        /*
        void incrementCount() {
          this.count++
        }
         */
        /**
         * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */
        aboutEquals(moduleSize /*float*/, i /*float*/, j /*float*/) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
         * based on count.
         */
        combineEstimate(i /*float*/, j /*float*/, newModuleSize /*float*/) {
            const combinedCount = this.count + 1;
            const combinedX = (this.count * this.getX() + j) / combinedCount;
            const combinedY = (this.count * this.getY() + i) / combinedCount;
            const combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
            return new FinderPattern$1(combinedX, combinedY, combinedModuleSize, combinedCount);
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>Encapsulates information about finder patterns in an image, including the location of
     * the three finder patterns, and their estimated module size.</p>
     *
     * @author Sean Owen
     */
    class FinderPatternInfo {
        constructor(patternCenters) {
            this.bottomLeft = patternCenters[0];
            this.topLeft = patternCenters[1];
            this.topRight = patternCenters[2];
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*import java.io.Serializable;*/
    /*import java.util.ArrayList;*/
    /*import java.util.Collections;*/
    /*import java.util.Comparator;*/
    /*import java.util.List;*/
    /*import java.util.Map;*/
    /**
     * <p>This class attempts to find finder patterns in a QR Code. Finder patterns are the square
     * markers at three corners of a QR Code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.
     *
     * @author Sean Owen
     */
    class FinderPatternFinder {
        /**
         * <p>Creates a finder that will search the image for three finder patterns.</p>
         *
         * @param image image to search
         */
        // public constructor(image: BitMatrix) {
        //   this(image, null)
        // }
        constructor(image, resultPointCallback) {
            this.image = image;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = [];
            this.crossCheckStateCount = new Int32Array(5);
            this.resultPointCallback = resultPointCallback;
        }
        getImage() {
            return this.image;
        }
        getPossibleCenters() {
            return this.possibleCenters;
        }
        find(hints) {
            const tryHarder = (hints !== null && hints !== undefined) && undefined !== hints.get(DecodeHintType$1.TRY_HARDER);
            const pureBarcode = (hints !== null && hints !== undefined) && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE);
            const image = this.image;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // We are looking for black/white/black/white/black modules in
            // 1:1:3:1:1 ratio; this tracks the number of such modules seen so far
            // Let's assume that the maximum version QR Code we support takes up 1/4 the height of the
            // image, and then account for the center being 3 modules in size. This gives the smallest
            // number of pixels the center could be, so skip this often. When trying harder, look for all
            // QR versions regardless of how dense they are.
            let iSkip = Math.floor((3 * maxI) / (4 * FinderPatternFinder.MAX_MODULES));
            if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) {
                iSkip = FinderPatternFinder.MIN_SKIP;
            }
            let done = false;
            const stateCount = new Int32Array(5);
            for (let i = iSkip - 1; i < maxI && !done; i += iSkip) {
                // Get a row of black/white values
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                stateCount[3] = 0;
                stateCount[4] = 0;
                let currentState = 0;
                for (let j = 0; j < maxJ; j++) {
                    if (image.get(j, i)) {
                        // Black pixel
                        if ((currentState & 1) === 1) { // Counting white pixels
                            currentState++;
                        }
                        stateCount[currentState]++;
                    }
                    else { // White pixel
                        if ((currentState & 1) === 0) { // Counting black pixels
                            if (currentState === 4) { // A winner?
                                if (FinderPatternFinder.foundPatternCross(stateCount)) { // Yes
                                    const confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                                    if (confirmed === true) {
                                        // Start examining every other line. Checking each line turned out to be too
                                        // expensive and didn't improve performance.
                                        iSkip = 2;
                                        if (this.hasSkipped === true) {
                                            done = this.haveMultiplyConfirmedCenters();
                                        }
                                        else {
                                            const rowSkip = this.findRowSkip();
                                            if (rowSkip > stateCount[2]) {
                                                // Skip rows between row of lower confirmed center
                                                // and top of presumed third confirmed center
                                                // but back up a bit to get a full chance of detecting
                                                // it, entire width of center of finder pattern
                                                // Skip by rowSkip, but back off by stateCount[2] (size of last center
                                                // of pattern we saw) to be conservative, and also back off by iSkip which
                                                // is about to be re-added
                                                i += rowSkip - stateCount[2] - iSkip;
                                                j = maxJ - 1;
                                            }
                                        }
                                    }
                                    else {
                                        stateCount[0] = stateCount[2];
                                        stateCount[1] = stateCount[3];
                                        stateCount[2] = stateCount[4];
                                        stateCount[3] = 1;
                                        stateCount[4] = 0;
                                        currentState = 3;
                                        continue;
                                    }
                                    // Clear state to start looking again
                                    currentState = 0;
                                    stateCount[0] = 0;
                                    stateCount[1] = 0;
                                    stateCount[2] = 0;
                                    stateCount[3] = 0;
                                    stateCount[4] = 0;
                                }
                                else { // No, shift counts back by two
                                    stateCount[0] = stateCount[2];
                                    stateCount[1] = stateCount[3];
                                    stateCount[2] = stateCount[4];
                                    stateCount[3] = 1;
                                    stateCount[4] = 0;
                                    currentState = 3;
                                }
                            }
                            else {
                                stateCount[++currentState]++;
                            }
                        }
                        else { // Counting white pixels
                            stateCount[currentState]++;
                        }
                    }
                }
                if (FinderPatternFinder.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
                    if (confirmed === true) {
                        iSkip = stateCount[0];
                        if (this.hasSkipped) {
                            // Found a third one
                            done = this.haveMultiplyConfirmedCenters();
                        }
                    }
                }
            }
            const patternInfo = this.selectBestPatterns();
            ResultPoint.orderBestPatterns(patternInfo);
            return new FinderPatternInfo(patternInfo);
        }
        /**
         * Given a count of black/white/black/white/black pixels just seen and an end position,
         * figures the location of the center of this run.
         */
        static centerFromEnd(stateCount, end /*int*/) {
            return (end - stateCount[4] - stateCount[3]) - stateCount[2] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
         *         used by finder patterns to be considered a match
         */
        static foundPatternCross(stateCount) {
            let totalModuleSize = 0;
            for (let i = 0; i < 5; i++) {
                const count = stateCount[i];
                if (count === 0) {
                    return false;
                }
                totalModuleSize += count;
            }
            if (totalModuleSize < 7) {
                return false;
            }
            const moduleSize = totalModuleSize / 7.0;
            const maxVariance = moduleSize / 2.0;
            // Allow less than 50% variance from 1-1-3-1-1 proportions
            return Math.abs(moduleSize - stateCount[0]) < maxVariance &&
                Math.abs(moduleSize - stateCount[1]) < maxVariance &&
                Math.abs(3.0 * moduleSize - stateCount[2]) < 3 * maxVariance &&
                Math.abs(moduleSize - stateCount[3]) < maxVariance &&
                Math.abs(moduleSize - stateCount[4]) < maxVariance;
        }
        getCrossCheckStateCount() {
            const crossCheckStateCount = this.crossCheckStateCount;
            crossCheckStateCount[0] = 0;
            crossCheckStateCount[1] = 0;
            crossCheckStateCount[2] = 0;
            crossCheckStateCount[3] = 0;
            crossCheckStateCount[4] = 0;
            return crossCheckStateCount;
        }
        /**
         * After a vertical and horizontal scan finds a potential finder pattern, this method
         * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
         * finder pattern to see if the same proportion is detected.
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         *  observed in any reading state, based on the results of the horizontal scan
         * @param originalStateCountTotal The original state count total.
         * @return true if proportions are withing expected limits
         */
        crossCheckDiagonal(startI /*int*/, centerJ /*int*/, maxCount /*int*/, originalStateCountTotal /*int*/) {
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up, left from center finding black center mass
            let i = 0;
            const image = this.image;
            while (startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)) {
                stateCount[2]++;
                i++;
            }
            if (startI < i || centerJ < i) {
                return false;
            }
            // Continue up, left finding white space
            while (startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) &&
                stateCount[1] <= maxCount) {
                stateCount[1]++;
                i++;
            }
            // If already too many modules in this state or ran off the edge:
            if (startI < i || centerJ < i || stateCount[1] > maxCount) {
                return false;
            }
            // Continue up, left finding black border
            while (startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) &&
                stateCount[0] <= maxCount) {
                stateCount[0]++;
                i++;
            }
            if (stateCount[0] > maxCount) {
                return false;
            }
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // Now also count down, right from center
            i = 1;
            while (startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)) {
                stateCount[2]++;
                i++;
            }
            // Ran off the edge?
            if (startI + i >= maxI || centerJ + i >= maxJ) {
                return false;
            }
            while (startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) &&
                stateCount[3] < maxCount) {
                stateCount[3]++;
                i++;
            }
            if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) {
                return false;
            }
            while (startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) &&
                stateCount[4] < maxCount) {
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) {
                return false;
            }
            // If we found a finder-pattern-like section, but its size is more than 100% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal &&
                FinderPatternFinder.foundPatternCross(stateCount);
        }
        /**
         * <p>After a horizontal scan finds a potential finder pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * finder pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of finder pattern, or {@link Float#NaN} if not found
         */
        crossCheckVertical(startI /*int*/, centerJ /*int*/, maxCount /*int*/, originalStateCountTotal /*int*/) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up from center
            let i = startI;
            while (i >= 0 && image.get(centerJ, i)) {
                stateCount[2]++;
                i--;
            }
            if (i < 0) {
                return NaN;
            }
            while (i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount) {
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) {
                return NaN;
            }
            while (i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount) {
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) {
                return NaN;
            }
            // Now also count down from center
            i = startI + 1;
            while (i < maxI && image.get(centerJ, i)) {
                stateCount[2]++;
                i++;
            }
            if (i === maxI) {
                return NaN;
            }
            while (i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount) {
                stateCount[3]++;
                i++;
            }
            if (i === maxI || stateCount[3] >= maxCount) {
                return NaN;
            }
            while (i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount) {
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) {
                return NaN;
            }
            // If we found a finder-pattern-like section, but its size is more than 40% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] +
                stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) {
                return NaN;
            }
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
         * except it reads horizontally instead of vertically. This is used to cross-cross
         * check a vertical cross check and locate the real center of the alignment pattern.</p>
         */
        crossCheckHorizontal(startJ /*int*/, centerI /*int*/, maxCount /*int*/, originalStateCountTotal /*int*/) {
            const image = this.image;
            const maxJ = image.getWidth();
            const stateCount = this.getCrossCheckStateCount();
            let j = startJ;
            while (j >= 0 && image.get(j, centerI)) {
                stateCount[2]++;
                j--;
            }
            if (j < 0) {
                return NaN;
            }
            while (j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount) {
                stateCount[1]++;
                j--;
            }
            if (j < 0 || stateCount[1] > maxCount) {
                return NaN;
            }
            while (j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount) {
                stateCount[0]++;
                j--;
            }
            if (stateCount[0] > maxCount) {
                return NaN;
            }
            j = startJ + 1;
            while (j < maxJ && image.get(j, centerI)) {
                stateCount[2]++;
                j++;
            }
            if (j === maxJ) {
                return NaN;
            }
            while (j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount) {
                stateCount[3]++;
                j++;
            }
            if (j === maxJ || stateCount[3] >= maxCount) {
                return NaN;
            }
            while (j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount) {
                stateCount[4]++;
                j++;
            }
            if (stateCount[4] >= maxCount) {
                return NaN;
            }
            // If we found a finder-pattern-like section, but its size is significantly different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] +
                stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) {
                return NaN;
            }
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
         * with another horizontal scan. This is needed primarily to locate the real horizontal
         * center of the pattern in cases of extreme skew.
         * And then we cross-cross-cross check with another diagonal scan.</p>
         *
         * <p>If that succeeds the finder pattern location is added to a list that tracks
         * the number of times each location has been nearly-matched as a finder pattern.
         * Each additional find is more evidence that the location is in fact a finder
         * pattern center
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where finder pattern may be found
         * @param j end of possible finder pattern in row
         * @param pureBarcode true if in "pure barcode" mode
         * @return true if a finder pattern candidate was found this time
         */
        handlePossibleCenter(stateCount, i /*int*/, j /*int*/, pureBarcode) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] +
                stateCount[4];
            let centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
            let centerI = this.crossCheckVertical(i, /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal);
            if (!isNaN(centerI)) {
                // Re-cross check
                centerJ = this.crossCheckHorizontal(/*(int) */ Math.floor(centerJ), /*(int) */ Math.floor(centerI), stateCount[2], stateCountTotal);
                if (!isNaN(centerJ) &&
                    (!pureBarcode || this.crossCheckDiagonal(/*(int) */ Math.floor(centerI), /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal))) {
                    const estimatedModuleSize = stateCountTotal / 7.0;
                    let found = false;
                    const possibleCenters = this.possibleCenters;
                    for (let index = 0, length = possibleCenters.length; index < length; index++) {
                        const center = possibleCenters[index];
                        // Look for about the same center and module size:
                        if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                            possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        const point = new FinderPattern$1(centerJ, centerI, estimatedModuleSize);
                        possibleCenters.push(point);
                        if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) {
                            this.resultPointCallback.foundPossibleResultPoint(point);
                        }
                    }
                    return true;
                }
            }
            return false;
        }
        /**
         * @return number of rows we could safely skip during scanning, based on the first
         *         two finder patterns that have been located. In some cases their position will
         *         allow us to infer that the third pattern must lie below a certain point farther
         *         down in the image.
         */
        findRowSkip() {
            const max = this.possibleCenters.length;
            if (max <= 1) {
                return 0;
            }
            let firstConfirmedCenter = null;
            for (const center of this.possibleCenters) {
                if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                    if (firstConfirmedCenter == null) {
                        firstConfirmedCenter = center;
                    }
                    else {
                        // We have two confirmed centers
                        // How far down can we skip before resuming looking for the next
                        // pattern? In the worst case, only the difference between the
                        // difference in the x / y coordinates of the two centers.
                        // This is the case where you find top left last.
                        this.hasSkipped = true;
                        return /*(int) */ Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) -
                            Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2);
                    }
                }
            }
            return 0;
        }
        /**
         * @return true iff we have found at least 3 finder patterns that have been detected
         *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
         *         candidates is "pretty similar"
         */
        haveMultiplyConfirmedCenters() {
            let confirmedCount = 0;
            let totalModuleSize = 0.0;
            const max = this.possibleCenters.length;
            for (const pattern of this.possibleCenters) {
                if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                    confirmedCount++;
                    totalModuleSize += pattern.getEstimatedModuleSize();
                }
            }
            if (confirmedCount < 3) {
                return false;
            }
            // OK, we have at least 3 confirmed centers, but, it's possible that one is a "false positive"
            // and that we need to keep looking. We detect this by asking if the estimated module sizes
            // vary too much. We arbitrarily say that when the total deviation from average exceeds
            // 5% of the total module size estimates, it's too much.
            const average = totalModuleSize / max;
            let totalDeviation = 0.0;
            for (const pattern of this.possibleCenters) {
                totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
            }
            return totalDeviation <= 0.05 * totalModuleSize;
        }
        /**
         * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
         *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
         *         size differs from the average among those patterns the least
         * @throws NotFoundException if 3 such finder patterns do not exist
         */
        selectBestPatterns() {
            const startSize = this.possibleCenters.length;
            if (startSize < 3) {
                // Couldn't find enough finder patterns
                throw new NotFoundException();
            }
            const possibleCenters = this.possibleCenters;
            let average;
            // Filter outlier possibilities whose module size is too different
            if (startSize > 3) {
                // But we can only afford to do so if we have at least 4 possibilities to choose from
                let totalModuleSize = 0.0;
                let square = 0.0;
                for (const center of this.possibleCenters) {
                    const size = center.getEstimatedModuleSize();
                    totalModuleSize += size;
                    square += size * size;
                }
                average = totalModuleSize / startSize;
                let stdDev = Math.sqrt(square / startSize - average * average);
                possibleCenters.sort(
                /**
                 * <p>Orders by furthest from average</p>
                 */
                // FurthestFromAverageComparator implements Comparator<FinderPattern>
                (center1, center2) => {
                    const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                    const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                    return dA < dB ? -1 : dA > dB ? 1 : 0;
                });
                const limit = Math.max(0.2 * average, stdDev);
                for (let i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++) {
                    const pattern = possibleCenters[i];
                    if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
                        possibleCenters.splice(i, 1);
                        i--;
                    }
                }
            }
            if (possibleCenters.length > 3) {
                // Throw away all but those first size candidate points we found.
                let totalModuleSize = 0.0;
                for (const possibleCenter of possibleCenters) {
                    totalModuleSize += possibleCenter.getEstimatedModuleSize();
                }
                average = totalModuleSize / possibleCenters.length;
                possibleCenters.sort(
                /**
                 * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
                 */
                // CenterComparator implements Comparator<FinderPattern>
                (center1, center2) => {
                    if (center2.getCount() === center1.getCount()) {
                        const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                        const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                        return dA < dB ? 1 : dA > dB ? -1 : 0;
                    }
                    else {
                        return center2.getCount() - center1.getCount();
                    }
                });
                possibleCenters.splice(3); // this is not realy necessary as we only return first 3 anyway
            }
            return [
                possibleCenters[0],
                possibleCenters[1],
                possibleCenters[2]
            ];
        }
    }
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3; // 1 pixel/module times 3 modules/center
    FinderPatternFinder.MAX_MODULES = 57; // support up to version 10 for mobile clients

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*import java.util.Map;*/
    /**
     * <p>Encapsulates logic that can detect a QR Code in an image, even if the QR Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */
    class Detector$2 {
        constructor(image) {
            this.image = image;
        }
        getImage() {
            return this.image;
        }
        getResultPointCallback() {
            return this.resultPointCallback;
        }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */
        // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
        //   return detect(null)
        // }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @param hints optional hints to detector
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */
        detect(hints) {
            this.resultPointCallback = (hints === null || hints === undefined) ? null :
                /*(ResultPointCallback) */ hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            const finder = new FinderPatternFinder(this.image, this.resultPointCallback);
            const info = finder.find(hints);
            return this.processFinderPatternInfo(info);
        }
        processFinderPatternInfo(info) {
            const topLeft = info.getTopLeft();
            const topRight = info.getTopRight();
            const bottomLeft = info.getBottomLeft();
            const moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
            if (moduleSize < 1.0) {
                throw new NotFoundException('No pattern found in proccess finder.');
            }
            const dimension = Detector$2.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
            const provisionalVersion = Version$1.getProvisionalVersionForDimension(dimension);
            const modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
            let alignmentPattern = null;
            // Anything above version 1 has an alignment pattern
            if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
                // Guess where a "bottom right" finder pattern would have been
                const bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                const bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                // Estimate that alignment pattern is closer by 3 modules
                // from "bottom right" to known top left location
                const correctionToTopLeft = 1.0 - 3.0 / modulesBetweenFPCenters;
                const estAlignmentX = /*(int) */ Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()));
                const estAlignmentY = /*(int) */ Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()));
                // Kind of arbitrary -- expand search radius before giving up
                for (let i = 4; i <= 16; i <<= 1) {
                    try {
                        alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
                        break;
                    }
                    catch (re /*NotFoundException*/) {
                        if (!(re instanceof NotFoundException)) {
                            throw re;
                        }
                        // try next round
                    }
                }
                // If we didn't find alignment pattern... well try anyway without it
            }
            const transform = Detector$2.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
            const bits = Detector$2.sampleGrid(this.image, transform, dimension);
            let points;
            if (alignmentPattern === null) {
                points = [bottomLeft, topLeft, topRight];
            }
            else {
                points = [bottomLeft, topLeft, topRight, alignmentPattern];
            }
            return new DetectorResult(bits, points);
        }
        static createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension /*int*/) {
            const dimMinusThree = dimension - 3.5;
            let bottomRightX; /*float*/
            let bottomRightY; /*float*/
            let sourceBottomRightX; /*float*/
            let sourceBottomRightY; /*float*/
            if (alignmentPattern !== null) {
                bottomRightX = alignmentPattern.getX();
                bottomRightY = alignmentPattern.getY();
                sourceBottomRightX = dimMinusThree - 3.0;
                sourceBottomRightY = sourceBottomRightX;
            }
            else {
                // Don't have an alignment pattern, just make up the bottom-right point
                bottomRightX = (topRight.getX() - topLeft.getX()) + bottomLeft.getX();
                bottomRightY = (topRight.getY() - topLeft.getY()) + bottomLeft.getY();
                sourceBottomRightX = dimMinusThree;
                sourceBottomRightY = dimMinusThree;
            }
            return PerspectiveTransform.quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
        }
        static sampleGrid(image, transform, dimension /*int*/) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
        }
        /**
         * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
         * of the finder patterns and estimated module size.</p>
         */
        static computeDimension(topLeft, topRight, bottomLeft, moduleSize /*float*/) {
            const tltrCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, topRight) / moduleSize);
            const tlblCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, bottomLeft) / moduleSize);
            let dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
            switch (dimension & 0x03) { // mod 4
                case 0:
                    dimension++;
                    break;
                // 1? do nothing
                case 2:
                    dimension--;
                    break;
                case 3:
                    throw new NotFoundException('Dimensions could be not found.');
            }
            return dimension;
        }
        /**
         * <p>Computes an average estimated module size based on estimated derived from the positions
         * of the three finder patterns.</p>
         *
         * @param topLeft detected top-left finder pattern center
         * @param topRight detected top-right finder pattern center
         * @param bottomLeft detected bottom-left finder pattern center
         * @return estimated module size
         */
        calculateModuleSize(topLeft, topRight, bottomLeft) {
            // Take the average
            return (this.calculateModuleSizeOneWay(topLeft, topRight) +
                this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2.0;
        }
        /**
         * <p>Estimates module size based on two finder patterns -- it uses
         * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
         * width of each, measuring along the axis between their centers.</p>
         */
        calculateModuleSizeOneWay(pattern, otherPattern) {
            const moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(pattern.getX()), 
            /*(int) */ Math.floor(pattern.getY()), 
            /*(int) */ Math.floor(otherPattern.getX()), 
            /*(int) */ Math.floor(otherPattern.getY()));
            const moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(otherPattern.getX()), 
            /*(int) */ Math.floor(otherPattern.getY()), 
            /*(int) */ Math.floor(pattern.getX()), 
            /*(int) */ Math.floor(pattern.getY()));
            if (isNaN(moduleSizeEst1)) {
                return moduleSizeEst2 / 7.0;
            }
            if (isNaN(moduleSizeEst2)) {
                return moduleSizeEst1 / 7.0;
            }
            // Average them, and divide by 7 since we've counted the width of 3 black modules,
            // and 1 white and 1 black module on either side. Ergo, divide sum by 14.
            return (moduleSizeEst1 + moduleSizeEst2) / 14.0;
        }
        /**
         * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
         * a finder pattern by looking for a black-white-black run from the center in the direction
         * of another point (another finder pattern center), and in the opposite direction too.
         */
        sizeOfBlackWhiteBlackRunBothWays(fromX /*int*/, fromY /*int*/, toX /*int*/, toY /*int*/) {
            let result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
            // Now count other way -- don't run off image though of course
            let scale = 1.0;
            let otherToX = fromX - (toX - fromX);
            if (otherToX < 0) {
                scale = fromX / /*(float) */ (fromX - otherToX);
                otherToX = 0;
            }
            else if (otherToX >= this.image.getWidth()) {
                scale = (this.image.getWidth() - 1 - fromX) / /*(float) */ (otherToX - fromX);
                otherToX = this.image.getWidth() - 1;
            }
            let otherToY = /*(int) */ Math.floor(fromY - (toY - fromY) * scale);
            scale = 1.0;
            if (otherToY < 0) {
                scale = fromY / /*(float) */ (fromY - otherToY);
                otherToY = 0;
            }
            else if (otherToY >= this.image.getHeight()) {
                scale = (this.image.getHeight() - 1 - fromY) / /*(float) */ (otherToY - fromY);
                otherToY = this.image.getHeight() - 1;
            }
            otherToX = /*(int) */ Math.floor(fromX + (otherToX - fromX) * scale);
            result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
            // Middle pixel is double-counted this way; subtract 1
            return result - 1.0;
        }
        /**
         * <p>This method traces a line from a point in the image, in the direction towards another point.
         * It begins in a black region, and keeps going until it finds white, then black, then white again.
         * It reports the distance from the start to this point.</p>
         *
         * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
         * may be skewed or rotated.</p>
         */
        sizeOfBlackWhiteBlackRun(fromX /*int*/, fromY /*int*/, toX /*int*/, toY /*int*/) {
            // Mild variant of Bresenham's algorithm
            // see http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            const steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            const dx = Math.abs(toX - fromX);
            const dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            const xstep = fromX < toX ? 1 : -1;
            const ystep = fromY < toY ? 1 : -1;
            // In black pixels, looking for white, first or second time.
            let state = 0;
            // Loop up until x == toX, but not beyond
            const xLimit = toX + xstep;
            for (let x = fromX, y = fromY; x !== xLimit; x += xstep) {
                const realX = steep ? y : x;
                const realY = steep ? x : y;
                // Does current pixel mean we have moved white to black or vice versa?
                // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                // color, advance to next state or end if we are in state 2 already
                if ((state === 1) === this.image.get(realX, realY)) {
                    if (state === 2) {
                        return MathUtils.distance(x, y, fromX, fromY);
                    }
                    state++;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) {
                        break;
                    }
                    y += ystep;
                    error -= dx;
                }
            }
            // Found black-white-black; give the benefit of the doubt that the next pixel outside the image
            // is "white" so this last point at (toX+xStep,toY) is the right ending. This is really a
            // small approximation; (toX+xStep,toY+yStep) might be really correct. Ignore this.
            if (state === 2) {
                return MathUtils.distance(toX + xstep, toY, fromX, fromY);
            }
            // else we didn't find even black-white-black; no estimate is really possible
            return NaN;
        }
        /**
         * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
         * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
         *
         * @param overallEstModuleSize estimated module size so far
         * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
         * @param estAlignmentY y coordinate of above
         * @param allowanceFactor number of pixels in all directions to search from the center
         * @return {@link AlignmentPattern} if found, or null otherwise
         * @throws NotFoundException if an unexpected error occurs during detection
         */
        findAlignmentInRegion(overallEstModuleSize /*float*/, estAlignmentX /*int*/, estAlignmentY /*int*/, allowanceFactor /*float*/) {
            // Look for an alignment pattern (3 modules in size) around where it
            // should be
            const allowance = /*(int) */ Math.floor(allowanceFactor * overallEstModuleSize);
            const alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
            const alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
            if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) {
                throw new NotFoundException('Alignment top exceeds estimated module size.');
            }
            const alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
            const alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
            if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) {
                throw new NotFoundException('Alignment bottom exceeds estimated module size.');
            }
            const alignmentFinder = new AlignmentPatternFinder(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
            return alignmentFinder.find();
        }
    }

    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*import java.util.List;*/
    /*import java.util.Map;*/
    /**
     * This implementation can detect and decode QR Codes in an image.
     *
     * @author Sean Owen
     */
    class QRCodeReader {
        constructor() {
            this.decoder = new Decoder$2();
        }
        getDecoder() {
            return this.decoder;
        }
        /**
         * Locates and decodes a QR code in an image.
         *
         * @return a representing: string the content encoded by the QR code
         * @throws NotFoundException if a QR code cannot be found
         * @throws FormatException if a QR code cannot be decoded
         * @throws ChecksumException if error correction fails
         */
        /*@Override*/
        // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
        //   return this.decode(image, null)
        // }
        /*@Override*/
        decode(image, hints) {
            let decoderResult;
            let points;
            if (hints !== undefined && hints !== null && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE)) {
                const bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decodeBitMatrix(bits, hints);
                points = QRCodeReader.NO_POINTS;
            }
            else {
                const detectorResult = new Detector$2(image.getBlackMatrix()).detect(hints);
                decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
                points = detectorResult.getPoints();
            }
            // If the code was mirrored: swap the bottom-left and the top-right points.
            if (decoderResult.getOther() instanceof QRCodeDecoderMetaData) {
                decoderResult.getOther().applyMirroredCorrection(points);
            }
            const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.QR_CODE, undefined);
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments !== null) {
                result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            }
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel !== null) {
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            }
            if (decoderResult.hasStructuredAppend()) {
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
            }
            return result;
        }
        /*@Override*/
        reset() {
            // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
         */
        static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack === null || rightBottomBlack === null) {
                throw new NotFoundException();
            }
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            let bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            let right = rightBottomBlack[0];
            // Sanity check!
            if (left >= right || top >= bottom) {
                throw new NotFoundException();
            }
            if (bottom - top !== right - left) {
                // Special case, where bottom-right module wasn't black so we found something else in the last row
                // Assume it's a square, so use height as the width
                right = left + (bottom - top);
                if (right >= image.getWidth()) {
                    // Abort if that would not make sense -- off image
                    throw new NotFoundException();
                }
            }
            const matrixWidth = Math.round((right - left + 1) / moduleSize);
            const matrixHeight = Math.round((bottom - top + 1) / moduleSize);
            if (matrixWidth <= 0 || matrixHeight <= 0) {
                throw new NotFoundException();
            }
            if (matrixHeight !== matrixWidth) {
                // Only possibly decode square regions
                throw new NotFoundException();
            }
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = /*(int) */ Math.floor(moduleSize / 2.0);
            top += nudge;
            left += nudge;
            // But careful that this does not sample off the edge
            // "right" is the farthest-right valid pixel location -- right+1 is not necessarily
            // This is positive by how much the inner x loop below would be too large
            const nudgedTooFarRight = left + /*(int) */ Math.floor((matrixWidth - 1) * moduleSize) - right;
            if (nudgedTooFarRight > 0) {
                if (nudgedTooFarRight > nudge) {
                    // Neither way fits; abort
                    throw new NotFoundException();
                }
                left -= nudgedTooFarRight;
            }
            // See logic above
            const nudgedTooFarDown = top + /*(int) */ Math.floor((matrixHeight - 1) * moduleSize) - bottom;
            if (nudgedTooFarDown > 0) {
                if (nudgedTooFarDown > nudge) {
                    // Neither way fits; abort
                    throw new NotFoundException();
                }
                top -= nudgedTooFarDown;
            }
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for (let y = 0; y < matrixHeight; y++) {
                const iOffset = top + /*(int) */ Math.floor(y * moduleSize);
                for (let x = 0; x < matrixWidth; x++) {
                    if (image.get(left + /*(int) */ Math.floor(x * moduleSize), iOffset)) {
                        bits.set(x, y);
                    }
                }
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const height = image.getHeight();
            const width = image.getWidth();
            let x = leftTopBlack[0];
            let y = leftTopBlack[1];
            let inBlack = true;
            let transitions = 0;
            while (x < width && y < height) {
                if (inBlack !== image.get(x, y)) {
                    if (++transitions === 5) {
                        break;
                    }
                    inBlack = !inBlack;
                }
                x++;
                y++;
            }
            if (x === width || y === height) {
                throw new NotFoundException();
            }
            return (x - leftTopBlack[0]) / 7.0;
        }
    }
    QRCodeReader.NO_POINTS = new Array();

    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */
    /*public final*/ class PDF417Common {
        PDF417Common() {
        }
        /**
         * @param moduleBitCount values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */
        // @Deprecated
        static getBitCountSum(moduleBitCount) {
            return MathUtils.sum(moduleBitCount);
        }
        static toIntArray(list) {
            if (list == null || !list.length) {
                return PDF417Common.EMPTY_INT_ARRAY;
            }
            const result = new Int32Array(list.length);
            let i = 0;
            for (const integer of list) {
                result[i++] = integer;
            }
            return result;
        }
        /**
         * @param symbol encoded symbol to translate to a codeword
         * @return the codeword corresponding to the symbol.
         */
        static getCodeword(symbol /*int*/) {
            const i = Arrays.binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 0x3FFFF);
            if (i < 0) {
                return -1;
            }
            return (PDF417Common.CODEWORD_TABLE[i] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
        }
    }
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    // Maximum Codewords (Data + Error).
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    // One left row indication column + max 30 data columns + one right row indicator column
    // public static /*final*/ MAX_CODEWORDS_IN_ROW: /*int*/ number = 32;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    /**
     * The sorted table of all possible symbols. Extracted from the PDF417
     * specification. The index of a symbol in this table corresponds to the
     * index into the codeword table.
     */
    PDF417Common.SYMBOL_TABLE = Int32Array.from([
        0x1025e, 0x1027a, 0x1029e, 0x102bc, 0x102f2, 0x102f4, 0x1032e, 0x1034e, 0x1035c, 0x10396, 0x103a6, 0x103ac,
        0x10422, 0x10428, 0x10436, 0x10442, 0x10444, 0x10448, 0x10450, 0x1045e, 0x10466, 0x1046c, 0x1047a, 0x10482,
        0x1049e, 0x104a0, 0x104bc, 0x104c6, 0x104d8, 0x104ee, 0x104f2, 0x104f4, 0x10504, 0x10508, 0x10510, 0x1051e,
        0x10520, 0x1053c, 0x10540, 0x10578, 0x10586, 0x1058c, 0x10598, 0x105b0, 0x105be, 0x105ce, 0x105dc, 0x105e2,
        0x105e4, 0x105e8, 0x105f6, 0x1062e, 0x1064e, 0x1065c, 0x1068e, 0x1069c, 0x106b8, 0x106de, 0x106fa, 0x10716,
        0x10726, 0x1072c, 0x10746, 0x1074c, 0x10758, 0x1076e, 0x10792, 0x10794, 0x107a2, 0x107a4, 0x107a8, 0x107b6,
        0x10822, 0x10828, 0x10842, 0x10848, 0x10850, 0x1085e, 0x10866, 0x1086c, 0x1087a, 0x10882, 0x10884, 0x10890,
        0x1089e, 0x108a0, 0x108bc, 0x108c6, 0x108cc, 0x108d8, 0x108ee, 0x108f2, 0x108f4, 0x10902, 0x10908, 0x1091e,
        0x10920, 0x1093c, 0x10940, 0x10978, 0x10986, 0x10998, 0x109b0, 0x109be, 0x109ce, 0x109dc, 0x109e2, 0x109e4,
        0x109e8, 0x109f6, 0x10a08, 0x10a10, 0x10a1e, 0x10a20, 0x10a3c, 0x10a40, 0x10a78, 0x10af0, 0x10b06, 0x10b0c,
        0x10b18, 0x10b30, 0x10b3e, 0x10b60, 0x10b7c, 0x10b8e, 0x10b9c, 0x10bb8, 0x10bc2, 0x10bc4, 0x10bc8, 0x10bd0,
        0x10bde, 0x10be6, 0x10bec, 0x10c2e, 0x10c4e, 0x10c5c, 0x10c62, 0x10c64, 0x10c68, 0x10c76, 0x10c8e, 0x10c9c,
        0x10cb8, 0x10cc2, 0x10cc4, 0x10cc8, 0x10cd0, 0x10cde, 0x10ce6, 0x10cec, 0x10cfa, 0x10d0e, 0x10d1c, 0x10d38,
        0x10d70, 0x10d7e, 0x10d82, 0x10d84, 0x10d88, 0x10d90, 0x10d9e, 0x10da0, 0x10dbc, 0x10dc6, 0x10dcc, 0x10dd8,
        0x10dee, 0x10df2, 0x10df4, 0x10e16, 0x10e26, 0x10e2c, 0x10e46, 0x10e58, 0x10e6e, 0x10e86, 0x10e8c, 0x10e98,
        0x10eb0, 0x10ebe, 0x10ece, 0x10edc, 0x10f0a, 0x10f12, 0x10f14, 0x10f22, 0x10f28, 0x10f36, 0x10f42, 0x10f44,
        0x10f48, 0x10f50, 0x10f5e, 0x10f66, 0x10f6c, 0x10fb2, 0x10fb4, 0x11022, 0x11028, 0x11042, 0x11048, 0x11050,
        0x1105e, 0x1107a, 0x11082, 0x11084, 0x11090, 0x1109e, 0x110a0, 0x110bc, 0x110c6, 0x110cc, 0x110d8, 0x110ee,
        0x110f2, 0x110f4, 0x11102, 0x1111e, 0x11120, 0x1113c, 0x11140, 0x11178, 0x11186, 0x11198, 0x111b0, 0x111be,
        0x111ce, 0x111dc, 0x111e2, 0x111e4, 0x111e8, 0x111f6, 0x11208, 0x1121e, 0x11220, 0x11278, 0x112f0, 0x1130c,
        0x11330, 0x1133e, 0x11360, 0x1137c, 0x1138e, 0x1139c, 0x113b8, 0x113c2, 0x113c8, 0x113d0, 0x113de, 0x113e6,
        0x113ec, 0x11408, 0x11410, 0x1141e, 0x11420, 0x1143c, 0x11440, 0x11478, 0x114f0, 0x115e0, 0x1160c, 0x11618,
        0x11630, 0x1163e, 0x11660, 0x1167c, 0x116c0, 0x116f8, 0x1171c, 0x11738, 0x11770, 0x1177e, 0x11782, 0x11784,
        0x11788, 0x11790, 0x1179e, 0x117a0, 0x117bc, 0x117c6, 0x117cc, 0x117d8, 0x117ee, 0x1182e, 0x11834, 0x1184e,
        0x1185c, 0x11862, 0x11864, 0x11868, 0x11876, 0x1188e, 0x1189c, 0x118b8, 0x118c2, 0x118c8, 0x118d0, 0x118de,
        0x118e6, 0x118ec, 0x118fa, 0x1190e, 0x1191c, 0x11938, 0x11970, 0x1197e, 0x11982, 0x11984, 0x11990, 0x1199e,
        0x119a0, 0x119bc, 0x119c6, 0x119cc, 0x119d8, 0x119ee, 0x119f2, 0x119f4, 0x11a0e, 0x11a1c, 0x11a38, 0x11a70,
        0x11a7e, 0x11ae0, 0x11afc, 0x11b08, 0x11b10, 0x11b1e, 0x11b20, 0x11b3c, 0x11b40, 0x11b78, 0x11b8c, 0x11b98,
        0x11bb0, 0x11bbe, 0x11bce, 0x11bdc, 0x11be2, 0x11be4, 0x11be8, 0x11bf6, 0x11c16, 0x11c26, 0x11c2c, 0x11c46,
        0x11c4c, 0x11c58, 0x11c6e, 0x11c86, 0x11c98, 0x11cb0, 0x11cbe, 0x11cce, 0x11cdc, 0x11ce2, 0x11ce4, 0x11ce8,
        0x11cf6, 0x11d06, 0x11d0c, 0x11d18, 0x11d30, 0x11d3e, 0x11d60, 0x11d7c, 0x11d8e, 0x11d9c, 0x11db8, 0x11dc4,
        0x11dc8, 0x11dd0, 0x11dde, 0x11de6, 0x11dec, 0x11dfa, 0x11e0a, 0x11e12, 0x11e14, 0x11e22, 0x11e24, 0x11e28,
        0x11e36, 0x11e42, 0x11e44, 0x11e50, 0x11e5e, 0x11e66, 0x11e6c, 0x11e82, 0x11e84, 0x11e88, 0x11e90, 0x11e9e,
        0x11ea0, 0x11ebc, 0x11ec6, 0x11ecc, 0x11ed8, 0x11eee, 0x11f1a, 0x11f2e, 0x11f32, 0x11f34, 0x11f4e, 0x11f5c,
        0x11f62, 0x11f64, 0x11f68, 0x11f76, 0x12048, 0x1205e, 0x12082, 0x12084, 0x12090, 0x1209e, 0x120a0, 0x120bc,
        0x120d8, 0x120f2, 0x120f4, 0x12108, 0x1211e, 0x12120, 0x1213c, 0x12140, 0x12178, 0x12186, 0x12198, 0x121b0,
        0x121be, 0x121e2, 0x121e4, 0x121e8, 0x121f6, 0x12204, 0x12210, 0x1221e, 0x12220, 0x12278, 0x122f0, 0x12306,
        0x1230c, 0x12330, 0x1233e, 0x12360, 0x1237c, 0x1238e, 0x1239c, 0x123b8, 0x123c2, 0x123c8, 0x123d0, 0x123e6,
        0x123ec, 0x1241e, 0x12420, 0x1243c, 0x124f0, 0x125e0, 0x12618, 0x1263e, 0x12660, 0x1267c, 0x126c0, 0x126f8,
        0x12738, 0x12770, 0x1277e, 0x12782, 0x12784, 0x12790, 0x1279e, 0x127a0, 0x127bc, 0x127c6, 0x127cc, 0x127d8,
        0x127ee, 0x12820, 0x1283c, 0x12840, 0x12878, 0x128f0, 0x129e0, 0x12bc0, 0x12c18, 0x12c30, 0x12c3e, 0x12c60,
        0x12c7c, 0x12cc0, 0x12cf8, 0x12df0, 0x12e1c, 0x12e38, 0x12e70, 0x12e7e, 0x12ee0, 0x12efc, 0x12f04, 0x12f08,
        0x12f10, 0x12f20, 0x12f3c, 0x12f40, 0x12f78, 0x12f86, 0x12f8c, 0x12f98, 0x12fb0, 0x12fbe, 0x12fce, 0x12fdc,
        0x1302e, 0x1304e, 0x1305c, 0x13062, 0x13068, 0x1308e, 0x1309c, 0x130b8, 0x130c2, 0x130c8, 0x130d0, 0x130de,
        0x130ec, 0x130fa, 0x1310e, 0x13138, 0x13170, 0x1317e, 0x13182, 0x13184, 0x13190, 0x1319e, 0x131a0, 0x131bc,
        0x131c6, 0x131cc, 0x131d8, 0x131f2, 0x131f4, 0x1320e, 0x1321c, 0x13270, 0x1327e, 0x132e0, 0x132fc, 0x13308,
        0x1331e, 0x13320, 0x1333c, 0x13340, 0x13378, 0x13386, 0x13398, 0x133b0, 0x133be, 0x133ce, 0x133dc, 0x133e2,
        0x133e4, 0x133e8, 0x133f6, 0x1340e, 0x1341c, 0x13438, 0x13470, 0x1347e, 0x134e0, 0x134fc, 0x135c0, 0x135f8,
        0x13608, 0x13610, 0x1361e, 0x13620, 0x1363c, 0x13640, 0x13678, 0x136f0, 0x1370c, 0x13718, 0x13730, 0x1373e,
        0x13760, 0x1377c, 0x1379c, 0x137b8, 0x137c2, 0x137c4, 0x137c8, 0x137d0, 0x137de, 0x137e6, 0x137ec, 0x13816,
        0x13826, 0x1382c, 0x13846, 0x1384c, 0x13858, 0x1386e, 0x13874, 0x13886, 0x13898, 0x138b0, 0x138be, 0x138ce,
        0x138dc, 0x138e2, 0x138e4, 0x138e8, 0x13906, 0x1390c, 0x13930, 0x1393e, 0x13960, 0x1397c, 0x1398e, 0x1399c,
        0x139b8, 0x139c8, 0x139d0, 0x139de, 0x139e6, 0x139ec, 0x139fa, 0x13a06, 0x13a0c, 0x13a18, 0x13a30, 0x13a3e,
        0x13a60, 0x13a7c, 0x13ac0, 0x13af8, 0x13b0e, 0x13b1c, 0x13b38, 0x13b70, 0x13b7e, 0x13b88, 0x13b90, 0x13b9e,
        0x13ba0, 0x13bbc, 0x13bcc, 0x13bd8, 0x13bee, 0x13bf2, 0x13bf4, 0x13c12, 0x13c14, 0x13c22, 0x13c24, 0x13c28,
        0x13c36, 0x13c42, 0x13c48, 0x13c50, 0x13c5e, 0x13c66, 0x13c6c, 0x13c82, 0x13c84, 0x13c90, 0x13c9e, 0x13ca0,
        0x13cbc, 0x13cc6, 0x13ccc, 0x13cd8, 0x13cee, 0x13d02, 0x13d04, 0x13d08, 0x13d10, 0x13d1e, 0x13d20, 0x13d3c,
        0x13d40, 0x13d78, 0x13d86, 0x13d8c, 0x13d98, 0x13db0, 0x13dbe, 0x13dce, 0x13ddc, 0x13de4, 0x13de8, 0x13df6,
        0x13e1a, 0x13e2e, 0x13e32, 0x13e34, 0x13e4e, 0x13e5c, 0x13e62, 0x13e64, 0x13e68, 0x13e76, 0x13e8e, 0x13e9c,
        0x13eb8, 0x13ec2, 0x13ec4, 0x13ec8, 0x13ed0, 0x13ede, 0x13ee6, 0x13eec, 0x13f26, 0x13f2c, 0x13f3a, 0x13f46,
        0x13f4c, 0x13f58, 0x13f6e, 0x13f72, 0x13f74, 0x14082, 0x1409e, 0x140a0, 0x140bc, 0x14104, 0x14108, 0x14110,
        0x1411e, 0x14120, 0x1413c, 0x14140, 0x14178, 0x1418c, 0x14198, 0x141b0, 0x141be, 0x141e2, 0x141e4, 0x141e8,
        0x14208, 0x14210, 0x1421e, 0x14220, 0x1423c, 0x14240, 0x14278, 0x142f0, 0x14306, 0x1430c, 0x14318, 0x14330,
        0x1433e, 0x14360, 0x1437c, 0x1438e, 0x143c2, 0x143c4, 0x143c8, 0x143d0, 0x143e6, 0x143ec, 0x14408, 0x14410,
        0x1441e, 0x14420, 0x1443c, 0x14440, 0x14478, 0x144f0, 0x145e0, 0x1460c, 0x14618, 0x14630, 0x1463e, 0x14660,
        0x1467c, 0x146c0, 0x146f8, 0x1471c, 0x14738, 0x14770, 0x1477e, 0x14782, 0x14784, 0x14788, 0x14790, 0x147a0,
        0x147bc, 0x147c6, 0x147cc, 0x147d8, 0x147ee, 0x14810, 0x14820, 0x1483c, 0x14840, 0x14878, 0x148f0, 0x149e0,
        0x14bc0, 0x14c30, 0x14c3e, 0x14c60, 0x14c7c, 0x14cc0, 0x14cf8, 0x14df0, 0x14e38, 0x14e70, 0x14e7e, 0x14ee0,
        0x14efc, 0x14f04, 0x14f08, 0x14f10, 0x14f1e, 0x14f20, 0x14f3c, 0x14f40, 0x14f78, 0x14f86, 0x14f8c, 0x14f98,
        0x14fb0, 0x14fce, 0x14fdc, 0x15020, 0x15040, 0x15078, 0x150f0, 0x151e0, 0x153c0, 0x15860, 0x1587c, 0x158c0,
        0x158f8, 0x159f0, 0x15be0, 0x15c70, 0x15c7e, 0x15ce0, 0x15cfc, 0x15dc0, 0x15df8, 0x15e08, 0x15e10, 0x15e20,
        0x15e40, 0x15e78, 0x15ef0, 0x15f0c, 0x15f18, 0x15f30, 0x15f60, 0x15f7c, 0x15f8e, 0x15f9c, 0x15fb8, 0x1604e,
        0x1605c, 0x1608e, 0x1609c, 0x160b8, 0x160c2, 0x160c4, 0x160c8, 0x160de, 0x1610e, 0x1611c, 0x16138, 0x16170,
        0x1617e, 0x16184, 0x16188, 0x16190, 0x1619e, 0x161a0, 0x161bc, 0x161c6, 0x161cc, 0x161d8, 0x161f2, 0x161f4,
        0x1620e, 0x1621c, 0x16238, 0x16270, 0x1627e, 0x162e0, 0x162fc, 0x16304, 0x16308, 0x16310, 0x1631e, 0x16320,
        0x1633c, 0x16340, 0x16378, 0x16386, 0x1638c, 0x16398, 0x163b0, 0x163be, 0x163ce, 0x163dc, 0x163e2, 0x163e4,
        0x163e8, 0x163f6, 0x1640e, 0x1641c, 0x16438, 0x16470, 0x1647e, 0x164e0, 0x164fc, 0x165c0, 0x165f8, 0x16610,
        0x1661e, 0x16620, 0x1663c, 0x16640, 0x16678, 0x166f0, 0x16718, 0x16730, 0x1673e, 0x16760, 0x1677c, 0x1678e,
        0x1679c, 0x167b8, 0x167c2, 0x167c4, 0x167c8, 0x167d0, 0x167de, 0x167e6, 0x167ec, 0x1681c, 0x16838, 0x16870,
        0x168e0, 0x168fc, 0x169c0, 0x169f8, 0x16bf0, 0x16c10, 0x16c1e, 0x16c20, 0x16c3c, 0x16c40, 0x16c78, 0x16cf0,
        0x16de0, 0x16e18, 0x16e30, 0x16e3e, 0x16e60, 0x16e7c, 0x16ec0, 0x16ef8, 0x16f1c, 0x16f38, 0x16f70, 0x16f7e,
        0x16f84, 0x16f88, 0x16f90, 0x16f9e, 0x16fa0, 0x16fbc, 0x16fc6, 0x16fcc, 0x16fd8, 0x17026, 0x1702c, 0x17046,
        0x1704c, 0x17058, 0x1706e, 0x17086, 0x1708c, 0x17098, 0x170b0, 0x170be, 0x170ce, 0x170dc, 0x170e8, 0x17106,
        0x1710c, 0x17118, 0x17130, 0x1713e, 0x17160, 0x1717c, 0x1718e, 0x1719c, 0x171b8, 0x171c2, 0x171c4, 0x171c8,
        0x171d0, 0x171de, 0x171e6, 0x171ec, 0x171fa, 0x17206, 0x1720c, 0x17218, 0x17230, 0x1723e, 0x17260, 0x1727c,
        0x172c0, 0x172f8, 0x1730e, 0x1731c, 0x17338, 0x17370, 0x1737e, 0x17388, 0x17390, 0x1739e, 0x173a0, 0x173bc,
        0x173cc, 0x173d8, 0x173ee, 0x173f2, 0x173f4, 0x1740c, 0x17418, 0x17430, 0x1743e, 0x17460, 0x1747c, 0x174c0,
        0x174f8, 0x175f0, 0x1760e, 0x1761c, 0x17638, 0x17670, 0x1767e, 0x176e0, 0x176fc, 0x17708, 0x17710, 0x1771e,
        0x17720, 0x1773c, 0x17740, 0x17778, 0x17798, 0x177b0, 0x177be, 0x177dc, 0x177e2, 0x177e4, 0x177e8, 0x17822,
        0x17824, 0x17828, 0x17836, 0x17842, 0x17844, 0x17848, 0x17850, 0x1785e, 0x17866, 0x1786c, 0x17882, 0x17884,
        0x17888, 0x17890, 0x1789e, 0x178a0, 0x178bc, 0x178c6, 0x178cc, 0x178d8, 0x178ee, 0x178f2, 0x178f4, 0x17902,
        0x17904, 0x17908, 0x17910, 0x1791e, 0x17920, 0x1793c, 0x17940, 0x17978, 0x17986, 0x1798c, 0x17998, 0x179b0,
        0x179be, 0x179ce, 0x179dc, 0x179e2, 0x179e4, 0x179e8, 0x179f6, 0x17a04, 0x17a08, 0x17a10, 0x17a1e, 0x17a20,
        0x17a3c, 0x17a40, 0x17a78, 0x17af0, 0x17b06, 0x17b0c, 0x17b18, 0x17b30, 0x17b3e, 0x17b60, 0x17b7c, 0x17b8e,
        0x17b9c, 0x17bb8, 0x17bc4, 0x17bc8, 0x17bd0, 0x17bde, 0x17be6, 0x17bec, 0x17c2e, 0x17c32, 0x17c34, 0x17c4e,
        0x17c5c, 0x17c62, 0x17c64, 0x17c68, 0x17c76, 0x17c8e, 0x17c9c, 0x17cb8, 0x17cc2, 0x17cc4, 0x17cc8, 0x17cd0,
        0x17cde, 0x17ce6, 0x17cec, 0x17d0e, 0x17d1c, 0x17d38, 0x17d70, 0x17d82, 0x17d84, 0x17d88, 0x17d90, 0x17d9e,
        0x17da0, 0x17dbc, 0x17dc6, 0x17dcc, 0x17dd8, 0x17dee, 0x17e26, 0x17e2c, 0x17e3a, 0x17e46, 0x17e4c, 0x17e58,
        0x17e6e, 0x17e72, 0x17e74, 0x17e86, 0x17e8c, 0x17e98, 0x17eb0, 0x17ece, 0x17edc, 0x17ee2, 0x17ee4, 0x17ee8,
        0x17ef6, 0x1813a, 0x18172, 0x18174, 0x18216, 0x18226, 0x1823a, 0x1824c, 0x18258, 0x1826e, 0x18272, 0x18274,
        0x18298, 0x182be, 0x182e2, 0x182e4, 0x182e8, 0x182f6, 0x1835e, 0x1837a, 0x183ae, 0x183d6, 0x18416, 0x18426,
        0x1842c, 0x1843a, 0x18446, 0x18458, 0x1846e, 0x18472, 0x18474, 0x18486, 0x184b0, 0x184be, 0x184ce, 0x184dc,
        0x184e2, 0x184e4, 0x184e8, 0x184f6, 0x18506, 0x1850c, 0x18518, 0x18530, 0x1853e, 0x18560, 0x1857c, 0x1858e,
        0x1859c, 0x185b8, 0x185c2, 0x185c4, 0x185c8, 0x185d0, 0x185de, 0x185e6, 0x185ec, 0x185fa, 0x18612, 0x18614,
        0x18622, 0x18628, 0x18636, 0x18642, 0x18650, 0x1865e, 0x1867a, 0x18682, 0x18684, 0x18688, 0x18690, 0x1869e,
        0x186a0, 0x186bc, 0x186c6, 0x186cc, 0x186d8, 0x186ee, 0x186f2, 0x186f4, 0x1872e, 0x1874e, 0x1875c, 0x18796,
        0x187a6, 0x187ac, 0x187d2, 0x187d4, 0x18826, 0x1882c, 0x1883a, 0x18846, 0x1884c, 0x18858, 0x1886e, 0x18872,
        0x18874, 0x18886, 0x18898, 0x188b0, 0x188be, 0x188ce, 0x188dc, 0x188e2, 0x188e4, 0x188e8, 0x188f6, 0x1890c,
        0x18930, 0x1893e, 0x18960, 0x1897c, 0x1898e, 0x189b8, 0x189c2, 0x189c8, 0x189d0, 0x189de, 0x189e6, 0x189ec,
        0x189fa, 0x18a18, 0x18a30, 0x18a3e, 0x18a60, 0x18a7c, 0x18ac0, 0x18af8, 0x18b1c, 0x18b38, 0x18b70, 0x18b7e,
        0x18b82, 0x18b84, 0x18b88, 0x18b90, 0x18b9e, 0x18ba0, 0x18bbc, 0x18bc6, 0x18bcc, 0x18bd8, 0x18bee, 0x18bf2,
        0x18bf4, 0x18c22, 0x18c24, 0x18c28, 0x18c36, 0x18c42, 0x18c48, 0x18c50, 0x18c5e, 0x18c66, 0x18c7a, 0x18c82,
        0x18c84, 0x18c90, 0x18c9e, 0x18ca0, 0x18cbc, 0x18ccc, 0x18cf2, 0x18cf4, 0x18d04, 0x18d08, 0x18d10, 0x18d1e,
        0x18d20, 0x18d3c, 0x18d40, 0x18d78, 0x18d86, 0x18d98, 0x18dce, 0x18de2, 0x18de4, 0x18de8, 0x18e2e, 0x18e32,
        0x18e34, 0x18e4e, 0x18e5c, 0x18e62, 0x18e64, 0x18e68, 0x18e8e, 0x18e9c, 0x18eb8, 0x18ec2, 0x18ec4, 0x18ec8,
        0x18ed0, 0x18efa, 0x18f16, 0x18f26, 0x18f2c, 0x18f46, 0x18f4c, 0x18f58, 0x18f6e, 0x18f8a, 0x18f92, 0x18f94,
        0x18fa2, 0x18fa4, 0x18fa8, 0x18fb6, 0x1902c, 0x1903a, 0x19046, 0x1904c, 0x19058, 0x19072, 0x19074, 0x19086,
        0x19098, 0x190b0, 0x190be, 0x190ce, 0x190dc, 0x190e2, 0x190e8, 0x190f6, 0x19106, 0x1910c, 0x19130, 0x1913e,
        0x19160, 0x1917c, 0x1918e, 0x1919c, 0x191b8, 0x191c2, 0x191c8, 0x191d0, 0x191de, 0x191e6, 0x191ec, 0x191fa,
        0x19218, 0x1923e, 0x19260, 0x1927c, 0x192c0, 0x192f8, 0x19338, 0x19370, 0x1937e, 0x19382, 0x19384, 0x19390,
        0x1939e, 0x193a0, 0x193bc, 0x193c6, 0x193cc, 0x193d8, 0x193ee, 0x193f2, 0x193f4, 0x19430, 0x1943e, 0x19460,
        0x1947c, 0x194c0, 0x194f8, 0x195f0, 0x19638, 0x19670, 0x1967e, 0x196e0, 0x196fc, 0x19702, 0x19704, 0x19708,
        0x19710, 0x19720, 0x1973c, 0x19740, 0x19778, 0x19786, 0x1978c, 0x19798, 0x197b0, 0x197be, 0x197ce, 0x197dc,
        0x197e2, 0x197e4, 0x197e8, 0x19822, 0x19824, 0x19842, 0x19848, 0x19850, 0x1985e, 0x19866, 0x1987a, 0x19882,
        0x19884, 0x19890, 0x1989e, 0x198a0, 0x198bc, 0x198cc, 0x198f2, 0x198f4, 0x19902, 0x19908, 0x1991e, 0x19920,
        0x1993c, 0x19940, 0x19978, 0x19986, 0x19998, 0x199ce, 0x199e2, 0x199e4, 0x199e8, 0x19a08, 0x19a10, 0x19a1e,
        0x19a20, 0x19a3c, 0x19a40, 0x19a78, 0x19af0, 0x19b18, 0x19b3e, 0x19b60, 0x19b9c, 0x19bc2, 0x19bc4, 0x19bc8,
        0x19bd0, 0x19be6, 0x19c2e, 0x19c34, 0x19c4e, 0x19c5c, 0x19c62, 0x19c64, 0x19c68, 0x19c8e, 0x19c9c, 0x19cb8,
        0x19cc2, 0x19cc8, 0x19cd0, 0x19ce6, 0x19cfa, 0x19d0e, 0x19d1c, 0x19d38, 0x19d70, 0x19d7e, 0x19d82, 0x19d84,
        0x19d88, 0x19d90, 0x19da0, 0x19dcc, 0x19df2, 0x19df4, 0x19e16, 0x19e26, 0x19e2c, 0x19e46, 0x19e4c, 0x19e58,
        0x19e74, 0x19e86, 0x19e8c, 0x19e98, 0x19eb0, 0x19ebe, 0x19ece, 0x19ee2, 0x19ee4, 0x19ee8, 0x19f0a, 0x19f12,
        0x19f14, 0x19f22, 0x19f24, 0x19f28, 0x19f42, 0x19f44, 0x19f48, 0x19f50, 0x19f5e, 0x19f6c, 0x19f9a, 0x19fae,
        0x19fb2, 0x19fb4, 0x1a046, 0x1a04c, 0x1a072, 0x1a074, 0x1a086, 0x1a08c, 0x1a098, 0x1a0b0, 0x1a0be, 0x1a0e2,
        0x1a0e4, 0x1a0e8, 0x1a0f6, 0x1a106, 0x1a10c, 0x1a118, 0x1a130, 0x1a13e, 0x1a160, 0x1a17c, 0x1a18e, 0x1a19c,
        0x1a1b8, 0x1a1c2, 0x1a1c4, 0x1a1c8, 0x1a1d0, 0x1a1de, 0x1a1e6, 0x1a1ec, 0x1a218, 0x1a230, 0x1a23e, 0x1a260,
        0x1a27c, 0x1a2c0, 0x1a2f8, 0x1a31c, 0x1a338, 0x1a370, 0x1a37e, 0x1a382, 0x1a384, 0x1a388, 0x1a390, 0x1a39e,
        0x1a3a0, 0x1a3bc, 0x1a3c6, 0x1a3cc, 0x1a3d8, 0x1a3ee, 0x1a3f2, 0x1a3f4, 0x1a418, 0x1a430, 0x1a43e, 0x1a460,
        0x1a47c, 0x1a4c0, 0x1a4f8, 0x1a5f0, 0x1a61c, 0x1a638, 0x1a670, 0x1a67e, 0x1a6e0, 0x1a6fc, 0x1a702, 0x1a704,
        0x1a708, 0x1a710, 0x1a71e, 0x1a720, 0x1a73c, 0x1a740, 0x1a778, 0x1a786, 0x1a78c, 0x1a798, 0x1a7b0, 0x1a7be,
        0x1a7ce, 0x1a7dc, 0x1a7e2, 0x1a7e4, 0x1a7e8, 0x1a830, 0x1a860, 0x1a87c, 0x1a8c0, 0x1a8f8, 0x1a9f0, 0x1abe0,
        0x1ac70, 0x1ac7e, 0x1ace0, 0x1acfc, 0x1adc0, 0x1adf8, 0x1ae04, 0x1ae08, 0x1ae10, 0x1ae20, 0x1ae3c, 0x1ae40,
        0x1ae78, 0x1aef0, 0x1af06, 0x1af0c, 0x1af18, 0x1af30, 0x1af3e, 0x1af60, 0x1af7c, 0x1af8e, 0x1af9c, 0x1afb8,
        0x1afc4, 0x1afc8, 0x1afd0, 0x1afde, 0x1b042, 0x1b05e, 0x1b07a, 0x1b082, 0x1b084, 0x1b088, 0x1b090, 0x1b09e,
        0x1b0a0, 0x1b0bc, 0x1b0cc, 0x1b0f2, 0x1b0f4, 0x1b102, 0x1b104, 0x1b108, 0x1b110, 0x1b11e, 0x1b120, 0x1b13c,
        0x1b140, 0x1b178, 0x1b186, 0x1b198, 0x1b1ce, 0x1b1e2, 0x1b1e4, 0x1b1e8, 0x1b204, 0x1b208, 0x1b210, 0x1b21e,
        0x1b220, 0x1b23c, 0x1b240, 0x1b278, 0x1b2f0, 0x1b30c, 0x1b33e, 0x1b360, 0x1b39c, 0x1b3c2, 0x1b3c4, 0x1b3c8,
        0x1b3d0, 0x1b3e6, 0x1b410, 0x1b41e, 0x1b420, 0x1b43c, 0x1b440, 0x1b478, 0x1b4f0, 0x1b5e0, 0x1b618, 0x1b660,
        0x1b67c, 0x1b6c0, 0x1b738, 0x1b782, 0x1b784, 0x1b788, 0x1b790, 0x1b79e, 0x1b7a0, 0x1b7cc, 0x1b82e, 0x1b84e,
        0x1b85c, 0x1b88e, 0x1b89c, 0x1b8b8, 0x1b8c2, 0x1b8c4, 0x1b8c8, 0x1b8d0, 0x1b8e6, 0x1b8fa, 0x1b90e, 0x1b91c,
        0x1b938, 0x1b970, 0x1b97e, 0x1b982, 0x1b984, 0x1b988, 0x1b990, 0x1b99e, 0x1b9a0, 0x1b9cc, 0x1b9f2, 0x1b9f4,
        0x1ba0e, 0x1ba1c, 0x1ba38, 0x1ba70, 0x1ba7e, 0x1bae0, 0x1bafc, 0x1bb08, 0x1bb10, 0x1bb20, 0x1bb3c, 0x1bb40,
        0x1bb98, 0x1bbce, 0x1bbe2, 0x1bbe4, 0x1bbe8, 0x1bc16, 0x1bc26, 0x1bc2c, 0x1bc46, 0x1bc4c, 0x1bc58, 0x1bc72,
        0x1bc74, 0x1bc86, 0x1bc8c, 0x1bc98, 0x1bcb0, 0x1bcbe, 0x1bcce, 0x1bce2, 0x1bce4, 0x1bce8, 0x1bd06, 0x1bd0c,
        0x1bd18, 0x1bd30, 0x1bd3e, 0x1bd60, 0x1bd7c, 0x1bd9c, 0x1bdc2, 0x1bdc4, 0x1bdc8, 0x1bdd0, 0x1bde6, 0x1bdfa,
        0x1be12, 0x1be14, 0x1be22, 0x1be24, 0x1be28, 0x1be42, 0x1be44, 0x1be48, 0x1be50, 0x1be5e, 0x1be66, 0x1be82,
        0x1be84, 0x1be88, 0x1be90, 0x1be9e, 0x1bea0, 0x1bebc, 0x1becc, 0x1bef4, 0x1bf1a, 0x1bf2e, 0x1bf32, 0x1bf34,
        0x1bf4e, 0x1bf5c, 0x1bf62, 0x1bf64, 0x1bf68, 0x1c09a, 0x1c0b2, 0x1c0b4, 0x1c11a, 0x1c132, 0x1c134, 0x1c162,
        0x1c164, 0x1c168, 0x1c176, 0x1c1ba, 0x1c21a, 0x1c232, 0x1c234, 0x1c24e, 0x1c25c, 0x1c262, 0x1c264, 0x1c268,
        0x1c276, 0x1c28e, 0x1c2c2, 0x1c2c4, 0x1c2c8, 0x1c2d0, 0x1c2de, 0x1c2e6, 0x1c2ec, 0x1c2fa, 0x1c316, 0x1c326,
        0x1c33a, 0x1c346, 0x1c34c, 0x1c372, 0x1c374, 0x1c41a, 0x1c42e, 0x1c432, 0x1c434, 0x1c44e, 0x1c45c, 0x1c462,
        0x1c464, 0x1c468, 0x1c476, 0x1c48e, 0x1c49c, 0x1c4b8, 0x1c4c2, 0x1c4c8, 0x1c4d0, 0x1c4de, 0x1c4e6, 0x1c4ec,
        0x1c4fa, 0x1c51c, 0x1c538, 0x1c570, 0x1c57e, 0x1c582, 0x1c584, 0x1c588, 0x1c590, 0x1c59e, 0x1c5a0, 0x1c5bc,
        0x1c5c6, 0x1c5cc, 0x1c5d8, 0x1c5ee, 0x1c5f2, 0x1c5f4, 0x1c616, 0x1c626, 0x1c62c, 0x1c63a, 0x1c646, 0x1c64c,
        0x1c658, 0x1c66e, 0x1c672, 0x1c674, 0x1c686, 0x1c68c, 0x1c698, 0x1c6b0, 0x1c6be, 0x1c6ce, 0x1c6dc, 0x1c6e2,
        0x1c6e4, 0x1c6e8, 0x1c712, 0x1c714, 0x1c722, 0x1c728, 0x1c736, 0x1c742, 0x1c744, 0x1c748, 0x1c750, 0x1c75e,
        0x1c766, 0x1c76c, 0x1c77a, 0x1c7ae, 0x1c7d6, 0x1c7ea, 0x1c81a, 0x1c82e, 0x1c832, 0x1c834, 0x1c84e, 0x1c85c,
        0x1c862, 0x1c864, 0x1c868, 0x1c876, 0x1c88e, 0x1c89c, 0x1c8b8, 0x1c8c2, 0x1c8c8, 0x1c8d0, 0x1c8de, 0x1c8e6,
        0x1c8ec, 0x1c8fa, 0x1c90e, 0x1c938, 0x1c970, 0x1c97e, 0x1c982, 0x1c984, 0x1c990, 0x1c99e, 0x1c9a0, 0x1c9bc,
        0x1c9c6, 0x1c9cc, 0x1c9d8, 0x1c9ee, 0x1c9f2, 0x1c9f4, 0x1ca38, 0x1ca70, 0x1ca7e, 0x1cae0, 0x1cafc, 0x1cb02,
        0x1cb04, 0x1cb08, 0x1cb10, 0x1cb20, 0x1cb3c, 0x1cb40, 0x1cb78, 0x1cb86, 0x1cb8c, 0x1cb98, 0x1cbb0, 0x1cbbe,
        0x1cbce, 0x1cbdc, 0x1cbe2, 0x1cbe4, 0x1cbe8, 0x1cbf6, 0x1cc16, 0x1cc26, 0x1cc2c, 0x1cc3a, 0x1cc46, 0x1cc58,
        0x1cc72, 0x1cc74, 0x1cc86, 0x1ccb0, 0x1ccbe, 0x1ccce, 0x1cce2, 0x1cce4, 0x1cce8, 0x1cd06, 0x1cd0c, 0x1cd18,
        0x1cd30, 0x1cd3e, 0x1cd60, 0x1cd7c, 0x1cd9c, 0x1cdc2, 0x1cdc4, 0x1cdc8, 0x1cdd0, 0x1cdde, 0x1cde6, 0x1cdfa,
        0x1ce22, 0x1ce28, 0x1ce42, 0x1ce50, 0x1ce5e, 0x1ce66, 0x1ce7a, 0x1ce82, 0x1ce84, 0x1ce88, 0x1ce90, 0x1ce9e,
        0x1cea0, 0x1cebc, 0x1cecc, 0x1cef2, 0x1cef4, 0x1cf2e, 0x1cf32, 0x1cf34, 0x1cf4e, 0x1cf5c, 0x1cf62, 0x1cf64,
        0x1cf68, 0x1cf96, 0x1cfa6, 0x1cfac, 0x1cfca, 0x1cfd2, 0x1cfd4, 0x1d02e, 0x1d032, 0x1d034, 0x1d04e, 0x1d05c,
        0x1d062, 0x1d064, 0x1d068, 0x1d076, 0x1d08e, 0x1d09c, 0x1d0b8, 0x1d0c2, 0x1d0c4, 0x1d0c8, 0x1d0d0, 0x1d0de,
        0x1d0e6, 0x1d0ec, 0x1d0fa, 0x1d11c, 0x1d138, 0x1d170, 0x1d17e, 0x1d182, 0x1d184, 0x1d188, 0x1d190, 0x1d19e,
        0x1d1a0, 0x1d1bc, 0x1d1c6, 0x1d1cc, 0x1d1d8, 0x1d1ee, 0x1d1f2, 0x1d1f4, 0x1d21c, 0x1d238, 0x1d270, 0x1d27e,
        0x1d2e0, 0x1d2fc, 0x1d302, 0x1d304, 0x1d308, 0x1d310, 0x1d31e, 0x1d320, 0x1d33c, 0x1d340, 0x1d378, 0x1d386,
        0x1d38c, 0x1d398, 0x1d3b0, 0x1d3be, 0x1d3ce, 0x1d3dc, 0x1d3e2, 0x1d3e4, 0x1d3e8, 0x1d3f6, 0x1d470, 0x1d47e,
        0x1d4e0, 0x1d4fc, 0x1d5c0, 0x1d5f8, 0x1d604, 0x1d608, 0x1d610, 0x1d620, 0x1d640, 0x1d678, 0x1d6f0, 0x1d706,
        0x1d70c, 0x1d718, 0x1d730, 0x1d73e, 0x1d760, 0x1d77c, 0x1d78e, 0x1d79c, 0x1d7b8, 0x1d7c2, 0x1d7c4, 0x1d7c8,
        0x1d7d0, 0x1d7de, 0x1d7e6, 0x1d7ec, 0x1d826, 0x1d82c, 0x1d83a, 0x1d846, 0x1d84c, 0x1d858, 0x1d872, 0x1d874,
        0x1d886, 0x1d88c, 0x1d898, 0x1d8b0, 0x1d8be, 0x1d8ce, 0x1d8e2, 0x1d8e4, 0x1d8e8, 0x1d8f6, 0x1d90c, 0x1d918,
        0x1d930, 0x1d93e, 0x1d960, 0x1d97c, 0x1d99c, 0x1d9c2, 0x1d9c4, 0x1d9c8, 0x1d9d0, 0x1d9e6, 0x1d9fa, 0x1da0c,
        0x1da18, 0x1da30, 0x1da3e, 0x1da60, 0x1da7c, 0x1dac0, 0x1daf8, 0x1db38, 0x1db82, 0x1db84, 0x1db88, 0x1db90,
        0x1db9e, 0x1dba0, 0x1dbcc, 0x1dbf2, 0x1dbf4, 0x1dc22, 0x1dc42, 0x1dc44, 0x1dc48, 0x1dc50, 0x1dc5e, 0x1dc66,
        0x1dc7a, 0x1dc82, 0x1dc84, 0x1dc88, 0x1dc90, 0x1dc9e, 0x1dca0, 0x1dcbc, 0x1dccc, 0x1dcf2, 0x1dcf4, 0x1dd04,
        0x1dd08, 0x1dd10, 0x1dd1e, 0x1dd20, 0x1dd3c, 0x1dd40, 0x1dd78, 0x1dd86, 0x1dd98, 0x1ddce, 0x1dde2, 0x1dde4,
        0x1dde8, 0x1de2e, 0x1de32, 0x1de34, 0x1de4e, 0x1de5c, 0x1de62, 0x1de64, 0x1de68, 0x1de8e, 0x1de9c, 0x1deb8,
        0x1dec2, 0x1dec4, 0x1dec8, 0x1ded0, 0x1dee6, 0x1defa, 0x1df16, 0x1df26, 0x1df2c, 0x1df46, 0x1df4c, 0x1df58,
        0x1df72, 0x1df74, 0x1df8a, 0x1df92, 0x1df94, 0x1dfa2, 0x1dfa4, 0x1dfa8, 0x1e08a, 0x1e092, 0x1e094, 0x1e0a2,
        0x1e0a4, 0x1e0a8, 0x1e0b6, 0x1e0da, 0x1e10a, 0x1e112, 0x1e114, 0x1e122, 0x1e124, 0x1e128, 0x1e136, 0x1e142,
        0x1e144, 0x1e148, 0x1e150, 0x1e166, 0x1e16c, 0x1e17a, 0x1e19a, 0x1e1b2, 0x1e1b4, 0x1e20a, 0x1e212, 0x1e214,
        0x1e222, 0x1e224, 0x1e228, 0x1e236, 0x1e242, 0x1e248, 0x1e250, 0x1e25e, 0x1e266, 0x1e26c, 0x1e27a, 0x1e282,
        0x1e284, 0x1e288, 0x1e290, 0x1e2a0, 0x1e2bc, 0x1e2c6, 0x1e2cc, 0x1e2d8, 0x1e2ee, 0x1e2f2, 0x1e2f4, 0x1e31a,
        0x1e332, 0x1e334, 0x1e35c, 0x1e362, 0x1e364, 0x1e368, 0x1e3ba, 0x1e40a, 0x1e412, 0x1e414, 0x1e422, 0x1e428,
        0x1e436, 0x1e442, 0x1e448, 0x1e450, 0x1e45e, 0x1e466, 0x1e46c, 0x1e47a, 0x1e482, 0x1e484, 0x1e490, 0x1e49e,
        0x1e4a0, 0x1e4bc, 0x1e4c6, 0x1e4cc, 0x1e4d8, 0x1e4ee, 0x1e4f2, 0x1e4f4, 0x1e502, 0x1e504, 0x1e508, 0x1e510,
        0x1e51e, 0x1e520, 0x1e53c, 0x1e540, 0x1e578, 0x1e586, 0x1e58c, 0x1e598, 0x1e5b0, 0x1e5be, 0x1e5ce, 0x1e5dc,
        0x1e5e2, 0x1e5e4, 0x1e5e8, 0x1e5f6, 0x1e61a, 0x1e62e, 0x1e632, 0x1e634, 0x1e64e, 0x1e65c, 0x1e662, 0x1e668,
        0x1e68e, 0x1e69c, 0x1e6b8, 0x1e6c2, 0x1e6c4, 0x1e6c8, 0x1e6d0, 0x1e6e6, 0x1e6fa, 0x1e716, 0x1e726, 0x1e72c,
        0x1e73a, 0x1e746, 0x1e74c, 0x1e758, 0x1e772, 0x1e774, 0x1e792, 0x1e794, 0x1e7a2, 0x1e7a4, 0x1e7a8, 0x1e7b6,
        0x1e812, 0x1e814, 0x1e822, 0x1e824, 0x1e828, 0x1e836, 0x1e842, 0x1e844, 0x1e848, 0x1e850, 0x1e85e, 0x1e866,
        0x1e86c, 0x1e87a, 0x1e882, 0x1e884, 0x1e888, 0x1e890, 0x1e89e, 0x1e8a0, 0x1e8bc, 0x1e8c6, 0x1e8cc, 0x1e8d8,
        0x1e8ee, 0x1e8f2, 0x1e8f4, 0x1e902, 0x1e904, 0x1e908, 0x1e910, 0x1e920, 0x1e93c, 0x1e940, 0x1e978, 0x1e986,
        0x1e98c, 0x1e998, 0x1e9b0, 0x1e9be, 0x1e9ce, 0x1e9dc, 0x1e9e2, 0x1e9e4, 0x1e9e8, 0x1e9f6, 0x1ea04, 0x1ea08,
        0x1ea10, 0x1ea20, 0x1ea40, 0x1ea78, 0x1eaf0, 0x1eb06, 0x1eb0c, 0x1eb18, 0x1eb30, 0x1eb3e, 0x1eb60, 0x1eb7c,
        0x1eb8e, 0x1eb9c, 0x1ebb8, 0x1ebc2, 0x1ebc4, 0x1ebc8, 0x1ebd0, 0x1ebde, 0x1ebe6, 0x1ebec, 0x1ec1a, 0x1ec2e,
        0x1ec32, 0x1ec34, 0x1ec4e, 0x1ec5c, 0x1ec62, 0x1ec64, 0x1ec68, 0x1ec8e, 0x1ec9c, 0x1ecb8, 0x1ecc2, 0x1ecc4,
        0x1ecc8, 0x1ecd0, 0x1ece6, 0x1ecfa, 0x1ed0e, 0x1ed1c, 0x1ed38, 0x1ed70, 0x1ed7e, 0x1ed82, 0x1ed84, 0x1ed88,
        0x1ed90, 0x1ed9e, 0x1eda0, 0x1edcc, 0x1edf2, 0x1edf4, 0x1ee16, 0x1ee26, 0x1ee2c, 0x1ee3a, 0x1ee46, 0x1ee4c,
        0x1ee58, 0x1ee6e, 0x1ee72, 0x1ee74, 0x1ee86, 0x1ee8c, 0x1ee98, 0x1eeb0, 0x1eebe, 0x1eece, 0x1eedc, 0x1eee2,
        0x1eee4, 0x1eee8, 0x1ef12, 0x1ef22, 0x1ef24, 0x1ef28, 0x1ef36, 0x1ef42, 0x1ef44, 0x1ef48, 0x1ef50, 0x1ef5e,
        0x1ef66, 0x1ef6c, 0x1ef7a, 0x1efae, 0x1efb2, 0x1efb4, 0x1efd6, 0x1f096, 0x1f0a6, 0x1f0ac, 0x1f0ba, 0x1f0ca,
        0x1f0d2, 0x1f0d4, 0x1f116, 0x1f126, 0x1f12c, 0x1f13a, 0x1f146, 0x1f14c, 0x1f158, 0x1f16e, 0x1f172, 0x1f174,
        0x1f18a, 0x1f192, 0x1f194, 0x1f1a2, 0x1f1a4, 0x1f1a8, 0x1f1da, 0x1f216, 0x1f226, 0x1f22c, 0x1f23a, 0x1f246,
        0x1f258, 0x1f26e, 0x1f272, 0x1f274, 0x1f286, 0x1f28c, 0x1f298, 0x1f2b0, 0x1f2be, 0x1f2ce, 0x1f2dc, 0x1f2e2,
        0x1f2e4, 0x1f2e8, 0x1f2f6, 0x1f30a, 0x1f312, 0x1f314, 0x1f322, 0x1f328, 0x1f342, 0x1f344, 0x1f348, 0x1f350,
        0x1f35e, 0x1f366, 0x1f37a, 0x1f39a, 0x1f3ae, 0x1f3b2, 0x1f3b4, 0x1f416, 0x1f426, 0x1f42c, 0x1f43a, 0x1f446,
        0x1f44c, 0x1f458, 0x1f46e, 0x1f472, 0x1f474, 0x1f486, 0x1f48c, 0x1f498, 0x1f4b0, 0x1f4be, 0x1f4ce, 0x1f4dc,
        0x1f4e2, 0x1f4e4, 0x1f4e8, 0x1f4f6, 0x1f506, 0x1f50c, 0x1f518, 0x1f530, 0x1f53e, 0x1f560, 0x1f57c, 0x1f58e,
        0x1f59c, 0x1f5b8, 0x1f5c2, 0x1f5c4, 0x1f5c8, 0x1f5d0, 0x1f5de, 0x1f5e6, 0x1f5ec, 0x1f5fa, 0x1f60a, 0x1f612,
        0x1f614, 0x1f622, 0x1f624, 0x1f628, 0x1f636, 0x1f642, 0x1f644, 0x1f648, 0x1f650, 0x1f65e, 0x1f666, 0x1f67a,
        0x1f682, 0x1f684, 0x1f688, 0x1f690, 0x1f69e, 0x1f6a0, 0x1f6bc, 0x1f6cc, 0x1f6f2, 0x1f6f4, 0x1f71a, 0x1f72e,
        0x1f732, 0x1f734, 0x1f74e, 0x1f75c, 0x1f762, 0x1f764, 0x1f768, 0x1f776, 0x1f796, 0x1f7a6, 0x1f7ac, 0x1f7ba,
        0x1f7d2, 0x1f7d4, 0x1f89a, 0x1f8ae, 0x1f8b2, 0x1f8b4, 0x1f8d6, 0x1f8ea, 0x1f91a, 0x1f92e, 0x1f932, 0x1f934,
        0x1f94e, 0x1f95c, 0x1f962, 0x1f964, 0x1f968, 0x1f976, 0x1f996, 0x1f9a6, 0x1f9ac, 0x1f9ba, 0x1f9ca, 0x1f9d2,
        0x1f9d4, 0x1fa1a, 0x1fa2e, 0x1fa32, 0x1fa34, 0x1fa4e, 0x1fa5c, 0x1fa62, 0x1fa64, 0x1fa68, 0x1fa76, 0x1fa8e,
        0x1fa9c, 0x1fab8, 0x1fac2, 0x1fac4, 0x1fac8, 0x1fad0, 0x1fade, 0x1fae6, 0x1faec, 0x1fb16, 0x1fb26, 0x1fb2c,
        0x1fb3a, 0x1fb46, 0x1fb4c, 0x1fb58, 0x1fb6e, 0x1fb72, 0x1fb74, 0x1fb8a, 0x1fb92, 0x1fb94, 0x1fba2, 0x1fba4,
        0x1fba8, 0x1fbb6, 0x1fbda
    ]);
    /**
     * This table contains to codewords for all symbols.
     */
    PDF417Common.CODEWORD_TABLE = Int32Array.from([
        2627, 1819, 2622, 2621, 1813, 1812, 2729, 2724, 2723, 2779, 2774, 2773, 902, 896, 908, 868, 865, 861, 859, 2511,
        873, 871, 1780, 835, 2493, 825, 2491, 842, 837, 844, 1764, 1762, 811, 810, 809, 2483, 807, 2482, 806, 2480, 815,
        814, 813, 812, 2484, 817, 816, 1745, 1744, 1742, 1746, 2655, 2637, 2635, 2626, 2625, 2623, 2628, 1820, 2752,
        2739, 2737, 2728, 2727, 2725, 2730, 2785, 2783, 2778, 2777, 2775, 2780, 787, 781, 747, 739, 736, 2413, 754, 752,
        1719, 692, 689, 681, 2371, 678, 2369, 700, 697, 694, 703, 1688, 1686, 642, 638, 2343, 631, 2341, 627, 2338, 651,
        646, 643, 2345, 654, 652, 1652, 1650, 1647, 1654, 601, 599, 2322, 596, 2321, 594, 2319, 2317, 611, 610, 608, 606,
        2324, 603, 2323, 615, 614, 612, 1617, 1616, 1614, 1612, 616, 1619, 1618, 2575, 2538, 2536, 905, 901, 898, 909,
        2509, 2507, 2504, 870, 867, 864, 860, 2512, 875, 872, 1781, 2490, 2489, 2487, 2485, 1748, 836, 834, 832, 830,
        2494, 827, 2492, 843, 841, 839, 845, 1765, 1763, 2701, 2676, 2674, 2653, 2648, 2656, 2634, 2633, 2631, 2629,
        1821, 2638, 2636, 2770, 2763, 2761, 2750, 2745, 2753, 2736, 2735, 2733, 2731, 1848, 2740, 2738, 2786, 2784, 591,
        588, 576, 569, 566, 2296, 1590, 537, 534, 526, 2276, 522, 2274, 545, 542, 539, 548, 1572, 1570, 481, 2245, 466,
        2242, 462, 2239, 492, 485, 482, 2249, 496, 494, 1534, 1531, 1528, 1538, 413, 2196, 406, 2191, 2188, 425, 419,
        2202, 415, 2199, 432, 430, 427, 1472, 1467, 1464, 433, 1476, 1474, 368, 367, 2160, 365, 2159, 362, 2157, 2155,
        2152, 378, 377, 375, 2166, 372, 2165, 369, 2162, 383, 381, 379, 2168, 1419, 1418, 1416, 1414, 385, 1411, 384,
        1423, 1422, 1420, 1424, 2461, 802, 2441, 2439, 790, 786, 783, 794, 2409, 2406, 2403, 750, 742, 738, 2414, 756,
        753, 1720, 2367, 2365, 2362, 2359, 1663, 693, 691, 684, 2373, 680, 2370, 702, 699, 696, 704, 1690, 1687, 2337,
        2336, 2334, 2332, 1624, 2329, 1622, 640, 637, 2344, 634, 2342, 630, 2340, 650, 648, 645, 2346, 655, 653, 1653,
        1651, 1649, 1655, 2612, 2597, 2595, 2571, 2568, 2565, 2576, 2534, 2529, 2526, 1787, 2540, 2537, 907, 904, 900,
        910, 2503, 2502, 2500, 2498, 1768, 2495, 1767, 2510, 2508, 2506, 869, 866, 863, 2513, 876, 874, 1782, 2720, 2713,
        2711, 2697, 2694, 2691, 2702, 2672, 2670, 2664, 1828, 2678, 2675, 2647, 2646, 2644, 2642, 1823, 2639, 1822, 2654,
        2652, 2650, 2657, 2771, 1855, 2765, 2762, 1850, 1849, 2751, 2749, 2747, 2754, 353, 2148, 344, 342, 336, 2142,
        332, 2140, 345, 1375, 1373, 306, 2130, 299, 2128, 295, 2125, 319, 314, 311, 2132, 1354, 1352, 1349, 1356, 262,
        257, 2101, 253, 2096, 2093, 274, 273, 267, 2107, 263, 2104, 280, 278, 275, 1316, 1311, 1308, 1320, 1318, 2052,
        202, 2050, 2044, 2040, 219, 2063, 212, 2060, 208, 2055, 224, 221, 2066, 1260, 1258, 1252, 231, 1248, 229, 1266,
        1264, 1261, 1268, 155, 1998, 153, 1996, 1994, 1991, 1988, 165, 164, 2007, 162, 2006, 159, 2003, 2000, 172, 171,
        169, 2012, 166, 2010, 1186, 1184, 1182, 1179, 175, 1176, 173, 1192, 1191, 1189, 1187, 176, 1194, 1193, 2313,
        2307, 2305, 592, 589, 2294, 2292, 2289, 578, 572, 568, 2297, 580, 1591, 2272, 2267, 2264, 1547, 538, 536, 529,
        2278, 525, 2275, 547, 544, 541, 1574, 1571, 2237, 2235, 2229, 1493, 2225, 1489, 478, 2247, 470, 2244, 465, 2241,
        493, 488, 484, 2250, 498, 495, 1536, 1533, 1530, 1539, 2187, 2186, 2184, 2182, 1432, 2179, 1430, 2176, 1427, 414,
        412, 2197, 409, 2195, 405, 2193, 2190, 426, 424, 421, 2203, 418, 2201, 431, 429, 1473, 1471, 1469, 1466, 434,
        1477, 1475, 2478, 2472, 2470, 2459, 2457, 2454, 2462, 803, 2437, 2432, 2429, 1726, 2443, 2440, 792, 789, 785,
        2401, 2399, 2393, 1702, 2389, 1699, 2411, 2408, 2405, 745, 741, 2415, 758, 755, 1721, 2358, 2357, 2355, 2353,
        1661, 2350, 1660, 2347, 1657, 2368, 2366, 2364, 2361, 1666, 690, 687, 2374, 683, 2372, 701, 698, 705, 1691, 1689,
        2619, 2617, 2610, 2608, 2605, 2613, 2593, 2588, 2585, 1803, 2599, 2596, 2563, 2561, 2555, 1797, 2551, 1795, 2573,
        2570, 2567, 2577, 2525, 2524, 2522, 2520, 1786, 2517, 1785, 2514, 1783, 2535, 2533, 2531, 2528, 1788, 2541, 2539,
        906, 903, 911, 2721, 1844, 2715, 2712, 1838, 1836, 2699, 2696, 2693, 2703, 1827, 1826, 1824, 2673, 2671, 2669,
        2666, 1829, 2679, 2677, 1858, 1857, 2772, 1854, 1853, 1851, 1856, 2766, 2764, 143, 1987, 139, 1986, 135, 133,
        131, 1984, 128, 1983, 125, 1981, 138, 137, 136, 1985, 1133, 1132, 1130, 112, 110, 1974, 107, 1973, 104, 1971,
        1969, 122, 121, 119, 117, 1977, 114, 1976, 124, 1115, 1114, 1112, 1110, 1117, 1116, 84, 83, 1953, 81, 1952, 78,
        1950, 1948, 1945, 94, 93, 91, 1959, 88, 1958, 85, 1955, 99, 97, 95, 1961, 1086, 1085, 1083, 1081, 1078, 100,
        1090, 1089, 1087, 1091, 49, 47, 1917, 44, 1915, 1913, 1910, 1907, 59, 1926, 56, 1925, 53, 1922, 1919, 66, 64,
        1931, 61, 1929, 1042, 1040, 1038, 71, 1035, 70, 1032, 68, 1048, 1047, 1045, 1043, 1050, 1049, 12, 10, 1869, 1867,
        1864, 1861, 21, 1880, 19, 1877, 1874, 1871, 28, 1888, 25, 1886, 22, 1883, 982, 980, 977, 974, 32, 30, 991, 989,
        987, 984, 34, 995, 994, 992, 2151, 2150, 2147, 2146, 2144, 356, 355, 354, 2149, 2139, 2138, 2136, 2134, 1359,
        343, 341, 338, 2143, 335, 2141, 348, 347, 346, 1376, 1374, 2124, 2123, 2121, 2119, 1326, 2116, 1324, 310, 308,
        305, 2131, 302, 2129, 298, 2127, 320, 318, 316, 313, 2133, 322, 321, 1355, 1353, 1351, 1357, 2092, 2091, 2089,
        2087, 1276, 2084, 1274, 2081, 1271, 259, 2102, 256, 2100, 252, 2098, 2095, 272, 269, 2108, 266, 2106, 281, 279,
        277, 1317, 1315, 1313, 1310, 282, 1321, 1319, 2039, 2037, 2035, 2032, 1203, 2029, 1200, 1197, 207, 2053, 205,
        2051, 201, 2049, 2046, 2043, 220, 218, 2064, 215, 2062, 211, 2059, 228, 226, 223, 2069, 1259, 1257, 1254, 232,
        1251, 230, 1267, 1265, 1263, 2316, 2315, 2312, 2311, 2309, 2314, 2304, 2303, 2301, 2299, 1593, 2308, 2306, 590,
        2288, 2287, 2285, 2283, 1578, 2280, 1577, 2295, 2293, 2291, 579, 577, 574, 571, 2298, 582, 581, 1592, 2263, 2262,
        2260, 2258, 1545, 2255, 1544, 2252, 1541, 2273, 2271, 2269, 2266, 1550, 535, 532, 2279, 528, 2277, 546, 543, 549,
        1575, 1573, 2224, 2222, 2220, 1486, 2217, 1485, 2214, 1482, 1479, 2238, 2236, 2234, 2231, 1496, 2228, 1492, 480,
        477, 2248, 473, 2246, 469, 2243, 490, 487, 2251, 497, 1537, 1535, 1532, 2477, 2476, 2474, 2479, 2469, 2468, 2466,
        2464, 1730, 2473, 2471, 2453, 2452, 2450, 2448, 1729, 2445, 1728, 2460, 2458, 2456, 2463, 805, 804, 2428, 2427,
        2425, 2423, 1725, 2420, 1724, 2417, 1722, 2438, 2436, 2434, 2431, 1727, 2444, 2442, 793, 791, 788, 795, 2388,
        2386, 2384, 1697, 2381, 1696, 2378, 1694, 1692, 2402, 2400, 2398, 2395, 1703, 2392, 1701, 2412, 2410, 2407, 751,
        748, 744, 2416, 759, 757, 1807, 2620, 2618, 1806, 1805, 2611, 2609, 2607, 2614, 1802, 1801, 1799, 2594, 2592,
        2590, 2587, 1804, 2600, 2598, 1794, 1793, 1791, 1789, 2564, 2562, 2560, 2557, 1798, 2554, 1796, 2574, 2572, 2569,
        2578, 1847, 1846, 2722, 1843, 1842, 1840, 1845, 2716, 2714, 1835, 1834, 1832, 1830, 1839, 1837, 2700, 2698, 2695,
        2704, 1817, 1811, 1810, 897, 862, 1777, 829, 826, 838, 1760, 1758, 808, 2481, 1741, 1740, 1738, 1743, 2624, 1818,
        2726, 2776, 782, 740, 737, 1715, 686, 679, 695, 1682, 1680, 639, 628, 2339, 647, 644, 1645, 1643, 1640, 1648,
        602, 600, 597, 595, 2320, 593, 2318, 609, 607, 604, 1611, 1610, 1608, 1606, 613, 1615, 1613, 2328, 926, 924, 892,
        886, 899, 857, 850, 2505, 1778, 824, 823, 821, 819, 2488, 818, 2486, 833, 831, 828, 840, 1761, 1759, 2649, 2632,
        2630, 2746, 2734, 2732, 2782, 2781, 570, 567, 1587, 531, 527, 523, 540, 1566, 1564, 476, 467, 463, 2240, 486,
        483, 1524, 1521, 1518, 1529, 411, 403, 2192, 399, 2189, 423, 416, 1462, 1457, 1454, 428, 1468, 1465, 2210, 366,
        363, 2158, 360, 2156, 357, 2153, 376, 373, 370, 2163, 1410, 1409, 1407, 1405, 382, 1402, 380, 1417, 1415, 1412,
        1421, 2175, 2174, 777, 774, 771, 784, 732, 725, 722, 2404, 743, 1716, 676, 674, 668, 2363, 665, 2360, 685, 1684,
        1681, 626, 624, 622, 2335, 620, 2333, 617, 2330, 641, 635, 649, 1646, 1644, 1642, 2566, 928, 925, 2530, 2527,
        894, 891, 888, 2501, 2499, 2496, 858, 856, 854, 851, 1779, 2692, 2668, 2665, 2645, 2643, 2640, 2651, 2768, 2759,
        2757, 2744, 2743, 2741, 2748, 352, 1382, 340, 337, 333, 1371, 1369, 307, 300, 296, 2126, 315, 312, 1347, 1342,
        1350, 261, 258, 250, 2097, 246, 2094, 271, 268, 264, 1306, 1301, 1298, 276, 1312, 1309, 2115, 203, 2048, 195,
        2045, 191, 2041, 213, 209, 2056, 1246, 1244, 1238, 225, 1234, 222, 1256, 1253, 1249, 1262, 2080, 2079, 154, 1997,
        150, 1995, 147, 1992, 1989, 163, 160, 2004, 156, 2001, 1175, 1174, 1172, 1170, 1167, 170, 1164, 167, 1185, 1183,
        1180, 1177, 174, 1190, 1188, 2025, 2024, 2022, 587, 586, 564, 559, 556, 2290, 573, 1588, 520, 518, 512, 2268,
        508, 2265, 530, 1568, 1565, 461, 457, 2233, 450, 2230, 446, 2226, 479, 471, 489, 1526, 1523, 1520, 397, 395,
        2185, 392, 2183, 389, 2180, 2177, 410, 2194, 402, 422, 1463, 1461, 1459, 1456, 1470, 2455, 799, 2433, 2430, 779,
        776, 773, 2397, 2394, 2390, 734, 728, 724, 746, 1717, 2356, 2354, 2351, 2348, 1658, 677, 675, 673, 670, 667, 688,
        1685, 1683, 2606, 2589, 2586, 2559, 2556, 2552, 927, 2523, 2521, 2518, 2515, 1784, 2532, 895, 893, 890, 2718,
        2709, 2707, 2689, 2687, 2684, 2663, 2662, 2660, 2658, 1825, 2667, 2769, 1852, 2760, 2758, 142, 141, 1139, 1138,
        134, 132, 129, 126, 1982, 1129, 1128, 1126, 1131, 113, 111, 108, 105, 1972, 101, 1970, 120, 118, 115, 1109, 1108,
        1106, 1104, 123, 1113, 1111, 82, 79, 1951, 75, 1949, 72, 1946, 92, 89, 86, 1956, 1077, 1076, 1074, 1072, 98,
        1069, 96, 1084, 1082, 1079, 1088, 1968, 1967, 48, 45, 1916, 42, 1914, 39, 1911, 1908, 60, 57, 54, 1923, 50, 1920,
        1031, 1030, 1028, 1026, 67, 1023, 65, 1020, 62, 1041, 1039, 1036, 1033, 69, 1046, 1044, 1944, 1943, 1941, 11, 9,
        1868, 7, 1865, 1862, 1859, 20, 1878, 16, 1875, 13, 1872, 970, 968, 966, 963, 29, 960, 26, 23, 983, 981, 978, 975,
        33, 971, 31, 990, 988, 985, 1906, 1904, 1902, 993, 351, 2145, 1383, 331, 330, 328, 326, 2137, 323, 2135, 339,
        1372, 1370, 294, 293, 291, 289, 2122, 286, 2120, 283, 2117, 309, 303, 317, 1348, 1346, 1344, 245, 244, 242, 2090,
        239, 2088, 236, 2085, 2082, 260, 2099, 249, 270, 1307, 1305, 1303, 1300, 1314, 189, 2038, 186, 2036, 183, 2033,
        2030, 2026, 206, 198, 2047, 194, 216, 1247, 1245, 1243, 1240, 227, 1237, 1255, 2310, 2302, 2300, 2286, 2284,
        2281, 565, 563, 561, 558, 575, 1589, 2261, 2259, 2256, 2253, 1542, 521, 519, 517, 514, 2270, 511, 533, 1569,
        1567, 2223, 2221, 2218, 2215, 1483, 2211, 1480, 459, 456, 453, 2232, 449, 474, 491, 1527, 1525, 1522, 2475, 2467,
        2465, 2451, 2449, 2446, 801, 800, 2426, 2424, 2421, 2418, 1723, 2435, 780, 778, 775, 2387, 2385, 2382, 2379,
        1695, 2375, 1693, 2396, 735, 733, 730, 727, 749, 1718, 2616, 2615, 2604, 2603, 2601, 2584, 2583, 2581, 2579,
        1800, 2591, 2550, 2549, 2547, 2545, 1792, 2542, 1790, 2558, 929, 2719, 1841, 2710, 2708, 1833, 1831, 2690, 2688,
        2686, 1815, 1809, 1808, 1774, 1756, 1754, 1737, 1736, 1734, 1739, 1816, 1711, 1676, 1674, 633, 629, 1638, 1636,
        1633, 1641, 598, 1605, 1604, 1602, 1600, 605, 1609, 1607, 2327, 887, 853, 1775, 822, 820, 1757, 1755, 1584, 524,
        1560, 1558, 468, 464, 1514, 1511, 1508, 1519, 408, 404, 400, 1452, 1447, 1444, 417, 1458, 1455, 2208, 364, 361,
        358, 2154, 1401, 1400, 1398, 1396, 374, 1393, 371, 1408, 1406, 1403, 1413, 2173, 2172, 772, 726, 723, 1712, 672,
        669, 666, 682, 1678, 1675, 625, 623, 621, 618, 2331, 636, 632, 1639, 1637, 1635, 920, 918, 884, 880, 889, 849,
        848, 847, 846, 2497, 855, 852, 1776, 2641, 2742, 2787, 1380, 334, 1367, 1365, 301, 297, 1340, 1338, 1335, 1343,
        255, 251, 247, 1296, 1291, 1288, 265, 1302, 1299, 2113, 204, 196, 192, 2042, 1232, 1230, 1224, 214, 1220, 210,
        1242, 1239, 1235, 1250, 2077, 2075, 151, 148, 1993, 144, 1990, 1163, 1162, 1160, 1158, 1155, 161, 1152, 157,
        1173, 1171, 1168, 1165, 168, 1181, 1178, 2021, 2020, 2018, 2023, 585, 560, 557, 1585, 516, 509, 1562, 1559, 458,
        447, 2227, 472, 1516, 1513, 1510, 398, 396, 393, 390, 2181, 386, 2178, 407, 1453, 1451, 1449, 1446, 420, 1460,
        2209, 769, 764, 720, 712, 2391, 729, 1713, 664, 663, 661, 659, 2352, 656, 2349, 671, 1679, 1677, 2553, 922, 919,
        2519, 2516, 885, 883, 881, 2685, 2661, 2659, 2767, 2756, 2755, 140, 1137, 1136, 130, 127, 1125, 1124, 1122, 1127,
        109, 106, 102, 1103, 1102, 1100, 1098, 116, 1107, 1105, 1980, 80, 76, 73, 1947, 1068, 1067, 1065, 1063, 90, 1060,
        87, 1075, 1073, 1070, 1080, 1966, 1965, 46, 43, 40, 1912, 36, 1909, 1019, 1018, 1016, 1014, 58, 1011, 55, 1008,
        51, 1029, 1027, 1024, 1021, 63, 1037, 1034, 1940, 1939, 1937, 1942, 8, 1866, 4, 1863, 1, 1860, 956, 954, 952,
        949, 946, 17, 14, 969, 967, 964, 961, 27, 957, 24, 979, 976, 972, 1901, 1900, 1898, 1896, 986, 1905, 1903, 350,
        349, 1381, 329, 327, 324, 1368, 1366, 292, 290, 287, 284, 2118, 304, 1341, 1339, 1337, 1345, 243, 240, 237, 2086,
        233, 2083, 254, 1297, 1295, 1293, 1290, 1304, 2114, 190, 187, 184, 2034, 180, 2031, 177, 2027, 199, 1233, 1231,
        1229, 1226, 217, 1223, 1241, 2078, 2076, 584, 555, 554, 552, 550, 2282, 562, 1586, 507, 506, 504, 502, 2257, 499,
        2254, 515, 1563, 1561, 445, 443, 441, 2219, 438, 2216, 435, 2212, 460, 454, 475, 1517, 1515, 1512, 2447, 798,
        797, 2422, 2419, 770, 768, 766, 2383, 2380, 2376, 721, 719, 717, 714, 731, 1714, 2602, 2582, 2580, 2548, 2546,
        2543, 923, 921, 2717, 2706, 2705, 2683, 2682, 2680, 1771, 1752, 1750, 1733, 1732, 1731, 1735, 1814, 1707, 1670,
        1668, 1631, 1629, 1626, 1634, 1599, 1598, 1596, 1594, 1603, 1601, 2326, 1772, 1753, 1751, 1581, 1554, 1552, 1504,
        1501, 1498, 1509, 1442, 1437, 1434, 401, 1448, 1445, 2206, 1392, 1391, 1389, 1387, 1384, 359, 1399, 1397, 1394,
        1404, 2171, 2170, 1708, 1672, 1669, 619, 1632, 1630, 1628, 1773, 1378, 1363, 1361, 1333, 1328, 1336, 1286, 1281,
        1278, 248, 1292, 1289, 2111, 1218, 1216, 1210, 197, 1206, 193, 1228, 1225, 1221, 1236, 2073, 2071, 1151, 1150,
        1148, 1146, 152, 1143, 149, 1140, 145, 1161, 1159, 1156, 1153, 158, 1169, 1166, 2017, 2016, 2014, 2019, 1582,
        510, 1556, 1553, 452, 448, 1506, 1500, 394, 391, 387, 1443, 1441, 1439, 1436, 1450, 2207, 765, 716, 713, 1709,
        662, 660, 657, 1673, 1671, 916, 914, 879, 878, 877, 882, 1135, 1134, 1121, 1120, 1118, 1123, 1097, 1096, 1094,
        1092, 103, 1101, 1099, 1979, 1059, 1058, 1056, 1054, 77, 1051, 74, 1066, 1064, 1061, 1071, 1964, 1963, 1007,
        1006, 1004, 1002, 999, 41, 996, 37, 1017, 1015, 1012, 1009, 52, 1025, 1022, 1936, 1935, 1933, 1938, 942, 940,
        938, 935, 932, 5, 2, 955, 953, 950, 947, 18, 943, 15, 965, 962, 958, 1895, 1894, 1892, 1890, 973, 1899, 1897,
        1379, 325, 1364, 1362, 288, 285, 1334, 1332, 1330, 241, 238, 234, 1287, 1285, 1283, 1280, 1294, 2112, 188, 185,
        181, 178, 2028, 1219, 1217, 1215, 1212, 200, 1209, 1227, 2074, 2072, 583, 553, 551, 1583, 505, 503, 500, 513,
        1557, 1555, 444, 442, 439, 436, 2213, 455, 451, 1507, 1505, 1502, 796, 763, 762, 760, 767, 711, 710, 708, 706,
        2377, 718, 715, 1710, 2544, 917, 915, 2681, 1627, 1597, 1595, 2325, 1769, 1749, 1747, 1499, 1438, 1435, 2204,
        1390, 1388, 1385, 1395, 2169, 2167, 1704, 1665, 1662, 1625, 1623, 1620, 1770, 1329, 1282, 1279, 2109, 1214, 1207,
        1222, 2068, 2065, 1149, 1147, 1144, 1141, 146, 1157, 1154, 2013, 2011, 2008, 2015, 1579, 1549, 1546, 1495, 1487,
        1433, 1431, 1428, 1425, 388, 1440, 2205, 1705, 658, 1667, 1664, 1119, 1095, 1093, 1978, 1057, 1055, 1052, 1062,
        1962, 1960, 1005, 1003, 1000, 997, 38, 1013, 1010, 1932, 1930, 1927, 1934, 941, 939, 936, 933, 6, 930, 3, 951,
        948, 944, 1889, 1887, 1884, 1881, 959, 1893, 1891, 35, 1377, 1360, 1358, 1327, 1325, 1322, 1331, 1277, 1275,
        1272, 1269, 235, 1284, 2110, 1205, 1204, 1201, 1198, 182, 1195, 179, 1213, 2070, 2067, 1580, 501, 1551, 1548,
        440, 437, 1497, 1494, 1490, 1503, 761, 709, 707, 1706, 913, 912, 2198, 1386, 2164, 2161, 1621, 1766, 2103, 1208,
        2058, 2054, 1145, 1142, 2005, 2002, 1999, 2009, 1488, 1429, 1426, 2200, 1698, 1659, 1656, 1975, 1053, 1957, 1954,
        1001, 998, 1924, 1921, 1918, 1928, 937, 934, 931, 1879, 1876, 1873, 1870, 945, 1885, 1882, 1323, 1273, 1270,
        2105, 1202, 1199, 1196, 1211, 2061, 2057, 1576, 1543, 1540, 1484, 1481, 1478, 1491, 1700
    ]);

    /*
    * Copyright 2007 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    // import java.util.List;
    /**
     * @author Guenther Grau
     */
    /*public final*/ class PDF417DetectorResult {
        constructor(bits, points) {
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }

    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    // import java.util.ArrayList;
    // import java.util.Arrays;
    // import java.util.List;
    // import java.util.Map;
    /**
     * <p>Encapsulates logic that can detect a PDF417 Code in an image, even if the
     * PDF417 Code is rotated or skewed, or partially obscured.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Guenther Grau
     */
    /*public*/ /*final*/ class Detector$3 {
        /**
         * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
         *
         * @param image barcode image to decode
         * @param hints optional hints to detector
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
         * @throws NotFoundException if no PDF417 Code can be found
         */
        static detectMultiple(image, hints, multiple) {
            // TODO detection improvement, tryHarder could try several different luminance thresholds/blackpoints or even
            // different binarizers
            // boolean tryHarder = hints != null && hints.containsKey(DecodeHintType.TRY_HARDER);
            let bitMatrix = image.getBlackMatrix();
            let barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            if (!barcodeCoordinates.length) {
                bitMatrix = bitMatrix.clone();
                bitMatrix.rotate180();
                barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            }
            return new PDF417DetectorResult(bitMatrix, barcodeCoordinates);
        }
        /**
         * Detects PDF417 codes in an image. Only checks 0 degree rotation
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @param bitMatrix bit matrix to detect barcodes in
         * @return List of ResultPoint arrays containing the coordinates of found barcodes
         */
        static detect(multiple, bitMatrix) {
            const barcodeCoordinates = new Array();
            let row = 0;
            let column = 0;
            let foundBarcodeInRow = false;
            while (row < bitMatrix.getHeight()) {
                const vertices = Detector$3.findVertices(bitMatrix, row, column);
                if (vertices[0] == null && vertices[3] == null) {
                    if (!foundBarcodeInRow) {
                        // we didn't find any barcode so that's the end of searching
                        break;
                    }
                    // we didn't find a barcode starting at the given column and row. Try again from the first column and slightly
                    // below the lowest barcode we found so far.
                    foundBarcodeInRow = false;
                    column = 0;
                    for (const barcodeCoordinate of barcodeCoordinates) {
                        if (barcodeCoordinate[1] != null) {
                            row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
                        }
                        if (barcodeCoordinate[3] != null) {
                            row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
                        }
                    }
                    row += Detector$3.ROW_STEP;
                    continue;
                }
                foundBarcodeInRow = true;
                barcodeCoordinates.push(vertices);
                if (!multiple) {
                    break;
                }
                // if we didn't find a right row indicator column, then continue the search for the next barcode after the
                // start pattern of the barcode just found.
                if (vertices[2] != null) {
                    column = Math.trunc(vertices[2].getX());
                    row = Math.trunc(vertices[2].getY());
                }
                else {
                    column = Math.trunc(vertices[4].getX());
                    row = Math.trunc(vertices[4].getY());
                }
            }
            return barcodeCoordinates;
        }
        /**
         * Locate the vertices and the codewords area of a black blob using the Start
         * and Stop patterns as locators.
         *
         * @param matrix the scanned barcode image.
         * @return an array containing the vertices:
         *           vertices[0] x, y top left barcode
         *           vertices[1] x, y bottom left barcode
         *           vertices[2] x, y top right barcode
         *           vertices[3] x, y bottom right barcode
         *           vertices[4] x, y top left codeword area
         *           vertices[5] x, y bottom left codeword area
         *           vertices[6] x, y top right codeword area
         *           vertices[7] x, y bottom right codeword area
         */
        static findVertices(matrix, startRow, startColumn) {
            const height = matrix.getHeight();
            const width = matrix.getWidth();
            // const result = new ResultPoint[8];
            const result = new Array(8);
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.START_PATTERN), Detector$3.INDEXES_START_PATTERN);
            if (result[4] != null) {
                startColumn = Math.trunc(result[4].getX());
                startRow = Math.trunc(result[4].getY());
            }
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.STOP_PATTERN), Detector$3.INDEXES_STOP_PATTERN);
            return result;
        }
        static copyToResult(result, tmpResult, destinationIndexes) {
            for (let i = 0; i < destinationIndexes.length; i++) {
                result[destinationIndexes[i]] = tmpResult[i];
            }
        }
        static findRowsWithPattern(matrix, height, width, startRow, startColumn, pattern) {
            // const result = new ResultPoint[4];
            const result = new Array(4);
            let found = false;
            const counters = new Int32Array(pattern.length);
            for (; startRow < height; startRow += Detector$3.ROW_STEP) {
                let loc = Detector$3.findGuardPattern(matrix, startColumn, startRow, width, false, pattern, counters);
                if (loc != null) {
                    while (startRow > 0) {
                        const previousRowLoc = Detector$3.findGuardPattern(matrix, startColumn, --startRow, width, false, pattern, counters);
                        if (previousRowLoc != null) {
                            loc = previousRowLoc;
                        }
                        else {
                            startRow++;
                            break;
                        }
                    }
                    result[0] = new ResultPoint(loc[0], startRow);
                    result[1] = new ResultPoint(loc[1], startRow);
                    found = true;
                    break;
                }
            }
            let stopRow = startRow + 1;
            // Last row of the current symbol that contains pattern
            if (found) {
                let skippedRowCount = 0;
                let previousRowLoc = Int32Array.from([Math.trunc(result[0].getX()), Math.trunc(result[1].getX())]);
                for (; stopRow < height; stopRow++) {
                    const loc = Detector$3.findGuardPattern(matrix, previousRowLoc[0], stopRow, width, false, pattern, counters);
                    // a found pattern is only considered to belong to the same barcode if the start and end positions
                    // don't differ too much. Pattern drift should be not bigger than two for consecutive rows. With
                    // a higher number of skipped rows drift could be larger. To keep it simple for now, we allow a slightly
                    // larger drift and don't check for skipped rows.
                    if (loc != null &&
                        Math.abs(previousRowLoc[0] - loc[0]) < Detector$3.MAX_PATTERN_DRIFT &&
                        Math.abs(previousRowLoc[1] - loc[1]) < Detector$3.MAX_PATTERN_DRIFT) {
                        previousRowLoc = loc;
                        skippedRowCount = 0;
                    }
                    else {
                        if (skippedRowCount > Detector$3.SKIPPED_ROW_COUNT_MAX) {
                            break;
                        }
                        else {
                            skippedRowCount++;
                        }
                    }
                }
                stopRow -= skippedRowCount + 1;
                result[2] = new ResultPoint(previousRowLoc[0], stopRow);
                result[3] = new ResultPoint(previousRowLoc[1], stopRow);
            }
            if (stopRow - startRow < Detector$3.BARCODE_MIN_HEIGHT) {
                Arrays.fill(result, null);
            }
            return result;
        }
        /**
         * @param matrix row of black/white values to search
         * @param column x position to start search
         * @param row y position to start search
         * @param width the number of pixels to search on this row
         * @param pattern pattern of counts of number of black and white pixels that are
         *                 being searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints.
         */
        static findGuardPattern(matrix, column, row, width, whiteFirst, pattern, counters) {
            Arrays.fillWithin(counters, 0, counters.length, 0);
            let patternStart = column;
            let pixelDrift = 0;
            // if there are black pixels left of the current pixel shift to the left, but only for MAX_PIXEL_DRIFT pixels
            while (matrix.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector$3.MAX_PIXEL_DRIFT) {
                patternStart--;
            }
            let x = patternStart;
            let counterPosition = 0;
            let patternLength = pattern.length;
            for (let isWhite = whiteFirst; x < width; x++) {
                let pixel = matrix.get(x, row);
                if (pixel !== isWhite) {
                    counters[counterPosition]++;
                }
                else {
                    if (counterPosition === patternLength - 1) {
                        if (Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) {
                            return new Int32Array([patternStart, x]);
                        }
                        patternStart += counters[0] + counters[1];
                        System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    }
                    else {
                        counterPosition++;
                    }
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            if (counterPosition === patternLength - 1 &&
                Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) {
                return new Int32Array([patternStart, x - 1]);
            }
            return null;
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white
         * values matches a given target pattern. This is reported as the ratio of
         * the total variance from the expected pattern proportions across all
         * pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */
        static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            let numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for (let i = 0; i < numCounters; i++) {
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) {
                // If we don't even have one pixel per unit of bar width, assume this
                // is too small to reliably match, so fail:
                return /*Float.POSITIVE_INFINITY*/ Infinity;
            }
            // We're going to fake floating-point math in integers. We just need to use more bits.
            // Scale up patternLength so that intermediate values below like scaledCounter will have
            // more "significant digits".
            let unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for (let x = 0; x < numCounters; x++) {
                let counter = counters[x];
                let scaledPattern = pattern[x] * unitBarWidth;
                let variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) {
                    return /*Float.POSITIVE_INFINITY*/ Infinity;
                }
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    Detector$3.INDEXES_START_PATTERN = Int32Array.from([0, 4, 1, 5]);
    Detector$3.INDEXES_STOP_PATTERN = Int32Array.from([6, 2, 7, 3]);
    Detector$3.MAX_AVG_VARIANCE = 0.42;
    Detector$3.MAX_INDIVIDUAL_VARIANCE = 0.8;
    // B S B S B S B S Bar/Space pattern
    // 11111111 0 1 0 1 0 1 000
    Detector$3.START_PATTERN = Int32Array.from([8, 1, 1, 1, 1, 1, 1, 3]);
    // 1111111 0 1 000 1 0 1 00 1
    Detector$3.STOP_PATTERN = Int32Array.from([7, 1, 1, 3, 1, 1, 1, 2, 1]);
    Detector$3.MAX_PIXEL_DRIFT = 3;
    Detector$3.MAX_PATTERN_DRIFT = 5;
    // if we set the value too low, then we don't detect the correct height of the bar if the start patterns are damaged.
    // if we set the value too high, then we might detect the start pattern from a neighbor barcode.
    Detector$3.SKIPPED_ROW_COUNT_MAX = 25;
    // A PDF471 barcode should have at least 3 rows, with each row being >= 3 times the module width. Therefore it should be at least
    // 9 pixels tall. To be conservative, we use about half the size to ensure we don't miss it.
    Detector$3.ROW_STEP = 5;
    Detector$3.BARCODE_MIN_HEIGHT = 10;

    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGFPoly
     */
    /*final*/ class ModulusPoly {
        constructor(field, coefficients) {
            if (coefficients.length === 0) {
                throw new IllegalArgumentException();
            }
            this.field = field;
            let coefficientsLength = /*int*/ coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = /*int*/ 1;
                while (firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0) {
                    firstNonZero++;
                }
                if (firstNonZero === coefficientsLength) {
                    this.coefficients = new Int32Array([0]);
                }
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            }
            else {
                this.coefficients = coefficients;
            }
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */
        getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */
        isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */
        getCoefficient(degree) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */
        evaluateAt(a) {
            if (a === 0) {
                // Just return the x^0 coefficient
                return this.getCoefficient(0);
            }
            if (a === 1) {
                // Just the sum of the coefficients
                let sum = /*int*/ 0;
                for (let coefficient /*int*/ of this.coefficients) {
                    sum = this.field.add(sum, coefficient);
                }
                return sum;
            }
            let result = /*int*/ this.coefficients[0];
            let size = /*int*/ this.coefficients.length;
            for (let i /*int*/ = 1; i < size; i++) {
                result = this.field.add(this.field.multiply(a, result), this.coefficients[i]);
            }
            return result;
        }
        add(other) {
            if (!this.field.equals(other.field)) {
                throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            }
            if (this.isZero()) {
                return other;
            }
            if (other.isZero()) {
                return this;
            }
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                let temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            let lengthDiff = /*int*/ largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for (let i /*int*/ = lengthDiff; i < largerCoefficients.length; i++) {
                sumDiff[i] = this.field.add(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            }
            return new ModulusPoly(this.field, sumDiff);
        }
        subtract(other) {
            if (!this.field.equals(other.field)) {
                throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            }
            if (other.isZero()) {
                return this;
            }
            return this.add(other.negative());
        }
        multiply(other) {
            if (other instanceof ModulusPoly) {
                return this.multiplyOther(other);
            }
            return this.multiplyScalar(other);
        }
        multiplyOther(other) {
            if (!this.field.equals(other.field)) {
                throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            }
            if (this.isZero() || other.isZero()) {
                // return this.field.getZero();
                return new ModulusPoly(this.field, new Int32Array([0]));
            }
            let aCoefficients = this.coefficients;
            let aLength = /*int*/ aCoefficients.length;
            let bCoefficients = other.coefficients;
            let bLength = /*int*/ bCoefficients.length;
            let product = new Int32Array(aLength + bLength - 1);
            for (let i /*int*/ = 0; i < aLength; i++) {
                let aCoeff = /*int*/ aCoefficients[i];
                for (let j /*int*/ = 0; j < bLength; j++) {
                    product[i + j] = this.field.add(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
                }
            }
            return new ModulusPoly(this.field, product);
        }
        negative() {
            let size = /*int*/ this.coefficients.length;
            let negativeCoefficients = new Int32Array(size);
            for (let i /*int*/ = 0; i < size; i++) {
                negativeCoefficients[i] = this.field.subtract(0, this.coefficients[i]);
            }
            return new ModulusPoly(this.field, negativeCoefficients);
        }
        multiplyScalar(scalar) {
            if (scalar === 0) {
                return new ModulusPoly(this.field, new Int32Array([0]));
            }
            if (scalar === 1) {
                return this;
            }
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size);
            for (let i /*int*/ = 0; i < size; i++) {
                product[i] = this.field.multiply(this.coefficients[i], scalar);
            }
            return new ModulusPoly(this.field, product);
        }
        multiplyByMonomial(degree, coefficient) {
            if (degree < 0) {
                throw new IllegalArgumentException();
            }
            if (coefficient === 0) {
                return new ModulusPoly(this.field, new Int32Array([0]));
            }
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size + degree);
            for (let i /*int*/ = 0; i < size; i++) {
                product[i] = this.field.multiply(this.coefficients[i], coefficient);
            }
            return new ModulusPoly(this.field, product);
        }
        /*
        ModulusPoly[] divide(other: ModulusPoly) {
          if (!field.equals(other.field)) {
            throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
          }
          if (other.isZero()) {
            throw new IllegalArgumentException("Divide by 0");
          }
      
          let quotient: ModulusPoly = field.getZero();
          let remainder: ModulusPoly = this;
      
          let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
          let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
      
          while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
            let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
            let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
            let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.add(iterationQuotient);
            remainder = remainder.subtract(term);
          }
      
          return new ModulusPoly[] { quotient, remainder };
        }
        */
        // @Override
        toString() {
            let result = new StringBuilder( /*8 * this.getDegree()*/); // dynamic string size in JS
            for (let degree /*int*/ = this.getDegree(); degree >= 0; degree--) {
                let coefficient = /*int*/ this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result.append(' - ');
                        coefficient = -coefficient;
                    }
                    else {
                        if (result.length() > 0) {
                            result.append(' + ');
                        }
                    }
                    if (degree === 0 || coefficient !== 1) {
                        result.append(coefficient);
                    }
                    if (degree !== 0) {
                        if (degree === 1) {
                            result.append('x');
                        }
                        else {
                            result.append('x^');
                            result.append(degree);
                        }
                    }
                }
            }
            return result.toString();
        }
    }

    class ModulusBase {
        add(a, b) {
            return (a + b) % this.modulus;
        }
        subtract(a, b) {
            return (this.modulus + a - b) % this.modulus;
        }
        exp(a) {
            return this.expTable[a];
        }
        log(a) {
            if (a === 0) {
                throw new IllegalArgumentException();
            }
            return this.logTable[a];
        }
        inverse(a) {
            if (a === 0) {
                throw new ArithmeticException();
            }
            return this.expTable[this.modulus - this.logTable[a] - 1];
        }
        multiply(a, b) {
            if (a === 0 || b === 0) {
                return 0;
            }
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
        }
        getSize() {
            return this.modulus;
        }
        equals(o) {
            return o === this;
        }
    }

    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * <p>A field based on powers of a generator integer, modulo some modulus.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGF
     */
    /*public final*/ class ModulusGF extends ModulusBase {
        // private /*final*/ modulus: /*int*/ number;
        constructor(modulus, generator) {
            super();
            this.modulus = modulus;
            this.expTable = new Int32Array(modulus);
            this.logTable = new Int32Array(modulus);
            let x = /*int*/ 1;
            for (let i /*int*/ = 0; i < modulus; i++) {
                this.expTable[i] = x;
                x = (x * generator) % modulus;
            }
            for (let i /*int*/ = 0; i < modulus - 1; i++) {
                this.logTable[this.expTable[i]] = i;
            }
            // logTable[0] == 0 but this should never be used
            this.zero = new ModulusPoly(this, new Int32Array([0]));
            this.one = new ModulusPoly(this, new Int32Array([1]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        buildMonomial(degree, coefficient) {
            if (degree < 0) {
                throw new IllegalArgumentException();
            }
            if (coefficient === 0) {
                return this.zero;
            }
            let coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new ModulusPoly(this, coefficients);
        }
    }
    ModulusGF.PDF417_GF = new ModulusGF(PDF417Common.NUMBER_OF_CODEWORDS, 3);

    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * <p>PDF417 error correction implementation.</p>
     *
     * <p>This <a href="http://en.wikipedia.org/wiki/Reed%E2%80%93Solomon_error_correction#Example">example</a>
     * is quite useful in understanding the algorithm.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.ReedSolomonDecoder
     */
    /*public final*/ class ErrorCorrection {
        constructor() {
            this.field = ModulusGF.PDF417_GF;
        }
        /**
         * @param received received codewords
         * @param numECCodewords number of those codewords used for EC
         * @param erasures location of erasures
         * @return number of errors
         * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
         */
        decode(received, numECCodewords, erasures) {
            let poly = new ModulusPoly(this.field, received);
            let S = new Int32Array(numECCodewords);
            let error = false;
            for (let i /*int*/ = numECCodewords; i > 0; i--) {
                let evaluation = poly.evaluateAt(this.field.exp(i));
                S[numECCodewords - i] = evaluation;
                if (evaluation !== 0) {
                    error = true;
                }
            }
            if (!error) {
                return 0;
            }
            let knownErrors = this.field.getOne();
            if (erasures != null) {
                for (const erasure of erasures) {
                    let b = this.field.exp(received.length - 1 - erasure);
                    // Add (1 - bx) term:
                    let term = new ModulusPoly(this.field, new Int32Array([this.field.subtract(0, b), 1]));
                    knownErrors = knownErrors.multiply(term);
                }
            }
            let syndrome = new ModulusPoly(this.field, S);
            // syndrome = syndrome.multiply(knownErrors);
            let sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
            let sigma = sigmaOmega[0];
            let omega = sigmaOmega[1];
            // sigma = sigma.multiply(knownErrors);
            let errorLocations = this.findErrorLocations(sigma);
            let errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
            for (let i /*int*/ = 0; i < errorLocations.length; i++) {
                let position = received.length - 1 - this.field.log(errorLocations[i]);
                if (position < 0) {
                    throw ChecksumException.getChecksumInstance();
                }
                received[position] = this.field.subtract(received[position], errorMagnitudes[i]);
            }
            return errorLocations.length;
        }
        /**
         *
         * @param ModulusPoly
         * @param a
         * @param ModulusPoly
         * @param b
         * @param int
         * @param R
         * @throws ChecksumException
         */
        runEuclideanAlgorithm(a, b, R) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                let temp = a;
                a = b;
                b = temp;
            }
            let rLast = a;
            let r = b;
            let tLast = this.field.getZero();
            let t = this.field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while (r.getDegree() >= Math.round(R / 2)) {
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) {
                    // Oops, Euclidean algorithm already terminated?
                    throw ChecksumException.getChecksumInstance();
                }
                r = rLastLast;
                let q = this.field.getZero();
                let denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                let dltInverse = this.field.inverse(denominatorLeadingTerm);
                while (r.getDegree() >= rLast.getDegree() && !r.isZero()) {
                    let degreeDiff = r.getDegree() - rLast.getDegree();
                    let scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.add(this.field.buildMonomial(degreeDiff, scale));
                    r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).subtract(tLastLast).negative();
            }
            let sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) {
                throw ChecksumException.getChecksumInstance();
            }
            let inverse = this.field.inverse(sigmaTildeAtZero);
            let sigma = t.multiply(inverse);
            let omega = r.multiply(inverse);
            return [sigma, omega];
        }
        /**
         *
         * @param errorLocator
         * @throws ChecksumException
         */
        findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            let numErrors = errorLocator.getDegree();
            let result = new Int32Array(numErrors);
            let e = 0;
            for (let i /*int*/ = 1; i < this.field.getSize() && e < numErrors; i++) {
                if (errorLocator.evaluateAt(i) === 0) {
                    result[e] = this.field.inverse(i);
                    e++;
                }
            }
            if (e !== numErrors) {
                throw ChecksumException.getChecksumInstance();
            }
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocator, errorLocations) {
            let errorLocatorDegree = errorLocator.getDegree();
            let formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
            for (let i /*int*/ = 1; i <= errorLocatorDegree; i++) {
                formalDerivativeCoefficients[errorLocatorDegree - i] =
                    this.field.multiply(i, errorLocator.getCoefficient(i));
            }
            let formalDerivative = new ModulusPoly(this.field, formalDerivativeCoefficients);
            // This is directly applying Forney's Formula
            let s = errorLocations.length;
            let result = new Int32Array(s);
            for (let i /*int*/ = 0; i < s; i++) {
                let xiInverse = this.field.inverse(errorLocations[i]);
                let numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
                let denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
                result[i] = this.field.multiply(numerator, denominator);
            }
            return result;
        }
    }

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * @author Guenther Grau
     */
    /*final*/ class BoundingBox {
        constructor(image, topLeft, bottomLeft, topRight, bottomRight) {
            if (image instanceof BoundingBox) {
                this.constructor_2(image);
            }
            else {
                this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
            }
        }
        /**
         *
         * @param image
         * @param topLeft
         * @param bottomLeft
         * @param topRight
         * @param bottomRight
         *
         * @throws NotFoundException
         */
        constructor_1(image, topLeft, bottomLeft, topRight, bottomRight) {
            const leftUnspecified = topLeft == null || bottomLeft == null;
            const rightUnspecified = topRight == null || bottomRight == null;
            if (leftUnspecified && rightUnspecified) {
                throw new NotFoundException();
            }
            if (leftUnspecified) {
                topLeft = new ResultPoint(0, topRight.getY());
                bottomLeft = new ResultPoint(0, bottomRight.getY());
            }
            else if (rightUnspecified) {
                topRight = new ResultPoint(image.getWidth() - 1, topLeft.getY());
                bottomRight = new ResultPoint(image.getWidth() - 1, bottomLeft.getY());
            }
            this.image = image;
            this.topLeft = topLeft;
            this.bottomLeft = bottomLeft;
            this.topRight = topRight;
            this.bottomRight = bottomRight;
            this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
            this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
            this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
            this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
        }
        constructor_2(boundingBox) {
            this.image = boundingBox.image;
            this.topLeft = boundingBox.getTopLeft();
            this.bottomLeft = boundingBox.getBottomLeft();
            this.topRight = boundingBox.getTopRight();
            this.bottomRight = boundingBox.getBottomRight();
            this.minX = boundingBox.getMinX();
            this.maxX = boundingBox.getMaxX();
            this.minY = boundingBox.getMinY();
            this.maxY = boundingBox.getMaxY();
        }
        /**
         * @throws NotFoundException
         */
        static merge(leftBox, rightBox) {
            if (leftBox == null) {
                return rightBox;
            }
            if (rightBox == null) {
                return leftBox;
            }
            return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
        }
        /**
         * @throws NotFoundException
         */
        addMissingRows(missingStartRows, missingEndRows, isLeft) {
            let newTopLeft = this.topLeft;
            let newBottomLeft = this.bottomLeft;
            let newTopRight = this.topRight;
            let newBottomRight = this.bottomRight;
            if (missingStartRows > 0) {
                let top = isLeft ? this.topLeft : this.topRight;
                let newMinY = Math.trunc(top.getY() - missingStartRows);
                if (newMinY < 0) {
                    newMinY = 0;
                }
                let newTop = new ResultPoint(top.getX(), newMinY);
                if (isLeft) {
                    newTopLeft = newTop;
                }
                else {
                    newTopRight = newTop;
                }
            }
            if (missingEndRows > 0) {
                let bottom = isLeft ? this.bottomLeft : this.bottomRight;
                let newMaxY = Math.trunc(bottom.getY() + missingEndRows);
                if (newMaxY >= this.image.getHeight()) {
                    newMaxY = this.image.getHeight() - 1;
                }
                let newBottom = new ResultPoint(bottom.getX(), newMaxY);
                if (isLeft) {
                    newBottomLeft = newBottom;
                }
                else {
                    newBottomRight = newBottom;
                }
            }
            return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
        }
        getMinX() {
            return this.minX;
        }
        getMaxX() {
            return this.maxX;
        }
        getMinY() {
            return this.minY;
        }
        getMaxY() {
            return this.maxY;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getBottomRight() {
            return this.bottomRight;
        }
    }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */
    /*final*/ class BarcodeMetadata {
        constructor(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel) {
            this.columnCount = columnCount;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.rowCountUpperPart = rowCountUpperPart;
            this.rowCountLowerPart = rowCountLowerPart;
            this.rowCount = rowCountUpperPart + rowCountLowerPart;
        }
        getColumnCount() {
            return this.columnCount;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getRowCount() {
            return this.rowCount;
        }
        getRowCountUpperPart() {
            return this.rowCountUpperPart;
        }
        getRowCountLowerPart() {
            return this.rowCountLowerPart;
        }
    }

    /**
     * Java Formatter class polyfill that works in the JS way.
     */
    class Formatter {
        constructor() {
            this.buffer = '';
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param str
         * @param arr
         */
        static form(str, arr) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%')
                    return '%';
                if (arr[++i] === undefined)
                    return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch (p4) {
                    case 's':
                        val = arr[i];
                        break;
                    case 'c':
                        val = arr[i][0];
                        break;
                    case 'f':
                        val = parseFloat(arr[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(arr[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(arr[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(arr[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(arr[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */
                let ch = p1 && (p1[0] + '') === '0' ? '0' : ' '; /* isnull? */
                while (val.length < size)
                    val = p0 !== undefined ? val + ch : ch + val; /* isminus? */
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return str.replace(regex, callback);
        }
        /**
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */
        format(append, ...args) {
            this.buffer += Formatter.form(append, args);
        }
        /**
         * Returns the Formatter string value.
         */
        toString() {
            return this.buffer;
        }
    }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @author Guenther Grau
     */
    class DetectionResultColumn {
        constructor(boundingBox) {
            this.boundingBox = new BoundingBox(boundingBox);
            // this.codewords = new Codeword[boundingBox.getMaxY() - boundingBox.getMinY() + 1];
            this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
        }
        /*final*/ getCodewordNearby(imageRow) {
            let codeword = this.getCodeword(imageRow);
            if (codeword != null) {
                return codeword;
            }
            for (let i = 1; i < DetectionResultColumn.MAX_NEARBY_DISTANCE; i++) {
                let nearImageRow = this.imageRowToCodewordIndex(imageRow) - i;
                if (nearImageRow >= 0) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) {
                        return codeword;
                    }
                }
                nearImageRow = this.imageRowToCodewordIndex(imageRow) + i;
                if (nearImageRow < this.codewords.length) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) {
                        return codeword;
                    }
                }
            }
            return null;
        }
        /*final int*/ imageRowToCodewordIndex(imageRow) {
            return imageRow - this.boundingBox.getMinY();
        }
        /*final void*/ setCodeword(imageRow, codeword) {
            this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
        }
        /*final*/ getCodeword(imageRow) {
            return this.codewords[this.imageRowToCodewordIndex(imageRow)];
        }
        /*final*/ getBoundingBox() {
            return this.boundingBox;
        }
        /*final*/ getCodewords() {
            return this.codewords;
        }
        // @Override
        toString() {
            const formatter = new Formatter();
            let row = 0;
            for (const codeword of this.codewords) {
                if (codeword == null) {
                    formatter.format('%3d:    |   %n', row++);
                    continue;
                }
                formatter.format('%3d: %3d|%3d%n', row++, codeword.getRowNumber(), codeword.getValue());
            }
            return formatter.toString();
        }
    }
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.HashMap;
    // import java.util.Map;
    // import java.util.Map.Entry;
    /**
     * @author Guenther Grau
     */
    /*final*/ class BarcodeValue {
        constructor() {
            this.values = new Map();
        }
        /**
         * Add an occurrence of a value
         */
        setValue(value) {
            value = Math.trunc(value);
            let confidence = this.values.get(value);
            if (confidence == null) {
                confidence = 0;
            }
            confidence++;
            this.values.set(value, confidence);
        }
        /**
         * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
         * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
         */
        getValue() {
            let maxConfidence = -1;
            let result = new Array();
            for (const [key, value] of this.values.entries()) {
                const entry = {
                    getKey: () => key,
                    getValue: () => value,
                };
                if (entry.getValue() > maxConfidence) {
                    maxConfidence = entry.getValue();
                    result = [];
                    result.push(entry.getKey());
                }
                else if (entry.getValue() === maxConfidence) {
                    result.push(entry.getKey());
                }
            }
            return PDF417Common.toIntArray(result);
        }
        getConfidence(value) {
            return this.values.get(value);
        }
    }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @author Guenther Grau
     */
    /*final*/ class DetectionResultRowIndicatorColumn extends DetectionResultColumn {
        constructor(boundingBox, isLeft) {
            super(boundingBox);
            this._isLeft = isLeft;
        }
        setRowNumbers() {
            for (let codeword /*Codeword*/ of this.getCodewords()) {
                if (codeword != null) {
                    codeword.setRowNumberAsRowIndicatorColumn();
                }
            }
        }
        // TODO implement properly
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustCompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let codewords = this.getCodewords();
            this.setRowNumbers();
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // We need to be careful using the average row height. Barcode could be skewed so that we have smaller and
            // taller rows
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let barcodeRow = -1;
            let maxRowHeight = 1;
            let currentRowHeight = 0;
            for (let codewordsRow /*int*/ = firstRow; codewordsRow < lastRow; codewordsRow++) {
                if (codewords[codewordsRow] == null) {
                    continue;
                }
                let codeword = codewords[codewordsRow];
                //      float expectedRowNumber = (codewordsRow - firstRow) / averageRowHeight;
                //      if (Math.abs(codeword.getRowNumber() - expectedRowNumber) > 2) {
                //        SimpleLog.log(LEVEL.WARNING,
                //            "Removing codeword, rowNumberSkew too high, codeword[" + codewordsRow + "]: Expected Row: " +
                //                expectedRowNumber + ", RealRow: " + codeword.getRowNumber() + ", value: " + codeword.getValue());
                //        codewords[codewordsRow] = null;
                //      }
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) {
                    currentRowHeight++;
                }
                else if (rowDifference === 1) {
                    maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                    currentRowHeight = 1;
                    barcodeRow = codeword.getRowNumber();
                }
                else if (rowDifference < 0 ||
                    codeword.getRowNumber() >= barcodeMetadata.getRowCount() ||
                    rowDifference > codewordsRow) {
                    codewords[codewordsRow] = null;
                }
                else {
                    let checkedRows;
                    if (maxRowHeight > 2) {
                        checkedRows = (maxRowHeight - 2) * rowDifference;
                    }
                    else {
                        checkedRows = rowDifference;
                    }
                    let closePreviousCodewordFound = checkedRows >= codewordsRow;
                    for (let i /*int*/ = 1; i <= checkedRows && !closePreviousCodewordFound; i++) {
                        // there must be (height * rowDifference) number of codewords missing. For now we assume height = 1.
                        // This should hopefully get rid of most problems already.
                        closePreviousCodewordFound = codewords[codewordsRow - i] != null;
                    }
                    if (closePreviousCodewordFound) {
                        codewords[codewordsRow] = null;
                    }
                    else {
                        barcodeRow = codeword.getRowNumber();
                        currentRowHeight = 1;
                    }
                }
            }
            // return (int) (averageRowHeight + 0.5);
        }
        getRowHeights() {
            let barcodeMetadata = this.getBarcodeMetadata();
            if (barcodeMetadata == null) {
                return null;
            }
            this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
            let result = new Int32Array(barcodeMetadata.getRowCount());
            for (let codeword /*Codeword*/ of this.getCodewords()) {
                if (codeword != null) {
                    let rowNumber = codeword.getRowNumber();
                    if (rowNumber >= result.length) {
                        // We have more rows than the barcode metadata allows for, ignore them.
                        continue;
                    }
                    result[rowNumber]++;
                } // else throw exception?
            }
            return result;
        }
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let codewords = this.getCodewords();
            let barcodeRow = -1;
            for (let codewordsRow /*int*/ = firstRow; codewordsRow < lastRow; codewordsRow++) {
                if (codewords[codewordsRow] == null) {
                    continue;
                }
                let codeword = codewords[codewordsRow];
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) ;
                else if (rowDifference === 1) {
                    barcodeRow = codeword.getRowNumber();
                }
                else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) {
                    codewords[codewordsRow] = null;
                }
                else {
                    barcodeRow = codeword.getRowNumber();
                }
            }
            // return (int) (averageRowHeight + 0.5);
        }
        getBarcodeMetadata() {
            let codewords = this.getCodewords();
            let barcodeColumnCount = new BarcodeValue();
            let barcodeRowCountUpperPart = new BarcodeValue();
            let barcodeRowCountLowerPart = new BarcodeValue();
            let barcodeECLevel = new BarcodeValue();
            for (let codeword /*Codeword*/ of codewords) {
                if (codeword == null) {
                    continue;
                }
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (!this._isLeft) {
                    codewordRowNumber += 2;
                }
                switch (codewordRowNumber % 3) {
                    case 0:
                        barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
                        break;
                    case 1:
                        barcodeECLevel.setValue(rowIndicatorValue / 3);
                        barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
                        break;
                    case 2:
                        barcodeColumnCount.setValue(rowIndicatorValue + 1);
                        break;
                }
            }
            // Maybe we should check if we have ambiguous values?
            if ((barcodeColumnCount.getValue().length === 0) ||
                (barcodeRowCountUpperPart.getValue().length === 0) ||
                (barcodeRowCountLowerPart.getValue().length === 0) ||
                (barcodeECLevel.getValue().length === 0) ||
                barcodeColumnCount.getValue()[0] < 1 ||
                barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < PDF417Common.MIN_ROWS_IN_BARCODE ||
                barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > PDF417Common.MAX_ROWS_IN_BARCODE) {
                return null;
            }
            let barcodeMetadata = new BarcodeMetadata(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            return barcodeMetadata;
        }
        removeIncorrectCodewords(codewords, barcodeMetadata) {
            // Remove codewords which do not match the metadata
            // TODO Maybe we should keep the incorrect codewords for the start and end positions?
            for (let codewordRow /*int*/ = 0; codewordRow < codewords.length; codewordRow++) {
                let codeword = codewords[codewordRow];
                if (codewords[codewordRow] == null) {
                    continue;
                }
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (codewordRowNumber > barcodeMetadata.getRowCount()) {
                    codewords[codewordRow] = null;
                    continue;
                }
                if (!this._isLeft) {
                    codewordRowNumber += 2;
                }
                switch (codewordRowNumber % 3) {
                    case 0:
                        if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) {
                            codewords[codewordRow] = null;
                        }
                        break;
                    case 1:
                        if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() ||
                            rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) {
                            codewords[codewordRow] = null;
                        }
                        break;
                    case 2:
                        if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) {
                            codewords[codewordRow] = null;
                        }
                        break;
                }
            }
        }
        isLeft() {
            return this._isLeft;
        }
        // @Override
        toString() {
            return 'IsLeft: ' + this._isLeft + '\n' + super.toString();
        }
    }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @author Guenther Grau
     */
    /*final*/ class DetectionResult {
        constructor(barcodeMetadata, boundingBox) {
            /*final*/ this.ADJUST_ROW_NUMBER_SKIP = 2;
            this.barcodeMetadata = barcodeMetadata;
            this.barcodeColumnCount = barcodeMetadata.getColumnCount();
            this.boundingBox = boundingBox;
            // this.detectionResultColumns = new DetectionResultColumn[this.barcodeColumnCount + 2];
            this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
        }
        getDetectionResultColumns() {
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
            let unadjustedCodewordCount = PDF417Common.MAX_CODEWORDS_IN_BARCODE;
            let previousUnadjustedCount;
            do {
                previousUnadjustedCount = unadjustedCodewordCount;
                unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
            } while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
            return this.detectionResultColumns;
        }
        adjustIndicatorColumnRowNumbers(detectionResultColumn) {
            if (detectionResultColumn != null) {
                detectionResultColumn
                    .adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
            }
        }
        // TODO ensure that no detected codewords with unknown row number are left
        // we should be able to estimate the row height and use it as a hint for the row number
        // we should also fill the rows top to bottom and bottom to top
        /**
         * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
         * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
         */
        adjustRowNumbersAndGetCount() {
            let unadjustedCount = this.adjustRowNumbersByRow();
            if (unadjustedCount === 0) {
                return 0;
            }
            for (let barcodeColumn /*int*/ = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++) {
                let codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
                for (let codewordsRow /*int*/ = 0; codewordsRow < codewords.length; codewordsRow++) {
                    if (codewords[codewordsRow] == null) {
                        continue;
                    }
                    if (!codewords[codewordsRow].hasValidRowNumber()) {
                        this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
                    }
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersByRow() {
            this.adjustRowNumbersFromBothRI();
            // TODO we should only do full row adjustments if row numbers of left and right row indicator column match.
            // Maybe it's even better to calculated the height (rows: d) and divide it by the number of barcode
            // rows. This, together with the LRI and RRI row numbers should allow us to get a good estimate where a row
            // number starts and ends.
            let unadjustedCount = this.adjustRowNumbersFromLRI();
            return unadjustedCount + this.adjustRowNumbersFromRRI();
        }
        adjustRowNumbersFromBothRI() {
            if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) {
                return;
            }
            let LRIcodewords = this.detectionResultColumns[0].getCodewords();
            let RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for (let codewordsRow /*int*/ = 0; codewordsRow < LRIcodewords.length; codewordsRow++) {
                if (LRIcodewords[codewordsRow] != null &&
                    RRIcodewords[codewordsRow] != null &&
                    LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) {
                    for (let barcodeColumn /*int*/ = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++) {
                        let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                        if (codeword == null) {
                            continue;
                        }
                        codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
                        if (!codeword.hasValidRowNumber()) {
                            this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
                        }
                    }
                }
            }
        }
        adjustRowNumbersFromRRI() {
            if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) {
                return 0;
            }
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for (let codewordsRow /*int*/ = 0; codewordsRow < codewords.length; codewordsRow++) {
                if (codewords[codewordsRow] == null) {
                    continue;
                }
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for (let barcodeColumn /*int*/ = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--) {
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) {
                            unadjustedCount++;
                        }
                    }
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersFromLRI() {
            if (this.detectionResultColumns[0] == null) {
                return 0;
            }
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[0].getCodewords();
            for (let codewordsRow /*int*/ = 0; codewordsRow < codewords.length; codewordsRow++) {
                if (codewords[codewordsRow] == null) {
                    continue;
                }
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for (let barcodeColumn /*int*/ = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++) {
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) {
                            unadjustedCount++;
                        }
                    }
                }
            }
            return unadjustedCount;
        }
        static adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword) {
            if (codeword == null) {
                return invalidRowCounts;
            }
            if (!codeword.hasValidRowNumber()) {
                if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
                    codeword.setRowNumber(rowIndicatorRowNumber);
                    invalidRowCounts = 0;
                }
                else {
                    ++invalidRowCounts;
                }
            }
            return invalidRowCounts;
        }
        adjustRowNumbers(barcodeColumn, codewordsRow, codewords) {
            if (!this.detectionResultColumns[barcodeColumn - 1]) {
                return;
            }
            let codeword = codewords[codewordsRow];
            let previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
            let nextColumnCodewords = previousColumnCodewords;
            if (this.detectionResultColumns[barcodeColumn + 1] != null) {
                nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
            }
            // let otherCodewords: Codeword[] = new Codeword[14];
            let otherCodewords = new Array(14);
            otherCodewords[2] = previousColumnCodewords[codewordsRow];
            otherCodewords[3] = nextColumnCodewords[codewordsRow];
            if (codewordsRow > 0) {
                otherCodewords[0] = codewords[codewordsRow - 1];
                otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
                otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
            }
            if (codewordsRow > 1) {
                otherCodewords[8] = codewords[codewordsRow - 2];
                otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
                otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
            }
            if (codewordsRow < codewords.length - 1) {
                otherCodewords[1] = codewords[codewordsRow + 1];
                otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
                otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
            }
            if (codewordsRow < codewords.length - 2) {
                otherCodewords[9] = codewords[codewordsRow + 2];
                otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
                otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
            }
            for (let otherCodeword of otherCodewords) {
                if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) {
                    return;
                }
            }
        }
        /**
         * @return true, if row number was adjusted, false otherwise
         */
        static adjustRowNumber(codeword, otherCodeword) {
            if (otherCodeword == null) {
                return false;
            }
            if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
                codeword.setRowNumber(otherCodeword.getRowNumber());
                return true;
            }
            return false;
        }
        getBarcodeColumnCount() {
            return this.barcodeColumnCount;
        }
        getBarcodeRowCount() {
            return this.barcodeMetadata.getRowCount();
        }
        getBarcodeECLevel() {
            return this.barcodeMetadata.getErrorCorrectionLevel();
        }
        setBoundingBox(boundingBox) {
            this.boundingBox = boundingBox;
        }
        getBoundingBox() {
            return this.boundingBox;
        }
        setDetectionResultColumn(barcodeColumn, detectionResultColumn) {
            this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
        }
        getDetectionResultColumn(barcodeColumn) {
            return this.detectionResultColumns[barcodeColumn];
        }
        // @Override
        toString() {
            let rowIndicatorColumn = this.detectionResultColumns[0];
            if (rowIndicatorColumn == null) {
                rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
            }
            // try (
            let formatter = new Formatter();
            // ) {
            for (let codewordsRow /*int*/ = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++) {
                formatter.format('CW %3d:', codewordsRow);
                for (let barcodeColumn /*int*/ = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++) {
                    if (this.detectionResultColumns[barcodeColumn] == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    formatter.format(' %3d|%3d', codeword.getRowNumber(), codeword.getValue());
                }
                formatter.format('%n');
            }
            return formatter.toString();
            // }
        }
    }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */
    /*final*/ class Codeword {
        constructor(startX, endX, bucket, value) {
            this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
            this.startX = Math.trunc(startX);
            this.endX = Math.trunc(endX);
            this.bucket = Math.trunc(bucket);
            this.value = Math.trunc(value);
        }
        hasValidRowNumber() {
            return this.isValidRowNumber(this.rowNumber);
        }
        isValidRowNumber(rowNumber) {
            return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === (rowNumber % 3) * 3;
        }
        setRowNumberAsRowIndicatorColumn() {
            this.rowNumber = Math.trunc((Math.trunc(this.value / 30)) * 3 + Math.trunc(this.bucket / 3));
        }
        getWidth() {
            return this.endX - this.startX;
        }
        getStartX() {
            return this.startX;
        }
        getEndX() {
            return this.endX;
        }
        getBucket() {
            return this.bucket;
        }
        getValue() {
            return this.value;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        setRowNumber(rowNumber) {
            this.rowNumber = rowNumber;
        }
        //   @Override
        toString() {
            return this.rowNumber + '|' + this.value;
        }
    }
    Codeword.BARCODE_ROW_UNKNOWN = -1;

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * @author Guenther Grau
     * @author creatale GmbH (christoph.schulz@creatale.de)
     */
    /*final*/ class PDF417CodewordDecoder {
        /* @note
         * this action have to be performed before first use of class
         * - static constructor
         * working with 32bit float (based from Java logic)
        */
        static initialize() {
            // Pre-computes the symbol ratio table.
            for ( /*int*/let i = 0; i < PDF417Common.SYMBOL_TABLE.length; i++) {
                let currentSymbol = PDF417Common.SYMBOL_TABLE[i];
                let currentBit = currentSymbol & 0x1;
                for ( /*int*/let j = 0; j < PDF417Common.BARS_IN_MODULE; j++) {
                    let size = 0.0;
                    while ((currentSymbol & 0x1) === currentBit) {
                        size += 1.0;
                        currentSymbol >>= 1;
                    }
                    currentBit = currentSymbol & 0x1;
                    if (!PDF417CodewordDecoder.RATIOS_TABLE[i]) {
                        PDF417CodewordDecoder.RATIOS_TABLE[i] = new Array(PDF417Common.BARS_IN_MODULE);
                    }
                    PDF417CodewordDecoder.RATIOS_TABLE[i][PDF417Common.BARS_IN_MODULE - j - 1] = Math.fround(size / PDF417Common.MODULES_IN_CODEWORD);
                }
            }
            this.bSymbolTableReady = true;
        }
        static getDecodedValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
            if (decodedValue !== -1) {
                return decodedValue;
            }
            return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
        }
        static sampleBitCounts(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let result = new Int32Array(PDF417Common.BARS_IN_MODULE);
            let bitCountIndex = 0;
            let sumPreviousBits = 0;
            for ( /*int*/let i = 0; i < PDF417Common.MODULES_IN_CODEWORD; i++) {
                let sampleIndex = bitCountSum / (2 * PDF417Common.MODULES_IN_CODEWORD) +
                    (i * bitCountSum) / PDF417Common.MODULES_IN_CODEWORD;
                if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
                    sumPreviousBits += moduleBitCount[bitCountIndex];
                    bitCountIndex++;
                }
                result[bitCountIndex]++;
            }
            return result;
        }
        static getDecodedCodewordValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
            return PDF417Common.getCodeword(decodedValue) === -1 ? -1 : decodedValue;
        }
        static getBitValue(moduleBitCount) {
            let result = /*long*/ 0;
            for (let /*int*/ i = 0; i < moduleBitCount.length; i++) {
                for ( /*int*/let bit = 0; bit < moduleBitCount[i]; bit++) {
                    result = (result << 1) | (i % 2 === 0 ? 1 : 0);
                }
            }
            return Math.trunc(result);
        }
        // working with 32bit float (as in Java)
        static getClosestDecodedValue(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let bitCountRatios = new Array(PDF417Common.BARS_IN_MODULE);
            if (bitCountSum > 1) {
                for (let /*int*/ i = 0; i < bitCountRatios.length; i++) {
                    bitCountRatios[i] = Math.fround(moduleBitCount[i] / bitCountSum);
                }
            }
            let bestMatchError = Float.MAX_VALUE;
            let bestMatch = -1;
            if (!this.bSymbolTableReady) {
                PDF417CodewordDecoder.initialize();
            }
            for ( /*int*/let j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++) {
                let error = 0.0;
                let ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
                for ( /*int*/let k = 0; k < PDF417Common.BARS_IN_MODULE; k++) {
                    let diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
                    error += Math.fround(diff * diff);
                    if (error >= bestMatchError) {
                        break;
                    }
                }
                if (error < bestMatchError) {
                    bestMatchError = error;
                    bestMatch = PDF417Common.SYMBOL_TABLE[j];
                }
            }
            return bestMatch;
        }
    }
    // flag that the table is ready for use
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array(PDF417Common.SYMBOL_TABLE.length).map(x => x = new Array(PDF417Common.BARS_IN_MODULE));

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // package com.google.zxing.pdf417;
    /**
     * @author Guenther Grau
     */
    /*public final*/ class PDF417ResultMetadata {
        constructor() {
            this.segmentCount = -1;
            this.fileSize = -1;
            this.timestamp = -1;
            this.checksum = -1;
        }
        /**
         * The Segment ID represents the segment of the whole file distributed over different symbols.
         *
         * @return File segment index
         */
        getSegmentIndex() {
            return this.segmentIndex;
        }
        setSegmentIndex(segmentIndex) {
            this.segmentIndex = segmentIndex;
        }
        /**
         * Is the same for each related PDF417 symbol
         *
         * @return File ID
         */
        getFileId() {
            return this.fileId;
        }
        setFileId(fileId) {
            this.fileId = fileId;
        }
        /**
         * @return always null
         * @deprecated use dedicated already parsed fields
         */
        //   @Deprecated
        getOptionalData() {
            return this.optionalData;
        }
        /**
         * @param optionalData old optional data format as int array
         * @deprecated parse and use new fields
         */
        //   @Deprecated
        setOptionalData(optionalData) {
            this.optionalData = optionalData;
        }
        /**
         * @return true if it is the last segment
         */
        isLastSegment() {
            return this.lastSegment;
        }
        setLastSegment(lastSegment) {
            this.lastSegment = lastSegment;
        }
        /**
         * @return count of segments, -1 if not set
         */
        getSegmentCount() {
            return this.segmentCount;
        }
        setSegmentCount(segmentCount /*int*/) {
            this.segmentCount = segmentCount;
        }
        getSender() {
            return this.sender || null;
        }
        setSender(sender) {
            this.sender = sender;
        }
        getAddressee() {
            return this.addressee || null;
        }
        setAddressee(addressee) {
            this.addressee = addressee;
        }
        /**
         * Filename of the encoded file
         *
         * @return filename
         */
        getFileName() {
            return this.fileName;
        }
        setFileName(fileName) {
            this.fileName = fileName;
        }
        /**
         * filesize in bytes of the encoded file
         *
         * @return filesize in bytes, -1 if not set
         */
        getFileSize() {
            return this.fileSize;
        }
        setFileSize(fileSize /*long*/) {
            this.fileSize = fileSize;
        }
        /**
         * 16-bit CRC checksum using CCITT-16
         *
         * @return crc checksum, -1 if not set
         */
        getChecksum() {
            return this.checksum;
        }
        setChecksum(checksum /*int*/) {
            this.checksum = checksum;
        }
        /**
         * unix epock timestamp, elapsed seconds since 1970-01-01
         *
         * @return elapsed seconds, -1 if not set
         */
        getTimestamp() {
            return this.timestamp;
        }
        setTimestamp(timestamp /*long*/) {
            this.timestamp = timestamp;
        }
    }

    /**
     * Ponyfill for Java's Long class.
     */
    class Long {
        /**
         * Parses a string to a number, since JS has no really Int64.
         *
         * @param num Numeric string.
         * @param radix Destination radix.
         */
        static parseLong(num, radix = undefined) {
            return parseInt(num, radix);
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class NullPointerException extends Exception {
    }
    NullPointerException.kind = 'NullPointerException';

    /*
     * Copyright (c) 1994, 2004, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */
    // package java.io;
    /**
     * This abstract class is the superclass of all classes representing
     * an output stream of bytes. An output stream accepts output bytes
     * and sends them to some sink.
     * <p>
     * Applications that need to define a subclass of
     * <code>OutputStream</code> must always provide at least a method
     * that writes one byte of output.
     *
     * @author  Arthur van Hoff
     * @see     java.io.BufferedOutputStream
     * @see     java.io.ByteArrayOutputStream
     * @see     java.io.DataOutputStream
     * @see     java.io.FilterOutputStream
     * @see     java.io.InputStream
     * @see     java.io.OutputStream#write(int)
     * @since   JDK1.0
     */
    /*public*/ class OutputStream /*implements Closeable, Flushable*/ {
        /**
         * Writes <code>b.length</code> bytes from the specified byte array
         * to this output stream. The general contract for <code>write(b)</code>
         * is that it should have exactly the same effect as the call
         * <code>write(b, 0, b.length)</code>.
         *
         * @param      b   the data.
         * @exception  IOException  if an I/O error occurs.
         * @see        java.io.OutputStream#write(byte[], int, int)
         */
        writeBytes(b) {
            this.writeBytesOffset(b, 0, b.length);
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this output stream.
         * The general contract for <code>write(b, off, len)</code> is that
         * some of the bytes in the array <code>b</code> are written to the
         * output stream in order; element <code>b[off]</code> is the first
         * byte written and <code>b[off+len-1]</code> is the last byte written
         * by this operation.
         * <p>
         * The <code>write</code> method of <code>OutputStream</code> calls
         * the write method of one argument on each of the bytes to be
         * written out. Subclasses are encouraged to override this method and
         * provide a more efficient implementation.
         * <p>
         * If <code>b</code> is <code>null</code>, a
         * <code>NullPointerException</code> is thrown.
         * <p>
         * If <code>off</code> is negative, or <code>len</code> is negative, or
         * <code>off+len</code> is greater than the length of the array
         * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
         *
         * @param      b     the data.
         * @param      off   the start offset in the data.
         * @param      len   the number of bytes to write.
         * @exception  IOException  if an I/O error occurs. In particular,
         *             an <code>IOException</code> is thrown if the output
         *             stream is closed.
         */
        writeBytesOffset(b, off, len) {
            if (b == null) {
                throw new NullPointerException();
            }
            else if ((off < 0) || (off > b.length) || (len < 0) ||
                ((off + len) > b.length) || ((off + len) < 0)) {
                throw new IndexOutOfBoundsException();
            }
            else if (len === 0) {
                return;
            }
            for (let i = 0; i < len; i++) {
                this.write(b[off + i]);
            }
        }
        /**
         * Flushes this output stream and forces any buffered output bytes
         * to be written out. The general contract of <code>flush</code> is
         * that calling it is an indication that, if any bytes previously
         * written have been buffered by the implementation of the output
         * stream, such bytes should immediately be written to their
         * intended destination.
         * <p>
         * If the intended destination of this stream is an abstraction provided by
         * the underlying operating system, for example a file, then flushing the
         * stream guarantees only that bytes previously written to the stream are
         * passed to the operating system for writing; it does not guarantee that
         * they are actually written to a physical device such as a disk drive.
         * <p>
         * The <code>flush</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */
        flush() {
        }
        /**
         * Closes this output stream and releases any system resources
         * associated with this stream. The general contract of <code>close</code>
         * is that it closes the output stream. A closed stream cannot perform
         * output operations and cannot be reopened.
         * <p>
         * The <code>close</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */
        close() {
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class OutOfMemoryError extends Exception {
    }

    /*
     * Copyright (c) 1994, 2010, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */
    /**
     * This class implements an output stream in which the data is
     * written into a byte array. The buffer automatically grows as data
     * is written to it.
     * The data can be retrieved using <code>toByteArray()</code> and
     * <code>toString()</code>.
     * <p>
     * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
     * this class can be called after the stream has been closed without
     * generating an <tt>IOException</tt>.
     *
     * @author  Arthur van Hoff
     * @since   JDK1.0
     */
    /*public*/ class ByteArrayOutputStream extends OutputStream {
        /**
         * Creates a new byte array output stream. The buffer capacity is
         * initially 32 bytes, though its size increases if necessary.
         */
        // public constructor() {
        //     this(32);
        // }
        /**
         * Creates a new byte array output stream, with a buffer capacity of
         * the specified size, in bytes.
         *
         * @param   size   the initial size.
         * @exception  IllegalArgumentException if size is negative.
         */
        constructor(size = 32) {
            super();
            /**
             * The number of valid bytes in the buffer.
             */
            this.count = 0;
            if (size < 0) {
                throw new IllegalArgumentException('Negative initial size: '
                    + size);
            }
            this.buf = new Uint8Array(size);
        }
        /**
         * Increases the capacity if necessary to ensure that it can hold
         * at least the number of elements specified by the minimum
         * capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
         * interpreted as a request for the unsatisfiably large capacity
         * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
         */
        ensureCapacity(minCapacity) {
            // overflow-conscious code
            if (minCapacity - this.buf.length > 0)
                this.grow(minCapacity);
        }
        /**
         * Increases the capacity to ensure that it can hold at least the
         * number of elements specified by the minimum capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         */
        grow(minCapacity) {
            // overflow-conscious code
            let oldCapacity = this.buf.length;
            let newCapacity = oldCapacity << 1;
            if (newCapacity - minCapacity < 0)
                newCapacity = minCapacity;
            if (newCapacity < 0) {
                if (minCapacity < 0) // overflow
                    throw new OutOfMemoryError();
                newCapacity = Integer.MAX_VALUE;
            }
            this.buf = Arrays.copyOfUint8Array(this.buf, newCapacity);
        }
        /**
         * Writes the specified byte to this byte array output stream.
         *
         * @param   b   the byte to be written.
         */
        write(b) {
            this.ensureCapacity(this.count + 1);
            this.buf[this.count] = /*(byte)*/ b;
            this.count += 1;
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this byte array output stream.
         *
         * @param   b     the data.
         * @param   off   the start offset in the data.
         * @param   len   the number of bytes to write.
         */
        writeBytesOffset(b, off, len) {
            if ((off < 0) || (off > b.length) || (len < 0) ||
                ((off + len) - b.length > 0)) {
                throw new IndexOutOfBoundsException();
            }
            this.ensureCapacity(this.count + len);
            System.arraycopy(b, off, this.buf, this.count, len);
            this.count += len;
        }
        /**
         * Writes the complete contents of this byte array output stream to
         * the specified output stream argument, as if by calling the output
         * stream's write method using <code>out.write(buf, 0, count)</code>.
         *
         * @param      out   the output stream to which to write the data.
         * @exception  IOException  if an I/O error occurs.
         */
        writeTo(out) {
            out.writeBytesOffset(this.buf, 0, this.count);
        }
        /**
         * Resets the <code>count</code> field of this byte array output
         * stream to zero, so that all currently accumulated output in the
         * output stream is discarded. The output stream can be used again,
         * reusing the already allocated buffer space.
         *
         * @see     java.io.ByteArrayInputStream#count
         */
        reset() {
            this.count = 0;
        }
        /**
         * Creates a newly allocated byte array. Its size is the current
         * size of this output stream and the valid contents of the buffer
         * have been copied into it.
         *
         * @return  the current contents of this output stream, as a byte array.
         * @see     java.io.ByteArrayOutputStream#size()
         */
        toByteArray() {
            return Arrays.copyOfUint8Array(this.buf, this.count);
        }
        /**
         * Returns the current size of the buffer.
         *
         * @return  the value of the <code>count</code> field, which is the number
         *          of valid bytes in this output stream.
         * @see     java.io.ByteArrayOutputStream#count
         */
        size() {
            return this.count;
        }
        toString(param) {
            if (!param) {
                return this.toString_void();
            }
            if (typeof param === 'string') {
                return this.toString_string(param);
            }
            return this.toString_number(param);
        }
        /**
         * Converts the buffer's contents into a string decoding bytes using the
         * platform's default character set. The length of the new <tt>String</tt>
         * is a function of the character set, and hence may not be equal to the
         * size of the buffer.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with the default replacement string for the platform's
         * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
         * class should be used when more control over the decoding process is
         * required.
         *
         * @return String decoded from the buffer's contents.
         * @since  JDK1.1
         */
        toString_void() {
            return new String(this.buf /*, 0, this.count*/).toString();
        }
        /**
         * Converts the buffer's contents into a string by decoding the bytes using
         * the specified {@link java.nio.charset.Charset charsetName}. The length of
         * the new <tt>String</tt> is a function of the charset, and hence may not be
         * equal to the length of the byte array.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with this charset's default replacement string. The {@link
         * java.nio.charset.CharsetDecoder} class should be used when more control
         * over the decoding process is required.
         *
         * @param  charsetName  the name of a supported
         *              {@linkplain java.nio.charset.Charset </code>charset<code>}
         * @return String decoded from the buffer's contents.
         * @exception  UnsupportedEncodingException
         *             If the named charset is not supported
         * @since   JDK1.1
         */
        toString_string(charsetName) {
            return new String(this.buf /*, 0, this.count, charsetName*/).toString();
        }
        /**
         * Creates a newly allocated string. Its size is the current size of
         * the output stream and the valid contents of the buffer have been
         * copied into it. Each character <i>c</i> in the resulting string is
         * constructed from the corresponding element <i>b</i> in the byte
         * array such that:
         * <blockquote><pre>
         *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
         * </pre></blockquote>
         *
         * @deprecated This method does not properly convert bytes into characters.
         * As of JDK&nbsp;1.1, the preferred way to do this is via the
         * <code>toString(String enc)</code> method, which takes an encoding-name
         * argument, or the <code>toString()</code> method, which uses the
         * platform's default character encoding.
         *
         * @param      hibyte    the high byte of each resulting Unicode character.
         * @return     the current contents of the output stream, as a string.
         * @see        java.io.ByteArrayOutputStream#size()
         * @see        java.io.ByteArrayOutputStream#toString(String)
         * @see        java.io.ByteArrayOutputStream#toString()
         */
        // @Deprecated
        toString_number(hibyte) {
            return new String(this.buf /*, hibyte, 0, this.count*/).toString();
        }
        /**
         * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
         * this class can be called after the stream has been closed without
         * generating an <tt>IOException</tt>.
         * <p>
         *
         * @throws IOException
         */
        close() {
        }
    }

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*private*/ var Mode$2;
    (function (Mode) {
        Mode[Mode["ALPHA"] = 0] = "ALPHA";
        Mode[Mode["LOWER"] = 1] = "LOWER";
        Mode[Mode["MIXED"] = 2] = "MIXED";
        Mode[Mode["PUNCT"] = 3] = "PUNCT";
        Mode[Mode["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
        Mode[Mode["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
    })(Mode$2 || (Mode$2 = {}));
    /**
     * Indirectly access the global BigInt constructor, it
     * allows browsers that doesn't support BigInt to run
     * the library without breaking due to "undefined BigInt"
     * errors.
     */
    function getBigIntConstructor() {
        if (typeof window !== 'undefined') {
            return window['BigInt'] || null;
        }
        if (typeof global !== 'undefined') {
            return global['BigInt'] || null;
        }
        if (typeof self !== 'undefined') {
            return self['BigInt'] || null;
        }
        throw new Error('Can\'t search globals for BigInt!');
    }
    /**
     * Used to store the BigInt constructor.
     */
    let BigInteger;
    /**
     * This function creates a bigint value. It allows browsers
     * that doesn't support BigInt to run the rest of the library
     * by not directly accessing the BigInt constructor.
     */
    function createBigInt(num) {
        if (typeof BigInteger === 'undefined') {
            BigInteger = getBigIntConstructor();
        }
        if (BigInteger === null) {
            throw new Error('BigInt is not supported!');
        }
        return BigInteger(num);
    }
    function getEXP900() {
        // in Java - array with length = 16
        let EXP900 = [];
        EXP900[0] = createBigInt(1);
        let nineHundred = createBigInt(900);
        EXP900[1] = nineHundred;
        // in Java - array with length = 16
        for (let i /*int*/ = 2; i < 16; i++) {
            EXP900[i] = EXP900[i - 1] * nineHundred;
        }
        return EXP900;
    }
    /**
     * <p>This class contains the methods for decoding the PDF417 codewords.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */
    /*final*/ class DecodedBitStreamParser$2 {
        //   private DecodedBitStreamParser() {
        // }
        /**
         *
         * @param codewords
         * @param ecLevel
         *
         * @throws FormatException
         */
        static decode(codewords, ecLevel) {
            // pass encoding to result (will be used for decode symbols in byte mode)
            let result = new StringBuilder('');
            // let encoding: Charset = StandardCharsets.ISO_8859_1;
            let encoding = CharacterSetECI.ISO8859_1;
            /**
             * @note the next command is specific from this TypeScript library
             * because TS can't properly cast some values to char and
             * convert it to string later correctly due to encoding
             * differences from Java version. As reported here:
             * https://github.com/zxing-js/library/pull/264/files#r382831593
             */
            result.enableDecoding(encoding);
            // Get compaction mode
            let codeIndex = 1;
            let code = codewords[codeIndex++];
            let resultMetadata = new PDF417ResultMetadata();
            while (codeIndex < codewords[0]) {
                switch (code) {
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                        codeIndex = DecodedBitStreamParser$2.byteCompaction(code, codewords, encoding, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        result.append(/*(char)*/ codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.ECI_CHARSET:
                        let charsetECI = CharacterSetECI.getCharacterSetECIByValue(codewords[codeIndex++]);
                        // encoding = Charset.forName(charsetECI.getName());
                        break;
                    case DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE:
                        // Can't do anything with generic ECI; skip its 2 characters
                        codeIndex += 2;
                        break;
                    case DecodedBitStreamParser$2.ECI_USER_DEFINED:
                        // Can't do anything with user ECI; skip its 1 character
                        codeIndex++;
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        codeIndex = DecodedBitStreamParser$2.decodeMacroBlock(codewords, codeIndex, resultMetadata);
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        // Should not see these outside a macro block
                        throw new FormatException();
                    default:
                        // Default to text compaction. During testing numerous barcodes
                        // appeared to be missing the starting mode. In these cases defaulting
                        // to text compaction seems to work.
                        codeIndex--;
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                }
                if (codeIndex < codewords.length) {
                    code = codewords[codeIndex++];
                }
                else {
                    throw FormatException.getFormatInstance();
                }
            }
            if (result.length() === 0) {
                throw FormatException.getFormatInstance();
            }
            let decoderResult = new DecoderResult(null, result.toString(), null, ecLevel);
            decoderResult.setOther(resultMetadata);
            return decoderResult;
        }
        /**
         *
         * @param int
         * @param param1
         * @param codewords
         * @param int
         * @param codeIndex
         * @param PDF417ResultMetadata
         * @param resultMetadata
         *
         * @throws FormatException
         */
        // @SuppressWarnings("deprecation")
        static decodeMacroBlock(codewords, codeIndex, resultMetadata) {
            if (codeIndex + DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) {
                // we must have at least two bytes left for the segment index
                throw FormatException.getFormatInstance();
            }
            let segmentIndexArray = new Int32Array(DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS);
            for (let i /*int*/ = 0; i < DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS; i++, codeIndex++) {
                segmentIndexArray[i] = codewords[codeIndex];
            }
            resultMetadata.setSegmentIndex(Integer.parseInt(DecodedBitStreamParser$2.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS)));
            let fileId = new StringBuilder();
            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, fileId);
            resultMetadata.setFileId(fileId.toString());
            let optionalFieldsStart = -1;
            if (codewords[codeIndex] === DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) {
                optionalFieldsStart = codeIndex + 1;
            }
            while (codeIndex < codewords[0]) {
                switch (codewords[codeIndex]) {
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        codeIndex++;
                        switch (codewords[codeIndex]) {
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                                let fileName = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, fileName);
                                resultMetadata.setFileName(fileName.toString());
                                break;
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                                let sender = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, sender);
                                resultMetadata.setSender(sender.toString());
                                break;
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                                let addressee = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, addressee);
                                resultMetadata.setAddressee(addressee.toString());
                                break;
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                                let segmentCount = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, segmentCount);
                                resultMetadata.setSegmentCount(Integer.parseInt(segmentCount.toString()));
                                break;
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                                let timestamp = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, timestamp);
                                resultMetadata.setTimestamp(Long.parseLong(timestamp.toString()));
                                break;
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                                let checksum = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, checksum);
                                resultMetadata.setChecksum(Integer.parseInt(checksum.toString()));
                                break;
                            case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                                let fileSize = new StringBuilder();
                                codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, fileSize);
                                resultMetadata.setFileSize(Long.parseLong(fileSize.toString()));
                                break;
                            default:
                                throw FormatException.getFormatInstance();
                        }
                        break;
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex++;
                        resultMetadata.setLastSegment(true);
                        break;
                    default:
                        throw FormatException.getFormatInstance();
                }
            }
            // copy optional fields to additional options
            if (optionalFieldsStart !== -1) {
                let optionalFieldsLength = codeIndex - optionalFieldsStart;
                if (resultMetadata.isLastSegment()) {
                    // do not include terminator
                    optionalFieldsLength--;
                }
                resultMetadata.setOptionalData(Arrays.copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
            }
            return codeIndex;
        }
        /**
         * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
         * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
         * well as selected control characters.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */
        static textCompaction(codewords, codeIndex, result) {
            // 2 character per codeword
            let textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            // Used to hold the byte compaction value if there is a mode shift
            let byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            let index = 0;
            let end = false;
            while ((codeIndex < codewords[0]) && !end) {
                let code = codewords[codeIndex++];
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    textCompactionData[index] = code / 30;
                    textCompactionData[index + 1] = code % 30;
                    index += 2;
                }
                else {
                    switch (code) {
                        case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            // reinitialize text compaction mode to alpha sub mode
                            textCompactionData[index++] = DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH;
                            break;
                        case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                        case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                            codeIndex--;
                            end = true;
                            break;
                        case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            // The Mode Shift codeword 913 shall cause a temporary
                            // switch from Text Compaction mode to Byte Compaction mode.
                            // This switch shall be in effect for only the next codeword,
                            // after which the mode shall revert to the prevailing sub-mode
                            // of the Text Compaction mode. Codeword 913 is only available
                            // in Text Compaction mode; its use is described in 5.4.2.4.
                            textCompactionData[index] = DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                            code = codewords[codeIndex++];
                            byteCompactionData[index] = code;
                            index++;
                            break;
                    }
                }
            }
            DecodedBitStreamParser$2.decodeTextCompaction(textCompactionData, byteCompactionData, index, result);
            return codeIndex;
        }
        /**
         * The Text Compaction mode includes all the printable ASCII characters
         * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
         * (9: e), LF or line feed (10: e), and CR or carriage
         * return (13: e). The Text Compaction mode also includes various latch
         * and shift characters which are used exclusively within the mode. The Text
         * Compaction mode encodes up to 2 characters per codeword. The compaction rules
         * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
         * switches are defined in 5.4.2.3.
         *
         * @param textCompactionData The text compaction data.
         * @param byteCompactionData The byte compaction data if there
         *                           was a mode shift.
         * @param length             The size of the text compaction and byte compaction data.
         * @param result             The decoded data is appended to the result.
         */
        static decodeTextCompaction(textCompactionData, byteCompactionData, length, result) {
            // Beginning from an initial state of the Alpha sub-mode
            // The default compaction mode for PDF417 in effect at the start of each symbol shall always be Text
            // Compaction mode Alpha sub-mode (alphabetic: uppercase). A latch codeword from another mode to the Text
            // Compaction mode shall always switch to the Text Compaction Alpha sub-mode.
            let subMode = Mode$2.ALPHA;
            let priorToShiftMode = Mode$2.ALPHA;
            let i = 0;
            while (i < length) {
                let subModeCh = textCompactionData[i];
                let ch = /*char*/ '';
                switch (subMode) {
                    case Mode$2.ALPHA:
                        // Alpha (alphabetic: uppercase)
                        if (subModeCh < 26) {
                            // Upper case Alpha Character
                            // Note: 65 = 'A' ASCII -> there is byte code of symbol
                            ch = /*(char)('A' + subModeCh) */ String.fromCharCode(65 + subModeCh);
                        }
                        else {
                            switch (subModeCh) {
                                case 26:
                                    ch = ' ';
                                    break;
                                case DecodedBitStreamParser$2.LL:
                                    subMode = Mode$2.LOWER;
                                    break;
                                case DecodedBitStreamParser$2.ML:
                                    subMode = Mode$2.MIXED;
                                    break;
                                case DecodedBitStreamParser$2.PS:
                                    // Shift to punctuation
                                    priorToShiftMode = subMode;
                                    subMode = Mode$2.PUNCT_SHIFT;
                                    break;
                                case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                    result.append(/*(char)*/ byteCompactionData[i]);
                                    break;
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                    subMode = Mode$2.ALPHA;
                                    break;
                            }
                        }
                        break;
                    case Mode$2.LOWER:
                        // Lower (alphabetic: lowercase)
                        if (subModeCh < 26) {
                            ch = /*(char)('a' + subModeCh)*/ String.fromCharCode(97 + subModeCh);
                        }
                        else {
                            switch (subModeCh) {
                                case 26:
                                    ch = ' ';
                                    break;
                                case DecodedBitStreamParser$2.AS:
                                    // Shift to alpha
                                    priorToShiftMode = subMode;
                                    subMode = Mode$2.ALPHA_SHIFT;
                                    break;
                                case DecodedBitStreamParser$2.ML:
                                    subMode = Mode$2.MIXED;
                                    break;
                                case DecodedBitStreamParser$2.PS:
                                    // Shift to punctuation
                                    priorToShiftMode = subMode;
                                    subMode = Mode$2.PUNCT_SHIFT;
                                    break;
                                case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                    // TODO Does this need to use the current character encoding? See other occurrences below
                                    result.append(/*(char)*/ byteCompactionData[i]);
                                    break;
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                    subMode = Mode$2.ALPHA;
                                    break;
                            }
                        }
                        break;
                    case Mode$2.MIXED:
                        // Mixed (punctuation: e)
                        if (subModeCh < DecodedBitStreamParser$2.PL) {
                            ch = DecodedBitStreamParser$2.MIXED_CHARS[subModeCh];
                        }
                        else {
                            switch (subModeCh) {
                                case DecodedBitStreamParser$2.PL:
                                    subMode = Mode$2.PUNCT;
                                    break;
                                case 26:
                                    ch = ' ';
                                    break;
                                case DecodedBitStreamParser$2.LL:
                                    subMode = Mode$2.LOWER;
                                    break;
                                case DecodedBitStreamParser$2.AL:
                                    subMode = Mode$2.ALPHA;
                                    break;
                                case DecodedBitStreamParser$2.PS:
                                    // Shift to punctuation
                                    priorToShiftMode = subMode;
                                    subMode = Mode$2.PUNCT_SHIFT;
                                    break;
                                case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                    result.append(/*(char)*/ byteCompactionData[i]);
                                    break;
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                    subMode = Mode$2.ALPHA;
                                    break;
                            }
                        }
                        break;
                    case Mode$2.PUNCT:
                        // Punctuation
                        if (subModeCh < DecodedBitStreamParser$2.PAL) {
                            ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        }
                        else {
                            switch (subModeCh) {
                                case DecodedBitStreamParser$2.PAL:
                                    subMode = Mode$2.ALPHA;
                                    break;
                                case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                    result.append(/*(char)*/ byteCompactionData[i]);
                                    break;
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                    subMode = Mode$2.ALPHA;
                                    break;
                            }
                        }
                        break;
                    case Mode$2.ALPHA_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < 26) {
                            ch = /*(char)('A' + subModeCh)*/ String.fromCharCode(65 + subModeCh);
                        }
                        else {
                            switch (subModeCh) {
                                case 26:
                                    ch = ' ';
                                    break;
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                    subMode = Mode$2.ALPHA;
                                    break;
                            }
                        }
                        break;
                    case Mode$2.PUNCT_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < DecodedBitStreamParser$2.PAL) {
                            ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        }
                        else {
                            switch (subModeCh) {
                                case DecodedBitStreamParser$2.PAL:
                                    subMode = Mode$2.ALPHA;
                                    break;
                                case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                    // PS before Shift-to-Byte is used as a padding character,
                                    // see 5.4.2.4 of the specification
                                    result.append(/*(char)*/ byteCompactionData[i]);
                                    break;
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                    subMode = Mode$2.ALPHA;
                                    break;
                            }
                        }
                        break;
                }
                // if (ch !== 0) {
                if (ch !== '') {
                    // Append decoded character to result
                    result.append(ch);
                }
                i++;
            }
        }
        /**
         * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
         * This includes all ASCII characters value 0 to 127 inclusive and provides for international
         * character set support.
         *
         * @param mode      The byte compaction mode i.e. 901 or 924
         * @param codewords The array of codewords (data + error)
         * @param encoding  Currently active character encoding
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */
        static /*int*/ byteCompaction(mode, codewords, encoding, codeIndex, result) {
            let decodedBytes = new ByteArrayOutputStream();
            let count = 0;
            let value = /*long*/ 0;
            let end = false;
            switch (mode) {
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    // Total number of Byte Compaction characters to be encoded
                    // is not a multiple of 6
                    let byteCompactedCodewords = new Int32Array(6);
                    let nextCode = codewords[codeIndex++];
                    while ((codeIndex < codewords[0]) && !end) {
                        byteCompactedCodewords[count++] = nextCode;
                        // Base 900
                        value = 900 * value + nextCode;
                        nextCode = codewords[codeIndex++];
                        // perhaps it should be ok to check only nextCode >= TEXT_COMPACTION_MODE_LATCH
                        switch (nextCode) {
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                            default:
                                if ((count % 5 === 0) && (count > 0)) {
                                    // Decode every 5 codewords
                                    // Convert to Base 256
                                    for (let j /*int*/ = 0; j < 6; ++j) {
                                        /* @note
                                         * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                                         * So the next bitwise operation could not be done with simple numbers
                                         */
                                        decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                                    }
                                    value = 0;
                                    count = 0;
                                }
                                break;
                        }
                    }
                    // if the end of all codewords is reached the last codeword needs to be added
                    if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                        byteCompactedCodewords[count++] = nextCode;
                    }
                    // If Byte Compaction mode is invoked with codeword 901,
                    // the last group of codewords is interpreted directly
                    // as one byte per codeword, without compaction.
                    for (let i /*int*/ = 0; i < count; i++) {
                        decodedBytes.write(/*(byte)*/ byteCompactedCodewords[i]);
                    }
                    break;
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    // Total number of Byte Compaction characters to be encoded
                    // is an integer multiple of 6
                    while (codeIndex < codewords[0] && !end) {
                        let code = codewords[codeIndex++];
                        if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                            count++;
                            // Base 900
                            value = 900 * value + code;
                        }
                        else {
                            switch (code) {
                                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                                case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                                case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                    codeIndex--;
                                    end = true;
                                    break;
                            }
                        }
                        if ((count % 5 === 0) && (count > 0)) {
                            // Decode every 5 codewords
                            // Convert to Base 256
                            /* @note
                             * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                             * So the next bitwise operation could not be done with simple numbers
                            */
                            for (let j /*int*/ = 0; j < 6; ++j) {
                                decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                            }
                            value = 0;
                            count = 0;
                        }
                    }
                    break;
            }
            result.append(StringEncoding.decode(decodedBytes.toByteArray(), encoding));
            return codeIndex;
        }
        /**
         * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         *
         * @throws FormatException
         */
        static numericCompaction(codewords, codeIndex /*int*/, result) {
            let count = 0;
            let end = false;
            let numericCodewords = new Int32Array(DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS);
            while (codeIndex < codewords[0] && !end) {
                let code = codewords[codeIndex++];
                if (codeIndex === codewords[0]) {
                    end = true;
                }
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    numericCodewords[count] = code;
                    count++;
                }
                else {
                    switch (code) {
                        case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                        case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                            codeIndex--;
                            end = true;
                            break;
                    }
                }
                if ((count % DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
                    // Re-invoking Numeric Compaction mode (by using codeword 902
                    // while in Numeric Compaction mode) serves  to terminate the
                    // current Numeric Compaction mode grouping as described in 5.4.4.2,
                    // and then to start a new one grouping.
                    result.append(DecodedBitStreamParser$2.decodeBase900toBase10(numericCodewords, count));
                    count = 0;
                }
            }
            return codeIndex;
        }
        /**
         * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
         *
         * @param codewords The array of codewords
         * @param count     The number of codewords
         * @return The decoded string representing the Numeric data.
         *
         * EXAMPLE
         * Encode the fifteen digit numeric string 000213298174000
         * Prefix the numeric string with a 1 and set the initial value of
         * t = 1 000 213 298 174 000
         * Calculate codeword 0
         * d0 = 1 000 213 298 174 000 mod 900 = 200
         *
         * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
         * Calculate codeword 1
         * d1 = 1 111 348 109 082 mod 900 = 282
         *
         * t = 1 111 348 109 082 div 900 = 1 234 831 232
         * Calculate codeword 2
         * d2 = 1 234 831 232 mod 900 = 632
         *
         * t = 1 234 831 232 div 900 = 1 372 034
         * Calculate codeword 3
         * d3 = 1 372 034 mod 900 = 434
         *
         * t = 1 372 034 div 900 = 1 524
         * Calculate codeword 4
         * d4 = 1 524 mod 900 = 624
         *
         * t = 1 524 div 900 = 1
         * Calculate codeword 5
         * d5 = 1 mod 900 = 1
         * t = 1 div 900 = 0
         * Codeword sequence is: 1, 624, 434, 632, 282, 200
         *
         * Decode the above codewords involves
         *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
         * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
         *
         * Remove leading 1 =>  Result is 000213298174000
         *
         * @throws FormatException
         */
        static decodeBase900toBase10(codewords, count) {
            let result = createBigInt(0);
            for (let i /*int*/ = 0; i < count; i++) {
                result += DecodedBitStreamParser$2.EXP900[count - i - 1] * createBigInt(codewords[i]);
            }
            let resultString = result.toString();
            if (resultString.charAt(0) !== '1') {
                throw new FormatException();
            }
            return resultString.substring(1);
        }
    }
    DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser$2.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser$2.ECI_CHARSET = 927;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser$2.PL = 25;
    DecodedBitStreamParser$2.LL = 27;
    DecodedBitStreamParser$2.AS = 27;
    DecodedBitStreamParser$2.ML = 28;
    DecodedBitStreamParser$2.AL = 28;
    DecodedBitStreamParser$2.PS = 29;
    DecodedBitStreamParser$2.PAL = 29;
    DecodedBitStreamParser$2.PUNCT_CHARS = ';<>@[\\]_`~!\r\t,:\n-.$/"|*()?{}\'';
    DecodedBitStreamParser$2.MIXED_CHARS = '0123456789&\r\t,:#-.$/+%*=^';
    /**
     * Table containing values for the exponent of 900.
     * This is used in the numeric compaction decode algorithm.
     */
    DecodedBitStreamParser$2.EXP900 = getBigIntConstructor() ? getEXP900() : [];
    DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS = 2;

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.Formatter;
    // import java.util.List;
    /**
     * @author Guenther Grau
     */
    /*public final*/ class PDF417ScanningDecoder {
        constructor() { }
        /**
         * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
         *
         * columns. That way width can be deducted from the pattern column.
         * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
         * than it should be. This can happen if the scanner used a bad blackpoint.
         *
         * @param BitMatrix
         * @param image
         * @param ResultPoint
         * @param imageTopLeft
         * @param ResultPoint
         * @param imageBottomLeft
         * @param ResultPoint
         * @param imageTopRight
         * @param ResultPoint
         * @param imageBottomRight
         * @param int
         * @param minCodewordWidth
         * @param int
         * @param maxCodewordWidth
         *
         * @throws NotFoundException
         * @throws FormatException
         * @throws ChecksumException
         */
        static decode(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
            let boundingBox = new BoundingBox(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
            let leftRowIndicatorColumn = null;
            let rightRowIndicatorColumn = null;
            let detectionResult;
            for (let firstPass /*boolean*/ = true;; firstPass = false) {
                if (imageTopLeft != null) {
                    leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
                }
                if (imageTopRight != null) {
                    rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
                }
                detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
                if (detectionResult == null) {
                    throw NotFoundException.getNotFoundInstance();
                }
                let resultBox = detectionResult.getBoundingBox();
                if (firstPass && resultBox != null &&
                    (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) {
                    boundingBox = resultBox;
                }
                else {
                    break;
                }
            }
            detectionResult.setBoundingBox(boundingBox);
            let maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
            detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
            detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
            let leftToRight = leftRowIndicatorColumn != null;
            for (let barcodeColumnCount /*int*/ = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++) {
                let barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
                if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */ undefined) {
                    // This will be the case for the opposite row indicator column, which doesn't need to be decoded again.
                    continue;
                }
                let detectionResultColumn;
                if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) {
                    detectionResultColumn = new DetectionResultRowIndicatorColumn(boundingBox, barcodeColumn === 0);
                }
                else {
                    detectionResultColumn = new DetectionResultColumn(boundingBox);
                }
                detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
                let startColumn = -1;
                let previousStartColumn = startColumn;
                // TODO start at a row for which we know the start position, then detect upwards and downwards from there.
                for (let imageRow /*int*/ = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++) {
                    startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
                    if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
                        if (previousStartColumn === -1) {
                            continue;
                        }
                        startColumn = previousStartColumn;
                    }
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        detectionResultColumn.setCodeword(imageRow, codeword);
                        previousStartColumn = startColumn;
                        minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
                        maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
                    }
                }
            }
            return PDF417ScanningDecoder.createDecoderResult(detectionResult);
        }
        /**
         *
         * @param leftRowIndicatorColumn
         * @param rightRowIndicatorColumn
         *
         * @throws NotFoundException
         */
        static merge(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) {
                return null;
            }
            let barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
            if (barcodeMetadata == null) {
                return null;
            }
            let boundingBox = BoundingBox.merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
            return new DetectionResult(barcodeMetadata, boundingBox);
        }
        /**
         *
         * @param rowIndicatorColumn
         *
         * @throws NotFoundException
         */
        static adjustBoundingBox(rowIndicatorColumn) {
            if (rowIndicatorColumn == null) {
                return null;
            }
            let rowHeights = rowIndicatorColumn.getRowHeights();
            if (rowHeights == null) {
                return null;
            }
            let maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
            let missingStartRows = 0;
            for (let rowHeight /*int*/ of rowHeights) {
                missingStartRows += maxRowHeight - rowHeight;
                if (rowHeight > 0) {
                    break;
                }
            }
            let codewords = rowIndicatorColumn.getCodewords();
            for (let row /*int*/ = 0; missingStartRows > 0 && codewords[row] == null; row++) {
                missingStartRows--;
            }
            let missingEndRows = 0;
            for (let row /*int*/ = rowHeights.length - 1; row >= 0; row--) {
                missingEndRows += maxRowHeight - rowHeights[row];
                if (rowHeights[row] > 0) {
                    break;
                }
            }
            for (let row /*int*/ = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--) {
                missingEndRows--;
            }
            return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
        }
        static getMax(values) {
            let maxValue = -1;
            for (let value /*int*/ of values) {
                maxValue = Math.max(maxValue, value);
            }
            return maxValue;
        }
        static getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            let leftBarcodeMetadata;
            if (leftRowIndicatorColumn == null ||
                (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) {
                return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
            }
            let rightBarcodeMetadata;
            if (rightRowIndicatorColumn == null ||
                (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) {
                return leftBarcodeMetadata;
            }
            if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() &&
                leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() &&
                leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) {
                return null;
            }
            return leftBarcodeMetadata;
        }
        static getRowIndicatorColumn(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
            let rowIndicatorColumn = new DetectionResultRowIndicatorColumn(boundingBox, leftToRight);
            for (let i /*int*/ = 0; i < 2; i++) {
                let increment = i === 0 ? 1 : -1;
                let startColumn = Math.trunc(Math.trunc(startPoint.getX()));
                for (let imageRow /*int*/ = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() &&
                    imageRow >= boundingBox.getMinY(); imageRow += increment) {
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        rowIndicatorColumn.setCodeword(imageRow, codeword);
                        if (leftToRight) {
                            startColumn = codeword.getStartX();
                        }
                        else {
                            startColumn = codeword.getEndX();
                        }
                    }
                }
            }
            return rowIndicatorColumn;
        }
        /**
         *
         * @param detectionResult
         * @param BarcodeValue
         * @param param2
         * @param param3
         * @param barcodeMatrix
         *
         * @throws NotFoundException
         */
        static adjustCodewordCount(detectionResult, barcodeMatrix) {
            let barcodeMatrix01 = barcodeMatrix[0][1];
            let numberOfCodewords = barcodeMatrix01.getValue();
            let calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() *
                detectionResult.getBarcodeRowCount() -
                PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
            if (numberOfCodewords.length === 0) {
                if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > PDF417Common.MAX_CODEWORDS_IN_BARCODE) {
                    throw NotFoundException.getNotFoundInstance();
                }
                barcodeMatrix01.setValue(calculatedNumberOfCodewords);
            }
            else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) {
                // The calculated one is more reliable as it is derived from the row indicator columns
                barcodeMatrix01.setValue(calculatedNumberOfCodewords);
            }
        }
        /**
         *
         * @param detectionResult
         *
         * @throws FormatException
         * @throws ChecksumException
         * @throws NotFoundException
         */
        static createDecoderResult(detectionResult) {
            let barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
            PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
            let erasures /*Collection<Integer>*/ = new Array();
            let codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
            let ambiguousIndexValuesList = /*List<int[]>*/ [];
            let ambiguousIndexesList = /*Collection<Integer>*/ new Array();
            for (let row /*int*/ = 0; row < detectionResult.getBarcodeRowCount(); row++) {
                for (let column /*int*/ = 0; column < detectionResult.getBarcodeColumnCount(); column++) {
                    let values = barcodeMatrix[row][column + 1].getValue();
                    let codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
                    if (values.length === 0) {
                        erasures.push(codewordIndex);
                    }
                    else if (values.length === 1) {
                        codewords[codewordIndex] = values[0];
                    }
                    else {
                        ambiguousIndexesList.push(codewordIndex);
                        ambiguousIndexValuesList.push(values);
                    }
                }
            }
            let ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
            for (let i /*int*/ = 0; i < ambiguousIndexValues.length; i++) {
                ambiguousIndexValues[i] = ambiguousIndexValuesList[i];
            }
            return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, PDF417Common.toIntArray(erasures), PDF417Common.toIntArray(ambiguousIndexesList), ambiguousIndexValues);
        }
        /**
         * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
         * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
         * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
         * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
         * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
         * so decoding the normal barcodes is not affected by this.
         *
         * @param erasureArray contains the indexes of erasures
         * @param ambiguousIndexes array with the indexes that have more than one most likely value
         * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
         * be the same length as the ambiguousIndexes array
         *
         * @throws FormatException
         * @throws ChecksumException
         */
        static createDecoderResultFromAmbiguousValues(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
            let ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
            let tries = 100;
            while (tries-- > 0) {
                for (let i /*int*/ = 0; i < ambiguousIndexCount.length; i++) {
                    codewords[ambiguousIndexes[i]] = ambiguousIndexValues[i][ambiguousIndexCount[i]];
                }
                try {
                    return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
                }
                catch (err) {
                    let ignored = err instanceof ChecksumException;
                    if (!ignored) {
                        throw err;
                    }
                }
                if (ambiguousIndexCount.length === 0) {
                    throw ChecksumException.getChecksumInstance();
                }
                for (let i /*int*/ = 0; i < ambiguousIndexCount.length; i++) {
                    if (ambiguousIndexCount[i] < ambiguousIndexValues[i].length - 1) {
                        ambiguousIndexCount[i]++;
                        break;
                    }
                    else {
                        ambiguousIndexCount[i] = 0;
                        if (i === ambiguousIndexCount.length - 1) {
                            throw ChecksumException.getChecksumInstance();
                        }
                    }
                }
            }
            throw ChecksumException.getChecksumInstance();
        }
        static createBarcodeMatrix(detectionResult) {
            // let barcodeMatrix: BarcodeValue[][] =
            // new BarcodeValue[detectionResult.getBarcodeRowCount()][detectionResult.getBarcodeColumnCount() + 2];
            let barcodeMatrix = Array.from({ length: detectionResult.getBarcodeRowCount() }, () => new Array(detectionResult.getBarcodeColumnCount() + 2));
            for (let row /*int*/ = 0; row < barcodeMatrix.length; row++) {
                for (let column /*int*/ = 0; column < barcodeMatrix[row].length; column++) {
                    barcodeMatrix[row][column] = new BarcodeValue();
                }
            }
            let column = 0;
            for (let detectionResultColumn /*DetectionResultColumn*/ of detectionResult.getDetectionResultColumns()) {
                if (detectionResultColumn != null) {
                    for (let codeword /*Codeword*/ of detectionResultColumn.getCodewords()) {
                        if (codeword != null) {
                            let rowNumber = codeword.getRowNumber();
                            if (rowNumber >= 0) {
                                if (rowNumber >= barcodeMatrix.length) {
                                    // We have more rows than the barcode metadata allows for, ignore them.
                                    continue;
                                }
                                barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                            }
                        }
                    }
                }
                column++;
            }
            return barcodeMatrix;
        }
        static isValidBarcodeColumn(detectionResult, barcodeColumn) {
            return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
        }
        static getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight) {
            let offset = leftToRight ? 1 : -1;
            let codeword = null;
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) {
                codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodeword(imageRow);
            }
            if (codeword != null) {
                return leftToRight ? codeword.getEndX() : codeword.getStartX();
            }
            codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
            if (codeword != null) {
                return leftToRight ? codeword.getStartX() : codeword.getEndX();
            }
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) {
                codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodewordNearby(imageRow);
            }
            if (codeword != null) {
                return leftToRight ? codeword.getEndX() : codeword.getStartX();
            }
            let skippedColumns = 0;
            while (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) {
                barcodeColumn -= offset;
                for (let previousRowCodeword /*Codeword*/ of detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords()) {
                    if (previousRowCodeword != null) {
                        return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) +
                            offset *
                                skippedColumns *
                                (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
                    }
                }
                skippedColumns++;
            }
            return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
        }
        static detectCodeword(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
            startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            // we usually know fairly exact now how long a codeword is. We should provide minimum and maximum expected length
            // and try to adjust the read pixels, e.g. remove single pixel errors or try to cut off exceeding pixels.
            // min and maxCodewordWidth should not be used as they are calculated for the whole barcode an can be inaccurate
            // for the current position
            let moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            if (moduleBitCount == null) {
                return null;
            }
            let endColumn;
            let codewordBitCount = MathUtils.sum(moduleBitCount);
            if (leftToRight) {
                endColumn = startColumn + codewordBitCount;
            }
            else {
                for (let i /*int*/ = 0; i < moduleBitCount.length / 2; i++) {
                    let tmpCount = moduleBitCount[i];
                    moduleBitCount[i] = moduleBitCount[moduleBitCount.length - 1 - i];
                    moduleBitCount[moduleBitCount.length - 1 - i] = tmpCount;
                }
                endColumn = startColumn;
                startColumn = endColumn - codewordBitCount;
            }
            // TODO implement check for width and correction of black and white bars
            // use start (and maybe stop pattern) to determine if black bars are wider than white bars. If so, adjust.
            // should probably done only for codewords with a lot more than 17 bits.
            // The following fixes 10-1.png, which has wide black bars and small white bars
            //    for (let i /*int*/ = 0; i < moduleBitCount.length; i++) {
            //      if (i % 2 === 0) {
            //        moduleBitCount[i]--;
            //      } else {
            //        moduleBitCount[i]++;
            //      }
            //    }
            // We could also use the width of surrounding codewords for more accurate results, but this seems
            // sufficient for now
            if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) {
                // We could try to use the startX and endX position of the codeword in the same column in the previous row,
                // create the bit count from it and normalize it to 8. This would help with single pixel errors.
                return null;
            }
            let decodedValue = PDF417CodewordDecoder.getDecodedValue(moduleBitCount);
            let codeword = PDF417Common.getCodeword(decodedValue);
            if (codeword === -1) {
                return null;
            }
            return new Codeword(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
        }
        static getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
            let imageColumn = startColumn;
            let moduleBitCount = new Int32Array(8);
            let moduleNumber = 0;
            let increment = leftToRight ? 1 : -1;
            let previousPixelValue = leftToRight;
            while ((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) &&
                moduleNumber < moduleBitCount.length) {
                if (image.get(imageColumn, imageRow) === previousPixelValue) {
                    moduleBitCount[moduleNumber]++;
                    imageColumn += increment;
                }
                else {
                    moduleNumber++;
                    previousPixelValue = !previousPixelValue;
                }
            }
            if (moduleNumber === moduleBitCount.length ||
                ((imageColumn === (leftToRight ? maxColumn : minColumn)) &&
                    moduleNumber === moduleBitCount.length - 1)) {
                return moduleBitCount;
            }
            return null;
        }
        static getNumberOfECCodeWords(barcodeECLevel) {
            return 2 << barcodeECLevel;
        }
        static adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
            let correctedStartColumn = codewordStartColumn;
            let increment = leftToRight ? -1 : 1;
            // there should be no black pixels before the start column. If there are, then we need to start earlier.
            for (let i /*int*/ = 0; i < 2; i++) {
                while ((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) &&
                    leftToRight === image.get(correctedStartColumn, imageRow)) {
                    if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) {
                        return codewordStartColumn;
                    }
                    correctedStartColumn += increment;
                }
                increment = -increment;
                leftToRight = !leftToRight;
            }
            return correctedStartColumn;
        }
        static checkCodewordSkew(codewordSize, minCodewordWidth, maxCodewordWidth) {
            return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize &&
                codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
        }
        /**
         * @throws FormatException,
         * @throws ChecksumException
         */
        static decodeCodewords(codewords, ecLevel, erasures) {
            if (codewords.length === 0) {
                throw FormatException.getFormatInstance();
            }
            let numECCodewords = 1 << (ecLevel + 1);
            let correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
            PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
            // Decode the codewords
            let decoderResult = DecodedBitStreamParser$2.decode(codewords, '' + ecLevel);
            decoderResult.setErrorsCorrected(correctedErrorsCount);
            decoderResult.setErasures(erasures.length);
            return decoderResult;
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place.</p>
         *
         * @param codewords   data and error correction codewords
         * @param erasures positions of any known erasures
         * @param numECCodewords number of error correction codewords that are available in codewords
         * @throws ChecksumException if error correction fails
         */
        static correctErrors(codewords, erasures, numECCodewords) {
            if (erasures != null &&
                erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS ||
                numECCodewords < 0 ||
                numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) {
                // Too many errors or EC Codewords is corrupted
                throw ChecksumException.getChecksumInstance();
            }
            return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
        }
        /**
         * Verify that all is OK with the codeword array.
         * @throws FormatException
         */
        static verifyCodewordCount(codewords, numECCodewords) {
            if (codewords.length < 4) {
                // Codeword array size should be at least 4 allowing for
                // Count CW, At least one Data CW, Error Correction CW, Error Correction CW
                throw FormatException.getFormatInstance();
            }
            // The first codeword, the Symbol Length Descriptor, shall always encode the total number of data
            // codewords in the symbol, including the Symbol Length Descriptor itself, data codewords and pad
            // codewords, but excluding the number of error correction codewords.
            let numberOfCodewords = codewords[0];
            if (numberOfCodewords > codewords.length) {
                throw FormatException.getFormatInstance();
            }
            if (numberOfCodewords === 0) {
                // Reset to the length of the array - 8 (Allow for at least level 3 Error Correction (8 Error Codewords)
                if (numECCodewords < codewords.length) {
                    codewords[0] = codewords.length - numECCodewords;
                }
                else {
                    throw FormatException.getFormatInstance();
                }
            }
        }
        static getBitCountForCodeword(codeword) {
            let result = new Int32Array(8);
            let previousValue = 0;
            let i = result.length - 1;
            while (true) {
                if ((codeword & 0x1) !== previousValue) {
                    previousValue = codeword & 0x1;
                    i--;
                    if (i < 0) {
                        break;
                    }
                }
                result[i]++;
                codeword >>= 1;
            }
            return result;
        }
        static getCodewordBucketNumber(codeword) {
            if (codeword instanceof Int32Array) {
                return this.getCodewordBucketNumber_Int32Array(codeword);
            }
            return this.getCodewordBucketNumber_number(codeword);
        }
        static getCodewordBucketNumber_number(codeword) {
            return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
        }
        static getCodewordBucketNumber_Int32Array(moduleBitCount) {
            return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
        }
        static toString(barcodeMatrix) {
            let formatter = new Formatter();
            // try (let formatter = new Formatter()) {
            for (let row /*int*/ = 0; row < barcodeMatrix.length; row++) {
                formatter.format('Row %2d: ', row);
                for (let column /*int*/ = 0; column < barcodeMatrix[row].length; column++) {
                    let barcodeValue = barcodeMatrix[row][column];
                    if (barcodeValue.getValue().length === 0) {
                        formatter.format('        ', null);
                    }
                    else {
                        formatter.format('%4d(%2d)', barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
                    }
                }
                formatter.format('%n');
            }
            return formatter.toString();
            // }
        }
    }
    /*final*/ PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    /*final*/ PDF417ScanningDecoder.MAX_ERRORS = 3;
    /*final*/ PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    /*final*/ PDF417ScanningDecoder.errorCorrection = new ErrorCorrection();

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // import java.util.ArrayList;
    // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode PDF417 codes in an image.
     *
     * @author Guenther Grau
     */
    /*public final*/ class PDF417Reader {
        // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
        /**
         * Locates and decodes a PDF417 code in an image.
         *
         * @return a String representing the content encoded by the PDF417 code
         * @throws NotFoundException if a PDF417 code cannot be found,
         * @throws FormatException if a PDF417 cannot be decoded
         * @throws ChecksumException
         */
        // @Override
        decode(image, hints = null) {
            let result = PDF417Reader.decode(image, hints, false);
            if (result == null || result.length === 0 || result[0] == null) {
                throw NotFoundException.getNotFoundInstance();
            }
            return result[0];
        }
        /**
         *
         * @param BinaryBitmap
         * @param image
         * @throws NotFoundException
         */
        //   @Override
        decodeMultiple(image, hints = null) {
            try {
                return PDF417Reader.decode(image, hints, true);
            }
            catch (ignored) {
                if (ignored instanceof FormatException || ignored instanceof ChecksumException) {
                    throw NotFoundException.getNotFoundInstance();
                }
                throw ignored;
            }
        }
        /**
         *
         * @param image
         * @param hints
         * @param multiple
         *
         * @throws NotFoundException
         * @throws FormatExceptionß
         * @throws ChecksumException
         */
        static decode(image, hints, multiple) {
            const results = new Array();
            const detectorResult = Detector$3.detectMultiple(image, hints, multiple);
            for (const points of detectorResult.getPoints()) {
                const decoderResult = PDF417ScanningDecoder.decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
                const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.PDF_417);
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
                const pdf417ResultMetadata = decoderResult.getOther();
                if (pdf417ResultMetadata != null) {
                    result.putMetadata(ResultMetadataType$1.PDF417_EXTRA_METADATA, pdf417ResultMetadata);
                }
                results.push(result);
            }
            return results.map(x => x);
        }
        static getMaxWidth(p1, p2) {
            if (p1 == null || p2 == null) {
                return 0;
            }
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMinWidth(p1, p2) {
            if (p1 == null || p2 == null) {
                return Integer.MAX_VALUE;
            }
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMaxCodewordWidth(p) {
            return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD /
                PDF417Common.MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD /
                PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        static getMinCodewordWidth(p) {
            return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD /
                PDF417Common.MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD /
                PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        // @Override
        reset() {
            // nothing needs to be reset
        }
    }

    /**
     * Custom Error class of type Exception.
     */
    class ReaderException extends Exception {
    }
    ReaderException.kind = 'ReaderException';

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing {*/
    /**
     * MultiFormatReader is a convenience class and the main entry point into the library for most uses.
     * By default it attempts to decode all barcode formats that the library supports. Optionally, you
     * can provide a hints object to request different behavior, for example only decoding QR codes.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class MultiFormatReader {
        /**
         * Creates an instance of this class
         * 
         * @param {Boolean} verbose if 'true' logs will be dumped to console, otherwise hidden.
         * @param hints The hints to use, clearing the previous state.
         */
        constructor(verbose, hints) {
            this.verbose = (verbose === true);
            if (hints) {
                this.setHints(hints);
            }
        }
        /**
         * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
         * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
         * Use setHints() followed by decodeWithState() for continuous scan applications.
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */
        /*@Override*/
        // public decode(image: BinaryBitmap): Result {
        //   setHints(null)
        //   return decodeInternal(image)
        // }
        /**
         * Decode an image using the hints provided. Does not honor existing state.
         *
         * @param image The pixel data to decode
         * @param hints The hints to use, clearing the previous state.
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */
        /*@Override*/
        decode(image, hints) {
            if (hints) {
                this.setHints(hints);
            }
            return this.decodeInternal(image);
        }
        /**
         * Decode an image using the state set up by calling setHints() previously. Continuous scan
         * clients will get a <b>large</b> speed increase by using this instead of decode().
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */
        decodeWithState(image) {
            // Make sure to set up the default state so we don't crash
            if (this.readers === null || this.readers === undefined) {
                this.setHints(null);
            }
            return this.decodeInternal(image);
        }
        /**
         * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
         * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
         * is important for performance in continuous scan clients.
         *
         * @param hints The set of hints to use for subsequent calls to decode(image)
         */
        setHints(hints) {
            this.hints = hints;
            const tryHarder = !isNullOrUndefined(hints)
                && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const formats = isNullOrUndefined(hints) ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const readers = new Array();
            if (!isNullOrUndefined(formats)) {
                const addOneDReader = formats.some(f => {
                    return (
                        f === BarcodeFormat$1.UPC_A ||
                        f === BarcodeFormat$1.UPC_E ||
                        f === BarcodeFormat$1.EAN_13 ||
                        f === BarcodeFormat$1.EAN_8 ||
                        f === BarcodeFormat$1.CODABAR ||
                        f === BarcodeFormat$1.CODE_39 ||
                        f === BarcodeFormat$1.CODE_93 ||
                        f === BarcodeFormat$1.CODE_128 ||
                        f === BarcodeFormat$1.ITF ||
                        f === BarcodeFormat$1.RSS_14 ||
                        f === BarcodeFormat$1.RSS_EXPANDED);
                });
                // Put 1D readers upfront in "normal" mode
                if (addOneDReader && !tryHarder) {
                    readers.push(new MultiFormatOneDReader(hints, this.verbose));
                }
                if (formats.includes(BarcodeFormat$1.QR_CODE)) {
                    readers.push(new QRCodeReader());
                }
                if (formats.includes(BarcodeFormat$1.DATA_MATRIX)) {
                    readers.push(new DataMatrixReader());
                }
                if (formats.includes(BarcodeFormat$1.AZTEC)) {
                    readers.push(new AztecReader());
                }
                if (formats.includes(BarcodeFormat$1.PDF_417)) {
                    readers.push(new PDF417Reader());
                }
                // if (formats.includes(BarcodeFormat.MAXICODE)) {
                //    readers.push(new MaxiCodeReader())
                // }
                // At end in "try harder" mode
                if (addOneDReader && tryHarder) {
                    readers.push(new MultiFormatOneDReader(hints, this.verbose));
                }
            }
            if (readers.length === 0) {
                if (!tryHarder) {
                    readers.push(new MultiFormatOneDReader(hints, this.verbose));
                }
                readers.push(new QRCodeReader());
                readers.push(new DataMatrixReader());
                readers.push(new AztecReader());
                readers.push(new PDF417Reader());
                // readers.push(new MaxiCodeReader())
                if (tryHarder) {
                    readers.push(new MultiFormatOneDReader(hints, this.verbose));
                }
            }
            this.readers = readers; // .toArray(new Reader[readers.size()])
        }
        /*@Override*/
        reset() {
            if (this.readers !== null) {
                for (const reader of this.readers) {
                    reader.reset();
                }
            }
        }
        /**
         * @throws NotFoundException
         */
        decodeInternal(image) {
            if (this.readers === null) {
                throw new ReaderException('No readers where selected, nothing can be read.');
            }
            for (const reader of this.readers) {
                // Trying to decode with ${reader} reader.
                try {
                    return reader.decode(image, this.hints);
                }
                catch (ex) {
                    if (ex instanceof ReaderException) {
                        continue;
                    }
                    // Bad Exception.
                }
            }
            throw new NotFoundException('No MultiFormat Readers were able to detect the code.');
        }
    }

    class BrowserMultiFormatReader extends BrowserCodeReader {
        constructor(hints = null, timeBetweenScansMillis = 500) {
            const reader = new MultiFormatReader();
            reader.setHints(hints);
            super(reader, timeBetweenScansMillis);
        }
        /**
         * Overwrite decodeBitmap to call decodeWithState, which will pay
         * attention to the hints set in the constructor function
         */
        decodeBitmap(binaryBitmap) {
            return this.reader.decodeWithState(binaryBitmap);
        }
    }

    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */
    class BrowserPDF417Reader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserPDF417Reader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */
        constructor(timeBetweenScansMillis = 500) {
            super(new PDF417Reader(), timeBetweenScansMillis);
        }
    }

    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */
    class BrowserQRCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */
        constructor(timeBetweenScansMillis = 500) {
            super(new QRCodeReader(), timeBetweenScansMillis);
        }
    }

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /*namespace com.google.zxing {*/
    /**
     * These are a set of hints that you may pass to Writers to specify their behavior.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    var EncodeHintType;
    (function (EncodeHintType) {
        /**
         * Specifies what degree of error correction to use, for example in QR Codes.
         * Type depends on the encoder. For example for QR codes it's type
         * {@link com.google.zxing.qrcode.decoder.ErrorCorrectionLevel ErrorCorrectionLevel}.
         * For Aztec it is of type {@link Integer}, representing the minimal percentage of error correction words.
         * For PDF417 it is of type {@link Integer}, valid values being 0 to 8.
         * In all cases, it can also be a {@link String} representation of the desired value as well.
         * Note: an Aztec symbol should have a minimum of 25% EC words.
         */
        EncodeHintType[EncodeHintType["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
        /**
         * Specifies what character encoding to use where applicable (type {@link String})
         */
        EncodeHintType[EncodeHintType["CHARACTER_SET"] = 1] = "CHARACTER_SET";
        /**
         * Specifies the matrix shape for Data Matrix (type {@link com.google.zxing.datamatrix.encoder.SymbolShapeHint})
         */
        EncodeHintType[EncodeHintType["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
        /**
         * Specifies a minimum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated use width/height params in
         * {@link com.google.zxing.datamatrix.DataMatrixWriter#encode(String, BarcodeFormat, int, int)}
         */
        /*@Deprecated*/
        EncodeHintType[EncodeHintType["MIN_SIZE"] = 3] = "MIN_SIZE";
        /**
         * Specifies a maximum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated without replacement
         */
        /*@Deprecated*/
        EncodeHintType[EncodeHintType["MAX_SIZE"] = 4] = "MAX_SIZE";
        /**
         * Specifies margin, in pixels, to use when generating the barcode. The meaning can vary
         * by format; for example it controls margin before and after the barcode horizontally for
         * most 1D formats. (Type {@link Integer}, or {@link String} representation of the integer value).
         */
        EncodeHintType[EncodeHintType["MARGIN"] = 5] = "MARGIN";
        /**
         * Specifies whether to use compact mode for PDF417 (type {@link Boolean}, or "true" or "false"
         * {@link String} value).
         */
        EncodeHintType[EncodeHintType["PDF417_COMPACT"] = 6] = "PDF417_COMPACT";
        /**
         * Specifies what compaction mode to use for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Compaction Compaction} or {@link String} value of one of its
         * enum values).
         */
        EncodeHintType[EncodeHintType["PDF417_COMPACTION"] = 7] = "PDF417_COMPACTION";
        /**
         * Specifies the minimum and maximum number of rows and columns for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Dimensions Dimensions}).
         */
        EncodeHintType[EncodeHintType["PDF417_DIMENSIONS"] = 8] = "PDF417_DIMENSIONS";
        /**
         * Specifies the required number of layers for an Aztec code.
         * A negative number (-1, -2, -3, -4) specifies a compact Aztec code.
         * 0 indicates to use the minimum number of layers (the default).
         * A positive number (1, 2, .. 32) specifies a normal (non-compact) Aztec code.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */
        EncodeHintType[EncodeHintType["AZTEC_LAYERS"] = 9] = "AZTEC_LAYERS";
        /**
         * Specifies the exact version of QR code to be encoded.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */
        EncodeHintType[EncodeHintType["QR_VERSION"] = 10] = "QR_VERSION";
    })(EncodeHintType || (EncodeHintType = {}));
    var EncodeHintType$1 = EncodeHintType;

    /**
     * <p>Implements Reed-Solomon encoding, as the name implies.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     */
    class ReedSolomonEncoder {
        /**
         * A reed solomon error-correcting encoding constructor is created by
         * passing as Galois Field with of size equal to the number of code
         * words (symbols) in the alphabet (the number of values in each
         * element of arrays that are encoded/decoded).
         * @param field A galois field with a number of elements equal to the size
         * of the alphabet of symbols to encode.
         */
        constructor(field) {
            this.field = field;
            this.cachedGenerators = [];
            this.cachedGenerators.push(new GenericGFPoly(field, Int32Array.from([1])));
        }
        buildGenerator(degree /*int*/) {
            const cachedGenerators = this.cachedGenerators;
            if (degree >= cachedGenerators.length) {
                let lastGenerator = cachedGenerators[cachedGenerators.length - 1];
                const field = this.field;
                for (let d = cachedGenerators.length; d <= degree; d++) {
                    const nextGenerator = lastGenerator.multiply(new GenericGFPoly(field, Int32Array.from([1, field.exp(d - 1 + field.getGeneratorBase())])));
                    cachedGenerators.push(nextGenerator);
                    lastGenerator = nextGenerator;
                }
            }
            return cachedGenerators[degree];
        }
        /**
         * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
         * to detect and correct errors that may have been introduced when the resulting
         * data is stored or transmitted.</p>
         *
         * @param toEncode array used for both and output. Caller initializes the array with
         * the code words (symbols) to be encoded followed by empty elements allocated to make
         * space for error-correction code words in the encoded output. The array contains
         * the encdoded output when encode returns. Code words are encoded as numbers from
         * 0 to n-1, where n is the number of possible code words (symbols), as determined
         * by the size of the Galois Field passed in the constructor of this object.
         * @param ecBytes the number of elements reserved in the array (first parameter)
         * to store error-correction code words. Thus, the number of code words (symbols)
         * to encode in the first parameter is thus toEncode.length - ecBytes.
         * Note, the use of "bytes" in the name of this parameter is misleading, as there may
         * be more or fewer than 256 symbols being encoded, as determined by the number of
         * elements in the Galois Field passed as a constructor to this object.
         * @throws IllegalArgumentException thrown in response to validation errros.
         */
        encode(toEncode, ecBytes /*int*/) {
            if (ecBytes === 0) {
                throw new IllegalArgumentException('No error correction bytes');
            }
            const dataBytes = toEncode.length - ecBytes;
            if (dataBytes <= 0) {
                throw new IllegalArgumentException('No data bytes provided');
            }
            const generator = this.buildGenerator(ecBytes);
            const infoCoefficients = new Int32Array(dataBytes);
            System.arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
            let info = new GenericGFPoly(this.field, infoCoefficients);
            info = info.multiplyByMonomial(ecBytes, 1);
            const remainder = info.divide(generator)[1];
            const coefficients = remainder.getCoefficients();
            const numZeroCoefficients = ecBytes - coefficients.length;
            for (let i = 0; i < numZeroCoefficients; i++) {
                toEncode[dataBytes + i] = 0;
            }
            System.arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
        }
    }

    /**
     * @author Satoru Takabayashi
     * @author Daniel Switkin
     * @author Sean Owen
     */
    class MaskUtil {
        constructor() {
            // do nothing
        }
        /**
         * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
         * give penalty to them. Example: 00000 or 11111.
         */
        static applyMaskPenaltyRule1(matrix) {
            return MaskUtil.applyMaskPenaltyRule1Internal(matrix, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix, false);
        }
        /**
         * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
         * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
         * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
         */
        static applyMaskPenaltyRule2(matrix) {
            let penalty = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for (let y = 0; y < height - 1; y++) {
                const arrayY = array[y];
                for (let x = 0; x < width - 1; x++) {
                    const value = arrayY[x];
                    if (value === arrayY[x + 1] && value === array[y + 1][x] && value === array[y + 1][x + 1]) {
                        penalty++;
                    }
                }
            }
            return MaskUtil.N2 * penalty;
        }
        /**
         * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
         * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
         * find patterns like 000010111010000, we give penalty once.
         */
        static applyMaskPenaltyRule3(matrix) {
            let numPenalties = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const arrayY = array[y]; // We can at least optimize this access
                    if (x + 6 < width &&
                        arrayY[x] === 1 &&
                        arrayY[x + 1] === 0 &&
                        arrayY[x + 2] === 1 &&
                        arrayY[x + 3] === 1 &&
                        arrayY[x + 4] === 1 &&
                        arrayY[x + 5] === 0 &&
                        arrayY[x + 6] === 1 &&
                        (MaskUtil.isWhiteHorizontal(arrayY, x - 4, x) || MaskUtil.isWhiteHorizontal(arrayY, x + 7, x + 11))) {
                        numPenalties++;
                    }
                    if (y + 6 < height &&
                        array[y][x] === 1 &&
                        array[y + 1][x] === 0 &&
                        array[y + 2][x] === 1 &&
                        array[y + 3][x] === 1 &&
                        array[y + 4][x] === 1 &&
                        array[y + 5][x] === 0 &&
                        array[y + 6][x] === 1 &&
                        (MaskUtil.isWhiteVertical(array, x, y - 4, y) || MaskUtil.isWhiteVertical(array, x, y + 7, y + 11))) {
                        numPenalties++;
                    }
                }
            }
            return numPenalties * MaskUtil.N3;
        }
        static isWhiteHorizontal(rowArray, from /*int*/, to /*int*/) {
            from = Math.max(from, 0);
            to = Math.min(to, rowArray.length);
            for (let i = from; i < to; i++) {
                if (rowArray[i] === 1) {
                    return false;
                }
            }
            return true;
        }
        static isWhiteVertical(array, col /*int*/, from /*int*/, to /*int*/) {
            from = Math.max(from, 0);
            to = Math.min(to, array.length);
            for (let i = from; i < to; i++) {
                if (array[i][col] === 1) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
         * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
         */
        static applyMaskPenaltyRule4(matrix) {
            let numDarkCells = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for (let y = 0; y < height; y++) {
                const arrayY = array[y];
                for (let x = 0; x < width; x++) {
                    if (arrayY[x] === 1) {
                        numDarkCells++;
                    }
                }
            }
            const numTotalCells = matrix.getHeight() * matrix.getWidth();
            const fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
            return fivePercentVariances * MaskUtil.N4;
        }
        /**
         * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
         * pattern conditions.
         */
        static getDataMaskBit(maskPattern /*int*/, x /*int*/, y /*int*/) {
            let intermediate; /*int*/
            let temp; /*int*/
            switch (maskPattern) {
                case 0:
                    intermediate = (y + x) & 0x1;
                    break;
                case 1:
                    intermediate = y & 0x1;
                    break;
                case 2:
                    intermediate = x % 3;
                    break;
                case 3:
                    intermediate = (y + x) % 3;
                    break;
                case 4:
                    intermediate = (Math.floor(y / 2) + Math.floor(x / 3)) & 0x1;
                    break;
                case 5:
                    temp = y * x;
                    intermediate = (temp & 0x1) + (temp % 3);
                    break;
                case 6:
                    temp = y * x;
                    intermediate = ((temp & 0x1) + (temp % 3)) & 0x1;
                    break;
                case 7:
                    temp = y * x;
                    intermediate = ((temp % 3) + ((y + x) & 0x1)) & 0x1;
                    break;
                default:
                    throw new IllegalArgumentException('Invalid mask pattern: ' + maskPattern);
            }
            return intermediate === 0;
        }
        /**
         * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
         * vertical and horizontal orders respectively.
         */
        static applyMaskPenaltyRule1Internal(matrix, isHorizontal) {
            let penalty = 0;
            const iLimit = isHorizontal ? matrix.getHeight() : matrix.getWidth();
            const jLimit = isHorizontal ? matrix.getWidth() : matrix.getHeight();
            const array = matrix.getArray();
            for (let i = 0; i < iLimit; i++) {
                let numSameBitCells = 0;
                let prevBit = -1;
                for (let j = 0; j < jLimit; j++) {
                    const bit = isHorizontal ? array[i][j] : array[j][i];
                    if (bit === prevBit) {
                        numSameBitCells++;
                    }
                    else {
                        if (numSameBitCells >= 5) {
                            penalty += MaskUtil.N1 + (numSameBitCells - 5);
                        }
                        numSameBitCells = 1; // Include the cell itself.
                        prevBit = bit;
                    }
                }
                if (numSameBitCells >= 5) {
                    penalty += MaskUtil.N1 + (numSameBitCells - 5);
                }
            }
            return penalty;
        }
    }
    // Penalty weights from section 6.8.2.1
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;

    /**
     * JAVAPORT: The original code was a 2D array of ints, but since it only ever gets assigned
     * -1, 0, and 1, I'm going to use less memory and go with bytes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class ByteMatrix {
        constructor(width /*int*/, height /*int*/) {
            this.width = width;
            this.height = height;
            const bytes = new Array(height); // [height][width]
            for (let i = 0; i !== height; i++) {
                bytes[i] = new Uint8Array(width);
            }
            this.bytes = bytes;
        }
        getHeight() {
            return this.height;
        }
        getWidth() {
            return this.width;
        }
        get(x /*int*/, y /*int*/) {
            return this.bytes[y][x];
        }
        /**
         * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
         */
        getArray() {
            return this.bytes;
        }
        // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
        setNumber(x /*int*/, y /*int*/, value /*byte|int*/) {
            this.bytes[y][x] = value;
        }
        // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
        //   bytes[y][x] = (byte) value
        // }
        setBoolean(x /*int*/, y /*int*/, value) {
            this.bytes[y][x] = /*(byte) */ (value ? 1 : 0);
        }
        clear(value /*byte*/) {
            for (const aByte of this.bytes) {
                Arrays.fill(aByte, value);
            }
        }
        equals(o) {
            if (!(o instanceof ByteMatrix)) {
                return false;
            }
            const other = o;
            if (this.width !== other.width) {
                return false;
            }
            if (this.height !== other.height) {
                return false;
            }
            for (let y = 0, height = this.height; y < height; ++y) {
                const bytesY = this.bytes[y];
                const otherBytesY = other.bytes[y];
                for (let x = 0, width = this.width; x < width; ++x) {
                    if (bytesY[x] !== otherBytesY[x]) {
                        return false;
                    }
                }
            }
            return true;
        }
        /*@Override*/
        toString() {
            const result = new StringBuilder(); // (2 * width * height + 2)
            for (let y = 0, height = this.height; y < height; ++y) {
                const bytesY = this.bytes[y];
                for (let x = 0, width = this.width; x < width; ++x) {
                    switch (bytesY[x]) {
                        case 0:
                            result.append(' 0');
                            break;
                        case 1:
                            result.append(' 1');
                            break;
                        default:
                            result.append('  ');
                            break;
                    }
                }
                result.append('\n');
            }
            return result.toString();
        }
    }

    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */
    class QRCode {
        constructor() {
            this.maskPattern = -1;
        }
        getMode() {
            return this.mode;
        }
        getECLevel() {
            return this.ecLevel;
        }
        getVersion() {
            return this.version;
        }
        getMaskPattern() {
            return this.maskPattern;
        }
        getMatrix() {
            return this.matrix;
        }
        /*@Override*/
        toString() {
            const result = new StringBuilder(); // (200)
            result.append('<<\n');
            result.append(' mode: ');
            result.append(this.mode ? this.mode.toString() : 'null');
            result.append('\n ecLevel: ');
            result.append(this.ecLevel ? this.ecLevel.toString() : 'null');
            result.append('\n version: ');
            result.append(this.version ? this.version.toString() : 'null');
            result.append('\n maskPattern: ');
            result.append(this.maskPattern.toString());
            if (this.matrix) {
                result.append('\n matrix:\n');
                result.append(this.matrix.toString());
            }
            else {
                result.append('\n matrix: null\n');
            }
            result.append('>>\n');
            return result.toString();
        }
        setMode(value) {
            this.mode = value;
        }
        setECLevel(value) {
            this.ecLevel = value;
        }
        setVersion(version) {
            this.version = version;
        }
        setMaskPattern(value /*int*/) {
            this.maskPattern = value;
        }
        setMatrix(value) {
            this.matrix = value;
        }
        // Check if "mask_pattern" is valid.
        static isValidMaskPattern(maskPattern /*int*/) {
            return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
        }
    }
    QRCode.NUM_MASK_PATTERNS = 8;

    /**
     * Custom Error class of type Exception.
     */
    class WriterException extends Exception {
    }
    WriterException.kind = 'WriterException';

    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */
    class MatrixUtil {
        constructor() {
            // do nothing
        }
        // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
        //
        // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
        // with the ByteMatrix initialized all to zero.
        static clearMatrix(matrix) {
            // TYPESCRIPTPORT: we use UintArray se changed here from -1 to 255
            matrix.clear(/*(byte) */ /*-1*/ 255);
        }
        // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
        // success, store the result in "matrix" and return true.
        static buildMatrix(dataBits, ecLevel, version, maskPattern /*int*/, matrix) {
            MatrixUtil.clearMatrix(matrix);
            MatrixUtil.embedBasicPatterns(version, matrix);
            // Type information appear with any version.
            MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix);
            // Version info appear if version >= 7.
            MatrixUtil.maybeEmbedVersionInfo(version, matrix);
            // Data should be embedded at end.
            MatrixUtil.embedDataBits(dataBits, maskPattern, matrix);
        }
        // Embed basic patterns. On success, modify the matrix and return true.
        // The basic patterns are:
        // - Position detection patterns
        // - Timing patterns
        // - Dark dot at the left bottom corner
        // - Position adjustment patterns, if need be
        static embedBasicPatterns(version, matrix) {
            // Let's get started with embedding big squares at corners.
            MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix);
            // Then, embed the dark dot at the left bottom corner.
            MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix);
            // Position adjustment patterns appear if version >= 2.
            MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version, matrix);
            // Timing patterns should be embedded after position adj. patterns.
            MatrixUtil.embedTimingPatterns(matrix);
        }
        // Embed type information. On success, modify the matrix.
        static embedTypeInfo(ecLevel, maskPattern /*int*/, matrix) {
            const typeInfoBits = new BitArray();
            MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
            for (let i = 0, size = typeInfoBits.getSize(); i < size; ++i) {
                // Place bits in LSB to MSB order.  LSB (least significant bit) is the last value in
                // "typeInfoBits".
                const bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i);
                // Type info bits at the left top corner. See 8.9 of JISX0510:2004 (p.46).
                const coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i];
                const x1 = coordinates[0];
                const y1 = coordinates[1];
                matrix.setBoolean(x1, y1, bit);
                if (i < 8) {
                    // Right top corner.
                    const x2 = matrix.getWidth() - i - 1;
                    const y2 = 8;
                    matrix.setBoolean(x2, y2, bit);
                }
                else {
                    // Left bottom corner.
                    const x2 = 8;
                    const y2 = matrix.getHeight() - 7 + (i - 8);
                    matrix.setBoolean(x2, y2, bit);
                }
            }
        }
        // Embed version information if need be. On success, modify the matrix and return true.
        // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
        static maybeEmbedVersionInfo(version, matrix) {
            if (version.getVersionNumber() < 7) { // Version info is necessary if version >= 7.
                return; // Don't need version info.
            }
            const versionInfoBits = new BitArray();
            MatrixUtil.makeVersionInfoBits(version, versionInfoBits);
            let bitIndex = 6 * 3 - 1; // It will decrease from 17 to 0.
            for (let i = 0; i < 6; ++i) {
                for (let j = 0; j < 3; ++j) {
                    // Place bits in LSB (least significant bit) to MSB order.
                    const bit = versionInfoBits.get(bitIndex);
                    bitIndex--;
                    // Left bottom corner.
                    matrix.setBoolean(i, matrix.getHeight() - 11 + j, bit);
                    // Right bottom corner.
                    matrix.setBoolean(matrix.getHeight() - 11 + j, i, bit);
                }
            }
        }
        // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
        // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
        // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
        static embedDataBits(dataBits, maskPattern /*int*/, matrix) {
            let bitIndex = 0;
            let direction = -1;
            // Start from the right bottom cell.
            let x = matrix.getWidth() - 1;
            let y = matrix.getHeight() - 1;
            while (x > 0) {
                // Skip the vertical timing pattern.
                if (x === 6) {
                    x -= 1;
                }
                while (y >= 0 && y < matrix.getHeight()) {
                    for (let i = 0; i < 2; ++i) {
                        const xx = x - i;
                        // Skip the cell if it's not empty.
                        if (!MatrixUtil.isEmpty(matrix.get(xx, y))) {
                            continue;
                        }
                        let bit;
                        if (bitIndex < dataBits.getSize()) {
                            bit = dataBits.get(bitIndex);
                            ++bitIndex;
                        }
                        else {
                            // Padding bit. If there is no bit left, we'll fill the left cells with 0, as described
                            // in 8.4.9 of JISX0510:2004 (p. 24).
                            bit = false;
                        }
                        // Skip masking if mask_pattern is -1 (TYPESCRIPTPORT: 255).
                        if (maskPattern !== 255 && MaskUtil.getDataMaskBit(maskPattern, xx, y)) {
                            bit = !bit;
                        }
                        matrix.setBoolean(xx, y, bit);
                    }
                    y += direction;
                }
                direction = -direction; // Reverse the direction.
                y += direction;
                x -= 2; // Move to the left.
            }
            // All bits should be consumed.
            if (bitIndex !== dataBits.getSize()) {
                throw new WriterException('Not all bits consumed: ' + bitIndex + '/' + dataBits.getSize());
            }
        }
        // Return the position of the most significant bit set (one: to) in the "value". The most
        // significant bit is position 32. If there is no bit set, return 0. Examples:
        // - findMSBSet(0) => 0
        // - findMSBSet(1) => 1
        // - findMSBSet(255) => 8
        static findMSBSet(value /*int*/) {
            return 32 - Integer.numberOfLeadingZeros(value);
        }
        // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
        // code is used for encoding type information and version information.
        // Example: Calculation of version information of 7.
        // f(x) is created from 7.
        //   - 7 = 000111 in 6 bits
        //   - f(x) = x^2 + x^1 + x^0
        // g(x) is given by the standard (p. 67)
        //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
        // Multiply f(x) by x^(18 - 6)
        //   - f'(x) = f(x) * x^(18 - 6)
        //   - f'(x) = x^14 + x^13 + x^12
        // Calculate the remainder of f'(x) / g(x)
        //         x^2
        //         __________________________________________________
        //   g(x) )x^14 + x^13 + x^12
        //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
        //         --------------------------------------------------
        //                              x^11 + x^10 + x^7 + x^4 + x^2
        //
        // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
        // Encode it in binary: 110010010100
        // The return value is 0xc94 (1100 1001 0100)
        //
        // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
        // operations. We don't care if coefficients are positive or negative.
        static calculateBCHCode(value /*int*/, poly /*int*/) {
            if (poly === 0) {
                throw new IllegalArgumentException('0 polynomial');
            }
            // If poly is "1 1111 0010 0101" (version info poly), msbSetInPoly is 13. We'll subtract 1
            // from 13 to make it 12.
            const msbSetInPoly = MatrixUtil.findMSBSet(poly);
            value <<= msbSetInPoly - 1;
            // Do the division business using exclusive-or operations.
            while (MatrixUtil.findMSBSet(value) >= msbSetInPoly) {
                value ^= poly << (MatrixUtil.findMSBSet(value) - msbSetInPoly);
            }
            // Now the "value" is the remainder (i.e. the BCH code)
            return value;
        }
        // Make bit vector of type information. On success, store the result in "bits" and return true.
        // Encode error correction level and mask pattern. See 8.9 of
        // JISX0510:2004 (p.45) for details.
        static makeTypeInfoBits(ecLevel, maskPattern /*int*/, bits) {
            if (!QRCode.isValidMaskPattern(maskPattern)) {
                throw new WriterException('Invalid mask pattern');
            }
            const typeInfo = (ecLevel.getBits() << 3) | maskPattern;
            bits.appendBits(typeInfo, 5);
            const bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
            bits.appendBits(bchCode, 10);
            const maskBits = new BitArray();
            maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
            bits.xor(maskBits);
            if (bits.getSize() !== 15) { // Just in case.
                throw new WriterException('should not happen but we got: ' + bits.getSize());
            }
        }
        // Make bit vector of version information. On success, store the result in "bits" and return true.
        // See 8.10 of JISX0510:2004 (p.45) for details.
        static makeVersionInfoBits(version, bits) {
            bits.appendBits(version.getVersionNumber(), 6);
            const bchCode = MatrixUtil.calculateBCHCode(version.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
            bits.appendBits(bchCode, 12);
            if (bits.getSize() !== 18) { // Just in case.
                throw new WriterException('should not happen but we got: ' + bits.getSize());
            }
        }
        // Check if "value" is empty.
        static isEmpty(value /*int*/) {
            return value === 255; // -1
        }
        static embedTimingPatterns(matrix) {
            // -8 is for skipping position detection patterns (7: size), and two horizontal/vertical
            // separation patterns (1: size). Thus, 8 = 7 + 1.
            for (let i = 8; i < matrix.getWidth() - 8; ++i) {
                const bit = (i + 1) % 2;
                // Horizontal line.
                if (MatrixUtil.isEmpty(matrix.get(i, 6))) {
                    matrix.setNumber(i, 6, bit);
                }
                // Vertical line.
                if (MatrixUtil.isEmpty(matrix.get(6, i))) {
                    matrix.setNumber(6, i, bit);
                }
            }
        }
        // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
        static embedDarkDotAtLeftBottomCorner(matrix) {
            if (matrix.get(8, matrix.getHeight() - 8) === 0) {
                throw new WriterException();
            }
            matrix.setNumber(8, matrix.getHeight() - 8, 1);
        }
        static embedHorizontalSeparationPattern(xStart /*int*/, yStart /*int*/, matrix) {
            for (let x = 0; x < 8; ++x) {
                if (!MatrixUtil.isEmpty(matrix.get(xStart + x, yStart))) {
                    throw new WriterException();
                }
                matrix.setNumber(xStart + x, yStart, 0);
            }
        }
        static embedVerticalSeparationPattern(xStart /*int*/, yStart /*int*/, matrix) {
            for (let y = 0; y < 7; ++y) {
                if (!MatrixUtil.isEmpty(matrix.get(xStart, yStart + y))) {
                    throw new WriterException();
                }
                matrix.setNumber(xStart, yStart + y, 0);
            }
        }
        static embedPositionAdjustmentPattern(xStart /*int*/, yStart /*int*/, matrix) {
            for (let y = 0; y < 5; ++y) {
                const patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
                for (let x = 0; x < 5; ++x) {
                    matrix.setNumber(xStart + x, yStart + y, patternY[x]);
                }
            }
        }
        static embedPositionDetectionPattern(xStart /*int*/, yStart /*int*/, matrix) {
            for (let y = 0; y < 7; ++y) {
                const patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
                for (let x = 0; x < 7; ++x) {
                    matrix.setNumber(xStart + x, yStart + y, patternY[x]);
                }
            }
        }
        // Embed position detection patterns and surrounding vertical/horizontal separators.
        static embedPositionDetectionPatternsAndSeparators(matrix) {
            // Embed three big squares at corners.
            const pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
            // Left top corner.
            MatrixUtil.embedPositionDetectionPattern(0, 0, matrix);
            // Right top corner.
            MatrixUtil.embedPositionDetectionPattern(matrix.getWidth() - pdpWidth, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedPositionDetectionPattern(0, matrix.getWidth() - pdpWidth, matrix);
            // Embed horizontal separation patterns around the squares.
            const hspWidth = 8;
            // Left top corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix);
            // Right top corner.
            MatrixUtil.embedHorizontalSeparationPattern(matrix.getWidth() - hspWidth, hspWidth - 1, matrix);
            // Left bottom corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, matrix.getWidth() - hspWidth, matrix);
            // Embed vertical separation patterns around the squares.
            const vspSize = 7;
            // Left top corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix);
            // Right top corner.
            MatrixUtil.embedVerticalSeparationPattern(matrix.getHeight() - vspSize - 1, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix.getHeight() - vspSize, matrix);
        }
        // Embed position adjustment patterns if need be.
        static maybeEmbedPositionAdjustmentPatterns(version, matrix) {
            if (version.getVersionNumber() < 2) { // The patterns appear if version >= 2
                return;
            }
            const index = version.getVersionNumber() - 1;
            const coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index];
            for (let i = 0, length = coordinates.length; i !== length; i++) {
                const y = coordinates[i];
                if (y >= 0) {
                    for (let j = 0; j !== length; j++) {
                        const x = coordinates[j];
                        if (x >= 0 && MatrixUtil.isEmpty(matrix.get(x, y))) {
                            // If the cell is unset, we embed the position adjustment pattern here.
                            // -2 is necessary since the x/y coordinates point to the center of the pattern, not the
                            // left top corner.
                            MatrixUtil.embedPositionAdjustmentPattern(x - 2, y - 2, matrix);
                        }
                    }
                }
            }
        }
    }
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([1, 1, 1, 1, 1, 1, 1]),
        Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
        Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
        Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
        Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
        Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
        Int32Array.from([1, 1, 1, 1, 1, 1, 1]),
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([1, 1, 1, 1, 1]),
        Int32Array.from([1, 0, 0, 0, 1]),
        Int32Array.from([1, 0, 1, 0, 1]),
        Int32Array.from([1, 0, 0, 0, 1]),
        Int32Array.from([1, 1, 1, 1, 1]),
    ]);
    // From Appendix E. Table 1, JIS0510X:2004 (71: p). The table was double-checked by komatsu.
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([-1, -1, -1, -1, -1, -1, -1]),
        Int32Array.from([6, 18, -1, -1, -1, -1, -1]),
        Int32Array.from([6, 22, -1, -1, -1, -1, -1]),
        Int32Array.from([6, 26, -1, -1, -1, -1, -1]),
        Int32Array.from([6, 30, -1, -1, -1, -1, -1]),
        Int32Array.from([6, 34, -1, -1, -1, -1, -1]),
        Int32Array.from([6, 22, 38, -1, -1, -1, -1]),
        Int32Array.from([6, 24, 42, -1, -1, -1, -1]),
        Int32Array.from([6, 26, 46, -1, -1, -1, -1]),
        Int32Array.from([6, 28, 50, -1, -1, -1, -1]),
        Int32Array.from([6, 30, 54, -1, -1, -1, -1]),
        Int32Array.from([6, 32, 58, -1, -1, -1, -1]),
        Int32Array.from([6, 34, 62, -1, -1, -1, -1]),
        Int32Array.from([6, 26, 46, 66, -1, -1, -1]),
        Int32Array.from([6, 26, 48, 70, -1, -1, -1]),
        Int32Array.from([6, 26, 50, 74, -1, -1, -1]),
        Int32Array.from([6, 30, 54, 78, -1, -1, -1]),
        Int32Array.from([6, 30, 56, 82, -1, -1, -1]),
        Int32Array.from([6, 30, 58, 86, -1, -1, -1]),
        Int32Array.from([6, 34, 62, 90, -1, -1, -1]),
        Int32Array.from([6, 28, 50, 72, 94, -1, -1]),
        Int32Array.from([6, 26, 50, 74, 98, -1, -1]),
        Int32Array.from([6, 30, 54, 78, 102, -1, -1]),
        Int32Array.from([6, 28, 54, 80, 106, -1, -1]),
        Int32Array.from([6, 32, 58, 84, 110, -1, -1]),
        Int32Array.from([6, 30, 58, 86, 114, -1, -1]),
        Int32Array.from([6, 34, 62, 90, 118, -1, -1]),
        Int32Array.from([6, 26, 50, 74, 98, 122, -1]),
        Int32Array.from([6, 30, 54, 78, 102, 126, -1]),
        Int32Array.from([6, 26, 52, 78, 104, 130, -1]),
        Int32Array.from([6, 30, 56, 82, 108, 134, -1]),
        Int32Array.from([6, 34, 60, 86, 112, 138, -1]),
        Int32Array.from([6, 30, 58, 86, 114, 142, -1]),
        Int32Array.from([6, 34, 62, 90, 118, 146, -1]),
        Int32Array.from([6, 30, 54, 78, 102, 126, 150]),
        Int32Array.from([6, 24, 50, 76, 102, 128, 154]),
        Int32Array.from([6, 28, 54, 80, 106, 132, 158]),
        Int32Array.from([6, 32, 58, 84, 110, 136, 162]),
        Int32Array.from([6, 26, 54, 82, 110, 138, 166]),
        Int32Array.from([6, 30, 58, 86, 114, 142, 170]),
    ]);
    // Type info cells at the left top corner.
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([8, 0]),
        Int32Array.from([8, 1]),
        Int32Array.from([8, 2]),
        Int32Array.from([8, 3]),
        Int32Array.from([8, 4]),
        Int32Array.from([8, 5]),
        Int32Array.from([8, 7]),
        Int32Array.from([8, 8]),
        Int32Array.from([7, 8]),
        Int32Array.from([5, 8]),
        Int32Array.from([4, 8]),
        Int32Array.from([3, 8]),
        Int32Array.from([2, 8]),
        Int32Array.from([1, 8]),
        Int32Array.from([0, 8]),
    ]);
    // From Appendix D in JISX0510:2004 (p. 67)
    MatrixUtil.VERSION_INFO_POLY = 0x1f25; // 1 1111 0010 0101
    // From Appendix C in JISX0510:2004 (p.65).
    MatrixUtil.TYPE_INFO_POLY = 0x537;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 0x5412;

    /*namespace com.google.zxing.qrcode.encoder {*/
    class BlockPair {
        constructor(dataBytes, errorCorrectionBytes) {
            this.dataBytes = dataBytes;
            this.errorCorrectionBytes = errorCorrectionBytes;
        }
        getDataBytes() {
            return this.dataBytes;
        }
        getErrorCorrectionBytes() {
            return this.errorCorrectionBytes;
        }
    }

    /*import java.io.UnsupportedEncodingException;*/
    /*import java.util.ArrayList;*/
    /*import java.util.Collection;*/
    /*import java.util.Map;*/
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */
    class Encoder {
        // TYPESCRIPTPORT: changed to UTF8, the default for js
        constructor() { }
        // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
        // Basically it applies four rules and summate all penalties.
        static calculateMaskPenalty(matrix) {
            return MaskUtil.applyMaskPenaltyRule1(matrix)
                + MaskUtil.applyMaskPenaltyRule2(matrix)
                + MaskUtil.applyMaskPenaltyRule3(matrix)
                + MaskUtil.applyMaskPenaltyRule4(matrix);
        }
        /**
         * @param content text to encode
         * @param ecLevel error correction level to use
         * @return {@link QRCode} representing the encoded QR code
         * @throws WriterException if encoding can't succeed, because of for example invalid content
         *   or configuration
         */
        // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
        //   return encode(content, ecLevel, null)
        // }
        static encode(content, ecLevel, hints = null) {
            // Determine what character encoding has been specified by the caller, if any
            let encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
            const hasEncodingHint = hints !== null && undefined !== hints.get(EncodeHintType$1.CHARACTER_SET);
            if (hasEncodingHint) {
                encoding = hints.get(EncodeHintType$1.CHARACTER_SET).toString();
            }
            // Pick an encoding mode appropriate for the content. Note that this will not attempt to use
            // multiple modes / segments even if that were more efficient. Twould be nice.
            const mode = this.chooseMode(content, encoding);
            // This will store the header information, like mode and
            // length, as well as "header" segments like an ECI segment.
            const headerBits = new BitArray();
            // Append ECI segment if applicable
            if (mode === Mode$1.BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
                const eci = CharacterSetECI.getCharacterSetECIByName(encoding);
                if (eci !== undefined) {
                    this.appendECI(eci, headerBits);
                }
            }
            // (With ECI in place,) Write the mode marker
            this.appendModeInfo(mode, headerBits);
            // Collect data within the main segment, separately, to count its size if needed. Don't add it to
            // main payload yet.
            const dataBits = new BitArray();
            this.appendBytes(content, mode, dataBits, encoding);
            let version;
            if (hints !== null && undefined !== hints.get(EncodeHintType$1.QR_VERSION)) {
                const versionNumber = Number.parseInt(hints.get(EncodeHintType$1.QR_VERSION).toString(), 10);
                version = Version$1.getVersionForNumber(versionNumber);
                const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version);
                if (!this.willFit(bitsNeeded, version, ecLevel)) {
                    throw new WriterException('Data too big for requested version');
                }
            }
            else {
                version = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
            }
            const headerAndDataBits = new BitArray();
            headerAndDataBits.appendBitArray(headerBits);
            // Find "length" of main segment and write it
            const numLetters = mode === Mode$1.BYTE ? dataBits.getSizeInBytes() : content.length;
            this.appendLengthInfo(numLetters, version, mode, headerAndDataBits);
            // Put data together into the overall payload
            headerAndDataBits.appendBitArray(dataBits);
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numDataBytes = version.getTotalCodewords() - ecBlocks.getTotalECCodewords();
            // Terminate the bits properly.
            this.terminateBits(numDataBytes, headerAndDataBits);
            // Interleave data bits with error correction code.
            const finalBits = this.interleaveWithECBytes(headerAndDataBits, version.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
            const qrCode = new QRCode();
            qrCode.setECLevel(ecLevel);
            qrCode.setMode(mode);
            qrCode.setVersion(version);
            //  Choose the mask pattern and set to "qrCode".
            const dimension = version.getDimensionForVersion();
            const matrix = new ByteMatrix(dimension, dimension);
            const maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version, matrix);
            qrCode.setMaskPattern(maskPattern);
            // Build the matrix and set it to "qrCode".
            MatrixUtil.buildMatrix(finalBits, ecLevel, version, maskPattern, matrix);
            qrCode.setMatrix(matrix);
            return qrCode;
        }
        /**
         * Decides the smallest version of QR code that will contain all of the provided data.
         *
         * @throws WriterException if the data cannot fit in any version
         */
        static recommendVersion(ecLevel, mode, headerBits, dataBits) {
            // Hard part: need to know version to know how many bits length takes. But need to know how many
            // bits it takes to know version. First we take a guess at version by assuming version will be
            // the minimum, 1:
            const provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, Version$1.getVersionForNumber(1));
            const provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
            // Use that guess to calculate the right version. I am still not sure this works in 100% of cases.
            const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
            return this.chooseVersion(bitsNeeded, ecLevel);
        }
        static calculateBitsNeeded(mode, headerBits, dataBits, version) {
            return headerBits.getSize() + mode.getCharacterCountBits(version) + dataBits.getSize();
        }
        /**
         * @return the code point of the table used in alphanumeric mode or
         *  -1 if there is no corresponding code in the table.
         */
        static getAlphanumericCode(code /*int*/) {
            if (code < Encoder.ALPHANUMERIC_TABLE.length) {
                return Encoder.ALPHANUMERIC_TABLE[code];
            }
            return -1;
        }
        // public static chooseMode(content: string): Mode {
        //   return chooseMode(content, null);
        // }
        /**
         * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
         * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
         */
        static chooseMode(content, encoding = null) {
            if (CharacterSetECI.SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) {
                // Choose Kanji mode if all input are double-byte characters
                return Mode$1.KANJI;
            }
            let hasNumeric = false;
            let hasAlphanumeric = false;
            for (let i = 0, length = content.length; i < length; ++i) {
                const c = content.charAt(i);
                if (Encoder.isDigit(c)) {
                    hasNumeric = true;
                }
                else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) {
                    hasAlphanumeric = true;
                }
                else {
                    return Mode$1.BYTE;
                }
            }
            if (hasAlphanumeric) {
                return Mode$1.ALPHANUMERIC;
            }
            if (hasNumeric) {
                return Mode$1.NUMERIC;
            }
            return Mode$1.BYTE;
        }
        static isOnlyDoubleByteKanji(content) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS); // content.getBytes("Shift_JIS"))
            }
            catch (ignored /*: UnsupportedEncodingException*/) {
                return false;
            }
            const length = bytes.length;
            if (length % 2 !== 0) {
                return false;
            }
            for (let i = 0; i < length; i += 2) {
                const byte1 = bytes[i] & 0xFF;
                if ((byte1 < 0x81 || byte1 > 0x9F) && (byte1 < 0xE0 || byte1 > 0xEB)) {
                    return false;
                }
            }
            return true;
        }
        static chooseMaskPattern(bits, ecLevel, version, matrix) {
            let minPenalty = Number.MAX_SAFE_INTEGER; // Lower penalty is better.
            let bestMaskPattern = -1;
            // We try all mask patterns to choose the best one.
            for (let maskPattern = 0; maskPattern < QRCode.NUM_MASK_PATTERNS; maskPattern++) {
                MatrixUtil.buildMatrix(bits, ecLevel, version, maskPattern, matrix);
                let penalty = this.calculateMaskPenalty(matrix);
                if (penalty < minPenalty) {
                    minPenalty = penalty;
                    bestMaskPattern = maskPattern;
                }
            }
            return bestMaskPattern;
        }
        static chooseVersion(numInputBits /*int*/, ecLevel) {
            for (let versionNum = 1; versionNum <= 40; versionNum++) {
                const version = Version$1.getVersionForNumber(versionNum);
                if (Encoder.willFit(numInputBits, version, ecLevel)) {
                    return version;
                }
            }
            throw new WriterException('Data too big');
        }
        /**
         * @return true if the number of input bits will fit in a code with the specified version and
         * error correction level.
         */
        static willFit(numInputBits /*int*/, version, ecLevel) {
            // In the following comments, we use numbers of Version 7-H.
            // numBytes = 196
            const numBytes = version.getTotalCodewords();
            // getNumECBytes = 130
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numEcBytes = ecBlocks.getTotalECCodewords();
            // getNumDataBytes = 196 - 130 = 66
            const numDataBytes = numBytes - numEcBytes;
            const totalInputBytes = (numInputBits + 7) / 8;
            return numDataBytes >= totalInputBytes;
        }
        /**
         * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
         */
        static terminateBits(numDataBytes /*int*/, bits) {
            const capacity = numDataBytes * 8;
            if (bits.getSize() > capacity) {
                throw new WriterException('data bits cannot fit in the QR Code' + bits.getSize() + ' > ' +
                    capacity);
            }
            for (let i = 0; i < 4 && bits.getSize() < capacity; ++i) {
                bits.appendBit(false);
            }
            // Append termination bits. See 8.4.8 of JISX0510:2004 (p.24) for details.
            // If the last byte isn't 8-bit aligned, we'll add padding bits.
            const numBitsInLastByte = bits.getSize() & 0x07;
            if (numBitsInLastByte > 0) {
                for (let i = numBitsInLastByte; i < 8; i++) {
                    bits.appendBit(false);
                }
            }
            // If we have more space, we'll fill the space with padding patterns defined in 8.4.9 (p.24).
            const numPaddingBytes = numDataBytes - bits.getSizeInBytes();
            for (let i = 0; i < numPaddingBytes; ++i) {
                bits.appendBits((i & 0x01) === 0 ? 0xEC : 0x11, 8);
            }
            if (bits.getSize() !== capacity) {
                throw new WriterException('Bits size does not equal capacity');
            }
        }
        /**
         * Get number of data bytes and number of error correction bytes for block id "blockID". Store
         * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
         * JISX0510:2004 (p.30)
         */
        static getNumDataBytesAndNumECBytesForBlockID(numTotalBytes /*int*/, numDataBytes /*int*/, numRSBlocks /*int*/, blockID /*int*/, numDataBytesInBlock, numECBytesInBlock) {
            if (blockID >= numRSBlocks) {
                throw new WriterException('Block ID too large');
            }
            // numRsBlocksInGroup2 = 196 % 5 = 1
            const numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
            // numRsBlocksInGroup1 = 5 - 1 = 4
            const numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
            // numTotalBytesInGroup1 = 196 / 5 = 39
            const numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
            // numTotalBytesInGroup2 = 39 + 1 = 40
            const numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
            // numDataBytesInGroup1 = 66 / 5 = 13
            const numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
            // numDataBytesInGroup2 = 13 + 1 = 14
            const numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
            // numEcBytesInGroup1 = 39 - 13 = 26
            const numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
            // numEcBytesInGroup2 = 40 - 14 = 26
            const numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
            // Sanity checks.
            // 26 = 26
            if (numEcBytesInGroup1 !== numEcBytesInGroup2) {
                throw new WriterException('EC bytes mismatch');
            }
            // 5 = 4 + 1.
            if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) {
                throw new WriterException('RS blocks mismatch');
            }
            // 196 = (13 + 26) * 4 + (14 + 26) * 1
            if (numTotalBytes !==
                ((numDataBytesInGroup1 + numEcBytesInGroup1) *
                    numRsBlocksInGroup1) +
                    ((numDataBytesInGroup2 + numEcBytesInGroup2) *
                        numRsBlocksInGroup2)) {
                throw new WriterException('Total bytes mismatch');
            }
            if (blockID < numRsBlocksInGroup1) {
                numDataBytesInBlock[0] = numDataBytesInGroup1;
                numECBytesInBlock[0] = numEcBytesInGroup1;
            }
            else {
                numDataBytesInBlock[0] = numDataBytesInGroup2;
                numECBytesInBlock[0] = numEcBytesInGroup2;
            }
        }
        /**
         * Interleave "bits" with corresponding error correction bytes. On success, store the result in
         * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
         */
        static interleaveWithECBytes(bits, numTotalBytes /*int*/, numDataBytes /*int*/, numRSBlocks /*int*/) {
            // "bits" must have "getNumDataBytes" bytes of data.
            if (bits.getSizeInBytes() !== numDataBytes) {
                throw new WriterException('Number of bits and data bytes does not match');
            }
            // Step 1.  Divide data bytes into blocks and generate error correction bytes for them. We'll
            // store the divided data bytes blocks and error correction bytes blocks into "blocks".
            let dataBytesOffset = 0;
            let maxNumDataBytes = 0;
            let maxNumEcBytes = 0;
            // Since, we know the number of reedsolmon blocks, we can initialize the vector with the number.
            const blocks = new Array(); // new Array<BlockPair>(numRSBlocks)
            for (let i = 0; i < numRSBlocks; ++i) {
                const numDataBytesInBlock = new Int32Array(1);
                const numEcBytesInBlock = new Int32Array(1);
                Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i, numDataBytesInBlock, numEcBytesInBlock);
                const size = numDataBytesInBlock[0];
                const dataBytes = new Uint8Array(size);
                bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
                const ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
                blocks.push(new BlockPair(dataBytes, ecBytes));
                maxNumDataBytes = Math.max(maxNumDataBytes, size);
                maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
                dataBytesOffset += numDataBytesInBlock[0];
            }
            if (numDataBytes !== dataBytesOffset) {
                throw new WriterException('Data bytes does not match offset');
            }
            const result = new BitArray();
            // First, place data blocks.
            for (let i = 0; i < maxNumDataBytes; ++i) {
                for (const block of blocks) {
                    const dataBytes = block.getDataBytes();
                    if (i < dataBytes.length) {
                        result.appendBits(dataBytes[i], 8);
                    }
                }
            }
            // Then, place error correction blocks.
            for (let i = 0; i < maxNumEcBytes; ++i) {
                for (const block of blocks) {
                    const ecBytes = block.getErrorCorrectionBytes();
                    if (i < ecBytes.length) {
                        result.appendBits(ecBytes[i], 8);
                    }
                }
            }
            if (numTotalBytes !== result.getSizeInBytes()) { // Should be same.
                throw new WriterException('Interleaving error: ' + numTotalBytes + ' and ' +
                    result.getSizeInBytes() + ' differ.');
            }
            return result;
        }
        static generateECBytes(dataBytes, numEcBytesInBlock /*int*/) {
            const numDataBytes = dataBytes.length;
            const toEncode = new Int32Array(numDataBytes + numEcBytesInBlock); // int[numDataBytes + numEcBytesInBlock]
            for (let i = 0; i < numDataBytes; i++) {
                toEncode[i] = dataBytes[i] & 0xFF;
            }
            new ReedSolomonEncoder(GenericGF.QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
            const ecBytes = new Uint8Array(numEcBytesInBlock);
            for (let i = 0; i < numEcBytesInBlock; i++) {
                ecBytes[i] = /*(byte) */ toEncode[numDataBytes + i];
            }
            return ecBytes;
        }
        /**
         * Append mode info. On success, store the result in "bits".
         */
        static appendModeInfo(mode, bits) {
            bits.appendBits(mode.getBits(), 4);
        }
        /**
         * Append length info. On success, store the result in "bits".
         */
        static appendLengthInfo(numLetters /*int*/, version, mode, bits) {
            const numBits = mode.getCharacterCountBits(version);
            if (numLetters >= (1 << numBits)) {
                throw new WriterException(numLetters + ' is bigger than ' + ((1 << numBits) - 1));
            }
            bits.appendBits(numLetters, numBits);
        }
        /**
         * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
         */
        static appendBytes(content, mode, bits, encoding) {
            switch (mode) {
                case Mode$1.NUMERIC:
                    Encoder.appendNumericBytes(content, bits);
                    break;
                case Mode$1.ALPHANUMERIC:
                    Encoder.appendAlphanumericBytes(content, bits);
                    break;
                case Mode$1.BYTE:
                    Encoder.append8BitBytes(content, bits, encoding);
                    break;
                case Mode$1.KANJI:
                    Encoder.appendKanjiBytes(content, bits);
                    break;
                default:
                    throw new WriterException('Invalid mode: ' + mode);
            }
        }
        static getDigit(singleCharacter) {
            return singleCharacter.charCodeAt(0) - 48;
        }
        static isDigit(singleCharacter) {
            const cn = Encoder.getDigit(singleCharacter);
            return cn >= 0 && cn <= 9;
        }
        static appendNumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while (i < length) {
                const num1 = Encoder.getDigit(content.charAt(i));
                if (i + 2 < length) {
                    // Encode three numeric letters in ten bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    const num3 = Encoder.getDigit(content.charAt(i + 2));
                    bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
                    i += 3;
                }
                else if (i + 1 < length) {
                    // Encode two numeric letters in seven bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    bits.appendBits(num1 * 10 + num2, 7);
                    i += 2;
                }
                else {
                    // Encode one numeric letter in four bits.
                    bits.appendBits(num1, 4);
                    i++;
                }
            }
        }
        static appendAlphanumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while (i < length) {
                const code1 = Encoder.getAlphanumericCode(content.charCodeAt(i));
                if (code1 === -1) {
                    throw new WriterException();
                }
                if (i + 1 < length) {
                    const code2 = Encoder.getAlphanumericCode(content.charCodeAt(i + 1));
                    if (code2 === -1) {
                        throw new WriterException();
                    }
                    // Encode two alphanumeric letters in 11 bits.
                    bits.appendBits(code1 * 45 + code2, 11);
                    i += 2;
                }
                else {
                    // Encode one alphanumeric letter in six bits.
                    bits.appendBits(code1, 6);
                    i++;
                }
            }
        }
        static append8BitBytes(content, bits, encoding) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, encoding);
            }
            catch (uee /*: UnsupportedEncodingException*/) {
                throw new WriterException(uee);
            }
            for (let i = 0, length = bytes.length; i !== length; i++) {
                const b = bytes[i];
                bits.appendBits(b, 8);
            }
        }
        /**
         * @throws WriterException
         */
        static appendKanjiBytes(content, bits) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS);
            }
            catch (uee /*: UnsupportedEncodingException*/) {
                throw new WriterException(uee);
            }
            const length = bytes.length;
            for (let i = 0; i < length; i += 2) {
                const byte1 = bytes[i] & 0xFF;
                const byte2 = bytes[i + 1] & 0xFF;
                const code = ((byte1 << 8) & 0xFFFFFFFF) | byte2;
                let subtracted = -1;
                if (code >= 0x8140 && code <= 0x9ffc) {
                    subtracted = code - 0x8140;
                }
                else if (code >= 0xe040 && code <= 0xebbf) {
                    subtracted = code - 0xc140;
                }
                if (subtracted === -1) {
                    throw new WriterException('Invalid byte sequence');
                }
                const encoded = ((subtracted >> 8) * 0xc0) + (subtracted & 0xff);
                bits.appendBits(encoded, 13);
            }
        }
        static appendECI(eci, bits) {
            bits.appendBits(Mode$1.ECI.getBits(), 4);
            // This is correct for values up to 127, which is all we need now.
            bits.appendBits(eci.getValue(), 8);
        }
    }
    // The original table is defined in the table 5 of JISX0510:2004 (p.19).
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        36, -1, -1, -1, 37, 38, -1, -1, -1, -1, 39, 40, -1, 41, 42, 43,
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 44, -1, -1, -1, -1, -1,
        -1, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
        25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, -1, -1, -1, -1, -1,
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = CharacterSetECI.UTF8.getName(); // "ISO-8859-1"

    /**
     * @deprecated Moving to @zxing/browser
     */
    class BrowserQRCodeSvgWriter {
        /**
         * Writes and renders a QRCode SVG element.
         *
         * @param contents
         * @param width
         * @param height
         * @param hints
         */
        write(contents, width, height, hints = null) {
            if (contents.length === 0) {
                throw new IllegalArgumentException('Found empty contents');
            }
            // if (format != BarcodeFormat.QR_CODE) {
            //   throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format)
            // }
            if (width < 0 || height < 0) {
                throw new IllegalArgumentException('Requested dimensions are too small: ' + width + 'x' + height);
            }
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) {
                    errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                }
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) {
                    quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
                }
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return this.renderResult(code, width, height, quietZone);
        }
        /**
         * Renders the result and then appends it to the DOM.
         */
        writeToDom(containerElement, contents, width, height, hints = null) {
            if (typeof containerElement === 'string') {
                containerElement = document.querySelector(containerElement);
            }
            const svgElement = this.write(contents, width, height, hints);
            if (containerElement)
                containerElement.appendChild(svgElement);
        }
        /**
         * Note that the input matrix uses 0 == white, 1 == black.
         * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
         */
        renderResult(code, width /*int*/, height /*int*/, quietZone /*int*/) {
            const input = code.getMatrix();
            if (input === null) {
                throw new IllegalStateException();
            }
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + (quietZone * 2);
            const qrHeight = inputHeight + (quietZone * 2);
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - (inputWidth * multiple)) / 2);
            const topPadding = Math.floor((outputHeight - (inputHeight * multiple)) / 2);
            const svgElement = this.createSVGElement(outputWidth, outputHeight);
            for (let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple) {
                // Write the contents of this row of the barcode
                for (let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple) {
                    if (input.get(inputX, inputY) === 1) {
                        const svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
                        svgElement.appendChild(svgRectElement);
                    }
                }
            }
            return svgElement;
        }
        /**
         * Creates a SVG element.
         *
         * @param w SVG's width attribute
         * @param h SVG's height attribute
         */
        createSVGElement(w, h) {
            const svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'svg');
            svgElement.setAttributeNS(null, 'height', w.toString());
            svgElement.setAttributeNS(null, 'width', h.toString());
            return svgElement;
        }
        /**
         * Creates a SVG rect element.
         *
         * @param x Element's x coordinate
         * @param y Element's y coordinate
         * @param w Element's width attribute
         * @param h Element's height attribute
         */
        createSvgRectElement(x, y, w, h) {
            const rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'rect');
            rect.setAttributeNS(null, 'x', x.toString());
            rect.setAttributeNS(null, 'y', y.toString());
            rect.setAttributeNS(null, 'height', w.toString());
            rect.setAttributeNS(null, 'width', h.toString());
            rect.setAttributeNS(null, 'fill', '#000000');
            return rect;
        }
    }
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    /**
     * SVG markup NameSpace
     */
    BrowserQRCodeSvgWriter.SVG_NS = 'http://www.w3.org/2000/svg';

    /*import java.util.Map;*/
    /**
     * This object renders a QR Code as a BitMatrix 2D array of greyscale values.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class QRCodeWriter {
        /*@Override*/
        // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
        //     /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/
        encode(contents, format, width /*int*/, height /*int*/, hints) {
            if (contents.length === 0) {
                throw new IllegalArgumentException('Found empty contents');
            }
            if (format !== BarcodeFormat$1.QR_CODE) {
                throw new IllegalArgumentException('Can only encode QR_CODE, but got ' + format);
            }
            if (width < 0 || height < 0) {
                throw new IllegalArgumentException(`Requested dimensions are too small: ${width}x${height}`);
            }
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) {
                    errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                }
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) {
                    quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
                }
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return QRCodeWriter.renderResult(code, width, height, quietZone);
        }
        // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
        // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
        static renderResult(code, width /*int*/, height /*int*/, quietZone /*int*/) {
            const input = code.getMatrix();
            if (input === null) {
                throw new IllegalStateException();
            }
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + (quietZone * 2);
            const qrHeight = inputHeight + (quietZone * 2);
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - (inputWidth * multiple)) / 2);
            const topPadding = Math.floor((outputHeight - (inputHeight * multiple)) / 2);
            const output = new BitMatrix(outputWidth, outputHeight);
            for (let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple) {
                // Write the contents of this row of the barcode
                for (let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple) {
                    if (input.get(inputX, inputY) === 1) {
                        output.setRegion(outputX, outputY, multiple, multiple);
                    }
                }
            }
            return output;
        }
    }
    QRCodeWriter.QUIET_ZONE_SIZE = 4;

    /*import java.util.Map;*/
    /**
     * This is a factory class which finds the appropriate Writer subclass for the BarcodeFormat
     * requested and encodes the barcode with the supplied contents.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class MultiFormatWriter {
        /*@Override*/
        // public encode(contents: string,
        //                         format: BarcodeFormat,
        //                         width: number /*int*/,
        //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/
        encode(contents, format, width /*int*/, height /*int*/, hints) {
            let writer;
            switch (format) {
                // case BarcodeFormat.EAN_8:
                //   writer = new EAN8Writer()
                //   break
                // case BarcodeFormat.UPC_E:
                //   writer = new UPCEWriter()
                //   break
                // case BarcodeFormat.EAN_13:
                //   writer = new EAN13Writer()
                //   break
                // case BarcodeFormat.UPC_A:
                //   writer = new UPCAWriter()
                //   break
                case BarcodeFormat$1.QR_CODE:
                    writer = new QRCodeWriter();
                    break;
                // case BarcodeFormat.CODE_39:
                //   writer = new Code39Writer()
                //   break
                // case BarcodeFormat.CODE_93:
                //   writer = new Code93Writer()
                //   break
                // case BarcodeFormat.CODE_128:
                //   writer = new Code128Writer()
                //   break
                // case BarcodeFormat.ITF:
                //   writer = new ITFWriter()
                //   break
                // case BarcodeFormat.PDF_417:
                //   writer = new PDF417Writer()
                //   break
                // case BarcodeFormat.CODABAR:
                //   writer = new CodaBarWriter()
                //   break
                // case BarcodeFormat.DATA_MATRIX:
                //   writer = new DataMatrixWriter()
                //   break
                // case BarcodeFormat.AZTEC:
                //   writer = new AztecWriter()
                //   break
                default:
                    throw new IllegalArgumentException('No encoder available for format ' + format);
            }
            return writer.encode(contents, format, width, height, hints);
        }
    }

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This object extends LuminanceSource around an array of YUV data returned from the camera driver,
     * with the option to crop to a rectangle within the full data. This can be used to exclude
     * superfluous pixels around the perimeter and speed up decoding.
     *
     * It works for any pixel format where the Y channel is planar and appears first, including
     * YCbCr_420_SP and YCbCr_422_SP.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */
    class PlanarYUVLuminanceSource extends LuminanceSource {
        constructor(yuvData, dataWidth /*int*/, dataHeight /*int*/, left /*int*/, top /*int*/, width /*int*/, height /*int*/, reverseHorizontal) {
            super(width, height);
            this.yuvData = yuvData;
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (left + width > dataWidth || top + height > dataHeight) {
                throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
            }
            if (reverseHorizontal) {
                this.reverseHorizontal(width, height);
            }
        }
        /*@Override*/
        getRow(y /*int*/, row) {
            if (y < 0 || y >= this.getHeight()) {
                throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            }
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) {
                row = new Uint8ClampedArray(width);
            }
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.yuvData, offset, row, 0, width);
            return row;
        }
        /*@Override*/
        getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) {
                return this.yuvData;
            }
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.yuvData, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for (let y = 0; y < height; y++) {
                const outputOffset = y * width;
                System.arraycopy(this.yuvData, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/
        isCropSupported() {
            return true;
        }
        /*@Override*/
        crop(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
        }
        renderThumbnail() {
            const width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const pixels = new Int32Array(width * height);
            const yuv = this.yuvData;
            let inputOffset = this.top * this.dataWidth + this.left;
            for (let y = 0; y < height; y++) {
                const outputOffset = y * width;
                for (let x = 0; x < width; x++) {
                    const grey = yuv[inputOffset + x * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 0xff;
                    pixels[outputOffset + x] = 0xFF000000 | (grey * 0x00010101);
                }
                inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            }
            return pixels;
        }
        /**
         * @return width of image from {@link #renderThumbnail()}
         */
        getThumbnailWidth() {
            return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        /**
         * @return height of image from {@link #renderThumbnail()}
         */
        getThumbnailHeight() {
            return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        reverseHorizontal(width /*int*/, height /*int*/) {
            const yuvData = this.yuvData;
            for (let y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth) {
                const middle = rowStart + width / 2;
                for (let x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--) {
                    const temp = yuvData[x1];
                    yuvData[x1] = yuvData[x2];
                    yuvData[x2] = temp;
                }
            }
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;

    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This class is used to help decode images from files which arrive as RGB data from
     * an ARGB pixel array. It does not support rotation.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Betaminos
     */
    class RGBLuminanceSource extends LuminanceSource {
        constructor(luminances, width /*int*/, height /*int*/, dataWidth /*int*/, dataHeight /*int*/, left /*int*/, top /*int*/) {
            super(width, height);
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (luminances.BYTES_PER_ELEMENT === 4) { // Int32Array
                const size = width * height;
                const luminancesUint8Array = new Uint8ClampedArray(size);
                for (let offset = 0; offset < size; offset++) {
                    const pixel = luminances[offset];
                    const r = (pixel >> 16) & 0xff; // red
                    const g2 = (pixel >> 7) & 0x1fe; // 2 * green
                    const b = pixel & 0xff; // blue
                    // Calculate green-favouring average cheaply
                    luminancesUint8Array[offset] = /*(byte) */ ((r + g2 + b) / 4) & 0xFF;
                }
                this.luminances = luminancesUint8Array;
            }
            else {
                this.luminances = luminances;
            }
            if (undefined === dataWidth) {
                this.dataWidth = width;
            }
            if (undefined === dataHeight) {
                this.dataHeight = height;
            }
            if (undefined === left) {
                this.left = 0;
            }
            if (undefined === top) {
                this.top = 0;
            }
            if (this.left + width > this.dataWidth || this.top + height > this.dataHeight) {
                throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
            }
        }
        /*@Override*/
        getRow(y /*int*/, row) {
            if (y < 0 || y >= this.getHeight()) {
                throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            }
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) {
                row = new Uint8ClampedArray(width);
            }
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.luminances, offset, row, 0, width);
            return row;
        }
        /*@Override*/
        getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) {
                return this.luminances;
            }
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.luminances, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for (let y = 0; y < height; y++) {
                const outputOffset = y * width;
                System.arraycopy(this.luminances, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/
        isCropSupported() {
            return true;
        }
        /*@Override*/
        crop(left /*int*/, top /*int*/, width /*int*/, height /*int*/) {
            return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }

    /**
     * Just to make a shortcut between Java code and TS code.
     */
    class Charset extends CharacterSetECI {
        static forName(name) {
            return this.getCharacterSetECIByName(name);
        }
    }

    /**
     * Just to make a shortcut between Java code and TS code.
     */
    class StandardCharsets {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI.ISO8859_1;

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * Aztec 2D code representation
     *
     * @author Rustam Abdullaev
     */
    /*public final*/ class AztecCode {
        /**
         * @return {@code true} if compact instead of full mode
         */
        isCompact() {
            return this.compact;
        }
        setCompact(compact) {
            this.compact = compact;
        }
        /**
         * @return size in pixels (width and height)
         */
        getSize() {
            return this.size;
        }
        setSize(size) {
            this.size = size;
        }
        /**
         * @return number of levels
         */
        getLayers() {
            return this.layers;
        }
        setLayers(layers) {
            this.layers = layers;
        }
        /**
         * @return number of data codewords
         */
        getCodeWords() {
            return this.codeWords;
        }
        setCodeWords(codeWords) {
            this.codeWords = codeWords;
        }
        /**
         * @return the symbol image
         */
        getMatrix() {
            return this.matrix;
        }
        setMatrix(matrix) {
            this.matrix = matrix;
        }
    }

    class Collections {
        /**
         * The singletonList(T) method is used to return an immutable list containing only the specified object.
         */
        static singletonList(item) {
            return [item];
        }
        /**
         * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
         */
        static min(collection, comparator) {
            return collection.sort(comparator)[0];
        }
    }

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    class Token {
        constructor(previous) {
            this.previous = previous;
        }
        getPrevious() {
            return this.previous;
        }
    }

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /*final*/ class SimpleToken extends Token {
        constructor(previous, value, bitCount) {
            super(previous);
            this.value = value;
            this.bitCount = bitCount;
        }
        /**
         * @Override
         */
        appendTo(bitArray, text) {
            bitArray.appendBits(this.value, this.bitCount);
        }
        add(value, bitCount) {
            return new SimpleToken(this, value, bitCount);
        }
        addBinaryShift(start, byteCount) {
            // no-op can't binary shift a simple token
            console.warn('addBinaryShift on SimpleToken, this simply returns a copy of this token');
            return new SimpleToken(this, start, byteCount);
        }
        /**
         * @Override
         */
        toString() {
            let value = this.value & ((1 << this.bitCount) - 1);
            value |= 1 << this.bitCount;
            return '<' + Integer.toBinaryString(value | (1 << this.bitCount)).substring(1) + '>';
        }
    }

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /*final*/ class BinaryShiftToken extends SimpleToken {
        constructor(previous, binaryShiftStart, binaryShiftByteCount) {
            super(previous, 0, 0);
            this.binaryShiftStart = binaryShiftStart;
            this.binaryShiftByteCount = binaryShiftByteCount;
        }
        /**
         * @Override
         */
        appendTo(bitArray, text) {
            for (let i = 0; i < this.binaryShiftByteCount; i++) {
                if (i === 0 || (i === 31 && this.binaryShiftByteCount <= 62)) {
                    // We need a header before the first character, and before
                    // character 31 when the total byte code is <= 62
                    bitArray.appendBits(31, 5); // BINARY_SHIFT
                    if (this.binaryShiftByteCount > 62) {
                        bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
                    }
                    else if (i === 0) {
                        // 1 <= binaryShiftByteCode <= 62
                        bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
                    }
                    else {
                        // 32 <= binaryShiftCount <= 62 and i == 31
                        bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
                    }
                }
                bitArray.appendBits(text[this.binaryShiftStart + i], 8);
            }
        }
        addBinaryShift(start, byteCount) {
            // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
            return new BinaryShiftToken(this, start, byteCount);
        }
        /**
         * @Override
         */
        toString() {
            return '<' + this.binaryShiftStart + '::' + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + '>';
        }
    }

    function addBinaryShift(token, start, byteCount) {
        // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
        return new BinaryShiftToken(token, start, byteCount);
    }
    function add(token, value, bitCount) {
        return new SimpleToken(token, value, bitCount);
    }

    const /*final*/ MODE_NAMES = [
        'UPPER',
        'LOWER',
        'DIGIT',
        'MIXED',
        'PUNCT'
    ];
    const /*final*/ MODE_UPPER = 0; // 5 bits
    const /*final*/ MODE_LOWER = 1; // 5 bits
    const /*final*/ MODE_DIGIT = 2; // 4 bits
    const /*final*/ MODE_MIXED = 3; // 5 bits
    const /*final*/ MODE_PUNCT = 4; // 5 bits
    const EMPTY_TOKEN = new SimpleToken(null, 0, 0);

    // The Latch Table shows, for each pair of Modes, the optimal method for
    // getting from one mode to another.  In the worst possible case, this can
    // be up to 14 bits.  In the best possible case, we are already there!
    // The high half-word of each entry gives the number of bits.
    // The low half-word of each entry are the actual bits necessary to change
    const LATCH_TABLE = [
        Int32Array.from([
            0,
            (5 << 16) + 28,
            (5 << 16) + 30,
            (5 << 16) + 29,
            (10 << 16) + (29 << 5) + 30 // UPPER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            (9 << 16) + (30 << 4) + 14,
            0,
            (5 << 16) + 30,
            (5 << 16) + 29,
            (10 << 16) + (29 << 5) + 30 // LOWER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            (4 << 16) + 14,
            (9 << 16) + (14 << 5) + 28,
            0,
            (9 << 16) + (14 << 5) + 29,
            (14 << 16) + (14 << 10) + (29 << 5) + 30
            // DIGIT -> UPPER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            (5 << 16) + 29,
            (5 << 16) + 28,
            (10 << 16) + (29 << 5) + 30,
            0,
            (5 << 16) + 30 // MIXED -> PUNCT
        ]),
        Int32Array.from([
            (5 << 16) + 31,
            (10 << 16) + (31 << 5) + 28,
            (10 << 16) + (31 << 5) + 30,
            (10 << 16) + (31 << 5) + 29,
            0
        ])
    ];

    function static_SHIFT_TABLE(SHIFT_TABLE) {
        for (let table /*Int32Array*/ of SHIFT_TABLE) {
            Arrays.fill(table, -1);
        }
        SHIFT_TABLE[MODE_UPPER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_UPPER] = 28;
        SHIFT_TABLE[MODE_MIXED][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_UPPER] = 15;
        return SHIFT_TABLE;
    }
    const /*final*/ SHIFT_TABLE = static_SHIFT_TABLE(Arrays.createInt32Array(6, 6)); // mode shift codes, per table

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * State represents all information about a sequence necessary to generate the current output.
     * Note that a state is immutable.
     */
    /*final*/ class State {
        constructor(token, mode, binaryBytes, bitCount) {
            this.token = token;
            this.mode = mode;
            this.binaryShiftByteCount = binaryBytes;
            this.bitCount = bitCount;
            // Make sure we match the token
            // int binaryShiftBitCount = (binaryShiftByteCount * 8) +
            //    (binaryShiftByteCount === 0 ? 0 :
            //     binaryShiftByteCount <= 31 ? 10 :
            //     binaryShiftByteCount <= 62 ? 20 : 21);
            // assert this.bitCount === token.getTotalBitCount() + binaryShiftBitCount;
        }
        getMode() {
            return this.mode;
        }
        getToken() {
            return this.token;
        }
        getBinaryShiftByteCount() {
            return this.binaryShiftByteCount;
        }
        getBitCount() {
            return this.bitCount;
        }
        // Create a new state representing this state with a latch to a (not
        // necessary different) mode, and then a code.
        latchAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0;
            let bitCount = this.bitCount;
            let token = this.token;
            if (mode !== this.mode) {
                let latch = LATCH_TABLE[this.mode][mode];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
            }
            let latchModeBitCount = mode === MODE_DIGIT ? 4 : 5;
            token = add(token, value, latchModeBitCount);
            return new State(token, mode, 0, bitCount + latchModeBitCount);
        }
        // Create a new state representing this state, with a temporary shift
        // to a different mode to output a single value.
        shiftAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0 && this.mode !== mode;
            let token = this.token;
            let thisModeBitCount = this.mode === MODE_DIGIT ? 4 : 5;
            // Shifts exist only to UPPER and PUNCT, both with tokens size 5.
            token = add(token, SHIFT_TABLE[this.mode][mode], thisModeBitCount);
            token = add(token, value, 5);
            return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
        }
        // Create a new state representing this state, but an additional character
        // output in Binary Shift mode.
        addBinaryShiftChar(index) {
            let token = this.token;
            let mode = this.mode;
            let bitCount = this.bitCount;
            if (this.mode === MODE_PUNCT || this.mode === MODE_DIGIT) {
                // assert binaryShiftByteCount === 0;
                let latch = LATCH_TABLE[mode][MODE_UPPER];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
                mode = MODE_UPPER;
            }
            let deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31
                ? 18
                : this.binaryShiftByteCount === 62
                    ? 9
                    : 8;
            let result = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
            if (result.binaryShiftByteCount === 2047 + 31) {
                // The string is as long as it's allowed to be.  We should end it.
                result = result.endBinaryShift(index + 1);
            }
            return result;
        }
        // Create the state identical to this one, but we are no longer in
        // Binary Shift mode.
        endBinaryShift(index) {
            if (this.binaryShiftByteCount === 0) {
                return this;
            }
            let token = this.token;
            token = addBinaryShift(token, index - this.binaryShiftByteCount, this.binaryShiftByteCount);
            // assert token.getTotalBitCount() === this.bitCount;
            return new State(token, this.mode, 0, this.bitCount);
        }
        // Returns true if "this" state is better (equal: or) to be in than "that"
        // state under all possible circumstances.
        isBetterThanOrEqualTo(other) {
            let newModeBitCount = this.bitCount + (LATCH_TABLE[this.mode][other.mode] >> 16);
            if (this.binaryShiftByteCount < other.binaryShiftByteCount) {
                // add additional B/S encoding cost of other, if any
                newModeBitCount +=
                    State.calculateBinaryShiftCost(other) -
                        State.calculateBinaryShiftCost(this);
            }
            else if (this.binaryShiftByteCount > other.binaryShiftByteCount &&
                other.binaryShiftByteCount > 0) {
                // maximum possible additional cost (it: h)
                newModeBitCount += 10;
            }
            return newModeBitCount <= other.bitCount;
        }
        toBitArray(text) {
            // Reverse the tokens, so that they are in the order that they should
            // be output
            let symbols = [];
            for (let token = this.endBinaryShift(text.length).token; token !== null; token = token.getPrevious()) {
                symbols.unshift(token);
            }
            let bitArray = new BitArray();
            // Add each token to the result.
            for (const symbol of symbols) {
                symbol.appendTo(bitArray, text);
            }
            // assert bitArray.getSize() === this.bitCount;
            return bitArray;
        }
        /**
         * @Override
         */
        toString() {
            return StringUtils.format('%s bits=%d bytes=%d', MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
        }
        static calculateBinaryShiftCost(state) {
            if (state.binaryShiftByteCount > 62) {
                return 21; // B/S with extended length
            }
            if (state.binaryShiftByteCount > 31) {
                return 20; // two B/S
            }
            if (state.binaryShiftByteCount > 0) {
                return 10; // one B/S
            }
            return 0;
        }
    }
    State.INITIAL_STATE = new State(EMPTY_TOKEN, MODE_UPPER, 0, 0);

    function static_CHAR_MAP(CHAR_MAP) {
        const spaceCharCode = StringUtils.getCharCode(' ');
        const pointCharCode = StringUtils.getCharCode('.');
        const commaCharCode = StringUtils.getCharCode(',');
        CHAR_MAP[MODE_UPPER][spaceCharCode] = 1;
        const zUpperCharCode = StringUtils.getCharCode('Z');
        const aUpperCharCode = StringUtils.getCharCode('A');
        for (let c = aUpperCharCode; c <= zUpperCharCode; c++) {
            CHAR_MAP[MODE_UPPER][c] = c - aUpperCharCode + 2;
        }
        CHAR_MAP[MODE_LOWER][spaceCharCode] = 1;
        const zLowerCharCode = StringUtils.getCharCode('z');
        const aLowerCharCode = StringUtils.getCharCode('a');
        for (let c = aLowerCharCode; c <= zLowerCharCode; c++) {
            CHAR_MAP[MODE_LOWER][c] = c - aLowerCharCode + 2;
        }
        CHAR_MAP[MODE_DIGIT][spaceCharCode] = 1;
        const nineCharCode = StringUtils.getCharCode('9');
        const zeroCharCode = StringUtils.getCharCode('0');
        for (let c = zeroCharCode; c <= nineCharCode; c++) {
            CHAR_MAP[MODE_DIGIT][c] = c - zeroCharCode + 2;
        }
        CHAR_MAP[MODE_DIGIT][commaCharCode] = 12;
        CHAR_MAP[MODE_DIGIT][pointCharCode] = 13;
        const mixedTable = [
            '\x00',
            ' ',
            '\x01',
            '\x02',
            '\x03',
            '\x04',
            '\x05',
            '\x06',
            '\x07',
            '\b',
            '\t',
            '\n',
            '\x0b',
            '\f',
            '\r',
            '\x1b',
            '\x1c',
            '\x1d',
            '\x1e',
            '\x1f',
            '@',
            '\\',
            '^',
            '_',
            '`',
            '|',
            '~',
            '\x7f'
        ];
        for (let i = 0; i < mixedTable.length; i++) {
            CHAR_MAP[MODE_MIXED][StringUtils.getCharCode(mixedTable[i])] = i;
        }
        const punctTable = [
            '\x00',
            '\r',
            '\x00',
            '\x00',
            '\x00',
            '\x00',
            '!',
            '\'',
            '#',
            '$',
            '%',
            '&',
            '\'',
            '(',
            ')',
            '*',
            '+',
            ',',
            '-',
            '.',
            '/',
            ':',
            ';',
            '<',
            '=',
            '>',
            '?',
            '[',
            ']',
            '{',
            '}'
        ];
        for (let i = 0; i < punctTable.length; i++) {
            if (StringUtils.getCharCode(punctTable[i]) > 0) {
                CHAR_MAP[MODE_PUNCT][StringUtils.getCharCode(punctTable[i])] = i;
            }
        }
        return CHAR_MAP;
    }
    const CHAR_MAP = static_CHAR_MAP(Arrays.createInt32Array(5, 256));

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * This produces nearly optimal encodings of text into the first-level of
     * encoding used by Aztec code.
     *
     * It uses a dynamic algorithm.  For each prefix of the string, it determines
     * a set of encodings that could lead to this prefix.  We repeatedly add a
     * character and generate a new set of optimal encodings until we have read
     * through the entire input.
     *
     * @author Frank Yellin
     * @author Rustam Abdullaev
     */
    /*public final*/ class HighLevelEncoder {
        constructor(text) {
            this.text = text;
        }
        /**
         * @return text represented by this encoder encoded as a {@link BitArray}
         */
        encode() {
            const spaceCharCode = StringUtils.getCharCode(' ');
            const lineBreakCharCode = StringUtils.getCharCode('\n');
            let states = Collections.singletonList(State.INITIAL_STATE);
            for (let index = 0; index < this.text.length; index++) {
                let pairCode;
                let nextChar = index + 1 < this.text.length ? this.text[index + 1] : 0;
                switch (this.text[index]) {
                    case StringUtils.getCharCode('\r'):
                        pairCode = nextChar === lineBreakCharCode ? 2 : 0;
                        break;
                    case StringUtils.getCharCode('.'):
                        pairCode = nextChar === spaceCharCode ? 3 : 0;
                        break;
                    case StringUtils.getCharCode(','):
                        pairCode = nextChar === spaceCharCode ? 4 : 0;
                        break;
                    case StringUtils.getCharCode(':'):
                        pairCode = nextChar === spaceCharCode ? 5 : 0;
                        break;
                    default:
                        pairCode = 0;
                }
                if (pairCode > 0) {
                    // We have one of the four special PUNCT pairs.  Treat them specially.
                    // Get a new set of states for the two new characters.
                    states = HighLevelEncoder.updateStateListForPair(states, index, pairCode);
                    index++;
                }
                else {
                    // Get a new set of states for the new character.
                    states = this.updateStateListForChar(states, index);
                }
            }
            // We are left with a set of states.  Find the shortest one.
            const minState = Collections.min(states, (a, b) => {
                return a.getBitCount() - b.getBitCount();
            });
            // Convert it to a bit array, and return.
            return minState.toBitArray(this.text);
        }
        // We update a set of states for a new character by updating each state
        // for the new character, merging the results, and then removing the
        // non-optimal states.
        updateStateListForChar(states, index) {
            const result = [];
            for (let state /*State*/ of states) {
                this.updateStateForChar(state, index, result);
            }
            return HighLevelEncoder.simplifyStates(result);
        }
        // Return a set of states that represent the possible ways of updating this
        // state for the next character.  The resulting set of states are added to
        // the "result" list.
        updateStateForChar(state, index, result) {
            let ch = (this.text[index] & 0xff);
            let charInCurrentTable = CHAR_MAP[state.getMode()][ch] > 0;
            let stateNoBinary = null;
            for (let mode /*int*/ = 0; mode <= MODE_PUNCT; mode++) {
                let charInMode = CHAR_MAP[mode][ch];
                if (charInMode > 0) {
                    if (stateNoBinary == null) {
                        // Only create stateNoBinary the first time it's required.
                        stateNoBinary = state.endBinaryShift(index);
                    }
                    // Try generating the character by latching to its mode
                    if (!charInCurrentTable ||
                        mode === state.getMode() ||
                        mode === MODE_DIGIT) {
                        // If the character is in the current table, we don't want to latch to
                        // any other mode except possibly digit (which uses only 4 bits).  Any
                        // other latch would be equally successful *after* this character, and
                        // so wouldn't save any bits.
                        const latchState = stateNoBinary.latchAndAppend(mode, charInMode);
                        result.push(latchState);
                    }
                    // Try generating the character by switching to its mode.
                    if (!charInCurrentTable &&
                        SHIFT_TABLE[state.getMode()][mode] >= 0) {
                        // It never makes sense to temporarily shift to another mode if the
                        // character exists in the current mode.  That can never save bits.
                        const shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
                        result.push(shiftState);
                    }
                }
            }
            if (state.getBinaryShiftByteCount() > 0 ||
                CHAR_MAP[state.getMode()][ch] === 0) {
                // It's never worthwhile to go into binary shift mode if you're not already
                // in binary shift mode, and the character exists in your current mode.
                // That can never save bits over just outputting the char in the current mode.
                let binaryState = state.addBinaryShiftChar(index);
                result.push(binaryState);
            }
        }
        static updateStateListForPair(states, index, pairCode) {
            const result = [];
            for (let state /*State*/ of states) {
                this.updateStateForPair(state, index, pairCode, result);
            }
            return this.simplifyStates(result);
        }
        static updateStateForPair(state, index, pairCode, result) {
            let stateNoBinary = state.endBinaryShift(index);
            // Possibility 1.  Latch to C.MODE_PUNCT, and then append this code
            result.push(stateNoBinary.latchAndAppend(MODE_PUNCT, pairCode));
            if (state.getMode() !== MODE_PUNCT) {
                // Possibility 2.  Shift to C.MODE_PUNCT, and then append this code.
                // Every state except C.MODE_PUNCT (handled above) can shift
                result.push(stateNoBinary.shiftAndAppend(MODE_PUNCT, pairCode));
            }
            if (pairCode === 3 || pairCode === 4) {
                // both characters are in DIGITS.  Sometimes better to just add two digits
                let digitState = stateNoBinary
                    .latchAndAppend(MODE_DIGIT, 16 - pairCode) // period or comma in DIGIT
                    .latchAndAppend(MODE_DIGIT, 1); // space in DIGIT
                result.push(digitState);
            }
            if (state.getBinaryShiftByteCount() > 0) {
                // It only makes sense to do the characters as binary if we're already
                // in binary mode.
                let binaryState = state
                    .addBinaryShiftChar(index)
                    .addBinaryShiftChar(index + 1);
                result.push(binaryState);
            }
        }
        static simplifyStates(states) {
            let result = [];
            for (const newState of states) {
                let add = true;
                for (const oldState of result) {
                    if (oldState.isBetterThanOrEqualTo(newState)) {
                        add = false;
                        break;
                    }
                    if (newState.isBetterThanOrEqualTo(oldState)) {
                        // iterator.remove();
                        result = result.filter(x => x !== oldState); // remove old state
                    }
                }
                if (add) {
                    result.push(newState);
                }
            }
            return result;
        }
    }

    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    // package com.google.zxing.aztec.encoder;
    // import com.google.zxing.common.BitArray;
    // import com.google.zxing.common.BitMatrix;
    // import com.google.zxing.common.reedsolomon.GenericGF;
    // import com.google.zxing.common.reedsolomon.ReedSolomonEncoder;
    /**
     * Generates Aztec 2D barcodes.
     *
     * @author Rustam Abdullaev
     */
    /*public final*/ class Encoder$1 {
        constructor() {
        }
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @return Aztec symbol matrix with metadata
         */
        static encodeBytes(data) {
            return Encoder$1.encode(data, Encoder$1.DEFAULT_EC_PERCENT, Encoder$1.DEFAULT_AZTEC_LAYERS);
        }
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
         *                      a minimum of 23% + 3 words is recommended)
         * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
         * @return Aztec symbol matrix with metadata
         */
        static encode(data, minECCPercent, userSpecifiedLayers) {
            // High-level encode
            let bits = new HighLevelEncoder(data).encode();
            // stuff bits and choose symbol size
            let eccBits = Integer.truncDivision((bits.getSize() * minECCPercent), 100) + 11;
            let totalSizeBits = bits.getSize() + eccBits;
            let compact;
            let layers;
            let totalBitsInLayer;
            let wordSize;
            let stuffedBits;
            if (userSpecifiedLayers !== Encoder$1.DEFAULT_AZTEC_LAYERS) {
                compact = userSpecifiedLayers < 0;
                layers = Math.abs(userSpecifiedLayers);
                if (layers > (compact ? Encoder$1.MAX_NB_BITS_COMPACT : Encoder$1.MAX_NB_BITS)) {
                    throw new IllegalArgumentException(StringUtils.format('Illegal value %s for layers', userSpecifiedLayers));
                }
                totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                wordSize = Encoder$1.WORD_SIZE[layers];
                let usableBitsInLayers = totalBitsInLayer - (totalBitsInLayer % wordSize);
                stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                if (stuffedBits.getSize() + eccBits > usableBitsInLayers) {
                    throw new IllegalArgumentException('Data to large for user specified layer');
                }
                if (compact && stuffedBits.getSize() > wordSize * 64) {
                    // Compact format only allows 64 data words, though C4 can hold more words than that
                    throw new IllegalArgumentException('Data to large for user specified layer');
                }
            }
            else {
                wordSize = 0;
                stuffedBits = null;
                // We look at the possible table sizes in the order Compact1, Compact2, Compact3,
                // Compact4, Normal4,...  Normal(i) for i < 4 isn't typically used since Compact(i+1)
                // is the same size, but has more data.
                for (let i /*int*/ = 0;; i++) {
                    if (i > Encoder$1.MAX_NB_BITS) {
                        throw new IllegalArgumentException('Data too large for an Aztec code');
                    }
                    compact = i <= 3;
                    layers = compact ? i + 1 : i;
                    totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                    if (totalSizeBits > totalBitsInLayer) {
                        continue;
                    }
                    // [Re]stuff the bits if this is the first opportunity, or if the
                    // wordSize has changed
                    if (stuffedBits == null || wordSize !== Encoder$1.WORD_SIZE[layers]) {
                        wordSize = Encoder$1.WORD_SIZE[layers];
                        stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                    }
                    let usableBitsInLayers = totalBitsInLayer - (totalBitsInLayer % wordSize);
                    if (compact && stuffedBits.getSize() > wordSize * 64) {
                        // Compact format only allows 64 data words, though C4 can hold more words than that
                        continue;
                    }
                    if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) {
                        break;
                    }
                }
            }
            let messageBits = Encoder$1.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
            // generate mode message
            let messageSizeInWords = stuffedBits.getSize() / wordSize;
            let modeMessage = Encoder$1.generateModeMessage(compact, layers, messageSizeInWords);
            // allocate symbol
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let matrixSize;
            if (compact) {
                // no alignment marks in compact mode, alignmentMap is a no-op
                matrixSize = baseMatrixSize;
                for (let i /*int*/ = 0; i < alignmentMap.length; i++) {
                    alignmentMap[i] = i;
                }
            }
            else {
                matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision((Integer.truncDivision(baseMatrixSize, 2) - 1), 15);
                let origCenter = Integer.truncDivision(baseMatrixSize, 2);
                let center = Integer.truncDivision(matrixSize, 2);
                for (let i /*int*/ = 0; i < origCenter; i++) {
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            let matrix = new BitMatrix(matrixSize);
            // draw data bits
            for (let i /*int*/ = 0, rowOffset = 0; i < layers; i++) {
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                for (let j /*int*/ = 0; j < rowSize; j++) {
                    let columnOffset = j * 2;
                    for (let k /*int*/ = 0; k < 2; k++) {
                        if (messageBits.get(rowOffset + columnOffset + k)) {
                            matrix.set(alignmentMap[i * 2 + k], alignmentMap[i * 2 + j]);
                        }
                        if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) {
                            matrix.set(alignmentMap[i * 2 + j], alignmentMap[baseMatrixSize - 1 - i * 2 - k]);
                        }
                        if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) {
                            matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - k], alignmentMap[baseMatrixSize - 1 - i * 2 - j]);
                        }
                        if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) {
                            matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - j], alignmentMap[i * 2 + k]);
                        }
                    }
                }
                rowOffset += rowSize * 8;
            }
            // draw mode message
            Encoder$1.drawModeMessage(matrix, compact, matrixSize, modeMessage);
            // draw alignment marks
            if (compact) {
                Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 5);
            }
            else {
                Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 7);
                for (let i /*int*/ = 0, j = 0; i < Integer.truncDivision(baseMatrixSize, 2) - 1; i += 15, j += 16) {
                    for (let k /*int*/ = Integer.truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2) {
                        matrix.set(Integer.truncDivision(matrixSize, 2) - j, k);
                        matrix.set(Integer.truncDivision(matrixSize, 2) + j, k);
                        matrix.set(k, Integer.truncDivision(matrixSize, 2) - j);
                        matrix.set(k, Integer.truncDivision(matrixSize, 2) + j);
                    }
                }
            }
            let aztec = new AztecCode();
            aztec.setCompact(compact);
            aztec.setSize(matrixSize);
            aztec.setLayers(layers);
            aztec.setCodeWords(messageSizeInWords);
            aztec.setMatrix(matrix);
            return aztec;
        }
        static drawBullsEye(matrix, center, size) {
            for (let i /*int*/ = 0; i < size; i += 2) {
                for (let j /*int*/ = center - i; j <= center + i; j++) {
                    matrix.set(j, center - i);
                    matrix.set(j, center + i);
                    matrix.set(center - i, j);
                    matrix.set(center + i, j);
                }
            }
            matrix.set(center - size, center - size);
            matrix.set(center - size + 1, center - size);
            matrix.set(center - size, center - size + 1);
            matrix.set(center + size, center - size);
            matrix.set(center + size, center - size + 1);
            matrix.set(center + size, center + size - 1);
        }
        static generateModeMessage(compact, layers, messageSizeInWords) {
            let modeMessage = new BitArray();
            if (compact) {
                modeMessage.appendBits(layers - 1, 2);
                modeMessage.appendBits(messageSizeInWords - 1, 6);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 28, 4);
            }
            else {
                modeMessage.appendBits(layers - 1, 5);
                modeMessage.appendBits(messageSizeInWords - 1, 11);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 40, 4);
            }
            return modeMessage;
        }
        static drawModeMessage(matrix, compact, matrixSize, modeMessage) {
            let center = Integer.truncDivision(matrixSize, 2);
            if (compact) {
                for (let i /*int*/ = 0; i < 7; i++) {
                    let offset = center - 3 + i;
                    if (modeMessage.get(i)) {
                        matrix.set(offset, center - 5);
                    }
                    if (modeMessage.get(i + 7)) {
                        matrix.set(center + 5, offset);
                    }
                    if (modeMessage.get(20 - i)) {
                        matrix.set(offset, center + 5);
                    }
                    if (modeMessage.get(27 - i)) {
                        matrix.set(center - 5, offset);
                    }
                }
            }
            else {
                for (let i /*int*/ = 0; i < 10; i++) {
                    let offset = center - 5 + i + Integer.truncDivision(i, 5);
                    if (modeMessage.get(i)) {
                        matrix.set(offset, center - 7);
                    }
                    if (modeMessage.get(i + 10)) {
                        matrix.set(center + 7, offset);
                    }
                    if (modeMessage.get(29 - i)) {
                        matrix.set(offset, center + 7);
                    }
                    if (modeMessage.get(39 - i)) {
                        matrix.set(center - 7, offset);
                    }
                }
            }
        }
        static generateCheckWords(bitArray, totalBits, wordSize) {
            // bitArray is guaranteed to be a multiple of the wordSize, so no padding needed
            let messageSizeInWords = bitArray.getSize() / wordSize;
            let rs = new ReedSolomonEncoder(Encoder$1.getGF(wordSize));
            let totalWords = Integer.truncDivision(totalBits, wordSize);
            let messageWords = Encoder$1.bitsToWords(bitArray, wordSize, totalWords);
            rs.encode(messageWords, totalWords - messageSizeInWords);
            let startPad = totalBits % wordSize;
            let messageBits = new BitArray();
            messageBits.appendBits(0, startPad);
            for (const messageWord /*: int*/ of Array.from(messageWords)) {
                messageBits.appendBits(messageWord, wordSize);
            }
            return messageBits;
        }
        static bitsToWords(stuffedBits, wordSize, totalWords) {
            let message = new Int32Array(totalWords);
            let i;
            let n;
            for (i = 0, n = stuffedBits.getSize() / wordSize; i < n; i++) {
                let value = 0;
                for (let j /*int*/ = 0; j < wordSize; j++) {
                    value |= stuffedBits.get(i * wordSize + j) ? (1 << wordSize - j - 1) : 0;
                }
                message[i] = value;
            }
            return message;
        }
        static getGF(wordSize) {
            switch (wordSize) {
                case 4:
                    return GenericGF.AZTEC_PARAM;
                case 6:
                    return GenericGF.AZTEC_DATA_6;
                case 8:
                    return GenericGF.AZTEC_DATA_8;
                case 10:
                    return GenericGF.AZTEC_DATA_10;
                case 12:
                    return GenericGF.AZTEC_DATA_12;
                default:
                    throw new IllegalArgumentException('Unsupported word size ' + wordSize);
            }
        }
        static stuffBits(bits, wordSize) {
            let out = new BitArray();
            let n = bits.getSize();
            let mask = (1 << wordSize) - 2;
            for (let i /*int*/ = 0; i < n; i += wordSize) {
                let word = 0;
                for (let j /*int*/ = 0; j < wordSize; j++) {
                    if (i + j >= n || bits.get(i + j)) {
                        word |= 1 << (wordSize - 1 - j);
                    }
                }
                if ((word & mask) === mask) {
                    out.appendBits(word & mask, wordSize);
                    i--;
                }
                else if ((word & mask) === 0) {
                    out.appendBits(word | 1, wordSize);
                    i--;
                }
                else {
                    out.appendBits(word, wordSize);
                }
            }
            return out;
        }
        static totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Encoder$1.DEFAULT_EC_PERCENT = 33; // default minimal percentage of error check words
    Encoder$1.DEFAULT_AZTEC_LAYERS = 0;
    Encoder$1.MAX_NB_BITS = 32;
    Encoder$1.MAX_NB_BITS_COMPACT = 4;
    Encoder$1.WORD_SIZE = Int32Array.from([
        4, 6, 6, 8, 8, 8, 8, 8, 8, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
        12, 12, 12, 12, 12, 12, 12, 12, 12, 12
    ]);

    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    /**
     * Renders an Aztec code as a {@link BitMatrix}.
     */
    /*public final*/ class AztecWriter {
        // @Override
        encode(contents, format, width, height) {
            return this.encodeWithHints(contents, format, width, height, null);
        }
        // @Override
        encodeWithHints(contents, format, width, height, hints) {
            let charset = StandardCharsets.ISO_8859_1;
            let eccPercent = Encoder$1.DEFAULT_EC_PERCENT;
            let layers = Encoder$1.DEFAULT_AZTEC_LAYERS;
            if (hints != null) {
                if (hints.has(EncodeHintType$1.CHARACTER_SET)) {
                    charset = Charset.forName(hints.get(EncodeHintType$1.CHARACTER_SET).toString());
                }
                if (hints.has(EncodeHintType$1.ERROR_CORRECTION)) {
                    eccPercent = Integer.parseInt(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                }
                if (hints.has(EncodeHintType$1.AZTEC_LAYERS)) {
                    layers = Integer.parseInt(hints.get(EncodeHintType$1.AZTEC_LAYERS).toString());
                }
            }
            return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
        }
        static encodeLayers(contents, format, width, height, charset, eccPercent, layers) {
            if (format !== BarcodeFormat$1.AZTEC) {
                throw new IllegalArgumentException('Can only encode AZTEC, but got ' + format);
            }
            let aztec = Encoder$1.encode(StringUtils.getBytes(contents, charset), eccPercent, layers);
            return AztecWriter.renderResult(aztec, width, height);
        }
        static renderResult(code, width, height) {
            let input = code.getMatrix();
            if (input == null) {
                throw new IllegalStateException();
            }
            let inputWidth = input.getWidth();
            let inputHeight = input.getHeight();
            let outputWidth = Math.max(width, inputWidth);
            let outputHeight = Math.max(height, inputHeight);
            let multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
            let leftPadding = (outputWidth - (inputWidth * multiple)) / 2;
            let topPadding = (outputHeight - (inputHeight * multiple)) / 2;
            let output = new BitMatrix(outputWidth, outputHeight);
            for (let inputY /*int*/ = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple) {
                // Write the contents of this row of the barcode
                for (let inputX /*int*/ = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple) {
                    if (input.get(inputX, inputY)) {
                        output.setRegion(outputX, outputY, multiple, multiple);
                    }
                }
            }
            return output;
        }
    }

    exports.AbstractExpandedDecoder = AbstractExpandedDecoder;
    exports.ArgumentException = ArgumentException;
    exports.ArithmeticException = ArithmeticException;
    exports.AztecCode = AztecCode;
    exports.AztecCodeReader = AztecReader;
    exports.AztecCodeWriter = AztecWriter;
    exports.AztecDecoder = Decoder;
    exports.AztecDetector = Detector;
    exports.AztecDetectorResult = AztecDetectorResult;
    exports.AztecEncoder = Encoder$1;
    exports.AztecHighLevelEncoder = HighLevelEncoder;
    exports.AztecPoint = Point;
    exports.BarcodeFormat = BarcodeFormat$1;
    exports.Binarizer = Binarizer;
    exports.BinaryBitmap = BinaryBitmap;
    exports.BitArray = BitArray;
    exports.BitMatrix = BitMatrix;
    exports.BitSource = BitSource;
    exports.BrowserAztecCodeReader = BrowserAztecCodeReader;
    exports.BrowserBarcodeReader = BrowserBarcodeReader;
    exports.BrowserCodeReader = BrowserCodeReader;
    exports.BrowserDatamatrixCodeReader = BrowserDatamatrixCodeReader;
    exports.BrowserMultiFormatReader = BrowserMultiFormatReader;
    exports.BrowserPDF417Reader = BrowserPDF417Reader;
    exports.BrowserQRCodeReader = BrowserQRCodeReader;
    exports.BrowserQRCodeSvgWriter = BrowserQRCodeSvgWriter;
    exports.CharacterSetECI = CharacterSetECI;
    exports.ChecksumException = ChecksumException;
    exports.Code128Reader = Code128Reader;
    exports.Code39Reader = Code39Reader;
    exports.DataMatrixDecodedBitStreamParser = DecodedBitStreamParser;
    exports.DataMatrixReader = DataMatrixReader;
    exports.DecodeHintType = DecodeHintType$1;
    exports.DecoderResult = DecoderResult;
    exports.DefaultGridSampler = DefaultGridSampler;
    exports.DetectorResult = DetectorResult;
    exports.EAN13Reader = EAN13Reader;
    exports.EncodeHintType = EncodeHintType$1;
    exports.Exception = Exception;
    exports.FormatException = FormatException;
    exports.GenericGF = GenericGF;
    exports.GenericGFPoly = GenericGFPoly;
    exports.GlobalHistogramBinarizer = GlobalHistogramBinarizer;
    exports.GridSampler = GridSampler;
    exports.GridSamplerInstance = GridSamplerInstance;
    exports.HTMLCanvasElementLuminanceSource = HTMLCanvasElementLuminanceSource;
    exports.HybridBinarizer = HybridBinarizer;
    exports.ITFReader = ITFReader;
    exports.IllegalArgumentException = IllegalArgumentException;
    exports.IllegalStateException = IllegalStateException;
    exports.InvertedLuminanceSource = InvertedLuminanceSource;
    exports.LuminanceSource = LuminanceSource;
    exports.MathUtils = MathUtils;
    exports.MultiFormatOneDReader = MultiFormatOneDReader;
    exports.MultiFormatReader = MultiFormatReader;
    exports.MultiFormatWriter = MultiFormatWriter;
    exports.NotFoundException = NotFoundException;
    exports.OneDReader = OneDReader;
    exports.PDF417DecodedBitStreamParser = DecodedBitStreamParser$2;
    exports.PDF417DecoderErrorCorrection = ErrorCorrection;
    exports.PDF417Reader = PDF417Reader;
    exports.PDF417ResultMetadata = PDF417ResultMetadata;
    exports.PerspectiveTransform = PerspectiveTransform;
    exports.PlanarYUVLuminanceSource = PlanarYUVLuminanceSource;
    exports.QRCodeByteMatrix = ByteMatrix;
    exports.QRCodeDataMask = DataMask;
    exports.QRCodeDecodedBitStreamParser = DecodedBitStreamParser$1;
    exports.QRCodeDecoderErrorCorrectionLevel = ErrorCorrectionLevel;
    exports.QRCodeDecoderFormatInformation = FormatInformation;
    exports.QRCodeEncoder = Encoder;
    exports.QRCodeEncoderQRCode = QRCode;
    exports.QRCodeMaskUtil = MaskUtil;
    exports.QRCodeMatrixUtil = MatrixUtil;
    exports.QRCodeMode = Mode$1;
    exports.QRCodeReader = QRCodeReader;
    exports.QRCodeVersion = Version$1;
    exports.QRCodeWriter = QRCodeWriter;
    exports.RGBLuminanceSource = RGBLuminanceSource;
    exports.RSS14Reader = RSS14Reader;
    exports.RSSExpandedReader = RSSExpandedReader;
    exports.ReaderException = ReaderException;
    exports.ReedSolomonDecoder = ReedSolomonDecoder;
    exports.ReedSolomonEncoder = ReedSolomonEncoder;
    exports.ReedSolomonException = ReedSolomonException;
    exports.Result = Result;
    exports.ResultMetadataType = ResultMetadataType$1;
    exports.ResultPoint = ResultPoint;
    exports.StringUtils = StringUtils;
    exports.UnsupportedOperationException = UnsupportedOperationException;
    exports.VideoInputDevice = VideoInputDevice;
    exports.WhiteRectangleDetector = WhiteRectangleDetector;
    exports.WriterException = WriterException;
    exports.ZXingArrays = Arrays;
    exports.ZXingCharset = Charset;
    exports.ZXingInteger = Integer;
    exports.ZXingStandardCharsets = StandardCharsets;
    exports.ZXingStringBuilder = StringBuilder;
    exports.ZXingStringEncoding = StringEncoding;
    exports.ZXingSystem = System;
    exports.createAbstractExpandedDecoder = createDecoder;

    Object.defineProperty(exports, '__esModule', { value: true });

})));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],494:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],495:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],496:[function(require,module,exports){
'use strict';

var hasToStringTag = require('has-tostringtag/shams')();
var callBound = require('call-bound');

var $toString = callBound('Object.prototype.toString');

/** @type {import('.')} */
var isStandardArguments = function isArguments(value) {
	if (
		hasToStringTag
		&& value
		&& typeof value === 'object'
		&& Symbol.toStringTag in value
	) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

/** @type {import('.')} */
var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null
		&& typeof value === 'object'
		&& 'length' in value
		&& typeof value.length === 'number'
		&& value.length >= 0
		&& $toString(value) !== '[object Array]'
		&& 'callee' in value
		&& $toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

/** @type {import('.')} */
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"call-bound":373,"has-tostringtag/shams":452}],497:[function(require,module,exports){
'use strict';

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};

},{}],498:[function(require,module,exports){
'use strict';

var callBound = require('call-bound');
var safeRegexTest = require('safe-regex-test');
var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
var hasToStringTag = require('has-tostringtag/shams')();
var getProto = require('get-proto');

var toStr = callBound('Object.prototype.toString');
var fnToStr = callBound('Function.prototype.toString');

var getGeneratorFunction = require('generator-function');

/** @type {import('.')} */
module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex(fnToStr(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	var GeneratorFunction = getGeneratorFunction();
	return GeneratorFunction && getProto(fn) === GeneratorFunction.prototype;
};

},{"call-bound":373,"generator-function":442,"get-proto":446,"has-tostringtag/shams":452,"safe-regex-test":789}],499:[function(require,module,exports){
'use strict';

var callBound = require('call-bound');
var hasToStringTag = require('has-tostringtag/shams')();
var hasOwn = require('hasown');
var gOPD = require('gopd');

/** @type {import('.')} */
var fn;

if (hasToStringTag) {
	/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
	var $exec = callBound('RegExp.prototype.exec');
	/** @type {object} */
	var isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
	var badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}

	/** @type {import('.')} */
	// @ts-expect-error TS can't figure out that the $exec call always throws
	// eslint-disable-next-line consistent-return
	fn = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			// eslint-disable-next-line no-extra-parens
			$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
		} catch (e) {
			return e === isRegexMarker;
		}
	};
} else {
	/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
	var $toString = callBound('Object.prototype.toString');
	/** @const @type {'[object RegExp]'} */
	var regexClass = '[object RegExp]';

	/** @type {import('.')} */
	fn = function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};
}

module.exports = fn;

},{"call-bound":373,"gopd":448,"has-tostringtag/shams":452,"hasown":466}],500:[function(require,module,exports){
'use strict';

var whichTypedArray = require('which-typed-array');

/** @type {import('.')} */
module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};

},{"which-typed-array":823}],501:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],502:[function(require,module,exports){
const color = require('colors/safe')

const { extendedTypeOf } = require('./util')

const Theme = {
  ' ' (s) { return s },
  '+': color.green,
  '-': color.red
}

const subcolorizeToCallback = function (options, key, diff, output, color, indent) {
  let subvalue
  const prefix = key ? `${key}: ` : ''
  const subindent = indent + '  '

  const outputElisions = (n) => {
    const maxElisions = options.maxElisions === undefined ? Infinity : options.maxElisions
    if (n < maxElisions) {
      for (let i = 0; i < n; i++) {
        output(' ', subindent + '...')
      }
    } else {
      output(' ', subindent + `... (${n} entries)`)
    }
  }

  switch (extendedTypeOf(diff)) {
    case 'object':
      if (('__old' in diff) && ('__new' in diff) && (Object.keys(diff).length === 2)) {
        subcolorizeToCallback(options, key, diff.__old, output, '-', indent)
        return subcolorizeToCallback(options, key, diff.__new, output, '+', indent)
      } else {
        output(color, `${indent}${prefix}{`)
        for (const subkey of Object.keys(diff)) {
          let m
          subvalue = diff[subkey]
          if ((m = subkey.match(/^(.*)__deleted$/))) {
            subcolorizeToCallback(options, m[1], subvalue, output, '-', subindent)
          } else if ((m = subkey.match(/^(.*)__added$/))) {
            subcolorizeToCallback(options, m[1], subvalue, output, '+', subindent)
          } else {
            subcolorizeToCallback(options, subkey, subvalue, output, color, subindent)
          }
        }
        return output(color, `${indent}}`)
      }

    case 'array': {
      output(color, `${indent}${prefix}[`)

      let looksLikeDiff = true
      for (const item of diff) {
        if ((extendedTypeOf(item) !== 'array') || !((item.length === 2) || ((item.length === 1) && (item[0] === ' '))) || !(typeof (item[0]) === 'string') || (item[0].length !== 1) || !([' ', '-', '+', '~'].includes(item[0]))) {
          looksLikeDiff = false
        }
      }

      if (looksLikeDiff) {
        let op
        let elisionCount = 0
        for ([op, subvalue] of diff) {
          if (op === ' ' && subvalue == null) {
            elisionCount++
          } else {
            if (elisionCount > 0) {
              outputElisions(elisionCount)
            }
            elisionCount = 0

            if (![' ', '~', '+', '-'].includes(op)) {
              throw new Error(`Unexpected op '${op}' in ${JSON.stringify(diff, null, 2)}`)
            }
            if (op === '~') { op = ' ' }
            subcolorizeToCallback(options, '', subvalue, output, op, subindent)
          }
        }
        if (elisionCount > 0) {
          outputElisions(elisionCount)
        }
      } else {
        for (subvalue of diff) {
          subcolorizeToCallback(options, '', subvalue, output, color, subindent)
        }
      }

      return output(color, `${indent}]`)
    }

    default:
      if (diff === 0 || diff === null || diff === false || diff === '' || diff) {
        return output(color, indent + prefix + JSON.stringify(diff))
      }
  }
}

const colorizeToCallback = (diff, options, output) =>
  subcolorizeToCallback(options, '', diff, output, ' ', '')

const colorizeToArray = function (diff, options = {}) {
  const output = []
  colorizeToCallback(diff, options, (color, line) => output.push(`${color}${line}`))
  return output
}

const colorize = function (diff, options = {}) {
  const output = []
  colorizeToCallback(diff, options, function (color, line) {
    if (options.color != null ? options.color : true) {
      return output.push(((options.theme != null ? options.theme[color] : undefined) != null ? (options.theme != null ? options.theme[color] : undefined) : Theme[color])(`${color}${line}`) + '\n')
    } else {
      return output.push(`${color}${line}\n`)
    }
  })
  return output.join('')
}

module.exports = { colorize, colorizeToArray, colorizeToCallback }

},{"./util":504,"colors/safe":385}],503:[function(require,module,exports){
const { SequenceMatcher } = require('@ewoudenberg/difflib')
const { extendedTypeOf, roundObj } = require('./util')
const { colorize, colorizeToCallback } = require('./colorize')

class JsonDiff {
  constructor (options) {
    options.outputKeys = options.outputKeys || []
    options.excludeKeys = options.excludeKeys || []
    this.options = options
  }

  isScalar (obj) {
    return typeof obj !== 'object' || obj === null
  }

  objectDiff (obj1, obj2) {
    let result = {}
    let score = 0
    let equal = true

    for (const [key, value] of Object.entries(obj1)) {
      if (!this.options.outputNewOnly) {
        const postfix = '__deleted'

        if (!(key in obj2) && !(this.options.excludeKeys.includes(key))) {
          result[`${key}${postfix}`] = value
          score -= 30
          equal = false
        }
      }
    }

    for (const [key, value] of Object.entries(obj2)) {
      const postfix = !this.options.outputNewOnly ? '__added' : ''

      if (!(key in obj1) && !(this.options.excludeKeys.includes(key))) {
        result[`${key}${postfix}`] = value
        score -= 30
        equal = false
      }
    }

    for (const [key, value1] of Object.entries(obj1)) {
      if (key in obj2) {
        if (this.options.excludeKeys.includes(key)) {
          continue
        }
        score += 20
        const value2 = obj2[key]
        const change = this.diff(value1, value2)
        if (!change.equal) {
          result[key] = change.result
          equal = false
        } else if (this.options.full || this.options.outputKeys.includes(key)) {
          result[key] = value1
        }
        // console.log(`key ${key} change.score=${change.score} ${change.result}`)
        score += Math.min(20, Math.max(-10, change.score / 5)) // BATMAN!
      }
    }

    if (equal) {
      score = 100 * Math.max(Object.keys(obj1).length, 0.5)
      if (!this.options.full) {
        result = undefined
      }
    } else {
      score = Math.max(0, score)
    }

    // console.log(`objectDiff(${JSON.stringify(obj1, null, 2)} <=> ${JSON.stringify(obj2, null, 2)}) == ${JSON.stringify({score, result, equal})}`)
    return { score, result, equal }
  }

  findMatchingObject (item, index, fuzzyOriginals) {
    // console.log('findMatchingObject: ' + JSON.stringify({item, fuzzyOriginals}, null, 2))
    let bestMatch = null

    for (const [key, { item: candidate, index: matchIndex }] of Object.entries(fuzzyOriginals)) {
      if (key !== '__next') {
        const indexDistance = Math.abs(matchIndex - index)
        if (extendedTypeOf(item) === extendedTypeOf(candidate)) {
          const { score } = this.diff(item, candidate)
          if (
            !bestMatch ||
            score > bestMatch.score ||
            (score === bestMatch.score &&
              indexDistance < bestMatch.indexDistance)
          ) {
            bestMatch = { score, key, indexDistance }
          }
        }
      }
    }

    // console.log('findMatchingObject result = ' + JSON.stringify(bestMatch, null, 2));
    return bestMatch
  }

  scalarize (array, originals, fuzzyOriginals) {
    // console.log('scalarize', array, originals, fuzzyOriginals);
    const fuzzyMatches = []
    if (fuzzyOriginals) {
      // Find best fuzzy match for each object in the array
      const keyScores = {}
      for (let index = 0; index < array.length; index++) {
        const item = array[index]
        if (this.isScalar(item)) {
          continue
        }
        const bestMatch = this.findMatchingObject(item, index, fuzzyOriginals)
        if (bestMatch && (!keyScores[bestMatch.key] || bestMatch.score > keyScores[bestMatch.key].score)) {
          keyScores[bestMatch.key] = { score: bestMatch.score, index }
        }
      }
      for (const [key, match] of Object.entries(keyScores)) {
        fuzzyMatches[match.index] = key
      }
    }

    const result = []
    for (let index = 0; index < array.length; index++) {
      const item = array[index]
      if (this.isScalar(item)) {
        result.push(item)
      } else {
        const key = fuzzyMatches[index] || '__$!SCALAR' + originals.__next++
        originals[key] = { item, index }
        result.push(key)
      }
    }
    // console.log('Scalarize result', result);
    return result
  }

  isScalarized (item, originals) {
    return typeof item === 'string' && item in originals
  }

  descalarize (item, originals) {
    if (this.isScalarized(item, originals)) {
      return originals[item].item
    } else {
      return item
    }
  }

  arrayDiff (obj1, obj2) {
    const originals1 = { __next: 1 }
    const seq1 = this.scalarize(obj1, originals1)
    const originals2 = { __next: originals1.__next }
    const seq2 = this.scalarize(obj2, originals2, originals1)

    if (this.options.sort) {
      seq1.sort()
      seq2.sort()
    }
    const opcodes = new SequenceMatcher(null, seq1, seq2).getOpcodes()

    // console.log(`arrayDiff:\nobj1 = ${JSON.stringify(obj1, null, 2)}\nobj2 = ${JSON.stringify(obj2, null, 2)}\nseq1 = ${JSON.stringify(seq1, null, 2)}\nseq2 = ${JSON.stringify(seq2, null, 2)}\nopcodes = ${JSON.stringify(opcodes, null, 2)}`)

    let result = []
    let score = 0
    let equal = true

    for (const [op, i1, i2, j1, j2] of opcodes) {
      let i, j
      let asc, end
      let asc1, end1
      let asc2, end2
      if (!(op === 'equal' || (this.options.keysOnly && op === 'replace'))) {
        equal = false
      }

      switch (op) {
        case 'equal':
          for (
            i = i1, end = i2, asc = i1 <= end;
            asc ? i < end : i > end;
            asc ? i++ : i--
          ) {
            const item = seq1[i]
            if (this.isScalarized(item, originals1)) {
              if (!this.isScalarized(item, originals2)) {
                throw new Error(
                  `internal bug: isScalarized(item, originals1) != isScalarized(item, originals2) for item ${JSON.stringify(
                    item
                  )}`
                )
              }
              const item1 = this.descalarize(item, originals1)
              const item2 = this.descalarize(item, originals2)
              const change = this.diff(item1, item2)
              if (!change.equal) {
                result.push(['~', change.result])
                equal = false
              } else {
                if (this.options.full || this.options.keepUnchangedValues) {
                  result.push([' ', item1])
                } else {
                  result.push([' '])
                }
              }
            } else {
              if (this.options.full || this.options.keepUnchangedValues) {
                result.push([' ', item])
              } else {
                result.push([' '])
              }
            }
            score += 10
          }
          break
        case 'delete':
          for (
            i = i1, end1 = i2, asc1 = i1 <= end1;
            asc1 ? i < end1 : i > end1;
            asc1 ? i++ : i--
          ) {
            result.push(['-', this.descalarize(seq1[i], originals1)])
            score -= 5
          }
          break
        case 'insert':
          for (
            j = j1, end2 = j2, asc2 = j1 <= end2;
            asc2 ? j < end2 : j > end2;
            asc2 ? j++ : j--
          ) {
            result.push(['+', this.descalarize(seq2[j], originals2)])
            score -= 5
          }
          break
        case 'replace':
          if (!this.options.keysOnly) {
            let asc3, end3
            let asc4, end4
            for (
              i = i1, end3 = i2, asc3 = i1 <= end3;
              asc3 ? i < end3 : i > end3;
              asc3 ? i++ : i--
            ) {
              result.push(['-', this.descalarize(seq1[i], originals1)])
              score -= 5
            }
            for (
              j = j1, end4 = j2, asc4 = j1 <= end4;
              asc4 ? j < end4 : j > end4;
              asc4 ? j++ : j--
            ) {
              result.push(['+', this.descalarize(seq2[j], originals2)])
              score -= 5
            }
          } else {
            let asc5, end5
            for (
              i = i1, end5 = i2, asc5 = i1 <= end5;
              asc5 ? i < end5 : i > end5;
              asc5 ? i++ : i--
            ) {
              const change = this.diff(
                this.descalarize(seq1[i], originals1),
                this.descalarize(seq2[i - i1 + j1], originals2)
              )
              if (!change.equal) {
                result.push(['~', change.result])
                equal = false
              } else {
                result.push([' '])
              }
            }
          }
          break
      }
    }

    if (equal || opcodes.length === 0) {
      if (!this.options.full) {
        result = undefined
      } else {
        result = obj1
      }
      score = 100
    } else {
      score = Math.max(0, score)
    }

    return { score, result, equal }
  }

  diff (obj1, obj2) {
    const type1 = extendedTypeOf(obj1)
    const type2 = extendedTypeOf(obj2)

    if (type1 === type2) {
      switch (type1) {
        case 'object':
          return this.objectDiff(obj1, obj2)

        case 'array':
          return this.arrayDiff(obj1, obj2)
      }
    }

    // Compare primitives or complex objects of different types
    let score = 100
    let result = obj1
    let equal
    if (!this.options.keysOnly) {
      if (type1 === 'date' && type2 === 'date') {
        equal = obj1.getTime() === obj2.getTime()
      } else {
        equal = obj1 === obj2
      }
      if (!equal) {
        score = 0

        if (this.options.outputNewOnly) {
          result = obj2
        } else {
          result = { __old: obj1, __new: obj2 }
        }
      } else if (!this.options.full) {
        result = undefined
      }
    } else {
      equal = true
      result = undefined
    }

    // console.log(`diff: equal ${equal} obj1 ${obj1} obj2 ${obj2} score ${score} ${result || ''}`)

    return { score, result, equal }
  }
}

function diff (obj1, obj2, options = {}) {
  if (options.precision !== undefined) {
    obj1 = roundObj(obj1, options.precision)
    obj2 = roundObj(obj2, options.precision)
  }
  return new JsonDiff(options).diff(obj1, obj2).result
}

function diffString (obj1, obj2, options = {}) {
  return colorize(diff(obj1, obj2, options), options)
}

module.exports = { diff, diffString, colorize, colorizeToCallback }

},{"./colorize":502,"./util":504,"@ewoudenberg/difflib":309}],504:[function(require,module,exports){
const extendedTypeOf = function (obj) {
  const result = typeof obj
  if (obj == null) {
    return 'null'
  } else if (result === 'object' && obj.constructor === Array) {
    return 'array'
  } else if (result === 'object' && obj instanceof Date) {
    return 'date'
  } else {
    return result
  }
}

const roundObj = function (data, precision) {
  const type = typeof data
  if (type === 'array') {
    return data.map((x) => roundObj(x, precision))
  } else if (type === 'object') {
    for (const key in data) {
      data[key] = roundObj(data[key], precision)
    }
    return data
  } else if (
    type === 'number' &&
    Number.isFinite(data) &&
    !Number.isInteger(data)
  ) {
    return +data.toFixed(precision)
  } else {
    return data
  }
}

module.exports = { extendedTypeOf, roundObj }

},{}],505:[function(require,module,exports){
/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.9"
/*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function () {
    return this
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.empty

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(factory)
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();

},{}],506:[function(require,module,exports){
/**
 * marked v14.1.4 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

    /**
     * Gets the original marked default options.
     */
    function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null,
        };
    }
    exports.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports.defaults = newDefaults;
    }

    /**
     * Helpers
     */
    const escapeTest = /[&<>"']/;
    const escapeReplace = new RegExp(escapeTest.source, 'g');
    const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
    const escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    };
    const getEscapeReplacement = (ch) => escapeReplacements[ch];
    function escape$1(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) {
                return html.replace(escapeReplace, getEscapeReplacement);
            }
        }
        else {
            if (escapeTestNoEncode.test(html)) {
                return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
            }
        }
        return html;
    }
    const caret = /(^|[^\[])\^/g;
    function edit(regex, opt) {
        let source = typeof regex === 'string' ? regex : regex.source;
        opt = opt || '';
        const obj = {
            replace: (name, val) => {
                let valSource = typeof val === 'string' ? val : val.source;
                valSource = valSource.replace(caret, '$1');
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: () => {
                return new RegExp(source, opt);
            },
        };
        return obj;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(/%25/g, '%');
        }
        catch {
            return null;
        }
        return href;
    }
    const noopTest = { exec: () => null };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(/\|/g, (match, offset, str) => {
            let escaped = false;
            let curr = offset;
            while (--curr >= 0 && str[curr] === '\\')
                escaped = !escaped;
            if (escaped) {
                // odd number of slashes means | is escaped
                // so we leave it alone
                return '|';
            }
            else {
                // add space before unescaped |
                return ' |';
            }
        }), cells = row.split(/ \|/);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) {
            cells.shift();
        }
        if (cells.length > 0 && !cells[cells.length - 1].trim()) {
            cells.pop();
        }
        if (count) {
            if (cells.length > count) {
                cells.splice(count);
            }
            else {
                while (cells.length < count)
                    cells.push('');
            }
        }
        for (; i < cells.length; i++) {
            // leading or trailing whitespace is ignored per the gfm spec
            cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        }
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */
    function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) {
            return '';
        }
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while (suffLen < l) {
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) {
                suffLen++;
            }
            else if (currChar !== c && invert) {
                suffLen++;
            }
            else {
                break;
            }
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) {
            return -1;
        }
        let level = 0;
        for (let i = 0; i < str.length; i++) {
            if (str[i] === '\\') {
                i++;
            }
            else if (str[i] === b[0]) {
                level++;
            }
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) {
                    return i;
                }
            }
        }
        return -1;
    }

    function outputLink(cap, link, raw, lexer) {
        const href = link.href;
        const title = link.title ? escape$1(link.title) : null;
        const text = cap[1].replace(/\\([\[\]])/g, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            const token = {
                type: 'link',
                raw,
                href,
                title,
                text,
                tokens: lexer.inlineTokens(text),
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw,
            href,
            title,
            text: escape$1(text),
        };
    }
    function indentCodeCompensation(raw, text) {
        const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) {
            return text;
        }
        const indentToCode = matchIndentToCode[1];
        return text
            .split('\n')
            .map(node => {
            const matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) {
                return node;
            }
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) {
                return node.slice(indentToCode.length);
            }
            return node;
        })
            .join('\n');
    }
    /**
     * Tokenizer
     */
    class _Tokenizer {
        options;
        rules; // set by the lexer
        lexer; // set by the lexer
        constructor(options) {
            this.options = options || exports.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) {
                return {
                    type: 'space',
                    raw: cap[0],
                };
            }
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(/^(?: {1,4}| {0,3}\t)/gm, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic
                        ? rtrim(text, '\n')
                        : text,
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || '');
                return {
                    type: 'code',
                    raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                    text,
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    const trimmed = rtrim(text, '#');
                    if (this.options.pedantic) {
                        text = trimmed.trim();
                    }
                    else if (!trimmed || / $/.test(trimmed)) {
                        // CommonMark requires space before trailing #s
                        text = trimmed.trim();
                    }
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text,
                    tokens: this.lexer.inline(text),
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) {
                return {
                    type: 'hr',
                    raw: rtrim(cap[0], '\n'),
                };
            }
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], '\n').split('\n');
                let raw = '';
                let text = '';
                const tokens = [];
                while (lines.length > 0) {
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for (i = 0; i < lines.length; i++) {
                        // get lines up to a continuation
                        if (/^ {0,3}>/.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        }
                        else if (!inBlockquote) {
                            currentLines.push(lines[i]);
                        }
                        else {
                            break;
                        }
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join('\n');
                    const currentText = currentRaw
                        // precede setext continuation with 4 spaces so it isn't a setext
                        .replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, '\n    $1')
                        .replace(/^ {0,3}>[ \t]?/gm, '');
                    raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                    text = text ? `${text}\n${currentText}` : currentText;
                    // parse blockquote lines as top level tokens
                    // merge paragraphs if this is a continuation
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    // if there is no continuation then we are done
                    if (lines.length === 0) {
                        break;
                    }
                    const lastToken = tokens[tokens.length - 1];
                    if (lastToken?.type === 'code') {
                        // blockquote continuation cannot be preceded by a code block
                        break;
                    }
                    else if (lastToken?.type === 'blockquote') {
                        // include continuation in nested blockquote
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    }
                    else if (lastToken?.type === 'list') {
                        // include continuation in nested list
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens[tokens.length - 1].raw.length).split('\n');
                        continue;
                    }
                }
                return {
                    type: 'blockquote',
                    raw,
                    tokens,
                    text,
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: [],
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) {
                    bull = isordered ? bull : '[*+-]';
                }
                // Get next list item
                const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while (src) {
                    let endEarly = false;
                    let raw = '';
                    let itemContents = '';
                    if (!(cap = itemRegex.exec(src))) {
                        break;
                    }
                    if (this.rules.block.hr.test(src)) { // End list if bullet was actually HR (possibly move into itemRegex?)
                        break;
                    }
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split('\n', 1)[0].replace(/^\t+/, (t) => ' '.repeat(3 * t.length));
                    let nextLine = src.split('\n', 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    }
                    else if (blankLine) {
                        indent = cap[1].length + 1;
                    }
                    else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && /^[ \t]*$/.test(nextLine)) { // Items begin with at most one blank line
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                        const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                        const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                        const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                        const htmlBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, 'i');
                        // Check if following lines should be included in List Item
                        while (src) {
                            const rawLine = src.split('\n', 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                                nextLineWithoutTabs = nextLine;
                            }
                            else {
                                nextLineWithoutTabs = nextLine.replace(/\t/g, '    ');
                            }
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) {
                                break;
                            }
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) {
                                break;
                            }
                            // End list item if found start of html block
                            if (htmlBeginRegex.test(nextLine)) {
                                break;
                            }
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) {
                                break;
                            }
                            // Horizontal rule found
                            if (hrRegex.test(nextLine)) {
                                break;
                            }
                            if (nextLineWithoutTabs.search(/[^ ]/) >= indent || !nextLine.trim()) { // Dedent if possible
                                itemContents += '\n' + nextLineWithoutTabs.slice(indent);
                            }
                            else {
                                // not enough indentation
                                if (blankLine) {
                                    break;
                                }
                                // paragraph continuation unless last line was a different block level element
                                if (line.replace(/\t/g, '    ').search(/[^ ]/) >= 4) { // indented code block
                                    break;
                                }
                                if (fencesBeginRegex.test(line)) {
                                    break;
                                }
                                if (headingBeginRegex.test(line)) {
                                    break;
                                }
                                if (hrRegex.test(line)) {
                                    break;
                                }
                                itemContents += '\n' + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) { // Check if current line is blank
                                blankLine = true;
                            }
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) {
                            list.loose = true;
                        }
                        else if (/\n[ \t]*\n[ \t]*$/.test(raw)) {
                            endsWithBlankLine = true;
                        }
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: [],
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = list.items[list.items.length - 1].raw.trimEnd();
                list.items[list.items.length - 1].text = list.items[list.items.length - 1].text.trimEnd();
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for (let i = 0; i < list.items.length; i++) {
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter(t => t.type === 'space');
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some(t => /\n.*\n/.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) {
                    for (let i = 0; i < list.items.length; i++) {
                        list.items[i].loose = true;
                    }
                }
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: 'html',
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                    text: cap[0],
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
                const href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
                return {
                    type: 'def',
                    tag,
                    raw: cap[0],
                    href,
                    title,
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) {
                return;
            }
            if (!/[:|]/.test(cap[2])) {
                // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
                return;
            }
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(/^\||\| *$/g, '').split('|');
            const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : [];
            const item = {
                type: 'table',
                raw: cap[0],
                header: [],
                align: [],
                rows: [],
            };
            if (headers.length !== aligns.length) {
                // header and align columns must be equal, rows can be different.
                return;
            }
            for (const align of aligns) {
                if (/^ *-+: *$/.test(align)) {
                    item.align.push('right');
                }
                else if (/^ *:-+: *$/.test(align)) {
                    item.align.push('center');
                }
                else if (/^ *:-+ *$/.test(align)) {
                    item.align.push('left');
                }
                else {
                    item.align.push(null);
                }
            }
            for (let i = 0; i < headers.length; i++) {
                item.header.push({
                    text: headers[i],
                    tokens: this.lexer.inline(headers[i]),
                    header: true,
                    align: item.align[i],
                });
            }
            for (const row of rows) {
                item.rows.push(splitCells(row, item.header.length).map((cell, i) => {
                    return {
                        text: cell,
                        tokens: this.lexer.inline(cell),
                        header: false,
                        align: item.align[i],
                    };
                }));
            }
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) {
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[2].charAt(0) === '=' ? 1 : 2,
                    text: cap[1],
                    tokens: this.lexer.inline(cap[1]),
                };
            }
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === '\n'
                    ? cap[1].slice(0, -1)
                    : cap[1];
                return {
                    type: 'paragraph',
                    raw: cap[0],
                    text,
                    tokens: this.lexer.inline(text),
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) {
                return {
                    type: 'text',
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0]),
                };
            }
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) {
                return {
                    type: 'escape',
                    raw: cap[0],
                    text: escape$1(cap[1]),
                };
            }
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
                    this.lexer.state.inLink = true;
                }
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
                    this.lexer.state.inLink = false;
                }
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
                    this.lexer.state.inRawBlock = true;
                }
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
                    this.lexer.state.inRawBlock = false;
                }
                return {
                    type: 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0],
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!(/>$/.test(trimmedUrl))) {
                        return;
                    }
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
                        return;
                    }
                }
                else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                let href = cap[2];
                let title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                }
                else {
                    title = cap[3] ? cap[3].slice(1, -1) : '';
                }
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !(/>$/.test(trimmedUrl))) {
                        // pedantic allows starting angle bracket without ending angle bracket
                        href = href.slice(1);
                    }
                    else {
                        href = href.slice(1, -1);
                    }
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title,
                }, cap[0], this.lexer);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src))
                || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text,
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        }
        emStrong(src, maskedSrc, prevChar = '') {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match)
                return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/[\p{L}\p{N}]/u))
                return;
            const nextChar = match[1] || match[2] || '';
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [...match[0]].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while ((match = endReg.exec(maskedSrc)) != null) {
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim)
                        continue; // skip single * in __abc*abc__
                    rLength = [...rDelim].length;
                    if (match[3] || match[4]) { // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    }
                    else if (match[5] || match[6]) { // either Left or Right Delim
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0)
                        continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [...match[0]][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: 'em',
                            raw,
                            text,
                            tokens: this.lexer.inlineTokens(text),
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: 'strong',
                        raw,
                        text,
                        tokens: this.lexer.inlineTokens(text),
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(/\n/g, ' ');
                const hasNonSpaceChars = /[^ ]/.test(text);
                const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
                    text = text.substring(1, text.length - 1);
                }
                text = escape$1(text, true);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text,
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) {
                return {
                    type: 'br',
                    raw: cap[0],
                };
            }
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) {
                return {
                    type: 'del',
                    raw: cap[0],
                    text: cap[2],
                    tokens: this.lexer.inlineTokens(cap[2]),
                };
            }
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === '@') {
                    text = escape$1(cap[1]);
                    href = 'mailto:' + text;
                }
                else {
                    text = escape$1(cap[1]);
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text,
                    href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text,
                        },
                    ],
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === '@') {
                    text = escape$1(cap[0]);
                    href = 'mailto:' + text;
                }
                else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                    } while (prevCapZero !== cap[0]);
                    text = escape$1(cap[0]);
                    if (cap[1] === 'www.') {
                        href = 'http://' + cap[0];
                    }
                    else {
                        href = cap[0];
                    }
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text,
                    href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text,
                        },
                    ],
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                let text;
                if (this.lexer.state.inRawBlock) {
                    text = cap[0];
                }
                else {
                    text = escape$1(cap[0]);
                }
                return {
                    type: 'text',
                    raw: cap[0],
                    text,
                };
            }
        }
    }

    /**
     * Block-Level Grammar
     */
    const newline = /^(?:[ \t]*(?:\n|$))+/;
    const blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/)
        .replace(/bull/g, bullet) // lists can interrupt
        .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
        .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
        .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
        .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
        .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
        .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/)
        .replace('label', _blockLabel)
        .replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/)
        .getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/)
        .replace(/bull/g, bullet)
        .getRegex();
    const _tag = 'address|article|aside|base|basefont|blockquote|body|caption'
        + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
        + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
        + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
        + '|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title'
        + '|tr|track|ul';
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit('^ {0,3}(?:' // optional indentation
        + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
        + '|comment[^\\n]*(\\n+|$)' // (2)
        + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
        + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
        + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
        + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ \t]*)+\\n|$)' // (6)
        + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ \t]*)+\\n|$)' // (7) open tag
        + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ \t]*)+\\n|$)' // (7) closing tag
        + ')', 'i')
        .replace('comment', _comment)
        .replace('tag', _tag)
        .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
        .getRegex();
    const paragraph = edit(_paragraph)
        .replace('hr', hr)
        .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
        .replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
        .replace('|table', '')
        .replace('blockquote', ' {0,3}>')
        .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
        .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
        .replace('tag', _tag) // pars can be interrupted by type (6) html blocks
        .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/)
        .replace('paragraph', paragraph)
        .getRegex();
    /**
     * Normal Block Grammar
     */
    const blockNormal = {
        blockquote,
        code: blockCode,
        def,
        fences,
        heading,
        hr,
        html,
        lheading,
        list,
        newline,
        paragraph,
        table: noopTest,
        text: blockText,
    };
    /**
     * GFM Block Grammar
     */
    const gfmTable = edit('^ *([^\\n ].*)\\n' // Header
        + ' {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)' // Align
        + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)') // Cells
        .replace('hr', hr)
        .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
        .replace('blockquote', ' {0,3}>')
        .replace('code', '(?: {4}| {0,3}\t)[^\\n]')
        .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
        .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
        .replace('tag', _tag) // tables can be interrupted by type (6) html blocks
        .getRegex();
    const blockGfm = {
        ...blockNormal,
        table: gfmTable,
        paragraph: edit(_paragraph)
            .replace('hr', hr)
            .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
            .replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
            .replace('table', gfmTable) // interrupt paragraphs with table
            .replace('blockquote', ' {0,3}>')
            .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
            .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
            .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
            .replace('tag', _tag) // pars can be interrupted by type (6) html blocks
            .getRegex(),
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */
    const blockPedantic = {
        ...blockNormal,
        html: edit('^ *(?:comment *(?:\\n|\\s*$)'
            + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
            + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
            .replace('comment', _comment)
            .replace(/tag/g, '(?!(?:'
            + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
            + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
            + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
            .getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest, // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph)
            .replace('hr', hr)
            .replace('heading', ' *#{1,6} *[^\n]')
            .replace('lheading', lheading)
            .replace('|table', '')
            .replace('blockquote', ' {0,3}>')
            .replace('|fences', '')
            .replace('|list', '')
            .replace('|html', '')
            .replace('|tag', '')
            .getRegex(),
    };
    /**
     * Inline-Level Grammar
     */
    const escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = '\\p{P}\\p{S}';
    const punctuation = edit(/^((?![*_])[\spunctuation])/, 'u')
        .replace(/punctuation/g, _punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, 'u')
        .replace(/punct/g, _punctuation)
        .getRegex();
    const emStrongRDelimAst = edit('^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)' // Skip orphan inside strong
        + '|[^*]+(?=[^*])' // Consume to delim
        + '|(?!\\*)[punct](\\*+)(?=[\\s]|$)' // (1) #*** can only be a Right Delimiter
        + '|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)' // (2) a***#, a*** can only be a Right Delimiter
        + '|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])' // (3) #***a, ***a can only be Left Delimiter
        + '|[\\s](\\*+)(?!\\*)(?=[punct])' // (4) ***# can only be Left Delimiter
        + '|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])' // (5) #***# can be either Left or Right Delimiter
        + '|[^punct\\s](\\*+)(?=[^punct\\s])', 'gu') // (6) a***a can be either Left or Right Delimiter
        .replace(/punct/g, _punctuation)
        .getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit('^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)' // Skip orphan inside strong
        + '|[^_]+(?=[^_])' // Consume to delim
        + '|(?!_)[punct](_+)(?=[\\s]|$)' // (1) #___ can only be a Right Delimiter
        + '|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)' // (2) a___#, a___ can only be a Right Delimiter
        + '|(?!_)[punct\\s](_+)(?=[^punct\\s])' // (3) #___a, ___a can only be Left Delimiter
        + '|[\\s](_+)(?!_)(?=[punct])' // (4) ___# can only be Left Delimiter
        + '|(?!_)[punct](_+)(?!_)(?=[punct])', 'gu') // (5) #___# can be either Left or Right Delimiter
        .replace(/punct/g, _punctuation)
        .getRegex();
    const anyPunctuation = edit(/\\([punct])/, 'gu')
        .replace(/punct/g, _punctuation)
        .getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/)
        .replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/)
        .replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/)
        .getRegex();
    const _inlineComment = edit(_comment).replace('(?:-->|$)', '-->').getRegex();
    const tag = edit('^comment'
        + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
        + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
        + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
        + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
        + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>') // CDATA section
        .replace('comment', _inlineComment)
        .replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/)
        .getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/)
        .replace('label', _inlineLabel)
        .replace('href', /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/)
        .replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/)
        .getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/)
        .replace('label', _inlineLabel)
        .replace('ref', _blockLabel)
        .getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/)
        .replace('ref', _blockLabel)
        .getRegex();
    const reflinkSearch = edit('reflink|nolink(?!\\()', 'g')
        .replace('reflink', reflink)
        .replace('nolink', nolink)
        .getRegex();
    /**
     * Normal Inline Grammar
     */
    const inlineNormal = {
        _backpedal: noopTest, // only used for GFM url
        anyPunctuation,
        autolink,
        blockSkip,
        br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim,
        emStrongRDelimAst,
        emStrongRDelimUnd,
        escape,
        link,
        nolink,
        punctuation,
        reflink,
        reflinkSearch,
        tag,
        text: inlineText,
        url: noopTest,
    };
    /**
     * Pedantic Inline Grammar
     */
    const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/)
            .replace('label', _inlineLabel)
            .getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
            .replace('label', _inlineLabel)
            .getRegex(),
    };
    /**
     * GFM Inline Grammar
     */
    const inlineGfm = {
        ...inlineNormal,
        escape: edit(escape).replace('])', '~|])').getRegex(),
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i')
            .replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/)
            .getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/,
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */
    const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace('{2,}', '*').getRegex(),
        text: edit(inlineGfm.text)
            .replace('\\b_', '\\b_| {2,}\\n')
            .replace(/\{2,\}/g, '*')
            .getRegex(),
    };
    /**
     * exports
     */
    const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic,
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic,
    };

    /**
     * Block Lexer
     */
    class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options) {
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true,
            };
            const rules = {
                block: block.normal,
                inline: inline.normal,
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            }
            else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) {
                    rules.inline = inline.breaks;
                }
                else {
                    rules.inline = inline.gfm;
                }
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */
        static get rules() {
            return {
                block,
                inline,
            };
        }
        /**
         * Static Lex Method
         */
        static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */
        static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */
        lex(src) {
            src = src
                .replace(/\r\n|\r/g, '\n');
            this.blockTokens(src, this.tokens);
            for (let i = 0; i < this.inlineQueue.length; i++) {
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) {
                src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
            }
            let token;
            let lastToken;
            let cutSrc;
            while (src) {
                if (this.options.extensions
                    && this.options.extensions.block
                    && this.options.extensions.block.some((extTokenizer) => {
                        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) {
                    continue;
                }
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) {
                        // if there's a single \n as a spacer, it's terminating the last line,
                        // so move it there so that we don't get unnecessary paragraph tags
                        tokens[tokens.length - 1].raw += '\n';
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else if (!this.tokens.links[token.tag]) {
                        this.tokens.links[token.tag] = {
                            href: token.href,
                            title: token.title,
                        };
                    }
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex) => {
                        tempStart = getStartIndex.call({ lexer: this }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) {
                            startIndex = Math.min(startIndex, tempStart);
                        }
                    });
                    if (startIndex < Infinity && startIndex >= 0) {
                        cutSrc = src.substring(0, startIndex + 1);
                    }
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken?.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    lastParagraphClipped = (cutSrc.length !== src.length);
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    }
                    else {
                        throw new Error(errMsg);
                    }
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({ src, tokens });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */
        inlineTokens(src, tokens = []) {
            let token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match;
            let keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
                        if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
                            maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                        }
                    }
                }
            }
            // Mask out other blocks
            while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
                maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            }
            // Mask out escaped characters
            while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
                maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            }
            while (src) {
                if (!keepPrevChar) {
                    prevChar = '';
                }
                keepPrevChar = false;
                // extensions
                if (this.options.extensions
                    && this.options.extensions.inline
                    && this.options.extensions.inline.some((extTokenizer) => {
                        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) {
                    continue;
                }
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex) => {
                        tempStart = getStartIndex.call({ lexer: this }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) {
                            startIndex = Math.min(startIndex, tempStart);
                        }
                    });
                    if (startIndex < Infinity && startIndex >= 0) {
                        cutSrc = src.substring(0, startIndex + 1);
                    }
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') { // Track prevChar before string of ____ started
                        prevChar = token.raw.slice(-1);
                    }
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    }
                    else {
                        tokens.push(token);
                    }
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    }
                    else {
                        throw new Error(errMsg);
                    }
                }
            }
            return tokens;
        }
    }

    /**
     * Renderer
     */
    class _Renderer {
        options;
        parser; // set by the parser
        constructor(options) {
            this.options = options || exports.defaults;
        }
        space(token) {
            return '';
        }
        code({ text, lang, escaped }) {
            const langString = (lang || '').match(/^\S*/)?.[0];
            const code = text.replace(/\n$/, '') + '\n';
            if (!langString) {
                return '<pre><code>'
                    + (escaped ? code : escape$1(code, true))
                    + '</code></pre>\n';
            }
            return '<pre><code class="language-'
                + escape$1(langString)
                + '">'
                + (escaped ? code : escape$1(code, true))
                + '</code></pre>\n';
        }
        blockquote({ tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>\n${body}</blockquote>\n`;
        }
        html({ text }) {
            return text;
        }
        heading({ tokens, depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
        }
        hr(token) {
            return '<hr>\n';
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = '';
            for (let j = 0; j < token.items.length; j++) {
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? 'ol' : 'ul';
            const startAttr = (ordered && start !== 1) ? (' start="' + start + '"') : '';
            return '<' + type + startAttr + '>\n' + body + '</' + type + '>\n';
        }
        listitem(item) {
            let itemBody = '';
            if (item.task) {
                const checkbox = this.checkbox({ checked: !!item.checked });
                if (item.loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                            item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                        }
                    }
                    else {
                        item.tokens.unshift({
                            type: 'text',
                            raw: checkbox + ' ',
                            text: checkbox + ' ',
                        });
                    }
                }
                else {
                    itemBody += checkbox + ' ';
                }
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>\n`;
        }
        checkbox({ checked }) {
            return '<input '
                + (checked ? 'checked="" ' : '')
                + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>\n`;
        }
        table(token) {
            let header = '';
            // header
            let cell = '';
            for (let j = 0; j < token.header.length; j++) {
                cell += this.tablecell(token.header[j]);
            }
            header += this.tablerow({ text: cell });
            let body = '';
            for (let j = 0; j < token.rows.length; j++) {
                const row = token.rows[j];
                cell = '';
                for (let k = 0; k < row.length; k++) {
                    cell += this.tablecell(row[k]);
                }
                body += this.tablerow({ text: cell });
            }
            if (body)
                body = `<tbody>${body}</tbody>`;
            return '<table>\n'
                + '<thead>\n'
                + header
                + '</thead>\n'
                + body
                + '</table>\n';
        }
        tablerow({ text }) {
            return `<tr>\n${text}</tr>\n`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? 'th' : 'td';
            const tag = token.align
                ? `<${type} align="${token.align}">`
                : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */
        strong({ tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text }) {
            return `<code>${text}</code>`;
        }
        br(token) {
            return '<br>';
        }
        del({ tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href, title, tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) {
                return text;
            }
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) {
                out += ' title="' + title + '"';
            }
            out += '>' + text + '</a>';
            return out;
        }
        image({ href, title, text }) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) {
                return text;
            }
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) {
                out += ` title="${title}"`;
            }
            out += '>';
            return out;
        }
        text(token) {
            return 'tokens' in token && token.tokens ? this.parser.parseInline(token.tokens) : token.text;
        }
    }

    /**
     * TextRenderer
     * returns only the textual part of the token
     */
    class _TextRenderer {
        // no need for block level renderers
        strong({ text }) {
            return text;
        }
        em({ text }) {
            return text;
        }
        codespan({ text }) {
            return text;
        }
        del({ text }) {
            return text;
        }
        html({ text }) {
            return text;
        }
        text({ text }) {
            return text;
        }
        link({ text }) {
            return '' + text;
        }
        image({ text }) {
            return '' + text;
        }
        br() {
            return '';
        }
    }

    /**
     * Parsing & Compiling
     */
    class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options) {
            this.options = options || exports.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */
        static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */
        static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */
        parse(tokens, top = true) {
            let out = '';
            for (let i = 0; i < tokens.length; i++) {
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({ parser: this }, genericToken);
                    if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(genericToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch (token.type) {
                    case 'space': {
                        out += this.renderer.space(token);
                        continue;
                    }
                    case 'hr': {
                        out += this.renderer.hr(token);
                        continue;
                    }
                    case 'heading': {
                        out += this.renderer.heading(token);
                        continue;
                    }
                    case 'code': {
                        out += this.renderer.code(token);
                        continue;
                    }
                    case 'table': {
                        out += this.renderer.table(token);
                        continue;
                    }
                    case 'blockquote': {
                        out += this.renderer.blockquote(token);
                        continue;
                    }
                    case 'list': {
                        out += this.renderer.list(token);
                        continue;
                    }
                    case 'html': {
                        out += this.renderer.html(token);
                        continue;
                    }
                    case 'paragraph': {
                        out += this.renderer.paragraph(token);
                        continue;
                    }
                    case 'text': {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while (i + 1 < tokens.length && tokens[i + 1].type === 'text') {
                            textToken = tokens[++i];
                            body += '\n' + this.renderer.text(textToken);
                        }
                        if (top) {
                            out += this.renderer.paragraph({
                                type: 'paragraph',
                                raw: body,
                                text: body,
                                tokens: [{ type: 'text', raw: body, text: body }],
                            });
                        }
                        else {
                            out += body;
                        }
                        continue;
                    }
                    default: {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        }
                        else {
                            throw new Error(errMsg);
                        }
                    }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */
        parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            let out = '';
            for (let i = 0; i < tokens.length; i++) {
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({ parser: this }, anyToken);
                    if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(anyToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch (token.type) {
                    case 'escape': {
                        out += renderer.text(token);
                        break;
                    }
                    case 'html': {
                        out += renderer.html(token);
                        break;
                    }
                    case 'link': {
                        out += renderer.link(token);
                        break;
                    }
                    case 'image': {
                        out += renderer.image(token);
                        break;
                    }
                    case 'strong': {
                        out += renderer.strong(token);
                        break;
                    }
                    case 'em': {
                        out += renderer.em(token);
                        break;
                    }
                    case 'codespan': {
                        out += renderer.codespan(token);
                        break;
                    }
                    case 'br': {
                        out += renderer.br(token);
                        break;
                    }
                    case 'del': {
                        out += renderer.del(token);
                        break;
                    }
                    case 'text': {
                        out += renderer.text(token);
                        break;
                    }
                    default: {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        }
                        else {
                            throw new Error(errMsg);
                        }
                    }
                }
            }
            return out;
        }
    }

    class _Hooks {
        options;
        block;
        constructor(options) {
            this.options = options || exports.defaults;
        }
        static passThroughHooks = new Set([
            'preprocess',
            'postprocess',
            'processAllTokens',
        ]);
        /**
         * Process markdown before marked
         */
        preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */
        postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */
        processAllTokens(tokens) {
            return tokens;
        }
        /**
         * Provide function to tokenize markdown
         */
        provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
         * Provide function to parse tokens
         */
        provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    }

    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args) {
            this.use(...args);
        }
        /**
         * Run callback for every token
         */
        walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens) {
                values = values.concat(callback.call(this, token));
                switch (token.type) {
                    case 'table': {
                        const tableToken = token;
                        for (const cell of tableToken.header) {
                            values = values.concat(this.walkTokens(cell.tokens, callback));
                        }
                        for (const row of tableToken.rows) {
                            for (const cell of row) {
                                values = values.concat(this.walkTokens(cell.tokens, callback));
                            }
                        }
                        break;
                    }
                    case 'list': {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                    default: {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) {
                            this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens) => {
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                        }
                        else if (genericToken.tokens) {
                            values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                    }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || { renderers: {}, childTokens: {} };
            args.forEach((pack) => {
                // copy options to new object
                const opts = { ...pack };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext) => {
                        if (!ext.name) {
                            throw new Error('extension name required');
                        }
                        if ('renderer' in ext) { // Renderer extensions
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) {
                                // Replace extension with func to run new extension but fall back if false
                                extensions.renderers[ext.name] = function (...args) {
                                    let ret = ext.renderer.apply(this, args);
                                    if (ret === false) {
                                        ret = prevRenderer.apply(this, args);
                                    }
                                    return ret;
                                };
                            }
                            else {
                                extensions.renderers[ext.name] = ext.renderer;
                            }
                        }
                        if ('tokenizer' in ext) { // Tokenizer Extensions
                            if (!ext.level || (ext.level !== 'block' && ext.level !== 'inline')) {
                                throw new Error("extension level must be 'block' or 'inline'");
                            }
                            const extLevel = extensions[ext.level];
                            if (extLevel) {
                                extLevel.unshift(ext.tokenizer);
                            }
                            else {
                                extensions[ext.level] = [ext.tokenizer];
                            }
                            if (ext.start) { // Function to check for start of token
                                if (ext.level === 'block') {
                                    if (extensions.startBlock) {
                                        extensions.startBlock.push(ext.start);
                                    }
                                    else {
                                        extensions.startBlock = [ext.start];
                                    }
                                }
                                else if (ext.level === 'inline') {
                                    if (extensions.startInline) {
                                        extensions.startInline.push(ext.start);
                                    }
                                    else {
                                        extensions.startInline = [ext.start];
                                    }
                                }
                            }
                        }
                        if ('childTokens' in ext && ext.childTokens) { // Child tokens to be visited by walkTokens
                            extensions.childTokens[ext.name] = ext.childTokens;
                        }
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for (const prop in pack.renderer) {
                        if (!(prop in renderer)) {
                            throw new Error(`renderer '${prop}' does not exist`);
                        }
                        if (['options', 'parser'].includes(prop)) {
                            // ignore options property
                            continue;
                        }
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args) => {
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) {
                                ret = prevRenderer.apply(renderer, args);
                            }
                            return ret || '';
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for (const prop in pack.tokenizer) {
                        if (!(prop in tokenizer)) {
                            throw new Error(`tokenizer '${prop}' does not exist`);
                        }
                        if (['options', 'rules', 'lexer'].includes(prop)) {
                            // ignore options, rules, and lexer properties
                            continue;
                        }
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args) => {
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) {
                                ret = prevTokenizer.apply(tokenizer, args);
                            }
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for (const prop in pack.hooks) {
                        if (!(prop in hooks)) {
                            throw new Error(`hook '${prop}' does not exist`);
                        }
                        if (['options', 'block'].includes(prop)) {
                            // ignore options and block properties
                            continue;
                        }
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) {
                            // @ts-expect-error cannot type hook function dynamically
                            hooks[hooksProp] = (arg) => {
                                if (this.defaults.async) {
                                    return Promise.resolve(hooksFunc.call(hooks, arg)).then(ret => {
                                        return prevHook.call(hooks, ret);
                                    });
                                }
                                const ret = hooksFunc.call(hooks, arg);
                                return prevHook.call(hooks, ret);
                            };
                        }
                        else {
                            // @ts-expect-error cannot type hook function dynamically
                            hooks[hooksProp] = (...args) => {
                                let ret = hooksFunc.apply(hooks, args);
                                if (ret === false) {
                                    ret = prevHook.apply(hooks, args);
                                }
                                return ret;
                            };
                        }
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function (token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) {
                            values = values.concat(walkTokens.call(this, token));
                        }
                        return values;
                    };
                }
                this.defaults = { ...this.defaults, ...opts };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = { ...this.defaults, ...opt };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        parseMarkdown(blockType) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parse = (src, options) => {
                const origOpt = { ...options };
                const opt = { ...this.defaults, ...origOpt };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                // throw error if an extension set async to true but parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) {
                    return throwError(new Error('marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.'));
                }
                // throw error in case of non string input
                if (typeof src === 'undefined' || src === null) {
                    return throwError(new Error('marked(): input parameter is undefined or null'));
                }
                if (typeof src !== 'string') {
                    return throwError(new Error('marked(): input parameter is of type '
                        + Object.prototype.toString.call(src) + ', string expected'));
                }
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer = opt.hooks ? opt.hooks.provideLexer() : (blockType ? _Lexer.lex : _Lexer.lexInline);
                const parser = opt.hooks ? opt.hooks.provideParser() : (blockType ? _Parser.parse : _Parser.parseInline);
                if (opt.async) {
                    return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src)
                        .then(src => lexer(src, opt))
                        .then(tokens => opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens)
                        .then(tokens => opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens)
                        .then(tokens => parser(tokens, opt))
                        .then(html => opt.hooks ? opt.hooks.postprocess(html) : html)
                        .catch(throwError);
                }
                try {
                    if (opt.hooks) {
                        src = opt.hooks.preprocess(src);
                    }
                    let tokens = lexer(src, opt);
                    if (opt.hooks) {
                        tokens = opt.hooks.processAllTokens(tokens);
                    }
                    if (opt.walkTokens) {
                        this.walkTokens(tokens, opt.walkTokens);
                    }
                    let html = parser(tokens, opt);
                    if (opt.hooks) {
                        html = opt.hooks.postprocess(html);
                    }
                    return html;
                }
                catch (e) {
                    return throwError(e);
                }
            };
            return parse;
        }
        onError(silent, async) {
            return (e) => {
                e.message += '\nPlease report this to https://github.com/markedjs/marked.';
                if (silent) {
                    const msg = '<p>An error occurred:</p><pre>'
                        + escape$1(e.message + '', true)
                        + '</pre>';
                    if (async) {
                        return Promise.resolve(msg);
                    }
                    return msg;
                }
                if (async) {
                    return Promise.reject(e);
                }
                throw e;
            };
        }
    }

    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */
    marked.options =
        marked.setOptions = function (options) {
            markedInstance.setOptions(options);
            marked.defaults = markedInstance.defaults;
            changeDefaults(marked.defaults);
            return marked;
        };
    /**
     * Gets the original marked default options.
     */
    marked.getDefaults = _getDefaults;
    marked.defaults = exports.defaults;
    /**
     * Use Extension
     */
    marked.use = function (...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */
    marked.walkTokens = function (tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */
    marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */
    marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;

    exports.Hooks = _Hooks;
    exports.Lexer = _Lexer;
    exports.Marked = Marked;
    exports.Parser = _Parser;
    exports.Renderer = _Renderer;
    exports.TextRenderer = _TextRenderer;
    exports.Tokenizer = _Tokenizer;
    exports.getDefaults = _getDefaults;
    exports.lexer = lexer;
    exports.marked = marked;
    exports.options = options;
    exports.parse = parse;
    exports.parseInline = parseInline;
    exports.parser = parser;
    exports.setOptions = setOptions;
    exports.use = use;
    exports.walkTokens = walkTokens;

}));


},{}],507:[function(require,module,exports){
'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;

},{}],508:[function(require,module,exports){
'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;

},{}],509:[function(require,module,exports){
'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

},{}],510:[function(require,module,exports){
'use strict';

/** @type {import('./max')} */
module.exports = Math.max;

},{}],511:[function(require,module,exports){
'use strict';

/** @type {import('./min')} */
module.exports = Math.min;

},{}],512:[function(require,module,exports){
'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;

},{}],513:[function(require,module,exports){
'use strict';

/** @type {import('./round')} */
module.exports = Math.round;

},{}],514:[function(require,module,exports){
'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};

},{"./isNaN":509}],515:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var HashBase = require('hash-base')
var Buffer = require('safe-buffer').Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

},{"hash-base":453,"inherits":495,"safe-buffer":788}],516:[function(require,module,exports){
// Meadow-Integration-Engine — the browser-safe, dependency-light entry point for the comprehension
// transform / push ENGINE classes, decoupled from the full meadow-integration package.
//
// The package `main` (Meadow-Integration.js) and the `browser` entry pull in orator, the meadow ORM,
// the DB connection drivers, xlsx, etc. — none of which the engine itself needs. These three services
// depend ONLY on fable-serviceproviderbase (and each other), so an in-browser consumer — e.g.
// pict-section-dataimport — can `require('meadow-integration/source/Meadow-Integration-Engine.js')`
// to get the engine WITHOUT dragging any server-only code into its bundle.
//
// This file is the stable public contract for in-browser engine consumers: if the internal layout
// under source/ ever changes, update the requires HERE and consumers keep importing this one path.
//
//   const { MeadowIntegrationTabularTransform, MeadowIntegrationAdapter, MeadowGUIDMap, getAdapter }
//       = require('meadow-integration/source/Meadow-Integration-Engine.js');
//
// - MeadowIntegrationTabularTransform : maps tabular rows -> a Comprehension (transformRecord per row;
//   runs Solvers + MultipleGUIDUniqueness fan-out).
// - MeadowIntegrationAdapter          : GUID marshaling, FK resolution, bulk upsert (setRestClient,
//   addSourceRecord, integrateRecords). Use getAdapter(fable, entity, prefix, options) for the
//   per-entity singleton.
// - MeadowGUIDMap                     : the in-session external-GUID <-> Meadow-ID map.

const MeadowIntegrationTabularTransform = require('./services/tabular/Service-TabularTransform.js');
const MeadowIntegrationAdapter = require('./Meadow-Service-Integration-Adapter.js');
const MeadowGUIDMap = require('./Meadow-Service-Integration-GUIDMap.js');

// Opt-in context-aware GUID layer (pure, dependency-light): compose deterministic, length-safe GUIDs that
// embed parent context (e.g. `UI_C10_P01278_LI8675309`) + a compiler that turns a per-entity strategy
// config into the structured spec the TabularTransform stamps. Reusable by the CLI, the server endpoints,
// and the browser import wizard alike.
const MeadowIntegrationGUIDComposer = require('./services/guid/Meadow-Integration-GUIDComposer.js');
const MeadowIntegrationGUIDStrategy = require('./services/guid/Meadow-Integration-GUIDStrategy.js');

module.exports =
{
	MeadowIntegrationTabularTransform,
	MeadowIntegrationAdapter,
	MeadowGUIDMap,
	// The per-entity adapter factory (caches on fable.servicesMap.IntegrationAdapter[Entity]).
	getAdapter: MeadowIntegrationAdapter.getAdapter,

	// Context-aware GUID composition + strategy compilation.
	MeadowIntegrationGUIDComposer,
	MeadowIntegrationGUIDStrategy,
	composeGUID: MeadowIntegrationGUIDComposer.composeGUID,
	compileGUIDStrategy: MeadowIntegrationGUIDStrategy.compile,
};

},{"./Meadow-Service-Integration-Adapter.js":517,"./Meadow-Service-Integration-GUIDMap.js":518,"./services/guid/Meadow-Integration-GUIDComposer.js":519,"./services/guid/Meadow-Integration-GUIDStrategy.js":520,"./services/tabular/Service-TabularTransform.js":521}],517:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libGUIDMap = require('./Meadow-Service-Integration-GUIDMap.js');
const libGUIDComposer = require('./services/guid/Meadow-Integration-GUIDComposer.js');

const defaultMeadowIntegrationAdapterOptions = (
	{
		"Entity": "DefaultEntity",

		"AdapterSetGUIDMarshalPrefix": false,

		"EntityGUIDMarshalPrefix": false,

		// Maximum allowed length for generated GUIDs.
		// When 0, the adapter falls back to DefaultGUIDColumnSize.
		// When a positive integer, this explicit value overrides everything.
		"GUIDMaxLength": 0,

		// Schema-driven per-entity GUID column sizes.
		// Keys are entity names, values are max GUID column sizes.
		// Pass the full map in options or let it default to empty.
		"GUIDColumnSizes": {},

		// Default GUID column size when not available in GUIDColumnSizes.
		"DefaultGUIDColumnSize": 36,

		// When false (default), the adapter will throw an error if a generated GUID
		// exceeds the maximum allowed length.
		// When true, the prefix is truncated to fit while preserving the full external GUID.
		"AllowGUIDTruncation": false,

		// How to shrink an over-length marshaled GUID when AllowGUIDTruncation is on:
		//   "substring" (default) — truncate the prefix, keep the external GUID whole (current behavior).
		//   "hash"                — keep the prefix, deterministically hash the external GUID to fit (stable).
		"GUIDTruncationStrategy": "substring",

		// When true, only marshal fields that are present in the schema (no passthrough of unknown fields).
		"SimpleMarshal": false,

		// When true, pass through all fields regardless of schema presence.
		"ForceMarshal": false,

		"PerformUpserts": true,
		"PerformDeletes": true,

		"RecordPushRetryThreshold": 5,

		"RecordThresholdForBulkUpsert": 1000,
		"BulkUpsertBatchSize": 100,

		// How often (in records) to log per-entity progress (0 = disabled).
		"ProgressLogInterval": 100,

		"ApiURLPrefix": '/1.0/'
	});

/**
 * Is a source record's `Deleted` flag set, in whatever shape the source produced it?
 *
 * Storage layers disagree about how a boolean is represented and every one of them is legitimate:
 * MySQL's `tinyint` arrives as `1`/`0` through mysql2, PostgreSQL gives a real `true`/`false`, and
 * anything that has been through JSON, a CSV, a spreadsheet or a template arrives as the string
 * `"1"`. A strict `=== true` honoured only the second of those and silently treated the rest as a
 * live record — an upsert instead of a delete, reported as success.
 *
 * Only the SET side is widened. `0`, `"0"`, `""`, `false`, `"false"`, `null`, `undefined` and an
 * absent property all remain not-deleted, so a record can never become a delete by accident.
 *
 * @param {any} pValue - the source record's `Deleted` value, in any representation
 * @return {boolean} true when the record should be routed to the delete pass
 */
const isDeletedFlagSet = function(pValue)
{
	if (typeof (pValue) === 'boolean')
	{
		return pValue;
	}
	if (typeof (pValue) === 'number')
	{
		return (pValue !== 0);
	}
	if (typeof (pValue) === 'string')
	{
		const tmpValue = pValue.trim().toLowerCase();
		return (tmpValue === '1') || (tmpValue === 'true') || (tmpValue === 't') || (tmpValue === 'y') || (tmpValue === 'yes');
	}
	return false;
};

class MeadowIntegrationAdapter extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultMeadowIntegrationAdapterOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'IntegrationAdapter';

		// Check if there is a GUIDMap .. if not make one
		if (!this.fable.MeadowGUIDMap)
		{
			this.fable.addAndInstantiateServiceType('MeadowGUIDMap', libGUIDMap);
		}

		// REST client: prefer explicit injection, then MeadowCloneRestClient, then
		// fall back to creating a bare RestClient as the original code did.
		this.client = this.options.Client || null;

		this.fable.instantiateServiceProviderIfNotExists('ProgressTrackerSet');

		this.Entity = this.options.Entity;
		this.EntityGUIDName = `GUID${this.Entity}`;
		this.EntityIDName = `ID${this.Entity}`;

		// Automagic GUID Components
		this.AdapterSetGUIDMarshalPrefix = this.options.AdapterSetGUIDMarshalPrefix;
		if (typeof this.AdapterSetGUIDMarshalPrefix !== 'string')
		{
			if (typeof this.fable.settings.AdapterSetGUIDMarshalPrefix === 'string')
			{
				this.AdapterSetGUIDMarshalPrefix = this.fable.settings.AdapterSetGUIDMarshalPrefix;
			}
			else
			{
				this.AdapterSetGUIDMarshalPrefix = 'INTG-DEF';
			}
		}
		this.EntityGUIDMarshalPrefix = this.options.EntityGUIDMarshalPrefix;
		if (typeof this.EntityGUIDMarshalPrefix !== 'string')
		{
			this.EntityGUIDMarshalPrefix = `E-${this.Entity}`;
		}

		// Resolve GUID max length: explicit option > GUIDColumnSizes > live server schema > DefaultGUIDColumnSize.
		// GUIDMaxLengthResolved tracks whether the width came from a real source; loadSchema() fills it in
		// from the server when it did not, and the length-check error names the source either way.
		if (this.options.GUIDMaxLength > 0)
		{
			this.GUIDMaxLength = this.options.GUIDMaxLength;
			this.GUIDMaxLengthSource = 'the GUIDMaxLength option';
			this.GUIDMaxLengthResolved = true;
		}
		else if (this.options.GUIDColumnSizes && this.options.GUIDColumnSizes.hasOwnProperty(this.Entity))
		{
			this.GUIDMaxLength = this.options.GUIDColumnSizes[this.Entity];
			this.GUIDMaxLengthSource = 'the GUIDColumnSizes option';
			this.GUIDMaxLengthResolved = true;
		}
		else
		{
			this.GUIDMaxLength = this.options.DefaultGUIDColumnSize;
			this.GUIDMaxLengthSource = 'the DefaultGUIDColumnSize fallback';
			this.GUIDMaxLengthResolved = false;
		}
		this.AllowGUIDTruncation = this.options.AllowGUIDTruncation;
		this.GUIDTruncationStrategy = this.options.GUIDTruncationStrategy || 'substring';

		// Integration Adapter Controls
		this._PerformUpserts = this.options.PerformUpserts;
		this._PerformDeletes = this.options.PerformDeletes;

		this._RecordPushRetryThreshold = this.options.RecordPushRetryThreshold;

		// Meta progress tracker — an optional external progress tracker hash that is
		// incremented alongside the per-entity tracker so callers can monitor overall
		// progress across multiple adapters/entities.
		this.MetaProgressTrackerHash = false;
		// How often (in records) to log the meta progress tracker status (0 = never auto-log).
		this.MetaProgressTrackerLogInterval = 0;

		// The source records (coming from the external system)
		this._SourceRecords = {};

		// The marshaled records (meant to be upserted to the storage or Queued for Delete)
		this._MarshaledRecords = {};
		this._DeletedRecords = {};
	}

	/**
	 * Set the REST client for this adapter.
	 * The client should expose: upsertEntity, upsertEntities, getEntityByGUID,
	 * getEntity, deleteEntity, getJSON, and have a serverURL + restClient property.
	 *
	 * @param {object} pClient - The REST client instance (e.g. MeadowCloneRestClient)
	 */
	setRestClient(pClient)
	{
		this.client = pClient;
	}

	/**
	 * Resolve the REST client to use.  Checks (in order):
	 * 1. Explicitly set client via setRestClient / options.Client
	 * 2. MeadowCloneRestClient on fable
	 * 3. EntityProvider on fable (legacy)
	 *
	 * @returns {object} A REST client instance
	 */
	_resolveClient()
	{
		if (this.client)
		{
			return this.client;
		}
		if (this.fable.MeadowCloneRestClient)
		{
			return this.fable.MeadowCloneRestClient;
		}
		if (this.fable.EntityProvider)
		{
			return this.fable.EntityProvider;
		}
		this.log.error(`No REST client available for Integration Adapter [${this.Entity}].  Call setRestClient() or ensure MeadowCloneRestClient is registered.`);
		return null;
	}

	/**
	 * Read this entity's GUID column width out of an entity schema document.
	 *
	 * meadow-endpoints answers GET /{Entity}/Schema with the DAL JSONSchema, which carries widths on
	 * `properties[Column].size` and repeats the meadow schema array at `MeadowSchema.Schema`.  Other
	 * meadow-compatible servers hand back a bare `Columns` array, so all three are tolerated.
	 *
	 * @param {Object} pSchemaDocument - The entity schema document
	 * @returns {number} The GUID column width, or 0 when the document does not describe one
	 */
	_readGUIDColumnSizeFromSchema(pSchemaDocument)
	{
		if (!pSchemaDocument || typeof(pSchemaDocument) !== 'object')
		{
			return 0;
		}

		if (pSchemaDocument.properties && pSchemaDocument.properties[this.EntityGUIDName])
		{
			let tmpPropertySize = Number(pSchemaDocument.properties[this.EntityGUIDName].size);
			if (tmpPropertySize > 0)
			{
				return tmpPropertySize;
			}
		}

		let tmpColumns = false;
		if (Array.isArray(pSchemaDocument.Columns))
		{
			tmpColumns = pSchemaDocument.Columns;
		}
		else if (pSchemaDocument.MeadowSchema && Array.isArray(pSchemaDocument.MeadowSchema.Schema))
		{
			tmpColumns = pSchemaDocument.MeadowSchema.Schema;
		}

		if (tmpColumns)
		{
			let tmpGUIDColumn = tmpColumns.find((pColumn) => pColumn.Column === this.EntityGUIDName);
			let tmpColumnSize = tmpGUIDColumn ? Number(tmpGUIDColumn.Size) : 0;
			if (tmpColumnSize > 0)
			{
				return tmpColumnSize;
			}
		}

		return 0;
	}

	/**
	 * Stash an entity schema document on the adapter and adopt its GUID column width when the caller
	 * did not already pin one via GUIDMaxLength or GUIDColumnSizes.
	 *
	 * @param {Object} pSchemaDocument - The entity schema document
	 */
	_applySchemaDocument(pSchemaDocument)
	{
		if (!pSchemaDocument || typeof(pSchemaDocument) !== 'object')
		{
			return;
		}

		this.meadowSchema = pSchemaDocument;

		if (this.GUIDMaxLengthResolved)
		{
			return;
		}

		let tmpSchemaSize = this._readGUIDColumnSizeFromSchema(pSchemaDocument);

		if (tmpSchemaSize < 1)
		{
			this.log.warn(`Server schema for [${this.Entity}] did not describe a width for [${this.EntityGUIDName}]; GUID length stays at ${this.GUIDMaxLength} from ${this.GUIDMaxLengthSource}.`);
			return;
		}

		if (tmpSchemaSize !== this.GUIDMaxLength)
		{
			this.log.info(`Server schema GUID column size for [${this.Entity}] is ${tmpSchemaSize} (local had ${this.GUIDMaxLength}); using server value.`);
		}
		else
		{
			this.log.trace(`Server schema confirms GUID column size for [${this.Entity}]: ${tmpSchemaSize}`);
		}

		this.GUIDMaxLength = tmpSchemaSize;
		this.GUIDMaxLengthSource = 'the live server schema';
		this.GUIDMaxLengthResolved = true;
	}

	/**
	 * Fetch the entity schema from the server and adopt the authoritative GUID column width.
	 *
	 * integrateRecords() calls this first.  Consumers that drive marshalSourceRecords() themselves must
	 * call it explicitly, or the GUID length check runs against DefaultGUIDColumnSize.  Idempotent: once
	 * a schema has been applied, further calls are a no-op.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback fired when the schema has been loaded (or failed to load)
	 */
	loadSchema(fCallback)
	{
		if (this.meadowSchema && (typeof(this.meadowSchema) === 'object'))
		{
			return fCallback();
		}

		let tmpClient = this._resolveClient();

		if (!tmpClient)
		{
			return fCallback(new Error(`No REST client available for [${this.Entity}].`));
		}

		this.fable.log.info(`Getting schema for ${this.Entity}....`);

		return tmpClient.getJSON(`${this.Entity}/Schema`,
			(pError, pResponse, pParsedBody) =>
			{
				// getJSON returns (pError, pResponse, pParsedBody).  Use the parsed body (3rd arg) if
				// present; fall back to pResponse for clients that return (pError, pBody) only.
				let tmpBody = (typeof(pParsedBody) === 'object') ? pParsedBody : pResponse;

				this._applySchemaDocument(tmpBody);

				return fCallback(pError);
			});
	}

	/**
	 * The combined GUID prefix string.
	 *
	 * @returns {string} The GUID prefix
	 */
	get GUIDPrefix()
	{
		let tmpPrefix = '';
		if (this.AdapterSetGUIDMarshalPrefix)
		{
			tmpPrefix += `${this.AdapterSetGUIDMarshalPrefix}-`;
		}
		if (this.EntityGUIDMarshalPrefix)
		{
			tmpPrefix += `${this.EntityGUIDMarshalPrefix}-`;
		}
		return tmpPrefix;
	}

	/**
	 * Generate a Meadow GUID from an external system GUID.
	 *
	 * If the generated GUID would exceed GUIDMaxLength and AllowGUIDTruncation
	 * is false (the default), an error is thrown so the integration stops immediately.
	 *
	 * When AllowGUIDTruncation is true, the prefix is progressively truncated to
	 * fit while preserving the full external GUID.
	 *
	 * @param {string} pExternalGUID - The external system GUID
	 * @returns {string} The generated Meadow GUID
	 */
	generateMeadowGUIDFromExternalGUID(pExternalGUID)
	{
		let tmpFullGUID = `${this.GUIDPrefix}${pExternalGUID}`;

		if (this.GUIDMaxLength > 0 && tmpFullGUID.length > this.GUIDMaxLength)
		{
			if (!this.AllowGUIDTruncation)
			{
				let tmpMessage = `Generated GUID for [${this.Entity}] is ${tmpFullGUID.length} characters, exceeding the limit of ${this.GUIDMaxLength} from ${this.GUIDMaxLengthSource}.\n`
					+ `  Comprehension GUID: [${pExternalGUID}] (${pExternalGUID.length} chars)\n`
					+ `  Server GUID:        [${tmpFullGUID}] (${tmpFullGUID.length} chars)\n`
					+ `  Prefix:             [${this.GUIDPrefix}] (${this.GUIDPrefix.length} chars)\n`;

				if (!this.GUIDMaxLengthResolved)
				{
					tmpMessage += `  No column width was resolved for [${this.Entity}] -- this limit is not the column's limit.  Call loadSchema() (integrateRecords() does) before marshaling, or supply GUIDColumnSizes / GUIDMaxLength if the column is wider.\n`;
				}

				tmpMessage += `  To allow automatic prefix truncation for one-time imports, set AllowGUIDTruncation to true (CLI: --allowguidtruncation).`;
				this.log.error(tmpMessage);
				throw new Error(tmpMessage);
			}

			// AllowGUIDTruncation is on — the external GUID is sacrosanct, so truncate the prefix instead.
			if (this.GUIDTruncationStrategy === 'hash')
			{
				// Hash strategy: keep the prefix; deterministically hash the external GUID into the remaining
				// budget so the result stays stable across runs (idempotent) rather than losing prefix chars.
				let tmpHashBudget = Math.max(8, this.GUIDMaxLength - this.GUIDPrefix.length);
				let tmpHashedExternal = libGUIDComposer.hashSegment(pExternalGUID, tmpHashBudget);
				tmpFullGUID = `${this.GUIDPrefix}${tmpHashedExternal}`;
				if (tmpFullGUID.length > this.GUIDMaxLength) { tmpFullGUID = tmpFullGUID.substring(0, this.GUIDMaxLength); }
				this.log.warn(`Generated GUID for [${this.Entity}] exceeded ${this.GUIDMaxLength} chars; external GUID hashed (GUIDTruncationStrategy=hash) to [${tmpHashedExternal}].`);
			}
			else
			{
				// Substring strategy (default): the external GUID is sacrosanct, so truncate the prefix instead.
				let tmpAvailablePrefixLength = this.GUIDMaxLength - pExternalGUID.length;

				if (tmpAvailablePrefixLength <= 0)
				{
					// External GUID alone meets or exceeds the limit; drop the prefix entirely.
					this.log.warn(`External GUID [${pExternalGUID}] for [${this.Entity}] is ${pExternalGUID.length} characters which meets or exceeds the GUID max length of ${this.GUIDMaxLength}.  Using external GUID with no prefix.`);
					tmpFullGUID = pExternalGUID.substring(0, this.GUIDMaxLength);
				}
				else
				{
					let tmpTruncatedPrefix = this.GUIDPrefix.substring(0, tmpAvailablePrefixLength);
					tmpFullGUID = `${tmpTruncatedPrefix}${pExternalGUID}`;
					this.log.warn(`Generated GUID for [${this.Entity}] would be ${this.GUIDPrefix.length + pExternalGUID.length} characters (limit ${this.GUIDMaxLength}); prefix truncated from [${this.GUIDPrefix}] to [${tmpTruncatedPrefix}].`);
				}
			}
		}

		return tmpFullGUID;
	}

	/**
	 * Integrate records: fetch schema, marshal, push.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback when done
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - Optional per-record extra marshal function
	 */
	integrateRecords(fCallback, fMarshalExtraData)
	{
		let tmpMarshalExtraData = fMarshalExtraData;
		let tmpAnticipate = this.fable.newAnticipate();
		let tmpClient = this._resolveClient();

		if (!tmpClient)
		{
			return fCallback(new Error(`No REST client available for [${this.Entity}].`));
		}

		tmpAnticipate.anticipate(
			(fStageComplete) =>
			{
				this.loadSchema(fStageComplete);
			});
		tmpAnticipate.anticipate(
			(fStageComplete) =>
			{
				this.fable.log.info(`Marshaling ${this.Entity} records....`);
				this.marshalSourceRecords(fStageComplete, tmpMarshalExtraData);
			});
		tmpAnticipate.anticipate(
			(fStageComplete) =>
			{
				this.fable.log.info(`Posting ${this.Entity} records....`);
				this.pushRecordsToServer(fStageComplete);
			});
		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Add a record to the adapter's Source Records buffer to be pushed.
	 *
	 * @param {Object} pRecord - The record to add
	 */
	addSourceRecord(pRecord)
	{
		if (!pRecord || typeof(pRecord) !== 'object' || Array.isArray(pRecord))
		{
			this.log.error(`Passed-in record was null, or not of type "object" (${typeof(pRecord)}), therefore it was not added to the Source Record buffer.`);
			return false;
		}

		let tmpRecordGUID = pRecord[this.EntityGUIDName];
		if (!tmpRecordGUID && (!pRecord.hasOwnProperty(this.EntityIDName) || !(pRecord[this.EntityIDName])))
		{
			tmpRecordGUID = pRecord[`_${this.EntityGUIDName}`];
			if (!tmpRecordGUID)
			{
				this.log.error(`Passed-in record did not contain a source system GUID data element [${this.Entity}].[${this.EntityGUIDName}], therefore it was not added to the Source Record Buffer:`, pRecord);
				return false;
			}
		}

		if (tmpRecordGUID)
		{
			this._SourceRecords[tmpRecordGUID] = pRecord;
		}
		else
		{
			this._SourceRecords[pRecord[this.EntityIDName]] = pRecord;
		}
	}

	/**
	 * Marshal a source record to a Meadow record (async).
	 *
	 * Handles:
	 * - GUID prefix generation and validation/truncation
	 * - External GUID mapping (GUID* fields → ID lookup from session map)
	 * - Server GUID mapping (_GUID* fields → async server lookup)
	 * - _Dest_IDEntity_*_Via_* pattern for explicit FK destination fields
	 * - Schema-based field type/length enforcement
	 * - SimpleMarshal and ForceMarshal options
	 *
	 * @param {Object} pSourceRecord - The source record to marshal
	 * @returns {Promise<Object>} The marshaled record
	 */
	async marshalRecord(pSourceRecord)
	{
		let tmpRecord = {};
		let tmpClient = this._resolveClient();

		// Create the new GUID
		let tmpRecordMeadowGUID;
		let tmpRecordExternalGUID = pSourceRecord[this.EntityGUIDName];
		if (tmpRecordExternalGUID)
		{
			tmpRecordMeadowGUID = this.generateMeadowGUIDFromExternalGUID(tmpRecordExternalGUID);
		}
		else
		{
			tmpRecordExternalGUID = pSourceRecord[`_${this.EntityGUIDName}`];
			tmpRecordMeadowGUID = tmpRecordExternalGUID;
		}

		if (!tmpRecordMeadowGUID && !pSourceRecord.hasOwnProperty(this.EntityIDName))
		{
			throw new Error(`Could not marshal record for [${this.Entity}] because no external system GUID was found in source record.`);
		}

		if (tmpRecordMeadowGUID)
		{
			// Mapping table for going between Meadow system GUIDs and External system GUIDs.
			tmpRecord[this.EntityGUIDName] = tmpRecordMeadowGUID;
			this.fable.MeadowGUIDMap.mapExternalGUIDtoMeadowGUID(this.Entity, tmpRecordExternalGUID, tmpRecordMeadowGUID);
		}

		// Now that we've dealt with basic identifiers, time to see if there are other Mapped GUIDs to look up.
		for (const tmpRecordKey of Object.keys(pSourceRecord))
		{
			if (tmpRecordKey == this.EntityGUIDName || tmpRecordKey == `_${this.EntityGUIDName}`)
			{
				// Don't do anything for the GUID that's already set...
			}
			else if (tmpRecordKey.startsWith('_Dest_IDEntity_') && tmpRecordKey.includes('_Via_'))
			{
				// This is a destination-explicit FK with a GUID to resolve via server lookup.
				let tmpMappedEntityGUIDName = tmpRecordKey.split('_Via_')[1];
				let tmpMappedEntityName = tmpMappedEntityGUIDName.substring(4);
				let tmpMappedEntityGUIDValue = pSourceRecord[tmpRecordKey];
				let tmpMeadowIDValue = await new Promise((resolve) =>
				{
					this.fable.MeadowGUIDMap.getIDFromGUIDAsync(tmpMappedEntityName, tmpMappedEntityGUIDValue,
					(pError, pResponse) =>
					{
						if (pResponse)
						{
							resolve(pResponse);
						}
						else
						{
							if (pError)
							{
								this.fable.log.warn(`Error getting Meadow id for ${tmpMappedEntityName} GUID [${tmpMappedEntityGUIDValue}]: ${pError.message || pError}`, { Stack: pError.stack });
							}
							resolve(0);
						}
					}, tmpClient);
				});
				if (tmpMeadowIDValue)
				{
					const tmpIDDestinationField = tmpRecordKey.split('_Via_')[0].split('_Dest_IDEntity_')[1];
					tmpRecord[tmpIDDestinationField] = tmpMeadowIDValue;
				}
				else
				{
					this.fable.log.warn(`Could not find Meadow ID for [${tmpMappedEntityName}] with GUID [${tmpMappedEntityGUIDValue}] while integrating [${this.Entity}] record [${tmpRecord[this.EntityGUIDName]}].`)
				}
			}
			else if (tmpRecordKey.startsWith('_Dest_'))
			{
				// skip this, it's a destination field override for a GUID
			}
			else if (tmpRecordKey.startsWith('GUID'))
			{
				// This is an external system GUID
				// Because external system GUIDs require adapters to look up, it should be mapped if the tree traversal worked.
				let tmpMappedEntityExternalGUIDName = tmpRecordKey;
				let tmpMappedEntityName = tmpMappedEntityExternalGUIDName.substring(4);
				let tmpMappedEntityExternalGUIDValue = pSourceRecord[tmpMappedEntityExternalGUIDName];

				let tmpMeadowIDValue = this.fable.MeadowGUIDMap.getMeadowIDFromExternalGUID(tmpMappedEntityName, tmpMappedEntityExternalGUIDValue);
				if (tmpMeadowIDValue)
				{
					const tmpIDDestinationField = pSourceRecord[`_Dest_${tmpRecordKey}`] || `ID${tmpMappedEntityName}`;
					tmpRecord[tmpIDDestinationField] = tmpMeadowIDValue;
				}
				else
				{
					this.fable.log.warn(`Could not find Meadow ID for [${tmpMappedEntityName}] with External GUID [${tmpMappedEntityExternalGUIDValue}] while integrating [${this.Entity}] record [${tmpRecord[this.EntityGUIDName]}].`)
				}
			}
			else if (tmpRecordKey.startsWith('_GUID'))
			{
				// This is a Meadow GUID that needs async server lookup.
				let tmpMappedEntityGUIDName = tmpRecordKey;
				let tmpMappedEntityName = tmpMappedEntityGUIDName.substring(5);
				let tmpMappedEntityGUIDValue = pSourceRecord[tmpMappedEntityGUIDName];
				let tmpMeadowIDValue = await new Promise((resolve) =>
				{
					this.fable.MeadowGUIDMap.getIDFromGUIDAsync(tmpMappedEntityName, tmpMappedEntityGUIDValue,
					(pError, pResponse) =>
					{
						if (pResponse)
						{
							resolve(pResponse);
						}
						else
						{
							if (pError)
							{
								this.fable.log.warn(`Error getting Meadow id for ${tmpMappedEntityName} GUID [${tmpMappedEntityGUIDValue}]: ${pError.message || pError}`, { Stack: pError.stack });
							}
							resolve(0);
						}
					}, tmpClient);
				});
				if (tmpMeadowIDValue)
				{
					const tmpIDDestinationField = pSourceRecord[`_Dest_${tmpRecordKey}`] || `ID${tmpMappedEntityName}`;
					tmpRecord[tmpIDDestinationField] = tmpMeadowIDValue;
					tmpRecord[`ID${tmpMappedEntityName}`] = tmpMeadowIDValue;
				}
				else
				{
					this.fable.log.warn(`Could not find Meadow ID for [${tmpMappedEntityName}] with GUID [${tmpMappedEntityGUIDValue}] while integrating [${this.Entity}] record [${tmpRecord[this.EntityGUIDName]}].`)
				}
			}
			else if ((this.meadowSchema && this.meadowSchema.hasOwnProperty('properties')) && (this.meadowSchema.properties.hasOwnProperty(tmpRecordKey)))
			{
				// Check the length if it's a string -- truncate if it isn't there for now.
				if (this.options.SimpleMarshal)
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
				}
				else if ((this.meadowSchema.properties[tmpRecordKey].type == 'string')
					&& pSourceRecord.hasOwnProperty(tmpRecordKey)
					&& (pSourceRecord[tmpRecordKey] != null)
					&& (pSourceRecord[tmpRecordKey].toString().length > this.meadowSchema.properties[tmpRecordKey].size))
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey].substring(0, this.meadowSchema.properties[tmpRecordKey].size);
				}
				else if (this.meadowSchema.properties[tmpRecordKey].type == 'string')
				{
					if ((pSourceRecord[tmpRecordKey] !== null) && (pSourceRecord[tmpRecordKey] !== undefined))
					{
						tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey].toString();
					}
				}
				else
				{
					tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
				}
			}
			else if (this.options.ForceMarshal)
			{
				tmpRecord[tmpRecordKey] = pSourceRecord[tmpRecordKey];
			}
		}

		// Clean any elements in the record that are reserved by Meadow
		if (tmpRecord.hasOwnProperty('CreateDate')) delete tmpRecord.CreateDate;
		if (tmpRecord.hasOwnProperty('UpdateDate')) delete tmpRecord.UpdateDate;
		if (tmpRecord.hasOwnProperty('Deleted')) delete tmpRecord.Deleted;
		if (tmpRecord.hasOwnProperty('DeleteDate')) delete tmpRecord.DeleteDate;

		return tmpRecord;
	}

	/**
	 * Marshal a single source record (async).
	 *
	 * @param {string} pSourceRecordGUID - The GUID of the source record
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - Optional extra marshal function
	 * @returns {Promise<boolean>}
	 */
	async marshalSingleSourceRecord(pSourceRecordGUID, fMarshalExtraData)
	{
		// 0. Get the original GUID
		let tmpSourceRecordGUID = pSourceRecordGUID;

		// 0.3 Get the Source Record
		let tmpSourceRecord = this._SourceRecords[tmpSourceRecordGUID];

		if (!tmpSourceRecord)
		{
			this.log.fatal(`Could not marshal source record for [${this.Entity}] because source record with GUID [${tmpSourceRecordGUID}] was not found in Source Records buffer.`);
			return;
		}

		// 0.5 Check if this is a delete
		let tmpDeleteOperation = isDeletedFlagSet(tmpSourceRecord.Deleted);

		// 1. Marshal the Source record into a Meadow record
		let tmpMarshaledRecord = await this.marshalRecord(tmpSourceRecord);

		// 2. Get the GUID of the record after Marshaling...
		let tmpMarshaledRecordGUID = tmpMarshaledRecord[this.EntityIDName];
		if (tmpMarshaledRecord.hasOwnProperty(this.EntityGUIDName))
		{
			tmpMarshaledRecordGUID = tmpMarshaledRecord[this.EntityGUIDName];
		}
		else if (tmpMarshaledRecord.hasOwnProperty(`_${this.EntityGUIDName}`))
		{
			tmpMarshaledRecordGUID = tmpMarshaledRecord[`_${this.EntityGUIDName}`];
		}

		// 3. Get a new Object or the existing object as start of the append operation
		let tmpOriginalRecord = (this._MarshaledRecords.hasOwnProperty(tmpMarshaledRecordGUID)) ? this._MarshaledRecords[tmpMarshaledRecordGUID] : {};

		// 4. Now merge the properties of the two records, using the new one as the more important values
		if (tmpDeleteOperation)
		{
			this._DeletedRecords[tmpMarshaledRecordGUID] = tmpMarshaledRecord;
		}
		else
		{
			this._MarshaledRecords[tmpMarshaledRecordGUID] = Object.assign(tmpOriginalRecord, tmpMarshaledRecord);
		}

		// 4.5 Inject a marshal stack
		if (typeof(fMarshalExtraData) == 'function')
		{
			fMarshalExtraData(tmpSourceRecord, tmpMarshaledRecord);
		}

		// 5. Now delete the record from the SourceRecords set so next marshal operation doesn't do it again needlessly
		delete this._SourceRecords[tmpSourceRecordGUID];

		return true;
	}

	/**
	 * Take all Source Records in the buffer and marshal them (async).
	 *
	 * @param {(error?: Error) => void} fCallback - Callback when done
	 * @param {(source: any, marshalled: any) => void} [fMarshalExtraData] - Optional extra marshal function
	 */
	async marshalSourceRecords(fCallback, fMarshalExtraData)
	{
		try
		{
			let tmpRecordKeys = Object.keys(this._SourceRecords);

			for (let i = 0; i < tmpRecordKeys.length; i++)
			{
				await this.marshalSingleSourceRecord(tmpRecordKeys[i], fMarshalExtraData);
			}

			return fCallback();
		}
		catch (error)
		{
			return fCallback(error);
		}
	}

	/**
	 * Take a single record and push it to the server.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback when done
	 * @param {string} pRecordGUID - The GUID of the record to push
	 * @param {number} [pRetryCount] - The number of times this record has been retried
	 */
	upsertSingleRecord(fCallback, pRecordGUID, pRetryCount)
	{
		let tmpRetryCount = (typeof(pRetryCount) === 'undefined') ? 0 : pRetryCount;
		let tmpClient = this._resolveClient();

		if (!tmpClient)
		{
			return fCallback(new Error(`No REST client available for [${this.Entity}].`));
		}

		// Non-configurable cap for a bit here... until better logic is written.
		if ((tmpRetryCount > this._RecordPushRetryThreshold) || (tmpRetryCount > 50))
		{
			this.log.error(`Upsert error sending [${this.Entity}].[${pRecordGUID}] to server... retry threshold of ${this._RecordPushRetryThreshold} reached.`);

			// upsert failed — try to read the record so we can at least have a valid ID / GUID mapping
			if (typeof(tmpClient.getEntityByGUID) === 'function')
			{
				let tmpIdentifierType = 'GUID';
				const tmpFallbackCallback = (pError, pBody) =>
				{
					if (pError)
					{
						this.log.error(`Error reading record ${tmpIdentifierType} [${pRecordGUID}] after upsert failures: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (pBody &&
							(pBody.hasOwnProperty(this.EntityIDName)) &&
							(pBody[this.EntityIDName] > 0) &&
							(pBody.hasOwnProperty(this.EntityGUIDName)) &&
							((pBody[this.EntityGUIDName] === pRecordGUID) || (pBody[this.EntityIDName] == pRecordGUID))
						)
					{
						this.log.info(`Fallback: Loaded and mapping record ${tmpIdentifierType} [${pRecordGUID}] after upsert failure.`);
						this.fable.MeadowGUIDMap.mapGUIDToID(this.Entity, pBody[this.EntityGUIDName], pBody[this.EntityIDName]);
					}
					else
					{
						this.log.error(`Could not verify record ${tmpIdentifierType} [${pRecordGUID}] after upsert failures; record not found or invalid response.`, { Record: pBody });
					}
					return fCallback();
				};
				if (this._MarshaledRecords[pRecordGUID] && this._MarshaledRecords[pRecordGUID][this.EntityIDName] == pRecordGUID)
				{
					tmpIdentifierType = 'ID';
					return tmpClient.getEntity(this.Entity, pRecordGUID, tmpFallbackCallback);
				}
				return tmpClient.getEntityByGUID(this.Entity, pRecordGUID, tmpFallbackCallback);
			}

			return fCallback();
		}

		tmpClient.upsertEntity(this.Entity, this._MarshaledRecords[pRecordGUID],
			(pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error sending PUT [${this.Entity}].[${pRecordGUID}] to server:  ${pError}`);
					let tmpErrorMessage = (typeof(pError.message) === 'string') ? pError.message : String(pError);
					if (tmpErrorMessage.indexOf('Error in DAL create: Error: Duplicate entry') > 0)
					{
						this.log.warn(`Duplicate record attempted when sending PUT to server record GUID [${pRecordGUID}]: ${tmpErrorMessage}`, pBody);
						return fCallback();
					}
					if (tmpErrorMessage.indexOf('exceeds the maximum allowed length') > 0)
					{
						this.log.error(`GUID length rejected by server for [${this.Entity}].[${pRecordGUID}] (${pRecordGUID.length} chars): ${tmpErrorMessage}`);
						return fCallback();
					}
					if (tmpErrorMessage.indexOf('Rejected Create') > -1 && tmpErrorMessage.indexOf('GUID') > -1)
					{
						this.log.error(`Server rejected create for [${this.Entity}].[${pRecordGUID}] due to GUID issue: ${tmpErrorMessage}`);
						return fCallback();
					}

					// simple delay for retries to not spam the server
					setTimeout(() =>
					{
						this.upsertSingleRecord(fCallback, pRecordGUID, tmpRetryCount + 1);
					}, 500);
					return;
				}

				if (
						pBody &&
						// Check that the server returned a valid record (look for the Identity column)
						(pBody.hasOwnProperty(this.EntityIDName)) &&
						// Check that the server returned a record that has a numeric ID which is nonzero
						(pBody[this.EntityIDName] > 0) &&
						// Check that the server also returned a GUID
						(pBody.hasOwnProperty(this.EntityGUIDName)) &&
						// Check that the GUID or ID matches what we expect
						((pBody[this.EntityGUIDName] === pRecordGUID) || (pBody[this.EntityIDName] == pRecordGUID))
					)
				{
					// Add the record ID to the lookup table
					this.fable.MeadowGUIDMap.mapGUIDToID(this.Entity, pBody[this.EntityGUIDName], pBody[this.EntityIDName]);
					return fCallback();
				}

				// Try again...
				this.log.error(`Problem sending PUT [${this.Entity}].[${pRecordGUID}] to server.  Incrementing retry count and trying again.`, { Record: pBody, RetryCount: tmpRetryCount });
				this.upsertSingleRecord(fCallback, pRecordGUID, tmpRetryCount + 1);
			});
	}

	/**
	 * Take a set of records and push them to the server in bulk.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback when done
	 * @param {string[]} pRecordGUIDs - The GUIDs of the records to push
	 * @param {number} [pRetryCount] - The number of times this batch has been retried
	 */
	upsertBulkRecords(fCallback, pRecordGUIDs, pRetryCount)
	{
		let tmpRetryCount = (typeof(pRetryCount) === 'undefined') ? 0 : pRetryCount;
		let tmpClient = this._resolveClient();

		if (!tmpClient)
		{
			return fCallback(new Error(`No REST client available for [${this.Entity}].`));
		}

		// Non-configurable cap for a bit here... until better logic is written.
		if ((tmpRetryCount > this._RecordPushRetryThreshold) || (tmpRetryCount > 50))
		{
			this.log.error(`Upsert error sending [${this.Entity}] to server... retry threshold of ${this._RecordPushRetryThreshold} reached.`);
			return fCallback();
		}

		let tmpRecordsToUpsert = [];

		for (let i = 0; i < pRecordGUIDs.length; i++)
		{
			tmpRecordsToUpsert.push(this._MarshaledRecords[pRecordGUIDs[i]]);
		}

		tmpClient.upsertEntities(this.Entity, tmpRecordsToUpsert,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error sending PUT [${this.Entity}] to server:  ${pError}`);
					return this.upsertBulkRecords(fCallback, pRecordGUIDs, tmpRetryCount + 1);
				}

				if (Array.isArray(pBody))
				{
					// Add the record IDs to the lookup table
					for (let i = 0; i < pBody.length; i++)
					{
						this.fable.MeadowGUIDMap.mapGUIDToID(this.Entity, pBody[i][this.EntityGUIDName], pBody[i][this.EntityIDName]);
					}
					return fCallback();
				}

				// Try again...
				this.log.error(`Problem sending PUT [${this.Entity}] to server.  Incrementing retry count and trying again.`, { Records: pBody, RetryCount: tmpRetryCount });
				this.upsertBulkRecords(fCallback, pRecordGUIDs, tmpRetryCount + 1);
			});
	}

	/**
	 * Increment the meta progress tracker (if configured) and conditionally log its status.
	 *
	 * Uses a threshold-crossing check rather than exact modulo so that bulk increments
	 * (e.g. +100) reliably trigger a log when they cross an interval boundary.
	 *
	 * @param {number} pAmount - The number of operations to increment by
	 */
	_incrementMetaProgressTracker(pAmount)
	{
		if (!this.MetaProgressTrackerHash)
		{
			return;
		}
		let tmpTracker = this.fable.ProgressTrackerSet;
		let tmpStatus = tmpTracker.incrementProgressTracker(this.MetaProgressTrackerHash, pAmount);

		if (this.MetaProgressTrackerLogInterval > 0 && tmpStatus)
		{
			let tmpPreviousCount = tmpStatus.CurrentCount - pAmount;
			let tmpPreviousInterval = Math.floor(tmpPreviousCount / this.MetaProgressTrackerLogInterval);
			let tmpCurrentInterval = Math.floor(tmpStatus.CurrentCount / this.MetaProgressTrackerLogInterval);

			if (tmpCurrentInterval > tmpPreviousInterval
				|| tmpStatus.CurrentCount >= tmpStatus.TotalCount)
			{
				tmpTracker.logProgressTrackerStatus(this.MetaProgressTrackerHash);
			}
		}
	}

	/**
	 * Push any records in the adapter buffer to the server.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback when done
	 */
	pushRecordsToServer(fCallback)
	{
		if (!this._PerformUpserts)
		{
			return fCallback();
		}
		// Run the upserts...
		let tmpRecordKeys = Object.keys(this._MarshaledRecords);
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpProgressTrackerGUID = this.fable.getUUID();
		let tmpProgressTracker = this.fable.ProgressTrackerSet;
		tmpProgressTracker.createProgressTracker(tmpProgressTrackerGUID, tmpRecordKeys.length);
		tmpProgressTracker.startProgressTracker(tmpProgressTrackerGUID);

		// Log meta tracker at the start of each entity
		if (this.MetaProgressTrackerHash)
		{
			this.log.info(`[${this.Entity}] Starting push of ${tmpRecordKeys.length} records...`);
			tmpProgressTracker.logProgressTrackerStatus(this.MetaProgressTrackerHash);
		}

		// Determine if bulk upserts are possible
		if (tmpRecordKeys.length > this.options.RecordThresholdForBulkUpsert)
		{
			let tmpBulkUpsertBatchCount = Math.ceil(tmpRecordKeys.length / this.options.BulkUpsertBatchSize);
			for (let i = 0; i < tmpBulkUpsertBatchCount; i++)
			{
				let tmpBatchRecordKeys = [];
				for (let j = 0; j < this.options.BulkUpsertBatchSize; j++)
				{
					let tmpRecordKey = tmpRecordKeys[(i * this.options.BulkUpsertBatchSize) + j];
					if (tmpRecordKey)
					{
						tmpBatchRecordKeys.push(tmpRecordKey);
					}
				}

				tmpAnticipate.anticipate(
					function(fDone)
					{
						this.log.trace(`[${this.Entity}] Bulk Upserting ${tmpBatchRecordKeys.length} records to server for transaction set [${tmpProgressTrackerGUID}]...`);
						this.upsertBulkRecords(
							(pError, pBody) =>
							{
								if (pError)
								{
									this.log.error(`Error sending Bulk Upserts for [${this.Entity}] to server:  ${pError}`);
								}
								tmpProgressTracker.incrementProgressTracker(tmpProgressTrackerGUID, tmpBatchRecordKeys.length);
								tmpProgressTracker.logProgressTrackerStatus(tmpProgressTrackerGUID);
								this._incrementMetaProgressTracker(tmpBatchRecordKeys.length);
								return fDone();
							}, tmpBatchRecordKeys);
					}.bind(this));
			}
		}
		else
		{
			for (let i = 0; i < tmpRecordKeys.length; i++)
			{
				let tmpRecordKey = tmpRecordKeys[i];
				tmpAnticipate.anticipate(
					function(fDone)
					{
						this.log.trace(`[${this.Entity}] Record [${tmpRecordKey}] pushing to server...`);
						tmpProgressTracker.incrementProgressTracker(tmpProgressTrackerGUID, 1);
						tmpProgressTracker.logProgressTrackerStatus(tmpProgressTrackerGUID);
						this.upsertSingleRecord(
							() =>
							{
								this._incrementMetaProgressTracker(1);
								return fDone();
							}, tmpRecordKey);
					}.bind(this));
			}
		}

		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Delete records from the server.
	 *
	 * @param {(error?: Error) => void} fCallback - Callback when done
	 */
	deleteRecordsFromServer(fCallback)
	{
		if (!this._PerformDeletes)
		{
			return fCallback();
		}

		let tmpClient = this._resolveClient();
		if (!tmpClient)
		{
			return fCallback(new Error(`No REST client available for [${this.Entity}].`));
		}

		let tmpRecordKeys = Object.keys(this._DeletedRecords);
		this.fable.Utility.eachLimit(tmpRecordKeys, 1,
			(pRecordGUID, fDeleteComplete) =>
			{
				this.log.trace(`[${this.Entity}] Record [${pRecordGUID}] deleting from server...`);
				// Now lookup the Meadow ID for it...
				tmpClient.getEntityByGUID(this.Entity, pRecordGUID,
					(pReadError, pReadBody) =>
					{
						if (pReadError)
						{
							this.log.warn(`Could not read [${this.Entity}] GUID [${pRecordGUID}] for DELETE operation:  ${pReadError}`);
							return fDeleteComplete();
						}

						if (pReadBody && pReadBody.hasOwnProperty(this.EntityIDName))
						{
							tmpClient.deleteEntity(this.Entity, pReadBody[this.EntityIDName], fDeleteComplete);
							return;
						}

						this.log.warn(`Could not delete [${this.Entity}] GUID [${pRecordGUID}] because lookup did not return an IDRecord.`);
						return fDeleteComplete();
					});
			},
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`Error sending trying to Delete from [${this.Entity}]:  ${pError}`);
				}
				return fCallback(pError);
			});
	}
}

module.exports = MeadowIntegrationAdapter;

// Macro for backwards compatibility
module.exports.getAdapter = (
	/**
	 * @param {object} pFable - A fable instance
	 * @param {string} pEntity - The entity name
	 * @param {string} [pEntityPrefix] - The entity GUID marshal prefix
	 * @param {object} [pCustomOptions] - Additional options to merge in (e.g. SimpleMarshal, ForceMarshal)
	 */
	function(pFable, pEntity, pEntityPrefix, pCustomOptions)
	{
		if (pFable.servicesMap.IntegrationAdapter && pFable.servicesMap.IntegrationAdapter.hasOwnProperty(pEntity))
		{
			return pFable.servicesMap.IntegrationAdapter[pEntity];
		}
		else
		{
			const tmpOptions = Object.assign({}, pCustomOptions, { Entity: pEntity, EntityGUIDMarshalPrefix: pEntityPrefix });
			return pFable.instantiateServiceProvider('IntegrationAdapter', tmpOptions, pEntity);
		}
	});

module.exports.default_configuration = defaultMeadowIntegrationAdapterOptions;

// Exported for testing: the predicate that decides whether a source record is a delete.
module.exports.isDeletedFlagSet = isDeletedFlagSet;

},{"./Meadow-Service-Integration-GUIDMap.js":518,"./services/guid/Meadow-Integration-GUIDComposer.js":519,"fable-serviceproviderbase":438}],518:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const defaultMeadowGUIDMapOptions = (
	{
		// Nothing here yet.
		// Maybe overwrite rules?  Right now it's just obliterate.
		// When we add persistence that would be here as well.
	});

class MeadowGUIDMap extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, defaultMeadowGUIDMapOptions, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'MeadowGUIDMap';

		// For now, keep GUID mappings to IDs in memory forever.
		// At the moment, we don't have enough data throughput for that to be a problem really.
		// When it becomes so, we can shift the persistence to some kind of key-value store.
		// These are back and forth between the Meadow GUIDs and the Meadow IDs
		this._GUIDMap = {};
		this._IDMap = {};

		// Keep track of *external* GUIDS that map to Meadow GUIDs
		this._ExternalGUIDMap = {};
	}

	// Add an entity for the mapping
	addEntity(pEntity)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this._GUIDMap[pEntity] = {};
			this._IDMap[pEntity] = {};
			this._ExternalGUIDMap[pEntity] = {};
		}

		return true;
	}

	// Map a Meadow GUID to an ID
	mapGUIDToID(pEntity, pGUID, pID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._GUIDMap[pEntity][pGUID] = pID;
		this._IDMap[pEntity][pID] = pGUID;

		return true;
	}

	// Get an ID from a GUID
	getIDFromGUID(pEntity, pGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._GUIDMap[pEntity].hasOwnProperty(pGUID)) ? this._GUIDMap[pEntity][pGUID] : false;
	}

	/**
	 * Get an ID from a GUID, loading from the server if not already cached.
	 *
	 * @param {string} pEntity - The entity name
	 * @param {string} pGUID - The GUID to look up
	 * @param {function} fCallback - Callback (pError, pID)
	 * @param {object} [pClient] - Optional REST client to use for the server lookup
	 *                              (defaults to this.fable.MeadowRestClient or this.fable.MeadowCloneRestClient)
	 */
	getIDFromGUIDAsync(pEntity, pGUID, fCallback, pClient)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		// If it has already been loaded, return it.
		if (this._GUIDMap[pEntity].hasOwnProperty(pGUID))
		{
			fCallback(null, this._GUIDMap[pEntity][pGUID]);
		}
		else
		{
			// Resolve the REST client to use for the server lookup
			let tmpClient = pClient || this.fable.MeadowRestClient || this.fable.MeadowCloneRestClient;

			if (!tmpClient || typeof(tmpClient.getEntityByGUID) !== 'function')
			{
				return fCallback(new Error(`No REST client with getEntityByGUID available for GUID lookup of [${pEntity}].[${pGUID}].`), false);
			}

			// Try to load it from the server
			tmpClient.getEntityByGUID(pEntity, pGUID,
				(pError, pBody) =>
				{
					if (pError)
					{
						return fCallback(pError);
					}
					else
					{
						let tmpEntityIDName = `ID${pEntity}`;
						if (pBody && pBody.hasOwnProperty(tmpEntityIDName))
						{
							this.mapGUIDToID(pEntity, pGUID, pBody[tmpEntityIDName]);
							return fCallback(pError, pBody[tmpEntityIDName]);
						}
						else
						{
							return fCallback(pError, false)
						}
					}
				});
		}
	}

	// Get a GUID from an ID
	getGUIDFromID(pEntity, pID)
	{
		if (!this._IDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._IDMap[pEntity].hasOwnProperty(pID)) ? this._IDMap[pEntity][pID] : false;
	}

	// For now this is one-directional; we may need two for bi-directional sync but there are other ways to resolve this.
	mapExternalGUIDtoMeadowGUID(pEntity, pExternalGUID, pMeadowGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		this._ExternalGUIDMap[pEntity][pExternalGUID] = pMeadowGUID;

		return true;
	}

	getMeadowGUIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		return (this._ExternalGUIDMap[pEntity].hasOwnProperty(pExternalGUID)) ? this._ExternalGUIDMap[pEntity][pExternalGUID] : false;
	}

	getMeadowIDFromExternalGUID(pEntity, pExternalGUID)
	{
		if (!this._GUIDMap.hasOwnProperty(pEntity))
		{
			this.addEntity(pEntity);
		}

		let tmpMeadowGUID = this.getMeadowGUIDFromExternalGUID(pEntity, pExternalGUID);
		return (tmpMeadowGUID) ? this.getIDFromGUID(pEntity, tmpMeadowGUID) : false;
	}
}

module.exports = MeadowGUIDMap;

module.exports.default_configuration = defaultMeadowGUIDMapOptions;
},{"fable-serviceproviderbase":438}],519:[function(require,module,exports){
// Meadow-Integration-GUIDComposer — deterministic, length-safe composition of context-aware GUIDs.
//
// A "context-aware" GUID embeds its parents' identifiers so it is globally unique without a true UUID,
// e.g. a Line Item 8675309 on Contract 10 / Project 01278 composes to `UI_C10_P01278_LI8675309`. The
// hard part is staying inside the destination GUID column's width: when the composed string is too long
// this DETERMINISTICALLY hashes segments (interior context first, then the own segment, then the first)
// until it fits — `UI_C10_HASH_LI8675309` → `UI_C10_HASH_HASH` — so the same source row always yields the
// same GUID (idempotent upsert) even after shrinking.
//
// PURE + dependency-light on purpose: no node `crypto`, no fable, no DOM. It runs unchanged in the browser
// engine bundle (the Meadow-Integration-Engine boundary) and is trivially unit-testable in isolation.

const _DEFAULT_SEPARATOR = '_';
const _DEFAULT_HASH_LENGTH = 10;

/**
 * Deterministic 53-bit string hash (cyrb53) rendered as a fixed-length base36 token. Same input → same
 * output in any JS runtime, forever — which is what makes a shrunk GUID still match on re-import.
 * @param {string} pValue
 * @param {number} [pLength] - max token length (default 10)
 * @returns {string}
 */
function hashSegment(pValue, pLength)
{
	const tmpLength = (typeof pLength === 'number' && pLength > 0) ? pLength : _DEFAULT_HASH_LENGTH;
	const tmpString = String((pValue === null || pValue === undefined) ? '' : pValue);
	let tmpH1 = 0xdeadbeef;
	let tmpH2 = 0x41c6ce57;
	for (let i = 0; i < tmpString.length; i++)
	{
		const tmpCharCode = tmpString.charCodeAt(i);
		tmpH1 = Math.imul(tmpH1 ^ tmpCharCode, 2654435761);
		tmpH2 = Math.imul(tmpH2 ^ tmpCharCode, 1597334677);
	}
	tmpH1 = Math.imul(tmpH1 ^ (tmpH1 >>> 16), 2246822507) ^ Math.imul(tmpH2 ^ (tmpH2 >>> 13), 3266489909);
	tmpH2 = Math.imul(tmpH2 ^ (tmpH2 >>> 16), 2246822507) ^ Math.imul(tmpH1 ^ (tmpH1 >>> 13), 3266489909);
	// 53-bit unsigned integer (safe-integer range) → base36 token.
	const tmpHashNumber = 4294967296 * (2097151 & tmpH2) + (tmpH1 >>> 0);
	const tmpToken = tmpHashNumber.toString(36);
	return (tmpToken.length > tmpLength) ? tmpToken.slice(0, tmpLength) : tmpToken;
}

/** Render one segment as `<abbrev><value>` (e.g. `P01278`). */
function segmentString(pSegment)
{
	const tmpSegment = pSegment || {};
	const tmpAbbrev = (tmpSegment.abbrev === null || tmpSegment.abbrev === undefined) ? '' : String(tmpSegment.abbrev);
	const tmpValue = (tmpSegment.value === null || tmpSegment.value === undefined) ? '' : String(tmpSegment.value);
	return `${tmpAbbrev}${tmpValue}`;
}

/** Join the prefix (if any) + the segment strings with the separator. */
function _assemble(pPrefix, pSegmentStrings, pSeparator)
{
	const tmpParts = pPrefix ? [ pPrefix ].concat(pSegmentStrings) : pSegmentStrings.slice();
	return tmpParts.join(pSeparator);
}

/**
 * The order to hash segments when shrinking: interior context segments first (left→right), then the own
 * (last) segment, then the first context segment — so the prefix + first context + own stay readable
 * longest. Deterministic, so the same overflow always shrinks the same way.
 * @param {number} pCount
 * @returns {Array<number>}
 */
function _shrinkOrder(pCount)
{
	const tmpOrder = [];
	for (let i = 1; i < pCount - 1; i++) { tmpOrder.push(i); }
	if (pCount - 1 >= 1) { tmpOrder.push(pCount - 1); }
	if (pCount >= 1) { tmpOrder.push(0); }
	const tmpSeen = {};
	return tmpOrder.filter((pIndex) => (tmpSeen[pIndex] ? false : (tmpSeen[pIndex] = true)));
}

/**
 * Compose a deterministic, length-safe context-aware GUID.
 * @param {object} pSpec
 * @param {string} [pSpec.prefix] - the leading token (e.g. `UI`); omitted if falsy
 * @param {Array<{abbrev:string, value:*}>} pSpec.segments - ordered context segments + the own segment last
 * @param {string} [pSpec.separator] - default `_`
 * @param {number} [pSpec.maxLength] - the destination GUID column width; <=0 means unbounded
 * @param {number} [pSpec.hashLength] - per-segment hash token length (default 10)
 * @returns {string}
 */
function composeGUID(pSpec)
{
	const tmpSpec = pSpec || {};
	const tmpPrefix = tmpSpec.prefix ? String(tmpSpec.prefix) : '';
	const tmpSeparator = (typeof tmpSpec.separator === 'string') ? tmpSpec.separator : _DEFAULT_SEPARATOR;
	const tmpMaxLength = (typeof tmpSpec.maxLength === 'number') ? tmpSpec.maxLength : 0;
	const tmpHashLength = (typeof tmpSpec.hashLength === 'number' && tmpSpec.hashLength > 0) ? tmpSpec.hashLength : _DEFAULT_HASH_LENGTH;
	const tmpSegments = Array.isArray(tmpSpec.segments) ? tmpSpec.segments : [];

	const tmpSegmentStrings = tmpSegments.map(segmentString);
	let tmpFull = _assemble(tmpPrefix, tmpSegmentStrings, tmpSeparator);
	if (tmpMaxLength <= 0 || tmpFull.length <= tmpMaxLength)
	{
		return tmpFull;
	}

	// Too long — hash segment VALUES (keeping each segment's abbreviation for readability) in shrink order
	// until it fits. The hash is deterministic, so this stays stable across runs.
	const tmpShrinkOrder = _shrinkOrder(tmpSegments.length);
	for (let k = 0; k < tmpShrinkOrder.length; k++)
	{
		const tmpIndex = tmpShrinkOrder[k];
		const tmpSegment = tmpSegments[tmpIndex] || {};
		const tmpAbbrev = (tmpSegment.abbrev === null || tmpSegment.abbrev === undefined) ? '' : String(tmpSegment.abbrev);
		tmpSegmentStrings[tmpIndex] = `${tmpAbbrev}${hashSegment(segmentString(tmpSegment), tmpHashLength)}`;
		tmpFull = _assemble(tmpPrefix, tmpSegmentStrings, tmpSeparator);
		if (tmpFull.length <= tmpMaxLength)
		{
			return tmpFull;
		}
	}

	// Last resort (even all-hashed is too long, or a tiny column): collapse the whole body after the prefix
	// into a single hash sized to the remaining budget.
	const tmpBody = _assemble(tmpPrefix, tmpSegments.map(segmentString), tmpSeparator);
	const tmpPrefixCost = tmpPrefix ? (tmpPrefix.length + tmpSeparator.length) : 0;
	const tmpBudget = Math.max(6, tmpMaxLength - tmpPrefixCost);
	tmpFull = (tmpPrefix ? `${tmpPrefix}${tmpSeparator}` : '') + hashSegment(tmpBody, tmpBudget);
	return (tmpFull.length > tmpMaxLength) ? tmpFull.slice(0, tmpMaxLength) : tmpFull;
}

module.exports = {
	composeGUID,
	hashSegment,
	segmentString,
};

},{}],520:[function(require,module,exports){
// Meadow-Integration-GUIDStrategy — compiles a high-level, per-entity GUID strategy into the structured
// spec the transform consumes (which `Service-TabularTransform.createRecordFromMapping` resolves per row
// via the GUID composer). This is the configurable brain behind context-aware import GUIDs.
//
// It does NOT touch fable or the DOM and produces only plain data (segment value-TEMPLATES, field names,
// length budgets) — so it is reusable by the CLI, the server endpoints, and the browser import wizard
// alike, and is trivially unit-testable.
//
// Three modes per entity AND per join, mapped onto the adapter's existing FK conventions:
//   - prefixed (default): compose `UI_<context…>_<own>`; own → `GUID<Entity>`. A join to a parent that
//       was uploaded in THIS run → `GUID<Parent>` (sync session GUIDMap); a join to a PRE-EXISTING parent
//       (crossSession) → `_GUID<Parent>` (async server `getEntityByGUID` lookup).
//   - raw: the source already carries a true Meadow GUID → `_GUID<Parent>` (join) / `GUID<Entity>` (own).
//   - rawid: the source already carries a real `ID<Parent>` → used directly.

const _DEFAULT_PREFIX = 'UI';
const _DEFAULT_SEPARATOR = '_';
const _DEFAULT_HASH_LENGTH = 10;

/** A `{~D:Record.<column>~}` value template (what the transform resolves per row). */
function valueTemplate(pColumn)
{
	return `{~D:Record.${pColumn}~}`;
}

/**
 * The value template for an entity's OWN key segment — the combinatorial-GUID input. Three shapes, in
 * precedence order: a user-typed pict template `OwnKeyTemplate` (any expression, e.g.
 * `{~D:Record.A~}-{~D:Record.B~}`); multiple columns `OwnKeyColumns` concatenated into one segment; or a
 * single `OwnKeyColumn` (the original behavior). The transform resolves the whole string per row via
 * fable's parseTemplate, so multiple `{~D:Record.X~}` tags in one segment just work.
 * @param {Record<string, any>} pEntityConfig
 * @returns {string}
 */
function ownValueTemplate(pEntityConfig)
{
	const tmpConfig = pEntityConfig || {};
	if (tmpConfig.OwnKeyTemplate)
	{
		return String(tmpConfig.OwnKeyTemplate);
	}
	if (Array.isArray(tmpConfig.OwnKeyColumns) && (tmpConfig.OwnKeyColumns.length > 0))
	{
		return tmpConfig.OwnKeyColumns.map((pColumn) => valueTemplate(pColumn)).join('');
	}
	if (tmpConfig.OwnKeyColumn)
	{
		return valueTemplate(tmpConfig.OwnKeyColumn);
	}
	return '';
}

/** Derive a short uppercase abbreviation for an entity with no catalog entry (initials / first letters). */
function _deriveAbbreviation(pEntityName)
{
	const tmpName = String(pEntityName || '');
	const tmpCapitals = tmpName.replace(/[^A-Z]/g, '');
	if (tmpCapitals.length >= 2)
	{
		return tmpCapitals.slice(0, 3);
	}
	return tmpName.slice(0, 3).toUpperCase();
}

/**
 * @param {string} pEntityName @param {Record<string, any>} pContext
 * @returns {string} the host-fixed abbreviation (catalog) or a derived fallback
 */
function abbreviationFor(pEntityName, pContext)
{
	const tmpCatalog = (pContext && pContext.Catalog) || {};
	const tmpEntry = tmpCatalog[pEntityName];
	if (tmpEntry && tmpEntry.Abbrev)
	{
		return String(tmpEntry.Abbrev);
	}
	return _deriveAbbreviation(pEntityName);
}

/**
 * The GUID column width for an entity, or 0 (unbounded) if unknown.
 *
 * Prefers the live schema width (`SchemaSizes`, populated for the entity actually being imported), then
 * falls back to the host catalog's declared `GUIDSize`. The fallback is LOAD-BEARING for JOIN compose:
 * when a child references a parent (e.g. Product → Material), only the CHILD's schema is loaded, so
 * `SchemaSizes` has no entry for the parent. Without the catalog width the parent's foreign-key GUID is
 * composed unbounded (never hashed) while the parent's OWN GUID was hashed to fit its column — so a long
 * key makes the two diverge and the cross-session match silently breaks. The catalog `GUIDSize` MUST
 * therefore match the parent's real GUID column width for long keys to resolve.
 */
function _maxLengthFor(pEntityName, pContext)
{
	const tmpSizes = (pContext && pContext.SchemaSizes) || {};
	const tmpSchemaSize = Number(tmpSizes[pEntityName] || 0);
	if (tmpSchemaSize > 0)
	{
		return tmpSchemaSize;
	}
	const tmpCatalog = (pContext && pContext.Catalog) || {};
	const tmpEntry = tmpCatalog[pEntityName];
	const tmpCatalogSize = tmpEntry ? Number(tmpEntry.GUIDSize || 0) : 0;
	return (tmpCatalogSize > 0) ? tmpCatalogSize : 0;
}

/** Build a compose spec (prefix + ordered segments + length budget) for an entity's fullGUID. */
function _composeSpec(pEntityName, pSegments, pContext)
{
	return {
		prefix: (pContext && (pContext.Prefix !== undefined)) ? pContext.Prefix : _DEFAULT_PREFIX,
		separator: (pContext && pContext.Separator) || _DEFAULT_SEPARATOR,
		hashLength: (pContext && pContext.HashLength) || _DEFAULT_HASH_LENGTH,
		maxLength: _maxLengthFor(pEntityName, pContext),
		segments: pSegments,
	};
}

/**
 * The ordered context + own segments for an entity's OWN fullGUID.
 * @returns {{segments:Array<any>, warnings:Array<string>}}
 */
function _ownSegments(pEntityName, pEntityConfig, pContext)
{
	const tmpWarnings = [];
	const tmpSegments = [];
	const tmpContextEntities = Array.isArray(pEntityConfig.ContextEntities) ? pEntityConfig.ContextEntities : [];
	const tmpContextKeyColumns = pEntityConfig.ContextKeyColumns || {};

	tmpContextEntities.forEach((pParentEntity) =>
	{
		const tmpKeyColumn = tmpContextKeyColumns[pParentEntity];
		if (!tmpKeyColumn)
		{
			tmpWarnings.push(`Context entity "${pParentEntity}" for "${pEntityName}" has no key column mapped — its segment will be empty.`);
		}
		tmpSegments.push({ abbrev: abbreviationFor(pParentEntity, pContext), valueTemplate: tmpKeyColumn ? valueTemplate(tmpKeyColumn) : '' });
	});

	const tmpOwnValue = ownValueTemplate(pEntityConfig);
	if (!tmpOwnValue)
	{
		tmpWarnings.push(`"${pEntityName}" has no own-key column mapped — its GUID cannot be stable, so re-imports will create duplicates. Map a natural-key column (e.g. a code), several columns, or a template.`);
	}
	tmpSegments.push({ abbrev: abbreviationFor(pEntityName, pContext), valueTemplate: tmpOwnValue });

	return { segments: tmpSegments, warnings: tmpWarnings };
}

/** Compile the OWN GUID descriptor (field name + compose spec / raw template) for one entity. */
function _compileOwn(pEntityName, pEntityConfig, pContext)
{
	const tmpGUIDName = `GUID${pEntityName}`;
	const tmpMode = pEntityConfig.Mode || 'prefixed';

	if (tmpMode === 'raw')
	{
		// Source carries a true Meadow GUID; with empty marshal prefixes it passes through GUID<Entity>.
		return { Own: { Mode: 'raw', FieldName: tmpGUIDName, ValueTemplate: valueTemplate(pEntityConfig.OwnGUIDColumn || pEntityConfig.OwnKeyColumn) }, warnings: [] };
	}
	if (tmpMode === 'rawid')
	{
		// rawid OWN is deferred: the comprehension is keyed by GUID<Entity>, so an ID-only own record has
		// no comprehension key. Use a join in rawid mode instead, or import such sheets via the raw path.
		return { Own: { Mode: 'prefixed', FieldName: tmpGUIDName, Compose: _composeSpec(pEntityName, _ownSegments(pEntityName, pEntityConfig, pContext).segments, pContext) },
			warnings: [ `"${pEntityName}" requested raw-ID own mode, which is not yet supported for the entity's own GUID — fell back to prefixed.` ] };
	}

	// prefixed (default)
	const tmpOwn = _ownSegments(pEntityName, pEntityConfig, pContext);
	return { Own: { Mode: 'prefixed', FieldName: tmpGUIDName, Compose: _composeSpec(pEntityName, tmpOwn.segments, pContext) }, warnings: tmpOwn.warnings };
}

/** The FK field name for a join, per the adapter's conventions. */
function joinFieldName(pParentEntity, pMode, pCrossSession)
{
	if (pMode === 'rawid')
	{
		return `ID${pParentEntity}`;
	}
	if (pMode === 'raw')
	{
		return `_GUID${pParentEntity}`;
	}
	// prefixed: sync (same-upload) vs async server lookup (pre-existing parent)
	return pCrossSession ? `_GUID${pParentEntity}` : `GUID${pParentEntity}`;
}

/** Compile one join (FK) descriptor for an entity. */
function _compileJoin(pParentEntity, pJoin, pContext)
{
	const tmpMode = pJoin.Mode || 'prefixed';
	const tmpCrossSession = !!pJoin.CrossSession;
	const tmpFieldName = joinFieldName(pParentEntity, tmpMode, tmpCrossSession);
	const tmpWarnings = [];

	if (tmpMode === 'raw' || tmpMode === 'rawid')
	{
		const tmpColumn = pJoin.GUIDColumn || pJoin.IDColumn || pJoin.KeyColumn;
		if (!tmpColumn)
		{
			tmpWarnings.push(`Join "${pParentEntity}" (${tmpMode}) has no source column mapped.`);
		}
		return { Join: { ParentEntity: pParentEntity, Mode: tmpMode, FieldName: tmpFieldName, ValueTemplate: tmpColumn ? valueTemplate(tmpColumn) : '' }, warnings: tmpWarnings };
	}

	// prefixed: recompute the PARENT's fullGUID from this row's columns (so it matches the parent's own GUID).
	if (!pJoin.KeyColumn)
	{
		tmpWarnings.push(`Join "${pParentEntity}" (prefixed) has no parent key column mapped — the foreign key will not resolve.`);
	}
	const tmpParentContextEntities = Array.isArray(pJoin.ContextEntities) ? pJoin.ContextEntities : [];
	const tmpParentContextKeyColumns = pJoin.ContextKeyColumns || {};
	const tmpSegments = tmpParentContextEntities.map((pGrandparent) => (
		{ abbrev: abbreviationFor(pGrandparent, pContext), valueTemplate: tmpParentContextKeyColumns[pGrandparent] ? valueTemplate(tmpParentContextKeyColumns[pGrandparent]) : '' }));
	tmpSegments.push({ abbrev: abbreviationFor(pParentEntity, pContext), valueTemplate: pJoin.KeyColumn ? valueTemplate(pJoin.KeyColumn) : '' });

	return { Join: { ParentEntity: pParentEntity, Mode: 'prefixed', FieldName: tmpFieldName, Compose: _composeSpec(pParentEntity, tmpSegments, pContext) }, warnings: tmpWarnings };
}

/**
 * Compile one entity's strategy (own GUID + joins).
 * @param {string} pEntityName @param {Record<string, any>} pEntityConfig @param {Record<string, any>} pContext
 * @returns {{Strategy:Record<string, any>, Warnings:Array<string>}}
 */
function compileEntity(pEntityName, pEntityConfig, pContext)
{
	const tmpConfig = pEntityConfig || {};
	const tmpWarnings = [];

	const tmpOwn = _compileOwn(pEntityName, tmpConfig, pContext);
	tmpWarnings.push(...tmpOwn.warnings);

	const tmpJoins = [];
	(Array.isArray(tmpConfig.Joins) ? tmpConfig.Joins : []).forEach((pJoin) =>
	{
		if (!pJoin || !pJoin.ParentEntity) { return; }
		const tmpCompiled = _compileJoin(pJoin.ParentEntity, pJoin, pContext);
		tmpJoins.push(tmpCompiled.Join);
		tmpWarnings.push(...tmpCompiled.warnings);
	});

	return {
		Strategy: { Entity: pEntityName, GUIDName: `GUID${pEntityName}`, Own: tmpOwn.Own, Joins: tmpJoins },
		Warnings: tmpWarnings,
	};
}

/**
 * Compile a whole import's GUID strategy.
 * @param {Record<string, any>} pConfig - { Prefix?, Separator?, HashLength?, Entities:{ <name>: <entityConfig> } }
 * @param {Record<string, any>} pContext - { Catalog:{ <entity>:{Abbrev,KeyField} }, SchemaSizes:{ <entity>:size } }
 * @returns {{Strategies:Record<string, any>, Warnings:Array<string>}}
 */
function compile(pConfig, pContext)
{
	const tmpConfig = pConfig || {};
	const tmpContext = Object.assign(
		{
			Prefix: (tmpConfig.Prefix !== undefined) ? tmpConfig.Prefix : _DEFAULT_PREFIX,
			Separator: tmpConfig.Separator || _DEFAULT_SEPARATOR,
			HashLength: tmpConfig.HashLength || _DEFAULT_HASH_LENGTH,
		},
		pContext || {});

	const tmpEntities = tmpConfig.Entities || {};
	const tmpStrategies = {};
	const tmpWarnings = [];
	Object.keys(tmpEntities).forEach((pEntityName) =>
	{
		const tmpCompiled = compileEntity(pEntityName, tmpEntities[pEntityName], tmpContext);
		tmpStrategies[pEntityName] = tmpCompiled.Strategy;
		tmpWarnings.push(...tmpCompiled.Warnings);
	});

	return { Strategies: tmpStrategies, Warnings: tmpWarnings };
}

module.exports = {
	compile,
	compileEntity,
	joinFieldName,
	abbreviationFor,
	valueTemplate,
	ownValueTemplate,
};

},{}],521:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');

const libGUIDComposer = require('../guid/Meadow-Integration-GUIDComposer.js');

/*
		// Comprehension Parameters
		// This can be *either* a mapping file, in the following format, or a set of parameters listed below.  The mapping file lets you map columns way easier!
		/* Comprehension Mapping File (for the file `/debug/testdata/airports.csv` in this repository):
		{
			"Entity": "Airport",
			"GUIDTemplate": "Airport-{~D:iata~}",
			"Mappings":
			{
				"Code": "{~D:iata~}",
				"Name": "{~D:name~}",
				"Description": "{~D:name~} airport in {~D:city~} auto-ingested from CSV file.",
				"City": "{~D:city~}",
				"State": "{~D:state~}",
				"Country": "{~D:country~}",
				"Latitude": "{~D:lat~}",
				"Longitude": "{~D:long~}"
			}
		}
*/

class MeadowIntegrationTabularTransform extends libFableService
{
	constructor(pFable, pManifest, pServiceHash)
	{
		super(pFable, pManifest, pServiceHash);
	}

	newMappingOutcomeObject()
	{
		const tmpMappingOutcome = (
			{
				Comprehension: {},            // The comprehension we are generating
				ExistingComprehension: false, // The comprehension we put the generated comprehension into

				// The three part configuration for this command, which is unioned together in this order to get the final executing configuration
				ImplicitConfiguration: false,  // Any configuration implicitly gathered from the first record
				ExplicitConfiguration: false,  // Any configuration that is explicit from a configuration file
				UserConfiguration: {},         // Any user passed-in overrides (e.g. a different entity name)
				// The container for the final merged execution configuration
				Configuration: false,

				ParsedRowCount: 0,
				BadRecords: []
			});

		return tmpMappingOutcome;
	}

	onBeforeInitializeMappingOutcomeObject(pMappingOutcomeObject)
	{

	}
	initializeMappingOutcomeObject(pMappingOutcomeObject)
	{
		const tmpMappingOutcome = (typeof(pMappingOutcomeObject) === 'object') ? pMappingOutcomeObject : this.newMappingOutcomeObject();

		if (tmpMappingOutcome.TimeInitialized)
		{
			return tmpMappingOutcome;
		}
		tmpMappingOutcome.TimeInitialized = +(new Date());

		this.onBeforeInitializeMappingOutcomeObject(tmpMappingOutcome);

		if (!tmpMappingOutcome.ImplicitConfiguration)
		{
			tmpMappingOutcome.ImplicitConfiguration = this.generateMappingConfigurationPrototype(`Unknown-${this.fable.getUUID()}`, tmpIncomingRecord);
		}

		if ((!tmpMappingOutcome.ExplicitConfiguration) || (typeof (tmpMappingOutcome.ExplicitConfiguration) != 'object'))
		{
			// Just use the implicit configuration
			//this.fable.log.info(`Using implicit configuration for ${tmpMappingOutcome.Entity} comprehension; no valid explicit configuration available.`);
			tmpMappingOutcome.Configuration = Object.assign({}, tmpMappingOutcome.ImplicitConfiguration, tmpMappingOutcome.UserConfiguration);
		}
		else
		{
			//this.fable.log.info(`Using explicit configuration for ${tmpMappingOutcome.Entity} comprehension.`);
			tmpMappingOutcome.Configuration = Object.assign({}, tmpMappingOutcome.ImplicitConfiguration, tmpMappingOutcome.ExplicitConfiguration, tmpMappingOutcome.UserConfiguration);
		}

		if (!('GUIDName' in tmpMappingOutcome.Configuration))
		{
			tmpMappingOutcome.Configuration.GUIDName = `GUID${tmpMappingOutcome.Configuration.Entity}`;
		}

		if (!(tmpMappingOutcome.Configuration.Entity in tmpMappingOutcome.Comprehension))
		{
			tmpMappingOutcome.Comprehension[tmpMappingOutcome.Configuration.Entity] = {};
		}

		this.onAfterInitializeMappingOutcomeObject(tmpMappingOutcome);

		return tmpMappingOutcome;
	}
	onAfterInitializeMappingOutcomeObject(pMappingOutcomeObject)
	{

	}

	generateMappingConfigurationPrototype(pRepresentativeString, pRecord)
	{
		let tmpMapping = {};

		// Generate the entity name from the filename
		// For instance "my favorite cats.csv" would become "MyFavoriteCats"
		// TODO: Upstream of this do libPath.basename(pRepresentativeString, libPath.extname( with the filename to generate this if it comes from a file
		tmpMapping.Entity = this.fable.DataFormat.cleanNonAlphaCharacters(this.fable.DataFormat.capitalizeEachWord(pRepresentativeString));

		let tmpKeys = Object.keys(pRecord);
		if (tmpKeys.length < 1)
		{
			tmpMapping.GUIDTemplate = ``;
		}
		else
		{
			tmpMapping.GUIDTemplate = `GUID-${tmpMapping.Entity}-{~Data:Record.${tmpKeys[0]}~}`;
		}

		tmpMapping.Mappings = {};

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpMapping.Mappings[tmpKeys[i]] = `{~Data:Record.${tmpKeys[i]}~}`;
		}

		return tmpMapping;
	}

	createRecordFromMapping(pRecord, pMapping, pRecordPrototype)
	{
		let tmpRecord = ((typeof(pRecordPrototype) == 'object') && (pRecordPrototype != null)) ? JSON.parse(JSON.stringify(pRecordPrototype)) : {};

		// Opt-in context-aware GUID strategy: compose the entity's own GUID + its foreign-key GUID/ID
		// fields from a structured spec (length-safe + deterministic). Falls back to the flat GUIDTemplate
		// when no strategy is attached, so every existing mapping behaves exactly as before.
		if (pMapping.GUIDStrategy)
		{
			this._applyGUIDStrategy(tmpRecord, pMapping.GUIDStrategy, pRecord);
		}
		else
		{
			tmpRecord[pMapping.GUIDName] = this.fable.parseTemplate(pMapping.GUIDTemplate, pRecord);
		}

		let tmpKeys = Object.keys(pMapping.Mappings);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpMappingKey = tmpKeys[i];
			if (pMapping.ManyfestAddresses)
			{
				this.fable.manifest.setValueAtAddress(tmpRecord, tmpMappingKey, this.fable.parseTemplate(pMapping.Mappings[tmpMappingKey], pRecord));
			}
			else
			{
				tmpRecord[tmpMappingKey] = this.fable.parseTemplate(pMapping.Mappings[tmpMappingKey], pRecord);
			}
		}

		return tmpRecord;
	}

	/**
	 * Resolve a GUID compose spec's segment value-templates against the row, then run the deterministic
	 * length-safe composer. The compiler (Meadow-Integration-GUIDStrategy) produced the spec.
	 * @param {Record<string, any>} pComposeSpec @param {Record<string, any>} pRecord
	 * @returns {string}
	 */
	composeGUIDFromSpec(pComposeSpec, pRecord)
	{
		let tmpSegments = (Array.isArray(pComposeSpec.segments) ? pComposeSpec.segments : []).map((pSegment) =>
		{
			return {
				abbrev: pSegment.abbrev,
				value: pSegment.valueTemplate ? this.fable.parseTemplate(pSegment.valueTemplate, pRecord) : '',
			};
		});
		return libGUIDComposer.composeGUID(
			{
				prefix: pComposeSpec.prefix,
				separator: pComposeSpec.separator,
				maxLength: pComposeSpec.maxLength,
				hashLength: pComposeSpec.hashLength,
				segments: tmpSegments,
			});
	}

	/**
	 * Stamp an entity's own GUID + its foreign-key fields onto the record from a compiled GUID strategy.
	 * Own / each join is one of: prefixed (Compose spec) or raw/rawid (a resolved source-column template).
	 * @param {Record<string, any>} pTargetRecord @param {Record<string, any>} pStrategy @param {Record<string, any>} pRecord
	 */
	_applyGUIDStrategy(pTargetRecord, pStrategy, pRecord)
	{
		let tmpOwn = pStrategy.Own || {};
		if (tmpOwn.FieldName)
		{
			pTargetRecord[tmpOwn.FieldName] = tmpOwn.Compose
				? this.composeGUIDFromSpec(tmpOwn.Compose, pRecord)
				: (tmpOwn.ValueTemplate ? this.fable.parseTemplate(tmpOwn.ValueTemplate, pRecord) : '');
		}
		let tmpJoins = Array.isArray(pStrategy.Joins) ? pStrategy.Joins : [];
		for (let i = 0; i < tmpJoins.length; i++)
		{
			let tmpJoin = tmpJoins[i];
			if (!tmpJoin || !tmpJoin.FieldName) { continue; }
			pTargetRecord[tmpJoin.FieldName] = tmpJoin.Compose
				? this.composeGUIDFromSpec(tmpJoin.Compose, pRecord)
				: (tmpJoin.ValueTemplate ? this.fable.parseTemplate(tmpJoin.ValueTemplate, pRecord) : '');
		}
	}

	addRecordToComprehension(pIncomingRecord, pMappingOutcome, pNewRecordPrototype, pGUIDUniquenessString)
	{
		let tmpNewRecordPrototype = (typeof(pNewRecordPrototype) == 'object') ? pNewRecordPrototype : {};
		let tmpIncomingRecord = JSON.parse(JSON.stringify(pIncomingRecord));

		if (pGUIDUniquenessString && (typeof (pGUIDUniquenessString) == 'string'))
		{
			tmpIncomingRecord['_GUIDUniqueness'] = pGUIDUniquenessString;
		}
		
		let tmpNewRecord = this.createRecordFromMapping(tmpIncomingRecord, pMappingOutcome.Configuration, tmpNewRecordPrototype);

		if (typeof (tmpNewRecord) != 'object')
		{
			this.fable.log.warn(`No valid record generated from incoming transformation operation.  Skipping.`);
			pMappingOutcome.BadRecords.push(tmpIncomingRecord);
		}
		else if (!tmpNewRecord[pMappingOutcome.Configuration.GUIDName] || tmpNewRecord[pMappingOutcome.Configuration.GUIDName] == '')
		{
			this.fable.log.warn(`No valid GUID found for record.  Skipping.`);
			pMappingOutcome.BadRecords.push(tmpIncomingRecord);
		}
		else
		{
			if (tmpNewRecord[pMappingOutcome.Configuration.GUIDName] in pMappingOutcome.Comprehension[pMappingOutcome.Configuration.Entity])
			{
				// Already been ingested once by this parse!
				this.fable.log.warn(`Duplicate record found for ${pMappingOutcome.Configuration.GUIDName}->[${tmpNewRecord[pMappingOutcome.Configuration.GUIDName]}].  Merging with previous record.`);
				pMappingOutcome.Comprehension[pMappingOutcome.Configuration.Entity][tmpNewRecord[pMappingOutcome.Configuration.GUIDName]] = Object.assign({}, pMappingOutcome.Comprehension[pMappingOutcome.Configuration.Entity][tmpNewRecord[pMappingOutcome.Configuration.GUIDName]], tmpNewRecord);
			}
			else if (pMappingOutcome.ExistingComprehension && (pMappingOutcome.Configuration.Entity in pMappingOutcome.ExistingComprehension) && (tmpNewRecord[pMappingOutcome.Configuration.GUIDName] in pMappingOutcome.ExistingComprehension[pMappingOutcome.Configuration.Entity]))
			{
				// Pull it in from the old comprehension
				pMappingOutcome.Comprehension[pMappingOutcome.Configuration.Entity][tmpNewRecord[pMappingOutcome.Configuration.GUIDName]] = Object.assign({}, pMappingOutcome.ExistingComprehension[pMappingOutcome.Configuration.Entity][tmpNewRecord[pMappingOutcome.Configuration.GUIDName]], tmpNewRecord);
			}
			else
			{
				// Net new record
				pMappingOutcome.Comprehension[pMappingOutcome.Configuration.Entity][tmpNewRecord[pMappingOutcome.Configuration.GUIDName]] = tmpNewRecord;
			}
		}
	}

	transformRecord(tmpIncomingRecord, pMappingOutcomeObject)
	{
		const tmpMappingOutcome = this.initializeMappingOutcomeObject(pMappingOutcomeObject);

		tmpMappingOutcome.ParsedRowCount++;

		// Generate a one-time-use solution object, which aids in the solver and templating
		let tmpMappingRecordSolution = (
			{
				IncomingRecord: tmpIncomingRecord,
				MappingConfiguration: tmpMappingOutcome.Configuration,
				MappingOutcome: tmpMappingOutcome,

				RowIndex: tmpMappingOutcome.ParsedRowCount,

				NewRecordsGUIDUniqueness: [],
				NewRecordPrototype: {},

				Fable: this.fable,
				Pict: this.fable,
				AppData: this.fable.AppData
			});

		if (tmpMappingOutcome.Configuration.Solvers && Array.isArray(tmpMappingOutcome.Configuration.Solvers))
		{
			// Solvers have IncomingRecord, RecordGenerationRules, NewRecordPrototype
			let tmpSolverResultsObject = {};
			for (let i = 0; i < tmpMappingOutcome.Configuration.Solvers.length; i++)
			{
				let tmpSolver = tmpMappingOutcome.Configuration.Solvers[i];
				this.fable.ExpressionParser.solve(tmpSolver, tmpMappingRecordSolution, tmpSolverResultsObject, this.fable.manifest, tmpMappingRecordSolution);
			}
		}

		if (tmpMappingOutcome.Configuration.MultipleGUIDUniqueness && tmpMappingRecordSolution.NewRecordsGUIDUniqueness.length > 0)
		{
			// Run create record for each of the uniqueness guid entries
			for (let i = 0; i < tmpMappingRecordSolution.NewRecordsGUIDUniqueness.length; i++)
			{
				this.addRecordToComprehension(tmpIncomingRecord, tmpMappingOutcome, tmpMappingRecordSolution.NewRecordPrototype, tmpMappingRecordSolution.NewRecordsGUIDUniqueness[i]);
			}
		}
		else if (!tmpMappingOutcome.Configuration.MultipleGUIDUniqueness)
		{
			this.addRecordToComprehension(tmpIncomingRecord, tmpMappingOutcome, tmpMappingRecordSolution.NewRecordPrototype);
		}
		else
		{
			this.fable.log.error(`No valid GUID uniqueness entries generated for ${tmpMappingOutcome.Entity} incoming record at row ${tmpMappingOutcome.ParsedRowCount}; skipping record.`);
		}
	}
}

module.exports = MeadowIntegrationTabularTransform;
},{"../guid/Meadow-Integration-GUIDComposer.js":519,"fable-serviceproviderbase":438}],522:[function(require,module,exports){
var bn = require('bn.js');
var brorand = require('brorand');

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};

},{"bn.js":523,"brorand":334}],523:[function(require,module,exports){
arguments[4][325][0].apply(exports,arguments)
},{"buffer":335,"dup":325}],524:[function(require,module,exports){
module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

},{}],525:[function(require,module,exports){
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};

},{}],526:[function(require,module,exports){
'use strict';

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = require('./isArguments'); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

},{"./isArguments":528}],527:[function(require,module,exports){
'use strict';

var slice = Array.prototype.slice;
var isArgs = require('./isArguments');

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : require('./implementation');

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

},{"./implementation":526,"./isArguments":528}],528:[function(require,module,exports){
'use strict';

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

},{}],529:[function(require,module,exports){
'use strict';

// modified from https://github.com/es-shims/es6-shim
var objectKeys = require('object-keys');
var hasSymbols = require('has-symbols/shams')();
var callBound = require('call-bound');
var $Object = require('es-object-atoms');
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = $Object(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = $Object(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys(from);
		var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};

},{"call-bound":373,"es-object-atoms":434,"has-symbols/shams":451,"object-keys":527}],530:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};

},{"./implementation":529}],531:[function(require,module,exports){
exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};

},{}],532:[function(require,module,exports){
module.exports={"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
}
},{}],533:[function(require,module,exports){
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.

'use strict';

var asn1 = require('asn1.js');

exports.certificate = require('./certificate');

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('modulus')['int'](),
		this.key('publicExponent')['int'](),
		this.key('privateExponent')['int'](),
		this.key('prime1')['int'](),
		this.key('prime2')['int'](),
		this.key('exponent1')['int'](),
		this.key('exponent2')['int'](),
		this.key('coefficient')['int']()
	);
});
exports.RSAPrivateKey = RSAPrivateKey;

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
	this.seq().obj(
		this.key('modulus')['int'](),
		this.key('publicExponent')['int']()
	);
});
exports.RSAPublicKey = RSAPublicKey;

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('none').null_().optional(),
		this.key('curve').objid().optional(),
		this.key('params').seq().obj(
			this.key('p')['int'](),
			this.key('q')['int'](),
			this.key('g')['int']()
		).optional()
	);
});

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});
exports.PublicKey = PublicKey;

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPrivateKey').octstr()
	);
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').seq().obj(
			this.key('id').objid(),
			this.key('decrypt').seq().obj(
				this.key('kde').seq().obj(
					this.key('id').objid(),
					this.key('kdeparams').seq().obj(
						this.key('salt').octstr(),
						this.key('iters')['int']()
					)
				),
				this.key('cipher').seq().obj(
					this.key('algo').objid(),
					this.key('iv').octstr()
				)
			)
		),
		this.key('subjectPrivateKey').octstr()
	);
});

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('p')['int'](),
		this.key('q')['int'](),
		this.key('g')['int'](),
		this.key('pub_key')['int'](),
		this.key('priv_key')['int']()
	);
});
exports.DSAPrivateKey = DSAPrivateKey;

exports.DSAparam = asn1.define('DSAparam', function () {
	this['int']();
});

var ECParameters = asn1.define('ECParameters', function () {
	this.choice({
		namedCurve: this.objid()
	});
});

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('privateKey').octstr(),
		this.key('parameters').optional().explicit(0).use(ECParameters),
		this.key('publicKey').optional().explicit(1).bitstr()
	);
});
exports.ECPrivateKey = ECPrivateKey;

exports.signature = asn1.define('signature', function () {
	this.seq().obj(
		this.key('r')['int'](),
		this.key('s')['int']()
	);
});

},{"./certificate":534,"asn1.js":311}],534:[function(require,module,exports){
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen

'use strict';

var asn = require('asn1.js');

var Time = asn.define('Time', function () {
	this.choice({
		utcTime: this.utctime(),
		generalTime: this.gentime()
	});
});

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
	this.seq().obj(
		this.key('type').objid(),
		this.key('value').any()
	);
});

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('parameters').optional(),
		this.key('curve').objid().optional()
	);
});

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
	this.setof(AttributeTypeValue);
});

var RDNSequence = asn.define('RDNSequence', function () {
	this.seqof(RelativeDistinguishedName);
});

var Name = asn.define('Name', function () {
	this.choice({
		rdnSequence: this.use(RDNSequence)
	});
});

var Validity = asn.define('Validity', function () {
	this.seq().obj(
		this.key('notBefore').use(Time),
		this.key('notAfter').use(Time)
	);
});

var Extension = asn.define('Extension', function () {
	this.seq().obj(
		this.key('extnID').objid(),
		this.key('critical').bool().def(false),
		this.key('extnValue').octstr()
	);
});

var TBSCertificate = asn.define('TBSCertificate', function () {
	this.seq().obj(
		this.key('version').explicit(0)['int']().optional(),
		this.key('serialNumber')['int'](),
		this.key('signature').use(AlgorithmIdentifier),
		this.key('issuer').use(Name),
		this.key('validity').use(Validity),
		this.key('subject').use(Name),
		this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
		this.key('issuerUniqueID').implicit(1).bitstr().optional(),
		this.key('subjectUniqueID').implicit(2).bitstr().optional(),
		this.key('extensions').explicit(3).seqof(Extension).optional()
	);
});

var X509Certificate = asn.define('X509Certificate', function () {
	this.seq().obj(
		this.key('tbsCertificate').use(TBSCertificate),
		this.key('signatureAlgorithm').use(AlgorithmIdentifier),
		this.key('signatureValue').bitstr()
	);
});

module.exports = X509Certificate;

},{"asn1.js":311}],535:[function(require,module,exports){
'use strict';

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = require('evp_bytestokey');
var ciphers = require('browserify-aes');
var Buffer = require('safe-buffer').Buffer;
module.exports = function (okey, password) {
	var key = okey.toString();
	var match = key.match(findProc);
	var decrypted;
	if (!match) {
		var match2 = key.match(fullRegex);
		decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
	} else {
		var suite = 'aes' + match[1];
		var iv = Buffer.from(match[2], 'hex');
		var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
		var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
		var out = [];
		var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
		out.push(cipher.update(cipherText));
		out.push(cipher['final']());
		decrypted = Buffer.concat(out);
	}
	var tag = key.match(startRegex)[1];
	return {
		tag: tag,
		data: decrypted
	};
};

},{"browserify-aes":338,"evp_bytestokey":436,"safe-buffer":788}],536:[function(require,module,exports){
'use strict';

var asn1 = require('./asn1');
var aesid = require('./aesid.json');
var fixProc = require('./fixProc');
var ciphers = require('browserify-aes');
var pbkdf2Sync = require('pbkdf2').pbkdf2Sync;
var Buffer = require('safe-buffer').Buffer;

// the iteration count comes from unauthenticated PKCS#8 parameters, so an
// attacker-supplied key could otherwise force unbounded PBKDF2 work before
// decryption even fails (GHSA-4x79-9w89-pmm5); cap it like other crypto libs.
var MAX_ITERATIONS = 10e6;

function decrypt(data, password) {
	var salt = data.algorithm.decrypt.kde.kdeparams.salt;
	var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
	if (iters !== iters || iters < 1 || iters > MAX_ITERATIONS) {
		throw new RangeError('iteration count must be an integer between 1 and ' + MAX_ITERATIONS + ', got: ' + iters);
	}
	var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
	var iv = data.algorithm.decrypt.cipher.iv;
	var cipherText = data.subjectPrivateKey;
	var keylen = parseInt(algo.split('-')[1], 10) / 8;
	var key = pbkdf2Sync(password, salt, iters, keylen, 'sha1');
	var cipher = ciphers.createDecipheriv(algo, key, iv);
	var out = [];
	out.push(cipher.update(cipherText));
	out.push(cipher['final']());
	return Buffer.concat(out);
}

function parseKeys(buffer) {
	var password;
	if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
		password = buffer.passphrase;
		buffer = buffer.key;
	}
	if (typeof buffer === 'string') {
		buffer = Buffer.from(buffer);
	}

	var stripped = fixProc(buffer, password);

	var type = stripped.tag;
	var data = stripped.data;
	var subtype, ndata;
	switch (type) {
		case 'CERTIFICATE':
			ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
			// falls through
		case 'PUBLIC KEY':
			if (!ndata) {
				ndata = asn1.PublicKey.decode(data, 'der');
			}
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
				case '1.2.840.10045.2.1':
					ndata.subjectPrivateKey = ndata.subjectPublicKey;
					return {
						type: 'ec',
						data: ndata
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
					return {
						type: 'dsa',
						data: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'ENCRYPTED PRIVATE KEY':
			data = asn1.EncryptedPrivateKey.decode(data, 'der');
			data = decrypt(data, password);
			// falls through
		case 'PRIVATE KEY':
			ndata = asn1.PrivateKey.decode(data, 'der');
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
				case '1.2.840.10045.2.1':
					return {
						curve: ndata.algorithm.curve,
						privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
					return {
						type: 'dsa',
						params: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'RSA PUBLIC KEY':
			return asn1.RSAPublicKey.decode(data, 'der');
		case 'RSA PRIVATE KEY':
			return asn1.RSAPrivateKey.decode(data, 'der');
		case 'DSA PRIVATE KEY':
			return {
				type: 'dsa',
				params: asn1.DSAPrivateKey.decode(data, 'der')
			};
		case 'EC PRIVATE KEY':
			data = asn1.ECPrivateKey.decode(data, 'der');
			return {
				curve: data.parameters.value,
				privateKey: data.privateKey
			};
		default: throw new Error('unknown key type ' + type);
	}
}
parseKeys.signature = asn1.signature;

module.exports = parseKeys;

},{"./aesid.json":532,"./asn1":533,"./fixProc":535,"browserify-aes":338,"pbkdf2":538,"safe-buffer":788}],537:[function(require,module,exports){
(function (process){(function (){
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;

}).call(this)}).call(this,require('_process'))

},{"_process":736}],538:[function(require,module,exports){
'use strict';

exports.pbkdf2 = require('./lib/async');
exports.pbkdf2Sync = require('./lib/sync');

},{"./lib/async":539,"./lib/sync":542}],539:[function(require,module,exports){
(function (global){(function (){
'use strict';

var Buffer = require('safe-buffer').Buffer;

var checkParameters = require('./precondition');
var defaultEncoding = require('./default-encoding');
var sync = require('./sync');
var toBuffer = require('./to-buffer');

var ZERO_BUF;
var subtle = global.crypto && global.crypto.subtle;
var toBrowser = {
	sha: 'SHA-1',
	'sha-1': 'SHA-1',
	sha1: 'SHA-1',
	sha256: 'SHA-256',
	'sha-256': 'SHA-256',
	sha384: 'SHA-384',
	'sha-384': 'SHA-384',
	'sha-512': 'SHA-512',
	sha512: 'SHA-512'
};
var checks = [];
var nextTick;
function getNextTick() {
	if (nextTick) {
		return nextTick;
	}
	if (global.process && global.process.nextTick) {
		nextTick = global.process.nextTick;
	} else if (global.queueMicrotask) {
		nextTick = global.queueMicrotask;
	} else if (global.setImmediate) {
		nextTick = global.setImmediate;
	} else {
		nextTick = global.setTimeout;
	}
	return nextTick;
}
function browserPbkdf2(password, salt, iterations, length, algo) {
	return subtle.importKey('raw', password, { name: 'PBKDF2' }, false, ['deriveBits']).then(function (key) {
		return subtle.deriveBits({
			name: 'PBKDF2',
			salt: salt,
			iterations: iterations,
			hash: {
				name: algo
			}
		}, key, length << 3);
	}).then(function (res) {
		return Buffer.from(res);
	});
}
function checkNative(algo) {
	if (global.process && !global.process.browser) {
		return Promise.resolve(false);
	}
	if (!subtle || !subtle.importKey || !subtle.deriveBits) {
		return Promise.resolve(false);
	}
	if (checks[algo] !== undefined) {
		return checks[algo];
	}
	ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
	var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
		.then(
			function () { return true; },
			function () { return false; }
		);
	checks[algo] = prom;
	return prom;
}

function resolvePromise(promise, callback) {
	promise.then(function (out) {
		getNextTick()(function () {
			callback(null, out);
		});
	}, function (e) {
		getNextTick()(function () {
			callback(e);
		});
	});
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
	if (typeof digest === 'function') {
		callback = digest;
		digest = undefined;
	}

	keylen = checkParameters(iterations, keylen);
	password = toBuffer(password, defaultEncoding, 'Password');
	salt = toBuffer(salt, defaultEncoding, 'Salt');
	if (typeof callback !== 'function') {
		throw new Error('No callback provided to pbkdf2');
	}

	digest = digest || 'sha1';
	var algo = toBrowser[digest.toLowerCase()];

	if (!algo || typeof global.Promise !== 'function') {
		getNextTick()(function () {
			var out;
			try {
				out = sync(password, salt, iterations, keylen, digest);
			} catch (e) {
				callback(e);
				return;
			}
			callback(null, out);
		});
		return;
	}

	resolvePromise(checkNative(algo).then(function (resp) {
		if (resp) {
			return browserPbkdf2(password, salt, iterations, keylen, algo);
		}

		return sync(password, salt, iterations, keylen, digest);
	}), callback);
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./default-encoding":540,"./precondition":541,"./sync":542,"./to-buffer":543,"safe-buffer":788}],540:[function(require,module,exports){
(function (process,global){(function (){
'use strict';

var defaultEncoding;
/* istanbul ignore next */
if (global.process && global.process.browser) {
	defaultEncoding = 'utf-8';
} else if (global.process && global.process.version) {
	var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);

	defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else {
	defaultEncoding = 'utf-8';
}
module.exports = defaultEncoding;

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":736}],541:[function(require,module,exports){
'use strict';

var $isFinite = isFinite;
var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs

module.exports = function (iterations, keylen) {
	if (typeof iterations !== 'number') {
		throw new TypeError('Iterations not a number');
	}

	if (iterations < 0 || !$isFinite(iterations)) {
		throw new TypeError('Bad iterations');
	}

	if (typeof keylen !== 'number') {
		throw new TypeError('Key length not a number');
	}

	if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
		throw new TypeError('Bad key length');
	}

	// `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
	// the native binding requires a true Int32; `-0` is held as a double and
	// aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
	return keylen + 0;
};

},{}],542:[function(require,module,exports){
'use strict';

var md5 = require('create-hash/md5');
var RIPEMD160 = require('ripemd160');
var sha = require('sha.js');
var Buffer = require('safe-buffer').Buffer;

var checkParameters = require('./precondition');
var defaultEncoding = require('./default-encoding');
var toBuffer = require('./to-buffer');

var ZEROS = Buffer.alloc(128);
var sizes = {
	__proto__: null,
	md5: 16,
	sha1: 20,
	sha224: 28,
	sha256: 32,
	sha384: 48,
	sha512: 64,
	'sha512-256': 32,
	ripemd160: 20,
	rmd160: 20
};

var mapping = {
	__proto__: null,
	'sha-1': 'sha1',
	'sha-224': 'sha224',
	'sha-256': 'sha256',
	'sha-384': 'sha384',
	'sha-512': 'sha512',
	'ripemd-160': 'ripemd160'
};

function rmd160Func(data) {
	return new RIPEMD160().update(data).digest();
}

function getDigest(alg) {
	function shaFunc(data) {
		return sha(alg).update(data).digest();
	}

	if (alg === 'rmd160' || alg === 'ripemd160') {
		return rmd160Func;
	}
	if (alg === 'md5') {
		return md5;
	}
	return shaFunc;
}

function Hmac(alg, key, saltLen) {
	var hash = getDigest(alg);
	var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;

	if (key.length > blocksize) {
		key = hash(key);
	} else if (key.length < blocksize) {
		key = Buffer.concat([key, ZEROS], blocksize);
	}

	var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
	var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
	for (var i = 0; i < blocksize; i++) {
		ipad[i] = key[i] ^ 0x36;
		opad[i] = key[i] ^ 0x5C;
	}

	var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
	ipad.copy(ipad1, 0, 0, blocksize);
	this.ipad1 = ipad1;
	this.ipad2 = ipad;
	this.opad = opad;
	this.alg = alg;
	this.blocksize = blocksize;
	this.hash = hash;
	this.size = sizes[alg];
}

Hmac.prototype.run = function (data, ipad) {
	data.copy(ipad, this.blocksize);
	var h = this.hash(ipad);
	h.copy(this.opad, this.blocksize);
	return this.hash(this.opad);
};

function pbkdf2(password, salt, iterations, keylen, digest) {
	keylen = checkParameters(iterations, keylen);
	password = toBuffer(password, defaultEncoding, 'Password');
	salt = toBuffer(salt, defaultEncoding, 'Salt');

	var lowerDigest = (digest || 'sha1').toLowerCase();
	var mappedDigest = mapping[lowerDigest] || lowerDigest;
	var size = sizes[mappedDigest];
	if (typeof size !== 'number' || !size) {
		throw new TypeError('Digest algorithm not supported: ' + digest);
	}

	var hmac = new Hmac(mappedDigest, password, salt.length);

	var DK = Buffer.allocUnsafe(keylen);
	var block1 = Buffer.allocUnsafe(salt.length + 4);
	salt.copy(block1, 0, 0, salt.length);

	var destPos = 0;
	var hLen = size;
	var l = Math.ceil(keylen / hLen);

	for (var i = 1; i <= l; i++) {
		block1.writeUInt32BE(i, salt.length);

		var T = hmac.run(block1, hmac.ipad1);
		var U = T;

		for (var j = 1; j < iterations; j++) {
			U = hmac.run(U, hmac.ipad2);
			for (var k = 0; k < hLen; k++) {
				T[k] ^= U[k];
			}
		}

		T.copy(DK, destPos);
		destPos += hLen;
	}

	return DK;
}

module.exports = pbkdf2;

},{"./default-encoding":540,"./precondition":541,"./to-buffer":543,"create-hash/md5":390,"ripemd160":785,"safe-buffer":788,"sha.js":792}],543:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('to-buffer');

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = useUint8Array && typeof ArrayBuffer !== 'undefined';
var isView = useArrayBuffer && ArrayBuffer.isView;

module.exports = function (thing, encoding, name) {
	if (
		typeof thing === 'string'
		|| Buffer.isBuffer(thing)
		|| (useUint8Array && thing instanceof Uint8Array)
		|| (isView && isView(thing))
	) {
		return toBuffer(thing, encoding);
	}
	throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

},{"safe-buffer":788,"to-buffer":816}],544:[function(require,module,exports){
module.exports={
    "name": "pict-application",
    "version": "1.0.34",
    "description": "Application base class for a pict view-based application",
    "main": "source/Pict-Application.js",
    "scripts": {
        "test": "npx quack test",
        "start": "node source/Pict-Application.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
        "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
        "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
        "tests": "npx quack test -g",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Application.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-application.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-application/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-application#readme",
    "devDependencies": {
        "@eslint/js": "^9.28.0",
        "browser-env": "^3.3.0",
        "eslint": "^9.28.0",
        "pict": "^1.0.348",
        "pict-docuserve": "^0.1.5",
        "pict-provider": "^1.0.10",
        "pict-view": "^1.0.66",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],545:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":544,"fable-serviceproviderbase":438}],546:[function(require,module,exports){
// The container for all the pict-dataexplorer related code.
//
// pict-dataexplorer is a config-driven, hierarchical ("folders") data explorer: browse a relational
// dataset as an expandable tree of records and their child collections — expand a record to see its
// 5 Users, 10 Media, 3 Documents — each expandable, each record carrying a preview-card popout. Lists
// resolve from meadow-endpoints (Lite / paginated / filtered / two-hop join) or a host-supplied
// custom resolver. Preview cards are a soft dependency on pict-section-recordset's RecordSetCardManager.

// The provider (primary API surface — registers the view + the resolution DataProvider, and exposes
// createExplorer() / registerCards()).
const PictProviderDataExplorer = require('./providers/Pict-Provider-DataExplorer.js');

// The resolution layer (meadow list/count/lite/join, or a custom Resolver).
const PictDataExplorerDataProvider = require('./providers/Pict-DataExplorer-DataProvider.js');

// The folders view (the expandable record/folder tree).
const PictViewDataExplorer = require('./views/PictView-DataExplorer.js');

module.exports = PictProviderDataExplorer;

module.exports.PictProviderDataExplorer = PictProviderDataExplorer;
module.exports.PictDataExplorerDataProvider = PictDataExplorerDataProvider;
module.exports.DataProvider = PictDataExplorerDataProvider;
module.exports.PictViewDataExplorer = PictViewDataExplorer;

module.exports.default_configuration = PictProviderDataExplorer.default_configuration;

},{"./providers/Pict-DataExplorer-DataProvider.js":547,"./providers/Pict-Provider-DataExplorer.js":548,"./views/PictView-DataExplorer.js":549}],547:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-DataExplorer-DataProvider',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/**
 * Resolves the lists, counts and child collections that the data explorer browses.
 *
 * Stateless w.r.t. the explorer config: every method takes the *resolved* entity config object(s) it
 * needs, so a single provider instance serves any number of explorers. The default implementation talks
 * to meadow-endpoints through the host's `pict.EntityProvider` (paginated + LiteExtended + FilteredTo +
 * Count); a child relationship can instead carry a `Resolver` function to source from anything (a data
 * lake, a cursor API, an in-memory set).
 *
 * Entity config shape (the fields this provider reads):
 *   { Entity, IDField, Lite?:[cols], URLPrefix?, Filter?:'<FoxHound stanza>', Sort?:'<field>' }
 * Child relationship shape:
 *   { Entity, Relationship: {Type:'Filter', Key} | {Type:'Join', JoinEntity, ParentKey, ChildKey},
 *     Filter?, Sort?, Resolver?:fn }
 *
 * Callback contracts mirror EntityProvider: list → `(err, recordsArray)`, count → `(err, number)`. The
 * child methods add a third `meta` arg: `(err, recordsArray, { hasMore })`.
 */
class PictDataExplorerDataProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/** @return {any} the host EntityProvider (resolved lazily so test stubs can replace it). */
	get entityProvider()
	{
		return this.pict.EntityProvider;
	}

	/**
	 * Fetch one page of a list, Lite-projected when the entity declares `Lite` columns.
	 * @param {Record<string, any>} pEntityConfig
	 * @param {string} pFilterExpression - a FoxHound filter stanza (or '' for none).
	 * @param {number} pBegin
	 * @param {number} pCount
	 * @param {(pError?: Error, pRecords?: Array<any>) => void} fCallback
	 */
	resolveList(pEntityConfig, pFilterExpression, pBegin, pCount, fCallback)
	{
		// Entity-level custom source: a host can resolve an entity's list from anything (an in-memory set,
		// a data lake, a cursor API) by giving the entity a `Resolver` fn. Bypasses meadow entirely.
		if (pEntityConfig && (typeof pEntityConfig.Resolver === 'function'))
		{
			return Promise.resolve(pEntityConfig.Resolver({ begin: pBegin, count: pCount, filterExpression: pFilterExpression }))
				.then((pResult) => fCallback(null, (pResult && Array.isArray(pResult.records)) ? pResult.records : []))
				.catch((pError) => fCallback(pError));
		}

		const tmpFilter = [ this._baseFilter(pEntityConfig, pFilterExpression), this._sortClause(pEntityConfig) ]
			.filter((pPart) => (pPart && pPart.length > 0)).join('~');
		const tmpProjection = this._projection(pEntityConfig);
		return this.entityProvider.getEntitySetPage(
			pEntityConfig.Entity, tmpFilter, pBegin, pCount, fCallback,
			'', pEntityConfig.URLPrefix || '', { Projection: tmpProjection });
	}

	/**
	 * Count the records matching a filter (sort is irrelevant to a count, so it is omitted).
	 * @param {Record<string, any>} pEntityConfig
	 * @param {string} pFilterExpression
	 * @param {(pError?: Error, pCount?: number) => void} fCallback
	 */
	resolveCount(pEntityConfig, pFilterExpression, fCallback)
	{
		if (pEntityConfig && (typeof pEntityConfig.Resolver === 'function'))
		{
			return Promise.resolve(pEntityConfig.Resolver({ CountOnly: true, filterExpression: pFilterExpression }))
				.then((pResult) => fCallback(null, this._resultCount(pResult)))
				.catch((pError) => fCallback(pError));
		}
		const tmpFilter = this._baseFilter(pEntityConfig, pFilterExpression);
		return this.entityProvider.getEntitySetRecordCount(pEntityConfig.Entity, tmpFilter, fCallback, '', pEntityConfig.URLPrefix || '');
	}

	/**
	 * Resolve a page of a parent record's child collection (the `Filter` one-hop, the `Join` two-hop, or a
	 * custom `Resolver`).
	 * @param {Record<string, any>} pParentEntityConfig
	 * @param {Record<string, any>} pParentRecord
	 * @param {Record<string, any>} pChildRelationship
	 * @param {Record<string, any>} pChildEntityConfig
	 * @param {number} pBegin
	 * @param {number} pCount
	 * @param {(pError?: Error, pRecords?: Array<any>, pMeta?: {hasMore:boolean}) => void} fCallback
	 */
	resolveChildren(pParentEntityConfig, pParentRecord, pChildRelationship, pChildEntityConfig, pBegin, pCount, fCallback)
	{
		const tmpParentID = pParentRecord[pParentEntityConfig.IDField];

		if (pChildRelationship && (typeof pChildRelationship.Resolver === 'function'))
		{
			return this._resolveCustom(pChildRelationship, pParentRecord, tmpParentID, pBegin, pCount, fCallback);
		}

		const tmpRelationship = (pChildRelationship && pChildRelationship.Relationship) || {};
		const tmpChildListConfig = this._childListConfig(pChildEntityConfig, pChildRelationship);

		if (tmpRelationship.Type === 'Join')
		{
			return this._resolveJoinChildren(tmpRelationship, tmpChildListConfig, pChildEntityConfig, tmpParentID, pBegin, pCount, fCallback);
		}

		if (tmpRelationship.Type === 'Reference')
		{
			// N:1 "belongs to" — the PARENT carries the FK (`Key`) pointing at one child by its id.
			const tmpReferenceID = pParentRecord[tmpRelationship.Key];
			if (this._isEmptyReference(tmpReferenceID)) { return fCallback(null, [], { hasMore: false }); }
			const tmpReferenceFilter = `FBV~${pChildEntityConfig.IDField}~EQ~${this._encode(tmpReferenceID)}`;
			return this.resolveList(tmpChildListConfig, tmpReferenceFilter, pBegin, pCount, (pError, pRecords) =>
			{
				if (pError) { return fCallback(pError); }
				return fCallback(null, pRecords || [], { hasMore: false });
			});
		}

		// Default: one-hop Filter — the child's `Key` FK column EQ the parent's id.
		const tmpFilter = `FBV~${tmpRelationship.Key}~EQ~${this._encode(tmpParentID)}`;
		return this.resolveList(tmpChildListConfig, tmpFilter, pBegin, pCount, (pError, pRecords) =>
		{
			if (pError) { return fCallback(pError); }
			const tmpRecords = pRecords || [];
			return fCallback(null, tmpRecords, { hasMore: (tmpRecords.length >= pCount) });
		});
	}

	/**
	 * Count a parent record's child collection (the badge number) — counts the join rows for a Join, or the
	 * filtered child rows for a Filter. Custom resolvers may answer via `{ count }`.
	 * @param {(pError?: Error, pCount?: number) => void} fCallback
	 */
	resolveChildCount(pParentEntityConfig, pParentRecord, pChildRelationship, pChildEntityConfig, fCallback)
	{
		const tmpParentID = pParentRecord[pParentEntityConfig.IDField];

		if (pChildRelationship && (typeof pChildRelationship.Resolver === 'function'))
		{
			return Promise.resolve(pChildRelationship.Resolver(pParentRecord, { CountOnly: true, ParentID: tmpParentID }))
				.then((pResult) => fCallback(null, this._resultCount(pResult)))
				.catch((pError) => fCallback(pError));
		}

		const tmpRelationship = (pChildRelationship && pChildRelationship.Relationship) || {};

		if (tmpRelationship.Type === 'Join')
		{
			const tmpJoinConfig = { Entity: tmpRelationship.JoinEntity, URLPrefix: pChildEntityConfig.URLPrefix };
			return this.resolveCount(tmpJoinConfig, `FBV~${tmpRelationship.ParentKey}~EQ~${this._encode(tmpParentID)}`, fCallback);
		}

		if (tmpRelationship.Type === 'Reference')
		{
			// N:1 — the badge is simply 0 or 1 (the FK is set or it is not); no query needed.
			return fCallback(null, this._isEmptyReference(pParentRecord[tmpRelationship.Key]) ? 0 : 1);
		}

		const tmpChildListConfig = this._childListConfig(pChildEntityConfig, pChildRelationship);
		return this.resolveCount(tmpChildListConfig, `FBV~${tmpRelationship.Key}~EQ~${this._encode(tmpParentID)}`, fCallback);
	}

	// --- internals -----------------------------------------------------------------------------------

	/**
	 * The Join two-hop: page the join (projecting only the child-key FK) → dedupe child ids in join order
	 * → one batched `INN` child read → reorder children to the join order. Pagination rides the JOIN.
	 */
	_resolveJoinChildren(pRelationship, pChildListConfig, pChildEntityConfig, pParentID, pBegin, pCount, fCallback)
	{
		const tmpJoinConfig = { Entity: pRelationship.JoinEntity, URLPrefix: pChildListConfig.URLPrefix, Lite: [ pRelationship.ChildKey ] };
		const tmpJoinFilter = `FBV~${pRelationship.ParentKey}~EQ~${this._encode(pParentID)}`;
		return this.resolveList(tmpJoinConfig, tmpJoinFilter, pBegin, pCount, (pJoinError, pJoinRows) =>
		{
			if (pJoinError) { return fCallback(pJoinError); }
			const tmpJoinRows = pJoinRows || [];
			const tmpHasMore = (tmpJoinRows.length >= pCount);

			// Collect + dedupe the child ids, preserving join order.
			const tmpIDs = [];
			const tmpSeen = {};
			for (let i = 0; i < tmpJoinRows.length; i++)
			{
				const tmpID = tmpJoinRows[i][pRelationship.ChildKey];
				if ((tmpID === undefined) || (tmpID === null)) { continue; }
				const tmpKey = String(tmpID);
				if (tmpSeen[tmpKey]) { continue; }
				tmpSeen[tmpKey] = true;
				tmpIDs.push(tmpID);
			}
			if (tmpIDs.length < 1) { return fCallback(null, [], { hasMore: tmpHasMore }); }

			// One batched child read by INN (no sort — we reorder to join order ourselves).
			const tmpChildIDField = pChildEntityConfig.IDField;
			const tmpINNConfig = Object.assign({}, pChildListConfig, { Sort: undefined });
			const tmpChildFilter = `FBL~${tmpChildIDField}~INN~${tmpIDs.map((pID) => this._encode(pID)).join(',')}`;
			return this.resolveList(tmpINNConfig, tmpChildFilter, 0, tmpIDs.length, (pChildError, pChildRecords) =>
			{
				if (pChildError) { return fCallback(pChildError); }
				const tmpByID = {};
				(pChildRecords || []).forEach((pRecord) => { tmpByID[String(pRecord[tmpChildIDField])] = pRecord; });
				const tmpOrdered = tmpIDs.map((pID) => tmpByID[String(pID)]).filter(Boolean);
				return fCallback(null, tmpOrdered, { hasMore: tmpHasMore });
			});
		});
	}

	/** A host-supplied resolver: `Resolver(parentRecord, {begin,count,ParentID}) → {records, hasMore, count?}`. */
	_resolveCustom(pChildRelationship, pParentRecord, pParentID, pBegin, pCount, fCallback)
	{
		return Promise.resolve(pChildRelationship.Resolver(pParentRecord, { begin: pBegin, count: pCount, ParentID: pParentID }))
			.then((pResult) =>
			{
				const tmpRecords = (pResult && Array.isArray(pResult.records)) ? pResult.records : [];
				return fCallback(null, tmpRecords, { hasMore: !!(pResult && pResult.hasMore) });
			})
			.catch((pError) => fCallback(pError));
	}

	/** Overlay the child entity config with the relationship's own base Filter/Sort. */
	_childListConfig(pChildEntityConfig, pChildRelationship)
	{
		const tmpFilter = [ pChildEntityConfig.Filter, pChildRelationship && pChildRelationship.Filter ]
			.filter((pPart) => (pPart && String(pPart).length > 0)).join('~');
		return Object.assign({}, pChildEntityConfig,
			{
				Filter: tmpFilter || undefined,
				Sort: (pChildRelationship && pChildRelationship.Sort) || pChildEntityConfig.Sort,
			});
	}

	/** `[ entity.Filter, filterExpression ]` joined with `~` (no sort). */
	_baseFilter(pEntityConfig, pFilterExpression)
	{
		return [ (pEntityConfig && pEntityConfig.Filter) || '', pFilterExpression || '' ]
			.filter((pPart) => (pPart && String(pPart).length > 0)).join('~');
	}

	_sortClause(pEntityConfig)
	{
		if (!pEntityConfig || !pEntityConfig.Sort) { return ''; }
		const tmpDirection = (String(pEntityConfig.SortDirection || 'ASC').toUpperCase() === 'DESC') ? 'DESC' : 'ASC';
		return `FSF~${pEntityConfig.Sort}~${tmpDirection}~0`;
	}

	_projection(pEntityConfig)
	{
		return (pEntityConfig && Array.isArray(pEntityConfig.Lite) && (pEntityConfig.Lite.length > 0))
			? { Mode: 'LiteExtended', ExtraColumns: pEntityConfig.Lite }
			: undefined;
	}

	_resultCount(pResult)
	{
		if (pResult && (typeof pResult.count === 'number')) { return pResult.count; }
		if (pResult && Array.isArray(pResult.records)) { return pResult.records.length; }
		return 0;
	}

	/** A foreign-key reference is "empty" when unset or the 0/'0' sentinel (no related record). */
	_isEmptyReference(pValue)
	{
		return (pValue === undefined) || (pValue === null) || (pValue === 0) || (pValue === '0');
	}

	/** Encode a filter VALUE (structural `~` stays literal). Numeric ids pass through unchanged. */
	_encode(pValue)
	{
		return encodeURIComponent(pValue);
	}
}

module.exports = PictDataExplorerDataProvider;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-provider":552}],548:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictDataExplorerDataProvider = require('./Pict-DataExplorer-DataProvider.js');
const libPictViewDataExplorer = require('../views/PictView-DataExplorer.js');

/**
 * Derive the text columns a tier's filter box searches (server-side substring LK). ALL non-key Lite
 * columns are searchable so a user can filter by anything they see — a code, a status, a city — not just
 * the title (a numeric column's LK simply never matches, which is harmless). The title / name field leads
 * (it is also the default sort key). The view ORs the clauses in a paren group so the search ANDs cleanly
 * with relationship / base filters.
 * @param {Record<string, any>} pEntity
 * @return {Array<string>}
 */
function deriveSearchFields(pEntity)
{
	const tmpLite = Array.isArray(pEntity.Lite) ? pEntity.Lite : [];
	const tmpSearchable = tmpLite.filter((pColumn) => !(/^(ID|GUID)/.test(pColumn)));
	if (tmpSearchable.length < 1) { return []; }
	const tmpTitle = pEntity.Display && pEntity.Display.Title;
	let tmpPrimary;
	if (tmpTitle && (String(tmpTitle).indexOf('{~') < 0) && (tmpSearchable.indexOf(tmpTitle) >= 0)) { tmpPrimary = tmpTitle; }
	else if (tmpSearchable.indexOf('Name') >= 0) { tmpPrimary = 'Name'; }
	else if (tmpSearchable.indexOf('Title') >= 0) { tmpPrimary = 'Title'; }
	else { tmpPrimary = tmpSearchable[0]; }
	return [ tmpPrimary ].concat(tmpSearchable.filter((pColumn) => pColumn !== tmpPrimary));
}

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-DataExplorer',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/**
 * The pict-dataexplorer provider — the primary API surface. Ensures the resolution DataProvider exists,
 * normalizes an explorer config graph, and creates/reconfigures explorer view instances.
 *
 * Preview cards are a SOFT dependency: when the host has registered pict-section-recordset's
 * `RecordSetCardManager`, explored records render a clickable ⓘ card; otherwise they degrade to plain
 * text. `registerCards()` is a convenience passthrough for hosts that want to declare card layouts here.
 */
class PictProviderDataExplorer extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Create (or reconfigure + reuse) an explorer view instance.
	 * @param {string} pExplorerHash - unique hash/id; renders into `#<pExplorerHash>` unless DestinationAddress given.
	 * @param {Record<string, any>} pConfig - the explorer config graph (Entities / Roots / URLPrefix / PageSize / MaxDepth).
	 * @return {any} the explorer view instance.
	 */
	createExplorer(pExplorerHash, pConfig)
	{
		if (!this.pict.providers['Pict-DataExplorer-DataProvider'])
		{
			this.pict.addProvider('Pict-DataExplorer-DataProvider', libPictDataExplorerDataProvider.default_configuration, libPictDataExplorerDataProvider);
		}

		const tmpConfig = this.normalizeConfig(pConfig);
		const tmpDestination = (pConfig && pConfig.DestinationAddress) || `#${pExplorerHash}`;
		const tmpViewConfig = Object.assign({}, libPictViewDataExplorer.default_configuration,
			{
				ViewIdentifier: pExplorerHash,
				ExplorerHash: pExplorerHash,
				ExplorerConfig: tmpConfig,
				DestinationAddress: tmpDestination,
				DefaultDestinationAddress: tmpDestination,
			});

		if (this.pict.views[pExplorerHash])
		{
			Object.assign(this.pict.views[pExplorerHash].options, tmpViewConfig);
			return this.pict.views[pExplorerHash];
		}
		return this.pict.addView(pExplorerHash, tmpViewConfig, libPictViewDataExplorer);
	}

	/**
	 * Fill in the defaults on an explorer config graph so the view + DataProvider can consume it directly.
	 * @param {Record<string, any>} pConfig
	 * @return {Record<string, any>} the normalized config (a copy; the input is not mutated).
	 */
	normalizeConfig(pConfig)
	{
		const tmpConfig = Object.assign({ URLPrefix: '', PageSize: 25, MaxDepth: 6 }, pConfig || {});
		const tmpEntities = {};
		const tmpSourceEntities = tmpConfig.Entities || {};
		for (const tmpName of Object.keys(tmpSourceEntities))
		{
			const tmpEntity = Object.assign({}, tmpSourceEntities[tmpName]);
			tmpEntity.Entity = tmpEntity.Entity || tmpName;
			tmpEntity.IDField = tmpEntity.IDField || `ID${tmpEntity.Entity}`;
			tmpEntity.GUIDField = tmpEntity.GUIDField || `GUID${tmpEntity.Entity}`;
			tmpEntity.Lite = Array.isArray(tmpEntity.Lite) ? tmpEntity.Lite : [];
			tmpEntity.URLPrefix = tmpEntity.URLPrefix || tmpConfig.URLPrefix || '';
			tmpEntity.Display = tmpEntity.Display || { Title: tmpEntity.IDField };
			tmpEntity.SearchFields = Array.isArray(tmpEntity.SearchFields) ? tmpEntity.SearchFields : deriveSearchFields(tmpEntity);
			tmpEntity.Children = (Array.isArray(tmpEntity.Children) ? tmpEntity.Children : []).map((pChild) =>
				Object.assign({}, pChild,
					{
						Label: pChild.Label || pChild.Entity,
						Resolve: pChild.Resolve || 'lazy',
						PageSize: pChild.PageSize || tmpConfig.PageSize,
					}));
			tmpEntities[tmpName] = tmpEntity;
		}
		tmpConfig.Entities = tmpEntities;
		tmpConfig.Roots = (Array.isArray(tmpConfig.Roots) ? tmpConfig.Roots : []).map((pRoot) =>
			Object.assign({}, pRoot, { Label: pRoot.Label || pRoot.Entity }));
		return tmpConfig;
	}

	/**
	 * Convenience passthrough: register preview-card layouts with the (soft-dependency) RecordSetCardManager.
	 * @param {Record<string, any>} pCardMap - `{ <EntityName>: <cardConfig>, ... }`.
	 * @return {boolean} true when a card manager was present to register into.
	 */
	registerCards(pCardMap)
	{
		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpManager || (typeof tmpManager.registerCard !== 'function'))
		{
			this.log.warn('Pict-DataExplorer: registerCards() called but no RecordSetCardManager is registered — explored records will degrade to plain text.');
			return false;
		}
		const tmpMap = pCardMap || {};
		for (const tmpKey of Object.keys(tmpMap))
		{
			tmpManager.registerCard(tmpKey, tmpMap[tmpKey]);
		}
		return true;
	}
}

module.exports = PictProviderDataExplorer;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../views/PictView-DataExplorer.js":549,"./Pict-DataExplorer-DataProvider.js":547,"pict-provider":552}],549:[function(require,module,exports){
const libPictView = require('pict-view');

// Meadow's standard audit/system columns — never offered in the column chooser (they are noise as chips and
// already surface in the ⓘ card's audit stripe). The opaque ID / GUID keys are filtered separately by regex.
const _SYSTEM_COLUMNS = [ 'CreateDate', 'CreatingIDUser', 'UpdateDate', 'UpdatingIDUser', 'Deleted', 'DeleteDate', 'DeletingIDUser' ];

const _ExplorerCSS = /*css*/`
.pdex { font-size: 0.92rem; color: var(--theme-color-text-primary, #1f2733); }
.pdex *, .pdex *::before, .pdex *::after { box-sizing: border-box; }
.pdex-children { padding-left: 1.15rem; border-left: 1px solid var(--theme-color-border-light, #eef1f5); margin-left: 0.45rem; }
.pdex > .pdex-node > .pdex-children, .pdex-root > .pdex-children { border-left: none; margin-left: 0; padding-left: 0; }
.pdex-row { display: flex; align-items: center; gap: 0.4rem; padding: 0.28rem 0.4rem; border-radius: 7px; cursor: pointer; min-width: 0; }
.pdex-row:hover { background: var(--theme-color-background-tertiary, #eef1f5); }
.pdex-row-selected, .pdex-row-selected:hover { background: var(--theme-color-brand-background, rgba(21,109,209,0.10)); box-shadow: inset 2px 0 0 var(--theme-color-brand-primary, #156dd1); }
.pdex-caret { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; }
.pdex-caret-empty { visibility: hidden; }
.pdex-folder-ic { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-brand-primary, #156dd1); }
.pdex-label { font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pdex-count { flex: 0 0 auto; font-size: 0.76rem; font-weight: 600; color: var(--theme-color-text-muted, #6b7686);
	background: var(--theme-color-background-tertiary, #eef1f5); border-radius: 10px; padding: 0.02rem 0.45rem; }
.pdex-title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pdex-title-fallback { opacity: 0.5; font-style: italic; font-weight: 400; }
.pdex-subtitle { flex: 1 1 auto; min-width: 0; font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pdex-loadmore { display: inline-block; margin: 0.2rem 0.4rem; padding: 0.25rem 0.6rem; font-size: 0.82rem; cursor: pointer; border-radius: 6px;
	color: var(--theme-color-brand-primary, #156dd1); }
.pdex-loadmore:hover { background: var(--theme-color-background-tertiary, #eef1f5); }
.pdex-empty, .pdex-loading { padding: 0.3rem 0.5rem; font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); font-style: italic; }
/* The preview-card ⓘ trigger — reuses pict-section-recordset's class names for visual parity. */
.pdex-row .psrs-card-trigger { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; opacity: 0.5; color: var(--theme-color-text-muted, #6b7686); }
.pdex-row .psrs-card-trigger:hover { opacity: 1; color: var(--theme-color-brand-primary, #156dd1); }
/* Per-tier toolbar — a filter box + a sort selector, shown under a folder row while it is expanded. */
.pdex-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem; margin: 0.15rem 0.4rem 0.35rem 1.5rem; }
.pdex-filter { display: inline-flex; align-items: center; gap: 0.3rem; flex: 1 1 12rem; min-width: 9rem; max-width: 22rem;
	background: var(--theme-color-background-secondary, #fff); border: 1px solid var(--theme-color-border-light, #d9e0e8); border-radius: 7px; padding: 0.1rem 0.45rem; }
.pdex-filter:focus-within { border-color: var(--theme-color-brand-primary, #156dd1); }
.pdex-filter-ic { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; }
.pdex-filter-input { flex: 1 1 auto; min-width: 0; border: none; outline: none; background: transparent; font: inherit; font-size: 0.84rem; color: inherit; padding: 0.15rem 0; }
.pdex-sort { display: inline-flex; align-items: center; gap: 0.3rem; flex: 0 0 auto; }
.pdex-sort-label { font-size: 0.76rem; font-weight: 600; color: var(--theme-color-text-muted, #6b7686); }
.pdex-sort-select { font: inherit; font-size: 0.82rem; color: inherit; background: var(--theme-color-background-secondary, #fff);
	border: 1px solid var(--theme-color-border-light, #d9e0e8); border-radius: 7px; padding: 0.12rem 1.3rem 0.12rem 0.45rem; cursor: pointer; }
.pdex-sort-dir { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; width: 1.7rem; height: 1.55rem; cursor: pointer;
	border: 1px solid var(--theme-color-border-light, #d9e0e8); border-radius: 7px; color: var(--theme-color-text-muted, #6b7686); }
.pdex-sort-dir:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
/* Per-entity column chooser (toolbar) + the chips it lights up next to each record. */
.pdex-columns { flex: 0 0 auto; position: relative; font-size: 0.8rem; }
.pdex-columns-summary { cursor: pointer; list-style: none; display: inline-flex; align-items: center; gap: 0.3rem; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-light, #d9e0e8); border-radius: 7px; padding: 0.18rem 0.5rem; }
.pdex-columns-summary::-webkit-details-marker { display: none; }
.pdex-columns[open] .pdex-columns-summary { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
.pdex-columns-list { position: absolute; z-index: 50; margin-top: 0.25rem; min-width: 10rem; max-height: 16rem; overflow: auto; padding: 0.35rem;
	background: var(--theme-color-background-secondary, #fff); border: 1px solid var(--theme-color-border-light, #d9e0e8); border-radius: 8px; box-shadow: 0 6px 18px rgba(0,0,0,0.12); }
.pdex-column-opt { display: flex; align-items: center; gap: 0.4rem; padding: 0.2rem 0.3rem; white-space: nowrap; cursor: pointer; border-radius: 5px; }
.pdex-column-opt:hover { background: var(--theme-color-background-tertiary, #eef1f5); }
.pdex-chips { display: inline-flex; flex-wrap: wrap; gap: 0.25rem; align-items: center; }
.pdex-chip { display: inline-flex; align-items: center; gap: 0.28rem; flex: 0 0 auto; font-size: 0.72rem; max-width: 18rem;
	background: var(--theme-color-background-tertiary, #eef1f5); border-radius: 10px; padding: 0.02rem 0.5rem; }
.pdex-chip-key { font-weight: 600; color: var(--theme-color-text-muted, #6b7686); }
.pdex-chip-val { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
/* Host-supplied row meters (RowMeters) — a right-aligned strip of progress bars + status pills. */
.pdex-meters { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.4rem; margin-left: 0.4rem; }
.pdex-meter { display: inline-flex; align-items: center; gap: 0.35rem; flex: 0 0 auto; }
.pdex-meter-track { width: 3.4rem; height: 0.4rem; border-radius: 3px; overflow: hidden; background: var(--theme-color-background-tertiary, #eef1f5); }
.pdex-meter-fill { display: block; height: 100%; border-radius: 3px; background: var(--theme-color-text-muted, #6b7686); }
.pdex-meter-text { font-size: 0.72rem; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; font-variant-numeric: tabular-nums; min-width: 2.9rem; text-align: right; }
.pdex-meter-ok .pdex-meter-fill { background: var(--theme-color-success, #2a9d54); }
.pdex-meter-warn .pdex-meter-fill { background: var(--theme-color-warning, #d6952b); }
.pdex-meter-bad .pdex-meter-fill { background: var(--theme-color-danger, #d1453b); }
.pdex-pill { display: inline-flex; align-items: center; flex: 0 0 auto; font-size: 0.72rem; font-weight: 600; white-space: nowrap;
	border-radius: 10px; padding: 0.02rem 0.5rem; background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-text-muted, #6b7686); }
.pdex-pill-ok { background: var(--theme-color-success-background, rgba(42,157,84,0.14)); color: var(--theme-color-success, #2a9d54); }
.pdex-pill-warn { background: var(--theme-color-warning-background, rgba(214,149,43,0.16)); color: var(--theme-color-warning, #b9791f); }
.pdex-pill-bad { background: var(--theme-color-danger-background, rgba(209,69,59,0.14)); color: var(--theme-color-danger, #d1453b); }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-DataExplorer',

	DefaultDestinationAddress: '#Pict-DataExplorer-Container',

	AutoRender: false,

	CSS: _ExplorerCSS,

	Templates:
	[
		{
			// The outer shell — a list of root folder nodes.
			Hash: 'PDEX-Root-Container',
			Template: /*html*/`<div class="pdex pdex-root">{~TS:PDEX-Folder-Node:Record.RootFolders~}</div>`,
		},
		{
			// A folder node WRAPPER (stable DOM id); its inner is re-rendered on toggle.
			Hash: 'PDEX-Folder-Node',
			Template: /*html*/`<div class="pdex-node pdex-folder" id="{~D:Record.NodeDOMID~}">{~TS:PDEX-Folder-Inner:Record.SelfSlot~}</div>`,
		},
		{
			Hash: 'PDEX-Folder-Inner',
			Template: /*html*/`<div class="pdex-row pdex-row-folder" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleNode('{~D:Record.NodeKey~}')">{~TS:PDEX-Caret-Down:Record.ExpandedSlot~}{~TS:PDEX-Caret-Right:Record.CollapsedSlot~}{~TS:PDEX-Caret-None:Record.NoCaretSlot~}<span class="pdex-folder-ic">{~I:Folder~}</span><span class="pdex-label">{~D:Record.Label~}</span>{~TS:PDEX-Count:Record.CountSlot~}</div>{~TS:PDEX-Folder-Toolbar:Record.ToolbarSlot~}<div class="pdex-children" id="{~D:Record.ChildrenDOMID~}"></div>`,
		},
		{
			// A record node WRAPPER.
			Hash: 'PDEX-Record-Node',
			Template: /*html*/`<div class="pdex-node pdex-record" id="{~D:Record.NodeDOMID~}">{~TS:PDEX-Record-Inner:Record.SelfSlot~}</div>`,
		},
		{
			Hash: 'PDEX-Record-Inner',
			Template: /*html*/`<div class="pdex-row pdex-row-record {~NE:Record.Selected^pdex-row-selected~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleNode('{~D:Record.NodeKey~}')">{~TS:PDEX-Caret-Down:Record.ExpandedSlot~}{~TS:PDEX-Caret-Right:Record.CollapsedSlot~}{~TS:PDEX-Caret-None:Record.NoCaretSlot~}<span class="pdex-title {~D:Record.TitleClass~}">{~D:Record.Title~}</span>{~TS:PDEX-Card-Trigger:Record.CardSlot~}<span class="pdex-chips">{~TS:PDEX-Chip:Record.ChipsSlot~}</span><span class="pdex-subtitle">{~D:Record.Subtitle~}</span><span class="pdex-meters">{~TS:PDEX-Meter:Record.MetersSlot~}</span></div><div class="pdex-children" id="{~D:Record.ChildrenDOMID~}"></div>`,
		},
		{
			// A folder's member list (record nodes) + a "Load more" + an empty-state.
			Hash: 'PDEX-Members',
			Template: /*html*/`{~TS:PDEX-Record-Node:Record.Members~}{~TS:PDEX-LoadMore:Record.LoadMoreSlot~}{~TS:PDEX-Empty:Record.EmptySlot~}`,
		},
		{
			// A record's child folders.
			Hash: 'PDEX-Folders',
			Template: /*html*/`{~TS:PDEX-Folder-Node:Record.Folders~}`,
		},
		{ Hash: 'PDEX-Caret-Down', Template: /*html*/`<span class="pdex-caret">{~I:ChevronDown~}</span>` },
		{ Hash: 'PDEX-Caret-Right', Template: /*html*/`<span class="pdex-caret">{~I:ChevronRight~}</span>` },
		{ Hash: 'PDEX-Caret-None', Template: /*html*/`<span class="pdex-caret pdex-caret-empty"></span>` },
		{ Hash: 'PDEX-Count', Template: /*html*/`<span class="pdex-count">{~D:Record.CountText~}</span>` },
		{ Hash: 'PDEX-Card-Trigger', Template: /*html*/`<span class="psrs-card-trigger" onclick="event.stopPropagation(); _Pict.views['{~D:Record.ViewHash~}'].openCardForNode('{~D:Record.NodeKey~}', this)"><span class="psrs-card-trigger-icon">{~I:Info~}</span></span>` },
		{ Hash: 'PDEX-LoadMore', Template: /*html*/`<div class="pdex-loadmore" onclick="_Pict.views['{~D:Record.ViewHash~}'].loadMore('{~D:Record.NodeKey~}')">Load more…</div>` },
		{ Hash: 'PDEX-Empty', Template: /*html*/`<div class="pdex-empty">{~D:Record.EmptyText~}</div>` },
		{
			// The per-tier toolbar: a filter box + a sort selector, shown only while a folder is expanded.
			Hash: 'PDEX-Folder-Toolbar',
			Template: /*html*/`<div class="pdex-toolbar" onclick="event.stopPropagation()">{~TS:PDEX-Filter-Box:Record.FilterSlot~}{~TS:PDEX-Sort-Box:Record.SortSlot~}{~TS:PDEX-Columns:Record.ColumnsSlot~}</div>`,
		},
		{
			Hash: 'PDEX-Filter-Box',
			Template: /*html*/`<span class="pdex-filter"><span class="pdex-filter-ic">{~I:Search~}</span><input type="text" class="pdex-filter-input" placeholder="Filter {~D:Record.Label~}…" value="{~D:Record.FilterValue~}" oninput="_Pict.views['{~D:Record.ViewHash~}'].onTierFilterInput('{~D:Record.NodeKey~}', this.value)" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.views['{~D:Record.ViewHash~}'].setTierFilter('{~D:Record.NodeKey~}', this.value); } else if (event.key === 'Escape') { this.value = ''; _Pict.views['{~D:Record.ViewHash~}'].setTierFilter('{~D:Record.NodeKey~}', ''); }" /></span>`,
		},
		{
			Hash: 'PDEX-Sort-Box',
			Template: /*html*/`<span class="pdex-sort"><span class="pdex-sort-label">Sort</span><select class="pdex-sort-select" onchange="_Pict.views['{~D:Record.ViewHash~}'].setTierSort('{~D:Record.NodeKey~}', this.value)">{~TS:PDEX-Sort-Option:Record.Columns~}</select><span class="pdex-sort-dir" title="Toggle sort direction" onclick="_Pict.views['{~D:Record.ViewHash~}'].toggleTierSortDir('{~D:Record.NodeKey~}')">{~TS:PDEX-SortDir-Asc:Record.DirAscSlot~}{~TS:PDEX-SortDir-Desc:Record.DirDescSlot~}</span></span>`,
		},
		{ Hash: 'PDEX-Sort-Option', Template: /*html*/`<option value="{~D:Record.Name~}" {~NE:Record.IsSelected^selected~}>{~D:Record.Label~}</option>` },
		{ Hash: 'PDEX-SortDir-Asc', Template: /*html*/`{~I:ArrowUp~}` },
		{ Hash: 'PDEX-SortDir-Desc', Template: /*html*/`{~I:ArrowDown~}` },
		{
			// A per-entity column chooser — toggled columns light up as chips on every record of the entity.
			Hash: 'PDEX-Columns',
			Template: /*html*/`<details class="pdex-columns"><summary class="pdex-columns-summary"><span>Columns</span>{~I:ChevronDown~}</summary><div class="pdex-columns-list">{~TS:PDEX-Column-Option:Record.Columns~}</div></details>`,
		},
		{ Hash: 'PDEX-Column-Option', Template: /*html*/`<label class="pdex-column-opt"><input type="checkbox" {~NE:Record.Checked^checked~} onchange="_Pict.views['{~D:Record.ViewHash~}'].toggleColumn('{~D:Record.Entity~}', '{~D:Record.Column~}')" /><span>{~D:Record.Column~}</span></label>` },
		{ Hash: 'PDEX-Chip', Template: /*html*/`<span class="pdex-chip"><span class="pdex-chip-key">{~D:Record.Column~}</span><span class="pdex-chip-val">{~D:Record.Value~}</span></span>` },
		// Host-supplied row meters (RowMeters): a dispatcher that renders a bar or a pill per meter record.
		{ Hash: 'PDEX-Meter', Template: /*html*/`{~TIfAbs:PDEX-Meter-Bar:Record:Record.Kind^===^bar~}{~TIfAbs:PDEX-Meter-Pill:Record:Record.Kind^===^pill~}` },
		{ Hash: 'PDEX-Meter-Bar', Template: /*html*/`<span class="pdex-meter pdex-meter-{~D:Record.Tone~}" title="{~D:Record.Title~}"><span class="pdex-meter-track"><span class="pdex-meter-fill" style="width: {~D:Record.Percent~}%;"></span></span><span class="pdex-meter-text">{~D:Record.Label~}</span></span>` },
		{ Hash: 'PDEX-Meter-Pill', Template: /*html*/`<span class="pdex-pill pdex-pill-{~D:Record.Tone~}" title="{~D:Record.Title~}">{~D:Record.Text~}</span>` },
	],

	Renderables: [],
};

/**
 * The data explorer "folders" view — an expandable tree of record / folder nodes.
 *
 * Rendering strategy: the recursion crosses record↔folder tiers in JS (pict templates cannot self-recurse
 * to unbounded depth), so each node's children are rendered with `parseTemplateByHash()` and assigned into
 * that node's stable child container on expand. AppData holds only node DATA + flags — never HTML. A node's
 * inner is re-rendered on toggle (to flip its caret) into its stable wrapper; its child container is then
 * filled (or cleared). Siblings are never touched.
 */
class PictViewDataExplorer extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/** @return {any} the resolution DataProvider. */
	get dataProvider()
	{
		return this.pict.providers['Pict-DataExplorer-DataProvider'];
	}

	/** @return {Record<string, any>} the normalized explorer config graph. */
	get explorerConfig()
	{
		return this.options.ExplorerConfig || { Entities: {}, Roots: [], PageSize: 25, MaxDepth: 6 };
	}

	/** @return {Record<string, any>} the per-explorer node store (created on first use). */
	_state()
	{
		if (!this.pict.AppData.PictDataExplorer) { this.pict.AppData.PictDataExplorer = {}; }
		if (!this.pict.AppData.PictDataExplorer[this.Hash]) { this.pict.AppData.PictDataExplorer[this.Hash] = { Nodes: {} }; }
		return this.pict.AppData.PictDataExplorer[this.Hash];
	}

	_node(pKey)
	{
		return this._state().Nodes[pKey];
	}

	/** A DOM-safe id from a logical node key (which contains `:` and `/`). */
	_domID(pPrefix, pKey)
	{
		return `${pPrefix}-${this.Hash}-${String(pKey).replace(/[^A-Za-z0-9]/g, '_')}`;
	}

	_entityConfig(pEntityName)
	{
		return this.explorerConfig.Entities[pEntityName] || { Entity: pEntityName, IDField: `ID${pEntityName}`, Lite: [], Display: { Title: `ID${pEntityName}` }, Children: [] };
	}

	// --- entry point ---------------------------------------------------------------------------------

	/** Render the root folder list into the destination. Call once after the destination exists in the DOM. */
	renderExplorer()
	{
		const tmpState = this._state();
		tmpState.Nodes = {};
		const tmpRootFolders = [];
		(this.explorerConfig.Roots || []).forEach((pRoot) =>
		{
			const tmpEntityConfig = this._entityConfig(pRoot.Entity);
			const tmpKey = `root:${pRoot.Entity}`;
			const tmpNode =
			{
				Kind: 'folder', IsRoot: true, Entity: pRoot.Entity, EntityConfig: tmpEntityConfig,
				Label: pRoot.Label || pRoot.Entity, RootFilter: pRoot.Filter || '', RootSort: pRoot.Sort,
				Expanded: false, Loaded: false, Loading: false, Count: null,
				MemberKeys: [], Cursor: 0, HasMore: true, PageSize: pRoot.PageSize || this.explorerConfig.PageSize, Depth: 0,
			};
			tmpState.Nodes[tmpKey] = tmpNode;
			tmpRootFolders.push(this._folderDescriptor(tmpKey, tmpNode));
		});
		const tmpHTML = this.pict.parseTemplateByHash('PDEX-Root-Container', { RootFolders: tmpRootFolders });
		this.pict.ContentAssignment.assignContent(this.options.DestinationAddress || this.options.DefaultDestinationAddress, tmpHTML);
		this.pict.CSSMap.injectCSS();
		return this;
	}

	// --- interactions --------------------------------------------------------------------------------

	toggleNode(pKey)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode) { return; }
		// Selection (opt-in via the explorer config's OnNodeSelect) — a RECORD row click selects it, so a
		// master/detail host can render the selected record in a side panel. Structural folders only expand.
		if ((typeof this.explorerConfig.OnNodeSelect === 'function') && (tmpNode.Kind === 'record'))
		{
			const tmpPreviousSelected = this._state().SelectedKey;
			this._state().SelectedKey = pKey;
			// Un-highlight the previously-selected row IN PLACE — re-rendering it would reset its child container
			// and collapse any expanded subtree beneath it. The newly-selected row picks up the highlight from
			// its descriptor in the _renderInner below.
			if (tmpPreviousSelected && (tmpPreviousSelected !== pKey)) { this._setRowSelectedClass(tmpPreviousSelected, false); }
			try { this.explorerConfig.OnNodeSelect({ Entity: tmpNode.Entity, Record: tmpNode.Record, Key: pKey, Node: tmpNode }); }
			catch (pError) { this.log.warn(`Pict-DataExplorer: OnNodeSelect threw: ${pError && pError.message}`); }
		}
		tmpNode.Expanded = !tmpNode.Expanded;
		this._renderInner(pKey);
		if (!tmpNode.Expanded) { return; }

		// Lazily discover the entity's full column list so the "Columns" chooser can offer every column (not just
		// the pre-fetched Lite); repaint the toolbar once it arrives.
		if (tmpNode.Kind === 'folder')
		{
			this._ensureSchemaColumns(tmpNode.Entity, (pLoaded) =>
			{
				// Repaint the toolbar to offer the freshly-loaded schema columns. _renderInner resets the child
				// container, so re-render any already-loaded members afterward — otherwise a slow schema fetch
				// landing AFTER a fast (e.g. in-memory) member load blanks the children until a collapse/re-expand.
				if (!pLoaded || !tmpNode.Expanded) { return; }
				this._renderInner(pKey);
				if (tmpNode.Loaded) { this.renderChildren(pKey); }
			});
		}

		if (tmpNode.Loaded) { this.renderChildren(pKey); this._autoExpandSoleChild(pKey); return; }

		// First expand → load this node's children, showing a transient "Loading…".
		this.pict.ContentAssignment.assignContent(`#${this._domID('PDEX-Children', pKey)}`, '<div class="pdex-loading">Loading…</div>');
		tmpNode.Loading = true;
		const fComplete = () =>
		{
			tmpNode.Loading = false;
			tmpNode.Loaded = true;
			if (tmpNode.Expanded) { this.renderChildren(pKey); this._autoExpandSoleChild(pKey); }
		};
		if (tmpNode.Kind === 'folder') { this._loadFolderMembers(pKey, tmpNode, fComplete); }
		else { this._loadRecordFolders(pKey, tmpNode, fComplete); }
	}

	/**
	 * When `AutoExpandSoleChild` is set and a just-expanded node has exactly ONE child collection (folder),
	 * expand that folder too — so a node whose only child is e.g. "Materials" doesn't force a second click.
	 * Cascades down a chain of sole children; stops as soon as a level has 0 or 2+ child folders.
	 */
	_autoExpandSoleChild(pKey)
	{
		if (!this.explorerConfig || !this.explorerConfig.AutoExpandSoleChild) { return; }
		const tmpNodes = this._state().Nodes;
		const tmpPrefix = `${pKey}/`;
		const tmpChildFolderKeys = Object.keys(tmpNodes).filter((pNodeKey) =>
			(pNodeKey.indexOf(tmpPrefix) === 0)
			&& (pNodeKey.slice(tmpPrefix.length).indexOf('/') < 0)   // direct child only
			&& tmpNodes[pNodeKey] && (tmpNodes[pNodeKey].Kind === 'folder'));
		if ((tmpChildFolderKeys.length === 1) && !tmpNodes[tmpChildFolderKeys[0]].Expanded)
		{
			this.toggleNode(tmpChildFolderKeys[0]);
		}
	}

	loadMore(pKey)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode || (tmpNode.Kind !== 'folder') || tmpNode.Loading) { return; }
		tmpNode.Loading = true;
		this._loadFolderMembers(pKey, tmpNode, () => { tmpNode.Loading = false; this.renderChildren(pKey); });
	}

	// --- per-tier filter + sort ----------------------------------------------------------------------

	/** Debounced live filtering as the user types in a tier's filter box. */
	onTierFilterInput(pKey, pValue)
	{
		if (!this._filterDebounce) { this._filterDebounce = {}; }
		if (this._filterDebounce[pKey]) { clearTimeout(this._filterDebounce[pKey]); }
		this._filterDebounce[pKey] = setTimeout(() => { delete this._filterDebounce[pKey]; this.setTierFilter(pKey, pValue); }, 250);
	}

	/** Apply a tier's filter text (server-side substring on the search field) and reload its first page. */
	setTierFilter(pKey, pValue)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode || (tmpNode.Kind !== 'folder')) { return; }
		if (this._filterDebounce && this._filterDebounce[pKey]) { clearTimeout(this._filterDebounce[pKey]); delete this._filterDebounce[pKey]; }
		const tmpNew = String((pValue === undefined || pValue === null) ? '' : pValue);
		if ((tmpNode.UserFilter || '') === tmpNew) { return; }
		tmpNode.UserFilter = tmpNew;
		this._reloadFolderMembers(pKey, tmpNode);
	}

	/** Apply a tier's sort column and reload its first page. */
	setTierSort(pKey, pField)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode || (tmpNode.Kind !== 'folder')) { return; }
		tmpNode.UserSort = String((pField === undefined || pField === null) ? '' : pField);
		this._reloadFolderMembers(pKey, tmpNode);
	}

	/** Flip a tier's sort direction (ASC ⇄ DESC), repaint the arrow, and reload its first page. */
	toggleTierSortDir(pKey)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode || (tmpNode.Kind !== 'folder')) { return; }
		tmpNode.UserSortDirection = (this._effectiveSortDir(tmpNode) === 'DESC') ? 'ASC' : 'DESC';
		this._renderInner(pKey); // repaint the toolbar so the direction arrow reflects the new state
		this._reloadFolderMembers(pKey, tmpNode);
	}

	/** Reset a folder's loaded members + pagination and re-fetch its first page (leaves the toolbar in place). */
	_reloadFolderMembers(pKey, pNode)
	{
		// Drop the previously-loaded member nodes (and their descendants) — the load path dedupes by node key,
		// so without this a reload of the same records would skip them and render an empty list.
		const tmpNodes = this._state().Nodes;
		const tmpPrefix = `${pKey}/`;
		Object.keys(tmpNodes).forEach((pNodeKey) => { if (pNodeKey.indexOf(tmpPrefix) === 0) { delete tmpNodes[pNodeKey]; } });
		pNode.MemberKeys = [];
		pNode.Cursor = 0;
		pNode.HasMore = true;
		pNode.Loaded = false;
		pNode.Loading = true;
		this.pict.ContentAssignment.assignContent(`#${this._domID('PDEX-Children', pKey)}`, '<div class="pdex-loading">Loading…</div>');
		this._loadFolderMembers(pKey, pNode, () =>
		{
			pNode.Loading = false;
			pNode.Loaded = true;
			this.renderChildren(pKey);
		});
	}

	openCardForNode(pKey, pAnchorElement)
	{
		const tmpNode = this._node(pKey);
		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpNode || !tmpManager || (typeof tmpManager.openCard !== 'function')) { return; }
		// Rich mode: the manager fetches the full record (the node holds only Lite columns), shows every
		// column, synthesizes a default card when the entity has none, and offers the audit stripe.
		tmpManager.openCard(tmpNode.Entity, tmpNode.Record, pAnchorElement, { Rich: true, Audit: true, EntityConfig: tmpNode.EntityConfig });
	}

	// --- loading -------------------------------------------------------------------------------------

	/** Fetch a page of a folder's members (root list, or a parent record's children) and create record nodes. */
	_loadFolderMembers(pKey, pNode, fComplete)
	{
		const fReceive = (pError, pRecords) =>
		{
			if (pError) { this.log.error(`Pict-DataExplorer: error loading [${pNode.Entity}] members: ${pError.message || pError}`); return fComplete(); }
			const tmpRecords = pRecords || [];
			const tmpIDField = pNode.EntityConfig.IDField;
			tmpRecords.forEach((pRecord) =>
			{
				const tmpChildKey = `${pKey}/rec:${pRecord[tmpIDField]}`;
				if (this._node(tmpChildKey)) { return; } // dedupe across pages
				this._state().Nodes[tmpChildKey] =
				{
					Kind: 'record', Entity: pNode.Entity, EntityConfig: pNode.EntityConfig, Record: pRecord,
					Context: pNode.Context || {},   // inherit the folder's accumulated ancestor-id context
					Expanded: false, Loaded: false, FolderKeys: [], Depth: pNode.Depth + 1,
					HasChildren: ((pNode.EntityConfig.Children || []).length > 0) && ((pNode.Depth + 1) < this.explorerConfig.MaxDepth),
				};
				pNode.MemberKeys.push(tmpChildKey);
			});
			pNode.Cursor += tmpRecords.length;
			pNode.HasMore = (tmpRecords.length >= pNode.PageSize);
			return fComplete();
		};

		if (pNode.IsRoot)
		{
			const tmpRootConfig = Object.assign({}, pNode.EntityConfig,
				{
					Lite: this._effectiveLite(pNode),
					Filter: pNode.RootFilter || pNode.EntityConfig.Filter,
					Sort: this._effectiveSortField(pNode) || undefined,
					SortDirection: this._effectiveSortDir(pNode),
				});
			return this.dataProvider.resolveList(tmpRootConfig, this._filterExpression(pNode), pNode.Cursor, pNode.PageSize, fReceive);
		}
		// Child folder: overlay the user's filter/sort onto the child entity config so the DataProvider ANDs the
		// substring clause with the relationship FK + base filters, and sorts the page.
		const tmpChildConfig = Object.assign({}, pNode.EntityConfig,
			{
				Lite: this._effectiveLite(pNode),
				Filter: [ pNode.EntityConfig.Filter, this._contextFilter(pNode), this._filterExpression(pNode) ].filter((pPart) => (pPart && String(pPart).length > 0)).join('~') || undefined,
				Sort: this._effectiveSortField(pNode) || undefined,
				SortDirection: this._effectiveSortDir(pNode),
			});
		return this.dataProvider.resolveChildren(pNode.ParentEntityConfig, pNode.ParentRecord, pNode.ChildRel, tmpChildConfig, pNode.Cursor, pNode.PageSize, (pError, pRecords, pMeta) =>
		{
			if (pMeta && (typeof pMeta.hasMore === 'boolean')) { pNode._metaHasMore = pMeta.hasMore; }
			fReceive(pError, pRecords);
			if (pNode._metaHasMore !== undefined) { pNode.HasMore = pNode._metaHasMore; delete pNode._metaHasMore; }
		});
	}

	/** Build a record's child folder nodes (one per ChildRel) and pre-fetch the badge counts that opt in. */
	_loadRecordFolders(pKey, pNode, fComplete)
	{
		const tmpChildren = pNode.EntityConfig.Children || [];
		const tmpCountQueue = [];
		// Each child folder inherits this record's accumulated ancestor-id context PLUS this record's own id, so a
		// descendant tier can filter by an ancestor (e.g. a grandchild tier reached through a parent carries that ancestor id).
		const tmpFolderContext = Object.assign({}, pNode.Context, this._ownContextEntry(pNode));
		tmpChildren.forEach((pChildRel) =>
		{
			const tmpRelationship = pChildRel.Relationship || {};
			// A tier can require ancestor context to even appear (so it shows only on the contextual path, not at
			// the entity's root browse) — skip it when a required context key is absent.
			const tmpRequire = Array.isArray(tmpRelationship.RequireContext) ? tmpRelationship.RequireContext : [];
			if (tmpRequire.some((pColumn) => (tmpFolderContext[pColumn] === undefined) || (tmpFolderContext[pColumn] === null))) { return; }
			const tmpChildEntityConfig = this._entityConfig(pChildRel.Entity);
			const tmpFolderKey = `${pKey}/fld:${pChildRel.Label}`;
			const tmpFolderNode =
			{
				Kind: 'folder', Entity: pChildRel.Entity, EntityConfig: tmpChildEntityConfig, Label: pChildRel.Label,
				ChildRel: pChildRel, ParentRecord: pNode.Record, ParentEntityConfig: pNode.EntityConfig,
				Context: tmpFolderContext,
				Expanded: false, Loaded: false, Loading: false, Count: null,
				MemberKeys: [], Cursor: 0, HasMore: true, PageSize: pChildRel.PageSize || this.explorerConfig.PageSize, Depth: pNode.Depth + 1,
			};
			this._state().Nodes[tmpFolderKey] = tmpFolderNode;
			pNode.FolderKeys.push(tmpFolderKey);
			if ((pChildRel.Resolve === 'count') || (pChildRel.Resolve === 'eager')) { tmpCountQueue.push({ Key: tmpFolderKey, Node: tmpFolderNode }); }
		});

		if (tmpCountQueue.length < 1) { return fComplete(); }
		let tmpPending = tmpCountQueue.length;
		const fOneDone = () => { tmpPending--; if (tmpPending <= 0) { fComplete(); } };
		tmpCountQueue.forEach((pEntry) =>
		{
			// Scope the badge by the same ancestor context the list will use, so the count matches the contents.
			const tmpContextFilter = this._contextFilter(pEntry.Node);
			const tmpCountConfig = tmpContextFilter
				? Object.assign({}, pEntry.Node.EntityConfig, { Filter: [ pEntry.Node.EntityConfig.Filter, tmpContextFilter ].filter((pPart) => (pPart && String(pPart).length > 0)).join('~') || undefined })
				: pEntry.Node.EntityConfig;
			this.dataProvider.resolveChildCount(pNode.EntityConfig, pNode.Record, pEntry.Node.ChildRel, tmpCountConfig, (pError, pCount) =>
			{
				pEntry.Node.Count = pError ? null : pCount;
				fOneDone();
			});
		});
	}

	// --- rendering -----------------------------------------------------------------------------------

	/** Re-render a node's inner (row + empty child container) into its stable wrapper — flips the caret. */
	_renderInner(pKey)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode) { return; }
		const tmpTemplate = (tmpNode.Kind === 'folder') ? 'PDEX-Folder-Inner' : 'PDEX-Record-Inner';
		const tmpDescriptor = (tmpNode.Kind === 'folder') ? this._folderDescriptor(pKey, tmpNode) : this._recordDescriptor(pKey, tmpNode);
		this.pict.ContentAssignment.assignContent(`#${this._domID('PDEX-Node', pKey)}`, this.pict.parseTemplateByHash(tmpTemplate, tmpDescriptor));
		this.pict.CSSMap.injectCSS();
	}

	/** Toggle the selected-highlight class on a node's own row IN PLACE (no re-render, so its subtree survives). */
	_setRowSelectedClass(pKey, pSelected)
	{
		const tmpElements = this.pict.ContentAssignment.getElement(`#${this._domID('PDEX-Node', pKey)} > .pdex-row-record`);
		const tmpRow = (tmpElements && (tmpElements.length !== undefined)) ? tmpElements[0] : tmpElements;
		if (tmpRow && tmpRow.classList) { tmpRow.classList[pSelected ? 'add' : 'remove']('pdex-row-selected'); }
	}

	/** Fill a node's child container: a folder's member records, or a record's child folders. */
	renderChildren(pKey)
	{
		const tmpNode = this._node(pKey);
		if (!tmpNode) { return; }
		const tmpContainer = `#${this._domID('PDEX-Children', pKey)}`;
		if (tmpNode.Kind === 'folder')
		{
			const tmpMembers = tmpNode.MemberKeys.map((pMemberKey) => this._recordDescriptor(pMemberKey, this._node(pMemberKey)));
			const tmpData =
			{
				Members: tmpMembers,
				LoadMoreSlot: tmpNode.HasMore ? [ { ViewHash: this.Hash, NodeKey: pKey } ] : [],
				EmptySlot: (tmpMembers.length < 1) ? [ { EmptyText: `No ${tmpNode.Label}` } ] : [],
			};
			this.pict.ContentAssignment.assignContent(tmpContainer, this.pict.parseTemplateByHash('PDEX-Members', tmpData));
		}
		else
		{
			const tmpFolders = tmpNode.FolderKeys.map((pFolderKey) => this._folderDescriptor(pFolderKey, this._node(pFolderKey)));
			this.pict.ContentAssignment.assignContent(tmpContainer, this.pict.parseTemplateByHash('PDEX-Folders', { Folders: tmpFolders }));
		}
		// Re-rendering this container re-creates each child row with an EMPTY child container, so any ALREADY-expanded
		// child (an auto-expanded sole child, or a child expanded before an async schema repaint reset this row) would
		// blank until a collapse/re-open. Recurse into expanded + loaded children to refill their subtrees.
		const tmpChildKeys = (tmpNode.Kind === 'folder') ? tmpNode.MemberKeys : tmpNode.FolderKeys;
		(tmpChildKeys || []).forEach((pChildKey) =>
		{
			const tmpChildNode = this._node(pChildKey);
			if (tmpChildNode && tmpChildNode.Expanded && tmpChildNode.Loaded) { this.renderChildren(pChildKey); }
		});
		this.pict.CSSMap.injectCSS();
	}

	// --- descriptors (data → template, no HTML in AppData) -------------------------------------------

	_caretSlots(pHasCaret, pExpanded)
	{
		return {
			ExpandedSlot: (pHasCaret && pExpanded) ? [ {} ] : [],
			CollapsedSlot: (pHasCaret && !pExpanded) ? [ {} ] : [],
			NoCaretSlot: pHasCaret ? [] : [ {} ],
		};
	}

	_folderDescriptor(pKey, pNode)
	{
		const tmpCountText = (pNode.Count != null) ? String(pNode.Count) : '';
		const tmpDescriptor = Object.assign(
			{
				ViewHash: this.Hash, NodeKey: pKey,
				NodeDOMID: this._domID('PDEX-Node', pKey), ChildrenDOMID: this._domID('PDEX-Children', pKey),
				Label: pNode.Label || pNode.Entity,
				CountText: tmpCountText, CountSlot: tmpCountText ? [ { CountText: tmpCountText } ] : [],
				ToolbarSlot: pNode.Expanded ? [ this._toolbarDescriptor(pKey, pNode) ] : [],
			},
			this._caretSlots(true, pNode.Expanded));
		tmpDescriptor.SelfSlot = [ tmpDescriptor ];
		return tmpDescriptor;
	}

	/** The filter-box + sort-selector + column-chooser descriptor for an expanded folder's toolbar. */
	_toolbarDescriptor(pKey, pNode)
	{
		const tmpEntityConfig = pNode.EntityConfig || {};
		const tmpSearchable = Array.isArray(tmpEntityConfig.SearchFields) && (tmpEntityConfig.SearchFields.length > 0);
		const tmpSortColumns = this._sortOptions(tmpEntityConfig);
		const tmpEffectiveSort = this._effectiveSortField(pNode);
		const tmpEffectiveDir = this._effectiveSortDir(pNode);
		const tmpChipColumns = this._chipEligibleColumns(tmpEntityConfig, pNode.Entity);
		const tmpChosenColumns = this._chosenColumns(pNode.Entity);
		return {
			ViewHash: this.Hash, NodeKey: pKey, Label: pNode.Label || pNode.Entity,
			FilterSlot: tmpSearchable ? [ { ViewHash: this.Hash, NodeKey: pKey, Label: pNode.Label || pNode.Entity, FilterValue: pNode.UserFilter || '' } ] : [],
			SortSlot: (tmpSortColumns.length > 0) ?
				[ {
					ViewHash: this.Hash, NodeKey: pKey,
					Columns: tmpSortColumns.map((pColumn) => ({ Name: pColumn, Label: pColumn, IsSelected: (pColumn === tmpEffectiveSort) })),
					DirAscSlot: (tmpEffectiveDir !== 'DESC') ? [ {} ] : [],
					DirDescSlot: (tmpEffectiveDir === 'DESC') ? [ {} ] : [],
				} ] : [],
			ColumnsSlot: (tmpChipColumns.length > 0) ?
				[ {
					ViewHash: this.Hash, Entity: pNode.Entity,
					Columns: tmpChipColumns.map((pColumn) => ({ ViewHash: this.Hash, Entity: pNode.Entity, Column: pColumn, Checked: (tmpChosenColumns.indexOf(pColumn) >= 0) })),
				} ] : [],
		};
	}

	/**
	 * The columns a tier offers in its "Columns" chooser. Prefers the entity's FULL schema column list (so any
	 * column can be lit up, not just the pre-fetched Lite), falling back to the Lite projection until the schema
	 * has loaded — or when no schema source is wired. Always drops the opaque ID / GUID keys, the standard
	 * system/audit columns, and the field already shown as the row title.
	 */
	_chipEligibleColumns(pEntityConfig, pEntity)
	{
		const tmpTitle = (pEntityConfig && pEntityConfig.Display && pEntityConfig.Display.Title) || '';
		const tmpSchemaColumns = this._schemaColumnCache && this._schemaColumnCache[pEntity];
		const tmpColumns = Array.isArray(tmpSchemaColumns) ? tmpSchemaColumns
			: ((pEntityConfig && Array.isArray(pEntityConfig.Lite)) ? pEntityConfig.Lite : []);
		// Host-supplied blacklists remove columns that never make sense as chips (e.g. a big JSON/Text blob): a
		// global one on the explorer config + a per-entity one, on top of the always-dropped ID / GUID keys, the
		// system/audit columns, and the row title.
		const tmpBlacklist = ((this.explorerConfig && Array.isArray(this.explorerConfig.ColumnBlacklist)) ? this.explorerConfig.ColumnBlacklist : [])
			.concat((pEntityConfig && Array.isArray(pEntityConfig.ColumnBlacklist)) ? pEntityConfig.ColumnBlacklist : []);
		return tmpColumns.filter((pColumn) =>
			!(/^(ID|GUID)/.test(pColumn)) && (pColumn !== tmpTitle) && (_SYSTEM_COLUMNS.indexOf(pColumn) < 0) && (tmpBlacklist.indexOf(pColumn) < 0));
	}

	/** The schema source used to discover an entity's full column list: the view's own, else the (soft-dep) card manager's. */
	_schemaSource()
	{
		if (typeof this.SchemaSource === 'function') { return this.SchemaSource; }
		const tmpCardManager = this.pict.providers.RecordSetCardManager;
		return (tmpCardManager && (typeof tmpCardManager.SchemaSource === 'function')) ? tmpCardManager.SchemaSource : null;
	}

	/** Column names from a fetched schema — JSON-schema (`properties`), Stricture (`Columns`), or a plain array. */
	_columnsFromSchema(pSchema)
	{
		if (pSchema && pSchema.properties && (typeof pSchema.properties === 'object')) { return Object.keys(pSchema.properties); }
		if (pSchema && Array.isArray(pSchema.Columns)) { return pSchema.Columns.map((pCol) => pCol.Column || pCol.column).filter(Boolean); }
		if (Array.isArray(pSchema)) { return pSchema.map((pCol) => (typeof pCol === 'string') ? pCol : (pCol && (pCol.Column || pCol.column))).filter(Boolean); }
		return [];
	}

	/** Lazily fetch + cache an entity's full column list. Calls back(true) only when this call populated the cache. */
	_ensureSchemaColumns(pEntity, fCallback)
	{
		if (!this._schemaColumnCache) { this._schemaColumnCache = {}; }
		if (Array.isArray(this._schemaColumnCache[pEntity])) { return fCallback(false); }
		const tmpSource = this._schemaSource();
		if (!tmpSource) { return fCallback(false); }
		if (!this._schemaPending) { this._schemaPending = {}; }
		if (this._schemaPending[pEntity]) { return fCallback(false); }
		this._schemaPending[pEntity] = true;
		tmpSource(pEntity, (pError, pSchema) =>
		{
			this._schemaPending[pEntity] = false;
			if (pError || !pSchema) { return fCallback(false); }
			this._schemaColumnCache[pEntity] = this._columnsFromSchema(pSchema);
			return fCallback(true);
		});
	}

	/** The projection a tier fetches: its Lite columns plus any chooser columns the user has turned on. */
	_effectiveLite(pNode)
	{
		const tmpLite = (pNode.EntityConfig && Array.isArray(pNode.EntityConfig.Lite)) ? pNode.EntityConfig.Lite.slice() : [];
		this._chosenColumns(pNode.Entity).forEach((pColumn) => { if (tmpLite.indexOf(pColumn) < 0) { tmpLite.push(pColumn); } });
		return tmpLite;
	}

	/** This record's own id keyed by its IDField — the entry a child folder adds to the inherited context. */
	_ownContextEntry(pRecordNode)
	{
		const tmpIDField = pRecordNode && pRecordNode.EntityConfig && pRecordNode.EntityConfig.IDField;
		if (!tmpIDField || !pRecordNode.Record) { return {}; }
		const tmpValue = pRecordNode.Record[tmpIDField];
		return ((tmpValue === undefined) || (tmpValue === null)) ? {} : { [tmpIDField]: tmpValue };
	}

	/**
	 * AND clauses scoping a child tier by ANCESTOR ids — the `ContextKeys` declared on the folder's relationship,
	 * pulled from the node's accumulated context (e.g. a child tier scoped to the ancestor it hangs
	 * under). Keys absent from the context are simply dropped, so the same tier degrades gracefully off the path.
	 */
	_contextFilter(pNode)
	{
		const tmpRelationship = (pNode && pNode.ChildRel && pNode.ChildRel.Relationship) || {};
		const tmpKeys = Array.isArray(tmpRelationship.ContextKeys) ? tmpRelationship.ContextKeys : [];
		const tmpContext = (pNode && pNode.Context) || {};
		return tmpKeys
			.filter((pColumn) => (tmpContext[pColumn] !== undefined) && (tmpContext[pColumn] !== null))
			.map((pColumn) => `FBV~${pColumn}~EQ~${tmpContext[pColumn]}`)
			.join('~');
	}

	/** localStorage key for an entity's chosen chip columns (per-entity, so it persists across visits). */
	_columnStorageKey(pEntity)
	{
		return `PictDataExplorer.Columns.${pEntity}`;
	}

	/** The columns the user has turned on as chips for an entity (localStorage, with an in-memory fallback). */
	_chosenColumns(pEntity)
	{
		try
		{
			if (typeof window !== 'undefined' && window.localStorage)
			{
				const tmpRaw = window.localStorage.getItem(this._columnStorageKey(pEntity));
				const tmpArray = tmpRaw ? JSON.parse(tmpRaw) : [];
				return Array.isArray(tmpArray) ? tmpArray : [];
			}
		}
		catch (pError) { /* fall through to the in-memory copy */ }
		return (this._columnMemory && this._columnMemory[pEntity]) ? this._columnMemory[pEntity].slice() : [];
	}

	_setChosenColumns(pEntity, pColumns)
	{
		if (!this._columnMemory) { this._columnMemory = {}; }
		this._columnMemory[pEntity] = (pColumns || []).slice();   // session fallback when storage is unavailable
		try
		{
			if (typeof window !== 'undefined' && window.localStorage) { window.localStorage.setItem(this._columnStorageKey(pEntity), JSON.stringify(pColumns)); }
		}
		catch (pError) { /* private mode / no storage — chips persist for the session only */ }
	}

	/**
	 * Toggle a chooser column for an entity (persist) + refresh every loaded tier of that entity. Turning ON a
	 * column the Lite projection doesn't already fetch reloads those tiers so the new column's data arrives;
	 * otherwise it just repaints the chips.
	 */
	toggleColumn(pEntity, pColumn)
	{
		const tmpChosen = this._chosenColumns(pEntity);
		const tmpIndex = tmpChosen.indexOf(pColumn);
		const tmpAdding = (tmpIndex < 0);
		if (tmpIndex >= 0) { tmpChosen.splice(tmpIndex, 1); }
		else { tmpChosen.push(pColumn); }
		this._setChosenColumns(pEntity, tmpChosen);
		const tmpEntityConfig = this.explorerConfig.Entities[pEntity] || {};
		const tmpBaseLite = Array.isArray(tmpEntityConfig.Lite) ? tmpEntityConfig.Lite : [];
		const tmpNeedsFetch = tmpAdding && (tmpBaseLite.indexOf(pColumn) < 0);
		const tmpNodes = this._state().Nodes;
		Object.keys(tmpNodes).forEach((pKey) =>
		{
			const tmpNode = tmpNodes[pKey];
			if (!tmpNode || (tmpNode.Kind !== 'folder') || (tmpNode.Entity !== pEntity) || !tmpNode.Expanded || !tmpNode.Loaded) { return; }
			if (tmpNeedsFetch) { this._reloadFolderMembers(pKey, tmpNode); }
			else { this.renderChildren(pKey); }
		});
	}

	/** The columns offered in a tier's sort dropdown — its Lite columns, minus the opaque ID / GUID keys. */
	_sortOptions(pEntityConfig)
	{
		const tmpLite = (pEntityConfig && Array.isArray(pEntityConfig.Lite)) ? pEntityConfig.Lite : [];
		return tmpLite.filter((pColumn) => !(/^(ID|GUID)/.test(pColumn)));
	}

	/** The effective sort field for a folder: the user's pick, else the configured Sort, else the search key. */
	_effectiveSortField(pNode)
	{
		if (pNode.UserSort !== undefined) { return pNode.UserSort; }
		const tmpEntityConfig = pNode.EntityConfig || {};
		if (pNode.RootSort) { return pNode.RootSort; }
		if (tmpEntityConfig.Sort) { return tmpEntityConfig.Sort; }
		return (Array.isArray(tmpEntityConfig.SearchFields) && tmpEntityConfig.SearchFields[0]) || '';
	}

	_effectiveSortDir(pNode)
	{
		return (pNode.UserSortDirection === 'DESC') ? 'DESC' : 'ASC';
	}

	/** The runtime substring (LK) filter clause for a folder, from its filter-box text (or '' for none). */
	_filterExpression(pNode)
	{
		// Strip the structural `~` from the user's text so it can't break the filter stanza.
		const tmpText = String(pNode.UserFilter || '').replace(/~/g, '').trim();
		const tmpEntityConfig = pNode.EntityConfig || {};
		const tmpFields = Array.isArray(tmpEntityConfig.SearchFields) ? tmpEntityConfig.SearchFields : [];
		if ((tmpText.length < 1) || (tmpFields.length < 1)) { return ''; }
		// URL-ENCODED `%` wildcards: the EntityProvider embeds the filter stanza VERBATIM into the request
		// (the legacy GET `/<Entity>s/.../FilteredTo/<filter>/...` path and the POST /Query body alike — it
		// does NOT url-encode it), so a raw `%te…` is a malformed percent-escape that gets thrown out and the
		// load never resolves. Pre-encode the value exactly as the sibling searchers pict-section-picker
		// (buildSearchFilter) and pict-section-recordset already do; the server decodes `%25foo%25` → `%foo%`.
		const tmpLike = encodeURIComponent(`%${tmpText}%`);
		// One field → a plain FBV LK. Multiple fields → a parenthesized OR group: FoxHound's FBVOR ORs ALL
		// prior clauses, so an ungrouped chain would OR away a child tier's relationship FK. The FOP…FCP
		// group keeps the OR self-contained so it ANDs cleanly with the relationship / base filters.
		if (tmpFields.length === 1) { return `FBV~${tmpFields[0]}~LK~${tmpLike}`; }
		const tmpClauses = tmpFields.map((pField, pIndex) => `${(pIndex === 0) ? 'FBV' : 'FBVOR'}~${pField}~LK~${tmpLike}`).join('~');
		return `FOP~~(~~${tmpClauses}~FCP~~)~`;
	}

	_recordDescriptor(pKey, pNode)
	{
		// Show the preview ⓘ on EVERY record when a card manager is present — it synthesizes a default card
		// for entities that have none registered, so no entry is left without a preview.
		const tmpHasCard = this._cardManagerPresent();
		const tmpChosen = this._chosenColumns(pNode.Entity);
		const tmpChips = tmpChosen
			.filter((pColumn) => pNode.Record && (pNode.Record[pColumn] !== undefined) && (pNode.Record[pColumn] !== null) && (String(pNode.Record[pColumn]) !== ''))
			.map((pColumn) => ({ Column: pColumn, Value: String(pNode.Record[pColumn]) }));
		// Host-supplied row accessory ("meters") — a right-aligned strip of progress bars + status pills, keyed
		// off the record. Opt-in per entity via EntityConfig.RowMeters(record) → [{ Kind:'bar'|'pill', Tone, … }];
		// rendered through the explorer's own themeable templates so any host gets a consistent visual language.
		const tmpMeters = (typeof pNode.EntityConfig.RowMeters === 'function')
			? (this._rowMeters(pNode.EntityConfig, pNode.Record))
			: [];
		// Resolve the display title; when the title field is empty (sparse data) fall back to a record
		// identifier (`Entity #id`) so a row never renders blank — a blank row reads as broken software.
		let tmpTitle = this._resolveDisplay(pNode.EntityConfig.Display && pNode.EntityConfig.Display.Title, pNode.Record);
		let tmpTitleClass = '';
		if (String(tmpTitle).trim() === '')
		{
			const tmpIDValue = (pNode.Record && (pNode.Record[pNode.EntityConfig.IDField] != null)) ? pNode.Record[pNode.EntityConfig.IDField] : '';
			tmpTitle = (tmpIDValue !== '') ? `${pNode.Entity} #${tmpIDValue}` : `(untitled ${pNode.Entity})`;
			tmpTitleClass = 'pdex-title-fallback';
		}
		const tmpDescriptor = Object.assign(
			{
				ViewHash: this.Hash, NodeKey: pKey,
				NodeDOMID: this._domID('PDEX-Node', pKey), ChildrenDOMID: this._domID('PDEX-Children', pKey),
				Title: tmpTitle,
				TitleClass: tmpTitleClass,
				Subtitle: this._resolveDisplay(pNode.EntityConfig.Display && pNode.EntityConfig.Display.Subtitle, pNode.Record),
				CardSlot: tmpHasCard ? [ { ViewHash: this.Hash, NodeKey: pKey } ] : [],
				ChipsSlot: tmpChips,
				MetersSlot: tmpMeters,
				Selected: (this._state().SelectedKey === pKey),
			},
			this._caretSlots(!!pNode.HasChildren, pNode.Expanded));
		tmpDescriptor.SelfSlot = [ tmpDescriptor ];
		return tmpDescriptor;
	}

	/**
	 * Normalize an entity's host-supplied RowMeters(record) into render-ready meter records. Each meter is a
	 * `{ Kind:'bar'|'pill', Tone:'ok'|'warn'|'bad'|'muted', Text, Label, Title, Percent }`; bars carry a clamped
	 * 0-100 Percent, pills carry Text. Errors in the host hook degrade to no meters (never a broken row).
	 */
	_rowMeters(pEntityConfig, pRecord)
	{
		let tmpMeters;
		try { tmpMeters = pEntityConfig.RowMeters(pRecord) || []; }
		catch (pError) { this.log.warn(`Pict-DataExplorer: RowMeters threw for [${pEntityConfig.IDField}]: ${pError && pError.message}`); return []; }
		if (!Array.isArray(tmpMeters)) { return []; }
		return tmpMeters.filter((pMeter) => pMeter && (pMeter.Kind === 'bar' || pMeter.Kind === 'pill')).map((pMeter) =>
			(
				{
					Kind: pMeter.Kind,
					Tone: pMeter.Tone || 'muted',
					Text: (pMeter.Text != null) ? String(pMeter.Text) : '',
					Label: (pMeter.Label != null) ? String(pMeter.Label) : '',
					Title: (pMeter.Title != null) ? String(pMeter.Title) : '',
					Percent: Math.max(0, Math.min(100, Number(pMeter.Percent) || 0)),
				}));
	}

	/** Resolve a Display value (a field name OR a `{~…~}` template) against a record into a display string. */
	_resolveDisplay(pValue, pRecord)
	{
		if (!pValue) { return ''; }
		if (String(pValue).indexOf('{~') >= 0)
		{
			try { return this.pict.parseTemplate(pValue, pRecord); }
			catch (pError) { return ''; }
		}
		return (pRecord && (pRecord[pValue] != null)) ? String(pRecord[pValue]) : '';
	}

	_hasCard(pEntityName)
	{
		const tmpManager = this.pict.providers.RecordSetCardManager;
		return !!(tmpManager && (typeof tmpManager.hasCard === 'function') && tmpManager.hasCard(pEntityName));
	}

	/** True when a card manager is available to open ANY record's preview (a registered or a default card). */
	_cardManagerPresent()
	{
		const tmpManager = this.pict.providers.RecordSetCardManager;
		return !!(tmpManager && (typeof tmpManager.openCard === 'function'));
	}
}

module.exports = PictViewDataExplorer;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":733}],550:[function(require,module,exports){
/**
 * Theme Diagram Adapter
 *
 * Helper utilities for plugging diagram renderers (Mermaid today,
 * Excalidraw / chart libraries next) into the pict-provider-theme
 * lifecycle.
 *
 * Why this exists:
 *   Diagram engines like Mermaid bake colors into the SVG at render
 *   time. Once rendered, CSS alone cannot recolor node fills, cluster
 *   backgrounds, or edge stroke ends — those are inline attributes on
 *   <rect>, <path>, <polygon>, etc.  Switching light/dark requires
 *   the engine to re-render with a fresh themeVariables block.
 *
 *   Pre-adapter, every view that hosted a Mermaid block had to:
 *     - read every CSS custom property by hand
 *     - mirror a 20+ key themeVariables object
 *     - wire its own onApply subscription
 *     - stash diagram source on the DOM
 *     - clear data-processed + re-run on theme change
 *
 *   The adapter centralizes all of that.  Section views call
 *   `adapter.adaptMermaid(mermaid, options)` and stop caring about the
 *   token list, the listener, and the refresh dance.
 *
 *  Public API:
 *     buildMermaidThemeVariables(pOverrides)        - read fresh tokens, return mermaid themeVariables
 *     getMermaidTokenMap()                          - canonical {mermaidKey: cssVarName} map
 *     initializeMermaid(mermaid, pOverrides)        - mermaid.initialize() with the right base + themeVariables
 *     refreshMermaidDiagrams(pSelectorOrRoot)       - restore source, clear data-processed, re-run mermaid.run
 *     stashMermaidSource(pNodes)                    - cache source on data-mermaid-source before first run
 *     adaptMermaid(provider, mermaid, pOptions)     - one-shot: initialize + subscribe + return handle
 *     readCSSVar(pName, pFallback, pRoot)           - fresh getComputedStyle read with fallback
 *
 *  All helpers are stateless and safe to call repeatedly.  Subscriptions
 *  return a dispose function the caller can hold onto for teardown.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// Canonical mapping: mermaid themeVariables key -> CSS custom property name -> fallback.
// Fallbacks match the pict-default LIGHT palette so unthemed apps look like
// the default theme rather than a third unrelated palette.
const MERMAID_TOKEN_MAP =
[
	// Primary surfaces (node fills + cluster background)
	{ Key: 'primaryColor',         Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'primaryTextColor',     Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'primaryBorderColor',   Var: '--theme-color-brand-primary',        Fallback: '#3357c7' },
	// Secondary (alt rows, alternate nodes, sequence actor bg)
	{ Key: 'secondaryColor',       Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'secondaryTextColor',   Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'secondaryBorderColor', Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Tertiary (clusters, accent groups)
	{ Key: 'tertiaryColor',        Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'tertiaryTextColor',    Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'tertiaryBorderColor',  Var: '--theme-color-border-light',         Fallback: '#e9e9e9' },
	// Page-level + line + note
	{ Key: 'background',           Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'mainBkg',              Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'secondBkg',            Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'lineColor',            Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'textColor',            Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBkgColor',         Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'noteTextColor',        Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBorderColor',      Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Status (Mermaid uses these for error/warning highlights)
	{ Key: 'errorBkgColor',        Var: '--theme-color-status-error',         Fallback: '#b62828' },
	{ Key: 'errorTextColor',       Var: '--theme-color-text-on-brand',        Fallback: '#ffffff' },
	// Typography
	{ Key: 'fontFamily',           Var: '--theme-typography-family-sans',     Fallback: 'inherit' }
];

/**
 * Read a CSS custom property off pRoot (default: documentElement).
 * Always issues a fresh getComputedStyle so the value reflects the
 * current class state on <html> (theme-light / theme-dark).
 *
 * @param {string} pName     - variable name including '--' prefix
 * @param {string} [pFallback] - returned when the variable is unset/empty
 * @param {Element} [pRoot]  - element to compute style against
 * @returns {string}
 */
function readCSSVar(pName, pFallback, pRoot)
{
	if (typeof window === 'undefined' || typeof document === 'undefined')
	{
		return pFallback || '';
	}
	let tmpRoot = pRoot || document.documentElement;
	if (!tmpRoot)
	{
		return pFallback || '';
	}
	let tmpVal = (getComputedStyle(tmpRoot).getPropertyValue(pName) || '').trim();
	return tmpVal || pFallback || '';
}

/**
 * Returns the canonical {mermaidKey: cssVarName} mapping.  Useful for
 * apps that need to inspect or extend the token list (e.g. to add
 * gantt / sequence / pie-specific tokens for a custom diagram type).
 *
 * @returns {Array<{Key, Var, Fallback}>}
 */
function getMermaidTokenMap()
{
	// Defensive copy so callers can't mutate the canonical list.
	return MERMAID_TOKEN_MAP.map((tmpEntry) => ({ Key: tmpEntry.Key, Var: tmpEntry.Var, Fallback: tmpEntry.Fallback }));
}

/**
 * Read every token in the mermaid map off the current document and
 * return an object suitable for mermaid.initialize({themeVariables}).
 *
 * @param {object} [pOverrides] - extra themeVariables keys to merge on top
 * @returns {object}
 */
function buildMermaidThemeVariables(pOverrides)
{
	let tmpVars = {};
	for (let i = 0; i < MERMAID_TOKEN_MAP.length; i++)
	{
		let tmpEntry = MERMAID_TOKEN_MAP[i];
		tmpVars[tmpEntry.Key] = readCSSVar(tmpEntry.Var, tmpEntry.Fallback);
	}
	if (pOverrides && typeof pOverrides === 'object')
	{
		let tmpKeys = Object.keys(pOverrides);
		for (let j = 0; j < tmpKeys.length; j++)
		{
			tmpVars[tmpKeys[j]] = pOverrides[tmpKeys[j]];
		}
	}
	return tmpVars;
}

/**
 * Call mermaid.initialize() with the canonical pict theme bindings.
 * Safe to call repeatedly; mermaid simply merges new config.
 *
 * @param {object} mermaid - the mermaid module / global
 * @param {object} [pOverrides] - extra themeVariables keys, or { config: ... }
 *                                to override startOnLoad / securityLevel / theme
 * @returns {boolean} true if initialize ran, false if no mermaid available
 */
function initializeMermaid(mermaid, pOverrides)
{
	if (!mermaid || typeof mermaid.initialize !== 'function') { return false; }
	let tmpOverrides = pOverrides || {};
	let tmpThemeOverrides = tmpOverrides.themeVariables;
	let tmpConfigOverrides = tmpOverrides.config || {};
	let tmpVars = buildMermaidThemeVariables(tmpThemeOverrides);
	let tmpConfig = Object.assign(
	{
		startOnLoad: false,
		theme: 'base',
		securityLevel: 'loose'
	}, tmpConfigOverrides,
	{
		themeVariables: tmpVars
	});
	mermaid.initialize(tmpConfig);
	return true;
}

/**
 * Cache each diagram's source text on data-mermaid-source so a later
 * refresh can restore it.  Mermaid replaces textContent with the
 * rendered SVG during run(); without this stash there's no way to
 * re-run.
 *
 * @param {NodeList|Array<Element>} pNodes
 */
function stashMermaidSource(pNodes)
{
	if (!pNodes || pNodes.length < 1) { return; }
	for (let i = 0; i < pNodes.length; i++)
	{
		let tmpEl = pNodes[i];
		if (!tmpEl || typeof tmpEl.getAttribute !== 'function') { continue; }
		if (!tmpEl.hasAttribute('data-mermaid-source'))
		{
			tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
		}
	}
}

/**
 * Restore each pre.mermaid[data-mermaid-source] element to its source
 * text, drop the data-processed flag (mermaid skips elements with that
 * flag set), strip the mermaid-rendered helper class if present, and
 * re-run mermaid against them.
 *
 * @param {string|Element|Document} [pSelectorOrRoot]
 *   - string: querySelectorAll target (defaults to whole document)
 *   - Element: scoped root to search inside
 *   - omitted: whole document
 * @returns {Promise|null} the mermaid.run() promise, or null if no work
 */
function refreshMermaidDiagrams(pSelectorOrRoot)
{
	if (typeof document === 'undefined') { return null; }
	let tmpMermaid = (typeof mermaid !== 'undefined') ? mermaid : null;
	if (!tmpMermaid || typeof tmpMermaid.run !== 'function') { return null; }

	let tmpRendered = _resolveMermaidNodes(pSelectorOrRoot);
	if (!tmpRendered || tmpRendered.length < 1) { return null; }

	for (let i = 0; i < tmpRendered.length; i++)
	{
		let tmpEl = tmpRendered[i];
		let tmpSrc = tmpEl.getAttribute('data-mermaid-source');
		if (tmpSrc !== null) { tmpEl.textContent = tmpSrc; }
		tmpEl.removeAttribute('data-processed');
		if (tmpEl.classList && typeof tmpEl.classList.remove === 'function')
		{
			tmpEl.classList.remove('mermaid-rendered');
		}
	}

	try
	{
		let tmpResult = tmpMermaid.run({ nodes: tmpRendered });
		// After mermaid finishes drawing, strip the !important flags it
		// bakes into per-node inline fill/stroke styles. See
		// stripMermaidStyleImportance() docs for the why.
		if (tmpResult && typeof tmpResult.then === 'function')
		{
			return tmpResult.then(function ()
			{
				stripMermaidStyleImportance(tmpRendered);
				return tmpResult;
			});
		}
		// Synchronous fallback (older mermaid versions).
		stripMermaidStyleImportance(tmpRendered);
		return tmpResult;
	}
	catch (pError)
	{
		// Surface to the caller; they're already wrapping in try/catch in
		// most cases.  Return a rejected promise so .catch() consumers fire.
		return Promise.reject(pError);
	}
}

/**
 * Mermaid 11's flowchart `style X fill:#...` directive emits the fill
 * and stroke inline with `!important`:
 *
 *   <rect class="basic label-container"
 *         style="fill:#e8f5e9 !important;stroke:#43a047 !important"/>
 *
 * Inline `!important` beats external `!important` via specificity, so
 * any theme-aware CSS we write (e.g. `.theme-dark ... { fill: theme-bg
 * !important }`) silently loses no matter how strong its selector.
 * Diagrams keep their Material pastels even in dark themes — light
 * fills with light text = unreadable.
 *
 * Strip just the `!important` flag off mermaid-emitted inline styles
 * after every render.  The fill/stroke values themselves stay intact,
 * so light mode keeps the author-intended palette; in dark mode the
 * external `.theme-dark` CSS now reaches the rect and recolors to a
 * theme-aware background.
 *
 * Must run after every mermaid render — initial + every re-render
 * triggered by a theme change.  `refreshMermaidDiagrams` calls it on
 * re-renders; the initial render in pict-section-content's view calls
 * it via the provider's `diagram.stripMermaidStyleImportance` handle.
 *
 * @param {string|Element|NodeList|Array} [pTarget]
 *   - omitted: scan the whole document
 *   - string: querySelector scope (e.g. '#Pict-Content-Body')
 *   - Element: scan within this element
 *   - NodeList/Array of `pre.mermaid` elements: scan within each
 * @returns {number} count of shapes that had !important stripped
 */
function stripMermaidStyleImportance(pTarget)
{
	if (typeof document === 'undefined') { return 0; }

	let tmpMermaids;
	if (!pTarget)
	{
		tmpMermaids = document.querySelectorAll('pre.mermaid');
	}
	else if (typeof pTarget === 'string')
	{
		let tmpScope = document.querySelector(pTarget);
		tmpMermaids = tmpScope ? tmpScope.querySelectorAll('pre.mermaid') : [];
	}
	else if (pTarget.length !== undefined)
	{
		// NodeList or Array of pre.mermaid elements
		tmpMermaids = pTarget;
	}
	else if (pTarget.querySelectorAll)
	{
		tmpMermaids = pTarget.querySelectorAll('pre.mermaid');
	}
	else
	{
		return 0;
	}

	let tmpStripped = 0;
	for (let i = 0; i < tmpMermaids.length; i++)
	{
		let tmpMerm = tmpMermaids[i];
		if (!tmpMerm || !tmpMerm.querySelectorAll) { continue; }
		let tmpShapes = tmpMerm.querySelectorAll(
			'.node rect[style*="!important"], ' +
			'.node polygon[style*="!important"], ' +
			'.node circle[style*="!important"], ' +
			'.node ellipse[style*="!important"], ' +
			'.node path[style*="!important"], ' +
			'.cluster rect[style*="!important"]'
		);
		for (let j = 0; j < tmpShapes.length; j++)
		{
			let tmpEl = tmpShapes[j];
			let tmpStyle = tmpEl.getAttribute('style') || '';
			if (tmpStyle.indexOf('!important') < 0) { continue; }
			tmpEl.setAttribute('style', tmpStyle.replace(/\s*!important\s*/gi, ''));
			tmpStripped++;
		}
	}
	return tmpStripped;
}

function _resolveMermaidNodes(pSelectorOrRoot)
{
	let tmpSelector = 'pre.mermaid[data-mermaid-source]';
	if (!pSelectorOrRoot)
	{
		return document.querySelectorAll(tmpSelector);
	}
	if (typeof pSelectorOrRoot === 'string')
	{
		// Treat the string as a scope selector; collect mermaid nodes inside it.
		let tmpScope = document.querySelector(pSelectorOrRoot);
		if (!tmpScope) { return []; }
		return tmpScope.querySelectorAll(tmpSelector);
	}
	if (pSelectorOrRoot.querySelectorAll)
	{
		return pSelectorOrRoot.querySelectorAll(tmpSelector);
	}
	return [];
}

/**
 * One-shot: initialize mermaid against the active theme, subscribe to
 * theme apply events, and return a handle the caller can use for
 * teardown / manual refresh.
 *
 *   let tmpHandle = adaptMermaid(pict.providers.Theme, mermaid, {
 *       refreshScope: '#Pict-Content-Body'
 *   });
 *   // ... later, on unload:
 *   tmpHandle.dispose();
 *
 * @param {object} pProvider - pict-provider-theme instance
 * @param {object} pMermaid  - the mermaid module / global
 * @param {object} [pOptions]
 *   @param {string|Element} [pOptions.refreshScope] - passed to refreshMermaidDiagrams
 *   @param {object} [pOptions.themeOverrides]       - extra themeVariables keys
 *   @param {object} [pOptions.configOverrides]      - extra mermaid.initialize() top-level keys
 *   @param {function} [pOptions.onBeforeRefresh]    - called before each refresh; signature (pContext)
 *   @param {function} [pOptions.onAfterRefresh]     - called after each refresh resolves; signature (pContext)
 * @returns {{ dispose: function, refresh: function, reinitialize: function, subscribed: boolean }}
 */
function adaptMermaid(pProvider, pMermaid, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpInitOverrides =
	{
		themeVariables: tmpOptions.themeOverrides,
		config: tmpOptions.configOverrides
	};

	// Always initialize, even if no provider — the static base theme should
	// still pick up whatever CSS variables the page does have.
	initializeMermaid(pMermaid, tmpInitOverrides);

	let tmpRefresh = function (pContext)
	{
		if (typeof tmpOptions.onBeforeRefresh === 'function')
		{
			try { tmpOptions.onBeforeRefresh(pContext || {}); }
			catch (e) { /* swallow; refresh must not be gated on listener errors */ }
		}
		initializeMermaid(pMermaid, tmpInitOverrides);
		let tmpResult = refreshMermaidDiagrams(tmpOptions.refreshScope);
		if (tmpResult && typeof tmpResult.then === 'function' && typeof tmpOptions.onAfterRefresh === 'function')
		{
			tmpResult.then(
				() => { try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ } },
				() => { /* error path: onAfterRefresh still fires so the UI can drop spinners */
					try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ }
				}
			);
		}
		return tmpResult;
	};

	let tmpDispose = function () {};
	let tmpSubscribed = false;
	if (pProvider && typeof pProvider.onApply === 'function')
	{
		tmpDispose = pProvider.onApply(function (pBundle, pContext)
		{
			tmpRefresh(pContext || {});
		});
		tmpSubscribed = true;
	}

	return {
		dispose: function ()
		{
			if (typeof tmpDispose === 'function') { tmpDispose(); }
		},
		refresh: tmpRefresh,
		reinitialize: function () { initializeMermaid(pMermaid, tmpInitOverrides); },
		subscribed: tmpSubscribed
	};
}

module.exports =
{
	MERMAID_TOKEN_MAP: MERMAID_TOKEN_MAP,
	readCSSVar: readCSSVar,
	getMermaidTokenMap: getMermaidTokenMap,
	buildMermaidThemeVariables: buildMermaidThemeVariables,
	initializeMermaid: initializeMermaid,
	stashMermaidSource: stashMermaidSource,
	refreshMermaidDiagrams: refreshMermaidDiagrams,
	stripMermaidStyleImportance: stripMermaidStyleImportance,
	adaptMermaid: adaptMermaid
};

},{}],551:[function(require,module,exports){
module.exports={
    "name": "pict-provider",
    "version": "1.0.13",
    "description": "Pict Provider Base Class",
    "main": "source/Pict-Provider.js",
    "scripts": {
        "start": "node source/Pict-Provider.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
        "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
        "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Provider.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-provider.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-provider/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "eslint": "^9.39.1",
        "pict": "^1.0.351",
        "pict-docuserve": "^0.1.5",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],552:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":551,"fable-serviceproviderbase":438}],553:[function(require,module,exports){
// The container for all the Pict-Section-Accordion related code.
//
// pict-section-accordion is a pict-native multi-step container: it renders the SAME step set as a
// collapsible accordion, a back/next wizard, or a numbered stepper, over one shared serializable nav
// state with per-step CanAdvance gating. It owns the chrome + navigation only — the HOST renders each
// step's body view into the step's always-present body container, so navigation never wipes content.

// The accordion provider (primary API surface — registers the view + CSS, exposes createAccordion()).
const PictProviderAccordion = require('./providers/Pict-Provider-Accordion.js');

// The multi-step view (also registered on demand by the provider's createAccordion()).
const PictViewAccordion = require('./views/PictView-Accordion.js');

module.exports = PictProviderAccordion;

module.exports.PictProviderAccordion = PictProviderAccordion;
module.exports.PictViewAccordion = PictViewAccordion;

module.exports.default_configuration = PictProviderAccordion.default_configuration;

},{"./providers/Pict-Provider-Accordion.js":554,"./views/PictView-Accordion.js":555}],554:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewAccordion = require('../views/PictView-Accordion.js');

// Themeable control CSS, registered once by hash. Host apps brand by defining the --theme-* tokens;
// the hardcoded values are fallbacks. Covers all three render modes (accordion / wizard / stepper).
const _AccordionCSS = /*css*/`
.psa { width: 100%; box-sizing: border-box; font-size: var(--theme-typography-size-md, 0.95rem); color: var(--theme-color-text-primary, #1f2733); }
.psa *, .psa *::before, .psa *::after { box-sizing: border-box; }

/* ---- Step bodies (shared by wizard + stepper): all present, only the active one shown. ---- */
.psa-step-body { display: none; }
.psa-step-body.psa-step-body-active { display: block; }

/* ---- Accordion mode ---- */
.psa-panel { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: var(--theme-radius-lg, 10px);
	margin-bottom: var(--theme-spacing-sm, 0.6rem); overflow: hidden; background: var(--theme-color-background-panel, #fff); }
.psa-panel-header { display: flex; align-items: center; gap: var(--theme-spacing-sm, 0.6rem); width: 100%; cursor: pointer; text-align: left;
	font: inherit; padding: var(--theme-spacing-md, 0.75rem) var(--theme-spacing-md, 0.9rem); border: none;
	background: var(--theme-color-background-secondary, #f6f7f9); color: var(--theme-color-text-primary, #1f2733); }
.psa-panel-header:hover { background: var(--theme-color-background-hover, #eef1f5); }
.psa-panel-header:disabled { cursor: not-allowed; opacity: 0.55; }
.psa-panel-header:focus-visible { outline: none; box-shadow: inset 0 0 0 2px color-mix(in srgb, var(--theme-color-focus-outline, #156dd1) 45%, transparent); }
.psa-panel-active > .psa-panel-header { background: var(--theme-color-background-selected, #e7eefb); }
.psa-panel-title { flex: 1 1 auto; min-width: 0; font-weight: var(--theme-typography-weight-medium, 600); display: flex; flex-direction: column; }
.psa-panel-indicator { flex: 0 0 auto; display: inline-flex; }
.psa-panel-chevron { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-text-muted, #6b7686); transition: transform var(--theme-duration-normal, 0.18s) ease; }
.psa-panel-open > .psa-panel-header .psa-panel-chevron { transform: rotate(180deg); }
.psa-panel-body { display: none; padding: var(--theme-spacing-lg, 1rem); border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
.psa-panel-open > .psa-panel-body { display: block; }

/* ---- Stepper mode ---- */
.psa-rail { display: flex; align-items: flex-start; gap: 0; margin-bottom: var(--theme-spacing-lg, 1rem); }
.psa-rail-item { flex: 1 1 0; display: flex; flex-direction: column; align-items: center; gap: 0.35rem; cursor: pointer; position: relative;
	border: none; background: transparent; font: inherit; color: var(--theme-color-text-muted, #6b7686); padding: 0; }
.psa-rail-item:disabled { cursor: not-allowed; opacity: 0.5; }
.psa-rail-item::before { content: ""; position: absolute; top: 14px; left: -50%; width: 100%; height: 2px; background: var(--theme-color-border-default, #d7dce3); z-index: 0; }
.psa-rail-item:first-child::before { display: none; }
.psa-rail-item.psa-rail-complete::before { background: var(--theme-color-status-success, #2e7a3a); }
.psa-rail-medallion { position: relative; z-index: 1; display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px;
	border-radius: var(--theme-radius-pill, 999px); background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b);
	font-size: var(--theme-typography-size-sm, 0.85rem); font-weight: var(--theme-typography-weight-medium, 600); }
.psa-rail-active .psa-rail-medallion { background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-background-panel, #fff); }
.psa-rail-complete .psa-rail-medallion { background: var(--theme-color-status-success, #2e7a3a); color: var(--theme-color-background-panel, #fff); }
.psa-rail-error .psa-rail-medallion { background: var(--theme-color-status-error, #b62828); color: var(--theme-color-background-panel, #fff); }
.psa-rail-label { font-size: var(--theme-typography-size-sm, 0.82rem); text-align: center; max-width: 12ch; }
.psa-rail-active .psa-rail-label { color: var(--theme-color-text-primary, #1f2733); font-weight: var(--theme-typography-weight-medium, 600); }

/* ---- Wizard mode ---- */
.psa-wizard-head { margin-bottom: var(--theme-spacing-md, 0.9rem); }
.psa-wizard-step { font-size: var(--theme-typography-size-xs, 0.76rem); color: var(--theme-color-text-muted, #6b7686); text-transform: uppercase; letter-spacing: 0.04em; }
.psa-wizard-title { font-size: var(--theme-typography-size-lg, 1.15rem); font-weight: var(--theme-typography-weight-bold, 700); }

/* ---- Subtitles + state icons ---- */
.psa-subtitle { font-size: var(--theme-typography-size-xs, 0.78rem); font-weight: var(--theme-typography-weight-regular, 400); color: var(--theme-color-text-muted, #6b7686); }
.psa-ic-check { display: inline-flex; color: var(--theme-color-status-success, #2e7a3a); }
.psa-ic-warn { display: inline-flex; color: var(--theme-color-status-error, #b62828); }

/* ---- Error chrome ---- */
.psa-step-error { display: flex; align-items: center; gap: 0.4rem; margin-bottom: var(--theme-spacing-sm, 0.6rem);
	padding: 0.5rem 0.7rem; border-radius: var(--theme-radius-md, 6px); font-size: var(--theme-typography-size-sm, 0.86rem);
	color: var(--theme-color-status-error, #b62828); background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 10%, transparent); }

/* ---- Nav footer (wizard + stepper) ---- */
.psa-nav { display: flex; justify-content: space-between; gap: var(--theme-spacing-sm, 0.6rem); margin-top: var(--theme-spacing-lg, 1rem); }
.psa-nav-back, .psa-nav-next { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit;
	padding: 0.45rem 0.9rem; border-radius: var(--theme-radius-md, 6px); }
.psa-nav-back { border: 1px solid var(--theme-color-border-default, #d7dce3); background: transparent; color: var(--theme-color-text-secondary, #45596b); }
.psa-nav-back:hover:not(:disabled) { background: var(--theme-color-background-hover, #eef1f5); }
.psa-nav-back:disabled { opacity: 0.5; pointer-events: none; }
.psa-nav-next { border: none; background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-background-panel, #fff); margin-left: auto;
	font-weight: var(--theme-typography-weight-medium, 600); }
.psa-nav-next:hover { background: var(--theme-color-brand-primaryhover, #1257ab); }
.psa-nav-done { background: var(--theme-color-status-success, #2e7a3a); }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Section-Accordion',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/**
 * The pict-section-accordion provider — the primary API surface. Registers the control CSS once and
 * creates/manages accordion view instances. (The base icon set already supplies ChevronDown / Check /
 * Warning / ArrowLeft / ArrowRight, so no custom icon set is needed.)
 */
class PictProviderAccordion extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Accordion-CSS', _AccordionCSS, 500);
		}
	}

	/**
	 * Create (or reconfigure + reuse) an accordion view instance.
	 * @param {string} pAccordionHash - unique hash/id; renders into `#<hash>` unless a DestinationAddress is given.
	 * @param {Record<string, any>} pConfig - accordion configuration (see PictViewAccordion defaults).
	 * @return {any} The accordion view instance.
	 */
	createAccordion(pAccordionHash, pConfig)
	{
		const tmpConfig = Object.assign(
			{
				DestinationAddress: `#${pAccordionHash}`,
				RenderMode: 'accordion',
				Steps: [],
				AllowMultipleOpen: false,
				LinearGating: true,
			},
			pConfig || {},
			{ AccordionHash: pAccordionHash });

		if (this.pict.views[pAccordionHash])
		{
			const tmpView = this.pict.views[pAccordionHash];
			Object.assign(tmpView.options, tmpConfig);
			tmpView.reconfigureSteps(tmpConfig.Steps);
			return tmpView;
		}
		return this.pict.addView(pAccordionHash, tmpConfig, libPictViewAccordion);
	}
}

module.exports = PictProviderAccordion;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../views/PictView-Accordion.js":555,"pict-provider":552}],555:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Normalize a host step list into the internal step shape (defaults filled, unique-Hash enforced).
 * The CanAdvance function rides ONLY on these instance steps — never in AppData — so the AppData
 * nav state stays JSON-serializable.
 * @param {string} pAccordionHash @param {Array<any>} pSteps
 * @return {Array<Record<string, any>>}
 */
const normalizeSteps = (pAccordionHash, pSteps) =>
{
	const tmpSteps = Array.isArray(pSteps) ? pSteps : [];
	const tmpSeen = {};
	return tmpSteps.map((pStep, pIndex) =>
	{
		if (!pStep || !pStep.Hash) { throw new Error('pict-section-accordion: every step needs a unique Hash.'); }
		if (tmpSeen[pStep.Hash]) { throw new Error(`pict-section-accordion: duplicate step Hash "${pStep.Hash}".`); }
		tmpSeen[pStep.Hash] = true;
		return {
			Hash: pStep.Hash,
			Title: (pStep.Title !== undefined) ? pStep.Title : pStep.Hash,
			Subtitle: pStep.Subtitle || '',
			DestinationAddress: pStep.DestinationAddress || `#PSA_Body_${pAccordionHash}_${pStep.Hash}`,
			Enabled: (pStep.Enabled !== false),
			Complete: !!pStep.Complete,
			Active: !!pStep.Active,
			Error: pStep.Error || null,
			CanAdvance: (typeof pStep.CanAdvance === 'function') ? pStep.CanAdvance : null,
			BodyViewHash: pStep.BodyViewHash || '',
			Index: pIndex,
		};
	});
};

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-Section-Accordion-View',

	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,

	DefaultRenderable: 'Pict-Section-Accordion-Renderable',

	// Per-instance options (supplied by PictProviderAccordion.createAccordion):
	AccordionHash: false,
	DestinationAddress: false,
	// Optional override of the AppData slot holding the serializable nav state.
	StateAddress: false,
	// 'accordion' | 'wizard' | 'stepper'.
	RenderMode: 'accordion',
	Steps: [],
	// Accordion: allow more than one panel open at once.
	AllowMultipleOpen: false,
	// Wizard/stepper: block rail-jumps past the furthest-reached step.
	LinearGating: true,
	BackLabel: 'Back',
	NextLabel: 'Next',
	DoneLabel: 'Done',
	GateBlockedMessage: 'Please complete this step before continuing.',
	OnStepChange: false,
	OnComplete: false,

	Templates:
	[
		{
			// Mode dispatch: exactly one of the slots is a single-element array, so only that mode's
			// layout renders. Each slot record carries everything its mode template references.
			Hash: 'Pict-Section-Accordion-Container',
			Template: /*html*/`<div class="psa psa--{~D:Record.RenderMode~}" id="PSA_{~D:Record.AccordionHash~}">{~TS:Pict-Section-Accordion-AccordionMode:Record.AccordionSlot~}{~TS:Pict-Section-Accordion-WizardMode:Record.WizardSlot~}{~TS:Pict-Section-Accordion-StepperMode:Record.StepperSlot~}</div>`
		},

		// ---- Accordion mode ----
		{
			Hash: 'Pict-Section-Accordion-AccordionMode',
			Template: /*html*/`{~TS:Pict-Section-Accordion-Panel:Record.Steps~}`
		},
		{
			// A panel: a header button + an always-present body container. Open/active/error state lives
			// in classes toggled at navigation time (so the host-rendered body is never re-created); the
			// header's inner content is repainted on flag changes via PanelHeaderInner.
			Hash: 'Pict-Section-Accordion-Panel',
			Template: /*html*/`
<div class="psa-panel{~NE:Record.IsOpen^ psa-panel-open~}{~NE:Record.Active^ psa-panel-active~}{~NE:Record.NotEnabled^ psa-panel-disabled~}{~NE:Record.HasError^ psa-panel-error~}" id="PSA_Panel_{~D:Record.AccordionHash~}_{~D:Record.Hash~}">
	<button type="button" class="psa-panel-header" id="PSA_Header_{~D:Record.AccordionHash~}_{~D:Record.Hash~}"{~NE:Record.NotEnabled^ disabled~} aria-expanded="{~D:Record.IsOpenStr~}" onclick="_Pict.views['{~D:Record.AccordionHash~}'].toggleStep('{~D:Record.Hash~}')">{~T:Pict-Section-Accordion-PanelHeaderInner~}</button>
	<div class="psa-panel-body" id="{~D:Record.BodyDomId~}"></div>
</div>`
		},
		{
			Hash: 'Pict-Section-Accordion-PanelHeaderInner',
			Template: /*html*/`<span class="psa-panel-indicator">{~TS:Pict-Section-Accordion-Check:Record.CompleteSlot~}{~TS:Pict-Section-Accordion-Warn:Record.ErrorIconSlot~}</span><span class="psa-panel-title">{~D:Record.Title~}{~TS:Pict-Section-Accordion-Subtitle:Record.SubtitleSlot~}</span><span class="psa-panel-chevron">{~I:ChevronDown~}</span>`
		},

		// ---- Wizard mode ----
		{
			Hash: 'Pict-Section-Accordion-WizardMode',
			Template: /*html*/`
<div class="psa-wizard">
	<div class="psa-wizard-head" id="PSA_WizHead_{~D:Record.AccordionHash~}">{~T:Pict-Section-Accordion-WizardHeadInner~}</div>
	<div class="psa-err" id="PSA_Err_{~D:Record.AccordionHash~}">{~T:Pict-Section-Accordion-ErrorRegion~}</div>
	<div class="psa-bodies">{~TS:Pict-Section-Accordion-StepBody:Record.Steps~}</div>
	<div class="psa-nav-wrap" id="PSA_Nav_{~D:Record.AccordionHash~}">{~T:Pict-Section-Accordion-NavFooterInner~}</div>
</div>`
		},
		{
			Hash: 'Pict-Section-Accordion-WizardHeadInner',
			Template: /*html*/`<div class="psa-wizard-step">{~D:Record.StepNumberLabel~}</div><div class="psa-wizard-title">{~D:Record.ActiveTitle~}{~TS:Pict-Section-Accordion-Subtitle:Record.ActiveSubtitleSlot~}</div>`
		},

		// ---- Stepper mode ----
		{
			Hash: 'Pict-Section-Accordion-StepperMode',
			Template: /*html*/`
<div class="psa-stepper">
	<div class="psa-rail" id="PSA_Rail_{~D:Record.AccordionHash~}">{~T:Pict-Section-Accordion-RailInner~}</div>
	<div class="psa-err" id="PSA_Err_{~D:Record.AccordionHash~}">{~T:Pict-Section-Accordion-ErrorRegion~}</div>
	<div class="psa-bodies">{~TS:Pict-Section-Accordion-StepBody:Record.Steps~}</div>
	<div class="psa-nav-wrap" id="PSA_Nav_{~D:Record.AccordionHash~}">{~T:Pict-Section-Accordion-NavFooterInner~}</div>
</div>`
		},
		{
			Hash: 'Pict-Section-Accordion-RailInner',
			Template: /*html*/`{~TS:Pict-Section-Accordion-RailItem:Record.Steps~}`
		},
		{
			Hash: 'Pict-Section-Accordion-RailItem',
			Template: /*html*/`
<button type="button" class="psa-rail-item{~NE:Record.Active^ psa-rail-active~}{~NE:Record.Complete^ psa-rail-complete~}{~NE:Record.HasError^ psa-rail-error~}{~NE:Record.NotEnabled^ psa-rail-disabled~}"{~NE:Record.NotEnabled^ disabled~} aria-current="{~D:Record.AriaCurrent~}" onclick="_Pict.views['{~D:Record.AccordionHash~}'].goToStep('{~D:Record.Hash~}')">
	<span class="psa-rail-medallion">{~TS:Pict-Section-Accordion-Check:Record.CompleteSlot~}{~TS:Pict-Section-Accordion-Warn:Record.ErrorIconSlot~}{~TS:Pict-Section-Accordion-Number:Record.NumberSlot~}</span>
	<span class="psa-rail-label">{~D:Record.Title~}</span>
</button>`
		},

		// ---- Shared ----
		{
			// A step body container — present for every step; CSS shows only the active one (wizard/stepper).
			Hash: 'Pict-Section-Accordion-StepBody',
			Template: /*html*/`<div class="psa-step-body{~NE:Record.Active^ psa-step-body-active~}" id="{~D:Record.BodyDomId~}"></div>`
		},
		{
			Hash: 'Pict-Section-Accordion-NavFooterInner',
			Template: /*html*/`
<div class="psa-nav">
	<button type="button" class="psa-nav-back"{~NE:Record.NoBack^ disabled~} onclick="_Pict.views['{~D:Record.AccordionHash~}'].back()">{~I:ArrowLeft~} {~D:Record.BackLabel~}</button>
	{~TS:Pict-Section-Accordion-NavNext:Record.NextSlot~}{~TS:Pict-Section-Accordion-NavDone:Record.DoneSlot~}
</div>`
		},
		{
			Hash: 'Pict-Section-Accordion-NavNext',
			Template: /*html*/`<button type="button" class="psa-nav-next" onclick="_Pict.views['{~D:Record.AccordionHash~}'].next()">{~D:Record.NextLabel~} {~I:ArrowRight~}</button>`
		},
		{
			Hash: 'Pict-Section-Accordion-NavDone',
			Template: /*html*/`<button type="button" class="psa-nav-next psa-nav-done" onclick="_Pict.views['{~D:Record.AccordionHash~}'].next()">{~D:Record.DoneLabel~} {~I:Check~}</button>`
		},
		{
			Hash: 'Pict-Section-Accordion-ErrorRegion',
			Template: /*html*/`{~TS:Pict-Section-Accordion-StepError:Record.ActiveErrorSlot~}`
		},
		{
			Hash: 'Pict-Section-Accordion-StepError',
			Template: /*html*/`<div class="psa-step-error">{~I:Warning~} <span>{~D:Record.Message~}</span></div>`
		},
		{
			Hash: 'Pict-Section-Accordion-Subtitle',
			Template: /*html*/`<span class="psa-subtitle">{~D:Record.Text~}</span>`
		},
		{ Hash: 'Pict-Section-Accordion-Check', Template: /*html*/`<span class="psa-ic-check">{~I:Check~}</span>` },
		{ Hash: 'Pict-Section-Accordion-Warn', Template: /*html*/`<span class="psa-ic-warn">{~I:Warning~}</span>` },
		{ Hash: 'Pict-Section-Accordion-Number', Template: /*html*/`{~D:Record.Number~}` },
	],

	Renderables:
	[
		{
			RenderableHash: 'Pict-Section-Accordion-Renderable',
			TemplateHash: 'Pict-Section-Accordion-Container',
			RenderMethod: 'replace',
		},
	],
};

class PictViewAccordion extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.options.DefaultDestinationAddress = this.options.DestinationAddress || `#${this.options.AccordionHash}`;
		this._StateAddress = this.options.StateAddress || `AppData.PictSectionAccordion.${this.options.AccordionHash}`;
		this.options.DefaultTemplateRecordAddress = this._StateAddress;
		if (Array.isArray(this.options.Renderables) && this.options.Renderables[0])
		{
			this.options.Renderables[0].ContentDestinationAddress = this.options.DefaultDestinationAddress;
		}

		// Step config (incl. CanAdvance fns) lives on the instance; nav state lives in AppData.
		this._steps = normalizeSteps(this.options.AccordionHash, this.options.Steps);

		try { this._ensureState(); this._buildState(); } catch (pError) { /* AppData not ready — onBeforeRender will build it */ }
	}

	/** @return {Record<string, any>} The AppData nav-state slot (resolved from StateAddress). */
	_state()
	{
		let tmpState = this.pict.manifest.getValueAtAddress(this.pict, this._StateAddress);
		if (!tmpState || typeof tmpState !== 'object')
		{
			tmpState = {};
			this.pict.manifest.setValueAtAddress(this.pict, this._StateAddress, tmpState);
		}
		return tmpState;
	}

	/** Seed the serializable nav state (StepFlags + ActiveStepHash + OpenHashes + MaxReachedIndex). */
	_ensureState()
	{
		const tmpState = this._state();
		if (!tmpState.StepFlags) { tmpState.StepFlags = {}; }
		this._steps.forEach((pStep) =>
		{
			if (!tmpState.StepFlags[pStep.Hash])
			{
				tmpState.StepFlags[pStep.Hash] = { Enabled: pStep.Enabled !== false, Complete: !!pStep.Complete, Error: pStep.Error || null };
			}
		});
		if (tmpState.ActiveStepHash === undefined || tmpState.ActiveStepHash === null || !this._steps.find((pStep) => pStep.Hash === tmpState.ActiveStepHash))
		{
			const tmpActive = this._steps.find((pStep) => pStep.Active)
				|| this._steps.find((pStep) => tmpState.StepFlags[pStep.Hash].Enabled)
				|| this._steps[0];
			tmpState.ActiveStepHash = tmpActive ? tmpActive.Hash : null;
		}
		if (!Array.isArray(tmpState.OpenHashes))
		{
			tmpState.OpenHashes = tmpState.ActiveStepHash ? [ tmpState.ActiveStepHash ] : [];
		}
		if (typeof tmpState.MaxReachedIndex !== 'number')
		{
			const tmpActiveStep = this._steps.find((pStep) => pStep.Hash === tmpState.ActiveStepHash);
			tmpState.MaxReachedIndex = tmpActiveStep ? tmpActiveStep.Index : 0;
		}
	}

	/** @return {Record<string, any>} The per-step flags map. */
	_flags() { return this._state().StepFlags || {}; }
	/** @return {string|null} The active step hash. */
	_activeStepHash() { return this._state().ActiveStepHash; }
	/** @param {string} pHash */
	_setActiveStepHash(pHash) { this._state().ActiveStepHash = pHash; }
	/** @param {string} pHash @return {string} The DOM id of a step's body container. */
	_bodyDomId(pHash) { return `PSA_Body_${this.options.AccordionHash}_${pHash}`; }

	/** @return {Set<string>} The hashes whose body should currently be visible. */
	_visibleStepHashes()
	{
		if ((this.options.RenderMode || 'accordion') === 'accordion') { return new Set(this._state().OpenHashes || []); }
		return new Set([ this._activeStepHash() ]);
	}

	/** Build one step's render projection. */
	_stepProjection(pStep, pActiveHash, pVisibleSet, pFlags)
	{
		const tmpFlags = pFlags[pStep.Hash] || {};
		const tmpEnabled = (tmpFlags.Enabled !== false);
		const tmpComplete = !!tmpFlags.Complete;
		const tmpError = tmpFlags.Error || null;
		const tmpActive = (pStep.Hash === pActiveHash);
		const tmpOpen = pVisibleSet.has(pStep.Hash);
		return {
			AccordionHash: this.options.AccordionHash,
			Hash: pStep.Hash,
			Title: pStep.Title,
			Number: pStep.Index + 1,
			Index: pStep.Index,
			Active: tmpActive,
			Enabled: tmpEnabled,
			NotEnabled: !tmpEnabled,
			Complete: tmpComplete,
			HasError: !!tmpError,
			IsOpen: tmpOpen,
			IsOpenStr: tmpOpen ? 'true' : 'false',
			AriaCurrent: tmpActive ? 'step' : 'false',
			BodyDomId: this._bodyDomId(pStep.Hash),
			SubtitleSlot: pStep.Subtitle ? [ { Text: pStep.Subtitle } ] : [],
			CompleteSlot: (tmpComplete && !tmpError) ? [ {} ] : [],
			ErrorIconSlot: tmpError ? [ {} ] : [],
			NumberSlot: (!tmpComplete && !tmpError) ? [ { Number: pStep.Index + 1 } ] : [],
		};
	}

	/** (Re)compute the full render state into AppData. */
	_buildState()
	{
		this._ensureState();
		const tmpState = this._state();
		const tmpHash = this.options.AccordionHash;
		const tmpMode = this.options.RenderMode || 'accordion';
		const tmpFlags = this._flags();
		const tmpActiveHash = this._activeStepHash();
		const tmpVisible = this._visibleStepHashes();

		tmpState.AccordionHash = tmpHash;
		tmpState.RenderMode = tmpMode;
		tmpState.IsAccordion = (tmpMode === 'accordion');
		tmpState.IsWizard = (tmpMode === 'wizard');
		tmpState.IsStepper = (tmpMode === 'stepper');

		tmpState.Steps = this._steps.map((pStep) => this._stepProjection(pStep, tmpActiveHash, tmpVisible, tmpFlags));

		const tmpActiveStep = this._steps.find((pStep) => pStep.Hash === tmpActiveHash) || this._steps[0] || null;
		const tmpActiveIndex = tmpActiveStep ? tmpActiveStep.Index : 0;
		const tmpActiveFlags = (tmpActiveStep && tmpFlags[tmpActiveStep.Hash]) || {};
		const tmpActiveErrorSlot = (tmpActiveStep && tmpActiveFlags.Error) ? [ { Message: tmpActiveFlags.Error } ] : [];
		const tmpActiveBodyDomId = tmpActiveStep ? this._bodyDomId(tmpActiveStep.Hash) : '';

		const tmpIsLast = (tmpActiveIndex >= this._steps.length - 1);
		const tmpNavBase = {
			AccordionHash: tmpHash,
			NoBack: (tmpActiveIndex <= 0),
			BackLabel: this.options.BackLabel,
			NextSlot: tmpIsLast ? [] : [ { AccordionHash: tmpHash, NextLabel: this.options.NextLabel } ],
			DoneSlot: tmpIsLast ? [ { AccordionHash: tmpHash, DoneLabel: this.options.DoneLabel } ] : [],
		};

		tmpState.AccordionSlot = tmpState.IsAccordion ? [ { AccordionHash: tmpHash, Steps: tmpState.Steps } ] : [];
		tmpState.WizardSlot = tmpState.IsWizard ? [ Object.assign({
			Steps: tmpState.Steps,
			StepNumberLabel: `Step ${tmpActiveIndex + 1} of ${this._steps.length}`,
			ActiveTitle: tmpActiveStep ? tmpActiveStep.Title : '',
			ActiveSubtitleSlot: (tmpActiveStep && tmpActiveStep.Subtitle) ? [ { Text: tmpActiveStep.Subtitle } ] : [],
			ActiveBodyDomId: tmpActiveBodyDomId,
			ActiveErrorSlot: tmpActiveErrorSlot,
		}, tmpNavBase) ] : [];
		tmpState.StepperSlot = tmpState.IsStepper ? [ Object.assign({
			Steps: tmpState.Steps,
			ActiveBodyDomId: tmpActiveBodyDomId,
			ActiveErrorSlot: tmpActiveErrorSlot,
		}, tmpNavBase) ] : [];

		return tmpState;
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		this._buildState();
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		this._applyActiveClasses();
		return super.onAfterRender(pRenderable);
	}

	/** Toggle visibility classes (no body re-creation) — the navigation counterpart to picker._paintOpen. */
	_applyActiveClasses()
	{
		if (typeof document === 'undefined') { return; }
		const tmpHash = this.options.AccordionHash;
		const tmpMode = this.options.RenderMode || 'accordion';
		const tmpActiveHash = this._activeStepHash();
		const tmpVisible = this._visibleStepHashes();
		this._steps.forEach((pStep) =>
		{
			if (tmpMode === 'accordion')
			{
				const tmpPanel = document.getElementById(`PSA_Panel_${tmpHash}_${pStep.Hash}`);
				if (tmpPanel && tmpPanel.classList)
				{
					tmpPanel.classList.toggle('psa-panel-open', tmpVisible.has(pStep.Hash));
					tmpPanel.classList.toggle('psa-panel-active', pStep.Hash === tmpActiveHash);
				}
			}
			else
			{
				const tmpBody = document.getElementById(this._bodyDomId(pStep.Hash));
				if (tmpBody && tmpBody.classList) { tmpBody.classList.toggle('psa-step-body-active', tmpVisible.has(pStep.Hash)); }
			}
		});
	}

	/** Repaint ONLY the chrome (headers / rail / wizard head / nav / error) — never the body containers. */
	_renderChrome()
	{
		const tmpState = this._buildState();
		const tmpHash = this.options.AccordionHash;
		if (typeof document === 'undefined') { this._applyActiveClasses(); return; }

		if (tmpState.IsAccordion)
		{
			tmpState.Steps.forEach((pStepProjection) =>
			{
				const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Accordion-PanelHeaderInner', pStepProjection);
				this.pict.ContentAssignment.assignContent(`#PSA_Header_${tmpHash}_${pStepProjection.Hash}`, tmpHTML);
			});
		}
		else if (tmpState.IsWizard && tmpState.WizardSlot[0])
		{
			const tmpRecord = tmpState.WizardSlot[0];
			this.pict.ContentAssignment.assignContent(`#PSA_WizHead_${tmpHash}`, this.pict.parseTemplateByHash('Pict-Section-Accordion-WizardHeadInner', tmpRecord));
			this.pict.ContentAssignment.assignContent(`#PSA_Err_${tmpHash}`, this.pict.parseTemplateByHash('Pict-Section-Accordion-ErrorRegion', tmpRecord));
			this.pict.ContentAssignment.assignContent(`#PSA_Nav_${tmpHash}`, this.pict.parseTemplateByHash('Pict-Section-Accordion-NavFooterInner', tmpRecord));
		}
		else if (tmpState.IsStepper && tmpState.StepperSlot[0])
		{
			const tmpRecord = tmpState.StepperSlot[0];
			this.pict.ContentAssignment.assignContent(`#PSA_Rail_${tmpHash}`, this.pict.parseTemplateByHash('Pict-Section-Accordion-RailInner', tmpRecord));
			this.pict.ContentAssignment.assignContent(`#PSA_Err_${tmpHash}`, this.pict.parseTemplateByHash('Pict-Section-Accordion-ErrorRegion', tmpRecord));
			this.pict.ContentAssignment.assignContent(`#PSA_Nav_${tmpHash}`, this.pict.parseTemplateByHash('Pict-Section-Accordion-NavFooterInner', tmpRecord));
		}
		this._applyActiveClasses();
	}

	/** @param {number} pFromIndex @return {Record<string, any>|null} The next enabled step after an index. */
	_nextEnabledStep(pFromIndex)
	{
		const tmpFlags = this._flags();
		for (let i = pFromIndex + 1; i < this._steps.length; i++)
		{
			if ((tmpFlags[this._steps[i].Hash] || {}).Enabled !== false) { return this._steps[i]; }
		}
		return null;
	}

	/** @param {number} pFromIndex @return {Record<string, any>|null} The previous enabled step before an index. */
	_prevEnabledStep(pFromIndex)
	{
		const tmpFlags = this._flags();
		for (let i = pFromIndex - 1; i >= 0; i--)
		{
			if ((tmpFlags[this._steps[i].Hash] || {}).Enabled !== false) { return this._steps[i]; }
		}
		return null;
	}

	/** @param {string} pTo @param {string} pFrom */
	_fireStepChange(pTo, pFrom)
	{
		if (typeof this.options.OnStepChange !== 'function') { return; }
		const tmpTo = this._steps.find((pStep) => pStep.Hash === pTo) || null;
		const tmpFrom = this._steps.find((pStep) => pStep.Hash === pFrom) || null;
		try { this.options.OnStepChange(tmpTo, tmpFrom); }
		catch (pError) { this.pict.log.warn(`pict-section-accordion [${this.options.AccordionHash}] OnStepChange threw.`, pError); }
	}

	// --- Public navigation API ---

	/**
	 * Navigate to a step (wizard/stepper) or open it (accordion). Honors Enabled + LinearGating.
	 * @param {string} pHash
	 * @return {Promise<boolean>} resolves true if the navigation happened.
	 */
	goToStep(pHash)
	{
		const tmpStep = this._steps.find((pStep) => pStep.Hash === pHash);
		if (!tmpStep) { return Promise.resolve(false); }
		if ((this._flags()[pHash] || {}).Enabled === false) { return Promise.resolve(false); }
		if (this.options.LinearGating && (this.options.RenderMode !== 'accordion') && tmpStep.Index > this._state().MaxReachedIndex)
		{
			return Promise.resolve(false);
		}
		const tmpFrom = this._activeStepHash();
		if (tmpFrom === pHash && (this.options.RenderMode !== 'accordion')) { return Promise.resolve(true); }
		this._setActiveStepHash(pHash);
		if ((this.options.RenderMode || 'accordion') === 'accordion')
		{
			const tmpState = this._state();
			if (!this.options.AllowMultipleOpen) { tmpState.OpenHashes = []; }
			if (tmpState.OpenHashes.indexOf(pHash) < 0) { tmpState.OpenHashes.push(pHash); }
		}
		if (tmpStep.Index > this._state().MaxReachedIndex) { this._state().MaxReachedIndex = tmpStep.Index; }
		this._renderChrome();
		this._fireStepChange(pHash, tmpFrom);
		return Promise.resolve(true);
	}

	/**
	 * Accordion: open/close a panel (single-open unless AllowMultipleOpen). Wizard/stepper: navigate.
	 * @param {string} pHash
	 */
	toggleStep(pHash)
	{
		if ((this.options.RenderMode || 'accordion') !== 'accordion') { return this.goToStep(pHash); }
		const tmpStep = this._steps.find((pStep) => pStep.Hash === pHash);
		if (!tmpStep) { return; }
		if ((this._flags()[pHash] || {}).Enabled === false) { return; }
		const tmpState = this._state();
		const tmpFrom = this._activeStepHash();
		const tmpIndex = tmpState.OpenHashes.indexOf(pHash);
		if (tmpIndex >= 0)
		{
			tmpState.OpenHashes.splice(tmpIndex, 1);
		}
		else
		{
			if (!this.options.AllowMultipleOpen) { tmpState.OpenHashes = []; }
			tmpState.OpenHashes.push(pHash);
			this._setActiveStepHash(pHash);
		}
		this._renderChrome();
		if (tmpState.OpenHashes.indexOf(pHash) >= 0) { this._fireStepChange(pHash, tmpFrom); }
	}

	/**
	 * Advance: run the active step's CanAdvance gate; on pass, mark it complete and move to the next
	 * enabled step (or fire OnComplete on the last step). On block, set the step's error.
	 * @return {Promise<boolean>} resolves true if advanced (or completed), false if gated.
	 */
	next()
	{
		const tmpActiveHash = this._activeStepHash();
		const tmpStep = this._steps.find((pStep) => pStep.Hash === tmpActiveHash);
		if (!tmpStep) { return Promise.resolve(false); }
		return Promise.resolve(this._evaluateCanAdvance(tmpStep)).then((pResult) =>
		{
			const tmpAllow = (pResult === true) || (pResult && pResult.allow === true);
			if (!tmpAllow)
			{
				const tmpMessage = (pResult && pResult.message) ? pResult.message : this.options.GateBlockedMessage;
				this.setStepError(tmpActiveHash, tmpMessage);
				return false;
			}
			this.setStepError(tmpActiveHash, null);
			this.setStepComplete(tmpActiveHash, true);
			const tmpNext = this._nextEnabledStep(tmpStep.Index);
			if (!tmpNext)
			{
				if (typeof this.options.OnComplete === 'function') { this.options.OnComplete(); }
				return true;
			}
			if (tmpNext.Index > this._state().MaxReachedIndex) { this._state().MaxReachedIndex = tmpNext.Index; }
			this.goToStep(tmpNext.Hash);
			return true;
		});
	}

	/** Go back to the previous enabled step (never gated). */
	back()
	{
		const tmpStep = this._steps.find((pStep) => pStep.Hash === this._activeStepHash());
		if (!tmpStep) { return Promise.resolve(false); }
		const tmpPrev = this._prevEnabledStep(tmpStep.Index);
		if (!tmpPrev) { return Promise.resolve(false); }
		return this.goToStep(tmpPrev.Hash);
	}

	/** @param {Record<string, any>} pStep @return {boolean|Promise<boolean>|{allow:boolean,message?:string}} */
	_evaluateCanAdvance(pStep)
	{
		if (typeof pStep.CanAdvance !== 'function') { return true; }
		const tmpContext = { Step: pStep, AccordionHash: this.options.AccordionHash, AppData: this.pict.AppData, view: this };
		try { return pStep.CanAdvance(tmpContext); }
		catch (pError) { this.pict.log.warn(`pict-section-accordion [${this.options.AccordionHash}] CanAdvance threw; allowing.`, pError); return true; }
	}

	/** @param {string} pHash @param {boolean} pBool */
	setStepComplete(pHash, pBool)
	{
		const tmpFlags = this._flags();
		if (!tmpFlags[pHash]) { tmpFlags[pHash] = {}; }
		tmpFlags[pHash].Complete = !!pBool;
		this._renderChrome();
	}

	/** @param {string} pHash @param {boolean} pBool */
	setStepEnabled(pHash, pBool)
	{
		const tmpFlags = this._flags();
		if (!tmpFlags[pHash]) { tmpFlags[pHash] = {}; }
		tmpFlags[pHash].Enabled = !!pBool;
		this._renderChrome();
	}

	/** @param {string} pHash @param {string|null} pMessage */
	setStepError(pHash, pMessage)
	{
		const tmpFlags = this._flags();
		if (!tmpFlags[pHash]) { tmpFlags[pHash] = {}; }
		tmpFlags[pHash].Error = pMessage || null;
		this._renderChrome();
	}

	/** Re-normalize the step list (provider reconfigure path); resets nav state. @param {Array<any>} pSteps */
	reconfigureSteps(pSteps)
	{
		this._steps = normalizeSteps(this.options.AccordionHash, pSteps);
		const tmpState = this._state();
		delete tmpState.StepFlags;
		delete tmpState.ActiveStepHash;
		delete tmpState.OpenHashes;
		delete tmpState.MaxReachedIndex;
		this._ensureState();
	}

	/** @return {Record<string, any>|null} The active step config (incl. its DestinationAddress). */
	getActiveStep()
	{
		return this._steps.find((pStep) => pStep.Hash === this._activeStepHash()) || null;
	}

	/** @return {Array<string>} The open step hashes (accordion) or the single active hash. */
	getOpenSteps()
	{
		return Array.from(this._visibleStepHashes());
	}

	/** @return {Record<string, any>} The serializable nav state (function-free; round-trips through JSON). */
	getState()
	{
		const tmpState = this._state();
		return {
			AccordionHash: this.options.AccordionHash,
			RenderMode: this.options.RenderMode || 'accordion',
			ActiveStepHash: tmpState.ActiveStepHash,
			StepFlags: JSON.parse(JSON.stringify(tmpState.StepFlags || {})),
			OpenHashes: (tmpState.OpenHashes || []).slice(),
			MaxReachedIndex: tmpState.MaxReachedIndex,
		};
	}
}

module.exports = PictViewAccordion;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":733}],556:[function(require,module,exports){
/**
 * Simple syntax highlighter for use with CodeJar.
 *
 * Provides basic keyword/string/number/comment highlighting for common languages.
 * Can be replaced with Prism.js or highlight.js for more sophisticated highlighting
 * by passing a custom highlight function to the view options.
 *
 * @module Pict-Code-Highlighter
 */

// Language definition map
const _LanguageDefinitions = (
{
	'javascript':
	{
		// Combined regex to tokenize: comments, strings, template literals, regex, then everything else
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2|(`(?:[^`\\]|\\.)*?`)|(\/(?![/*])(?:\\.|\[(?:\\.|[^\]])*\]|[^/\\\n])+\/[gimsuvy]*)/g,
		keywords: /\b(async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|export|extends|finally|for|from|function|get|if|import|in|instanceof|let|new|of|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/g,
		builtins: /\b(true|false|null|undefined|NaN|Infinity|console|window|document|Math|JSON|Array|Object|String|Number|Boolean|Date|RegExp|Map|Set|Promise|Error|Symbol|parseInt|parseFloat|require|module|exports)\b/g,
		numbers: /\b(\d+\.?\d*(?:e[+-]?\d+)?|0x[0-9a-fA-F]+|0b[01]+|0o[0-7]+)\b/g
	},
	'json':
	{
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:[^"\\]|\\.)*")/g,
		keywords: /\b(true|false|null)\b/g,
		numbers: /-?\b\d+\.?\d*(?:e[+-]?\d+)?\b/g
	},
	'html':
	{
		// Tokenizer captures: (1) comments, (2) strings, (3) tags with attributes
		tokenizer: /(<!--[\s\S]*?-->)|(["'])(?:(?!\2|\\).|\\.)*?\2|(<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s+[a-zA-Z-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*))?)*\s*\/?>)/g,
		// tagToken group index for identifying tag matches
		tagGroupIndex: 3
	},
	'css':
	{
		tokenizer: /(\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		selectors: /([.#]?[a-zA-Z_][\w-]*(?:\s*[>+~]\s*[.#]?[a-zA-Z_][\w-]*)*)\s*\{/g,
		properties: /\b([a-zA-Z-]+)\s*:/g,
		numbers: /\b(\d+\.?\d*)(px|em|rem|%|vh|vw|s|ms|deg|fr)?\b/g,
		keywords: /\b(important|inherit|initial|unset|none|auto|block|inline|flex|grid)\b/g
	},
	'sql':
	{
		tokenizer: /(--[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		keywords: /\b(SELECT|FROM|WHERE|AND|OR|INSERT|INTO|VALUES|UPDATE|SET|DELETE|CREATE|TABLE|DROP|ALTER|ADD|COLUMN|INDEX|JOIN|LEFT|RIGHT|INNER|OUTER|ON|AS|ORDER|BY|GROUP|HAVING|LIMIT|OFFSET|UNION|ALL|DISTINCT|COUNT|SUM|AVG|MIN|MAX|NOT|NULL|IS|IN|BETWEEN|LIKE|EXISTS|CASE|WHEN|THEN|ELSE|END|PRIMARY|KEY|FOREIGN|REFERENCES|CONSTRAINT|DEFAULT|CHECK|UNIQUE|CASCADE|GRANT|REVOKE|COMMIT|ROLLBACK|BEGIN|TRANSACTION|INT|VARCHAR|DATETIME|AUTO_INCREMENT|CURRENT_TIMESTAMP)\b/gi,
		numbers: /\b\d+\.?\d*\b/g
	}
});

// Alias some common language names
_LanguageDefinitions['js'] = _LanguageDefinitions['javascript'];
_LanguageDefinitions['htm'] = _LanguageDefinitions['html'];

/**
 * Escape HTML special characters to prevent XSS when inserting into innerHTML.
 *
 * @param {string} pString - The string to escape
 * @returns {string} The escaped string
 */
function escapeHTML(pString)
{
	return pString
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Highlight a segment of code that is NOT inside a string or comment.
 * This applies keyword, number, and structural highlighting.
 *
 * @param {string} pCode - The code segment to highlight (already HTML-escaped)
 * @param {object} pLanguageDef - The language definition
 * @returns {string} The highlighted HTML
 */
function highlightCodeSegment(pCode, pLanguageDef)
{
	let tmpResult = pCode;

	// CSS selectors
	if (pLanguageDef.selectors)
	{
		pLanguageDef.selectors.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.selectors, '<span class="function-name">$1</span>{');
	}

	// CSS properties
	if (pLanguageDef.properties)
	{
		pLanguageDef.properties.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.properties, '<span class="property">$1</span>:');
	}

	// Keywords
	if (pLanguageDef.keywords)
	{
		pLanguageDef.keywords.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.keywords, '<span class="keyword">$1</span>');
	}

	// Builtins
	if (pLanguageDef.builtins)
	{
		pLanguageDef.builtins.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.builtins, '<span class="keyword">$1</span>');
	}

	// Numbers (CSS numbers may have units as a capture group, others do not)
	if (pLanguageDef.numbers)
	{
		pLanguageDef.numbers.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.numbers, (pMatch) =>
		{
			return `<span class="number">${pMatch}</span>`;
		});
	}

	return tmpResult;
}

/**
 * Highlight an HTML tag token, applying tag name, attribute name, and attribute value colors.
 *
 * The approach: parse the raw tag into structured pieces first, then build the
 * highlighted output from those pieces. This avoids mixing raw text with HTML span
 * tags, which would cause regex replacements to match span attributes on subsequent passes.
 *
 * @param {string} pTag - The raw (unescaped) tag string
 * @returns {string} The highlighted HTML
 */
function highlightHTMLTag(pTag)
{
	let tmpResult = '';
	let tmpRest = pTag;

	// 1. Extract the opening bracket and tag name: < or </  followed by tagname
	let tmpTagNameMatch = tmpRest.match(/^(<\/?)([a-zA-Z][a-zA-Z0-9-]*)/);
	if (!tmpTagNameMatch)
	{
		// Not a recognizable tag, just escape the whole thing
		return escapeHTML(pTag);
	}

	tmpResult += escapeHTML(tmpTagNameMatch[1]);
	tmpResult += '<span class="tag">' + escapeHTML(tmpTagNameMatch[2]) + '</span>';
	tmpRest = tmpRest.substring(tmpTagNameMatch[0].length);

	// 2. Parse attributes from the remaining text (before the closing > or />)
	// Repeatedly match: whitespace + attr-name + optional =value
	let tmpAttrRegex = /^(\s+)([a-zA-Z-]+)(?:(\s*=\s*)(["'])([^"']*?)\4)?/;
	let tmpAttrMatch;

	while ((tmpAttrMatch = tmpRest.match(tmpAttrRegex)) !== null)
	{
		// Whitespace before the attribute
		tmpResult += tmpAttrMatch[1];
		// Attribute name
		tmpResult += '<span class="attr-name">' + escapeHTML(tmpAttrMatch[2]) + '</span>';

		// If there's an = value part
		if (tmpAttrMatch[3])
		{
			tmpResult += escapeHTML(tmpAttrMatch[3]);
			tmpResult += '<span class="attr-value">' + escapeHTML(tmpAttrMatch[4]) + escapeHTML(tmpAttrMatch[5]) + escapeHTML(tmpAttrMatch[4]) + '</span>';
		}

		tmpRest = tmpRest.substring(tmpAttrMatch[0].length);
	}

	// 3. Whatever remains (whitespace, />, >) — escape it all
	tmpResult += escapeHTML(tmpRest);

	return tmpResult;
}

/**
 * Create a highlight function for a given language.
 *
 * The approach: use a single tokenizer regex to split the code into protected tokens
 * (comments, strings) and code segments. Process each segment independently.
 * This avoids placeholder/sentinel issues entirely.
 *
 * @param {string} pLanguage - The language identifier (e.g. "javascript", "json", "html")
 * @returns {function} A function that takes an element and highlights its textContent
 */
function createHighlighter(pLanguage)
{
	return function highlightElement(pElement)
	{
		let tmpCode = pElement.textContent;
		let tmpLanguageName = (typeof (pLanguage) === 'string') ? pLanguage.toLowerCase() : 'javascript';
		let tmpLanguageDef = _LanguageDefinitions[tmpLanguageName];

		if (!tmpLanguageDef)
		{
			// No highlighting rules for this language; just escape and return
			pElement.innerHTML = escapeHTML(tmpCode);
			return;
		}

		if (!tmpLanguageDef.tokenizer)
		{
			// No tokenizer; just escape and apply keyword highlighting
			pElement.innerHTML = highlightCodeSegment(escapeHTML(tmpCode), tmpLanguageDef);
			return;
		}

		// Split the code into tokens using the tokenizer regex.
		// The tokenizer captures comments and strings as groups.
		// We process everything between matches as code.
		let tmpResult = '';
		let tmpLastIndex = 0;
		let tmpTagGroupIndex = tmpLanguageDef.tagGroupIndex || 0;

		tmpLanguageDef.tokenizer.lastIndex = 0;
		let tmpMatch;

		while ((tmpMatch = tmpLanguageDef.tokenizer.exec(tmpCode)) !== null)
		{
			// Add the code segment before this match
			if (tmpMatch.index > tmpLastIndex)
			{
				let tmpSegment = tmpCode.substring(tmpLastIndex, tmpMatch.index);
				tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
			}

			let tmpFullMatch = tmpMatch[0];

			// Determine token type from capture groups
			// Group 1 is always comments, Group 2+ are strings/template literals/regex
			if (tmpMatch[1])
			{
				// Comment
				tmpResult += `<span class="comment">${escapeHTML(tmpFullMatch)}</span>`;
			}
			else if (tmpTagGroupIndex > 0 && tmpMatch[tmpTagGroupIndex])
			{
				// HTML tag — highlight tag name, attributes, and values
				tmpResult += highlightHTMLTag(tmpFullMatch);
			}
			else
			{
				// String, template literal, or regex
				tmpResult += `<span class="string">${escapeHTML(tmpFullMatch)}</span>`;
			}

			tmpLastIndex = tmpLanguageDef.tokenizer.lastIndex;
		}

		// Add any remaining code after the last match
		if (tmpLastIndex < tmpCode.length)
		{
			let tmpSegment = tmpCode.substring(tmpLastIndex);
			tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
		}

		pElement.innerHTML = tmpResult;
	};
}

module.exports = createHighlighter;
module.exports.LanguageDefinitions = _LanguageDefinitions;

},{}],557:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "CodeEditor-Wrap",
	"DefaultDestinationAddress": "#CodeEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "CodeEditor-Container",
			"Template": "<!-- CodeEditor-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "CodeEditor-Wrap",
			"TemplateHash": "CodeEditor-Container",
			"DestinationAddress": "#CodeEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#CodeEditor-Container-Div",

	// Address in AppData or other Pict address space to read/write code content
	"CodeDataAddress": false,

	// The language for syntax highlighting (e.g. "javascript", "html", "css", "json")
	"Language": "javascript",

	// Whether the editor is read-only
	"ReadOnly": false,

	// Tab character: use tab or spaces
	"Tab": "\t",

	// Whether to indent with the same whitespace as the previous line
	"IndentOn": /[({[]$/,

	// Whether to add a closing bracket/paren/brace
	"MoveToNewLine": /^[)}\]]/,

	// Whether to handle the closing character
	"AddClosing": true,

	// Whether to preserve indentation on new lines
	"CatchTab": true,

	// Whether to show line numbers
	"LineNumbers": true,

	// Default code content if no address is provided
	"DefaultCode": "// Enter your code here\n",

	// CSS for the code editor.
	//
	// Every color/font is wired through pict-provider-theme tokens so apps
	// using pict-provider-theme get themed code editor automatically.  Each
	// var() carries its original ATOM-One-Light hex as the fallback so apps
	// without pict-provider-theme installed look exactly as before.
	"CSS": `.pict-code-editor-wrap
{
	display: flex;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.5;
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
}
.pict-code-editor-wrap .pict-code-line-numbers
{
	width: 40px;
	min-width: 40px;
	/* padding-top/bottom are stamped at runtime from the editor's
	   computed padding so row 1 of the gutter aligns with row 1 of
	   the code; only horizontal padding is stylesheet-owned. */
	padding: 0;
	text-align: right;
	background: var(--theme-color-editor-linenumber-background, var(--theme-color-background-secondary, #F5F5F5));
	border-right: 1px solid var(--theme-color-editor-gutter-border, var(--theme-color-border-default, #D0D0D0));
	color: var(--theme-color-editor-linenumber-text, var(--theme-color-text-muted, #999));
	font-size: 13px;
	/* line-height, padding-top, padding-bottom, and font-family are
	   intentionally NOT declared here.  PictSectionCode._syncGutterMetrics()
	   copies them from the editor's computed styles at init and on every
	   editor resize, so the gutter is guaranteed to track the editor.
	   Declaring them in CSS would either be redundant (when matching) or
	   actively wrong (when the editor's metrics diverge — e.g. theme scale
	   changes the editor's font-size).  See codejar-linenumbers for the
	   canonical version of this pattern. */
	user-select: none;
	pointer-events: none;
	box-sizing: border-box;
}
.pict-code-editor-wrap .pict-code-line-numbers span
{
	display: block;
	padding: 0 8px 0 0;
}
.pict-code-editor-wrap .pict-code-editor
{
	margin: 0;
	padding: 10px 10px 10px 8px;
	min-height: 100px;
	flex: 1;
	min-width: 0;
	outline: none;
	tab-size: 4;
	white-space: pre;
	overflow-wrap: normal;
	color: var(--theme-color-text-primary, #383A42);
	background: var(--theme-color-background-panel, #FAFAFA);
	caret-color: var(--theme-color-brand-primary, #526FFF);
	border-radius: 0 4px 4px 0;
}
.pict-code-editor-wrap .pict-code-editor.pict-code-no-line-numbers
{
	padding-left: 10px;
	border-radius: 4px;
}
.pict-code-editor-wrap .pict-code-editor::selection,
.pict-code-editor-wrap .pict-code-editor *::selection
{
	background: var(--theme-color-editor-selection-background, var(--theme-color-selection-background, #B3D4FC));
}
/* Syntax token colors — each class binds to a Color.Syntax.* token from
   pict-provider-theme. Fallback hexes match the One Light palette so apps
   that don't install the theme provider look the same as before. */
.pict-code-editor-wrap .pict-code-editor .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
.pict-code-editor-wrap .pict-code-editor .string        { color: var(--theme-color-syntax-string,      #50A14F); }
.pict-code-editor-wrap .pict-code-editor .number        { color: var(--theme-color-syntax-number,      #986801); }
.pict-code-editor-wrap .pict-code-editor .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
.pict-code-editor-wrap .pict-code-editor .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
.pict-code-editor-wrap .pict-code-editor .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
.pict-code-editor-wrap .pict-code-editor .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
.pict-code-editor-wrap .pict-code-editor .property      { color: var(--theme-color-syntax-property,    #E45649); }
.pict-code-editor-wrap .pict-code-editor .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
.pict-code-editor-wrap .pict-code-editor .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
.pict-code-editor-wrap .pict-code-editor .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
.pict-code-editor-wrap .pict-code-editor .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
.pict-code-editor-wrap .pict-code-editor .type          { color: var(--theme-color-syntax-type,        #C18401); }
.pict-code-editor-wrap .pict-code-editor .variable      { color: var(--theme-color-syntax-variable,    #383A42); }

/* highlight.js class aliases — when host apps render code blocks with
   highlight.js (e.g. markdown previews via CodeJar's hljs integration),
   the output uses .hljs / .hljs-* classes rather than the bare token
   classes pict-section-code emits. Mapping them here lets one stylesheet
   theme both editor surfaces (bare classes) and hljs-rendered surfaces
   without the host needing a separate per-app github.css. Rules are
   intentionally unscoped (no .pict-code-editor-wrap parent) so they
   apply globally wherever hljs paints. */
.hljs                  { color: var(--theme-color-text-primary,         #383A42); background: transparent; }
.hljs-keyword,
.hljs-keyword.hljs-typeof,
.hljs-selector-tag,
.hljs-literal          { color: var(--theme-color-syntax-keyword,       #A626A4); }
.hljs-string,
.hljs-regexp,
.hljs-template-tag,
.hljs-template-variable { color: var(--theme-color-syntax-string,       #50A14F); }
.hljs-number,
.hljs-meta             { color: var(--theme-color-syntax-number,        #986801); }
.hljs-comment,
.hljs-quote            { color: var(--theme-color-syntax-comment,       #A0A1A7); font-style: italic; }
.hljs-operator,
.hljs-link             { color: var(--theme-color-syntax-operator,      #0184BC); }
.hljs-punctuation      { color: var(--theme-color-syntax-punctuation,   #383A42); }
.hljs-function .hljs-title,
.hljs-title.function_,
.hljs-title.class_     { color: var(--theme-color-syntax-function,      #4078F2); }
.hljs-variable,
.hljs-variable.language_,
.hljs-params           { color: var(--theme-color-syntax-variable,      #383A42); }
.hljs-type,
.hljs-class .hljs-title { color: var(--theme-color-syntax-type,         #C18401); }
.hljs-built_in,
.hljs-builtin-name     { color: var(--theme-color-syntax-builtin,       #986801); }
.hljs-attr,
.hljs-property         { color: var(--theme-color-syntax-property,      #E45649); }
.hljs-tag,
.hljs-name             { color: var(--theme-color-syntax-tag,           #E45649); }
.hljs-attribute        { color: var(--theme-color-syntax-attrname,      #986801); }
.hljs-symbol           { color: var(--theme-color-syntax-attrvalue,     #50A14F); }
.hljs-emphasis         { font-style: italic; }
.hljs-strong           { font-weight: bold; }
.hljs-deletion         { color: var(--theme-color-status-error,         #B62828); background: rgba(220, 50, 47, 0.08); }
.hljs-addition         { color: var(--theme-color-status-success,       #2E7A3A); background: rgba(80, 161, 79, 0.10); }
`
});

},{}],558:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libCreateHighlighter = require('./Pict-Code-Highlighter.js');
const _DefaultConfiguration = require('./Pict-Section-Code-DefaultConfiguration.js');

class PictSectionCode extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// The CodeJar instance
		this.codeJar = null;

		// The highlight function (can be overridden)
		this._highlightFunction = null;

		// The current language
		this._language = this.options.Language || 'javascript';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._codeJarPrototype = null;
		this.targetElement = false;

		// Build the default highlight function for the configured language
		this._highlightFunction = libCreateHighlighter(this._language);

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeJar prototype.  If not passed explicitly, try to find it
	 * as a global (window.CodeJar) or require it from the npm package.
	 *
	 * @param {function} [pCodeJarPrototype] - The CodeJar constructor function
	 * @returns {boolean|void}
	 */
	connectCodeJarPrototype(pCodeJarPrototype)
	{
		if (typeof (pCodeJarPrototype) === 'function')
		{
			this._codeJarPrototype = pCodeJarPrototype;
			return;
		}

		// Try to find CodeJar in global scope
		if (typeof (window) !== 'undefined')
		{
			if (typeof (window.CodeJar) === 'function')
			{
				this.log.trace(`PICT-Code Found CodeJar in window.CodeJar.`);
				this._codeJarPrototype = window.CodeJar;
				return;
			}
		}

		this.log.error(`PICT-Code No CodeJar prototype found. Include codejar via script tag or call connectCodeJarPrototype(CodeJar) explicitly.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Resolve the CodeJar prototype if not already set
		if (!this._codeJarPrototype)
		{
			this.connectCodeJarPrototype();
		}

		if (!this._codeJarPrototype)
		{
			this.log.error(`PICT-Code Cannot initialize editor; no CodeJar prototype available.`);
			return false;
		}

		if (this.codeJar)
		{
			this.log.error(`PICT-Code editor is already initialized!`);
			return false;
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-Code Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Build the editor DOM structure
		this._buildEditorDOM();

		// Get initial code content
		let tmpCode = this._resolveCodeContent();

		// Create the CodeJar options
		let tmpCodeJarOptions = {};
		if (this.options.Tab)
		{
			tmpCodeJarOptions.tab = this.options.Tab;
		}
		if (this.options.IndentOn)
		{
			tmpCodeJarOptions.indentOn = this.options.IndentOn;
		}
		if (this.options.MoveToNewLine)
		{
			tmpCodeJarOptions.moveToNewLine = this.options.MoveToNewLine;
		}
		if (typeof (this.options.AddClosing) !== 'undefined')
		{
			tmpCodeJarOptions.addClosing = this.options.AddClosing;
		}
		if (typeof (this.options.CatchTab) !== 'undefined')
		{
			tmpCodeJarOptions.catchTab = this.options.CatchTab;
		}

		this.customConfigureEditorOptions(tmpCodeJarOptions);

		// Instantiate CodeJar on the editor element
		let tmpEditorElement = this._editorElement;
		this.codeJar = this._codeJarPrototype(tmpEditorElement, this._highlightFunction, tmpCodeJarOptions);

		// CodeJar forces white-space:pre-wrap and overflow-wrap:break-word
		// via inline styles, which causes line wrapping that breaks the
		// line-number alignment.  Override back to non-wrapping so the
		// wrap container scrolls horizontally instead.
		this._resetEditorWrapStyles();

		// Set the initial code
		if (tmpCode)
		{
			this.codeJar.updateCode(tmpCode);
		}

		// Wire up the change handler
		this.codeJar.onUpdate((pCode) =>
		{
			this._updateLineNumbers();
			this.onCodeChange(pCode);
		});

		// Initial line number render
		this._updateLineNumbers();

		// Sync line-numbers vertical position with the editor's scroll.
		//
		// The editor element scrolls internally (CodeJar uses
		// contenteditable + overflow:auto for long content), but the
		// line-numbers div is a sibling with overflow:visible — without
		// this sync the line-numbers content stays glued at the top of
		// the wrap while the editor scrolls underneath it, so "line 1"
		// appears next to whatever line is actually showing.
		//
		// Using `transform: translateY(...)` instead of scrollTop keeps
		// the sync compositor-only (no reflow per scroll event) and
		// avoids needing to change the line-numbers element's overflow
		// from visible.  Passive listener so we don't block scrolling.
		if (this._lineNumbersElement)
		{
			let tmpLineNumbersEl = this._lineNumbersElement;
			tmpEditorElement.addEventListener('scroll', function ()
			{
				tmpLineNumbersEl.style.transform = 'translateY(-' + tmpEditorElement.scrollTop + 'px)';
			}, { passive: true });
		}

		// Sync gutter typographic metrics from the editor.  The gutter
		// must use the editor's exact line-height (and matching padding)
		// or rows drift apart cumulatively.  See _syncGutterMetrics().
		this._syncGutterMetrics();

		// Watch the editor for size changes (window resize affecting
		// flex layout, container resize) and re-sync the gutter so it
		// continues to track the editor.  ResizeObserver fires once per
		// frame at most, so the cost is negligible.
		if (this._lineNumbersElement && typeof (ResizeObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorResizeObserver = new ResizeObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorResizeObserver.observe(tmpEditorElement);
		}

		// Watch for direct style/class mutations on the editor.  Theme
		// providers that toggle scale by swapping a class on the editor,
		// or host code that adjusts editor typography via inline styles,
		// don't necessarily change the editor's box size — so the
		// ResizeObserver above wouldn't see them.  MutationObserver on
		// the attributes catches these cases.
		if (this._lineNumbersElement && typeof (MutationObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorStyleObserver = new MutationObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorStyleObserver.observe(tmpEditorElement,
				{ attributes: true, attributeFilter: ['style', 'class'] });
		}

		// Handle read-only
		if (this.options.ReadOnly)
		{
			tmpEditorElement.setAttribute('contenteditable', 'false');
		}
	}

	/**
	 * Build the editor DOM elements inside the target container.
	 */
	_buildEditorDOM()
	{
		// Clear the target
		this.targetElement.innerHTML = '';

		// Create wrapper
		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-code-editor-wrap';

		// Create line numbers container
		if (this.options.LineNumbers)
		{
			let tmpLineNumbers = document.createElement('div');
			tmpLineNumbers.className = 'pict-code-line-numbers';
			tmpWrap.appendChild(tmpLineNumbers);
			this._lineNumbersElement = tmpLineNumbers;
		}

		// Create the editor element (CodeJar needs a pre or div)
		let tmpEditor = document.createElement('div');
		tmpEditor.className = 'pict-code-editor language-' + this._language;
		if (!this.options.LineNumbers)
		{
			tmpEditor.className += ' pict-code-no-line-numbers';
		}
		tmpWrap.appendChild(tmpEditor);

		this.targetElement.appendChild(tmpWrap);
		this._editorElement = tmpEditor;
		this._wrapElement = tmpWrap;
	}

	/**
	 * Update the line numbers display based on current code content.
	 */
	_updateLineNumbers()
	{
		if (!this.options.LineNumbers || !this._lineNumbersElement || !this._editorElement)
		{
			return;
		}

		let tmpCode = this._editorElement.textContent || '';
		let tmpLineCount = tmpCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += `<span>${i}</span>`;
		}

		this._lineNumbersElement.innerHTML = tmpHTML;

		// Defense-in-depth: every line-count rebuild is also a natural
		// re-sync point.  Cheap (one getComputedStyle + a handful of
		// style writes) and guarantees newly-added spans use the same
		// metrics as the editor at the moment of the rebuild.
		this._syncGutterMetrics();
	}

	/**
	 * Copy typographic metrics from the editor element to the line-numbers
	 * gutter so every gutter row lines up with its corresponding code row.
	 *
	 * The gutter is a sibling element with its own font/line-height
	 * declarations — if any one diverges from the editor (unitless
	 * line-height resolving against a different font-size, host CSS
	 * overriding font-family, theme scale changing the editor's metrics),
	 * the two desync and the drift accumulates with every line.
	 *
	 * The pattern is borrowed from the canonical `codejar-linenumbers`
	 * library (julianpoemp/codejar-linenumbers), which solves the same
	 * class of bug by reading the editor's computed styles at init and
	 * stamping them onto the gutter.  We extend that here by also
	 * re-stamping whenever the editor resizes (see the ResizeObserver in
	 * onAfterInitialRender), so theme scale changes self-heal too.
	 *
	 * Public callers can invoke {@link syncMetrics} to force a re-sync
	 * after any external change that affects editor typography.
	 */
	_syncGutterMetrics()
	{
		if (!this._lineNumbersElement || !this._editorElement)
		{
			return;
		}
		if (typeof (window) === 'undefined' || typeof (window.getComputedStyle) !== 'function')
		{
			return;
		}

		let tmpEditorStyle = window.getComputedStyle(this._editorElement);
		let tmpLineHeight = tmpEditorStyle.lineHeight;

		// `normal` is the spec default — leave the gutter untouched so the
		// stylesheet's declaration wins (we have no number to copy).
		if (tmpLineHeight && tmpLineHeight !== 'normal')
		{
			this._lineNumbersElement.style.lineHeight = tmpLineHeight;
		}

		// Match the editor's vertical padding so row 1 of the gutter sits
		// at the same y-offset as row 1 of the code.
		if (tmpEditorStyle.paddingTop)
		{
			this._lineNumbersElement.style.paddingTop = tmpEditorStyle.paddingTop;
		}
		if (tmpEditorStyle.paddingBottom)
		{
			this._lineNumbersElement.style.paddingBottom = tmpEditorStyle.paddingBottom;
		}

		// Font-family must match so the visual baseline of the digits
		// aligns with the code (different monospace fonts can have
		// different x-heights even at identical line-heights).
		if (tmpEditorStyle.fontFamily)
		{
			this._lineNumbersElement.style.fontFamily = tmpEditorStyle.fontFamily;
		}

		// Dev-time sanity check.  If the gutter's resolved row height
		// disagrees with the editor's, alignment will drift cumulatively.
		// Warn loudly so the regression is caught at the next reload
		// instead of silently accumulating pixels per line.
		if (typeof (console) !== 'undefined' && console.warn)
		{
			let tmpFirstSpan = this._lineNumbersElement.querySelector('span');
			if (tmpFirstSpan)
			{
				let tmpGutterRow = tmpFirstSpan.getBoundingClientRect().height;
				let tmpEditorRow = parseFloat(tmpLineHeight);
				if (tmpGutterRow && tmpEditorRow && Math.abs(tmpGutterRow - tmpEditorRow) > 0.5)
				{
					console.warn('[pict-section-code] gutter/editor row-height mismatch: ' +
						'gutter ' + tmpGutterRow + 'px vs editor ' + tmpEditorRow + 'px — ' +
						'line numbers will drift. Check for CSS overriding ' +
						'.pict-code-line-numbers line-height.');
				}
			}
		}
	}

	/**
	 * Public hook for hosts to force a gutter metrics re-sync after
	 * external typography changes (theme scale, font-size swap, etc.).
	 * The ResizeObserver attached at init handles most cases, but call
	 * this from an app's post-theme-change hook for belt-and-suspenders
	 * coverage.
	 */
	syncMetrics()
	{
		this._syncGutterMetrics();
	}

	/**
	 * Reset inline styles that CodeJar sets on the editor element.
	 *
	 * CodeJar forces white-space:pre-wrap and overflow-wrap:break-word so
	 * long lines wrap visually.  That breaks line-number alignment because
	 * each wrapped visual row is not a logical line.  Resetting to pre /
	 * normal makes the outer .pict-code-editor-wrap scroll horizontally.
	 */
	_resetEditorWrapStyles()
	{
		if (!this._editorElement)
		{
			return;
		}
		this._editorElement.style.whiteSpace = 'pre';
		this._editorElement.style.overflowWrap = 'normal';
	}

	/**
	 * Resolve the initial code content from address or default.
	 *
	 * @returns {string} The code content
	 */
	_resolveCodeContent()
	{
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.CodeDataAddress);
			if (typeof (tmpAddressedData) === 'string')
			{
				return tmpAddressedData;
			}
			else
			{
				this.log.warn(`PICT-Code Address [${this.options.CodeDataAddress}] did not return a string; it was ${typeof (tmpAddressedData)}.`);
			}
		}

		return this.options.DefaultCode || '';
	}

	/**
	 * Hook for subclasses to customize CodeJar options before instantiation.
	 *
	 * @param {object} pOptions - The CodeJar options object to modify
	 */
	customConfigureEditorOptions(pOptions)
	{
		// Override in subclass to tweak options
	}

	/**
	 * Called when the code content changes.  Override in subclasses to handle changes.
	 *
	 * @param {string} pCode - The new code content
	 */
	onCodeChange(pCode)
	{
		// Write back to data address if configured
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.CodeDataAddress, pCode);
		}
	}

	// -- Public API Methods --

	/**
	 * Get the current code content.
	 *
	 * @returns {string} The current code
	 */
	getCode()
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code getCode called before editor initialized.');
			return '';
		}
		return this.codeJar.toString();
	}

	/**
	 * Set the code content.
	 *
	 * @param {string} pCode - The code to set
	 */
	setCode(pCode)
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code setCode called before editor initialized.');
			return;
		}
		this.codeJar.updateCode(pCode);
		this._updateLineNumbers();
	}

	/**
	 * Change the editor language and re-highlight.
	 *
	 * @param {string} pLanguage - The language identifier
	 */
	setLanguage(pLanguage)
	{
		this._language = pLanguage;
		this._highlightFunction = libCreateHighlighter(pLanguage);

		if (this._editorElement)
		{
			// Update the class
			this._editorElement.className = 'pict-code-editor language-' + pLanguage;
			if (!this.options.LineNumbers)
			{
				this._editorElement.className += ' pict-code-no-line-numbers';
			}
		}

		if (this.codeJar)
		{
			// Re-create the editor with the new highlight function
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set a custom highlight function to replace the built-in highlighter.
	 * Useful for integrating Prism.js, highlight.js, or any other library.
	 *
	 * @param {function} pHighlightFunction - A function that takes a DOM element and highlights its textContent
	 */
	setHighlightFunction(pHighlightFunction)
	{
		if (typeof (pHighlightFunction) !== 'function')
		{
			this.log.error('PICT-Code setHighlightFunction requires a function.');
			return;
		}
		this._highlightFunction = pHighlightFunction;

		if (this.codeJar)
		{
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set the read-only state of the editor.
	 *
	 * @param {boolean} pReadOnly - Whether the editor should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this._editorElement)
		{
			this._editorElement.setAttribute('contenteditable', pReadOnly ? 'false' : 'true');
		}
	}

	/**
	 * Destroy the editor and clean up.
	 */
	destroy()
	{
		if (this._editorResizeObserver)
		{
			this._editorResizeObserver.disconnect();
			this._editorResizeObserver = null;
		}
		if (this._editorStyleObserver)
		{
			this._editorStyleObserver.disconnect();
			this._editorStyleObserver = null;
		}
		if (this.codeJar)
		{
			this.codeJar.destroy();
			this.codeJar = null;
		}
	}

	/**
	 * Marshal code content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			let tmpCode = this._resolveCodeContent();
			if (typeof (tmpCode) === 'string')
			{
				this.codeJar.updateCode(tmpCode);
				this._updateLineNumbers();
			}
		}
	}

	/**
	 * Marshal the current code content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			this.onCodeChange(this.codeJar.toString());
		}
	}
}

module.exports = PictSectionCode;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.createHighlighter = libCreateHighlighter;

// Demo bundle for pict-docuserve.  Host apps that embed docuserve and
// want pict-section-code's demos visible in their docs site call
// `require('pict-section-code').registerWithDocuserve(pict)` once at
// app boot.  Silent no-op when Docuserve-Demos isn't installed.
//
// The require here is intentionally eager: browserify needs a static
// `require()` at module-toplevel to trace and bundle the demos source.
// The apparent circular dep (demos/index.js requires THIS module to
// reach the PictSectionCode class) is benign — by the time demos/
// index.js runs, `module.exports = PictSectionCode` has already
// executed, so it sees a usable class.  The `.demos` and
// `.registerWithDocuserve` attachments below run after the require
// returns, so demos/index.js never observes them being undefined.
const libCodeDemos = require('./demos');
module.exports.demos                = libCodeDemos.demos;
module.exports.registerWithDocuserve = libCodeDemos.registerWithDocuserve;

},{"./Pict-Code-Highlighter.js":556,"./Pict-Section-Code-DefaultConfiguration.js":557,"./demos":559,"pict-view":733}],559:[function(require,module,exports){
/**
 * pict-section-code demos
 *
 * Each entry is consumed by pict-docuserve's `Docuserve-Demos` provider.
 * Hosts that want these demos to appear in their docs site call
 * `require('pict-section-code/source/demos').registerWithDocuserve(pict)`
 * once at app boot (typically inside their DocuserveApplication subclass
 * after `super(...)`).
 *
 * Each demo's Mount(pict, container, spec) signature creates a fresh
 * pict-section-code view instance inside the supplied container.  Spec
 * fields are passed through to the view config so a single demo template
 * can express "JavaScript with line numbers", "JSON read-only no
 * gutter", etc. without duplicating the wiring.
 */

const libPictSectionCode = require('../Pict-Section-Code.js');

/**
 * Internal helper: mount a pict-section-code instance into a host
 * container according to the demo spec.  Each call registers a uniquely
 * identified view so multiple demos on the same page coexist cleanly.
 */
function mountCodeEditor(pPict, pContainer, pSpec)
{
	// Tag this mount with an id we can target as the destination.
	let tmpDestId = 'demo-code-' + (pSpec.Hash || 'unnamed') + '-' + Date.now();
	pContainer.innerHTML = '<div id="' + tmpDestId + '"></div>';

	let tmpConfig =
	{
		ViewIdentifier:            'Demo-Code-' + tmpDestId,
		DefaultDestinationAddress: '#' + tmpDestId,
		Templates:
		[
			{ Hash: 'CodeEditor-Container', Template: '<!-- demo code editor renders here -->' }
		],
		Renderables:
		[
			{ RenderableHash: 'CodeEditor-Wrap', TemplateHash: 'CodeEditor-Container', DestinationAddress: '#' + tmpDestId }
		],
		TargetElementAddress: '#' + tmpDestId,
		Language:    pSpec.Language    || 'javascript',
		ReadOnly:    !!pSpec.ReadOnly,
		LineNumbers: pSpec.LineNumbers !== false,
		Tab:         pSpec.Tab         || '\t',
		AddClosing:  pSpec.AddClosing !== false,
		CatchTab:    pSpec.CatchTab   !== false,
		DefaultCode: pSpec.Code        || '// example code\n',
		// AutoRender is intentionally OFF so we can pre-wire CodeJar
		// before the first render fires.  pict-section-code looks for
		// window.CodeJar by default; most hosts bundle CodeJar under
		// window.CodeJarModules.CodeJar (e.g. retold-content-system's
		// codejar-bundle.js), so we wire it explicitly here.
		AutoRender:  false,
		RenderOnLoad: false
	};

	let tmpView = pPict.addView(tmpConfig.ViewIdentifier, tmpConfig, libPictSectionCode);
	if (!tmpView) { return null; }

	// Connect the CodeJar prototype + highlight function from the
	// CodeJarModules global if it's loaded.  Falls back to bare CodeJar
	// if the host published the prototype directly.
	if (typeof window !== 'undefined')
	{
		if (window.CodeJarModules && typeof window.CodeJarModules.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJarModules.CodeJar);
		}
		else if (typeof window.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJar);
		}

		// Wire highlight.js highlighting if the bundle exposes it.
		if (window.CodeJarModules && window.CodeJarModules.hljs)
		{
			let tmpHljs = window.CodeJarModules.hljs;
			let tmpLanguage = tmpConfig.Language;
			tmpView._highlightFunction = function (pElement)
			{
				pElement.removeAttribute('data-highlighted');
				delete pElement.dataset.highlighted;
				pElement.className = pElement.className
					.replace(/\bhljs\b/g, '')
					.replace(/\blanguage-\S+/g, '')
					.trim();
				pElement.classList.add('language-' + tmpLanguage);
				try { tmpHljs.highlightElement(pElement); }
				catch (pErr) { /* swallow — highlighting is best-effort */ }
			};
		}
	}

	try { tmpView.render(); }
	catch (pError) { /* pict-section-code logs its own errors */ }
	return tmpView;
}

const _Demos =
[
	{
		DemoSchemaVersion: 1,
		Hash:        'javascript-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JavaScript editor',
		Description: 'Default pict-section-code configuration — line numbers on, highlight.js for JavaScript, two-space tab.',
		Spec:
		{
			Hash: 'javascript-editor',
			Language: 'javascript',
			LineNumbers: true,
			Tab: '  ',
			Code:
				'// A small example — try editing me.\n' +
				'function fibonacci(n) {\n' +
				'  if (n <= 1) return n;\n' +
				'  return fibonacci(n - 1) + fibonacci(n - 2);\n' +
				'}\n' +
				'\n' +
				'for (let i = 0; i < 10; i++) {\n' +
				'  console.log(`fib(${i}) =`, fibonacci(i));\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "javascript",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "  ",\n' +
					'  "Code": "function fibonacci(n) { … }"\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'json-readonly',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JSON viewer (read-only)',
		Description: 'Read-only mode with line numbers off — useful for embedded "show me the payload" surfaces in dashboards.',
		Spec:
		{
			Hash: 'json-readonly',
			Language: 'json',
			ReadOnly: true,
			LineNumbers: false,
			Code:
				'{\n' +
				'  "version": "1.0.7",\n' +
				'  "syntax": {\n' +
				'    "keyword":  "#A626A4",\n' +
				'    "string":   "#50A14F",\n' +
				'    "number":   "#986801",\n' +
				'    "function": "#4078F2"\n' +
				'  },\n' +
				'  "features": ["highlighting", "line-numbers", "readonly", "themed"]\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "json",\n' +
					'  "ReadOnly": true,\n' +
					'  "LineNumbers": false\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'css-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'CSS editor (4-space tab)',
		Description: 'CSS-flavoured highlighting with a 4-space tab and bracket auto-close turned off — leaner editing for stylesheet snippets.',
		Spec:
		{
			Hash: 'css-editor',
			Language: 'css',
			LineNumbers: true,
			Tab: '    ',
			AddClosing: false,
			Code:
				'/* Theme-aware token usage */\n' +
				'.docuserve-demo-title {\n' +
				'    color: var(--theme-color-text-primary, #3D3229);\n' +
				'    font-size: 1.5em;\n' +
				'    font-weight: 600;\n' +
				'}\n' +
				'\n' +
				'.docuserve-demo-description {\n' +
				'    color: var(--theme-color-text-secondary, #5E5549);\n' +
				'    line-height: 1.55;\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "css",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "    ",\n' +
					'  "AddClosing": false\n' +
					'}'
			}
		]
	}
];

/**
 * Register every pict-section-code demo with the host docuserve app.
 *
 * @param {object} pPict - The Pict instance (typically `this.pict` inside
 *                        a DocuserveApplication subclass).
 * @returns {number} count of demos registered (0 if Docuserve-Demos
 *                   provider isn't present — silent no-op).
 */
function registerWithDocuserve(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers['Docuserve-Demos'])
	{
		return 0;
	}
	return pPict.providers['Docuserve-Demos'].registerAll(_Demos);
}

module.exports = _Demos;
module.exports.demos = _Demos;
module.exports.registerWithDocuserve = registerWithDocuserve;

},{"../Pict-Section-Code.js":558}],560:[function(require,module,exports){
'use strict';

/**
 * Shared CSS for pict-section-content. Registered by BOTH the provider (so any consumer
 * using parseMarkdown gets code-block + content styling, even without instantiating the view)
 * and the view, under one hash so it injects once. This is the lower-layer home for the
 * code-block line-number gutter layout (.pict-content-code-wrap is a flex row) that used to
 * only ship with the view -- fixing the recurring "line numbers render above the code" bug.
 */
module.exports = /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.75em 0;
		}
		.pict-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		/* ─── Code blocks ─────────────────────────────────────
		   Background, text color, line-number gutter, and every
		   syntax token route through pict-provider-theme tokens —
		   the same set pict-section-code (the live editor) uses.
		   This way the rendered-preview code blocks look identical
		   to the live editor and re-skin together when the theme
		   switches.  Previous version used the text-primary token
		   as the code background (a TEXT token used as BACKGROUND),
		   which broke in dark mode and any palette where text and
		   background-tertiary diverge.
		*/
		.pict-content pre {
			background:    var(--theme-color-background-tertiary, #F0ECE4);
			color:         var(--theme-color-text-primary,        #3D3229);
			border:        1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
		}
		/* Inline code (single backtick) — slightly differentiated
		   from block code so it doesn't disappear into prose. */
		.pict-content code {
			background:    var(--theme-color-background-secondary, #FAF8F4);
			color:         var(--theme-color-text-primary,         #3D3229);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
		}
		.pict-content-code-wrap {
			display: flex;
			flex-direction: row;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
			font-size: 14px;
			line-height: 1.5;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			overflow: hidden;
			margin: 1em 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			width: 40px;
			min-width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background:    var(--theme-color-background-secondary, #FAF8F4);
			border-right:  1px solid var(--theme-color-border-default, #DDD6CA);
			color:         var(--theme-color-text-muted,           #8A7F72);
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
			color:      var(--theme-color-text-primary,        #3D3229);
			border: none;
			padding: 1.25em 1.25em 1.25em 8px;
			border-radius: 0 6px 6px 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			flex: 1;
			min-width: 0;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		/* Syntax token colors — every class binds to a --theme-color-syntax-*
		   variable, the same tokens pict-section-code (the live editor) uses.
		   Each var() carries an Atom One Light hex as fallback for hosts
		   without a theme provider; themes that DO ship syntax tokens
		   (pict-default, retold-content-system, etc.) drive everything
		   coherently. */
		.pict-content-code-wrap .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
		.pict-content-code-wrap .string        { color: var(--theme-color-syntax-string,      #50A14F); }
		.pict-content-code-wrap .number        { color: var(--theme-color-syntax-number,      #986801); }
		.pict-content-code-wrap .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
		.pict-content-code-wrap .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
		.pict-content-code-wrap .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
		.pict-content-code-wrap .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
		.pict-content-code-wrap .property      { color: var(--theme-color-syntax-property,    #E45649); }
		.pict-content-code-wrap .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
		.pict-content-code-wrap .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
		.pict-content-code-wrap .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
		.pict-content-code-wrap .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
		.pict-content-code-wrap .type          { color: var(--theme-color-syntax-type,        #C18401); }
		.pict-content-code-wrap .variable      { color: var(--theme-color-syntax-variable,    #383A42); }
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.8em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2A241E);
			text-align: center;
			padding: 1em;
		}
		.pict-content pre.mermaid text,
		.pict-content pre.mermaid .nodeLabel,
		.pict-content pre.mermaid .edgeLabel,
		.pict-content pre.mermaid .label,
		.pict-content pre.mermaid .cluster-label,
		.pict-content pre.mermaid span,
		.pict-content pre.mermaid foreignObject p,
		.pict-content pre.mermaid foreignObject div,
		.pict-content pre.mermaid foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-content pre.mermaid .edgePath .path {
			stroke: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content pre.mermaid .arrowheadPath {
			fill: var(--theme-color-text-secondary, #5E5549) !important;
		}
		/* Dark-mode override for handcrafted mermaid diagrams that bake
		   per-node inline fill colors via 'style X fill:#...' directives
		   (common in architecture / module docs, where pastel layer
		   colors mark visual hierarchy). Mermaid renders those as inline
		   style="fill:#..." SVG attributes — highest specificity, so
		   neither themeVariables nor unflagged CSS can reach them.
		   In light mode the Material pastels read fine; in dark mode the
		   same light fills become a high-contrast island on the dark
		   page with unreadable text. Force the fills back to a theme
		   background so dark-mode reads; light mode is intentionally
		   unmodified so the per-layer hierarchy is preserved there. */
		.theme-dark .pict-content pre.mermaid .node rect,
		.theme-dark .pict-content pre.mermaid .node polygon,
		.theme-dark .pict-content pre.mermaid .node circle,
		.theme-dark .pict-content pre.mermaid .node ellipse,
		.theme-dark .pict-content pre.mermaid .node path,
		.theme-dark .pict-content pre.mermaid .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		/* Mirror of the above for theme mode 'system' — when the user
		   hasn't explicitly picked light or dark, the theme provider
		   leaves <html> without .theme-light/.theme-dark and the CSS
		   variables follow prefers-color-scheme. The .theme-dark-prefixed
		   block above doesn't match in that case, so light pastels would
		   win again on dark OSes. Mirror the rule under the media query,
		   gated by :not(.theme-light) so an explicit light override on a
		   dark OS still wins. */
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-content pre.mermaid .node rect,
			html:not(.theme-light) .pict-content pre.mermaid .node polygon,
			html:not(.theme-light) .pict-content pre.mermaid .node circle,
			html:not(.theme-light) .pict-content pre.mermaid .node ellipse,
			html:not(.theme-light) .pict-content pre.mermaid .node path,
			html:not(.theme-light) .pict-content pre.mermaid .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* Excalidraw fence placeholders + rendered SVGs */
		.pict-content .pict-excalidraw-fence {
			display: block;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			padding: 1em;
			margin: 1em 0;
			text-align: center;
		}
		.pict-content .pict-excalidraw-fence svg {
			max-width: 100%;
			height: auto;
		}
		.pict-content .pict-excalidraw-fence-loading {
			color: var(--theme-color-text-secondary, #5E5549);
			font-style: italic;
			font-size: 0.9em;
			padding: 1em;
		}
		.pict-content .pict-excalidraw-fence-error {
			border-color: var(--theme-color-status-error, #D9534F);
			background: var(--theme-color-background-secondary, #FFF5F5);
		}
		.pict-content .pict-excalidraw-fence-error-message {
			color: var(--theme-color-status-error, #D9534F);
			font-family: var(--theme-typography-family-mono, monospace);
			font-size: 0.85em;
			text-align: left;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}

		/* Fullscreen viewer for images and mermaid diagrams (click-to-zoom) */
		.pict-content [data-fullscreen-source] {
			cursor: zoom-in;
			outline: 1px solid transparent;
			outline-offset: 3px;
			border-radius: 4px;
			transition: outline-color 0.15s ease;
		}
		.pict-content [data-fullscreen-source]:hover {
			outline-color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Code block container with hover-revealed action buttons */
		.pict-content-code-container {
			position: relative;
			display: flex;
			align-items: flex-start;
			gap: 8px;
			margin: 1em 0;
		}
		.pict-content-code-container > .pict-content-code-wrap {
			margin: 0;
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-muted, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
		}
		.pict-content-code-action-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copy-failed {
			background: var(--theme-color-status-error, #B23A3A);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-status-error, #B23A3A);
		}
		.pict-fullscreen-overlay {
			position: fixed;
			inset: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			background: rgba(0, 0, 0, 0.62);
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			color: var(--theme-color-text-primary, #2A241E);
		}
		.pict-fullscreen-overlay[hidden] {
			display: none;
		}
		.pict-fullscreen-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1em;
			height: 48px;
			padding: 0 1em;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-primary, #1A1612);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			flex: 0 0 auto;
		}
		.pict-fullscreen-title {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 0.95em;
			font-weight: 600;
			letter-spacing: 0.01em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-controls {
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.pict-fullscreen-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			padding: 0;
			background: transparent;
			border: 1px solid transparent;
			border-radius: 6px;
			color: var(--theme-color-text-muted, #5E5549);
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}
		.pict-fullscreen-btn svg {
			display: block;
			width: 16px;
			height: 16px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.75;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-fullscreen-btn:hover {
			background: var(--theme-color-border-light, #EAE3D8);
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-fullscreen-close:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
		}
		.pict-fullscreen-stage {
			flex: 1 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			padding: 1.5em;
			cursor: zoom-in;
			touch-action: none;
		}
		.pict-fullscreen-stage.is-zoomed {
			cursor: grab;
		}
		.pict-fullscreen-stage.is-panning {
			cursor: grabbing;
		}
		.pict-fullscreen-content {
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			max-height: 100%;
			transform-origin: center center;
			transition: transform 0.05s linear;
			will-change: transform;
		}
		.pict-fullscreen-content > * {
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
		.pict-fullscreen-content .pict-fullscreen-img {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			width: auto;
			height: auto;
			object-fit: contain;
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 12px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 16px;
			border-radius: 6px;
		}
		/* Bespoke inline-SVG diagrams (pict-renderer-graph / excalidraw).  Backdrop
		   uses the diagram's own --diagram-paper so the zoomed copy keeps the same
		   theme as the inline one (the host defines --diagram-* on the overlay). */
		.pict-fullscreen-content .pict-fullscreen-diagram-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--diagram-paper, var(--theme-color-background-panel, #FFFFFF));
			padding: 16px;
			border-radius: 6px;
		}
		/* Same dark-mode fill/stroke override as for inline diagrams, but
		   scoped to the fullscreen-overlay clone — which lives under
		   <body>, NOT inside .pict-content, so the pre.mermaid-scoped
		   rules above don't reach it. */
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* ---- video (the video fence, and video files written with the image form) ---- */
		.pict-content-video { margin: 18px 0; }
		.pict-content-video figcaption {
			font-size: 13px;
			color: var(--theme-color-text-secondary, #6B6255);
			margin-top: 6px;
		}
		.pict-content-video-file video,
		video.pict-content-video-inline {
			display: block;
			width: 100%;
			max-width: 100%;
			border-radius: 8px;
			background: #000;
		}
		/* The click-to-load card. It carries the whole clickable area, so a reader is never hunting for a
		   small play button, and it looks like a player rather than a link so nobody wonders what it is. */
		.pict-content-video-card {
			position: relative;
			display: flex;
			align-items: center;
			gap: 14px;
			padding: 16px 18px;
			min-height: 96px;
			text-decoration: none;
			border-radius: 8px;
			overflow: hidden;
			background: var(--theme-color-background-tertiary, #211C17);
			border: 1px solid var(--theme-color-border-default, #5E5549);
			color: var(--theme-color-text-primary, #F0EAE0);
		}
		.pict-content-video-card:hover { border-color: var(--theme-color-brand-primary, #C89B3C); }
		.pict-content-video-poster {
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			opacity: 0.45;
		}
		.pict-content-video-play { position: relative; flex: 0 0 auto; line-height: 0; }
		.pict-content-video-play-bg { fill: #212121; opacity: 0.85; }
		.pict-content-video-card:hover .pict-content-video-play-bg { fill: #cc0000; opacity: 1; }
		.pict-content-video-label { position: relative; display: flex; flex-direction: column; gap: 3px; min-width: 0; }
		.pict-content-video-title {
			font-weight: 600;
			font-size: 15px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.pict-content-video-source { font-size: 12px; color: var(--theme-color-text-secondary, #A69B8B); }
		.pict-content-video-frame {
			display: block;
			width: 100%;
			aspect-ratio: 16 / 9;
			border: 0;
			border-radius: 8px;
			background: #000;
		}
		.pict-content-video-empty figcaption {
			padding: 12px 14px;
			border: 1px dashed var(--theme-color-border-default, #5E5549);
			border-radius: 8px;
			margin-top: 0;
		}
		.pict-fullscreen-content .pict-fullscreen-codewrap {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			margin: 0;
			overflow: auto;
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
	`;

},{}],561:[function(require,module,exports){
// The container for all the Pict-Section-Content related code.

// The main content view class
module.exports = require('./views/Pict-View-Content.js');

// The content provider (markdown parsing, HTML escaping)
module.exports.PictContentProvider = require('./providers/Pict-Provider-Content.js');

// A thin demo view that auto-registers the provider, reads markdown
// from an AppData address, and pushes parsed HTML through the base
// view's displayContent pipeline.  Used by the docuserve playground;
// host applications can pick it up too if they just want "render this
// markdown blob" without writing the parse-and-display glue.
module.exports.PictContentDemoView = require('./views/PictView-Content-Demo.js');

},{"./providers/Pict-Provider-Content.js":562,"./views/Pict-View-Content.js":563,"./views/PictView-Content-Demo.js":564}],562:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libCreateHighlighter = require('pict-section-code').createHighlighter;

const libContentCSS = require('../Pict-Content-CSS.js');

/**
 * Content Provider for Pict Section Content
 *
 * A general-purpose markdown-to-HTML parser with support for:
 * - Headings, paragraphs, lists, blockquotes, horizontal rules
 * - Fenced code blocks with language tags (nested fence support)
 * - Syntax highlighting and line numbers for code blocks (via pict-section-code)
 * - Tables (GFM pipe syntax)
 * - Mermaid diagram blocks
 * - KaTeX math (inline and display)
 * - Bold, italic, inline code, links, images
 *
 * Link resolution is customizable via an optional callback.
 */
class PictContentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Register the content CSS at the PROVIDER layer. parseMarkdown emits the
		// .pict-content-code-wrap markup (a line-number gutter + a <pre>), and that CSS makes the
		// wrap a flex row so the numbers sit to the LEFT of the code. Consumers like the
		// inline-documentation reader use this provider WITHOUT instantiating the view, so the
		// view's CSS never shipped and the numbers stacked ABOVE the code -- the recurring bug.
		// Registering here fixes it for every consumer; the view uses the same hash, so it still
		// injects only once. (pict CLAUDE.md: providers must addCSS() themselves.)
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Content-CSS', libContentCSS, 500);
		}
	}

	/**
	 * Highlight a code string using pict-section-code's syntax highlighter.
	 * Uses a mock element to interface with the highlighter's DOM-based API.
	 *
	 * @param {string} pCode - The raw code string
	 * @param {string} pLanguage - The language identifier (e.g. "javascript", "html")
	 * @returns {string} The syntax-highlighted HTML
	 */
	highlightCode(pCode, pLanguage)
	{
		if (!pCode)
		{
			return '';
		}

		let tmpHighlighter = libCreateHighlighter(pLanguage);
		// Create a mock element to interface with the highlighter
		let tmpMockElement = { textContent: pCode, innerHTML: '' };
		tmpHighlighter(tmpMockElement);
		return tmpMockElement.innerHTML;
	}

	/**
	 * Generate line number HTML for a code block.
	 *
	 * @param {string} pCode - The raw code string
	 * @returns {string} HTML string with line number spans
	 */
	generateLineNumbers(pCode)
	{
		if (!pCode)
		{
			return '<span>1</span>';
		}

		let tmpLineCount = pCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += '<span>' + i + '</span>';
		}

		return tmpHTML;
	}

	/**
	 * Parse a markdown string into HTML.
	 *
	 * @param {string} pMarkdown - The raw markdown text
	 * @param {Function} [pLinkResolver] - Optional callback for link resolution: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback for image URL resolution: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. Passed through to parseInline() for vocabulary term auto-linking.
	 * @returns {string} The parsed HTML
	 */
	parseMarkdown(pMarkdown, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pMarkdown)
		{
			return '';
		}

		let tmpLines = pMarkdown.split('\n');
		let tmpHTML = [];
		let tmpInCodeBlock = false;
		let tmpCodeFenceLength = 0;
		let tmpCodeLang = '';
		let tmpCodeLines = [];
		let tmpInList = false;
		let tmpListType = '';
		let tmpInBlockquote = false;
		let tmpBlockquoteLines = [];
		let tmpInMathBlock = false;
		let tmpMathLines = [];
		let tmpParagraphLines = [];

		// Helper to flush accumulated paragraph lines into a single <p> tag
		let fFlushParagraph = () =>
		{
			if (tmpParagraphLines.length > 0)
			{
				tmpHTML.push('<p>' + tmpParagraphLines.map((pLine) => { return this.parseInline(pLine, pLinkResolver, pImageResolver, pVocabularyResolver); }).join(' ') + '</p>');
				tmpParagraphLines = [];
			}
		};

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			// Display math blocks ($$...$$) — skip if inside a code block
			if (!tmpInCodeBlock && tmpLine.trim().match(/^\$\$/))
			{
				if (tmpInMathBlock)
				{
					// End math block
					tmpHTML.push('<div class="pict-content-katex-display">' + tmpMathLines.join('\n') + '</div>');
					tmpInMathBlock = false;
					tmpMathLines = [];
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					tmpInMathBlock = true;
				}
				continue;
			}

			if (tmpInMathBlock)
			{
				tmpMathLines.push(tmpLine);
				continue;
			}

			// Code blocks (fenced) — track fence length so ````x```` nests around ```y```
			let tmpFenceMatch = tmpLine.match(/^(`{3,})/);
			if (tmpFenceMatch)
			{
				let tmpFenceLen = tmpFenceMatch[1].length;

				if (tmpInCodeBlock)
				{
					// Only close if the closing fence is at least as long as the opening
					if (tmpFenceLen >= tmpCodeFenceLength && tmpLine.trim() === tmpFenceMatch[1])
					{
						// End code block
						if (tmpCodeLang === 'mermaid')
						{
							// Mermaid diagrams: output raw content for client-side rendering
							tmpHTML.push('<pre class="mermaid">' + tmpCodeLines.join('\n') + '</pre>');
						}
						else if (tmpCodeLang === 'video')
						{
							// Video: one fence, two outcomes, decided by where the video lives.
							// Self-hosted (a relative URL, or a file with a video extension) plays inline;
							// a third-party watch page becomes a click-to-load card. See videoEmbedHTML.
							tmpHTML.push(this.videoEmbedHTML(tmpCodeLines.join('\n')));
						}
						else if (tmpCodeLang === 'excalidraw')
						{
							// Excalidraw scenes: emit a placeholder div with the
							// scene JSON URI-component encoded into a data
							// attribute.  Pict-View-Content's
							// renderExcalidrawDiagrams() swaps these for rendered
							// SVGs once the wrapper bundle is ready.  We don't
							// validate the JSON here — invalid fences just stay
							// as the loading placeholder until the runtime
							// reports the error.
							let tmpRawScene = tmpCodeLines.join('\n');
							let tmpEncoded;
							try { tmpEncoded = encodeURIComponent(tmpRawScene); }
							catch (pErr) { tmpEncoded = ''; }
							tmpHTML.push('<div class="pict-excalidraw-fence" data-scene="' + tmpEncoded + '">' +
								'<div class="pict-excalidraw-fence-loading">Rendering Excalidraw diagram…</div>' +
								'</div>');
						}
						else
						{
							let tmpCodeText = tmpCodeLines.join('\n');
						let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
						let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
						tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code class="language-' + this.escapeHTML(tmpCodeLang) + '">' + tmpHighlightedCode + '</code></pre></div>');
						}
						tmpInCodeBlock = false;
						tmpCodeFenceLength = 0;
						tmpCodeLang = '';
						tmpCodeLines = [];
						continue;
					}
					else
					{
						// Inner fence with fewer backticks — treat as content
						tmpCodeLines.push(tmpLine);
						continue;
					}
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					// Start code block — record fence length
					tmpCodeFenceLength = tmpFenceLen;
					tmpCodeLang = tmpLine.replace(/^`{3,}/, '').trim();
					tmpInCodeBlock = true;
					continue;
				}
			}

			if (tmpInCodeBlock)
			{
				tmpCodeLines.push(tmpLine);
				continue;
			}

			// Blockquotes
			if (tmpLine.match(/^>\s?/))
			{
				if (!tmpInBlockquote)
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					tmpInBlockquote = true;
					tmpBlockquoteLines = [];
				}
				tmpBlockquoteLines.push(tmpLine.replace(/^>\s?/, ''));
				continue;
			}
			else if (tmpInBlockquote)
			{
				tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
				tmpInBlockquote = false;
				tmpBlockquoteLines = [];
			}

			// Horizontal rule
			if (tmpLine.match(/^(-{3,}|\*{3,}|_{3,})\s*$/))
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				tmpHTML.push('<hr>');
				continue;
			}

			// Headings
			let tmpHeadingMatch = tmpLine.match(/^(#{1,6})\s+(.+)/);
			if (tmpHeadingMatch)
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				let tmpLevel = tmpHeadingMatch[1].length;
				let tmpText = this.parseInline(tmpHeadingMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver);
				let tmpID = tmpHeadingMatch[2].toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
				tmpHTML.push('<h' + tmpLevel + ' id="' + tmpID + '">' + tmpText + '</h' + tmpLevel + '>');
				continue;
			}

			// Unordered list items
			let tmpULMatch = tmpLine.match(/^(\s*)[-*+]\s+(.*)/);
			if (tmpULMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ul')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ul>');
					tmpInList = true;
					tmpListType = 'ul';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpULMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Ordered list items
			let tmpOLMatch = tmpLine.match(/^(\s*)\d+\.\s+(.*)/);
			if (tmpOLMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ol')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ol>');
					tmpInList = true;
					tmpListType = 'ol';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpOLMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Indented continuation line of a wrapped list item — fold its
			// content into the last <li> instead of closing the list. Closing
			// here would split a real <ol>/<ul>, and each fragment restarts
			// ordered numbering. A non-indented non-marker line still closes
			// the list (handled below); blank lines never reach this branch.
			if (tmpInList && tmpLine.match(/^\s+\S/) && tmpHTML.length > 0 && tmpHTML[tmpHTML.length - 1].endsWith('</li>'))
			{
				let tmpLastIndex = tmpHTML.length - 1;
				let tmpListItemBody = tmpHTML[tmpLastIndex].slice(0, -'</li>'.length);
				tmpHTML[tmpLastIndex] = tmpListItemBody + ' ' + this.parseInline(tmpLine.trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>';
				continue;
			}

			// Close list if we've left list items
			if (tmpInList && tmpLine.trim() !== '')
			{
				tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
				tmpInList = false;
			}

			// Empty line — flush any accumulated paragraph
			if (tmpLine.trim() === '')
			{
				fFlushParagraph();
				continue;
			}

			// Table detection
			if (tmpLine.match(/^\|/) && i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|[\s-:|]+\|/))
			{
				fFlushParagraph();
				// Close any open list
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}

				let tmpTableHTML = '<table>';

				// Header row
				let tmpHeaders = tmpLine.split('|').filter((pCell) => { return pCell.trim() !== ''; });
				tmpTableHTML += '<thead><tr>';
				for (let h = 0; h < tmpHeaders.length; h++)
				{
					tmpTableHTML += '<th>' + this.parseInline(tmpHeaders[h].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</th>';
				}
				tmpTableHTML += '</tr></thead>';

				// Skip separator row
				i++;

				// Body rows
				tmpTableHTML += '<tbody>';
				while (i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|/))
				{
					i++;
					let tmpCells = tmpLines[i].split('|').filter((pCell) => { return pCell.trim() !== ''; });
					tmpTableHTML += '<tr>';
					for (let c = 0; c < tmpCells.length; c++)
					{
						tmpTableHTML += '<td>' + this.parseInline(tmpCells[c].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</td>';
					}
					tmpTableHTML += '</tr>';
				}
				tmpTableHTML += '</tbody></table>';
				tmpHTML.push(tmpTableHTML);
				continue;
			}

			// Accumulate paragraph lines — consecutive non-blank text lines
			// will be joined into a single <p> tag when flushed
			tmpParagraphLines.push(tmpLine);
		}

		// Flush any remaining accumulated paragraph
		fFlushParagraph();

		// Close any trailing open elements
		if (tmpInList)
		{
			tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
		}
		if (tmpInBlockquote)
		{
			tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
		}
		if (tmpInCodeBlock)
		{
			let tmpCodeText = tmpCodeLines.join('\n');
			let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
			let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
			tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code>' + tmpHighlightedCode + '</code></pre></div>');
		}

		return tmpHTML.join('\n');
	}

	/**
	 * Parse inline markdown elements (bold, italic, code, links, images, KaTeX).
	 *
	 * @param {string} pText - The text to parse
	 * @param {Function} [pLinkResolver] - Optional callback: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. When provided, known vocabulary terms in the rendered text are wrapped in <span class="pict-vocab-term"> with data attributes carrying the popover content.
	 * @returns {string} HTML with inline elements
	 */
	parseInline(pText, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pText)
		{
			return '';
		}

		let tmpResult = pText;

		// Extract inline code spans into placeholders so bold/italic regexes don't mangle their contents
		let tmpCodeSpans = [];
		tmpResult = tmpResult.replace(/`([^`]+)`/g, (pMatch, pCode) =>
		{
			let tmpIndex = tmpCodeSpans.length;
			tmpCodeSpans.push('<code>' + pCode + '</code>');
			return '\x00CODEINLINE' + tmpIndex + '\x00';
		});

		// Inline LaTeX equations ($...$) — must be processed before other inline patterns
		// Match single $ delimiters that aren't adjacent to spaces (to avoid false positives with currency)
		tmpResult = tmpResult.replace(/\$([^\$\s][^\$]*?[^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');
		// Also match single-character inline math like $x$
		tmpResult = tmpResult.replace(/\$([^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');

		// Images
		tmpResult = tmpResult.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (pMatch, pAlt, pSrc) =>
		{
			let tmpSrc = pSrc;
			if (typeof pImageResolver === 'function')
			{
				let tmpResolved = pImageResolver(pSrc, pAlt);
				if (tmpResolved)
				{
					tmpSrc = tmpResolved;
				}
			}
			// A video file written with the image form. Authors reach for `![clip](demo.mp4)` because it is
			// the syntax their fingers know, and an <img> pointed at an mp4 is a broken image icon -- so it
			// renders a player instead. Only a real video EXTENSION qualifies; see hasVideoExtension.
			if (this.hasVideoExtension(tmpSrc) && this.isSafeMediaURL(tmpSrc))
			{
				return '<video class="pict-content-video-inline" controls preload="metadata" src="' + this.escapeHTML(tmpSrc) + '">' +
					'<a href="' + this.escapeHTML(tmpSrc) + '">' + this.escapeHTML(pAlt || 'Download the video') + '</a></video>';
			}
			return '<img src="' + tmpSrc + '" alt="' + pAlt + '">';
		});

		// Links
		tmpResult = tmpResult.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (pMatch, pLinkText, pHref) =>
		{
			if (typeof pLinkResolver === 'function')
			{
				let tmpResolved = pLinkResolver(pHref, pLinkText);
				if (tmpResolved)
				{
					let tmpTarget = tmpResolved.target ? ' target="' + tmpResolved.target + '"' : '';
					let tmpRel = tmpResolved.rel ? ' rel="' + tmpResolved.rel + '"' : '';
					return '<a href="' + tmpResolved.href + '"' + tmpTarget + tmpRel + '>' + pLinkText + '</a>';
				}
			}
			// Default behavior: external links open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return '<a href="' + pHref + '" target="_blank" rel="noopener">' + pLinkText + '</a>';
			}
			return '<a href="' + pHref + '">' + pLinkText + '</a>';
		});

		// Bold
		tmpResult = tmpResult.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
		// Underscore strong only at word boundaries (CommonMark intraword rule) so
		// identifiers / URLs like a__b or foo__bar aren't treated as emphasis.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])__([^_]+?)__(?![A-Za-z0-9_])/g, '$1<strong>$2</strong>');

		// Italic
		tmpResult = tmpResult.replace(/\*([^*]+)\*/g, '<em>$1</em>');
		// Underscore italic only at word boundaries — a single underscore inside a
		// word or a URL (e.g. hello_world in a link href) must NOT become <em>.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])_([^_]+?)_(?![A-Za-z0-9_])/g, '$1<em>$2</em>');

		// Restore inline code spans from placeholders
		tmpResult = tmpResult.replace(/\x00CODEINLINE(\d+)\x00/g, (pMatch, pIndex) =>
		{
			return tmpCodeSpans[parseInt(pIndex)];
		});

		// Vocabulary term auto-linking: scan the rendered text for
		// known vocabulary terms and wrap each first occurrence in a
		// span with data attributes for the popover system. Skips
		// content inside <code>, <a>, <pre>, and <strong> tags to
		// avoid mangling links, code, or already-emphasized text.
		if (typeof pVocabularyResolver === 'function')
		{
			tmpResult = this._applyVocabularyLinks(tmpResult, pVocabularyResolver);
		}

		return tmpResult;
	}

	/**
	 * Scan HTML for vocabulary terms and wrap the first occurrence
	 * of each in a <span class="pict-vocab-term"> element. The
	 * resolver callback is called for each candidate word/phrase
	 * and returns { slug, title, short } if it's a known term.
	 *
	 * Skips content inside HTML tags to avoid breaking links,
	 * code spans, and other markup.
	 *
	 * @param {string} pHTML
	 * @param {Function} pResolver - (word) => {slug, title, short} | null
	 * @returns {string}
	 */
	_applyVocabularyLinks(pHTML, pResolver)
	{
		if (!pHTML || typeof pResolver !== 'function')
		{
			return pHTML;
		}

		// Track which terms we've already linked to avoid duplicate
		// links for the same term appearing multiple times.
		let tmpLinked = {};

		// Split the HTML into segments: tags vs text nodes. We only
		// scan text nodes for vocabulary terms; tags pass through.
		// This regex captures HTML tags as separators.
		let tmpParts = pHTML.split(/(<[^>]+>)/g);

		// Track whether we're inside a tag that should be skipped
		let tmpSkipDepth = 0;
		let tmpSkipTags = ['code', 'a', 'pre', 'span'];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];

			// Check if this is an HTML tag
			if (tmpPart.charAt(0) === '<')
			{
				// Opening tag?
				let tmpOpenMatch = tmpPart.match(/^<(\w+)/);
				if (tmpOpenMatch && tmpSkipTags.indexOf(tmpOpenMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth++;
				}
				// Closing tag?
				let tmpCloseMatch = tmpPart.match(/^<\/(\w+)/);
				if (tmpCloseMatch && tmpSkipTags.indexOf(tmpCloseMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth = Math.max(0, tmpSkipDepth - 1);
				}
				continue; // Don't modify tags
			}

			// Skip text inside protected elements
			if (tmpSkipDepth > 0) continue;

			// Scan this text node for vocabulary terms. Use word
			// boundary regex to match whole words only.
			tmpParts[i] = tmpPart.replace(/\b([A-Za-z][A-Za-z0-9_-]{1,30})\b/g, (pMatch, pWord) =>
			{
				// Skip very short words and common English words
				if (pWord.length < 3) return pMatch;

				let tmpLower = pWord.toLowerCase();
				if (tmpLinked[tmpLower]) return pMatch; // already linked

				let tmpResult = pResolver(tmpLower);
				if (!tmpResult) return pMatch;

				tmpLinked[tmpLower] = true;
				let tmpShortEsc = (tmpResult.short || '').replace(/"/g, '&quot;');
				return '<span class="pict-vocab-term" data-vocab-slug="' + tmpResult.slug +
					'" data-vocab-title="' + (tmpResult.title || '').replace(/"/g, '&quot;') +
					'" data-vocab-short="' + tmpShortEsc + '">' + pMatch + '</span>';
			});
		}

		return tmpParts.join('');
	}

	/**
	 * The file extensions that mean "these bytes ARE the video", as opposed to a page about one.
	 */
	static get VIDEO_EXTENSIONS()
	{
		return ['mp4', 'webm', 'ogv', 'ogg', 'mov', 'm4v'];
	}

	/**
	 * Recognize a third-party video URL and return { Provider, Embed, Watch }, or null when the URL is not
	 * one this knows how to embed.
	 *
	 * Only YouTube and Vimeo are recognized on purpose: an embed is a third party running code in the
	 * reader's page, so the set of parties allowed to do that is a list, not a guess.
	 *
	 * @param {string} pURL
	 * @returns {Object|null}
	 */
	videoProviderFor(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		let tmpYouTube = tmpURL.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
		if (tmpYouTube)
		{
			// youtube-nocookie.com is the same player without the tracking cookies it would otherwise set
			// the moment the frame loads.
			return {
				Provider: 'YouTube',
				Embed: 'https://www.youtube-nocookie.com/embed/' + tmpYouTube[1] + '?autoplay=1&rel=0',
				Watch: 'https://www.youtube.com/watch?v=' + tmpYouTube[1]
			};
		}
		let tmpVimeo = tmpURL.match(/vimeo\.com\/(?:video\/)?(\d{6,})/);
		if (tmpVimeo)
		{
			return {
				Provider: 'Vimeo',
				Embed: 'https://player.vimeo.com/video/' + tmpVimeo[1] + '?autoplay=1',
				Watch: 'https://vimeo.com/' + tmpVimeo[1]
			};
		}
		return null;
	}

	/**
	 * Is this URL safe to put in an href or a src? Only http(s) and same-document relative URLs are, which
	 * is what keeps a javascript: or data: URL in a document from becoming script when a reader clicks it.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	isSafeMediaURL(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		if (!tmpURL) { return false; }
		if (/^https?:\/\//i.test(tmpURL)) { return true; }
		// A relative or root-relative path: same origin by construction, so it carries the document's own
		// trust. Anything with a scheme that is not http(s) is refused.
		return !/^[A-Za-z][A-Za-z0-9+.-]*:/.test(tmpURL);
	}

	/**
	 * Does this URL end in a video file extension? Strictly the extension, nothing inferred.
	 *
	 * The inline image form uses THIS rather than isDirectVideoURL: in a ```video fence the author has
	 * already said the thing is a video, so a relative URL can be taken at its word, but `![logo](/img/x)`
	 * is an image and treating every extensionless relative source as video would turn the whole media
	 * library into broken players.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	hasVideoExtension(pURL)
	{
		let tmpPath = String(pURL || '').trim().split('?')[0].split('#')[0];
		return PictContentProvider.VIDEO_EXTENSIONS.indexOf((tmpPath.split('.').pop() || '').toLowerCase()) >= 0;
	}

	/**
	 * Does this URL point at video BYTES rather than a page about a video?
	 *
	 * A known video extension says yes. So does any relative URL: those are served by the application
	 * itself, which is how an uploaded recording is addressed (a blob route often carries no extension at
	 * all), and the application does not serve watch pages to its own markdown.
	 *
	 * @param {string} pURL
	 * @returns {boolean}
	 */
	isDirectVideoURL(pURL)
	{
		let tmpURL = String(pURL || '').trim();
		if (!tmpURL) { return false; }
		if (this.hasVideoExtension(tmpURL)) { return true; }
		return !/^https?:\/\//i.test(tmpURL);
	}

	/**
	 * The HTML for a ```video fence.
	 *
	 * Body shape: the URL on the first non-empty line, then optional `key: value` lines (title, poster).
	 *
	 *     ```video
	 *     https://www.youtube.com/watch?v=abc123
	 *     title: How the deploy pipeline works
	 *     poster: /1.0/Media/42/Blob
	 *     ```
	 *
	 * Two outcomes, decided by where the video lives:
	 *
	 * - Self-hosted (relative URL, or a file with a video extension) renders a plain <video controls
	 *   preload="metadata">. The bytes come from the same place the page did, so there is nothing to
	 *   consent to, and preload="metadata" paints the real first frame as its own thumbnail.
	 * - A third-party watch page renders a CLICK-TO-LOAD card. Nothing is fetched from that party until the
	 *   reader asks for it -- not the player, and not the poster image either, since fetching a thumbnail
	 *   from the provider would leak the reader to them exactly as the player does. A poster is shown only
	 *   when the author supplied one. Without JavaScript the card is still a working link to the video,
	 *   which is what a server-rendered or printed copy of the document falls back to.
	 *
	 * @param {string} pBody - The fence contents
	 * @returns {string} The HTML
	 */
	videoEmbedHTML(pBody)
	{
		let tmpLines = String(pBody || '').split('\n').map((pLine) => { return pLine.trim(); }).filter((pLine) => { return pLine.length > 0; });
		if (!tmpLines.length)
		{
			return '<figure class="pict-content-video pict-content-video-empty"><figcaption>No video URL was given.</figcaption></figure>';
		}
		let tmpURL = tmpLines[0];
		let tmpOptions = {};
		for (let i = 1; i < tmpLines.length; i++)
		{
			let tmpMatch = tmpLines[i].match(/^([A-Za-z][A-Za-z0-9_-]*)\s*:\s*(.*)$/);
			if (tmpMatch) { tmpOptions[tmpMatch[1].toLowerCase()] = tmpMatch[2].trim(); }
		}
		if (!this.isSafeMediaURL(tmpURL))
		{
			return '<figure class="pict-content-video pict-content-video-empty"><figcaption>That video link was not a http(s) or relative URL.</figcaption></figure>';
		}

		let tmpTitle = tmpOptions.title || '';
		let tmpPoster = (tmpOptions.poster && this.isSafeMediaURL(tmpOptions.poster)) ? tmpOptions.poster : '';
		// The caption belongs under a PLAYER, which has nowhere else to say what it is. A card already
		// carries the title inside it, so captioning that one prints the same sentence twice.
		let tmpCaption = tmpTitle ? ('<figcaption>' + this.escapeHTML(tmpTitle) + '</figcaption>') : '';

		if (this.isDirectVideoURL(tmpURL))
		{
			return '<figure class="pict-content-video pict-content-video-file">' +
				'<video controls preload="metadata" src="' + this.escapeHTML(tmpURL) + '"' +
				(tmpPoster ? (' poster="' + this.escapeHTML(tmpPoster) + '"') : '') + '>' +
				'<a href="' + this.escapeHTML(tmpURL) + '">' + this.escapeHTML(tmpTitle || 'Download the video') + '</a>' +
				'</video>' + tmpCaption + '</figure>';
		}

		let tmpProvider = this.videoProviderFor(tmpURL);
		let tmpWatch = tmpProvider ? tmpProvider.Watch : tmpURL;
		let tmpLabel = tmpProvider
			? (tmpProvider.Provider + ' - plays from ' + tmpProvider.Provider + ' when you start it')
			: 'Opens in a new tab';
		// data-embed is what the view swaps in on click. A card with no data-embed (an unrecognized site)
		// stays a link, which is the honest outcome: this cannot promise to embed a page it does not know.
		return '<figure class="pict-content-video pict-content-video-embed"' +
			(tmpProvider ? (' data-embed="' + this.escapeHTML(tmpProvider.Embed) + '"') : '') +
			' data-provider="' + this.escapeHTML(tmpProvider ? tmpProvider.Provider : 'link') + '">' +
			'<a class="pict-content-video-card" href="' + this.escapeHTML(tmpWatch) + '" target="_blank" rel="noopener noreferrer">' +
			(tmpPoster ? ('<img class="pict-content-video-poster" src="' + this.escapeHTML(tmpPoster) + '" alt="">') : '') +
			'<span class="pict-content-video-play" aria-hidden="true">' +
			'<svg viewBox="0 0 68 48" width="54" height="38"><path class="pict-content-video-play-bg" d="M66.5 7.7a8 8 0 0 0-5.6-5.7C55.9.6 34 .6 34 .6s-21.9 0-26.9 1.4a8 8 0 0 0-5.6 5.7A83 83 0 0 0 .1 24a83 83 0 0 0 1.4 16.3 8 8 0 0 0 5.6 5.7c5 1.4 26.9 1.4 26.9 1.4s21.9 0 26.9-1.4a8 8 0 0 0 5.6-5.7A83 83 0 0 0 67.9 24a83 83 0 0 0-1.4-16.3z"/><path d="M27 34V14l18 10z" fill="#fff"/></svg>' +
			'</span>' +
			'<span class="pict-content-video-label">' +
			'<span class="pict-content-video-title">' + this.escapeHTML(tmpTitle || tmpWatch) + '</span>' +
			'<span class="pict-content-video-source">' + this.escapeHTML(tmpLabel) + '</span>' +
			'</span></a></figure>';
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = PictContentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Pict-Content",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"../Pict-Content-CSS.js":560,"pict-provider":552,"pict-section-code":558}],563:[function(require,module,exports){
const libPictView = require('pict-view');

const libContentCSS = require('../Pict-Content-CSS.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	// Shared with the provider under one hash so the CSS injects once whether the view, the
	// provider (parseMarkdown), or both are used.
	CSS: libContentCSS,
	CSSHash: 'Pict-Section-Content-CSS',

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Ensure the container carries the `.pict-content` class so the
		// 30+ theme-scoped CSS rules below (`.pict-content a`, `.pict-content
		// h1`, `.pict-content pre`, ...) actually match when a host passes
		// a custom container ID.  Idempotent — re-adding the class is a
		// no-op if it's already there from the host's markup.
		if (tmpContentContainer && !tmpContentContainer.classList.contains('pict-content'))
		{
			tmpContentContainer.classList.add('pict-content');
		}

		// Tag images and code blocks immediately so they're clickable.
		// Mermaid blocks are tagged after mermaid.run() resolves (see below).
		this.enableFullscreenViewers(tmpContainerID, { skipMermaid: true });

		// Post-render: initialize Mermaid diagrams if mermaid is available.
		// Once mermaid finishes, retag so the rendered SVGs are also clickable.
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render ```excalidraw fenced scenes if the
		// pict-section-excalidraw wrapper bundle is loaded.  Each fence
		// becomes a static SVG (with the scene embedded for re-edit by
		// retold-content-system).
		this.renderExcalidrawDiagrams(tmpContainerID);

		// Post-render: make ```video cards for third-party players click-to-load.
		this.hydrateVideoEmbeds(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Wire the click-to-load video cards the markdown parser emitted for third-party players.
	 *
	 * Until a reader clicks, nothing has been requested from the provider: no player, no cookies, no
	 * thumbnail, no record that this document was opened. The click is the consent, and only then is the
	 * iframe created. This is the whole reason the card exists rather than an iframe -- an embed that loads
	 * with the page has already told a third party who is reading before anyone chose anything.
	 *
	 * Degrades to a link. With no JavaScript, or before this runs, the card is an anchor to the video, which
	 * is what a server-rendered or printed copy of a document is left with.
	 *
	 * Idempotent: a hydrated figure carries data-hydrated, so a re-render does not double-bind.
	 *
	 * @param {string} [pContainerID]
	 */
	hydrateVideoEmbeds(pContainerID)
	{
		if (typeof document === 'undefined') { return; }
		let tmpContainer = pContainerID ? document.getElementById(String(pContainerID).replace(/^#/, '')) : document;
		if (!tmpContainer) { return; }
		let tmpFigures = tmpContainer.querySelectorAll('.pict-content-video-embed[data-embed]:not([data-hydrated])');
		for (let i = 0; i < tmpFigures.length; i++)
		{
			let tmpFigure = tmpFigures[i];
			tmpFigure.setAttribute('data-hydrated', 'true');
			let tmpCard = tmpFigure.querySelector('.pict-content-video-card');
			if (!tmpCard) { continue; }
			tmpCard.addEventListener('click', (pEvent) =>
			{
				// A modified click is the reader asking for a new tab; leave the anchor to do that.
				if (pEvent.metaKey || pEvent.ctrlKey || pEvent.shiftKey || pEvent.altKey || pEvent.button > 0) { return; }
				pEvent.preventDefault();
				let tmpEmbed = tmpFigure.getAttribute('data-embed') || '';
				if (!tmpEmbed) { return; }
				let tmpFrame = document.createElement('iframe');
				tmpFrame.setAttribute('src', tmpEmbed);
				tmpFrame.setAttribute('title', (tmpFigure.querySelector('.pict-content-video-title') || {}).textContent || 'Video');
				tmpFrame.setAttribute('frameborder', '0');
				tmpFrame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
				tmpFrame.setAttribute('allowfullscreen', 'allowfullscreen');
				// The player gets no referrer: which document someone watched a video from is not the
				// provider's business, and nothing about playback needs it.
				tmpFrame.setAttribute('referrerpolicy', 'no-referrer');
				tmpFrame.className = 'pict-content-video-frame';
				tmpCard.parentNode.replaceChild(tmpFrame, tmpCard);
			});
		}
	}

	/**
	 * Render any `.pict-excalidraw-fence` placeholders inside the container
	 * as static SVGs using the pict-section-excalidraw wrapper bundle's
	 * exportToSvg helper.  Each fence's scene JSON travels through a
	 * URI-component-encoded data-scene attribute (placed there by the
	 * markdown parser in Pict-Provider-Content).
	 *
	 * Gracefully degrades when the wrapper bundle isn't on the page:
	 * leaves the loading placeholder visible with a one-time console hint.
	 * Idempotent — placeholders carry `data-rendered="true"` after the
	 * first pass so re-renders don't double-emit.
	 *
	 * @param {string} [pContainerID]
	 */
	renderExcalidrawDiagrams(pContainerID)
	{
		if (typeof document === 'undefined') return;

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody) return;

		let tmpFences = tmpContentBody.querySelectorAll('.pict-excalidraw-fence:not([data-rendered])');
		if (tmpFences.length < 1) return;

		let tmpVendor = (typeof window !== 'undefined') ? window.PictSectionExcalidrawVendor : null;
		if (!tmpVendor || typeof tmpVendor.exportToSvg !== 'function')
		{
			// Bundle not loaded — leave the placeholder visible.  The host
			// can load the wrapper bundle and call renderExcalidrawDiagrams
			// again, or include the script tag in its HTML shell.
			if (this.log && this.log.warn && !this._excalidrawBundleWarnLogged)
			{
				this.log.warn('pict-excalidraw fence(s) found but pict-section-excalidraw wrapper bundle is not loaded — leaving as placeholders.');
				this._excalidrawBundleWarnLogged = true;
			}
			return;
		}

		for (let i = 0; i < tmpFences.length; i++)
		{
			let tmpFence = tmpFences[i];
			let tmpEncoded = tmpFence.getAttribute('data-scene') || '';
			let tmpJson = '';
			try { tmpJson = decodeURIComponent(tmpEncoded); }
			catch (pErr) { tmpJson = ''; }

			let tmpScene;
			try { tmpScene = JSON.parse(tmpJson); }
			catch (pErr)
			{
				this._renderExcalidrawFenceError(tmpFence, 'Invalid scene JSON: ' + pErr.message);
				continue;
			}

			let tmpExportArgs = {
				elements: tmpScene.elements || [],
				appState: Object.assign({ exportEmbedScene: true }, tmpScene.appState || {}),
				files:    tmpScene.files    || {}
			};

			tmpVendor.exportToSvg(tmpExportArgs).then((pSvgEl) =>
			{
				if (!pSvgEl) return;
				// Style the SVG to fit the fence's content width while preserving aspect.
				pSvgEl.removeAttribute('width');
				pSvgEl.removeAttribute('height');
				pSvgEl.setAttribute('style', 'max-width: 100%; height: auto;');
				tmpFence.innerHTML = '';
				tmpFence.appendChild(pSvgEl);
				tmpFence.setAttribute('data-rendered', 'true');
			}).catch((pErr) =>
			{
				this._renderExcalidrawFenceError(tmpFence,
					'Excalidraw render failed: ' + (pErr && pErr.message ? pErr.message : pErr));
			});
		}
	}

	_renderExcalidrawFenceError(pFence, pMessage)
	{
		pFence.setAttribute('data-rendered', 'true');
		pFence.classList.add('pict-excalidraw-fence-error');
		pFence.innerHTML = '<div class="pict-excalidraw-fence-error-message"></div>';
		// Use textContent on the inner div so any user-supplied error
		// substrings (e.g. parser error positions) can't introduce HTML.
		let tmpMsg = pFence.querySelector('.pict-excalidraw-fence-error-message');
		if (tmpMsg) tmpMsg.textContent = pMessage;
		if (this.log && this.log.warn) this.log.warn('pict-excalidraw fence: ' + pMessage);
	}

	/**
	 * Lazily wire mermaid into the active pict-provider-theme via the
	 * shared Theme-Diagram-Adapter. The adapter handles:
	 *   - mermaid.initialize() with the canonical pict token map
	 *   - onApply subscription (re-init + re-render on theme/mode change)
	 *   - source stashing + data-processed reset for refresh
	 *
	 * Idempotent: the first call binds the adapter, subsequent calls are
	 * no-ops.  When the provider isn't installed, mermaid still gets
	 * initialized once against whatever CSS variables happen to exist.
	 */
	_ensureMermaidAdapter()
	{
		if (this._mermaidAdapter) { return this._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				this._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				// No provider: lazy-require the adapter directly so the
				// static base theme still picks up any CSS vars on :root.
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				this._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			if (this.log && this.log.warn) { this.log.warn('Mermaid theme adapter init failed: ' + pError.message); }
			this._mermaidAdapter = null;
		}
		return this._mermaidAdapter;
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the Theme-Diagram-Adapter, which initializes
		// mermaid against the active palette and subscribes to onApply so a
		// theme/mode change triggers re-render of every pre.mermaid on the page.
		this._ensureMermaidAdapter();

		// Cache each diagram's source on the element so theme-change
		// re-renders can restore it. Mermaid replaces textContent with
		// the rendered SVG during run(), so we lose the source unless
		// we stash it here first.
		let tmpProviderForStash = this.pict && this.pict.providers && this.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		// mermaid.run() will process all pre.mermaid elements in the container.
		// It returns a promise; once it resolves the inner SVG exists and we
		// can tag the diagrams as fullscreen-clickable.
		try
		{
			let tmpResult = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(() =>
				{
					// Strip mermaid 11's inline !important fill/stroke flags
					// so the view's theme-aware .theme-dark CSS rules can win
					// against the per-node colors mermaid bakes inline.  The
					// adapter strips on every re-render; the initial render
					// runs through mermaid.run() directly so we have to call
					// the strip here too.  Without this the dark-mode rect
					// fill override silently loses to inline `!important`.
					let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
					if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
					{
						tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
					}
					this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
				}).catch((pError) =>
				{
					this.log.error('Mermaid rendering error: ' + (pError && pError.message ? pError.message : pError));
				});
			}
			else
			{
				// Synchronous fallback (older mermaid)
				let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
				if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
				{
					tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
				}
				this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
			}
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Walk the freshly-rendered content and tag images, mermaid diagrams,
	 * and fenced code blocks so they're click-to-fullscreen.  Also installs
	 * a single delegated click listener on the container the first time it
	 * is called for that container.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 * @param {Object} [pOptions] - { skipMermaid: bool, onlyMermaid: bool }
	 */
	enableFullscreenViewers(pContainerID, pOptions)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}
		let tmpOptions = pOptions || {};

		if (!tmpOptions.onlyMermaid)
		{
			// Images
			let tmpImages = tmpContentBody.querySelectorAll('img:not([data-fullscreen-source])');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpImg = tmpImages[i];
				tmpImg.setAttribute('data-fullscreen-source', 'image');
				let tmpAlt = tmpImg.getAttribute('alt');
				if (!tmpAlt)
				{
					let tmpSrc = tmpImg.getAttribute('src') || '';
					tmpAlt = tmpSrc.split('/').pop().split('?')[0] || 'Image';
				}
				tmpImg.setAttribute('data-fullscreen-title', tmpAlt);
			}

			// Code wraps (fenced blocks): do NOT tag for click-to-fullscreen —
			// that would conflict with text selection for copy/paste.
			// Instead wrap each in a container with hover-revealed action
			// buttons (fullscreen + copy) floating to the right.
			let tmpCodeWraps = tmpContentBody.querySelectorAll('.pict-content-code-wrap:not([data-code-actions-wired])');
			for (let i = 0; i < tmpCodeWraps.length; i++)
			{
				this._wireCodeActions(tmpCodeWraps[i]);
			}
		}

		if (!tmpOptions.skipMermaid)
		{
			// Mermaid diagrams (after mermaid.run() has replaced the inner pre)
			let tmpMermaid = tmpContentBody.querySelectorAll('pre.mermaid:not([data-fullscreen-source])');
			for (let i = 0; i < tmpMermaid.length; i++)
			{
				let tmpPre = tmpMermaid[i];
				// Only tag once mermaid has actually rendered an svg into it
				if (tmpPre.querySelector('svg'))
				{
					tmpPre.setAttribute('data-fullscreen-source', 'mermaid');
					tmpPre.setAttribute('data-fullscreen-title', 'Mermaid Diagram');
				}
			}
		}

		// Install delegated click listener once per container.
		if (!tmpContentBody.__pictFullscreenWired)
		{
			tmpContentBody.__pictFullscreenWired = true;
			tmpContentBody.addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				while (tmpTarget && tmpTarget !== tmpContentBody && !tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					tmpTarget = tmpTarget.parentElement;
				}
				if (tmpTarget && tmpTarget !== tmpContentBody && tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					pEvent.preventDefault();
					this._openFullscreen(tmpTarget);
				}
			});
		}
	}

	/**
	 * Wrap a fenced code block in a container that holds the existing
	 * .pict-content-code-wrap plus a hover-revealed action column with
	 * fullscreen + copy buttons.  The action column is sticky-positioned
	 * so it follows the page scroll while the user is alongside a long
	 * code block.
	 *
	 * @param {HTMLElement} pCodeWrap - The .pict-content-code-wrap element
	 */
	_wireCodeActions(pCodeWrap)
	{
		if (!pCodeWrap || pCodeWrap.hasAttribute('data-code-actions-wired'))
		{
			return;
		}
		pCodeWrap.setAttribute('data-code-actions-wired', 'true');

		// Determine the fullscreen title from the language tag, if any.
		let tmpCodeEl = pCodeWrap.querySelector('code[class*="language-"]');
		let tmpLang = 'Code';
		if (tmpCodeEl)
		{
			let tmpMatch = (tmpCodeEl.getAttribute('class') || '').match(/language-(\S+)/);
			if (tmpMatch)
			{
				tmpLang = tmpMatch[1] + ' code';
			}
		}
		pCodeWrap.setAttribute('data-code-language', tmpLang);

		// Build the wrapping container.
		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-content-code-container';

		let tmpActions = document.createElement('div');
		tmpActions.className = 'pict-content-code-actions';
		tmpActions.setAttribute('aria-hidden', 'false');

		let tmpFullscreenBtn = document.createElement('button');
		tmpFullscreenBtn.type = 'button';
		tmpFullscreenBtn.className = 'pict-content-code-action-btn';
		tmpFullscreenBtn.setAttribute('aria-label', 'Open code in fullscreen');
		tmpFullscreenBtn.setAttribute('title', 'Open in fullscreen');
		tmpFullscreenBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><polyline points="3 6 3 3 6 3"></polyline><polyline points="13 6 13 3 10 3"></polyline><polyline points="3 10 3 13 6 13"></polyline><polyline points="13 10 13 13 10 13"></polyline></svg>';

		let tmpCopyBtn = document.createElement('button');
		tmpCopyBtn.type = 'button';
		tmpCopyBtn.className = 'pict-content-code-action-btn';
		tmpCopyBtn.setAttribute('aria-label', 'Copy code to clipboard');
		tmpCopyBtn.setAttribute('title', 'Copy code');
		tmpCopyBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1.25"></rect><path d="M11 5V3.25A1.25 1.25 0 0 0 9.75 2H3.25A1.25 1.25 0 0 0 2 3.25v6.5A1.25 1.25 0 0 0 3.25 11H5"></path></svg>';

		tmpActions.appendChild(tmpFullscreenBtn);
		tmpActions.appendChild(tmpCopyBtn);

		// Insert the container in the place of the code wrap, then move the
		// code wrap inside it followed by the actions column.
		let tmpParent = pCodeWrap.parentNode;
		tmpParent.insertBefore(tmpContainer, pCodeWrap);
		tmpContainer.appendChild(pCodeWrap);
		tmpContainer.appendChild(tmpActions);

		// Click handlers
		tmpFullscreenBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._openCodeFullscreen(pCodeWrap);
		});
		tmpCopyBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._copyCodeToClipboard(pCodeWrap, tmpCopyBtn);
		});
	}

	/**
	 * Open the fullscreen overlay for a fenced code block.  Reuses the
	 * same overlay singleton as image / mermaid.
	 */
	_openCodeFullscreen(pCodeWrap)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		// Stamp the source attributes the overlay's open() expects.
		pCodeWrap.setAttribute('data-fullscreen-source', 'code');
		pCodeWrap.setAttribute('data-fullscreen-title', pCodeWrap.getAttribute('data-code-language') || 'Code');
		tmpOverlay.open(pCodeWrap);
	}

	/**
	 * Copy the raw text of a code block to the clipboard and briefly flash
	 * a "Copied!" state on the trigger button.
	 */
	_copyCodeToClipboard(pCodeWrap, pButton)
	{
		let tmpCodeEl = pCodeWrap.querySelector('code');
		let tmpText = tmpCodeEl ? tmpCodeEl.textContent : pCodeWrap.textContent;

		let fFlashOk = () =>
		{
			pButton.classList.add('is-copied');
			pButton.setAttribute('title', 'Copied!');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copied');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};
		let fFlashFail = () =>
		{
			pButton.classList.add('is-copy-failed');
			pButton.setAttribute('title', 'Copy failed');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copy-failed');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};

		try
		{
			if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
			{
				navigator.clipboard.writeText(tmpText).then(fFlashOk).catch(fFlashFail);
				return;
			}
		}
		catch (e)
		{
			// fall through to legacy fallback
		}

		// Legacy fallback for non-secure contexts.
		try
		{
			let tmpTextarea = document.createElement('textarea');
			tmpTextarea.value = tmpText;
			tmpTextarea.style.position = 'fixed';
			tmpTextarea.style.opacity = '0';
			document.body.appendChild(tmpTextarea);
			tmpTextarea.select();
			let tmpOk = document.execCommand('copy');
			document.body.removeChild(tmpTextarea);
			if (tmpOk) { fFlashOk(); } else { fFlashFail(); }
		}
		catch (e)
		{
			fFlashFail();
		}
	}

	/**
	 * Lazily build the singleton fullscreen overlay element and attach it
	 * to <body>.  Returns the existing instance if already built.
	 */
	_buildFullscreenOverlay()
	{
		if (PictContentView._FullscreenOverlay)
		{
			return PictContentView._FullscreenOverlay;
		}

		let tmpOverlay = document.createElement('div');
		tmpOverlay.className = 'pict-fullscreen-overlay';
		tmpOverlay.setAttribute('role', 'dialog');
		tmpOverlay.setAttribute('aria-modal', 'true');
		tmpOverlay.setAttribute('aria-labelledby', 'pict-fullscreen-title');
		tmpOverlay.setAttribute('hidden', '');
		tmpOverlay.innerHTML = ''
			+ '<div class="pict-fullscreen-titlebar">'
			+   '<span class="pict-fullscreen-title" id="pict-fullscreen-title"></span>'
			+   '<div class="pict-fullscreen-controls">'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-out" aria-label="Zoom out" title="Zoom out"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-reset" aria-label="Reset zoom" title="Reset zoom"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="5"></circle><line x1="8" y1="5" x2="8" y2="11"></line><line x1="5" y1="8" x2="11" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-in" aria-label="Zoom in" title="Zoom in"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line><line x1="8" y1="3" x2="8" y2="13"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn pict-fullscreen-close" data-action="close" aria-label="Close" title="Close (Esc)"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="4" y1="4" x2="12" y2="12"></line><line x1="12" y1="4" x2="4" y2="12"></line></svg></button>'
			+   '</div>'
			+ '</div>'
			+ '<div class="pict-fullscreen-stage">'
			+   '<div class="pict-fullscreen-content"></div>'
			+ '</div>';
		document.body.appendChild(tmpOverlay);

		let tmpState = {
			scale: 1,
			translateX: 0,
			translateY: 0,
			isPanning: false,
			didPan: false,
			currentKind: '',
			panStartX: 0,
			panStartY: 0,
			panOrigX: 0,
			panOrigY: 0,
			pinchInitialDistance: 0,
			pinchInitialScale: 1
		};

		let tmpStage = tmpOverlay.querySelector('.pict-fullscreen-stage');
		let tmpContent = tmpOverlay.querySelector('.pict-fullscreen-content');
		let tmpTitleEl = tmpOverlay.querySelector('.pict-fullscreen-title');

		let fApplyTransform = () =>
		{
			tmpContent.style.transform = 'translate(' + tmpState.translateX + 'px, ' + tmpState.translateY + 'px) scale(' + tmpState.scale + ')';
			tmpStage.classList.toggle('is-zoomed', tmpState.scale > 1.001);
		};

		let fClampScale = (pValue) =>
		{
			if (pValue < 0.5) return 0.5;
			if (pValue > 8) return 8;
			return pValue;
		};

		let fZoomAt = (pNewScale, pAnchorClientX, pAnchorClientY) =>
		{
			let tmpClamped = fClampScale(pNewScale);
			let tmpStageRect = tmpStage.getBoundingClientRect();
			let tmpAnchorX = (pAnchorClientX !== undefined) ? pAnchorClientX : (tmpStageRect.left + tmpStageRect.width / 2);
			let tmpAnchorY = (pAnchorClientY !== undefined) ? pAnchorClientY : (tmpStageRect.top + tmpStageRect.height / 2);
			// Convert anchor into the local coordinate of the content (which is centered)
			let tmpCenterX = tmpStageRect.left + tmpStageRect.width / 2;
			let tmpCenterY = tmpStageRect.top + tmpStageRect.height / 2;
			let tmpDX = tmpAnchorX - tmpCenterX;
			let tmpDY = tmpAnchorY - tmpCenterY;
			let tmpRatio = tmpClamped / tmpState.scale;
			tmpState.translateX = tmpDX - tmpRatio * (tmpDX - tmpState.translateX);
			tmpState.translateY = tmpDY - tmpRatio * (tmpDY - tmpState.translateY);
			tmpState.scale = tmpClamped;
			fApplyTransform();
		};

		let fResetTransform = () =>
		{
			tmpState.scale = 1;
			tmpState.translateX = 0;
			tmpState.translateY = 0;
			fApplyTransform();
		};

		let fClose = () =>
		{
			tmpOverlay.setAttribute('hidden', '');
			tmpContent.innerHTML = '';
			fResetTransform();
			document.documentElement.style.removeProperty('overflow');
			document.removeEventListener('keydown', fKeydown);
		};

		let fKeydown = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pEvent.preventDefault();
				fClose();
			}
			else if (pEvent.key === '+' || pEvent.key === '=')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale + 0.25);
			}
			else if (pEvent.key === '-' || pEvent.key === '_')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale - 0.25);
			}
			else if (pEvent.key === '0')
			{
				pEvent.preventDefault();
				fResetTransform();
			}
		};

		// Backdrop click closes (only when clicking the backdrop itself or
		// the stage area, not the inner content).  Suppress if a
		// drag-to-pan just finished — the pointerup that ended the pan
		// also fires a click event which we must ignore.
		tmpOverlay.addEventListener('click', (pEvent) =>
		{
			if (tmpState.didPan)
			{
				tmpState.didPan = false;
				return;
			}
			if (pEvent.target === tmpOverlay || pEvent.target === tmpStage)
			{
				fClose();
			}
		});

		// Toolbar buttons
		tmpOverlay.querySelectorAll('[data-action]').forEach((pBtn) =>
		{
			pBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpAction = pBtn.getAttribute('data-action');
				if (tmpAction === 'close')
				{
					fClose();
				}
				else if (tmpAction === 'zoom-in')
				{
					fZoomAt(tmpState.scale + 0.25);
				}
				else if (tmpAction === 'zoom-out')
				{
					fZoomAt(tmpState.scale - 0.25);
				}
				else if (tmpAction === 'zoom-reset')
				{
					fResetTransform();
				}
			});
		});

		// Wheel zoom — for images and mermaid diagrams.
		// For code blocks, let the browser handle native scrolling
		// so the user can scroll through long code.
		tmpStage.addEventListener('wheel', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			pEvent.preventDefault();
			let tmpDelta = -pEvent.deltaY;
			let tmpStep = (tmpDelta > 0 ? 1 : -1) * 0.15;
			fZoomAt(tmpState.scale + tmpStep, pEvent.clientX, pEvent.clientY);
		}, { passive: false });

		// Drag-to-pan when zoomed (not for code blocks — they scroll natively)
		tmpStage.addEventListener('pointerdown', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			if (tmpState.scale <= 1.001)
			{
				return;
			}
			if (pEvent.target.closest('.pict-fullscreen-controls'))
			{
				return;
			}
			tmpState.isPanning = true;
			tmpState.panStartX = pEvent.clientX;
			tmpState.panStartY = pEvent.clientY;
			tmpState.panOrigX = tmpState.translateX;
			tmpState.panOrigY = tmpState.translateY;
			tmpStage.setPointerCapture(pEvent.pointerId);
			tmpStage.classList.add('is-panning');
		});
		tmpStage.addEventListener('pointermove', (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.translateX = tmpState.panOrigX + (pEvent.clientX - tmpState.panStartX);
			tmpState.translateY = tmpState.panOrigY + (pEvent.clientY - tmpState.panStartY);
			fApplyTransform();
		});
		let fEndPan = (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.isPanning = false;
			// Flag that a pan just ended so the subsequent click event
			// (which the browser fires after pointerup) does not close
			// the overlay via the backdrop-close handler.
			tmpState.didPan = true;
			tmpStage.classList.remove('is-panning');
			try { tmpStage.releasePointerCapture(pEvent.pointerId); } catch (e) {}
		};
		tmpStage.addEventListener('pointerup', fEndPan);
		tmpStage.addEventListener('pointercancel', fEndPan);

		// Touch pinch zoom
		let tmpActiveTouches = {};
		tmpStage.addEventListener('touchstart', (pEvent) =>
		{
			for (let i = 0; i < pEvent.touches.length; i++)
			{
				let tmpT = pEvent.touches[i];
				tmpActiveTouches[tmpT.identifier] = { x: tmpT.clientX, y: tmpT.clientY };
			}
			if (pEvent.touches.length === 2)
			{
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				tmpState.pinchInitialDistance = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				tmpState.pinchInitialScale = tmpState.scale;
			}
		}, { passive: true });
		tmpStage.addEventListener('touchmove', (pEvent) =>
		{
			if (pEvent.touches.length === 2 && tmpState.pinchInitialDistance > 0)
			{
				pEvent.preventDefault();
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				let tmpRatio = tmpDist / tmpState.pinchInitialDistance;
				let tmpMidX = (tmpA.clientX + tmpB.clientX) / 2;
				let tmpMidY = (tmpA.clientY + tmpB.clientY) / 2;
				fZoomAt(tmpState.pinchInitialScale * tmpRatio, tmpMidX, tmpMidY);
			}
		}, { passive: false });
		tmpStage.addEventListener('touchend', () =>
		{
			tmpActiveTouches = {};
			tmpState.pinchInitialDistance = 0;
		});

		PictContentView._FullscreenOverlay = {
			element: tmpOverlay,
			content: tmpContent,
			titleEl: tmpTitleEl,
			state: tmpState,
			open: (pSourceEl) =>
			{
				let tmpTitle = pSourceEl.getAttribute('data-fullscreen-title') || '';
				tmpTitleEl.textContent = tmpTitle;
				tmpContent.innerHTML = '';

				let tmpKind = pSourceEl.getAttribute('data-fullscreen-source');
				tmpState.currentKind = tmpKind || '';
				let tmpClone;
				if (tmpKind === 'mermaid')
				{
					let tmpSvg = pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-mermaid-svg');
						// Drop mermaid's inline max-width / width / height style so the
						// fullscreen CSS rule actually controls the size.
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'diagram')
				{
					// Inline SVG diagram (bespoke pict-renderer-graph / excalidraw):
					// clone the <svg> and drop its intrinsic sizing so the fullscreen
					// stage controls the dimensions -- same approach as mermaid, but
					// the source element may BE the svg or a wrapper around it.
					let tmpSvg = (String(pSourceEl.tagName).toLowerCase() === 'svg') ? pSourceEl : pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-diagram-svg');
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'image')
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-img');
				}
				else
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-codewrap');
				}
				tmpContent.appendChild(tmpClone);

				// Hide zoom controls for code blocks (they scroll natively)
				let tmpZoomBtns = tmpOverlay.querySelectorAll('[data-action="zoom-in"], [data-action="zoom-out"], [data-action="zoom-reset"]');
				for (let i = 0; i < tmpZoomBtns.length; i++)
				{
					tmpZoomBtns[i].style.display = (tmpKind === 'code') ? 'none' : '';
				}

				fResetTransform();
				tmpOverlay.removeAttribute('hidden');
				document.documentElement.style.overflow = 'hidden';
				document.addEventListener('keydown', fKeydown);
			},
			close: fClose
		};
		return PictContentView._FullscreenOverlay;
	}

	/**
	 * Open the fullscreen overlay for a tagged source element.
	 */
	_openFullscreen(pSourceEl)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		tmpOverlay.open(pSourceEl);
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"../Pict-Content-CSS.js":560,"pict-provider-theme/source/Theme-Diagram-Adapter.js":550,"pict-view":733}],564:[function(require,module,exports){
// Pict-Section-Content — Demo view
//
// A thin renderable wrapper around the canonical Pict-View-Content view.
// The base view is "lazy" — it shows a Loading placeholder until its host
// application explicitly calls `displayContent(parsedHTML)`.  That works
// fine when an application has its own page logic, but it's awkward for
// the docuserve playground (which doesn't know anything about
// markdown / parseMarkdown).
//
// This demo view bridges that gap:
//   1. Ensures the PictContentProvider is registered with `pict`.
//   2. Reads markdown text from an AppData address (configurable via
//      `MarkdownDataAddress`, e.g. "AppData.ContentDemo.Markdown").
//   3. On every render, parses the markdown via the provider and calls
//      the parent view's `displayContent` to push HTML into the DOM.
//
// Host applications that need anything more elaborate (navigation,
// multiple documents, link resolvers) should keep using the canonical
// Pict-View-Content view directly.  This demo view exists for the
// playground and other "just render this markdown blob" surfaces.

const libPictViewContent = require('./Pict-View-Content.js');
const libPictContentProvider = require('../providers/Pict-Provider-Content.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content-Demo",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	// Where to read the markdown source from. Resolved against the
	// pict instance with simple dot-walking — "AppData.X.Y.Z".
	MarkdownDataAddress: "AppData.ContentDemo.Markdown",

	// AutoRender on, so the playground's wrapper just instantiates the
	// view and the markdown shows up on next tick.
	AutoRender: true,

	// Inherit CSS / Templates / Renderables from the base view so we
	// render into the same #Pict-Content-Container with the same shell.
	CSS: libPictViewContent.default_configuration.CSS,
	Templates: libPictViewContent.default_configuration.Templates,
	Renderables: libPictViewContent.default_configuration.Renderables
};

class PictContentDemoView extends libPictViewContent
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Ensure the content provider is registered. Use a stable hash
		// so repeat instantiation is a no-op.
		let tmpProviderHash = 'Pict-Content';
		if (!this.pict.providers[tmpProviderHash])
		{
			this.pict.addProvider(tmpProviderHash, libPictContentProvider.default_configuration, libPictContentProvider);
		}
	}

	/**
	 * Walk a dotted address ("AppData.X.Y.Z") against the pict instance
	 * and return the value, or null if any segment is missing.
	 */
	_readMarkdownFromAddress()
	{
		let tmpAddress = this.options.MarkdownDataAddress;
		if (!tmpAddress || typeof tmpAddress !== 'string')
		{
			return null;
		}
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.pict;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}
		return (typeof tmpCurrent === 'string') ? tmpCurrent : null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		// Pull markdown from AppData and push parsed HTML through the
		// parent view's pipeline (which also wires Mermaid / KaTeX /
		// fullscreen viewers).
		let tmpMarkdown = this._readMarkdownFromAddress();
		let tmpProvider = this.pict.providers['Pict-Content'];
		if (tmpProvider && typeof tmpMarkdown === 'string')
		{
			let tmpHTML = tmpProvider.parseMarkdown(tmpMarkdown);
			this.displayContent(tmpHTML);
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictContentDemoView;

module.exports.default_configuration = _ViewConfiguration;

},{"../providers/Pict-Provider-Content.js":562,"./Pict-View-Content.js":563}],565:[function(require,module,exports){
// Themeable wizard CSS for pict-section-dataimport. Registered once (by hash) by the provider. Covers
// the per-step body content (detect/columns/mapping/preview/push); the wizard chrome itself comes from
// pict-section-accordion, and the dropzone from pict-section-upload. Brand via the --theme-* tokens.

module.exports = /*css*/`
.psd { width: 100%; box-sizing: border-box; font-size: var(--theme-typography-size-md, 0.95rem); color: var(--theme-color-text-primary, #1f2733); }
.psd *, .psd *::before, .psd *::after { box-sizing: border-box; }
.psd-step { display: flex; flex-direction: column; gap: var(--theme-spacing-md, 0.85rem); }
.psd-hint { font-size: var(--theme-typography-size-sm, 0.86rem); color: var(--theme-color-text-muted, #6b7686); margin: 0; }
.psd-section-title { font-size: var(--theme-typography-size-md, 0.95rem); font-weight: var(--theme-typography-weight-bold, 700); margin: 0; }

/* Parse options row (delimiter, has-header, kind) */
.psd-options { display: flex; flex-wrap: wrap; align-items: center; gap: var(--theme-spacing-md, 0.9rem); }
.psd-field { display: flex; align-items: center; gap: 0.4rem; font-size: var(--theme-typography-size-sm, 0.86rem); }
.psd-field label { color: var(--theme-color-text-secondary, #45596b); }
.psd-input, .psd-select { font: inherit; font-size: var(--theme-typography-size-sm, 0.88rem); padding: 0.35rem 0.5rem;
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: var(--theme-radius-md, 6px);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.psd-input:focus, .psd-select:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-focus-outline, #156dd1) 22%, transparent); }
.psd-textarea { width: 100%; min-height: 150px; font-family: var(--theme-typography-family-mono, ui-monospace, monospace);
	font-size: var(--theme-typography-size-sm, 0.82rem); padding: 0.6rem 0.7rem; border-radius: var(--theme-radius-md, 6px);
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-secondary, #f6f7f9);
	color: var(--theme-color-text-primary, #1f2733); resize: vertical; }

/* Tables (detected columns, sample rows, generated-record preview) */
.psd-table-wrap { overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: var(--theme-radius-md, 6px); max-height: 320px; }
.psd-table { border-collapse: collapse; width: 100%; font-size: var(--theme-typography-size-sm, 0.84rem); }
.psd-table th { position: sticky; top: 0; text-align: left; padding: 0.45rem 0.6rem; white-space: nowrap;
	background: var(--theme-color-background-secondary, #f6f7f9); color: var(--theme-color-text-secondary, #45596b);
	border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); font-weight: var(--theme-typography-weight-medium, 600); }
.psd-table td { padding: 0.4rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5);
	color: var(--theme-color-text-primary, #1f2733); white-space: nowrap; max-width: 320px; overflow: hidden; text-overflow: ellipsis; }
.psd-table tr:last-child td { border-bottom: none; }
.psd-type { font-size: var(--theme-typography-size-xs, 0.72rem); color: var(--theme-color-text-muted, #6b7686); font-weight: 400; }
.psd-mono { font-family: var(--theme-typography-family-mono, ui-monospace, monospace); }
.psd-ruler { font-family: var(--theme-typography-family-mono, ui-monospace, monospace); font-size: var(--theme-typography-size-sm, 0.82rem);
	white-space: pre; overflow-x: auto; padding: 0.5rem 0.6rem; background: var(--theme-color-background-secondary, #f6f7f9);
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: var(--theme-radius-md, 6px); }

/* Mapping editor */
.psd-entity { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: var(--theme-radius-md, 8px); padding: var(--theme-spacing-md, 0.85rem); }
.psd-entity-head { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; margin-bottom: 0.6rem; }
.psd-entity-name { font-weight: var(--theme-typography-weight-bold, 700); }
.psd-entity-count { font-size: var(--theme-typography-size-xs, 0.74rem); color: var(--theme-color-text-muted, #6b7686); }
.psd-map-row { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; align-items: center; padding: 0.25rem 0; }
.psd-map-field { font-size: var(--theme-typography-size-sm, 0.86rem); }
.psd-map-required { color: var(--theme-color-status-error, #b62828); }

/* Buttons + status */
.psd-btn { cursor: pointer; font: inherit; font-size: var(--theme-typography-size-sm, 0.88rem); font-weight: var(--theme-typography-weight-medium, 600);
	padding: 0.45rem 0.9rem; border-radius: var(--theme-radius-md, 6px); border: none;
	background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-background-panel, #fff); display: inline-flex; align-items: center; gap: 0.4rem; }
.psd-btn:hover { background: var(--theme-color-brand-primaryhover, #1257ab); }
.psd-btn-ghost { background: transparent; color: var(--theme-color-brand-primary, #156dd1); border: 1px solid var(--theme-color-border-default, #d7dce3); }
.psd-btn-ghost:hover { background: var(--theme-color-background-hover, #eef1f5); }
.psd-btn:disabled { opacity: 0.5; pointer-events: none; }

.psd-report { display: flex; flex-wrap: wrap; gap: 0.5rem; }
.psd-chip { font-size: var(--theme-typography-size-sm, 0.82rem); padding: 0.25rem 0.6rem; border-radius: var(--theme-radius-pill, 999px);
	background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
.psd-chip strong { color: var(--theme-color-text-primary, #1f2733); }

.psd-banner { display: flex; align-items: center; gap: 0.45rem; padding: 0.55rem 0.75rem; border-radius: var(--theme-radius-md, 6px); font-size: var(--theme-typography-size-sm, 0.86rem); }
.psd-banner-ok { color: var(--theme-color-status-success, #2e7a3a); background: color-mix(in srgb, var(--theme-color-status-success, #2e7a3a) 12%, transparent); }
.psd-banner-warn { color: var(--theme-color-status-warning, #b8860b); background: color-mix(in srgb, var(--theme-color-status-warning, #d9a406) 14%, transparent); }
.psd-banner-error { color: var(--theme-color-status-error, #b62828); background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 12%, transparent); }
.psd-banner-info { color: var(--theme-color-status-info, #1f6fb5); background: color-mix(in srgb, var(--theme-color-status-info, #1f6fb5) 12%, transparent); }

.psd-progress { height: 8px; border-radius: var(--theme-radius-pill, 999px); overflow: hidden; background: var(--theme-color-background-tertiary, #e9edf2); }
.psd-progress-fill { height: 100%; background: var(--theme-color-brand-primary, #156dd1); transition: width var(--theme-duration-normal, 0.2s) ease; }
.psd-row-actions { display: flex; gap: 0.5rem; flex-wrap: wrap; align-items: center; }

.psd-guid { display: flex; flex-direction: column; gap: 0.4rem; margin: 0.3rem 0 0.6rem; padding: 0.5rem 0.65rem;
	border: 1px solid var(--theme-color-border-light, #e6e9ee); border-radius: var(--theme-radius-md, 6px); background: var(--theme-color-background-secondary, #f7f9fb); }
.psd-guid-line { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; }
.psd-guid-label { font-size: var(--theme-typography-size-sm, 0.82rem); font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
.psd-guid-sub { font-size: var(--theme-typography-size-sm, 0.8rem); color: var(--theme-color-text-secondary, #6b7686); }
.psd-guid-parent { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; padding-left: 0.5rem; }
.psd-guid-rm { padding: 0 0.45rem; line-height: 1.4; }
.psd-guid-add { padding-left: 0.5rem; }
.psd-guid-owncol { display: inline-flex; align-items: center; gap: 0.15rem; }
.psd-guid-owadd { max-width: 8rem; opacity: 0.85; }
.psd-guid-tpl { min-width: 16rem; font-family: var(--theme-typography-family-mono, monospace); }
.psd-guid-own-fx { padding: 0 0.5rem; font-size: var(--theme-typography-size-sm, 0.78rem); }
.psd-guid-preview { font-size: var(--theme-typography-size-sm, 0.82rem); color: var(--theme-color-text-secondary, #6b7686); }
.psd-guid-warn { display: flex; align-items: center; gap: 0.4rem; font-size: var(--theme-typography-size-sm, 0.82rem); color: var(--theme-color-status-warning, #b8860b); }
`;

},{}],566:[function(require,module,exports){
// The container for all the Pict-Section-DataImport related code.
//
// pict-section-dataimport is an embeddable, configurable data-import wizard. A host registers the
// provider and calls createImportWizard(hash, config) to drop the whole flow into its UI:
//   1. Upload a CSV / TSV / Excel / fixed-width file (pict-section-upload).
//   2. Validate + detect its schema (columns, sample rows, fixed-width boundaries).
//   3. Map source columns to a target schema (a live Meadow entity schema, or a host-config schema).
//   4. Generate comprehensions (meadow-integration's browser-safe transform engine).
//   5. Push them — records via the browser EntityProvider, or one POST to a Comprehension endpoint.
// The step container is pict-section-accordion (wizard / accordion / stepper). All four extension
// points — Parser, Schema, Push, State — are host-swappable seams.

const PictProviderDataImport = require('./providers/Pict-Provider-DataImport.js');
const PictViewDataImportWizard = require('./views/PictView-DataImport-Wizard.js');

const DataImportComprehensionBuilder = require('./services/DataImport-ComprehensionBuilder.js');
const DataImportSession = require('./services/DataImport-Session.js');

const DataImportParserProvider = require('./seams/DataImport-ParserProvider.js');
const DataImportParserDelimited = require('./seams/DataImport-Parser-Delimited.js');
const DataImportParserFixedWidth = require('./seams/DataImport-Parser-FixedWidth.js');
const DataImportParserXlsx = require('./seams/DataImport-Parser-Xlsx.js');
const DataImportSchemaProvider = require('./seams/DataImport-SchemaProvider.js');
const DataImportPushTarget = require('./seams/DataImport-PushTarget.js');
const DataImportStateStore = require('./seams/DataImport-StateStore.js');

module.exports = PictProviderDataImport;

module.exports.PictProviderDataImport = PictProviderDataImport;
module.exports.PictViewDataImportWizard = PictViewDataImportWizard;

// Core services
module.exports.DataImportComprehensionBuilder = DataImportComprehensionBuilder;
module.exports.DataImportSession = DataImportSession;

// Seams (base classes + built-in adapters) — for hosts writing custom parsers / schema sources /
// push targets / state stores.
module.exports.ParserProvider = DataImportParserProvider;
module.exports.ParserDelimited = DataImportParserDelimited;
module.exports.ParserFixedWidth = DataImportParserFixedWidth;
module.exports.ParserXlsx = DataImportParserXlsx;
module.exports.SchemaProvider = DataImportSchemaProvider;
module.exports.SchemaProviderConfig = DataImportSchemaProvider.DataImportSchemaProviderConfig;
module.exports.PushTarget = DataImportPushTarget;
module.exports.PushTargetComprehension = DataImportPushTarget.DataImportPushTargetComprehension;
module.exports.StateStore = DataImportStateStore;
module.exports.StateStoreMemory = DataImportStateStore.DataImportStateStoreMemory;
module.exports.StateStoreLocal = DataImportStateStore.DataImportStateStoreLocal;

// The Meadow seam adapters are loaded lazily by the provider (they require the engine), but exposed
// here for direct use.
module.exports.getMeadowAdapters = () => require('./providers/Pict-Provider-DataImport-Meadow.js');

module.exports.default_configuration = PictProviderDataImport.default_configuration;

},{"./providers/Pict-Provider-DataImport-Meadow.js":567,"./providers/Pict-Provider-DataImport.js":568,"./seams/DataImport-Parser-Delimited.js":569,"./seams/DataImport-Parser-FixedWidth.js":570,"./seams/DataImport-Parser-Xlsx.js":571,"./seams/DataImport-ParserProvider.js":572,"./seams/DataImport-PushTarget.js":573,"./seams/DataImport-SchemaProvider.js":574,"./seams/DataImport-StateStore.js":575,"./services/DataImport-ComprehensionBuilder.js":576,"./services/DataImport-Session.js":578,"./views/PictView-DataImport-Wizard.js":579}],567:[function(require,module,exports){
// Pict-Provider-DataImport-Meadow — the Meadow-specific seam adapters: a SchemaProvider that reads
// entity schemas from a live Meadow server, and a PushTarget that lands comprehension records via the
// browser EntityProvider + meadow-integration's Integration Adapter (GUID marshaling + FK resolution).
//
// This file (plus the ComprehensionBuilder) is where the meadow-integration engine is touched; it is
// only required when SchemaSource:'meadow' or PushMode:'entityprovider' is used. The engine is reached
// through the browser-clean Meadow-Integration-Engine re-export (no server-only code).

const libEngine = require('meadow-integration/source/Meadow-Integration-Engine.js');
const libSchemaProvider = require('../seams/DataImport-SchemaProvider.js');
const libPushTarget = require('../seams/DataImport-PushTarget.js');

/**
 * Wrap pict.EntityProvider as an Integration-Adapter REST client: adds getJSON (prefixed, for the
 * schema fetch) + getEntityByGUID (via a filtered getEntitySet, used by the adapter's fallback path),
 * and delegates upsert/get/delete straight through.
 * @param {any} pPict @param {string} pURLPrefix @return {Record<string, any>}
 */
const makeEntityProviderShim = (pPict, pURLPrefix) =>
{
	const tmpEntityProvider = pPict.EntityProvider;
	const tmpPrefix = pURLPrefix || (tmpEntityProvider.options && tmpEntityProvider.options.urlPrefix) || '/1.0/';
	return {
		serverURL: tmpPrefix,
		restClient: tmpEntityProvider.restClient,
		getJSON: (pURL, fCallback) =>
		{
			// The adapter passes an unprefixed 'Entity/Schema' — prepend the base URL unless already absolute.
			const tmpFullURL = (pURL.indexOf('http') === 0 || pURL.indexOf(tmpPrefix) === 0) ? pURL : (tmpPrefix + pURL);
			return tmpEntityProvider.restClient.getJSON(tmpFullURL, fCallback);
		},
		getEntity: (pEntity, pID, fCallback) => tmpEntityProvider.getEntity(pEntity, pID, fCallback),
		upsertEntity: (pEntity, pRecord, fCallback) => tmpEntityProvider.upsertEntity(pEntity, pRecord, fCallback),
		upsertEntities: (pEntity, pRecords, fCallback) => tmpEntityProvider.upsertEntities(pEntity, pRecords, fCallback),
		deleteEntity: (pEntity, pID, fCallback) => tmpEntityProvider.deleteEntity(pEntity, pID, fCallback),
		getEntityByGUID: (pEntity, pGUID, fCallback) =>
		{
			const tmpFilter = `FBV~GUID${pEntity}~EQ~${encodeURIComponent(pGUID)}`;
			tmpEntityProvider.getEntitySet(pEntity, tmpFilter, (pError, pRecords) =>
			{
				if (pError) { return fCallback(pError); }
				return fCallback(null, (Array.isArray(pRecords) && pRecords.length > 0) ? pRecords[0] : null);
			});
		},
	};
};

/**
 * SchemaProvider that reads each configured Meadow entity's schema from <URLPrefix><Entity>/Schema,
 * mapping it to the dataimport schema shape (inferring foreign keys from ID<Other> columns).
 */
class DataImportSchemaProviderMeadow extends libSchemaProvider
{
	getSchema()
	{
		const tmpEntities = Array.isArray(this.options.MeadowEntities) ? this.options.MeadowEntities : [];
		const tmpPrefix = this.options.URLPrefix || '/1.0/';
		const tmpEntityProvider = this.pict.EntityProvider;
		if (!tmpEntityProvider || !tmpEntityProvider.restClient)
		{
			return Promise.reject(new Error('pict-section-dataimport: a Meadow schema source needs pict.EntityProvider.'));
		}

		return Promise.all(tmpEntities.map((pEntityName) => new Promise((resolve) =>
		{
			tmpEntityProvider.restClient.getJSON(`${tmpPrefix}${pEntityName}/Schema`, (pError, pResponse, pParsedBody) =>
			{
				const tmpSchemaBody = (pParsedBody && typeof pParsedBody === 'object') ? pParsedBody
					: ((pResponse && typeof pResponse === 'object') ? pResponse : {});
				resolve(this._mapMeadowEntitySchema(pEntityName, tmpSchemaBody, tmpEntities));
			});
		}))).then((pEntityList) =>
		{
			return { Entities: pEntityList, Order: this._deriveOrder(pEntityList) };
		});
	}

	/** Map a Meadow /Schema body to the { Entity, GUIDName, Fields } shape. */
	_mapMeadowEntitySchema(pEntityName, pSchemaBody, pAllEntities)
	{
		const tmpGUIDName = `GUID${pEntityName}`;
		let tmpColumns = [];
		if (Array.isArray(pSchemaBody.Columns)) { tmpColumns = pSchemaBody.Columns; }
		else if (pSchemaBody.Schema && Array.isArray(pSchemaBody.Schema)) { tmpColumns = pSchemaBody.Schema; }
		else if (pSchemaBody.properties && typeof pSchemaBody.properties === 'object')
		{
			tmpColumns = Object.keys(pSchemaBody.properties).map((pKey) => Object.assign({ Column: pKey }, pSchemaBody.properties[pKey]));
		}

		// Audit / lifecycle columns Meadow stamps on every entity — noise in a column-mapping UI.
		const tmpSystemColumns = { CreateDate: 1, CreatingIDUser: 1, UpdateDate: 1, UpdatingIDUser: 1, Deleted: 1, DeleteDate: 1, DeletingIDUser: 1 };
		const tmpFields = tmpColumns.map((pColumn) =>
		{
			const tmpName = pColumn.Column || pColumn.Name || pColumn.column;
			let tmpForeignKeyEntity = '';
			if (tmpName && tmpName.indexOf('ID') === 0 && tmpName.length > 2)
			{
				const tmpReferenced = tmpName.slice(2);
				if (pAllEntities.indexOf(tmpReferenced) >= 0 && tmpReferenced !== pEntityName) { tmpForeignKeyEntity = tmpReferenced; }
			}
			return {
				Name: tmpName,
				Type: pColumn.DataType || pColumn.Type || pColumn.type || 'string',
				Size: Number(pColumn.Size || pColumn.size || 0) || 0,
				Required: !!(pColumn.Required || pColumn.NonNull),
				IsGUID: (tmpName === tmpGUIDName),
				ForeignKeyEntity: tmpForeignKeyEntity,
			};
		}).filter((pField) => !!pField.Name
			&& pField.Name !== `ID${pEntityName}`        // the auto-increment primary key
			&& !tmpSystemColumns[pField.Name]);          // audit/lifecycle columns

		return { Entity: pEntityName, GUIDName: tmpGUIDName, Fields: tmpFields };
	}

	/** Order entities referenced-before-referrer (entities with fewer outbound FKs first). */
	_deriveOrder(pEntityList)
	{
		const tmpNames = pEntityList.map((pEntity) => pEntity.Entity);
		const tmpFKCount = {};
		pEntityList.forEach((pEntity) =>
		{
			tmpFKCount[pEntity.Entity] = pEntity.Fields.filter((pField) => pField.ForeignKeyEntity && tmpNames.indexOf(pField.ForeignKeyEntity) >= 0).length;
		});
		// Stable sort by outbound-FK count: zero-FK reference entities first, join tables last.
		return tmpNames.slice().sort((pA, pB) => (tmpFKCount[pA] - tmpFKCount[pB]));
	}
}

/**
 * PushTarget that lands comprehension records via pict.EntityProvider, using a fresh Integration
 * Adapter per entity (so GUID marshaling + FK resolution run through meadow-integration). Entities are
 * pushed sequentially IN ORDER so each referenced entity's GUID->ID mappings populate the shared
 * MeadowGUIDMap before a referrer marshals its foreign keys.
 */
class DataImportPushTargetEntityProvider extends libPushTarget
{
	push(pComprehension, pContext)
	{
		const tmpContext = pContext || {};
		const tmpOrder = (Array.isArray(tmpContext.Order) && tmpContext.Order.length > 0) ? tmpContext.Order : Object.keys(pComprehension || {});
		const tmpShim = makeEntityProviderShim(this.pict, tmpContext.ServerURL || tmpContext.URLPrefix);
		const tmpPushed = [];
		let tmpTotal = 0;
		tmpOrder.forEach((pEntity) => { tmpTotal += Object.keys((pComprehension && pComprehension[pEntity]) || {}).length; });
		let tmpDone = 0;

		// Sequential reduce over the ordered entities (referenced entities first).
		return tmpOrder.reduce((pPromise, pEntity) => pPromise.then(() =>
		{
			const tmpRecords = (pComprehension && pComprehension[pEntity]) || {};
			const tmpGUIDs = Object.keys(tmpRecords);
			if (tmpGUIDs.length === 0) { return; }

			const tmpAdapterOptions = Object.assign({}, libEngine.MeadowIntegrationAdapter.default_configuration,
				{
					Entity: pEntity,
					EntityGUIDMarshalPrefix: tmpContext.EntityGUIDPrefix || `E-${pEntity}`,
					AdapterSetGUIDMarshalPrefix: tmpContext.GUIDPrefix || 'INTG-DEF',
					SimpleMarshal: true,
					ForceMarshal: true,
					PerformDeletes: false,
					AllowGUIDTruncation: !!tmpContext.AllowGUIDTruncation,
				});
			const tmpAdapter = new libEngine.MeadowIntegrationAdapter(this.pict, tmpAdapterOptions, `DataImport-${pEntity}`);
			tmpAdapter.setRestClient(tmpShim);
			tmpGUIDs.forEach((pGUID) => tmpAdapter.addSourceRecord(tmpRecords[pGUID]));

			return new Promise((resolve, reject) =>
			{
				tmpAdapter.integrateRecords((pError) =>
				{
					if (pError) { return reject(pError); }
					tmpPushed.push(pEntity);
					tmpDone += tmpGUIDs.length;
					if (typeof tmpContext.onProgress === 'function') { tmpContext.onProgress(tmpDone, tmpTotal); }
					return resolve();
				});
			});
		}), Promise.resolve()).then(() =>
		{
			return { Success: true, EntitiesPushed: tmpPushed, Message: `Pushed ${tmpDone} record(s) across ${tmpPushed.length} entity(ies) via EntityProvider.` };
		});
	}
}

module.exports =
{
	makeEntityProviderShim,
	DataImportSchemaProviderMeadow,
	DataImportPushTargetEntityProvider,
};

},{"../seams/DataImport-PushTarget.js":573,"../seams/DataImport-SchemaProvider.js":574,"meadow-integration/source/Meadow-Integration-Engine.js":516}],568:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewWizard = require('../views/PictView-DataImport-Wizard.js');
const libComprehensionBuilder = require('../services/DataImport-ComprehensionBuilder.js');
const libDataImportCSS = require('../Pict-Section-DataImport-CSS.js');

const libParserDelimited = require('../seams/DataImport-Parser-Delimited.js');
const libParserFixedWidth = require('../seams/DataImport-Parser-FixedWidth.js');
const libParserXlsx = require('../seams/DataImport-Parser-Xlsx.js');
const libSchemaProvider = require('../seams/DataImport-SchemaProvider.js');
const libPushTarget = require('../seams/DataImport-PushTarget.js');
const libStateStore = require('../seams/DataImport-StateStore.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Section-DataImport',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/**
 * The pict-section-dataimport provider — the embeddable API surface. Registers the wizard CSS, then
 * createImportWizard(hash, config) drops the whole upload -> validate -> map -> generate -> push flow
 * into the host's DOM. The four seams (Parser / Schema / Push / State) are normalized here from
 * strings, instances, or functions into live objects the wizard view consumes.
 */
class PictProviderDataImport extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-DataImport-CSS', libDataImportCSS, 500);
		}
		this._meadowAdapter = null;
	}

	/** Lazily require the Meadow seam adapters (only when a Meadow schema source / EntityProvider push is used). */
	_meadow()
	{
		if (!this._meadowAdapter) { this._meadowAdapter = require('./Pict-Provider-DataImport-Meadow.js'); }
		return this._meadowAdapter;
	}

	/**
	 * Create (or reconfigure + reuse) an embedded import wizard.
	 * @param {string} pWizardHash @param {Record<string, any>} pConfig
	 * @return {any} The wizard view instance.
	 */
	createImportWizard(pWizardHash, pConfig)
	{
		const tmpConfig = Object.assign(
			{
				DestinationAddress: `#${pWizardHash}`,
				RenderMode: 'wizard',
				URLPrefix: '/1.0/',
				GUIDPrefix: 'INTG-DEF',
				EntityGUIDPrefix: '',
				AllowGUIDTruncation: false,
				AllowedFileTypes: [ 'csv', 'tsv', 'xlsx', 'fixedwidth' ],
				SchemaSource: 'meadow',
				PushMode: 'entityprovider',
				StateStore: 'memory',
			},
			pConfig || {},
			{ WizardHash: pWizardHash });

		// When a context-aware GUID strategy is active the composer owns the ENTIRE GUID (the desired
		// `UI_..._...` format is not the engine's prefix-marshal format), so the marshaling prefixes must
		// be empty — otherwise the push would double-prefix the already-composed GUID.
		if (tmpConfig.GUIDStrategy)
		{
			tmpConfig.GUIDPrefix = '';
			tmpConfig.EntityGUIDPrefix = '';
		}

		// Resolve the seams onto the config — the wizard view reads these directly.
		tmpConfig.ResolvedParsers = this._resolveParsers(tmpConfig);
		tmpConfig.ResolvedSchemaProvider = this._resolveSchemaProvider(tmpConfig);
		tmpConfig.ResolvedPushTarget = this._resolvePushTarget(tmpConfig);
		tmpConfig.ResolvedStateStore = this._resolveStateStore(tmpConfig);
		tmpConfig.ComprehensionBuilder = new libComprehensionBuilder(this.pict);

		if (this.pict.views[pWizardHash])
		{
			Object.assign(this.pict.views[pWizardHash].options, tmpConfig);
			return this.pict.views[pWizardHash];
		}
		return this.pict.addView(pWizardHash, tmpConfig, libPictViewWizard);
	}

	/** Build the parser registry { kind: instance }, merging any host-supplied custom parsers. */
	_resolveParsers(pConfig)
	{
		const tmpParsers =
		{
			csv: new libParserDelimited(this.pict, { Kind: 'csv' }),
			tsv: new libParserDelimited(this.pict, { Kind: 'tsv' }),
			fixedwidth: new libParserFixedWidth(this.pict, {}),
			xlsx: new libParserXlsx(this.pict, {}),
		};
		if (pConfig.Parsers && typeof pConfig.Parsers === 'object')
		{
			Object.keys(pConfig.Parsers).forEach((pKind) => { tmpParsers[pKind] = pConfig.Parsers[pKind]; });
		}
		return tmpParsers;
	}

	/** Normalize SchemaSource: 'meadow' | 'config' | instance | function(ctx)->Promise<schema>. */
	_resolveSchemaProvider(pConfig)
	{
		const tmpSource = pConfig.SchemaSource;
		if (tmpSource && typeof tmpSource.getSchema === 'function') { return tmpSource; }
		if (typeof tmpSource === 'function') { return { getSchema: (pContext) => Promise.resolve(tmpSource(pContext)) }; }
		if (tmpSource === 'meadow')
		{
			return new (this._meadow().DataImportSchemaProviderMeadow)(this.pict, { MeadowEntities: pConfig.MeadowEntities || [], URLPrefix: pConfig.URLPrefix });
		}
		// default: a config-supplied schema descriptor
		return new libSchemaProvider.DataImportSchemaProviderConfig(this.pict, { Schema: pConfig.Schema || { Entities: [] } });
	}

	/** Normalize PushMode: 'entityprovider' | 'comprehension' | instance | function(comp,ctx)->Promise<result>. */
	_resolvePushTarget(pConfig)
	{
		const tmpMode = pConfig.PushMode;
		if (tmpMode && typeof tmpMode.push === 'function') { return tmpMode; }
		if (typeof tmpMode === 'function') { return { push: (pComprehension, pContext) => Promise.resolve(tmpMode(pComprehension, pContext)) }; }
		if (tmpMode === 'entityprovider')
		{
			return new (this._meadow().DataImportPushTargetEntityProvider)(this.pict, {});
		}
		// default: POST the whole comprehension to an endpoint
		return new libPushTarget.DataImportPushTargetComprehension(this.pict, { URL: pConfig.ComprehensionPushURL });
	}

	/** Normalize StateStore: 'memory' | 'localStorage' | instance, or a PersistenceHook on the config. */
	_resolveStateStore(pConfig)
	{
		if (pConfig.PersistenceHook && typeof pConfig.PersistenceHook.save === 'function')
		{
			return new libStateStore.DataImportStateStoreHook(this.pict, { Hook: pConfig.PersistenceHook });
		}
		const tmpStore = pConfig.StateStore;
		if (tmpStore && typeof tmpStore.save === 'function') { return tmpStore; }
		if (tmpStore === 'localStorage') { return new libStateStore.DataImportStateStoreLocal(this.pict, { KeyPrefix: pConfig.StateStoreKeyPrefix }); }
		return new libStateStore.DataImportStateStoreMemory(this.pict, {});
	}
}

module.exports = PictProviderDataImport;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../Pict-Section-DataImport-CSS.js":565,"../seams/DataImport-Parser-Delimited.js":569,"../seams/DataImport-Parser-FixedWidth.js":570,"../seams/DataImport-Parser-Xlsx.js":571,"../seams/DataImport-PushTarget.js":573,"../seams/DataImport-SchemaProvider.js":574,"../seams/DataImport-StateStore.js":575,"../services/DataImport-ComprehensionBuilder.js":576,"../views/PictView-DataImport-Wizard.js":579,"./Pict-Provider-DataImport-Meadow.js":567,"pict-provider":552}],569:[function(require,module,exports){
// DataImport-Parser-Delimited — CSV + TSV parser (hand-rolled, RFC-4180-aware, no dependency).
//
// Handles quoted fields, embedded delimiters + newlines inside quotes, and doubled "" escapes. One
// class serves both CSV and TSV; the delimiter comes from ParseConfig.Delimited.Delimiter (defaulting
// from the instance Kind). Registered as a 'csv' instance and a 'tsv' instance by the provider.

const libParserProvider = require('./DataImport-ParserProvider.js');

class DataImportParserDelimited extends libParserProvider
{
	get Kind()
	{
		return this.options.Kind || 'csv';
	}

	/** @param {Record<string, any>} pParseConfig @return {{Delimiter:string, HasHeader:boolean, SampleRowLimit:number}} */
	_settings(pParseConfig)
	{
		const tmpDelimitedConfig = (pParseConfig && pParseConfig.Delimited) || {};
		const tmpDefaultDelimiter = (this.Kind === 'tsv') ? '\t' : ',';
		return {
			Delimiter: tmpDelimitedConfig.Delimiter || tmpDefaultDelimiter,
			HasHeader: (tmpDelimitedConfig.HasHeader !== false),
			SampleRowLimit: (pParseConfig && pParseConfig.SampleRowLimit) || 25,
		};
	}

	/**
	 * Parse delimited text into an array of cell-arrays (one per record), quote-aware + multiline-safe.
	 * @param {string} pText @param {string} pDelimiter @return {Array<Array<string>>}
	 */
	parseDelimited(pText, pDelimiter)
	{
		const tmpRows = [];
		let tmpRow = [];
		let tmpField = '';
		let tmpInQuotes = false;
		const tmpText = (pText || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
		let tmpRowHasContent = false;

		for (let i = 0; i < tmpText.length; i++)
		{
			const tmpChar = tmpText[i];
			if (tmpInQuotes)
			{
				if (tmpChar === '"')
				{
					if (tmpText[i + 1] === '"') { tmpField += '"'; i++; }   // escaped doubled quote
					else { tmpInQuotes = false; }
				}
				else { tmpField += tmpChar; }
			}
			else if (tmpChar === '"')
			{
				tmpInQuotes = true;
				tmpRowHasContent = true;
			}
			else if (tmpChar === pDelimiter)
			{
				tmpRow.push(tmpField);
				tmpField = '';
				tmpRowHasContent = true;
			}
			else if (tmpChar === '\n')
			{
				tmpRow.push(tmpField);
				// Skip wholly-empty lines (a trailing newline shouldn't yield a blank record).
				if (tmpRowHasContent || tmpRow.length > 1 || tmpRow[0] !== '') { tmpRows.push(tmpRow); }
				tmpRow = [];
				tmpField = '';
				tmpRowHasContent = false;
			}
			else
			{
				tmpField += tmpChar;
				tmpRowHasContent = true;
			}
		}
		// Flush the final field/row if the file didn't end on a newline.
		if (tmpField !== '' || tmpRow.length > 0)
		{
			tmpRow.push(tmpField);
			if (tmpRowHasContent || tmpRow.length > 1 || tmpRow[0] !== '') { tmpRows.push(tmpRow); }
		}
		return tmpRows;
	}

	/** @param {number} pCount @return {Array<string>} Generated column names (Column1, Column2, …). */
	_generatedHeader(pCount)
	{
		const tmpHeader = [];
		for (let i = 0; i < pCount; i++) { tmpHeader.push(`Column${i + 1}`); }
		return tmpHeader;
	}

	detect(pFileHandle, pParseConfig)
	{
		const tmpSettings = this._settings(pParseConfig);
		return this._readText(pFileHandle).then((pText) =>
		{
			const tmpRows = this.parseDelimited(pText, tmpSettings.Delimiter);
			if (tmpRows.length === 0) { return { Columns: [], SampleRows: [], RowCountEstimate: 0 }; }
			const tmpHeader = tmpSettings.HasHeader ? tmpRows[0].map((pCell) => String(pCell).trim()) : this._generatedHeader(tmpRows[0].length);
			const tmpDataRows = tmpSettings.HasHeader ? tmpRows.slice(1) : tmpRows;
			return this._buildDetection(tmpHeader, tmpDataRows, tmpSettings.SampleRowLimit);
		});
	}

	parse(pFileHandle, pParseConfig)
	{
		const tmpSettings = this._settings(pParseConfig);
		return this._readText(pFileHandle).then((pText) =>
		{
			const tmpRows = this.parseDelimited(pText, tmpSettings.Delimiter);
			if (tmpRows.length === 0) { return []; }
			const tmpHeader = tmpSettings.HasHeader ? tmpRows[0].map((pCell) => String(pCell).trim()) : this._generatedHeader(tmpRows[0].length);
			const tmpDataRows = tmpSettings.HasHeader ? tmpRows.slice(1) : tmpRows;
			return tmpDataRows.map((pRow) =>
			{
				const tmpObject = {};
				for (let c = 0; c < tmpHeader.length; c++) { tmpObject[tmpHeader[c]] = (pRow[c] !== undefined) ? pRow[c] : ''; }
				return tmpObject;
			});
		});
	}
}

module.exports = DataImportParserDelimited;

},{"./DataImport-ParserProvider.js":572}],570:[function(require,module,exports){
// DataImport-Parser-FixedWidth — fixed-width / column-position file parser (hand-rolled, no dependency).
//
// Fixed-width files have no reliable auto-detect, so detect() with NO column spec returns the raw
// lines (so the validate UI can show a monospaced ruler for the user to define boundaries). Once
// ParseConfig.FixedWidth.Columns is set (each { Name, Start, End } — End exclusive, 0-based), detect()
// and parse() slice + trim each line into fields.

const libParserProvider = require('./DataImport-ParserProvider.js');

class DataImportParserFixedWidth extends libParserProvider
{
	get Kind()
	{
		return this.options.Kind || 'fixedwidth';
	}

	/** @param {Record<string, any>} pParseConfig @return {{Columns:Array<any>, HasHeader:boolean, SampleRowLimit:number}} */
	_settings(pParseConfig)
	{
		const tmpFixedConfig = (pParseConfig && pParseConfig.FixedWidth) || {};
		return {
			Columns: Array.isArray(tmpFixedConfig.Columns) ? tmpFixedConfig.Columns : [],
			HasHeader: !!tmpFixedConfig.HasHeader,
			SampleRowLimit: (pParseConfig && pParseConfig.SampleRowLimit) || 25,
		};
	}

	/** @param {string} pText @return {Array<string>} Non-empty lines. */
	_lines(pText)
	{
		return (pText || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter((pLine) => pLine.length > 0);
	}

	/** Slice one line into a cell array per the column spec. @param {string} pLine @param {Array<any>} pColumns @return {Array<string>} */
	_sliceLine(pLine, pColumns)
	{
		return pColumns.map((pColumn) =>
		{
			const tmpStart = (typeof pColumn.Start === 'number') ? pColumn.Start : 0;
			const tmpEnd = (typeof pColumn.End === 'number') ? pColumn.End : pLine.length;
			return pLine.substring(tmpStart, tmpEnd).trim();
		});
	}

	detect(pFileHandle, pParseConfig)
	{
		const tmpSettings = this._settings(pParseConfig);
		return this._readText(pFileHandle).then((pText) =>
		{
			const tmpLines = this._lines(pText);
			// No column spec yet — hand the raw lines back so the UI can render a boundary ruler.
			if (tmpSettings.Columns.length === 0)
			{
				return { Columns: [], SampleRows: [], RowCountEstimate: tmpLines.length, RawLines: tmpLines.slice(0, tmpSettings.SampleRowLimit) };
			}
			const tmpHeader = tmpSettings.Columns.map((pColumn) => pColumn.Name);
			const tmpDataLines = tmpSettings.HasHeader ? tmpLines.slice(1) : tmpLines;
			const tmpDataRows = tmpDataLines.map((pLine) => this._sliceLine(pLine, tmpSettings.Columns));
			const tmpDetection = this._buildDetection(tmpHeader, tmpDataRows, tmpSettings.SampleRowLimit);
			tmpDetection.RawLines = tmpLines.slice(0, tmpSettings.SampleRowLimit);
			return tmpDetection;
		});
	}

	parse(pFileHandle, pParseConfig)
	{
		const tmpSettings = this._settings(pParseConfig);
		if (tmpSettings.Columns.length === 0)
		{
			return Promise.reject(new Error('pict-section-dataimport: fixed-width parse requires a column spec (ParseConfig.FixedWidth.Columns).'));
		}
		return this._readText(pFileHandle).then((pText) =>
		{
			const tmpHeader = tmpSettings.Columns.map((pColumn) => pColumn.Name);
			const tmpDataLines = tmpSettings.HasHeader ? this._lines(pText).slice(1) : this._lines(pText);
			return tmpDataLines.map((pLine) =>
			{
				const tmpCells = this._sliceLine(pLine, tmpSettings.Columns);
				const tmpObject = {};
				for (let c = 0; c < tmpHeader.length; c++) { tmpObject[tmpHeader[c]] = tmpCells[c]; }
				return tmpObject;
			});
		});
	}
}

module.exports = DataImportParserFixedWidth;

},{"./DataImport-ParserProvider.js":572}],571:[function(require,module,exports){
// DataImport-Parser-Xlsx — Excel parser, wrapping SheetJS (xlsx). LAZY-required so the ~1MB library
// is only pulled into the bundle/process when xlsx import is actually used; xlsx is an OPTIONAL peer
// dependency (the default AllowedFileTypes can omit 'xlsx' entirely). Reads the first worksheet.

const libParserProvider = require('./DataImport-ParserProvider.js');

class DataImportParserXlsx extends libParserProvider
{
	get Kind()
	{
		return this.options.Kind || 'xlsx';
	}

	/** @return {any} The xlsx library, or throws a friendly error if it isn't installed. */
	_xlsx()
	{
		if (this._xlsxLib) { return this._xlsxLib; }
		try { this._xlsxLib = require('xlsx'); }
		catch (pError) { throw new Error('pict-section-dataimport: xlsx import needs the optional "xlsx" (SheetJS) dependency installed.'); }
		return this._xlsxLib;
	}

	/** @param {Record<string, any>} pParseConfig @return {Promise<Array<Array<any>>>} The sheet as array-of-arrays. */
	_readSheetMatrix(pFileHandle, pParseConfig)
	{
		const tmpXLSX = this._xlsx();
		return this._readArrayBuffer(pFileHandle).then((pBuffer) =>
		{
			const tmpWorkbook = tmpXLSX.read(pBuffer, { type: 'array' });
			const tmpSheetName = (pParseConfig && pParseConfig.Xlsx && pParseConfig.Xlsx.SheetName) || tmpWorkbook.SheetNames[0];
			const tmpSheet = tmpWorkbook.Sheets[tmpSheetName];
			if (!tmpSheet) { return []; }
			// header:1 → array-of-arrays; blank cells become '' so columns line up.
			return tmpXLSX.utils.sheet_to_json(tmpSheet, { header: 1, defval: '', blankrows: false });
		});
	}

	_settings(pParseConfig)
	{
		const tmpXlsxConfig = (pParseConfig && pParseConfig.Xlsx) || {};
		return {
			HasHeader: (tmpXlsxConfig.HasHeader !== false),
			SampleRowLimit: (pParseConfig && pParseConfig.SampleRowLimit) || 25,
		};
	}

	detect(pFileHandle, pParseConfig)
	{
		const tmpSettings = this._settings(pParseConfig);
		return this._readSheetMatrix(pFileHandle, pParseConfig).then((pMatrix) =>
		{
			if (!pMatrix || pMatrix.length === 0) { return { Columns: [], SampleRows: [], RowCountEstimate: 0 }; }
			const tmpHeader = tmpSettings.HasHeader
				? pMatrix[0].map((pCell) => String(pCell).trim())
				: pMatrix[0].map((pCell, pIndex) => `Column${pIndex + 1}`);
			const tmpDataRows = tmpSettings.HasHeader ? pMatrix.slice(1) : pMatrix;
			return this._buildDetection(tmpHeader, tmpDataRows, tmpSettings.SampleRowLimit);
		});
	}

	parse(pFileHandle, pParseConfig)
	{
		const tmpSettings = this._settings(pParseConfig);
		return this._readSheetMatrix(pFileHandle, pParseConfig).then((pMatrix) =>
		{
			if (!pMatrix || pMatrix.length === 0) { return []; }
			const tmpHeader = tmpSettings.HasHeader
				? pMatrix[0].map((pCell) => String(pCell).trim())
				: pMatrix[0].map((pCell, pIndex) => `Column${pIndex + 1}`);
			const tmpDataRows = tmpSettings.HasHeader ? pMatrix.slice(1) : pMatrix;
			return tmpDataRows.map((pRow) =>
			{
				const tmpObject = {};
				for (let c = 0; c < tmpHeader.length; c++) { tmpObject[tmpHeader[c]] = (pRow[c] !== undefined) ? pRow[c] : ''; }
				return tmpObject;
			});
		});
	}
}

module.exports = DataImportParserXlsx;

},{"./DataImport-ParserProvider.js":572,"xlsx":363}],572:[function(require,module,exports){
// DataImport-ParserProvider — the abstract file-parser seam.
//
// A parser turns an uploaded file handle (the pict-section-upload shape: { Name, Size, Type,
// getText(cb), getArrayBuffer(cb) }) into (a) a DETECTION result for the validate/map UI — detected
// columns + sample rows + an estimated row count — and (b) a full row stream for comprehension
// generation. Hosts can register custom parsers (e.g. EBCDIC, a bespoke binary) by extending this and
// registering the instance under a file kind. The module stays format-agnostic behind this seam.

class DataImportParserProvider
{
	/**
	 * @param {any} pPict @param {Record<string, any>} pOptions
	 */
	constructor(pPict, pOptions)
	{
		this.pict = pPict;
		this.options = pOptions || {};
	}

	/** @return {string} The file kind this parser handles ('csv' | 'tsv' | 'fixedwidth' | 'xlsx' | custom). */
	get Kind()
	{
		return this.options.Kind || 'base';
	}

	/**
	 * Inspect a file: return the detected columns, a sample of rows, and an estimated total row count.
	 * @param {Record<string, any>} pFileHandle @param {Record<string, any>} pParseConfig
	 * @return {Promise<{Columns:Array<any>, SampleRows:Array<any>, RowCountEstimate:number, RawLines?:Array<string>}>}
	 */
	detect(pFileHandle, pParseConfig)
	{
		return Promise.reject(new Error(`pict-section-dataimport: parser [${this.Kind}] does not implement detect().`));
	}

	/**
	 * Parse the whole file into an array of row objects (keyed by column name).
	 * @param {Record<string, any>} pFileHandle @param {Record<string, any>} pParseConfig
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	parse(pFileHandle, pParseConfig)
	{
		return Promise.reject(new Error(`pict-section-dataimport: parser [${this.Kind}] does not implement parse().`));
	}

	/** Read a file handle's text content as a Promise. @param {Record<string, any>} pFileHandle @return {Promise<string>} */
	_readText(pFileHandle)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pFileHandle || typeof pFileHandle.getText !== 'function')
			{
				return reject(new Error('pict-section-dataimport: file handle has no getText().'));
			}
			pFileHandle.getText((pError, pText) => (pError ? reject(pError) : resolve(pText || '')));
		});
	}

	/** Read a file handle's bytes as a Promise. @param {Record<string, any>} pFileHandle @return {Promise<ArrayBuffer>} */
	_readArrayBuffer(pFileHandle)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pFileHandle || typeof pFileHandle.getArrayBuffer !== 'function')
			{
				return reject(new Error('pict-section-dataimport: file handle has no getArrayBuffer().'));
			}
			pFileHandle.getArrayBuffer((pError, pBuffer) => (pError ? reject(pError) : resolve(pBuffer)));
		});
	}

	/**
	 * Cheap value-type inference for the detected-columns UI (presentational only — never coerces data).
	 * @param {Array<any>} pValues @return {string} 'integer' | 'number' | 'boolean' | 'date' | 'string'
	 */
	_inferType(pValues)
	{
		const tmpSample = (pValues || []).filter((pValue) => pValue !== undefined && pValue !== null && String(pValue).trim() !== '');
		if (tmpSample.length === 0) { return 'string'; }
		let tmpAllInteger = true;
		let tmpAllNumber = true;
		let tmpAllBoolean = true;
		let tmpAllDate = true;
		for (let i = 0; i < tmpSample.length; i++)
		{
			const tmpValue = String(tmpSample[i]).trim();
			if (!/^-?\d+$/.test(tmpValue)) { tmpAllInteger = false; }
			if (!/^-?\d*\.?\d+(?:[eE][+-]?\d+)?$/.test(tmpValue)) { tmpAllNumber = false; }
			if (!/^(true|false|yes|no|0|1)$/i.test(tmpValue)) { tmpAllBoolean = false; }
			if (isNaN(Date.parse(tmpValue))) { tmpAllDate = false; }
		}
		if (tmpAllInteger) { return 'integer'; }
		if (tmpAllNumber) { return 'number'; }
		if (tmpAllBoolean) { return 'boolean'; }
		if (tmpAllDate) { return 'date'; }
		return 'string';
	}

	/**
	 * Build the {Columns, SampleRows, RowCountEstimate} detection result from a header + data rows.
	 * @param {Array<string>} pHeader @param {Array<Array<any>>} pDataRows @param {number} pSampleLimit
	 * @return {{Columns:Array<any>, SampleRows:Array<any>, RowCountEstimate:number}}
	 */
	_buildDetection(pHeader, pDataRows, pSampleLimit)
	{
		const tmpLimit = pSampleLimit || 25;
		const tmpSampleRows = [];
		for (let i = 0; i < Math.min(pDataRows.length, tmpLimit); i++)
		{
			const tmpRowObject = {};
			for (let c = 0; c < pHeader.length; c++) { tmpRowObject[pHeader[c]] = pDataRows[i][c]; }
			tmpSampleRows.push(tmpRowObject);
		}
		const tmpColumns = pHeader.map((pName, pIndex) =>
		{
			const tmpColumnValues = pDataRows.slice(0, tmpLimit).map((pRow) => pRow[pIndex]);
			return { Index: pIndex, SourceName: pName, InferredType: this._inferType(tmpColumnValues), SampleValues: tmpColumnValues.slice(0, 3) };
		});
		return { Columns: tmpColumns, SampleRows: tmpSampleRows, RowCountEstimate: pDataRows.length };
	}
}

module.exports = DataImportParserProvider;

},{}],573:[function(require,module,exports){
// DataImport-PushTarget — the abstract push seam, plus the built-in Comprehension-POST adapter.
//
// push() takes the generated comprehension + a context (GUID prefixes, server URL, the entity Order,
// an onProgress hook) and lands it somewhere, returning { Success, EntitiesPushed, Message }. The
// POST adapter sends the whole comprehension to a /Comprehension/Push endpoint (the server owns the
// meadow-integration engine) — so this path needs no client-side EntityProvider. The direct
// per-record EntityProvider push adapter lives in Pict-Provider-DataImport-Meadow.js.

class DataImportPushTarget
{
	constructor(pPict, pOptions)
	{
		this.pict = pPict;
		this.options = pOptions || {};
	}

	/**
	 * @param {Record<string, any>} pComprehension @param {Record<string, any>} pContext
	 * @return {Promise<{Success:boolean, EntitiesPushed:Array<string>, Message:string}>}
	 */
	push(pComprehension, pContext)
	{
		return Promise.reject(new Error('pict-section-dataimport: PushTarget does not implement push().'));
	}
}

/**
 * Built-in adapter: POST the whole comprehension to a Comprehension/Push endpoint. The request body
 * matches meadow-integration's Endpoint-ComprehensionPush contract:
 *   { Comprehension, GUIDPrefix, EntityGUIDPrefix, ServerURL } -> { Success, EntitiesPushed, Message }
 * A host can inject a PostFunction (url, body) => Promise<responseJson> for tests / custom transport;
 * otherwise it uses fetch, falling back to the pict EntityProvider rest client.
 */
class DataImportPushTargetComprehension extends DataImportPushTarget
{
	push(pComprehension, pContext)
	{
		const tmpContext = pContext || {};
		const tmpURL = this.options.URL || tmpContext.ComprehensionPushURL || '/1.0/Comprehension/Push';
		const tmpBody = {
			Comprehension: pComprehension,
			GUIDPrefix: tmpContext.GUIDPrefix,
			EntityGUIDPrefix: tmpContext.EntityGUIDPrefix,
			ServerURL: tmpContext.ServerURL,
		};
		const fPost = (typeof this.options.PostFunction === 'function') ? this.options.PostFunction : this._defaultPost.bind(this);
		return Promise.resolve(fPost(tmpURL, tmpBody)).then((pResponse) =>
		{
			const tmpResponse = pResponse || {};
			return {
				Success: (tmpResponse.Success !== undefined) ? tmpResponse.Success : true,
				EntitiesPushed: Array.isArray(tmpResponse.EntitiesPushed) ? tmpResponse.EntitiesPushed : Object.keys(pComprehension || {}),
				Message: tmpResponse.Message || 'Comprehension posted.',
			};
		});
	}

	/** Default JSON POST: fetch when available, else the pict EntityProvider rest client. */
	_defaultPost(pURL, pBody)
	{
		if (typeof fetch === 'function')
		{
			return fetch(pURL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(pBody) })
				.then((pResult) => pResult.json());
		}
		if (this.pict && this.pict.EntityProvider && this.pict.EntityProvider.restClient && typeof this.pict.EntityProvider.restClient.postJSON === 'function')
		{
			return new Promise((resolve, reject) =>
			{
				this.pict.EntityProvider.restClient.postJSON({ url: pURL, body: pBody }, (pError, pResponse, pResponseBody) =>
				{
					if (pError) { return reject(pError); }
					resolve(pResponseBody || (pResponse && pResponse.body) || {});
				});
			});
		}
		return Promise.reject(new Error('pict-section-dataimport: no fetch / rest client available to POST the comprehension.'));
	}
}

module.exports = DataImportPushTarget;
module.exports.DataImportPushTargetComprehension = DataImportPushTargetComprehension;

},{}],574:[function(require,module,exports){
// DataImport-SchemaProvider — the abstract target-schema seam, plus the built-in config-schema
// adapter (a complex, non-Meadow schema supplied entirely by host configuration).
//
// getSchema() returns the target entities + fields the mapping step maps columns ONTO:
//   { Entities: [ { Entity, GUIDName, Fields: [ { Name, Type, Size, Required, IsGUID, ForeignKeyEntity,
//     FKGUIDTemplate } ] } ], Order: [ entityName, ... ] }
// The Meadow adapter (which fetches <URLPrefix><Entity>/Schema) lives in Pict-Provider-DataImport-Meadow.js
// so this file — and the whole core — stays free of any Meadow/EntityProvider dependency.

class DataImportSchemaProvider
{
	constructor(pPict, pOptions)
	{
		this.pict = pPict;
		this.options = pOptions || {};
	}

	/**
	 * @param {Record<string, any>} pContext
	 * @return {Promise<{Entities:Array<any>, Order:Array<string>}>}
	 */
	getSchema(pContext)
	{
		return Promise.reject(new Error('pict-section-dataimport: SchemaProvider does not implement getSchema().'));
	}

	/** Normalize a raw schema descriptor: default GUIDName, ensure Fields arrays + an Order. @param {Record<string, any>} pSchema */
	_normalizeSchema(pSchema)
	{
		const tmpEntities = (pSchema && Array.isArray(pSchema.Entities)) ? pSchema.Entities : [];
		const tmpNormalized = tmpEntities.map((pEntity) =>
		{
			return {
				Entity: pEntity.Entity,
				GUIDName: pEntity.GUIDName || `GUID${pEntity.Entity}`,
				GUIDTemplateDefault: pEntity.GUIDTemplateDefault || '',
				Fields: Array.isArray(pEntity.Fields) ? pEntity.Fields.map((pField) =>
				{
					return Object.assign({
						Name: pField.Name,
						Type: pField.Type || 'string',
						Size: (typeof pField.Size === 'number') ? pField.Size : 0,
						Required: !!pField.Required,
						IsGUID: (pField.IsGUID !== undefined) ? !!pField.IsGUID : (pField.Name === (pEntity.GUIDName || `GUID${pEntity.Entity}`)),
						ForeignKeyEntity: pField.ForeignKeyEntity || '',
						FKGUIDTemplate: pField.FKGUIDTemplate || '',
					}, pField);
				}) : [],
			};
		});
		const tmpOrder = (pSchema && Array.isArray(pSchema.Order) && pSchema.Order.length > 0)
			? pSchema.Order
			: tmpNormalized.map((pEntity) => pEntity.Entity);
		return { Entities: tmpNormalized, Order: tmpOrder };
	}
}

/**
 * Built-in adapter: the target schema is a descriptor passed directly in host config (the
 * "complex REST schema defined by configuration" case). No network — just normalization.
 */
class DataImportSchemaProviderConfig extends DataImportSchemaProvider
{
	getSchema()
	{
		const tmpSchema = this.options.Schema || { Entities: [] };
		return Promise.resolve(this._normalizeSchema(tmpSchema));
	}
}

module.exports = DataImportSchemaProvider;
module.exports.DataImportSchemaProviderConfig = DataImportSchemaProviderConfig;

},{}],575:[function(require,module,exports){
// DataImport-StateStore — the abstract persistence seam, plus built-in memory + localStorage adapters.
//
// This is what lets a user reload a partially-mapped dataset: the wizard serializes its session (file
// ref, parse config, detected columns, the mapping) and save()s it; load()/list() bring it back. A
// host can supply a custom store (or the lighter PersistenceHook on the wizard config) to persist
// sessions on a server instead.

class DataImportStateStore
{
	constructor(pPict, pOptions)
	{
		this.pict = pPict;
		this.options = pOptions || {};
	}

	/** @param {string} pSessionId @param {Record<string, any>} pSerializedSession @return {Promise<void>} */
	save(pSessionId, pSerializedSession) { return Promise.reject(new Error('not implemented')); }
	/** @param {string} pSessionId @return {Promise<Record<string, any>|null>} */
	load(pSessionId) { return Promise.reject(new Error('not implemented')); }
	/** @return {Promise<Array<{SessionId:string, Title:string, UpdatedAt:number}>>} */
	list() { return Promise.reject(new Error('not implemented')); }
	/** @param {string} pSessionId @return {Promise<void>} */
	remove(pSessionId) { return Promise.reject(new Error('not implemented')); }
}

/** Ephemeral in-process store (fine for tests + transient sessions). */
class DataImportStateStoreMemory extends DataImportStateStore
{
	constructor(pPict, pOptions)
	{
		super(pPict, pOptions);
		this._map = {};
	}

	save(pSessionId, pSerializedSession)
	{
		this._map[pSessionId] = JSON.parse(JSON.stringify(pSerializedSession));
		return Promise.resolve();
	}
	load(pSessionId)
	{
		return Promise.resolve(this._map[pSessionId] ? JSON.parse(JSON.stringify(this._map[pSessionId])) : null);
	}
	list()
	{
		return Promise.resolve(Object.keys(this._map).map((pKey) =>
		{
			const tmpSession = this._map[pKey] || {};
			return { SessionId: pKey, Title: tmpSession.Title || pKey, UpdatedAt: tmpSession.UpdatedAt || 0 };
		}));
	}
	remove(pSessionId)
	{
		delete this._map[pSessionId];
		return Promise.resolve();
	}
}

/** Browser localStorage store, keyed by an options.KeyPrefix (default 'dataimport:'). */
class DataImportStateStoreLocal extends DataImportStateStore
{
	get _prefix() { return this.options.KeyPrefix || 'dataimport:'; }

	_storage()
	{
		if (typeof localStorage === 'undefined') { throw new Error('pict-section-dataimport: localStorage is not available in this environment.'); }
		return localStorage;
	}

	save(pSessionId, pSerializedSession)
	{
		try { this._storage().setItem(this._prefix + pSessionId, JSON.stringify(pSerializedSession)); return Promise.resolve(); }
		catch (pError) { return Promise.reject(pError); }
	}
	load(pSessionId)
	{
		try
		{
			const tmpRaw = this._storage().getItem(this._prefix + pSessionId);
			return Promise.resolve(tmpRaw ? JSON.parse(tmpRaw) : null);
		}
		catch (pError) { return Promise.reject(pError); }
	}
	list()
	{
		try
		{
			const tmpStorage = this._storage();
			const tmpSessions = [];
			for (let i = 0; i < tmpStorage.length; i++)
			{
				const tmpKey = tmpStorage.key(i);
				if (tmpKey && tmpKey.indexOf(this._prefix) === 0)
				{
					let tmpSession = {};
					try { tmpSession = JSON.parse(tmpStorage.getItem(tmpKey)) || {}; } catch (pError) { tmpSession = {}; }
					tmpSessions.push({ SessionId: tmpKey.slice(this._prefix.length), Title: tmpSession.Title || tmpKey, UpdatedAt: tmpSession.UpdatedAt || 0 });
				}
			}
			return Promise.resolve(tmpSessions);
		}
		catch (pError) { return Promise.reject(pError); }
	}
	remove(pSessionId)
	{
		try { this._storage().removeItem(this._prefix + pSessionId); return Promise.resolve(); }
		catch (pError) { return Promise.reject(pError); }
	}
}

/** Adapter that wraps a host-supplied PersistenceHook { save, load, list, remove } (e.g. server persistence). */
class DataImportStateStoreHook extends DataImportStateStore
{
	save(pSessionId, pSerializedSession) { return Promise.resolve(this.options.Hook.save(pSessionId, pSerializedSession)); }
	load(pSessionId) { return Promise.resolve(this.options.Hook.load(pSessionId)); }
	list() { return Promise.resolve(this.options.Hook.list ? this.options.Hook.list() : []); }
	remove(pSessionId) { return Promise.resolve(this.options.Hook.remove ? this.options.Hook.remove(pSessionId) : undefined); }
}

module.exports = DataImportStateStore;
module.exports.DataImportStateStoreMemory = DataImportStateStoreMemory;
module.exports.DataImportStateStoreLocal = DataImportStateStoreLocal;
module.exports.DataImportStateStoreHook = DataImportStateStoreHook;

},{}],576:[function(require,module,exports){
// DataImport-ComprehensionBuilder — turns a mapping + parsed rows into a Comprehension, using
// meadow-integration's browser-safe transform engine (reached via the clean Meadow-Integration-Engine
// re-export, which pulls in NO server-only code — verified). This is the only client-side piece that
// needs the engine, and it's the heart of the module: it runs the canonical transformRecord pipeline
// (Solvers + MultipleGUIDUniqueness fan-out) so the comprehensions are byte-identical to what the
// meadow-integration CLI would produce from the same mapping files.

const libEngine = require('meadow-integration/source/Meadow-Integration-Engine.js');

class DataImportComprehensionBuilder
{
	/**
	 * @param {any} pPict
	 * @param {any} [pTransform] - inject a transform engine (tests); else one is built from the engine export.
	 */
	constructor(pPict, pTransform)
	{
		this.pict = pPict;
		this.transform = pTransform || new libEngine.MeadowIntegrationTabularTransform(pPict);
	}

	/**
	 * Build a comprehension from a multi-entity mapping + parsed rows.
	 * @param {Record<string, any>} pMapping - { Order:[entityName,…], Entities:{ <name>: <entityMapping> } }
	 *   where each entityMapping is the meadow mapping shape: { Entity, GUIDName?, GUIDTemplate, Mappings,
	 *   Solvers?, MultipleGUIDUniqueness?, ManyfestAddresses? }.
	 * @param {Array<Record<string, any>>} pRows
	 * @return {{Comprehension:Record<string, any>, Report:Record<string, any>}}
	 */
	build(pMapping, pRows)
	{
		const tmpRows = Array.isArray(pRows) ? pRows : [];
		const tmpEntities = (pMapping && pMapping.Entities) || {};
		const tmpOrder = (pMapping && Array.isArray(pMapping.Order) && pMapping.Order.length > 0)
			? pMapping.Order
			: Object.keys(tmpEntities);

		const tmpComprehension = {};
		const tmpReport = { ParsedRowCount: tmpRows.length, EntityCounts: {}, BadRecords: [] };

		// Process entities IN ORDER so the comprehension's keys come out referenced-before-referrer
		// (the push paths do no topo-sort — emission order is load-bearing for FK resolution).
		for (let e = 0; e < tmpOrder.length; e++)
		{
			const tmpEntityKey = tmpOrder[e];
			const tmpEntityMapping = tmpEntities[tmpEntityKey];
			if (!tmpEntityMapping || !tmpEntityMapping.Entity) { continue; }

			const tmpOutcome = this.transform.newMappingOutcomeObject();
			// Set a truthy ImplicitConfiguration so the engine's implicit-generation branch (which would
			// otherwise dereference an undefined variable) never runs; our explicit mapping is authoritative.
			tmpOutcome.ImplicitConfiguration = {};
			tmpOutcome.ExplicitConfiguration = tmpEntityMapping;
			this.transform.initializeMappingOutcomeObject(tmpOutcome);

			for (let r = 0; r < tmpRows.length; r++)
			{
				try { this.transform.transformRecord(tmpRows[r], tmpOutcome); }
				catch (pError)
				{
					tmpReport.BadRecords.push({ Entity: tmpEntityMapping.Entity, RowIndex: r, Reason: pError.message || String(pError), Row: tmpRows[r] });
				}
			}

			const tmpEntityName = tmpEntityMapping.Entity;
			tmpComprehension[tmpEntityName] = tmpOutcome.Comprehension[tmpEntityName] || {};
			tmpReport.EntityCounts[tmpEntityName] = Object.keys(tmpComprehension[tmpEntityName]).length;
			(tmpOutcome.BadRecords || []).forEach((pBadRow) =>
			{
				tmpReport.BadRecords.push({ Entity: tmpEntityName, Reason: 'No valid GUID generated for record', Row: pBadRow });
			});
		}

		return { Comprehension: tmpComprehension, Report: tmpReport };
	}

	/**
	 * Pre-flight FK-ordering check: flag any `GUID<Other>` mapping field whose referenced entity appears
	 * LATER than (or not in) the Order — those FKs would silently resolve to NULL/0 at push time.
	 * @param {Record<string, any>} pMapping
	 * @return {Array<{Entity:string, Field:string, ReferencedEntity:string, Message:string}>}
	 */
	validateForeignKeyOrder(pMapping)
	{
		const tmpEntities = (pMapping && pMapping.Entities) || {};
		const tmpOrder = (pMapping && Array.isArray(pMapping.Order) && pMapping.Order.length > 0)
			? pMapping.Order
			: Object.keys(tmpEntities);
		const tmpEntityNames = tmpOrder
			.map((pKey) => tmpEntities[pKey] && tmpEntities[pKey].Entity)
			.filter(Boolean);
		const tmpIndexByEntity = {};
		tmpEntityNames.forEach((pName, pIndex) => { tmpIndexByEntity[pName] = pIndex; });

		const tmpWarnings = [];
		tmpOrder.forEach((pKey, pIndex) =>
		{
			const tmpEntityMapping = tmpEntities[pKey];
			if (!tmpEntityMapping || !tmpEntityMapping.Mappings) { return; }
			const tmpGUIDName = tmpEntityMapping.GUIDName || `GUID${tmpEntityMapping.Entity}`;
			Object.keys(tmpEntityMapping.Mappings).forEach((pFieldName) =>
			{
				if (pFieldName === tmpGUIDName) { return; }                 // the entity's own GUID, not an FK
				if (pFieldName.indexOf('GUID') !== 0) { return; }            // only GUID<Other> fields are FKs
				const tmpReferenced = pFieldName.slice(4);
				if (!tmpReferenced || tmpReferenced === tmpEntityMapping.Entity) { return; }
				if (!(tmpReferenced in tmpIndexByEntity)) { return; }        // references something outside this import — fine
				if (tmpIndexByEntity[tmpReferenced] >= pIndex)
				{
					tmpWarnings.push({
						Entity: tmpEntityMapping.Entity,
						Field: pFieldName,
						ReferencedEntity: tmpReferenced,
						Message: `"${tmpEntityMapping.Entity}.${pFieldName}" references "${tmpReferenced}", which is generated after it — reorder so "${tmpReferenced}" comes first, or its foreign key will be unresolved.`,
					});
				}
			});
		});
		return tmpWarnings;
	}
}

module.exports = DataImportComprehensionBuilder;

},{"meadow-integration/source/Meadow-Integration-Engine.js":516}],577:[function(require,module,exports){
// DataImport-GuidStrategyApply — wires the meadow-integration GUID strategy compiler into a wizard
// mapping. Given the per-entity strategy config + the host context catalog + the resolved schema (for
// the GUID column widths), it compiles the strategy and attaches it to each entity mapping, then strips
// the GUID / FK fields the strategy now owns out of each entity's data Mappings.
//
// Thin glue over meadow-integration's engine (the composer + compiler live there, reused by the CLI +
// server endpoints too); this only knows the dataimport mapping shape. Pure + unit-testable.

const libEngine = require('meadow-integration/source/Meadow-Integration-Engine.js');

/**
 * Build { <entity>: <GUID column width> } from a resolved dataimport schema (Entities[].Fields[].Size,
 * IsGUID), so the composer can keep each entity's GUID inside its column.
 * @param {Record<string, any>} pSchema
 * @returns {Record<string, number>}
 */
function schemaSizes(pSchema)
{
	const tmpSizes = {};
	((pSchema && pSchema.Entities) || []).forEach((pEntity) =>
	{
		const tmpGUIDField = (pEntity.Fields || []).find((pField) => pField.IsGUID);
		if (tmpGUIDField && (Number(tmpGUIDField.Size) > 0))
		{
			tmpSizes[pEntity.Entity] = Number(tmpGUIDField.Size);
		}
	});
	return tmpSizes;
}

/**
 * Compile + attach GUID strategies to a mapping.
 * @param {Record<string, any>} pMapping - { Order, Entities:{ <name>: <entityMapping> } }
 * @param {Record<string, any>} pStrategyConfig - { Prefix?, Entities:{ <name>: <entityConfig> } }
 * @param {Record<string, any>} pCatalog - { <entity>:{ Abbrev, KeyField } }
 * @param {Record<string, any>} pSchema - resolved dataimport schema (for GUID column sizes)
 * @returns {{Mapping:Record<string, any>, Warnings:Array<string>}}
 */
function applyStrategy(pMapping, pStrategyConfig, pCatalog, pSchema)
{
	const tmpCompiled = libEngine.compileGUIDStrategy(pStrategyConfig || {}, { Catalog: pCatalog || {}, SchemaSizes: schemaSizes(pSchema) });
	const tmpEntities = (pMapping && pMapping.Entities) || {};

	Object.keys(tmpEntities).forEach((pEntityName) =>
	{
		const tmpStrategy = tmpCompiled.Strategies[pEntityName];
		if (!tmpStrategy) { return; }
		const tmpEntityMapping = tmpEntities[pEntityName];
		tmpEntityMapping.GUIDStrategy = tmpStrategy;

		// Strip the fields the strategy now stamps (own GUID + every FK field) out of the data Mappings,
		// so they aren't double-written by the flat-template Mappings loop.
		const tmpStrategyFields = {};
		if (tmpStrategy.Own && tmpStrategy.Own.FieldName) { tmpStrategyFields[tmpStrategy.Own.FieldName] = true; }
		(tmpStrategy.Joins || []).forEach((pJoin) => { if (pJoin.FieldName) { tmpStrategyFields[pJoin.FieldName] = true; } });
		if (tmpEntityMapping.Mappings)
		{
			Object.keys(tmpEntityMapping.Mappings).forEach((pField) =>
			{
				if (tmpStrategyFields[pField]) { delete tmpEntityMapping.Mappings[pField]; }
			});
		}
	});

	return { Mapping: pMapping, Warnings: tmpCompiled.Warnings || [] };
}

/**
 * Build a meadow-integration strategy config from the simplified per-entity UI model the wizard panel
 * edits. Each "parent link" becomes BOTH a context segment in the entity's own GUID (when prefixed) AND
 * a foreign-key join — which is the user's mental model (`UI_C10_P01278_LI8675309` embeds Contract +
 * Project context and the Line Item carries GUIDContract / GUIDProject FKs).
 * @param {Record<string, any>} pUIEntities - { <entity>: { Mode, OwnKeyColumn, Parents:[{Entity,KeyColumn,Mode,CrossSession}] } }
 * @param {string} pPrefix - the GUID prefix (e.g. 'UI')
 * @returns {{Prefix:string, Entities:Record<string, any>}}
 */
function buildStrategyConfig(pUIEntities, pPrefix)
{
	const tmpEntities = {};
	Object.keys(pUIEntities || {}).forEach((pEntityName) =>
	{
		const tmpUI = pUIEntities[pEntityName] || {};
		const tmpParents = Array.isArray(tmpUI.Parents) ? tmpUI.Parents : [];
		// Only prefixed parents contribute a context segment to the own GUID (raw / rawid carry an external
		// GUID / ID that has no composable key for the prefix).
		const tmpContextEntities = [];
		const tmpContextKeyColumns = {};
		tmpParents.forEach((pParent) =>
		{
			if ((pParent.Mode || 'prefixed') === 'prefixed' && pParent.Entity)
			{
				tmpContextEntities.push(pParent.Entity);
				tmpContextKeyColumns[pParent.Entity] = pParent.KeyColumn;
			}
		});
		tmpEntities[pEntityName] = {
			Mode: tmpUI.Mode || 'prefixed',
			OwnKeyColumn: tmpUI.OwnKeyColumn,
			// Combinatorial own key: several columns concatenated, or a user-typed pict template. The engine's
			// ownValueTemplate() prefers OwnKeyTemplate, then OwnKeyColumns, then the single OwnKeyColumn.
			OwnKeyColumns: Array.isArray(tmpUI.OwnKeyColumns) ? tmpUI.OwnKeyColumns : undefined,
			OwnKeyTemplate: tmpUI.OwnKeyTemplate,
			OwnGUIDColumn: tmpUI.OwnGUIDColumn,
			ContextEntities: tmpContextEntities,
			ContextKeyColumns: tmpContextKeyColumns,
			Joins: tmpParents.filter((pParent) => !!pParent.Entity).map((pParent) =>
			{
				const tmpMode = pParent.Mode || 'prefixed';
				return {
					ParentEntity: pParent.Entity,
					Mode: tmpMode,
					KeyColumn: pParent.KeyColumn,
					GUIDColumn: pParent.KeyColumn,
					IDColumn: pParent.KeyColumn,
					CrossSession: (pParent.CrossSession !== false),
				};
			}),
		};
	});
	return { Prefix: (pPrefix !== undefined) ? pPrefix : 'UI', Entities: tmpEntities };
}

/**
 * Preview the GUID a compose spec would produce for a sample row (simple `{~D:Record.X~}` resolution, no
 * fable needed) — used by the wizard panel to show a live example as the user configures the strategy.
 * @param {Record<string, any>} pComposeSpec @param {Record<string, any>} pSampleRow
 * @returns {string}
 */
function previewGUID(pComposeSpec, pSampleRow)
{
	if (!pComposeSpec || !Array.isArray(pComposeSpec.segments)) { return ''; }
	const tmpRow = pSampleRow || {};
	const tmpSegments = pComposeSpec.segments.map((pSegment) =>
	{
		// Resolve EVERY `{~D:Record.<col>~}` tag in the segment (a segment can now be multiple columns or a
		// typed template, not just one column) — a lightweight parseTemplate stand-in for the live preview.
		// Any non-tag literal text in the template is kept verbatim.
		const tmpValue = String(pSegment.valueTemplate || '').replace(/\{~D:Record\.([^~}]+)~\}/g, (pFull, pColumn) =>
		{
			const tmpCell = tmpRow[pColumn];
			return (tmpCell !== undefined && tmpCell !== null) ? String(tmpCell) : '';
		});
		return { abbrev: pSegment.abbrev, value: tmpValue };
	});
	return libEngine.composeGUID({ prefix: pComposeSpec.prefix, separator: pComposeSpec.separator, maxLength: pComposeSpec.maxLength, hashLength: pComposeSpec.hashLength, segments: tmpSegments });
}

/**
 * One-call preview for the wizard panel: build the config from the UI model, compile it, and preview the
 * given entity's OWN GUID on a sample row.
 * @returns {string}
 */
function previewEntityGUID(pUIEntities, pPrefix, pCatalog, pSchema, pEntityName, pSampleRow)
{
	const tmpConfig = buildStrategyConfig(pUIEntities, pPrefix);
	const tmpCompiled = libEngine.compileGUIDStrategy(tmpConfig, { Catalog: pCatalog || {}, SchemaSizes: schemaSizes(pSchema) });
	const tmpStrategy = tmpCompiled.Strategies[pEntityName];
	if (!tmpStrategy || !tmpStrategy.Own || !tmpStrategy.Own.Compose) { return ''; }
	return previewGUID(tmpStrategy.Own.Compose, pSampleRow);
}

module.exports = {
	applyStrategy,
	schemaSizes,
	buildStrategyConfig,
	previewGUID,
	previewEntityGUID,
};

},{"meadow-integration/source/Meadow-Integration-Engine.js":516}],578:[function(require,module,exports){
// DataImport-Session — the per-import-session state shape + (de)serialization helpers.
//
// One session lives at AppData.DataImport.Sessions[<wizardHash>] and is fully JSON-serializable: the
// live uploaded file handle is referenced indirectly (File.Ref), never embedded, so a StateStore can
// persist a partially-mapped session and reload it later. `Mapping` is the durable artifact;
// `Comprehension` is a recomputable cache (re-derivable from Mapping + re-parsed rows).

/** @return {number} A timestamp (plain module code — Date.now is fine here). */
const now = () => Date.now();

/**
 * Build a fresh import session.
 * @param {string} pSessionId @param {Record<string, any>} pConfig
 * @return {Record<string, any>}
 */
const newImportSession = (pSessionId, pConfig) =>
{
	const tmpConfig = pConfig || {};
	const tmpTimestamp = now();
	return {
		SessionId: pSessionId,
		Title: tmpConfig.Title || pSessionId,
		SchemaVersion: 1,
		CreatedAt: tmpTimestamp,
		UpdatedAt: tmpTimestamp,

		CurrentStep: 'upload',     // upload | detect | mapping | generate | push
		StepStatus: { upload: 'active', detect: 'pending', mapping: 'pending', generate: 'pending', push: 'pending' },

		// File REF (not the live handle/bytes): { Ref, Name, Size, Type, Kind, Stored, StorageRef }.
		File: null,

		ParseConfig:
		{
			Kind: null,            // csv | tsv | fixedwidth | xlsx
			Delimited: { Delimiter: ',', HasHeader: true },
			FixedWidth: { Columns: [], HasHeader: false },
			Xlsx: { HasHeader: true },
			SampleRowLimit: 25,
		},
		DetectedColumns: [],
		SampleRows: [],
		RawLines: [],              // fixed-width ruler source (when no column spec yet)
		RowCountEstimate: 0,

		Mapping:
		{
			TargetSchemaSource: tmpConfig.SchemaSource || 'meadow',
			Order: [],
			Entities: {},          // <entityName>: { Entity, GUIDName, GUIDTemplate, Mappings, Solvers, MultipleGUIDUniqueness, _ColumnBindings }
		},

		Comprehension: null,       // recomputable cache: { <Entity>: { <guid>: record } }
		GenerationReport: null,    // { ParsedRowCount, EntityCounts, BadRecords }

		Push:
		{
			Mode: tmpConfig.PushMode || 'entityprovider',
			Status: 'idle',        // idle | running | complete | error
			Progress: { Total: 0, Pushed: 0 },
			Result: null,
			Error: null,
		},
	};
};

/**
 * A JSON-safe snapshot for persistence. The Comprehension can be huge + is recomputable, so it is
 * dropped by default (pass pIncludeComprehension to keep it).
 * @param {Record<string, any>} pSession @param {boolean} [pIncludeComprehension]
 * @return {Record<string, any>}
 */
const serialize = (pSession, pIncludeComprehension) =>
{
	const tmpSnapshot = JSON.parse(JSON.stringify(pSession || {}));
	if (!pIncludeComprehension) { tmpSnapshot.Comprehension = null; }
	tmpSnapshot.UpdatedAt = now();
	return tmpSnapshot;
};

/**
 * Rebuild a session object from a snapshot (filling any new fields a newer SchemaVersion added).
 * @param {Record<string, any>} pSnapshot
 * @return {Record<string, any>}
 */
const hydrate = (pSnapshot) =>
{
	const tmpSnapshot = pSnapshot || {};
	const tmpBase = newImportSession(tmpSnapshot.SessionId || 'import', {});
	// Deep-merge the saved fields over the fresh base (saved values win; new base fields survive).
	return Object.assign(tmpBase, tmpSnapshot, {
		ParseConfig: Object.assign({}, tmpBase.ParseConfig, tmpSnapshot.ParseConfig),
		Mapping: Object.assign({}, tmpBase.Mapping, tmpSnapshot.Mapping),
		Push: Object.assign({}, tmpBase.Push, tmpSnapshot.Push),
	});
};

/** Mark a session's UpdatedAt. @param {Record<string, any>} pSession */
const touch = (pSession) => { if (pSession) { pSession.UpdatedAt = now(); } return pSession; };

module.exports = { newImportSession, serialize, hydrate, touch };

},{}],579:[function(require,module,exports){
const libPictView = require('pict-view');
const libSession = require('../services/DataImport-Session.js');
const libStrategyApply = require('../services/DataImport-GuidStrategyApply.js');

// Required sibling controls (peers). The wizard registers their providers if the host hasn't.
const libPictSectionAccordion = require('pict-section-accordion');
const libPictSectionUpload = require('pict-section-upload');

const _STEP_DEFS =
[
	{ Hash: 'upload', Title: 'Upload' },
	{ Hash: 'detect', Title: 'Validate' },
	{ Hash: 'mapping', Title: 'Map' },
	{ Hash: 'generate', Title: 'Generate' },
	{ Hash: 'push', Title: 'Push' },
];

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-Section-DataImport-Wizard',

	AutoInitialize: true,
	AutoRender: false,
	AutoSolveWithApp: false,

	DefaultRenderable: 'DI-Root',

	WizardHash: false,
	DestinationAddress: false,
	RenderMode: 'wizard',
	URLPrefix: '/1.0/',
	GUIDPrefix: 'INTG-DEF',
	EntityGUIDPrefix: '',
	AllowGUIDTruncation: false,
	AllowedFileTypes: [ 'csv', 'tsv', 'xlsx', 'fixedwidth' ],
	SchemaSource: 'meadow',
	PushMode: 'entityprovider',
	// A host can ship a starting mapping (entities + GUID templates + fan-out solvers); the UI edits it.
	DefaultMapping: null,
	// Resolved seams (injected by the provider's createImportWizard):
	ResolvedParsers: null,
	ResolvedSchemaProvider: null,
	ResolvedPushTarget: null,
	ResolvedStateStore: null,
	ComprehensionBuilder: null,
	// Callbacks:
	OnStepChange: false, OnSchemaLoaded: false, OnComprehension: false, OnPushComplete: false, OnError: false,
	// Allow a JSON download of the generated comprehension (handy when there's no server to push to).
	AllowDownload: true,

	Templates:
	[
		{ Hash: 'DI-Root', Template: /*html*/`<div class="psd" id="DI_{~D:Record.WizardHash~}"><div id="DI_Acc_{~D:Record.WizardHash~}"></div></div>` },

		{
			Hash: 'DI-Body-Upload',
			Template: /*html*/`<div class="psd-step"><p class="psd-hint">Upload a CSV, TSV, Excel, or fixed-width file. Its bytes are read in your browser for the next steps.</p><div id="DI_Upload_{~D:Record.WizardHash~}"></div></div>`
		},

		{
			Hash: 'DI-Body-Detect',
			Template: /*html*/`
<div class="psd-step">
	<div class="psd-options">
		<div class="psd-field"><label>Format</label>
			<select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setParseKind(this.value)">{~TS:DI-Opt:Record.KindOptions~}</select></div>
		{~TS:DI-Detect-Delimited:Record.DelimitedSlot~}
	</div>
	{~TS:DI-Detect-Ruler:Record.RulerSlot~}
	<p class="psd-section-title">Detected columns <span class="psd-type">({~D:Record.ColumnCount~} columns · ~{~D:Record.RowCountEstimate~} rows)</span></p>
	<div class="psd-table-wrap"><table class="psd-table"><thead><tr>{~TS:DI-Col-Head:Record.SampleHeader~}</tr></thead><tbody>{~TS:DI-Sample-Row:Record.SampleRows~}</tbody></table></div>
</div>`
		},
		{ Hash: 'DI-Opt', Template: /*html*/`<option value="{~D:Record.Value~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>` },
		{
			Hash: 'DI-Detect-Delimited',
			Template: /*html*/`<div class="psd-field"><label>Delimiter</label><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setDelimiter(this.value)">{~TS:DI-Opt:Record.DelimiterOptions~}</select></div><div class="psd-field"><label><input type="checkbox"{~NE:Record.HasHeader^ checked~} onchange="_Pict.views['{~D:Record.WizardHash~}'].setHasHeader(this.checked)" /> First row is a header</label></div>` },
		{ Hash: 'DI-Detect-Ruler', Template: /*html*/`<div><p class="psd-hint">Fixed-width: enter column boundaries as JSON (Name/Start/End), then re-detect.</p><div class="psd-ruler">{~D:Record.Ruler~}</div><textarea class="psd-textarea" id="DI_FW_{~D:Record.WizardHash~}" placeholder='[{"Name":"code","Start":0,"End":3}]'>{~D:Record.ColumnsJSON~}</textarea><div class="psd-row-actions"><button type="button" class="psd-btn psd-btn-ghost" onclick="_Pict.views['{~D:Record.WizardHash~}'].applyFixedWidthColumns()">Apply boundaries</button></div></div>` },
		{ Hash: 'DI-Col-Head', Template: /*html*/`<th>{~D:Record.SourceName~}<div class="psd-type">{~D:Record.InferredType~}</div></th>` },
		{ Hash: 'DI-Sample-Row', Template: /*html*/`<tr>{~TS:DI-Sample-Cell:Record.Cells~}</tr>` },
		{ Hash: 'DI-Sample-Cell', Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>` },

		{
			Hash: 'DI-Body-Mapping',
			Template: /*html*/`
<div class="psd-step">
	<p class="psd-hint">Map each target field to a source column. Foreign-key + fan-out rules come from the starting mapping (edit the raw JSON for advanced control).</p>
	{~TS:DI-Map-Entity:Record.Entities~}
	<details class="psd-raw"><summary class="psd-hint">Advanced — raw mapping JSON</summary><textarea class="psd-textarea" id="DI_RawMap_{~D:Record.WizardHash~}">{~D:Record.RawJSON~}</textarea><div class="psd-row-actions"><button type="button" class="psd-btn psd-btn-ghost" onclick="_Pict.views['{~D:Record.WizardHash~}'].applyRawMapping()">Apply raw mapping</button></div></details>
</div>`
		},
		{
			Hash: 'DI-Map-Entity',
			Template: /*html*/`
<div class="psd-entity">
	<div class="psd-entity-head"><span class="psd-entity-name">{~D:Record.Entity~}</span>{~TS:DI-Map-GUID-Legacy:Record.LegacyGUIDSlot~}</div>
	{~TS:DI-GUID-Panel:Record.StrategySlot~}
	{~TS:DI-Map-Row:Record.Fields~}
</div>`
		},
		{ Hash: 'DI-Map-GUID-Legacy', Template: /*html*/`<span class="psd-entity-count">GUID: <span class="psd-mono">{~D:Record.GUIDTemplate~}</span></span>` },
		{
			Hash: 'DI-GUID-Panel',
			Template: /*html*/`
<div class="psd-guid">
	<div class="psd-guid-line"><span class="psd-guid-label">Identifier</span><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setStrategyMode('{~D:Record.Entity~}',this.value)">{~TS:DI-Opt:Record.ModeOptions~}</select>{~TS:DI-GUID-Own:Record.OwnKeySlot~}</div>
	{~TS:DI-GUID-Parent:Record.Parents~}
	{~TS:DI-GUID-AddParent:Record.AddParentSlot~}
	{~TS:DI-GUID-Preview:Record.PreviewSlot~}
	{~TS:DI-GUID-Warn:Record.Warnings~}
</div>`
		},
		{ Hash: 'DI-GUID-Own', Template: /*html*/`<span class="psd-guid-sub">keyed by</span>{~TS:DI-GUID-OwnCol:Record.ColumnItems~}{~TS:DI-GUID-OwnAdd:Record.AddColumnSlot~}{~TS:DI-GUID-OwnTpl:Record.TemplateSlot~}<button type="button" class="psd-btn psd-btn-ghost psd-guid-own-fx" onclick="_Pict.views['{~D:Record.WizardHash~}'].toggleStrategyOwnMode('{~D:Record.Entity~}')" title="Switch between columns and a typed template">{~D:Record.ToggleLabel~}</button>` },
		{ Hash: 'DI-GUID-OwnCol', Template: /*html*/`<span class="psd-guid-owncol"><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setStrategyOwnKeyAt('{~D:Record.Entity~}',{~D:Record.Index~},this.value)">{~TS:DI-Opt:Record.Options~}</select>{~TS:DI-GUID-OwnColRm:Record.RemoveSlot~}</span>` },
		{ Hash: 'DI-GUID-OwnColRm', Template: /*html*/`<button type="button" class="psd-btn psd-btn-ghost psd-guid-rm" onclick="_Pict.views['{~D:Record.WizardHash~}'].removeStrategyOwnKey('{~D:Record.Entity~}',{~D:Record.Index~})" title="Remove column">&times;</button>` },
		{ Hash: 'DI-GUID-OwnAdd', Template: /*html*/`<select class="psd-select psd-guid-owadd" onchange="if(this.value){_Pict.views['{~D:Record.WizardHash~}'].addStrategyOwnKey('{~D:Record.Entity~}',this.value);this.value='';}">{~TS:DI-Opt:Record.Options~}</select>` },
		{ Hash: 'DI-GUID-OwnTpl', Template: /*html*/`<input type="text" class="psd-input psd-guid-tpl" placeholder="{~D:Record.Placeholder~}" value="{~D:Record.Template~}" onchange="_Pict.views['{~D:Record.WizardHash~}'].setStrategyOwnKeyTemplate('{~D:Record.Entity~}',this.value)" />` },
		{
			Hash: 'DI-GUID-Parent',
			Template: /*html*/`<div class="psd-guid-parent"><span class="psd-guid-sub">related to</span><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setParentEntity('{~D:Record.Entity~}',{~D:Record.Index~},this.value)">{~TS:DI-Opt:Record.EntityOptions~}</select><span class="psd-guid-sub">via</span><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setParentKey('{~D:Record.Entity~}',{~D:Record.Index~},this.value)">{~TS:DI-Opt:Record.KeyOptions~}</select><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setParentMode('{~D:Record.Entity~}',{~D:Record.Index~},this.value)">{~TS:DI-Opt:Record.ModeOptions~}</select><button type="button" class="psd-btn psd-btn-ghost psd-guid-rm" onclick="_Pict.views['{~D:Record.WizardHash~}'].removeStrategyParent('{~D:Record.Entity~}',{~D:Record.Index~})" title="Remove">&times;</button></div>`
		},
		{ Hash: 'DI-GUID-AddParent', Template: /*html*/`<div class="psd-guid-add"><select class="psd-select" onchange="if(this.value){_Pict.views['{~D:Record.WizardHash~}'].addStrategyParent('{~D:Record.Entity~}',this.value);this.value='';}">{~TS:DI-Opt:Record.Options~}</select></div>` },
		{ Hash: 'DI-GUID-Preview', Template: /*html*/`<div class="psd-guid-preview">Example: <span class="psd-mono">{~D:Record.Preview~}</span></div>` },
		{ Hash: 'DI-GUID-Warn', Template: /*html*/`<div class="psd-guid-warn">{~I:Warning~} <span>{~D:Record.Message~}</span></div>` },
		{
			Hash: 'DI-Map-Row',
			Template: /*html*/`<div class="psd-map-row"><span class="psd-map-field">{~D:Record.Name~}{~NE:Record.Required^ <span class="psd-map-required">*</span>~}</span><select class="psd-select" onchange="_Pict.views['{~D:Record.WizardHash~}'].setMappingBinding('{~D:Record.Entity~}','{~D:Record.Name~}',this.value)">{~TS:DI-Opt:Record.Options~}</select></div>`
		},

		{
			Hash: 'DI-Body-Generate',
			Template: /*html*/`
<div class="psd-step">
	<div class="psd-row-actions"><button type="button" class="psd-btn" onclick="_Pict.views['{~D:Record.WizardHash~}'].generate()">Generate comprehension</button>{~TS:DI-Download:Record.DownloadSlot~}</div>
	{~TS:DI-Warnings:Record.Warnings~}
	{~TS:DI-Gen-Report:Record.ReportSlot~}
</div>`
		},
		{ Hash: 'DI-Download', Template: /*html*/`<button type="button" class="psd-btn psd-btn-ghost" onclick="_Pict.views['{~D:Record.WizardHash~}'].downloadComprehension()">Download JSON</button>` },
		{ Hash: 'DI-Warnings', Template: /*html*/`<div class="psd-banner psd-banner-warn">{~I:Warning~} <span>{~D:Record.Message~}</span></div>` },
		{
			Hash: 'DI-Gen-Report',
			Template: /*html*/`<div><div class="psd-banner psd-banner-ok">{~I:Check~} <span>Generated {~D:Record.ParsedRowCount~} rows into {~D:Record.EntityTotal~} record(s).</span></div><div class="psd-report">{~TS:DI-Count-Chip:Record.EntityCounts~}</div>{~TS:DI-Preview:Record.PreviewSlot~}</div>` },
		{ Hash: 'DI-Count-Chip', Template: /*html*/`<span class="psd-chip"><strong>{~D:Record.Count~}</strong> {~D:Record.Entity~}</span>` },
		{ Hash: 'DI-Preview', Template: /*html*/`<div><p class="psd-section-title">Preview <span class="psd-type">({~D:Record.Entity~}, first {~D:Record.ShownCount~})</span></p><div class="psd-table-wrap"><table class="psd-table"><thead><tr>{~TS:DI-Col-Head2:Record.Header~}</tr></thead><tbody>{~TS:DI-Sample-Row:Record.Rows~}</tbody></table></div></div>` },
		{ Hash: 'DI-Col-Head2', Template: /*html*/`<th>{~D:Record.Name~}</th>` },

		{
			Hash: 'DI-Body-Push',
			Template: /*html*/`
<div class="psd-step">
	<p class="psd-hint">Push mode: <span class="psd-mono">{~D:Record.Mode~}</span></p>
	<div class="psd-row-actions"><button type="button" class="psd-btn" onclick="_Pict.views['{~D:Record.WizardHash~}'].push()"{~NE:Record.PushDisabled^ disabled~}>{~D:Record.PushLabel~}</button></div>
	{~TS:DI-Push-Progress:Record.ProgressSlot~}
	{~TS:DI-Push-Result:Record.ResultSlot~}
	{~TS:DI-Push-Error:Record.ErrorSlot~}
</div>`
		},
		{ Hash: 'DI-Push-Progress', Template: /*html*/`<div class="psd-progress"><div class="psd-progress-fill" style="width: {~D:Record.Pct~}%;"></div></div>` },
		{ Hash: 'DI-Push-Result', Template: /*html*/`<div class="psd-banner psd-banner-ok">{~I:Check~} <span>{~D:Record.Message~}</span></div>` },
		{ Hash: 'DI-Push-Error', Template: /*html*/`<div class="psd-banner psd-banner-error">{~I:Error~} <span>{~D:Record.Message~}</span></div>` },
	],

	Renderables:
	[
		{ RenderableHash: 'DI-Root', TemplateHash: 'DI-Root', RenderMethod: 'replace' },
	],
};

class PictViewDataImportWizard extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.options.DefaultDestinationAddress = this.options.DestinationAddress || `#${this.options.WizardHash}`;
		this._StateAddress = `AppData.DataImport.Sessions.${this.options.WizardHash}`;
		this.options.DefaultTemplateRecordAddress = `AppData.DataImport._WizardConfig.${this.options.WizardHash}`;
		if (Array.isArray(this.options.Renderables) && this.options.Renderables[0])
		{
			this.options.Renderables[0].ContentDestinationAddress = this.options.DefaultDestinationAddress;
		}

		this._accHash = `${this.options.WizardHash}-Accordion`;
		this._uploadHash = `${this.options.WizardHash}-Upload`;
		this._accordion = null;
		this._uploadView = null;
		this._fileHandle = null;     // the live upload handle (off AppData)
		this._parsedRows = null;     // cache of parsed rows
		this._schema = null;         // resolved target schema
		this._wired = false;

		// The render record for DI-Root just needs WizardHash.
		this.pict.AppData.DataImport = this.pict.AppData.DataImport || {};
		this.pict.AppData.DataImport._WizardConfig = this.pict.AppData.DataImport._WizardConfig || {};
		this.pict.AppData.DataImport._WizardConfig[this.options.WizardHash] = { WizardHash: this.options.WizardHash };

		this._ensureProviders();
		this._session();   // seed the session
	}

	/** Register the sibling providers if the host hasn't already. */
	_ensureProviders()
	{
		if (!this.pict.providers['Pict-Section-Accordion'])
		{
			this.pict.addProvider('Pict-Section-Accordion', libPictSectionAccordion.default_configuration, libPictSectionAccordion);
		}
		if (!this.pict.providers['Pict-Section-Upload'])
		{
			this.pict.addProvider('Pict-Section-Upload', libPictSectionUpload.default_configuration, libPictSectionUpload);
		}
	}

	/** @return {Record<string, any>} The session state slot (created on first access). */
	_session()
	{
		this.pict.AppData.DataImport = this.pict.AppData.DataImport || {};
		this.pict.AppData.DataImport.Sessions = this.pict.AppData.DataImport.Sessions || {};
		if (!this.pict.AppData.DataImport.Sessions[this.options.WizardHash])
		{
			const tmpSession = libSession.newImportSession(this.options.WizardHash, { Title: this.options.Title, SchemaSource: this.options.SchemaSource, PushMode: this.options.PushMode });
			if (this.options.DefaultMapping) { tmpSession.Mapping = JSON.parse(JSON.stringify(this.options.DefaultMapping)); tmpSession.Mapping.TargetSchemaSource = this.options.SchemaSource; }
			this.pict.AppData.DataImport.Sessions[this.options.WizardHash] = tmpSession;
		}
		return this.pict.AppData.DataImport.Sessions[this.options.WizardHash];
	}

	onAfterRender(pRenderable)
	{
		if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		// Build the accordion + step bodies on first render, and REBUILD whenever a host re-render has wiped
		// our mount. When the wizard is embedded in a routed host that repaints its container (on navigation,
		// or after a push), the DI-Root template recreates an EMPTY `#DI_Acc_<WizardHash>` while `_wired` stays
		// true — which would otherwise leave a bare accordion shell. createAccordion / createUploader are keyed
		// by hash (reconfigure-or-create) and the accordion keeps its serializable nav state, so the rebuild
		// restores the current step + the host's step bodies without losing progress.
		if (!this._wired || !this._accordionMounted())
		{
			this._wired = true;
			this._buildWizard();
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Is the accordion currently rendered into its mount, or has a host re-render wiped it? The DI-Root
	 * template recreates an empty `#DI_Acc_<WizardHash>` on every paint, so an empty mount means the
	 * accordion (and its step bodies) need (re)building.
	 * @return {boolean}
	 */
	_accordionMounted()
	{
		// No DOM to inspect (server-side render) — defer to the `_wired` one-time gate.
		if (typeof document === 'undefined') { return true; }
		const tmpElement = document.getElementById(`DI_Acc_${this.options.WizardHash}`);
		return !!(tmpElement && tmpElement.children && (tmpElement.children.length > 0));
	}

	/** Create the accordion + upload view and render all step bodies; safe to re-run (idempotent rebuild). */
	_buildWizard()
	{
		const tmpAccordionProvider = this.pict.providers['Pict-Section-Accordion'];
		const tmpSteps = _STEP_DEFS.map((pStep) => Object.assign({}, pStep, { CanAdvance: () => this._canAdvance(pStep.Hash) }));
		this._accordion = tmpAccordionProvider.createAccordion(this._accHash,
			{
				DestinationAddress: `#DI_Acc_${this.options.WizardHash}`,
				RenderMode: this.options.RenderMode,
				Steps: tmpSteps,
				OnStepChange: (pTo) => this._onEnterStep(pTo && pTo.Hash),
				OnComplete: () => { /* last step (push) Next: no-op; push is an explicit button */ },
			});
		this.pict.views[this._accHash].render();

		// Render each step's body into its accordion container.
		_STEP_DEFS.forEach((pStep) => this._renderStepBody(pStep.Hash));

		// Create the upload control into the upload step body.
		this._createUploader();
	}

	/** @return {boolean} Per-step Next gate. */
	_canAdvance(pStepHash)
	{
		const tmpSession = this._session();
		switch (pStepHash)
		{
			case 'upload': return !!tmpSession.File;
			case 'detect': return Array.isArray(tmpSession.DetectedColumns) && tmpSession.DetectedColumns.length > 0;
			case 'mapping': return !!(tmpSession.Mapping && tmpSession.Mapping.Order && tmpSession.Mapping.Order.length > 0);
			case 'generate': return !!tmpSession.Comprehension;
			default: return true;
		}
	}

	/** Step-entry side effects: parse on entering detect, load schema on entering mapping. */
	_onEnterStep(pStepHash)
	{
		if (typeof this.options.OnStepChange === 'function') { try { this.options.OnStepChange(pStepHash); } catch (pError) { /* host callback */ } }
		if (pStepHash === 'detect') { this._runDetect(); }
		else if (pStepHash === 'mapping') { this._loadSchemaAndMapping(); }
		else if (pStepHash === 'generate') { this._renderStepBody('generate'); }
		else if (pStepHash === 'push') { this._renderStepBody('push'); }
	}

	_createUploader()
	{
		const tmpUploadProvider = this.pict.providers['Pict-Section-Upload'];
		const tmpAccept = this._acceptString();
		tmpUploadProvider.createUploader(this._uploadHash,
			{
				DestinationAddress: `#DI_Upload_${this.options.WizardHash}`,
				Accept: tmpAccept,
				DropLabel: 'Drop your data file here, or',
				OnComplete: (pHandle) => this._onFileReady(pHandle),
				OnRemove: () => { this._fileHandle = null; this._parsedRows = null; this._session().File = null; this._refreshAccordionChrome(); },
			});
		this._uploadView = this.pict.views[this._uploadHash];
		this._uploadView.render();
	}

	/** @return {string} The accept filter derived from AllowedFileTypes. */
	_acceptString()
	{
		const tmpMap = { csv: '.csv,text/csv', tsv: '.tsv,.tab', xlsx: '.xlsx,.xls', fixedwidth: '.txt,.dat,.fw' };
		return (this.options.AllowedFileTypes || []).map((pKind) => tmpMap[pKind] || '').filter(Boolean).join(',');
	}

	_onFileReady(pHandle)
	{
		this._fileHandle = pHandle;
		this._parsedRows = null;
		const tmpKind = this._inferKind(pHandle);
		const tmpSession = this._session();
		tmpSession.File = { Ref: `upload:${this._uploadHash}:${pHandle.Hash}`, Name: pHandle.Name, Size: pHandle.Size, Type: pHandle.Type, Kind: tmpKind, Stored: false, StorageRef: null };
		tmpSession.ParseConfig.Kind = tmpKind;
		tmpSession.StepStatus.upload = 'complete';
		if (this._accordion) { this._accordion.setStepComplete('upload', true); }
		this._persist();
	}

	/** @return {string} Infer the parser kind from the file name/type. */
	_inferKind(pHandle)
	{
		const tmpName = (pHandle.Name || '').toLowerCase();
		const tmpType = (pHandle.Type || '').toLowerCase();
		if (/\.(xlsx|xls)$/.test(tmpName) || tmpType.indexOf('spreadsheet') >= 0 || tmpType.indexOf('excel') >= 0) { return 'xlsx'; }
		if (/\.(tsv|tab)$/.test(tmpName) || tmpType.indexOf('tab-separated') >= 0) { return 'tsv'; }
		if (/\.(fw|dat)$/.test(tmpName)) { return 'fixedwidth'; }
		return 'csv';
	}

	/** @return {any} The active parser for the session's file kind. */
	_activeParser()
	{
		const tmpKind = this._session().ParseConfig.Kind || 'csv';
		const tmpParsers = this.options.ResolvedParsers || {};
		return tmpParsers[tmpKind] || tmpParsers.csv;
	}

	// --- Step 2: detect ---

	_runDetect()
	{
		const tmpParser = this._activeParser();
		const tmpSession = this._session();
		if (!this._fileHandle || !tmpParser) { this._renderStepBody('detect'); return; }
		tmpParser.detect(this._fileHandle, tmpSession.ParseConfig).then((pDetection) =>
		{
			tmpSession.DetectedColumns = pDetection.Columns || [];
			tmpSession.SampleRows = pDetection.SampleRows || [];
			tmpSession.RowCountEstimate = pDetection.RowCountEstimate || 0;
			tmpSession.RawLines = pDetection.RawLines || [];
			tmpSession.StepStatus.detect = (tmpSession.DetectedColumns.length > 0) ? 'complete' : 'active';
			this._parsedRows = null;
			this._persist();
			this._renderStepBody('detect');
			this._refreshAccordionChrome();
		}).catch((pError) => { this._reportError(pError); });
	}

	setParseKind(pKind) { this._session().ParseConfig.Kind = pKind; this._runDetect(); }
	setDelimiter(pValue) { this._session().ParseConfig.Delimited.Delimiter = (pValue === 'tab') ? '\t' : pValue; this._runDetect(); }
	setHasHeader(pChecked) { this._session().ParseConfig.Delimited.HasHeader = !!pChecked; this._runDetect(); }
	applyFixedWidthColumns()
	{
		const tmpElement = (typeof document !== 'undefined') ? document.getElementById(`DI_FW_${this.options.WizardHash}`) : null;
		if (!tmpElement) { return; }
		try { this._session().ParseConfig.FixedWidth.Columns = JSON.parse(tmpElement.value || '[]'); this._runDetect(); }
		catch (pError) { this._reportError(new Error('Fixed-width columns must be valid JSON.')); }
	}

	_detectRenderState()
	{
		const tmpSession = this._session();
		const tmpKind = tmpSession.ParseConfig.Kind || 'csv';
		const tmpKindOptions = [ 'csv', 'tsv', 'xlsx', 'fixedwidth' ].map((pK) => ({ Value: pK, Label: pK.toUpperCase(), Selected: (pK === tmpKind) }));
		const tmpHeader = (tmpSession.DetectedColumns || []).map((pColumn) => ({ SourceName: pColumn.SourceName, InferredType: pColumn.InferredType }));
		const tmpSampleRows = (tmpSession.SampleRows || []).slice(0, 12).map((pRow) =>
			({ Cells: (tmpSession.DetectedColumns || []).map((pColumn) => ({ Value: pRow[pColumn.SourceName] })) }));
		const tmpIsDelimited = (tmpKind === 'csv' || tmpKind === 'tsv');
		const tmpIsFixed = (tmpKind === 'fixedwidth');
		return {
			WizardHash: this.options.WizardHash,
			KindOptions: tmpKindOptions,
			DelimitedSlot: tmpIsDelimited ? [ {
				WizardHash: this.options.WizardHash,
				HasHeader: (tmpSession.ParseConfig.Delimited.HasHeader !== false),
				DelimiterOptions: [ { Value: ',', Label: 'Comma', Selected: tmpSession.ParseConfig.Delimited.Delimiter === ',' }, { Value: 'tab', Label: 'Tab', Selected: tmpSession.ParseConfig.Delimited.Delimiter === '\t' }, { Value: ';', Label: 'Semicolon', Selected: tmpSession.ParseConfig.Delimited.Delimiter === ';' }, { Value: '|', Label: 'Pipe', Selected: tmpSession.ParseConfig.Delimited.Delimiter === '|' } ],
			} ] : [],
			RulerSlot: tmpIsFixed ? [ { WizardHash: this.options.WizardHash, Ruler: this._buildRuler(tmpSession.RawLines), ColumnsJSON: JSON.stringify(tmpSession.ParseConfig.FixedWidth.Columns || []) } ] : [],
			ColumnCount: (tmpSession.DetectedColumns || []).length,
			RowCountEstimate: tmpSession.RowCountEstimate || 0,
			SampleHeader: tmpHeader,
			SampleRows: tmpSampleRows,
		};
	}

	_buildRuler(pLines)
	{
		const tmpLines = Array.isArray(pLines) ? pLines.slice(0, 8) : [];
		if (tmpLines.length === 0) { return ''; }
		const tmpWidth = Math.max.apply(null, tmpLines.map((pLine) => pLine.length).concat([ 0 ]));
		let tmpRuler = '';
		for (let i = 0; i < tmpWidth; i++) { tmpRuler += (i % 10 === 0) ? String((i / 10) % 10) : ((i % 5 === 0) ? '+' : '.'); }
		return tmpRuler + '\n' + tmpLines.join('\n');
	}

	// --- Step 3: mapping ---

	_loadSchemaAndMapping()
	{
		const tmpSession = this._session();
		const tmpProvider = this.options.ResolvedSchemaProvider;
		if (!tmpProvider) { this._renderStepBody('mapping'); return; }
		Promise.resolve(tmpProvider.getSchema({ URLPrefix: this.options.URLPrefix })).then((pSchema) =>
		{
			this._schema = pSchema || { Entities: [], Order: [] };
			if (typeof this.options.OnSchemaLoaded === 'function') { try { this.options.OnSchemaLoaded(this._schema); } catch (pError) { /* host */ } }
			// Seed the mapping from the schema if the host gave no default mapping yet.
			if (!tmpSession.Mapping.Order || tmpSession.Mapping.Order.length === 0) { tmpSession.Mapping = this._autoBuildMapping(this._schema); }
			this._seedStrategyUI();
			this._applyGUIDStrategy();
			this._persist();
			this._renderStepBody('mapping');
			this._refreshAccordionChrome();
		}).catch((pError) => { this._reportError(pError); });
	}

	/** Is the context-aware GUID strategy panel + composition enabled for this wizard? */
	_strategyActive()
	{
		return !!this.options.GUIDStrategy;
	}

	/** Seed the editable per-entity GUID strategy UI model (host default, else prefixed + first column). */
	_seedStrategyUI()
	{
		if (!this._strategyActive()) { return; }
		const tmpSession = this._session();
		tmpSession.GUIDStrategyUI = tmpSession.GUIDStrategyUI || {};
		const tmpDefaults = this.options.GUIDStrategyDefault || {};
		const tmpFirstColumn = ((tmpSession.DetectedColumns || [])[0] || {}).SourceName || '';
		(tmpSession.Mapping.Order || []).forEach((pEntityName) =>
		{
			if (!tmpSession.GUIDStrategyUI[pEntityName])
			{
				tmpSession.GUIDStrategyUI[pEntityName] = tmpDefaults[pEntityName]
					? JSON.parse(JSON.stringify(tmpDefaults[pEntityName]))
					: { Mode: 'prefixed', OwnKeyColumn: tmpFirstColumn, OwnKeyColumns: tmpFirstColumn ? [ tmpFirstColumn ] : [], OwnKeyMode: 'columns', OwnKeyTemplate: '', Parents: [] };
			}
		});
	}

	/**
	 * Compile the editable GUID strategy UI model (meadow-integration) against the schema's GUID column
	 * sizes + attach it to each entity mapping. The transform then composes stable, length-safe GUIDs +
	 * foreign-key fields instead of the flat GUIDTemplate.
	 */
	_applyGUIDStrategy()
	{
		if (!this._strategyActive()) { return; }
		const tmpSession = this._session();
		const tmpConfig = libStrategyApply.buildStrategyConfig(tmpSession.GUIDStrategyUI || {}, this.options.GUIDStrategyPrefix || 'UI');
		const tmpResult = libStrategyApply.applyStrategy(tmpSession.Mapping, tmpConfig, this.options.ContextEntityCatalog, this._schema);
		this._strategyWarnings = tmpResult.Warnings || [];
	}

	/** Mutable per-entity UI model accessor (creates a default if absent). */
	_strategyUIEntity(pEntity)
	{
		const tmpSession = this._session();
		tmpSession.GUIDStrategyUI = tmpSession.GUIDStrategyUI || {};
		if (!tmpSession.GUIDStrategyUI[pEntity]) { tmpSession.GUIDStrategyUI[pEntity] = { Mode: 'prefixed', OwnKeyColumn: '', OwnKeyColumns: [], OwnKeyMode: 'columns', OwnKeyTemplate: '', Parents: [] }; }
		return tmpSession.GUIDStrategyUI[pEntity];
	}

	/** Recompile + re-render after any strategy panel edit. */
	_afterStrategyEdit()
	{
		this._applyGUIDStrategy();
		this._persist();
		this._renderStepBody('mapping');
	}

	setStrategyMode(pEntity, pMode) { this._strategyUIEntity(pEntity).Mode = pMode; this._afterStrategyEdit(); }

	// Combinatorial own key (#1): the entity's GUID can be keyed by ONE column, SEVERAL columns concatenated,
	// or a user-typed pict template. OwnKeyColumns is the column list; OwnKeyTemplate (template mode) wins in
	// the engine's ownValueTemplate(). OwnKeyColumn is kept in sync for backward compatibility.
	/** The own-key column list (migrating a legacy single OwnKeyColumn on first access). */
	_ownColumns(pEntity)
	{
		const tmpEntity = this._strategyUIEntity(pEntity);
		if (!Array.isArray(tmpEntity.OwnKeyColumns))
		{
			tmpEntity.OwnKeyColumns = tmpEntity.OwnKeyColumn ? [ tmpEntity.OwnKeyColumn ] : [];
		}
		return tmpEntity.OwnKeyColumns;
	}
	_syncOwnSingle(pEntity) { const tmpEntity = this._strategyUIEntity(pEntity); tmpEntity.OwnKeyColumn = this._ownColumns(pEntity)[0] || ''; }
	setStrategyOwnKey(pEntity, pColumn) { const tmpEntity = this._strategyUIEntity(pEntity); tmpEntity.OwnKeyColumns = pColumn ? [ pColumn ] : []; tmpEntity.OwnKeyColumn = pColumn; this._afterStrategyEdit(); }
	setStrategyOwnKeyAt(pEntity, pIndex, pColumn)
	{
		const tmpColumns = this._ownColumns(pEntity);
		if (pColumn) { tmpColumns[Number(pIndex)] = pColumn; } else { tmpColumns.splice(Number(pIndex), 1); }
		this._syncOwnSingle(pEntity); this._afterStrategyEdit();
	}
	addStrategyOwnKey(pEntity, pColumn) { this._ownColumns(pEntity).push(pColumn); this._syncOwnSingle(pEntity); this._afterStrategyEdit(); }
	removeStrategyOwnKey(pEntity, pIndex) { this._ownColumns(pEntity).splice(Number(pIndex), 1); this._syncOwnSingle(pEntity); this._afterStrategyEdit(); }
	setStrategyOwnKeyTemplate(pEntity, pTemplate) { this._strategyUIEntity(pEntity).OwnKeyTemplate = pTemplate; this._afterStrategyEdit(); }
	toggleStrategyOwnMode(pEntity)
	{
		const tmpEntity = this._strategyUIEntity(pEntity);
		if (tmpEntity.OwnKeyMode === 'template')
		{
			tmpEntity.OwnKeyMode = 'columns';
			tmpEntity.OwnKeyTemplate = '';   // columns win once template is cleared
		}
		else
		{
			tmpEntity.OwnKeyMode = 'template';
			if (!tmpEntity.OwnKeyTemplate)
			{
				tmpEntity.OwnKeyTemplate = this._ownColumns(pEntity).map((pColumn) => `{~D:Record.${pColumn}~}`).join('');
			}
		}
		this._afterStrategyEdit();
	}
	addStrategyParent(pEntity, pParentEntity)
	{
		const tmpEntity = this._strategyUIEntity(pEntity);
		tmpEntity.Parents = tmpEntity.Parents || [];
		tmpEntity.Parents.push({ Entity: pParentEntity, KeyColumn: '', Mode: 'prefixed', CrossSession: true });
		this._afterStrategyEdit();
	}
	removeStrategyParent(pEntity, pIndex) { const tmpEntity = this._strategyUIEntity(pEntity); if (tmpEntity.Parents) { tmpEntity.Parents.splice(Number(pIndex), 1); } this._afterStrategyEdit(); }
	setParentEntity(pEntity, pIndex, pParentEntity) { const tmpParent = (this._strategyUIEntity(pEntity).Parents || [])[Number(pIndex)]; if (tmpParent) { tmpParent.Entity = pParentEntity; } this._afterStrategyEdit(); }
	setParentKey(pEntity, pIndex, pColumn) { const tmpParent = (this._strategyUIEntity(pEntity).Parents || [])[Number(pIndex)]; if (tmpParent) { tmpParent.KeyColumn = pColumn; } this._afterStrategyEdit(); }
	setParentMode(pEntity, pIndex, pMode) { const tmpParent = (this._strategyUIEntity(pEntity).Parents || [])[Number(pIndex)]; if (tmpParent) { tmpParent.Mode = pMode; } this._afterStrategyEdit(); }

	/** Build the strategy-panel render data for one entity (mode + own-key + parents + live preview). */
	_strategyEntityState(pEntityName, pSourceNames)
	{
		const tmpSession = this._session();
		const tmpUI = (tmpSession.GUIDStrategyUI || {})[pEntityName] || { Mode: 'prefixed', OwnKeyColumn: '', Parents: [] };
		const tmpCatalog = this.options.ContextEntityCatalog || {};
		const tmpCatalogEntities = Object.keys(tmpCatalog);
		const tmpModeOptions = (pSelected) => [ { Value: 'prefixed', Label: 'Prefixed (auto)', Selected: pSelected === 'prefixed' }, { Value: 'raw', Label: 'Raw GUID', Selected: pSelected === 'raw' }, { Value: 'rawid', Label: 'Raw ID', Selected: pSelected === 'rawid' } ];
		const tmpColumnOptions = (pSelected) => [ { Value: '', Label: '(column)', Selected: !pSelected } ].concat(pSourceNames.map((pName) => ({ Value: pName, Label: pName, Selected: pName === pSelected })));

		// Own-key slot: only prefixed mode composes its own GUID. It can be one column, several columns
		// (concatenated), or a typed template — see #1 combinatorial GUID.
		let tmpOwnKeySlot = [];
		if ((tmpUI.Mode || 'prefixed') === 'prefixed')
		{
			const tmpIsTemplate = (tmpUI.OwnKeyMode === 'template');
			const tmpOwnCols = Array.isArray(tmpUI.OwnKeyColumns) ? tmpUI.OwnKeyColumns : (tmpUI.OwnKeyColumn ? [ tmpUI.OwnKeyColumn ] : []);
			const tmpColumnItems = tmpIsTemplate ? [] : tmpOwnCols.map((pColumn, pIndex) => (
				{
					WizardHash: this.options.WizardHash, Entity: pEntityName, Index: pIndex,
					Options: tmpColumnOptions(pColumn),
					RemoveSlot: (tmpOwnCols.length > 1) ? [ { WizardHash: this.options.WizardHash, Entity: pEntityName, Index: pIndex } ] : [],
				}));
			const tmpUsedOwn = {};
			tmpOwnCols.forEach((pColumn) => { if (pColumn) { tmpUsedOwn[pColumn] = true; } });
			const tmpAddOwnOptions = [ { Value: '', Label: '+ column', Selected: true } ].concat(pSourceNames.filter((pName) => !tmpUsedOwn[pName]).map((pName) => ({ Value: pName, Label: pName, Selected: false })));
			const tmpAddColumnSlot = (!tmpIsTemplate && (tmpAddOwnOptions.length > 1)) ? [ { WizardHash: this.options.WizardHash, Entity: pEntityName, Options: tmpAddOwnOptions } ] : [];
			const tmpTemplateSlot = tmpIsTemplate ? [ { WizardHash: this.options.WizardHash, Entity: pEntityName, Template: tmpUI.OwnKeyTemplate || '', Placeholder: 'e.g. {~D:Record.District~}-{~D:Record.Code~}' } ] : [];
			tmpOwnKeySlot = [ { WizardHash: this.options.WizardHash, Entity: pEntityName, ColumnItems: tmpColumnItems, AddColumnSlot: tmpAddColumnSlot, TemplateSlot: tmpTemplateSlot, ToggleLabel: tmpIsTemplate ? 'use columns' : 'ƒ template' } ];
		}

		const tmpParents = (tmpUI.Parents || []).map((pParent, pIndex) => (
			{
				WizardHash: this.options.WizardHash, Entity: pEntityName, Index: pIndex,
				EntityOptions: [ { Value: '', Label: '(entity)', Selected: !pParent.Entity } ].concat(tmpCatalogEntities.map((pName) => ({ Value: pName, Label: pName, Selected: pName === pParent.Entity }))),
				KeyOptions: tmpColumnOptions(pParent.KeyColumn),
				ModeOptions: tmpModeOptions(pParent.Mode || 'prefixed'),
			}));

		const tmpUsed = {};
		(tmpUI.Parents || []).forEach((pParent) => { if (pParent.Entity) { tmpUsed[pParent.Entity] = true; } });
		const tmpAddOptions = [ { Value: '', Label: '+ Related entity', Selected: true } ].concat(tmpCatalogEntities.filter((pName) => !tmpUsed[pName] && (pName !== pEntityName)).map((pName) => ({ Value: pName, Label: pName, Selected: false })));
		const tmpAddParentSlot = (tmpAddOptions.length > 1) ? [ { WizardHash: this.options.WizardHash, Entity: pEntityName, Options: tmpAddOptions } ] : [];

		let tmpPreviewSlot = [];
		try
		{
			const tmpPreview = libStrategyApply.previewEntityGUID(tmpSession.GUIDStrategyUI || {}, this.options.GUIDStrategyPrefix || 'UI', tmpCatalog, this._schema, pEntityName, (tmpSession.SampleRows || [])[0] || {});
			if (tmpPreview) { tmpPreviewSlot = [ { Preview: tmpPreview } ]; }
		}
		catch (pError) { /* preview is best-effort */ }

		const tmpWarnings = (this._strategyWarnings || []).filter((pWarning) => pWarning.indexOf(`"${pEntityName}"`) >= 0).map((pWarning) => ({ Message: pWarning }));

		return {
			WizardHash: this.options.WizardHash, Entity: pEntityName,
			ModeOptions: tmpModeOptions(tmpUI.Mode || 'prefixed'),
			OwnKeySlot: tmpOwnKeySlot, Parents: tmpParents, AddParentSlot: tmpAddParentSlot,
			PreviewSlot: tmpPreviewSlot, Warnings: tmpWarnings,
		};
	}

	/** Auto-build a starting mapping from the schema: same-named source columns + a GUID template guess. */
	_autoBuildMapping(pSchema)
	{
		const tmpSourceNames = (this._session().DetectedColumns || []).map((pColumn) => pColumn.SourceName);
		const tmpEntities = {};
		const tmpOrder = pSchema.Order || pSchema.Entities.map((pEntity) => pEntity.Entity);
		pSchema.Entities.forEach((pEntity) =>
		{
			const tmpGUIDColumn = tmpSourceNames[0] || 'id';
			const tmpMappings = {};
			const tmpBindings = {};
			pEntity.Fields.forEach((pField) =>
			{
				if (pField.IsGUID) { return; }
				const tmpMatch = tmpSourceNames.find((pName) => pName.toLowerCase() === pField.Name.toLowerCase());
				if (tmpMatch) { tmpMappings[pField.Name] = `{~D:Record.${tmpMatch}~}`; tmpBindings[pField.Name] = tmpMatch; }
			});
			tmpEntities[pEntity.Entity] = {
				Entity: pEntity.Entity,
				GUIDName: pEntity.GUIDName,
				GUIDTemplate: pEntity.GUIDTemplateDefault || `${pEntity.Entity}_{~D:Record.${tmpGUIDColumn}~}`,
				Mappings: tmpMappings,
				_ColumnBindings: tmpBindings,
			};
		});
		return { TargetSchemaSource: this.options.SchemaSource, Order: tmpOrder, Entities: tmpEntities };
	}

	setMappingBinding(pEntity, pField, pSourceColumn)
	{
		const tmpSession = this._session();
		const tmpEntityMapping = tmpSession.Mapping.Entities[pEntity];
		if (!tmpEntityMapping) { return; }
		tmpEntityMapping._ColumnBindings = tmpEntityMapping._ColumnBindings || {};
		if (pSourceColumn) { tmpEntityMapping._ColumnBindings[pField] = pSourceColumn; tmpEntityMapping.Mappings[pField] = `{~D:Record.${pSourceColumn}~}`; }
		else { delete tmpEntityMapping._ColumnBindings[pField]; delete tmpEntityMapping.Mappings[pField]; }
		this._persist();
	}

	applyRawMapping()
	{
		const tmpElement = (typeof document !== 'undefined') ? document.getElementById(`DI_RawMap_${this.options.WizardHash}`) : null;
		if (!tmpElement) { return; }
		try { this._session().Mapping = JSON.parse(tmpElement.value); this._persist(); this._renderStepBody('mapping'); this._refreshAccordionChrome(); }
		catch (pError) { this._reportError(new Error('Mapping JSON is invalid.')); }
	}

	_mappingRenderState()
	{
		const tmpSession = this._session();
		const tmpSourceNames = (tmpSession.DetectedColumns || []).map((pColumn) => pColumn.SourceName);
		const tmpMapping = tmpSession.Mapping || { Order: [], Entities: {} };
		const tmpSchemaByEntity = {};
		if (this._schema) { (this._schema.Entities || []).forEach((pEntity) => { tmpSchemaByEntity[pEntity.Entity] = pEntity; }); }

		const tmpEntities = (tmpMapping.Order || []).map((pEntityName) =>
		{
			const tmpEntityMapping = tmpMapping.Entities[pEntityName] || { Entity: pEntityName, Mappings: {}, _ColumnBindings: {} };
			const tmpSchemaEntity = tmpSchemaByEntity[pEntityName];
			// Field rows: prefer the schema's fields; else the mapping's own field keys.
			const tmpFieldNames = tmpSchemaEntity
				? tmpSchemaEntity.Fields.filter((pField) => !pField.IsGUID).map((pField) => pField.Name)
				: Object.keys(tmpEntityMapping.Mappings || {});
			const tmpBindings = tmpEntityMapping._ColumnBindings || {};
			const tmpFields = tmpFieldNames.map((pFieldName) =>
			{
				const tmpBound = tmpBindings[pFieldName] || '';
				const tmpOptions = [ { Value: '', Label: '(none)', Selected: !tmpBound } ].concat(tmpSourceNames.map((pName) => ({ Value: pName, Label: pName, Selected: pName === tmpBound })));
				const tmpRequired = tmpSchemaEntity ? !!(tmpSchemaEntity.Fields.find((pField) => pField.Name === pFieldName) || {}).Required : false;
				return { WizardHash: this.options.WizardHash, Entity: pEntityName, Name: pFieldName, Required: tmpRequired, Options: tmpOptions };
			});
			return {
				Entity: pEntityName, GUIDTemplate: tmpEntityMapping.GUIDTemplate || '', Fields: tmpFields,
				LegacyGUIDSlot: this._strategyActive() ? [] : [ { GUIDTemplate: tmpEntityMapping.GUIDTemplate || '' } ],
				StrategySlot: this._strategyActive() ? [ this._strategyEntityState(pEntityName, tmpSourceNames) ] : [],
			};
		});

		return { WizardHash: this.options.WizardHash, Entities: tmpEntities, RawJSON: JSON.stringify(tmpMapping, null, 2) };
	}

	// --- Step 4: generate ---

	_ensureParsedRows()
	{
		if (this._parsedRows) { return Promise.resolve(this._parsedRows); }
		const tmpParser = this._activeParser();
		if (!this._fileHandle || !tmpParser) { return Promise.resolve([]); }
		return Promise.resolve(tmpParser.parse(this._fileHandle, this._session().ParseConfig)).then((pRows) => { this._parsedRows = pRows || []; return this._parsedRows; });
	}

	generate()
	{
		const tmpSession = this._session();
		const tmpBuilder = this.options.ComprehensionBuilder;
		if (!tmpBuilder) { this._reportError(new Error('No comprehension builder available.')); return; }
		this._ensureParsedRows().then((pRows) =>
		{
			const tmpResult = tmpBuilder.build(tmpSession.Mapping, pRows);
			tmpSession.Comprehension = tmpResult.Comprehension;
			tmpSession.GenerationReport = tmpResult.Report;
			tmpSession.StepStatus.generate = 'complete';
			this._mappingWarnings = tmpBuilder.validateForeignKeyOrder(tmpSession.Mapping);
			if (typeof this.options.OnComprehension === 'function') { try { this.options.OnComprehension(tmpSession.Comprehension, tmpResult.Report); } catch (pError) { /* host */ } }
			this._persist();
			this._renderStepBody('generate');
			this._refreshAccordionChrome();
		}).catch((pError) => { this._reportError(pError); });
	}

	_generateRenderState()
	{
		const tmpSession = this._session();
		const tmpReport = tmpSession.GenerationReport;
		const tmpWarnings = this._mappingWarnings || [];
		const tmpState = {
			WizardHash: this.options.WizardHash,
			Warnings: tmpWarnings.map((pWarning) => ({ Message: pWarning.Message })),
			DownloadSlot: (this.options.AllowDownload && tmpSession.Comprehension) ? [ { WizardHash: this.options.WizardHash } ] : [],
			ReportSlot: [],
		};
		if (tmpReport && tmpSession.Comprehension)
		{
			const tmpEntityCounts = Object.keys(tmpReport.EntityCounts || {}).map((pEntity) => ({ Entity: pEntity, Count: tmpReport.EntityCounts[pEntity] }));
			const tmpEntityTotal = tmpEntityCounts.reduce((pSum, pEntry) => pSum + pEntry.Count, 0);
			// Preview the first generated entity (first few records).
			const tmpFirstEntity = Object.keys(tmpSession.Comprehension)[0];
			let tmpPreviewSlot = [];
			if (tmpFirstEntity)
			{
				const tmpRecords = Object.keys(tmpSession.Comprehension[tmpFirstEntity]).slice(0, 8).map((pKey) => tmpSession.Comprehension[tmpFirstEntity][pKey]);
				const tmpHeaderNames = tmpRecords.length > 0 ? Object.keys(tmpRecords[0]) : [];
				tmpPreviewSlot = [ {
					Entity: tmpFirstEntity, ShownCount: tmpRecords.length,
					Header: tmpHeaderNames.map((pName) => ({ Name: pName })),
					Rows: tmpRecords.map((pRecord) => ({ Cells: tmpHeaderNames.map((pName) => ({ Value: String(pRecord[pName] === undefined ? '' : pRecord[pName]) })) })),
				} ];
			}
			tmpState.ReportSlot = [ { ParsedRowCount: tmpReport.ParsedRowCount, EntityTotal: tmpEntityTotal, EntityCounts: tmpEntityCounts, PreviewSlot: tmpPreviewSlot } ];
		}
		return tmpState;
	}

	downloadComprehension()
	{
		const tmpSession = this._session();
		if (!tmpSession.Comprehension || typeof document === 'undefined') { return; }
		const tmpBlob = new Blob([ JSON.stringify(tmpSession.Comprehension, null, 2) ], { type: 'application/json' });
		const tmpURL = URL.createObjectURL(tmpBlob);
		const tmpAnchor = document.createElement('a');
		tmpAnchor.href = tmpURL;
		tmpAnchor.download = `${this.options.WizardHash}-comprehension.json`;
		tmpAnchor.click();
		URL.revokeObjectURL(tmpURL);
	}

	// --- Step 5: push ---

	push()
	{
		const tmpSession = this._session();
		const tmpTarget = this.options.ResolvedPushTarget;
		if (!tmpTarget || !tmpSession.Comprehension) { this._reportError(new Error('Nothing to push — generate a comprehension first.')); return; }
		tmpSession.Push.Status = 'running';
		tmpSession.Push.Error = null;
		this._renderStepBody('push');
		const tmpContext = {
			Order: tmpSession.Mapping.Order,
			GUIDPrefix: this.options.GUIDPrefix,
			EntityGUIDPrefix: this.options.EntityGUIDPrefix,
			ServerURL: this.options.ServerURL,
			URLPrefix: this.options.URLPrefix,
			ComprehensionPushURL: this.options.ComprehensionPushURL,
			AllowGUIDTruncation: this.options.AllowGUIDTruncation,
			// When the GUID strategy owns length, the composer has already sized every GUID to its real
			// column width. Hand the push target those widths so a marshaling adapter doesn't re-truncate a
			// composed (already-fitting) GUID down to a smaller default — which would clip the entity's own
			// distinguishing segment and collide. Only sent for the strategy path (no behavior change otherwise).
			GUIDColumnSizes: (this.options.GUIDStrategy && this._schema) ? libStrategyApply.schemaSizes(this._schema) : undefined,
			onProgress: (pPushed, pTotal) => { tmpSession.Push.Progress = { Pushed: pPushed, Total: pTotal }; this._renderStepBody('push'); },
		};
		Promise.resolve(tmpTarget.push(tmpSession.Comprehension, tmpContext)).then((pResult) =>
		{
			tmpSession.Push.Status = 'complete';
			tmpSession.Push.Result = pResult;
			tmpSession.StepStatus.push = 'complete';
			if (typeof this.options.OnPushComplete === 'function') { try { this.options.OnPushComplete(pResult); } catch (pError) { /* host */ } }
			this._persist();
			this._renderStepBody('push');
			this._refreshAccordionChrome();
		}).catch((pError) =>
		{
			tmpSession.Push.Status = 'error';
			tmpSession.Push.Error = pError.message || String(pError);
			this._renderStepBody('push');
			this._reportError(pError);
		});
	}

	_pushRenderState()
	{
		const tmpSession = this._session();
		const tmpPush = tmpSession.Push;
		const tmpRunning = (tmpPush.Status === 'running');
		const tmpPct = (tmpPush.Progress && tmpPush.Progress.Total > 0) ? Math.round((tmpPush.Progress.Pushed / tmpPush.Progress.Total) * 100) : (tmpPush.Status === 'complete' ? 100 : 0);
		return {
			WizardHash: this.options.WizardHash,
			Mode: tmpPush.Mode,
			PushLabel: tmpRunning ? 'Pushing…' : 'Push to server',
			PushDisabled: tmpRunning || !tmpSession.Comprehension,
			ProgressSlot: (tmpRunning || tmpPush.Status === 'complete') ? [ { Pct: tmpPct } ] : [],
			ResultSlot: (tmpPush.Status === 'complete' && tmpPush.Result) ? [ { Message: tmpPush.Result.Message || 'Pushed.' } ] : [],
			ErrorSlot: (tmpPush.Status === 'error' && tmpPush.Error) ? [ { Message: tmpPush.Error } ] : [],
		};
	}

	// --- Shared ---

	_renderStepBody(pStepHash)
	{
		const tmpDestination = `#PSA_Body_${this._accHash}_${pStepHash}`;
		let tmpHTML = '';
		if (pStepHash === 'upload') { tmpHTML = this.pict.parseTemplateByHash('DI-Body-Upload', { WizardHash: this.options.WizardHash }); }
		else if (pStepHash === 'detect') { tmpHTML = this.pict.parseTemplateByHash('DI-Body-Detect', this._detectRenderState()); }
		else if (pStepHash === 'mapping') { tmpHTML = this.pict.parseTemplateByHash('DI-Body-Mapping', this._mappingRenderState()); }
		else if (pStepHash === 'generate') { tmpHTML = this.pict.parseTemplateByHash('DI-Body-Generate', this._generateRenderState()); }
		else if (pStepHash === 'push') { tmpHTML = this.pict.parseTemplateByHash('DI-Body-Push', this._pushRenderState()); }
		this.pict.ContentAssignment.assignContent(tmpDestination, tmpHTML);
	}

	/** Reflect step completion on the accordion chrome (so Next-gates + medallions update). */
	_refreshAccordionChrome()
	{
		if (!this._accordion) { return; }
		const tmpSession = this._session();
		[ 'upload', 'detect', 'mapping', 'generate' ].forEach((pStep) =>
		{
			if (this._canAdvance(pStep)) { this._accordion.setStepComplete(pStep, true); }
		});
	}

	/** Persist the session via the configured StateStore (best-effort). */
	_persist()
	{
		const tmpStore = this.options.ResolvedStateStore;
		if (!tmpStore) { return; }
		try { Promise.resolve(tmpStore.save(this.options.WizardHash, libSession.serialize(this._session()))).catch(() => {}); }
		catch (pError) { /* non-fatal */ }
	}

	_reportError(pError)
	{
		this.pict.log.warn(`pict-section-dataimport [${this.options.WizardHash}] ${pError.message || pError}`);
		if (typeof this.options.OnError === 'function') { try { this.options.OnError(pError); } catch (pInner) { /* host */ } }
	}

	/** @return {Record<string, any>} The current session (for host inspection). */
	getSession() { return this._session(); }
}

module.exports = PictViewDataImportWizard;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../services/DataImport-GuidStrategyApply.js":577,"../services/DataImport-Session.js":578,"pict-section-accordion":553,"pict-section-upload":721,"pict-view":733}],580:[function(require,module,exports){
/**
 * Default configuration for pict-section-excalidraw.
 *
 * Lives in its own file (mirrors pict-section-code) so the configuration —
 * including the (substantial) CSS — can be reasoned about without scrolling
 * past the view's lifecycle code.
 */

// CSS for the excalidraw wrapper.  All colors flow through pict-section-theme
// CSS custom properties (var(--theme-color-*, fallback)) so the control re-tints
// automatically when the app switches themes.  Layout values are local —
// Excalidraw's own chrome owns its internal sizing.
/* The 320px floor is a var so a host that sizes the control itself (a form field with a resize grip,
   say) can drop below it; without that, the floor silently wins and the control refuses to shrink. */
const _CSS = `.pict-excalidraw-wrap
{
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: var(--pict-excalidraw-min-height, 320px);
	background: var(--theme-color-background-panel, #FFFFFF);
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
	font-family: var(--theme-typography-family-base, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
	color: var(--theme-color-text-primary, #1A1A1A);
}

/* Theme bridge: forward pict tokens into the variables Excalidraw's own
   stylesheet reads.  See vendor/excalidraw/packages/excalidraw/css/ for the
   token names.  We default to the official light palette so Excalidraw renders
   correctly even before a pict theme overrides anything. */
.pict-excalidraw-wrap
{
	--default-bg-color:       var(--theme-color-background-panel,    #FFFFFF);
	--island-bg-color:        var(--theme-color-background-secondary, #FFFFFF);
	--input-bg-color:         var(--theme-color-background-primary,   #FFFFFF);
	--input-border-color:     var(--theme-color-border-default,       #D0D0D0);
	--text-primary-color:     var(--theme-color-text-primary,         #1A1A1A);
	--color-primary:          var(--theme-color-brand-primary,        #6965DB);
	--color-primary-darker:   var(--theme-color-brand-primary-hover,  #5754C4);
	--color-primary-darkest:  var(--theme-color-brand-primary-hover,  #4642B7);
	--color-on-primary-container: var(--theme-color-background-panel, #FFFFFF);
	--button-hover-bg:        var(--theme-color-background-hover,     #F1F0FF);
	--button-active-bg:       var(--theme-color-background-selected,  #E3E2FE);
	--button-active-border:   var(--theme-color-brand-primary,        #6965DB);
	--popup-bg-color:         var(--theme-color-background-panel,     #FFFFFF);
	--popup-border-color:     var(--theme-color-border-default,       #D0D0D0);
	--icon-fill-color:        var(--theme-color-text-primary,         #1A1A1A);
	--shadow-island:          0 0 0 1px var(--theme-color-border-light, rgba(0,0,0,0.06)), 0 2px 6px 0 var(--theme-color-shadow-color, rgba(0,0,0,0.08));
}

/* iframe mode: the iframe element itself owns the entire wrap surface */
.pict-excalidraw-iframe
{
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: var(--pict-excalidraw-min-height, 320px);
	border: 0;
	background: var(--theme-color-background-panel, #FFFFFF);
}

/* react mode: a single inner div that Excalidraw mounts into via createRoot */
.pict-excalidraw-mount
{
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: var(--pict-excalidraw-min-height, 320px);
	position: relative;
}

/* Status / error overlay used by both modes before the third-party lib is
   wired up, or when bundling failed. */
.pict-excalidraw-status
{
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
	background: var(--theme-color-background-panel, #FFFFFF);
	color: var(--theme-color-text-secondary, #4A4A4A);
	text-align: center;
	font-size: 14px;
	line-height: 1.4;
	z-index: 1;
}
.pict-excalidraw-status code
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace);
	font-size: 12px;
	padding: 2px 6px;
	background: var(--theme-color-background-secondary, #F4F4F4);
	border: 1px solid var(--theme-color-border-light, rgba(0,0,0,0.06));
	border-radius: 3px;
}
.pict-excalidraw-status.error
{
	color: var(--theme-color-status-error, #B43B3B);
}
`;

module.exports = ({
	"RenderOnLoad": true,

	"DefaultRenderable": "Excalidraw-Wrap",
	"DefaultDestinationAddress": "#Excalidraw-Container-Div",
	"TargetElementAddress": "#Excalidraw-Container-Div",

	// 'react' or 'iframe'.  React is cleanest for theme conformance; iframe is
	// the right choice if the host app's global CSS is aggressive enough to
	// bleed into Excalidraw and you'd rather pay the postMessage tax than fight
	// it.
	"EmbedMode": "react",

	// Address in AppData (dot-notation) to two-way bind the scene JSON into.
	// Set to false to opt out.
	"DrawingDataAddress": false,

	// 'light' | 'dark' | 'auto'.  'auto' follows the pict-section-theme mode
	// when the provider is present.
	"Theme": "light",

	// How Excalidraw should classify the editor for UI density.  Excalidraw's own answer comes from
	// the CONTAINER's box, which misreads a small embed on a large desktop as a phone and hides the
	// shape properties behind a popover.
	//   'auto'    - Excalidraw decides (its stock behavior)
	//   'pointer' - desktop chrome for a mouse; Excalidraw's own answer on a touch screen
	//   'desktop' | 'tablet' | 'phone' - pin it
	"FormFactor": "auto",

	"ViewModeEnabled": false,
	"ZenModeEnabled":  false,
	"GridModeEnabled": false,
	"LangCode":        "en",

	// Forwarded verbatim to <Excalidraw UIOptions={...}>.  See:
	// https://docs.excalidraw.com/docs/@excalidraw/excalidraw/api/props/ui-options
	"UIOptions": {},

	// Initial scene used when no OnLoad callback / DrawingDataAddress yields
	// anything.
	"InitialData":
	{
		"elements": [],
		"appState": {},
		"files":    {}
	},

	// Base URL the iframe / wrapper looks under for fonts + locales.  Set this
	// to wherever you copied vendor/excalidraw-built/assets/ at deploy time.
	"AssetBaseURL": "./excalidraw-assets/",

	// URL of the iframe host page (iframe mode only).  Defaults to
	// excalidraw-iframe-host.html sitting next to the page that loaded the
	// wrapper bundle.
	"IframeHostURL": "./excalidraw-iframe-host.html",

	// Lazy-loading: if the wrapper bundle isn't already on the page when the
	// view first mounts, fetch it on demand from these URLs.  Saves first-
	// paint cost for pages that don't have a diagram.  Leave null to require
	// the host to load the scripts via <script> tags (default — preserves
	// the existing eager-load behavior).
	//
	//   LazyLoadReactVendorURL: URL to react-vendor.min.js (or any script
	//                            that sets window.React + window.ReactDOM).
	//                            Skip if the host already loads React.
	//   LazyLoadWrapperURL:      URL to excalidraw-wrapper.min.js (or any
	//                            script that sets
	//                            window.PictSectionExcalidrawVendor).
	"LazyLoadReactVendorURL": null,
	"LazyLoadWrapperURL":     null,

	// Callback hooks — see README.  Signatures intentionally use Node-style
	// fCallback(err, value) so they compose with the rest of the Fable/Pict
	// async patterns.
	"OnLoad":   null,
	"OnSave":   null,
	"OnChange": null,

	// Throttle (ms) for the OnChange callback fired during active editing.
	// Excalidraw fires onChange on every pointer move; the wrapper batches.
	"OnChangeThrottleMs": 250,

	"Templates":
	[
		{
			"Hash": "Excalidraw-Container",
			"Template": "<!-- Excalidraw-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "Excalidraw-Wrap",
			"TemplateHash": "Excalidraw-Container",
			"DestinationAddress": "#Excalidraw-Container-Div"
		}
	],

	"CSS": _CSS
});

},{}],581:[function(require,module,exports){
/**
 * pict-section-excalidraw — main entry.
 *
 * Exports a single dispatch view class that picks between the React-mount and
 * iframe implementations at construction time based on the EmbedMode option.
 *
 * Consumers can either:
 *   1. Use the default export and pass EmbedMode in the configuration
 *   2. Pull the explicit implementation classes directly:
 *        const { ReactView, IframeView } = require('pict-section-excalidraw');
 */

const libPictViewClass            = require('pict-view');
const libExcalidrawReactView      = require('./views/PictView-Excalidraw-React.js');
const libExcalidrawIframeView     = require('./views/PictView-Excalidraw-Iframe.js');
const _DefaultConfiguration       = require('./Pict-Section-Excalidraw-DefaultConfiguration.js');

/**
 * Resolve which implementation class the consumer wants based on the merged
 * configuration.  Exposed so the dispatch view and any framework registration
 * helpers can agree on the same selection logic.
 */
function selectImplementation(pOptions)
{
	let tmpMode = ((pOptions && pOptions.EmbedMode) || _DefaultConfiguration.EmbedMode || 'react').toLowerCase();
	if (tmpMode === 'iframe')
	{
		return libExcalidrawIframeView;
	}
	return libExcalidrawReactView;
}

/**
 * PictSectionExcalidraw — thin dispatcher.  Constructs the chosen
 * implementation as a sibling pict-view on the same fable and proxies the
 * public surface onto it.  We don't extend either implementation directly
 * because the embed mode is a runtime decision, not a class-level one.
 */
class PictSectionExcalidraw extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._ImplementationClass = selectImplementation(tmpOptions);

		// Instantiate the actual implementation view as a peer pict-view.  It
		// gets its own ViewIdentifier (suffixed) so AppData/template scopes
		// don't clash with the dispatcher.
		let tmpImplOptions = Object.assign({}, tmpOptions);
		tmpImplOptions.ViewIdentifier = (tmpOptions.ViewIdentifier || 'PictSectionExcalidraw') + '-Impl';

		this._Implementation = new this._ImplementationClass(pFable, tmpImplOptions, pServiceHash);

		// Public-API proxy: forward every method the implementations expose so
		// consumers can hold a reference to the dispatcher and not care which
		// mode is active.
		let tmpForwardedMethods =
		[
			'getScene', 'setScene', 'exportSvg', 'exportBlob', 'serialize',
			'setTheme', 'setReadOnly', 'load', 'save', 'destroy',
			'getApi', 'connectExcalidrawGlobal', 'isDestroyed',
			'convertMermaidToExcalidraw'
		];
		for (let i = 0; i < tmpForwardedMethods.length; i++)
		{
			let tmpName = tmpForwardedMethods[i];
			this[tmpName] = (...pArgs) =>
			{
				if (typeof this._Implementation[tmpName] === 'function')
				{
					return this._Implementation[tmpName].apply(this._Implementation, pArgs);
				}
				return undefined;
			};
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// The implementation is what actually owns the destination div.  We
		// render it once the dispatcher's own render cycle has fired so the
		// outer container exists.
		if (this._Implementation && typeof this._Implementation.render === 'function')
		{
			if (!this._dispatchedRender)
			{
				this._dispatchedRender = true;
				this._Implementation.render();
			}
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictSectionExcalidraw;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.ReactView             = libExcalidrawReactView;
module.exports.IframeView            = libExcalidrawIframeView;
module.exports.selectImplementation  = selectImplementation;

// Form-side integration: the `Diagram` InputType (and its provider class) lives
// in pict-section-form under `providers/inputs/Pict-Provider-Input-Diagram.js`,
// not here. The provider lazy-requires this module on the first setMode('edit')
// so consumers that never edit don't pull the Excalidraw vendor bundle.
//
//   const libDiagramInput = require('pict-section-form').DiagramInput;
//   pict.addProvider('Pict-Input-Diagram',
//       libDiagramInput.default_configuration, libDiagramInput);
//
// The Themeify-SVG utility (used to rewrite Excalidraw hex colors to CSS
// variables on save) is now exposed as `require('pict-section-form').themeifySVG`.

},{"./Pict-Section-Excalidraw-DefaultConfiguration.js":580,"./views/PictView-Excalidraw-Iframe.js":583,"./views/PictView-Excalidraw-React.js":584,"pict-view":733}],582:[function(require,module,exports){
/**
 * Excalidraw-Form-Factor.js
 *
 * Excalidraw decides how dense its UI should be from the size of the CONTAINER it is mounted in:
 * roughly `width <= 599 || (height < 500 && width < 1000)` reads as a phone, and a phone gets the
 * mobile styles panel — shape properties collapse behind a dismissable popover instead of the
 * left-hand island.
 *
 * That heuristic is right for excalidraw.com, where the container IS the viewport, and wrong for an
 * embed, where the container is a box on a page that may be a few hundred pixels tall on a 27"
 * monitor with a mouse. Excalidraw exposes `UIOptions.getFormFactor(width, height)` for exactly this
 * case; returning `undefined` from it falls back to Excalidraw's own detection.
 *
 * NOTE: the iframe host (source/iframe-host/excalidraw-iframe-host.js) carries its own copy of this
 * logic — a function cannot cross postMessage, so the parent sends the MODE STRING and the host
 * rebuilds the resolver inside the frame. Keep the two in step.
 */

const FORM_FACTORS = ['desktop', 'tablet', 'phone'];

/**
 * Does this device drive the pointer with a finger rather than a mouse?
 *
 * @return {boolean} True when the primary pointer is coarse (touch).
 */
function isCoarsePointer()
{
	if ((typeof window === 'undefined') || (typeof window.matchMedia !== 'function')) return false;
	try { return window.matchMedia('(pointer: coarse)').matches; }
	catch (pErr) { return false; }
}

/**
 * Build the `UIOptions.getFormFactor` hook for a configured FormFactor mode.
 *
 * @param {string} pMode - 'auto' | 'pointer' | 'desktop' | 'tablet' | 'phone'.
 * @return {Function} The hook, or null when Excalidraw should decide for itself.
 */
function buildFormFactorResolver(pMode)
{
	let tmpMode = (typeof pMode === 'string') ? pMode.toLowerCase() : 'auto';

	if (tmpMode === 'pointer')
	{
		// Classify by input device, not by the size of the box we happen to be embedded in. A touch
		// screen still gets Excalidraw's own answer — the mobile UI is genuinely better with a finger.
		return function () { return isCoarsePointer() ? undefined : 'desktop'; };
	}

	if (FORM_FACTORS.indexOf(tmpMode) > -1)
	{
		return function () { return tmpMode; };
	}

	// 'auto' and anything unrecognized: don't install the hook at all.
	return null;
}

module.exports = { buildFormFactorResolver, isCoarsePointer, FORM_FACTORS };

},{}],583:[function(require,module,exports){
/**
 * PictView-Excalidraw-Iframe — iframe embedding of Excalidraw.
 *
 * The destination div hosts an <iframe> pointing at our vendored
 * excalidraw-iframe-host.html.  Communication happens through window.postMessage
 * with a small protocol:
 *
 *   parent -> iframe :  { type: 'pict-excalidraw:init',  payload: { initialData, theme, langCode, viewModeEnabled, ... } }
 *   parent -> iframe :  { type: 'pict-excalidraw:setScene',  payload: { elements, appState, files } }
 *   parent -> iframe :  { type: 'pict-excalidraw:setTheme',  payload: 'light' | 'dark' }
 *   parent -> iframe :  { type: 'pict-excalidraw:setReadOnly', payload: bool }
 *   parent -> iframe :  { type: 'pict-excalidraw:setThemeTokens', payload: { '--theme-color-...': '#xxx', ... } }
 *   parent -> iframe :  { type: 'pict-excalidraw:requestScene', requestId }
 *   parent -> iframe :  { type: 'pict-excalidraw:requestSvg',   requestId, exportOptions }
 *
 *   iframe -> parent :  { type: 'pict-excalidraw:ready' }
 *   iframe -> parent :  { type: 'pict-excalidraw:change',     payload: { elements, appState, files } }
 *   iframe -> parent :  { type: 'pict-excalidraw:sceneReply', requestId, payload }
 *   iframe -> parent :  { type: 'pict-excalidraw:svgReply',   requestId, payload }
 *
 * The iframe runs the same wrapper bundle as the React-mount mode — see
 * excalidraw-iframe-host.html.
 */

const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('../Pict-Section-Excalidraw-DefaultConfiguration.js');

class PictViewExcalidrawIframe extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;
		this.targetElement = false;
		this._iframeElement = null;
		this._wrapElement   = null;
		this._statusElement = null;
		this._iframeReady   = false;

		this._pendingRequests   = Object.create(null);
		this._nextRequestId     = 1;
		this._lastSceneSnapshot = null;
		this._messageListener   = null;

		this._onChangeThrottleHandle = null;
		this._lastSeenChangeSnapshot = null;
		this._currentTheme = this.options.Theme || 'light';

		// Set true by destroy(); gates public API methods + the throttle
		// callback against post-teardown state mutations.
		this._destroyed = false;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpTargetSet = this.pict.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetSet || tmpTargetSet.length < 1)
		{
			this.log.error(`PICT-Excalidraw (iframe) could not find target [${this.options.TargetElementAddress}].`);
			return false;
		}
		this.targetElement = tmpTargetSet[0];

		this._buildContainerDOM();
		this._wireMessageListener();
		this._mountIframe();
	}

	_buildContainerDOM()
	{
		this.targetElement.innerHTML = '';

		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-excalidraw-wrap pict-excalidraw-wrap-iframe';

		let tmpStatus = document.createElement('div');
		tmpStatus.className = 'pict-excalidraw-status';
		tmpStatus.innerHTML = 'Loading Excalidraw…';
		tmpWrap.appendChild(tmpStatus);

		let tmpIframe = document.createElement('iframe');
		tmpIframe.className = 'pict-excalidraw-iframe';
		tmpIframe.setAttribute('title', 'Excalidraw drawing');
		tmpIframe.setAttribute('allow', 'clipboard-read; clipboard-write');
		tmpWrap.appendChild(tmpIframe);

		this.targetElement.appendChild(tmpWrap);

		this._wrapElement   = tmpWrap;
		this._iframeElement = tmpIframe;
		this._statusElement = tmpStatus;
	}

	_wireMessageListener()
	{
		// MessageEvent is one of the few cases where addEventListener is
		// legitimate — window-level events don't have an inline-handler
		// equivalent.  See pict CLAUDE.md "legitimate exceptions".
		this._messageListener = (pEvent) =>
		{
			if (!pEvent || !pEvent.data || typeof pEvent.data !== 'object') return;
			if (pEvent.source !== (this._iframeElement && this._iframeElement.contentWindow)) return;
			this._handleIframeMessage(pEvent.data);
		};
		window.addEventListener('message', this._messageListener);
	}

	_mountIframe()
	{
		let tmpUrl = this.options.IframeHostURL || './excalidraw-iframe-host.html';
		this._iframeElement.src = tmpUrl;
	}

	_postToIframe(pMessage)
	{
		if (!this._iframeElement || !this._iframeElement.contentWindow) return false;
		this._iframeElement.contentWindow.postMessage(pMessage, '*');
		return true;
	}

	_handleIframeMessage(pData)
	{
		switch (pData.type)
		{
			case 'pict-excalidraw:ready':
				this._iframeReady = true;
				if (this._statusElement) this._statusElement.style.display = 'none';
				this._sendInitMessage();
				return;

			case 'pict-excalidraw:change':
				this._handleChange(pData.payload);
				return;

			case 'pict-excalidraw:sceneReply':
			case 'pict-excalidraw:svgReply':
			case 'pict-excalidraw:blobReply':
			{
				let tmpReq = this._pendingRequests[pData.requestId];
				if (tmpReq)
				{
					clearTimeout(tmpReq.timeout);
					delete this._pendingRequests[pData.requestId];
					tmpReq.resolve(pData.payload);
				}
				return;
			}

			case 'pict-excalidraw:error':
			{
				let tmpReq = pData.requestId && this._pendingRequests[pData.requestId];
				if (tmpReq)
				{
					clearTimeout(tmpReq.timeout);
					delete this._pendingRequests[pData.requestId];
					tmpReq.reject(new Error(pData.message || 'iframe error'));
				}
				else
				{
					this.log.error(`PICT-Excalidraw (iframe) error: ${pData.message}`);
				}
				return;
			}

			default:
				// Unknown message — ignored
				return;
		}
	}

	_sendInitMessage()
	{
		let tmpInitial = this._resolveInitialData();
		this._postToIframe({
			type: 'pict-excalidraw:init',
			payload:
			{
				initialData:     tmpInitial,
				theme:           this._resolveTheme(this._currentTheme),
				langCode:        this.options.LangCode || 'en',
				viewModeEnabled: !!this.options.ViewModeEnabled,
				zenModeEnabled:  !!this.options.ZenModeEnabled,
				gridModeEnabled: !!this.options.GridModeEnabled,
				UIOptions:       this.options.UIOptions || {},
				// The MODE STRING, not a resolver: postMessage structured-clones its payload and a
				// function would throw a DataCloneError.  The host rebuilds the hook inside the frame.
				formFactor:      this.options.FormFactor || 'auto',
				assetBaseURL:    this.options.AssetBaseURL
			}
		});

		// Push theme tokens into the iframe so its CSS variables resolve.
		this._pushThemeTokens();

		// Deferred OnLoad fires now that the iframe is ready.
		if (typeof this.options.OnLoad === 'function')
		{
			this.load();
		}
	}

	_pushThemeTokens()
	{
		if (typeof document === 'undefined' || !document.documentElement) return;
		// Snapshot the theme variables off documentElement's computed style.
		// We only forward variables we know Excalidraw consumes (the bridge
		// vars baked into the wrap CSS), not the entire theme catalog.
		let tmpVars = [
			'--theme-color-background-panel',
			'--theme-color-background-primary',
			'--theme-color-background-secondary',
			'--theme-color-background-hover',
			'--theme-color-background-selected',
			'--theme-color-border-default',
			'--theme-color-border-light',
			'--theme-color-text-primary',
			'--theme-color-text-secondary',
			'--theme-color-brand-primary',
			'--theme-color-brand-primary-hover',
			'--theme-color-status-error',
			'--theme-color-shadow-color'
		];
		let tmpStyle = window.getComputedStyle(document.documentElement);
		let tmpPayload = {};
		for (let i = 0; i < tmpVars.length; i++)
		{
			let tmpVal = tmpStyle.getPropertyValue(tmpVars[i]).trim();
			if (tmpVal) tmpPayload[tmpVars[i]] = tmpVal;
		}
		this._postToIframe({ type: 'pict-excalidraw:setThemeTokens', payload: tmpPayload });
	}

	_resolveInitialData()
	{
		if (this.options.DrawingDataAddress)
		{
			let tmpFromAppData = this._readAppData(this.options.DrawingDataAddress);
			if (tmpFromAppData && tmpFromAppData.elements) return tmpFromAppData;
		}
		return this.options.InitialData || { elements: [], appState: {}, files: {} };
	}

	_resolveTheme(pTheme)
	{
		if (pTheme === 'auto')
		{
			if (typeof document !== 'undefined' && document.documentElement)
			{
				if (document.documentElement.classList && document.documentElement.classList.contains('theme-mode-dark'))
				{
					return 'dark';
				}
			}
			let tmpThemeProvider = this.pict && this.pict.providers && this.pict.providers.ThemeSection;
			if (tmpThemeProvider && tmpThemeProvider.getCurrentMode)
			{
				let tmpMode = tmpThemeProvider.getCurrentMode();
				if (tmpMode === 'dark') return 'dark';
				if (tmpMode === 'light') return 'light';
			}
			return 'light';
		}
		return (pTheme === 'dark') ? 'dark' : 'light';
	}

	_handleChange(pSnap)
	{
		if (this._destroyed) return;
		this._lastSceneSnapshot = pSnap;
		this._lastSeenChangeSnapshot = pSnap;
		if (this._onChangeThrottleHandle) return;

		let tmpDelay = this.options.OnChangeThrottleMs || 250;
		this._onChangeThrottleHandle = setTimeout(() =>
		{
			this._onChangeThrottleHandle = null;
			if (this._destroyed) return;
			let tmpFinal = this._lastSeenChangeSnapshot;
			if (!tmpFinal) return;

			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, tmpFinal);
			}
			if (typeof this.options.OnChange === 'function')
			{
				try { this.options.OnChange(this, tmpFinal); }
				catch (pErr) { this.log.error(`PICT-Excalidraw OnChange threw: ${pErr && pErr.message}`); }
			}
		}, tmpDelay);
	}

	_readAppData(pAddress)
	{
		if (!pAddress) return null;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.getValueByHash)
			{
				return this.fable.manifest.getValueByHash(this.pict.AppData, tmpRelative);
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length; i++)
			{
				if (tmpCursor == null) return null;
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			return tmpCursor;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw read AppData failed: ${pErr && pErr.message}`);
			return null;
		}
	}

	_writeAppData(pAddress, pValue)
	{
		if (!pAddress) return false;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.setValueByHash)
			{
				this.fable.manifest.setValueByHash(this.pict.AppData, tmpRelative, pValue);
				return true;
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if (tmpCursor[tmpParts[i]] == null) tmpCursor[tmpParts[i]] = {};
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
			return true;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw write AppData failed: ${pErr && pErr.message}`);
			return false;
		}
	}

	_request(pType, pExtra)
	{
		let tmpId = (this._nextRequestId++);
		return new Promise((fResolve, fReject) =>
		{
			this._pendingRequests[tmpId] = { resolve: fResolve, reject: fReject };
			this._postToIframe(Object.assign({ type: pType, requestId: tmpId }, pExtra || {}));
			// Safety timeout — 30s (cleared on reply / destroy)
			this._pendingRequests[tmpId].timeout = setTimeout(() =>
			{
				if (this._pendingRequests[tmpId])
				{
					delete this._pendingRequests[tmpId];
					fReject(new Error('iframe request timed out'));
				}
			}, 30000);
		});
	}

	// ---- Public API ---------------------------------------------------------

	getApi() { return null; /* iframe mode hides the live API behind postMessage */ }

	/**
	 * Iframe mode returns the most recent change snapshot synchronously, and
	 * the live scene asynchronously via requestScene().  Most callers want the
	 * sync snapshot — for the freshest one, await requestScene().
	 */
	getScene() { return this._lastSceneSnapshot; }

	requestScene() { return this._request('pict-excalidraw:requestScene'); }

	setScene(pSceneData)
	{
		if (!pSceneData) return false;
		this._postToIframe({ type: 'pict-excalidraw:setScene', payload: pSceneData });
		return true;
	}

	exportSvg(pOpts)
	{
		return this._request('pict-excalidraw:requestSvg', { exportOptions: pOpts || {} });
	}

	exportBlob(pOpts)
	{
		return this._request('pict-excalidraw:requestBlob', { exportOptions: pOpts || {} });
	}

	serialize()
	{
		let tmpScene = this._lastSceneSnapshot;
		if (!tmpScene) return null;
		return JSON.stringify({
			type: 'excalidraw',
			version: 2,
			source: 'pict-section-excalidraw',
			elements: tmpScene.elements || [],
			appState: tmpScene.appState || {},
			files:    tmpScene.files    || {}
		});
	}

	setTheme(pTheme)
	{
		this._currentTheme = pTheme || 'light';
		let tmpResolved = this._resolveTheme(this._currentTheme);
		this._postToIframe({ type: 'pict-excalidraw:setTheme', payload: tmpResolved });
		this._pushThemeTokens();
	}

	setReadOnly(pReadOnly)
	{
		this.options.ViewModeEnabled = !!pReadOnly;
		this._postToIframe({ type: 'pict-excalidraw:setReadOnly', payload: !!pReadOnly });
	}

	load()
	{
		if (typeof this.options.OnLoad === 'function')
		{
			this.options.OnLoad(this, (pErr, pSceneData) =>
			{
				if (pErr) { this.log.error(`PICT-Excalidraw OnLoad error: ${pErr.message || pErr}`); return; }
				if (pSceneData) this.setScene(pSceneData);
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			let tmpScene = this._readAppData(this.options.DrawingDataAddress);
			if (tmpScene) this.setScene(tmpScene);
		}
	}

	save()
	{
		// Iframe mode: prefer the snapshot, but freshen via requestScene if we
		// don't have one yet.
		let tmpResolveAndSave = (pScene) =>
		{
			if (!pScene) return;
			if (typeof this.options.OnSave === 'function')
			{
				this.options.OnSave(this, pScene, (pErr) =>
				{
					if (pErr) this.log.error(`PICT-Excalidraw OnSave error: ${pErr.message || pErr}`);
				});
				return;
			}
			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, pScene);
			}
		};
		if (this._lastSceneSnapshot)
		{
			tmpResolveAndSave(this._lastSceneSnapshot);
			return;
		}
		this.requestScene().then(tmpResolveAndSave).catch((pErr) =>
		{
			this.log.error(`PICT-Excalidraw save scene fetch failed: ${pErr.message || pErr}`);
		});
	}

	/**
	 * Tear down the iframe + message listener + pending request promises.
	 * Idempotent.  After destroy(), public API methods short-circuit so
	 * post-teardown calls don't crash.
	 */
	destroy()
	{
		if (this._destroyed) return;
		this._destroyed = true;

		if (this._onChangeThrottleHandle)
		{
			clearTimeout(this._onChangeThrottleHandle);
			this._onChangeThrottleHandle = null;
		}
		this._lastSeenChangeSnapshot = null;

		if (this._messageListener)
		{
			try { window.removeEventListener('message', this._messageListener); }
			catch (pErr) { /* ignore */ }
			this._messageListener = null;
		}

		// Reject any in-flight request promises so awaiters get a real
		// error instead of waiting 30s for the safety timeout.
		let tmpReqKeys = Object.keys(this._pendingRequests);
		for (let i = 0; i < tmpReqKeys.length; i++)
		{
			let tmpReq = this._pendingRequests[tmpReqKeys[i]];
			if (tmpReq && typeof tmpReq.reject === 'function')
			{
				clearTimeout(tmpReq.timeout);
					try { tmpReq.reject(new Error('view destroyed')); }
				catch (pErr) { /* ignore */ }
			}
		}
		this._pendingRequests = Object.create(null);

		// Force-stop the iframe.  Navigating to about:blank unmounts the
		// React tree inside it cleanly; just nulling our reference would
		// leave the page running until GC.
		if (this._iframeElement)
		{
			try { this._iframeElement.src = 'about:blank'; }
			catch (pErr) { /* ignore */ }
		}

		// Clear the destination DOM so a subsequent re-render starts clean.
		if (this.targetElement && this.targetElement.innerHTML !== undefined)
		{
			try { this.targetElement.innerHTML = ''; }
			catch (pErr) { /* ignore */ }
		}

		this._iframeReady = false;
		this._lastSceneSnapshot = null;
		this._iframeElement = null;
		this._statusElement = null;
		this._wrapElement = null;
		this.targetElement = false;
		this.initialRenderComplete = false;
	}

	/** Whether destroy() has been called. */
	isDestroyed()
	{
		return !!this._destroyed;
	}
}

module.exports = PictViewExcalidrawIframe;
module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":580,"pict-view":733}],584:[function(require,module,exports){
/**
 * PictView-Excalidraw-React — React-mount embedding of Excalidraw.
 *
 * Mirrors the pict-section-code <-> CodeJar pattern: a wrapper script is loaded
 * via <script> tag in the HTML shell that puts React, ReactDOM, and Excalidraw
 * on the window as PictSectionExcalidrawVendor.  This view picks those up at
 * onAfterInitialRender, calls ReactDOM.createRoot on the destination div, and
 * mounts <Excalidraw> with our merged props.
 *
 * Lifecycle:
 *   onBeforeInitialize  -> seed instance fields
 *   onAfterRender       -> inject CSS, run initial-render hook once
 *   onAfterInitialRender-> resolve vendor globals, mount root, fire OnLoad
 *   destroy             -> unmount root, drop references
 *
 * AppData binding mirrors pict-section-code: if DrawingDataAddress is set we
 * read it on load and write it on change (via the OnChange throttle).
 */

const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('../Pict-Section-Excalidraw-DefaultConfiguration.js');
const { buildFormFactorResolver } = require('../utils/Excalidraw-Form-Factor.js');

class PictViewExcalidrawReact extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// Vendor globals are resolved lazily on first render so the consumer
		// can either load them via a <script> tag (preferred) or hand them in
		// explicitly via connectExcalidrawGlobal().
		this._vendor = null;

		// React root + the live Excalidraw API handle, both populated on mount.
		this._reactRoot       = null;
		this._excalidrawAPI   = null;
		this.targetElement    = false;
		this._wrapElement     = null;
		this._mountElement    = null;
		this._statusElement   = null;

		// Throttle bookkeeping for the OnChange callback.
		this._onChangeThrottleHandle = null;
		this._lastSeenChangeSnapshot = null;

		// Set when InitialData isn't directly available and we want OnLoad
		// to fire once the excalidrawAPI callback runs.
		this._pendingDeferredLoad = false;

		// Set true by destroy(); gates public methods that touch DOM/React.
		this._destroyed = false;

		// Current theme mirror.  Updated by setTheme() so re-mounts on resize
		// pick the most recent value rather than the original option.
		this._currentTheme = this.options.Theme || 'light';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();
		return super.onBeforeInitialize();
	}

	/**
	 * Connect the vendor globals explicitly.  If not called, the view will
	 * look for window.PictSectionExcalidrawVendor at first render.
	 *
	 * @param {{ React: any, ReactDOM: any, Excalidraw: any,
	 *           exportToSvg?: Function, exportToBlob?: Function,
	 *           serializeAsJSON?: Function }} pVendor
	 */
	connectExcalidrawGlobal(pVendor)
	{
		if (pVendor && pVendor.Excalidraw && pVendor.React && pVendor.ReactDOM)
		{
			this._vendor = pVendor;
			return true;
		}
		return false;
	}

	_resolveVendor()
	{
		if (this._vendor) return this._vendor;
		if (typeof window !== 'undefined' && window.PictSectionExcalidrawVendor)
		{
			let tmpV = window.PictSectionExcalidrawVendor;
			if (tmpV.Excalidraw && tmpV.React && tmpV.ReactDOM)
			{
				this._vendor = tmpV;
				return tmpV;
			}
		}
		return null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		// Locate the container.  We expect the consumer to have placed a div
		// at TargetElementAddress that we own from here on.
		let tmpTargetSet = this.pict.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetSet || tmpTargetSet.length < 1)
		{
			this.log.error(`PICT-Excalidraw could not find target element [${this.options.TargetElementAddress}].`);
			return false;
		}
		this.targetElement = tmpTargetSet[0];

		this._buildContainerDOM();

		let tmpVendor = this._resolveVendor();
		if (tmpVendor)
		{
			this._mountReact(tmpVendor);
			return;
		}

		// No vendor globals on the page yet.  If lazy-load URLs are configured,
		// inject the scripts on demand; otherwise fail loudly with a status
		// message and a console error so the developer knows what's missing.
		if (this.options.LazyLoadWrapperURL)
		{
			this._renderStatus('Loading Excalidraw…', /* isError */ false);
			this._lazyLoadVendor().then(() =>
			{
				if (this._destroyed) return;
				let tmpReVendor = this._resolveVendor();
				if (tmpReVendor)
				{
					this._mountReact(tmpReVendor);
				}
				else
				{
					this._renderStatus(
						'Excalidraw failed to lazy-load.  Check the network tab for ' +
						'<code>excalidraw-wrapper.min.js</code>.',
						/* isError */ true
					);
				}
			}).catch((pErr) =>
			{
				this.log.error(`PICT-Excalidraw lazy-load failed: ${pErr && pErr.message}`);
				this._renderStatus('Excalidraw lazy-load failed: <code>' +
					((pErr && pErr.message) || 'unknown error') + '</code>',
					/* isError */ true);
			});
			return;
		}

		this._renderStatus(
			'Excalidraw wrapper bundle not loaded.  Include ' +
			'<code>excalidraw-wrapper.min.js</code> via a script tag, set ' +
			'<code>LazyLoadWrapperURL</code> in the view options, or call ' +
			'<code>connectExcalidrawGlobal({React, ReactDOM, Excalidraw})</code>.',
			/* isError */ true
		);
		this.log.error('PICT-Excalidraw vendor bundle not found; cannot mount.');
		return false;
	}

	/**
	 * Inject the configured react-vendor + wrapper scripts and resolve once
	 * window.PictSectionExcalidrawVendor exists.  Idempotent — multiple
	 * views mounting at the same time share a single in-flight load.
	 */
	_lazyLoadVendor()
	{
		if (typeof window === 'undefined') return Promise.reject(new Error('no window'));

		// Already loaded (a previous view kicked it off and it finished).
		if (window.PictSectionExcalidrawVendor) return Promise.resolve();

		// Shared in-flight load.  Stash the promise on window so concurrent
		// view mounts reuse it instead of injecting duplicate <script> tags.
		if (window.__pictExcalidrawLazyLoadPromise)
		{
			return window.__pictExcalidrawLazyLoadPromise;
		}

		let tmpReactURL   = this.options.LazyLoadReactVendorURL;
		let tmpWrapperURL = this.options.LazyLoadWrapperURL;

		let tmpInjectScript = (pUrl) => new Promise((fResolve, fReject) =>
		{
			let tmpScript = document.createElement('script');
			tmpScript.src   = pUrl;
			tmpScript.async = false;
			tmpScript.onload  = () => fResolve();
			tmpScript.onerror = () => fReject(new Error('failed to load ' + pUrl));
			document.head.appendChild(tmpScript);
		});

		let tmpChain = Promise.resolve();
		if (tmpReactURL && !window.React)
		{
			tmpChain = tmpChain.then(() => tmpInjectScript(tmpReactURL));
		}
		tmpChain = tmpChain.then(() => tmpInjectScript(tmpWrapperURL));
		tmpChain = tmpChain.then(() =>
		{
			if (!window.PictSectionExcalidrawVendor)
			{
				throw new Error('wrapper loaded but window.PictSectionExcalidrawVendor was not set');
			}
		}).finally(() =>
		{
			// Clear the in-flight handle whether we succeeded or failed —
			// subsequent retries get a fresh attempt instead of latching on
			// to a rejected promise.
			window.__pictExcalidrawLazyLoadPromise = null;
		});

		window.__pictExcalidrawLazyLoadPromise = tmpChain;
		return tmpChain;
	}

	_buildContainerDOM()
	{
		this.targetElement.innerHTML = '';

		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-excalidraw-wrap pict-excalidraw-wrap-react';

		let tmpMount = document.createElement('div');
		tmpMount.className = 'pict-excalidraw-mount';
		tmpWrap.appendChild(tmpMount);

		let tmpStatus = document.createElement('div');
		tmpStatus.className = 'pict-excalidraw-status';
		tmpStatus.style.display = 'none';
		tmpWrap.appendChild(tmpStatus);

		this.targetElement.appendChild(tmpWrap);

		this._wrapElement   = tmpWrap;
		this._mountElement  = tmpMount;
		this._statusElement = tmpStatus;
	}

	_renderStatus(pMessageHTML, pIsError)
	{
		if (!this._statusElement) return;
		this._statusElement.style.display = 'flex';
		this._statusElement.classList.toggle('error', !!pIsError);
		this._statusElement.innerHTML = pMessageHTML;
	}

	_hideStatus()
	{
		if (!this._statusElement) return;
		this._statusElement.style.display = 'none';
	}

	/**
	 * UIOptions as handed to <Excalidraw>, with our FormFactor override folded in when one is
	 * configured.  Excalidraw deliberately excludes getFormFactor from its props memo, so passing a
	 * fresh function per render is safe.
	 *
	 * @return {Object} The UIOptions object.
	 */
	_buildUIOptions()
	{
		let tmpUIOptions = Object.assign({}, this.options.UIOptions || {});
		if (!tmpUIOptions.getFormFactor)
		{
			let tmpResolver = buildFormFactorResolver(this.options.FormFactor);
			if (tmpResolver) tmpUIOptions.getFormFactor = tmpResolver;
		}
		return tmpUIOptions;
	}

	_mountReact(pVendor)
	{
		let tmpReact     = pVendor.React;
		let tmpReactDOM  = pVendor.ReactDOM;
		let tmpExcalidraw = pVendor.Excalidraw;

		let tmpInitialData = this._resolveInitialData();

		// Resolve theme — 'auto' follows the pict theme provider if present.
		let tmpResolvedTheme = this._resolveTheme(this._currentTheme);

		let tmpProps =
		{
			initialData:     tmpInitialData,
			theme:           tmpResolvedTheme,
			langCode:        this.options.LangCode || 'en',
			viewModeEnabled: !!this.options.ViewModeEnabled,
			zenModeEnabled:  !!this.options.ZenModeEnabled,
			gridModeEnabled: !!this.options.GridModeEnabled,
			UIOptions:       this._buildUIOptions(),
			// NOTE: the public prop in @excalidraw/excalidraw is
			// `onExcalidrawAPI` (despite some older docs / community
			// wrappers referring to `excalidrawAPI`).  See
			// packages/excalidraw/index.tsx — `excalidrawAPI` is just the
			// shape of the mountPayload object passed through the context.
			onExcalidrawAPI: (pApi) =>
			{
				this._excalidrawAPI = pApi;
				// Now that the API exists, we can satisfy any deferred load.
				if (this._pendingDeferredLoad)
				{
					this._pendingDeferredLoad = false;
					this.load();
				}
			},
			onChange: (pElements, pAppState, pFiles) =>
			{
				this._handleChange(pElements, pAppState, pFiles);
			}
		};

		// Set the EXCALIDRAW_ASSET_PATH global if the bundle hasn't already.
		// Excalidraw uses this to locate fonts + locale chunks.
		if (typeof window !== 'undefined' && this.options.AssetBaseURL && !window.EXCALIDRAW_ASSET_PATH)
		{
			window.EXCALIDRAW_ASSET_PATH = this.options.AssetBaseURL;
		}

		try
		{
			this._reactRoot = tmpReactDOM.createRoot(this._mountElement);
			this._reactRoot.render(
				tmpReact.createElement(tmpExcalidraw, tmpProps)
			);
			this._hideStatus();
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw mount failed: ${pErr && pErr.message}`);
			this._renderStatus('Excalidraw failed to mount: <code>' +
				(pErr && pErr.message ? pErr.message : 'unknown error') +
				'</code>', /* isError */ true);
		}
	}

	_resolveInitialData()
	{
		// 1. Explicit InitialData in options wins for the synchronous mount.
		//    OnLoad fires asynchronously and replaces the scene via setScene
		//    once it resolves.
		// 2. DrawingDataAddress in AppData is read synchronously.
		// 3. The default empty scene falls through otherwise.
		if (this.options.DrawingDataAddress)
		{
			let tmpFromAppData = this._readAppData(this.options.DrawingDataAddress);
			if (tmpFromAppData && tmpFromAppData.elements)
			{
				return tmpFromAppData;
			}
		}

		// Defer OnLoad call until after the API resolves.  We don't have a
		// scene to push synchronously here, so use the InitialData fallback.
		if (typeof this.options.OnLoad === 'function')
		{
			this._pendingDeferredLoad = true;
		}

		return this.options.InitialData ||
			{ elements: [], appState: {}, files: {} };
	}

	_resolveTheme(pTheme)
	{
		if (pTheme === 'auto')
		{
			// Try pict-section-theme's mode (if installed).  The theme
			// provider exposes a current mode via either a provider service
			// or as a CSS class on documentElement — both are tolerated.
			if (typeof document !== 'undefined' && document.documentElement)
			{
				let tmpRoot = document.documentElement;
				if (tmpRoot.classList && tmpRoot.classList.contains('theme-mode-dark'))
				{
					return 'dark';
				}
			}
			let tmpThemeProvider = this.pict && this.pict.providers && this.pict.providers.ThemeSection;
			if (tmpThemeProvider && tmpThemeProvider.getCurrentMode)
			{
				let tmpMode = tmpThemeProvider.getCurrentMode();
				if (tmpMode === 'dark') return 'dark';
				if (tmpMode === 'light') return 'light';
			}
			return 'light';
		}
		return (pTheme === 'dark') ? 'dark' : 'light';
	}

	_handleChange(pElements, pAppState, pFiles)
	{
		// Guard: if we've been torn down, drop the change on the floor.
		// React can fire onChange briefly after unmount in dev mode + once
		// or twice in production during the final flush.
		if (this._destroyed) return;

		// Excalidraw fires onChange on every pointer move.  We throttle the
		// downstream callback + AppData write so consumers see a steady,
		// reasonable rate.
		this._lastSeenChangeSnapshot = { elements: pElements, appState: pAppState, files: pFiles };

		if (this._onChangeThrottleHandle) return;

		let tmpDelay = this.options.OnChangeThrottleMs || 250;
		this._onChangeThrottleHandle = setTimeout(() =>
		{
			this._onChangeThrottleHandle = null;
			if (this._destroyed) return;
			let tmpSnap = this._lastSeenChangeSnapshot;
			if (!tmpSnap) return;

			// Write to AppData if bound
			if (this.options.DrawingDataAddress)
			{
				this._writeAppData(this.options.DrawingDataAddress, this._cloneScene(tmpSnap));
			}

			// Notify consumer
			if (typeof this.options.OnChange === 'function')
			{
				try { this.options.OnChange(this, this._cloneScene(tmpSnap)); }
				catch (pErr) { this.log.error(`PICT-Excalidraw OnChange threw: ${pErr && pErr.message}`); }
			}
		}, tmpDelay);
	}

	_cloneScene(pSnap)
	{
		// Excalidraw exposes the live arrays — we shallow-clone the shape so
		// consumers can stash a snapshot without seeing it mutate.
		return {
			elements: pSnap.elements ? pSnap.elements.slice() : [],
			appState: pSnap.appState ? Object.assign({}, pSnap.appState) : {},
			files:    pSnap.files    ? Object.assign({}, pSnap.files)    : {}
		};
	}

	_readAppData(pAddress)
	{
		if (!pAddress) return null;
		try
		{
			// Strip the AppData. prefix so the address is relative to the
			// AppData object that we (or fable.manifest) walk into.  Passing
			// "AppData.Drawing" directly with pict.AppData as base would
			// resolve to pict.AppData.AppData.Drawing, which is wrong.
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.getValueByHash)
			{
				return this.fable.manifest.getValueByHash(this.pict.AppData, tmpRelative);
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length; i++)
			{
				if (tmpCursor == null) return null;
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			return tmpCursor;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw read AppData failed: ${pErr && pErr.message}`);
			return null;
		}
	}

	_writeAppData(pAddress, pValue)
	{
		if (!pAddress) return false;
		try
		{
			let tmpRelative = pAddress.replace(/^AppData\./, '');
			if (this.fable && this.fable.manifest && this.fable.manifest.setValueByHash)
			{
				this.fable.manifest.setValueByHash(this.pict.AppData, tmpRelative, pValue);
				return true;
			}
			let tmpParts = tmpRelative.split('.');
			let tmpCursor = this.pict.AppData;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if (tmpCursor[tmpParts[i]] == null) tmpCursor[tmpParts[i]] = {};
				tmpCursor = tmpCursor[tmpParts[i]];
			}
			tmpCursor[tmpParts[tmpParts.length - 1]] = pValue;
			return true;
		}
		catch (pErr)
		{
			this.log.error(`PICT-Excalidraw write AppData failed: ${pErr && pErr.message}`);
			return false;
		}
	}

	// ---- Public API ---------------------------------------------------------

	/** Return the live Excalidraw imperative API (or null if not yet mounted). */
	getApi()
	{
		return this._excalidrawAPI;
	}

	/** Return the current scene as a plain { elements, appState, files } object. */
	getScene()
	{
		if (!this._excalidrawAPI) return null;
		return {
			elements: this._excalidrawAPI.getSceneElements(),
			appState: this._excalidrawAPI.getAppState(),
			files:    this._excalidrawAPI.getFiles ? this._excalidrawAPI.getFiles() : {}
		};
	}

	/**
	 * Replace the current scene with the supplied data.  Accepts either the
	 * full { elements, appState, files } object or just an elements array.
	 */
	setScene(pSceneData)
	{
		if (!this._excalidrawAPI) return false;
		if (!pSceneData) return false;

		let tmpScene = Array.isArray(pSceneData)
			? { elements: pSceneData, appState: {}, files: {} }
			: pSceneData;

		this._excalidrawAPI.updateScene({
			elements: tmpScene.elements || [],
			appState: tmpScene.appState || {},
			collaborators: new Map()
		});
		if (tmpScene.files && this._excalidrawAPI.addFiles)
		{
			let tmpFilesArr = [];
			let tmpKeys = Object.keys(tmpScene.files);
			for (let i = 0; i < tmpKeys.length; i++) tmpFilesArr.push(tmpScene.files[tmpKeys[i]]);
			if (tmpFilesArr.length) this._excalidrawAPI.addFiles(tmpFilesArr);
		}
		return true;
	}

	/**
	 * Export the current scene as an SVGElement.  Returns a Promise.
	 *
	 * Per-export overrides accept both top-level keys (passed through to
	 * Excalidraw's exportToSvg opts) and the appState-resident export flags
	 * that Excalidraw expects to find on appState (exportEmbedScene,
	 * exportBackground, exportPadding, exportScale, exportWithDarkMode).
	 * We auto-promote the appState ones so callers can write
	 * `view.exportSvg({ exportEmbedScene: true })` without remembering
	 * which key lives where.
	 */
	exportSvg(pOpts)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.exportToSvg) return Promise.reject(new Error('exportToSvg unavailable'));
		let tmpScene = this.getScene();
		if (!tmpScene) return Promise.reject(new Error('Excalidraw not mounted'));
		let tmpOpts = pOpts || {};
		let tmpAppStateOverrides = this._promoteAppStateExportKeys(tmpOpts);
		return tmpVendor.exportToSvg(Object.assign({
			elements: tmpScene.elements,
			appState: Object.assign({}, tmpScene.appState, tmpAppStateOverrides),
			files:    tmpScene.files
		}, tmpOpts));
	}

	/** Export the current scene as a PNG blob.  Returns a Promise. */
	exportBlob(pOpts)
	{
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.exportToBlob) return Promise.reject(new Error('exportToBlob unavailable'));
		let tmpScene = this.getScene();
		if (!tmpScene) return Promise.reject(new Error('Excalidraw not mounted'));
		let tmpOpts = pOpts || {};
		let tmpAppStateOverrides = this._promoteAppStateExportKeys(tmpOpts);
		return tmpVendor.exportToBlob(Object.assign({
			elements: tmpScene.elements,
			appState: Object.assign({}, tmpScene.appState, tmpAppStateOverrides),
			files:    tmpScene.files,
			mimeType: 'image/png'
		}, tmpOpts));
	}

	/**
	 * Pull out the export-control flags that Excalidraw expects on
	 * appState and return them as a separate object.  Mutates the input
	 * to remove the promoted keys (so they don't double-apply at top level).
	 */
	_promoteAppStateExportKeys(pOpts)
	{
		let tmpKeys = [
			'exportEmbedScene', 'exportBackground', 'exportPadding',
			'exportScale', 'exportWithDarkMode'
		];
		let tmpOut = {};
		for (let i = 0; i < tmpKeys.length; i++)
		{
			if (Object.prototype.hasOwnProperty.call(pOpts, tmpKeys[i]))
			{
				tmpOut[tmpKeys[i]] = pOpts[tmpKeys[i]];
				delete pOpts[tmpKeys[i]];
			}
		}
		return tmpOut;
	}

	/**
	 * Convert a mermaid diagram source string into Excalidraw scene elements,
	 * optionally applying them to the live canvas.
	 *
	 * Uses Excalidraw's bundled @excalidraw/mermaid-to-excalidraw +
	 * convertToExcalidrawElements helpers via the wrapper bundle.
	 *
	 * @param {string} pMermaid - Mermaid source (flowchart, sequence, class, …)
	 * @param {object} [pOpts]
	 * @param {boolean} [pOpts.apply=true] - When true, replaces the current scene
	 *                                        with the converted elements via
	 *                                        setScene().  When false, just
	 *                                        returns the elements without
	 *                                        touching the canvas.
	 * @param {object}  [pOpts.mermaidOptions] - Forwarded to parseMermaidToExcalidraw
	 *                                            (e.g. { fontSize: 16 }).
	 * @returns {Promise<{elements: any[], files: object}>}
	 */
	convertMermaidToExcalidraw(pMermaid, pOpts)
	{
		let tmpOpts = pOpts || {};
		let tmpApply = (tmpOpts.apply !== false);
		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.parseMermaidToExcalidraw || !tmpVendor.convertToExcalidrawElements)
		{
			return Promise.reject(new Error('mermaid helpers not available — wrapper bundle out of date?'));
		}
		return tmpVendor.parseMermaidToExcalidraw(pMermaid, tmpOpts.mermaidOptions || {}).then((pParsed) =>
		{
			let tmpSkeleton = (pParsed && pParsed.elements) || [];
			let tmpFiles    = (pParsed && pParsed.files)    || {};
			let tmpElements = tmpVendor.convertToExcalidrawElements(tmpSkeleton);
			if (tmpApply)
			{
				this.setScene({ elements: tmpElements, appState: {}, files: tmpFiles });
			}
			return { elements: tmpElements, files: tmpFiles };
		});
	}

	/** Serialize the current scene as a JSON string compatible with .excalidraw files. */
	serialize()
	{
		let tmpVendor = this._resolveVendor();
		let tmpScene = this.getScene();
		if (!tmpScene) return null;
		if (tmpVendor && tmpVendor.serializeAsJSON)
		{
			return tmpVendor.serializeAsJSON(tmpScene.elements, tmpScene.appState, tmpScene.files, 'local');
		}
		return JSON.stringify({
			type: 'excalidraw',
			version: 2,
			source: 'pict-section-excalidraw',
			elements: tmpScene.elements,
			appState: tmpScene.appState,
			files:    tmpScene.files
		});
	}

	/**
	 * Switch theme.  Accepts 'light', 'dark', or 'auto'.  Re-mounts the React
	 * tree with the new theme prop — Excalidraw doesn't expose a runtime
	 * theme switch on the API.
	 */
	setTheme(pTheme)
	{
		this._currentTheme = pTheme || 'light';
		if (this._excalidrawAPI && this._excalidrawAPI.updateScene)
		{
			let tmpResolved = this._resolveTheme(this._currentTheme);
			this._excalidrawAPI.updateScene({ appState: { theme: tmpResolved } });
		}
	}

	/** Toggle the Excalidraw view-mode flag (read-only). */
	setReadOnly(pReadOnly)
	{
		this.options.ViewModeEnabled = !!pReadOnly;
		if (this._excalidrawAPI && this._excalidrawAPI.updateScene)
		{
			this._excalidrawAPI.updateScene({ appState: { viewModeEnabled: !!pReadOnly } });
		}
	}

	/**
	 * Invoke OnLoad if registered, or read from DrawingDataAddress otherwise,
	 * and apply the result.
	 */
	load()
	{
		if (typeof this.options.OnLoad === 'function')
		{
			this.options.OnLoad(this, (pErr, pSceneData) =>
			{
				if (pErr)
				{
					this.log.error(`PICT-Excalidraw OnLoad error: ${pErr.message || pErr}`);
					return;
				}
				if (pSceneData)
				{
					this.setScene(pSceneData);
				}
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			let tmpScene = this._readAppData(this.options.DrawingDataAddress);
			if (tmpScene) this.setScene(tmpScene);
		}
	}

	/** Invoke OnSave with the current scene, or just write to AppData. */
	save()
	{
		let tmpScene = this.getScene();
		if (!tmpScene) return;
		if (typeof this.options.OnSave === 'function')
		{
			this.options.OnSave(this, tmpScene, (pErr) =>
			{
				if (pErr) this.log.error(`PICT-Excalidraw OnSave error: ${pErr.message || pErr}`);
			});
			return;
		}
		if (this.options.DrawingDataAddress)
		{
			this._writeAppData(this.options.DrawingDataAddress, this._cloneScene(tmpScene));
		}
	}

	/**
	 * Tear down React root + flush pending throttles + clear the destination
	 * DOM.  Idempotent — safe to call twice.  After destroy(), public API
	 * methods that touch DOM/React (getScene, setScene, exportSvg, save,
	 * load, setTheme, setReadOnly) become no-ops via the _destroyed gate.
	 */
	destroy()
	{
		if (this._destroyed) return;
		this._destroyed = true;

		if (this._onChangeThrottleHandle)
		{
			clearTimeout(this._onChangeThrottleHandle);
			this._onChangeThrottleHandle = null;
		}
		this._lastSeenChangeSnapshot = null;
		this._pendingDeferredLoad = false;

		if (this._reactRoot)
		{
			try { this._reactRoot.unmount(); }
			catch (pErr) { this.log.error(`PICT-Excalidraw unmount failed: ${pErr && pErr.message}`); }
			this._reactRoot = null;
		}

		// Clear the destination so a subsequent re-render starts clean.  We
		// own the contents of targetElement from onAfterInitialRender on.
		if (this.targetElement && this.targetElement.innerHTML !== undefined)
		{
			try { this.targetElement.innerHTML = ''; }
			catch (pErr) { /* ignore */ }
		}

		this._excalidrawAPI = null;
		this._wrapElement   = null;
		this._mountElement  = null;
		this._statusElement = null;
		this.targetElement  = false;
		this._vendor        = null;
		this.initialRenderComplete = false;
	}

	/** Whether destroy() has been called. */
	isDestroyed()
	{
		return !!this._destroyed;
	}
}

module.exports = PictViewExcalidrawReact;
module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":580,"../utils/Excalidraw-Form-Factor.js":582,"pict-view":733}],585:[function(require,module,exports){
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  function getDefaults() {
    return {
      async: false,
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      hooks: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }
  exports.defaults = getDefaults();
  function changeDefaults(newDefaults) {
    exports.defaults = newDefaults;
  }

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = new RegExp(escapeTest.source, 'g');
  var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
  var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };
  function escape(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }
    return html;
  }
  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  /**
   * @param {string} html
   */
  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }
  var caret = /(^|[^\[])\^/g;

  /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */
  function edit(regex, opt) {
    regex = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }
  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */
  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      var prot;
      try {
        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }
  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  /**
   * @param {string} base
   * @param {string} href
   */
  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;
    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }
      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }
      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }
  var noopTest = {
    exec: function noopTest() {}
  };
  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
          curr = offset;
        while (--curr >= 0 && str[curr] === '\\') {
          escaped = !escaped;
        }
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/);
    var i = 0;

    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
      cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
      cells.pop();
    }
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) {
        cells.push('');
      }
    }
    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */
  function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }
    return str.slice(0, l - suffLen);
  }
  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var l = str.length;
    var level = 0,
      i = 0;
    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }
  function checkSanitizeDeprecation(opt) {
    if (opt && opt.sanitize && !opt.silent) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
  }

  // copied from https://stackoverflow.com/a/5450113/806777
  /**
   * @param {string} pattern
   * @param {number} count
   */
  function repeatString(pattern, count) {
    if (count < 1) {
      return '';
    }
    var result = '';
    while (count > 1) {
      if (count & 1) {
        result += pattern;
      }
      count >>= 1;
      pattern += pattern;
    }
    return result + pattern;
  }

  function outputLink(cap, link, raw, lexer) {
    var href = link.href;
    var title = link.title ? escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
      lexer.state.inLink = true;
      var token = {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
      };
      lexer.state.inLink = false;
      return token;
    }
    return {
      type: 'image',
      raw: raw,
      href: href,
      title: title,
      text: escape(text)
    };
  }
  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
      return text;
    }
    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }
      var indentInNode = matchIndentInNode[0];
      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }
      return node;
    }).join('\n');
  }

  /**
   * Tokenizer
   */
  var Tokenizer = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Tokenizer.prototype;
    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);
      if (cap && cap[0].length > 0) {
        return {
          type: 'space',
          raw: cap[0]
        };
      }
    };
    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };
    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);
      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
          text: text
        };
      }
    };
    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);
      if (cap) {
        var text = cap[2].trim();

        // remove trailing #s
        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');
          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);
      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };
    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ *>[ \t]?/gm, '');
        var top = this.lexer.state.top;
        this.lexer.state.top = true;
        var tokens = this.lexer.blockTokens(text);
        this.lexer.state.top = top;
        return {
          type: 'blockquote',
          raw: cap[0],
          tokens: tokens,
          text: text
        };
      }
    };
    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);
      if (cap) {
        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
        var bull = cap[1].trim();
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: '',
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        };
        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
        if (this.options.pedantic) {
          bull = isordered ? bull : '[*+-]';
        }

        // Get next list item
        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");

        // Check if current bullet point can start a new List Item
        while (src) {
          endEarly = false;
          if (!(cap = itemRegex.exec(src))) {
            break;
          }
          if (this.rules.block.hr.test(src)) {
            // End list if bullet was actually HR (possibly move into itemRegex?)
            break;
          }
          raw = cap[0];
          src = src.substring(raw.length);
          line = cap[2].split('\n', 1)[0].replace(/^\t+/, function (t) {
            return ' '.repeat(3 * t.length);
          });
          nextLine = src.split('\n', 1)[0];
          if (this.options.pedantic) {
            indent = 2;
            itemContents = line.trimLeft();
          } else {
            indent = cap[2].search(/[^ ]/); // Find first non-space char
            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
            itemContents = line.slice(indent);
            indent += cap[1].length;
          }
          blankLine = false;
          if (!line && /^ *$/.test(nextLine)) {
            // Items begin with at most one blank line
            raw += nextLine + '\n';
            src = src.substring(nextLine.length + 1);
            endEarly = true;
          }
          if (!endEarly) {
            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
            var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
            var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
            var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");

            // Check if following lines should be included in List Item
            while (src) {
              rawLine = src.split('\n', 1)[0];
              nextLine = rawLine;

              // Re-align to follow commonmark nesting rules
              if (this.options.pedantic) {
                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
              }

              // End list item if found code fences
              if (fencesBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new heading
              if (headingBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new bullet
              if (nextBulletRegex.test(nextLine)) {
                break;
              }

              // Horizontal rule found
              if (hrRegex.test(src)) {
                break;
              }
              if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) {
                // Dedent if possible
                itemContents += '\n' + nextLine.slice(indent);
              } else {
                // not enough indentation
                if (blankLine) {
                  break;
                }

                // paragraph continuation unless last line was a different block level element
                if (line.search(/[^ ]/) >= 4) {
                  // indented code block
                  break;
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(line)) {
                  break;
                }
                itemContents += '\n' + nextLine;
              }
              if (!blankLine && !nextLine.trim()) {
                // Check if current line is blank
                blankLine = true;
              }
              raw += rawLine + '\n';
              src = src.substring(rawLine.length + 1);
              line = nextLine.slice(indent);
            }
          }
          if (!list.loose) {
            // If the previous item ended with a blank line, the list is loose
            if (endsWithBlankLine) {
              list.loose = true;
            } else if (/\n *\n *$/.test(raw)) {
              endsWithBlankLine = true;
            }
          }

          // Check for task list items
          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.exec(itemContents);
            if (istask) {
              ischecked = istask[0] !== '[ ] ';
              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
            }
          }
          list.items.push({
            type: 'list_item',
            raw: raw,
            task: !!istask,
            checked: ischecked,
            loose: false,
            text: itemContents
          });
          list.raw += raw;
        }

        // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
        list.items[list.items.length - 1].raw = raw.trimRight();
        list.items[list.items.length - 1].text = itemContents.trimRight();
        list.raw = list.raw.trimRight();
        var l = list.items.length;

        // Item child tokens handled here at end because we needed to have the final item to trim it first
        for (i = 0; i < l; i++) {
          this.lexer.state.top = false;
          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
          if (!list.loose) {
            // Check if list should be loose
            var spacers = list.items[i].tokens.filter(function (t) {
              return t.type === 'space';
            });
            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function (t) {
              return /\n.*\n/.test(t.raw);
            });
            list.loose = hasMultipleLineBreaks;
          }
        }

        // Set all items to loose if list is loose
        if (list.loose) {
          for (i = 0; i < l; i++) {
            list.items[i].loose = true;
          }
        }
        return list;
      }
    };
    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);
      if (cap) {
        var token = {
          type: 'html',
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        };
        if (this.options.sanitize) {
          var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
          token.type = 'paragraph';
          token.text = text;
          token.tokens = this.lexer.inline(text);
        }
        return token;
      }
    };
    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);
      if (cap) {
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
        var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: href,
          title: title
        };
      }
    };
    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);
      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1]).map(function (c) {
            return {
              text: c
            };
          }),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
        };
        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i, j, k, row;
          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }
          l = item.rows.length;
          for (i = 0; i < l; i++) {
            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
              return {
                text: c
              };
            });
          }

          // parse child tokens inside headers and cells

          // header child tokens
          l = item.header.length;
          for (j = 0; j < l; j++) {
            item.header[j].tokens = this.lexer.inline(item.header[j].text);
          }

          // cell child tokens
          l = item.rows.length;
          for (j = 0; j < l; j++) {
            row = item.rows[j];
            for (k = 0; k < row.length; k++) {
              row[k].tokens = this.lexer.inline(row[k].text);
            }
          }
          return item;
        }
      }
    };
    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);
      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1],
          tokens: this.lexer.inline(cap[1])
        };
      }
    };
    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);
      if (cap) {
        var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
        return {
          type: 'paragraph',
          raw: cap[0],
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);
      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0],
          tokens: this.lexer.inline(cap[0])
        };
      }
    };
    _proto.escape = function escape$1(src) {
      var cap = this.rules.inline.escape.exec(src);
      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: escape(cap[1])
        };
      }
    };
    _proto.tag = function tag(src) {
      var cap = this.rules.inline.tag.exec(src);
      if (cap) {
        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
          this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
          this.lexer.state.inLink = false;
        }
        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = true;
        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = false;
        }
        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        };
      }
    };
    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);
      if (cap) {
        var trimmedUrl = cap[2].trim();
        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          }

          // ending angle bracket cannot be escaped
          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');
          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }
        var href = cap[2];
        var title = '';
        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim();
        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }
        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0], this.lexer);
      }
    };
    _proto.reflink = function reflink(src, links) {
      var cap;
      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];
        if (!link) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }
        return outputLink(cap, link, cap[0], this.lexer);
      }
    };
    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }
      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return;

      // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
      var nextChar = match[1] || match[2] || '';
      if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
        var lLength = match[0].length - 1;
        var rDelim,
          rLength,
          delimTotal = lLength,
          midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0;

        // Clip maskedSrc to same section of string as src (move to lexer?)
        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;
          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters

          // Remove extra characters. *a*** -> *a*
          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
          var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);

          // Create `em` if smallest delimiter has odd char count. *a***
          if (Math.min(lLength, rLength) % 2) {
            var _text = raw.slice(1, -1);
            return {
              type: 'em',
              raw: raw,
              text: _text,
              tokens: this.lexer.inlineTokens(_text)
            };
          }

          // Create 'strong' if smallest delimiter has even char count. **a***
          var text = raw.slice(2, -2);
          return {
            type: 'strong',
            raw: raw,
            text: text,
            tokens: this.lexer.inlineTokens(text)
          };
        }
      }
    };
    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);
      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }
        text = escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };
    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);
      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };
    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);
      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2],
          tokens: this.lexer.inlineTokens(cap[2])
        };
      }
    };
    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);
      if (cap) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.url = function url(src, mangle) {
      var cap;
      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
          } else {
            href = cap[0];
          }
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.inlineText = function inlineText(src, smartypants) {
      var cap = this.rules.inline.text.exec(src);
      if (cap) {
        var text;
        if (this.lexer.state.inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        } else {
          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }
        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };
    return Tokenizer;
  }();

  /**
   * Block-Level Grammar
   */
  var block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = _extends({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = _extends({}, block.normal, {
    table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
  });

  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = _extends({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Inline-Level Grammar
   */
  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
      //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
      rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
      rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
    },

    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
  };

  // list of punctuation marks from CommonMark spec
  // without * and _ to handle the different emphasis markers * and _
  inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
  inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

  // sequences em should skip over [title](link), `code`, <html>
  inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
  // lookbehind is not available on Safari as of version 16
  // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
  inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
  inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = _extends({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = _extends({}, inline.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = _extends({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = _extends({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * smartypants text replacement
   * @param {string} text
   */
  function smartypants(text) {
    return text
    // em-dashes
    .replace(/---/g, "\u2014")
    // en-dashes
    .replace(/--/g, "\u2013")
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")
    // closing singles & apostrophes
    .replace(/'/g, "\u2019")
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")
    // closing doubles
    .replace(/"/g, "\u201D")
    // ellipses
    .replace(/\.{3}/g, "\u2026");
  }

  /**
   * mangle email addresses
   * @param {string} text
   */
  function mangle(text) {
    var out = '',
      i,
      ch;
    var l = text.length;
    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }
    return out;
  }

  /**
   * Block Lexer
   */
  var Lexer = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || exports.defaults;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      this.tokenizer.lexer = this;
      this.inlineQueue = [];
      this.state = {
        inLink: false,
        inRawBlock: false,
        top: true
      };
      var rules = {
        block: block.normal,
        inline: inline.normal
      };
      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;
        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }
      this.tokenizer.rules = rules;
    }

    /**
     * Expose Rules
     */
    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }

    /**
     * Static Lex Inline Method
     */;
    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }

    /**
     * Preprocessing
     */;
    var _proto = Lexer.prototype;
    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n');
      this.blockTokens(src, this.tokens);
      var next;
      while (next = this.inlineQueue.shift()) {
        this.inlineTokens(next.src, next.tokens);
      }
      return this.tokens;
    }

    /**
     * Lexing
     */;
    _proto.blockTokens = function blockTokens(src, tokens) {
      var _this = this;
      if (tokens === void 0) {
        tokens = [];
      }
      if (this.options.pedantic) {
        src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
      } else {
        src = src.replace(/^( *)(\t+)/gm, function (_, leading, tabs) {
          return leading + '    '.repeat(tabs.length);
        });
      }
      var token, lastToken, cutSrc, lastParagraphClipped;
      while (src) {
        if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // newline
        if (token = this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);
          if (token.raw.length === 1 && tokens.length > 0) {
            // if there's a single \n as a spacer, it's terminating the last line,
            // so move it there so that we don't get unecessary paragraph tags
            tokens[tokens.length - 1].raw += '\n';
          } else {
            tokens.push(token);
          }
          continue;
        }

        // code
        if (token = this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          // An indented code block cannot interrupt a paragraph.
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // fences
        if (token = this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // heading
        if (token = this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // hr
        if (token = this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // blockquote
        if (token = this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // list
        if (token = this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // html
        if (token = this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // def
        if (token = this.tokenizer.def(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.raw;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else if (!this.tokens.links[token.tag]) {
            this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }
          continue;
        }

        // table (gfm)
        if (token = this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // lheading
        if (token = this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startBlock) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this.options.extensions.startBlock.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];
          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          continue;
        }

        // text
        if (token = this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      this.state.top = true;
      return tokens;
    };
    _proto.inline = function inline(src, tokens) {
      if (tokens === void 0) {
        tokens = [];
      }
      this.inlineQueue.push({
        src: src,
        tokens: tokens
      });
      return tokens;
    }

    /**
     * Lexing/Compiling
     */;
    _proto.inlineTokens = function inlineTokens(src, tokens) {
      var _this2 = this;
      if (tokens === void 0) {
        tokens = [];
      }
      var token, lastToken, cutSrc;

      // String with links masked to avoid interference with em and strong
      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar;

      // Mask out reflinks
      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);
        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      }
      // Mask out other blocks
      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      }

      // Mask out escaped em & strong delimiters
      while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
      }
      while (src) {
        if (!keepPrevChar) {
          prevChar = '';
        }
        keepPrevChar = false;

        // extensions
        if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this2
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // escape
        if (token = this.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // tag
        if (token = this.tokenizer.tag(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // link
        if (token = this.tokenizer.link(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // reflink, nolink
        if (token = this.tokenizer.reflink(src, this.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // em & strong
        if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // code
        if (token = this.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // br
        if (token = this.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // del (gfm)
        if (token = this.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // autolink
        if (token = this.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // url (gfm)
        if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startInline) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this2.options.extensions.startInline.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
          src = src.substring(token.raw.length);
          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }
          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      return tokens;
    };
    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);
    return Lexer;
  }();

  /**
   * Renderer
   */
  var Renderer = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Renderer.prototype;
    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];
      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);
        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }
      _code = _code.replace(/\n$/, '') + '\n';
      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
      }
      return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
    }

    /**
     * @param {string} quote
     */;
    _proto.blockquote = function blockquote(quote) {
      return "<blockquote>\n" + quote + "</blockquote>\n";
    };
    _proto.html = function html(_html) {
      return _html;
    }

    /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */;
    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        var id = this.options.headerPrefix + slugger.slug(raw);
        return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
      }

      // ignore IDs
      return "<h" + level + ">" + text + "</h" + level + ">\n";
    };
    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }

    /**
     * @param {string} text
     */;
    _proto.listitem = function listitem(text) {
      return "<li>" + text + "</li>\n";
    };
    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    }

    /**
     * @param {string} text
     */;
    _proto.paragraph = function paragraph(text) {
      return "<p>" + text + "</p>\n";
    }

    /**
     * @param {string} header
     * @param {string} body
     */;
    _proto.table = function table(header, body) {
      if (body) body = "<tbody>" + body + "</tbody>";
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    }

    /**
     * @param {string} content
     */;
    _proto.tablerow = function tablerow(content) {
      return "<tr>\n" + content + "</tr>\n";
    };
    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
      return tag + content + ("</" + type + ">\n");
    }

    /**
     * span level renderer
     * @param {string} text
     */;
    _proto.strong = function strong(text) {
      return "<strong>" + text + "</strong>";
    }

    /**
     * @param {string} text
     */;
    _proto.em = function em(text) {
      return "<em>" + text + "</em>";
    }

    /**
     * @param {string} text
     */;
    _proto.codespan = function codespan(text) {
      return "<code>" + text + "</code>";
    };
    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    }

    /**
     * @param {string} text
     */;
    _proto.del = function del(text) {
      return "<del>" + text + "</del>";
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = '<a href="' + href + '"';
      if (title) {
        out += ' title="' + title + '"';
      }
      out += '>' + text + '</a>';
      return out;
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
      if (title) {
        out += " title=\"" + title + "\"";
      }
      out += this.options.xhtml ? '/>' : '>';
      return out;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */
  var TextRenderer = /*#__PURE__*/function () {
    function TextRenderer() {}
    var _proto = TextRenderer.prototype;
    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };
    _proto.em = function em(text) {
      return text;
    };
    _proto.codespan = function codespan(text) {
      return text;
    };
    _proto.del = function del(text) {
      return text;
    };
    _proto.html = function html(text) {
      return text;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    _proto.link = function link(href, title, text) {
      return '' + text;
    };
    _proto.image = function image(href, title, text) {
      return '' + text;
    };
    _proto.br = function br() {
      return '';
    };
    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */
  var Slugger = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    /**
     * @param {string} value
     */
    var _proto = Slugger.prototype;
    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }

    /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */;
    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;
      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];
        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }
      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }
      return slug;
    }

    /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */;
    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }
      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };
    return Slugger;
  }();

  /**
   * Parsing & Compiling
   */
  var Parser = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || exports.defaults;
      this.options.renderer = this.options.renderer || new Renderer();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer();
      this.slugger = new Slugger();
    }

    /**
     * Static Parse Method
     */
    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }

    /**
     * Static Parse Inline Method
     */;
    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }

    /**
     * Parse Loop
     */;
    var _proto = Parser.prototype;
    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }
      var out = '',
        i,
        j,
        k,
        l2,
        l3,
        row,
        cell,
        header,
        body,
        token,
        ordered,
        start,
        loose,
        itemBody,
        item,
        checked,
        task,
        checkbox,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'space':
            {
              continue;
            }
          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }
          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
          case 'table':
            {
              header = '';

              // header
              cell = '';
              l2 = token.header.length;
              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                  header: true,
                  align: token.align[j]
                });
              }
              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.rows.length;
              for (j = 0; j < l2; j++) {
                row = token.rows[j];
                cell = '';
                l3 = row.length;
                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                    header: false,
                    align: token.align[k]
                  });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';
              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
          case 'html':
            {
              // TODO parse inline content if parameter markdown=1
              out += this.renderer.html(token.text);
              continue;
            }
          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    }

    /**
     * Parse Inline Tokens
     */;
    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
        i,
        token,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }
          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }
          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }
          case 'br':
            {
              out += renderer.br();
              break;
            }
          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    };
    return Parser;
  }();

  var Hooks = /*#__PURE__*/function () {
    function Hooks(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Hooks.prototype;
    /**
     * Process markdown before marked
     */
    _proto.preprocess = function preprocess(markdown) {
      return markdown;
    }

    /**
     * Process HTML after marked is finished
     */;
    _proto.postprocess = function postprocess(html) {
      return html;
    };
    return Hooks;
  }();
  Hooks.passThroughHooks = new Set(['preprocess', 'postprocess']);

  function onError(silent, async, callback) {
    return function (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if (silent) {
        var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
        if (async) {
          return Promise.resolve(msg);
        }
        if (callback) {
          callback(null, msg);
          return;
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      if (callback) {
        callback(e);
        return;
      }
      throw e;
    };
  }
  function parseMarkdown(lexer, parser) {
    return function (src, opt, callback) {
      if (typeof opt === 'function') {
        callback = opt;
        opt = null;
      }
      var origOpt = _extends({}, opt);
      opt = _extends({}, marked.defaults, origOpt);
      var throwError = onError(opt.silent, opt.async, callback);

      // throw error in case of non string input
      if (typeof src === 'undefined' || src === null) {
        return throwError(new Error('marked(): input parameter is undefined or null'));
      }
      if (typeof src !== 'string') {
        return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
      }
      checkSanitizeDeprecation(opt);
      if (opt.hooks) {
        opt.hooks.options = opt;
      }
      if (callback) {
        var highlight = opt.highlight;
        var tokens;
        try {
          if (opt.hooks) {
            src = opt.hooks.preprocess(src);
          }
          tokens = lexer(src, opt);
        } catch (e) {
          return throwError(e);
        }
        var done = function done(err) {
          var out;
          if (!err) {
            try {
              if (opt.walkTokens) {
                marked.walkTokens(tokens, opt.walkTokens);
              }
              out = parser(tokens, opt);
              if (opt.hooks) {
                out = opt.hooks.postprocess(out);
              }
            } catch (e) {
              err = e;
            }
          }
          opt.highlight = highlight;
          return err ? throwError(err) : callback(null, out);
        };
        if (!highlight || highlight.length < 3) {
          return done();
        }
        delete opt.highlight;
        if (!tokens.length) return done();
        var pending = 0;
        marked.walkTokens(tokens, function (token) {
          if (token.type === 'code') {
            pending++;
            setTimeout(function () {
              highlight(token.text, token.lang, function (err, code) {
                if (err) {
                  return done(err);
                }
                if (code != null && code !== token.text) {
                  token.text = code;
                  token.escaped = true;
                }
                pending--;
                if (pending === 0) {
                  done();
                }
              });
            }, 0);
          }
        });
        if (pending === 0) {
          done();
        }
        return;
      }
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function (src) {
          return lexer(src, opt);
        }).then(function (tokens) {
          return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function () {
            return tokens;
          }) : tokens;
        }).then(function (tokens) {
          return parser(tokens, opt);
        }).then(function (html) {
          return opt.hooks ? opt.hooks.postprocess(html) : html;
        })["catch"](throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        var _tokens = lexer(src, opt);
        if (opt.walkTokens) {
          marked.walkTokens(_tokens, opt.walkTokens);
        }
        var html = parser(_tokens, opt);
        if (opt.hooks) {
          html = opt.hooks.postprocess(html);
        }
        return html;
      } catch (e) {
        return throwError(e);
      }
    };
  }

  /**
   * Marked
   */
  function marked(src, opt, callback) {
    return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    marked.defaults = _extends({}, marked.defaults, opt);
    changeDefaults(marked.defaults);
    return marked;
  };
  marked.getDefaults = getDefaults;
  marked.defaults = exports.defaults;

  /**
   * Use Extension
   */

  marked.use = function () {
    var extensions = marked.defaults.extensions || {
      renderers: {},
      childTokens: {}
    };
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    args.forEach(function (pack) {
      // copy options to new object
      var opts = _extends({}, pack);

      // set async to true if it was set to true before
      opts.async = marked.defaults.async || opts.async || false;

      // ==-- Parse "addon" extensions --== //
      if (pack.extensions) {
        pack.extensions.forEach(function (ext) {
          if (!ext.name) {
            throw new Error('extension name required');
          }
          if (ext.renderer) {
            // Renderer extensions
            var prevRenderer = extensions.renderers[ext.name];
            if (prevRenderer) {
              // Replace extension with func to run new extension but fall back if false
              extensions.renderers[ext.name] = function () {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }
                var ret = ext.renderer.apply(this, args);
                if (ret === false) {
                  ret = prevRenderer.apply(this, args);
                }
                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }
          if (ext.tokenizer) {
            // Tokenizer Extensions
            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
              throw new Error("extension level must be 'block' or 'inline'");
            }
            if (extensions[ext.level]) {
              extensions[ext.level].unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }
            if (ext.start) {
              // Function to check for start of token
              if (ext.level === 'block') {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === 'inline') {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }
          if (ext.childTokens) {
            // Child tokens to be visited by walkTokens
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
        opts.extensions = extensions;
      }

      // ==-- Parse "overwrite" extensions --== //
      if (pack.renderer) {
        (function () {
          var renderer = marked.defaults.renderer || new Renderer();
          var _loop = function _loop(prop) {
            var prevRenderer = renderer[prop];
            // Replace renderer with func to run extension, but fall back if false
            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var ret = pack.renderer[prop].apply(renderer, args);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.renderer) {
            _loop(prop);
          }
          opts.renderer = renderer;
        })();
      }
      if (pack.tokenizer) {
        (function () {
          var tokenizer = marked.defaults.tokenizer || new Tokenizer();
          var _loop2 = function _loop2(prop) {
            var prevTokenizer = tokenizer[prop];
            // Replace tokenizer with func to run extension, but fall back if false
            tokenizer[prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              var ret = pack.tokenizer[prop].apply(tokenizer, args);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.tokenizer) {
            _loop2(prop);
          }
          opts.tokenizer = tokenizer;
        })();
      }

      // ==-- Parse Hooks extensions --== //
      if (pack.hooks) {
        (function () {
          var hooks = marked.defaults.hooks || new Hooks();
          var _loop3 = function _loop3(prop) {
            var prevHook = hooks[prop];
            if (Hooks.passThroughHooks.has(prop)) {
              hooks[prop] = function (arg) {
                if (marked.defaults.async) {
                  return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function (ret) {
                    return prevHook.call(hooks, ret);
                  });
                }
                var ret = pack.hooks[prop].call(hooks, arg);
                return prevHook.call(hooks, ret);
              };
            } else {
              hooks[prop] = function () {
                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                var ret = pack.hooks[prop].apply(hooks, args);
                if (ret === false) {
                  ret = prevHook.apply(hooks, args);
                }
                return ret;
              };
            }
          };
          for (var prop in pack.hooks) {
            _loop3(prop);
          }
          opts.hooks = hooks;
        })();
      }

      // ==-- Parse WalkTokens extensions --== //
      if (pack.walkTokens) {
        var _walkTokens = marked.defaults.walkTokens;
        opts.walkTokens = function (token) {
          var values = [];
          values.push(pack.walkTokens.call(this, token));
          if (_walkTokens) {
            values = values.concat(_walkTokens.call(this, token));
          }
          return values;
        };
      }
      marked.setOptions(opts);
    });
  };

  /**
   * Run callback for every token
   */

  marked.walkTokens = function (tokens, callback) {
    var values = [];
    var _loop4 = function _loop4() {
      var token = _step.value;
      values = values.concat(callback.call(marked, token));
      switch (token.type) {
        case 'table':
          {
            for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
              var cell = _step2.value;
              values = values.concat(marked.walkTokens(cell.tokens, callback));
            }
            for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
              var row = _step3.value;
              for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                var _cell = _step4.value;
                values = values.concat(marked.walkTokens(_cell.tokens, callback));
              }
            }
            break;
          }
        case 'list':
          {
            values = values.concat(marked.walkTokens(token.items, callback));
            break;
          }
        default:
          {
            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
              // Walk any extensions
              marked.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                values = values.concat(marked.walkTokens(token[childTokens], callback));
              });
            } else if (token.tokens) {
              values = values.concat(marked.walkTokens(token.tokens, callback));
            }
          }
      }
    };
    for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
      _loop4();
    }
    return values;
  };

  /**
   * Parse Inline
   * @param {string} src
   */
  marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);

  /**
   * Expose
   */
  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.Hooks = Hooks;
  marked.parse = marked;
  var options = marked.options;
  var setOptions = marked.setOptions;
  var use = marked.use;
  var walkTokens = marked.walkTokens;
  var parseInline = marked.parseInline;
  var parse = marked;
  var parser = Parser.parse;
  var lexer = Lexer.lex;

  exports.Hooks = Hooks;
  exports.Lexer = Lexer;
  exports.Parser = Parser;
  exports.Renderer = Renderer;
  exports.Slugger = Slugger;
  exports.TextRenderer = TextRenderer;
  exports.Tokenizer = Tokenizer;
  exports.getDefaults = getDefaults;
  exports.lexer = lexer;
  exports.marked = marked;
  exports.options = options;
  exports.parse = parse;
  exports.parseInline = parseInline;
  exports.parser = parser;
  exports.setOptions = setOptions;
  exports.use = use;
  exports.walkTokens = walkTokens;

}));

},{}],586:[function(require,module,exports){
module.exports={
    "name": "pict-section-form",
    "version": "1.4.4",
    "description": "Pict dynamic forms",
    "main": "source/Pict-Section-Form.js",
    "directories": {
        "test": "test"
    },
    "repository": {
        "type": "git",
        "url": "git+https://github.com/fable-retold/pict-section-form.git"
    },
    "bugs": {
        "url": "https://github.com/fable-retold/pict-section-form/issues"
    },
    "homepage": "https://github.com/fable-retold/pict-section-form#readme",
    "scripts": {
        "start": "node source/Pict-Section-Form.js",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "test": "npx quack test",
        "test:injection": "node test/browser/Injection-Conformance-Harness-Runner.js",
        "lint": "eslint source/**",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p ./tsconfig.json --noEmit",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-section-form-image:local",
        "docker-dev-run": "docker run -it -d --name pict-section-form-dev -p 48888:8080 -p 49999:9999 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-section-form\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-section-form-image:local",
        "docker-dev-shell": "docker exec -it pict-section-form-dev /bin/bash"
    },
    "types": "types/source/Pict-Section-Form.d.ts",
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "devDependencies": {
        "@eslint/js": "^9.39.2",
        "@types/chai": "^4.3.20",
        "@types/mocha": "^10.0.10",
        "@types/node": "^22.19.21",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.2",
        "jquery": "^4.0.0",
        "pict": "^1.0.401",
        "pict-application": "^1.0.34",
        "pict-docuserve": "^1.4.19",
        "pict-service-commandlineutility": "^1.0.20",
        "quackage": "^1.3.0",
        "tui-grid": "^4.21.22",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "chart.js": "^4.5.1",
        "fable-serviceproviderbase": "^3.0.19",
        "marked": "^4.3.0",
        "pict-provider": "^1.0.13",
        "pict-section-excalidraw": "^1.0.6",
        "pict-section-markdowneditor": "^1.0.21",
        "pict-section-objecteditor": "^1.0.3",
        "pict-section-tuigrid": "^1.0.32",
        "pict-template": "^1.0.15",
        "pict-view": "^1.0.68"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],587:[function(require,module,exports){
// The container for all the Pict-Section-Form related code.

// The main dynamic view class
module.exports = require('./views/Pict-View-DynamicForm.js');
//module.exports.default_configuration = require('./views/Pict-View-DynamicForm-DefaultConfiguration.json');

// The dynamic application dependencies
module.exports.PictDynamicFormDependencyManager = require('./services/Pict-Service-DynamicFormDependencyManager.js');

// The base provider class for form section templates; meant to be subclassed
module.exports.PictFormTemplateProvider = require('./providers/Pict-Provider-DynamicTemplates.js');

// The base provider class for Input Extensions
module.exports.PictInputExtensionProvider = require('./providers/Pict-Provider-InputExtension.js');

// The metacontroller view
module.exports.PictFormMetacontroller = require('./views/Pict-View-Form-Metacontroller.js');

// The application container
module.exports.PictFormApplication = require('./application/Pict-Application-Form.js');

// The dynamic layout provider
module.exports.PictDynamicLayoutProvider = require('./providers/Pict-Provider-DynamicLayout.js');

// The ManifestFactory, for when we want to convert tabular data to configuration
module.exports.ManifestFactory = require('./services/ManifestFactory.js');
module.exports.ManifestConversionToCSV = require('./services/ManifestConversionToCSV.js');

// Reveal the support base class
module.exports.PictFormSupportBase = require('./views/support/Pict-View-PSF-SupportBase.js');

// The optional form persistence provider for offline data storage
module.exports.PictFormPersistenceProvider = require('./providers/Pict-Provider-FormPersistence.js');


// The extension views
module.exports.ExtensionViews = (
	{
		LifecycleVisualization: require('./views/support/Pict-View-PSF-LifeCycle-Visualization.js'),
		DebugViewer: require('./views/support/Pict-View-PSF-DebugViewer.js')
	});

// Complex InputTypes — heavy editor deps (markdowneditor, excalidraw) are
// lazy-required by the providers themselves on first setMode('edit'). The
// require below is just for the provider class; nothing heavy loads here.
module.exports.RichTextInput = require('./providers/inputs/Pict-Provider-Input-RichText.js');
module.exports.DiagramInput  = require('./providers/inputs/Pict-Provider-Input-Diagram.js');

// SVG palette → theme-CSS-variable rewriter. Re-exported so consumers can
// theme stored SVGs without needing pict-section-excalidraw.
module.exports.themeifySVG = require('./providers/inputs/util/Themeify-SVG.js').themeifySVG;
},{"./application/Pict-Application-Form.js":588,"./providers/Pict-Provider-DynamicLayout.js":592,"./providers/Pict-Provider-DynamicTemplates.js":596,"./providers/Pict-Provider-FormPersistence.js":597,"./providers/Pict-Provider-InputExtension.js":599,"./providers/inputs/Pict-Provider-Input-Diagram.js":611,"./providers/inputs/Pict-Provider-Input-RichText.js":620,"./providers/inputs/util/Themeify-SVG.js":627,"./services/ManifestConversionToCSV.js":636,"./services/ManifestFactory.js":637,"./services/Pict-Service-DynamicFormDependencyManager.js":638,"./views/Pict-View-DynamicForm.js":653,"./views/Pict-View-Form-Metacontroller.js":654,"./views/support/Pict-View-PSF-DebugViewer.js":657,"./views/support/Pict-View-PSF-LifeCycle-Visualization.js":658,"./views/support/Pict-View-PSF-SupportBase.js":661}],588:[function(require,module,exports){
const libPictApplication = require('pict-application');

const libPictSectionForm = require('../Pict-Section-Form.js');

/**
 * Represents a PictSectionFormApplication.
 *
 * This is the automagic controller for a dyncamic form application.
 *
 * @class
 * @extends libPictApplication
 */
class PictSectionFormApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & import('fable')} */
		this.pict;
		// Add the pict form service
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);

		// Add the pict form metacontroller service, which provides programmaatic view construction from manifests and render/marshal methods.
		this.pict.addView('PictFormMetacontroller', {}, libPictSectionForm.PictFormMetacontroller);
	}

	/**
	 * Marshals data from any rendered dynamic views to application data.
	 */
	marshalDataFromDynamicViewsToAppData()
	{
		this.pict.views.PictFormMetacontroller.marshalFromView();
	}

	/**
	 * Marshals data from the application data to any rendered dynamic views.
	 */
	marshalDataFromAppDataToDynamicViews()
	{
		this.pict.views.PictFormMetacontroller.marshalToView();
	}
};

module.exports = PictSectionFormApplication

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"Name": "A Simple Pict Forms Application",
	"Hash": "PictFormsApp",

	"MainViewportViewIdentifier": "PictFormMetacontroller",
	"AutoSolveAfterInitialize": false,

	"pict_configuration":
		{
			"Product": "PictDefaultFormsApp"
		}
});

},{"../Pict-Section-Form.js":587,"pict-application":545}],589:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// TODO: Pull this back to pict as a core service once we are happy with the shape.
/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-SolverBehaviors",

	"AutoInitialize": false,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

/**
 * Provides functions available in the solver for manipulating the form.
 * Such as showing/hiding sections, inputs, groups.  Coloring inputs,
 * sections, groups.  Applying styles to inputs, sections, groups.
 * Extends the `libPictProvider` class.
 */
class PictDynamicFormsSolverBehaviors extends libPictProvider
{
	/**
	 * Creates an instance of the `PictDynamicFormsInformary` class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { newManyfest: (options: any) => import('manyfest') }} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideSectionClass = 'pict-section-form-hidden-section';
		this.cssHideGroupClass = 'pict-section-form-hidden-group';

		// #SECTION-<formID> and #GROUP-<formID>-<hash> are both emitted by the section template, so a
		// render() regenerates them without the hide class and the hide silently reverts. Record what
		// was asked for so reapplySectionVisibility can restore it after a render.
		/** @type {Record<string, boolean>} */
		this.sectionVisibilityState = {};
		/** @type {Record<string, boolean>} */
		this.groupVisibilityState = {};

		// Same story for every solver that decorates the DOM -- highlight classes and inline background
		// colors all land on markup the section template regenerates. Keyed by what the decoration
		// targets so re-applying one overwrites rather than accumulating.
		/** @type {Record<string, {Section: string, Method: string, Arguments: Array<any>}>} */
		this.decorationState = {};
		/** @type {boolean} */
		this.decorationReplayInProgress = false;
		/** @type {string} */
		this.cssTabularRowHighlightClass = 'pict-tabular-row-highlight';
		/** @type {string} */
		this.cssTabularColumnHighlightClass = 'pict-tabular-column-highlight';
		this.cssSnippet = '.pict-section-form-hidden-section { display: none; } .pict-section-form-hidden-group { display: none; }'
			// Row/column highlight classes used by the highlighttabularrow / highlighttabularcolumn solvers.
			// !important so the highlight beats host table-striping CSS; the color solvers set
			// inline-important styles which in turn beat these (inline-important > stylesheet-important).
			+ ' .pict-tabular-row-highlight > td, .pict-tabular-row-highlight > th { background-color: var(--pict-tabular-highlight-color, #FFF3CD) !important; }'
			+ ' td.pict-tabular-column-highlight, th.pict-tabular-column-highlight { background-color: var(--pict-tabular-highlight-color, #FFF3CD) !important; }';

		this.solverOrdinalMap = {};
		// An injected copy gating an ordinal must not gate the same ordinal in a sibling copy, so a gate set
		// while solving a copy is recorded against that copy. A gate set by the form itself stays global,
		// which is what a form that gates its own ordinals has always relied on.
		/** @type {Record<string, Record<string, boolean>>} */
		this.scopedSolverOrdinalMap = {};
		/** @type {string} */
		this.activeSolverScope = '';

		this.setCSSSnippets();
	}

	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;
		this.pict.CSSMap.addCSS('Pict-Section-Form-SolverBehaviors', this.cssSnippet, 1001, 'Pict-DynamicForm-SolverBehaviors');
		this.pict.CSSMap.injectCSS();
	}

	addSolverFunction(pExpressionParser, pFunctionName, pFunctionAddress, pFunctionComment, pAddressParameterIndices)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		if (pExpressionParser.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`PictDynamicFormsInformary: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		let tmpFunctionEntry = (
		{
			Name: pFunctionComment || `Autogenerated function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});
		if (Array.isArray(pAddressParameterIndices) && pAddressParameterIndices.length > 0)
		{
			tmpFunctionEntry.AddressParameterIndices = pAddressParameterIndices;
		}
		pExpressionParser.functionMap[tmpFunctionName] = tmpFunctionEntry;
	}

	runSolvers()
	{
		const tmpViewHashes = this.pict.providers.DynamicSolver.solveViews(undefined, true);
		/* TODO: since this is always run from a solve, I don't think we need to do an extra marshal here
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			for (let i = 0; i < tmpViewHashes.length; i++)
			{
				const tmpViewHash = tmpViewHashes[i];
				this.pict.views[tmpViewHash]?.marshalToView?.();
			}
		}
		*/
	}

	injectBehaviors(pExpressionParser)
	{
		// Wire up the solver functions.
		this.addSolverFunction(pExpressionParser, 'logvalues', 'fable.providers.DynamicFormSolverBehaviors.logValues', 'Logs a set of values to the console and returns the last one.');

		this.addSolverFunction(pExpressionParser, 'unionarrays', 'fable.providers.DynamicFormSolverBehaviors.unionArrays', 'Return the union of two arrays.');
		this.addSolverFunction(pExpressionParser, 'differencearrays', 'fable.providers.DynamicFormSolverBehaviors.differenceArrays', 'Return the difference of two arrays.');
		this.addSolverFunction(pExpressionParser, 'uniquearray', 'fable.providers.DynamicFormSolverBehaviors.uniqueArray', 'Return a new array with only unique values from the input array.');
		this.addSolverFunction(pExpressionParser, 'sortarray', 'fable.providers.DynamicFormSolverBehaviors.sortArray', 'Returns a sorted array from the input array.');

		this.addSolverFunction(pExpressionParser, 'showsections', 'fable.providers.DynamicFormSolverBehaviors.showSections', 'Shows sections based on hashes in an array.', [0]);
		this.addSolverFunction(pExpressionParser, 'hidesections', 'fable.providers.DynamicFormSolverBehaviors.hideSections', 'Hides sections based on hashes in an array.', [0]);

		this.addSolverFunction(pExpressionParser, 'setsectionvisibility', 'fable.providers.DynamicFormSolverBehaviors.setSectionVisibility', 'Sets a sections visiblity to true or fales based on the second parameter.', [0]);
		this.addSolverFunction(pExpressionParser, 'setgroupvisibility', 'fable.providers.DynamicFormSolverBehaviors.setGroupVisibility', 'Sets a group visiblity to true or fales based on the third parameter.', [0, 1]);

		this.addSolverFunction(pExpressionParser, 'generatehtmlhexcolor', 'fable.providers.DynamicFormSolverBehaviors.generateHTMLHexColor', 'Generates a HTML hex color from three integer parameters (red, green, blue).');

		this.addSolverFunction(pExpressionParser, 'colorsectionbackground', 'fable.providers.DynamicFormSolverBehaviors.colorSectionBackground', 'Colors a section background with a HTML hex color (e.g. #FF0000 for red).', [0]);
		this.addSolverFunction(pExpressionParser, 'colorgroupbackground', 'fable.providers.DynamicFormSolverBehaviors.colorGroupBackground', 'Colors a group background with a HTML hex color (e.g. #FF0000 for red).', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colorinputbackground', 'fable.providers.DynamicFormSolverBehaviors.colorInputBackground', 'Colors an input background with a HTML hex color (e.g. #FF0000 for red).', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colorinputbackgroundtabular', 'fable.providers.DynamicFormSolverBehaviors.colorInputBackgroundTabular', 'Colors a tabular input background with a HTML hex color (e.g. #FF0000 for red).', [0, 1, 2]);

		// Whole-row and whole-column highlight/color for tabular groups. The highlight pair toggles a
		// CSS class across every cell of a row/column based on a 1/0 flag; the color pair sets (1) or
		// clears (0) an inline background color. None of these touch form data -- purely presentational.
		this.addSolverFunction(pExpressionParser, 'highlighttabularrow', 'fable.providers.DynamicFormSolverBehaviors.highlightTabularRow', 'Adds (1) or removes (0) a highlight class on every cell of a tabular row.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'highlighttabularcolumn', 'fable.providers.DynamicFormSolverBehaviors.highlightTabularColumn', 'Adds (1) or removes (0) a highlight class on every cell of a tabular column.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colortabularrow', 'fable.providers.DynamicFormSolverBehaviors.colorTabularRow', 'Sets (1) or clears (0) the background color on every cell of a tabular row.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colortabularcolumn', 'fable.providers.DynamicFormSolverBehaviors.colorTabularColumn', 'Sets (1) or clears (0) the background color on every cell of a tabular column.', [0, 1]);

		this.addSolverFunction(pExpressionParser, 'setsolverordinalenabled', 'fable.providers.DynamicFormSolverBehaviors.setSolverOrdinalEnabled', 'Enables or disabled a solver ordinal to determine if it should run.');
		this.addSolverFunction(pExpressionParser, 'enablesolverordinal', 'fable.providers.DynamicFormSolverBehaviors.enableSolverOrdinal', 'Enables a solver ordinal so that it can run.');
		this.addSolverFunction(pExpressionParser, 'disablesolverordinall', 'fable.providers.DynamicFormSolverBehaviors.disableSolverOrdinal', 'Disables a solver ordinal so that it will not run.');

		this.addSolverFunction(pExpressionParser, 'settabularrowlength', 'fable.providers.DynamicFormSolverBehaviors.setTabularRowLength', 'Sets the length of a tabular data set.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'runsolvers', 'fable.providers.DynamicFormSolverBehaviors.runSolvers', 'Solves all views.');
		this.addSolverFunction(pExpressionParser, 'refreshtabularsection', 'fable.providers.DynamicFormSolverBehaviors.refreshTabularSection', 'Causes a tabular section to refresh its display.', [0, 1]);

		// Scope data access functions for cross-section and global data resolution
		this.addSolverFunction(pExpressionParser, 'getglobalformdata', 'fable.providers.DynamicFormSolverBehaviors.getGlobalFormData', 'Gets a value from the global form data by hash.');
		this.addSolverFunction(pExpressionParser, 'resolveglobalformdata', 'fable.providers.DynamicFormSolverBehaviors.resolveGlobalFormData', 'Resolves a value from the global form data by manyfest address.');
		this.addSolverFunction(pExpressionParser, 'getsectionformdata', 'fable.providers.DynamicFormSolverBehaviors.getSectionFormData', 'Gets a value from a specific section by hash or address.', [0]);
		this.addSolverFunction(pExpressionParser, 'getsectiontabularformdata', 'fable.providers.DynamicFormSolverBehaviors.getSectionTabularFormData', 'Gets a value from a specific tabular section row by hash or address.', [0, 1]);

		// Comprehension generation -- writes a single Property/Value into the configured comprehension destination
		// nested as Context -> Entity -> GUID -> Property.  Context is treated as a manyfest address so dotted
		// contexts like "OnApprovalAction.Approve" produce nested context branches.  See docs/Comprehensions.md.
		this.addSolverFunction(pExpressionParser, 'addcomprehensionentity', 'fable.providers.DynamicFormSolverBehaviors.addComprehensionEntity', 'Writes a property/value into the configured comprehension destination, nested as Context -> Entity -> GUID -> Property.');

		return false;
	}

	// TODO: These array functions probably belong in fable as core utilities; move them back later
	/**
	 * Returns a new array containing the union of two input arrays, removing duplicate values.
	 *
	 * @param {Array} pArrayA - The first array to union.
	 * @param {Array} pArrayB - The second array to union.
	 * @returns {Array} A new array containing unique elements from both input arrays.
	 */
	unionArrays(pArrayA, pArrayB)
	{
		let tmpSet = new Set();

		if (Array.isArray(pArrayA))
		{
			for (let i = 0; i < pArrayA.length; i++)
			{
				tmpSet.add(pArrayA[i]);
			}
		}

		if (Array.isArray(pArrayB))
		{
			for (let i = 0; i < pArrayB.length; i++)
			{
				tmpSet.add(pArrayB[i]);
			}
		}

		return Array.from(tmpSet);
	}

	/**
	 * Returns an array containing the elements that are present in the first array but not in the second array.
	 *
	 * @param {Array} pArrayA - The array from which to subtract elements.
	 * @param {Array} pArrayB - The array containing elements to exclude from the first array.
	 * @returns {Array} An array of elements found in pArrayA but not in pArrayB.
	 */
	differenceArrays(pArrayA, pArrayB)
	{
		let tmpSetA = new Set();
		let tmpSetB = new Set();

		if (Array.isArray(pArrayA))
		{
			for (let i = 0; i < pArrayA.length; i++)
			{
				tmpSetA.add(pArrayA[i]);
			}
		}

		if (Array.isArray(pArrayB))
		{
			for (let i = 0; i < pArrayB.length; i++)
			{
				tmpSetB.add(pArrayB[i]);
			}
		}

		let tmpResultSet = new Set();

		tmpSetA.forEach(
			(pValue) =>
			{
				if (!tmpSetB.has(pValue))
				{
					tmpResultSet.add(pValue);
				}
			}
		);

		return Array.from(tmpResultSet);
	}

	/**
	 * Returns a new array containing only the unique elements from the input array.
	 *
	 * @param {Array} pArray - The array from which to extract unique elements.
	 * @returns {Array} A new array with duplicate values removed.
	 */
	uniqueArray(pArray)
	{
		let tmpSet = new Set();

		if (Array.isArray(pArray))
		{
			for (let i = 0; i < pArray.length; i++)
			{
				tmpSet.add(pArray[i]);
			}
		}

		return Array.from(tmpSet);
	}

	/**
	 * Sorts the given array in place using the default sort order.
	 * If the input is not an array, returns an empty array.
	 *
	 * @param {Array} pArray - The array to be sorted.
	 * @returns {Array} The sorted array, or an empty array if input is not an array.
	 */
	sortArray(pArray)
	{
		if (!Array.isArray(pArray))
		{
			return [];
		}

		return pArray.sort();
	}

	/**
	 * The copy a view belongs to: the salt createDistinctManifest appended to its section hash, or an empty
	 * string for a section the form declares itself.
	 *
	 * @param {any} pView - A dynamic form view.
	 *
	 * @return {string} The scope gates set while solving that view are recorded against.
	 */
	getViewSolverScope(pView)
	{
		const tmpSection = pView ? pView.sectionDefinition : undefined;
		if (!tmpSection || !tmpSection.OriginalHash || !tmpSection.Hash || (tmpSection.Hash === tmpSection.OriginalHash))
		{
			return '';
		}
		return tmpSection.Hash.substring(tmpSection.OriginalHash.length + 1);
	}

	/**
	 * Records which copy's solvers are running, so a gate one of them sets lands on that copy.
	 *
	 * @param {string} pScope - A scope from getViewSolverScope.
	 *
	 * @return {string} The scope that was active before, to restore afterwards.
	 */
	setActiveSolverScope(pScope)
	{
		const tmpPreviousScope = this.activeSolverScope;
		this.activeSolverScope = pScope || '';
		return tmpPreviousScope;
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 * @param {boolean} pEnabled
	 */
	writeSolverOrdinalGate(pSolverOrdinal, pEnabled)
	{
		const tmpOrdinalKey = `ORD-${pSolverOrdinal}`;
		if (!this.activeSolverScope)
		{
			this.solverOrdinalMap[tmpOrdinalKey] = pEnabled;
			return;
		}
		if (!this.scopedSolverOrdinalMap[this.activeSolverScope])
		{
			this.scopedSolverOrdinalMap[this.activeSolverScope] = {};
		}
		this.scopedSolverOrdinalMap[this.activeSolverScope][tmpOrdinalKey] = pEnabled;
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 * @param {boolean|string|number} pEnabled
	 */
	setSolverOrdinalEnabled(pSolverOrdinal, pEnabled)
	{
		this.writeSolverOrdinalGate(pSolverOrdinal, pEnabled == true || pEnabled == '1');
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 */
	enableSolverOrdinal(pSolverOrdinal)
	{
		this.writeSolverOrdinalGate(pSolverOrdinal, true);
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 */
	disableSolverOrdinal(pSolverOrdinal)
	{
		this.writeSolverOrdinalGate(pSolverOrdinal, false);
	}

	/**
	 * @param {number|string} pSolveOrdinal
	 * @param {string} [pScope] - The copy being solved; without one only the form's own gates apply.
	 *
	 * @return {boolean}
	 */
	checkSolverOrdinalEnabled(pSolveOrdinal, pScope)
	{
		let tmpOrdinalKey = `ORD-${pSolveOrdinal}`;
		if ((tmpOrdinalKey in this.solverOrdinalMap) && (this.solverOrdinalMap[tmpOrdinalKey] !== true))
		{
			return false;
		}
		const tmpScopedGates = pScope ? this.scopedSolverOrdinalMap[pScope] : undefined;
		if (tmpScopedGates && (tmpOrdinalKey in tmpScopedGates) && (tmpScopedGates[tmpOrdinalKey] !== true))
		{
			return false;
		}
		return true;
	}

	getSectionSelector(pSectionFormID)
	{
		return `#SECTION-${pSectionFormID}`;
	}

	setSectionVisibility(pSectionHash, pVisible)
	{
		if (pVisible != "0")
		{
			return this.showSection(pSectionHash);
		}
		else
		{
			return this.hideSection(pSectionHash);
		}
	}

	/**
	 * Shows multiple sections by their hash identifiers.
	 *
	 * Iterates over the provided array of section hash values and calls `showSection`
	 * for each one to display the corresponding section.
	 *
	 * @param {string | Array<string>} pSectionHashArray - An array of section hash strings to be shown.
	 */
	showSections(pSectionHashArray)
	{
		const tmpSectionHashArray = Array.isArray(pSectionHashArray) ? pSectionHashArray : [pSectionHashArray];
		for (let i = 0; i < tmpSectionHashArray.length; i++)
		{
			this.showSection(tmpSectionHashArray[i]);
		}
	}

	/**
	 * Hides multiple sections specified by their hash values.
	 *
	 * Iterates over the provided array of section hashes and hides each section
	 * by calling the `hideSection` method for each hash.
	 *
	 * @param {string | Array<string>} pSectionHashArray - An array of section hash strings to be hidden.
	 */
	hideSections(pSectionHashArray)
	{
		const tmpSectionHashArray = Array.isArray(pSectionHashArray) ? pSectionHashArray : [pSectionHashArray];
		for (let i = 0; i < tmpSectionHashArray.length; i++)
		{
			this.hideSection(tmpSectionHashArray[i]);
		}
	}

	/* THESE DO NOT BELONG HERE BUT THIS WORKS FOR NOW */
	hideSection(pSectionHash)
	{
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: hideSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		// Record BEFORE the DOM guard below: the guard short-circuits when the DOM already matches, and
		// the state map has to stay accurate even then so a later render can restore it.
		this.sectionVisibilityState[pSectionHash] = false;

		if (this.pict.ContentAssignment.hasClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass))
		{
			// Already hidden.
			return true;
		}

		this.pict.ContentAssignment.addClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass);
		return true;
	}

	showSection(pSectionHash)
	{
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: showSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		this.sectionVisibilityState[pSectionHash] = true;

		if (!this.pict.ContentAssignment.hasClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass))
		{
			// Already visible.
			return true;
		}

		this.pict.ContentAssignment.removeClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass);
		return true;
	}

	getGroupSelector(pSectionFormID, pGroupHash)
	{
		return `#GROUP-${pSectionFormID}-${pGroupHash}`;
	}

	setGroupVisibility(pSectionHash, pGroupHash, pVisible)
	{
		if (pVisible != "0")
		{
			return this.showGroup(pSectionHash, pGroupHash);
		}
		else
		{
			return this.hideGroup(pSectionHash, pGroupHash);
		}
	}

	hideGroup(pSectionHash, pGroupHash)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: hideGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		this.groupVisibilityState[this.getGroupVisibilityStateKey(pSectionHash, pGroupHash)] = false;

		if (this.pict.ContentAssignment.hasClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass))
		{
			// Already hidden.
			return true;
		}

		this.pict.ContentAssignment.addClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass);
		return true;
	}

	showGroup(pSectionHash, pGroupHash)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		this.groupVisibilityState[this.getGroupVisibilityStateKey(pSectionHash, pGroupHash)] = true;

		if (!this.pict.ContentAssignment.hasClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass))
		{
			// Already visible.
			return true;
		}

		this.pict.ContentAssignment.removeClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass);
		return true;
	}

	/**
	 * @param {string} pSectionHash
	 * @param {string} pGroupHash
	 *
	 * @return {string} - The groupVisibilityState key for a section/group pair.
	 */
	getGroupVisibilityStateKey(pSectionHash, pGroupHash)
	{
		return `${pSectionHash}::${pGroupHash}`;
	}

	/**
	 * Re-apply a section's recorded visibility (and that of its groups) after a render regenerated its DOM.
	 *
	 * Every render path -- DynamicColumns rebuild, dependent-view rebuild, row add/delete/move, the
	 * group-scoped swap in renderGroupInPlace -- repaints those elements with only their manifest
	 * CSSClass, and solvers run BEFORE the marshal that triggers them, so nothing else puts the hide
	 * back. Called from the view's onAfterRender so one restore covers them all. A section with no
	 * recorded state is left as the template rendered it.
	 *
	 * @param {string} pSectionHash - The section that was just rendered.
	 *
	 * @return {void}
	 */
	reapplySectionVisibility(pSectionHash)
	{
		if (typeof pSectionHash !== 'string' || pSectionHash.length < 1)
		{
			return;
		}

		if (pSectionHash in this.sectionVisibilityState)
		{
			this.setSectionVisibility(pSectionHash, this.sectionVisibilityState[pSectionHash] ? 1 : 0);
		}

		const tmpGroupKeyPrefix = `${pSectionHash}::`;
		const tmpGroupKeys = Object.keys(this.groupVisibilityState);
		for (let i = 0; i < tmpGroupKeys.length; i++)
		{
			if (tmpGroupKeys[i].indexOf(tmpGroupKeyPrefix) !== 0)
			{
				continue;
			}
			const tmpGroupHash = tmpGroupKeys[i].substring(tmpGroupKeyPrefix.length);
			this.setGroupVisibility(pSectionHash, tmpGroupHash, this.groupVisibilityState[tmpGroupKeys[i]] ? 1 : 0);
		}
	}

	/**
	 * Remember a DOM decoration a solver just applied so it can be replayed after a render.
	 *
	 * @param {string} pSectionHash - The section the decoration targets.
	 * @param {string} pKey - Stable identity for what is decorated; a repeat overwrites it.
	 * @param {string} pMethod - The method on this provider that applies it.
	 * @param {Array<any>} pArguments - The arguments to replay it with.
	 *
	 * @return {void}
	 */
	recordDecoration(pSectionHash, pKey, pMethod, pArguments)
	{
		if (this.decorationReplayInProgress)
		{
			return;
		}
		this.decorationState[`${pSectionHash}::${pKey}`] = { Section: pSectionHash, Method: pMethod, Arguments: pArguments };
	}

	/**
	 * Replay every decoration recorded against a section after a render repainted its markup.
	 *
	 * Highlight classes and inline colors live on rows, cells and containers that the section
	 * template regenerates, exactly like the hide classes. Replay is idempotent: each entry is
	 * keyed by its target, and a recorded "remove" simply re-runs a removal against fresh markup.
	 *
	 * @param {string} pSectionHash - The section that was just rendered.
	 *
	 * @return {void}
	 */
	reapplySectionDecorations(pSectionHash)
	{
		if (typeof pSectionHash !== 'string' || pSectionHash.length < 1)
		{
			return;
		}

		const tmpKeys = Object.keys(this.decorationState);
		this.decorationReplayInProgress = true;
		try
		{
			for (let i = 0; i < tmpKeys.length; i++)
			{
				const tmpEntry = this.decorationState[tmpKeys[i]];
				if (!tmpEntry || (tmpEntry.Section !== pSectionHash) || (typeof this[tmpEntry.Method] !== 'function'))
				{
					continue;
				}
				this[tmpEntry.Method].apply(this, tmpEntry.Arguments);
			}
		}
		finally
		{
			this.decorationReplayInProgress = false;
		}
	}

	/**
	 * Restore everything a solver put on this section's DOM that a render just wiped -- visibility
	 * first, then decorations. This is what the section view calls from its own onAfterRender.
	 *
	 * @param {string} pSectionHash - The section that was just rendered.
	 *
	 * @return {void}
	 */
	reapplySectionDOMState(pSectionHash)
	{
		this.reapplySectionVisibility(pSectionHash);
		this.reapplySectionDecorations(pSectionHash);
	}

	/**
	 * Re-render a single group in place, leaving the rest of the section's DOM untouched.
	 *
	 * The section template is one string (wrap/section prefixes + every group's
	 * generateGroupLayoutTemplate + postfixes), so a normal render rebuilds all of it.
	 * This regenerates just the requested group's slice and swaps that one element.
	 *
	 * Init is then run the normal way (the view's own post-render pass) rather than being
	 * hand-scoped: input providers guard their own re-initialization (a select2 picker
	 * checks for an existing instance before creating one), so untouched groups no-op and
	 * only the freshly-rendered group actually initializes.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The section view.
	 * @param {string} pGroupHash - The group to re-render.
	 * @return {boolean} - True if the group was rendered in place; false to fall back to a full render.
	 */
	renderGroupInPlace(pView, pGroupHash)
	{
		try
		{
			if (!pView || !pView.formID || (typeof pView.getGroupIndexFromHash !== 'function'))
			{
				return false;
			}
			const tmpGroupIndex = pView.getGroupIndexFromHash(pGroupHash);
			if (tmpGroupIndex < 0)
			{
				return false;
			}
			const tmpGroup = pView.getGroup(tmpGroupIndex);
			const tmpGenerator = this.pict.providers.MetatemplateGenerator;
			if (!tmpGroup || !tmpGenerator || (typeof tmpGenerator.getGroupLayoutProvider !== 'function'))
			{
				return false;
			}
			const tmpLayout = tmpGenerator.getGroupLayoutProvider(pView, tmpGroup);
			if (!tmpLayout || (typeof tmpLayout.generateGroupLayoutTemplate !== 'function'))
			{
				return false;
			}
			const tmpElements = this.pict.ContentAssignment.getElement(`#GROUP-${pView.formID}-${tmpGroup.Hash}`);
			const tmpElement = (tmpElements && tmpElements.length) ? tmpElements[0] : null;
			if (!tmpElement || (typeof tmpElement.outerHTML !== 'string'))
			{
				return false;
			}

			// Same parse shape the view uses for the whole section: the view is Context[0],
			// which the group templates reference for formID/UUID/Hash.
			const tmpTemplateHash = `Pict-Form-Template-Group-InPlace-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;
			this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpLayout.generateGroupLayoutTemplate(pView, tmpGroup));
			const tmpRecordAddress = pView.options.DefaultTemplateRecordAddress;
			const tmpRecord = (typeof tmpRecordAddress === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
			const tmpContent = this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, [ pView ]);
			if (typeof tmpContent !== 'string' || !tmpContent.length)
			{
				return false;
			}

			tmpElement.outerHTML = tmpContent;
			pView.onAfterRender({ RenderableHash: `GroupInPlace-${tmpGroup.Hash}` });
			return true;
		}
		catch (pError)
		{
			this.log.warn(`renderGroupInPlace failed for group [${pGroupHash}]; falling back to a full section render: ${pError.message || pError}`);
			return false;
		}
	}

	/**
	 * Causes a tabular section to refresh its display
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group
	 * @param {string} pGroupHash - The hash of the tabular group
	 *
	 * @return {void}
	 */
	refreshTabularSection(pSectionHash, pGroupHash)
	{
		const tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return;
		}
		const tmpGroupIndex = tmpGroupView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return;
		}
		const tmpGroup = tmpGroupView.getGroup(tmpGroupIndex);

		if (tmpGroup)
		{
			// Also render any other views that have this as the RecordSetAddress
			// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
			const tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
				/** @param {import('../views/Pict-View-DynamicForm.js')} pViewToTestForGroup */
				(pViewToTestForGroup) =>
				{
					if (!pViewToTestForGroup.isPictSectionForm)
					{
						return false;
					}
					const tmpGroupsToTest = pViewToTestForGroup.getGroups();
					for (let i = 0; i < tmpGroupsToTest.length; i++)
					{
						if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
						{
							return true;
						}
					}
					return false;
				}
			)
			// We expect this view to be in the set.
			for (let i = 0; i < tmpViewsToRender.length; i++)
			{
				// Re-render ONLY the group that actually changed when we can. A full
				// section render replaces every group's DOM, which destroys any widget
				// the user is mid-interaction with (select2 pickers blank for ~700ms) and
				// drops layout state. Falls back to the full render when the group-scoped
				// path is not possible, so behaviour is unchanged for anything it cannot handle.
				if (!this.renderGroupInPlace(tmpViewsToRender[i], pGroupHash))
				{
					tmpViewsToRender[i].render();
				}
			}

			//NOTE: not running a solve, since this is run from the solver; if you need a solve, call runSolvers()

			// We've re-rendered but we don't know what needs to be marshaled
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
	}

	/**
	 * Set the length of a tabular set
	 * @param {string} pSectionHash - The hash of the section containing the tabular group
	 * @param {string} pGroupHash - The hash of the tabular group
	 * @param {number|string} pLength - The desired length of the tabular set
	 * @param {boolean|string} pDeleteExtraRows - If true, will delete extra rows from the end if the length is less than current 
	 * @returns 
	 */
	setTabularRowLength(pSectionHash, pGroupHash, pLength, pDeleteExtraRows = false)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}
		let tmpGroupIndex = tmpGroupView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}
		let tmpTabularRecordSet = tmpGroupView.getTabularRecordSet(tmpGroupIndex);
		if (!tmpTabularRecordSet || !Array.isArray(tmpTabularRecordSet))
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find a valid tabular record set with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		let tmpLength = parseInt(pLength.toString());
		if (isNaN(tmpLength) || tmpLength < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength was given an invalid length [${pLength}] with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		// See if the length is less than what we have
		let tmpCurrentLength = tmpTabularRecordSet.length;

		let tmpDeleteExtraRows = (pDeleteExtraRows == true || pDeleteExtraRows == '1');

		if (tmpLength > tmpCurrentLength)
		{
			// Add rows until we are at the expected length
			for (let i = tmpCurrentLength; i < tmpLength; i++)
			{
				tmpGroupView.createDynamicTableRow(tmpGroupIndex);
			}
		}
		else if (tmpLength < tmpCurrentLength && tmpDeleteExtraRows)
		{
			// Remove rows from the end until we are at the expected length
			for (let i = tmpCurrentLength - 1; i >= tmpLength; i--)
			{
				tmpGroupView.deleteDynamicTableRow(tmpGroupIndex, i);
			}
		}
	}


	generateHTMLHexColor(pRed, pGreen, pBlue)
	{
		let tmpRed = (parseInt(pRed) || 0);
		let tmpGreen = (parseInt(pGreen) || 0);
		let tmpBlue = (parseInt(pBlue) || 0);

		if (tmpRed < 0) { tmpRed = 0; }
		if (tmpRed > 255) { tmpRed = 255; }
		if (tmpGreen < 0) { tmpGreen = 0; }
		if (tmpGreen > 255) { tmpGreen = 255; }
		if (tmpBlue < 0) { tmpBlue = 0; }
		if (tmpBlue > 255) { tmpBlue = 255; }

		let tmpRedHex = tmpRed.toString(16).toUpperCase();
		if (tmpRedHex.length < 2) { tmpRedHex = `0${tmpRedHex}`; }
		let tmpGreenHex = tmpGreen.toString(16).toUpperCase();
		if (tmpGreenHex.length < 2) { tmpGreenHex = `0${tmpGreenHex}`; }
		let tmpBlueHex = tmpBlue.toString(16).toUpperCase();
		if (tmpBlueHex.length < 2) { tmpBlueHex = `0${tmpBlueHex}`; }

		return `#${tmpRedHex}${tmpGreenHex}${tmpBlueHex}`;
	}

	colorSectionBackground(pSectionHash, pColor, pApplyChange)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, 'sectionbackground', 'colorSectionBackground', [ pSectionHash, pColor, pApplyChange ]);

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(this.getSectionSelector(tmpSectionView.formID));

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorSection could not find section element with hash [${pSectionHash}] selector [${this.getSectionSelector(tmpSectionView.formID)}].`);
			return false;
		}

		let tmpElement = tmpElementSet[0];

		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	colorGroupBackground(pSectionHash, pGroupHash, pColor, pApplyChange)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, `${pGroupHash}::groupbackground`, 'colorGroupBackground', [ pSectionHash, pGroupHash, pColor, pApplyChange ]);

		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(this.getGroupSelector(tmpGroupView.formID, pGroupHash));

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorGroup could not find group element with section hash [${pSectionHash}] group [${pGroupHash}] selector [${this.getGroupSelector(tmpGroupView.formID, pGroupHash)}].`);
			return false;
		}

		let tmpElement = tmpElementSet[0];
		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	/**
	 * Colors an input background or its container with a HTML hex color (e.g. #FF0000 for red).
	 * @param {string} pSectionHash - The hash of the section containing the input.
	 * @param {string} pInputHash - The hash of the input to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} pApplyChange - If "0", the change will not be applied.
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 * @returns {boolean} - Returns true if the color was applied successfully or if the change was skipped for pApplyChange equal to "0", false otherwise.
	 */
	colorInputBackground(pSectionHash, pInputHash, pColor, pApplyChange, pCSSSelector)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, `input::${pInputHash}`, 'colorInputBackground', [ pSectionHash, pInputHash, pColor, pApplyChange, pCSSSelector ]);

		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		let tmpInputView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);

		if (!tmpInputView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input with section hash [${pSectionHash}] input [${pInputHash}].`);
			return false;
		}

		let tmpInput = tmpInputView.getInputFromHash(pInputHash);

		if (!tmpInput)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input with section hash [${pSectionHash}] input [${pInputHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(tmpInput.Macro.HTMLSelectorControl);

		if (tmpElementSet.length < 1)
		{
			tmpElementSet = this.pict.ContentAssignment.getElement(`#${tmpInput.Macro.RawHTMLID}`);
		}

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input element with section hash [${pSectionHash}] input [${pInputHash}] selector [#${tmpInput.Macro.RawHTMLID}].`);
			return false;
		}

		return this.colorElementBackground(tmpElementSet, pColor, pCSSSelector);
	}

	/**
	 * Colors an input background or its container with a HTML hex color (e.g. #FF0000 for red).
	 * @param {string} pSectionHash - The hash of the section containing the input.
	 * @param {string} pGroupHash - The hash of the group containing the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pInputHash - The hash of the input to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} pApplyChange - If "0", the change will not be applied.
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 * @param {string} [pElementIDPrefix] - Optional. The prefix for the tabular element ID. Default is 'TABULAR-DATA-'.
	 * @returns {boolean} - Returns true if the color was applied successfully or if the change was skipped for pApplyChange equal to "0", false otherwise.
	 */
	colorInputBackgroundTabular(pSectionHash, pGroupHash, pInputHash, pRowIndex, pColor, pApplyChange, pCSSSelector, pElementIDPrefix = 'TABULAR-DATA-')
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		this.recordDecoration(pSectionHash, `${pGroupHash}::inputcell::${pInputHash}::${pRowIndex}`, 'colorInputBackgroundTabular',
			[ pSectionHash, pGroupHash, pInputHash, pRowIndex, pColor, pApplyChange, pCSSSelector, pElementIDPrefix ]);

		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		let tmpInputView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);

		if (!tmpInputView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}].`);
			return false;
		}

		let tmpInput = tmpInputView.getTabularRecordInputByHash(pGroupHash, pInputHash);

		if (!tmpInput)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}].`);
			return false;
		}

		if (!tmpInput.Macro)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}] is missing Macro data.`);
			return false;
		}

		//FIXME: how do we get the input decorated with the index?
		const tmpControlHTMLSelector = tmpInput.Macro.HTMLSelectorControlTabular + `[data-i-index="${pRowIndex}"]`;
		let tmpElementSet = this.pict.ContentAssignment.getElement(tmpControlHTMLSelector);

		if (tmpElementSet.length < 1)
		{
			//FIXME: is this reliable for all input types? (no)
			tmpElementSet = this.pict.ContentAssignment.getElement(`#${pElementIDPrefix}${tmpInput.Macro.RawHTMLID}-${pRowIndex}`);
		}

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input element with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}] row index [${pRowIndex}] selector [#${tmpInput.Macro.RawHTMLID}-${pRowIndex}].`);
			return false;
		}

		return this.colorElementBackground(tmpElementSet, pColor, pCSSSelector);
	}

	/**
	 * @param {Array<HTMLElement>} pElementSet - The element to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 *
	 * @returns {boolean}
	 */
	colorElementBackground(pElementSet, pColor, pCSSSelector)
	{
		/** @type {HTMLElement} */
		let tmpElement = pElementSet[0];

		// if we passed a class target, find the closest element with that class and apply the color to it
		// otherwise, just apply it to the input element itself
		if (pCSSSelector)
		{
			// find closest target by class name and if we find it, immediately break out of the loop
			for (let i = 0; i < pElementSet.length; i++)
			{
				const element = pElementSet[i];
				const closest = element.closest(`${pCSSSelector}`);
				if (closest && closest instanceof HTMLElement)
				{
					tmpElement = closest;
					break;
				}
			}
		}

		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	/**
	 * Interprets a solver-supplied 1/0 (or true/false) flag.
	 *
	 * Solver numbers arrive as arbitrary-precision strings, so a plain truthiness
	 * check would treat the string "0" as true. This normalizes the common
	 * "off" representations to false and everything else to true.
	 *
	 * @param {any} pFlag
	 * @returns {boolean}
	 */
	isSolverFlagEnabled(pFlag)
	{
		return (pFlag != null)
			&& (pFlag !== false)
			&& (pFlag !== 0)
			&& (pFlag !== '0')
			&& (pFlag !== '')
			&& (pFlag !== 'false');
	}

	/**
	 * Resolves the DOM selector for a tabular group's container div.
	 *
	 * The tabular group div carries `id="GROUP-<formID>-<groupHash>"` (the same
	 * convention the non-tabular group layout uses), so highlight/color solvers
	 * can scope their cell queries to a single group.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @returns {string|null} A CSS selector for the group container, or null if unresolved.
	 */
	getTabularGroupSelector(pSectionHash, pGroupHash)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('PictDynamicFormsSolverBehaviors: getTabularGroupSelector has no PictFormMetacontroller.');
			return null;
		}
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsSolverBehaviors: getTabularGroupSelector could not find section view with hash [${pSectionHash}].`);
			return null;
		}
		return `#GROUP-${tmpSectionView.formID}-${pGroupHash}`;
	}

	/**
	 * Adds (pApplyFlag truthy) or removes (pApplyFlag falsy) a highlight class on
	 * every cell of a tabular row -- the row labels, editing controls and data
	 * cells all get the class because it lands on the row's `<tr>`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The zero-based row index.
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- add or remove the class.
	 * @param {string} [pHighlightClass] - Optional override for the class name.
	 * @returns {boolean}
	 */
	highlightTabularRow(pSectionHash, pGroupHash, pRowIndex, pApplyFlag, pHighlightClass)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpClass = (typeof pHighlightClass === 'string' && pHighlightClass.length > 0) ? pHighlightClass : this.cssTabularRowHighlightClass;
		this.recordDecoration(pSectionHash, `${pGroupHash}::row::${pRowIndex}::${tmpClass}`, 'highlightTabularRow',
			[ pSectionHash, pGroupHash, pRowIndex, pApplyFlag, pHighlightClass ]);
		let tmpRowSelector = `${tmpGroupSelector} tr[data-tabular-row-index="${pRowIndex}"]`;
		if (this.isSolverFlagEnabled(pApplyFlag))
		{
			this.pict.ContentAssignment.addClass(tmpRowSelector, tmpClass);
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpRowSelector, tmpClass);
		}
		return true;
	}

	/**
	 * Adds (pApplyFlag truthy) or removes (pApplyFlag falsy) a highlight class on
	 * every cell of a tabular column -- both the `<th>` header cell and every
	 * `<td>` data cell that carries the matching `data-tabular-column-index`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pColumnIndex - The column's input index (descriptor InputIndex).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- add or remove the class.
	 * @param {string} [pHighlightClass] - Optional override for the class name.
	 * @returns {boolean}
	 */
	highlightTabularColumn(pSectionHash, pGroupHash, pColumnIndex, pApplyFlag, pHighlightClass)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpClass = (typeof pHighlightClass === 'string' && pHighlightClass.length > 0) ? pHighlightClass : this.cssTabularColumnHighlightClass;
		this.recordDecoration(pSectionHash, `${pGroupHash}::column::${pColumnIndex}::${tmpClass}`, 'highlightTabularColumn',
			[ pSectionHash, pGroupHash, pColumnIndex, pApplyFlag, pHighlightClass ]);
		let tmpColumnSelector = `${tmpGroupSelector} [data-tabular-column-index="${pColumnIndex}"]`;
		if (this.isSolverFlagEnabled(pApplyFlag))
		{
			this.pict.ContentAssignment.addClass(tmpColumnSelector, tmpClass);
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpColumnSelector, tmpClass);
		}
		return true;
	}

	/**
	 * Sets (pApplyFlag truthy) or clears (pApplyFlag falsy) an inline background
	 * color on every data cell of a tabular row.
	 *
	 * The color is applied with `important` priority so it beats both host
	 * table-striping CSS and the highlight classes.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The zero-based row index.
	 * @param {string} pColor - The HTML color to apply (e.g. #FF0000).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- apply or clear the color.
	 * @returns {boolean}
	 */
	colorTabularRow(pSectionHash, pGroupHash, pRowIndex, pColor, pApplyFlag)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpApply = this.isSolverFlagEnabled(pApplyFlag) && (typeof pColor === 'string') && (pColor.length > 0);
		this.recordDecoration(pSectionHash, `${pGroupHash}::rowcolor::${pRowIndex}`, 'colorTabularRow',
			[ pSectionHash, pGroupHash, pRowIndex, pColor, pApplyFlag ]);
		let tmpElementSet = this.pict.ContentAssignment.getElement(`${tmpGroupSelector} tr[data-tabular-row-index="${pRowIndex}"] td`);
		for (let i = 0; i < tmpElementSet.length; i++)
		{
			if (tmpApply)
			{
				tmpElementSet[i].style.setProperty('background-color', pColor, 'important');
			}
			else
			{
				tmpElementSet[i].style.removeProperty('background-color');
			}
		}
		return true;
	}

	/**
	 * Sets (pApplyFlag truthy) or clears (pApplyFlag falsy) an inline background
	 * color on every cell of a tabular column -- header `<th>` plus all data `<td>`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pColumnIndex - The column's input index (descriptor InputIndex).
	 * @param {string} pColor - The HTML color to apply (e.g. #FF0000).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- apply or clear the color.
	 * @returns {boolean}
	 */
	colorTabularColumn(pSectionHash, pGroupHash, pColumnIndex, pColor, pApplyFlag)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpApply = this.isSolverFlagEnabled(pApplyFlag) && (typeof pColor === 'string') && (pColor.length > 0);
		this.recordDecoration(pSectionHash, `${pGroupHash}::columncolor::${pColumnIndex}`, 'colorTabularColumn',
			[ pSectionHash, pGroupHash, pColumnIndex, pColor, pApplyFlag ]);
		let tmpElementSet = this.pict.ContentAssignment.getElement(`${tmpGroupSelector} [data-tabular-column-index="${pColumnIndex}"]`);
		for (let i = 0; i < tmpElementSet.length; i++)
		{
			if (tmpApply)
			{
				tmpElementSet[i].style.setProperty('background-color', pColor, 'important');
			}
			else
			{
				tmpElementSet[i].style.removeProperty('background-color');
			}
		}
		return true;
	}

	/**
	 * Gets a value from the global form data by hash, falling back to address resolution
	 * using the global manyfest from the metacontroller.
	 *
	 * @param {string} pHash - The hash to resolve from the global form data.
	 * @returns {any} The value at the hash, or undefined if not found.
	 */
	getGlobalFormData(pHash)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getGlobalFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpMarshalDestination = this.pict.views.PictFormMetacontroller.viewMarshalDestination;
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestination);

		if ((typeof(tmpMarshalDestinationObject) !== 'object') || (tmpMarshalDestinationObject === null))
		{
			tmpMarshalDestinationObject = this.pict.AppData;
		}

		// Use the global pict manifest which has all descriptors added during bootstrapPictFormViewsFromManifest
		return this.pict.manifest.getValueByHash(tmpMarshalDestinationObject, pHash);
	}

	/**
	 * Resolves a value from the global form data by manyfest address,
	 * using the global manyfest from the metacontroller and the viewMarshalDestination.
	 *
	 * @param {string} pAddress - The manyfest address to resolve from the global form data.
	 * @returns {any} The value at the address, or undefined if not found.
	 */
	resolveGlobalFormData(pAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('resolveGlobalFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpMarshalDestination = this.pict.views.PictFormMetacontroller.viewMarshalDestination;
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestination);

		if ((typeof(tmpMarshalDestinationObject) !== 'object') || (tmpMarshalDestinationObject === null))
		{
			tmpMarshalDestinationObject = this.pict.AppData;
		}

		// Use the global pict manifest to resolve the address
		return this.pict.manifest.getValueAtAddress(tmpMarshalDestinationObject, pAddress);
	}

	/**
	 * Gets a value from a specific section's form data by hash or address.
	 *
	 * Uses the section view's sectionManifest and getMarshalDestinationObject
	 * to properly resolve the value within the section's scope.
	 *
	 * @param {string} pSectionHash - The hash of the section to get data from.
	 * @param {string} pHashOrAddress - The hash or address to resolve within the section.
	 * @returns {any} The value at the hash/address, or undefined if not found.
	 */
	getSectionFormData(pSectionHash, pHashOrAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getSectionFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`getSectionFormData: Could not find section view with hash [${pSectionHash}].`);
			return undefined;
		}

		return tmpSectionView.getValueByHash(pHashOrAddress);
	}

	/**
	 * Gets a value from a specific tabular section's row data by hash or address.
	 *
	 * Resolves the tabular record set from the section view, then gets the specific
	 * row's value using the group's supportingManifest.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The index of the row (may be string due to arbitrary precision).
	 * @param {string} pHashOrAddress - The hash or address to resolve within the row.
	 * @returns {any} The value at the hash/address in the row, or undefined if not found.
	 */
	getSectionTabularFormData(pSectionHash, pGroupHash, pRowIndex, pHashOrAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getSectionTabularFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`getSectionTabularFormData: Could not find section view with hash [${pSectionHash}].`);
			return undefined;
		}

		let tmpGroupIndex = tmpSectionView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`getSectionTabularFormData: Could not find group with hash [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		let tmpGroup = tmpSectionView.getGroup(tmpGroupIndex);
		if (!tmpGroup)
		{
			this.log.warn(`getSectionTabularFormData: Could not get group at index ${tmpGroupIndex} in section [${pSectionHash}].`);
			return undefined;
		}

		let tmpTabularRecordSet = tmpSectionView.getTabularRecordSet(tmpGroupIndex);
		if (!tmpTabularRecordSet)
		{
			this.log.warn(`getSectionTabularFormData: Could not find tabular record set for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		// RowIndex may be passed as a string due to arbitrary precision numbers in the solver
		let tmpRowIndex = parseInt(pRowIndex.toString());
		if (isNaN(tmpRowIndex) || tmpRowIndex < 0)
		{
			this.log.warn(`getSectionTabularFormData: Invalid row index [${pRowIndex}] for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		if (tmpRowIndex >= tmpTabularRecordSet.length)
		{
			this.log.warn(`getSectionTabularFormData: Row index [${tmpRowIndex}] out of bounds for group [${pGroupHash}] in section [${pSectionHash}] (length ${tmpTabularRecordSet.length}).`);
			return undefined;
		}
		let tmpRecord = tmpTabularRecordSet[tmpRowIndex];

		if (!tmpRecord || typeof(tmpRecord) !== 'object')
		{
			this.log.warn(`getSectionTabularFormData: No valid record at row index [${tmpRowIndex}] for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		// Use the group's supporting manifest to resolve the value
		if (tmpGroup.supportingManifest)
		{
			return tmpGroup.supportingManifest.getValueByHash(tmpRecord, pHashOrAddress);
		}

		// Fallback to direct property access if no supporting manifest
		if (pHashOrAddress in tmpRecord)
		{
			return tmpRecord[pHashOrAddress];
		}

		return undefined;
	}

	logValues()
	{
		let tmpLastValue = null;
		let tmpLogLine = 'Solver logvalues call: ';
		for (let i = 0; i < arguments.length; i++)
		{
			tmpLastValue = arguments[i];
			tmpLogLine += `  [${i}]=[${tmpLastValue}]`;
		}
		this.log.info(tmpLogLine);
		return tmpLastValue;
	}

	/**
	 * Resolves the comprehension destination object, creating intermediate objects along the configured
	 * address if they don't exist.  The address is read from
	 * `PictFormMetacontroller.comprehensionDestinationAddress` (default `AppData.FormEntityComprehensions`)
	 * and resolved against the pict instance, so callers can target any subtree (`AppData.*`, `Bundle.*`, ...).
	 *
	 * @returns {Record<string, any>|null} The destination object (mutable), or null if the address resolves
	 * to a non-object value the function can't safely write into (e.g. a number).
	 */
	resolveComprehensionDestination()
	{
		let tmpAddress = 'AppData.FormEntityComprehensions';
		if (this.pict.views.PictFormMetacontroller && typeof this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress === 'string'
			&& this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress.length > 0)
		{
			tmpAddress = this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress;
		}

		let tmpExisting = this.pict.resolveStateFromAddress(tmpAddress);
		if (tmpExisting && typeof tmpExisting === 'object')
		{
			return tmpExisting;
		}
		if (tmpExisting != null && typeof tmpExisting !== 'object')
		{
			this.log.warn(`addComprehensionEntity: comprehension destination [${tmpAddress}] resolves to a non-object value; refusing to overwrite.`);
			return null;
		}

		// The address is empty -- materialize an object there.  setStateValueAtAddress walks the
		// address creating intermediate objects on the way.
		this.pict.setStateValueAtAddress(tmpAddress, null, {});
		return this.pict.resolveStateFromAddress(tmpAddress);
	}

	/**
	 * Writes a single property/value into the configured comprehension destination, nested as
	 * `Context -> Entity -> GUID -> Property = Value`.
	 *
	 * `Context` is a manyfest address (dot-separated) so dotted contexts like
	 * `OnApprovalAction.Approve` produce nested context branches.  `Entity`, `GUID`, and `Property`
	 * are treated as opaque property names -- dots in them are NOT interpreted as nesting (so an
	 * entity GUID like `0x73278432987` lands as a single key).
	 *
	 * Successive calls to the same `(Context, Entity, GUID)` accumulate properties on the same
	 * record.  Successive calls to the same `(Context, Entity, GUID, Property)` overwrite.
	 *
	 * The destination address is configured on the metacontroller via
	 * `comprehensionDestinationAddress` (default `AppData.FormEntityComprehensions`) -- see
	 * `docs/Comprehensions.md`.
	 *
	 * @param {string} pContext - The comprehension context address (e.g. `"OnSave"`, `"OnApprovalAction.Approve"`).
	 * @param {string} pEntity - The entity name (e.g. `"Book"`).
	 * @param {string} pGUID - The external GUID for the record (e.g. `"0x73278432987"`).
	 * @param {string} pProperty - The property to set on the record (e.g. `"Title"`).
	 * @param {any} pValue - The value to write.
	 *
	 * @returns {any} `pValue` on success, `undefined` if the call was a no-op (invalid args / unwritable destination).
	 */
	addComprehensionEntity(pContext, pEntity, pGUID, pProperty, pValue)
	{
		// Every part of the path must be a non-empty stringifiable identifier -- silently swallowing
		// missing parts would write the comprehension into the wrong place under a literal "undefined"
		// key.  Warn and bail instead.
		if (pContext == null || pEntity == null || pGUID == null || pProperty == null)
		{
			this.log.warn(`addComprehensionEntity: ignoring call with null/undefined parts (Context=[${pContext}], Entity=[${pEntity}], GUID=[${pGUID}], Property=[${pProperty}]).`);
			return undefined;
		}

		let tmpContext = String(pContext);
		let tmpEntity = String(pEntity);
		let tmpGUID = String(pGUID);
		let tmpProperty = String(pProperty);

		if (tmpContext.length < 1 || tmpEntity.length < 1 || tmpGUID.length < 1 || tmpProperty.length < 1)
		{
			this.log.warn(`addComprehensionEntity: ignoring call with empty parts (Context=[${tmpContext}], Entity=[${tmpEntity}], GUID=[${tmpGUID}], Property=[${tmpProperty}]).`);
			return undefined;
		}

		let tmpDestination = this.resolveComprehensionDestination();
		if (!tmpDestination)
		{
			return undefined;
		}

		// Walk the context path manually so we don't have to worry about manyfest's address parsing
		// for the entity/GUID/property keys (which may contain characters like '0x...' that are fine
		// as keys but unusual as addresses).
		let tmpContextParts = tmpContext.split('.');
		let tmpCursor = tmpDestination;
		for (let i = 0; i < tmpContextParts.length; i++)
		{
			let tmpKey = tmpContextParts[i];
			if (tmpKey.length < 1)
			{
				continue;
			}
			if (!tmpCursor[tmpKey] || typeof tmpCursor[tmpKey] !== 'object')
			{
				tmpCursor[tmpKey] = {};
			}
			tmpCursor = tmpCursor[tmpKey];
		}

		if (!tmpCursor[tmpEntity] || typeof tmpCursor[tmpEntity] !== 'object')
		{
			tmpCursor[tmpEntity] = {};
		}
		let tmpEntityBucket = tmpCursor[tmpEntity];

		if (!tmpEntityBucket[tmpGUID] || typeof tmpEntityBucket[tmpGUID] !== 'object')
		{
			tmpEntityBucket[tmpGUID] = {};
		}
		tmpEntityBucket[tmpGUID][tmpProperty] = pValue;

		return pValue;
	}
}

module.exports = PictDynamicFormsSolverBehaviors;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],590:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Input",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicInput class is a provider that manages data brokering and provider mappings for dynamic inputs.
 */
class PictDynamicInput extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicInput class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		// A map of strings for each input template, mapping it to arrays of default providers.
		this.templateProviderMap = {};
		/** @type {Record<string, boolean>} */
		this.ignoredEventHashes = {};
	}

	/**
	 * @param {string} pEventHash
	 */
	registerIgnoredEventHash(pEventHash)
	{
		this.ignoredEventHashes[pEventHash] = true;
	}

	/**
	 * Retrieves the template hash for the input based on the provided view and input.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {any} pInput - The input object.
	 * @returns {string|boolean} - The template hash if found, otherwise false.
	 */
	getInputTemplateHash(pView, pInput)
	{
		if (pInput.IsTabular)
		{
			let tmpTemplateBeginInputTypePostfix = `-TabularTemplate-Begin-Input-InputType-${pInput.PictForm.InputType}`;
			let tmpTemplateEndInputTypePostfix = `-TabularTemplate-End-Input-InputType-${pInput.PictForm.InputType}`;

			let tmpTemplateBeginDataTypePostfix = `-TabularTemplate-Begin-Input-DataType-${pInput.DataType}`;
			let tmpTemplateEndDataTypePostfix = `-TabularTemplate-End-Input-DataType-${pInput.DataType}`;
			if (pView.checkViewSpecificTemplate(tmpTemplateBeginInputTypePostfix) && pView.checkViewSpecificTemplate(tmpTemplateEndInputTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateBeginInputTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateBeginInputTypePostfix) && pView.checkThemeSpecificTemplate(tmpTemplateEndInputTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateBeginInputTypePostfix);
			}
			else if (pView.checkViewSpecificTemplate(tmpTemplateBeginDataTypePostfix) && pView.checkViewSpecificTemplate(tmpTemplateEndDataTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateBeginDataTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateBeginDataTypePostfix) && pView.checkThemeSpecificTemplate(tmpTemplateEndDataTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateBeginDataTypePostfix);
			}
		}
		else
		{
			let tmpTemplateInputTypePostfix = `-Template-Input-InputType-${pInput.PictForm.InputType}`;
			let tmpTemplateDataTypePostfix = `-Template-Input-DataType-${pInput.DataType}`;
			if (pView.checkViewSpecificTemplate(tmpTemplateInputTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateInputTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateInputTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateInputTypePostfix);
			}
			else if (pView.checkViewSpecificTemplate(tmpTemplateDataTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateDataTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateDataTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateDataTypePostfix);
			}
		}
		return false;
	}

	/**
	 * Adds a default input provider for a given template full hash.
	 *
	 * @param {string} pTemplateFullHash - The full hash of the template.
	 * @param {any} pProvider - The provider to be added.
	 */
	addDefaultInputProvider(pTemplateFullHash, pProvider)
	{
		if (!(pTemplateFullHash in this.templateProviderMap))
		{
			this.templateProviderMap[pTemplateFullHash] = [];
		}
		if (this.templateProviderMap[pTemplateFullHash].indexOf(pProvider) < 0)
		{
			this.templateProviderMap[pTemplateFullHash].push(pProvider);
		}
	}

	/**
	 * Retrieves the default input providers based on the given view and input.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {string} pInput - The input to retrieve input providers for.
	 * @returns {Array} An array of default input providers.
	 */
	getDefaultInputProviders(pView, pInput)
	{
		let tmpTemplateHash = this.getInputTemplateHash(pView, pInput);
		if (tmpTemplateHash && this.templateProviderMap[tmpTemplateHash])
		{
			return this.templateProviderMap[tmpTemplateHash];
		}
		return [];
	}
}

module.exports = PictDynamicInput;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],591:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-InputEvents",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicInputEvents class is a provider that manages data brokering and provider mappings for dynamic inputs.
 */
class PictDynamicInputEvents extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicInputEvents class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Requests input data from the view based on the provided input hash.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pInputHash - The input hash.
	 * @param {any} [pEvent] - The input event.
	 */
	inputDataRequest(pView, pInputHash, pEvent)
	{
		if (pInputHash)
		{
			let tmpInput = pView.getInputFromHash(pInputHash);
			if (pEvent)
			{
				let tmpFormattedEvent;
				if (typeof pEvent === 'string')
				{
					tmpFormattedEvent = pEvent;
				}
				else
				{
					if (pEvent.namespace)
					{
						tmpFormattedEvent = `${pEvent.type}.${pEvent.namespace}`;
					}
					else
					{
						tmpFormattedEvent = pEvent.type;
					}
				}
				if (this.pict.providers.DynamicInput.ignoredEventHashes[tmpFormattedEvent])
				{
					return;
				}
			}
			let tmpHashAddress = pView.sectionManifest.resolveHashAddress(pInputHash);
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onDataRequest(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector);
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] inputDataRequest cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error running inputDataRequest specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find input hash [${pInputHash}] for inputDataRequest event.`);
		}
	}

	/**
	 * Handles the input event for a dynamic form.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pInputHash - The input hash.
	 * @param {string} pEvent - The input event.
	 * @param {string} [pTransactionGUID] - (optional) The active transaction GUID.
	 */
	inputEvent(pView, pInputHash, pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof pTransactionGUID === 'string') ? pTransactionGUID : this.pict.getUUID();
		let tmpInput = pView.getInputFromHash(pInputHash);
		if (pInputHash)
		{
			let tmpHashAddress = pView.sectionManifest.resolveHashAddress(pInputHash);
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						// we may find uninitialized inputs here, so we do not send events to those
						if (tmpInput.Macro)
						{
							pView.pict.providers[tmpInputProviderList[i]].onEvent(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, pEvent, tmpTransactionGUID);
							pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
							{
								pView.pict.providers[tmpInputProviderList[i]].onAfterEventCompletion(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, pEvent, tmpTransactionGUID);
							});
						}
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] inputEvent ${pEvent} cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
				if (pTransactionGUID !== tmpTransactionGUID)
				{
					// since we synthesized this transaction, finalize it
					pView.finalizeTransaction(tmpTransactionGUID);
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error running inputEvent ${pEvent} specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find input hash [${pInputHash}] for inputEvent ${pEvent} event.`);
		}
	}

	/**
	 * Requests input data for a tabular record.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} [pEvent] - The input event.
	 */
	inputDataRequestTabular(pView, pGroupIndex, pInputIndex, pRowIndex, pEvent)
	{
		let tmpInput = pView.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (pGroupIndex && pInputIndex && pRowIndex && tmpInput)
		{
			if (pEvent)
			{
				let tmpFormattedEvent;
				if (typeof pEvent === 'string')
				{
					tmpFormattedEvent = pEvent;
				}
				else
				{
					if (pEvent.namespace)
					{
						tmpFormattedEvent = `${pEvent.type}.${pEvent.namespace}`;
					}
					else
					{
						tmpFormattedEvent = pEvent.type;
					}
				}
				if (this.pict.providers.DynamicInput.ignoredEventHashes[tmpFormattedEvent])
				{
					return;
				}
			}
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				// TODO: Can we simplify pView?
				let tmpValueAddress = pView.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);

				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular+`[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onDataRequestTabular(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex);
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error marshaling specific (${pGroupIndex} | ${pInputIndex} | ${pRowIndex}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			// pView is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.
			pView.marshalFromView();
		}
	}

	/**
	 * Handles the tabular input event.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pEvent - The input event.
	 * @param {string} [pTransactionGUID] - (optional) The active transaction GUID.
	 */
	inputEventTabular(pView, pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof pTransactionGUID === 'string') ? pTransactionGUID : this.pict.getUUID();
		let tmpInput = pView.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (pGroupIndex != null && pInputIndex != null && pRowIndex != null && tmpInput)
		{
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();

				// TODO: Can we simplify pView?
				let tmpValueAddress = pView.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);

				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular+`[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onEventTabular(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, pEvent, tmpTransactionGUID);
						pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
						{
							pView.pict.providers[tmpInputProviderList[i]].onAfterEventTabularCompletion(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, pEvent, tmpTransactionGUID);
						});
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex} calling inputEvent ${pEvent}.`);
					}
				}
				if (pTransactionGUID !== tmpTransactionGUID)
				{
					// since we synthesized this transaction, finalize it
					pView.finalizeTransaction(tmpTransactionGUID);
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error marshaling specific (${pGroupIndex} | ${pInputIndex} | ${pRowIndex}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in calling inputEvent ${pEvent}: ${pError}`);
			}
		}
	}
}

module.exports = PictDynamicInputEvents;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],592:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Layout",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicLayout class is a provider that generates dynamic layouts based on configuration.
 */
class PictDynamicLayout extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicLayout class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Generate a group layout template for the Dynamically Generated views.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		return '';
	}

	/**
	 * After a group template has been rendered, this lets a layout initialize any controls that
	 * are necessary (e.g. a custom input type or such).
	 *
	 * @param {object} pView  - The view to initialize the newly rendered control for
	 * @param {object} pGroup - The group to initialize the newly rendered control for
	 * @returns
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		return true;
	}

	/**
	 * This fires after data has been marshaled to the form from the model.
	 *
	 * @param {object} pView  - The view to initialize the newly rendered control for
	 * @param {object} pGroup - The group to initialize the newly rendered control for
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		return true;
	}
}

module.exports = PictDynamicLayout;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],593:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-RecordSet",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictRecordSet class is a provider to read and write record sets.
 *
 * Record sets are bodies of records that are larger than what we would want to
 * be projected into a view.
 */
class PictRecordSet extends libPictProvider
{
	/**
	 * Creates an instance of the PictRecordSet class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.recordProviders = {};
	}

	/**
	 * Returns the count for a specific dynamic record set.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the count is returned.
	 * @returns {any} - The result of the callback function.
	 */
	count(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Reads a record list.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the record list is read.
	 * @returns {any} - The result of the callback function.
	 */
	readRecordList(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Reads a record.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the record is read.
	 * @returns {any} - The result of the callback function.
	 */
	readRecord(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Writes a record.
	 *
	 * @param {Object} pRecord - The record to be written.
	 * @param {Function} fCallback - The callback function to be called after the record is written.
	 * @returns {any} - The result of the callback function.
	 */
	writeRecord(pRecord, fCallback)
	{
		return fCallback();
	}

	/**
	 * Deletes a record.
	 *
	 * @param {Object} pRecord - The record to be deleted.
	 * @param {Function} fCallback - The callback function to be called after the record is deleted.
	 * @returns {any} - The result of the callback function.
	 */
	deleteRecord(pRecord, fCallback)
	{
		return fCallback();
	}
}

module.exports = PictRecordSet;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],594:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libDynamicFormSolverBehaviors = require('./Pict-Provider-DynamicFormSolverBehaviors.js');

const libListDistilling = require('./Pict-Provider-ListDistilling.js');
const libDynamicMetaLists = require('./Pict-Provider-MetaLists.js');

const libInputSelect = require('./inputs/Pict-Provider-Input-Select.js');
const libInputDateTime = require('./inputs/Pict-Provider-Input-DateTime.js');
const libInputTabGroupSelector = require('./inputs/Pict-Provider-Input-TabGroupSelector.js');
const libInputTabSectionSelector = require('./inputs/Pict-Provider-Input-TabSectionSelector.js');
const libInputEntityBundleRequest = require('./inputs/Pict-Provider-Input-EntityBundleRequest.js');
const libInputAutofillTriggerGroup = require('./inputs/Pict-Provider-Input-AutofillTriggerGroup.js');
const libInputMarkdown = require('./inputs/Pict-Provider-Input-Markdown.js');
const libInputHTML = require('./inputs/Pict-Provider-Input-HTML.js');
const libInputTemplated = require('./inputs/Pict-Provider-Input-Templated.js');
const libInputPreciseNumber = require('./inputs/Pict-Provider-Input-PreciseNumber.js');
const libInputLink = require('./inputs/Pict-Provider-Input-Link.js');
const libInputTemplatedEntityLookup = require('./inputs/Pict-Provider-Input-TemplatedEntityLookup.js');
const libInputChart = require('./inputs/Pict-Provider-Input-Chart.js');
const libInputTabularTriggerGroup = require('./inputs/Pict-Provider-Input-TabularTriggerGroup.js');
const libInputObjectEditor = require('./inputs/Pict-Provider-Input-ObjectEditor.js');
const libInputFacetFilter = require('./inputs/Pict-Provider-Input-FacetFilter.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Solver",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicSolver class is a provider that solves configuration-generated dynamic views.
 */
class PictDynamicSolver extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicSolver class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { ExpressionParser: any }} */
		this.pict;
		/** @type {import('pict') & { instantiateServiceProviderIfNotExists: (hash: string) => any, ExpressionParser: any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this._RunSolversRegex = /\brunsolvers\b/gi;

		// Initialize the solver service if it isn't up
		this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');

		this.pict.addProviderSingleton('DynamicFormSolverBehaviors', libDynamicFormSolverBehaviors.default_configuration, libDynamicFormSolverBehaviors);
		this.pict.providers.DynamicFormSolverBehaviors.injectBehaviors(this.fable.ExpressionParser);
		this.pict.addProviderSingleton('DynamicMetaLists', libDynamicMetaLists.default_configuration, libDynamicMetaLists);
		this.pict.addProviderSingleton('ListDistilling', libListDistilling.default_configuration, libListDistilling);
		this.pict.addProviderSingleton('Pict-Input-Select', libInputSelect.default_configuration, libInputSelect);
		this.pict.addProviderSingleton('Pict-Input-DateTime', libInputDateTime.default_configuration, libInputDateTime);
		this.pict.addProviderSingleton('Pict-Input-TabGroupSelector', libInputTabGroupSelector.default_configuration, libInputTabGroupSelector);
		this.pict.addProviderSingleton('Pict-Input-TabSectionSelector', libInputTabSectionSelector.default_configuration, libInputTabSectionSelector);
		this.pict.addProviderSingleton('Pict-Input-EntityBundleRequest', libInputEntityBundleRequest.default_configuration, libInputEntityBundleRequest);
		this.pict.addProviderSingleton('Pict-Input-AutofillTriggerGroup', libInputAutofillTriggerGroup.default_configuration, libInputAutofillTriggerGroup);
		this.pict.addProviderSingleton('Pict-Input-Markdown', libInputMarkdown.default_configuration, libInputMarkdown);
		this.pict.addProviderSingleton('Pict-Input-HTML', libInputHTML.default_configuration, libInputHTML);
		this.pict.addProviderSingleton('Pict-Input-Templated', libInputTemplated.default_configuration, libInputTemplated);
		this.pict.addProviderSingleton('Pict-Input-PreciseNumber', libInputPreciseNumber.default_configuration, libInputPreciseNumber);
		this.pict.addProviderSingleton('Pict-Input-TemplatedEntityLookup', libInputTemplatedEntityLookup.default_configuration, libInputTemplatedEntityLookup);
		this.pict.addProviderSingleton('Pict-Input-Link', libInputLink.default_configuration, libInputLink);
		this.pict.addProviderSingleton('Pict-Input-Chart', libInputChart.default_configuration, libInputChart);
		this.pict.addProviderSingleton('Pict-Input-TabularTriggerGroup', libInputTabularTriggerGroup.default_configuration, libInputTabularTriggerGroup);
		this.pict.addProviderSingleton('Pict-Input-ObjectEditor', libInputObjectEditor.default_configuration, libInputObjectEditor);
		this.pict.addProviderSingleton('Pict-Input-FacetFilter', libInputFacetFilter.default_configuration, libInputFacetFilter);
	}

	logSolveOutcome(pSolveOutcome)
	{
		let tmpSolveOutcome = pSolveOutcome;
		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			tmpSolveOutcome = this.lastSolveOutcome;
		}
		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			this.log.error(`DynamicSolver [${this.UUID}]::[${this.Hash}] No solve outcome available to log.`);
			return;
		}

		let tmpSolversRun = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length;

		this.log.info(`DynamicSolver completed solving ${tmpSolversRun} solvers in ${tmpSolveOutcome.EndTimeStamp - tmpSolveOutcome.StartTimeStamp} ms.`);

		for (let i = 0; i < tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length; i++)
		{
			let tmpSolver = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers[i];
			this.log.info(`  Solver [${tmpSolver.Hash}] Ordinal ${tmpSolver.Ordinal} executed in ${tmpSolver.EndTimeStamp - tmpSolver.StartTimeStamp}ms solving for [${tmpSolver?.ResultsObject?.PostfixedAssignmentAddress}] expression [${tmpSolver.Expression}]`);
		}
	}

	/**
	 * Prepares the solver results map by ensuring it has the necessary structure.
	 *
	 * @param {Object} pSolverResultsMap - The solver results map to prepare.
	 * @returns {Object} - The prepared solver results map.
	*/
	prepareSolverResultsMap(pSolverResultsMap)
	{
		let tmpSolverResultsMap = pSolverResultsMap;
		if (typeof(tmpSolverResultsMap) !== 'object' || tmpSolverResultsMap === null)
		{
			tmpSolverResultsMap = {};
		}
		if (!('ExecutedSolvers' in tmpSolverResultsMap))
		{
			tmpSolverResultsMap.ExecutedSolvers = [];
		}
		if (!('SolverResolutionMap' in tmpSolverResultsMap))
		{
			tmpSolverResultsMap.SolverResolutionMap = {};
		}
		return tmpSolverResultsMap;
	}

	/**
	 * Backfills solver dependencies into the solve outcome.
	 *
	 * @param {Object} pSolveOutcome - The solve outcome object.
	 * @returns {Object} - The updated solve outcome with backfilled dependencies.
	 */
	backfillSolverDependencies(pSolveOutcome)
	{
		let tmpSolveOutcome = pSolveOutcome;

		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			tmpSolveOutcome = this.lastSolveOutcome;
		}

		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			this.log.error(`DynamicSolver [${this.UUID}]::[${this.Hash}] No solve outcome available to backfill solver dependencies.`);
			return;
		}

		for (let i = 0; i < tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length; i++)
		{
			let tmpSolver = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers[i];
			if (('ResultsObject' in tmpSolver) && (typeof(tmpSolver.ResultsObject) === 'object') && (tmpSolver.ResultsObject !== null))
			{
				// Now fill any dependencies from the results object
				// If the Postfixed Assignment Address is "Result" it hasn't been set and we will ignore it.
				if (tmpSolver.ResultsObject.PostfixedAssignmentAddress && (tmpSolver.ResultsObject.PostfixedAssignmentAddress != 'Result'))
				{
					if (typeof(tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress]) !== 'object')
					{
						tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress] = {};
					}
					// Go through the postfixed list and pull out any symbols being assigned
					for (let j = 0; j < tmpSolver.ResultsObject.PostfixTokenObjects.length; j++)
					{
						let tmpTokenObject = tmpSolver.ResultsObject.PostfixTokenObjects[j];
						if (tmpTokenObject.Type == 'Token.Symbol')
						{
							if (!(tmpTokenObject.Token in tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress]))
							{
								tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] = 0;
							}
							tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] = tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] + 1;
						}
					}
				}
			}
		}

		return tmpSolveOutcome;
	}

	/**
	 * Runs a manual solver expression against the dynamic view marshal destination or the application data.
	 *
	 * @param {string} pSolverExpression - The solver expression to run.
	 * @param {boolean} [pSilent=false] - Whether to suppress debug logging output.
	 * @returns {any} - The result of the solver expression.
	 */
	runSolver(pSolverExpression, pSilent = false)
	{
		let tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);

		if ((typeof(tmpViewMarshalDestinationObject) !== 'object') || (tmpViewMarshalDestinationObject === null))
		{
			tmpViewMarshalDestinationObject = this.pict.AppData;
		}

		let tmpResultsObject = {};
		let tmpSolutionValue = this.fable.ExpressionParser.solve(pSolverExpression, tmpViewMarshalDestinationObject, tmpResultsObject, this.pict.manifest);

		if (tmpResultsObject.fable)
		{
			delete tmpResultsObject.fable;
		}

		if (!pSilent)
		{
			this.pict.log.trace(`Manual solve executed for expression: ${pSolverExpression}`, tmpResultsObject);
		}

		return tmpSolutionValue;
	}

	/**
	 * Checks the solver and returns the solver object if it passes the checks.
	 *
	 * Automatically converts string solvers to have an Ordinal of 1.
	 *
	 * @param {string|object} pSolver - The solver to be checked. It can be either a string or an object.
	 * @param {boolean} [pFiltered=false] - Indicates whether the solvers should be filtered.
	 * @param {number} [pOrdinal] - The ordinal value to compare with the solver's ordinal value when filtered.
	 * @returns {object|undefined} - The solver object if it passes the checks, otherwise undefined.
	 */
	checkSolver(pSolver, pFiltered, pOrdinal)
	{
		let tmpSolver = pSolver;
		if (tmpSolver === undefined)
		{
			return;
		}
		if (typeof(tmpSolver) === 'string')
		{
			tmpSolver = {Expression:tmpSolver, Ordinal:1};
		}
		if (!('Expression' in tmpSolver))
		{
			this.log.error(`Dynamic View solver ${pOrdinal} is missing the Expression property.`, { Solver: pSolver });
			return;
		}
		if (!(`Ordinal` in tmpSolver))
		{
			tmpSolver.Ordinal = 1;
		}

		// This filters the solvers
		if (pFiltered && (tmpSolver.Ordinal != pOrdinal))
		{
			return;
		}

		return tmpSolver;
	}

	/** @typedef {{ Ordinal: number, Expression: string } | string} Solver */

	/**
	 * Execute a set of adhoc solvers.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The dynamic view to execute the solvers against.
	 * @param {Array<Solver>} pSolvers - An array of solvers to execute.
	 * @param {string} pReason - The reason for executing the solvers.
	 */
	executeSolvers(pView, pSolvers, pReason)
	{
		const tmpSolvers = Array.isArray(pSolvers) ? pSolvers : [];
		let tmpSolveOutcome = {};
		tmpSolveOutcome.SolverResultsMap = {};
		tmpSolveOutcome.StartTimeStamp = +new Date();

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		for (let i = 0; i < tmpSolvers.length; i++)
		{
			const tmpSolver = this.checkSolver(tmpSolvers[i]);
			if (tmpSolver)
			{
				let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
				tmpOrdinalContainer.AdhocSolvers.push(tmpSolver);
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort((a, b) =>
		{
			if (isNaN(Number(a)) || isNaN(Number(b)))
			{
				return a.localeCompare(b);
			}
			return Number(a) - Number(b);
		});

		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicSolver [${this.UUID}]::[${this.Hash}] [${pReason}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			const tmpAdhocScope = this.pict.providers.DynamicFormSolverBehaviors.getViewSolverScope(pView);
			let tmpExecuteOrdinal = this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpOrdinalKeys[i], tmpAdhocScope);
			if (tmpExecuteOrdinal)
			{
				const tmpPreviousScope = this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpAdhocScope);
				this.executeAdhocSolvers(pView, tmpOrdinalContainer.AdhocSolvers, pReason, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap);
				this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpPreviousScope);
			}
		}

		tmpSolveOutcome.EndTimeStamp = +new Date();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastAdhocSolveOutcome = tmpSolveOutcome;
	}

	/**
	 * Runs each Adhoc solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The dynamic view to execute the solvers against.
	 * @param {Array<string>} pAdhocSolverArray - An array of Solvers from the groups to solve.
	 * @param {string} pReason - The reason for executing the solvers.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeAdhocSolvers(pView, pAdhocSolverArray, pReason, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pAdhocSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pAdhocSolverArray[i], tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					pView.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] [${pReason}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = +new Date();
			tmpSolver.Hash = `AdhocSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`Dynamic View [${pView.UUID}]::[${pView.Hash}] [${pReason}] solving equation ${i} ordinal ${tmpSolver.Ordinal} [${pView.options.Solvers[i]}]`);
			}
			tmpSolver.ResultsObject = {};
			let tmpSolutionValue = this.fable.ExpressionParser.solve(tmpSolver.Expression, pView.getMarshalDestinationObject(), tmpSolver.ResultsObject, this.pict.manifest, pView.getMarshalDestinationObject());
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`[${tmpSolver.Expression}] [${pReason}] result was ${tmpSolutionValue}`);
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Runs each RecordSet solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {array} pGroupSolverArray - An array of Solvers from the groups to solve.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeGroupSolvers(pGroupSolverArray, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		// This is purely for readability of the code below ... uglify optimizes it out.
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		// Solve the group RecordSet solvers first
		for (let j = 0; j < pGroupSolverArray.length; j++)
		{
			let tmpView = this.pict.views[pGroupSolverArray[j].ViewHash];
			let tmpGroup = tmpView.getGroup(pGroupSolverArray[j].GroupIndex);
			let tmpSolver = this.checkSolver(pGroupSolverArray[j].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			const tmpGroupScope = this.pict.providers.DynamicFormSolverBehaviors.getViewSolverScope(tmpView);
			if (tmpGroupScope && !this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpSolver.Ordinal, tmpGroupScope))
			{
				continue;
			}
			this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpGroupScope);

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					tmpView.log.warn(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `${pGroupSolverArray[j].ViewHash}-GroupSolver-${j}`;

			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] solving RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}

			let tmpRecordSet = tmpView.getTabularRecordSet(tmpGroup.GroupIndex);

			if (Array.isArray(tmpRecordSet))
			{
				for (let l = 0; l < tmpRecordSet.length; l++)
				{
					let tmpRecord = tmpRecordSet[l];
					tmpSolver.ResultsObject = {};
					let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, tmpGroup.supportingManifest, tmpRecord);
					if (this.pict.LogNoisiness > 1)
					{
						tmpView.log.trace(`Group ${tmpGroup.Hash} [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
					}
				}
			}
			else if (typeof(tmpRecordSet) == 'object')
			{
				let tmpRecordSetKeys = Object.keys(tmpRecordSet);
				for (let l = 0; l < tmpRecordSetKeys.length; l++)
				{
					let tmpRecord = tmpRecordSet[tmpRecordSetKeys[l]];
					tmpSolver.ResultsObject = {};
					let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, tmpGroup.supportingManifest, tmpRecord);
					if (this.pict.LogNoisiness > 1)
					{
						tmpView.log.trace(`Group ${tmpGroup.Hash} [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
					}
				}
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = Date.now();
		}
		this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope('');
	}

	/**
	 * Executes the section solvers at a given ordinal (or all if no ordinal is passed).
	 *
	 * @param {Array} pViewSectionSolverArray - The array of view section solvers.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeSectionSolvers(pViewSectionSolverArray, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pViewSectionSolverArray.length; i++)
		{
			let tmpView = this.pict.views[pViewSectionSolverArray[i].ViewHash];
			let tmpSolver = this.checkSolver(pViewSectionSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			// A gate an injected copy set applies to that copy's solvers, not to a sibling's at the same ordinal.
			const tmpSectionScope = this.pict.providers.DynamicFormSolverBehaviors.getViewSolverScope(tmpView);
			if (tmpSectionScope && !this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpSolver.Ordinal, tmpSectionScope))
			{
				continue;
			}
			this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope(tmpSectionScope);

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					tmpView.log.warn(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = +new Date();
			tmpSolver.Hash = `${pViewSectionSolverArray[i].ViewHash}-SectionSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] solving equation ${i} ordinal ${tmpSolver.Ordinal} [${tmpView.options.Solvers[i]}]`);
			}
			tmpSolver.ResultsObject = {};
			let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpView.getMarshalDestinationObject(), tmpSolver.ResultsObject, this.pict.manifest, tmpView.getMarshalDestinationObject());
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`[${tmpSolver.Expression}] result was ${tmpSolutionValue}`);
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
		this.pict.providers.DynamicFormSolverBehaviors.setActiveSolverScope('');
	}

	/**
	 * Executes the view solvers for the given array of view hashes.
	 *
	 * @param {Array} pViewSolverArray - The array of view solvers to execute.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 */
	executeViewSolvers(pViewSolverArray, pOrdinal, pSolverResultsMap)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pViewSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pViewSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			tmpSolver.Hash = `${pViewSolverArray[i].ViewHash}-ViewSolve-${i}`;
			tmpSolver.StartTimeStamp = +new Date();
			let tmpView = this.pict.views[pViewSolverArray[i].ViewHash];
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] running solve() on view [${pViewSolverArray[i].ViewHash}`);
			}
			// Solve with the normal view solve() pipeline
			tmpView.solve();
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Executes any validation solvers defined in the form manifest.
	 *
	 * @param {Object} pSolverResultsMap - The solver results map to use for executing validation solvers.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles when executing validation solvers.
	 */
	executeValidationSolvers(pSolverResultsMap, pPreventSolverCycles = false)
	{
		const tmpValidationSolvers = this.pict.views.PictFormMetacontroller?.manifestDescription?.ValidationSolvers;
		if (!Array.isArray(tmpValidationSolvers))
		{
			return;
		}
		const tmpMarshalDestination = this.pict.views.PictFormMetacontroller && this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination) || this.pict.AppData;
		for (let i = 0; i < tmpValidationSolvers.length; i++)
		{
			const tmpSolver = this.checkSolver(tmpValidationSolvers[i]);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.warn(`Skipping Validation Solver ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`Running validation solver ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}
			this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpMarshalDestination, pSolverResultsMap, this.pict.manifest, tmpMarshalDestination);
		}
	}

	/**
	 * Checks if the given ordinal exists in the provided ordinal set.
	 *
	 * If not, it adds the ordinal to the set.
	 *
	 * @param {number} pOrdinal - The ordinal to check.
	 * @param {Object} pOrdinalSet - The ordinal set to check against.
	 * @returns {Object} - The ordinal object from the ordinal set.
	 */
	checkAutoSolveOrdinal (pOrdinal, pOrdinalSet)
	{
		if (!(pOrdinal.toString() in pOrdinalSet))
		{
			pOrdinalSet[pOrdinal.toString()] = { ViewSolvers:[], SectionSolvers:[], GroupSolvers:[], AdhocSolvers:[] };
		}
		return pOrdinalSet[pOrdinal];
	}

	/**
	 * Solves the views based on the provided view hashes or all views in pict.
	 *
	 * If non-dynamic views are also passed in, they are solved as well.
	 *
	 * This algorithm is particularly complex because it solves views in
	 * order across two dimensions:
	 *
	 * 1. The order of the views in the view hash array.
	 * 2. Precedence order (based on Ordinal)
	 *
	 * The way it manages the precedence order solving is by enumerating the
	 * view hash array multiple times until it exhausts the solution set.
	 *
	 * In dynamic views, when there are collisions in precedence order between
	 * Section Solvers and Group RecordSet Solvers, it prefers the RecordSet
	 * solvers first.  The thinking behind this is that a RecordSet solver is
	 * a "tier down" from the core Section it resides within.  These are
	 * leaves on the tree.

	 * @param {Array|string[]} [pViewHashes] - An optional array of view hashes to solve. If not provided, all views in the fable will be solved.
	 * @param {boolean} [pPreventSolverCycles] - An optional context string for the solve operation.
	 * TODO: make sure you can't cycle with the same solve context - new solver method to invoke this
	 *
	 * @return {Array<string>} - An array of view hashes that were solved.
	 */
	solveViews(pViewHashes, pPreventSolverCycles)
	{
		//this.log.trace(`Dynamic View Provider [${this.UUID}]::[${this.Hash}] solving views.`);
		let tmpViewHashes = Array.isArray(pViewHashes) ? pViewHashes : Object.keys(this.fable.views);
		const tmpPreventSolverCycles = pPreventSolverCycles === true;

		let tmpSolveOutcome = {};
		tmpSolveOutcome.SolverResultsMap = {};
		tmpSolveOutcome.StartTimeStamp = +new Date();
		tmpSolveOutcome.ViewHashes = tmpViewHashes;

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			let tmpView = this.fable.views[tmpViewHashes[i]];
			if (tmpView.isPictView && !tmpView.isPictSectionForm && !tmpView.isPictMetacontroller)
			{
				// This is just a normal view.  We will solve it at the appropriate ordinal.
				let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpView.options.AutoSolveOrdinal, tmpOrdinalsToSolve);
				tmpOrdinalContainer.ViewSolvers.push({ViewHash:tmpViewHashes[i]});
			}
			else if (tmpView.isPictSectionForm)
			{
				// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
				for (let j = 0; j < tmpView.sectionDefinition.Groups.length; j++)
				{
					let tmpGroup = tmpView.getGroup(j);
					if (`RecordSetSolvers` in tmpGroup)
					{
						for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
						{
							let tmpSolver = this.checkSolver(tmpGroup.RecordSetSolvers[k]);
							if (tmpSolver)
							{
								let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
								tmpOrdinalContainer.GroupSolvers.push({ViewHash:tmpViewHashes[i], GroupIndex:j, Solver:tmpSolver});
							}
						}
					}
				}
				if (Array.isArray(tmpView.options.Solvers))
				{
					// Add thje section solver(s)
					for (let j = 0; j < tmpView.options.Solvers.length; j++)
					{
						let tmpSolver = this.checkSolver(tmpView.options.Solvers[j]);
						if (tmpSolver)
						{
							let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
							tmpOrdinalContainer.SectionSolvers.push({ViewHash:tmpViewHashes[i], Solver:tmpSolver});
						}
					}
				}
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort((a, b) =>
		{
			if (isNaN(Number(a)) || isNaN(Number(b)))
			{
				return a.localeCompare(b);
			}
			return Number(a) - Number(b);
		});

		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicSolver [${this.UUID}]::[${this.Hash}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			let tmpExecuteOrdinal = this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpOrdinalKeys[i]);
			if (tmpExecuteOrdinal)
			{
				this.executeGroupSolvers(tmpOrdinalContainer.GroupSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);
				this.executeSectionSolvers(tmpOrdinalContainer.SectionSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);
				this.executeViewSolvers(tmpOrdinalContainer.ViewSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap);
			}
		}

		this.executeValidationSolvers(tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);

		// Now regenerate the metalists .. after the solve has happened.
		this.pict.providers.DynamicMetaLists.buildViewSpecificLists(tmpViewHashes);

		tmpSolveOutcome.EndTimeStamp = +new Date();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastSolveOutcome = tmpSolveOutcome;
		return tmpViewHashes;
	}
}

module.exports = PictDynamicSolver;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./Pict-Provider-DynamicFormSolverBehaviors.js":589,"./Pict-Provider-ListDistilling.js":600,"./Pict-Provider-MetaLists.js":601,"./inputs/Pict-Provider-Input-AutofillTriggerGroup.js":606,"./inputs/Pict-Provider-Input-Chart.js":608,"./inputs/Pict-Provider-Input-DateTime.js":609,"./inputs/Pict-Provider-Input-EntityBundleRequest.js":612,"./inputs/Pict-Provider-Input-FacetFilter.js":613,"./inputs/Pict-Provider-Input-HTML.js":614,"./inputs/Pict-Provider-Input-Link.js":615,"./inputs/Pict-Provider-Input-Markdown.js":616,"./inputs/Pict-Provider-Input-ObjectEditor.js":617,"./inputs/Pict-Provider-Input-PreciseNumber.js":618,"./inputs/Pict-Provider-Input-Select.js":621,"./inputs/Pict-Provider-Input-TabGroupSelector.js":622,"./inputs/Pict-Provider-Input-TabSectionSelector.js":623,"./inputs/Pict-Provider-Input-TabularTriggerGroup.js":624,"./inputs/Pict-Provider-Input-Templated.js":625,"./inputs/Pict-Provider-Input-TemplatedEntityLookup.js":626,"pict-provider":552}],595:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-DynamicTabularData",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * @typedef {Object} ElementDescriptor
 * @property {string} Hash - The hash of the element.
 */

/**
 * The DynamicTabularData class is a provider that translates simple list entries into arrays of entries ready to use in drop-down lists and such
 */
class DynamicTabularData extends libPictProvider
{
	/**
	 * Creates an instance of the DynamicTabularData class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Retrieves the tabular record set from the specified view and group index.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @returns {Array|Object|boolean} - The tabular record set if it exists, otherwise false.
	 */
	getTabularRecordSet(pView, pGroupIndex)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);
		if (!tmpGroup || !tmpGroup?.RecordSetAddress)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordSet ${pGroupIndex} was not a valid group or did not have a valid RecordSetAddress.`);
			return false;
		}

		let tmpRowSource = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		return tmpRowSource;
	}

	/**
	 * Retrieves the tabular record input from the specified view, group, and input indexes.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns {ElementDescriptor|boolean} The tabular record input or false if the group is invalid.
	 */
	getTabularRecordInput(pView, pGroupIndex, pInputIndex)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInput ${pGroupIndex} was not a valid group.`);
			return false;
		}

		// Now get the supporting manifest and the input element
		// This needs more guards
		let tmpSupportingManifestHash = tmpGroup.supportingManifest.elementAddresses[pInputIndex];
		return tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
	}

	/**
	 * Retrieves the tabular record input from the specified view, group, and input indexes.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupHash - The index of the group.
	 * @param {number} pInputHash - The index of the input.
	 * @returns {ElementDescriptor|boolean} The tabular record input or false if the group is invalid.
	 */
	getTabularRecordInputByHash(pView, pGroupHash, pInputHash)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroups().find((pGroup) => pGroup.Hash === pGroupHash);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} was not a valid group.`);
			return false;
		}

		if (!tmpGroup.supportingManifest)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} s not a tabular group.`);
			return false;
		}

		// Now get the supporting manifest and the input element
		// This needs more guards
		for (const tmpDescriptor of Object.values(tmpGroup.supportingManifest.elementDescriptors))
		{
			if (tmpDescriptor.Hash === pInputHash)
			{
				return tmpDescriptor;
			}
		}

		this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} could not find input ${pInputHash}.`);
		return false;
	}

	/**
	 * Retrieves tabular record data based on the provided parameters.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pRowIdentifier - The identifier of the row.
	 * @returns {boolean|Object} - The tabular record data or false if not found.
	 */
	getTabularRecordData(pView, pGroupIndex, pRowIdentifier)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} was not a valid group.`);
			return false;
		}

		// Now identify the group
		let tmpRowSourceRecord =  pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		if (!tmpRowSourceRecord)
		{
			// Try the address
			tmpRowSourceRecord = pView.sectionManifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		}

		if (!tmpRowSourceRecord)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} could not find the record set for ${tmpGroup.RecordSetAddress}.`);
			return false;
		}

		// Now we have the source record let's see what it is
		try
		{
			if (Array.isArray(tmpRowSourceRecord))
			{
				return tmpRowSourceRecord[pRowIdentifier];
			}
			else if (typeof(tmpRowSourceRecord) === 'object')
			{
				return tmpRowSourceRecord[pRowIdentifier];
			}
			else
			{
				this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} could not determine the type of the record set for ${tmpGroup.RecordSetAddress}.`);
				return false;
			}
		}
		catch (pError)
		{
			this.log.error(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} encountered an error: ${pError}`);
			return false;
		}
	}

	/**
	 * Creates a dynamic table row for the given view and group index.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 */
	createDynamicTableRow(pView, pGroupIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MaximumRowCount && (tmpDestinationObject.length >= tmpGroup.MaximumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to add a row but the maximum rows ${tmpGroup.MaximumRowCount} has been reached.`);
					return;
				}
				let tmpRowPrototype = {};
				if (tmpGroup.DefaultRows && tmpDestinationObject.length < tmpGroup.DefaultRows.length)
				{
					tmpRowPrototype = JSON.parse(JSON.stringify(tmpGroup.DefaultRows[tmpDestinationObject.length]));
				}
				tmpDestinationObject.push(tmpGroup.supportingManifest.populateDefaults(tmpRowPrototype));

				// Also render any other views that have this as the RecordSetAddress
				// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
				let tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
					/** @param {import('../views/Pict-View-DynamicForm.js')} pViewToTestForGroup */
					(pViewToTestForGroup) =>
					{
						if (!pViewToTestForGroup.isPictSectionForm)
						{
							return false;
						}
						let tmpGroupsToTest = pViewToTestForGroup.getGroups();
						for (let i = 0; i < tmpGroupsToTest.length; i++)
						{
							if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
							{
								return true;
							}
						}
						return false;
					}
				)
				// We expect this view to be in the set. Re-rendering an entity-selector
				// table clobbers its selected values in the model, so preserve them.
				this._renderViewsPreservingRecordSet(tmpGroup.RecordSetAddress, tmpViewsToRender);

				// Rebuild any OTHER views whose DynamicColumns are sourced from this record set
				// (e.g. a "% Passing" table whose columns are generated from this "Products" table)
				// HERE, in the render phase -- BEFORE the marshal below -- so the column DOM is
				// correct when the marshal fills it. Previously these dependent tables were only
				// rebuilt from inside the Tabular layout's onDataMarshalToForm hook (mid-marshal),
				// which left the freshly rebuilt cells unpopulated until a later edit/marshal --
				// the "dependent table blanks out on row add/delete until you edit a field" bug.
				this._rebuildDependentDynamicColumnViews(tmpGroup.RecordSetAddress);

				// Run the solver
				this.pict.providers.DynamicSolver.solveViews();

				//pView.render();
				//pView.marshalToView();
				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}


	/**
	 * Creates a dynamic table row for the given view and group index without firing render or marshal events.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 */
	createDynamicTableRowWithoutEvents(pView, pGroupIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MaximumRowCount && (tmpDestinationObject.length >= tmpGroup.MaximumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to add a row but the maximum rows ${tmpGroup.MaximumRowCount} has been reached.`);
					return;
				}
				let tmpRowPrototype = {};
				if (tmpGroup.DefaultRows && tmpDestinationObject.length < tmpGroup.DefaultRows.length)
				{
					tmpRowPrototype = JSON.parse(JSON.stringify(tmpGroup.DefaultRows[tmpDestinationObject.length]));
				}
				tmpDestinationObject.push(tmpGroup.supportingManifest.populateDefaults(tmpRowPrototype))
			}
		}
	}

	/**
	 * Sets the index of a dynamic table row in a view.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number|string} pRowIndex - The current index of the row.
	 * @param {number} pNewRowIndex - The new index to move the row to.
	 * @returns {boolean} - Returns false if the index is out of bounds, otherwise returns undefined.
	 */
	setDynamicTableRowIndex(pView, pGroupIndex, pRowIndex, pNewRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				let tmpNewRowIndex = parseInt(String(pNewRowIndex), 10);
				if ((tmpDestinationObject.length <= tmpRowIndex) || (tmpRowIndex < 0))
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] to [${pNewRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so a source reorder must apply the same permutation to every
				// dependent row's positional cells -- otherwise user-entered values stay put while
				// their column re-labels to a different source row. Must run BEFORE the dependent
				// views re-resolve their columns below. No-op for value-keyed generators.
				this._moveDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpNewRowIndex, tmpOriginalLength);

				// Render (source + dependent views) BEFORE solving so dependent DynamicColumns tables
				// don't blank until the next edit, and the solve's DOM side effects survive. Matches
				// the add/delete handlers' order.
				this._repaintAfterRowReorder(pView, tmpGroup);
			}
		}
	}

	/**
	 * Moves a dynamic table row down within a view.
	 *
	 * @param {Object} pView - The view containing the dynamic table.
	 * @param {number} pGroupIndex - The index of the group containing the row.
	 * @param {number|string} pRowIndex - The index of the row to be moved.
	 * @returns {boolean} - Returns true if the row was successfully moved, false otherwise.
	 */
	moveDynamicTableRowDown(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] down but it's already at the bottom.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				let tmpNewRowIndex = tmpRowIndex + 1;
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so a source reorder must apply the same permutation to every
				// dependent row's positional cells -- otherwise user-entered values stay put while
				// their column re-labels to a different source row. Must run BEFORE the dependent
				// views re-resolve their columns below. No-op for value-keyed generators.
				this._moveDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpNewRowIndex, tmpOriginalLength);

				// Render (source + dependent views) BEFORE solving so the solve's DOM side effects
				// (e.g. SetGroupVisibility hiding a validation message) act on the freshly rebuilt
				// DOM and survive, and so dependent DynamicColumns tables don't blank until the next
				// edit. Matches the add/delete handlers' order.
				this._repaintAfterRowReorder(pView, tmpGroup);
			}
		}
	}

	/**
	 * Moves a dynamic table row up.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number|string} pRowIndex - The index of the row to be moved.
	 * @returns {boolean} Returns true if the row was moved successfully, false otherwise.
	 */
	moveDynamicTableRowUp(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == 0)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] up but it's already at the top.`);
					return false;
				}
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				let tmpNewRowIndex = tmpRowIndex - 1;
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so a source reorder must apply the same permutation to every
				// dependent row's positional cells -- otherwise user-entered values stay put while
				// their column re-labels to a different source row. Must run BEFORE the dependent
				// views re-resolve their columns below. No-op for value-keyed generators.
				this._moveDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpNewRowIndex, tmpOriginalLength);

				// Render (source + dependent views) BEFORE solving so the solve's DOM side effects
				// (e.g. SetGroupVisibility hiding a validation message) act on the freshly rebuilt
				// DOM and survive, and so dependent DynamicColumns tables don't blank until the next
				// edit. Matches the add/delete handlers' order.
				this._repaintAfterRowReorder(pView, tmpGroup);
			}
		}
	}


	/**
	 * Deletes a dynamic table row from the specified view.
	 *
	 * @param {Object} pView - The view from which to delete the row.
	 * @param {number} pGroupIndex - The index of the group containing the row.
	 * @param {number|string} pRowIndex - The index or key of the row to delete.
	 * @returns {boolean} - Returns true if the row was successfully deleted, false otherwise.
	 */
	deleteDynamicTableRow(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to delete a row but the minimum rows ${tmpGroup.MinimumRowCount} has been reached.`);
					return false;
				}

				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to delete row [${pRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpOriginalLength = tmpDestinationObject.length;
				tmpDestinationObject.splice(tmpRowIndex, 1);

				// Position-keyed DynamicColumns (KeyBy:"Position") store dependent cell data by the
				// source row's INDEX, so deleting a source row must shift every dependent row's
				// positional cells down past the removed index -- otherwise the values below it
				// re-associate to the wrong column. (Solver-filled cells re-derive on the next
				// solve; user-entered cells would shift without this.) Must run BEFORE the
				// dependent views re-resolve their columns below. No-op for value-keyed generators.
				this._spliceDependentPositionalColumns(tmpGroup.RecordSetAddress, tmpRowIndex, tmpOriginalLength);

				// Also render any other views that have this as the RecordSetAddress
				// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
				let tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
					(pViewToTestForGroup) =>
					{
						if (!pViewToTestForGroup.isPictSectionForm)
						{
							return false;
						}
						let tmpGroupsToTest = pViewToTestForGroup.getGroups();
						for (let i = 0; i < tmpGroupsToTest.length; i++)
						{
							if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
							{
								return true;
							}
						}
						return false;
					}
				)
				// We expect this view to be in the set. Re-rendering an entity-selector
				// table clobbers its selected values in the model, so preserve them.
				this._renderViewsPreservingRecordSet(tmpGroup.RecordSetAddress, tmpViewsToRender);

				// Rebuild any OTHER views whose DynamicColumns are sourced from this record set
				// (e.g. a "% Passing" table whose columns are generated from this "Products" table)
				// HERE, in the render phase -- BEFORE the marshal below -- so the column DOM is
				// correct when the marshal fills it. Previously these dependent tables were only
				// rebuilt from inside the Tabular layout's onDataMarshalToForm hook (mid-marshal),
				// which left the freshly rebuilt cells unpopulated until a later edit/marshal --
				// the "dependent table blanks out on row add/delete until you edit a field" bug.
				this._rebuildDependentDynamicColumnViews(tmpGroup.RecordSetAddress);

				// Run the solver
				this.pict.providers.DynamicSolver.solveViews();

				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}

	/**
	 * Render every view in pViewsToRender while preserving pRecordSetAddress's data in
	 * the model. Re-rendering a table that contains entity-selector cells (Material /
	 * Organization / Product / etc.) destroys and recreates their select2 widgets; the
	 * transient empty widget gets read back into the model and wipes the selected value
	 * AND its resolved __Record for EVERY row -- the "selected Source / Name disappears
	 * after adding or deleting a row" data-loss bug. Because it clobbers the saved
	 * FormData, the value is then also missing from the exported PDF. A render() must be
	 * model-non-destructive, so snapshot the record set before rendering and restore any
	 * cleared fields afterward. No-op for plain (non-entity) tables, where render never
	 * changes the model (snapshot == post-render state, restore is a no-op).
	 *
	 * @param {string} pRecordSetAddress - RecordSetAddress of the table being re-rendered.
	 * @param {Array<Object>} pViewsToRender - Views bound to that record set to render.
	 */
	_renderViewsPreservingRecordSet(pRecordSetAddress, pViewsToRender)
	{
		if (!Array.isArray(pViewsToRender) || (pViewsToRender.length < 1))
		{
			return;
		}
		// Snapshot the record set (deep clone each row) from a view that owns it.
		let tmpRecordSet = false;
		let tmpSnapshot = false;
		for (let i = 0; i < pViewsToRender.length; i++)
		{
			let tmpCandidate = pViewsToRender[i].sectionManifest.getValueByHash(pViewsToRender[i].getMarshalDestinationObject(), pRecordSetAddress);
			if (Array.isArray(tmpCandidate))
			{
				tmpRecordSet = tmpCandidate;
				tmpSnapshot = tmpCandidate.map((pRow) => (pRow && (typeof pRow === 'object')) ? JSON.parse(JSON.stringify(pRow)) : pRow);
				break;
			}
		}
		for (let i = 0; i < pViewsToRender.length; i++)
		{
			pViewsToRender[i].render();
		}
		// Restore any model fields a destructive re-render cleared (entity value + __Record).
		if (Array.isArray(tmpRecordSet) && Array.isArray(tmpSnapshot))
		{
			for (let i = 0; i < tmpRecordSet.length; i++)
			{
				if (tmpRecordSet[i] && (typeof tmpRecordSet[i] === 'object') && tmpSnapshot[i] && (typeof tmpSnapshot[i] === 'object'))
				{
					Object.assign(tmpRecordSet[i], tmpSnapshot[i]);
				}
			}
		}
	}

	/**
	 * Rebuild every OTHER section-form view whose DynamicColumns are sourced from
	 * pSourceRecordSetAddress: re-resolve their generated columns and rebuild their
	 * template + DOM. Call this in the RENDER phase (after a source row was added or
	 * removed, before solving + marshaling) so dependent tables paint their column
	 * changes up front instead of mid-marshal. Idempotent and safe when there are no
	 * dependent views (it simply finds none).
	 *
	 * @param {string} pSourceRecordSetAddress - RecordSetAddress whose rows drive the columns.
	 */
	_rebuildDependentDynamicColumnViews(pSourceRecordSetAddress)
	{
		if ((typeof pSourceRecordSetAddress !== 'string') || (pSourceRecordSetAddress.length < 1))
		{
			return;
		}
		if (!this.pict.views.PictFormMetacontroller)
		{
			return;
		}
		let tmpDependentViews = this.pict.views.PictFormMetacontroller.filterViews(
			(pViewToTest) =>
			{
				if (!pViewToTest.isPictSectionForm)
				{
					return false;
				}
				let tmpGroups = pViewToTest.getGroups();
				for (let i = 0; i < tmpGroups.length; i++)
				{
					let tmpDynamicColumns = tmpGroups[i].DynamicColumns;
					if (!Array.isArray(tmpDynamicColumns))
					{
						continue;
					}
					for (let g = 0; g < tmpDynamicColumns.length; g++)
					{
						if (tmpDynamicColumns[g] && (tmpDynamicColumns[g].SourceAddress === pSourceRecordSetAddress))
						{
							return true;
						}
					}
				}
				return false;
			});
		for (let i = 0; i < tmpDependentViews.length; i++)
		{
			let tmpView = tmpDependentViews[i];
			let tmpGroups = tmpView.getGroups();
			for (let g = 0; g < tmpGroups.length; g++)
			{
				let tmpGroup = tmpGroups[g];
				if (Array.isArray(tmpGroup.DynamicColumns) && (tmpGroup.DynamicColumns.length > 0) &&
					this.fable.ManifestFactory && (typeof this.fable.ManifestFactory._resolveDynamicColumns === 'function'))
				{
					this.fable.ManifestFactory._resolveDynamicColumns(tmpView, tmpGroup);
				}
			}
			tmpView.rebuildCustomTemplate();
			tmpView.render();
		}
	}

	/**
	 * For position-keyed DynamicColumns (KeyBy: "Position") sourced from
	 * pSourceRecordSetAddress, shift each dependent row's positional cells down past
	 * a just-removed source index so values stay aligned with their column. Cells are
	 * addressed by resolving the generator's InformaryDataAddressTemplate with the
	 * synthetic { __Index } record, the same way columns are generated. No-op for
	 * value-keyed generators (their data stays attached to the stable value).
	 *
	 * @param {string} pSourceRecordSetAddress - RecordSetAddress of the deleted-from source.
	 * @param {number} pDeletedIndex - Index of the source row that was removed.
	 * @param {number} pOriginalLength - Source row count BEFORE the removal.
	 */
	_spliceDependentPositionalColumns(pSourceRecordSetAddress, pDeletedIndex, pOriginalLength)
	{
		if ((typeof pSourceRecordSetAddress !== 'string') || (pSourceRecordSetAddress.length < 1))
		{
			return;
		}
		if (!this.pict.views.PictFormMetacontroller)
		{
			return;
		}
		let tmpManifestFactory = this.fable.ManifestFactory;
		if (!tmpManifestFactory || (typeof tmpManifestFactory._parseDynamicColumnTemplate !== 'function'))
		{
			return;
		}
		let tmpViews = this.pict.views.PictFormMetacontroller.filterViews((pViewToTest) => { return pViewToTest.isPictSectionForm; });
		for (let v = 0; v < tmpViews.length; v++)
		{
			let tmpView = tmpViews[v];
			let tmpGroups = tmpView.getGroups();
			for (let g = 0; g < tmpGroups.length; g++)
			{
				let tmpGroup = tmpGroups[g];
				if (!Array.isArray(tmpGroup.DynamicColumns) || (tmpGroup.DynamicColumns.length < 1))
				{
					continue;
				}
				let tmpDependentRows = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
				if (!Array.isArray(tmpDependentRows) || (tmpDependentRows.length < 1))
				{
					continue;
				}
				for (let c = 0; c < tmpGroup.DynamicColumns.length; c++)
				{
					let tmpGenerator = tmpGroup.DynamicColumns[c];
					if (!tmpGenerator || (tmpGenerator.SourceAddress !== pSourceRecordSetAddress))
					{
						continue;
					}
					// Only position-keyed generators store data by index; value-keyed columns keep
					// their data attached to the (stable) value, so they need no shifting.
					if (tmpGenerator.KeyBy !== 'Position')
					{
						continue;
					}
					if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string')
					{
						continue;
					}
					// Resolve the positional cell address for each original column index once.
					let tmpAddresses = [];
					for (let k = 0; k < pOriginalLength; k++)
					{
						tmpAddresses[k] = tmpManifestFactory._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, { __Index: k, __RowNumber: k + 1 });
					}
					for (let r = 0; r < tmpDependentRows.length; r++)
					{
						let tmpRow = tmpDependentRows[r];
						if (!tmpRow || (typeof tmpRow !== 'object'))
						{
							continue;
						}
						// Shift every cell below the deleted index down by one.
						for (let k = pDeletedIndex; k < (pOriginalLength - 1); k++)
						{
							if (!tmpAddresses[k] || !tmpAddresses[k + 1])
							{
								continue;
							}
							let tmpNextValue = tmpView.sectionManifest.getValueByHash(tmpRow, tmpAddresses[k + 1]);
							tmpView.sectionManifest.setValueByHash(tmpRow, tmpAddresses[k], tmpNextValue);
						}
						// Clear the now-orphaned final positional cell.
						let tmpLastAddress = tmpAddresses[pOriginalLength - 1];
						if (tmpLastAddress)
						{
							tmpView.sectionManifest.setValueByHash(tmpRow, tmpLastAddress, undefined);
						}
					}
				}
			}
		}
	}

	/**
	 * For position-keyed DynamicColumns (KeyBy: "Position") sourced from
	 * pSourceRecordSetAddress, REORDER each dependent row's positional cells to
	 * mirror a source row that moved from pOldIndex to pNewIndex. The source array
	 * was already spliced (remove at pOldIndex, insert at pNewIndex); this applies
	 * the identical permutation to every dependent row's positional cell VALUES so
	 * the data stays attached to its column when the columns re-resolve to the new
	 * source order. Without it, a reorder leaves user-entered cells under the wrong
	 * (renamed) column. Solver-filled rows re-derive on the next solve regardless;
	 * applying the move to them too is harmless (the solve overwrites them). No-op
	 * for value-keyed generators (their data stays attached to the stable value).
	 *
	 * Must run AFTER the source splice and BEFORE the dependent views re-resolve +
	 * the marshal repaints them. Symmetric with _spliceDependentPositionalColumns.
	 *
	 * @param {string} pSourceRecordSetAddress - RecordSetAddress of the moved-within source.
	 * @param {number} pOldIndex - Source row's index before the move.
	 * @param {number} pNewIndex - Source row's index after the move.
	 * @param {number} pLength - Source row count (unchanged by a move).
	 */
	_moveDependentPositionalColumns(pSourceRecordSetAddress, pOldIndex, pNewIndex, pLength)
	{
		if ((typeof pSourceRecordSetAddress !== 'string') || (pSourceRecordSetAddress.length < 1))
		{
			return;
		}
		if (pOldIndex === pNewIndex)
		{
			return;
		}
		if (!this.pict.views.PictFormMetacontroller)
		{
			return;
		}
		let tmpManifestFactory = this.fable.ManifestFactory;
		if (!tmpManifestFactory || (typeof tmpManifestFactory._parseDynamicColumnTemplate !== 'function'))
		{
			return;
		}
		let tmpViews = this.pict.views.PictFormMetacontroller.filterViews((pViewToTest) => { return pViewToTest.isPictSectionForm; });
		for (let v = 0; v < tmpViews.length; v++)
		{
			let tmpView = tmpViews[v];
			let tmpGroups = tmpView.getGroups();
			for (let g = 0; g < tmpGroups.length; g++)
			{
				let tmpGroup = tmpGroups[g];
				if (!Array.isArray(tmpGroup.DynamicColumns) || (tmpGroup.DynamicColumns.length < 1))
				{
					continue;
				}
				let tmpDependentRows = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
				if (!Array.isArray(tmpDependentRows) || (tmpDependentRows.length < 1))
				{
					continue;
				}
				for (let c = 0; c < tmpGroup.DynamicColumns.length; c++)
				{
					let tmpGenerator = tmpGroup.DynamicColumns[c];
					if (!tmpGenerator || (tmpGenerator.SourceAddress !== pSourceRecordSetAddress))
					{
						continue;
					}
					// Only position-keyed generators store data by index; value-keyed columns keep
					// their data attached to the (stable) value, so they need no reordering.
					if (tmpGenerator.KeyBy !== 'Position')
					{
						continue;
					}
					if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string')
					{
						continue;
					}
					// Resolve the positional cell address for each column index once.
					let tmpAddresses = [];
					for (let k = 0; k < pLength; k++)
					{
						tmpAddresses[k] = tmpManifestFactory._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, { __Index: k, __RowNumber: k + 1 });
					}
					for (let r = 0; r < tmpDependentRows.length; r++)
					{
						let tmpRow = tmpDependentRows[r];
						if (!tmpRow || (typeof tmpRow !== 'object'))
						{
							continue;
						}
						// Read the current positional cell values, apply the identical
						// remove-at-old / insert-at-new permutation, then write them back.
						let tmpValues = [];
						for (let k = 0; k < pLength; k++)
						{
							tmpValues[k] = tmpAddresses[k] ? tmpView.sectionManifest.getValueByHash(tmpRow, tmpAddresses[k]) : undefined;
						}
						let tmpMoved = tmpValues.splice(pOldIndex, 1);
						tmpValues.splice(pNewIndex, 0, tmpMoved[0]);
						for (let k = 0; k < pLength; k++)
						{
							if (tmpAddresses[k])
							{
								tmpView.sectionManifest.setValueByHash(tmpRow, tmpAddresses[k], tmpValues[k]);
							}
						}
					}
				}
			}
		}
	}

	/**
	 * Shared tail for the row-reorder handlers (move up / move down / set index).
	 * Repaints the moved source table and every dependent view, in the RENDER phase
	 * BEFORE solving + marshaling, then solves and marshals. Mirrors what the add /
	 * delete handlers do so a reorder doesn't blank dependent DynamicColumns tables
	 * (or the rest of their section) until the next edit. Render happens before the
	 * solve so the solve's DOM side effects (e.g. SetGroupVisibility) land on the
	 * freshly rebuilt DOM and survive.
	 *
	 * @param {Object} pGroup - The reordered group (its RecordSetAddress drives dependents).
	 */
	_repaintAfterRowReorder(pView, pGroup)
	{
		// A reorder (move up/down/set-index) preserves the row COUNT -- the source table's DOM rows
		// already exist; only which row holds which value changes. A full source-view render() would
		// tear down and re-create every cell widget, and each entity-selector select2 re-init costs
		// roughly O(document size), so on a large form that is SECONDS per move. Skip the source
		// render and let the marshal below push the reordered model values into the existing DOM rows
		// in place. (Add/delete change the row count and still render via their own paths.) Skipping
		// the render also removes the need for the snapshot/restore in _renderViewsPreservingRecordSet:
		// with no destructive render, the entity values are never clobbered.

		// Dependent DynamicColumns views still need their generated column labels re-resolved for the
		// new order (cheap -- those tables carry no entity widgets).
		this._rebuildDependentDynamicColumnViews(pGroup.RecordSetAddress);

		// Run the solver, then marshal the model back out to the existing form DOM.
		this.pict.providers.DynamicSolver.solveViews();
		this.pict.views.PictFormMetacontroller.marshalFormSections();

		// marshalFormSections updates simple cells in place, but a stateful widget (an entity
		// selector's select2) will not switch to a reordered value whose <option> isn't the one it
		// currently shows. Ask each input provider to repaint its display for the new row order:
		// entity selectors force their select2 to the row's current value, everything else no-ops.
		// Cheap (in-place value set, no widget teardown) versus the full re-render this replaced.
		if (pView && (typeof pView.runInputProviderFunctions === 'function'))
		{
			pView.runInputProviderFunctions('onTabularRowReorderRepaint', null, null, this.fable.getUUID());
		}
	}
}

module.exports = DynamicTabularData;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],596:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libDynamicInput = require('../providers/Pict-Provider-DynamicInput.js');

const templateSetDefaultFormTemplates = require('./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js');
const templateSetReadOnlyTemplates = require('./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js');

const libTemplateValueSetWithGroup = require('../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js');
const libTemplateDynamicInput = require('../templates/Pict-Template-Metatemplate-Input.js');
const libTemplateDynamicInputWithHashAddress = require('../templates/Pict-Template-Metatemplate-InputWithHashAddress.js');
const libTemplateDynamicInputWithView = require('../templates/Pict-Template-Metatemplate-InputWithView.js');
const libTemplateDynamicInputWithViewAndHashAddress = require('../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js');
const libTemplateDynamicInputWithViewAndDescriptorAddress = require('../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js');
const libTemplateControlFromDynamicManifest = require('../templates/Pict-Template-ControlFromDynamicManifest.js');
const libTemplateControlFromDynamicManifestForHash = require('../templates/Pict-Template-ControlFromDynamicManifestForHash.js');
const libTemplateGetViewSchemaValue = require('../templates/Pict-Template-DyanmicView-Value.js');
const libTemplateGetViewSchemaValueByHash = require('../templates/Pict-Template-DyanmicView-ValueByHash.js');
const libTemplateTabularRowLabels = require('../templates/Pict-Template-TabularRowLabels.js');
const libTemplateTabularEditingControls = require('../templates/Pict-Template-TabularEditingControls.js');


// TODO: This is temporary until we publish new pict
const libTemplatePluckJoinUnique = require('../templates/Pict-Template-Proxy-PluckJoinUnique.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetaTemplates-Basic",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a class that provides dynamic templates for the Pict form section provider.
 * @extends libPictProvider
 */
class PictDynamicFormsTemplates extends libPictProvider
{
	/**
	 * Constructs a new instance of the PictProviderDynamicTemplates class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		this.pict.addProviderSingleton('DynamicInput', libDynamicInput.default_configuration, libDynamicInput);

		this.pict.addTemplate(libTemplateValueSetWithGroup);
		this.pict.addTemplate(libTemplateDynamicInput);
		this.pict.addTemplate(libTemplateDynamicInputWithHashAddress);
		this.pict.addTemplate(libTemplateDynamicInputWithView);
		this.pict.addTemplate(libTemplateDynamicInputWithViewAndHashAddress);
		this.pict.addTemplate(libTemplateDynamicInputWithViewAndDescriptorAddress);
		this.pict.addTemplate(libTemplatePluckJoinUnique);
		this.pict.addTemplate(libTemplateControlFromDynamicManifest);
		this.pict.addTemplate(libTemplateControlFromDynamicManifestForHash);
		this.pict.addTemplate(libTemplateGetViewSchemaValue);
		this.pict.addTemplate(libTemplateGetViewSchemaValueByHash);
		this.pict.addTemplate(libTemplateTabularRowLabels);
		this.pict.addTemplate(libTemplateTabularEditingControls);

		if (this.options?.MetaTemplateSet && typeof(this.options.MetaTemplateSet) === 'object')
		{
			this.injectTemplateSet(this.options.MetaTemplateSet);
		}
		else
		{
			this.injectTemplateSet(templateSetDefaultFormTemplates);
		}
		this.injectTemplateSet(templateSetReadOnlyTemplates);
	}

	/**
	 * Injects a template set into Pict for the Dynamic Form Section Provider.
	 *
	 * The TemplateSet object expects to have a `TemplatePrefix` and `Templates` property.
	 *
	 * The `TemplatePrefix` is used to prefix the hash of the template.
	 *
	 * The `Templates` property is an array of objects with the following properties:
	 * - `HashPostfix` - The postfix to be added to the template hash.  This defines which dynamic template in the Layout it represents.
	 * - `Template` - The template string to be injected.
	 * - `DefaultInputExtensions` - An optional array of default input extensions to be added to the Dynamic Input provider.
	 *
	 * The context of the template *is not the data*.  The template context is one of these five things depending on the layout layer:
	 * - `Form` - The form object.
	 * - `Section` - The section object.
	 * - `Group` - The group object.
	 * - `Row` - The row object.
	 * - `Input` - The input object.
	 *
	 * @param {Object} pTemplateSet - The template set to be injected.
	 */
	injectTemplateSet(pTemplateSet)
	{
		let tmpTemplatePrefix = 'PictFormsUnknown';
		let tmpTemplates = [];
		let tmpTemplateSet = {};

		tmpTemplatePrefix = this.options?.MetaTemplateSet ?? tmpTemplatePrefix;
		tmpTemplates = this.options?.MetaTemplateSet?.Templates ?? tmpTemplates;

		tmpTemplatePrefix = pTemplateSet?.TemplatePrefix ?? tmpTemplatePrefix;
		tmpTemplates = pTemplateSet?.Templates ?? tmpTemplates;

		for (let i = 0; i < tmpTemplates.length; i++)
		{
			let tmpMetaTemplate = tmpTemplates[i];
			let tmpMetaTemplateHash = `${tmpTemplatePrefix}${tmpMetaTemplate.HashPostfix}`;
			tmpTemplateSet[tmpMetaTemplateHash] = (
				{
					Hash: tmpMetaTemplateHash,
					Template: tmpMetaTemplate.Template
				});
			if (tmpMetaTemplate.hasOwnProperty('DefaultInputExtensions'))
			{
				tmpTemplateSet[tmpMetaTemplateHash].DefaultInputExtensions = JSON.parse(JSON.stringify(tmpMetaTemplate.DefaultInputExtensions));
			}
		}

		for (let i = 0; i < templateSetDefaultFormTemplates.Templates.length; i++)
		{
			let tmpTemplate = templateSetDefaultFormTemplates.Templates[i];
			let tmpTemplateHash = `${tmpTemplatePrefix}${tmpTemplate.HashPostfix}`;
			// Only load default templates if they are not already defined in the options
			if (!(tmpTemplateHash in tmpTemplateSet))
			{
				tmpTemplateSet[tmpTemplateHash] = (
					{
						Hash: tmpTemplateHash,
						Template: tmpTemplate.Template
					});
				if (tmpTemplate.hasOwnProperty('DefaultInputExtensions'))
				{
					tmpTemplateSet[tmpTemplateHash].DefaultInputExtensions = JSON.parse(JSON.stringify(tmpTemplate.DefaultInputExtensions));
				}
			}
		}

		let tmpTemplateList = Object.keys(tmpTemplateSet);
		this.log.info(`Pict Form Section Provider for [${tmpTemplatePrefix}] Loaded ${tmpTemplateList.length} templates.`);
		for (let i = 0; i < tmpTemplateList.length; i++)
		{
			let tmpMetaTemplate = tmpTemplateSet[tmpTemplateList[i]];
			this.pict.TemplateProvider.addTemplate(tmpMetaTemplate.Hash, tmpMetaTemplate.Template);
			if (tmpMetaTemplate.hasOwnProperty('DefaultInputExtensions'))
			{
				for (let i = 0; i < tmpMetaTemplate.DefaultInputExtensions.length; i++)
				{
					this.pict.providers.DynamicInput.addDefaultInputProvider(tmpMetaTemplate.Hash, tmpMetaTemplate.DefaultInputExtensions[i]);
				}
			}
		}
	}
}

module.exports = PictDynamicFormsTemplates;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../providers/Pict-Provider-DynamicInput.js":590,"../templates/Pict-Template-ControlFromDynamicManifest.js":639,"../templates/Pict-Template-ControlFromDynamicManifestForHash.js":640,"../templates/Pict-Template-DyanmicView-Value.js":641,"../templates/Pict-Template-DyanmicView-ValueByHash.js":642,"../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js":643,"../templates/Pict-Template-Metatemplate-Input.js":644,"../templates/Pict-Template-Metatemplate-InputWithHashAddress.js":645,"../templates/Pict-Template-Metatemplate-InputWithView.js":646,"../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js":647,"../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js":648,"../templates/Pict-Template-Proxy-PluckJoinUnique.js":649,"../templates/Pict-Template-TabularEditingControls.js":650,"../templates/Pict-Template-TabularRowLabels.js":651,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js":604,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js":605,"pict-provider":552}],597:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Provider-FormPersistence",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false,

	// Scoping configuration
	// Override the app identifier; defaults to pict.settings.Product
	"AppIdentifier": false,
	// Override the form type identifier; defaults to "DefaultForm"
	"FormTypeIdentifier": false,

	// Auto-persistence settings
	// When true, the provider will automatically persist the active form on data changes
	// triggered from DynamicForm views (dataChanged / dataChangedTabular).
	"AutoPersistOnDataChange": false,
	"AutoPersistDebounceMs": 2000,
	// When true, bundle data is also saved alongside form data during autosave
	// if the active form record has a BundleContextIdentifier.
	"AutoPersistBundleWithForm": true,

	// Storage key prefix
	"StorageKeyPrefix": "PSF",

	// The address to resolve bundle data from (e.g. "Bundle")
	"BundleSourceAddress": "Bundle",
	// The address to resolve form data from; false means use DataBroker.marshalDestination
	"FormDataSourceAddress": false
});

/**
 * Provider for offline form data persistence.
 *
 * Stores form data and bundle data in scoped records (localStorage by default).
 * The wrapping application can override the storage backend by calling setStorageAdapter().
 *
 * This provider is opt-in; the wrapping application registers it when needed.
 *
 * @extends libPictProvider
 */
class PictFormPersistence extends libPictProvider
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {string|null} */
		this._activeFormGUID = null;

		/** @type {any} */
		this._persistTimerHandle = null;

		// Initialize the default localStorage adapter
		this.storageAdapter = this.createLocalStorageAdapter();
	}

	// ========================================================================
	// Storage Adapter
	// ========================================================================

	/**
	 * Creates the default localStorage adapter.
	 *
	 * @returns {object} An adapter object with setItem, getItem, removeItem, getKeysWithPrefix methods.
	 */
	createLocalStorageAdapter()
	{
		let tmpSelf = this;

		return (
		{
			setItem: function (pKey, pValue)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						window.localStorage.setItem(pKey, pValue);
						return true;
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return false;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage setItem error: ${pError.message}`);
					return false;
				}
			},

			getItem: function (pKey)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						return window.localStorage.getItem(pKey);
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return null;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage getItem error: ${pError.message}`);
					return null;
				}
			},

			removeItem: function (pKey)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						window.localStorage.removeItem(pKey);
						return true;
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return false;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage removeItem error: ${pError.message}`);
					return false;
				}
			},

			getKeysWithPrefix: function (pPrefix)
			{
				let tmpKeys = [];
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						for (let i = 0; i < window.localStorage.length; i++)
						{
							let tmpKey = window.localStorage.key(i);
							if (tmpKey && tmpKey.startsWith(pPrefix))
							{
								tmpKeys.push(tmpKey);
							}
						}
					}
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage getKeysWithPrefix error: ${pError.message}`);
				}
				return tmpKeys;
			}
		});
	}

	/**
	 * Replace the storage adapter with a custom implementation.
	 *
	 * The adapter must implement: setItem(key, value), getItem(key), removeItem(key), getKeysWithPrefix(prefix).
	 *
	 * @param {object} pAdapter - The storage adapter to use.
	 * @returns {boolean} True if the adapter was accepted.
	 */
	setStorageAdapter(pAdapter)
	{
		if (typeof (pAdapter) !== 'object' || pAdapter === null)
		{
			this.log.error('FormPersistence setStorageAdapter called with an invalid adapter.');
			return false;
		}

		let tmpRequiredMethods = ['setItem', 'getItem', 'removeItem', 'getKeysWithPrefix'];

		for (let i = 0; i < tmpRequiredMethods.length; i++)
		{
			if (typeof (pAdapter[tmpRequiredMethods[i]]) !== 'function')
			{
				this.log.error(`FormPersistence setStorageAdapter: adapter is missing required method [${tmpRequiredMethods[i]}].`);
				return false;
			}
		}

		this.storageAdapter = pAdapter;
		return true;
	}

	// ========================================================================
	// Key Generation
	// ========================================================================

	/**
	 * Returns the application identifier for storage key scoping.
	 *
	 * @returns {string}
	 */
	getAppIdentifier()
	{
		if (this.options.AppIdentifier)
		{
			return this.options.AppIdentifier;
		}
		if (this.pict && this.pict.settings && this.pict.settings.Product)
		{
			return this.pict.settings.Product;
		}
		return 'DefaultApp';
	}

	/**
	 * Returns the form type identifier for storage key scoping.
	 *
	 * @returns {string}
	 */
	getFormTypeIdentifier()
	{
		if (this.options.FormTypeIdentifier)
		{
			return this.options.FormTypeIdentifier;
		}
		return 'DefaultForm';
	}

	/**
	 * Builds a storage key for a specific record type and identifier.
	 *
	 * @param {string} pRecordType - The record type (e.g. "Form", "Bundle", "Index").
	 * @param {string} [pIdentifier] - The specific record identifier (e.g. GUID or context ID).
	 * @returns {string} The fully qualified storage key.
	 */
	getStorageKey(pRecordType, pIdentifier)
	{
		let tmpPrefix = `${this.options.StorageKeyPrefix}:${this.getAppIdentifier()}:${this.getFormTypeIdentifier()}`;

		if (pIdentifier)
		{
			return `${tmpPrefix}:${pRecordType}:${pIdentifier}`;
		}
		return `${tmpPrefix}:${pRecordType}`;
	}

	/**
	 * Returns the storage key for the form index.
	 *
	 * @returns {string}
	 */
	getIndexKey()
	{
		return this.getStorageKey('Index');
	}

	// ========================================================================
	// Index Management
	// ========================================================================

	/**
	 * Retrieves the form index from storage.
	 *
	 * The index contains metadata for all persisted form records.
	 *
	 * @returns {object} The index object with a Records property.
	 */
	getFormIndex()
	{
		let tmpIndexKey = this.getIndexKey();
		let tmpRawIndex = this.storageAdapter.getItem(tmpIndexKey);

		if (tmpRawIndex)
		{
			try
			{
				let tmpIndex = JSON.parse(tmpRawIndex);
				if (typeof (tmpIndex) === 'object' && tmpIndex !== null && ('Records' in tmpIndex))
				{
					return tmpIndex;
				}
			}
			catch (pError)
			{
				this.log.error(`FormPersistence getFormIndex: failed to parse index: ${pError.message}`);
			}
		}

		// Return a fresh empty index
		return { Records: {} };
	}

	/**
	 * Saves the form index to storage.
	 *
	 * @param {object} pIndex - The index object to persist.
	 * @returns {boolean} True if saved successfully.
	 */
	_saveFormIndex(pIndex)
	{
		let tmpIndexKey = this.getIndexKey();
		return this.storageAdapter.setItem(tmpIndexKey, JSON.stringify(pIndex));
	}

	// ========================================================================
	// Form Data CRUD
	// ========================================================================

	/**
	 * Creates a new form record in the index and returns its GUID.
	 *
	 * This does not save any form data yet; it only creates the index entry.
	 * Call saveFormData() to persist the actual form content.
	 *
	 * @param {string} [pBundleContextIdentifier] - An optional context identifier linking this form to a bundle (e.g. a project ID).
	 * @param {string} [pLabel] - An optional human-readable label for this form instance.
	 * @returns {string} The GUID assigned to the new form record.
	 */
	newFormRecord(pBundleContextIdentifier, pLabel)
	{
		let tmpGUID = this.fable.getUUID();
		let tmpNow = new Date().toISOString();

		let tmpFormIndex = this.getFormIndex();

		tmpFormIndex.Records[tmpGUID] = (
		{
			GUID: tmpGUID,
			Created: tmpNow,
			Modified: tmpNow,
			BundleContextIdentifier: pBundleContextIdentifier || null,
			Synced: false,
			SyncedTimestamp: null,
			Label: pLabel || null
		});

		this._saveFormIndex(tmpFormIndex);

		this.log.info(`FormPersistence: created new form record [${tmpGUID}]${pLabel ? ` labeled "${pLabel}"` : ''}.`);

		return tmpGUID;
	}

	/**
	 * Saves the current in-memory form data to storage for a specific instance GUID.
	 *
	 * Reads from the DataBroker marshal destination (or the configured FormDataSourceAddress).
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to save.
	 * @returns {boolean} True if saved successfully.
	 */
	saveFormData(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence saveFormData called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();
		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.error(`FormPersistence saveFormData called for unknown GUID [${pInstanceGUID}].`);
			return false;
		}

		let tmpFormDataSource;
		try
		{
			if (this.options.FormDataSourceAddress)
			{
				tmpFormDataSource = this.pict.resolveStateFromAddress(this.options.FormDataSourceAddress);
			}
			else
			{
				tmpFormDataSource = this.pict.providers.DataBroker.marshalDestinationObject;
			}
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveFormData: failed to resolve form data source: ${pError.message}`);
			return false;
		}

		let tmpSerializedData;
		try
		{
			tmpSerializedData = JSON.stringify(tmpFormDataSource);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveFormData: failed to serialize form data: ${pError.message}`);
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		let tmpResult = this.storageAdapter.setItem(tmpStorageKey, tmpSerializedData);

		if (tmpResult)
		{
			// Update index metadata
			tmpFormIndex.Records[pInstanceGUID].Modified = new Date().toISOString();
			tmpFormIndex.Records[pInstanceGUID].Synced = false;
			this._saveFormIndex(tmpFormIndex);
		}

		return tmpResult;
	}

	/**
	 * Returns the raw serialized form data string for a given GUID without loading it into memory.
	 *
	 * Useful for synchronization -- the wrapping app can send this directly to the server.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {string|null} The raw JSON string, or null if not found.
	 */
	getFormDataRaw(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence getFormDataRaw called without an instance GUID.');
			return null;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		return this.storageAdapter.getItem(tmpStorageKey);
	}

	/**
	 * Loads form data from storage and applies it to the in-memory marshal destination.
	 *
	 * After loading, calls marshalToView() on the metacontroller if available.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to load.
	 * @returns {boolean} True if loaded successfully.
	 */
	loadFormData(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence loadFormData called without an instance GUID.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		let tmpSerializedData = this.storageAdapter.getItem(tmpStorageKey);

		if (tmpSerializedData === null)
		{
			this.log.warn(`FormPersistence loadFormData: no data found for GUID [${pInstanceGUID}].`);
			return false;
		}

		let tmpFormData;
		try
		{
			tmpFormData = JSON.parse(tmpSerializedData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadFormData: failed to parse stored data for GUID [${pInstanceGUID}]: ${pError.message}`);
			return false;
		}

		// Resolve the destination object
		let tmpDestinationObject;
		try
		{
			if (this.options.FormDataSourceAddress)
			{
				tmpDestinationObject = this.pict.resolveStateFromAddress(this.options.FormDataSourceAddress);
			}
			else
			{
				tmpDestinationObject = this.pict.providers.DataBroker.marshalDestinationObject;
			}
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadFormData: failed to resolve destination object: ${pError.message}`);
			return false;
		}

		// Clear existing data and apply loaded data
		let tmpExistingKeys = Object.keys(tmpDestinationObject);
		for (let i = 0; i < tmpExistingKeys.length; i++)
		{
			delete tmpDestinationObject[tmpExistingKeys[i]];
		}
		Object.assign(tmpDestinationObject, tmpFormData);

		// Marshal to view if the metacontroller is available
		if (this.pict.views && this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalToView();
		}

		this.log.info(`FormPersistence: loaded form data for GUID [${pInstanceGUID}].`);
		return true;
	}

	/**
	 * Deletes a form record from storage and removes it from the index.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to delete.
	 * @returns {boolean} True if deleted successfully.
	 */
	deleteFormRecord(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence deleteFormRecord called without an instance GUID.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		this.storageAdapter.removeItem(tmpStorageKey);

		let tmpFormIndex = this.getFormIndex();
		if (pInstanceGUID in tmpFormIndex.Records)
		{
			delete tmpFormIndex.Records[pInstanceGUID];
			this._saveFormIndex(tmpFormIndex);
		}

		this.log.info(`FormPersistence: deleted form record [${pInstanceGUID}].`);
		return true;
	}

	// ========================================================================
	// Bundle Data
	// ========================================================================

	/**
	 * Saves bundle data for a given context identifier.
	 *
	 * Reads from the configured BundleSourceAddress (default: "Bundle").
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier (e.g. a project ID).
	 * @returns {boolean} True if saved successfully.
	 */
	saveBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence saveBundleData called without a context identifier.');
			return false;
		}

		let tmpBundleData;
		try
		{
			tmpBundleData = this.pict.resolveStateFromAddress(this.options.BundleSourceAddress);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveBundleData: failed to resolve bundle data source: ${pError.message}`);
			return false;
		}

		let tmpSerializedData;
		try
		{
			tmpSerializedData = JSON.stringify(tmpBundleData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveBundleData: failed to serialize bundle data: ${pError.message}`);
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		return this.storageAdapter.setItem(tmpStorageKey, tmpSerializedData);
	}

	/**
	 * Loads bundle data for a given context identifier into the bundle source address.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier (e.g. a project ID).
	 * @returns {boolean} True if loaded successfully.
	 */
	loadBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence loadBundleData called without a context identifier.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		let tmpSerializedData = this.storageAdapter.getItem(tmpStorageKey);

		if (tmpSerializedData === null)
		{
			this.log.warn(`FormPersistence loadBundleData: no data found for context [${pContextIdentifier}].`);
			return false;
		}

		let tmpBundleData;
		try
		{
			tmpBundleData = JSON.parse(tmpSerializedData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadBundleData: failed to parse stored data for context [${pContextIdentifier}]: ${pError.message}`);
			return false;
		}

		// Resolve the bundle destination
		let tmpBundleDestination;
		try
		{
			tmpBundleDestination = this.pict.resolveStateFromAddress(this.options.BundleSourceAddress);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadBundleData: failed to resolve bundle destination: ${pError.message}`);
			return false;
		}

		// Clear existing bundle data and apply loaded data
		let tmpExistingKeys = Object.keys(tmpBundleDestination);
		for (let i = 0; i < tmpExistingKeys.length; i++)
		{
			delete tmpBundleDestination[tmpExistingKeys[i]];
		}
		Object.assign(tmpBundleDestination, tmpBundleData);

		this.log.info(`FormPersistence: loaded bundle data for context [${pContextIdentifier}].`);
		return true;
	}

	/**
	 * Deletes bundle data for a given context identifier.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier.
	 * @returns {boolean} True if deleted successfully.
	 */
	deleteBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence deleteBundleData called without a context identifier.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		this.storageAdapter.removeItem(tmpStorageKey);

		this.log.info(`FormPersistence: deleted bundle data for context [${pContextIdentifier}].`);
		return true;
	}

	// ========================================================================
	// Listing
	// ========================================================================

	/**
	 * Returns an array of all form record metadata objects from the index.
	 *
	 * @returns {Array<object>} An array of form record metadata.
	 */
	listFormRecords()
	{
		let tmpFormIndex = this.getFormIndex();
		return Object.values(tmpFormIndex.Records);
	}

	/**
	 * Returns an array of form records that have not been marked as synced.
	 *
	 * @returns {Array<object>} An array of unsynced form record metadata.
	 */
	listUnsyncedFormRecords()
	{
		let tmpRecords = this.listFormRecords();
		let tmpUnsynced = [];

		for (let i = 0; i < tmpRecords.length; i++)
		{
			if (!tmpRecords[i].Synced)
			{
				tmpUnsynced.push(tmpRecords[i]);
			}
		}

		return tmpUnsynced;
	}

	/**
	 * Returns an array of form records associated with a specific bundle context.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier.
	 * @returns {Array<object>} An array of matching form record metadata.
	 */
	listFormRecordsForContext(pContextIdentifier)
	{
		let tmpRecords = this.listFormRecords();
		let tmpMatching = [];

		for (let i = 0; i < tmpRecords.length; i++)
		{
			if (tmpRecords[i].BundleContextIdentifier === pContextIdentifier)
			{
				tmpMatching.push(tmpRecords[i]);
			}
		}

		return tmpMatching;
	}

	// ========================================================================
	// Sync Support
	// ========================================================================

	/**
	 * Marks a form record as synced.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {boolean} True if the record was found and updated.
	 */
	markFormSynced(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence markFormSynced called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();

		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.warn(`FormPersistence markFormSynced: GUID [${pInstanceGUID}] not found in index.`);
			return false;
		}

		tmpFormIndex.Records[pInstanceGUID].Synced = true;
		tmpFormIndex.Records[pInstanceGUID].SyncedTimestamp = new Date().toISOString();
		this._saveFormIndex(tmpFormIndex);

		return true;
	}

	/**
	 * Marks a form record as dirty (unsynced).
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {boolean} True if the record was found and updated.
	 */
	markFormDirty(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence markFormDirty called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();

		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.warn(`FormPersistence markFormDirty: GUID [${pInstanceGUID}] not found in index.`);
			return false;
		}

		tmpFormIndex.Records[pInstanceGUID].Synced = false;
		this._saveFormIndex(tmpFormIndex);

		return true;
	}

	// ========================================================================
	// Active Form Management
	// ========================================================================

	/**
	 * Gets the currently active form instance GUID.
	 *
	 * @returns {string|null} The active form GUID, or null if none is set.
	 */
	getActiveFormGUID()
	{
		return this._activeFormGUID;
	}

	/**
	 * Sets the active form instance GUID.
	 *
	 * This is used by persistActiveForm() and triggerDebouncedPersist().
	 *
	 * @param {string} pInstanceGUID - The GUID to set as active.
	 */
	setActiveFormGUID(pInstanceGUID)
	{
		this._activeFormGUID = pInstanceGUID || null;
	}

	/**
	 * Saves the currently active form's data to storage.
	 *
	 * When AutoPersistBundleWithForm is true and the active form record has
	 * a BundleContextIdentifier, the bundle data is also persisted.
	 *
	 * @returns {boolean} True if persisted successfully, false if no active form or save failed.
	 */
	persistActiveForm()
	{
		if (!this._activeFormGUID)
		{
			this.log.warn('FormPersistence persistActiveForm: no active form GUID set.');
			return false;
		}

		let tmpResult = this.saveFormData(this._activeFormGUID);

		// Also persist the associated bundle context if configured
		if (tmpResult && this.options.AutoPersistBundleWithForm)
		{
			let tmpFormIndex = this.getFormIndex();
			let tmpRecord = tmpFormIndex.Records[this._activeFormGUID];
			if (tmpRecord && tmpRecord.BundleContextIdentifier)
			{
				this.saveBundleData(tmpRecord.BundleContextIdentifier);
			}
		}

		return tmpResult;
	}

	/**
	 * Triggers a debounced persist of the active form.
	 *
	 * Call this from a dataChanged handler to avoid persisting on every keystroke.
	 * The persist fires after AutoPersistDebounceMs of inactivity.
	 */
	triggerDebouncedPersist()
	{
		if (!this._activeFormGUID)
		{
			return;
		}

		if (this._persistTimerHandle)
		{
			clearTimeout(this._persistTimerHandle);
		}

		let tmpSelf = this;
		this._persistTimerHandle = setTimeout(
			function ()
			{
				tmpSelf.persistActiveForm();
				tmpSelf._persistTimerHandle = null;
			},
			this.options.AutoPersistDebounceMs);
	}

	/**
	 * Called by DynamicForm views when data changes (dataChanged or dataChangedTabular).
	 *
	 * When AutoPersistOnDataChange is enabled, triggers a debounced persist.
	 * This method exists as the integration hook between the form lifecycle and
	 * the persistence provider -- the DynamicForm view calls this if the provider exists.
	 */
	onFormDataChanged()
	{
		if (this.options.AutoPersistOnDataChange)
		{
			this.triggerDebouncedPersist();
		}
	}
}

module.exports = PictFormPersistence;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],598:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// TODO: Pull this back to pict as a core service once we are happy with the shape.
/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Informary",

	"AutoInitialize": false,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a provider for dynamic forms in the PICT system.
 * Extends the `libPictProvider` class.
 */
class PictDynamicFormsInformary extends libPictProvider
{
	/**
	 * Creates an instance of the `PictDynamicFormsInformary` class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { newManyfest: (options: any) => import('manyfest') }} */
		this.pict;
		/** @type {any} */
		this.log;

		this.genericManifest = this.pict.newManyfest({Scope:'GenericInformary'});
	}

	/**
	 * Retrieves all form elements for a given form hash.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @returns {HTMLElement[]} - An array of HTML elements representing the form elements.
	 */
	getFormElements(pFormHash)
	{
		let tmpSelector = `[data-i-form="${pFormHash}"]`;
		//this.log.trace(`Getting form elements for form hash selector: ${tmpSelector}`);
		return this.pict.ContentAssignment.getElement(tmpSelector);
	}

	/**
	 * Get a full content browser address based on the form, datum and optionally the container and index.
	 *
	 * This can be used in getDomElementByAddress or jquery selectors to return the element.
	 *
	 * @param {string} pFormHash - The form hash.
	 * @param {string} pDatumHash - The datum hash.
	 * @param {string|null} pContainer - The container (optional).
	 * @param {string|number} pIndex - The index.
	 * @returns {string} The content browser address.
	 */
	getContentBrowserAddress(pFormHash, pDatumHash, pContainer, pIndex)
	{
		// TODO: Need some guards, yo
		if (pContainer)
		{
			return `[data-i-form="${pFormHash}"][data-i-datum="${pDatumHash}"][data-i-container="${pContainer}"][data-i-index="${pIndex}"]`;
		}
		else
		{
			return `[data-i-form="${pFormHash}"][data-i-datum="${pDatumHash}"]`;
		}
	}

	/**
	 * Returns the composed container address string for a given container, index, and datum hash.
	 *
	 * @param {string} pContainer - The container name.
	 * @param {string|number} pIndex - The index of the container.
	 * @param {string} pDatumHash - The datum hash.
	 * @returns {string} The composed container address.
	 */
	getComposedContainerAddress(pContainer, pIndex, pDatumHash)
	{
		return `${pContainer}[${pIndex}].${pDatumHash}`;
	}

	/**
	 * Marshals form data to the provided application state data object using the given form hash and manifest.
	 *
	 * @param {object} pAppStateData - The application state data object to marshal the form data to.
	 * @param {string} pFormHash - The form hash representing the form elements.
	 * @param {import('manyfest')} pManifest - The manifest object used to map form data to the application state data.
	 * @param {string} [pDatum] - The datum hash to pull in.  If not provided, all data is marshalled.
	 * @param {number|string} [pRecordIndex] - The record index to pull in.  If not provided, all data is marshalled.
	 */
	marshalFormToData(pAppStateData, pFormHash, pManifest, pDatum, pRecordIndex)
	{
		const tmpManifest = typeof(pManifest) === 'object' ? pManifest : this.genericManifest;
		const tmpFormElements = this.getFormElements(pFormHash);

		// Optional Filters (so we don't just blindly do the whole form)
		const tmpDatum = (pDatum == null) ? false : pDatum;
		const tmpRecordIndex = (typeof(pRecordIndex) === 'number') ? String(pRecordIndex) : pRecordIndex;

		// Enumerate the form elements, and put data in them for each address
		for (const tmpFormElement of tmpFormElements)
		{
			this.marshalSpecicificFormElementToData(pFormHash, tmpFormElement, tmpManifest, pAppStateData, tmpDatum, tmpRecordIndex);
		}
	}

	/**
	 * Marshals a specific form element's data to the application state data.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @param {HTMLElement} pFormElement - The form element to marshal.
	 * @param {import('manyfest')} pManifest - The manifest object to set values.
	 * @param {Object} pAppStateData - The application state data object.
	 * @param {any} [pDatumFilter] - Optional filter for datum address.
	 * @param {any} [pRecordIndexFilter] - Optional filter for record index.
	 * @returns {boolean} - Returns false if the element falls outside the filters or if the browser value is null.
	 */
	marshalSpecicificFormElementToData(pFormHash, pFormElement, pManifest, pAppStateData, pDatumFilter, pRecordIndexFilter)
	{
		const tmpDatumAddress = pFormElement.getAttribute('data-i-datum');

		const tmpContainerAddress = pFormElement.getAttribute('data-i-container');
		const tmpIndex = pFormElement.getAttribute('data-i-index');

		// Process the filters
		// TODO: Now that this is a function, having these filters here is not good.  We need to move this to the caller.  But the above getAttribute is required... rethink filtering?
		if (pDatumFilter && (pDatumFilter !== tmpDatumAddress))
		{
			// Falls outside the filter, continue on
			return false;
		}
		if (pRecordIndexFilter && tmpIndex && pRecordIndexFilter !== tmpIndex)
		{
			// Falls outside the filter, continue on
			return false;
		}

		let tmpBrowserValue = this.pict.ContentAssignment.readContent(this.getContentBrowserAddress(pFormHash, tmpDatumAddress, tmpContainerAddress, tmpIndex));
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`Informary marshalling BrowserForm Data ${tmpBrowserValue} from form element [${tmpDatumAddress}] in container [${tmpContainerAddress}] at index [${tmpIndex}] to the datum address [${tmpDatumAddress}].`);
		}

		if (tmpBrowserValue == null)
		{
			return false;
		}

		if (!tmpContainerAddress)
		{
			pManifest.setValueAtAddress(pAppStateData, tmpDatumAddress, tmpBrowserValue);
		}
		else
		{
			// Compose the address .. right now only arrays
			pManifest.setValueAtAddress(pAppStateData, this.getComposedContainerAddress(tmpContainerAddress, tmpIndex, tmpDatumAddress), tmpBrowserValue);
		}
		return true;
	}

	/**
	 * Marshals data from some application state object to a specific subset of browser form elements.
	 *
	 * @param {object} pAppStateData - The application state data to marshal into the form.  Usually AppData but can be other objects.
	 * @param {string} pFormHash - The hash of the form to marshal data into.  This is the data-i-form attribute.
	 * @param {import('manyfest')} pManifest - The manifest object.  If not provided, the generic manifest is used.
	 */
	marshalDataToForm(pAppStateData, pFormHash, pManifest)
	{
		// TODO: Take a list of hashes and/or index addresses to marshal in, preventing OVERMARSHAL from taking control
		let tmpManifest = typeof(pManifest) === 'object' ? pManifest : this.genericManifest;
		let tmpFormElements = this.getFormElements(pFormHash);

		// Enumerate the form elements, and put data in them for each address
		for (let i = 0; i < tmpFormElements.length; i++)
		{
			this.marshalSpecificElementDataToForm(tmpFormElements[i], tmpManifest, pAppStateData);
		}
	}

	/**
	 * Marshals specific element data to a form.
	 *
	 * @param {HTMLElement} pFormElement - The form element to marshal data to.
	 * @param {import('manyfest')} pManifest - The manifest object containing data retrieval methods.
	 * @param {Record<string, any>} pAppStateData - The application state data.
	 * @returns {boolean} Returns false if the form element does not have a datum address.
	 */
	marshalSpecificElementDataToForm(pFormElement, pManifest, pAppStateData)
	{
		let tmpDatumAddress = pFormElement.getAttribute('data-i-datum');

		let tmpContainerAddress = pFormElement.getAttribute('data-i-container');
		let tmpIndex = Number(pFormElement.getAttribute('data-i-index'));

		if (!tmpDatumAddress)
		{
			this.log.warn(`Informary found a form element without a datum address.  Skipping.`);
			return false;
		}

		if (!tmpContainerAddress)
		{
			let tmpAppStateValue = pManifest.getValueAtAddress(pAppStateData, tmpDatumAddress);

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`Informary marshalling App State data ${tmpAppStateValue} to Browser Form element [${tmpDatumAddress}].`);
			}

			if (tmpAppStateValue != null)
			{
				this.pict.ContentAssignment.assignContent(pFormElement, tmpAppStateValue);
			}
		}
		else
		{
			let tmpAppStateValue = pManifest.getValueAtAddress(pAppStateData, this.getComposedContainerAddress(tmpContainerAddress, tmpIndex, tmpDatumAddress));

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`Informary marshalling App State data ${tmpAppStateValue} to Browser Form element [${tmpDatumAddress}] in container [${tmpContainerAddress}] at index [${tmpIndex}].`);
			}

			if (tmpAppStateValue != null)
			{
				this.pict.ContentAssignment.assignContent(pFormElement, tmpAppStateValue);
			}
		}
		return true;
	}

	/**
	 * Manually marshals data to a form by assigning content based on context in the descriptor.
	 * @param {Record<string, any>} pInput - The input manifest descriptor to marshal data to form from.
	 * @returns boolean if assignment was successful
	 */
	manualMarshalDataToFormByInput(pInput)
	{
		if (typeof(pInput) !== 'object')
		{
			this.log.error(`Informary failed to marshal data to form because the input is not an object.`);
			return false;
		}
		if (!('Hash' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a hash.`);
			return false;
		}
		if (!('PictForm' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a PictForm object.`);
			return false;
		}
		let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
		if (!tmpInputView)
		{
			this.log.error(`Informary failed to marshal data to form because the input view is missing.`);
			return false;
		}
		return this.pict.ContentAssignment.assignContent(pInput.Macro.HTMLSelector, tmpInputView.getValueByHash(pInput.Hash));
	}

	/**
	 * Manually marshals tabular data to a form by assigning content based on context in the descriptor.
	 * @param {object} pInput - The input manifest descriptor to marshal data to form from.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns boolean if assignment was successful
	 */
	manualMarshalTabularDataToFormByInput(pInput, pRowIndex)
	{
		if (typeof(pInput) !== 'object')
		{
			this.log.error(`Informary failed to marshal data to form because the input is not an object.`);
			return false;
		}
		if (!('Hash' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a hash.`);
			return false;
		}
		if (!('PictForm' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a PictForm object.`);
			return false;
		}
		let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
		if (!tmpInputView)
		{
			this.log.error(`Informary failed to marshal data to form because the input view is missing.`);
			return false;
		}
		return this.pict.ContentAssignment.assignContent(`${pInput.Macro.HTMLSelectorTabular}[data-i-index="${pRowIndex}"]`,
			tmpInputView.getTabularValueByHash(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex));
	}

	/**
	 * Manually marshals data to a form by assigning content to a specified HTML address.
	 *
	 * @param {string} pHTMLAddress - The HTML address where the content should be assigned.
	 * @param {string} pValue - The value to be assigned to the specified HTML address.
	 */
	manualMarshalDataToForm(pHTMLAddress, pValue)
	{
		return this.pict.ContentAssignment.assignContent(pHTMLAddress, pValue);
	}

	/**
	 * Manually marshals tabular data to a form.
	 *
	 * @param {string} pHTMLAddress - The HTML address where the data should be assigned.
	 * @param {string} pValue - The value to be assigned to the form element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 */
	manualMarshalTabularDataToForm(pHTMLAddress, pValue, pRowIndex)
	{
		return this.pict.ContentAssignment.assignContent(`${pHTMLAddress}[data-i-index="${pRowIndex}"]`, pValue);
	}
}

module.exports = PictDynamicFormsInformary;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],599:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-InputExtension",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictInputExtensionProvider class is a provider that allows extensions to the input fields of a form.
 *
 * Can be mapped in via the PictForm property of a descriptor.
 */
class PictInputExtensionProvider extends libPictProvider
{
	/**
	 * Creates an instance of the PictInputExtensionProvider class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}


	/**
	 * Generates the HTML ID for a custom input element based on the given input HTML ID.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @returns {string} The generated input HTML ID.
	 */
	getInputHTMLID(pInputHTMLID)
	{
		return `#INPUT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a hidden input element in a tabular data provider.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns {string} - The generated HTML ID for the hidden input element.
	 */
	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * An input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {number} pRowIndex - The row index of the tabular data
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the input in the row columns.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Repaint this input's rendered display from the model after a tabular row REORDER
	 * (move up/down/set-index), which preserves the row count but changes which row holds
	 * which value. A plain marshal updates simple inputs in place, but stateful widgets
	 * (e.g. an entity-selector's select2) will not switch to a value whose option isn't the
	 * one currently shown; those providers override this to force their display to the row's
	 * current value. Default is a no-op.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to display.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true.
	 */
	onTabularRowReorderRepaint(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Tabular sibling of onTabularRowReorderRepaint. Default is a no-op.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to display.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true.
	 */
	onTabularRowReorderRepaintTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean} - Returns true.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @returns {boolean} - Returns true.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return true;
	}


	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		return true;
	}
}

module.exports = PictInputExtensionProvider;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],600:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-ListDistilling",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictListDistilling class is a provider that filters lists based on input rules.
 */
class PictListDistilling extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/*
	  * This is a sidecar just for making filtration simpler.
	  *
	  * Types of Filtration:
	  * 1. Filter by an explicit value list (union of a set of values)
	  *   Example (explicit:
	  *		{ FilterType: "Explicit", FilterList: ["B", "C"] }
	  *   Example (implicit):
	  * 	{ FilterType: "Explicit", FilterListAddress: 'AppData.Bundle.Colors' }
	  * 2. Filter by a cross-map to a "join" list
	  *   Example (explicit):
	  * 	{ FilterType: "CrossMap", FilterValue:10, FilterValueAddress:'IDColor', FilterValueLookupAddress:'AppData.CurrentSelections.IDColor', FilterMap: [{IDColor:10, IDFruit:20}, {IDColor:10, IDFruit:30, {IDColor:20, IDFruit:30}] }
	  *   Example (implicit):
	  * 	{ FilterType: "CrossMap", FilterValue:10, FilterValueAddress:'IDColor', FilterValueLookupAddress:'AppData.CurrentSelections.IDColor', FilterMapAddress: 'AppData.Bundle.ColorFruitJoin' }
	  * 3. Filter by a string match (from an address?!  Would be cool)
	  *   Example:
	  * 	{ FilterType: "StringMatch", StringMatch: '*Apple* }
	  */
	/**
	  * Filter a list of options based on the filtering rules in a dynamic form input.
	  *
	  * Example Configuration:
	  * ...
			"ListFilterRules": [
					{
						"Filter": "Colour Entry Filter",
						"FilterType": "Explicit",
						"FilterValueComparison": "==",
						"FilterValueAddress": "Listopia.Filters.Colour",
						"IgnoreEmptyValue": true
					},
					{
						"Filter": "Colour List Distilling Filter",
						"FilterType": "CrossMap",
						"JoinListAddress": "View.sectionDefinition.Intersections.Colors.FruitSelectionColorsJoin",
						"JoinListAddressGlobal": true,
						"JoinListValueAddress": "GUIDColors",
						"ExternalValueAddress": "GUIDFruitSelection",
						"FilterToValueAddress": "Listopia.Fruit",
						"IgnoreEmpty": true
					}
				],
	  * ...
	  *
	  * @param {Object} pView - The pict view the list is within
	  * @param {*} pInput - The input within the dynamic forms view
	  * @param {*} pList - The raw list of options to filter
	  * @param {number} [pRowIndex] - The tabular row the list is for; Facet rules read sibling values from this row
	  * @returns
	  */
	filterList(pView, pInput, pList, pRowIndex)
	{
		// The list is expected to be an array of objects with "id" and "text" properties.  This is because of Select2.
		if (typeof(pInput) != 'object')
		{
			this.log.warn(`FilterList failed because the input is not an object.`);
			return pList;
		}
		if (!('PictForm' in pInput))
		{
			this.log.warn(`FilterList failed because the input does not have a PictForm stanza object.`);
			return pList;
		}
		if (!Array.isArray(pList))
		{
			this.log.warn(`FilterList for input [${pInput.Hash}] failed because the list is not an array.`);
			return [];
		}
		let tmpFilterRules = pInput.PictForm.ListFilterRules;
		if ((!tmpFilterRules) || (tmpFilterRules.length == 0) || (!Array.isArray(tmpFilterRules)))
		{
			return pList;
		}

		// Facet rules resolve to a set of allowed values once per list build rather than once per option.
		const tmpFacetAllowedValues = tmpFilterRules.map((pRule) => (pRule && (pRule.FilterType === 'Facet')) ? this.getFacetOfferedValues(pView, pInput, pRule, pRowIndex) : null);

		// Make a copy of the incoming list of options
		let tmpFilteredList = pList.slice(0);
		// We walk backwards so we can remove items from the end without breaking this loop.
		for (let h = pList.length - 1; h >= 0; h--)
		{
			let tmpListEntry = pList[h];
			let tmpEntryAllowed = true;
			for (let i = 0; i < tmpFilterRules.length; i++)
			{
				let tmpFilterRule = tmpFilterRules[i];

				// Remember that options are objects with "id" and "text" properties.  Because of Select2.
				// Genericising this with templating.  Most users will not leverage this technology.
				let tmpRecordComparisonValueAddress = ('FilteredRecordComparisonValue' in tmpFilterRule) ? tmpFilterRule.FilteredRecordComparisonValueAddress : false;
				let tmpComparisonValue;
				if (!tmpRecordComparisonValueAddress)
				{
					// Presume it's filtering on 'id'
					tmpComparisonValue = tmpListEntry.id;
				}
				else
				{
					tmpComparisonValue = pView.getValueByHash(tmpRecordComparisonValueAddress);
				}

				switch(tmpFilterRule.FilterType)
				{
					case 'Explicit':
						let tmpExplicitFilterValueAddress = tmpFilterRule.FilterValueAddress;
						let tmpExplicitFilterValueComparison = ('FilterValueComparison' in tmpFilterRule) ? tmpFilterRule.FilterValueComparison : '==';
						let tmpExplicitFilterIgnoreEmpty = ('IgnoreEmptyValue' in tmpFilterRule) ? tmpFilterRule.IgnoreEmptyValue : false;

						// TODO: This can be massively optimized by only solving this when something changes in the data location.
						//       Cache invalidation will be a PITA on this one.
						let tmpExplicitFilterValue = pView.getValueByHash(tmpExplicitFilterValueAddress);

						if (tmpExplicitFilterIgnoreEmpty && ((!tmpExplicitFilterValue) || (tmpExplicitFilterValue == '')))
						{
							// The comparison value is empty, so ignore it.
							break;
						}

						// Now check each value in the list to see if it matches the filter.
						switch(tmpExplicitFilterValueComparison.toLowerCase())
						{
							// Equal To
							case '=':
							case '==':
							case 'eq':
								if (tmpComparisonValue != tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} != ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;

							// Not Equal
							case '!=':
							case 'ne':
								if (tmpComparisonValue == tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} == ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;

							// Approximately Equal
							case '~=':
							case 'ae':
								if (tmpComparisonValue == tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} == ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;
						}
						break;

					case 'CrossMap':
						// Filter based on a list of "join" records, with:
						// A "JoinListAddress" address - where to find the list of joins in the application state
						// A "JoinListAddressGlobal" boolean - if the list is global or not (global means scoped to pict vs appdata/state location)
						// A "JoinListValueAddress" address - the address within the record that maps to the ID of the list value
						// A "ExternalValueAddress" address - the address of the external value we are comparing to
						// A "FilterToValueAddress" address - the external address to use to see if the ExternalValue matches
						// A "IgnoreEmpty" boolean - makes the tech ignore empty ExternalValue (including undefined etc.)
						//
						// So for example, if you had a list of Colors with id: "Red", "Green", "Blue"
						/*
							...And you had a list of joins they would be something like:
							AppData.BrandList [
								{ Brand: "Santa", DominantColor: "Red"},
								{ Brand: "Subaru", DominantColor: "Off White"},
								{ Brand: "Subaru", DominantColor: "Green"},
								{ Brand: "IBM", DominantColor: "Blue"},
								{ .... }
							]

							...And somewhere else we had the following state:

							AppData.SelectedBrand: "Subaru"
						*/
						/*
							The values would be:
								-> JoinListAddress: "AppData.BrandList"
								-> JoinListAddressGlobal: false
								-> JoinListValueAddress: "Record.Color"          <-- (this maps to the id in the select list)
								-> ExternalValueAddress: "Record.Brand"          <-- (this maps to the id for the external lookup)
								-> FilterToValueAddress: "AppData.SelectedBrand"
								-> IgnoreEmpty: true                             <-- Don't filter if the AppData.SelectedBrand is an empty string or such
						*/
						let tmpJoinListAddress = tmpFilterRule.JoinListAddress;
						let tmpJoinListAddressGlobal = ('JoinListAddressGlobal' in tmpFilterRule) ? tmpFilterRule.JoinListAddressGlobal : false;
						let tmpJoinListValueAddress = tmpFilterRule.JoinListValueAddress;
						let tmpExternalValueAddress = tmpFilterRule.ExternalValueAddress;
						let tmpFilterToValueAddress = tmpFilterRule.FilterToValueAddress;
						let tmpIgnoreEmpty = ('IgnoreEmpty' in tmpFilterRule) ? tmpFilterRule.IgnoreEmpty : false;

						let tmpJoinList;

						if (tmpJoinListAddressGlobal)
						{
							const tmpAddressSpace =
							{
								Fable: this.pict,
								Pict: this.pict,
								AppData: this.pict.AppData,
								Bundle: this.pict.Bundle,
								View: pView,
							};

							tmpJoinList = this.pict.manifest.getValueAtAddress(tmpAddressSpace, tmpJoinListAddress);
						}
						else
						{
							tmpJoinList = pView.getValueByHash(tmpJoinListAddress);
						}
						let tmpFilterToValueAddressValue = pView.getValueByHash(tmpFilterToValueAddress);

						if (tmpIgnoreEmpty && ((!tmpFilterToValueAddressValue) || (tmpFilterToValueAddressValue == '')))
						{
							// The comparison value is empty, so ignore it.
							break;
						}
						if ((!Array.isArray(tmpJoinList)) && (tmpJoinList != null) && (typeof(tmpJoinList) == 'object'))
						{
							let tmpJoinListKeys = Object.keys(tmpJoinList);
							let tmpNewJoinList = [];
							for (let i = 0; i < tmpJoinListKeys.length; i++)
							{
								tmpNewJoinList.push(tmpJoinList[tmpJoinListKeys[i]]);
							}
							tmpJoinList = tmpNewJoinList;
						}

						if ((!Array.isArray(tmpJoinList)) || (tmpJoinList.length == 0))
						{
							// The join list is not an array.  We can't filter it.
							break;
						}

						//this.pict.log.trace(`FilterList: CrossMap: JoinListAddress[${tmpJoinListAddress}](${tmpJoinList.length})->${tmpJoinListValueAddress} ExternalValueAddress[${tmpExternalValueAddress}] FilterToValueAddress[${tmpFilterToValueAddress}]`);

						// TODO: This is not industrial grade, yo.  Small lists only please.  O(n^2) is not cool.
						let tmpPossiblyAllowed = false;
						for (let i = 0; i < tmpJoinList.length; i++)
						{
							let tmpJoinListValue = this.pict.manifest.getValueAtAddress(tmpJoinList[i], tmpJoinListValueAddress);
							let tmpExternalValue = this.pict.manifest.getValueAtAddress(tmpJoinList[i], tmpExternalValueAddress);

							if (tmpIgnoreEmpty && ((!tmpJoinListValue) || (tmpJoinListValue == '')))
							{
								// The comparison value is empty, so ignore it.
								continue;
							}

							//this.pict.log.trace(`          CrossMap Test: JoinListValue[${tmpJoinListValue}]<==>ComparisonValue[${tmpComparisonValue}] ExternalValue[${tmpExternalValue}]<==>FilterToValue[${tmpFilterToValueAddressValue}]`);
							if ((tmpFilterToValueAddressValue == tmpExternalValue) && (tmpJoinListValue == tmpComparisonValue))
							{
								//this.pict.log.trace(`   !!! CrossMap: Matched: ${tmpJoinListValue} == ${tmpComparisonValue} && ${tmpExternalValue} == ${tmpFilterToValueAddressValue}`);
								tmpPossiblyAllowed = true;
								break;
							}
						}
						tmpEntryAllowed = tmpPossiblyAllowed && tmpEntryAllowed;

						break;

					case 'Facet':
						if (tmpFacetAllowedValues[i] && !tmpFacetAllowedValues[i].has(String(tmpComparisonValue)))
						{
							tmpEntryAllowed = false;
						}
						break;

					default:
						// See if there is a provider for it
						let tmpProvider = this.pict.providers[tmpFilterRule.FilterType];
						if (tmpProvider)
						{
							// Your provider could do anything here.
							// We may want a second place to bolt one of these on
							tmpEntryAllowed = tmpProvider.filterList(pView, pInput, pList, tmpListEntry);
						}
						break;
				}
			}

			if (!tmpEntryAllowed)
			{
				tmpFilteredList.splice(h,1);
			}
		}

		//this.log.trace(`FilterList: Input [${pInput.Hash}] has [${pList.length}] options to filter with [${tmpFilterRules.length}] rules.`);

		return tmpFilteredList;
	}

	/**
	 * @param {Record<string, any>} pInput
	 * @return {Record<string, any>|null} the input's Facet rule, if it has one
	 */
	getFacetRule(pInput)
	{
		const tmpRules = pInput && pInput.PictForm && pInput.PictForm.ListFilterRules;
		if (!Array.isArray(tmpRules))
		{
			return null;
		}
		return tmpRules.find((pRule) => pRule && (pRule.FilterType === 'Facet')) || null;
	}

	/**
	 * @param {Object} pView
	 * @param {Record<string, any>} pRule
	 * @return {Array<any>} the join list a Facet rule distills, as an array
	 */
	getFacetJoinList(pView, pRule)
	{
		let tmpJoinList;
		if (pRule.JoinListAddressGlobal)
		{
			const tmpAddressSpace = { Fable: this.pict, Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle, View: pView };
			tmpJoinList = this.pict.manifest.getValueAtAddress(tmpAddressSpace, pRule.JoinListAddress);
		}
		else
		{
			tmpJoinList = pView.getValueByHash(pRule.JoinListAddress);
		}
		if (Array.isArray(tmpJoinList))
		{
			return tmpJoinList;
		}
		if (tmpJoinList && (typeof(tmpJoinList) === 'object'))
		{
			return Object.values(tmpJoinList);
		}
		return [];
	}

	/**
	 * Every input that shares a Facet rule's join list with pInput, in the same tabular row (or the same
	 * view, outside a table), with the value it currently holds.  pInput itself is included.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {number} [pRowIndex]
	 * @return {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>}
	 */
	getFacetSiblings(pView, pInput, pRowIndex)
	{
		const tmpRule = this.getFacetRule(pInput);
		if (!tmpRule)
		{
			return [];
		}
		const tmpSiblings = [];
		const fAdd = (pSiblingInput, fGetValue) =>
		{
			const tmpSiblingRule = this.getFacetRule(pSiblingInput);
			if (tmpSiblingRule && (tmpSiblingRule.JoinListAddress === tmpRule.JoinListAddress))
			{
				tmpSiblings.push({ Input: pSiblingInput, Rule: tmpSiblingRule, Value: fGetValue(pSiblingInput) });
			}
		};
		const tmpIsTabular = (typeof(pRowIndex) === 'number') || ((typeof(pRowIndex) === 'string') && (pRowIndex !== ''));
		if (tmpIsTabular)
		{
			const tmpGroupIndex = pInput.PictForm.GroupIndex;
			const tmpGroup = pView.getGroup(tmpGroupIndex);
			const tmpRecord = pView.getTabularRecordData(tmpGroupIndex, pRowIndex) || {};
			const tmpAddresses = (tmpGroup && tmpGroup.supportingManifest) ? tmpGroup.supportingManifest.elementAddresses : [];
			for (let i = 0; i < tmpAddresses.length; i++)
			{
				const tmpSiblingInput = pView.getTabularRecordInput(tmpGroupIndex, i);
				if (tmpSiblingInput)
				{
					fAdd(tmpSiblingInput, (pSibling) => tmpGroup.supportingManifest.getValueByHash(tmpRecord, pSibling.DataAddress || tmpAddresses[i]));
				}
			}
			return tmpSiblings;
		}
		const tmpDescriptors = (pView.sectionManifest && pView.sectionManifest.elementDescriptors) ? pView.sectionManifest.elementDescriptors : {};
		for (const tmpAddress of Object.keys(tmpDescriptors))
		{
			const tmpSiblingInput = tmpDescriptors[tmpAddress];
			if (tmpSiblingInput && tmpSiblingInput.PictForm && !tmpSiblingInput.IsTabular)
			{
				fAdd(tmpSiblingInput, (pSibling) => pView.getValueByHash(pSibling.Hash));
			}
		}
		return tmpSiblings;
	}

	/**
	 * @param {any} pValue
	 * @return {boolean}
	 */
	isEmptyFacetValue(pValue)
	{
		return (pValue === undefined) || (pValue === null) || (pValue === '');
	}

	/**
	 * The values a Facet rule's dropdown offers: the allowed values (narrowed per the rule's NarrowBy), plus
	 * the input's own current value unless KeepCurrentValue is false, so a filter never hides what the row
	 * already stores (a saved choice that has since fallen out of scope still shows).
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {Record<string, any>} pRule - the input's Facet rule
	 * @param {number} [pRowIndex]
	 * @return {Set<string>}
	 */
	getFacetOfferedValues(pView, pInput, pRule, pRowIndex)
	{
		const tmpSiblings = this.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpOffered = this.getFacetAllowedValues(pView, pInput, pRule, pRowIndex, tmpSiblings, pRule.NarrowBy);
		const tmpSelf = tmpSiblings.find((pSibling) => pSibling.Input === pInput);
		if ((pRule.KeepCurrentValue !== false) && tmpSelf && !this.isEmptyFacetValue(tmpSelf.Value))
		{
			tmpOffered.add(String(tmpSelf.Value));
		}
		return tmpOffered;
	}

	/**
	 * @param {any} pJoinValue - the value on the join record
	 * @param {string} pOperator - EQ (default), NE, LT, LE, GT or GE
	 * @param {string} pValue - the constraint value
	 * @return {boolean}
	 */
	compareFacetValue(pJoinValue, pOperator, pValue)
	{
		if (!pOperator || (pOperator === 'EQ'))
		{
			return String(pJoinValue) === pValue;
		}
		if (pOperator === 'NE')
		{
			return String(pJoinValue) !== pValue;
		}
		if (this.isEmptyFacetValue(pJoinValue))
		{
			return false;
		}
		// Numbers compare as numbers; anything else compares as text, and a bare YYYY-MM-DD compares against
		// only the date part of an ISO timestamp so a record dated that day is on the day, not after it.
		const tmpNumeric = (pJoinValue !== '') && (pValue !== '') && !isNaN(Number(pJoinValue)) && !isNaN(Number(pValue));
		let tmpLeft = tmpNumeric ? Number(pJoinValue) : String(pJoinValue);
		if (!tmpNumeric && /^\d{4}-\d{2}-\d{2}$/.test(pValue) && /^\d{4}-\d{2}-\d{2}T/.test(tmpLeft))
		{
			tmpLeft = tmpLeft.substring(0, 10);
		}
		const tmpRight = tmpNumeric ? Number(pValue) : pValue;
		switch (pOperator)
		{
			case 'LT':
				return tmpLeft < tmpRight;
			case 'LE':
				return tmpLeft <= tmpRight;
			case 'GT':
				return tmpLeft > tmpRight;
			case 'GE':
				return tmpLeft >= tmpRight;
			default:
				this.log.warn(`Facet constraint operator [${pOperator}] is not supported; the constraint is ignored.`);
				return true;
		}
	}

	/**
	 * The values a Facet rule's input may hold, given what its siblings hold: the distinct
	 * JoinListValueAddress values of the join records that agree with every constraining non-empty sibling
	 * value and every explicit facet.  Empty siblings do not constrain.
	 *
	 * pNarrowBy picks the constraining siblings: 'All' (default) is every sibling; 'Preceding' is only the
	 * siblings before this input (column order in a table), so a list offers every value its upstream
	 * choices allow and picking one never needs a downstream value cleared first.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {Record<string, any>} pRule - the input's Facet rule
	 * @param {number} [pRowIndex]
	 * @param {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>} [pSiblings] - precomputed siblings (values may be overridden by the caller)
	 * @param {string} [pNarrowBy] - 'All' or 'Preceding'
	 * @return {Set<string>}
	 */
	getFacetAllowedValues(pView, pInput, pRule, pRowIndex, pSiblings, pNarrowBy)
	{
		const tmpAllowed = new Set();
		for (const tmpJoinRecord of this.getFacetMatchingRecords(pView, pInput, pRule, pRowIndex, pSiblings, pNarrowBy))
		{
			const tmpCandidate = this.pict.manifest.getValueAtAddress(tmpJoinRecord, pRule.JoinListValueAddress);
			if (!this.isEmptyFacetValue(tmpCandidate))
			{
				tmpAllowed.add(String(tmpCandidate));
			}
		}
		return tmpAllowed;
	}

	/**
	 * The join records that agree with every constraining non-empty sibling value and every explicit facet;
	 * see getFacetAllowedValues for pNarrowBy.  pInput's own value does not constrain.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {Record<string, any>} pRule - the input's Facet rule
	 * @param {number} [pRowIndex]
	 * @param {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>} [pSiblings]
	 * @param {string} [pNarrowBy] - 'All' or 'Preceding'
	 * @return {Array<Record<string, any>>}
	 */
	getFacetMatchingRecords(pView, pInput, pRule, pRowIndex, pSiblings, pNarrowBy)
	{
		const tmpConstraints = [];
		const tmpSiblings = pSiblings || this.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpOwnIndex = tmpSiblings.findIndex((pSibling) => pSibling.Input === pInput);
		for (let i = 0; i < tmpSiblings.length; i++)
		{
			const tmpSibling = tmpSiblings[i];
			if ((pNarrowBy === 'Preceding') && (tmpOwnIndex >= 0) && (i > tmpOwnIndex))
			{
				continue;
			}
			if ((tmpSibling.Input !== pInput) && !this.isEmptyFacetValue(tmpSibling.Value))
			{
				tmpConstraints.push({ Address: tmpSibling.Rule.JoinListValueAddress, Value: String(tmpSibling.Value) });
			}
		}
		for (const tmpFacet of (Array.isArray(pRule.Facets) ? pRule.Facets : []))
		{
			const tmpValue = ('ValueAddress' in tmpFacet) ? pView.getValueByHash(tmpFacet.ValueAddress) : tmpFacet.Value;
			if (!this.isEmptyFacetValue(tmpValue))
			{
				tmpConstraints.push({ Address: tmpFacet.JoinListValueAddress, Value: String(tmpValue), Operator: tmpFacet.Operator });
			}
		}
		return this.getFacetJoinList(pView, pRule).filter((pJoinRecord) =>
		{
			for (const tmpConstraint of tmpConstraints)
			{
				if (!this.compareFacetValue(this.pict.manifest.getValueAtAddress(pJoinRecord, tmpConstraint.Address), tmpConstraint.Operator, tmpConstraint.Value))
				{
					return false;
				}
			}
			return true;
		});
	}
}

module.exports = PictListDistilling;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],601:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetaList",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictMetalist class is a provider that translates simple list entries into arrays of entries ready to use in drop-down lists and such
 */
class PictMetalist extends libPictProvider
{
	/**
	 * Creates an instance of the PictMetalist class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.computedLists = {};
		this.listDefinitions = {};
	}
	/** @typedef {{ id: string, text: string }} PickListItem */

	/**
	 * Retrieves a list based on the provided view hash and list hash.
	 *
	 * @param {string} pListHash - The list hash.
	 * @param {Object} [pOptions={}] - (optional) Additional options for retrieving the list. (ex. search term)
	 *
	 * @returns {Array<PickListItem>} - The retrieved list.
	 */
	getList(pListHash, pOptions = {})
	{
		if (this.listDefinitions[pListHash].Dynamic)
		{
			const tmpList = [];
			const tmpTransactionGUID = this.pict.getUUID();
			const tmpHash = tmpTransactionGUID.substring(0, 8);
			const tmpAddress = `AppData._MetaLists.${tmpHash}`;
			this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpList);
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`GetPickList:${pListHash}:${tmpAddress}:${JSON.stringify(pOptions)}`, tmpTransactionGUID);
			this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
			delete this.pict.AppData._MetaLists[tmpHash];
			return tmpList;
		}
		if (pListHash in this.computedLists)
		{
			return this.computedLists[pListHash];
		}
		return [];
	}

	/**
	 * Checks if a list exists in the Pict Provider MetaLists.
	 *
	 * @param {string} pListHash - The hash of the list.
	 * @returns {boolean} - Returns true if the list exists, otherwise false.
	 */
	hasList(pListHash)
	{
		return (pListHash in this.computedLists);
	}

	/**
	 * Rebuilds any lists defined in specific views
	 * @param {Array} pViewHashes - An array of strings representing the view hashes to rebuild lists for.
	 */
	buildViewSpecificLists(pViewHashes)
	{
		// this.log.trace(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] pulling Metalists.`);
		let tmpViewHashes = Array.isArray(pViewHashes) ? pViewHashes : Object.keys(this.fable.views);

		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			let tmpViewHash = tmpViewHashes[i];
			let tmpView = this.fable.views[tmpViewHash];
			if (tmpView.isPictSectionForm)
			{
				let tmpSection = tmpView.sectionDefinition;
				if (('PickLists' in tmpSection) && Array.isArray(tmpSection.PickLists))
				{
					for (let j = 0; j < tmpSection.PickLists.length; j++)
					{
						let tmpPickList = tmpSection.PickLists[j];
						this.buildList(tmpPickList);
					}
				}
			}
		}
	}

	/**
	 * Rebuilds a list based on the provided hash.
	 *
	 * @param {string} pListHash - The hash of the list to be rebuilt.
	 */
	rebuildListByHash(pListHash)
	{
		if (pListHash in this.listDefinitions)
		{
			this.buildList(this.listDefinitions[pListHash]);
		}
	}

	/**
	 * Builds a list based on the provided list object.  Stores it internally for use in dropdowns and list boxes.
	 * @param {Object} pListObject - The List definition object
	 * @returns boolean
	 */
	buildList(pListObject)
	{
		// Basic list validation
		if (typeof(pListObject) !== 'object')
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList that is not an object. Skipping.`);
			return false;
		}
		if (!('Hash' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a Hash. Skipping.`);
			return false;
		}

		// Lazily add it if it doesn't exist
		if (!(pListObject.Hash in this.listDefinitions))
		{
			this.listDefinitions[pListObject.Hash] = pListObject;
			this.computedLists[pListObject.Hash] = [];
		}

		// Now try to build the list!
		let tmpResultingList = [];

		// Advanced list validation
		if (!('ListAddress' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a ListAddress. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		if (!('ListSourceAddress' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a ListSourceAddress. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		// TODO: Research easy ways to infer this...
		if (!('TextTemplate' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a TextTemplate. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		if (!('IDTemplate' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a IDTemplate. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] requires PictFormMetacontroller but not found. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		// Now try to fetch the list data; a global source reads application state rather than the form data.
		let tmpListData;
		if (pListObject.ListSourceAddressGlobal)
		{
			const tmpAddressSpace = { Fable: this.pict, Pict: this.pict, AppData: this.pict.AppData, Bundle: this.pict.Bundle };
			tmpListData = this.pict.manifest.getValueAtAddress(tmpAddressSpace, pListObject.ListSourceAddress);
		}
		else
		{
			tmpListData = this.pict.providers.DataBroker.getValueByHash(pListObject.ListSourceAddress);
		}
		if (!tmpListData)
		{
			//this.log.warn(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to fetch the list data for PickList [${pListObject.Hash}]. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		// Use this for the unique feature
		let tmpListHashes = {};

		if (Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpListEntry = tmpListData[i];
				if (tmpListEntry && (typeof tmpListEntry === 'object'))
				{
					let tmpTextString = this.pict.parseTemplate(pListObject.TextTemplate, tmpListEntry);
					let tmpIDString = this.pict.parseTemplate(pListObject.IDTemplate, tmpListEntry);

					if (!tmpTextString || !tmpIDString)
					{
						// A list over an optional field (SkipEmpty) expects records without it.
						if (pListObject.SkipEmpty)
						{
							continue;
						}
						this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to generate the Text or ID for PickList [${pListObject.Hash}]. Skipping.`);
//						this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to generate the Text or ID for PickList [${pListObject.Hash}]. Skipping.`, {"Text": tmpTextString, "ID": tmpIDString, "Entry": tmpListEntry});
						continue;
					}

					if (pListObject.Unique && (tmpIDString in tmpListHashes))
					{
						continue;
					}
					tmpListHashes[tmpIDString] = true;
					tmpResultingList.push({"id": tmpIDString, "text": tmpTextString});
				}
			}
		}

		if (pListObject.Sorted)
		{
			tmpResultingList.sort((pLeft, pRight) => pLeft.text.localeCompare(pRight.text));
		}

		// Now store the list
		this.computedLists[pListObject.Hash] = tmpResultingList;
	}
}

module.exports = PictMetalist;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],602:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewDynamicForm = require('../views/Pict-View-DynamicForm.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Provider-MetatemplateGenerator",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

const _DynamicInputViewSection = (
		{
			"Hash": "DynamicInputs",
			"Name": "Dynamic Inputs",
			"ViewHash": "PictFormMetacontroller-DynamicInputs",

			"IncludeInMetatemplateSectionGeneration": false,

			"Manifests": {
				"Section": {
					"Scope": "MetaTemplate",
					"Sections": [
						{
							"Hash": "DynamicInputs",
							"Name": "Dynamic Inputs"
						}
					],
					"Descriptors": {
						"MetaTemplate.DynamicInputPlaceholder": {
							"Name": "DynamicInputPlaceholder",
							"Hash": "DynamicInputPlaceholder",
							"DataType": "String",
							"Macro": {
								"HTMLSelector": ""
							},
							"PictForm": {
								"Section": "DynamicInputs"
							}
						}
					}
				}
			}
		});

/**
 * Class representing a Pict Metatemplate Generator.
 * @extends libPictProvider
 */
class PictMetatemplateGenerator extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {libPictViewDynamicForm} */
		this.dynamicInputView;

		this.baseTemplatePrefix = "Pict-MT-Base";
	}

	onInitializeAsync(fCallback)
	{
		this.createOnDemandMetatemplateView();
		return super.onInitializeAsync(fCallback);
	}

	createOnDemandMetatemplateView()
	{
		const tmpViewConfiguration = JSON.parse(JSON.stringify(_DynamicInputViewSection));

		if (tmpViewConfiguration.ViewHash in this.pict.views)
		{
			this.dynamicInputView = this.pict.views[tmpViewConfiguration.ViewHash];
		}
		else
		{
			this.dynamicInputView = this.pict.addView(tmpViewConfiguration.ViewHash, tmpViewConfiguration, libPictViewDynamicForm);
		}
	}

	/**
	 * Retrieves the metatemplate template reference in raw format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pTemplatePostfix - The template postfix.
	 * @param {string} pRawTemplateDataAddress - The raw template data address.
	 * @returns {string} The metatemplate template reference in raw format, or false if it doesn't exist.
	 */
	getMetatemplateTemplateReferenceRaw(pView, pTemplatePostfix, pRawTemplateDataAddress)
	{
		// 1. Check if there is a section-specific template loaded
		if (pView.checkViewSpecificTemplate(pTemplatePostfix))
		{
			return `\n{~T:${pView.formsTemplateSetPrefix}${pTemplatePostfix}:${pRawTemplateDataAddress}~}`;
		}
		// 2. Check if there is a theme-specific template loaded for this postfix
		else if (pView.checkThemeSpecificTemplate(pTemplatePostfix))
		{
			return `\n{~T:${pView.defaultTemplatePrefix}${pTemplatePostfix}:${pRawTemplateDataAddress}~}`;
		}
		// 3. This shouldn't happen if the template is based on the base class.
		else
		{
			return '';
		}
	}

	/**
	 * Retrieves the metatemplate template reference.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pTemplatePostfix - The template postfix.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getMetatemplateTemplateReference(pView, pTemplatePostfix, pViewDataAddress)
	{
		return this.getMetatemplateTemplateReferenceRaw(pView, pTemplatePostfix, `Pict.views["${pView.Hash}"].${pViewDataAddress}`);
	}

	/**
	 * Retrieves the metatemplate template reference for the given input view, data type, input type, and view data address.
	 *
	 * @param {Object} pView - The input view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateInputTypePostfix = `-Template-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateDataTypePostfix = `-Template-Input-DataType-${pDataType}`;

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateInputTypePostfix, pViewDataAddress);
			if (tmpTemplate)
			{
				return tmpTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateDataTypePostfix, pViewDataAddress);
		if (tmpTemplate)
		{
			return tmpTemplate;
		}

		// There wasn't an input type specific or data type specific template, so fall back to the generic input template.
		return this.getMetatemplateTemplateReference(pView, '-Template-Input', pViewDataAddress);
	}

	/**
	 * Generates a tabular input metatemplate template reference.
	 *
	 * @param {Object} pView - The view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @param {number} pGroupIndex - The group index.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} The tabular input metatemplate template reference.
	 */
	getTabularInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress, pGroupIndex, pRowIndex)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateBeginInputTypePostfix = `-TabularTemplate-Begin-Input-InputType-${pInputType}`;
		let tmpTemplateMidInputTypePostfix = `-TabularTemplate-Mid-Input-InputType-${pInputType}`;
		let tmpTemplateEndInputTypePostfix = `-TabularTemplate-End-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateBeginDataTypePostfix = `-TabularTemplate-Begin-Input-DataType-${pDataType}`;
		let tmpTemplateMidDataTypePostfix = `-TabularTemplate-Mid-Input-DataType-${pDataType}`;
		let tmpTemplateEndDataTypePostfix = `-TabularTemplate-End-Input-DataType-${pDataType}`;

		// Tabular inputs are done in three parts -- the "begin", the "address" of the data and the "end".

		// This means it is easily extensible to work on JSON objects as well as arrays.
		let tmpMidTemplate = this.getMetatemplateTemplateReference(pView, '-TabularTemplate-Mid-Input', pViewDataAddress);
		let tmpInformaryDataAddressTemplate = this.getMetatemplateTemplateReference(pView, '-TabularTemplate-InformaryAddress-Input', pViewDataAddress);

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateBeginInputTypePostfix, pViewDataAddress);
			let tmpEndTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateEndInputTypePostfix, pViewDataAddress);
			let tmpCustomMidTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateMidInputTypePostfix, pViewDataAddress);
			tmpMidTemplate = (tmpCustomMidTemplate) ? tmpCustomMidTemplate : tmpMidTemplate;
			if (tmpBeginTemplate && tmpEndTemplate)
			{
				return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateBeginDataTypePostfix, pViewDataAddress);
		let tmpEndTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateEndDataTypePostfix, pViewDataAddress);
		if (tmpBeginTemplate && tmpEndTemplate)
		{
			let tmpCustomMidTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateMidDataTypePostfix, pViewDataAddress);
			tmpMidTemplate = (tmpCustomMidTemplate) ? tmpCustomMidTemplate : tmpMidTemplate;
			return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
		}

		// If we didn't find the template for the "input type", or the "data type", fall back to the default
		tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, 'TabularTemplate-Begin-Input', pViewDataAddress);
		tmpEndTemplate = this.getMetatemplateTemplateReference(pView, 'TabularTemplate-End-Input', pViewDataAddress);
		if (tmpBeginTemplate && tmpEndTemplate)
		{
			return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
		}

		// There was some kind of catastrophic failure -- the above templates should always be loaded.
		this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] catastrophic error generating tabular metatemplate: missing input template for Data Type ${pDataType} and Input Type ${pInputType}, Data Address ${pViewDataAddress}, Group Index ${pGroupIndex} and Record Subaddress ${pRowIndex}.`)
		return '';
	}

	/**
	 * Retrieves the metatemplate template reference for the given vertical input view, data type, input type, and view data address.
	 *
	 * @param {Object} pView - The input view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getVerticalInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateInputTypePostfix = `-VerticalTemplate-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateDataTypePostfix = `-VerticalTemplate-Input-DataType-${pDataType}`;

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateInputTypePostfix, pViewDataAddress);
			if (tmpTemplate)
			{
				return tmpTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateDataTypePostfix, pViewDataAddress);
		if (tmpTemplate)
		{
			return tmpTemplate;
		}

		// There wasn't an input type specific or data type specific template, so fall back to the generic input template.
		return this.getMetatemplateTemplateReference(pView, '-Template-Input', pViewDataAddress);
	}

	/**
	 * Retrieves the group layout provider based on the given view and group.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {Object} The group layout provider.
	 */
	getGroupLayoutProvider(pView, pGroup)
	{
		let tmpGroupLayout = (typeof(pGroup.Layout) === 'string') ? pGroup.Layout :
								(typeof(pView.sectionDefinition.DefaultGroupLayout) === 'string') ? pView.sectionDefinition.DefaultGroupLayout :
								'Record';
		// This switch is unnecessary but meant to be illustrative of what this function does.
		// It could technically be as simple as the default stanza.
		switch(tmpGroupLayout)
		{
			case 'Tabular':
				return this.pict.providers['Pict-Layout-Tabular'];
			case 'Record':
				return this.pict.providers['Pict-Layout-Record'];
			case 'Vertical':
				return this.pict.providers['Pict-Layout-VerticalRecord'];
			case 'Default':
			default:
				// Try to load a custom layout, then fall back to the Record layout if it doesn't exist
				if (`Pict-Layout-${tmpGroupLayout}` in this.pict.providers)
				{
					return this.pict.providers[`Pict-Layout-${tmpGroupLayout}`];
				}
				else
				{
					return this.pict.providers['Pict-Layout-Record'];
				}
		}
	}

	/**
	 * Rebuilds the custom template for the given view.
	 *
	 * This uses the layout providers for each group.
	 *
	 * @param {Object} pView - The view object.
	 */
	rebuildCustomTemplate(pView)
	{
		let tmpTemplate = ``;

		if (this.pict.views.PictFormMetacontroller && ('formTemplatePrefix' in this.pict.views.PictFormMetacontroller) && (!('defaultTemplatePrefix' in pView)))
		{
				pView.defaultTemplatePrefix = this.pict.views.PictFormMetacontroller.formTemplatePrefix;
		}

		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Wrap-Prefix`, `sectionDefinition`);
		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Section-Prefix`, `sectionDefinition`);

		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];

			tmpGroup.GroupIndex = i;

			tmpGroup.SectionTabularRowVirtualTemplateHash = `Pict-Form-Template-TabularRow-Virtual-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;
			tmpGroup.SectionTabularRowTemplateHash = `Pict-Form-Template-TabularRow-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;

			tmpTemplate += this.getGroupLayoutProvider(pView, tmpGroup).generateGroupLayoutTemplate(pView, tmpGroup);
		}

		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Section-Postfix`, `sectionDefinition`);
		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Wrap-Postfix`, `sectionDefinition`);

		this.pict.providers.MetatemplateMacros.rebuildMacros(pView);

		this.pict.TemplateProvider.addTemplate(pView.options.SectionTemplateHash, tmpTemplate);
	}
}

module.exports = PictMetatemplateGenerator;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../views/Pict-View-DynamicForm.js":653,"pict-provider":552}],603:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetatemplateMacros",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
})

/**
 * Class representing PictMetatemplateMacros.
 * @extends libPictProvider
 */
class PictMetatemplateMacros extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { settings: any }} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.additionalInputMacros = {};
		if ('AdditionalInputMacros' in this.options)
		{
			this.additionalInputMacros = Object.assign(this.additionalInputMacros, this.options.AdditionalInputMacros);
		}
		if ('CustomInputMacros' in this.pict.settings)
		{
			this.AdditionalInputMacros = Object.assign(this.additionalInputMacros, this.pict.settings.CustomInputMacros);
		}

		this.additionalGroupMacros = {};
		if ('AdditionalGroupMacros' in this.options)
		{
			this.additionalGroupMacros = Object.assign(this.additionalGroupMacros, this.options.AdditionalGroupMacros);
		}
		if ('CustomGroupMacros' in this.pict.settings)
		{
			this.additionalGroupMacros = Object.assign(this.additionalGroupMacros, this.pict.settings.CustomGroupMacros);
		}

		this.additionalSectionMacros = {};
		if ('AdditionalSectionMacros' in this.options)
		{
			this.additionalSectionMacros = Object.assign(this.additionalSectionMacros, this.options.AdditionalSectionMacros);
		}
		if ('CustomSectionMacros' in this.pict.settings)
		{
			this.additionalSectionMacros = Object.assign(this.additionalSectionMacros, this.pict.settings.CustomSectionMacros);
		}
	}

	/**
	 * Builds macros for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 */
	buildInputMacros(pView, pInput)
	{
		let tmpInputMacroKeys = Object.keys(pView.options.MacroTemplates.Input);
		let tmpAdditionalInputMacroKeys = Object.keys(this.additionalInputMacros);
		if (!('Macro' in pInput))
		{
			pInput.Macro = {};
		}
		for (let n = 0; n < tmpInputMacroKeys.length; n++)
		{
			pInput.Macro[tmpInputMacroKeys[n]] = pView.pict.parseTemplate(pView.options.MacroTemplates.Input[tmpInputMacroKeys[n]], pInput, null, [pView]);
		}
		for (let n = 0; n < tmpAdditionalInputMacroKeys.length; n++)
		{
			pInput.Macro[tmpAdditionalInputMacroKeys[n]] = pView.pict.parseTemplate(this.additionalInputMacros[tmpAdditionalInputMacroKeys[n]], pInput, null, [pView]);
		}
	}

	/**
	 * Rebuilds macros for the given view.
	 *
	 * @param {Object} pView - The view object.
	 * @returns {boolean} - Returns false if MacroTemplates is not present in pView.options.
	 */
	rebuildMacros(pView)
	{
		if (!('MacroTemplates' in pView.options))
		{
			return false;
		}

		// Section macros
		let tmpSectionMacroKeys = Object.keys(pView.options.MacroTemplates.Section);
		let tmpAdditionalSectionMacroKeys = Object.keys(this.additionalSectionMacros);
		if (typeof(pView.sectionDefinition.Macro) !== 'object')
		{
			pView.sectionDefinition.Macro = {};
		}
		for (let n = 0; n < tmpSectionMacroKeys.length; n++)
		{
			pView.sectionDefinition.Macro[tmpSectionMacroKeys[n]] = pView.pict.parseTemplate (pView.options.MacroTemplates.Section[tmpSectionMacroKeys[n]], pView.sectionDefinition, null, [pView]);
		}
		for (let n = 0; n < tmpAdditionalSectionMacroKeys.length; n++)
		{
			pView.sectionDefinition.Macro[tmpAdditionalSectionMacroKeys[n]] = pView.pict.parseTemplate (this.additionalSectionMacros[tmpAdditionalSectionMacroKeys[n]], pView.sectionDefinition, null, [pView]);
		}
		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];

			// Group Macros
			let tmpGroupMacroKeys = Object.keys(pView.options.MacroTemplates.Group);
			let tmpAdditionalGroupMacroKeys = Object.keys(this.additionalGroupMacros);
			if (!('Macro'  in tmpGroup))
			{
				tmpGroup.Macro = {};
			}
			for (let n = 0; n < tmpGroupMacroKeys.length; n++)
			{
				tmpGroup.Macro[tmpGroupMacroKeys[n]] = pView.pict.parseTemplate(pView.options.MacroTemplates.Group[tmpGroupMacroKeys[n]], tmpGroup, null, [pView]);
			}
			for (let n = 0; n < tmpAdditionalGroupMacroKeys.length; n++)
			{
				tmpGroup.Macro[tmpAdditionalGroupMacroKeys[n]] = pView.pict.parseTemplate(this.additionalGroupMacros[tmpAdditionalGroupMacroKeys[n]], tmpGroup, null, [pView]);
			}

			if (!Array.isArray(tmpGroup.Rows))
			{
				tmpGroup.Rows = [];
			}
			for (let j = 0; j < tmpGroup.Rows.length; j++)
			{
				// TODO: Do we want row macros?  Let's be still and find out.
				let tmpRow = tmpGroup.Rows[j];
				for (let k = 0; k < tmpRow.Inputs.length; k++)
				{
					this.buildInputMacros(pView, tmpRow.Inputs[k]);
				}
			}

			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					this.buildInputMacros(pView, tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]]);
				}
			}
		}
	}
}

module.exports = PictMetatemplateMacros;
module.exports.default_configuration = _DefaultProviderConfiguration;



},{"pict-provider":552}],604:[function(require,module,exports){
module.exports = (
{
	"TemplatePrefix": "Pict-Forms-ReadOnly",

	"Templates":
	[
		/*
		 *
		 * [ Metacontroller Templates ]
		 *
		 */
		// the form "Header", rendered once before the dynamic views, after which come the section(s), then their group(s)
		{
			"HashPostfix": "-Template-Form-Container-Header",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container Header

  ;,//;,    ,;/
 o:::::::;;///
>::::::::;;\\\
  ''\\\\'" ';\

Glug glug glug Oo... -->
<div id="Pict-{~D:Context[0].UUID~}-FormContainer" class="pict-form">`
		},
		//
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Prefix",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`
		},
		// the container div into which the actual view renders.
		// if you overwrite this template, make sure this ID is available on a container somewhere or auto rendering won't work
		{
			"HashPostfix": "-Template-Form-Container",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`
		},
		{
			"HashPostfix": "-Template-Form-Container-Custom",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`
		},

		// -Form-Container-Wrap-Postfix
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Postfix",
			"Template": /*HTML*/`
</div>
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
`
		},


		/*
		 *
		 * [ Basic Form Templates START ]
		 *
		 */
		// the wrapping container for a view which is a collection of form section(s)...
		{
			"HashPostfix": "-Template-Wrap-Prefix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		{
			"HashPostfix": "-Template-Wrap-Postfix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		// the wrapping container for each specific section in a form... for legends and the like
		{
			"HashPostfix": "-Template-Section-Prefix",
			"Template": /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<div class="pict-form-section">
		<h2>{~D:Record.Name~}</h2>
`
		},
		// -Form-Template-Section-Postfix
		{
			"HashPostfix": "-Template-Section-Postfix",
			"Template": /*HTML*/`
		</div>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Group and Row Templates (default)
		 */
		// a "group" is a cluster of inputs that are further categorized into row(s)
		{
			"HashPostfix": "-Template-Group-Prefix",
			"Template": /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<h3>Group: {~D:Record.Name~}</h3>
`
		},
		// row(s) are useful when our form has multiple inputs on some lines and a single on another...
		// like city, state and zip all in the same "row" of an address form
		{
			"HashPostfix": "-Template-Row-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div>
`
		},
		{
			"HashPostfix": "-Template-Row-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-Group-Postfix",
			"Template": /*HTML*/`
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		/*
		 * END Group and Row Templates (default)
		 */

		/*
		 * BEGIN Input Templates (default)
		 */
		{
			"HashPostfix": "-Template-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <textarea disabled {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span> <select disabled {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span> <input disabled {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ObjectEditor",
			"DefaultInputExtensions": ["Pict-Input-ObjectEditor"],
			"Template": /*HTML*/`
					<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
`
		},
		/*
		 * END Input Templates (default)
		 */
		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		/*
		 * Tab Groups are sets of Groups within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...
			"UI.StatisticsTabState": {
				Name: "Statistics Tab State",
				Hash: "StatisticsTabState",
				DataType: "String",
				PictForm: { Section: "Recipe", Group: "StatisticsTabs", 
					InputType: "TabGroupSelector",
					// The default when there is no state is the first entry here.
					// If you want to set a default, you can just do it in the state address though.
					TabGroupSet: ["Statistics", "FruitStatistics"] }
			},
		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector",
			"DefaultInputExtensions": ["Pict-Input-TabGroupSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<a href="#" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}')">{~D:Context[1].TabGroupHash~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</p>
`
		},		/*
		 * END View Management Templates (default)
		 */
		/*
		 *
		 * [ Basic Form Templates END ]
		 *
		 */

		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TuiGrid-Container",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.ControlAttr~} id="{~D:Record.TuiGridHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-TuiGrid-Controls",
			"Template": /*HTML*/`
			<div>[ <a href="#" onclick="{~P~}.providers['Pict-Layout-TuiGrid'].addRow('{~D:Context[0].Hash~}', {~D:Record.GroupIndex~})">create</a> ]</div>
`
		},
		/*
		 *
		 * [ External Control Templates END ]
		 *
		 */


		/*
		 *
		 * [ Tabular Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TabularTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<table>
					<tbody>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Group-Postfix",
			"Template": /*HTML*/`
				</tbody>
			</table>
			<div><a href="#" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Tabular Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPrefix -->`
		},
		// because the row extension template below adds an extra column, we need to make our header have parity
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPostfix -->
						<th style="min-width:100px;"></th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a tabular templateset
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPostfix-->
					<td><a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
					<a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
					<a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a></td>
`
		},
		/*
		 * END Tabular Template "Extra" Columns
		 */

		/*
		 * BEGIN Tabular Template Header Columns
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Prefix",
			"Template": /*HTML*/`
				<thead>
					<tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-HeaderCell",
			"Template": /*HTML*/`
						<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
						<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}">{~D:Record.Name~}</th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Postfix",
			"Template": /*HTML*/`
					</tr>
				</thead>
				<tbody>
`
		},
		/*
		 * END Tabular Template Header Columns
		 */

		/*
		 * BEGIN Tabular TemplateSet Templates (row and cell prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-TabularTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">{~T:TabularTemplateRow-ExtraPrefix~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}"><!-- {~D:Record.Name~}  -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Postfix",
			"Template": /*HTML*/`
						</td>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-Postfix",
			"Template": /*HTML*/`
					{~T:TabularTemplateRow-ExtraPostfix~}</tr>`
		},
		/*
		 * END Tabular TemplateSet Templates
		 */


		/*
		 * BEGIN Tabular Input Templates
		 */
		{
			"HashPostfix": "-TabularTemplate-Begin-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Mid-Input",
			"Template": /*HTML*/`  `
		},
		{
			"HashPostfix": "-TabularTemplate-InformaryAddress-Input",
			"Template": /*HTML*/` data-i-index="{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"  `
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-String",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-Number",
			"Template": /*HTML*/` value="">
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<textarea disabled {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TextArea",
			"Template": /*HTML*/` ></textarea>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" id="SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Option",
			"Template": /*HTML*/` value="">
					<select disabled {~D:Record.Macro.ControlAttr~} id="SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"></select>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Boolean",
			"Template": /*HTML*/` value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-DateTime",
			"Template": /*HTML*/` value="">
					<input disabled {~D:Record.Macro.ControlAttr~} id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} {~D:Record.Macro.InformaryTabular~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Hidden",
			"Template": /*HTML*/` value="">
`
		},

		/*
		 * END Tabular Input Templates
		 */
		/*
		 *
		 * [ Tabular Templates END ]
		 *
		 */
	]
});

},{}],605:[function(require,module,exports){
module.exports = (
{
	"TemplatePrefix": "Pict-MT-Base",
	"Templates":
	[
		/*
		 *
		 * [ Metacontroller Templates ]
		 *
		 */
		// the form "Header", rendered once before the dynamic views, after which come the section(s), then their group(s)
		{
			"HashPostfix": "-Template-Form-Container-Header",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container Header

  ;,//;,    ,;/
 o:::::::;;///
>::::::::;;\\\
  ''\\\\'" ';\

Glug glug glug Oo... -->
<div id="Pict-{~D:Context[0].UUID~}-FormContainer" class="pict-form">`
		},
		//
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Prefix",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`
		},
		// the container div into which the actual view renders.
		// if you overwrite this template, make sure this ID is available on a container somewhere or auto rendering won't work
		{
			"HashPostfix": "-Template-Form-Container",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`
		},
		{
			"HashPostfix": "-Template-Form-Container-Custom",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`
		},

		// -Form-Container-Wrap-Postfix
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Postfix",
			"Template": /*HTML*/`
</div>
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
`
		},


		/*
		 *
		 * [ Basic Form Templates START ]
		 *
		 */
		// the wrapping container for a view which is a collection of form section(s)...
		{
			"HashPostfix": "-Template-Wrap-Prefix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		{
			"HashPostfix": "-Template-Wrap-Postfix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		// the wrapping container for each specific section in a form... for legends and the like
		{
			"HashPostfix": "-Template-Section-Prefix",
			"Template": /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<div id="SECTION-{~D:Context[0].formID~}" class="pict-form-section {~D:Record.CSSClass~}">
		<h2>{~D:Record.Name~}</h2>
`
		},
		// -Form-Template-Section-Postfix
		{
			"HashPostfix": "-Template-Section-Postfix",
			"Template": /*HTML*/`
		</div>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Group and Row Templates (default)
		 */
		// a "group" is a cluster of inputs that are further categorized into row(s)
		{
			"HashPostfix": "-Template-Group-Prefix",
			"Template": /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
			<h3>Group: {~D:Record.Name~}</h3>
`
		},
		// row(s) are useful when our form has multiple inputs on some lines and a single on another...
		// like city, state and zip all in the same "row" of an address form
		{
			"HashPostfix": "-Template-Row-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div>
`
		},
		{
			"HashPostfix": "-Template-Row-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-VerticalRow-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Vertical Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div class="pict-form-vertical-group">
`
		},
		{
			"HashPostfix": "-Template-VerticalRow-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Vertical Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-Group-Postfix",
			"Template": /*HTML*/`
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		/*
		 * END Group and Row Templates (default)
		 */

		/*
		 * BEGIN Input Templates (default)
		 */
		{
			"HashPostfix": "-Template-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span>
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<input type="text" {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" value="" readonly="readonly">
`
		},

		{
			"HashPostfix": "-Template-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span> <select {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span> <input {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></span>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" readonly {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></input>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}">{~D:Record.Name~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Chart",
			"DefaultInputExtensions": ["Pict-Input-Chart"],
			"Template": /*HTML*/`
					<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
					<div style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; margin-left:{~DWAF:Record.PictForm.QuantizedWidthOffset:0~}%; display:inline-block;">
						<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
						<h3><span>{~D:Record.Name~}:</span></h3>
						<!-- ChartHeight (pixels) sets the plot area. It is min-height rather than height so the
					     default of 0 is a true no-op for every chart that never sets it: Chart.js keeps sizing
					     the canvas by its 2:1 aspect ratio exactly as before. When it IS set, the provider turns
					     maintainAspectRatio off so the canvas fills this box instead of ignoring it. -->
						<div style="width:100%; min-height:{~DWAF:Record.PictForm.ChartHeight:0~}px;"><canvas id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></canvas></div>
					</div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Markdown",
			"DefaultInputExtensions": ["Pict-Input-Markdown"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-HTML",
			"DefaultInputExtensions": ["Pict-Input-HTML"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Templated",
			"DefaultInputExtensions": ["Pict-Input-Templated"],
			"Template": /*HTML*/`
					<!-- InputType Templated {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-templated"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TemplatedEntityLookup",
			"DefaultInputExtensions": ["Pict-Input-TemplatedEntityLookup"],
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-RichText",
			"DefaultInputExtensions": ["Pict-Input-RichText"],
			"Template": /*HTML*/`
					<!-- InputType RichText {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-richtext"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Diagram",
			"DefaultInputExtensions": ["Pict-Input-Diagram"],
			"Template": /*HTML*/`
					<!-- InputType Diagram {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-diagram"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ObjectEditor",
			"DefaultInputExtensions": ["Pict-Input-ObjectEditor"],
			"Template": /*HTML*/`
					<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
`
		},
		/*
		 * END Input Templates (default)
		 */
		/*
		 * BEGIN Vertical Input Templates
		 */
		{
			"HashPostfix": "-VerticalTemplate-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<div class="pict-form-vertical-input">
						<span>{~D:Record.Name~}:</span>
						<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
						<input type="text" {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" value="" readonly="readonly">
					</div>

`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<select {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} />
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></span>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" readonly {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></input>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<a {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}>{~D:Record.Name~}</a>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Markdown",
			"DefaultInputExtensions": ["Pict-Input-Markdown"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-HTML",
			"DefaultInputExtensions": ["Pict-Input-HTML"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Templated",
			"DefaultInputExtensions": ["Pict-Input-Templated"],
			"Template": /*HTML*/`
				<!-- InputType Templated {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-templated"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-TemplatedEntityLookup",
			"DefaultInputExtensions": ["Pict-Input-TemplatedEntityLookup"],
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-RichText",
			"DefaultInputExtensions": ["Pict-Input-RichText"],
			"Template": /*HTML*/`
					<!-- InputType RichText {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<label class="pict-form-label">{~D:Record.Name~}</label>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-richtext"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Diagram",
			"DefaultInputExtensions": ["Pict-Input-Diagram"],
			"Template": /*HTML*/`
					<!-- InputType Diagram {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<label class="pict-form-label">{~D:Record.Name~}</label>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-diagram"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-ObjectEditor",
			"DefaultInputExtensions": ["Pict-Input-ObjectEditor"],
			"Template": /*HTML*/`
					<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<label class="pict-form-label">{~D:Record.Name~}</label>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
				</div>
`
		},
		/*
		 * END Vertical Input Templates (default)
		 */
		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		/*
		 * Tab Groups are sets of Groups within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...
			"UI.StatisticsTabState": {
				Name: "Statistics Tab State",
				Hash: "StatisticsTabState",
				DataType: "String",
				PictForm: { Section: "Recipe", Group: "StatisticsTabs", 
					InputType: "TabGroupSelector",
					// The default when there is no state is the first entry here.
					// If you want to set a default, you can just do it in the state address though.
					TabGroupSet: ["Statistics", "FruitStatistics"] }
			},
		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector",
			"DefaultInputExtensions": ["Pict-Input-TabGroupSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<a href="#/" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}')">{~D:Context[1].TabGroupName~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</p>
`
		},
		/*
		 * Tab Sections are sets of Sections within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...

		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector",
			"DefaultInputExtensions": ["Pict-Input-TabSectionSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<a href="#/" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}')">{~D:Context[1].TabSectionName~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</p>
`
		},
		/*
		 * END View Management Templates (default)
		 */
		/*
		 *
		 * [ Basic Form Templates END ]
		 *
		 */

		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TuiGrid-Container",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.ControlAttr~} id="{~D:Record.TuiGridHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-TuiGrid-Controls",
			"Template": /*HTML*/`
			<div>[ <a href="#/" onclick="{~P~}.providers['Pict-Layout-TuiGrid'].addRow('{~D:Context[0].Hash~}', {~D:Record.GroupIndex~})">create</a> ]</div>
`
		},
		/*
		 *
		 * [ External Control Templates END ]
		 *
		 */


		/*
		 *
		 * [ RecordSet Templates START ]
		 *
		 */
		{
			"HashPostfix": "-RecordSetTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.PictFormLayout~}>
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Group-Postfix",
			"Template": /*HTML*/`
			<div><a href="#/" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},


		/*
		 * BEGIN RecordSet Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */

		{
			"HashPostfix": "-RecordSetTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a RecordSet Templateset
		{
			"HashPostfix": "-RecordSetTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->
					<div class="PictSectionForm-RecordSet-Controls">
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a>
					</div>
`
		},
		/*
		 * END RecordSet Template "Extra" Columns
		 */

		/*
		 * BEGIN RecordSet TemplateSet Templates ("row" and "cell" prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-RecordSetTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<div class="RecordSetEntry">
					<!-- RecordSetTemplateRow-Prefix -->
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<div style="display:inline;">
							<!-- RecordSetTemplateCell-Prefix -->
							<span class="RecordSetInputLabel">{~D:Record.Name~}</span>
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Cell-Postfix",
			"Template": /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Row-Postfix",
			"Template": /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`
		},
		/*
		 * END RecordSet TemplateSet Templates
		 */



		/*
		 *
		 * [ Tabular Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TabularTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<table>
					<tbody>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Group-Postfix",
			"Template": /*HTML*/`
				</tbody>
			</table>
			<div><a href="#/" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Tabular Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPrefix -->`
		},
		// because the row extension template below adds an extra column, we need to make our header have parity
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPostfix -->
						<th style="min-width:100px;"></th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a tabular templateset
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPostfix-->
					<td><a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
					<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
					<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a></td>
`
		},
		/*
		 * END Tabular Template "Extra" Columns
		 */

		/*
		 * BEGIN Tabular Template Header Columns
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Prefix",
			"Template": /*HTML*/`
				<thead>
					<tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-HeaderCell",
			"Template": /*HTML*/`
						<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
						<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}">{~D:Record.Name~}</th>
`
		},
		{
			// The column label only (no <th> wrapper). Used by the ColumnSorting
			// header cell so the label resolves dynamically on every render -- the
			// same way the default HeaderCell above does -- instead of being baked
			// as a static string when the template is built. This lets DynamicColumns
			// name changes (e.g. via refreshtabularsection) update the visible header
			// without a full rebuildCustomTemplate.
			"HashPostfix": "-TabularTemplate-HeaderCellLabel",
			"Template": /*HTML*/`{~D:Record.Name~}`
		},
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Postfix",
			"Template": /*HTML*/`
					</tr>
				</thead>
				<tbody>
`
		},
		/*
		 * END Tabular Template Header Columns
		 */

		/*
		 * BEGIN Tabular Template Extra Header Rows
		 * Used for stacked/clustered headers (the Group's `Headers` config).
		 * Each entry in Headers is one ADDITIONAL header row stacked above the
		 * default column-name row. Cells carry { Label, ColumnSpan, CSSClass }.
		 */
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderRow-Prefix",
			"Template": /*HTML*/`
					<tr class="pict-tabular-extra-header-row">
`
		},
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderRow-Postfix",
			"Template": /*HTML*/`
					</tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderCell",
			"Template": /*HTML*/`<th colspan="{~D:Record.ColumnSpan~}" class="pict-tabular-extra-header-cell {~D:Record.CSSClass~}">{~D:Record.Label~}</th>`
		},
		/*
		 * END Tabular Template Extra Header Rows
		 */

		/*
		 * BEGIN Tabular Template Row Label Columns
		 * Used for left-side label columns (the Group's `RowLabels` config).
		 * Header cell renders one <th> per RowLabels entry. Per-row cell renders
		 * one <td> per RowLabels entry; rowspans collapse consecutive equal
		 * values when `Cluster: true`. Skipped cells emit nothing (a real <td>
		 * upstream has already covered them via rowspan).
		 */
		{
			"HashPostfix": "-TabularTemplate-RowLabel-HeaderCell",
			"Template": /*HTML*/`<th class="pict-row-label-header">{~D:Record.Name~}</th>`
		},
		{
			"HashPostfix": "-TabularTemplate-RowLabel-Cell",
			"Template": /*HTML*/`<td rowspan="{~D:Record.RowSpan~}" class="pict-row-label">{~D:Record.RenderedLabel~}</td>`
		},
		{
			"HashPostfix": "-TabularTemplate-RowLabel-Cell-Skipped",
			"Template": ``
		},
		/*
		 * END Tabular Template Row Label Columns
		 */

		/*
		 * BEGIN Tabular TemplateSet Templates (row and cell prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-TabularTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">{~T:TabularTemplateRow-ExtraPrefix~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}"><!-- {~D:Record.Name~}  -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Postfix",
			"Template": /*HTML*/`
						</td>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-Postfix",
			"Template": /*HTML*/`
					{~T:TabularTemplateRow-ExtraPostfix~}</tr>`
		},
		/*
		 * END Tabular TemplateSet Templates
		 */


		/*
		 * BEGIN Tabular Input Templates
		 */
		{
			"HashPostfix": "-TabularTemplate-Begin-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Mid-Input",
			"Template": /*HTML*/`  `
		},
		{
			"HashPostfix": "-TabularTemplate-InformaryAddress-Input",
			"Template": /*HTML*/` data-i-index="{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"  `
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-String",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-Number",
			"Template": /*HTML*/` value="">
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-PreciseNumber",
			"Template": /*HTML*/` value="">
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly",
			"Template": /*HTML*/`
						value="">
					<input type="text" {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} value="" readonly="readonly">
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TextArea",
			"Template": /*HTML*/` ></textarea>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Option",
			"Template": /*HTML*/` value="">
					<select {~D:Record.Macro.ControlAttr~} id="SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"></select>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Boolean",
			"Template": /*HTML*/` value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-DateTime",
			"Template": /*HTML*/` value="">
					<input {~D:Record.Macro.ControlAttr~} id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~}
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Hidden",
			"Template": /*HTML*/`></span>`,
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} {~D:Record.Macro.InformaryTabular~}`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Color",
			"Template": /*HTML*/` />
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InformaryTabular~}`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-DisplayOnly",
			"Template": /*HTML*/` ></span>
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input readonly type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-ReadOnly",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Link",
			"Template": /*HTML*/` value="">
					<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~}>{~D:Record.Name~}</a>`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup",
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TemplatedEntityLookup",
			"Template": /*HTML*/` value="">`
		},

		/*
		 * END Tabular Input Templates
		 */
		/*
		 *
		 * [ Tabular Templates END ]
		 *
		 */
	]
});

},{}],606:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class for the Autofill Trigger Group
 *
 * Autofill Trigger Groups have three parameters:
 *  - the group hash
 *  - a boolean defining whether the input triggers all inputs on the group
 *    to autofill themselves
 *  - an address (either in Pict or AppData) to pull data from
 *  - whether or not to marshal values if the result is empty/null/undefined
 *
 * In practice this looks like this:
 *
	Providers: ["Pict-Input-AutofillTriggerGroup"],
	AutofillTriggerGroup:
		{
			TriggerGroupHash: "Author",
			TriggerAddress: "AppData.CurrentAuthor.Name",
			MarshalEmptyValues: true
		}
 *
 *
 * The group is cavalier about clearing data when
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	getTriggerGroupConfigurationArray(pInput)
	{
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups)
		{
			return [];
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		return tmpAutoFillTriggerGroups;
	}

	autoFillFromAddressList(pView, pInput, pTriggerGroupInfo, pHTMLSelector)
	{
		// First sanity check the triggergroupinfo
		if (!('TriggerGroupHash' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerGroupHash) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerGroupHash string is not present.`);
			return false;
		}
		if (!('TriggerAddress' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerAddress) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerAddress string is not present.`);
			return false;
		}

		let tmpValue = this.pict.manifest.getValueByHash(this.pict, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}
		// Maybe this just works!
		pView.setDataByInput(pInput, tmpValue);
		pView.manualMarshalDataToViewByInput(pInput);
		return true;
	}

	autoFillFromAddressListTabular(pView, pInput, pTriggerGroupInfo, pHTMLSelector, pRowIndex)
	{
		// First sanity check the triggergroupinfo
		if (!('TriggerGroupHash' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerGroupHash) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerGroupHash string is not present.`);
			return false;
		}
		if (!('TriggerAddress' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerAddress) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerAddress string is not present.`);
			return false;
		}

		let tmpValue = this.pict.manifest.getValueByHash(this.pict, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}
		// Setting data is in the view intentionally, to allow triggered events.  Probabbly needs to be a separate provider.
		pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpValue);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
		return true;
	}

	// Trigger the group if it's flagged as a triggering input
	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpTriggerGroupConfigurations = this.getTriggerGroupConfigurationArray(pInput);
		if (Array.isArray(tmpTriggerGroupConfigurations) && this.pict.views.PictFormMetacontroller)
		{
			for (let i = 0; i < tmpTriggerGroupConfigurations.length; i++)
			{
				const tmpGroupConfig = tmpTriggerGroupConfigurations[i];
				if (tmpGroupConfig.TriggerAllInputs)
				{
					if (Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} pre-trigger`);
					}
					pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
					{
						if (Array.isArray(tmpGroupConfig.PostSolvers))
						{
							this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} post-trigger`);
							const tmpMarshalScope = tmpGroupConfig.MarshalOnComplete;
							if (tmpMarshalScope === true)
							{
								this.pict.views.PictFormMetacontroller.marshalToView();
							}
							else if (tmpMarshalScope)
							{
								this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
								this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
							}
						}
					});
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TriggerGroup:${tmpGroupConfig.TriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpTriggerGroupConfigurations = this.getTriggerGroupConfigurationArray(pInput);
		if (Array.isArray(tmpTriggerGroupConfigurations) && this.pict.views.PictFormMetacontroller)
		{
			for (let i = 0; i < tmpTriggerGroupConfigurations.length; i++)
			{
				const tmpGroupConfig = tmpTriggerGroupConfigurations[i];
				if (tmpGroupConfig.TriggerAllInputs)
				{
					if (Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular pre-trigger`);
					}
					pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
					{
						if (Array.isArray(tmpGroupConfig.PostSolvers))
						{
							this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular post-trigger`);
							const tmpMarshalScope = tmpGroupConfig.MarshalOnComplete;
							if (tmpMarshalScope === true)
							{
								this.pict.views.PictFormMetacontroller.marshalToView();
							}
							else if (tmpMarshalScope)
							{
								this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
								this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
							}
						}
					});
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TriggerGroup:${tmpGroupConfig.TriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}
			}
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups || tmpType !== 'TriggerGroup' || (pInput.Hash || pInput.DataAddress) == tmpInputHash)
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		for (let i = 0; i < tmpAutoFillTriggerGroups.length; i++)
		{
			let tmpAutoFillTriggerGroup = tmpAutoFillTriggerGroups[i];
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			if (Array.isArray(tmpAutoFillTriggerGroup.PreSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PreSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} pre-autofill`);
			}

			//FIXME: why is this check here? revisit
			if ('TriggerAddress' in tmpAutoFillTriggerGroup)
			{
				// Autofill based on the address list as it isn't a select option
				this.autoFillFromAddressList(pView, pInput, tmpAutoFillTriggerGroup, pHTMLSelector);
			}
			
			if (tmpAutoFillTriggerGroup.SelectOptionsRefresh)
			{
				// Regenerate the picklist
				// Because the pick lists are view specific, we need to lookup the view the input is in
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
				this.pict.providers['Pict-Input-Select'].refreshSelectList(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector);
				tmpInputView.manualMarshalDataToViewByInput(pInput, tmpEventGUID);
			}

			if (Array.isArray(tmpAutoFillTriggerGroup.PostSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PostSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} post-autofill`);
				const tmpMarshalScope = tmpAutoFillTriggerGroup.MarshalOnComplete;
				if (tmpMarshalScope === true)
				{
					this.pict.views.PictFormMetacontroller.marshalToView();
				}
				else if (tmpMarshalScope)
				{
					this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
					this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
				}
			}
		}

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.AutofillTriggerGroup || tmpType !== 'TriggerGroup' || (pInput.Hash || pInput.DataAddress) == tmpInputHash)
		{
			// Do nothing for now -- this is the triggering element
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		for (const tmpAutoFillTriggerGroup of tmpAutoFillTriggerGroups)
		{
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}
			/*
			 * FIXME: for large tables, do we want to run this for every row?
			if (Array.isArray(tmpAutoFillTriggerGroup.PreSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PreSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} pre-autofill`);
			}
			*/

			//FIXME: why is this flow different from non-tabular? revisit
			if (!tmpAutoFillTriggerGroup.SelectOptionsRefresh)
			{
				// Autofill based on the address list as it isn't a select option
				this.autoFillFromAddressListTabular(pView, pInput, tmpAutoFillTriggerGroup, pHTMLSelector, pRowIndex);
			}
			else if (!pInput.PictForm.SelectOptionsPickList)
			{
				// There is no select options picklist so we can't auto refresh it.
			}
			else
			{
				// Regenerate the picklist
				// TODO: This is inefficient -- it regenerates the list for every single row.  Easy optimization.
				// Use the transaction stuff at some point, now that we have it in the event.
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
				this.pict.providers['Pict-Input-Select'].refreshSelectListTabular(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector, pRowIndex);
				tmpInputView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex, tmpEventGUID);
			}
			/*
			 * TODO: for large tables, do we want to run this for every row?
			if (Array.isArray(tmpAutoFillTriggerGroup.PostSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PostSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} post-autofill`);
			}
			*/
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],607:[function(require,module,exports){
'use strict';
/**
 * Scoped CSS for the chart input's grouped legend. Registered once by
 * Pict-Provider-Input-Chart via
 * `pict.CSSMap.addCSS('Pict-Input-Chart-CSS', libCSS, 500)`.
 *
 * Chart.js's own legend is a single flow-wrapped row of swatches. On a control
 * chart that is eight entries of near-identical colour, with the limit lines
 * indistinguishable from the readings, wrapping into an unreadable block. This
 * legend is a vertical list, grouped, with each group toggleable as a unit.
 *
 * Everything is themeable through the --theme-color-* tokens (text also through
 * --pict-chart-text-color, which the canvas follows too). Text falls back to the
 * inherited colour, so a host without the tokens still gets a legend that
 * follows its light or dark theme.
 */
const libCSS = /*css*/`
.pict-chart-shell { display: flex; align-items: stretch; gap: 0.75rem; width: 100%; }
.pict-chart-shell.pict-chart-legend-top { flex-direction: column-reverse; }
.pict-chart-shell.pict-chart-legend-bottom { flex-direction: column; }
.pict-chart-shell .pict-chart-canvas-area { flex: 1 1 auto; min-width: 0; position: relative; }

.pict-chart-legend { flex: 0 0 auto; max-width: 15rem; font-size: 0.78rem; line-height: 1.35;
	color: var(--pict-chart-text-color, var(--theme-color-text-primary, currentColor)); user-select: none; }
.pict-chart-legend-top .pict-chart-legend,
.pict-chart-legend-bottom .pict-chart-legend { max-width: none; }

.pict-chart-legend-group + .pict-chart-legend-group { margin-top: 0.5rem; }
.pict-chart-legend-group-header { display: flex; align-items: center; gap: 0.35rem; cursor: pointer;
	font-size: 0.68rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
	color: var(--theme-color-text-muted, currentColor); padding: 0.15rem 0; }
.pict-chart-legend-group-header:hover { color: var(--theme-color-text-primary, currentColor); }
.pict-chart-legend-group-caret { font-size: 0.6rem; transition: transform 0.12s ease; }
.pict-chart-legend-group.pict-collapsed .pict-chart-legend-group-caret { transform: rotate(-90deg); }
.pict-chart-legend-group.pict-collapsed .pict-chart-legend-items { display: none; }
/* A group whose series are ALL hidden is dimmed as a whole, so the group toggle
   reads as a control rather than decoration. */
.pict-chart-legend-group.pict-group-off .pict-chart-legend-group-header { opacity: 0.45; }

.pict-chart-legend-items { display: flex; flex-direction: column; gap: 0.1rem; }
.pict-chart-legend-top .pict-chart-legend-items,
.pict-chart-legend-bottom .pict-chart-legend-items { flex-direction: row; flex-wrap: wrap; gap: 0.1rem 0.75rem; }

.pict-chart-legend-item { display: flex; align-items: center; gap: 0.4rem; cursor: pointer;
	padding: 0.1rem 0.2rem; border-radius: 4px; }
.pict-chart-legend-item:hover { background: var(--theme-color-background-hover, rgba(0,0,0,0.04)); }
.pict-chart-legend-item.pict-hidden { opacity: 0.4; }
.pict-chart-legend-item.pict-hidden .pict-chart-legend-label { text-decoration: line-through; }
.pict-chart-legend-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* The swatch carries the series' identity: colour, and whether it is a solid
   line, a dashed one, or unconnected markers. A legend that shows every entry
   as the same solid block cannot distinguish a reading from its control limit. */
.pict-chart-legend-swatch { flex: 0 0 auto; width: 1.4rem; height: 0.7rem; position: relative; }
.pict-chart-legend-swatch::before { content: ''; position: absolute; left: 0; right: 0; top: 50%;
	transform: translateY(-50%); height: 0.15rem; border-radius: 1px; background: currentColor; }
.pict-chart-legend-swatch.pict-swatch-dashed::before {
	background: repeating-linear-gradient(to right, currentColor 0 0.28rem, transparent 0.28rem 0.5rem); }
.pict-chart-legend-swatch.pict-swatch-dotted::before {
	background: repeating-linear-gradient(to right, currentColor 0 0.12rem, transparent 0.12rem 0.28rem); }
.pict-chart-legend-swatch.pict-swatch-markers::before { display: none; }
.pict-chart-legend-swatch.pict-swatch-markers::after { content: ''; position: absolute; left: 50%; top: 50%;
	transform: translate(-50%, -50%); width: 0.45rem; height: 0.45rem; border-radius: 50%; background: currentColor; }

.pict-chart-legend-toggle { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer;
	font-size: 0.68rem; color: var(--theme-color-text-muted, currentColor);
	background: none; border: 1px solid var(--theme-color-border-light, #e8ebf0);
	border-radius: 5px; padding: 0.1rem 0.4rem; margin-bottom: 0.35rem; }
.pict-chart-legend-toggle:hover { color: var(--theme-color-text-primary, currentColor);
	border-color: var(--theme-color-border-strong, #c2c9d2); }

/* ---------------------------------------------------------------------------
   PRINT
   ---------------------------------------------------------------------------
   Three things break when a Chart.js chart is printed from the browser, and none
   of them is "canvas does not print" -- the canvas rasterises fine.

   1. CLIPPING. Chart.js writes an INLINE style.width/height on the canvas taken
      from the SCREEN layout, and only corrects it from a ResizeObserver whose
      callback runs in requestAnimationFrame -- which never fires inside the
      synchronous print snapshot. So a canvas laid out at ~930px keeps that width
      on a page box narrower than it, and the right-hand side is simply cut off.
      max-width:100% overrides the inline width; height:auto keeps the ratio.

   2. VANISHING SWATCHES. The legend swatches are painted with background and
      ::before/::after gradients, and browsers drop backgrounds in print unless
      the reader happens to tick "Background graphics". Without these the legend
      prints as a column of empty boxes and nothing can be matched to a line --
      on a control chart, where telling the reading from the limits is the entire
      point, that is worse than printing no legend at all.

   3. INTERACTIVE AFFORDANCES. A hide-legend button and a collapse caret are
      meaningless on paper, and a group a reader happened to collapse on screen
      must still print -- collapsing is a space affordance, not a statement about
      the data.
*/
@media print
{
	.pict-input-chart canvas { max-width: 100% !important; height: auto !important; }
	.pict-input-chart { break-inside: avoid; page-break-inside: avoid; }

	/* Legend under the plot so the plot gets the full page width. */
	.pict-chart-shell { display: block; break-inside: avoid; page-break-inside: avoid; }
	.pict-chart-canvas-area { width: 100%; }
	.pict-chart-legend { max-width: none; width: 100%; margin-top: 0.35rem; }
	.pict-chart-legend-items { flex-direction: row; flex-wrap: wrap; gap: 0.1rem 0.75rem; }

	.pict-chart-legend-toggle { display: none !important; }

	.pict-chart-legend-group.pict-collapsed .pict-chart-legend-items { display: flex !important; }

	.pict-chart-legend-swatch,
	.pict-chart-legend-swatch::before,
	.pict-chart-legend-swatch::after
	{
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
}
`;

module.exports = libCSS;

},{}],608:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libChartCSS = require('./Pict-Provider-Input-Chart-CSS.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		// Manage the the configuration parsing configurations -- these can be overridden in the object or even per-input
		if (!this.options.DefaultCoreParsingConfiguration || !Array.isArray(this.options.DefaultCoreParsingConfiguration))
		{
			this.options.DefaultCoreParsingConfiguration = (
				{
					AddressInObject: '',
					ObjectType: 'object',
					MergeMethod: 'Object',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartConfigCorePrototypeRaw',
							Method: `Raw`,
							Merge: true
						},
						{
							InputProperty: 'PictForm.ChartConfigCorePrototypeAddress',
							Method: `Address`,
							Merge: true
						},
						{
							InputProperty: `PictForm.ChartConfigCorePrototype`,
							Method: 'SingleSolver',
							Merge: true
						}
					]
				});
		}
		this.defaultCoreParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultCoreParsingConfiguration));

		if (typeof (this.options.DefaultLabelParsingConfiguration) !== 'object' || !Array.isArray(this.options.DefaultLabelParsingConfiguration.Steps))
		{
			this.options.DefaultLabelParsingConfiguration = (
				{
					AddressInObject: 'data.labels',
					ObjectType: 'array',
					MergeMethod: 'Array',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartLabelsRaw',
							Method: `Raw`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartLabelsAddress',
							Method: `Address`,
							Merge: false
						},
						{
							InputProperty: `PictForm.ChartLabelsSolver`,
							Method: 'SingleSolver',
							Merge: false
						}
					]
				});
		}
		this.defaultLabelParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultLabelParsingConfiguration));

		if (typeof (this.options.DefaultDataParsingConfiguration) !== 'object' || !Array.isArray(this.options.DefaultDataParsingConfiguration.Steps))
		{
			this.options.DefaultDataParsingConfiguration = (
				{
					AddressInObject: 'data.datasets',
					ObjectType: 'array',
					MergeMethod: 'Array',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsRaw',
							Method: `Raw`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsAddress',
							Method: `Address`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsSolvers',
							Method: `ArrayOfSolvers`,
							Merge: true
						}
					]
				});
		}
		this.defaultDataParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultDataParsingConfiguration));

		this.currentChartObjects = {};
		this.currentChartDataObjects = {};
		// Legend visibility + collapsed groups, per input hash, so a redraw does not
		// undo what the user toggled.
		this.currentChartLegendState = {};
		this.currentChartThemeColors = {};

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Input-Chart-CSS', libChartCSS, 500);
		}
	}

	/**
	 * Classify a dataset's line style for its legend swatch, so a reading, a
	 * dashed control limit and an unconnected marker series are told apart at a
	 * glance. Chart.js's own legend draws every entry as the same block.
	 *
	 * @param {Object} pDataset - The Chart.js dataset.
	 * @return {string} A swatch modifier class.
	 */
	_legendSwatchClass(pDataset)
	{
		if (pDataset.showLine === false) { return 'pict-swatch-markers'; }
		const tmpDash = Array.isArray(pDataset.borderDash) ? pDataset.borderDash : null;
		if (!tmpDash || tmpDash.length < 1) { return ''; }
		// A short first segment reads as dotted, a long one as dashed.
		return (Number(tmpDash[0]) <= 3) ? 'pict-swatch-dotted' : 'pict-swatch-dashed';
	}

	/**
	 * Group the datasets for the legend. A dataset declares its group with
	 * `LegendGroup` on the solver entry (carried onto the dataset as
	 * `pictLegendGroup`); anything that does not is "Data". Group ORDER follows
	 * first appearance, so configuration controls it rather than sort order.
	 *
	 * @param {Object} pChart - The Chart.js instance.
	 * @return {Array<{Key: string, Items: Array<{Index: number, Dataset: Object}>}>}
	 */
	_legendGroups(pChart)
	{
		const tmpGroups = [];
		const tmpIndex = {};
		const tmpDatasets = (pChart && pChart.data && pChart.data.datasets) || [];
		for (let i = 0; i < tmpDatasets.length; i++)
		{
			const tmpKey = tmpDatasets[i].pictLegendGroup || 'Data';
			if (!(tmpKey in tmpIndex))
			{
				tmpIndex[tmpKey] = tmpGroups.length;
				tmpGroups.push({ Key: tmpKey, Items: [] });
			}
			tmpGroups[tmpIndex[tmpKey]].Items.push({ Index: i, Dataset: tmpDatasets[i] });
		}
		return tmpGroups;
	}

	/**
	 * Build (or rebuild) the grouped HTML legend beside a chart's canvas.
	 *
	 * The legend is created in the DOM rather than in the template because there
	 * are several chart templates (the base set plus per-theme copies) and a
	 * legend added to only some of them is the kind of divergence that goes
	 * unnoticed. Chart.js's built-in legend is switched off whenever this runs.
	 *
	 * @param {string} pRawHTMLID - The input's Macro.RawHTMLID.
	 * @param {Object} pChart - The Chart.js instance.
	 * @param {Object} pLegendConfiguration - The resolved ChartLegend config.
	 */
	renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration)
	{
		if (typeof (document) === 'undefined' || !pChart || !pChart.canvas) { return false; }
		const tmpCanvas = pChart.canvas;
		const tmpContainer = tmpCanvas.parentElement;
		if (!tmpContainer) { return false; }

		const tmpState = this.currentChartLegendState[pRawHTMLID] = this.currentChartLegendState[pRawHTMLID] || { Hidden: false, Collapsed: {} };
		const tmpPosition = pLegendConfiguration.Position || 'right';

		// Wrap the canvas ONCE: shell > (canvas area | legend).
		//
		// After the first wrap the container's parent is the canvas AREA, not the
		// shell, so testing the immediate parent for 'pict-chart-shell' never matches
		// again and every re-render nests another shell inside the last -- 14 shells
		// and 14 legends for 3 charts after a handful of toggles. Detect the wrapped
		// shape by its own marker and climb to the shell.
		let tmpShell = null;
		const tmpExistingArea = tmpContainer.parentElement;
		if (tmpExistingArea && tmpExistingArea.classList.contains('pict-chart-canvas-area')
			&& tmpExistingArea.parentElement && tmpExistingArea.parentElement.classList.contains('pict-chart-shell'))
		{
			tmpShell = tmpExistingArea.parentElement;
		}
		if (!tmpShell)
		{
			tmpShell = document.createElement('div');
			tmpShell.className = 'pict-chart-shell';
			tmpContainer.parentNode.insertBefore(tmpShell, tmpContainer);
			const tmpArea = document.createElement('div');
			tmpArea.className = 'pict-chart-canvas-area';
			tmpShell.appendChild(tmpArea);
			tmpArea.appendChild(tmpContainer);
		}
		tmpShell.classList.remove('pict-chart-legend-top', 'pict-chart-legend-bottom');
		if (tmpPosition === 'top') { tmpShell.classList.add('pict-chart-legend-top'); }
		if (tmpPosition === 'bottom') { tmpShell.classList.add('pict-chart-legend-bottom'); }

		let tmpLegend = tmpShell.querySelector(':scope > .pict-chart-legend');
		if (!tmpLegend)
		{
			tmpLegend = document.createElement('div');
			tmpLegend.className = 'pict-chart-legend';
			tmpShell.appendChild(tmpLegend);
		}
		tmpLegend.innerHTML = '';

		// Show/hide the whole legend. Charts differ in how much room they have,
		// so this is per-chart and remembered for the session.
		if (pLegendConfiguration.AllowHide !== false)
		{
			const tmpToggle = document.createElement('button');
			tmpToggle.type = 'button';
			tmpToggle.className = 'pict-chart-legend-toggle';
			tmpToggle.textContent = tmpState.Hidden ? 'Show legend' : 'Hide legend';
			tmpToggle.addEventListener('click', () =>
			{
				tmpState.Hidden = !tmpState.Hidden;
				this.renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration);
			});
			tmpLegend.appendChild(tmpToggle);
		}
		if (tmpState.Hidden) { return true; }

		const tmpGroups = this._legendGroups(pChart);
		for (const tmpGroup of tmpGroups)
		{
			const tmpGroupElement = document.createElement('div');
			tmpGroupElement.className = 'pict-chart-legend-group';
			const tmpAllHidden = tmpGroup.Items.every((pItem) => pChart.getDatasetMeta(pItem.Index).hidden === true);
			if (tmpAllHidden) { tmpGroupElement.classList.add('pict-group-off'); }
			if (tmpState.Collapsed[tmpGroup.Key]) { tmpGroupElement.classList.add('pict-collapsed'); }

			const tmpHeader = document.createElement('div');
			tmpHeader.className = 'pict-chart-legend-group-header';
			const tmpCaret = document.createElement('span');
			tmpCaret.className = 'pict-chart-legend-group-caret';
			tmpCaret.textContent = '▾';
			tmpHeader.appendChild(tmpCaret);
			const tmpHeaderLabel = document.createElement('span');
			tmpHeaderLabel.textContent = tmpGroup.Key;
			tmpHeader.appendChild(tmpHeaderLabel);
			// Header click toggles the GROUP's series on/off; the caret collapses it.
			tmpHeader.addEventListener('click', (pEvent) =>
			{
				if (pEvent.target === tmpCaret)
				{
					tmpState.Collapsed[tmpGroup.Key] = !tmpState.Collapsed[tmpGroup.Key];
				}
				else
				{
					const tmpTurnOn = tmpAllHidden;
					for (const tmpItem of tmpGroup.Items)
					{
						pChart.getDatasetMeta(tmpItem.Index).hidden = tmpTurnOn ? false : true;
					}
					pChart.update();
				}
				this.renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration);
			});
			tmpGroupElement.appendChild(tmpHeader);

			const tmpItems = document.createElement('div');
			tmpItems.className = 'pict-chart-legend-items';
			for (const tmpItem of tmpGroup.Items)
			{
				const tmpHidden = pChart.getDatasetMeta(tmpItem.Index).hidden === true;
				const tmpItemElement = document.createElement('div');
				tmpItemElement.className = 'pict-chart-legend-item' + (tmpHidden ? ' pict-hidden' : '');
				const tmpSwatch = document.createElement('span');
				tmpSwatch.className = ('pict-chart-legend-swatch ' + this._legendSwatchClass(tmpItem.Dataset)).trim();
				tmpSwatch.style.color = tmpItem.Dataset.borderColor || tmpItem.Dataset.backgroundColor || '#868E96';
				tmpItemElement.appendChild(tmpSwatch);
				const tmpLabel = document.createElement('span');
				tmpLabel.className = 'pict-chart-legend-label';
				tmpLabel.textContent = tmpItem.Dataset.label || `Series ${tmpItem.Index + 1}`;
				tmpLabel.title = tmpLabel.textContent;
				tmpItemElement.appendChild(tmpLabel);
				tmpItemElement.addEventListener('click', () =>
				{
					pChart.getDatasetMeta(tmpItem.Index).hidden = !tmpHidden;
					pChart.update();
					this.renderChartLegend(pRawHTMLID, pChart, pLegendConfiguration);
				});
				tmpItems.appendChild(tmpItemElement);
			}
			tmpGroupElement.appendChild(tmpItems);
			tmpLegend.appendChild(tmpGroupElement);
		}
		return true;
	}

	/**
	 * Resolve the ChartLegend configuration for an input. Returns null when the
	 * grouped legend is not in use, in which case Chart.js's own legend stands.
	 *
	 * @param {Object} pInput - The PictForm input object.
	 * @return {Object|null}
	 */
	resolveChartLegendConfiguration(pInput)
	{
		const tmpPictform = (pInput && pInput.PictForm) || {};
		const tmpLegend = tmpPictform.ChartLegend;
		if (!tmpLegend) { return null; }
		if (tmpLegend === true) { return { Position: 'right' }; }
		if (typeof (tmpLegend) !== 'object') { return null; }
		if (tmpLegend.Enabled === false) { return null; }
		return tmpLegend;
	}

	/**
	 * Resolve the ChartValueLabels configuration for an input, filled out with
	 * defaults. Returns null when values are not drawn on the chart, in which
	 * case they show only in the hover tooltip.
	 *
	 * @param {Object} pInput - The PictForm input object.
	 * @return {Object|null}
	 */
	resolveChartValueLabelConfiguration(pInput)
	{
		const tmpPictform = (pInput && pInput.PictForm) || {};
		let tmpValueLabels = tmpPictform.ChartValueLabels;
		if (tmpValueLabels === true)
		{
			tmpValueLabels = {};
		}
		if (!tmpValueLabels || (typeof (tmpValueLabels) !== 'object') || (tmpValueLabels.Enabled === false))
		{
			return null;
		}
		const tmpConfiguration = Object.assign(
			{
				Datasets: 'All',
				Position: 'top',
				Offset: 4,
				Padding: 2,
				FontSize: 11,
				FontWeight: 'normal',
				HideOverlaps: true,
			}, tmpValueLabels);
		if ([ 'top', 'bottom', 'center' ].indexOf(tmpConfiguration.Position) < 0)
		{
			tmpConfiguration.Position = 'top';
		}
		const fNumberOr = (pValue, pDefault) =>
		{
			const tmpNumber = parseFloat(pValue);
			return (isFinite(tmpNumber) && (tmpNumber >= 0)) ? tmpNumber : pDefault;
		};
		tmpConfiguration.Offset = fNumberOr(tmpConfiguration.Offset, 4);
		tmpConfiguration.Padding = fNumberOr(tmpConfiguration.Padding, 2);
		tmpConfiguration.FontSize = fNumberOr(tmpConfiguration.FontSize, 11) || 11;
		return tmpConfiguration;
	}

	/**
	 * Build the Chart.js inline plugin that draws each point's value on the chart.
	 *
	 * @param {Object} pConfiguration - From resolveChartValueLabelConfiguration.
	 * @return {Object} A Chart.js plugin.
	 */
	createChartValueLabelPlugin(pConfiguration)
	{
		return (
			{
				id: 'pictValueLabels',
				afterDatasetsDraw: (pChart) =>
				{
					this.drawChartValueLabels(pChart, pConfiguration);
				},
			});
	}

	/**
	 * Format a value for its label: blanks and non-numbers draw nothing, and
	 * floating-point noise (0.30000000000000004) is trimmed unless Decimals fixes
	 * the places.
	 *
	 * @param {any} pValue - The parsed data value.
	 * @param {Object} pConfiguration - From resolveChartValueLabelConfiguration.
	 * @return {string|null} The label text, or null for no label.
	 */
	_formatChartValueLabel(pValue, pConfiguration)
	{
		if ((pValue === null) || (typeof (pValue) === 'undefined') || (pValue === ''))
		{
			return null;
		}
		const tmpNumber = Number(pValue);
		if (!isFinite(tmpNumber))
		{
			return null;
		}
		const tmpDecimals = parseInt(pConfiguration.Decimals, 10);
		if (isFinite(tmpDecimals) && (tmpDecimals >= 0))
		{
			return tmpNumber.toFixed(Math.min(tmpDecimals, 20));
		}
		return String(parseFloat(tmpNumber.toPrecision(12)));
	}

	/**
	 * Work out every candidate value label for a drawn chart: its text, colour and
	 * box. A box that would leave the plot area is flipped to the other side of
	 * its point, then clamped inside.
	 *
	 * @param {Object} pChart - The Chart.js instance.
	 * @param {Object} pConfiguration - From resolveChartValueLabelConfiguration.
	 * @param {(pText: string) => number} fMeasureText - Returns the drawn width of a label's text.
	 * @return {Array<{ Text: string, Color: string, X: number, Y: number, Left: number, Top: number, Width: number, Height: number, DatasetIndex: number, Index: number }>}
	 */
	_collectChartValueLabels(pChart, pConfiguration, fMeasureText)
	{
		const tmpLabels = [];
		const tmpArea = pChart && pChart.chartArea;
		const tmpDatasets = (pChart && pChart.data && pChart.data.datasets) || [];
		if (!tmpArea)
		{
			return tmpLabels;
		}
		const tmpAllDatasets = (pConfiguration.Datasets !== 'OptIn');
		const tmpHeight = pConfiguration.FontSize + (2 * pConfiguration.Padding);
		for (let i = 0; i < tmpDatasets.length; i++)
		{
			const tmpDataset = tmpDatasets[i];
			if (!tmpDataset)
			{
				continue;
			}
			// Raw and Address datasets reach Chart.js as written, so they carry the flag as ValueLabels
			const tmpFlag = (typeof (tmpDataset.pictValueLabels) === 'boolean') ? tmpDataset.pictValueLabels : tmpDataset.ValueLabels;
			const tmpIncluded = (tmpFlag === true) || (tmpAllDatasets && (tmpFlag !== false));
			if (!tmpIncluded)
			{
				continue;
			}
			if ((typeof (pChart.isDatasetVisible) === 'function') && !pChart.isDatasetVisible(i))
			{
				continue;
			}
			const tmpMeta = pChart.getDatasetMeta(i);
			if (!tmpMeta || !Array.isArray(tmpMeta.data))
			{
				continue;
			}
			const tmpValueAxis = (tmpMeta.vScale && tmpMeta.vScale.axis) || 'y';
			for (let j = 0; j < tmpMeta.data.length; j++)
			{
				const tmpElement = tmpMeta.data[j];
				if (!tmpElement || tmpElement.skip)
				{
					continue;
				}
				let tmpValue = (tmpMeta.controller && (typeof (tmpMeta.controller.getParsed) === 'function')) ? tmpMeta.controller.getParsed(j) : tmpDataset.data[j];
				if ((typeof (tmpValue) === 'object') && (tmpValue !== null))
				{
					tmpValue = (tmpValueAxis in tmpValue) ? tmpValue[tmpValueAxis] : tmpValue.y;
				}
				const tmpText = this._formatChartValueLabel(tmpValue, pConfiguration);
				if (tmpText === null)
				{
					continue;
				}
				const tmpPosition = (typeof (tmpElement.tooltipPosition) === 'function') ? tmpElement.tooltipPosition(false) : tmpElement;
				if (!isFinite(tmpPosition.x) || !isFinite(tmpPosition.y))
				{
					continue;
				}
				const tmpWidth = fMeasureText(tmpText) + (2 * pConfiguration.Padding);
				const tmpRadius = (tmpElement.options && isFinite(tmpElement.options.radius)) ? Number(tmpElement.options.radius) : 0;
				const tmpGap = tmpRadius + pConfiguration.Offset;
				// Arcs (pie, doughnut, polar area) label their centroid
				let tmpPlacement = (typeof (tmpElement.outerRadius) === 'number') ? 'center' : pConfiguration.Position;
				// A bar below its base reads from its far end, so its label goes underneath
				if ((tmpPlacement !== 'center') && ('base' in tmpElement) && (Number(tmpValue) < 0))
				{
					tmpPlacement = (tmpPlacement === 'top') ? 'bottom' : 'top';
				}
				const tmpAboveTop = tmpPosition.y - tmpGap - tmpHeight;
				const tmpBelowTop = tmpPosition.y + tmpGap;
				const fClampTop = (pTop) => Math.max(tmpArea.top, Math.min(pTop, tmpArea.bottom - tmpHeight));
				let tmpTop = tmpPosition.y - (tmpHeight / 2);
				// The other side of the point, tried when the first choice collides with a kept label
				let tmpAlternateTop = null;
				if (tmpPlacement === 'top')
				{
					const tmpFits = (tmpAboveTop >= tmpArea.top);
					tmpTop = tmpFits ? tmpAboveTop : tmpBelowTop;
					tmpAlternateTop = tmpFits ? fClampTop(tmpBelowTop) : null;
				}
				else if (tmpPlacement === 'bottom')
				{
					const tmpFits = ((tmpBelowTop + tmpHeight) <= tmpArea.bottom);
					tmpTop = tmpFits ? tmpBelowTop : tmpAboveTop;
					tmpAlternateTop = tmpFits ? fClampTop(tmpAboveTop) : null;
				}
				tmpTop = fClampTop(tmpTop);
				const tmpLeft = Math.max(tmpArea.left, Math.min(tmpPosition.x - (tmpWidth / 2), tmpArea.right - tmpWidth));
				let tmpColor = pConfiguration.Color || (pChart.options && pChart.options.color) || '#666';
				if (pConfiguration.Color === 'Dataset')
				{
					tmpColor = (tmpElement.options && tmpElement.options.borderColor) || tmpDataset.borderColor || (pChart.options && pChart.options.color) || '#666';
				}
				tmpLabels.push(
					{
						Text: tmpText,
						Color: tmpColor,
						X: tmpLeft + (tmpWidth / 2),
						Y: tmpTop + (tmpHeight / 2),
						Left: tmpLeft,
						Top: tmpTop,
						Width: tmpWidth,
						Height: tmpHeight,
						AlternateTop: tmpAlternateTop,
						DatasetIndex: i,
						Index: j,
					});
			}
		}
		return tmpLabels;
	}

	/**
	 * Keep the labels that fit. A label that would overlap one already kept moves
	 * to the other side of its point if that is clear, and is hidden otherwise.
	 * Earlier datasets win, then earlier points, so the series listed first keeps
	 * its values when series crowd each other.
	 *
	 * @param {Array<Object>} pLabels - From _collectChartValueLabels.
	 * @param {boolean} pHideOverlaps - False keeps every label where it was first placed.
	 * @return {Array<Object>} The labels to draw.
	 */
	_layoutChartValueLabels(pLabels, pHideOverlaps)
	{
		if (!pHideOverlaps)
		{
			return pLabels;
		}
		const tmpKept = [];
		const fIsClear = (pLeft, pTop, pWidth, pHeight) =>
		{
			for (let j = 0; j < tmpKept.length; j++)
			{
				const tmpOther = tmpKept[j];
				if ((pLeft < tmpOther.Left + tmpOther.Width) && (tmpOther.Left < pLeft + pWidth)
					&& (pTop < tmpOther.Top + tmpOther.Height) && (tmpOther.Top < pTop + pHeight))
				{
					return false;
				}
			}
			return true;
		};
		for (let i = 0; i < pLabels.length; i++)
		{
			const tmpLabel = pLabels[i];
			if (fIsClear(tmpLabel.Left, tmpLabel.Top, tmpLabel.Width, tmpLabel.Height))
			{
				tmpKept.push(tmpLabel);
			}
			else if ((typeof (tmpLabel.AlternateTop) === 'number') && fIsClear(tmpLabel.Left, tmpLabel.AlternateTop, tmpLabel.Width, tmpLabel.Height))
			{
				tmpKept.push(Object.assign({}, tmpLabel, { Top: tmpLabel.AlternateTop, Y: tmpLabel.AlternateTop + (tmpLabel.Height / 2), AlternateTop: null }));
			}
		}
		return tmpKept;
	}

	/**
	 * The halo drawn behind label text so it stays readable over grid lines and
	 * other series: dark behind light text, light behind dark text.
	 *
	 * @param {string} pTextColor - The chart's text colour.
	 * @return {string} The halo colour.
	 */
	_chartValueLabelHaloColor(pTextColor)
	{
		const tmpMatch = /^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)/.exec(pTextColor || '');
		if (tmpMatch)
		{
			const tmpLuminance = ((0.299 * Number(tmpMatch[1])) + (0.587 * Number(tmpMatch[2])) + (0.114 * Number(tmpMatch[3]))) / 255;
			if (tmpLuminance > 0.5)
			{
				return 'rgba(0, 0, 0, 0.75)';
			}
		}
		return 'rgba(255, 255, 255, 0.85)';
	}

	/**
	 * Draw each point's value on a chart's canvas, after its datasets.
	 *
	 * @param {Object} pChart - The Chart.js instance.
	 * @param {Object} pConfiguration - From resolveChartValueLabelConfiguration.
	 * @return {number} How many labels were drawn.
	 */
	drawChartValueLabels(pChart, pConfiguration)
	{
		const tmpContext = pChart && pChart.ctx;
		if (!tmpContext || !pChart.chartArea)
		{
			return 0;
		}
		const tmpFamily = (pChart.options && pChart.options.font && pChart.options.font.family) || 'sans-serif';
		tmpContext.save();
		tmpContext.font = `${pConfiguration.FontWeight} ${pConfiguration.FontSize}px ${tmpFamily}`;
		const tmpLabels = this._layoutChartValueLabels(
			this._collectChartValueLabels(pChart, pConfiguration, (pText) => tmpContext.measureText(pText).width),
			pConfiguration.HideOverlaps !== false);
		tmpContext.textAlign = 'center';
		tmpContext.textBaseline = 'middle';
		const tmpHaloWidth = parseFloat(pConfiguration.HaloWidth);
		if (pConfiguration.Halo !== false)
		{
			tmpContext.lineJoin = 'round';
			tmpContext.lineWidth = (isFinite(tmpHaloWidth) && (tmpHaloWidth > 0)) ? tmpHaloWidth : 3;
			tmpContext.strokeStyle = pConfiguration.HaloColor || this._chartValueLabelHaloColor(pChart.options && pChart.options.color);
		}
		for (let i = 0; i < tmpLabels.length; i++)
		{
			if (pConfiguration.Halo !== false)
			{
				tmpContext.strokeText(tmpLabels[i].Text, tmpLabels[i].X, tmpLabels[i].Y);
			}
			tmpContext.fillStyle = tmpLabels[i].Color;
			tmpContext.fillText(tmpLabels[i].Text, tmpLabels[i].X, tmpLabels[i].Y);
		}
		tmpContext.restore();
		return tmpLabels.length;
	}

	/**
	 * Resolve the text and grid colours a chart should draw with from the page
	 * around its canvas, so the canvas follows the host's light or dark theme the
	 * way the surrounding HTML does. `--pict-chart-text-color` and
	 * `--pict-chart-grid-color` win when set; otherwise the text colour is the
	 * canvas's inherited CSS `color` and the grid is that colour faded.
	 *
	 * @param {Object} pInput - The PictForm input object.
	 * @return {{ Text: string, Grid: string|null }|null} Null when there is no rendered canvas to read.
	 */
	resolveChartThemeColors(pInput)
	{
		if ((typeof (window) === 'undefined') || (typeof (window.getComputedStyle) !== 'function') || !pInput || !pInput.Macro)
		{
			return null;
		}
		const tmpCanvasElements = this.pict.ContentAssignment.getElement(`#CANVAS-FOR-${pInput.Macro.RawHTMLID}`);
		if (!Array.isArray(tmpCanvasElements) || (tmpCanvasElements.length < 1))
		{
			return null;
		}
		const tmpStyle = window.getComputedStyle(tmpCanvasElements[0]);
		const tmpText = tmpStyle.getPropertyValue('--pict-chart-text-color').trim() || tmpStyle.color;
		if (!tmpText)
		{
			return null;
		}
		const tmpGrid = tmpStyle.getPropertyValue('--pict-chart-grid-color').trim() || this._fadeChartColor(tmpText, 0.15);
		return { Text: tmpText, Grid: tmpGrid };
	}

	/**
	 * @param {string} pColor - A computed `rgb()` / `rgba()` colour.
	 * @param {number} pAlpha - The opacity to give it.
	 * @return {string|null} The faded colour, or null when the colour is in another notation.
	 */
	_fadeChartColor(pColor, pAlpha)
	{
		const tmpMatch = /^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)/.exec(pColor);
		if (!tmpMatch)
		{
			return null;
		}
		return `rgba(${tmpMatch[1]}, ${tmpMatch[2]}, ${tmpMatch[3]}, ${pAlpha})`;
	}

	/**
	 * Apply theme colours to a drawn chart, filling only the colour options the
	 * manifest left unset, so an explicit colour always wins. Chart.js takes
	 * tick, grid and title colours from its global defaults rather than the
	 * chart's own `color`, so every scale the chart drew is coloured by id.
	 *
	 * @param {Object} pChart - The Chart.js instance.
	 * @param {Object} pManifestOptions - The chart options as built from the manifest, before Chart.js filled in its defaults.
	 * @param {{ Text: string, Grid: string|null }|null} pColors - From resolveChartThemeColors.
	 * @return {boolean} True when a colour changed and the chart was updated.
	 */
	applyChartThemeColors(pChart, pManifestOptions, pColors)
	{
		if (!pChart || (typeof (pChart.options) !== 'object') || !pColors)
		{
			return false;
		}
		const tmpManifestOptions = (typeof (pManifestOptions) === 'object' && pManifestOptions !== null) ? pManifestOptions : {};
		let tmpChanged = false;
		const fSetUnlessExplicit = (pPath, pValue) =>
		{
			if (!pValue)
			{
				return;
			}
			if (typeof (this.pict.manifest.getValueByHash(tmpManifestOptions, pPath)) !== 'undefined')
			{
				return;
			}
			const tmpParts = pPath.split('.');
			let tmpTarget = pChart.options;
			for (let i = 0; i < tmpParts.length - 1; i++)
			{
				if ((typeof (tmpTarget[tmpParts[i]]) !== 'object') || (tmpTarget[tmpParts[i]] === null))
				{
					tmpTarget[tmpParts[i]] = {};
				}
				tmpTarget = tmpTarget[tmpParts[i]];
			}
			const tmpKey = tmpParts[tmpParts.length - 1];
			if (tmpTarget[tmpKey] !== pValue)
			{
				tmpTarget[tmpKey] = pValue;
				tmpChanged = true;
			}
		};

		fSetUnlessExplicit('color', pColors.Text);
		fSetUnlessExplicit('plugins.title.color', pColors.Text);
		fSetUnlessExplicit('plugins.subtitle.color', pColors.Text);

		const tmpScales = (typeof (pChart.scales) === 'object' && pChart.scales !== null) ? pChart.scales : {};
		const tmpScaleIDs = Object.keys(tmpScales);
		for (let i = 0; i < tmpScaleIDs.length; i++)
		{
			const tmpScaleAddress = `scales.${tmpScaleIDs[i]}`;
			fSetUnlessExplicit(`${tmpScaleAddress}.ticks.color`, pColors.Text);
			fSetUnlessExplicit(`${tmpScaleAddress}.title.color`, pColors.Text);
			fSetUnlessExplicit(`${tmpScaleAddress}.grid.color`, pColors.Grid);
			fSetUnlessExplicit(`${tmpScaleAddress}.border.color`, pColors.Grid);
			const tmpScaleOptions = tmpScales[tmpScaleIDs[i]] && tmpScales[tmpScaleIDs[i]].options;
			if (tmpScaleOptions && tmpScaleOptions.pointLabels)
			{
				fSetUnlessExplicit(`${tmpScaleAddress}.pointLabels.color`, pColors.Text);
				fSetUnlessExplicit(`${tmpScaleAddress}.angleLines.color`, pColors.Grid);
				// Radial tick labels sit on a white backdrop by default, which hides light text
				fSetUnlessExplicit(`${tmpScaleAddress}.ticks.backdropColor`, 'transparent');
			}
		}

		if (tmpChanged && (typeof (pChart.update) === 'function'))
		{
			pChart.update('none');
		}
		return tmpChanged;
	}

	/**
	 * Re-read the theme colours around a chart and apply them when they differ
	 * from the last ones applied to it (or always, when forced for a new chart).
	 *
	 * @param {Object} pInput - The PictForm input object.
	 * @param {Object} pChart - The Chart.js instance.
	 * @param {Object} pManifestOptions - The chart options as built from the manifest.
	 * @param {boolean} [pForce] - Apply even if the colours have not changed.
	 */
	refreshChartThemeColors(pInput, pChart, pManifestOptions, pForce)
	{
		const tmpColors = this.resolveChartThemeColors(pInput);
		if (!tmpColors)
		{
			return;
		}
		const tmpKey = `Theme-For-${pInput.Macro.RawHTMLID}`;
		const tmpSignature = JSON.stringify(tmpColors);
		if (!pForce && (this.currentChartThemeColors[tmpKey] === tmpSignature))
		{
			return;
		}
		this.applyChartThemeColors(pChart, pManifestOptions, tmpColors);
		this.currentChartThemeColors[tmpKey] = tmpSignature;
	}

	/**
	 * Copy the arrays and plain objects of a chart configuration fragment, so the
	 * parsing steps can merge into it without writing back into the manifest or
	 * application state it was read from. Anything else (functions such as
	 * Chart.js callbacks, class instances) is carried across by reference.
	 *
	 * @param {any} pValue - The configuration fragment.
	 * @return {any} The copy.
	 */
	_cloneChartConfiguration(pValue)
	{
		if (Array.isArray(pValue))
		{
			return pValue.map((pItem) => this._cloneChartConfiguration(pItem));
		}
		if ((pValue === null) || (typeof (pValue) !== 'object'))
		{
			return pValue;
		}
		const tmpPrototype = Object.getPrototypeOf(pValue);
		if ((tmpPrototype !== Object.prototype) && (tmpPrototype !== null))
		{
			return pValue;
		}
		const tmpCopy = {};
		const tmpKeys = Object.keys(pValue);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpCopy[tmpKeys[i]] = this._cloneChartConfiguration(pValue[tmpKeys[i]]);
		}
		return tmpCopy;
	}

	/**
	 * 
	 * @param {Object} pInput - The PictForm input object
	 * @param {*} pChartConfiguration - The current configuration object for the form
	 * @param {*} pParsingConfiguration - The parsing configuration to apply
	 * @param {*} pInputParsingConfigurationScope - The input-specific parsing configuration string address for additional configuration
	 * @returns 
	 */
	applyInputParsingConfiguration(pInput, pChartConfiguration, pParsingConfiguration, pInputParsingConfigurationScope)
	{
		// TODO: There is a ton of DRY to be had in this function when we break it out to the base class
		let tmpInput = pInput;
		let tmpInputParsingConfigurationScope = pInputParsingConfigurationScope;

		let tmpChartConfiguration = pChartConfiguration;
		let tmpParsingConfiguration = pParsingConfiguration;

		if (typeof (pInput) !== 'object')
		{
			return false;
		}
		if (typeof (pInputParsingConfigurationScope) !== 'string' || (pInputParsingConfigurationScope.length < 1))
		{
			return false;
		}
		if (typeof (tmpParsingConfiguration) !== 'object')
		{
			return false;
		}

		if (typeof (tmpChartConfiguration) !== 'object')
		{
			tmpChartConfiguration = {};
		}

		// 1. Check if there is any custom configurtion for how to parse the config for this input (dynamic dynamic)
		let tmpInputCustomConfiguration = this.pict.manifest.getValueByHash(tmpInput, tmpInputParsingConfigurationScope);
		if (typeof (tmpInputCustomConfiguration) === 'object')
		{
			// Merge the custom configuration into the base configuration
			tmpParsingConfiguration = Object.assign({}, tmpParsingConfiguration, tmpInputCustomConfiguration);
		}

		let tmpExistingData;

		// 2. Enumerate through each step and apply them consistently
		for (let i = 0; i < tmpParsingConfiguration.Steps.length; i++)
		{
			let tmpCurrentStep = tmpParsingConfiguration.Steps[i];

			// Get existing data -- what the earlier steps left, so a merging step layers onto them
			if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
			{
				tmpExistingData = tmpChartConfiguration;
			}
			else
			{
				tmpExistingData = this.pict.manifest.getValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject);
			}

			switch (tmpCurrentStep.Method)
			{
				case 'Initialize':
					// Do nothing, already initialized
					if (tmpParsingConfiguration.AddressInObject && (typeof (tmpParsingConfiguration.AddressInObject) === 'string') && (tmpParsingConfiguration.AddressInObject.length > 0))
					{
						let tmpCurrentStepData = this.pict.manifest.getValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject);
						// see if the address exists and if it's the type we expect
						if (tmpParsingConfiguration.ObjectType === 'array')
						{
							if (!tmpCurrentStepData || !Array.isArray(tmpCurrentStepData))
							{
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, []);
							}
						}
						else if (tmpParsingConfiguration.ObjectType === 'object')
						{
							if (!tmpCurrentStepData || (typeof (tmpCurrentStepData) !== 'object'))
							{
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, {});
							}
						}
						else
						{
							this.pict.log.warn(`Unsupported ObjectType ${tmpParsingConfiguration.ObjectType} parsing chart Initialize configuration for input ${tmpInput.Macro.RawHTMLID}`);
						}
					}
					break;
				case 'Raw':
					// Check if the Raw is in there
					let tmpRawDataExists = this.pict.manifest.checkAddressExists(tmpInput, tmpCurrentStep.InputProperty);
					if (!tmpRawDataExists)
					{
						break;
					}

					// Get the raw data from the input
					let tmpRawData = this._cloneChartConfiguration(this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty));
					let tmpRawDataType = typeof(tmpRawData);

					// We only support objects as configuration
					if (tmpRawDataType !== 'object')
					{
						break;
					}

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpRawData))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpRawData);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpRawData);
								}
								else
								{
									tmpChartConfiguration = tmpRawData;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpRawData);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;
				case 'Address':
					let tmpAddress = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					// Input is the Record in the resolution chain
					if (!tmpAddress)
					{
						break;
					}

					let tmpPotentialConfigurationObject = this._cloneChartConfiguration(this.pict.resolveStateFromAddress(tmpAddress, pInput));

					if (typeof (tmpPotentialConfigurationObject) !== 'object')
					{
						break;
					}

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpPotentialConfigurationObject))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpPotentialConfigurationObject);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpPotentialConfigurationObject);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpPotentialConfigurationObject);
								}
								else
								{
									tmpChartConfiguration = tmpPotentialConfigurationObject;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpPotentialConfigurationObject);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpPotentialConfigurationObject);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpPotentialConfigurationObject);
						}
					}
					break;
				case 'SingleSolver':
					let tmpSolverExpression = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					// Check that the expression is a string
					if (typeof (tmpSolverExpression) !== 'string')
					{
						break;
					}

					let tmpSolvedConfiguration = this.pict.providers.DynamicSolver.runSolver(tmpSolverExpression, true);

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpSolvedConfiguration))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpSolvedConfiguration);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedConfiguration);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpSolvedConfiguration);
								}
								else
								{
									tmpChartConfiguration = tmpSolvedConfiguration;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpSolvedConfiguration);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedConfiguration);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedConfiguration);
						}
					}
					break;

				case 'ArrayOfSolvers':
					let tmpSolverExpressionList = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);

					// Check that the expression is a string
					if (!Array.isArray(tmpSolverExpressionList))
					{
						break;
					}

					for (let i = 0; i < tmpSolverExpressionList.length; i++)
					{
						let tmpCurrentSolverExpression = tmpSolverExpressionList[i];
						if (typeof(tmpCurrentSolverExpression) !== 'object')
						{
							continue;
						}

						let tmpSolverLabel = tmpCurrentSolverExpression.Label;
						let tmpSolverExpression = tmpCurrentSolverExpression.DataSolver;
						let tmpSolvedDataSet = this.pict.providers.DynamicSolver.runSolver(tmpSolverExpression, true);

						let tmpDataObject = (
							{
								label: tmpSolverLabel,
								data: (Array.isArray(tmpSolvedDataSet)) ? tmpSolvedDataSet : []
							});

						if (tmpCurrentSolverExpression.ChartType)
						{
							tmpDataObject.type = tmpCurrentSolverExpression.ChartType;
						}

						// Add in any custom Y axis ID
						if (tmpCurrentSolverExpression.CustomYAxisID)
						{
							tmpDataObject.yAxisID = tmpCurrentSolverExpression.CustomYAxisID;
						}

						// Add in any custom X axis ID
						if (tmpCurrentSolverExpression.CustomXAxisID)
						{
							tmpDataObject.xAxisID = tmpCurrentSolverExpression.CustomXAxisID;
						}

						// Add in a custom Tension
						if ((tmpCurrentSolverExpression.Tension !== undefined) && (tmpCurrentSolverExpression.Tension !== null))
						{
							tmpDataObject.tension = tmpCurrentSolverExpression.Tension;
						}
						
						// Add in a custom pointRadius
						if ((tmpCurrentSolverExpression.PointRadius !== undefined) && (tmpCurrentSolverExpression.PointRadius !== null))
						{
							tmpDataObject.pointRadius = tmpCurrentSolverExpression.PointRadius;
						}

						// Check if this has a stack defined (for stacked bar charts and such)
						if (tmpCurrentSolverExpression.StackGroup)
						{
							tmpDataObject.stack = tmpCurrentSolverExpression.StackGroup;
						}

						// DatasetOptions is the general escape hatch: every key is merged onto
						// the Chart.js dataset as-is. Without it a dataset could only carry the
						// handful of properties named above, so a series could not be given a
						// colour, a dash pattern, or told not to join its points -- the config
						// was silently dropped and the chart drew in default colours. It is
						// applied last, so it wins over the named options above.
						if (tmpCurrentSolverExpression.DatasetOptions && (typeof(tmpCurrentSolverExpression.DatasetOptions) === 'object'))
						{
							Object.assign(tmpDataObject, tmpCurrentSolverExpression.DatasetOptions);
						}

						// Which legend group this series belongs to ("Data", "Limits", …).
						// Carried as a pict-prefixed key so it cannot collide with a Chart.js
						// dataset property.
						if (tmpCurrentSolverExpression.LegendGroup)
						{
							tmpDataObject.pictLegendGroup = tmpCurrentSolverExpression.LegendGroup;
						}

						if (typeof (tmpCurrentSolverExpression.ValueLabels) === 'boolean')
						{
							tmpDataObject.pictValueLabels = tmpCurrentSolverExpression.ValueLabels;
						}

						if (tmpParsingConfiguration.ObjectType === 'array')
						{
							if (Array.isArray(tmpSolvedDataSet))
							{
								if (tmpCurrentStep.Merge)
								{
									// Get existing data
									if (!Array.isArray(tmpExistingData))
									{
										tmpExistingData = [];
									}
									tmpExistingData.push(tmpDataObject);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpExistingData);
								}
								else
								{
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, [tmpDataObject]);
								}
							}
						}
						else if (tmpParsingConfiguration.ObjectType === 'object')
						{
							if (tmpCurrentStep.Merge)
							{
								if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
								{
									// This is the "root" object, so we need to merge or set directly
									if (tmpCurrentStep.Merge)
									{
										tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpSolvedDataSet);
									}
									else
									{
										tmpChartConfiguration = tmpSolvedDataSet;
									}
								}
								else
								{
									if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
									{
										tmpExistingData = {};
									}
									if (tmpCurrentStep.Merge)
									{
										// Merge the objects
										let tmpMergedData = Object.assign(tmpExistingData, tmpSolvedDataSet);
										this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
									}
									else
									{
										// Just set the value
										this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedDataSet);
									}
								}
							}
							else
							{
								// Just set the value?
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedDataSet);
							}
						}
					}
					break;
			}
		}
	}

	getInputChartConfiguration(pView, pInput, pValue)
	{
		let tmpView = pView;
		let tmpInput = pInput;
		let tmpValue = pValue;

		if (!('PictForm' in tmpInput))
		{
			return false;
		}

		let tmpPictform = pInput.PictForm;

		let tmpChartConfiguration = (typeof (tmpPictform.ChartJSOptionsCorePrototype) === 'object') ? this._cloneChartConfiguration(tmpPictform.ChartJSOptionsCorePrototype) : {};

		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultCoreParsingConfiguration, 'PictForm.ChartConfigCoreParsingConfigurationOverride');
		if (!('type' in tmpChartConfiguration))
		{
			tmpChartConfiguration.type = (typeof (tmpPictform.ChartType) === 'string') ? tmpPictform.ChartType : 'bar';
		}
		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultLabelParsingConfiguration, 'PictForm.ChartLabelsParsingConfigurationOverride');
		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultDataParsingConfiguration, 'PictForm.ChartDataParsingConfigurationOverride');

		// A blank is a MISSING reading, not a zero one. Solver-built series routinely carry "" for
		// "this measure has no value here" -- a control limit the agency does not publish, a sample
		// the lab never ran -- and Chart.js coerces that empty string to 0, drawing a line that dives
		// to the axis and reads as a real measurement of zero. Chart.js's own convention for a gap is
		// null, so blanks are normalized to it and the series simply breaks. Set ChartPlotBlanksAsZero
		// to keep the old coercion for a chart that genuinely means zero.
		if (!tmpPictform.ChartPlotBlanksAsZero)
		{
			const tmpDatasets = tmpChartConfiguration?.data?.datasets;
			if (Array.isArray(tmpDatasets))
			{
				for (let i = 0; i < tmpDatasets.length; i++)
				{
					if (!tmpDatasets[i] || !Array.isArray(tmpDatasets[i].data)) { continue; }
					tmpDatasets[i].data = tmpDatasets[i].data.map(
						(pPoint) => ((pPoint === '') || (pPoint === null) || (typeof (pPoint) === 'undefined')) ? null : pPoint);
				}
			}
		}

		// ChartHeight is one knob with two halves: the template gives the canvas container a min-height,
		// and Chart.js has to be told to stop deriving its own height from the width or it will ignore
		// that box entirely. Requiring a caller to set maintainAspectRatio by hand alongside the height
		// would make a single intent ("make this chart taller") into two coupled settings that are wrong
		// in isolation, so it is derived here. An explicit maintainAspectRatio in the core prototype still
		// wins -- this only fills in the value the caller did not state.
		// The grouped legend replaces Chart.js's own, which is a single wrapped row
		// of identical swatches -- unreadable once a chart carries a reading, a
		// running average and three pairs of control limits.
		if (this.resolveChartLegendConfiguration(pInput))
		{
			if (typeof (tmpChartConfiguration.options) !== 'object' || tmpChartConfiguration.options === null)
			{
				tmpChartConfiguration.options = {};
			}
			if (typeof (tmpChartConfiguration.options.plugins) !== 'object' || tmpChartConfiguration.options.plugins === null)
			{
				tmpChartConfiguration.options.plugins = {};
			}
			tmpChartConfiguration.options.plugins.legend = Object.assign({}, tmpChartConfiguration.options.plugins.legend, { display: false });
		}

		const tmpValueLabelConfiguration = this.resolveChartValueLabelConfiguration(pInput);
		if (tmpValueLabelConfiguration)
		{
			if (!Array.isArray(tmpChartConfiguration.plugins))
			{
				tmpChartConfiguration.plugins = [];
			}
			tmpChartConfiguration.plugins.push(this.createChartValueLabelPlugin(tmpValueLabelConfiguration));
			// Room above the plot for the topmost point's label, so it does not have to flip below its point
			if ((tmpValueLabelConfiguration.Position === 'top') && (typeof (tmpChartConfiguration.options?.layout?.padding) === 'undefined'))
			{
				if (typeof (tmpChartConfiguration.options) !== 'object' || tmpChartConfiguration.options === null)
				{
					tmpChartConfiguration.options = {};
				}
				tmpChartConfiguration.options.layout = Object.assign({}, tmpChartConfiguration.options.layout,
					{ padding: { top: tmpValueLabelConfiguration.FontSize + tmpValueLabelConfiguration.Offset + (2 * tmpValueLabelConfiguration.Padding) } });
			}
		}

		const tmpChartHeight = parseFloat(tmpPictform.ChartHeight);
		if (isFinite(tmpChartHeight) && (tmpChartHeight > 0))
		{
			if (typeof (tmpChartConfiguration.options) !== 'object' || tmpChartConfiguration.options === null)
			{
				tmpChartConfiguration.options = {};
			}
			if (!('maintainAspectRatio' in tmpChartConfiguration.options))
			{
				tmpChartConfiguration.options.maintainAspectRatio = false;
			}
			if (!('responsive' in tmpChartConfiguration.options))
			{
				tmpChartConfiguration.options.responsive = true;
			}
		}

		return tmpChartConfiguration;
	}

	initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Stuff the config into a hidden element for reference
		let tmpConfigStorageLocation = `#CONFIG-FOR-${pInput.Macro.RawHTMLID}`;
		let tmpChartConfiguration = this.getInputChartConfiguration(pView, pInput, pValue);
		this.pict.ContentAssignment.assignContent(tmpConfigStorageLocation, JSON.stringify(tmpChartConfiguration));

		let tmpChartCanvasElementSelector = `#CANVAS-FOR-${pInput.Macro.RawHTMLID}`;
		let tmpChartCanvasElement = this.pict.ContentAssignment.getElement(tmpChartCanvasElementSelector);
		if ((!Array.isArray(tmpChartCanvasElement)) || (tmpChartCanvasElement.length < 1))
		{
			this.log.warn(`Chart canvas element not found for input ${tmpChartCanvasElementSelector}`);
			return false;
		}
		tmpChartCanvasElement = tmpChartCanvasElement[0]

		// Check if there is a window.Chart which is the Chart.js library
		if (typeof (window.Chart) !== 'function')
		{
			this.log.warn(`Chart.js library not loaded for input ${tmpChartCanvasElementSelector}`);
		}
		else
		{
			// Chart.js writes its resolved defaults back into the options it is given
			const tmpManifestOptions = this._cloneChartConfiguration(tmpChartConfiguration.options || {});
			this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`] = new window.Chart(tmpChartCanvasElement, tmpChartConfiguration);
			// TODO: Make this invalidation better.
			this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] = JSON.stringify(tmpChartConfiguration.data);
			this.refreshChartThemeColors(pInput, this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`], tmpManifestOptions, true);

			const tmpLegendConfiguration = this.resolveChartLegendConfiguration(pInput);
			if (tmpLegendConfiguration)
			{
				this.renderChartLegend(pInput.Macro.RawHTMLID, this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`], tmpLegendConfiguration);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`])
		{
			this.initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		}
		else
		{
			let tmpChartConfiguration = this.getInputChartConfiguration(pView, pInput, pValue);
			let tmpNewChartDataString = JSON.stringify(tmpChartConfiguration.data);
			if (this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] !== tmpNewChartDataString)
			{
				this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`].data = tmpChartConfiguration.data;
				this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`].update();
				const tmpUpdatedLegendConfiguration = this.resolveChartLegendConfiguration(pInput);
				if (tmpUpdatedLegendConfiguration)
				{
					this.renderChartLegend(pInput.Macro.RawHTMLID, this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`], tmpUpdatedLegendConfiguration);
				}
				this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] = tmpNewChartDataString;
			}
			this.refreshChartThemeColors(pInput, this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`], tmpChartConfiguration.options);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @returns {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599,"./Pict-Provider-Input-Chart-CSS.js":607}],609:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 * Represents a custom input handler for a Pict section form.
 * @extends libPictSectionInputExtension
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a DateTime input element based on the given input HTML ID.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @returns {string} The generated DateTime input HTML ID.
	 */
	getDateTimeInputHTMLID(pInputHTMLID)
	{
		return `#DATETIME-INPUT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a hidden input element in a tabular datetime data provider.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns {string} - The generated HTML ID for the hidden input element.
	 */
	getTabularDateTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular date-time input HTML ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} The tabular date-time input HTML ID.
	 */
	getTabularDateTimeInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Fires after data has been marshaled to the form.
	 *
	 * This is important because the DateTime has a "shadow" hidden input that stores the value for the date control.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method call.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form in a tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for the specified input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean} - Returns true if the data request is successful, otherwise false.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		// TODO: Should this be opinionated about time zone?  If so, this is the start of it.
		// let tmpDateTimeElement = this.pict.ContentAssignment.getElement(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID));
		// if (tmpDateTimeElement && tmpDateTimeElement.length > 0)
		// {
		// 	tmpDateTimeElement = tmpDateTimeElement[0];
		// }
		// else
		// {
		// 	return false;
		// }
		//let tmpDateValue = this.fable.Dates.dayJS(tmpDateTimeElement.value);

		let tmpInputSelectValue;
		try
		{
			tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID));
			this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
			pView.dataChanged(pInput.Hash);
		}
		catch
		{
			this.log.error(`The value [${tmpInputSelectValue}] is not a valid date; skipping parsing for [#${pInput.Macro.RawHTMLID}].`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for the specified input when in a tabular section.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {boolean} - Returns true if the data request is successful, otherwise false.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// TODO: If we decide to be opinionated about time zone, use the above here as well
		let tmpInputSelectValue;
		try
		{
			tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
			pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		}
		catch
		{
			this.log.error(`The value [${tmpInputSelectValue}] is not a valid date; skipping parsing for [#${pInput.Macro.RawHTMLID}].`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],610:[function(require,module,exports){
/**
 * Pict-Provider-Input-Diagram-CSS.js
 *
 * Scoped CSS for the Diagram form-input slot. Registered via
 * `pict.CSSMap.addCSS('Pict-Input-Diagram-CSS', libCSS, 500)` from the
 * provider's constructor.
 *
 * SVG content rendered into the view-mode slot uses palette CSS variables
 * (`--diagram-ink`, `--diagram-accent`, etc.) emitted by Themeify-SVG. The
 * SVG carries hex fallbacks inline, so the diagram looks correct even when no
 * theme variables are defined.
 *
 * Class names:
 *
 *   .pict-section-form-diagram        the outer slot the form template emits
 *   .pict-section-form-diagram-view   the inline-SVG container (view mode)
 *   .pict-section-form-diagram-edit   the Excalidraw container (edit mode)
 *   .pict-section-form-diagram-toggle "Edit" / "Done" affordance chip
 */

module.exports = /*css*/`
.pict-section-form-diagram
{
	display: block;
	width: 100%;
	min-height: 120px;
	border: 1px solid var(--theme-color-border-primary, #D4C4A8);
	border-radius: 4px;
	background: var(--theme-color-background-primary, #FFFFFF);
	color: var(--theme-color-text-primary, #2A2520);
	box-sizing: border-box;
	position: relative;
}

.pict-section-form-diagram-view
{
	padding: 12px;
	min-height: 96px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: auto;
}

.pict-section-form-diagram-view.is-empty
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-style: italic;
	font-size: 0.9rem;
}

.pict-section-form-diagram-view svg
{
	display: block;
	max-width: 100%;
	height: auto;
}

/* Open-editor sizing.
 *
 * The height is a variable so the provider can drive it from the descriptor's Diagram.Height (and
 * from a height the user dragged to) without inlining a whole style block. The default clears
 * Excalidraw's own 500px "this is a phone" breakpoint AND leaves the shape-properties island room to
 * render unscrolled — below that the island is clipped to a scrolling sliver and the property
 * buttons become miserable to hit.
 *
 * The resize:vertical rule is the drag grip, the same affordance a textarea has; it needs a
 * non-visible overflow to show up at all. The floor is deliberately a small absolute value rather than the
 * configured height, or the grip could not drag below whatever the field was configured to. */
.pict-section-form-diagram-edit
{
	padding: 0;
	height: var(--pict-diagram-height, 560px);
	min-height: 180px;
	display: flex;
	resize: vertical;
	overflow: hidden;
}

/* The Excalidraw view brings its own chrome inside the slot. Force the wrap and the Excalidraw root
 * to FILL rather than to floor: a min-height in here would fight the grip on the way down and pin
 * the canvas taller than the box the user just dragged. */
.pict-section-form-diagram-edit > .pict-excalidraw-wrap,
.pict-section-form-diagram-edit > .pict-excalidraw-wrap > .pict-excalidraw-mount
{
	flex: 1 1 auto;
	min-height: 0;
	height: 100%;
}

.pict-section-form-diagram-edit .excalidraw
{
	width: 100%;
	height: 100%;
	min-height: 0;
}

.pict-section-form-diagram-toggle
{
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 2;
	padding: 3px 9px;
	font-size: 0.72rem;
	font-weight: 600;
	color: var(--theme-color-text-secondary, #5A4A3C);
	background: var(--theme-color-background-tertiary, #F4EEE2);
	border: 1px solid var(--theme-color-border-secondary, #D4C4A8);
	border-radius: 3px;
	cursor: pointer;
	user-select: none;
}

.pict-section-form-diagram-toggle:hover
{
	color: var(--theme-color-text-primary, #2A2520);
	background: var(--theme-color-background-primary, #FFFFFF);
	border-color: var(--theme-color-accent, #2E7D74);
}

.pict-section-form-diagram.mode-edit .pict-section-form-diagram-toggle::after { content: 'Done'; }
.pict-section-form-diagram.mode-view .pict-section-form-diagram-toggle::after { content: 'Edit'; }
`;

},{}],611:[function(require,module,exports){
/**
 * Pict-Provider-Input-Diagram.js
 *
 * A pict-section-form input provider that pairs Excalidraw (edit mode) with
 * an inline SVG (view mode). Boots in VIEW mode — the heavy Excalidraw bundle
 * isn't pulled until the host UI calls
 * `provider.setMode(pInputHash, 'edit')`.
 *
 * The stored value is an Excalidraw-exported SVG carrying the embedded scene
 * in its <metadata>. View mode writes that SVG verbatim into the slot. Edit
 * mode parses the embedded scene back out (via the wrapper's loadFromBlob)
 * and seeds Excalidraw with it.
 *
 * Descriptor shape:
 *
 *   {
 *     "Name": "Architecture",
 *     "Hash": "ArchDiagram",
 *     "DataType": "String",
 *     "PictForm": {
 *       "InputType": "Diagram",
 *       "Diagram": {
 *         "ThemeColors":           true,
 *         "Height":                "640px",
 *         "FormFactor":            "pointer",
 *         "EditorImplementation":  "react",
 *         "EditorOptions":         { ... }
 *       }
 *     }
 *   }
 *
 * Runtime API:
 *
 *   provider.setMode(inputHash, 'edit' | 'view', fCallback)
 *   provider.getMode(inputHash)
 *   provider.toggleMode(inputHash)
 *   provider.commit(inputHash, fCallback)
 */

const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libPictSectionExcalidraw     = require('pict-section-excalidraw');

// Form templates live in pict-section-form's default-template set, so no
// runtime template injection is needed here. CSS still needs registering.
const libCSS      = require('./Pict-Provider-Input-Diagram-CSS.js');
const libThemeify = require('./util/Themeify-SVG.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Input-Diagram',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	AutoSolveWithApp: false
};

/**
 * @typedef {Object} Instance
 * @property {string} mode - 'edit' or 'view'
 * @property {string} slotID - The HTML ID of the content slot for this input
 * @property {string} lastValue - The last known value (SVG string)
 * @property {Object} viewInstance - The editor view instance (if in edit mode)
 * @property {string} viewHash - The hash of the editor view (if in edit mode)
 * @property {Object} input - The input definition object
 */

class PictInputDiagram extends libPictSectionInputExtension
{
	/**
	 * Creates an instance of the PictInputExtensionProvider class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */ this.pict;
		/** @type {any}            */ this.log;

		// inputHash → { mode, slotID, lastValue (SVG string), viewInstance?, viewHash?, input }
		/** @type {Record<String, Instance>} */
		this._instances = {};

		// Register the scoped CSS.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Input-Diagram-CSS', libCSS, 500);
		}
	}

	// ----------------------------------------------------------------------------
	// Helpers
	// ----------------------------------------------------------------------------

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @returns {string} The HTML ID selector for the content display slot corresponding to the input.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @param {number} pRowIndex - The row index for tabular inputs.
	 * @returns {string} The HTML ID selector for the content display slot corresponding to the tabular input.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Resolve the value to use for display/editing, following this precedence:
	 * 1. The provided pValue (if a non-empty string)
	 * 2. The input's Content property (if a non-empty string)
	 * 3. The input's Default property (if a non-empty string)
	 * 4. An empty string if none of the above are valid
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {any} pValue - The value provided for the input.
	 * @returns {string} The resolved value to use for display/editing.
	 */
	_resolveValue(pInput, pValue)
	{
		if (typeof pValue === 'string' && pValue.length > 0) return pValue;
		if (pInput && pInput.Content && typeof pInput.Content === 'string') return pInput.Content;
		if (pInput && pInput.Default && typeof pInput.Default === 'string') return pInput.Default;
		return '';
	}

	/**
	 * @param {any} pValue - The value to check.
	 * @return {boolean} True if the value is a string that appears to contain an <svg> element, false otherwise.
	 */
	_isLikelySvg(pValue)
	{
		return (typeof pValue === 'string') && /<svg[\s>]/i.test(pValue);
	}

	/**
	 * @param {string} pSlotID - The HTML ID of the content slot to assign.
	 * @param {string} pHTML - The HTML string to assign to the slot.
	 * @returns {boolean} True if the assignment was successful, false otherwise.
	 */
	_assignSlotContent(pSlotID, pHTML)
	{
		if (this.pict && this.pict.ContentAssignment &&
			typeof this.pict.ContentAssignment.assignContent === 'function')
		{
			this.pict.ContentAssignment.assignContent(pSlotID, pHTML);
			return true;
		}
		return false;
	}

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input whose hidden value field should be updated.
	 * @param {string} pValue - The SVG string to set as the value of the hidden input field.
	 * @returns {boolean} True if the value was successfully written and a change event dispatched, false otherwise.
	 */
	_writeHiddenInputValue(pInputHTMLID, pValue)
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pInputHTMLID) : null;
		if (!tmpEl) return false;
		tmpEl.value = (pValue == null) ? '' : String(pValue);
		try { tmpEl.dispatchEvent(new Event('change', { bubbles: true })); }
		catch (pErr) { /* jsdom may lack Event */ }
		return true;
	}

	_resolveVendor()
	{
		if (typeof window === 'undefined') return null;
		return window.PictSectionExcalidrawVendor || null;
	}

	/**
	 * Wrap an SVG string in a thin <div> for the view-mode slot. If the value
	 * is empty or not an SVG, show an "(empty)" placeholder.
	 *
	 * @param {string} pValue - The SVG string to wrap for display.
	 * @returns {string} The HTML string to assign to the view slot.
	 */
	_buildViewHTML(pValue)
	{
		if (this._isLikelySvg(pValue))
		{
			return `<div class="pict-section-form-diagram-view">${pValue}</div>`;
		}
		return `<div class="pict-section-form-diagram-view is-empty">(empty diagram)</div>`;
	}

	/**
	 * Flag edit/view mode on the DISPLAY SLOT so the scoped CSS (sizing, the resize grip, the toggle
	 * chip pseudo) has something to key off.
	 *
	 * The slot is resolved FIRST and the RawHTMLID element is only a fallback. That order is
	 * load-bearing: a host template is free to put `id="{RawHTMLID}"` on the hidden <input> (it has
	 * to, if it wants the provider's value write-back to find it), and when it does,
	 * `getElementById(RawHTMLID)` returns that hidden input — so every mode class, and with it every
	 * sizing rule keyed off `.pict-section-form-diagram-edit`, lands on an invisible element and the
	 * editor silently falls back to the embed's own min-height. Our own default template omits that
	 * id, so this reordering is a no-op there.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {string} pMode - The mode to set ('edit' or 'view').
	 */
	_setSlotModeClass(pInput, pMode)
	{
		if (typeof document === 'undefined') return;
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpOuter = document.querySelector(this.getContentDisplayHTMLID(tmpRawHTMLID)) ||
			document.getElementById(tmpRawHTMLID);
		if (!tmpOuter || !tmpOuter.classList) return;
		tmpOuter.classList.remove('mode-edit', 'mode-view', 'pict-section-form-diagram-edit');
		if (pMode === 'edit')
		{
			tmpOuter.classList.add('mode-edit', 'pict-section-form-diagram-edit');
		}
		else
		{
			tmpOuter.classList.add('mode-view');
		}
	}

	// ----------------------------------------------------------------------------
	// Editor height
	// ----------------------------------------------------------------------------

	/**
	 * @param {Object} pInput - The input definition object.
	 * @returns {Element} The display slot element for this input, or null when it isn't in the DOM.
	 */
	_getSlotElement(pInput)
	{
		if ((typeof document === 'undefined') || !pInput || !pInput.Macro) return null;
		return document.querySelector(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID));
	}

	/**
	 * Coerce a configured height into a CSS length. Bare numbers (and numeric strings) are treated as
	 * pixels so a descriptor can say 640 or "640" as readily as "640px".
	 *
	 * @param {any} pValue - The configured height.
	 * @returns {string} A CSS length, or '' when the value isn't usable.
	 */
	_normalizeHeight(pValue)
	{
		if (typeof pValue === 'number')
		{
			return (isFinite(pValue) && pValue > 0) ? `${pValue}px` : '';
		}
		if (typeof pValue !== 'string') return '';
		let tmpValue = pValue.trim();
		if (tmpValue.length < 1) return '';
		if (/^[0-9]+(\.[0-9]+)?$/.test(tmpValue)) return `${tmpValue}px`;
		// Anything else is passed through as authored (px/rem/vh/calc()/…) — the browser ignores a
		// value it can't parse, which degrades to the stylesheet default rather than breaking layout.
		return tmpValue;
	}

	/**
	 * @param {Object} pInput - The input definition object.
	 * @returns {string} The localStorage key this input's user-dragged height is remembered under.
	 */
	_heightStorageKey(pInput)
	{
		return `pict-input-diagram:height:${(pInput && pInput.Hash) || ''}`;
	}

	/**
	 * @param {Object} pInput - The input definition object.
	 * @returns {string} The remembered height for this input, or '' if there isn't one.
	 */
	_readStoredHeight(pInput)
	{
		try
		{
			if ((typeof window === 'undefined') || !window.localStorage) return '';
			return this._normalizeHeight(window.localStorage.getItem(this._heightStorageKey(pInput)));
		}
		catch (pErr)
		{
			// Storage can throw outright (Safari private mode, blocked site data) — a forgotten height
			// is not worth a broken editor.
			return '';
		}
	}

	/**
	 * @param {Object} pInput - The input definition object.
	 * @param {string} pHeight - The height to remember.
	 * @returns {boolean} True if it was written.
	 */
	_writeStoredHeight(pInput, pHeight)
	{
		try
		{
			if ((typeof window === 'undefined') || !window.localStorage) return false;
			window.localStorage.setItem(this._heightStorageKey(pInput), pHeight);
			return true;
		}
		catch (pErr)
		{
			return false;
		}
	}

	/**
	 * Resolve the editor height for an input: a height the user dragged to wins over the descriptor's
	 * configured Height, which wins over the stylesheet default (signalled by '').
	 *
	 * @param {Object} pInput - The input definition object.
	 * @returns {string} A CSS length, or '' to leave the stylesheet in charge.
	 */
	_resolveEditorHeight(pInput)
	{
		let tmpStored = this._readStoredHeight(pInput);
		if (tmpStored) return tmpStored;
		let tmpDiagramOpts = (pInput.PictForm && pInput.PictForm.Diagram) || {};
		return this._normalizeHeight(tmpDiagramOpts.Height);
	}

	/**
	 * Push the resolved height onto the slot as `--pict-diagram-height`, which the scoped CSS reads.
	 * Any inline height left behind by an earlier drag is dropped first so the variable is what
	 * actually applies on a fresh mount.
	 *
	 * @param {Object} pInput - The input definition object.
	 */
	_applyEditorHeight(pInput)
	{
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || !tmpSlot.style) return;
		tmpSlot.style.removeProperty('height');
		let tmpHeight = this._resolveEditorHeight(pInput);
		if (tmpHeight)
		{
			tmpSlot.style.setProperty('--pict-diagram-height', tmpHeight);
		}
		else
		{
			tmpSlot.style.removeProperty('--pict-diagram-height');
		}
	}

	/**
	 * Strip the edit-mode sizing when dropping back to view. The resize grip writes an INLINE height
	 * onto the slot, and that would otherwise pin the static SVG view to whatever the canvas was
	 * dragged to.
	 *
	 * @param {Object} pInput - The input definition object.
	 */
	_clearEditorHeight(pInput)
	{
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || !tmpSlot.style) return;
		tmpSlot.style.removeProperty('height');
		tmpSlot.style.removeProperty('width');
		tmpSlot.style.removeProperty('--pict-diagram-height');
	}

	/**
	 * Remember whatever height the slot is currently sitting at. Only an INLINE height counts — that is
	 * what the native resize grip writes; a height coming from the stylesheet or the descriptor is not
	 * a user decision and must not be frozen into storage.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @returns {boolean} True if a height was remembered.
	 */
	_captureEditorHeight(pInput)
	{
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || !tmpSlot.style || !tmpSlot.style.height) return false;
		return this._writeStoredHeight(pInput, tmpSlot.style.height);
	}

	/**
	 * Watch the slot so a height the user drags to is remembered for next time. The grip is native CSS
	 * `resize` (no drag handling of our own), so a ResizeObserver is the only signal that it moved.
	 * Debounced — a drag fires continuously.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {Object} pInstance - The instance record to hang the observer off.
	 */
	_observeEditorResize(pInput, pInstance)
	{
		if (typeof ResizeObserver === 'undefined') return;
		let tmpSlot = this._getSlotElement(pInput);
		if (!tmpSlot || pInstance.resizeObserver) return;
		let tmpProvider = this;
		pInstance.resizeObserver = new ResizeObserver(() =>
		{
			if (pInstance.resizeTimer) clearTimeout(pInstance.resizeTimer);
			pInstance.resizeTimer = setTimeout(() =>
			{
				pInstance.resizeTimer = null;
				tmpProvider._captureEditorHeight(pInput);
			}, 300);
		});
		try { pInstance.resizeObserver.observe(tmpSlot); }
		catch (pErr) { pInstance.resizeObserver = null; }
	}

	/**
	 * @param {Object} pInstance - The instance record whose resize watcher should be torn down.
	 */
	_unobserveEditorResize(pInstance)
	{
		if (!pInstance) return;
		if (pInstance.resizeTimer)
		{
			clearTimeout(pInstance.resizeTimer);
			pInstance.resizeTimer = null;
		}
		if (pInstance.resizeObserver)
		{
			try { pInstance.resizeObserver.disconnect(); }
			catch (pErr) { /* already gone */ }
			pInstance.resizeObserver = null;
		}
	}

	// ----------------------------------------------------------------------------
	// View mode
	// ----------------------------------------------------------------------------

	_mountView(pView, pInput, pValue)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpValue     = this._resolveValue(pInput, pValue);

		this._assignSlotContent(tmpSlotID, this._buildViewHTML(tmpValue));
		this._setSlotModeClass(pInput, 'view');
		this._clearEditorHeight(pInput);

		let tmpInst = this._instances[pInput.Hash] || {};
		tmpInst.mode         = 'view';
		tmpInst.slotID       = tmpSlotID;
		tmpInst.lastValue    = tmpValue;
		tmpInst.input        = pInput;
		tmpInst.viewInstance = null;
		this._instances[pInput.Hash] = tmpInst;
	}

	// ----------------------------------------------------------------------------
	// Edit mode
	// ----------------------------------------------------------------------------

	_extractSceneFromSvg(pSVG, fCallback)
	{
		// Convert the SVG string into a Blob/File and pass through the wrapper's
		// loadFromBlob, which extracts the embedded scene from the metadata.
		if (!this._isLikelySvg(pSVG))
		{
			return fCallback(null, null);
		}

		let tmpVendor = this._resolveVendor();
		if (!tmpVendor || !tmpVendor.loadFromBlob)
		{
			if (this.log) this.log.warn('[Pict-Input-Diagram] vendor.loadFromBlob unavailable — falling back to empty scene');
			return fCallback(null, null);
		}

		try
		{
			// Browser-side construction of a Blob; pass null/null per the
			// vendor's signature (localAppState, localElements).
			let tmpBlob = new window.Blob([pSVG], { type: 'image/svg+xml' });
			let tmpPromise = tmpVendor.loadFromBlob(tmpBlob, null, null);
			Promise.resolve(tmpPromise).then(
				(pScene) => { fCallback(null, pScene || null); },
				(pErr)   => { fCallback(pErr, null); }
			);
		}
		catch (pErr)
		{
			fCallback(pErr, null);
		}
	}

	_buildEditorOptions(pInput, pValue, pInst)
	{
		let tmpDiagramOpts = (pInput.PictForm && pInput.PictForm.Diagram) || {};
		let tmpEditorOpts  = tmpDiagramOpts.EditorOptions || {};
		let tmpRawHTMLID   = pInput.Macro.RawHTMLID;

		// Per-input AppData stash for the scene (so re-renders don't lose it
		// when the editor unmounts).
		if (!this.pict.AppData._PictInputDiagram) this.pict.AppData._PictInputDiagram = {};
		if (!this.pict.AppData._PictInputDiagram[pInput.Hash])
		{
			this.pict.AppData._PictInputDiagram[pInput.Hash] = { Scene: null };
		}
		let tmpDrawingAddr = `AppData._PictInputDiagram.${pInput.Hash}.Scene`;

		// Pin a Provider to register Excalidraw's resources (icons, etc.) once
		// on the host pict — done by Pict-Section-Excalidraw's own provider.
		let tmpOptions = Object.assign({}, tmpEditorOpts,
		{
			ViewIdentifier:       `Pict-Input-Diagram-Editor-${pInput.Hash}`,
			TargetElementAddress: this.getContentDisplayHTMLID(tmpRawHTMLID),
			DrawingDataAddress:   tmpDrawingAddr,
			EditorImplementation: tmpDiagramOpts.EditorImplementation || 'react',
			// Excalidraw picks its UI density from the CONTAINER's box, so an embedded canvas — which is
			// short by definition — reads as a phone and buries the shape properties behind a popover.
			// 'pointer' asks the embed to classify by input device instead: desktop chrome for a mouse,
			// Excalidraw's own detection on a touch screen. See pict-section-excalidraw's FormFactor.
			FormFactor:           tmpDiagramOpts.FormFactor || 'pointer'
		});

		return tmpOptions;
	}

	_mountEdit(pView, pInput, pValue, fCallback)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpValue     = this._resolveValue(pInput, pValue);
		let tmpInst      = this._instances[pInput.Hash] || {};
		tmpInst.input    = pInput;
		let tmpDiagramOpts = (pInput.PictForm && pInput.PictForm.Diagram) || {};
		let tmpThemeColors = (tmpDiagramOpts.ThemeColors !== false);

		// Clear view-mode content.
		this._assignSlotContent(tmpSlotID, '');

		this._extractSceneFromSvg(tmpValue, (pExtractErr, pScene) =>
		{
			let tmpEditorOpts  = this._buildEditorOptions(pInput, tmpValue, tmpInst);
			let tmpViewHash    = tmpEditorOpts.ViewIdentifier;
			let tmpProvider    = this;

			// Inject the parsed scene into the per-input AppData stash so the
			// editor's _resolveInitialData picks it up.
			if (pScene && this.pict.AppData._PictInputDiagram &&
				this.pict.AppData._PictInputDiagram[pInput.Hash])
			{
				this.pict.AppData._PictInputDiagram[pInput.Hash].Scene =
				{
					elements: pScene.elements || [],
					appState: pScene.appState || {},
					files:    pScene.files    || {}
				};
			}

			// OnChange handler — debounced inside the editor view itself; we
			// just trigger an SVG export and stamp into the form-data input.
			tmpEditorOpts.OnChange = (pEditorView, pSceneSnap) =>
			{
				try
				{
					let tmpExportPromise = pEditorView.exportSvg({ exportEmbedScene: true, exportBackground: false });
					Promise.resolve(tmpExportPromise).then(
						(pSvgEl) =>
						{
							let tmpSvgStr = (pSvgEl && typeof pSvgEl.outerHTML === 'string') ? pSvgEl.outerHTML :
								(typeof pSvgEl === 'string') ? pSvgEl : null;
							if (!tmpSvgStr) return;

							if (tmpThemeColors)
							{
								tmpSvgStr = libThemeify.themeifySVG(tmpSvgStr);
							}

							tmpProvider._writeHiddenInputValue(tmpRawHTMLID, tmpSvgStr);
							let tmpLatest = tmpProvider._instances[pInput.Hash];
							if (tmpLatest) tmpLatest.lastValue = tmpSvgStr;
						},
						(pExpErr) =>
						{
							if (tmpProvider.log)
							{
								tmpProvider.log.warn('[Pict-Input-Diagram] exportSvg failed in OnChange',
									{ error: pExpErr.message, inputHash: pInput.Hash });
							}
						}
					);
				}
				catch (pErr)
				{
					if (tmpProvider.log)
					{
						tmpProvider.log.warn('[Pict-Input-Diagram] OnChange handler threw',
							{ error: pErr.message, inputHash: pInput.Hash });
					}
				}
			};

			this.pict.addView(tmpViewHash, tmpEditorOpts, libPictSectionExcalidraw);
			let tmpEditorView = this.pict.views[tmpViewHash];
			if (!tmpEditorView)
			{
				let tmpErr = new Error('Failed to instantiate Diagram editor view ' + tmpViewHash);
				if (this.log) this.log.error('[Pict-Input-Diagram] addView returned nothing', { viewHash: tmpViewHash });
				if (typeof fCallback === 'function') fCallback(tmpErr);
				return;
			}

			this._setSlotModeClass(pInput, 'edit');
			this._applyEditorHeight(pInput);
			this._observeEditorResize(pInput, tmpInst);

			tmpInst.mode         = 'edit';
			tmpInst.slotID       = tmpSlotID;
			tmpInst.lastValue    = tmpValue;
			tmpInst.viewInstance = tmpEditorView;
			tmpInst.viewHash     = tmpViewHash;
			tmpInst.themeColors  = tmpThemeColors;
			this._instances[pInput.Hash] = tmpInst;

			try
			{
				let tmpResult = tmpEditorView.render();
				if (tmpResult && typeof tmpResult.then === 'function')
				{
					tmpResult.then(
						() => { if (typeof fCallback === 'function') fCallback(null); },
						(pRenderErr) => { if (typeof fCallback === 'function') fCallback(pRenderErr); }
					);
				}
				else
				{
					if (typeof fCallback === 'function') fCallback(null);
				}
			}
			catch (pErr)
			{
				if (this.log) this.log.error('[Pict-Input-Diagram] editor.render threw', { error: pErr.message });
				if (typeof fCallback === 'function') fCallback(pErr);
			}
		});
	}

	_destroyEdit(pInput)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst) return;
		// Capture BEFORE teardown: ResizeObserver is frame-driven and never fires in a backgrounded or
		// headless context, so closing the editor is the one commit point we can rely on.
		this._captureEditorHeight(pInput);
		// Ahead of the viewInstance guard — a slot can be watched without a live editor view (a mount
		// that failed part way), and a leaked ResizeObserver would keep the detached slot alive.
		this._unobserveEditorResize(tmpInst);
		if (!tmpInst.viewInstance) return;

		let tmpView = tmpInst.viewInstance;
		try
		{
			if (typeof tmpView.destroy === 'function') tmpView.destroy();
		}
		catch (pErr)
		{
			if (this.log) this.log.warn('[Pict-Input-Diagram] editor.destroy threw', { error: pErr.message });
		}

		if (this.pict.AppData._PictInputDiagram &&
			this.pict.AppData._PictInputDiagram[pInput.Hash])
		{
			delete this.pict.AppData._PictInputDiagram[pInput.Hash];
		}

		if (tmpInst.viewHash && this.pict.views && this.pict.views[tmpInst.viewHash])
		{
			try { delete this.pict.views[tmpInst.viewHash]; }
			catch (pErr) { /* not all envs allow delete */ }
		}

		tmpInst.viewInstance = null;
		tmpInst.viewHash     = null;
	}

	// ----------------------------------------------------------------------------
	// Public runtime API
	// ----------------------------------------------------------------------------

	getMode(pInputHash)
	{
		let tmpInst = this._instances[pInputHash];
		return tmpInst ? tmpInst.mode : null;
	}

	setMode(pInputHash, pMode, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			let tmpErr = new Error('Cannot setMode — input is not mounted: ' + pInputHash);
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		if (pMode !== 'edit' && pMode !== 'view')
		{
			let tmpErr = new Error('setMode: unknown mode "' + pMode + '" (use "edit" or "view")');
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		if (tmpInst.mode === pMode)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}

		if (pMode === 'edit')
		{
			this._mountEdit(null, tmpInst.input, tmpInst.lastValue, fCallback);
			return;
		}

		this._destroyEdit(tmpInst.input);
		this._mountView(null, tmpInst.input, tmpInst.lastValue);
		if (typeof fCallback === 'function') fCallback(null);
	}

	toggleMode(pInputHash, fCallback)
	{
		let tmpMode = this.getMode(pInputHash);
		let tmpNext = (tmpMode === 'edit') ? 'view' : 'edit';
		this.setMode(pInputHash, tmpNext, fCallback);
	}

	commit(pInputHash, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst || tmpInst.mode !== 'edit' || !tmpInst.viewInstance)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}
		// Force a synchronous export so the form value reflects the latest
		// scene even if the throttled OnChange hasn't fired yet.
		let tmpThemeColors = tmpInst.themeColors !== false;
		let tmpProvider    = this;
		let tmpRawHTMLID   = tmpInst.input.Macro.RawHTMLID;
		try
		{
			let tmpExportPromise = tmpInst.viewInstance.exportSvg({ exportEmbedScene: true, exportBackground: false });
			Promise.resolve(tmpExportPromise).then(
				(pSvgEl) =>
				{
					let tmpSvgStr = (pSvgEl && typeof pSvgEl.outerHTML === 'string') ? pSvgEl.outerHTML : null;
					if (tmpSvgStr)
					{
						if (tmpThemeColors) tmpSvgStr = libThemeify.themeifySVG(tmpSvgStr);
						tmpProvider._writeHiddenInputValue(tmpRawHTMLID, tmpSvgStr);
						tmpInst.lastValue = tmpSvgStr;
					}
					if (typeof fCallback === 'function') fCallback(null);
				},
				(pErr) =>
				{
					if (typeof fCallback === 'function') fCallback(pErr);
				}
			);
		}
		catch (pErr)
		{
			if (typeof fCallback === 'function') fCallback(pErr);
		}
	}

	// ----------------------------------------------------------------------------
	// Lifecycle hooks
	// ----------------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._mountView(pView, pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 *
	 * @return {boolean}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		let tmpErr = new Error('Diagram InputType is not supported inside Tabular rows in Phase 1.');
		if (this.log) this.log.warn('[Pict-Input-Diagram] tabular not supported', { inputHash: pInput && pInput.Hash });
		throw tmpErr;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst)
		{
			this._mountView(pView, pInput, pValue);
		}
		else if (tmpInst.mode === 'view')
		{
			this._mountView(pView, pInput, pValue);
		}
		else
		{
			// Edit mode: hot-replace the editor's scene.
			tmpInst.lastValue = (typeof pValue === 'string') ? pValue : tmpInst.lastValue;
			this._extractSceneFromSvg(tmpInst.lastValue, (pErr, pScene) =>
			{
				if (pErr || !pScene) return;
				if (tmpInst.viewInstance && typeof tmpInst.viewInstance.setScene === 'function')
				{
					try { tmpInst.viewInstance.setScene(pScene); }
					catch (pSetErr)
					{
						if (this.log) this.log.warn('[Pict-Input-Diagram] setScene threw after marshal',
							{ error: pSetErr.message });
					}
				}
			});
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = PictInputDiagram;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../Pict-Provider-InputExtension.js":599,"./Pict-Provider-Input-Diagram-CSS.js":610,"./util/Themeify-SVG.js":627,"pict-section-excalidraw":581}],612:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class for Entity Bundle Requests.
 *
 * When an input is flagged as an EntityBundleRequest entity, it will go pull a
 * sequential list of records on data selection.
 *
 * Paired with the AutofillTriggerGroup, this allows other values to be filled
 * when a record is selected and fetched.

Providers: ["Pict-Input-EntityBundleRequest", "Pict-Input-TriggerGroup"],
		EntitiesBundle: [
		{
			"Entity": "Author",
			"Filter": "FBV~IDAuthor~EQ~{~D:Record.Value~}",
			"Destination": "AppData.CurrentAuthor",
			// This marshals a single record
			"SingleRecord": true
		},
		{
			"Entity": "BookAuthorJoin",
			"Filter": "FBV~IDAuthor~EQ~{~D:Appdata.CurrentAuthor.IDAuthor~}",
			"Destination": "AppData.BookAuthorJoins"
		},
		{
			"Entity": "Book",
			"Filter": "FBL~IDBook~LK~{PJU~:,^IDBook^Appdata.BookAuthorJoins~}",
			"Destination": "AppData.BookAuthorJoins"
		}
	],
	EntityBundleTriggerGroup: "BookTriggerGroup"

 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	gatherEntitySet(fCallback, pEntityInformation, pView, pInput, pValue)
	{
		// First sanity check the pEntityInformation
		if (!('Entity' in pEntityInformation) || (typeof(pEntityInformation.Entity) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain an Entity string.`);
			return fCallback();
		}
		if (!('Filter' in pEntityInformation) || (typeof(pEntityInformation.Filter) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Filter string.`);
			return fCallback();
		}
		if (!('Destination' in pEntityInformation) || (typeof(pEntityInformation.Destination) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Destination string.`);
			return fCallback();
		}

		const tmpFilterTemplateRecord = { Value:pValue, Input:pInput, View:pView };
		let tmpRecordStartCursor = null;
		let tmpRecordCount = null;
		if (pEntityInformation.RecordCount)
		{
			tmpRecordStartCursor = pEntityInformation.RecordStartCursor != null ? pEntityInformation.RecordStartCursor : 0;
			tmpRecordCount = pEntityInformation.RecordCount != null ? pEntityInformation.RecordCount : null;
		}
		// Parse the filter template
		const tmpFilterString = this.pict.parseTemplate(pEntityInformation.Filter, tmpFilterTemplateRecord);
		if (tmpFilterString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity Filter did not return a string for FilterBy`)
		}

		// Now get the records
		const callback = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting entity set for [${pEntityInformation.Entity}] with filter [${tmpFilterString}]: ${pError}`, pError);
				return fCallback(pError, '');
			}

			this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]`);

			// Now assign it back to the destination; because this is not view specific it doesn't use the manifests from them (to deal with scope overlap with subgrids).
			if (pEntityInformation.SingleRecord)
			{
				if (pRecordSet.length > 1)
				{
					this.log.warn(`EntityBundleRequest found more than one record for ${pEntityInformation.Entity} filtered to [${tmpFilterString}] but SingleRecord is true; setting the first record.`);
				}
				if (pRecordSet.length < 1)
				{
					this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, false);
				}
				this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, pRecordSet[0]);
			}
			else
			{
				this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, pRecordSet);
			}

			return fCallback();
		};
		if (tmpRecordCount)
		{
			this.pict.EntityProvider.getEntitySetPage(pEntityInformation.Entity, tmpFilterString, tmpRecordStartCursor, tmpRecordCount, callback);
		}
		else
		{
			this.pict.EntityProvider.getEntitySet(pEntityInformation.Entity, tmpFilterString, callback);
		}
	}

	gatherCustomDataSet(fCallback, pCustomRequestInformation, pView, pInput, pValue)
	{
		// First sanity check the pCustomRequestInformation
		if (!('URL' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URL) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the stanza did not contain a URL string.`);
			return fCallback();
		}

		const tmpURLTemplateRecord = { Value:pValue, Input:pInput, View:pView };
		// Parse the filter template
		const tmpURLTemplateString = this.pict.parseTemplate(pCustomRequestInformation.URL, tmpURLTemplateRecord);
		if (tmpURLTemplateString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the entity Filter did not return a string for FilterBy`)
		}

		let tmpURLPrefix = '';
		// This will only be true if the "Host" is set.
		const tmpCustomURIHost = pCustomRequestInformation.Host ? pCustomRequestInformation.Host : false;
		// If "Host" is set, protocol and port are optional.
		const tmpCustomURIProtocol = pCustomRequestInformation.Protocol ? pCustomRequestInformation.Protocol : 'https';
		const tmpCustomURIPort = pCustomRequestInformation.Port ? pCustomRequestInformation.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.pict.EntityProvider.options.urlPrefix;
		}

		// Now get the records
		const callback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting data set for [${pCustomRequestInformation.Entity}] with filter [${tmpURLTemplateString}]: ${pError}`, pError);
				return fCallback(pError, '');
			}

			this.log.trace(`EntityBundleRequest completed request for ${pCustomRequestInformation.Entity} filtered to [${tmpURLTemplateString}]`);

			// Since this is a templated endpoint it can be used for logging etc.
			if (pCustomRequestInformation.Destination)
			{
				this.pict.manifest.setValueByHash(this.pict, pCustomRequestInformation.Destination, pData);
			}

			return fCallback();
		};

		let tmpOptions = (
			{
				url: `${tmpURLPrefix}${tmpURLTemplateString}`
			});
		tmpOptions = this.pict.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.pict.EntityProvider.restClient.getJSON(tmpOptions, callback);
	}

	/**
	 * TODO: I added a proise return here to know when this data load is done for the dashboard usecase. Could use a revisit.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} [pTransactionGUID] - (optional) The transaction GUID for the event dispatch.
	 *
	 * @return {Promise<Error?>} - Returns a promise that resolves when the data has been gathered.
	 */
	async gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Gather data from the server
		// These have to date not been asyncronous.  Now they will be...
		if ((typeof(pInput) !== 'object') || !('PictForm' in pInput) || !('EntitiesBundle' in pInput.PictForm) || !Array.isArray(pInput.PictForm.EntitiesBundle))
		{
			this.log.warn(`Input at ${pHTMLSelector} is set as an EntityBundleRequest input but no array of entity requests was found`);
			return null;
		}

		const tmpLoadGUID = `BundleLoad-${this.pict.getUUID()}`;
		if (pTransactionGUID)
		{
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpLoadGUID);
		}
		let tmpInput = pInput;
		let tmpValue = pValue;
		let tmpAnticipate = this.fable.newAnticipate();

		if (tmpInput.PictForm.EntitiesBundle.length > 0 && tmpInput.PictForm.EntitiesBundle[0].PictMode)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.pict.EntityProvider.gatherDataFromServer(tmpInput.PictForm.EntitiesBundle, (pError) =>
				{
					// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
					setTimeout(() => fNext(pError), 0);
				});
			});
		}
		else
		{
			const tmpStateStack = [];
			/** @type {Record<string, any>} */
			let tmpState = { Value: tmpValue, Input: tmpInput, View: pView };
			for (let i = 0; i < tmpInput.PictForm.EntitiesBundle.length; i++)
			{
				let tmpEntityBundleEntry = tmpInput.PictForm.EntitiesBundle[i];
				tmpAnticipate.anticipate(
					(fNext) =>
					{
						try
						{
							switch (tmpEntityBundleEntry.Type)
							{
								case 'Custom':
									return this.gatherCustomDataSet(fNext, tmpEntityBundleEntry, pView, tmpInput, tmpValue);
								case 'SetStateAddress':
									tmpStateStack.push(tmpState);
									tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
									if (typeof tmpState === 'undefined')
									{
										tmpState = {};
										this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
									}
									break;
								case 'PopState':
									if (tmpStateStack.length > 0)
									{
										tmpState = tmpStateStack.pop();
									}
									else
									{
										this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
									}
									break;
								case 'MapJoin':
									this.pict.EntityProvider.mapJoin(tmpEntityBundleEntry, this.pict.EntityProvider.prepareState(tmpState, tmpEntityBundleEntry));
									break;
								case 'ProjectDataset':
									this.pict.EntityProvider.projectDataset(tmpEntityBundleEntry, this.pict.EntityProvider.prepareState(tmpState, tmpEntityBundleEntry));
									break;
								// This is the default case, for a meadow entity set or single entity
								case 'MeadowEntity':
								default:
									return this.gatherEntitySet(fNext, tmpEntityBundleEntry, pView, tmpInput, tmpValue);
							}
						}
						catch (pError)
						{
							this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, pError);
						}
						return fNext();
					});
			}
			// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
			tmpAnticipate.anticipate((fNext) => setTimeout(fNext, 0));
		}

		tmpAnticipate.anticipate(
			(fNext) =>
			{
				if (tmpInput.PictForm.EntityBundleTriggerGroup && this.pict.views.PictFormMetacontroller)
				{
					const tmpGroupConfig = this.getTriggerGroupConfigurationArray(tmpInput, tmpInput.PictForm.EntityBundleTriggerGroup)[0];
					if (tmpGroupConfig && Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `EntityBundleTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} pre-trigger`);
					}
					let tmpTransactionGUID;
					if (tmpGroupConfig && Array.isArray(tmpGroupConfig.PostSolvers))
					{
						tmpTransactionGUID = pTransactionGUID || this.pict.getUUID();
						if (tmpTransactionGUID !== pTransactionGUID)
						{
							this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
						}
						pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
						{
							if (Array.isArray(tmpGroupConfig.PostSolvers))
							{
								this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `EntityBundleTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} post-trigger`);
								const tmpMarshalScope = tmpGroupConfig.MarshalOnComplete;
								if (tmpMarshalScope === true)
								{
									this.pict.views.PictFormMetacontroller.marshalToView();
								}
								else if (tmpMarshalScope)
								{
									this.pict.views.PictFormMetacontroller.marshalSectionToView(tmpMarshalScope.Section);
									this.pict.views.PictFormMetacontroller.marshalInputToView(tmpMarshalScope.Input);
								}
							}
						});
					}
					// Trigger the autofill global event
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${tmpInput.PictForm.EntityBundleTriggerGroup}:BundleLoad:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`, pTransactionGUID);
					if (tmpTransactionGUID && tmpTransactionGUID !== pTransactionGUID)
					{
						pView.finalizeTransaction(tmpTransactionGUID);
					}
				}
				if (tmpInput.PictForm.EntityBundleTriggerMetacontrollerSolve && this.pict.views.PictFormMetacontroller)
				{
					// Trigger the solve global event
					this.pict.views.PictFormMetacontroller.solve();
				}
				if (tmpInput.PictForm.EntityBundleTriggerMetacontrollerRender && this.pict.views.PictFormMetacontroller)
				{
					// Trigger the render
					this.pict.views.PictFormMetacontroller.render();
				}
				fNext();
			});

		return new Promise((pResolve, pReject) =>
		{
			// Now fire the "autofilldata" event for the groups.
			tmpAnticipate.wait(
				(pError) =>
				{
					//FIXME: should we be ignoring this error? rejecting here is unsafe since the result isn't guaranteed to be handled, so will crash stuff currently
					if (pError)
					{
						this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, pError);
					}
					//TODO: close the async operation if we have a transaction GUID
					if (pTransactionGUID)
					{
						pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpLoadGUID);
					}

					return pResolve(pError);
				});
		});
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 * @return {Array<Record<string, any>>} - An array of trigger group configurations.
	 */
	getTriggerGroupConfigurationArray(pInput, pTriggerGroupHash)
	{
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups)
		{
			return [];
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		if (pTriggerGroupHash == null)
		{
			return tmpAutoFillTriggerGroups;
		}
		return tmpAutoFillTriggerGroups.filter((pGroup) => pGroup.TriggerGroupHash === pTriggerGroupHash);
	}


	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Try to get the input element
		if (pInput.PictForm && (pValue || pInput.PictForm.EntityBundleTriggerWithoutValue) && pInput.PictForm.EntityBundleTriggerOnInitialize)
		{
			// This is a request on initial load
			this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		// This is in case we need to do a request on initial load!
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.log.error(`EntityBundleRequest for input [${pInput.Hash}] Tabular support is intentionally not supported.`);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.PictForm && (pValue || pInput.PictForm.EntityBundleTriggerWithoutValue) && pInput.PictForm.EntityBundleTriggerOnDataChange !== false)
		{
			this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		const [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup' || !tmpGroupHash || pInput.PictForm.TriggerGroupHash !== tmpGroupHash)
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],613:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * FacetFilter input provider.
 *
 * Keeps a set of inputs that choose from one shared join list (their `Facet` ListFilterRules name the same
 * `JoinListAddress`) mutually consistent when one of them changes.  In a tabular group the set is the
 * facet inputs in the changed row only; outside a table it is the facet inputs in the same view.
 *
 * On a change it runs, before the form solves:
 *   1. ClearInvalid (default true): walking the siblings in column order, a sibling whose value no longer
 *      appears in any join record agreeing with the changed value (and the siblings already kept) is cleared.
 *   2. AutoFillSingle (default true): an empty sibling left with exactly one allowed value takes it, repeated
 *      until nothing changes.  The changed input itself is never filled, so clearing it sticks.
 *   3. CarryFields ({ "<row address>": "<join record address>" }): on a sibling that holds a value, the join
 *      record its facet set now identifies (exactly one agreeing record) is copied into the row; with no value,
 *      or no single record, those row fields are cleared.
 *
 * It only acts on a user change, never on load or marshal, so a saved value -- carried fields included -- is
 * never rewritten by opening a document or by the join list changing later.  Narrowing the offered options
 * is the `Facet` rule's job in ListDistilling.filterList.
 *
 *   ListFilterRules: [ { FilterType: "Facet", JoinListAddress: "AppData.Graph", JoinListAddressGlobal: true, JoinListValueAddress: "Colour" } ],
 *   Providers: [ "Pict-Input-FacetFilter" ]
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class FacetFilterInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		// Writing a sibling runs that sibling's change providers (this one included); only the user's change reconciles.
		this.reconciling = false;
	}

	/**
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput
	 * @param {number|undefined} pRowIndex - undefined outside a table
	 * @param {any} pValue
	 */
	setFacetValue(pView, pInput, pRowIndex, pValue)
	{
		if ((typeof(pRowIndex) === 'number') || ((typeof(pRowIndex) === 'string') && (pRowIndex !== '')))
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, pValue);
			return;
		}
		pView.setDataByInput(pInput, pValue);
	}

	/**
	 * Reconciles the changed input's facet siblings; see the class description.
	 *
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput - the input the user changed
	 * @param {number} [pRowIndex]
	 * @return {Array<string>} hashes of the siblings whose value was changed
	 */
	reconcileFacets(pView, pInput, pRowIndex)
	{
		if (this.reconciling)
		{
			return [];
		}
		this.reconciling = true;
		try
		{
			return this.reconcileFacetSiblings(pView, pInput, pRowIndex);
		}
		finally
		{
			this.reconciling = false;
		}
	}

	/**
	 * @param {Object} pView
	 * @param {Record<string, any>} pInput - the input the user changed
	 * @param {number} [pRowIndex]
	 * @return {Array<string>} hashes of the siblings whose value was changed
	 */
	reconcileFacetSiblings(pView, pInput, pRowIndex)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		const tmpSiblings = tmpDistilling.getFacetSiblings(pView, pInput, pRowIndex);
		const tmpChanged = [];
		if (tmpSiblings.length < 2)
		{
			return tmpChanged;
		}

		const tmpKept = tmpSiblings.map((pSibling) => (pSibling.Input === pInput));
		for (let i = 0; i < tmpSiblings.length; i++)
		{
			const tmpSibling = tmpSiblings[i];
			if (tmpKept[i] || tmpDistilling.isEmptyFacetValue(tmpSibling.Value))
			{
				tmpKept[i] = true;
				continue;
			}
			const tmpConstraining = tmpSiblings.map((pOther, pIndex) => ({ Input: pOther.Input, Rule: pOther.Rule, Value: tmpKept[pIndex] ? pOther.Value : '' }));
			const tmpAllowed = tmpDistilling.getFacetAllowedValues(pView, tmpSibling.Input, tmpSibling.Rule, pRowIndex, tmpConstraining);
			if (tmpAllowed.has(String(tmpSibling.Value)) || (tmpSibling.Rule.ClearInvalid === false))
			{
				tmpKept[i] = true;
				continue;
			}
			tmpSibling.Value = '';
			this.setFacetValue(pView, tmpSibling.Input, pRowIndex, '');
			tmpChanged.push(tmpSibling.Input.Hash);
			tmpKept[i] = true;
		}

		for (let tmpPass = 0; tmpPass < tmpSiblings.length; tmpPass++)
		{
			let tmpFilled = false;
			for (const tmpSibling of tmpSiblings)
			{
				if ((tmpSibling.Input === pInput) || !tmpDistilling.isEmptyFacetValue(tmpSibling.Value) || (tmpSibling.Rule.AutoFillSingle === false))
				{
					continue;
				}
				const tmpAllowed = tmpDistilling.getFacetAllowedValues(pView, tmpSibling.Input, tmpSibling.Rule, pRowIndex, tmpSiblings);
				if (tmpAllowed.size === 1)
				{
					tmpSibling.Value = tmpAllowed.values().next().value;
					this.setFacetValue(pView, tmpSibling.Input, pRowIndex, tmpSibling.Value);
					tmpChanged.push(tmpSibling.Input.Hash);
					tmpFilled = true;
				}
			}
			if (!tmpFilled)
			{
				break;
			}
		}

		for (const tmpSibling of tmpSiblings)
		{
			if (tmpSibling.Rule.CarryFields && (typeof(tmpSibling.Rule.CarryFields) === 'object'))
			{
				this.carryFields(pView, tmpSibling, pRowIndex, tmpSiblings);
			}
		}
		return tmpChanged;
	}

	/**
	 * Copies a sibling's CarryFields from the one join record its facet set identifies, or clears them.
	 *
	 * @param {Object} pView
	 * @param {{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }} pSibling
	 * @param {number|undefined} pRowIndex
	 * @param {Array<{ Input: Record<string, any>, Rule: Record<string, any>, Value: any }>} pSiblings
	 */
	carryFields(pView, pSibling, pRowIndex, pSiblings)
	{
		const tmpDistilling = this.pict.providers.ListDistilling;
		let tmpRecord = null;
		if (!tmpDistilling.isEmptyFacetValue(pSibling.Value))
		{
			const tmpMatches = tmpDistilling.getFacetMatchingRecords(pView, pSibling.Input, pSibling.Rule, pRowIndex, pSiblings)
				.filter((pJoinRecord) => String(this.pict.manifest.getValueAtAddress(pJoinRecord, pSibling.Rule.JoinListValueAddress)) === String(pSibling.Value));
			tmpRecord = (tmpMatches.length === 1) ? tmpMatches[0] : null;
		}
		const tmpIsTabular = (typeof(pRowIndex) === 'number') || ((typeof(pRowIndex) === 'string') && (pRowIndex !== ''));
		const tmpTarget = tmpIsTabular ? pView.getTabularRecordData(pSibling.Input.PictForm.GroupIndex, pRowIndex) : pView.getMarshalDestinationObject();
		if (!tmpTarget)
		{
			return;
		}
		for (const tmpRowAddress of Object.keys(pSibling.Rule.CarryFields))
		{
			const tmpValue = tmpRecord ? this.pict.manifest.getValueAtAddress(tmpRecord, pSibling.Rule.CarryFields[tmpRowAddress]) : '';
			this.pict.manifest.setValueAtAddress(tmpTarget, tmpRowAddress, (tmpValue === undefined) ? '' : tmpValue);
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any}
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.reconcileFacets(pView, pInput);
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.reconcileFacets(pView, pInput, pRowIndex);
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = FacetFilterInputHandler;

module.exports.default_configuration = (
{
	"ProviderIdentifier": "Pict-Input-FacetFilter",
	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

},{"../Pict-Provider-InputExtension.js":599}],614:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		return tmpContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],615:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class LinkInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { Math: any } & { DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.setAttribute(this.getInputHTMLID(pInput.Macro.RawHTMLID), 'href', pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.setAttribute(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), 'href', pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = LinkInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],616:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (tmpContent)
		{
			tmpContent = libMarked.parse(tmpContent);
		}
		return tmpContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599,"marked":585}],617:[function(require,module,exports){
/**
 * Pict-Provider-Input-ObjectEditor.js
 *
 * A pict-section-form input provider that embeds pict-section-objecteditor as
 * an interactive JSON-object editor. In edit mode the tree is editable
 * (Editable:true); in view / read-only mode the same tree renders read-only
 * (Editable:false). Unlike the Diagram input, the object editor is a light,
 * pure-JS view, so there is no lazy heavy-bundle split — both modes mount the
 * same view and only the Editable flag differs.
 *
 * The object the editor mutates lives in a per-input AppData stash at
 *
 *   AppData._PictInputObjectEditor.<InputHash>.Data
 *
 * The object editor mutates that object in place. On a data request (the form
 * gathering its values for a save) the stash is serialized to JSON and written
 * into the input's hidden field, so the form marshals it like any other value.
 *
 * Incoming values may be a live object OR a JSON string — both are accepted.
 *
 * Descriptor shape:
 *
 *   {
 *     "Name": "Custom Properties",
 *     "Hash": "CustomProperties",
 *     "DataType": "Object",
 *     "PictForm": {
 *       "InputType": "ObjectEditor",
 *       "ReadOnly": false,                 // true renders a read-only tree
 *       "ObjectEditor": {                  // all optional
 *         "Editable":           true,      // explicit override of ReadOnly
 *         "InitialExpandDepth": 2
 *       }
 *     }
 *   }
 *
 * Runtime API (parity with the other section inputs):
 *
 *   provider.setMode(inputHash, 'edit' | 'view', fCallback)
 *   provider.getMode(inputHash)
 *   provider.toggleMode(inputHash)
 *   provider.commit(inputHash, fCallback)
 */

const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libPictSectionObjectEditor   = require('pict-section-objecteditor');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Input-ObjectEditor',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	AutoSolveWithApp: false
};

/**
 * @typedef {Object} Instance
 * @property {string} mode - 'edit' or 'view'
 * @property {string} slotID - The HTML ID selector of the content slot for this input
 * @property {Object} viewInstance - The object editor view instance
 * @property {string} viewHash - The hash of the object editor view
 * @property {Object} input - The input definition object
 */

class PictInputObjectEditor extends libPictSectionInputExtension
{
	/**
	 * Creates an instance of the PictInputObjectEditor class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */ this.pict;
		/** @type {any}            */ this.log;

		// inputHash -> Instance
		/** @type {Record<String, Instance>} */
		this._instances = {};
	}

	// ----------------------------------------------------------------------------
	// Helpers
	// ----------------------------------------------------------------------------

	/**
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @returns {string} The HTML ID selector for the content display slot.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * The AppData address where this input's editable object is stashed.
	 *
	 * @param {string} pInputHash - The input Hash.
	 * @returns {string} The dotted AppData address the object editor binds to.
	 */
	getObjectDataAddress(pInputHash)
	{
		return `AppData._PictInputObjectEditor.${pInputHash}.Data`;
	}

	/**
	 * Resolve the incoming value to a plain object, accepting either a live
	 * object or a JSON string. Falls back to the input's Content / Default /
	 * an empty object.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {any} pValue - The value provided for the input.
	 * @returns {Object} The resolved object to edit/display.
	 */
	_resolveValue(pInput, pValue)
	{
		let tmpCandidate = pValue;
		if (tmpCandidate === null || typeof tmpCandidate === 'undefined' || tmpCandidate === '')
		{
			if (pInput && typeof pInput.Content !== 'undefined' && pInput.Content !== null && pInput.Content !== '')
			{
				tmpCandidate = pInput.Content;
			}
			else if (pInput && typeof pInput.Default !== 'undefined' && pInput.Default !== null && pInput.Default !== '')
			{
				tmpCandidate = pInput.Default;
			}
		}

		if (typeof tmpCandidate === 'string')
		{
			let tmpTrimmed = tmpCandidate.trim();
			if (tmpTrimmed.length < 1)
			{
				return {};
			}
			try
			{
				let tmpParsed = JSON.parse(tmpTrimmed);
				return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : { Value: tmpParsed };
			}
			catch (pErr)
			{
				if (this.log)
				{
					this.log.warn('[Pict-Input-ObjectEditor] value was a non-JSON string; wrapping as { Value }',
						{ error: pErr.message });
				}
				return { Value: tmpCandidate };
			}
		}

		if (tmpCandidate && typeof tmpCandidate === 'object')
		{
			return tmpCandidate;
		}

		return {};
	}

	/**
	 * Determine whether the editor should be editable for this input. An
	 * explicit PictForm.ObjectEditor.Editable boolean wins; otherwise the tree
	 * is editable unless PictForm.ReadOnly is true.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @returns {boolean} True if the tree should be editable.
	 */
	_resolveEditable(pInput)
	{
		let tmpPictForm = (pInput && pInput.PictForm) || {};
		if (tmpPictForm.ObjectEditor && typeof tmpPictForm.ObjectEditor.Editable === 'boolean')
		{
			return tmpPictForm.ObjectEditor.Editable;
		}
		return (tmpPictForm.ReadOnly !== true);
	}

	/**
	 * Ensure the per-input AppData stash exists and return its wrapper.
	 *
	 * @param {string} pInputHash - The input Hash.
	 * @returns {Object} The stash wrapper { Data }.
	 */
	_ensureStash(pInputHash)
	{
		if (!this.pict.AppData._PictInputObjectEditor)
		{
			this.pict.AppData._PictInputObjectEditor = {};
		}
		if (!this.pict.AppData._PictInputObjectEditor[pInputHash])
		{
			this.pict.AppData._PictInputObjectEditor[pInputHash] = { Data: {} };
		}
		return this.pict.AppData._PictInputObjectEditor[pInputHash];
	}

	/**
	 * @param {string} pInputHash - The input Hash.
	 * @returns {Object} The current edited object from the stash.
	 */
	_currentObject(pInputHash)
	{
		return this._ensureStash(pInputHash).Data;
	}

	/**
	 * Serialize an object into the input's hidden field.
	 *
	 * @param {string} pInputHTMLID - The RawHTMLID of the input.
	 * @param {Object} pObject - The object to serialize.
	 * @param {boolean} [pDispatchChange] - When true, dispatch a DOM change event.
	 * @returns {boolean} True if the value was written.
	 */
	_writeHiddenInputValue(pInputHTMLID, pObject, pDispatchChange)
	{
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pInputHTMLID) : null;
		if (!tmpEl) return false;

		let tmpString = '';
		try
		{
			tmpString = (pObject === null || typeof pObject === 'undefined') ? '' : JSON.stringify(pObject);
		}
		catch (pErr)
		{
			if (this.log)
			{
				this.log.warn('[Pict-Input-ObjectEditor] could not stringify object for hidden input',
					{ error: pErr.message });
			}
			tmpString = '';
		}
		tmpEl.value = tmpString;

		if (pDispatchChange)
		{
			try { tmpEl.dispatchEvent(new Event('change', { bubbles: true })); }
			catch (pErr) { /* jsdom may lack Event */ }
		}
		return true;
	}

	// ----------------------------------------------------------------------------
	// Mount / render
	// ----------------------------------------------------------------------------

	/**
	 * Mount (or re-render) the object editor for an input. Re-uses the view
	 * instance across re-renders, re-painting into the (possibly fresh) slot.
	 *
	 * @param {Object} pInput - The input definition object.
	 * @param {any} pValue - The value to edit/display.
	 * @param {boolean} pEditable - Whether the tree is editable.
	 * @param {Function} [fCallback] - Optional completion callback.
	 */
	_mount(pInput, pValue, pEditable, fCallback)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpViewHash  = `Pict-Input-ObjectEditor-${pInput.Hash}`;

		// Seed the per-input stash with the resolved object (the editor mutates
		// this object in place).
		let tmpStash = this._ensureStash(pInput.Hash);
		tmpStash.Data = this._resolveValue(pInput, pValue);

		let tmpView = this.pict.views[tmpViewHash];
		if (!tmpView)
		{
			let tmpOverrides = (pInput.PictForm && pInput.PictForm.ObjectEditor) || {};
			let tmpEditorOptions =
			{
				ViewIdentifier:    tmpViewHash,
				AutoRender:        false,
				Editable:          pEditable,
				ObjectDataAddress: this.getObjectDataAddress(pInput.Hash),
				// Point this instance's container renderable at our own slot so
				// multiple editors on a page never share a destination.
				Renderables:
				[
					{
						RenderableHash:     'ObjectEditor-Container',
						TemplateHash:       'ObjectEditor-Container-Template',
						// pict-view resolves a renderable's destination from ContentDestinationAddress
						// (see Pict-View.buildRenderOptions). A bare DestinationAddress is ignored, so the
						// container template never painted into the slot and the tree had nowhere to mount.
						ContentDestinationAddress: tmpSlotID,
						RenderMethod:       'replace'
					}
				]
			};
			if (typeof tmpOverrides.InitialExpandDepth === 'number')
			{
				tmpEditorOptions.InitialExpandDepth = tmpOverrides.InitialExpandDepth;
			}

			this.pict.addView(tmpViewHash, tmpEditorOptions, libPictSectionObjectEditor);
			tmpView = this.pict.views[tmpViewHash];
			// The object editor builds its per-type node renderers in onBeforeInitialize; a view added
			// after the boot cycle isn't initialized automatically, so initialize it before first render.
			if (tmpView && typeof tmpView.initialize === 'function') { tmpView.initialize(); }
		}
		else
		{
			// Re-use: update the mutable option before re-rendering into the slot.
			tmpView.options.Editable = pEditable;
		}

		if (!tmpView)
		{
			let tmpErr = new Error('Failed to instantiate ObjectEditor view ' + tmpViewHash);
			if (this.log) this.log.error('[Pict-Input-ObjectEditor] addView returned nothing', { viewHash: tmpViewHash });
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		let tmpInst = this._instances[pInput.Hash] || {};
		tmpInst.mode         = pEditable ? 'edit' : 'view';
		tmpInst.slotID       = tmpSlotID;
		tmpInst.viewInstance = tmpView;
		tmpInst.viewHash     = tmpViewHash;
		tmpInst.input        = pInput;
		this._instances[pInput.Hash] = tmpInst;

		try
		{
			// Render the container into the CURRENT slot explicitly. The host slot's RawHTMLID is
			// regenerated on every form re-render, so a re-used view instance would otherwise paint into
			// its original (now-removed) slot; passing the destination here re-points it every mount.
			let tmpResult = tmpView.render('ObjectEditor-Container', tmpSlotID);
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(
					() => { if (typeof fCallback === 'function') fCallback(null); },
					(pErr) => { if (typeof fCallback === 'function') fCallback(pErr); }
				);
			}
			else if (typeof fCallback === 'function')
			{
				fCallback(null);
			}
		}
		catch (pErr)
		{
			if (this.log) this.log.error('[Pict-Input-ObjectEditor] render threw', { error: pErr.message });
			if (typeof fCallback === 'function') fCallback(pErr);
		}
	}

	// ----------------------------------------------------------------------------
	// Public runtime API
	// ----------------------------------------------------------------------------

	getMode(pInputHash)
	{
		let tmpInst = this._instances[pInputHash];
		return tmpInst ? tmpInst.mode : null;
	}

	setMode(pInputHash, pMode, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			let tmpErr = new Error('Cannot setMode — input is not mounted: ' + pInputHash);
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		if (pMode !== 'edit' && pMode !== 'view')
		{
			let tmpErr = new Error('setMode: unknown mode "' + pMode + '" (use "edit" or "view")');
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}
		this._mount(tmpInst.input, this._currentObject(pInputHash), (pMode === 'edit'), fCallback);
	}

	toggleMode(pInputHash, fCallback)
	{
		let tmpMode = this.getMode(pInputHash);
		let tmpNext = (tmpMode === 'edit') ? 'view' : 'edit';
		this.setMode(pInputHash, tmpNext, fCallback);
	}

	/**
	 * Flush the current edited object to the input's hidden field.
	 *
	 * @param {string} pInputHash - The input Hash.
	 * @param {Function} [fCallback] - Optional completion callback.
	 */
	commit(pInputHash, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}
		this._writeHiddenInputValue(tmpInst.input.Macro.RawHTMLID, this._currentObject(pInputHash), true);
		if (typeof fCallback === 'function') fCallback(null);
	}

	// ----------------------------------------------------------------------------
	// Lifecycle hooks
	// ----------------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._mount(pInput, pValue, this._resolveEditable(pInput));
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * The ObjectEditor InputType is not supported inside Tabular rows.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object.
	 * @param {string} pHTMLSelector - The HTML selector for the input object.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @return {boolean}
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		let tmpErr = new Error('ObjectEditor InputType is not supported inside Tabular rows.');
		if (this.log) this.log.warn('[Pict-Input-ObjectEditor] tabular not supported', { inputHash: pInput && pInput.Hash });
		throw tmpErr;
	}

	/**
	 * Fires when data is marshaled to the form for this input — re-seed the
	 * stash with the fresh value and re-paint, preserving the current mode.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpInst = this._instances[pInput.Hash];
		let tmpEditable = tmpInst ? (tmpInst.mode === 'edit') : this._resolveEditable(pInput);
		this._mount(pInput, pValue, tmpEditable);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Fires when the form gathers this input's value (the save direction).
	 * Serialize the (in-place-mutated) stash into the hidden field so the form
	 * marshals the latest object. No change dispatch — this is a read.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean}
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		if (this._instances[pInput.Hash])
		{
			this._writeHiddenInputValue(pInput.Macro.RawHTMLID, this._currentObject(pInput.Hash), false);
		}
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}
}

module.exports = PictInputObjectEditor;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../Pict-Provider-InputExtension.js":599,"pict-section-objecteditor":698}],618:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { Math: any } & { DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	roundValue(pInput, pValue)
	{
		// A value that is not a number must render BLANK, never a formatted stand-in.
		// Formatting one produced "NaN" in a tabular cell (from a null return) and
		// "0.00" from undefined -- both of which read as real measurements. A
		// running average is legitimately empty until its window fills, so this is
		// the common case, not an edge case.
		if ((pValue === null) || (typeof (pValue) === 'undefined') || (String(pValue).trim() === ''))
		{
			return '';
		}

		let tmpValue = pValue;

		if ('DecimalPrecision' in pInput.PictForm)
		{
			let tmpRoundingMethod = this.fable.Math.roundHalfUp;
			if ('RoundingMethod' in pInput.PictForm)
			{
				try
				{
					tmpRoundingMethod = parseInt(pInput.PictForm.RoundingMethod);
				}
				catch(pError)
				{
					this.log.error(`Error parsing rounding method onDataMarshalToForm for input ${pInput.Hash}`, pError);
				}
			}
			tmpValue = this.fable.Math.toFixedPrecise(tmpValue, pInput.PictForm.DecimalPrecision, tmpRoundingMethod);
		}

		if (('AddCommas' in pInput.PictForm) && pInput.PictForm.AddCommas)
		{
			tmpValue = this.fable.DataFormat.formatterAddCommasToNumber(tmpValue);
		}

		if ('DigitsPrefix' in pInput.PictForm)
		{
			tmpValue = pInput.PictForm.DigitsPrefix + tmpValue;
		}
		if ('DigitsPostfix' in pInput.PictForm)
		{
			tmpValue = tmpValue + pInput.PictForm.DigitsPostfix;
		}

		return tmpValue;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getInputHTMLID(pInput.Macro.RawHTMLID), this.roundValue(pInput, pValue));
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent('#PRECISE-' + this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex).substring(1), pValue);
		this.pict.ContentAssignment.assignContent(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), this.roundValue(pInput, pValue));
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],619:[function(require,module,exports){
/**
 * Pict-Provider-Input-RichText-CSS.js
 *
 * Scoped CSS for the RichText form-input slot. Registered via
 * `pict.CSSMap.addCSS('Pict-Input-RichText-CSS', libCSS, 500)` from the
 * provider's constructor.
 *
 * All colors flow through theme tokens with hex fallbacks so the input looks
 * correct standalone (no theme provider) and adapts when a theme provider is
 * mounted. Three font-stack tokens (`--theme-font-body`, `--theme-font-mono`)
 * are pulled the same way.
 *
 * Class names:
 *
 *   .pict-section-form-richtext        the outer slot the form template emits
 *   .pict-section-form-richtext-view   the rendered-markdown container (view mode)
 *   .pict-section-form-richtext-edit   the editor container (edit mode)
 *   .pict-section-form-richtext-toggle "Edit" / "Done" affordance the consumer
 *                                      can render inside the slot if they want
 *                                      a built-in mode-switch chip
 */

module.exports = /*css*/`
.pict-section-form-richtext
{
	display: block;
	width: 100%;
	min-height: 64px;
	border: 1px solid var(--theme-color-border-primary, #D4C4A8);
	border-radius: 4px;
	background: var(--theme-color-background-primary, #FFFFFF);
	color: var(--theme-color-text-primary, #2A2520);
	font-family: var(--theme-font-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
	font-size: 0.95rem;
	line-height: 1.55;
	box-sizing: border-box;
}

.pict-section-form-richtext-view
{
	padding: 10px 14px;
	min-height: 48px;
}

.pict-section-form-richtext-view.is-empty
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-style: italic;
}

.pict-section-form-richtext-view :first-child { margin-top: 0; }
.pict-section-form-richtext-view :last-child  { margin-bottom: 0; }

.pict-section-form-richtext-view h1,
.pict-section-form-richtext-view h2,
.pict-section-form-richtext-view h3,
.pict-section-form-richtext-view h4
{
	color: var(--theme-color-text-heading, var(--theme-color-text-primary, #2A2520));
	margin: 0.6em 0 0.3em 0;
	line-height: 1.25;
}

.pict-section-form-richtext-view code
{
	font-family: var(--theme-font-mono, 'SFMono-Regular', Menlo, monospace);
	font-size: 0.9em;
	padding: 1px 5px;
	background: var(--theme-color-background-tertiary, #F4EEE2);
	border-radius: 3px;
}

.pict-section-form-richtext-view pre
{
	font-family: var(--theme-font-mono, 'SFMono-Regular', Menlo, monospace);
	background: var(--theme-color-background-tertiary, #F4EEE2);
	padding: 10px 12px;
	border-radius: 4px;
	overflow: auto;
}

.pict-section-form-richtext-view blockquote
{
	margin: 0.5em 0;
	padding: 4px 12px;
	border-left: 3px solid var(--theme-color-accent, #2E7D74);
	color: var(--theme-color-text-secondary, #5A4A3C);
	background: var(--theme-color-background-secondary, #FBF7EE);
}

.pict-section-form-richtext-view img
{
	max-width: 100%;
	height: auto;
	border-radius: 3px;
}

.pict-section-form-richtext-edit
{
	padding: 0;
	min-height: 220px;
}

/*
 * The editor (pict-section-markdowneditor) brings its own chrome inside the
 * slot. We just provide a container border + sane min-height; CodeMirror takes
 * over from there.
 */

/* Optional mode-toggle affordance — render inside the slot from the host UI
 * via _Pict.providers['Pict-Input-RichText'].toggleMode('<hash>'). The chip is
 * absolutely positioned in the top-right corner so it doesn't take a column
 * from the form layout. */
.pict-section-form-richtext { position: relative; }

.pict-section-form-richtext-toggle
{
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 2;
	padding: 3px 9px;
	font-size: 0.72rem;
	font-weight: 600;
	color: var(--theme-color-text-secondary, #5A4A3C);
	background: var(--theme-color-background-tertiary, #F4EEE2);
	border: 1px solid var(--theme-color-border-secondary, #D4C4A8);
	border-radius: 3px;
	cursor: pointer;
	user-select: none;
}

.pict-section-form-richtext-toggle:hover
{
	color: var(--theme-color-text-primary, #2A2520);
	background: var(--theme-color-background-primary, #FFFFFF);
	border-color: var(--theme-color-accent, #2E7D74);
}

.pict-section-form-richtext.mode-edit  .pict-section-form-richtext-toggle::after { content: 'Done'; }
.pict-section-form-richtext.mode-view  .pict-section-form-richtext-toggle::after { content: 'Edit'; }
`;

},{}],620:[function(require,module,exports){
/**
 * Pict-Provider-Input-RichText.js
 *
 * A pict-section-form input provider that pairs the markdown editor
 * (edit mode) with rendered markdown (view mode). Boots in VIEW mode —
 * the heavy CodeMirror bundle isn't pulled until the host UI calls
 * `provider.setMode(pInputHash, 'edit')`.
 *
 * Descriptor shape:
 *
 *   {
 *     "Name": "Body",
 *     "Hash": "PostBody",
 *     "DataType": "String",
 *     "PictForm": {
 *       "InputType": "RichText",
 *       "RichText": {
 *         "AllowImages": true,
 *         "ImageUploader": "uploadImage",     // method on pict.PictApplication
 *         "Height": "400px",                  // applied to the slot in edit mode
 *         "EditorOptions": { ... },           // pass-through to markdowneditor
 *         "ViewerOptions": { ... }            // reserved for future use
 *       }
 *     }
 *   }
 *
 * Runtime API:
 *
 *   provider.setMode(inputHash, 'edit' | 'view', fCallback)
 *   provider.getMode(inputHash)            // 'edit' | 'view' | null (not mounted)
 *   provider.toggleMode(inputHash)         // convenience for buttons
 *   provider.commit(inputHash, fCallback)  // force-save edit-mode editor → form
 */

const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');
const libMarked                    = require('marked');
const libMarkdownEditor            = require('pict-section-markdowneditor');

// Form templates live in pict-section-form's default-template set, so no
// runtime template injection is needed here. CSS still needs registering
// — the scoped slot styling lives next to the provider.
const libCSS = require('./Pict-Provider-Input-RichText-CSS.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Input-RichText',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	AutoSolveWithApp: false
};

class PictInputRichText extends libPictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */ this.pict;
		/** @type {any}            */ this.log;

		// inputHash → { mode: 'view'|'edit', slotID, lastValue, viewInstance?: Pict-Section-MarkdownEditor, input }
		this._instances = {};

		// Register the scoped CSS for the slot.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Input-RichText-CSS', libCSS, 500);
		}
	}

	// ----------------------------------------------------------------------------
	// Helpers
	// ----------------------------------------------------------------------------

	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Resolve a string value from various places the form may stash content.
	 */
	_resolveContent(pInput, pValue)
	{
		if (typeof pValue === 'string' && pValue.length > 0) return pValue;
		if (pInput && pInput.Content && typeof pInput.Content === 'string') return pInput.Content;
		if (pInput && pInput.Default && typeof pInput.Default === 'string') return pInput.Default;
		return '';
	}

	/**
	 * Render markdown to HTML. Falls back to escaping if marked throws.
	 */
	_renderMarkdown(pMarkdown)
	{
		try
		{
			return libMarked.parse(pMarkdown || '');
		}
		catch (pErr)
		{
			if (this.log) this.log.warn('[Pict-Input-RichText] marked.parse failed', { error: pErr.message });
			let tmpEscaped = String(pMarkdown || '').replace(/[&<>"]/g, (c) =>
				({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
			return `<pre>${tmpEscaped}</pre>`;
		}
	}

	_writeHiddenInputValue(pInputHTMLID, pValue)
	{
		// The hidden <input> the form template emits — referenced as just the
		// raw HTML ID (no #DISPLAY-FOR- prefix). Inform Informary of the change
		// via a dispatched event so the form's AppData updates downstream.
		let tmpEl = (typeof document !== 'undefined') ? document.getElementById(pInputHTMLID) : null;
		if (!tmpEl) return false;
		tmpEl.value = (pValue == null) ? '' : String(pValue);
		try
		{
			tmpEl.dispatchEvent(new Event('change', { bubbles: true }));
		}
		catch (pErr)
		{
			// jsdom-in-test sometimes lacks Event constructor; harmless in browser.
		}
		return true;
	}

	_assignSlotContent(pSlotID, pHTML)
	{
		if (this.pict && this.pict.ContentAssignment &&
			typeof this.pict.ContentAssignment.assignContent === 'function')
		{
			this.pict.ContentAssignment.assignContent(pSlotID, pHTML);
			return true;
		}
		return false;
	}

	// ----------------------------------------------------------------------------
	// View mode
	// ----------------------------------------------------------------------------

	_mountView(pView, pInput, pValue)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpContent   = this._resolveContent(pInput, pValue);

		let tmpInnerHTML;
		if (tmpContent && tmpContent.length > 0)
		{
			tmpInnerHTML =
				`<div class="pict-section-form-richtext-view">${this._renderMarkdown(tmpContent)}</div>`;
		}
		else
		{
			tmpInnerHTML =
				`<div class="pict-section-form-richtext-view is-empty">(empty)</div>`;
		}

		this._assignSlotContent(tmpSlotID, tmpInnerHTML);

		// Mode flag on the outer slot so the optional toggle chip can pick the
		// right "Edit" / "Done" label via the ::after pseudo selector.
		if (typeof document !== 'undefined')
		{
			let tmpOuter = document.getElementById(tmpRawHTMLID + '-CONTAINER') ||
				document.querySelector(tmpSlotID);
			if (tmpOuter && tmpOuter.classList)
			{
				tmpOuter.classList.remove('mode-edit');
				tmpOuter.classList.add('mode-view');
			}
		}

		let tmpInst = this._instances[pInput.Hash] || {};
		tmpInst.mode      = 'view';
		tmpInst.slotID    = tmpSlotID;
		tmpInst.lastValue = tmpContent;
		tmpInst.input     = pInput;
		// If we previously held an editor, it's already been torn down by caller.
		tmpInst.viewInstance = null;
		this._instances[pInput.Hash] = tmpInst;
	}

	// ----------------------------------------------------------------------------
	// Edit mode
	// ----------------------------------------------------------------------------

	_buildEditorOptions(pInput, pValue, pInst)
	{
		let tmpRichTextOpts = (pInput.PictForm && pInput.PictForm.RichText) || {};
		let tmpEditorOpts   = tmpRichTextOpts.EditorOptions || {};
		let tmpRawHTMLID    = pInput.Macro.RawHTMLID;

		// Per-input AppData address for segments. Picked to be unlikely to collide
		// with anything a host app puts in AppData.
		let tmpSegmentsAddr = `AppData._PictInputRichText.${pInput.Hash}.Segments`;

		// Ensure the segments array exists at that address. Single segment per
		// editor — multi-segment is a power-feature the markdown editor itself
		// supports, but inside a single form field one segment is the right
		// surface.
		if (!this.pict.AppData._PictInputRichText)
		{
			this.pict.AppData._PictInputRichText = {};
		}
		this.pict.AppData._PictInputRichText[pInput.Hash] =
		{
			Segments: [{ Content: (pValue || '') }]
		};

		let tmpOptions = Object.assign({}, tmpEditorOpts,
		{
			ViewIdentifier:      `Pict-Input-RichText-Editor-${pInput.Hash}`,
			TargetElementAddress: this.getContentDisplayHTMLID(tmpRawHTMLID),
			ContentDataAddress:   tmpSegmentsAddr,
			ReadOnly:             false
		});

		return tmpOptions;
	}

	_mountEdit(pView, pInput, pValue, fCallback)
	{
		let tmpRawHTMLID = pInput.Macro.RawHTMLID;
		let tmpSlotID    = this.getContentDisplayHTMLID(tmpRawHTMLID);
		let tmpContent   = this._resolveContent(pInput, pValue);
		let tmpInst      = this._instances[pInput.Hash] || {};
		tmpInst.input    = pInput;

		// Clear view-mode content so the editor mounts into a clean slot.
		this._assignSlotContent(tmpSlotID, '');

		let tmpEditorOpts  = this._buildEditorOptions(pInput, tmpContent, tmpInst);
		let tmpViewHash    = tmpEditorOpts.ViewIdentifier;
		let tmpRichTextOpts = (pInput.PictForm && pInput.PictForm.RichText) || {};

		// Build a subclass that captures content changes back to the form's
		// hidden input. Subclassing is how pict-section-markdowneditor itself
		// is meant to be extended (its constructor accepts options + the parent
		// view class is libPictViewClass).
		let tmpProvider = this;

		class RichTextFormEditor extends libMarkdownEditor
		{
			constructor(pSubFable, pSubOptions, pSubServiceHash)
			{
				super(pSubFable, pSubOptions, pSubServiceHash);
			}

			onContentChange(pSegmentIndex, pContent)
			{
				try
				{
					// Single-segment editor — every change replaces the value.
					tmpProvider._writeHiddenInputValue(tmpRawHTMLID, pContent);
					let tmpLatest = tmpProvider._instances[pInput.Hash];
					if (tmpLatest) tmpLatest.lastValue = pContent;
				}
				catch (pErr)
				{
					if (tmpProvider.log)
					{
						tmpProvider.log.warn('[Pict-Input-RichText] onContentChange handler failed',
							{ error: pErr.message, inputHash: pInput.Hash });
					}
				}
				if (super.onContentChange) super.onContentChange(pSegmentIndex, pContent);
			}

			onImageUpload(pFile, pSegmentIndex, fImgCallback)
			{
				if (!tmpRichTextOpts.AllowImages)
				{
					if (tmpProvider.log)
					{
						tmpProvider.log.info('[Pict-Input-RichText] image upload rejected (AllowImages=false)',
							{ inputHash: pInput.Hash, fileName: pFile && pFile.name });
					}
					// Returning false lets the base markdown editor fall through to
					// its default base64 inline; we *don't* want that when text-only,
					// so we eat the file by calling back with an error.
					fImgCallback('Image uploads are disabled for this field.');
					return true;
				}

				let tmpUploaderName = tmpRichTextOpts.ImageUploader;
				if (tmpUploaderName &&
					tmpProvider.pict && tmpProvider.pict.PictApplication &&
					typeof tmpProvider.pict.PictApplication[tmpUploaderName] === 'function')
				{
					try
					{
						return tmpProvider.pict.PictApplication[tmpUploaderName](pFile, pInput, fImgCallback);
					}
					catch (pErr)
					{
						if (tmpProvider.log)
						{
							tmpProvider.log.warn('[Pict-Input-RichText] ImageUploader threw',
								{ error: pErr.message, inputHash: pInput.Hash });
						}
						fImgCallback(pErr.message);
						return true;
					}
				}

				// No uploader configured + AllowImages=true → default base64 inline.
				return false;
			}

			/**
			 * Push CodeMirror extensions before the editor mounts. We enable
			 * line wrapping by default so long markdown paragraphs flow to
			 * the next visual line instead of horizontally scrolling — the
			 * almost-always-correct default for prose. Opt out via
			 * `PictForm.RichText.WordWrap: false` in the descriptor.
			 */
			customConfigureExtensions(pExtensions, pSegmentIndex)
			{
				let tmpWantWrap = (tmpRichTextOpts.WordWrap !== false);
				if (tmpWantWrap)
				{
					let tmpCM = this._codeMirrorModules;
					if (tmpCM && tmpCM.EditorView && tmpCM.EditorView.lineWrapping)
					{
						pExtensions.push(tmpCM.EditorView.lineWrapping);
					}
				}
				return pExtensions;
			}
		}

		this.pict.addView(tmpViewHash, tmpEditorOpts, RichTextFormEditor);
		let tmpEditorView = this.pict.views[tmpViewHash];

		if (!tmpEditorView)
		{
			let tmpErr = new Error('Failed to instantiate RichText editor view ' + tmpViewHash);
			if (this.log) this.log.error('[Pict-Input-RichText] addView returned nothing', { viewHash: tmpViewHash });
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		// Surface mode on the outer slot for the optional toggle-chip pseudo.
		if (typeof document !== 'undefined')
		{
			let tmpOuter = document.querySelector(tmpSlotID);
			if (tmpOuter && tmpOuter.classList)
			{
				tmpOuter.classList.remove('mode-view');
				tmpOuter.classList.add('mode-edit', 'pict-section-form-richtext-edit');
			}
		}

		tmpInst.mode         = 'edit';
		tmpInst.slotID       = tmpSlotID;
		tmpInst.lastValue    = tmpContent;
		tmpInst.viewInstance = tmpEditorView;
		tmpInst.viewHash     = tmpViewHash;
		this._instances[pInput.Hash] = tmpInst;

		// Render the editor. The view's render() resolves TargetElementAddress
		// against ContentAssignment and paints into the slot.
		try
		{
			let tmpResult = tmpEditorView.render();
			// Some renders are async (Promise-returning) and some are sync.
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(
					() => { if (typeof fCallback === 'function') fCallback(null); },
					(pRenderErr) => { if (typeof fCallback === 'function') fCallback(pRenderErr); }
				);
			}
			else
			{
				if (typeof fCallback === 'function') fCallback(null);
			}
		}
		catch (pErr)
		{
			if (this.log) this.log.error('[Pict-Input-RichText] editor.render threw', { error: pErr.message });
			if (typeof fCallback === 'function') fCallback(pErr);
		}
	}

	_destroyEdit(pInput)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst || !tmpInst.viewInstance) return;

		let tmpView = tmpInst.viewInstance;

		try
		{
			if (typeof tmpView.destroy === 'function')
			{
				tmpView.destroy();
			}
		}
		catch (pErr)
		{
			if (this.log) this.log.warn('[Pict-Input-RichText] editor.destroy threw', { error: pErr.message });
		}

		// Drop the per-input AppData branch (we re-seed on next edit-mode mount).
		if (this.pict.AppData._PictInputRichText &&
			this.pict.AppData._PictInputRichText[pInput.Hash])
		{
			delete this.pict.AppData._PictInputRichText[pInput.Hash];
		}

		// Remove the view registration so subsequent mounts re-register cleanly.
		if (tmpInst.viewHash && this.pict.views && this.pict.views[tmpInst.viewHash])
		{
			try { delete this.pict.views[tmpInst.viewHash]; }
			catch (pErr) { /* not all environments allow delete on this collection */ }
		}

		tmpInst.viewInstance = null;
		tmpInst.viewHash     = null;
	}

	// ----------------------------------------------------------------------------
	// Public runtime API
	// ----------------------------------------------------------------------------

	getMode(pInputHash)
	{
		let tmpInst = this._instances[pInputHash];
		return tmpInst ? tmpInst.mode : null;
	}

	setMode(pInputHash, pMode, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst)
		{
			let tmpErr = new Error('Cannot setMode — input is not mounted: ' + pInputHash);
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		if (pMode !== 'edit' && pMode !== 'view')
		{
			let tmpErr = new Error('setMode: unknown mode "' + pMode + '" (use "edit" or "view")');
			if (typeof fCallback === 'function') fCallback(tmpErr);
			return;
		}

		if (tmpInst.mode === pMode)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}

		if (pMode === 'edit')
		{
			this._mountEdit(null, tmpInst.input, tmpInst.lastValue, fCallback);
			return;
		}

		// pMode === 'view': pull the latest, tear down editor, re-render view.
		this._destroyEdit(tmpInst.input);
		this._mountView(null, tmpInst.input, tmpInst.lastValue);
		if (typeof fCallback === 'function') fCallback(null);
	}

	toggleMode(pInputHash, fCallback)
	{
		let tmpMode = this.getMode(pInputHash);
		let tmpNext = (tmpMode === 'edit') ? 'view' : 'edit';
		this.setMode(pInputHash, tmpNext, fCallback);
	}

	commit(pInputHash, fCallback)
	{
		let tmpInst = this._instances[pInputHash];
		if (!tmpInst || tmpInst.mode !== 'edit' || !tmpInst.viewInstance)
		{
			if (typeof fCallback === 'function') fCallback(null);
			return;
		}
		// The editor writes through onContentChange on every keystroke, so the
		// hidden input is already up to date. We just confirm.
		if (typeof fCallback === 'function') fCallback(null);
	}

	// ----------------------------------------------------------------------------
	// Lifecycle hooks (called by pict-section-form during form rendering)
	// ----------------------------------------------------------------------------

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._mountView(pView, pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpErr = new Error('RichText InputType is not supported inside Tabular rows in Phase 1.');
		if (this.log) this.log.warn('[Pict-Input-RichText] tabular not supported', { inputHash: pInput && pInput.Hash });
		throw tmpErr;
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpInst = this._instances[pInput.Hash];
		if (!tmpInst)
		{
			// First time seeing this input — boot in view mode.
			this._mountView(pView, pInput, pValue);
		}
		else if (tmpInst.mode === 'view')
		{
			this._mountView(pView, pInput, pValue);
		}
		else
		{
			// Edit mode: push the new value into the editor's segment store.
			tmpInst.lastValue = (typeof pValue === 'string') ? pValue : tmpInst.lastValue;
			if (this.pict.AppData._PictInputRichText &&
				this.pict.AppData._PictInputRichText[pInput.Hash])
			{
				this.pict.AppData._PictInputRichText[pInput.Hash].Segments =
					[{ Content: tmpInst.lastValue }];
				// Re-render the editor so it picks up the new segments.
				if (tmpInst.viewInstance && typeof tmpInst.viewInstance.render === 'function')
				{
					try { tmpInst.viewInstance.render(); }
					catch (pErr)
					{
						if (this.log) this.log.warn('[Pict-Input-RichText] re-render after marshal threw',
							{ error: pErr.message });
					}
				}
			}
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		// Tabular is unsupported — silent no-op (the initialize step already threw).
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = PictInputRichText;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../Pict-Provider-InputExtension.js":599,"./Pict-Provider-Input-RichText-CSS.js":619,"marked":585,"pict-section-markdowneditor":680}],621:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the select input element.
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular select input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular select input ID.
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select dropdown ID based on the input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {string} - The generated tabular select dropdown ID.
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Records the option ids on the element and reports whether they differ from what it last rendered,
	 * so a refresh on every marshal does not rebuild (and blur) a dropdown whose options are unchanged.
	 *
	 * @param {HTMLElement} pSelectElement
	 * @param {Array<{ id: string, text: string }>} pListData
	 * @return {boolean}
	 */
	optionsChanged(pSelectElement, pListData)
	{
		if (!pSelectElement || !pSelectElement.setAttribute)
		{
			return true;
		}
		const tmpSignature = Array.isArray(pListData) ? pListData.map((pEntry) => `${pEntry.id}\u0001${pEntry.text}`).join('\u0002') : '';
		if (pSelectElement.getAttribute('data-pict-options') === tmpSignature)
		{
			return false;
		}
		pSelectElement.setAttribute('data-pict-options', tmpSignature);
		return true;
	}

	/**
	 * Refreshes the select list for a dynamic input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 */
	refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		let tmpListData = pInput.PictForm?.SelectOptions;

		if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElement || tmpInputSelectElement.length < 1)
		{
			return false;
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData);

		tmpInputSelectElement = tmpInputSelectElement[0];
		if (!this.optionsChanged(tmpInputSelectElement, tmpListData))
		{
			return;
		}
		// HAX
		tmpInputSelectElement.innerHTML = '';

		if (tmpInputSelectElement && tmpListData && Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpOption = document.createElement('option');
				tmpOption.value = tmpListData[i].id;
				tmpOption.text = tmpListData[i].text;
				tmpInputSelectElement.appendChild(tmpOption);
			}
		}
	}

	/**
	 * Refreshes the select list for a tabular input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex 
	 */
	refreshSelectListTabular(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		let tmpListData = pInput.PictForm?.SelectOptions;

		if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData, pRowIndex);

		// TODO: Determine later if this should ever be an array.
		if (!Array.isArray(tmpInputSelectElement) || tmpInputSelectElement.length < 1)
		{
			return;
		}

		tmpInputSelectElement = tmpInputSelectElement[0];

		if (!this.optionsChanged(tmpInputSelectElement, tmpListData))
		{
			return;
		}

		// HAX
		tmpInputSelectElement.innerHTML = '';

		if (tmpInputSelectElement && tmpListData && Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpOption = document.createElement('option');
				tmpOption.value = tmpListData[i].id;
				tmpOption.text = tmpListData[i].text;
				tmpInputSelectElement.appendChild(tmpOption);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.refreshSelectListTabular(pView, pGroup, pView.getRow(pInput.PictForm.GroupIndex, pRowIndex), pInput, pValue, pHTMLSelector, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (this.pict.providers.ListDistilling.getFacetRule(pInput))
		{
			this.refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		}
		/** @type {Array<HTMLElement>|HTMLElement} */
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		const tmpInputSelectElement = tmpInputSelectElements[0];
		if (!(tmpInputSelectElement instanceof HTMLSelectElement))
		{
			return false;
		}

		let tmpValueSelected = false;

		for (let i = 0; i < tmpInputSelectElement.options.length; i++)
		{
			if (tmpInputSelectElement.options[i].value === pValue)
			{
				tmpInputSelectElement.selectedIndex = i;
				tmpValueSelected = true;
				break;
			}
		}

		if (!tmpValueSelected)
		{
			tmpInputSelectElement.selectedIndex = -1;
			//this.log.error(`The value [${pValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
		}

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (this.pict.providers.ListDistilling.getFacetRule(pInput))
		{
			this.refreshSelectListTabular(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex);
		}
		/** @type {Array<HTMLElement>|HTMLElement} */
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		const tmpInputSelectElement = tmpInputSelectElements[0];
		if (!(tmpInputSelectElement instanceof HTMLSelectElement))
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}

		let tmpValueSelected = false;

		for (let i = 0; i < tmpInputSelectElement.options.length; i++)
		{
			if (tmpInputSelectElement.options[i].value === pValue)
			{
				tmpInputSelectElement.selectedIndex = i;
				tmpValueSelected = true;
				break;
			}
		}

		if (!tmpValueSelected)
		{
			tmpInputSelectElement.selectedIndex = -1;
			//this.log.error(`The value [${pValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
		}

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @returns {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		let tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		let tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],622:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideClass = 'pict-tab-group-hidden';
		this.cssSelectedTabClass = 'pict-tab-group-selectedtab';
		this.cssSnippet = '.pict-tab-group-hidden { display: none; } .pict-tab-group-selectedtab { font-weight: bold; }';

		this.setCSSSnippets();
	}

	/**
	 * @param {string} [pCSSHideClass]
	 * @param {string} [pCSSSnippet]
	 */
	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;

		this.pict.CSSMap.addCSS('Pict-Section-Form-Input-Group-TabSelector', this.cssSnippet, 1001, 'Pict-Input-TabSelector');
		this.pict.CSSMap.injectCSS();
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pGroupHash - The group hash.
	 *
	 * @return {string}
	 */
	getTabSelector(pView, pInput, pGroupHash)
	{
		return `#TAB-${pGroupHash}-${pInput.Macro.RawHTMLID}`;
	}


	/**
	 * @param {Object} pView - The view object.
	 * @param {string} pGroupHash - The group hash.
	 *
	 * @return {string}
	 */
	getGroupSelector(pView, pGroupHash)
	{
		return `#GROUP-${pView.formID}-${pGroupHash}`;
	}

	/**
	 * Is this tab group hash actually one of the input's tabs?
	 *
	 * @param {Object} pInput - The input object.
	 * @param {string} pTabGroupHash - The tab group hash to test.
	 *
	 * @return {boolean}
	 */
	isTabInSet(pInput, pTabGroupHash)
	{
		let tmpTabSet = pInput?.PictForm?.TabGroupSet;
		return !!pTabGroupHash && Array.isArray(tmpTabSet) && (tmpTabSet.indexOf(pTabGroupHash) > -1);
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabHash
	 *
	 * @return {boolean} - true once the tab is shown; false (nothing changed) if the view, input or tab hash is not valid.
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabHash)
	{
		// First get the view
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the view did not exist!`)
			return false;
		}
		// Then the input
		let tmpInput = tmpView.getInputFromHash(pInputHash)
		if (!tmpInput)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the input did not exist!`)
			return false;
		}
		// Now enumerate the tabs and hide the others, then show this one.
		// TODO: This could be made more elegant by testing which ones are shown and swapping them faster.
		if (!(tmpInput?.PictForm?.TabGroupSet) || !Array.isArray(tmpInput.PictForm.TabGroupSet))
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the input did not have a valid TabGroupSet array in the PictForm object!`)
			return false;
		}

		// A hash that is not in the set matches nothing below, so it would hide EVERY group and leave no
		// tab selected. Refuse it without touching anything; false already means "did not switch".
		if (!this.isTabInSet(tmpInput, pTabHash))
		{
			this.pict.log.warn(`TabSelector input provider was asked for tab [${pTabHash}] on view [${pViewHash}] input [${pInputHash}] but it is not in the TabGroupSet; leaving the current tab selected.`);
			return false;
		}

		for (let i = 0; i < tmpInput.PictForm.TabGroupSet.length; i++)
		{
			let tmpTabGroupHash = tmpInput.PictForm.TabGroupSet[i];
			if (tmpTabGroupHash != pTabHash)
			{
				// Hide this tab group if it isn't the "expected to be visible" group
				this.pict.ContentAssignment.addClass(this.getGroupSelector(tmpView, tmpTabGroupHash), this.cssHideClass);
				this.pict.ContentAssignment.removeClass(this.getTabSelector(tmpView, tmpInput, tmpTabGroupHash), this.cssSelectedTabClass);
			}
			else
			{
				// Show this tab group if it is the "expected to be visible" group
				this.pict.ContentAssignment.removeClass(this.getGroupSelector(tmpView, tmpTabGroupHash), this.cssHideClass);
				this.pict.ContentAssignment.addClass(this.getTabSelector(tmpView, tmpInput, tmpTabGroupHash), this.cssSelectedTabClass);
			}
		}
		tmpView.setDataByInput(tmpInput, pTabHash);
		return true;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the select input element.
	 */
	getTabSelectorInputHTMLID(pInputHTMLID)
	{
		return `#TAB-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		let tmpTabSet = pInput.PictForm?.TabGroupSet;

		if (!tmpTabSet || !Array.isArray(tmpTabSet) || tmpTabSet.length < 1)
		{
			this.pict.log.error(`TabSelector input provider tried to initialize Tab Group Set for HTML ID [${pInput.Macro.RawHTMLID}] but there were no valid entries in the tmpInput.PictForm.TabGroupSet array!`)
			return false;
		}

		let tmpEntryMetatemplateHash = this.pict.providers.DynamicInput.getInputTemplateHash(pView, { PictForm: { InputType: 'TabGroupSelector-TabElement', DataType: 'String' } });

		let tmpTabGroupSetEntries = '';
		// If there are tab group names, use them, otherwise use the hash
		let tempTabSetNames = pInput.PictForm?.TabGroupNames || [];

		for (let i = 0; i < tmpTabSet.length; i++)
		{
			tmpTabGroupSetEntries += this.pict.parseTemplateByHash(tmpEntryMetatemplateHash, pInput, null, [pView, {TabGroupHash: tmpTabSet[i], TabGroupName: (tempTabSetNames[i] || tmpTabSet[i])}]);
		}

		// TODO: Fix typescript types so this function has an optional rather than required fourth parameter.
		this.pict.ContentAssignment.projectContent('replace', this.getTabSelectorInputHTMLID(pInput.Macro.RawHTMLID), tmpTabGroupSetEntries, 'FixTheTypescriptTypes');

		// Now set the default tab (or first one). Take the first candidate that is actually one of this
		// input's tabs, since selectTabByViewHash refuses anything else: a stored value can name a group
		// since renamed or dropped from the manifest, and DefaultTabGroupHash can simply be a typo.
		const tmpTabCandidates = [];
		if (pInput.PictForm?.DefaultFromData !== false)
		{
			tmpTabCandidates.push(pValue);
		}
		tmpTabCandidates.push(pInput.PictForm?.DefaultTabGroupHash);

		let tmpDefaultTabGroupHash = tmpTabSet[0];
		for (let i = 0; i < tmpTabCandidates.length; i++)
		{
			if (this.isTabInSet(pInput, tmpTabCandidates[i]))
			{
				tmpDefaultTabGroupHash = tmpTabCandidates[i];
				break;
			}
		}

		this.selectTabByViewHash(pView.Hash, pInput.Hash, tmpDefaultTabGroupHash);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],623:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideClass = 'pict-tab-section-hidden';
		this.cssSelectedTabClass = 'pict-tab-section-selectedtab';
		this.cssSnippet = '.pict-tab-section-hidden { display: none; } .pict-tab-section-selectedtab { font-weight: bold; }';

		this.setCSSSnippets();
	}

	/**
	 * @param {string} [pCSSHideClass]
	 * @param {string} [pCSSSnippet]
	 */
	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;
		this.pict.CSSMap.addCSS('Pict-Section-Form-Input-Section-TabSelector', this.cssSnippet, 1001, 'Pict-Input-TabSelector');
	}

	/**
	 * @param {string} pManifestSectionHash
	 *
	 * @return {string}
	 */
	getViewHash(pManifestSectionHash)
	{
		return `PictSectionForm-${pManifestSectionHash}`;
	}

	/**
	 * @param {string} pTabSectionHash
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	getTabSelector(pTabSectionHash, pInput)
	{
		return `#TAB-${pTabSectionHash}-${pInput.Macro.RawHTMLID}`;
	}

	/**
	 * @param {string} pTabViewSectionHash
	 *
	 * @return {string}
	 */
	getSectionSelector(pTabViewSectionHash)
	{
		const metaController = this.pict.views.PictFormMetacontroller;
		return `#Pict-${metaController ? metaController.UUID : this.UUID}-${pTabViewSectionHash}-Wrap`;
	}

	/**
	 * Is this tab section hash actually one of the input's tabs?
	 *
	 * @param {Object} pInput - The input object.
	 * @param {string} pTabSectionHash - The tab section hash to test.
	 *
	 * @return {boolean}
	 */
	isTabInSet(pInput, pTabSectionHash)
	{
		let tmpTabSet = pInput?.PictForm?.TabSectionSet;
		return !!pTabSectionHash && Array.isArray(tmpTabSet) && (tmpTabSet.indexOf(pTabSectionHash) > -1);
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabViewHash
	 *
	 * @return {boolean} - true once the section is shown; false (nothing changed) if the view, input or tab hash is not valid.
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabViewHash)
	{
		// First get the view
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the view did not exist!`)
			return false;
		}
		// Then the input
		let tmpInput = tmpView.getInputFromHash(pInputHash)
		if (!tmpInput)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the input did not exist!`)
			return false;
		}
		// Now enumerate the tabs and hide the others, then show this one.
		// TODO: This could be made more elegant by testing which ones are shown and swapping them faster.
		if (!(tmpInput?.PictForm?.TabSectionSet) || !Array.isArray(tmpInput.PictForm.TabSectionSet))
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the input did not have a valid TabSectionSet array in the PictForm object!`)
			return false;
		}
		// A hash that is not in the set matches nothing below, so it would hide EVERY section and leave no
		// tab selected. Refuse it without touching anything; false already means "did not switch".
		if (!this.isTabInSet(tmpInput, pTabViewHash))
		{
			this.pict.log.warn(`TabSelector input provider was asked for tab [${pTabViewHash}] on view [${pViewHash}] input [${pInputHash}] but it is not in the TabSectionSet; leaving the current tab selected.`);
			return false;
		}
		let tmpTabView = this.pict.views[this.getViewHash(pTabViewHash)];
		if (!tmpTabView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the tab view did not exist!`)
			return false;
		}

		for (let i = 0; i < tmpInput.PictForm.TabSectionSet.length; i++)
		{
			let tmpTabSectionHash = tmpInput.PictForm.TabSectionSet[i];
			if (tmpTabSectionHash != pTabViewHash)
			{
				// Hide this tab group if it isn't the "expected to be visible" group
				this.pict.ContentAssignment.addClass(this.getSectionSelector(tmpTabSectionHash), this.cssHideClass);
				this.pict.ContentAssignment.removeClass(this.getTabSelector(tmpTabSectionHash, tmpInput), this.cssSelectedTabClass);
			}
			else
			{
				// Show this tab group if it is the "expected to be visible" group
				this.pict.ContentAssignment.removeClass(this.getSectionSelector(tmpTabSectionHash), this.cssHideClass);
				this.pict.ContentAssignment.addClass(this.getTabSelector(tmpTabSectionHash, tmpInput), this.cssSelectedTabClass);
			}
		}
		tmpView.setDataByInput(tmpInput, pTabViewHash);
		return true;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 *
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getTabSelectorInputHTMLID(pInputHTMLID)
	{
		return `#TAB-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		let tmpTabSet = pInput.PictForm?.TabSectionSet;

		if (!tmpTabSet || !Array.isArray(tmpTabSet) || tmpTabSet.length < 1)
		{
			this.pict.log.error(`TabSelector input provider tried to initialize Tab Group Set for HTML ID [${pInput.Macro.RawHTMLID}] but there were no valid entries in the tmpInput.PictForm.TabSectionSet array!`)
			return false;
		}

		let tmpEntryMetatemplateHash = this.pict.providers.DynamicInput.getInputTemplateHash(pView, { PictForm: { InputType: 'TabSectionSelector-TabElement', DataType: 'String' } });

		let tmpTabSectionSetEntries = '';
		// If there are tab group names, use them, otherwise use the hash
		let tempTabSetNames = pInput.PictForm?.TabSectionNames || [];

		for (let i = 0; i < tmpTabSet.length; i++)
		{
			tmpTabSectionSetEntries += this.pict.parseTemplateByHash(tmpEntryMetatemplateHash, pInput, null, [pView, {TabSectionHash: tmpTabSet[i], TabSectionName: (tempTabSetNames[i] || tmpTabSet[i])}]);
		}

		// TODO: Fix typescript types so this function has an optional rather than required fourth parameter.
		this.pict.ContentAssignment.projectContent('replace', this.getTabSelectorInputHTMLID(pInput.Macro.RawHTMLID), tmpTabSectionSetEntries, 'FixTheTypescriptTypes');

		// Now set the default tab (or first one). Take the first candidate that is actually one of this
		// input's tabs, since selectTabByViewHash refuses anything else: a stored value can name a section
		// since renamed or dropped from the manifest, and DefaultTabSectionHash can simply be a typo.
		const tmpTabCandidates = [];
		if (pInput.PictForm?.DefaultFromData !== false)
		{
			tmpTabCandidates.push(pValue);
		}
		tmpTabCandidates.push(pInput.PictForm?.DefaultTabSectionHash);

		let tmpDefaultTabSectionHash = tmpTabSet[0];
		for (let i = 0; i < tmpTabCandidates.length; i++)
		{
			if (this.isTabInSet(pInput, tmpTabCandidates[i]))
			{
				tmpDefaultTabSectionHash = tmpTabCandidates[i];
				break;
			}
		}

		this.selectTabByViewHash(pView.Hash, pInput.Hash, tmpDefaultTabSectionHash);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599}],624:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * TabularTriggerGroup input provider.
 *
 * This provider enables per-row trigger group behavior in tabular layouts.
 * Unlike the global AutofillTriggerGroup (which fills ALL rows with the same
 * data), this provider fetches entity data scoped to a specific row and only
 * updates inputs within that same row.
 *
 * It combines the entity-fetching capability of EntityBundleRequest with
 * the autofill behavior of AutofillTriggerGroup, but scoped to individual
 * tabular rows.
 *
 * Triggering input configuration:
 *
 *   Providers: ["Pict-Input-TabularTriggerGroup"],
 *   TabularTriggerGroup:
 *     {
 *       TriggerGroupHash: "AuthorRowTrigger",
 *       TriggerAllInputs: true,
 *       EntitiesBundle: [
 *         {
 *           "Entity": "Author",
 *           "Filter": "FBV~IDAuthor~EQ~{~D:Record.Value~}",
 *           "Destination": "CurrentAuthor",
 *           "SingleRecord": true
 *         }
 *       ]
 *     }
 *
 * Receiving input configuration:
 *
 *   Providers: ["Pict-Input-TabularTriggerGroup"],
 *   TabularTriggerGroup:
 *     {
 *       TriggerGroupHash: "AuthorRowTrigger",
 *       TriggerAddress: "CurrentAuthor.Name",
 *       MarshalEmptyValues: true
 *     }
 *
 * The provider stores fetched entity data in a per-row cache at:
 *   AppData._TabularTriggerCache.{TriggerGroupHash}[{RowIndex}]
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class TabularTriggerGroupInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Get the trigger group configuration, normalizing to an array.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @returns {Array<Record<string, any>>}
	 */
	getTriggerGroupConfigurationArray(pInput)
	{
		let tmpConfigs = pInput.PictForm.TabularTriggerGroup;
		if (!tmpConfigs)
		{
			return [];
		}
		if (!Array.isArray(tmpConfigs))
		{
			tmpConfigs = [tmpConfigs];
		}
		return tmpConfigs;
	}

	/**
	 * Ensure the per-row cache structure exists.
	 *
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 * @param {number} pRowIndex - The row index.
	 * @returns {Object} The cache object for this row.
	 */
	ensureRowCache(pTriggerGroupHash, pRowIndex)
	{
		if (!this.pict.AppData._TabularTriggerCache)
		{
			this.pict.AppData._TabularTriggerCache = {};
		}
		if (!this.pict.AppData._TabularTriggerCache[pTriggerGroupHash])
		{
			this.pict.AppData._TabularTriggerCache[pTriggerGroupHash] = {};
		}
		if (!this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex])
		{
			this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex] = {};
		}
		return this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex];
	}

	/**
	 * Gather a single entity set from the server.
	 *
	 * @param {Function} fCallback - Callback when done.
	 * @param {Object} pEntityInfo - The entity bundle entry.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value of the triggering input.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 */
	gatherEntitySet(fCallback, pEntityInfo, pView, pInput, pValue, pRowIndex, pTriggerGroupHash)
	{
		if (!pEntityInfo.Entity || typeof(pEntityInfo.Entity) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Entity string.`);
			return fCallback();
		}
		if (!pEntityInfo.Filter || typeof(pEntityInfo.Filter) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Filter string.`);
			return fCallback();
		}
		if (!pEntityInfo.Destination || typeof(pEntityInfo.Destination) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Destination string.`);
			return fCallback();
		}

		let tmpFilterTemplateRecord = { Value: pValue, Input: pInput, View: pView };
		let tmpFilterString = this.pict.parseTemplate(pEntityInfo.Filter, tmpFilterTemplateRecord);

		if (tmpFilterString === '')
		{
			this.log.warn(`TabularTriggerGroup: entity Filter did not return a string for FilterBy`);
		}

		let tmpRecordStartCursor = null;
		let tmpRecordCount = null;
		if (pEntityInfo.RecordCount)
		{
			tmpRecordStartCursor = pEntityInfo.RecordStartCursor != null ? pEntityInfo.RecordStartCursor : 0;
			tmpRecordCount = pEntityInfo.RecordCount != null ? pEntityInfo.RecordCount : null;
		}

		let tmpCallback = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`TabularTriggerGroup error getting entity set for [${pEntityInfo.Entity}] row ${pRowIndex}: ${pError}`, pError);
				return fCallback(pError);
			}

			this.log.trace(`TabularTriggerGroup found ${pRecordSet.length} records for ${pEntityInfo.Entity} row ${pRowIndex}`);

			let tmpRowCache = this.ensureRowCache(pTriggerGroupHash, pRowIndex);

			if (pEntityInfo.SingleRecord)
			{
				if (pRecordSet.length < 1)
				{
					this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, false);
				}
				else
				{
					this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, pRecordSet[0]);
				}
			}
			else
			{
				this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, pRecordSet);
			}

			return fCallback();
		};

		if (tmpRecordCount)
		{
			this.pict.EntityProvider.getEntitySetPage(pEntityInfo.Entity, tmpFilterString, tmpRecordStartCursor, tmpRecordCount, tmpCallback);
		}
		else
		{
			this.pict.EntityProvider.getEntitySet(pEntityInfo.Entity, tmpFilterString, tmpCallback);
		}
	}

	/**
	 * Gather a custom data set from the server.
	 *
	 * @param {Function} fCallback - Callback when done.
	 * @param {Object} pRequestInfo - The custom request info.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 */
	gatherCustomDataSet(fCallback, pRequestInfo, pView, pInput, pValue, pRowIndex, pTriggerGroupHash)
	{
		if (!pRequestInfo.URL || typeof(pRequestInfo.URL) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse custom request: missing URL string.`);
			return fCallback();
		}

		let tmpURLTemplateRecord = { Value: pValue, Input: pInput, View: pView };
		let tmpURLTemplateString = this.pict.parseTemplate(pRequestInfo.URL, tmpURLTemplateRecord);

		let tmpURLPrefix = '';
		let tmpCustomURIHost = pRequestInfo.Host ? pRequestInfo.Host : false;
		let tmpCustomURIProtocol = pRequestInfo.Protocol ? pRequestInfo.Protocol : 'https';
		let tmpCustomURIPort = pRequestInfo.Port ? pRequestInfo.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.pict.EntityProvider.options.urlPrefix;
		}

		let tmpCallback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`TabularTriggerGroup error getting custom data for row ${pRowIndex}: ${pError}`, pError);
				return fCallback(pError);
			}

			if (pRequestInfo.Destination)
			{
				let tmpRowCache = this.ensureRowCache(pTriggerGroupHash, pRowIndex);
				this.pict.manifest.setValueByHash(tmpRowCache, pRequestInfo.Destination, pData);
			}

			return fCallback();
		};

		let tmpOptions = { url: `${tmpURLPrefix}${tmpURLTemplateString}` };
		tmpOptions = this.pict.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.pict.EntityProvider.restClient.getJSON(tmpOptions, tmpCallback);
	}

	/**
	 * Fetch entity data for a specific tabular row.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {Object} pGroupConfig - The trigger group configuration.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {Promise}
	 */
	async gatherDataForRow(pView, pInput, pValue, pHTMLSelector, pRowIndex, pGroupConfig, pTransactionGUID)
	{
		if (!Array.isArray(pGroupConfig.EntitiesBundle) || pGroupConfig.EntitiesBundle.length < 1)
		{
			this.log.warn(`TabularTriggerGroup: no EntitiesBundle array found for triggering input [${pInput.Hash}] row ${pRowIndex}`);
			return null;
		}

		let tmpTriggerGroupHash = pGroupConfig.TriggerGroupHash;
		let tmpLoadGUID = `TabularBundleLoad-${this.pict.getUUID()}`;

		if (pTransactionGUID)
		{
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpLoadGUID);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		for (let i = 0; i < pGroupConfig.EntitiesBundle.length; i++)
		{
			let tmpEntityBundleEntry = pGroupConfig.EntitiesBundle[i];
			tmpAnticipate.anticipate(
				(fNext) =>
				{
					try
					{
						switch (tmpEntityBundleEntry.Type)
						{
							case 'Custom':
								return this.gatherCustomDataSet(fNext, tmpEntityBundleEntry, pView, pInput, pValue, pRowIndex, tmpTriggerGroupHash);
							case 'MeadowEntity':
							default:
								return this.gatherEntitySet(fNext, tmpEntityBundleEntry, pView, pInput, pValue, pRowIndex, tmpTriggerGroupHash);
						}
					}
					catch (pError)
					{
						this.log.error(`TabularTriggerGroup error gathering entity set for row ${pRowIndex}: ${pError}`, pError);
					}
					return fNext();
				});
		}

		// Ensure we wait at least one tick for event ordering
		tmpAnticipate.anticipate((fNext) => setTimeout(fNext, 0));

		// After all data is gathered, fire the row-scoped trigger event
		tmpAnticipate.anticipate(
			(fNext) =>
			{
				if (this.pict.views.PictFormMetacontroller)
				{
					// Fire row-scoped event: TabularTriggerGroup:{GroupHash}:DataChange:{InputHash}:{RowIndex}:{UUID}
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TabularTriggerGroup:${tmpTriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${pRowIndex}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}

				if (pGroupConfig.PostSolvers && Array.isArray(pGroupConfig.PostSolvers))
				{
					this.pict.providers.DynamicSolver.executeSolvers(pView, pGroupConfig.PostSolvers, `TabularTriggerGroup hash ${tmpTriggerGroupHash} row ${pRowIndex} post-trigger`);
				}

				fNext();
			});

		return new Promise((pResolve, pReject) =>
		{
			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`TabularTriggerGroup error gathering data for row ${pRowIndex}: ${pError}`, pError);
					}
					if (pTransactionGUID)
					{
						pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpLoadGUID);
					}
					return pResolve(pError);
				});
		});
	}

	/**
	 * Autofill a tabular input from the row cache.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {Object} pTriggerGroupInfo - The trigger group configuration.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {boolean}
	 */
	autoFillFromRowCache(pView, pInput, pTriggerGroupInfo, pHTMLSelector, pRowIndex)
	{
		if (!pTriggerGroupInfo.TriggerGroupHash || typeof(pTriggerGroupInfo.TriggerGroupHash) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to autofill: missing TriggerGroupHash string.`);
			return false;
		}
		if (!pTriggerGroupInfo.TriggerAddress || typeof(pTriggerGroupInfo.TriggerAddress) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to autofill: missing TriggerAddress string.`);
			return false;
		}

		let tmpRowCache = this.ensureRowCache(pTriggerGroupInfo.TriggerGroupHash, pRowIndex);
		let tmpValue = this.pict.manifest.getValueByHash(tmpRowCache, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}

		pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpValue);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
		return true;
	}

	/**
	 * Handle data changes in tabular inputs.
	 * If this is a triggering input, fetch data and fire row-scoped event.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpConfigs = this.getTriggerGroupConfigurationArray(pInput);

		for (let i = 0; i < tmpConfigs.length; i++)
		{
			let tmpConfig = tmpConfigs[i];
			if (tmpConfig.TriggerAllInputs)
			{
				if (tmpConfig.PreSolvers && Array.isArray(tmpConfig.PreSolvers))
				{
					this.pict.providers.DynamicSolver.executeSolvers(pView, tmpConfig.PreSolvers, `TabularTriggerGroup hash ${tmpConfig.TriggerGroupHash} row ${pRowIndex} pre-trigger`);
				}

				this.gatherDataForRow(pView, pInput, pValue, pHTMLSelector, pRowIndex, tmpConfig, pTransactionGUID);
			}
		}

		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handle events after completion for tabular inputs.
	 * If this is a receiving input, autofill from the row cache only if the
	 * event's row index matches.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of this input.
	 * @param {string} pEvent - The event string.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {boolean}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		let tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let tmpParts = tmpPayload.split(':');
		// Expected format: TabularTriggerGroup:{GroupHash}:DataChange:{InputHash}:{RowIndex}:{UUID}
		let tmpType = tmpParts[0];
		let tmpGroupHash = tmpParts[1];
		let tmpEventType = tmpParts[2];
		let tmpInputHash = tmpParts[3];
		let tmpEventRowIndex = parseInt(tmpParts[4], 10);

		if (tmpType !== 'TabularTriggerGroup')
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		// Skip if this is the triggering input itself
		if ((pInput.Hash || pInput.DataAddress) === tmpInputHash)
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		// Only process if the row index matches
		if (pRowIndex !== tmpEventRowIndex)
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		let tmpConfigs = this.getTriggerGroupConfigurationArray(pInput);

		for (let i = 0; i < tmpConfigs.length; i++)
		{
			let tmpConfig = tmpConfigs[i];
			if (tmpConfig.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			if (tmpConfig.TriggerAddress)
			{
				this.autoFillFromRowCache(pView, pInput, tmpConfig, pHTMLSelector, pRowIndex);
			}

			if (tmpConfig.SelectOptionsRefresh)
			{
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				if (tmpInputView && pInput.PictForm.SelectOptionsPickList)
				{
					this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
					this.pict.providers['Pict-Input-Select'].refreshSelectListTabular(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector, pRowIndex);
					tmpInputView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
				}
			}
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Non-tabular data change handler.
	 * TabularTriggerGroup is designed for tabular use, but we support non-tabular
	 * as a pass-through for flexibility.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Non-tabular event handler.
	 * TabularTriggerGroup events are scoped to tabular, so non-tabular events
	 * are ignored.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = TabularTriggerGroupInputHandler;

module.exports.default_configuration = (
{
	"ProviderIdentifier": "Pict-Input-TabularTriggerGroup",
	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

},{"../Pict-Provider-InputExtension.js":599}],625:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * Input provider for simple templated content display.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class TemplatedInputProvider extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {number} [pRowIndex] - (optional) The row index for tabular data.
	 *
	 * @return {void}
	 */
	handleContentUpdate(pView, pInput, pValue, pRowIndex)
	{
		let tmpContent = '';
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		let tmpIsLocked = false;
		//TODO: support more templates
		//TODO: support "locked" content?
		if (!tmpIsLocked && pInput.PictForm && pInput.PictForm.Template && (typeof(pInput.PictForm.Template) === 'string'))
		{
			tmpContent = this.pict.parseTemplate(pInput.PictForm.Template, Object.assign({}, this.pict, { Data: pView.getMarshalDestinationObject() }), null, [this], this);
		}
		if (!tmpContent && !tmpIsLocked && pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (pRowIndex != null)
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpContent);
		}
		else
		{
			pView.setDataByInput(pInput, tmpContent);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, null, pTransactionGUID);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleInitialize(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object|null} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number|null} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	_handleInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm && pInput.PictForm.Templates && typeof pInput.PictForm.Templates === 'object' && !Array.isArray(pInput.PictForm.Templates))
		{
			for (const [ tmpTemplateHash, tmpTemplate ] of Object.entries(pInput.PictForm.Templates))
			{
				if (this.pict.TemplateProvider.templates[tmpTemplateHash])
				{
					this.pict.log.error(`[Pict-Input-Templated] Attempt to override template with hash: ${tmpTemplateHash}; skipping.`);
					continue;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpTemplate, `Templated Input hash: ${pInput.Hash}`);
			}
		}
		this.handleContentUpdate(pView, pInput, pValue);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup')
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}

		const tmpTriggerGroupHashes = Array.isArray(pInput.PictForm?.TriggerGroupHash) ? pInput.PictForm.TriggerGroupHash : [pInput.PictForm?.TriggerGroupHash];
		if (!pInput.PictForm || !pInput.PictForm.TriggerGroupHash || !tmpTriggerGroupHashes.includes(tmpGroupHash))
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		this.handleContentUpdate(pView, pInput, pValue);
		pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup')
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		const tmpTriggerGroupHashes = Array.isArray(pInput.PictForm?.TriggerGroupHash) ? pInput.PictForm.TriggerGroupHash : [pInput.PictForm?.TriggerGroupHash];
		if (!pInput.PictForm || !pInput.PictForm.TriggerGroupHash || !tmpTriggerGroupHashes.includes(tmpGroupHash))
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		this.handleContentUpdate(pView, pInput, pValue, pRowIndex);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = TemplatedInputProvider;

},{"../Pict-Provider-InputExtension.js":599}],626:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * 
	 * @param {String} pDisplayID 
	 * @param {Object} pInput - The PictForm Input Object
	 * @param {any} pValue 
	 */
	assignDisplayEntityData(pDisplayID, pInput, pValue)
	{
		// 0. Manage state
		let tmpDisplayTemplate = (typeof(pInput.PictForm.TemplatedEntityLookup.Template) === "string") ? pInput.PictForm.TemplatedEntityLookup.Template : "";
		let tmpDisplayContent = '';

		if (typeof(pInput) != "object")
		{
			this.log.error("Error in assignDisplayEntityData: pInput is not an object");
			return;
		}
		if (!(`PictForm` in pInput))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm is not an object");
			return;
		}
		if (!(`TemplatedEntityLookup` in pInput.PictForm))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm.TemplatedEntityLookup is not in the PictForm object");
			return;
		}
		if (!Array.isArray(pInput.PictForm.TemplatedEntityLookup.EntitiesBundle))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm.TemplatedEntityLookup.EntitiesBundle is not an array");
			return;
		}

		const tmpAnticipate = this.fable.newAnticipate();

		// 1. Get the entities
		tmpAnticipate.anticipate(
			function (fNext)
			{
				this.pict.EntityProvider.gatherDataFromServer(pInput.PictForm.TemplatedEntityLookup.EntitiesBundle, (pError) =>
				{
					// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
					setTimeout(() => fNext(pError), 0);
				});
			}.bind(this));

		// 2. Check the Empty Value Test List

		// 3. Render the Template
		tmpAnticipate.anticipate(
			function (fNext)
			{
				this.pict.parseTemplate(tmpDisplayTemplate, {Value: pValue},
					function (pError, pResult)
					{
						if (pError)
						{
							this.log.error("Error rendering template in assignDisplayEntityData", pError);
							return;
						}
						tmpDisplayContent = pResult;
						return fNext();
					}.bind(this));
			}.bind(this));

		// 4. Assign the Content to the display element
		tmpAnticipate.wait(
			function (pError)
			{
				if (pError)
				{
					this.log.error("Error in assignDisplayEntityData", pError);
					return;
				}
				this.pict.ContentAssignment.assignContent(pDisplayID, tmpDisplayContent);
			}.bind(this));
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.assignDisplayEntityData(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.assignDisplayEntityData(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput, pValue);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.TemplatedEntityLookup || !('TriggerGroupHash' in pInput.PictForm.TemplatedEntityLookup))
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = [pInput.PictForm.TemplatedEntityLookup];

		for (let i = 0; i < tmpAutoFillTriggerGroups.length; i++)
		{
			let tmpAutoFillTriggerGroup = tmpAutoFillTriggerGroups[i];
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			this.assignDisplayEntityData(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pInput, pValue);
		}

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.TemplatedEntityLookup || !('TriggerGroupHash' in pInput.PictForm.TemplatedEntityLookup))
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = [pInput.PictForm.TemplatedEntityLookup];
		for (const tmpAutoFillTriggerGroup of tmpAutoFillTriggerGroups)
		{
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			this.assignDisplayEntityData(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput, pValue);
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":599,"marked":585}],627:[function(require,module,exports){
/**
 * Themeify-SVG.js
 *
 * Rewrite an exported Excalidraw SVG so its palette colors become CSS custom
 * properties with hex fallbacks:
 *
 *     stroke="#1B1F23"  ->  stroke="var(--diagram-ink, #1B1F23)"
 *
 * With no variables set, the hex fallback renders the original look, so the
 * SVG is correct standalone (in an <img>, a file viewer, etc.). When an
 * embedder that inlines the SVG sets `--diagram-ink` and the other tokens
 * per active theme, the same single SVG adapts live, light/dark.
 *
 * The embedded <metadata> block (base64 Excalidraw scene) is protected and
 * left byte-for-byte intact so the scene still round-trips into
 * pict-section-excalidraw for hand-editing.
 *
 * Token names (all under the --diagram- namespace):
 *   ink, paper, accent, highlight, deemphasis, link
 *
 * This file mirrors the canonical implementation at
 * `pict-renderer-graph/source/Pict-Renderer-Graph-Theme-SVG.js`. The two are
 * kept in sync by hand. If you edit the regex pass here, update the other.
 * The reason for the duplication: this section module renders directly into
 * a browser DOM, and we don't want to pull pict-renderer-graph (which spins
 * up Chromium) in as a runtime dependency.
 */

const _PaletteTokens = ['ink', 'paper', 'accent', 'highlight', 'deemphasis', 'link'];

// The default Excalidraw notebook palette we map TO theme tokens. Callers can
// pass their own palette via the second arg; this is the fallback so callers
// who just want the standard mapping don't have to specify anything.
const _DefaultPalette =
{
	ink:        '#1B1F23',
	paper:      '#FDFCF7',
	accent:     '#E66C2C',
	highlight:  '#FFD966',
	deemphasis: '#A0A0A0',
	link:       '#2E7D74'
};

function escapeRegExp(pStr)
{
	return pStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Rewrite the palette colors in an SVG to CSS variables with hex fallbacks.
 *
 * @param {string} pSVG - The exported SVG string.
 * @param {object} [pPaletteOrProfile] - Either a flat palette
 *   `{ink, paper, accent, ...}` OR a style profile carrying `.Palette`. When
 *   omitted, the standard notebook palette is used.
 * @returns {string} The SVG with palette colors rewritten to CSS variables.
 */
function themeifySVG(pSVG, pPaletteOrProfile)
{
	if (typeof pSVG !== 'string')
	{
		return pSVG;
	}

	let tmpPalette = _DefaultPalette;
	if (pPaletteOrProfile && typeof pPaletteOrProfile === 'object')
	{
		// Accept either a profile-shaped object (has .Palette) or a bare palette.
		tmpPalette = pPaletteOrProfile.Palette || pPaletteOrProfile;
	}

	// Protect the metadata block — it carries the embedded scene verbatim.
	let tmpMetaMatch   = pSVG.match(/<metadata[\s\S]*?<\/metadata>/i);
	let tmpMeta        = tmpMetaMatch ? tmpMetaMatch[0] : '';
	let tmpPlaceholder = ' PICT-SECTION-EXCALIDRAW-METADATA ';
	let tmpBody        = tmpMeta ? pSVG.replace(tmpMeta, tmpPlaceholder) : pSVG;

	for (let i = 0; i < _PaletteTokens.length; i++)
	{
		let tmpToken = _PaletteTokens[i];
		let tmpHex   = tmpPalette[tmpToken];
		if ((typeof tmpHex !== 'string') || !/^#[0-9a-fA-F]{6}$/.test(tmpHex))
		{
			continue;
		}
		// Match the hex only where it's used as a color: a stroke= / fill=
		// attribute, or a stroke: / fill: inside a style string. The property
		// must be immediately followed by =" or : so we never catch
		// "strokeColor" in the source JSON (followed by ").
		let tmpRegExp = new RegExp('(stroke|fill)(="|:\\s*)(' + escapeRegExp(tmpHex) + ')(?=["\\s;)])', 'gi');
		tmpBody = tmpBody.replace(tmpRegExp, (pWhole, pProp, pSep, pHex) =>
		{
			return pProp + pSep + 'var(--diagram-' + tmpToken + ', ' + pHex + ')';
		});
	}

	return tmpMeta ? tmpBody.replace(tmpPlaceholder, tmpMeta) : tmpBody;
}

module.exports =
{
	themeifySVG:    themeifySVG,
	paletteTokens:  _PaletteTokens,
	defaultPalette: _DefaultPalette
};

},{}],628:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class ChartLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a Configuration-based Chart.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		// Chart Parameters!!!
		tmpTemplate += 'No really... this is a chart.';
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = ChartLayout;

},{"../Pict-Provider-DynamicLayout.js":592}],629:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		pGroup.Rows.sort((rowA, rowB) =>
		{
			if (rowA.RowNumber && rowB.RowNumber)
			{
				return rowA.RowNumber >= rowB.RowNumber ? 1 : -1;
			}
			if (!rowA.RowNumber && !rowB.RowNumber)
			{
				return rowA.Hash >= rowB.Hash ? 1 : -1;
			}
			return rowA.RowNumber ? 1 : -1;
		});

		// loop over descriptors that have my group set?
		// set their GroupIndex from pGroup
		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			let tmpRow = pGroup.Rows[j];

			// There are three row layouts: Record, Tabular and Columnar
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;
			}
		}
		const hash = pGroup.CustomLayoutTemplateHash;
		if (hash)
		{
			const template = this.pict.TemplateProvider.getTemplate(hash);
			if (template)
			{
				return template;
			}
			this.log.warn(`Custom layout template not found for hash: ${hash}`);
		}
		return pGroup.CustomLayoutTemplate || '';
	}
}

module.exports = RecordLayout;

},{"../Pict-Provider-DynamicLayout.js":592}],630:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {Array<(pInput: any) => boolean>} */
		this.layoutExcludedInputChecks = [];
	}

	/**
	 * Register a check that marks an input as taking no width in its row. An excluded
	 * input gets `PictForm.LayoutExcluded = true` and a QuantizedWidth of 0, and the
	 * other inputs in the row share its space.
	 *
	 * @param {(pInput: any) => boolean} fCheck - returns true when the input takes no width
	 */
	registerLayoutExcludedInputCheck(fCheck)
	{
		if ((typeof fCheck === 'function') && !this.layoutExcludedInputChecks.includes(fCheck))
		{
			this.layoutExcludedInputChecks.push(fCheck);
		}
	}

	/**
	 * @param {any} pInput
	 * @returns {boolean} - true when any registered check excludes the input from row width
	 */
	isLayoutExcludedInput(pInput)
	{
		for (let i = 0; i < this.layoutExcludedInputChecks.length; i++)
		{
			if (this.layoutExcludedInputChecks[i](pInput))
			{
				return true;
			}
		}
		return false;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		pGroup.Rows.sort((rowA, rowB) =>
		{
			if (rowA.RowNumber && rowB.RowNumber)
			{
				return rowA.RowNumber >= rowB.RowNumber ? 1 : -1;
			}
			if (!rowA.RowNumber && !rowB.RowNumber)
			{
				return rowA.Hash >= rowB.Hash ? 1 : -1;
			}
			return rowA.RowNumber ? 1 : -1;
		});

		if (!('Rows' in pGroup))
		{
			pGroup.Rows = [];
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			// TODO: Validate that the row exists?  Bootstrap seems to have it here.
			let tmpRow = pGroup.Rows[j]
			tmpRow.WidthTotalRaw = 0;

			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;
				let tmpInputWidth = 1;
				try
				{
					tmpInputWidth = Math.abs(parseFloat(tmpInput.PictForm.Width));
				}
				catch (pParseError)
				{
					tmpInputWidth = 1;
				}
				if (!tmpInputWidth || isNaN(tmpInputWidth) || tmpInputWidth <= 0)
				{
					tmpInputWidth = 1;
				}
				let tmpInputWidthOffset = Math.abs(parseFloat(tmpInput.PictForm.WidthOffset));
				if (!tmpInputWidthOffset || isNaN(tmpInputWidthOffset))
				{
					tmpInputWidthOffset = 0;
				}
				tmpInput.PictForm.LayoutExcluded = this.isLayoutExcludedInput(tmpInput);
				if (tmpInput.PictForm.LayoutExcluded)
				{
					tmpInputWidth = 0;
					tmpInputWidthOffset = 0;
				}
				tmpInput.PictForm.RawWidth = tmpInputWidth;
				tmpInput.PictForm.RawWidthOffset = tmpInputWidthOffset;
				tmpRow.WidthTotalRaw += tmpInputWidth + tmpInputWidthOffset;

				//tmpTemplate += tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}
			// Now that we've gotten all the raw widths for the row, quantize them properly.
			// Default by quantizing to 99 percentage units wide
			let tmpGroupQuantizedWidth = 95;
			if ('WidthQuantization' in pGroup)
			{
				try
				{
					tmpGroupQuantizedWidth = Math.abs(parseInt(pGroup.WidthQuantization));
					if (!tmpGroupQuantizedWidth || isNaN(tmpGroupQuantizedWidth) || tmpGroupQuantizedWidth <= 0)
					{
						tmpGroupQuantizedWidth = 95;
					}
				}
				catch(pParseError)
				{
					// TODO: UGH THIS IS NaN at the moment.......
					tmpGroupQuantizedWidth = 95;
				}
			}
			else if ('WidthQuantization' in this.pict.PictApplication.options)
			{
				tmpGroupQuantizedWidth = this.pict.PictApplication.options.WidthQuantization;
			}
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				if (tmpRow.WidthTotalRaw > 0)
				{
					tmpInput.PictForm.QuantizedWidth = Math.round((tmpInput.PictForm.RawWidth / tmpRow.WidthTotalRaw) * tmpGroupQuantizedWidth);
					tmpInput.PictForm.QuantizedWidthOffset = Math.round((tmpInput.PictForm.RawWidthOffset / tmpRow.WidthTotalRaw) * tmpGroupQuantizedWidth);
				}
				else
				{
					tmpInput.PictForm.QuantizedWidth = 0;
					tmpInput.PictForm.QuantizedWidthOffset = 0;
				}
				//this.fable.log.trace(`Quantized input width for Group ${pGroup.GroupIndex} Row ${j} Input ${k} (${tmpInput.Name}) to ${tmpInput.PictForm.QuantizedWidth} (Raw: ${tmpInput.PictForm.RawWidth} / Total Raw: ${tmpRow.WidthTotalRaw} / Group Quantization: ${tmpGroupQuantizedWidth})`);

				tmpTemplate += tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}

			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = RecordLayout;

},{"../Pict-Provider-DynamicLayout.js":592}],631:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordSetLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a complex multi-record repeated form view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such, only, it will render itself once for each element in a set.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// TODO: We cheated and this is still tabular.  Gotta change it up!
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';
		let tmpTemplateSetRecordRowTemplate = '';
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		let tmpMaxRowIndex = 0;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			if (tmpInput.PictForm.Row)
			{
				tmpInput.PictForm.RowIndex = tmpInput.PictForm.Row;
				if (tmpInput.PictForm.RowIndex > tmpMaxRowIndex)
				{
					tmpMaxRowIndex = tmpInput.PictForm.RowIndex;
				}
			}
		}

		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			if (!tmpInput.PictForm.RowIndex)
			{
				tmpInput.PictForm.RowIndex = tmpMaxRowIndex + 1;
			}
		}

		for (let d = 0; d < tmpMaxRowIndex + 1; d++)
		{
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
				// Update the InputIndex to match the current render config
				if (tmpInput.PictForm.TabularHidden)
				{
					continue;
				}

				// tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-HeaderCell`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				if (tmpInput.PictForm.RowIndex == d)
				{
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Cell-Prefix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
					let tmpInputType = (('PictForm' in tmpInput) && tmpInput.PictForm.InputType) ? tmpInput.PictForm.InputType : 'Default';
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInputType, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`, pGroup.GroupIndex, k);
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Cell-Postfix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				}
			}
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}

		// This is the template by which the tabular template includes the rows.
		// The template recursion here is difficult to envision without drawing it.
		// TODO: Consider making this function available in manyfest in some fashion it seems dope.
		let tmpTemplateSetVirtualRowTemplate = '';
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-RecordSetTemplate-Row-ExtraPrefix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += `\n\n{~T:${pGroup.SectionTabularRowTemplateHash}:Record~}\n`;
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-RecordSetTemplate-Row-ExtraPostfix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// This is a custom template expression
		tmpTemplate += `\n\n{~MTVS:${pGroup.SectionTabularRowVirtualTemplateHash}:${pGroup.GroupIndex}:${pView.getMarshalDestinationAddress()}.${pGroup.RecordSetAddress}~}\n`;

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		// Add the TemplateSetTemplate
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowVirtualTemplateHash, tmpTemplateSetVirtualRowTemplate);
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowTemplateHash, tmpTemplateSetRecordRowTemplate);

		return tmpTemplate;
	}
}

module.exports = RecordSetLayout;

},{"../Pict-Provider-DynamicLayout.js":592}],632:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

// The resolved --theme-color-* tokens carried onto a column-chooser popover when it is portaled to
// <body>: off its scoped container it would otherwise fall back to the stylesheet's hex defaults.
// Mirrors pict-section-picker's PictView-Picker `_THEME_TOKENS`.
const _COLCHOOSER_THEME_TOKENS =
[
	'--theme-color-text-primary', '--theme-color-text-secondary', '--theme-color-text-muted',
	'--theme-color-border-default', '--theme-color-border-light', '--theme-color-background-panel',
	'--theme-color-background-tertiary',
];

class TabularLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		// Register the sort glyphs used by the optional ColumnSorting feature, through
		// pict's built-in icon registry (so they theme + scale like every other glyph).
		if (this.pict && this.pict.providers && this.pict.providers.Icon
			&& typeof this.pict.providers.Icon.registerSet === 'function')
		{
			this.pict.providers.Icon.registerSet(
				{
					Outline:
					{
						Sort: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 20V5"/><path d="M5.5 8.5L9 5L12.5 8.5"/><path d="M15 4V19"/><path d="M11.5 15.5L15 19L18.5 15.5"/></svg>',
						SortAscending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V5"/><path d="M6 11L12 5L18 11"/></svg>',
						SortDescending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4V19"/><path d="M6 13L12 19L18 13"/></svg>'
					}
				});
		}

		// CSS for the clickable sort control. Inactive glyphs are faded; the
		// actively-sorted column's glyph is full opacity.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Layout-Tabular-Sort-CSS',
				'.pict-tabular-sort-control { cursor: pointer; display: inline-flex; vertical-align: middle; margin-left: 0.3em; opacity: 0.4; }'
				+ ' .pict-tabular-sort-control:hover { opacity: 0.75; }'
				+ ' .pict-tabular-sort-control.pict-tabular-sort-asc, .pict-tabular-sort-control.pict-tabular-sort-desc { opacity: 1; }',
				500);

			// CSS for the optional ColumnChooser feature: a right-aligned trigger button above the
			// table plus a checkbox popover. Anchored the same listener-free way as pict-section-picker:
			// the popover is position:absolute under the (position:relative) bar so it rides page scroll
			// for free, and is portaled to <body> in DOCUMENT coords only when a clipping ancestor would
			// otherwise cut it -- no scroll/resize handlers. The transparent backdrop catches outside
			// clicks. Dark-mode blocks (below, with DARK var() fallbacks) let the widget theme correctly
			// even where the host has not defined the --theme-color-* tokens; a host that HAS defined
			// them still wins, and the token values are carried across when the popover is portaled.
			let tmpColumnChooserBaseCSS = /*css*/`
	.pict-tabular-colchooser-bar { position: relative; display: flex; justify-content: flex-end; margin: 0 0 0.35rem; }
	.pict-tabular-colchooser-trigger { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.88rem;
		padding: 0.3rem 0.65rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px;
		background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
	.pict-tabular-colchooser-trigger:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
	.pict-tabular-colchooser-count { font-size: 0.8em; color: var(--theme-color-text-muted, #6b7686); }
	.pict-tabular-colchooser-pop { position: absolute; top: calc(100% + 6px); right: 0; z-index: 30; min-width: 220px; max-width: 320px; display: none; }
	.pict-tabular-colchooser-pop.open { display: block; }
	.pict-tabular-colchooser-pop.pict-tabular-colchooser-pop-portal { right: auto; }
	.pict-tabular-colchooser-backdrop { position: fixed; inset: 0; z-index: 0; }
	.pict-tabular-colchooser-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(70vh, 420px);
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
		border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
	.pict-tabular-colchooser-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem 0; }
	.pict-tabular-colchooser-row { display: flex; align-items: center; gap: 0.5rem; font-size: 0.9rem; cursor: pointer;
		padding: 0.32rem 0.8rem; color: var(--theme-color-text-primary, #1f2733); }
	.pict-tabular-colchooser-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
	.pict-tabular-colchooser-row input { flex: 0 0 auto; margin: 0; cursor: pointer; }
	.pict-tabular-colchooser-footer { flex: 0 0 auto; display: flex; justify-content: flex-end; padding: 0.45rem 0.7rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.pict-tabular-colchooser-reset { font: inherit; font-size: 0.84rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
	.pict-tabular-colchooser-reset:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eceef2); }
`;
			// Dark-mode overrides: re-declare only the color-bearing rules with DARK var() fallbacks under
			// each of the app's dark signals. Duplicated per selector (explicit [data-theme=dark] and
			// .theme-dark, plus the system preference guarded by html:not([data-theme=light]) so an
			// explicit light choice still wins) exactly as headlight-styles' bulma-*.scss does. Higher
			// specificity than the base rules, so dark wins whenever its selector matches; the [data-theme]
			// signal lives on <html>, so these still apply after a popover is portaled to <body>.
			let fColumnChooserDarkRules = (pScope) => /*css*/`
	${pScope} .pict-tabular-colchooser-trigger { border-color: var(--theme-color-border-default, #3a4250); background: var(--theme-color-background-panel, #242b36); color: var(--theme-color-text-secondary, #c3cad4); }
	${pScope} .pict-tabular-colchooser-trigger:hover { background: var(--theme-color-background-tertiary, #2c3542); color: var(--theme-color-text-primary, #e6e9ee); }
	${pScope} .pict-tabular-colchooser-count { color: var(--theme-color-text-muted, #8b95a4); }
	${pScope} .pict-tabular-colchooser-panel { background: var(--theme-color-background-panel, #242b36); border-color: var(--theme-color-border-default, #3a4250); }
	${pScope} .pict-tabular-colchooser-row { color: var(--theme-color-text-primary, #e6e9ee); }
	${pScope} .pict-tabular-colchooser-row:hover { background: var(--theme-color-background-tertiary, #2c3542); }
	${pScope} .pict-tabular-colchooser-footer { border-top-color: var(--theme-color-border-light, #333b47); }
	${pScope} .pict-tabular-colchooser-reset { color: var(--theme-color-text-muted, #8b95a4); }
	${pScope} .pict-tabular-colchooser-reset:hover { color: var(--theme-color-text-primary, #e6e9ee); background: var(--theme-color-background-tertiary, #2c3542); }
`;
			this.pict.CSSMap.addCSS('Pict-Layout-Tabular-ColumnChooser-CSS',
				tmpColumnChooserBaseCSS
				+ fColumnChooserDarkRules('[data-theme="dark"]')
				+ fColumnChooserDarkRules('.theme-dark')
				+ `@media (prefers-color-scheme: dark) {` + fColumnChooserDarkRules('html:not([data-theme="light"])') + `}`,
				500);
		}
	}

	/**
	 * Builds one prime-header `<th>` with an injected, clickable sort control
	 * `<span>` carrying the sort SVG glyph. Used when the group has
	 * `ColumnSorting: true`. The glyph reflects the current sort state of the
	 * column (neutral / ascending / descending).
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pDescriptor - The column's descriptor.
	 * @param {number} pColumnIndex - The descriptor's InputIndex.
	 * @returns {string}
	 */
	_buildSortableHeaderCell(pView, pGroup, pDescriptor, pColumnIndex)
	{
		let tmpSortState = pGroup._SortState || { ColumnIndex: -1, Direction: 'none' };
		let tmpIsActive = (tmpSortState.ColumnIndex === pColumnIndex) && (tmpSortState.Direction !== 'none');
		let tmpIconName = 'Sort';
		let tmpStateClass = 'pict-tabular-sort-none';
		if (tmpIsActive && tmpSortState.Direction === 'asc')
		{
			tmpIconName = 'SortAscending';
			tmpStateClass = 'pict-tabular-sort-asc';
		}
		else if (tmpIsActive && tmpSortState.Direction === 'desc')
		{
			tmpIconName = 'SortDescending';
			tmpStateClass = 'pict-tabular-sort-desc';
		}
		let tmpGlyph = (typeof this.pict.icon === 'function') ? this.pict.icon(tmpIconName) : '';
		// Resolve the column label through a metatemplate reference (not a baked
		// literal) so it re-resolves on every render -- this keeps the sortable
		// header in lock-step with the descriptor Name the same way the default
		// (non-sorting) header does. The sort-control glyph/state below is baked,
		// which is fine: it only changes on a sort click, which rebuilds anyway.
		let tmpLabelReference = this.pict.providers.MetatemplateGenerator.getMetatemplateTemplateReference(
			pView, `-TabularTemplate-HeaderCellLabel`, `getTabularRecordInput("${pGroup.GroupIndex}","${pColumnIndex}")`);
		return `\n\t\t\t\t\t\t<th data-tabular-column-index="${pColumnIndex}">${tmpLabelReference} `
			+ `<span class="pict-tabular-sort-control ${tmpStateClass}" `
			+ `onclick="_Pict.providers['Pict-Layout-Tabular'].sortTabularColumn('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumnIndex})">`
			+ `${tmpGlyph}</span></th>\n`;
	}

	/**
	 * Resolves one row's value for a column descriptor. Dynamic columns store
	 * their value at the descriptor's InformaryDataAddress (a nested path);
	 * static columns resolve by hash.
	 *
	 * @param {Object} pGroup
	 * @param {Object} pDescriptor
	 * @param {Object} pRecord
	 * @returns {any}
	 */
	_getTabularCellValue(pGroup, pDescriptor, pRecord)
	{
		if (!pDescriptor || !pRecord || !pGroup.supportingManifest)
		{
			return undefined;
		}
		let tmpKey = (pDescriptor.PictForm && typeof pDescriptor.PictForm.InformaryDataAddress === 'string'
			&& pDescriptor.PictForm.InformaryDataAddress.length > 0)
			? pDescriptor.PictForm.InformaryDataAddress
			: pDescriptor.Hash;
		try
		{
			return pGroup.supportingManifest.getValueByHash(pRecord, tmpKey);
		}
		catch (pError)
		{
			return undefined;
		}
	}

	/**
	 * Comparator for tabular sort. Numeric when both values parse as numbers,
	 * otherwise a locale string comparison. Null/undefined sort as empty.
	 *
	 * @param {any} pValueA
	 * @param {any} pValueB
	 * @returns {number}
	 */
	_compareTabularValues(pValueA, pValueB)
	{
		let tmpA = (pValueA == null) ? '' : pValueA;
		let tmpB = (pValueB == null) ? '' : pValueB;
		let tmpNumberA = Number(tmpA);
		let tmpNumberB = Number(tmpB);
		if ((tmpA !== '') && (tmpB !== '') && !isNaN(tmpNumberA) && !isNaN(tmpNumberB))
		{
			if (tmpNumberA < tmpNumberB) { return -1; }
			if (tmpNumberA > tmpNumberB) { return 1; }
			return 0;
		}
		return String(tmpA).localeCompare(String(tmpB));
	}

	/**
	 * Inline-handler entry point: sorts a tabular group's record set by a column.
	 * A fresh column starts ascending; clicking the active column toggles
	 * ascending -> descending. Rebuilds so the header glyph re-bakes, then
	 * re-renders and re-marshals.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex
	 * @returns {boolean}
	 */
	sortTabularColumn(pViewHash, pGroupIndex, pColumnIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || tmpGroup.ColumnSorting !== true)
		{
			return false;
		}
		let tmpColumnIndex = Number(pColumnIndex);
		if (isNaN(tmpColumnIndex) || tmpColumnIndex < 0)
		{
			return false;
		}

		// Cycle the direction: a new column starts ascending, the active column toggles.
		if (!tmpGroup._SortState)
		{
			tmpGroup._SortState = { ColumnIndex: -1, Direction: 'none' };
		}
		if (tmpGroup._SortState.ColumnIndex === tmpColumnIndex && tmpGroup._SortState.Direction === 'asc')
		{
			tmpGroup._SortState.Direction = 'desc';
		}
		else
		{
			tmpGroup._SortState.ColumnIndex = tmpColumnIndex;
			tmpGroup._SortState.Direction = 'asc';
		}

		// Resolve the descriptor + record set and sort the record set in place.
		let tmpDescriptor = null;
		if (tmpGroup.supportingManifest && Array.isArray(tmpGroup.supportingManifest.elementAddresses))
		{
			let tmpHash = tmpGroup.supportingManifest.elementAddresses[tmpColumnIndex];
			tmpDescriptor = tmpGroup.supportingManifest.elementDescriptors[tmpHash];
		}
		let tmpRecordSet = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		if (tmpDescriptor && Array.isArray(tmpRecordSet))
		{
			let tmpDirection = (tmpGroup._SortState.Direction === 'desc') ? -1 : 1;
			tmpRecordSet.sort((pRecordA, pRecordB) =>
			{
				return this._compareTabularValues(
					this._getTabularCellValue(tmpGroup, tmpDescriptor, pRecordA),
					this._getTabularCellValue(tmpGroup, tmpDescriptor, pRecordB)) * tmpDirection;
			});
		}

		// Rebuild so the header re-bakes with the updated glyph, then re-render + marshal.
		tmpView.rebuildCustomTemplate();
		tmpView.render();
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			tmpView.marshalToView();
		}
		return true;
	}

	/**
	 * Resolve a template string against a record. Returns '' on failure.
	 *
	 * @param {string} pTemplate
	 * @param {Object} pRecord
	 * @returns {string}
	 */
	_parseTabularTemplate(pTemplate, pRecord)
	{
		if (typeof pTemplate !== 'string')
		{
			return '';
		}
		if (pTemplate.indexOf('{') === -1)
		{
			return pTemplate;
		}
		try
		{
			let tmpResult = this.pict.parseTemplate(pTemplate, pRecord, null);
			return (typeof tmpResult === 'string') ? tmpResult : '';
		}
		catch (pError)
		{
			this.log.warn(`PICT Form Tabular template parse failed: ${pError && pError.message}`);
			return '';
		}
	}

	/**
	 * Build the expanded Headers config for a group.
	 *
	 * Returns the user-provided pGroup.Headers (each row = array of cells) plus
	 * a synthesized "header group" row prepended at the front when any DynamicColumns
	 * generator declares a HeaderGroupTemplate. The synthesized row clusters
	 * consecutive descriptors with the same _DynamicColumnHeaderGroup value into
	 * a single cell with ColumnSpan.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Array<Array<{Label: string, ColumnSpan: number, CSSClass: string}>>}
	 */
	_buildExpandedHeadersConfig(pView, pGroup)
	{
		let tmpExpanded = [];

		// When the column chooser has hidden columns, each user-provided header
		// cell's ColumnSpan shrinks by the hidden columns it covers (cells reduced
		// to zero drop out), so the stacked headers stay aligned with the columns
		// that actually render. The spans partition the configured (non-
		// TabularHidden) data columns in manifest order — same contract the
		// span-total warning in generateGroupLayoutTemplate enforces.
		let tmpChooserHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		let tmpConfiguredColumnVisibility = [];
		if (tmpChooserHiddenSet && pGroup.supportingManifest && Array.isArray(pGroup.supportingManifest.elementAddresses))
		{
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
				if (!tmpDescriptor || (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden))
				{
					continue;
				}
				tmpConfiguredColumnVisibility.push(!tmpChooserHiddenSet.has(String(pGroup.supportingManifest.elementAddresses[k])));
			}
		}

		// Render user-provided Headers config first (at the top of the table).
		if (Array.isArray(pGroup.Headers))
		{
			for (let r = 0; r < pGroup.Headers.length; r++)
			{
				let tmpRowConfig = pGroup.Headers[r];
				if (!Array.isArray(tmpRowConfig))
				{
					continue;
				}
				let tmpNormalizedRow = [];
				// Walks the configured-column visibility list as spans consume columns.
				let tmpColumnCursor = 0;
				for (let c = 0; c < tmpRowConfig.length; c++)
				{
					let tmpCell = tmpRowConfig[c];
					if (!tmpCell || typeof tmpCell !== 'object')
					{
						continue;
					}
					let tmpColumnSpan = (Number(tmpCell.ColumnSpan) > 0) ? Number(tmpCell.ColumnSpan) : 1;
					if (tmpChooserHiddenSet)
					{
						let tmpVisibleSpan = 0;
						for (let s = 0; s < tmpColumnSpan; s++)
						{
							// Columns past the configured set keep their span (the
							// misalignment warning will already have fired for that).
							if ((tmpColumnCursor >= tmpConfiguredColumnVisibility.length) || tmpConfiguredColumnVisibility[tmpColumnCursor])
							{
								tmpVisibleSpan++;
							}
							tmpColumnCursor++;
						}
						if (tmpVisibleSpan === 0)
						{
							continue;
						}
						tmpColumnSpan = tmpVisibleSpan;
					}
					tmpNormalizedRow.push({
						Label: (typeof tmpCell.Label === 'string') ? tmpCell.Label : '',
						ColumnSpan: tmpColumnSpan,
						CSSClass: (typeof tmpCell.CSSClass === 'string') ? tmpCell.CSSClass : ''
					});
				}
				tmpExpanded.push(tmpNormalizedRow);
			}
		}

		// Then synthesize a clustered super-header row from any DynamicColumns generator
		// that declared a HeaderGroupTemplate. This row sits JUST ABOVE the default
		// column-name row so the visual cluster lines up with the columns it groups.
		// Walk the supportingManifest in order and group adjacent descriptors that
		// share both _DynamicColumnGeneratorIndex and _DynamicColumnHeaderGroup; static
		// descriptors get blank "spacer" cells.
		let tmpHasHeaderGroups = false;
		if (Array.isArray(pGroup.DynamicColumns))
		{
			for (let g = 0; g < pGroup.DynamicColumns.length; g++)
			{
				if (pGroup.DynamicColumns[g] && pGroup.DynamicColumns[g].HeaderGroupTemplate)
				{
					tmpHasHeaderGroups = true;
					break;
				}
			}
		}
		if (tmpHasHeaderGroups && pGroup.supportingManifest)
		{
			let tmpSynthRow = [];
			let tmpCurrentRun = null;
			let tmpAddresses = pGroup.supportingManifest.elementAddresses;
			for (let k = 0; k < tmpAddresses.length; k++)
			{
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpAddresses[k]];
				if (!tmpDescriptor)
				{
					continue;
				}
				if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden)
				{
					continue;
				}
				if (tmpChooserHiddenSet && tmpChooserHiddenSet.has(String(tmpAddresses[k])))
				{
					continue;
				}
				let tmpIsDynamic = (typeof tmpDescriptor._DynamicColumnGeneratorIndex === 'number');
				let tmpGroupLabel = (tmpIsDynamic && typeof tmpDescriptor._DynamicColumnHeaderGroup === 'string')
					? tmpDescriptor._DynamicColumnHeaderGroup
					: '';
				let tmpRunKey = tmpIsDynamic ? `D${tmpDescriptor._DynamicColumnGeneratorIndex}|${tmpGroupLabel}` : `S|${k}`;
				if (tmpCurrentRun && tmpCurrentRun.RunKey === tmpRunKey)
				{
					tmpCurrentRun.Cell.ColumnSpan += 1;
				}
				else
				{
					tmpCurrentRun = {
						RunKey: tmpRunKey,
						Cell: {
							Label: tmpIsDynamic ? tmpGroupLabel : '',
							ColumnSpan: 1,
							CSSClass: tmpIsDynamic ? 'pict-tabular-dynamic-header-group' : 'pict-tabular-static-header-spacer'
						}
					};
					tmpSynthRow.push(tmpCurrentRun.Cell);
				}
			}
			tmpExpanded.push(tmpSynthRow);
		}

		return tmpExpanded;
	}

	/**
	 * Compute per-row label metadata for a tabular group with RowLabels config.
	 *
	 * Walks the current RecordSetAddress array. For each row, resolves the
	 * label value for each RowLabels entry (Template / RowNumber / SourceAddress).
	 * For Cluster:true columns, consecutive equal values collapse into a single
	 * cell on the first row of the run, with continuation rows marked Skip:true.
	 *
	 * Writes the result to pGroup.RowLabelMetadata as an array index-aligned
	 * with the record set. Idempotent — safe to call on every marshal.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_computeRowLabelMetadata(pView, pGroup)
	{
		if (!Array.isArray(pGroup.RowLabels) || pGroup.RowLabels.length === 0)
		{
			pGroup.RowLabelMetadata = [];
			return;
		}
		let tmpRecordSet = [];
		if (typeof pGroup.RecordSetAddress === 'string' && pGroup.RecordSetAddress.length > 0)
		{
			let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
			let tmpFetched = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, pGroup.RecordSetAddress);
			if (Array.isArray(tmpFetched))
			{
				tmpRecordSet = tmpFetched;
			}
		}

		let tmpMetadata = [];
		for (let i = 0; i < tmpRecordSet.length; i++)
		{
			let tmpRow = tmpRecordSet[i];
			let tmpCells = [];
			for (let l = 0; l < pGroup.RowLabels.length; l++)
			{
				let tmpLabelConfig = pGroup.RowLabels[l];
				let tmpRenderedLabel = '';
				if (tmpLabelConfig.RowNumber === true)
				{
					tmpRenderedLabel = String(i + 1);
				}
				else if (typeof tmpLabelConfig.SourceAddress === 'string' && tmpLabelConfig.SourceAddress.length > 0)
				{
					let tmpLabelSource = this.pict.resolveStateFromAddress(tmpLabelConfig.SourceAddress, null);
					if (Array.isArray(tmpLabelSource) && i < tmpLabelSource.length)
					{
						let tmpItem = tmpLabelSource[i];
						tmpRenderedLabel = (typeof tmpItem === 'string') ? tmpItem : (tmpItem == null ? '' : String(tmpItem));
					}
				}
				else if (typeof tmpLabelConfig.Template === 'string')
				{
					// Templates can reference Record.Value.X (the row record) or AppData.X.
					tmpRenderedLabel = this._parseTabularTemplate(tmpLabelConfig.Template, { Value: tmpRow, Key: i });
				}
				tmpCells.push({
					Label: tmpLabelConfig.Name || '',
					RenderedLabel: tmpRenderedLabel,
					RowSpan: 1,
					Skip: false,
					Cluster: tmpLabelConfig.Cluster === true,
					CSSClass: (typeof tmpLabelConfig.CSSClass === 'string') ? tmpLabelConfig.CSSClass : ''
				});
			}
			tmpMetadata.push({ Cells: tmpCells });
		}

		// Pass 2: apply clustering (rowspan collapse for consecutive equal values).
		for (let l = 0; l < pGroup.RowLabels.length; l++)
		{
			if (!pGroup.RowLabels[l].Cluster)
			{
				continue;
			}
			let tmpRunStart = 0;
			for (let i = 1; i <= tmpMetadata.length; i++)
			{
				let tmpAtEnd = (i === tmpMetadata.length);
				let tmpMatches = !tmpAtEnd
					&& tmpMetadata[i].Cells[l].RenderedLabel === tmpMetadata[tmpRunStart].Cells[l].RenderedLabel;
				if (tmpMatches)
				{
					tmpMetadata[i].Cells[l].Skip = true;
				}
				else
				{
					let tmpRunLength = i - tmpRunStart;
					tmpMetadata[tmpRunStart].Cells[l].RowSpan = tmpRunLength;
					tmpRunStart = i;
				}
			}
		}

		pGroup.RowLabelMetadata = tmpMetadata;
	}

	/**
	 * Called from the row template via the {~TRL:...~} tag. Returns the HTML for
	 * the leading cells of one tabular row: an optional row-selection checkbox
	 * cell followed by the configured row-label cells.
	 *
	 * @param {Object} pView
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @returns {string}
	 */
	_renderTabularRowLabelsHTML(pView, pGroupIndex, pRowKey)
	{
		if (!pView || !pView.sectionDefinition || !Array.isArray(pView.sectionDefinition.Groups))
		{
			return '';
		}
		let tmpGroupIdx = Number(pGroupIndex);
		if (isNaN(tmpGroupIdx) || tmpGroupIdx < 0 || tmpGroupIdx >= pView.sectionDefinition.Groups.length)
		{
			return '';
		}
		let tmpGroup = pView.sectionDefinition.Groups[tmpGroupIdx];
		let tmpRowKeyNum = Number(pRowKey);

		// The {~TRL:~} tag runs once per row, in row order, during a render pass.
		// Recompute the label metadata when the first row renders so a render()
		// that was not preceded by a fresh marshal (e.g. a row move / add / delete)
		// still shows correct, current row labels rather than the previous order.
		if (tmpRowKeyNum === 0)
		{
			this._computeRowLabelMetadata(pView, tmpGroup);
		}

		let tmpHTML = '';

		// Leading row-selection checkbox cell.
		if (tmpGroup._RowSelectionConfig && !isNaN(tmpRowKeyNum) && tmpRowKeyNum >= 0)
		{
			let tmpSelected = this._getTabularSelectionArray(pView, tmpGroup._RowSelectionConfig);
			let tmpCheckedAttr = tmpSelected[tmpRowKeyNum] ? ' checked="checked"' : '';
			tmpHTML += `<td class="pict-tabular-row-select">`
				+ `<input type="checkbox"${tmpCheckedAttr} onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularRowSelection('${pView.Hash}', ${tmpGroupIdx}, '${tmpRowKeyNum}', this.checked)">`
				+ `</td>`;
		}

		// Row-label cells.
		if (Array.isArray(tmpGroup.RowLabelMetadata)
			&& !isNaN(tmpRowKeyNum) && tmpRowKeyNum >= 0 && tmpRowKeyNum < tmpGroup.RowLabelMetadata.length)
		{
			let tmpCells = tmpGroup.RowLabelMetadata[tmpRowKeyNum].Cells;
			for (let c = 0; c < tmpCells.length; c++)
			{
				let tmpCell = tmpCells[c];
				if (tmpCell.Skip)
				{
					continue;
				}
				let tmpRowSpanAttr = (tmpCell.RowSpan > 1) ? ` rowspan="${tmpCell.RowSpan}"` : '';
				let tmpClassAttr = `pict-row-label${tmpCell.Cluster ? ' pict-row-label-clustered' : ''}${tmpCell.CSSClass ? ' ' + tmpCell.CSSClass : ''}`;
				tmpHTML += `<td${tmpRowSpanAttr} class="${tmpClassAttr}">${this._escapeHTML(tmpCell.RenderedLabel)}</td>`;
			}
		}
		return tmpHTML;
	}

	/**
	 * Called from the row template via {~F:...~} to emit the editing controls
	 * (del/up/down) for a row. Used when EditingControlsPosition === 'left'.
	 * For EditingControlsPosition === 'right' the existing default
	 * -TabularTemplate-Row-ExtraPostfix template handles this.
	 *
	 * @param {Object} pView
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @returns {string}
	 */
	_renderTabularEditingControlsHTML(pView, pGroupIndex, pRowKey)
	{
		if (!pView)
		{
			return '';
		}
		let tmpViewHash = pView.Hash;
		return `<td class="pict-tabular-editing-controls"><a href="#/" onClick="_Pict.views['${tmpViewHash}'].deleteDynamicTableRow(${pGroupIndex},'${pRowKey}')">del</a> <a href="#/" onClick="_Pict.views['${tmpViewHash}'].moveDynamicTableRowUp(${pGroupIndex},'${pRowKey}')">up</a> <a href="#/" onClick="_Pict.views['${tmpViewHash}'].moveDynamicTableRowDown(${pGroupIndex},'${pRowKey}')">down</a></td>`;
	}

	_escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	/**
	 * Normalize a Group.RowSelection / Group.ColumnSelection config value.
	 *
	 * Accepts `true` (use all defaults) or an object
	 * `{ Enabled, DataAddress, HighlightClass, HeaderLabel }`. Returns null when
	 * selection is not enabled.
	 *
	 * - `DataAddress` — address (relative to the form's marshal destination) where
	 *   the boolean selection array is stored, so it persists with the form data.
	 * - `HighlightClass` — class auto-applied to selected rows/columns. Set to an
	 *   empty string to make selection purely data-driven (solver-applied only).
	 * - `HeaderLabel` — text for the selection column's header cell.
	 *
	 * @param {boolean|Object} pConfigValue
	 * @param {string} pDefaultDataAddress
	 * @param {string} pDefaultHighlightClass
	 * @returns {{DataAddress: string, HighlightClass: string, HeaderLabel: string}|null}
	 */
	_normalizeSelectionConfig(pConfigValue, pDefaultDataAddress, pDefaultHighlightClass)
	{
		if (pConfigValue !== true && (typeof pConfigValue !== 'object' || pConfigValue === null))
		{
			return null;
		}
		let tmpConfig = (typeof pConfigValue === 'object') ? pConfigValue : {};
		if (tmpConfig.Enabled === false)
		{
			return null;
		}
		return {
			DataAddress: (typeof tmpConfig.DataAddress === 'string' && tmpConfig.DataAddress.length > 0)
				? tmpConfig.DataAddress
				: pDefaultDataAddress,
			HighlightClass: ('HighlightClass' in tmpConfig)
				? (tmpConfig.HighlightClass || '')
				: pDefaultHighlightClass,
			HeaderLabel: (typeof tmpConfig.HeaderLabel === 'string') ? tmpConfig.HeaderLabel : ''
		};
	}

	/**
	 * The absolute address (within the form's marshal destination) of a selection
	 * config's boolean array.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @returns {string}
	 */
	_getTabularSelectionAddress(pView, pSelectionConfig)
	{
		return `${pView.getMarshalDestinationAddress()}.${pSelectionConfig.DataAddress}`;
	}

	/**
	 * Reads the boolean selection array for a row/column selection config.
	 * Always returns an array (empty when nothing has been selected yet).
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @returns {Array<boolean>}
	 */
	_getTabularSelectionArray(pView, pSelectionConfig)
	{
		let tmpValue = this.pict.resolveStateFromAddress(this._getTabularSelectionAddress(pView, pSelectionConfig));
		return Array.isArray(tmpValue) ? tmpValue : [];
	}

	/**
	 * Sets one flag in a selection array and writes it back into the form data.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @param {number|string} pIndex
	 * @param {boolean} pSelected
	 * @returns {Array<boolean>}
	 */
	_setTabularSelectionFlag(pView, pSelectionConfig, pIndex, pSelected)
	{
		let tmpArray = this._getTabularSelectionArray(pView, pSelectionConfig);
		let tmpIndex = Number(pIndex);
		if (!isNaN(tmpIndex) && tmpIndex >= 0)
		{
			tmpArray[tmpIndex] = !!pSelected;
		}
		this.pict.setStateValueAtAddress(this._getTabularSelectionAddress(pView, pSelectionConfig), null, tmpArray);
		return tmpArray;
	}

	/**
	 * Inline-handler entry point: toggles a row's selection state. Called by the
	 * checkbox rendered in the row-selection column. Writes the new state into the
	 * form data, optionally applies the highlight class, then re-solves so any
	 * user solvers that read the selection state can react.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @param {boolean} pChecked
	 * @returns {boolean}
	 */
	toggleTabularRowSelection(pViewHash, pGroupIndex, pRowKey, pChecked)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !tmpGroup._RowSelectionConfig)
		{
			return false;
		}
		this._setTabularSelectionFlag(tmpView, tmpGroup._RowSelectionConfig, pRowKey, pChecked);
		if (tmpGroup._RowSelectionConfig.HighlightClass && this.pict.providers.DynamicFormSolverBehaviors)
		{
			this.pict.providers.DynamicFormSolverBehaviors.highlightTabularRow(
				tmpView.sectionDefinition.Hash, tmpGroup.Hash, pRowKey, pChecked ? 1 : 0, tmpGroup._RowSelectionConfig.HighlightClass);
		}
		this.pict.PictApplication.solve();
		return true;
	}

	/**
	 * Inline-handler entry point: toggles a column's selection state. Called by the
	 * checkbox rendered in the column-selection header row.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex
	 * @param {boolean} pChecked
	 * @returns {boolean}
	 */
	toggleTabularColumnSelection(pViewHash, pGroupIndex, pColumnIndex, pChecked)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !tmpGroup._ColumnSelectionConfig)
		{
			return false;
		}
		this._setTabularSelectionFlag(tmpView, tmpGroup._ColumnSelectionConfig, pColumnIndex, pChecked);
		if (tmpGroup._ColumnSelectionConfig.HighlightClass && this.pict.providers.DynamicFormSolverBehaviors)
		{
			this.pict.providers.DynamicFormSolverBehaviors.highlightTabularColumn(
				tmpView.sectionDefinition.Hash, tmpGroup.Hash, pColumnIndex, pChecked ? 1 : 0, tmpGroup._ColumnSelectionConfig.HighlightClass);
		}
		this.pict.PictApplication.solve();
		return true;
	}

	/**
	 * Re-applies selection highlight classes from the stored selection arrays.
	 * Run after a (re)render rebuilds the table DOM and the classes would
	 * otherwise be lost. No-op when no highlight class is configured.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_reapplyTabularSelectionHighlights(pView, pGroup)
	{
		let tmpBehaviors = this.pict.providers.DynamicFormSolverBehaviors;
		if (!tmpBehaviors || !pView.sectionDefinition)
		{
			return;
		}
		let tmpSectionHash = pView.sectionDefinition.Hash;
		if (pGroup._RowSelectionConfig && pGroup._RowSelectionConfig.HighlightClass)
		{
			let tmpRows = this._getTabularSelectionArray(pView, pGroup._RowSelectionConfig);
			for (let i = 0; i < tmpRows.length; i++)
			{
				tmpBehaviors.highlightTabularRow(tmpSectionHash, pGroup.Hash, i, tmpRows[i] ? 1 : 0, pGroup._RowSelectionConfig.HighlightClass);
			}
		}
		if (pGroup._ColumnSelectionConfig && pGroup._ColumnSelectionConfig.HighlightClass)
		{
			let tmpColumns = this._getTabularSelectionArray(pView, pGroup._ColumnSelectionConfig);
			for (let i = 0; i < tmpColumns.length; i++)
			{
				tmpBehaviors.highlightTabularColumn(tmpSectionHash, pGroup.Hash, i, tmpColumns[i] ? 1 : 0, pGroup._ColumnSelectionConfig.HighlightClass);
			}
		}
	}

	/**
	 * Normalize a Group.ColumnChooser config value.
	 *
	 * Accepts `true` (use all defaults) or an object
	 * `{ Enabled, DataAddress, ButtonLabel, DefaultHiddenColumns }`. Returns null
	 * when the chooser is not enabled (the feature is strictly opt-in).
	 *
	 * - `DataAddress` — address (relative to the form's marshal destination) where
	 *   the array of hidden column hashes is stored, so it persists with the form data.
	 * - `ButtonLabel` — text for the trigger button above the table.
	 * - `DefaultHiddenColumns` — column hashes hidden until the user changes them
	 *   (merged with any descriptor-level `PictForm.TabularDefaultHidden` flags).
	 *
	 * @param {boolean|Object} pConfigValue
	 * @param {string} pDefaultDataAddress
	 * @returns {{DataAddress: string, ButtonLabel: string, DefaultHiddenColumns: Array<string>}|null}
	 */
	_normalizeColumnChooserConfig(pConfigValue, pDefaultDataAddress)
	{
		if (pConfigValue !== true && (typeof pConfigValue !== 'object' || pConfigValue === null))
		{
			return null;
		}
		let tmpConfig = (typeof pConfigValue === 'object') ? pConfigValue : {};
		if (tmpConfig.Enabled === false)
		{
			return null;
		}
		return {
			DataAddress: (typeof tmpConfig.DataAddress === 'string' && tmpConfig.DataAddress.length > 0)
				? tmpConfig.DataAddress
				: pDefaultDataAddress,
			ButtonLabel: (typeof tmpConfig.ButtonLabel === 'string' && tmpConfig.ButtonLabel.length > 0)
				? tmpConfig.ButtonLabel
				: 'Columns',
			DefaultHiddenColumns: Array.isArray(tmpConfig.DefaultHiddenColumns)
				? tmpConfig.DefaultHiddenColumns.map((pHash) => String(pHash))
				: []
		};
	}

	/**
	 * Lazily normalize (and cache on the group) the ColumnChooser config. The
	 * template bake re-normalizes each pass; this accessor covers code paths
	 * (marshal hooks, inline handlers) that may run against a group whose
	 * template hasn't been baked yet.
	 *
	 * @param {Object} pGroup
	 * @returns {{DataAddress: string, ButtonLabel: string, DefaultHiddenColumns: Array<string>}|null}
	 */
	_ensureTabularColumnChooserConfig(pGroup)
	{
		if (pGroup._ColumnChooserConfig === undefined)
		{
			pGroup._ColumnChooserConfig = this._normalizeColumnChooserConfig(pGroup.ColumnChooser, `${pGroup.Hash}_HiddenColumns`);
		}
		return pGroup._ColumnChooserConfig;
	}

	/**
	 * The absolute address (within the form's marshal destination) of the
	 * chooser's hidden-column-hash array.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pChooserConfig
	 * @returns {string}
	 */
	_getTabularHiddenColumnsAddress(pView, pChooserConfig)
	{
		return `${pView.getMarshalDestinationAddress()}.${pChooserConfig.DataAddress}`;
	}

	/**
	 * The set of column hashes hidden BY DEFAULT for a group: the chooser
	 * config's DefaultHiddenColumns plus every descriptor flagged
	 * `PictForm.TabularDefaultHidden`. These apply only until the user changes
	 * column visibility (which writes an explicit array into the form data).
	 *
	 * @param {Object} pGroup
	 * @returns {Array<string>}
	 */
	_getTabularColumnChooserDefaultHidden(pGroup)
	{
		let tmpConfig = pGroup._ColumnChooserConfig;
		if (!tmpConfig)
		{
			return [];
		}
		let tmpDefaultHidden = {};
		for (let i = 0; i < tmpConfig.DefaultHiddenColumns.length; i++)
		{
			tmpDefaultHidden[tmpConfig.DefaultHiddenColumns[i]] = true;
		}
		if (pGroup.supportingManifest && Array.isArray(pGroup.supportingManifest.elementAddresses))
		{
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpHash];
				if (tmpDescriptor && tmpDescriptor.PictForm
					&& !tmpDescriptor.PictForm.TabularHidden
					&& tmpDescriptor.PictForm.TabularDefaultHidden === true)
				{
					tmpDefaultHidden[String(tmpHash)] = true;
				}
			}
		}
		return Object.keys(tmpDefaultHidden);
	}

	/**
	 * The EFFECTIVE set of chooser-hidden column hashes for a group: the array
	 * stored in the form data when the user has made choices, otherwise the
	 * configured defaults. Returns null when the chooser is not enabled, so
	 * callers can use a single falsy check to keep the legacy code path intact.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Set<string>|null}
	 */
	_getTabularColumnChooserHiddenSet(pView, pGroup)
	{
		let tmpConfig = this._ensureTabularColumnChooserConfig(pGroup);
		if (!tmpConfig)
		{
			return null;
		}
		let tmpStored = this.pict.resolveStateFromAddress(this._getTabularHiddenColumnsAddress(pView, tmpConfig));
		let tmpHiddenList = Array.isArray(tmpStored)
			? tmpStored
			: this._getTabularColumnChooserDefaultHidden(pGroup);
		let tmpHiddenSet = new Set();
		for (let i = 0; i < tmpHiddenList.length; i++)
		{
			tmpHiddenSet.add(String(tmpHiddenList[i]));
		}
		return tmpHiddenSet;
	}

	/**
	 * A canonical string for the group's effective hidden-column set, used to
	 * detect (on marshal) that loaded form data carries different column
	 * visibility than the table template was baked with.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {string}
	 */
	_getTabularColumnChooserStateKey(pView, pGroup)
	{
		let tmpHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		if (!tmpHiddenSet)
		{
			return '';
		}
		return Array.from(tmpHiddenSet).sort().join('|');
	}

	/**
	 * The columns the chooser can manage, in manifest order. Statically hidden
	 * descriptors (`PictForm.TabularHidden`) are never choosable and never
	 * listed. Each entry carries the descriptor's manifest index so inline
	 * handlers can address it without string-escaping concerns.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Array<{Key: string, Name: string, ColumnIndex: number, Visible: boolean}>}
	 */
	_getTabularChoosableColumns(pView, pGroup)
	{
		let tmpColumns = [];
		if (!pGroup.supportingManifest || !Array.isArray(pGroup.supportingManifest.elementAddresses))
		{
			return tmpColumns;
		}
		let tmpHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpHash = String(pGroup.supportingManifest.elementAddresses[k]);
			let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpHash];
			if (!tmpDescriptor || (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden))
			{
				continue;
			}
			tmpColumns.push(
				{
					Key: tmpHash,
					Name: (tmpDescriptor.Name != null && String(tmpDescriptor.Name).length > 0) ? String(tmpDescriptor.Name) : tmpHash,
					ColumnIndex: k,
					Visible: !(tmpHiddenSet && tmpHiddenSet.has(tmpHash))
				});
		}
		return tmpColumns;
	}

	/**
	 * DOM element id for one of the chooser's baked elements (TRIGGER / POPOVER),
	 * namespaced by form and group so multiple tabular groups can each carry
	 * their own chooser.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {string} pElement
	 * @returns {string}
	 */
	_getTabularColumnChooserElementId(pView, pGroup, pElement)
	{
		return `PICTFORM-COLCHOOSER-${pElement}-${pView.formID}-${pGroup.Hash}`;
	}

	/**
	 * Builds the chooser bar baked above the table: a right-aligned trigger
	 * button (with a "n hidden" hint when columns are hidden) plus the empty
	 * popover container the open action renders into.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {string}
	 */
	_buildTabularColumnChooserBarHTML(pView, pGroup)
	{
		let tmpColumns = this._getTabularChoosableColumns(pView, pGroup);
		let tmpHiddenCount = tmpColumns.filter((pColumn) => !pColumn.Visible).length;
		let tmpGlyph = (typeof this.pict.icon === 'function') ? this.pict.icon('Settings') : '';
		let tmpCountHint = (tmpHiddenCount > 0)
			? ` <span class="pict-tabular-colchooser-count">(${tmpHiddenCount} hidden)</span>`
			: '';
		return `<div class="pict-tabular-colchooser-bar">`
			+ `<button type="button" class="pict-tabular-colchooser-trigger" id="${this._getTabularColumnChooserElementId(pView, pGroup, 'TRIGGER')}" `
			+ `title="Choose which columns to show" `
			+ `onclick="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnChooser('${pView.Hash}', ${pGroup.GroupIndex})">`
			+ `${tmpGlyph} ${this._escapeHTML(pGroup._ColumnChooserConfig.ButtonLabel)}${tmpCountHint}</button>`
			+ `<div class="pict-tabular-colchooser-pop" id="${this._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}"></div>`
			+ `</div>`;
	}

	/**
	 * Renders the chooser popover's content (backdrop + panel of checkbox rows +
	 * reset footer) into its baked container. Runs on open and after each toggle
	 * (the table re-render replaces the popover element, so its content must be
	 * repainted to keep the menu open across toggles).
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_renderTabularColumnChooserPopover(pView, pGroup)
	{
		let tmpColumns = this._getTabularChoosableColumns(pView, pGroup);
		let tmpRowsHTML = '';
		for (let i = 0; i < tmpColumns.length; i++)
		{
			let tmpColumn = tmpColumns[i];
			tmpRowsHTML += `<label class="pict-tabular-colchooser-row">`
				+ `<input type="checkbox"${tmpColumn.Visible ? ' checked="checked"' : ''} `
				+ `onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex}, ${tmpColumn.ColumnIndex}, this.checked)">`
				+ `<span>${this._escapeHTML(tmpColumn.Name)}</span>`
				+ `</label>`;
		}
		let tmpPopoverHTML = `<div class="pict-tabular-colchooser-backdrop" onclick="_Pict.providers['Pict-Layout-Tabular'].closeTabularColumnChooser('${pView.Hash}', ${pGroup.GroupIndex})"></div>`
			+ `<div class="pict-tabular-colchooser-panel">`
			+ `<div class="pict-tabular-colchooser-list">${tmpRowsHTML}</div>`
			+ `<div class="pict-tabular-colchooser-footer">`
			+ `<button type="button" class="pict-tabular-colchooser-reset" onclick="_Pict.providers['Pict-Layout-Tabular'].resetTabularColumnVisibility('${pView.Hash}', ${pGroup.GroupIndex})">Reset to defaults</button>`
			+ `</div>`
			+ `</div>`;
		this.pict.ContentAssignment.assignContent(`#${this._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}`, tmpPopoverHTML);
	}

	/**
	 * Reflect the chooser popover's open/closed state on its container element,
	 * positioning it against the trigger when opening.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {boolean} pOpen
	 */
	_paintTabularColumnChooserOpenState(pView, pGroup, pOpen)
	{
		let tmpPopoverElements = this.pict.ContentAssignment.getElement(`#${this._getTabularColumnChooserElementId(pView, pGroup, 'POPOVER')}`);
		if (!tmpPopoverElements.length)
		{
			return;
		}
		tmpPopoverElements[0].classList.toggle('open', !!pOpen);
		if (pOpen)
		{
			this._applyTabularColumnChooserAnchor(pView, pGroup, tmpPopoverElements[0]);
		}
		else
		{
			// Bring a portaled popover home on close so a closed chooser never strands a node on <body>.
			this._restoreTabularColumnChooserPopover(pView, pGroup, tmpPopoverElements[0]);
		}
	}

	/**
	 * Anchor the (open) chooser popover to its trigger with the same listener-free strategy as
	 * pict-section-picker: keep it in the DOM and CSS-absolute under the (position:relative) bar --
	 * which rides page scroll for free -- UNLESS a clipping ancestor would cut it, in which case
	 * portal it to <body> and place it in document coords. No scroll/resize handlers: an absolute
	 * (not fixed) panel tracks the document as it scrolls, so one placement holds.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {HTMLElement} pPopover
	 */
	_applyTabularColumnChooserAnchor(pView, pGroup, pPopover)
	{
		if (!pPopover || (typeof document === 'undefined') || (typeof window === 'undefined'))
		{
			return;
		}
		let tmpTrigger = document.getElementById(this._getTabularColumnChooserElementId(pView, pGroup, 'TRIGGER'));
		if (!tmpTrigger)
		{
			return;
		}
		// Judge from the trigger (it never moves); a portaled panel has no clipping ancestors, so
		// testing the panel itself would flip-flop.
		if (this._tabularColumnChooserShouldPortal(tmpTrigger, pPopover))
		{
			this._portalTabularColumnChooserPopover(pPopover, tmpTrigger);
		}
		else
		{
			this._restoreTabularColumnChooserPopover(pView, pGroup, pPopover);
		}
	}

	/**
	 * Move the popover to <body> and place it against the trigger in document coords (viewport rect +
	 * scroll), flipping above when the room below is genuinely cramped. Carries the resolved
	 * --theme-color-* tokens across so the panel stays themed off its scoped container.
	 *
	 * @param {HTMLElement} pPopover
	 * @param {HTMLElement} pTrigger
	 */
	_portalTabularColumnChooserPopover(pPopover, pTrigger)
	{
		if (!pPopover || !pTrigger || (typeof document === 'undefined') || (typeof window === 'undefined'))
		{
			return;
		}
		// Adopt this popover onto <body>, sweeping any stale same-id copy a prior re-render left behind.
		this._sweepPortaledColchooserOrphans(pPopover.getAttribute('id'), pPopover);
		if (pPopover.parentElement !== document.body)
		{
			document.body.appendChild(pPopover);
		}
		pPopover.classList.add('pict-tabular-colchooser-pop-portal');
		// Carry the resolved --theme-color-* tokens across: off its scoped container the panel would
		// otherwise fall back to the stylesheet hex defaults. Skip empty reads so a token the host never
		// defined keeps its own var(--token, #hex) fallback (matches pict-section-picker's _portalPop).
		if (typeof window.getComputedStyle === 'function')
		{
			let tmpComputed = window.getComputedStyle(pTrigger);
			_COLCHOOSER_THEME_TOKENS.forEach((pToken) =>
			{
				let tmpValue = tmpComputed.getPropertyValue(pToken);
				if (tmpValue && tmpValue.trim() !== '')
				{
					pPopover.style.setProperty(pToken, tmpValue.trim());
				}
			});
		}
		let tmpPanel = pPopover.querySelector('.pict-tabular-colchooser-panel');
		let tmpRect = pTrigger.getBoundingClientRect();
		let tmpGap = 6;
		let tmpMargin = 8;
		let tmpWidth = pPopover.offsetWidth || 240;
		let tmpViewportHeight = window.innerHeight;
		let tmpViewportWidth = window.innerWidth;
		let tmpSpaceBelow = tmpViewportHeight - tmpRect.bottom - tmpGap - tmpMargin;
		let tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		let tmpBelow = (tmpSpaceBelow >= 220) || (tmpSpaceBelow >= tmpSpaceAbove);
		// Document coords (viewport rect + scroll): absolute against <body>, so the panel rides page
		// scroll with no listener. Right-aligned to the trigger, clamped into the viewport.
		pPopover.style.right = 'auto';
		pPopover.style.bottom = 'auto';
		pPopover.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.right - tmpWidth, tmpViewportWidth - tmpWidth - tmpMargin)) + window.scrollX)}px`;
		if (tmpBelow)
		{
			pPopover.style.top = `${Math.round(tmpRect.bottom + tmpGap + window.scrollY)}px`;
			pPopover.style.transform = '';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceBelow, 420))}px`; }
		}
		else
		{
			pPopover.style.top = `${Math.round(tmpRect.top - tmpGap + window.scrollY)}px`;
			pPopover.style.transform = 'translateY(-100%)';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceAbove, 420))}px`; }
		}
	}

	/**
	 * Re-home a portaled popover into its bar and drop everything the portal wrote. Doubles as the
	 * orphan sweeper: if a re-render already baked a fresh in-bar popover, the portaled one is stale
	 * and gets discarded rather than duplicated.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {HTMLElement} pPopover
	 */
	_restoreTabularColumnChooserPopover(pView, pGroup, pPopover)
	{
		if (!pPopover || (typeof document === 'undefined'))
		{
			return;
		}
		// Discard any OTHER portaled copy of this popover a prior re-render may have left on <body>.
		this._sweepPortaledColchooserOrphans(pPopover.getAttribute('id'), pPopover);
		if (pPopover.parentElement === document.body)
		{
			let tmpTrigger = document.getElementById(this._getTabularColumnChooserElementId(pView, pGroup, 'TRIGGER'));
			let tmpBar = tmpTrigger ? tmpTrigger.parentElement : null;
			let tmpFreshInBar = tmpBar ? tmpBar.querySelector('.pict-tabular-colchooser-pop') : null;
			if (tmpBar && (!tmpFreshInBar || tmpFreshInBar === pPopover))
			{
				// Re-home the popover next to its trigger, inside the bar.
				tmpBar.appendChild(pPopover);
			}
			else
			{
				// A re-render already baked a fresh in-bar popover; this portaled one is a leftover.
				pPopover.remove();
				return;
			}
		}
		pPopover.classList.remove('pict-tabular-colchooser-pop-portal');
		// Clear the inline offsets/transform, or they'd override the stylesheet and strand the panel.
		pPopover.style.top = '';
		pPopover.style.left = '';
		pPopover.style.right = '';
		pPopover.style.bottom = '';
		pPopover.style.transform = '';
		// Drop the copied tokens so back in the bar it inherits them live again.
		_COLCHOOSER_THEME_TOKENS.forEach((pToken) => pPopover.style.removeProperty(pToken));
		let tmpPanel = pPopover.querySelector('.pict-tabular-colchooser-panel');
		if (tmpPanel) { tmpPanel.style.maxHeight = ''; }
	}

	/**
	 * Remove any portaled copies of a chooser popover (matched by element id) that are direct children
	 * of <body>, except the one to keep. Iterates body children so no attribute-selector escaping of
	 * the id is needed, and is scoped by id so it never touches another table's portaled popover.
	 *
	 * @param {string} pElementId
	 * @param {HTMLElement} pKeep
	 */
	_sweepPortaledColchooserOrphans(pElementId, pKeep)
	{
		if (!pElementId || (typeof document === 'undefined') || !document.body)
		{
			return;
		}
		Array.prototype.slice.call(document.body.children).forEach((pNode) =>
		{
			if (pNode !== pKeep && pNode.id === pElementId
				&& pNode.classList && pNode.classList.contains('pict-tabular-colchooser-pop'))
			{
				pNode.remove();
			}
		});
	}

	/**
	 * Portal when ANY clipping ancestor of the trigger would actually cut the popover -- an overflow
	 * ancestor alone isn't enough, but a roomy inner clipper doesn't excuse a tighter one further out.
	 *
	 * @param {HTMLElement} pTrigger
	 * @param {HTMLElement} pPopover
	 * @returns {boolean}
	 */
	_tabularColumnChooserShouldPortal(pTrigger, pPopover)
	{
		let tmpWidth = (pPopover && pPopover.offsetWidth) ? pPopover.offsetWidth : 240;
		let tmpClipper = this._tabularColumnChooserClippingAncestor(pTrigger);
		while (tmpClipper)
		{
			if (this._tabularColumnChooserClipBites(pTrigger, tmpClipper, tmpWidth))
			{
				return true;
			}
			tmpClipper = this._tabularColumnChooserClippingAncestor(tmpClipper);
		}
		return false;
	}

	/**
	 * Nearest ancestor (up to, not including, <body>) with an overflow clip on any axis, or null.
	 * Stops at <body> because the document's own scroll is what the absolute anchoring rides on.
	 *
	 * @param {HTMLElement} pElement
	 * @returns {HTMLElement|null}
	 */
	_tabularColumnChooserClippingAncestor(pElement)
	{
		if ((typeof window === 'undefined') || (typeof window.getComputedStyle !== 'function'))
		{
			return null;
		}
		let tmpNode = pElement ? pElement.parentElement : null;
		while (tmpNode && tmpNode.nodeType === 1 && tmpNode !== document.body)
		{
			let tmpStyle = window.getComputedStyle(tmpNode);
			if (tmpStyle && [ tmpStyle.overflow, tmpStyle.overflowX, tmpStyle.overflowY ].some((pValue) => pValue && pValue !== 'visible'))
			{
				return tmpNode;
			}
			tmpNode = tmpNode.parentElement;
		}
		return null;
	}

	/**
	 * Would the clipper cut the popover if it opened in place? The CSS path opens downward, right-
	 * aligned to the trigger; project that worst-case box (trigger bottom + gap, up to the max height)
	 * and test whether any edge falls outside the clipper. 1px slack avoids a needless portal on a
	 * flush edge.
	 *
	 * @param {HTMLElement} pTrigger
	 * @param {HTMLElement} pClipper
	 * @param {number} pWidth
	 * @returns {boolean}
	 */
	_tabularColumnChooserClipBites(pTrigger, pClipper, pWidth)
	{
		if (!pTrigger || !pClipper || (typeof pTrigger.getBoundingClientRect !== 'function')
			|| (typeof pClipper.getBoundingClientRect !== 'function'))
		{
			return true;
		}
		let tmpTriggerRect = pTrigger.getBoundingClientRect();
		let tmpClipRect = pClipper.getBoundingClientRect();
		let tmpGap = 6;
		let tmpIdeal = 420;
		let tmpSlack = 1;
		let tmpWidthResolved = Math.max(220, pWidth || 220);
		let tmpPanelTop = tmpTriggerRect.bottom + tmpGap;
		let tmpPanelBottom = tmpPanelTop + tmpIdeal;
		let tmpPanelRight = tmpTriggerRect.right;
		let tmpPanelLeft = tmpTriggerRect.right - tmpWidthResolved;
		return (tmpPanelBottom > tmpClipRect.bottom + tmpSlack)
			|| (tmpPanelTop < tmpClipRect.top - tmpSlack)
			|| (tmpPanelLeft < tmpClipRect.left - tmpSlack)
			|| (tmpPanelRight > tmpClipRect.right + tmpSlack);
	}

	/**
	 * Rebuild + re-render a tabular view and re-marshal the form data into it.
	 * Same tail as sortTabularColumn: the rebuild re-bakes the table template
	 * (column set, headers, chooser bar), the render repaints, the marshal
	 * pushes current values back into the freshly built inputs.
	 *
	 * @param {Object} pView
	 */
	_rebuildTabularGroupView(pView)
	{
		pView.rebuildCustomTemplate();
		pView.render();
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			pView.marshalToView();
		}
	}

	/**
	 * Inline-handler entry point: opens/closes a group's column chooser popover
	 * (the trigger button's handler). Open/closed is derived from the popover's
	 * DOM class, not an instance flag — a re-render replaces the popover element
	 * (visually closed), so a flag would go stale and demand a double-click.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @returns {boolean}
	 */
	toggleTabularColumnChooser(pViewHash, pGroupIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !this._ensureTabularColumnChooserConfig(tmpGroup))
		{
			return false;
		}
		let tmpPopoverElements = this.pict.ContentAssignment.getElement(`#${this._getTabularColumnChooserElementId(tmpView, tmpGroup, 'POPOVER')}`);
		if (tmpPopoverElements.length && tmpPopoverElements[0].classList.contains('open'))
		{
			this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, false);
			return true;
		}
		this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
		return true;
	}

	/**
	 * Inline-handler entry point: closes a group's column chooser popover (the
	 * backdrop's handler).
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @returns {boolean}
	 */
	closeTabularColumnChooser(pViewHash, pGroupIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup)
		{
			return false;
		}
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, false);
		return true;
	}

	/**
	 * Inline-handler entry point: shows/hides one column (a chooser checkbox's
	 * handler). Writes the updated hidden-hash array into the form data (so it
	 * persists with a save), rebuilds the table template without the column,
	 * re-renders, re-marshals, then re-opens the popover the re-render closed.
	 *
	 * Hiding never touches the underlying record data — the column's values
	 * stay in the record set and reappear when the column is shown again.
	 *
	 * Refuses to hide the last visible column (the checkbox snaps back).
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex - The column's manifest index (stable within a bake).
	 * @param {boolean} pVisible - true to show the column, false to hide it.
	 * @returns {boolean}
	 */
	toggleTabularColumnVisibility(pViewHash, pGroupIndex, pColumnIndex, pVisible)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup)
		{
			return false;
		}
		let tmpConfig = this._ensureTabularColumnChooserConfig(tmpGroup);
		if (!tmpConfig)
		{
			return false;
		}
		let tmpColumns = this._getTabularChoosableColumns(tmpView, tmpGroup);
		let tmpColumn = tmpColumns.find((pCandidate) => pCandidate.ColumnIndex === Number(pColumnIndex));
		if (!tmpColumn)
		{
			return false;
		}
		let tmpHiddenSet = this._getTabularColumnChooserHiddenSet(tmpView, tmpGroup);
		if (pVisible)
		{
			tmpHiddenSet.delete(tmpColumn.Key);
		}
		else
		{
			let tmpVisibleCount = tmpColumns.filter((pCandidate) => pCandidate.Visible).length;
			if (tmpVisibleCount <= 1 && tmpColumn.Visible)
			{
				this.log.warn(`PICT Form Tabular column chooser on group [${tmpGroup.Hash}] refused to hide the last visible column [${tmpColumn.Key}].`);
				// Repaint the popover so the refused checkbox snaps back to checked.
				this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
				this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
				return false;
			}
			tmpHiddenSet.add(tmpColumn.Key);
		}
		this.pict.setStateValueAtAddress(this._getTabularHiddenColumnsAddress(tmpView, tmpConfig), null, Array.from(tmpHiddenSet));
		this._rebuildTabularGroupView(tmpView);
		// The re-render replaced the popover element (closed); keep the menu open
		// so the user can toggle several columns in one visit.
		this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
		return true;
	}

	/**
	 * Inline-handler entry point: resets a group's column visibility to its
	 * configured defaults (the reset footer button's handler). Writes the
	 * default hidden set into the form data explicitly — the user interacted,
	 * so the state should serialize deterministically with a save.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @returns {boolean}
	 */
	resetTabularColumnVisibility(pViewHash, pGroupIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup)
		{
			return false;
		}
		let tmpConfig = this._ensureTabularColumnChooserConfig(tmpGroup);
		if (!tmpConfig)
		{
			return false;
		}
		this.pict.setStateValueAtAddress(this._getTabularHiddenColumnsAddress(tmpView, tmpConfig), null, this._getTabularColumnChooserDefaultHidden(tmpGroup));
		this._rebuildTabularGroupView(tmpView);
		this._renderTabularColumnChooserPopover(tmpView, tmpGroup);
		this._paintTabularColumnChooserOpenState(tmpView, tmpGroup, true);
		return true;
	}

	/**
	 * A `<colgroup>` sizing the visible data columns as percentages of the table,
	 * in proportion to each descriptor's `PictForm.Width` (missing, zero or
	 * unparseable counts as 1, as in the Record layout). Leading non-data columns
	 * get an unsized `<col>` so the data widths line up.
	 *
	 * Returns an empty string when no visible column carries a positive Width, so
	 * tables without widths keep the browser's automatic column sizing.
	 *
	 * @param {Object} pGroup
	 * @param {Set<string>|null} pChooserHiddenSet - columns hidden by the ColumnChooser
	 * @param {number} pLeadingColumnCount - row-select, row label and left editing-control columns
	 * @returns {string}
	 */
	_buildTabularColGroupHTML(pGroup, pChooserHiddenSet, pLeadingColumnCount)
	{
		let tmpRawWidths = [];
		let tmpAnyWidth = false;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpHash];
			if (!tmpDescriptor || (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden))
			{
				continue;
			}
			if (pChooserHiddenSet && pChooserHiddenSet.has(String(tmpHash)))
			{
				continue;
			}
			let tmpWidth = Math.abs(parseFloat(tmpDescriptor.PictForm ? tmpDescriptor.PictForm.Width : undefined));
			if (!tmpWidth || isNaN(tmpWidth))
			{
				tmpWidth = 1;
			}
			else
			{
				tmpAnyWidth = true;
			}
			tmpRawWidths.push(tmpWidth);
		}

		if (!tmpAnyWidth)
		{
			return '';
		}

		let tmpTotal = tmpRawWidths.reduce((pSum, pWidth) => pSum + pWidth, 0);
		let tmpColGroup = '<colgroup class="pict-tabular-colgroup">';
		for (let l = 0; l < pLeadingColumnCount; l++)
		{
			tmpColGroup += '<col>';
		}
		for (let c = 0; c < tmpRawWidths.length; c++)
		{
			let tmpPercent = Math.round((tmpRawWidths[c] / tmpTotal) * 10000) / 100;
			tmpColGroup += `<col style="width:${tmpPercent}%">`;
		}
		tmpColGroup += '</colgroup>';
		return tmpColGroup;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';
		let tmpTemplateSetRecordRowTemplate = '';

		// Read new optional configuration.
		let tmpEditingControlsPosition = (typeof pGroup.EditingControlsPosition === 'string') ? pGroup.EditingControlsPosition : 'right';
		let tmpRowLabels = Array.isArray(pGroup.RowLabels) ? pGroup.RowLabels : [];
		let tmpSuppressDefaultColumnHeaderRow = (pGroup.SuppressDefaultColumnHeaderRow === true);
		// ColumnSorting (off by default): injects a clickable sort-glyph span into every prime header cell.
		let tmpColumnSortingEnabled = (pGroup.ColumnSorting === true);
		if (tmpColumnSortingEnabled && !pGroup._SortState)
		{
			pGroup._SortState = { ColumnIndex: -1, Direction: 'none' };
		}
		// ColumnChooser (off by default): a menu of checkboxes above the table that
		// shows/hides columns, with the hidden set stored in the form data. Normalized
		// BEFORE the headers expand so chooser-hidden columns adjust header spans.
		pGroup._ColumnChooserConfig = this._normalizeColumnChooserConfig(pGroup.ColumnChooser, `${pGroup.Hash}_HiddenColumns`);
		let tmpChooserHiddenSet = this._getTabularColumnChooserHiddenSet(pView, pGroup);
		// Remember what visibility this bake used, so a marshal carrying different
		// (e.g. freshly loaded) state knows to trigger a rebuild.
		pGroup._ColumnChooserBakedStateKey = tmpChooserHiddenSet ? Array.from(tmpChooserHiddenSet).sort().join('|') : '';
		let tmpExpandedHeaders = this._buildExpandedHeadersConfig(pView, pGroup);

		// Stash the structures referenced by the templates below.
		pGroup.ExpandedHeaders = tmpExpandedHeaders;
		pGroup.RowLabelHeaderCells = tmpRowLabels.map((pLabel) =>
			({
				Name: pLabel.Name || '',
				CSSClass: (typeof pLabel.CSSClass === 'string') ? pLabel.CSSClass : ''
			}));

		// Selectable rows / columns. When enabled, a checkbox column / header row is
		// rendered and the boolean selection state is stored in the form data so it
		// persists with a save. Solvers can read that state; selection optionally
		// auto-applies a highlight class.
		pGroup._RowSelectionConfig = this._normalizeSelectionConfig(pGroup.RowSelection, `${pGroup.Hash}_RowSelection`, 'pict-tabular-row-highlight');
		pGroup._ColumnSelectionConfig = this._normalizeSelectionConfig(pGroup.ColumnSelection, `${pGroup.Hash}_ColumnSelection`, 'pict-tabular-column-highlight');
		let tmpRowSelectionEnabled = (pGroup._RowSelectionConfig != null);
		let tmpColumnSelectionEnabled = (pGroup._ColumnSelectionConfig != null);
		let tmpEditingLeft = (tmpEditingControlsPosition === 'left');
		let tmpEditingRight = (tmpEditingControlsPosition === 'right');
		// Leading (non-data) columns that precede the data cells: row-select, row labels, left controls.
		let tmpLeadingColumnCount = (tmpRowSelectionEnabled ? 1 : 0) + tmpRowLabels.length + (tmpEditingLeft ? 1 : 0);

		// When EditingControlsPosition isn't 'right' (the default), the right-side editing-
		// controls slots are suppressed PER GROUP by gating their emission on tmpEditingRight
		// below (the RowHeader-ExtraPostfix parity cell and the per-row Row-ExtraPostfix cell).
		//
		// We must NOT suppress by registering an empty view-specific override here:
		// getViewSpecificTemplateHash() is keyed by the view's formsTemplateSetPrefix, which is
		// shared by EVERY tabular group in the section. A single 'hidden'/'left' group registering
		// the empty override would shadow the default editing-controls template for sibling groups
		// that DO want controls ('right'), deleting their menu column from the DOM entirely. The
		// gate is the group's own EditingControlsPosition, so each group is independent and a
		// view-specific override (if a host registers one) still applies to the groups that emit.

		// The chooser bar sits ABOVE the group's table container (a div can't live
		// inside <table> without the browser foster-parenting it out anyway).
		if (pGroup._ColumnChooserConfig)
		{
			tmpTemplate += this._buildTabularColumnChooserBarHTML(pView, pGroup);
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Group-Prefix ends with the <table> open tag and RowHeader-Prefix starts with <thead>.
		tmpTemplate += this._buildTabularColGroupHTML(pGroup, tmpChooserHiddenSet, tmpLeadingColumnCount);

		// Header section
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Emit additional header rows (above the default column-name row).
		// Each row gets its own <tr>; leading non-data columns get blank <th>s
		// prepended (and a trailing one for right-side editing controls) for alignment.
		for (let r = 0; r < tmpExpandedHeaders.length; r++)
		{
			let tmpHeaderRow = tmpExpandedHeaders[r];
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderRow-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
			for (let l = 0; l < tmpLeadingColumnCount; l++)
			{
				tmpTemplate += `<th class="pict-row-label-spacer"></th>`;
			}
			for (let c = 0; c < tmpHeaderRow.length; c++)
			{
				let tmpCellAddress = `getGroup("${pGroup.GroupIndex}").ExpandedHeaders.${r}.${c}`;
				tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderCell`, tmpCellAddress);
			}
			if (tmpEditingRight)
			{
				// Parity cell for the right-side editing-controls column. Tag it with the same
				// pict-tabular-editing-controls-header class as the left-controls header (below)
				// so host CSS sizes it like the controls column AND collapses it in lockstep when
				// that column is hidden -- otherwise it lingers as an empty phantom column and the
				// stacked-header rule's bottom border overshoots the data columns.
				tmpTemplate += `<th class="pict-row-label-spacer pict-tabular-editing-controls-header"></th>`;
			}
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderRow-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}

		// Column-selection header row -- a <tr> of checkboxes, one per visible data
		// column, plus leading/trailing spacers to line up with the data columns.
		if (tmpColumnSelectionEnabled)
		{
			let tmpColumnSelectionState = this._getTabularSelectionArray(pView, pGroup._ColumnSelectionConfig);
			let tmpColumnSelectRow = `<tr class="pict-tabular-column-select-row">`;
			for (let l = 0; l < tmpLeadingColumnCount; l++)
			{
				tmpColumnSelectRow += `<th class="pict-row-label-spacer"></th>`;
			}
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpColumnDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
				if (!tmpColumnDescriptor || (tmpColumnDescriptor.PictForm && tmpColumnDescriptor.PictForm.TabularHidden))
				{
					continue;
				}
				if (tmpChooserHiddenSet && tmpChooserHiddenSet.has(String(pGroup.supportingManifest.elementAddresses[k])))
				{
					continue;
				}
				let tmpColumnCheckedAttr = tmpColumnSelectionState[k] ? ' checked="checked"' : '';
				tmpColumnSelectRow += `<th class="pict-tabular-column-select">`
					+ `<input type="checkbox"${tmpColumnCheckedAttr} onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnSelection('${pView.Hash}', ${pGroup.GroupIndex}, ${k}, this.checked)">`
					+ `</th>`;
			}
			if (tmpEditingRight)
			{
				// Parity cell for the right-side editing-controls column (mirrors the extra-header
				// row above) -- collapses with the column via pict-tabular-editing-controls-header.
				tmpColumnSelectRow += `<th class="pict-row-label-spacer pict-tabular-editing-controls-header"></th>`;
			}
			tmpColumnSelectRow += `</tr>`;
			tmpTemplate += tmpColumnSelectRow;
		}

		// Existing ExtraPrefix slot (preserved for host overrides)
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-ExtraPrefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Row-selection header cell.
		if (tmpRowSelectionEnabled)
		{
			tmpTemplate += `<th class="pict-row-label-header pict-tabular-row-select-header">${this._escapeHTML(pGroup._RowSelectionConfig.HeaderLabel)}</th>`;
		}

		// Row label header cells in the default header row.
		for (let l = 0; l < tmpRowLabels.length; l++)
		{
			let tmpLabelHeaderAddress = `getGroup("${pGroup.GroupIndex}").RowLabelHeaderCells.${l}`;
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowLabel-HeaderCell`, tmpLabelHeaderAddress);
		}

		// Header cell matching the left-side editing controls column, if configured.
		if (tmpEditingLeft)
		{
			tmpTemplate += `<th class="pict-row-label-header pict-tabular-editing-controls-header"></th>`;
		}

		// Per-descriptor header cells + the per-descriptor row body template.
		let tmpDataColumnCount = 0;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			// Chooser-hidden columns are skipped at bake time (neither header nor row
			// cells render) but their record data is never touched — showing the
			// column again restores it intact, same invariant as DynamicColumns.
			if (tmpChooserHiddenSet && tmpChooserHiddenSet.has(String(tmpSupportingManifestHash)))
			{
				continue;
			}
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			tmpInput.PictForm.RowIndex = 0;

			if (!tmpSuppressDefaultColumnHeaderRow)
			{
				if (tmpColumnSortingEnabled)
				{
					tmpTemplate += this._buildSortableHeaderCell(pView, pGroup, tmpInput, k);
				}
				else
				{
					tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-HeaderCell`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				}
			}

			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Cell-Prefix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
			let tmpInputType = (('PictForm' in tmpInput) && tmpInput.PictForm.InputType) ? tmpInput.PictForm.InputType : 'Default';
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInputType, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`, pGroup.GroupIndex, k);
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Cell-Postfix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
			tmpDataColumnCount++;
		}

		// Right-side editing-controls header parity cell -- only when this group keeps its
		// controls on the right. Gated per group (matches the extra-header-row parity above).
		if (tmpEditingRight)
		{
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-ExtraPostfix`, `getGroup("${pGroup.GroupIndex}")`);
		}
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// Warn on header alignment mismatches (data-column count must equal each extra-header
		// row's total ColumnSpan).
		for (let r = 0; r < tmpExpandedHeaders.length; r++)
		{
			let tmpSpanTotal = 0;
			for (let c = 0; c < tmpExpandedHeaders[r].length; c++)
			{
				tmpSpanTotal += tmpExpandedHeaders[r][c].ColumnSpan || 1;
			}
			if (tmpSpanTotal !== tmpDataColumnCount)
			{
				this.log.warn(`PICT Form [${pView.UUID}]::[${pView.Hash}] tabular group [${pGroup.Hash}] header row ${r} total ColumnSpan (${tmpSpanTotal}) does not match data column count (${tmpDataColumnCount}). Header will visually misalign.`);
			}
		}

		// Compute initial row label metadata; recomputed on every marshal in onDataMarshalToForm.
		this._computeRowLabelMetadata(pView, pGroup);

		// This is the template by which the tabular template includes the rows.
		// The template recursion here is difficult to envision without drawing it.
		// TODO: Consider making this function available in manyfest in some fashion it seems dope.
		let tmpTemplateSetVirtualRowTemplate = '';
		// Row-Prefix references the per-row MTVS record (not the group) so the <tr>
		// can carry data-tabular-row-index for the highlight/color/selection features.
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-Prefix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-ExtraPrefix`, `Record`);

		// Leading cells: the row-selection checkbox and the row-label columns
		// (both emitted by the {~TRL:~} tag), followed by left-side editing controls.
		if (tmpRowLabels.length > 0 || tmpRowSelectionEnabled)
		{
			tmpTemplateSetVirtualRowTemplate += `{~TRL:${pView.Hash}~}`;
		}
		if (tmpEditingLeft)
		{
			tmpTemplateSetVirtualRowTemplate += `{~TEC:${pView.Hash}~}`;
		}

		tmpTemplateSetVirtualRowTemplate += `\n\n{~T:${pGroup.SectionTabularRowTemplateHash}:Record~}\n`;
		// Right-side editing-controls cell (del/up/down) -- only when this group keeps its
		// controls on the right. Gated per group so a sibling group's 'hidden'/'left' setting
		// can't suppress this group's column. 'left' emits its controls via {~TEC:~} above.
		if (tmpEditingRight)
		{
			tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-ExtraPostfix`, `Record`);
		}
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// This is a custom template expression
		tmpTemplate += `\n\n{~MTVS:${pGroup.SectionTabularRowVirtualTemplateHash}:${pGroup.GroupIndex}:${pView.getMarshalDestinationAddress()}.${pGroup.RecordSetAddress}~}\n`;

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		// Add the TemplateSetTemplate
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowVirtualTemplateHash, tmpTemplateSetVirtualRowTemplate);
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowTemplateHash, tmpTemplateSetRecordRowTemplate);

		return tmpTemplate;
	}

	/**
	 * Called after the tabular group template has been (re)rendered into the DOM.
	 * Re-applies the selection highlight classes from the stored selection arrays so
	 * a freshly rendered table shows its checked rows/columns highlighted without
	 * waiting for a marshal or a solve. The render just rebuilt the row/cell DOM, so
	 * any classes a previous pass applied are gone and must be restored here.
	 *
	 * This is what makes a solve-free load (e.g. a read-only form that must not run
	 * solvers because they can mutate data) show its saved highlights immediately.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {boolean}
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		if (!pGroup)
		{
			return true;
		}
		this._reapplyTabularSelectionHighlights(pView, pGroup);
		return true;
	}

	/**
	 * Called after data is marshaled to the form. Re-runs DynamicColumns
	 * resolution and row-label clustering so additions/removals of source
	 * data flow into the rendered table without manual refresh calls.
	 *
	 * Loop guard: only triggers a template rebuild + re-render when the
	 * desired set of dynamic descriptor hashes ACTUALLY changes from the
	 * cached state, so steady state is a no-op (just a row-label recompute).
	 * A label-only change (same columns, a source row renamed) takes the
	 * lighter render()-only path so the header text re-bakes without a rebuild.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		if (!pGroup)
		{
			return true;
		}
		// Avoid recursion when this hook itself triggers a render -> marshal cycle.
		if (pGroup._RebuildInProgress)
		{
			return true;
		}

		let tmpHasDynamicColumns = Array.isArray(pGroup.DynamicColumns) && pGroup.DynamicColumns.length > 0;
		if (tmpHasDynamicColumns && this.fable.ManifestFactory && typeof this.fable.ManifestFactory._resolveDynamicColumns === 'function')
		{
			let tmpResult = this.fable.ManifestFactory._resolveDynamicColumns(pView, pGroup);
			if (tmpResult && tmpResult.changed)
			{
				pGroup._RebuildInProgress = true;
				try
				{
					pView.rebuildCustomTemplate();
					pView.render();
					// Refill the freshly rebuilt table DOM in this same marshal cycle.
					this._refillAfterDynamicColumnRebuild(pView);
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				// The re-render rebuilt the table DOM -- restore selection highlights.
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
			if (tmpResult && tmpResult.namesChanged)
			{
				// The column SET is unchanged but an existing column's display label was
				// refreshed (e.g. a source row renamed). _resolveDynamicColumns already
				// updated the descriptor Name in place; a render() re-bakes the header
				// labels from it -- no structural template rebuild required.
				pGroup._RebuildInProgress = true;
				try
				{
					pView.render();
					// Same-cycle refill: a label-only re-render still repaints the cell DOM.
					this._refillAfterDynamicColumnRebuild(pView);
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
		}

		// When the chooser's effective hidden-column set differs from the one the
		// current table template was baked with (e.g. the host just loaded saved
		// form data carrying a <GroupHash>_HiddenColumns array), rebuild so the
		// table reflects the loaded visibility. Steady state is a no-op — the
		// bake stamped _ColumnChooserBakedStateKey from the same form data.
		if (this._ensureTabularColumnChooserConfig(pGroup))
		{
			let tmpCurrentStateKey = this._getTabularColumnChooserStateKey(pView, pGroup);
			if (tmpCurrentStateKey !== pGroup._ColumnChooserBakedStateKey)
			{
				pGroup._RebuildInProgress = true;
				try
				{
					pView.rebuildCustomTemplate();
					pView.render();
					// Refill the freshly rebuilt table DOM in this same marshal cycle.
					this._refillAfterDynamicColumnRebuild(pView);
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
		}

		this._computeRowLabelMetadata(pView, pGroup);
		// Keep selection highlights in sync with the (possibly reloaded) selection data.
		this._reapplyTabularSelectionHighlights(pView, pGroup);
		return true;
	}

	/**
	 * After a mid-marshal DynamicColumns rebuild/re-render, the freshly painted table DOM
	 * is empty: the enclosing onMarshalToView already ran its marshalDataToForm BEFORE this
	 * hook re-rendered, so the dynamic cells lost the values that pass had just written and
	 * would only refill on the NEXT marshal -- the "% Passing table blanks on row add/delete
	 * or Source/Name select until another action brings it back" bug. Re-marshal the view's
	 * data into the new DOM here so the cells repopulate within the SAME cycle. This is safe
	 * to call from inside onDataMarshalToForm: marshalDataToForm only writes model values into
	 * the inputs and does NOT itself invoke onDataMarshalToForm, so it cannot recurse here.
	 *
	 * @param {Object} pView
	 */
	_refillAfterDynamicColumnRebuild(pView)
	{
		try
		{
			this.pict.providers.Informary.marshalDataToForm(pView.getMarshalDestinationObject(), pView.formID, pView.sectionManifest);
		}
		catch (pError)
		{
			this.log.error(`Error refilling tabular dynamic-column cells after rebuild: ${pError}`);
		}
	}
}

module.exports = TabularLayout;

},{"../Pict-Provider-DynamicLayout.js":592}],633:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

const libPictSectionTuiGridLayout = require('./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js');

class TuiGridLayout extends libPictSectionGroupLayout
{
	/**
	 * @param {import('pict')} pFable - The Fable instance.
	 * @param {any} [pOptions={}] - The options for the TuiGrid layout.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		this.viewGridConfigurations = {};

		this.viewTuiGrids = {};
		this.viewGridState = {};
	}

	/**
	 * Generates the HTML ID for a TuiGrid group within a specific view.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {string} - The generated HTML ID.
	 */
	getGridHtmlID(pView, pGroup)
	{
		return `View-${pView.UUID}-GroupTuiGrid-${pGroup.GroupIndex}`;
	}

	/**
	 * Returns the HTML ID of the Tui view in the specified group.
	 *
	 * @param {string} pView - The Tui view.
	 * @param {string} pGroup - The group.
	 * @returns {string} - The HTML ID of the Tui view.
	 */
	getViewTuiHtmlID(pView, pGroup)
	{
		return `#${this.getGridHtmlID(pView, pGroup)}`;
	}

	/**
	 * Retrieves the TuiGrid view for a given view and group.
	 *
	 * @param {string} pView - The view name.
	 * @param {string} pGroup - The group name.
	 * @returns {libPictSectionTuiGridLayout} - The TuiGrid view if it exists, otherwise false.
	 */
	getViewGrid(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		if (!this.viewTuiGrids.hasOwnProperty(tmpGridUUID))
		{
			return null;
		}
		return this.viewTuiGrids[tmpGridUUID];
	}

	/**
	 * Creates a TuiGrid view for the specified view and group.
	 *
	 * @param {any} pView - The view object.
	 * @param {any} pGroup - The group object.
	 * @return {libPictSectionTuiGridLayout} - The created TuiGrid view.
	 */
	createViewTuiGrid(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		if (this.viewTuiGrids.hasOwnProperty(tmpGridUUID))
		{
			// Purely for information for now.
			this.log.info(`Dynamic TuiGrid view [${pView.UUID}]::[${pView.Hash}] is reinitializing a TuiGrid in group ${pGroup.GroupIndex} TuiGrid UUID [${tmpGridUUID}].`);
			// ...we need to clear out the littered tuiGrid views probably.
		}
		// Generate the pict view
		let tmpGridConfiguration = this.getViewTuiConfiguration(pView, pGroup);
		/** @type {libPictSectionTuiGridLayout} */
		let tmpGridView = this.pict.addView(tmpGridUUID, tmpGridConfiguration, libPictSectionTuiGridLayout);
		// Manually initialize the view
		tmpGridView.cachedGridData = this.generateDataRepresentation(pView, pGroup);

		tmpGridView.initialize();

		this.viewTuiGrids[tmpGridUUID] = tmpGridView;
		return tmpGridView;
	}

	/**
	 * Retrieves the TuiGrid configuration for a specific view and group.
	 *
	 * @param {any} pView - The view identifier.
	 * @param {any} pGroup - The group identifier.
	 * @returns {object} - The TuiGrid configuration for the specified view and group.
	 */
	getViewTuiConfiguration(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		// If there isn't yet a tui configuration, make a new one.
		if (!this.viewGridConfigurations.hasOwnProperty(tmpGridUUID))
		{
			// Generate a unique destination for the TuiGrid
			let tmpGroupTuiGridConfiguration = JSON.parse(JSON.stringify(libPictSectionTuiGridLayout.default_configuration));
			this.viewGridConfigurations[tmpGridUUID] = tmpGroupTuiGridConfiguration;

			tmpGroupTuiGridConfiguration.DefaultDestinationAddress = this.getViewTuiHtmlID(pView, pGroup);
			tmpGroupTuiGridConfiguration.TargetElementAddress = this.getViewTuiHtmlID(pView, pGroup);
			tmpGroupTuiGridConfiguration.TuiColumnSchema = [];
			/*
				{
					"header": "IDRecord",
					"name": "idrecord",
					"PictTriggerSolveOnChange": true
				},
				{
					"header": "Description",
					"name": "description",
					"editor": "text"
				}
			*/

			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
				// Update the InputIndex to match the current render config
				if (!('PictForm' in tmpInput))
				{
					tmpInput.PictForm = {};
				}
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = 0;

				let tmpTuiGridInput = {
					"header": tmpInput.Name,
					"name": tmpInput.Hash,
					// TODO: Should these all trigger solves?  Seems pretty expensive?
					"PictTriggerSolveOnChange": true,
					"PictSectionFormInput": tmpInput
				};
				switch (tmpInput.DataType)
				{
					case 'Number':
					case 'PreciseNumber':
						tmpTuiGridInput.editor = (
							{
								"type": "EditorNumber",
								"options": {}
							});
						tmpTuiGridInput.editor.options.decimalPrecision = tmpInput?.PictForm?.DecimalPrecision ?? 10;
						break;
					case 'String':
						tmpTuiGridInput.editor = 'text';
						break;
					case 'DateTime':
						tmpTuiGridInput.editor = {
							type: 'datePicker',
							options: {
								format: 'yyyy-MM-dd'
							}
						};
						break;
				}
				switch (tmpInput.PictForm.InputType)
				{
					case 'Option':
					{
						tmpTuiGridInput.editor = (
							{
								"type": "select",
								"options": {
									"listItems": []
								}
							});
						let tmpDefaultData = tmpInput.PictForm.SelectOptions;
						if (tmpInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pView.Hash, tmpInput.PictForm.SelectOptionsPickList))
						{
							tmpDefaultData = this.pict.providers.DynamicMetaLists.getList(pView.Hash, tmpInput.PictForm.SelectOptionsPickList);
						}
						if (tmpDefaultData && Array.isArray(tmpDefaultData))
						{
							for (let i = 0; i < tmpDefaultData.length; i++)
							{
								let tmpOption = (
									{
										"value": tmpDefaultData[i].id,
										"text": tmpDefaultData[i].text
									});
								tmpTuiGridInput.editor.options.listItems.push(tmpOption);
							}
						}
						break;
					}
				}
				tmpGroupTuiGridConfiguration.TuiColumnSchema.push(tmpTuiGridInput);
			}
		}

		return this.viewGridConfigurations[tmpGridUUID];
	}

	/**
	 * Generate a group layout template for a TuiGrid dynamically generated group view.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		pGroup.TuiGridHTMLID = this.getGridHtmlID(pView, pGroup);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TuiGrid-Container`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TuiGrid-Controls`, `getGroup("${pGroup.GroupIndex}")`);
		//tmpTemplate += `<div id="${this.getGridHtmlID(pView, pGroup)}"></div>`;
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}

	/**
	 * Generates a data representation for the given view and group.
	 *
	 * @param {any} pView - The view object.
	 * @param {any} pGroup - The group object.
	 * @returns {Array<any>} - The generated data representation.
	 */
	generateDataRepresentation(pView, pGroup)
	{
		let tmpData = [];
		this.viewGridState[this.getGridHtmlID(pView, pGroup)] = tmpData;

		let tmpTabularRecordSet = pView.getTabularRecordSet(pGroup.GroupIndex);

		if (Array.isArray(tmpTabularRecordSet))
		{
			for (let j = 0; j < tmpTabularRecordSet.length; j++)
			{
				let tmpTuiRowData = { RecordIndex: j };
				let tmpTabularRecord = tmpTabularRecordSet[j];
				for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
				{
					let tmpElementDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
					if (tmpElementDescriptor)
					{
						pGroup.supportingManifest.setValueAtAddress(tmpTuiRowData, tmpElementDescriptor.Hash, pGroup.supportingManifest.getValueByHash(tmpTabularRecord, tmpElementDescriptor.Hash));
					}
				}
				tmpData.push(tmpTuiRowData);
			}
		}
		return tmpData;
	}

	/**
	 * Initialize the TuiGrid!
	 *
	 * @param {any} pView  - The view to initialize the newly rendered control for
	 * @param {any} pGroup - The group to initialize the newly rendered control for
	 * @returns {boolean} - Returns true if the initialization is successful, false otherwise.
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		// We do this at the last minute to avoid extraneous creation of these.
		let tmpTuiGridView = this.createViewTuiGrid(pView, pGroup);

		// TODO: Guard?
		tmpTuiGridView.render();

		if (tmpTuiGridView.tuiGrid)
		{
			//FIXME: masking the type from the underlying tui-grid so we can decorate it here
			//       would be better to decorate the type from the upstream package.
			/** @type {any} */
			const tmpControl = tmpTuiGridView.tuiGrid;
			tmpControl.View = pView;
			tmpControl.Group = pGroup;
		}

		return true;
	}

	/**
	 * Marshals data from a view to a form in the TuiGrid layout.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {boolean} - Returns true if the data marshaling is successful, false otherwise.
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		let tmpTuiGridView = this.getViewGrid(pView, pGroup);

		if (!tmpTuiGridView)
		{
			this.log.error(`PICT Form TuiGrid [${pView.UUID}]::[${pView.Hash}] error marshalling data to form: missing TuiGrid for group ${pGroup.GroupIndex}; skipping marshal.`);
			return false;
		}

		// painstakingly compare each value for now.
		let tmpTabularRecordSet = pView.getTabularRecordSet(pGroup.GroupIndex);
		let tmpBrowserRecordSet = tmpTuiGridView.tuiGrid.getData();

		if (Array.isArray(tmpTabularRecordSet))
		{
			for (let j = 0; j < tmpTabularRecordSet.length; j++)
			{
				try
				{
					let tmpStoredRowData = tmpTabularRecordSet[j];
					// Get the tuigrid row that represents AppData
					let tmpBrowserRowData = tmpBrowserRecordSet[j];
					// Enumerate each entry in the manifest and see if changes happened
					for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
					{
						let tmpElementDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
						if (tmpElementDescriptor)
						{
							let tmpBrowserValue = pGroup.supportingManifest.getValueAtAddress(tmpBrowserRowData, tmpElementDescriptor.Hash);
							let tmpAppStateValue = pGroup.supportingManifest.getValueByHash(tmpStoredRowData, tmpElementDescriptor.Hash);
							if (tmpBrowserValue !== tmpAppStateValue)
							{
								this.log.trace(`PICT Form TuiGrid Dynamic View [${pView.UUID}]::[${pView.Hash}] updating tabular record ${j} element ${tmpElementDescriptor.Hash} from [${tmpBrowserValue}] to [${tmpAppStateValue}].`);
								tmpTuiGridView.tuiGrid.setValue(j, tmpElementDescriptor.Hash, tmpAppStateValue);
							}
						}
					}
				}
				catch (pError)
				{
					this.log.error(`PICT Form TuiGrid [${pView.UUID}]::[${pView.Hash}] gross error marshalling data to form: ${pError}`);
				}
			}
		}

		return true;
	}

	/**
	 * Adds a new row to the Pict-Layout-TuiGrid.
	 *
	 * @param {string} pViewHash - The hash of the PICT form view.
	 * @param {number} pGroupIndex - The index of the group in the view.
	 * @returns {boolean} Returns false if there is an error adding the row, otherwise returns true.
	 */
	addRow(pViewHash, pGroupIndex)
	{
		if (!(pViewHash in this.pict.views))
		{
			this.log.error(`PICT Form View [${pViewHash}] error adding row: no matching view found in pict.`);
			return false;
		}
		let tmpView = this.pict.views[pViewHash];
		let tmpGroup = tmpView.getGroup(pGroupIndex);
		if (!tmpGroup)
		{
			this.log.error(`PICT Form View [${pViewHash}] error adding row: no matching group index ${pGroupIndex} found in view.`);
			return false;
		}

		let tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		let tmpNewObject = tmpGroup.supportingManifest.populateDefaults({});

		if (Array.isArray(tmpDestinationObject))
		{
			tmpDestinationObject.push(tmpNewObject);
		}
		else if (typeof(tmpDestinationObject) === 'object')
		{
			let tmpRowIndex = tmpView.fable.getUUID();
			tmpDestinationObject[tmpRowIndex] = tmpNewObject;
		}

		// Add it to the TUIGrid
		let tmpTuiGridView = this.getViewGrid(tmpView, tmpGroup);
		if (tmpTuiGridView)
		{
			tmpTuiGridView.tuiGrid.appendRow(JSON.parse(JSON.stringify(tmpNewObject)));
		}
	}
}

module.exports = TuiGridLayout;

},{"../Pict-Provider-DynamicLayout.js":592,"./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js":634}],634:[function(require,module,exports){
const libPictSectionTuiGrid = require('pict-section-tuigrid');

/**
 * TuiGridLayout class represents a layout for TuiGrid in the Pict-Layout-TuiGrid module.
 * @extends libPictSectionTuiGrid
 */
class TuiGridLayout extends libPictSectionTuiGrid
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.viewGridConfigurations = {};

		this.cachedGridData = [];
	}

	/**
	 * Custom configuration for the grid settings -- fires when
	 *
	 * Sets the grid data to the cached grid data for the tuigrid.
	 *
	 * @returns {any} The result of the super.customConfigureGridSettings() method.
	 */
	customConfigureGridSettings()
	{
		// Set the grid data to the cached grid data
		this.gridSettings.data = this.cachedGridData;
		return super.customConfigureGridSettings();
	}

	/**
	 * Handles the change event in the Pict-Section-TuiGrid component.
	 *
	 * Updates the state in the model based on the grid changes.  This is
	 *
	 * @param {Object} pChangeData - The change data object.
	 * @returns {any} - The result of the super changeHandler method.
	 */
	changeHandler(pChangeData)
	{
		// Update the state in our model based on the grid

		for (let i = 0; i < pChangeData.changes.length; i++)
		{
			let tmpChange = pChangeData.changes[i];
			let tmpRowIndex = pChangeData.instance.getValue(tmpChange.rowKey, 'RecordIndex');
			// TODO: Right now each of these calls runs a solve() on the entire form.  This is not ideal.
			pChangeData.instance.View.setDataTabularByHash(pChangeData.instance.Group.GroupIndex, tmpChange.columnName, tmpRowIndex, tmpChange.value);
		}

		return super.changeHandler(pChangeData);
	}
}

module.exports = TuiGridLayout;

},{"pict-section-tuigrid":716}],635:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class VerticalRecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		if (!('Rows' in pGroup))
		{
			pGroup.Rows = [];
		}

		pGroup.Rows.sort((rowA, rowB) =>
		{
			if (rowA.RowNumber && rowB.RowNumber)
			{
				return rowA.RowNumber >= rowB.RowNumber ? 1 : -1;
			}
			if (!rowA.RowNumber && !rowB.RowNumber)
			{
				return rowA.Hash >= rowB.Hash ? 1 : -1;
			}
			return rowA.RowNumber ? 1 : -1;
		});

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		// Every input has its own "row" in the vertical layout
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-VerticalRow-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			let tmpRow = pGroup.Rows[j];
			// There are three row layouts: Record, Tabular and Columnar
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{	
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;

				tmpTemplate += tmpMetatemplateGenerator.getVerticalInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}
		}

		// Close every input that has its own "row" in the vertical layout
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-VerticalRow-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = VerticalRecordLayout;

},{"../Pict-Provider-DynamicLayout.js":592}],636:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class ManifestConversionToCSV extends libFableServiceProviderBase
{
    constructor(pFable, pOptions, pServiceHash)
    {
        super(pFable, pOptions, pServiceHash);

        /** @type {import('pict') & { instantiateServiceProviderWithoutRegistration: (hash: string, options?: any, uuid?: string) => any }} */
        this.fable;
        /** @type {any} */
        this.log;
        /** @type {string} */
        this.UUID;

        this.CSV_HEADER = [
            "Form",
            "Form Name",
            "SubManifest",
			"HideTabularEditingControls",
			"GroupRecordSetAddress",
            "DataOnly",
            "Section Name",
            "Section Hash",
            "Group Name",
            "Group Hash",
            "Group Layout",
            "Group CSS",
            "Group Show Title",
            "Row",
            "Width",
            "Minimum Row Count",
            "Maximum Row Count",
            "Input Address",
            "Input Name",
            "Input Hash",
            "Input Extra",
            "Units",
            "DataType",
            "Decimal Precision",
            "InputType",
            "Equation",
            "Equation Ordinal",
            "Default",
            "Description",
            "Tooltip",
            "Input Notes",
            "Entity",
            "EntityColumnFilter",
            "EntityDestination",
            "EntitySingleRecord",
            "TriggerGroup",
            "TriggerAddress",
            "TriggerAllInputs",
            "MarshalEmptyValues",
            "ChartType",
            "ChartLabelsAddress",
            "ChartLabelsSolver",
            "ChartDatasetsAddress",
            "ChartDatasetsLabel",
            "ChartDatasetsSolvers"
        ];

        // Generate the header to column mapping
        this.CSV_COLUMN_MAP = {};
        for (let i = 0; i < this.CSV_HEADER.length; i++)
        {
            let tmpColumnName = this.CSV_HEADER[i];
            this.CSV_COLUMN_MAP[tmpColumnName] = i;
        }
    }

    getRowFromDescriptor(pForm, pDescriptorKey, pDescriptor)
    {
        let tmpRow = new Array(this.CSV_HEADER.length).fill('');

        if ((!pDescriptor) || (typeof(pDescriptor) !== 'object') || !pDescriptorKey || (typeof(pDescriptorKey) !== 'string'))
        {
            return false;
        }

        let tmpPictForm = pDescriptor.PictForm;

        tmpRow[this.CSV_COLUMN_MAP["Form"]] = pForm;
        tmpRow[this.CSV_COLUMN_MAP["Form Name"]] = pDescriptor.FormName || '';
        tmpRow[this.CSV_COLUMN_MAP["SubManifest"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["DataOnly"]] = (typeof(tmpPictForm) === 'undefined') ? '1' : '';
        tmpRow[this.CSV_COLUMN_MAP["Section Name"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Section Hash"]] = (tmpPictForm && tmpPictForm.Section) ? tmpPictForm.Section
														: (pDescriptor.FormSection) ? pDescriptor.FormSection
														: '';
        tmpRow[this.CSV_COLUMN_MAP["Group Name"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group Hash"]] = (tmpPictForm && tmpPictForm.Group) ? tmpPictForm.Group
														: (pDescriptor.FormGroup) ? pDescriptor.FormGroup
														: '';
        tmpRow[this.CSV_COLUMN_MAP["Group Layout"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group CSS"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group Show Title"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Row"]] = (tmpPictForm && tmpPictForm.Row) ? tmpPictForm.Row : '';
        tmpRow[this.CSV_COLUMN_MAP["Width"]] = (tmpPictForm && tmpPictForm.Width) ? tmpPictForm.Width : '';
        tmpRow[this.CSV_COLUMN_MAP["Minimum Row Count"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Maximum Row Count"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Input Address"]] = (pDescriptor.DataAddress) ? pDescriptor.DataAddress : pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Name"]] = pDescriptor.Name || pDescriptor.DataAddress || pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Hash"]] = pDescriptor.Hash || pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Extra"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Units"]] = (tmpPictForm && tmpPictForm.Units) ? tmpPictForm.Units : '';
        tmpRow[this.CSV_COLUMN_MAP["DataType"]] = pDescriptor.DataType || 'String';
        tmpRow[this.CSV_COLUMN_MAP["Decimal Precision"]] = (tmpPictForm && tmpPictForm.DecimalPrecision) ? tmpPictForm.DecimalPrecision : '';
        tmpRow[this.CSV_COLUMN_MAP["InputType"]] = (tmpPictForm && tmpPictForm.InputType) ? tmpPictForm.InputType : '';
        tmpRow[this.CSV_COLUMN_MAP["Equation"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Default"]] = (pDescriptor.Default !== undefined) ? pDescriptor.Default : '';
        tmpRow[this.CSV_COLUMN_MAP["Description"]] = (pDescriptor.Description) ? pDescriptor.Description : '';
        tmpRow[this.CSV_COLUMN_MAP["Tooltip"]] = (tmpPictForm && tmpPictForm.Tooltip) ? tmpPictForm.Tooltip : '';
        tmpRow[this.CSV_COLUMN_MAP["Input Notes"]] = (tmpPictForm && tmpPictForm.SpreadsheetNotes) ? tmpPictForm.SpreadsheetNotes : '';

        tmpRow[this.CSV_COLUMN_MAP["Entity"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntityColumnFilter"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntityDestination"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntitySingleRecord"]] = '';
		/**
		tmpDescriptor.PictForm.EntitiesBundle = [
				{
					"Entity": tmpRecord.Entity,
					"Filter": `FBV~${tmpRecord.EntityColumnFilter}~EQ~{~D:Record.Value~}`,
					"Destination": tmpRecord.EntityDestination,
					// This marshals a single record
					"SingleRecord": tmpRecord.EntitySingleRecord ? true : false
				}
			]
		 */
		if (tmpPictForm && tmpPictForm.EntitiesBundle && Array.isArray(tmpPictForm.EntitiesBundle) && tmpPictForm.EntitiesBundle.length > 0)
		{
			let tmpEntityBundle = tmpPictForm.EntitiesBundle[0];
			if (tmpEntityBundle.Entity)
			{
				tmpRow[this.CSV_COLUMN_MAP["Entity"]] = tmpEntityBundle.Entity;
			}
			// Pull the filter column out if we can; we only want what's between "FBV~" and "~EQ~"
			if (tmpEntityBundle.Filter)
			{
				let tmpFilter = tmpEntityBundle.Filter;
				let tmpFilterStart = tmpFilter.indexOf('FBV~');
				let tmpFilterEnd = tmpFilter.indexOf('~EQ~');
				if ((tmpFilterStart >= 0) && (tmpFilterEnd > tmpFilterStart))
				{
					let tmpColumnFilter = tmpFilter.substring(tmpFilterStart + 4, tmpFilterEnd);
					tmpRow[this.CSV_COLUMN_MAP["EntityColumnFilter"]] = tmpColumnFilter;
				}
			}
			if (tmpEntityBundle.Destination)
			{
				tmpRow[this.CSV_COLUMN_MAP["EntityDestination"]] = tmpEntityBundle.Destination;
			}
			if (tmpEntityBundle.SingleRecord)
			{
				tmpRow[this.CSV_COLUMN_MAP["EntitySingleRecord"]] = 'true';
			}
		}

        tmpRow[this.CSV_COLUMN_MAP["TriggerGroup"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["TriggerAddress"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["TriggerAllInputs"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["MarshalEmptyValues"]] = '';
		if (tmpPictForm && tmpPictForm.AutofillTriggerGroup)
		{
			// Grab the first trigger group and put it in here.
			let tmpTriggerGroup;
			if (Array.isArray(tmpPictForm.AutofillTriggerGroup) && tmpPictForm.AutofillTriggerGroup.length > 0)
			{
				tmpTriggerGroup = tmpPictForm.AutofillTriggerGroup[0];
			}
			else if (typeof(tmpPictForm.AutofillTriggerGroup) === 'object')
			{
				tmpTriggerGroup = tmpPictForm.AutofillTriggerGroup;
			}
			if (tmpTriggerGroup)
			{
				if (tmpTriggerGroup.TriggerGroupHash)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerGroup"]] = tmpTriggerGroup.TriggerGroupHash;
				}
				if (tmpTriggerGroup.TriggerAllInputs)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerAllInputs"]] = 'true';
				}
				if (tmpTriggerGroup.TriggerAddress)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerAddress"]] = tmpTriggerGroup.TriggerAddress;
				}
				if (tmpTriggerGroup.MarshalEmptyValues)
				{
					tmpRow[this.CSV_COLUMN_MAP["MarshalEmptyValues"]] = 'true';
				}
			}
		}
        tmpRow[this.CSV_COLUMN_MAP["ChartType"]] = (tmpPictForm && tmpPictForm.ChartType) ? tmpPictForm.ChartType : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartLabelsAddress"]] = (tmpPictForm && tmpPictForm.ChartLabelsAddress) ? tmpPictForm.ChartLabelsAddress : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartLabelsSolver"]] = (tmpPictForm && tmpPictForm.ChartLabelsSolver) ? tmpPictForm.ChartLabelsSolver : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsAddress"]] = (tmpPictForm && tmpPictForm.ChartDatasetsAddress) ? tmpPictForm.ChartDatasetsAddress : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsLabel"]] = (tmpPictForm && tmpPictForm.ChartDatasetsSolvers && Array.isArray(tmpPictForm.ChartDatasetsSolvers) && tmpPictForm.ChartDatasetsSolvers.length > 0) ? tmpPictForm.ChartDatasetsSolvers[0].Label : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsSolvers"]] = (tmpPictForm && tmpPictForm.ChartDatasetsSolvers && Array.isArray(tmpPictForm.ChartDatasetsSolvers) && tmpPictForm.ChartDatasetsSolvers.length > 0) ? tmpPictForm.ChartDatasetsSolvers[0].DataSolver : '';

		if (tmpPictForm && (tmpPictForm.InputType == 'Option') && tmpPictForm.SelectOptions && Array.isArray(tmpPictForm.SelectOptions))
		{
			// Pull the select options into the Input Extra field as a comma-delimited list
			let tmpInputExtraOptions = '';

			for (let i = 0; i < tmpPictForm.SelectOptions.length; i++)
			{
				let tmpOption = tmpPictForm.SelectOptions[i];

				if (tmpOption.id && tmpOption.text)
				{
					if (tmpInputExtraOptions.length > 0)
					{
						tmpInputExtraOptions += ',';
					}
					tmpInputExtraOptions += `${tmpOption.id}^${tmpOption.text}`;
				}
			}

            tmpRow[this.CSV_COLUMN_MAP["Input Extra"]] = tmpInputExtraOptions;
		}

        return tmpRow;
    }

    createTabularArrayFromManifests(pManifest)
    {
        // CSV_COLUMN_MAP is already initialized in constructor

        // Convert the manifest to an array of CSV rows
        let tmpCSVRows = [];

        // Figure out the form
        let tmpForm = 'Default';
        if ((pManifest) && (pManifest.Scope) && (typeof(pManifest.Scope) === 'string'))
        {
            tmpForm = pManifest.Scope;
        }
        if ((pManifest) && (pManifest.Form) && (typeof(pManifest.Form) === 'string'))
        {
            tmpForm = pManifest.Form;
        }

        // Add the header row
        tmpCSVRows.push(this.CSV_HEADER);

        if (typeof(pManifest) !== 'object')
        {
            this.log.error('ManifestConversionToCSV: Provided manifest is not an object; cannot convert to CSV.');
            return tmpCSVRows;
        }

        if (!pManifest.Descriptors || (typeof(pManifest.Descriptors) !== 'object'))
        {
            this.log.error('ManifestConversionToCSV: Provided manifest does not have a valid Descriptors property; cannot convert to CSV.');
            return tmpCSVRows;
        }

        let tmpDescriptorKeys = Object.keys(pManifest.Descriptors);
        for (let i = 0; i < tmpDescriptorKeys.length; i++)
        {
            let tmpDescriptorKey = tmpDescriptorKeys[i];
            let tmpDescriptor = pManifest.Descriptors[tmpDescriptorKey];

            if ((!tmpDescriptor) || (typeof(tmpDescriptor) !== 'object'))
            {
                continue;
            }

            let tmpCSVRow = this.getRowFromDescriptor(tmpForm, tmpDescriptorKey, tmpDescriptor);
            if (tmpCSVRow)
            {
                tmpCSVRows.push(tmpCSVRow);
            }
        }

        for (let i = 0; i < pManifest.Sections.length; i++)
        {
            let tmpSection = pManifest.Sections[i];
            let tmpSectionHash = tmpSection.Hash || 'DEFAULT_SECTION_HASH';

            if ((!tmpSection) || (typeof(tmpSection) !== 'object'))
            {
                continue;
            }

            // See if the group has a name and decorate the manifest entry with the group name
            if (tmpSection.Groups && Array.isArray(tmpSection.Groups))
            {
                for (let j = 0; j < tmpSection.Groups.length; j++)
                {
                    let tmpGroup = tmpSection.Groups[j];
                    let tmpGroupHash = tmpGroup.Hash;

					if ((tmpGroup.Layout == 'Tabular') || (tmpGroup.Layout == 'RecordSet'))
					{
						// Pull in the reference manifest for this tabular set
						/*
							{
								"Name": "Boxes",
								"Hash": "BoxCollGrp",
								"Rows": [],
								"RecordSetSolvers": [
									"BoxFloorspace = BoxWidth * BoxDepth",
									"BoxVolume = BoxFloorspace * BoxHeight"
								],
								"MinimumRowCount": 3,
								"MaximumRowCount": 10,
								"ShowTitle": true,
								"Layout": "Tabular",
								"RecordSetAddress": "Boxes",
								"RecordManifest": "BoxCollectionData"
							}
						*/
			   			// Validate there is a RecordSetAddress and RecordManifest
						if (tmpGroup.RecordSetAddress && tmpGroup.RecordManifest)
						{
							// Find the Array placeholder in the CSV
							let tmpGroupArrayPlaceholderIndex = -1;
							for (let k = 0; k < tmpCSVRows.length; k++)
							{
								let tmpRow = tmpCSVRows[k];
								if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
								{
									let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
									let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
									if ((tmpRowSectionHash === tmpSectionHash) && (tmpRowGroupHash === tmpGroupHash))
									{
										// This is the row for this group
										tmpGroupArrayPlaceholderIndex = k;
										break;
									}

									// Try to match on the Input Address as a fallback
									let tmpRowInputAddress = tmpRow[this.CSV_COLUMN_MAP["Input Address"]];
									if (tmpRowInputAddress === tmpGroup.RecordSetAddress)
									{
										// Set the section and group hash here, this is an old manifest
										tmpRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
										tmpRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;
										tmpGroupArrayPlaceholderIndex = k;
										break;
									}
								}
							}
							if (tmpGroupArrayPlaceholderIndex >= 0)
							{
								let tmpRow = tmpCSVRows[tmpGroupArrayPlaceholderIndex];

								// Set the SubManifest on the placeholder row
								tmpRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;
								tmpRow[this.CSV_COLUMN_MAP["GroupRecordSetAddress"]] = tmpGroup.RecordSetAddress;
								tmpRow[this.CSV_COLUMN_MAP["HideTabularEditingControls"]] = tmpGroup.HideTabularEditingControls;

								// Now set the Minimum and Maximum Row Counts
								if (tmpGroup.MinimumRowCount)
								{
									tmpRow[this.CSV_COLUMN_MAP["Minimum Row Count"]] = tmpGroup.MinimumRowCount;
								}
								if (tmpGroup.MaximumRowCount)
								{
									tmpRow[this.CSV_COLUMN_MAP["Maximum Row Count"]] = tmpGroup.MaximumRowCount;
								}

								// Find the reference manifest, pull in the descriptors, and create rows for each
								let tmpReferenceManifest = pManifest.ReferenceManifests[tmpGroup.RecordManifest];
								let tmpReferenceManifestDescriptorKeys = Object.keys(tmpReferenceManifest.Descriptors);
								for (let m = 0; m < tmpReferenceManifestDescriptorKeys.length; m++)
								{
									let tmpReferenceDescriptorKey = tmpReferenceManifestDescriptorKeys[m];
									let tmpReferenceDescriptor = tmpReferenceManifest.Descriptors[tmpReferenceDescriptorKey];

									if ((!tmpReferenceDescriptor) || (typeof(tmpReferenceDescriptor) !== 'object'))
									{
										continue;
									}

									let tmpReferenceCSVRow = this.getRowFromDescriptor(tmpForm, tmpReferenceDescriptorKey, tmpReferenceDescriptor);
									if (tmpReferenceCSVRow)
									{
										// Set the Section and Group Hashes on this row
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;

										// Set the SubManifest on this row
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;

										// Insert this row after the placeholder
										tmpCSVRows.splice(tmpGroupArrayPlaceholderIndex + 1, 0, tmpReferenceCSVRow);
									}
								}
							}
						}
					}

                    if (tmpGroupHash)
                    {
                        for (let k = 0; k < tmpCSVRows.length; k++)
                        {
                            let tmpRow = tmpCSVRows[k];
                            if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
                            {
                                let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
                                if (tmpRowGroupHash === tmpGroupHash)
                                {
                                    // This is the row for this group
                                    tmpRow[this.CSV_COLUMN_MAP["Group Name"]] = tmpGroup.Name || tmpGroupHash;
									if (tmpGroup.Layout)
									{
										tmpRow[this.CSV_COLUMN_MAP["Group Layout"]] = tmpGroup.Layout;
									}
									if (tmpGroup.hasOwnProperty('ShowTitle'))
									{
										tmpRow[this.CSV_COLUMN_MAP["Group Show Title"]] = tmpGroup.ShowTitle;
									}
									if (tmpGroup.hasOwnProperty('CSSClass'))
									{
										tmpRow[this.CSV_COLUMN_MAP["Group CSS"]] = tmpGroup.CSSClass;
									}
                                }
                            }
                        }
                    }
                }
            }

			// See if there is a section name and decorate the manifest entries with the name
            for (let j = 0; j < tmpCSVRows.length; j++)
            {
                let tmpRow = tmpCSVRows[j];
                if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
                {
                    let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
                    if (tmpRowSectionHash === tmpSectionHash)
                    {
                        // This is the row for this section
                        tmpRow[this.CSV_COLUMN_MAP["Section Name"]] = tmpSection.Name || tmpSectionHash;
                    }
                }
            }

			// Now go through the section and group solvers, and decorate the appropriate rows
			if (tmpSection.Solvers && Array.isArray(tmpSection.Solvers))
			{
				for (let j = 0; j < tmpSection.Solvers.length; j++)
				{
					let tmpSolver = tmpSection.Solvers[j];
					let tmpSolverAssigned = false;

					// find an unused row in this section to decorate
					for (let k = 0; k < tmpCSVRows.length; k++)
					{
						let tmpRow = tmpCSVRows[k];
						if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
						{
							let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
							let tmpRowEquation = tmpRow[this.CSV_COLUMN_MAP["Equation"]];
							let tmpRowSubManifest = tmpRow[this.CSV_COLUMN_MAP["SubManifest"]];
							// If it's in the section
							if ((tmpRowSectionHash === tmpSectionHash)
									// And it isn't a tabular row
									&& (!tmpRowSubManifest || (tmpRowSubManifest == ''))
									// And an equation hasn't been set already
									&& (!tmpRowEquation || (tmpRowEquation.length == 0)))
							{
								// This is an unused row for this section
								if (typeof(tmpSolver) === 'string')
								{
									tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
									tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
								}
								else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
								{
									tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
									tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
								}
								tmpSolverAssigned = true;
								break;
							}
						}
					}
					// If the solver wasn't assigned, we have to create a hidden data only row for it and splice it in
					if (!tmpSolverAssigned)
					{
						let tmpHiddenSolverRow = new Array(this.CSV_HEADER.length).fill('');
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Form"]] = tmpForm;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
						// Set DataOnly
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataOnly"]] = '1';
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataType"]] = 'String';
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["InputType"]] = 'Hidden';
						// Generate an input hash and name that show its for a solver
						let tmpSolverInputHash = `Solver_for_${tmpSectionHash}_${j + 1}`;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Hash"]] = tmpSolverInputHash;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Name"]] = `Auto gen hidden solver entry for ${tmpSection.Name || tmpSectionHash} #${j + 1}`;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Address"]] = tmpSolverInputHash;
						if (typeof(tmpSolver) === 'string')
						{
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
						}
						else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
						{
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
						}
						// Splice this row after the last row for this section
						let tmpLastSectionRowIndex = -1;
						for (let k = 0; k < tmpCSVRows.length; k++)
						{
							let tmpRow = tmpCSVRows[k];
							if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
							{
								let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
								if (tmpRowSectionHash === tmpSectionHash)
								{
									tmpLastSectionRowIndex = k;
								}
							}
						}
						if (tmpLastSectionRowIndex >= 0)
						{
							tmpCSVRows.splice(tmpLastSectionRowIndex + 1, 0, tmpHiddenSolverRow);
						}
						else
						{
							// Just push it on the end
							tmpCSVRows.push(tmpHiddenSolverRow);
						}
					}
				}
			}

			// Lastly enumerate the group solvers
			if (tmpSection.Groups && Array.isArray(tmpSection.Groups))
			{
				for (let j = 0; j < tmpSection.Groups.length; j++)
				{
					let tmpGroup = tmpSection.Groups[j];
					let tmpGroupHash = tmpGroup.Hash;

					if (tmpGroup.RecordSetSolvers && Array.isArray(tmpGroup.RecordSetSolvers))
					{
						for (let m = 0; m < tmpGroup.RecordSetSolvers.length; m++)
						{
							let tmpSolver = tmpGroup.RecordSetSolvers[m];
							let tmpSolverAssigned = false;

							// find an unused row in this group to decorate
							for (let k = 0; k < tmpCSVRows.length; k++)
							{
								let tmpRow = tmpCSVRows[k];
								if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
								{
									let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
									let tmpRowEquation = tmpRow[this.CSV_COLUMN_MAP["Equation"]];
									let tmpRowSubManifest = tmpRow[this.CSV_COLUMN_MAP["SubManifest"]];
									// If it's in the group
									if ((tmpRowGroupHash === tmpGroupHash)
											// And it is a tabular row
											&& (tmpRowSubManifest == tmpGroup.RecordManifest)
											// And an equation hasn't been set already
											&& (!tmpRowEquation || (tmpRowEquation.length == 0)))
									{
										// This is an unused row for this group
										if (typeof(tmpSolver) === 'string')
										{
											tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
											tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
										}
										else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
										{
											tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
											tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
										}
										tmpSolverAssigned = true;
										break;
									}
								}
							}
							// If the solver wasn't assigned, we have to create a hidden data only row for it and splice it in
							if (!tmpSolverAssigned)
							{
								let tmpHiddenSolverRow = new Array(this.CSV_HEADER.length).fill('');
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Form"]] = tmpForm;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;
								// Set the submanifest on the row
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;
								// Set DataOnly
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataOnly"]] = '1';
								// Generate an input hash and name that show its for a solver
								let tmpSolverInputHash = `Solver_for_${tmpGroupHash}_${m + 1}`;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Hash"]] = tmpSolverInputHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Name"]] = `Auto gen hidden solver entry for ${tmpGroup.Name || tmpGroupHash} #${m + 1}`;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Address"]] = tmpSolverInputHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataType"]] = 'String';
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["InputType"]] = 'Hidden';
								if (typeof(tmpSolver) === 'string')
								{
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
								}
								else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
								{
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
								}
								// Splice this row after the last row for this group
								let tmpLastGroupRowIndex = -1;
								for (let k = 0; k < tmpCSVRows.length; k++)
								{
									let tmpRow = tmpCSVRows[k];
									if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
									{
										let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
										if (tmpRowGroupHash === tmpGroupHash)
										{
											tmpLastGroupRowIndex = k;
										}
									}
								}
								if (tmpLastGroupRowIndex >= 0)
								{
									tmpCSVRows.splice(tmpLastGroupRowIndex + 1, 0, tmpHiddenSolverRow);
								}
								else
								{
									// Just push it on the end
									tmpCSVRows.push(tmpHiddenSolverRow);
								}
							}
						}
					}
				}
			}
        }

		if (tmpCSVRows.length > 1)
		{
			// Add the FormName from the root of the manifest to the first row Form Name column
			let tmpFirstDataRow = tmpCSVRows[1];
			if (tmpFirstDataRow && pManifest.FormName)
			{
				tmpFirstDataRow[this.CSV_COLUMN_MAP["Form Name"]] = pManifest.FormName || tmpFirstDataRow[this.CSV_COLUMN_MAP["Form Name"]];
			}
		}

        return tmpCSVRows;
    }
}

module.exports = ManifestConversionToCSV;

},{"fable-serviceproviderbase":438}],637:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _DefaultManifestSettings = (
	{
		Manifest: { Scope: 'Default' }
	});

class ManifestFactory extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultManifestSettings)), pOptions);
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { instantiateServiceProviderWithoutRegistration: (hash: string, options?: any, uuid?: string) => any, newManyfest: () => import('manyfest') }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		this.manifest = tmpOptions.Manifest;

		if (!('Descriptors' in this.manifest))
		{
			this.manifest.Descriptors = {};
		}
		if (!('Sections' in this.manifest))
		{
			this.manifest.Sections = [];
		}
		if (!('ReferenceManifests' in this.manifest))
		{
			this.manifest.ReferenceManifests = {};
		}
		this.referenceManifestFactories = {};

		this.sectionHashLookup = {};
		this.groupHashLookup = {};

		let tmpReferenceManifestKeys = Object.keys(this.manifest.ReferenceManifests);
		for (let i = 0; i < tmpReferenceManifestKeys.length; i++)
		{
			this.referenceManifestFactories[tmpReferenceManifestKeys[i]] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory', this.manifest.ReferenceManifests[tmpReferenceManifestKeys[i]], `${this.UUID}-${tmpReferenceManifestKeys[i]}`);
		}

		// Keep track of a numeric index that's unique to this form, for autogenerating identifiers.
		this.defaultHashCounter = 0;

		this._SanitizeObjectKeyRegex = /[^a-zA-Z0-9_]/gi;
		this._SanitizeObjectKeyReplacement = '_';
		this._SanitizeObjectKeyInvalid = 'INVALID';
	}

	/**
	 * Clean a string of any characters to create a consistent object key.
	 *
	 * @param {string} pString = The string to clean.
	 * @return {string} the cleaned string, or a placeholder if the input is invalid
	 */
	sanitizeObjectKey(pString)
	{
		if (typeof pString !== 'string' || pString.length < 1)
		{
			return this._SanitizeObjectKeyInvalid;
		}
		return pString.replace(this._SanitizeObjectKeyRegex, this._SanitizeObjectKeyReplacement);
	}

	/**
	 * Initialize the form groups.
	 *
	 * This function will initialize the form groups of a view based on the manifest.
	 *
	 * TODO: Figure out if this is the best place for this.  It *is* pretty useful for
	 * inferring manifests, so has uses outside of the view lifecycle.
	 *
	 * @param {Object} pView - The view to initialize form groups for
	 */
	initializeFormGroups(pView)
	{
		// Enumerate the manifest and make sure a group exists for each group in the section definition
		let tmpDescriptorKeys = Object.keys(pView.options.Manifests.Section.Descriptors);
		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			// TODO: Change this to use the parsed sectionManifest rather than parsing the manifest itself
			let tmpDescriptor = pView.options.Manifests.Section.Descriptors[tmpDescriptorKeys[i]];

			if (
				// If there is an obect in the descriptor
				typeof (tmpDescriptor) == 'object' &&
				// AND it has a PictForm property
				('PictForm' in tmpDescriptor) &&
				// AND the PictForm property is an object
				typeof (tmpDescriptor.PictForm) == 'object' &&
				// AND the PictForm object has a Section property
				('Section' in tmpDescriptor.PictForm) &&
				// AND the Section property matches our section hash
				tmpDescriptor.PictForm.Section == pView.sectionDefinition.Hash
			)
			{
				tmpDescriptor.PictForm.InformaryDataAddress = tmpDescriptorKeys[i];

				// Decorate the view hash for reverse lookup
				tmpDescriptor.PictForm.ViewHash = pView.Hash;

				let tmpGroupHash = (typeof (tmpDescriptor.PictForm.Group) == 'string') ? tmpDescriptor.PictForm.Group : 'Default';

				if (!('Groups' in pView.sectionDefinition))
				{
					pView.sectionDefinition.Groups = [];
				}
				let tmpGroup = pView.sectionDefinition.Groups.find((pGroup) => { return pGroup.Hash == tmpGroupHash; });
				if (!tmpGroup)
				{
					tmpGroup = { Hash: tmpGroupHash, Name: tmpGroupHash, Description: false, Rows: [] };
					pView.sectionDefinition.Groups.push(tmpGroup);
				}
				else if (!Array.isArray(tmpGroup.Rows))
				{
					tmpGroup.Rows = [];
				}

				if (Number(tmpDescriptor.PictForm.Row))
				{
					tmpDescriptor.PictForm.Row = Number(tmpDescriptor.PictForm.Row);
				}
				let tmpRowHash = (typeof (tmpDescriptor.PictForm.Row) == 'string') ? tmpDescriptor.PictForm.Row :
					(typeof (tmpDescriptor.PictForm.Row) == 'number') ? `Row_${tmpDescriptor.PictForm.Row.toString()}` :
						'Row_Default';

				tmpDescriptor.PictForm.RowHash = tmpRowHash;

				let tmpRow = tmpGroup.Rows.find((pRow) => { return pRow.Hash == tmpRowHash; });

				if (!tmpRow)
				{
					tmpRow = { Hash: tmpRowHash, Name: tmpRowHash, Inputs: [] };
					if (typeof (tmpDescriptor.PictForm.Row) == 'number')
					{
						tmpRow.RowNumber = tmpDescriptor.PictForm.Row
					}
					tmpGroup.Rows.push(tmpRow);
					tmpRow.Inputs.push(tmpDescriptor);
				}
				else
				{
					tmpRow.Inputs.push(tmpDescriptor);
				}
			}
		}

		// Now check to see if we need to build group
		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];
			tmpGroup.GroupIndex = i;
			if ('HideTitle' in tmpGroup)
			{
				tmpGroup.HideTitle = false;
			}
			if (!tmpGroup.hasOwnProperty('Layout'))
			{
				tmpGroup.Layout = 'Record';
			}
			// Check if the group has a Rows array.
			// TODO: Is no rows valid?  Maaaaaybe?  Layouts makes this compelling.
			if (!tmpGroup.hasOwnProperty('Rows') || !Array.isArray(tmpGroup.Rows))
			{
				tmpGroup.Rows = [];
			}

			// Check if the group has a supporting manifest and load it.
			if ('RecordManifest' in tmpGroup)
			{
				tmpGroup.supportingManifest = pView.fable.instantiateServiceProviderWithoutRegistration('Manifest', pView.options.Manifests.Section.ReferenceManifests[tmpGroup.RecordManifest]);
			}
			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					let tmpInput = tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]];
					tmpInput.IsTabular = true;

					if (!('PictForm' in tmpInput))
					{
						tmpInput.PictForm = {};
					}
					tmpInput.PictForm.ViewHash = pView.Hash;

					tmpInput.PictForm.InformaryDataAddress = tmpSupportingManifestDescriptorKeys[k];
					if (typeof (tmpGroup.RecordSetAddress) == 'string')
					{
						tmpInput.PictForm.InformaryContainerAddress = tmpGroup.RecordSetAddress;
					}
					tmpInput.RowIdentifierTemplateHash = '{~D:Record.RowID~}';
				}

				// Resolve DynamicColumns generators once at init so the supporting manifest
				// is fully populated before the layout template is generated.
				if (Array.isArray(tmpGroup.DynamicColumns) && tmpGroup.DynamicColumns.length > 0)
				{
					this._resolveDynamicColumns(pView, tmpGroup);
				}
			}

			// Check if there is a record set address; initialize it if it doesn't exist
			if (tmpGroup.RecordSetAddress)
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpRecordSetDataObjectExists = pView.sectionManifest.checkAddressExistsByHash(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress);
				let tmpRecordSetDataObject = pView.sectionManifest.getValueAtAddress(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress);
				if (!tmpRecordSetDataObjectExists)
				{
					pView.log.warn(`Automatically setting an empty array at [${tmpGroup.RecordSetAddress}].`);
					pView.sectionManifest.setValueByHash(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress, []);
				}
				else if (Array.isArray(tmpRecordSetDataObject))
				{
					pView.log.trace(`RecordSetAddress is an Array for [${tmpGroup.Hash}]`);
				}
				else if (typeof (tmpRecordSetDataObject) === 'object')
				{
					pView.log.trace(`RecordSetAddress is an Object for [${tmpGroup.Hash}]`);
				}
				else
				{
					pView.log.error(`RecordSetAddress is not an Array or Object for [${tmpGroup.Hash}]; it is a [${typeof (tmpRecordSetDataObject)}] -- likely the data shape will cause erratic problems.`);
				}

				// Check if there are default rows to add
				if (tmpGroup.MinimumRowCount)
				{
					if (!tmpRecordSetDataObject)
					{
						pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress, []);
						tmpRecordSetDataObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
					}
					for (let i = tmpRecordSetDataObject.length; i < tmpGroup.MinimumRowCount; i++)
					{
						pView.pict.providers.DynamicTabularData.createDynamicTableRowWithoutEvents(pView, tmpGroup.GroupIndex);
					}
				}
			}
		}
	}

	/**
	 * Resolve a single template string against a record context.
	 *
	 * @param {string} pTemplate - The template string to resolve.
	 * @param {Object} pRecord - The record context to resolve against.
	 * @returns {string} The resolved string, or '' on failure.
	 */
	_parseDynamicColumnTemplate(pTemplate, pRecord)
	{
		if (typeof pTemplate !== 'string')
		{
			return '';
		}
		if (pTemplate.indexOf('{') === -1)
		{
			return pTemplate;
		}
		try
		{
			let tmpResult = this.fable.parseTemplate(pTemplate, pRecord, null);
			return (typeof tmpResult === 'string') ? tmpResult : '';
		}
		catch (pError)
		{
			this.log.warn(`PICT Form Tabular DynamicColumns template parse failed: ${pError && pError.message}`);
			return '';
		}
	}

	/**
	 * Resolve a Tabular Group's DynamicColumns generators into descriptors on its supportingManifest.
	 *
	 * NON-DESTRUCTIVE: descriptor pruning is structural only -- row record data at
	 * removed InformaryDataAddresses is never touched, so hidden data persists for
	 * later restoration if the source row reappears.
	 *
	 * InformaryDataAddressTemplate is resolved ONCE at descriptor generation time
	 * (Informary itself is a pure string concat at marshal time -- see
	 * Pict-Provider-Informary.getComposedContainerAddress).
	 *
	 * @param {Object} pView - The view containing the group.
	 * @param {Object} pGroup - The group object (must already have supportingManifest).
	 * @returns {{added: Array<string>, removed: Array<string>, unchanged: Array<string>, changed: boolean, namesChanged: boolean}}
	 */
	_resolveDynamicColumns(pView, pGroup)
	{
		let tmpEmpty = { added: [], removed: [], unchanged: [], changed: false, namesChanged: false };
		if (!pGroup || !Array.isArray(pGroup.DynamicColumns) || pGroup.DynamicColumns.length === 0)
		{
			return tmpEmpty;
		}
		if (!pGroup.supportingManifest)
		{
			this.log.warn(`PICT Form Tabular DynamicColumns on group [${pGroup.Hash}] skipped: no supportingManifest.`);
			return tmpEmpty;
		}
		if (!Array.isArray(pGroup.DynamicColumnsState))
		{
			pGroup.DynamicColumnsState = [];
		}

		let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
		let tmpSupportingManifest = pGroup.supportingManifest;

		let tmpAggregateAdded = [];
		let tmpAggregateRemoved = [];
		let tmpAggregateUnchanged = [];
		let tmpAggregateChanged = false;
		let tmpAggregateNamesChanged = false;

		for (let i = 0; i < pGroup.DynamicColumns.length; i++)
		{
			let tmpGenerator = pGroup.DynamicColumns[i];
			if (!pGroup.DynamicColumnsState[i])
			{
				pGroup.DynamicColumnsState[i] = { LastHashes: [], LastHeaderGroups: [] };
			}
			let tmpState = pGroup.DynamicColumnsState[i];

			if (typeof tmpGenerator.SourceAddress !== 'string' || tmpGenerator.SourceAddress.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing SourceAddress.`);
				continue;
			}
			if (typeof tmpGenerator.HashTemplate !== 'string' || tmpGenerator.HashTemplate.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing HashTemplate.`);
				continue;
			}
			if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string' || tmpGenerator.InformaryDataAddressTemplate.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing InformaryDataAddressTemplate.`);
				continue;
			}

			let tmpSourceArray = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpGenerator.SourceAddress);
			if (!Array.isArray(tmpSourceArray))
			{
				tmpSourceArray = [];
			}

			// Build the desired descriptor set from the current source array.
			let tmpDesiredHashes = [];
			let tmpDesiredDescriptors = {};
			let tmpDesiredHeaderGroups = [];
			let tmpSeenHashes = {};
			for (let k = 0; k < tmpSourceArray.length; k++)
			{
				let tmpSourceRow = tmpSourceArray[k];
				// Expose the source-row position to the generator templates WITHOUT mutating the
				// stored row: a shallow copy carries __Index (0-based) and __RowNumber (1-based)
				// alongside the row's own fields. This lets a generator key its columns by
				// POSITION (KeyBy: "Position") -- e.g. HashTemplate "Col_{~D:Record.__Index~}",
				// NameTemplate "Product {~D:Record.__RowNumber~}" -- so adding/removing a source
				// row never collides on a stored identity value (no markers in the saved data).
				let tmpTemplateRecord = (tmpSourceRow && (typeof tmpSourceRow === 'object'))
					? Object.assign({}, tmpSourceRow, { __Index: k, __RowNumber: k + 1 })
					: { Value: tmpSourceRow, __Index: k, __RowNumber: k + 1 };
				let tmpHash = this._parseDynamicColumnTemplate(tmpGenerator.HashTemplate, tmpTemplateRecord);
				if (!tmpHash)
				{
					continue;
				}
				if (tmpSeenHashes[tmpHash])
				{
					this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} produced duplicate Hash [${tmpHash}] on group [${pGroup.Hash}]; later row wins.`);
				}
				tmpSeenHashes[tmpHash] = true;

				let tmpName = tmpGenerator.NameTemplate
					? this._parseDynamicColumnTemplate(tmpGenerator.NameTemplate, tmpTemplateRecord)
					: tmpHash;
				let tmpInformaryDataAddress = this._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, tmpTemplateRecord);
				if (!tmpInformaryDataAddress)
				{
					this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} produced empty InformaryDataAddress for row ${k} on group [${pGroup.Hash}]; skipping.`);
					continue;
				}
				let tmpHeaderGroup = tmpGenerator.HeaderGroupTemplate
					? this._parseDynamicColumnTemplate(tmpGenerator.HeaderGroupTemplate, tmpTemplateRecord)
					: '';

				let tmpDescriptor = {
					Hash: tmpHash,
					Name: tmpName || tmpHash,
					DataType: tmpGenerator.DataType || 'String',
					IsTabular: true,
					_DynamicColumnGeneratorIndex: i,
					_DynamicColumnHeaderGroup: tmpHeaderGroup,
					PictForm: Object.assign({}, tmpGenerator.PictForm || {}, {
						ViewHash: pView.Hash,
						InformaryContainerAddress: pGroup.RecordSetAddress,
						InformaryDataAddress: tmpInformaryDataAddress
					})
				};

				tmpDesiredHashes.push(tmpHash);
				tmpDesiredDescriptors[tmpHash] = tmpDescriptor;
				tmpDesiredHeaderGroups.push(tmpHeaderGroup);
			}

			// Diff against the cached last state.
			let tmpLastHashes = Array.isArray(tmpState.LastHashes) ? tmpState.LastHashes : [];
			let tmpDesiredSet = {};
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				tmpDesiredSet[tmpDesiredHashes[h]] = true;
			}
			let tmpRemoved = tmpLastHashes.filter((pHash) => { return !tmpDesiredSet[pHash]; });
			let tmpLastSet = {};
			for (let h = 0; h < tmpLastHashes.length; h++)
			{
				tmpLastSet[tmpLastHashes[h]] = true;
			}
			let tmpAdded = tmpDesiredHashes.filter((pHash) => { return !tmpLastSet[pHash]; });
			let tmpUnchanged = tmpDesiredHashes.filter((pHash) => { return tmpLastSet[pHash]; });
			let tmpHeaderGroupsChanged = JSON.stringify(tmpDesiredHeaderGroups) !== JSON.stringify(tmpState.LastHeaderGroups || []);
			let tmpOrderChanged = JSON.stringify(tmpDesiredHashes) !== JSON.stringify(tmpLastHashes);

			// Remove dropped descriptors from the supportingManifest entirely.
			for (let r = 0; r < tmpRemoved.length; r++)
			{
				let tmpHashToRemove = tmpRemoved[r];
				let tmpAddrIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpHashToRemove);
				if (tmpAddrIdx >= 0)
				{
					tmpSupportingManifest.elementAddresses.splice(tmpAddrIdx, 1);
				}
				delete tmpSupportingManifest.elementDescriptors[tmpHashToRemove];
				if (tmpSupportingManifest.elementHashes && (tmpHashToRemove in tmpSupportingManifest.elementHashes))
				{
					delete tmpSupportingManifest.elementHashes[tmpHashToRemove];
				}
			}

			// Re-place all descriptors for this generator in the desired order at the InsertAt position.
			// First, pull them out so we can splice them back in as a contiguous block.
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				let tmpAddr = tmpDesiredHashes[h];
				let tmpExistingIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpAddr);
				if (tmpExistingIdx >= 0)
				{
					tmpSupportingManifest.elementAddresses.splice(tmpExistingIdx, 1);
				}
				// Preserve an already-registered descriptor OBJECT rather than swapping in a
				// fresh one. The live descriptor carries the generated Macro (informary HTML
				// bindings) and InputIndex stamped during the last template build. Replacing
				// it with a fresh, Macro-less object silently breaks marshaling on any later
				// render() that is NOT accompanied by a template rebuild -- e.g. moving,
				// adding or deleting a row. Refresh only the data-derived fields in place.
				let tmpExistingDescriptor = tmpSupportingManifest.elementDescriptors[tmpAddr];
				if (tmpExistingDescriptor)
				{
					let tmpFreshDescriptor = tmpDesiredDescriptors[tmpAddr];
					// A column whose hash is UNCHANGED can still have a refreshed display label
					// or header group when the source row's name-driving field is edited (e.g.
					// renaming a product). The structural diff above only tracks the hash SET, so
					// flag a label-only change separately -- the layout uses it to re-bake header
					// text via a render() without a full (and costlier) template rebuild.
					if (tmpExistingDescriptor.Name !== tmpFreshDescriptor.Name
						|| tmpExistingDescriptor._DynamicColumnHeaderGroup !== tmpFreshDescriptor._DynamicColumnHeaderGroup)
					{
						tmpAggregateNamesChanged = true;
					}
					tmpExistingDescriptor.Name = tmpFreshDescriptor.Name;
					tmpExistingDescriptor.DataType = tmpFreshDescriptor.DataType;
					tmpExistingDescriptor.IsTabular = tmpFreshDescriptor.IsTabular;
					tmpExistingDescriptor._DynamicColumnGeneratorIndex = tmpFreshDescriptor._DynamicColumnGeneratorIndex;
					tmpExistingDescriptor._DynamicColumnHeaderGroup = tmpFreshDescriptor._DynamicColumnHeaderGroup;
					if (!tmpExistingDescriptor.PictForm)
					{
						tmpExistingDescriptor.PictForm = {};
					}
					Object.assign(tmpExistingDescriptor.PictForm, tmpFreshDescriptor.PictForm);
					tmpDesiredDescriptors[tmpAddr] = tmpExistingDescriptor;
				}
				else
				{
					tmpSupportingManifest.elementDescriptors[tmpAddr] = tmpDesiredDescriptors[tmpAddr];
				}
				if (!tmpSupportingManifest.elementHashes)
				{
					tmpSupportingManifest.elementHashes = {};
				}
				tmpSupportingManifest.elementHashes[tmpAddr] = tmpAddr;
			}

			// Compute insertion index.
			let tmpInsertAt = tmpGenerator.InsertAt || 'End';
			let tmpInsertionIndex;
			if (tmpInsertAt === 'Start')
			{
				tmpInsertionIndex = 0;
			}
			else if (typeof tmpInsertAt === 'object' && tmpInsertAt !== null && typeof tmpInsertAt.After === 'string')
			{
				let tmpAfterIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpInsertAt.After);
				tmpInsertionIndex = (tmpAfterIdx < 0) ? tmpSupportingManifest.elementAddresses.length : tmpAfterIdx + 1;
			}
			else
			{
				tmpInsertionIndex = tmpSupportingManifest.elementAddresses.length;
			}
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				tmpSupportingManifest.elementAddresses.splice(tmpInsertionIndex + h, 0, tmpDesiredHashes[h]);
			}

			tmpState.LastHashes = tmpDesiredHashes.slice();
			tmpState.LastHeaderGroups = tmpDesiredHeaderGroups.slice();

			if (tmpAdded.length || tmpRemoved.length || tmpHeaderGroupsChanged || tmpOrderChanged)
			{
				tmpAggregateChanged = true;
			}
			tmpAggregateAdded.push.apply(tmpAggregateAdded, tmpAdded);
			tmpAggregateRemoved.push.apply(tmpAggregateRemoved, tmpRemoved);
			tmpAggregateUnchanged.push.apply(tmpAggregateUnchanged, tmpUnchanged);
		}

		return {
			added: tmpAggregateAdded,
			removed: tmpAggregateRemoved,
			unchanged: tmpAggregateUnchanged,
			changed: tmpAggregateChanged,
			namesChanged: tmpAggregateNamesChanged
		};
	}

	/**
	 * Adds a manifest descriptor to the manifest.
	 *
	 * @param {Object} pManifestDescriptor - The manifest descriptor to add.
	 */
	addDescriptor(pManifestDescriptor)
	{
		if (pManifestDescriptor.DataAddress in this.manifest.Descriptors)
		{
			this.log.info('[ERROR] Duplicate descriptor hash found:', pManifestDescriptor);
		}
		this.manifest.Descriptors[pManifestDescriptor.DataAddress] = pManifestDescriptor;
	}

	/**
	 * Get a section from the manifest.
	 *
	 * @param {string} pSectionHash - The section Hash
	 *
	 * @return {Object} The manifest section object
	 */
	getManifestSection(pSectionHash)
	{
		for (const tmpSection of this.manifest.Sections)
		{
			if (tmpSection.Hash === pSectionHash)
			{
				return tmpSection;
			}
		}
		// Add the section if it do no exist
		const tmpSection = { Name: pSectionHash, Hash: pSectionHash, Solvers: [], Groups: [] };
		this.manifest.Sections.push(tmpSection);
		return tmpSection;
	}

	/**
	 * Get a group from a section.
	 *
	 * @param {string|Object} pManifestSection - The manifest Section -- either a Hash string or the object itself
	 * @param {string} pGroupHash - The group Hash
	 *
	 * @return {Object} The group object
	 */
	getManifestGroup(pManifestSection, pGroupHash)
	{
		let tmpManifestSection = (typeof (pManifestSection) === 'string') ? this.getManifestSection(pManifestSection) : pManifestSection;
		for (const tmpGroup of tmpManifestSection.Groups)
		{
			if (tmpGroup.Hash === pGroupHash)
			{
				return tmpGroup;
			}
		}
		// Add the group if it do no exist
		const tmpGroup = { Name: pGroupHash, Hash: pGroupHash, Rows: [], RecordSetSolvers: [] };
		tmpManifestSection.Groups.push(tmpGroup);
		return tmpGroup;
	}

	/**
	 * Lints a manifest record row.
	 * @param {Object} pRecord - The record to be linted.
	 * @returns {boolean} - Returns true if the record is valid, false otherwise.
	 */
	tabularRowLint(pRecord)
	{
		if (!pRecord)
		{
			this.log.error('Record is missing from record:', pRecord);
			return false;
		}
		if (!pRecord.Form)
		{
			this.log.error('Form is missing from record:', pRecord);
			return false;
		}
		return true;
	}

	decorateChartDescriptorFromTabularRow(pRecord, pDescriptor, pPostfix)
	{
		let tmpRecord = pRecord;
		let tmpDescriptor = pDescriptor;
		let tmpPostfix = pPostfix || '';

		// Log out the data coming in
		//this.log.debug(`Decorating chart descriptor from tabular row for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`,{ Record: tmpRecord, Descriptor: tmpDescriptor });

		// Charts will pull in five extra pieces of config if they exist: ChartType, ChartLabelsAddress, ChartLabelsSolver, ChartDatasetsAddress, ChartDatasetsSolver
		if (tmpRecord.ChartType)
		{
			tmpDescriptor.PictForm.ChartType = tmpRecord.ChartType;
		}
		if (tmpPostfix == '')
		{
			// Maybe later this gets more advanced.
			if (tmpRecord.ChartLabelsAddress)
			{
				tmpDescriptor.PictForm.ChartLabelsAddress = tmpRecord.ChartLabelsAddress;
			}
			if (tmpRecord.ChartLabelsSolver)
			{
				tmpDescriptor.PictForm.ChartLabelsSolver = tmpRecord.ChartLabelsSolver;
			}
			if (tmpRecord.ChartDatasetsAddress)
			{
				tmpDescriptor.PictForm.ChartDatasetsAddress = tmpRecord.ChartDatasetsAddress;
			}
		}
		
		if (tmpRecord[`ChartDatasetsSolver${tmpPostfix}`])
		{
			let tmpSolverEntry = { DataSolver: tmpRecord[`ChartDatasetsSolver${tmpPostfix}`] };
			//this.log.debug(`Adding chart dataset solver for descriptor ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpSolverEntry);
			if (!tmpRecord[`ChartDatasetsLabel${tmpPostfix}`])
			{
				tmpSolverEntry.Label = 'Data';
			}
			else
			{
				tmpSolverEntry.Label = tmpRecord[`ChartDatasetsLabel${tmpPostfix}`];
			}
			if (tmpRecord[`ChartDataSetsSolverChartType${tmpPostfix}`])
			{
				tmpSolverEntry.ChartType = tmpRecord[`ChartDataSetsSolverChartType${tmpPostfix}`];
			}
			if (!tmpDescriptor.PictForm.ChartDatasetsSolvers || !Array.isArray(tmpDescriptor.PictForm.ChartDatasetsSolvers))
			{
				tmpDescriptor.PictForm.ChartDatasetsSolvers = [];
			}
			// Log and add the solver entry
			//this.log.debug(`Adding chart dataset solver entry for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpSolverEntry);
			tmpDescriptor.PictForm.ChartDatasetsSolvers.push(tmpSolverEntry);
		}
		// Log the descripter going out
		//this.log.debug(`Decorated chart descriptor from tabular row for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpDescriptor);
	}

	/**
	 * Add a manifest descriptor from a tabular row.
	 *
	 * @param {Object} pManifestFactory - The manifest factory
	 * @param {Object} pRecord - The tabular row record -- expected to have at least a 'Form'
	 *
	 * @return {Object} the descriptor
	 */
	tabularRowAddDescriptor(pManifestFactory, pRecord)
	{
		if (typeof (pRecord) !== 'object')
		{
			this.log.error(`Invalid record passed to addManifestDescriptor: ${pRecord}`);
			return false;
		}

		let tmpRecord = JSON.parse(JSON.stringify(pRecord));

		// Fill out required defaults on the row
		tmpRecord['Input Hash'] = tmpRecord['Input Hash']?.trim?.() || `DefaultHash${this.defaultHashCounter++}`;
		tmpRecord['Input Address'] = tmpRecord['Input Address']?.trim?.() || `DefaultData.InputHash_${tmpRecord['Input Hash']}`;
		tmpRecord['Input Name'] = tmpRecord['Input Name']?.trim?.() || `Auto Input ${tmpRecord['Input Hash']}`;
		tmpRecord.DataType = tmpRecord.DataType?.trim?.() || 'String';

		const tmpDescriptor = (
			{
				Hash: tmpRecord['Input Hash'],
				Name: tmpRecord['Input Name'],
				DataAddress: tmpRecord['Input Address'],
				DataType: tmpRecord.DataType,
				PictForm: {},
			});

		if (tmpRecord.Default)
		{
			tmpDescriptor.Default = tmpRecord.Default;
		}

		// Set the optional settings if they are present on the record
		if (tmpRecord.InputType)
		{
			tmpDescriptor.PictForm.InputType = tmpRecord.InputType;
		}
		if (tmpRecord.Row)
		{
			tmpDescriptor.PictForm.Row = tmpRecord.Row;
		}
		if (tmpRecord.Width)
		{
			tmpDescriptor.PictForm.Width = tmpRecord.Width;
		}

		if (tmpRecord['Input Notes'])
		{
			tmpDescriptor.PictForm.SpreadsheetNotes = tmpRecord['Input Notes'];
		}

		if (tmpRecord['Description'])
		{
			tmpDescriptor.Description = tmpRecord['Description'];
		}

		if (tmpRecord['Units'])
		{
			tmpDescriptor.PictForm.Units = tmpRecord['Units'];
		}

		if (tmpRecord['Tooltip'])
		{
			tmpDescriptor.PictForm.Tooltip = tmpRecord['Tooltip'];
		}

		if ((tmpDescriptor.PictForm.InputType == 'Option') && (tmpRecord['Input Extra']))
		{
			let tmpOptionSet = [];
			let tmpOptionSetValues = tmpRecord['Input Extra'].split(',');

			for (let i = 0; i < tmpOptionSetValues.length; i++)
			{
				if (tmpOptionSetValues[i].trim() != '')
				{
					let tmpOptionSetValuePair = tmpOptionSetValues[i].split('^');
					if (tmpOptionSetValuePair.length == 2)
					{
						tmpOptionSet.push({ id: tmpOptionSetValuePair[0].trim(), text: tmpOptionSetValuePair[1].trim() });
					}
					else
					{
						tmpOptionSet.push({ id: tmpOptionSetValues[i].trim(), text: tmpOptionSetValues[i].trim() });
					}
				}
			}

			if (tmpOptionSet.length > 0)
			{
				tmpDescriptor.PictForm.SelectOptions = tmpOptionSet;
			}
		}

		if (((tmpDescriptor.PictForm.InputType == 'TabSectionSelector') || (tmpDescriptor.PictForm.InputType == 'TabGroupSelector')) && (tmpRecord['Input Extra']))
		{
			let tmpTabSet = [];
			let tmpTabSetNames = [];
			let tmpTabSetConfiguredValues = tmpRecord['Input Extra'].split(',');

			for (let i = 0; i < tmpTabSetConfiguredValues.length; i++)
			{
				if (tmpTabSetConfiguredValues[i].trim() != '')
				{
					let tmpTabSetValuePair = tmpTabSetConfiguredValues[i].split('^');
					if (tmpTabSetValuePair.length >= 2)
					{
						tmpTabSet.push(tmpTabSetValuePair[0].trim());
						tmpTabSetNames.push(tmpTabSetValuePair[1].trim());
					}
					else
					{
						tmpTabSet.push(tmpTabSetValuePair[0].trim());
						tmpTabSetNames.push(tmpTabSetValuePair[0].trim());
					}
				}
			}

			if (tmpTabSet.length > 0)
			{
				if (tmpDescriptor.PictForm.InputType == 'TabSectionSelector')
				{
					tmpDescriptor.PictForm.TabSectionSet = tmpTabSet;
					tmpDescriptor.PictForm.TabSectionNames = tmpTabSetNames;
				}
				else if (tmpDescriptor.PictForm.InputType == 'TabGroupSelector')
				{
					tmpDescriptor.PictForm.TabGroupSet = tmpTabSet;
					tmpDescriptor.PictForm.TabGroupNames = tmpTabSetNames;
				}
			}
		}

		// Verbose obtuse data validation.
		if ((`TriggerGroup` in tmpRecord) && (typeof (tmpRecord.TriggerGroup) === 'string') && (tmpRecord.TriggerGroup != ''))
		{
			if (!Array.isArray(tmpDescriptor.PictForm.Providers))
			{
				tmpDescriptor.PictForm.Providers = [];
			}

			tmpDescriptor.PictForm.Providers.push('Pict-Input-AutofillTriggerGroup');
			if (!Array.isArray(tmpDescriptor.PictForm.AutofillTriggerGroup))
			{
				const tmpPreviousTriggerGroup = tmpDescriptor.PictForm.AutofillTriggerGroup;
				tmpDescriptor.PictForm.AutofillTriggerGroup = [];
				if (tmpPreviousTriggerGroup)
				{
					tmpDescriptor.PictForm.AutofillTriggerGroup.push(tmpPreviousTriggerGroup);
				}
			}
			const tmpTriggerGroupHashes = tmpRecord.TriggerGroup.split(',');
			const tmpTriggerAddresses = (`TriggerAddress` in tmpRecord) ? tmpRecord.TriggerAddress.split(',') : [];
			const tmpTriggerAllInputs = (`TriggerAllInputs` in tmpRecord) ? tmpRecord.TriggerAllInputs.split(',') : [];

			for (let i = 0; i < tmpTriggerGroupHashes.length; i++)
			{
				const tmpTriggerGroup =
				{
					TriggerGroupHash: tmpTriggerGroupHashes[i].trim(),
					MarshalEmptyValues: tmpRecord.MarshalEmptyValues ? true : false,
				};

				const tmpTriggerAddress = tmpTriggerAddresses[i]?.trim?.();
				if (tmpTriggerAddress)
				{
					tmpTriggerGroup.TriggerAddress = tmpTriggerAddress;
				}
				const tmpTriggerAllInput = tmpTriggerAllInputs[i]?.trim?.();
				if (tmpTriggerAllInput != null && (tmpTriggerAllInput.toLowerCase() == 'true' || tmpTriggerAllInput.toLowerCase() == 'x' || tmpTriggerAllInput.toLowerCase() == '1'))
				{
					tmpTriggerGroup.TriggerAllInputs = true;
				}
				// TODO: Ugh
				if (tmpDescriptor.PictForm.InputType == 'Option')
				{
					tmpTriggerGroup.SelectOptionsRefresh = true;
				}
				tmpDescriptor.PictForm.AutofillTriggerGroup.push(tmpTriggerGroup);
			}
		}

		if (typeof tmpRecord.Entity === 'string' && tmpRecord.Entity.trim() &&
			(
				(typeof tmpRecord.EntityColumnFilter === 'string' && tmpRecord.EntityColumnFilter.trim()) ||
				(typeof tmpRecord.EntityFilterTemplate === 'string' && tmpRecord.EntityFilterTemplate.trim())
			) &&
			typeof tmpRecord.EntityDestination === 'string' && tmpRecord.EntityDestination.trim())
		{
			if (!Array.isArray(tmpDescriptor.PictForm.Providers))
			{
				tmpDescriptor.PictForm.Providers = [];
			}

			if (!tmpDescriptor.PictForm.Providers.includes('Pict-Input-EntityBundleRequest'))
			{
				tmpDescriptor.PictForm.Providers.push('Pict-Input-EntityBundleRequest')
			}
			tmpDescriptor.PictForm.EntitiesBundle = [
				{
					"Entity": tmpRecord.Entity,
					"Filter": (tmpRecord.EntityFilterTemplate && tmpRecord.EntityFilterTemplate.trim()) || `FBV~${tmpRecord.EntityColumnFilter.trim()}~EQ~{~D:Record.Value~}`,
					"Destination": tmpRecord.EntityDestination,
					// This marshals a single record
					"SingleRecord": tmpRecord.EntitySingleRecord && tmpRecord.EntitySingleRecord !== 'false',
				}
			]
		}

		// This is used for Section and Group, regardless of where the Descriptor goes.
		let tmpCoreManifestFactory = pManifestFactory;
		if ((`SubManifest` in tmpRecord) && (tmpRecord.SubManifest) && (tmpRecord.InputType != 'TabularAddress'))
		{
			tmpDescriptor.IsTabular = true;
			// Below is what amounts to complex pointer arithmatic.
			if (!(tmpRecord.SubManifest in pManifestFactory.manifest.ReferenceManifests))
			{
				// Build a reference manifest if it doesn't exist
				pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory', { Manifest: { Scope: tmpRecord.SubManifest } }, `${this.UUID}-${tmpRecord.SubManifest}`);
				pManifestFactory.manifest.ReferenceManifests[tmpRecord.SubManifest] = pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest].manifest;
			}
			pManifestFactory = pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest];
		}

		if ('Decimal Precision' in tmpRecord)
		{
			// See if the Decimal Precision is set
			if (tmpRecord['Decimal Precision'] && (tmpRecord['Decimal Precision'] != ''))
			{
				try
				{
					tmpDescriptor.PictForm.DecimalPrecision = parseInt(tmpRecord['Decimal Precision']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Decimal Precision for ${tmpRecord['Input Hash']}: ${pError}`);
				}
			}
		}

		// Setup the Section and the Group
		const tmpSectionName = tmpRecord['Section Name']?.trim?.();

		let tmpSectionHash = this.sanitizeObjectKey(tmpSectionName || 'Default_Section');
		// Note: The section name part is laissez-faire about whether it needs to be there or not.  The Hash is required on each column if we want to customize.
		if (tmpRecord['Section Hash'] && tmpRecord['Section Hash'] != '')
		{
			tmpSectionHash = this.sanitizeObjectKey(tmpRecord['Section Hash']);
		}

		tmpDescriptor.PictForm.Section = tmpSectionHash;
		const tmpSection = tmpCoreManifestFactory.getManifestSection(tmpSectionHash);
		if (tmpSectionName)
		{
			tmpSection.Name = tmpSectionName;
		}

		if (tmpRecord['Section CSS'])
		{
			tmpSection.CSSClass = tmpRecord['Section CSS'];
		}

		const tmpGroupName = tmpRecord['Group Name']?.trim?.();
		let tmpGroupHash = this.sanitizeObjectKey(tmpGroupName || 'Default_Group');
		// Note: The group name part is laissez-faire about whether it needs to be there or not.  The Hash is required on each column if we want to customize.
		if (tmpRecord['Group Hash'] && tmpRecord['Group Hash'] != '')
		{
			tmpGroupHash = this.sanitizeObjectKey(tmpRecord['Group Hash']);
		}

		tmpDescriptor.PictForm.Group = tmpGroupHash;
		const tmpGroup = tmpCoreManifestFactory.getManifestGroup(tmpSection, tmpGroupHash);
		tmpGroup.Name = tmpGroupName || ''; // by default, the new group with have a name with the hash, but avoid that to support default groups without ugly forms

		if (tmpRecord['Group CSS'])
		{
			tmpGroup.CSSClass = tmpRecord['Group CSS'];
		}
		if (tmpRecord['Group Layout'])
		{
			tmpGroup.Layout = tmpRecord['Group Layout'];
		}
		if (tmpRecord['Minimum Row Count'])
		{
			try
			{
				tmpGroup.MinimumRowCount = parseInt(tmpRecord['Minimum Row Count']);
			}
			catch (pError)
			{
				this.log.error(`Failed to parse Minimum Row Count for ${tmpRecord['Input Hash']}: ${pError}`);
			}
		}
		if (tmpRecord['Maximum Row Count'])
		{
			try
			{
				tmpGroup.MaximumRowCount = parseInt(tmpRecord['Maximum Row Count']);
			}
			catch (pError)
			{
				this.log.error(`Failed to parse Maximum Row Count for ${tmpRecord['Input Hash']}: ${pError}`);
			}
		}
		if (tmpRecord['HideTabularEditingControls'] && ((tmpRecord['HideTabularEditingControls'] == '1') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 'true') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 't') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 'y')))
		{
			tmpGroup.HideTabularEditingControls = true;
		}
		if (tmpRecord['Group Show Title'] && (tmpRecord['Group Show Title'] != ''))
		{
			switch (tmpRecord['Group Show Title'].toLowerCase())
			{
				case 1:
				case '1':
				case 'true':
					tmpGroup.ShowTitle = true;
					break;
				case 0:
				case '0':
				case 'false':
					tmpGroup.ShowTitle = false;
					break;
			}
		}
		if (tmpDescriptor.Hash in pManifestFactory.manifest.Descriptors)
		{
			this.log.info(`[ERROR] Duplicate descriptor hash found ${tmpDescriptor.Hash}.  This will overwrite the original descriptor.`);
		}

		// Now checking if the group is Tabular -- if it is we need to set some extra values on the Group and have solvers occur inline
		// Layout: "Tabular",
		// RecordSetSolvers: [
		// 	{
		// 		Ordinal: 0,
		// 		Expression: "PercentTotalFat = (Fat * 9) / Calories",
		// 	},
		// ],
		// RecordSetAddress: "FruitData.FruityVice",
		// RecordManifest: "FruitEditor",
		if (tmpRecord.InputType == 'TabularAddress')
		{
			tmpGroup.Layout = 'Tabular';
			// If the csv defines the GroupRecordSetAddress, use that explicitly
			this.log.info(`Group ${tmpGroup.Hash} RSA ${tmpRecord['GroupRecordSetAddress']} -> Descriptor ${tmpDescriptor.DataAddress}`);
			if (tmpRecord['GroupRecordSetAddress'] && (typeof (tmpRecord.GroupRecordSetAddress == 'string')) && (tmpRecord.GroupRecordSetAddress.length > 0))
			{
				tmpGroup.RecordSetAddress = tmpRecord.GroupRecordSetAddress;
			}
			else
			{
				tmpGroup.RecordSetAddress = tmpDescriptor.DataAddress;
			}
			// Otherwise fall back to the DataAddress
			tmpGroup.RecordManifest = tmpRecord.SubManifest;
		}

		if (tmpRecord['Equation'] && !this._isTrue(tmpRecord['Validator']))
		{
			// Clean up the equation a bit to remove any leading/trailing spaces and replace HTML quotes
			// that may have been added by the CSV or other source.
			const tmpCleanEquation = tmpRecord['Equation'].trim();
			let tmpEquationOrdinal = 1;
			if (tmpRecord['Equation Ordinal'])
			{
				try
				{
					tmpEquationOrdinal = parseInt(tmpRecord['Equation Ordinal']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Equation Ordinal for ${tmpRecord['Input Hash']}: ${pError}`);
				}
			}
			this.log.trace(`Adding solver to ${tmpRecord.Form} --> ${tmpGroup.Name} for ${tmpRecord['Input Hash']} Ordinal ${tmpEquationOrdinal}: ${tmpRecord['Equation']}`);
			if ((tmpGroup.Layout == 'Tabular') || (tmpGroup.Layout == 'RecordSet'))
			{
				if (tmpEquationOrdinal == 1)
				{
					tmpGroup.RecordSetSolvers.push(tmpCleanEquation);
				}
				else
				{
					tmpGroup.RecordSetSolvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
				}
			}
			else
			{
				if (tmpEquationOrdinal == 1)
				{
					tmpSection.Solvers.push(tmpCleanEquation);
				}
				else
				{
					tmpSection.Solvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
				}
			}
		}

		this.onTabularRowAddDescriptor(tmpRecord, tmpSection, tmpGroup, tmpDescriptor);

		if (tmpRecord.DataOnly && tmpDescriptor.PictForm)
		{
			if (tmpDescriptor.PictForm.Group)
			{
				tmpDescriptor.FormGroup = tmpDescriptor.PictForm.Group;
			}
			if (tmpDescriptor.PictForm.Section)
			{
				tmpDescriptor.FormSection = tmpDescriptor.PictForm.Section;
			}
			delete tmpDescriptor.PictForm;
		}

		if ((tmpRecord.InputType == 'Chart') && (tmpDescriptor.PictForm))
		{
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '1');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '2');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '3');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '4');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '5');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '6');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '7');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '8');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '9');
		}

		// Finally add any `Descriptor_Extension_* properties
		const tmpDescriptorKeys = Object.keys(tmpRecord);
		let tmpDescriptorManifest = this.fable.newManyfest();
		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			let tmpKey = tmpDescriptorKeys[i];
			if (tmpKey.startsWith('Descriptor_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpValue = tmpRecord[tmpKey];

					// Use the manifest to put it on the descriptor
					if (tmpValue)
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Float_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Float_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue = parseFloat(tmpRawValue);

					// Use the manifest to put it on the descriptor
					if (!isNaN(tmpValue))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
						this.log.trace(`Set Float Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}] to value [${tmpValue}]`);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Float Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Integer_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Integer_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue = parseInt(tmpRawValue);

					// Use the manifest to put it on the descriptor
					if (!isNaN(tmpValue))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Integer Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Boolean_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Boolean_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue;

					if ((tmpRawValue.toLowerCase() == 'x') || (tmpRawValue.toLowerCase() == 'y') || (tmpRawValue.toLowerCase() == 'yes') || (tmpRawValue.toLowerCase() == 't') || (tmpRawValue.toLowerCase() == 'true') || (tmpRawValue == '1'))
					{
						tmpValue = true;
					}
					if ((tmpRawValue.toLowerCase() == 'n') || (tmpRawValue.toLowerCase() == 'no') || (tmpRawValue.toLowerCase() == 'f') || (tmpRawValue.toLowerCase() == 'false') || (tmpRawValue == '0'))
					{
						tmpValue = false;
					}

					// Use the manifest to put it on the descriptor
					if ((tmpValue === true) || (tmpValue === false))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
					else if (tmpRawValue)
					{
						this.log.warn(`Could not parse Boolean value [${tmpRawValue}] for Descriptor Boolean Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]`);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Boolean Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}
		}

		if (tmpRecord.InputType != 'TabularAddress')
		{
			pManifestFactory.addDescriptor(tmpDescriptor);
		}
		else
		{
			tmpCoreManifestFactory.addDescriptor(tmpDescriptor);
		}

		return tmpDescriptor;
	}

	/**
	 * Add a validation solver to a manifest from a tabular row.
	 *
	 * @param {Record<string, any>} pManifest - The manifest being built
	 * @param {Record<string, any>} pRecord - The tabular row record -- expected to have at least a 'Form'
	 */
	tabularRowAddValidator(pManifest, pRecord)
	{
		if (pRecord['Equation'])
		{
			// Clean up the equation a bit to remove any leading/trailing spaces and replace HTML quotes
			// that may have been added by the CSV or other source.
			const tmpCleanEquation = pRecord['Equation'].trim();
			let tmpEquationOrdinal = 1;
			if (pRecord['Equation Ordinal'])
			{
				try
				{
					tmpEquationOrdinal = parseInt(pRecord['Equation Ordinal']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Equation Ordinal for ${pRecord['Input Hash']}: ${pError}`);
				}
			}
			this.log.trace(`Adding solver to ${pRecord.Form} Validation Solvers Ordinal ${tmpEquationOrdinal}: ${pRecord['Equation']}`);
			if (!Array.isArray(pManifest.ValidationSolvers))
			{
				pManifest.ValidationSolvers = [];
			}
			if (tmpEquationOrdinal == 1)
			{
				pManifest.ValidationSolvers.push(tmpCleanEquation);
			}
			else
			{
				pManifest.ValidationSolvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
			}
		}
	}

	/**
	 * This fires whenever a Tabular Row is adding a Descriptor to the Manifest.
	 *
	 * If you want to extend how descriptors are built, the code belongs in here.
	 *
	 * @param {Object} pIncomingDescriptor - The record for the descriptor being added (from a CSV or other source)
	 * @param {Object} pSection - The section object
	 * @param {Object} pGroup - The group object
	 * @param {Object} pNewDescriptor - The descriptor object
	 */
	onTabularRowAddDescriptor(pIncomingDescriptor, pSection, pGroup, pNewDescriptor)
	{
		// This is meant to be overloaded by the parent class
	}

	migrateAutofillTriggerGroupSolvers(pManifests)
	{
		for (const tmpManifestFactory of Object.values(pManifests))
		{
			const tmpManifest = tmpManifestFactory.manifest;

			const tmpGatheredSolverExpressions = [];

			for (const tmpSection of tmpManifest.Sections || [])
			{
				if (Array.isArray(tmpSection.Solvers))
				{
					for (let i = 0; i < tmpSection.Solvers.length; i++)
					{
						const tmpSolverEntry = tmpSection.Solvers[i];
						const tmpSolverExpression = (typeof (tmpSolverEntry) === 'string') ? tmpSolverEntry : tmpSolverEntry.Expression;
						if (typeof tmpSolverExpression === 'string' && tmpSolverExpression.startsWith('TriggerGroup:'))
						{
							tmpGatheredSolverExpressions.push(tmpSolverEntry);
							// Remove it from the section solvers
							tmpSection.Solvers.splice(i, 1);
							--i;
						}
					}
				}
				for (const tmpGroup of tmpSection.Groups || [])
				{
					if (Array.isArray(tmpGroup.RecordSetSolvers))
					{
						for (let i = 0; i < tmpGroup.RecordSetSolvers.length; i++)
						{
							const tmpSolverEntry = tmpGroup.RecordSetSolvers[i];
							const tmpSolverExpression = (typeof (tmpSolverEntry) === 'string') ? tmpSolverEntry : tmpSolverEntry.Expression;
							if (typeof tmpSolverExpression === 'string' && tmpSolverExpression.startsWith('TriggerGroup:'))
							{
								tmpGatheredSolverExpressions.push(tmpSolverEntry);
								// Remove it from the group solvers
								tmpGroup.RecordSetSolvers.splice(i, 1);
								--i;
							}
						}
					}
				}
			}
			for (const tmpTriggerGroupSolverEntry of tmpGatheredSolverExpressions)
			{
				const tmpSolverExpression = (typeof (tmpTriggerGroupSolverEntry) === 'string') ? tmpTriggerGroupSolverEntry : tmpTriggerGroupSolverEntry.Expression;
				let [ tmpType, tmpTriggerGroupHash, tmpPrePost, tmpSimpleSolverExpression ] = tmpSolverExpression.split(':');
				if (!tmpSimpleSolverExpression)
				{
					tmpSimpleSolverExpression = tmpPrePost;
					tmpPrePost = 'post';
				}

				if (!tmpSimpleSolverExpression || tmpSimpleSolverExpression.trim() === '')
				{
					this.log.error(`Skipping migration of empty TriggerGroup solver expression in manifest [${tmpManifest.Scope}] for TriggerGroup [${tmpTriggerGroupHash}]`);
					continue;
				}
				const tmpTriggerGroupDescriptor = Object.values(tmpManifest.Descriptors).find((pDescriptor) =>
				{
					if (!pDescriptor.PictForm?.AutofillTriggerGroup)
					{
						return false;
					}
					/** @type {Array<any>} */
					const tmpTriggerGroups = Array.isArray(pDescriptor.PictForm.AutofillTriggerGroup) ? pDescriptor.PictForm.AutofillTriggerGroup : [pDescriptor.PictForm.AutofillTriggerGroup];
					return tmpTriggerGroups.some((pTriggerGroup) => pTriggerGroup.TriggerGroupHash === tmpTriggerGroupHash);
				});
				if (!tmpTriggerGroupDescriptor)
				{
					this.log.error(`Could not find descriptor for TriggerGroup [${tmpTriggerGroupHash}] in manifest [${tmpManifest.Scope}] while migrating solver expression: ${tmpSolverExpression}`);
					continue;
				}
				const tmpTriggerGroups = Array.isArray(tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup) ? tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup : [tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup];
				const tmpTriggerGroup = tmpTriggerGroups.find((pTriggerGroup) => pTriggerGroup.TriggerGroupHash === tmpTriggerGroupHash);
				if (!tmpTriggerGroup)
				{
					this.log.error(`Could not find TriggerGroup entry for TriggerGroup [${tmpTriggerGroupHash}] in descriptor [${tmpTriggerGroupDescriptor.Hash}] while migrating solver expression: ${tmpSolverExpression}`);
					continue;
				}
				let tmpUpdatedTriggerGroupSolverEntry = tmpTriggerGroupSolverEntry;
				if (typeof tmpTriggerGroupSolverEntry === 'string')
				{
					tmpUpdatedTriggerGroupSolverEntry = tmpSimpleSolverExpression;
				}
				else
				{
					tmpTriggerGroupSolverEntry.Expression = tmpSimpleSolverExpression;
				}
				if (tmpPrePost.toLowerCase() === 'pre')
				{
					tmpTriggerGroup.PreSolvers = tmpTriggerGroup.PreSolvers || [];
					tmpTriggerGroup.PreSolvers.push(tmpUpdatedTriggerGroupSolverEntry);
				}
				else
				{
					tmpTriggerGroup.PostSolvers = tmpTriggerGroup.PostSolvers || [];
					tmpTriggerGroup.PostSolvers.push(tmpUpdatedTriggerGroupSolverEntry);
				}
			}
		}
	}

	/**
	 * Helper function to determine if a value is "truthy" in the context of dynamic configuration.
	 *
	 * @param {any} pValue - The value to be evaluated
	 *
	 * @return {boolean} whether the value is considered true
	 */
	_isTrue(pValue)
	{
		if (typeof pValue === 'boolean')
		{
			return pValue;
		}
		if (typeof pValue === 'string')
		{
			const tmpValue = pValue.trim().toLowerCase();
			return tmpValue === 'true' || tmpValue === 't' || tmpValue === 'yes' || tmpValue === 'y' || tmpValue === '1';
		}
		return pValue == true || pValue == 1;
	}

	/**
	 * Create some manifests with a "factory" pattern.
	 *
	 * @param {any} pRecords - The records as an array of objects
	 *
	 * @return {any} the manifests
	 */
	createManifestsFromTabularArray(pRecords)
	{
		if (!pRecords || !Array.isArray(pRecords))
		{
			this.log.info('Invalid records passed to generateManifests.');
			return {};
		}

		const tmpManifestFactories = {};

		for (let i = 0; i < pRecords.length; i++)
		{
			let tmpRecord = pRecords[i];

			// Lint the row we are parsing
			if (!this.tabularRowLint(tmpRecord))
			{
				continue;
			}

			if (!tmpManifestFactories[tmpRecord.Form])
			{
				// Create the manifest if one doesn't exist
				tmpManifestFactories[tmpRecord.Form] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory',
					{
						Manifest:
						{
							Form: tmpRecord.Form
						}
					}, `${this.UUID}-${tmpRecord.Form}`);
			}

			const tmpManifestFactory = tmpManifestFactories[tmpRecord.Form];

			// Check if there is a Form Name to be set
			if (tmpRecord['Form Name'])
			{
				tmpManifestFactory.manifest.FormName = tmpRecord['Form Name'];
			}
			if (tmpRecord['Input Hash'])
			{
				this.tabularRowAddDescriptor(tmpManifestFactory, tmpRecord);
			}
			if (this._isTrue(tmpRecord['Validator']))
			{
				this.log.trace(`Adding validator from tabular row on form ${tmpRecord.Form}: ${tmpRecord.Equation}`);
				this.tabularRowAddValidator(tmpManifestFactory.manifest, tmpRecord);
			}
		}
		this.migrateAutofillTriggerGroupSolvers(tmpManifestFactories);

		this.log.info(`Generated ${Object.keys(tmpManifestFactories).length} manifests.`);

		let tmpManifestKeys = Object.keys(tmpManifestFactories);
		let tmpOutputManifests = {};
		for (let i = 0; i < tmpManifestKeys.length; i++)
		{
			tmpOutputManifests[tmpManifestKeys[i]] = tmpManifestFactories[tmpManifestKeys[i]].manifest;
		}
		return tmpOutputManifests;
	}
}

module.exports = ManifestFactory;
/** @type {Record<string, any>} */
ManifestFactory.default_configuration = {};

},{"fable-serviceproviderbase":438}],638:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libManifestFactory = require('../services/ManifestFactory.js');

const libDynamicSolver = require('../providers/Pict-Provider-DynamicSolver.js');
const libDynamicInput = require('../providers/Pict-Provider-DynamicInput.js');
const libDynamicInputEvents = require('../providers/Pict-Provider-DynamicInputEvents.js');
const libDynamicTabularData = require('../providers/Pict-Provider-DynamicTabularData.js');
const libDynamicRecordSet = require('../providers/Pict-Provider-DynamicRecordSet.js');

const libFormsTemplateProvider = require('../providers/Pict-Provider-DynamicTemplates.js');

const libMetatemplateGenerator = require('../providers/Pict-Provider-MetatemplateGenerator.js');
const libMetatemplateMacros = require('../providers/Pict-Provider-MetatemplateMacros.js');

const libPictLayoutRecord = require('../providers/layouts/Pict-Layout-Record.js');
const libPictLayoutVerticalRecord = require('../providers/layouts/Pict-Layout-VerticalRecord.js');
const libPictLayoutTabular = require('../providers/layouts/Pict-Layout-Tabular.js');
const libPictLayoutRecordSet = require('../providers/layouts/Pict-Layout-RecordSet.js');
const libPictLayoutChart = require('../providers/layouts/Pict-Layout-Chart.js');
const libPictLayoutTuiGrid = require('../providers/layouts/Pict-Layout-TuiGrid.js');
const libPictLayoutCustom = require('../providers/layouts/Pict-Layout-Custom.js');

const libInformary = require('../providers/Pict-Provider-Informary.js');

class PictDynamicFormDependencyManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		//let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultManifestSettings)), pOptions);
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		this.fable.addAndInstantiateSingletonService('ManifestFactory', libManifestFactory.default_configuration, libManifestFactory);

		this.fable.addProviderSingleton('DynamicInput', libDynamicInput.default_configuration, libDynamicInput);
		this.fable.addProviderSingleton('DynamicInputEvents', libDynamicInputEvents.default_configuration, libDynamicInputEvents);
		this.fable.addProviderSingleton('DynamicSolver', libDynamicSolver.default_configuration, libDynamicSolver);
		this.fable.addProviderSingleton('DynamicTabularData', libDynamicTabularData.default_configuration, libDynamicTabularData);
		this.fable.addProviderSingleton('DynamicRecordSet', libDynamicRecordSet.default_configuration, libDynamicRecordSet);

		this.fable.addProviderSingleton('PictFormSectionDefaultTemplateProvider', libFormsTemplateProvider.default_configuration, libFormsTemplateProvider);

		this.fable.addProviderSingleton('MetatemplateGenerator', libMetatemplateGenerator.default_configuration, libMetatemplateGenerator);
		this.fable.addProviderSingleton('MetatemplateMacros', libMetatemplateMacros.default_configuration, libMetatemplateMacros);

		this.fable.addProviderSingleton('Pict-Layout-Record', libPictLayoutRecord.default_configuration, libPictLayoutRecord);
		this.fable.addProviderSingleton('Pict-Layout-VerticalRecord', libPictLayoutVerticalRecord.default_configuration, libPictLayoutVerticalRecord);
		this.fable.addProviderSingleton('Pict-Layout-Tabular', libPictLayoutTabular.default_configuration, libPictLayoutTabular);
		this.fable.addProviderSingleton('Pict-Layout-RecordSet', libPictLayoutRecordSet.default_configuration, libPictLayoutRecordSet);
		this.fable.addProviderSingleton('Pict-Layout-Chart', libPictLayoutChart.default_configuration, libPictLayoutChart);
		this.fable.addProviderSingleton('Pict-Layout-TuiGrid', libPictLayoutTuiGrid.default_configuration, libPictLayoutTuiGrid);
		this.fable.addProviderSingleton('Pict-Layout-Custom', libPictLayoutCustom.default_configuration, libPictLayoutCustom);

		this.fable.addProviderSingleton('Informary', libInformary.default_configuration, libInformary);
	}
}

module.exports = PictDynamicFormDependencyManager;

/** @type {Record<string, any>} */
PictDynamicFormDependencyManager.default_configuration = { };

},{"../providers/Pict-Provider-DynamicInput.js":590,"../providers/Pict-Provider-DynamicInputEvents.js":591,"../providers/Pict-Provider-DynamicRecordSet.js":593,"../providers/Pict-Provider-DynamicSolver.js":594,"../providers/Pict-Provider-DynamicTabularData.js":595,"../providers/Pict-Provider-DynamicTemplates.js":596,"../providers/Pict-Provider-Informary.js":598,"../providers/Pict-Provider-MetatemplateGenerator.js":602,"../providers/Pict-Provider-MetatemplateMacros.js":603,"../providers/layouts/Pict-Layout-Chart.js":628,"../providers/layouts/Pict-Layout-Custom.js":629,"../providers/layouts/Pict-Layout-Record.js":630,"../providers/layouts/Pict-Layout-RecordSet.js":631,"../providers/layouts/Pict-Layout-Tabular.js":632,"../providers/layouts/Pict-Layout-TuiGrid.js":633,"../providers/layouts/Pict-Layout-VerticalRecord.js":635,"../services/ManifestFactory.js":637,"fable-serviceproviderbase":438}],639:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * @typedef {{
       reset: () => void,
       clone: () => Manyfest,
       deserialize: (pManifestString: string) => void,
       loadManifest: (pManifest: any) => void,
       serialize: () => string,
       getManifest: () => { Scope: string, Descriptors: any, HashTranslations: any, },
       addDescriptor: (pAddress: string, pDescriptor: any) => void,
       getDescriptorByHash: (pHash: string) => any,
       getDescriptor: (pAddress: string) => any,
       eachDescriptor: (fAction: (pDescriptor: any) => void) => void,
       checkAddressExistsByHash : (pObject: any, pHash: string) => boolean,
       checkAddressExists : (pObject: any, pAddress: string) => boolean,
       resolveHashAddress: (pHash: string) => any,
       getValueByHash : (pObject: any, pHash: string) => any,
       getValueAtAddress : (pObject: any, pAddress: string) => any,
       setValueByHash: (pObject: any, pHash: string, pValue: any) => boolean,
       setValueAtAddress : (pObject: any, pAddress: string, pValue: any) => void,
       deleteValueByHash: (pObject: any, pHash: string, pValue: any) => void,
       deleteValueAtAddress : (pObject: any, pAddress: string, pValue: any) => void,
       validate: (pObject: any) => boolean,
       getDefaultValue: (pDescriptor: any) => any,
       populateDefaults: (pObject: any, pOverwriteProperties: boolean) => void,
       populateObject: (pObject: any, pOverwriteProperties: boolean, fFilter: (pDescriptor: any) => boolean) => void,
       serviceType: string,
       options: any,
       scope?: string,
       elementAddresses: Array<string>,
       elementHashes: Object,
       elementDescriptors: Object,
 * }} Manyfest
 */


/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateControlFromDynamicManifest extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~DynamicInput:', '~}');
		this.addPattern('{~DI:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpHash = pTemplateHash.trim();
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptor(tmpHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateControlFromDynamicManifest: Cannot find descriptor for address [${tmpHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];
		const tmpScope = tmpView || pScope;
		const tmpContextArray = tmpScope ? [ tmpScope ] : (pContextArray || [ this.pict ]);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpView, descriptor);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpView, descriptor.DataType, descriptor.PictForm.InputType,
			`getInput("${descriptor.PictForm.GroupIndex}","${descriptor.PictForm.RowIndex}","${descriptor.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, descriptor, fCallback, tmpContextArray, tmpScope, pState);
	}
}

module.exports = PictTemplateControlFromDynamicManifest;

},{"pict-template":731}],640:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateControlFromDynamicManifest extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~DynamicInputForHash:', '~}');
		this.addPattern('{~DIH:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema hash.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema hash.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpHash = pTemplateHash.trim();
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptorByHash(tmpHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateControlFromDynamicManifest: Cannot find descriptor for hash [${tmpHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];
		const tmpScope = tmpView || pScope;
		const tmpContextArray = tmpScope ? [ tmpScope ] : (pContextArray || [ this.pict ]);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpView, descriptor);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpView, descriptor.DataType, descriptor.PictForm.InputType,
			`getInput("${descriptor.PictForm.GroupIndex}","${descriptor.PictForm.RowIndex}","${descriptor.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, descriptor, fCallback, tmpContextArray, tmpScope, pState);
	}
}

module.exports = PictTemplateControlFromDynamicManifest;

},{"pict-template":731}],641:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateGetViewSchemaValue extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~SchemaValue:', '~}');
		this.addPattern('{~SV:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const [ tmpSchemaAddress, tmpTemplateHash ] = pTemplateHash.trim().split('^');
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptor(tmpSchemaAddress);
		if (!descriptor)
		{
			this.log.error(`PictTemplateGetViewSchemaValue: Cannot find descriptor for address [${tmpSchemaAddress}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];

		const value = tmpView.getValueByHash(tmpSchemaAddress);

		if (tmpTemplateHash)
		{
			const tmpRecord = { Value: value, ParentRecord: pRecord, View: tmpView, Descriptor: descriptor };
			if (typeof fCallback !== 'function')
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
			}
			return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return fCallback(pError, '');
					}
					return fCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}

		if (typeof(fCallback) === 'function')
		{
			fCallback(null, value ? String(value) : '');
		}
		else
		{
			return value ? String(value) : '';
		}
	}
}

module.exports = PictTemplateGetViewSchemaValue;

},{"pict-template":731}],642:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateGetViewSchemaValueByHash extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~SchemaValueForHash:', '~}');
		this.addPattern('{~SVH:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const [ tmpSchemaHash, tmpTemplateHash ] = pTemplateHash.trim().split('^');
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptorByHash(tmpSchemaHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateGetViewSchemaValueByHash: Cannot find descriptor for address [${tmpSchemaHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];

		const value = tmpView.getValueByHash(tmpSchemaHash);

		if (tmpTemplateHash)
		{
			const tmpRecord = { Value: value, ParentRecord: pRecord, View: tmpView, Descriptor: descriptor };
			if (typeof fCallback !== 'function')
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
			}
			return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return fCallback(pError, '');
					}
					return fCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}

		if (typeof(fCallback) === 'function')
		{
			fCallback(null, value ? String(value) : '');
		}
		else
		{
			return value ? String(value) : '';
		}
	}
}

module.exports = PictTemplateGetViewSchemaValueByHash;

},{"pict-template":731}],643:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will take a value set and render a template for each value in the set.
 *
 * It passes along additional context (the metacontroller group) for dynamic programming tables.
 */
class PictTemplateMetacontrollerValueSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetacontrollerTemplateValueSet:', '~}');
		this.addPattern('{~MTVS:', '~}');
	}

	/**
	 * Renders the PICT Metacontroller Template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Metacontroller Template [MetacontrollerTemplateValueSet]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetacontrollerTemplateValueSet]::[${tmpHash}]`);
		}

		let tmpGroupIndex;
		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`Metacontroller template requires 3 parameters [${tmpHash}]`);
			return '';
		}
		tmpTemplateHash = tmpHashTemplateSeparator[0];
		tmpGroupIndex = tmpHashTemplateSeparator[1];
		tmpAddressOfData = tmpHashTemplateSeparator[2];

		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i, Group: tmpGroupIndex });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i], Group: tmpGroupIndex });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Asynchronously renders a template with the provided template hash, record, callback, and context array.
	 *
	 * @param {string} pTemplateHash - The template hash to render.
	 * @param {object} pRecord - The record object to use for rendering the template.
	 * @param {function} fCallback - The callback function to invoke after rendering the template.
	 * @param {array} pContextArray - The context array to use for resolving the data.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i, });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
			return;
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
			return;
		}
	}
}

module.exports = PictTemplateMetacontrollerValueSet;

},{"pict-template":731}],644:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateMetatemplateInputTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetaTemplateInput:', '~}');
		this.addPattern('{~MTI:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		tmpInputAddress = tmpHashTemplateSeparator[1];
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		tmpInputAddress = tmpHashTemplateSeparator[1];
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
		return;
	}
}

module.exports = PictTemplateMetatemplateInputTemplate;

},{"pict-template":731}],645:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateMetatemplateInputTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetaTemplateInputWithHashAddress:', '~}');
		this.addPattern('{~MTIWHA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[1], pRecord, pContextArray, null, pScope, pState);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`MetaTemplateInput template requires a valid Address for an Address in the second parameter [${tmpHash}]`);
			return '';
		}
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		const tmpInput =
		{
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm:
			{
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			},
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				const tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the Address and the DataType)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[1], pRecord, pContextArray, null, pScope, pState);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`MetaTemplateInput template requires a valid Address for an Address in the second parameter [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
		return;
	}
}

module.exports = PictTemplateMetatemplateInputTemplate;

},{"pict-template":731}],646:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash)
 */
class PictTemplateInputWithViewTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithView:', '~}');
		this.addPattern('{~IWV:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithView]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithView template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		tmpInputAddress = tmpHashTemplateSeparator[2];
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithView template requires a valid dynamic View hash [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithView]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithView template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		tmpInputAddress = tmpHashTemplateSeparator[2];
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithView template requires a valid dynamic View hash [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}
}

module.exports = PictTemplateInputWithViewTemplate;

},{"pict-template":731}],647:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash)
 */
class PictTemplateInputWithViewAndDescriptorAddressTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js'), DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithViewAndDescriptorAddress:', '~}');
		this.addPattern('{~IWVDA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndDescriptorAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpDescriptorAddress;

		// This is just a simple 2 part hash (the view hash and the descriptor address)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires two parameters (ViewHash and DescriptorAddress) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpDescriptorAddress = tmpHashTemplateSeparator[1];

		const tmpInput = this.resolveStateFromAddress(tmpDescriptorAddress, pRecord, pContextArray, null, pScope, pState);

		if (!tmpInput || typeof tmpInput !== 'object' || Array.isArray(tmpInput) || !tmpInput.Address)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid input object at address [${tmpDescriptorAddress}]`);
			return '';
		}

		this._shoreUpDescriptor(tmpInput);

		this.currentInputIndex++;

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid dynamic View hash [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndDescriptorAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpDescriptorAddress;

		// This is just a simple 2 part hash (the view hash and the descriptor address)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires two parameters (ViewHash and DescriptorAddress) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpDescriptorAddress = tmpHashTemplateSeparator[1];

		const tmpInput = this.resolveStateFromAddress(tmpDescriptorAddress, pRecord, pContextArray, null, pScope, pState);

		this._shoreUpDescriptor(tmpInput);

		this.currentInputIndex++;

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid dynamic View hash [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}

	_shoreUpDescriptor(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object' || Array.isArray(pDescriptor))
		{
			throw new Error('Invalid descriptor object provided to shoreUpDescriptor');
		}
		if (!pDescriptor.DataAddress)
		{
			pDescriptor.DataAddress = pDescriptor.Address;
		}
		if (!pDescriptor.Hash)
		{
			pDescriptor.Hash = this.fable.DataFormat.sanitizeObjectKey(pDescriptor.Address);
		}
		if (!pDescriptor.Name)
		{
			pDescriptor.Name = pDescriptor.Hash;
		}
		if (!pDescriptor.DataType)
		{
			pDescriptor.DataType = 'String';
		}
		if (!pDescriptor.PictForm)
		{
			pDescriptor.PictForm = { };
		}
		if (!pDescriptor.PictForm.InformaryDataAddress)
		{
			pDescriptor.PictForm.InformaryDataAddress = pDescriptor.DataAddress;
		}
		if (pDescriptor.PictForm.GroupIndex == null)
		{
			pDescriptor.PictForm.GroupIndex = 0;
		}
		if (pDescriptor.PictForm.Row == null)
		{
			pDescriptor.PictForm.Row = 0;
		}
	}
}

module.exports = PictTemplateInputWithViewAndDescriptorAddressTemplate;

},{"pict-template":731}],648:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash) and a hash address.
 */
class PictTemplateInputWithViewAndHashAddressTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithViewAndHashAddress:', '~}');
		this.addPattern('{~IWVHA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndHashAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[2], pRecord, pContextArray, null, pScope);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid Address for an Address in the third parameter [${tmpHash}]`);
			return '';
		}
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		const tmpInput =
		{
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm:
			{
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			},
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash]; //tmpMetatemplateGenerator.dynamicInputView;

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid dynamic View hash as the first parameter [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				const tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndHashAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[2], pRecord, pContextArray, null, pScope);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid Address for an Address in the third parameter [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash]; //tmpMetatemplateGenerator.dynamicInputView;

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid View hash as the first parameter [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}
}

module.exports = PictTemplateInputWithViewAndHashAddressTemplate;

},{"pict-template":731}],649:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPluckJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~PluckJoinUnique:', '~}');
		this.addPattern('{~PJU:', '~}');
	}

	/**
	 * Renders the PICT Metacontroller Template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 3)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();
		let tmpAddress = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				// This one only works on arrays of objects.
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if ((tmpValueSet[j] === null) || (typeof(tmpValueSet) !== 'object'))
					{
						continue;
					}
					let tmpValue = this.pict.manifest.getValueByHash(tmpValueSet[j], tmpAddress);
					if (!(tmpValue in tmpValueMap))
					{
						tmpValueMap[tmpValue] = true;
						tmpValueList.push(tmpValue);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderPluckJoinUnique;

},{"pict-template":731}],650:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Template tag that renders the editing-controls <td> (del / up / down) for
 * one row of a tabular group when EditingControlsPosition is "left".
 *
 * Usage in a tabular row template:
 *
 *   {~TabularEditingControls:<ViewHash>~}
 *   {~TEC:<ViewHash>~}
 *
 * Reads Record.Group and Record.Key from the MTVS row wrapper, then calls
 * the layout provider's `_renderTabularEditingControlsHTML(view, gi, rk)`.
 *
 * Implemented as a dedicated tag (rather than `{~F:~}`) so it works on the
 * older pict versions some hosts ship with.
 */
class PictTemplateTabularEditingControls extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~TabularEditingControls:', '~}');
		this.addPattern('{~TEC:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		if (!tmpHash || !pRecord)
		{
			return '';
		}
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return '';
		}
		let tmpGroupIndex = pRecord.Group;
		let tmpRowKey = pRecord.Key;
		let tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || typeof tmpLayout._renderTabularEditingControlsHTML !== 'function')
		{
			return '';
		}
		return tmpLayout._renderTabularEditingControlsHTML(tmpView, tmpGroupIndex, tmpRowKey);
	}
}

module.exports = PictTemplateTabularEditingControls;

},{"pict-template":731}],651:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Template tag that renders the left-side row-label <td> cells for one row
 * of a tabular group with `RowLabels` configured.
 *
 * Usage in a tabular row template:
 *
 *   {~TabularRowLabels:<ViewHash>~}
 *   {~TRL:<ViewHash>~}
 *
 * The current Record context is expected to be the MTVS wrapper
 * (`{ Value, Key, Group }`); the tag reads `Record.Group` and `Record.Key`
 * to look up the group's precomputed `RowLabelMetadata[Record.Key].Cells`
 * and renders one `<td rowspan>` per non-skipped cell.
 *
 * This is implemented as a dedicated tag (rather than `{~F:~}`) so it works
 * on the older pict versions some hosts ship with.
 */
class PictTemplateTabularRowLabels extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~TabularRowLabels:', '~}');
		this.addPattern('{~TRL:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		if (!tmpHash || !pRecord)
		{
			return '';
		}
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return '';
		}
		let tmpGroupIndex = pRecord.Group;
		let tmpRowKey = pRecord.Key;
		let tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || typeof tmpLayout._renderTabularRowLabelsHTML !== 'function')
		{
			return '';
		}
		return tmpLayout._renderTabularRowLabelsHTML(tmpView, tmpGroupIndex, tmpRowKey);
	}
}

module.exports = PictTemplateTabularRowLabels;

},{"pict-template":731}],652:[function(require,module,exports){
module.exports={
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ExecuteSolversWithoutMetacontroller": false,
	"IncludeInMetatemplateSectionGeneration": true,
	"IncludeInDefaultDynamicRender": true,

	"DefaultRenderable": "Form-Main",
	"DefaultDestinationAddress": "#Pict-Form-Container",

	"Renderables": [],

	"Templates": [],

	"MacroTemplates": {
		"Section": {
			"HTMLID": " id=\"Section-{~D:Context[0].UUID~}\" "
		},
		"Group": {
			"HTMLID": " id=\"Group-{~D:Context[0].UUID~}\" ",

			"PictFormLayout": " data-i-pictdynamiclayout=\"true\" data-i-pictgroupindex=\"{~D:Record.GroupIndex~}\" data-i-pictlayout=\"{~D:Record.Layout~}\" ",

			"TabularCreateRowFunctionCall": "{~P~}.views['{~D:Context[0].Hash~}'].createDynamicTableRow({~D:Record.GroupIndex~})"
		},
		"Input": {
			"Informary": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\" ",
			"InformaryTabular": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\" data-i-container=\"{~D:Record.PictForm.InformaryContainerAddress~}\" ",

			"ControlAttr": " data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",

			"HTMLSelector": "[data-i-form=\"{~D:Context[0].formID~}\"][data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"]",
			"HTMLSelectorTabular": "[data-i-form=\"{~D:Context[0].formID~}\"][data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"][data-i-container=\"{~D:Record.PictForm.InformaryContainerAddress~}\"]",
			"HTMLSelectorControl": "[data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\"]",
			"HTMLSelectorControlTabular": "[data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\"]",

			"RawHTMLID": "{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}",

			"HTMLName": " name=\"{~D:Record.Name~}\" ",
			"HTMLIDAddress": "#{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}",
			"HTMLID": " id=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",
			"HTMLForID": " for=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",

			"InputFullProperties": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"  name=\"{~D:Record.Name~}\" ",
			"InputChangeHandler": " onchange=\"{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}')\" ",

			"DataRequestFunction": " {~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}'); "
		}
	},

	"TargetElementAddress": "#Form-Container-Div"
}

},{}],653:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/** @type {Record<string, any>} */
const libPackage = require('../../package.json');

/** @type {Record<string, any>} */
const _DefaultConfiguration = require('./Pict-View-DynamicForm-DefaultConfiguration.json');

const PENDING_ASYNC_OPERATION_TYPE = 'PendingAsyncOperation';
const TRANSACTION_COMPLETE_CALLBACK_TYPE = 'onTransactionComplete';
const READY_TO_FINALIZE_TYPE = 'ReadyToFinalize';

/**
 * Represents a dynamic form view for the Pict application.
 *
 * This is the code that maintains the lifecycle with the Pict application and
 * the data handling methods for a dynamic forms view (or set of views).
 *
 * @extends libPictViewClass
 */
class PictViewDynamicForm extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);

		if (!tmpOptions.Manifests)
		{
			throw new Error('PictSectionForm instantiation attempt without a Manifests in pOptions.Manifest -- cannot instantiate.');
		}
		if (!('Section' in tmpOptions.Manifests))
		{
			throw new Error('PictSectionForm instantiation attempt without a Section manifest in pOptions.Manifests -- cannot instantiate.');
		}
		// Set the default destination address to be based on the section hash if it hasn't been overridden by the manifest section definition
		if (tmpOptions.DefaultDestinationAddress === '#Pict-Form-Container')
		{
			tmpOptions.DefaultDestinationAddress = `#Pict-Form-Container-${tmpOptions.Hash}`;
		}
		// Set the default renderable to be based on the section hash if it hasn't been overridden by the manifest section definition
		if (tmpOptions.DefaultRenderable === 'Form-Main')
		{
			tmpOptions.DefaultRenderable = `Form-${tmpOptions.Hash}`;
		}
		// Set the template hash (which is the section-specific template prefix) if it hasn't been overridden by the manifest section definition
		if (!tmpOptions.SectionTemplateHash)
		{
			tmpOptions.SectionTemplateHash = `Pict-Form-Template-${tmpOptions.Hash}`;
		}

		// Create a renderable if none exist
		if (tmpOptions.Renderables.length < 1)
		{
			tmpOptions.Renderables.push(
				{
					RenderableHash: tmpOptions.DefaultRenderable,
					TemplateHash: tmpOptions.SectionTemplateHash,
					RenderMethod: 'replace'
				});
		}

		// Now construct the view.
		super(pFable, tmpOptions, pServiceHash);

		if (!this.fable.PictDynamicFormDependencyManager)
		{
			throw new Error('PictSectionForm instantiation attempt without a PictDynamicFormDependencyManager service in fable -- cannot instantiate.');
		}

		// Use this to manage transactions
		//FIXME: should we have these sioled??
		//this.transactionTracking = this.pict.newTransactionTracker();

		/** @type {Record<string, any>} */
		this._PackagePictView = this._Package;
		this._Package = libPackage;

		// Pull in the section definition
		this.sectionDefinition = this.options;

		// Initialize the section manifest -- instantiated to live only the lifecycle of this view
		this.sectionManifest = this.fable.instantiateServiceProviderWithoutRegistration('Manifest', this.options.Manifests.Section);

		// Shift solvers to an array of tasks
		this.sectionSolvers = [];
		// Pull in solvers
		if (('Solvers' in this.options) && Array.isArray(this.options.Solvers))
		{
			for (let i = 0; i < this.options.Solvers.length; i++)
			{
				if (typeof (this.options.Solvers[i]) === 'string')
				{
					this.sectionSolvers.push(this.options.Solvers[i]);
				}
			}
		}

		// Load any view section-specific templates
		this.formsTemplateSetPrefix = `PFT-${this.Hash}-${this.UUID}`;
		if (('MetaTemplates' in this.options) && Array.isArray(this.options.MetaTemplates))
		{
			for (let i = 0; i < this.options.MetaTemplates.length; i++)
			{
				let tmpMetaTemplate = this.options.MetaTemplates[i];

				if (('HashPostfix' in tmpMetaTemplate) && ('Template' in tmpMetaTemplate))
				{
					let tmpTemplateHash = `${this.formsTemplateSetPrefix}${tmpMetaTemplate.HashPostfix}`;
					this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpMetaTemplate.Template);
				}
				else
				{
					this.log.warn(`MetaTemplate entry ${i} in PictSectionForm [${this.UUID}]::[${this.Hash}] does not have a Hash and Template property; custom template skipped.`);
				}
			}
		}
		// The default template prefix
		this.customDefaultTemplatePrefix = null;

		this.formID = `Pict-Form-${this.Hash}-${this.UUID}`;

		this.viewMarshalDestination = null;
		this.initialBundleLoaded = false;

		this.fable.ManifestFactory.initializeFormGroups(this);

		this._LoopDetectionData = {};
	}

	/**
	 * Returns the default template prefix.
	 *
	 * @returns {string} The default template prefix.
	 */
	get defaultTemplatePrefix()
	{
		if (this.customDefaultTemplatePrefix)
		{
			return this.customDefaultTemplatePrefix;
		}
		else if (this.pict.views.PictFormMetacontroller)
		{
			return this.pict.views.PictFormMetacontroller.formTemplatePrefix;
		}
		else
		{
			return this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}
	}

	/**
	 * This method is called whenever data is changed within an input.
	 *
	 * It handles the data marshaling from the view to the data model,
	 * runs any providers connected to the input, solves the Pict application,
	 * then marshals data back to the view.
	 *
	 * @param {string} pInputHash - The hash of the input that triggered the data change.
	 */
	dataChanged(pInputHash)
	{
		let tmpInput = this.getInputFromHash(pInputHash);
		// This is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.

		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] dataChanged event for input [${pInputHash}].`);
		}
		if (pInputHash)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			let tmpHashAddress = this.sectionManifest.resolveHashAddress(pInputHash);
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest, tmpHashAddress);
				// Now run any providers connected to this input
				let tmpValue = this.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);

				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChange(this, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form dataChanged [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
		else
		{
			this.marshalFromView();
		}
		// Run any dynamic input providers for the input hash.
		this.pict.PictApplication.solve();
		if (this.pict.views.PictFormMetacontroller)
		{
			// since the solver may have changed data in other secitons, remarshal all sections
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			this.marshalToView();
		}
		// Notify the FormPersistence provider if it exists, for autosave
		if (this.pict.providers.FormPersistence)
		{
			this.pict.providers.FormPersistence.onFormDataChanged();
		}
	}


	/**
	 * Called whenever tabular data is changed.
	 *
	 * @param {number} pGroupIndex - the index of the group
	 * @param {number} pInputIndex - the index of the input
	 * @param {number} pRowIndex - the index of the row where the data was changed
	 */
	dataChangedTabular(pGroupIndex, pInputIndex, pRowIndex)
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] dataChangedTabular event for group ${pGroupIndex} input ${pInputIndex} row ${pRowIndex}.`);
		}
		let tmpInput = this.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (
			(typeof (pGroupIndex) != 'undefined')
			&& (typeof (pInputIndex) != 'undefined')
			&& (typeof (pRowIndex) != 'undefined')
			&& (typeof (tmpInput) == 'object')
		)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			let tmpHashAddress = tmpInput.Address;
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest, tmpHashAddress, pRowIndex);

				// TODO: Can we simplify this?
				let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = this.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);
				// Each row has a distinct address!
				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular + `[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChangeTabular(this, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form dataChangedTabular [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${tmpInput.Hash}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
		else
		{
			// This is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.
			this.marshalFromView();
		}
		// Run any dynamic input providers for the input hash.
		this.pict.PictApplication.solve();
		if (this.pict.views.PictFormMetacontroller)
		{
			// since the solver may have changed data in other secitons, remarshal all sections
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			this.marshalToView();
		}
		// Notify the FormPersistence provider if it exists, for autosave
		if (this.pict.providers.FormPersistence)
		{
			this.pict.providers.FormPersistence.onFormDataChanged();
		}
	}

	/**
	 * Sets the data in a specific form input based on the provided input object
	 *
	 * FIXME: does this need to have a transaction GUID passed in?
	 *
	 * @param {object} pInput - The input object.
	 * @param {any} pValue - The value to set.
	 * @returns {boolean} Returns true if the data was set successfully, false otherwise.
	 */
	setDataByInput(pInput, pValue)
	{
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.sectionManifest.setValueByHash(this.getMarshalDestinationObject(), pInput.Hash, pValue);

			// TODO: DRY TIME, excellent.
			let tmpValue = pValue;
			// Each row has a distinct address!
			let tmpVirtualInformaryHTMLSelector = pInput.Macro.HTMLSelector;
			let tmpInputProviderList = this.getInputProviderList(pInput);
			for (let i = 0; i < tmpInputProviderList.length; i++)
			{
				if (this.pict.providers[tmpInputProviderList[i]])
				{
					this.pict.providers[tmpInputProviderList[i]].onDataChange(this, pInput, tmpValue, tmpVirtualInformaryHTMLSelector, tmpTransactionGUID);
				}
				else
				{
					this.log.error(`Dynamic form setDataByInput [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${pInput.Hash}].`);
				}
			}
		}
		catch (pError)
		{
			this.log.error(`Dynamic form setDataByInput [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInput.Hash}) from view in dataChanged event: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}

		return false;
	}

	/**
	 * Sets the data in a specific tabular form input based on the provided hash, group and row.
	 *
	 * FIXME: does this need to have a transaction GUID passed in?
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pInputHash - The hash of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} pValue - The value to set.
	 * @returns {boolean} Returns true if the data was set successfully, false otherwise.
	 */
	setDataTabularByHash(pGroupIndex, pInputHash, pRowIndex, pValue)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = this.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper setDataTabularByHash ${pGroupIndex} was not a valid group.`);
			return false;
		}

		let tmpInputIndex = -1;
		let tmpElementDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
		for (let i = 0; i < tmpElementDescriptorKeys.length; i++)
		{
			if (tmpGroup.supportingManifest.elementDescriptors[tmpElementDescriptorKeys[i]].Hash === pInputHash)
			{
				tmpInputIndex = i;
				break;
			}
		}
		if (tmpInputIndex < 0)
		{
			this.log.warn(`PICT View Metatemplate Helper setDataTabularByHash Group ${pGroupIndex} did not have hash [${pInputHash}].`);
			return false;
		}

		let tmpInput = this.getTabularRecordInput(pGroupIndex, tmpInputIndex);
		if (
			(typeof (pGroupIndex) != 'undefined')
			&& (typeof (pRowIndex) != 'undefined')
			&& (typeof (tmpInput) == 'object')
		)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				this.sectionManifest.setValueByHash(tmpMarshalDestinationObject, tmpValueAddress, pValue)

				// TODO: DRY TIME, excellent.
				let tmpValue = pValue;
				// Each row has a distinct address!
				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular + `[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChangeTabular(this, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form setDataTabularByHash [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form setDataTabularByHash [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInputHash}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}

		return false;
	}

	/**
	 * Retrieves the marshal destination address.
	 *
	 * @returns {string} The marshal destination address.
	 */
	getMarshalDestinationAddress()
	{
		return this.viewMarshalDestination || this.pict.providers.DataBroker.marshalDestination;
	}

	/**
	 * Retrieves the marshal destination object.  This is where the model data is stored.
	 *
	 * @return {Record<string, any>} The marshal destination object.
	 */
	getMarshalDestinationObject()
	{
		return this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.viewMarshalDestination);
	}

	/**
	 * Gets a value by hash address.
	 *
	 * @param {string} pHashAddress
	 * @return {any} The value at the specified hash address.
	 */
	getValueByHash(pHashAddress)
	{
		return this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), pHashAddress);
	}

	/**
	 * Gets a value by hash address.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pInputIndex
	 * @param {number} pRowIndex
	 * @return {any} The value at the specified hash address.
	 */
	getTabularValueByHash(pGroupIndex, pInputIndex, pRowIndex)
	{
		const tmpInput = this.getTabularRecordInput(pGroupIndex, pInputIndex);
		const tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
		return this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpAddress);
	}

	/**
	 * Marshals data to the view.
	 *
	 * @returns {any} The result of calling the superclass's onMarshalToView method.
	 */
	onMarshalToView()
	{
		// TODO: Only marshal data that has changed since the last marshal.  Thought experiment: who decides what changes happened?
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
			// TODO: Add optional transaction awareness to informary
			this.pict.providers.Informary.marshalDataToForm(tmpMarshalDestinationObject, this.formID, this.sectionManifest);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', null, null, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data to view: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
		return super.onMarshalToView();
	}

	manualMarshalDataToViewByInput(pInput, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) == 'string') ? pTransactionGUID : this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.pict.providers.Informary.manualMarshalDataToFormByInput(pInput);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', pInput.Hash, null, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data to view: ${pError}`);
		}
		finally
		{
			if (tmpTransactionGUID !== pTransactionGUID)
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
	}

	manualMarshalTabularDataToViewByInput(pInput, pRowIndex, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) == 'string') ? pTransactionGUID : this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.pict.providers.Informary.manualMarshalTabularDataToFormByInput(pInput, pRowIndex);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', pInput.Hash, pRowIndex, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling tabular data to view: ${pError}`);
		}
		finally
		{
			if (tmpTransactionGUID !== pTransactionGUID)
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
	}

	/**
	 * Marshals data from the view to the destination object.
	 * @returns {any} The result of calling the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		try
		{
			let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
			this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data from view: ${pError}`);
		}
		return super.onMarshalFromView();
	}

	/**
	 * Executes after marshaling the data to the form.
	 * Checks if there are any hooks set from the input providers (from custom InputType handler hooks) and runs them.
	 */
	onAfterMarshalToForm()
	{
		// Check to see if there are any hooks set from the input templates
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.runInputProviderFunctions('onAfterMarshalToForm', null, null, tmpTransactionGUID);

		}
		catch (pError)
		{
			this.log.error(`Gross error running after marshal to form: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Executes the solve operation for the dynamic views.
	 *
	 * @returns {any} The result of the solve operation.
	 */
	onSolve()
	{
		// Usually the metacontroller runs this for the views
		if (this.options.ExecuteSolversWithoutMetacontroller)
		{
			this.pict.providers.DynamicSolver.solveViews([this.Hash]);
		}
		return super.onSolve();
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		if (!this.initialBundleLoaded)
		{
			if (Array.isArray(this.sectionDefinition.InitialBundle))
			{
				this.pict.EntityProvider.processBundle(this.sectionDefinition.InitialBundle);
			}
			this.initialBundleLoaded = true;
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {(error?: Error) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync((pError) =>
		{
			if (!this.initialBundleLoaded)
			{
				if (Array.isArray(this.sectionDefinition.InitialBundle))
				{
					this.pict.EntityProvider.gatherDataFromServer(this.sectionDefinition.InitialBundle, (pInnerError) =>
					{
						if (pInnerError)
						{
							this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to load initial bundle: ${pInnerError}`);
						}
						// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
						setTimeout(() => fCallback(pError), 0);
					});
					return;
				}
				this.initialBundleLoaded = true;
			}
			return fCallback(pError);
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		let tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		try
		{
			this.runLayoutProviderFunctions('onGroupLayoutInitialize', tmpTransactionGUID);
			this.runInputProviderFunctions('onInputInitialize', null, null, tmpTransactionGUID, true);
		}
		catch (pError)
		{
			this.log.error(`Gross error running after render: ${pError.message || pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}

		// The render that just happened repainted this section's markup without anything the solvers put
		// on it -- the setsectionvisibility / setgroupvisibility hide classes, and any highlight class or
		// inline color. Solvers run before the marshal that triggers most renders, so nothing else puts
		// them back: restore them here, once, for every render path.
		if (this.pict.providers.DynamicFormSolverBehaviors && this.sectionDefinition)
		{
			this.pict.providers.DynamicFormSolverBehaviors.reapplySectionDOMState(this.sectionDefinition.Hash);
		}

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Executes layout provider functions based on the given function name.
	 *
	 * These were TODO items that are now done but..  leaving them here to document complexity of why it works this way.
	 *
	 * --> This happens based on markers in the DOM, since we don't know which layout providers are active for which groups.
	 *
	 * --> This is easy to make happen with a macro on groups that gives us the data.
	 *
	 * --> THIS IS NOW SCOPED TO A PARTICULAR GROUP.  That is ... only one layout for a group at a time.
	 *
	 * The easiest way (and a speed up for other queries as such) is to scope it within the view container element
	 *
	 * @param {string} pFunctionName - The name of the function to execute.
	 * @param {string} [pTransactionGUID] - The transaction GUID to use for logging.
	 */
	runLayoutProviderFunctions(pFunctionName, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpTransaction = this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		// Check to see if there are any hooks set from the input templates
		let tmpLayoutProviders = this.pict.ContentAssignment.getElement(`${this.sectionDefinition.DefaultDestinationAddress} [data-i-pictdynamiclayout="true"]`);

		// Slightly more code for getting the active layout providers but provides TRUE DYNAMISM.
		for (let i = 0; i < tmpLayoutProviders.length; i++)
		{
			let tmpGroupIndex = tmpLayoutProviders[0].getAttribute('data-i-pictgroupindex');
			let tmpLayout = tmpLayoutProviders[0].getAttribute('data-i-pictlayout');

			if (isNaN(tmpGroupIndex) || (tmpGroupIndex < 0))
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions ${tmpGroupIndex} was not a valid group index.`);
				continue;
			}
			let tmpGroup = this.getGroup(tmpGroupIndex);
			if (!tmpGroup)
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions for group ${tmpGroupIndex} was not a valid group.`);
				continue;
			}
			if (!tmpLayout || typeof (tmpLayout) !== 'string')
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions for group ${tmpGroup} layout [${tmpLayout}] was not a valid layout.`);
				continue;
			}

			let tmpLayoutProvider = this.pict.providers.MetatemplateGenerator.getGroupLayoutProvider(this, tmpGroup);
			if (tmpLayoutProvider && (pFunctionName in tmpLayoutProvider))
			{
				let tmpFunction = tmpLayoutProvider[pFunctionName];
				if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `G${tmpGroupIndex}-L${tmpLayout}`, pFunctionName))
				{
					tmpFunction.call(tmpLayoutProvider, this, tmpGroup);
				}
			}
		}
		if (tmpTransactionGUID !== pTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * @private
	 * @param {string} pFunctionName
	 * @param {string} [pInputHash]
	 * @param {number} [pRowIndex]
	 */
	_trackInfiniteLoop(pFunctionName, pInputHash, pRowIndex)
	{
		this._LoopDetectionData[pFunctionName] = this._LoopDetectionData[pFunctionName] || {};
		const tmpInputSignature = `${pInputHash ?? ''}::${pRowIndex ?? ''}`;
		const tmpNowEpochMS = Date.now();
		this._LoopDetectionData[pFunctionName][tmpInputSignature] = this._LoopDetectionData[pFunctionName][tmpInputSignature] || { Count: 0, Timestamp: tmpNowEpochMS };
		if (tmpNowEpochMS - this._LoopDetectionData[pFunctionName][tmpInputSignature].Timestamp > 1000)
		{
			// only track events within a 1 second window
			this._LoopDetectionData[pFunctionName][tmpInputSignature].Count = 0;
			this._LoopDetectionData[pFunctionName][tmpInputSignature].Timestamp = tmpNowEpochMS;
		}
		this._LoopDetectionData[pFunctionName][tmpInputSignature].Count += 1;
		return this._LoopDetectionData[pFunctionName][tmpInputSignature];
	}

	/**
	 * Runs the input provider functions.
	 *
	 * @param {string} pFunctionName - The name of the function to run for each input provider.
	 * @param {string} [pInputHash] - The hash of the input to run the function for.
	 * @param {number} [pRowIndex] - The index of the row to run the
	 * @param {string} [pTransactionGUID] - The transaction GUID to use for logging.
	 * @param {boolean} [pLoopDetection] - Whether to enable loop detection.
	 */
	runInputProviderFunctions(pFunctionName, pInputHash, pRowIndex, pTransactionGUID, pLoopDetection)
	{
		const tmpLoopData = this._trackInfiniteLoop(pFunctionName, pInputHash, pRowIndex);
		if (pLoopDetection && tmpLoopData.Count > 10) // seems like a reasonable threshold for now (10 inits in a second)
		{
			this.log.fatal(` !!!!!! Infinite loop detected in runInputProviderFunctions for function [${pFunctionName}] on input [${pInputHash}] row [${pRowIndex}] in form [${this.Hash}]::[${this.UUID}].  Aborting further processing.`, { Stack: new Error().stack });
			return;
		}
		const tmpTransactionGUID = (typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpTransaction = this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		// Check to see if there are any hooks set from the input templates
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = this.sectionDefinition.Groups[i];

			if (Array.isArray(tmpGroup.Rows))
			{
				for (let j = 0; j < tmpGroup.Rows.length; j++)
				{
					// TODO: Do we want row macros?  Let's be still and find out.
					let tmpRow = tmpGroup.Rows[j];
					for (let k = 0; k < tmpRow.Inputs.length; k++)
					{
						let tmpInput = tmpRow.Inputs[k];
						// Now run any providers connected to this input
						if (tmpInput && tmpInput.PictForm
							&& (!pInputHash || (pInputHash === tmpInput.Hash)))
						{
							let tmpInputProviderList = this.getInputProviderList(tmpInput);
							for (let l = 0; l < tmpInputProviderList.length; l++)
							{
								if (this.pict.providers[tmpInputProviderList[l]])
								{
									let tmpHashAddress = this.sectionManifest.resolveHashAddress(tmpInput.Hash);
									let tmpValue = this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpHashAddress);
									try
									{
										if (this.pict.LogNoisiness > 2)
										{
											this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] running provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}].`);
										}
										// TODO: Right now the Option input requires this bug to work
										//if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `I${tmpInput.Hash}-P${tmpInputProviderList[l]}`, pFunctionName))
										if ((tmpInput.PictForm.InputType == 'Option') || this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `I${tmpInput.Hash}-P${tmpInputProviderList[l]}`, pFunctionName))
										{
											this.pict.providers[tmpInputProviderList[l]][pFunctionName](this, tmpGroup, j, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, tmpTransactionGUID);
										}
									}
									catch (pError)
									{
										this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to run provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}] with error: ${pError}`);
									}
								}
								else
								{
									this.log.error(`Dynamic form runInputProviderFunctions core [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[l]}] for input [${tmpInput.Hash}].`);
								}
							}
						}
					}
				}
			}

			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					let tmpTabularRecordSet = this.getTabularRecordSet(tmpGroup.GroupIndex);
					// No data in the record set, no events to push to providers.
					if (!tmpTabularRecordSet)
					{
						continue;
					}

					if (Array.isArray(tmpTabularRecordSet))
					{
						let tmpInput = tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]];
						// Now run any providers connected to this input
						if (tmpInput && tmpInput.PictForm
							&& (!pInputHash || (pInputHash === tmpInput.Hash)))
						{
							let tmpInputProviderList = this.getInputProviderList(tmpInput);
							for (let l = 0; l < tmpInputProviderList.length; l++)
							{
								let tmpRowsToExecute = [];
								if (pRowIndex != null)
								{
									if (pRowIndex < tmpTabularRecordSet.length)
									{
										tmpRowsToExecute.push(pRowIndex);
									}
									else
									{
										this.log.error(`Dynamic form runInputProviderFunctions [${this.Hash}]::[${this.UUID}] row index ${pRowIndex} is out of bounds for input [${tmpInput.Hash}] with ${tmpTabularRecordSet.length} rows.`);
									}
								}
								else
								{
									for (let r = 0; r < tmpTabularRecordSet.length; r++)
									{
										tmpRowsToExecute.push(r);
									}
								}
								for (const r of tmpRowsToExecute)
								{
									if (this.pict.providers[tmpInputProviderList[l]] &&
										(pRowIndex === undefined || pRowIndex === null || pRowIndex === r))
									{
										// There is a provider, we have an input and it is supposed to be run through for a record
										let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, r, tmpInput.PictForm.InformaryDataAddress);
										let tmpValue = this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpValueAddress);
										try
										{
											if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `TI${tmpInput.Hash}-P${tmpInputProviderList[l]}-R${r}`, pFunctionName))
											{
												this.pict.providers[tmpInputProviderList[l]][pFunctionName + 'Tabular'](this, tmpGroup, tmpInput, tmpValue, tmpInput.Macro.HTMLSelectorTabular, r, tmpTransactionGUID);
											}
										}
										catch (pError)
										{
											this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to run provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}] with error: ${pError}`);
										}
									}
									else
									{
										this.log.error(`Dynamic form runInputProviderFunctions supporting [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[l]}] for input [${tmpInput.Hash}]${pRowIndex != null ? ` in row ${pRowIndex}` : ''}.`);
									}
								}
							}
						}
					}
				}
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Checks if a view-specific template exists based on the given template postfix.
	 * @param {string} pTemplatePostfix - The postfix of the template to check.
	 * @returns {boolean} - Returns true if the view-specific template exists, otherwise false.
	 */
	checkViewSpecificTemplate(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return (this.getViewSpecificTemplateHash(pTemplatePostfix) in this.pict.TemplateProvider.templates);
	}

	/**
	 * Returns the template hash for the view specific template.
	 *
	 * @param {string} pTemplatePostfix - The postfix for the template.
	 * @returns {string} The template hash for the view specific template.
	 */
	getViewSpecificTemplateHash(pTemplatePostfix)
	{
		return `${this.formsTemplateSetPrefix}${pTemplatePostfix}`;
	}

	/**
	 * Checks if a theme-specific template exists.
	 *
	 * @param {string} pTemplatePostfix - The postfix of the template.
	 * @returns {boolean} - Returns true if the theme-specific template exists, otherwise false.
	 */
	checkThemeSpecificTemplate(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return (this.getThemeSpecificTemplateHash(pTemplatePostfix) in this.pict.TemplateProvider.templates);
	}

	/**
	 * Returns the theme-specific template hash based on the given template postfix.
	 *
	 * @param {string} pTemplatePostfix - The postfix to be appended to the default template prefix.
	 * @returns {string} The theme-specific template hash.
	 */
	getThemeSpecificTemplateHash(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return `${this.defaultTemplatePrefix}${pTemplatePostfix}`;
	}

	/**
	 * Rebuilds the custom template fore the dynamic form..
	 */
	rebuildCustomTemplate()
	{
		this.pict.providers.MetatemplateGenerator.rebuildCustomTemplate(this);
	}

	/**
	 * Returns the index of a group within the sectionDefinition.Groups array that matches the provided hash.
	 *
	 * @param {string} pGroupHash - The hash value of the group to find.
	 * @returns {number} The index of the group if found; otherwise, -1.
	 */
	getGroupIndexFromHash(pGroupHash)
	{
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			if (this.sectionDefinition.Groups[i].Hash === pGroupHash)
			{
				return i;
			}
		}
		this.log.warn(`PICT View Metatemplate Helper getGroupIndexByHash could not find group with hash [${pGroupHash}].`);
		return -1;
	}

	/**
	 * Get a group by its hash
	 * @param {string} pGroupHash - The hash of the group to retrieve.
	 * @returns {object|boolean} - The group object if found, or false if the group hash is not found.
	 */
	getGroupFromHash(pGroupHash)
	{
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			if (this.sectionDefinition.Groups[i].Hash === pGroupHash)
			{
				return this.sectionDefinition.Groups[i];
			}
		}
		this.log.warn(`PICT View Metatemplate Helper getGroupByHash could not find group with hash [${pGroupHash}].`);
		return false;
	}

	/**
	 * Retrieves a group from the PICT View Metatemplate Helper based on the provided group index.
	 *
	 * @param {number} pGroupIndex - The index of the group to retrieve.
	 * @returns {object|boolean} - The group object if found, or false if the group index is invalid.
	 */
	getGroup(pGroupIndex)
	{
		if (isNaN(pGroupIndex))
		{
			this.log.warn(`PICT View Metatemplate Helper getGroup ${pGroupIndex} was expecting a number.`);
			return false;
		}
		if (pGroupIndex > this.sectionDefinition.Groups.length)
		{
			this.log.warn(`PICT View Metatemplate Helper getGroup ${pGroupIndex} was out of bounds.`);
			return false;
		}

		return this.sectionDefinition.Groups[pGroupIndex];
	}

	/**
	 * Returns all groups in the section.
	 * @returns {Array}
	 */
	getGroups()
	{
		if (!Array.isArray(this.sectionDefinition.Groups))
		{
			return [];
		}
		return this.sectionDefinition.Groups;
	}

	/**
	 * Get a row for an input form group.
	 *
	 * Rows are a horizontal collection of inputs.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pRowIndex
	 * @returns
	 */
	getRow(pGroupIndex, pRowIndex)
	{
		let tmpGroup = this.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			if (isNaN(pRowIndex))
			{
				this.log.warn(`PICT View Metatemplate Helper getRow ${pRowIndex} was expecting a number.`);
				return false;
			}
			if (pRowIndex > tmpGroup.Rows.length)
			{
				//this.log.warn(`PICT View Metatemplate Helper getRow ${pRowIndex} was out of bounds.`);
				return [];
			}
			return tmpGroup.Rows[pRowIndex];
		}
		else
		{
			return false;
		}
	}

	/**
	 * Get a customized key value pair object for a specific row.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {Object} a key value pair for a specific row, used in metatemplating.
	 */
	getRowKeyValuePair(pGroupIndex, pRowIndex)
	{
		return { Key: pGroupIndex, Value: this.getRow(pGroupIndex, pRowIndex), Group: this.getGroup(pGroupIndex) };
	}

	/**
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns {Object|boolean} The input object if found, or false if the input index is invalid.
	 */
	getInput(pGroupIndex, pRowIndex, pInputIndex)
	{
		let tmpRow = this.getRow(pGroupIndex, pRowIndex);

		if (tmpRow)
		{
			if (isNaN(pInputIndex))
			{
				this.log.warn(`PICT View Metatemplate Helper getInput ${pInputIndex} was expecting a number.`);
				return false;
			}
			if (pInputIndex > tmpRow.Inputs.length)
			{
				this.log.warn(`PICT View Metatemplate Helper getInput ${pInputIndex} was out of bounds.`);
				return false;
			}
			return tmpRow.Inputs[pInputIndex];
		}
		else
		{
			return false;
		}
	}

	/**
	 * Retrieves the input provider list for the given input object.
	 *
	 * @param {Object} pInput - The input object.
	 * @returns {Array} The input provider list.
	 */
	getInputProviderList(pInput)
	{
		if (!('PictForm' in pInput))
		{
			return [];
		}
		if (('Providers' in pInput.PictForm) && Array.isArray(pInput.PictForm.Providers))
		{
			let tmpDefaultProviders = this.pict.providers.DynamicInput.getDefaultInputProviders(this, pInput);

			if (tmpDefaultProviders.length > 0)
			{
				return tmpDefaultProviders.concat(pInput.PictForm.Providers);
			}
			return pInput.PictForm.Providers;
		}
		else
		{
			return this.pict.providers.DynamicInput.getDefaultInputProviders(this, pInput);
		}
	}

	/**
	 * Retrieves the input object for a specific hash.
	 *
	 * @param {string} pInputHash - The string hash for an input (not the address).
	 * @returns {Object} The input Object for the given hash.
	 */
	getInputFromHash(pInputHash)
	{
		return this.sectionManifest.getDescriptorByHash(pInputHash);
	}

	/**
	 * Triggers a DataRequest event for an Input Provider
	 *
	 * @param {String} pInputHash - The input hash.
	 * @param {any} [pEvent] - The input event.
	 * @returns {boolean} Whether or not the data request was successful.
	 */
	inputDataRequest(pInputHash, pEvent)
	{
		return this.pict.providers.DynamicInputEvents.inputDataRequest(this, pInputHash, pEvent);
	}

	/**
	 * Handles the generic Input Event for an Input Provider
	 *
	 * @param {String} pInputHash - The input hash object.
	 * @param {string} pEvent - The input event string.
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 * @returns {any} - The result of the input event handling.
	 */
	inputEvent(pInputHash, pEvent, pTransactionGUID)
	{
		return this.pict.providers.DynamicInputEvents.inputEvent(this, pInputHash, pEvent, pTransactionGUID);
	}

	/**
	 * @deprecated
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	globalInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		this.manifestInputEvent(pEvent, pCompletedHashes, pTransactionGUID);
	}

	/**
	 *
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	manifestInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpInputHashes = Object.keys(this.sectionManifest.elementHashes);

		for (let i = 0; i < tmpInputHashes.length; i++)
		{
			if (!(tmpInputHashes[i] in pCompletedHashes))
			{
				pCompletedHashes[tmpInputHashes[i]] = true;
				this.inputEvent(tmpInputHashes[i], pEvent, pTransactionGUID);
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			// We created a transaction, so finalize it.
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Triggers a DataRequest event for an Input Provider
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} [pEvent] - The input event.
	 * @returns {Promise<any>} A promise that resolves with the input data.
	 */
	inputDataRequestTabular(pGroupIndex, pInputIndex, pRowIndex, pEvent)
	{
		return this.pict.providers.DynamicInputEvents.inputDataRequestTabular(this, pGroupIndex, pInputIndex, pRowIndex, pEvent);
	}

	/**
	 * Handles the generic Tabular Input Event for an Input Provider
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pEvent - The input event object.
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 * @returns {any} - The result of the input event handling.
	 */
	inputEventTabular(pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID)
	{
		return this.pict.providers.DynamicInputEvents.inputEventTabular(this, pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 */
	registerEventTransactionAsyncOperation(pTransactionGUID, pAsyncOperationHash)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, pAsyncOperationHash, PENDING_ASYNC_OPERATION_TYPE);
	}

	/**
	 * FIXME: consolidate with same functions(s) in the metacontroller
	 *
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 *
	 * @return {boolean} - Returns true if the async operation was found and marked as complete, otherwise false.
	 */
	eventTransactionAsyncOperationComplete(pTransactionGUID, pAsyncOperationHash)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpMarkedOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				if (tmpQueueItem.Data === pAsyncOperationHash)
				{
					tmpQueue.splice(i, 1);
					++tmpMarkedOperationCount;
					--i;
				}
				else
				{
					++tmpPendingAsyncOperationCount;
				}
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpMarkedOperationCount === 0)
		{
			this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete ${pTransactionGUID} could not find async operation with hash ${pAsyncOperationHash}.`);
			return;
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			for (let i = 0; i < tmpQueue.length; i++)
			{
				const tmpQueueItem = tmpQueue[i];
				if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
				{
					tmpQueue.splice(i, 1);
					--i;
					if (typeof tmpQueueItem.Data !== 'function')
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback was not a function.`);
						continue;
					}
					try
					{
						tmpQueueItem.Data();
					}
					catch (pError)
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback error: ${pError}`, { Stack: pError.stack });
					}
				}
			}
			delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		}
		return tmpMarkedOperationCount > 0;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 *
	 * @return {boolean} - Returns true if the transaction was found and able to be finalized, otherwise false.
	 */
	finalizeTransaction(pTransactionGUID)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, null, READY_TO_FINALIZE_TYPE);

		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
		}
		if (tmpPendingAsyncOperationCount > 0)
		{
			this.pict.log.info(`PICT View Metatemplate Helper finalizeTransaction ${pTransactionGUID} is waiting on ${tmpPendingAsyncOperationCount} pending async operations.`);
			return false;
		}
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
			{
				tmpQueue.splice(i, 1);
				--i;
				if (typeof tmpQueueItem.Data !== 'function')
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback was not a function.`);
					continue;
				}
				try
				{
					tmpQueueItem.Data();
				}
				catch (pError)
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback error: ${pError}`, { Stack: pError.stack });
				}
			}
		}
		delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		return true;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Function} fCallback - The callback to call when the transaction is complete.
	 */
	registerOnTransactionCompleteCallback(pTransactionGUID, fCallback)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			fCallback();
		}
		else
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, fCallback, TRANSACTION_COMPLETE_CALLBACK_TYPE);
		}
	}

	/**
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	groupInputEvent(pGroupIndex, pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpGroup = this.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper subManifestInputEvent ${pGroupIndex} is not a valid group index.`);
			return;
		}

		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		if (tmpGroup.Rows.length < 1)
		{
			// tabular
			const tmpRecordSetRows = this.getTabularRecordSet(pGroupIndex);
			if (!Array.isArray(tmpRecordSetRows))
			{
				return;
			}
			for (let i = 0; i < tmpRecordSetRows.length; i++)
			{
				for (const tmpInput of Object.values(tmpGroup.supportingManifest.elementDescriptors))
				{
					const tmpInputSignature = `${this.Hash}-${tmpGroup.Hash}-${tmpInput.Hash}-${i}`;
					if (!(tmpInputSignature in pCompletedHashes))
					{
						pCompletedHashes[tmpInputSignature] = true;
						this.inputEventTabular(pGroupIndex, tmpInput.PictForm.InputIndex, i, pEvent, tmpTransactionGUID);
					}
				}
			}
		}
		for (const tmpRow of tmpGroup.Rows || [])
		{
			for (const tmpInput of tmpRow.Inputs || [])
			{
				const tmpInputSignature = `${this.Hash}-${tmpGroup.Hash}-${tmpInput.Hash}-${tmpRow.Hash}`;
				if (!(tmpInputSignature in pCompletedHashes))
				{
					pCompletedHashes[tmpInputSignature] = true;
					this.inputEvent(tmpInput.Hash, pEvent, tmpTransactionGUID);
				}
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			// We created a transaction, so finalize it.
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 *
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	sectionInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpGroupCount = this.sectionDefinition.Groups.length;
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}

		for (let i = 0; i < tmpGroupCount; i++)
		{
			this.groupInputEvent(i, pEvent, pCompletedHashes, pTransactionGUID);
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Get the input object for a specific tabular record group and index.
	 *
	 * Input objects are not distinct among rows.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns
	 */
	getTabularRecordInput(pGroupIndex, pInputIndex)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordInput(this, pGroupIndex, pInputIndex);
	}

	/**
	 * Get the input object for a specific tabular record group and index.
	 *
	 * Input objects are not distinct among rows.
	 *
	 * @param {string} pGroupHash - The hash of the group.
	 * @param {string} pInputHash - The hash of the input.
	 *
	 * @return {Object} The input object.
	 */
	getTabularRecordInputByHash(pGroupHash, pInputHash)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordInputByHash(this, pGroupHash, pInputHash);
	}

	/**
	 * Get the tabular record object for a particular row in a group.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pRowIdentifier - The row number
	 * @returns {Object} The record for the particular row
	 */
	getTabularRecordData(pGroupIndex, pRowIdentifier)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordData(this, pGroupIndex, pRowIdentifier);
	}

	/**
	 * Get the tabular record set for a particular group.
	 *
	 * @param {number} pGroupIndex
	 * @returns {Array} The record set for the group.
	 */
	getTabularRecordSet(pGroupIndex)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordSet(this, pGroupIndex);
	}

	/**
	 * Add a new data row to the end of a dynamic tabular group.
	 *
	 * This will generate any defaults in the SubManifest.
	 *
	 * @param {number} pGroupIndex
	 * @returns
	 */
	createDynamicTableRow(pGroupIndex)
	{
		return this.pict.providers.DynamicTabularData.createDynamicTableRow(this, pGroupIndex);
	}

	/**
	 * Move a dynamic table row to an arbitrary position in the array.
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move
	 * @param {number} pNewRowIndex - The new position for the row
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	setDynamicTableRowIndex(pGroupIndex, pRowIndex, pNewRowIndex)
	{
		return this.pict.providers.DynamicTabularData.setDynamicTableRowIndex(this, pGroupIndex, pRowIndex, pNewRowIndex);
	}

	/**
	 * Move a dynamic table row down
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move down
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	moveDynamicTableRowDown(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.moveDynamicTableRowDown(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Move a dynamic table row up
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move up
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	moveDynamicTableRowUp(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.moveDynamicTableRowUp(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Deletes a dynamic table row.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {Promise} A promise that resolves when the row is deleted.
	 */
	deleteDynamicTableRow(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.deleteDynamicTableRow(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Returns whether the current form is a Pict Section form.
	 * @returns {boolean} True if the form is a Pict Section form, false otherwise.
	 */
	get isPictSectionForm()
	{
		return true;
	}
}

module.exports = PictViewDynamicForm;

module.exports.default_configuration = _DefaultConfiguration;

},{"../../package.json":586,"./Pict-View-DynamicForm-DefaultConfiguration.json":652,"pict-view":733}],654:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictDynamicFormDependencyManager = require(`../services/Pict-Service-DynamicFormDependencyManager.js`);
const libPictViewDynamicForm = require('./Pict-View-DynamicForm.js');

// TODO: Potentially create an internalized list of views for this to manage, separate from the pict.views object
// TODO: Manage view lifecycle internally, including destruction of views if they are flagged to not be needed.
// Why?  This allows us to dynamically add and remove sections without having to reload the application.

// Solver directives iterate: their headers name addresses to iterate over, and declare iteration variables
// that are locals of the expression rather than anything the manifest owns.
const SOLVER_DIRECTIVE_CODES = new Set([ 'SERIES', 'MONTECARLO', 'MAP', 'MULTIROWMAP' ]);

// Everything an injected copy of a manifest can say about itself, grouped by how createDistinctManifest has
// to translate it. These drive the translation below and are exported as the checklist the injection
// conformance tests measure fixture coverage against, so a new construct cannot be added in one place only.
const INJECTION_INPUT_SECTION_HASH_PROPERTIES = [ 'TabSectionSet', 'DefaultTabSectionHash' ];
const INJECTION_INPUT_GROUP_HASH_PROPERTIES = [ 'TabGroupSet', 'DefaultTabGroupHash' ];
const INJECTION_INPUT_SOLVER_PROPERTIES = [ 'ChartLabelsSolver', 'ChartConfigCorePrototype' ];
const INJECTION_INPUT_SOLVER_SET_PROPERTIES = [ { Property: 'ChartDatasetsSolvers', SolverProperty: 'DataSolver' } ];
const INJECTION_INPUT_ADDRESS_PROPERTIES = [ 'ChartLabelsAddress', 'ChartDatasetsAddress', 'ChartConfigCorePrototypeAddress' ];
const INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES = [ 'AutofillTriggerGroup', 'TemplatedEntityLookup', 'TabularTriggerGroup' ];
// A trigger group hash held on its own rather than inside a trigger group configuration. Both sides of a
// trigger read the hash from their own configuration, so salting every carrier keeps a copy's triggers
// inside that copy.
const INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES = [ 'TriggerGroupHash', 'EntityBundleTriggerGroup' ];
const INJECTION_INPUT_TEMPLATE_PROPERTIES = [ 'Template' ];
const INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES = [ 'EntitiesBundle' ];
const INJECTION_ENTITY_BUNDLE_ADDRESS_PROPERTIES = [ 'Destination' ];
const INJECTION_ENTITY_BUNDLE_TEMPLATE_PROPERTIES = [ 'Filter', 'EntityFilterTemplate' ];
const INJECTION_TRIGGER_GROUP_SOLVER_PROPERTIES = [ 'PreSolvers', 'PostSolvers' ];
const INJECTION_MANIFEST_CONSTRUCTS = [ 'Sections.Solvers', 'Sections.Groups.RecordSetAddress', 'Sections.Groups.RecordSetSolvers', 'ReferenceManifests', 'ValidationSolvers', 'Descriptors.DataAddress', 'Descriptors.Hash', 'Descriptors.PictForm.Section', 'Descriptors.PictForm.Group' ];

const PENDING_ASYNC_OPERATION_TYPE = 'PendingAsyncOperation';
const TRANSACTION_COMPLETE_CALLBACK_TYPE = 'onTransactionComplete';
const READY_TO_FINALIZE_TYPE = 'ReadyToFinalize';

/**
 * @typedef {(a: any, b: any) => number} SortFunction
 * @typedef {import('manyfest').ManifestDescriptor} ManifestDescriptor
 */

/**
 * Class representing a PictFormMetacontroller.
 *
 * The metacontroller creates, manages and runs dynamic views and their lifecycle events.
 *
 * @extends libPictViewClass
 */
class PictFormMetacontroller extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictFormMetacontroller';

		// Load the dynamic application dependencies if they don't exist
		this.fable.addAndInstantiateSingletonService('PictDynamicFormDependencyManager', libPictDynamicFormDependencyManager.default_configuration, libPictDynamicFormDependencyManager);

		this.lastRenderedViews = [];

		this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;

		this.manifest = this.pict.manifest;

		this.AutoSolveOnFirstRender = true;
		this.FirstRenderCompleted = false;

		// The PictForm properties an injected manifest can carry a trigger group in, and those that carry a
		// bare trigger group hash. A host that ships input providers of its own pushes its own carriers onto
		// these, so they are salted along with the rest when a manifest is injected.
		this.injectionTriggerGroupProperties = INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES.slice();
		this.injectionTriggerGroupHashProperties = INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES.slice();

		// Destination address for entity comprehensions generated by the addComprehensionEntity solver
		// function.  Resolves relative to the pict instance (so `AppData.X`, `Bundle.X`, etc. all work).
		// Override in code (`this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress = '...'`)
		// or via the view options (`ComprehensionDestinationAddress`).
		this.comprehensionDestinationAddress = (this.options && typeof this.options.ComprehensionDestinationAddress === 'string' && this.options.ComprehensionDestinationAddress.length > 0)
			? this.options.ComprehensionDestinationAddress
			: 'AppData.FormEntityComprehensions';

		this.SupportViewPrototypes = (
		{
			LifecycleVisualization: require('./support/Pict-View-PSF-LifeCycle-Visualization.js'),
			DebugViewer: require('./support/Pict-View-PSF-DebugViewer.js'),
			AppDataViewer: require('./support/Pict-View-PSF-AppData-Visualization.js'),
			SolverVisualization: require('./support/Pict-View-PSF-Solver-Visualization.js'),
			SpecificSolveVisualization: require('./support/Pict-View-PSF-SpecificSolve-Visualization.js'),
		});
	}

	get viewMarshalDestination()
	{
		return this.pict.providers.DataBroker.marshalDestination;
	}

	set viewMarshalDestination(pValue)
	{
		this.pict.providers.DataBroker.marshalDestination = pValue;
	}

	/**
	 * Marshals data from the view to the model, usually AppData (or configured data store).
	 *
	 * @returns {any} The result of the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalFromView();
			}
		}
		return super.onMarshalFromView();
	}

	/**
	 * Marshals the data to the view from the model, usually AppData (or configured data store).
	 *
	 * @returns {any} The result of the super.onMarshalToView() method.
	 */
	onMarshalToView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalToView();
			}
		}
		return super.onMarshalToView();
	}

	gatherInitialBundle(fCallback)
	{
		// Runs before bootstrap has set manifestDescription, so fall back to the manifest bootstrap will use.
		const tmpManifestDescription = this.manifestDescription || this.fable.settings.DefaultFormManifest;
		if (tmpManifestDescription && Array.isArray(tmpManifestDescription.InitialBundle))
		{
			this.log.info(`Gathering initial bundle for ${tmpManifestDescription.InitialBundle.length} entities.`);
			return this.pict.EntityProvider.gatherDataFromServer(tmpManifestDescription.InitialBundle, (pError) =>
			{
				// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
				setTimeout(() => fCallback(pError), 0);
			});
		}
		else
		{
			this.log.info('No initial bundle to gather.');
			return fCallback();
		}
	}

	/**
	 * Executes after the initialization of the object.
	 *
	 * @param {ErrorCallback} fCallback - The callback function to be executed after the initialization.
	 * @returns {void}
	 */
	onAfterInitializeAsync(fCallback)
	{

		return super.onAfterInitializeAsync(
			function (pError)
			{
				if (pError)
				{
					return fCallback(pError);
				}
				this.gatherInitialBundle((pError) =>
				{
					// This is safe -- if there is no settings.DefaultFormManifest configuration, it just doesn't do anything
					this.bootstrapPictFormViewsFromManifest();
					// Generate the metatemplate (the container for each section)
					this.generateMetatemplate();

					return fCallback(pError);
				});
			}.bind(this));
	}

	/**
	 * Executes after the view is rendered.
	 * It regenerates the form section templates, renders the form sections,
	 * and optionally populates the form with data.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 *
	 * @return {boolean} The result of the superclass's onAfterRender method.
	 */
	onAfterRender(pRenderable)
	{
		const res = super.onAfterRender(pRenderable);
		this.regenerateFormSectionTemplates();
		this.renderFormSections();

		if (this.AutoSolveOnFirstRender && !this.FirstRenderCompleted)
		{
			this.FirstRenderCompleted = true;
			this.pict.providers.DynamicSolver.solveViews();
		}

		if (this.options.AutoPopulateAfterRender)
		{
			this.marshalToView();
		}
		return res;
	}

	/**
	 * Executes the solve operation -- automatically solves all dynamic views that are present.
	 *
	 * @returns {any} The result of the solve operation.
	 */
	onSolve()
	{
		this.pict.providers.DynamicSolver.solveViews();
		return super.onSolve();
	}

	runSolver(pExpression, pSilent)
	{
		this.pict.providers.DynamicSolver.runSolver(pExpression, pSilent);
	}

	onBeforeFilterViews(pViewFilterState)
	{
		return pViewFilterState;
	}

	onAfterFilterViews(pViewFilterState)
	{
		return pViewFilterState;
	}

	/**
	 * @param {string} pSectionManifestHash - The hash of the section to find.
	 *
	 * @return {Record<string, any>} The section definition object, or undefined if not found.
	 */
	findDynamicSectionManifestDefinition(pSectionManifestHash)
	{
		const sectionManifest = this.manifestDescription?.ReferenceManifests?.[pSectionManifestHash];
		if (typeof(sectionManifest) !== 'object')
		{
			this.log.error(`findDynamicSectionManifestDefinition() could not find a section manifest with hash [${pSectionManifestHash}]`);
			return null;
		}
		return sectionManifest;
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to add
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 *
	 * @return {Array<import('./Pict-View-DynamicForm.js')>} the views that correspond to the newly added sections
	 */
	injectManifestAndRender(pManifest, pAfterSectionHash, pUUID)
	{
		const tmpManifest = pUUID ? this.createDistinctManifest(pManifest, pUUID) : pManifest;
		const tmpViewsToRender = this.injectManifest(tmpManifest, pAfterSectionHash);
		this.updateMetatemplateInDOM();
		//FIXME: for some reason, DOM append is not synchronous, so we need to delay the render....................?
		setTimeout(() =>
		{
			for (const tmpViewToRender of tmpViewsToRender)
			{
				tmpViewToRender.render();
			}
			if (this.options.AutoPopulateAfterRender)
			{
				for (const tmpViewToRender of tmpViewsToRender)
				{
					tmpViewToRender.marshalToView();
				}
			}
		}, 0);

		return tmpViewsToRender;
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to add
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 *
	 * @return {Array<import('./Pict-View-DynamicForm.js')>} the views that correspond to the newly added sections; note that these views are NOT rendered yet
	 */
	injectManifest(pManifest, pAfterSectionHash)
	{
		const tmpAfterSectionHash = pAfterSectionHash ? (pAfterSectionHash.startsWith('PictSectionForm-') ? pAfterSectionHash : `PictSectionForm-${pAfterSectionHash}`) : null;
		const tmpAllViewKeys = Object.keys(this.pict.views);
		const tmpReferenceManifestViewIndex = tmpAfterSectionHash ? tmpAllViewKeys.indexOf(tmpAfterSectionHash) : -1;
		const tmpViewsToShift = [];
		if (tmpReferenceManifestViewIndex >= 0)
		{
			// reorder views (hacky - add layer to do this more directly)
			for (let i = tmpReferenceManifestViewIndex + 1; i < tmpAllViewKeys.length; i++)
			{
				const tmpKey = tmpAllViewKeys[i];
				tmpViewsToShift.push({ key: tmpKey, view: this.pict.views[tmpKey] });
				delete this.pict.views[tmpKey];
			}
		}
		const tmpViewsToRender = this.bootstrapAdditiveManifest(pManifest, tmpAfterSectionHash);
		for (const tmpViewToShift of tmpViewsToShift)
		{
			this.pict.views[tmpViewToShift.key] = tmpViewToShift.view;
		}
		// this ensures if we re-render everything, we have the new sections in the template
		this.generateMetatemplate();
		for (const tmpViewToRender of tmpViewsToRender)
		{
			tmpViewToRender.rebuildCustomTemplate();
		}
		this.pict.CSSMap.injectCSS();

		return tmpViewsToRender;
	}

	/**
	 * Builds translation maps for addresses and hashes based on the manifest. This is used for rewriting solver expressions to map them to distinct manifests.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to build translations from.
	 *
	 * @return {{ AddressTranslation: Record<string, string>, HashTranslation: Record<string, string> }} The translation maps for addresses and hashes.
	 */
	buildManifestTranslations(pManifest)
	{
		/** @type {Record<string, string>} */
		const tmpAddressTranslation = {};
		/** @type {Record<string, string>} */
		const tmpHashTranslation = {};
		/** @type {Array<string>} */
		const tmpCollisions = [];
		/**
		 * @param {Record<string, string>} pTranslation - The map being filled.
		 * @param {string} pOriginal - What the reference was called before the copy was salted.
		 * @param {string} pTranslated - What it is called in this copy.
		 */
		const addTranslation = (pTranslation, pOriginal, pTranslated) =>
		{
			if ((pOriginal in pTranslation) && (pTranslation[pOriginal] !== pTranslated))
			{
				tmpCollisions.push(`${pOriginal} -> ${pTranslation[pOriginal]} | ${pTranslated}`);
			}
			pTranslation[pOriginal] = pTranslated;
		};
		for (const tmpSection of pManifest.Sections || [])
		{
			if (tmpSection.OriginalHash)
			{
				addTranslation(tmpAddressTranslation, tmpSection.OriginalHash, tmpSection.Hash);
			}
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (tmpGroup.OriginalHash)
				{
					addTranslation(tmpAddressTranslation, tmpGroup.OriginalHash, tmpGroup.Hash);
				}
			}
		}
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				addTranslation(tmpAddressTranslation, tmpDescriptor.OriginalDataAddress, tmpDescriptor.DataAddress);
			}
			if (tmpDescriptor.OriginalHash)
			{
				addTranslation(tmpHashTranslation, tmpDescriptor.OriginalHash, tmpDescriptor.Hash);
			}
		}
		if (tmpCollisions.length > 0)
		{
			// More than one copy of the same manifest is in here, so no single map can say what a name became.
			// Build the translation from each copy as it is salted instead of from the form they were merged into.
			this.pict.log.warn(`PictFormMetacontroller.buildManifestTranslations: ${tmpCollisions.length} reference(s) translate to more than one destination, so the last one wins. This manifest holds more than one injected copy.`, { Collisions: tmpCollisions.slice(0, 10) });
		}
		return { AddressTranslation: tmpAddressTranslation, HashTranslation: tmpHashTranslation };
	}

	/**
	 * Translates a reference to something the manifest owns -- an exact hash or address, or a reference that
	 * only starts with one (`Rows.length`, `Rows[0].Line`, `Crate.Items.length`), where the longest address
	 * the reference starts with wins.
	 *
	 * @param {string} pReference - The reference to translate.
	 * @param {Record<string, string>} pPrimaryTranslation - Consulted first: hashes for symbols, addresses for address-shaped references.
	 * @param {Record<string, string>} pSecondaryTranslation - Consulted second.
	 * @param {Record<string, string>} [pPrefixTranslation] - Addresses that a partial reference may start with.
	 *
	 * @return {string|null} The translated reference, or null when the manifest does not own it.
	 */
	translateManifestReference(pReference, pPrimaryTranslation, pSecondaryTranslation, pPrefixTranslation)
	{
		if ((typeof(pReference) !== 'string') || (pReference.length === 0))
		{
			return null;
		}
		const tmpPrefixTranslation = pPrefixTranslation || { };
		if (pReference in pPrimaryTranslation)
		{
			return pPrimaryTranslation[pReference];
		}
		if (pReference in pSecondaryTranslation)
		{
			return pSecondaryTranslation[pReference];
		}
		if (pReference in tmpPrefixTranslation)
		{
			return tmpPrefixTranslation[pReference];
		}
		for (let i = pReference.length - 1; i > 0; i--)
		{
			if ((pReference[i] !== '.') && (pReference[i] !== '['))
			{
				continue;
			}
			const tmpPrefix = pReference.substring(0, i);
			if (tmpPrefix in tmpPrefixTranslation)
			{
				return `${tmpPrefixTranslation[tmpPrefix]}${pReference.substring(i)}`;
			}
		}
		return null;
	}

	/**
	 * Finds the SERIES / MAP / MULTIROWMAP / MONTECARLO directive in a tokenized solver expression, if there
	 * is one, and reads its header the way the expression parser does: which header positions hold an address
	 * to iterate over (everything else in a header, keyword or not, is not a reference to translate -- notably
	 * the per-row property a MULTIROWMAP variable reads), and which names the body sees as iteration variables
	 * rather than as addresses.
	 *
	 * @param {Array<string>} pTokens - The raw tokens of the expression.
	 *
	 * @return {{ Code: string, HeaderStart: number, HeaderEnd: number, TranslateIndices: Set<number>, Locals: Set<string> }|null} null when the expression has no directive.
	 */
	parseSolverDirectiveScope(pTokens)
	{
		let tmpDirectiveIndex = -1;
		for (let i = 0; i < pTokens.length; i++)
		{
			if (SOLVER_DIRECTIVE_CODES.has(String(pTokens[i]).toUpperCase()) && ((i === 0) || (pTokens[i - 1] === '=') || (pTokens[i - 1] === '?=')))
			{
				tmpDirectiveIndex = i;
				break;
			}
		}
		if (tmpDirectiveIndex < 0)
		{
			return null;
		}
		const tmpHeaderEnd = pTokens.indexOf(':', tmpDirectiveIndex + 1);
		if (tmpHeaderEnd < 0)
		{
			return null;
		}
		const tmpCode = String(pTokens[tmpDirectiveIndex]).toUpperCase();
		const tmpTranslateIndices = new Set();
		const tmpLocals = new Set([ 'stepIndex' ]);
		if (tmpCode === 'SERIES')
		{
			tmpLocals.add('n');
			tmpLocals.add('prev_n');
		}
		if (tmpCode === 'MULTIROWMAP')
		{
			tmpLocals.add('rowIndex');
		}
		for (let i = tmpDirectiveIndex + 1; i < tmpHeaderEnd; i++)
		{
			const tmpToken = String(pTokens[i]).toUpperCase();
			const tmpPreviousToken = String(pTokens[i - 1]).toUpperCase();
			if ((tmpCode === 'SERIES') && ((tmpPreviousToken === 'FROM') || (tmpPreviousToken === 'TO') || (tmpPreviousToken === 'STEP')))
			{
				tmpTranslateIndices.add(i);
				continue;
			}
			if ((tmpToken !== 'VAR') && (tmpToken !== 'VARIABLE') && (tmpToken !== 'V'))
			{
				if ((tmpCode === 'MULTIROWMAP') && (tmpToken === 'ROWS') && (String(pTokens[i + 1]).toUpperCase() === 'FROM') && ((i + 2) < tmpHeaderEnd))
				{
					tmpTranslateIndices.add(i + 2);
				}
				continue;
			}
			const tmpVariableIndex = i + 1;
			if (tmpVariableIndex >= tmpHeaderEnd)
			{
				continue;
			}
			tmpLocals.add(String(pTokens[tmpVariableIndex]));
			if (tmpCode === 'MAP')
			{
				tmpLocals.add(`prev_${pTokens[tmpVariableIndex]}`);
				if ((String(pTokens[tmpVariableIndex + 1]).toUpperCase() === 'FROM') && ((tmpVariableIndex + 2) < tmpHeaderEnd))
				{
					tmpTranslateIndices.add(tmpVariableIndex + 2);
				}
			}
		}
		return { Code: tmpCode, HeaderStart: tmpDirectiveIndex, HeaderEnd: tmpHeaderEnd, TranslateIndices: tmpTranslateIndices, Locals: tmpLocals };
	}

	/**
	 * Collects every trigger group an injected manifest declares and maps it onto a salted hash, so a change
	 * in one copy does not run the matching trigger group in another copy of the same manifest.
	 *
	 * A manifest that means to hear the form it is injected into lists those hashes in `SharedTriggerGroups`
	 * at its root; those are left alone.
	 *
	 * @param {Record<string, any>} pManifest - The manifest being copied.
	 * @param {string} pUUID - The salt appended to each hash.
	 *
	 * @return {Record<string, string>} Original trigger group hash to salted hash.
	 */
	buildTriggerGroupTranslation(pManifest, pUUID)
	{
		/** @type {Record<string, string>} */
		const tmpTriggerGroupTranslation = {};
		const tmpSharedTriggerGroups = Array.isArray(pManifest.SharedTriggerGroups) ? pManifest.SharedTriggerGroups : [];
		const tmpTriggerGroupProperties = this.injectionTriggerGroupProperties || INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES;
		const tmpTriggerGroupHashProperties = this.injectionTriggerGroupHashProperties || INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES;
		/**
		 * @param {any} pHash - A trigger group hash, or an array of them.
		 */
		const addTriggerGroupHash = (pHash) =>
		{
			if (Array.isArray(pHash))
			{
				for (const tmpHash of pHash)
				{
					addTriggerGroupHash(tmpHash);
				}
				return;
			}
			if ((typeof(pHash) !== 'string') || (pHash.length === 0) || tmpSharedTriggerGroups.includes(pHash))
			{
				return;
			}
			tmpTriggerGroupTranslation[pHash] = `${pHash}_${pUUID}`;
		};
		/**
		 * @param {any} pPictForm - The PictForm configuration of an input.
		 */
		const addInputTriggerGroupHashes = (pPictForm) =>
		{
			if (!pPictForm || (typeof(pPictForm) !== 'object'))
			{
				return;
			}
			for (const tmpTriggerGroupProperty of tmpTriggerGroupProperties)
			{
				const tmpTriggerGroupConfiguration = pPictForm[tmpTriggerGroupProperty];
				const tmpTriggerGroups = Array.isArray(tmpTriggerGroupConfiguration) ? tmpTriggerGroupConfiguration : [ tmpTriggerGroupConfiguration ];
				for (const tmpTriggerGroup of tmpTriggerGroups)
				{
					if (tmpTriggerGroup && (typeof(tmpTriggerGroup) === 'object'))
					{
						addTriggerGroupHash(tmpTriggerGroup.TriggerGroupHash);
					}
				}
			}
			for (const tmpTriggerGroupHashProperty of tmpTriggerGroupHashProperties)
			{
				addTriggerGroupHash(pPictForm[tmpTriggerGroupHashProperty]);
			}
		};
		for (const tmpDescriptor of Object.values(pManifest.Descriptors || {}))
		{
			addInputTriggerGroupHashes(tmpDescriptor.PictForm);
		}
		for (const tmpReferenceManifest of Object.values(pManifest.ReferenceManifests || {}))
		{
			for (const tmpColumnDescriptor of Object.values(tmpReferenceManifest.Descriptors || {}))
			{
				addInputTriggerGroupHashes(tmpColumnDescriptor.PictForm);
			}
		}
		return tmpTriggerGroupTranslation;
	}

	/**
	 * Rewrite a solver expression by tokenizing, replacing address/hash tokens, and recomposing.
	 *
	 * @param {string} pExpression - The solver expression string.
	 * @param {Record<string, string>} pHashTranslation - A mapping of original hashes to new hashes for replacement.
	 * @param {Record<string, string>} pAddressTranslation - A mapping of original addresses to new addresses for replacement.
	 * @param {{ PrefixAddressTranslation?: Record<string, string>, RowRelative?: boolean }} [pOptions] - PrefixAddressTranslation holds the addresses a partial reference may start with (defaults to pAddressTranslation); RowRelative marks an expression solved against a record of a record set rather than against the manifest.
	 *
	 * @return {string} The rewritten expression, or the original if no changes were made.
	 */
	rewriteSolverExpression(pExpression, pHashTranslation, pAddressTranslation, pOptions)
	{
		const tmpHashTranslation = pHashTranslation || { };
		const tmpAddressTranslation = pAddressTranslation || { };
		const tmpOptions = pOptions || { };
		const tmpPrefixAddressTranslation = tmpOptions.PrefixAddressTranslation || tmpAddressTranslation;
		// A record set solver is solved against one record of the set, so a bare reference in it names a column
		// of that record; only references that are absolute can be ours to translate.
		const tmpRowRelative = Boolean(tmpOptions.RowRelative);

		// Use the expression parser tokenizer for discrete token-based solver rewriting.
		// This avoids the regex word-boundary issues when hash and address are the same string.
		const tmpExpressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpMarshalDestination = this.viewMarshalDestination;

		if (typeof(pExpression) !== 'string' || pExpression.length === 0)
		{
			return pExpression;
		}

		/**
		 * @param {string} pReference - The reference held by the token.
		 * @param {boolean} pPreferHash - Whether a hash translation wins over an address translation.
		 * @param {boolean} pManifestRelative - Whether a bare reference resolves against the manifest.
		 *
		 * @return {string|null} The translated reference, or null when nothing matched.
		 */
		const translateReference = (pReference, pPreferHash, pManifestRelative) =>
		{
			if (pManifestRelative)
			{
				const tmpTranslated = this.translateManifestReference(pReference, pPreferHash ? tmpHashTranslation : tmpAddressTranslation, pPreferHash ? tmpAddressTranslation : tmpHashTranslation, tmpPrefixAddressTranslation);
				if (tmpTranslated !== null)
				{
					return tmpTranslated;
				}
			}
			if (tmpMarshalDestination && pReference.startsWith(`${tmpMarshalDestination}.`))
			{
				// Behind the marshal destination the reference is an address, so addresses win over hashes.
				const tmpTranslated = this.translateManifestReference(pReference.substring(tmpMarshalDestination.length + 1), tmpAddressTranslation, tmpHashTranslation, tmpPrefixAddressTranslation);
				if (tmpTranslated !== null)
				{
					return `${tmpMarshalDestination}.${tmpTranslated}`;
				}
			}
			return null;
		};

		let tmpResultObject = {};
		tmpExpressionParser.tokenize(pExpression, tmpResultObject);

		let tmpTokens = Array.from(tmpResultObject.OriginalRawTokens);
		let tmpModified = false;
		const tmpDirectiveScope = this.parseSolverDirectiveScope(tmpTokens);

		// Function context stack for tracking string parameters inside annotated functions
		let tmpFunctionStack = [];
		let tmpParenDepth = 0;

		for (let i = 0; i < tmpTokens.length; i++)
		{
			let tmpToken = tmpTokens[i];
			let tmpTokenType = tmpExpressionParser.Tokenizer.getTokenType(tmpToken);

			if (tmpDirectiveScope)
			{
				if ((i >= tmpDirectiveScope.HeaderStart) && (i <= tmpDirectiveScope.HeaderEnd) && !tmpDirectiveScope.TranslateIndices.has(i))
				{
					continue;
				}
				if ((i > tmpDirectiveScope.HeaderEnd) && tmpDirectiveScope.Locals.has(String(tmpToken).replace(/^\{|\}$/g, '').split(/[.[]/)[0]))
				{
					continue;
				}
			}

			// Track parenthesis depth and function context
			if (tmpToken === '(')
			{
				// Check if the previous token is a known function name
				if (i > 0)
				{
					let tmpPrevToken = tmpTokens[i - 1].toLowerCase();
					if (tmpPrevToken in tmpExpressionParser.functionMap)
					{
						tmpFunctionStack.push({ name: tmpPrevToken, paramIndex: 0, depth: tmpParenDepth });
					}
				}
				tmpParenDepth++;
				continue;
			}
			if (tmpToken === ')')
			{
				tmpParenDepth--;
				if (tmpFunctionStack.length > 0 && tmpFunctionStack[tmpFunctionStack.length - 1].depth === tmpParenDepth)
				{
					tmpFunctionStack.pop();
				}
				continue;
			}
			if (tmpToken === ',')
			{
				if (tmpFunctionStack.length > 0 && tmpFunctionStack[tmpFunctionStack.length - 1].depth === tmpParenDepth - 1)
				{
					tmpFunctionStack[tmpFunctionStack.length - 1].paramIndex++;
				}
				continue;
			}

			// Token.Symbol -- check hash mappings then address mappings
			if (tmpTokenType === 'Token.Symbol')
			{
				const tmpReplacement = translateReference(tmpToken, true, !tmpRowRelative);

				if (tmpReplacement !== null)
				{
					tmpTokens[i] = tmpReplacement;
					tmpModified = true;
				}
			}
			// Token.StateAddress -- extract inner address, check mappings with and without marshal prefix
			else if (tmpTokenType === 'Token.StateAddress')
			{
				const tmpReplacement = translateReference(tmpToken.substring(1, tmpToken.length - 1), false, !tmpRowRelative);

				if (tmpReplacement !== null)
				{
					tmpTokens[i] = `{${tmpReplacement}}`;
					tmpModified = true;
				}
			}
			// Token.String inside an annotated function -- check if this parameter index has addresses
			else if (tmpTokenType === 'Token.String' && tmpFunctionStack.length > 0)
			{
				let tmpCurrentFunc = tmpFunctionStack[tmpFunctionStack.length - 1];
				let tmpFuncEntry = tmpExpressionParser.functionMap[tmpCurrentFunc.name];

				if (tmpFuncEntry && Array.isArray(tmpFuncEntry.AddressParameterIndices) && tmpFuncEntry.AddressParameterIndices.includes(tmpCurrentFunc.paramIndex))
				{
					// String parameters name a hash or an absolute address, never a column of a record.
					const tmpReplacement = translateReference(tmpToken.substring(1, tmpToken.length - 1), true, true);

					if (tmpReplacement !== null)
					{
						tmpTokens[i] = `"${tmpReplacement}"`;
						tmpModified = true;
					}
				}
			}
		}

		if (!tmpModified)
		{
			return pExpression;
		}

		return tmpExpressionParser.recompose(tmpTokens);
	}

	/**
	 * Changes:
	 *   * The hashes of each section+group to be globally unique.
	 *   * The data address of each element to map to a unique location.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to create a distinct copy of.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 *
	 * @return {Record<string, any>} A distinct copy of the manifest.
	 */
	createDistinctManifest(pManifest, pUUID)
	{
		const tmpUUID = pUUID != null ? pUUID : this.pict.getUUID().replace(/-/g, '');
		const tmpManifest = JSON.parse(JSON.stringify(pManifest));
		/** @type {Record<string, string>} */
		const tmpAddressTranslation = {};
		/** @type {Record<string, string>} */
		const tmpSectionTranslation = {};
		/** @type {Record<string, string>} */
		const tmpGroupTranslation = {};
		/** @type {Record<string, string>} */
		const tmpRecordSetTranslation = {};
		/** @type {Record<string, string>} */
		const tmpTriggerGroupTranslation = this.buildTriggerGroupTranslation(tmpManifest, tmpUUID);
		for (const tmpSection of tmpManifest.Sections || [])
		{
			if (!tmpSection.Hash)
			{
				tmpSection.Hash = `${this.fable.getUUID()}`;
			}
			tmpSection.OriginalHash = tmpSection.Hash;
			tmpSection.Hash = `${tmpSection.Hash}_${tmpUUID}`;
			tmpAddressTranslation[tmpSection.OriginalHash] = tmpSection.Hash;
			tmpSectionTranslation[tmpSection.OriginalHash] = tmpSection.Hash;
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (!tmpGroup.Hash)
				{
					tmpGroup.Hash = `${this.fable.getUUID()}`;
				}
				tmpGroup.OriginalHash = tmpGroup.Hash;
				tmpGroup.Hash = `${tmpGroup.Hash}_${tmpUUID}`;
				tmpAddressTranslation[tmpGroup.OriginalHash] = tmpGroup.Hash;
				tmpGroupTranslation[tmpGroup.OriginalHash] = tmpGroup.Hash;
				if (tmpGroup.RecordSetAddress)
				{
					const tmpRecordSetAddress = `${tmpUUID}.${tmpGroup.RecordSetAddress}`;
					this.pict.log.info(`PictFormMetacontroller.createDistinctManifest: Updated group record set address from "${tmpGroup.RecordSetAddress}" to "${tmpRecordSetAddress}".`);
					tmpRecordSetTranslation[tmpGroup.RecordSetAddress] = tmpRecordSetAddress;
					tmpGroup.RecordSetAddress = tmpRecordSetAddress;
				}
			}
		}
		/** @type {Record<string, ManifestDescriptor>} */
		const tmpDescriptors = tmpManifest.Descriptors || {};
		/** @type {Record<string, ManifestDescriptor>} */
		const tmpNewDescriptors = {};
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDescriptors))
		{
			if (!tmpDescriptor.DataAddress)
			{
				tmpDescriptor.DataAddress = tmpKey;
			}
			tmpDescriptor.OriginalDataAddress = tmpDescriptor.DataAddress;
			// we only make distinct top level properties to keep things as tidy as possible so do a split to isoloate that
			//TODO: if we have .. dereferences (for example) in the data address, this may not work properly

			// nest the data addresses inside a container that is unique to this injection
			tmpDescriptor.DataAddress = `${tmpUUID}.${tmpDescriptor.OriginalDataAddress}`;
			if (tmpDescriptor.Address != null)
			{
				tmpDescriptor.Address = tmpDescriptor.DataAddress;
			}
			// nesting doesn't work for hashes, so we append instead for input, section and group hashes
			if (tmpDescriptor.Hash)
			{
				tmpDescriptor.OriginalHash = tmpDescriptor.Hash;
				tmpDescriptor.Hash = `${tmpDescriptor.Hash}_${tmpUUID}`;
			}
			if (tmpDescriptor.PictForm)
			{
				if (tmpDescriptor.PictForm.Section)
				{
					tmpDescriptor.PictForm.Section = `${tmpDescriptor.PictForm.Section}_${tmpUUID}`;
				}
				if (tmpDescriptor.PictForm.Group)
				{
					tmpDescriptor.PictForm.Group = `${tmpDescriptor.PictForm.Group}_${tmpUUID}`;
				}
			}
			tmpNewDescriptors[tmpDescriptor.DataAddress] = tmpDescriptor;
		}
		tmpManifest.Descriptors = tmpNewDescriptors;
		/** @type {Record<string, string>} */
		const tmpHashTranslation = {};
		for (const tmpDescriptor of Object.values(tmpManifest?.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				tmpAddressTranslation[tmpDescriptor.OriginalDataAddress] = tmpDescriptor.DataAddress;
			}
			if (tmpDescriptor.OriginalHash)
			{
				tmpHashTranslation[tmpDescriptor.OriginalHash] = tmpDescriptor.Hash;
			}
		}
		const escapeRegExp =
		/**
		 * @param {string} str - the string to match
		 * @return {string} - the escaped string
		 */
		(str) =>
		{
			return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		}
		for (const [ tmpOriginalAddress, tmpUpdatedAddress ] of Object.entries(tmpAddressTranslation))
		{
			for (const tmpIterAddress of Object.keys(tmpAddressTranslation))
			{
				if (tmpIterAddress === tmpOriginalAddress)
				{
					continue;
				}
				const tmpTranslatedAddress = tmpAddressTranslation[tmpIterAddress].replace(new RegExp(`^${escapeRegExp(tmpOriginalAddress)}\\b`, 'g'), tmpUpdatedAddress);
				if (tmpTranslatedAddress !== tmpAddressTranslation[tmpIterAddress])
				{
					this.pict.log.info(`PictFormMetacontroller.createDistinctManifest: Updated address translation for "${tmpIterAddress}" from "${tmpAddressTranslation[tmpIterAddress]}" to "${tmpTranslatedAddress}".`);
					tmpAddressTranslation[tmpIterAddress] = tmpTranslatedAddress;
					const [ tmpCurrentKey, tmpOriginalDescriptor ] = Object.entries(tmpManifest.Descriptors).find(([ pKey, pDescriptor ]) => pDescriptor.OriginalDataAddress === tmpIterAddress);
					tmpManifest.Descriptors[tmpCurrentKey].DataAddress = tmpTranslatedAddress;
					if (tmpManifest.Descriptors[tmpCurrentKey].Address != null)
					{
						tmpManifest.Descriptors[tmpCurrentKey].Address = tmpManifest.Descriptors[tmpCurrentKey].DataAddress;
					}
					tmpManifest.Descriptors[tmpTranslatedAddress] = tmpManifest.Descriptors[tmpCurrentKey];
					delete tmpManifest.Descriptors[tmpCurrentKey];
				}
			}
		}
		// The addresses a partial reference (`Rows.length`, `Crate.Items[0]`) may start with: every address the
		// manifest declares, plus the record set addresses, which have no descriptor of their own.
		/** @type {Record<string, string>} */
		const tmpPrefixAddressTranslation = Object.assign({}, tmpRecordSetTranslation);
		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				tmpPrefixAddressTranslation[tmpDescriptor.OriginalDataAddress] = tmpDescriptor.DataAddress;
			}
		}

		/**
		 * Rewrite a single solver entry (string or object with Expression property).
		 *
		 * @param {Array} pSolverArray - The array of solvers to rewrite in.
		 * @param {number} pIndex - The index of the solver to rewrite.
		 * @param {string} pLogPrefix - Logging prefix for identification.
		 * @param {{ RowRelative?: boolean }} [pSolverOptions] - Passed through to rewriteSolverExpression.
		 */
		const rewriteSolverEntry = (pSolverArray, pIndex, pLogPrefix, pSolverOptions) =>
		{
			const tmpSolver = pSolverArray[pIndex];
			const tmpSolverExpression = typeof tmpSolver === 'string' ? tmpSolver : tmpSolver.Expression;
			if (!tmpSolverExpression)
			{
				return;
			}
			const tmpUpdatedSolver = this.rewriteSolverExpression(tmpSolverExpression, tmpHashTranslation, tmpAddressTranslation, Object.assign({ PrefixAddressTranslation: tmpPrefixAddressTranslation }, pSolverOptions));
			if (tmpUpdatedSolver !== tmpSolverExpression)
			{
				this.pict.log.info(`PictFormMetacontroller.createDistinctManifest: Updated ${pLogPrefix} ${pIndex} from "${tmpSolverExpression}" to "${tmpUpdatedSolver}".`);
				if (typeof tmpSolver === 'string')
				{
					pSolverArray[pIndex] = tmpUpdatedSolver;
				}
				else
				{
					pSolverArray[pIndex].Expression = tmpUpdatedSolver;
				}
			}
		};

		for (const tmpSection of tmpManifest.Sections || [])
		{
			if (Array.isArray(tmpSection.Solvers) && tmpSection.Solvers.length > 0)
			{
				for (let i = 0; i < tmpSection.Solvers.length; i++)
				{
					rewriteSolverEntry(tmpSection.Solvers, i, 'section solver reference');
				}
			}
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (Array.isArray(tmpGroup.RecordSetSolvers) && tmpGroup.RecordSetSolvers.length > 0)
				{
					for (let i = 0; i < tmpGroup.RecordSetSolvers.length; i++)
					{
						rewriteSolverEntry(tmpGroup.RecordSetSolvers, i, 'group solver reference', { RowRelative: true });
					}
				}
			}
		}

		/**
		 * @param {any} pValue - A hash, or an array of hashes.
		 * @param {Record<string, string>} pTranslation - The hashes this manifest owns.
		 *
		 * @return {any} The value, with any hash the manifest owns translated.
		 */
		const translateHashReference = (pValue, pTranslation) =>
		{
			if (typeof(pValue) === 'string')
			{
				return (pValue in pTranslation) ? pTranslation[pValue] : pValue;
			}
			if (Array.isArray(pValue))
			{
				return pValue.map((pHash) => (((typeof(pHash) === 'string') && (pHash in pTranslation)) ? pTranslation[pHash] : pHash));
			}
			return pValue;
		};

		/**
		 * Configuration addresses resolve from the application root, so they are only ours when they point
		 * into the marshal destination.
		 *
		 * @param {any} pAddress - The configured address.
		 *
		 * @return {any} The address, nested into this injection when the manifest owns it.
		 */
		const rewriteAbsoluteAddress = (pAddress) =>
		{
			const tmpMarshalDestination = this.viewMarshalDestination;
			if ((typeof(pAddress) !== 'string') || !tmpMarshalDestination || !pAddress.startsWith(`${tmpMarshalDestination}.`))
			{
				return pAddress;
			}
			const tmpTranslated = this.translateManifestReference(pAddress.substring(tmpMarshalDestination.length + 1), tmpAddressTranslation, tmpHashTranslation, tmpPrefixAddressTranslation);
			return (tmpTranslated === null) ? pAddress : `${tmpMarshalDestination}.${tmpTranslated}`;
		};

		/**
		 * @param {any} pSolverExpression - A solver expression configured on an input.
		 * @param {string} pLogPrefix - Logging prefix for identification.
		 *
		 * @return {any} The rewritten expression.
		 */
		const rewriteSolverValue = (pSolverExpression, pLogPrefix) =>
		{
			if (typeof(pSolverExpression) !== 'string')
			{
				return pSolverExpression;
			}
			const tmpSolverContainer = [ pSolverExpression ];
			rewriteSolverEntry(tmpSolverContainer, 0, pLogPrefix);
			return tmpSolverContainer[0];
		};

		/**
		 * Input templates render against the marshal destination, so the addresses they reference are ours.
		 *
		 * @param {any} pTemplate - The configured template.
		 *
		 * @return {any} The template, with local addresses nested into this injection.
		 */
		const rewriteTemplateAddresses = (pTemplate) =>
		{
			if (typeof(pTemplate) !== 'string')
			{
				return pTemplate;
			}
			const tmpMarshalDestination = this.viewMarshalDestination;
			const tmpTemplateRoots = [ 'Record.Data.' ];
			if (tmpMarshalDestination)
			{
				tmpTemplateRoots.push(`${tmpMarshalDestination}.`);
			}
			let tmpTemplate = pTemplate;
			for (const tmpTemplateRoot of tmpTemplateRoots)
			{
				tmpTemplate = tmpTemplate.replace(new RegExp(`${escapeRegExp(tmpTemplateRoot)}([A-Za-z0-9_$.[\\]]+)`, 'g'),
					(pMatch, pAddress) =>
					{
						const tmpTranslated = this.translateManifestReference(pAddress, tmpAddressTranslation, tmpHashTranslation, tmpPrefixAddressTranslation);
						return (tmpTranslated === null) ? pMatch : `${tmpTemplateRoot}${tmpTranslated}`;
					});
			}
			return tmpTemplate;
		};

		/**
		 * Entity bundles gather server data into an address, filtered by a template; both can point at
		 * something this manifest owns.
		 *
		 * @param {any} pEntitiesBundle - The configured entity bundle array.
		 */
		const rewriteEntitiesBundle = (pEntitiesBundle) =>
		{
			if (!Array.isArray(pEntitiesBundle))
			{
				return;
			}
			for (const tmpEntityBundle of pEntitiesBundle)
			{
				if (!tmpEntityBundle || (typeof(tmpEntityBundle) !== 'object'))
				{
					continue;
				}
				for (const tmpAddressProperty of INJECTION_ENTITY_BUNDLE_ADDRESS_PROPERTIES)
				{
					if (tmpEntityBundle[tmpAddressProperty])
					{
						tmpEntityBundle[tmpAddressProperty] = rewriteAbsoluteAddress(tmpEntityBundle[tmpAddressProperty]);
					}
				}
				for (const tmpTemplateProperty of INJECTION_ENTITY_BUNDLE_TEMPLATE_PROPERTIES)
				{
					if (tmpEntityBundle[tmpTemplateProperty])
					{
						tmpEntityBundle[tmpTemplateProperty] = rewriteTemplateAddresses(tmpEntityBundle[tmpTemplateProperty]);
					}
				}
			}
		};

		/**
		 * @param {any} pTriggerGroup - A trigger group configuration.
		 */
		const rewriteTriggerGroup = (pTriggerGroup) =>
		{
			if (!pTriggerGroup || (typeof(pTriggerGroup) !== 'object'))
			{
				return;
			}
			for (const tmpTemplateProperty of INJECTION_INPUT_TEMPLATE_PROPERTIES)
			{
				if (pTriggerGroup[tmpTemplateProperty])
				{
					pTriggerGroup[tmpTemplateProperty] = rewriteTemplateAddresses(pTriggerGroup[tmpTemplateProperty]);
				}
			}
			for (const tmpEntityBundleProperty of INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES)
			{
				rewriteEntitiesBundle(pTriggerGroup[tmpEntityBundleProperty]);
			}
			for (const tmpSolverProperty of INJECTION_TRIGGER_GROUP_SOLVER_PROPERTIES)
			{
				if (Array.isArray(pTriggerGroup[tmpSolverProperty]))
				{
					for (let i = 0; i < pTriggerGroup[tmpSolverProperty].length; i++)
					{
						rewriteSolverEntry(pTriggerGroup[tmpSolverProperty], i, `trigger group ${tmpSolverProperty} reference`);
					}
				}
			}
			if (pTriggerGroup.TriggerAddress)
			{
				pTriggerGroup.TriggerAddress = rewriteAbsoluteAddress(pTriggerGroup.TriggerAddress);
			}
			if (pTriggerGroup.MarshalOnComplete && (typeof(pTriggerGroup.MarshalOnComplete) === 'object'))
			{
				pTriggerGroup.MarshalOnComplete.Section = translateHashReference(pTriggerGroup.MarshalOnComplete.Section, tmpSectionTranslation);
				pTriggerGroup.MarshalOnComplete.Input = translateHashReference(pTriggerGroup.MarshalOnComplete.Input, tmpHashTranslation);
			}
			pTriggerGroup.TriggerGroupHash = translateHashReference(pTriggerGroup.TriggerGroupHash, tmpTriggerGroupTranslation);
		};

		/**
		 * Trigger groups and entity bundles resolve against the section view and the application, so they name
		 * things this manifest owns wherever the input carrying them lives.
		 *
		 * @param {any} pPictForm - The PictForm configuration of an input.
		 */
		const rewriteInputTriggerConfiguration = (pPictForm) =>
		{
			for (const tmpTriggerGroupHashProperty of (this.injectionTriggerGroupHashProperties || INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES))
			{
				if (pPictForm[tmpTriggerGroupHashProperty])
				{
					pPictForm[tmpTriggerGroupHashProperty] = translateHashReference(pPictForm[tmpTriggerGroupHashProperty], tmpTriggerGroupTranslation);
				}
			}
			for (const tmpTriggerGroupProperty of (this.injectionTriggerGroupProperties || INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES))
			{
				const tmpTriggerGroupConfiguration = pPictForm[tmpTriggerGroupProperty];
				if (Array.isArray(tmpTriggerGroupConfiguration))
				{
					for (const tmpTriggerGroup of tmpTriggerGroupConfiguration)
					{
						rewriteTriggerGroup(tmpTriggerGroup);
					}
				}
				else if (tmpTriggerGroupConfiguration)
				{
					rewriteTriggerGroup(tmpTriggerGroupConfiguration);
				}
			}
			for (const tmpEntityBundleProperty of INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES)
			{
				rewriteEntitiesBundle(pPictForm[tmpEntityBundleProperty]);
			}
		};

		// A record set column can carry a trigger group of its own, and those solvers are run against the
		// section view rather than against a record, so they name what this manifest owns. The column's hash
		// and address are relative to a record of the set, so they stay as they are.
		for (const tmpReferenceManifest of Object.values(tmpManifest.ReferenceManifests || {}))
		{
			for (const tmpColumnDescriptor of Object.values(tmpReferenceManifest.Descriptors || {}))
			{
				if (tmpColumnDescriptor.PictForm && (typeof(tmpColumnDescriptor.PictForm) === 'object'))
				{
					rewriteInputTriggerConfiguration(tmpColumnDescriptor.PictForm);
				}
			}
		}

		for (const tmpDescriptor of Object.values(tmpManifest.Descriptors || {}))
		{
			const tmpPictForm = tmpDescriptor.PictForm;
			if (!tmpPictForm || (typeof(tmpPictForm) !== 'object'))
			{
				continue;
			}
			for (const tmpSectionHashProperty of INJECTION_INPUT_SECTION_HASH_PROPERTIES)
			{
				if (tmpPictForm[tmpSectionHashProperty])
				{
					tmpPictForm[tmpSectionHashProperty] = translateHashReference(tmpPictForm[tmpSectionHashProperty], tmpSectionTranslation);
					// A tab selector stores the hash of the tab it is on, so its default is one too.
					tmpDescriptor.Default = translateHashReference(tmpDescriptor.Default, tmpSectionTranslation);
				}
			}
			for (const tmpGroupHashProperty of INJECTION_INPUT_GROUP_HASH_PROPERTIES)
			{
				if (tmpPictForm[tmpGroupHashProperty])
				{
					tmpPictForm[tmpGroupHashProperty] = translateHashReference(tmpPictForm[tmpGroupHashProperty], tmpGroupTranslation);
					tmpDescriptor.Default = translateHashReference(tmpDescriptor.Default, tmpGroupTranslation);
				}
			}
			for (const tmpSolverProperty of INJECTION_INPUT_SOLVER_PROPERTIES)
			{
				if (tmpPictForm[tmpSolverProperty])
				{
					tmpPictForm[tmpSolverProperty] = rewriteSolverValue(tmpPictForm[tmpSolverProperty], `input ${tmpSolverProperty} reference`);
				}
			}
			for (const tmpSolverSetProperty of INJECTION_INPUT_SOLVER_SET_PROPERTIES)
			{
				if (Array.isArray(tmpPictForm[tmpSolverSetProperty.Property]))
				{
					for (const tmpSolverEntry of tmpPictForm[tmpSolverSetProperty.Property])
					{
						if (tmpSolverEntry && (typeof(tmpSolverEntry) === 'object') && tmpSolverEntry[tmpSolverSetProperty.SolverProperty])
						{
							tmpSolverEntry[tmpSolverSetProperty.SolverProperty] = rewriteSolverValue(tmpSolverEntry[tmpSolverSetProperty.SolverProperty], `input ${tmpSolverSetProperty.Property} reference`);
						}
					}
				}
			}
			for (const tmpAddressProperty of INJECTION_INPUT_ADDRESS_PROPERTIES)
			{
				if (tmpPictForm[tmpAddressProperty])
				{
					tmpPictForm[tmpAddressProperty] = rewriteAbsoluteAddress(tmpPictForm[tmpAddressProperty]);
				}
			}
			rewriteInputTriggerConfiguration(tmpPictForm);
			for (const tmpTemplateProperty of INJECTION_INPUT_TEMPLATE_PROPERTIES)
			{
				if (tmpPictForm[tmpTemplateProperty])
				{
					tmpPictForm[tmpTemplateProperty] = rewriteTemplateAddresses(tmpPictForm[tmpTemplateProperty]);
				}
			}
		}
		if (Array.isArray(tmpManifest.ValidationSolvers))
		{
			for (let i = 0; i < tmpManifest.ValidationSolvers.length; i++)
			{
				rewriteSolverEntry(tmpManifest.ValidationSolvers, i, 'validation solver reference');
			}
		}
		return tmpManifest;
	}

	/**
	 * @param {Array<string>} pManifestHashes - The hashes of the manifests to add.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 */
	injectManifestsByHash(pManifestHashes, pAfterSectionHash, pUUID)
	{
		let tmpViewsToRender = [];
		for (const tmpManifestHash of pManifestHashes)
		{
			const tmpManifest = this.findDynamicSectionManifestDefinition(tmpManifestHash);
			if (tmpManifest)
			{
				const tmpUniqueManifest = this.createDistinctManifest(tmpManifest, pUUID);
				const tmpViews = this.injectManifest(tmpUniqueManifest, pAfterSectionHash);
				tmpViewsToRender = tmpViewsToRender.concat(tmpViews);
			}
		}
		this.updateMetatemplateInDOM();
		setTimeout(() =>
		{
			for (const tmpViewToRender of tmpViewsToRender)
			{
				tmpViewToRender.render();
			}
		}, 0);
	}

	/**
	 * @param {Record<string, any>} pSectionsManifest - The section definition object.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 */
	bootstrapAdditiveManifest(pSectionsManifest, pAfterSectionHash)
	{
		const tmpViewsToRender = [];
		const tmpNewSectionDefinitions = this.bootstrapPictFormViewsFromManifest(pSectionsManifest, pAfterSectionHash);
		for (const tmpNewSectionDefinition of tmpNewSectionDefinitions)
		{
			const tmpView = this.pict.views[`PictSectionForm-${tmpNewSectionDefinition.Hash}`];
			if (tmpView)
			{
				tmpViewsToRender.push(tmpView);
			}
		}
		return tmpViewsToRender;
	}

	/**
	 * Filters the views based on the provided filter and sort functions.
	 *
	 * By default, filters views based on the provided filter function and sorts them based on the provided sort function.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to determine if a view should be included.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the filtered views.
	 * @returns {Array} - The filtered and sorted views.
	 */
	filterViews(fFilterFunction, fSortFunction)
	{
		// Generate the filter state object
		let tmpViewFilterState = (
			{
				//FIXME: need to be able to control this order better - adding dynamic sections will always put them at the end, which is rarely what you want
				ViewHashList: Object.keys(this.pict.views),
				// If there is no customization to the filter or sort, just render the last set.
				RenderLastRenderedViewsWithoutCustomization: true,
				// The last rendered views that were rendered
				LastRenderedViews: this.lastRenderedViews,
				// True or false, if the view should be included in the render.
				FilterFunction: fFilterFunction,
				// The sort function to apply to the views (it is sorting OBJECTS, not strings)
				SortFunction: fSortFunction,
				// The final outcome view list
				FilteredViewList: []
			});

		// Execute the customization function
		tmpViewFilterState = this.onBeforeFilterViews(tmpViewFilterState);

		// Filter the views based on the filter function and type
		for (let i = 0; i < tmpViewFilterState.ViewHashList.length; i++)
		{
			let tmpView = this.fable.views[tmpViewFilterState.ViewHashList[i]];
			// If the filter function returns false, skip this view.
			if (tmpViewFilterState.FilterFunction && !tmpViewFilterState.FilterFunction(tmpView))
			{
				continue;
			}
			if (tmpView.isPictSectionForm)
			{
				if (
					// If you don't pass in a filter and it's a dynamic section but set to not be included in the dynamic render, skip it
					(typeof(tmpViewFilterState.FilterFunction) != 'function')
					&& (!tmpView.sectionDefinition.IncludeInDefaultDynamicRender))
				{
					continue;
				}
				tmpViewFilterState.FilteredViewList.push(tmpView);
			}
			else if (!this.options.OnlyRenderDynamicSections || tmpView.options.IncludeInMetacontrollerOperations)
			{
				// If the OnlyRenderDynamicSections option is false, we will render all views in the array..
				// This is great when the app is small and simple.  And DANGEROUS if it isn't.  Take care!
				tmpViewFilterState.FilteredViewList.push(tmpView);
			}
		}

		// Auto-position any views marked with DynamicPlacementMode or DynamicAnchor - this is to assist with mixing configuration driven forms with
		// custom views.
		const tmpViewsToAutoPosition = tmpViewFilterState.FilteredViewList.filter((v) => v.options.DynamicPlacementMode || v.options.DynamicAnchor);
		for (const tmpView of tmpViewsToAutoPosition)
		{
			const tmpMode = tmpView.options.DynamicPlacementMode || 'After';
			const tmpAnchor = tmpView.options.DynamicAnchor;
			let tmpMovingViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v === tmpView);
			let tmpAnchorViewIndex;

			switch (tmpMode)
			{
			case 'First':
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				tmpViewFilterState.FilteredViewList.unshift(tmpView);
				break;
			case 'Last':
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				tmpViewFilterState.FilteredViewList.push(tmpView);
				break;
			case 'Before':
			case 'After':
				tmpAnchorViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v.Hash == tmpAnchor);
				if (tmpAnchorViewIndex < 0)
				{
					// for convenience, also check for dynamic prefixed views if an exact match is not found
					const tmpDynamicAnchor = `PictSectionForm-${tmpAnchor}`;
					tmpAnchorViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v.Hash == tmpDynamicAnchor);
				}
				if (tmpAnchorViewIndex < 0)
				{
					this.log.error(`No anchor view [${tmpAnchor}] found to position view [${tmpView.Hash}] [${tmpMode}].`);
					break;
				}
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				if (tmpMovingViewIndex < tmpAnchorViewIndex)
				{
					// we just removed the element before the target, so we need to adjust
					--tmpAnchorViewIndex;
				}
				if (tmpMode === 'After')
				{
					// this lets us share most of the code for Before and After
					++tmpAnchorViewIndex;
				}
				tmpViewFilterState.FilteredViewList.splice(tmpAnchorViewIndex, 0, tmpView);
				break;
			default:
				this.log.error(`Not auto-positioning view with unknown DynamicPlacementMode: ${tmpMode}`);
			}
		}

		// Sort the views based on the sort function
		// This is to allow dynamic forms sections to have their own sorting criteria before rendering.
		if (typeof(tmpViewFilterState.SortFunction) == 'function')
		{
			tmpViewFilterState.FilteredViewList.sort(tmpViewFilterState.SortFunction);
		}

		// Execute the after filter customization function
		tmpViewFilterState = this.onAfterFilterViews(tmpViewFilterState);

		return tmpViewFilterState.FilteredViewList;
	}

	/**
	 * Renders a specific dynamic form section based on the provided form section hash.
	 *
	 * For this to work, we need the container for the section to be available on the form.
	 *
	 * @param {string} pFormSectionHash - The hash of the form section to render.
	 * @returns {void}
	 */
	renderSpecificFormSection(pFormSectionHash)
	{
		let fViewFilter = (pView) => { return pView.Hash == pFormSectionHash; };
		this.lastRenderedViews = this.filterViews(fViewFilter);
		this.regenerateFormSectionTemplates();
		this.generateMetatemplate();
		this.render();
	}

	/**
	 * Renders the default dynamic form sections based on the provided form section hash.
	 *
	 * @returns {void}
	 */
	renderDefaultFormSections()
	{
		this.lastRenderedViews = this.filterViews((pView) => { return pView?.sectionDefinition?.IncludeInDefaultDynamicRender ?? false; });
		this.regenerateFormSectionTemplates();
		this.generateMetatemplate();
		this.render();
	}

	/**
	 * Renders the form sections based on the provided filter and sort functions.
	 *
	 * If no filter and sort functions are provided, render all form sections.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to filter the views.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the views.
	 */
	renderFormSections(fFilterFunction, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFilterFunction, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (tmpViewList[i] === this)
			{
				continue;
			}
			tmpViewList[i].render();
		}
	}

	/**
	 * Marshals data to the form sections based on the provided filter and sort functions
	 *
	 * If no filter and sort functions are provided, render all form sections.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to filter the views.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the views.
	 */
	marshalFormSections(fFilterFunction, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFilterFunction, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (tmpViewList[i] === this)
			{
				continue;
			}
			tmpViewList[i].marshalToView();
		}
	}

	/**
	 * Regenerates the DyunamicForm section templates based on the provided filter and sort function.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function used to determine which views to include in the regeneration.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function used to determine the order of the views in the regeneration.
	 */
	regenerateFormSectionTemplates(fFormSectionFilter, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			const tmpView = tmpViewList[i];
			if (tmpView === this)
			{
				continue;
			}
			if (tmpView.isPictSectionForm)
			{
				tmpView.rebuildCustomTemplate();
			}
		}
		// Make sure any form-specific CSS is injected properly.
		this.pict.CSSMap.injectCSS();
	}

	/**
	 * Generates a meta template for the DynamicForm views managed by this Metacontroller.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function to apply on the form section.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function to apply on the form section.
	 * @returns {void}
	 */
	generateMetatemplate(fFormSectionFilter, fSortFunction)
	{
		let tmpTemplate = ``;

		if (!this.formTemplatePrefix)
		{
			this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}

		// Add the Form Prefix stuff
		tmpTemplate += `{~T:${this.formTemplatePrefix}-Template-Form-Container-Header:Pict.views["${this.Hash}"]~}`;

		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);

		for (let i = 0; i < tmpViewList.length; i++)
		{
			let tmpFormView = tmpViewList[i];
			if (tmpFormView === this)
			{
				continue;
			}
			if (tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				if (tmpFormView.isPictSectionForm)
				{
					tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				else
				{
					//NOTE: For now, requiring the destination address to be an ID for this case
					tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
					tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			else if (!tmpFormView.isPictSectionForm)
			{
				//NOTE: For now, requiring the destination address to be an ID for this case
				tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
		}
		tmpTemplate += `{~T:${this.formTemplatePrefix}-Template-Form-Container-Footer:Pict.views["${this.Hash}"]~}`;

		this.pict.TemplateProvider.addTemplate(this.options.MetaTemplateHash, tmpTemplate);
	}

	/**
	 * Generates a meta template for the DynamicForm views managed by this Metacontroller.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function to apply on the form section.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function to apply on the form section.
	 *
	 * @return {void}
	 */
	updateMetatemplateInDOM(fFormSectionFilter, fSortFunction)
	{
		if (!this.formTemplatePrefix)
		{
			this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}

		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);
		let tmpPrevDiv = null;
		let tmpDeferredDivContent;
		let tmpDeferredDivID = null;

		for (let i = 0; i < tmpViewList.length; i++)
		{
			let tmpFormView = tmpViewList[i];
			if (tmpFormView === this)
			{
				continue;
			}
			if (!tmpFormView.isPictSectionForm)
			{
				continue;
			}
			if (!tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				continue;
			}
			const tmpFormDivID = tmpFormView.options.CustomTargetID || `Pict-${this.UUID}-${tmpFormView.options.Hash}-Wrap`;
			let tmpFormDivs = this.pict.ContentAssignment.getElement(`#${tmpFormDivID}`);
			if (tmpFormDivs.length > 0)
			{
				const tmpFormDiv = tmpFormDivs[0];
				if (tmpDeferredDivID)
				{
					// We have a deferred div ID, so we need to insert it before this one
					this.pict.ContentAssignment.insertContentBefore(`#${tmpFormDivID}`, tmpDeferredDivContent);
					tmpDeferredDivID = null;
					tmpDeferredDivContent = null;
				}
				tmpPrevDiv = tmpFormDiv;
				continue;
			}
			let tmpFormDivTemplate = '';
			if (tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				if (tmpFormView.isPictSectionForm)
				{
					tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				else
				{
					//NOTE: For now, requiring the destination address to be an ID for this case
					tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
					tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			else if (!tmpFormView.isPictSectionForm)
			{
				//NOTE: For now, requiring the destination address to be an ID for this case
				tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			const tmpFormDivContent = this.pict.parseTemplate(tmpFormDivTemplate, tmpFormView, null, [this]);
			if (tmpPrevDiv)
			{
				this.pict.ContentAssignment.insertContentAfter(`#${tmpPrevDiv.id}`, tmpFormDivContent);
				tmpFormDivs = this.pict.ContentAssignment.getElement(`#${tmpFormDivID}`);
				tmpPrevDiv = tmpFormDivs[0];
				continue;
			}
			tmpDeferredDivID = tmpFormDivID;
			tmpDeferredDivContent = tmpFormDivContent;
		}
		if (tmpDeferredDivID)
		{
			// this means the container was empty, so just add it to the end
			this.pict.ContentAssignment.appendContent(`#Pict-${this.UUID}-FormContainer`, tmpDeferredDivContent);
			tmpDeferredDivID = null;
			tmpDeferredDivContent = null;
		}
	}

	/**
	 * Retrieves a safe clone of the section definition for a given manyfest section description object.
	 *
	 * @param {object} pSectionObject - The section object.
	 * @returns {object|boolean} - The section definition if successful, otherwise false.
	 */
	getSectionDefinition(pSectionObject)
	{
		if (typeof(pSectionObject) != 'object')
		{
			this.log.error('getSectionDefinition() called without a valid section object.');
			return false;
		}

		if (!('Hash' in pSectionObject))
		{
			this.log.error('getSectionDefinition() called without a valid section object hash.');
			return false;
		}

		try
		{
			let tmpSectionDefinition = JSON.parse(JSON.stringify(pSectionObject));

			if (!('Name' in tmpSectionDefinition))
			{
				// If there isn't a name, use the hash
				tmpSectionDefinition.Name = tmpSectionDefinition.Hash;
			}
			if (!('Description' in tmpSectionDefinition))
			{
				// If there isn't a description, use the name
				tmpSectionDefinition.Description = `PICT Section [${tmpSectionDefinition.Name}].`;
			}
			if (!('Groups' in tmpSectionDefinition))
			{
				// If there isn't a groups array, create an empty one
				tmpSectionDefinition.Groups = [];
			}

			return tmpSectionDefinition;
		}
		catch(pError)
		{
			this.log.error(`getSectionDefinition() failed to parse the section object with error: ${pError.message || pError}`);
			return false;
		}
	}

	getSectionViewFromHash(pSectionHash)
	{
		let tmpSectionHash = (typeof(pSectionHash) === 'string') ? pSectionHash : false;
		if (!tmpSectionHash)
		{
			this.log.error('getSectionViewFromHash() called without a valid section hash.');
			return false;
		}
		let tmpViewHash = `PictSectionForm-${tmpSectionHash}`;
		if (tmpViewHash in this.fable.views)
		{
			return this.fable.views[tmpViewHash];
		}
		this.log.error(`getSectionViewFromHash() could not find a view for section hash [${tmpSectionHash}].`);
		return false;
	}

	/**
	 * Marshal one or more section views' data to the DOM.
	 *
	 * For values written outside the normal solve -> marshal cycle (e.g. a trigger group's `PostSolvers`
	 * running in an EntityBundleRequest transaction-complete callback). The global equivalent is
	 * `marshalToView()`; this is the section-scoped, cheaper option.
	 *
	 * @param {string|string[]} pSectionHashes - a section hash, or an array of section hashes
	 * @returns {void}
	 */
	marshalSectionToView(pSectionHashes)
	{
		const tmpSectionHashes = (Array.isArray(pSectionHashes) ? pSectionHashes : [ pSectionHashes ]).filter((pHash) => typeof pHash === 'string' && pHash.length > 0);
		for (const tmpSectionHash of tmpSectionHashes)
		{
			const tmpSectionView = this.getSectionViewFromHash(tmpSectionHash);
			if (tmpSectionView)
			{
				tmpSectionView.marshalToView();
			}
		}
	}

	/**
	 * Marshal one or more inputs' data to the DOM, wherever they live (finds the owning section view).
	 *
	 * The single-input equivalent of {@link marshalSectionToView}; use it when only specific fields
	 * changed (e.g. a trigger group that computed one read-only attribute).
	 *
	 * @param {string|string[]} pInputHashes - an input hash, or an array of input hashes
	 * @returns {void}
	 */
	marshalInputToView(pInputHashes)
	{
		const tmpInputHashes = (Array.isArray(pInputHashes) ? pInputHashes : [ pInputHashes ]).filter((pHash) => typeof pHash === 'string' && pHash.length > 0);
		if (tmpInputHashes.length < 1)
		{
			return;
		}
		const tmpSectionViews = this.filterViews();
		for (const tmpInputHash of tmpInputHashes)
		{
			for (let i = 0; i < tmpSectionViews.length; i++)
			{
				const tmpSectionView = tmpSectionViews[i];
				if (tmpSectionView === this || typeof tmpSectionView.getInputFromHash !== 'function')
				{
					continue;
				}
				const tmpInput = tmpSectionView.getInputFromHash(tmpInputHash);
				if (tmpInput)
				{
					tmpSectionView.manualMarshalDataToViewByInput(tmpInput);
					break;
				}
			}
		}
	}

	/**
	 * Appends the validation solvers of a manifest being added to the form onto the form's own, in order,
	 * skipping any the form already holds so adding the same manifest again does not run its solvers twice.
	 *
	 * @param {Record<string, any>} pTargetManifest - The form's manifest description, which receives the solvers.
	 * @param {Record<string, any>} pSourceManifest - The manifest being added to the form.
	 *
	 * @return {number} The number of validation solvers added.
	 */
	mergeValidationSolvers(pTargetManifest, pSourceManifest)
	{
		if (!pTargetManifest || !pSourceManifest || !Array.isArray(pSourceManifest.ValidationSolvers) || (pSourceManifest.ValidationSolvers.length < 1))
		{
			return 0;
		}
		if (!Array.isArray(pTargetManifest.ValidationSolvers))
		{
			pTargetManifest.ValidationSolvers = [];
		}
		const tmpExistingSolvers = new Set(pTargetManifest.ValidationSolvers.map((pSolver) => JSON.stringify(pSolver)));
		let tmpAddedCount = 0;
		for (const tmpSolver of pSourceManifest.ValidationSolvers)
		{
			const tmpSolverKey = JSON.stringify(tmpSolver);
			if (tmpExistingSolvers.has(tmpSolverKey))
			{
				continue;
			}
			tmpExistingSolvers.add(tmpSolverKey);
			pTargetManifest.ValidationSolvers.push(JSON.parse(tmpSolverKey));
			++tmpAddedCount;
		}
		return tmpAddedCount;
	}

	/**
	 * Clears out the manifest description set on the meta controller.
	 */
	clearManifestDescription()
	{
		this.manifestDescription = null;
	}

	/**
	 * Bootstraps Pict DynamicForm views from a Manyfest description JSON object.
	 *
	 * @param {Object} pManifestDescription - The manifest description object.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 *
	 * @returns {Array<Record<string, any>>} - An array of section definitions added.
	 */
	bootstrapPictFormViewsFromManifest(pManifestDescription, pAfterSectionHash)
	{
		let tmpManifestDescription = (typeof(pManifestDescription) === 'object') ? pManifestDescription : false;
		let tmpSectionList = [];

		if (typeof(tmpManifestDescription) != 'object')
		{
			// Check and see if there is a DefaultFormManifest in the settings
			if (('DefaultFormManifest' in this.fable.settings)
				&& typeof(this.fable.settings.DefaultFormManifest) == 'object'
				&& ('Descriptors' in this.fable.settings.DefaultFormManifest))
			{
				tmpManifestDescription = this.fable.settings.DefaultFormManifest;
			}
			else
			{
				this.log.error('PictFormMetacontroller.bootstrapPictFormViewsFromManifest() called without a valid manifest, and no settings.DefaultFormManifest was provided.');
				return tmpSectionList;
			}
		}
		if (this.manifestDescription)
		{
			this.stashedManifestDescription = this.manifestDescription;
			this.manifestDescription = tmpManifestDescription;
			//FIXME: merge manifests more fully... should this be an external capability?
			for (const [ tmpKey, tmpDescriptor ] of Object.entries(this.manifestDescription.Descriptors || {}))
			{
				if (this.stashedManifestDescription.Descriptors[tmpKey])
				{
					this.log.error(`PictFormMetacontroller.bootstrapPictFormViewsFromManifest() found a duplicate descriptor key [${tmpKey}] when merging manifests. The new descriptor will be skipped.`);
					continue;
				}
				this.stashedManifestDescription.Descriptors[tmpKey] = JSON.parse(JSON.stringify(tmpDescriptor));
			}
			for (const tmpKey of Object.keys(this.manifestDescription.ReferenceManifests || {}))
			{
				if (this.stashedManifestDescription.ReferenceManifests[tmpKey])
				{
					this.log.warn(`PictFormMetacontroller.bootstrapPictFormViewsFromManifest() found a duplicate reference manifest key [${tmpKey}] when merging manifests. The new reference manifest will be skipped.`);
					continue;
				}
				this.stashedManifestDescription.ReferenceManifests[tmpKey] = JSON.parse(JSON.stringify(this.manifestDescription.ReferenceManifests[tmpKey]));
			}
			this.mergeValidationSolvers(this.stashedManifestDescription, this.manifestDescription);
			let tmpInsertAtIndex = this.stashedManifestDescription.Sections.findIndex((pSection) => pSection.Hash == pAfterSectionHash);
			if (tmpInsertAtIndex < 0)
			{
				tmpInsertAtIndex = 0;
			}
			else
			{
				// We want to insert AFTER the found index, so increment by 1
				++tmpInsertAtIndex;
			}
			for (const tmpSection of this.manifestDescription.Sections || [])
			{
				const tmpClonedSection = JSON.parse(JSON.stringify(tmpSection));
				this.stashedManifestDescription.Sections.splice(tmpInsertAtIndex, 0, tmpClonedSection);
				++tmpInsertAtIndex;
			}
		}
		else
		{
			this.manifestDescription = tmpManifestDescription;
		}
		let tmpManifest = this.fable.instantiateServiceProviderWithoutRegistration('Manifest', this.manifestDescription);

		if (this.options.AutoPopulateDefaultObject)
		{
			// Fill out the defaults at the marshal location if it doesn't exist
			const tmpMarshalDestinationObject = this.pict.providers.DataBroker.marshalDestinationObject;
			if (typeof(tmpMarshalDestinationObject) === 'object')
			{
				tmpManifest.populateDefaults(tmpMarshalDestinationObject);
			}
		}

		// Get the list of Explicitly Defined section hashes from the Sections property of the manifest
		if (('Sections' in this.manifestDescription) && Array.isArray(this.manifestDescription.Sections))
		{
			for (let i = 0; i < this.manifestDescription.Sections.length; i++)
			{
				let tmpSectionDefinition = this.getSectionDefinition(this.manifestDescription.Sections[i]);

				if (tmpSectionDefinition)
				{
					tmpSectionList.push(tmpSectionDefinition);
				}
			}
		}

		let tmpImplicitSectionHashes = {};

		let tmpDescriptorKeys = Object.keys(tmpManifest.elementDescriptors);

		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			let tmpDescriptor = tmpManifest.elementDescriptors[tmpDescriptorKeys[i]];

			if (tmpDescriptor)
			{
				this.pict.manifest.addDescriptor(tmpDescriptorKeys[i], tmpDescriptor);
			}

			if (
					// If there is an object in the descriptor
					typeof(tmpDescriptor) == 'object' &&
					// AND it has a PictForm property
					('PictForm' in tmpDescriptor) &&
					// AND the PictForm property is an object
					typeof(tmpDescriptor.PictForm) == 'object' &&
					// AND the PictForm object has a Section property
					('Section' in tmpDescriptor.PictForm) &&
					// AND the Section property is a string
					typeof(tmpDescriptor.PictForm.Section) == 'string'
				)
			{
				tmpImplicitSectionHashes[tmpDescriptor.PictForm.Section] = true;
			}
		}

		let tmpImplicitSectionKeys = Object.keys(tmpImplicitSectionHashes);

		for (let i = 0; i < tmpImplicitSectionKeys.length; i++)
		{
			let tmpExistingSection = tmpSectionList.find((pSection) => { return pSection.Hash == tmpImplicitSectionKeys[i]; });

			if (!tmpExistingSection)
			{
				tmpSectionList.push(this.getSectionDefinition({Hash: tmpImplicitSectionKeys[i]}));
			}
		}

		// Now load a section view for each section
		for (let i = 0; i < tmpSectionList.length; i++)
		{
			let tmpViewHash = `PictSectionForm-${tmpSectionList[i].Hash}`;

			if (tmpViewHash in this.fable.views)
			{
				this.log.info(`getSectionList() found an existing view for section [${tmpSectionList[i].Hash}] so will be skipped.`);
				continue;
			}
			let tmpViewConfiguration = JSON.parse(JSON.stringify(tmpSectionList[i]));
			if (!('Manifests' in tmpViewConfiguration))
			{
				tmpViewConfiguration.Manifests = {};
			}
			tmpViewConfiguration.Manifests.Section = this.manifestDescription;
			this.pict.addView(tmpViewHash, tmpViewConfiguration, libPictViewDynamicForm);
		}

		if ('PickLists' in this.manifestDescription)
		{
			let tmpPickListKeys = Object.keys(this.manifestDescription.PickLists);
			for (let i = 0; i < tmpPickListKeys.length; i++)
			{
				let tmpPickList = this.manifestDescription.PickLists[tmpPickListKeys[i]];
				this.pict.providers.DynamicMetaLists.buildList(tmpPickList);
			}
		}

		// Now see if there is custom CSS
		for (let i = 0; i < tmpSectionList.length; i++)
		{
			let tmpSection = tmpSectionList[i];
			if (('CustomCSS' in tmpSection) && (typeof(tmpSection.CustomCSS) == 'string'))
			{
				this.pict.CSSMap.addCSS(`PSF-SectionCSS-${tmpSection.Hash}`, tmpSection.CustomCSS);
			}
		}

		if (this.stashedManifestDescription)
		{
			this.manifestDescription = this.stashedManifestDescription;
			delete this.stashedManifestDescription;
		}
		return tmpSectionList;
	}

	/**
	 * Trigger an event on all inputs on all views.
	 * @param {string} pEvent - The event to trigger
	 * @param {string} [pTransactionGUID] - (optional) The transaction GUID to use for the event.
	 */
	triggerGlobalInputEvent(pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		let tmpEvent = (typeof(pEvent) === 'string') ? pEvent : this.fable.getUUID();
		let tmpViewHashes = Object.keys(this.pict.views);
		let tmpCompletedHashes = {};
		/** @type {import('./Pict-View-DynamicForm.js')} */
		let tmpFinalizeView = null;
		// Filter the views based on the filter function and type
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			/** @type {import('./Pict-View-DynamicForm.js')} */
			let tmpView = this.pict.views[tmpViewHashes[i]];
			if (tmpView.isPictSectionForm)
			{
				tmpFinalizeView = tmpView;
				tmpView.sectionInputEvent(tmpEvent, tmpCompletedHashes, tmpTransactionGUID);
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID && tmpFinalizeView)
		{
			// If we created the transaction GUID, we need to finalize it
			tmpFinalizeView.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 */
	registerEventTransactionAsyncOperation(pTransactionGUID, pAsyncOperationHash)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, pAsyncOperationHash, PENDING_ASYNC_OPERATION_TYPE);
	}

	/**
	 * FIXME: consolidate with same functions(s) in the dynamic view class
	 *
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 *
	 * @return {boolean} - Returns true if the async operation was found and marked as complete, otherwise false.
	 */
	eventTransactionAsyncOperationComplete(pTransactionGUID, pAsyncOperationHash)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpMarkedOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				if (tmpQueueItem.Data === pAsyncOperationHash)
				{
					tmpQueue.splice(i, 1);
					++tmpMarkedOperationCount;
					--i;
				}
				else
				{
					++tmpPendingAsyncOperationCount;
				}
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpMarkedOperationCount === 0)
		{
			this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete ${pTransactionGUID} could not find async operation with hash ${pAsyncOperationHash}.`);
			return;
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			for (let i = 0; i < tmpQueue.length; i++)
			{
				const tmpQueueItem = tmpQueue[i];
				if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
				{
					tmpQueue.splice(i, 1);
					--i;
					if (typeof tmpQueueItem.Data !== 'function')
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback was not a function.`);
						continue;
					}
					try
					{
						tmpQueueItem.Data();
					}
					catch (pError)
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback error: ${pError}`, { Stack: pError.stack });
					}
				}
			}
			delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		}
		return tmpMarkedOperationCount > 0;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 *
	 * @return {boolean} - Returns true if the transaction was found and able to be finalized, otherwise false.
	 */
	finalizeTransaction(pTransactionGUID)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, null, READY_TO_FINALIZE_TYPE);

		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
		}
		if (tmpPendingAsyncOperationCount > 0)
		{
			this.pict.log.info(`PICT View Metatemplate Helper finalizeTransaction ${pTransactionGUID} is waiting on ${tmpPendingAsyncOperationCount} pending async operations.`);
			return false;
		}
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
			{
				tmpQueue.splice(i, 1);
				--i;
				if (typeof tmpQueueItem.Data !== 'function')
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback was not a function.`);
					continue;
				}
				try
				{
					tmpQueueItem.Data();
				}
				catch (pError)
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback error: ${pError}`, { Stack: pError.stack });
				}
			}
		}
		delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		return true;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Function} fCallback - The callback to call when the transaction is complete.
	 */
	registerOnTransactionCompleteCallback(pTransactionGUID, fCallback)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			fCallback();
		}
		else
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, fCallback, TRANSACTION_COMPLETE_CALLBACK_TYPE);
		}
	}

	showSupportViewInlineEditor()
	{
		// 1. See if the Support views are loaded
		// 2. Load the support view if it isn't
		this.pict.addViewSingleton("Pict-Form-DebugViewer", {}, this.SupportViewPrototypes.DebugViewer);
		this.pict.addViewSingleton("Pict-Form-AppDataViewer", {}, this.SupportViewPrototypes.AppDataViewer);
//		this.pict.addViewSingleton("Pict-Form-LifecycleVisualization", {}, this.SupportViewPrototypes.LifecycleVisualization);
		this.pict.addViewSingleton("Pict-Form-SolverVisualization", {}, this.SupportViewPrototypes.SolverVisualization);
//		this.pict.addViewSingleton("Pict-Form-SpecificSolveVisualization", {}, this.SupportViewPrototypes.SpecificSolveVisualization);
	
		// 3. See if the container for the support view is loaded
		// 4. Render the container for the support view if it isn't loaded
		this.pict.views["Pict-Form-DebugViewer"].bootstrapContainer();
	
		// 5. Render the support view into the container
		this.pict.views["Pict-Form-DebugViewer"].render();
	}

	/**
	 * Returns whether the object is a Pict Metacontroller.
	 *
	 * @returns {boolean} True if the object is a Pict Metacontroller, false otherwise.
	 */
	get isPictMetacontroller()
	{
		return true;
	}
}

module.exports = PictFormMetacontroller;

/**
 * What createDistinctManifest translates when a manifest is injected, by kind. The injection conformance
 * tests measure fixture coverage against this, so adding a construct here without a fixture case fails.
 *
 * @type {Record<string, any>}
 */
module.exports.InjectionTranslation = (
{
	"InputSectionHashProperties": INJECTION_INPUT_SECTION_HASH_PROPERTIES,
	"InputGroupHashProperties": INJECTION_INPUT_GROUP_HASH_PROPERTIES,
	"InputSolverProperties": INJECTION_INPUT_SOLVER_PROPERTIES,
	"InputSolverSetProperties": INJECTION_INPUT_SOLVER_SET_PROPERTIES,
	"InputAddressProperties": INJECTION_INPUT_ADDRESS_PROPERTIES,
	"InputTriggerGroupProperties": INJECTION_INPUT_TRIGGER_GROUP_PROPERTIES,
	"InputTriggerGroupHashProperties": INJECTION_INPUT_TRIGGER_GROUP_HASH_PROPERTIES,
	"InputTemplateProperties": INJECTION_INPUT_TEMPLATE_PROPERTIES,
	"InputEntityBundleProperties": INJECTION_INPUT_ENTITY_BUNDLE_PROPERTIES,
	"EntityBundleAddressProperties": INJECTION_ENTITY_BUNDLE_ADDRESS_PROPERTIES,
	"EntityBundleTemplateProperties": INJECTION_ENTITY_BUNDLE_TEMPLATE_PROPERTIES,
	"TriggerGroupSolverProperties": INJECTION_TRIGGER_GROUP_SOLVER_PROPERTIES,
	"ManifestConstructs": INJECTION_MANIFEST_CONSTRUCTS,
	"SolverDirectiveCodes": Array.from(SOLVER_DIRECTIVE_CODES),
});

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"AutoRender": true,

	"AutoPopulateDefaultObject": true,
	"AutoSolveBeforeRender": true,
	"AutoPopulateAfterRender": true,

	"DefaultRenderable": "Pict-Forms-Metacontainer",
	"DefaultDestinationAddress": "#Pict-Form-Container",

	"OnlyRenderDynamicSections": true,

	"MetaTemplateHash": "Pict-Forms-Metatemplate",

	"Templates": [
		{
			"Hash": "Pict-Forms-Metatemplate",
			"Template": "<!-- Pict-Forms-Metatemplate HAS NOT BEEN GENERATED; call pict.views.PictFormsMetatemplate.generateMetatemplate() to build the containers -->"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "Pict-Forms-Metacontainer",
			"TemplateHash": "Pict-Forms-Metatemplate",
			"DestinationAddress": "#Pict-Form-Container"
		}
	]
});

},{"../services/Pict-Service-DynamicFormDependencyManager.js":638,"./Pict-View-DynamicForm.js":653,"./support/Pict-View-PSF-AppData-Visualization.js":656,"./support/Pict-View-PSF-DebugViewer.js":657,"./support/Pict-View-PSF-LifeCycle-Visualization.js":658,"./support/Pict-View-PSF-Solver-Visualization.js":659,"./support/Pict-View-PSF-SpecificSolve-Visualization.js":660,"pict-view":733}],655:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-Form-SupportExtensions",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a class that provides dynamic templates for the Pict form section provider.
 * @extends libPictProvider
 */
class PictSupportExtension extends libPictProvider
{
	/**
	 * Constructs a new instance of the PictProviderDynamicTemplates class.
	 * @param {Object} pFable - The pFable object.
	 * @param {Object} pOptions - The options object.
	 * @param {Object} pServiceHash - The service hash object.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		// These next blocks of code manually do what views often do, to support sharing of this across multiple views.

		// Only add this css if it doesn't exist already in the css map
		if (!('Pict-Support' in this.pict.CSSMap.inlineCSSMap))
		{
			this.pict.CSSMap.addCSS('Pict-Support',
				/*css*/`
					:root{
						--PSF-Global-background-color: #dcdce5;
						--PSF-Global-text-color: var(--theme-color-text-primary, #333333);

						--PSFExt-gutter-size: 5px;
						--PSFExt-indentation-size: calc(2 * var(--PSFExt-gutter-size));
						--PSFExt-Global-background-color: #dedede;
						--PSFExt-Global-text-color: var(--theme-color-text-primary, #333333);
						--PSFExt-Section-background-color: var(--theme-color-background-tertiary, #efefef);
						--PSFExt-Section-button-color: #5A52A3;
						--PSFExt-Section-button-text-color: #D8D7E5;
						--PSFExt-Section-token-color: #eAf3a2;
						--PSFExt-Section-label-color: var(--theme-color-text-muted, #999);
						--PSFExt-Section-Data-background-color: var(--theme-color-background-secondary, #fafafa);
						--PSFExt-Section-Group-Header-background-color: #ebebff;
						--PSFExt-Section-Group-Row-Header-background-color: #dcf0f0;
						--PSFExt-Solver-Entry-text-color: #bb4a9c;
						--PSFExt-Section-DynamicInput-background-color: #a3ccd8;
						--PSFExt-Section-DynamicInput-button-color: #2b89a4;
						--PSFExt-Section-DynamicInput-button-text-color: #D8D7E5;
					}

					/** Wrapping container	*/
					#Pict-Form-Extensions-Wrap {
						display:flex;
						flex-direction: column;
						height: 75vh;
						overflow: hidden;
						position: absolute;
						left: 50%;
						top: 0px;
						width: 20vw;
						min-width: 340px;
						min-height: 200px;
					}
					#Pict-Form-Extension-DragControl {
						background-color: #eae;
						cursor: move;
						padding: 4px 6px;
						border-radius: 3px;
						border: 1px solid var(--theme-color-text-primary, #111);
					}
					#Pict-Form-Extensions-Container { 
						flex-grow: 1;
						overflow: auto;
						margin-top: 2px;
						color: var(--PSF-Global-text-color);
						background-color: var(--PSF-Global-background-color);
						padding: 10px;
						border: 4px double var(--theme-color-text-primary, #111);
						border-radius: 8px;
						box-shadow: 2px 2px 10px rgba(0,0,0,0.5);
						font-size: 14px;
						font-family: Arial, sans-serif;
						font-size: 14px;
					}
					#Pict-Form-Extension-ResizeControl {
						background-color: #eae;
						cursor: move;
						padding: 4px 4px;
						border-radius: 3px;
						border: 1px solid var(--theme-color-text-primary, #111);
					}
					.PSFExt-Extension-Footer {
						text-align: right;
						font-size: 10px;
						font-weight: bold;
						margin-top: 8px;
					}

					/** Headers	*/
					.PSFExt-Extension-Header {
						font-size: 10px;
						font-weight: bold;
						margin-bottom: var(--PSFExt-gutter-size);
					}
					.PSFExt-Global-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
					}
					.PSFExt-Section-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
					}
					.PSFExt-Content-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
						background-color: var(--PSFExt-Section-background-color);
					}
					.PSFExt-Data-Header {
						font-weight: bold;
						border-bottom: 1px dotted var(--theme-color-border-default, #ccc);
						padding: var(--PSFExt-gutter-size);
					}
					/** Section content */
					.PSFExt-Section { 
						margin: var(--PSFExt-gutter-size);
						padding: var(--PSFExt-gutter-size);
						background-color: var(--PSFExt-Section-background-color);
						border-radius: 4px;
					}
					.PSFExt-Section-Descriptors { 
						padding: var(--PSFExt-gutter-size) 0;
					}
					.PSFExt-Section-Group { 
						padding: var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Buttons {
						list-style-type: none;
						padding: 0;
						padding-bottom: var(--PSFExt-gutter-size);
						margin: calc(var(--PSFExt-gutter-size) * 2) var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Button { 
						display: inline;
						margin-right: calc(var(--PSFExt-gutter-size) * 0.25);
						text-decoration: none;
						background-color: var(--PSFExt-Section-button-color);
						padding: var(--PSFExt-gutter-size);
						border-radius: var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Button a { 
						text-decoration: none;
						color: var(--PSFExt-Section-button-text-color);
					}
					.PSFExt-Section-Button a:hover { 
						text-decoration: underline;
					}
					.PSFExt-Section-Solver-Entry:not(:last-child) {
						border-bottom: 1px solid var(--theme-color-border-default, #ccc);
					}
					.PSFExt-Solver-Entry { 
						font-family: "Courier New", "Lucida Console", monospace;
						font-weight: bold;
						margin-top: var(--PSFExt-gutter-size);
						padding: var(--PSFExt-gutter-size);
						line-height: 1.2;
						color: var(--PSFExt-Solver-Entry-text-color);
						border-bottom: 1px dotted var(--theme-color-border-default, #ccc);
					}
					.PSFExt-Solver-Result { 
						font-family: "Courier New", "Lucida Console", monospace;
						font-weight: bold;
						margin-top: var(--PSFExt-gutter-size);
						padding: 0 var(--PSFExt-gutter-size);
						line-height: 1.2;
					}
					.PSFExt-Section-ExtraData {
						padding-top: calc(var(--PSFExt-gutter-size) / 2);
						padding-bottom: calc(var(--PSFExt-gutter-size) / 2);
						background-color: var(--PSFExt-Section-Data-background-color);
					}
					.PSFExt-Section-Group .PSFExt-Content-Header.PSFExt-Section-Group-Header {
						background-color: var(--PSFExt-Section-Group-Header-background-color);
					}
					.PSFExt-Section-Group .PSFExt-Content-Header.PSFExt-Section-Group-Row-Header {
						background-color: var(--PSFExt-Section-Group-Row-Header-background-color);
					}
					.PSFExt-DeEmphasize { 
						color: var(--PSFExt-Section-label-color);
						font-size: smaller;
					}
					.PSFExt-Data { 
						margin-left: var(--PSFExt-indentation-size);
						line-height: 0.85;
						font-size: smaller;
					}
					.PSFExt-Data-Table {
						width: 100%;
						border-collapse: collapse;
						margin-left: var(--PSFExt-indentation-size);
						margin-top: var(--PSFExt-gutter-size);
						margin-bottom: var(--PSFExt-gutter-size);
						overflow-x: auto;
					}
					.PSFExt-Label { 
						min-width: 15%;
						color: var(--PSFExt-Section-label-color);
						margin: var(--PSFExt-gutter-size) 0;
					}
					.PSFExt-Label::after {
						content: ": ";
					}
					.PSFExt-Hidden { 
						display: none;
					}
					.PSFExt-Section-Solver-DynamicInput {
						background-color: var(--theme-color-background-panel, #ffffff);
					}
					
					/** empty states */
					.PSFExt-Section-Solvers:empty::before {
						content: "No Section Solvers Defined";
						font-style: italic;
						color: var(--PSFExt-Section-label-color);
						margin-left: var(--PSFExt-indentation-size);
						text-align: center;
						padding: var(--PSFExt-gutter-size);
						display: block;
						font-size: smaller;
					}
					.PSFExt-Group-Solvers:empty::before {
						content: "No Group/RecordSet Solvers Defined";
						font-style: italic;
						color: var(--PSFExt-Section-label-color);
						margin-left: var(--PSFExt-indentation-size);
						text-align: center;
						padding: var(--PSFExt-gutter-size);
						display: block;
						font-size: smaller;
					}
					.PSFExt-ExpressionEditbox {
						width: calc(100% - 20px);
						resize: vertical;
						min-height: 80px;
						font-family: monospace;
						font-size: 0.9em;
					}
					.PSFExt-Token {
						background-color: var(--PSFExt-Section-token-color);
					}
				`, 1000, 'Pict-Form-SupportBase');
		}

		// Only add these templates if they doesn't exist
		if (this.pict.TemplateProvider.getTemplate('Pict-Form-Support-Container') == null)
		{
			this.pict.TemplateProvider.addTemplate('Pict-Form-Support-Container',
				/*html*/`
			<div id="Pict-Form-Extensions-Wrap">
				<p class="PSFExt-Extension-Header"><span id="Pict-Form-Extension-DragControl" class="PSDV-Extension-Header-Controlbar">Pict.Extensions {~TS:Pict-Form-Support-Container-Link:Pict.providers[Pict-Form-SupportExtensions].getSupportViewLinks()~} <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#Pict-Form-Extensions-Container', 'PSFExt-Hidden');{~P~}.ContentAssignment.toggleClass('#Pict-Form-Extensions-Footer', 'PSFExt-Hidden');">toggle</a></span></p>
				<div id="Pict-Form-Extensions-Container"></div>
				<p id="Pict-Form-Extensions-Footer" class="PSFExt-Extension-Footer"><span id="Pict-Form-Extension-ResizeControl">Pict.Extensions Resize</span></p>
			</div>
				`);
		}
		if (this.pict.TemplateProvider.getTemplate('Pict-Form-Support-Container-Link') == null)
		{
			this.pict.TemplateProvider.addTemplate('Pict-Form-Support-Container-Link',
				/*html*/` [ <a href="{~D:Record.Link~}" onclick="{~D:Record.OnClick~}" data-shortname="{~D:Record.ShortName~}" data-longname="{~D:Record.LongName~}">{~D:Record.ShortName~}</a> ] `);
		}


		this.SupportViews = {};
	}

	registerSupportView(pView)
	{
		this.pict.log.info(`Registering support view ${pView.Hash} with Pict Support Extension provider.`);
		this.SupportViews[pView.Hash] = pView;
	}

	getSupportViewLinks()
	{
		let tmpLinks = [];
		let tmpSupportViewHashes = Object.keys(this.SupportViews);
		for (let i = 0; i < tmpSupportViewHashes.length; i++)
		{
			let tmpViewHash = tmpSupportViewHashes[i];
			let tmpView = this.SupportViews[tmpViewHash];
			tmpLinks.push(
				{
					Hash: tmpView.Hash,
					Link: `javascript:void(0);`,
					ShortName: tmpView.DisplayShortName,
					LongName: tmpView.DisplayLongName,
					OnClick: `${this.pict.browserAddress}.views['${tmpView.Hash}'].render()`
				}
			);
		}
		return tmpLinks;
	}
}

module.exports = PictSupportExtension;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":552}],656:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-AppData",

	DefaultRenderable: 'Pict-Form-AppData-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-AppData-Content",
			Template: /*html*/`
<div id="Pict-Form-AppData-Content">
	<h2 class="PSFAD-Global-Header">Pict Form Data Visualization</h2>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Form Marshal Destination</span> {~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Form Data</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">AppData</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.AppData')">Download AppData JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Fable Settings</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.settings')">Download fable settings JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Application Options</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.PictApplication.options')">Download Application options JSON</a>]
	</p>
	<div id="PSFExt-Data-Browser" class="PSFExt-Section">
		{~TVS:Pict-Form-AppData:Context[0].flattenMarshalDestination()~}
	</div>
`
		},
		{
			Hash: "Pict-Form-AppData",
			Template: /*html*/`
	<div class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header"><span class="PSFExt-DeEmphasize">Address:</span> 
			{~D:Record.Key~}
		</h3>
		<div id="PSFExt-AD-{~D:Record.Key~}-Extra" class="PSFExt-Section-ExtraData">
			{~TIfAbs:Pict-Form-AppData-ObjectValueDisplay:Record:Record.Value.DataType^==^Object~}
			{~TIfAbs:Pict-Form-AppData-NotObjectValueDisplay:Record:Record.Value.DataType^!=^Object~}
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-AppData-NotObjectValueDisplay",
			Template: /*html*/`
				<!-- Not Object Value Display -->
				{~TIfAbs:Pict-Form-AppData-ArrayValueDisplay:Record:Record.Value.DataType^==^Array~}
				{~TIfAbs:Pict-Form-AppData-PrimitiveValueDisplay:Record:Record.Value.DataType^!=^Array~}
`
		},
		{
			Hash: "Pict-Form-AppData-ObjectValueDisplay",
			Template: /*html*/`
			<!-- Object Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Type</span> Javascript Object {~T:Pict-Form-AppData-ObjectDownloadLink~}
			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-ArrayValueDisplay",
			Template: /*html*/`
			<!-- Array Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Type</span> Array {~TIfAbs:Pict-Form-AppData-ArrayDownloadLink~}

			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-PrimitiveValueDisplay",
			Template: /*html*/`
			<!-- Primitive Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Value</span> {~D:Record.Value.Default~}
			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-ObjectDownloadLink",
			Template: /*html*/`[<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download JSON</a>]`
		},
		{
			Hash: "Pict-Form-AppData-ArrayDownloadLink",
			Template: /*html*/`[<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download Array</a>]`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-AppData-Renderable",
			TemplateHash: "Pict-Form-AppData-Content"
		}
	]
});

class PictFormsAppData extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'FDT';
		this.DisplayLongName = 'FormData';
	}

	flattenMarshalDestination()
	{
		return this.flattenAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
	}

	flattenAppData()
	{
		return this.flattenAddress('AppData');
	}

	flattenAddress(pAddress)
	{
		let tmpData = this.pict.resolveStateFromAddress(pAddress);
		// Now flatten the entire data structure...
		return this.pict.manifest.objectAddressGeneration.generateAddressses(tmpData);
	}
}

module.exports = PictFormsAppData;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":661}],657:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-DebugViewer",

	DefaultRenderable: 'Pict-Form-DebugViewer-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/`
	/** Dynamic Input Section Overrides */
	#PSFExt-DynamicInputSection .PSFExt-Section { 
		margin: var(--PSFExt-gutter-size);
		padding: var(--PSFExt-gutter-size);
		background-color: var(--PSFExt-Section-DynamicInput-background-color);
	}

	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Section-Button { 
		background-color: var(--PSFExt-Section-DynamicInput-button-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Section-Button a { 
		color: var(--PSFExt-Section-DynamicInput-button-text-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Label,
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-DeEmphasize { 
		color: var(--PSFExt-Section-DynamicInput-button-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section-Descriptors { 
		border-left: 5px solid var(--PSFExt-Section-DynamicInput-background-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section-Group { 
		border-left: 5px solid var(--PSFExt-Section-DynamicInput-button-color);
	}
`,

	Templates: [
		{
			Hash: "Pict-Form-DebugViewer-Content",
			Template: /*html*/`
<div id="Pict-Form-DebugViewer-Content">
	<h2 class="PSFExt-Global-Header">Pict Inline Form Editing Tool</h2>
	{~T:Pict-Form-DebugViewer-MetacontrollerContainer~}
</div>`
		},
		{
			Hash: "Pict-Form-DebugViewer-MetacontrollerContainer",
			Template: /*html*/`
	<p class="PSFExt-Data"><span class="PSFExt-Label">Scope:</span> {~D:Context[0].getDynamicState().Scope~}</p>
	<ul class="PSFExt-Section-Buttons">
	</ul>
	<div id="PSFExt-SectionList">
		{~TS:Pict-Form-DebugViewer-SectionContainer:Context[0].getDynamicState().SectionViews~}
	</div>
	<hr>
	<div id="PSFExt-DynamicInputSection">
		{~T:Pict-Form-DebugViewer-SectionContainer:Context[0].getDynamicState().DynamicInputView~}
	</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-SectionContainer",
			Template: /*html*/`
	<div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header"><span class="PSFExt-DeEmphasize">Section:</span> {~D:Record.sectionDefinition.Name~}</h3>
		<ul class="PSFExt-Section-Buttons">
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views['{~D:Record.View.Hash~}'].render()">Render</a></li>
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.assignContent('{~D:Record.View.options.DefaultDestinationAddress~}','')">Clear</a></li>
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.removeClass('#PSFExt-{~D:Record.View.Hash~}-Extra', 'PSFExt-Hidden')">Extra Data</a></li>
		</ul>
		<div id="PSFExt-{~D:Record.View.Hash~}-Extra" class="PSFExt-Hidden PSFExt-Section-ExtraData">
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Description</span> {~D:Record.sectionDefinition.Description~}
			</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Hash</span> {~D:Record.View.Hash~}
			</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">HTML ID</span> {~D:Record.View.sectionDefinition.Macro.HTMLID~}
			</p>
			<h4 class="PSFExt-Content-Header">Section Solvers:</h4>
			<div class="PSFExt-Section-Solvers">{~TS:Pict-Form-DebugViewer-SolverEntry:Record.Solvers[]<<~?ExpressionScope,==,Section?~>>~}</div>
			<h4 class="PSFExt-Content-Header">Tabular/RecordSet Solvers:</h4>
			<div class="PSFExt-Group-Solvers">{~TS:Pict-Form-DebugViewer-SolverEntry:Record.Solvers[]<<~?ExpressionScope,==,Group?~>>~}</div>
			<h4 class="PSFExt-Content-Header">Inputs:</h4>
			<div class="PSFExt-Section-Solver-DynamicInput">
				{~TS:Pict-Form-DebugViewer-GroupContainer:Record.View.sectionDefinition.Groups~}
			</div>
			<ul class="PSFExt-Section-Buttons">
				<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.View.Hash~}-Extra', 'PSFExt-Hidden')">Hide Extra Data for {~D:Record.View.Hash~}</a></li>
			</ul>
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-SolverEntry",
			Template: /*html*/`
			<div class="PSFExt-Section-Solver-Entry">
				<p class="PSFExt-Solver-Entry">{~D:Record.Expression~}</p>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Last Result</span> <span class="PSFExt-Solver-Result">{~D:Record.LastResult~}</span></p>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Sequence</span> Ordinal [{~D:Record.Ordinal~}] Index [{~D:Record.Index~}]</p>
			</div>
			`
		},
		{
			Hash: "Pict-Form-DebugViewer-GroupContainer",
			Template: /*html*/`
			<div class="PSFExt-Section-Group">
				<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">
					<span class="PSFExt-DeEmphasize">Group:</span> {~D:Record.Name~} [idx <em>{~D:Record.GroupIndex~}</em>]
				</h5>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Layout</span> {~D:Record.Layout~}</p>
				<div class="PSFExt-Section-Rows">
					{~TS:Pict-Form-DebugViewer-RowContainer:Record.Rows~}
				</div>
			</div>
			`
		},
		{
			Hash: "Pict-Form-DebugViewer-RowContainer",
			Template: /*html*/`
					<div class="PSFExt-Section-Descriptors">
						<h6 class="PSFExt-Content-Header PSFExt-Section-Group-Row-Header">
							<span class="PSFExt-DeEmphasize">Row:</span> {~D:Record.Hash~}
						</h6>
						{~TS:Pict-Form-DebugViewer-DescriptorContainer:Record.Inputs~}
					</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-DescriptorContainer",
			Template: /*html*/`
						<div class="PSFExt-Section-Descriptor">
							<p class="PSFExt-Data-Header"><span class="PSFExt-DeEmphasize">Input:</span> {~D:Record.Name~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Hash</span> {~D:Record.Hash~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">DataType</span> {~D:Record.DataType~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">InputType</span> {~D:Record.PictForm.InputType~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Informary Data Address</span> {~D:Record.PictForm.InformaryDataAddress~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Input Index</span> {~D:Record.PictForm.InputIndex~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">HTML ID</span> {~D:Record.PictForm.Macro.HTMLID~}</p>
						</div>
					`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-DebugViewer-Renderable",
			TemplateHash: "Pict-Form-DebugViewer-Content"
		}
	]
});

class PictFormsInlineEditor extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'ILE';
		this.DisplayLongName = 'InlineEditor';
	}
}

module.exports = PictFormsInlineEditor;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":661}],658:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-LifeCycle",

	DefaultRenderable: 'Pict-Form-LifeCycle-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-LifeCycle-Content",
			Template: /*html*/`
<div id="Pict-Form-LifeCycle-Content">
	<h2 class="PSFLC-Global-Header">Pict LifeCycle Visualization</h2>
</div>
`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-LifeCycle-Renderable",
			TemplateHash: "Pict-Form-LifeCycle-Content"
		}
	]
});

class PictFormsLifeCycle extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'LCV';
		this.DisplayLongName = 'LifecycleVisulization';
	}
}

module.exports = PictFormsLifeCycle;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":661}],659:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-Solver",

	DefaultRenderable: 'Pict-Form-Solver-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-Solver-Content",
			Template: /*html*/`
<div id="Pict-Form-Solver-Content">
	<h2 class="PSFS-Global-Header">Pict Solver Visualization</h2>
	<ul class="PSFExt-Section-Buttons">
		<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views.PictFormMetacontroller.solve(); {~P~}.views.PictFormMetacontroller.marshalFormSections(); {~P~}.views['{~D:Context[0].Hash~}'].render();">Solve</a></li>
	</ul>
	{~TS:Pict-Form-Solver-Entries:Context[0].getDynamicState().Solvers~}
</div>
`
		},
		{
			Hash: "Pict-Form-Solver-Entries",
			Template: /*html*/`
	<div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header">
			<span class="PSFExt-DeEmphasize">{~D:Record.ExpressionScope~} {~D:Record.SectionOrdinal~}.G.{~D:Record.GroupOrdinal~}</span> Ord</span>{~D:Record.Ordinal~} <span class="PSFExt-DeEmphasize">Ind</span>{~D:Record.Index~}
			[ <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">Edit</a> ]
			[ <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer', 'PSFExt-Hidden');">More</a> ]
		</h3>
		
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer" class="PSFExt-Hidden">
			<p class="PSFExt-Data">
				<textarea id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox" class="PSFExt-ExpressionEditbox">{~D:Record.Expression~}</textarea>
			</p>
			<ul class="PSFExt-Section-Buttons">
				<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].updateExpressionFromElement('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox', '{~D:Record.ExpressionScope~}', '{~D:Record.ViewHash~}', {~D:Record.SectionOrdinal~}, {~D:Record.Index~}, '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display'); {~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">Apply</a></li>
			</ul>
		</div>
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Extra" class="PSFExt-Section-ExtraData">
			<p class="PSFExt-Solver-Entry" id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display">{~D:Record.Expression~}</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Value</span> {~TBT:Record.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record:Pict-Form-RecordValueDisplaySimple~}
			</p>
		</div>
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer" class="PSFExt-Section-ExtraData PSFExt-Hidden">
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Tokens</h5>
			{~TS:Pict-Form-Solver-PostfixToken:Record.LastResultsObject.PostfixTokenObjects~}
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">Virtual Symbols</h5>
			{~TVS:Pict-Form-Solver-VirtualSymbols:Record.LastResultsObject.VirtualSymbols~}
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Solve List</h5>
			{~TVS:Pict-Form-Solver-PostFixSolveEntry:Record.LastResultsObject.PostfixSolveList~}
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-Solver-PostfixToken",
			Template: /*html*/`
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">{~D:Record.Type~}</span> <span class="PSFExt-Token">{~D:Record.Token~}</span>
			</p>
`
		},
		{
			Hash: "Pict-Form-Solver-VirtualSymbols",
			Template: /*html*/`
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">{~D:Record.Key~}</span> {~TBT:Record.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record:Pict-Form-RecordValueDisplaySimple~}
			</p>
`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayComplex",
			Template: /*html*/`
			<!-- Complex Value -->
			{~TBT:Record.Value:array:Pict-Form-RecordValueDisplayArray:Record:Pict-Form-RecordValueDisplayObject~}
`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayObject",
			Template: /*html*/`JSON Object
			<!-- RAW Object
{~DJ:Record.Value~}
			-->`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayArray",
			Template: /*html*/`JSON Array ({~D:Record.Value.length~} items)
			<!-- RAW Array
{~DJ:Record.Value~}
			-->`
		},
		{
			Hash: "Pict-Form-RecordValueDisplaySimple",
			Template: /*html*/`{~D:Record.Value~}`
		},
		{
			Hash: "Pict-Form-Solver-PostFixSolveEntry",
			Template: /*html*/`
			<div>
				<h6 class="PSFExt-Content-Header PSFExt-Data-Header">Postfix Solve Entry #{~D:Record.Key~} Symbol <span class="PSFExt-Token">{~D:Record.Value.VirtualSymbolName~}</span></h6>
				<table class="PSFExt-Data-Table">
					<th>
						<tr><td></td><td>Left</td><td>Operation</td><td>Right</td></tr>
					</th>
					<tr>
						<td>Virtual Symbol</td>
						<td> {~D:Record.Value.LeftValue.VirtualSymbolName~} </td>
						<td> {~D:Record.Value.Operation.VirtualSymbolName~} </td>
						<td> {~D:Record.Value.RightValue.VirtualSymbolName~} </td>
					</tr>
					<tr>
						<td>Value</td>
						<td> {~TBT:Record.Value.LeftValue.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record.Value.LeftValue:Pict-Form-RecordValueDisplaySimple~} </td>
						<td></td>
						<td> {~TBT:Record.Value.RightValue.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record.Value.RightValue:Pict-Form-RecordValueDisplaySimple~} </td>
					</tr>
					<tr>
						<td>Tokens</td>
						<td> {~D:Record.Value.LeftValue.Token~} </td>
						<td> {~D:Record.Value.Operation.Token~} </td>
						<td> {~D:Record.Value.RightValue.Token~} </td>
					</tr>
					<tr>
						<td>Type</td>
						<td> {~D:Record.Value.LeftValue.Type~} </td>
						<td> {~D:Record.Value.Operation.Type~} </td>
						<td> {~D:Record.Value.RightValue.Type~} </td>
					</tr>
					<tr>
						<td>Solve Layer</td>
						<td> {~D:Record.Value.LeftValue.SolveLayerStack~} </td>
						<td></td>
						<td> {~D:Record.Value.RightValue.SolveLayerStack~} </td>
					</tr>
				</table>
			</div>
`
		},
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-Solver-Renderable",
			TemplateHash: "Pict-Form-Solver-Content"
		}
	]
});

class PictFormsSolver extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'SLV';
		this.DisplayLongName = 'SolverVisualization';
	}
}

module.exports = PictFormsSolver;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":661}],660:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-SpecificSolve",

	DefaultRenderable: 'Pict-Form-SpecificSolve-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-SpecificSolve-Content",
			Template: /*html*/`
<div id="Pict-Form-SpecificSolve-Content">
	<h2 class="PSFSS-Global-Header">Pict Specific Solve Timing Visualization</h2>
</div>
`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-SpecificSolve-Renderable",
			TemplateHash: "Pict-Form-SpecificSolve-Content"
		}
	]
});

class PictFormsSpecificSolve extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'STV';
		this.DisplayLongName = 'SpecificSolveTimingVisualization';
	}
}

module.exports = PictFormsSpecificSolve;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":661}],661:[function(require,module,exports){
const libPictView = require(`pict-view`);

const libPictSupportProvider = require('./Pict-Provider-PSF-Support.js');

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-SupportBase",

	DefaultRenderable: 'Pict-Form-SUPPORT-BASE',

	RenderOnLoad: false,

	Templates: [],
	Renderables: [
		{
			RenderableHash: "Pict-Form-SUPPORT-BASE",
			TemplateHash: "Pict-Form-SUPPORT-BASE-NOTEMPLATE"
		}
	]
});

class PictFormsSupportBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Add the support provider if it doesn't exist
		this.pict.addProviderSingleton("Pict-Form-SupportExtensions", {}, libPictSupportProvider);

		this.DisplayShortName = 'U';
		this.DisplayLongName = 'UNDEFINED';

		// Register this with the support provider
		this.pict.providers["Pict-Form-SupportExtensions"].registerSupportView(this);
	}

	getDynamicState()
	{
		if (!('PictFormMetacontroller' in this.pict.views))
		{
			this.pict.log.warn(`Pict Forms Inline Editor tried to initialize but no metacontroller was found.`);
			return (
				{
					"Scope": `ERR_NO_METACONTROLLER`,
					"Description": `Error initializing inline editor -- no metacontroller found.`,
					"Manifest": this.fable.newManyfest(),
					"Sections": []
				});
		}
		let tmpMetacontroller = this.pict.views.PictFormMetacontroller;
		let tmpDynamicState = (
			{
				// TODO: The way the metacontroller pulls in the manifest and bootstraps the description is putting "DEFAULT" into the actual manifest; fix this.
				"Scope": tmpMetacontroller.manifestDescription.Scope,
				"Description": ``,
				"Manifest": tmpMetacontroller.manifest,
				"ManifestDescription": tmpMetacontroller.manifestDescription,
				"AllViews": tmpMetacontroller.filterViews(),
				"SectionViews": [],
				"DynamicInputView": false,
				"Solvers": []
			});

		for (let i = 0; i < tmpDynamicState.AllViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.AllViews[i];
			if (tmpSectionView.isPictSectionForm && (tmpSectionView.Hash == 'PictFormMetacontroller-DynamicInputs'))
			{
				// This is the special Dynamic Input section -- it goes in its own place.
				tmpDynamicState.DynamicInputView = tmpSectionView;
			}
			else if (tmpSectionView.isPictSectionForm)
			{
				tmpDynamicState.SectionViews.push(
					{
						View: tmpSectionView,
						sectionDefinition: tmpSectionView.sectionDefinition,
						Solvers: []
					});
			}
		}

		// Now get the solvers for each section view
		for (let i = 0; i < tmpDynamicState.SectionViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.SectionViews[i].View;
			let tmpSectionViewSolvers = tmpDynamicState.SectionViews[i].Solvers;
			// Find the view representation in the 
			if (tmpSectionView.isPictSectionForm && Array.isArray(tmpSectionView.sectionDefinition.Solvers))
			{
				for (let j = 0; j < tmpSectionView.sectionDefinition.Solvers.length; j++)
				{
					let tmpSolver = tmpSectionView.sectionDefinition.Solvers[j];

					let tmpSolverEntry = { ViewHash: tmpSectionView.Hash, SectionOrdinal: i, GroupOrdinal: -1, Ordinal: 1, Index: j, Expression: '', ExpressionType: 'Unknown', ExpressionScope: 'Section'}
					if (typeof(tmpSolver) === 'string')
					{
						tmpSolverEntry.Expression = tmpSolver;
						tmpSolverEntry.ExpressionType = 'Simple';
					}
					else if (typeof(tmpSolver) === 'object')
					{
						// When the solvers are in this format:
						// {
						// 	Ordinal: 0,
						// 	Expression: "PercentTotalFat = (Fat * 9) / Calories",
						// }
						tmpSolverEntry.Expression = tmpSolver.Expression;
						tmpSolverEntry.Ordinal = tmpSolver.Ordinal;
						tmpSolverEntry.ExpressionType = 'Complex';
					}
					tmpDynamicState.Solvers.push(tmpSolverEntry);
					tmpSectionViewSolvers.push(tmpSolverEntry);
				}
			}

			// Now get all the Group solvers
			// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
			for (let j = 0; j < tmpSectionView.sectionDefinition.Groups.length; j++)
			{
				let tmpGroup = tmpSectionView.getGroup(j);
				if (`RecordSetSolvers` in tmpGroup)
				{
					for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
					{
						let tmpSolver = tmpGroup.RecordSetSolvers[k];
	
						let tmpSolverEntry = { ViewHash: tmpSectionView.Hash, SectionOrdinal: i, GroupOrdinal: j, Ordinal: 1, Index: k, Expression: '', ExpressionType: 'Unknown', ExpressionScope: 'Group'}
						if (tmpSolver)
						{
							if (typeof(tmpSolver) === 'string')
							{
								tmpSolverEntry.Expression = tmpSolver;
								tmpSolverEntry.ExpressionType = 'Simple';
							}
							else if (typeof(tmpSolver) === 'object')
							{
								// When the solvers are in this format:
								// {
								// 	Ordinal: 0,
								// 	Expression: "PercentTotalFat = (Fat * 9) / Calories",
								// }
								tmpSolverEntry.Expression = tmpSolver.Expression;
								tmpSolverEntry.Ordinal = tmpSolver.Ordinal;
								tmpSolverEntry.ExpressionType = 'Complex';
							}
						}
						tmpDynamicState.Solvers.push(tmpSolverEntry);
						tmpSectionViewSolvers.push(tmpSolverEntry);
					}
				}
			}

			// Now sort the solvers by Ordinal, then Group/Section and then Index
			tmpSectionViewSolvers.sort((pLeftValue, pRightValue) => 
			{
				if (pLeftValue.Ordinal < pRightValue.Ordinal) return -1;
				if (pLeftValue.Ordinal > pRightValue.Ordinal) return 1;
				if (pLeftValue.ExpressionScope == 'Group' && pRightValue.ExpressionScope == 'Section') return -1;
				if (pLeftValue.ExpressionScope == 'Section' && pRightValue.ExpressionScope == 'Group') return 1;
				if (pLeftValue.Index < pRightValue.Index) return -1;
				if (pLeftValue.Index > pRightValue.Index) return 1;
				return 0;
			});
		}

		tmpDynamicState.Solvers.sort((pLeftValue, pRightValue) => 
			{
				if (pLeftValue.Ordinal < pRightValue.Ordinal) return -1;
				if (pLeftValue.Ordinal > pRightValue.Ordinal) return 1;
				if (pLeftValue.ExpressionScope == 'Group' && pRightValue.ExpressionScope == 'Section') return -1;
				if (pLeftValue.ExpressionScope == 'Section' && pRightValue.ExpressionScope == 'Group') return 1;
				if (pLeftValue.Index < pRightValue.Index) return -1;
				if (pLeftValue.Index > pRightValue.Index) return 1;
				return 0;
			});
		// Get the *full* last solve outcome object
		tmpDynamicState.LastSolveOutcome = this.pict.providers.DynamicSolver.lastSolveOutcome;

		// Now walk through the solvers and see if the outcome has a result for it.
		if (typeof(tmpDynamicState.LastSolveOutcome) == 'object')
		{
			for (let i = 0; i < tmpDynamicState.Solvers.length; i++)
			{
				let tmpSolverEntry = tmpDynamicState.Solvers[i];

				if (tmpSolverEntry.Ordinal in tmpDynamicState.LastSolveOutcome.SolveOrdinals)
				{
					if (tmpSolverEntry.ExpressionScope == 'Section')
					{
						let tmpSolveResultSet = tmpDynamicState.LastSolveOutcome.SolveOrdinals[tmpSolverEntry.Ordinal].SectionSolvers;
						if (Array.isArray(tmpSolveResultSet))
						{
							for (let j = 0; j < tmpSolveResultSet.length; j++)
							{
								let tmpPotentialResultEntry =	tmpSolveResultSet[j];
								if ((tmpPotentialResultEntry.ViewHash == tmpSolverEntry.ViewHash) && (tmpPotentialResultEntry.Solver.Expression == tmpSolverEntry.Expression))
								{
									// We have a match -- assign the result to the solver entry
									tmpSolverEntry.LastResult = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									tmpSolverEntry.Value = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									tmpSolverEntry.LastResultsObject = tmpPotentialResultEntry.Solver.ResultsObject;
								}
							}
						}
					}
					else if ((tmpSolverEntry.ExpressionScope == 'Group'))
					{
						let tmpSolveResultSet = tmpDynamicState.LastSolveOutcome.SolveOrdinals[tmpSolverEntry.Ordinal].GroupSolvers;
						if (Array.isArray(tmpSolveResultSet))
						{
							for (let j = 0; j < tmpSolveResultSet.length; j++)
							{
								let tmpPotentialResultEntry =	tmpSolveResultSet[j];
								if ((tmpPotentialResultEntry.ViewHash == tmpSolverEntry.ViewHash) && (tmpPotentialResultEntry.Solver.Expression == tmpSolverEntry.Expression))
								{
									// We have a match -- assign the result to the solver entry
									if (tmpPotentialResultEntry.Solver && ('ResultsObject' in tmpPotentialResultEntry.Solver))
									{
										tmpSolverEntry.LastResult = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									}
									if (tmpPotentialResultEntry.Solver && ('ResultsObject' in tmpPotentialResultEntry.Solver))
									{
										tmpSolverEntry.LastResultsObject = tmpPotentialResultEntry.Solver.ResultsObject;
									}
								}
							}
						}
					}
				}
			}
		}

		return tmpDynamicState;
	}

	getSectionSolvers(pSectionViewHash)
	{
		let tmpDynamicState = this.getDynamicState();
		let tmpSectionSolvers = tmpDynamicState.Solvers.map((pSolverEntry) => { if (pSolverEntry.ViewHash === pSectionViewHash) return pSolverEntry; });
		return tmpSectionSolvers;
	}


	downloadJSONObjectAsFile(pAddress)
	{
		try
		{
			const tmpJSONData = this.pict.resolveStateFromAddress(pAddress);
			const tmpJSONFileName = `PICT_JSON_${pAddress.replace('.','_')}.json`;
			const tmpJSONString = JSON.stringify(tmpJSONData, null, 4);

			if (!URL || !Blob)
			{
				this.pict.log.error(`Browser does not support required features for downloading JSON object from address ${pAddress}.`);
				return;
			}

			// Synthesize a file, URL and link to facilitate a file download
			const tmpAbstractFileBlob = new Blob([tmpJSONString], { type: "application/json" });
			const tmpAbstractFileURL = URL.createObjectURL(tmpAbstractFileBlob);
			const tmpAbstractAnchorElement = document.createElement("a");
			tmpAbstractAnchorElement.href = tmpAbstractFileURL;
			tmpAbstractAnchorElement.download = tmpJSONFileName;
			// Trigger the download
			tmpAbstractAnchorElement.click();
			// Clean up the URL from memory
			URL.revokeObjectURL(tmpAbstractFileURL);
		}
		catch (pError)
		{
			this.pict.log.error(`Error downloading JSON object from address ${pAddress}: ${pError.message}`);
		}
	}

	updateExpressionFromElement(pExpressionElementAddress, pExpressionScope, pSectionViewHash, pSectionOrdinal, pSolverIndex, pExpressionElementRepresentationAddress)
	{
		// 1. Get the expression from the element
		let tmpExpressionElementValue = this.pict.ContentAssignment.readContent(pExpressionElementAddress);

		if (!tmpExpressionElementValue)
		{
			this.pict.log.warn(`No expression found in element at address ${pExpressionElementAddress}; cannot update ${pExpressionScope} solver Ordinal ${pSectionOrdinal} Index ${pSolverIndex}.`);
			return;
		}
		// 2. Go through the enumeration of solvers to find if this expression exists
		let tmpMetacontroller = this.pict.views.PictFormMetacontroller;
		let tmpDynamicState = (
			{
				// TODO: The way the metacontroller pulls in the manifest and bootstraps the description is putting "DEFAULT" into the actual manifest; fix this.
				"Scope": tmpMetacontroller.manifestDescription.Scope,
				"Description": ``,
				"Manifest": tmpMetacontroller.manifest,
				"ManifestDescription": tmpMetacontroller.manifestDescription,
				"AllViews": tmpMetacontroller.filterViews(),
				"SectionViews": [],
				"DynamicInputView": false,
				"Solvers": []
			});

		for (let i = 0; i < tmpDynamicState.AllViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.AllViews[i];
			if (tmpSectionView.isPictSectionForm && (tmpSectionView.Hash == 'PictFormMetacontroller-DynamicInputs'))
			{
				// This is the special Dynamic Input section -- it goes in its own place.
				tmpDynamicState.DynamicInputView = tmpSectionView;
			}
			else if (tmpSectionView.isPictSectionForm)
			{
				tmpDynamicState.SectionViews.push(
					{
						View: tmpSectionView,
						sectionDefinition: tmpSectionView.sectionDefinition,
						Solvers: []
					});
			}
		}

		// Now get the solvers for each section view
		for (let i = 0; i < tmpDynamicState.SectionViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.SectionViews[i].View;
			let tmpSectionViewSolvers = tmpDynamicState.SectionViews[i].Solvers;
			// Find the view representation in the 
			if (tmpSectionView.isPictSectionForm && Array.isArray(tmpSectionView.sectionDefinition.Solvers))
			{
				for (let j = 0; j < tmpSectionView.sectionDefinition.Solvers.length; j++)
				{
					let tmpSolver = tmpSectionView.sectionDefinition.Solvers[j];

					// 3a. Update the expression in the solver definition
					if (pExpressionScope == 'Section' && i == pSectionOrdinal && j == pSolverIndex && tmpSectionView.Hash == pSectionViewHash)
					{
						// This is the solver we are updating
						if (typeof(tmpSolver) === 'string')
						{
							// Simple solver -- just a string
							tmpSectionView.sectionDefinition.Solvers[j] = tmpExpressionElementValue;
						}
						else if (typeof(tmpSolver) === 'object')
						{
							// Complex solver -- update the expression property
							tmpSectionView.sectionDefinition.Solvers[j].Expression = tmpExpressionElementValue;
						}
					}
				}
			}

			// Now get all the Group solvers
			// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
			for (let j = 0; j < tmpSectionView.sectionDefinition.Groups.length; j++)
			{
				let tmpGroup = tmpSectionView.getGroup(j);
				if (`RecordSetSolvers` in tmpGroup)
				{
					for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
					{
						let tmpSolver = tmpGroup.RecordSetSolvers[k];
	
						// 3b. Update the expression in the solver definition
						if (pExpressionScope == 'Group' && i == pSectionOrdinal && j == pSolverIndex && tmpSectionView.Hash == pSectionViewHash)
						{
							// This is the solver we are updating
							if (typeof(tmpSolver) === 'string')
							{
								// Simple solver -- just a string
								tmpSectionView.sectionDefinition.Solvers[j] = tmpExpressionElementValue;
							}
							else if (typeof(tmpSolver) === 'object')
							{
								// Complex solver -- update the expression property
								tmpSectionView.sectionDefinition.Solvers[j].Expression = tmpExpressionElementValue;
							}
						}
					}
				}
			}
		}

		// 4. Write the updated expression to it's representation element, if provided
		if (pExpressionElementRepresentationAddress)
		{
			this.pict.ContentAssignment.assignContent(pExpressionElementRepresentationAddress, tmpExpressionElementValue);
		}
	}

	bootstrapContainer()
	{
		// 3. See if the container for the support view is loaded
		let tmpContainerTest = this.options.DefaultDestinationAddress;

		let tmpContainerElement = this.pict.ContentAssignment.getElement(this.options.DefaultDestinationAddress);
		if (tmpContainerElement.length > 0)
		{
			return true;
		}

		// 4. Render the container for the support view if it isn't loaded
		let tmpContainerRenderableHash = 'Pict-Form-Support-Container';

		// Check if the renderable exists -- if not, create it dynamically
		// This just appends itself to the body once, and creates a simple container for extensions to load into.
		if (!(tmpContainerRenderableHash in this.renderables))
		{
			this.renderables[tmpContainerRenderableHash] = (
				{
					RenderableHash: "Pict-Form-Support-Container",
					TemplateHash: "Pict-Form-Support-Container",
					ContentDestinationAddress: 'body',
					RenderMethod: 'append_once',
					TestAddress: "#Pict-Form-Extensions-Container",
				});
		}

		this.renderables[tmpContainerRenderableHash].TestAddress = tmpContainerTest;
		this.pict.CSSMap.injectCSS();

		this.render(tmpContainerRenderableHash);

		// 5. Make the container draggable
		// Setup the draggable behavior for the window
		let tmpDraggableElement = document.getElementById('Pict-Form-Extensions-Wrap'); // What we are dragging
		let tmpDragInteractiveControl = document.getElementById('Pict-Form-Extension-DragControl'); // The control you click on to drag
		if (tmpDraggableElement && tmpDragInteractiveControl)
		{
			tmpDragInteractiveControl.addEventListener('mousedown',
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				* BEGIN of browser event code block
				*
				* The below code is meant to run in response to a browser event.
				* --> Therefore the "this" context is the element that fired the event.
				* --> Happy trails.
				*/
				function (pEvent)
				{
					let tmpOffsetX = pEvent.offsetX + tmpDragInteractiveControl.clientLeft;
					let tmpOffsetY = pEvent.offsetY + tmpDragInteractiveControl.clientTop;
					function dragHandler(pEvent)
					{
						pEvent.stopPropagation();
						
						tmpDraggableElement.style.left = (pEvent.clientX - tmpOffsetX) + 'px';
						tmpDraggableElement.style.top = (pEvent.clientY - tmpOffsetY) + 'px';
					}
					function dragStop(pEvent)
					{
						window.removeEventListener('pointermove', dragHandler);
						window.removeEventListener('pointerup', dragStop);
					}
					window.addEventListener('pointermove', dragHandler);
					window.addEventListener('pointerup', dragStop);

					// Prevent janky selection behaviors in the browser
					pEvent.preventDefault();
				});
				/*
				* END of browser event code block
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
		}

		// 6. Make the container resizable
		// Setup the draggable behavior for the window
		let tmpResizableElement = document.getElementById('Pict-Form-Extensions-Wrap'); // What we are resizing
		let tmpResizableControl = document.getElementById('Pict-Form-Extension-ResizeControl'); // The control you click on to drag
		if (tmpResizableElement && tmpResizableControl)
		{
			tmpResizableControl.addEventListener('mousedown',
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				* BEGIN of browser event code block
				*
				* The below code is meant to run in response to a browser event.
				* --> Therefore the "this" context is the element that fired the event.
				* --> Happy trails.
				*/
				function (pEvent)
				{
					function dragResizeHandler(pEvent)
					{
						pEvent.stopPropagation();
						
						let tmpNewWidth = pEvent.clientX - tmpResizableElement.getBoundingClientRect().left;
						let tmpNewHeight = pEvent.clientY - tmpResizableElement.getBoundingClientRect().top;

						// Check the CSS for minimum width and height, and set these to those if we go under
						let tmpComputedStyle = getComputedStyle(tmpResizableElement);
						let tmpMinWidth = parseInt(tmpComputedStyle.minWidth, 10);
						let tmpMinHeight = parseInt(tmpComputedStyle.minHeight, 10);

						if (tmpNewWidth < tmpMinWidth)
						{
							tmpNewWidth = tmpMinWidth;
						}
						if (tmpNewHeight < tmpMinHeight)
						{
							tmpNewHeight = tmpMinHeight;
						}
						tmpResizableElement.style.width = tmpNewWidth + 'px';
						tmpResizableElement.style.height = tmpNewHeight + 'px';
					}
					function dragResizeStop(pEvent)
					{
						window.removeEventListener('pointermove', dragResizeHandler);
						window.removeEventListener('pointerup', dragResizeStop);
					}
					window.addEventListener('pointermove', dragResizeHandler);
					window.addEventListener('pointerup', dragResizeStop);

					// Prevent janky selection behaviors in the browser
					pEvent.preventDefault();
				});
				/*
				* END of browser event code block
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
		}

	}
}

module.exports = PictFormsSupportBase;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-Provider-PSF-Support.js":655,"pict-view":733}],662:[function(require,module,exports){
// The container for all the Pict-Section-InlineDocumentation related code.

// The main inline documentation provider (primary API surface)
module.exports = require('./providers/Pict-Provider-InlineDocumentation.js');

// Exported views for advanced usage
module.exports.InlineDocumentationLayoutView = require('./views/Pict-View-InlineDocumentation-Layout.js');
module.exports.InlineDocumentationContentView = require('./views/Pict-View-InlineDocumentation-Content.js');
module.exports.InlineDocumentationNavView = require('./views/Pict-View-InlineDocumentation-Nav.js');
module.exports.InlineDocumentationTopicManagerView = require('./views/Pict-View-InlineDocumentation-TopicManager.js');

},{"./providers/Pict-Provider-InlineDocumentation.js":663,"./views/Pict-View-InlineDocumentation-Content.js":664,"./views/Pict-View-InlineDocumentation-Layout.js":665,"./views/Pict-View-InlineDocumentation-Nav.js":666,"./views/Pict-View-InlineDocumentation-TopicManager.js":667}],663:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;
const libPictSectionModal = require('pict-section-modal');
const libPictSectionMarkdownEditor = require('pict-section-markdowneditor');
const libLunr = require('lunr');

const libViewLayout = require('../views/Pict-View-InlineDocumentation-Layout.js');
const libViewContent = require('../views/Pict-View-InlineDocumentation-Content.js');
const libViewNav = require('../views/Pict-View-InlineDocumentation-Nav.js');
const libViewTopicManager = require('../views/Pict-View-InlineDocumentation-TopicManager.js');

// Image files the reader displays directly (as an <img>) rather than parsing as markdown.
// The server serves each with its real image/* MimeType, so the browser renders it, SVG included.
const _IMAGE_EXTENSIONS = { png: true, jpg: true, jpeg: true, gif: true, svg: true, webp: true, bmp: true, ico: true };

// The extension of a doc path's last segment, lower-cased, or '' when it carries none.
function _pathExtension(pPath)
{
	let tmpMatch = String(pPath || '').match(/\.([a-z0-9]+)$/i);
	return tmpMatch ? tmpMatch[1].toLowerCase() : '';
}

/**
 * Inline Documentation Provider
 *
 * The primary API for embedding a documentation browser in a Pict application.
 * Instantiates all necessary views and sub-providers, manages documentation
 * state, and exposes methods for loading documents and navigating topics.
 */
class InlineDocumentationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({},
			JSON.parse(JSON.stringify(_DefaultConfiguration)),
			pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._ContentCache = {};
		this._ActiveTooltipBindings = [];
		this._tooltipHelpLinkHandler = null;

		// Instantiate the content provider for markdown parsing
		this._ContentProvider = this.pict.addProviderSingleton('Pict-Content', libPictContentProvider.default_configuration, libPictContentProvider);

		// Register views
		this.pict.addViewSingleton('InlineDoc-Layout', libViewLayout.default_configuration, libViewLayout);
		this.pict.addViewSingleton('InlineDoc-Content', libViewContent.default_configuration, libViewContent);
		this.pict.addViewSingleton('InlineDoc-Nav', libViewNav.default_configuration, libViewNav);
		this.pict.addViewSingleton('InlineDoc-TopicManager', libViewTopicManager.default_configuration, libViewTopicManager);

		// Register pict-section-modal if not already present (needed by topic manager)
		if (!this.pict.views['Pict-Section-Modal'])
		{
			this.pict.addViewSingleton('Pict-Section-Modal', libPictSectionModal.default_configuration, libPictSectionModal);
		}

		// Register the markdown editor for edit mode
		let tmpEditorConfig = JSON.parse(JSON.stringify(libPictSectionMarkdownEditor.default_configuration));
		tmpEditorConfig.DefaultDestinationAddress = '#InlineDoc-Editor-Container';
		tmpEditorConfig.TargetElementAddress = '#InlineDoc-Editor-Container';
		tmpEditorConfig.ContentDataAddress = 'AppData.InlineDocumentation.EditorSegments';
		tmpEditorConfig.DefaultPreviewMode = 'off';
		tmpEditorConfig.Renderables =
		[
			{
				RenderableHash: 'MarkdownEditor-Wrap',
				TemplateHash: 'MarkdownEditor-Container',
				ContentDestinationAddress: '#InlineDoc-Editor-Container'
			}
		];
		this.pict.addViewSingleton('InlineDoc-MarkdownEditor', tmpEditorConfig, libPictSectionMarkdownEditor);
	}

	/**
	 * Initialize the inline documentation system.
	 *
	 * Sets up application state, loads sidebar navigation and optionally
	 * topic definitions, then renders the layout.
	 *
	 * @param {Object} [pOptions] - Options: { DocsBaseURL, TopicsURL, ContainerAddress, VocabularyResolver }
	 * @param {Function} [fCallback] - Callback when initialization is complete
	 */
	initializeDocumentation(pOptions, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpOptions = pOptions || {};

		// Initialize application state
		if (!this.pict.AppData.InlineDocumentation)
		{
			this.pict.AppData.InlineDocumentation = {};
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.DocsBaseURL = tmpOptions.DocsBaseURL || tmpState.DocsBaseURL || '';
		tmpState.CurrentPath = '';
		tmpState.CurrentRoute = '';
		tmpState.SidebarGroups = tmpState.SidebarGroups || [];
		tmpState.Topic = null;
		tmpState.Topics = tmpState.Topics || {};
		tmpState.NavigationHistory = [];

		// Navigation outline state
		tmpState.NavCollapsed = true;
		tmpState.CollapsedGroups = {};
		tmpState.ActiveDocumentHeadings = [];
		tmpState.NavFilterText = '';

		// Full-text search state
		tmpState.SearchIndexLoaded = false;
		tmpState.SearchQuery = '';
		tmpState.SearchResults = [];

		// "Show non-document files" preference. The tree lists documents by default; when the
		// host enables the toggle (AssetToggleEnabled), the reader can reveal asset files
		// (images, ...) and the choice is remembered per browser.
		tmpState.AssetToggleEnabled = (tmpOptions.AssetToggleEnabled !== undefined)
			? !!tmpOptions.AssetToggleEnabled
			: (tmpState.AssetToggleEnabled || false);
		tmpState.ShowAssetFiles = this._readShowAssetFilesPref();

		// Whether the tree shows the active document's headings as an in-document outline beneath
		// it. Defaults on; a host that wants a files-only tree passes ShowDocumentHeadings: false.
		tmpState.ShowDocumentHeadings = (tmpOptions.ShowDocumentHeadings !== undefined)
			? !!tmpOptions.ShowDocumentHeadings
			: (tmpState.ShowDocumentHeadings !== false);

		// External link resolution — paths starting with / in the
		// sidebar are cross-module references. ExternalDocBaseURL
		// is prepended to make them full URLs opened in a new tab.
		tmpState.ExternalDocBaseURL = tmpOptions.ExternalDocBaseURL || '';

		// Edit mode state — read from pOptions if provided
		if (tmpOptions.EditEnabled !== undefined)
		{
			tmpState.EditEnabled = !!tmpOptions.EditEnabled;
		}
		else
		{
			tmpState.EditEnabled = tmpState.EditEnabled || false;
		}
		tmpState.Editing = false;
		tmpState.EditingPath = '';
		tmpState.EditingContent = '';
		tmpState.TooltipEditMode = false;

		// Store the onSave callback if provided
		if (typeof tmpOptions.onSave === 'function')
		{
			this._onSave = tmpOptions.onSave;
		}

		// Store the vocabulary resolver if provided. Forwarded as the 4th arg to the content
		// provider's parseMarkdown() at this module's docs-viewer render call sites, so known
		// product terms get wrapped in .pict-vocab-term spans for a hover popover. (pWord) =>
		// { slug, title, short } | null.
		if (typeof tmpOptions.VocabularyResolver === 'function')
		{
			this._VocabularyResolver = tmpOptions.VocabularyResolver;
		}

		// Store the structure-management callbacks if provided. Each is optional and
		// purely additive: the Nav view only shows the matching affordance (New Folder,
		// New Doc, rename/delete, drag reorder/move) when its callback is present, so a
		// host that wires none of them gets exactly today's read-only browser.
		//   onCreateFolder(pParentPath, pName, fCallback)
		//   onCreateDocument(pParentPath, pName, fCallback)
		//   onDeleteNode(pPath, pNodeType, fCallback)
		//   onMoveNode(pFromPath, pToPath, fCallback)   (move into a folder, and rename)
		//   onReorder(pParentPath, pOrderedNames, fCallback)
		if (typeof tmpOptions.onCreateFolder === 'function') { this._onCreateFolder = tmpOptions.onCreateFolder; }
		if (typeof tmpOptions.onCreateDocument === 'function') { this._onCreateDocument = tmpOptions.onCreateDocument; }
		if (typeof tmpOptions.onDeleteNode === 'function') { this._onDeleteNode = tmpOptions.onDeleteNode; }
		if (typeof tmpOptions.onMoveNode === 'function') { this._onMoveNode = tmpOptions.onMoveNode; }
		if (typeof tmpOptions.onReorder === 'function') { this._onReorder = tmpOptions.onReorder; }

		// Store the onTopicsSave callback if provided
		if (typeof tmpOptions.onTopicsSave === 'function')
		{
			this._onTopicsSave = tmpOptions.onTopicsSave;
		}

		// Store the onImageUpload callback if provided
		if (typeof tmpOptions.onImageUpload === 'function')
		{
			this._onImageUpload = tmpOptions.onImageUpload;
			this._wireEditorImageUpload();
		}

		// Topic manager enabled state
		// If explicitly set, use that; otherwise track EditEnabled
		if (tmpOptions.TopicManagerEnabled !== undefined)
		{
			tmpState.TopicManagerEnabled = !!tmpOptions.TopicManagerEnabled;
			this._topicManagerExplicitlySet = true;
		}
		else
		{
			tmpState.TopicManagerEnabled = tmpState.EditEnabled || false;
			this._topicManagerExplicitlySet = false;
		}

		// Optionally override the layout container address
		if (tmpOptions.ContainerAddress)
		{
			let tmpLayoutView = this.pict.views['InlineDoc-Layout'];
			if (tmpLayoutView && tmpLayoutView.options && tmpLayoutView.options.Renderables)
			{
				for (let i = 0; i < tmpLayoutView.options.Renderables.length; i++)
				{
					tmpLayoutView.options.Renderables[i].ContentDestinationAddress = tmpOptions.ContainerAddress;
				}
			}
		}

		// Load sidebar, topics, and search index in parallel
		let tmpPending = 2;
		if (tmpOptions.SearchIndexURL) tmpPending++;

		let tmpSelf = this;
		let tmpFinish = () =>
		{
			tmpPending--;
			if (tmpPending <= 0)
			{
				// Mark sidebar items as external based on ExternalDocBaseURL
				tmpSelf._markExternalSidebarItems();

				// Render the layout (which contains nav and content containers)
				tmpSelf.pict.views['InlineDoc-Layout'].render();
				// Render the navigation
				tmpSelf.pict.views['InlineDoc-Nav'].render();

				return tmpCallback();
			}
		};

		this._loadSidebar(tmpFinish);
		this._loadTopics(tmpOptions.TopicsURL, tmpFinish);

		if (tmpOptions.SearchIndexURL)
		{
			this._loadSearchIndex(tmpOptions.SearchIndexURL, tmpFinish);
		}
	}

	/**
	 * Load and display a markdown document.
	 *
	 * Fetches the document relative to DocsBaseURL, parses it to HTML via
	 * pict-section-content, and displays it in the content view.
	 *
	 * @param {string} pPath - Relative document path (e.g. 'getting-started.md')
	 * @param {Function} [fCallback] - Callback receiving (error, htmlContent)
	 */
	loadDocument(pPath, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};

		if (!pPath)
		{
			return tmpCallback('No document path provided');
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpContentView = this.pict.views['InlineDoc-Content'];

		// Parse anchor from path (e.g. 'page.md#section-heading')
		let tmpAnchor = '';
		let tmpPath = pPath;
		let tmpHashIndex = tmpPath.indexOf('#');
		if (tmpHashIndex >= 0)
		{
			tmpAnchor = tmpPath.substring(tmpHashIndex + 1);
			tmpPath = tmpPath.substring(0, tmpHashIndex);
		}

		// Only add .md when the path carries no extension of its own. A path that already
		// names a file type (README.md, guides/layer-model.svg, ...) is served as-is, so an
		// image is not turned into a 404 by an appended .md.
		let tmpExtension = _pathExtension(tmpPath);
		if (!tmpExtension)
		{
			tmpPath = tmpPath + '.md';
			tmpExtension = 'md';
		}

		// Update state
		tmpState.CurrentPath = tmpPath;
		tmpState.NavigationHistory.push(tmpPath);

		// Render the content view template (creates the container element)
		tmpContentView.render();

		let tmpURL = (tmpState.DocsBaseURL || '') + tmpPath;

		// An image is displayed directly (the server serves its image/* bytes) — there is no
		// markdown to parse, so show it in an image viewer instead of fetching + parsing.
		if (_IMAGE_EXTENSIONS[tmpExtension])
		{
			tmpContentView.displayContent(this._buildImageViewerHTML(tmpURL, tmpPath));
			tmpState.NavCollapsed = true;
			tmpState.NavFilterText = '';
			tmpState.SearchQuery = '';
			tmpState.SearchResults = [];
			this.pict.views['InlineDoc-Nav'].render();
			return tmpCallback(null, '');
		}

		// Show loading indicator
		tmpContentView.showLoading();

		// Fetch the document
		this._fetchDocument(tmpURL, (pError, pHTML) =>
		{
			if (pError)
			{
				tmpContentView.displayContent(this._getErrorPageHTML(tmpPath));
				return tmpCallback(pError);
			}

			tmpContentView.displayContent(pHTML);

			// Scroll to anchor if specified
			if (tmpAnchor)
			{
				this._scrollToAnchor(tmpAnchor);
			}

			// Collapse the nav outline and clear search/filter
			tmpState.NavCollapsed = true;
			tmpState.NavFilterText = '';
			tmpState.SearchQuery = '';
			tmpState.SearchResults = [];
			this.pict.views['InlineDoc-Nav'].render();

			return tmpCallback(null, pHTML);
		});
	}

	/**
	 * The content-area HTML for viewing an image document: the image itself (the server serves
	 * its bytes with the right image/* type, so SVG renders too), captioned with its path and a
	 * link to open the raw file in a new tab.
	 *
	 * @param {string} pURL - The image's source URL (DocsBaseURL + path)
	 * @param {string} pPath - The lake path (for the caption / filename)
	 * @returns {string} HTML string for displayContent
	 */
	_buildImageViewerHTML(pURL, pPath)
	{
		let fEscape = (pText) => String(pText == null ? '' : pText)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		let tmpName = String(pPath || '').slice(String(pPath || '').lastIndexOf('/') + 1);
		return '<div class="pict-inline-doc-image-view">'
			+ '<img class="pict-inline-doc-image" src="' + fEscape(pURL) + '" alt="' + fEscape(tmpName) + '" />'
			+ '<div class="pict-inline-doc-image-caption">'
			+ '<span class="pict-inline-doc-image-name">' + fEscape(pPath) + '</span>'
			+ '<a class="pict-inline-doc-image-open" href="' + fEscape(pURL) + '" target="_blank" rel="noopener">Open original</a>'
			+ '</div></div>';
	}

	/**
	 * Set the active topic, filtering navigation to that topic's documents.
	 *
	 * @param {string} pTopicKey - The topic key (TopicCode from pict_documentation_topics.json)
	 */
	setTopic(pTopicKey)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicKey || !tmpState.Topics || !tmpState.Topics[pTopicKey])
		{
			this.log.warn(`InlineDocumentation: Topic [${pTopicKey}] not found.`);
			return;
		}

		tmpState.Topic = pTopicKey;

		// Re-render navigation with topic filter
		this.pict.views['InlineDoc-Nav'].render();
	}

	/**
	 * Load and display a topic's help document by TopicCode.
	 *
	 * Looks up the topic in the pict_documentation_topics.json format,
	 * sets it as active, and loads its TopicHelpFilePath.
	 *
	 * @param {string} pTopicCode - The TopicCode (e.g. 'BOOKSHOP-BOOKLIST')
	 * @param {Function} [fCallback] - Callback receiving (error, htmlContent)
	 */
	loadTopicDocument(pTopicCode, fCallback)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			this.log.warn(`InlineDocumentation: Topic [${pTopicCode}] not found.`);
			if (typeof fCallback === 'function')
			{
				return fCallback('Topic not found');
			}
			return;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];
		tmpState.Topic = pTopicCode;

		// Re-render navigation
		this.pict.views['InlineDoc-Nav'].render();

		// Load the topic's help file
		let tmpPath = tmpTopic.TopicHelpFilePath || '';
		if (tmpPath)
		{
			this.loadDocument(tmpPath, fCallback);
		}
	}

	/**
	 * Clear the active topic, showing full navigation.
	 */
	clearTopic()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.Topic = null;

		// Re-render navigation without filter
		this.pict.views['InlineDoc-Nav'].render();
	}

	/**
	 * Add a new topic definition at runtime.
	 *
	 * @param {string} pTopicCode - Unique topic code
	 * @param {Object} pTopicDefinition - Topic object: { TopicCode, TopicHelpFilePath, TopicTitle, Routes }
	 */
	addTopic(pTopicCode, pTopicDefinition)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode)
		{
			this.log.warn('InlineDocumentation: addTopic requires a TopicCode.');
			return;
		}

		if (!tmpState.Topics)
		{
			tmpState.Topics = {};
		}

		let tmpDefinition = Object.assign({ TopicCode: pTopicCode }, pTopicDefinition || {});
		tmpState.Topics[pTopicCode] = tmpDefinition;
	}

	/**
	 * Add a route pattern to an existing topic.
	 *
	 * @param {string} pTopicCode - The topic to add the route to
	 * @param {string} pRoutePattern - Route pattern (e.g. '/settings', '/admin/*')
	 */
	addRouteToTopic(pTopicCode, pRoutePattern)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			this.log.warn(`InlineDocumentation: Topic [${pTopicCode}] not found for addRouteToTopic.`);
			return;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];

		if (!tmpTopic.Routes)
		{
			tmpTopic.Routes = [];
		}

		if (tmpTopic.Routes.indexOf(pRoutePattern) < 0)
		{
			tmpTopic.Routes.push(pRoutePattern);
		}
	}

	/**
	 * Get a list of all topics in a UI-friendly array format.
	 *
	 * @returns {Array} Array of { TopicCode, TopicTitle, TopicHelpFilePath, RouteCount }
	 */
	getTopicList()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpResult = [];

		if (!tmpState || !tmpState.Topics)
		{
			return tmpResult;
		}

		let tmpTopicCodes = Object.keys(tmpState.Topics);

		for (let i = 0; i < tmpTopicCodes.length; i++)
		{
			let tmpTopic = tmpState.Topics[tmpTopicCodes[i]];
			tmpResult.push(
			{
				TopicCode: tmpTopicCodes[i],
				TopicTitle: tmpTopic.TopicTitle || tmpTopic.Name || tmpTopicCodes[i],
				TopicHelpFilePath: tmpTopic.TopicHelpFilePath || '',
				RouteCount: (tmpTopic.Routes && Array.isArray(tmpTopic.Routes)) ? tmpTopic.Routes.length : 0
			});
		}

		return tmpResult;
	}

	/**
	 * Update an existing topic definition.
	 *
	 * Merges only the properties present in pUpdates into the topic.
	 *
	 * @param {string} pTopicCode - The topic to update
	 * @param {Object} pUpdates - Properties to merge: { TopicTitle, TopicHelpFilePath, Routes }
	 * @returns {boolean} True if updated, false if topic not found
	 */
	updateTopic(pTopicCode, pUpdates)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			return false;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];
		let tmpUpdates = pUpdates || {};

		if (tmpUpdates.hasOwnProperty('TopicTitle'))
		{
			tmpTopic.TopicTitle = tmpUpdates.TopicTitle;
		}
		if (tmpUpdates.hasOwnProperty('TopicHelpFilePath'))
		{
			tmpTopic.TopicHelpFilePath = tmpUpdates.TopicHelpFilePath;
		}
		if (tmpUpdates.hasOwnProperty('Routes'))
		{
			tmpTopic.Routes = tmpUpdates.Routes;
		}

		return true;
	}

	/**
	 * Remove a topic definition.
	 *
	 * If the removed topic is the currently active topic, clears it.
	 *
	 * @param {string} pTopicCode - The topic to remove
	 * @returns {boolean} True if removed, false if topic not found
	 */
	removeTopic(pTopicCode)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			return false;
		}

		delete tmpState.Topics[pTopicCode];

		// Clear active topic if it was the one removed
		if (tmpState.Topic === pTopicCode)
		{
			tmpState.Topic = null;
		}

		return true;
	}

	/**
	 * Remove a specific route pattern from a topic.
	 *
	 * @param {string} pTopicCode - The topic to modify
	 * @param {string} pRoutePattern - The route pattern to remove
	 * @returns {boolean} True if removed, false if not found
	 */
	removeRouteFromTopic(pTopicCode, pRoutePattern)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTopicCode || !tmpState.Topics || !tmpState.Topics[pTopicCode])
		{
			return false;
		}

		let tmpTopic = tmpState.Topics[pTopicCode];

		if (!tmpTopic.Routes || !Array.isArray(tmpTopic.Routes))
		{
			return false;
		}

		let tmpIndex = tmpTopic.Routes.indexOf(pRoutePattern);

		if (tmpIndex < 0)
		{
			return false;
		}

		tmpTopic.Routes.splice(tmpIndex, 1);
		return true;
	}

	/**
	 * Persist the current topics via the onTopicsSave callback.
	 *
	 * If no onTopicsSave handler was provided, succeeds locally.
	 *
	 * @param {Function} [fCallback] - Callback receiving (error)
	 */
	saveTopics(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (typeof this._onTopicsSave === 'function')
		{
			this._onTopicsSave(tmpState.Topics, (pError) =>
			{
				if (pError)
				{
					this.log.warn(`InlineDocumentation: Topics save failed: ${pError}`);
					return tmpCallback(pError);
				}
				return tmpCallback(null);
			});
		}
		else
		{
			// No save handler — succeed locally
			return tmpCallback(null);
		}
	}

	/**
	 * Enable or disable the topic manager UI.
	 *
	 * When enabled, management buttons appear in the navigation toolbar.
	 *
	 * @param {boolean} pEnabled - Whether topic management is available
	 */
	setTopicManagerEnabled(pEnabled)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.TopicManagerEnabled = !!pEnabled;

		// Re-render navigation to show/hide management buttons
		let tmpNavView = this.pict.views['InlineDoc-Nav'];
		if (tmpNavView)
		{
			tmpNavView.render();
		}
	}

	// -- Wildcard builder helpers --

	/**
	 * Split a route into segments with wildcard pattern options.
	 *
	 * For a route like '/books/detail/5', returns:
	 * [
	 *   { Segment: 'books',  Path: '/books',         WildcardPattern: '/books/*',         Index: 0 },
	 *   { Segment: 'detail', Path: '/books/detail',   WildcardPattern: '/books/detail/*',   Index: 1 },
	 *   { Segment: '5',      Path: '/books/detail/5', WildcardPattern: '/books/detail/5/*', Index: 2 }
	 * ]
	 *
	 * @param {string} pRoute - The route to split
	 * @returns {Array} Array of segment objects
	 */
	getRouteSegments(pRoute)
	{
		if (!pRoute || typeof pRoute !== 'string')
		{
			return [];
		}

		// Strip leading slash and split
		let tmpClean = pRoute.replace(/^\//, '');
		if (!tmpClean)
		{
			return [];
		}

		let tmpParts = tmpClean.split('/');
		let tmpSegments = [];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPath = '/' + tmpParts.slice(0, i + 1).join('/');
			tmpSegments.push(
			{
				Segment: tmpParts[i],
				Path: tmpPath,
				WildcardPattern: tmpPath + '/*',
				Index: i
			});
		}

		return tmpSegments;
	}

	/**
	 * Build a wildcard pattern from a route at a given segment index.
	 *
	 * The wildcard replaces everything after the segment at pSegmentIndex.
	 * For '/books/detail/5' with index 1, returns '/books/detail/*'.
	 *
	 * @param {string} pRoute - The route
	 * @param {number} pSegmentIndex - The segment index (0-based) where the wildcard starts after
	 * @returns {string} The wildcard pattern, or empty string if invalid
	 */
	buildWildcardPattern(pRoute, pSegmentIndex)
	{
		let tmpSegments = this.getRouteSegments(pRoute);

		if (tmpSegments.length < 1 || pSegmentIndex < 0 || pSegmentIndex >= tmpSegments.length)
		{
			return '';
		}

		return tmpSegments[pSegmentIndex].WildcardPattern;
	}

	/**
	 * Get all topics whose Routes match a given route.
	 *
	 * Unlike resolveHelpForRoute (which returns only the best match),
	 * this returns all matching topic codes — useful when multiple
	 * documents are relevant to the same route.
	 *
	 * @param {string} pRoute - The application route
	 * @returns {Array} Array of { TopicCode, Pattern, MatchLength } objects, sorted by match length descending
	 */
	getTopicsForRoute(pRoute)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpMatches = [];

		if (!pRoute || !tmpState.Topics)
		{
			return tmpMatches;
		}

		let tmpTopicCodes = Object.keys(tmpState.Topics);

		for (let i = 0; i < tmpTopicCodes.length; i++)
		{
			let tmpTopic = tmpState.Topics[tmpTopicCodes[i]];

			if (!tmpTopic.Routes || !Array.isArray(tmpTopic.Routes))
			{
				continue;
			}

			for (let j = 0; j < tmpTopic.Routes.length; j++)
			{
				let tmpPattern = tmpTopic.Routes[j];

				if (!tmpPattern)
				{
					continue;
				}

				let tmpMatchLength = 0;
				let tmpIsMatch = false;

				if (tmpPattern.endsWith('/*'))
				{
					let tmpPrefix = tmpPattern.slice(0, -2);
					if (pRoute === tmpPrefix || pRoute.indexOf(tmpPrefix + '/') === 0)
					{
						tmpIsMatch = true;
						tmpMatchLength = tmpPrefix.length;
					}
				}
				else
				{
					if (pRoute === tmpPattern)
					{
						tmpIsMatch = true;
						tmpMatchLength = tmpPattern.length;
					}
				}

				if (tmpIsMatch)
				{
					tmpMatches.push({ TopicCode: tmpTopicCodes[i], Pattern: tmpPattern, MatchLength: tmpMatchLength });
				}
			}
		}

		// Sort by match length descending (best match first)
		tmpMatches.sort((a, b) => b.MatchLength - a.MatchLength);

		return tmpMatches;
	}

	/**
	 * Change the documentation base URL.
	 *
	 * @param {string} pURL - The new base URL
	 */
	setDocsBaseURL(pURL)
	{
		if (!this.pict.AppData.InlineDocumentation)
		{
			this.pict.AppData.InlineDocumentation = {};
		}
		this.pict.AppData.InlineDocumentation.DocsBaseURL = pURL || '';
		// Clear cache when base URL changes
		this._ContentCache = {};
	}

	/**
	 * Get the navigation history.
	 *
	 * @returns {Array} Array of visited document paths
	 */
	getNavigationHistory()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		return (tmpState && tmpState.NavigationHistory) ? tmpState.NavigationHistory : [];
	}

	/**
	 * Navigate back to the previous document.
	 *
	 * @param {Function} [fCallback] - Callback when navigation is complete
	 */
	navigateBack(fCallback)
	{
		let tmpHistory = this.getNavigationHistory();

		if (tmpHistory.length < 2)
		{
			return;
		}

		// Remove current page
		tmpHistory.pop();
		// Get previous page
		let tmpPreviousPath = tmpHistory.pop();

		this.loadDocument(tmpPreviousPath, fCallback);
	}

	// -- Edit mode --

	/**
	 * Enable or disable edit permissions.
	 *
	 * When enabled, a pencil icon appears in the content area allowing
	 * the user to toggle into edit mode.
	 *
	 * @param {boolean} pEnabled - Whether edit mode is available
	 */
	setEditEnabled(pEnabled)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.EditEnabled = !!pEnabled;

		// If TopicManagerEnabled was not explicitly configured, mirror EditEnabled
		if (!this._topicManagerExplicitlySet)
		{
			tmpState.TopicManagerEnabled = !!pEnabled;

			// Re-render navigation to show/hide management buttons
			let tmpNavView = this.pict.views['InlineDoc-Nav'];
			if (tmpNavView)
			{
				tmpNavView.render();
			}
		}

		// Re-render content view to show/hide edit toolbar
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView)
		{
			tmpContentView.renderEditToolbar();
		}
	}

	/**
	 * Toggle between view and edit mode.
	 */
	toggleEdit()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (tmpState.Editing)
		{
			this.cancelEdit();
		}
		else
		{
			this.beginEdit();
		}
	}

	/**
	 * Enter edit mode for the current document.
	 *
	 * Retrieves the raw markdown from cache and displays it in the markdown editor.
	 */
	beginEdit()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpState.EditEnabled || !tmpState.CurrentPath)
		{
			return;
		}

		// Get the raw markdown from cache
		let tmpURL = (tmpState.DocsBaseURL || '') + tmpState.CurrentPath;
		let tmpCacheEntry = this._ContentCache[tmpURL];
		let tmpMarkdown = (tmpCacheEntry && tmpCacheEntry.markdown) ? tmpCacheEntry.markdown : '';

		tmpState.Editing = true;
		tmpState.EditingPath = tmpState.CurrentPath;
		tmpState.EditingContent = tmpMarkdown;

		// Show the editor
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView)
		{
			tmpContentView.showEditor(tmpMarkdown);
		}
	}

	/**
	 * Cancel editing and restore the rendered view.
	 */
	cancelEdit()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		tmpState.Editing = false;
		tmpState.EditingPath = '';
		tmpState.EditingContent = '';
		tmpState.EditorSegments = [];

		// Restore the rendered content
		let tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView)
		{
			tmpContentView.hideEditor();

			// Re-display the cached HTML
			let tmpURL = (tmpState.DocsBaseURL || '') + tmpState.CurrentPath;
			let tmpCacheEntry = this._ContentCache[tmpURL];
			if (tmpCacheEntry && tmpCacheEntry.html)
			{
				tmpContentView.displayContent(tmpCacheEntry.html);
			}
		}
	}

	/**
	 * Save the current edits.
	 *
	 * Reads the markdown editor content, calls the onSave callback provided by the
	 * host app, re-parses the markdown, and returns to view mode.
	 *
	 * @param {Function} [fCallback] - Callback receiving (error)
	 */
	saveEdit(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpContentView = this.pict.views['InlineDoc-Content'];

		if (!tmpState.Editing)
		{
			return tmpCallback('Not in edit mode');
		}

		// Read content from the markdown editor
		// First marshal editor state to data, then read from the data address
		let tmpMarkdown = '';
		let tmpEditorView = this.pict.views['InlineDoc-MarkdownEditor'];
		if (tmpEditorView && typeof tmpEditorView.marshalFromView === 'function')
		{
			tmpEditorView.marshalFromView();
		}
		if (tmpState.EditorSegments && tmpState.EditorSegments.length > 0)
		{
			tmpMarkdown = tmpState.EditorSegments[0].Content || '';
		}

		let tmpPath = tmpState.EditingPath;
		let tmpURL = (tmpState.DocsBaseURL || '') + tmpPath;

		let tmpSaveData = { Path: tmpPath, Content: tmpMarkdown };

		let tmpFinishSave = () =>
		{
			// Re-parse the markdown and update cache
			let tmpHTML = this._ContentProvider.parseMarkdown(
				tmpMarkdown,
				this._createLinkResolver(),
				this._createImageResolver(tmpURL),
				this._VocabularyResolver);
			this._ContentCache[tmpURL] = { html: tmpHTML, markdown: tmpMarkdown };

			// Exit edit mode
			tmpState.Editing = false;
			tmpState.EditingPath = '';
			tmpState.EditingContent = '';
			tmpState.EditorSegments = [];

			// Display the updated content
			if (tmpContentView)
			{
				tmpContentView.hideEditor();
				tmpContentView.displayContent(tmpHTML);
			}

			return tmpCallback(null);
		};

		// Call the onSave callback if provided
		if (typeof this._onSave === 'function')
		{
			this._onSave(tmpSaveData, (pError) =>
			{
				if (pError)
				{
					this.log.warn(`InlineDocumentation: Save failed: ${pError}`);
					return tmpCallback(pError);
				}
				tmpFinishSave();
			});
		}
		else
		{
			// No save handler — just update locally
			tmpFinishSave();
		}
	}

	// -- Route-based help --

	/**
	 * Find the best-matching topic for a given route.
	 *
	 * Iterates all topics looking for ones with a Routes array. Supports
	 * exact match and wildcard suffix (e.g. "/books/store/*" matches
	 * "/books/store/123"). Returns the TopicCode with the longest matching
	 * route pattern, or null if no match.
	 *
	 * @param {string} pRoute - The application route (e.g. '/books/store/5')
	 * @returns {string|null} The TopicCode of the best match, or null
	 */
	resolveHelpForRoute(pRoute)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pRoute || !tmpState.Topics)
		{
			return null;
		}

		let tmpBestMatch = null;
		let tmpBestLength = -1;

		let tmpTopicCodes = Object.keys(tmpState.Topics);

		for (let i = 0; i < tmpTopicCodes.length; i++)
		{
			let tmpTopic = tmpState.Topics[tmpTopicCodes[i]];

			if (!tmpTopic.Routes || !Array.isArray(tmpTopic.Routes))
			{
				continue;
			}

			for (let j = 0; j < tmpTopic.Routes.length; j++)
			{
				let tmpPattern = tmpTopic.Routes[j];

				if (!tmpPattern)
				{
					continue;
				}

				let tmpMatches = false;
				let tmpMatchLength = 0;

				if (tmpPattern.endsWith('/*'))
				{
					// Wildcard suffix — match if route starts with prefix
					let tmpPrefix = tmpPattern.slice(0, -2);
					if (pRoute === tmpPrefix || pRoute.indexOf(tmpPrefix + '/') === 0)
					{
						tmpMatches = true;
						tmpMatchLength = tmpPrefix.length;
					}
				}
				else
				{
					// Exact match
					if (pRoute === tmpPattern)
					{
						tmpMatches = true;
						tmpMatchLength = tmpPattern.length;
					}
				}

				if (tmpMatches && tmpMatchLength > tmpBestLength)
				{
					tmpBestMatch = tmpTopicCodes[i];
					tmpBestLength = tmpMatchLength;
				}
			}
		}

		return tmpBestMatch;
	}

	/**
	 * Navigate help to the topic matching a given route.
	 *
	 * Convenience method: resolves the route to a topic, then loads it.
	 * If no topic matches, does nothing.
	 *
	 * @param {string} pRoute - The application route
	 * @param {Function} [fCallback] - Callback receiving (error, htmlContent)
	 * @returns {boolean} True if a matching topic was found
	 */
	navigateToRoute(pRoute, fCallback)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.CurrentRoute = pRoute || '';

		let tmpTopicCode = this.resolveHelpForRoute(pRoute);

		if (tmpTopicCode)
		{
			this.loadTopicDocument(tmpTopicCode, fCallback);
			return true;
		}

		return false;
	}

	// -- Tooltip placeholders --

	/**
	 * Enable or disable tooltip edit mode.
	 *
	 * When enabled, all tooltip placeholders are visible and clickable
	 * for content editors to author tooltip content. When disabled,
	 * only placeholders with content show tooltips on hover.
	 *
	 * Automatically re-scans tooltips after toggling.
	 *
	 * @param {boolean} pEnabled - Whether tooltip edit mode is active
	 */
	setTooltipEditMode(pEnabled)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpState)
		{
			return;
		}

		tmpState.TooltipEditMode = !!pEnabled;
		this.scanTooltips();
	}

	/**
	 * Get the tooltip content for a key from the active topic.
	 *
	 * Looks up the currently active topic's Tooltips hash for the
	 * given key and returns the Content string, or null if not found.
	 *
	 * @param {string} pTooltipKey - The tooltip key (from data-d-tooltip attribute)
	 * @returns {string|null} The tooltip content, or null
	 */
	getTooltipContent(pTooltipKey)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTooltipKey || !tmpState || !tmpState.Topic || !tmpState.Topics)
		{
			return null;
		}

		let tmpTopic = tmpState.Topics[tmpState.Topic];

		if (!tmpTopic || !tmpTopic.Tooltips || !tmpTopic.Tooltips[pTooltipKey])
		{
			return null;
		}

		return tmpTopic.Tooltips[pTooltipKey].Content || null;
	}

	/**
	 * Set tooltip content for a key on the active topic.
	 *
	 * Lazily creates the Tooltips hash on the topic if needed.
	 * Passing null or empty string removes the tooltip entry.
	 *
	 * @param {string} pTooltipKey - The tooltip key
	 * @param {string|null} pContent - The markdown content, or null to remove
	 * @returns {boolean} True if set, false if no active topic
	 */
	setTooltipContent(pTooltipKey, pContent)
	{
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!pTooltipKey || !tmpState || !tmpState.Topic || !tmpState.Topics)
		{
			return false;
		}

		let tmpTopic = tmpState.Topics[tmpState.Topic];

		if (!tmpTopic)
		{
			return false;
		}

		if (!pContent)
		{
			// Remove the entry
			if (tmpTopic.Tooltips && tmpTopic.Tooltips[pTooltipKey])
			{
				delete tmpTopic.Tooltips[pTooltipKey];
			}
			return true;
		}

		// Lazily create Tooltips hash
		if (!tmpTopic.Tooltips)
		{
			tmpTopic.Tooltips = {};
		}

		tmpTopic.Tooltips[pTooltipKey] = { Content: pContent };
		return true;
	}

	/**
	 * Remove all active tooltip bindings from the DOM.
	 *
	 * Destroys tooltip handles, removes click listeners, removes
	 * injected icons, and restores original element state.
	 */
	clearTooltipBindings()
	{
		for (let i = 0; i < this._ActiveTooltipBindings.length; i++)
		{
			let tmpBinding = this._ActiveTooltipBindings[i];

			// Destroy the modal tooltip handle
			if (tmpBinding.TooltipHandle && typeof tmpBinding.TooltipHandle.destroy === 'function')
			{
				tmpBinding.TooltipHandle.destroy();
			}

			// Remove click handler
			if (tmpBinding.ClickHandler && tmpBinding.Element)
			{
				tmpBinding.Element.removeEventListener('click', tmpBinding.ClickHandler);
			}

			// Remove injected icon
			if (tmpBinding.InjectedIcon && tmpBinding.InjectedIcon.parentNode)
			{
				tmpBinding.InjectedIcon.parentNode.removeChild(tmpBinding.InjectedIcon);
			}

			// Remove edit-mode CSS classes
			if (tmpBinding.Element)
			{
				tmpBinding.Element.classList.remove(
					'pict-inline-doc-tooltip-edit-target',
					'pict-inline-doc-tooltip-empty');
			}

			// Restore original display for hidden icon spans
			if (tmpBinding.OriginalDisplay !== undefined && tmpBinding.Element)
			{
				tmpBinding.Element.style.display = tmpBinding.OriginalDisplay;
			}
		}

		this._ActiveTooltipBindings = [];

		// Remove document-level help link handler
		if (this._tooltipHelpLinkHandler && typeof document !== 'undefined')
		{
			document.removeEventListener('click', this._tooltipHelpLinkHandler);
			this._tooltipHelpLinkHandler = null;
		}
	}

	/**
	 * Scan the document for tooltip placeholder elements and wire them up.
	 *
	 * Finds all elements with data-d-tooltip attributes and:
	 * - In normal mode: attaches hover tooltips for those with content
	 * - In edit mode: adds visual indicators and click-to-edit handlers
	 *
	 * Call this after your application views render.
	 */
	scanTooltips()
	{
		this.clearTooltipBindings();

		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpState)
		{
			return;
		}

		let tmpModal = this.pict.views['Pict-Section-Modal'];
		let tmpElements = document.querySelectorAll('[data-d-tooltip]');
		let tmpEditMode = tmpState.TooltipEditMode || false;

		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpKey = tmpElement.getAttribute('data-d-tooltip');

			if (!tmpKey)
			{
				continue;
			}

			let tmpContent = this.getTooltipContent(tmpKey);
			let tmpIsIcon = tmpElement.hasAttribute('data-d-tooltip-icon');

			let tmpBinding =
			{
				Element: tmpElement,
				Key: tmpKey,
				Type: tmpIsIcon ? 'icon' : 'attribute',
				TooltipHandle: null,
				ClickHandler: null,
				InjectedIcon: null,
				OriginalDisplay: undefined
			};

			if (tmpEditMode)
			{
				this._wireTooltipEditMode(tmpElement, tmpKey, tmpContent, tmpIsIcon, tmpBinding, tmpModal);
			}
			else
			{
				this._wireTooltipNormalMode(tmpElement, tmpKey, tmpContent, tmpIsIcon, tmpBinding, tmpModal);
			}

			this._ActiveTooltipBindings.push(tmpBinding);
		}

		// Install document-level click delegation for help: links in tooltips
		this._installTooltipHelpLinkHandler();
	}

	/**
	 * Install a document-level click handler for help links inside tooltips.
	 *
	 * Tooltip elements are created/destroyed dynamically by the modal system,
	 * so we use event delegation on the document to catch clicks on
	 * [rel^="pict-inline-doc-help:"] links wherever they appear.
	 */
	_installTooltipHelpLinkHandler()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		// Remove existing handler if any
		if (this._tooltipHelpLinkHandler)
		{
			document.removeEventListener('click', this._tooltipHelpLinkHandler);
		}

		let tmpSelf = this;

		this._tooltipHelpLinkHandler = (pEvent) =>
		{
			let tmpTarget = pEvent.target;

			// Walk up to find the link element
			while (tmpTarget && tmpTarget !== document)
			{
				if (tmpTarget.tagName === 'A' && tmpTarget.getAttribute('rel') && tmpTarget.getAttribute('rel').indexOf('pict-inline-doc-help:') === 0)
				{
					pEvent.preventDefault();
					pEvent.stopPropagation();

					let tmpPath = tmpTarget.getAttribute('rel').replace('pict-inline-doc-help:', '');
					tmpSelf.loadDocument(tmpPath);
					return;
				}
				tmpTarget = tmpTarget.parentNode;
			}
		};

		document.addEventListener('click', this._tooltipHelpLinkHandler);
	}

	/**
	 * Wire a tooltip element for normal (non-edit) mode.
	 *
	 * @param {HTMLElement} pElement - The placeholder element
	 * @param {string} pKey - The tooltip key
	 * @param {string|null} pContent - The tooltip content (or null)
	 * @param {boolean} pIsIcon - Whether this is an icon-type placeholder
	 * @param {Object} pBinding - The binding tracking object
	 * @param {Object} pModal - The modal view instance
	 */
	_wireTooltipNormalMode(pElement, pKey, pContent, pIsIcon, pBinding, pModal)
	{
		if (pIsIcon)
		{
			if (pContent)
			{
				// Inject an icon and attach tooltip
				let tmpIcon = this._createTooltipIcon(pElement);
				pBinding.InjectedIcon = tmpIcon;

				if (pModal && pModal.richTooltip)
				{
					let tmpHTML = this._ContentProvider.parseMarkdown(pContent, this._createTooltipLinkResolver());
					pBinding.TooltipHandle = pModal.richTooltip(pElement, tmpHTML, { interactive: true, maxWidth: '350px' });
				}
			}
			else
			{
				// No content — hide the span
				pBinding.OriginalDisplay = pElement.style.display;
				pElement.style.display = 'none';
			}
		}
		else
		{
			// Attribute tooltip
			if (pContent && pModal && pModal.richTooltip)
			{
				let tmpHTML = this._ContentProvider.parseMarkdown(pContent, this._createTooltipLinkResolver());
				pBinding.TooltipHandle = pModal.richTooltip(pElement, tmpHTML, { interactive: true, maxWidth: '350px' });
			}
			// No content = do nothing, element stays as-is
		}
	}

	/**
	 * Wire a tooltip element for edit mode.
	 *
	 * @param {HTMLElement} pElement - The placeholder element
	 * @param {string} pKey - The tooltip key
	 * @param {string|null} pContent - The tooltip content (or null)
	 * @param {boolean} pIsIcon - Whether this is an icon-type placeholder
	 * @param {Object} pBinding - The binding tracking object
	 * @param {Object} pModal - The modal view instance
	 */
	_wireTooltipEditMode(pElement, pKey, pContent, pIsIcon, pBinding, pModal)
	{
		// Add edit-mode indicator class
		pElement.classList.add('pict-inline-doc-tooltip-edit-target');

		if (pIsIcon)
		{
			// Always show icon in edit mode
			let tmpIcon = this._createTooltipIcon(pElement);
			pBinding.InjectedIcon = tmpIcon;

			if (!pContent)
			{
				pElement.classList.add('pict-inline-doc-tooltip-empty');
			}
		}

		// Click handler to open editor
		let tmpSelf = this;
		let tmpClickHandler = (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			tmpSelf._showTooltipEditor(pKey);
		};

		pElement.addEventListener('click', tmpClickHandler);
		pBinding.ClickHandler = tmpClickHandler;
	}

	/**
	 * Create and inject a tooltip icon element into a span.
	 *
	 * @param {HTMLElement} pElement - The span element to inject into
	 * @returns {HTMLElement} The created icon element
	 */
	_createTooltipIcon(pElement)
	{
		let tmpIcon = document.createElement('span');
		tmpIcon.className = 'pict-inline-doc-tooltip-icon';

		// Check for custom icon class
		let tmpCustomClass = pElement.getAttribute('data-d-tooltip-icon');
		if (tmpCustomClass && tmpCustomClass !== '')
		{
			tmpIcon.className += ' ' + tmpCustomClass;
		}
		else
		{
			tmpIcon.innerHTML = '&#x2753;';
		}

		pElement.appendChild(tmpIcon);
		return tmpIcon;
	}

	/**
	 * Show the tooltip content editor modal.
	 *
	 * @param {string} pTooltipKey - The tooltip key to edit
	 */
	_showTooltipEditor(pTooltipKey)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];

		if (!tmpModal)
		{
			return;
		}

		let tmpCurrentContent = this.getTooltipContent(pTooltipKey) || '';
		let tmpSelf = this;

		let tmpEditorHTML = '<div class="pict-inline-doc-tm-form-group">';
		tmpEditorHTML += '<label class="pict-inline-doc-tm-form-label">Tooltip Key</label>';
		tmpEditorHTML += '<div style="font-family:monospace;font-size:0.85em;color:var(--theme-color-text-muted, #8A7F72);padding:0.3em 0;">' + this._escapeTooltipHTML(pTooltipKey) + '</div>';
		tmpEditorHTML += '</div>';
		tmpEditorHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpEditorHTML += '<label class="pict-inline-doc-tm-form-label">Content (Markdown)</label>';
		tmpEditorHTML += '<textarea class="pict-inline-doc-tooltip-editor-textarea" id="InlineDoc-Tooltip-Editor-Textarea">' + this._escapeTooltipHTML(tmpCurrentContent) + '</textarea>';
		tmpEditorHTML += '</div>';
		tmpEditorHTML += '<div class="pict-inline-doc-tooltip-preview-label">Preview</div>';
		tmpEditorHTML += '<div class="pict-inline-doc-tooltip-preview" id="InlineDoc-Tooltip-Editor-Preview"></div>';

		tmpModal.show(
		{
			title: 'Edit Tooltip',
			content: tmpEditorHTML,
			closeable: true,
			width: '480px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				let tmpTextarea = document.getElementById('InlineDoc-Tooltip-Editor-Textarea');
				let tmpPreview = document.getElementById('InlineDoc-Tooltip-Editor-Preview');

				if (tmpTextarea && tmpPreview)
				{
					// Initial preview
					let tmpLinkResolver = tmpSelf._createTooltipLinkResolver();
					let tmpInitialHTML = tmpCurrentContent ? tmpSelf._ContentProvider.parseMarkdown(tmpCurrentContent, tmpLinkResolver) : '<span style="color:var(--theme-color-text-muted, #8A7F72);">No content yet.</span>';
					tmpPreview.innerHTML = tmpInitialHTML;

					// Live preview on input
					tmpTextarea.addEventListener('input', () =>
					{
						let tmpValue = tmpTextarea.value.trim();
						if (tmpValue)
						{
							tmpPreview.innerHTML = tmpSelf._ContentProvider.parseMarkdown(tmpValue, tmpLinkResolver);
						}
						else
						{
							tmpPreview.innerHTML = '<span style="color:var(--theme-color-text-muted, #8A7F72);">No content yet.</span>';
						}
					});

					tmpTextarea.focus();
				}
			}
		}).then((pResult) =>
		{
			if (pResult === 'save')
			{
				let tmpTextarea = document.getElementById('InlineDoc-Tooltip-Editor-Textarea');
				let tmpNewContent = tmpTextarea ? tmpTextarea.value.trim() : '';

				tmpSelf.setTooltipContent(pTooltipKey, tmpNewContent || null);
				tmpSelf.saveTopics();
				tmpSelf.scanTooltips();

				if (tmpModal.toast)
				{
					tmpModal.toast('Tooltip saved.', { type: 'success' });
				}
			}
		});
	}

	/**
	 * Escape HTML for safe insertion into tooltip editor.
	 *
	 * @param {string} pText - Text to escape
	 * @returns {string} Escaped text
	 */
	_escapeTooltipHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	// -- Image upload --

	/**
	 * Wire the onImageUpload handler onto the markdown editor view.
	 *
	 * Overrides the editor's onImageUpload method so that when a user
	 * drops or pastes an image, it is routed through the host app's
	 * onImageUpload callback with the current document path for context.
	 *
	 * The host callback signature is:
	 *   onImageUpload(pFile, pDocumentPath, fCallback)
	 * where fCallback is fCallback(pError, pRelativeURL).
	 */
	_wireEditorImageUpload()
	{
		let tmpSelf = this;
		let tmpEditorView = this.pict.views['InlineDoc-MarkdownEditor'];

		if (!tmpEditorView)
		{
			return;
		}

		tmpEditorView.onImageUpload = (pFile, pSegmentIndex, fCallback) =>
		{
			if (typeof tmpSelf._onImageUpload !== 'function')
			{
				return false;
			}

			let tmpState = tmpSelf.pict.AppData.InlineDocumentation;
			let tmpDocumentPath = (tmpState && tmpState.EditingPath) ? tmpState.EditingPath : '';

			tmpSelf._onImageUpload(pFile, tmpDocumentPath, (pError, pURL) =>
			{
				if (pError)
				{
					tmpSelf.log.warn(`InlineDocumentation: Image upload failed: ${pError}`);
				}
				fCallback(pError, pURL);
			});

			return true;
		};
	}

	/**
	 * Scroll the content area to a heading that matches an anchor string.
	 *
	 * Looks for headings (h1-h6) in the content body whose text, when
	 * slugified, matches the anchor. Uses the standard GitHub-style
	 * slugification: lowercase, spaces to hyphens, strip non-alphanumeric.
	 *
	 * @param {string} pAnchor - The anchor string (without #)
	 */
	_scrollToAnchor(pAnchor)
	{
		if (typeof document === 'undefined' || !pAnchor)
		{
			return;
		}

		// Delay slightly to ensure content is rendered
		setTimeout(() =>
		{
			let tmpContentBody = document.getElementById('InlineDoc-Content-Body');
			if (!tmpContentBody)
			{
				return;
			}

			let tmpSlug = pAnchor.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

			// Check for an element with a matching id first
			let tmpTarget = tmpContentBody.querySelector('#' + CSS.escape(tmpSlug));

			// If no id match, search heading text
			if (!tmpTarget)
			{
				let tmpHeadings = tmpContentBody.querySelectorAll('h1, h2, h3, h4, h5, h6');
				for (let i = 0; i < tmpHeadings.length; i++)
				{
					let tmpHeadingText = tmpHeadings[i].textContent || '';
					let tmpHeadingSlug = tmpHeadingText.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
					if (tmpHeadingSlug === tmpSlug)
					{
						tmpTarget = tmpHeadings[i];
						break;
					}
				}
			}

			if (tmpTarget)
			{
				tmpTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}, 50);
	}

	// ================================================================
	// Full-text search
	// ================================================================

	/**
	 * Load a lunr.js keyword index from a URL.
	 *
	 * The index file is the same format generated by Indoctrinate's
	 * generate_keyword_index command: { LunrIndex, Documents, DocumentCount }.
	 *
	 * @param {string} pURL - URL to the retold-keyword-index.json file
	 * @param {Function} [fCallback] - Callback when done
	 */
	_loadSearchIndex(pURL, fCallback)
	{
		let tmpCallback = (typeof fCallback === 'function') ? fCallback : () => {};
		let tmpSelf = this;

		if (typeof fetch === 'undefined')
		{
			return tmpCallback();
		}

		fetch(pURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pIndexData) =>
			{
				if (!pIndexData || !pIndexData.LunrIndex || !pIndexData.Documents)
				{
					if (tmpSelf.log) tmpSelf.log.info('InlineDocumentation: No keyword index found; search unavailable.');
					return tmpCallback();
				}

				try
				{
					tmpSelf._LunrIndex = libLunr.Index.load(pIndexData.LunrIndex);
					tmpSelf._SearchDocuments = pIndexData.Documents;

					let tmpState = tmpSelf.pict.AppData.InlineDocumentation;
					if (tmpState)
					{
						tmpState.SearchIndexLoaded = true;
					}

					if (tmpSelf.log) tmpSelf.log.info('InlineDocumentation: Search index loaded (' + (pIndexData.DocumentCount || 0) + ' documents).');
				}
				catch (pError)
				{
					if (tmpSelf.log) tmpSelf.log.warn('InlineDocumentation: Error hydrating lunr index: ' + pError);
				}

				return tmpCallback();
			})
			.catch((pError) =>
			{
				if (tmpSelf.log) tmpSelf.log.warn('InlineDocumentation: Error loading search index: ' + pError);
				return tmpCallback();
			});
	}

	/**
	 * Search the loaded lunr index.
	 *
	 * @param {string} pQuery - The search query
	 * @returns {Array} Array of { Key, Title, Group, DocPath, Score }
	 */
	search(pQuery)
	{
		if (!this._LunrIndex || !this._SearchDocuments || !pQuery || !pQuery.trim())
		{
			return [];
		}

		let tmpResults = [];

		try
		{
			let tmpLunrResults = this._LunrIndex.search(pQuery);

			for (let i = 0; i < tmpLunrResults.length; i++)
			{
				let tmpRef = tmpLunrResults[i].ref;
				let tmpScore = tmpLunrResults[i].score;
				let tmpDoc = this._SearchDocuments[tmpRef];

				if (!tmpDoc)
				{
					continue;
				}

				tmpResults.push(
				{
					Key: tmpRef,
					Title: tmpDoc.Title || tmpRef,
					Group: tmpDoc.Group || '',
					Module: tmpDoc.Module || '',
					DocPath: tmpDoc.DocPath || tmpRef,
					Score: tmpScore
				});
			}
		}
		catch (pError)
		{
			if (this.log) this.log.warn('InlineDocumentation: Search error: ' + pError);
		}

		return tmpResults;
	}

	// ================================================================
	// External link resolution (catalog-based)
	// ================================================================

	/**
	 * Check if a path is an external reference.
	 *
	 * Paths that started with / in the sidebar are cross-module
	 * references. They get normalized during parsing (leading /
	 * stripped), but they contain 2+ path segments (group/module/).
	 * Simple filenames like README.md are local.
	 *
	 * An ExternalDocBaseURL must be configured for this to return true.
	 *
	 * @param {string} pPath - The normalized document path
	 * @returns {boolean}
	 */
	isExternalPath(pPath)
	{
		if (!pPath) return false;

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState || !tmpState.ExternalDocBaseURL) return false;

		// Paths with 2+ segments (e.g., pict/pict/, fable/fable/)
		// are cross-module references. Simple filenames are local.
		let tmpPath = pPath.replace(/^\.\//, '').replace(/^\//, '');
		let tmpParts = tmpPath.split('/').filter((p) => p.length > 0);
		return tmpParts.length >= 2;
	}

	/**
	 * Resolve an external path to a full URL.
	 *
	 * @param {string} pPath - The document path
	 * @returns {string|null} The external URL, or null if not external
	 */
	resolveExternalURL(pPath)
	{
		if (!this.isExternalPath(pPath)) return null;

		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpBaseURL = (tmpState && tmpState.ExternalDocBaseURL) || '';
		if (!tmpBaseURL) return null;

		let tmpPath = pPath.replace(/^\.\//, '').replace(/^\//, '');
		return tmpBaseURL + tmpPath;
	}

	/**
	 * After sidebar is loaded, mark items that are external
	 * references with External: true and ExternalURL.
	 */
	_markExternalSidebarItems()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState || !tmpState.ExternalDocBaseURL) return;

		let tmpGroups = tmpState.SidebarGroups || [];
		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpItems = tmpGroups[i].Items || [];
			for (let j = 0; j < tmpItems.length; j++)
			{
				let tmpItem = tmpItems[j];
				if (this.isExternalPath(tmpItem.Path))
				{
					tmpItem.External = true;
					tmpItem.ExternalURL = this.resolveExternalURL(tmpItem.Path);
				}
			}
		}
	}

	/**
	 * Extract h2 and h3 headings from the rendered content body.
	 *
	 * Queries #InlineDoc-Content-Body for heading elements, extracts
	 * their text, generates slugified IDs for anchor scrolling, and
	 * stores the results in AppData for the nav outline.
	 *
	 * @returns {Array} Array of { Text, Slug, Level }
	 */
	_extractHeadings()
	{
		let tmpHeadings = [];

		if (typeof document === 'undefined')
		{
			return tmpHeadings;
		}

		let tmpContentBody = document.getElementById('InlineDoc-Content-Body');
		if (!tmpContentBody)
		{
			return tmpHeadings;
		}

		let tmpElements = tmpContentBody.querySelectorAll('h2, h3');

		for (let i = 0; i < tmpElements.length; i++)
		{
			let tmpElement = tmpElements[i];
			let tmpText = (tmpElement.textContent || '').trim();
			let tmpLevel = parseInt(tmpElement.tagName.substring(1), 10);
			let tmpSlug = tmpText.toLowerCase()
				.replace(/[^a-z0-9\s-]/g, '')
				.replace(/\s+/g, '-')
				.replace(/-+/g, '-');

			// Assign the ID to the heading element if not already set
			// so scrollIntoView can find it
			if (!tmpElement.id)
			{
				tmpElement.id = tmpSlug;
			}

			tmpHeadings.push({ Text: tmpText, Slug: tmpSlug, Level: tmpLevel });
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (tmpState)
		{
			tmpState.ActiveDocumentHeadings = tmpHeadings;
		}

		return tmpHeadings;
	}

	// -- Internal methods --

	/**
	 * Fetch a markdown document and convert it to HTML.
	 *
	 * @param {string} pURL - The URL to fetch
	 * @param {Function} fCallback - Callback receiving (error, htmlContent)
	 */
	_fetchDocument(pURL, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};

		if (!pURL)
		{
			return tmpCallback('No URL provided', '');
		}

		// Check cache
		if (this._ContentCache[pURL])
		{
			return tmpCallback(null, this._ContentCache[pURL].html);
		}

		fetch(pURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					return tmpCallback('Document not found', '');
				}

				let tmpHTML = this._ContentProvider.parseMarkdown(
					pMarkdown,
					this._createLinkResolver(),
					this._createImageResolver(pURL),
					this._VocabularyResolver);
				this._ContentCache[pURL] = { html: tmpHTML, markdown: pMarkdown };
				return tmpCallback(null, tmpHTML);
			})
			.catch((pError) =>
			{
				this.log.warn(`InlineDocumentation: Error fetching [${pURL}]: ${pError}`);
				return tmpCallback(pError, '');
			});
	}

	/**
	 * Create a link resolver that converts internal doc links to provider API calls.
	 *
	 * Internal links (relative .md paths) get converted to javascript:void(0) with
	 * a data attribute so the content view's click handler can intercept them and
	 * call loadDocument().
	 *
	 * @returns {Function} A link resolver callback
	 */
	_createLinkResolver()
	{
		return (pHref, pLinkText) =>
		{
			// Only intercept internal markdown links
			if (pHref.match(/^https?:\/\//))
			{
				// External link — open in new tab
				return { href: pHref, target: '_blank', rel: 'noopener' };
			}

			// help: prefix — internal documentation link (e.g. help:book-list.md#section)
			if (pHref.match(/^help:/))
			{
				let tmpHelpPath = pHref.replace(/^help:/, '');
				return {
					href: 'javascript:void(0)',
					target: '',
					rel: 'pict-inline-doc-link:' + tmpHelpPath
				};
			}

			// Internal doc link — mark for interception. Strip a route-style prefix ("#/page/foo.md")
			// so the rel carries a clean doc path; otherwise loadDocument() reads the leading "#" as an
			// anchor delimiter and fails to resolve the document (body cross-links would 404).
			let tmpPath = pHref.replace(/^#\/page\//, '').replace(/^#\//, '').replace(/^\.\//, '').replace(/^\//, '');
			return {
				href: 'javascript:void(0)',
				// Use a data attribute for the click handler
				// The content view will wire up click interception
				target: '',
				rel: 'pict-inline-doc-link:' + tmpPath
			};
		};
	}

	/**
	 * Create a link resolver for tooltip content.
	 *
	 * Handles help:path.md#anchor links that open documents in the help
	 * panel. These links get a special rel attribute so click handlers
	 * can intercept them.
	 *
	 * External links open in a new tab. All other links are treated as
	 * help: links within the tooltip context.
	 *
	 * @returns {Function} A link resolver callback
	 */
	_createTooltipLinkResolver()
	{
		return (pHref, pLinkText) =>
		{
			// External links — open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return { href: pHref, target: '_blank', rel: 'noopener' };
			}

			// Strip help: prefix if present
			let tmpPath = pHref.replace(/^help:/, '');
			// Clean relative prefixes
			tmpPath = tmpPath.replace(/^\.\//, '').replace(/^\//, '');

			return {
				href: 'javascript:void(0)',
				target: '',
				rel: 'pict-inline-doc-help:' + tmpPath
			};
		};
	}

	/**
	 * Create an image resolver closure.
	 *
	 * @param {string} pDocURL - The URL the document was fetched from
	 * @returns {Function} An image resolver callback
	 */
	_createImageResolver(pDocURL)
	{
		let tmpBaseDir = '';
		if (pDocURL)
		{
			let tmpLastSlash = pDocURL.lastIndexOf('/');
			if (tmpLastSlash >= 0)
			{
				tmpBaseDir = pDocURL.substring(0, tmpLastSlash + 1);
			}
		}

		return (pSrc, pAlt) =>
		{
			if (pSrc.match(/^https?:\/\//) || pSrc.match(/^data:/) || pSrc.match(/^\//))
			{
				return pSrc;
			}
			return tmpBaseDir + pSrc;
		};
	}

	// ── "show non-document files" preference (persisted per browser) ──────────
	_showAssetFilesStorageKey() { return 'pict-inline-doc-show-asset-files'; }
	_readShowAssetFilesPref()
	{
		try { return (typeof localStorage !== 'undefined') && localStorage.getItem(this._showAssetFilesStorageKey()) === '1'; }
		catch (pError) { return false; }
	}
	_writeShowAssetFilesPref(pOn)
	{
		try { if (typeof localStorage !== 'undefined') { localStorage.setItem(this._showAssetFilesStorageKey(), pOn ? '1' : '0'); } }
		catch (pError) { /* storage unavailable - the choice just does not persist */ }
	}

	/**
	 * Flip the "show non-document files" preference, persist it, and reload the tree so the asset
	 * files appear or disappear. The Nav toolbar toggle calls this.
	 */
	toggleAssetFiles()
	{
		let tmpState = this.pict.AppData.InlineDocumentation;
		tmpState.ShowAssetFiles = !tmpState.ShowAssetFiles;
		this._writeShowAssetFilesPref(tmpState.ShowAssetFiles);
		this.reloadSidebar();
	}

	/**
	 * Load and parse _sidebar.md from the docs base URL.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	_loadSidebar(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpDocsBase = tmpState.DocsBaseURL || '';
		// When the reader is showing asset files, ask the server for the full tree; otherwise it
		// returns documents only (a server that does not honor the param simply returns everything).
		let tmpQuery = tmpState.ShowAssetFiles ? '?files=all' : '';

		fetch(tmpDocsBase + '_sidebar.md' + tmpQuery)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('InlineDocumentation: No _sidebar.md found.');
					return tmpCallback();
				}

				tmpState.SidebarGroups = this._parseSidebarMarkdown(pMarkdown);
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`InlineDocumentation: Error loading _sidebar.md: ${pError}`);
				return tmpCallback();
			});
	}

	// ================================================================
	// Structure management (folders, move, reorder, delete)
	// ================================================================

	/**
	 * Which structure affordances the host has wired. The Nav view reads this to
	 * decide which controls to show; an unwired host gets a read-only browser.
	 *
	 * @returns {{ create:boolean, delete:boolean, move:boolean, reorder:boolean, any:boolean }}
	 */
	getStructureCapabilities()
	{
		let tmpCreate = (typeof this._onCreateFolder === 'function') || (typeof this._onCreateDocument === 'function');
		let tmpDelete = (typeof this._onDeleteNode === 'function');
		let tmpMove = (typeof this._onMoveNode === 'function');
		let tmpReorder = (typeof this._onReorder === 'function');
		return {
			create: tmpCreate,
			createFolder: (typeof this._onCreateFolder === 'function'),
			createDocument: (typeof this._onCreateDocument === 'function'),
			delete: tmpDelete,
			move: tmpMove,
			reorder: tmpReorder,
			any: tmpCreate || tmpDelete || tmpMove || tmpReorder
		};
	}

	/**
	 * Reload the sidebar from the server and re-render the navigation. Called after
	 * a structure change persists so the tree reflects the server's authoritative
	 * order/shape (the drag is optimistic; this makes it real).
	 *
	 * @param {Function} [fCallback] - Callback when the reload completes
	 */
	reloadSidebar(fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		this._loadSidebar(() =>
		{
			this._markExternalSidebarItems();
			let tmpNavView = this.pict.views['InlineDoc-Nav'];
			if (tmpNavView)
			{
				tmpNavView.render();
			}
			return tmpCallback();
		});
	}

	// Small toast helper (falls back to a log if the modal is not present).
	_structureToast(pMessage, pType)
	{
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info', duration: (pType === 'error') ? 6000 : 2500 });
		}
		else if (this.log)
		{
			this.log.info('InlineDocumentation: ' + pMessage);
		}
	}

	// Run a host structure callback, then reload the sidebar on success (or toast the
	// error). Shared by every request* method below so the persist-then-refetch flow
	// is identical for create/delete/move/reorder.
	_runStructureOp(fOp, pSuccessMessage, fCallback)
	{
		let tmpSelf = this;
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		fOp((pError) =>
		{
			if (pError)
			{
				tmpSelf._structureToast((pError && pError.message) || String(pError), 'error');
				return tmpCallback(pError);
			}
			tmpSelf.reloadSidebar(() =>
			{
				if (pSuccessMessage) { tmpSelf._structureToast(pSuccessMessage, 'success'); }
				return tmpCallback(null);
			});
		});
	}

	requestCreateFolder(pParentPath, pName, fCallback)
	{
		if (typeof this._onCreateFolder !== 'function') { return; }
		let tmpParent = pParentPath || '';
		this._runStructureOp((fDone) => this._onCreateFolder(tmpParent, pName, fDone), 'Folder created.', fCallback);
	}

	requestCreateDocument(pParentPath, pName, fCallback)
	{
		if (typeof this._onCreateDocument !== 'function') { return; }
		let tmpParent = pParentPath || '';
		this._runStructureOp((fDone) => this._onCreateDocument(tmpParent, pName, fDone), 'Document created.', fCallback);
	}

	requestDeleteNode(pPath, pNodeType, fCallback)
	{
		if (typeof this._onDeleteNode !== 'function' || !pPath) { return; }
		this._runStructureOp((fDone) => this._onDeleteNode(pPath, pNodeType || 'file', fDone), 'Deleted.', fCallback);
	}

	requestMoveNode(pFromPath, pToPath, fCallback)
	{
		if (typeof this._onMoveNode !== 'function' || !pFromPath || !pToPath || pFromPath === pToPath) { return; }
		this._runStructureOp((fDone) => this._onMoveNode(pFromPath, pToPath, fDone), 'Moved.', fCallback);
	}

	requestReorder(pParentPath, pOrderedNames, fCallback)
	{
		if (typeof this._onReorder !== 'function' || !Array.isArray(pOrderedNames)) { return; }
		let tmpParent = pParentPath || '';
		this._runStructureOp((fDone) => this._onReorder(tmpParent, pOrderedNames, fDone), '', fCallback);
	}

	/**
	 * Load topic definitions from a JSON file.
	 *
	 * Expected format:
	 *   {
	 *     "getting-started": {
	 *       "Name": "Getting Started",
	 *       "Documents": ["README.md", "getting-started.md"]
	 *     }
	 *   }
	 *
	 * @param {string} [pTopicsURL] - URL to fetch topics from (defaults to DocsBaseURL + '_topics.json')
	 * @param {Function} fCallback - Callback when done
	 */
	_loadTopics(pTopicsURL, fCallback)
	{
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => {};
		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpDocsBase = tmpState.DocsBaseURL || '';

		let tmpURL = pTopicsURL || (tmpDocsBase + '_topics.json');

		fetch(tmpURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pTopics) =>
			{
				if (pTopics)
				{
					tmpState.Topics = pTopics;
					this.log.info(`InlineDocumentation: Topics loaded (${Object.keys(pTopics).length} topics).`);
				}
				else
				{
					this.log.info('InlineDocumentation: No _topics.json found.');
				}
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.info(`InlineDocumentation: No topics loaded (${pError}).`);
				return tmpCallback();
			});
	}

	/**
	 * Parse _sidebar.md into a navigation structure.
	 *
	 * Returns an array of group objects:
	 *   [{ Name, Key, Path, Items: [{ Name, Path }] }]
	 *
	 * @param {string} pMarkdown - Raw _sidebar.md content
	 * @returns {Array} Parsed sidebar groups
	 */
	_parseSidebarMarkdown(pMarkdown)
	{
		let tmpGroups = [];
		let tmpCurrentGroup = null;
		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			if (!tmpLine.trim())
			{
				continue;
			}

			let tmpIndentMatch = tmpLine.match(/^(\s*)/);
			let tmpIndent = tmpIndentMatch ? tmpIndentMatch[1].length : 0;
			let tmpContent = tmpLine.trim();

			let tmpListMatch = tmpContent.match(/^[-*+]\s+(.*)/);
			if (!tmpListMatch)
			{
				continue;
			}

			let tmpItemContent = tmpListMatch[1].trim();
			let tmpLinkMatch = tmpItemContent.match(/^\[([^\]]+)\]\(([^)]+)\)/);

			// A link whose target ends in '/' is a FOLDER reference, not a document:
			// the server can emit `- [Label](real/folder/path/)` so the client knows a
			// folder's real (possibly relabeled, possibly empty) path for structure ops.
			// Everything else keeps working: a folder rendered as a plain `- Label` with
			// no link still parses as a pathless folder (older sidebars, backward compat).
			let tmpIsFolderLink = tmpLinkMatch && /\/$/.test(tmpLinkMatch[2].trim());
			let tmpFolderPath = tmpIsFolderLink ? this._normalizePath(tmpLinkMatch[2].trim().replace(/\/+$/, '')) : '';

			if (tmpIndent < 2)
			{
				// Top-level item — group header
				if (tmpIsFolderLink)
				{
					tmpCurrentGroup = {
						Name: tmpLinkMatch[1].trim(),
						Key: tmpLinkMatch[1].trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
						Path: '',
						FolderPath: tmpFolderPath,
						Items: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
				else if (tmpLinkMatch)
				{
					let tmpName = tmpLinkMatch[1].trim();
					let tmpPath = tmpLinkMatch[2].trim();

					tmpCurrentGroup = {
						Name: tmpName,
						Key: tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
						Path: this._normalizePath(tmpPath),
						Items: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
				else
				{
					tmpCurrentGroup = {
						Name: tmpItemContent,
						Key: tmpItemContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
						Path: '',
						Items: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
			}
			else if (tmpCurrentGroup)
			{
				// Indented item — a document (link), a folder reference (trailing-slash
				// link), or a legacy sub-folder (no link) within the current group.
				// Capture the nesting Level from the indentation so the nav can render
				// real hierarchy.
				let tmpLevel = Math.max(0, Math.floor((tmpIndent - 2) / 2));
				if (tmpIsFolderLink)
				{
					tmpCurrentGroup.Items.push({
						Name: tmpLinkMatch[1].trim(),
						Path: '',
						FolderPath: tmpFolderPath,
						Level: tmpLevel,
						IsFolder: true
					});
				}
				else if (tmpLinkMatch)
				{
					tmpCurrentGroup.Items.push({
						Name: tmpLinkMatch[1].trim(),
						Path: this._normalizePath(tmpLinkMatch[2].trim()),
						Level: tmpLevel
					});
				}
				else
				{
					tmpCurrentGroup.Items.push({
						Name: tmpItemContent,
						Path: '',
						Level: tmpLevel,
						IsFolder: true
					});
				}
			}
		}

		// Make sub-folder nodes actionable: resolve each folder's first
		// descendant document (the items are in depth-first order, so scan
		// forward until we leave the folder's subtree) so clicking the folder
		// opens its first child.
		for (let g = 0; g < tmpGroups.length; g++)
		{
			let tmpItems = tmpGroups[g].Items || [];
			for (let a = 0; a < tmpItems.length; a++)
			{
				if (!tmpItems[a].IsFolder) { continue; }
				for (let b = a + 1; b < tmpItems.length; b++)
				{
					if ((tmpItems[b].Level || 0) <= (tmpItems[a].Level || 0)) { break; }
					if (tmpItems[b].Path) { tmpItems[a].FirstChildPath = tmpItems[b].Path; break; }
				}
			}
		}

		return tmpGroups;
	}

	/**
	 * Normalize a document path from sidebar links.
	 * Strips leading slashes and ./ prefixes.
	 *
	 * @param {string} pPath - The raw path
	 * @returns {string} The normalized path
	 */
	_normalizePath(pPath)
	{
		if (!pPath)
		{
			return '';
		}
		return pPath.replace(/^\.\//, '').replace(/^\//, '');
	}

	/**
	 * Get an error page HTML block for a missing document.
	 *
	 * @param {string} pPath - The path that was not found
	 * @returns {string} HTML to display
	 */
	_getErrorPageHTML(pPath)
	{
		let tmpPath = this._ContentProvider.escapeHTML(pPath || 'unknown');
		return '<div class="pict-inline-doc-not-found">'
			+ '<h2>Page Not Found</h2>'
			+ '<p>The document <code>' + tmpPath + '</code> could not be loaded.</p>'
			+ '</div>';
	}
}

const _DefaultConfiguration =
{
	ProviderIdentifier: "Pict-InlineDocumentation",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

module.exports = InlineDocumentationProvider;

module.exports.default_configuration = _DefaultConfiguration;

},{"../views/Pict-View-InlineDocumentation-Content.js":664,"../views/Pict-View-InlineDocumentation-Layout.js":665,"../views/Pict-View-InlineDocumentation-Nav.js":666,"../views/Pict-View-InlineDocumentation-TopicManager.js":667,"lunr":505,"pict-provider":552,"pict-section-content":561,"pict-section-markdowneditor":680,"pict-section-modal":690}],664:[function(require,module,exports){
const libPictContentView = require('pict-section-content');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-Content",

	DefaultRenderable: "InlineDoc-Content-Display",
	DefaultContentDestinationAddress: "#InlineDoc-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc-content {
			padding: 1em 1.25em;
			max-width: 100%;
			word-wrap: break-word;
			overflow-wrap: break-word;
		}
		.pict-inline-doc-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 150px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.95em;
		}
		.pict-inline-doc-content h1 {
			font-size: 1.75em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-inline-doc-content h2 {
			font-size: 1.35em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.2em;
			margin-top: 1.25em;
		}
		.pict-inline-doc-content h3 {
			font-size: 1.15em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1em;
		}
		.pict-inline-doc-content h4, .pict-inline-doc-content h5, .pict-inline-doc-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 0.8em;
		}
		.pict-inline-doc-content p {
			line-height: 1.65;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.6em 0;
		}
		.pict-inline-doc-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
			cursor: pointer;
		}
		.pict-inline-doc-content a:hover {
			text-decoration: underline;
		}
		/* Code blocks: bg + text both flow from background/text tokens
		   so they re-skin coherently across themes. (Previous version
		   paired background-tertiary with text-on-brand — both light
		   in most palettes, producing invisible text.) */
		.pict-inline-doc-content pre {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			color:      var(--theme-color-text-primary,        #3D3229);
			padding: 1em;
			border-radius: 5px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.85em;
			max-width: 100%;
		}
		.pict-inline-doc-content code {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			padding: 0.15em 0.35em;
			border-radius: 3px;
			font-size: 0.85em;
			color: var(--theme-color-brand-accent, #9E6B47);
		}
		.pict-inline-doc-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-inline-doc-content blockquote {
			border-left: 3px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 0.8em 0;
			padding: 0.4em 0.8em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-inline-doc-content blockquote p {
			margin: 0.2em 0;
		}
		.pict-inline-doc-content ul, .pict-inline-doc-content ol {
			padding-left: 1.8em;
			line-height: 1.7;
		}
		.pict-inline-doc-content li {
			margin: 0.2em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-inline-doc-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 1.5em 0;
		}
		.pict-inline-doc-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 0.8em 0;
			display: block;
			overflow-x: auto;
		}
		.pict-inline-doc-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.7em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.4em 0.7em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-inline-doc-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-inline-doc-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-inline-doc-not-found {
			text-align: center;
			padding: 2em 1em;
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-inline-doc-not-found h2 {
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1.3em;
			border-bottom: none;
		}
		.pict-inline-doc-not-found code {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			padding: 0.15em 0.35em;
			border-radius: 3px;
			font-size: 0.85em;
			color: var(--theme-color-brand-accent, #9E6B47);
		}
		/* Code block action buttons (copy, fullscreen) from pict-section-content */
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-secondary, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-edit-toolbar {
			display: none;
			align-items: center;
			gap: 0.4em;
			padding: 0.4em 0.6em;
			margin-bottom: 0.5em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-size: 0.8em;
		}
		.pict-inline-doc-edit-toolbar.visible {
			display: flex;
		}
		.pict-inline-doc-edit-toolbar .edit-label {
			color: var(--theme-color-text-muted, #8A7F72);
			margin-right: auto;
		}
		.pict-inline-doc-edit-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			padding: 0.25em 0.6em;
			border: 1px solid var(--theme-color-border-default, #D4A373);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.9em;
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-edit-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-edit-btn.primary {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-edit-btn.primary:hover {
			background: var(--theme-color-brand-primary-hover, #266D65);
		}
		.pict-inline-doc-edit-btn .btn-icon {
			margin-right: 0.3em;
		}
		#InlineDoc-Editor-Container {
			min-height: 300px;
		}
		/* Tooltip placeholder: edit mode indicators */
		[data-d-tooltip].pict-inline-doc-tooltip-edit-target {
			outline: 1px dashed var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
			cursor: pointer;
			position: relative;
		}
		[data-d-tooltip].pict-inline-doc-tooltip-edit-target:not([data-d-tooltip-icon])::after {
			content: '?';
			position: absolute;
			top: -6px;
			right: -6px;
			width: 14px;
			height: 14px;
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-radius: 50%;
			font-size: 9px;
			line-height: 14px;
			text-align: center;
			font-weight: 700;
			pointer-events: none;
		}
		/* Tooltip placeholder: default icon */
		.pict-inline-doc-tooltip-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 16px;
			height: 16px;
			font-size: 12px;
			color: var(--theme-color-brand-primary, #2E7D74);
			cursor: pointer;
			vertical-align: middle;
		}
		/* Empty icon tooltip in edit mode */
		.pict-inline-doc-tooltip-empty .pict-inline-doc-tooltip-icon {
			opacity: 0.4;
			outline: 1px dashed var(--theme-color-text-muted, #8A7F72);
			outline-offset: 1px;
			border-radius: 50%;
		}
		/* Tooltip editor textarea in modal */
		.pict-inline-doc-tooltip-editor-textarea {
			width: 100%;
			min-height: 120px;
			padding: 0.6em;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.85em;
			line-height: 1.5;
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			resize: vertical;
			box-sizing: border-box;
		}
		.pict-inline-doc-tooltip-editor-textarea:focus {
			outline: none;
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 0 0 2px rgba(46, 125, 116, 0.15);
		}
		.pict-inline-doc-tooltip-preview {
			margin-top: 0.5em;
			padding: 0.5em 0.7em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-size: 0.9em;
			min-height: 2em;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-tooltip-preview-label {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			margin-bottom: 0.3em;
		}
		/* Image document view (an svg/png/... opened from the tree) */
		.pict-inline-doc-image-view {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 0.75em;
			padding: 1.5em;
		}
		.pict-inline-doc-image-view .pict-inline-doc-image {
			max-width: 100%;
			height: auto;
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 6px;
			background: var(--theme-color-background-panel, #FDFCFA);
		}
		.pict-inline-doc-image-caption {
			display: flex;
			align-items: center;
			gap: 1em;
			font-size: 0.85em;
			color: var(--theme-color-text-muted, #8A7F72);
		}
		.pict-inline-doc-image-name {
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
		}
		.pict-inline-doc-image-open {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-inline-doc-image-open:hover {
			text-decoration: underline;
		}
	`,

	Templates:
	[
		{
			Hash: "InlineDoc-Content-Template",
			Template: /*html*/`
<div class="pict-inline-doc-edit-toolbar" id="InlineDoc-Edit-Toolbar">
	<span class="edit-label" id="InlineDoc-Edit-Label">View mode</span>
	<button class="pict-inline-doc-edit-btn" id="InlineDoc-Edit-Toggle" title="Edit this document"><span class="btn-icon"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 1.5l3 3L5 14H2v-3z"/><line x1="9" y1="4" x2="12" y2="7"/></svg></span> Edit</button>
	<button class="pict-inline-doc-edit-btn primary" id="InlineDoc-Edit-Save" style="display:none"><span class="btn-icon"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,8 6.5,11.5 13,4.5"/></svg></span> Save</button>
	<button class="pict-inline-doc-edit-btn" id="InlineDoc-Edit-Cancel" style="display:none"><span class="btn-icon"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg></span> Cancel</button>
</div>
<div class="pict-inline-doc-content pict-content" id="InlineDoc-Content-Body">
	<div class="pict-inline-doc-content-loading">Loading...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "InlineDoc-Content-Display",
			TemplateHash: "InlineDoc-Content-Template",
			ContentDestinationAddress: "#InlineDoc-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class InlineDocumentationContentView extends libPictContentView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender()
	{
		this.renderEditToolbar();
		return super.onAfterRender();
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 */
	displayContent(pHTMLContent)
	{
		super.displayContent(pHTMLContent, 'InlineDoc-Content-Body');

		// Wire up click interception for internal doc links
		this._wireInternalLinks();

		// Update the edit toolbar state
		this.renderEditToolbar();
	}

	/**
	 * Show a loading indicator.
	 */
	showLoading()
	{
		super.showLoading('Loading...', 'InlineDoc-Content-Body');
	}

	/**
	 * Show or hide the edit toolbar based on EditEnabled state.
	 */
	renderEditToolbar()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpToolbar = document.getElementById('InlineDoc-Edit-Toolbar');
		if (!tmpToolbar)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState)
		{
			return;
		}

		if (tmpState.EditEnabled && tmpState.CurrentPath)
		{
			tmpToolbar.classList.add('visible');
		}
		else
		{
			tmpToolbar.classList.remove('visible');
		}

		// Update button visibility based on editing state
		let tmpToggleBtn = document.getElementById('InlineDoc-Edit-Toggle');
		let tmpSaveBtn = document.getElementById('InlineDoc-Edit-Save');
		let tmpCancelBtn = document.getElementById('InlineDoc-Edit-Cancel');
		let tmpLabel = document.getElementById('InlineDoc-Edit-Label');

		if (tmpState.Editing)
		{
			if (tmpToggleBtn) { tmpToggleBtn.style.display = 'none'; }
			if (tmpSaveBtn) { tmpSaveBtn.style.display = ''; }
			if (tmpCancelBtn) { tmpCancelBtn.style.display = ''; }
			if (tmpLabel) { tmpLabel.textContent = 'Editing: ' + (tmpState.EditingPath || ''); }
		}
		else
		{
			if (tmpToggleBtn) { tmpToggleBtn.style.display = ''; }
			if (tmpSaveBtn) { tmpSaveBtn.style.display = 'none'; }
			if (tmpCancelBtn) { tmpCancelBtn.style.display = 'none'; }
			if (tmpLabel) { tmpLabel.textContent = tmpState.CurrentPath || 'View mode'; }
		}

		// Re-wire click handlers (DOM may have been recreated by render)
		this._wireEditToolbar();
	}

	/**
	 * Show the markdown editor with the raw markdown content.
	 *
	 * @param {string} pMarkdown - The raw markdown to edit
	 */
	showEditor(pMarkdown)
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('InlineDoc-Content-Body');
		if (!tmpContainer)
		{
			return;
		}

		// Create a container for the markdown editor view to render into
		tmpContainer.innerHTML = '<div id="InlineDoc-Editor-Container"></div>';

		// Set up the editor segments data for the markdown editor
		if (!this.pict.AppData.InlineDocumentation)
		{
			this.pict.AppData.InlineDocumentation = {};
		}
		this.pict.AppData.InlineDocumentation.EditorSegments = [{ Content: pMarkdown || '' }];

		// Render the markdown editor view into the container
		let tmpEditorView = this.pict.views['InlineDoc-MarkdownEditor'];
		if (tmpEditorView)
		{
			tmpEditorView.render();
		}

		this.renderEditToolbar();
	}

	/**
	 * Hide the textarea editor.
	 */
	hideEditor()
	{
		// The editor will be replaced by displayContent, but update toolbar state
		this.renderEditToolbar();
	}

	/**
	 * Wire click handlers for the edit toolbar buttons.
	 */
	_wireEditToolbar()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];

		let tmpToggleBtn = document.getElementById('InlineDoc-Edit-Toggle');
		if (tmpToggleBtn)
		{
			tmpToggleBtn.addEventListener('click', () =>
			{
				if (tmpProvider)
				{
					tmpProvider.beginEdit();
				}
			});
		}

		let tmpSaveBtn = document.getElementById('InlineDoc-Edit-Save');
		if (tmpSaveBtn)
		{
			tmpSaveBtn.addEventListener('click', () =>
			{
				if (tmpProvider)
				{
					tmpProvider.saveEdit();
				}
			});
		}

		let tmpCancelBtn = document.getElementById('InlineDoc-Edit-Cancel');
		if (tmpCancelBtn)
		{
			tmpCancelBtn.addEventListener('click', () =>
			{
				if (tmpProvider)
				{
					tmpProvider.cancelEdit();
				}
			});
		}
	}

	/**
	 * Wire click handlers on internal documentation links.
	 *
	 * Links with rel="pict-inline-doc-link:path" are intercepted and
	 * routed through the provider's loadDocument() method.
	 */
	_wireInternalLinks()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('InlineDoc-Content-Body');
		if (!tmpContainer)
		{
			return;
		}

		let tmpLinks = tmpContainer.querySelectorAll('a[rel^="pict-inline-doc-link:"]');
		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];

		for (let i = 0; i < tmpLinks.length; i++)
		{
			let tmpLink = tmpLinks[i];
			let tmpRel = tmpLink.getAttribute('rel');
			let tmpPath = tmpRel.replace('pict-inline-doc-link:', '');

			// Check if this is a cross-module link that should open externally
			if (tmpProvider && typeof tmpProvider.isExternalPath === 'function' && tmpProvider.isExternalPath(tmpPath))
			{
				let tmpExternalURL = tmpProvider.resolveExternalURL(tmpPath);
				if (tmpExternalURL)
				{
					tmpLink.setAttribute('href', tmpExternalURL);
					tmpLink.setAttribute('target', '_blank');
					tmpLink.setAttribute('rel', 'noopener');
					continue;
				}
			}

			tmpLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				if (tmpProvider)
				{
					tmpProvider.loadDocument(tmpPath);
				}
			});
		}
	}
}

module.exports = InlineDocumentationContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-section-content":561}],665:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-Layout",

	DefaultRenderable: "InlineDoc-Layout-Container",
	DefaultContentDestinationAddress: "#InlineDoc-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc {
			display: flex;
			flex-direction: row;
			width: 100%;
			height: 100%;
			min-height: 300px;
			font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
			font-size: 15px;
			color: var(--theme-color-text-primary, #423D37);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 6px;
			overflow: hidden;
		}
		.pict-inline-doc-nav-container {
			width: var(--pict-inline-doc-nav-width, 240px);
			min-width: 160px;
			max-width: 640px;
			border-right: 1px solid var(--theme-color-border-default, #E5DED4);
			background: var(--theme-color-background-secondary, #F7F5F0);
			overflow-y: auto;
			flex-shrink: 0;
		}
		.pict-inline-doc-resizer {
			flex: 0 0 6px;
			width: 6px;
			margin: 0 -3px;
			z-index: 2;
			cursor: col-resize;
			background: transparent;
			transition: background 0.12s ease;
		}
		.pict-inline-doc-resizer:hover,
		.pict-inline-doc-resizer.pict-inline-doc-resizing {
			background: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-content-container {
			flex: 1;
			overflow-y: auto;
			overflow-x: hidden;
			min-width: 0;
		}
		.pict-inline-doc-nav-container.pict-inline-doc-nav-hidden {
			display: none;
		}
		/* Whole-panel collapse: shrink the nav to a thin strip showing only the
		   expand chevron, handing the freed width back to the content. The Nav
		   view toggles .pict-inline-doc-nav-collapsed on the container. width is
		   !important so it beats any inline width left by the drag-resizer. */
		.pict-inline-doc-nav-container.pict-inline-doc-nav-collapsed {
			width: 40px !important;
			min-width: 40px;
		}
		.pict-inline-doc-nav-container.pict-inline-doc-nav-collapsed + .pict-inline-doc-resizer {
			display: none;
		}
		.pict-inline-doc-nav-collapsed .pict-inline-doc-nav-collapsed-header {
			flex-direction: column;
			padding: 0.6em 0;
			justify-content: flex-start;
		}
		.pict-inline-doc-nav-collapsed .pict-inline-doc-nav-current-title,
		.pict-inline-doc-nav-collapsed .pict-inline-doc-nav-search-icon {
			display: none;
		}
		/* Compact mode: stack nav above content when container is narrow */
		.pict-inline-doc.pict-inline-doc-compact {
			flex-direction: column;
		}
		.pict-inline-doc.pict-inline-doc-compact .pict-inline-doc-nav-container {
			width: 100%;
			min-width: 0;
			max-width: none;
			border-right: none;
			border-bottom: 1px solid var(--theme-color-border-default, #E5DED4);
			overflow-y: visible;
			flex-shrink: 0;
		}
		.pict-inline-doc.pict-inline-doc-compact .pict-inline-doc-resizer {
			display: none;
		}
	`,

	Templates:
	[
		{
			Hash: "InlineDoc-Layout-Template",
			Template: /*html*/`
<div class="pict-inline-doc">
	<div class="pict-inline-doc-nav-container" id="InlineDoc-Nav-Container"></div>
	<div class="pict-inline-doc-resizer" id="InlineDoc-Resizer" title="Drag to resize the navigation"></div>
	<div class="pict-inline-doc-content-container" id="InlineDoc-Content-Container"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "InlineDoc-Layout-Container",
			TemplateHash: "InlineDoc-Layout-Template",
			ContentDestinationAddress: "#InlineDoc-Container",
			RenderMethod: "replace"
		}
	]
};

class InlineDocumentationLayoutView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender()
	{
		// Inject all view CSS into the PICT-CSS style element
		this.pict.CSSMap.injectCSS();

		// Restore any saved nav width, then make the nav/content divider draggable
		this._restoreNavWidth();
		this._wireNavResizer();

		// Watch for size changes and toggle compact mode
		this._setupCompactModeObserver();

		return super.onAfterRender();
	}

	/**
	 * Make the divider between the nav and the content draggable so the reader
	 * can widen or narrow the navigation. The width lives in a CSS custom
	 * property on the layout container and is persisted to localStorage.
	 */
	_wireNavResizer()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpResizer = document.getElementById('InlineDoc-Resizer');
		let tmpContainer = document.querySelector('.pict-inline-doc');
		let tmpNav = document.getElementById('InlineDoc-Nav-Container');
		if (!tmpResizer || !tmpContainer || !tmpNav)
		{
			return;
		}

		let tmpMin = 160;
		let tmpMax = 640;
		let tmpSelf = this;

		tmpResizer.addEventListener('mousedown', (pDownEvent) =>
		{
			pDownEvent.preventDefault();
			let tmpStartX = pDownEvent.clientX;
			let tmpStartWidth = tmpNav.offsetWidth;

			tmpResizer.classList.add('pict-inline-doc-resizing');
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			// A drag needs document-level move/up tracking; both listeners are
			// removed on release, so nothing leaks across renders.
			let fMove = (pMoveEvent) =>
			{
				let tmpWidth = tmpStartWidth + (pMoveEvent.clientX - tmpStartX);
				tmpWidth = Math.max(tmpMin, Math.min(tmpMax, tmpWidth));
				tmpContainer.style.setProperty('--pict-inline-doc-nav-width', tmpWidth + 'px');
			};
			let fUp = () =>
			{
				document.removeEventListener('mousemove', fMove);
				document.removeEventListener('mouseup', fUp);
				tmpResizer.classList.remove('pict-inline-doc-resizing');
				document.body.style.userSelect = '';
				document.body.style.cursor = '';
				tmpSelf._persistNavWidth(tmpContainer.style.getPropertyValue('--pict-inline-doc-nav-width'));
			};

			document.addEventListener('mousemove', fMove);
			document.addEventListener('mouseup', fUp);
		});
	}

	_persistNavWidth(pWidth)
	{
		try
		{
			if (pWidth && typeof localStorage !== 'undefined')
			{
				localStorage.setItem('pict-inline-doc-nav-width', pWidth);
			}
		}
		catch (pError) { /* storage unavailable — the width just won't persist */ }
	}

	_restoreNavWidth()
	{
		try
		{
			if (typeof localStorage === 'undefined')
			{
				return;
			}
			let tmpSaved = localStorage.getItem('pict-inline-doc-nav-width');
			if (!tmpSaved)
			{
				return;
			}
			let tmpContainer = document.querySelector('.pict-inline-doc');
			if (tmpContainer)
			{
				tmpContainer.style.setProperty('--pict-inline-doc-nav-width', tmpSaved);
			}
		}
		catch (pError) { /* ignore */ }
	}

	/**
	 * Set up a ResizeObserver to toggle compact mode when the container
	 * is too narrow for a side-by-side nav + content layout.
	 *
	 * Below the threshold, the nav switches to a horizontal top bar.
	 */
	_setupCompactModeObserver()
	{
		if (typeof document === 'undefined' || typeof ResizeObserver === 'undefined')
		{
			return;
		}

		let tmpContainer = document.querySelector('.pict-inline-doc');
		if (!tmpContainer)
		{
			return;
		}

		// Clean up any previous observer
		if (this._resizeObserver)
		{
			this._resizeObserver.disconnect();
		}

		let tmpCompactThreshold = 550;

		this._resizeObserver = new ResizeObserver((pEntries) =>
		{
			for (let i = 0; i < pEntries.length; i++)
			{
				let tmpWidth = pEntries[i].contentRect.width;

				if (tmpWidth < tmpCompactThreshold)
				{
					tmpContainer.classList.add('pict-inline-doc-compact');
				}
				else
				{
					tmpContainer.classList.remove('pict-inline-doc-compact');
				}
			}
		});

		this._resizeObserver.observe(tmpContainer);

		// Also do an immediate check
		let tmpWidth = tmpContainer.offsetWidth;
		if (tmpWidth > 0 && tmpWidth < tmpCompactThreshold)
		{
			tmpContainer.classList.add('pict-inline-doc-compact');
		}
	}
}

module.exports = InlineDocumentationLayoutView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":733}],666:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-Nav",

	DefaultRenderable: "InlineDoc-Nav-Display",
	DefaultContentDestinationAddress: "#InlineDoc-Nav-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc-nav {
			display: flex;
			flex-direction: column;
			height: 100%;
		}
		.pict-inline-doc-nav-collapsed-header {
			display: flex;
			align-items: center;
			padding: 0.5em 0.8em;
			cursor: pointer;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			background: var(--theme-color-background-secondary, #F7F5F0);
			user-select: none;
		}
		.pict-inline-doc-nav-collapsed-header:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
		}
		.pict-inline-doc-nav-chevron {
			font-size: 0.6em;
			transition: transform 0.2s ease;
			color: var(--theme-color-text-muted, #8A7F72);
			display: inline-flex;
			align-items: center;
			margin-right: 0.5em;
		}
		.pict-inline-doc-nav-chevron.expanded {
			transform: rotate(90deg);
		}
		.pict-inline-doc-nav-current-title {
			font-size: 0.9em;
			font-weight: 500;
			color: var(--theme-color-text-primary, #3D3229);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			flex: 1;
		}
		.pict-inline-doc-nav-outline {
			display: none;
			overflow-y: auto;
		}
		.pict-inline-doc-nav-outline.expanded {
			display: block;
		}
		.pict-inline-doc-nav-filter {
			padding: 0.3em 0.6em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
		}
		.pict-inline-doc-nav-filter input {
			width: 100%;
			box-sizing: border-box;
			padding: 0.3em 0.5em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			font-size: 0.85em;
			outline: none;
		}
		.pict-inline-doc-nav-filter input:focus {
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-group {
			margin-bottom: 0;
		}
		.pict-inline-doc-nav-group-header {
			display: flex;
			align-items: center;
			padding: 0.4em 0.8em;
			font-weight: 600;
			font-size: 0.7em;
			color: var(--theme-color-text-secondary, #5E5549);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			cursor: pointer;
			user-select: none;
		}
		.pict-inline-doc-nav-group-header:hover {
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-nav-group-toggle {
			margin-right: 0.35em;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 0.85em;
			height: 0.85em;
			color: currentColor;
			transition: transform 0.15s ease;
		}
		.pict-inline-doc-nav-group-toggle svg {
			width: 100%;
			height: 100%;
			display: block;
		}
		.pict-inline-doc-nav-group-toggle.collapsed {
			transform: rotate(-90deg);
		}
		.pict-inline-doc-nav-group.collapsed .pict-inline-doc-nav-group-items {
			display: none;
		}
		.pict-inline-doc-nav-folder-toggle {
			margin-right: 0.15em;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 0.8em;
			height: 0.8em;
			vertical-align: -0.1em;
			opacity: 0.6;
			cursor: pointer;
			transition: transform 0.15s ease, opacity 0.1s ease;
		}
		.pict-inline-doc-nav-folder-toggle svg {
			width: 100%;
			height: 100%;
			display: block;
		}
		.pict-inline-doc-nav-folder-toggle:hover {
			opacity: 1;
		}
		.pict-inline-doc-nav-folder-toggle.collapsed {
			transform: rotate(-90deg);
		}
		.pict-inline-doc-nav-item {
			display: block;
			padding: 0.25em 0.8em 0.25em calc(1.6em + var(--doc-nav-level, 0) * 0.85em);
			color: var(--theme-color-text-secondary, #5E5549);
			text-decoration: none;
			font-size: 0.85em;
			cursor: pointer;
			border-left: 3px solid transparent;
			transition: background 0.1s ease, border-color 0.1s ease;
		}
		.pict-inline-doc-nav-item:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
		}
		.pict-inline-doc-nav-folder {
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-nav-folder-icon {
			margin-right: 0.4em;
			vertical-align: -0.12em;
			opacity: 0.65;
		}
		.pict-inline-doc-nav-file-icon {
			margin-right: 0.4em;
			vertical-align: -0.12em;
			opacity: 0.55;
		}
		.pict-inline-doc-nav-section-dot {
			margin-right: 0.4em;
			vertical-align: -0.12em;
			opacity: 0.3;
		}
		.pict-inline-doc-nav-item.active {
			background: var(--theme-color-background-hover, #E8E3D8);
			color: var(--theme-color-brand-primary, #2E7D74);
			border-left-color: var(--theme-color-brand-primary, #2E7D74);
			font-weight: 500;
		}
		.pict-inline-doc-nav-heading {
			display: block;
			padding: 0.15em 0.8em 0.15em calc(2.4em + var(--doc-nav-level, 0) * 0.85em);
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.78em;
			cursor: pointer;
			border-left: 3px solid transparent;
			transition: background 0.1s ease, color 0.1s ease;
		}
		.pict-inline-doc-nav-heading:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-inline-doc-nav-heading.h3 {
			padding-left: calc(3.2em + var(--doc-nav-level, 0) * 0.85em);
			font-size: 0.72em;
		}
		/* Search icon in collapsed header */
		.pict-inline-doc-nav-search-icon {
			display: inline-flex;
			align-items: center;
			color: var(--theme-color-text-muted, #8A7F72);
			opacity: 0.5;
			transition: opacity 0.2s;
			flex-shrink: 0;
			margin-left: 0.3em;
		}
		.pict-inline-doc-nav-search-icon:hover {
			opacity: 1;
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Search results section */
		.pict-inline-doc-nav-search-results {
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding: 0.3em 0;
		}
		.pict-inline-doc-nav-search-status {
			padding: 0.2em 0.8em;
			font-size: 0.7em;
			color: var(--theme-color-text-muted, #8A7F72);
			text-transform: uppercase;
			letter-spacing: 0.03em;
		}
		.pict-inline-doc-nav-search-result {
			display: flex;
			align-items: baseline;
			padding: 0.25em 0.8em 0.25em 1.2em;
			cursor: pointer;
			font-size: 0.82em;
			color: var(--theme-color-text-primary, #3D3229);
			text-decoration: none;
			transition: background 0.1s ease;
			gap: 0.5em;
		}
		.pict-inline-doc-nav-search-result:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
		}
		.pict-inline-doc-nav-search-result-title {
			flex: 1;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.pict-inline-doc-nav-search-result-group {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			white-space: nowrap;
		}
		/* External link indicator */
		.pict-inline-doc-nav-item-external {
			color: var(--theme-color-text-muted, #8A7F72);
		}
		.pict-inline-doc-nav-item-external:hover {
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-external-icon {
			display: inline;
			margin-left: 0.3em;
			opacity: 0.5;
			vertical-align: -0.05em;
		}
		.pict-inline-doc-nav-topic-badge {
			display: inline-block;
			margin: 0.5em 1em;
			padding: 0.3em 0.7em;
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-radius: 4px;
			font-size: 0.8em;
			font-weight: 500;
		}
		.pict-inline-doc-nav-topic-clear {
			margin-left: 0.5em;
			cursor: pointer;
			opacity: 0.8;
		}
		.pict-inline-doc-nav-topic-clear:hover {
			opacity: 1;
		}
		.pict-inline-doc-nav-toolbar {
			display: flex;
			align-items: center;
			gap: 0.3em;
			padding: 0.3em 1em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
		}
		.pict-inline-doc-nav-toolbar-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.9em;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-nav-toolbar-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			border-color: var(--theme-color-border-default, #C4BDB3);
		}
		.pict-inline-doc-nav-toolbar-btn.accent {
			border-color: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-toolbar-btn.accent:hover {
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-nav-toolbar-btn.active {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-toolbar-btn.active:hover {
			background: var(--theme-color-brand-primary-hover, #266D65);
		}
		.pict-inline-doc-nav-toolbar-spacer {
			flex: 1;
		}
		/* Structure management: per-node hover actions (rename / delete) */
		.pict-inline-doc-nav-item,
		.pict-inline-doc-nav-group-header {
			position: relative;
		}
		.pict-inline-doc-nav-node-actions {
			position: absolute;
			right: 0.35em;
			top: 50%;
			transform: translateY(-50%);
			display: none;
			align-items: center;
			gap: 0.1em;
		}
		.pict-inline-doc-nav-item:hover > .pict-inline-doc-nav-node-actions,
		.pict-inline-doc-nav-group-header:hover > .pict-inline-doc-nav-node-actions {
			display: inline-flex;
		}
		.pict-inline-doc-nav-node-action {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 1.4em;
			height: 1.4em;
			border-radius: 3px;
			color: var(--theme-color-text-muted, #8A7F72);
			background: var(--theme-color-background-panel, #fff);
			cursor: pointer;
			opacity: 0.85;
		}
		.pict-inline-doc-nav-node-action:hover {
			background: var(--theme-color-background-tertiary, #EDE8DF);
			color: var(--theme-color-text-primary, #3D3229);
			opacity: 1;
		}
		.pict-inline-doc-nav-node-action.danger:hover {
			color: var(--theme-color-status-error, #B3261E);
		}
		/* Drag-and-drop reorder / move affordances */
		.pict-inline-doc-nav-item[draggable="true"],
		.pict-inline-doc-nav-group-header[draggable="true"] {
			cursor: grab;
		}
		.pict-inline-doc-nav-dragging {
			opacity: 0.45;
		}
		.pict-inline-doc-nav-drop-into {
			background: var(--theme-color-background-hover, #E8E3D8) !important;
			outline: 1px dashed var(--theme-color-brand-primary, #2E7D74);
			outline-offset: -1px;
		}
		.pict-inline-doc-nav-drop-before {
			box-shadow: inset 0 2px 0 0 var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-nav-drop-after {
			box-shadow: inset 0 -2px 0 0 var(--theme-color-brand-primary, #2E7D74);
		}
	`,

	Templates:
	[
		{
			Hash: "InlineDoc-Nav-Template",
			Template: /*html*/`<div class="pict-inline-doc-nav" id="InlineDoc-Nav-Body"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "InlineDoc-Nav-Display",
			TemplateHash: "InlineDoc-Nav-Template",
			ContentDestinationAddress: "#InlineDoc-Nav-Container",
			RenderMethod: "replace"
		}
	]
};

class InlineDocumentationNavView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender()
	{
		this._renderNavigation();
		return super.onAfterRender();
	}

	/**
	 * Build and inject the navigation HTML into the nav body.
	 */
	_renderNavigation()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('InlineDoc-Nav-Body');
		if (!tmpContainer)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState)
		{
			return;
		}

		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
		// The active document's headings render as sub-items (an in-document outline) beneath it.
		// A host can turn that off (ShowDocumentHeadings: false) to keep the tree to files + folders
		// only; leaving headings out here also keeps them out of the filter match below.
		let tmpHeadings = [];
		if (tmpState.ShowDocumentHeadings !== false && tmpProvider && typeof tmpProvider._extractHeadings === 'function')
		{
			tmpHeadings = tmpProvider._extractHeadings();
		}

		let tmpCurrentPath = tmpState.CurrentPath || '';
		let tmpIsCollapsed = tmpState.NavCollapsed !== false;
		let tmpFilterText = tmpState.NavFilterText || '';
		let tmpCurrentDocName = this._resolveCurrentDocName(tmpState, tmpCurrentPath);

		// Reflect the collapsed state on the nav CONTAINER (the layout owns its
		// width). Collapsing then shrinks the whole panel to a thin strip and hands
		// the freed width back to the content, instead of hiding the outline while
		// the container stays full-width.
		let tmpNavContainer = document.getElementById('InlineDoc-Nav-Container');
		if (tmpNavContainer)
		{
			tmpNavContainer.classList.toggle('pict-inline-doc-nav-collapsed', tmpIsCollapsed);
		}

		let tmpHTML = '';

		let tmpSearchQuery = tmpState.SearchQuery || '';
		let tmpSearchResults = tmpState.SearchResults || [];

		// 1. Collapsed header with search icon
		let tmpChevronClass = 'pict-inline-doc-nav-chevron' + (tmpIsCollapsed ? '' : ' expanded');
		tmpHTML += '<div class="pict-inline-doc-nav-collapsed-header">';
		tmpHTML += '<span class="' + tmpChevronClass + '" id="InlineDoc-Nav-CollapseToggle">';
		tmpHTML += '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,3 11,8 6,13"/></svg>';
		tmpHTML += '</span>';
		tmpHTML += '<span class="pict-inline-doc-nav-current-title" id="InlineDoc-Nav-TitleToggle">' + this._escapeHTML(tmpCurrentDocName) + '</span>';
		tmpHTML += '<span class="pict-inline-doc-nav-search-icon" id="InlineDoc-Nav-SearchBtn" title="Search documentation">';
		tmpHTML += '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="7" r="4.5"/><line x1="10.5" y1="10.5" x2="14" y2="14"/></svg>';
		tmpHTML += '</span>';
		tmpHTML += '</div>';

		// 2. Outline body
		let tmpOutlineClass = 'pict-inline-doc-nav-outline' + (tmpIsCollapsed ? '' : ' expanded');
		tmpHTML += '<div class="' + tmpOutlineClass + '" id="InlineDoc-Nav-Outline">';

		// Search / filter input
		let tmpPlaceholder = tmpState.SearchIndexLoaded ? 'Search documentation...' : 'Filter...';
		tmpHTML += '<div class="pict-inline-doc-nav-filter">';
		tmpHTML += '<input type="text" id="InlineDoc-Nav-FilterInput" placeholder="' + tmpPlaceholder + '" value="' + this._escapeHTML(tmpSearchQuery || tmpFilterText) + '" />';
		tmpHTML += '</div>';

		// Search results (when full-text search is active)
		if (tmpSearchResults.length > 0 && tmpSearchQuery)
		{
			tmpHTML += '<div class="pict-inline-doc-nav-search-results">';
			tmpHTML += '<div class="pict-inline-doc-nav-search-status">' + tmpSearchResults.length + ' result' + (tmpSearchResults.length !== 1 ? 's' : '') + '</div>';
			for (let i = 0; i < tmpSearchResults.length && i < 15; i++)
			{
				let tmpResult = tmpSearchResults[i];
				tmpHTML += '<a class="pict-inline-doc-nav-search-result" data-search-path="' + this._escapeHTML(tmpResult.DocPath) + '">';
				tmpHTML += '<span class="pict-inline-doc-nav-search-result-title">' + this._escapeHTML(tmpResult.Title) + '</span>';
				if (tmpResult.Group)
				{
					tmpHTML += '<span class="pict-inline-doc-nav-search-result-group">' + this._escapeHTML(tmpResult.Group) + '</span>';
				}
				tmpHTML += '</a>';
			}
			tmpHTML += '</div>';
		}

		// Topic badge
		tmpHTML += this._renderTopicBadge(tmpState);

		// Toolbar
		tmpHTML += this._renderToolbar(tmpState);

		// Group tree
		tmpHTML += this._renderGroupTree(tmpState, tmpCurrentPath, tmpHeadings, tmpFilterText);

		tmpHTML += '</div>';

		tmpContainer.innerHTML = tmpHTML;

		// Wire up click handlers
		this._wireClickHandlers(tmpContainer);
	}

	/**
	 * Resolve the display name for the currently loaded document.
	 *
	 * Searches SidebarGroups for a matching item name; falls back to the path.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @param {string} pCurrentPath - The current document path
	 * @returns {string} The resolved document name
	 */
	_resolveCurrentDocName(pState, pCurrentPath)
	{
		if (!pCurrentPath)
		{
			return 'Documentation';
		}

		let tmpGroups = pState.SidebarGroups || [];

		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];

			// Check if the group itself matches
			if (tmpGroup.Path && tmpGroup.Path === pCurrentPath)
			{
				return tmpGroup.Name || pCurrentPath;
			}

			let tmpItems = tmpGroup.Items || [];
			for (let j = 0; j < tmpItems.length; j++)
			{
				if (tmpItems[j].Path === pCurrentPath)
				{
					return tmpItems[j].Name || pCurrentPath;
				}
			}
		}

		return pCurrentPath;
	}

	/**
	 * Render the topic badge HTML if a topic is active.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @returns {string} HTML string for the topic badge, or empty string
	 */
	_renderTopicBadge(pState)
	{
		let tmpActiveTopic = pState.Topic;

		if (!tmpActiveTopic || !pState.Topics || !pState.Topics[tmpActiveTopic])
		{
			return '';
		}

		let tmpTopicDef = pState.Topics[tmpActiveTopic];
		let tmpTopicName = tmpTopicDef.TopicTitle || tmpTopicDef.Name || tmpActiveTopic;

		let tmpHTML = '<div class="pict-inline-doc-nav-topic-badge">'
			+ this._escapeHTML(tmpTopicName)
			+ '<span class="pict-inline-doc-nav-topic-clear" id="InlineDoc-Nav-ClearTopic">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">'
			+ '<line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/>'
			+ '</svg></span>'
			+ '</div>';

		return tmpHTML;
	}

	/**
	 * The host-wired structure capabilities (create/delete/move/reorder). Falls back
	 * to an all-false shape when the provider or the API is unavailable, so callers
	 * can read it unconditionally.
	 *
	 * @returns {object} capability flags
	 */
	_structureCaps()
	{
		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
		if (tmpProvider && typeof tmpProvider.getStructureCapabilities === 'function')
		{
			return tmpProvider.getStructureCapabilities();
		}
		return { create: false, createFolder: false, createDocument: false, delete: false, move: false, reorder: false, any: false };
	}

	/**
	 * Render the toolbar HTML: structure controls (New Folder / New Doc) when the
	 * host wired them, plus the topic-management controls when TopicManagerEnabled.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @returns {string} HTML string for the toolbar, or empty string
	 */
	_renderToolbar(pState)
	{
		let tmpCaps = this._structureCaps();

		if (!pState.TopicManagerEnabled && !tmpCaps.any && !pState.AssetToggleEnabled)
		{
			return '';
		}

		let tmpHTML = '<div class="pict-inline-doc-nav-toolbar">';

		// Structure buttons — only the ones the host actually wired.
		if (tmpCaps.createFolder)
		{
			tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn" id="InlineDoc-Nav-NewFolder" title="New folder">'
				+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
				+ '<path d="M1.5 4.5a1 1 0 0 1 1-1h3.2l1.3 1.4h5.5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z"/>'
				+ '<line x1="8" y1="7" x2="8" y2="11"/><line x1="6" y1="9" x2="10" y2="9"/>'
				+ '</svg></button>';
		}
		if (tmpCaps.createDocument)
		{
			tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn" id="InlineDoc-Nav-NewDoc" title="New document">'
				+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
				+ '<path d="M4 2.5H9L12 5.5V13.5H4Z"/><polyline points="9 2.5 9 5.5 12 5.5"/>'
				+ '<line x1="8" y1="8" x2="8" y2="11.5"/><line x1="6.25" y1="9.75" x2="9.75" y2="9.75"/>'
				+ '</svg></button>';
		}

		// "Show non-document files" toggle (host opt-in). Placed after the structure buttons so it
		// appears in both the read-only and topic-manager toolbars.
		tmpHTML += this._assetToggleButtonHTML(pState);

		if (!pState.TopicManagerEnabled)
		{
			tmpHTML += '<span class="pict-inline-doc-nav-toolbar-spacer"></span>';
			tmpHTML += '</div>';
			return tmpHTML;
		}

		tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn" id="InlineDoc-Nav-ManageTopics" title="Manage Topics">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
			+ '<circle cx="8" cy="8" r="2.5"/>'
			+ '<path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41"/>'
			+ '</svg></button>';

		if (pState.CurrentRoute)
		{
			tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn accent" id="InlineDoc-Nav-BindTopic" title="Bind topic to current route">'
				+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
				+ '<path d="M6.5 9.5a3.5 3.5 0 005 0l2-2a3.5 3.5 0 00-5-5l-1 1"/>'
				+ '<path d="M9.5 6.5a3.5 3.5 0 00-5 0l-2 2a3.5 3.5 0 005 5l1-1"/>'
				+ '</svg></button>';
		}

		let tmpTooltipEditActive = pState.TooltipEditMode ? ' active' : '';
		tmpHTML += '<button class="pict-inline-doc-nav-toolbar-btn' + tmpTooltipEditActive + '" id="InlineDoc-Nav-TooltipEditMode" title="Toggle tooltip edit mode">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
			+ '<path d="M14 10a1.5 1.5 0 01-1.5 1.5H4l-3 3V3A1.5 1.5 0 012.5 1.5h10A1.5 1.5 0 0114 3z"/>'
			+ '</svg></button>';

		tmpHTML += '<span class="pict-inline-doc-nav-toolbar-spacer"></span>';
		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * The "show / hide non-document files" toolbar toggle, rendered only when the host opted in
	 * (AssetToggleEnabled). Active styling reflects the current preference; the click handler in
	 * _wireClickHandlers flips it through the provider.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @returns {string} HTML for the toggle button, or ''
	 */
	_assetToggleButtonHTML(pState)
	{
		if (!pState.AssetToggleEnabled)
		{
			return '';
		}
		let tmpActive = pState.ShowAssetFiles ? ' active' : '';
		let tmpTitle = pState.ShowAssetFiles ? 'Hide non-document files' : 'Show non-document files';
		return '<button class="pict-inline-doc-nav-toolbar-btn' + tmpActive + '" id="InlineDoc-Nav-ToggleAssetFiles" title="' + tmpTitle + '">'
			+ '<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
			+ '<rect x="2" y="3" width="12" height="10" rx="1"/><circle cx="5.5" cy="6.5" r="1"/><path d="M2.5 11l3.2-3 2.3 2 2-1.6 3.5 3"/>'
			+ '</svg></button>';
	}

	/**
	 * Drag attributes for a movable / reorderable node. Emitted only when the host
	 * wired move or reorder and the node has a real path.
	 *
	 * @param {string} pPath - The node's real lake path
	 * @param {string} pType - 'file' or 'folder'
	 * @param {object} pCaps - Structure capabilities
	 * @returns {string} An attribute fragment (leading space) or ''
	 */
	_dragAttrs(pPath, pType, pCaps)
	{
		if (!pPath || (!pCaps.move && !pCaps.reorder))
		{
			return '';
		}
		return ' draggable="true" data-node-path="' + this._escapeHTML(pPath) + '" data-node-type="' + pType + '"';
	}

	/**
	 * Per-node hover actions (rename / delete), gated by capabilities. Requires a
	 * real path; a legacy pathless folder gets no actions.
	 *
	 * @param {string} pPath - The node's real lake path
	 * @param {string} pType - 'file' or 'folder'
	 * @param {object} pCaps - Structure capabilities
	 * @returns {string} HTML for the actions cluster, or ''
	 */
	_nodeActionsHTML(pPath, pType, pCaps)
	{
		if (!pPath || (!pCaps.move && !pCaps.delete))
		{
			return '';
		}
		// Actions carry their own data-action-path / data-action-type (NOT data-node-path)
		// so the drag / reorder queries, which select real nodes by [data-node-path], never
		// match these buttons.
		let tmpHTML = '<span class="pict-inline-doc-nav-node-actions">';
		if (pCaps.move)
		{
			tmpHTML += '<span class="pict-inline-doc-nav-node-action" data-action="rename" data-action-path="' + this._escapeHTML(pPath) + '" data-action-type="' + pType + '" title="Rename">'
				+ '<svg width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 2.5l2 2L6 12l-2.5.5L4 10z"/></svg>'
				+ '</span>';
		}
		if (pCaps.delete)
		{
			tmpHTML += '<span class="pict-inline-doc-nav-node-action danger" data-action="delete" data-action-path="' + this._escapeHTML(pPath) + '" data-action-type="' + pType + '" title="Delete">'
				+ '<svg width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="2.5 4 13.5 4"/><path d="M5.5 4V2.8h5V4M6.5 7v4M9.5 7v4M4 4l0.7 9h6.6L12 4"/></svg>'
				+ '</span>';
		}
		tmpHTML += '</span>';
		return tmpHTML;
	}

	/**
	 * Build the group/item/heading tree HTML.
	 *
	 * @param {object} pState - The InlineDocumentation state
	 * @param {string} pCurrentPath - The current document path
	 * @param {Array} pHeadings - Array of { Text, Slug, Level } from _extractHeadings
	 * @param {string} pFilterText - The current filter text
	 * @returns {string} HTML string for the group tree
	 */
	_renderGroupTree(pState, pCurrentPath, pHeadings, pFilterText)
	{
		let tmpCaps = this._structureCaps();
		let tmpHTML = '';
		let tmpGroups = pState.SidebarGroups || [];
		let tmpActiveTopic = pState.Topic;
		let tmpTopicDocuments = null;
		let tmpFilterLower = (pFilterText || '').toLowerCase();

		// Resolve topic document filter
		if (tmpActiveTopic && pState.Topics && pState.Topics[tmpActiveTopic])
		{
			let tmpTopicDef = pState.Topics[tmpActiveTopic];

			if (tmpTopicDef.TopicHelpFilePath)
			{
				tmpTopicDocuments = [tmpTopicDef.TopicHelpFilePath];
			}
			else if (tmpTopicDef.Documents)
			{
				tmpTopicDocuments = tmpTopicDef.Documents;
			}
			else
			{
				tmpTopicDocuments = [];
			}
		}

		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];
			let tmpGroupItems = tmpGroup.Items || [];

			// Apply topic filter
			if (tmpTopicDocuments)
			{
				tmpGroupItems = tmpGroupItems.filter((pItem) =>
				{
					return tmpTopicDocuments.indexOf(pItem.Path) >= 0;
				});

				let tmpGroupMatches = tmpTopicDocuments.indexOf(tmpGroup.Path) >= 0;

				if (tmpGroupItems.length < 1 && !tmpGroupMatches)
				{
					continue;
				}
			}

			// Apply text filter — match item names AND headings of the active document
			if (tmpFilterLower)
			{
				tmpGroupItems = tmpGroupItems.filter((pItem) =>
				{
					if ((pItem.Name || '').toLowerCase().indexOf(tmpFilterLower) >= 0)
					{
						return true;
					}
					// For the active document, also check heading text
					if (pItem.Path === pCurrentPath && pHeadings.length > 0)
					{
						for (let h = 0; h < pHeadings.length; h++)
						{
							if ((pHeadings[h].Text || '').toLowerCase().indexOf(tmpFilterLower) >= 0)
							{
								return true;
							}
						}
					}
					return false;
				});

				let tmpGroupNameMatches = (tmpGroup.Name || '').toLowerCase().indexOf(tmpFilterLower) >= 0;

				if (tmpGroupItems.length < 1 && !tmpGroupNameMatches)
				{
					continue;
				}
			}

			let tmpGroupKey = tmpGroup.Key || tmpGroup.Name || ('group-' + i);
			let tmpIsGroupCollapsed = pState.CollapsedGroups && pState.CollapsedGroups[tmpGroupKey];
			let tmpGroupClass = 'pict-inline-doc-nav-group' + (tmpIsGroupCollapsed ? ' collapsed' : '');
			let tmpToggleClass = 'pict-inline-doc-nav-group-toggle' + (tmpIsGroupCollapsed ? ' collapsed' : '');

			// A top-level group is a root node: a folder (its real FolderPath) or a
			// root document (its Path). Drag attrs on the header enable root reorder /
			// drop-into-folder; the hover actions enable rename/delete of the top node.
			let tmpGroupPath = tmpGroup.FolderPath || tmpGroup.Path || '';
			let tmpGroupType = tmpGroup.FolderPath ? 'folder' : 'file';

			tmpHTML += '<div class="' + tmpGroupClass + '" data-group="' + this._escapeHTML(tmpGroupKey) + '">';
			tmpHTML += '<div class="pict-inline-doc-nav-group-header"' + this._dragAttrs(tmpGroupPath, tmpGroupType, tmpCaps) + '>';
			tmpHTML += '<span class="' + tmpToggleClass + '" aria-hidden="true">'
				+ '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" '
				+ 'stroke-linecap="round" stroke-linejoin="round">'
				+ '<polyline points="3 6 8 11 13 6"/>'
				+ '</svg></span>';
			tmpHTML += this._escapeHTML(tmpGroup.Name);
			tmpHTML += this._nodeActionsHTML(tmpGroupPath, tmpGroupType, tmpCaps);
			tmpHTML += '</div>';

			tmpHTML += '<div class="pict-inline-doc-nav-group-items">';

			// If the group itself has a path, show it as the first item
			if (tmpGroup.Path)
			{
				let tmpActive = (pCurrentPath === tmpGroup.Path) ? ' active' : '';
				tmpHTML += '<a class="pict-inline-doc-nav-item' + tmpActive
					+ '" data-doc-path="' + this._escapeHTML(tmpGroup.Path) + '"'
					+ this._dragAttrs(tmpGroup.Path, 'file', tmpCaps) + '>'
					+ this._fileIconSVG()
					+ this._escapeHTML(tmpGroup.Name)
					+ this._nodeActionsHTML(tmpGroup.Path, 'file', tmpCaps)
					+ '</a>';

				// If this is the active item, render heading sub-items
				if (pCurrentPath === tmpGroup.Path)
				{
					tmpHTML += this._renderHeadingSubItems(pHeadings, tmpFilterLower, 0);
				}
			}

			// Folders collapse by hiding their descendants. The item list is flat (each row carries
			// its own Level for indent), so a collapsed folder is applied as a path prefix: any later
			// row whose path starts with it is skipped. Folder paths carry a trailing slash, so the
			// prefix match stops at the directory boundary and never catches a sibling.
			let tmpHidePrefixes = [];
			for (let j = 0; j < tmpGroupItems.length; j++)
			{
				let tmpItem = tmpGroupItems[j];
				let tmpIndent = ' style="--doc-nav-level:' + (tmpItem.Level || 0) + '"';

				let tmpItemKey = tmpItem.Path || tmpItem.FolderPath || '';
				let tmpHiddenUnderFolder = false;
				for (let h = 0; h < tmpHidePrefixes.length; h++)
				{
					if (tmpItemKey && tmpItemKey.indexOf(tmpHidePrefixes[h]) === 0) { tmpHiddenUnderFolder = true; break; }
				}
				if (tmpHiddenUnderFolder) { continue; }

				// Sub-folder node (no document of its own). Indent it by its
				// level and, when it has descendants, make it clickable so it
				// opens its first child document; mark it with a folder glyph.
				// A real FolderPath (trailing-slash sidebar link) makes it a drag
				// source, a drop target, and rename/delete-able.
				if (!tmpItem.Path)
				{
					let tmpFolderPath = tmpItem.FolderPath || '';
					let tmpFolderDrag = this._dragAttrs(tmpFolderPath, 'folder', tmpCaps);
					let tmpFolderActions = this._nodeActionsHTML(tmpFolderPath, 'folder', tmpCaps);
					let tmpFolderCollapsed = !!(pState.CollapsedFolders && pState.CollapsedFolders[tmpFolderPath]);
					if (tmpItem.FirstChildPath)
					{
						// Folders are navigational shortcuts to their first child; the
						// child item carries the active highlight, so the folder doesn't.
						// The chevron collapses the folder (hides its descendants) without
						// navigating -- its click is stopped in _wireClickHandlers.
						let tmpFolderToggle = '<span class="pict-inline-doc-nav-folder-toggle' + (tmpFolderCollapsed ? ' collapsed' : '')
							+ '" data-folder-toggle="' + this._escapeHTML(tmpFolderPath) + '" title="Collapse or expand this folder">'
							+ '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 8 11 13 6"/></svg>'
							+ '</span>';
						tmpHTML += '<a class="pict-inline-doc-nav-item pict-inline-doc-nav-folder'
							+ '" data-doc-path="' + this._escapeHTML(tmpItem.FirstChildPath) + '"' + tmpIndent + tmpFolderDrag + '>'
							+ tmpFolderToggle
							+ this._folderIconSVG()
							+ this._escapeHTML(tmpItem.Name)
							+ tmpFolderActions
							+ '</a>';
						// A collapsed folder hides every later row under its path.
						if (tmpFolderCollapsed) { tmpHidePrefixes.push(tmpFolderPath); }
					}
					else
					{
						// An empty folder (marker-only) still gets its path, so it is a
						// valid drop target and can be renamed / removed.
						tmpHTML += '<span class="pict-inline-doc-nav-item pict-inline-doc-nav-folder"' + tmpIndent + tmpFolderDrag + '>'
							+ this._folderIconSVG()
							+ this._escapeHTML(tmpItem.Name)
							+ tmpFolderActions
							+ '</span>';
					}
					continue;
				}

				if (tmpItem.External && tmpItem.ExternalURL)
				{
					// External link — opens in a new tab
					tmpHTML += '<a class="pict-inline-doc-nav-item pict-inline-doc-nav-item-external'
						+ '" data-external-url="' + this._escapeHTML(tmpItem.ExternalURL) + '"' + tmpIndent + '>'
						+ this._fileIconSVG()
						+ this._escapeHTML(tmpItem.Name)
						+ '<svg class="pict-inline-doc-nav-external-icon" width="0.75em" height="0.75em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h4"/><polyline points="8,2 14,2 14,8"/><line x1="14" y1="2" x2="7" y2="9"/></svg>'
						+ '</a>';
				}
				else
				{
					let tmpActive = (pCurrentPath === tmpItem.Path) ? ' active' : '';
					tmpHTML += '<a class="pict-inline-doc-nav-item' + tmpActive
						+ '" data-doc-path="' + this._escapeHTML(tmpItem.Path) + '"' + tmpIndent
						+ this._dragAttrs(tmpItem.Path, 'file', tmpCaps) + '>'
						+ this._fileIconSVG()
						+ this._escapeHTML(tmpItem.Name)
						+ this._nodeActionsHTML(tmpItem.Path, 'file', tmpCaps)
						+ '</a>';

					// If this is the active item, render heading sub-items
					if (pCurrentPath === tmpItem.Path)
					{
						tmpHTML += this._renderHeadingSubItems(pHeadings, tmpFilterLower, tmpItem.Level || 0);
					}
				}
			}

			tmpHTML += '</div>';
			tmpHTML += '</div>';
		}

		return tmpHTML;
	}

	/**
	 * A small folder glyph for sub-folder nav nodes. Uses currentColor so it
	 * follows the theme like the other inline nav icons.
	 *
	 * @returns {string} inline SVG HTML
	 */
	_folderIconSVG()
	{
		return '<svg class="pict-inline-doc-nav-folder-icon" width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1.5 5a1 1 0 0 1 1-1h3.2l1.3 1.4h5.5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z"/></svg>';
	}

	/**
	 * A small document glyph (a page with a folded corner) for markdown file
	 * nodes. Same footprint as the folder glyph so files and folders line up at
	 * the same depth.
	 *
	 * @returns {string} inline SVG HTML
	 */
	_fileIconSVG()
	{
		return '<svg class="pict-inline-doc-nav-file-icon" width="0.85em" height="0.85em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2.5H9L12 5.5V13.5H4Z"/><polyline points="9 2.5 9 5.5 12 5.5"/></svg>';
	}

	/**
	 * A small filled dot marking an in-document section (a heading sub-item shown
	 * beneath the active document). currentColor + low opacity keeps it quiet.
	 *
	 * @returns {string} inline SVG HTML
	 */
	_sectionDotSVG()
	{
		return '<svg class="pict-inline-doc-nav-section-dot" width="0.85em" height="0.85em" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="2.3" fill="currentColor"/></svg>';
	}

	/**
	 * Render heading sub-items (h2 and h3) beneath the active nav item.
	 *
	 * @param {Array} pHeadings - Array of { Text, Slug, Level }
	 * @param {string} pFilterText - Lowercase filter text
	 * @returns {string} HTML string for heading sub-items
	 */
	_renderHeadingSubItems(pHeadings, pFilterText, pBaseLevel)
	{
		if (!pHeadings || pHeadings.length < 1)
		{
			return '';
		}

		// Indent the headings relative to their (possibly nested) parent
		// document item, so they line up one notch under it at any tree depth.
		let tmpLevelStyle = ' style="--doc-nav-level:' + (pBaseLevel || 0) + '"';
		let tmpHTML = '';

		for (let i = 0; i < pHeadings.length; i++)
		{
			let tmpHeading = pHeadings[i];
			let tmpText = tmpHeading.Text || '';

			// Apply filter
			if (pFilterText && tmpText.toLowerCase().indexOf(pFilterText) < 0)
			{
				continue;
			}

			let tmpLevelClass = (tmpHeading.Level === 3) ? ' h3' : '';
			tmpHTML += '<a class="pict-inline-doc-nav-heading' + tmpLevelClass
				+ '" data-heading-slug="' + this._escapeHTML(tmpHeading.Slug) + '"' + tmpLevelStyle + '>'
				+ this._sectionDotSVG()
				+ this._escapeHTML(tmpText)
				+ '</a>';
		}

		return tmpHTML;
	}

	/**
	 * Wire click handlers on navigation items, group headers, and controls.
	 *
	 * @param {HTMLElement} pContainer - The nav container element
	 */
	_wireClickHandlers(pContainer)
	{
		let tmpProvider = this.pict.providers['Pict-InlineDocumentation'];
		let tmpState = this.pict.AppData.InlineDocumentation;

		let tmpSelf = this;

		// Collapse toggle (chevron)
		let tmpCollapseToggle = pContainer.querySelector('#InlineDoc-Nav-CollapseToggle');
		if (tmpCollapseToggle)
		{
			tmpCollapseToggle.addEventListener('click', () =>
			{
				if (tmpState)
				{
					tmpState.NavCollapsed = !tmpState.NavCollapsed;
				}
				tmpSelf._renderNavigation();
			});
		}

		// Title click also toggles
		let tmpTitleToggle = pContainer.querySelector('#InlineDoc-Nav-TitleToggle');
		if (tmpTitleToggle)
		{
			tmpTitleToggle.addEventListener('click', () =>
			{
				if (tmpState)
				{
					tmpState.NavCollapsed = !tmpState.NavCollapsed;
				}
				tmpSelf._renderNavigation();
			});
		}

		// Search icon — expands outline and focuses search input
		let tmpSearchBtn = pContainer.querySelector('#InlineDoc-Nav-SearchBtn');
		if (tmpSearchBtn)
		{
			tmpSearchBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				if (tmpState)
				{
					tmpState.NavCollapsed = false;
				}
				tmpSelf._renderNavigation();

				let tmpInput = document.getElementById('InlineDoc-Nav-FilterInput');
				if (tmpInput)
				{
					tmpInput.focus();
				}
			});
		}

		// Search / filter input
		let tmpFilterInput = pContainer.querySelector('#InlineDoc-Nav-FilterInput');
		if (tmpFilterInput)
		{
			let tmpDebounceTimer = null;

			tmpFilterInput.addEventListener('input', (pEvent) =>
			{
				let tmpValue = pEvent.target.value || '';

				if (tmpState)
				{
					tmpState.NavFilterText = tmpValue;
				}

				// If search index is loaded, debounce full-text search
				if (tmpState && tmpState.SearchIndexLoaded && tmpProvider && typeof tmpProvider.search === 'function')
				{
					if (tmpDebounceTimer) clearTimeout(tmpDebounceTimer);
					tmpDebounceTimer = setTimeout(() =>
					{
						tmpState.SearchQuery = tmpValue;
						tmpState.SearchResults = tmpValue.trim() ? tmpProvider.search(tmpValue) : [];
						tmpSelf._renderNavigation();

						let tmpNewInput = document.getElementById('InlineDoc-Nav-FilterInput');
						if (tmpNewInput)
						{
							tmpNewInput.focus();
							let tmpLen = tmpNewInput.value.length;
							tmpNewInput.setSelectionRange(tmpLen, tmpLen);
						}
					}, 250);
				}
				else
				{
					// No search index — immediate client-side filter only
					tmpSelf._renderNavigation();

					let tmpNewInput = document.getElementById('InlineDoc-Nav-FilterInput');
					if (tmpNewInput)
					{
						tmpNewInput.focus();
						let tmpLen = tmpNewInput.value.length;
						tmpNewInput.setSelectionRange(tmpLen, tmpLen);
					}
				}
			});
		}

		// Search result clicks
		let tmpSearchResults = pContainer.querySelectorAll('.pict-inline-doc-nav-search-result[data-search-path]');
		for (let i = 0; i < tmpSearchResults.length; i++)
		{
			let tmpResult = tmpSearchResults[i];
			tmpResult.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpPath = tmpResult.getAttribute('data-search-path');
				if (tmpProvider && tmpPath)
				{
					if (tmpState)
					{
						tmpState.SearchQuery = '';
						tmpState.SearchResults = [];
						tmpState.NavFilterText = '';
					}
					tmpProvider.loadDocument(tmpPath);
				}
			});
		}

		// External links — open in new tab
		let tmpExternalLinks = pContainer.querySelectorAll('[data-external-url]');
		for (let i = 0; i < tmpExternalLinks.length; i++)
		{
			let tmpExtLink = tmpExternalLinks[i];
			tmpExtLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpURL = tmpExtLink.getAttribute('data-external-url');
				if (tmpURL)
				{
					window.open(tmpURL, '_blank');
				}
			});
		}

		// Document links
		let tmpLinks = pContainer.querySelectorAll('.pict-inline-doc-nav-item[data-doc-path]');
		for (let i = 0; i < tmpLinks.length; i++)
		{
			let tmpLink = tmpLinks[i];
			tmpLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpPath = tmpLink.getAttribute('data-doc-path');
				if (tmpProvider && tmpPath)
				{
					// Clear filter when navigating
					if (tmpState)
					{
						tmpState.NavFilterText = '';
					}
					tmpProvider.loadDocument(tmpPath);
				}
			});
		}

		// Heading links
		let tmpHeadingLinks = pContainer.querySelectorAll('.pict-inline-doc-nav-heading[data-heading-slug]');
		for (let i = 0; i < tmpHeadingLinks.length; i++)
		{
			let tmpHeadingLink = tmpHeadingLinks[i];
			tmpHeadingLink.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpSlug = tmpHeadingLink.getAttribute('data-heading-slug');
				if (tmpProvider && tmpSlug)
				{
					tmpProvider._scrollToAnchor(tmpSlug);
				}
			});
		}

		// Group collapse toggle
		let tmpHeaders = pContainer.querySelectorAll('.pict-inline-doc-nav-group-header');
		for (let i = 0; i < tmpHeaders.length; i++)
		{
			let tmpHeader = tmpHeaders[i];
			tmpHeader.addEventListener('click', () =>
			{
				let tmpGroup = tmpHeader.parentElement;
				if (tmpGroup)
				{
					tmpGroup.classList.toggle('collapsed');

					// Persist collapse state
					let tmpGroupKey = tmpGroup.getAttribute('data-group');
					if (tmpState && tmpGroupKey)
					{
						if (!tmpState.CollapsedGroups)
						{
							tmpState.CollapsedGroups = {};
						}
						let tmpToggle = tmpGroup.querySelector('.pict-inline-doc-nav-group-toggle');
						if (tmpGroup.classList.contains('collapsed'))
						{
							tmpState.CollapsedGroups[tmpGroupKey] = true;
							if (tmpToggle)
							{
								tmpToggle.classList.add('collapsed');
							}
						}
						else
						{
							delete tmpState.CollapsedGroups[tmpGroupKey];
							if (tmpToggle)
							{
								tmpToggle.classList.remove('collapsed');
							}
						}
					}
				}
			});
		}

		// Sub-folder collapse toggle. Clicking the chevron must not navigate (the folder row is a
		// link to its first child) or bubble to the group header, so it stops both. The item list is
		// flat, so collapsing re-renders the nav (descendants are skipped on rebuild); preserve the
		// scroll position so collapsing a deep folder does not jump the sidebar to the top.
		let tmpFolderToggles = pContainer.querySelectorAll('[data-folder-toggle]');
		for (let i = 0; i < tmpFolderToggles.length; i++)
		{
			let tmpFolderToggle = tmpFolderToggles[i];
			tmpFolderToggle.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				pEvent.preventDefault();
				if (!tmpState) { return; }
				let tmpFolderPath = tmpFolderToggle.getAttribute('data-folder-toggle');
				if (!tmpFolderPath) { return; }
				if (!tmpState.CollapsedFolders) { tmpState.CollapsedFolders = {}; }
				if (tmpState.CollapsedFolders[tmpFolderPath]) { delete tmpState.CollapsedFolders[tmpFolderPath]; }
				else { tmpState.CollapsedFolders[tmpFolderPath] = true; }
				let tmpOutline = document.getElementById('InlineDoc-Nav-Outline');
				let tmpScrollTop = tmpOutline ? tmpOutline.scrollTop : 0;
				tmpSelf._renderNavigation();
				let tmpOutlineAfter = document.getElementById('InlineDoc-Nav-Outline');
				if (tmpOutlineAfter) { tmpOutlineAfter.scrollTop = tmpScrollTop; }
			});
		}

		// Topic clear button
		let tmpClearBtn = pContainer.querySelector('#InlineDoc-Nav-ClearTopic');
		if (tmpClearBtn && tmpProvider)
		{
			tmpClearBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpProvider.clearTopic();
			});
		}

		// Topic manager button
		let tmpManageBtn = pContainer.querySelector('#InlineDoc-Nav-ManageTopics');
		if (tmpManageBtn)
		{
			tmpManageBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpTopicManagerView = this.pict.views['InlineDoc-TopicManager'];
				if (tmpTopicManagerView)
				{
					tmpTopicManagerView.showTopicManager();
				}
			});
		}

		// Show / hide non-document (asset) files toggle
		let tmpAssetToggleBtn = pContainer.querySelector('#InlineDoc-Nav-ToggleAssetFiles');
		if (tmpAssetToggleBtn)
		{
			tmpAssetToggleBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpDocProvider = this.pict.providers['Pict-InlineDocumentation'];
				if (tmpDocProvider && typeof tmpDocProvider.toggleAssetFiles === 'function')
				{
					tmpDocProvider.toggleAssetFiles();
				}
			});
		}

		// Tooltip edit mode toggle
		let tmpTooltipEditBtn = pContainer.querySelector('#InlineDoc-Nav-TooltipEditMode');
		if (tmpTooltipEditBtn)
		{
			tmpTooltipEditBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpDocProvider = this.pict.providers['Pict-InlineDocumentation'];
				if (tmpDocProvider)
				{
					let tmpCurrentState = this.pict.AppData.InlineDocumentation;
					tmpDocProvider.setTooltipEditMode(!tmpCurrentState.TooltipEditMode);
				}
			});
		}

		// Bind topic to route button
		let tmpBindBtn = pContainer.querySelector('#InlineDoc-Nav-BindTopic');
		if (tmpBindBtn)
		{
			tmpBindBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpTopicManagerView = this.pict.views['InlineDoc-TopicManager'];
				if (tmpTopicManagerView)
				{
					tmpTopicManagerView.showBindTopicToRoute();
				}
			});
		}

		// Structure management: toolbar create buttons, per-node rename/delete, drag reorder/move.
		this._wireStructureHandlers(pContainer);
		this._wireDragDrop(pContainer);
	}

	// ─── structure management wiring ─────────────────────────────────────
	_provider() { return this.pict.providers['Pict-InlineDocumentation']; }
	_modal() { return this.pict.views['Pict-Section-Modal']; }
	_dirname(pPath) { let p = String(pPath || ''); let i = p.lastIndexOf('/'); return i >= 0 ? p.slice(0, i) : ''; }
	_basename(pPath) { let p = String(pPath || ''); let i = p.lastIndexOf('/'); return i >= 0 ? p.slice(i + 1) : p; }

	/**
	 * Prompt for a single line of text via the modal (no native prompt()). Resolves
	 * to the trimmed value, or null if cancelled / empty.
	 */
	_promptForName(pTitle, pLabel, pDefault, pPlaceholder)
	{
		let tmpModal = this._modal();
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			return Promise.resolve(null);
		}
		let tmpDefault = this._escapeHTML(pDefault || '');
		let tmpContent = '<p style="margin:0 0 0.4em">' + this._escapeHTML(pLabel || 'Name') + '</p>'
			+ '<input type="text" id="InlineDoc-Structure-Prompt" class="pict-input" style="width:100%;box-sizing:border-box;padding:0.4em 0.5em" '
			+ 'value="' + tmpDefault + '" placeholder="' + this._escapeHTML(pPlaceholder || '') + '" '
			+ 'onkeydown="if(event.key===\'Enter\'){event.preventDefault();}" />';
		return tmpModal.show(
			{
				title: pTitle || 'Name',
				content: tmpContent,
				closeable: true,
				width: '420px',
				buttons:
				[
					{ Hash: 'cancel', Label: 'Cancel' },
					{ Hash: 'ok', Label: 'OK', Style: 'primary' }
				],
				onOpen: () =>
				{
					let tmpInput = document.getElementById('InlineDoc-Structure-Prompt');
					if (tmpInput) { tmpInput.focus(); tmpInput.select(); }
				}
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return null; }
				let tmpInput = document.getElementById('InlineDoc-Structure-Prompt');
				let tmpValue = tmpInput ? String(tmpInput.value || '').trim() : '';
				return tmpValue || null;
			});
	}

	/**
	 * Wire the toolbar create buttons and the per-node rename / delete actions.
	 *
	 * @param {HTMLElement} pContainer - The nav container element
	 */
	_wireStructureHandlers(pContainer)
	{
		let tmpSelf = this;
		let tmpProvider = this._provider();
		if (!tmpProvider) { return; }

		// New Folder
		let tmpNewFolderBtn = pContainer.querySelector('#InlineDoc-Nav-NewFolder');
		if (tmpNewFolderBtn)
		{
			tmpNewFolderBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpSelf._promptForName('New folder', 'Folder name (a path like guides/setup nests it):', '', 'folder-name').then((pName) =>
				{
					if (pName) { tmpProvider.requestCreateFolder('', pName); }
				});
			});
		}

		// New Document
		let tmpNewDocBtn = pContainer.querySelector('#InlineDoc-Nav-NewDoc');
		if (tmpNewDocBtn)
		{
			tmpNewDocBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpSelf._promptForName('New document', 'Document name (.md is added if omitted):', '', 'my-document').then((pName) =>
				{
					if (pName) { tmpProvider.requestCreateDocument('', pName); }
				});
			});
		}

		// Rename / Delete actions on every node
		let tmpActions = pContainer.querySelectorAll('.pict-inline-doc-nav-node-action[data-action]');
		for (let i = 0; i < tmpActions.length; i++)
		{
			let tmpAction = tmpActions[i];
			tmpAction.addEventListener('click', (pEvent) =>
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				let tmpKind = tmpAction.getAttribute('data-action');
				let tmpPath = tmpAction.getAttribute('data-action-path');
				let tmpType = tmpAction.getAttribute('data-action-type') || 'file';
				if (!tmpPath) { return; }
				if (tmpKind === 'rename')
				{
					let tmpParent = tmpSelf._dirname(tmpPath);
					let tmpOldName = tmpSelf._basename(tmpPath);
					tmpSelf._promptForName('Rename', 'New name:', tmpOldName, '').then((pName) =>
					{
						if (!pName) { return; }
						let tmpNewName = pName.replace(/^\/+|\/+$/g, '');
						if (!tmpNewName || tmpNewName === tmpOldName) { return; }
						let tmpNewPath = tmpParent ? (tmpParent + '/' + tmpNewName) : tmpNewName;
						tmpProvider.requestMoveNode(tmpPath, tmpNewPath);
					});
				}
				else if (tmpKind === 'delete')
				{
					let tmpModal = tmpSelf._modal();
					let tmpName = tmpSelf._basename(tmpPath);
					let tmpMessage = (tmpType === 'folder')
						? ('Delete the folder "' + tmpName + '" and everything inside it? This cannot be undone.')
						: ('Delete "' + tmpName + '"? This cannot be undone.');
					if (tmpModal && typeof tmpModal.confirm === 'function')
					{
						tmpModal.confirm(tmpMessage, { title: 'Delete', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true }).then((pOk) =>
						{
							if (pOk) { tmpProvider.requestDeleteNode(tmpPath, tmpType); }
						});
					}
					else
					{
						tmpProvider.requestDeleteNode(tmpPath, tmpType);
					}
				}
			});
		}
	}

	/**
	 * Collect the ordered basenames of every node sharing a parent, in DOM order
	 * (deduped by path so a group whose header and inner item share a path counts
	 * once). Used to persist a drag reorder.
	 *
	 * @param {HTMLElement} pContainer - The nav container
	 * @param {string} pParent - The parent path ('' for root)
	 * @returns {Array<string>} Ordered basenames
	 */
	_gatherSiblingNames(pContainer, pParent)
	{
		let tmpNodes = pContainer.querySelectorAll('[data-node-path]');
		let tmpNames = [];
		let tmpSeen = {};
		for (let i = 0; i < tmpNodes.length; i++)
		{
			let tmpPath = tmpNodes[i].getAttribute('data-node-path');
			if (!tmpPath || this._dirname(tmpPath) !== pParent) { continue; }
			if (tmpSeen[tmpPath]) { continue; }
			tmpSeen[tmpPath] = true;
			tmpNames.push(this._basename(tmpPath));
		}
		return tmpNames;
	}

	/**
	 * Wire HTML5 drag-and-drop: reorder within a parent (-> requestReorder) and drop
	 * onto a folder to move into it (-> requestMoveNode). Optimistic visual cues; the
	 * server rewrite + reloadSidebar make it authoritative.
	 *
	 * @param {HTMLElement} pContainer - The nav container element
	 */
	_wireDragDrop(pContainer)
	{
		let tmpSelf = this;
		let tmpProvider = this._provider();
		if (!tmpProvider) { return; }
		let tmpCaps = this._structureCaps();
		if (!tmpCaps.move && !tmpCaps.reorder) { return; }

		let tmpDraggables = pContainer.querySelectorAll('[data-node-path][draggable="true"]');
		let fClearMarks = () =>
		{
			let tmpMarked = pContainer.querySelectorAll('.pict-inline-doc-nav-drop-into, .pict-inline-doc-nav-drop-before, .pict-inline-doc-nav-drop-after');
			for (let i = 0; i < tmpMarked.length; i++)
			{
				tmpMarked[i].classList.remove('pict-inline-doc-nav-drop-into', 'pict-inline-doc-nav-drop-before', 'pict-inline-doc-nav-drop-after');
			}
		};

		for (let i = 0; i < tmpDraggables.length; i++)
		{
			let tmpEl = tmpDraggables[i];

			tmpEl.addEventListener('dragstart', (pEvent) =>
			{
				let tmpPath = tmpEl.getAttribute('data-node-path');
				tmpSelf._dragState =
				{
					Path: tmpPath,
					Type: tmpEl.getAttribute('data-node-type') || 'file',
					Parent: tmpSelf._dirname(tmpPath),
					Name: tmpSelf._basename(tmpPath)
				};
				tmpEl.classList.add('pict-inline-doc-nav-dragging');
				if (pEvent.dataTransfer)
				{
					pEvent.dataTransfer.effectAllowed = 'move';
					try { pEvent.dataTransfer.setData('text/plain', tmpPath); } catch (pErr) { /* IE guard */ }
				}
			});

			tmpEl.addEventListener('dragend', () =>
			{
				tmpEl.classList.remove('pict-inline-doc-nav-dragging');
				fClearMarks();
				tmpSelf._dragState = null;
			});

			tmpEl.addEventListener('dragover', (pEvent) =>
			{
				let tmpDrag = tmpSelf._dragState;
				if (!tmpDrag) { return; }
				let tmpTargetPath = tmpEl.getAttribute('data-node-path');
				let tmpTargetType = tmpEl.getAttribute('data-node-type') || 'file';
				let tmpMode = tmpSelf._dropModeFor(tmpDrag, tmpTargetPath, tmpTargetType, pEvent, tmpEl, tmpCaps);
				if (!tmpMode) { return; }
				pEvent.preventDefault();
				if (pEvent.dataTransfer) { pEvent.dataTransfer.dropEffect = 'move'; }
				tmpEl.classList.remove('pict-inline-doc-nav-drop-into', 'pict-inline-doc-nav-drop-before', 'pict-inline-doc-nav-drop-after');
				tmpEl.classList.add('pict-inline-doc-nav-drop-' + tmpMode);
			});

			tmpEl.addEventListener('dragleave', () =>
			{
				tmpEl.classList.remove('pict-inline-doc-nav-drop-into', 'pict-inline-doc-nav-drop-before', 'pict-inline-doc-nav-drop-after');
			});

			tmpEl.addEventListener('drop', (pEvent) =>
			{
				let tmpDrag = tmpSelf._dragState;
				if (!tmpDrag) { return; }
				let tmpTargetPath = tmpEl.getAttribute('data-node-path');
				let tmpTargetType = tmpEl.getAttribute('data-node-type') || 'file';
				let tmpMode = tmpSelf._dropModeFor(tmpDrag, tmpTargetPath, tmpTargetType, pEvent, tmpEl, tmpCaps);
				pEvent.preventDefault();
				pEvent.stopPropagation();
				fClearMarks();
				if (!tmpMode) { return; }

				if (tmpMode === 'into')
				{
					// Move the dragged node into the target folder (keeping its basename).
					let tmpDestination = tmpTargetPath + '/' + tmpDrag.Name;
					tmpProvider.requestMoveNode(tmpDrag.Path, tmpDestination);
					return;
				}

				// Reorder within the shared parent: rebuild the sibling name list with the
				// dragged node repositioned before/after the target, then persist.
				let tmpNames = tmpSelf._gatherSiblingNames(pContainer, tmpDrag.Parent);
				let tmpFromIdx = tmpNames.indexOf(tmpDrag.Name);
				let tmpTargetName = tmpSelf._basename(tmpTargetPath);
				if (tmpFromIdx < 0) { return; }
				tmpNames.splice(tmpFromIdx, 1);
				let tmpTargetIdx = tmpNames.indexOf(tmpTargetName);
				if (tmpTargetIdx < 0) { return; }
				let tmpInsertIdx = (tmpMode === 'after') ? tmpTargetIdx + 1 : tmpTargetIdx;
				tmpNames.splice(tmpInsertIdx, 0, tmpDrag.Name);
				tmpProvider.requestReorder(tmpDrag.Parent, tmpNames);
			});
		}
	}

	/**
	 * Decide the drop mode for a hovered target: 'into' (move into a folder),
	 * 'before' / 'after' (reorder within the same parent), or null (not a valid drop).
	 */
	_dropModeFor(pDrag, pTargetPath, pTargetType, pEvent, pTargetEl, pCaps)
	{
		if (!pTargetPath || pTargetPath === pDrag.Path) { return null; }
		// Never drop a folder into itself or a descendant.
		if (pDrag.Type === 'folder' && (pTargetPath === pDrag.Path || pTargetPath.indexOf(pDrag.Path + '/') === 0)) { return null; }

		// Drop onto a different folder that is not already this node's parent -> move in.
		if (pCaps.move && pTargetType === 'folder' && pTargetPath !== pDrag.Parent)
		{
			return 'into';
		}

		// Same-parent nodes -> reorder (before/after by pointer position).
		if (pCaps.reorder && this._dirname(pTargetPath) === pDrag.Parent)
		{
			let tmpRect = pTargetEl.getBoundingClientRect();
			let tmpMidpoint = tmpRect.top + (tmpRect.height / 2);
			return (pEvent.clientY >= tmpMidpoint) ? 'after' : 'before';
		}

		return null;
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - Text to escape
	 * @returns {string} Escaped text
	 */
	_escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = InlineDocumentationNavView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":733}],667:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "InlineDoc-TopicManager",

	AutoRender: false,

	CSS: /*css*/`
		.pict-inline-doc-tm-topic-list {
			max-height: 400px;
			overflow-y: auto;
			margin: 0 -0.5em;
		}
		.pict-inline-doc-tm-topic-item {
			display: flex;
			align-items: center;
			padding: 0.6em 0.8em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-topic-item:hover {
			background: var(--theme-color-background-secondary, #F5F0E8);
		}
		.pict-inline-doc-tm-topic-item:last-child {
			border-bottom: none;
		}
		.pict-inline-doc-tm-topic-info {
			flex: 1;
			min-width: 0;
		}
		.pict-inline-doc-tm-topic-title {
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
			font-size: 0.95em;
		}
		.pict-inline-doc-tm-topic-meta {
			font-size: 0.8em;
			color: var(--theme-color-text-muted, #8A7F72);
			margin-top: 0.15em;
		}
		.pict-inline-doc-tm-topic-actions {
			display: flex;
			gap: 0.3em;
			flex-shrink: 0;
		}
		.pict-inline-doc-tm-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.85em;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-tm-action-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
			border-color: var(--theme-color-border-default, #C4BDB3);
		}
		.pict-inline-doc-tm-action-btn.danger:hover {
			background: var(--theme-color-background-tertiary, #FDE8E8);
			border-color: var(--theme-color-status-error, #E57373);
			color: var(--theme-color-status-error, #C62828);
		}
		.pict-inline-doc-tm-new-topic {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0.7em;
			margin-top: 0.5em;
			border: 1px dashed var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			color: var(--theme-color-brand-primary, #2E7D74);
			font-size: 0.9em;
			font-weight: 500;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-tm-new-topic:hover {
			background: var(--theme-color-background-hover, #F0F9F7);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-empty {
			text-align: center;
			padding: 2em 1em;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.9em;
		}
		.pict-inline-doc-tm-form-group {
			margin-bottom: 0.8em;
		}
		.pict-inline-doc-tm-form-label {
			display: block;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--theme-color-text-secondary, #5E5549);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			margin-bottom: 0.3em;
		}
		.pict-inline-doc-tm-form-input {
			width: 100%;
			padding: 0.45em 0.6em;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			box-sizing: border-box;
		}
		.pict-inline-doc-tm-form-input:focus {
			outline: none;
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 0 0 2px rgba(46, 125, 116, 0.15);
		}
		.pict-inline-doc-tm-form-input[readonly] {
			background: var(--theme-color-background-secondary, #F5F0E8);
			color: var(--theme-color-text-muted, #8A7F72);
		}
		.pict-inline-doc-tm-form-hint {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			margin-top: 0.2em;
		}
		.pict-inline-doc-tm-routes-section {
			margin-top: 0.5em;
		}
		.pict-inline-doc-tm-route-chips {
			display: flex;
			flex-wrap: wrap;
			gap: 0.3em;
			margin-bottom: 0.5em;
		}
		.pict-inline-doc-tm-route-chip {
			display: inline-flex;
			align-items: center;
			padding: 0.2em 0.5em;
			background: var(--theme-color-background-hover, #E8E3D8);
			border-radius: 12px;
			font-size: 0.82em;
			color: var(--theme-color-text-primary, #3D3229);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
		}
		.pict-inline-doc-tm-route-chip-remove {
			margin-left: 0.4em;
			cursor: pointer;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 0.9em;
			line-height: 1;
		}
		.pict-inline-doc-tm-route-chip-remove:hover {
			color: var(--theme-color-status-error, #C62828);
		}
		.pict-inline-doc-tm-route-actions {
			display: flex;
			flex-wrap: wrap;
			gap: 0.3em;
		}
		.pict-inline-doc-tm-route-action-btn {
			display: inline-flex;
			align-items: center;
			padding: 0.25em 0.5em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.8em;
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-route-action-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-tm-route-action-btn.accent {
			border-color: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-route-action-btn.accent:hover {
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-tm-route-input-row {
			display: none;
			align-items: center;
			gap: 0.3em;
			margin-top: 0.4em;
		}
		.pict-inline-doc-tm-route-input-row.visible {
			display: flex;
		}
		.pict-inline-doc-tm-route-input {
			flex: 1;
			padding: 0.35em 0.5em;
			font-size: 0.85em;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			color: var(--theme-color-text-primary, #3D3229);
			background: var(--theme-color-background-panel,    #FDFCFA);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 3px;
		}
		.pict-inline-doc-tm-route-input:focus {
			outline: none;
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-wc-container {
			padding: 0.5em 0;
		}
		.pict-inline-doc-tm-wc-label {
			font-size: 0.85em;
			color: var(--theme-color-text-secondary, #5E5549);
			margin-bottom: 0.6em;
		}
		.pict-inline-doc-tm-wc-segments {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 0.15em;
			margin-bottom: 0.8em;
		}
		.pict-inline-doc-tm-wc-slash {
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1.1em;
			font-weight: 300;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
		}
		.pict-inline-doc-tm-wc-segment {
			display: inline-flex;
			align-items: center;
			padding: 0.4em 0.7em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-primary, #3D3229);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.9em;
			cursor: pointer;
			transition: background 0.15s, border-color 0.15s, opacity 0.15s;
			user-select: none;
		}
		.pict-inline-doc-tm-wc-segment:hover {
			border-color: var(--theme-color-brand-primary, #2E7D74);
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-tm-wc-segment.selected {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-wc-segment.after-wildcard {
			opacity: 0.35;
			border-style: dashed;
			cursor: default;
		}
		.pict-inline-doc-tm-wc-segment.after-wildcard:hover {
			border-color: var(--theme-color-border-default, #DDD6CA);
			background: var(--theme-color-background-panel,    #fff);
		}
		.pict-inline-doc-tm-wc-wildcard-star {
			display: inline-flex;
			align-items: center;
			padding: 0.4em 0.6em;
			color: var(--theme-color-brand-primary, #2E7D74);
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 1.1em;
			font-weight: 700;
		}
		.pict-inline-doc-tm-wc-preview {
			padding: 0.5em 0.7em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-inline-doc-tm-wc-preview-label {
			font-size: 0.75em;
			color: var(--theme-color-text-muted, #8A7F72);
			text-transform: uppercase;
			letter-spacing: 0.03em;
			margin-bottom: 0.3em;
		}
		.pict-inline-doc-tm-bind-route-display {
			padding: 0.5em 0.7em;
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #E5DED4);
			border-radius: 4px;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-bottom: 0.8em;
		}
		.pict-inline-doc-tm-bind-topic-list {
			max-height: 250px;
			overflow-y: auto;
			margin-bottom: 0.6em;
		}
		.pict-inline-doc-tm-bind-topic-option {
			display: flex;
			align-items: center;
			padding: 0.5em 0.6em;
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			cursor: pointer;
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-bind-topic-option:hover {
			background: var(--theme-color-background-secondary, #F5F0E8);
		}
		.pict-inline-doc-tm-bind-topic-option.selected {
			background: var(--theme-color-background-hover, #F0F9F7);
		}
		.pict-inline-doc-tm-bind-radio {
			width: 16px;
			height: 16px;
			border: 2px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 50%;
			margin-right: 0.6em;
			flex-shrink: 0;
			position: relative;
		}
		.pict-inline-doc-tm-bind-topic-option.selected .pict-inline-doc-tm-bind-radio {
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-bind-topic-option.selected .pict-inline-doc-tm-bind-radio::after {
			content: '';
			position: absolute;
			top: 3px;
			left: 3px;
			width: 6px;
			height: 6px;
			background: var(--theme-color-brand-primary, #2E7D74);
			border-radius: 50%;
		}
		.pict-inline-doc-tm-bind-route-type {
			display: flex;
			gap: 0.5em;
			margin-bottom: 0.5em;
		}
		.pict-inline-doc-tm-bind-route-type-btn {
			flex: 1;
			padding: 0.5em;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			background: var(--theme-color-background-panel,    #fff);
			color: var(--theme-color-text-secondary, #5E5549);
			font-size: 0.85em;
			text-align: center;
			cursor: pointer;
			transition: background 0.1s, border-color 0.1s;
		}
		.pict-inline-doc-tm-bind-route-type-btn:hover {
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-inline-doc-tm-bind-route-type-btn.selected {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #fff);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-inline-doc-tm-sidebar-list {
			max-height: 300px;
			overflow-y: auto;
		}
		.pict-inline-doc-tm-sidebar-item {
			padding: 0.4em 0.6em;
			cursor: pointer;
			font-size: 0.9em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			transition: background 0.1s;
		}
		.pict-inline-doc-tm-sidebar-item:hover {
			background: var(--theme-color-background-secondary, #F5F0E8);
		}
		.pict-inline-doc-tm-sidebar-item .path {
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 0.85em;
			color: var(--theme-color-text-muted, #8A7F72);
			margin-left: 0.5em;
		}
		.pict-inline-doc-tm-validation-error {
			color: var(--theme-color-status-error, #C62828);
			font-size: 0.8em;
			margin-top: 0.3em;
		}
	`,

	Templates: [],
	Renderables: []
};

class InlineDocumentationTopicManagerView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Get the modal view instance if available.
	 *
	 * @returns {Object|null} The PictSectionModal view, or null
	 */
	_getModal()
	{
		return this.pict.views['PictSectionModal'] || this.pict.views['Pict-Section-Modal'] || null;
	}

	/**
	 * Get the inline documentation provider.
	 *
	 * @returns {Object|null} The provider instance
	 */
	_getProvider()
	{
		return this.pict.providers['Pict-InlineDocumentation'] || null;
	}

	// -- Topic List --

	/**
	 * Show the topic manager modal with the full topic list.
	 */
	showTopicManager()
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal)
		{
			this.log.warn('InlineDocumentation TopicManager: Pict-Section-Modal view is not registered.');
			return;
		}

		if (!tmpProvider)
		{
			return;
		}

		let tmpTopics = tmpProvider.getTopicList();
		let tmpContent = this._buildTopicListHTML(tmpTopics);

		tmpModal.show(
		{
			title: 'Manage Topics',
			content: tmpContent,
			closeable: true,
			width: '520px',
			buttons:
			[
				{ Hash: 'close', Label: 'Close', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireTopicListHandlers(pDialog);
			}
		});
	}

	/**
	 * Build the HTML for the topic list modal.
	 *
	 * @param {Array} pTopics - Array from getTopicList()
	 * @returns {string} HTML content
	 */
	_buildTopicListHTML(pTopics)
	{
		if (!pTopics || pTopics.length < 1)
		{
			return '<div class="pict-inline-doc-tm-empty">No topics defined yet.</div>'
				+ '<div class="pict-inline-doc-tm-new-topic" data-action="new-topic">+ New Topic</div>';
		}

		let tmpHTML = '<div class="pict-inline-doc-tm-topic-list">';

		for (let i = 0; i < pTopics.length; i++)
		{
			let tmpTopic = pTopics[i];
			tmpHTML += '<div class="pict-inline-doc-tm-topic-item" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '">';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-info">';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-title">' + this._escapeHTML(tmpTopic.TopicTitle) + '</div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-meta">';
			tmpHTML += this._escapeHTML(tmpTopic.TopicCode);
			if (tmpTopic.TopicHelpFilePath)
			{
				tmpHTML += ' &middot; ' + this._escapeHTML(tmpTopic.TopicHelpFilePath);
			}
			tmpHTML += ' &middot; ' + tmpTopic.RouteCount + ' route' + (tmpTopic.RouteCount !== 1 ? 's' : '');
			tmpHTML += '</div>';
			tmpHTML += '</div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-actions">';
			tmpHTML += '<button class="pict-inline-doc-tm-action-btn" data-action="edit" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '" title="Edit"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 1.5l3 3L5 14H2v-3z"/><line x1="9" y1="4" x2="12" y2="7"/></svg></button>';
			tmpHTML += '<button class="pict-inline-doc-tm-action-btn danger" data-action="delete" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '" title="Delete"><svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg></button>';
			tmpHTML += '</div>';
			tmpHTML += '</div>';
		}

		tmpHTML += '</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-new-topic" data-action="new-topic">+ New Topic</div>';

		return tmpHTML;
	}

	/**
	 * Wire click handlers for the topic list modal.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 */
	_wireTopicListHandlers(pDialog)
	{
		let tmpSelf = this;
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		// Edit buttons
		let tmpEditBtns = pDialog.querySelectorAll('[data-action="edit"]');
		for (let i = 0; i < tmpEditBtns.length; i++)
		{
			tmpEditBtns[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpCode = tmpEditBtns[i].getAttribute('data-topic-code');
				// Dismiss the list modal, then open editor
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() => { tmpSelf.showTopicEditor(tmpCode); }, 250);
			});
		}

		// Delete buttons
		let tmpDeleteBtns = pDialog.querySelectorAll('[data-action="delete"]');
		for (let i = 0; i < tmpDeleteBtns.length; i++)
		{
			tmpDeleteBtns[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpCode = tmpDeleteBtns[i].getAttribute('data-topic-code');

				if (tmpModal && tmpModal.confirm)
				{
					tmpModal.confirm(
						'Are you sure you want to delete the topic "' + tmpCode + '"?',
						{ title: 'Delete Topic', dangerous: true }
					).then((pConfirmed) =>
					{
						if (pConfirmed && tmpProvider)
						{
							tmpProvider.removeTopic(tmpCode);
							tmpProvider.saveTopics();

							// Re-render nav
							let tmpNavView = tmpSelf.pict.views['InlineDoc-Nav'];
							if (tmpNavView)
							{
								tmpNavView.render();
							}

							if (tmpModal.toast)
							{
								tmpModal.toast('Topic deleted.', { type: 'success' });
							}

							// Re-open the list
							setTimeout(() => { tmpSelf.showTopicManager(); }, 250);
						}
					});
				}
			});
		}

		// New topic button
		let tmpNewBtn = pDialog.querySelector('[data-action="new-topic"]');
		if (tmpNewBtn)
		{
			tmpNewBtn.addEventListener('click', () =>
			{
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() => { tmpSelf.showTopicEditor(null); }, 250);
			});
		}
	}

	// -- Topic Editor --

	/**
	 * Show the topic editor modal for creating or editing a topic.
	 *
	 * @param {string|null} pTopicCode - Topic code to edit, or null for new
	 */
	showTopicEditor(pTopicCode)
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		let tmpIsNew = !pTopicCode;
		let tmpTopic = null;

		if (pTopicCode && tmpState.Topics && tmpState.Topics[pTopicCode])
		{
			// Clone for editing
			tmpTopic = JSON.parse(JSON.stringify(tmpState.Topics[pTopicCode]));
		}
		else
		{
			tmpTopic =
			{
				TopicCode: '',
				TopicTitle: '',
				TopicHelpFilePath: '',
				Routes: []
			};
		}

		let tmpContent = this._buildTopicEditorHTML(tmpTopic, tmpIsNew);

		// Track editor routes state in closure
		let tmpEditorRoutes = tmpTopic.Routes ? tmpTopic.Routes.slice() : [];

		tmpModal.show(
		{
			title: tmpIsNew ? 'New Topic' : 'Edit Topic',
			content: tmpContent,
			closeable: true,
			width: '500px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireTopicEditorHandlers(pDialog, tmpTopic, tmpIsNew, tmpEditorRoutes);
			}
		}).then((pResult) =>
		{
			if (pResult === 'save')
			{
				this._handleTopicEditorSave(tmpTopic, tmpIsNew, tmpEditorRoutes);
			}
			else
			{
				// Return to list on cancel
				setTimeout(() => { this.showTopicManager(); }, 250);
			}
		});
	}

	/**
	 * Build the HTML for the topic editor form.
	 *
	 * @param {Object} pTopic - The topic data
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @returns {string} HTML content
	 */
	_buildTopicEditorHTML(pTopic, pIsNew)
	{
		let tmpHTML = '';

		// Topic Code
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Topic Code</label>';
		if (pIsNew)
		{
			tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-code" value="" placeholder="MY-TOPIC-CODE" />';
			tmpHTML += '<div class="pict-inline-doc-tm-form-hint">Uppercase letters, numbers, and hyphens only.</div>';
		}
		else
		{
			tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-code" value="' + this._escapeHTML(pTopic.TopicCode) + '" readonly />';
		}
		tmpHTML += '<div class="pict-inline-doc-tm-validation-error" id="tm-editor-code-error"></div>';
		tmpHTML += '</div>';

		// Topic Title
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Title</label>';
		tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-title" value="' + this._escapeHTML(pTopic.TopicTitle || pTopic.Name || '') + '" placeholder="My Topic Title" />';
		tmpHTML += '<div class="pict-inline-doc-tm-validation-error" id="tm-editor-title-error"></div>';
		tmpHTML += '</div>';

		// Help File Path
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Help Document</label>';
		tmpHTML += '<div style="display:flex;gap:0.3em;align-items:center;">';
		tmpHTML += '<input type="text" class="pict-inline-doc-tm-form-input" id="tm-editor-helpfile" value="' + this._escapeHTML(pTopic.TopicHelpFilePath || '') + '" placeholder="help-topic.md" style="flex:1;" />';
		tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn" id="tm-editor-browse-sidebar" title="Browse sidebar documents">Browse</button>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		// Routes
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Routes</label>';
		tmpHTML += '<div class="pict-inline-doc-tm-routes-section">';
		tmpHTML += '<div class="pict-inline-doc-tm-route-chips" id="tm-editor-route-chips">';
		tmpHTML += this._buildRouteChipsHTML(pTopic.Routes || []);
		tmpHTML += '</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-route-actions">';
		tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn" id="tm-editor-add-route">+ Add Route</button>';

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (tmpState && tmpState.CurrentRoute)
		{
			tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn accent" id="tm-editor-add-current-route">+ Current Route</button>';
			tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn accent" id="tm-editor-build-wildcard">Build Wildcard</button>';
		}

		tmpHTML += '</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-route-input-row" id="tm-editor-route-input-row">';
		tmpHTML += '<input type="text" class="pict-inline-doc-tm-route-input" id="tm-editor-route-input" placeholder="/my/route" />';
		tmpHTML += '<button class="pict-inline-doc-tm-route-action-btn accent" id="tm-editor-route-input-add">Add</button>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * Build HTML for route chips.
	 *
	 * @param {Array} pRoutes - Array of route pattern strings
	 * @returns {string} HTML for the chips
	 */
	_buildRouteChipsHTML(pRoutes)
	{
		if (!pRoutes || pRoutes.length < 1)
		{
			return '<span style="font-size:0.8em;color:var(--theme-color-text-muted, #8A7F72);">No routes bound.</span>';
		}

		let tmpHTML = '';
		for (let i = 0; i < pRoutes.length; i++)
		{
			tmpHTML += '<span class="pict-inline-doc-tm-route-chip">';
			tmpHTML += this._escapeHTML(pRoutes[i]);
			tmpHTML += '<span class="pict-inline-doc-tm-route-chip-remove" data-route="' + this._escapeHTML(pRoutes[i]) + '">&times;</span>';
			tmpHTML += '</span>';
		}
		return tmpHTML;
	}

	/**
	 * Refresh the route chips in an open editor dialog.
	 *
	 * @param {Array} pRoutes - Current routes array
	 */
	_refreshRouteChips(pRoutes)
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById('tm-editor-route-chips');
		if (tmpContainer)
		{
			tmpContainer.innerHTML = this._buildRouteChipsHTML(pRoutes);
			this._wireRouteChipRemoveHandlers(pRoutes);
		}
	}

	/**
	 * Wire remove handlers on route chips.
	 *
	 * @param {Array} pRoutes - The mutable routes array
	 */
	_wireRouteChipRemoveHandlers(pRoutes)
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		let tmpSelf = this;
		let tmpRemoveBtns = document.querySelectorAll('.pict-inline-doc-tm-route-chip-remove');
		for (let i = 0; i < tmpRemoveBtns.length; i++)
		{
			tmpRemoveBtns[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpRoute = tmpRemoveBtns[i].getAttribute('data-route');
				let tmpIdx = pRoutes.indexOf(tmpRoute);
				if (tmpIdx >= 0)
				{
					pRoutes.splice(tmpIdx, 1);
				}
				tmpSelf._refreshRouteChips(pRoutes);
			});
		}
	}

	/**
	 * Wire all handlers for the topic editor form.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 * @param {Object} pTopic - The topic data
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @param {Array} pEditorRoutes - Mutable routes array for this editor session
	 */
	_wireTopicEditorHandlers(pDialog, pTopic, pIsNew, pEditorRoutes)
	{
		let tmpSelf = this;
		let tmpProvider = this._getProvider();
		let tmpState = this.pict.AppData.InlineDocumentation;

		// Route chip remove handlers
		this._wireRouteChipRemoveHandlers(pEditorRoutes);

		// Add Route button — show input row
		let tmpAddRouteBtn = document.getElementById('tm-editor-add-route');
		if (tmpAddRouteBtn)
		{
			tmpAddRouteBtn.addEventListener('click', () =>
			{
				let tmpRow = document.getElementById('tm-editor-route-input-row');
				if (tmpRow)
				{
					tmpRow.classList.toggle('visible');
					let tmpInput = document.getElementById('tm-editor-route-input');
					if (tmpInput)
					{
						tmpInput.focus();
					}
				}
			});
		}

		// Add route from text input
		let tmpRouteInputAddBtn = document.getElementById('tm-editor-route-input-add');
		if (tmpRouteInputAddBtn)
		{
			tmpRouteInputAddBtn.addEventListener('click', () =>
			{
				let tmpInput = document.getElementById('tm-editor-route-input');
				if (tmpInput && tmpInput.value.trim())
				{
					let tmpRoute = tmpInput.value.trim();
					if (tmpRoute.charAt(0) !== '/')
					{
						tmpRoute = '/' + tmpRoute;
					}
					if (pEditorRoutes.indexOf(tmpRoute) < 0)
					{
						pEditorRoutes.push(tmpRoute);
						tmpSelf._refreshRouteChips(pEditorRoutes);
					}
					tmpInput.value = '';
				}
			});
		}

		// Enter key on route input
		let tmpRouteInput = document.getElementById('tm-editor-route-input');
		if (tmpRouteInput)
		{
			tmpRouteInput.addEventListener('keydown', (pEvent) =>
			{
				if (pEvent.key === 'Enter')
				{
					pEvent.preventDefault();
					if (tmpRouteInputAddBtn)
					{
						tmpRouteInputAddBtn.click();
					}
				}
			});
		}

		// Add Current Route button
		let tmpAddCurrentBtn = document.getElementById('tm-editor-add-current-route');
		if (tmpAddCurrentBtn && tmpState && tmpState.CurrentRoute)
		{
			tmpAddCurrentBtn.addEventListener('click', () =>
			{
				let tmpRoute = tmpState.CurrentRoute;
				if (pEditorRoutes.indexOf(tmpRoute) < 0)
				{
					pEditorRoutes.push(tmpRoute);
					tmpSelf._refreshRouteChips(pEditorRoutes);
				}
			});
		}

		// Build Wildcard button
		let tmpWildcardBtn = document.getElementById('tm-editor-build-wildcard');
		if (tmpWildcardBtn && tmpProvider && tmpState && tmpState.CurrentRoute)
		{
			tmpWildcardBtn.addEventListener('click', () =>
			{
				let tmpModal = tmpSelf._getModal();
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() =>
				{
					tmpSelf.showWildcardBuilder(tmpState.CurrentRoute, (pPattern) =>
					{
						if (pPattern && pEditorRoutes.indexOf(pPattern) < 0)
						{
							pEditorRoutes.push(pPattern);
						}
						// Re-open the editor
						tmpSelf._reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes);
					});
				}, 250);
			});
		}

		// Browse Sidebar button
		let tmpBrowseBtn = document.getElementById('tm-editor-browse-sidebar');
		if (tmpBrowseBtn)
		{
			tmpBrowseBtn.addEventListener('click', () =>
			{
				let tmpModal = tmpSelf._getModal();
				if (tmpModal && tmpModal.dismissModals)
				{
					tmpModal.dismissModals();
				}
				setTimeout(() =>
				{
					tmpSelf._showSidebarPicker((pPath) =>
					{
						if (pPath)
						{
							pTopic.TopicHelpFilePath = pPath;
						}
						tmpSelf._reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes);
					});
				}, 250);
			});
		}
	}

	/**
	 * Re-open the topic editor after returning from a sub-flow (wildcard builder, sidebar picker).
	 *
	 * Captures current form values from the DOM before the modal was dismissed,
	 * then reconstructs the editor with updated state.
	 *
	 * @param {Object} pTopic - The topic data (may have been updated by sub-flow)
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @param {Array} pEditorRoutes - Current routes for this editor session
	 */
	_reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes)
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			return;
		}

		// Rebuild the topic from whatever was captured
		let tmpContent = this._buildTopicEditorHTML(
		{
			TopicCode: pTopic.TopicCode,
			TopicTitle: pTopic.TopicTitle,
			TopicHelpFilePath: pTopic.TopicHelpFilePath,
			Routes: pEditorRoutes
		}, pIsNew);

		tmpModal.show(
		{
			title: pIsNew ? 'New Topic' : 'Edit Topic',
			content: tmpContent,
			closeable: true,
			width: '500px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'save', Label: 'Save', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireTopicEditorHandlers(pDialog, pTopic, pIsNew, pEditorRoutes);
			}
		}).then((pResult) =>
		{
			if (pResult === 'save')
			{
				this._handleTopicEditorSave(pTopic, pIsNew, pEditorRoutes);
			}
			else
			{
				setTimeout(() => { this.showTopicManager(); }, 250);
			}
		});
	}

	/**
	 * Handle saving from the topic editor.
	 *
	 * Reads form values, validates, and persists.
	 *
	 * @param {Object} pTopic - The original topic data
	 * @param {boolean} pIsNew - Whether this is a new topic
	 * @param {Array} pEditorRoutes - Current routes from the editor
	 */
	_handleTopicEditorSave(pTopic, pIsNew, pEditorRoutes)
	{
		let tmpProvider = this._getProvider();
		let tmpModal = this._getModal();
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpProvider)
		{
			return;
		}

		// Read form values from DOM (they're still present briefly during dismiss)
		let tmpCode = '';
		let tmpTitle = '';
		let tmpHelpFile = '';

		if (typeof document !== 'undefined')
		{
			let tmpCodeInput = document.getElementById('tm-editor-code');
			let tmpTitleInput = document.getElementById('tm-editor-title');
			let tmpHelpInput = document.getElementById('tm-editor-helpfile');

			if (tmpCodeInput) { tmpCode = tmpCodeInput.value.trim(); }
			if (tmpTitleInput) { tmpTitle = tmpTitleInput.value.trim(); }
			if (tmpHelpInput) { tmpHelpFile = tmpHelpInput.value.trim(); }
		}

		// Validation
		let tmpErrors = [];

		if (pIsNew)
		{
			if (!tmpCode)
			{
				tmpErrors.push('Topic Code is required.');
			}
			else if (!/^[A-Z0-9][A-Z0-9-]*$/.test(tmpCode))
			{
				tmpErrors.push('Topic Code must use uppercase letters, numbers, and hyphens only.');
			}
			else if (tmpState.Topics && tmpState.Topics[tmpCode])
			{
				tmpErrors.push('A topic with code "' + tmpCode + '" already exists.');
			}
		}
		else
		{
			tmpCode = pTopic.TopicCode;
		}

		if (!tmpTitle)
		{
			tmpErrors.push('Title is required.');
		}

		if (tmpErrors.length > 0)
		{
			if (tmpModal && tmpModal.toast)
			{
				tmpModal.toast(tmpErrors.join(' '), { type: 'error' });
			}
			// Re-open editor with current values
			pTopic.TopicTitle = tmpTitle;
			pTopic.TopicHelpFilePath = tmpHelpFile;
			if (pIsNew)
			{
				pTopic.TopicCode = tmpCode;
			}
			setTimeout(() => { this._reopenEditorAfterSubflow(pTopic, pIsNew, pEditorRoutes); }, 300);
			return;
		}

		// Apply changes
		if (pIsNew)
		{
			tmpProvider.addTopic(tmpCode,
			{
				TopicCode: tmpCode,
				TopicTitle: tmpTitle,
				TopicHelpFilePath: tmpHelpFile,
				Routes: pEditorRoutes
			});
		}
		else
		{
			tmpProvider.updateTopic(tmpCode,
			{
				TopicTitle: tmpTitle,
				TopicHelpFilePath: tmpHelpFile,
				Routes: pEditorRoutes
			});
		}

		tmpProvider.saveTopics();

		// Re-render nav
		let tmpNavView = this.pict.views['InlineDoc-Nav'];
		if (tmpNavView)
		{
			tmpNavView.render();
		}

		if (tmpModal && tmpModal.toast)
		{
			tmpModal.toast('Topic saved.', { type: 'success' });
		}

		// Return to topic list
		setTimeout(() => { this.showTopicManager(); }, 300);
	}

	// -- Wildcard Builder --

	/**
	 * Show the wildcard builder modal.
	 *
	 * Displays route segments as clickable blocks and lets the user
	 * visually choose where the wildcard starts.
	 *
	 * @param {string} pCurrentRoute - The route to build a pattern for
	 * @param {Function} fOnSelect - Callback receiving the selected pattern (or null on cancel)
	 */
	showWildcardBuilder(pCurrentRoute, fOnSelect)
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			if (typeof fOnSelect === 'function') { fOnSelect(null); }
			return;
		}

		let tmpSegments = tmpProvider.getRouteSegments(pCurrentRoute);

		if (tmpSegments.length < 1)
		{
			if (tmpModal.toast)
			{
				tmpModal.toast('No route segments to build a wildcard from.', { type: 'error' });
			}
			if (typeof fOnSelect === 'function') { fOnSelect(null); }
			return;
		}

		// Default selection: last segment before end (or first if only one)
		let tmpSelectedIndex = Math.max(0, tmpSegments.length - 2);
		let tmpContent = this._buildWildcardBuilderHTML(tmpSegments, pCurrentRoute, tmpSelectedIndex);

		tmpModal.show(
		{
			title: 'Build Wildcard Pattern',
			content: tmpContent,
			closeable: true,
			width: '520px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'exact', Label: 'Use Exact Route' },
				{ Hash: 'pattern', Label: 'Use Pattern', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireWildcardBuilderHandlers(pDialog, tmpSegments, tmpSelectedIndex);
			}
		}).then((pResult) =>
		{
			if (pResult === 'pattern')
			{
				// Get the current selection
				let tmpPreview = (typeof document !== 'undefined') ? document.getElementById('tm-wc-preview-value') : null;
				let tmpPattern = tmpPreview ? tmpPreview.textContent : tmpSegments[tmpSelectedIndex].WildcardPattern;
				if (typeof fOnSelect === 'function') { fOnSelect(tmpPattern); }
			}
			else if (pResult === 'exact')
			{
				if (typeof fOnSelect === 'function') { fOnSelect(pCurrentRoute); }
			}
			else
			{
				if (typeof fOnSelect === 'function') { fOnSelect(null); }
			}
		});
	}

	/**
	 * Build the HTML for the wildcard builder.
	 *
	 * @param {Array} pSegments - Segment objects from getRouteSegments()
	 * @param {string} pCurrentRoute - The original route
	 * @param {number} pSelectedIndex - The initially selected segment index
	 * @returns {string} HTML content
	 */
	_buildWildcardBuilderHTML(pSegments, pCurrentRoute, pSelectedIndex)
	{
		let tmpHTML = '<div class="pict-inline-doc-tm-wc-container">';

		tmpHTML += '<div class="pict-inline-doc-tm-wc-label">Click a segment to set the wildcard boundary. Everything after the selected segment will match any path.</div>';

		tmpHTML += '<div class="pict-inline-doc-tm-wc-segments" id="tm-wc-segments">';

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpClass = 'pict-inline-doc-tm-wc-segment';
			if (i === pSelectedIndex)
			{
				tmpClass += ' selected';
			}
			else if (i > pSelectedIndex)
			{
				tmpClass += ' after-wildcard';
			}

			tmpHTML += '<span class="pict-inline-doc-tm-wc-slash">/</span>';
			tmpHTML += '<span class="' + tmpClass + '" data-segment-index="' + i + '">';
			tmpHTML += this._escapeHTML(pSegments[i].Segment);
			tmpHTML += '</span>';
		}

		tmpHTML += '<span class="pict-inline-doc-tm-wc-slash">/</span>';
		tmpHTML += '<span class="pict-inline-doc-tm-wc-wildcard-star" id="tm-wc-star">*</span>';

		tmpHTML += '</div>';

		tmpHTML += '<div class="pict-inline-doc-tm-wc-preview-label">Pattern</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-wc-preview" id="tm-wc-preview-value">';
		tmpHTML += this._escapeHTML(pSegments[pSelectedIndex].WildcardPattern);
		tmpHTML += '</div>';

		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * Wire click handlers for the wildcard builder segments.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 * @param {Array} pSegments - Segment objects
	 * @param {number} pInitialIndex - Initially selected index
	 */
	_wireWildcardBuilderHandlers(pDialog, pSegments, pInitialIndex)
	{
		let tmpSelectedIndex = pInitialIndex;

		let tmpUpdateSelection = (pNewIndex) =>
		{
			tmpSelectedIndex = pNewIndex;
			let tmpSegmentEls = pDialog.querySelectorAll('.pict-inline-doc-tm-wc-segment');
			for (let i = 0; i < tmpSegmentEls.length; i++)
			{
				let tmpIdx = parseInt(tmpSegmentEls[i].getAttribute('data-segment-index'), 10);
				tmpSegmentEls[i].classList.remove('selected', 'after-wildcard');
				if (tmpIdx === pNewIndex)
				{
					tmpSegmentEls[i].classList.add('selected');
				}
				else if (tmpIdx > pNewIndex)
				{
					tmpSegmentEls[i].classList.add('after-wildcard');
				}
			}

			let tmpPreview = pDialog.querySelector('#tm-wc-preview-value');
			if (tmpPreview)
			{
				tmpPreview.textContent = pSegments[pNewIndex].WildcardPattern;
			}
		};

		let tmpSegmentEls = pDialog.querySelectorAll('.pict-inline-doc-tm-wc-segment');
		for (let i = 0; i < tmpSegmentEls.length; i++)
		{
			tmpSegmentEls[i].addEventListener('click', () =>
			{
				let tmpIdx = parseInt(tmpSegmentEls[i].getAttribute('data-segment-index'), 10);
				tmpUpdateSelection(tmpIdx);
			});
		}
	}

	// -- Bind Topic to Route --

	/**
	 * Show the quick-bind flow for connecting a topic to the current route.
	 */
	showBindTopicToRoute()
	{
		let tmpModal = this._getModal();
		let tmpProvider = this._getProvider();

		if (!tmpModal || !tmpProvider)
		{
			return;
		}

		let tmpState = this.pict.AppData.InlineDocumentation;
		if (!tmpState || !tmpState.CurrentRoute)
		{
			if (tmpModal.toast)
			{
				tmpModal.toast('No current route to bind to.', { type: 'error' });
			}
			return;
		}

		let tmpCurrentRoute = tmpState.CurrentRoute;
		let tmpTopics = tmpProvider.getTopicList();
		let tmpContent = this._buildBindHTML(tmpCurrentRoute, tmpTopics);

		// Track selection state
		let tmpSelectedTopicCode = null;
		let tmpRouteType = 'exact'; // 'exact' or 'wildcard'

		tmpModal.show(
		{
			title: 'Bind Topic to Route',
			content: tmpContent,
			closeable: true,
			width: '480px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' },
				{ Hash: 'bind', Label: 'Bind Route', Style: 'primary' }
			],
			onOpen: (pDialog) =>
			{
				this._wireBindHandlers(pDialog, tmpTopics, tmpCurrentRoute,
					(pCode) => { tmpSelectedTopicCode = pCode; },
					(pType) => { tmpRouteType = pType; }
				);
			}
		}).then((pResult) =>
		{
			if (pResult !== 'bind' || !tmpSelectedTopicCode)
			{
				return;
			}

			if (tmpSelectedTopicCode === '__NEW__')
			{
				// Open new topic editor with current route pre-filled
				this.showTopicEditor(null);
				return;
			}

			if (tmpRouteType === 'wildcard')
			{
				// Open wildcard builder, then bind
				this.showWildcardBuilder(tmpCurrentRoute, (pPattern) =>
				{
					if (pPattern)
					{
						tmpProvider.addRouteToTopic(tmpSelectedTopicCode, pPattern);
						tmpProvider.saveTopics();

						let tmpNavView = this.pict.views['InlineDoc-Nav'];
						if (tmpNavView) { tmpNavView.render(); }

						if (tmpModal.toast)
						{
							tmpModal.toast('Route bound to topic.', { type: 'success' });
						}
					}
				});
			}
			else
			{
				// Exact match bind
				tmpProvider.addRouteToTopic(tmpSelectedTopicCode, tmpCurrentRoute);
				tmpProvider.saveTopics();

				let tmpNavView = this.pict.views['InlineDoc-Nav'];
				if (tmpNavView) { tmpNavView.render(); }

				if (tmpModal.toast)
				{
					tmpModal.toast('Route bound to topic.', { type: 'success' });
				}
			}
		});
	}

	/**
	 * Build the HTML for the bind-topic-to-route modal.
	 *
	 * @param {string} pCurrentRoute - The current route
	 * @param {Array} pTopics - Topic list
	 * @returns {string} HTML content
	 */
	_buildBindHTML(pCurrentRoute, pTopics)
	{
		let tmpHTML = '';

		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-display">' + this._escapeHTML(pCurrentRoute) + '</div>';

		// Route type selection
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Route Match Type</label>';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-type">';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-type-btn selected" data-route-type="exact">Exact Match</div>';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-route-type-btn" data-route-type="wildcard">Wildcard Pattern</div>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		// Topic selection
		tmpHTML += '<div class="pict-inline-doc-tm-form-group">';
		tmpHTML += '<label class="pict-inline-doc-tm-form-label">Select Topic</label>';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-topic-list">';

		for (let i = 0; i < pTopics.length; i++)
		{
			let tmpTopic = pTopics[i];
			tmpHTML += '<div class="pict-inline-doc-tm-bind-topic-option" data-topic-code="' + this._escapeHTML(tmpTopic.TopicCode) + '">';
			tmpHTML += '<div class="pict-inline-doc-tm-bind-radio"></div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-info">';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-title">' + this._escapeHTML(tmpTopic.TopicTitle) + '</div>';
			tmpHTML += '<div class="pict-inline-doc-tm-topic-meta">' + this._escapeHTML(tmpTopic.TopicCode) + '</div>';
			tmpHTML += '</div>';
			tmpHTML += '</div>';
		}

		// Create new option
		tmpHTML += '<div class="pict-inline-doc-tm-bind-topic-option" data-topic-code="__NEW__">';
		tmpHTML += '<div class="pict-inline-doc-tm-bind-radio"></div>';
		tmpHTML += '<div class="pict-inline-doc-tm-topic-info">';
		tmpHTML += '<div class="pict-inline-doc-tm-topic-title" style="color:var(--theme-color-brand-primary, #2E7D74);">+ Create New Topic</div>';
		tmpHTML += '</div>';
		tmpHTML += '</div>';

		tmpHTML += '</div>';
		tmpHTML += '</div>';

		return tmpHTML;
	}

	/**
	 * Wire handlers for the bind-topic-to-route modal.
	 *
	 * @param {HTMLElement} pDialog - The modal dialog element
	 * @param {Array} pTopics - Topic list
	 * @param {string} pCurrentRoute - The current route
	 * @param {Function} fOnTopicSelect - Called with selected topic code
	 * @param {Function} fOnRouteTypeSelect - Called with 'exact' or 'wildcard'
	 */
	_wireBindHandlers(pDialog, pTopics, pCurrentRoute, fOnTopicSelect, fOnRouteTypeSelect)
	{
		// Topic selection
		let tmpTopicOptions = pDialog.querySelectorAll('.pict-inline-doc-tm-bind-topic-option');
		for (let i = 0; i < tmpTopicOptions.length; i++)
		{
			tmpTopicOptions[i].addEventListener('click', () =>
			{
				// Deselect all
				for (let j = 0; j < tmpTopicOptions.length; j++)
				{
					tmpTopicOptions[j].classList.remove('selected');
				}
				tmpTopicOptions[i].classList.add('selected');
				fOnTopicSelect(tmpTopicOptions[i].getAttribute('data-topic-code'));
			});
		}

		// Route type selection
		let tmpRouteTypeBtns = pDialog.querySelectorAll('.pict-inline-doc-tm-bind-route-type-btn');
		for (let i = 0; i < tmpRouteTypeBtns.length; i++)
		{
			tmpRouteTypeBtns[i].addEventListener('click', () =>
			{
				for (let j = 0; j < tmpRouteTypeBtns.length; j++)
				{
					tmpRouteTypeBtns[j].classList.remove('selected');
				}
				tmpRouteTypeBtns[i].classList.add('selected');
				fOnRouteTypeSelect(tmpRouteTypeBtns[i].getAttribute('data-route-type'));
			});
		}
	}

	// -- Sidebar Picker --

	/**
	 * Show a sidebar document picker modal.
	 *
	 * @param {Function} fOnSelect - Callback receiving the selected path (or null)
	 */
	_showSidebarPicker(fOnSelect)
	{
		let tmpModal = this._getModal();
		let tmpState = this.pict.AppData.InlineDocumentation;

		if (!tmpModal)
		{
			if (typeof fOnSelect === 'function') { fOnSelect(null); }
			return;
		}

		let tmpGroups = (tmpState && tmpState.SidebarGroups) ? tmpState.SidebarGroups : [];
		let tmpContent = this._buildSidebarPickerHTML(tmpGroups);

		tmpModal.show(
		{
			title: 'Select Document',
			content: tmpContent,
			closeable: true,
			width: '400px',
			buttons:
			[
				{ Hash: 'cancel', Label: 'Cancel' }
			],
			onOpen: (pDialog) =>
			{
				let tmpItems = pDialog.querySelectorAll('.pict-inline-doc-tm-sidebar-item');
				for (let i = 0; i < tmpItems.length; i++)
				{
					tmpItems[i].addEventListener('click', () =>
					{
						let tmpPath = tmpItems[i].getAttribute('data-path');
						if (tmpModal.dismissModals)
						{
							tmpModal.dismissModals();
						}
						if (typeof fOnSelect === 'function') { fOnSelect(tmpPath); }
					});
				}
			}
		}).then((pResult) =>
		{
			if (pResult === 'cancel' || pResult === null)
			{
				if (typeof fOnSelect === 'function') { fOnSelect(null); }
			}
		});
	}

	/**
	 * Build the HTML for the sidebar document picker.
	 *
	 * @param {Array} pGroups - SidebarGroups array
	 * @returns {string} HTML content
	 */
	_buildSidebarPickerHTML(pGroups)
	{
		let tmpHTML = '<div class="pict-inline-doc-tm-sidebar-list">';
		let tmpHasItems = false;

		for (let i = 0; i < pGroups.length; i++)
		{
			let tmpGroup = pGroups[i];

			if (tmpGroup.Path)
			{
				tmpHasItems = true;
				tmpHTML += '<div class="pict-inline-doc-tm-sidebar-item" data-path="' + this._escapeHTML(tmpGroup.Path) + '">';
				tmpHTML += this._escapeHTML(tmpGroup.Name);
				tmpHTML += '<span class="path">' + this._escapeHTML(tmpGroup.Path) + '</span>';
				tmpHTML += '</div>';
			}

			let tmpItems = tmpGroup.Items || [];
			for (let j = 0; j < tmpItems.length; j++)
			{
				if (tmpItems[j].Path)
				{
					tmpHasItems = true;
					tmpHTML += '<div class="pict-inline-doc-tm-sidebar-item" data-path="' + this._escapeHTML(tmpItems[j].Path) + '">';
					tmpHTML += this._escapeHTML(tmpItems[j].Name);
					tmpHTML += '<span class="path">' + this._escapeHTML(tmpItems[j].Path) + '</span>';
					tmpHTML += '</div>';
				}
			}
		}

		if (!tmpHasItems)
		{
			tmpHTML += '<div class="pict-inline-doc-tm-empty">No sidebar documents found.</div>';
		}

		tmpHTML += '</div>';
		return tmpHTML;
	}

	// -- Utilities --

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - Text to escape
	 * @returns {string} Escaped text
	 */
	_escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = InlineDocumentationTopicManagerView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":733}],668:[function(require,module,exports){
module.exports={
	"RenderOnLoad": true,

	"DefaultRenderable": "Leaflet-Wrap",
	"DefaultDestinationAddress": "#Pict-Leaflet-Container-Div",

	"LeafletDestinationAddress": "Leaflet-Map-Container-Div",
	"LeafletInitialZoom": 13,
	"LeafletInitialCenter": [ 21.315603, -157.858093 ],

	"Templates": [
		{
			"Hash": "Leaflet-Container",
			"Template": "<div id=\"Leaflet-Map-Container-Div\"></div>"
		}
	],

	"Renderables": [
		{
			"RenderableHash": "Leaflet-Wrap",
			"TemplateHash": "Leaflet-Container",
			"DestinationAddress": "#Pict-Leaflet-Container-Div"
		}
	]
}
},{}],669:[function(require,module,exports){
const libPictViewClass = require('pict-view');

class PictSectionLeaflet extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, require('./Pict-Section-Leaflet-DefaultConfiguration.json'), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		this.leafletInitialCenter = this.options.LeafletInitialCenter;
		this.leafletInitialZoom = this.options.LeafletInitialZoom;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._leafletPrototype = false;

		this.leaflet = false;
	}

	connectLeafletPrototype(pLeafletPrototype)
	{
		if (typeof (pLeafletPrototype) != 'undefined')
		{
			this._leafletPrototype = pLeafletPrototype;
		}
		else
		{
			this.log.trace(`PICT-Leaflet No Leaflet Prototype defined or explicitly set; looking for it in the window object.`);
			if (typeof (window) != 'undefined')
			{
				if (typeof (window.L) != 'undefined')
				{
					this.log.trace(`PICT-Leaflet Found Leaflet Prototype in window.L.`);
					this.connectLeafletPrototype(window.L);
				}
				else
				{
					this.log.error(`PICT-Leaflet No Leaflet Prototype found in window.L.`);
					return false;
				}
			}
			else
			{
				this.log.error(`PICT-Leaflet No Leaflet Prototype found in window.leaflet -- window object unavailable.  The map will not function.`);
				return false;
			}
		}
	}

	onAfterRender()
	{
		if (this.leaflet)
		{
			delete this.leaflet;
		}
		// This is where we wire up and initialize the leaflet control.
		this.connectLeafletPrototype();
		if (this.leaflet)
		{
			// The map is already initialized.
			this.log.error(`Leaflet going to ${this.options.LeafletDestinationAddress} is already initialized!`);
			return false;
		}

		let libLeaflet = this._leafletPrototype;
		// Note the leaflet destination address is not a browser address but just the text of the ID
		this.leaflet = libLeaflet.map(this.options.LeafletDestinationAddress);

		this.leaflet.setView(this.leafletInitialCenter, this.leafletInitialZoom);

		this.onAfterInitializeLeaflet();

		return true;
	}

	onAfterInitializeLeaflet()
	{

	}
}

module.exports = PictSectionLeaflet;

module.exports.default_configuration = require('./Pict-Section-Leaflet-DefaultConfiguration.json');
},{"./Pict-Section-Leaflet-DefaultConfiguration.json":668,"pict-view":733}],670:[function(require,module,exports){
/**
 * Pict-Section-Mapping CSS
 *
 * All class names prefixed `psm-` (Pict Section Mapping). Same color
 * palette + button styling as the dashboard / operation sections so a
 * host mounting all three sees a consistent look.
 */
'use strict';

module.exports = `
.psm-root
{
	--psm-bg:           #0e1a2b;
	--psm-bg-elev:      #0a1525;
	--psm-bg-elev-2:    #0f172a;
	--psm-border:       #1e293b;
	--psm-border-soft:  #0f1c2f;
	--psm-fg:           #f8fafc;
	--psm-fg-soft:      #cbd5e1;
	--psm-fg-mute:      #94a3b8;
	--psm-fg-fade:      #64748b;
	--psm-accent:       #2563eb;
	--psm-accent-fg:    #ffffff;
	--psm-success:      #16a34a;
	--psm-success-fg:   #dcfce7;
	--psm-danger:       #b91c1c;
	--psm-danger-fg:    #fecaca;

	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	background: var(--psm-bg);
	color: var(--psm-fg);
	min-height: 100%;
}

.psm-toolbar
{
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	background: var(--psm-bg-elev);
	border-bottom: 1px solid var(--psm-border);
	flex-wrap: wrap;
}
.psm-toolbar h2 { margin: 0; font-size: 16px; font-weight: 600; }
.psm-toolbar .psm-toolbar-spacer { flex: 1; }
.psm-toolbar label { color: var(--psm-fg-mute); font-size: 12px; display: inline-flex; align-items: center; gap: 6px; }
.psm-toolbar input
{
	background: var(--psm-bg-elev-2);
	color: var(--psm-fg);
	border: 1px solid var(--psm-border);
	padding: 5px 9px;
	border-radius: 4px;
	font-size: 12px;
	font-family: inherit;
}
.psm-toolbar input.psm-scope-input { width: 140px; font-family: monospace; }
.psm-toolbar .psm-scope-hint { color: var(--psm-fg-fade); font-size: 11px; font-style: italic; }
.psm-btn
{
	background: var(--psm-bg-elev-2);
	color: var(--psm-fg-soft);
	border: 1px solid var(--psm-border);
	padding: 5px 11px;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	text-decoration: none;
	display: inline-flex;
	align-items: center;
	gap: 4px;
}
.psm-btn:hover { background: #1e293b; color: var(--psm-fg); }
.psm-btn.psm-btn-primary { background: var(--psm-accent); border-color: var(--psm-accent); color: var(--psm-accent-fg); }
.psm-btn.psm-btn-primary:hover { background: #1d4ed8; }
.psm-btn.psm-btn-success { background: var(--psm-success); border-color: var(--psm-success); color: var(--psm-success-fg); }
.psm-btn.psm-btn-success:hover { background: #15803d; }
.psm-btn.psm-btn-danger { background: transparent; color: var(--psm-danger-fg); border-color: var(--psm-danger); }
.psm-btn.psm-btn-danger:hover { background: var(--psm-danger); color: var(--psm-accent-fg); }
.psm-btn[disabled], .psm-btn.psm-btn-disabled { opacity: 0.5; pointer-events: none; }

.psm-content { padding: 16px; max-width: 1400px; margin: 0 auto; }

/* List view */
.psm-list-wrap { display: flex; flex-direction: column; gap: 12px; }
.psm-list { display: flex; flex-direction: column; gap: 8px; }
.psm-list-row
{
	display: grid;
	grid-template-columns: 1.5fr 1.6fr 2fr auto;
	gap: 12px;
	padding: 10px 14px;
	background: var(--psm-bg-elev);
	border: 1px solid var(--psm-border);
	border-radius: 6px;
	align-items: center;
}
.psm-list-row .psm-row-name { font-family: monospace; font-size: 13px; color: var(--psm-fg); font-weight: 600; }
.psm-list-row .psm-row-name .psm-row-scope { color: var(--psm-fg-fade); font-style: italic; font-weight: 400; margin-left: 6px; font-size: 11px; }
.psm-list-row .psm-row-desc { color: var(--psm-fg-soft); font-size: 12px; }
.psm-list-row .psm-row-flow { font-size: 11px; color: var(--psm-fg-mute); font-family: monospace; }
.psm-list-row .psm-row-actions { display: flex; gap: 6px; justify-content: flex-end; }

.psm-empty, .psm-error
{
	padding: 18px;
	text-align: center;
	color: var(--psm-fg-fade);
	font-size: 13px;
	border: 1px dashed var(--psm-border);
	border-radius: 6px;
	background: var(--psm-bg-elev);
}
.psm-error { color: #f87171; background: #2a1010; border-color: #2a1010; }

/* Editor */
.psm-editor { display: flex; flex-direction: column; gap: 14px; }
.psm-editor-header { display: flex; gap: 12px; align-items: center; }
.psm-editor-header h3 { margin: 0; font-size: 16px; }
.psm-editor-form { display: grid; grid-template-columns: 160px 1fr; gap: 10px 14px; align-items: center; }
.psm-editor-form label { color: var(--psm-fg-mute); font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
.psm-editor-form input[type=text]
{
	background: var(--psm-bg-elev-2);
	color: var(--psm-fg);
	border: 1px solid var(--psm-border);
	padding: 6px 10px;
	border-radius: 4px;
	font-size: 13px;
	font-family: inherit;
}
.psm-editor-form .psm-help { color: var(--psm-fg-fade); font-size: 11px; font-style: italic; }
.psm-editor-form textarea
{
	background: var(--psm-bg-elev-2);
	color: var(--psm-fg);
	border: 1px solid var(--psm-border);
	padding: 8px 10px;
	border-radius: 4px;
	font-size: 12px;
	font-family: monospace;
	min-height: 240px;
	resize: vertical;
	width: 100%;
	box-sizing: border-box;
}
.psm-editor-actions { display: flex; gap: 8px; justify-content: flex-end; }
.psm-editor-error { color: #f87171; font-size: 12px; padding: 8px 12px; background: #2a1010; border-radius: 4px; }
.psm-source-target
{
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 14px;
	padding: 12px;
	background: var(--psm-bg-elev-2);
	border: 1px solid var(--psm-border);
	border-radius: 4px;
}
.psm-source-target .psm-st-section h4 { margin: 0 0 8px 0; color: var(--psm-fg-mute); font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; }
.psm-source-target .psm-st-row { display: grid; grid-template-columns: 90px 1fr; gap: 6px; margin-bottom: 6px; align-items: center; }
.psm-source-target .psm-st-row label { color: var(--psm-fg-fade); font-size: 11px; }

/* Run result */
.psm-run-result
{
	padding: 14px;
	background: var(--psm-bg-elev);
	border: 1px solid var(--psm-border);
	border-radius: 6px;
	margin-top: 10px;
	font-size: 13px;
	display: flex;
	flex-direction: column;
	gap: 8px;
}
.psm-run-result h4 { margin: 0; font-size: 14px; color: var(--psm-fg-soft); }
.psm-run-result .psm-run-stats { display: flex; gap: 18px; flex-wrap: wrap; }
.psm-run-result .psm-run-stat { display: flex; flex-direction: column; }
.psm-run-result .psm-run-stat .psm-stat-label { font-size: 10px; color: var(--psm-fg-mute); text-transform: uppercase; letter-spacing: 0.5px; }
.psm-run-result .psm-run-stat .psm-stat-value { font-size: 16px; color: var(--psm-fg); font-family: monospace; font-weight: 600; }
.psm-run-result.psm-run-success { border-color: var(--psm-success); }
.psm-run-result.psm-run-error   { border-color: var(--psm-danger); }
.psm-run-result.psm-run-running { border-color: var(--psm-warning); }
.psm-run-result .psm-run-error-message
{
	color: var(--psm-danger-fg);
	font-family: monospace;
	font-size: 12px;
	white-space: pre-wrap;
}
`;

},{}],671:[function(require,module,exports){
/**
 * Pict-Section-Mapping default configuration.
 *
 * Template-driven view per modules/pict/CLAUDE.md conventions.
 */
'use strict';

const SHELL_TEMPLATE = /*html*/`
<div class="psm-root psm-mode-{~Data:AppData.Mapping.Mode~}">
	{~TS:Pict-Section-Mapping-Toolbar:AppData.Mapping.ToolbarSlot~}
	<div class="psm-content">
		{~TS:Pict-Section-Mapping-List:AppData.Mapping.ListSlot~}
		{~TS:Pict-Section-Mapping-Editor:AppData.Mapping.EditSlot~}
	</div>
</div>`;

const TOOLBAR_TEMPLATE = /*html*/`
<div class="psm-toolbar">
	<h2>Mappings</h2>
	{~TS:Pict-Section-Mapping-Toolbar-BackLink:AppData.Mapping.BackLinkSlot~}
	<span class="psm-toolbar-spacer"></span>
	<label>scope
		<input type="text" class="psm-scope-input" spellcheck="false" placeholder="* (all scopes)"
			value="{~Data:AppData.Mapping.Scope~}"
			oninput="_Pict.views['Pict-Section-Mapping'].onScopeInput(this.value)" />
		<span class="psm-scope-hint">* = all • empty = global • any string = that scope</span>
	</label>
	{~TS:Pict-Section-Mapping-Toolbar-NewButton:AppData.Mapping.NewButtonSlot~}
</div>`;

const TOOLBAR_BACKLINK_TEMPLATE = /*html*/`
<a class="psm-btn" href="javascript:void(0)"
	onclick="_Pict.views['Pict-Section-Mapping'].openList()">← All mappings</a>`;

const TOOLBAR_NEWBUTTON_TEMPLATE = /*html*/`
<a class="psm-btn psm-btn-primary" href="javascript:void(0)"
	onclick="_Pict.views['Pict-Section-Mapping'].openEditor(null)">+ New mapping</a>`;

const LIST_TEMPLATE = /*html*/`
<div class="psm-list-wrap">
	{~TS:Pict-Section-Mapping-LoadingState:AppData.Mapping.LoadingSlot~}
	{~TS:Pict-Section-Mapping-LoadError:AppData.Mapping.LoadErrorSlot~}
	{~TS:Pict-Section-Mapping-EmptyState:AppData.Mapping.EmptySlot~}
	{~TS:Pict-Section-Mapping-ListBody:AppData.Mapping.ListBodySlot~}
</div>`;

const LOADING_TEMPLATE = /*html*/`<div class="psm-empty">Loading…</div>`;

const LOAD_ERROR_TEMPLATE = /*html*/`
<div class="psm-error">Failed to load mappings: {~Data:Record.Message~}</div>`;

const EMPTY_TEMPLATE = /*html*/`<div class="psm-empty">{~Data:Record.Message~}</div>`;

const LIST_BODY_TEMPLATE = /*html*/`
<div class="psm-list">
	{~TS:Pict-Section-Mapping-ListRow:AppData.Mapping.Mappings~}
</div>`;

const LIST_ROW_TEMPLATE = /*html*/`
<div class="psm-list-row" id="psm-row-{~Data:Record.IDMappingConfig~}">
	<div class="psm-row-name">{~Data:Record.NameOrUnnamed~}{~TS:Pict-Section-Mapping-RowScopeBadge:Record.ScopeBadgeSlot~}</div>
	<div class="psm-row-desc">{~Data:Record.Description~}</div>
	<div class="psm-row-flow">{~Data:Record.SourceLabel~} → {~Data:Record.TargetLabel~}</div>
	<div class="psm-row-actions">{~TS:Pict-Section-Mapping-RowAction:Record.ActionsSlot~}</div>
	{~TS:Pict-Section-Mapping-RunResult:Record.ResultSlot~}
</div>`;

const ROW_SCOPE_BADGE_TEMPLATE = /*html*/`
<span class="psm-row-scope">· {~Data:Record.Scope~}</span>`;

const ROW_ACTION_TEMPLATE = /*html*/`
<a class="psm-btn {~Data:Record.ButtonClass~}" href="javascript:void(0)"
	onclick="_Pict.views['Pict-Section-Mapping'].{~Data:Record.Method~}({~Data:Record.IDMappingConfig~})">{~Data:Record.Label~}</a>`;

const RUN_RESULT_TEMPLATE = /*html*/`
<div class="psm-run-result {~Data:Record.StatusClass~}">
	<h4>{~Data:Record.Title~}</h4>
	{~TS:Pict-Section-Mapping-RunErrorMessage:Record.ErrorSlot~}
	{~TS:Pict-Section-Mapping-RunStat:Record.Stats~}
</div>`;

const RUN_ERROR_TEMPLATE = /*html*/`
<div class="psm-run-error-message">{~Data:Record.Message~}</div>`;

const RUN_STAT_TEMPLATE = /*html*/`
<div class="psm-run-stat">
	<span class="psm-stat-label">{~Data:Record.Label~}</span>
	<span class="psm-stat-value">{~Data:Record.Value~}</span>
</div>`;

const EDITOR_TEMPLATE = /*html*/`
<div class="psm-editor">
	<div class="psm-editor-header">
		<h3>{~Data:Record.HeaderTitle~}</h3>
	</div>
	<div class="psm-editor-form">
		<label>Name</label>
		<input type="text" placeholder="Human-readable name (e.g. &quot;weather → WeatherSummary&quot;)"
			value="{~Data:Record.Name~}"
			onchange="_Pict.views['Pict-Section-Mapping'].setEditingField('Name', this.value)" />

		<label>Scope</label>
		<input type="text" placeholder="(empty = global)"
			value="{~Data:Record.Scope~}"
			onchange="_Pict.views['Pict-Section-Mapping'].setEditingField('Scope', this.value)" />

		<label>Description</label>
		<input type="text"
			value="{~Data:Record.Description~}"
			onchange="_Pict.views['Pict-Section-Mapping'].setEditingField('Description', this.value)" />

		<label>Source ↔ Target</label>
		<div class="psm-source-target">
			<div class="psm-st-section">
				<h4>Source</h4>
				{~TS:Pict-Section-Mapping-EditorSTRow:Record.SourceFields~}
			</div>
			<div class="psm-st-section">
				<h4>Target</h4>
				{~TS:Pict-Section-Mapping-EditorSTRow:Record.TargetFields~}
			</div>
		</div>

		<label>Configuration (JSON)</label>
		<div>
			<textarea spellcheck="false"
				onchange="_Pict.views['Pict-Section-Mapping'].setEditingField('MappingConfiguration', this.value)">{~Data:Record.MappingConfiguration~}</textarea>
			<div class="psm-help">
				meadow-integration shape: <code>{ Entity, GUIDName, GUIDTemplate, Mappings: { TargetField: "{~D:Record.SourceField~}" }, Solvers }</code>.
			</div>
		</div>
	</div>

	{~TS:Pict-Section-Mapping-EditorError:Record.ErrorSlot~}

	<div class="psm-editor-actions">
		<a class="psm-btn" href="javascript:void(0)"
			onclick="_Pict.views['Pict-Section-Mapping'].openList()">Cancel</a>
		<a class="psm-btn psm-btn-primary" href="javascript:void(0)"
			onclick="_Pict.views['Pict-Section-Mapping'].saveEditing()">{~Data:Record.SaveButtonLabel~}</a>
	</div>
</div>`;

const EDITOR_ST_ROW_TEMPLATE = /*html*/`
<div class="psm-st-row">
	<label>{~Data:Record.Label~}</label>
	<input type="text" placeholder="{~Data:Record.Field~}"
		value="{~Data:Record.Value~}"
		onchange="_Pict.views['Pict-Section-Mapping'].setEditingField('{~Data:Record.Field~}', this.value)" />
</div>`;

const EDITOR_ERROR_TEMPLATE = /*html*/`
<div class="psm-editor-error">{~Data:Record.Message~}</div>`;

module.exports =
{
	ViewIdentifier:            'Pict-Section-Mapping',
	DefaultRenderable:         'Pict-Section-Mapping-Shell',
	DefaultDestinationAddress: '#Pict-Section-Mapping',
	DefaultTemplateRecordAddress: 'AppData.Mapping',
	AutoRender:                true,
	RenderOnLoad:              false,

	APIBaseUrl:           '/mapper',
	Mode:                 'manage',
	ShowToolbar:          true,
	Scope:                null,
	WriteToken:           null,

	Templates:
	[
		{ Hash: 'Pict-Section-Mapping-Shell',                  Template: SHELL_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-Toolbar',                Template: TOOLBAR_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-Toolbar-BackLink',       Template: TOOLBAR_BACKLINK_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-Toolbar-NewButton',      Template: TOOLBAR_NEWBUTTON_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-List',                   Template: LIST_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-LoadingState',           Template: LOADING_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-LoadError',              Template: LOAD_ERROR_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-EmptyState',             Template: EMPTY_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-ListBody',               Template: LIST_BODY_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-ListRow',                Template: LIST_ROW_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-RowScopeBadge',          Template: ROW_SCOPE_BADGE_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-RowAction',              Template: ROW_ACTION_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-RunResult',              Template: RUN_RESULT_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-RunErrorMessage',        Template: RUN_ERROR_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-RunStat',                Template: RUN_STAT_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-Editor',                 Template: EDITOR_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-EditorSTRow',            Template: EDITOR_ST_ROW_TEMPLATE },
		{ Hash: 'Pict-Section-Mapping-EditorError',            Template: EDITOR_ERROR_TEMPLATE }
	],

	Renderables:
	[
		{
			RenderableHash: 'Pict-Section-Mapping-Shell',
			TemplateHash: 'Pict-Section-Mapping-Shell',
			TemplateRecordAddress: 'AppData.Mapping',
			DestinationAddress: '#Pict-Section-Mapping',
			RenderMethod: 'replace'
		}
	]
};

},{}],672:[function(require,module,exports){
/**
 * Pict-Section-Mapping
 *
 * Embeddable Pict view for Mapping CRUD + Run, surfacing the
 * retold-data-mapper /mapper/mapping* REST API.
 *
 * Template-driven per modules/pict/CLAUDE.md (mirrors pict-section-operation):
 *   - All state lives in pict.AppData.Mapping.*
 *   - Templates + Renderables; no document.createElement, no .onclick closures.
 *   - View switching uses single-element-array slots driven by {~TS:~}.
 *   - Modal interactions via pict-section-modal; no native popups.
 *
 * Modes:
 *   `manage`     full CRUD (default)
 *   `list-only`  list-only — Run/Edit/Delete + the New button are suppressed.
 *
 * Public API (called by host apps and inline template handlers):
 *   openList()
 *   openEditor(pRecOrID)        // null = new
 *   saveEditing()
 *   runMapping(pIDMappingConfig)
 *   deleteMapping(pIDMappingConfig)
 *   onScopeInput(pValue)
 *   setEditingField(pName, pValue)
 *   refresh()
 *
 * Note: the data-mapper also has a separate visual mapping editor
 * (the Pict app at index.html) for graphical field mapping. This
 * section is the lightweight CRUD + Run surface; the visual editor
 * is the richer alternative for editing MappingConfiguration.
 */
'use strict';

const libPictView = require('pict-view');
const libDefaultConf = require('./Pict-Section-Mapping-DefaultConfiguration.js');
const libCSS = require('./Pict-Section-Mapping-CSS.js');
const libAPIProvider = require('./providers/PictProvider-Mapping-API.js');

const DEFAULT_MAPPING_CONFIGURATION =
{
	Entity:       '/* TargetEntity */',
	GUIDName:     'GUID/* TargetEntity */',
	GUIDTemplate: '/* {~D:Record.SourceField~} for unique-per-row GUID */',
	Solvers:      [],
	Mappings:
	{
		'/* TargetField */': '{~D:Record./* SourceField */~}'
	}
};

const DEFAULT_MAPPING_CONFIGURATION_TEXT = JSON.stringify(DEFAULT_MAPPING_CONFIGURATION, null, 2);

const RUN_STAT_FIELDS = ['RowsRead', 'RowsMapped', 'RowsWritten', 'Errors', 'TargetEntity', 'ElapsedMs'];

const SOURCE_EDITOR_FIELDS =
[
	{ Field: 'SourceBeaconName',     Label: 'Beacon' },
	{ Field: 'SourceConnectionHash', Label: 'Connection' },
	{ Field: 'SourceEntity',         Label: 'Entity' }
];

const TARGET_EDITOR_FIELDS =
[
	{ Field: 'TargetBeaconName',     Label: 'Beacon' },
	{ Field: 'TargetConnectionHash', Label: 'Connection' },
	{ Field: 'TargetEntity',         Label: 'Entity' }
];

class PictSectionMapping extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, libDefaultConf, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this._API = new libAPIProvider({
			APIBaseUrl: this.options.APIBaseUrl,
			Scope:      this.options.Scope,
			WriteToken: this.options.WriteToken
		});

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Mapping-CSS', libCSS, 500);
		}

		this._seedAppData();
		this._scopeDebounce = null;
	}

	_seedAppData()
	{
		if (!this.pict.AppData) this.pict.AppData = {};
		this.pict.AppData.Mapping = Object.assign(
			{
				Mode:                 this.options.Mode || 'manage',
				ShowToolbar:          !!this.options.ShowToolbar,
				Scope:                this._API.getScope(),
				View:                 'list',     // 'list' | 'edit'
				Mappings:             [],
				Editing:              null,
				EditorError:          '',
				LoadState:            'idle',     // 'idle' | 'loading' | 'error' | 'empty' | 'ready'
				LoadErrorMessage:     '',
				EmptyMessage:         '',
				RunResults:           {},

				ToolbarSlot:          [],
				BackLinkSlot:         [],
				NewButtonSlot:        [],
				ListSlot:             [],
				EditSlot:             [],
				LoadingSlot:          [],
				LoadErrorSlot:        [],
				EmptySlot:            [],
				ListBodySlot:         []
			},
			this.pict.AppData.Mapping || {});
	}

	// ── Lifecycle ────────────────────────────────────────────────────

	onAfterInitialize()
	{
		this._loadList();
		return super.onAfterInitialize();
	}

	onBeforeRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._populateSlots();
		return super.onBeforeRender(pRenderable, pAddress, pRecord, pContent);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	// ── Public API ───────────────────────────────────────────────────

	openList()
	{
		this.pict.AppData.Mapping.View = 'list';
		this.pict.AppData.Mapping.Editing = null;
		this.pict.AppData.Mapping.EditorError = '';
		this._loadList();
	}

	openEditor(pRecOrID)
	{
		if (pRecOrID == null)
		{
			this._openEditorWith(null);
			return;
		}
		if (typeof pRecOrID === 'object')
		{
			this._openEditorWith(pRecOrID);
			return;
		}
		let tmpID = parseInt(pRecOrID, 10);
		let tmpFound = this.pict.AppData.Mapping.Mappings.find((r) => r.IDMappingConfig === tmpID);
		this._openEditorWith(tmpFound || null);
	}

	saveEditing()
	{
		let tmpRec = this.pict.AppData.Mapping.Editing;
		if (!tmpRec)
		{
			this._toast('Nothing to save.', 'error');
			return;
		}
		if (!tmpRec.Name || !tmpRec.Name.trim())
		{
			this._setEditorError('Name is required.');
			return;
		}
		let tmpConfRaw = (typeof tmpRec.MappingConfiguration === 'string')
			? tmpRec.MappingConfiguration
			: JSON.stringify(tmpRec.MappingConfiguration || {}, null, 2);
		let tmpConfParsed;
		try { tmpConfParsed = JSON.parse(tmpConfRaw); }
		catch (pErr) { this._setEditorError('Configuration JSON parse error: ' + pErr.message); return; }

		let tmpIsNew = !tmpRec.IDMappingConfig;
		let tmpPayload = Object.assign({}, tmpRec, { MappingConfiguration: tmpConfParsed });

		this._API.saveMapping(tmpPayload).then(() =>
		{
			this._toast(tmpIsNew ? 'Mapping created.' : 'Mapping saved.', 'success');
			this.openList();
		}).catch((pErr) => this._setEditorError(pErr.message));
	}

	runMapping(pIDMappingConfig)
	{
		let tmpID = parseInt(pIDMappingConfig, 10);
		if (!tmpID)
		{
			this._toast('Run failed: missing IDMappingConfig', 'error');
			return;
		}
		let tmpMap = this.pict.AppData.Mapping.Mappings.find((r) => r.IDMappingConfig === tmpID);
		let tmpName = tmpMap ? (tmpMap.Name || tmpMap.Hash || ('mapping ' + tmpID)) : ('mapping ' + tmpID);

		this.pict.AppData.Mapping.RunResults[tmpID] = { Status: 'Running' };
		this.render();

		this._API.runMapping(tmpID).then((pResult) =>
		{
			this.pict.AppData.Mapping.RunResults[tmpID] = Object.assign({}, pResult || {}, { Status: 'Success', Hash: tmpName });
			this.render();
		}).catch((pErr) =>
		{
			this.pict.AppData.Mapping.RunResults[tmpID] = { Status: 'Error', Hash: tmpName, Error: pErr.message };
			this.render();
		});
	}

	deleteMapping(pIDMappingConfig)
	{
		let tmpID = parseInt(pIDMappingConfig, 10);
		if (!tmpID)
		{
			this._toast('Delete failed: missing IDMappingConfig', 'error');
			return;
		}
		let tmpMap = this.pict.AppData.Mapping.Mappings.find((r) => r.IDMappingConfig === tmpID);
		let tmpLabel = tmpMap ? (tmpMap.Name || tmpMap.Hash || ('mapping ' + tmpID)) : ('mapping ' + tmpID);

		this._confirm(
			'Delete mapping "' + tmpLabel + '"? This cannot be undone.',
			{ title: 'Delete mapping?', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true })
			.then((pOk) =>
			{
				if (!pOk) return;
				this._API.deleteMapping(tmpID).then(() =>
				{
					this._toast('Mapping deleted.', 'success');
					this._loadList();
				}).catch((pErr) => this._toast('Delete failed: ' + pErr.message, 'error'));
			});
	}

	onScopeInput(pValue)
	{
		clearTimeout(this._scopeDebounce);
		let tmpValue = (pValue == null) ? '' : String(pValue).trim();
		this._scopeDebounce = setTimeout(() =>
		{
			this._API.setScope(tmpValue);
			this.pict.AppData.Mapping.Scope = tmpValue;
			this.pict.AppData.Mapping.View = 'list';
			this.pict.AppData.Mapping.Editing = null;
			this._loadList();
		}, 300);
	}

	setEditingField(pName, pValue)
	{
		if (!this.pict.AppData.Mapping.Editing) return;
		this.pict.AppData.Mapping.Editing[pName] = pValue;
		// Silent — no render(), preserves cursor/selection state.
	}

	refresh()
	{
		this._loadList();
	}

	// ── Internal ─────────────────────────────────────────────────────

	_loadList()
	{
		this.pict.AppData.Mapping.View = 'list';
		this.pict.AppData.Mapping.LoadState = 'loading';
		this.pict.AppData.Mapping.LoadErrorMessage = '';
		this.render();

		this._API.listMappings().then((pData) =>
		{
			let tmpRows = (pData && pData.Mappings) || [];
			this.pict.AppData.Mapping.Mappings = tmpRows;
			if (tmpRows.length === 0)
			{
				let tmpScope = this._API.getScope();
				this.pict.AppData.Mapping.LoadState = 'empty';
				if (tmpScope === '*')
				{
					this.pict.AppData.Mapping.EmptyMessage =
						'No mappings yet across any scope. Click + New mapping above to create one, '
						+ 'or run a seed harness (e.g. npm run seed-synth-demo) to plant a sample set.';
				}
				else if (tmpScope === '')
				{
					this.pict.AppData.Mapping.EmptyMessage =
						'No mappings in global scope. Set scope to * to see scope-tagged mappings, '
						+ 'or click + New mapping above.';
				}
				else
				{
					this.pict.AppData.Mapping.EmptyMessage =
						'No mappings in scope "' + tmpScope + '". '
						+ 'Set scope to * to see all scopes, or click + New mapping above.';
				}
			}
			else
			{
				this.pict.AppData.Mapping.LoadState = 'ready';
			}
			this.render();
		}).catch((pErr) =>
		{
			this.pict.AppData.Mapping.LoadState = 'error';
			this.pict.AppData.Mapping.LoadErrorMessage = pErr.message || String(pErr);
			this.render();
		});
	}

	_openEditorWith(pRec)
	{
		let tmpScope = this._API.getScope();
		let tmpEditing = pRec
			? Object.assign({}, pRec, {
				MappingConfiguration: (typeof pRec.MappingConfiguration === 'string')
					? pRec.MappingConfiguration
					: JSON.stringify(pRec.MappingConfiguration || {}, null, 2)
			})
			: {
				Scope: tmpScope,
				Name: '', Description: '',
				SourceBeaconName: '', SourceConnectionHash: '', SourceEntity: '',
				TargetBeaconName: '', TargetConnectionHash: '', TargetEntity: '',
				MappingConfiguration: DEFAULT_MAPPING_CONFIGURATION_TEXT
			};

		this.pict.AppData.Mapping.Editing = tmpEditing;
		this.pict.AppData.Mapping.EditorError = '';
		this.pict.AppData.Mapping.View = 'edit';
		this.render();
	}

	_setEditorError(pMessage)
	{
		this.pict.AppData.Mapping.EditorError = pMessage || '';
		this.render();
	}

	_populateSlots()
	{
		let tmpData = this.pict.AppData.Mapping;
		let tmpView = tmpData.View || 'list';
		let tmpMode = tmpData.Mode || 'manage';
		let tmpShowToolbar = !!tmpData.ShowToolbar;

		tmpData.Scope = this._API.getScope();

		tmpData.ToolbarSlot   = tmpShowToolbar ? [{}] : [];
		tmpData.BackLinkSlot  = (tmpView !== 'list') ? [{}] : [];
		tmpData.NewButtonSlot = (tmpMode === 'manage' && tmpView === 'list') ? [{}] : [];

		tmpData.ListSlot = (tmpView === 'list') ? [{}] : [];
		tmpData.EditSlot = (tmpView === 'edit' && tmpData.Editing) ? [this._buildEditorRecord(tmpData.Editing, tmpData.EditorError)] : [];

		let tmpState = (tmpView === 'list') ? (tmpData.LoadState || 'idle') : 'hidden';
		tmpData.LoadingSlot   = (tmpState === 'loading') ? [{}] : [];
		tmpData.LoadErrorSlot = (tmpState === 'error') ? [{ Message: tmpData.LoadErrorMessage }] : [];
		tmpData.EmptySlot     = (tmpState === 'empty') ? [{ Message: tmpData.EmptyMessage }] : [];
		tmpData.ListBodySlot  = (tmpState === 'ready') ? [{}] : [];

		if (tmpState === 'ready')
		{
			tmpData.Mappings = (tmpData.Mappings || []).map((m) => this._decorateMapping(m, tmpMode, tmpData.RunResults));
		}
	}

	_decorateMapping(pMapping, pMode, pRunResults)
	{
		let tmpID = pMapping.IDMappingConfig;
		let tmpRunResult = pRunResults && pRunResults[tmpID] ? pRunResults[tmpID] : null;

		return Object.assign({}, pMapping,
			{
				NameOrUnnamed:        pMapping.Name || '(unnamed)',
				SourceLabel:          (pMapping.SourceBeaconName || '?') + '/' + (pMapping.SourceEntity || '?'),
				TargetLabel:          (pMapping.TargetBeaconName || '?') + '/' + (pMapping.TargetEntity || '?'),
				ScopeBadgeSlot:       pMapping.Scope ? [{ Scope: pMapping.Scope }] : [],
				ActionsSlot:          (pMode === 'manage') ? this._buildRowActions(tmpID, tmpRunResult) : [],
				ResultSlot:           tmpRunResult ? [this._buildRunResultRecord(tmpRunResult)] : []
			});
	}

	_buildRowActions(pID, pRunResult)
	{
		let tmpRunning = pRunResult && pRunResult.Status === 'Running';
		return [
			{ IDMappingConfig: pID, Method: 'runMapping',    Label: tmpRunning ? 'Running…' : '▶ Run', ButtonClass: tmpRunning ? 'psm-btn-success psm-btn-disabled' : 'psm-btn-success' },
			{ IDMappingConfig: pID, Method: 'openEditor',    Label: 'Edit',     ButtonClass: '' },
			{ IDMappingConfig: pID, Method: 'deleteMapping', Label: 'Delete',   ButtonClass: 'psm-btn-danger' }
		];
	}

	_buildRunResultRecord(pRunResult)
	{
		let tmpStatus = pRunResult.Status || 'Success';
		let tmpStats = [];
		if (tmpStatus === 'Success')
		{
			for (let i = 0; i < RUN_STAT_FIELDS.length; i++)
			{
				let tmpKey = RUN_STAT_FIELDS[i];
				if (pRunResult[tmpKey] === undefined || pRunResult[tmpKey] === null) continue;
				tmpStats.push({ Label: tmpKey, Value: String(pRunResult[tmpKey]) });
			}
		}

		let tmpName = pRunResult.Hash || '(mapping)';
		let tmpTitle = (tmpStatus === 'Error') ? ('✗  ' + tmpName + ' — failed')
			: (tmpStatus === 'Running') ? ('… ' + tmpName + ' — running')
			: ('✓  ' + tmpName + ' — completed');
		let tmpStatusClass = (tmpStatus === 'Error') ? 'psm-run-error'
			: (tmpStatus === 'Running') ? 'psm-run-running'
			: 'psm-run-success';
		let tmpErrorSlot = (tmpStatus === 'Error' && pRunResult.Error)
			? [{ Message: pRunResult.Error }]
			: [];

		return {
			Title:        tmpTitle,
			StatusClass:  tmpStatusClass,
			Stats:        tmpStats,
			ErrorSlot:    tmpErrorSlot
		};
	}

	_buildEditorRecord(pEditing, pErrorMessage)
	{
		let tmpIsNew = !pEditing.IDMappingConfig;
		let tmpSourceFields = SOURCE_EDITOR_FIELDS.map((f) =>
			({ Field: f.Field, Label: f.Label, Value: pEditing[f.Field] || '' }));
		let tmpTargetFields = TARGET_EDITOR_FIELDS.map((f) =>
			({ Field: f.Field, Label: f.Label, Value: pEditing[f.Field] || '' }));

		return {
			HeaderTitle:           tmpIsNew ? 'New mapping' : ('Edit mapping "' + (pEditing.Name || pEditing.IDMappingConfig) + '"'),
			Name:                  pEditing.Name || '',
			Scope:                 pEditing.Scope || '',
			Description:           pEditing.Description || '',
			SourceFields:          tmpSourceFields,
			TargetFields:          tmpTargetFields,
			MappingConfiguration:  pEditing.MappingConfiguration || '',
			SaveButtonLabel:       tmpIsNew ? 'Create mapping' : 'Save changes',
			ErrorSlot:             pErrorMessage ? [{ Message: pErrorMessage }] : []
		};
	}

	// ── Modal ────────────────────────────────────────────────────────

	_modal()
	{
		if (!this.pict || !this.pict.views) return null;
		return this.pict.views['Pict-Section-Modal']
			|| this.pict.views.Modal
			|| null;
	}

	_confirm(pMessage, pOptions)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			return tmpModal.confirm(pMessage, pOptions);
		}
		this.log.warn('Pict-Section-Mapping: pict-section-modal not present; auto-confirming "' + pMessage + '"');
		return Promise.resolve(true);
	}

	_toast(pMessage, pType)
	{
		let tmpModal = this._modal();
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
			return;
		}
		this.log.info('[pict-section-mapping] ' + pMessage);
	}
}

module.exports = PictSectionMapping;
module.exports.default_configuration = libDefaultConf;
module.exports.APIProvider = libAPIProvider;
module.exports.DEFAULT_MAPPING_CONFIGURATION = DEFAULT_MAPPING_CONFIGURATION;

},{"./Pict-Section-Mapping-CSS.js":670,"./Pict-Section-Mapping-DefaultConfiguration.js":671,"./providers/PictProvider-Mapping-API.js":673,"pict-view":733}],673:[function(require,module,exports){
/**
 * Pict-Section-Mapping API Provider
 *
 * REST client for the data-mapper /mapper/mapping* surface.
 * Uses the same active-scope localStorage key as the dashboard
 * and operation sections so a host mounting any combination
 * of them gets one coherent active scope.
 *
 * Bearer-token write gate: when WriteToken is set, POST/PUT/DELETE
 * carry `Authorization: Bearer <token>` to satisfy the data-mapper's
 * DATA_MAPPER_WRITE_TOKEN env-driven gate. GET stays open.
 */
'use strict';

const SCOPE_STORAGE_KEY = 'retold.dataMapper.activeScope';

class MappingAPIProvider
{
	constructor(pOptions)
	{
		let tmpOptions = pOptions || {};
		this._apiBaseUrl = tmpOptions.APIBaseUrl || '/mapper';
		this._scopeOverride = (typeof tmpOptions.Scope === 'string') ? tmpOptions.Scope : null;
		this._writeToken = (typeof tmpOptions.WriteToken === 'string' && tmpOptions.WriteToken.length > 0)
			? tmpOptions.WriteToken : null;
	}

	getScope(pCallScope)
	{
		if (typeof pCallScope === 'string') return pCallScope;
		if (typeof this._scopeOverride === 'string') return this._scopeOverride;
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				let tmpStored = localStorage.getItem(SCOPE_STORAGE_KEY);
				if (tmpStored !== null) return tmpStored;
			}
		}
		catch (pErr) { /* opaque origin or disabled storage — fall through */ }
		// First-load default: show everything. '' would have meant "global
		// only", which silently hides scope-tagged seeds (e.g. the synth-
		// demo bundle) from a fresh operator browsing the list. The picker
		// can still narrow back down to '' or any specific scope.
		return '*';
	}

	setScope(pScope)
	{
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				if (pScope) localStorage.setItem(SCOPE_STORAGE_KEY, pScope);
				else localStorage.removeItem(SCOPE_STORAGE_KEY);
			}
		}
		catch (pErr) { /* opaque origin or disabled storage — keep in-memory only */ }
		this._scopeOverride = (typeof pScope === 'string') ? pScope : null;
	}

	setWriteToken(pToken)
	{
		this._writeToken = (typeof pToken === 'string' && pToken.length > 0) ? pToken : null;
	}

	_fetch(pMethod, pPath, pBody)
	{
		let tmpOpts = { method: pMethod, headers: {} };
		let tmpIsWrite = (pMethod !== 'GET' && pMethod !== 'HEAD');

		if (pBody !== undefined && pBody !== null)
		{
			tmpOpts.headers['Content-Type'] = 'application/json';
			tmpOpts.body = JSON.stringify(pBody);
		}
		if (tmpIsWrite && this._writeToken)
		{
			tmpOpts.headers['Authorization'] = 'Bearer ' + this._writeToken;
		}

		return fetch(this._apiBaseUrl + pPath, tmpOpts).then((pRes) =>
		{
			if (!pRes.ok)
			{
				return pRes.text().then((pText) =>
				{
					let tmpMsg = pText && pText.length < 400 ? pText : ('HTTP ' + pRes.status);
					throw new Error(tmpMsg);
				});
			}
			let tmpCT = pRes.headers.get('content-type') || '';
			if (tmpCT.indexOf('application/json') === 0) return pRes.json();
			return pRes.text();
		});
	}

	_scopeQuery(pScope)
	{
		let tmpScope = this.getScope(pScope);
		if (tmpScope === '') return '';
		return '?scope=' + encodeURIComponent(tmpScope);
	}

	listMappings(pScope)
	{
		return this._fetch('GET', '/mappings' + this._scopeQuery(pScope));
	}

	getMapping(pHashOrID, pScope)
	{
		return this._fetch('GET', '/mapping/' + encodeURIComponent(pHashOrID) + this._scopeQuery(pScope));
	}

	saveMapping(pRecord, pScope)
	{
		let tmpRecord = Object.assign({}, pRecord);
		if (tmpRecord.Scope === undefined) tmpRecord.Scope = this.getScope(pScope);
		if (tmpRecord.IDMappingConfig)
		{
			let tmpID = tmpRecord.IDMappingConfig;
			delete tmpRecord.IDMappingConfig;
			return this._fetch('PUT', '/mapping/' + tmpID, tmpRecord);
		}
		return this._fetch('POST', '/mappings', tmpRecord);
	}

	deleteMapping(pID)
	{
		return this._fetch('DELETE', '/mapping/' + pID);
	}

	// Run goes through UV — server route is /mapper/uv/run-mapping/:id.
	// The previous implementation pointed at /mapping/:id/run which never
	// existed; runs always returned 404.
	runMapping(pID)
	{
		return this._fetch('POST', '/uv/run-mapping/' + pID, {});
	}

	// Lake-sample peek for editor convenience — render five rows from a
	// beacon/connection/entity tuple.
	peekTable(pBeaconName, pConnectionHash, pEntity, pPageSize, pPage)
	{
		return this._fetch('POST', '/dashboard/panel-data',
			{
				BeaconName:     pBeaconName,
				ConnectionName: pConnectionHash,
				Endpoint:       pEntity,
				PageSize:       pPageSize || 5,
				Page:           pPage || 0
			});
	}
}

module.exports = MappingAPIProvider;
module.exports.SCOPE_STORAGE_KEY = SCOPE_STORAGE_KEY;

},{}],674:[function(require,module,exports){
/**
 * Pict-MDE-CodeMirror: Helper module for PictSectionMarkdownEditor
 *
 * Handles CodeMirror editor instance creation, extension configuration,
 * keyboard shortcuts, paste handling, and the data URI collapse extension.
 */

/**
 * Attach CodeMirror editor creation methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Create a CodeMirror editor instance inside a container element.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to mount the editor in
	 * @param {number} pSegmentIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	pView._createEditorInContainer = function _createEditorInContainer(pContainer, pSegmentIndex, pContent)
	{
		let tmpCM = pView._codeMirrorModules;

		// Build the extensions array
		let tmpExtensions = [];

		// Keyboard shortcuts for formatting, inter-segment navigation, and image paste handling
		// IMPORTANT: Must be added BEFORE consumer extensions (e.g. basicSetup) so that
		// our domEventHandlers fire before CM6's internal keymap handlers.
		tmpExtensions.push(
			tmpCM.EditorView.domEventHandlers(
			{
				keydown: (pEvent, pEditorView) =>
				{
					// Ctrl/Cmd + B = bold
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'b')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'bold');
						return true;
					}
					// Ctrl/Cmd + I = italic
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'i')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'italic');
						return true;
					}
					// Ctrl/Cmd + E = inline code
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'e')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'code');
						return true;
					}

				},
				paste: (pEvent, pEditorView) =>
				{
					// Check clipboard for image data
					let tmpItems = pEvent.clipboardData && pEvent.clipboardData.items;
					if (!tmpItems)
					{
						return false;
					}
					for (let i = 0; i < tmpItems.length; i++)
					{
						// Paste: a clipboard item is not a File yet, so the type is tested directly.
						if (tmpItems[i].type.startsWith('image/') || tmpItems[i].type.startsWith('video/'))
						{
							pEvent.preventDefault();
							let tmpFile = tmpItems[i].getAsFile();
							if (tmpFile)
							{
								pView._processImageFile(tmpFile, pSegmentIndex);
							}
							return true;
						}
					}
					return false;
				},
				drop: (pEvent, pEditorView) =>
				{
					// Intercept image file drops at the CodeMirror level to prevent
					// the browser from inserting the image as a raw DOM element.
					// Without this, both CodeMirror's default drop behavior AND the
					// container-level handler fire, causing rendering artifacts.
					if (pView._dragSourceIndex >= 0)
					{
						return false; // segment-reorder drag, not a file drop
					}
					if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
					{
						return false;
					}
					let tmpFile = pEvent.dataTransfer.files[0];
					if (pView._isEmbeddableFile(tmpFile))
					{
						pEvent.preventDefault();
						pEvent.stopPropagation();
						pView._processImageFile(tmpFile, pSegmentIndex);
						// Clean up the dragover visual indicator on the container
						let tmpContainer = pEditorView.dom.closest('.pict-mde-segment-editor');
						if (tmpContainer)
						{
							tmpContainer.classList.remove('pict-mde-image-dragover');
						}
						return true;
					}
					return false;
				}
			})
		);

		// Add consumer-provided extensions (e.g. basicSetup, markdown())
		if (tmpCM.extensions && Array.isArray(tmpCM.extensions))
		{
			tmpExtensions = tmpExtensions.concat(tmpCM.extensions);
		}

		// Wrap long lines instead of scrolling horizontally. Markdown is prose, and
		// a horizontally-scrolling editor in a narrow pane is unusable. On by
		// default; a consumer can disable it with LineWrapping: false.
		if (pView.options.LineWrapping !== false)
		{
			tmpExtensions.push(tmpCM.EditorView.lineWrapping);
		}

		// Update listener for content changes, focus, and cursor tracking
		tmpExtensions.push(
			tmpCM.EditorView.updateListener.of((pUpdate) =>
			{
				if (pUpdate.docChanged)
				{
					pView._onSegmentContentChange(pSegmentIndex, pUpdate.state.doc.toString());
				}

				// Track focus changes to toggle the active class
				if (pUpdate.focusChanged)
				{
					if (pUpdate.view.hasFocus)
					{
						pView._setActiveSegment(pSegmentIndex);
						// Position sidebar at cursor on focus
						pView._updateSidebarPosition(pSegmentIndex);
					}
					else
					{
						// Small delay so clicking a sidebar button doesn't immediately deactivate
						setTimeout(() =>
						{
							if (pView._activeSegmentIndex === pSegmentIndex)
							{
								// Check if focus moved to another segment or truly left
								let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
								if (tmpSegEl && !tmpSegEl.contains(document.activeElement))
								{
									pView._clearActiveSegment(pSegmentIndex);
									pView._resetSidebarPosition(pSegmentIndex);
								}
							}
						}, 100);
					}
				}

				// Track cursor/selection changes to move the sidebar
				if (pUpdate.selectionSet && pUpdate.view.hasFocus)
				{
					pView._updateSidebarPosition(pSegmentIndex);
				}
			})
		);

		// Collapse long data URIs in image markdown so the editor is readable
		let tmpCollapseExtension = pView._buildDataURICollapseExtension();
		if (tmpCollapseExtension)
		{
			tmpExtensions.push(tmpCollapseExtension);
		}

		// Make read-only if configured
		if (pView.options.ReadOnly)
		{
			tmpExtensions.push(tmpCM.EditorState.readOnly.of(true));
			tmpExtensions.push(tmpCM.EditorView.editable.of(false));
		}

		// Allow consumer to customize extensions
		tmpExtensions = pView.customConfigureExtensions(tmpExtensions, pSegmentIndex);

		let tmpState = tmpCM.EditorState.create(
		{
			doc: pContent || '',
			extensions: tmpExtensions
		});

		let tmpEditorView = new tmpCM.EditorView(
		{
			state: tmpState,
			parent: pContainer
		});

		pView._segmentEditors[pSegmentIndex] = tmpEditorView;

		// -- Inter-segment arrow-key navigation --
		// Use a capture-phase DOM listener so we intercept ArrowDown/ArrowUp
		// BEFORE CodeMirror's internal keymap handlers process them.
		tmpEditorView.contentDOM.addEventListener('keydown', function (pEvent)
		{
			if (pEvent.key !== 'ArrowDown' && pEvent.key !== 'ArrowUp')
			{
				return;
			}
			// Don't interfere if a modifier key is held (selection, etc.)
			if (pEvent.shiftKey || pEvent.ctrlKey || pEvent.metaKey || pEvent.altKey)
			{
				return;
			}

			let tmpState = tmpEditorView.state;
			let tmpCursorPos = tmpState.selection.main.head;
			let tmpLine = tmpState.doc.lineAt(tmpCursorPos);
			let tmpColumnOffset = tmpCursorPos - tmpLine.from;

			if (pEvent.key === 'ArrowDown')
			{
				// Only navigate when cursor is on the very last line
				if (tmpLine.to < tmpState.doc.length)
				{
					return; // not on last line — let CM handle it
				}

				// Find next segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpOrderedIndices.length - 1)
				{
					return; // last segment — nowhere to go
				}

				let tmpNextInternalIndex = tmpOrderedIndices[tmpLogicalIndex + 1];
				let tmpNextEditor = pView._segmentEditors[tmpNextInternalIndex];
				if (!tmpNextEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the next editor and place cursor on the first line
				let tmpFirstLine = tmpNextEditor.state.doc.line(1);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpFirstLine.to - tmpFirstLine.from);
				tmpNextEditor.focus();
				tmpNextEditor.dispatch({ selection: { anchor: tmpFirstLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpNextInternalIndex);
			}
			else if (pEvent.key === 'ArrowUp')
			{
				// Only navigate when cursor is on the very first line
				if (tmpLine.number > 1)
				{
					return; // not on first line — let CM handle it
				}

				// Find previous segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex <= 0)
				{
					return; // first segment — nowhere to go
				}

				let tmpPrevInternalIndex = tmpOrderedIndices[tmpLogicalIndex - 1];
				let tmpPrevEditor = pView._segmentEditors[tmpPrevInternalIndex];
				if (!tmpPrevEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the previous editor and place cursor on the last line
				let tmpLastLine = tmpPrevEditor.state.doc.line(tmpPrevEditor.state.doc.lines);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpLastLine.to - tmpLastLine.from);
				tmpPrevEditor.focus();
				tmpPrevEditor.dispatch({ selection: { anchor: tmpLastLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpPrevInternalIndex);
			}
		}, true); // <-- capture phase

		// -- Capture-phase drop listener for image files --
		// Safari processes native contenteditable drops before CodeMirror's
		// bubble-phase domEventHandlers fire, which can insert a raw <img>
		// element into the editor DOM.  A capture-phase listener fires first
		// and lets us preventDefault() before the browser acts.
		tmpEditorView.contentDOM.addEventListener('drop', function (pEvent)
		{
			if (pView._dragSourceIndex >= 0)
			{
				return; // segment-reorder drag
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}
			let tmpFile = pEvent.dataTransfer.files[0];
			if (pView._isEmbeddableFile(tmpFile))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
				// Clean up the dragover visual indicator
				let tmpEditorEl = pView._resolveInstanceElement(`PictMDE-SegmentEditor-${pSegmentIndex}`);
				if (tmpEditorEl)
				{
					tmpEditorEl.classList.remove('pict-mde-image-dragover');
				}
			}
		}, true); // <-- capture phase
	};

	/**
	 * Build a CodeMirror extension that visually collapses long data URIs
	 * inside markdown image syntax.
	 *
	 * The extension uses Decoration.replace() to hide the long base64 portion
	 * and show a compact widget instead, e.g. "data:image/jpeg;base64...28KB".
	 * The actual document content is unchanged -- only the visual display
	 * is affected.
	 *
	 * Returns null if the required CodeMirror modules (Decoration, ViewPlugin,
	 * WidgetType) are not available.
	 *
	 * @returns {object|null} A CodeMirror ViewPlugin extension, or null
	 */
	pView._buildDataURICollapseExtension = function _buildDataURICollapseExtension()
	{
		let tmpCM = pView._codeMirrorModules;

		// All three classes are required -- degrade gracefully if not available
		if (!tmpCM || !tmpCM.Decoration || !tmpCM.ViewPlugin || !tmpCM.WidgetType)
		{
			return null;
		}

		let tmpDecoration = tmpCM.Decoration;
		let tmpViewPlugin = tmpCM.ViewPlugin;
		let tmpWidgetType = tmpCM.WidgetType;

		// Minimum data URI length before collapsing (short URIs are left alone)
		let tmpMinLength = 200;

		// Widget class: renders the collapsed placeholder inline
		class DataURIWidget extends tmpWidgetType
		{
			constructor(pLabel)
			{
				super();
				this.label = pLabel;
			}

			toDOM()
			{
				let tmpSpan = document.createElement('span');
				tmpSpan.className = 'pict-mde-data-uri-collapsed';
				tmpSpan.textContent = this.label;
				tmpSpan.title = 'Data URI (click to expand in image preview below)';
				return tmpSpan;
			}

			eq(pOther)
			{
				return this.label === pOther.label;
			}
		}

		/**
		 * Scan the visible ranges of the document for data URIs inside image
		 * markdown and build a DecorationSet that replaces the long portion.
		 *
		 * Pattern:  ![alt](data:image/TYPE;base64,LONGSTRING)
		 *
		 * We keep "![alt](data:image/TYPE;base64," visible and replace only the
		 * long base64 payload plus the closing ")" with a compact widget.
		 */
		function buildDecorations(pEditorView)
		{
			let tmpDecorations = [];
			let tmpDoc = pEditorView.state.doc;

			for (let tmpVisRange of pEditorView.visibleRanges)
			{
				let tmpFrom = tmpVisRange.from;
				let tmpTo = tmpVisRange.to;
				let tmpText = tmpDoc.sliceString(tmpFrom, tmpTo);

				// Match: ![...](data:image/...;base64,...) -- we need positions of the base64 payload
				let tmpRegex = /!\[[^\]]*\]\(data:([^;]+);base64,/g;
				let tmpMatch;

				while ((tmpMatch = tmpRegex.exec(tmpText)) !== null)
				{
					// tmpMatch[0] is "![alt](data:image/png;base64,"
					// tmpMatch[1] is the MIME subtype, e.g. "image/png"
					let tmpPayloadStart = tmpFrom + tmpMatch.index + tmpMatch[0].length;

					// Find the closing parenthesis -- scan forward from payloadStart
					let tmpPayloadEnd = -1;
					let tmpSearchFrom = tmpPayloadStart;
					let tmpDocLength = tmpDoc.length;

					// Scan character by character in the document for the closing ')'
					// We need to handle this carefully since the payload could be huge
					// and span beyond the visible range.
					// Search up to 5MB worth of characters (way more than any realistic image).
					let tmpMaxScan = Math.min(tmpDocLength, tmpSearchFrom + 5 * 1024 * 1024);
					let tmpChunkSize = 4096;

					for (let tmpPos = tmpSearchFrom; tmpPos < tmpMaxScan; tmpPos += tmpChunkSize)
					{
						let tmpEnd = Math.min(tmpPos + tmpChunkSize, tmpMaxScan);
						let tmpChunk = tmpDoc.sliceString(tmpPos, tmpEnd);
						let tmpParenIdx = tmpChunk.indexOf(')');
						if (tmpParenIdx >= 0)
						{
							tmpPayloadEnd = tmpPos + tmpParenIdx;
							break;
						}
					}

					if (tmpPayloadEnd < 0)
					{
						// No closing paren found -- skip this match
						continue;
					}

					// Calculate the payload length (base64 data between comma and closing paren)
					let tmpPayloadLength = tmpPayloadEnd - tmpPayloadStart;

					if (tmpPayloadLength < tmpMinLength)
					{
						// Too short to bother collapsing
						continue;
					}

					// Build a human-readable size label
					let tmpSizeBytes = Math.round(tmpPayloadLength * 0.75); // base64 to bytes approx
					let tmpSizeLabel;
					if (tmpSizeBytes >= 1024 * 1024)
					{
						tmpSizeLabel = (tmpSizeBytes / (1024 * 1024)).toFixed(1) + 'MB';
					}
					else if (tmpSizeBytes >= 1024)
					{
						tmpSizeLabel = Math.round(tmpSizeBytes / 1024) + 'KB';
					}
					else
					{
						tmpSizeLabel = tmpSizeBytes + 'B';
					}

					let tmpMimeType = tmpMatch[1] || 'image';
					let tmpWidgetLabel = `\u2026${tmpSizeLabel})`;

					// Replace from the start of the base64 payload to after the closing paren
					let tmpWidget = tmpDecoration.replace(
					{
						widget: new DataURIWidget(tmpWidgetLabel)
					});

					tmpDecorations.push(tmpWidget.range(tmpPayloadStart, tmpPayloadEnd + 1));
				}
			}

			return tmpDecoration.set(tmpDecorations, true);
		}

		// Create the ViewPlugin
		let tmpPlugin = tmpViewPlugin.fromClass(
			class
			{
				constructor(pEditorView)
				{
					this.decorations = buildDecorations(pEditorView);
				}

				update(pUpdate)
				{
					if (pUpdate.docChanged || pUpdate.viewportChanged)
					{
						this.decorations = buildDecorations(pUpdate.view);
					}
				}
			},
			{
				decorations: (pPlugin) => pPlugin.decorations
			}
		);

		return tmpPlugin;
	};
};

},{}],675:[function(require,module,exports){
/**
 * Pict-MDE-DragAndReorder: Helper module for PictSectionMarkdownEditor
 *
 * Handles segment drag-and-drop reordering, active segment management,
 * sidebar cursor-tracking positioning, and hidden-preview state maintenance
 * across reorder operations.
 */

/**
 * Attach drag/reorder and active-segment methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Wire drag-and-drop events on a segment element for reorder via the drag handle.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireSegmentDragEvents = function _wireSegmentDragEvents(pSegmentElement, pSegmentIndex)
	{
		let tmpHandle = pSegmentElement.querySelector('.pict-mde-drag-handle');
		if (!tmpHandle)
		{
			return;
		}

		// The drag handle is the draggable element
		tmpHandle.addEventListener('dragstart', (pEvent) =>
		{
			pView._dragSourceIndex = pSegmentIndex;
			pEvent.dataTransfer.effectAllowed = 'move';
			pEvent.dataTransfer.setData('text/plain', String(pSegmentIndex));
			// Add a dragging class to the container so CSS can disable pointer-events
			// on CodeMirror editors (preventing them from intercepting the drop event)
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.add('pict-mde-dragging');
			}
			setTimeout(() =>
			{
				pSegmentElement.style.opacity = '0.4';
			}, 0);
		});

		tmpHandle.addEventListener('dragend', () =>
		{
			pSegmentElement.style.opacity = '';
			pView._dragSourceIndex = -1;
			pView._clearAllDropIndicators();
			// Remove the dragging class from the container
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.remove('pict-mde-dragging');
			}
		});

		// Drop target: the whole segment row. We determine above/below from mouse Y.
		pSegmentElement.addEventListener('dragover', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'move';

			// Clear all indicators first, then set the correct one
			pView._clearAllDropIndicators();

			// Determine if cursor is in the top or bottom half of this segment
			let tmpRect = pSegmentElement.getBoundingClientRect();
			let tmpMidY = tmpRect.top + (tmpRect.height / 2);
			if (pEvent.clientY < tmpMidY)
			{
				pSegmentElement.classList.add('pict-mde-drag-over-top');
			}
			else
			{
				pSegmentElement.classList.add('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if we're actually leaving the element (not entering a child)
			if (!pSegmentElement.contains(pEvent.relatedTarget))
			{
				pSegmentElement.classList.remove('pict-mde-drag-over-top');
				pSegmentElement.classList.remove('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('drop', (pEvent) =>
		{
			pEvent.preventDefault();

			let tmpDropBelow = pSegmentElement.classList.contains('pict-mde-drag-over-bottom');
			pView._clearAllDropIndicators();

			let tmpSourceIndex = pView._dragSourceIndex;
			if (tmpSourceIndex < 0 || tmpSourceIndex === pSegmentIndex)
			{
				return;
			}

			pView._reorderSegment(tmpSourceIndex, pSegmentIndex, tmpDropBelow);
		});
	};

	/**
	 * Clear all drop indicator classes from all segments.
	 */
	pView._clearAllDropIndicators = function _clearAllDropIndicators()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}
		let tmpAllSegments = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpAllSegments.length; i++)
		{
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-top');
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-bottom');
		}
	};

	/**
	 * Reorder a segment from one position to another via drag.
	 *
	 * @param {number} pFromInternalIndex - The internal index of the dragged segment
	 * @param {number} pToInternalIndex - The internal index of the drop target
	 * @param {boolean} pDropBelow - Whether the drop was on the bottom half of the target
	 */
	pView._reorderSegment = function _reorderSegment(pFromInternalIndex, pToInternalIndex, pDropBelow)
	{
		let tmpFromLogical = pView._getLogicalIndex(pFromInternalIndex);
		let tmpToLogical = pView._getLogicalIndex(pToInternalIndex);

		if (tmpFromLogical < 0 || tmpToLogical < 0)
		{
			pView.log.warn(`PICT-MarkdownEditor _reorderSegment: could not resolve logical indices (from=${tmpFromLogical}, to=${tmpToLogical}).`);
			return;
		}

		if (tmpFromLogical === tmpToLogical)
		{
			return;
		}

		// Marshal all editor content back to data before manipulating the array
		pView._marshalAllEditorsToData();

		let tmpSegments = pView._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length < 2)
		{
			return;
		}

		// Calculate the target insertion index
		let tmpInsertAt = pDropBelow ? tmpToLogical + 1 : tmpToLogical;

		// Adjust for the removal shifting indices down
		if (tmpFromLogical < tmpInsertAt)
		{
			tmpInsertAt--;
		}

		// If the insert position equals the source, no move needed
		if (tmpInsertAt === tmpFromLogical)
		{
			return;
		}

		// Perform the reorder: remove from old position, insert at new
		let tmpMoved = tmpSegments.splice(tmpFromLogical, 1)[0];
		tmpSegments.splice(tmpInsertAt, 0, tmpMoved);

		// Explicitly write the reordered array back to the data address
		pView._setSegmentsToData(tmpSegments);

		// Reorder per-segment hidden preview state to follow the moved segment
		pView._reorderHiddenPreviewState(tmpFromLogical, tmpInsertAt);

		// Reorder per-segment tab states to follow the moved segment
		pView._reorderSegmentTabStates(tmpFromLogical, tmpInsertAt);

		pView._buildEditorUI();
	};

	/**
	 * Reorder the hidden preview state after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderHiddenPreviewState = function _reorderHiddenPreviewState(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		// Build an ordered array of hidden-state booleans
		let tmpKeys = Object.keys(pView._hiddenPreviewSegments).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(!!pView._hiddenPreviewSegments[i]);
		}

		// Perform the same splice on the states array
		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		// Rebuild the hidden map
		pView._hiddenPreviewSegments = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i])
			{
				pView._hiddenPreviewSegments[i] = true;
			}
		}
	};

	/**
	 * Swap the hidden preview state of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapHiddenPreviewState = function _swapHiddenPreviewState(pIndexA, pIndexB)
	{
		let tmpAHidden = !!pView._hiddenPreviewSegments[pIndexA];
		let tmpBHidden = !!pView._hiddenPreviewSegments[pIndexB];

		if (tmpBHidden) { pView._hiddenPreviewSegments[pIndexA] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexA]; }

		if (tmpAHidden) { pView._hiddenPreviewSegments[pIndexB] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexB]; }
	};

	/**
	 * Reorder the segment tab states after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderSegmentTabStates = function _reorderSegmentTabStates(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		let tmpKeys = Object.keys(pView._segmentTabStates).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(pView._segmentTabStates[i] || 'editor');
		}

		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		pView._segmentTabStates = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i] !== 'editor')
			{
				pView._segmentTabStates[i] = tmpStates[i];
			}
		}
	};

	/**
	 * Swap the segment tab states of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapSegmentTabStates = function _swapSegmentTabStates(pIndexA, pIndexB)
	{
		let tmpA = pView._segmentTabStates[pIndexA] || 'editor';
		let tmpB = pView._segmentTabStates[pIndexB] || 'editor';

		if (tmpB !== 'editor') { pView._segmentTabStates[pIndexA] = tmpB; }
		else { delete pView._segmentTabStates[pIndexA]; }

		if (tmpA !== 'editor') { pView._segmentTabStates[pIndexB] = tmpA; }
		else { delete pView._segmentTabStates[pIndexB]; }
	};

	// -- Active Segment Management --

	/**
	 * Set a segment as the active (focused) segment.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._setActiveSegment = function _setActiveSegment(pSegmentIndex)
	{
		// Clear previous active
		if (pView._activeSegmentIndex >= 0 && pView._activeSegmentIndex !== pSegmentIndex)
		{
			let tmpPrevEl = pView._resolveInstanceElement(`PictMDE-Segment-${pView._activeSegmentIndex}`);
			if (tmpPrevEl)
			{
				tmpPrevEl.classList.remove('pict-mde-active');
			}
		}

		pView._activeSegmentIndex = pSegmentIndex;

		let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.add('pict-mde-active');
		}
	};

	/**
	 * Clear the active state from a segment (on blur).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._clearActiveSegment = function _clearActiveSegment(pSegmentIndex)
	{
		if (pView._activeSegmentIndex === pSegmentIndex)
		{
			pView._activeSegmentIndex = -1;
		}

		let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.remove('pict-mde-active');
		}

		// Reset sidebar back to sticky when segment is no longer active
		pView._resetSidebarPosition(pSegmentIndex);
	};

	// -- Sidebar Cursor Tracking --

	/**
	 * Update the sidebar formatting-buttons position so they float next to the
	 * cursor / selection in the active segment.
	 *
	 * When a segment is active and has a cursor, we switch the sidebar-actions
	 * from sticky positioning to absolute, offset to align with the cursor line.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateSidebarPosition = function _updateSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			return;
		}

		// Get the cursor position in the editor
		let tmpCursorPos = tmpEditor.state.selection.main.head;
		let tmpCursorCoords = tmpEditor.coordsAtPos(tmpCursorPos);
		if (!tmpCursorCoords)
		{
			// If we can't get coords, revert to sticky
			pView._resetSidebarPosition(pSegmentIndex);
			return;
		}

		// Calculate the offset relative to the segment element
		let tmpSegmentRect = tmpSegmentEl.getBoundingClientRect();
		let tmpOffsetTop = tmpCursorCoords.top - tmpSegmentRect.top;

		// Clamp so the sidebar buttons don't go above the segment or below it
		let tmpSidebarHeight = tmpQuadrantTR.offsetHeight || 0;
		let tmpSegmentHeight = tmpSegmentEl.offsetHeight || 0;
		let tmpMaxOffset = Math.max(0, tmpSegmentHeight - tmpSidebarHeight);
		tmpOffsetTop = Math.max(0, Math.min(tmpOffsetTop, tmpMaxOffset));

		// Apply the cursor-relative positioning
		tmpQuadrantTR.classList.add('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.setProperty('--pict-mde-sidebar-top', `${tmpOffsetTop}px`);
	};

	/**
	 * Reset the sidebar back to default sticky positioning (no cursor tracking).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._resetSidebarPosition = function _resetSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		tmpQuadrantTR.classList.remove('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.removeProperty('--pict-mde-sidebar-top');
	};
};

},{}],676:[function(require,module,exports){
/**
 * Pict-MDE-Formatting: Helper module for PictSectionMarkdownEditor
 *
 * Handles markdown formatting operations (bold, italic, code, heading, link)
 * applied to selections or at the cursor position in CodeMirror editors.
 */

// Markdown formatting definitions: wrapper characters for toggle-style formatting
const _FormattingMap =
{
	bold: { wrap: '**' },
	italic: { wrap: '*' },
	code: { wrap: '`' },
	heading: { prefix: '# ' },
	link: { before: '[', after: '](url)' }
};

/**
 * Attach formatting methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Apply markdown formatting to the selection (or insert formatting at cursor)
	 * in a specific segment.
	 *
	 * If text is selected, wraps it.  If no selection, inserts the formatting
	 * markers and places the cursor between them.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pFormatType - One of: 'bold', 'italic', 'code', 'heading', 'link'
	 */
	pView.applyFormatting = function applyFormatting(pSegmentIndex, pFormatType)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpFormat = _FormattingMap[pFormatType];
		if (!tmpFormat)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: unknown format type "${pFormatType}".`);
			return;
		}

		let tmpState = tmpEditor.state;
		let tmpSelection = tmpState.selection.main;
		let tmpFrom = tmpSelection.from;
		let tmpTo = tmpSelection.to;
		let tmpHasSelection = (tmpFrom !== tmpTo);
		let tmpSelectedText = tmpHasSelection ? tmpState.sliceDoc(tmpFrom, tmpTo) : '';

		let tmpChanges;
		let tmpCursorPos;

		if (tmpFormat.wrap)
		{
			// Toggle-style: wrap selection or insert empty wrapper
			let tmpWrap = tmpFormat.wrap;
			if (tmpHasSelection)
			{
				// Check if already wrapped — if so, unwrap
				let tmpBefore = tmpState.sliceDoc(Math.max(0, tmpFrom - tmpWrap.length), tmpFrom);
				let tmpAfter = tmpState.sliceDoc(tmpTo, Math.min(tmpState.doc.length, tmpTo + tmpWrap.length));

				if (tmpBefore === tmpWrap && tmpAfter === tmpWrap)
				{
					// Unwrap
					tmpChanges = [
						{ from: tmpFrom - tmpWrap.length, to: tmpFrom, insert: '' },
						{ from: tmpTo, to: tmpTo + tmpWrap.length, insert: '' }
					];
					tmpCursorPos = tmpFrom - tmpWrap.length;
					tmpEditor.dispatch(
					{
						changes: tmpChanges,
						selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
					});
					return;
				}

				// Wrap the selection
				let tmpInsert = tmpWrap + tmpSelectedText + tmpWrap;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
				});
			}
			else
			{
				// No selection: insert empty wrapper and place cursor inside
				let tmpInsert = tmpWrap + tmpWrap;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}
		else if (tmpFormat.prefix)
		{
			// Line-prefix style (headings)
			let tmpLine = tmpState.doc.lineAt(tmpFrom);
			let tmpLineText = tmpLine.text;

			// Toggle: if line already starts with the prefix, remove it; otherwise add
			if (tmpLineText.startsWith(tmpFormat.prefix))
			{
				tmpChanges = { from: tmpLine.from, to: tmpLine.from + tmpFormat.prefix.length, insert: '' };
			}
			else
			{
				tmpChanges = { from: tmpLine.from, insert: tmpFormat.prefix };
			}
			tmpEditor.dispatch({ changes: tmpChanges });
		}
		else if (tmpFormat.before && tmpFormat.after)
		{
			// Surround style (links)
			if (tmpHasSelection)
			{
				let tmpInsert = tmpFormat.before + tmpSelectedText + tmpFormat.after;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				// Place cursor on the "url" part
				tmpCursorPos = tmpFrom + tmpFormat.before.length + tmpSelectedText.length + 2;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + 3 }
				});
			}
			else
			{
				let tmpInsert = tmpFormat.before + tmpFormat.after;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpFormat.before.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}

		// Re-focus the editor after clicking a sidebar button
		tmpEditor.focus();
	};
};

},{}],677:[function(require,module,exports){
/**
 * Pict-MDE-ImageHandling: Helper module for PictSectionMarkdownEditor
 *
 * Handles image operations: file picker, file processing (hook or base64
 * fallback), markdown insertion, preview thumbnail rendering, and
 * drag-and-drop for image files onto the editor.
 */

/**
 * Attach image handling methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Open a file picker to select an image for insertion into a segment.
	 * Called by the sidebar image button onclick handler.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView.openImagePicker = function openImagePicker(pSegmentIndex)
	{
		let tmpFileInput = pView._resolveInstanceElement(`PictMDE-ImageInput-${pSegmentIndex}`);
		if (!tmpFileInput)
		{
			pView.log.warn(`PICT-MarkdownEditor openImagePicker: file input not found for segment ${pSegmentIndex}.`);
			return;
		}

		// Wire the change handler fresh each time (in case it was already used)
		tmpFileInput.onchange = () =>
		{
			if (tmpFileInput.files && tmpFileInput.files.length > 0)
			{
				pView._processImageFile(tmpFileInput.files[0], pSegmentIndex);
			}
			// Reset the input so the same file can be re-selected
			tmpFileInput.value = '';
		};

		tmpFileInput.click();
	};

	/**
	 * Is this a file the editor can put into a document -- an image or a video?
	 *
	 * One test, used by every entry point (picker, drag, paste), so a file that can be dropped can also be
	 * pasted and vice versa. Anything else is ignored: a dropped PDF is not something markdown can show.
	 *
	 * @param {File} pFile
	 * @returns {boolean}
	 */
	pView._isEmbeddableFile = function _isEmbeddableFile(pFile)
	{
		if (!pFile || !pFile.type) { return false; }
		return pFile.type.startsWith('image/') || pFile.type.startsWith('video/');
	};

	/**
	 * Process an image or video File object from any input method (picker, drag, paste).
	 *
	 * If the consumer has overridden onImageUpload and it returns true, the consumer handles the upload and
	 * calls the callback with a URL. Otherwise the file is converted to a base64 data URI inline.
	 *
	 * NOTE for consumers: onImageUpload now receives VIDEO files as well as images. It always had the File,
	 * so a consumer that cares can branch on pFile.type; the hook was not split in two because a second hook
	 * would mean video silently doing nothing until every consumer implemented it.
	 *
	 * A video is inserted as a `video` fence rather than the image form, because an uploaded file is usually
	 * addressed by a blob route with no extension -- and the renderer can only read "this is a video" off an
	 * extension. The fence says it outright.
	 *
	 * @param {File} pFile - The image or video File object
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._processImageFile = function _processImageFile(pFile, pSegmentIndex)
	{
		if (!pView._isEmbeddableFile(pFile))
		{
			pView.log.warn(`PICT-MarkdownEditor _processImageFile: not an image or video file (type: ${pFile ? pFile.type : 'null'}).`);
			return;
		}

		let tmpIsVideo = pFile.type.startsWith('video/');
		let tmpAltText = pFile.name ? pFile.name.replace(/\.[^.]+$/, '') : (tmpIsVideo ? 'video' : 'image');

		// Check if the consumer wants to handle the upload
		let tmpCallback = (pError, pURL) =>
		{
			if (pError)
			{
				pView.log.error(`PICT-MarkdownEditor image upload error: ${pError}`);
				return;
			}
			if (pURL)
			{
				if (tmpIsVideo) { pView._insertVideoMarkdown(pSegmentIndex, pURL, tmpAltText); }
				else { pView._insertImageMarkdown(pSegmentIndex, pURL, tmpAltText); }
			}
		};

		let tmpHandled = pView.onImageUpload(pFile, pSegmentIndex, tmpCallback);

		if (tmpHandled)
		{
			// Consumer is handling the upload asynchronously
			return;
		}

		// Default: convert to base64 data URI
		if (typeof (FileReader) === 'undefined')
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader not available in this environment.`);
			return;
		}

		// A video has no inline fallback worth having: a base64 data URI of a recording is megabytes of text
		// pasted into the document, which bloats every save and read of it from then on. Without a consumer
		// upload handler there is nowhere to put it, so say so rather than wedging the document.
		if (tmpIsVideo)
		{
			pView.log.warn('PICT-MarkdownEditor: a video needs an upload handler (onImageUpload) -- inlining one as a data URI would embed megabytes of base64 in the document.');
			return;
		}

		let tmpReader = new FileReader();
		tmpReader.onload = () =>
		{
			pView._insertImageMarkdown(pSegmentIndex, tmpReader.result, tmpAltText);
		};
		tmpReader.onerror = () =>
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader error.`);
		};
		tmpReader.readAsDataURL(pFile);
	};

	/**
	 * Insert a `video` fence at the cursor position in a segment editor.
	 *
	 * The fence rather than the image form: an uploaded recording is usually addressed by a blob route with
	 * no file extension, and the renderer reads "this is a video" off the extension. The fence states it.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The video URL
	 * @param {string} [pTitle] - The title line (default: 'video')
	 */
	pView._insertVideoMarkdown = function _insertVideoMarkdown(pSegmentIndex, pURL, pTitle)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertVideoMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpTitle = pTitle || 'video';
		// Sits on its own lines: a fence has to start at the beginning of a line to be a fence at all.
		let tmpInsert = '\n```video\n' + pURL + '\ntitle: ' + tmpTitle + '\n```\n';

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});
		tmpEditor.focus();
	};

	/**
	 * Insert markdown image syntax at the cursor position in a segment editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The image URL (data URI or remote URL)
	 * @param {string} [pAltText] - The alt text (default: 'image')
	 */
	pView._insertImageMarkdown = function _insertImageMarkdown(pSegmentIndex, pURL, pAltText)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertImageMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpAlt = pAltText || 'image';
		let tmpInsert = `![${tmpAlt}](${pURL})`;

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});

		tmpEditor.focus();

		// Update the image preview area for this segment
		pView._updateImagePreviews(pSegmentIndex);
	};

	/**
	 * Scan the content of a segment for markdown image references and render
	 * preview thumbnails in the preview area below the editor.
	 *
	 * Matches the pattern ![alt](url) and creates <img> elements for each.
	 * The preview area is hidden when there are no images.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateImagePreviews = function _updateImagePreviews(pSegmentIndex)
	{
		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-ImagePreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		// Match markdown image syntax: ![alt text](url)
		let tmpImageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
		let tmpMatches = [];
		let tmpMatch;
		while ((tmpMatch = tmpImageRegex.exec(tmpContent)) !== null)
		{
			tmpMatches.push(
			{
				alt: tmpMatch[1] || 'image',
				url: tmpMatch[2]
			});
		}

		if (tmpMatches.length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		// Build preview HTML
		let tmpHTML = '';
		for (let i = 0; i < tmpMatches.length; i++)
		{
			let tmpAlt = tmpMatches[i].alt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			let tmpResolvedURL = pView._resolveImageURL(tmpMatches[i].url);
			let tmpURL = tmpResolvedURL.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
			tmpHTML += `<div class="pict-mde-image-preview-item"><img src="${tmpURL}" alt="${tmpAlt}" /><span class="pict-mde-image-preview-label">${tmpAlt}</span></div>`;
		}

		tmpPreviewEl.innerHTML = tmpHTML;
		tmpPreviewEl.classList.add('pict-mde-has-images');
	};

	/**
	 * Wire drag-and-drop events for image files on a segment editor container.
	 *
	 * These events are separate from the segment-reorder drag events.
	 * File drags are distinguished from segment reorder drags by checking
	 * dataTransfer.types for 'Files' and ensuring _dragSourceIndex is -1.
	 *
	 * @param {HTMLElement} pEditorContainer - The .pict-mde-segment-editor element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireImageDragEvents = function _wireImageDragEvents(pEditorContainer, pSegmentIndex)
	{
		pEditorContainer.addEventListener('dragover', (pEvent) =>
		{
			// Only handle file drags, not segment-reorder drags
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.types || pEvent.dataTransfer.types.indexOf('Files') < 0)
			{
				return;
			}
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'copy';
			pEditorContainer.classList.add('pict-mde-image-dragover');
		});

		pEditorContainer.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if actually leaving the element
			if (!pEditorContainer.contains(pEvent.relatedTarget))
			{
				pEditorContainer.classList.remove('pict-mde-image-dragover');
			}
		});

		pEditorContainer.addEventListener('drop', (pEvent) =>
		{
			pEditorContainer.classList.remove('pict-mde-image-dragover');

			// Only handle file drops, not segment-reorder drops
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}

			let tmpFile = pEvent.dataTransfer.files[0];
			if (pView._isEmbeddableFile(tmpFile))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
			}
		});
	};
};

},{}],678:[function(require,module,exports){
/**
 * Pict-MDE-RichPreview: Helper module for PictSectionMarkdownEditor
 *
 * Handles rich content preview rendering via pict-section-content:
 * markdown-to-HTML parsing, mermaid diagram rendering, KaTeX math
 * rendering, and the full rendered-view toggle.
 */

const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;

/**
 * Attach rich preview methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Get the pict-section-content provider instance for markdown parsing.
	 * Lazily instantiated on first use.
	 *
	 * @returns {object} The PictContentProvider instance
	 */
	pView._getContentProvider = function _getContentProvider()
	{
		if (!pView._contentProvider)
		{
			pView._contentProvider = new libPictContentProvider(pView.fable, {}, 'Pict-Content-Provider-MDE');
		}
		return pView._contentProvider;
	};

	/**
	 * Render the raw markdown content of a segment into the rich preview area
	 * using pict-section-content's parseMarkdown() provider method.
	 *
	 * The rendered HTML includes syntax-highlighted code blocks, mermaid diagram
	 * placeholders, KaTeX math placeholders, headings, lists, tables, etc.
	 *
	 * After setting innerHTML, post-render hooks call mermaid.run() and
	 * katex.render() to activate diagrams and equations (if those libraries
	 * are available on window -- loaded by the consumer via CDN).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateRichPreviews = function _updateRichPreviews(pSegmentIndex)
	{
		if (!pView.options.EnableRichPreview)
		{
			return;
		}

		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-RichPreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		if (!tmpContent || tmpContent.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Use pict-section-content's provider to parse the raw markdown into HTML.
		// If a Vocabulary provider is registered on the pict instance,
		// pass its resolver so vocabulary terms auto-link in the preview.
		let tmpProvider = pView._getContentProvider();
		let tmpVocabResolver = null;
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.getResolver === 'function')
		{
			tmpVocabResolver = pView.pict.providers.Vocabulary.getResolver();
		}
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpContent, null, null, tmpVocabResolver);

		if (!tmpRenderedHTML || tmpRenderedHTML.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Wrap the rendered HTML in a pict-content container so that
		// pict-section-content's CSS classes take effect
		let tmpPreviewID = `PictMDE-RichPreviewBody-${pSegmentIndex}`;
		tmpPreviewEl.innerHTML = `<div class="pict-content" id="${tmpPreviewID}">${tmpRenderedHTML}</div>`;
		tmpPreviewEl.classList.add('pict-mde-has-rich-preview');

		// Wire vocabulary popover hover handlers if the provider is available
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.wirePopovers === 'function')
		{
			pView.pict.providers.Vocabulary.wirePopovers('#' + tmpPreviewID);
		}

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpPreviewEl.querySelectorAll('img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation counter for stale-render protection (mermaid is async)
		let tmpGeneration = (pView._richPreviewGenerations[pSegmentIndex] || 0) + 1;
		pView._richPreviewGenerations[pSegmentIndex] = tmpGeneration;

		// Post-render: call mermaid.run() for mermaid diagram elements
		pView._postRenderMermaid(tmpPreviewID, pSegmentIndex, tmpGeneration);

		// Post-render: call katex.render() for KaTeX math elements
		pView._postRenderKaTeX(tmpPreviewID);
	};

	/**
	 * Lazily bind the shared Theme-Diagram-Adapter for mermaid.  The
	 * adapter handles mermaid.initialize() against the active pict
	 * theme, subscribes to onApply, and re-renders existing diagrams
	 * when the theme/mode changes.  Idempotent.
	 *
	 * Falls back to a direct-require path when no theme provider is
	 * installed — the static base theme still picks up any CSS
	 * variables on :root.
	 */
	pView._ensureMermaidAdapter = function _ensureMermaidAdapter()
	{
		if (pView._mermaidAdapter) { return pView._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				pView._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				pView._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid theme adapter init failed: ${pError.message || pError}`);
			pView._mermaidAdapter = null;
		}
		return pView._mermaidAdapter;
	};

	/**
	 * Post-render hook: render Mermaid diagrams in the preview container.
	 * Uses the same approach as pict-section-content's renderMermaidDiagrams().
	 *
	 * @param {string} pContainerID - The container element ID
	 * @param {number} pSegmentIndex - The segment index (for stale-render protection)
	 * @param {number} pGeneration - The generation counter value
	 */
	pView._postRenderMermaid = function _postRenderMermaid(pContainerID, pSegmentIndex, pGeneration)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainer = pView._resolveInstanceElement(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		let tmpMermaidElements = tmpContainer.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the shared Theme-Diagram-Adapter so mermaid
		// follows the active palette and re-renders when the theme/mode
		// changes (manual toggle or OS-driven via prefers-color-scheme).
		pView._ensureMermaidAdapter();

		// Cache each diagram's source on the element. mermaid.run()
		// replaces textContent with the rendered SVG; the cache lets
		// the adapter's refresh re-run without re-parsing markdown.
		let tmpProviderForStash = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		try
		{
			let tmpPromise = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpPromise && typeof tmpPromise.catch === 'function')
			{
				tmpPromise.catch((pError) =>
				{
					// Check stale-render: rendered view uses _renderedViewGeneration,
					// per-segment previews use _richPreviewGenerations
					let tmpCurrentGen = (pSegmentIndex === -1)
						? pView._renderedViewGeneration
						: pView._richPreviewGenerations[pSegmentIndex];
					if (tmpCurrentGen !== pGeneration)
					{
						return; // stale render -- a newer update has replaced us
					}
					pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
				});
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
		}
	};

	/**
	 * Post-render hook: render KaTeX inline and display math in the preview container.
	 * Uses the same approach as pict-section-content's renderKaTeXEquations().
	 *
	 * @param {string} pContainerID - The container element ID
	 */
	pView._postRenderKaTeX = function _postRenderKaTeX(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainer = pView._resolveInstanceElement(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		// Render inline math: <span class="pict-content-katex-inline">
		let tmpInlineElements = tmpContainer.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX inline error: ${pError.message || pError}`);
			}
		}

		// Render display math: <div class="pict-content-katex-display">
		let tmpDisplayElements = tmpContainer.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX display error: ${pError.message || pError}`);
			}
		}
	};

	/**
	 * Simple HTML escape for error messages in the rich preview.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string}
	 */
	pView._escapeHTMLForPreview = function _escapeHTMLForPreview(pText)
	{
		return pText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	};

	// -- Rendered View (full document preview) --

	/**
	 * Toggle between the editing view (CodeMirror segments) and a fully rendered
	 * view of the combined markdown output using pict-section-content.
	 *
	 * @param {boolean} [pRendered] - If provided, set to this value; otherwise toggle
	 */
	pView.toggleRenderedView = function toggleRenderedView(pRendered)
	{
		if (typeof (pRendered) === 'boolean')
		{
			pView._renderedViewActive = pRendered;
		}
		else
		{
			pView._renderedViewActive = !pView._renderedViewActive;
		}

		if (pView._renderedViewActive)
		{
			pView._renderRenderedView();
		}
		else
		{
			pView._restoreEditingView();
		}
	};

	/**
	 * Switch to the rendered view: marshal all editors, combine all segment
	 * content, render to HTML via pict-section-content, and replace the
	 * container contents with the rendered output.
	 */
	pView._renderRenderedView = function _renderRenderedView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		// Marshal current editor content back to data before switching
		pView._marshalAllEditorsToData();

		// Combine all segments into a single markdown document
		let tmpSegments = pView._getSegmentsFromData();
		let tmpCombinedContent = '';
		if (tmpSegments && tmpSegments.length > 0)
		{
			let tmpParts = [];
			for (let i = 0; i < tmpSegments.length; i++)
			{
				tmpParts.push(tmpSegments[i].Content || '');
			}
			tmpCombinedContent = tmpParts.join('\n\n');
		}

		// Destroy existing CodeMirror editors
		for (let tmpIdx in pView._segmentEditors)
		{
			if (pView._segmentEditors[tmpIdx])
			{
				pView._segmentEditors[tmpIdx].destroy();
			}
		}
		pView._segmentEditors = {};

		// Render the combined markdown via pict-section-content
		let tmpProvider = pView._getContentProvider();
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpCombinedContent);

		// Build the rendered view container
		let tmpRenderedViewID = 'PictMDE-RenderedView';
		tmpContainer.innerHTML = `<div class="pict-mde-rendered-view" id="${tmpRenderedViewID}"><div class="pict-content">${tmpRenderedHTML || ''}</div></div>`;
		tmpContainer.classList.add('pict-mde-rendered-mode');

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpContainer.querySelectorAll('.pict-mde-rendered-view img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation for stale-render protection
		pView._renderedViewGeneration++;
		let tmpGeneration = pView._renderedViewGeneration;

		// Post-render hooks for mermaid diagrams and KaTeX equations
		let tmpContentContainer = tmpContainer.querySelector(`#${tmpRenderedViewID} .pict-content`);
		if (tmpContentContainer)
		{
			let tmpContentID = 'PictMDE-RenderedViewContent';
			tmpContentContainer.id = tmpContentID;

			pView._postRenderMermaid(tmpContentID, -1, tmpGeneration);
			pView._postRenderKaTeX(tmpContentID);
		}
	};

	/**
	 * Switch back from rendered view to the editing view: rebuild the
	 * full editor UI from the data.
	 */
	pView._restoreEditingView = function _restoreEditingView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		tmpContainer.classList.remove('pict-mde-rendered-mode');
		pView._buildEditorUI();
	};
};

},{"pict-provider-theme/source/Theme-Diagram-Adapter.js":550,"pict-section-content":561}],679:[function(require,module,exports){
module.exports = (
{
	"DefaultRenderable": "MarkdownEditor-Wrap",
	"DefaultDestinationAddress": "#MarkdownEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "MarkdownEditor-Container",
			"Template": /*html*/`<div class="pict-mde" id="PictMDE-Container"></div>`
		},
		{
			"Hash": "MarkdownEditor-Segment",
			"Template": /*html*/`<div class="pict-mde-segment" id="PictMDE-Segment-{~D:Record.SegmentIndex~}" data-segment-index="{~D:Record.SegmentIndex~}">
	<div class="pict-mde-left-controls">
		<div class="pict-mde-quadrant-tl"></div>
		<div class="pict-mde-quadrant-bl"></div>
	</div>
	<div class="pict-mde-drag-handle" draggable="true" title="Drag to reorder"></div>
	<div class="pict-mde-segment-body">
		<div class="pict-mde-tab-bar" id="PictMDE-TabBar-{~D:Record.SegmentIndex~}">
			<button type="button" class="pict-mde-tab pict-mde-tab-active" data-tab="editor" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'editor')">Edit</button>
			<button type="button" class="pict-mde-tab" data-tab="preview" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'preview')">Preview</button>
		</div>
		<div class="pict-mde-segment-editor" id="PictMDE-SegmentEditor-{~D:Record.SegmentIndex~}"></div>
		<div class="pict-mde-preview-pane" id="PictMDE-PreviewPane-{~D:Record.SegmentIndex~}">
			<div class="pict-mde-image-preview" id="PictMDE-ImagePreview-{~D:Record.SegmentIndex~}"></div>
			<div class="pict-mde-rich-preview" id="PictMDE-RichPreview-{~D:Record.SegmentIndex~}"></div>
		</div>
	</div>
	<div class="pict-mde-sidebar" id="PictMDE-Sidebar-{~D:Record.SegmentIndex~}">
		<div class="pict-mde-quadrant-tr"></div>
		<div class="pict-mde-quadrant-br"></div>
		<input type="file" accept="image/*" class="pict-mde-image-input" id="PictMDE-ImageInput-{~D:Record.SegmentIndex~}" style="display:none" />
	</div>
</div>`
		},
		{
			"Hash": "MarkdownEditor-AddSegment",
			"Template": /*html*/`<div class="pict-mde-add-segment">
	<button type="button" class="pict-mde-btn-add" onclick="{~D:Record.ViewIdentifier~}.addSegment()">+ Add Segment</button>
</div>`
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "MarkdownEditor-Wrap",
			"TemplateHash": "MarkdownEditor-Container",
			"DestinationAddress": "#MarkdownEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#MarkdownEditor-Container-Div",

	// Address in AppData to read/write the segments array
	// The data at this address should be an array of objects, each with a "Content" property
	// e.g. AppData.Document.Segments = [ { Content: "# Hello" }, { Content: "Some text" } ]
	"ContentDataAddress": false,

	// Whether the editor should be read-only
	"ReadOnly": false,

	// Whether to show rich content previews (rendered markdown with syntax-highlighted
	// code, mermaid diagrams, KaTeX equations, tables, etc. via pict-section-content).
	// Requires the consumer to load the mermaid and/or katex libraries via CDN
	// for diagram/equation rendering; code highlighting works without CDN scripts.
	"EnableRichPreview": true,

	// Default preview layout mode: "off", "bottom", "side", "tabbed"
	//   off       — no preview (default)
	//   bottom    — preview below the editor
	//   side      — editor and preview side-by-side
	//   tabbed    — per-segment tabs switching between editor and preview
	"DefaultPreviewMode": "off",

	// Base URL prepended to relative image URLs in image and rich previews.
	// Set this to the directory-level path (e.g. "/content/") so that images
	// referenced by filename in the markdown resolve correctly.
	// Absolute URLs (starting with /, http://, https://, data:) are left as-is.
	"ImageBaseURL": "",

	// ---- Quadrant button definitions ----
	// Each quadrant is an array of button objects:
	//   HTML   — innerHTML for the button
	//   Action — method name, optionally "method:arg" (receives segment index as first param)
	//   Class  — additional CSS class(es) appended to the base class
	//   Title  — tooltip text
	//
	// Consumers can override any quadrant to add, remove, or reorder buttons.
	// Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	// Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.

	// Quadrant button HTML is parsed through Pict's template engine before
	// being assigned as innerHTML, so `{~I:Name~}` template tags resolve
	// to themable SVG icons from pict.providers.Icon.  Typographic
	// formatting buttons (Bold / Italic / Inline-code / Heading / Link)
	// stay as stylized letters — that's the markdown-editor convention.
	"ButtonsTL":
	[
		{ "HTML": "{~I:Close~}",    "Action": "removeSegment",    "Class": "pict-mde-btn-remove",    "Title": "Remove Segment" }
	],

	"ButtonsBL":
	[
		{ "HTML": "{~I:ArrowUp~}",   "Action": "moveSegmentUp",     "Class": "pict-mde-btn-move",     "Title": "Move Up" },
		{ "HTML": "{~I:ArrowDown~}", "Action": "moveSegmentDown",   "Class": "pict-mde-btn-move",     "Title": "Move Down" },
		{ "HTML": "{~I:Settings~}",  "Action": "toggleControls",    "Class": "pict-mde-btn-linenums", "Title": "Toggle Controls" },
		{ "HTML": "{~I:Eye~}",       "Action": "cyclePreviewMode",  "Class": "pict-mde-btn-preview",  "Title": "Cycle Preview Mode" }
	],

	"ButtonsTR":
	[
		{ "HTML": "<b>B</b>",            "Action": "applyFormatting:bold",     "Class": "", "Title": "Bold (Ctrl+B)" },
		{ "HTML": "<i>I</i>",            "Action": "applyFormatting:italic",   "Class": "", "Title": "Italic (Ctrl+I)" },
		{ "HTML": "<code>&lt;&gt;</code>","Action": "applyFormatting:code",    "Class": "", "Title": "Inline Code (Ctrl+E)" },
		{ "HTML": "#",                   "Action": "applyFormatting:heading",  "Class": "", "Title": "Heading" },
		{ "HTML": "[&thinsp;]",          "Action": "applyFormatting:link",     "Class": "", "Title": "Link" },
		{ "HTML": "{~I:Image~}",         "Action": "openImagePicker",          "Class": "pict-mde-sidebar-btn-image", "Title": "Insert Image" }
	],

	"ButtonsBR":
	[
	],

	// CSS for the markdown editor
	"CSS": /*css*/`
/* ---- Container ---- */
.pict-mde
{
	font-family: var(--theme-typography-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif);
	font-size: 14px;
}

/* ---- Segment row: left-controls | drag-handle | editor body | sidebar ---- */
.pict-mde-segment
{
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	margin-bottom: 6px;
	min-height: 48px;
	transition: background-color 0.15s ease;
}

/* ---- Left controls column ---- */
.pict-mde-left-controls
{
	flex: 0 0 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 2px 0;
}

/* ---- Left-side quadrants ---- */
.pict-mde-quadrant-tl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	position: sticky;
	top: 2px;
	z-index: 2;
}
.pict-mde-quadrant-bl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	position: sticky;
	bottom: 2px;
	z-index: 2;
}

/* ---- Left-side buttons (shared base) ---- */
.pict-mde-left-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	color: var(--theme-color-text-muted, #888);
	line-height: 1;
	font-family: inherit;
	opacity: 0;
	transition: opacity 0.15s ease;
}
.pict-mde-segment:hover .pict-mde-left-btn,
.pict-mde-segment.pict-mde-active .pict-mde-left-btn
{
	opacity: 1;
}
.pict-mde-left-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-btn-remove:hover
{
	color: var(--theme-color-status-error, #CC3333);
}
.pict-mde-btn-linenums
{
	font-size: 11px;
	font-weight: 600;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}
/* Highlight when controls are active */
.pict-mde.pict-mde-controls-on .pict-mde-btn-linenums
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-btn-preview
{
	font-size: 11px;
}
/* Preview button: highlight when any preview mode is active */
.pict-mde.pict-mde-preview-bottom .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-side .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-tabbed .pict-mde-btn-preview
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
/* Dim preview button when mode is off */
.pict-mde.pict-mde-preview-off .pict-mde-btn-preview
{
	color: var(--theme-color-border-default, #CCC);
}

/* ---- Drag handle (simple grey bar) ---- */
.pict-mde-drag-handle
{
	flex: 0 0 8px;
	cursor: grab;
	background: var(--theme-color-background-tertiary, #EDEDED);
	transition: background-color 0.15s ease;
	user-select: none;
}
.pict-mde-drag-handle:active
{
	cursor: grabbing;
}
.pict-mde-drag-handle:hover
{
	background: var(--theme-color-border-default, #C8C8C8);
}

/* ---- Editor body (middle column) ---- */
.pict-mde-segment-body
{
	flex: 1 1 0%;
	min-width: 0;
	overflow: hidden;
	background: var(--theme-color-background-panel, #FFFFFF);
	transition: background-color 0.15s ease;
}
.pict-mde-segment-editor
{
	min-height: 48px;
}

/* ---- Image preview area below the editor ---- */
.pict-mde-image-preview
{
	display: none;
}
.pict-mde-image-preview.pict-mde-has-images
{
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 12px;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
}
.pict-mde-image-preview img
{
	max-width: 200px;
	max-height: 150px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	object-fit: contain;
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-image-preview-item
{
	position: relative;
	display: inline-block;
}
.pict-mde-image-preview-label
{
	display: block;
	font-size: 10px;
	color: var(--theme-color-text-muted, #999);
	margin-top: 2px;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ---- Rich content preview area (rendered via pict-section-content) ---- */
.pict-mde-rich-preview
{
	display: none;
}
.pict-mde-rich-preview.pict-mde-has-rich-preview
{
	display: block;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-panel, #FCFCFC);
	overflow: hidden;
}
/* Constrain images in the rich preview even if pict-section-content CSS loads late */
.pict-mde-rich-preview img
{
	max-width: 100%;
	height: auto;
}
/* ---- Preview layout modes ---- */

/* Tab bar: hidden by default, shown only in tabbed mode */
.pict-mde-tab-bar
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-tab-bar
{
	display: flex;
	gap: 0;
	border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-tab
{
	padding: 4px 12px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #888);
	border-bottom: 2px solid transparent;
	font-family: inherit;
}
.pict-mde-tab:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-tab.pict-mde-tab-active
{
	color: var(--theme-color-brand-primary, #4A90D9);
	border-bottom-color: var(--theme-color-brand-primary, #4A90D9);
}

/* Off mode: hide all preview panes and tab bars */
.pict-mde.pict-mde-preview-off .pict-mde-preview-pane
{
	display: none;
}
.pict-mde.pict-mde-preview-off .pict-mde-tab-bar
{
	display: none;
}
/* Legacy class alias for backward compatibility */
.pict-mde.pict-mde-previews-hidden .pict-mde-preview-pane
{
	display: none;
}

/* Bottom mode: vertical stacking (default flex-column behavior) */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}

/* Side-by-side mode: editor and preview side by side */
.pict-mde.pict-mde-preview-side .pict-mde-segment-body
{
	display: flex;
	flex-direction: row;
}
.pict-mde.pict-mde-preview-side .pict-mde-segment-editor
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: hidden;
}
.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: auto;
	border-left: 1px solid var(--theme-color-border-light, #EDEDED);
}
/* Side-by-side: remove top borders since preview is beside, not below */
.pict-mde.pict-mde-preview-side .pict-mde-rich-preview.pict-mde-has-rich-preview
{
	border-top: none;
}
.pict-mde.pict-mde-preview-side .pict-mde-image-preview.pict-mde-has-images
{
	border-top: none;
}

/* Tabbed mode: default hides preview, shows editor */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-preview-pane
{
	display: none;
}
/* Tabbed mode: when showing preview, hide editor and show preview */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-segment-editor
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-preview-pane
{
	display: block;
}

/* Per-segment preview hide: only applies in bottom and side modes */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane,
.pict-mde.pict-mde-preview-side .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane
{
	display: none;
}
/* Constrain the pict-content inside the preview to fit the segment */
.pict-mde-rich-preview .pict-content
{
	padding: 12px;
	max-width: none;
	margin: 0;
	font-size: 13px;
}
/* Reduce heading sizes in the preview to be proportional */
.pict-mde-rich-preview .pict-content h1
{
	font-size: 1.4em;
	margin-top: 0;
}
.pict-mde-rich-preview .pict-content h2
{
	font-size: 1.2em;
	margin-top: 0.75em;
}
.pict-mde-rich-preview .pict-content h3
{
	font-size: 1.1em;
	margin-top: 0.6em;
}

/* ---- Rendered view (full document preview mode) ---- */
.pict-mde-rendered-view
{
	padding: 16px 20px;
	background: var(--theme-color-background-panel, #FFFFFF);
	min-height: 120px;
}
.pict-mde-rendered-view .pict-content
{
	max-width: none;
	margin: 0;
}
/* Hide the add-segment button in rendered mode */
.pict-mde.pict-mde-rendered-mode .pict-mde-add-segment
{
	display: none;
}

/* Focused / active editor gets subtle warm background */
.pict-mde-segment.pict-mde-active .pict-mde-segment-body
{
	background: var(--theme-color-background-secondary, #FAFAF5);
}
.pict-mde-segment.pict-mde-active .pict-mde-drag-handle
{
	background: var(--theme-color-border-strong, #9CB4C8);
}

/* ---- Right sidebar column ---- */
.pict-mde-sidebar
{
	flex: 0 0 30px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
}

/* ---- Right-side quadrants ---- */
.pict-mde-quadrant-tr
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease, top 0.1s ease;
	position: sticky;
	top: 0;
}
.pict-mde-quadrant-br
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease;
	position: sticky;
	bottom: 0;
}

/* Active segment always shows its right-side quadrants */
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 1;
}
/* When no segment is active, hovering shows both left + right controls */
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 1;
}

/* ---- Controls-hidden mode: right quadrants show faintly on hover ---- */
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-br
{
	opacity: 0;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 0.3;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 0.3;
}

/* When JS sets a cursor-relative offset, switch TR from sticky to absolute positioning */
.pict-mde-quadrant-tr.pict-mde-sidebar-at-cursor
{
	position: absolute;
	top: var(--pict-mde-sidebar-top, 0px);
}

/* ---- Right-side buttons (shared base) ---- */
.pict-mde-sidebar-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 22px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	border-radius: 3px;
	color: var(--theme-color-text-secondary, #666);
	line-height: 1;
	font-family: inherit;
}
.pict-mde-sidebar-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-sidebar-btn b
{
	font-size: 13px;
	font-weight: 700;
}
.pict-mde-sidebar-btn i
{
	font-size: 13px;
	font-style: italic;
}
.pict-mde-sidebar-btn code
{
	font-size: 10px;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}

/* ---- Add segment button ---- */
.pict-mde-add-segment
{
	margin-top: 6px;
	padding-left: 30px;
}
.pict-mde-btn-add
{
	display: block;
	width: 100%;
	padding: 7px;
	border: 2px dashed var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	background: transparent;
	color: var(--theme-color-text-muted, #999);
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
}
.pict-mde-btn-add:hover
{
	border-color: var(--theme-color-brand-primary, #4A90D9);
	color: var(--theme-color-brand-primary, #4A90D9);
	background: rgba(74, 144, 217, 0.04);
}

/* ---- Image drag-over indicator ---- */
.pict-mde-segment-editor.pict-mde-image-dragover
{
	outline: 2px dashed var(--theme-color-brand-primary, #4A90D9);
	outline-offset: -2px;
}

/* ---- Drag-in-progress: prevent CodeMirror from intercepting drop events ---- */
.pict-mde.pict-mde-dragging .pict-mde-segment-editor
{
	pointer-events: none;
}

/* ---- Drop target indicators for drag reorder ---- */
.pict-mde-segment.pict-mde-drag-over-top
{
	box-shadow: 0 -2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-segment.pict-mde-drag-over-bottom
{
	box-shadow: 0 2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}

/* ---- CodeMirror overrides inside segments ---- */
.pict-mde-segment-editor .cm-editor
{
	border: none;
}
.pict-mde-segment-editor .cm-editor .cm-scroller
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.6;
}
.pict-mde-segment-editor .cm-editor.cm-focused
{
	outline: none;
}
.pict-mde-segment-editor .cm-editor .cm-content
{
	padding: 8px 12px;
	min-height: 36px;
}
.pict-mde-segment-editor .cm-editor .cm-gutters
{
	background: var(--theme-color-background-secondary, #F8F8F8);
	border-right: 1px solid var(--theme-color-border-light, #E8E8E8);
	color: var(--theme-color-text-muted, #BBB);
}

/* ---- Collapsed data URI widget ---- */
.pict-mde-data-uri-collapsed
{
	display: inline;
	background: var(--theme-color-background-tertiary, #F0F0F0);
	color: var(--theme-color-text-muted, #888);
	font-size: 11px;
	padding: 1px 4px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
	cursor: default;
	white-space: nowrap;
}

/* ---- Line number / controls toggle: gutters hidden by default ---- */
.pict-mde .cm-editor .cm-gutters
{
	display: none;
}
.pict-mde.pict-mde-controls-on .cm-editor .cm-gutters
{
	display: flex;
}

/* ============================================
   RESPONSIVE: Tablet / Phone (max-width: 768px)
   ============================================ */
@media (max-width: 768px)
{
	/* Prevent any horizontal overflow in the editor */
	.pict-mde
	{
		overflow-x: hidden;
		max-width: 100%;
	}

	/* Reduce the left controls column width */
	.pict-mde-left-controls
	{
		flex: 0 0 16px;
	}
	.pict-mde-left-btn
	{
		width: 16px;
		height: 18px;
		font-size: 10px;
	}

	/* Make left-side buttons always visible on touch (no hover) */
	.pict-mde-left-btn
	{
		opacity: 0.6;
	}

	/* Narrow the drag handle */
	.pict-mde-drag-handle
	{
		flex: 0 0 5px;
	}

	/* Shrink the right sidebar column */
	.pict-mde-sidebar
	{
		flex: 0 0 24px;
	}
	.pict-mde-sidebar-btn
	{
		width: 20px;
		height: 20px;
		font-size: 11px;
	}

	/* Make right sidebar buttons always visible (touch devices) */
	.pict-mde-quadrant-tr,
	.pict-mde-quadrant-br
	{
		opacity: 0.7;
	}
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
	{
		opacity: 1;
	}

	/* Reduce CodeMirror content padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 6px 6px;
	}

	/* Reduce font size slightly for more content on screen */
	.pict-mde-segment-editor .cm-editor .cm-scroller
	{
		font-size: 13px;
	}

	/* Add segment button: reduce left margin */
	.pict-mde-add-segment
	{
		padding-left: 21px;
	}

	/* Side-by-side: fall back to vertical stacking on narrow screens */
	.pict-mde.pict-mde-preview-side .pict-mde-segment-body
	{
		flex-direction: column;
	}
	.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
	{
		border-left: none;
		border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	}

	/* Tab bar: smaller on tablet */
	.pict-mde-tab
	{
		padding: 3px 8px;
		font-size: 11px;
	}

	/* Rich preview: less padding */
	.pict-mde-rich-preview .pict-content
	{
		padding: 8px;
		font-size: 12px;
	}

	/* Image previews: smaller max dimensions */
	.pict-mde-image-preview img
	{
		max-width: 120px;
		max-height: 100px;
	}

	/* Rendered view: less padding */
	.pict-mde-rendered-view
	{
		padding: 10px 8px;
	}
}

/* ============================================
   RESPONSIVE: Small phone (max-width: 480px)
   ============================================ */
@media (max-width: 480px)
{
	/* Wrap segment so left controls flow to the top as a horizontal bar */
	.pict-mde-segment
	{
		flex-wrap: wrap;
	}

	/* Left controls become a horizontal toolbar at the top of the segment */
	.pict-mde-left-controls
	{
		flex: 0 0 100%;
		flex-direction: row;
		justify-content: flex-start;
		gap: 2px;
		padding: 3px 4px;
		order: -1;
		background: var(--theme-color-background-secondary, #F5F5F5);
		border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	}
	.pict-mde-left-btn
	{
		width: 24px;
		height: 24px;
		font-size: 12px;
		opacity: 0.7;
	}

	/* Left quadrants flow horizontally */
	.pict-mde-quadrant-tl,
	.pict-mde-quadrant-bl
	{
		flex-direction: row;
		gap: 2px;
		position: static;
	}

	/* Segment body: explicit basis so it fills the wrapped row */
	.pict-mde-segment-body
	{
		flex: 1 1 calc(100% - 20px);
	}

	/* Hide drag handle on very small screens */
	.pict-mde-drag-handle
	{
		display: none;
	}

	/* Right sidebar: further shrink */
	.pict-mde-sidebar
	{
		flex: 0 0 20px;
	}
	.pict-mde-sidebar-btn
	{
		width: 18px;
		height: 18px;
		font-size: 10px;
	}

	/* Add segment: no left offset since controls are at top */
	.pict-mde-add-segment
	{
		padding-left: 0;
	}

	/* Even tighter CodeMirror padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 4px 4px;
	}
}
`
});

},{}],680:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libPictSectionContent = require('pict-section-content');
const _DefaultConfiguration = require('./Pict-Section-MarkdownEditor-DefaultConfiguration.js');

// Helper modules
const libFormatting = require('./Pict-MDE-Formatting.js');
const libImageHandling = require('./Pict-MDE-ImageHandling.js');
const libDragAndReorder = require('./Pict-MDE-DragAndReorder.js');
const libRichPreview = require('./Pict-MDE-RichPreview.js');
const libCodeMirror = require('./Pict-MDE-CodeMirror.js');

class PictSectionMarkdownEditor extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// CodeMirror prototype references (injected by consumer or found on window)
		this._codeMirrorModules = null;

		// Map of segment index to CodeMirror EditorView instance
		this._segmentEditors = {};

		// Internal segment counter (monotonically increasing for unique IDs)
		this._segmentCounter = 0;

		// The view identifier used for onclick handlers in templates
		this._viewCallIdentifier = false;

		// Currently active (focused) segment index, or -1
		this._activeSegmentIndex = -1;

		// Drag state for reorder
		this._dragSourceIndex = -1;

		// Whether controls (line numbers + right sidebar) are currently visible
		this._controlsVisible = true;

		// Current preview layout mode: "off", "bottom", "side", "tabbed"
		this._previewMode = this.options.DefaultPreviewMode || 'off';

		// Last non-off preview layout, for togglePreview() backward compatibility
		this._lastPreviewLayout = 'bottom';

		// Per-segment tab state in tabbed mode (keyed by logical index; "editor" or "preview")
		this._segmentTabStates = {};

		// Set of logical segment indices where preview has been individually hidden
		this._hiddenPreviewSegments = {};

		// Debounce timers for image preview updates (keyed by segment index)
		this._imagePreviewTimers = {};

		// Debounce timers for rich content preview updates (keyed by segment index)
		this._richPreviewTimers = {};

		// Generation counters for mermaid async rendering (keyed by segment index)
		this._richPreviewGenerations = {};

		// Content provider for markdown-to-HTML rendering in rich previews
		// (pict-section-content provides parseMarkdown, code highlighting, etc.)
		this._contentProvider = null;

		// Whether the rendered (read-mode) view is currently active
		this._renderedViewActive = false;

		// Generation counter for rendered view mermaid async rendering
		this._renderedViewGeneration = 0;

		// Attach helper modules
		libFormatting.attach(this);
		libImageHandling.attach(this);
		libDragAndReorder.attach(this);
		libRichPreview.attach(this);
		libCodeMirror.attach(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElement = false;

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeMirror modules.  The consumer must pass an object with:
	 *   - EditorView: the EditorView class
	 *   - EditorState: the EditorState class
	 *   - extensions: an array of extensions to use (e.g. basicSetup, markdown(), etc.)
	 *
	 * If not called explicitly, the view will attempt to find them on window.CodeMirrorModules.
	 *
	 * @param {object} [pCodeMirrorModules] - The CodeMirror modules object
	 * @returns {boolean|void}
	 */
	connectCodeMirrorModules(pCodeMirrorModules)
	{
		if (pCodeMirrorModules && typeof (pCodeMirrorModules) === 'object')
		{
			if (typeof (pCodeMirrorModules.EditorView) === 'function' && typeof (pCodeMirrorModules.EditorState) === 'function')
			{
				this._codeMirrorModules = pCodeMirrorModules;
				return;
			}
		}

		// Try to find CodeMirror modules in global scope
		if (typeof (window) !== 'undefined')
		{
			if (window.CodeMirrorModules && typeof (window.CodeMirrorModules.EditorView) === 'function')
			{
				this.log.trace(`PICT-MarkdownEditor Found CodeMirror modules on window.CodeMirrorModules.`);
				this._codeMirrorModules = window.CodeMirrorModules;
				return;
			}
		}

		this.log.error(`PICT-MarkdownEditor No CodeMirror modules found. Provide them via connectCodeMirrorModules() or set window.CodeMirrorModules.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		else
		{
			// A re-render means the host re-created our destination element (an
			// editor shown/hidden, or remounted into a fresh container). The
			// targetElement cached on the first render is now detached, so a
			// rebuild would write segments into an orphaned node. Re-resolve the
			// live target and rebuild into it from the current segment data.
			this._remountEditorUI();
		}

		// Inject CSS from all registered views (after onAfterInitialRender so
		// that pict-section-content's CSS is registered before injection)
		this.pict.CSSMap.injectCSS();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Re-resolve the target element from TargetElementAddress and rebuild the
	 * editor UI into it. Called on re-render so the editor survives the host
	 * replacing its destination element (which would otherwise leave
	 * this.targetElement pointing at a detached node and the live container empty).
	 */
	_remountEditorUI()
	{
		if (!this._codeMirrorModules)
		{
			return;
		}

		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			return;
		}

		this.targetElement = tmpTargetElementSet[0];
		this._buildEditorUI();
	}

	onAfterInitialRender()
	{
		// Resolve CodeMirror modules if not already set
		if (!this._codeMirrorModules)
		{
			this.connectCodeMirrorModules();
		}

		if (!this._codeMirrorModules)
		{
			this.log.error(`PICT-MarkdownEditor Cannot initialize; no CodeMirror modules available.`);
			return false;
		}

		// Register pict-section-content's CSS for rich preview rendering.
		// This ensures the rendered markdown (headings, code blocks, tables, etc.)
		// is styled correctly inside the preview area.
		if (this.options.EnableRichPreview)
		{
			let tmpContentViewConfig = libPictSectionContent.default_configuration;
			if (tmpContentViewConfig && tmpContentViewConfig.CSS)
			{
				this.pict.CSSMap.addCSS('Pict-Content-View', tmpContentViewConfig.CSS);
			}
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-MarkdownEditor Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Determine the view call identifier for onclick handlers
		this._viewCallIdentifier = this._resolveViewCallIdentifier();

		// Build the editor UI
		this._buildEditorUI();
	}

	/**
	 * Resolve how the view can be referenced from global onclick handlers.
	 * Returns a string like "_Pict.views['MyViewHash']" — bracket syntax
	 * is required so view hashes containing hyphens (e.g.
	 * "ContentEditor-MarkdownEditor") parse correctly. Dot access
	 * (`_Pict.views.X-Y`) is read as subtraction by the JS parser and
	 * the onclick silently no-ops.
	 *
	 * @returns {string}
	 */
	_resolveViewCallIdentifier()
	{
		let tmpViews = this.pict.views;
		for (let tmpViewHash in tmpViews)
		{
			if (tmpViews[tmpViewHash] === this)
			{
				return `_Pict.views['${tmpViewHash}']`;
			}
		}
		return `_Pict.servicesMap.PictView['${this.Hash}']`;
	}

	/**
	 * Get the .pict-mde container element.  Always does a fresh DOM lookup
	 * because pict's async render pipeline can replace the element between calls.
	 *
	 * @returns {HTMLElement|null}
	 */
	_getContainerElement()
	{
		if (this.targetElement)
		{
			let tmpContainer = this.targetElement.querySelector('.pict-mde');
			if (tmpContainer)
			{
				return tmpContainer;
			}
		}
		return this.targetElement || null;
	}

	/**
	 * Resolve one of THIS editor instance's elements by its raw PictMDE id, scoped to this
	 * instance's container.
	 *
	 * The segment/preview/editor elements all carry fixed ids (PictMDE-Segment-0, ...). Several
	 * markdown editors can share one page -- the Drafting Kit loops editor mounts three at once, one
	 * per loop -- and they all emit that same id space, so a document-wide getElementById would
	 * resolve the FIRST instance's element and the editors would bleed into each other. Scoping every
	 * lookup to the instance's own .pict-mde container keeps the instances independent without
	 * needing to make the ids globally unique.
	 *
	 * Falls back to a document-wide lookup only when no container is resolved yet (e.g. pre-mount),
	 * which preserves the original single-instance behavior for the entity-form and Docs Lake editors.
	 *
	 * @param {string} pElementID - the element id, e.g. `PictMDE-Segment-3`
	 * @returns {HTMLElement|null}
	 */
	_resolveInstanceElement(pElementID)
	{
		let tmpContainer = this._getContainerElement();
		if (tmpContainer && typeof tmpContainer.querySelector === 'function')
		{
			return tmpContainer.querySelector('#' + pElementID);
		}
		return document.getElementById(pElementID);
	}

	/**
	 * Resolve a URL relative to the configured ImageBaseURL.
	 *
	 * Absolute URLs (starting with /, http://, https://, data:) are returned
	 * unchanged.  Relative URLs are prepended with this.options.ImageBaseURL.
	 *
	 * @param {string} pURL - The URL to resolve
	 * @returns {string} The resolved URL
	 */
	_resolveImageURL(pURL)
	{
		if (!pURL || !this.options.ImageBaseURL)
		{
			return pURL;
		}

		// Leave absolute URLs alone
		if (pURL.startsWith('/') || pURL.startsWith('http://') || pURL.startsWith('https://') || pURL.startsWith('data:'))
		{
			return pURL;
		}

		let tmpBase = this.options.ImageBaseURL;
		// Ensure base ends with /
		if (tmpBase && !tmpBase.endsWith('/'))
		{
			tmpBase += '/';
		}

		return tmpBase + pURL;
	}

	/**
	 * Build the full editor UI: render existing segments from data and the add-segment button.
	 */
	_buildEditorUI()
	{
		let tmpContainer = this._getContainerElement();

		// Ensure the container has the pict-mde class (the template's wrapper
		// may have been replaced by pict's async render pipeline)
		if (tmpContainer && !tmpContainer.classList.contains('pict-mde'))
		{
			tmpContainer.classList.add('pict-mde');
		}

		// Destroy existing editors before clearing
		for (let tmpIdx in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIdx])
			{
				this._segmentEditors[tmpIdx].destroy();
			}
		}

		tmpContainer.innerHTML = '';

		// Restore toggle states on the container after clearing
		tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
		tmpContainer.classList.add('pict-mde-preview-' + this._previewMode);
		if (this._controlsVisible)
		{
			tmpContainer.classList.add('pict-mde-controls-on');
		}
		else
		{
			tmpContainer.classList.add('pict-mde-controls-hidden');
		}

		// Load existing segments from data address, or start with one empty segment
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length === 0)
		{
			tmpSegments = [{ Content: '' }];
			this._setSegmentsToData(tmpSegments);
		}

		this._segmentCounter = 0;
		this._segmentEditors = {};

		for (let i = 0; i < tmpSegments.length; i++)
		{
			this._renderSegment(tmpContainer, i, tmpSegments[i].Content || '');
		}

		this._renderAddButton(tmpContainer);
	}

	/**
	 * Render a single segment into the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 * @param {number} pIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	_renderSegment(pContainer, pIndex, pContent)
	{
		let tmpSegmentIndex = this._segmentCounter++;

		let tmpRecord =
		{
			SegmentIndex: tmpSegmentIndex,
			SegmentDisplayIndex: pIndex + 1,
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-Segment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpSegmentElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpSegmentElement);

		// Build quadrant buttons from configuration arrays
		this._buildQuadrantButtons(tmpSegmentElement, tmpSegmentIndex);

		// Restore per-segment preview hidden state (tracked by logical index)
		if (this._hiddenPreviewSegments[pIndex])
		{
			tmpSegmentElement.classList.add('pict-mde-preview-hidden');
		}

		// Restore per-segment tab state in tabbed mode
		if (this._previewMode === 'tabbed' && this._segmentTabStates[pIndex] === 'preview')
		{
			tmpSegmentElement.classList.add('pict-mde-tab-showing-preview');
			let tmpTabBar = tmpSegmentElement.querySelector('.pict-mde-tab-bar');
			if (tmpTabBar)
			{
				let tmpEditorTab = tmpTabBar.querySelector('[data-tab="editor"]');
				let tmpPreviewTab = tmpTabBar.querySelector('[data-tab="preview"]');
				if (tmpEditorTab) { tmpEditorTab.classList.remove('pict-mde-tab-active'); }
				if (tmpPreviewTab) { tmpPreviewTab.classList.add('pict-mde-tab-active'); }
			}
		}

		// Wire up drag-and-drop on the drag handle
		this._wireSegmentDragEvents(tmpSegmentElement, tmpSegmentIndex);

		// Create the CodeMirror editor in the segment editor container
		let tmpEditorContainer = this._resolveInstanceElement(`PictMDE-SegmentEditor-${tmpSegmentIndex}`);
		if (tmpEditorContainer)
		{
			this._createEditorInContainer(tmpEditorContainer, tmpSegmentIndex, pContent);

			// Wire image drag-and-drop on the editor container
			this._wireImageDragEvents(tmpEditorContainer, tmpSegmentIndex);

			// Render image previews for existing content
			if (pContent)
			{
				this._updateImagePreviews(tmpSegmentIndex);
				this._updateRichPreviews(tmpSegmentIndex);
			}
		}
	}

	/**
	 * Build buttons in all four quadrants (TL, BL, TR, BR) from the
	 * configuration arrays.  Each button config has:
	 *   HTML   — innerHTML
	 *   Action — "methodName" or "methodName:arg"
	 *   Class  — additional CSS class(es)
	 *   Title  — tooltip text
	 *
	 * Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	 * Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	_buildQuadrantButtons(pSegmentElement, pSegmentIndex)
	{
		let tmpQuadrants =
		[
			{ key: 'ButtonsTL', selector: '.pict-mde-quadrant-tl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsBL', selector: '.pict-mde-quadrant-bl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsTR', selector: '.pict-mde-quadrant-tr', baseClass: 'pict-mde-sidebar-btn' },
			{ key: 'ButtonsBR', selector: '.pict-mde-quadrant-br', baseClass: 'pict-mde-sidebar-btn' }
		];

		let tmpSelf = this;

		for (let q = 0; q < tmpQuadrants.length; q++)
		{
			let tmpQuadrant = tmpQuadrants[q];
			let tmpContainer = pSegmentElement.querySelector(tmpQuadrant.selector);
			if (!tmpContainer)
			{
				continue;
			}

			let tmpButtons = this.options[tmpQuadrant.key];
			if (!Array.isArray(tmpButtons))
			{
				continue;
			}

			for (let b = 0; b < tmpButtons.length; b++)
			{
				let tmpBtnConfig = tmpButtons[b];

				let tmpButton = document.createElement('button');
				tmpButton.type = 'button';
				tmpButton.className = tmpQuadrant.baseClass;
				if (tmpBtnConfig.Class)
				{
					tmpButton.className += ' ' + tmpBtnConfig.Class;
				}
				// Run the button HTML through Pict's template engine so
				// `{~I:Name~}` tags expand into themable SVG icons from
				// pict.providers.Icon.  Plain HTML strings (e.g. the
				// stylized `<b>B</b>` formatting buttons) pass through
				// unchanged — the parser is a no-op when no template tags
				// are present.
				let tmpHTML = tmpBtnConfig.HTML || '';
				if (tmpHTML && typeof (this.pict.parseTemplate) === 'function')
				{
					tmpHTML = this.pict.parseTemplate(tmpHTML, {});
				}
				tmpButton.innerHTML = tmpHTML;
				tmpButton.title = tmpBtnConfig.Title || '';

				// Parse the action string: "methodName" or "methodName:arg"
				let tmpAction = tmpBtnConfig.Action || '';
				let tmpMethod = tmpAction;
				let tmpArg = null;
				let tmpColonIndex = tmpAction.indexOf(':');
				if (tmpColonIndex >= 0)
				{
					tmpMethod = tmpAction.substring(0, tmpColonIndex);
					tmpArg = tmpAction.substring(tmpColonIndex + 1);
				}

				// Build the click handler
				(function (pMethod, pArg, pSegIdx)
				{
					tmpButton.addEventListener('click', () =>
					{
						if (typeof (tmpSelf[pMethod]) === 'function')
						{
							if (pArg !== null)
							{
								tmpSelf[pMethod](pSegIdx, pArg);
							}
							else
							{
								tmpSelf[pMethod](pSegIdx);
							}
						}
						else
						{
							tmpSelf.log.warn(`PICT-MarkdownEditor _buildQuadrantButtons: method "${pMethod}" not found.`);
						}
					});
				})(tmpMethod, tmpArg, pSegmentIndex);

				tmpContainer.appendChild(tmpButton);
			}
		}
	}


	/**
	 * Hook for subclasses to customize the CodeMirror extensions before editor creation.
	 *
	 * @param {Array} pExtensions - The extensions array to modify
	 * @param {number} pSegmentIndex - The segment index
	 * @returns {Array} The modified extensions array
	 */
	customConfigureExtensions(pExtensions, pSegmentIndex)
	{
		return pExtensions;
	}

	/**
	 * Render the "Add Segment" button at the bottom of the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 */
	_renderAddButton(pContainer)
	{
		let tmpRecord =
		{
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-AddSegment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpButtonElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpButtonElement);
	}

	/**
	 * Hook for consumers to handle image uploads.
	 *
	 * Override this in a subclass or consumer to upload images to a server/CDN.
	 * Return true to indicate you are handling the upload asynchronously.
	 * Call fCallback(null, url) on success, or fCallback(error) on failure.
	 * Return false/undefined to fall back to base64 data URI inline.
	 *
	 * @param {File} pFile - The image File object
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {function} fCallback - Callback: fCallback(pError, pURL)
	 * @returns {boolean} true if handling the upload, false to use base64 default
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		// Override in subclass or consumer
		return false;
	}

	// -- Controls Toggle (line numbers + right sidebar) --

	/**
	 * Toggle controls (line number gutters and right sidebar formatting
	 * buttons) on or off for all segments.
	 *
	 * When controls are hidden the right-side quadrants (TR, BR) appear
	 * faintly on hover but are otherwise invisible, and CodeMirror line
	 * number gutters are hidden.
	 *
	 * This method is called by the quadrant button system with the segment
	 * index as the first argument — it ignores that argument and uses only
	 * the optional boolean.
	 *
	 * @param {number|boolean} [pSegmentIndexOrVisible] - Segment index (ignored) or boolean
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleControls(pSegmentIndexOrVisible, pVisible)
	{
		// When called from a quadrant button, first arg is segment index (number).
		// When called programmatically, first arg may be a boolean.
		let tmpVisible = pVisible;
		if (typeof (pSegmentIndexOrVisible) === 'boolean')
		{
			tmpVisible = pSegmentIndexOrVisible;
		}

		if (typeof (tmpVisible) === 'boolean')
		{
			this._controlsVisible = tmpVisible;
		}
		else
		{
			this._controlsVisible = !this._controlsVisible;
		}

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			if (this._controlsVisible)
			{
				tmpContainer.classList.add('pict-mde-controls-on');
				tmpContainer.classList.remove('pict-mde-controls-hidden');
			}
			else
			{
				tmpContainer.classList.remove('pict-mde-controls-on');
				tmpContainer.classList.add('pict-mde-controls-hidden');
			}
		}
	}

	/**
	 * Toggle line numbers on or off for all segments.
	 * Backward-compatible alias for toggleControls().
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleLineNumbers(pVisible)
	{
		this.toggleControls(pVisible);
	}

	// -- Preview Toggle --

	/**
	 * Toggle rich previews on or off for all segments globally.
	 *
	 * When hidden globally, individual segment overrides are preserved
	 * so that restoring global visibility returns to the per-segment state.
	 *
	 * Backward compatible: toggles between "off" and the last-used preview layout.
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	togglePreview(pVisible)
	{
		if (typeof (pVisible) === 'boolean')
		{
			if (pVisible)
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
		else
		{
			if (this._previewMode === 'off')
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
	}

	/**
	 * Set the preview layout mode.
	 *
	 * @param {string} pMode - One of "off", "bottom", "side", "tabbed"
	 */
	setPreviewMode(pMode)
	{
		let tmpValidModes = ['off', 'bottom', 'side', 'tabbed'];
		if (tmpValidModes.indexOf(pMode) < 0)
		{
			this.log.warn(`PICT-MarkdownEditor setPreviewMode: unknown mode "${pMode}".`);
			return;
		}

		// Remember the last non-off mode for toggle restore
		if (pMode !== 'off')
		{
			this._lastPreviewLayout = pMode;
		}

		this._previewMode = pMode;

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
			tmpContainer.classList.add('pict-mde-preview-' + pMode);
		}

		// When switching to a visible preview mode, trigger preview renders
		// for all segments to ensure they are up to date
		if (pMode !== 'off')
		{
			let tmpOrderedIndices = this._getOrderedSegmentIndices();
			for (let i = 0; i < tmpOrderedIndices.length; i++)
			{
				this._updateRichPreviews(tmpOrderedIndices[i]);
				this._updateImagePreviews(tmpOrderedIndices[i]);
			}
		}
	}

	/**
	 * Cycle through preview layout modes: off → bottom → side → tabbed → off.
	 *
	 * Accepts a segment index as first argument (ignored) for compatibility
	 * with the quadrant button system.
	 *
	 * @param {number} [pSegmentIndex] - Ignored; present for quadrant button compat
	 */
	cyclePreviewMode(pSegmentIndex)
	{
		let tmpModeOrder = ['off', 'bottom', 'side', 'tabbed'];
		let tmpCurrentIndex = tmpModeOrder.indexOf(this._previewMode);
		let tmpNextIndex = (tmpCurrentIndex + 1) % tmpModeOrder.length;
		this.setPreviewMode(tmpModeOrder[tmpNextIndex]);
	}

	/**
	 * Switch a segment between editor and preview tabs (tabbed mode).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pTab - "editor" or "preview"
	 */
	switchSegmentTab(pSegmentIndex, pTab)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		this._segmentTabStates[tmpLogicalIndex] = pTab;

		let tmpSegmentEl = this._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		// Toggle the preview-showing class on the segment
		if (pTab === 'preview')
		{
			tmpSegmentEl.classList.add('pict-mde-tab-showing-preview');
			// Trigger preview render when switching to preview tab
			this._updateRichPreviews(pSegmentIndex);
			this._updateImagePreviews(pSegmentIndex);
		}
		else
		{
			tmpSegmentEl.classList.remove('pict-mde-tab-showing-preview');
		}

		// Update tab bar active state
		let tmpTabBar = this._resolveInstanceElement(`PictMDE-TabBar-${pSegmentIndex}`);
		if (tmpTabBar)
		{
			let tmpTabs = tmpTabBar.querySelectorAll('.pict-mde-tab');
			for (let i = 0; i < tmpTabs.length; i++)
			{
				if (tmpTabs[i].getAttribute('data-tab') === pTab)
				{
					tmpTabs[i].classList.add('pict-mde-tab-active');
				}
				else
				{
					tmpTabs[i].classList.remove('pict-mde-tab-active');
				}
			}
		}
	}

	/**
	 * Toggle the rich preview for a single segment.
	 *
	 * This adds/removes the .pict-mde-preview-hidden class on the
	 * individual segment element, independent of the global toggle.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleSegmentPreview(pSegmentIndex, pVisible)
	{
		// Convert internal index to logical index for persistent tracking
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpCurrentlyHidden = !!this._hiddenPreviewSegments[tmpLogicalIndex];

		if (typeof (pVisible) === 'boolean')
		{
			tmpCurrentlyHidden = !pVisible;
		}
		else
		{
			tmpCurrentlyHidden = !tmpCurrentlyHidden;
		}

		if (tmpCurrentlyHidden)
		{
			this._hiddenPreviewSegments[tmpLogicalIndex] = true;
		}
		else
		{
			delete this._hiddenPreviewSegments[tmpLogicalIndex];
		}

		let tmpSegmentEl = this._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegmentEl)
		{
			if (tmpCurrentlyHidden)
			{
				tmpSegmentEl.classList.add('pict-mde-preview-hidden');
			}
			else
			{
				tmpSegmentEl.classList.remove('pict-mde-preview-hidden');
				// Render preview content when making it visible
				this._updateRichPreviews(pSegmentIndex);
				this._updateImagePreviews(pSegmentIndex);
			}
		}
	}

	// -- Segment Data Management --

	/**
	 * Get the segments array from the configured data address.
	 *
	 * @returns {Array|null}
	 */
	_getSegmentsFromData()
	{
		if (!this.options.ContentDataAddress)
		{
			return null;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		let tmpData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.ContentDataAddress);

		if (Array.isArray(tmpData))
		{
			return tmpData;
		}

		return null;
	}

	/**
	 * Write the segments array to the configured data address.
	 *
	 * @param {Array} pSegments - The segments array
	 */
	_setSegmentsToData(pSegments)
	{
		if (!this.options.ContentDataAddress)
		{
			return;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.ContentDataAddress, pSegments);
	}

	/**
	 * Called when a segment's content changes in the CodeMirror editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pContent - The new content
	 */
	_onSegmentContentChange(pSegmentIndex, pContent)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		if (tmpLogicalIndex < tmpSegments.length)
		{
			tmpSegments[tmpLogicalIndex].Content = pContent;
		}

		this.onContentChange(tmpLogicalIndex, pContent);

		// Debounce image preview updates (500ms) to avoid thrashing on every keystroke
		let tmpSelf = this;
		if (this._imagePreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._imagePreviewTimers[pSegmentIndex]);
		}
		this._imagePreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateImagePreviews(pSegmentIndex);
			delete tmpSelf._imagePreviewTimers[pSegmentIndex];
		}, 500);

		// Debounce rich content preview updates (mermaid / KaTeX) at 500ms
		if (this._richPreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._richPreviewTimers[pSegmentIndex]);
		}
		this._richPreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateRichPreviews(pSegmentIndex);
			delete tmpSelf._richPreviewTimers[pSegmentIndex];
		}, 500);
	}

	/**
	 * Hook for subclasses to respond to content changes.
	 *
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {string} pContent - The new content
	 */
	onContentChange(pSegmentIndex, pContent)
	{
		// Override in subclass
	}

	/**
	 * Get the logical (ordered) index for an internal segment index.
	 *
	 * @param {number} pInternalIndex - The internal segment index
	 * @returns {number} The logical index, or -1 if not found
	 */
	_getLogicalIndex(pInternalIndex)
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return -1;
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			let tmpIndex = parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10);
			if (tmpIndex === pInternalIndex)
			{
				return i;
			}
		}

		return -1;
	}

	/**
	 * Get the ordered list of internal segment indices from the DOM.
	 *
	 * @returns {Array<number>}
	 */
	_getOrderedSegmentIndices()
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return [];
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		let tmpIndices = [];
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			tmpIndices.push(parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10));
		}
		return tmpIndices;
	}

	// -- Public API --

	/**
	 * Add a new empty segment at the end.
	 *
	 * @param {string} [pContent] - Optional initial content for the new segment
	 */
	addSegment(pContent)
	{
		let tmpContent = (typeof (pContent) === 'string') ? pContent : '';

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			tmpSegments = [];
		}
		tmpSegments.push({ Content: tmpContent });
		this._setSegmentsToData(tmpSegments);

		this._buildEditorUI();
	}

	/**
	 * Remove a segment by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	removeSegment(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: segment index ${pSegmentIndex} not found.`);
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length <= 1)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: cannot remove the last segment.`);
			return;
		}

		if (this._segmentEditors[pSegmentIndex])
		{
			this._segmentEditors[pSegmentIndex].destroy();
			delete this._segmentEditors[pSegmentIndex];
		}

		tmpSegments.splice(tmpLogicalIndex, 1);
		this._setSegmentsToData(tmpSegments);

		// Update per-segment hidden preview state after removal
		let tmpNewHidden = {};
		for (let tmpKey in this._hiddenPreviewSegments)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx] = true;
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx - 1] = true;
			}
			// tmpIdx === tmpLogicalIndex is the removed segment; skip it
		}
		this._hiddenPreviewSegments = tmpNewHidden;

		// Update per-segment tab states after removal
		let tmpNewTabStates = {};
		for (let tmpKey in this._segmentTabStates)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx] = this._segmentTabStates[tmpKey];
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx - 1] = this._segmentTabStates[tmpKey];
			}
		}
		this._segmentTabStates = tmpNewTabStates;

		this._buildEditorUI();
	}

	/**
	 * Move a segment up by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentUp(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex <= 0)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex - 1];
		tmpSegments[tmpLogicalIndex - 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex - 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex - 1);

		this._buildEditorUI();
	}

	/**
	 * Move a segment down by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentDown(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpSegments.length - 1)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex + 1];
		tmpSegments[tmpLogicalIndex + 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex + 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex + 1);

		this._buildEditorUI();
	}

	/**
	 * Get the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @returns {string} The segment content
	 */
	getSegmentContent(pLogicalIndex)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			return '';
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			return tmpEditor.state.doc.toString();
		}

		return '';
	}

	/**
	 * Set the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @param {string} pContent - The content to set
	 */
	setSegmentContent(pLogicalIndex, pContent)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			this.log.warn(`PICT-MarkdownEditor setSegmentContent: index ${pLogicalIndex} out of range.`);
			return;
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			tmpEditor.dispatch(
			{
				changes:
				{
					from: 0,
					to: tmpEditor.state.doc.length,
					insert: pContent
				}
			});
		}
	}

	/**
	 * Get the total number of segments.
	 *
	 * @returns {number}
	 */
	getSegmentCount()
	{
		return this._getOrderedSegmentIndices().length;
	}

	/**
	 * Get all content from all segments joined together.
	 *
	 * @param {string} [pSeparator] - The separator between segments (default: "\n\n")
	 * @returns {string}
	 */
	getAllContent(pSeparator)
	{
		let tmpSeparator = (typeof (pSeparator) === 'string') ? pSeparator : '\n\n';
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		let tmpParts = [];

		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor)
			{
				tmpParts.push(tmpEditor.state.doc.toString());
			}
		}

		return tmpParts.join(tmpSeparator);
	}

	/**
	 * Marshal all editor contents back into the data address.
	 */
	_marshalAllEditorsToData()
	{
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor && i < tmpSegments.length)
			{
				tmpSegments[i].Content = tmpEditor.state.doc.toString();
			}
		}
	}

	/**
	 * Set the read-only state of all editors.
	 *
	 * @param {boolean} pReadOnly - Whether editors should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this.initialRenderComplete)
		{
			this._marshalAllEditorsToData();
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.initialRenderComplete && this.options.ContentDataAddress)
		{
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal the current editor content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		this._marshalAllEditorsToData();
	}

	/**
	 * Destroy all editors and clean up.
	 */
	destroy()
	{
		for (let tmpIndex in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIndex])
			{
				this._segmentEditors[tmpIndex].destroy();
			}
		}
		this._segmentEditors = {};

		// Clear rich preview debounce timers
		for (let tmpIndex in this._richPreviewTimers)
		{
			clearTimeout(this._richPreviewTimers[tmpIndex]);
		}
		this._richPreviewTimers = {};
		this._richPreviewGenerations = {};
		this._segmentTabStates = {};
	}
}

module.exports = PictSectionMarkdownEditor;

module.exports.default_configuration = _DefaultConfiguration;

// Form-side integration: the `RichText` InputType (and its provider class) lives
// in pict-section-form under `providers/inputs/Pict-Provider-Input-RichText.js`,
// not here. The provider lazy-requires this module on the first setMode('edit')
// so consumers that never edit don't pull CodeMirror.
//
//   const libRichTextInput = require('pict-section-form').RichTextInput;
//   pict.addProvider('Pict-Input-RichText',
//       libRichTextInput.default_configuration, libRichTextInput);

},{"./Pict-MDE-CodeMirror.js":674,"./Pict-MDE-DragAndReorder.js":675,"./Pict-MDE-Formatting.js":676,"./Pict-MDE-ImageHandling.js":677,"./Pict-MDE-RichPreview.js":678,"./Pict-Section-MarkdownEditor-DefaultConfiguration.js":679,"pict-section-content":561,"pict-view":733}],681:[function(require,module,exports){
/**
 * Pict-Modal-Confirm
 *
 * Builds confirm and double-confirm dialog DOM, returns Promises.
 */
class PictModalConfirm
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a single-step confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmLabel, cancelLabel, dangerous)
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is provided, user must type it to enable the confirm button.
	 * Otherwise, first click changes button text, second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel)
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultDoubleConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDoubleConfirmDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Build a standard confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpBtnStyle = pOptions.dangerous ? 'danger' : 'primary';

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				'<p>' + this._escapeHTML(pMessage) + '</p>' +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--' + tmpBtnStyle + '" data-action="confirm">' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpConfirmBtn.addEventListener('click', () => { tmpDismiss(true); });

		tmpDialog._dismiss = tmpDismiss;
		tmpDialog._focusTarget = tmpCancelBtn;

		return tmpDialog;
	}

	/**
	 * Build a double-confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDoubleConfirmDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpHasPhrase = (typeof pOptions.confirmPhrase === 'string') && (pOptions.confirmPhrase.length > 0);

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		let tmpBodyContent = '<p>' + this._escapeHTML(pMessage) + '</p>';

		if (tmpHasPhrase)
		{
			let tmpPromptText = pOptions.phrasePrompt.replace('{phrase}', pOptions.confirmPhrase);
			tmpBodyContent +=
				'<div class="pict-modal-confirm-prompt">' + this._escapeHTML(tmpPromptText) + '</div>' +
				'<input type="text" class="pict-modal-confirm-input" autocomplete="off" spellcheck="false" />';
		}

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				tmpBodyContent +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--danger" data-action="confirm" disabled>' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });

		if (tmpHasPhrase)
		{
			// Phrase-based: enable confirm button when input matches
			let tmpInput = tmpDialog.querySelector('.pict-modal-confirm-input');
			tmpInput.addEventListener('input', () =>
			{
				tmpConfirmBtn.disabled = (tmpInput.value !== pOptions.confirmPhrase);
			});
			tmpConfirmBtn.addEventListener('click', () =>
			{
				if (!tmpConfirmBtn.disabled)
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpInput;
		}
		else
		{
			// Two-click: first click changes label, second click confirms
			let tmpClickCount = 0;
			let tmpOriginalLabel = pOptions.confirmLabel;
			tmpConfirmBtn.disabled = false;

			tmpConfirmBtn.addEventListener('click', () =>
			{
				tmpClickCount++;
				if (tmpClickCount === 1)
				{
					tmpConfirmBtn.textContent = 'Click again to confirm';
				}
				else
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpCancelBtn;
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show a dialog element: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {function} fResolve - Promise resolver (for overlay click dismiss)
	 */
	_showDialog(pDialog, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'confirm'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(false); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track active modal
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus
		if (pDialog._focusTarget)
		{
			pDialog._focusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pDialog._dismiss(false);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);
	}

	/**
	 * Dismiss a dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult - Value to resolve the promise with
	 * @param {function} fResolve - Promise resolver
	 */
	_dismissDialog(pDialog, pResult, fResolve)
	{
		// Prevent double-dismiss
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		// Remove keyboard handler
		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		// Animate out
		pDialog.classList.remove('pict-modal-visible');

		// Remove from active modals
		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		// Update overlay click handler to point to new topmost modal
		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		// Hide overlay
		this._modal._overlay.hide();

		// Remove from DOM after transition
		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		// Resolve promise
		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalConfirm;

},{}],682:[function(require,module,exports){
/**
 * Pict-Modal-Dropdown
 *
 * Anchor-positioned menu that behaves like a dropdown / popover. Handy for:
 *   - nav menus that hang off a header link or button
 *   - "split button" style addenda (a primary action paired with a chevron
 *     that opens a list of related/alternate actions)
 *   - any "more options" affordance where a full modal would be heavy
 *
 * Differences from the modal Window helper:
 *   - No backdrop overlay — the rest of the page stays interactive.
 *   - Positioned next to the anchor element, not centered.
 *   - Auto-flips above when there isn't room below; clamps inside the viewport.
 *   - Click outside or Escape dismisses (matches native menu conventions).
 *
 * Usage:
 *     modal.dropdown(anchorEl, {
 *         items:
 *         [
 *             { Hash: 'edit',   Label: 'Edit'                    },
 *             { Hash: 'rename', Label: 'Rename...'                },
 *             { Separator: true                                   },
 *             { Hash: 'delete', Label: 'Delete', Style: 'danger'  },
 *             { Hash: 'archive',Label: 'Archive', Disabled: true,
 *               Tooltip: 'Already archived'                       }
 *         ],
 *         align: 'left'        // 'left' | 'right' (relative to anchor)
 *     }).then((pChoice) => { ... });
 *
 * Returns a Promise that resolves with `{ Hash, Item }` on selection or
 * `null` on dismiss.
 */
class PictModalDropdown
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._activeMenu = null;
	}

	/**
	 * Open a dropdown menu anchored to an element.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   a rect-like { left, top, width, height } anchor (handy for context menus).
	 * @param {object} pOptions
	 * @param {Array}    pOptions.items     - [{ Hash, Label, Style?, Disabled?, Tooltip?, Icon?, Separator? }]
	 * @param {string}   [pOptions.ContentHTML] - Free-form HTML body for the popover, rendered
	 *   verbatim via innerHTML INSTEAD of building a menu from items[]. When set, the element is
	 *   a plain anchored popover (no role=menu / keyboard item nav); outside-click, Escape,
	 *   auto-flip and reposition still apply. Sanitize untrusted content. items is ignored.
	 * @param {string}   [pOptions.align]   - 'left'|'right'|'center' (default 'left')
	 * @param {string}   [pOptions.position]- 'auto'|'below'|'above' (default 'auto')
	 * @param {string}   [pOptions.minWidth]- CSS minWidth (default: anchor width if known, else '160px')
	 * @param {string}   [pOptions.maxWidth]- CSS maxWidth (default unset; the base menu caps at 360px,
	 *   the --content variant uncaps — set this for wide rich-content popovers)
	 * @param {string}   [pOptions.maxHeight]- CSS maxHeight (default '60vh')
	 * @param {string}   [pOptions.className]- extra class(es) for the menu element
	 * @param {boolean}  [pOptions.closeOnSelect] - default true (no-op in ContentHTML mode)
	 * @param {function} [pOptions.onSelect]- called with (Hash, Item) on selection
	 * @param {function} [pOptions.onClose] - called after dismiss
	 * @returns {Promise<{Hash: string, Item: object}|null>}
	 */
	dropdown(pAnchor, pOptions)
	{
		let tmpOptions = Object.assign(
			{
				align:         'left',
				position:      'auto',
				maxHeight:     '60vh',
				closeOnSelect: true,
			},
			pOptions || {});

		let tmpAnchorEl = this._resolveAnchor(pAnchor);
		let tmpAnchorRect = this._anchorRect(pAnchor, tmpAnchorEl);
		if (!tmpAnchorRect) { return Promise.resolve(null); }

		// Re-opening the same menu is a no-op; closing-then-reopening is a
		// caller decision (just call dismissDropdown() first).
		if (this._activeMenu && this._activeMenu.anchor === tmpAnchorEl)
		{
			return this._activeMenu.promise;
		}

		// Only one dropdown at a time keeps focus / keyboard handling sane.
		this.dismissAll();

		let tmpItems = Array.isArray(tmpOptions.items) ? tmpOptions.items : [];

		let tmpResolveOuter;
		let tmpPromise = new Promise((fResolve) => { tmpResolveOuter = fResolve; });

		let tmpMenu = this._buildMenu(tmpItems, tmpOptions);
		document.body.appendChild(tmpMenu);
		this._positionMenu(tmpMenu, tmpAnchorRect, tmpOptions);

		// Animate in on the next frame.
		void tmpMenu.offsetHeight;
		tmpMenu.classList.add('pict-modal-visible');

		let tmpDismiss = (pResult) =>
		{
			if (tmpMenu._dismissed) { return; }
			tmpMenu._dismissed = true;
			document.removeEventListener('mousedown', tmpOutsideHandler, true);
			document.removeEventListener('keydown', tmpKeyHandler, true);
			window.removeEventListener('resize', tmpRepositionHandler);
			window.removeEventListener('scroll', tmpRepositionHandler, true);
			tmpMenu.classList.remove('pict-modal-visible');
			setTimeout(() =>
				{
					if (tmpMenu.parentNode) { tmpMenu.parentNode.removeChild(tmpMenu); }
				}, 180);
			if (this._activeMenu && this._activeMenu.element === tmpMenu) { this._activeMenu = null; }
			if (typeof tmpOptions.onClose === 'function') { tmpOptions.onClose(pResult); }
			tmpResolveOuter(pResult);
		};

		// Wire item clicks (each item element carries a data-hash; separators
		// and disabled items are skipped).
		let tmpItemEls = tmpMenu.querySelectorAll('[data-pict-modal-dropdown-item]');
		for (let i = 0; i < tmpItemEls.length; i++)
		{
			let tmpEl = tmpItemEls[i];
			tmpEl.addEventListener('click', (pEvent) =>
				{
					if (tmpEl.hasAttribute('data-disabled')) { return; }
					pEvent.stopPropagation();
					let tmpIdx = parseInt(tmpEl.getAttribute('data-index'), 10);
					let tmpItem = tmpItems[tmpIdx];
					let tmpHash = tmpEl.getAttribute('data-hash');
					if (typeof tmpOptions.onSelect === 'function')
					{
						tmpOptions.onSelect(tmpHash, tmpItem);
					}
					if (tmpOptions.closeOnSelect !== false) { tmpDismiss({ Hash: tmpHash, Item: tmpItem }); }
				});
		}

		// Click anywhere outside the menu (and outside the anchor) → dismiss.
		// Use mousedown/capture so we beat any per-element click handlers.
		let tmpOutsideHandler = (pEvent) =>
		{
			if (tmpMenu.contains(pEvent.target)) { return; }
			if (tmpAnchorEl && tmpAnchorEl.contains && tmpAnchorEl.contains(pEvent.target)) { return; }
			tmpDismiss(null);
		};
		document.addEventListener('mousedown', tmpOutsideHandler, true);

		// Esc dismisses; arrow keys navigate items (skipping disabled/separator).
		let tmpKeyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape') { pEvent.stopPropagation(); tmpDismiss(null); return; }
			if (pEvent.key === 'ArrowDown' || pEvent.key === 'ArrowUp')
			{
				pEvent.preventDefault();
				this._focusNeighbor(tmpMenu, pEvent.key === 'ArrowDown' ? 1 : -1);
			}
			else if (pEvent.key === 'Enter' || pEvent.key === ' ')
			{
				let tmpFocused = document.activeElement;
				if (tmpFocused && tmpMenu.contains(tmpFocused) && tmpFocused.hasAttribute('data-pict-modal-dropdown-item'))
				{
					pEvent.preventDefault();
					tmpFocused.click();
				}
			}
		};
		document.addEventListener('keydown', tmpKeyHandler, true);

		// Reposition on viewport resize / scroll so the menu doesn't drift
		// off the anchor.
		let tmpRepositionHandler = () =>
		{
			let tmpRect = this._anchorRect(pAnchor, tmpAnchorEl);
			if (tmpRect) { this._positionMenu(tmpMenu, tmpRect, tmpOptions); }
		};
		window.addEventListener('resize', tmpRepositionHandler);
		window.addEventListener('scroll', tmpRepositionHandler, true);

		// Move keyboard focus to the first enabled item so arrows / Enter work
		// without an extra click.
		setTimeout(() => { this._focusFirstEnabled(tmpMenu); }, 0);

		this._activeMenu = { element: tmpMenu, anchor: tmpAnchorEl, promise: tmpPromise, dismiss: tmpDismiss };

		return tmpPromise;
	}

	/**
	 * Dismiss the currently-open dropdown (if any).
	 */
	dismissAll()
	{
		if (this._activeMenu)
		{
			let tmpDismiss = this._activeMenu.dismiss;
			this._activeMenu = null;
			tmpDismiss(null);
		}
	}

	// ─────────────────────────────────────────────
	//  Internals
	// ─────────────────────────────────────────────

	_resolveAnchor(pAnchor)
	{
		if (!pAnchor) { return null; }
		if (typeof pAnchor === 'string') { return document.querySelector(pAnchor); }
		if (pAnchor.nodeType === 1) { return pAnchor; }
		// rect-like — no element to attach focus / outside-click ignore to,
		// but that's fine, the caller knows what they're doing.
		return null;
	}

	_anchorRect(pAnchor, pAnchorEl)
	{
		if (pAnchorEl && typeof pAnchorEl.getBoundingClientRect === 'function')
		{
			return pAnchorEl.getBoundingClientRect();
		}
		if (pAnchor && typeof pAnchor === 'object'
			&& typeof pAnchor.left === 'number' && typeof pAnchor.top === 'number')
		{
			return {
				left:   pAnchor.left,
				top:    pAnchor.top,
				width:  pAnchor.width  || 0,
				height: pAnchor.height || 0,
				right:  pAnchor.left + (pAnchor.width  || 0),
				bottom: pAnchor.top  + (pAnchor.height || 0),
			};
		}
		return null;
	}

	/**
	 * True when the value is usable as ContentHTML — a primitive string or a
	 * boxed String object (some template engines hand back `new String(...)`,
	 * which is `typeof 'object'` and would otherwise slip past the guard).
	 *
	 * @param {*} pValue
	 * @returns {boolean}
	 */
	_isContentHTML(pValue)
	{
		return (typeof pValue === 'string') || (pValue instanceof String);
	}

	_buildMenu(pItems, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-modal-dropdown';
		// Free-form content popovers carry a modifier so the host can reset the
		// menu-item chrome (padding / max-width) and style the body itself.
		if (this._isContentHTML(pOptions.ContentHTML)) { tmpMenu.className += ' pict-modal-dropdown--content'; }
		if (pOptions.className) { tmpMenu.className += ' ' + pOptions.className; }
		tmpMenu.id = 'pict-modal-dropdown-' + tmpId;
		tmpMenu.style.maxHeight = pOptions.maxHeight;
		if (pOptions.maxWidth) { tmpMenu.style.maxWidth = pOptions.maxWidth; }

		// ContentHTML mode: render the caller's HTML verbatim instead of building
		// a menu from items[]. This is a free-form anchored popover (e.g. a rich
		// info card, or a pre-rendered template menu) — not a role=menu list, so
		// we skip the menu role and the per-item keyboard semantics. Outside-click
		// / Escape / auto-flip / reposition all still apply from dropdown().
		if (this._isContentHTML(pOptions.ContentHTML))
		{
			tmpMenu.innerHTML = pOptions.ContentHTML;
			return tmpMenu;
		}

		tmpMenu.setAttribute('role', 'menu');

		let tmpHtml = '';
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpItem = pItems[i];
			if (tmpItem.Separator)
			{
				tmpHtml += '<div class="pict-modal-dropdown-separator" role="separator"></div>';
				continue;
			}
			if (tmpItem.Header)
			{
				tmpHtml += '<div class="pict-modal-dropdown-header">'
					+ this._escapeHTML(tmpItem.Header) + '</div>';
				continue;
			}
			let tmpCls = 'pict-modal-dropdown-item';
			if (tmpItem.Style)    { tmpCls += ' pict-modal-dropdown-item--' + tmpItem.Style; }
			if (tmpItem.Disabled) { tmpCls += ' pict-modal-dropdown-item--disabled'; }
			let tmpAttrs = ''
				+ ' data-pict-modal-dropdown-item'
				+ ' data-index="' + i + '"'
				+ ' data-hash="'  + this._escapeHTML(tmpItem.Hash || '') + '"'
				+ ' role="menuitem"'
				+ ' tabindex="-1"';
			if (tmpItem.Disabled) { tmpAttrs += ' aria-disabled="true" data-disabled'; }
			if (tmpItem.Tooltip)  { tmpAttrs += ' title="' + this._escapeHTML(tmpItem.Tooltip) + '"'; }
			let tmpIcon = tmpItem.Icon ? '<span class="pict-modal-dropdown-item-icon">' + tmpItem.Icon + '</span>' : '';
			let tmpHint = tmpItem.Hint ? '<span class="pict-modal-dropdown-item-hint">' + this._escapeHTML(tmpItem.Hint) + '</span>' : '';
			tmpHtml += '<div class="' + tmpCls + '"' + tmpAttrs + '>'
				+ tmpIcon
				+ '<span class="pict-modal-dropdown-item-label">' + this._escapeHTML(tmpItem.Label || '') + '</span>'
				+ tmpHint
				+ '</div>';
		}

		tmpMenu.innerHTML = tmpHtml;
		return tmpMenu;
	}

	_positionMenu(pMenu, pAnchorRect, pOptions)
	{
		// Apply min-width before measuring so the menu's natural size accounts
		// for the constraint.
		let tmpMinWidth = pOptions.minWidth
			|| (pAnchorRect.width >= 80 ? Math.ceil(pAnchorRect.width) + 'px' : '160px');
		pMenu.style.minWidth = tmpMinWidth;

		// Measure after attaching.
		let tmpMenuRect = pMenu.getBoundingClientRect();
		let tmpVw = window.innerWidth || document.documentElement.clientWidth;
		let tmpVh = window.innerHeight || document.documentElement.clientHeight;
		let tmpGap = 4; // breathing room between anchor and menu

		// Vertical: prefer below; flip above when not enough room and there's
		// more above. 'below'/'above' overrides force the side.
		let tmpRoomBelow = tmpVh - pAnchorRect.bottom - tmpGap;
		let tmpRoomAbove = pAnchorRect.top - tmpGap;
		let tmpPlaceAbove;
		if      (pOptions.position === 'above') { tmpPlaceAbove = true; }
		else if (pOptions.position === 'below') { tmpPlaceAbove = false; }
		else { tmpPlaceAbove = (tmpMenuRect.height > tmpRoomBelow) && (tmpRoomAbove > tmpRoomBelow); }

		// Cap height to whichever side we landed on so the menu can scroll
		// internally instead of running off the screen.
		let tmpCap = Math.max(80, (tmpPlaceAbove ? tmpRoomAbove : tmpRoomBelow) - 8);
		pMenu.style.maxHeight = tmpCap + 'px';

		// Horizontal alignment to the anchor, then clamp inside the viewport.
		let tmpLeft;
		if (pOptions.align === 'right')
		{
			tmpLeft = pAnchorRect.right - tmpMenuRect.width;
		}
		else if (pOptions.align === 'center')
		{
			tmpLeft = pAnchorRect.left + (pAnchorRect.width - tmpMenuRect.width) / 2;
		}
		else
		{
			tmpLeft = pAnchorRect.left;
		}
		tmpLeft = Math.min(tmpLeft, tmpVw - tmpMenuRect.width - 4);
		tmpLeft = Math.max(4, tmpLeft);

		let tmpTop;
		if (tmpPlaceAbove)
		{
			tmpTop = Math.max(4, pAnchorRect.top - tmpMenuRect.height - tmpGap);
			pMenu.classList.add('pict-modal-dropdown--above');
		}
		else
		{
			tmpTop = pAnchorRect.bottom + tmpGap;
			pMenu.classList.remove('pict-modal-dropdown--above');
		}

		pMenu.style.left = Math.round(tmpLeft) + 'px';
		pMenu.style.top  = Math.round(tmpTop)  + 'px';
	}

	_focusFirstEnabled(pMenu)
	{
		let tmpItems = pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])');
		if (tmpItems.length) { tmpItems[0].focus(); }
	}

	_focusNeighbor(pMenu, pDirection)
	{
		let tmpItems = Array.prototype.slice.call(
			pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])'));
		if (!tmpItems.length) { return; }
		let tmpActive = document.activeElement;
		let tmpIdx = tmpItems.indexOf(tmpActive);
		let tmpNext = (tmpIdx === -1)
			? (pDirection > 0 ? 0 : tmpItems.length - 1)
			: (tmpIdx + pDirection + tmpItems.length) % tmpItems.length;
		tmpItems[tmpNext].focus();
	}

	_escapeHTML(pText)
	{
		if (typeof pText !== 'string') { return ''; }
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalDropdown;

},{}],683:[function(require,module,exports){
/**
 * Pict-Modal-Overlay
 *
 * Manages a shared backdrop overlay element appended to document.body.
 * Reference-counted — created on first modal open, removed when last closes.
 */
class PictModalOverlay
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._element = null;
		this._refCount = 0;
	}

	/**
	 * Show the overlay (incrementing reference count).
	 * Creates the DOM element on first call.
	 *
	 * @param {function} [fOnClick] - Optional click handler (e.g. dismiss topmost modal)
	 */
	show(fOnClick)
	{
		this._refCount++;

		if (!this._element)
		{
			this._element = document.createElement('div');
			this._element.className = 'pict-modal-overlay';
			document.body.appendChild(this._element);

			// Force reflow so the transition animates
			void this._element.offsetHeight;
			this._element.classList.add('pict-modal-visible');
		}

		if (fOnClick)
		{
			// Store the latest click handler (for the topmost modal)
			this._currentClickHandler = fOnClick;
			this._element.onclick = (pEvent) =>
			{
				if (pEvent.target === this._element && this._currentClickHandler)
				{
					this._currentClickHandler();
				}
			};
		}
	}

	/**
	 * Update the overlay click handler (e.g. when topmost modal changes).
	 *
	 * @param {function} [fOnClick] - New click handler
	 */
	updateClickHandler(fOnClick)
	{
		this._currentClickHandler = fOnClick || null;
	}

	/**
	 * Hide the overlay (decrementing reference count).
	 * Removes the DOM element when reference count reaches zero.
	 */
	hide()
	{
		this._refCount--;

		if (this._refCount <= 0)
		{
			this._refCount = 0;
			if (this._element)
			{
				this._element.classList.remove('pict-modal-visible');
				let tmpElement = this._element;
				// Remove after transition
				setTimeout(() =>
				{
					if (tmpElement.parentNode)
					{
						tmpElement.parentNode.removeChild(tmpElement);
					}
				}, 220);
				this._element = null;
				this._currentClickHandler = null;
			}
		}
	}

	/**
	 * Force-remove the overlay regardless of reference count.
	 */
	destroy()
	{
		this._refCount = 0;
		if (this._element && this._element.parentNode)
		{
			this._element.parentNode.removeChild(this._element);
		}
		this._element = null;
		this._currentClickHandler = null;
	}
}

module.exports = PictModalOverlay;

},{}],684:[function(require,module,exports){
/**
 * Pict-Modal-Panel
 *
 * Adds resizable and collapsible panel behavior to any DOM element.
 * Follows the handler composition pattern used by the other modal
 * handlers (confirm, window, toast, tooltip).
 *
 * Usage:
 *   let handle = modal.panel('#my-panel', { position: 'right', width: 340 });
 *   handle.toggle();
 *   handle.destroy();
 */
class PictModalPanel
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._panels = [];
	}

	/**
	 * Attach resizable/collapsible panel behavior to an element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Panel options
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	create(pTargetSelector, pOptions)
	{
		let tmpDefaults = (this._modal && this._modal.options && this._modal.options.DefaultPanelOptions) || {};
		let tmpOptions = Object.assign({},
			{
				position: 'right',
				width: 340,
				minWidth: 200,
				maxWidth: 600,
				collapsible: true,
				collapsed: false,
				persist: false,
				persistKey: '',
				onResize: null,
				onToggle: null
			},
			tmpDefaults,
			pOptions);

		if (typeof document === 'undefined') return this._nullHandle();

		let tmpTarget = document.querySelector(pTargetSelector);
		if (!tmpTarget) return this._nullHandle();

		let tmpId = this._modal._nextId();
		let tmpIsRight = tmpOptions.position === 'right';
		let tmpIsCollapsed = false;
		let tmpCurrentWidth = tmpOptions.width;
		let tmpDestroyed = false;

		// Restore persisted state
		if (tmpOptions.persist && tmpOptions.persistKey)
		{
			try
			{
				let tmpStored = localStorage.getItem('pict-panel-' + tmpOptions.persistKey);
				if (tmpStored)
				{
					let tmpParsed = JSON.parse(tmpStored);
					if (typeof tmpParsed.width === 'number') tmpCurrentWidth = tmpParsed.width;
					if (typeof tmpParsed.collapsed === 'boolean') tmpOptions.collapsed = tmpParsed.collapsed;
				}
			}
			catch (e) { /* ignore */ }
		}

		// Apply classes and initial width
		tmpTarget.classList.add('pict-panel');
		tmpTarget.classList.add(tmpIsRight ? 'pict-panel-right' : 'pict-panel-left');
		tmpTarget.style.width = tmpCurrentWidth + 'px';

		// Remove display:none if present — panel uses width collapse instead
		if (tmpTarget.style.display === 'none')
		{
			tmpTarget.style.display = '';
		}

		// ── Create the edge container ───────────────────────
		let tmpEdge = document.createElement('div');
		tmpEdge.className = 'pict-panel-edge ' + (tmpIsRight ? 'pict-panel-edge-right' : 'pict-panel-edge-left');

		// Resize handle
		let tmpResize = document.createElement('div');
		tmpResize.className = 'pict-panel-resize';
		tmpEdge.appendChild(tmpResize);

		// Collapse tab (chevron SVG)
		let tmpTab = null;
		if (tmpOptions.collapsible)
		{
			tmpTab = document.createElement('div');
			tmpTab.className = 'pict-panel-tab';
			tmpTab.title = 'Toggle panel';
			tmpEdge.appendChild(tmpTab);
		}

		// Insert edge as a sibling so it is not clipped by the
		// panel's own overflow (e.g. overflow-y: auto for scrolling).
		// Right panels: edge goes BEFORE the panel (left side).
		// Left panels: edge goes AFTER the panel (right side).
		if (tmpTarget.parentNode)
		{
			if (tmpIsRight)
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget);
			}
			else
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget.nextSibling);
			}
		}
		else
		{
			tmpTarget.insertBefore(tmpEdge, tmpTarget.firstChild);
		}

		// ── Chevron lookup via pict.providers.Icon ──────────
		// Both directions come from the core registry (`{~I:ChevronLeft~}`
		// / `{~I:ChevronRight~}`).  Resolved per-render so a theme that
		// re-registers the chevron variant picks up automatically.  Empty
		// fallback in the unlikely case pict is missing the Icon provider
		// (very old pict versions; current minimum is 1.0.368).
		let tmpPictHandle = (typeof (window) !== 'undefined' && window.pict) ? window.pict : null;
		let tmpIcon = (pName) => (tmpPictHandle && typeof (tmpPictHandle.icon) === 'function')
			? tmpPictHandle.icon(pName)
			: '';

		let tmpUpdateChevron = () =>
		{
			if (!tmpTab) return;
			let tmpChevronRight = tmpIcon('ChevronRight');
			let tmpChevronLeft  = tmpIcon('ChevronLeft');
			if (tmpIsRight)
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronLeft : tmpChevronRight;
			}
			else
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronRight : tmpChevronLeft;
			}
		};

		// ── Persist helper ──────────────────────────────────
		let tmpPersist = () =>
		{
			if (!tmpOptions.persist || !tmpOptions.persistKey) return;
			try
			{
				localStorage.setItem('pict-panel-' + tmpOptions.persistKey,
					JSON.stringify({ width: tmpCurrentWidth, collapsed: tmpIsCollapsed }));
			}
			catch (e) { /* ignore */ }
		};

		// ── Collapse / expand ───────────────────────────────
		let tmpCollapse = () =>
		{
			if (tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(true);
		};

		let tmpExpand = () =>
		{
			if (!tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = false;
			tmpEdge.classList.remove('pict-panel-edge-collapsed');
			tmpTarget.classList.remove('pict-panel-collapsed');
			tmpTarget.style.width = tmpCurrentWidth + 'px';
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(false);
		};

		let tmpToggle = () =>
		{
			if (tmpIsCollapsed) tmpExpand();
			else tmpCollapse();
		};

		let tmpSetWidth = (pWidth) =>
		{
			if (tmpDestroyed) return;
			let tmpWidth = Math.max(tmpOptions.minWidth, Math.min(tmpOptions.maxWidth, pWidth));
			tmpCurrentWidth = tmpWidth;
			if (!tmpIsCollapsed)
			{
				tmpTarget.style.width = tmpWidth + 'px';
			}
			tmpPersist();
			if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpWidth);
		};

		// ── Tab click ───────────────────────────────────────
		if (tmpTab)
		{
			tmpTab.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpToggle();
			});
		}

		// ── Resize drag ─────────────────────────────────────
		let tmpOnMouseDown = (pEvent) =>
		{
			if (tmpIsCollapsed) return;
			pEvent.preventDefault();

			let tmpStartX = pEvent.clientX;
			let tmpStartWidth = tmpTarget.offsetWidth;

			tmpResize.classList.add('dragging');
			tmpTarget.style.transition = 'none';
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			let tmpOnMouseMove = (pMoveEvent) =>
			{
				let tmpDelta = tmpIsRight
					? (tmpStartX - pMoveEvent.clientX)
					: (pMoveEvent.clientX - tmpStartX);
				let tmpNewWidth = Math.max(tmpOptions.minWidth,
					Math.min(tmpOptions.maxWidth, tmpStartWidth + tmpDelta));
				tmpTarget.style.width = tmpNewWidth + 'px';
			};

			let tmpOnMouseUp = (pUpEvent) =>
			{
				document.removeEventListener('mousemove', tmpOnMouseMove);
				document.removeEventListener('mouseup', tmpOnMouseUp);

				tmpResize.classList.remove('dragging');
				tmpTarget.style.transition = '';
				document.body.style.userSelect = '';
				document.body.style.cursor = '';

				// Capture the final width
				tmpCurrentWidth = tmpTarget.offsetWidth;
				tmpPersist();
				if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpCurrentWidth);
			};

			document.addEventListener('mousemove', tmpOnMouseMove);
			document.addEventListener('mouseup', tmpOnMouseUp);
		};

		tmpResize.addEventListener('mousedown', tmpOnMouseDown);

		// ── Initial state ───────────────────────────────────
		tmpUpdateChevron();

		if (tmpOptions.collapsed)
		{
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
		}

		// ── Destroy ─────────────────────────────────────────
		let tmpDestroy = () =>
		{
			if (tmpDestroyed) return;
			tmpDestroyed = true;

			tmpResize.removeEventListener('mousedown', tmpOnMouseDown);
			if (tmpEdge.parentNode) tmpEdge.remove();
			tmpTarget.classList.remove('pict-panel', 'pict-panel-right', 'pict-panel-left', 'pict-panel-collapsed');
			tmpTarget.style.width = '';
			tmpTarget.style.transition = '';

			let tmpIdx = this._panels.indexOf(tmpHandle);
			if (tmpIdx >= 0) this._panels.splice(tmpIdx, 1);
		};

		// ── Return handle ───────────────────────────────────
		let tmpHandle =
		{
			id: tmpId,
			collapse: tmpCollapse,
			expand: tmpExpand,
			toggle: tmpToggle,
			setWidth: tmpSetWidth,
			destroy: tmpDestroy
		};

		this._panels.push(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Return a no-op handle for server-side or missing-element cases.
	 */
	_nullHandle()
	{
		return {
			id: 0,
			collapse: () => {},
			expand: () => {},
			toggle: () => {},
			setWidth: () => {},
			destroy: () => {}
		};
	}

	/**
	 * Destroy all active panels.
	 */
	destroyAll()
	{
		let tmpPanels = this._panels.slice();
		for (let i = 0; i < tmpPanels.length; i++)
		{
			tmpPanels[i].destroy();
		}
	}
}

module.exports = PictModalPanel;

},{}],685:[function(require,module,exports){
/**
 * Pict-Modal-Shell — viewport-managing layout system for top / right /
 * bottom / left panels around a center.
 *
 * # What this is for
 *
 * Most apps grow a chrome of stacked bars: a topbar, sometimes a
 * sub-nav, sometimes a bottom status bar, often a left sidebar, maybe
 * a right inspector. Each one has its own collapse / resize / persist
 * concerns, and apps end up reinventing the layout glue + the chrome
 * controls per-app.
 *
 * The Shell solves this once. The host calls `modal.shell(viewport)`,
 * adds panels in the order they should stack from each edge, and the
 * Shell manages:
 *
 *   - DOM structure (a flex tree wrapping the viewport)
 *   - Layout placement (multiple panels per side, each in registration order)
 *   - Collapse / expand chrome (a thin tab strip when collapsed)
 *   - Resize chrome (drag handle on the inner edge)
 *   - Pinned (in-flow) vs overlay (absolutely-positioned) panels
 *   - Persistence (per-panel collapsed + size, scoped by host or custom key)
 *   - Center destination (the workspace area between all panels)
 *
 * # Usage
 *
 *   let tmpShell = modal.shell('#App-Container', { PersistenceKey: 'my-app' });
 *
 *   tmpShell.addPanel({
 *       Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 60,
 *       ContentDestinationId: 'App-TopBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'statusbar', Side: 'bottom', Mode: 'fixed', Size: 28,
 *       ContentDestinationId: 'App-StatusBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'sidebar', Side: 'left', Mode: 'resizable', Size: 280,
 *       MinSize: 180, MaxSize: 480, Title: 'Modules',
 *       ContentDestinationId: 'App-Sidebar'
 *   });
 *
 *   let tmpCenter = tmpShell.center({ ContentDestinationId: 'App-Workspace' });
 *
 *   // Render into the destinations the same way as any other Pict view.
 *   pict.ContentAssignment.assignContent('#App-Sidebar', tmpHTML);
 *
 * # Panel options
 *
 *   Hash:                 unique id within the shell (auto-generated if omitted).
 *                         Used as the localStorage key suffix and for getPanel().
 *   Side:                 'top' | 'right' | 'bottom' | 'left'.
 *   Mode:                 'fixed' (no chrome), 'collapsible' (collapse tab),
 *                         'resizable' (collapse tab + drag handle).
 *   Position:             'pinned' (default; takes layout space) or 'overlay'
 *                         (absolutely positioned over the center / siblings).
 *   Scope:                'shell' (default) | 'center'.
 *                         When 'shell', the panel mounts in one of the
 *                         outer rows / side stacks (Side decides which).
 *                         When 'center', the panel mounts INSIDE the
 *                         center column instead — useful for bars that
 *                         should align with the content area only, not
 *                         span across the sidebars.  Only Side='top' and
 *                         Side='bottom' are supported with Scope='center'.
 *                         The center auto-switches to a flex-column
 *                         layout so the content destination + inner
 *                         panels stack vertically.
 *   Size:                 initial px (height for top/bottom, width for left/right).
 *                         Default: 200 for sides, 60 for top/bottom.
 *   MinSize, MaxSize:     drag clamp for resizable panels.
 *   Collapsed:            initial state. Persisted state overrides this.
 *   CollapsedSize:        px the panel becomes when collapsed (default 24).
 *   Title:                shown in the collapse tab.
 *   Icon:                 optional inline SVG / HTML for the collapse tab.
 *   ContentDestinationId: id given to the inner content div so the host can
 *                         reach it via #ContentDestinationId selectors.
 *   ContentView:          ViewIdentifier (string) of a registered Pict view
 *                         that owns this panel's content. When set, the
 *                         shell auto-renders the view once at panel creation
 *                         (so the destination is filled before the user
 *                         opens the panel) AND again on every expand
 *                         transition (so freshly-streamed state shows up).
 *                         Centralises the "I created a panel — now I have
 *                         to remember to render the view into it" boilerplate.
 *   Persist:              default true; pass false to skip save/load for this
 *                         panel even when the shell has persistence enabled.
 *   Hidden:               default false. When true, the collapsed state has
 *                         NO visible chrome — no collapse tab, no edge
 *                         affordance, the panel root is display: none. The
 *                         only way to reveal it is a programmatic
 *                         expand()/toggle() from elsewhere (e.g. a topbar
 *                         gear). Mode still controls the EXPANDED chrome —
 *                         pass Mode: 'resizable' to keep the drag handle
 *                         while open, then vanish on collapse.
 *   OnExpand, OnCollapse: callbacks that fire ONLY on transitions
 *                         (collapsed→expanded or expanded→collapsed).
 *                         Cleaner than OnToggle which fires for both
 *                         directions and forces callers to inspect the
 *                         bool. OnToggle is kept for back-compat.
 *
 * # Persistence
 *
 *   Storage key:  'pict-modal-shell:' + <PersistenceKey or hostname or 'default'>
 *   Value shape:  { Version: 1, Panels: { <hash>: { Collapsed: bool, Size: number } } }
 */

const STORAGE_PREFIX = 'pict-modal-shell:';
const SCHEMA_VERSION = 1;
const DEFAULT_COLLAPSED_SIZE = 24;
const DEFAULT_SIZE_SIDE = 240;
const DEFAULT_SIZE_TOPBOTTOM = 60;

class PictModalShell
{
	constructor(pModalSection, pViewportEl, pOptions)
	{
		this._modal = pModalSection;
		this._viewport = pViewportEl;
		this._options = pOptions || {};
		this._panels = [];
		this._panelsByHash = {};
		this._centerDestinationEl = null;
		this._idCounter = 0;
		this._activeDrag = null;
		this._persistenceEnabled = (this._options.Persistence !== false);
		this._persistenceKey = this._persistenceEnabled
			? this._resolvePersistenceKey(this._options.PersistenceKey)
			: null;

		// Build the wrapper DOM inside the viewport.
		this._buildSkeleton();
	}

	// ────────────────────────────────────────────────────────────────
	//  Public API
	// ────────────────────────────────────────────────────────────────

	addPanel(pConfig)
	{
		let tmpPanel = new ShellPanel(this, pConfig || {});
		this._panels.push(tmpPanel);
		this._panelsByHash[tmpPanel.Hash] = tmpPanel;
		this._mountPanel(tmpPanel);
		// Render the bound ContentView once now so the destination has
		// content even before the user opens the panel. This is the
		// "create" half of the unified create-and-popup pattern — hosts
		// no longer need to chase down each panel and call view.render()
		// manually after addPanel().
		tmpPanel._renderContentView();
		return tmpPanel;
	}

	getPanel(pHash) { return this._panelsByHash[pHash] || null; }

	getPanels() { return this._panels.slice(); }

	/**
	 * Convenience for cross-view popup triggers. Equivalent to
	 * `shell.getPanel(hash).popup()`. Silently no-ops when the hash
	 * doesn't match a registered panel (so callers don't have to
	 * null-check during boot races).
	 */
	openPanel(pHash)
	{
		let tmpPanel = this._panelsByHash[pHash];
		if (tmpPanel) { tmpPanel.popup(); }
		return tmpPanel || null;
	}

	/**
	 * Configure the center area. Optional; if never called, the center
	 * still exists but has no host-supplied destination id (host can
	 * still reach it via .pict-modal-shell-center).
	 */
	center(pOptions)
	{
		pOptions = pOptions || {};
		if (pOptions.ContentDestinationId)
		{
			// Remove any previously-created destination so center() is
			// idempotent across reconfigurations.  We don't blow away
			// the whole center via innerHTML='' anymore: Scope:'center'
			// panels mounted by earlier addPanel() calls need to stay
			// in place.  Find the right insertion point so the
			// destination sits between any top-scoped panels and any
			// bottom-scoped panels.
			if (this._centerDestinationEl && this._centerDestinationEl.parentNode === this._centerEl)
			{
				this._centerEl.removeChild(this._centerDestinationEl);
			}
			let tmpInner = document.createElement('div');
			tmpInner.id = pOptions.ContentDestinationId;
			tmpInner.className = 'pict-modal-shell-center-content';
			let tmpFirstBottomScoped = null;
			let tmpChildren = this._centerEl.children;
			for (let i = 0; i < tmpChildren.length; i++)
			{
				let tmpCandidate = tmpChildren[i];
				if (tmpCandidate.classList && tmpCandidate.classList.contains('pict-modal-shell-panel-bottom'))
				{
					tmpFirstBottomScoped = tmpCandidate;
					break;
				}
			}
			if (tmpFirstBottomScoped)
			{
				this._centerEl.insertBefore(tmpInner, tmpFirstBottomScoped);
			}
			else
			{
				this._centerEl.appendChild(tmpInner);
			}
			this._centerDestinationEl = tmpInner;
		}
		return this._centerEl;
	}

	getCenterEl() { return this._centerEl; }

	destroy()
	{
		for (let i = 0; i < this._panels.length; i++) { this._panels[i].destroy(true); }
		this._panels = [];
		this._panelsByHash = {};
		if (this._wrapperEl && this._wrapperEl.parentNode)
		{
			this._wrapperEl.parentNode.removeChild(this._wrapperEl);
		}
		this._detachDragHandlers();
	}

	// ────────────────────────────────────────────────────────────────
	//  Persistence
	// ────────────────────────────────────────────────────────────────

	_resolvePersistenceKey(pUserKey)
	{
		if (typeof pUserKey === 'string' && pUserKey.length > 0) return STORAGE_PREFIX + pUserKey;
		try
		{
			if (typeof window !== 'undefined' && window.location && window.location.hostname)
			{
				return STORAGE_PREFIX + window.location.hostname;
			}
		}
		catch (pErr) { /* fall through */ }
		return STORAGE_PREFIX + 'default';
	}

	_loadState()
	{
		if (!this._persistenceKey) return null;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return null;
			let tmpRaw = tmpStore.getItem(this._persistenceKey);
			if (!tmpRaw) return null;
			let tmpParsed = JSON.parse(tmpRaw);
			if (!tmpParsed || tmpParsed.Version !== SCHEMA_VERSION) return null;
			return (tmpParsed.Panels && typeof tmpParsed.Panels === 'object') ? tmpParsed.Panels : {};
		}
		catch (pErr) { return null; }
	}

	_loadPanelState(pHash)
	{
		let tmpAll = this._loadState();
		if (!tmpAll) return null;
		return tmpAll[pHash] || null;
	}

	_savePanelState(pHash, pState)
	{
		if (!this._persistenceKey) return;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return;
			let tmpAll = this._loadState() || {};
			tmpAll[pHash] = pState;
			tmpStore.setItem(this._persistenceKey, JSON.stringify(
			{
				Version: SCHEMA_VERSION,
				Panels: tmpAll,
				SavedAt: new Date().toISOString()
			}));
		}
		catch (pErr) { /* swallow */ }
	}

	// ────────────────────────────────────────────────────────────────
	//  DOM scaffolding
	// ────────────────────────────────────────────────────────────────

	_buildSkeleton()
	{
		// Wipe whatever was inside the viewport — the host opted into
		// the shell taking ownership of layout.
		this._viewport.innerHTML = '';
		this._viewport.classList.add('pict-modal-shell-host');

		this._wrapperEl = document.createElement('div');
		this._wrapperEl.className = 'pict-modal-shell';

		this._topRow = document.createElement('div');
		this._topRow.className = 'pict-modal-shell-row pict-modal-shell-row-top';
		this._wrapperEl.appendChild(this._topRow);

		this._middleRow = document.createElement('div');
		this._middleRow.className = 'pict-modal-shell-row pict-modal-shell-row-middle';
		this._wrapperEl.appendChild(this._middleRow);

		this._leftStack = document.createElement('div');
		this._leftStack.className = 'pict-modal-shell-side pict-modal-shell-side-left';
		this._middleRow.appendChild(this._leftStack);

		this._centerEl = document.createElement('div');
		this._centerEl.className = 'pict-modal-shell-center';
		this._middleRow.appendChild(this._centerEl);

		this._rightStack = document.createElement('div');
		this._rightStack.className = 'pict-modal-shell-side pict-modal-shell-side-right';
		this._middleRow.appendChild(this._rightStack);

		this._bottomRow = document.createElement('div');
		this._bottomRow.className = 'pict-modal-shell-row pict-modal-shell-row-bottom';
		this._wrapperEl.appendChild(this._bottomRow);

		// Overlay layer for overlay-position panels (absolute over middle row)
		this._overlayLayer = document.createElement('div');
		this._overlayLayer.className = 'pict-modal-shell-overlay-layer';
		this._middleRow.appendChild(this._overlayLayer);

		this._viewport.appendChild(this._wrapperEl);
	}

	_mountPanel(pPanel)
	{
		if (pPanel.Position === 'overlay')
		{
			this._overlayLayer.appendChild(pPanel.El);
			return;
		}
		if (pPanel.Scope === 'center')
		{
			// Center-scoped panels mount inside the center column.
			// The column switches to flex-column so the content
			// destination + the panel(s) stack vertically.
			this._centerEl.classList.add('pict-modal-shell-center-with-inner-panel');
			if (pPanel.Side === 'top')
			{
				// Top-scoped panels go above the content destination.
				// If center() hasn't run yet, this still works — we
				// insert before whatever's first (or just append to an
				// empty center, which leaves us above any subsequent
				// content destination).
				this._centerEl.insertBefore(pPanel.El, this._centerEl.firstChild);
			}
			else
			{
				// Side === 'bottom' (the Scope guard already filtered
				// left/right).  Append to the bottom of the center.
				this._centerEl.appendChild(pPanel.El);
			}
			return;
		}
		let tmpHost;
		if      (pPanel.Side === 'top')    tmpHost = this._topRow;
		else if (pPanel.Side === 'bottom') tmpHost = this._bottomRow;
		else if (pPanel.Side === 'left')   tmpHost = this._leftStack;
		else if (pPanel.Side === 'right')  tmpHost = this._rightStack;
		else                               tmpHost = this._wrapperEl;
		tmpHost.appendChild(pPanel.El);
	}

	// ────────────────────────────────────────────────────────────────
	//  Drag (resize) machinery — shared across all resizable panels.
	// ────────────────────────────────────────────────────────────────

	_attachDragStart(pPanel, pEvent)
	{
		pEvent.preventDefault();
		let tmpAxis = (pPanel.Side === 'top' || pPanel.Side === 'bottom') ? 'y' : 'x';
		this._activeDrag =
		{
			Panel:       pPanel,
			Axis:        tmpAxis,
			StartCoord:  (tmpAxis === 'x') ? pEvent.clientX : pEvent.clientY,
			StartSize:   pPanel.Size,
			Direction:   (pPanel.Side === 'left' || pPanel.Side === 'top') ? 1 : -1,
			PendingSize: null,
			RAFId:       0
		};
		document.body.classList.add(tmpAxis === 'x' ? 'pict-modal-shell-dragging-x' : 'pict-modal-shell-dragging-y');
		// Suppress the panel's collapse/expand width/height transition for
		// the duration of the drag — without this, every pointermove kicks
		// off a fresh 140ms transition that stacks up and renders the
		// resize as visibly laggy ("choppy"). With the transition off the
		// panel snaps to each new size in the same frame as the pointer.
		pPanel.El.classList.add('pict-modal-shell-panel-resizing');
		// Capture the pointer so dragging works even when the cursor leaves
		// the resize handle (otherwise the user has to keep the cursor
		// exactly on the 6 px strip — feels twitchy).
		try { pEvent.target.setPointerCapture && pEvent.target.setPointerCapture(pEvent.pointerId); }
		catch (pErr) { /* not supported in old browsers — fine */ }
		document.addEventListener('pointermove', this._onDragMove);
		document.addEventListener('pointerup',   this._onDragEnd);
	}

	// Pointer events fire at the device's input rate (often 240 Hz+ on
	// modern trackpads / mice) but we only paint at the display's refresh
	// rate (60–120 Hz). Coalesce multiple pointermoves per frame into a
	// single setSize() call via requestAnimationFrame — this drops the
	// per-frame work to one DOM mutation regardless of pointer rate.
	_onDragMove = (pEvent) =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		let tmpCoord = (tmpD.Axis === 'x') ? pEvent.clientX : pEvent.clientY;
		let tmpDelta = (tmpCoord - tmpD.StartCoord) * tmpD.Direction;
		tmpD.PendingSize = tmpD.StartSize + tmpDelta;
		if (!tmpD.RAFId)
		{
			let tmpSelf = this;
			tmpD.RAFId = (typeof window !== 'undefined' && window.requestAnimationFrame)
				? window.requestAnimationFrame(function () { tmpSelf._flushDrag(); })
				: setTimeout(function () { tmpSelf._flushDrag(); }, 16);
		}
	};

	_flushDrag()
	{
		let tmpD = this._activeDrag;
		if (!tmpD) return;
		tmpD.RAFId = 0;
		if (tmpD.PendingSize !== null)
		{
			tmpD.Panel.setSize(tmpD.PendingSize);
			tmpD.PendingSize = null;
		}
	}

	_onDragEnd = () =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		// Flush any pending pointermove that hadn't painted yet so the
		// final size matches the actual cursor position, not the last
		// rAF-aligned value.
		if (tmpD.PendingSize !== null) { this._flushDrag(); }
		if (tmpD.RAFId && typeof window !== 'undefined' && window.cancelAnimationFrame)
		{
			window.cancelAnimationFrame(tmpD.RAFId);
		}
		document.body.classList.remove('pict-modal-shell-dragging-x');
		document.body.classList.remove('pict-modal-shell-dragging-y');
		tmpD.Panel.El.classList.remove('pict-modal-shell-panel-resizing');
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
		// Persist final size.
		tmpD.Panel._persist();
		this._activeDrag = null;
	};

	_detachDragHandlers()
	{
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
	}
}

// ════════════════════════════════════════════════════════════════════
//  ShellPanel — one panel within a Shell
// ════════════════════════════════════════════════════════════════════

class ShellPanel
{
	constructor(pShell, pConfig)
	{
		this._shell = pShell;
		this._config = pConfig;

		this.Hash = pConfig.Hash || ('panel-' + ++pShell._idCounter);
		this.Side = (pConfig.Side === 'right' || pConfig.Side === 'bottom' || pConfig.Side === 'left') ? pConfig.Side : 'top';
		this.Mode = (pConfig.Mode === 'collapsible' || pConfig.Mode === 'resizable') ? pConfig.Mode : 'fixed';
		this.Position = (pConfig.Position === 'overlay') ? 'overlay' : 'pinned';
		// Scope: 'center' opts the panel into the center column instead
		// of the shell's outer rows.  Only valid for Side='top'/'bottom'
		// (left/right inside center would need a separate axis we don't
		// support).  Invalid combinations silently fall back to 'shell'.
		this.Scope = (pConfig.Scope === 'center'
				&& (this.Side === 'top' || this.Side === 'bottom'))
			? 'center'
			: 'shell';
		this.Title = pConfig.Title || '';
		this.Icon  = pConfig.Icon  || '';
		this.MinSize = (typeof pConfig.MinSize === 'number') ? pConfig.MinSize : 40;
		this.MaxSize = (typeof pConfig.MaxSize === 'number') ? pConfig.MaxSize : 1200;
		// `Hidden: true` is a panel that has NO visible chrome in its collapsed
		// state — no collapse tab sliver, no resize handle, no edge marker, and
		// (via CSS) display: none on the panel root. The only way to reveal it
		// is a programmatic expand()/toggle() called from elsewhere in the app
		// (e.g. a gear button in the topbar). Useful when the host wants a
		// fully-shaped panel but doesn't want an always-visible affordance for
		// discovering it. The Mode is still honoured for the EXPANDED state —
		// pass Mode: 'resizable' to keep the drag handle while the panel is
		// open, while still vanishing entirely when collapsed.
		this.Hidden = !!pConfig.Hidden;
		this.CollapsedSize = (typeof pConfig.CollapsedSize === 'number')
			? pConfig.CollapsedSize
			: (this.Hidden ? 0 : DEFAULT_COLLAPSED_SIZE);
		this.PersistEnabled = pShell._persistenceEnabled && (pConfig.Persist !== false);

		let tmpDefaultSize = (this.Side === 'left' || this.Side === 'right') ? DEFAULT_SIZE_SIDE : DEFAULT_SIZE_TOPBOTTOM;
		this.Size = (typeof pConfig.Size === 'number') ? pConfig.Size : tmpDefaultSize;
		this.Collapsed = !!pConfig.Collapsed;

		// Persisted state overrides initial Size/Collapsed.
		if (this.PersistEnabled)
		{
			let tmpSaved = pShell._loadPanelState(this.Hash);
			if (tmpSaved)
			{
				if (typeof tmpSaved.Size === 'number') this.Size = tmpSaved.Size;
				if (typeof tmpSaved.Collapsed === 'boolean') this.Collapsed = tmpSaved.Collapsed;
			}
		}
		this._clampSize();

		// Build the panel DOM.
		this._buildEl(pConfig);
		this._applySize();
		this._applyCollapsedClass();

		// Responsive drawer — at narrow viewports, flip a docked side
		// panel into a "top drawer" by adding a class to the middle row
		// that toggles flex-direction from row to column. The panel
		// stretches to full width and trades its inline `width` for a
		// configurable drawer `height`. The user's collapse/expand
		// keeps working: collapsed in drawer mode just gives the panel
		// height: 0 (so only the collapse tab remains visible at the
		// top of the content), expanded restores the drawer height.
		// Pass `0` or omit to disable. Mirrors retold-remote's
		// `.content-editor-body { flex-direction: column }` pattern.
		this.ResponsiveDrawer = (typeof pConfig.ResponsiveDrawer === 'number'
			&& pConfig.ResponsiveDrawer > 0)
				? pConfig.ResponsiveDrawer : 0;
		// Drawer height — applied as `height` to the panel in drawer
		// mode. CSS units (px / vh / %) accepted. Default 33vh which
		// gives the panel roughly a third of the viewport height and
		// leaves comfortable room for the workspace below.
		this.DrawerHeight = (typeof pConfig.DrawerHeight === 'string' && pConfig.DrawerHeight)
			? pConfig.DrawerHeight : '33vh';
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
		if (this.ResponsiveDrawer > 0)
		{
			this._wireResponsiveDrawer();
		}
	}

	// ───────────── public ─────────────

	getContentEl() { return this._contentEl; }

	/**
	 * Returns the currently-bound ContentView Pict view instance, or
	 * null if no ContentView is configured / the view isn't registered
	 * yet.
	 */
	getContentView()
	{
		if (!this._config.ContentView) return null;
		let tmpPict = this._shell._modal && this._shell._modal.pict;
		if (!tmpPict || !tmpPict.views) return null;
		return tmpPict.views[this._config.ContentView] || null;
	}

	collapse() { this._setCollapsed(true);  }
	expand()   { this._setCollapsed(false); }
	toggle()   { this._setCollapsed(!this.Collapsed); }

	/**
	 * Unified "show this panel" affordance — this is the shared
	 * codepath every popup trigger should funnel through. Behavior:
	 *
	 *   - If collapsed → expand (which fires OnExpand + re-renders the
	 *     ContentView via the shared transition machinery).
	 *   - If already open → re-render the ContentView (so any newly-
	 *     streamed state is visible) AND briefly flash the panel
	 *     border so the user notices that the existing panel just
	 *     received attention. Avoids the "I clicked a button but
	 *     nothing happened" feeling when the panel was already open.
	 *
	 * Idempotent — safe to call from any number of triggers without
	 * stacking effects.
	 */
	popup()
	{
		if (this.Collapsed)
		{
			this._setCollapsed(false);
		}
		else
		{
			// Already open — refresh content + flash for attention.
			this._renderContentView();
			this._flash();
		}
	}

	setSize(pSize)
	{
		if (typeof pSize !== 'number' || !isFinite(pSize)) return;
		this.Size = pSize;
		this._clampSize();
		this._applySize();
	}

	destroy(pSkipFromShell)
	{
		this._unwireResponsiveDrawer();
		if (this.El && this.El.parentNode) this.El.parentNode.removeChild(this.El);
		if (!pSkipFromShell)
		{
			let tmpIdx = this._shell._panels.indexOf(this);
			if (tmpIdx >= 0) this._shell._panels.splice(tmpIdx, 1);
			delete this._shell._panelsByHash[this.Hash];
		}
	}

	// ───────────── internals ─────────────

	_clampSize()
	{
		if (this.Size < this.MinSize) this.Size = this.MinSize;
		if (this.Size > this.MaxSize) this.Size = this.MaxSize;
	}

	// Responsive drawer — sets up a matchMedia listener for
	// `(max-width: <ResponsiveDrawer>px)`. Each crossing flips the
	// shell's middle row between row layout (wide) and column layout
	// (narrow) by toggling the `pict-modal-shell-drawer-active` class
	// on the middle row. The matching CSS makes side panels expand to
	// full width with a fixed `DrawerHeight`, becoming top/bottom
	// drawers above/below the workspace center. Collapsed in drawer
	// mode collapses to height: 0, leaving only the collapse tab.
	//
	// This pattern is the conventional "responsive sidebar" approach
	// (used by retold-remote's content editor) — the user keeps their
	// sidebar accessible at narrow widths but it gives the workspace
	// room to breathe.
	_wireResponsiveDrawer()
	{
		if (typeof window === 'undefined' || !window.matchMedia) return;

		this._mediaQuery = window.matchMedia('(max-width: ' + this.ResponsiveDrawer + 'px)');

		// Apply the drawer height as a CSS variable on the panel
		// element so the static CSS rules can read it. Doing this once
		// here avoids per-event JS style writes.
		if (this.El) { this.El.style.setProperty('--pict-modal-drawer-height', this.DrawerHeight); }

		let tmpSelf = this;
		this._mediaQueryHandler = function (pEvent)
		{
			let tmpNarrow = (pEvent && typeof pEvent.matches === 'boolean')
				? pEvent.matches
				: tmpSelf._mediaQuery.matches;
			tmpSelf._setDrawerMode(tmpNarrow);
		};

		// Apply the current state immediately (handles the case where the
		// page loads already-narrow). Newer browsers use addEventListener;
		// older ones use addListener.
		if (this._mediaQuery.addEventListener)
		{
			this._mediaQuery.addEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.addListener)
		{
			this._mediaQuery.addListener(this._mediaQueryHandler);
		}
		this._mediaQueryHandler({ matches: this._mediaQuery.matches });

		// Belt + suspenders: also listen to window resize and re-sync.
		// `matchMedia.change` is supposed to be reliable on every
		// boundary crossing, but in real-world testing (esp. when the
		// user is dragging DevTools to resize the inner viewport, or
		// going through fast successive crossings) we've seen the
		// change event silently miss. A plain resize listener is
		// cheap and the handler is idempotent — if matches state
		// hasn't actually changed the body of `_setDrawerMode` is a
		// no-op (it short-circuits when classes are already correct).
		this._resizeHandler = function ()
		{
			tmpSelf._setDrawerMode(tmpSelf._mediaQuery.matches);
		};
		window.addEventListener('resize', this._resizeHandler);
	}

	_unwireResponsiveDrawer()
	{
		if (this._resizeHandler && typeof window !== 'undefined')
		{
			window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (!this._mediaQuery || !this._mediaQueryHandler) return;
		if (this._mediaQuery.removeEventListener)
		{
			this._mediaQuery.removeEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.removeListener)
		{
			this._mediaQuery.removeListener(this._mediaQueryHandler);
		}
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
	}

	// Toggle drawer mode by adding / removing a class on the shell's
	// middle row. The CSS rule for `.pict-modal-shell-drawer-active`
	// flips flex-direction column, makes side panels full-width, and
	// applies the panel's `--pict-modal-drawer-height` for sizing.
	// Also tags the panel itself so per-panel CSS can target it.
	// Re-applies the inline size at the end so the wide-mode crossing
	// gets a clean width back (drawer mode forced width: 100% via CSS
	// !important; the inline style was stale).
	_setDrawerMode(pDrawer)
	{
		if (!this._shell || !this._shell._middleRow) return;
		// Idempotent — short-circuit when the panel's drawer state
		// already matches the target. Keeps the resize-event fallback
		// (which fires constantly during drag-resize) from doing
		// pointless DOM thrash + style re-application every frame.
		let tmpCurrentlyDrawer = !!(this.El
			&& this.El.classList.contains('pict-modal-shell-panel-drawer'));
		if (tmpCurrentlyDrawer === !!pDrawer) return;
		if (pDrawer)
		{
			this._shell._middleRow.classList.add('pict-modal-shell-drawer-active');
			if (this.El) { this.El.classList.add('pict-modal-shell-panel-drawer'); }
		}
		else
		{
			// Only remove the row-level class if NO other panel still
			// wants drawer mode. Multi-panel hosts can safely each opt
			// in independently this way.
			let tmpStillNarrow = false;
			let tmpPanels = this._shell._panels || [];
			for (let i = 0; i < tmpPanels.length; i++)
			{
				let tmpP = tmpPanels[i];
				if (tmpP !== this
					&& tmpP._mediaQuery
					&& tmpP._mediaQuery.matches
					&& tmpP.ResponsiveDrawer > 0)
				{
					tmpStillNarrow = true;
					break;
				}
			}
			if (!tmpStillNarrow)
			{
				this._shell._middleRow.classList.remove('pict-modal-shell-drawer-active');
			}
			if (this.El) { this.El.classList.remove('pict-modal-shell-panel-drawer'); }
		}
		// Re-apply inline size. In drawer mode the CSS !important
		// rule overrides this anyway, but on the wide crossing we
		// need the inline width to be correct so the panel shows up
		// at its proper docked / collapsed-docked size rather than
		// inheriting any stale state.
		this._applySize();
	}

	_buildEl(pConfig)
	{
		let tmpRoot = document.createElement('div');
		tmpRoot.className = 'pict-modal-shell-panel pict-modal-shell-panel-' + this.Side
			+ ' pict-modal-shell-panel-mode-' + this.Mode
			+ (this.Position === 'overlay' ? ' pict-modal-shell-panel-overlay' : '')
			+ (this.Hidden ? ' pict-modal-shell-panel-hidden' : '');
		tmpRoot.setAttribute('data-shell-panel-hash', this.Hash);
		tmpRoot.setAttribute('data-shell-panel-side', this.Side);
		tmpRoot.setAttribute('data-shell-panel-mode', this.Mode);

		// Content area — hosts render their stuff into the inner #id div.
		let tmpContentWrap = document.createElement('div');
		tmpContentWrap.className = 'pict-modal-shell-panel-content';
		this._contentEl = document.createElement('div');
		if (pConfig.ContentDestinationId)
		{
			this._contentEl.id = pConfig.ContentDestinationId;
		}
		this._contentEl.className = 'pict-modal-shell-panel-content-inner';
		tmpContentWrap.appendChild(this._contentEl);
		tmpRoot.appendChild(tmpContentWrap);

		// Collapse tab — shown when collapsible / resizable. Lives at the
		// inner edge so it's always reachable when the panel is collapsed.
		// Hidden panels skip the tab entirely — the only path back from
		// collapsed → expanded is a programmatic expand() / toggle() call
		// from the host (e.g. a topbar gear button).
		if ((this.Mode === 'collapsible' || this.Mode === 'resizable') && !this.Hidden)
		{
			this._collapseTab = document.createElement('button');
			this._collapseTab.type = 'button';
			this._collapseTab.className = 'pict-modal-shell-panel-collapse-tab';
			this._collapseTab.setAttribute('aria-label',
				(this.Title ? 'Toggle ' + this.Title : 'Toggle panel'));
			this._collapseTab.title = this.Title || 'Toggle';
			this._collapseTab.innerHTML = ''
				+ (this.Icon ? '<span class="pict-modal-shell-panel-collapse-tab-icon">' + this.Icon + '</span>' : '')
				+ (this.Title ? '<span class="pict-modal-shell-panel-collapse-tab-title">' + this._escape(this.Title) + '</span>' : '');
			let tmpSelf = this;
			this._collapseTab.addEventListener('click', function () { tmpSelf.toggle(); });
			tmpRoot.appendChild(this._collapseTab);
		}

		// Resize handle — only when resizable. Positioned via CSS based
		// on side.
		if (this.Mode === 'resizable')
		{
			this._resizeHandle = document.createElement('div');
			this._resizeHandle.className = 'pict-modal-shell-panel-resize-handle';
			this._resizeHandle.setAttribute('aria-hidden', 'true');
			let tmpSelf = this;
			this._resizeHandle.addEventListener('pointerdown', function (pEvent)
			{
				if (tmpSelf.Collapsed) return;
				tmpSelf._shell._attachDragStart(tmpSelf, pEvent);
			});
			tmpRoot.appendChild(this._resizeHandle);
		}

		this.El = tmpRoot;
	}

	_applySize()
	{
		let tmpEffective = this.Collapsed ? this.CollapsedSize : this.Size;
		if (this.Side === 'left' || this.Side === 'right')
		{
			this.El.style.width = tmpEffective + 'px';
			this.El.style.height = '';
		}
		else
		{
			this.El.style.height = tmpEffective + 'px';
			this.El.style.width = '';
		}
	}

	_applyCollapsedClass()
	{
		if (this.Collapsed) this.El.classList.add('pict-modal-shell-panel-collapsed');
		else this.El.classList.remove('pict-modal-shell-panel-collapsed');
	}

	_setCollapsed(pBool)
	{
		if (this.Collapsed === !!pBool) return;
		let tmpWasCollapsed = this.Collapsed;
		this.Collapsed = !!pBool;
		this._applyCollapsedClass();
		this._applySize();
		this._persist();

		// Transition-specific hooks fire BEFORE OnToggle so OnExpand
		// callers can mutate state (e.g. set focus, re-fetch data) and
		// have it reflected by any OnToggle observer that runs after.
		if (tmpWasCollapsed && !this.Collapsed)
		{
			// collapsed → expanded. Render the bound ContentView so
			// freshly-streamed state shows up the moment the panel
			// becomes visible (replaces the manual view.render() dance
			// hosts used to do in their own runAction-style helpers).
			this._renderContentView();
			this._fireHook('OnExpand');
		}
		else if (!tmpWasCollapsed && this.Collapsed)
		{
			this._fireHook('OnCollapse');
		}

		// Back-compat: OnToggle still fires for both directions.
		this._fireHook('OnToggle', this.Collapsed);
	}

	_fireHook(pName, pArg)
	{
		let tmpFn = this._config[pName];
		if (typeof tmpFn !== 'function') return;
		try
		{
			if (typeof pArg !== 'undefined') { tmpFn(pArg, this); }
			else                             { tmpFn(this); }
		}
		catch (pErr) { /* host hook failure must not break the panel */ }
	}

	/**
	 * Render the bound ContentView (if any) into this panel's
	 * destination. Called by the shell on panel creation + on every
	 * collapsed→expanded transition + by popup() when re-flashing an
	 * already-open panel. Silently no-ops when no ContentView is
	 * configured or the view isn't registered yet (boot races).
	 */
	_renderContentView()
	{
		let tmpView = this.getContentView();
		if (tmpView && typeof tmpView.render === 'function')
		{
			try { tmpView.render(); }
			catch (pErr) { /* view render failure shouldn't break the panel chrome */ }
		}
	}

	/**
	 * Briefly highlight the panel — used by popup() when called on an
	 * already-open panel so the user sees that their click landed.
	 * The class is removed after the CSS animation completes; safe to
	 * re-trigger (timeouts overlap, last one wins on the trailing edge).
	 */
	_flash()
	{
		if (!this.El) return;
		this.El.classList.add('pict-modal-shell-panel-flash');
		let tmpSelf = this;
		clearTimeout(this._flashTimer);
		this._flashTimer = setTimeout(function ()
		{
			if (tmpSelf.El) tmpSelf.El.classList.remove('pict-modal-shell-panel-flash');
		}, 700);
	}

	_persist()
	{
		if (!this.PersistEnabled) return;
		this._shell._savePanelState(this.Hash,
		{
			Collapsed: this.Collapsed,
			Size: this.Size
		});
	}

	_escape(pStr)
	{
		return String(pStr || '')
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

// ════════════════════════════════════════════════════════════════════
//  Module exports — used internally by Pict-Section-Modal.shell()
// ════════════════════════════════════════════════════════════════════

class PictModalShellManager
{
	constructor(pModalSection)
	{
		this._modal = pModalSection;
		this._shellsByViewport = new WeakMap();
	}

	/**
	 * Idempotent — calling shell() twice with the same viewport returns
	 * the same instance.
	 */
	shell(pViewportSelectorOrEl, pOptions)
	{
		let tmpEl = (typeof pViewportSelectorOrEl === 'string')
			? document.querySelector(pViewportSelectorOrEl)
			: pViewportSelectorOrEl;
		if (!tmpEl)
		{
			throw new Error('Pict-Modal-Shell.shell: viewport not found for ' + pViewportSelectorOrEl);
		}
		let tmpExisting = this._shellsByViewport.get(tmpEl);
		if (tmpExisting) return tmpExisting;
		let tmpShell = new PictModalShell(this._modal, tmpEl, pOptions);
		this._shellsByViewport.set(tmpEl, tmpShell);
		return tmpShell;
	}
}

module.exports = PictModalShellManager;
module.exports.PictModalShell = PictModalShell;
module.exports.ShellPanel = ShellPanel;
module.exports.STORAGE_PREFIX = STORAGE_PREFIX;
module.exports.SCHEMA_VERSION = SCHEMA_VERSION;

},{}],686:[function(require,module,exports){
/**
 * Pict-Modal-Toast
 *
 * Manages toast notification elements with auto-dismiss and stacking.
 */
class PictModalToast
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._containers = {};
	}

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message text
	 * @param {object} [pOptions] - Options (type, duration, position, dismissible, allowHTML)
	 * @param {boolean} [pOptions.allowHTML=false] - When true, render pMessage as raw HTML instead of escaping it. Only pass trusted markup.
	 * @returns {{ dismiss: function }} Handle with dismiss method
	 */
	toast(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultToastOptions, pOptions);
		let tmpContainer = this._getContainer(tmpOptions.position);
		let tmpId = this._modal._nextId();

		let tmpToast = document.createElement('div');
		tmpToast.className = 'pict-modal-toast pict-modal-toast--' + tmpOptions.type;
		tmpToast.id = 'pict-modal-toast-' + tmpId;

		// Escape by default; render raw markup only when the caller opts in with allowHTML (trusted content).
		let tmpMessageMarkup = (tmpOptions.allowHTML === true) ? pMessage : this._escapeHTML(pMessage);
		let tmpContent = '<span class="pict-modal-toast-message">' + tmpMessageMarkup + '</span>';

		if (tmpOptions.dismissible)
		{
			tmpContent += '<button class="pict-modal-toast-dismiss" aria-label="Dismiss">&times;</button>';
		}

		tmpToast.innerHTML = tmpContent;

		// Create handle
		let tmpDismissed = false;
		let tmpTimeoutHandle = null;

		let tmpDismiss = () =>
		{
			if (tmpDismissed)
			{
				return;
			}
			tmpDismissed = true;

			if (tmpTimeoutHandle)
			{
				clearTimeout(tmpTimeoutHandle);
			}

			// Exit animation
			tmpToast.classList.remove('pict-modal-visible');
			tmpToast.classList.add('pict-modal-toast-exit');

			// Remove from active list
			this._modal._activeToasts = this._modal._activeToasts.filter(
				(pEntry) => { return pEntry.element !== tmpToast; }
			);

			// Remove from DOM after transition
			setTimeout(() =>
			{
				if (tmpToast.parentNode)
				{
					tmpToast.parentNode.removeChild(tmpToast);
				}
				this._cleanupContainer(tmpOptions.position);
			}, 220);
		};

		let tmpHandle = { dismiss: tmpDismiss };

		// Wire dismiss button
		if (tmpOptions.dismissible)
		{
			let tmpDismissBtn = tmpToast.querySelector('.pict-modal-toast-dismiss');
			if (tmpDismissBtn)
			{
				tmpDismissBtn.addEventListener('click', tmpDismiss);
			}
		}

		// Append to container
		tmpContainer.appendChild(tmpToast);

		// Track
		let tmpEntry =
		{
			element: tmpToast,
			dismiss: tmpDismiss,
			handle: tmpHandle
		};
		this._modal._activeToasts.push(tmpEntry);

		// Animate in
		void tmpToast.offsetHeight;
		tmpToast.classList.add('pict-modal-visible');

		// Auto-dismiss
		if (tmpOptions.duration > 0)
		{
			tmpTimeoutHandle = setTimeout(tmpDismiss, tmpOptions.duration);
		}

		return tmpHandle;
	}

	/**
	 * Get or create a toast container for the given position.
	 *
	 * @param {string} pPosition - Position key (e.g. 'top-right')
	 * @returns {HTMLElement}
	 */
	_getContainer(pPosition)
	{
		if (this._containers[pPosition])
		{
			return this._containers[pPosition];
		}

		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-modal-toast-container pict-modal-toast-container--' + pPosition;
		document.body.appendChild(tmpContainer);
		this._containers[pPosition] = tmpContainer;

		return tmpContainer;
	}

	/**
	 * Remove a container if it has no more toasts.
	 *
	 * @param {string} pPosition
	 */
	_cleanupContainer(pPosition)
	{
		let tmpContainer = this._containers[pPosition];
		if (tmpContainer && tmpContainer.children.length === 0)
		{
			if (tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
			delete this._containers[pPosition];
		}
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissAll()
	{
		let tmpToasts = this._modal._activeToasts.slice();
		for (let i = 0; i < tmpToasts.length; i++)
		{
			tmpToasts[i].dismiss();
		}
	}

	/**
	 * Destroy all containers.
	 */
	destroy()
	{
		this.dismissAll();
		let tmpPositions = Object.keys(this._containers);
		for (let i = 0; i < tmpPositions.length; i++)
		{
			let tmpContainer = this._containers[tmpPositions[i]];
			if (tmpContainer && tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
		}
		this._containers = {};
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalToast;

},{}],687:[function(require,module,exports){
/**
 * Pict-Modal-Tooltip
 *
 * Manages simple text and rich HTML tooltips with positioning and auto-flip.
 */
class PictModalTooltip
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options (position, delay, maxWidth)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	tooltip(pElement, pText, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pText, false, tmpOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Attach a pinnable rich HTML tooltip to an element.
	 *
	 * Behaves like richTooltip() on hover/focus, but a click on the element
	 * toggles a pinned state: while pinned the tooltip stays open (it does not
	 * hide on mouseleave/focusout) and follows its anchor on scroll/resize.
	 * This is opt-in sugar over richTooltip() with `{ pinnable: true }` — the
	 * default tooltip()/richTooltip() behavior is unchanged.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive, startPinned, onPinChange)
	 * @returns {{ destroy: function, pin: function, unpin: function, isPinned: function }} Handle
	 */
	pinnableTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions, { pinnable: true });
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Internal: attach tooltip event listeners to an element.
	 *
	 * @param {HTMLElement} pElement
	 * @param {string} pContent
	 * @param {boolean} pIsHTML
	 * @param {object} pOptions
	 * @returns {{ destroy: function }}
	 */
	_attachTooltip(pElement, pContent, pIsHTML, pOptions)
	{
		let tmpTooltipElement = null;
		let tmpShowTimeout = null;
		let tmpHideTimeout = null;
		let tmpDestroyed = false;
		let tmpId = this._modal._nextId();

		// Pin state — only meaningful when pOptions.pinnable is set. A pinned
		// tooltip stays visible (transient hide is suppressed) and follows its
		// anchor on scroll/resize.
		let tmpPinned = false;

		let tmpShow = () =>
		{
			if (tmpDestroyed || tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement = document.createElement('div');
			tmpTooltipElement.className = 'pict-modal-tooltip pict-modal-tooltip--' + pOptions.position;
			tmpTooltipElement.id = 'pict-modal-tooltip-' + tmpId;
			tmpTooltipElement.setAttribute('role', 'tooltip');
			tmpTooltipElement.style.maxWidth = pOptions.maxWidth;

			if (pOptions.interactive)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-interactive');
			}

			// Optional consumer-supplied class(es) on the tooltip element, e.g.
			// to theme the bubble + arrow by overriding the --pict-modal-tooltip-*
			// custom properties for a specific tooltip.
			if (pOptions.className)
			{
				let tmpExtraClasses = String(pOptions.className).split(/\s+/);
				for (let i = 0; i < tmpExtraClasses.length; i++)
				{
					if (tmpExtraClasses[i])
					{
						tmpTooltipElement.classList.add(tmpExtraClasses[i]);
					}
				}
			}

			// Arrow
			let tmpArrow = document.createElement('div');
			tmpArrow.className = 'pict-modal-tooltip-arrow';

			// Content
			let tmpContentDiv = document.createElement('div');
			if (pIsHTML)
			{
				tmpContentDiv.innerHTML = pContent;
			}
			else
			{
				tmpContentDiv.textContent = pContent;
			}

			tmpTooltipElement.appendChild(tmpArrow);
			tmpTooltipElement.appendChild(tmpContentDiv);
			document.body.appendChild(tmpTooltipElement);

			// Set aria-describedby on target
			pElement.setAttribute('aria-describedby', tmpTooltipElement.id);

			// Position
			this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);

			// Animate in — but only paint when the anchor is actually rendered.
			// A pinned / startPinned tooltip whose anchor lives in a hidden
			// container (e.g. an inactive tab panel) would otherwise show at the
			// clamped corner as an orphan. It is revealed later by tmpReposition
			// once the anchor gains a layout box (see the ResizeObserver below).
			void tmpTooltipElement.offsetHeight;
			if (this._isElementRendered(pElement))
			{
				tmpTooltipElement.classList.add('pict-modal-visible');
			}

			// Track
			this._modal._activeTooltips.push(
			{
				element: tmpTooltipElement,
				targetElement: pElement,
				destroy: tmpDestroy
			});

			// For interactive tooltips, allow hovering over the tooltip itself
			if (pOptions.interactive && tmpTooltipElement)
			{
				tmpTooltipElement.addEventListener('mouseenter', () =>
				{
					if (tmpHideTimeout)
					{
						clearTimeout(tmpHideTimeout);
						tmpHideTimeout = null;
					}
				});
				tmpTooltipElement.addEventListener('mouseleave', () =>
				{
					if (!tmpPinned)
					{
						tmpHide();
					}
				});
			}

			// Reflect pinned state on a freshly-(re)created element.
			if (tmpPinned && tmpTooltipElement)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-pinned');
			}
		};

		let tmpHide = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement.classList.remove('pict-modal-visible');
			let tmpEl = tmpTooltipElement;
			tmpTooltipElement = null;

			// Remove aria
			pElement.removeAttribute('aria-describedby');

			// Remove from tracking
			this._modal._activeTooltips = this._modal._activeTooltips.filter(
				(pEntry) => { return pEntry.element !== tmpEl; }
			);

			setTimeout(() =>
			{
				if (tmpEl.parentNode)
				{
					tmpEl.parentNode.removeChild(tmpEl);
				}
			}, 220);
		};

		let tmpOnMouseEnter = () =>
		{
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
				tmpHideTimeout = null;
			}
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnMouseLeave = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// A pinned tooltip stays open regardless of pointer.
			if (tmpPinned)
			{
				return;
			}
			// Small delay before hiding to allow moving to interactive tooltip
			if (pOptions.interactive)
			{
				tmpHideTimeout = setTimeout(tmpHide, 100);
			}
			else
			{
				tmpHide();
			}
		};

		let tmpOnFocusIn = () =>
		{
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnFocusOut = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// A pinned tooltip stays open regardless of focus.
			if (tmpPinned)
			{
				return;
			}
			tmpHide();
		};

		// -- Pin lifecycle (opt-in via pOptions.pinnable) --

		// Keep a pinned tooltip glued to its anchor as the page scrolls/resizes.
		// The element is position:fixed and portaled to <body>, so it does not
		// move with the document on its own. When the anchor scrolls out of the
		// viewport we fade the tooltip out (without dropping the pin) and bring
		// it back when the anchor returns.
		let tmpResizeObserver = null;
		let tmpReposition = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}
			let tmpRect = pElement.getBoundingClientRect();
			// Rendered (has a layout box) AND within the viewport. A hidden anchor
			// (display:none, or inside a hidden tab panel) has no box, so the
			// tooltip is hidden rather than stranded at the clamped corner.
			let tmpInView = this._isElementRendered(pElement)
				&& (tmpRect.bottom > 0) && (tmpRect.top < window.innerHeight)
				&& (tmpRect.right > 0) && (tmpRect.left < window.innerWidth);
			if (tmpInView)
			{
				this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);
				tmpTooltipElement.classList.add('pict-modal-visible');
			}
			else
			{
				tmpTooltipElement.classList.remove('pict-modal-visible');
			}
		};

		let tmpAddRepositionListeners = () =>
		{
			// `true` (capture) so scrolls inside any nested container reposition too.
			window.addEventListener('scroll', tmpReposition, true);
			window.addEventListener('resize', tmpReposition);
			// A ResizeObserver on the anchor catches it being shown/hidden (e.g. a
			// tab panel toggling display) — transitions the window scroll/resize
			// listeners miss — so a pinned tooltip appears the moment its anchor
			// gains a layout box and hides again when it loses one.
			if (typeof ResizeObserver !== 'undefined')
			{
				tmpResizeObserver = new ResizeObserver(() => tmpReposition());
				tmpResizeObserver.observe(pElement);
			}
		};

		let tmpRemoveRepositionListeners = () =>
		{
			window.removeEventListener('scroll', tmpReposition, true);
			window.removeEventListener('resize', tmpReposition);
			if (tmpResizeObserver)
			{
				tmpResizeObserver.disconnect();
				tmpResizeObserver = null;
			}
		};

		let tmpPin = () =>
		{
			if (tmpPinned || tmpDestroyed)
			{
				return;
			}
			tmpPinned = true;
			if (!tmpTooltipElement)
			{
				tmpShow();
			}
			if (tmpTooltipElement)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-pinned');
			}
			tmpAddRepositionListeners();
			if (typeof pOptions.onPinChange === 'function')
			{
				pOptions.onPinChange(true, pElement);
			}
		};

		let tmpUnpin = () =>
		{
			if (!tmpPinned)
			{
				return;
			}
			tmpPinned = false;
			tmpRemoveRepositionListeners();
			if (tmpTooltipElement)
			{
				tmpTooltipElement.classList.remove('pict-modal-tooltip-pinned');
			}
			tmpHide();
			if (typeof pOptions.onPinChange === 'function')
			{
				pOptions.onPinChange(false, pElement);
			}
		};

		let tmpOnClick = (pEvent) =>
		{
			if (pEvent)
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
			}
			if (tmpPinned)
			{
				tmpUnpin();
			}
			else
			{
				tmpPin();
			}
		};

		// Attach listeners
		pElement.addEventListener('mouseenter', tmpOnMouseEnter);
		pElement.addEventListener('mouseleave', tmpOnMouseLeave);
		pElement.addEventListener('focusin', tmpOnFocusIn);
		pElement.addEventListener('focusout', tmpOnFocusOut);
		if (pOptions.pinnable)
		{
			pElement.addEventListener('click', tmpOnClick);
		}

		let tmpDestroy = () =>
		{
			if (tmpDestroyed)
			{
				return;
			}
			tmpDestroyed = true;

			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
			}
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
			}

			tmpRemoveRepositionListeners();
			tmpPinned = false;
			tmpHide();

			pElement.removeEventListener('mouseenter', tmpOnMouseEnter);
			pElement.removeEventListener('mouseleave', tmpOnMouseLeave);
			pElement.removeEventListener('focusin', tmpOnFocusIn);
			pElement.removeEventListener('focusout', tmpOnFocusOut);
			if (pOptions.pinnable)
			{
				pElement.removeEventListener('click', tmpOnClick);
			}
		};

		// Optionally render already-pinned (explicit consumer opt-in).
		if (pOptions.pinnable && pOptions.startPinned)
		{
			tmpPin();
		}

		return {
			destroy: tmpDestroy,
			pin: tmpPin,
			unpin: tmpUnpin,
			isPinned: () => { return tmpPinned; }
		};
	}

	/**
	 * Position a tooltip element relative to the target element.
	 * Flips direction if the tooltip would overflow the viewport.
	 *
	 * @param {HTMLElement} pTooltip
	 * @param {HTMLElement} pTarget
	 * @param {string} pPosition - 'top', 'bottom', 'left', 'right'
	 */
	_positionTooltip(pTooltip, pTarget, pPosition)
	{
		let tmpTargetRect = pTarget.getBoundingClientRect();
		let tmpTooltipRect = pTooltip.getBoundingClientRect();
		let tmpGap = 8;

		let tmpPosition = pPosition;

		// Flip if needed
		if (tmpPosition === 'top' && tmpTargetRect.top < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'bottom';
		}
		else if (tmpPosition === 'bottom' && (window.innerHeight - tmpTargetRect.bottom) < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'top';
		}
		else if (tmpPosition === 'left' && tmpTargetRect.left < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'right';
		}
		else if (tmpPosition === 'right' && (window.innerWidth - tmpTargetRect.right) < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'left';
		}

		// Update class for arrow direction
		pTooltip.className = pTooltip.className.replace(/pict-modal-tooltip--\w+/, 'pict-modal-tooltip--' + tmpPosition);

		let tmpTop = 0;
		let tmpLeft = 0;

		switch (tmpPosition)
		{
			case 'top':
				tmpTop = tmpTargetRect.top - tmpTooltipRect.height - tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'bottom':
				tmpTop = tmpTargetRect.bottom + tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'left':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.left - tmpTooltipRect.width - tmpGap;
				break;
			case 'right':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.right + tmpGap;
				break;
		}

		// Clamp to viewport
		tmpLeft = Math.max(4, Math.min(tmpLeft, window.innerWidth - tmpTooltipRect.width - 4));
		tmpTop = Math.max(4, Math.min(tmpTop, window.innerHeight - tmpTooltipRect.height - 4));

		pTooltip.style.top = tmpTop + 'px';
		pTooltip.style.left = tmpLeft + 'px';
	}

	/**
	 * Whether an element is currently rendered (has a layout box). Returns false
	 * for a display:none element or one inside a display:none ancestor (e.g. an
	 * inactive tab panel) — in which case a pinned tooltip should stay hidden
	 * until the anchor reappears.
	 *
	 * @param {HTMLElement} pElement
	 * @returns {boolean}
	 */
	_isElementRendered(pElement)
	{
		return !!(pElement && typeof pElement.getClientRects === 'function' && pElement.getClientRects().length > 0);
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissAll()
	{
		let tmpTooltips = this._modal._activeTooltips.slice();
		for (let i = 0; i < tmpTooltips.length; i++)
		{
			tmpTooltips[i].destroy();
		}
	}
}

module.exports = PictModalTooltip;

},{}],688:[function(require,module,exports){
/**
 * Pict-Modal-Window
 *
 * Builds custom floating modal windows with arbitrary content and buttons.
 */
class PictModalWindow
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options
	 * @param {string} [pOptions.title] - Dialog title
	 * @param {string} [pOptions.content] - HTML content for the body
	 * @param {Array} [pOptions.buttons] - Array of { Hash, Label, Style }
	 * @param {boolean} [pOptions.closeable] - Whether the close button and overlay dismiss are enabled
	 * @param {string} [pOptions.width] - CSS width value
	 * @param {boolean} [pOptions.unbounded] - If true, removes the default 90vh/90vw viewport cap. The dialog will grow with its content and may extend beyond the viewport.
	 * @param {function} [pOptions.onOpen] - Called after dialog is shown, receives dialog element
	 * @param {function} [pOptions.onClose] - Called after dialog is dismissed
	 * @returns {Promise<string|null>} Resolves with clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultModalOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions, fResolve);
			this._showDialog(tmpDialog, tmpOptions, fResolve);
		});
	}

	/**
	 * Build the modal dialog element.
	 *
	 * @param {object} pOptions
	 * @param {function} fResolve
	 * @returns {HTMLElement}
	 */
	_buildDialog(pOptions, fResolve)
	{
		let tmpId = this._modal._nextId();

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = pOptions.width;

		// Header
		let tmpHeaderHTML = '';
		if (pOptions.title || pOptions.closeable)
		{
			tmpHeaderHTML = '<div class="pict-modal-dialog-header">';
			tmpHeaderHTML += '<span class="pict-modal-dialog-title">' + this._escapeHTML(pOptions.title) + '</span>';
			if (pOptions.closeable)
			{
				tmpHeaderHTML += '<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>';
			}
			tmpHeaderHTML += '</div>';
		}

		// Body
		let tmpBodyHTML = '<div class="pict-modal-dialog-body">' + (pOptions.content || '') + '</div>';

		// Footer with buttons
		let tmpFooterHTML = '';
		if (pOptions.buttons && pOptions.buttons.length > 0)
		{
			tmpFooterHTML = '<div class="pict-modal-dialog-footer">';
			for (let i = 0; i < pOptions.buttons.length; i++)
			{
				let tmpButton = pOptions.buttons[i];
				let tmpBtnClass = 'pict-modal-btn';
				if (tmpButton.Style)
				{
					tmpBtnClass += ' pict-modal-btn--' + tmpButton.Style;
				}
				tmpFooterHTML += '<button class="' + tmpBtnClass + '" data-hash="' + this._escapeHTML(tmpButton.Hash) + '">' +
					this._escapeHTML(tmpButton.Label) + '</button>';
			}
			tmpFooterHTML += '</div>';
		}

		tmpDialog.innerHTML = tmpHeaderHTML + tmpBodyHTML + tmpFooterHTML;

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve, pOptions);
		};

		// Wire close button
		if (pOptions.closeable)
		{
			let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
			if (tmpCloseBtn)
			{
				tmpCloseBtn.addEventListener('click', () => { tmpDismiss(null); });
			}
		}

		// Wire action buttons
		let tmpActionButtons = tmpDialog.querySelectorAll('[data-hash]');
		for (let i = 0; i < tmpActionButtons.length; i++)
		{
			let tmpBtn = tmpActionButtons[i];
			tmpBtn.addEventListener('click', () =>
			{
				tmpDismiss(tmpBtn.getAttribute('data-hash'));
			});
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show the dialog: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {object} pOptions
	 * @param {function} fResolve
	 */
	_showDialog(pDialog, pOptions, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'window'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses && pOptions.closeable)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(null); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus first button or close button
		let tmpFocusTarget = pDialog.querySelector('.pict-modal-btn') || pDialog.querySelector('.pict-modal-dialog-close');
		if (tmpFocusTarget)
		{
			tmpFocusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape' && pOptions.closeable)
			{
				pDialog._dismiss(null);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);

		// onOpen callback
		if (typeof pOptions.onOpen === 'function')
		{
			pOptions.onOpen(pDialog);
		}
	}

	/**
	 * Dismiss the dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult
	 * @param {function} fResolve
	 * @param {object} pOptions
	 */
	_dismissDialog(pDialog, pResult, fResolve, pOptions)
	{
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		pDialog.classList.remove('pict-modal-visible');

		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		this._modal._overlay.hide();

		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		if (typeof pOptions.onClose === 'function')
		{
			pOptions.onClose(pResult);
		}

		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalWindow;

},{}],689:[function(require,module,exports){
module.exports = (
{
	"AutoInitialize": true,
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ViewIdentifier": "Pict-Section-Modal",

	"OverlayClickDismisses": true,

	"DefaultConfirmOptions":
	{
		"title": "Confirm",
		"confirmLabel": "OK",
		"cancelLabel": "Cancel",
		"dangerous": false,
		"unbounded": false
	},

	"DefaultDoubleConfirmOptions":
	{
		"title": "Are you sure?",
		"confirmLabel": "Confirm",
		"cancelLabel": "Cancel",
		"phrasePrompt": "Type \"{phrase}\" to confirm:",
		"confirmPhrase": "",
		"unbounded": false
	},

	"DefaultModalOptions":
	{
		"title": "",
		"content": "",
		"buttons": [],
		"closeable": true,
		"width": "480px",
		"unbounded": false
	},

	"DefaultTooltipOptions":
	{
		"position": "top",
		"delay": 200,
		"maxWidth": "300px",
		"interactive": false,
		"pinnable": false,
		"startPinned": false
	},

	"DefaultToastOptions":
	{
		"type": "info",
		"duration": 3000,
		"position": "top-right",
		"dismissible": true,
		"allowHTML": false
	},

	"DefaultPanelOptions":
	{
		"position": "right",
		"width": 340,
		"minWidth": 200,
		"maxWidth": 600,
		"collapsible": true,
		"collapsed": false,
		"persist": false,
		"persistKey": ""
	},

	"Templates": [],
	"Renderables": [],

	"CSS": /*css*/`
/* pict-section-modal */
.pict-modal-root
{
	/* Defaults are routed through pict-provider-theme tokens so apps
	   using the theme provider get themed modals automatically.  Each
	   var() carries its original hex as the fallback so apps that don't
	   install pict-provider-theme look exactly as before.  Apps may
	   still override any --pict-modal-* var directly to layer over the
	   theme-driven defaults. */

	/* Overlay */
	--pict-modal-overlay-bg: rgba(0, 0, 0, 0.5);

	/* Dialog */
	--pict-modal-bg:                  var(--theme-color-background-panel,  #ffffff);
	--pict-modal-fg:                  var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-border:              var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-border-radius:       8px;
	--pict-modal-shadow:              0 4px 24px rgba(0, 0, 0, 0.15);
	--pict-modal-header-bg:           var(--theme-color-background-secondary, #f5f5f5);
	--pict-modal-header-fg:           var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-header-border:       var(--theme-color-border-default,    #e0e0e0);

	/* Buttons */
	--pict-modal-btn-bg:              var(--theme-color-background-secondary, #e0e0e0);
	--pict-modal-btn-fg:              var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-btn-hover-bg:        var(--theme-color-background-hover,  #d0d0d0);
	--pict-modal-btn-primary-bg:      var(--theme-color-brand-primary,     #2563eb);
	--pict-modal-btn-primary-fg:      var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-primary-hover-bg:var(--theme-color-brand-primary-hover,#1d4ed8);
	--pict-modal-btn-danger-bg:       var(--theme-color-status-error,      #dc2626);
	--pict-modal-btn-danger-fg:       var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-danger-hover-bg: var(--theme-color-status-error,      #b91c1c);
	--pict-modal-btn-border-radius:   4px;

	/* Toast */
	--pict-modal-toast-bg:            var(--theme-color-background-panel,  #333333);
	--pict-modal-toast-fg:            var(--theme-color-text-primary,      #ffffff);
	--pict-modal-toast-success-bg:    var(--theme-color-status-success,    #16a34a);
	--pict-modal-toast-warning-bg:    var(--theme-color-status-warning,    #d97706);
	--pict-modal-toast-error-bg:      var(--theme-color-status-error,      #dc2626);
	--pict-modal-toast-info-bg:       var(--theme-color-status-info,       #2563eb);
	--pict-modal-toast-border-radius: 6px;
	--pict-modal-toast-shadow:        0 2px 12px rgba(0, 0, 0, 0.15);

	/* Tooltip */
	--pict-modal-tooltip-bg:          var(--theme-color-background-tertiary,#1a1a1a);
	--pict-modal-tooltip-fg:          var(--theme-color-text-primary,      #ffffff);
	--pict-modal-tooltip-border-radius:4px;
	--pict-modal-tooltip-shadow:      0 2px 8px rgba(0, 0, 0, 0.15);
	--pict-modal-tooltip-pinned-ring: var(--theme-color-brand-primary, #2E7D74);

	/* Dropdown */
	--pict-modal-dropdown-bg:                 var(--theme-color-background-panel,  #ffffff);
	--pict-modal-dropdown-fg:                 var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-border:             var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-dropdown-border-radius:      6px;
	--pict-modal-dropdown-shadow:             0 6px 18px rgba(0, 0, 0, 0.18);
	--pict-modal-dropdown-item-hover-bg:      var(--theme-color-background-hover,  rgba(37, 99, 235, 0.10));
	--pict-modal-dropdown-item-hover-fg:      var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-item-disabled-fg:   var(--theme-color-text-muted,        #9aa0a6);
	--pict-modal-dropdown-separator:          var(--theme-color-border-light,      #e8e8e8);
	--pict-modal-dropdown-header-fg:          var(--theme-color-text-secondary,    #6b7280);
	--pict-modal-dropdown-danger-fg:          var(--theme-color-status-error,      #dc2626);
	--pict-modal-dropdown-primary-fg:         var(--theme-color-brand-primary,     #2563eb);

	/* Typography */
	--pict-modal-font-family:         var(--theme-typography-family-sans,  system-ui, -apple-system, sans-serif);
	--pict-modal-font-size:           14px;
	--pict-modal-title-font-size:     16px;

	/* Animation */
	--pict-modal-transition-duration: 200ms;
}

/* Overlay */
.pict-modal-overlay
{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--pict-modal-overlay-bg);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
}

.pict-modal-overlay.pict-modal-visible
{
	opacity: 1;
}

/* Dialog */
.pict-modal-dialog
{
	position: fixed;
	z-index: 1010;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) translateY(-20px);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;

	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;

	background: var(--pict-modal-bg);
	color: var(--pict-modal-fg);
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-border-radius);
	box-shadow: var(--pict-modal-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
}

.pict-modal-dialog.pict-modal-visible
{
	opacity: 1;
	transform: translate(-50%, -50%) translateY(0);
}

/* Unbounded modifier — lets callers opt out of the 90vh/90vw viewport cap.
   Use with caution: content taller than the viewport will push buttons
   below the fold. */
.pict-modal-dialog.pict-modal-dialog--unbounded
{
	max-height: none;
	max-width: none;
}

.pict-modal-dialog-header
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: var(--pict-modal-header-bg);
	color: var(--pict-modal-header-fg);
	border-bottom: 1px solid var(--pict-modal-header-border);
	border-radius: var(--pict-modal-border-radius) var(--pict-modal-border-radius) 0 0;
}

.pict-modal-dialog-title
{
	font-size: var(--pict-modal-title-font-size);
	font-weight: 600;
}

.pict-modal-dialog-close
{
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--pict-modal-fg);
	padding: 0 4px;
	line-height: 1;
	opacity: 0.6;
}

.pict-modal-dialog-close:hover
{
	opacity: 1;
}

.pict-modal-dialog-body
{
	padding: 16px;
	overflow-y: auto;
	flex: 1;
}

.pict-modal-dialog-footer
{
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid var(--pict-modal-border);
}

/* Buttons */
.pict-modal-btn
{
	padding: 8px 16px;
	border: none;
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	cursor: pointer;
	background: var(--pict-modal-btn-bg);
	color: var(--pict-modal-btn-fg);
	transition: background var(--pict-modal-transition-duration) ease;
}

.pict-modal-btn:hover
{
	background: var(--pict-modal-btn-hover-bg);
}

.pict-modal-btn:disabled
{
	opacity: 0.5;
	cursor: not-allowed;
}

.pict-modal-btn--primary
{
	background: var(--pict-modal-btn-primary-bg);
	color: var(--pict-modal-btn-primary-fg);
}

.pict-modal-btn--primary:hover
{
	background: var(--pict-modal-btn-primary-hover-bg);
}

.pict-modal-btn--danger
{
	background: var(--pict-modal-btn-danger-bg);
	color: var(--pict-modal-btn-danger-fg);
}

.pict-modal-btn--danger:hover
{
	background: var(--pict-modal-btn-danger-hover-bg);
}

/* Double confirm input */
.pict-modal-confirm-input
{
	width: 100%;
	padding: 8px 12px;
	margin-top: 12px;
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	box-sizing: border-box;
}

.pict-modal-confirm-input:focus
{
	outline: 2px solid var(--pict-modal-btn-primary-bg);
	outline-offset: -1px;
}

.pict-modal-confirm-prompt
{
	margin-top: 12px;
	font-size: 13px;
	color: var(--pict-modal-fg);
	opacity: 0.7;
}

/* Toast container */
.pict-modal-toast-container
{
	position: fixed;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	gap: 8px;
	pointer-events: none;
	max-width: 400px;
}

.pict-modal-toast-container--top-right
{
	top: 16px;
	right: 16px;
}

.pict-modal-toast-container--top-left
{
	top: 16px;
	left: 16px;
}

.pict-modal-toast-container--bottom-right
{
	bottom: 16px;
	right: 16px;
}

.pict-modal-toast-container--bottom-left
{
	bottom: 16px;
	left: 16px;
}

.pict-modal-toast-container--top-center
{
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
}

.pict-modal-toast-container--bottom-center
{
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
}

/* Toast */
.pict-modal-toast
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: var(--pict-modal-toast-border-radius);
	box-shadow: var(--pict-modal-toast-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	background: var(--pict-modal-toast-bg);
	color: var(--pict-modal-toast-fg);
	pointer-events: auto;
	opacity: 0;
	transform: translateX(100%);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-toast.pict-modal-visible
{
	opacity: 1;
	transform: translateX(0);
}

.pict-modal-toast.pict-modal-toast-exit
{
	opacity: 0;
	transform: translateX(100%);
}

.pict-modal-toast--info
{
	background: var(--pict-modal-toast-info-bg);
}

.pict-modal-toast--success
{
	background: var(--pict-modal-toast-success-bg);
}

.pict-modal-toast--warning
{
	background: var(--pict-modal-toast-warning-bg);
}

.pict-modal-toast--error
{
	background: var(--pict-modal-toast-error-bg);
}

.pict-modal-toast-message
{
	flex: 1;
}

.pict-modal-toast-dismiss
{
	background: none;
	border: none;
	color: inherit;
	font-size: 18px;
	cursor: pointer;
	padding: 0 2px;
	line-height: 1;
	opacity: 0.7;
}

.pict-modal-toast-dismiss:hover
{
	opacity: 1;
}

/* Tooltip */
.pict-modal-tooltip
{
	position: fixed;
	z-index: 1020;
	padding: 6px 10px;
	border-radius: var(--pict-modal-tooltip-border-radius);
	box-shadow: var(--pict-modal-tooltip-shadow);
	background: var(--pict-modal-tooltip-bg);
	color: var(--pict-modal-tooltip-fg);
	font-family: var(--pict-modal-font-family);
	font-size: 13px;
	pointer-events: none;
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
	white-space: normal;
	word-wrap: break-word;
}

.pict-modal-tooltip.pict-modal-tooltip-interactive
{
	pointer-events: auto;
}

.pict-modal-tooltip.pict-modal-visible
{
	opacity: 1;
}

/* Pinned tooltips stay open and can be interacted with; a subtle ring
   distinguishes a pinned tooltip from a transient hover tooltip. */
.pict-modal-tooltip.pict-modal-tooltip-pinned
{
	pointer-events: auto;
	box-shadow: var(--pict-modal-tooltip-shadow), 0 0 0 1px var(--pict-modal-tooltip-pinned-ring);
}

.pict-modal-tooltip-arrow
{
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--pict-modal-tooltip-bg);
	transform: rotate(45deg);
}

.pict-modal-tooltip--top .pict-modal-tooltip-arrow
{
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow
{
	top: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--left .pict-modal-tooltip-arrow
{
	right: -4px;
	top: 50%;
	margin-top: -4px;
}

.pict-modal-tooltip--right .pict-modal-tooltip-arrow
{
	left: -4px;
	top: 50%;
	margin-top: -4px;
}

/* ── Dropdown ─────────────────────────────────────────────────────────
   Anchor-positioned menu (no overlay). Used for nav menus and
   "split button" addenda — see Pict-Modal-Dropdown.js.
*/
.pict-modal-dropdown
{
	position: fixed;
	z-index: 1025;
	min-width: 160px;
	max-width: 360px;
	max-height: 60vh;
	overflow-y: auto;
	background: var(--pict-modal-dropdown-bg);
	color: var(--pict-modal-dropdown-fg);
	border: 1px solid var(--pict-modal-dropdown-border);
	border-radius: var(--pict-modal-dropdown-border-radius);
	box-shadow: var(--pict-modal-dropdown-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	padding: 4px 0;
	opacity: 0;
	transform: translateY(-4px);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

/* Free-form content popovers keep the dropdown chrome (bg / border / shadow /
   flip / dismiss) but hand sizing + inner padding to the injected content, so a
   pre-rendered template menu or a wide rich card isn't boxed by the menu
   defaults. Cap width per-call via the maxWidth option. */
.pict-modal-dropdown.pict-modal-dropdown--content
{
	max-width: none;
	padding: 0;
}

.pict-modal-dropdown.pict-modal-dropdown--above { transform: translateY(4px); }

.pict-modal-dropdown.pict-modal-visible
{
	opacity: 1;
	transform: translateY(0);
}

.pict-modal-dropdown-item
{
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	cursor: pointer;
	user-select: none;
	color: inherit;
	outline: none;
}

.pict-modal-dropdown-item:hover,
.pict-modal-dropdown-item:focus
{
	background: var(--pict-modal-dropdown-item-hover-bg);
	color: var(--pict-modal-dropdown-item-hover-fg);
}

.pict-modal-dropdown-item--disabled
{
	cursor: not-allowed;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--disabled:hover,
.pict-modal-dropdown-item--disabled:focus
{
	background: transparent;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--primary { color: var(--pict-modal-dropdown-primary-fg); }
.pict-modal-dropdown-item--danger  { color: var(--pict-modal-dropdown-danger-fg); }

.pict-modal-dropdown-item-icon
{
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.pict-modal-dropdown-item-icon svg { width: 100%; height: 100%; display: block; }

.pict-modal-dropdown-item-label { flex: 1 1 auto; min-width: 0; }

.pict-modal-dropdown-item-hint
{
	flex: 0 0 auto;
	font-size: 11px;
	opacity: 0.6;
	margin-left: 12px;
}

.pict-modal-dropdown-separator
{
	height: 1px;
	background: var(--pict-modal-dropdown-separator);
	margin: 4px 0;
}

.pict-modal-dropdown-header
{
	padding: 6px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--pict-modal-dropdown-header-fg);
}

/* ── Resizable / Collapsible Panels ──────────────── */
.pict-panel
{
	position: relative;
	transition: width 0.2s ease;
	flex-shrink: 0;
	overflow: visible;
}
.pict-panel-collapsed
{
	width: 0 !important;
	min-width: 0 !important;
	overflow: visible;
}
.pict-panel-collapsed > *:not(.pict-panel-edge)
{
	display: none;
}

/* Edge container — zero-width flex sibling of the panel.
   Sits next to the panel in the flex layout; children
   use absolute positioning to overlap the panel boundary. */
.pict-panel-edge
{
	position: relative;
	width: 0;
	flex-shrink: 0;
	z-index: 50;
	overflow: visible;
}

/* Resize handle — thin strip on the panel boundary */
.pict-panel-resize
{
	position: absolute;
	top: 0;
	bottom: 0;
	width: 4px;
	cursor: col-resize;
	background: transparent;
	transition: background 0.15s, width 0.15s;
}
.pict-panel-edge-right .pict-panel-resize
{
	right: 0;
	border-right: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-edge-left .pict-panel-resize
{
	left: 0;
	border-left: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-resize:hover,
.pict-panel-edge:hover .pict-panel-resize
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 0.5;
}
.pict-panel-resize.dragging
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 1;
	transition: none;
}
.pict-panel-edge-collapsed .pict-panel-resize
{
	display: none;
}

/* Collapse tab — tucked sliver at rest, slides out on hover */
.pict-panel-tab
{
	position: absolute;
	top: 8px;
	width: 8px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: var(--pict-panel-border, #DDD6CA);
	border: 1px solid var(--pict-panel-border, #DDD6CA);
	cursor: pointer;
	color: var(--pict-panel-fg, #8A7F72);
	font-size: 10px;
	line-height: 1;
	opacity: 0.5;
	transition: opacity 0.25s, width 0.2s ease, height 0.2s ease, left 0.2s ease, right 0.2s ease, background 0.2s;
	z-index: 51;
}
.pict-panel-edge:hover .pict-panel-tab,
.pict-panel-tab:hover
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}
/* Right panel: tab to the left of the edge */
.pict-panel-edge-right .pict-panel-tab
{
	right: 0;
	border-right: none;
	border-radius: 4px 0 0 4px;
}
.pict-panel-edge-right:hover .pict-panel-tab,
.pict-panel-edge-right .pict-panel-tab:hover
{
	right: 0;
}
/* Left panel: tab to the right of the edge */
.pict-panel-edge-left .pict-panel-tab
{
	left: 0;
	border-left: none;
	border-radius: 0 4px 4px 0;
}
.pict-panel-edge-left:hover .pict-panel-tab,
.pict-panel-edge-left .pict-panel-tab:hover
{
	left: 0;
}
/* When collapsed — more visible */
.pict-panel-edge-collapsed .pict-panel-tab
{
	width: 10px;
	height: 28px;
	opacity: 0.6;
}
.pict-panel-edge-collapsed .pict-panel-tab:hover,
.pict-panel-edge-collapsed:hover .pict-panel-tab
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}

/* ───────────────────────────────────────────────────────────────────
 *  Pict-Modal-Shell — viewport-managing layout for top / right /
 *  bottom / left panels around a center.
 * ───────────────────────────────────────────────────────────────── */

.pict-modal-shell-host { display: block; height: 100%; min-height: 0; }
.pict-modal-shell
{
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	position: relative;
	color: var(--pict-modal-fg, var(--theme-color-text-primary, #1a1a1a));
	background: var(--theme-color-background-primary, transparent);
}
.pict-modal-shell-row { display: flex; min-width: 0; min-height: 0; }
/* "First added = at the edge" convention is held by reversing the
   flex-direction on the bottom row + right side. That way, for ALL
   four sides, calling addPanel() N times stacks panel #1 against
   the viewport edge, panel #2 just inside it, panel #3 further in,
   and so on. Without these reverses, top + left worked that way but
   bottom + right inverted (first-added at content side, last-added
   at edge), which surprised callers. */
.pict-modal-shell-row-top    { flex: 0 0 auto; flex-direction: column; }
.pict-modal-shell-row-bottom { flex: 0 0 auto; flex-direction: column-reverse; }
.pict-modal-shell-row-middle
{
	flex: 1 1 0;
	flex-direction: row;
	min-height: 0;
	position: relative;
}
.pict-modal-shell-side
{
	display: flex;
	flex: 0 0 auto;
	min-height: 0;
}
.pict-modal-shell-side-left  { flex-direction: row; }
.pict-modal-shell-side-right { flex-direction: row-reverse; }
.pict-modal-shell-center
{
	flex: 1 1 0;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
}
.pict-modal-shell-center-content
{
	min-height: 100%;
}
/* Center column gains this class when at least one Scope:'center'
   panel is added.  The center stops scrolling internally — that job
   moves to the content destination — and switches to a vertical flex
   so the destination and any inner panels stack cleanly. */
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel
{
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-center-content
{
	flex: 1 1 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-panel
{
	flex: 0 0 auto;
	width: 100%;
}

/* Panels — base */
.pict-modal-shell-panel
{
	/* How far the collapse-tab's panel-bg "merge bar" extends INTO
	   the panel past the tab's geometric edge. Painted via box-shadow
	   on the tab (no DOM impact), it masks any 1px theme border on an
	   inner element, content padding offset, or resize-handle hover
	   bleed in the strip between the tab's panel-facing edge and the
	   first real pixel of panel content. Consumers can bump this for
	   themes with thicker (2+px) inner borders. */
	--pict-modal-collapse-tab-merge: 2px;
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: inherit;
	min-width: 0;
	min-height: 0;
	transition: width 140ms ease, height 140ms ease;
}
.pict-modal-shell-panel-content
{
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
}
/* Fixed-mode panels are pure chrome (topbars, status rows). Their
   content should fit the configured Size exactly — never scroll. The
   1px border that .pict-modal-shell-panel-mode-fixed adds on the
   inner edge shaves 1px off the content's available height, which
   then triggers a sliver-scrollbar on any inner widget with
   min-height matching the panel Size. overflow:hidden here suppresses
   that without affecting resizable/collapsible panels (sidebars,
   drawers) where scrollable content is the whole point. */
.pict-modal-shell-panel-mode-fixed > .pict-modal-shell-panel-content
{
	overflow: hidden;
}
.pict-modal-shell-panel-content-inner
{
	min-height: 100%;
}
/* Panel boundary — fixed-mode panels get a hairline border for explicit
   demarcation. Collapsible / resizable panels DROP the boundary border
   (background contrast separates them from the center anyway) so the
   collapse tab can pull out cleanly without a hairline cutting across
   it. The host stylesheet still gets full control via the panel's own
   background. */
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-top    { border-bottom: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-bottom { border-top:    1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-left   { border-right:  1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-right  { border-left:   1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }

/* Resize handle — absolute on the inner edge of each panel. */
.pict-modal-shell-panel-resize-handle
{
	position: absolute;
	background: transparent;
	z-index: 5;
	transition: background-color 120ms ease;
}
/* Resize handle hover — use the active brand's mode-aware primary
   color (set by pict-section-theme's Brand provider as
   --brand-color-primary-mode) so the resize affordance picks up the
   app's wordmark color. Falls back to the theme's brand-primary
   token if no brand is registered. */
.pict-modal-shell-panel-resize-handle:hover
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.4;
}
.pict-modal-shell-panel-left   .pict-modal-shell-panel-resize-handle { right: -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-right  .pict-modal-shell-panel-resize-handle { left:  -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-top    .pict-modal-shell-panel-resize-handle { bottom:-3px; left: 0; right: 0; height: 6px; cursor: row-resize; }
.pict-modal-shell-panel-bottom .pict-modal-shell-panel-resize-handle { top:   -3px; left: 0; right: 0; height: 6px; cursor: row-resize; }

/* Collapse tab — slim sliver flush on the panel's OUTER boundary
   (where the resize handle sits), modelled on retold-content-system's
   sidebar tab. At rest it's a 6×28 px sliver; hover expands to
   18×36 px without overlapping the panel's own content. The tab is
   positioned with its center on the boundary so half pokes into the
   adjacent area — the only place we can safely take over without
   stepping on app UI inside the panel. Title text only renders in the
   collapsed state where there's room for it. */
.pict-modal-shell-panel-collapse-tab
{
	position: absolute;
	display: flex;            /* not inline-flex — avoids baseline alignment quirks */
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #d0d7de));
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: var(--theme-color-text-muted, #6b7280);
	font: inherit;
	font-size: 10px;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	cursor: pointer;
	z-index: 50;
	opacity: 0.55;
	padding: 0;
	box-sizing: border-box;
	line-height: 0;          /* keep child boxes from inflating around the rotated chevron */
	/* Geometry (width/height/right/left) is intentionally NOT animated.
	   Sliding the tab's outer edge inward on hover-out makes it look like
	   the tab is "sliding into" the panel content — weird visual.
	   Snapping the size change instead, and animating only the appearance
	   (opacity/color/shadow), gives a clean fade-in/out with no boundary
	   weirdness. */
	transition: opacity 160ms ease,
	            background-color 160ms ease, color 160ms ease,
	            border-color 160ms ease, box-shadow 160ms ease;
}
/* Hover state pulls accent color from the active brand (mode-aware,
   so it's legible in both light + dark) with theme brand-primary as
   fallback. The whole point of brand colors is that they show up
   across the app's chrome. */
.pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab
{
	opacity: 1;
	color:        var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Drop shadow casts AWAY from the panel so the tab feels pulled out
   (extension of the panel) rather than floating across the boundary.
   The tab itself is now positioned fully OUTSIDE the panel boundary
   (see the per-side rules below), so we don't need a merge-bar shadow
   to mask any in-panel overlap — only the drop shadow remains. */
.pict-modal-shell-panel-left:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left    > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-right:hover   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right   > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: -3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-top:hover     > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top     > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-bottom:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom  > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.18);
}

/* Per-side base positioning — the tab lives entirely OUTSIDE the
   panel's outer boundary.  Its panel-facing edge touches the boundary
   (offset = -tabThickness) and the rest of the tab pokes out into the
   adjacent area (center / sibling panel).  Border on the panel-facing
   edge is dropped so the tab looks attached to the panel rather than
   floating beside it.
   Why fully-outside?  Earlier iterations had the tab straddling the
   boundary (1px inside + 4px outside) with a panel-bg-colored merge-bar
   masking the in-panel half — that worked geometrically but visually
   read as "tab pinned into the panel," and any rendering inside the
   panel (especially custom borders or hover bleeds) could clip against
   the in-panel half.  Fully-external positioning eliminates the overlap
   class of bugs and lets the tab live entirely in the adjacent area
   where there's no app content to step on. */
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab
{
	right: -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 0 4px 4px 0;
	border-left: 0;
}
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab
{
	left:  -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 4px 0 0 4px;
	border-right: 0;
}
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab
{
	bottom: -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 0 0 4px 4px;
	border-top: 0;
}
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab
{
	top:    -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 4px 4px 0 0;
	border-bottom: 0;
}

/* Hover: tab grows OUTWARD into the adjacent area.  The panel-facing
   edge stays glued to the boundary (offset = -tabThickness), so the
   tab still looks attached on hover — only its outer dimension grows.
   For side panels the height also grows (28 → 36) downward; for top
   /bottom panels the width grows (28 → 36) — see the next block for
   the perpendicular-axis offsets. */
.pict-modal-shell-panel-left:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; right: -18px;
}
.pict-modal-shell-panel-right:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; left: -18px;
}
.pict-modal-shell-panel-top:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; bottom: -18px;
}
.pict-modal-shell-panel-bottom:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; top: -18px;
}

.pict-modal-shell-panel-collapse-tab-title { display: none; white-space: nowrap; }

/* Auto-generated chevron glyph inside the tab — only visible once the
   tab is wide / tall enough to show it (i.e. hover state, or when the
   panel is collapsed). Direction follows side + state.
   Sized 5×5 (down from 6) so even with rotation the visual stays
   well clear of the tab's overflow:hidden bounds at 18×36 hover and
   the 24px collapsed tab strip width. flex-shrink:0 ensures the
   pseudo never collapses to zero in tight tab dimensions. */
.pict-modal-shell-panel-collapse-tab::before
{
	content: '';
	display: block;
	width: 5px; height: 5px;
	flex-shrink: 0;
	opacity: 0;
	border-right: 1.5px solid currentColor;
	border-bottom: 1.5px solid currentColor;
	transform: rotate(135deg);
	transform-origin: center center;
	transition: opacity 160ms ease, transform 160ms ease;
}
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab::before,
.pict-modal-shell-panel-collapse-tab:hover::before,
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	opacity: 1;
}
.pict-modal-shell-panel-right                                       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-top                                         > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }
.pict-modal-shell-panel-bottom                                      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(135deg); }
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed        > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed     > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }

/* Collapsed state — content disappears, only the collapse tab remains. */
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-content
{
	display: none;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed
{
	/* When collapsed, side panels rotate the title for vertical reading. */
	overflow: hidden;
}
/* When collapsed: the entire panel becomes the tab strip — full width
   for sides, full height for top/bottom — with the title visible
   vertically (sides) or horizontally (top/bottom). The little sliver
   tab on the boundary disappears (we don't need it anymore — clicking
   anywhere on the panel toggles it back open). */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed
{
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	/* Promote the tab to FILL the collapsed panel (not just hug its
	   content) so the centered chevron + title group sits in the middle
	   of the panel. Without explicit width/height: 100%, the position:
	   absolute element shrinks to its natural content size and the
	   group ends up flush at the top of the panel — where the chevron
	   gets clipped by the topbar. */
	position: absolute !important;
	top: 0 !important; right: 0 !important; bottom: 0 !important; left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	border: 0;
	border-radius: 0;
	background: transparent;
	opacity: 0.85;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 4px;        /* keeps chevron + title clear of edges */
	box-shadow: none;
	color: var(--theme-color-text-muted, #6b7280);
	box-sizing: border-box;
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	background: var(--theme-color-background-hover, var(--pict-modal-bg, #fff));
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: none;
}
/* Side panels (collapsed): rotate the title for vertical reading. */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed  > .pict-modal-shell-panel-collapse-tab
{
	writing-mode: vertical-rl;
	text-orientation: mixed;
}
.pict-modal-shell-panel-collapsed .pict-modal-shell-panel-collapse-tab-title
{
	display: inline;
}

/* Hidden panels — when Hidden:true is passed to addPanel, the collapsed
   state has zero footprint: no collapse tab (the tab is never built),
   the panel root is display:none, and the resize handle vanishes. The
   only path to the open state is a programmatic expand()/toggle() from
   somewhere else in the app (e.g. a topbar gear button). When expanded,
   the panel renders normally — so resize/drag handles continue to work
   while the panel is open. */
.pict-modal-shell-panel-hidden.pict-modal-shell-panel-collapsed
{
	display: none !important;
}

/* Overlay panels — float over the middle row instead of taking layout
   space. The overlay layer is positioned absolutely inside the middle
   row; individual overlay panels stack with positive z-index. */
.pict-modal-shell-overlay-layer
{
	position: absolute;
	inset: 0;
	pointer-events: none;
	z-index: 10;
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel
{
	pointer-events: auto;
	position: absolute;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-left   { left:   0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-right  { right:  0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-top    { top:    0; left: 0; right: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-bottom { bottom: 0; left: 0; right: 0; }

/* ─────────────────────────────────────────────────────────────────
   Responsive drawer mode — .pict-modal-shell-drawer-active toggles
   onto the middle row when any panel with ResponsiveDrawer crosses
   below its breakpoint. Flips the row's flex-direction from row to
   column, stacking side panels above the center and stretching them
   to full width. Each opted-in panel itself gets the
   .pict-modal-shell-panel-drawer class so per-panel rules below
   target only the drawer-mode panels (right + non-drawer panels in
   the same row are unaffected). The drawer height is read from a
   per-panel --pict-modal-drawer-height CSS variable (default
   33vh, set in JS from the DrawerHeight option).
   ───────────────────────────────────────────────────────────────── */
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active
{
	flex-direction: column;
	/* The drawer tab lives outside the drawer's bottom edge — ancestor
	   chain MUST allow it to escape clip. */
	overflow: visible;
}
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active .pict-modal-shell-side
{
	/* Side stacks stretch full-width and lay out their panels as a
	   horizontal row of stacked drawers (so two drawers from the same
	   side don't end up overlapping). overflow: visible so the
	   per-panel tab can extend below the side stack into the workspace. */
	width: 100% !important;
	flex-direction: column;
	overflow: visible;
}
/* The drawer-tagged panel itself: kill the inline width set by
   _applySize (we override with !important since the inline style has
   higher specificity than a class selector), then size by height
   from the CSS variable. Resize handle is hidden in drawer mode
   because horizontal dragging doesn't translate to vertical sizing
   and the user already has the collapse tab to dismiss / restore.

   padding-bottom reserves an 18px strip at the bottom of the panel
   for the tab. The tab sits INSIDE the drawer's footprint — never
   below it — so the workspace header below the drawer is never in
   the same vertical band as the tab. (Previously the tab hung
   below the drawer's bottom edge into the workspace's top padding;
   that made the tab visually compete with the workspace header,
   even when the tab box-model bounds technically cleared the
   header.) box-sizing: border-box so the padding eats from the
   33vh, not adding to it. */
.pict-modal-shell-panel-drawer
{
	width: 100% !important;
	max-width: 100% !important;
	height: var(--pict-modal-drawer-height, 33vh);
	transition: height 140ms ease;
	padding-bottom: 18px;
	box-sizing: border-box;
	overflow: visible !important;
	/* Clip the panel bg to its CONTENT area only — the 18px
	   padding-bottom reserve (where the tab lives) becomes
	   transparent, so the middle row's primary background shows
	   through. Without this the reserve would render with the
	   panel's chrome bg, creating a visible "strip" between the
	   drawer content above and the workspace below — the tab would
	   look like it's sitting on its own miscoloured band rather
	   than at the seam between drawer and workspace. */
	background-clip: content-box;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed
{
	/* Collapsed = "just the tab strip is visible". 18px matches the
	   panel's tab reserve so the height is consistent across states.
	   When this is 0 the tab would have nowhere to render and the
	   user couldn't reopen the drawer. */
	height: 18px !important;
	padding-bottom: 0 !important;
	/* Drop the panel's bg in collapsed state — without this the 18px
	   strip shows the --pict-modal-bg (panel chrome) which doesn't
	   match the workspace --theme-color-background-primary below it,
	   creating a visible "drawer band" around the tab that breaks the
	   illusion of the tab belonging to the workspace area. With
	   transparent bg the middle row's primary background shows
	   through, the strip blends with the workspace, and the tab pill
	   reads as a free-floating handle. */
	background: transparent !important;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
/* The drawer's collapse tab is a horizontal pill protruding from the
   bottom of the drawer (rather than the inner edge of a side panel).
   Override the side-panel positioning rules from above so the tab
   always sits at the drawer's bottom-center seam, in both expanded
   and collapsed states. The expand-from-zero affordance: when
   collapsed (height: 0), the tab still hangs below "where the
   drawer would be" — a small handle the user can click to pull
   the drawer back down. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	position: absolute !important;
	/* Anchored to the panel's BOTTOM edge — the tab lives INSIDE the
	   drawer's footprint (in the 18px reserve at the bottom), never
	   below it into the workspace. This means the workspace below
	   the drawer is never sharing a vertical band with the tab, so
	   the workspace header doesn't optically compete with it.
	   bottom: 4px aligns the tab's top edge exactly with the panel's
	   CONTENT-AREA bottom (panel.height − padding-bottom 18px). With
	   border-top: 0 on the tab, the seam between the drawer content
	   above and the tab body is invisible — they share --pict-modal-bg
	   and merge into one shape, the tab reading as a labelled
	   extension of the drawer hanging downward. Collapsed state
	   keeps the smaller offset (overridden below) because its panel
	   has no padding-bottom, so the math doesn't apply. */
	top: auto !important;
	bottom: 4px !important;
	left: 50% !important;
	right: auto !important;
	transform: translate(-50%, 0) !important;
	width: 64px !important;
	height: 14px !important;
	/* CRITICAL: border-box + padding: 0 — the collapsed-state base
	   rule inherits "padding: 12px 4px" (so the chevron clears the
	   edges of a tab that fills a 24px-wide side strip). In drawer
	   mode the tab is a 14px tall pill, NOT a strip-fill, so that
	   12px vertical padding would balloon the tab's outer height to
	   ~38px and crash into the workspace header text. The chevron
	   is centered via flex anyway. */
	box-sizing: border-box !important;
	padding: 0 !important;
	/* Rounded BOTTOM corners + no top border — the tab looks like a
	   traditional drawer-handle/tab hanging from above. Its rounded
	   bottom curves face the workspace (the "open downward" affordance
	   for a top drawer). border-top: 0 lets the tab visually merge
	   with whatever's directly above it inside the panel (sidebar
	   content when expanded, the panel background when collapsed). */
	border-radius: 0 0 8px 8px;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #cfd5dd));
	border-top: 0;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #fff));
	opacity: 0.95;
	z-index: 20;
	/* The default side-panel hover-grow values would yank the tab off
	   to the wrong spot in drawer mode — neutralise. */
	display: flex;
	align-items: center;
	justify-content: center;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	opacity: 1;
	width: 96px !important;
	/* height stays at 14px — the tab is anchored with bottom, so any
	   height growth would push the tab's TOP edge UPWARD past the
	   space available above it. In EXPANDED state that crashes into
	   the drawer content above; in COLLAPSED state it crashes into
	   the topbar's brand stripes. Width-only growth (64 to 96, +50%)
	   still gives the "tab is reaching toward me" affordance without
	   the encroachment. */
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
/* Collapsed-state bottom-offset override. Expanded panels have an
   18px padding-bottom reserve, and "bottom: 4px" anchors the tab's
   top edge exactly at the content-area boundary (so it merges
   visually with the drawer above). Collapsed panels have
   padding-bottom: 0 and a total height of 18px — "bottom: 4px"
   there would put the tab's top at the panel's actual top edge,
   crashing the (border-top: 0) tab into the topbar. The smaller
   "bottom: 2px" keeps the 14px tab vertically centered in the 18px
   strip with 2px margins on either side. */
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	bottom: 2px !important;
}
/* Chevron inside the tab: point UP when expanded (the drawer
   collapses UP / out of view, so the arrow indicates "click me to
   send the drawer up"), DOWN when collapsed (the drawer expands DOWN
   into view). Rotations come from the existing top-panel chevron
   table: rotate(-135deg) → UP arrow, rotate(45deg) → DOWN arrow. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(-135deg) !important;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(45deg) !important;
}
/* The collapse tab's existing title-text span is hidden when reduced
   to a pill — there's no horizontal room. The chevron alone reads
   correctly. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-title,
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-icon
{
	display: none;
}

/* Drag-active state — disable text selection + change cursor globally
   so resize feels solid even when the cursor briefly leaves the handle. */
.pict-modal-shell-dragging-x, .pict-modal-shell-dragging-y { user-select: none; }
.pict-modal-shell-dragging-x * { cursor: col-resize !important; }
.pict-modal-shell-dragging-y * { cursor: row-resize !important; }

/* Per-panel resize-active state — kills the panel's collapse/expand
   width/height transition for the duration of a drag. Without this,
   every pointermove starts a fresh 140 ms transition and the resize
   visibly lags behind the cursor ("choppy"). With it disabled the
   panel snaps to the new size on the same frame as the pointer, which
   feels native. */
.pict-modal-shell-panel-resizing { transition: none !important; }
.pict-modal-shell-panel-resizing > .pict-modal-shell-panel-resize-handle
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.5;
}

/* Panel popup-attention flash — fires when popup() is called on an
   already-open panel. Brief brand-colored inset glow so the user sees
   that their click landed even though the panel didn't change shape.
   Class is added by the shell, auto-removed after ~700 ms. */
@keyframes pict-modal-shell-panel-flash
{
	0%   { box-shadow: inset 0 0 0 0 transparent; }
	30%  { box-shadow: inset 0 0 0 3px var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)); }
	100% { box-shadow: inset 0 0 0 0 transparent; }
}
.pict-modal-shell-panel-flash
{
	animation: pict-modal-shell-panel-flash 600ms ease-out;
}
`
});

},{}],690:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictModalOverlay = require('./Pict-Modal-Overlay.js');
const libPictModalConfirm = require('./Pict-Modal-Confirm.js');
const libPictModalWindow = require('./Pict-Modal-Window.js');
const libPictModalToast = require('./Pict-Modal-Toast.js');
const libPictModalTooltip = require('./Pict-Modal-Tooltip.js');
const libPictModalPanel = require('./Pict-Modal-Panel.js');
const libPictModalDropdown = require('./Pict-Modal-Dropdown.js');
const libPictModalShell = require('./Pict-Modal-Shell.js');

const _DefaultConfiguration = require('./Pict-Section-Modal-DefaultConfiguration.js');

class PictSectionModal extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this._activeModals = [];
		this._activeTooltips = [];
		this._activeToasts = [];
		this._idCounter = 0;

		this._overlay = new libPictModalOverlay(this);
		this._confirm = new libPictModalConfirm(this);
		this._window = new libPictModalWindow(this);
		this._toast = new libPictModalToast(this);
		this._tooltip = new libPictModalTooltip(this);
		this._panel = new libPictModalPanel(this);
		this._dropdown = new libPictModalDropdown(this);
		this._shell = new libPictModalShell(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Ensure the root class is on the body for CSS variable scoping
		if (typeof document !== 'undefined' && document.body)
		{
			if (!document.body.classList.contains('pict-modal-root'))
			{
				document.body.classList.add('pict-modal-root');
			}
		}

		return super.onBeforeInitialize();
	}

	/**
	 * Generate a unique ID for DOM elements.
	 *
	 * @returns {number}
	 */
	_nextId()
	{
		this._idCounter++;
		return this._idCounter;
	}

	// -- Confirm API --

	/**
	 * Show a confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmLabel, cancelLabel, dangerous }
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		return this._confirm.confirm(pMessage, pOptions);
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is set, the user must type it to enable the confirm button.
	 * If no confirmPhrase, the first click changes the button text and the second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel }
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		return this._confirm.doubleConfirm(pMessage, pOptions);
	}

	// -- Modal Window API --

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options { title, content, buttons, closeable, width, onOpen, onClose }
	 * @returns {Promise<string|null>} Resolves with the clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		return this._window.show(pOptions);
	}

	// -- Tooltip API --

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options { position, delay, maxWidth }
	 * @returns {{ destroy: function }}
	 */
	tooltip(pElement, pText, pOptions)
	{
		return this._tooltip.tooltip(pElement, pText, pOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive }
	 * @returns {{ destroy: function }}
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.richTooltip(pElement, pHTMLContent, pOptions);
	}

	/**
	 * Attach a pinnable rich HTML tooltip to an element. Hover/focus behaves
	 * like richTooltip(); a click on the element toggles a pinned state that
	 * keeps the tooltip open and follows the anchor on scroll/resize.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive, startPinned, onPinChange }
	 * @returns {{ destroy: function, pin: function, unpin: function, isPinned: function }}
	 */
	pinnableTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.pinnableTooltip(pElement, pHTMLContent, pOptions);
	}

	// -- Toast API --

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message
	 * @param {object} [pOptions] - Options { type, duration, position, dismissible }
	 * @returns {{ dismiss: function }}
	 */
	toast(pMessage, pOptions)
	{
		return this._toast.toast(pMessage, pOptions);
	}

	// -- Dropdown API --

	/**
	 * Open an anchor-positioned dropdown menu (no backdrop, click-outside
	 * dismisses). Useful for nav menus and split-button addenda. Pass
	 * `ContentHTML` instead of `items` to render a free-form anchored popover
	 * (rich card, pre-rendered template menu) with the same dismiss/flip behavior.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   { left, top, width, height } rect for context-menu style anchoring.
	 * @param {object} pOptions - { items | ContentHTML, align, position, minWidth,
	 *   maxWidth, maxHeight, className, closeOnSelect, onSelect, onClose }
	 * @returns {Promise<{Hash, Item}|null>} Selection or null on dismiss
	 *   (always resolves null in ContentHTML mode).
	 */
	dropdown(pAnchor, pOptions)
	{
		return this._dropdown.dropdown(pAnchor, pOptions);
	}

	/**
	 * Dismiss any open dropdown.
	 */
	dismissDropdowns()
	{
		this._dropdown.dismissAll();
	}

	// -- Panel API --

	/**
	 * Attach resizable/collapsible panel behavior to a DOM element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Options { position, width, minWidth, maxWidth, collapsible, collapsed, persist, persistKey, onResize, onToggle }
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	panel(pTargetSelector, pOptions)
	{
		return this._panel.create(pTargetSelector, pOptions);
	}

	// -- Shell API --

	/**
	 * Get (or create) a layout shell for a viewport. Idempotent.
	 *
	 * The shell takes ownership of the viewport's contents and manages
	 * top / right / bottom / left panel placement plus a center area.
	 * See Pict-Modal-Shell.js for full panel-config semantics.
	 *
	 * @param {string|HTMLElement} pViewport - selector or element of the
	 *   container the shell should fill (commonly the app's root div).
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.Persistence=true]   - autosave panel state to localStorage
	 * @param {string}  [pOptions.PersistenceKey=null]- override scope (default: hostname)
	 * @returns {PictModalShell}
	 */
	shell(pViewport, pOptions)
	{
		return this._shell.shell(pViewport, pOptions);
	}

	// -- Cleanup API --

	/**
	 * Dismiss all open modals.
	 */
	dismissModals()
	{
		let tmpModals = this._activeModals.slice();
		for (let i = tmpModals.length - 1; i >= 0; i--)
		{
			tmpModals[i].dismiss(null);
		}
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissTooltips()
	{
		this._tooltip.dismissAll();
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissToasts()
	{
		this._toast.dismissAll();
	}

	/**
	 * Dismiss everything: modals, tooltips, and toasts.
	 */
	dismissAll()
	{
		this.dismissModals();
		this.dismissTooltips();
		this.dismissToasts();
		this.dismissDropdowns();
	}

	/**
	 * Clean up all DOM elements when the view is destroyed.
	 */
	/**
	 * Destroy all active panels.
	 */
	destroyPanels()
	{
		this._panel.destroyAll();
	}

	destroy()
	{
		this.dismissAll();
		this.destroyPanels();
		this._overlay.destroy();
		this._toast.destroy();
		if (typeof super.destroy === 'function') { return super.destroy(); }
	}
}

module.exports = PictSectionModal;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Modal-Confirm.js":681,"./Pict-Modal-Dropdown.js":682,"./Pict-Modal-Overlay.js":683,"./Pict-Modal-Panel.js":684,"./Pict-Modal-Shell.js":685,"./Pict-Modal-Toast.js":686,"./Pict-Modal-Tooltip.js":687,"./Pict-Modal-Window.js":688,"./Pict-Section-Modal-DefaultConfiguration.js":689,"pict-view":733}],691:[function(require,module,exports){
// The container for all the Pict-Section-Navigation related code.

// The navigation provider (primary API surface — holds the navigation graph and
// registers the render-type views).
const PictProviderNavigation = require('./providers/Pict-Provider-Navigation.js');

// The render-type views (also auto-registered by the provider).
const PictViewNavigationHub = require('./views/PictView-Navigation-Hub.js');
const PictViewNavigationSidebar = require('./views/PictView-Navigation-Sidebar.js');
const PictViewNavigationPalette = require('./views/PictView-Navigation-Palette.js');
const PictViewNavigationList = require('./views/PictView-Navigation-List.js');

module.exports = PictProviderNavigation;

module.exports.PictProviderNavigation = PictProviderNavigation;
module.exports.PictViewNavigationHub = PictViewNavigationHub;
module.exports.PictViewNavigationSidebar = PictViewNavigationSidebar;
module.exports.PictViewNavigationPalette = PictViewNavigationPalette;
module.exports.PictViewNavigationList = PictViewNavigationList;

},{"./providers/Pict-Provider-Navigation.js":692,"./views/PictView-Navigation-Hub.js":693,"./views/PictView-Navigation-List.js":694,"./views/PictView-Navigation-Palette.js":695,"./views/PictView-Navigation-Sidebar.js":696}],692:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libViewHub = require('../views/PictView-Navigation-Hub.js');
const libViewSidebar = require('../views/PictView-Navigation-Sidebar.js');
const libViewPalette = require('../views/PictView-Navigation-Palette.js');
const libViewList = require('../views/PictView-Navigation-List.js');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Navigation',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Where the navigation state lives in AppData (graph + transient query/active state).
	StateAddress: 'PictNavigation',

	// The navigation graph (a JSON tree of category/item nodes). May also be supplied
	// later via setNavigationGraph(). See the README for the node shape.
	NavigationGraph: [],

	// Optional host navigation handler: OnNavigate(pNode) is called when an item is
	// activated. When absent, navigate() falls back to setting window.location.hash for
	// hash-style routes.
	OnNavigate: null
};

/**
 * Navigation Provider
 *
 * Owns the navigation graph (a JSON tree of categories and items) and all the
 * search / filter / activate logic the render-type views share. Registers the
 * four render-type views (hub, sidebar, palette, list) so a single addProvider()
 * gives you everything; each view reads this provider by hash.
 */
class PictNavigationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		/** @type {Record<string, any>} */
		this.options;

		// Optional host navigation handler.
		this.onNavigate = (typeof this.options.OnNavigate === 'function') ? this.options.OnNavigate : null;

		// Initialize state (graph + transient query/active) in AppData.
		const tmpState = this._state();
		tmpState.Graph = this._normalizeNodes(Array.isArray(this.options.NavigationGraph) ? this.options.NavigationGraph : [], '');
		if (typeof tmpState.Query !== 'string') tmpState.Query = '';
		if (typeof tmpState.ShowAdvanced !== 'boolean') tmpState.ShowAdvanced = false;
		if (typeof tmpState.ActiveHash === 'undefined') tmpState.ActiveHash = null;

		// Register the render-type views (idempotent singletons).
		this.pict.addViewSingleton('Navigation-Hub', libViewHub.default_configuration, libViewHub);
		this.pict.addViewSingleton('Navigation-Sidebar', libViewSidebar.default_configuration, libViewSidebar);
		this.pict.addViewSingleton('Navigation-Palette', libViewPalette.default_configuration, libViewPalette);
		this.pict.addViewSingleton('Navigation-List', libViewList.default_configuration, libViewList);

		// A dedicated palette instance for the ⌘K launcher overlay — its own local query
		// (so quick-jumping never disturbs a docked sidebar) rendered into the overlay card.
		this.pict.addViewSingleton('Navigation-Launcher', Object.assign({}, libViewPalette.default_configuration,
			{
				ViewIdentifier: 'Navigation-Launcher',
				NavigationProviderHash: this.options.ProviderIdentifier,
				UseLocalQuery: true,
				ShowFooter: true,
				SearchPlaceholder: 'Jump to anywhere…  (type to search)',
				DefaultDestinationAddress: '#PictNavLauncher-Card',
				Renderables:
				[
					{ RenderableHash: 'Navigation-Palette-Wrap', TemplateHash: 'Navigation-Palette-Container', DestinationAddress: '#PictNavLauncher-Card', RenderType: 'replace' }
				]
			}), libViewPalette);

		// Launcher overlay state.
		this._launcherOpen = false;
		this._hotkeyBound = false;
		this._hotkeyUnbind = null;

		// Optional global item filter — a host gate (e.g. session visibility) applied to
		// EVERY render (lists, sidebar, launcher), on top of any per-call Scope/Filter.
		this._globalFilter = null;

		// Shared CSS for all render types (themeable via --theme-color-* with fallbacks).
		if (this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Navigation-Shared-CSS', PictNavigationProvider.SharedCSS, 500);
		}
	}

	// ── Render-type metadata ───────────────────────────────────────────────────

	/**
	 * The render types this provider can produce, in display order. Each entry is
	 * { Key, Label, Layout, Icon, Blurb }. Layout is 'page' (renders as a home screen)
	 * or 'rail' (a persistent docked sidebar). Hosts build their style chooser from this
	 * rather than hard-coding the list.
	 *
	 * @returns {Array<{Key:string, Label:string, Layout:string, Icon:string, Blurb:string}>}
	 */
	getRenderTypes()
	{
		return PictNavigationProvider.RenderTypes.map((pType) => Object.assign({}, pType));
	}

	/** 'page' (home screen) or 'rail' (persistent docked sidebar) for a render type. */
	getRenderTypeLayout(pRenderType)
	{
		const tmpType = PictNavigationProvider.RenderTypes.find((pType) => pType.Key === pRenderType);
		return tmpType ? tmpType.Layout : 'page';
	}

	/** True when the render type is a persistent docked sidebar rather than a home screen. */
	isRailRenderType(pRenderType)
	{
		return this.getRenderTypeLayout(pRenderType) === 'rail';
	}

	/** The navigation state object in AppData. */
	_state()
	{
		const tmpAddress = this.options.StateAddress || 'PictNavigation';
		if (!this.pict.AppData[tmpAddress] || typeof this.pict.AppData[tmpAddress] !== 'object')
		{
			this.pict.AppData[tmpAddress] = {};
		}
		return this.pict.AppData[tmpAddress];
	}

	// ── Graph ────────────────────────────────────────────────────────────────

	/**
	 * Replace the navigation graph. Accepts an array of category nodes; each node may
	 * carry { Hash, Name, Description, Blurb, Icon, Accent, Route, Keywords, Advanced,
	 * Secondary, Children }. The tree is normalized (every node gets a Hash; Children
	 * defaults to []).
	 *
	 * @param {Array<Object>} pGraph
	 */
	setNavigationGraph(pGraph)
	{
		this._state().Graph = this._normalizeNodes(Array.isArray(pGraph) ? pGraph : [], '');
		return this.getNavigationGraph();
	}

	/** @returns {Array<Object>} the normalized navigation graph. */
	getNavigationGraph()
	{
		return this._state().Graph || [];
	}

	_normalizeNodes(pNodes, pParentHash)
	{
		const tmpResult = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			const tmpNode = Object.assign({}, pNodes[i]);
			if (!tmpNode.Hash)
			{
				tmpNode.Hash = (pParentHash ? (pParentHash + '.') : '') + this.slugify(tmpNode.Name || ('node-' + i));
			}
			tmpNode.Children = this._normalizeNodes(Array.isArray(tmpNode.Children) ? tmpNode.Children : [], tmpNode.Hash);
			tmpNode.IsLeaf = (tmpNode.Children.length === 0);
			tmpResult.push(tmpNode);
		}
		return tmpResult;
	}

	slugify(pName)
	{
		return String(pName == null ? '' : pName).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
	}

	// ── Query / state ────────────────────────────────────────────────────────

	setQuery(pQuery) { this._state().Query = String(pQuery == null ? '' : pQuery); return this; }
	getQuery() { return this._state().Query || ''; }

	setShowAdvanced(pShow) { this._state().ShowAdvanced = !!pShow; return this; }
	getShowAdvanced() { return !!this._state().ShowAdvanced; }

	/**
	 * Set (or clear with null) a global item-visibility filter applied to every render —
	 * lists, the docked sidebar, and the launcher. A predicate (item, category) => boolean;
	 * items returning false are hidden everywhere. Use for session/role-based gating.
	 */
	setGlobalFilter(pFilter) { this._globalFilter = (typeof pFilter === 'function') ? pFilter : null; return this; }
	getGlobalFilter() { return this._globalFilter; }

	setActive(pHash) { this._state().ActiveHash = pHash || null; return this; }
	getActive() { return this._state().ActiveHash || null; }

	/** Find a node anywhere in the tree by Hash. */
	getNodeByHash(pHash)
	{
		let tmpFound = null;
		const fWalk = (pNodes) =>
		{
			for (let i = 0; i < pNodes.length && !tmpFound; i++)
			{
				if (pNodes[i].Hash === pHash) { tmpFound = pNodes[i]; return; }
				fWalk(pNodes[i].Children || []);
			}
		};
		fWalk(this.getNavigationGraph());
		return tmpFound;
	}

	/** Find a leaf node whose Route matches pRoute (leading '#' ignored on both sides). */
	getNodeByRoute(pRoute)
	{
		if (!pRoute) return null;
		const fNormalize = (pValue) => String(pValue == null ? '' : pValue).replace(/^#/, '');
		const tmpTarget = fNormalize(pRoute);
		if (!tmpTarget) return null;
		let tmpFound = null;
		const fWalk = (pNodes) =>
		{
			for (let i = 0; i < pNodes.length && !tmpFound; i++)
			{
				if (pNodes[i].Route && fNormalize(pNodes[i].Route) === tmpTarget) { tmpFound = pNodes[i]; return; }
				fWalk(pNodes[i].Children || []);
			}
		};
		fWalk(this.getNavigationGraph());
		return tmpFound;
	}

	/** Mark the node matching pRoute active (or clear active if none matches). Returns the node. */
	setActiveByRoute(pRoute)
	{
		const tmpNode = this.getNodeByRoute(pRoute);
		this.setActive(tmpNode ? tmpNode.Hash : null);
		return tmpNode;
	}

	// ── Search / filter ──────────────────────────────────────────────────────

	/** Every whitespace-separated token of the (lowercased) query must appear in the node's text. */
	matchesNode(pNode, pQuery)
	{
		if (!pQuery) return true;
		const tmpHay = ((pNode.Name || '') + ' ' + (pNode.Description || '') + ' ' + (pNode.Keywords || '')).toLowerCase();
		return pQuery.split(/\s+/).filter(Boolean).every((pTok) => tmpHay.indexOf(pTok) >= 0);
	}

	/** Does pNeedle begin a word in pHay (at the start, or after a non-alphanumeric)? Both already lowercased. */
	_hasWordStart(pHay, pNeedle)
	{
		if (!pNeedle) return false;
		let tmpFrom = 0;
		for (;;)
		{
			const tmpAt = pHay.indexOf(pNeedle, tmpFrom);
			if (tmpAt < 0) return false;
			if (tmpAt === 0 || /[^a-z0-9]/.test(pHay.charAt(tmpAt - 1))) return true;
			tmpFrom = tmpAt + 1;
		}
	}

	/**
	 * Relevance score for ranking search results (higher = better). A match in the TITLE (Name)
	 * ALWAYS outranks a match that is only in the Description/Keywords — the two live in separate
	 * bands (title band starts at 10000; the body band is capped below it), so the title-vs-body
	 * ordering can never be inverted by a long query racking up description hits. Within the title
	 * band, a tighter match scores higher — exact > prefix > word-start > substring — plus a
	 * coverage term (how much of the title the query spans) so e.g. "project" ranks the "Projects"
	 * screen above "Project Activity". pQuery is expected already trimmed + lowercased, as
	 * matchesNode receives it; callers should only score nodes that matchesNode() accepts.
	 *
	 * @param {Object} pNode - a leaf node ({ Name, Description, Keywords, ... })
	 * @param {string} pQuery - the trimmed, lowercased query
	 * @returns {number}
	 */
	scoreNode(pNode, pQuery)
	{
		if (!pQuery) return 0;
		const tmpName = String(pNode.Name == null ? '' : pNode.Name).toLowerCase();
		const tmpDesc = String(pNode.Description == null ? '' : pNode.Description).toLowerCase();
		const tmpKeys = String(pNode.Keywords == null ? '' : pNode.Keywords).toLowerCase();
		const tmpTokens = pQuery.split(/\s+/).filter(Boolean);

		// ── Title (Name) quality — 0 means no title hit ──
		let tmpTitle = 0;
		const tmpNameAt = tmpName.indexOf(pQuery);
		if (tmpName === pQuery) tmpTitle = 1000;                        // exact title
		else if (tmpNameAt === 0) tmpTitle = 600;                       // title starts with the whole query
		else if (this._hasWordStart(tmpName, pQuery)) tmpTitle = 420;   // query starts a word in the title
		else if (tmpNameAt >= 0) tmpTitle = 260;                        // query appears somewhere in the title
		if (tmpTitle > 0)
		{
			// Coverage: the more of the title the query spans, the more specific the match
			// ("project" covers most of "Projects" but little of "Project Activity").
			tmpTitle += Math.round((pQuery.length / Math.max(tmpName.length, 1)) * 200);
		}
		// Per-token title hits keep multi-word queries title-weighted.
		tmpTokens.forEach((pTok) =>
		{
			if (this._hasWordStart(tmpName, pTok)) tmpTitle += 90;
			else if (tmpName.indexOf(pTok) >= 0) tmpTitle += 55;
		});

		// ── Description + Keywords quality — bounded strictly below the title band ──
		let tmpBody = 0;
		if (tmpDesc.indexOf(pQuery) >= 0) tmpBody += 60;
		if (tmpKeys.indexOf(pQuery) >= 0) tmpBody += 40;
		tmpTokens.forEach((pTok) =>
		{
			if (tmpDesc.indexOf(pTok) >= 0) tmpBody += 18;
			if (tmpKeys.indexOf(pTok) >= 0) tmpBody += 10;
		});
		if (tmpBody > 900) tmpBody = 900;

		// Title band (>= 10000) always beats the body-only band (< 1000).
		return (tmpTitle > 0) ? (10000 + tmpTitle + tmpBody) : tmpBody;
	}

	/** Stable, relevance-descending sort of leaf nodes for a query (ties keep authored graph order). */
	_rankNodes(pNodes, pGetNode, pQuery)
	{
		if (!pQuery || !Array.isArray(pNodes) || pNodes.length < 2) return pNodes;
		return pNodes
			.map((pEntry, pIndex) => ({ Entry: pEntry, Score: this.scoreNode(pGetNode(pEntry), pQuery), Ordinal: pIndex }))
			.sort((pA, pB) => (pB.Score - pA.Score) || (pA.Ordinal - pB.Ordinal))
			.map((pWrapped) => pWrapped.Entry);
	}

	/**
	 * Categories (top-level nodes) with their leaf items filtered by the current — or
	 * supplied — query + showAdvanced. Advanced items are hidden while browsing but an
	 * active query reveals matching ones. Empty categories are dropped. This is the
	 * primary data source for the hub / sidebar / list views.
	 *
	 * Pass `Scope` (an array of category hashes) to pre-filter to a subset of the graph —
	 * the basis for topic / pre-filtered nav pages. Pass `Filter` (a predicate
	 * (item, category) => boolean) to gate individual items (e.g. session-based visibility).
	 *
	 * @param {{Query?: string, ShowAdvanced?: boolean, Scope?: Array<string>, Filter?: Function}} [pOptions]
	 * @returns {Array<Object>} [ { ...category, Items: [filtered children] } ]
	 */
	getFilteredCategories(pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpQuery = (typeof tmpOptions.Query === 'string' ? tmpOptions.Query : this.getQuery()).trim().toLowerCase();
		const tmpShowAdvanced = (typeof tmpOptions.ShowAdvanced === 'boolean') ? tmpOptions.ShowAdvanced : this.getShowAdvanced();
		const tmpScope = Array.isArray(tmpOptions.Scope) ? tmpOptions.Scope : null;
		const tmpFilter = (typeof tmpOptions.Filter === 'function') ? tmpOptions.Filter : null;
		const tmpGlobalFilter = this._globalFilter;

		const tmpResult = [];
		this.getNavigationGraph().forEach((pCategory) =>
		{
			if (tmpScope && tmpScope.indexOf(pCategory.Hash) < 0) return;
			let tmpItems = (pCategory.Children || []).filter((pItem) =>
				(!tmpGlobalFilter || tmpGlobalFilter(pItem, pCategory)) &&
				(!tmpFilter || tmpFilter(pItem, pCategory)) &&
				(tmpShowAdvanced || !pItem.Advanced || (tmpQuery && this.matchesNode(pItem, tmpQuery))) &&
				this.matchesNode(pItem, tmpQuery));
			if (tmpItems.length === 0) return;
			// When searching, rank items within the category (title before description); browsing keeps authored order.
			tmpItems = this._rankNodes(tmpItems, (pItem) => pItem, tmpQuery);
			tmpResult.push(Object.assign({}, pCategory, { Items: tmpItems }));
		});
		return tmpResult;
	}

	/**
	 * A flat, query-filtered list of leaf items across all categories (advanced included
	 * once a query is present). Used by the command-palette view.
	 *
	 * Pass `Scope` / `Filter` (same semantics as getFilteredCategories) to pre-filter.
	 *
	 * @param {string} [pQuery]
	 * @param {{Scope?: Array<string>, Filter?: Function}} [pOptions]
	 * @returns {Array<{Item: Object, Category: Object}>}
	 */
	searchFlat(pQuery, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpQuery = (typeof pQuery === 'string' ? pQuery : this.getQuery()).trim().toLowerCase();
		const tmpScope = Array.isArray(tmpOptions.Scope) ? tmpOptions.Scope : null;
		const tmpFilter = (typeof tmpOptions.Filter === 'function') ? tmpOptions.Filter : null;
		const tmpGlobalFilter = this._globalFilter;
		const tmpResult = [];
		this.getNavigationGraph().forEach((pCategory) =>
		{
			if (tmpScope && tmpScope.indexOf(pCategory.Hash) < 0) return;
			(pCategory.Children || []).forEach((pItem) =>
			{
				if (tmpGlobalFilter && !tmpGlobalFilter(pItem, pCategory)) return;
				if (tmpFilter && !tmpFilter(pItem, pCategory)) return;
				if (this.matchesNode(pItem, tmpQuery)) tmpResult.push({ Item: pItem, Category: pCategory });
			});
		});
		// Rank: title matches before description/keyword matches, tighter matches first (ties keep graph order).
		return this._rankNodes(tmpResult, (pEntry) => pEntry.Item, tmpQuery);
	}

	// ── Render helpers ───────────────────────────────────────────────────────

	escapeHTML(pStr)
	{
		return String(pStr == null ? '' : pStr).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	/** HTML-escape, then wrap query tokens in <mark> for match highlighting. */
	highlight(pText, pQuery)
	{
		let tmpOut = this.escapeHTML(pText);
		const tmpQuery = (pQuery || '').trim();
		if (!tmpQuery) return tmpOut;
		tmpQuery.split(/\s+/).filter(Boolean).forEach((pTok) =>
		{
			const tmpEsc = pTok.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			tmpOut = tmpOut.replace(new RegExp('(' + tmpEsc + ')', 'ig'), '<mark class="pict-nav-mark">$1</mark>');
		});
		return tmpOut;
	}

	// ── Navigation ───────────────────────────────────────────────────────────

	/**
	 * Activate a navigation node. Resolves a hash to its node, marks it active, then
	 * hands off to the host OnNavigate handler if one is configured; otherwise falls
	 * back to hash-route navigation for `Route` values that start with '#'.
	 *
	 * @param {Object|string} pNodeOrHash
	 */
	navigate(pNodeOrHash)
	{
		const tmpNode = (typeof pNodeOrHash === 'string') ? this.getNodeByHash(pNodeOrHash) : pNodeOrHash;
		if (!tmpNode)
		{
			this.log.warn(`PictNavigation.navigate: node not found for [${pNodeOrHash}].`);
			return;
		}
		this.setActive(tmpNode.Hash);
		this.log.info(`PictNavigation: navigate -> ${tmpNode.Name} (${tmpNode.Route || tmpNode.Hash})`);

		// A navigation always dismisses the launcher overlay if it was open.
		if (this.isLauncherOpen()) { this.closeLauncher(); }

		if (typeof this.onNavigate === 'function')
		{
			this.onNavigate(tmpNode);
			return;
		}
		if (typeof tmpNode.Route === 'string' && tmpNode.Route.charAt(0) === '#' && typeof window !== 'undefined' && window.location)
		{
			window.location.hash = tmpNode.Route.replace(/^#/, '');
		}
	}

	/**
	 * Convenience: point a render-type view at a destination and render it. pRenderType
	 * is 'Hub' | 'Sidebar' | 'Palette' | 'List' (the view hash suffix).
	 *
	 * Pass `pOptions.Scope` (category-hash array) / `pOptions.Filter` (item predicate) to
	 * render a pre-filtered subset. Both are always applied (defaulting to none) so a prior
	 * scoped render does not leak into an unscoped one on the same shared view.
	 *
	 * @param {string} pRenderType
	 * @param {string} [pDestinationAddress]
	 * @param {{Scope?: Array<string>, Filter?: Function}} [pOptions]
	 */
	render(pRenderType, pDestinationAddress, pOptions)
	{
		const tmpView = this.pict.views['Navigation-' + pRenderType];
		if (!tmpView)
		{
			this.log.warn(`PictNavigation.render: unknown render type [${pRenderType}].`);
			return null;
		}
		if (pDestinationAddress)
		{
			tmpView.options.DefaultDestinationAddress = pDestinationAddress;
			if (Array.isArray(tmpView.options.Renderables))
			{
				tmpView.options.Renderables.forEach((pRenderable) => { pRenderable.DestinationAddress = pDestinationAddress; });
			}
		}
		const tmpOptions = pOptions || {};
		tmpView.options.Scope = Array.isArray(tmpOptions.Scope) ? tmpOptions.Scope : null;
		tmpView.options.Filter = (typeof tmpOptions.Filter === 'function') ? tmpOptions.Filter : null;
		tmpView.render();
		return tmpView;
	}

	/**
	 * Render the Sidebar render type in DOCKED mode (rail only, no detail pane) into a
	 * destination — the persistent-application-sidebar form. Item clicks navigate the host.
	 * Returns the docked sidebar view (call .syncActive() on it after external navigations).
	 *
	 * @param {string} pDestinationAddress
	 */
	renderSidebarDocked(pDestinationAddress)
	{
		// A dedicated docked instance (ShowDetail false) distinct from the two-pane 'Navigation-Sidebar'.
		if (!this.pict.views['Navigation-Sidebar-Docked'])
		{
			this.pict.addViewSingleton('Navigation-Sidebar-Docked', Object.assign({}, libViewSidebar.default_configuration,
				{
					ViewIdentifier: 'Navigation-Sidebar-Docked',
					NavigationProviderHash: this.options.ProviderIdentifier,
					ShowDetail: false,
					DefaultDestinationAddress: pDestinationAddress || '#Navigation-Container',
					Renderables:
					[
						{ RenderableHash: 'Navigation-Sidebar-Wrap', TemplateHash: 'Navigation-Sidebar-Container', DestinationAddress: pDestinationAddress || '#Navigation-Container', RenderType: 'replace' }
					]
				}), libViewSidebar);
		}
		return this.render('Sidebar-Docked', pDestinationAddress);
	}

	// ── Command-palette launcher overlay ───────────────────────────────────────

	/** Ensure the body-level launcher overlay container exists (backdrop + centered card). */
	_ensureLauncherDOM()
	{
		if (typeof document === 'undefined') return;
		if (document.getElementById('PictNavLauncher')) return;
		// Body-level overlay chrome — a documented exception to the "no direct DOM" rule
		// (same category as a popover/tooltip; there is no renderable destination for it yet).
		const tmpContainer = document.createElement('div');
		tmpContainer.id = 'PictNavLauncher';
		tmpContainer.className = 'pict-nav-launcher';
		document.body.appendChild(tmpContainer);
		const tmpProviderRef = `_Pict.providers['${this.options.ProviderIdentifier}']`;
		this.pict.ContentAssignment.assignContent('#PictNavLauncher',
			`<div class="pict-nav-launcher-backdrop" onclick="${tmpProviderRef}.closeLauncher()"></div>` +
			`<div class="pict-nav-launcher-card" id="PictNavLauncher-Card" role="dialog" aria-modal="true" aria-label="Jump to"></div>`);
	}

	/** Open the command-palette launcher overlay (fresh, empty query) and focus its input. */
	openLauncher()
	{
		this._ensureLauncherDOM();
		const tmpView = this.pict.views['Navigation-Launcher'];
		if (tmpView)
		{
			tmpView._localQuery = '';
			tmpView.render();
		}
		this.pict.CSSMap.injectCSS();
		this.pict.ContentAssignment.addClass('#PictNavLauncher', 'is-open');
		this._launcherOpen = true;
		// Focus the search input on the next tick (after the overlay is painted/visible).
		const fFocus = () =>
		{
			const tmpInput = this.pict.ContentAssignment.getElement('#PictNavLauncher input');
			if (tmpInput && tmpInput[0] && typeof tmpInput[0].focus === 'function') { tmpInput[0].focus(); }
		};
		if (typeof setTimeout === 'function') { setTimeout(fFocus, 0); } else { fFocus(); }
		return this;
	}

	/** Hide the launcher overlay. */
	closeLauncher()
	{
		this.pict.ContentAssignment.removeClass('#PictNavLauncher', 'is-open');
		this._launcherOpen = false;
		return this;
	}

	toggleLauncher() { return this._launcherOpen ? this.closeLauncher() : this.openLauncher(); }

	isLauncherOpen() { return !!this._launcherOpen; }

	/**
	 * Install a single, safe global keydown handler for the launcher:
	 *   • Cmd/Ctrl+K  → toggle the launcher overlay (the Slack/Linear quick-switcher key)
	 *   • Escape      → close the launcher (only when it is open; otherwise left alone)
	 * Idempotent; returns an unbind function. This is a documented exception to the
	 * "no addEventListener" rule — a browser-level global shortcut has no inline equivalent.
	 *
	 * @returns {Function} unbind
	 */
	bindLauncherHotkey()
	{
		if (typeof document === 'undefined') { return () => {}; }
		if (this._hotkeyBound) { return this._hotkeyUnbind; }
		const fHandler = (pEvent) =>
		{
			if (!pEvent) return;
			const tmpKey = (pEvent.key || '').toLowerCase();
			if ((pEvent.metaKey || pEvent.ctrlKey) && !pEvent.altKey && tmpKey === 'k')
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				this.toggleLauncher();
				return;
			}
			if (tmpKey === 'escape' && this.isLauncherOpen())
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				this.closeLauncher();
			}
		};
		// Capture phase so we intercept before focused inputs (e.g. the palette's own keydown).
		document.addEventListener('keydown', fHandler, true);
		this._hotkeyBound = true;
		this._hotkeyUnbind = () =>
		{
			document.removeEventListener('keydown', fHandler, true);
			this._hotkeyBound = false;
			this._hotkeyUnbind = null;
		};
		this.log.info('PictNavigation: launcher hotkey bound (Cmd/Ctrl+K opens, Escape closes).');
		return this._hotkeyUnbind;
	}
}

/* The render types this section can produce, in display order. Layout 'page' renders
   as a home screen; 'rail' is a persistent docked sidebar. Hosts read this to build a
   navigation-style chooser without hard-coding the list. */
PictNavigationProvider.RenderTypes =
[
	{ Key: 'Sidebar', Label: 'Sidebar', Layout: 'rail', Icon: 'Menu', Blurb: 'A persistent docked rail on the left.' },
	{ Key: 'Hub', Label: 'Hub', Layout: 'page', Icon: 'Home', Blurb: 'Categorized cards — a settings home.' },
	{ Key: 'List', Label: 'List', Layout: 'page', Icon: 'More', Blurb: 'A scannable grouped list.' },
	{ Key: 'Palette', Label: 'Command Palette', Layout: 'page', Icon: 'Search', Blurb: 'A ⌘K-style search list.' }
];

/* Shared, themeable styling for every render type. Colors come from the pict theme
   tokens (--theme-color-*) with neutral fallbacks so the views look right with or
   without a theme provider. */
PictNavigationProvider.SharedCSS = /*css*/`
.pict-nav { color: var(--theme-color-text-primary, #1f2733); font-size: 14px; }
.pict-nav *, .pict-nav *::before, .pict-nav *::after { box-sizing: border-box; }
.pict-nav-mark { background: var(--theme-color-status-warning, #f2c94c); color: inherit; border-radius: 2px; padding: 0 1px; }

/* Search field */
.pict-nav-search { position: relative; }
.pict-nav-search input {
	width: 100%; font: inherit; font-size: 0.95rem; padding: 0.55rem 0.7rem 0.55rem 2.1rem;
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px;
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-search input:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 18%, transparent); }
.pict-nav-search .pict-nav-search-ic { position: absolute; left: 0.7rem; top: 50%; transform: translateY(-50%);
	color: var(--theme-color-text-muted, #6b7686); pointer-events: none; }

/* Advanced toggle — right-aligned under the search box, with a little top + right
   breathing room so "Show advanced" doesn't crowd the search box's right edge. */
.pict-nav-adv { display: flex; justify-content: flex-end; align-items: center; gap: 0.4rem; font-size: 0.8rem;
	color: var(--theme-color-text-secondary, #45505f); cursor: pointer; user-select: none;
	padding: 0.4rem 0.35rem 0 0; }

/* Icon chip */
.pict-nav-ic { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 38px; height: 38px; border-radius: 9px; background: var(--theme-color-background-tertiary, #eceef2); }

/* Empty state */
.pict-nav-empty { text-align: center; color: var(--theme-color-text-muted, #6b7686); padding: 2.5rem 1rem; }

/* Command-palette launcher overlay (⌘K). The card hosts the palette render type. */
.pict-nav-launcher { position: fixed; inset: 0; z-index: 6000; display: none; }
.pict-nav-launcher.is-open { display: block; }
.pict-nav-launcher-backdrop { position: absolute; inset: 0;
	background: color-mix(in srgb, var(--theme-color-text-primary, #1f2733) 42%, transparent); }
.pict-nav-launcher-card { position: absolute; left: 50%; top: 13vh; transform: translateX(-50%);
	width: min(660px, 94vw); animation: pict-nav-launcher-in 0.12s ease-out; }
.pict-nav-launcher-card .pict-nav-pl { max-height: 68vh; }
@keyframes pict-nav-launcher-in { from { opacity: 0; transform: translate(-50%, -6px); } to { opacity: 1; transform: translate(-50%, 0); } }
`;

module.exports = PictNavigationProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"../views/PictView-Navigation-Hub.js":693,"../views/PictView-Navigation-List.js":694,"../views/PictView-Navigation-Palette.js":695,"../views/PictView-Navigation-Sidebar.js":696,"pict-provider":552}],693:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: HUB
 *
 * Categorized cards with inline descriptions and a live search. The "settings home"
 * pattern — best for discoverability and always-visible help.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-Hub",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowAdvancedToggle": true,
	"SearchPlaceholder": "Search…",

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-Hub-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-Hub-Container", "Template": html`<div class="pict-nav-hub-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-Hub-Wrap",
			"TemplateHash": "Navigation-Hub-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-hub-head { display: flex; gap: 0.75rem; align-items: center; margin-bottom: 1.25rem; }
.pict-nav-hub-head .pict-nav-search { flex: 1 1 auto; }
.pict-nav-hub-cat { margin-bottom: 1.9rem; }
.pict-nav-hub-cat-head { display: flex; align-items: baseline; gap: 0.55rem; margin-bottom: 0.8rem; padding-bottom: 0.4rem; border-bottom: 2px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-hub-cat.is-secondary .pict-nav-hub-cat-head { border-bottom-style: dashed; }
.pict-nav-hub-cat-head h3 { font-size: 1.12rem; font-weight: 700; margin: 0; color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-hub-cat-ic { color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-hub-cat-blurb { color: var(--theme-color-text-muted, #6b7686); font-size: 0.84rem; }
.pict-nav-hub-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 0.8rem; }
.pict-nav-hub-card { display: flex; gap: 0.8rem; align-items: flex-start; padding: 0.95rem 1rem; text-decoration: none; color: inherit;
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 11px;
	transition: box-shadow .14s ease, transform .14s ease, border-color .14s ease; }
.pict-nav-hub-card:hover { box-shadow: 0 8px 20px color-mix(in srgb, var(--theme-color-shadow-color, rgba(15,23,42,0.12)) 80%, transparent);
	transform: translateY(-2px); border-color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-hub-card .pict-nav-ic { color: var(--theme-color-brand-primary, #156dd1); font-size: 1.4rem; display: inline-flex; align-items: center; }
.pict-nav-hub-card-text { min-width: 0; }
.pict-nav-hub-card-name { display: block; font-weight: 650; line-height: 1.15; }
.pict-nav-hub-card-desc { display: block; font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 3px; line-height: 1.38; }
.pict-nav-adv-pill { font-size: 0.6rem; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 7px; margin-left: 6px; vertical-align: middle; }
`
};

class PictViewNavigationHub extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	_resultsAddress()
	{
		return '#PictNav-Hub-Results-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-search">
					<span class="pict-nav-search-ic">${this.pict.icon('Search')}</span>
					<input type="text" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(tmpProvider.getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" />
				</div>` : '';
			const tmpAdvanced = this.options.ShowAdvancedToggle ? `
				<label class="pict-nav-adv"><input type="checkbox" ${tmpProvider.getShowAdvanced() ? 'checked' : ''} onchange="${tmpHandler}.onToggleAdvanced(this.checked)" /> Show advanced</label>` : '';
			const tmpShell = `<div class="pict-nav pict-nav-hub">
				<div class="pict-nav-hub-head">${tmpSearch}${tmpAdvanced}</div>
				<div id="${this._resultsAddress().slice(1)}" class="pict-nav-hub-results"></div>
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaint();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild the (search-filtered) results area without disturbing the search input. */
	repaint()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = tmpProvider.getQuery();
		const tmpCategories = tmpProvider.getFilteredCategories({ Scope: this.options.Scope, Filter: this.options.Filter });

		let tmpHTML = '';
		tmpCategories.forEach((pCategory) =>
		{
			const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
			tmpHTML += `<section class="pict-nav-hub-cat ${pCategory.Secondary ? 'is-secondary' : ''}">
				<header class="pict-nav-hub-cat-head"><span class="pict-nav-hub-cat-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span><h3>${tmpProvider.escapeHTML(pCategory.Name)}</h3>${pCategory.Blurb ? `<span class="pict-nav-hub-cat-blurb">${tmpProvider.escapeHTML(pCategory.Blurb)}</span>` : ''}</header>
				<div class="pict-nav-hub-grid">`;
			pCategory.Items.forEach((pItem) =>
			{
				const tmpAccent = pItem.Accent || pCategory.Accent;
				const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
				tmpHTML += `<a class="pict-nav-hub-card" href="${pItem.Route ? tmpProvider.escapeHTML(pItem.Route) : '#'}" onclick="return ${tmpHandler}.activate('${pItem.Hash}', event)">
					<span class="pict-nav-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
					<span class="pict-nav-hub-card-text"><span class="pict-nav-hub-card-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}${pItem.Advanced ? '<span class="pict-nav-adv-pill">adv</span>' : ''}</span>${pItem.Description ? `<span class="pict-nav-hub-card-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
				</a>`;
			});
			tmpHTML += `</div></section>`;
		});
		if (tmpCategories.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">Nothing matches your search.</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._resultsAddress(), tmpHTML);
	}

	onSearch(pValue)
	{
		this.navigationProvider.setQuery(pValue);
		this.repaint();
	}

	onToggleAdvanced(pChecked)
	{
		this.navigationProvider.setShowAdvanced(pChecked);
		this.repaint();
	}

	activate(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.navigate(pHash);
		return false;
	}
}

module.exports = PictViewNavigationHub;
module.exports.default_configuration = default_configuration;

},{"pict-view":733}],694:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: LIST
 *
 * A scannable single-column, grouped settings list (iOS / Stripe-settings style):
 * each category is a rounded "group" card whose rows carry a name, a one-line
 * description and a chevron. Best for a top-to-bottom directory where every setting
 * gets an inline explanation. Shares the live search + advanced toggle of the hub.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-List",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowAdvancedToggle": true,
	"SearchPlaceholder": "Search…",

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-List-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-List-Container", "Template": html`<div class="pict-nav-list-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-List-Wrap",
			"TemplateHash": "Navigation-List-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-list-wrap { max-width: 780px; margin: 0 auto; }
.pict-nav-list-head { margin-bottom: 1.1rem; }
.pict-nav-list-head .pict-nav-search { flex: 1 1 auto; }
.pict-nav-list-head-row { display: flex; gap: 0.75rem; align-items: center; }
.pict-nav-list-group { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0);
	border-radius: 12px; overflow: hidden; margin-bottom: 1.1rem; }
.pict-nav-list-group.is-secondary { opacity: 0.96; }
.pict-nav-list-group-head { display: flex; align-items: center; gap: 0.6rem; padding: 0.8rem 1.1rem;
	background: var(--theme-color-background-tertiary, #eceef2); border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-list-group-head h3 { font-size: 1rem; font-weight: 700; margin: 0; color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-list-group-ic { color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-list-group-blurb { color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; margin-left: auto; text-align: right; }
.pict-nav-list-row { display: flex; align-items: center; gap: 0.9rem; padding: 0.8rem 1.1rem; text-decoration: none; color: inherit;
	border-top: 1px solid var(--theme-color-border-light, #e8ebf0); transition: background .12s ease; }
.pict-nav-list-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pict-nav-list-row .pict-nav-ic { width: 34px; height: 34px; color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; display: inline-flex; align-items: center; justify-content: center; }
.pict-nav-list-row-text { min-width: 0; }
.pict-nav-list-row-name { display: block; font-weight: 600; line-height: 1.15; }
.pict-nav-list-row-desc { display: block; font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 1px; line-height: 1.35; }
.pict-nav-list-chev { margin-left: auto; color: var(--theme-color-text-muted, #6b7686); }
.pict-nav-adv-pill { font-size: 0.6rem; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 7px; margin-left: 6px; vertical-align: middle; }
`
};

class PictViewNavigationList extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	_resultsAddress()
	{
		return '#PictNav-List-Results-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-search">
					<span class="pict-nav-search-ic">${this.pict.icon('Search')}</span>
					<input type="text" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(tmpProvider.getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" />
				</div>` : '';
			const tmpAdvanced = this.options.ShowAdvancedToggle ? `
				<label class="pict-nav-adv"><input type="checkbox" ${tmpProvider.getShowAdvanced() ? 'checked' : ''} onchange="${tmpHandler}.onToggleAdvanced(this.checked)" /> Show advanced</label>` : '';
			const tmpShell = `<div class="pict-nav pict-nav-list">
				<div class="pict-nav-list-wrap">
					<div class="pict-nav-list-head">
						<div class="pict-nav-list-head-row">${tmpSearch}</div>
						${tmpAdvanced}
					</div>
					<div id="${this._resultsAddress().slice(1)}" class="pict-nav-list-results"></div>
				</div>
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaint();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild the (search-filtered) results area without disturbing the search input. */
	repaint()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = tmpProvider.getQuery();
		const tmpCategories = tmpProvider.getFilteredCategories({ Scope: this.options.Scope, Filter: this.options.Filter });

		let tmpHTML = '';
		tmpCategories.forEach((pCategory) =>
		{
			const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
			tmpHTML += `<section class="pict-nav-list-group ${pCategory.Secondary ? 'is-secondary' : ''}">
				<header class="pict-nav-list-group-head"><span class="pict-nav-list-group-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span><h3>${tmpProvider.escapeHTML(pCategory.Name)}</h3>${pCategory.Blurb ? `<span class="pict-nav-list-group-blurb">${tmpProvider.escapeHTML(pCategory.Blurb)}</span>` : ''}</header>`;
			pCategory.Items.forEach((pItem) =>
			{
				const tmpAccent = pItem.Accent || pCategory.Accent;
				const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
				tmpHTML += `<a class="pict-nav-list-row" href="${pItem.Route ? tmpProvider.escapeHTML(pItem.Route) : '#'}" onclick="return ${tmpHandler}.activate('${pItem.Hash}', event)">
					<span class="pict-nav-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
					<span class="pict-nav-list-row-text"><span class="pict-nav-list-row-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}${pItem.Advanced ? '<span class="pict-nav-adv-pill">adv</span>' : ''}</span>${pItem.Description ? `<span class="pict-nav-list-row-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
					<span class="pict-nav-list-chev">${this.pict.icon('ChevronRight')}</span>
				</a>`;
			});
			tmpHTML += `</section>`;
		});
		if (tmpCategories.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">Nothing matches your filter.</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._resultsAddress(), tmpHTML);
	}

	onSearch(pValue)
	{
		this.navigationProvider.setQuery(pValue);
		this.repaint();
	}

	onToggleAdvanced(pChecked)
	{
		this.navigationProvider.setShowAdvanced(pChecked);
		this.repaint();
	}

	activate(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.navigate(pHash);
		return false;
	}
}

module.exports = PictViewNavigationList;
module.exports.default_configuration = default_configuration;

},{"pict-view":733}],695:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: PALETTE
 *
 * A command-palette / ⌘K-style search list. A search box at the top filters a flat,
 * keyboard-navigable list of items (↑/↓ to move, Enter to open, Esc to clear). When the
 * search is empty the full directory is shown grouped by category; once a query is typed
 * the results collapse to a flat list with a per-row category tag. Rendered inline inside
 * its container (not a fixed overlay) so the host can position it.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-Palette",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowFooter": true,
	"SearchPlaceholder": "Search configuration, tools, analytics…",

	// When true the view keeps its own query string instead of the provider's shared
	// query state. The command-palette launcher overlay sets this so quick-jumping
	// never disturbs a docked sidebar / inline render that is sharing the provider.
	"UseLocalQuery": false,

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-Palette-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-Palette-Container", "Template": html`<div class="pict-nav-pl-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-Palette-Wrap",
			"TemplateHash": "Navigation-Palette-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-pl { display: flex; flex-direction: column; max-height: 76vh;
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0);
	border-radius: 14px; box-shadow: 0 18px 50px color-mix(in srgb, var(--theme-color-shadow-color, rgba(15,23,42,0.18)) 85%, transparent); overflow: hidden; }
.pict-nav-pl-head { display: flex; align-items: center; gap: 0.75rem; padding: 0.95rem 1.15rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-pl-head .pict-nav-pl-ic-search { color: var(--theme-color-text-muted, #6b7686); font-size: 1.05rem; display: inline-flex; align-items: center; }
.pict-nav-pl-head input { flex: 1 1 auto; border: none; outline: none; background: transparent; font: inherit; font-size: 1.18rem; color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-pl-head input::placeholder { color: var(--theme-color-text-muted, #6b7686); }
.pict-nav-pl-esc { font-size: 0.6rem; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 2px 8px; flex: 0 0 auto; }
.pict-nav-pl-results { overflow: auto; padding: 0.4rem; }
.pict-nav-pl-cat { font-size: 0.67rem; font-weight: 800; text-transform: uppercase; letter-spacing: .07em; color: var(--theme-color-text-muted, #6b7686); padding: 0.7rem 0.75rem 0.25rem; }
.pict-nav-pl-row { display: flex; align-items: center; gap: 0.85rem; padding: 0.55rem 0.75rem; border-radius: 9px; cursor: pointer; scroll-margin: 8px; }
.pict-nav-pl-row.hl { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent); }
.pict-nav-pl-row .pict-nav-ic { width: 32px; height: 32px; font-size: 1.15rem; display: inline-flex; align-items: center; justify-content: center; }
.pict-nav-pl-text { min-width: 0; }
.pict-nav-pl-name { font-weight: 600; }
.pict-nav-pl-desc { display: block; font-size: 0.79rem; color: var(--theme-color-text-muted, #6b7686); line-height: 1.25; margin-top: 1px; }
.pict-nav-pl-tag { margin-left: auto; flex: 0 0 auto; font-size: 0.67rem; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 9px; white-space: nowrap; }
.pict-nav-pl-row.hl .pict-nav-pl-tag { display: none; }
.pict-nav-pl-enter { margin-left: auto; flex: 0 0 auto; font-size: 0.72rem; font-weight: 700; color: var(--theme-color-brand-primary, #156dd1); opacity: 0; }
.pict-nav-pl-row.hl .pict-nav-pl-enter { opacity: 1; }
.pict-nav-pl-adv-pill { font-size: 0.6rem; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686);
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 999px; padding: 1px 7px; margin-left: 6px; vertical-align: middle; }
.pict-nav-pl-foot { border-top: 1px solid var(--theme-color-border-light, #e8ebf0); padding: 0.5rem 0.95rem; font-size: 0.72rem;
	color: var(--theme-color-text-muted, #6b7686); display: flex; gap: 1.2rem; flex-wrap: wrap; }
.pict-nav-pl-foot kbd { background: var(--theme-color-background-tertiary, #eceef2); border-radius: 4px; padding: 0 5px; font: inherit; font-weight: 700; }
`
};

class PictViewNavigationPalette extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Keyboard-highlight index into the currently-visible rows.
		this._highlightIndex = 0;
		// Flat list of { Item, Category } for the currently-rendered rows (set during repaint).
		this._rows = [];
		// Local query string, used only when UseLocalQuery is set (launcher overlay).
		this._localQuery = '';
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	/** The active query — local to this view, or the provider's shared query. */
	_getQuery()
	{
		return this.options.UseLocalQuery ? (this._localQuery || '') : this.navigationProvider.getQuery();
	}

	_setQuery(pValue)
	{
		if (this.options.UseLocalQuery) { this._localQuery = String(pValue == null ? '' : pValue); }
		else { this.navigationProvider.setQuery(pValue); }
	}

	_resultsAddress()
	{
		return '#PictNav-Palette-Results-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-pl-head">
					<span class="pict-nav-pl-ic-search">${this.pict.icon('Search')}</span>
					<input type="text" autocomplete="off" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(this._getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" onkeydown="${tmpHandler}.onKey(event)" />
					<span class="pict-nav-pl-esc">esc</span>
				</div>` : '';
			const tmpFooter = this.options.ShowFooter ? `
				<div class="pict-nav-pl-foot"><span><kbd>↑</kbd> <kbd>↓</kbd> navigate</span><span><kbd>↵</kbd> open</span><span><kbd>esc</kbd> clear</span></div>` : '';
			const tmpShell = `<div class="pict-nav pict-nav-pl">
				${tmpSearch}
				<div id="${this._resultsAddress().slice(1)}" class="pict-nav-pl-results"></div>
				${tmpFooter}
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaint();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild ONLY the results region without disturbing the search input. */
	repaint()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = this._getQuery();

		this._rows = [];
		let tmpHTML = '';

		const fRenderRow = (pItem, pCategory, pFlat) =>
		{
			const tmpIdx = this._rows.length;
			this._rows.push({ Item: pItem, Category: pCategory });
			const tmpAccent = pItem.Accent || pCategory.Accent;
			const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
			const tmpTail = pFlat
				? `<span class="pict-nav-pl-tag">${tmpProvider.escapeHTML(pCategory.Name)}</span><span class="pict-nav-pl-enter">↵ open</span>`
				: `<span class="pict-nav-pl-enter">↵ open</span>`;
			return `<div class="pict-nav-pl-row" data-idx="${tmpIdx}" onmousemove="${tmpHandler}.setHighlight(${tmpIdx})" onclick="${tmpHandler}.openIndex(${tmpIdx})">
				<span class="pict-nav-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
				<span class="pict-nav-pl-text"><span class="pict-nav-pl-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}${pItem.Advanced ? '<span class="pict-nav-pl-adv-pill">adv</span>' : ''}</span>${pItem.Description ? `<span class="pict-nav-pl-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
				${tmpTail}
			</div>`;
		};

		if (!tmpQuery)
		{
			// Empty query: full directory, grouped by category with a header before each group. The palette is a
			// jump-to-anywhere surface with no advanced toggle of its own, so it always lists advanced items too
			// (ShowAdvanced: true); the query branch below already ignores the advanced gate via searchFlat.
			const tmpCategories = tmpProvider.getFilteredCategories({ Query: tmpQuery, Scope: this.options.Scope, Filter: this.options.Filter, ShowAdvanced: true });
			tmpCategories.forEach((pCategory) =>
			{
				tmpHTML += `<div class="pict-nav-pl-cat">${tmpProvider.escapeHTML(pCategory.Name)}</div>`;
				pCategory.Items.forEach((pItem) => { tmpHTML += fRenderRow(pItem, pCategory, false); });
			});
		}
		else
		{
			// Active query: flat list across all categories, each row tagged with its category.
			const tmpMatches = tmpProvider.searchFlat(tmpQuery, { Scope: this.options.Scope, Filter: this.options.Filter });
			tmpMatches.forEach((pMatch) => { tmpHTML += fRenderRow(pMatch.Item, pMatch.Category, true); });
		}

		if (this._rows.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">No matches. Try another word.</div>`;
		}

		this.pict.ContentAssignment.assignContent(this._resultsAddress(), tmpHTML);
		this._highlightIndex = 0;
		this._paintHighlight();
	}

	/** Toggle the `hl` class so the row at _highlightIndex is highlighted, and scroll it into view. */
	_paintHighlight()
	{
		const tmpRows = this.pict.ContentAssignment.getElement(this._resultsAddress() + ' .pict-nav-pl-row');
		if (!tmpRows) return;
		for (let i = 0; i < tmpRows.length; i++)
		{
			const tmpRow = tmpRows[i];
			if (!tmpRow || !tmpRow.classList) continue;
			tmpRow.classList.toggle('hl', i === this._highlightIndex);
		}
		const tmpActive = tmpRows[this._highlightIndex];
		if (tmpActive && typeof tmpActive.scrollIntoView === 'function')
		{
			tmpActive.scrollIntoView({ block: 'nearest' });
		}
	}

	onKey(pEvent)
	{
		if (!pEvent) return;
		const tmpMax = this._rows.length - 1;
		switch (pEvent.key)
		{
			case 'ArrowDown':
				pEvent.preventDefault();
				this._highlightIndex = Math.min(this._highlightIndex + 1, tmpMax);
				this._paintHighlight();
				break;
			case 'ArrowUp':
				pEvent.preventDefault();
				this._highlightIndex = Math.max(this._highlightIndex - 1, 0);
				this._paintHighlight();
				break;
			case 'Enter':
				pEvent.preventDefault();
				this.openIndex(this._highlightIndex);
				break;
			case 'Escape':
				pEvent.preventDefault();
				if (pEvent.target) { pEvent.target.value = ''; }
				this.onSearch('');
				break;
			default:
				break;
		}
	}

	setHighlight(pIndex)
	{
		this._highlightIndex = pIndex;
		this._paintHighlight();
	}

	openIndex(pIndex)
	{
		const tmpRow = this._rows[pIndex];
		if (tmpRow)
		{
			this.navigationProvider.navigate(tmpRow.Item.Hash);
		}
	}

	onSearch(pValue)
	{
		this._setQuery(pValue);
		this.repaint();
	}
}

module.exports = PictViewNavigationPalette;
module.exports.default_configuration = default_configuration;

},{"pict-view":733}],696:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;

/**
 * Navigation render type: SIDEBAR
 *
 * A persistent grouped left rail with always-visible help and a detail pane on the
 * right. Selecting an item in the rail shows its detail (it does NOT navigate away);
 * the detail pane's "Open" button performs the actual navigation. The "search-first
 * sidebar" pattern — best for dense settings areas where you want a stable map of
 * everything on the left and contextual explanation on the right.
 */
const default_configuration =
{
	"ViewIdentifier": "Navigation-Sidebar",
	"NavigationProviderHash": "Pict-Navigation",

	"ShowSearch": true,
	"ShowAdvancedToggle": true,
	"SearchPlaceholder": "Search…",

	// ShowDetail true  → standalone two-pane home screen (rail + a detail pane that
	//                    explains the selected item; the detail's Open button navigates).
	// ShowDetail false → docked mode: just the rail, sized to fill its container, for use
	//                    as a persistent application sidebar. Clicking an item navigates
	//                    the host immediately (the host's main area is the "detail").
	"ShowDetail": true,

	"WelcomeHeading": "Configuration",
	"WelcomeBlurb": "Search or pick an area from the left. Each entry explains what it does.",

	"RenderOnLoad": false,
	"DefaultRenderable": "Navigation-Sidebar-Wrap",
	"DefaultDestinationAddress": "#Navigation-Container",

	"Templates":
	[
		{ "Hash": "Navigation-Sidebar-Container", "Template": html`<div class="pict-nav-sb-mount"></div>` }
	],
	"Renderables":
	[
		{
			"RenderableHash": "Navigation-Sidebar-Wrap",
			"TemplateHash": "Navigation-Sidebar-Container",
			"DestinationAddress": "#Navigation-Container",
			"RenderType": "replace"
		}
	],

	"CSS": /*css*/`
.pict-nav-sb-layout { display: flex; height: 100%; min-height: 360px; }
.pict-nav-sb-rail { flex: 0 0 330px; width: 330px; display: flex; flex-direction: column; min-height: 0;
	background: var(--theme-color-background-panel, #fff); border-right: 1px solid var(--theme-color-border-light, #e8ebf0); }
/* Docked mode: the rail is the whole thing (no detail pane), filling its host container. */
.pict-nav-sb-docked, .pict-nav-sb-docked .pict-nav-sb-layout { height: 100%; min-height: 0; }
.pict-nav-sb-docked .pict-nav-sb-rail { flex: 1 1 auto; width: 100%; border-right: none; }
.pict-nav-sb-rail-head { padding: 0.75rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pict-nav-sb-rail-body { flex: 1 1 auto; overflow: auto; padding: 0.5rem 0.5rem 2rem; min-height: 0; }
.pict-nav-sb-group { margin-bottom: 0.35rem; }
.pict-nav-sb-group-head { display: flex; align-items: center; gap: 0.5rem; padding: 0.55rem 0.55rem 0.35rem;
	font-size: 0.72rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em;
	color: var(--theme-color-text-muted, #6b7686); cursor: pointer; user-select: none; }
.pict-nav-sb-group-head .pict-nav-sb-cat-ic { display: inline-flex; align-items: center; }
.pict-nav-sb-group-head .pict-nav-sb-chev { margin-left: auto; display: inline-flex; align-items: center;
	transition: transform 0.15s ease; }
.pict-nav-sb-group.collapsed .pict-nav-sb-chev { transform: rotate(-90deg); }
.pict-nav-sb-group.collapsed .pict-nav-sb-items { display: none; }
.pict-nav-sb-item { display: flex; gap: 0.6rem; align-items: flex-start; padding: 0.5rem 0.55rem;
	border-radius: 8px; text-decoration: none; color: inherit; }
.pict-nav-sb-item:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pict-nav-sb-item.is-active { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent);
	box-shadow: inset 3px 0 0 var(--theme-color-brand-primary, #156dd1); }
.pict-nav-sb-item .pict-nav-sb-item-ic { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 26px; height: 26px; border-radius: 7px; background: var(--theme-color-background-tertiary, #eceef2);
	color: var(--theme-color-brand-primary, #156dd1); margin-top: 1px; font-size: 1rem; }
.pict-nav-sb-item-text { min-width: 0; }
.pict-nav-sb-item-name { display: block; font-weight: 600; font-size: 0.9rem; line-height: 1.15; }
.pict-nav-sb-item-desc { display: block; font-size: 0.76rem; color: var(--theme-color-text-muted, #6b7686); line-height: 1.32; margin-top: 1px; }

.pict-nav-sb-main { flex: 1 1 auto; min-width: 0; overflow: auto; padding: 2.5rem 3rem;
	color: var(--theme-color-text-primary, #1f2733); }
.pict-nav-sb-detail { max-width: 640px; }
.pict-nav-sb-detail-cat { font-size: 0.78rem; margin-bottom: 1rem; }
.pict-nav-sb-detail-head { display: flex; gap: 1.1rem; align-items: center; }
.pict-nav-sb-detail-ic { flex: 0 0 auto; width: 64px; height: 64px; border-radius: 16px; display: flex;
	align-items: center; justify-content: center; font-size: 1.7rem; background: var(--theme-color-background-tertiary, #eceef2);
	color: var(--theme-color-brand-primary, #156dd1); }
.pict-nav-sb-detail-title { font-size: 1.5rem; font-weight: 700; margin: 0 0 0.25rem; line-height: 1.15; }
.pict-nav-sb-detail-sub { color: var(--theme-color-text-muted, #6b7686); margin: 0; }
.pict-nav-sb-detail-actions { margin-top: 1.75rem; display: flex; align-items: center; gap: 0.85rem; flex-wrap: wrap; }
.pict-nav-sb-open { display: inline-flex; align-items: center; gap: 0.4rem; font: inherit; font-weight: 650; cursor: pointer;
	padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
	background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-on-brand, #fff); }
.pict-nav-sb-open:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 88%, #000); }
.pict-nav-sb-detail-route { font-size: 0.78rem; color: var(--theme-color-text-muted, #6b7686); }
.pict-nav-sb-detail-route code { background: var(--theme-color-background-tertiary, #eceef2); border-radius: 4px; padding: 1px 5px; }
.pict-nav-sb-adv-tag { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b7686); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 999px; padding: 1px 8px; margin-left: 0.6rem; vertical-align: middle; }

.pict-nav-sb-welcome { max-width: 640px; }
.pict-nav-sb-welcome h1 { display: flex; align-items: center; gap: 0.5rem; font-size: 1.7rem; font-weight: 700; margin: 0 0 0.4rem; }
.pict-nav-sb-welcome h1 .pict-nav-sb-welcome-ic { color: var(--theme-color-brand-primary, #156dd1); display: inline-flex; }
.pict-nav-sb-welcome-sub { color: var(--theme-color-text-muted, #6b7686); font-size: 1.05rem; margin: 0 0 1.25rem; }
.pict-nav-sb-welcome hr { border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); margin: 0 0 1rem; }
.pict-nav-sb-welcome-cat { display: flex; gap: 0.6rem; align-items: center; padding: 0.5rem 0; }
.pict-nav-sb-welcome-cat .pict-nav-sb-welcome-cat-ic { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 34px; height: 34px; border-radius: 9px; background: var(--theme-color-background-tertiary, #eceef2); }
.pict-nav-sb-welcome-cat-blurb { color: var(--theme-color-text-muted, #6b7686); font-size: 0.84rem; }
`
};

class PictViewNavigationSidebar extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	get navigationProvider()
	{
		return this.pict.providers[this.options.NavigationProviderHash || 'Pict-Navigation'];
	}

	_railAddress()
	{
		return '#PictNav-Sidebar-Rail-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	_detailAddress()
	{
		return '#PictNav-Sidebar-Detail-' + String(this.options.ViewIdentifier).replace(/[^a-zA-Z0-9]/g, '');
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.navigationProvider;
		if (tmpProvider)
		{
			const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
			const tmpSearch = this.options.ShowSearch ? `
				<div class="pict-nav-search">
					<span class="pict-nav-search-ic">${this.pict.icon('Search')}</span>
					<input type="text" placeholder="${tmpProvider.escapeHTML(this.options.SearchPlaceholder)}" value="${tmpProvider.escapeHTML(tmpProvider.getQuery())}"
						oninput="${tmpHandler}.onSearch(this.value)" />
				</div>` : '';
			const tmpAdvanced = this.options.ShowAdvancedToggle ? `
				<label class="pict-nav-adv"><input type="checkbox" ${tmpProvider.getShowAdvanced() ? 'checked' : ''} onchange="${tmpHandler}.onToggleAdvanced(this.checked)" /> Show advanced</label>` : '';
			const tmpDocked = !this.options.ShowDetail;
			const tmpDetail = tmpDocked ? '' : `<main id="${this._detailAddress().slice(1)}" class="pict-nav-sb-main"></main>`;
			const tmpShell = `<div class="pict-nav pict-nav-sb${tmpDocked ? ' pict-nav-sb-docked' : ''}">
				<div class="pict-nav-sb-layout">
					<aside class="pict-nav-sb-rail">
						<div class="pict-nav-sb-rail-head">${tmpSearch}${tmpAdvanced}</div>
						<div id="${this._railAddress().slice(1)}" class="pict-nav-sb-rail-body"></div>
					</aside>
					${tmpDetail}
				</div>
			</div>`;
			this.pict.ContentAssignment.assignContent(this.options.DefaultDestinationAddress, tmpShell);
			this.repaintRail();
			if (!tmpDocked) { this.repaintDetail(); }
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Rebuild the grouped rail body without disturbing the search input above it. */
	repaintRail()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpQuery = tmpProvider.getQuery();
		const tmpActiveHash = tmpProvider.getActive();
		const tmpCategories = tmpProvider.getFilteredCategories({ Scope: this.options.Scope, Filter: this.options.Filter });
		const tmpChevron = this.pict.icon('ChevronDown');

		let tmpHTML = '';
		tmpCategories.forEach((pCategory) =>
		{
			const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
			// A category can render collapsed by default (pCategory.Collapsed); an active search, or holding the
			// currently-active item, forces it open -- so navigating within a collapsed-by-default group (e.g. the
			// Settings group) does not fold it up under you on the repaint that follows the navigation.
			const tmpHoldsActive = !!tmpActiveHash && (pCategory.Items || []).some((pItem) => pItem.Hash === tmpActiveHash);
			const tmpCollapsed = (pCategory.Collapsed && !tmpQuery && !tmpHoldsActive) ? ' collapsed' : '';
			tmpHTML += `<div class="pict-nav-sb-group${tmpCollapsed}">
				<div class="pict-nav-sb-group-head" onclick="this.parentNode.classList.toggle('collapsed')">
					<span class="pict-nav-sb-cat-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span>
					<span>${tmpProvider.escapeHTML(pCategory.Name)}</span>
					<span class="pict-nav-sb-chev">${tmpChevron}</span>
				</div>
				<div class="pict-nav-sb-items">`;
			pCategory.Items.forEach((pItem) =>
			{
				const tmpAccent = pItem.Accent || pCategory.Accent;
				const tmpIcStyle = tmpAccent ? ` style="color:${tmpAccent}"` : '';
				const tmpActive = (tmpActiveHash === pItem.Hash) ? ' is-active' : '';
				// Docked rail navigates immediately; two-pane shows the item in the detail pane.
				const tmpClick = this.options.ShowDetail ? 'select' : 'activate';
				tmpHTML += `<a class="pict-nav-sb-item${tmpActive}" href="${pItem.Route ? tmpProvider.escapeHTML(pItem.Route) : '#'}" title="${tmpProvider.escapeHTML(pItem.Description)}" onclick="return ${tmpHandler}.${tmpClick}('${pItem.Hash}', event)">
					<span class="pict-nav-sb-item-ic"${tmpIcStyle}>${pItem.Icon ? this.pict.icon(pItem.Icon) : ''}</span>
					<span class="pict-nav-sb-item-text"><span class="pict-nav-sb-item-name">${tmpProvider.highlight(pItem.Name, tmpQuery)}</span>${pItem.Description ? `<span class="pict-nav-sb-item-desc">${tmpProvider.highlight(pItem.Description, tmpQuery)}</span>` : ''}</span>
				</a>`;
			});
			tmpHTML += `</div></div>`;
		});
		if (tmpCategories.length === 0)
		{
			tmpHTML = `<div class="pict-nav-empty">No matches.</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._railAddress(), tmpHTML);
	}

	/** Rebuild the right-hand detail pane for the active node, or the welcome screen. */
	repaintDetail()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) return;
		const tmpHandler = `_Pict.views['${this.options.ViewIdentifier}']`;
		const tmpActiveHash = tmpProvider.getActive();
		const tmpNode = tmpActiveHash ? tmpProvider.getNodeByHash(tmpActiveHash) : null;

		let tmpHTML;
		if (tmpNode)
		{
			const tmpIcStyle = tmpNode.Accent ? ` style="color:${tmpNode.Accent}"` : '';
			const tmpRoute = tmpNode.Route ? tmpProvider.escapeHTML(tmpNode.Route) : '';
			tmpHTML = `<div class="pict-nav-sb-detail">
				<div class="pict-nav-sb-detail-head">
					<span class="pict-nav-sb-detail-ic"${tmpIcStyle}>${tmpNode.Icon ? this.pict.icon(tmpNode.Icon) : ''}</span>
					<div>
						<h1 class="pict-nav-sb-detail-title">${tmpProvider.escapeHTML(tmpNode.Name)}${tmpNode.Advanced ? '<span class="pict-nav-sb-adv-tag">Advanced</span>' : ''}</h1>
						${tmpNode.Description ? `<p class="pict-nav-sb-detail-sub">${tmpProvider.escapeHTML(tmpNode.Description)}</p>` : ''}
					</div>
				</div>
				<div class="pict-nav-sb-detail-actions">
					<button type="button" class="pict-nav-sb-open" onclick="${tmpHandler}.activate('${tmpNode.Hash}', event)">${this.pict.icon('ExternalLink')} Open ${tmpProvider.escapeHTML(tmpNode.Name)}</button>
					${tmpRoute ? `<span class="pict-nav-sb-detail-route">Route: <code>${tmpRoute}</code></span>` : ''}
				</div>
			</div>`;
		}
		else
		{
			let tmpCats = '';
			tmpProvider.getNavigationGraph().forEach((pCategory) =>
			{
				const tmpCatStyle = pCategory.Accent ? ` style="color:${pCategory.Accent}"` : '';
				tmpCats += `<div class="pict-nav-sb-welcome-cat">
					<span class="pict-nav-sb-welcome-cat-ic"${tmpCatStyle}>${pCategory.Icon ? this.pict.icon(pCategory.Icon) : ''}</span>
					<span><strong>${tmpProvider.escapeHTML(pCategory.Name)}</strong>${pCategory.Blurb ? ` <span class="pict-nav-sb-welcome-cat-blurb">— ${tmpProvider.escapeHTML(pCategory.Blurb)}</span>` : ''}</span>
				</div>`;
			});
			tmpHTML = `<div class="pict-nav-sb-welcome">
				<h1><span class="pict-nav-sb-welcome-ic">${this.pict.icon('Settings')}</span><span>${tmpProvider.escapeHTML(this.options.WelcomeHeading)}</span></h1>
				<p class="pict-nav-sb-welcome-sub">${tmpProvider.escapeHTML(this.options.WelcomeBlurb)}</p>
				<hr/>${tmpCats}</div>`;
		}
		this.pict.ContentAssignment.assignContent(this._detailAddress(), tmpHTML);
	}

	/** Select an item: show its detail and move the active highlight. Does NOT navigate. */
	select(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.setActive(pHash);
		this.repaintRail();
		this.repaintDetail();
		return false;
	}

	/** Navigate to a node (the detail pane's "Open" button, or a docked-rail item click). */
	activate(pHash, pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this.navigationProvider.navigate(pHash);
		// In docked mode the rail stays put — move the active highlight to the clicked item.
		this.syncActive();
		return false;
	}

	/**
	 * Re-paint the rail so its active highlight matches the provider's active node. Call
	 * this from the host after an external navigation (URL change, ⌘K launcher) so a
	 * docked sidebar reflects the current route.
	 */
	syncActive()
	{
		this.repaintRail();
		return this;
	}

	onSearch(pValue)
	{
		this.navigationProvider.setQuery(pValue);
		this.repaintRail();
	}

	onToggleAdvanced(pChecked)
	{
		this.navigationProvider.setShowAdvanced(pChecked);
		this.repaintRail();
	}
}

module.exports = PictViewNavigationSidebar;
module.exports.default_configuration = default_configuration;

},{"pict-view":733}],697:[function(require,module,exports){
module.exports = (
{
	ViewIdentifier: 'Pict-ObjectEditor',

	DefaultRenderable: 'ObjectEditor-Container',
	DefaultDestinationAddress: '#ObjectEditor-Container',

	AutoRender: false,

	// Address in AppData where the JSON object lives
	ObjectDataAddress: false,

	// Maximum depth to auto-expand on initial load
	InitialExpandDepth: 1,

	// Whether editing is enabled (vs read-only inspector mode)
	Editable: true,

	// Whether to show type indicator badges
	ShowTypeIndicators: true,

	// Indentation pixels per depth level
	IndentPixels: 20,

	CSS: /*css*/`
.pict-objecteditor
{
	font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', 'JetBrains Mono', Consolas, monospace;
	font-size: 13px;
	line-height: 1.5;
	color: var(--theme-color-text-primary, #3D3229);
	background: var(--theme-color-background-panel, #FDFCFA);
	border: 1px solid var(--theme-color-border-default, #E8E3DA);
	border-radius: 6px;
	padding: 8px 0;
	overflow: auto;
}
.pict-oe-row
{
	display: flex;
	align-items: center;
	padding: 2px 12px 2px 0;
	min-height: 26px;
	cursor: default;
	border-radius: 3px;
}
.pict-oe-row:hover
{
	background: var(--theme-color-background-hover, #F5F0E8);
}
.pict-oe-toggle
{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	cursor: pointer;
	color: var(--theme-color-text-muted, #8A7F72);
	font-size: 10px;
	flex-shrink: 0;
	user-select: none;
	border-radius: 3px;
	transition: color 0.1s;
}
.pict-oe-toggle:hover
{
	background: var(--theme-color-border-default, #E8E3DA);
	color: var(--theme-color-text-primary, #3D3229);
}
.pict-oe-spacer
{
	display: inline-block;
	width: 16px;
	flex-shrink: 0;
}
.pict-oe-key
{
	color: var(--theme-color-syntax-property, #9E6B47);
	flex-shrink: 0;
}
.pict-oe-separator
{
	color: var(--theme-color-text-muted, #8A7F72);
	margin: 0 8px;
	flex-shrink: 0;
}
.pict-oe-value
{
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-oe-value-string
{
	color: var(--theme-color-syntax-string, #2E7D74);
}
.pict-oe-value-string::before
{
	content: '"';
	color: var(--theme-color-syntax-string, #A8CFC9);
}
.pict-oe-value-string::after
{
	content: '"';
	color: var(--theme-color-syntax-string, #A8CFC9);
}
.pict-oe-value-number
{
	color: var(--theme-color-syntax-number, #3B6DAA);
}
.pict-oe-value-boolean
{
	color: var(--theme-color-syntax-keyword, #8B5E3C);
	font-weight: 600;
}
.pict-oe-value-null
{
	color: var(--theme-color-syntax-keyword, #B0A89E);
	font-style: italic;
}
.pict-oe-summary
{
	color: var(--theme-color-text-placeholder, #B0A89E);
	margin-left: 6px;
	font-size: 12px;
}
.pict-oe-type-badge
{
	display: inline-block;
	font-size: 9px;
	padding: 0 4px;
	border-radius: 3px;
	background: var(--theme-color-background-tertiary, #F0ECE4);
	color: var(--theme-color-text-muted, #8A7F72);
	margin-left: 6px;
	line-height: 16px;
	vertical-align: middle;
}
.pict-oe-value-input
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-syntax-string, #2E7D74);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: inherit;
	outline: none;
	min-width: 80px;
}
.pict-oe-value-input:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-array-index
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-size: 11px;
}
.pict-oe-empty
{
	color: var(--theme-color-text-placeholder, #B0A89E);
	font-style: italic;
	padding: 8px 12px;
}
.pict-oe-actions
{
	margin-left: auto;
	padding-left: 12px;
	padding-right: 4px;
	opacity: 0.4;
	transition: opacity 0.15s;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 5px;
}
.pict-oe-row:hover .pict-oe-actions
{
	opacity: 1;
}
.pict-oe-action-btn
{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 22px;
	height: 22px;
	padding: 0 5px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #DDD8CF);
	background: var(--theme-color-background-hover, #F5F0E8);
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #8A7F72);
	user-select: none;
	box-sizing: border-box;
}
.pict-oe-action-btn:hover
{
	background: var(--theme-color-background-hover, #E8E3DA);
	border-color: var(--theme-color-border-default, #C5BFAE);
	color: var(--theme-color-text-primary, #3D3229);
}
.pict-oe-action-remove
{
	border-color: var(--theme-color-status-error, #E8C8C8);
	background: var(--theme-color-background-hover, #FAF0F0);
	color: var(--theme-color-status-error, #A04040);
}
.pict-oe-action-remove:hover
{
	background: var(--theme-color-background-hover, #F0D6D6);
	border-color: var(--theme-color-status-error, #D4A0A0);
	color: var(--theme-color-status-error, #A04040);
}
.pict-oe-action-move
{
	font-size: 9px;
}
.pict-oe-action-move:hover
{
	background: var(--theme-color-background-hover, #D6E4F0);
	border-color: var(--theme-color-status-info, #A8C4DA);
	color: var(--theme-color-status-info, #3B6DAA);
}
.pict-oe-action-add
{
	border-color: var(--theme-color-status-success, #C8D8C8);
	background: var(--theme-color-background-hover, #F0F5F0);
	color: var(--theme-color-status-success, #5A7A5A);
}
.pict-oe-action-add:hover
{
	background: var(--theme-color-background-hover, #D6E8D6);
	border-color: var(--theme-color-status-success, #A0C0A0);
	color: var(--theme-color-status-success, #3D5C3D);
}
.pict-oe-key-input
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-syntax-property, #9E6B47);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: var(--theme-color-syntax-property, #9E6B47);
	outline: none;
	min-width: 60px;
	margin-left: 6px;
}
.pict-oe-key-input:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-type-select
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-border-default, #C5BFAE);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: var(--theme-color-text-primary, #3D3229);
	outline: none;
	margin-left: 6px;
	cursor: pointer;
}
.pict-oe-type-select:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-root-add
{
	display: flex;
	align-items: center;
	padding: 4px 12px;
	min-height: 26px;
	cursor: default;
}
.pict-oe-root-add .pict-oe-action-btn
{
	width: auto;
	white-space: nowrap;
	padding: 0 8px;
}
`,

	MacroTemplates:
	{
		Node:
		{
			RowOpen: '<div class="pict-oe-row" style="padding-left:{~D:Record.PaddingLeft~}px" data-path="{~D:Record.EscapedPath~}">',
			RowClose: '</div>',
			Toggle: '<span class="pict-oe-toggle" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].toggleNode(\'{~D:Record.EscapedPath~}\')">{~D:Record.ToggleArrow~}</span>',
			Spacer: '<span class="pict-oe-spacer"></span>',
			KeyName: '<span class="pict-oe-key">{~D:Record.EscapedKey~}</span>',
			KeyIndex: '<span class="pict-oe-key"><span class="pict-oe-array-index">{~D:Record.ArrayIndex~}</span></span>',
			Separator: '<span class="pict-oe-separator">:</span>',
			TypeBadge: '<span class="pict-oe-type-badge">{~D:Record.TypeLabel~}</span>',
			Summary: '<span class="pict-oe-summary">{~D:Record.SummaryText~}</span>',
			ValueStringEditable: '<span class="pict-oe-value pict-oe-value-string" ondblclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginEdit(\'{~D:Record.EscapedPath~}\', \'string\')" title="{~D:Record.EscapedTitle~}">{~D:Record.EscapedValue~}</span>',
			ValueStringReadOnly: '<span class="pict-oe-value pict-oe-value-string" title="{~D:Record.EscapedTitle~}">{~D:Record.EscapedValue~}</span>',
			ValueNumberEditable: '<span class="pict-oe-value pict-oe-value-number" ondblclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginEdit(\'{~D:Record.EscapedPath~}\', \'number\')">{~D:Record.EscapedValue~}</span>',
			ValueNumberReadOnly: '<span class="pict-oe-value pict-oe-value-number">{~D:Record.EscapedValue~}</span>',
			ValueBooleanEditable: '<span class="pict-oe-value pict-oe-value-boolean" style="cursor:pointer" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].toggleBoolean(\'{~D:Record.EscapedPath~}\')">{~D:Record.DisplayValue~}</span>',
			ValueBooleanReadOnly: '<span class="pict-oe-value pict-oe-value-boolean">{~D:Record.DisplayValue~}</span>',
			ValueNull: '<span class="pict-oe-value pict-oe-value-null">null</span>',
			ActionsOpen: '<span class="pict-oe-actions">',
			ActionsClose: '</span>',
			ButtonRemove: '<span class="pict-oe-action-btn pict-oe-action-remove" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].removeNode(\'{~D:Record.EscapedPath~}\')" title="Remove">\u00D7</span>',
			ButtonAddObject: '<span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToObject(\'{~D:Record.EscapedPath~}\')" title="Add">+</span>',
			ButtonAddArray: '<span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToArray(\'{~D:Record.EscapedPath~}\')" title="Add">+</span>',
			ButtonMoveUp: '<span class="pict-oe-action-btn pict-oe-action-move" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].moveArrayElementUp(\'{~D:Record.EscapedArrayPath~}\', {~D:Record.ArrayIndex~})" title="Move up">\u25B2</span>',
			ButtonMoveDown: '<span class="pict-oe-action-btn pict-oe-action-move" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].moveArrayElementDown(\'{~D:Record.EscapedArrayPath~}\', {~D:Record.ArrayIndex~})" title="Move down">\u25BC</span>',
			RootAddObject: '<div class="pict-oe-root-add" data-path=""><span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToObject(\'\')" title="Add property">+ add property</span></div>',
			RootAddArray: '<div class="pict-oe-root-add" data-path=""><span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToArray(\'\')" title="Add element">+ add element</span></div>'
		}
	},

	Templates:
	[
		{
			Hash: 'ObjectEditor-Container-Template',
			Template: '<div class="pict-objecteditor" id="ObjectEditor-Tree-{~D:Context[0].Hash~}"></div>'
		},
		{
			Hash: 'ObjectEditor-Node-String',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Number',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Boolean',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Null',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Object',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Toggle~}{~D:Record.Macro.Key~}{~D:Record.Macro.TypeBadge~}{~D:Record.Macro.Summary~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Array',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Toggle~}{~D:Record.Macro.Key~}{~D:Record.Macro.TypeBadge~}{~D:Record.Macro.Summary~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'ObjectEditor-Container',
			TemplateHash: 'ObjectEditor-Container-Template',
			DestinationAddress: '#ObjectEditor-Container',
			RenderMethod: 'replace'
		}
	]
});

},{}],698:[function(require,module,exports){
// Pict Section: Object Editor
// A tree-based JSON object viewer and editor for Pict applications.

// The main object editor view class
module.exports = require('./views/PictView-ObjectEditor.js');

// Node type views
module.exports.PictViewObjectEditorNode = require('./views/PictView-ObjectEditor-Node.js');
module.exports.PictViewObjectEditorNodeString = require('./views/PictView-ObjectEditor-NodeString.js');
module.exports.PictViewObjectEditorNodeNumber = require('./views/PictView-ObjectEditor-NodeNumber.js');
module.exports.PictViewObjectEditorNodeBoolean = require('./views/PictView-ObjectEditor-NodeBoolean.js');
module.exports.PictViewObjectEditorNodeNull = require('./views/PictView-ObjectEditor-NodeNull.js');
module.exports.PictViewObjectEditorNodeObject = require('./views/PictView-ObjectEditor-NodeObject.js');
module.exports.PictViewObjectEditorNodeArray = require('./views/PictView-ObjectEditor-NodeArray.js');

// Default configuration
module.exports.default_configuration = require('./Pict-Section-ObjectEditor-DefaultConfiguration.js');

},{"./Pict-Section-ObjectEditor-DefaultConfiguration.js":697,"./views/PictView-ObjectEditor-Node.js":699,"./views/PictView-ObjectEditor-NodeArray.js":700,"./views/PictView-ObjectEditor-NodeBoolean.js":701,"./views/PictView-ObjectEditor-NodeNull.js":702,"./views/PictView-ObjectEditor-NodeNumber.js":703,"./views/PictView-ObjectEditor-NodeObject.js":704,"./views/PictView-ObjectEditor-NodeString.js":705,"./views/PictView-ObjectEditor.js":706}],699:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Base class for all object editor node type renderers.
 *
 * Each subclass implements renderNodeHTML() to return an HTML string
 * for a single tree row.  One instance per type, not per node.
 *
 * Rendering uses the Pict template system with MacroTemplates defined
 * in the view configuration.  Each macro is a Jellyfish template string
 * compiled against the node descriptor (Record) and the ObjectEditor
 * view (Context[0]).  Subclasses set type-specific properties on the
 * node descriptor, call compileMacros(), then resolve a per-type
 * template that references the compiled macros.
 */
class PictViewObjectEditorNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNode';

		// Reference to the parent ObjectEditor view; set by the orchestrator
		this._ObjectEditorView = null;
	}

	/**
	 * Render a single tree node row as an HTML string.
	 *
	 * @param {Object} pNode - Node descriptor { Path, Key, Depth, DataType, HasChildren, ChildCount, IsExpanded, IsArrayElement, ArrayIndex }
	 * @param {*} pValue - The actual value at this node's path
	 * @param {Object} pOptions - Editor options { Editable, ShowTypeIndicators, IndentPixels, ViewHash }
	 *
	 * @return {string} HTML string for this row
	 */
	renderNodeHTML(pNode, pValue, pOptions)
	{
		return '';
	}

	// --- Macro compilation ---

	/**
	 * Compile all MacroTemplates onto pNode.Macro.
	 *
	 * This sets computed display properties on the node descriptor,
	 * then resolves every MacroTemplate from the view configuration
	 * against the node (as Record) and the ObjectEditor view (as Context[0]).
	 *
	 * After this call, pNode.Macro contains the compiled HTML fragments
	 * ready to be composed by a per-type template.
	 */
	compileMacros(pNode, pValue, pOptions)
	{
		// Compute derived display properties on the node descriptor
		pNode.PaddingLeft = (pNode.Depth * pOptions.IndentPixels) + 12;
		pNode.EscapedPath = this.escapeAttribute(pNode.Path);
		pNode.EscapedKey = this.escapeHTML(String(pNode.Key));
		pNode.ToggleArrow = pNode.IsExpanded ? '\u25BC' : '\u25B6';

		// Parse out parent array path for move buttons
		let tmpBracketMatch = pNode.Path.match(/^(.*)\[(\d+)\]$/);
		if (tmpBracketMatch)
		{
			pNode.EscapedArrayPath = this.escapeAttribute(tmpBracketMatch[1]);
		}
		else
		{
			pNode.EscapedArrayPath = '';
		}

		// Compile each MacroTemplate onto pNode.Macro
		let tmpMacroTemplates = this._ObjectEditorView.options.MacroTemplates.Node;
		let tmpMacroKeys = Object.keys(tmpMacroTemplates);
		pNode.Macro = {};

		for (let i = 0; i < tmpMacroKeys.length; i++)
		{
			let tmpKey = tmpMacroKeys[i];
			pNode.Macro[tmpKey] = this.pict.parseTemplate(
				tmpMacroTemplates[tmpKey],
				pNode,
				null,
				[this._ObjectEditorView]
			);
		}

		// Set the Key macro conditionally: array index or key name
		if (pNode.IsArrayElement)
		{
			pNode.Macro.Key = pNode.Macro.KeyIndex;
		}
		else
		{
			pNode.Macro.Key = pNode.Macro.KeyName;
		}

		// Set TypeBadge to empty if ShowTypeIndicators is false
		if (!pOptions.ShowTypeIndicators)
		{
			pNode.Macro.TypeBadge = '';
		}
	}

	/**
	 * Compose action button macros for leaf nodes.
	 * Returns a compiled HTML string for the actions area.
	 */
	compileActions(pNode, pOptions)
	{
		if (!pOptions.Editable)
		{
			return '';
		}
		let tmpHTML = pNode.Macro.ActionsOpen;
		if (pNode.IsArrayElement)
		{
			tmpHTML += pNode.Macro.ButtonMoveUp + pNode.Macro.ButtonMoveDown;
		}
		tmpHTML += pNode.Macro.ButtonRemove;
		tmpHTML += pNode.Macro.ActionsClose;
		return tmpHTML;
	}

	/**
	 * Compose action button macros for container nodes (object/array).
	 * Includes an add button in addition to move and remove.
	 */
	compileContainerActions(pNode, pOptions, pContainerType)
	{
		if (!pOptions.Editable)
		{
			return '';
		}
		let tmpHTML = pNode.Macro.ActionsOpen;
		tmpHTML += (pContainerType === 'array') ? pNode.Macro.ButtonAddArray : pNode.Macro.ButtonAddObject;
		if (pNode.IsArrayElement)
		{
			tmpHTML += pNode.Macro.ButtonMoveUp + pNode.Macro.ButtonMoveDown;
		}
		tmpHTML += pNode.Macro.ButtonRemove;
		tmpHTML += pNode.Macro.ActionsClose;
		return tmpHTML;
	}

	/**
	 * Escape a string for safe use in HTML attributes.
	 */
	escapeAttribute(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	/**
	 * Escape a string for safe use in HTML content.
	 */
	escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

module.exports = PictViewObjectEditorNode;

},{"pict-view":733}],700:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeArray extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeArray';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpLength = Array.isArray(pValue) ? pValue.length : 0;

		pNode.TypeLabel = 'Array';
		let tmpNoun = (tmpLength === 1) ? 'item' : 'items';
		pNode.SummaryText = '[' + tmpLength + ' ' + tmpNoun + ']';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Compose container actions (includes add button)
		pNode.Macro.Actions = this.compileContainerActions(pNode, pOptions, 'array');

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Array'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeArray;

},{"./PictView-ObjectEditor-Node.js":699}],701:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeBoolean extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeBoolean';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		pNode.DisplayValue = pValue ? 'true' : 'false';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueBooleanEditable : pNode.Macro.ValueBooleanReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Boolean'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeBoolean;

},{"./PictView-ObjectEditor-Node.js":699}],702:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeNull extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeNull';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Null always uses the static ValueNull macro
		pNode.Macro.Value = pNode.Macro.ValueNull;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Null'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeNull;

},{"./PictView-ObjectEditor-Node.js":699}],703:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeNumber extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeNumber';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		pNode.EscapedValue = this.escapeHTML(String(pValue));

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueNumberEditable : pNode.Macro.ValueNumberReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Number'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeNumber;

},{"./PictView-ObjectEditor-Node.js":699}],704:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeObject extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeObject';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpKeyCount = 0;
		if (pValue && typeof pValue === 'object' && !Array.isArray(pValue))
		{
			tmpKeyCount = Object.keys(pValue).length;
		}

		pNode.TypeLabel = 'Object';
		let tmpNoun = (tmpKeyCount === 1) ? 'key' : 'keys';
		pNode.SummaryText = '{' + tmpKeyCount + ' ' + tmpNoun + '}';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Compose container actions (includes add button)
		pNode.Macro.Actions = this.compileContainerActions(pNode, pOptions, 'object');

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Object'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeObject;

},{"./PictView-ObjectEditor-Node.js":699}],705:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeString extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeString';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpDisplayValue = (typeof pValue === 'string') ? pValue : '';
		// Truncate long strings for display
		let tmpTruncated = tmpDisplayValue.length > 120 ? tmpDisplayValue.substring(0, 120) + '\u2026' : tmpDisplayValue;
		pNode.EscapedValue = this.escapeHTML(tmpTruncated);
		pNode.EscapedTitle = this.escapeAttribute(tmpDisplayValue);

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueStringEditable : pNode.Macro.ValueStringReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-String'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeString;

},{"./PictView-ObjectEditor-Node.js":699}],706:[function(require,module,exports){
const libPictView = require('pict-view');

const libNodeString = require('./PictView-ObjectEditor-NodeString.js');
const libNodeNumber = require('./PictView-ObjectEditor-NodeNumber.js');
const libNodeBoolean = require('./PictView-ObjectEditor-NodeBoolean.js');
const libNodeNull = require('./PictView-ObjectEditor-NodeNull.js');
const libNodeObject = require('./PictView-ObjectEditor-NodeObject.js');
const libNodeArray = require('./PictView-ObjectEditor-NodeArray.js');

const _DefaultConfiguration = require('../Pict-Section-ObjectEditor-DefaultConfiguration.js');

class PictViewObjectEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// Set of expanded path strings
		this._ExpandedPaths = new Set();

		// Map of data type -> node renderer instance
		this._NodeRenderers = {};
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Register node type service types if they aren't already present
		let tmpNodeTypes =
		{
			'PictViewObjectEditorNodeString': libNodeString,
			'PictViewObjectEditorNodeNumber': libNodeNumber,
			'PictViewObjectEditorNodeBoolean': libNodeBoolean,
			'PictViewObjectEditorNodeNull': libNodeNull,
			'PictViewObjectEditorNodeObject': libNodeObject,
			'PictViewObjectEditorNodeArray': libNodeArray
		};

		let tmpNodeTypeKeys = Object.keys(tmpNodeTypes);
		for (let i = 0; i < tmpNodeTypeKeys.length; i++)
		{
			let tmpKey = tmpNodeTypeKeys[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpKey))
			{
				this.fable.addServiceType(tmpKey, tmpNodeTypes[tmpKey]);
			}
		}

		// Instantiate one renderer per data type
		this._NodeRenderers.string = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeString');
		this._NodeRenderers.number = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeNumber');
		this._NodeRenderers.boolean = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeBoolean');
		this._NodeRenderers.null = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeNull');
		this._NodeRenderers.object = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeObject');
		this._NodeRenderers.array = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeArray');

		// Set back-references on each renderer
		let tmpRendererKeys = Object.keys(this._NodeRenderers);
		for (let i = 0; i < tmpRendererKeys.length; i++)
		{
			this._NodeRenderers[tmpRendererKeys[i]]._ObjectEditorView = this;
		}

		return super.onBeforeInitialize();
	}

	onAfterRender()
	{
		super.onAfterRender();

		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.initialRenderComplete = true;
			this.onAfterInitialRender();
		}

		// Always re-populate the tree after any render, since the container
		// template may have been re-rendered (e.g., by the application auto-render).
		this.renderTree();
	}

	onAfterInitialRender()
	{
		// Expand to the configured initial depth
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, this.options.InitialExpandDepth);
		}
	}

	// --- Public API ---

	/**
	 * Toggle expand/collapse on a node path.
	 */
	toggleNode(pPath)
	{
		if (this._ExpandedPaths.has(pPath))
		{
			this._ExpandedPaths.delete(pPath);
		}
		else
		{
			this._ExpandedPaths.add(pPath);
		}
		this.renderTree();
	}

	/**
	 * Toggle a boolean value at a path.
	 */
	toggleBoolean(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}
		let tmpCurrentValue = this._getValueAtPath(tmpData, pPath);
		this._setValueAtPath(tmpData, pPath, !tmpCurrentValue);
		this.renderTree();
	}

	/**
	 * Begin inline editing of a leaf node.
	 */
	beginEdit(pPath, pType)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpCurrentValue = this._getValueAtPath(tmpData, pPath);
		let tmpRowElement = this._getTreeElement().querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		let tmpValueSpan = tmpRowElement.querySelector('.pict-oe-value');
		if (!tmpValueSpan)
		{
			return;
		}

		let tmpInputType = (pType === 'number') ? 'number' : 'text';
		let tmpInputValue = (tmpCurrentValue === null || tmpCurrentValue === undefined) ? '' : String(tmpCurrentValue);
		let tmpEscapedPath = tmpInputValue.replace(/"/g, '&quot;');

		let tmpInput = document.createElement('input');
		tmpInput.type = tmpInputType;
		tmpInput.className = 'pict-oe-value-input';
		tmpInput.value = tmpInputValue;

		let tmpSelf = this;
		let tmpCommit = function()
		{
			let tmpNewValue = tmpInput.value;
			if (pType === 'number')
			{
				tmpNewValue = Number(tmpNewValue);
				if (isNaN(tmpNewValue))
				{
					tmpNewValue = 0;
				}
			}
			tmpSelf._setValueAtPath(tmpData, pPath, tmpNewValue);
			tmpSelf.renderTree();
		};

		tmpInput.addEventListener('blur', tmpCommit);
		tmpInput.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpInput.blur();
			}
			else if (pEvent.key === 'Escape')
			{
				// Cancel edit, just re-render
				tmpInput.removeEventListener('blur', tmpCommit);
				tmpSelf.renderTree();
			}
		});

		tmpValueSpan.innerHTML = '';
		tmpValueSpan.appendChild(tmpInput);
		tmpInput.focus();
		tmpInput.select();
	}

	/**
	 * Set a value at a dot-path in the object data and re-render.
	 */
	setValueAtPath(pPath, pValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}
		this._setValueAtPath(tmpData, pPath, pValue);
		this.renderTree();
	}

	/**
	 * Expand all nodes to a given depth.
	 */
	expandToDepth(pDepth)
	{
		this._ExpandedPaths.clear();
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, pDepth);
		}
		this.renderTree();
	}

	/**
	 * Expand all nodes in the tree.
	 */
	expandAll()
	{
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, Infinity);
		}
		this.renderTree();
	}

	/**
	 * Collapse all nodes in the tree.
	 */
	collapseAll()
	{
		this._ExpandedPaths.clear();
		this.renderTree();
	}

	// --- Add/Remove API ---

	/**
	 * Add a property to an object at a given path.
	 */
	addObjectProperty(pPath, pKey, pDefaultValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (tmpTarget === null || tmpTarget === undefined || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpValue = (pDefaultValue !== undefined) ? pDefaultValue : '';
		tmpTarget[pKey] = tmpValue;

		// Auto-expand the parent so the new property is visible
		if (pPath)
		{
			this._ExpandedPaths.add(pPath);
		}

		this.renderTree();
	}

	/**
	 * Remove a property from an object at a given path.
	 */
	removeObjectProperty(pPath, pKey)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (tmpTarget === null || tmpTarget === undefined || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpChildPath = pPath ? (pPath + '.' + pKey) : pKey;
		this._cleanupExpandedPaths(tmpChildPath);
		delete tmpTarget[pKey];

		this.renderTree();
	}

	/**
	 * Add an element to the end of an array at a given path.
	 */
	addArrayElement(pPath, pDefaultValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpValue = (pDefaultValue !== undefined) ? pDefaultValue : '';
		tmpTarget.push(tmpValue);

		// Auto-expand the parent so the new element is visible
		if (pPath)
		{
			this._ExpandedPaths.add(pPath);
		}

		this.renderTree();
	}

	/**
	 * Remove an element from an array at a given path by index.
	 */
	removeArrayElement(pPath, pIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex < 0 || tmpIntIndex >= tmpTarget.length)
		{
			return;
		}

		// Clean up expanded paths for the removed element and shift higher indices
		let tmpRemovedPath = pPath ? (pPath + '[' + tmpIntIndex + ']') : ('[' + tmpIntIndex + ']');
		this._cleanupExpandedPaths(tmpRemovedPath);
		this._shiftArrayExpandedPaths(pPath, tmpIntIndex, tmpTarget.length);

		tmpTarget.splice(tmpIntIndex, 1);

		this.renderTree();
	}

	/**
	 * Remove a node from its parent, auto-detecting whether parent is object or array.
	 * Works by parsing the path to find the parent and key/index.
	 */
	removeNode(pPath)
	{
		if (!pPath)
		{
			return;
		}

		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		// Determine if the last segment is a bracket index or a dot key
		let tmpBracketMatch = pPath.match(/^(.*)\[(\d+)\]$/);
		if (tmpBracketMatch)
		{
			// Array element: parent path is the part before [N]
			let tmpParentPath = tmpBracketMatch[1];
			let tmpIndex = parseInt(tmpBracketMatch[2], 10);
			this.removeArrayElement(tmpParentPath, tmpIndex);
		}
		else
		{
			// Object property: parent path is everything before the last dot
			let tmpLastDot = pPath.lastIndexOf('.');
			if (tmpLastDot === -1)
			{
				// Top-level key — parent is root
				let tmpKey = pPath;
				this.removeObjectProperty('', tmpKey);
			}
			else
			{
				let tmpParentPath = pPath.substring(0, tmpLastDot);
				let tmpKey = pPath.substring(tmpLastDot + 1);
				this.removeObjectProperty(tmpParentPath, tmpKey);
			}
		}
	}

	// --- Array Reorder API ---

	/**
	 * Move an array element up by one position (swap with the element before it).
	 * If already at index 0 this is a no-op.
	 */
	moveArrayElementUp(pPath, pIndex)
	{
		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex <= 0)
		{
			return;
		}
		this.moveArrayElementToIndex(pPath, tmpIntIndex, tmpIntIndex - 1);
	}

	/**
	 * Move an array element down by one position (swap with the element after it).
	 * If already at the last index this is a no-op.
	 */
	moveArrayElementDown(pPath, pIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex < 0 || tmpIntIndex >= tmpTarget.length - 1)
		{
			return;
		}
		this.moveArrayElementToIndex(pPath, tmpIntIndex, tmpIntIndex + 1);
	}

	/**
	 * Move an array element from one index to another.
	 * If pNewIndex is out of bounds it is clamped to [0, length-1].
	 */
	moveArrayElementToIndex(pPath, pFromIndex, pToIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpFrom = parseInt(pFromIndex, 10);
		if (isNaN(tmpFrom) || tmpFrom < 0 || tmpFrom >= tmpTarget.length)
		{
			return;
		}

		let tmpTo = parseInt(pToIndex, 10);
		if (isNaN(tmpTo))
		{
			return;
		}
		// Clamp to valid range
		if (tmpTo < 0)
		{
			tmpTo = 0;
		}
		if (tmpTo >= tmpTarget.length)
		{
			tmpTo = tmpTarget.length - 1;
		}

		if (tmpFrom === tmpTo)
		{
			return;
		}

		// Update expanded paths before mutating the array
		this._moveArrayExpandedPaths(pPath, tmpFrom, tmpTo, tmpTarget.length);

		// Splice the element out and insert at the new position
		let tmpElement = tmpTarget.splice(tmpFrom, 1)[0];
		tmpTarget.splice(tmpTo, 0, tmpElement);

		this.renderTree();
	}

	/**
	 * Begin adding a new property to an object by showing an inline key input
	 * and a type selector dropdown.
	 */
	beginAddToObject(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		let tmpRowElement = tmpTreeElement.querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		// Create an inline input for the key name
		let tmpInput = document.createElement('input');
		tmpInput.type = 'text';
		tmpInput.className = 'pict-oe-key-input';
		tmpInput.placeholder = 'key';

		// Create a type selector dropdown
		let tmpSelect = this._createTypeSelect();

		let tmpSelf = this;
		let tmpCommitted = false;
		let tmpCommit = function()
		{
			if (tmpCommitted)
			{
				return;
			}
			tmpCommitted = true;
			let tmpKey = tmpInput.value.trim();
			if (tmpKey)
			{
				let tmpDefaultValue = tmpSelf._getDefaultValueForType(tmpSelect.value);
				tmpSelf.addObjectProperty(pPath, tmpKey, tmpDefaultValue);
			}
			else
			{
				tmpSelf.renderTree();
			}
		};

		tmpInput.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		tmpSelect.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		// Commit when focus leaves both elements
		let tmpBlurTimeout = null;
		let tmpHandleBlur = function()
		{
			clearTimeout(tmpBlurTimeout);
			tmpBlurTimeout = setTimeout(function()
			{
				// Check if focus moved to the other element in the pair
				if (document.activeElement !== tmpInput && document.activeElement !== tmpSelect)
				{
					tmpCommit();
				}
			}, 150);
		};

		tmpInput.addEventListener('blur', tmpHandleBlur);
		tmpSelect.addEventListener('blur', tmpHandleBlur);

		// Insert before the actions container
		let tmpActionsSpan = tmpRowElement.querySelector('.pict-oe-actions');
		if (tmpActionsSpan)
		{
			tmpRowElement.insertBefore(tmpInput, tmpActionsSpan);
			tmpRowElement.insertBefore(tmpSelect, tmpActionsSpan);
		}
		else
		{
			tmpRowElement.appendChild(tmpInput);
			tmpRowElement.appendChild(tmpSelect);
		}
		tmpInput.focus();
	}

	/**
	 * Begin adding a new element to an array by showing a type selector dropdown.
	 */
	beginAddToArray(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		let tmpRowElement = tmpTreeElement.querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		// Create a type selector dropdown
		let tmpSelect = this._createTypeSelect();

		let tmpSelf = this;
		let tmpCommitted = false;
		let tmpCommit = function()
		{
			if (tmpCommitted)
			{
				return;
			}
			tmpCommitted = true;
			let tmpDefaultValue = tmpSelf._getDefaultValueForType(tmpSelect.value);
			tmpSelf.addArrayElement(pPath, tmpDefaultValue);
		};

		tmpSelect.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		tmpSelect.addEventListener('blur', function()
		{
			setTimeout(function()
			{
				tmpCommit();
			}, 100);
		});

		// Insert before the actions container
		let tmpActionsSpan = tmpRowElement.querySelector('.pict-oe-actions');
		if (tmpActionsSpan)
		{
			tmpRowElement.insertBefore(tmpSelect, tmpActionsSpan);
		}
		else
		{
			tmpRowElement.appendChild(tmpSelect);
		}
		tmpSelect.focus();
	}

	/**
	 * Create a type selector <select> element for choosing the type of a new entry.
	 */
	_createTypeSelect()
	{
		let tmpSelect = document.createElement('select');
		tmpSelect.className = 'pict-oe-type-select';

		let tmpTypes = ['String', 'Number', 'Boolean', 'Null', 'Object', 'Array'];
		for (let i = 0; i < tmpTypes.length; i++)
		{
			let tmpOption = document.createElement('option');
			tmpOption.value = tmpTypes[i];
			tmpOption.textContent = tmpTypes[i];
			tmpSelect.appendChild(tmpOption);
		}

		return tmpSelect;
	}

	/**
	 * Return the default value for a given type name.
	 */
	_getDefaultValueForType(pTypeName)
	{
		switch (pTypeName)
		{
			case 'Number':
				return 0;
			case 'Boolean':
				return false;
			case 'Null':
				return null;
			case 'Object':
				return {};
			case 'Array':
				return [];
			case 'String':
			default:
				return '';
		}
	}

	// --- Marshal lifecycle ---

	marshalToView()
	{
		this.renderTree();
		return super.marshalToView();
	}

	// --- Tree rendering ---

	/**
	 * Render the visible tree into the container element.
	 */
	renderTree()
	{
		let tmpData = this._resolveObjectData();
		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		if (tmpData === null || tmpData === undefined)
		{
			this.pict.ContentAssignment.assignContent(tmpTreeElement, '<div class="pict-oe-empty">No data</div>');
			return;
		}

		let tmpOptions =
		{
			Editable: this.options.Editable,
			ShowTypeIndicators: this.options.ShowTypeIndicators,
			IndentPixels: this.options.IndentPixels,
			ViewHash: this.Hash
		};

		let tmpHTML = '';

		if (typeof tmpData === 'object' && !Array.isArray(tmpData))
		{
			// Render top-level object keys without a root wrapper node
			tmpHTML = this._walkObject(tmpData, '', 0, tmpOptions, true);
			// Add a root-level "add property" button when editable
			if (tmpOptions.Editable)
			{
				tmpHTML += this.pict.parseTemplate(
					this.options.MacroTemplates.Node.RootAddObject,
					{},
					null,
					[this]
				);
			}
		}
		else if (Array.isArray(tmpData))
		{
			// Render top-level array elements without a root wrapper node
			tmpHTML = this._walkArray(tmpData, '', 0, tmpOptions, true);
			// Add a root-level "add element" button when editable
			if (tmpOptions.Editable)
			{
				tmpHTML += this.pict.parseTemplate(
					this.options.MacroTemplates.Node.RootAddArray,
					{},
					null,
					[this]
				);
			}
		}
		else
		{
			// Single primitive value at root
			let tmpNode =
			{
				Path: '',
				Key: '(root)',
				Depth: 0,
				DataType: this._getJsonType(tmpData),
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: false,
				ArrayIndex: -1
			};
			let tmpRenderer = this._NodeRenderers[tmpNode.DataType];
			if (tmpRenderer)
			{
				tmpHTML = tmpRenderer.renderNodeHTML(tmpNode, tmpData, tmpOptions);
			}
		}

		if (!tmpHTML)
		{
			tmpHTML = '<div class="pict-oe-empty">Empty object</div>';
		}

		this.pict.ContentAssignment.assignContent(tmpTreeElement, tmpHTML);
	}

	// --- Internal tree walking ---

	_walkObject(pValue, pBasePath, pDepth, pOptions, pIsRoot)
	{
		let tmpHTML = '';
		let tmpKeys = Object.keys(pValue);

		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pBasePath ? (pBasePath + '.' + tmpKey) : tmpKey;
			let tmpChildValue = pValue[tmpKey];
			let tmpType = this._getJsonType(tmpChildValue);

			let tmpNode =
			{
				Path: tmpChildPath,
				Key: tmpKey,
				Depth: pDepth,
				DataType: tmpType,
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: false,
				ArrayIndex: -1
			};

			if (tmpType === 'object')
			{
				let tmpChildKeys = (tmpChildValue !== null) ? Object.keys(tmpChildValue) : [];
				tmpNode.HasChildren = tmpChildKeys.length > 0;
				tmpNode.ChildCount = tmpChildKeys.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.object;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkObject(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else if (tmpType === 'array')
			{
				tmpNode.HasChildren = tmpChildValue.length > 0;
				tmpNode.ChildCount = tmpChildValue.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.array;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkArray(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else
			{
				let tmpRenderer = this._NodeRenderers[tmpType];
				if (tmpRenderer)
				{
					tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);
				}
			}
		}

		return tmpHTML;
	}

	_walkArray(pValue, pBasePath, pDepth, pOptions, pIsRoot)
	{
		let tmpHTML = '';

		for (let i = 0; i < pValue.length; i++)
		{
			let tmpChildPath = pBasePath ? (pBasePath + '[' + i + ']') : ('[' + i + ']');
			let tmpChildValue = pValue[i];
			let tmpType = this._getJsonType(tmpChildValue);

			let tmpNode =
			{
				Path: tmpChildPath,
				Key: String(i),
				Depth: pDepth,
				DataType: tmpType,
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: true,
				ArrayIndex: i
			};

			if (tmpType === 'object')
			{
				let tmpChildKeys = (tmpChildValue !== null) ? Object.keys(tmpChildValue) : [];
				tmpNode.HasChildren = tmpChildKeys.length > 0;
				tmpNode.ChildCount = tmpChildKeys.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.object;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkObject(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else if (tmpType === 'array')
			{
				tmpNode.HasChildren = tmpChildValue.length > 0;
				tmpNode.ChildCount = tmpChildValue.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.array;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkArray(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else
			{
				let tmpRenderer = this._NodeRenderers[tmpType];
				if (tmpRenderer)
				{
					tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);
				}
			}
		}

		return tmpHTML;
	}

	// --- Utility methods ---

	_getJsonType(pValue)
	{
		if (pValue === null || pValue === undefined)
		{
			return 'null';
		}
		if (Array.isArray(pValue))
		{
			return 'array';
		}
		let tmpType = typeof pValue;
		if (tmpType === 'object')
		{
			return 'object';
		}
		if (tmpType === 'number')
		{
			return 'number';
		}
		if (tmpType === 'boolean')
		{
			return 'boolean';
		}
		return 'string';
	}

	_resolveObjectData()
	{
		if (!this.options.ObjectDataAddress)
		{
			return null;
		}

		// Support "AppData.SomeKey" style addresses
		let tmpAddress = this.options.ObjectDataAddress;
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.fable;

		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}

		return tmpCurrent;
	}

	_getTreeElement()
	{
		let tmpElementId = 'ObjectEditor-Tree-' + this.Hash;
		let tmpElements = this.pict.ContentAssignment.getElement('#' + tmpElementId);
		if (tmpElements && tmpElements.length > 0)
		{
			return tmpElements[0];
		}
		return null;
	}

	_getValueAtPath(pObject, pPath)
	{
		if (!pPath)
		{
			return pObject;
		}

		let tmpSegments = this._parsePath(pPath);
		let tmpCurrent = pObject;

		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return undefined;
			}
			tmpCurrent = tmpCurrent[tmpSegments[i]];
		}

		return tmpCurrent;
	}

	_setValueAtPath(pObject, pPath, pValue)
	{
		if (!pPath)
		{
			return;
		}

		let tmpSegments = this._parsePath(pPath);
		let tmpCurrent = pObject;

		for (let i = 0; i < tmpSegments.length - 1; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return;
			}
			tmpCurrent = tmpCurrent[tmpSegments[i]];
		}

		if (tmpCurrent !== null && tmpCurrent !== undefined)
		{
			tmpCurrent[tmpSegments[tmpSegments.length - 1]] = pValue;
		}
	}

	/**
	 * Parse a dotted path with bracket notation into segments.
	 * e.g., "config.items[2].name" -> ["config", "items", 2, "name"]
	 */
	_parsePath(pPath)
	{
		let tmpSegments = [];
		let tmpParts = pPath.split('.');

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];
			// Check for bracket notation
			let tmpBracketMatch = tmpPart.match(/^([^\[]*)\[(\d+)\]$/);
			if (tmpBracketMatch)
			{
				if (tmpBracketMatch[1])
				{
					tmpSegments.push(tmpBracketMatch[1]);
				}
				tmpSegments.push(parseInt(tmpBracketMatch[2], 10));
			}
			else if (tmpPart)
			{
				tmpSegments.push(tmpPart);
			}
		}

		return tmpSegments;
	}

	/**
	 * Remove all expanded paths that reference a deleted subtree.
	 */
	_cleanupExpandedPaths(pRemovedPath)
	{
		let tmpToRemove = [];
		this._ExpandedPaths.forEach(function(tmpPath)
		{
			if (tmpPath === pRemovedPath || tmpPath.indexOf(pRemovedPath + '.') === 0 || tmpPath.indexOf(pRemovedPath + '[') === 0)
			{
				tmpToRemove.push(tmpPath);
			}
		});

		for (let i = 0; i < tmpToRemove.length; i++)
		{
			this._ExpandedPaths.delete(tmpToRemove[i]);
		}
	}

	/**
	 * After removing an array element, shift expanded paths for higher indices down by one.
	 * e.g., if we removed items[2], then items[3] becomes items[2], items[4] becomes items[3], etc.
	 */
	_shiftArrayExpandedPaths(pArrayPath, pRemovedIndex, pOriginalLength)
	{
		let tmpPrefix = pArrayPath ? pArrayPath : '';

		for (let i = pRemovedIndex + 1; i < pOriginalLength; i++)
		{
			let tmpOldPath = tmpPrefix + '[' + i + ']';
			let tmpNewPath = tmpPrefix + '[' + (i - 1) + ']';

			// Collect all expanded paths that start with the old path
			let tmpToRename = [];
			this._ExpandedPaths.forEach(function(tmpPath)
			{
				if (tmpPath === tmpOldPath)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath });
				}
				else if (tmpPath.indexOf(tmpOldPath + '.') === 0)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath + tmpPath.substring(tmpOldPath.length) });
				}
				else if (tmpPath.indexOf(tmpOldPath + '[') === 0)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath + tmpPath.substring(tmpOldPath.length) });
				}
			});

			for (let j = 0; j < tmpToRename.length; j++)
			{
				this._ExpandedPaths.delete(tmpToRename[j].old);
				this._ExpandedPaths.add(tmpToRename[j].replacement);
			}
		}
	}

	/**
	 * Update expanded paths when an array element moves from one index to another.
	 * Works by collecting all paths for every index in the affected range,
	 * then remapping them to their new positions.
	 */
	_moveArrayExpandedPaths(pArrayPath, pFromIndex, pToIndex, pLength)
	{
		let tmpPrefix = pArrayPath ? pArrayPath : '';

		// Determine the range of indices affected by the move
		let tmpMinIndex = Math.min(pFromIndex, pToIndex);
		let tmpMaxIndex = Math.max(pFromIndex, pToIndex);

		// Collect all expanded paths for every index in the affected range
		// Map: index -> array of { suffix } (the part after the [N])
		let tmpPathsByIndex = {};
		for (let i = tmpMinIndex; i <= tmpMaxIndex; i++)
		{
			tmpPathsByIndex[i] = [];
		}

		let tmpToRemove = [];
		let tmpSelf = this;

		this._ExpandedPaths.forEach(function(tmpPath)
		{
			for (let i = tmpMinIndex; i <= tmpMaxIndex; i++)
			{
				let tmpIndexPath = tmpPrefix + '[' + i + ']';
				if (tmpPath === tmpIndexPath)
				{
					tmpPathsByIndex[i].push('');
					tmpToRemove.push(tmpPath);
				}
				else if (tmpPath.indexOf(tmpIndexPath + '.') === 0)
				{
					tmpPathsByIndex[i].push(tmpPath.substring(tmpIndexPath.length));
					tmpToRemove.push(tmpPath);
				}
				else if (tmpPath.indexOf(tmpIndexPath + '[') === 0)
				{
					tmpPathsByIndex[i].push(tmpPath.substring(tmpIndexPath.length));
					tmpToRemove.push(tmpPath);
				}
			}
		});

		// Remove old paths
		for (let i = 0; i < tmpToRemove.length; i++)
		{
			this._ExpandedPaths.delete(tmpToRemove[i]);
		}

		// Compute new index mapping:
		// When moving from -> to, the element at pFromIndex goes to pToIndex,
		// and all elements between shift by 1 in the opposite direction.
		let tmpNewIndexMap = {};
		if (pFromIndex < pToIndex)
		{
			// Moving forward: elements between (from+1..to) shift down by 1
			tmpNewIndexMap[pFromIndex] = pToIndex;
			for (let i = pFromIndex + 1; i <= pToIndex; i++)
			{
				tmpNewIndexMap[i] = i - 1;
			}
		}
		else
		{
			// Moving backward: elements between (to..from-1) shift up by 1
			tmpNewIndexMap[pFromIndex] = pToIndex;
			for (let i = pToIndex; i < pFromIndex; i++)
			{
				tmpNewIndexMap[i] = i + 1;
			}
		}

		// Re-add paths at their new indices
		let tmpOldIndices = Object.keys(tmpPathsByIndex);
		for (let i = 0; i < tmpOldIndices.length; i++)
		{
			let tmpOldIndex = parseInt(tmpOldIndices[i], 10);
			let tmpNewIndex = tmpNewIndexMap[tmpOldIndex];
			let tmpSuffixes = tmpPathsByIndex[tmpOldIndex];
			for (let j = 0; j < tmpSuffixes.length; j++)
			{
				this._ExpandedPaths.add(tmpPrefix + '[' + tmpNewIndex + ']' + tmpSuffixes[j]);
			}
		}
	}

	/**
	 * Recursively expand paths up to a given depth.
	 */
	_expandToDepth(pValue, pBasePath, pCurrentDepth, pMaxDepth)
	{
		if (pValue === null || pValue === undefined || typeof pValue !== 'object')
		{
			return;
		}

		if (Array.isArray(pValue))
		{
			for (let i = 0; i < pValue.length; i++)
			{
				let tmpChildPath = pBasePath ? (pBasePath + '[' + i + ']') : ('[' + i + ']');
				if (typeof pValue[i] === 'object' && pValue[i] !== null)
				{
					// Mark this child as expanded (it's an object or array that can be toggled)
					this._ExpandedPaths.add(tmpChildPath);
					if (pCurrentDepth + 1 < pMaxDepth)
					{
						this._expandToDepth(pValue[i], tmpChildPath, pCurrentDepth + 1, pMaxDepth);
					}
				}
			}
		}
		else
		{
			let tmpKeys = Object.keys(pValue);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpKey = tmpKeys[i];
				let tmpChildPath = pBasePath ? (pBasePath + '.' + tmpKey) : tmpKey;
				let tmpChildValue = pValue[tmpKey];
				if (typeof tmpChildValue === 'object' && tmpChildValue !== null)
				{
					// Mark this child as expanded (it's an object or array that can be toggled)
					this._ExpandedPaths.add(tmpChildPath);
					if (pCurrentDepth + 1 < pMaxDepth)
					{
						this._expandToDepth(tmpChildValue, tmpChildPath, pCurrentDepth + 1, pMaxDepth);
					}
				}
			}
		}
	}
}

module.exports = PictViewObjectEditor;

module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-ObjectEditor-DefaultConfiguration.js":697,"./PictView-ObjectEditor-NodeArray.js":700,"./PictView-ObjectEditor-NodeBoolean.js":701,"./PictView-ObjectEditor-NodeNull.js":702,"./PictView-ObjectEditor-NodeNumber.js":703,"./PictView-ObjectEditor-NodeObject.js":704,"./PictView-ObjectEditor-NodeString.js":705,"pict-view":733}],707:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;
const css = String.raw;

const hatchScale = 1000;

function buildHatchPattern(color, bounds)
{
	const scaleFactor = bounds.x > bounds.y ? bounds.x : bounds.y;
	const scale = scaleFactor / hatchScale;
	const svg = /*html*/`
		<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
			<pattern id="hatch" width="9" height="1" patternUnits="userSpaceOnUse" patternTransform="rotate(45) scale(${ scale })">
				<rect x="0" y="0" width="3" height="1" fill="${ color }" fill-opacity="30%"/>
			</pattern>
		</svg>
	`;
	return "url('data:image/svg+xml;utf8, " + encodeURIComponent(svg) + "#hatch') !important;";
}

const default_configuration = 
{
	"RenderOnLoad": true,
	"DefaultRenderable": "OpenSeaDragon-Wrap",
	"DefaultDestinationAddress": "#OpenSeaDragon-Container-Div",
	"EnableAnnotation": false,
	"DisableFullscreen": true,
	"DisableButtons": false,
	"PrefixUrl": '/',
	"TileSources": {},
	"ViewAddress": 'PictSectionOpenSeaDragon',
	"OSDASViewAddress": 'PictSectionOpenSeaDragonAnnotationSelector',
	"Colors": {
		"red": "red",
		"green": "green",
		"blue": "blue"
	},
	"Annotations": [],
	"DrawModeLabel": "Annotation",
	"HatchModeLabel": "Hatching",
	"Templates": [
		{
			"Hash": "OpenSeaDragon-Container",
			"Template": html`
				<div class="osd-container-wrapper" id="OSD-Containers-Wrapper">
					<div id="OpenSeaDragon-Element" class="osd-default"></div>
					<div id="OSD-Toolbar" class="osd-height-zero osd-toolbar">
						<div id="DrawingToolbar" class="osd-drawing-toolbar"></div>
						<div id="ColorPickerToolbar" class="osd-color-picker-toolbar"></div>
					</div>
					<div id="DrawingModeToggle" class="osd-height-zero osd-drawmode-toggle-box">
					</div>
				</div>
				<div id="OSD-SVG-Sandbox" class="osd-sandbox"></div>
				<style id="ColorOverrides"></style>
				<style id="SelectedColorOverride"></style>
				<style id="OSDGeneralStyling">
					.osd-drawmode-toggle-box {
						display: flex;
					}
					.osd-drawmode-text {
						font-size: 17px;
						font-family: Lato,sans-serif;
						margin-left: 5px;
						margin-right: 5px;
					}
					.osd-drawmode-switch {
						position: relative;
						display: inline-block;
						width: 40px;
						height: 20px;
						background-color: rgba(0, 0, 0, 0.25);
						border-radius: 20px;
						transition: all 0.3s;
						cursor: pointer;
					}
					.osd-drawmode-switch::after {
						content: '';
						position: absolute;
						width: 18px;
						height: 18px;
						border-radius:50%;
						background-color: white;
						top: 1px;
						left: 1px;
						transition: all 0.3s;
					}
					.osd-drawmode-checkbox:checked + .osd-drawmode-switch::after {
						left : 20px;
					}
					.osd-drawmode-checkbox:checked + .osd-drawmode-switch {
						background-color: var(--theme-color-brand-primary, #7983ff);
					}
					.osd-drawmode-checkbox {
						display : none;
					}
					.osd-hatchmode-toggle-box {
						display: flex;
					}
					.osd-hatchmode-text {
						font-size: 17px;
						font-family: Lato,sans-serif;
						margin-left: 5px;
						margin-right: 5px;
					}
					.osd-hatchmode-switch {
						position: relative;
						display: inline-block;
						width: 40px;
						height: 20px;
						background-color: rgba(0, 0, 0, 0.25);
						border-radius: 20px;
						transition: all 0.3s;
						cursor: pointer;
						margin-left: 20px;
					}
					.osd-hatchmode-switch::after {
						content: '';
						position: absolute;
						width: 18px;
						height: 18px;
						border-radius:50%;
						background-color: white;
						top: 1px;
						left: 1px;
						transition: all 0.3s;
					}
					.osd-hatchmode-checkbox:checked + .osd-hatchmode-switch::after {
						left : 20px;
					}
					.osd-hatchmode-checkbox:checked + .osd-hatchmode-switch {
						background-color: var(--theme-color-brand-primary, #7983ff);
					}
					.osd-hatchmode-checkbox {
						display : none;
					}
					.osd-sandbox {
						pointer-events: none; 
						width: 100vw; 
						height: 100vh; 
						top:0; left:0; 
						background-color: transparent; 
						position: absolute;
					}
					.osd-container-wrapper {
						width: 100%; 
						height: 100%; 
						display: flex; 
						flex-direction: column;
					}
					.osd-drawing-toolbar {
						min-width: 320px;
					}
					.osd-color-picker-toolbar {
						display: flex; 
						flex-direction: row;
					}
					.osd-default {
						margin-left: 20px; 
						height: 100%;
						width: calc(100% - 25px);
					}
					.osd-color-active {
						background-color: rgba(0, 0, 0, 0.3) !important;
					}
					.osd-with-annotations {
						height: calc(100% - 55px) !important;
					}
					.osd-height-zero {
						height: 0px !important;
					}
					.osd-width-zero {
						width: 0px !important;
					}
					.osd-color-button-class {
						margin:4px 4px 4px 0;
						background-color: transparent;
						cursor: pointer;
						border-radius: 4px;
						padding: 8px;
						width: 45px;
						height: 45px;
						border: 0px;
					}
					.osd-color-button-class:hover {
						background-color:rgba(0,0,0,0.05);
					}
					.osd-toolbar {
						height: 55px;
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
					}
					.osd-annotations-panel-open {
						width: 80% !important
					}
					.osd-color-subcircle {
						display: block;
						height: 20px;
						width: 20px;
						border: 1px solid black;
						border-radius: 50%;
						margin: auto;
					}
				</style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "OpenSeaDragon-Wrap",
			"TemplateHash": "OpenSeaDragon-Container",
			"DestinationAddress": "#OpenSeaDragon-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#OpenSeaDragon-Container-Div"
};

class PictSectionOpenSeaDragon extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.triggerRender = false;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElementAddress = false;
	}

	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		this.hatchMode = false;
		let tmpTargetElementSet = this.services.ContentAssignment.getElement('#OpenSeaDragon-Element');
		if (tmpTargetElementSet.length < 1)
		{
			this.log.error(`Could not find target element [#OpenSeaDragon-Element] for OpenSeaDragon!  Rendering won't function properly.`);
			this.targetElement = false;
			return false;
		}
		else
		{
			this.targetElement = tmpTargetElementSet[0];
		}
		let tmpToolbarElementSet = this.services.ContentAssignment.getElement('#DrawingToolbar');
		if (tmpToolbarElementSet.length < 1)
		{
			this.log.error(`Could not find target element [#DrawingToolbar] for Annotator Toolbar!  Annotations won't function properly.`);
			this.toolbarElement = false;
			return false;
		}
		else
		{
			this.toolbarElement = tmpToolbarElementSet[0];
		}

		// Settings for configuring OpenSeaDragon.
		this.osdSettings = 
		{
			element: this.targetElement,
			prefixUrl: this.options.PrefixUrl,
			tileSources: this.options.TileSources,
			showFullPageControl: !this.options.DisableFullscreen,
			showZoomControl: !this.options.DisableButtons,
			showHomeControl: !this.options.DisableButtons
		};

		// Color formatter for Annotorious. Works with the styleClass attribute and the color class system which is config based.
		this.format = (annotation) => {
			return 'pict-osd-' + (annotation?.underlying?.target?.styleClass || (this.hatchMode ? this.color + '-hatched' : this.color) || 'red');
		};

		this.customConfigureViewerSettings();

		// Instantiate the OpenSeaDragon element.
		if (this.viewer)
		{
			this.viewer.destroy();
		}

		// Annotorious (and its plugin globals: Annotorious, SelectorPack, BetterPolygon, ...) is required by
		// default. Pass { Annotorious: false } in the view options to run as a plain OpenSeaDragon deep-zoom
		// viewer with no annotation layer, so a host need not load the Annotorious globals at all. Existing
		// consumers that do not set the flag are unaffected.
		this.annotoriousEnabled = (this.options.Annotorious !== false);
		// We only need to instantiate Annotorious if a set of annotations were passed in, or annotation editing is enabled.
		this.editingEnabled = this.annotoriousEnabled && this.options.EnableAnnotation && this.toolbarElement;

		this.viewer = OpenSeadragon(this.osdSettings);
		this.viewer.addHandler('open', () => {
			// Inject a stylesheet based on the set of colors passed into the component.
			let colorStyles = '';
			if (Object.keys(this.options?.Colors)?.length)
			{
				this.colorSet = this.options.Colors;
				for (let color of Object.keys(this.colorSet))
				{
					colorStyles += css`
						.pict-osd-${ color } > * {
							stroke: ${ this.colorSet[color] } !important;
							stroke-width: 2 !important;
						}
						.pict-osd-fill-${ color } {
							fill: ${ this.colorSet[color] } !important;
						}
						.pict-osd-${ color }-hatched > * {
							stroke: ${ this.colorSet[color] } !important;
							stroke-width: 2 !important;
							fill: ${ buildHatchPattern(this.colorSet[color], this.viewer?.world?.getItemAt(0)?.getContentSize() || { x: hatchScale, y: hatchScale }) }
						}
					`;
				}
			}
			else
			{
				this.assignColor('red');
				colorStyles += css`
					.pict-osd-red > * {
						stroke: red !important;
						stroke-width: 2 !important;
					}
				`;
			}
			this.pict.ContentAssignment.assignContent('#ColorOverrides', colorStyles);
			// If a custom color set was passed via config, add those custom colors to the toolbar if editing is enabled.
			if (this.colorSet && this.editingEnabled)
			{
				let colorSelectorTemplate = ``;
				for (let color of Object.keys(this.colorSet))
				{
					colorSelectorTemplate += html`
						<button type="button" class="osd-color-button-class" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.assignColor('${ color }')" id="ColorSelector${ color }">
							<div title="Color ${ color }" style="background-color: ${ this.colorSet[color] };" class="osd-color-subcircle"></div>
						</button>
					`;
				}
				this.pict.ContentAssignment.assignContent('#ColorPickerToolbar', `
					${ colorSelectorTemplate }
				`);
				this.assignColor(Object.keys(this.colorSet)[0]);
			}
			else
			{
				this.assignColor('red');
			}
		});

		if (this.annotoriousEnabled && (this.editingEnabled || this.options.Annotations?.length))
		{
			this.AnnotationsPanel = this.pict.views?.[this.options.OSDASViewAddress];
			if (!this.AnnotationsPanel)
			{
				this.triggerRender = true;
			}
			if (this.AnnotationsPanel && this.triggerRender)
			{
				this.triggerRender = false;
				this.AnnotationsPanel.render();
			}

			// Settings for configuring Annotorious.
			this.annoSettings = {
				allowEmpty: true,
				disableEditor: !this.editingEnabled,
				disableSelect: !this.editingEnabled
			};

			if (this.annotator){
				this.annotator.destroy();
			}

			// Instantiate Annotorious.
			this.annotator = OpenSeadragon.Annotorious(this.viewer, this.annoSettings);	

			// Apply the custom color formatter.
			this.annotator.formatters = [this.format];

			// Instantiate Annotorious Plugins.
			Annotorious.SelectorPack(this.annotator, 
			{
				tools: ['circle', 'ellipse', 'rect', 'freehand', 'polygon', 'line']
			});
			Annotorious.BetterPolygon(this.annotator);
			
			if (Annotorious.PictPack)
			{
				Annotorious.PictPack(this.annotator);
			}

			// If editing is enabled, reflow the ui to include the editing toolbar.
			if (this.editingEnabled)
			{
				this.pict.ContentAssignment.addClass('#OpenSeaDragon-Element', 'osd-with-annotations');
				this.pict.ContentAssignment.removeClass('#OSD-Toolbar', 'osd-height-zero');
				this.pict.ContentAssignment.removeClass('#DrawingModeToggle', 'osd-height-zero');
				Annotorious.Toolbar(this.annotator, this.toolbarElement, { withMouse: true, withTooltip:false });
			}

			//Inject any annotations passed via config.
			if (this.options.Annotations?.length)
			{
				for (let a of this.options.Annotations)
				{
					this.annotator.addAnnotation(a);
				}
				this.AnnotationsPanel?.updateAnnotationsPanel();
			}

			// Apply hooks for the annotation events.
			this.annotator.on('createAnnotation', (annotation, overrideID) => { this.annotationCreationHook(annotation, overrideID) });
			this.annotator.on('selectAnnotation', (annotation, element) => { this.annotationSelectionHook(annotation, element); });
			this.annotator.on('updateAnnotation', (annotation, previousState) => { this.annotationUpdateHook(annotation, previousState); });
			this.annotator.on('deleteAnnotation', (annotation) => { this.annotationDeleteHook(annotation); });
			this.annotator.on('createSelection', async (selection) => { this.selectionCreateHook(selection) });
			this.viewer.addHandler('canvas-double-click', (event) => { this.canvasDoubleClickHook(event); });

			if (this.editingEnabled)
			{
				const drawingModeTemplate = html`
					<input title="Toggle ${ this.options?.DrawModeLabel || 'Annotation' }" type="checkbox" id="osd-drawmode-toggle" class="osd-drawmode-checkbox" checked onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.toggleDrawingMode()"/>  
					<label for="osd-drawmode-toggle" class="osd-drawmode-switch"></label>
			 		<span title="Toggle ${ this.options?.DrawModeLabel || 'Annotation' }" class="osd-drawmode-text"> ${ this.options?.DrawModeLabel || 'Annotation' } </span>
					<input title="Toggle ${ this.options?.HatchModeLabel || 'Hatching' }" type="checkbox" id="osd-hatchmode-toggle" class="osd-hatchmode-checkbox" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.toggleHatchMode()"/>  
					<label for="osd-hatchmode-toggle" class="osd-hatchmode-switch"></label>
			 		<span title="Toggle ${ this.options?.HatchModeLabel || 'Hatching' }" class="osd-hatchmode-text"> ${ this.options?.HatchModeLabel || 'Hatching' } </span>`;
				this.pict.ContentAssignment.assignContent('#DrawingModeToggle', `
					${ drawingModeTemplate }
				`);
				const arrowToolButton = html`
					<button type="button" class="a9s-toolbar-btn arrow" title="Arrow" aria-label="Create a Arrow annotation" onclick="_Pict.views.${ this.options.ViewAddress || 'OSDSection' }.selectDrawingTool(event, 'arrow')">
						<span class="a9s-toolbar-btn-inner">
							<svg viewBox="0 0 70 50">
								<g>
									<path d="M 12 47 L 55 14 L 52 10 L 60 10 L 60 18 L 55 14 Z"></path>
									<g class="handles">
										<circle cx="12" cy="47" r="5"></circle>
									</g>
								</g>
							</svg>
						</span>
					</button>`;
				this.pict.ContentAssignment.appendContent('#DrawingToolbar .a9s-toolbar', arrowToolButton);
				this.annotator.disableEditor = false;
			}
		}
		else if (this.annotoriousEnabled)
		{
			// Instantiate Annotorious then destroy it in case there's any left over state that needs to be cleared.
			this.annotator = OpenSeadragon.Annotorious(this.viewer, {
				disableEditor: true,
				disableSelect: true
			});	
			this.annotator.destroy();
		}
	}

	// Set a new tile source. Can optionally rerender the component as well.
	setTileSources(tileSources, reRender)
	{
		this.options.TileSources = tileSources;
		if (reRender)
		{
			this.render();
		}
	}

	// Set an Annotation set. Can optionally rerender component as well.
	setAnnotations(annotations, reRender)
	{
		if (this.annotator) { this.annotator.clearAnnotations(); }
		this.options.Annotations = annotations;
		if (reRender)
		{
			this.render();
		}
	}

	/**
	 * This is expected to be overloaded with anything that needs to be added to the OpenSeaDragon configuration.
	 */
	customConfigureViewerSettings ()
	{
		// This can be overloaded to tweak this.osdSettings and this.annoSettings.
	}

	// Sets the current drawing color for annotations.
	assignColor (color)
	{
		this.color = color;
		if (this.colorSet)
		{
			for (let tempColor of Object.keys(this.colorSet))
			{
				this.pict.ContentAssignment.removeClass(`#ColorSelector${ tempColor }`, 'osd-color-active');
			}
		}

		// Set the active color in the toolbar.
		this.pict.ContentAssignment.addClass(`#ColorSelector${ color }`, 'osd-color-active');

		// Override the annotator drawing styles based on the selected color.
		this.pict.ContentAssignment.assignContent('#SelectedColorOverride', css`
			.a9s-annotation.editable.selected > g > * {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
			.a9s-selection > g > path {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
			.a9s-selection > * {
				stroke: ${ this.colorSet?.[color] || 'red' } !important;
				stroke-width: 2 !important;
			}
		`);
	}

	/**
	 * @spec focuses the viewport on the referenced annotation, if one exists
	 * @param { number | string } annotationID - the id of an annotation
	 * @returns {void}
	 */
	focusOnAnnotation(annotationID)
	{
		this.log.debug(`[focusOnAnnotation] id[${annotationID}]`);
		if (!annotationID)
		{
			this.log.warn('[focusOnAnnotation] no id provided, cannot focus on the associated element');
			return;
		}
		this.annotator.fitBoundsWithConstraints(annotationID);
	}

	/**
	 * @param {object} point - something like an OpenSeaDragon.Point, anything with an x and y property
	 */
	focusOnPoint(point)
	{
		let vp = this.viewer.viewport.viewerElementToViewportCoordinates(point);
		this.viewer.viewport.panTo(vp);
		// TODO should we re-apply constraints here? Not sure it's needed...
	}

	// Hook that runs when an annotation gets selected. By default, this just stores the style of the annotation element as part of the annotation.
	annotationCreationHook (annotation, overrideID)
	{
		if (annotation?.target){
			annotation.stylesheet = this.hatchMode ? 
			{
				"type": "CssStylesheet",
				"value": css`
					.${ this.color }-hatched > * { 
						stroke: ${ this.colorSet?.[this.color] } !important;
						stroke-width: 2 !important; 
						fill: ${ buildHatchPattern(this.colorSet?.[this.color], this.viewer?.world?.getItemAt(0)?.getContentSize() || { x: hatchScale, y: hatchScale }) }
					}
				`
			} :
			{
				"type": "CssStylesheet",
				"value": css`
					.${ this.color } > * { 
						stroke: ${ this.colorSet?.[this.color] } !important;
						stroke-width: 2 !important; 
					}
				`
			};
			annotation.target.styleClass = this.hatchMode ? `${ this.color }-hatched` : this.color;
		}
		this.AnnotationsPanel?.updateAnnotationsPanel();
	}

	// Hook that runs when an annotation gets selected. By default, this just sets the current color to whatever the selected annotation is.
	annotationSelectionHook (annotation, element)
	{
		this.assignColor(annotation?.target?.styleClass?.replace('-hatched', '') || 'red');
		if (annotation?.target?.styleClass?.includes('hatched'))
		{
			document.querySelector('#osd-hatchmode-toggle').checked = true;
			this.hatchMode = true;
		}
		else
		{
			document.querySelector('#osd-hatchmode-toggle').checked = false;
			this.hatchMode = false;
		}
		this.releaseAnnotations();
		this.focusOnAnnotation(annotation.id);
	}

	// Hook that runs when an annotation gets updated. By default this is used for updating the state of the comments side bar.
	annotationUpdateHook (annotation, previousState)
	{
		if (this.annotator?.disableEditor)
		{
			setTimeout(()=>
			{
				this.AnnotationsPanel?.updateAnnotationsPanel();
			}, 10);
		}
		else
		{
			this.AnnotationsPanel?.updateAnnotationsPanel();
		}
	}

	// Hook that runs when an annotation gets delete. By default this is used for updating the state of the comments side bar.
	annotationDeleteHook (annotation)
	{
		this.AnnotationsPanel?.updateAnnotationsPanel();
	}

	/**
	 * @spec handles the createSelection event.
	 * @param {object} selection - selection object from Annotorious API
	 */
	async selectionCreateHook (selection)
	{
		if (this.annotator.disableEditor)
		{
			// note: this updateSelected is async
			this.annotator.updateSelected(selection, true);
		}
		/**
		 * ideal: focus on selection so user can better interact with it in the viewport.
		 * Issue is, the selection doesn't yet have an ID, so cannot tell
		 * Annotorious to adjust the viewport for us.
		 * this.focusOnAnnotation(selection.id);
		 */
	}

	/**
	 *
	 * @returns {boolean} value of "current zoom >= max zoom (configured for osd)"
	 */
	maxZoomReached ()
	{
		const maxZoom = this.viewer.viewport.getMaxZoom();
		const zoom = this.viewer.viewport.getZoom(true);
		return zoom >= maxZoom;
	}

	/**
	 * @spec focuses on the point where the user double clicked.
	 * @spec we only refocus when maxZoom has been reached to avoid clashing with single click zoom behavior
	 * @param {object} event
	 */
	canvasDoubleClickHook (event)
	{
		if (this.maxZoomReached())
		{
			this.focusOnPoint(event.position);
		}
	}

	// Toggles the annotator between "drawing only" mode and "commenting" mode.
	toggleDrawingMode ()
	{
		if (this.annotator)
		{
			this.annotator.disableEditor = !this.annotator.disableEditor;
		}
	}

	// Toggle on/off the hatch fill mode.
	toggleHatchMode ()
	{
		this.hatchMode = !this.hatchMode;
	}

	selectDrawingTool(event, id)
	{
		this.toolbarElement.querySelector('.a9s-toolbar-btn.active')?.classList.remove('active');
		const button = event.target.closest('button');
		if (!button?.classList.contains('active'))
		{
			button.classList.add('active');
		}
		this.annotator.setDrawingTool(id);
      	this.annotator.setDrawingEnabled(true);
	}

	// Passes an annotation selection event onto the annotator plus does some extra handling to scroll it into view.
	selectAnnotation(id)
	{
		if (this.editingEnabled)
		{
			this.annotator.selectAnnotation(id);
		}
		for (let a of this.captureAnnotations())
		{
			if (a.id === id)
			{
				this.annotationSelectionHook(a);
			}
		}

		// Pan/Zoom the OSD controller to the annotation that is being selected.
		this.annotator.fitBoundsWithConstraints(id);
	}

	// Adds a connecting line between a comment and an element.
	connectAnnotation(id)
	{
		let isSelectionOpen = this.annotator.getSelected();
		if (isSelectionOpen) {
			this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
			return;
		}
		const safeID = id.replaceAll('#', '');
		this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
		const commentElement = this.pict.ContentAssignment.getElement(`#OSD-Comment-${ safeID }`);
		const annotationElement = this.pict.ContentAssignment.getElement(`[data-id="${ id }"]`);
		if (!commentElement?.[0] || !annotationElement?.[0])
		{
			this.log.warn('An expected element was missing, cannot render annotation connection with id: ', id);
			return;
		}
		const osdElementPosition = this?.viewer?.element?.getBoundingClientRect();
		const commentPosition = commentElement?.[0]?.getBoundingClientRect();
		let annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
		const isInView = () => 
		{
			return annotationPosition.top >= osdElementPosition.top &&
				   annotationPosition.left >= osdElementPosition.left &&
				   annotationPosition.left + annotationPosition.width <= osdElementPosition.left + osdElementPosition.width &&
				   annotationPosition.height + annotationPosition.height <= osdElementPosition.height + osdElementPosition.height;
		};
		const performGraphics = () => 
		{
			annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
			let colorClass = '';
			let fillClass = '';
			for (let a of this.captureAnnotations())
			{
				if (a.id === id)
				{
					colorClass = 'pict-osd-' + a?.target?.styleClass;
					fillClass = 'pict-osd-fill-' + a?.target?.styleClass;
				}
			}
			const lineTemplate = html`
				<style>
					.osd-connector-svg {
						z-index: 9999999;
						width: 100%;
						height: 100%;
					}
					.osd-connector-rect.osd-connector-specific {
						stroke: transparent !important;
					}
					.osd-connector-line.osd-connector-specific {
						stroke-width: 2.5 !important;
					}
				</style>
				<svg class="${ colorClass } osd-connector-svg">
					<rect class="osd-connector-rect osd-connector-specific" fill="rgb(255, 234, 0, 0.2)" x="${ annotationPosition.left }" y="${ annotationPosition.top }" width="${ annotationPosition.width }" height="${ annotationPosition.height }" />
					<line class="osd-connector-line osd-connector-specific" x1="${ commentPosition.left + 5  }" y1="${ commentPosition.top + 5 }" x2="${ annotationPosition.left + annotationPosition.width/2 }" y2="${ annotationPosition.top + annotationPosition.height/2 }" id="line1"/>
					<circle class="${ fillClass }" cx="${ annotationPosition.left + annotationPosition.width/2 }" cy="${ annotationPosition.top + annotationPosition.height/2 }" r="5" />
				</svg>`;

			const triggeringElement = this.pict.ContentAssignment.getElement(`#OSD-Comment-Outer-${ safeID }`);
			isSelectionOpen = this.annotator.getSelected();
			// Only render the svg elements if the user is still hovering and selection is not being edited.
			if (triggeringElement?.[0]?.matches(':hover') && !isSelectionOpen) {
				this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, lineTemplate);
			}
			else if (isSelectionOpen)
			{
				this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
			}
		}
		if (!isInView())
		{
			this.annotator.panTo(id);
			setTimeout(()=>
			{
				annotationPosition = annotationElement?.[0]?.getBoundingClientRect();
				if (!isInView())
				{
					this.annotator.fitBoundsWithConstraints(id);
					setTimeout(()=>
					{
						performGraphics();
					}, 500);
				}
				else
				{
					performGraphics();
				}
			}, 1000)
		}
		else
		{
			performGraphics();
		}
	}

	// Removes any connecting lines between a comments and annotations.
	releaseAnnotations()
	{
		this.pict.ContentAssignment.assignContent(`#OSD-SVG-Sandbox`, '');
	}

	/*
	 * Captures the current viewport relative to the overall image.
	 */
	captureViewport ()
	{
		if (this.viewer){
			return this.viewer.viewport.getBounds();
		}
		this.log.error('OpenSeaDragon is not initialized for some reason, giving back null.');
		return null;
	}

	/*
	 * Captures the annotation objects for the currently annotated image.
	 */
	captureAnnotations ()
	{
		if (this.annotator){
			return this.annotator.getAnnotations();
		}
		return [];
	}
		
}

module.exports = PictSectionOpenSeaDragon;
module.exports.default_configuration = default_configuration;


},{"pict-view":733}],708:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const html = String.raw;
const css = String.raw;

const default_configuration = 
{
	"RenderOnLoad": true,
	"DefaultRenderable": "OpenSeaDragonAnnotationSelector-Wrap",
	"DefaultDestinationAddress": "#OpenSeaDragonAnnotationSelector-Container-Div",
	"ViewAddress": 'PictSectionOpenSeaDragonAnnotationSelector',
	"OSDViewAddress": "PictSectionOpenSeaDragon",
	"Colors": {
		"red": "red",
		"green": "green",
		"blue": "blue"
	},
	"Templates": [
		{
			"Hash": "OpenSeaDragonAnnotationSelector-Container",
			"Template": html`
				<div class="osd-scrollable-comments" id="OSD-Scrollable-Comments">
				</div>
				<style id="OSDASGeneralStyling">
					.osd-scrollable-comments {
						height: 100%;
						width: 100%;
						overflow-y: auto;
						padding: 5px;
						background-color: lightgrey;
					}
					.osd-editable-text {
						border-top: 1px solid lightgrey; 
						max-height: fit-content;
					}
					.osd-editor-inner {
						-webkit-box-shadow: none !important; 
						-moz-box-shadow: none !important; 
						box-shadow: none !important; 
						border-radius: 6px !important; 
						border: 1px solid lightgrey;
					}
					.osd-comment-holder {
						z-index: auto; 
						line-height: normal; 
						cursor: pointer; 
						max-width: 100%; 
						opacity: 1; 
						position: relative !important; 
						margin: 10px 0px 10px 0px;
						width: 100% !important;
					}
					.osd-comment-color-flag {
						height: 12px;
						width: 60%;
						border-bottom: 3px solid lightgrey;
						border-right: 3px solid lightgrey;
						display: block;
						border-radius: 6px 0px 25px 0px;
					}
					.osd-editor-inner:hover > span.osd-comment-color-flag{
						transform: translate(-2px, -2px);
						border-bottom: 5px solid lightgrey;
						border-right: 5px solid lightgrey;
					}
					.osdas-taglist {
						display: flex;
    					flex-wrap: wrap;
					}
					.osdas-widget {
						display: block !important;
					}
				</style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "OpenSeaDragonAnnotationSelector-Wrap",
			"TemplateHash": "OpenSeaDragonAnnotationSelector-Container",
			"DestinationAddress": "#OpenSeaDragonAnnotationSelector-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#OpenSeaDragonAnnotationSelector-Container-Div"
}

class PictSectionOpenSeaDragonAnnotationSelector extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.triggerRender = false;
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElementAddress = false;
	}

	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		this.OSDSection = this.pict.views?.[this.options.OSDViewAddress];
		if (!this.OSDSection)
		{
			this.triggerRender = true;
		}
		if (this.OSDSection)
		{
			if (this.triggerRender)
			{
				this.triggerRender = false;
				this.OSDSection.render();
			}
			this.updateAnnotationsPanel();
		}
	}

	// Update the annotations side panel to include any annotation comments/tags, should be called anytime the annotation list gets changed (create/update/delete).
	updateAnnotationsPanel(annotations) {
		const annotationSet = annotations || this.OSDSection?.captureAnnotations() || [];
		annotationSet.sort((a,b)=>
		{
			if ( a.id < b.id ){
				return -1;
			}
			if ( a.id > b.id ){
				return 1;
			}
			return 0;
		});

		this.pict.ContentAssignment.assignContent('#OSD-Scrollable-Comments', '');
		let commentsTemplate = '';

		// Loop through the annotations and add any with comments or tags to the panel ui.
		for (let a of annotationSet)
		{
			let bodyCommentTemplate = '';
			let bodyTagTemplate = '';
			for (let b of a.body)
			{
				if (b.purpose === 'commenting' || b.purpose === 'replying')
				{
					bodyCommentTemplate += html`
						<div class="r6o-editable-text osd-editable-text">
							${ b.value }
						</div>
					`;
				}
				if (b.purpose === 'tagging')
				{
					bodyTagTemplate += html`
						<li>
							<span class="r6o-label">
								${ b.value }
							</span>
						</li>
					`;
				}
			}
			if (bodyCommentTemplate || bodyTagTemplate)
			{
				if (bodyCommentTemplate)
				{
					bodyCommentTemplate = html`
						<div disabled class="r6o-widget comment">
							${ bodyCommentTemplate }
						</div>
					`;
				}
				if (bodyTagTemplate)
				{
					bodyTagTemplate = html`
						<div class="r6o-widget r6o-tag osdas-widget">
							<ul class="r6o-taglist osdas-taglist">
								${ bodyTagTemplate }
							</ul>
						</div>
					`;
				}
				commentsTemplate += html`
					<div id="OSD-Comment-Outer-${ a.id.replaceAll('#', '') }" class="osd-comment-holder r6o-editor r6o-arrow-top r6o-arrow-left pushed right" onmouseover="_Pict.views.${ this.options.OSDViewAddress || 'PictSectionOpenSeaDragon' }.connectAnnotation('${ a.id }')" onmouseout="_Pict.views.${ this.options.OSDViewAddress || 'PictSectionOpenSeaDragon' }.releaseAnnotations()" onclick="_Pict.views.${ this.options.OSDViewAddress || 'PictSectionOpenSeaDragon' }.selectAnnotation('${ a.id }')">
						<div class="r6o-editor-inner osd-editor-inner">
							<span class="osd-comment-color-flag" id="OSD-Comment-${ a.id.replaceAll('#', '') }" style="background-color: ${ this.options.Colors[a?.target?.styleClass?.replace('-hatched', '')] || 'transparent' };"></span>
							${ bodyCommentTemplate }
							${ bodyTagTemplate }
						</div>
					</div>
				`;
			}
		}

		// If anything was added to the panel template, inject it back into the section and ensure the panel is open.
		if (commentsTemplate)
		{
			this.pict.ContentAssignment.assignContent('#OSD-Scrollable-Comments', commentsTemplate);
			this.pict.ContentAssignment.removeClass('#OSD-Container-Right', 'osd-width-zero');
			this.pict.ContentAssignment.addClass('#OSD-Container-Left', 'osd-annotations-panel-open');
		}
		else
		{
			// Otherwise, close the panel ui.
			this.pict.ContentAssignment.addClass('#OSD-Container-Right', 'osd-width-zero');
			this.pict.ContentAssignment.removeClass('#OSD-Container-Left', 'osd-annotations-panel-open');
		}
	}
}

module.exports = PictSectionOpenSeaDragonAnnotationSelector;
module.exports.default_configuration = default_configuration;


},{"pict-view":733}],709:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const default_configuration =
{
	"RenderOnLoad": true,
	"DefaultRenderable": "PDFJS-Wrap",
	"DefaultDestinationAddress": "#PDFJS-Container-Div",
	"ViewAddress": 'PictSectionPDFJS',
	"theme": "dark",
	"styles": /*css*/``,
    "pdfUrl": "",
    "pdfjsPath": "./pdfjs-dist",
	"Templates": [
		{
			"Hash": "PDFJS-Container",
			"Template": /*html*/`
				<div id="pdfjs-info-banner" class="pdfjs-banner-container">
				</div>
                <div id="pdfjs-injectable" class="injectable-size">
                </div>
                <style>
                    .injectable-size {
                        height: 100%;
                    }
					.pdfjs-info-banner {
						display: inline-block;
						font-family: sans-serif;
						font-size: 1rem;
						align-content: center;
						padding-left: 10px;
						line-height: 100%;
						height: 30px;
						color: hsl(221deg, 14%, 29%);
					}
					.pdfjs-banner-close {
						display: inline-block;
						align-content: center;
						padding-right: 10px;
						line-height: 100%;
						height: 30px;
						font-weight: bold;
						cursor: pointer;
						color: hsl(221deg, 14%, 29%);
					}
					.pdfjs-banner-container {
						display: flex;
						background-color: hsl(45deg, 100%, 48%);
						width: 100%;
						justify-content: space-between;
					}
                </style>
			`
		}
	],

	"Renderables": [
		{
			"RenderableHash": "PDFJS-Wrap",
			"TemplateHash": "PDFJS-Container",
			"DestinationAddress": "#PDFJS-Container-Div",
			"RenderType": "replace"
		}
	],

	"TargetElementAddress": "#PDFJS-Container-Div"
}

class PictSectionPDFJS extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, default_configuration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
	}

	onBeforeInitialize()
	{
		this.pdfjsInstance = {};
		super.onBeforeInitialize();
	}

	onAfterRender(pRenderable)
	{
		super.onAfterRender(pRenderable);
		const viewerEl = /*html*/`
		<pdfjs-viewer-element
			class="injectable-size"
			src="${ this.options.pdfUrl }"
			viewer-path="${ this.options.pdfjsPath }"
			viewer-css-theme="${ this.options?.theme?.toUpperCase() || 'DARK' }"
			viewer-extra-styles="${ this.options?.styles }
									#editorStampButton {
										display: none;
									}
									#editorInkButton {
										display: none;
									}
									#editorFreeTextButton {
										display: none;
									}
									#editorHighlightButton {
										display: none;
									}
								"
			>
		</pdfjs-viewer-element>`;
		// Remove the listener from any previous render so re-renders don't stack handlers.
		if (this._onWebViewerLoaded)
		{
			document.removeEventListener('webviewerloaded', this._onWebViewerLoaded);
		}

		// The pdfjs viewer dispatches "webviewerloaded" on the parent document (with the iframe's window as detail.source)
		// just before it starts up, so it must be listened for before the viewer element is injected.
		this._onWebViewerLoaded = (pEvent) =>
		{
			const viewerElement = document.querySelector(`${ this.options?.DefaultDestinationAddress } pdfjs-viewer-element`);
			const viewerWindow = viewerElement?.shadowRoot?.querySelector('iframe')?.contentWindow;
			if (!viewerWindow || pEvent?.detail?.source !== viewerWindow)
			{
				// Either this view is no longer rendered or the event came from a different viewer on the page.
				if (!viewerElement)
				{
					document.removeEventListener('webviewerloaded', this._onWebViewerLoaded);
				}
				return;
			}
			const pdfjsApp = viewerWindow.PDFViewerApplication;
			// The event bus is only created during initialization, and "documentloaded" fires once a pdf (and its first page) is ready.
			// This fires again if a new document is opened in the same viewer, keeping the instance reference current.
			pdfjsApp?.initializedPromise?.then(() =>
			{
				pdfjsApp.eventBus.on('documentloaded', () => this.onPDFJSDocumentLoaded(pdfjsApp));
			});
		};
		document.addEventListener('webviewerloaded', this._onWebViewerLoaded);

		this.pict.ContentAssignment.assignContent(`${ this.options?.DefaultDestinationAddress } > #pdfjs-injectable`, viewerEl);
	}

	/*
		Called once the pdfjs viewer has loaded a document.
		Sets the local instance reference and checks if it should show the info banner.
	*/
	onPDFJSDocumentLoaded(pdfjsApp)
	{
		this.pdfjsInstance = pdfjsApp;
		const bannerInjectionEl = document.querySelector('#pdfjs-info-banner');
		if (bannerInjectionEl)
		{
			bannerInjectionEl.innerHTML = '';
		}
		this.getStartingPageLabel().then((page) =>
		{
			if (page !== 1)
			{
				if (bannerInjectionEl)
				{
					bannerInjectionEl.innerHTML = this.options?.pageInfoTemplate ? this.options.pageInfoTemplate : /*html*/`
						<div class="pdfjs-info-banner">
							Note: This pdf does not start on page 1.
						</div>
						<div class="pdfjs-banner-close" onclick="
							if (document.querySelector('#pdfjs-info-banner')?.innerHTML)
							{
								document.querySelector('#pdfjs-info-banner').innerHTML = '';
							}
						">&times;</div>
					`;
				}
			}
		});
	}

	/*
		Gets the current active page of the pdf viewer.
		This is the "absolute" page number rather than being based on altered numbering in the page labels metadata.
	*/
	getCurrentPage()
	{
		return this.pdfjsInstance?.page || 1;
	}

	/*
		Sets the current active page of the pdf viewer.
		This is the "absolute" page number rather than being based on altered numbering in the page labels metadata.
	*/
	setCurrentPage(pageNumber)
	{
		if (!this.pdfjsInstance?.page)
		{
			return;
		}
		this.pdfjsInstance.page = pageNumber;
	}

	/*
		Gets the current active page of the pdf viewer.
		This is the "relative" page number, i.e. defined by the pdfs metadata rather than the absolute number of pages.
		Note that this function is async.
	*/
	async getCurrentPageLabel()
	{
		const labels = await this.pdfjsInstance?.pdfDocument?.getPageLabels();
		const currentPage = this.getCurrentPage();
		if (!labels || !currentPage)
		{
			return currentPage;
		}
		else
		{
			// If the page is not parseable as a number, just return the string (example: pages labeled with roman numerals, like "ii").
			return Number(labels[this.getCurrentPage() - 1]) || labels[this.getCurrentPage() - 1];
		}
	}

	/*
		Gets the first page number of the pdf with whatever relative/offset label it may have.
		Note that this function is also async.
	*/
	async getStartingPageLabel()
	{
		const labels = await this.pdfjsInstance?.pdfDocument?.getPageLabels();
		if (!labels)
		{
			return 1;
		}
		else
		{
			// If the page is not parseable as a number, just return the string (example: pages labeled with roman numerals, like "ii").
			return Number(labels[0]) || labels[0];
		}
	}
}

module.exports = PictSectionPDFJS;
module.exports.default_configuration = default_configuration;


},{"pict-view":733}],710:[function(require,module,exports){
// Sub-path entry: `require('pict-section-picker/form')`.
//
// The pict-section-form input-type adapter — kept off the package's main entry so the picker core
// stays usable without pict-section-form (which is an OPTIONAL peer dependency, required only here).
module.exports = require('./source/form/Pict-Section-Picker-FormInput.js');

},{"./source/form/Pict-Section-Picker-FormInput.js":712}],711:[function(require,module,exports){
// The container for all the Pict-Section-Picker related code.
//
// pict-section-picker is a themeable, pict-native searchable select / combobox: a jQuery- and
// select2-free widget supporting single & multi select, search, server pagination, categorized
// groups and creatable entries. It is driven by a host-agnostic async DataProvider, and ships a
// built-in adapter for the pict EntityProvider (Meadow entities) for the common case.

// The picker provider (primary API surface — registers the widget view + CSS, and exposes
// createPicker() / data-source adapters).
const PictProviderPicker = require('./providers/Pict-Provider-Picker.js');

// The widget view (also auto-registered by the provider).
const PictViewPicker = require('./views/PictView-Picker.js');

module.exports = PictProviderPicker;

module.exports.PictProviderPicker = PictProviderPicker;
module.exports.PictViewPicker = PictViewPicker;

module.exports.default_configuration = PictProviderPicker.default_configuration;

},{"./providers/Pict-Provider-Picker.js":713,"./views/PictView-Picker.js":714}],712:[function(require,module,exports){
/**
 * pict-section-form input-type adapter for pict-section-picker.
 *
 * Renders a picker widget into a dynamic-form cell — the host-agnostic replacement for a select2
 * entity input. Registered as a pict-section-form InputType (default name `Picker`); a host opts a
 * field in with `PictForm.InputType: 'Picker'` (+ Entity / SearchFields / Multiple / …). Used by the
 * pict-section-recordset entity filters and by document forms alike.
 *
 * Contextual scoping (project / spec-year / tenant / …) stays host configuration: the descriptor may
 * carry a `PictForm.GetContextScopeFilter()` hook, OR a host subclass overrides
 * `getContextualSearchFilters(pInput)`. Either way the module never learns what the context means.
 *
 * Requires `pict-section-form` (an OPTIONAL peer dependency — only loaded when you require this file)
 * and the `Pict-Section-Picker` provider registered on the pict instance.
 */
const libPictInputExtension = require('pict-section-form').PictInputExtensionProvider;

/**
 * The picker "nothing selected" sentinel per numeric descriptor DataType.
 *
 * A pict-section-form marshal reads values with manyfest's getValueByHash, which substitutes the
 * DESCRIPTOR DEFAULT whenever the address is undefined — and, absent an explicit `Default`, that is
 * manyfest's per-DataType default: '' for String but 0 for Number/Integer/Float. So a pristine
 * `{ DataType: 'Number', InputType: 'Picker' }` field (an entity FK, virtually always) marshals in as
 * 0, which the widget would otherwise paint as a literal "0" selection instead of the placeholder.
 * Mapping the type to its sentinel makes the picker render empty for it. Display only — the model is
 * untouched, so 0-means-unset stays a valid data pattern for solvers and exports.
 *
 * PreciseNumber ('0.0') is deliberately absent: it is a decimal-measurement type, not an id type.
 * @type {Record<string, Array<any>>}
 */
const _NUMERIC_UNSET_SENTINELS =
{
	Number: [ 0 ],
	Integer: [ 0 ],
	Float: [ 0 ],
};

/**
 * The values a descriptor's picker should PAINT as empty (see _NUMERIC_UNSET_SENTINELS). A descriptor
 * overrides with `PictForm.EmptyValues` — its own sentinel list, or `[]` to opt out and show the raw 0.
 *
 * Exported because a host's READ/PRINT display provider must agree with the edit widget about what
 * counts as unset; sharing the one function is what stops the two from drifting.
 * @param {Record<string, any>} pInput - the pict-section-form input descriptor.
 * @return {Array<any>}
 */
const resolveEmptyValues = (pInput) =>
{
	const tmpPictForm = (pInput && pInput.PictForm) || {};
	if (Array.isArray(tmpPictForm.EmptyValues)) { return tmpPictForm.EmptyValues; }
	return _NUMERIC_UNSET_SENTINELS[pInput && pInput.DataType] || [];
};

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Input-Picker',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * Build the InputType metatemplate entries (a hidden informary input + a host element the picker
 * renders into) for a given InputType name + provider hash. Injected via injectTemplateSet.
 *
 * @param {string} pInputTypeName - e.g. 'Picker'.
 * @param {string} pProviderHash - the input-extension provider service hash to auto-attach.
 * @return {Array<Record<string, any>>}
 */
const buildPickerInputTemplates = (pInputTypeName, pProviderHash) =>
[
	{
		// Mirror the host's DEFAULT input metatemplate structure exactly — a label span + the control
		// where the <input>/<select> would be — so the picker inherits the host's filter/form chrome
		// (label style, spacing, and the row's flex-end trash alignment) instead of inventing its own.
		HashPostfix: `-Template-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			<!-- InputType ${pInputTypeName} {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" id="{~D:Record.Macro.RawHTMLID~}" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="" />
			<span>{~D:Record.Name~}:</span> <div class="pps-form-host" id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"></div>`,
	},
	{
		HashPostfix: `-VerticalTemplate-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			<!-- InputType ${pInputTypeName} {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input type="hidden" id="{~D:Record.Macro.RawHTMLID~}" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="" />
			<span>{~D:Record.Name~}:</span> <div class="pps-form-host" id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"></div>`,
	},
	{
		HashPostfix: `-TabularTemplate-Begin-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			<input type="hidden" id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" tabindex="-1" {~D:Record.Macro.InformaryTabular~} `,
	},
	{
		HashPostfix: `-TabularTemplate-End-Input-InputType-${pInputTypeName}`,
		DefaultInputExtensions: [ pProviderHash ],
		Template: /*html*/`
			value="" />
			<div class="pps-form-host" id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"></div>`,
	},
];

class PictInputTypePicker extends libPictInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {any} */
		this.pict;
	}

	// Visible host + picker-view-hash ids. Must match the metatemplate element ids above.
	getPickerHostID(pRawHTMLID) { return `#PICKER-FOR-${pRawHTMLID}`; }
	getPickerHash(pRawHTMLID) { return `Picker-${pRawHTMLID}`; }
	getTabularPickerHostID(pRawHTMLID, pRowIndex) { return `#PICKER-TABULAR-${pRawHTMLID}-${pRowIndex}`; }
	getTabularPickerHash(pRawHTMLID, pRowIndex) { return `Picker-${pRawHTMLID}-${pRowIndex}`; }
	getTabularHiddenID(pRawHTMLID, pRowIndex) { return `#PICKER-TABULAR-DATA-${pRawHTMLID}-${pRowIndex}`; }

	/**
	 * Overridable: extra FoxHound scope stanza(s) AND-applied to the entity search. Default reads the
	 * descriptor's `GetContextScopeFilter()` hook (set by the host / recordset filter base), else its
	 * static `BaseFilter`. Host subclasses override this to read app state (project / spec-year / …).
	 *
	 * @param {Record<string, any>} pInput @return {string|Array<string>}
	 */
	getContextualSearchFilters(pInput)
	{
		const tmpHook = pInput && pInput.PictForm && pInput.PictForm.GetContextScopeFilter;
		if (typeof tmpHook === 'function')
		{
			try { return tmpHook() || ''; }
			catch (pError) { this.pict.log.warn(`Pict-Input-Picker: GetContextScopeFilter threw.`, pError); return ''; }
		}
		return (pInput && pInput.PictForm && pInput.PictForm.BaseFilter) || '';
	}

	/** Overridable seam onto the shared {@link resolveEmptyValues}. @param {Record<string, any>} pInput @return {Array<any>} */
	_resolveEmptyValues(pInput)
	{
		return resolveEmptyValues(pInput);
	}

	/** Build the picker config from a form input descriptor. */
	_buildPickerConfig(pInput, pHostSelector, fOnChange)
	{
		const tmpPF = pInput.PictForm || {};
		return {
			DestinationAddress: pHostSelector,
			Mode: tmpPF.Multiple ? 'multi' : 'single',
			Placeholder: tmpPF.Placeholder || (tmpPF.Entity ? `Select ${tmpPF.Entity}…` : 'Select…'),
			Searchable: (tmpPF.Searchable !== false),
			ReadOnly: !!tmpPF.ReadOnly,
			Entity: tmpPF.Entity,
			SearchFields: tmpPF.SearchFields,
			// A bare-number search also finds the record with that ID (on unless PictForm.SearchByID is false).
			SearchByID: tmpPF.SearchByID,
			SearchIDField: tmpPF.SearchIDField,
			IDMatchLabel: tmpPF.IDMatchLabel,
			ValueField: tmpPF.ValueField,
			TextField: tmpPF.TextField,
			// Optional composed-display template (overrides TextField); see the picker's TextTemplate option.
			TextTemplate: tmpPF.TextTemplate,
			PageSize: tmpPF.PageSize || 20,
			Options: tmpPF.Options || [],
			// JoinEntity compound display (1:1 / 1:many parent-entity context) — passed straight through
			// to the picker's entity adapter, which fetch-then-merges the join. No-op when JoinEntity unset.
			JoinEntity: tmpPF.JoinEntity,
			JoinField: tmpPF.JoinField,
			JoinEntityValueField: tmpPF.JoinEntityValueField,
			JoinEntityDisplayField: tmpPF.JoinEntityDisplayField,
			JoinEntityFirst: tmpPF.JoinEntityFirst,
			JoinSeparator: tmpPF.JoinSeparator,
			// EntityTag badge: the record field whose value becomes a Tag pill, ordered by EntityTagLast.
			EntityTag: tmpPF.EntityTag,
			TagLast: tmpPF.EntityTagLast,
			// Lines a long option label may wrap to in the open list (default 3; 0 = no limit).
			OptionLabelLines: tmpPF.OptionLabelLines,
			// Numeric-descriptor "unset" sentinel(s) rendered as the placeholder rather than as a value.
			EmptyValues: this._resolveEmptyValues(pInput),
			// Per-search contextual scope — the generic hook the host fills.
			BaseFilter: () => this.getContextualSearchFilters(pInput),
			OnChange: fOnChange,
		};
	}

	/** Instantiate (or reuse) the picker view for a config — entity-backed when Entity is set. */
	_instantiatePicker(pPickerHash, pConfig)
	{
		const tmpProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpProvider)
		{
			this.pict.log.warn('Pict-Input-Picker: the Pict-Section-Picker provider is not registered.');
			return null;
		}
		return pConfig.Entity
			? tmpProvider.createEntityPicker(pPickerHash, pConfig)
			: tmpProvider.createPicker(pPickerHash, pConfig);
	}

	/**
	 * Write a picker value into the form: csv to the hidden informary input (+ dataChanged), plus the
	 * raw array to `PictForm.ValueArrayAddress` when set (the recordset filter reads Values as an
	 * array). The csv-vs-array bridge lives HERE (generic) instead of in each host.
	 */
	_commit(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpCSV = Array.isArray(pValue) ? pValue.join(',') : (pValue === undefined || pValue === null ? '' : pValue);
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpCSV);
		if (pInput.PictForm && pInput.PictForm.ValueArrayAddress && pView.Bundle)
		{
			const tmpArray = Array.isArray(pValue) ? pValue : (tmpCSV === '' ? [] : String(tmpCSV).split(','));
			this.pict.manifest.setValueAtAddress(pView.Bundle, pInput.PictForm.ValueArrayAddress, tmpArray);
		}
		pView.dataChanged(pInput.Hash);
	}

	_commitTabular(pView, pInput, pValue, pHiddenID, pRowIndex)
	{
		const tmpCSV = Array.isArray(pValue) ? pValue.join(',') : (pValue === undefined || pValue === null ? '' : pValue);
		this.pict.ContentAssignment.assignContent(pHiddenID, tmpCSV);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
	}

	/**
	 * Idempotently mount (or reuse) the picker into its host element + seed its value. Called from both
	 * onInputInitialize and onDataMarshalToForm because, in the async-virtual filter render, the host
	 * element only exists in the real DOM by the marshal pass — whichever hook fires post-DOM wins, and
	 * re-calls are harmless (the picker view is reused by hash).
	 *
	 * setValue does the work: it builds the widget on the first call and, once the widget is live, re-seeds
	 * the value WITHOUT a full render — so a marshal (which re-runs this on every solve) no longer rebuilds
	 * the search box or orphans a portaled dropdown. That is why there is no explicit render() here.
	 * @return {boolean} true if the picker is mounted.
	 */
	_mountPicker(pView, pInput, pValue, pHostSelector, pPickerHash, fOnChange)
	{
		if (!this.pict.ContentAssignment.getElement(pHostSelector)?.[0]) { return false; }
		const tmpView = this._instantiatePicker(pPickerHash, this._buildPickerConfig(pInput, pHostSelector, fOnChange));
		if (!tmpView) { return false; }
		tmpView.setValue(pValue);
		return true;
	}

	// --- non-tabular lifecycle ---

	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpRaw = pInput.Macro.RawHTMLID;
		this._mountPicker(pView, pInput, pValue, this.getPickerHostID(tmpRaw), this.getPickerHash(tmpRaw),
			(pNewValue) => this._commit(pView, pInput, pNewValue, pInput.Macro.HTMLSelector));
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpRaw = pInput.Macro.RawHTMLID;
		const tmpPickerHash = this.getPickerHash(tmpRaw);
		// Mount if it isn't already (post-DOM hook), else just re-seed the value.
		if (!this._mountPicker(pView, pInput, pValue, this.getPickerHostID(tmpRaw), tmpPickerHash,
			(pNewValue) => this._commit(pView, pInput, pNewValue, pInput.Macro.HTMLSelector)))
		{
			const tmpView = this.pict.views[tmpPickerHash];
			if (tmpView) { tmpView.setValue(pValue); }
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		const tmpView = this.pict.views[this.getPickerHash(pInput.Macro.RawHTMLID)];
		const tmpVal = tmpView ? tmpView.getValue() : pValue;
		this._commit(pView, pInput, tmpVal, pHTMLSelector);
		return super.onDataRequest(pView, pInput, tmpVal, pHTMLSelector);
	}

	// --- tabular lifecycle (one picker view instance per (input, row)) ---

	/** Idempotent tabular mount (see _mountPicker). @return {boolean} */
	_mountPickerTabular(pView, pInput, pValue, pRowIndex)
	{
		const tmpRaw = pInput.Macro.RawHTMLID;
		const tmpHostSelector = this.getTabularPickerHostID(tmpRaw, pRowIndex);
		if (!this.pict.ContentAssignment.getElement(tmpHostSelector)?.[0]) { return false; }
		const tmpHiddenID = this.getTabularHiddenID(tmpRaw, pRowIndex);
		const tmpView = this._instantiatePicker(this.getTabularPickerHash(tmpRaw, pRowIndex),
			this._buildPickerConfig(pInput, tmpHostSelector, (pNewValue) => this._commitTabular(pView, pInput, pNewValue, tmpHiddenID, pRowIndex)));
		if (!tmpView) { return false; }
		// setValue builds on the first call and re-seeds targeted once live — no explicit render (see _mountPicker).
		tmpView.setValue(pValue);
		return true;
	}

	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._mountPickerTabular(pView, pInput, pValue, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!this._mountPickerTabular(pView, pInput, pValue, pRowIndex))
		{
			const tmpView = this.pict.views[this.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex)];
			if (tmpView) { tmpView.setValue(pValue); }
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		const tmpView = this.pict.views[this.getTabularPickerHash(pInput.Macro.RawHTMLID, pRowIndex)];
		const tmpVal = tmpView ? tmpView.getValue() : pValue;
		this._commitTabular(pView, pInput, tmpVal, this.getTabularHiddenID(pInput.Macro.RawHTMLID, pRowIndex), pRowIndex);
		return super.onDataRequestTabular(pView, pInput, tmpVal, pHTMLSelector, pRowIndex);
	}
}

/**
 * Register the Picker InputType on a pict instance: the input-extension provider + its metatemplate(s).
 * Idempotent. Requires `pict-section-form` loaded (PictFormSectionDefaultTemplateProvider present) and
 * the `Pict-Section-Picker` provider registered.
 *
 * @param {any} pPict - the pict instance.
 * @param {Record<string, any>} [pOptions]
 *   - InputTypeName {string} - the InputType string (default 'Picker').
 *   - ProviderHash {string} - the input-extension provider service hash (default 'Pict-Input-Picker').
 *   - ProviderClass {Function} - provider class to register (default PictInputTypePicker; a host
 *     passes a subclass that overrides getContextualSearchFilters for its scoping).
 *   - TemplatePrefix {string|Array<string>} - the form template prefix(es) to inject the metatemplate
 *     under (default 'Pict-MT-Base'; Headlight uses its theme prefixes).
 * @return {boolean} true if registered.
 */
const registerPickerInputType = (pPict, pOptions) =>
{
	const tmpOptions = pOptions || {};
	const tmpInputTypeName = tmpOptions.InputTypeName || 'Picker';
	const tmpProviderHash = tmpOptions.ProviderHash || 'Pict-Input-Picker';
	const tmpProviderClass = tmpOptions.ProviderClass || PictInputTypePicker;
	const tmpPrefixes = Array.isArray(tmpOptions.TemplatePrefix) ? tmpOptions.TemplatePrefix : [ tmpOptions.TemplatePrefix || 'Pict-MT-Base' ];

	if (!pPict.providers[tmpProviderHash])
	{
		pPict.addProvider(tmpProviderHash, Object.assign({}, _DEFAULT_CONFIGURATION, { ProviderIdentifier: tmpProviderHash }), tmpProviderClass);
	}

	const tmpTemplateProvider = pPict.providers.PictFormSectionDefaultTemplateProvider;
	if (!tmpTemplateProvider || typeof tmpTemplateProvider.injectTemplateSet !== 'function')
	{
		pPict.log.warn('Pict-Input-Picker: PictFormSectionDefaultTemplateProvider not available; cannot register the Picker metatemplate (is pict-section-form loaded?).');
		return false;
	}
	const tmpTemplates = buildPickerInputTemplates(tmpInputTypeName, tmpProviderHash);
	tmpPrefixes.forEach((pPrefix) => tmpTemplateProvider.injectTemplateSet({ TemplatePrefix: pPrefix, Templates: tmpTemplates }));
	return true;
};

module.exports = PictInputTypePicker;

module.exports.PictInputTypePicker = PictInputTypePicker;
module.exports.registerPickerInputType = registerPickerInputType;
module.exports.buildPickerInputTemplates = buildPickerInputTemplates;
module.exports.resolveEmptyValues = resolveEmptyValues;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-section-form":587}],713:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewPicker = require('../views/PictView-Picker.js');

// Themeable widget CSS. Registered once (by hash) regardless of how many picker instances exist.
// Host apps brand by defining the --theme-color-* tokens; the hardcoded values are fallbacks.
const _PickerCSS = /*css*/`
.pps { position: relative; width: 100%; box-sizing: border-box; }
.pps *, .pps *::before, .pps *::after { box-sizing: border-box; }
.pps-control { display: flex; align-items: center; gap: 0.5rem; width: 100%; cursor: pointer; font: inherit; font-size: 0.92rem;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); text-align: left; }
.pps-control:hover { border-color: var(--theme-color-border-strong, #c2c9d2); }
.pps.pps-open .pps-control { border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.pps-valuearea { flex: 1 1 auto; min-width: 0; }
.pps-value { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-value.pps-placeholder { color: var(--theme-color-text-muted, #6b7686); }
.pps-chevron { flex: 0 0 auto; display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; transition: transform 0.15s ease; }
.pps.pps-open .pps-chevron { transform: rotate(180deg); }
/* Read-only: render the resolved selection as plain, non-interactive text (no border / chevron / clear /
   dropdown). Used by read-only form views; the value text inherits the surrounding field styling. */
.pps-readonly .pps-control { border-color: transparent; background: transparent; padding-left: 0; padding-right: 0; cursor: default; pointer-events: none; }
.pps-readonly .pps-control:hover { border-color: transparent; box-shadow: none; }
.pps-readonly .pps-chevron, .pps-readonly .pps-clear, .pps-readonly .pps-chip-x { display: none; }
.pps-readonly .pps-pop, .pps-readonly .pps-backdrop { display: none; }
/* Clearable (AllowClear): the inline × next to the value (mirrors the chip ×) and the pinned "Any" row. */
.pps-clear { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.78rem; border-radius: 4px; padding: 0.1rem;
	color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.pps-clear:hover { opacity: 1; background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 22%, transparent); }
.pps-clear-option { border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pps-clear-option .pps-option-label { color: var(--theme-color-text-muted, #6b7686); font-style: italic; }

/* Multi-select chips. The control hosts a wrapping row of removable tags + a muted placeholder. */
.pps-multi .pps-control { align-items: flex-start; }
.pps-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem; min-width: 0; }
.pps-chips-ph { color: var(--theme-color-text-muted, #6b7686);
	/* The placeholder is the ONLY chips-row child that is free text, so it is the one thing that can
	   force the control taller than a line. Single-select truncates (.pps-value above); multi did not,
	   so a long label wrapped and knocked neighbouring filters out of vertical alignment. Truncate to
	   match: min-width:0 lets it shrink inside the flex row, and it never wraps. */
	min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-chip { display: inline-flex; align-items: center; gap: 0.3rem; max-width: 100%; font-size: 0.82rem; line-height: 1.4;
	padding: 0.1rem 0.2rem 0.1rem 0.5rem; border-radius: 6px;
	background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 12%, transparent);
	color: var(--theme-color-brand-primary, #156dd1); }
.pps-chip-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-chip-x { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.78rem; border-radius: 4px; padding: 0.1rem; opacity: 0.7; }
.pps-chip-x:hover { opacity: 1; background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 22%, transparent); }

/* Preview-card ⓘ — the opt-in affordance next to a selected value / chip. Stays clickable in
   read-only mode (where the control itself has pointer-events: none). */
.pps-card-info { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.82rem; padding: 0 0.1rem; opacity: 0.5; color: var(--theme-color-text-muted, #6b7686); }
.pps-card-info:hover { opacity: 1; color: var(--theme-color-brand-primary, #156dd1); }
.pps-readonly .pps-card-info { pointer-events: auto; }

/* EntityTag badge — a small code/number pill shown next to an option / chip / selected value (the
   select2 EntitySelector "tag" parity). Ordering (before/after the label) is driven by the TagLast
   option in the view's render state. */
.pps-tag { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.74rem; font-weight: 600; line-height: 1.25;
	padding: 0.05rem 0.4rem; border-radius: 5px; white-space: nowrap;
	background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
.pps-valuebox { display: flex; align-items: center; gap: 0.4rem; min-width: 0; }
.pps-valuebox .pps-value { min-width: 0; }
/* A long label wraps up to OptionLabelLines lines (--pps-option-lines, set on the list) and then ends in an
   ellipsis; the full text stays in the row's title tooltip. */
.pps-option-label { min-width: 0; overflow: hidden; overflow-wrap: anywhere; display: -webkit-box; -webkit-box-orient: vertical;
	-webkit-line-clamp: var(--pps-option-lines, 3); line-clamp: var(--pps-option-lines, 3); }
/* A row found by its ID (SearchByID): a muted "<Entity> #<ID>" after the label, in the open list only. */
.pps-option-idmatch { flex: 0 0 auto; margin-left: 0.5rem; font-size: 0.78rem; white-space: nowrap; color: var(--theme-color-text-muted, #6b7686); }

/* Transparent full-viewport backdrop: closes on outside click (no document listener). Only present
   while OPEN — otherwise a fixed full-viewport layer would swallow every click on the page. When open,
   the control is raised above it so its chips/× stay clickable; the dropdown sits above both. */
.pps-backdrop { position: fixed; inset: 0; z-index: 0; display: none; }
.pps.pps-open .pps-backdrop { display: block; }
.pps.pps-open .pps-control { position: relative; z-index: 1; }
/* Default anchoring: absolute against the control's own box (.pps is position:relative), so the panel
   rides page scroll for free — no measuring, no listeners. Works because a typical form row sets no
   overflow to clip it. */
.pps-pop { position: absolute; z-index: 40; top: calc(100% + 0.3rem); left: 0; right: 0; min-width: 200px; display: none; }
.pps.pps-open .pps-pop { display: block; }
/* Portal fallback, applied by the view when a clipping ancestor would cut the panel: it moves the pop to
   <body> and places it in DOCUMENT coords. Still absolute (not fixed) so it rides scroll like the
   default. On <body> it's outside the .pps.pps-open rule, so visibility keys off pps-pop-open — which
   also keeps a stray/orphaned portaled pop hidden. */
.pps-pop.pps-pop-portal { position: absolute; right: auto; display: none; }
.pps-pop.pps-pop-portal.pps-pop-open { display: block; }
.pps-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(60vh, 360px);
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
.pps-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.pps-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
.pps-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.pps-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem; }
.pps-option { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.9rem;
	padding: 0.45rem 0.6rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.pps-option:hover, .pps-option.pps-highlight { background: var(--theme-color-background-tertiary, #eceef2); }
.pps-option.pps-selected { color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
.pps-option-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); }
.pps-option-check.pps-hidden { visibility: hidden; }
.pps-empty { padding: 0.7rem 0.6rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; text-align: center; }
.pps-loading { padding: 0.6rem; text-align: center; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; }
.pps-more { display: block; width: calc(100% - 0.5rem); margin: 0.25rem; padding: 0.4rem; cursor: pointer; font: inherit; font-size: 0.85rem;
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #156dd1); }
.pps-more:hover { background: var(--theme-color-background-tertiary, #eceef2); }

/* Category header (groups) + creatable "Create …" row. */
.pps-group { padding: 0.45rem 0.6rem 0.2rem; font-size: 0.72rem; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); }
.pps-create { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.9rem;
	padding: 0.45rem 0.6rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
.pps-create:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.pps-create-ic { flex: 0 0 auto; display: inline-flex; }

/* Field decoration (opt-in): the ⚙ toggle in the search row + the field chooser panel between search and
   list. The chooser mount stays empty (collapsed) until opened. */
.pps-decorate-btn { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; font-size: 0.82rem;
	padding: 0.15rem; border: none; border-radius: 5px; background: transparent; color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.pps-decorate-btn:hover { opacity: 1; background: var(--theme-color-background-tertiary, #eceef2); }
.pps-decorate-btn.pps-decorate-on { color: var(--theme-color-brand-primary, #156dd1); opacity: 1; }
.pps-decorate-btn.pps-decorate-open { background: var(--theme-color-background-tertiary, #eceef2); opacity: 1; }
.pps-decorate-panel:empty { display: none; }
.pps-decorate { flex: 0 0 auto; max-height: 11rem; overflow-y: auto; padding: 0.5rem 0.7rem;
	border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-tertiary, #f4f6f9); }
.pps-decorate-title { font-size: 0.7rem; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.4rem; }
.pps-decorate-list { display: flex; flex-direction: column; gap: 0.05rem; }
.pps-decorate-opt { display: flex; align-items: center; gap: 0.45rem; cursor: pointer; font-size: 0.86rem; color: var(--theme-color-text-primary, #1f2733); padding: 0.15rem 0.1rem; }
.pps-decorate-opt:hover { color: var(--theme-color-brand-primary, #156dd1); }
.pps-decorate-opt input { flex: 0 0 auto; cursor: pointer; margin: 0; }
.pps-decorate-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pps-decorate-empty { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.1rem; }

/* Form-input adapter (pict-section-picker/form): the picker host fills its row like the host's
   native inputs (width:100% forces it to wrap below the label span + fill, matching a scalar input). */
.pps-form-host { flex: 1 1 100%; min-width: 0; width: 100%; }
`;

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Section-Picker',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Opt-in fleet default: when true, every picker this provider creates closes any open sibling on
	// open (at most one dropdown on the page — select2 parity). Off by default so existing hosts see
	// no behavior change; a per-picker SingleActivePicker in createPicker's config overrides it.
	SingleActivePicker: false,
};

/**
 * The pict-section-picker provider — the primary API surface. Registers the widget CSS once and
 * creates/manages picker view instances.
 */
class PictProviderPicker extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Back-off bookkeeping, keyed by picker hash. On the provider (page-lived), not the DataProvider
		// closure, which createEntityPicker rebuilds on every marshal-driven re-mount.
		/** @type {Record<string, {Dropped: boolean, Term: string|null}>} */
		this.backOffState = {};

		// Hash of the picker whose dropdown is open (opt-in SingleActivePicker). A hash, not a view, and
		// provider-scoped so two pict instances on a page can't cross-close.
		/** @type {string|false} */
		this.currentOpenPickerHash = false;

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Picker-CSS', _PickerCSS, 500);
		}
	}

	/**
	 * Create (or reconfigure + reuse) a picker widget instance.
	 *
	 * @param {string} pPickerHash - A unique hash/id for this picker; the widget renders its control
	 *   into the DOM element `#<pPickerHash>` unless a DestinationAddress is given.
	 * @param {Record<string, any>} pConfig - Picker configuration:
	 *   - DestinationAddress {string} - CSS selector to render into (default `#<pPickerHash>`).
	 *   - ValueAddress {string} - AppData address the selection is read from / written to.
	 *   - Mode {'single'} - selection mode (multi/categories/creatable land in later phases).
	 *   - Placeholder {string} - text shown when nothing is selected.
	 *   - Searchable {boolean} - show the search box (default true).
	 *   - Options {Array<{Value:any, Text:string}>} - static option list.
	 *   - OnChange {function} - optional callback invoked with the new value after a selection.
	 *   - SingleActivePicker {boolean} - opt-in: opening this picker closes any open sibling
	 *     (defaults from the provider's own SingleActivePicker option).
	 * @return {any} The picker view instance.
	 */
	createPicker(pPickerHash, pConfig)
	{
		const tmpConfig = Object.assign(
			{
				DestinationAddress: `#${pPickerHash}`,
				Mode: 'single',
				Searchable: true,
				Placeholder: 'Select…',
				Options: [],
				// Seed the provider-level fleet default; an explicit per-picker value overrides it.
				SingleActivePicker: !!this.options.SingleActivePicker,
			},
			pConfig || {},
			// PickerProvider lets the view reach provider-scoped bookkeeping (the single-active slot)
			// without guessing the service hash this provider was registered under.
			{ PickerHash: pPickerHash, PickerProvider: this });

		if (this.pict.views[pPickerHash])
		{
			Object.assign(this.pict.views[pPickerHash].options, tmpConfig);
			return this.pict.views[pPickerHash];
		}
		return this.pict.addView(pPickerHash, tmpConfig, libPictViewPicker);
	}

	/**
	 * Build the Meadow FoxHound filter for a search term across one or more fields.
	 *
	 * The term is tokenized on whitespace and the per-token clauses are AND'd (concatenated) — so
	 * "john smith" matches a record with those words in any order / across fields, mirroring the
	 * legacy select2 behavior. Per token: single field → `FBV~Field~LK~%token%`; multiple fields →
	 * the LIKEs are OR'd inside a paren group (`FOP…FCP`) so the OR can't bleed into a sibling AND
	 * base filter. Each token is `encodeURIComponent`-wrapped exactly as pict-section-recordset does,
	 * so the structural `~` separators stay literal in the URL path while the value is escaped.
	 *
	 * @param {Array<string>} pSearchFields - The entity fields to LIKE-match.
	 * @param {string} pTerm - The (raw) search term; whitespace-delimited into AND'd tokens.
	 * @return {string} The FoxHound filter stanza(s), or '' for an all-whitespace/empty term.
	 */
	buildSearchFilter(pSearchFields, pTerm)
	{
		const tmpTokens = String(pTerm == null ? '' : pTerm).split(/\s+/).map((pToken) => pToken.trim()).filter((pToken) => pToken.length > 0);
		if (tmpTokens.length === 0) { return ''; }
		const fTokenClause = (pToken) =>
		{
			const tmpEncoded = encodeURIComponent(`%${pToken}%`);
			if (pSearchFields.length === 1)
			{
				return `FBV~${pSearchFields[0]}~LK~${tmpEncoded}`;
			}
			const tmpInner = pSearchFields.map((pField, pIndex) => `${pIndex === 0 ? 'FBV' : 'FBVOR'}~${pField}~LK~${tmpEncoded}`).join('~');
			return `FOP~0~(~0~${tmpInner}~FCP~0~)~0`;
		};
		// Concatenated stanzas AND together, so every token must match somewhere.
		return tmpTokens.map(fTokenClause).join('~');
	}

	/**
	 * Build an async picker DataProvider backed by a Meadow entity (via `pict.EntityProvider`).
	 * Returns a `(searchTerm, page) => Promise<{ results:[{Value,Text,Record}], hasMore }>` function —
	 * the exact contract PictViewPicker consumes for server search + pagination.
	 *
	 * @param {Record<string, any>} pConfig - Entity source configuration:
	 *   - Entity {string} (required) - the Meadow entity name (e.g. `Author`).
	 *   - SearchFields {Array<string>} - fields to LIKE-search (default `['Name']`).
	 *   - ValueField {string} - record field used as the option Value (default `ID<Entity>`).
	 *   - TextField {string} - record field used as the option Text (default `Name`).
	 *   - TextTemplate {string} - optional pict template rendered against the whole record for the option
	 *       Text (overrides TextField; composes with JoinEntity). Lets a host show a composed, disambiguated
	 *       label, e.g. `{~DWTF:Record.NameFull:...~} ({~D:Record.Email~})`.
	 *   - PageSize {number} - records per page (default 20).
	 *   - Sort {string} - optional field to sort ascending (adds `FSF~<field>~ASC~0`).
	 *   - PriorityValues {Array<any>|function} - optional pin-to-top: value-ids (or a `() => ids |
	 *       Promise<ids>` resolver) to float to the top of the FIRST unfiltered page, in the given order.
	 *       BROWSE-only — a search term defers entirely to natural relevance so a pin never hides a typed-for
	 *       record. The resolver is memoized per provider instance (it may hit the network — e.g. "this line
	 *       item's project's prime contractor"); pinned ids are held out of the natural flow (NIN) so they
	 *       never double on a later page, and pinned rows are fetched + composed under the same scope + cull.
	 *   - BaseFilter {string|Array<string>|Object|function} - optional always-applied FoxHound filter
	 *     (AND), e.g. `FBV~IDCustomer~EQ~1`. May be a **function** `(searchTerm, page) => string|string[]|Object`
	 *     evaluated on every search — the generic hook for host-injected CONTEXTUAL scoping (project,
	 *     tenant, spec-year, …). The module stays agnostic; the host supplies the closure.
	 *     The object form `{ Filters, BackOffFilters }` (each a string or array of stanzas) splits the
	 *     scope into a MANDATORY set and a BACK-OFF set: both are applied together first, and when the
	 *     first page of a search comes back EMPTY the request is retried once WITHOUT the back-off set —
	 *     so a host can narrow aggressively ("this project's items") yet auto-widen instead of showing
	 *     "No matches" when the narrow scope has none. Later pages of the same search stay widened so
	 *     "Load more" pages the set the user is actually looking at.
	 *   - MapRecord {function} - optional `(record) => {Value, Text}` mapper (overrides Value/TextField).
	 *   - JoinEntity {string} - optional second entity to JOIN for a compound display (e.g. a `LineItem`
	 *     shown with its `Project`). Each searched row must carry the FK (`JoinField`). Because Meadow
	 *     can't join in one read, this is fetch-then-merge: after the primary page resolves, the unique
	 *     FK ids drive ONE `FBL~ID{JoinEntity}~INN~<ids>` request, and the joined display field is
	 *     stitched onto each row (as `Record.JoinName` / `Record.JoinRecord`) + composed into the Text.
	 *   - JoinField {string} - the FK column ON THE SEARCHED ROW pointing at JoinEntity (default `ID{JoinEntity}`).
	 *   - JoinEntityValueField {string} - the PK column on JoinEntity to match (default `ID{JoinEntity}`).
	 *   - JoinEntityDisplayField {string} - the JoinEntity field to display (default `Name`).
	 *   - JoinEntityFirst {boolean} - put the joined value first in the compound (default `true`):
	 *     `JoinName - baseText`; when `false`, `baseText - JoinName`.
	 *   - JoinSeparator {string} - the compound separator (default `' - '`).
	 *   - EntityTag {string} - optional record field whose value becomes a `Tag` badge on each option
	 *     (e.g. a `LineItem`'s `ItemNumber`). The picker view renders it as a styled badge alongside the
	 *     label (ordering via the picker's `TagLast` option). Composes with JoinEntity (tag is outermost).
	 *   - EntityTags {Array<string|{Field:string, Label?:string, Template?:string}>} - a SET of extra
	 *     fields rendered as multiple disambiguation chips (e.g. `['ISBN', { Field: 'PublicationYear',
	 *     Label: 'Year' }]`). A string spec shows the raw value; an object spec can prefix a `Label`
	 *     (`"Year: 2000"`) or render a `Template` against the whole record. Renders as `Tags` (an array)
	 *     alongside the optional single `Tag`.
	 * @param {string} [pStateKey] - Key (the picker hash) under which the back-off bookkeeping is held on
	 *   the provider, so it survives this closure being rebuilt on re-mount. Omit for closure-local state.
	 * @return {(pSearchTerm: string, pPage: number) => Promise<{results: Array<any>, hasMore: boolean}>}
	 */
	createEntityDataProvider(pConfig, pStateKey)
	{
		const tmpEntity = pConfig.Entity;
		const tmpSearchFields = (Array.isArray(pConfig.SearchFields) && pConfig.SearchFields.length > 0) ? pConfig.SearchFields : [ 'Name' ];
		const tmpValueField = pConfig.ValueField || `ID${tmpEntity}`;
		const tmpTextField = pConfig.TextField || 'Name';
		const tmpPageSize = pConfig.PageSize || 20;
		const tmpSort = pConfig.Sort || false;
		const tmpBaseFilterConfig = pConfig.BaseFilter || '';
		const tmpMapRecord = (typeof pConfig.MapRecord === 'function') ? pConfig.MapRecord : false;
		const tmpJoinConfig = this._resolveJoinConfig(pConfig);
		const tmpEntityTagField = pConfig.EntityTag || false;
		const tmpEntityTagFields = Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false;
		const tmpTextTemplate = pConfig.TextTemplate || false;
		// Search by ID (on unless SearchByID is false): a search that is only a number also finds the record
		// with that ID, pinned to the top of the first page; `#<number>` finds the ID only.
		const tmpSearchByID = (pConfig.SearchByID !== false);
		const tmpIDField = pConfig.SearchIDField || `ID${tmpEntity}`;
		const fParseIDSearch = (pSearchTerm) =>
		{
			if (!tmpSearchByID)
			{
				return null;
			}
			const tmpMatch = /^(#?)(\d+)$/.exec(String(pSearchTerm == null ? '' : pSearchTerm).trim());
			if (!tmpMatch)
			{
				return null;
			}
			return { ID: tmpMatch[2], Only: (tmpMatch[1] === '#') };
		};
		// The muted marker on a row found by its ID: `<Entity> #<ID>`. IDMatchLabel is a word to use in place
		// of the entity name, or `(record, id) => text`.
		const fIDMatchLabel = (pRecord, pID) =>
		{
			const tmpLabelConfig = pConfig.IDMatchLabel;
			if (typeof tmpLabelConfig === 'function')
			{
				try
				{
					return tmpLabelConfig(pRecord, pID);
				}
				catch (pError)
				{
					this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] IDMatchLabel() threw; using the default.`, pError);
				}
			}
			return `${(typeof tmpLabelConfig === 'string' && tmpLabelConfig) ? tmpLabelConfig : tmpEntity} #${pID}`;
		};
		const fToOption = (pRecord, pMarkIDMatch) =>
		{
			const tmpOption = tmpMapRecord
				? tmpMapRecord(pRecord)
				: this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields);
			if (pMarkIDMatch && tmpOption)
			{
				tmpOption.IDMatch = fIDMatchLabel(pRecord, pRecord[tmpIDField]);
			}
			return tmpOption;
		};

		// Back-off state: after a page-0 search comes back empty and is retried without the back-off set,
		// later pages of the SAME term stay widened (a new page-0 resets it). Held on the provider by hash
		// so it survives this closure's marshal-time rebuild; no key (direct API use) = closure-local.
		const tmpBackOff = pStateKey
			? (this.backOffState[pStateKey] = this.backOffState[pStateKey] || { Dropped: false, Term: null })
			: { Dropped: false, Term: null };

		// Pin-to-top: an optional set of value-ids — or a `() => ids | Promise<ids>` resolver — that float
		// to the top of the FIRST unfiltered page. A BROWSE-only affordance: with a search term, the query
		// defers entirely to natural relevance so the pin never hides a typed-for record. The pinned ids are
		// resolved ONCE per provider instance (the resolver may hit the network — e.g. "this line item's
		// project's prime contractor"), kept OUT of the natural flow (NIN) so they never double on a later
		// page, and their rows are fetched + composed exactly like the rest (honoring the scope + cull).
		const tmpPriorityConfig = pConfig.PriorityValues || false;
		let tmpPriorityIDsPromise = null;
		const fResolvePriorityIDs = () =>
		{
			if (tmpPriorityIDsPromise) { return tmpPriorityIDsPromise; }
			let tmpResolved = [];
			try { tmpResolved = (typeof tmpPriorityConfig === 'function') ? tmpPriorityConfig() : tmpPriorityConfig; }
			catch (pError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] PriorityValues resolver threw; ignoring pin-to-top.`, pError); tmpResolved = []; }
			tmpPriorityIDsPromise = Promise.resolve(tmpResolved)
				.then((pIDs) => (Array.isArray(pIDs) ? pIDs : []).filter((pID) => (pID !== undefined) && (pID !== null) && (pID !== '')))
				.catch((pError) => { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] PriorityValues resolver rejected; ignoring pin-to-top.`, pError); return []; });
			return tmpPriorityIDsPromise;
		};
		// Fetch + compose the pinned rows themselves — one INN read under the mandatory scope (so an
		// out-of-scope or already-culled pin never appears), ordered by the resolver's id order. `pPinField`
		// is the column the ids are in: the ValueField for PriorityValues, the ID field for a search by ID.
		const fFetchPriorityOptions = (pPriorityIDs, pScopeFilter, pPinField, pMarkIDMatch) => new Promise((resolve) =>
		{
			const tmpStanzas = [];
			if (pScopeFilter) { tmpStanzas.push(pScopeFilter); }
			tmpStanzas.push(`FBL~${pPinField}~INN~${pPriorityIDs.map((pID) => encodeURIComponent(pID)).join(',')}`);
			if (tmpSort) { tmpStanzas.push(`FSF~${tmpSort}~ASC~0`); }
			this.pict.EntityProvider.getEntitySetPage(tmpEntity, tmpStanzas.filter(Boolean).join('~'), 0, pPriorityIDs.length,
				(pError, pRecords) =>
				{
					if (pError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] pin-to-top fetch failed; skipping.`, pError); return resolve([]); }
					this._decorateRecordsWithJoin(Array.isArray(pRecords) ? pRecords : [], tmpJoinConfig).then((pDecorated) =>
					{
						const tmpByID = {};
						for (let i = 0; i < pDecorated.length; i++) { tmpByID[String(pDecorated[i][pPinField])] = pDecorated[i]; }
						const tmpOptions = pPriorityIDs
							.map((pID) => tmpByID[String(pID)])
							.filter((pRecord) => !!pRecord)
							.map((pRecord) => fToOption(pRecord, pMarkIDMatch));
						return resolve(tmpOptions);
					});
				});
		});

		// One page of the natural (non-pinned) query. `pPriorityIDs` is empty except on an unfiltered browse
		// with a pin configured, or a search by ID — where those ids (in `pPinField`) are excluded here (NIN)
		// and prepended in fFinish.
		const fRunQuery = (pSearchTerm, pPage, pPriorityIDs, pPinField) => new Promise((resolve, reject) =>
		{
			if (!this.pict.EntityProvider || typeof this.pict.EntityProvider.getEntitySetPage !== 'function')
			{
				return reject(new Error('Pict-Section-Picker: pict.EntityProvider is not available for entity-backed pickers.'));
			}

			// Resolve the base filter at SEARCH time. A function form lets the host inject contextual
			// scoping (e.g. "only this project's line items") without the module knowing the context;
			// it can return a single stanza, an array of stanzas, a `{ Filters, BackOffFilters }` split,
			// or nothing.
			let tmpBaseFilter = tmpBaseFilterConfig;
			if (typeof tmpBaseFilterConfig === 'function')
			{
				try { tmpBaseFilter = tmpBaseFilterConfig(pSearchTerm, pPage); }
				catch (pScopeError) { this.pict.log.warn(`Pict-Section-Picker [${tmpEntity}] BaseFilter() threw; ignoring contextual scope.`, pScopeError); tmpBaseFilter = ''; }
			}
			const tmpScope = this._normalizeBaseFilter(tmpBaseFilter);
			const tmpIDSearch = fParseIDSearch(pSearchTerm);

			const tmpPageIndex = (pPage || 0);
			if (tmpPageIndex === 0) { tmpBackOff.Dropped = false; tmpBackOff.Term = null; }
			const tmpCarryWidened = tmpBackOff.Dropped && (tmpBackOff.Term === (pSearchTerm || ''));
			const tmpApplyBackOff = !!tmpScope.BackOffFilter && !tmpCarryWidened;

			const fComposeFilter = (pIncludeBackOff) =>
			{
				const tmpStanzas = [];
				if (tmpScope.Filter) { tmpStanzas.push(tmpScope.Filter); }
				if (pIncludeBackOff && tmpScope.BackOffFilter) { tmpStanzas.push(tmpScope.BackOffFilter); }
				if (tmpIDSearch && tmpIDSearch.Only)
				{
					tmpStanzas.push(`FBV~${tmpIDField}~EQ~${tmpIDSearch.ID}`);
				}
				else if (pSearchTerm)
				{
					tmpStanzas.push(this.buildSearchFilter(tmpSearchFields, pSearchTerm));
				}
				// Pin-to-top: keep the pinned rows OUT of the natural flow so they appear only at the top
				// (prepended in fFinish), never doubled on a later page.
				if (pPriorityIDs.length > 0) { tmpStanzas.push(`FBL~${pPinField}~NIN~${pPriorityIDs.map((pID) => encodeURIComponent(pID)).join(',')}`); }
				if (tmpSort) { tmpStanzas.push(`FSF~${tmpSort}~ASC~0`); }
				return tmpStanzas.filter(Boolean).join('~');
			};

			const fFinish = (pRecords) =>
			{
				const tmpList = Array.isArray(pRecords) ? pRecords : [];
				// JoinEntity (when configured): one INN fetch for the joined rows, stitched onto each
				// searched row, before mapping — so the option Text can show the compound display.
				this._decorateRecordsWithJoin(tmpList, tmpJoinConfig).then((pDecorated) =>
				{
					// A `#<number>` search returns only ID matches, so every row carries the marker.
					const tmpResults = pDecorated.map((pRecord) => fToOption(pRecord, !!(tmpIDSearch && tmpIDSearch.Only)));
					// hasMore: a full page came back, so there is (probably) another. Avoids a Count round-trip.
					// Pin-to-top: on the first browse page, prepend the pinned options ahead of the natural
					// results (which excluded them via NIN above).
					if (pPriorityIDs.length < 1 || tmpPageIndex !== 0)
					{
						return resolve({ results: tmpResults, hasMore: (tmpList.length >= tmpPageSize) });
					}
					return fFetchPriorityOptions(pPriorityIDs, tmpScope.Filter, pPinField, !!(tmpIDSearch && !tmpIDSearch.Only)).then((pPinned) =>
						resolve({ results: pPinned.concat(tmpResults), hasMore: (tmpList.length >= tmpPageSize) }));
				});
			};

			const tmpCursor = tmpPageIndex * tmpPageSize;
			this.pict.EntityProvider.getEntitySetPage(tmpEntity, fComposeFilter(tmpApplyBackOff), tmpCursor, tmpPageSize,
				(pError, pRecords) =>
				{
					if (pError) { return reject(pError); }
					const tmpList = Array.isArray(pRecords) ? pRecords : [];
					// Back-off retry: an EMPTY first page under the back-off set means the narrow scope has
					// nothing — auto-widen by retrying once without it, instead of stranding the user on
					// "No matches" for options that exist just outside the preferred scope.
					if (tmpList.length < 1 && tmpApplyBackOff && tmpPageIndex === 0)
					{
						tmpBackOff.Dropped = true;
						tmpBackOff.Term = (pSearchTerm || '');
						return this.pict.EntityProvider.getEntitySetPage(tmpEntity, fComposeFilter(false), tmpCursor, tmpPageSize,
							(pRetryError, pRetryRecords) =>
							{
								if (pRetryError) { return reject(pRetryError); }
								return fFinish(pRetryRecords);
							});
					}
					return fFinish(tmpList);
				});
		});

		// A bare-number search pins the record with that ID. Otherwise, with no pin configured, the plain
		// per-page provider; with one, resolve the pinned ids first (browse only — a search term defers
		// entirely to natural relevance) and run the query with them.
		return (pSearchTerm, pPage) =>
		{
			const tmpIDSearch = fParseIDSearch(pSearchTerm);
			if (tmpIDSearch && !tmpIDSearch.Only)
			{
				return fRunQuery(pSearchTerm, pPage, [ tmpIDSearch.ID ], tmpIDField);
			}
			if (pSearchTerm || !tmpPriorityConfig)
			{
				return fRunQuery(pSearchTerm, pPage, [], tmpValueField);
			}
			return fResolvePriorityIDs().then((pIDs) => fRunQuery(pSearchTerm, pPage, pIDs, tmpValueField));
		};
	}

	/**
	 * Normalize a resolved BaseFilter value into `{ Filter, BackOffFilter }` joined-stanza strings.
	 * Accepts the historical string / array forms (all-mandatory, no back-off) and the object form
	 * `{ Filters, BackOffFilters }` where each side is itself a string or array of stanzas.
	 *
	 * @param {any} pResolved - The BaseFilter config value, or a BaseFilter function's return value.
	 * @return {{Filter: string, BackOffFilter: string}}
	 */
	_normalizeBaseFilter(pResolved)
	{
		const fJoin = (pValue) => Array.isArray(pValue) ? pValue.filter(Boolean).join('~') : (pValue || '');
		if (pResolved && typeof pResolved === 'object' && !Array.isArray(pResolved))
		{
			return { Filter: fJoin(pResolved.Filters), BackOffFilter: fJoin(pResolved.BackOffFilters) };
		}
		return { Filter: fJoin(pResolved), BackOffFilter: '' };
	}

	/**
	 * Resolve the JoinEntity options off an entity-source config into a normalized internal shape, or
	 * `false` when no JoinEntity is configured. Centralizes the defaults so the DataProvider and the
	 * ResolveValue builders agree.
	 *
	 * @param {Record<string, any>} pConfig
	 * @return {false | {Entity:string, FKColumn:string, PKColumn:string, DisplayField:string, First:boolean, Separator:string}}
	 */
	_resolveJoinConfig(pConfig)
	{
		if (!pConfig || !pConfig.JoinEntity) { return false; }
		return {
			Entity: pConfig.JoinEntity,
			// The FK on the SEARCHED row, and the PK it points at on the join entity (the INN column).
			FKColumn: pConfig.JoinField || `ID${pConfig.JoinEntity}`,
			PKColumn: pConfig.JoinEntityValueField || `ID${pConfig.JoinEntity}`,
			DisplayField: pConfig.JoinEntityDisplayField || 'Name',
			// Default join-first (mirrors the documented select2 EntitySelector default).
			First: (pConfig.JoinEntityFirst !== false),
			Separator: (typeof pConfig.JoinSeparator === 'string') ? pConfig.JoinSeparator : ' - ',
		};
	}

	/**
	 * Compose a compound display from a base text + a joined value, honoring ordering + separator.
	 * Falls back to just the base text when there is no joined value.
	 *
	 * @param {any} pBaseText @param {any} pJoinText @param {boolean} pFirst @param {string} pSeparator
	 * @return {any}
	 */
	_composeJoinedText(pBaseText, pJoinText, pFirst, pSeparator)
	{
		if (pJoinText === undefined || pJoinText === null || pJoinText === '') { return pBaseText; }
		const tmpBase = (pBaseText === undefined || pBaseText === null) ? '' : pBaseText;
		return pFirst ? `${pJoinText}${pSeparator}${tmpBase}` : `${tmpBase}${pSeparator}${pJoinText}`;
	}

	/**
	 * Build the picker option `{ Value, Text, Record[, Tag] }` from a (possibly join-decorated) record:
	 * the Text honors any JoinEntity compound, and a Tag badge is added from `pTagField` when set. Shared
	 * by the DataProvider (per page row) and the ResolveValue (pre-bound value) so they stay consistent.
	 *
	 * @param {any} pRecord @param {string} pValueField @param {string} pTextField
	 * @param {false | Record<string, any>} pJoinConfig @param {string|false} pTagField
	 * @return {{Value:any, Text:any, Record:any, Tag?:any}}
	 */
	_composeOption(pRecord, pValueField, pTextField, pJoinConfig, pTagField, pTextTemplate, pTagFields)
	{
		// The option label is either a single field (pTextField) or — when a TextTemplate is configured — a
		// template rendered against the whole record, so a host can show a composed, disambiguated display
		// (e.g. "Brian Smith (brian@…)") instead of one ambiguous column. JoinEntity still wraps the result.
		const tmpBaseText = pTextTemplate
			? this.pict.parseTemplate(pTextTemplate, pRecord)
			: pRecord[pTextField];
		const tmpText = pJoinConfig
			? this._composeJoinedText(tmpBaseText, pRecord.JoinName, pJoinConfig.First, pJoinConfig.Separator)
			: tmpBaseText;
		const tmpOption = { Value: pRecord[pValueField], Text: tmpText, Record: pRecord };
		if (pTagField) { tmpOption.Tag = pRecord[pTagField]; }
		// EntityTags: a set of extra fields rendered as disambiguation chips (e.g. a book's ISBN + Year).
		if (Array.isArray(pTagFields) && pTagFields.length > 0)
		{
			tmpOption.Tags = pTagFields
				.map((pSpec) => this._composeTagValue(pSpec, pRecord))
				.filter((pTag) => (pTag !== undefined && pTag !== null && pTag !== ''));
		}
		return tmpOption;
	}

	/**
	 * Resolve one EntityTags spec to a chip string. A spec is either a field name (`'ISBN'` → the raw
	 * value) or an object `{ Field, Label, Template }`: `Template` renders against the whole record;
	 * `Label` prefixes the value (`"Year: 2000"`) — useful when several numeric chips would be ambiguous.
	 *
	 * @param {string|Record<string, any>} pSpec @param {any} pRecord
	 * @return {any}
	 */
	_composeTagValue(pSpec, pRecord)
	{
		if (typeof pSpec === 'string')
		{
			return pRecord[pSpec];
		}
		if (pSpec && typeof pSpec === 'object')
		{
			let tmpValue = pSpec.Template ? this.pict.parseTemplate(pSpec.Template, pRecord) : pRecord[pSpec.Field];
			if (tmpValue === undefined || tmpValue === null || tmpValue === '') { return ''; }
			return pSpec.Label ? `${pSpec.Label}: ${tmpValue}` : tmpValue;
		}
		return '';
	}

	/**
	 * Fetch-then-merge the join entity for a page of searched records. Collects the unique FK ids the
	 * rows carry (`JoinConfig.FKColumn`), issues ONE `FBL~{PKColumn}~INN~<ids>` request against the join
	 * entity, and stitches `JoinRecord` + `JoinName` onto each searched row. Resolves the (mutated) same
	 * array; on any error or when there's nothing to join, resolves the records un-decorated (the Text
	 * gracefully degrades to the base field).
	 *
	 * @param {Array<any>} pRecords @param {false | Record<string, any>} pJoinConfig
	 * @return {Promise<Array<any>>}
	 */
	_decorateRecordsWithJoin(pRecords, pJoinConfig)
	{
		return new Promise((resolve) =>
		{
			if (!pJoinConfig || !Array.isArray(pRecords) || pRecords.length < 1 || !this.pict.EntityProvider) { return resolve(pRecords); }
			const tmpIDs = [];
			const tmpSeen = {};
			for (let i = 0; i < pRecords.length; i++)
			{
				const tmpID = pRecords[i][pJoinConfig.FKColumn];
				if (tmpID !== undefined && tmpID !== null && tmpID !== '' && !tmpSeen[tmpID]) { tmpSeen[tmpID] = true; tmpIDs.push(tmpID); }
			}
			if (tmpIDs.length < 1) { return resolve(pRecords); }
			const tmpFilter = `FBL~${pJoinConfig.PKColumn}~INN~${tmpIDs.join(',')}`;
			this.pict.EntityProvider.getEntitySetPage(pJoinConfig.Entity, tmpFilter, 0, tmpIDs.length,
				(pError, pJoinRecords) =>
				{
					if (pError)
					{
						this.pict.log.warn(`Pict-Section-Picker [${pJoinConfig.Entity}] join fetch failed; showing un-joined text.`, pError);
						return resolve(pRecords);
					}
					const tmpMap = {};
					const tmpJoinList = Array.isArray(pJoinRecords) ? pJoinRecords : [];
					for (let i = 0; i < tmpJoinList.length; i++) { tmpMap[tmpJoinList[i][pJoinConfig.PKColumn]] = tmpJoinList[i]; }
					for (let i = 0; i < pRecords.length; i++)
					{
						const tmpJoinRecord = tmpMap[pRecords[i][pJoinConfig.FKColumn]];
						if (tmpJoinRecord) { pRecords[i].JoinRecord = tmpJoinRecord; pRecords[i].JoinName = tmpJoinRecord[pJoinConfig.DisplayField]; }
					}
					return resolve(pRecords);
				});
		});
	}

	/**
	 * Build a `ResolveValue(value) => Promise<{Value,Text}>` for an entity-backed picker, so a
	 * pre-bound ID resolves to its display text on first render (fetched + cached by `getEntity`).
	 *
	 * @param {Record<string, any>} pConfig - Same shape as {@link createEntityDataProvider}.
	 * @return {(pValue: any) => Promise<any>}
	 */
	createEntityResolveValue(pConfig)
	{
		const tmpEntity = pConfig.Entity;
		const tmpValueField = pConfig.ValueField || `ID${tmpEntity}`;
		const tmpTextField = pConfig.TextField || 'Name';
		const tmpMapRecord = (typeof pConfig.MapRecord === 'function') ? pConfig.MapRecord : false;
		const tmpJoinConfig = this._resolveJoinConfig(pConfig);
		const tmpEntityTagField = pConfig.EntityTag || false;
		const tmpEntityTagFields = Array.isArray(pConfig.EntityTags) ? pConfig.EntityTags : false;
		const tmpTextTemplate = pConfig.TextTemplate || false;

		return (pValue) => new Promise((resolve) =>
		{
			if (pValue === undefined || pValue === null || pValue === '' || !this.pict.EntityProvider)
			{
				return resolve(null);
			}
			this.pict.EntityProvider.getEntity(tmpEntity, pValue,
				(pError, pRecord) =>
				{
					if (pError || !pRecord) { return resolve(null); }
					const fFinish = () =>
					{
						if (tmpMapRecord) { return resolve(tmpMapRecord(pRecord)); }
						return resolve(this._composeOption(pRecord, tmpValueField, tmpTextField, tmpJoinConfig, tmpEntityTagField, tmpTextTemplate, tmpEntityTagFields));
					};
					// JoinEntity: resolve the single joined record (cached getEntity) for the compound label.
					const tmpFK = tmpJoinConfig ? pRecord[tmpJoinConfig.FKColumn] : null;
					if (!tmpJoinConfig || tmpFK === undefined || tmpFK === null || tmpFK === '') { return fFinish(); }
					this.pict.EntityProvider.getEntity(tmpJoinConfig.Entity, tmpFK,
						(pJoinError, pJoinRecord) =>
						{
							if (!pJoinError && pJoinRecord) { pRecord.JoinRecord = pJoinRecord; pRecord.JoinName = pJoinRecord[tmpJoinConfig.DisplayField]; }
							return fFinish();
						});
				});
		});
	}

	/**
	 * Create a picker backed by a Meadow entity — the high-level entry point for the real
	 * lims/config/bridge entity pickers. Wires a server DataProvider + ResolveValue from `pConfig`
	 * and delegates to {@link createPicker}. Any picker option (DestinationAddress, ValueAddress,
	 * Placeholder, OnChange, …) may also be supplied and is passed through.
	 *
	 * @param {string} pPickerHash - Unique hash/id for this picker.
	 * @param {Record<string, any>} pConfig - {@link createEntityDataProvider} config + picker options.
	 * @return {any} The picker view instance.
	 */
	createEntityPicker(pPickerHash, pConfig)
	{
		const tmpConfig = Object.assign({}, pConfig);
		// Key the back-off state by picker hash so it survives this rebuild (hosts re-mount every marshal).
		tmpConfig.DataProvider = this.createEntityDataProvider(pConfig, pPickerHash);
		if (!tmpConfig.ResolveValue) { tmpConfig.ResolveValue = this.createEntityResolveValue(pConfig); }
		return this.createPicker(pPickerHash, tmpConfig);
	}
}

module.exports = PictProviderPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../views/PictView-Picker.js":714,"pict-provider":552}],714:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * HTML-escape a value so it is safe both inside a double-quoted attribute and as element text content.
 * Option values / labels can carry characters like the inch mark (`1"`) or an apostrophe that would
 * otherwise terminate an attribute or an inline handler string. Every user value the templates drop into
 * an attribute or a text node is passed through this; the value a handler actually operates on is read
 * back — the browser decodes it — from a `data-` attribute rather than being inlined into the onclick.
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	return String((pValue === null || pValue === undefined) ? '' : pValue)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * The theme custom properties the widget paints from. Copied onto a portaled panel so it keeps the
 * host's theme after it stops inheriting from a scoped container (see _portalPop / _restorePop).
 * @type {Array<string>}
 */
const _THEME_TOKENS =
[
	'--theme-color-brand-primary', '--theme-color-text-primary', '--theme-color-text-secondary',
	'--theme-color-text-muted', '--theme-color-border-default', '--theme-color-border-light',
	'--theme-color-border-strong', '--theme-color-background-primary', '--theme-color-background-panel',
	'--theme-color-background-tertiary',
];

/**
 * Record columns never offered as field-decoration choices — the common Meadow audit/system columns. The
 * value + text fields and any host `DecorationIgnoreFields` are layered on top of these at runtime.
 * @type {Array<string>}
 */
const _DECORATION_IGNORE_DEFAULT =
[
	'Deleted', 'DeleteDate', 'DeletingIDUser', 'CreateDate', 'CreatingIDUser',
	'UpdateDate', 'UpdatingIDUser', 'ExternalSyncDate',
];
/** localStorage key prefix for the per-entity field-decoration choice (client-only, no server state). */
const _DECORATION_KEY_PREFIX = 'PictSectionPicker.Decoration.';

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-Section-Picker-View',

	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,

	DefaultRenderable: 'Pict-Section-Picker-Renderable',

	// Per-instance options (supplied by PictProviderPicker.createPicker):
	PickerHash: false,
	DestinationAddress: false,
	ValueAddress: false,
	// 'single' (scalar value) or 'multi' (array of values, rendered as removable chips).
	Mode: 'single',
	Placeholder: 'Select…',
	Searchable: true,
	Options: [],
	// EntityTag badge ordering: false → badge before the label (the select2 default), true → after.
	// The per-option Tag value rides on each source row (`{Value, Text, Tag}`); the entity adapter
	// stamps it from an `EntityTag` field name. With no Tag on a row, no badge renders.
	TagLast: false,
	// Async data source (Phase 2): DataProvider(searchTerm, page) => Promise<{ results:[{Value,Text}], hasMore }>.
	// When a function, the widget searches + paginates through it instead of the static Options list.
	DataProvider: false,
	PageSize: 20,
	// Async only: minimum trimmed search length before a server query fires (browse-on-open + new
	// search). 0 = always query (the common default). >0 suppresses the request below the threshold.
	MinimumSearchLength: 0,
	// Optional ResolveValue(value) => Promise<{Value,Text}> to resolve the display text of a pre-set
	// value in async mode (e.g. fetch the entity for a bound ID so the control shows its name).
	ResolveValue: false,
	// Multi mode extra bindings (the EntitySelectorMultiple contract). All optional; ValueAddress
	// always holds the array of values. These mirror it as a csv string and as the full record list.
	StringArrayValueAddress: false,
	SelectedValuesAddress: false,
	// Creatable (Phase 4): OnCreate(searchTerm) => {Value,Text} | Promise<{Value,Text}>. When set, a
	// "Create …" row appears for a non-empty search term that doesn't exactly match an existing option.
	OnCreate: false,
	// Creatable: when true, the "Create …" row is pinned at the top of the open list whatever the search
	// says — empty or an exact match included — so creating needs no typing (OnCreate then gets '').
	CreateAlwaysVisible: false,
	// The "Create …" row's text. A string, or a function (searchTerm) => string. Rendered as text; a blank
	// result or a throw falls back to the default ('Create "<term>"', or 'Create new' with no term).
	CreateLabel: false,
	// Clearable (single mode): when true, the dropdown gets a pinned "Any" row at the top and the
	// control grows an inline × while a value is selected — either empties the selection and fires
	// OnChange(null, null). Filters are the natural fit ("Any" = no constraint); multi mode already
	// clears via its chips, so the option is ignored there.
	AllowClear: false,
	ClearLabel: 'Any',
	// The text shown when the list has no options for the current search. A string, or a function
	// (searchTerm) => string asked again on every empty render, so a host can say why the list is empty
	// (e.g. its own scope narrowed it). Rendered as text; an empty result or a throw falls back to the default.
	EmptyLabel: 'No matches',
	// How many lines a long option label may wrap to in the open list before it ends in an ellipsis (the
	// full text stays in the row's tooltip). 1 keeps every row on one line; 0 lets labels wrap without limit.
	OptionLabelLines: 3,

	// When true, render the resolved selection as plain, non-interactive text (no dropdown / chevron /
	// clear) — for read-only form views. The host sets PictForm.ReadOnly; the form-input passes it through.
	ReadOnly: false,

	// Opt-in: opening this picker closes any other open picker that ALSO opted in (at most one dropdown
	// on the page — select2-style). Off by default so hosts that tolerate stacked dropdowns see no
	// behavior change, and a picker left off is neither closed by nor closes a participant. Usually
	// enabled fleet-wide via the provider's SingleActivePicker option (createPicker seeds it).
	SingleActivePicker: false,

	// The Meadow entity this picker selects from. Set automatically by createEntityPicker; a custom-
	// DataProvider host may pass it to opt into entity-aware affordances (preview cards, field decoration).
	Entity: false,
	// Field decoration (opt-in). When true AND the picker is entity-aware — an `Entity` name is set and its
	// result rows carry a full `Record` — a small ⚙ in the search row lets the user pin extra record fields
	// onto every option row as tag badges ("VendorCode: 12345"), to tell same-named entities apart. The
	// choice is remembered in localStorage keyed by Entity (so it follows the user to every picker of that
	// entity) and never leaves the browser. `DecorationIgnoreFields` drops fields from the chooser, on top
	// of the value/text fields and the common audit columns, which are always hidden.
	AllowFieldDecoration: false,
	DecorationIgnoreFields: [],

	// Values that mean "nothing is selected" for DISPLAY, on top of undefined/null/''. The widget still
	// stores and returns whatever it was given — this only decides whether the control paints the
	// placeholder instead of the raw value, so a host's sentinel never has to become a data change.
	// The pict-section-form adapter seeds it with [0] for a Number/Integer/Float descriptor, whose
	// pristine marshal value is manyfest's DataType default 0 rather than ''. A sentinel that DOES
	// resolve to a real source row (a static option literally valued 0) is a genuine selection and is
	// shown normally.
	EmptyValues: [],

	Templates:
	[
		{
			// The whole widget: control box + (transparent) backdrop + dropdown. The dropdown lives in
			// the DOM whether open or closed (toggled by the .pps-open class) so open/close needs no
			// re-render. The option list re-renders on its own for search (keeps the input focused).
			// The control is a div (role=combobox) not a button so multi-mode chips can carry their own
			// remove buttons without nesting <button> elements.
			Hash: 'Pict-Section-Picker-Control',
			Template: /*html*/`
	<div class="pps{~NE:Record.IsMulti^ pps-multi~}{~NE:Record.ReadOnly^ pps-readonly~}" id="PPS_{~D:Record.PickerHash~}">
		<div class="pps-control" role="combobox" tabindex="0" aria-haspopup="listbox" onclick="_Pict.views['{~D:Record.PickerHash~}'].toggle(event)" onkeydown="_Pict.views['{~D:Record.PickerHash~}'].onControlKey(event)">
			<div class="pps-valuearea" id="PPS_Value_{~D:Record.PickerHash~}">{~T:Pict-Section-Picker-ValueArea~}</div>
			{~TS:Pict-Section-Picker-ClearX:Record.ClearSlot~}
			<span class="pps-chevron">{~I:ChevronDown~}</span>
		</div>
		<div class="pps-backdrop" onclick="_Pict.views['{~D:Record.PickerHash~}'].closeFromBackdrop(event)"></div>
		<div class="pps-pop" id="PPS_Pop_{~D:Record.PickerHash~}">
			<div class="pps-panel">
				{~TS:Pict-Section-Picker-Search:Record.SearchSlot~}
				<div class="pps-decorate-panel" id="PPS_Decorate_{~D:Record.PickerHash~}">{~T:Pict-Section-Picker-DecoratePanel~}</div>
				<div class="pps-list" id="PPS_List_{~D:Record.PickerHash~}" style="--pps-option-lines: {~D:Record.OptionLabelLines~}">
					{~T:Pict-Section-Picker-List~}
				</div>
			</div>
		</div>
	</div>
`
		},
		{
			// The control's value display: single-mode value span OR multi-mode chips, chosen by the
			// single-element-array slots so we never render both.
			Hash: 'Pict-Section-Picker-ValueArea',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-Single:Record.SingleSlot~}
	{~TS:Pict-Section-Picker-Multi:Record.MultiSlot~}
`
		},
		{
			// The inline clear × (AllowClear) — a control-level adornment between the value area and
			// the chevron, so it centers next to the text (the value area's children stack as blocks).
			// It sits OUTSIDE #PPS_Value_, so the targeted repaint can't refresh it — and its presence
			// tracks the VALUE. _shapeSignature() therefore includes it, which forces setValue onto a
			// full render whenever it would appear or disappear. stopPropagation so clearing
			// never bubbles into the control's open/close toggle — mirrors the multi-chip remove ×.
			Hash: 'Pict-Section-Picker-ClearX',
			Template: /*html*/`
	<span class="pps-clear" title="Clear" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].clearValue()">{~I:Close~}</span>
`
		},
		{
			Hash: 'Pict-Section-Picker-Single',
			Template: /*html*/`
	<span class="pps-valuebox">{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-value{~NE:Record.NoValue^ pps-placeholder~}" title="{~D:Record.ValueTitleAttr~}">{~D:Record.DisplayTextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-CardInfo:Record.CardSlot~}</span>
`
		},
		{
			// Multi-mode: the selected chips, plus a placeholder slot when nothing is selected.
			Hash: 'Pict-Section-Picker-Multi',
			Template: /*html*/`
	<span class="pps-chips">{~TS:Pict-Section-Picker-Chip:Record.Chips~}{~TS:Pict-Section-Picker-Placeholder:Record.PlaceholderSlot~}</span>
`
		},
		{
			Hash: 'Pict-Section-Picker-Placeholder',
			Template: /*html*/`
	<span class="pps-chips-ph">{~D:Record.Placeholder~}</span>
`
		},
		{
			// One selected chip with an inline remove button. stopPropagation on the × so removing a
			// chip never bubbles up to the control's open/close toggle.
			Hash: 'Pict-Section-Picker-Chip',
			Template: /*html*/`
	<span class="pps-chip">{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-chip-text" title="{~D:Record.TextAttr~}">{~D:Record.TextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-CardInfo:Record.CardSlot~}<span class="pps-chip-x" data-pps-valuekey="{~D:Record.ValueKeyAttr~}" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].removeChipFromElement(this)">{~I:Close~}</span></span>
`
		},
		{
			// Search box — its own template (gated by the single-element-array SearchSlot) because
			// {~NE:~} does not recursively parse nested {~I:~}/{~D:~} tags.
			Hash: 'Pict-Section-Picker-Search',
			Template: /*html*/`
	<div class="pps-search">
		<span class="pps-search-ic">{~I:Search~}</span>
		<input type="text" id="PPS_Search_{~D:Record.PickerHash~}" placeholder="Search…" autocomplete="off" oninput="_Pict.views['{~D:Record.PickerHash~}'].search(this.value)" onkeydown="_Pict.views['{~D:Record.PickerHash~}'].onSearchKey(event)">
		{~TS:Pict-Section-Picker-DecorateToggle:Record.DecorateSlot~}
	</div>
`
		},
		{
			Hash: 'Pict-Section-Picker-List',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-ClearOption:Record.ClearOptionSlot~}
	{~TS:Pict-Section-Picker-Create:Record.CreateSlot~}
	{~TS:Pict-Section-Picker-Group:Record.Groups~}
	{~TS:Pict-Section-Picker-Empty:Record.EmptySlot~}
	{~NE:Record.Loading^<div class="pps-loading">Loading…</div>~}
	{~TS:Pict-Section-Picker-More:Record.MoreSlot~}
`
		},
		{
			Hash: 'Pict-Section-Picker-Empty',
			Template: /*html*/`<div class="pps-empty">{~D:Record.Label~}</div>`
		},
		{
			// The pinned "Any" row (AllowClear, single mode) — selecting it empties the selection.
			// It shows the check when nothing is selected (i.e. "Any" is the active state).
			Hash: 'Pict-Section-Picker-ClearOption',
			Template: /*html*/`
	<button type="button" class="pps-option pps-clear-option{~NE:Record.Selected^ pps-selected~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].clearValue()">
		<span class="pps-option-check{~NE:Record.NotSelected^ pps-hidden~}">{~I:Check~}</span>
		<span class="pps-option-label">{~D:Record.Label~}</span>
	</button>
`
		},
		{
			// A category: an optional header (single-element-array HeaderSlot) followed by its options.
			// With no categories everything lands in one unlabeled group, so the list path is uniform.
			Hash: 'Pict-Section-Picker-Group',
			Template: /*html*/`
	{~TS:Pict-Section-Picker-GroupHeader:Record.HeaderSlot~}
	{~TS:Pict-Section-Picker-Option:Record.Options~}
`
		},
		{
			Hash: 'Pict-Section-Picker-GroupHeader',
			Template: /*html*/`
	<div class="pps-group">{~D:Record.Label~}</div>
`
		},
		{
			// "Create <term>" row — its own template (single-element-array CreateSlot), so the nested
			// {~I:~}/{~D:~} tags parse (unlike inside an {~NE:~}).
			Hash: 'Pict-Section-Picker-Create',
			Template: /*html*/`
	<button type="button" class="pps-create" onclick="_Pict.views['{~D:Record.PickerHash~}'].createFromSearch()"><span class="pps-create-ic">{~I:Plus~}</span><span class="pps-create-label">{~D:Record.Label~}</span></button>
`
		},
		{
			// "Load more" — its own template (single-element-array MoreSlot) for the same nested-tag
			// reason as the search box.
			Hash: 'Pict-Section-Picker-More',
			Template: /*html*/`
	<button type="button" class="pps-more" onclick="_Pict.views['{~D:Record.PickerHash~}'].loadMore()">Load more</button>
`
		},
		{
			Hash: 'Pict-Section-Picker-Option',
			Template: /*html*/`
	<button type="button" class="pps-option{~NE:Record.Selected^ pps-selected~}{~NE:Record.Highlight^ pps-highlight~}" data-pps-valuekey="{~D:Record.ValueKeyAttr~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].selectFromElement(this)">
		<span class="pps-option-check{~NE:Record.NotSelected^ pps-hidden~}">{~I:Check~}</span>
		{~TS:Pict-Section-Picker-Tag:Record.TagBeforeSlot~}<span class="pps-option-label" title="{~D:Record.TextAttr~}">{~D:Record.TextAttr~}</span>{~TS:Pict-Section-Picker-Tag:Record.TagAfterSlot~}{~TS:Pict-Section-Picker-IDMatch:Record.IDMatchSlot~}
	</button>
`
		},
		{
			Hash: 'Pict-Section-Picker-IDMatch',
			Template: /*html*/`<span class="pps-option-idmatch">{~D:Record.Label~}</span>`
		},
		{
			// EntityTag badge — a small code/number pill rendered before or after the label via the
			// TagBeforeSlot / TagAfterSlot single-element-array slots on each option / chip / value record.
			Hash: 'Pict-Section-Picker-Tag',
			Template: /*html*/`
		<span class="pps-tag">{~D:Record.Tag~}</span>
`
		},
		{
			// Preview-card ⓘ trigger — a small affordance next to a selected value / chip that opens the
			// entity's registered preview card (RecordSetCardManager, a soft dependency). Gated to a
			// single-element-array CardSlot so it renders only when a card exists for the picker's Entity;
			// stopPropagation so it never toggles the control or removes a chip.
			Hash: 'Pict-Section-Picker-CardInfo',
			Template: /*html*/`
		<span class="pps-card-info" title="Preview" data-pps-entity="{~D:Record.EntityAttr~}" data-pps-value="{~D:Record.ValueAttr~}" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].openCardFromElement(this)">{~I:Info~}</span>
`
		},
		{
			// Field-decoration ⚙ (AllowFieldDecoration) — a trailing button in the search row that opens the
			// field chooser. Rendered via the single-element-array DecorateSlot so it appears only when the
			// feature is enabled + eligible. stopPropagation so it never bubbles into the control toggle.
			Hash: 'Pict-Section-Picker-DecorateToggle',
			Template: /*html*/`<button type="button" id="PPS_DecorateBtn_{~D:Record.PickerHash~}" class="pps-decorate-btn{~NE:Record.HasFields^ pps-decorate-on~}{~NE:Record.Open^ pps-decorate-open~}" title="Show extra fields on each row" onclick="event.stopPropagation(); _Pict.views['{~D:Record.PickerHash~}'].toggleDecorate(event)">{~I:Settings~}</button>`
		},
		{
			// The field chooser — rendered into #PPS_Decorate_ between the search row and the list. Empty
			// (collapsed) unless the chooser is open; DecoratePanelSlot carries the candidate fields.
			Hash: 'Pict-Section-Picker-DecoratePanel',
			Template: /*html*/`{~TS:Pict-Section-Picker-DecorateInner:Record.DecoratePanelSlot~}`
		},
		{
			Hash: 'Pict-Section-Picker-DecorateInner',
			Template: /*html*/`
		<div class="pps-decorate">
			<div class="pps-decorate-title">Show extra fields on each row</div>
			<div class="pps-decorate-list">{~TS:Pict-Section-Picker-DecorateField:Record.Fields~}{~NE:Record.NoFields^<div class="pps-decorate-empty">No extra fields to show yet.</div>~}</div>
		</div>
`
		},
		{
			// One checkbox row in the chooser. The label wraps the input so a click anywhere toggles it.
			Hash: 'Pict-Section-Picker-DecorateField',
			Template: /*html*/`<label class="pps-decorate-opt"><input type="checkbox"{~NE:Record.Checked^ checked~} data-pps-field="{~D:Record.FieldAttr~}" onclick="_Pict.views['{~D:Record.PickerHash~}'].toggleDecorateFieldFromElement(this)"><span class="pps-decorate-name">{~D:Record.FieldAttr~}</span></label>`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'Pict-Section-Picker-Renderable',
			TemplateHash: 'Pict-Section-Picker-Control',
			RenderMethod: 'replace',
		},
	],
};

class PictViewPicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Render the control into the host-supplied destination, and read state from this picker's
		// AppData slot (keyed by hash so many pickers can share the global templates).
		this.options.DefaultDestinationAddress = this.options.DestinationAddress || `#${this.options.PickerHash}`;
		this._StateAddress = `AppData.PictSectionPicker.${this.options.PickerHash}`;
		this.options.DefaultTemplateRecordAddress = this._StateAddress;
		if (Array.isArray(this.options.Renderables) && this.options.Renderables[0])
		{
			this.options.Renderables[0].ContentDestinationAddress = this.options.DefaultDestinationAddress;
		}

		// Transient UI state (the data lives in AppData; these drive a single picker's interaction).
		this._open = false;
		this._search = '';
		this._highlight = -1;
		// Async-mode state (Phase 2): accumulated results across pages + paging/loading flags.
		this._loadedResults = [];
		this._page = 0;
		this._hasMore = false;
		this._loading = false;
		this._loaded = false;
		this._searchTimer = null;
		this._selectedText = null;
		// Anchoring: true while portaled to <body>, false while CSS-anchored. Decided per open (see the
		// "Dropdown anchoring & render states" note below).
		this._portaled = false;
		// _shapeSignature() of the current paint, stamped by onAfterRender (null until first render).
		this._renderedShape = null;
		// Multi-mode state: the authoritative {Value,Text} for each selected value, keyed by String(Value),
		// so a chip keeps its label even after the search results that produced it have scrolled away.
		this._values = [];
		this._selectedRecords = {};

		// Field-decoration (opt-in) state: the chosen extra fields (loaded from localStorage) + the chooser's
		// open flag + a lazily-resolved storage backend. Load before the first _buildState so the initial
		// paint already carries any remembered decorations.
		this._decorationOpen = false;
		this._decorationFields = [];
		this._decorationStore = null;
		this._loadDecorationFields();

		// Populate the AppData state slot now so the template Record (resolved from
		// DefaultTemplateRecordAddress) reflects it on the very first render — pict resolves the
		// Record before onBeforeRender runs.
		try { this._buildState(); } catch (pError) { /* AppData/value not ready — onBeforeRender will build it */ }

		// Async mode: resolve the display text of pre-set bound value(s) (e.g. fetch the entity for an ID).
		if (this._isAsync() && typeof this.options.ResolveValue === 'function')
		{
			this._resolveInitialValues();
		}
	}

	/** @return {boolean} True when a DataProvider function is configured (async/server mode). */
	_isAsync()
	{
		return (typeof this.options.DataProvider === 'function');
	}

	/** @return {boolean} True when the picker is in multi-select (chips) mode. */
	_isMulti()
	{
		return (this.options.Mode === 'multi');
	}

	/** @return {Record<string, any>} The AppData state slot for this picker. */
	_state()
	{
		this.pict.AppData.PictSectionPicker = this.pict.AppData.PictSectionPicker || {};
		this.pict.AppData.PictSectionPicker[this.options.PickerHash] = this.pict.AppData.PictSectionPicker[this.options.PickerHash] || {};
		return this.pict.AppData.PictSectionPicker[this.options.PickerHash];
	}

	/**
	 * True when a value should be PAINTED as "nothing selected" — undefined/null/'', or one of the
	 * host's configured `EmptyValues` sentinels. Display-only: `_value` / getValue() keep the raw value,
	 * so nothing here rewrites the host's model.
	 *
	 * The sentinel yields to reality: one that matches a real source row (a static option literally
	 * valued 0, say) is a genuine selection and renders normally. Entity pickers skip the async resolve
	 * for a sentinel entirely — there is no entity #0 to fetch.
	 * @param {any} pValue @return {boolean}
	 */
	_isEmptyValue(pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '') { return true; }
		const tmpEmptyValues = this.options.EmptyValues;
		if (!Array.isArray(tmpEmptyValues) || tmpEmptyValues.length < 1) { return false; }
		if (!tmpEmptyValues.some((pEmpty) => String(pEmpty) === String(pValue))) { return false; }
		return !this._lookupRecord(pValue);
	}

	/** Resolve display text for any pre-bound value(s) via the async ResolveValue hook, then repaint. */
	_resolveInitialValues()
	{
		const tmpResolveOne = (pValue) =>
		{
			if (this._isEmptyValue(pValue)) { return; }
			Promise.resolve(this.options.ResolveValue(pValue)).then((pResolved) =>
			{
				if (pResolved && pResolved.Text)
				{
					if (this._isMulti())
					{
						this._selectedRecords[String(pValue)] = { Value: pResolved.Value !== undefined ? pResolved.Value : pValue, Text: pResolved.Text, Tag: pResolved.Tag, Tags: pResolved.Tags };
						this._renderValue();
					}
					else
					{
						this._selectedText = pResolved.Text;
						this.render();
					}
				}
			}).catch(() => { /* leave the raw value showing */ });
		};

		if (this._isMulti())
		{
			this.getValue().forEach(tmpResolveOne);
		}
		else
		{
			tmpResolveOne(this.getValue());
		}
	}

	/**
	 * @return {any} The current selection: a scalar in single mode, or an array of values in multi mode
	 *   (normalizing a csv string or scalar at the bound address into an array).
	 */
	getValue()
	{
		const tmpRaw = this.options.ValueAddress
			? this.pict.manifest.getValueAtAddress(this.pict, this.options.ValueAddress)
			: (this._isMulti() ? this._values : this._value);
		if (!this._isMulti())
		{
			return tmpRaw;
		}
		if (tmpRaw === undefined || tmpRaw === null || tmpRaw === '') { return []; }
		if (Array.isArray(tmpRaw)) { return tmpRaw; }
		if (typeof tmpRaw === 'string') { return tmpRaw.split(',').filter((pPart) => pPart !== ''); }
		return [ tmpRaw ];
	}

	/**
	 * Persist the selection to the bound address(es). Single mode writes the scalar; multi mode writes
	 * the array to ValueAddress and mirrors it to the optional csv / records addresses.
	 * @param {any} pValue - The new value (scalar in single mode, array in multi mode).
	 */
	_setValue(pValue)
	{
		if (!this._isMulti())
		{
			this._value = pValue;
			if (this.options.ValueAddress)
			{
				this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, pValue);
			}
			return;
		}

		const tmpArray = Array.isArray(pValue) ? pValue : [];
		this._values = tmpArray;
		if (this.options.ValueAddress)
		{
			this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, tmpArray);
		}
		if (this.options.StringArrayValueAddress)
		{
			this.pict.manifest.setValueAtAddress(this.pict, this.options.StringArrayValueAddress, tmpArray.join(','));
		}
		if (this.options.SelectedValuesAddress)
		{
			const tmpRecords = tmpArray.map((pVal) => this._selectedRecords[String(pVal)] || { Value: pVal, Text: String(pVal) });
			this.pict.manifest.setValueAtAddress(this.pict, this.options.SelectedValuesAddress, tmpRecords);
		}
	}

	/**
	 * Public: set the picker's value programmatically (e.g. when a host form marshals data into it).
	 * Accepts a scalar (single mode) or an array / csv string (multi mode), seeds display text for any
	 * unknown values (from the source rows, else async ResolveValue), then repaints.
	 * @param {any} pValue
	 * @return {PictViewPicker} this
	 */
	setValue(pValue)
	{
		if (this._isMulti())
		{
			let tmpArray = pValue;
			if (tmpArray === undefined || tmpArray === null || tmpArray === '') { tmpArray = []; }
			else if (typeof tmpArray === 'string') { tmpArray = tmpArray.split(',').filter((pPart) => pPart !== ''); }
			else if (!Array.isArray(tmpArray)) { tmpArray = [ tmpArray ]; }
			// Seed the {Value,Text} records BEFORE persisting, so the SelectedValuesAddress mirror that
			// _setValue writes carries real labels (not String(value) fallbacks). Mirrors select()'s
			// seed-then-persist order.
			this._seedSelectedRecords(tmpArray);
			this._setValue(tmpArray);
		}
		else
		{
			this._setValue(pValue);
			this._selectedText = null;
			this._seedSelectedRecords(this._isEmptyValue(pValue) ? [] : [ pValue ]);
		}
		this._reflectValue();
		return this;
	}

	/**
	 * Reflect a programmatic setValue into the DOM. Full render when the widget isn't live yet, or when
	 * _shapeSignature() shows something outside the value area / list changed; otherwise just repaint
	 * those two (the list's checkmark tracks the value). The targeted path is what lets a form marshal
	 * re-seed on every solve without tearing down the search box (losing focus) or orphaning a portal.
	 * select()/clearValue() keep their own full renders — this is only the setValue path.
	 */
	_reflectValue()
	{
		const tmpLive = (typeof document !== 'undefined') && !!document.getElementById(`PPS_${this.options.PickerHash}`);
		if (!tmpLive || (this._shapeSignature() !== this._renderedShape)) { this.render(); return; }
		this._renderValue();
		this._renderList();
	}

	/**
	 * Signature of the render-affecting state the targeted refresh CANNOT repaint — the three things that
	 * render outside #PPS_Value_ / #PPS_List_: the root's pps-multi/pps-readonly classes, the search box,
	 * and the inline clear × (gated on value presence, so it moves with no config change). _reflectValue
	 * full-renders when this changes. Extend it if the control template grows another such slot.
	 * @return {string}
	 */
	_shapeSignature()
	{
		const tmpMulti = this._isMulti();
		const tmpValue = tmpMulti ? undefined : this.getValue();
		const tmpHasValue = !this._isEmptyValue(tmpValue);
		return [
			tmpMulti,
			!!this.options.ReadOnly,
			!!this.options.Searchable,
			(!tmpMulti && this.options.AllowClear === true && tmpHasValue),
		].join('|');
	}

	/**
	 * Ensure each value has a {Value,Text} in _selectedRecords — from the current source rows when
	 * present, else (async mode) fetched via ResolveValue and painted in when it resolves.
	 * @param {Array<any>} pValues
	 */
	_seedSelectedRecords(pValues)
	{
		pValues.forEach((pVal) =>
		{
			if (this._isEmptyValue(pVal) || this._selectedRecords[String(pVal)]) { return; }
			const tmpRow = this._sourceRows().find((pRow) => String(pRow.Value) === String(pVal));
			if (tmpRow)
			{
				this._selectedRecords[String(pVal)] = { Value: tmpRow.Value, Text: tmpRow.Text, Tag: tmpRow.Tag, Tags: tmpRow.Tags };
				return;
			}
			if (this._isAsync() && typeof this.options.ResolveValue === 'function')
			{
				Promise.resolve(this.options.ResolveValue(pVal)).then((pResolved) =>
				{
					if (pResolved && pResolved.Text)
					{
						this._selectedRecords[String(pVal)] = { Value: pResolved.Value !== undefined ? pResolved.Value : pVal, Text: pResolved.Text, Tag: pResolved.Tag, Tags: pResolved.Tags };
						if (!this._isMulti()) { this._selectedText = pResolved.Text; }
						this._renderValue();
					}
				}).catch(() => { /* leave the raw value showing */ });
			}
		});
	}

	/** @return {Array<{Value:any, Text:string, Tag?:any}>} The current option source rows (async results or static Options). */
	_sourceRows()
	{
		if (this._isAsync()) { return this._loadedResults; }
		return Array.isArray(this.options.Options) ? this.options.Options : [];
	}

	/**
	 * Build the EntityTag before/after render slots for a record. Accepts a single tag value OR an array
	 * of them (the `Tags` multi-badge form), so a record can carry several disambiguation chips (e.g. a
	 * book's ISBN + year). Empty/blank entries are dropped; a tag-less record renders no badge. The slot
	 * is a per-tag `{Tag}` array, and the value/chip/option templates already iterate it with `{~TS:~}`.
	 * @param {any} pTags - a tag value, or an array of tag values.
	 * @param {boolean} pTagLast
	 * @return {{TagBeforeSlot:Array<any>, TagAfterSlot:Array<any>}}
	 */
	_tagSlots(pTags, pTagLast)
	{
		const tmpList = Array.isArray(pTags)
			? pTags
			: ((pTags !== undefined && pTags !== null && pTags !== '') ? [ pTags ] : []);
		const tmpSlot = tmpList
			.filter((pTag) => (pTag !== undefined && pTag !== null && pTag !== ''))
			.map((pTag) => ({ Tag: pTag }));
		return {
			TagBeforeSlot: (tmpSlot.length > 0 && !pTagLast) ? tmpSlot : [],
			TagAfterSlot: (tmpSlot.length > 0 && pTagLast) ? tmpSlot : [],
		};
	}

	/**
	 * The tag(s) to render for a record — the multi-badge `Tags` array when present, else the single
	 * `Tag` (back-compat). Centralizes the precedence used by every `_tagSlots` call site.
	 * @param {any} pRecord
	 * @return {any}
	 */
	_recordTags(pRecord)
	{
		if (!pRecord) { return undefined; }
		return (pRecord.Tags !== undefined) ? pRecord.Tags : pRecord.Tag;
	}

	// --- Field decoration (opt-in): let the user pin extra record fields onto each option row ---

	/** @return {boolean} The decoration affordance is available: opted in, interactive, and namespaced. */
	_decorationEnabled()
	{
		return (this.options.AllowFieldDecoration === true) && !this.options.ReadOnly && !!this._decorationKey();
	}

	/** localStorage key — per Entity, so a field pinned on one Organization picker shows on them all;
	 *  falls back to the picker hash when no Entity is set. @return {string} */
	_decorationKey()
	{
		if (this.options.Entity) { return `${_DECORATION_KEY_PREFIX}${this.options.Entity}`; }
		return this.options.PickerHash ? `${_DECORATION_KEY_PREFIX}${this.options.PickerHash}` : '';
	}

	/** Lazily resolve a storage backend: window.localStorage in a browser, an in-memory shim otherwise
	 *  (unit tests / SSR), mirroring the pict-section-recordset persistence idiom. */
	_decorationStorage()
	{
		if (this._decorationStore) { return this._decorationStore; }
		if ((typeof window === 'object') && window && (typeof window.localStorage === 'object') && window.localStorage)
		{
			this._decorationStore = window.localStorage;
		}
		else
		{
			const tmpMemory = {};
			this._decorationStore = {
				getItem: (pKey) => ((pKey in tmpMemory) ? tmpMemory[pKey] : null),
				setItem: (pKey, pValue) => { tmpMemory[pKey] = String(pValue); },
				removeItem: (pKey) => { delete tmpMemory[pKey]; },
			};
		}
		return this._decorationStore;
	}

	/** Read the persisted decoration field list for this picker's entity into _decorationFields. */
	_loadDecorationFields()
	{
		this._decorationFields = [];
		if (this.options.AllowFieldDecoration !== true) { return; }
		const tmpKey = this._decorationKey();
		if (!tmpKey) { return; }
		try
		{
			const tmpRaw = this._decorationStorage().getItem(tmpKey);
			const tmpParsed = tmpRaw ? JSON.parse(tmpRaw) : [];
			if (Array.isArray(tmpParsed)) { this._decorationFields = tmpParsed.filter((pField) => ((typeof pField === 'string') && pField)); }
		}
		catch (pError) { this._decorationFields = []; }
	}

	/** Persist the current decoration field list under this picker's entity key. */
	_saveDecorationFields()
	{
		const tmpKey = this._decorationKey();
		if (!tmpKey) { return; }
		try { this._decorationStorage().setItem(tmpKey, JSON.stringify(this._decorationFields)); }
		catch (pError) { /* storage full / disabled — the in-session choice still applies */ }
	}

	/** Field names hidden from the chooser: the common audit columns + the host's DecorationIgnoreFields +
	 *  the value/text fields (already shown as the row's value + label). @return {Set<string>} */
	_decorationIgnoreSet()
	{
		const tmpSet = new Set(_DECORATION_IGNORE_DEFAULT);
		const tmpHostIgnore = Array.isArray(this.options.DecorationIgnoreFields) ? this.options.DecorationIgnoreFields : [];
		tmpHostIgnore.forEach((pField) => { if (pField) { tmpSet.add(String(pField)); } });
		if (this.options.ValueField) { tmpSet.add(String(this.options.ValueField)); }
		else if (this.options.Entity) { tmpSet.add(`ID${this.options.Entity}`); }
		tmpSet.add(this.options.TextField ? String(this.options.TextField) : 'Name');
		return tmpSet;
	}

	/** Candidate decoration fields: the union of keys across the loaded rows' `Record` objects, minus the
	 *  ignore set, sorted. Empty until a result page carries records. @return {Array<string>} */
	_decorationCandidateFields()
	{
		const tmpKeys = {};
		this._sourceRows().forEach((pRow) =>
		{
			const tmpRecord = pRow && pRow.Record;
			if (tmpRecord && (typeof tmpRecord === 'object')) { Object.keys(tmpRecord).forEach((pKey) => { tmpKeys[pKey] = true; }); }
		});
		const tmpIgnore = this._decorationIgnoreSet();
		return Object.keys(tmpKeys).filter((pKey) => !tmpIgnore.has(pKey)).sort();
	}

	/** The decoration chips for an option: "Field: value" for each chosen field present on its `Record`.
	 *  @param {any} pOption @return {Array<string>|null} */
	_decorationTagsFor(pOption)
	{
		if (!this._decorationEnabled() || (this._decorationFields.length === 0)) { return null; }
		const tmpRecord = pOption && pOption.Record;
		if (!tmpRecord || (typeof tmpRecord !== 'object')) { return null; }
		const tmpTags = this._decorationFields
			.map((pField) => { const tmpValue = tmpRecord[pField]; return ((tmpValue !== undefined && tmpValue !== null && tmpValue !== '') ? `${pField}: ${tmpValue}` : null); })
			.filter((pTag) => (pTag !== null));
		return (tmpTags.length > 0) ? tmpTags : null;
	}

	/** The row's own EntityTag(s) plus the user's decoration chips (decorations last). @param {any} pOption */
	_combinedTags(pOption)
	{
		const tmpBase = this._recordTags(pOption);
		const tmpDecoration = this._decorationTagsFor(pOption);
		if (!tmpDecoration) { return tmpBase; }
		const tmpBaseList = Array.isArray(tmpBase) ? tmpBase : ((tmpBase !== undefined && tmpBase !== null && tmpBase !== '') ? [ tmpBase ] : []);
		return tmpBaseList.concat(tmpDecoration);
	}

	/** Toggle the field chooser open/closed (the ⚙ in the search row); repaints just the chooser + button. */
	toggleDecorate(pEvent)
	{
		if (pEvent && (typeof pEvent.stopPropagation === 'function')) { pEvent.stopPropagation(); }
		if (!this._decorationEnabled()) { return; }
		this._decorationOpen = !this._decorationOpen;
		this._renderDecorate();
		this._syncDecorateToggle();
	}

	/** Add/remove a field from the decoration set, persist, and repaint the option list + chooser. */
	toggleDecorateField(pField)
	{
		if (!pField) { return; }
		const tmpIndex = this._decorationFields.indexOf(pField);
		if (tmpIndex >= 0) { this._decorationFields.splice(tmpIndex, 1); }
		else { this._decorationFields.push(pField); }
		this._saveDecorationFields();
		this._renderList();
		this._renderDecorate();
		this._syncDecorateToggle();
	}

	/** Re-render only the chooser panel (mirrors _renderList — targeted, keeps the search input focused). */
	_renderDecorate()
	{
		if (typeof document === 'undefined') { return; }
		if (!document.getElementById(`PPS_Decorate_${this.options.PickerHash}`)) { return; }
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-DecoratePanel', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_Decorate_${this.options.PickerHash}`, tmpHTML);
	}

	/** Reflect the on/open state onto the ⚙ button without rebuilding the search row (which holds focus). */
	_syncDecorateToggle()
	{
		if (typeof document === 'undefined') { return; }
		const tmpBtn = document.getElementById(`PPS_DecorateBtn_${this.options.PickerHash}`);
		if (!tmpBtn) { return; }
		tmpBtn.classList.toggle('pps-decorate-on', (this._decorationFields.length > 0));
		tmpBtn.classList.toggle('pps-decorate-open', !!this._decorationOpen);
	}

	/**
	 * The empty-list text for the current search: the EmptyLabel string, or what an EmptyLabel function
	 * returns for the search term. A blank result or a throw falls back to the default.
	 *
	 * @return {string} The label, unescaped.
	 */
	_resolveEmptyLabel()
	{
		const tmpDefault = 'No matches';
		let tmpLabel = this.options.EmptyLabel;
		if (typeof tmpLabel === 'function')
		{
			try
			{
				tmpLabel = tmpLabel(this._search || '');
			}
			catch (pError)
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] EmptyLabel() threw; showing the default.`, pError);
				tmpLabel = '';
			}
		}
		return (typeof tmpLabel === 'string' && tmpLabel.length > 0) ? tmpLabel : tmpDefault;
	}

	/**
	 * The "Create …" row's text for a search term: the CreateLabel string, or what a CreateLabel function
	 * returns for the term. A blank result or a throw falls back to the default.
	 *
	 * @param {string} pTerm - The trimmed search term ('' when nothing is typed).
	 * @return {string} The label, unescaped.
	 */
	_resolveCreateLabel(pTerm)
	{
		const tmpDefault = (pTerm.length > 0) ? `Create “${pTerm}”` : 'Create new';
		let tmpLabel = this.options.CreateLabel;
		if (typeof tmpLabel === 'function')
		{
			try
			{
				tmpLabel = tmpLabel(pTerm);
			}
			catch (pError)
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] CreateLabel() threw; showing the default.`, pError);
				tmpLabel = '';
			}
		}
		return (typeof tmpLabel === 'string' && tmpLabel.length > 0) ? tmpLabel : tmpDefault;
	}

	/**
	 * The `--pps-option-lines` value for the open list, from OptionLabelLines: a whole number of lines, or
	 * `none` (0 / false) for no limit. Anything unusable falls back to the default.
	 *
	 * @return {string}
	 */
	_optionLabelLines()
	{
		const tmpLines = this.options.OptionLabelLines;
		if (tmpLines === 0 || tmpLines === false)
		{
			return 'none';
		}
		const tmpCount = parseInt(tmpLines, 10);
		return (tmpCount >= 1) ? String(tmpCount) : String(_DEFAULT_CONFIGURATION.OptionLabelLines);
	}

	/**
	 * (Re)compute the picker's render state into AppData: the displayed value / chips + the
	 * (search-filtered) option list with selected/highlight flags.
	 */
	_buildState()
	{
		const tmpState = this._state();
		const tmpAsync = this._isAsync();
		const tmpMulti = this._isMulti();
		const tmpSearch = (this._search || '').toLowerCase();

		// Source rows: async = the accumulated server results (already filtered server-side);
		// static = the configured Options, filtered locally by the search term.
		const tmpStatic = Array.isArray(this.options.Options) ? this.options.Options : [];
		const tmpSource = tmpAsync
			? this._loadedResults
			: tmpStatic.filter((pOption) => !tmpSearch || String(pOption.Text).toLowerCase().includes(tmpSearch));

		// Membership set used to flag options as selected (multi: every value; single: the one value).
		const tmpSelectedKeys = new Set((tmpMulti ? this.getValue() : [ this.getValue() ])
			.filter((pVal) => !this._isEmptyValue(pVal))
			.map((pVal) => String(pVal)));

		const tmpTagLast = !!this.options.TagLast;
		tmpState.Options = tmpSource.map((pOption, pIndex) =>
		{
			const tmpIsSelected = tmpSelectedKeys.has(String(pOption.Value));
			return Object.assign({
				PickerHash: this.options.PickerHash,
				ValueKey: String(pOption.Value),
				ValueKeyAttr: escapeHTML(String(pOption.Value)),
				Text: pOption.Text,
				TextAttr: escapeHTML(pOption.Text),
				Selected: tmpIsSelected,
				NotSelected: !tmpIsSelected,
				Highlight: (pIndex === this._highlight),
				IDMatchSlot: pOption.IDMatch ? [ { Label: escapeHTML(String(pOption.IDMatch)) } ] : [],
			}, this._tagSlots(this._combinedTags(pOption), tmpTagLast));
		});

		// Cluster options into categories (preserving order), keyed by each source row's optional Group.
		// With no Group fields everything lands in one unlabeled group, so the renderer has one path.
		const tmpGroups = [];
		const tmpGroupIndex = {};
		tmpState.Options.forEach((pOption, pIndex) =>
		{
			const tmpLabel = (tmpSource[pIndex] && tmpSource[pIndex].Group) ? String(tmpSource[pIndex].Group) : '';
			if (!(tmpLabel in tmpGroupIndex))
			{
				tmpGroupIndex[tmpLabel] = tmpGroups.length;
				tmpGroups.push({ Label: tmpLabel, HeaderSlot: tmpLabel ? [ { Label: tmpLabel } ] : [], Options: [] });
			}
			tmpGroups[tmpGroupIndex[tmpLabel]].Options.push(pOption);
		});
		tmpState.Groups = tmpGroups;

		// Creatable: offer "Create <term>" for a non-empty search that doesn't exactly match a known row, or
		// always when CreateAlwaysVisible pins the row.
		const tmpTerm = (this._search || '').trim();
		const tmpCanCreate = (typeof this.options.OnCreate === 'function')
			&& ((this.options.CreateAlwaysVisible === true)
				|| (tmpTerm.length > 0 && !this._sourceRows().some((pRow) => String(pRow.Text).trim().toLowerCase() === tmpTerm.toLowerCase())));
		tmpState.CreateSlot = tmpCanCreate
			? [ { PickerHash: this.options.PickerHash, Term: tmpTerm, TermAttr: escapeHTML(tmpTerm), Label: escapeHTML(this._resolveCreateLabel(tmpTerm)) } ]
			: [];

		tmpState.PickerHash = this.options.PickerHash;
		tmpState.IsMulti = tmpMulti;
		tmpState.Placeholder = this.options.Placeholder;
		tmpState.Searchable = !!this.options.Searchable;
		tmpState.ReadOnly = !!this.options.ReadOnly;
		tmpState.OptionLabelLines = this._optionLabelLines();

		// Clearable (AllowClear, single mode): the pinned "Any" dropdown row — checked when nothing is
		// selected ("Any" is the active state) — and the control's inline × while a value is selected.
		const tmpAllowClear = (!tmpMulti && this.options.AllowClear === true);
		const tmpClearableValue = tmpMulti ? undefined : this.getValue();
		const tmpClearableHasValue = !this._isEmptyValue(tmpClearableValue);
		tmpState.ClearOptionSlot = tmpAllowClear
			? [ { PickerHash: this.options.PickerHash, Label: this.options.ClearLabel || 'Any', Selected: !tmpClearableHasValue, NotSelected: tmpClearableHasValue } ]
			: [];
		tmpState.ClearSlot = (tmpAllowClear && tmpClearableHasValue) ? [ { PickerHash: this.options.PickerHash } ] : [];
		// Field decoration (opt-in): the ⚙ toggle rides in the search row; the chooser panel renders between
		// search and list. Both are single-element-array slots gated on the feature being enabled + eligible.
		const tmpDecorate = this._decorationEnabled();
		const tmpDecorateFields = (tmpDecorate && this._decorationOpen) ? this._decorationCandidateFields() : [];
		tmpState.DecoratePanelSlot = (tmpDecorate && this._decorationOpen)
			? [ {
				PickerHash: this.options.PickerHash,
				Fields: tmpDecorateFields.map((pField) => ({ PickerHash: this.options.PickerHash, Field: pField, FieldAttr: escapeHTML(pField), Checked: (this._decorationFields.indexOf(pField) >= 0) })),
				NoFields: (tmpDecorateFields.length === 0),
			} ]
			: [];
		// Single-element-array conditionals (render the search box / "Load more" only when applicable).
		tmpState.SearchSlot = this.options.Searchable
			? [ {
				PickerHash: this.options.PickerHash,
				DecorateSlot: tmpDecorate ? [ { PickerHash: this.options.PickerHash, HasFields: (this._decorationFields.length > 0), Open: !!this._decorationOpen } ] : [],
			} ]
			: [];
		tmpState.Loading = !!this._loading;
		tmpState.IsEmpty = (tmpState.Options.length === 0 && !this._loading && !tmpCanCreate);
		tmpState.EmptySlot = tmpState.IsEmpty ? [ { Label: escapeHTML(this._resolveEmptyLabel()) } ] : [];
		tmpState.HasMore = !!(tmpAsync && this._hasMore && !this._loading);
		tmpState.MoreSlot = tmpState.HasMore ? [ { PickerHash: this.options.PickerHash } ] : [];

		// Preview-card affordance (opt-in): a small ⓘ next to the selected value / chips that opens the
		// entity's registered preview card. Active only when the host registered a RecordSetCardManager
		// (soft dependency) that has a card for this picker's Entity, and the picker didn't opt out
		// (RecordCard !== false). Otherwise the picker renders exactly as before.
		const tmpCardManager = this.pict.providers.RecordSetCardManager;
		const tmpCardEntity = this.options.Entity;
		const tmpCardEnabled = !!(tmpCardManager && tmpCardEntity && (this.options.RecordCard !== false) && (typeof tmpCardManager.hasCard === 'function') && tmpCardManager.hasCard(tmpCardEntity));

		// The single/multi value-area is rendered via single-element-array slots; each slot's element
		// IS the Record for its sub-template, so it must carry everything that template references.
		if (tmpMulti)
		{
			// A sentinel inside the array is dropped from the chip list, so a Number-typed multi picker
			// marshalling in as a lone 0 shows the placeholder rather than a "0" chip.
			const tmpValues = this.getValue().filter((pVal) => !this._isEmptyValue(pVal));
			const tmpNoValue = (tmpValues.length === 0);
			const tmpChips = tmpValues.map((pVal) =>
			{
				const tmpRecord = this._lookupRecord(pVal);
				return Object.assign(
					{ PickerHash: this.options.PickerHash, ValueKey: String(pVal), ValueKeyAttr: escapeHTML(String(pVal)), Text: tmpRecord ? tmpRecord.Text : String(pVal), TextAttr: escapeHTML(tmpRecord ? tmpRecord.Text : String(pVal)), CardSlot: tmpCardEnabled ? [ { PickerHash: this.options.PickerHash, Entity: tmpCardEntity, EntityAttr: escapeHTML(tmpCardEntity), Value: String(pVal), ValueAttr: escapeHTML(String(pVal)) } ] : [] },
					this._tagSlots(this._recordTags(tmpRecord), tmpTagLast));
			});
			tmpState.SingleSlot = [];
			tmpState.MultiSlot = [ {
				PickerHash: this.options.PickerHash,
				Chips: tmpChips,
				PlaceholderSlot: tmpNoValue ? [ { Placeholder: this.options.Placeholder } ] : [],
			} ];
		}
		else
		{
			const tmpValue = this.getValue();
			const tmpHasValue = !this._isEmptyValue(tmpValue);
			const tmpSelected = tmpHasValue ? this._lookupRecord(tmpValue) : null;
			// No value → the placeholder, never a stale _selectedText left over from a prior selection.
			const tmpDisplayText = !tmpHasValue ? this.options.Placeholder
				: (tmpSelected ? tmpSelected.Text : (this._selectedText || String(tmpValue)));
			tmpState.SingleSlot = [ Object.assign({
				PickerHash: this.options.PickerHash,
				DisplayText: tmpDisplayText,
				DisplayTextAttr: escapeHTML(tmpDisplayText),
				ValueTitleAttr: tmpHasValue ? escapeHTML(tmpDisplayText) : '',
				NoValue: !tmpHasValue,
				CardSlot: (tmpCardEnabled && tmpHasValue) ? [ { PickerHash: this.options.PickerHash, Entity: tmpCardEntity, EntityAttr: escapeHTML(tmpCardEntity), Value: String(tmpValue), ValueAttr: escapeHTML(String(tmpValue)) } ] : [],
			}, this._tagSlots(this._recordTags(tmpSelected), tmpTagLast)) ];
			tmpState.MultiSlot = [];
		}
		return tmpState;
	}

	/**
	 * Find the {Value,Text} record for a value: the stored selection record (authoritative for chips /
	 * async), else a row in the current source (static Options or loaded results).
	 * @param {any} pValue
	 * @return {{Value:any, Text:string, Tag?:any}|null}
	 */
	_lookupRecord(pValue)
	{
		if (pValue === undefined || pValue === null || pValue === '') { return null; }
		const tmpStored = this._selectedRecords[String(pValue)];
		if (tmpStored) { return tmpStored; }
		return this._sourceRows().find((pOption) => String(pOption.Value) === String(pValue)) || null;
	}

	/**
	 * Load a page of results from the async DataProvider, accumulating (append) or replacing the list.
	 * @param {number} pPage - zero-based page index.
	 * @param {boolean} pAppend - true to append (Load more), false to replace (new search / first open).
	 */
	_loadPage(pPage, pAppend)
	{
		if (!this._isAsync()) { return; }
		// Minimum-search-length gate: below the threshold, don't hit the server. First page only
		// (browse-on-open + new search); "Load more" always already has an at-length term.
		const tmpMinLength = this.options.MinimumSearchLength || 0;
		if (tmpMinLength > 0 && !pAppend && pPage === 0 && (this._search || '').trim().length < tmpMinLength)
		{
			this._loadedResults = [];
			this._hasMore = false;
			this._page = 0;
			this._loaded = true;
			this._loading = false;
			this._renderList();
			return;
		}
		this._loading = true;
		this._renderList();
		const tmpSearchAtRequest = this._search;
		Promise.resolve()
			.then(() => this.options.DataProvider(this._search, pPage))
			.then((pResult) =>
			{
				// Drop a stale first-page response if the search term changed while it was in flight.
				if (!pAppend && pPage === 0 && tmpSearchAtRequest !== this._search) { return; }
				const tmpResults = (pResult && Array.isArray(pResult.results)) ? pResult.results : [];
				this._loadedResults = pAppend ? this._loadedResults.concat(tmpResults) : tmpResults;
				this._hasMore = !!(pResult && pResult.hasMore);
				this._page = pPage;
				this._loaded = true;
				this._loading = false;
				this._renderList();
			})
			.catch((pError) =>
			{
				this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] DataProvider error.`, pError);
				this._loading = false;
				this._renderList();
			});
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		// A closed picker's full render paints an empty search box, and the view outlives a mount (the same
		// PickerHash hands this instance back), so a term kept from before would filter unseen.
		if (!this._open)
		{
			this._search = '';
		}
		this._buildState();
		return super.onBeforeRender(pRenderable);
	}

	/** Toggle the dropdown open/closed. */
	toggle(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		return this._open ? this.close() : this.open();
	}

	/** Keyboard on the control: open the dropdown on Enter / Space / ArrowDown. */
	onControlKey(pEvent)
	{
		if (pEvent.key === 'Enter' || pEvent.key === ' ' || pEvent.key === 'ArrowDown')
		{
			pEvent.preventDefault();
			if (!this._open) { this.open(); }
		}
		else if (pEvent.key === 'Escape')
		{
			this.close();
		}
	}

	/** Open the dropdown and focus the search box. With the opt-in SingleActivePicker option, closes
	 *  any open sibling picker first — one active dropdown per page. */
	open()
	{
		this._claimActivePicker();
		this._open = true;
		this._highlight = -1;
		this._paintOpen();
		this._applyAnchorMode();
		if (this._isAsync() && !this._loaded) { this._loadPage(0, false); }
		const tmpSearch = /** @type {HTMLInputElement} */ (document.getElementById(`PPS_Search_${this.options.PickerHash}`));
		if (tmpSearch) { tmpSearch.focus(); tmpSearch.select(); }
	}

	/** Take the provider's single-active slot, closing whichever sibling holds it. Opt-in only (an off
	 *  picker neither claims nor is closed). The slot holds a hash on the provider, so two pict instances
	 *  sharing this module can't cross-close. */
	_claimActivePicker()
	{
		const tmpProvider = this.options.PickerProvider;
		if (!this.options.SingleActivePicker || !tmpProvider) { return; }
		const tmpOpenHash = tmpProvider.currentOpenPickerHash;
		if (tmpOpenHash && tmpOpenHash !== this.options.PickerHash)
		{
			const tmpOpenView = this.pict.views[tmpOpenHash];
			if (tmpOpenView && typeof tmpOpenView.close === 'function') { tmpOpenView.close(); }
		}
		tmpProvider.currentOpenPickerHash = this.options.PickerHash;
	}

	/*
	 * Dropdown anchoring & render states
	 * ----------------------------------
	 * Anchoring (picked per open by _applyAnchorMode -> _shouldPortal):
	 *   CSS      : .pps-pop is absolute inside the widget and rides page scroll for free. Default.
	 *   Portaled : moved to <body> in document coords when a clipping ancestor (overflow != visible)
	 *              would actually cut it. Still absolute, so it rides scroll too; carries the control's
	 *              --theme-color-* across since it left any scoped container.
	 * Open  : _open -> pps-open on the root, pps-pop-open on the pop (a portaled pop is outside the
	 *         root's .pps-open rule, so it needs its own class to show).
	 * Render: full render() rebuilds the widget; setValue uses the targeted _reflectValue (value area +
	 *         list only) unless _shapeSignature() shows something outside them changed.
	 * _popElement finds the pop in either place; _markClosed is the single close funnel.
	 */

	/** The pop wherever it lives (in-widget or portaled). By position not id: a re-render can briefly
	 *  leave two sharing the id, and the in-widget copy is the live one. @return {HTMLElement|null} */
	_popElement()
	{
		if (typeof document === 'undefined') { return null; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpInWidget = tmpRoot ? /** @type {HTMLElement} */ (tmpRoot.querySelector('.pps-pop')) : null;
		if (tmpInWidget) { return tmpInWidget; }
		return /** @type {HTMLElement} */ (document.querySelector(`body > [id="PPS_Pop_${this.options.PickerHash}"]`));
	}

	/** Pick this open's anchoring (see states above): portal when _shouldPortal finds a clipping ancestor
	 *  that would cut the panel, else CSS. Judged from the control, which never moves — a portaled panel
	 *  has no clipping ancestors, so testing it would flip-flop. */
	_applyAnchorMode()
	{
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpPop = this._popElement();
		if (!tmpPop) { return; }
		const tmpControl = tmpRoot ? /** @type {HTMLElement} */ (tmpRoot.querySelector('.pps-control')) : null;
		this._portaled = !!tmpControl && this._shouldPortal(tmpControl);
		if (this._portaled) { this._portalPop(tmpPop); }
		else { this._restorePop(tmpPop); }
		// A portaled pop is hidden until pps-pop-open is set (it's outside the root's .pps-open rule).
		tmpPop.classList.toggle('pps-pop-open', !!this._open);
	}

	/** Move the panel to <body> and place it against the control in document coords (viewport rect +
	 *  scroll), flipping above when room below is short. Width is pinned since it no longer inherits the
	 *  widget's. @param {HTMLElement} pPop */
	_portalPop(pPop)
	{
		if (typeof document === 'undefined') { return; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		const tmpControl = tmpRoot ? tmpRoot.querySelector('.pps-control') : null;
		if (!tmpControl) { return; }
		// Sweep any stale portaled copy a prior re-render left on <body> (same id) before adopting this one.
		document.querySelectorAll(`body > [id="PPS_Pop_${this.options.PickerHash}"]`)
			.forEach((pNode) => { if (pNode !== pPop) { pNode.remove(); } });
		if (pPop.parentElement !== document.body) { document.body.appendChild(pPop); }
		pPop.classList.add('pps-pop-portal');

		// Carry the resolved --theme-color-* across: on <body> the panel has left any scoped container, so
		// without this it would fall back to the hex defaults. Skip empty reads — pinning "" would defeat
		// the var(--token, #hex) fallback for tokens the host never defined.
		if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function')
		{
			const tmpComputed = window.getComputedStyle(tmpControl);
			_THEME_TOKENS.forEach((pToken) =>
			{
				const tmpValue = tmpComputed.getPropertyValue(pToken);
				if (tmpValue && tmpValue.trim() !== '') { pPop.style.setProperty(pToken, tmpValue.trim()); }
			});
		}

		const tmpRect = tmpControl.getBoundingClientRect();
		const tmpGap = 5;
		const tmpMargin = 8;
		const tmpIdeal = 360;
		const tmpWidth = Math.max(200, Math.round(tmpRect.width));
		const tmpSpaceBelow = window.innerHeight - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		const tmpBelow = (tmpSpaceBelow >= tmpIdeal) || (tmpSpaceBelow >= tmpSpaceAbove);
		const tmpPanel = /** @type {HTMLElement} */ (pPop.querySelector('.pps-panel'));

		pPop.style.width = `${tmpWidth}px`;
		pPop.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.left, window.innerWidth - tmpWidth - tmpMargin)) + window.scrollX)}px`;
		pPop.style.bottom = 'auto';
		// Document coords (viewport rect + scroll): absolute against <body>, so one placement is enough.
		pPop.style.top = tmpBelow
			? `${Math.round(tmpRect.bottom + tmpGap + window.scrollY)}px`
			: `${Math.round(tmpRect.top - tmpGap + window.scrollY)}px`;
		if (!tmpBelow) { pPop.style.transform = 'translateY(-100%)'; }
		else { pPop.style.transform = ''; }
		if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(0, Math.round(Math.min(tmpBelow ? tmpSpaceBelow : tmpSpaceAbove, tmpIdeal)))}px`; }
	}

	/** Re-home a portaled panel and drop everything the portal wrote. Doubles as the orphan sweeper: if a
	 *  re-render already put a fresh panel in the widget, the portaled one is stale and gets discarded.
	 *  @param {HTMLElement} pPop */
	_restorePop(pPop)
	{
		if (typeof document === 'undefined' || !pPop) { return; }
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		if (pPop.parentElement === document.body)
		{
			if (!tmpRoot) { pPop.remove(); return; }
			// A re-render already put a fresh panel in the widget — this portaled one is a leftover.
			if (tmpRoot.querySelector('.pps-pop') && tmpRoot.querySelector('.pps-pop') !== pPop) { pPop.remove(); return; }
			tmpRoot.appendChild(pPop);
		}
		pPop.classList.remove('pps-pop-portal');
		// Clear the inline offsets, or they'd override the stylesheet and strand the panel.
		pPop.style.top = '';
		pPop.style.left = '';
		pPop.style.right = '';
		pPop.style.bottom = '';
		pPop.style.width = '';
		pPop.style.transform = '';
		// Drop the copied tokens so back in the widget it inherits them live again.
		_THEME_TOKENS.forEach((pToken) => pPop.style.removeProperty(pToken));
		const tmpPanel = /** @type {HTMLElement} */ (pPop.querySelector('.pps-panel'));
		if (tmpPanel) { tmpPanel.style.maxHeight = ''; }
	}

	/** Portal when ANY clipping ancestor would actually cut the panel (_clipBites) — an overflow ancestor
	 *  alone isn't enough, but a roomy inner clipper doesn't excuse a tighter one further out.
	 *  @param {HTMLElement} pControl @return {boolean} */
	_shouldPortal(pControl)
	{
		// Walk every clipper outward, not just the nearest: _clippingAncestor starts from parentElement,
		// so re-feeding it the clipper it returned continues the walk.
		let tmpClipper = this._clippingAncestor(pControl);
		while (tmpClipper)
		{
			if (this._clipBites(pControl, tmpClipper)) { return true; }
			tmpClipper = this._clippingAncestor(tmpClipper);
		}
		return false;
	}

	/** Nearest ancestor (up to, not including, body) with an overflow clip on any axis, or null. Stops at
	 *  body because the document's own scroll is what the absolute anchoring rides on, not a clip.
	 *  @param {HTMLElement} pElement @return {HTMLElement|null} */
	_clippingAncestor(pElement)
	{
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') { return null; }
		let tmpNode = pElement ? pElement.parentElement : null;
		while (tmpNode && tmpNode.nodeType === 1 && tmpNode !== document.body)
		{
			const tmpStyle = window.getComputedStyle(tmpNode);
			if (tmpStyle && [ tmpStyle.overflow, tmpStyle.overflowX, tmpStyle.overflowY ].some((pValue) => pValue && pValue !== 'visible'))
			{
				return /** @type {HTMLElement} */ (tmpNode);
			}
			tmpNode = tmpNode.parentElement;
		}
		return null;
	}

	/** True when the control has any overflow-clipping ancestor. Thin boolean over _clippingAncestor;
	 *  the anchor decision uses _shouldPortal, which also weighs whether the clip reaches the panel.
	 *  @param {HTMLElement} pElement @return {boolean} */
	_hasClippingAncestor(pElement) { return !!this._clippingAncestor(pElement); }

	/** Would the clipper cut the panel if it opened in place? The CSS path always opens downward and never
	 *  flips, so project that worst-case box (control bottom + gap, up to max height) and test whether any
	 *  edge falls outside the clipper. 1px slack avoids a needless portal on a flush edge.
	 *  @param {HTMLElement} pControl @param {HTMLElement} pClipper @return {boolean} */
	_clipBites(pControl, pClipper)
	{
		if (!pControl || !pClipper || typeof pControl.getBoundingClientRect !== 'function'
			|| typeof pClipper.getBoundingClientRect !== 'function') { return true; }
		const tmpControlRect = pControl.getBoundingClientRect();
		const tmpClipRect = pClipper.getBoundingClientRect();
		const tmpGap = 5;
		const tmpIdeal = 360;
		const tmpSlack = 1;
		const tmpPanelTop = tmpControlRect.bottom + tmpGap;
		const tmpPanelBottom = tmpPanelTop + tmpIdeal;
		const tmpWidth = Math.max(200, tmpControlRect.width);
		const tmpPanelLeft = tmpControlRect.left;
		const tmpPanelRight = tmpControlRect.left + tmpWidth;
		return (tmpPanelBottom > tmpClipRect.bottom + tmpSlack)
			|| (tmpPanelTop < tmpClipRect.top - tmpSlack)
			|| (tmpPanelLeft < tmpClipRect.left - tmpSlack)
			|| (tmpPanelRight > tmpClipRect.right + tmpSlack);
	}

	/** The single close funnel (close, single-mode select, clearValue, createFromSearch): clears open
	 *  state, the provider's active-picker slot, and the results cache so nothing leaks a stale reference. */
	_markClosed()
	{
		this._open = false;
		this._highlight = -1;
		this._decorationOpen = false;
		const tmpProvider = this.options.PickerProvider;
		if (tmpProvider && tmpProvider.currentOpenPickerHash === this.options.PickerHash) { tmpProvider.currentOpenPickerHash = false; }
		// Bring a portaled panel home, so a closed picker never leaves a stray on <body>.
		if (this._portaled) { this._restorePop(this._popElement()); this._portaled = false; }
		// Drop the accumulated pages so the next open re-queries — BaseFilter is resolved per query
		// because the host's scope shifts underneath the picker (a "Show All" toggle, a dependent pick),
		// so caching across a close would serve the old scope. Matches the legacy select2 re-query.
		this._loaded = false;
		this._loadedResults = [];
		this._page = 0;
		this._hasMore = false;
		// Back-off state spans only page 0 -> "load more" in one session, so release it here too.
		if (tmpProvider && tmpProvider.backOffState) { delete tmpProvider.backOffState[this.options.PickerHash]; }
	}


	/** Async mode: load + append the next page of results. */
	loadMore()
	{
		if (this._isAsync() && this._hasMore && !this._loading)
		{
			this._loadPage(this._page + 1, true);
		}
	}

	/** Close the dropdown. */
	close()
	{
		this._markClosed();
		this._paintOpen();
	}

	/**
	 * Close from the transparent backdrop, and pass the click through to whatever
	 * the user actually aimed at.
	 *
	 * The backdrop is a full-viewport layer, so while a picker is open EVERY click
	 * elsewhere on the page lands on it and is consumed closing the dropdown. The
	 * button underneath never sees it, and the interaction reads as "the first
	 * click did nothing" — measured on a filter bar, the Apply handler recorded
	 * zero calls on the first click and one on the second. A dropdown dismissing
	 * itself should not also cost the click that dismissed it.
	 *
	 * The backdrop is display:none the moment the widget is painted closed, so
	 * elementFromPoint then returns the real target rather than the backdrop.
	 *
	 * @param {MouseEvent} pEvent - The backdrop click.
	 */
	closeFromBackdrop(pEvent)
	{
		this.close();
		if (!pEvent || (typeof document === 'undefined') || (typeof document.elementFromPoint !== 'function'))
		{
			return;
		}
		const tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		// Nothing meaningful under the cursor (or the backdrop somehow survived) —
		// closing was the whole intent.
		if (!tmpTarget || tmpTarget === document.body || tmpTarget === document.documentElement
			|| (tmpTarget.classList && tmpTarget.classList.contains('pps-backdrop')))
		{
			return;
		}
		if (typeof tmpTarget.click === 'function') { tmpTarget.click(); }
	}

	/** Opt-in teardown for a host that drops the view (pict-view has no destroy hook). _markClosed already
	 *  releases the single-active slot, re-homes/removes a portaled panel, and clears the back-off entry;
	 *  the un-destroyed case is harmless since a stray portaled pop stays hidden without pps-pop-open. */
	destroy()
	{
		this._markClosed();
		this._paintOpen();
		// Belt-and-suspenders: if the widget root was detached mid-teardown, take any stray pop with us.
		if (typeof document !== 'undefined')
		{
			const tmpStray = document.querySelector(`body > [id="PPS_Pop_${this.options.PickerHash}"]`);
			if (tmpStray) { tmpStray.remove(); }
		}
	}

	/** Reflect open/closed on the root (pps-open) and on the pop (pps-pop-open) — a portaled pop is outside
	 *  the root's rule, so it needs the class directly, which also keeps a stray one hidden. */
	_paintOpen()
	{
		const tmpRoot = document.getElementById(`PPS_${this.options.PickerHash}`);
		if (tmpRoot) { tmpRoot.classList.toggle('pps-open', !!this._open); }
		const tmpPop = this._popElement();
		if (tmpPop) { tmpPop.classList.toggle('pps-pop-open', !!this._open); }
	}

	/** Re-render only the option list (keeps the search input + its focus intact). */
	_renderList()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-List', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_List_${this.options.PickerHash}`, tmpHTML);
	}

	/** Re-render only the control's value area (the value span or the chips) — used in multi mode so
	 *  toggling a selection updates the chips without tearing down the open dropdown + search box. */
	_renderValue()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Picker-ValueArea', this._state());
		this.pict.ContentAssignment.assignContent(`#PPS_Value_${this.options.PickerHash}`, tmpHTML);
	}

	/** @param {string} pValue - Filter the option list by this search term. */
	search(pValue)
	{
		this._search = pValue || '';
		this._highlight = -1;
		if (this._isAsync())
		{
			// Debounce server searches; reset to page 0.
			if (this._searchTimer) { clearTimeout(this._searchTimer); }
			this._searchTimer = setTimeout(() => { this._loadPage(0, false); }, 220);
		}
		else
		{
			this._renderList();
		}
	}

	/** Keyboard navigation within the search box: arrows highlight, Enter selects, Escape closes. */
	onSearchKey(pEvent)
	{
		const tmpOptions = this._state().Options || [];
		if (pEvent.key === 'ArrowDown')
		{
			pEvent.preventDefault();
			this._highlight = Math.min(this._highlight + 1, tmpOptions.length - 1);
			this._renderList();
		}
		else if (pEvent.key === 'ArrowUp')
		{
			pEvent.preventDefault();
			this._highlight = Math.max(this._highlight - 1, 0);
			this._renderList();
		}
		else if (pEvent.key === 'Enter')
		{
			pEvent.preventDefault();
			if (this._highlight >= 0 && tmpOptions[this._highlight])
			{
				this.select(tmpOptions[this._highlight].ValueKey);
			}
			else if ((this._state().CreateSlot || []).length > 0 && (this._search || '').trim().length > 0)
			{
				this.createFromSearch();
			}
		}
		else if (pEvent.key === 'Escape')
		{
			pEvent.preventDefault();
			this.close();
		}
	}

	/**
	 * Read a `data-` attribute off a clicked element. The option / chip / card / decorate handlers carry
	 * the value they operate on in a data attribute instead of inlining it into the onclick string, so a
	 * value containing a quote (e.g. `1"`) can never break the attribute or the handler; the browser has
	 * already decoded the attribute back to the raw value by the time we read it here.
	 * @param {any} pElement - the clicked DOM element (`this` inside the inline handler).
	 * @param {string} pAttribute - the data attribute to read.
	 * @return {string|null}
	 */
	_readElementData(pElement, pAttribute)
	{
		return (pElement && typeof pElement.getAttribute === 'function') ? pElement.getAttribute(pAttribute) : null;
	}

	/** Option-row click shim: select the value carried in `data-pps-valuekey`. @param {any} pElement */
	selectFromElement(pElement)
	{
		const tmpValueKey = this._readElementData(pElement, 'data-pps-valuekey');
		if (tmpValueKey !== null) { this.select(tmpValueKey); }
	}

	/** Chip-× click shim: remove the value carried in `data-pps-valuekey`. @param {any} pElement */
	removeChipFromElement(pElement)
	{
		const tmpValueKey = this._readElementData(pElement, 'data-pps-valuekey');
		if (tmpValueKey !== null) { this.removeChip(tmpValueKey); }
	}

	/** Preview-card ⓘ click shim: open the card for the entity/value carried in data attributes. @param {any} pElement */
	openCardFromElement(pElement)
	{
		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpManager || typeof tmpManager.openCard !== 'function') { return; }
		tmpManager.openCard(this._readElementData(pElement, 'data-pps-entity'), this._readElementData(pElement, 'data-pps-value'), pElement);
	}

	/** Field-decoration checkbox click shim: toggle the field carried in `data-pps-field`. @param {any} pElement */
	toggleDecorateFieldFromElement(pElement)
	{
		const tmpField = this._readElementData(pElement, 'data-pps-field');
		if (tmpField !== null) { this.toggleDecorateField(tmpField); }
	}

	/**
	 * Select an option. Single mode: set the value + close. Multi mode: toggle the value in/out of the
	 * selection, keep the dropdown open, and refocus the search box for rapid multi-pick.
	 * @param {string} pValueKey - String(Value) of the option.
	 */
	select(pValueKey)
	{
		const tmpOption = this._sourceRows().find((pOption) => String(pOption.Value) === String(pValueKey));
		if (!tmpOption) { return; }

		if (!this._isMulti())
		{
			this._selectedText = tmpOption.Text;
			this._selectedRecords[String(tmpOption.Value)] = { Value: tmpOption.Value, Text: tmpOption.Text, Tag: tmpOption.Tag, Tags: tmpOption.Tags };
			this._setValue(tmpOption.Value);
			this._search = '';
			this._markClosed();
			this.render();
			if (typeof this.options.OnChange === 'function')
			{
				this.options.OnChange(tmpOption.Value, tmpOption);
			}
			return;
		}

		// Multi: toggle membership.
		const tmpValues = this.getValue().slice();
		const tmpIndex = tmpValues.findIndex((pVal) => String(pVal) === String(pValueKey));
		if (tmpIndex >= 0)
		{
			tmpValues.splice(tmpIndex, 1);
			delete this._selectedRecords[String(pValueKey)];
		}
		else
		{
			tmpValues.push(tmpOption.Value);
			this._selectedRecords[String(pValueKey)] = { Value: tmpOption.Value, Text: tmpOption.Text, Tag: tmpOption.Tag, Tags: tmpOption.Tags };
		}
		this._setValue(tmpValues);
		this._renderValue();
		this._renderList();
		if (typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(tmpValues, this.getSelectedRecords());
		}
		// Focus AFTER OnChange: a host that re-marshals inside its handler re-renders the widget and would
		// blow away a focus set before it. onAfterRender also restores focus while open, covering the
		// re-render that does happen; this covers the common case where it does not.
		const tmpSearch = document.getElementById(`PPS_Search_${this.options.PickerHash}`);
		if (tmpSearch) { tmpSearch.focus(); }
	}

	/**
	 * Clearable (AllowClear, single mode): empty the selection — from the control's inline × or the
	 * pinned "Any" dropdown row. Closing mirrors select() (clearing IS a selection: "Any"), and
	 * OnChange(null, null) fires only when there was a value to clear, so clicking "Any" while
	 * already empty just closes the dropdown.
	 */
	clearValue()
	{
		if (this._isMulti()) { return; }
		const tmpValue = this.getValue();
		const tmpHadValue = !this._isEmptyValue(tmpValue);
		this._selectedText = null;
		this._setValue(null);
		this._search = '';
		this._markClosed();
		this.render();
		if (tmpHadValue && typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(null, null);
		}
	}

	/** @return {Array<{Value:any, Text:string}>} The full record list for the current multi selection. */
	getSelectedRecords()
	{
		return this.getValue().map((pVal) => this._selectedRecords[String(pVal)] || { Value: pVal, Text: String(pVal) });
	}

	/**
	 * Creatable: build a new option from the current search term via OnCreate, then select it (single:
	 * set + close; multi: add a chip). The created record is inserted into the source list so it shows
	 * as a normal, checked option.
	 */
	createFromSearch()
	{
		const tmpTerm = (this._search || '').trim();
		if ((!tmpTerm && this.options.CreateAlwaysVisible !== true) || typeof this.options.OnCreate !== 'function') { return; }
		Promise.resolve(this.options.OnCreate(tmpTerm)).then((pRecord) =>
		{
			if (!pRecord || pRecord.Value === undefined || pRecord.Value === null) { return; }
			// Make the new record part of the source so the list can render it like any other option.
			if (this._isAsync())
			{
				if (!this._loadedResults.some((pRow) => String(pRow.Value) === String(pRecord.Value))) { this._loadedResults.unshift(pRecord); }
			}
			else if (Array.isArray(this.options.Options) && !this.options.Options.some((pRow) => String(pRow.Value) === String(pRecord.Value)))
			{
				this.options.Options.unshift(pRecord);
			}
			this._selectedRecords[String(pRecord.Value)] = { Value: pRecord.Value, Text: pRecord.Text, Tag: pRecord.Tag };

			if (this._isMulti())
			{
				const tmpValues = this.getValue().slice();
				if (!tmpValues.some((pVal) => String(pVal) === String(pRecord.Value))) { tmpValues.push(pRecord.Value); }
				this._setValue(tmpValues);
				this._search = '';
				this._highlight = -1;
				this._renderValue();
				this._renderList();
				const tmpSearchBox = /** @type {HTMLInputElement} */ (document.getElementById(`PPS_Search_${this.options.PickerHash}`));
				if (tmpSearchBox) { tmpSearchBox.value = ''; tmpSearchBox.focus(); }
				if (typeof this.options.OnChange === 'function') { this.options.OnChange(tmpValues, this.getSelectedRecords()); }
			}
			else
			{
				this._selectedText = pRecord.Text;
				this._setValue(pRecord.Value);
				this._search = '';
				this._markClosed();
				this.render();
				if (typeof this.options.OnChange === 'function') { this.options.OnChange(pRecord.Value, pRecord); }
			}
		}).catch((pError) =>
		{
			this.pict.log.warn(`Pict-Section-Picker [${this.options.PickerHash}] OnCreate error.`, pError);
		});
	}

	/** Multi mode: remove a selected value (chip ×). Keeps the dropdown state as-is. */
	removeChip(pValueKey)
	{
		const tmpValues = this.getValue().filter((pVal) => String(pVal) !== String(pValueKey));
		delete this._selectedRecords[String(pValueKey)];
		this._setValue(tmpValues);
		this._renderValue();
		if (this._open) { this._renderList(); }
		if (typeof this.options.OnChange === 'function')
		{
			this.options.OnChange(tmpValues, this.getSelectedRecords());
		}
	}

	/** @param {import('pict-view').Renderable} pRenderable */
	onAfterRender(pRenderable)
	{
		if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		// Stamp the painted shape so a later setValue knows if a targeted refresh still fits (_reflectValue).
		this._renderedShape = this._shapeSignature();
		this._paintOpen();
		// A render while open rebuilds a fresh in-widget pop and orphans any portaled one; re-anchoring
		// sweeps the orphan and re-portals, then we restore the search focus the render dropped.
		if (this._open)
		{
			this._applyAnchorMode();
			const tmpSearch = document.getElementById(`PPS_Search_${this.options.PickerHash}`);
			if (tmpSearch && document.activeElement !== tmpSearch) { tmpSearch.focus(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PictViewPicker;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":733}],715:[function(require,module,exports){
module.exports={
	"RenderOnLoad": true,

	"GridWidth": "auto",
	"GridRowHeight": 40,

	"GridBodyHeight": "auto",
	"GridBodyMinHeight": 130,

	"GridColumnMinWidth": 50,
	"GridColumnWidthResizable": true,
	"GridColumnHeightResizable": false,

	"GridColumnFrozenCount": 0,
	"GridColumnFrozenBorderWidth": 3,

	"GridScrollX": true,
	"GridScrollY": true,

	"GridShowDummyRows": false,
	"GridDraggableRows": false,

	"GridSelectionUnit": "cell",

	"DefaultRenderable": "TuiGrid-Wrap",
	"DefaultDestinationAddress": "#TuiGrid-Container-Div",

	"Templates": [
		{
			"Hash": "TuiGrid-Container",
			"Template": "<!-- TuiGrid-Container Rendering Soon -->"
		}
	],

	"Renderables": [
		{
			"RenderableHash": "TuiGrid-Wrap",
			"TemplateHash": "TuiGrid-Container",
			"DestinationAddress": "#TuiGrid-Container-Div"
		}
	],

	"TargetElementAddress": "#TuiGrid-Container-Div",

	"GridDataAddress": false,

	"GridData": [
		{
			"idrecord": 1,
			"entity": "SampleEntity",
			"name": "Record name 1",
			"description": "description 1"
		},
		{
			"idrecord": 2,
			"entity": "SampleEntity",
			"name": "Record name 2",
			"description": "description 2"
		},
		{
			"idrecord": 3,
			"entity": "SampleEntity",
			"name": "Record name 3",
			"description": "description 3"
		},
		{
			"idrecord": 4,
			"entity": "SampleEntity",
			"name": "Record name 4",
			"description": "description 4"
		},
		{
			"idrecord": 5,
			"entity": "SampleEntity",
			"name": "Record name 5",
			"description": "description 5"
		},
		{
			"idrecord": 6,
			"entity": "SampleEntity",
			"name": "Record name 6",
			"description": "description 6"
		},
		{
			"idrecord": 7,
			"entity": "SampleEntity",
			"name": "Record name 7",
			"description": "description 7"
		},
		{
			"idrecord": 8,
			"entity": "SampleEntity",
			"name": "Record name 8",
			"description": "description 8"
		},
		{
			"idrecord": 9,
			"entity": "SampleEntity",
			"name": "Record name 9",
			"description": "description 9"
		}
	],
	"ColumnsToSolveOnChange": {},
	"TuiColumnSchema": [
		{
			"header": "IDRecord",
			"name": "idrecord",
			"PictTriggerSolveOnChange": true
		},
		{
			"header": "Entity",
			"name": "entity",
			"PictTriggerSolveOnChange": true
		},
		{
			"header": "Name",
			"name": "name",
			"editor": "text"
		},
		{
			"header": "Description",
			"name": "description",
			"editor": "text"
		}
	]
}

},{}],716:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/**
 * @typedef {typeof import('tui-grid').default} TuiGridClass
 * @typedef {import('tui-grid').default} TuiGrid
 */

class PictSectionTuiGrid extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, require('./Pict-Section-TuiGrid-DefaultConfiguration.json'), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {{ [key: string]: any }} */
		this.services;
		this.dateFormatter = this.fable.instantiateServiceProviderWithoutRegistration('Dates');

		this.initialRenderComplete = false;

		this.customFormatters = {};
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		/** @type {TuiGridClass} */
		this._tuiGridPrototype = null;

		/** @type {TuiGrid} */
		this.tuiGrid = null;

		this.customHeaders = require('./Pict-TuiGrid-Headers.js');
		this.customEditors = require('./Pict-TuiGrid-Editors.js');
		this.initializeCustomFormatters();

		this.columnSchema = false;
		this.targetElementAddress = false;
		/** @type {Array<any>} */
		this.gridData = null;

		return super.onBeforeInitialize();
	}

	initializeCustomFormatters()
	{
		this.customFormatters.FormatterTwoDigitNumber = (pCell) =>
			{
				let tmpCellValue = Number.parseFloat(pCell.value);
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				if (isNaN(tmpCellValue))
				{
					return '';
				}
				else
				{
					return this.fable.Math.roundPrecise(pCell.value, tmpPrecision);
				}
			};
		this.customFormatters.FormatterCurrencyNumber = (pCell) =>
			{
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				let tmpCellValue = this.fable.DataFormat.formatterDollars(pCell.value, tmpPrecision);
				return tmpCellValue;
			};

		this.customFormatters.FormatterRoundedNumber = (pCell) =>
			{
				let tmpCellValue = Number.parseFloat(pCell.value);
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				if (isNaN(tmpCellValue))
				{
					return '';
				}
				else
				{
					return this.fable.Math.roundPrecise(pCell.value, tmpPrecision);
				}
			};

		this.customFormatters.FormatterDate = (pCell) =>
			{
				let tmpDate = this.fable.Dates.dayJS.utc(pCell.value);
				if (pCell.dateformat)
				{
					return tmpDate.format(pCell.dateformat);
				}
				else
				{
					return tmpDate.format();
				}
			};
	}

	/**
	 * Construct a tuiGrid instance and connect it to the browser's dom object for the grid.  If the
	 * prototype is not passed in, try to find a window.tui (where the library puts itself) in the window
	 * object.
	 *
	 * @param {TuiGridClass} [pTuiGridPrototype] - The TuiGrid prototype class expected to be loaded in the browser
	 * @returns
	 */
	connectTuiGridPrototype(pTuiGridPrototype)
	{
		if (typeof (pTuiGridPrototype) != 'undefined')
		{
			this._tuiGridPrototype = pTuiGridPrototype;
		}
		else
		{
			this.log.trace(`PICT-TuiGrid No TuiGrid Prototype defined or explicitly set; looking for it in the window object.`);
			if (typeof (window) != 'undefined')
			{
				if ((typeof (window.tui) != 'undefined') && (typeof (window.tui.Grid) != 'undefined'))
				{
					this.log.trace(`PICT-TuiGrid Found TuiGrid Prototype in window.tuiGrid.`);
					this.connectTuiGridPrototype(window.tui.Grid);
				}
				else
				{
					this.log.error(`PICT-TuiGrid No TuiGrid Prototype found in window.tuiGrid.`);
					return false;
				}
			}
			else
			{
				this.log.error(`PICT-TuiGrid No TuiGrid Prototype found in window.tuiGrid -- window object unavailable.`);
				return false;
			}
		}
	}

	/**
	 * @typedef {Object} TUIGridCellChange
	 * @property {any} rowKey - The key of the row that changed.
	 * @property {string} columnName - The name of the column that changed.
	 * @property {any} value - The "current" value of the cell. Slightly different meaning in preChangeHandler vs changeHandler (before / after the change is applied).
	 * @property {any} [nextValue] - The value that the cell will have after the change. Only populated in preChangeHandler (not changeHandler).
	 * @property {any} [prevValue] - The value that the cell had before the change. Only populated in changeHandler (not preChangeHandler).
	 */

	/**
	 * @typedef {Object} TUIGridChangeEvent
	 * @property {TuiGrid} instance - The TuiGrid instance that fired the event.
	 * @property {TUIGridCellChange[]} changes - An array of objects representing the changes to grid cell values.
	 */

	/**
	 * Interface method for handling changesets from the TuiGrid control. Invoked before the change has been applied to the affected cells.
	 *
	 * * The pre-change cell value is stored in value while the new cell value is stored in nextValue.
	 * * Any changes made to nextValue in this method will be reflected in the grid for that cell.
	 *
	 * @param {TUIGridChangeEvent} pChangeData - An event containing an array of objects representing the changes to grid cell values.
	 */
	preChangeHandler(pChangeData)
	{
	}

	/**
	 * Interface method for handling changesets from the TuiGrid control. Invoked after the change has been applied to the affected cells.
	 *
	 * * Performs solver trigger for changes to any columns configured in "ColumnsToSolveOnChange" or with "PictTriggerSolveOnChange": true on a specific row.
	 * * The previous cell value is stored in prevValue while the next cell value is stored in value.
	 *
	 * @param {TUIGridChangeEvent} pChangeData - An event object containing an array of objects representing the changes to grid cell values.
	 */
	changeHandler(pChangeData)
	{
		let tmpSolverNecessary = false;

		for (let i = 0; i < pChangeData.changes.length; i++)
		{
			let tmpEntity = pChangeData.instance.getValue(pChangeData.changes[i].rowKey, 'entity');
			let tmpIDRecord = pChangeData.instance.getValue(pChangeData.changes[i].rowKey, 'idrecord');

			this.log.trace(`Generic Change Handler for TuiGrid Fired, Entity ${tmpEntity} IDRecord ${tmpIDRecord} setting Column [${pChangeData.changes[i].value}] to new Value [${pChangeData.changes[i].value}]`);

			if (this.options.ColumnsToSolveOnChange.hasOwnProperty(pChangeData.changes[i].columnName))
			{
				tmpSolverNecessary = true;
			}
		}

		if (tmpSolverNecessary)
		{
			this.services.PictApplication.solve();
		}
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// This is where we wire up and initialize the tuigrid control -- the initial render has put the placeholder content in place.
		// Check for a tuigrid prototype, and find it in the window object it if it doesn't exist
		if (!this._tuiGridPrototype)
		{
			this.connectTuiGridPrototype();
		}
		// This is where we wire up and initialize the tuigrid control
		if (this.tuiGrid)
		{
			// The grid is already initialized.
			this.log.error(`TuiGrid going to ${this.options.TargetElementAddress} is already initialized!`);
			return false;
		}

		if (this.options.GridDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options,
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.GridDataAddress);
			if (typeof (tmpAddressedData) != 'object')
			{
				this.log.error(`Address for GridData [${this.options.GridDataAddress}] did not return an object; it was a ${typeof (tmpAddressedData)}.`);
				this.gridData = [];
			}
			else
			{
				this.gridData = JSON.parse(JSON.stringify(tmpAddressedData));
			}
		}
		else
		{
			this.gridData = [];
		}

		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (tmpTargetElementSet.length < 1)
		{
			this.log.error(`Could not find target element [${this.options.TargetElementAddress}] for TuiGrid!  Rendering won't function properly.`);
			this.targetElement = false;
			return false;
		}

		// Just go for the first one.
		this.targetElement = tmpTargetElementSet[0];

		// Check to see if there are any custom formatters.
		this.columnSchema = this.options.TuiColumnSchema;
		// Setup the solver and custom schema handlers.
		for (let i = 0; i < this.columnSchema.length; i++)
		{
			let tmpColumn = this.columnSchema[i];
			// If this bit is set on a column, the Form solver will trigger each time a change happens to that column.
			if (tmpColumn.PictTriggerSolveOnChange)
			{
				this.options.ColumnsToSolveOnChange[tmpColumn.name] = tmpColumn;
			}
			// Look to see if there is an internal formatter that matches the type
			if ((tmpColumn.hasOwnProperty('formatter')) && (this.customFormatters.hasOwnProperty(tmpColumn.formatter)))
			{
				// Assign our special formatter to the column.
				tmpColumn.formatter = this.customFormatters[tmpColumn.formatter];
			}
			// Look to see if there is an editor stanza
			if (tmpColumn.hasOwnProperty('editor'))
			{
				// Look to see if there is an internal editor that matches the type
				if ((tmpColumn.editor.hasOwnProperty('type'))
					&& (typeof (tmpColumn.editor.type) == 'string')
					&& (this.customEditors.hasOwnProperty(tmpColumn.editor.type)))
				{
					// Assign our special editor to the column.
					tmpColumn.editor.type = this.customEditors[tmpColumn.editor.type];
				}

				// Look to see if there is an internal editor that matches the type
				if ((tmpColumn.editor.hasOwnProperty('options'))
					&& (typeof (tmpColumn.editor.options) == 'object')
					&& (tmpColumn.editor.options.hasOwnProperty('listItems'))
					&& (typeof (tmpColumn.editor.options.listItems) == 'string'))
				{
					// Look for this address!  For the Record object, we will pass in the options.
					const tmpAddressSpace =
					{
						Fable: this.fable,
						Pict: this.fable,
						AppData: this.AppData,
						Bundle: this.Bundle,
						Options: this.options,
					};
					let tmpListItems = this.fable.manifest.getValueByHash(tmpAddressSpace, tmpColumn.editor.options.listItems);
					if (typeof (tmpListItems) == 'object')
					{
						tmpColumn.editor.options.listItems = tmpListItems;
					}
					else
					{
						this.log.warn(`Pict TuiGrid for column [${tmpColumn.name}] had [${tmpColumn.editor.options.listItems}] as a listItems address, but it didn't return an object.  It was a [${typeof (tmpListItems)}].  Setting to empty list.`);
						tmpColumn.editor.options.listItems = [];
					}
				}
			}
		}

		this.gridSettings = {
				data: this.gridData,
				el: this.targetElement,
				columns: this.columnSchema,

				// This is no bueno, yo
				usageStatistics: false,

				scrollY: this.options.GridScrollY,

				columnOptions:
				{
					resizable: this.options.GridColumnWidthResizable
				}
			};

		this.customConfigureGridSettings();

		let libTuiGrid = this._tuiGridPrototype;
		this.tuiGrid = new libTuiGrid(this.gridSettings);
		this.tuiGrid.on('beforeChange', (pChangeData) =>
		{
			//TODO: the exported event type from tui-grid is incomplete so mask it here
			/** @type {any} */
			const tmpChangeData = pChangeData;
			this.preChangeHandler(tmpChangeData);
		});
		this.tuiGrid.on('afterChange', (pChangeData) =>
		{
			//TODO: the exported event type from tui-grid is incomplete so mask it here
			/** @type {any} */
			const tmpChangeData = pChangeData;
			this.changeHandler(tmpChangeData);
		});
	}

	/**
	 * This is expected to be overloaded with anything that needs to be added to the grid configuration
	 * before the Toast UI Grid component is initialized in the browser.
	 */
	customConfigureGridSettings ()
	{
		// This can be overloaded to tweak up the this.gridSettings
	}

	/**
	 * Lookup a specific record in the toast ui grid data set by value and pull the value from the map into the browser.
	 *
	 * This function exists because if we mutate data in the map of plain javascript records tuigrid
	 * manages, it doesn't automatically refresh the UI.  From reading the TUIGrid documentation, this
	 * is because they don't want to refresh until all the data has changed.
	 *
	 * The best practice has been to have a hidden column behind the tuigrid that maps the correct entity
	 * value set to the record in the map (e.g. IDRecord in one column and Entity in another).
	 *
	 * @param {string} pCellColumnToBeSet - the Column hash to set
	 * @param {string} pCellValueToSet - Value to be set
	 * @param {string} pLookupValue - the Value to look up in tuigrid
	 * @param {string} pLookupColumn - the key of the column in the tuigrid record (which are plain javascript objects defined by the tuigrid config)
	 * @return {void}
	 */
	SetGridValue(pCellColumnToBeSet, pCellValueToSet, pLookupValue, pLookupColumn)
	{
		if (typeof (pLookupValue) == 'undefined')
		{
			console.log(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by [${pLookupColumn}]::[${pLookupValue}].  No valid lookup value!`);
			return;
		}

		if (!this.tuiGrid)
		{
			this.log.warn(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by [${pLookupColumn}]::[${pLookupValue}].  No valid grid!`);
			return;
		}

		const tmpData = this.tuiGrid.getData();

		for (let i = 0; i < tmpData.length; i++)
		{
			const tmpRecord = tmpData[i];

			if (tmpRecord[pLookupColumn] == pLookupValue)
			{
				this.tuiGrid.setValue(i, pCellColumnToBeSet, pCellValueToSet);
			}
		}
	}

	/**
	 * Lookup a specific record in the toast ui grid data set by row key and pull in a column.
	 *
	 * This function exists because if we mutate data in the map of plain javascript records tuigrid
	 * manages, it doesn't automatically refresh the UI.  From reading the TUIGrid documentation, this
	 * is because they don't want to refresh until all the data has changed.
	 *
	 *
	 * @param {string} pCellColumnToBeSet - the Column hash to set
	 * @param {string} pCellValueToSet - Value to be set
	 * @param {string} pRowKey - the key of the row to be set
	 * @return {boolean}
	 */
	SetGridValueByRowKey(pCellColumnToBeSet, pCellValueToSet, pRowKey)
	{
		if (typeof (pRowKey) == 'undefined')
		{
			this.log.error(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by row key [${pRowKey}].  No valid row key!`);
			return false;
		}

		if (!this.tuiGrid)
		{
			this.log.warn(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by row key [${pRowKey}].  No valid grid!`);
			return false;
		}

		this.tuiGrid.setValue(pRowKey, pCellColumnToBeSet, pCellValueToSet);
		return true;
	}
}

module.exports = PictSectionTuiGrid;

/** @type {Record<string, any>} */
module.exports.default_configuration = require('./Pict-Section-TuiGrid-DefaultConfiguration.json');

},{"./Pict-Section-TuiGrid-DefaultConfiguration.json":715,"./Pict-TuiGrid-Editors.js":719,"./Pict-TuiGrid-Headers.js":720,"pict-view":733}],717:[function(require,module,exports){
// Custom number editor class with an option for precision
class tuiCustomEditorNumber
{
	constructor(pProperties)
	{
		const tmpElement = document.createElement('input');

		const decimalPrecision = (pProperties.columnInfo.editor.options.decimalPrecision) ? pProperties.columnInfo.editor.options.decimalPrecision : 3;

		tmpElement.type = 'number';
		tmpElement.value = String(pProperties.value);
		tmpElement.oninput = (pElement) =>
		{
			if (pElement.target instanceof HTMLInputElement)
			{
				const tmpCastNumber = parseFloat(pElement.target.value).toFixed(decimalPrecision).toString()
				if (tmpCastNumber.length < parseFloat(pElement.target.value).toString().length)
				{
					pElement.target.value = tmpCastNumber;
				}
			}
		};

		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	getValue()
	{
		return this.Element.value;
	}

	mounted()
	{
		this.Element.select();
	}
}

module.exports = tuiCustomEditorNumber;

},{}],718:[function(require,module,exports){
// Custom number editor class with an option for precision
class tuiCustomEditorText
{
	constructor(pProperties)
	{
		const tmpElement = document.createElement('input');

		tmpElement.type = 'text';
		tmpElement.value = String(pProperties.value);
		tmpElement.placeholder =  pProperties.columnInfo.editor.options.placeholder || '';
		tmpElement.pattern = pProperties.columnInfo.editor.options.pattern || '';
		tmpElement.minLength = pProperties.columnInfo.editor.options.minLength || '';
		tmpElement.maxLength = pProperties.columnInfo.editor.options.maxLength || '';
		tmpElement.required = pProperties.columnInfo.editor.options.required || '';

		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	getValue()
	{
		return this.Element.value;
	}

	mounted()
	{
		this.Element.select();
	}
}

module.exports = tuiCustomEditorText;

},{}],719:[function(require,module,exports){
module.exports =
{
	EditorNumber: require('./Pict-TuiGrid-Editor-Number.js'),
	EditorText: require('./Pict-TuiGrid-Editor-Text.js'),
};

},{"./Pict-TuiGrid-Editor-Number.js":717,"./Pict-TuiGrid-Editor-Text.js":718}],720:[function(require,module,exports){
// Custom column header where the header is hidden
class tuiCustomColumnHeaderNone
{
	constructor()
	{
		let tmpElement = document.createElement('input');
		tmpElement.type = 'hidden';
		tmpElement.value = '';
		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	render()
	{
		// Noop!
	}
}

module.exports =
{
	CustomColumnHeaderNone: tuiCustomColumnHeaderNone,
};

},{}],721:[function(require,module,exports){
// The container for all the Pict-Section-Upload related code.
//
// pict-section-upload is a themeable, pict-native dropzone file-upload control: drag-and-drop,
// single & multi file, per-file progress + status, and a host-agnostic UploadTarget seam. The
// built-in Browser target reads files entirely in the browser (for client-side parsing); the
// built-in Server target streams/POSTs them to an endpoint with progress. A host can supply any
// object satisfying the UploadTarget interface for custom destinations.

// The upload provider (primary API surface — registers the widget view + CSS + dropzone icon, and
// exposes createUploader() / the target + file-handle factories).
const PictProviderUpload = require('./providers/Pict-Provider-Upload.js');

// The dropzone widget view (also registered on demand by the provider's createUploader()).
const PictViewUpload = require('./views/PictView-Upload.js');

// The UploadTarget seam — base interface + built-in implementations.
const UploadTargetBase = require('./targets/Upload-Target-Base.js');
const UploadTargetBrowser = require('./targets/Upload-Target-Browser.js');
const UploadTargetServer = require('./targets/Upload-Target-Server.js');

module.exports = PictProviderUpload;

module.exports.PictProviderUpload = PictProviderUpload;
module.exports.PictViewUpload = PictViewUpload;
module.exports.UploadTargetBase = UploadTargetBase;
module.exports.UploadTargetBrowser = UploadTargetBrowser;
module.exports.UploadTargetServer = UploadTargetServer;

module.exports.default_configuration = PictProviderUpload.default_configuration;

},{"./providers/Pict-Provider-Upload.js":723,"./targets/Upload-Target-Base.js":724,"./targets/Upload-Target-Browser.js":725,"./targets/Upload-Target-Server.js":726,"./views/PictView-Upload.js":727}],722:[function(require,module,exports){
// Upload-Helpers — pure helpers shared by the provider (public API) and the view (internal use),
// so target resolution + file-handle construction have exactly one implementation. Requires only
// the target classes (leaf), so there is no provider<->view require cycle.

const libUploadTargetBase = require('./targets/Upload-Target-Base.js');
const libUploadTargetBrowser = require('./targets/Upload-Target-Browser.js');
const libUploadTargetServer = require('./targets/Upload-Target-Server.js');

/**
 * Human-readable byte size, e.g. 1536 -> "1.5 KB".
 * @param {number} pBytes
 * @return {string}
 */
function formatBytes(pBytes)
{
	const tmpBytes = (typeof pBytes === 'number' && isFinite(pBytes)) ? pBytes : 0;
	if (tmpBytes <= 0) { return '0 B'; }
	const tmpUnits = [ 'B', 'KB', 'MB', 'GB', 'TB' ];
	const tmpExponent = Math.min(Math.floor(Math.log(tmpBytes) / Math.log(1024)), tmpUnits.length - 1);
	const tmpValue = tmpBytes / Math.pow(1024, tmpExponent);
	// Whole bytes show no decimal; larger units show one.
	const tmpRounded = (tmpExponent === 0) ? tmpValue : Math.round(tmpValue * 10) / 10;
	return `${tmpRounded} ${tmpUnits[tmpExponent]}`;
}

/**
 * Normalize a config's UploadTarget (a string, a {Type,...} object, or a ready instance) into a
 * live UploadTarget. Mirrors the picker's _resolveJoinConfig "string | object | instance" handling.
 * @param {any} pPict
 * @param {Record<string, any>} pConfig - the uploader config (UploadTarget + server options).
 * @return {any} an UploadTarget instance.
 */
function resolveTarget(pPict, pConfig)
{
	const tmpSpec = (pConfig && pConfig.UploadTarget !== undefined) ? pConfig.UploadTarget : 'browser';

	// A ready-made instance (host-supplied custom target): anything with read() + upload().
	if (tmpSpec && typeof tmpSpec.read === 'function' && typeof tmpSpec.upload === 'function')
	{
		return tmpSpec;
	}

	if (tmpSpec === 'server' || (tmpSpec && typeof tmpSpec === 'object' && tmpSpec.Type === 'server'))
	{
		const tmpServerOptions = (tmpSpec && typeof tmpSpec === 'object')
			? tmpSpec
			: { Endpoint: pConfig.UploadEndpoint || pConfig.Endpoint, Method: pConfig.UploadMethod };
		return new libUploadTargetServer(pPict, tmpServerOptions);
	}

	const tmpBrowserOptions = (tmpSpec && typeof tmpSpec === 'object') ? tmpSpec : {};
	return new libUploadTargetBrowser(pPict, tmpBrowserOptions);
}

/**
 * Wrap a native File in a serializable file handle bound to a target. The data fields are plain
 * (so the handle JSON-serializes cleanly into AppData snapshots) and the read methods are defined
 * NON-ENUMERABLE so they stay callable on the live object but drop out of JSON.stringify.
 * @param {any} pPict @param {any} pFile @param {any} pTarget
 * @return {Record<string, any>} the file handle.
 */
function buildFileHandle(pPict, pFile, pTarget)
{
	const tmpHash = (pPict && typeof pPict.getUUID === 'function')
		? pPict.getUUID()
		: (`upload-${Date.now()}-${Math.floor(Math.random() * 1e9)}`);

	const tmpHandle =
	{
		Hash: tmpHash,
		Name: (pFile && pFile.name) || 'file',
		Size: (pFile && typeof pFile.size === 'number') ? pFile.size : 0,
		Type: (pFile && pFile.type) || '',
		Status: 'pending',
		Progress: 0,
		Error: null,
		ServerId: null,
		ServerURL: null,
		ServerResponse: null,
	};
	// SizeLabel is derived display DATA (a formatted string), not HTML — fine to precompute.
	tmpHandle.SizeLabel = formatBytes(tmpHandle.Size);

	const fDefineMethod = (pKey, pFunction) =>
	{
		Object.defineProperty(tmpHandle, pKey, { value: pFunction, enumerable: false, writable: false, configurable: true });
	};
	fDefineMethod('getText', (fCallback) => pTarget.read(pFile, 'text', fCallback));
	fDefineMethod('getArrayBuffer', (fCallback) => pTarget.read(pFile, 'arraybuffer', fCallback));
	fDefineMethod('getDataURL', (fCallback) => pTarget.read(pFile, 'dataurl', fCallback));
	fDefineMethod('getFile', () => pFile);

	return tmpHandle;
}

module.exports = {
	formatBytes,
	resolveTarget,
	buildFileHandle,
	UploadTargetBase: libUploadTargetBase,
	UploadTargetBrowser: libUploadTargetBrowser,
	UploadTargetServer: libUploadTargetServer,
};

},{"./targets/Upload-Target-Base.js":724,"./targets/Upload-Target-Browser.js":725,"./targets/Upload-Target-Server.js":726}],723:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewUpload = require('../views/PictView-Upload.js');
const libUploadHelpers = require('../Upload-Helpers.js');

// Themeable control CSS. Registered once (by hash) regardless of how many uploaders exist. Host apps
// brand by defining the --theme-* tokens; the hardcoded values are fallbacks.
const _UploadCSS = /*css*/`
.psu { width: 100%; box-sizing: border-box; font-size: var(--theme-typography-size-md, 0.95rem); }
.psu *, .psu *::before, .psu *::after { box-sizing: border-box; }
.psu-input { display: none; }

.psu-dropzone { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: var(--theme-spacing-sm, 0.5rem);
	padding: var(--theme-spacing-xl, 1.5rem); text-align: center; cursor: pointer;
	border: 2px dashed var(--theme-color-border-strong, #b6bdc7); border-radius: var(--theme-radius-lg, 10px);
	background: var(--theme-color-background-secondary, #f6f7f9); color: var(--theme-color-text-muted, #6b7686);
	transition: border-color var(--theme-duration-normal, 0.18s) ease, background var(--theme-duration-normal, 0.18s) ease; }
.psu-dropzone:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-secondary, #45596b); }
.psu-dropzone:focus-visible { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-focus-outline, #156dd1) 30%, transparent); }
.psu-dropzone--active { border-color: var(--theme-color-brand-primary, #156dd1);
	background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 8%, transparent); color: var(--theme-color-brand-primary, #156dd1); }
.psu-dropzone-icon { display: inline-flex; font-size: 1.8rem; color: var(--theme-color-brand-primary, #156dd1); }
.psu-dropzone-text { font-size: var(--theme-typography-size-md, 0.95rem); }
.psu-browse { color: var(--theme-color-brand-primary, #156dd1); font-weight: var(--theme-typography-weight-medium, 600); text-decoration: underline; }
.psu-dropzone-hint { font-size: var(--theme-typography-size-xs, 0.78rem); color: var(--theme-color-text-muted, #6b7686); }

.psu-error { display: flex; align-items: center; gap: 0.4rem; margin-top: var(--theme-spacing-sm, 0.5rem);
	padding: 0.5rem 0.7rem; border-radius: var(--theme-radius-md, 6px); font-size: var(--theme-typography-size-sm, 0.86rem);
	color: var(--theme-color-status-error, #b62828); background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 10%, transparent); }

.psu-list { display: flex; flex-direction: column; gap: var(--theme-spacing-sm, 0.5rem); margin-top: var(--theme-spacing-sm, 0.5rem); }
.psu-empty { padding: var(--theme-spacing-sm, 0.5rem); color: var(--theme-color-text-muted, #6b7686); font-size: var(--theme-typography-size-sm, 0.86rem); text-align: center; }

.psu-file { display: flex; align-items: center; gap: var(--theme-spacing-sm, 0.6rem);
	padding: var(--theme-spacing-sm, 0.55rem) var(--theme-spacing-md, 0.75rem);
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: var(--theme-radius-md, 6px);
	background: var(--theme-color-background-panel, #ffffff); box-shadow: var(--theme-shadow-sm, 0 1px 2px rgba(17,24,39,0.06)); }
.psu-file-error { border-color: color-mix(in srgb, var(--theme-color-status-error, #b62828) 45%, transparent); }
.psu-file-icon { flex: 0 0 auto; display: inline-flex; font-size: 1.2rem; color: var(--theme-color-text-secondary, #45596b); }
.psu-file-image .psu-file-icon { color: var(--theme-color-brand-accent, #7a59c7); }
.psu-file-main { flex: 1 1 auto; min-width: 0; }
.psu-file-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1f2733);
	font-weight: var(--theme-typography-weight-medium, 600); font-size: var(--theme-typography-size-sm, 0.88rem); }
.psu-file-meta { font-size: var(--theme-typography-size-xs, 0.76rem); color: var(--theme-color-text-muted, #6b7686); }
.psu-file-rowerror { font-size: var(--theme-typography-size-xs, 0.76rem); color: var(--theme-color-status-error, #b62828); margin-top: 0.15rem; }

.psu-bar { margin-top: 0.35rem; height: 5px; border-radius: var(--theme-radius-pill, 999px); overflow: hidden;
	background: var(--theme-color-background-tertiary, #e9edf2); }
.psu-bar-fill { height: 100%; border-radius: var(--theme-radius-pill, 999px); background: var(--theme-color-brand-primary, #156dd1);
	transition: width var(--theme-duration-normal, 0.18s) ease; }

.psu-file-badge { flex: 0 0 auto; font-size: var(--theme-typography-size-xs, 0.72rem); font-weight: var(--theme-typography-weight-medium, 600);
	padding: 0.1rem 0.5rem; border-radius: var(--theme-radius-pill, 999px); white-space: nowrap;
	background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
.psu-file-badge-complete { background: color-mix(in srgb, var(--theme-color-status-success, #2e7a3a) 16%, transparent); color: var(--theme-color-status-success, #2e7a3a); }
.psu-file-badge-error { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 16%, transparent); color: var(--theme-color-status-error, #b62828); }
.psu-file-badge-uploading, .psu-file-badge-reading { background: color-mix(in srgb, var(--theme-color-status-info, #1f6fb5) 16%, transparent); color: var(--theme-color-status-info, #1f6fb5); }

.psu-file-remove { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; border: none; background: transparent;
	padding: 0.2rem; border-radius: var(--theme-radius-sm, 4px); color: var(--theme-color-text-muted, #6b7686); opacity: 0.7; }
.psu-file-remove:hover { opacity: 1; color: var(--theme-color-status-error, #b62828); background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 12%, transparent); }
`;

// A single custom dropzone glyph (cloud + up arrow). The base icon set already covers File /
// Spreadsheet / Image / Code / Close / Warning, so this is the only addition. Monoline currentColor
// per the icon-registry convention (no width/height on the svg — the registry sizes via font-size).
const _UPLOAD_ICONS =
{
	Outline:
	{
		UploadCloud: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7 18a4.5 4.5 0 0 1-.9-8.91A5.5 5.5 0 0 1 17.5 9.5a3.75 3.75 0 0 1 .5 7.46"/><path d="M12 13v7"/><path d="m8.7 16 3.3-3.3L15.3 16"/></svg>',
	},
};

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Section-Upload',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/**
 * The pict-section-upload provider — the primary API surface. Registers the widget CSS + dropzone
 * icon once, and creates/manages uploader view instances. Also exposes the target factories and the
 * file-handle factory so a host can build handles without a view.
 */
class PictProviderUpload extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Section-Upload-CSS', _UploadCSS, 500);
		}
		if (this.pict && this.pict.providers && this.pict.providers.Icon && typeof this.pict.providers.Icon.registerSet === 'function')
		{
			this.pict.providers.Icon.registerSet(_UPLOAD_ICONS);
		}
	}

	/**
	 * Create (or reconfigure + reuse) an uploader view instance.
	 * @param {string} pUploaderHash - unique hash/id; the control renders into `#<hash>` unless a
	 *   DestinationAddress is given.
	 * @param {Record<string, any>} pConfig - uploader configuration (see PictViewUpload defaults).
	 * @return {any} The uploader view instance.
	 */
	createUploader(pUploaderHash, pConfig)
	{
		const tmpConfig = Object.assign(
			{
				DestinationAddress: `#${pUploaderHash}`,
				Multiple: false,
				Accept: '',
				MaxSize: 0,
				UploadTarget: 'browser',
			},
			pConfig || {},
			{ UploaderHash: pUploaderHash });

		if (this.pict.views[pUploaderHash])
		{
			const tmpView = this.pict.views[pUploaderHash];
			Object.assign(tmpView.options, tmpConfig);
			// Re-resolve the target in case UploadTarget changed on reconfigure.
			tmpView._target = libUploadHelpers.resolveTarget(this.pict, tmpView.options);
			return tmpView;
		}
		return this.pict.addView(pUploaderHash, tmpConfig, libPictViewUpload);
	}

	/**
	 * Build a read-in-browser UploadTarget.
	 * @param {Record<string, any>} pConfig
	 * @return {any}
	 */
	createBrowserTarget(pConfig)
	{
		return new libUploadHelpers.UploadTargetBrowser(this.pict, pConfig || {});
	}

	/**
	 * Build a server UploadTarget.
	 * @param {Record<string, any>} pConfig - { Endpoint, Method, Headers, FieldName, Raw, WithCredentials, ResponseHandle }.
	 * @return {any}
	 */
	createServerTarget(pConfig)
	{
		return new libUploadHelpers.UploadTargetServer(this.pict, pConfig || {});
	}

	/**
	 * Wrap a native File in a file handle bound to a target (defaults to a browser target). Lets a
	 * host build the same handle shape an uploader produces, without a view.
	 * @param {any} pFile @param {any} [pTarget]
	 * @return {Record<string, any>}
	 */
	wrapFile(pFile, pTarget)
	{
		return libUploadHelpers.buildFileHandle(this.pict, pFile, pTarget || this.createBrowserTarget({}));
	}
}

// Static byte-format helper (shared with the view via the helpers module; exposed for hosts/tests).
PictProviderUpload.formatBytes = libUploadHelpers.formatBytes;

module.exports = PictProviderUpload;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../Upload-Helpers.js":722,"../views/PictView-Upload.js":727,"pict-provider":552}],724:[function(require,module,exports){
// Upload-Target-Base — the host-agnostic UploadTarget seam.
//
// A target answers two questions for the uploader: "how do I READ a File's bytes?" (used by the
// file handle's getText/getArrayBuffer/getDataURL) and "how do I SEND it somewhere?" (upload()).
// The base implements read() via FileReader (shared by every target) and a no-op upload(); the
// Browser target keeps the no-op (read-in-browser only), the Server target overrides upload().
//
// This mirrors pict-section-picker's host-agnostic DataProvider seam: built-ins cover the common
// cases, and a host can pass any object satisfying this interface (e.g. an S3 presigned PUT, an
// IndexedDB sink, a Meadow attachment endpoint) without the view changing.

class UploadTargetBase
{
	/**
	 * @param {any} pPict - the Pict instance (for logging); targets are otherwise stateless.
	 * @param {Record<string, any>} pOptions - target configuration.
	 */
	constructor(pPict, pOptions)
	{
		this.pict = pPict;
		this.options = pOptions || {};
		// Browser target: no server leg. Server target flips this true.
		this.supportsUpload = false;
	}

	/**
	 * Read a File's contents in the browser.
	 * @param {any} pFile - the native File / Blob.
	 * @param {'text'|'arraybuffer'|'dataurl'} pKind - how to decode it.
	 * @param {(pError:any, pValue?:any)=>void} fCallback
	 */
	read(pFile, pKind, fCallback)
	{
		if (typeof fCallback !== 'function') { return; }
		if (!pFile) { return fCallback(new Error('pict-section-upload: no file to read.')); }
		if (typeof FileReader === 'undefined') { return fCallback(new Error('pict-section-upload: FileReader is not available in this environment.')); }

		let tmpReader;
		try { tmpReader = new FileReader(); }
		catch (pError) { return fCallback(pError); }

		// FileReader surfaces its result ONLY through the load/error events (no inline-handler form,
		// no synchronous read), and the reader is a JS-created object — not template DOM that gets
		// torn down on re-render. So assigning onload/onerror here is the sanctioned "listener-only
		// browser API" exception to the no-addEventListener rule (see pict CLAUDE.md).
		tmpReader.onload = () => fCallback(null, tmpReader.result);
		tmpReader.onerror = () => fCallback(tmpReader.error || new Error('pict-section-upload: file read failed.'));

		try
		{
			switch (pKind)
			{
				case 'arraybuffer':
					tmpReader.readAsArrayBuffer(pFile);
					break;
				case 'dataurl':
					tmpReader.readAsDataURL(pFile);
					break;
				case 'text':
				default:
					tmpReader.readAsText(pFile);
					break;
			}
		}
		catch (pError)
		{
			return fCallback(pError);
		}
	}

	/**
	 * Transfer the File to its destination. Base default: a no-op that completes immediately (the
	 * Browser target keeps this — there is no server leg). The Server target overrides it.
	 * @param {any} pHandle - the file handle.
	 * @param {any} pFile - the native File.
	 * @param {(pPercent:number)=>void} fProgress - progress callback (0..100).
	 * @param {(pError:any, pResult?:any)=>void} fCallback
	 * @return {{abort:Function}} an abort handle.
	 */
	upload(pHandle, pFile, fProgress, fCallback)
	{
		if (typeof fCallback === 'function') { fCallback(null, {}); }
		return { abort: () => {} };
	}
}

module.exports = UploadTargetBase;

},{}],725:[function(require,module,exports){
// Upload-Target-Browser — the read-in-browser target (no server leg).
//
// Reads files entirely client-side via FileReader (inherited from the base) so a downstream
// consumer (e.g. pict-section-dataimport) can parse the bytes in the browser. upload() is the
// base no-op: there is nowhere to send the file, so it "completes" immediately and the file is
// simply available for reading.

const libUploadTargetBase = require('./Upload-Target-Base.js');

class UploadTargetBrowser extends libUploadTargetBase
{
	constructor(pPict, pOptions)
	{
		super(pPict, pOptions);
		this.supportsUpload = false;
	}
}

module.exports = UploadTargetBrowser;

},{"./Upload-Target-Base.js":724}],726:[function(require,module,exports){
// Upload-Target-Server — streams/POSTs a file up to a server with progress.
//
// Sends the File as multipart FormData (default) or as a raw streamed body (config.Raw, for PUT to
// object storage), reporting upload progress and parsing the server response for an id / URL. The
// returned abort handle lets the view cancel an in-flight upload (e.g. when the user removes the row).
//
// Configuration (pOptions):
//   Endpoint        {string}   - required; the URL to send to.
//   Method          {string}   - 'POST' (default) | 'PUT'.
//   Headers         {object}   - extra request headers.
//   FieldName       {string}   - multipart field name (default 'file').
//   Raw             {boolean}  - send the raw File as the body instead of FormData (streamed PUT).
//   WithCredentials {boolean}  - set xhr.withCredentials.
//   ResponseHandle  {function} - (xhr) => { ServerId, ServerURL, ServerResponse }; overrides the
//                                default JSON parse of { ID|id, URL|url }.

const libUploadTargetBase = require('./Upload-Target-Base.js');

class UploadTargetServer extends libUploadTargetBase
{
	constructor(pPict, pOptions)
	{
		super(pPict, pOptions);
		this.supportsUpload = true;
	}

	/**
	 * @param {any} pHandle @param {any} pFile
	 * @param {(pPercent:number)=>void} fProgress @param {(pError:any, pResult?:any)=>void} fCallback
	 * @return {{abort:Function}}
	 */
	upload(pHandle, pFile, fProgress, fCallback)
	{
		const tmpEndpoint = this.options.Endpoint;
		if (!tmpEndpoint)
		{
			if (typeof fCallback === 'function') { fCallback(new Error('pict-section-upload ServerTarget: no Endpoint configured.')); }
			return { abort: () => {} };
		}
		if (typeof XMLHttpRequest === 'undefined')
		{
			if (typeof fCallback === 'function') { fCallback(new Error('pict-section-upload ServerTarget: XMLHttpRequest is not available in this environment.')); }
			return { abort: () => {} };
		}

		const tmpMethod = (this.options.Method || 'POST').toUpperCase();
		let tmpXHR;
		try { tmpXHR = new XMLHttpRequest(); }
		catch (pError)
		{
			if (typeof fCallback === 'function') { fCallback(pError); }
			return { abort: () => {} };
		}

		tmpXHR.open(tmpMethod, tmpEndpoint, true);
		if (this.options.WithCredentials) { tmpXHR.withCredentials = true; }
		const tmpHeaders = this.options.Headers || {};
		for (const tmpKey in tmpHeaders)
		{
			if (Object.prototype.hasOwnProperty.call(tmpHeaders, tmpKey))
			{
				try { tmpXHR.setRequestHeader(tmpKey, tmpHeaders[tmpKey]); } catch (pError) { /* header rejected — non-fatal */ }
			}
		}

		// XMLHttpRequestUpload exposes transfer progress ONLY via the 'progress' event — there is no
		// inline-handler equivalent on an element, and the xhr is a JS-created object (not template
		// DOM). This is the sanctioned "listener-only browser API" exception (see pict CLAUDE.md).
		if (tmpXHR.upload && typeof fProgress === 'function')
		{
			tmpXHR.upload.addEventListener('progress', (pEvent) =>
			{
				if (pEvent && pEvent.lengthComputable && pEvent.total > 0)
				{
					fProgress(Math.round((pEvent.loaded / pEvent.total) * 100));
				}
			});
		}

		tmpXHR.onload = () =>
		{
			if (tmpXHR.status >= 200 && tmpXHR.status < 300)
			{
				let tmpResult = {};
				try { tmpResult = this._handleResponse(tmpXHR); } catch (pError) { tmpResult = {}; }
				if (typeof fCallback === 'function') { fCallback(null, tmpResult); }
			}
			else if (typeof fCallback === 'function')
			{
				fCallback(new Error(`pict-section-upload: upload failed with HTTP ${tmpXHR.status}.`));
			}
		};
		tmpXHR.onerror = () => { if (typeof fCallback === 'function') { fCallback(new Error('pict-section-upload: upload network error.')); } };
		tmpXHR.onabort = () => { if (typeof fCallback === 'function') { fCallback(new Error('pict-section-upload: upload aborted.')); } };

		if (this.options.Raw === true)
		{
			if (!tmpHeaders['Content-Type'])
			{
				try { tmpXHR.setRequestHeader('Content-Type', (pFile && pFile.type) || 'application/octet-stream'); } catch (pError) { /* non-fatal */ }
			}
			tmpXHR.send(pFile);
		}
		else
		{
			const tmpForm = new FormData();
			tmpForm.append(this.options.FieldName || 'file', pFile, pHandle && pHandle.Name);
			tmpXHR.send(tmpForm);
		}

		return { abort: () => { try { tmpXHR.abort(); } catch (pError) { /* already done */ } } };
	}

	/**
	 * Parse the server response into the handle's server fields.
	 * @param {any} pXHR
	 * @return {{ServerId:any, ServerURL:any, ServerResponse:any}}
	 */
	_handleResponse(pXHR)
	{
		if (typeof this.options.ResponseHandle === 'function')
		{
			return this.options.ResponseHandle(pXHR);
		}
		let tmpBody = {};
		try { tmpBody = JSON.parse(pXHR.responseText); } catch (pError) { tmpBody = {}; }
		return {
			ServerId: (tmpBody && (tmpBody.ID !== undefined ? tmpBody.ID : tmpBody.id)) || null,
			ServerURL: (tmpBody && (tmpBody.URL !== undefined ? tmpBody.URL : tmpBody.url)) || null,
			ServerResponse: tmpBody,
		};
	}
}

module.exports = UploadTargetServer;

},{"./Upload-Target-Base.js":724}],727:[function(require,module,exports){
const libPictView = require('pict-view');
const libUploadHelpers = require('../Upload-Helpers.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'Pict-Section-Upload-View',

	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,

	DefaultRenderable: 'Pict-Section-Upload-Renderable',

	// Per-instance options (supplied by PictProviderUpload.createUploader):
	UploaderHash: false,
	DestinationAddress: false,
	// AppData address that receives the resulting file handle (single mode) or handle array (multi).
	ValueAddress: false,
	Multiple: false,
	// `<input accept>`-style filter: comma list of extensions (.csv), mime types (text/csv) or
	// wildcards (image/*). Empty = accept everything.
	Accept: '',
	// Max bytes per file (0 = unbounded).
	MaxSize: 0,
	// When the target supports upload, start the transfer as soon as a file is added.
	AutoUpload: true,
	// 'browser' (read-in-browser only), 'server', a { Type:'server', Endpoint, ... } object, or a
	// host-supplied UploadTarget instance.
	UploadTarget: 'browser',
	DropLabel: 'Drag & drop files here, or',
	BrowseLabel: 'browse',
	// Lifecycle callbacks (the host-agnostic contract; the module never assumes a host shape):
	OnFileAdded: false,
	OnProgress: false,
	OnComplete: false,
	OnError: false,
	OnRemove: false,

	Templates:
	[
		{
			// The whole control: dropzone + (display:none) file input + the file list. The dropzone
			// and input are SIBLINGS of the list, so re-rendering just the list (_renderList) on a
			// progress tick never tears down the dropzone (drag state) or the input.
			Hash: 'Pict-Section-Upload-Container',
			Template: /*html*/`
<div class="psu" id="PSU_{~D:Record.UploaderHash~}">
	<div class="psu-dropzone" id="PSU_Drop_{~D:Record.UploaderHash~}" role="button" tabindex="0"
		ondragover="_Pict.views['{~D:Record.UploaderHash~}'].dragOver(event)"
		ondragleave="_Pict.views['{~D:Record.UploaderHash~}'].dragLeave(event)"
		ondrop="_Pict.views['{~D:Record.UploaderHash~}'].drop(event)"
		onclick="_Pict.views['{~D:Record.UploaderHash~}'].browse()"
		onkeydown="if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); _Pict.views['{~D:Record.UploaderHash~}'].browse(); }">
		<span class="psu-dropzone-icon">{~I:UploadCloud~}</span>
		<div class="psu-dropzone-text">{~D:Record.DropLabel~} <span class="psu-browse">{~D:Record.BrowseLabel~}</span></div>
		{~TS:Pict-Section-Upload-Hint:Record.AcceptHintSlot~}
	</div>
	<input type="file" class="psu-input" id="PSU_Input_{~D:Record.UploaderHash~}"{~NE:Record.IsMultiple^ multiple~} accept="{~D:Record.Accept~}" onchange="_Pict.views['{~D:Record.UploaderHash~}'].onInputChange(this)" />
	{~TS:Pict-Section-Upload-Error:Record.ErrorSlot~}
	<div class="psu-list" id="PSU_List_{~D:Record.UploaderHash~}">{~T:Pict-Section-Upload-ListInner~}</div>
</div>
`
		},
		{
			// The inner content of the file list — re-rendered on its own for progress / add / remove.
			Hash: 'Pict-Section-Upload-ListInner',
			Template: /*html*/`{~TS:Pict-Section-Upload-Row:Record.Files~}{~TS:Pict-Section-Upload-Empty:Record.EmptySlot~}`
		},
		{
			Hash: 'Pict-Section-Upload-Hint',
			Template: /*html*/`<div class="psu-dropzone-hint">{~D:Record.Text~}</div>`
		},
		{
			Hash: 'Pict-Section-Upload-Empty',
			Template: /*html*/`<div class="psu-empty">No files selected yet.</div>`
		},
		{
			Hash: 'Pict-Section-Upload-Error',
			Template: /*html*/`<div class="psu-error">{~I:Warning~} <span>{~D:Record.Message~}</span></div>`
		},
		{
			// One file row. The status drives the badge + row tint via class interpolation (a status
			// string is data, not HTML). Icon category + progress + row-error are single-element-array
			// slots so nested {~I:~}/{~D:~} tags parse (an {~NE:~} would not recurse into them).
			Hash: 'Pict-Section-Upload-Row',
			Template: /*html*/`
<div class="psu-file psu-file-{~D:Record.Status~}" id="PSU_Row_{~D:Record.Hash~}">
	<span class="psu-file-icon">{~TS:Pict-Section-Upload-Ico-Sheet:Record.IcoSheet~}{~TS:Pict-Section-Upload-Ico-Image:Record.IcoImage~}{~TS:Pict-Section-Upload-Ico-Code:Record.IcoCode~}{~TS:Pict-Section-Upload-Ico-File:Record.IcoFile~}</span>
	<div class="psu-file-main">
		<div class="psu-file-name" title="{~D:Record.Name~}">{~D:Record.Name~}</div>
		<div class="psu-file-meta">{~D:Record.SizeLabel~}{~NE:Record.TypeLabel^ · ~}{~D:Record.TypeLabel~}</div>
		{~TS:Pict-Section-Upload-Progress:Record.ProgressSlot~}
		{~TS:Pict-Section-Upload-RowError:Record.RowErrorSlot~}
	</div>
	<span class="psu-file-badge psu-file-badge-{~D:Record.Status~}">{~D:Record.StatusLabel~}</span>
	<button type="button" class="psu-file-remove" title="Remove" onclick="_Pict.views['{~D:Record.UploaderHash~}'].removeFile('{~D:Record.Hash~}')">{~I:Close~}</button>
</div>
`
		},
		{
			Hash: 'Pict-Section-Upload-Progress',
			Template: /*html*/`<div class="psu-bar"><div class="psu-bar-fill" style="width: {~D:Record.Progress~}%;"></div></div>`
		},
		{
			Hash: 'Pict-Section-Upload-RowError',
			Template: /*html*/`<div class="psu-file-rowerror">{~D:Record.Error~}</div>`
		},
		{ Hash: 'Pict-Section-Upload-Ico-Sheet', Template: /*html*/`{~I:Spreadsheet~}` },
		{ Hash: 'Pict-Section-Upload-Ico-Image', Template: /*html*/`{~I:Image~}` },
		{ Hash: 'Pict-Section-Upload-Ico-Code', Template: /*html*/`{~I:Code~}` },
		{ Hash: 'Pict-Section-Upload-Ico-File', Template: /*html*/`{~I:File~}` },
	],

	Renderables:
	[
		{
			RenderableHash: 'Pict-Section-Upload-Renderable',
			TemplateHash: 'Pict-Section-Upload-Container',
			RenderMethod: 'replace',
		},
	],
};

class PictViewUpload extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.options.DefaultDestinationAddress = this.options.DestinationAddress || `#${this.options.UploaderHash}`;
		this._StateAddress = `AppData.PictSectionUpload.${this.options.UploaderHash}`;
		this.options.DefaultTemplateRecordAddress = this._StateAddress;
		if (Array.isArray(this.options.Renderables) && this.options.Renderables[0])
		{
			this.options.Renderables[0].ContentDestinationAddress = this.options.DefaultDestinationAddress;
		}

		// Transient state. The live File objects + abort handles are kept HERE (off AppData) so the
		// AppData state slot stays JSON-serializable; only the plain handle-data projection goes to AppData.
		this._fileEntries = [];   // [{ Handle, File, AbortHandle }]
		this._dragging = false;
		this._error = null;
		this._target = libUploadHelpers.resolveTarget(this.pict, this.options);

		try { this._buildState(); } catch (pError) { /* AppData not ready — onBeforeRender will build it */ }
	}

	/** @return {Record<string, any>} The AppData state slot for this uploader. */
	_state()
	{
		this.pict.AppData.PictSectionUpload = this.pict.AppData.PictSectionUpload || {};
		this.pict.AppData.PictSectionUpload[this.options.UploaderHash] = this.pict.AppData.PictSectionUpload[this.options.UploaderHash] || {};
		return this.pict.AppData.PictSectionUpload[this.options.UploaderHash];
	}

	/** (Re)compute the render state into AppData from the current file entries + transient flags. */
	_buildState()
	{
		const tmpState = this._state();
		tmpState.UploaderHash = this.options.UploaderHash;
		tmpState.IsMultiple = !!this.options.Multiple;
		tmpState.Accept = this.options.Accept || '';
		tmpState.DropLabel = this.options.DropLabel;
		tmpState.BrowseLabel = this.options.BrowseLabel;
		tmpState.SupportsUpload = !!(this._target && this._target.supportsUpload);
		tmpState.AcceptHintSlot = this.options.Accept ? [ { Text: `Accepted: ${this.options.Accept}` } ] : [];
		tmpState.Files = this._fileEntries.map((pEntry) => this._fileProjection(pEntry.Handle));
		tmpState.EmptySlot = (this._fileEntries.length === 0) ? [ {} ] : [];
		tmpState.ErrorSlot = this._error ? [ { Message: this._error } ] : [];
		tmpState.IsDragging = !!this._dragging;
		return tmpState;
	}

	/** Build the plain render record for one file handle (icon category + status label + slots). */
	_fileProjection(pHandle)
	{
		const tmpCategory = this._iconCategory(pHandle);
		const tmpProgress = (typeof pHandle.Progress === 'number') ? pHandle.Progress : 0;
		return {
			UploaderHash: this.options.UploaderHash,
			Hash: pHandle.Hash,
			Name: pHandle.Name,
			SizeLabel: pHandle.SizeLabel,
			TypeLabel: pHandle.Type || '',
			Status: pHandle.Status,
			StatusLabel: this._statusLabel(pHandle),
			Progress: tmpProgress,
			IcoSheet: (tmpCategory === 'sheet') ? [ {} ] : [],
			IcoImage: (tmpCategory === 'image') ? [ {} ] : [],
			IcoCode: (tmpCategory === 'code') ? [ {} ] : [],
			IcoFile: (tmpCategory === 'file') ? [ {} ] : [],
			ProgressSlot: (pHandle.Status === 'uploading' || pHandle.Status === 'reading') ? [ { Progress: tmpProgress } ] : [],
			RowErrorSlot: (pHandle.Status === 'error' && pHandle.Error) ? [ { Error: pHandle.Error } ] : [],
		};
	}

	/** @return {string} 'image' | 'sheet' | 'code' | 'file' for the row glyph. */
	_iconCategory(pHandle)
	{
		const tmpName = (pHandle.Name || '').toLowerCase();
		const tmpType = (pHandle.Type || '').toLowerCase();
		if (tmpType.indexOf('image/') === 0 || /\.(png|jpe?g|gif|webp|svg|bmp|ico)$/.test(tmpName)) { return 'image'; }
		if (tmpType.indexOf('csv') >= 0 || tmpType.indexOf('spreadsheet') >= 0 || tmpType.indexOf('excel') >= 0 || /\.(csv|tsv|tab|xlsx?)$/.test(tmpName)) { return 'sheet'; }
		if (tmpType.indexOf('json') >= 0 || tmpType.indexOf('xml') >= 0 || tmpType.indexOf('javascript') >= 0 || /\.(json|xml|js|ts|html?|css|md|yaml|yml)$/.test(tmpName)) { return 'code'; }
		return 'file';
	}

	/** @return {string} A human badge label for a handle's status. */
	_statusLabel(pHandle)
	{
		switch (pHandle.Status)
		{
			case 'pending': return 'Pending';
			case 'reading': return 'Reading…';
			case 'uploading': return 'Uploading…';
			case 'complete': return (this._target && this._target.supportsUpload) ? 'Uploaded' : 'Ready';
			case 'error': return 'Error';
			default: return String(pHandle.Status || '');
		}
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		this._buildState();
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		this._paintDragging();
		return super.onAfterRender(pRenderable);
	}

	/** Reflect the drag-hover state on the dropzone (a transient class toggle, no re-render). */
	_paintDragging()
	{
		if (typeof document === 'undefined') { return; }
		const tmpElement = document.getElementById(`PSU_Drop_${this.options.UploaderHash}`);
		if (tmpElement && tmpElement.classList) { tmpElement.classList.toggle('psu-dropzone--active', !!this._dragging); }
	}

	/** Re-render only the file list (leaves the dropzone + input — and their drag state — intact). */
	_renderList()
	{
		this._buildState();
		const tmpHTML = this.pict.parseTemplateByHash('Pict-Section-Upload-ListInner', this._state());
		this.pict.ContentAssignment.assignContent(`#PSU_List_${this.options.UploaderHash}`, tmpHTML);
	}

	// --- Drag & drop (inline handlers; preventDefault both dragover and drop or the browser navigates). ---

	dragOver(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this._dragging = true;
		this._paintDragging();
	}

	dragLeave(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		// dragleave also fires when crossing onto a child element; only clear when truly leaving the root.
		if (typeof document !== 'undefined' && pEvent && pEvent.relatedTarget)
		{
			const tmpRoot = document.getElementById(`PSU_Drop_${this.options.UploaderHash}`);
			if (tmpRoot && typeof tmpRoot.contains === 'function' && tmpRoot.contains(pEvent.relatedTarget)) { return; }
		}
		this._dragging = false;
		this._paintDragging();
	}

	drop(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		this._dragging = false;
		this._paintDragging();
		const tmpFiles = (pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files) ? pEvent.dataTransfer.files : null;
		if (tmpFiles) { this._ingestFileList(tmpFiles); }
	}

	/** Open the native file picker by clicking the hidden input (a programmatic click, not a listener). */
	browse()
	{
		if (typeof document === 'undefined') { return; }
		const tmpInput = document.getElementById(`PSU_Input_${this.options.UploaderHash}`);
		if (tmpInput && typeof tmpInput.click === 'function') { tmpInput.click(); }
	}

	onInputChange(pElement)
	{
		if (pElement && pElement.files) { this._ingestFileList(pElement.files); }
		// Reset so re-selecting the same file fires change again.
		if (pElement) { try { pElement.value = ''; } catch (pError) { /* non-fatal */ } }
	}

	/**
	 * Validate + add a FileList's files: rejects surface a dropzone error + OnError; accepted files
	 * become handles, get bound to the value address, and (server target + AutoUpload) start uploading.
	 * @param {any} pFileList - a FileList or array of File.
	 */
	_ingestFileList(pFileList)
	{
		this._error = null;
		const tmpList = Array.prototype.slice.call(pFileList || []);
		if (tmpList.length === 0) { return; }

		const tmpAccepted = [];
		for (let i = 0; i < tmpList.length; i++)
		{
			const tmpCheck = this._validate(tmpList[i]);
			if (!tmpCheck.ok)
			{
				this._error = tmpCheck.reason;
				if (typeof this.options.OnError === 'function') { try { this.options.OnError(new Error(tmpCheck.reason), tmpList[i]); } catch (pError) { /* host callback threw */ } }
				continue;
			}
			tmpAccepted.push(tmpList[i]);
		}

		if (tmpAccepted.length === 0) { this.render(); return; }

		// Single mode replaces any existing file; multi appends.
		if (!this.options.Multiple)
		{
			this._abortAll();
			this._fileEntries = [];
		}
		const tmpToAdd = this.options.Multiple ? tmpAccepted : tmpAccepted.slice(0, 1);
		const tmpNewEntries = tmpToAdd.map((pFile) => this._addEntry(pFile));

		this._writeValue();
		this.render();
		tmpNewEntries.forEach((pEntry) => this._afterAdd(pEntry));
	}

	/** Build + register a file entry (handle + live File + abort slot). */
	_addEntry(pFile)
	{
		const tmpHandle = libUploadHelpers.buildFileHandle(this.pict, pFile, this._target);
		const tmpEntry = { Handle: tmpHandle, File: pFile, AbortHandle: null };
		this._fileEntries.push(tmpEntry);
		return tmpEntry;
	}

	/** Fire OnFileAdded, then either start the upload (server target) or mark ready (browser target). */
	_afterAdd(pEntry)
	{
		if (typeof this.options.OnFileAdded === 'function')
		{
			try { this.options.OnFileAdded(pEntry.Handle); } catch (pError) { this.pict.log.warn(`pict-section-upload [${this.options.UploaderHash}] OnFileAdded threw.`, pError); }
		}
		if (this._target && this._target.supportsUpload && this.options.AutoUpload)
		{
			this._startUpload(pEntry);
		}
		else
		{
			// Browser target: the file is available in-browser immediately (nothing to upload). It
			// reaches 'complete' (= ready) and fires OnComplete too, so hosts react uniformly to
			// "file ready" whether or not there was a server leg.
			pEntry.Handle.Status = 'complete';
			this._renderList();
			if (typeof this.options.OnComplete === 'function') { this.options.OnComplete(pEntry.Handle); }
		}
	}

	/** Start the server transfer for an entry, wiring progress + completion back to the handle. */
	_startUpload(pEntry)
	{
		const tmpHandle = pEntry.Handle;
		tmpHandle.Status = 'uploading';
		tmpHandle.Progress = 0;
		tmpHandle.Error = null;
		this._renderList();

		pEntry.AbortHandle = this._target.upload(tmpHandle, pEntry.File,
			(pPercent) =>
			{
				tmpHandle.Progress = pPercent;
				this._renderList();
				if (typeof this.options.OnProgress === 'function') { this.options.OnProgress(tmpHandle, pPercent); }
			},
			(pError, pResult) =>
			{
				if (pError)
				{
					tmpHandle.Status = 'error';
					tmpHandle.Error = pError.message || String(pError);
					this._renderList();
					if (typeof this.options.OnError === 'function') { this.options.OnError(pError, tmpHandle); }
					return;
				}
				tmpHandle.Status = 'complete';
				tmpHandle.Progress = 100;
				if (pResult)
				{
					tmpHandle.ServerId = (pResult.ServerId !== undefined) ? pResult.ServerId : null;
					tmpHandle.ServerURL = (pResult.ServerURL !== undefined) ? pResult.ServerURL : null;
					tmpHandle.ServerResponse = (pResult.ServerResponse !== undefined) ? pResult.ServerResponse : pResult;
				}
				this._writeValue();
				this._renderList();
				if (typeof this.options.OnComplete === 'function') { this.options.OnComplete(tmpHandle); }
			});
	}

	/** @return {{ok:boolean, reason?:string}} Accept-filter + MaxSize gate for a single File. */
	_validate(pFile)
	{
		const tmpMax = this.options.MaxSize || 0;
		if (tmpMax > 0 && pFile.size > tmpMax)
		{
			return { ok: false, reason: `"${pFile.name}" is too large (${libUploadHelpers.formatBytes(pFile.size)} > ${libUploadHelpers.formatBytes(tmpMax)}).` };
		}
		const tmpAccept = (this.options.Accept || '').trim();
		if (tmpAccept && !this._matchesAccept(pFile, tmpAccept))
		{
			return { ok: false, reason: `"${pFile.name}" is not an accepted file type (${tmpAccept}).` };
		}
		return { ok: true };
	}

	/** @return {boolean} Whether a File matches an `<input accept>`-style filter string. */
	_matchesAccept(pFile, pAccept)
	{
		const tmpName = (pFile.name || '').toLowerCase();
		const tmpType = (pFile.type || '').toLowerCase();
		const tmpTokens = pAccept.split(',').map((pToken) => pToken.trim().toLowerCase()).filter(Boolean);
		for (let i = 0; i < tmpTokens.length; i++)
		{
			const tmpToken = tmpTokens[i];
			if (tmpToken.charAt(0) === '.')
			{
				if (tmpName.endsWith(tmpToken)) { return true; }
			}
			else if (tmpToken.endsWith('/*'))
			{
				if (tmpType.indexOf(tmpToken.slice(0, -1)) === 0) { return true; }   // 'image/*' -> prefix 'image/'
			}
			else if (tmpToken.indexOf('/') >= 0)
			{
				if (tmpType === tmpToken) { return true; }
			}
			else if (tmpName.endsWith(`.${tmpToken}`))
			{
				return true;
			}
		}
		return false;
	}

	/** Persist the current file handle(s) to the bound value address. */
	_writeValue()
	{
		if (!this.options.ValueAddress) { return; }
		const tmpHandles = this._fileEntries.map((pEntry) => pEntry.Handle);
		const tmpValue = this.options.Multiple ? tmpHandles : (tmpHandles[0] || null);
		this.pict.manifest.setValueAtAddress(this.pict, this.options.ValueAddress, tmpValue);
	}

	/** Abort any in-flight uploads. */
	_abortAll()
	{
		this._fileEntries.forEach((pEntry) =>
		{
			if (pEntry.AbortHandle && typeof pEntry.AbortHandle.abort === 'function') { try { pEntry.AbortHandle.abort(); } catch (pError) { /* already done */ } }
		});
	}

	// --- Public API ---

	/** Remove a file by hash (aborting any in-flight upload), rebind the value, repaint the list. */
	removeFile(pHash)
	{
		const tmpIndex = this._fileEntries.findIndex((pEntry) => pEntry.Handle.Hash === pHash);
		if (tmpIndex < 0) { return; }
		const tmpEntry = this._fileEntries[tmpIndex];
		if (tmpEntry.AbortHandle && typeof tmpEntry.AbortHandle.abort === 'function') { try { tmpEntry.AbortHandle.abort(); } catch (pError) { /* already done */ } }
		this._fileEntries.splice(tmpIndex, 1);
		this._writeValue();
		this._renderList();
		if (typeof this.options.OnRemove === 'function') { this.options.OnRemove(tmpEntry.Handle); }
	}

	/** Manually start uploads for any not-yet-uploaded files (when AutoUpload is off). */
	uploadAll()
	{
		if (!(this._target && this._target.supportsUpload)) { return; }
		this._fileEntries.forEach((pEntry) =>
		{
			if (pEntry.Handle.Status === 'pending') { this._startUpload(pEntry); }
		});
	}

	/** Remove every file (aborting in-flight uploads) and clear the bound value. */
	clear()
	{
		this._abortAll();
		this._fileEntries = [];
		this._error = null;
		this._writeValue();
		this.render();
	}

	/** @return {Array<Record<string, any>>} The current file handles (with their read methods). */
	getFiles()
	{
		return this._fileEntries.map((pEntry) => pEntry.Handle);
	}

	/** @return {any} The bound value: a single handle (single mode) or the handle array (multi). */
	getValue()
	{
		const tmpHandles = this.getFiles();
		return this.options.Multiple ? tmpHandles : (tmpHandles[0] || null);
	}
}

module.exports = PictViewUpload;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../Upload-Helpers.js":722,"pict-view":733}],728:[function(require,module,exports){
/**
* Template Expression Graph
* @author      Steven Velozo <steven@velozo.com>
* @description Directed graph of template-to-template and template-to-data dependencies.
*/

class TemplateGraph
{
	constructor()
	{
		// Nodes keyed by "type:id" (e.g., "template:MainPage", "data:AppData.User.Name")
		this.Nodes = {};

		// Edges as an array of { From, To, Type } objects
		this.Edges = [];

		// Reverse index: target → array of edge indices for getEdgesTo()
		this._ReverseIndex = {};
		// Forward index: source → array of edge indices for getEdgesFrom()
		this._ForwardIndex = {};
	}

	/**
	 * Add a node to the graph.
	 *
	 * @param {string} pType - The node type ("template", "data", "entity")
	 * @param {string} pID - The node identifier
	 *
	 * @return {string} The node key ("type:id")
	 */
	addNode(pType, pID)
	{
		let tmpKey = `${pType}:${pID}`;

		if (!(tmpKey in this.Nodes))
		{
			this.Nodes[tmpKey] = { Type: pType, ID: pID };
		}

		return tmpKey;
	}

	/**
	 * Add a directed edge to the graph.
	 *
	 * @param {string} pFromKey - The source node key ("type:id")
	 * @param {string} pToKey - The target node key ("type:id")
	 * @param {string} pEdgeType - The edge type ("renders", "reads", "reads-entity", etc.)
	 *
	 * @return {number} The edge index
	 */
	addEdge(pFromKey, pToKey, pEdgeType)
	{
		// Check for duplicate edge
		let tmpForwardEdges = this._ForwardIndex[pFromKey];
		if (tmpForwardEdges)
		{
			for (let i = 0; i < tmpForwardEdges.length; i++)
			{
				let tmpEdge = this.Edges[tmpForwardEdges[i]];
				if (tmpEdge.To === pToKey && tmpEdge.Type === pEdgeType)
				{
					return tmpForwardEdges[i];
				}
			}
		}

		let tmpIndex = this.Edges.length;
		this.Edges.push({ From: pFromKey, To: pToKey, Type: pEdgeType });

		// Update forward index
		if (!(pFromKey in this._ForwardIndex))
		{
			this._ForwardIndex[pFromKey] = [];
		}
		this._ForwardIndex[pFromKey].push(tmpIndex);

		// Update reverse index
		if (!(pToKey in this._ReverseIndex))
		{
			this._ReverseIndex[pToKey] = [];
		}
		this._ReverseIndex[pToKey].push(tmpIndex);

		return tmpIndex;
	}

	/**
	 * Get all nodes in the graph.
	 *
	 * @return {Object} Map of node key → { Type, ID }
	 */
	getNodes()
	{
		return this.Nodes;
	}

	/**
	 * Get all edges in the graph.
	 *
	 * @return {Array<Object>} Array of { From, To, Type }
	 */
	getEdges()
	{
		return this.Edges;
	}

	/**
	 * Get all outgoing edges from a node.
	 *
	 * @param {string} pNodeKey - The source node key ("type:id")
	 *
	 * @return {Array<Object>} Array of { From, To, Type }
	 */
	getEdgesFrom(pNodeKey)
	{
		let tmpIndices = this._ForwardIndex[pNodeKey];
		if (!tmpIndices)
		{
			return [];
		}

		let tmpEdges = [];
		for (let i = 0; i < tmpIndices.length; i++)
		{
			tmpEdges.push(this.Edges[tmpIndices[i]]);
		}
		return tmpEdges;
	}

	/**
	 * Get all incoming edges to a node.
	 *
	 * @param {string} pNodeKey - The target node key ("type:id")
	 *
	 * @return {Array<Object>} Array of { From, To, Type }
	 */
	getEdgesTo(pNodeKey)
	{
		let tmpIndices = this._ReverseIndex[pNodeKey];
		if (!tmpIndices)
		{
			return [];
		}

		let tmpEdges = [];
		for (let i = 0; i < tmpIndices.length; i++)
		{
			tmpEdges.push(this.Edges[tmpIndices[i]]);
		}
		return tmpEdges;
	}

	/**
	 * Export the graph as a serializable JSON object.
	 *
	 * @return {Object} { Nodes: [...], Edges: [...] }
	 */
	toJSON()
	{
		let tmpNodes = [];
		let tmpNodeKeys = Object.keys(this.Nodes);
		for (let i = 0; i < tmpNodeKeys.length; i++)
		{
			let tmpNode = this.Nodes[tmpNodeKeys[i]];
			tmpNodes.push({ Key: tmpNodeKeys[i], Type: tmpNode.Type, ID: tmpNode.ID });
		}

		return {
			Nodes: tmpNodes,
			Edges: this.Edges.slice()
		};
	}

	/**
	 * Export the graph in Graphviz DOT format.
	 *
	 * @return {string} DOT format string
	 */
	toDOT()
	{
		let tmpLines = ['digraph TemplateGraph {'];
		tmpLines.push('\trankdir=LR;');
		tmpLines.push('');

		// Node declarations with shapes by type
		let tmpNodeKeys = Object.keys(this.Nodes);
		for (let i = 0; i < tmpNodeKeys.length; i++)
		{
			let tmpNode = this.Nodes[tmpNodeKeys[i]];
			let tmpShape = 'box';
			if (tmpNode.Type === 'data')
			{
				tmpShape = 'ellipse';
			}
			else if (tmpNode.Type === 'entity')
			{
				tmpShape = 'diamond';
			}

			let tmpSafeKey = tmpNodeKeys[i].replace(/[^a-zA-Z0-9_]/g, '_');
			tmpLines.push(`\t${tmpSafeKey} [label="${tmpNode.ID}" shape=${tmpShape}];`);
		}

		tmpLines.push('');

		// Edge declarations
		for (let i = 0; i < this.Edges.length; i++)
		{
			let tmpEdge = this.Edges[i];
			let tmpFromSafe = tmpEdge.From.replace(/[^a-zA-Z0-9_]/g, '_');
			let tmpToSafe = tmpEdge.To.replace(/[^a-zA-Z0-9_]/g, '_');
			tmpLines.push(`\t${tmpFromSafe} -> ${tmpToSafe} [label="${tmpEdge.Type}"];`);
		}

		tmpLines.push('}');
		return tmpLines.join('\n');
	}

	/**
	 * Clear all nodes and edges.
	 */
	clear()
	{
		this.Nodes = {};
		this.Edges = [];
		this._ReverseIndex = {};
		this._ForwardIndex = {};
	}
}

module.exports = TemplateGraph;

},{}],729:[function(require,module,exports){
/**
* Pict Template Preprocessor
* @author      Steven Velozo <steven@velozo.com>
* @description Compiles template strings into cached segment arrays for fast-path execution,
*              and builds an expression dependency graph for visualization and analysis.
*/

const libFableServiceBase = require('fable-serviceproviderbase');
const libTemplateGraph = require('./Pict-Template-Preprocessor-Graph.js');

class PictTemplatePreprocessor extends libFableServiceBase
{
	/**
	 * @param {Object} pFable - The Fable/Pict Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictTemplatePreprocessor';

		/** @type {Map<string, Array<Object>>} */
		this.cache = new Map();

		this.graph = new libTemplateGraph();

		// Edge classifiers: map of PatternStartString → function(hash) → array of { type, nodeType, nodeID }
		this._EdgeClassifiers = {};
		this._initializeDefaultClassifiers();

		this._installWrappers();
	}

	// -- Edge Classifiers --

	/**
	 * Register default edge classifiers for built-in template expression types.
	 * @private
	 */
	_initializeDefaultClassifiers()
	{
		// Template references: {~Template:TemplateName:DataAddress~} or {~T:...~}
		let fTemplateClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpTemplateName = tmpParts[0].trim();
			if (!tmpTemplateName)
			{
				return [];
			}
			return [{ EdgeType: 'renders', NodeType: 'template', NodeID: tmpTemplateName }];
		};
		this._EdgeClassifiers['{~Template:'] = fTemplateClassifier;
		this._EdgeClassifiers['{~T:'] = fTemplateClassifier;

		// TemplateSet references
		let fTemplateSetClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpTemplateName = tmpParts[0].trim();
			if (!tmpTemplateName)
			{
				return [];
			}
			return [{ EdgeType: 'renders-set', NodeType: 'template', NodeID: tmpTemplateName }];
		};
		this._EdgeClassifiers['{~TemplateSet:'] = fTemplateSetClassifier;
		this._EdgeClassifiers['{~TS:'] = fTemplateSetClassifier;

		// TemplateIf references
		let fTemplateIfClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpTemplateName = tmpParts[0].trim();
			if (!tmpTemplateName)
			{
				return [];
			}
			let tmpEdges = [{ EdgeType: 'renders-if', NodeType: 'template', NodeID: tmpTemplateName }];
			// Also extract data addresses from comparison (third part)
			if (tmpParts.length >= 3)
			{
				let tmpComparisonParts = tmpParts[2].split('^');
				if (tmpComparisonParts.length >= 3)
				{
					tmpEdges.push({ EdgeType: 'reads', NodeType: 'data', NodeID: tmpComparisonParts[0].trim() });
					tmpEdges.push({ EdgeType: 'reads', NodeType: 'data', NodeID: tmpComparisonParts[2].trim() });
				}
			}
			return tmpEdges;
		};
		this._EdgeClassifiers['{~TemplateIf:'] = fTemplateIfClassifier;
		this._EdgeClassifiers['{~TIf:'] = fTemplateIfClassifier;

		// TemplateIfElse references
		let fTemplateIfElseClassifier = (pHash) =>
		{
			let tmpParts = pHash.split(':');
			let tmpEdges = [];
			if (tmpParts[0])
			{
				tmpEdges.push({ EdgeType: 'renders-if-else', NodeType: 'template', NodeID: tmpParts[0].trim() });
			}
			if (tmpParts.length >= 4 && tmpParts[3])
			{
				tmpEdges.push({ EdgeType: 'renders-if-else', NodeType: 'template', NodeID: tmpParts[3].trim() });
			}
			return tmpEdges;
		};
		this._EdgeClassifiers['{~TemplateIfElse:'] = fTemplateIfElseClassifier;
		this._EdgeClassifiers['{~TIfE:'] = fTemplateIfElseClassifier;

		// Data references
		let fDataClassifier = (pHash) =>
		{
			let tmpAddress = pHash.split(':')[0].trim();
			if (!tmpAddress)
			{
				return [];
			}
			return [{ EdgeType: 'reads', NodeType: 'data', NodeID: tmpAddress }];
		};
		this._EdgeClassifiers['{~Data:'] = fDataClassifier;
		this._EdgeClassifiers['{~D:'] = fDataClassifier;
		this._EdgeClassifiers['{~DataJson:'] = fDataClassifier;
		this._EdgeClassifiers['{~DJ:'] = fDataClassifier;
		this._EdgeClassifiers['{~Dollars:'] = fDataClassifier;
		this._EdgeClassifiers['{~Digits:'] = fDataClassifier;
		this._EdgeClassifiers['{~DateTimeFormat:'] = fDataClassifier;
		this._EdgeClassifiers['{~PascalCaseIdentifier:'] = fDataClassifier;
		this._EdgeClassifiers['{~LogValue:'] = fDataClassifier;
		this._EdgeClassifiers['{~LogValueTree:'] = fDataClassifier;
		this._EdgeClassifiers['{~NotEmpty:'] = fDataClassifier;

		// Entity references: {~Entity:EntityType^IDAddress^TemplateHash~}
		let fEntityClassifier = (pHash) =>
		{
			let tmpParts = pHash.split('^');
			let tmpEdges = [];
			if (tmpParts.length >= 1 && tmpParts[0])
			{
				tmpEdges.push({ EdgeType: 'reads-entity', NodeType: 'entity', NodeID: tmpParts[0].trim() });
			}
			if (tmpParts.length >= 2 && tmpParts[1])
			{
				tmpEdges.push({ EdgeType: 'reads', NodeType: 'data', NodeID: tmpParts[1].trim() });
			}
			if (tmpParts.length >= 3 && tmpParts[2])
			{
				tmpEdges.push({ EdgeType: 'renders', NodeType: 'template', NodeID: tmpParts[2].trim() });
			}
			return tmpEdges;
		};
		this._EdgeClassifiers['{~Entity:'] = fEntityClassifier;
		this._EdgeClassifiers['{~E:'] = fEntityClassifier;
	}

	/**
	 * Register a custom edge classifier for a template expression tag.
	 *
	 * @param {string} pTag - The PatternStartString (e.g., '{~MyCustom:')
	 * @param {function} fClassifier - Function(hash) returning array of { EdgeType, NodeType, NodeID }
	 */
	addEdgeClassifier(pTag, fClassifier)
	{
		this._EdgeClassifiers[pTag] = fClassifier;
	}

	// -- Compile Step --

	/**
	 * Compile a template string into a segment array using the trie parse tree.
	 * Mirrors the parseCharacter state machine from MetaTemplate-StringParser
	 * but records segments instead of executing Parse functions.
	 *
	 * @param {string} pString - The template string to compile
	 * @param {Object} pParseTree - The trie root from MetaTemplate.ParseTree
	 *
	 * @return {Array<Object>} Array of segments: { Type: 'Literal', Value } or { Type: 'Expression', Hash, Leaf, Tag }
	 */
	compile(pString, pParseTree)
	{
		let tmpSegments = [];
		let tmpLiteralBuffer = '';

		// State machine - mirrors StringParser
		let tmpPattern = {};
		let tmpPatternMatch = false;
		let tmpStartPatternMatchComplete = false;
		let tmpEndPatternMatchBegan = false;
		let tmpPatternStartNode = false;
		let tmpOutputBuffer = '';

		let fFlushLiteral = () =>
		{
			if (tmpLiteralBuffer.length > 0)
			{
				tmpSegments.push({ Type: 'Literal', Value: tmpLiteralBuffer });
				tmpLiteralBuffer = '';
			}
		};

		let fRecordExpression = () =>
		{
			// Extract the hash (content between start and end tags)
			let tmpHash = tmpOutputBuffer.substr(
				tmpPattern.PatternStartString.length,
				tmpOutputBuffer.length - (tmpPattern.PatternStartString.length + tmpPattern.PatternEndString.length));

			fFlushLiteral();
			tmpSegments.push({
				Type: 'Expression',
				Hash: tmpHash,
				Leaf: tmpPattern,
				Tag: tmpPattern.PatternStartString
			});
		};

		let fResetState = () =>
		{
			tmpPattern = {};
			tmpPatternMatch = false;
			tmpStartPatternMatchComplete = false;
			tmpEndPatternMatchBegan = false;
			tmpPatternStartNode = false;
			tmpOutputBuffer = '';
		};

		for (let i = 0; i < pString.length; i++)
		{
			let tmpChar = pString[i];

			if (tmpPatternMatch)
			{
				if (!tmpStartPatternMatchComplete && (tmpChar in tmpPattern))
				{
					// Continue matching start pattern
					tmpPattern = tmpPattern[tmpChar];
					tmpOutputBuffer += tmpChar;
				}
				else if (tmpEndPatternMatchBegan)
				{
					if (tmpChar in tmpPattern.PatternEnd)
					{
						tmpPattern = tmpPattern.PatternEnd[tmpChar];
						tmpOutputBuffer += tmpChar;

						// End pattern is complete - record the expression
						fRecordExpression();
						fResetState();
						continue;
					}
					else if (tmpChar in tmpPatternStartNode.PatternEnd)
					{
						// Broke out of end, restart end matching
						tmpPattern = tmpPatternStartNode.PatternEnd[tmpChar];
						tmpOutputBuffer += tmpChar;
					}
					else
					{
						tmpEndPatternMatchBegan = false;
						tmpOutputBuffer += tmpChar;
					}
				}
				else if ('PatternEnd' in tmpPattern)
				{
					if (!tmpStartPatternMatchComplete)
					{
						tmpStartPatternMatchComplete = true;
						tmpPatternStartNode = tmpPattern;
					}

					tmpOutputBuffer += tmpChar;

					if (tmpChar in tmpPattern.PatternEnd)
					{
						tmpEndPatternMatchBegan = true;
						tmpPattern = tmpPattern.PatternEnd[tmpChar];

						// Single-char end pattern completes immediately
						if ('Parse' in tmpPattern)
						{
							fRecordExpression();
							fResetState();
							continue;
						}
					}
				}
				else
				{
					// Start pattern didn't match; flush accumulated chars as literal and retry
					tmpLiteralBuffer += tmpOutputBuffer;
					fResetState();
				}
			}

			if (!tmpPatternMatch)
			{
				if (tmpChar in pParseTree)
				{
					// Potential start of a new pattern
					// Flush any accumulated literal from a failed match
					if (tmpOutputBuffer.length > 0)
					{
						tmpLiteralBuffer += tmpOutputBuffer;
						tmpOutputBuffer = '';
					}
					tmpOutputBuffer = tmpChar;
					tmpPattern = pParseTree[tmpChar];
					tmpPatternMatch = true;
				}
				else
				{
					tmpLiteralBuffer += tmpChar;
				}
			}
		}

		// Flush any remaining content
		if (tmpOutputBuffer.length > 0)
		{
			tmpLiteralBuffer += tmpOutputBuffer;
		}
		fFlushLiteral();

		return tmpSegments;
	}

	// -- Fast-Path Execution --

	/**
	 * Execute a compiled template synchronously.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 * @param {any} pData - The data for template rendering
	 * @param {Array<any>} pContextArray - Context array
	 * @param {any} pScope - Sticky scope
	 * @param {any} pState - State object
	 *
	 * @return {string} The rendered output
	 */
	executeCompiled(pSegments, pData, pContextArray, pScope, pState)
	{
		let tmpPreviousDataContext = (Array.isArray(pContextArray)) ? pContextArray : [];
		let tmpDataContext = Array.from(tmpPreviousDataContext);
		tmpDataContext.push(pData);

		let tmpOutput = '';

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type === 'Literal')
			{
				tmpOutput += tmpSegment.Value;
			}
			else
			{
				let tmpLeaf = tmpSegment.Leaf;
				let tmpContext = ('ParserContext' in tmpLeaf) ? tmpLeaf.ParserContext : false;
				let tmpResult;
				if (tmpContext)
				{
					tmpResult = tmpLeaf.Parse.call(tmpContext, tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
				}
				else
				{
					tmpResult = tmpLeaf.Parse(tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
				}
				// Direct concatenation matches original Pict StringParser behavior
				// (e.g., undefined → "undefined", null → "null")
				tmpOutput += tmpResult;
			}
		}

		return tmpOutput;
	}

	/**
	 * Execute a compiled template asynchronously.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 * @param {any} pData - The data for template rendering
	 * @param {function} fCallback - Callback function (pError, pOutput)
	 * @param {Array<any>} pContextArray - Context array
	 * @param {any} pScope - Sticky scope
	 * @param {any} pState - State object
	 */
	executeCompiledAsync(pSegments, pData, fCallback, pContextArray, pScope, pState)
	{
		let tmpPreviousDataContext = (Array.isArray(pContextArray)) ? pContextArray : [];
		let tmpDataContext = Array.from(tmpPreviousDataContext);
		tmpDataContext.push(pData);

		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpOutputParts = new Array(pSegments.length);

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpIndex = i;
			let tmpSegment = pSegments[tmpIndex];

			if (tmpSegment.Type === 'Literal')
			{
				tmpAnticipate.anticipate(
					(fStepCallback) =>
					{
						tmpOutputParts[tmpIndex] = tmpSegment.Value;
						return fStepCallback();
					});
			}
			else
			{
				tmpAnticipate.anticipate(
					(fStepCallback) =>
					{
						let tmpLeaf = tmpSegment.Leaf;
						let tmpContext = ('ParserContext' in tmpLeaf) ? tmpLeaf.ParserContext : false;

						if (tmpLeaf.isAsync)
						{
							let fAsyncParse = tmpContext ? tmpLeaf.ParseAsync.bind(tmpContext) : tmpLeaf.ParseAsync;
							fAsyncParse(tmpSegment.Hash, pData,
								(pError, pAsyncOutput) =>
								{
									if (pError)
									{
										this.log.info(`Preprocessor ERROR: Async template error parsing ${tmpSegment.Tag}: ${pError}`);
									}
									// Force string coercion to match original Pict concatenation behavior
									// (Array.join swallows undefined/null, but the original parser
									// produces "undefined"/"null" via string concatenation)
									tmpOutputParts[tmpIndex] = '' + pAsyncOutput;
									return fStepCallback();
								}, tmpDataContext, pScope, pState);
						}
						else
						{
							let tmpResult;
							if (tmpContext)
							{
								tmpResult = tmpLeaf.Parse.call(tmpContext, tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
							}
							else
							{
								tmpResult = tmpLeaf.Parse(tmpSegment.Hash, pData, tmpDataContext, pScope, pState);
							}
							// Force string coercion to match original Pict concatenation behavior
							tmpOutputParts[tmpIndex] = '' + tmpResult;
							return fStepCallback();
						}
					});
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				return fCallback(pError, tmpOutputParts.join(''));
			});
	}

	// -- Graph Population --

	/**
	 * Classify expression segments and add edges to the graph.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 * @param {string} pSourceTemplateID - The source template identifier
	 */
	classifyEdges(pSegments, pSourceTemplateID)
	{
		if (!pSourceTemplateID)
		{
			return;
		}

		let tmpSourceKey = this.graph.addNode('template', pSourceTemplateID);

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type !== 'Expression')
			{
				continue;
			}

			let tmpClassifier = this._EdgeClassifiers[tmpSegment.Tag];
			if (!tmpClassifier)
			{
				continue;
			}

			let tmpEdges = tmpClassifier(tmpSegment.Hash);
			for (let j = 0; j < tmpEdges.length; j++)
			{
				let tmpEdge = tmpEdges[j];
				let tmpTargetKey = this.graph.addNode(tmpEdge.NodeType, tmpEdge.NodeID);
				this.graph.addEdge(tmpSourceKey, tmpTargetKey, tmpEdge.EdgeType);
			}
		}
	}

	// -- Entity Prefetch --

	/**
	 * Collect entity expressions from compiled segments.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array
	 *
	 * @return {Array<{EntityType: string, IDAddress: string}>} Array of entity expression descriptors
	 */
	_collectEntityExpressions(pSegments)
	{
		let tmpPlans = [];

		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type !== 'Expression')
			{
				continue;
			}
			if (tmpSegment.Tag !== '{~E:' && tmpSegment.Tag !== '{~Entity:')
			{
				continue;
			}

			let tmpParts = tmpSegment.Hash.split('^');
			if (tmpParts.length < 2)
			{
				continue;
			}

			let tmpEntityType = tmpParts[0].trim();
			let tmpIDAddress = tmpParts[1].trim();

			if (tmpEntityType && tmpIDAddress)
			{
				tmpPlans.push({ EntityType: tmpEntityType, IDAddress: tmpIDAddress });
			}
		}

		return tmpPlans;
	}

	/**
	 * Collect entity expressions from a template and one level of referenced child templates.
	 * Compiles templates on demand if not already cached.
	 *
	 * @param {string} pTemplateString - The template string to scan
	 * @param {number} [pMaxDepth=1] - How many levels of template references to follow
	 *
	 * @return {Array<{EntityType: string, IDAddress: string}>} Array of entity expression descriptors
	 */
	_collectEntityExpressionsDeep(pTemplateString, pMaxDepth)
	{
		if (typeof pMaxDepth !== 'number')
		{
			pMaxDepth = 1;
		}

		let tmpCompiled = this.cache.get(pTemplateString);
		if (!tmpCompiled)
		{
			tmpCompiled = this.compile(pTemplateString, this.fable.MetaTemplate.ParseTree);
			this.cache.set(pTemplateString, tmpCompiled);
		}

		let tmpPlans = this._collectEntityExpressions(tmpCompiled);

		if (pMaxDepth <= 0)
		{
			return tmpPlans;
		}

		let tmpVisited = new Set();
		tmpVisited.add(pTemplateString);

		this._scanTemplateReferencesForEntities(tmpCompiled, tmpPlans, tmpVisited, pMaxDepth - 1);

		return tmpPlans;
	}

	/**
	 * Recursively scan template references in segments for entity expressions.
	 * Handles Template, TemplateIf, TemplateIfElse, and TemplateSet references.
	 *
	 * @param {Array<Object>} pSegments - The compiled segment array to scan
	 * @param {Array<Object>} pPlans - Accumulator for found entity plans
	 * @param {Set<string>} pVisited - Set of already-visited template strings to avoid cycles
	 * @param {number} pRemainingDepth - How many more levels to follow
	 * @private
	 */
	_scanTemplateReferencesForEntities(pSegments, pPlans, pVisited, pRemainingDepth)
	{
		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSegment = pSegments[i];
			if (tmpSegment.Type !== 'Expression')
			{
				continue;
			}

			let tmpTemplateNames = [];

			if (tmpSegment.Tag === '{~T:' || tmpSegment.Tag === '{~Template:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
			}
			else if (tmpSegment.Tag === '{~TIf:' || tmpSegment.Tag === '{~TemplateIf:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
			}
			else if (tmpSegment.Tag === '{~TIfE:' || tmpSegment.Tag === '{~TemplateIfElse:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
				if (tmpParts.length >= 4 && tmpParts[3])
				{
					tmpTemplateNames.push(tmpParts[3].trim());
				}
			}
			else if (tmpSegment.Tag === '{~TS:' || tmpSegment.Tag === '{~TemplateSet:')
			{
				let tmpParts = tmpSegment.Hash.split(':');
				if (tmpParts[0])
				{
					tmpTemplateNames.push(tmpParts[0].trim());
				}
			}

			for (let j = 0; j < tmpTemplateNames.length; j++)
			{
				let tmpTemplateName = tmpTemplateNames[j];
				let tmpChildTemplateString = this.fable.TemplateProvider.getTemplate(tmpTemplateName);

				if (!tmpChildTemplateString || pVisited.has(tmpChildTemplateString))
				{
					continue;
				}

				pVisited.add(tmpChildTemplateString);

				let tmpChildCompiled = this.cache.get(tmpChildTemplateString);
				if (!tmpChildCompiled)
				{
					tmpChildCompiled = this.compile(tmpChildTemplateString, this.fable.MetaTemplate.ParseTree);
					this.cache.set(tmpChildTemplateString, tmpChildCompiled);
				}

				let tmpChildPlans = this._collectEntityExpressions(tmpChildCompiled);
				for (let k = 0; k < tmpChildPlans.length; k++)
				{
					pPlans.push(tmpChildPlans[k]);
				}

				if (pRemainingDepth > 0)
				{
					this._scanTemplateReferencesForEntities(tmpChildCompiled, pPlans, pVisited, pRemainingDepth - 1);
				}
			}
		}
	}

	/**
	 * Resolve an entity ID address against a record.
	 * Handles common address prefixes: Record., AppData., Scope., Context[N].
	 *
	 * @param {string} pAddress - The address to resolve (e.g., "Record.IDCity")
	 * @param {any} pRecord - The current data record
	 * @param {Array<any>} [pContextArray] - Context array
	 * @param {any} [pScope] - Scope object
	 * @param {any} [pState] - State object
	 *
	 * @return {any} The resolved value, or null if not resolvable
	 */
	_resolveEntityID(pAddress, pRecord, pContextArray, pScope, pState)
	{
		let tmpAddress = pAddress;
		let tmpRoot = pRecord;

		if (tmpAddress.startsWith('Record.'))
		{
			tmpAddress = tmpAddress.substring(7);
			tmpRoot = pRecord;
		}
		else if (tmpAddress.startsWith('AppData.'))
		{
			tmpAddress = tmpAddress.substring(8);
			tmpRoot = this.fable.AppData;
		}
		else if (tmpAddress.startsWith('Scope.'))
		{
			tmpAddress = tmpAddress.substring(6);
			tmpRoot = pScope;
		}
		else if (tmpAddress.startsWith('Context['))
		{
			let tmpMatch = tmpAddress.match(/^Context\[(\d+)\]\.(.+)$/);
			if (tmpMatch && Array.isArray(pContextArray) && pContextArray[parseInt(tmpMatch[1])])
			{
				tmpRoot = pContextArray[parseInt(tmpMatch[1])];
				tmpAddress = tmpMatch[2];
			}
			else
			{
				return null;
			}
		}

		if (tmpRoot == null || typeof tmpRoot !== 'object')
		{
			return null;
		}

		// Walk dot-notation path
		let tmpParts = tmpAddress.split('.');
		let tmpValue = tmpRoot;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpValue == null || typeof tmpValue !== 'object')
			{
				return null;
			}
			tmpValue = tmpValue[tmpParts[i]];
		}

		return tmpValue;
	}

	/**
	 * Extract an array of records from a dataset (handles both Array and Object datasets).
	 *
	 * @param {Array|Object} pDataSet - The dataset
	 *
	 * @return {Array} Array of records
	 */
	_getRecordsFromDataSet(pDataSet)
	{
		if (Array.isArray(pDataSet))
		{
			return pDataSet;
		}
		if (typeof pDataSet === 'object' && pDataSet !== null)
		{
			return Object.values(pDataSet);
		}
		return [];
	}

	/**
	 * Prefetch entities for a template set before iteration begins.
	 * Scans the template (and one level of child templates) for entity expressions,
	 * resolves IDs across the dataset, and batch-fetches them into the EntityProvider cache.
	 *
	 * @param {string} pTemplateString - The template string that will be iterated
	 * @param {Array|Object} pDataSet - The dataset to iterate
	 * @param {function} fCallback - Called when prefetch is complete (pError)
	 * @param {Array<any>} [pContextArray] - Context array
	 * @param {any} [pScope] - Scope object
	 * @param {any} [pState] - State object
	 */
	prefetchEntitiesForSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
	{
		// Guard: EntityProvider must exist
		if (!this.fable.EntityProvider)
		{
			return fCallback();
		}

		// Guard: template string and dataset must be valid
		if (typeof pTemplateString !== 'string' || pTemplateString.length < 1)
		{
			return fCallback();
		}
		if (!pDataSet || (typeof pDataSet !== 'object'))
		{
			return fCallback();
		}

		// Collect entity expressions from the template + one level deep
		let tmpEntityPlans = this._collectEntityExpressionsDeep(pTemplateString, 1);

		if (tmpEntityPlans.length < 1)
		{
			return fCallback();
		}

		// Gather unique IDs per entity type across the dataset
		let tmpRecords = this._getRecordsFromDataSet(pDataSet);
		let tmpEntityBatches = {};  // EntityType → Set of IDs

		for (let i = 0; i < tmpEntityPlans.length; i++)
		{
			let tmpPlan = tmpEntityPlans[i];

			if (!(tmpPlan.EntityType in tmpEntityBatches))
			{
				tmpEntityBatches[tmpPlan.EntityType] = new Set();
				this.fable.EntityProvider.initializeCache(tmpPlan.EntityType);
			}

			for (let j = 0; j < tmpRecords.length; j++)
			{
				let tmpID = this._resolveEntityID(tmpPlan.IDAddress, tmpRecords[j], pContextArray, pScope, pState);
				if (tmpID != null && tmpID !== '' && tmpID !== 0)
				{
					// Only add if not already in EntityProvider cache
					let tmpCached = this.fable.EntityProvider.recordCache[tmpPlan.EntityType].read(tmpID);
					if (!tmpCached)
					{
						tmpEntityBatches[tmpPlan.EntityType].add(tmpID);
					}
				}
			}
		}

		// Batch-fetch each entity type
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');
		let tmpEntityTypes = Object.keys(tmpEntityBatches);

		for (let i = 0; i < tmpEntityTypes.length; i++)
		{
			let tmpEntityType = tmpEntityTypes[i];
			let tmpIDs = tmpEntityBatches[tmpEntityType];

			if (tmpIDs.size < 1)
			{
				continue;
			}

			let tmpIDArray = Array.from(tmpIDs);

			tmpAnticipate.anticipate(
				(fNext) =>
				{
					let tmpFilter = `FBL~ID${tmpEntityType}~INN~${tmpIDArray.join(',')}`;

					this.fable.EntityProvider.getEntitySet(tmpEntityType, tmpFilter,
						(pError, pEntitySet) =>
						{
							if (pError)
							{
								this.log.warn(`Preprocessor: Entity prefetch error for [${tmpEntityType}]: ${pError}`);
							}
							// getEntitySet auto-caches via cacheIndividualEntityRecords
							return fNext();
						});
				});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				return fCallback(pError);
			});
	}

	// -- Wrapper Installation --

	/**
	 * Install preprocessor wrappers around parseTemplate methods on the Pict instance.
	 * Follows the same pattern as Pict-Template-Audit._installWrappers().
	 * @private
	 */
	_installWrappers()
	{
		let tmpPict = this.fable;
		let tmpPreprocessor = this;

		// Save reference to original methods
		this._originalParseTemplate = tmpPict.parseTemplate.bind(tmpPict);
		this._originalParseTemplateByHash = tmpPict.parseTemplateByHash.bind(tmpPict);

		// -- parseTemplate wrapper (the hot path) --
		tmpPict.parseTemplate = function _preprocessorParseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState)
		{
			if (typeof(pTemplateString) !== 'string' || pTemplateString.length < 1)
			{
				if (typeof(fCallback) === 'function')
				{
					return fCallback(null, '');
				}
				return '';
			}

			let tmpCompiled = tmpPreprocessor.cache.get(pTemplateString);
			if (!tmpCompiled)
			{
				tmpCompiled = tmpPreprocessor.compile(pTemplateString, tmpPict.MetaTemplate.ParseTree);
				tmpPreprocessor.cache.set(pTemplateString, tmpCompiled);

				// Extract graph edges if we know the source template
				let tmpSourceTemplate = (pState && pState._PreprocessorSourceTemplate) ? pState._PreprocessorSourceTemplate : null;
				tmpPreprocessor.classifyEdges(tmpCompiled, tmpSourceTemplate);
			}

			if (typeof(fCallback) === 'function')
			{
				return tmpPreprocessor.executeCompiledAsync(tmpCompiled, pData, fCallback, pContextArray, pScope, pState);
			}
			return tmpPreprocessor.executeCompiled(tmpCompiled, pData, pContextArray, pScope, pState);
		};

		// -- parseTemplateByHash wrapper (sets source node hint for graph) --
		tmpPict.parseTemplateByHash = function _preprocessorParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState)
		{
			let tmpTemplateString = tmpPict.TemplateProvider.getTemplate(pTemplateHash);
			if (!tmpTemplateString)
			{
				tmpTemplateString = '';
			}

			if (!pState)
			{
				pState = {};
			}
			pState._PreprocessorSourceTemplate = pTemplateHash;

			return tmpPict.parseTemplate(tmpTemplateString, pData, fCallback, pContextArray, pScope, pState);
		};

		// -- parseTemplateSet wrapper (prefetch entities before iteration) --
		this._originalParseTemplateSet = tmpPict.parseTemplateSet.bind(tmpPict);

		tmpPict.parseTemplateSet = function _preprocessorParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			// Sync path cannot do async prefetch — fall through to original
			if (typeof(fCallback) !== 'function')
			{
				return tmpPreprocessor._originalParseTemplateSet(pTemplateString, pDataSet, null, pContextArray, pScope, pState);
			}

			// Async path: prefetch entities, then proceed with normal iteration
			tmpPreprocessor.prefetchEntitiesForSet(pTemplateString, pDataSet,
				(pPrefetchError) =>
				{
					if (pPrefetchError)
					{
						tmpPreprocessor.log.warn(`Preprocessor: Entity prefetch error during template set: ${pPrefetchError}`);
					}
					return tmpPreprocessor._originalParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState);
				}, pContextArray, pScope, pState);
		};

		// -- parseTemplateSetByHash wrapper (sets source template + prefetch) --
		this._originalParseTemplateSetByHash = tmpPict.parseTemplateSetByHash.bind(tmpPict);

		tmpPict.parseTemplateSetByHash = function _preprocessorParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			let tmpTemplateString = tmpPict.TemplateProvider.getTemplate(pTemplateHash);
			if (!tmpTemplateString)
			{
				tmpTemplateString = '';
			}

			if (!pState)
			{
				pState = {};
			}
			pState._PreprocessorSourceTemplate = pTemplateHash;

			return tmpPict.parseTemplateSet(tmpTemplateString, pDataSet, fCallback, pContextArray, pScope, pState);
		};
	}

	/**
	 * Remove preprocessor wrappers and restore original methods.
	 */
	unwrapTemplateFunctions()
	{
		let tmpPict = this.fable;

		if (this._originalParseTemplate && typeof(this._originalParseTemplate) === 'function')
		{
			tmpPict.parseTemplate = this._originalParseTemplate;
			this._originalParseTemplate = null;
		}

		if (this._originalParseTemplateByHash && typeof(this._originalParseTemplateByHash) === 'function')
		{
			tmpPict.parseTemplateByHash = this._originalParseTemplateByHash;
			this._originalParseTemplateByHash = null;
		}

		if (this._originalParseTemplateSet && typeof(this._originalParseTemplateSet) === 'function')
		{
			tmpPict.parseTemplateSet = this._originalParseTemplateSet;
			this._originalParseTemplateSet = null;
		}

		if (this._originalParseTemplateSetByHash && typeof(this._originalParseTemplateSetByHash) === 'function')
		{
			tmpPict.parseTemplateSetByHash = this._originalParseTemplateSetByHash;
			this._originalParseTemplateSetByHash = null;
		}
	}

	/**
	 * Clear the compiled template cache.
	 */
	clearCache()
	{
		this.cache.clear();
	}

	/**
	 * Clear everything — cache and graph.
	 */
	clear()
	{
		this.cache.clear();
		this.graph.clear();
	}
}

module.exports = PictTemplatePreprocessor;

/** @type {Record<string, any>} */
PictTemplatePreprocessor.default_configuration = {};

},{"./Pict-Template-Preprocessor-Graph.js":728,"fable-serviceproviderbase":438}],730:[function(require,module,exports){
module.exports={
    "name": "pict-template",
    "version": "1.0.15",
    "description": "Pict Template Base Class",
    "main": "source/Pict-Template.js",
    "scripts": {
        "start": "node source/Pict-Template.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Template.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "pict": "^1.0.348",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],731:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":730,"fable-serviceproviderbase":438}],732:[function(require,module,exports){
module.exports={
    "name": "pict-view",
    "version": "1.0.68",
    "description": "Pict View Base Class",
    "main": "source/Pict-View.js",
    "scripts": {
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "start": "node source/Pict-View.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
        "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
        "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
        "types": "tsc -p .",
        "lint": "eslint source/**"
    },
    "types": "types/source/Pict-View.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.1",
        "pict": "^1.0.363",
        "quackage": "^1.0.65",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable": "^3.1.67",
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],733:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":732,"fable-serviceproviderbase":438}],734:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = [
	'Float16Array',
	'Float32Array',
	'Float64Array',
	'Int8Array',
	'Int16Array',
	'Int32Array',
	'Uint8Array',
	'Uint8ClampedArray',
	'Uint16Array',
	'Uint32Array',
	'BigInt64Array',
	'BigUint64Array'
];

},{}],735:[function(require,module,exports){
(function (process){(function (){
'use strict';

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this)}).call(this,require('_process'))

},{"_process":736}],736:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],737:[function(require,module,exports){
exports.publicEncrypt = require('./publicEncrypt')
exports.privateDecrypt = require('./privateDecrypt')

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}

},{"./privateDecrypt":740,"./publicEncrypt":741}],738:[function(require,module,exports){
var createHash = require('create-hash')
var Buffer = require('safe-buffer').Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}

},{"create-hash":389,"safe-buffer":788}],739:[function(require,module,exports){
arguments[4][325][0].apply(exports,arguments)
},{"buffer":335,"dup":325}],740:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var crt = require('browserify-rsa')
var createHash = require('create-hash')
var withPublic = require('./withPublic')
var Buffer = require('safe-buffer').Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}

},{"./mgf":738,"./withPublic":742,"./xor":743,"bn.js":739,"browserify-rsa":356,"create-hash":389,"parse-asn1":536,"safe-buffer":788}],741:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var randomBytes = require('randombytes')
var createHash = require('create-hash')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var withPublic = require('./withPublic')
var crt = require('browserify-rsa')
var Buffer = require('safe-buffer').Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}

},{"./mgf":738,"./withPublic":742,"./xor":743,"bn.js":739,"browserify-rsa":356,"create-hash":389,"parse-asn1":536,"randombytes":771,"safe-buffer":788}],742:[function(require,module,exports){
var BN = require('bn.js')
var Buffer = require('safe-buffer').Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic

},{"bn.js":739,"safe-buffer":788}],743:[function(require,module,exports){
module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}

},{}],744:[function(require,module,exports){

const canPromise = require('./can-promise')

const QRCode = require('./core/qrcode')
const CanvasRenderer = require('./renderer/canvas')
const SvgRenderer = require('./renderer/svg-tag.js')

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})

},{"./can-promise":745,"./core/qrcode":761,"./renderer/canvas":768,"./renderer/svg-tag.js":769}],745:[function(require,module,exports){
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}

},{}],746:[function(require,module,exports){
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = require('./utils').getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}

},{"./utils":765}],747:[function(require,module,exports){
const Mode = require('./mode')

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData

},{"./mode":758}],748:[function(require,module,exports){
function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer

},{}],749:[function(require,module,exports){
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix

},{}],750:[function(require,module,exports){
const Mode = require('./mode')

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    this.data = new TextEncoder().encode(data)
  } else {
    this.data = new Uint8Array(data)
  }
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData

},{"./mode":758}],751:[function(require,module,exports){
const ECLevel = require('./error-correction-level')

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

},{"./error-correction-level":752}],752:[function(require,module,exports){
exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{}],753:[function(require,module,exports){
const getSymbolSize = require('./utils').getSymbolSize
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}

},{"./utils":765}],754:[function(require,module,exports){
const Utils = require('./utils')

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}

},{"./utils":765}],755:[function(require,module,exports){
const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}

},{}],756:[function(require,module,exports){
const Mode = require('./mode')
const Utils = require('./utils')

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData

},{"./mode":758,"./utils":765}],757:[function(require,module,exports){
/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}

},{}],758:[function(require,module,exports){
const VersionCheck = require('./version-check')
const Regex = require('./regex')

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{"./regex":763,"./version-check":766}],759:[function(require,module,exports){
const Mode = require('./mode')

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData

},{"./mode":758}],760:[function(require,module,exports){
const GF = require('./galois-field')

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}

},{"./galois-field":755}],761:[function(require,module,exports){
const Utils = require('./utils')
const ECLevel = require('./error-correction-level')
const BitBuffer = require('./bit-buffer')
const BitMatrix = require('./bit-matrix')
const AlignmentPattern = require('./alignment-pattern')
const FinderPattern = require('./finder-pattern')
const MaskPattern = require('./mask-pattern')
const ECCode = require('./error-correction-code')
const ReedSolomonEncoder = require('./reed-solomon-encoder')
const Version = require('./version')
const FormatInfo = require('./format-info')
const Mode = require('./mode')
const Segments = require('./segments')

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}

},{"./alignment-pattern":746,"./bit-buffer":748,"./bit-matrix":749,"./error-correction-code":751,"./error-correction-level":752,"./finder-pattern":753,"./format-info":754,"./mask-pattern":757,"./mode":758,"./reed-solomon-encoder":762,"./segments":764,"./utils":765,"./version":767}],762:[function(require,module,exports){
const Polynomial = require('./polynomial')

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder

},{"./polynomial":760}],763:[function(require,module,exports){
const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}

},{}],764:[function(require,module,exports){
const Mode = require('./mode')
const NumericData = require('./numeric-data')
const AlphanumericData = require('./alphanumeric-data')
const ByteData = require('./byte-data')
const KanjiData = require('./kanji-data')
const Regex = require('./regex')
const Utils = require('./utils')
const dijkstra = require('dijkstrajs')

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}

},{"./alphanumeric-data":747,"./byte-data":750,"./kanji-data":756,"./mode":758,"./numeric-data":759,"./regex":763,"./utils":765,"dijkstrajs":407}],765:[function(require,module,exports){
let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}

},{}],766:[function(require,module,exports){
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}

},{}],767:[function(require,module,exports){
const Utils = require('./utils')
const ECCode = require('./error-correction-code')
const ECLevel = require('./error-correction-level')
const Mode = require('./mode')
const VersionCheck = require('./version-check')

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}

},{"./error-correction-code":751,"./error-correction-level":752,"./mode":758,"./utils":765,"./version-check":766}],768:[function(require,module,exports){
const Utils = require('./utils')

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}

},{"./utils":770}],769:[function(require,module,exports){
const Utils = require('./utils')

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}

},{"./utils":770}],770:[function(require,module,exports){
function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}

},{}],771:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = require('safe-buffer').Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":736,"safe-buffer":788}],772:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = require('safe-buffer')
var randombytes = require('randombytes')
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":736,"randombytes":771,"safe-buffer":788}],773:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};
},{"./_stream_readable":775,"./_stream_writable":777,"core-util-is":386,"inherits":495,"process-nextick-args":735}],774:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":776,"core-util-is":386,"inherits":495}],775:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./_stream_duplex":773,"./internal/streams/BufferList":778,"./internal/streams/destroy":779,"./internal/streams/stream":780,"_process":736,"core-util-is":386,"events":435,"inherits":495,"isarray":781,"process-nextick-args":735,"safe-buffer":782,"string_decoder/":783,"util":335}],776:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":773,"core-util-is":386,"inherits":495}],777:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"./_stream_duplex":773,"./internal/streams/destroy":779,"./internal/streams/stream":780,"_process":736,"core-util-is":386,"inherits":495,"process-nextick-args":735,"safe-buffer":782,"timers":815,"util-deprecate":818}],778:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = require('safe-buffer').Buffer;
var util = require('util');

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
},{"safe-buffer":782,"util":335}],779:[function(require,module,exports){
'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};
},{"process-nextick-args":735}],780:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":435}],781:[function(require,module,exports){
arguments[4][501][0].apply(exports,arguments)
},{"dup":501}],782:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":364}],783:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":782}],784:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":773,"./lib/_stream_passthrough.js":774,"./lib/_stream_readable.js":775,"./lib/_stream_transform.js":776,"./lib/_stream_writable.js":777}],785:[function(require,module,exports){
'use strict';

var Buffer = require('buffer').Buffer;
var inherits = require('inherits');
var HashBase = require('hash-base');

var ARRAY16 = new Array(16);

var zl = [
	0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var zr = [
	5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var sl = [
	11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sr = [
	8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

function rotl(x, n) {
	return (x << n) | (x >>> (32 - n));
}

function fn1(a, b, c, d, e, m, k, s) {
	return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0;
}

function fn2(a, b, c, d, e, m, k, s) {
	return (rotl((a + ((b & c) | (~b & d)) + m + k) | 0, s) + e) | 0;
}

function fn3(a, b, c, d, e, m, k, s) {
	return (rotl((a + ((b | ~c) ^ d) + m + k) | 0, s) + e) | 0;
}

function fn4(a, b, c, d, e, m, k, s) {
	return (rotl((a + ((b & d) | (c & ~d)) + m + k) | 0, s) + e) | 0;
}

function fn5(a, b, c, d, e, m, k, s) {
	return (rotl((a + (b ^ (c | ~d)) + m + k) | 0, s) + e) | 0;
}

function RIPEMD160() {
	HashBase.call(this, 64);

	// state
	this._a = 0x67452301;
	this._b = 0xefcdab89;
	this._c = 0x98badcfe;
	this._d = 0x10325476;
	this._e = 0xc3d2e1f0;
}

inherits(RIPEMD160, HashBase);

RIPEMD160.prototype._update = function () {
	var words = ARRAY16;
	for (var j = 0; j < 16; ++j) {
		words[j] = this._block.readInt32LE(j * 4);
	}

	var al = this._a | 0;
	var bl = this._b | 0;
	var cl = this._c | 0;
	var dl = this._d | 0;
	var el = this._e | 0;

	var ar = this._a | 0;
	var br = this._b | 0;
	var cr = this._c | 0;
	var dr = this._d | 0;
	var er = this._e | 0;

	// computation
	for (var i = 0; i < 80; i += 1) {
		var tl;
		var tr;
		if (i < 16) {
			tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
			tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
		} else if (i < 32) {
			tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
			tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
		} else if (i < 48) {
			tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
			tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
		} else if (i < 64) {
			tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
			tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
		} else { // if (i<80) {
			tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
			tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
		}

		al = el;
		el = dl;
		dl = rotl(cl, 10);
		cl = bl;
		bl = tl;

		ar = er;
		er = dr;
		dr = rotl(cr, 10);
		cr = br;
		br = tr;
	}

	// update state
	var t = (this._b + cl + dr) | 0;
	this._b = (this._c + dl + er) | 0;
	this._c = (this._d + el + ar) | 0;
	this._d = (this._e + al + br) | 0;
	this._e = (this._a + bl + cr) | 0;
	this._a = t;
};

RIPEMD160.prototype._digest = function () {
	// create padding and handle blocks
	this._block[this._blockOffset] = 0x80;
	this._blockOffset += 1;
	if (this._blockOffset > 56) {
		this._block.fill(0, this._blockOffset, 64);
		this._update();
		this._blockOffset = 0;
	}

	this._block.fill(0, this._blockOffset, 56);
	this._block.writeUInt32LE(this._length[0], 56);
	this._block.writeUInt32LE(this._length[1], 60);
	this._update();

	// produce result
	var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20); // eslint-disable-line no-buffer-constructor
	buffer.writeInt32LE(this._a, 0);
	buffer.writeInt32LE(this._b, 4);
	buffer.writeInt32LE(this._c, 8);
	buffer.writeInt32LE(this._d, 12);
	buffer.writeInt32LE(this._e, 16);
	return buffer;
};

module.exports = RIPEMD160;

},{"buffer":364,"hash-base":786,"inherits":495}],786:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('./to-buffer');
var Transform = require('readable-stream').Transform;
var inherits = require('inherits');

function HashBase(blockSize) {
	Transform.call(this);

	this._block = Buffer.allocUnsafe(blockSize);
	this._blockSize = blockSize;
	this._blockOffset = 0;
	this._length = [0, 0, 0, 0];

	this._finalized = false;
}

inherits(HashBase, Transform);

HashBase.prototype._transform = function (chunk, encoding, callback) {
	var error = null;
	try {
		this.update(chunk, encoding);
	} catch (err) {
		error = err;
	}

	callback(error);
};

HashBase.prototype._flush = function (callback) {
	var error = null;
	try {
		this.push(this.digest());
	} catch (err) {
		error = err;
	}

	callback(error);
};

HashBase.prototype.update = function (data, encoding) {
	if (this._finalized) {
		throw new Error('Digest already called');
	}

	var dataBuffer = toBuffer(data, encoding); // asserts correct input type

	// consume data
	var block = this._block;
	var offset = 0;
	while (this._blockOffset + dataBuffer.length - offset >= this._blockSize) {
		for (var i = this._blockOffset; i < this._blockSize;) {
			block[i] = dataBuffer[offset];
			i += 1;
			offset += 1;
		}
		this._update();
		this._blockOffset = 0;
	}
	while (offset < dataBuffer.length) {
		block[this._blockOffset] = dataBuffer[offset];
		this._blockOffset += 1;
		offset += 1;
	}

	// update length
	for (var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j) {
		this._length[j] += carry;
		carry = (this._length[j] / 0x0100000000) | 0;
		if (carry > 0) {
			this._length[j] -= 0x0100000000 * carry;
		}
	}

	return this;
};

HashBase.prototype._update = function () {
	throw new Error('_update is not implemented');
};

HashBase.prototype.digest = function (encoding) {
	if (this._finalized) {
		throw new Error('Digest already called');
	}
	this._finalized = true;

	var digest = this._digest();
	if (encoding !== undefined) {
		digest = digest.toString(encoding);
	}

	// reset state
	this._block.fill(0);
	this._blockOffset = 0;
	for (var i = 0; i < 4; ++i) {
		this._length[i] = 0;
	}

	return digest;
};

HashBase.prototype._digest = function () {
	throw new Error('_digest is not implemented');
};

module.exports = HashBase;

},{"./to-buffer":787,"inherits":495,"readable-stream":784,"safe-buffer":788}],787:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('to-buffer');

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = useUint8Array && typeof ArrayBuffer !== 'undefined';
var isView = useArrayBuffer && ArrayBuffer.isView;

module.exports = function (thing, encoding) {
	if (
		typeof thing === 'string'
    || Buffer.isBuffer(thing)
    || (useUint8Array && thing instanceof Uint8Array)
    || (isView && isView(thing))
	) {
		return toBuffer(thing, encoding);
	}
	throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

},{"safe-buffer":788,"to-buffer":816}],788:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":364}],789:[function(require,module,exports){
'use strict';

var callBound = require('call-bound');
var isRegex = require('is-regex');

var $exec = callBound('RegExp.prototype.exec');
var $TypeError = require('es-errors/type');

/** @type {import('.')} */
module.exports = function regexTester(regex) {
	if (!isRegex(regex)) {
		throw new $TypeError('`regex` must be a RegExp');
	}
	return function test(s) {
		return $exec(regex, s) !== null;
	};
};

},{"call-bound":373,"es-errors/type":432,"is-regex":499}],790:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var define = require('define-data-property');
var hasDescriptors = require('has-property-descriptors')();
var gOPD = require('gopd');

var $TypeError = require('es-errors/type');
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};

},{"define-data-property":395,"es-errors/type":432,"get-intrinsic":443,"gopd":448,"has-property-descriptors":449}],791:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var toBuffer = require('to-buffer');

// prototype class for hash functions
function Hash(blockSize, finalSize) {
	this._block = Buffer.alloc(blockSize);
	this._finalSize = finalSize;
	this._blockSize = blockSize;
	this._len = 0;
}

Hash.prototype.update = function (data, enc) {
	/* eslint no-param-reassign: 0 */
	data = toBuffer(data, enc || 'utf8');

	var block = this._block;
	var blockSize = this._blockSize;
	var length = data.length;
	var accum = this._len;

	for (var offset = 0; offset < length;) {
		var assigned = accum % blockSize;
		var remainder = Math.min(length - offset, blockSize - assigned);

		for (var i = 0; i < remainder; i++) {
			block[assigned + i] = data[offset + i];
		}

		accum += remainder;
		offset += remainder;

		if ((accum % blockSize) === 0) {
			this._update(block);
		}
	}

	this._len += length;
	return this;
};

Hash.prototype.digest = function (enc) {
	var rem = this._len % this._blockSize;

	this._block[rem] = 0x80;

	/*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */
	this._block.fill(0, rem + 1);

	if (rem >= this._finalSize) {
		this._update(this._block);
		this._block.fill(0);
	}

	var bits = this._len * 8;

	// uint32
	if (bits <= 0xffffffff) {
		this._block.writeUInt32BE(bits, this._blockSize - 4);

		// uint64
	} else {
		var lowBits = (bits & 0xffffffff) >>> 0;
		var highBits = (bits - lowBits) / 0x100000000;

		this._block.writeUInt32BE(highBits, this._blockSize - 8);
		this._block.writeUInt32BE(lowBits, this._blockSize - 4);
	}

	this._update(this._block);
	var hash = this._hash();

	return enc ? hash.toString(enc) : hash;
};

Hash.prototype._update = function () {
	throw new Error('_update must be implemented by subclass');
};

module.exports = Hash;

},{"safe-buffer":788,"to-buffer":816}],792:[function(require,module,exports){
'use strict';

module.exports = function SHA(algorithm) {
	var alg = algorithm.toLowerCase();

	var Algorithm = module.exports[alg];
	if (!Algorithm) {
		throw new Error(alg + ' is not supported (we accept pull requests)');
	}

	return new Algorithm();
};

module.exports.sha = require('./sha');
module.exports.sha1 = require('./sha1');
module.exports.sha224 = require('./sha224');
module.exports.sha256 = require('./sha256');
module.exports.sha384 = require('./sha384');
module.exports.sha512 = require('./sha512');

},{"./sha":793,"./sha1":794,"./sha224":795,"./sha256":796,"./sha384":797,"./sha512":798}],793:[function(require,module,exports){
'use strict';

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
];

var W = new Array(80);

function Sha() {
	this.init();
	this._w = W;

	Hash.call(this, 64, 56);
}

inherits(Sha, Hash);

Sha.prototype.init = function () {
	this._a = 0x67452301;
	this._b = 0xefcdab89;
	this._c = 0x98badcfe;
	this._d = 0x10325476;
	this._e = 0xc3d2e1f0;

	return this;
};

function rotl5(num) {
	return (num << 5) | (num >>> 27);
}

function rotl30(num) {
	return (num << 30) | (num >>> 2);
}

function ft(s, b, c, d) {
	if (s === 0) {
		return (b & c) | (~b & d);
	}
	if (s === 2) {
		return (b & c) | (b & d) | (c & d);
	}
	return b ^ c ^ d;
}

Sha.prototype._update = function (M) {
	var w = this._w;

	var a = this._a | 0;
	var b = this._b | 0;
	var c = this._c | 0;
	var d = this._d | 0;
	var e = this._e | 0;

	for (var i = 0; i < 16; ++i) {
		w[i] = M.readInt32BE(i * 4);
	}
	for (; i < 80; ++i) {
		w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
	}

	for (var j = 0; j < 80; ++j) {
		var s = ~~(j / 20);
		var t = (rotl5(a) + ft(s, b, c, d) + e + w[j] + K[s]) | 0;

		e = d;
		d = c;
		c = rotl30(b);
		b = a;
		a = t;
	}

	this._a = (a + this._a) | 0;
	this._b = (b + this._b) | 0;
	this._c = (c + this._c) | 0;
	this._d = (d + this._d) | 0;
	this._e = (e + this._e) | 0;
};

Sha.prototype._hash = function () {
	var H = Buffer.allocUnsafe(20);

	H.writeInt32BE(this._a | 0, 0);
	H.writeInt32BE(this._b | 0, 4);
	H.writeInt32BE(this._c | 0, 8);
	H.writeInt32BE(this._d | 0, 12);
	H.writeInt32BE(this._e | 0, 16);

	return H;
};

module.exports = Sha;

},{"./hash":791,"inherits":495,"safe-buffer":788}],794:[function(require,module,exports){
'use strict';

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
];

var W = new Array(80);

function Sha1() {
	this.init();
	this._w = W;

	Hash.call(this, 64, 56);
}

inherits(Sha1, Hash);

Sha1.prototype.init = function () {
	this._a = 0x67452301;
	this._b = 0xefcdab89;
	this._c = 0x98badcfe;
	this._d = 0x10325476;
	this._e = 0xc3d2e1f0;

	return this;
};

function rotl1(num) {
	return (num << 1) | (num >>> 31);
}

function rotl5(num) {
	return (num << 5) | (num >>> 27);
}

function rotl30(num) {
	return (num << 30) | (num >>> 2);
}

function ft(s, b, c, d) {
	if (s === 0) {
		return (b & c) | (~b & d);
	}
	if (s === 2) {
		return (b & c) | (b & d) | (c & d);
	}
	return b ^ c ^ d;
}

Sha1.prototype._update = function (M) {
	var w = this._w;

	var a = this._a | 0;
	var b = this._b | 0;
	var c = this._c | 0;
	var d = this._d | 0;
	var e = this._e | 0;

	for (var i = 0; i < 16; ++i) {
		w[i] = M.readInt32BE(i * 4);
	}
	for (; i < 80; ++i) {
		w[i] = rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
	}

	for (var j = 0; j < 80; ++j) {
		var s = ~~(j / 20);
		var t = (rotl5(a) + ft(s, b, c, d) + e + w[j] + K[s]) | 0;

		e = d;
		d = c;
		c = rotl30(b);
		b = a;
		a = t;
	}

	this._a = (a + this._a) | 0;
	this._b = (b + this._b) | 0;
	this._c = (c + this._c) | 0;
	this._d = (d + this._d) | 0;
	this._e = (e + this._e) | 0;
};

Sha1.prototype._hash = function () {
	var H = Buffer.allocUnsafe(20);

	H.writeInt32BE(this._a | 0, 0);
	H.writeInt32BE(this._b | 0, 4);
	H.writeInt32BE(this._c | 0, 8);
	H.writeInt32BE(this._d | 0, 12);
	H.writeInt32BE(this._e | 0, 16);

	return H;
};

module.exports = Sha1;

},{"./hash":791,"inherits":495,"safe-buffer":788}],795:[function(require,module,exports){
'use strict';

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits');
var Sha256 = require('./sha256');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var W = new Array(64);

function Sha224() {
	this.init();

	this._w = W; // new Array(64)

	Hash.call(this, 64, 56);
}

inherits(Sha224, Sha256);

Sha224.prototype.init = function () {
	this._a = 0xc1059ed8;
	this._b = 0x367cd507;
	this._c = 0x3070dd17;
	this._d = 0xf70e5939;
	this._e = 0xffc00b31;
	this._f = 0x68581511;
	this._g = 0x64f98fa7;
	this._h = 0xbefa4fa4;

	return this;
};

Sha224.prototype._hash = function () {
	var H = Buffer.allocUnsafe(28);

	H.writeInt32BE(this._a, 0);
	H.writeInt32BE(this._b, 4);
	H.writeInt32BE(this._c, 8);
	H.writeInt32BE(this._d, 12);
	H.writeInt32BE(this._e, 16);
	H.writeInt32BE(this._f, 20);
	H.writeInt32BE(this._g, 24);

	return H;
};

module.exports = Sha224;

},{"./hash":791,"./sha256":796,"inherits":495,"safe-buffer":788}],796:[function(require,module,exports){
'use strict';

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x428A2F98,
	0x71374491,
	0xB5C0FBCF,
	0xE9B5DBA5,
	0x3956C25B,
	0x59F111F1,
	0x923F82A4,
	0xAB1C5ED5,
	0xD807AA98,
	0x12835B01,
	0x243185BE,
	0x550C7DC3,
	0x72BE5D74,
	0x80DEB1FE,
	0x9BDC06A7,
	0xC19BF174,
	0xE49B69C1,
	0xEFBE4786,
	0x0FC19DC6,
	0x240CA1CC,
	0x2DE92C6F,
	0x4A7484AA,
	0x5CB0A9DC,
	0x76F988DA,
	0x983E5152,
	0xA831C66D,
	0xB00327C8,
	0xBF597FC7,
	0xC6E00BF3,
	0xD5A79147,
	0x06CA6351,
	0x14292967,
	0x27B70A85,
	0x2E1B2138,
	0x4D2C6DFC,
	0x53380D13,
	0x650A7354,
	0x766A0ABB,
	0x81C2C92E,
	0x92722C85,
	0xA2BFE8A1,
	0xA81A664B,
	0xC24B8B70,
	0xC76C51A3,
	0xD192E819,
	0xD6990624,
	0xF40E3585,
	0x106AA070,
	0x19A4C116,
	0x1E376C08,
	0x2748774C,
	0x34B0BCB5,
	0x391C0CB3,
	0x4ED8AA4A,
	0x5B9CCA4F,
	0x682E6FF3,
	0x748F82EE,
	0x78A5636F,
	0x84C87814,
	0x8CC70208,
	0x90BEFFFA,
	0xA4506CEB,
	0xBEF9A3F7,
	0xC67178F2
];

var W = new Array(64);

function Sha256() {
	this.init();

	this._w = W; // new Array(64)

	Hash.call(this, 64, 56);
}

inherits(Sha256, Hash);

Sha256.prototype.init = function () {
	this._a = 0x6a09e667;
	this._b = 0xbb67ae85;
	this._c = 0x3c6ef372;
	this._d = 0xa54ff53a;
	this._e = 0x510e527f;
	this._f = 0x9b05688c;
	this._g = 0x1f83d9ab;
	this._h = 0x5be0cd19;

	return this;
};

function ch(x, y, z) {
	return z ^ (x & (y ^ z));
}

function maj(x, y, z) {
	return (x & y) | (z & (x | y));
}

function sigma0(x) {
	return ((x >>> 2) | (x << 30)) ^ ((x >>> 13) | (x << 19)) ^ ((x >>> 22) | (x << 10));
}

function sigma1(x) {
	return ((x >>> 6) | (x << 26)) ^ ((x >>> 11) | (x << 21)) ^ ((x >>> 25) | (x << 7));
}

function gamma0(x) {
	return ((x >>> 7) | (x << 25)) ^ ((x >>> 18) | (x << 14)) ^ (x >>> 3);
}

function gamma1(x) {
	return ((x >>> 17) | (x << 15)) ^ ((x >>> 19) | (x << 13)) ^ (x >>> 10);
}

Sha256.prototype._update = function (M) {
	var w = this._w;

	var a = this._a | 0;
	var b = this._b | 0;
	var c = this._c | 0;
	var d = this._d | 0;
	var e = this._e | 0;
	var f = this._f | 0;
	var g = this._g | 0;
	var h = this._h | 0;

	for (var i = 0; i < 16; ++i) {
		w[i] = M.readInt32BE(i * 4);
	}
	for (; i < 64; ++i) {
		w[i] = (gamma1(w[i - 2]) + w[i - 7] + gamma0(w[i - 15]) + w[i - 16]) | 0;
	}

	for (var j = 0; j < 64; ++j) {
		var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + w[j]) | 0;
		var T2 = (sigma0(a) + maj(a, b, c)) | 0;

		h = g;
		g = f;
		f = e;
		e = (d + T1) | 0;
		d = c;
		c = b;
		b = a;
		a = (T1 + T2) | 0;
	}

	this._a = (a + this._a) | 0;
	this._b = (b + this._b) | 0;
	this._c = (c + this._c) | 0;
	this._d = (d + this._d) | 0;
	this._e = (e + this._e) | 0;
	this._f = (f + this._f) | 0;
	this._g = (g + this._g) | 0;
	this._h = (h + this._h) | 0;
};

Sha256.prototype._hash = function () {
	var H = Buffer.allocUnsafe(32);

	H.writeInt32BE(this._a, 0);
	H.writeInt32BE(this._b, 4);
	H.writeInt32BE(this._c, 8);
	H.writeInt32BE(this._d, 12);
	H.writeInt32BE(this._e, 16);
	H.writeInt32BE(this._f, 20);
	H.writeInt32BE(this._g, 24);
	H.writeInt32BE(this._h, 28);

	return H;
};

module.exports = Sha256;

},{"./hash":791,"inherits":495,"safe-buffer":788}],797:[function(require,module,exports){
'use strict';

var inherits = require('inherits');
var SHA512 = require('./sha512');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var W = new Array(160);

function Sha384() {
	this.init();
	this._w = W;

	Hash.call(this, 128, 112);
}

inherits(Sha384, SHA512);

Sha384.prototype.init = function () {
	this._ah = 0xcbbb9d5d;
	this._bh = 0x629a292a;
	this._ch = 0x9159015a;
	this._dh = 0x152fecd8;
	this._eh = 0x67332667;
	this._fh = 0x8eb44a87;
	this._gh = 0xdb0c2e0d;
	this._hh = 0x47b5481d;

	this._al = 0xc1059ed8;
	this._bl = 0x367cd507;
	this._cl = 0x3070dd17;
	this._dl = 0xf70e5939;
	this._el = 0xffc00b31;
	this._fl = 0x68581511;
	this._gl = 0x64f98fa7;
	this._hl = 0xbefa4fa4;

	return this;
};

Sha384.prototype._hash = function () {
	var H = Buffer.allocUnsafe(48);

	function writeInt64BE(h, l, offset) {
		H.writeInt32BE(h, offset);
		H.writeInt32BE(l, offset + 4);
	}

	writeInt64BE(this._ah, this._al, 0);
	writeInt64BE(this._bh, this._bl, 8);
	writeInt64BE(this._ch, this._cl, 16);
	writeInt64BE(this._dh, this._dl, 24);
	writeInt64BE(this._eh, this._el, 32);
	writeInt64BE(this._fh, this._fl, 40);

	return H;
};

module.exports = Sha384;

},{"./hash":791,"./sha512":798,"inherits":495,"safe-buffer":788}],798:[function(require,module,exports){
'use strict';

var inherits = require('inherits');
var Hash = require('./hash');
var Buffer = require('safe-buffer').Buffer;

var K = [
	0x428a2f98,
	0xd728ae22,
	0x71374491,
	0x23ef65cd,
	0xb5c0fbcf,
	0xec4d3b2f,
	0xe9b5dba5,
	0x8189dbbc,
	0x3956c25b,
	0xf348b538,
	0x59f111f1,
	0xb605d019,
	0x923f82a4,
	0xaf194f9b,
	0xab1c5ed5,
	0xda6d8118,
	0xd807aa98,
	0xa3030242,
	0x12835b01,
	0x45706fbe,
	0x243185be,
	0x4ee4b28c,
	0x550c7dc3,
	0xd5ffb4e2,
	0x72be5d74,
	0xf27b896f,
	0x80deb1fe,
	0x3b1696b1,
	0x9bdc06a7,
	0x25c71235,
	0xc19bf174,
	0xcf692694,
	0xe49b69c1,
	0x9ef14ad2,
	0xefbe4786,
	0x384f25e3,
	0x0fc19dc6,
	0x8b8cd5b5,
	0x240ca1cc,
	0x77ac9c65,
	0x2de92c6f,
	0x592b0275,
	0x4a7484aa,
	0x6ea6e483,
	0x5cb0a9dc,
	0xbd41fbd4,
	0x76f988da,
	0x831153b5,
	0x983e5152,
	0xee66dfab,
	0xa831c66d,
	0x2db43210,
	0xb00327c8,
	0x98fb213f,
	0xbf597fc7,
	0xbeef0ee4,
	0xc6e00bf3,
	0x3da88fc2,
	0xd5a79147,
	0x930aa725,
	0x06ca6351,
	0xe003826f,
	0x14292967,
	0x0a0e6e70,
	0x27b70a85,
	0x46d22ffc,
	0x2e1b2138,
	0x5c26c926,
	0x4d2c6dfc,
	0x5ac42aed,
	0x53380d13,
	0x9d95b3df,
	0x650a7354,
	0x8baf63de,
	0x766a0abb,
	0x3c77b2a8,
	0x81c2c92e,
	0x47edaee6,
	0x92722c85,
	0x1482353b,
	0xa2bfe8a1,
	0x4cf10364,
	0xa81a664b,
	0xbc423001,
	0xc24b8b70,
	0xd0f89791,
	0xc76c51a3,
	0x0654be30,
	0xd192e819,
	0xd6ef5218,
	0xd6990624,
	0x5565a910,
	0xf40e3585,
	0x5771202a,
	0x106aa070,
	0x32bbd1b8,
	0x19a4c116,
	0xb8d2d0c8,
	0x1e376c08,
	0x5141ab53,
	0x2748774c,
	0xdf8eeb99,
	0x34b0bcb5,
	0xe19b48a8,
	0x391c0cb3,
	0xc5c95a63,
	0x4ed8aa4a,
	0xe3418acb,
	0x5b9cca4f,
	0x7763e373,
	0x682e6ff3,
	0xd6b2b8a3,
	0x748f82ee,
	0x5defb2fc,
	0x78a5636f,
	0x43172f60,
	0x84c87814,
	0xa1f0ab72,
	0x8cc70208,
	0x1a6439ec,
	0x90befffa,
	0x23631e28,
	0xa4506ceb,
	0xde82bde9,
	0xbef9a3f7,
	0xb2c67915,
	0xc67178f2,
	0xe372532b,
	0xca273ece,
	0xea26619c,
	0xd186b8c7,
	0x21c0c207,
	0xeada7dd6,
	0xcde0eb1e,
	0xf57d4f7f,
	0xee6ed178,
	0x06f067aa,
	0x72176fba,
	0x0a637dc5,
	0xa2c898a6,
	0x113f9804,
	0xbef90dae,
	0x1b710b35,
	0x131c471b,
	0x28db77f5,
	0x23047d84,
	0x32caab7b,
	0x40c72493,
	0x3c9ebe0a,
	0x15c9bebc,
	0x431d67c4,
	0x9c100d4c,
	0x4cc5d4be,
	0xcb3e42b6,
	0x597f299c,
	0xfc657e2a,
	0x5fcb6fab,
	0x3ad6faec,
	0x6c44198c,
	0x4a475817
];

var W = new Array(160);

function Sha512() {
	this.init();
	this._w = W;

	Hash.call(this, 128, 112);
}

inherits(Sha512, Hash);

Sha512.prototype.init = function () {
	this._ah = 0x6a09e667;
	this._bh = 0xbb67ae85;
	this._ch = 0x3c6ef372;
	this._dh = 0xa54ff53a;
	this._eh = 0x510e527f;
	this._fh = 0x9b05688c;
	this._gh = 0x1f83d9ab;
	this._hh = 0x5be0cd19;

	this._al = 0xf3bcc908;
	this._bl = 0x84caa73b;
	this._cl = 0xfe94f82b;
	this._dl = 0x5f1d36f1;
	this._el = 0xade682d1;
	this._fl = 0x2b3e6c1f;
	this._gl = 0xfb41bd6b;
	this._hl = 0x137e2179;

	return this;
};

function Ch(x, y, z) {
	return z ^ (x & (y ^ z));
}

function maj(x, y, z) {
	return (x & y) | (z & (x | y));
}

function sigma0(x, xl) {
	return ((x >>> 28) | (xl << 4)) ^ ((xl >>> 2) | (x << 30)) ^ ((xl >>> 7) | (x << 25));
}

function sigma1(x, xl) {
	return ((x >>> 14) | (xl << 18)) ^ ((x >>> 18) | (xl << 14)) ^ ((xl >>> 9) | (x << 23));
}

function Gamma0(x, xl) {
	return ((x >>> 1) | (xl << 31)) ^ ((x >>> 8) | (xl << 24)) ^ (x >>> 7);
}

function Gamma0l(x, xl) {
	return ((x >>> 1) | (xl << 31)) ^ ((x >>> 8) | (xl << 24)) ^ ((x >>> 7) | (xl << 25));
}

function Gamma1(x, xl) {
	return ((x >>> 19) | (xl << 13)) ^ ((xl >>> 29) | (x << 3)) ^ (x >>> 6);
}

function Gamma1l(x, xl) {
	return ((x >>> 19) | (xl << 13)) ^ ((xl >>> 29) | (x << 3)) ^ ((x >>> 6) | (xl << 26));
}

function getCarry(a, b) {
	return (a >>> 0) < (b >>> 0) ? 1 : 0;
}

Sha512.prototype._update = function (M) {
	var w = this._w;

	var ah = this._ah | 0;
	var bh = this._bh | 0;
	var ch = this._ch | 0;
	var dh = this._dh | 0;
	var eh = this._eh | 0;
	var fh = this._fh | 0;
	var gh = this._gh | 0;
	var hh = this._hh | 0;

	var al = this._al | 0;
	var bl = this._bl | 0;
	var cl = this._cl | 0;
	var dl = this._dl | 0;
	var el = this._el | 0;
	var fl = this._fl | 0;
	var gl = this._gl | 0;
	var hl = this._hl | 0;

	for (var i = 0; i < 32; i += 2) {
		w[i] = M.readInt32BE(i * 4);
		w[i + 1] = M.readInt32BE((i * 4) + 4);
	}
	for (; i < 160; i += 2) {
		var xh = w[i - (15 * 2)];
		var xl = w[i - (15 * 2) + 1];
		var gamma0 = Gamma0(xh, xl);
		var gamma0l = Gamma0l(xl, xh);

		xh = w[i - (2 * 2)];
		xl = w[i - (2 * 2) + 1];
		var gamma1 = Gamma1(xh, xl);
		var gamma1l = Gamma1l(xl, xh);

		// w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
		var Wi7h = w[i - (7 * 2)];
		var Wi7l = w[i - (7 * 2) + 1];

		var Wi16h = w[i - (16 * 2)];
		var Wi16l = w[i - (16 * 2) + 1];

		var Wil = (gamma0l + Wi7l) | 0;
		var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
		Wil = (Wil + gamma1l) | 0;
		Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
		Wil = (Wil + Wi16l) | 0;
		Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;

		w[i] = Wih;
		w[i + 1] = Wil;
	}

	for (var j = 0; j < 160; j += 2) {
		Wih = w[j];
		Wil = w[j + 1];

		var majh = maj(ah, bh, ch);
		var majl = maj(al, bl, cl);

		var sigma0h = sigma0(ah, al);
		var sigma0l = sigma0(al, ah);
		var sigma1h = sigma1(eh, el);
		var sigma1l = sigma1(el, eh);

		// t1 = h + sigma1 + ch + K[j] + w[j]
		var Kih = K[j];
		var Kil = K[j + 1];

		var chh = Ch(eh, fh, gh);
		var chl = Ch(el, fl, gl);

		var t1l = (hl + sigma1l) | 0;
		var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
		t1l = (t1l + chl) | 0;
		t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
		t1l = (t1l + Kil) | 0;
		t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
		t1l = (t1l + Wil) | 0;
		t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0;

		// t2 = sigma0 + maj
		var t2l = (sigma0l + majl) | 0;
		var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;

		hh = gh;
		hl = gl;
		gh = fh;
		gl = fl;
		fh = eh;
		fl = el;
		el = (dl + t1l) | 0;
		eh = (dh + t1h + getCarry(el, dl)) | 0;
		dh = ch;
		dl = cl;
		ch = bh;
		cl = bl;
		bh = ah;
		bl = al;
		al = (t1l + t2l) | 0;
		ah = (t1h + t2h + getCarry(al, t1l)) | 0;
	}

	this._al = (this._al + al) | 0;
	this._bl = (this._bl + bl) | 0;
	this._cl = (this._cl + cl) | 0;
	this._dl = (this._dl + dl) | 0;
	this._el = (this._el + el) | 0;
	this._fl = (this._fl + fl) | 0;
	this._gl = (this._gl + gl) | 0;
	this._hl = (this._hl + hl) | 0;

	this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
	this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
	this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
	this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
	this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
	this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
	this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
	this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
};

Sha512.prototype._hash = function () {
	var H = Buffer.allocUnsafe(64);

	function writeInt64BE(h, l, offset) {
		H.writeInt32BE(h, offset);
		H.writeInt32BE(l, offset + 4);
	}

	writeInt64BE(this._ah, this._al, 0);
	writeInt64BE(this._bh, this._bl, 8);
	writeInt64BE(this._ch, this._cl, 16);
	writeInt64BE(this._dh, this._dl, 24);
	writeInt64BE(this._eh, this._el, 32);
	writeInt64BE(this._fh, this._fl, 40);
	writeInt64BE(this._gh, this._gl, 48);
	writeInt64BE(this._hh, this._hl, 56);

	return H;
};

module.exports = Sha512;

},{"./hash":791,"inherits":495,"safe-buffer":788}],799:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/lib/_stream_readable.js');
Stream.Writable = require('readable-stream/lib/_stream_writable.js');
Stream.Duplex = require('readable-stream/lib/_stream_duplex.js');
Stream.Transform = require('readable-stream/lib/_stream_transform.js');
Stream.PassThrough = require('readable-stream/lib/_stream_passthrough.js');
Stream.finished = require('readable-stream/lib/internal/streams/end-of-stream.js')
Stream.pipeline = require('readable-stream/lib/internal/streams/pipeline.js')

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":435,"inherits":495,"readable-stream/lib/_stream_duplex.js":801,"readable-stream/lib/_stream_passthrough.js":802,"readable-stream/lib/_stream_readable.js":803,"readable-stream/lib/_stream_transform.js":804,"readable-stream/lib/_stream_writable.js":805,"readable-stream/lib/internal/streams/end-of-stream.js":809,"readable-stream/lib/internal/streams/pipeline.js":811}],800:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],801:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');
require('inherits')(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require('_process'))

},{"./_stream_readable":803,"./_stream_writable":805,"_process":736,"inherits":495}],802:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require('./_stream_transform');
require('inherits')(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":804,"inherits":495}],803:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = require('util');
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/buffer_list');
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require('inherits')(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":800,"./_stream_duplex":801,"./internal/streams/async_iterator":806,"./internal/streams/buffer_list":807,"./internal/streams/destroy":808,"./internal/streams/from":810,"./internal/streams/state":812,"./internal/streams/stream":813,"_process":736,"buffer":364,"events":435,"inherits":495,"string_decoder/":814,"util":335}],804:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var _require$codes = require('../errors').codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require('./_stream_duplex');
require('inherits')(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":800,"./_stream_duplex":801,"inherits":495}],805:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require('inherits')(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":800,"./_stream_duplex":801,"./internal/streams/destroy":808,"./internal/streams/state":812,"./internal/streams/stream":813,"_process":736,"buffer":364,"inherits":495,"util-deprecate":818}],806:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = require('./end-of-stream');
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require('_process'))

},{"./end-of-stream":809,"_process":736}],807:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('buffer'),
  Buffer = _require.Buffer;
var _require2 = require('util'),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();
},{"buffer":364,"util":335}],808:[function(require,module,exports){
(function (process){(function (){
'use strict';

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require('_process'))

},{"_process":736}],809:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;
},{"../../../errors":800}],810:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],811:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = require('../../../errors').codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;
},{"../../../errors":800,"./end-of-stream":809}],812:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":800}],813:[function(require,module,exports){
arguments[4][780][0].apply(exports,arguments)
},{"dup":780,"events":435}],814:[function(require,module,exports){
arguments[4][783][0].apply(exports,arguments)
},{"dup":783,"safe-buffer":788}],815:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":736,"timers":815}],816:[function(require,module,exports){
'use strict';

var Buffer = require('safe-buffer').Buffer;
var isArray = require('isarray');
var typedArrayBuffer = require('typed-array-buffer');

var isView = ArrayBuffer.isView || function isView(obj) {
	try {
		typedArrayBuffer(obj);
		return true;
	} catch (e) {
		return false;
	}
};

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = typeof ArrayBuffer !== 'undefined'
	&& typeof Uint8Array !== 'undefined';
var useFromArrayBuffer = useArrayBuffer && (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);

module.exports = function toBuffer(data, encoding) {
	if (Buffer.isBuffer(data)) {
		if (data.constructor && !('isBuffer' in data)) {
			// probably a SlowBuffer
			return Buffer.from(data);
		}
		return data;
	}

	if (typeof data === 'string') {
		return Buffer.from(data, encoding);
	}

	/*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */
	if (useArrayBuffer && isView(data)) {
		// Bug in Node.js <6.3.1, which treats this as out-of-bounds
		if (data.byteLength === 0) {
			return Buffer.alloc(0);
		}

		// When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
		if (useFromArrayBuffer) {
			var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
			/*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */
			if (res.byteLength === data.byteLength) {
				return res;
			}
		}

		// Convert to Uint8Array bytes and then to Buffer
		var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
		var result = Buffer.from(uint8);

		/*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */
		if (result.length === data.byteLength) {
			return result;
		}
	}

	/*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */
	if (useUint8Array && data instanceof Uint8Array) {
		return Buffer.from(data);
	}

	var isArr = isArray(data);
	if (isArr) {
		for (var i = 0; i < data.length; i += 1) {
			var x = data[i];
			if (
				typeof x !== 'number'
				|| x < 0
				|| x > 255
				|| ~~x !== x // NaN and integer check
			) {
				throw new RangeError('Array items must be numbers in the range 0-255.');
			}
		}
	}

	/*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */
	if (
		isArr || (
			Buffer.isBuffer(data)
			&& data.constructor
			&& typeof data.constructor.isBuffer === 'function'
			&& data.constructor.isBuffer(data)
		)
	) {
		return Buffer.from(data);
	}

	throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

},{"isarray":501,"safe-buffer":788,"typed-array-buffer":817}],817:[function(require,module,exports){
'use strict';

var $TypeError = require('es-errors/type');

var callBound = require('call-bound');

/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */
var $typedArrayBuffer = callBound('TypedArray.prototype.buffer', true);

var isTypedArray = require('is-typed-array');

/** @type {import('.')} */
// node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $typedArrayBuffer || function typedArrayBuffer(x) {
	if (!isTypedArray(x)) {
		throw new $TypeError('Not a Typed Array');
	}
	return x.buffer;
};

},{"call-bound":373,"es-errors/type":432,"is-typed-array":500}],818:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],819:[function(require,module,exports){
arguments[4][328][0].apply(exports,arguments)
},{"dup":328}],820:[function(require,module,exports){
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

'use strict';

var isArgumentsObject = require('is-arguments');
var isGeneratorFunction = require('is-generator-function');
var whichTypedArray = require('which-typed-array');
var isTypedArray = require('is-typed-array');

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});

},{"is-arguments":496,"is-generator-function":498,"is-typed-array":500,"which-typed-array":823}],821:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = require('./support/types');

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

}).call(this)}).call(this,require('_process'))

},{"./support/isBuffer":819,"./support/types":820,"_process":736,"inherits":495}],822:[function(require,module,exports){
var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};

},{}],823:[function(require,module,exports){
(function (global){(function (){
'use strict';

var forEach = require('for-each');
var availableTypedArrays = require('available-typed-arrays');
var callBind = require('call-bind');
var callBound = require('call-bound');
var gOPD = require('gopd');
var getProto = require('get-proto');

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require('has-tostringtag/shams')();

var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');

/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */
/** @import { TypedArrayName } from '.' */

/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};

/** @type {Cache} */
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getProto) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr && getProto) {
			var proto = getProto(arr);
			// @ts-expect-error TS won't narrow inside a closure
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor && proto) {
				var superProto = getProto(proto);
				// @ts-expect-error TS won't narrow inside a closure
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			if (descriptor && descriptor.get) {
				var bound = callBind(descriptor.get);
				cache[
					/** @type {`$${TypedArrayName}`} */
					('$' + typedArray)
				] = bound;
			}
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			var bound = /** @type {typeof BoundSlice | typeof BoundSet} */ (
				// @ts-expect-error TODO FIXME
				callBind(fn)
			);
			cache[
				/** @type {`$${TypedArrayName}`} */
				('$' + typedArray)
			] = bound;
		}
	});
}

/** @type {(value: object) => false | TypedArrayName} */
function tryTypedArrays(value) {
	/** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
	forEach(
		/** @type {Record<`$${TypedArrayName}`, Getter>} */ (cache),
		/** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */
		function (getter, typedArray) {
			if (!found) {
				try {
					// @ts-expect-error a throw is fine here
					if ('$' + getter(value) === typedArray) {
						found = /** @type {TypedArrayName} */ ($slice(typedArray, 1));
					}
				} catch (e) { /**/ }
			}
		}
	);
	return found;
}

/** @type {(value: object) => false | TypedArrayName} */
function trySlices(value) {
	/** @type {ReturnType<typeof trySlices>} */ var found = false;
	forEach(
		/** @type {Record<`$${TypedArrayName}`, Getter>} */(cache),
		/** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function (getter, name) {
			if (!found) {
				try {
					// @ts-expect-error a throw is fine here
					getter(value);
					found = /** @type {TypedArrayName} */ ($slice(name, 1));
				} catch (e) { /**/ }
			}
		}
	);
	return found;
}

/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */
function isTATag(tag) {
	return $indexOf(typedArrays, tag) > -1;
}

/** @type {(value: unknown) => ReturnType<typeof import('.')>} */
function whichTypedArray(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		var tag = $slice($toString(value), 8, -1);
		if (isTATag(tag)) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
}

module.exports = whichTypedArray;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"available-typed-arrays":331,"call-bind":372,"call-bound":373,"for-each":439,"get-proto":446,"gopd":448,"has-tostringtag/shams":452}],824:[function(require,module,exports){
arguments[4][437][0].apply(exports,arguments)
},{"dup":437}],825:[function(require,module,exports){
arguments[4][438][0].apply(exports,arguments)
},{"../package.json":824,"dup":438}],826:[function(require,module,exports){
/**
 * Pict MicroApp — compose a micro app class from a host application class and a manifest.
 *
 * This is the one-liner an app author writes:
 *
 *     const libHostApplication = require('some-big-pict-application');
 *     const libMicroApp = require('pict-microapp');
 *
 *     class MyApp extends libMicroApp.composeMicroApp(libHostApplication, require('./MyApp-Manifest.js'), {...}) {}
 *     module.exports = MyApp;
 *     module.exports.default_configuration = libHostApplication.default_configuration;
 *
 * The composed class inherits everything the host does and overrides exactly four things: it
 * registers the MicroApp provider, installs the route gate before the host registers routes,
 * swaps the navigation graph and its visibility gate, and re-points the landing route.
 *
 * @author steven velozo <steven@velozo.com>
 */

const _DEFAULT_COMPOSE_OPTIONS =
{
	// Service hash the MicroApp provider is registered under on the host pict instance.
	ProviderHash: 'MicroApp',

	// Service hash of the pict-router provider (the route funnel the gate wraps).
	RouterProviderHash: 'PictRouter',

	// Service hash of the pict-section-navigation provider, when the host has one.
	NavigationProviderHash: 'Pict-Navigation',

	// Service hash of the provider that owns the host's `defaultRoute` property. Many hosts wrap
	// pict-router in an application router provider; that wrapper is what holds the landing route.
	// Defaults to RouterProviderHash when not set.
	HostRouterProviderHash: '',

	// The host lifecycle method the gate is installed from. The gate runs BEFORE the host's own
	// implementation, so this must be a hook that fires after the router provider exists and
	// before the host registers its routes.
	AttachOn: 'onAfterInitializeAsync',

	// Host method that installs the navigation visibility filter. Overridden so the micro app's
	// gate wins. Set to '' to leave the host's navigation gate alone.
	NavigationGateMethod: '',

	// Host method that answers "may this session see this nav item?" — reused verbatim so
	// capability and module gating keeps working against the micro app's own graph.
	HostPermittedMethod: '',

	// Host method that answers "is this a privileged platform session?" — used to keep the micro
	// app's menu visible to platform staff who hold no tenant entitlements.
	IsPrivilegedMethod: ''
};

/**
 * Build a micro app application class from a host application class and a manifest.
 *
 * @param {Function} pHostApplicationClass - the host pict application class to present a subset of
 * @param {Object} pManifest - the micro app manifest (see Pict-MicroApp-Manifest.js)
 * @param {Object} [pComposeOptions] - the host binding options above
 * @return {Function} a class extending the host application class
 */
function composeMicroApp(pHostApplicationClass, pManifest, pComposeOptions)
{
	if (typeof pHostApplicationClass !== 'function')
	{
		throw new Error('pict-microapp: composeMicroApp requires a host application class.');
	}

	const libPictMicroApp = require('./Pict-MicroApp.js');
	const tmpOptions = Object.assign({}, _DEFAULT_COMPOSE_OPTIONS, pComposeOptions || {});
	const tmpHostRouterProviderHash = tmpOptions.HostRouterProviderHash || tmpOptions.RouterProviderHash;
	const tmpAttachOn = tmpOptions.AttachOn;
	// The host class is only known at runtime, so it is cast to a constructor signature for the
	// benefit of the declaration build; the composed class is deliberately untyped beyond that.
	const tmpHostClass = /** @type {new (...pArguments: Array<any>) => any} */ (pHostApplicationClass);

	class PictMicroApplication extends tmpHostClass
	{
		constructor(pFable, pApplicationOptions, pServiceHash)
		{
			super(pFable, pApplicationOptions, pServiceHash);

			/** @type {any} */
			this.pict;

			// The host has finished registering its views and providers by now, so the navigation
			// provider exists and the graph can be swapped in place.
			this.pict.addProvider(tmpOptions.ProviderHash,
				{
					Manifest: pManifest,
					RouterProviderHash: tmpOptions.RouterProviderHash,
					NavigationProviderHash: tmpOptions.NavigationProviderHash
				}, libPictMicroApp);

			this.MicroApp.applyNavigationGraph();
			this.MicroApp.applyBranding();
		}

		/**
		 * The MicroApp provider for this application.
		 *
		 * @return {Object} the provider
		 */
		get MicroApp()
		{
			return this.pict.providers[tmpOptions.ProviderHash];
		}
	}

	// The gate has to be installed from a lifecycle hook, and the hook's name is configuration, so
	// the override is assigned onto the prototype rather than written in the class body.
	PictMicroApplication.prototype[tmpAttachOn] = async function (fCallback)
	{
		const tmpMicroApp = this.MicroApp;
		if (tmpMicroApp)
		{
			tmpMicroApp.gateRouter();
			tmpMicroApp.installNotFound();
			tmpMicroApp.applyDefaultRoute(this.pict.providers[tmpHostRouterProviderHash]);
		}
		return pHostApplicationClass.prototype[tmpAttachOn].call(this, fCallback);
	};

	// The host's navigation gate is usually written for the host's own (much larger) audience mix.
	// Replacing it keeps the micro app's menu from being trimmed to nothing.
	if (tmpOptions.NavigationGateMethod)
	{
		PictMicroApplication.prototype[tmpOptions.NavigationGateMethod] = function ()
		{
			const tmpMicroApp = this.MicroApp;
			if (!tmpMicroApp)
			{
				return pHostApplicationClass.prototype[tmpOptions.NavigationGateMethod].call(this);
			}
			const tmpHostPermitted = tmpOptions.HostPermittedMethod
				? (pItem) => this[tmpOptions.HostPermittedMethod](pItem)
				: null;
			const tmpIsPrivileged = tmpOptions.IsPrivilegedMethod
				? () => this[tmpOptions.IsPrivilegedMethod]()
				: (() => false);
			return tmpMicroApp.applyNavigationGate(tmpHostPermitted, { IsPrivileged: tmpIsPrivileged });
		};
	}

	return PictMicroApplication;
}

module.exports = composeMicroApp;
module.exports.default_compose_options = _DEFAULT_COMPOSE_OPTIONS;

},{"./Pict-MicroApp.js":828}],827:[function(require,module,exports){
/**
 * Pict MicroApp — manifest normalization and route matching.
 *
 * A micro app is described by a plain-object manifest: the routes it exposes, the navigation it
 * renders, where it lands, and how it is branded. Everything in this file is pure — no pict, no
 * DOM — so the matching rules can be unit tested headlessly.
 *
 * @author steven velozo <steven@velozo.com>
 */

/**
 * The shape a normalized manifest always has, whatever the author wrote.
 */
const _DEFAULT_MANIFEST =
{
	// Display name of the micro app (used in logs and as the fallback document title).
	Name: 'MicroApp',
	// Stable identifier for this micro app.
	Hash: 'MicroApp',

	// The route the app lands on when it boots with no deep link, and where blocked routes bounce to.
	// Written without the leading '#'.
	DefaultRoute: '/',

	Routes:
	{
		// Route patterns this micro app exposes, exactly as the host registers them (leading '#'
		// optional). A trailing '*' makes an entry a prefix glob: '/Asset/*' allows every route
		// whose pattern starts with '/Asset/'.
		Allow: [],
		// Patterns removed even when Allow would admit them. Deny wins.
		Deny: [],
		// Parameterized host routes that fan out over an entity name — the pict-section-recordset
		// wildcards ('/PSRS/:RecordSet/List') are the motivating case. These cannot be dropped
		// per-entity at registration time, so they are GUARDED instead: the route registers, but
		// its handler bounces to the fallback route when the resolved entity is not in Entities.
		EntityParameter: 'RecordSet',
		Entities: [],
		// When true (the default) an EntityParameter route is admitted and guarded. When false it
		// is treated like any other route and must be listed in Allow to survive.
		GuardEntityRoutes: true,
		// Where a blocked entity bounces to. Defaults to DefaultRoute.
		Fallback: '',
		// When true, a hash that matches no surviving route lands on Fallback instead of nothing.
		CatchUnmatched: true,
		// Routes always admitted regardless of Allow — the boot, logout and default plumbing every
		// host app needs to keep working.
		AlwaysAllow: [ '/', '/Logout' ]
	},

	Navigation:
	{
		// The navigation graph this micro app renders, in the host navigation module's own shape.
		// When empty the host's own graph is left alone.
		Sections: [],
		// Keep the host from replacing the graph later. Hosts rebuild their navigation as config and
		// permissions resolve, which silently reverts the swap — usually after login, where it is
		// easy to miss. Turn this off only if a micro app genuinely wants the host's later graph.
		PinGraph: true,
		// Drop the host's super-user short-circuit. A micro app's graph IS already the slimmed
		// surface, so hiding all of it from platform staff is never what you want.
		SuperUserSeesEverything: true,
		// Keep the host's capability / module / session gates on top of the micro app graph.
		HonorHostGates: true
	},

	Branding:
	{
		// document.title for the app.
		Title: '',
		// Title shown on the host's login screen, when the host supports one.
		LoginTitle: ''
	}
};

/**
 * Strip a route to the canonical form used for comparison: no leading '#', exactly one leading '/',
 * no trailing '/' (except the bare root).
 *
 * @param {String} pRoute - a route pattern or hash
 * @return {String} the canonical route pattern
 */
function normalizeRoute(pRoute)
{
	let tmpRoute = String(pRoute == null ? '' : pRoute).trim();
	if (tmpRoute.length < 1)
	{
		return '';
	}
	tmpRoute = tmpRoute.replace(/^#/, '');
	tmpRoute = tmpRoute.replace(/^\/+/, '/');
	if (tmpRoute.charAt(0) !== '/')
	{
		tmpRoute = `/${ tmpRoute }`;
	}
	// Collapse every trailing slash, not just the last one, so '//Widgets//' and '/Widgets' are the
	// same route. The bare root keeps its slash.
	tmpRoute = tmpRoute.replace(/\/+$/, '');
	return (tmpRoute.length > 0) ? tmpRoute : '/';
}

/**
 * Deep-ish merge of an author manifest over the defaults. Only the three known sub-objects are
 * merged a level down; everything else is a straight overwrite.
 *
 * @param {Object} [pManifest] - the author's manifest
 * @return {Object} a fully populated manifest
 */
function normalizeManifest(pManifest)
{
	const tmpManifest = (pManifest && (typeof pManifest === 'object')) ? pManifest : {};
	const tmpNormalized = Object.assign({}, _DEFAULT_MANIFEST, tmpManifest);

	tmpNormalized.Routes = Object.assign({}, _DEFAULT_MANIFEST.Routes, tmpManifest.Routes || {});
	tmpNormalized.Navigation = Object.assign({}, _DEFAULT_MANIFEST.Navigation, tmpManifest.Navigation || {});
	tmpNormalized.Branding = Object.assign({}, _DEFAULT_MANIFEST.Branding, tmpManifest.Branding || {});

	tmpNormalized.DefaultRoute = normalizeRoute(tmpNormalized.DefaultRoute) || '/';
	tmpNormalized.Routes.Allow = (tmpNormalized.Routes.Allow || []).map(normalizeRoute).filter((pEntry) => (pEntry.length > 0));
	tmpNormalized.Routes.Deny = (tmpNormalized.Routes.Deny || []).map(normalizeRoute).filter((pEntry) => (pEntry.length > 0));
	tmpNormalized.Routes.AlwaysAllow = (tmpNormalized.Routes.AlwaysAllow || []).map(normalizeRoute).filter((pEntry) => (pEntry.length > 0));
	tmpNormalized.Routes.Fallback = normalizeRoute(tmpNormalized.Routes.Fallback) || tmpNormalized.DefaultRoute;
	tmpNormalized.Routes.Entities = (tmpNormalized.Routes.Entities || []).map((pEntry) => String(pEntry));

	return tmpNormalized;
}

/**
 * Does a canonical route pattern match one allow/deny entry? An entry ending in '*' is a prefix
 * glob; anything else is an exact pattern match (so '/Asset/Workspace/:ID' matches only the route
 * registered with that exact parameter spelling).
 *
 * @param {String} pRoute - a canonical route pattern
 * @param {String} pEntry - a canonical allow/deny entry
 * @return {Boolean} whether the entry matches
 */
function routeMatchesEntry(pRoute, pEntry)
{
	if (pEntry === '*')
	{
		return true;
	}
	if (pEntry.charAt(pEntry.length - 1) === '*')
	{
		return (pRoute.indexOf(pEntry.slice(0, -1)) === 0);
	}
	return (pRoute === pEntry);
}

/**
 * Does this route pattern fan out over the manifest's entity parameter (for example
 * '/PSRS/:RecordSet/List' with an EntityParameter of 'RecordSet')?
 *
 * @param {String} pRoute - a canonical route pattern
 * @param {String} pEntityParameter - the parameter name that names an entity
 * @return {Boolean} whether the route is entity-parameterized
 */
function routeIsEntityParameterized(pRoute, pEntityParameter)
{
	if (!pEntityParameter)
	{
		return false;
	}
	return (pRoute.indexOf(`:${ pEntityParameter }`) > -1);
}

/**
 * Decide what the gate should do with a route the host is trying to register.
 *
 * Returns one of three modes:
 *   Allow — register it untouched.
 *   Guard — register it, but wrap the handler so disallowed entities bounce to the fallback.
 *   Block — do not register it at all.
 *
 * @param {Object} pManifest - a normalized manifest
 * @param {String} pRoute - the route pattern the host passed to addRoute
 * @return {{Mode: String, Route: String, Reason: String}} the decision
 */
function decideRoute(pManifest, pRoute)
{
	const tmpRoute = normalizeRoute(pRoute);
	const tmpRoutes = pManifest.Routes;

	if (tmpRoute.length < 1)
	{
		return { Mode: 'Block', Route: tmpRoute, Reason: 'EmptyRoute' };
	}
	for (const tmpEntry of tmpRoutes.Deny)
	{
		if (routeMatchesEntry(tmpRoute, tmpEntry))
		{
			return { Mode: 'Block', Route: tmpRoute, Reason: 'Denied' };
		}
	}
	for (const tmpEntry of tmpRoutes.AlwaysAllow)
	{
		if (routeMatchesEntry(tmpRoute, tmpEntry))
		{
			return { Mode: 'Allow', Route: tmpRoute, Reason: 'AlwaysAllowed' };
		}
	}
	// An empty Allow list means "expose everything" — a micro app that only wants a different
	// navigation and landing page does not have to enumerate the host's whole route table.
	if (tmpRoutes.Allow.length < 1)
	{
		return { Mode: 'Allow', Route: tmpRoute, Reason: 'NoAllowList' };
	}
	for (const tmpEntry of tmpRoutes.Allow)
	{
		if (routeMatchesEntry(tmpRoute, tmpEntry))
		{
			return { Mode: 'Allow', Route: tmpRoute, Reason: 'Allowed' };
		}
	}
	if (tmpRoutes.GuardEntityRoutes && routeIsEntityParameterized(tmpRoute, tmpRoutes.EntityParameter))
	{
		return { Mode: 'Guard', Route: tmpRoute, Reason: 'EntityParameterized' };
	}
	return { Mode: 'Block', Route: tmpRoute, Reason: 'NotAllowed' };
}

/**
 * Is an entity name exposed by this micro app? An empty Entities list means every entity is
 * exposed (the manifest author did not want to constrain the record-set surface).
 *
 * @param {Object} pManifest - a normalized manifest
 * @param {String} pEntity - the entity name resolved from the route
 * @return {Boolean} whether the entity is exposed
 */
function entityPermitted(pManifest, pEntity)
{
	const tmpEntities = pManifest.Routes.Entities;
	if (tmpEntities.length < 1)
	{
		return true;
	}
	return (tmpEntities.indexOf(String(pEntity)) > -1);
}

module.exports =
{
	default_manifest: _DEFAULT_MANIFEST,
	normalizeManifest: normalizeManifest,
	normalizeRoute: normalizeRoute,
	routeMatchesEntry: routeMatchesEntry,
	routeIsEntityParameterized: routeIsEntityParameterized,
	decideRoute: decideRoute,
	entityPermitted: entityPermitted
};

},{}],828:[function(require,module,exports){
/**
 * Pict MicroApp — present a large pict application as a small, focused one.
 *
 * A "micro app" is not a fork and not a rebuild: it is the SAME application, booted the same way,
 * with a smaller surface. You keep every view, provider, template, style and fix the host app
 * already has — and an enhancement to the host lands in every micro app on its next build — but
 * the routes, the navigation and the landing page are the micro app's own.
 *
 * The seam is narrow on purpose. A host pict application registers every route it owns through one
 * funnel, `PictRouter.addRoute`. This provider wraps that funnel with an allow list taken from a
 * declarative manifest, swaps the navigation graph, and re-points the landing route. Nothing else
 * about the host's boot sequence changes, which is what keeps a micro app cheap to build and cheap
 * to keep working as the host evolves.
 *
 * What this module deliberately does NOT do is make the JavaScript bundle smaller — the host's
 * module graph is still bundled whole. It slims the app the user sees, not the bytes the browser
 * downloads. See the README for the reasoning and for when that tradeoff stops being the right one.
 *
 * @author steven velozo <steven@velozo.com>
 */

const libPictProvider = require('pict-provider');

const libManifest = require('./Pict-MicroApp-Manifest.js');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'MicroApp',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// The micro app manifest. See Pict-MicroApp-Manifest.js for the shape and defaults.
	Manifest: {},

	// Service hash of the host's pict-router provider. Every host that uses pict-router registers
	// it under this hash.
	RouterProviderHash: 'PictRouter',

	// Service hash of the host's pict-section-navigation provider, when it has one.
	NavigationProviderHash: 'Pict-Navigation',

	// Log each route the gate blocks. Noisy but invaluable while authoring a manifest, so it is on.
	LogBlockedRoutes: true
};

class PictMicroApp extends libPictProvider
{
	/**
	 * @param {Object} pFable - the fable instance
	 * @param {Object} [pOptions] - provider options, including the Manifest
	 * @param {String} [pServiceHash] - the service hash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		/** The normalized manifest — always fully populated, whatever the author wrote. */
		this.manifest = libManifest.normalizeManifest(this.options.Manifest);

		/** Route patterns the gate refused, in registration order. Read this when a screen is missing. */
		this.blockedRoutes = [];
		/** Route patterns the gate admitted with an entity guard. */
		this.guardedRoutes = [];
		/** Route patterns that survived untouched. */
		this.allowedRoutes = [];

		/** The original addRoute, kept so releaseRouter() can put the host back the way it was. */
		this._originalAddRoute = null;
		/** The original navigo `on`, for the same reason. */
		this._originalRouterOn = null;
		/** The router provider the gate is currently installed on. */
		this._gatedRouter = null;
		/** True while the provider-level gate is delegating into the navigo-level one. */
		this._delegating = false;
	}

	/**
	 * The host's pict-router provider, or null before it exists.
	 *
	 * @return {Object|null} the router provider
	 */
	get pictRouter()
	{
		const tmpProviders = (this.pict && this.pict.providers) ? this.pict.providers : {};
		return tmpProviders[this.options.RouterProviderHash] || null;
	}

	/**
	 * The host's navigation provider, or null when the host has none.
	 *
	 * @return {Object|null} the navigation provider
	 */
	get navigationProvider()
	{
		const tmpProviders = (this.pict && this.pict.providers) ? this.pict.providers : {};
		return tmpProviders[this.options.NavigationProviderHash] || null;
	}

	/**
	 * Replace the manifest after construction. Only meaningful before the gate is installed.
	 *
	 * @param {Object} pManifest - a micro app manifest
	 * @return {Object} the normalized manifest
	 */
	setManifest(pManifest)
	{
		this.manifest = libManifest.normalizeManifest(pManifest);
		return this.manifest;
	}

	/**
	 * What would the gate do with this route? Exposed so an app (or a test) can ask without
	 * registering anything.
	 *
	 * @param {String} pRoute - a route pattern
	 * @return {{Mode: String, Route: String, Reason: String}} the decision
	 */
	routeDecision(pRoute)
	{
		return libManifest.decideRoute(this.manifest, pRoute);
	}

	/**
	 * Install the route gate on the host's router.
	 *
	 * MUST be called after the router provider exists but BEFORE the host registers its routes. In
	 * a pict application that means after the provider that owns routing has been added (usually in
	 * onInitializeAsync) and before the login/data-load cycle that registers them.
	 *
	 * Wrapping the instance method rather than the prototype keeps the blast radius to this one
	 * router: a host that shares pict-router with an embedded module is unaffected.
	 *
	 * TWO funnels are wrapped, not one. Most code registers through the provider's `addRoute`, but
	 * some modules reach past it and call the underlying router's `on` directly — pict-section-
	 * recordset's list, dashboard, associate and bulk-delete views all do, which is every one of its
	 * highest-traffic screens. Gating only `addRoute` silently leaves those wide open, and because
	 * they still work you would never notice. The provider-level wrapper sets `_delegating` while it
	 * calls through, so a route that came in via `addRoute` is decided once, not twice.
	 *
	 * @param {Object} [pPictRouter] - the router provider; defaults to the configured one
	 * @return {Boolean} whether the gate was installed
	 */
	gateRouter(pPictRouter)
	{
		const tmpRouter = pPictRouter || this.pictRouter;
		if (!tmpRouter || (typeof tmpRouter.addRoute !== 'function'))
		{
			this.pict.log.warn(`MicroApp [${ this.manifest.Name }] could not gate routes: no router provider at '${ this.options.RouterProviderHash }'.`);
			return false;
		}
		if (this._originalAddRoute)
		{
			// Already gated. Re-gating would double-wrap every handler.
			return true;
		}

		this._gatedRouter = tmpRouter;
		this._originalAddRoute = tmpRouter.addRoute.bind(tmpRouter);

		tmpRouter.addRoute = (pRoute, pRenderable, pTitle, pHooks) =>
		{
			const tmpDecision = this.routeDecision(pRoute);
			if (tmpDecision.Mode === 'Block')
			{
				this._noteBlocked(tmpDecision);
				return;
			}

			const tmpGuarded = (tmpDecision.Mode === 'Guard');
			if (tmpGuarded)
			{
				this.guardedRoutes.push(tmpDecision.Route);
			}
			else
			{
				this.allowedRoutes.push(tmpDecision.Route);
			}

			this._delegating = true;
			try
			{
				return this._originalAddRoute(tmpDecision.Route,
					tmpGuarded ? this._guardRenderable(tmpDecision.Route, pRenderable) : pRenderable, pTitle, pHooks);
			}
			finally
			{
				this._delegating = false;
			}
		};

		// The second funnel: direct registrations against the underlying router.
		if (tmpRouter.router && (typeof tmpRouter.router.on === 'function'))
		{
			this._originalRouterOn = tmpRouter.router.on.bind(tmpRouter.router);
			tmpRouter.router.on = (pRoute, pHandler, pHooks) =>
			{
				// Already decided by the provider-level wrapper, or one of the router's other
				// `on` shapes (a bare handler, or a route map) that carries no path to decide on.
				if (this._delegating || (typeof pRoute !== 'string'))
				{
					return this._originalRouterOn(pRoute, pHandler, pHooks);
				}

				const tmpDecision = this.routeDecision(pRoute);
				if (tmpDecision.Mode === 'Block')
				{
					this._noteBlocked(tmpDecision);
					return this._gatedRouter.router;
				}
				if (tmpDecision.Mode === 'Guard')
				{
					this.guardedRoutes.push(tmpDecision.Route);
					return this._originalRouterOn(tmpDecision.Route, this._guardRenderable(tmpDecision.Route, pHandler), pHooks);
				}
				this.allowedRoutes.push(tmpDecision.Route);
				return this._originalRouterOn(pRoute, pHandler, pHooks);
			};
		}

		return true;
	}

	/**
	 * Record (and optionally log) a route the gate refused.
	 *
	 * @param {{Route: String, Reason: String}} pDecision - the decision that blocked it
	 */
	_noteBlocked(pDecision)
	{
		this.blockedRoutes.push(pDecision.Route);
		if (this.options.LogBlockedRoutes)
		{
			this.pict.log.trace(`MicroApp [${ this.manifest.Name }] route not exposed: ${ pDecision.Route } (${ pDecision.Reason })`);
		}
	}

	/**
	 * Put the host's router back the way it was. Primarily for tests.
	 *
	 * @return {Boolean} whether a gate was removed
	 */
	releaseRouter()
	{
		if (!this._gatedRouter || !this._originalAddRoute)
		{
			return false;
		}
		this._gatedRouter.addRoute = this._originalAddRoute;
		if (this._originalRouterOn && this._gatedRouter.router)
		{
			this._gatedRouter.router.on = this._originalRouterOn;
		}
		this._originalAddRoute = null;
		this._originalRouterOn = null;
		this._gatedRouter = null;
		return true;
	}

	/**
	 * Wrap an entity-parameterized route's handler so an entity the micro app does not expose
	 * bounces to the fallback instead of rendering.
	 *
	 * Wildcard record-set routes ('/PSRS/:RecordSet/List') are registered once by the host and fan
	 * out over every entity it knows. They cannot be refused per-entity at registration time, so
	 * this is where the subsetting has to happen.
	 *
	 * @param {String} pRoute - the canonical route pattern
	 * @param {Function|String} pRenderable - the host's handler
	 * @return {Function|String} the guarded handler, or the renderable untouched when it is a template
	 */
	_guardRenderable(pRoute, pRenderable)
	{
		if (typeof pRenderable !== 'function')
		{
			return pRenderable;
		}
		const tmpEntityParameter = this.manifest.Routes.EntityParameter;
		return (pRouteData) =>
		{
			const tmpEntity = (pRouteData && pRouteData.data) ? pRouteData.data[tmpEntityParameter] : null;
			if (tmpEntity && !libManifest.entityPermitted(this.manifest, tmpEntity))
			{
				this.pict.log.trace(`MicroApp [${ this.manifest.Name }] entity not exposed on ${ pRoute }: ${ tmpEntity } — routing to ${ this.manifest.Routes.Fallback }.`);
				return this.navigate(this.manifest.Routes.Fallback);
			}
			return pRenderable(pRouteData);
		};
	}

	/**
	 * Send the browser to a route. Uses the host router when it is available so hooks and history
	 * behave the same as any other navigation.
	 *
	 * @param {String} pRoute - the route to navigate to
	 * @return {Boolean} whether a navigation was attempted
	 */
	navigate(pRoute)
	{
		const tmpRoute = libManifest.normalizeRoute(pRoute);
		const tmpRouter = this.pictRouter;
		if (tmpRouter && (typeof tmpRouter.navigate === 'function'))
		{
			tmpRouter.navigate(tmpRoute);
			return true;
		}
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = tmpRoute;
			return true;
		}
		return false;
	}

	/**
	 * Point a hash that matched no surviving route at the fallback, so a stale bookmark into a
	 * screen this micro app does not carry lands somewhere real instead of on a blank page.
	 *
	 * @param {Object} [pPictRouter] - the router provider; defaults to the configured one
	 * @return {Boolean} whether the handler was installed
	 */
	installNotFound(pPictRouter)
	{
		if (!this.manifest.Routes.CatchUnmatched)
		{
			return false;
		}
		const tmpRouter = pPictRouter || this.pictRouter;
		// `router` is the underlying navigo instance the pict provider wraps.
		if (!tmpRouter || !tmpRouter.router || (typeof tmpRouter.router.notFound !== 'function'))
		{
			return false;
		}
		tmpRouter.router.notFound(() =>
		{
			this.pict.log.trace(`MicroApp [${ this.manifest.Name }] unmatched route — routing to ${ this.manifest.Routes.Fallback }.`);
			this.navigate(this.manifest.Routes.Fallback);
		});
		return true;
	}

	/**
	 * Swap the host's navigation graph for the micro app's, and PIN it.
	 *
	 * Pinning is not paranoia. A host application of any size rebuilds its own navigation after the
	 * fact — as configuration loads, as permissions resolve, as dynamically registered sections
	 * appear — and each rebuild calls `setNavigationGraph` with the host's graph, silently undoing
	 * the swap. The symptom is the worst kind: the micro app's menu is correct at first paint and
	 * then quietly becomes the host's, usually after login, where nobody is looking.
	 *
	 * So rather than racing the host for the last write, the setter itself is wrapped: later calls
	 * still re-normalize and re-render, they just always land on the micro app's sections.
	 *
	 * @param {Object} [pNavigationProvider] - the navigation provider; defaults to the configured one
	 * @return {Boolean} whether the graph was swapped
	 */
	applyNavigationGraph(pNavigationProvider)
	{
		const tmpSections = this.manifest.Navigation.Sections;
		if (!tmpSections || (tmpSections.length < 1))
		{
			return false;
		}
		const tmpProvider = pNavigationProvider || this.navigationProvider;
		if (!tmpProvider || (typeof tmpProvider.setNavigationGraph !== 'function'))
		{
			this.pict.log.warn(`MicroApp [${ this.manifest.Name }] could not set the navigation graph: no navigation provider at '${ this.options.NavigationProviderHash }'.`);
			return false;
		}

		if (this.manifest.Navigation.PinGraph && !tmpProvider._microAppGraphPinned)
		{
			const fSetNavigationGraph = tmpProvider.setNavigationGraph.bind(tmpProvider);
			tmpProvider.setNavigationGraph = () => fSetNavigationGraph(tmpSections);
			tmpProvider._microAppGraphPinned = true;
		}

		tmpProvider.setNavigationGraph(tmpSections);
		return true;
	}

	/**
	 * Install the micro app's navigation visibility gate.
	 *
	 * A host that serves many audiences usually trims its own (large) graph hard — the Headlight
	 * platform app, for instance, shows platform super-users only the handful of cross-customer
	 * destinations. Applied to a micro app graph, which is already the slimmed surface, that trim
	 * empties the menu completely. So the default here keeps the host's real gates (session,
	 * module, capability) and drops only the audience short-circuit.
	 *
	 * @param {Function} pHostPermitted - (pItem) => Boolean, the host's own per-item capability test
	 * @param {Object} [pOptions] - { IsPrivileged: () => Boolean } to keep privileged sessions unfiltered
	 * @return {Boolean} whether the gate was installed
	 */
	applyNavigationGate(pHostPermitted, pOptions)
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider || (typeof tmpProvider.setGlobalFilter !== 'function'))
		{
			return false;
		}
		const tmpOptions = pOptions || {};
		const tmpIsPrivileged = (typeof tmpOptions.IsPrivileged === 'function') ? tmpOptions.IsPrivileged : (() => false);
		const tmpHonorHostGates = this.manifest.Navigation.HonorHostGates;
		const tmpSuperUserSeesEverything = this.manifest.Navigation.SuperUserSeesEverything;

		tmpProvider.setGlobalFilter((pItem, pCategory) =>
		{
			if (pItem.Hidden || (pCategory && pCategory.Hidden))
			{
				return false;
			}
			if (!tmpHonorHostGates)
			{
				return true;
			}
			// A privileged session holds no entitlements in the customer's own tenancy, so running
			// it through the capability test would blank the menu a second way. Show it everything.
			if (tmpSuperUserSeesEverything && tmpIsPrivileged())
			{
				return true;
			}
			return (typeof pHostPermitted === 'function') ? !!pHostPermitted(pItem, pCategory) : true;
		});
		return true;
	}

	/**
	 * Point the host's routing provider at the micro app's landing route.
	 *
	 * @param {Object} pHostRouterProvider - the provider that owns `defaultRoute` (often a wrapper
	 *        around pict-router rather than pict-router itself)
	 * @return {Boolean} whether the landing route was set
	 */
	applyDefaultRoute(pHostRouterProvider)
	{
		if (!pHostRouterProvider)
		{
			return false;
		}
		// Hosts spell this without the leading slash (navigo's own convention for a default).
		pHostRouterProvider.defaultRoute = this.manifest.DefaultRoute.replace(/^\//, '');
		return true;
	}

	/**
	 * Apply the manifest's branding to the document.
	 *
	 * @return {Boolean} whether a title was set
	 */
	applyBranding()
	{
		const tmpTitle = this.manifest.Branding.Title || this.manifest.Name;
		if (!tmpTitle || (typeof document === 'undefined'))
		{
			return false;
		}
		document.title = tmpTitle;
		return true;
	}

	/**
	 * A one-line summary of what the gate did, for the console and for tests.
	 *
	 * @return {{Name: String, Allowed: Number, Guarded: Number, Blocked: Number}} the tally
	 */
	get routeTally()
	{
		return (
			{
				Name: this.manifest.Name,
				Allowed: this.allowedRoutes.length,
				Guarded: this.guardedRoutes.length,
				Blocked: this.blockedRoutes.length
			});
	}
}

module.exports = PictMicroApp;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;
module.exports.Manifest = libManifest;
module.exports.composeMicroApp = require('./Pict-MicroApp-Compose.js');

},{"./Pict-MicroApp-Compose.js":826,"./Pict-MicroApp-Manifest.js":827,"pict-provider":830}],829:[function(require,module,exports){
arguments[4][551][0].apply(exports,arguments)
},{"dup":551}],830:[function(require,module,exports){
arguments[4][552][0].apply(exports,arguments)
},{"../package.json":829,"dup":552,"fable-serviceproviderbase":825}],831:[function(require,module,exports){
/**
 * Headlight Bridge Inspection — the first Headlight micro app.
 *
 * This app has almost no code of its own, and that is the point. It IS the Headlight platform
 * configuration application — same views, same providers, same styling, same boot sequence — with a
 * bridge-shaped surface laid over it by pict-microapp: the bridge dashboard as the landing screen,
 * a five-section menu, and a route allow list that exposes the inspection, bridge, team, document
 * and observation screens and nothing else.
 *
 * The practical consequence: a fix or a feature that lands in the platform app shows up here on the
 * next build, with no porting. Adding a screen to this app is one line in the manifest.
 *
 * Three files make up the whole app:
 *   BridgeInspection-MicroApp-Manifest.js   what the app exposes (routes, record sets, branding)
 *   BridgeInspection-Navigation-Graph.js    the menu
 *   this file                               the wiring, plus bridge-specific login branding
 *
 * The platform app is required by relative path rather than as a package dependency — the same way
 * it reaches into web/lims and web/headlight-form-editor. The build resolves it through the Docker
 * context (see the Dockerfile's ADD list), so browserify can walk its graph.
 */

const libPlatformConfiguration = require('../../headlight-platform-configuration/source/PlatformConfiguration-Application-Web.js');
const libPictMicroApp = require('pict-microapp');

const libBridgeManifest = require('./BridgeInspection-MicroApp-Manifest.js');

/**
 * Bridge branding for the shared Headlight login page.
 *
 * The platform app holds its own login options in a module-level constant and applies them at each
 * of the three places it can show the login screen, so they cannot be overridden by configuration.
 * `_brandLoginPage()` below wraps the login view's own customize method instead, which catches all
 * three call sites at once.
 */
const BRIDGE_LOGIN_PAGE_OPTIONS =
{
	title: 'Bridge Inspection',
	titleStyles: `
		z-index: 1;
		text-shadow:  5px 9px 2px var(--bulma-black);
		word-wrap: break-word;
		overflow-wrap: break-word;
		text-align: center;
		font-size: 4rem !important;
		margin: 0 0 5vh 0;`,
	wallpaperStyles: `
		background-image: url('../../images/headlight-bridge.jpg');
		background-size: cover;
		background-repeat: no-repeat;
		background-color: var(--bulma-grey);
		background-blend-mode: multiply;`,
	closePanelsOnLogout: true
};

/**
 * How pict-microapp binds the manifest to the platform application's own naming.
 *
 * `AttachOn` matters most: the route gate has to be installed after the platform app has created
 * its router provider (during onInitializeAsync) and before that router registers its routes
 * (during the login / data-load cycle). onAfterInitializeAsync sits exactly between the two.
 */
const BRIDGE_COMPOSE_OPTIONS =
{
	RouterProviderHash: 'PictRouter',
	HostRouterProviderHash: 'PlatformConfigurationRouter',
	NavigationProviderHash: 'Pict-Navigation',
	AttachOn: 'onAfterInitializeAsync',
	NavigationGateMethod: '_applyCustomerNavGate',
	HostPermittedMethod: '_navItemPermitted',
	IsPrivilegedMethod: '_isSuperUser'
};

class BridgeInspection extends libPictMicroApp.composeMicroApp(libPlatformConfiguration, libBridgeManifest, BRIDGE_COMPOSE_OPTIONS)
{
	/**
	 * The platform app registers its login view here, so this is the first moment the branding
	 * wrapper can be installed — before any of the three code paths that show the login page run.
	 *
	 * @return {any} the base class result
	 */
	onInitialize()
	{
		const tmpResult = super.onInitialize();
		this._brandLoginPage();
		return tmpResult;
	}

	/**
	 * Wrap the login view's customize method so the platform's options are applied first and the
	 * bridge's branding lands on top, wherever the platform app decides to show the login screen.
	 *
	 * @return {Boolean} whether the wrapper was installed
	 */
	/**
	 * This app's documentation, replacing the platform configuration app's.
	 *
	 * Without this override a bridge inspector opening the Academy lands on "Platform Configuration"
	 * and a table of contents about Master Lists, Pay Items and Customer Provisioning — the host app's
	 * docs, shipped verbatim into this app's serve folder. The content itself lives centrally in
	 * docs/academy/bridge-inspection/ and is copied in at build time (see package.json copyFiles).
	 *
	 * ContentHashPrefix is the load-bearing one: AcademyContent has no application column, so the Hash
	 * namespace is the ONLY thing separating this app's rows from the config app's. Sharing a prefix
	 * would mean each app's doc push silently overwrote the other's.
	 */
	get documentationProfile()
	{
		return (
			{
				DocsBaseURL: 'docs/',
				TopicsURL: 'docs/_topics.json',
				LandingArticle: 'overview.md',
				ContentHashPrefix: 'Doc-BridgeApp-',
				Title: 'Bridge Academy',
				Subtitle: 'Guides for inspecting, scheduling and reporting on bridges.',
			});
	}

	_brandLoginPage()
	{
		const tmpLoginView = this.pict.views.HeadlightLogin;
		if (!tmpLoginView || (typeof tmpLoginView.customizeLoginPage !== 'function') || tmpLoginView._bridgeBranded)
		{
			return false;
		}
		const fPlatformCustomize = tmpLoginView.customizeLoginPage.bind(tmpLoginView);
		tmpLoginView.customizeLoginPage = (pOptions) => fPlatformCustomize(Object.assign({}, pOptions, BRIDGE_LOGIN_PAGE_OPTIONS));
		tmpLoginView._bridgeBranded = true;
		return true;
	}
}

module.exports = BridgeInspection;

// The platform app's configuration is reused wholesale — its 164 form manifests, its ~60 record-set
// configurations, its field decoration and its PSRS wiring are exactly what the bridge screens run
// on. Only the product identity changes, so the server knows which app is asking.
module.exports.default_configuration = Object.assign({}, libPlatformConfiguration.default_configuration,
	{
		Name: 'Bridge Inspection',
		Hash: 'BridgeInspection'
	});

module.exports.default_configuration.pict_configuration = Object.assign({},
	libPlatformConfiguration.default_configuration.pict_configuration,
	{
		Product: 'BridgeInspection'
	});

},{"../../headlight-platform-configuration/source/PlatformConfiguration-Application-Web.js":1055,"./BridgeInspection-MicroApp-Manifest.js":832,"pict-microapp":828}],832:[function(require,module,exports){
/**
 * Headlight Bridge Inspection — the pict-microapp manifest.
 *
 * This file IS the app. Everything the bridge app is — where it lands, which of the platform's
 * several hundred routes it exposes, which record sets are reachable, what its menu looks like — is
 * declared here and applied by pict-microapp against the platform configuration application.
 *
 * Adding a screen to the bridge app is therefore a one-line change: build it once in the platform
 * app (where every customer benefits), then list its route here.
 *
 * ROUTE SPELLINGS MUST MATCH THE HOST EXACTLY. The allow list is compared against the pattern the
 * platform app passes to `addRoute`, parameter names included — '/Asset/Workspace/:ID' matches,
 * '/Asset/Workspace/:IDAsset' does not. When a screen comes up missing, read
 * `_Pict.providers.MicroApp.blockedRoutes` in the console: the route you meant to keep will be
 * sitting in it, spelled the way the host actually registered it.
 */

const libBridgeNavigation = require('./BridgeInspection-Navigation-Graph.js');

module.exports =
{
	Name: 'Bridge Inspection',
	Hash: 'BridgeInspection',

	// The bridge dashboard (map / browse / overview of every bridge) is the landing screen, and is
	// also where a route this app does not carry bounces to.
	DefaultRoute: '/AssetDashboard',

	Routes:
	{
		Allow:
		[
			// --- Landing: the bridge dashboard -------------------------------------------------
			// :View is map | browse | overview.
			'/AssetDashboard',
			'/AssetDashboard/:View',

			// --- The bridge itself: the PhysicalAsset workspace ---------------------------------
			// Note the entity/prefix mismatch in the host: entity PhysicalAsset, route prefix Asset.
			// Tabs: overview | location | elements | defects | observations | documents | migrate.
			'/Asset/Workspace/:ID',
			'/Asset/Workspace/:ID/:Tab',
			// GUID bridges the host registers so a record-set row opens the workspace. Assets are
			// externally synced, so the host deliberately bounces Create back to the list.
			'/PSRS/PhysicalAsset/View/:GUIDRecord',
			'/PSRS/PhysicalAsset/Edit/:GUIDRecord',
			'/PSRS/PhysicalAsset/Create',

			// --- Inspections --------------------------------------------------------------------
			// :View is overview | list | calendar (plus year | month | week | timeline).
			'/InspectionSchedule',
			'/InspectionSchedule/:View',
			// Tabs: overview | assets | documents | inspectors | teams | timeline.
			'/Inspection/Workspace/:ID',
			'/Inspection/Workspace/:ID/:Tab',
			'/PSRS/Inspection/View/:GUIDRecord',
			// Schedule an inspection — the bespoke create screen, which also generates the document packet.
			// The /ForAsset/ form is how the bridge workspace's "Schedule inspection" action arrives.
			// Listed explicitly: the entity guard would admit these anyway, but a route this app depends on
			// should not be exposed only incidentally.
			'/PSRS/Inspection/Create',
			'/PSRS/Inspection/Create/ForAsset/:IDPhysicalAsset',

			// --- Teams ---------------------------------------------------------------------------
			// Tabs: overview | members | documents | projects | inspections | subteams | labs. The
			// schedule's team lane deep-links the :Tab form, so both are load-bearing.
			'/Team/Workspace/:ID',
			'/Team/Workspace/:ID/:Tab',
			'/PSRS/Team/View/:GUIDRecord',

			// --- Documents -----------------------------------------------------------------------
			// The throughput dashboard is reached from the nav as /DocumentThroughput/Inspection-Dossier,
			// and the inspection schedule's overview embeds the same provider inline.
			'/DocumentThroughput',
			'/DocumentThroughput/:Type',
			// These three are LITERAL routes in the host, shadowing the generic record-set list on
			// purpose (the generic one scans the whole Documents table). Keep all three.
			'/PSRS/Document/List',
			'/Documents/Browse',
			'/Documents/Explore',
			'/Document/Workspace/:ID',
			'/Document/Workspace/:ID/:Tab',
			'/PSRS/Document/View/:GUIDRecord',

			// --- Observations --------------------------------------------------------------------
			// Same shape: literal routes backed by the fast Solr-indexed list, three view modes.
			'/PSRS/Observation/List',
			'/Observations',
			'/ObservationExplorer',
			'/Observations/Explore',
			'/Observations/Map',
			'/Observation/Workspace/:ID',
			'/Observation/Workspace/:ID/:Tab',
			'/PSRS/Observation/View/:GUIDRecord',

			// --- Projects -------------------------------------------------------------------------
			// Not in the menu, but reachable: the inspection schedule links a project by name, and an
			// inspection's documents live under one. Dropping these would leave dead links on screens
			// this app does carry.
			'/Project/Workspace/:ID',
			'/Project/Workspace/:ID/:Tab',
			'/PSRS/Project/View/:GUIDRecord',

			// --- Asset setup (advanced) -------------------------------------------------------------
			'/AssetTypeManifests',
			'/AssetTypeManifests/:IDAssetType',
			'/AssetTypeDescriptor',
			'/AssetCatalogSync',

			// --- Documentation ----------------------------------------------------------------------
			'/Academy',
			'/Academy/:Topic',

			// The host's own alias for "go to the landing screen".
			'/Dashboard'
		],

		Deny: [],

		// The platform app registers ONE wildcard route per record-set verb
		// ('/PSRS/:RecordSet/List' and friends) covering all ~60 of its record sets, so they cannot
		// be dropped entity by entity at registration time. pict-microapp guards them instead: the
		// routes register, but an entity that is not listed here bounces to the dashboard.
		//
		// This is the list of record sets the bridge app exposes. It is deliberately a little wider
		// than the menu, because workspace association tabs link out to related records.
		EntityParameter: 'RecordSet',
		Entities:
		[
			'PhysicalAsset',
			'PhysicalAssetElement',
			'PhysicalAssetElementType',
			'PhysicalAssetMaterial',
			'PhysicalAssetDefect',
			'PhysicalAssetMetadata',
			'AssetType',
			'AssetClassification',
			'Inspection',
			'InspectionType',
			'Team',
			'Document',
			'Observation',
			'ObservationManifest',
			'Project',
			'User',
			'Organization',
			'Lab',
			'Equipment'
		],

		CatchUnmatched: true
	},

	Navigation:
	{
		Sections: libBridgeNavigation.BRIDGE_SECTIONS,
		// Keep the platform's capability / module gating, drop its super-user short-circuit — that
		// short-circuit exists to trim the platform's huge menu down for cross-customer staff, and
		// applied to this five-section graph it would hide the whole app from the people building it.
		SuperUserSeesEverything: true,
		HonorHostGates: true
	},

	Branding:
	{
		Title: 'Headlight Bridge Inspection'
	}
};

},{"./BridgeInspection-Navigation-Graph.js":833}],833:[function(require,module,exports){
/**
 * Headlight Bridge Inspection — navigation graph for pict-section-navigation.
 *
 * This is the micro app's whole menu. It replaces the platform configuration app's ~200-entry graph
 * (swapped in by pict-microapp via `setNavigationGraph`), so every destination a bridge inspector or
 * program manager needs has to be here — and nothing else should be.
 *
 * The node shape is the platform app's: `Hash` is stable identity, `Route` is an app hash route,
 * `Icon` is a Font Awesome class, `Accent` is a pict theme token. `Capability: '<Entity>-<Action>'`
 * gates an entry on the signed-in user's effective permissions; a `#/PSRS/<Entity>/List` route
 * derives `<Entity>-Read` automatically, so only non-PSRS entries need one spelled out. `Advanced`
 * entries stay hidden until the user asks to see advanced items or searches for them.
 *
 * Keep this in step with the route allow list in BridgeInspection-MicroApp-Manifest.js: a nav entry
 * pointing at a route the manifest does not expose is a dead link, and pict-microapp will not catch
 * it for you (it gates routes, not menu items).
 */

const BRIDGE_SECTIONS =
[
	{
		Name: 'Inspections', Hash: 'inspections', Icon: 'fas fa-clipboard-check', Accent: 'var(--theme-color-brand-primary)',
		Blurb: 'Plan the inspection program, then work the inspections themselves.',
		Children:
		[
			{
				Name: 'Inspection Schedule', Icon: 'fas fa-calendar-days', Route: '#/InspectionSchedule', Capability: 'Inspection-Read',
				Keywords: 'schedule calendar overview worklist upcoming overdue due deadline program oversight timeline year month week',
				Description: 'The program view of every inspection — what is due, what is overdue, and what each team is carrying.'
			},
			{
				Name: 'Inspections', Icon: 'fas fa-clipboard-list', Route: '#/PSRS/Inspection/List', Capability: 'Inspection-Read',
				Keywords: 'inspection list search routine nstm underwater element dossier status scheduled completed',
				Description: 'Every inspection as a searchable list — open one to work its documents, assets, inspectors and teams.'
			},
			{
				Name: 'Approval Throughput', Icon: 'fas fa-gauge-high', Route: '#/DocumentThroughput/Inspection-Dossier', Capability: 'Document-Read',
				Keywords: 'throughput approval workflow dossier cycle time bottleneck submitter reviewer pipeline turnaround',
				Description: 'How inspection dossiers move through approval — cycle times, where they stall, and who is carrying the load.'
			}
		]
	},
	{
		Name: 'Bridges', Hash: 'bridges', Icon: 'fas fa-bridge', Accent: 'var(--theme-color-status-success)',
		Blurb: 'The bridge inventory, on a map and in detail.',
		Children:
		[
			{
				Name: 'Bridge Dashboard', Icon: 'fas fa-map-location-dot', Route: '#/AssetDashboard', Capability: 'PhysicalAsset-Read',
				Keywords: 'bridge dashboard map browse overview inventory snbi asset structure county carried intersected search landing',
				Description: 'Every bridge on a map, with SNBI metadata and inspection status — the app’s landing screen.'
			},
			{
				Name: 'Bridge Inventory', Icon: 'fas fa-table-list', Route: '#/PSRS/PhysicalAsset/List', Capability: 'PhysicalAsset-Read',
				Keywords: 'asset inventory list bridge structure number search physical asset raw records table',
				Description: 'The bridge inventory as a searchable table — open one to get its full workspace.'
			}
		]
	},
	{
		Name: 'Teams', Hash: 'teams', Icon: 'fas fa-users', Accent: 'var(--theme-color-status-info)',
		Blurb: 'The crews doing the work, and what they have been assigned.',
		Children:
		[
			{
				Name: 'Teams', Icon: 'fas fa-users', Route: '#/PSRS/Team/List', Capability: 'Team-Read',
				Keywords: 'team crew inspector member roster assignment subteam lab project inspection who',
				Description: 'Inspection teams, their members, and the inspections and projects each one is assigned to.'
			}
		]
	},
	{
		Name: 'Field Data', Hash: 'field-data', Icon: 'fas fa-camera', Accent: 'var(--theme-color-status-warning)',
		Blurb: 'What came back from the field.',
		Children:
		[
			{
				Name: 'Observations', Icon: 'fas fa-clipboard-check', Route: '#/Observations', Capability: 'Observation-Read',
				Keywords: 'observation field data photo artifact capture list chart map explore faceted search defect condition',
				Description: 'Field observations as a list, a set of charts, or a map — cross-filter by type and reporting status.'
			},
			{
				Name: 'Documents', Icon: 'fas fa-file-lines', Route: '#/Documents/Browse', Capability: 'Document-Read',
				Keywords: 'document browse report form dossier element inspection approval status search list chart',
				Description: 'Browse the documents behind the inspections — reports, forms and dossiers, with their approval state.'
			}
		]
	},
	{
		Name: 'Asset Setup', Hash: 'asset-setup', Icon: 'fas fa-gears', Accent: 'var(--theme-color-text-muted)',
		Blurb: 'Configure what a bridge record carries and where the catalog comes from.',
		Children:
		[
			{
				Name: 'Metadata Shape', Icon: 'fas fa-sliders', Route: '#/AssetTypeDescriptor', Capability: 'AssetType-Read', Advanced: true,
				Keywords: 'metadata shape descriptor show hide visible field label units help metric map display customize rename reorder publish draft snbi',
				Description: 'What a bridge\u2019s detail panel shows: which values appear, what they are called, their units and help, and which the map can be coloured by.'
			},
			{
				Name: 'Asset Type Manifests', Icon: 'fas fa-diagram-project', Route: '#/AssetTypeManifests', Capability: 'AssetType-Read', Advanced: true,
				Keywords: 'asset type manifest custom property schema snbi submission field definition configure metadata',
				Description: 'The custom-property schema each asset type carries — including the SNBI submission shape.'
			},
			{
				Name: 'Sync Asset Catalog', Icon: 'fas fa-cloud-arrow-down', Route: '#/AssetCatalogSync', Capability: 'PhysicalAsset-Create', Advanced: true,
				Keywords: 'sync catalog aashto seed element type defect material public data lake import bootstrap',
				Description: 'Seed this customer’s asset element, defect and material catalog from the shared public data lake.'
			}
		]
	}
];

module.exports = BRIDGE_SECTIONS;
module.exports.BRIDGE_SECTIONS = BRIDGE_SECTIONS;

},{}],834:[function(require,module,exports){
/**
 * ManifestSchema part helpers (dependency-free).
 *
 * A schema-backed form keeps its manifest in a root ManifestSchema record plus ordered
 * ManifestSchemaPartial records, linked from the RNI by Options.FormManifestSchemaID/Hash
 * (header) and Options.FormFooterManifestSchemaID/Hash (footer). composeParts() merges one
 * record set exactly like the runtime loaders (report_definitions LoadFormManifest,
 * ManifestLoaderService._mergeManifests); splitParts() is its inverse, so a save writes each
 * record back holding only what it owns.
 */

const ROOT_OWNER = 'root';
const MERGED_KEYS = [ 'Descriptors', 'Sections', 'ReferenceManifests' ];

function cloneJSON(pValue)
{
	return (pValue === undefined) ? undefined : JSON.parse(JSON.stringify(pValue));
}

function isPlainObject(pValue)
{
	return Boolean(pValue) && (typeof pValue === 'object') && !Array.isArray(pValue);
}

/**
 * Parse a Manifest / ManifestPartial column; the API may hand it back as an object or a JSON string.
 *
 * @param {*} pValue
 * @return {object|null}
 */
function parseManifestField(pValue)
{
	if (isPlainObject(pValue))
	{
		return pValue;
	}
	if (typeof pValue === 'string' && pValue.trim().length > 0)
	{
		try
		{
			const tmpParsed = JSON.parse(pValue);
			return isPlainObject(tmpParsed) ? tmpParsed : null;
		}
		catch (pError)
		{
			return null;
		}
	}
	return null;
}

function _ref(pID, pHash)
{
	const tmpID = parseInt(pID, 10) || 0;
	const tmpHash = (typeof pHash === 'string') ? pHash.trim() : '';
	return (tmpID > 0 || tmpHash) ? { ID: tmpID, Hash: tmpHash } : null;
}

/**
 * Classify where an RNI's manifest lives, using the runtime's precedence: any FormDefinition
 * object wins and the schema references are ignored.
 *
 * StubFormDefinition flags a schema-backed form whose Options also carry a FormDefinition with no
 * manifest in it (e.g. `{ Product }` left by an older Metadata save) — the runtime loads that stub.
 *
 * @param {object} pOptions - Parsed RNI Options.
 * @return {{ Mode: ('embedded'|'schema'|'none'), Header: ?{ ID: number, Hash: string }, Footer: ?{ ID: number, Hash: string }, IgnoredRefs: boolean, StubFormDefinition: boolean }}
 */
function getManifestStorage(pOptions)
{
	const tmpOptions = isPlainObject(pOptions) ? pOptions : {};
	const tmpHeader = _ref(tmpOptions.FormManifestSchemaID, tmpOptions.FormManifestSchemaHash);
	const tmpFooter = _ref(tmpOptions.FormFooterManifestSchemaID, tmpOptions.FormFooterManifestSchemaHash);
	const tmpHasRefs = Boolean(tmpHeader || tmpFooter);
	const tmpDefinition = isPlainObject(tmpOptions.FormDefinition) ? tmpOptions.FormDefinition : null;
	const tmpDefinitionHasManifest = Boolean(tmpDefinition) &&
		(isPlainObject(tmpDefinition.DefaultFormManifest) || Boolean(tmpDefinition.Descriptors) || Boolean(tmpDefinition.Sections));

	const fResult = (pMode, pExtra) => Object.assign(
		{ Mode: pMode, Header: tmpHeader, Footer: tmpFooter, IgnoredRefs: false, StubFormDefinition: false }, pExtra);

	if (tmpDefinitionHasManifest)
	{
		return fResult('embedded', { IgnoredRefs: tmpHasRefs });
	}
	if (tmpHasRefs)
	{
		return fResult('schema', { StubFormDefinition: Boolean(tmpDefinition) });
	}
	if (tmpDefinition || isPlainObject(tmpOptions.DefaultFormManifest))
	{
		return fResult('embedded');
	}
	return fResult('none');
}

function _partialOwner(pPartialRecord)
{
	return String(pPartialRecord.IDManifestSchemaPartial);
}

function _sectionExists(pSections, pHash)
{
	return pSections.some((pSection) => pSection && pSection.Hash === pHash);
}

/**
 * Merge a root ManifestSchema record with its partials, recording which record supplied each item.
 *
 * @param {object} pRootRecord - ManifestSchema record (`.Manifest`).
 * @param {Array<object>} pPartialRecords - ManifestSchemaPartial records (`.ManifestPartial`), in join Ordinal order.
 * @return {{ Manifest: object, Owners: { Descriptors: Object<string, string>, Sections: Object<string, string>, ReferenceManifests: Object<string, string> } }}
 */
function composeParts(pRootRecord, pPartialRecords)
{
	const tmpManifest = cloneJSON(parseManifestField(pRootRecord && pRootRecord.Manifest)) || {};
	if (!isPlainObject(tmpManifest.Descriptors)) { tmpManifest.Descriptors = {}; }
	if (!Array.isArray(tmpManifest.Sections)) { tmpManifest.Sections = []; }
	if (!isPlainObject(tmpManifest.ReferenceManifests)) { tmpManifest.ReferenceManifests = {}; }

	const tmpOwners = { Descriptors: {}, Sections: {}, ReferenceManifests: {} };
	for (const tmpKey of Object.keys(tmpManifest.Descriptors)) { tmpOwners.Descriptors[tmpKey] = ROOT_OWNER; }
	for (const tmpKey of Object.keys(tmpManifest.ReferenceManifests)) { tmpOwners.ReferenceManifests[tmpKey] = ROOT_OWNER; }
	for (const tmpSection of tmpManifest.Sections)
	{
		if (tmpSection && tmpSection.Hash) { tmpOwners.Sections[tmpSection.Hash] = ROOT_OWNER; }
	}

	for (const tmpPartial of (pPartialRecords || []))
	{
		const tmpSource = parseManifestField(tmpPartial && tmpPartial.ManifestPartial);
		if (!tmpSource) { continue; }
		const tmpOwner = _partialOwner(tmpPartial);

		// First-wins with a falsy check, mirroring the runtime merge.
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(isPlainObject(tmpSource.Descriptors) ? tmpSource.Descriptors : {}))
		{
			if (!tmpManifest.Descriptors[tmpKey])
			{
				tmpManifest.Descriptors[tmpKey] = cloneJSON(tmpDescriptor);
				tmpOwners.Descriptors[tmpKey] = tmpOwner;
			}
		}
		for (const tmpSection of (Array.isArray(tmpSource.Sections) ? tmpSource.Sections : []))
		{
			if (tmpSection && !_sectionExists(tmpManifest.Sections, tmpSection.Hash))
			{
				tmpManifest.Sections.push(cloneJSON(tmpSection));
				if (tmpSection.Hash) { tmpOwners.Sections[tmpSection.Hash] = tmpOwner; }
			}
		}
		for (const [ tmpKey, tmpReference ] of Object.entries(isPlainObject(tmpSource.ReferenceManifests) ? tmpSource.ReferenceManifests : {}))
		{
			if (!tmpManifest.ReferenceManifests[tmpKey])
			{
				tmpManifest.ReferenceManifests[tmpKey] = cloneJSON(tmpReference);
				tmpOwners.ReferenceManifests[tmpKey] = tmpOwner;
			}
		}
	}

	return { Manifest: tmpManifest, Owners: tmpOwners };
}

/**
 * Append a footer manifest onto a header manifest the way the runtime does (additive, first-wins).
 *
 * @param {object} pHeaderManifest
 * @param {object} [pFooterManifest]
 * @return {object} A new merged manifest; the inputs are not mutated.
 */
function composeForm(pHeaderManifest, pFooterManifest)
{
	const tmpManifest = cloneJSON(pHeaderManifest) || {};
	if (!isPlainObject(tmpManifest.Descriptors)) { tmpManifest.Descriptors = {}; }
	if (!Array.isArray(tmpManifest.Sections)) { tmpManifest.Sections = []; }
	if (!isPlainObject(tmpManifest.ReferenceManifests)) { tmpManifest.ReferenceManifests = {}; }
	if (!isPlainObject(pFooterManifest)) { return tmpManifest; }

	for (const [ tmpKey, tmpDescriptor ] of Object.entries(pFooterManifest.Descriptors || {}))
	{
		if (!tmpManifest.Descriptors[tmpKey]) { tmpManifest.Descriptors[tmpKey] = cloneJSON(tmpDescriptor); }
	}
	for (const tmpSection of (Array.isArray(pFooterManifest.Sections) ? pFooterManifest.Sections : []))
	{
		if (tmpSection && !_sectionExists(tmpManifest.Sections, tmpSection.Hash)) { tmpManifest.Sections.push(cloneJSON(tmpSection)); }
	}
	for (const [ tmpKey, tmpReference ] of Object.entries(pFooterManifest.ReferenceManifests || {}))
	{
		if (!tmpManifest.ReferenceManifests[tmpKey]) { tmpManifest.ReferenceManifests[tmpKey] = cloneJSON(tmpReference); }
	}
	return tmpManifest;
}

/**
 * Compose one loaded source — header, footer, or both — into the single manifest a document
 * renders, so every reader of a schema-backed form sees the same thing.
 *
 * @param {{ Parts: object }} pSource - A FormEditorManifestSchemaParts.loadSource() result.
 * @return {object|null} The composed manifest, or null when neither part loaded.
 */
function composeSourceManifest(pSource)
{
	const tmpParts = (pSource && pSource.Parts) || {};
	const tmpHeader = tmpParts.Header && tmpParts.Header.Composition && tmpParts.Header.Composition.Manifest;
	const tmpFooter = tmpParts.Footer && tmpParts.Footer.Composition && tmpParts.Footer.Composition.Manifest;
	if (tmpHeader)
	{
		return composeForm(tmpHeader, tmpFooter);
	}
	return tmpFooter ? cloneJSON(tmpFooter) : null;
}

/**
 * Split an edited manifest back into the records composeParts() read it from.
 *
 * Items go back to the record that supplied them at load. New items join the part that owns their
 * section (a new section joins the part of the section before it), else the root. An item deleted in
 * the edit leaves every record, shadowed copies included, so it cannot resurface on the next load.
 * Non-merged top-level keys belong to the root.
 *
 * @param {object} pEditedManifest
 * @param {object} pRootRecord - The ManifestSchema record as loaded.
 * @param {Array<object>} pPartialRecords - The partial records as loaded, in join Ordinal order.
 * @param {{ Owners: object }} pComposition - composeParts() output from load time.
 * @return {{ Root: object, Partials: Object<string, object> }}
 */
function splitParts(pEditedManifest, pRootRecord, pPartialRecords, pComposition)
{
	const tmpEdited = cloneJSON(pEditedManifest) || {};
	const tmpDescriptors = isPlainObject(tmpEdited.Descriptors) ? tmpEdited.Descriptors : {};
	const tmpSections = Array.isArray(tmpEdited.Sections) ? tmpEdited.Sections : [];
	const tmpReferences = isPlainObject(tmpEdited.ReferenceManifests) ? tmpEdited.ReferenceManifests : {};
	const tmpPartials = pPartialRecords || [];
	const tmpOwners = (pComposition && pComposition.Owners) || { Descriptors: {}, Sections: {}, ReferenceManifests: {} };

	const tmpBuckets = {};
	tmpBuckets[ROOT_OWNER] = { Descriptors: {}, Sections: [], ReferenceManifests: {} };
	for (const tmpPartial of tmpPartials)
	{
		tmpBuckets[_partialOwner(tmpPartial)] = { Descriptors: {}, Sections: [], ReferenceManifests: {} };
	}
	const fKnown = (pOwner) => ((typeof pOwner === 'string') && tmpBuckets[pOwner]) ? pOwner : null;

	// Sections first: descriptors and reference manifests place themselves by section.
	const tmpSectionOwners = {};
	let tmpPrevious = ROOT_OWNER;
	for (const tmpSection of tmpSections)
	{
		const tmpHash = tmpSection && tmpSection.Hash;
		const tmpOwner = (tmpHash && fKnown(tmpOwners.Sections[tmpHash])) || tmpPrevious;
		if (tmpHash) { tmpSectionOwners[tmpHash] = tmpOwner; }
		tmpBuckets[tmpOwner].Sections.push(tmpSection);
		tmpPrevious = tmpOwner;
	}

	const tmpReferenceUse = {};
	for (const tmpSection of tmpSections)
	{
		for (const tmpGroup of ((tmpSection && Array.isArray(tmpSection.Groups)) ? tmpSection.Groups : []))
		{
			const tmpName = tmpGroup && tmpGroup.RecordManifest;
			if (tmpName && !tmpReferenceUse[tmpName]) { tmpReferenceUse[tmpName] = tmpSectionOwners[tmpSection.Hash] || ROOT_OWNER; }
		}
	}
	for (const [ tmpKey, tmpValue ] of Object.entries(tmpReferences))
	{
		const tmpOwner = fKnown(tmpOwners.ReferenceManifests[tmpKey]) || tmpReferenceUse[tmpKey] || ROOT_OWNER;
		tmpBuckets[tmpOwner].ReferenceManifests[tmpKey] = tmpValue;
	}

	for (const [ tmpKey, tmpValue ] of Object.entries(tmpDescriptors))
	{
		const tmpSectionHash = tmpValue && tmpValue.PictForm && tmpValue.PictForm.Section;
		const tmpOwner = fKnown(tmpOwners.Descriptors[tmpKey]) || (tmpSectionHash && tmpSectionOwners[tmpSectionHash]) || ROOT_OWNER;
		tmpBuckets[tmpOwner].Descriptors[tmpKey] = tmpValue;
	}

	// A partial keeps its shadowed copy of a key another record owns, unless the edit deleted the key.
	const tmpEditedHashes = new Set(tmpSections.map((pSection) => pSection && pSection.Hash).filter(Boolean));
	const fKeepShadowed = (pBucket, pSource) =>
	{
		for (const [ tmpKey, tmpValue ] of Object.entries(isPlainObject(pSource.Descriptors) ? pSource.Descriptors : {}))
		{
			if (Object.prototype.hasOwnProperty.call(tmpDescriptors, tmpKey) && !Object.prototype.hasOwnProperty.call(pBucket.Descriptors, tmpKey))
			{
				pBucket.Descriptors[tmpKey] = tmpValue;
			}
		}
		for (const tmpSection of (Array.isArray(pSource.Sections) ? pSource.Sections : []))
		{
			const tmpHash = tmpSection && tmpSection.Hash;
			if (tmpHash && tmpEditedHashes.has(tmpHash) && !_sectionExists(pBucket.Sections, tmpHash))
			{
				pBucket.Sections.push(tmpSection);
			}
		}
		for (const [ tmpKey, tmpValue ] of Object.entries(isPlainObject(pSource.ReferenceManifests) ? pSource.ReferenceManifests : {}))
		{
			if (Object.prototype.hasOwnProperty.call(tmpReferences, tmpKey) && !Object.prototype.hasOwnProperty.call(pBucket.ReferenceManifests, tmpKey))
			{
				pBucket.ReferenceManifests[tmpKey] = tmpValue;
			}
		}
	};

	// Don't add an empty container the record never had.
	const fSetContainers = (pTarget, pBucket, pOriginal) =>
	{
		for (const tmpKey of MERGED_KEYS)
		{
			const tmpValue = pBucket[tmpKey];
			const tmpEmpty = Array.isArray(tmpValue) ? (tmpValue.length === 0) : (Object.keys(tmpValue).length === 0);
			if (!tmpEmpty || (pOriginal && Object.prototype.hasOwnProperty.call(pOriginal, tmpKey)))
			{
				pTarget[tmpKey] = tmpValue;
			}
			else
			{
				delete pTarget[tmpKey];
			}
		}
		return pTarget;
	};

	const tmpRootOriginal = parseManifestField(pRootRecord && pRootRecord.Manifest) || {};
	const tmpRoot = {};
	for (const tmpKey of Object.keys(tmpEdited))
	{
		tmpRoot[tmpKey] = MERGED_KEYS.includes(tmpKey) ? null : tmpEdited[tmpKey];
	}
	fSetContainers(tmpRoot, tmpBuckets[ROOT_OWNER], tmpRootOriginal);

	const tmpPartialManifests = {};
	for (const tmpPartial of tmpPartials)
	{
		const tmpOwner = _partialOwner(tmpPartial);
		const tmpOriginal = parseManifestField(tmpPartial.ManifestPartial) || {};
		fKeepShadowed(tmpBuckets[tmpOwner], tmpOriginal);
		const tmpNext = {};
		for (const tmpKey of Object.keys(tmpOriginal))
		{
			tmpNext[tmpKey] = MERGED_KEYS.includes(tmpKey) ? null : cloneJSON(tmpOriginal[tmpKey]);
		}
		tmpPartialManifests[tmpOwner] = fSetContainers(tmpNext, tmpBuckets[tmpOwner], tmpOriginal);
	}

	return { Root: tmpRoot, Partials: tmpPartialManifests };
}

function _canonical(pValue)
{
	if (Array.isArray(pValue))
	{
		return pValue.map(_canonical);
	}
	if (isPlainObject(pValue))
	{
		const tmpResult = {};
		for (const tmpKey of Object.keys(pValue).sort())
		{
			if (pValue[tmpKey] !== undefined) { tmpResult[tmpKey] = _canonical(pValue[tmpKey]); }
		}
		return tmpResult;
	}
	return pValue;
}

function canonicalJSON(pValue)
{
	return JSON.stringify(_canonical(pValue === undefined ? null : pValue));
}

function _clearRows(pSections)
{
	for (const tmpSection of (Array.isArray(pSections) ? pSections : []))
	{
		for (const tmpGroup of ((tmpSection && Array.isArray(tmpSection.Groups)) ? tmpSection.Groups : []))
		{
			if (tmpGroup) { delete tmpGroup.Rows; }
		}
	}
}

/**
 * Add the bare groups the editor creates when it loads a manifest: one for each descriptor Group its
 * Section does not declare, and a default group for a section with descriptors but no groups. Mirrors
 * pict-section-formeditor's `_ensureSectionGroups` (Pict-Provider-FormEditorManifestOps.js); the two must
 * not drift. The runtime builds the same groups, so adding them changes nothing that renders.
 *
 * @param {object} pManifest - Mutated.
 */
function _addEditorGroups(pManifest)
{
	if (!Array.isArray(pManifest.Sections) || !isPlainObject(pManifest.Descriptors))
	{
		return;
	}
	const tmpSections = {};
	for (const tmpSection of pManifest.Sections)
	{
		if (!isPlainObject(tmpSection))
		{
			continue;
		}
		if (!Array.isArray(tmpSection.Groups))
		{
			tmpSection.Groups = [];
		}
		if (tmpSection.Hash)
		{
			tmpSections[tmpSection.Hash] = tmpSection;
		}
	}
	for (const tmpDescriptor of Object.values(pManifest.Descriptors))
	{
		const tmpPictForm = isPlainObject(tmpDescriptor) ? tmpDescriptor.PictForm : null;
		const tmpSection = (isPlainObject(tmpPictForm) && tmpPictForm.Section) ? tmpSections[tmpPictForm.Section] : null;
		if (!tmpSection)
		{
			continue;
		}
		const tmpGroupHash = tmpPictForm.Group || '';
		if (!tmpGroupHash)
		{
			if (tmpSection.Groups.length === 0)
			{
				tmpSection.Groups.push({ Hash: `${tmpSection.Hash}Group_Default`, Name: 'Default', Layout: 'Record' });
			}
		}
		else if (!tmpSection.Groups.some((pGroup) => pGroup && pGroup.Hash === tmpGroupHash))
		{
			tmpSection.Groups.push({ Hash: tmpGroupHash, Name: tmpGroupHash, Layout: 'Record' });
		}
	}
}

/**
 * Comparable form of a manifest: the groups the editor adds on load included, Group Rows cleared (the
 * platform rebuilds them at load) and empty top-level containers dropped, so a no-op edit compares
 * equal to what was stored.
 *
 * @param {object} pManifest
 * @return {object}
 */
function normalizeForCompare(pManifest)
{
	const tmpManifest = cloneJSON(parseManifestField(pManifest)) || {};
	_addEditorGroups(tmpManifest);
	_clearRows(tmpManifest.Sections);
	for (const tmpReference of Object.values(isPlainObject(tmpManifest.ReferenceManifests) ? tmpManifest.ReferenceManifests : {}))
	{
		if (tmpReference) { _clearRows(tmpReference.Sections); }
	}
	for (const tmpKey of Object.keys(tmpManifest))
	{
		const tmpValue = tmpManifest[tmpKey];
		if ((Array.isArray(tmpValue) && tmpValue.length === 0) || (isPlainObject(tmpValue) && Object.keys(tmpValue).length === 0))
		{
			delete tmpManifest[tmpKey];
		}
	}
	return tmpManifest;
}

function _keyedDiff(pBefore, pAfter)
{
	const tmpBefore = pBefore || {};
	const tmpAfter = pAfter || {};
	const tmpResult = { Added: 0, Removed: 0, Modified: 0 };
	for (const tmpKey of Object.keys(tmpAfter))
	{
		if (!Object.prototype.hasOwnProperty.call(tmpBefore, tmpKey)) { tmpResult.Added++; }
		else if (canonicalJSON(tmpBefore[tmpKey]) !== canonicalJSON(tmpAfter[tmpKey])) { tmpResult.Modified++; }
	}
	for (const tmpKey of Object.keys(tmpBefore))
	{
		if (!Object.prototype.hasOwnProperty.call(tmpAfter, tmpKey)) { tmpResult.Removed++; }
	}
	return tmpResult;
}

function _sectionsByHash(pSections)
{
	const tmpResult = {};
	(Array.isArray(pSections) ? pSections : []).forEach((pSection, pIndex) =>
	{
		tmpResult[(pSection && pSection.Hash) || `#${pIndex}`] = pSection;
	});
	return tmpResult;
}

/**
 * Describe what changes between two versions of one record's manifest.
 *
 * @return {{ Changed: boolean, Descriptors: object, Sections: object, ReferenceManifests: object, SectionOrder: boolean, Settings: boolean }}
 */
function describeRecordChange(pBefore, pAfter)
{
	const tmpBefore = normalizeForCompare(pBefore);
	const tmpAfter = normalizeForCompare(pAfter);
	const tmpSettingsOf = (pManifest) =>
	{
		const tmpSettings = Object.assign({}, pManifest);
		for (const tmpKey of MERGED_KEYS) { delete tmpSettings[tmpKey]; }
		return canonicalJSON(tmpSettings);
	};
	const tmpHashOrder = (pManifest) => (Array.isArray(pManifest.Sections) ? pManifest.Sections : []).map((pSection) => pSection && pSection.Hash);
	const tmpBeforeHashes = tmpHashOrder(tmpBefore);
	const tmpAfterHashes = tmpHashOrder(tmpAfter).filter((pHash) => tmpBeforeHashes.includes(pHash));

	return {
		Changed: canonicalJSON(tmpBefore) !== canonicalJSON(tmpAfter),
		Descriptors: _keyedDiff(tmpBefore.Descriptors, tmpAfter.Descriptors),
		Sections: _keyedDiff(_sectionsByHash(tmpBefore.Sections), _sectionsByHash(tmpAfter.Sections)),
		ReferenceManifests: _keyedDiff(tmpBefore.ReferenceManifests, tmpAfter.ReferenceManifests),
		SectionOrder: canonicalJSON(tmpBeforeHashes.filter((pHash) => tmpAfterHashes.includes(pHash))) !== canonicalJSON(tmpAfterHashes),
		Settings: tmpSettingsOf(tmpBefore) !== tmpSettingsOf(tmpAfter),
	};
}

/**
 * Plan a save: split the edit, find the records that actually change, and check that re-composing
 * the split reproduces the edit (section order across parts is the one thing a split cannot keep).
 *
 * @param {object} pEditedManifest - Already prepared for save (Rows cleared).
 * @param {object} pRootRecord
 * @param {Array<object>} pPartialRecords - In join Ordinal order.
 * @param {{ Owners: object }} pComposition - composeParts() output from load time.
 * @return {{ Root: object, Partials: Object<string, object>, Changes: Array<{ Kind: ('root'|'partial'), Record: object, Manifest: object, Change: object }>, SectionOrderKept: boolean, ContentKept: boolean }}
 */
function planSave(pEditedManifest, pRootRecord, pPartialRecords, pComposition)
{
	const tmpSplit = splitParts(pEditedManifest, pRootRecord, pPartialRecords, pComposition);
	const tmpChanges = [];

	const tmpRootChange = describeRecordChange(pRootRecord && pRootRecord.Manifest, tmpSplit.Root);
	if (tmpRootChange.Changed)
	{
		tmpChanges.push({ Kind: 'root', Record: pRootRecord, Manifest: tmpSplit.Root, Change: tmpRootChange });
	}
	for (const tmpPartial of (pPartialRecords || []))
	{
		const tmpNext = tmpSplit.Partials[_partialOwner(tmpPartial)];
		const tmpChange = describeRecordChange(tmpPartial.ManifestPartial, tmpNext);
		if (tmpChange.Changed)
		{
			tmpChanges.push({ Kind: 'partial', Record: tmpPartial, Manifest: tmpNext, Change: tmpChange });
		}
	}

	const tmpRecomposed = composeParts({ Manifest: tmpSplit.Root },
		(pPartialRecords || []).map((pPartial) => ({ IDManifestSchemaPartial: pPartial.IDManifestSchemaPartial, ManifestPartial: tmpSplit.Partials[_partialOwner(pPartial)] }))).Manifest;
	const tmpExpected = normalizeForCompare(pEditedManifest);
	const tmpActual = normalizeForCompare(tmpRecomposed);
	const tmpHashes = (pManifest) => canonicalJSON((pManifest.Sections || []).map((pSection) => pSection && pSection.Hash));
	const tmpUnordered = (pManifest) =>
	{
		const tmpCopy = Object.assign({}, pManifest);
		tmpCopy.Sections = _sectionsByHash(pManifest.Sections);
		return canonicalJSON(tmpCopy);
	};

	return {
		Root: tmpSplit.Root,
		Partials: tmpSplit.Partials,
		Changes: tmpChanges,
		SectionOrderKept: tmpHashes(tmpExpected) === tmpHashes(tmpActual),
		ContentKept: tmpUnordered(tmpExpected) === tmpUnordered(tmpActual),
	};
}

/**
 * Count what each record of a composition supplies, for the editor's parts list.
 *
 * @param {{ Owners: object }} pComposition
 * @return {Object<string, { Sections: number, Descriptors: number }>} Keyed by owner ('root' or partial ID).
 */
function countOwned(pComposition)
{
	const tmpCounts = {};
	const fBump = (pOwner, pKey) =>
	{
		if (!tmpCounts[pOwner]) { tmpCounts[pOwner] = { Sections: 0, Descriptors: 0 }; }
		tmpCounts[pOwner][pKey]++;
	};
	const tmpOwners = (pComposition && pComposition.Owners) || {};
	for (const tmpOwner of Object.values(tmpOwners.Sections || {})) { fBump(tmpOwner, 'Sections'); }
	for (const tmpOwner of Object.values(tmpOwners.Descriptors || {})) { fBump(tmpOwner, 'Descriptors'); }
	return tmpCounts;
}

module.exports = {
	ROOT_OWNER,
	parseManifestField,
	getManifestStorage,
	composeParts,
	composeForm,
	composeSourceManifest,
	splitParts,
	normalizeForCompare,
	canonicalJSON,
	describeRecordChange,
	planSave,
	countOwned,
};

},{}],835:[function(require,module,exports){

const libPictView = require('pict-view');
const libPictSectionCode = require('pict-section-code');
const libManifestSchemaParts = require('../utils/manifest-schema-parts.js');

// Where a sample form built on the SampleCreation schema keeps the new sample's starting fields. Read by Fieldbook's
// New → Sample (lib/web/legacy/headlight_web_component_common/source/factories/report.factory.js createSampleForm).
const SAMPLE_CREATION_DEFAULT_ADDRESSES = { RecordAddress: 'SampleID__Record', LineItemsAddress: 'SampleLineItemIDs' };

class ReportNamedInstanceCreate extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		this._IsEditMode = false;
		this._CurrentRecordID = null;

		// Archetype dropdown options loaded from API
		this._ReportArchetypes = [];

		// Hash validation state
		this._HashDebounceTimer = null;
		this._HashValidationState = 'idle'; // idle | checking | valid | taken

		// Raw-JSON metadata editor (Fields | JSON tabs).  Editing the raw Options JSON is gated by the synthetic,
		// UX-only `ReportNamedInstance-EditJSON` entitlement (grantable in Platform Configuration → Entitlements);
		// without it the JSON tab is read-only.
		this._ActiveMetaTab = 'fields';   // 'fields' | 'json'
		this._CanEditJSON = false;
		this._JSONEditorView = null;
		this._JSONEditorHash = 'RNI-Metadata-JSONEditor';
		this._JSONSeed = '';

		// Where the loaded form's manifest lives, captured at LOAD time (manifest-schema-parts
		// getManifestStorage).  saveRecord() guards against the raw-JSON tab silently flipping a
		// schema-backed form to an embedded one; null in create mode, where there is nothing to detach.
		this._Storage = null;
	}

	/**
	 * Navigate to the create view for a brand-new record.
	 */
	onNavigateCreate()
	{
		this._IsEditMode = false;
		this._CurrentRecordID = null;
		this._HashValidationState = 'idle';
		this._ActiveMetaTab = 'fields';

		// Seed a blank record with the full Options structure that the platform
		// requires for dynamic forms to work.  These fields match the structure
		// produced by the headlight dynamic forms CLI push tool.
		this.AppData.CreateEditRecord = {
			Name: '',
			Hash: '',
			IDReportArchetype: 0,
			DefaultReport: 1,
			Options: {
				FormDefinition: {
					Product: 'HeadlightDynamicForm',
					DefaultFormManifest: {
						Scope: 'NewForm',
						Sections: [],
						Descriptors: {},
						ReferenceManifests: {},
						StaticOptionLists: [],
						PickLists: []
					}
				},
				Meta: {
					reportTitle: ''
				},
				FormOnly: true,
				TidingsData: {
					Type: 'headlight-dynamic-form',
					Renderer: 'html'
				},
				DefaultEmailFormat: 'pdf'
			}
		};

		this._loadArchetypesThenRender();
	}

	/**
	 * Navigate to the edit-metadata view for an existing record.
	 */
	onNavigateEdit(pIDReportNamedInstance)
	{
		this._IsEditMode = true;
		this._CurrentRecordID = pIDReportNamedInstance;
		this._HashValidationState = 'idle';
		this._ActiveMetaTab = 'fields';

		this.pict.HeadlightRestClient.getJSON(`ReportNamedInstance/${pIDReportNamedInstance}`, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error(`Error loading ReportNamedInstance: ${pError}`);
				this.AppData.CreateEditRecord = null;
				return;
			}

			// Parse Options if it came back as a string
			let tmpOptions = pBody.Options;
			if (typeof tmpOptions === 'string')
			{
				try { tmpOptions = JSON.parse(tmpOptions); }
				catch (e) { tmpOptions = {}; }
			}
			if (!tmpOptions) { tmpOptions = {}; }

			this._Storage = libManifestSchemaParts.getManifestStorage(tmpOptions);

			this.AppData.CreateEditRecord = {
				IDReportNamedInstance: pBody.IDReportNamedInstance,
				GUIDReportNamedInstance: pBody.GUIDReportNamedInstance,
				Name: pBody.Name || '',
				Hash: pBody.Hash || '',
				IDReportArchetype: pBody.IDReportArchetype || 0,
				DefaultReport: pBody.DefaultReport != null ? pBody.DefaultReport : true,
				Options: tmpOptions,
				CreateDate: pBody.CreateDate,
				UpdateDate: pBody.UpdateDate,
				// Preserve the original hash so we can skip uniqueness checks
				// when the user hasn't changed it.
				_OriginalHash: pBody.Hash || '',
			};

			this._loadArchetypesThenRender();
		});
	}

	/**
	 * Load the list of ReportArchetypes, then render the form.
	 */
	_loadArchetypesThenRender()
	{
		this.pict.HeadlightRestClient.getJSON('ReportArchetypes/FilteredTo/FBV~IDReportArchetype~GT~0/0/250', (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.warn('Could not load ReportArchetypes: ' + pError);
				this._ReportArchetypes = [];
			}
			else
			{
				this._ReportArchetypes = Array.isArray(pBody) ? pBody : [];
			}

			// Resolve the JSON-edit entitlement before painting so the JSON tab renders in the correct mode.
			this._resolveCanEditJSON(() =>
			{
				this.render('RNI-Create-Container', this.options.ContainerDestination || '#FormEditor-Application-Container');
				this._focusNameField();
			});
		});
	}

	/**
	 * Resolve whether the current user may hand-edit the raw Options JSON.  This is a UX-only gate backed by the
	 * synthetic `ReportNamedInstance-EditJSON` capability (granted via Platform Configuration → Entitlements).  We
	 * read the user's flat granted-permission list directly — the enforcement-config model isn't involved because
	 * this permission exists purely to unlock an editor affordance.  Super users (role tier 5) always qualify.
	 */
	_resolveCanEditJSON(fCallback)
	{
		const fDone = () => { if (typeof fCallback === 'function') { fCallback(); } };
		const tmpUser = this.AppData.CurrentUser || {};
		const tmpIDUser = tmpUser.UserID || tmpUser.IDUser || 0;
		const tmpIDCustomer = tmpUser.CustomerID || tmpUser.IDCustomer || 0;

		if (Number(tmpUser.UserRoleIndex) === 5)
		{
			this._CanEditJSON = true;
			return fDone();
		}
		if (!tmpIDUser || !tmpIDCustomer)
		{
			this._CanEditJSON = false;
			return fDone();
		}

		this.pict.HeadlightRestClient.getJSON(`Permissions/For/User/${tmpIDUser}/In/Customer/${tmpIDCustomer}`, (pError, pBody) =>
		{
			this._CanEditJSON = !pError && Array.isArray(pBody) && (pBody.indexOf('ReportNamedInstance-EditJSON') !== -1);
			fDone();
		});
	}

	/**
	 * Toggle between the guided Fields tab and the raw-JSON tab.  When switching to JSON, re-seed the editor from the
	 * current Options (after capturing any pending Fields edits) so the JSON always reflects the latest form state.
	 */
	switchMetaTab(pTab)
	{
		this._ActiveMetaTab = (pTab === 'json') ? 'json' : 'fields';
		const tmpIsJSON = (this._ActiveMetaTab === 'json');

		const tmpFieldsTab = document.getElementById('RNI-Meta-Tab-Fields');
		const tmpJSONTab = document.getElementById('RNI-Meta-Tab-JSON');
		const tmpFieldsPanel = document.getElementById('RNI-Meta-Panel-Fields');
		const tmpJSONPanel = document.getElementById('RNI-Meta-Panel-JSON');
		if (tmpFieldsTab) { tmpFieldsTab.className = tmpIsJSON ? '' : 'is-active'; }
		if (tmpJSONTab) { tmpJSONTab.className = tmpIsJSON ? 'is-active' : ''; }
		if (tmpFieldsPanel) { tmpFieldsPanel.classList.toggle('is-hidden', tmpIsJSON); }
		if (tmpJSONPanel) { tmpJSONPanel.classList.toggle('is-hidden', !tmpIsJSON); }

		if (tmpIsJSON)
		{
			const tmpRecord = this._readFormValues() || this.AppData.CreateEditRecord || {};
			const tmpOptions = (tmpRecord && tmpRecord.Options) ? tmpRecord.Options : {};
			let tmpSeed = '{}';
			try { tmpSeed = JSON.stringify(tmpOptions, null, 4); } catch (e) { tmpSeed = '{}'; }
			this._JSONSeed = tmpSeed;
			this._updateJSONNote();
			this._mountJSONEditor(tmpSeed);
		}
	}

	/**
	 * Show the JSON tab for an error WITHOUT throwing away what the user typed.
	 *
	 * switchMetaTab('json') reseeds the editor from the record and remounts it, which is right when
	 * arriving from the Fields tab and wrong when reporting a problem with text already in the editor
	 * — the user loses the edit they were told to fix, and cannot even see what was wrong.
	 */
	_revealJSONTabPreservingEdit()
	{
		if (this._ActiveMetaTab === 'json') { return; }
		this.switchMetaTab('json');
	}

	/** Show/hide the read-only banner on the JSON tab based on the resolved entitlement. */
	_updateJSONNote()
	{
		const tmpNote = document.getElementById('RNI-Create-JSON-Note');
		if (!tmpNote) { return; }
		if (this._CanEditJSON)
		{
			tmpNote.classList.add('is-hidden');
			tmpNote.innerHTML = '';
		}
		else
		{
			tmpNote.classList.remove('is-hidden');
			tmpNote.innerHTML = '<span class="icon"><i class="fas fa-lock"></i></span> <span>Read-only. Editing the raw JSON requires the <strong>Edit report JSON</strong> entitlement &mdash; an administrator can grant it in Platform Configuration &rarr; Entitlements.</span>';
		}
	}

	/** Lazily register the pict-section-code view used for the raw Options JSON (mirrors the FormClone editor). */
	_ensureJSONEditorView()
	{
		if (this._JSONEditorView) { return this._JSONEditorView; }
		const tmpHash = this._JSONEditorHash;
		this._JSONEditorView = this.pict.addView(
			tmpHash,
			{
				ViewIdentifier: tmpHash,
				Language: 'json',
				ReadOnly: false,
				LineNumbers: true,
				DefaultCode: '',
				AddClosing: false,
				IndentOn: false,
				MoveToNewLine: false,
				AutoRender: false,
				RenderOnLoad: false,
				DefaultRenderable: 'RNI-JSONEditor-Wrap',
				DefaultDestinationAddress: '#RNI-Create-JSON-Container',
				TargetElementAddress: '#RNI-Create-JSON-Container',
				Renderables:
				[
					{
						RenderableHash: 'RNI-JSONEditor-Wrap',
						TemplateHash: 'RNI-JSONEditor-Container',
						DestinationAddress: '#RNI-Create-JSON-Container'
					}
				]
			},
			libPictSectionCode
		);
		this._JSONEditorView.initialize();
		return this._JSONEditorView;
	}

	/** (Re)mount the JSON editor into its container and seed it, honouring the read-only gate. */
	_mountJSONEditor(pSeed)
	{
		const tmpContainerList = this.pict.ContentAssignment.getElement('#RNI-Create-JSON-Container');
		if (!tmpContainerList || !tmpContainerList[0]) { return; }
		const tmpEditor = this._ensureJSONEditorView();
		if (tmpEditor.codeJar && typeof tmpEditor.destroy === 'function')
		{
			tmpEditor.destroy();
			tmpEditor.initialRenderComplete = false;
		}
		tmpEditor.render();
		if (tmpEditor.codeJar)
		{
			tmpEditor.setCode(pSeed || '');
			if (typeof tmpEditor.setReadOnly === 'function') { tmpEditor.setReadOnly(!this._CanEditJSON); }
		}
	}

	_focusNameField()
	{
		setTimeout(() =>
		{
			const tmpNameInput = document.getElementById('RNI-Create-Name');
			if (tmpNameInput)
			{
				tmpNameInput.focus();
			}
		}, 50);
	}

	/**
	 * Read form field values from the DOM back into AppData.CreateEditRecord.
	 */
	_readFormValues()
	{
		const tmpRecord = this.AppData.CreateEditRecord;
		if (!tmpRecord) { return null; }

		const tmpName = document.getElementById('RNI-Create-Name');
		const tmpHash = document.getElementById('RNI-Create-Hash');
		const tmpIDReportArchetype = document.getElementById('RNI-Create-IDReportArchetype');
		const tmpDefaultReport = document.getElementById('RNI-Create-DefaultReport');
		const tmpFormOnly = document.getElementById('RNI-Create-FormOnly');
		const tmpTidingsType = document.getElementById('RNI-Create-TidingsType');
		const tmpTidingsRenderer = document.getElementById('RNI-Create-TidingsRenderer');
		const tmpDefaultEmailFormat = document.getElementById('RNI-Create-DefaultEmailFormat');
		const tmpReportTitle = document.getElementById('RNI-Create-ReportTitle');

		if (tmpName) { tmpRecord.Name = tmpName.value.trim(); }
		if (tmpHash) { tmpRecord.Hash = tmpHash.value.trim(); }
		if (tmpIDReportArchetype) { tmpRecord.IDReportArchetype = parseInt(tmpIDReportArchetype.value, 10) || 0; }
		if (tmpDefaultReport) { tmpRecord.DefaultReport = tmpDefaultReport.checked; }

		// Ensure Options structure exists
		if (!tmpRecord.Options) { tmpRecord.Options = {}; }
		if (!tmpRecord.Options.TidingsData) { tmpRecord.Options.TidingsData = {}; }
		if (!tmpRecord.Options.Meta) { tmpRecord.Options.Meta = {}; }

		if (tmpFormOnly) { tmpRecord.Options.FormOnly = tmpFormOnly.checked; }
		const tmpStartsSample = document.getElementById('RNI-Create-StartsSample');
		if (tmpStartsSample)
		{
			if (!tmpStartsSample.checked)
			{
				delete tmpRecord.Options.SampleCreation;
			}
			else if (!tmpRecord.Options.SampleCreation || (typeof tmpRecord.Options.SampleCreation !== 'object'))
			{
				tmpRecord.Options.SampleCreation = Object.assign({}, SAMPLE_CREATION_DEFAULT_ADDRESSES);
			}
		}
		if (tmpTidingsType) { tmpRecord.Options.TidingsData.Type = tmpTidingsType.value.trim(); }
		if (tmpTidingsRenderer) { tmpRecord.Options.TidingsData.Renderer = tmpTidingsRenderer.value.trim(); }
		if (tmpDefaultEmailFormat) { tmpRecord.Options.DefaultEmailFormat = tmpDefaultEmailFormat.value.trim(); }
		if (tmpReportTitle) { tmpRecord.Options.Meta.reportTitle = tmpReportTitle.value.trim(); }

		return tmpRecord;
	}

	// ---- Hash uniqueness validation ----

	/**
	 * Called on every keystroke in the Hash input.  Debounces 500ms then
	 * queries the server to check whether the hash is already taken.
	 */
	onHashInput()
	{
		if (this._HashDebounceTimer)
		{
			clearTimeout(this._HashDebounceTimer);
		}

		const tmpHashInput = document.getElementById('RNI-Create-Hash');
		if (!tmpHashInput) { return; }

		const tmpHash = tmpHashInput.value.trim();
		if (!tmpHash)
		{
			this._setHashValidationState('idle');
			return;
		}

		// In edit mode, if the hash hasn't changed from the original, skip the check
		if (this._IsEditMode && this.AppData.CreateEditRecord && tmpHash === this.AppData.CreateEditRecord._OriginalHash)
		{
			this._setHashValidationState('idle');
			return;
		}

		this._setHashValidationState('checking');

		this._HashDebounceTimer = setTimeout(() =>
		{
			this._checkHashUniqueness(tmpHash);
		}, 500);
	}

	_checkHashUniqueness(pHash)
	{
		const tmpEncodedHash = encodeURIComponent(pHash);
		this.pict.HeadlightRestClient.getJSON(
			`ReportNamedInstances/FilteredTo/FBV~Hash~EQ~${tmpEncodedHash}/0/1`,
			(pError, pBody) =>
			{
				// If the input changed while we were waiting, ignore this response
				const tmpHashInput = document.getElementById('RNI-Create-Hash');
				if (!tmpHashInput || tmpHashInput.value.trim() !== pHash)
				{
					return;
				}

				if (pError)
				{
					this._setHashValidationState('idle');
					return;
				}

				const tmpResults = Array.isArray(pBody) ? pBody : [];

				if (tmpResults.length === 0)
				{
					this._setHashValidationState('valid');
				}
				else
				{
					// If we're editing and the match is ourselves, that's fine
					if (this._IsEditMode && this.AppData.CreateEditRecord &&
						tmpResults[0].IDReportNamedInstance === this.AppData.CreateEditRecord.IDReportNamedInstance)
					{
						this._setHashValidationState('valid');
					}
					else
					{
						this._setHashValidationState('taken');
					}
				}
			}
		);
	}

	_setHashValidationState(pState)
	{
		this._HashValidationState = pState;

		const tmpHashInput = document.getElementById('RNI-Create-Hash');
		const tmpHashHelp = document.getElementById('RNI-Create-Hash-Help');
		const tmpHashIcon = document.getElementById('RNI-Create-Hash-Status-Icon');

		if (!tmpHashInput || !tmpHashHelp) { return; }

		// Reset classes
		tmpHashInput.classList.remove('is-success', 'is-danger', 'is-warning');

		switch (pState)
		{
		case 'checking':
			tmpHashInput.classList.add('is-warning');
			tmpHashHelp.className = 'help is-warning';
			tmpHashHelp.textContent = 'Checking availability...';
			if (tmpHashIcon) { tmpHashIcon.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; }
			break;
		case 'valid':
			tmpHashInput.classList.add('is-success');
			tmpHashHelp.className = 'help is-success';
			tmpHashHelp.textContent = 'This hash is available.';
			if (tmpHashIcon) { tmpHashIcon.innerHTML = '<i class="fas fa-check"></i>'; }
			break;
		case 'taken':
			tmpHashInput.classList.add('is-danger');
			tmpHashHelp.className = 'help is-danger';
			tmpHashHelp.textContent = 'This hash is already in use. Please choose another.';
			if (tmpHashIcon) { tmpHashIcon.innerHTML = '<i class="fas fa-times"></i>'; }
			break;
		default: // idle
			tmpHashHelp.className = 'help';
			tmpHashHelp.textContent = 'A unique identifier. If left blank, the Name will be used.';
			if (tmpHashIcon) { tmpHashIcon.innerHTML = '<i class="fas fa-hashtag"></i>'; }
			break;
		}
	}

	// ---- Save ----

	/**
	 * Validate and save the record (create or update).
	 */
	saveRecord()
	{
		const tmpRecord = this._readFormValues();
		if (!tmpRecord)
		{
			return;
		}

		// Validate required fields
		if (!tmpRecord.Name)
		{
			this._showNotification('Name is required.', 'warning');
			const tmpNameInput = document.getElementById('RNI-Create-Name');
			if (tmpNameInput) { tmpNameInput.focus(); }
			return;
		}

		// If Hash is empty, default to Name
		if (!tmpRecord.Hash)
		{
			tmpRecord.Hash = tmpRecord.Name;
		}

		// Block save if we know the hash is taken
		if (this._HashValidationState === 'taken')
		{
			this._showNotification('The Hash is already in use. Please choose a unique Hash.', 'danger');
			const tmpHashInput = document.getElementById('RNI-Create-Hash');
			if (tmpHashInput) { tmpHashInput.focus(); }
			return;
		}

		// If the user edited the raw Options JSON (and is entitled), it is authoritative for Options — parse and
		// validate it, replacing the field-derived Options.  An untouched or read-only editor is ignored.
		if (this._CanEditJSON && this._JSONEditorView && this._JSONEditorView.codeJar && (typeof this._JSONEditorView.getCode === 'function'))
		{
			const tmpJSONText = this._JSONEditorView.getCode();
			if ((typeof tmpJSONText === 'string') && (tmpJSONText !== this._JSONSeed))
			{
				let tmpParsed = null;
				try { tmpParsed = JSON.parse(tmpJSONText); }
				catch (e)
				{
					this._showNotification('The Options JSON is not valid JSON — fix it before saving.', 'danger');
					this._revealJSONTabPreservingEdit();
					return;
				}
				if (tmpParsed && (typeof tmpParsed === 'object') && !Array.isArray(tmpParsed))
				{
					// A pasted FormDefinition outranks the schema links at render time, so saving this would
					// quietly detach a schema-backed form — the record would keep FormManifestSchemaID while
					// the runtime ignored it.  Compare against the mode captured at LOAD, not the pasted JSON.
					// Any FormDefinition object counts, even {} or null: same `typeof === 'object'` test as the runtime
					// loaders (ManifestLoaderService._resolveManifest, report_definitions LoadFormManifest).
					if (this._Storage && (this._Storage.Mode === 'schema'))
					{
						const tmpPastedStorage = libManifestSchemaParts.getManifestStorage(tmpParsed);
						// Every loader merges the footer only into the header's manifest (report_definitions LoadFormManifest,
						// ManifestLoaderService._resolveManifest, the Materials / Payment app loaders), so a kept footer link loads nothing.
						const tmpHeaderDropped = Boolean(this._Storage.Header) && !tmpPastedStorage.Header;
						if ((typeof tmpParsed.FormDefinition === 'object') || (tmpPastedStorage.Mode !== 'schema') || tmpHeaderDropped)
						{
							this._showNotification(this._schemaDetachMessage(tmpParsed, tmpPastedStorage), 'danger');
							this._revealJSONTabPreservingEdit();
							return;
						}
					}
					tmpRecord.Options = tmpParsed;
				}
				else
				{
					this._showNotification('The Options JSON must be a JSON object.', 'danger');
					this._revealJSONTabPreservingEdit();
					return;
				}
			}
		}

		// Get IDCustomer from session
		const tmpIDCustomer = (this.AppData.CurrentUser && this.AppData.CurrentUser.CustomerID)
			? parseInt(this.AppData.CurrentUser.CustomerID, 10)
			: 0;

		// Build the payload
		const tmpPayload = {
			Name: tmpRecord.Name,
			Hash: tmpRecord.Hash,
			IDCustomer: tmpIDCustomer,
			IDReportArchetype: tmpRecord.IDReportArchetype,
			DefaultReport: tmpRecord.DefaultReport ? 1 : 0,
		};

		// If editing, include identity fields
		if (this._IsEditMode && tmpRecord.IDReportNamedInstance)
		{
			tmpPayload.IDReportNamedInstance = tmpRecord.IDReportNamedInstance;
			tmpPayload.GUIDReportNamedInstance = tmpRecord.GUIDReportNamedInstance;
		}

		// Send Options as an OBJECT (not a JSON string).  The API's
		// serializeOptions hook expects an object so it can diff it against
		// the archetype before persisting.  Sending a string causes the diff
		// to produce garbage, breaking TidingsData and other required fields.
		if (tmpRecord.Options)
		{
			// Ensure the critical FormDefinition.Product field is always present — except on schema-backed forms,
			// where any FormDefinition makes the runtime load it instead of the linked ManifestSchema.
			if (libManifestSchemaParts.getManifestStorage(tmpRecord.Options).Mode !== 'schema')
			{
				if (!tmpRecord.Options.FormDefinition) { tmpRecord.Options.FormDefinition = {}; }
				if (!tmpRecord.Options.FormDefinition.Product)
				{
					tmpRecord.Options.FormDefinition.Product = 'HeadlightDynamicForm';
				}
			}

			tmpPayload.Options = tmpRecord.Options;
		}
		else
		{
			// Fallback: seed with the full default structure
			tmpPayload.Options = {
				FormDefinition: {
					Product: 'HeadlightDynamicForm',
					DefaultFormManifest: {
						Scope: 'NewForm',
						Sections: [],
						Descriptors: {},
						ReferenceManifests: {},
						StaticOptionLists: [],
						PickLists: []
					}
				},
				Meta: { reportTitle: '' },
				FormOnly: true,
				TidingsData: {
					Type: 'headlight-dynamic-form',
					Renderer: 'html'
				},
				DefaultEmailFormat: 'pdf'
			};
		}

		// Show saving state
		const tmpSaveButton = document.getElementById('RNI-Create-Save-Button');
		if (tmpSaveButton)
		{
			tmpSaveButton.classList.add('is-loading');
		}

		this.pict.HeadlightRestClient.putJSON('ReportNamedInstance/Upsert', tmpPayload, (pError, pBody) =>
		{
			if (tmpSaveButton)
			{
				tmpSaveButton.classList.remove('is-loading');
			}

			if (pError)
			{
				this.pict.log.error(`Error saving ReportNamedInstance: ${pError}`);
				this._showNotification('Error saving record. Please try again.', 'danger');
				return;
			}

			this._showNotification('Record saved successfully!', 'success');

			if (pBody && pBody.IDReportNamedInstance)
			{
				// Default: navigate to the form editor for the new/updated record. A host that only reuses the
				// metadata editor (e.g. the config app's Document Types) overrides AfterSaveRoute with its own
				// destination; `{IDReportNamedInstance}` / `{GUIDReportNamedInstance}` are substituted from the saved record.
				const tmpRoute = (this.options.AfterSaveRoute || '#/ReportNamedInstance/{IDReportNamedInstance}/Edit')
					.replace('{IDReportNamedInstance}', pBody.IDReportNamedInstance)
					.replace('{GUIDReportNamedInstance}', pBody.GUIDReportNamedInstance || '');
				window.location.hash = tmpRoute;
			}
		});
	}

	/**
	 * Why saveRecord() refused a raw-JSON paste on a schema-backed form, naming the schema link fields the paste removed.
	 *
	 * @param {object} pParsed - The pasted Options.
	 * @param {object} pPastedStorage - getManifestStorage() of the pasted Options.
	 * @return {string}
	 */
	_schemaDetachMessage(pParsed, pPastedStorage)
	{
		const tmpLoadedHeader = this._Storage.Header;
		const tmpLoadedFooter = this._Storage.Footer;
		const tmpHeaderRemoved = Boolean(tmpLoadedHeader) && !pPastedStorage.Header;
		const tmpFooterRemoved = Boolean(tmpLoadedFooter) && !pPastedStorage.Footer;
		if (!tmpHeaderRemoved && (pPastedStorage.Header || pPastedStorage.Footer))
		{
			return 'This form is schema-backed, and the pasted Options carry their own FormDefinition — saving it would detach the form from its linked ManifestSchema, which the runtime would then ignore. Remove the FormDefinition, or edit the manifest in the Form Editor instead.';
		}

		const tmpRemovedFields = [];
		if (tmpHeaderRemoved && (tmpLoadedHeader.ID > 0))
		{
			tmpRemovedFields.push('FormManifestSchemaID');
		}
		if (tmpHeaderRemoved && tmpLoadedHeader.Hash)
		{
			tmpRemovedFields.push('FormManifestSchemaHash');
		}
		if (tmpFooterRemoved && (tmpLoadedFooter.ID > 0))
		{
			tmpRemovedFields.push('FormFooterManifestSchemaID');
		}
		if (tmpFooterRemoved && tmpLoadedFooter.Hash)
		{
			tmpRemovedFields.push('FormFooterManifestSchemaHash');
		}
		const tmpRemovedLink = `remove its link to the ManifestSchema (${tmpRemovedFields.join(', ')})`;

		if (typeof pParsed.FormDefinition === 'object')
		{
			return `This form is schema-backed, and the pasted Options ${tmpRemovedLink} and carry their own FormDefinition — saving it would detach the form from its ManifestSchema. Put the link back and remove the FormDefinition, or edit the manifest in the Form Editor instead.`;
		}
		const tmpConsequence = pPastedStorage.Footer
			? 'the footer link they keep loads nothing on its own, so saving it would leave the form without its manifest'
			: 'saving it would leave the form without its manifest';
		return `This form is schema-backed, and the pasted Options ${tmpRemovedLink} — ${tmpConsequence}. Put the link back to save your other changes.`;
	}

	// ---- Render lifecycle ----

	onAfterRender()
	{
		super.onAfterRender();

		const tmpRecord = this.AppData.CreateEditRecord;

		// Set the page title based on create vs edit mode
		const tmpTitleEl = document.getElementById('RNI-Create-Page-Title');
		if (tmpTitleEl)
		{
			tmpTitleEl.textContent = this._IsEditMode ? 'Edit Record Metadata' : 'Create New Record';
		}

		const tmpSaveLabelEl = document.getElementById('RNI-Create-Save-Label');
		if (tmpSaveLabelEl)
		{
			tmpSaveLabelEl.textContent = this._IsEditMode ? 'Save Changes' : 'Create Record';
		}

		// Show or hide the delete button (only visible in edit mode)
		const tmpDeleteBtn = document.getElementById('RNI-Create-Delete-Button');
		if (tmpDeleteBtn)
		{
			if (this._IsEditMode)
			{
				tmpDeleteBtn.classList.remove('is-hidden');
			}
			else
			{
				tmpDeleteBtn.classList.add('is-hidden');
			}
		}

		// Set checkbox state
		const tmpDefaultReport = document.getElementById('RNI-Create-DefaultReport');
		if (tmpDefaultReport && tmpRecord)
		{
			tmpDefaultReport.checked = !!tmpRecord.DefaultReport;
		}

		// Set FormOnly checkbox
		const tmpFormOnly = document.getElementById('RNI-Create-FormOnly');
		if (tmpFormOnly && tmpRecord)
		{
			tmpFormOnly.checked = tmpRecord.Options && tmpRecord.Options.FormOnly !== undefined
				? !!tmpRecord.Options.FormOnly
				: true;
		}

		// Offered for forms built on the SampleCreation schema, and for any form that already starts samples.
		const tmpStartsSample = document.getElementById('RNI-Create-StartsSample');
		const tmpStartsSampleField = document.getElementById('RNI-Create-StartsSample-Field');
		if (tmpStartsSample && tmpStartsSampleField)
		{
			const tmpOptions = (tmpRecord && tmpRecord.Options) || {};
			tmpStartsSample.checked = !!tmpOptions.SampleCreation;
			tmpStartsSampleField.classList.toggle('is-hidden', !(tmpStartsSample.checked || (tmpOptions.FormManifestSchemaHash === 'SampleCreation')));
		}

		// Set TidingsData fields
		const tmpTidingsType = document.getElementById('RNI-Create-TidingsType');
		if (tmpTidingsType && tmpRecord && tmpRecord.Options && tmpRecord.Options.TidingsData)
		{
			tmpTidingsType.value = tmpRecord.Options.TidingsData.Type || 'headlight-dynamic-form';
		}
		const tmpTidingsRenderer = document.getElementById('RNI-Create-TidingsRenderer');
		if (tmpTidingsRenderer && tmpRecord && tmpRecord.Options && tmpRecord.Options.TidingsData)
		{
			tmpTidingsRenderer.value = tmpRecord.Options.TidingsData.Renderer || 'html';
		}

		// Set DefaultEmailFormat
		const tmpDefaultEmailFormat = document.getElementById('RNI-Create-DefaultEmailFormat');
		if (tmpDefaultEmailFormat && tmpRecord && tmpRecord.Options)
		{
			tmpDefaultEmailFormat.value = tmpRecord.Options.DefaultEmailFormat || 'pdf';
		}

		// Set Report Title
		const tmpReportTitle = document.getElementById('RNI-Create-ReportTitle');
		if (tmpReportTitle && tmpRecord && tmpRecord.Options && tmpRecord.Options.Meta)
		{
			tmpReportTitle.value = tmpRecord.Options.Meta.reportTitle || '';
		}

		// Populate the archetype dropdown
		const tmpArchetypeSelect = document.getElementById('RNI-Create-IDReportArchetype');
		if (tmpArchetypeSelect)
		{
			let tmpOptionsHTML = '<option value="0">-- No Archetype --</option>';
			for (let i = 0; i < this._ReportArchetypes.length; i++)
			{
				const tmpArch = this._ReportArchetypes[i];
				const tmpSelected = (tmpRecord && tmpRecord.IDReportArchetype === tmpArch.IDReportArchetype) ? ' selected' : '';
				// Use Description as the primary human-readable label, with Archetype as secondary context
				let tmpLabel = '';
				if (tmpArch.Description && tmpArch.Archetype)
				{
					tmpLabel = `${tmpArch.Description} (${tmpArch.Archetype})`;
				}
				else if (tmpArch.Description)
				{
					tmpLabel = tmpArch.Description;
				}
				else if (tmpArch.Archetype)
				{
					tmpLabel = tmpArch.Archetype;
				}
				else
				{
					tmpLabel = `Archetype ${tmpArch.IDReportArchetype}`;
				}
				tmpOptionsHTML += `<option value="${tmpArch.IDReportArchetype}"${tmpSelected}>${tmpLabel}</option>`;
			}
			tmpArchetypeSelect.innerHTML = tmpOptionsHTML;
		}

		// Wire up the hash input for debounced uniqueness checking
		const tmpHashInput = document.getElementById('RNI-Create-Hash');
		if (tmpHashInput)
		{
			tmpHashInput.addEventListener('input', () => { this.onHashInput(); });
		}
	}

	// ---- Delete ----

	/**
	 * Show the delete confirmation modal (edit mode only).
	 */
	confirmDelete()
	{
		if (!this._IsEditMode || !this._CurrentRecordID) { return; }
		const tmpModal = document.getElementById('RNI-Delete-Confirm-Modal');
		if (tmpModal)
		{
			tmpModal.classList.add('is-active');
		}
	}

	cancelDelete()
	{
		const tmpModal = document.getElementById('RNI-Delete-Confirm-Modal');
		if (tmpModal)
		{
			tmpModal.classList.remove('is-active');
		}
	}

	executeDelete()
	{
		if (!this._IsEditMode || !this._CurrentRecordID) { return; }

		const tmpDeleteBtn = document.getElementById('RNI-Delete-Confirm-Button');
		if (tmpDeleteBtn) { tmpDeleteBtn.classList.add('is-loading'); }

		this.pict.HeadlightRestClient.deleteEntity('ReportNamedInstance', this._CurrentRecordID, (pError) =>
		{
			if (tmpDeleteBtn) { tmpDeleteBtn.classList.remove('is-loading'); }

			this.cancelDelete();

			if (pError)
			{
				this.pict.log.error(`Error deleting ReportNamedInstance: ${pError}`);
				this._showNotification('Error deleting record. Please try again.', 'danger');
				return;
			}

			this._showNotification('Record deleted successfully.', 'success');
			// Navigate back to the list after a brief pause
			setTimeout(() =>
			{
				window.location.hash = this.options.ListRoute || '#/ReportNamedInstances';
			}, 800);
		});
	}

	// ---- Helpers ----

	_showNotification(pMessage, pType)
	{
		const tmpContainer = document.getElementById('RNI-Create-Notification-Area');
		if (tmpContainer)
		{
			tmpContainer.innerHTML = /*html*/`
				<div class="notification is-${pType} is-soft">
					<button class="delete" onclick="this.parentElement.remove()"></button>
					${pMessage}
				</div>`;
			setTimeout(() =>
			{
				tmpContainer.innerHTML = '';
			}, 4000);
		}
	}

	navigateToList()
	{
		window.location.hash = this.options.ListRoute || '#/ReportNamedInstances';
	}

	/**
	 * Custom-view entry point for pict-section-recordset's `RecordSetCustomViews` override (see
	 * RecordSet-RecordBaseView.delegateToCustomView). A host record set can point its View/Edit/Create
	 * screens at this view; PSRS calls this with `{ Action, RecordSet, GUIDRecord }`. Create opens a blank
	 * editor; View/Edit resolve the route's GUID to the record id, then open it for editing.
	 * @param {{Action:string, RecordSet:string, GUIDRecord:string}} pContext
	 */
	onRecordSetCustomView(pContext)
	{
		if (!pContext || pContext.Action === 'Create' || !pContext.GUIDRecord)
		{
			return this.onNavigateCreate();
		}
		this.pict.HeadlightRestClient.getJSON(`ReportNamedInstances/FilteredTo/FBV~GUIDReportNamedInstance~EQ~${encodeURIComponent(pContext.GUIDRecord)}/0/1`, (pError, pBody) =>
		{
			const tmpRecord = (!pError && Array.isArray(pBody) && pBody[0]) ? pBody[0] : null;
			if (tmpRecord && tmpRecord.IDReportNamedInstance)
			{
				this.onNavigateEdit(tmpRecord.IDReportNamedInstance);
			}
			else
			{
				this.pict.log.warn(`ReportNamedInstance custom view could not resolve a record for GUID [${pContext.GUIDRecord}].`);
			}
		});
	}
}

module.exports = ReportNamedInstanceCreate;

module.exports.default_configuration = (
{
	ViewIdentifier: 'ReportNamedInstanceCreate',

	DefaultRenderable: 'RNI-Create-Container',
	DefaultDestinationAddress: '#FormEditor-Application-Container',

	AutoRender: false,

	CSS: /*css*/`
.rni-create-container
{
	display: flex;
	flex-direction: column;
	height: calc(100vh - 80px);
}
.rni-create-toolbar
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 16px;
	background: var(--bulma-scheme-main-bis);
	border-bottom: 1px solid var(--bulma-border);
	flex-wrap: wrap;
	gap: 8px;
}
.rni-create-toolbar-left
{
	display: flex;
	align-items: center;
	gap: 12px;
}
.rni-create-toolbar-right
{
	display: flex;
	align-items: center;
	gap: 8px;
}
.rni-create-title
{
	font-size: 1.1rem;
	font-weight: 600;
	margin: 0;
}
.rni-create-body
{
	flex: 1;
	overflow: auto;
	padding: 24px;
}
.rni-create-form
{
	max-width: 720px;
	margin: 0 auto;
}
.rni-create-form .field
{
	margin-bottom: 1rem;
}
.rni-create-meta
{
	margin-top: 1.5rem;
	padding-top: 1rem;
	border-top: 1px solid var(--bulma-border);
}
.rni-create-meta .field
{
	margin-bottom: 0.75rem;
}
.rni-meta-tabs
{
	margin-bottom: 0.75rem;
}
.rni-json-wrap
{
	max-width: 1100px;
	margin: 0 auto;
}
.rni-json-note .icon
{
	vertical-align: middle;
}
.rni-json-help
{
	margin-bottom: 0.5rem;
}
.rni-json-editor
{
	min-height: 440px;
}
.rni-json-editor .pict-code-editor-wrap
{
	min-height: 440px;
	max-height: 70vh;
}
`,

	Templates:
	[
		{
			Hash: 'RNI-Create-Container-Template',
			Template: /*html*/`
<div class="rni-create-container">
	<div id="RNI-Create-Notification-Area"></div>
	<div class="rni-create-toolbar">
		<div class="rni-create-toolbar-left">
			<button class="button is-small" onclick="_Pict.views.ReportNamedInstanceCreate.navigateToList()">
				<span class="icon"><i class="fas fa-arrow-left"></i></span>
				<span>Back to List</span>
			</button>
			<p class="rni-create-title">
				<span id="RNI-Create-Page-Title"></span>
			</p>
		</div>
		<div class="rni-create-toolbar-right">
			<button id="RNI-Create-Delete-Button" class="button is-small is-danger is-hidden" onclick="_Pict.views.ReportNamedInstanceCreate.confirmDelete()">
				<span class="icon"><i class="fas fa-trash"></i></span>
				<span>Delete</span>
			</button>
			<button id="RNI-Create-Save-Button" class="button is-small is-success" onclick="_Pict.views.ReportNamedInstanceCreate.saveRecord()">
				<span class="icon"><i class="fas fa-floppy-disk"></i></span>
				<span><span id="RNI-Create-Save-Label"></span></span>
			</button>
		</div>
	</div>
	<div class="rni-create-body">
		<div class="tabs is-small rni-meta-tabs">
			<ul>
				<li id="RNI-Meta-Tab-Fields" class="is-active"><a onclick="_Pict.views.ReportNamedInstanceCreate.switchMetaTab('fields')"><span class="icon is-small"><i class="fas fa-list-ul"></i></span><span>Fields</span></a></li>
				<li id="RNI-Meta-Tab-JSON"><a onclick="_Pict.views.ReportNamedInstanceCreate.switchMetaTab('json')"><span class="icon is-small"><i class="fas fa-code"></i></span><span>JSON</span></a></li>
			</ul>
		</div>
		<div id="RNI-Meta-Panel-Fields">
		<div class="rni-create-form">
			<h3 class="title is-5">
				<span class="icon"><i class="fas fa-file-circle-plus"></i></span>
				Report Named Instance
			</h3>

			<div class="field">
				<label class="label">Name <span class="has-text-danger">*</span></label>
				<div class="control has-icons-left">
					<input id="RNI-Create-Name" class="input" type="text"
						placeholder="Enter a descriptive name..."
						value="{~D:AppData.CreateEditRecord.Name~}" />
					<span class="icon is-left"><i class="fas fa-font"></i></span>
				</div>
				<p class="help">The display name for this report instance.</p>
			</div>

			<div class="field">
				<label class="label">Hash</label>
				<div class="control has-icons-left has-icons-right">
					<input id="RNI-Create-Hash" class="input" type="text"
						placeholder="Defaults to Name if left empty"
						value="{~D:AppData.CreateEditRecord.Hash~}" />
					<span class="icon is-left"><i class="fas fa-hashtag"></i></span>
					<span id="RNI-Create-Hash-Status-Icon" class="icon is-right"><i class="fas fa-hashtag"></i></span>
				</div>
				<p id="RNI-Create-Hash-Help" class="help">A unique identifier. If left blank, the Name will be used.</p>
			</div>

			<div class="rni-create-meta">
				<h5 class="title is-6 mb-3">
					<span class="icon"><i class="fas fa-sliders"></i></span>
					Additional Settings
				</h5>

				<div class="field">
					<label class="label">Report Archetype</label>
					<div class="control has-icons-left">
						<div class="select is-fullwidth">
							<select id="RNI-Create-IDReportArchetype">
								<option value="0">Loading...</option>
							</select>
						</div>
						<span class="icon is-left"><i class="fas fa-layer-group"></i></span>
					</div>
					<p class="help">The report archetype for this instance.</p>
				</div>

				<div class="field">
					<label class="checkbox">
						<input id="RNI-Create-DefaultReport" type="checkbox" checked />
						Default Report
					</label>
					<p class="help">Whether this report is available by default (without a project join).</p>
				</div>

				<div class="field">
					<label class="checkbox">
						<input id="RNI-Create-FormOnly" type="checkbox" />
						Form Only
					</label>
					<p class="help">Marks this as a dynamic form (not a traditional report).</p>
				</div>

				<div id="RNI-Create-StartsSample-Field" class="field is-hidden">
					<label class="checkbox">
						<input id="RNI-Create-StartsSample" type="checkbox" />
						Starts a new sample
					</label>
					<p class="help">Fieldbook’s New → Sample, and the Sample Plan dashboard’s New Sample buttons, create this form on the project.</p>
				</div>
			</div>

			<div class="rni-create-meta">
				<h5 class="title is-6 mb-3">
					<span class="icon"><i class="fas fa-gears"></i></span>
					Platform Configuration
				</h5>

				<div class="field">
					<label class="label">Report Title</label>
					<div class="control has-icons-left">
						<input id="RNI-Create-ReportTitle" class="input" type="text"
							placeholder="Optional display title for reports"
							value="" />
						<span class="icon is-left"><i class="fas fa-heading"></i></span>
					</div>
					<p class="help">Title shown when this form is rendered as a report.</p>
				</div>

				<div class="columns">
					<div class="column">
						<div class="field">
							<label class="label">Tidings Type</label>
							<div class="control has-icons-left">
								<input id="RNI-Create-TidingsType" class="input" type="text"
									placeholder="headlight-dynamic-form"
									value="headlight-dynamic-form" />
								<span class="icon is-left"><i class="fas fa-tag"></i></span>
							</div>
							<p class="help">The document type identifier used by the report service.</p>
						</div>
					</div>
					<div class="column">
						<div class="field">
							<label class="label">Renderer</label>
							<div class="control has-icons-left">
								<div class="select is-fullwidth">
									<select id="RNI-Create-TidingsRenderer">
										<option value="html">html</option>
										<option value="pdf">pdf</option>
										<option value="json">json</option>
										<option value="default">default</option>
									</select>
								</div>
								<span class="icon is-left"><i class="fas fa-display"></i></span>
							</div>
							<p class="help">How the report service renders this form.</p>
						</div>
					</div>
				</div>

				<div class="field">
					<label class="label">Default Email Format</label>
					<div class="control has-icons-left">
						<div class="select is-fullwidth">
							<select id="RNI-Create-DefaultEmailFormat">
								<option value="pdf">pdf</option>
								<option value="html">html</option>
							</select>
						</div>
						<span class="icon is-left"><i class="fas fa-envelope"></i></span>
					</div>
					<p class="help">The format used when emailing this form.</p>
				</div>
			</div>
		</div>
		</div>
		<div id="RNI-Meta-Panel-JSON" class="is-hidden">
			<div class="rni-json-wrap">
				<div id="RNI-Create-JSON-Note" class="notification is-warning is-soft rni-json-note is-hidden"></div>
				<p class="help rni-json-help">The full <strong>Options</strong> configuration for this report, as raw JSON. Editing here overrides the Fields tab for the Options object when you Save.</p>
				<div id="RNI-Create-JSON-Container" class="rni-json-editor"></div>
			</div>
		</div>
	</div>
	<div id="RNI-Delete-Confirm-Modal" class="modal">
		<div class="modal-background" onclick="_Pict.views.ReportNamedInstanceCreate.cancelDelete()"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title has-text-danger">
					<span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
					<span>Confirm Delete</span>
				</p>
				<button class="delete" aria-label="close" onclick="_Pict.views.ReportNamedInstanceCreate.cancelDelete()"></button>
			</header>
			<section class="modal-card-body">
				<p>Are you sure you want to delete <strong>{~D:AppData.CreateEditRecord.Name~}</strong>?</p>
				<p class="mt-2 has-text-grey">This action cannot be undone. The record and its form definition will be permanently removed.</p>
			</section>
			<footer class="modal-card-foot">
				<div class="buttons">
					<button id="RNI-Delete-Confirm-Button" class="button is-danger" onclick="_Pict.views.ReportNamedInstanceCreate.executeDelete()">
						<span class="icon"><i class="fas fa-trash"></i></span>
						<span>Delete</span>
					</button>
					<button class="button" onclick="_Pict.views.ReportNamedInstanceCreate.cancelDelete()">Cancel</button>
				</div>
			</footer>
		</div>
	</div>
</div>`
		},
		{
			Hash: 'RNI-JSONEditor-Container',
			Template: /*html*/`
<div class="rni-json-editor-inner">
	<div id="${'${ViewIdentifier}-CodeJar-Wrap'}" class="pict-code-editor-wrap"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'RNI-Create-Container',
			TemplateHash: 'RNI-Create-Container-Template',
			RenderMethod: 'replace'
		}
	]
});

},{"../utils/manifest-schema-parts.js":834,"pict-section-code":558,"pict-view":733}],836:[function(require,module,exports){
"use strict";var r=ArrayBuffer,e=Uint8Array,t=Uint16Array,o=Int16Array,n=Int32Array,a=function(r,t,o){if(e.prototype.slice)return e.prototype.slice.call(r,t,o);(null==t||t<0)&&(t=0),(null==o||o>r.length)&&(o=r.length);var n=new e(o-t);return n.set(r.subarray(t,o)),n},i=function(r,t,o,n){if(e.prototype.fill)return e.prototype.fill.call(r,t,o,n);for((null==o||o<0)&&(o=0),(null==n||n>r.length)&&(n=r.length);o<n;++o)r[o]=t;return r},s=function(r,t,o,n){if(e.prototype.copyWithin)return e.prototype.copyWithin.call(r,t,o,n);for((null==o||o<0)&&(o=0),(null==n||n>r.length)&&(n=r.length);o<n;)r[t++]=r[o++]},c=["invalid zstd data","window size too large (>2046MB)","invalid block type","FSE accuracy too high","match distance too far back","unexpected EOF"],u=function(r,e,t){var o=new Error(e||c[r]);if(o.code=r,Error.captureStackTrace&&Error.captureStackTrace(o,u),!t)throw o;return o},p=function(r,e,t){for(var o=0,n=0;o<t;++o)n|=r[e++]<<(o<<3);return n},h=function(r,t){var o,a,i=r[0]|r[1]<<8|r[2]<<16;if(3126568==i&&253==r[3]){var s=r[4],c=s>>5&1,h=s>>2&1,d=3&s,f=s>>6;8&s&&u(0);var y=6-c,l=3==d?4:d,m=p(r,y,l),v=f?1<<f:c,w=p(r,y+=l,v)+(1==f&&256),_=w;if(!c){var E=1<<10+(r[5]>>3);_=E+(E>>3)*(7&r[5])}_>2145386496&&u(1);var g=new e((1==t?w||_:t?0:_)+12);return g[0]=1,g[4]=4,g[8]=8,{b:y+v,y:0,l:0,d:m,w:t&&1!=t?t:g.subarray(12),e:_,o:new n(g.buffer,0,3),u:w,c:h,m:Math.min(131072,_)}}if(25481893==(i>>4|r[3]<<20))return 8+(((o=r)[a=4]|o[a+1]<<8|o[a+2]<<16|o[a+3]<<24)>>>0);u(0)},d=function(r){for(var e=0;1<<e<=r;++e);return e-1},f=function(n,a,i){var s=4+(a<<3),c=5+(15&n[a]);c>i&&u(3);for(var p=1<<c,h=p,f=-1,y=-1,l=-1,m=p,v=new r(512+(p<<2)),w=new o(v,0,256),_=new t(v,0,256),E=new t(v,512,p),g=512+(p<<1),b=new e(v,g,p),M=new e(v,g+p);f<255&&h>0;){var O=d(h+1),L=s>>3,F=(1<<O+1)-1,G=(n[L]|n[L+1]<<8|n[L+2]<<16)>>(7&s)&F,D=(1<<O)-1,R=F-h-1,C=G&D;if(C<R?(s+=O,G=C):(s+=O+1,G>D&&(G-=R)),w[++f]=--G,-1==G?(h+=G,b[--m]=f):h-=G,!G)do{var B=s>>3;y=(n[B]|n[B+1]<<8)>>(7&s)&3,s+=2,f+=y}while(3==y)}(f>255||h)&&u(0);for(var K=0,Q=(p>>1)+(p>>3)+3,k=p-1,I=0;I<=f;++I){var H=w[I];if(H<1)_[I]=-H;else for(l=0;l<H;++l){b[K]=I;do{K=K+Q&k}while(K>=m)}}for(K&&u(0),l=0;l<p;++l){var x=_[b[l]]++,W=M[l]=c-d(x);E[l]=(x<<W)-p}return[s+7>>3,{b:c,s:b,n:M,t:E}]},y=f(new e([81,16,99,140,49,198,24,99,12,33,196,24,99,102,102,134,70,146,4]),0,6)[1],l=f(new e([33,20,196,24,99,140,33,132,16,66,8,33,132,16,66,8,33,68,68,68,68,68,68,68,68,36,9]),0,6)[1],m=f(new e([32,132,16,66,102,70,68,68,68,68,36,73,2]),0,5)[1],v=function(r,e){for(var t=r.length,o=new n(t),a=0;a<t;++a)o[a]=e,e+=1<<r[a];return o},w=new e(new n([0,0,0,0,16843009,50528770,134678020,202050057,269422093]).buffer,0,36),_=v(w,0),E=new e(new n([0,0,0,0,0,0,0,0,16843009,50528770,117769220,185207048,252579084,16]).buffer,0,53),g=v(E,3),b=function(r,e,t){var o=r.length,n=e.length,a=r[o-1],i=(1<<t.b)-1,s=-t.b;a||u(0);for(var c=0,p=t.b,h=(o<<3)-8+d(a)-p,f=-1;h>s&&f<n;){var y=h>>3;c=(c<<p|(r[y]|r[y+1]<<8|r[y+2]<<16)>>(7&h))&i,e[++f]=t.s[c],h-=p=t.n[c]}h==s&&f+1==n||u(0)},M=function(r,e,t){var o=6,n=e.length+3>>2,a=n<<1,i=n+a;b(r.subarray(o,o+=r[0]|r[1]<<8),e.subarray(0,n),t),b(r.subarray(o,o+=r[2]|r[3]<<8),e.subarray(n,a),t),b(r.subarray(o,o+=r[4]|r[5]<<8),e.subarray(a,i),t),b(r.subarray(o),e.subarray(i),t)},O=function(r,o,n){var s,c=o.b,p=r[c],h=p>>1&3;o.l=1&p;var v=p>>3|r[c+1]<<5|r[c+2]<<13,O=(c+=3)+v;if(1==h){if(c>=r.length)return;return o.b=c+1,n?(i(n,r[c],o.y,o.y+=v),n):i(new e(v),r[c])}if(!(O>r.length)){if(0==h)return o.b=O,n?(n.set(r.subarray(c,O),o.y),o.y+=v,n):a(r,c,O);if(2==h){var L=r[c],F=3&L,G=L>>2&3,D=L>>4,R=0,C=0;F<2?1&G?D|=r[++c]<<4|(2&G&&r[++c]<<12):D=L>>3:(C=G,G<2?(D|=(63&r[++c])<<4,R=r[c]>>6|r[++c]<<2):2==G?(D|=r[++c]<<4|(3&r[++c])<<12,R=r[c]>>2|r[++c]<<6):(D|=r[++c]<<4|(63&r[++c])<<12,R=r[c]>>6|r[++c]<<2|r[++c]<<10)),++c;var B=n?n.subarray(o.y,o.y+o.m):new e(o.m),K=B.length-D;if(0==F)B.set(r.subarray(c,c+=D),K);else if(1==F)i(B,r[c++],K);else{var Q=o.h;if(2==F){var k=function(r,o){var n=0,a=-1,s=new e(292),c=r[o],p=s.subarray(0,256),h=s.subarray(256,268),y=new t(s.buffer,268);if(c<128){var l=f(r,o+1,6),m=l[0],v=l[1],w=m<<3,_=r[o+=c];_||u(0);for(var E=0,g=0,b=v.b,M=b,O=(++o<<3)-8+d(_);!((O-=b)<w);){var L=O>>3;if(E+=(r[L]|r[L+1]<<8)>>(7&O)&(1<<b)-1,p[++a]=v.s[E],(O-=M)<w)break;g+=(r[L=O>>3]|r[L+1]<<8)>>(7&O)&(1<<M)-1,p[++a]=v.s[g],b=v.n[E],E=v.t[E],M=v.n[g],g=v.t[g]}++a>255&&u(0)}else{for(a=c-127;n<a;n+=2){var F=r[++o];p[n]=F>>4,p[n+1]=15&F}++o}var G=0;for(n=0;n<a;++n)(B=p[n])>11&&u(0),G+=B&&1<<B-1;var D=d(G)+1,R=1<<D,C=R-G;for(C&C-1&&u(0),p[a++]=d(C)+1,n=0;n<a;++n){var B=p[n];++h[p[n]=B&&D+1-B]}var K=new e(R<<1),Q=K.subarray(0,R),k=K.subarray(R);for(y[D]=0,n=D;n>0;--n){var I=y[n];i(k,n,I,y[n-1]=I+h[n]*(1<<D-n))}for(y[0]!=R&&u(0),n=0;n<a;++n){var H=p[n];if(H){var x=y[H];i(Q,n,x,y[H]=x+(1<<D-H))}}return[o,{n:k,b:D,s:Q}]}(r,c);R+=c-(c=k[0]),o.h=Q=k[1]}else Q||u(0);(C?M:b)(r.subarray(c,c+=R),B.subarray(K),Q)}var I=r[c++];if(I){255==I?I=32512+(r[c++]|r[c++]<<8):I>127&&(I=I-128<<8|r[c++]);var H=r[c++];3&H&&u(0);for(var x=[l,m,y],W=2;W>-1;--W){var N=H>>2+(W<<1)&3;if(1==N){var Y=new e([0,0,r[c++]]);x[W]={s:Y.subarray(2,3),n:Y.subarray(0,1),t:new t(Y.buffer,0,1),b:0}}else 2==N?(c=(s=f(r,c,9-(1&W)))[0],x[W]=s[1]):3==N&&(o.t||u(0),x[W]=o.t[W])}var X=o.t=x,U=X[0],S=X[1],P=X[2],z=r[O-1];z||u(0);var J=(O<<3)-8+d(z)-P.b,Z=J>>3,j=0,T=(r[Z]|r[Z+1]<<8)>>(7&J)&(1<<P.b)-1,$=(r[Z=(J-=S.b)>>3]|r[Z+1]<<8)>>(7&J)&(1<<S.b)-1,q=(r[Z=(J-=U.b)>>3]|r[Z+1]<<8)>>(7&J)&(1<<U.b)-1;for(++I;--I;){var V=P.s[T],A=P.n[T],rr=U.s[q],er=U.n[q],tr=S.s[$],or=S.n[$],nr=1<<tr,ar=nr+((r[Z=(J-=tr)>>3]|r[Z+1]<<8|r[Z+2]<<16|r[Z+3]<<24)>>>(7&J)&nr-1);Z=(J-=E[rr])>>3;var ir=g[rr]+((r[Z]|r[Z+1]<<8|r[Z+2]<<16)>>(7&J)&(1<<E[rr])-1);Z=(J-=w[V])>>3;var sr=_[V]+((r[Z]|r[Z+1]<<8|r[Z+2]<<16)>>(7&J)&(1<<w[V])-1);if(Z=(J-=A)>>3,T=P.t[T]+((r[Z]|r[Z+1]<<8)>>(7&J)&(1<<A)-1),Z=(J-=er)>>3,q=U.t[q]+((r[Z]|r[Z+1]<<8)>>(7&J)&(1<<er)-1),Z=(J-=or)>>3,$=S.t[$]+((r[Z]|r[Z+1]<<8)>>(7&J)&(1<<or)-1),ar>3)o.o[2]=o.o[1],o.o[1]=o.o[0],o.o[0]=ar-=3;else{var cr=ar-(0!=sr);cr?(ar=3==cr?o.o[0]-1:o.o[cr],cr>1&&(o.o[2]=o.o[1]),o.o[1]=o.o[0],o.o[0]=ar):ar=o.o[0]}for(W=0;W<sr;++W)B[j+W]=B[K+W];K+=sr;var ur=(j+=sr)-ar;if(ur<0){var pr=-ur,hr=o.e+ur;pr>ir&&(pr=ir);for(W=0;W<pr;++W)B[j+W]=o.w[hr+W];j+=pr,ir-=pr,ur=0}for(W=0;W<ir;++W)B[j+W]=B[ur+W];j+=ir}if(j!=K)for(;K<B.length;)B[j++]=B[K++];else j=B.length;n?o.y+=j:B=a(B,0,j)}else if(n){if(o.y+=D,K)for(W=0;W<D;++W)B[W]=B[K+W]}else K&&(B=a(B,K));return o.b=O,B}u(2)}},L=function(r,t){if(1==r.length)return r[0];for(var o=new e(t),n=0,a=0;n<r.length;++n){var i=r[n];o.set(i,a),a+=i.length}return o};const F='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!#$%&()*+,./:;<=>?@[]^_`{|}~"';function G(r){const e=function(r){const e=r.length,t=[];let o=0,n=0,a=-1;for(let i=0;i<e;i++){const e=F.indexOf(r[i]);if(-1!==e)if(a<0)a=e;else{a+=91*e,o|=a<<n,n+=(8191&a)>88?13:14;do{t.push(255&o),o>>=8,n-=8}while(n>7);a=-1}}return a>-1&&t.push(255&(o|a<<n)),new Uint8Array(t)}(r);return function(r,e){for(var t=0,o=[],n=+!e,a=0;r.length;){var i=h(r,n||e);if("object"==typeof i){for(n?(e=null,i.w.length==i.u&&(o.push(e=i.w),a+=i.u)):(o.push(e),i.e=0);!i.l;){var c=O(r,i,e);c||u(5),e?i.e=i.y:(o.push(c),a+=c.length,s(i.w,0,c.length),i.w.set(c,i.w.length-c.length))}t=i.b+4*i.c}else t=i;r=r.subarray(t)}return L(o,a)}(e)}var D=("undefined"!=typeof document&&document.currentScript&&document.currentScript.src,function(r={}){var e,t,o=r;o.ready=new Promise(((r,o)=>{e=r,t=o}));var n,a,i=Object.assign({},o),s=!1,c=console.log.bind(console),u=console.error.bind(console);Object.assign(o,i),i=null,o.wasmBinary&&(n=o.wasmBinary),"object"!=typeof WebAssembly&&F("no native wasm support detected");var p,h,d,f,y,l,m=!1;function v(r,e){r||F(e)}function w(){var r=a.buffer;o.HEAP8=p=new Int8Array(r),o.HEAP16=d=new Int16Array(r),o.HEAPU8=h=new Uint8Array(r),o.HEAPU16=new Uint16Array(r),o.HEAP32=f=new Int32Array(r),o.HEAPU32=y=new Uint32Array(r),o.HEAPF32=new Float32Array(r),o.HEAPF64=l=new Float64Array(r)}var _=[],E=[],g=[],b=0,M=null;function O(r){b++}function L(r){if(0==--b&&M){var e=M;M=null,e()}}function F(r){u(r="Aborted("+r+")"),m=!0,r+=". Build with -sASSERTIONS for more info.";var e=new WebAssembly.RuntimeError(r);throw t(e),e}var G,D,R,C=r=>r.startsWith("data:application/octet-stream;base64,"),B=r=>r.startsWith("file://");function K(r){if(r==G&&n)return new Uint8Array(n);throw"both async and sync fetching of the wasm failed"}function Q(r,e,t){return function(r){return n||!s||"function"!=typeof fetch||B(r)?Promise.resolve().then((()=>K(r))):fetch(r,{credentials:"same-origin"}).then((e=>{if(!e.ok)throw`failed to load wasm binary file at '${r}'`;return e.arrayBuffer()})).catch((()=>K(r)))}(r).then((r=>WebAssembly.instantiate(r,e))).then((r=>r)).then(t,(r=>{u(`failed to asynchronously prepare wasm: ${r}`),F(r)}))}C(G="graphvizlib.wasm")||(G=""+G);var k={172264:(r,e)=>{var t=rr(r),o=rr(e);A.createPath("/",W.dirname(t)),A.writeFile(W.join("/",t),o)}};function I(r){this.name="ExitStatus",this.message=`Program terminated with exit(${r})`,this.status=r}var H=r=>{for(;r.length>0;)r.shift()(o)};class x{constructor(r){this.excPtr=r,this.ptr=r-24}set_type(r){y[this.ptr+4>>2]=r}get_type(){return y[this.ptr+4>>2]}set_destructor(r){y[this.ptr+8>>2]=r}get_destructor(){return y[this.ptr+8>>2]}set_caught(r){r=r?1:0,p[this.ptr+12>>0]=r}get_caught(){return 0!=p[this.ptr+12>>0]}set_rethrown(r){r=r?1:0,p[this.ptr+13>>0]=r}get_rethrown(){return 0!=p[this.ptr+13>>0]}init(r,e){this.set_adjusted_ptr(0),this.set_type(r),this.set_destructor(e)}set_adjusted_ptr(r){y[this.ptr+16>>2]=r}get_adjusted_ptr(){return y[this.ptr+16>>2]}get_exception_ptr(){if(Yr(this.get_type()))return y[this.excPtr>>2];var r=this.get_adjusted_ptr();return 0!==r?r:this.excPtr}}var W={isAbs:r=>"/"===r.charAt(0),splitPath:r=>/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(r).slice(1),normalizeArray:(r,e)=>{for(var t=0,o=r.length-1;o>=0;o--){var n=r[o];"."===n?r.splice(o,1):".."===n?(r.splice(o,1),t++):t&&(r.splice(o,1),t--)}if(e)for(;t;t--)r.unshift("..");return r},normalize:r=>{var e=W.isAbs(r),t="/"===r.substr(-1);return(r=W.normalizeArray(r.split("/").filter((r=>!!r)),!e).join("/"))||e||(r="."),r&&t&&(r+="/"),(e?"/":"")+r},dirname:r=>{var e=W.splitPath(r),t=e[0],o=e[1];return t||o?(o&&(o=o.substr(0,o.length-1)),t+o):"."},basename:r=>{if("/"===r)return"/";var e=(r=(r=W.normalize(r)).replace(/\/$/,"")).lastIndexOf("/");return-1===e?r:r.substr(e+1)},join:function(){var r=Array.prototype.slice.call(arguments);return W.normalize(r.join("/"))},join2:(r,e)=>W.normalize(r+"/"+e)},N=r=>(N=(()=>{if("object"==typeof crypto&&"function"==typeof crypto.getRandomValues)return r=>crypto.getRandomValues(r);F("initRandomDevice")})())(r),Y={resolve:function(){for(var r="",e=!1,t=arguments.length-1;t>=-1&&!e;t--){var o=t>=0?arguments[t]:A.cwd();if("string"!=typeof o)throw new TypeError("Arguments to path.resolve must be strings");if(!o)return"";r=o+"/"+r,e=W.isAbs(o)}return(e?"/":"")+(r=W.normalizeArray(r.split("/").filter((r=>!!r)),!e).join("/"))||"."},relative:(r,e)=>{function t(r){for(var e=0;e<r.length&&""===r[e];e++);for(var t=r.length-1;t>=0&&""===r[t];t--);return e>t?[]:r.slice(e,t-e+1)}r=Y.resolve(r).substr(1),e=Y.resolve(e).substr(1);for(var o=t(r.split("/")),n=t(e.split("/")),a=Math.min(o.length,n.length),i=a,s=0;s<a;s++)if(o[s]!==n[s]){i=s;break}var c=[];for(s=i;s<o.length;s++)c.push("..");return(c=c.concat(n.slice(i))).join("/")}},X="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0,U=(r,e,t)=>{for(var o=e+t,n=e;r[n]&&!(n>=o);)++n;if(n-e>16&&r.buffer&&X)return X.decode(r.subarray(e,n));for(var a="";e<n;){var i=r[e++];if(128&i){var s=63&r[e++];if(192!=(224&i)){var c=63&r[e++];if((i=224==(240&i)?(15&i)<<12|s<<6|c:(7&i)<<18|s<<12|c<<6|63&r[e++])<65536)a+=String.fromCharCode(i);else{var u=i-65536;a+=String.fromCharCode(55296|u>>10,56320|1023&u)}}else a+=String.fromCharCode((31&i)<<6|s)}else a+=String.fromCharCode(i)}return a},S=[],P=r=>{for(var e=0,t=0;t<r.length;++t){var o=r.charCodeAt(t);o<=127?e++:o<=2047?e+=2:o>=55296&&o<=57343?(e+=4,++t):e+=3}return e},z=(r,e,t,o)=>{if(!(o>0))return 0;for(var n=t,a=t+o-1,i=0;i<r.length;++i){var s=r.charCodeAt(i);if(s>=55296&&s<=57343&&(s=65536+((1023&s)<<10)|1023&r.charCodeAt(++i)),s<=127){if(t>=a)break;e[t++]=s}else if(s<=2047){if(t+1>=a)break;e[t++]=192|s>>6,e[t++]=128|63&s}else if(s<=65535){if(t+2>=a)break;e[t++]=224|s>>12,e[t++]=128|s>>6&63,e[t++]=128|63&s}else{if(t+3>=a)break;e[t++]=240|s>>18,e[t++]=128|s>>12&63,e[t++]=128|s>>6&63,e[t++]=128|63&s}}return e[t]=0,t-n};function J(r,e,t){var o=t>0?t:P(r)+1,n=new Array(o),a=z(r,n,0,n.length);return e&&(n.length=a),n}var Z={ttys:[],init(){},shutdown(){},register(r,e){Z.ttys[r]={input:[],output:[],ops:e},A.registerDevice(r,Z.stream_ops)},stream_ops:{open(r){var e=Z.ttys[r.node.rdev];if(!e)throw new A.ErrnoError(43);r.tty=e,r.seekable=!1},close(r){r.tty.ops.fsync(r.tty)},fsync(r){r.tty.ops.fsync(r.tty)},read(r,e,t,o,n){if(!r.tty||!r.tty.ops.get_char)throw new A.ErrnoError(60);for(var a=0,i=0;i<o;i++){var s;try{s=r.tty.ops.get_char(r.tty)}catch(r){throw new A.ErrnoError(29)}if(void 0===s&&0===a)throw new A.ErrnoError(6);if(null==s)break;a++,e[t+i]=s}return a&&(r.node.timestamp=Date.now()),a},write(r,e,t,o,n){if(!r.tty||!r.tty.ops.put_char)throw new A.ErrnoError(60);try{for(var a=0;a<o;a++)r.tty.ops.put_char(r.tty,e[t+a])}catch(r){throw new A.ErrnoError(29)}return o&&(r.node.timestamp=Date.now()),a}},default_tty_ops:{get_char:r=>(()=>{if(!S.length){var r=null;if("undefined"!=typeof window&&"function"==typeof window.prompt?null!==(r=window.prompt("Input: "))&&(r+="\n"):"function"==typeof readline&&null!==(r=readline())&&(r+="\n"),!r)return null;S=J(r,!0)}return S.shift()})(),put_char(r,e){null===e||10===e?(c(U(r.output,0)),r.output=[]):0!=e&&r.output.push(e)},fsync(r){r.output&&r.output.length>0&&(c(U(r.output,0)),r.output=[])},ioctl_tcgets:r=>({c_iflag:25856,c_oflag:5,c_cflag:191,c_lflag:35387,c_cc:[3,28,127,21,4,0,1,0,17,19,26,0,18,15,23,22,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}),ioctl_tcsets:(r,e,t)=>0,ioctl_tiocgwinsz:r=>[24,80]},default_tty1_ops:{put_char(r,e){null===e||10===e?(u(U(r.output,0)),r.output=[]):0!=e&&r.output.push(e)},fsync(r){r.output&&r.output.length>0&&(u(U(r.output,0)),r.output=[])}}},j=(r,e)=>Math.ceil(r/e)*e,T=r=>{r=j(r,65536);var e=Nr(65536,r);return e?((r,e)=>(h.fill(0,r,r+e),r))(e,r):0},$={ops_table:null,mount:r=>$.createNode(null,"/",16895,0),createNode(r,e,t,o){if(A.isBlkdev(t)||A.isFIFO(t))throw new A.ErrnoError(63);$.ops_table||={dir:{node:{getattr:$.node_ops.getattr,setattr:$.node_ops.setattr,lookup:$.node_ops.lookup,mknod:$.node_ops.mknod,rename:$.node_ops.rename,unlink:$.node_ops.unlink,rmdir:$.node_ops.rmdir,readdir:$.node_ops.readdir,symlink:$.node_ops.symlink},stream:{llseek:$.stream_ops.llseek}},file:{node:{getattr:$.node_ops.getattr,setattr:$.node_ops.setattr},stream:{llseek:$.stream_ops.llseek,read:$.stream_ops.read,write:$.stream_ops.write,allocate:$.stream_ops.allocate,mmap:$.stream_ops.mmap,msync:$.stream_ops.msync}},link:{node:{getattr:$.node_ops.getattr,setattr:$.node_ops.setattr,readlink:$.node_ops.readlink},stream:{}},chrdev:{node:{getattr:$.node_ops.getattr,setattr:$.node_ops.setattr},stream:A.chrdev_stream_ops}};var n=A.createNode(r,e,t,o);return A.isDir(n.mode)?(n.node_ops=$.ops_table.dir.node,n.stream_ops=$.ops_table.dir.stream,n.contents={}):A.isFile(n.mode)?(n.node_ops=$.ops_table.file.node,n.stream_ops=$.ops_table.file.stream,n.usedBytes=0,n.contents=null):A.isLink(n.mode)?(n.node_ops=$.ops_table.link.node,n.stream_ops=$.ops_table.link.stream):A.isChrdev(n.mode)&&(n.node_ops=$.ops_table.chrdev.node,n.stream_ops=$.ops_table.chrdev.stream),n.timestamp=Date.now(),r&&(r.contents[e]=n,r.timestamp=n.timestamp),n},getFileDataAsTypedArray:r=>r.contents?r.contents.subarray?r.contents.subarray(0,r.usedBytes):new Uint8Array(r.contents):new Uint8Array(0),expandFileStorage(r,e){var t=r.contents?r.contents.length:0;if(!(t>=e)){e=Math.max(e,t*(t<1048576?2:1.125)>>>0),0!=t&&(e=Math.max(e,256));var o=r.contents;r.contents=new Uint8Array(e),r.usedBytes>0&&r.contents.set(o.subarray(0,r.usedBytes),0)}},resizeFileStorage(r,e){if(r.usedBytes!=e)if(0==e)r.contents=null,r.usedBytes=0;else{var t=r.contents;r.contents=new Uint8Array(e),t&&r.contents.set(t.subarray(0,Math.min(e,r.usedBytes))),r.usedBytes=e}},node_ops:{getattr(r){var e={};return e.dev=A.isChrdev(r.mode)?r.id:1,e.ino=r.id,e.mode=r.mode,e.nlink=1,e.uid=0,e.gid=0,e.rdev=r.rdev,A.isDir(r.mode)?e.size=4096:A.isFile(r.mode)?e.size=r.usedBytes:A.isLink(r.mode)?e.size=r.link.length:e.size=0,e.atime=new Date(r.timestamp),e.mtime=new Date(r.timestamp),e.ctime=new Date(r.timestamp),e.blksize=4096,e.blocks=Math.ceil(e.size/e.blksize),e},setattr(r,e){void 0!==e.mode&&(r.mode=e.mode),void 0!==e.timestamp&&(r.timestamp=e.timestamp),void 0!==e.size&&$.resizeFileStorage(r,e.size)},lookup(r,e){throw A.genericErrors[44]},mknod:(r,e,t,o)=>$.createNode(r,e,t,o),rename(r,e,t){if(A.isDir(r.mode)){var o;try{o=A.lookupNode(e,t)}catch(r){}if(o)for(var n in o.contents)throw new A.ErrnoError(55)}delete r.parent.contents[r.name],r.parent.timestamp=Date.now(),r.name=t,e.contents[t]=r,e.timestamp=r.parent.timestamp,r.parent=e},unlink(r,e){delete r.contents[e],r.timestamp=Date.now()},rmdir(r,e){var t=A.lookupNode(r,e);for(var o in t.contents)throw new A.ErrnoError(55);delete r.contents[e],r.timestamp=Date.now()},readdir(r){var e=[".",".."];for(var t of Object.keys(r.contents))e.push(t);return e},symlink(r,e,t){var o=$.createNode(r,e,41471,0);return o.link=t,o},readlink(r){if(!A.isLink(r.mode))throw new A.ErrnoError(28);return r.link}},stream_ops:{read(r,e,t,o,n){var a=r.node.contents;if(n>=r.node.usedBytes)return 0;var i=Math.min(r.node.usedBytes-n,o);if(i>8&&a.subarray)e.set(a.subarray(n,n+i),t);else for(var s=0;s<i;s++)e[t+s]=a[n+s];return i},write(r,e,t,o,n,a){if(e.buffer===p.buffer&&(a=!1),!o)return 0;var i=r.node;if(i.timestamp=Date.now(),e.subarray&&(!i.contents||i.contents.subarray)){if(a)return i.contents=e.subarray(t,t+o),i.usedBytes=o,o;if(0===i.usedBytes&&0===n)return i.contents=e.slice(t,t+o),i.usedBytes=o,o;if(n+o<=i.usedBytes)return i.contents.set(e.subarray(t,t+o),n),o}if($.expandFileStorage(i,n+o),i.contents.subarray&&e.subarray)i.contents.set(e.subarray(t,t+o),n);else for(var s=0;s<o;s++)i.contents[n+s]=e[t+s];return i.usedBytes=Math.max(i.usedBytes,n+o),o},llseek(r,e,t){var o=e;if(1===t?o+=r.position:2===t&&A.isFile(r.node.mode)&&(o+=r.node.usedBytes),o<0)throw new A.ErrnoError(28);return o},allocate(r,e,t){$.expandFileStorage(r.node,e+t),r.node.usedBytes=Math.max(r.node.usedBytes,e+t)},mmap(r,e,t,o,n){if(!A.isFile(r.node.mode))throw new A.ErrnoError(43);var a,i,s=r.node.contents;if(2&n||s.buffer!==p.buffer){if((t>0||t+e<s.length)&&(s=s.subarray?s.subarray(t,t+e):Array.prototype.slice.call(s,t,t+e)),i=!0,!(a=T(e)))throw new A.ErrnoError(48);p.set(s,a)}else i=!1,a=s.byteOffset;return{ptr:a,allocated:i}},msync:(r,e,t,o,n)=>($.stream_ops.write(r,e,0,o,t,!1),0)}},q=[],V=(r,e)=>{var t=0;return r&&(t|=365),e&&(t|=146),t},A={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:!1,ignorePermissions:!0,ErrnoError:class{constructor(r){this.name="ErrnoError",this.errno=r}},genericErrors:{},filesystems:null,syncFSRequests:0,lookupPath(r,e={}){if(!(r=Y.resolve(r)))return{path:"",node:null};if((e=Object.assign({follow_mount:!0,recurse_count:0},e)).recurse_count>8)throw new A.ErrnoError(32);for(var t=r.split("/").filter((r=>!!r)),o=A.root,n="/",a=0;a<t.length;a++){var i=a===t.length-1;if(i&&e.parent)break;if(o=A.lookupNode(o,t[a]),n=W.join2(n,t[a]),A.isMountpoint(o)&&(!i||i&&e.follow_mount)&&(o=o.mounted.root),!i||e.follow)for(var s=0;A.isLink(o.mode);){var c=A.readlink(n);if(n=Y.resolve(W.dirname(n),c),o=A.lookupPath(n,{recurse_count:e.recurse_count+1}).node,s++>40)throw new A.ErrnoError(32)}}return{path:n,node:o}},getPath(r){for(var e;;){if(A.isRoot(r)){var t=r.mount.mountpoint;return e?"/"!==t[t.length-1]?`${t}/${e}`:t+e:t}e=e?`${r.name}/${e}`:r.name,r=r.parent}},hashName(r,e){for(var t=0,o=0;o<e.length;o++)t=(t<<5)-t+e.charCodeAt(o)|0;return(r+t>>>0)%A.nameTable.length},hashAddNode(r){var e=A.hashName(r.parent.id,r.name);r.name_next=A.nameTable[e],A.nameTable[e]=r},hashRemoveNode(r){var e=A.hashName(r.parent.id,r.name);if(A.nameTable[e]===r)A.nameTable[e]=r.name_next;else for(var t=A.nameTable[e];t;){if(t.name_next===r){t.name_next=r.name_next;break}t=t.name_next}},lookupNode(r,e){var t=A.mayLookup(r);if(t)throw new A.ErrnoError(t);for(var o=A.hashName(r.id,e),n=A.nameTable[o];n;n=n.name_next){var a=n.name;if(n.parent.id===r.id&&a===e)return n}return A.lookup(r,e)},createNode(r,e,t,o){var n=new A.FSNode(r,e,t,o);return A.hashAddNode(n),n},destroyNode(r){A.hashRemoveNode(r)},isRoot:r=>r===r.parent,isMountpoint:r=>!!r.mounted,isFile:r=>32768==(61440&r),isDir:r=>16384==(61440&r),isLink:r=>40960==(61440&r),isChrdev:r=>8192==(61440&r),isBlkdev:r=>24576==(61440&r),isFIFO:r=>4096==(61440&r),isSocket:r=>49152==(49152&r),flagsToPermissionString(r){var e=["r","w","rw"][3&r];return 512&r&&(e+="w"),e},nodePermissions:(r,e)=>A.ignorePermissions||(!e.includes("r")||292&r.mode)&&(!e.includes("w")||146&r.mode)&&(!e.includes("x")||73&r.mode)?0:2,mayLookup(r){if(!A.isDir(r.mode))return 54;var e=A.nodePermissions(r,"x");return e||(r.node_ops.lookup?0:2)},mayCreate(r,e){try{return A.lookupNode(r,e),20}catch(r){}return A.nodePermissions(r,"wx")},mayDelete(r,e,t){var o;try{o=A.lookupNode(r,e)}catch(r){return r.errno}var n=A.nodePermissions(r,"wx");if(n)return n;if(t){if(!A.isDir(o.mode))return 54;if(A.isRoot(o)||A.getPath(o)===A.cwd())return 10}else if(A.isDir(o.mode))return 31;return 0},mayOpen:(r,e)=>r?A.isLink(r.mode)?32:A.isDir(r.mode)&&("r"!==A.flagsToPermissionString(e)||512&e)?31:A.nodePermissions(r,A.flagsToPermissionString(e)):44,MAX_OPEN_FDS:4096,nextfd(){for(var r=0;r<=A.MAX_OPEN_FDS;r++)if(!A.streams[r])return r;throw new A.ErrnoError(33)},getStreamChecked(r){var e=A.getStream(r);if(!e)throw new A.ErrnoError(8);return e},getStream:r=>A.streams[r],createStream:(r,e=-1)=>(A.FSStream||(A.FSStream=function(){this.shared={}},A.FSStream.prototype={},Object.defineProperties(A.FSStream.prototype,{object:{get(){return this.node},set(r){this.node=r}},isRead:{get(){return 1!=(2097155&this.flags)}},isWrite:{get(){return 0!=(2097155&this.flags)}},isAppend:{get(){return 1024&this.flags}},flags:{get(){return this.shared.flags},set(r){this.shared.flags=r}},position:{get(){return this.shared.position},set(r){this.shared.position=r}}})),r=Object.assign(new A.FSStream,r),-1==e&&(e=A.nextfd()),r.fd=e,A.streams[e]=r,r),closeStream(r){A.streams[r]=null},chrdev_stream_ops:{open(r){var e=A.getDevice(r.node.rdev);r.stream_ops=e.stream_ops,r.stream_ops.open?.(r)},llseek(){throw new A.ErrnoError(70)}},major:r=>r>>8,minor:r=>255&r,makedev:(r,e)=>r<<8|e,registerDevice(r,e){A.devices[r]={stream_ops:e}},getDevice:r=>A.devices[r],getMounts(r){for(var e=[],t=[r];t.length;){var o=t.pop();e.push(o),t.push.apply(t,o.mounts)}return e},syncfs(r,e){"function"==typeof r&&(e=r,r=!1),A.syncFSRequests++,A.syncFSRequests>1&&u(`warning: ${A.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);var t=A.getMounts(A.root.mount),o=0;function n(r){return A.syncFSRequests--,e(r)}function a(r){if(r)return a.errored?void 0:(a.errored=!0,n(r));++o>=t.length&&n(null)}t.forEach((e=>{if(!e.type.syncfs)return a(null);e.type.syncfs(e,r,a)}))},mount(r,e,t){var o,n="/"===t,a=!t;if(n&&A.root)throw new A.ErrnoError(10);if(!n&&!a){var i=A.lookupPath(t,{follow_mount:!1});if(t=i.path,o=i.node,A.isMountpoint(o))throw new A.ErrnoError(10);if(!A.isDir(o.mode))throw new A.ErrnoError(54)}var s={type:r,opts:e,mountpoint:t,mounts:[]},c=r.mount(s);return c.mount=s,s.root=c,n?A.root=c:o&&(o.mounted=s,o.mount&&o.mount.mounts.push(s)),c},unmount(r){var e=A.lookupPath(r,{follow_mount:!1});if(!A.isMountpoint(e.node))throw new A.ErrnoError(28);var t=e.node,o=t.mounted,n=A.getMounts(o);Object.keys(A.nameTable).forEach((r=>{for(var e=A.nameTable[r];e;){var t=e.name_next;n.includes(e.mount)&&A.destroyNode(e),e=t}})),t.mounted=null;var a=t.mount.mounts.indexOf(o);t.mount.mounts.splice(a,1)},lookup:(r,e)=>r.node_ops.lookup(r,e),mknod(r,e,t){var o=A.lookupPath(r,{parent:!0}).node,n=W.basename(r);if(!n||"."===n||".."===n)throw new A.ErrnoError(28);var a=A.mayCreate(o,n);if(a)throw new A.ErrnoError(a);if(!o.node_ops.mknod)throw new A.ErrnoError(63);return o.node_ops.mknod(o,n,e,t)},create:(r,e)=>(e=void 0!==e?e:438,e&=4095,e|=32768,A.mknod(r,e,0)),mkdir:(r,e)=>(e=void 0!==e?e:511,e&=1023,e|=16384,A.mknod(r,e,0)),mkdirTree(r,e){for(var t=r.split("/"),o="",n=0;n<t.length;++n)if(t[n]){o+="/"+t[n];try{A.mkdir(o,e)}catch(r){if(20!=r.errno)throw r}}},mkdev:(r,e,t)=>(void 0===t&&(t=e,e=438),e|=8192,A.mknod(r,e,t)),symlink(r,e){if(!Y.resolve(r))throw new A.ErrnoError(44);var t=A.lookupPath(e,{parent:!0}).node;if(!t)throw new A.ErrnoError(44);var o=W.basename(e),n=A.mayCreate(t,o);if(n)throw new A.ErrnoError(n);if(!t.node_ops.symlink)throw new A.ErrnoError(63);return t.node_ops.symlink(t,o,r)},rename(r,e){var t,o,n=W.dirname(r),a=W.dirname(e),i=W.basename(r),s=W.basename(e);if(t=A.lookupPath(r,{parent:!0}).node,o=A.lookupPath(e,{parent:!0}).node,!t||!o)throw new A.ErrnoError(44);if(t.mount!==o.mount)throw new A.ErrnoError(75);var c,u=A.lookupNode(t,i),p=Y.relative(r,a);if("."!==p.charAt(0))throw new A.ErrnoError(28);if("."!==(p=Y.relative(e,n)).charAt(0))throw new A.ErrnoError(55);try{c=A.lookupNode(o,s)}catch(r){}if(u!==c){var h=A.isDir(u.mode),d=A.mayDelete(t,i,h);if(d)throw new A.ErrnoError(d);if(d=c?A.mayDelete(o,s,h):A.mayCreate(o,s))throw new A.ErrnoError(d);if(!t.node_ops.rename)throw new A.ErrnoError(63);if(A.isMountpoint(u)||c&&A.isMountpoint(c))throw new A.ErrnoError(10);if(o!==t&&(d=A.nodePermissions(t,"w")))throw new A.ErrnoError(d);A.hashRemoveNode(u);try{t.node_ops.rename(u,o,s)}catch(r){throw r}finally{A.hashAddNode(u)}}},rmdir(r){var e=A.lookupPath(r,{parent:!0}).node,t=W.basename(r),o=A.lookupNode(e,t),n=A.mayDelete(e,t,!0);if(n)throw new A.ErrnoError(n);if(!e.node_ops.rmdir)throw new A.ErrnoError(63);if(A.isMountpoint(o))throw new A.ErrnoError(10);e.node_ops.rmdir(e,t),A.destroyNode(o)},readdir(r){var e=A.lookupPath(r,{follow:!0}).node;if(!e.node_ops.readdir)throw new A.ErrnoError(54);return e.node_ops.readdir(e)},unlink(r){var e=A.lookupPath(r,{parent:!0}).node;if(!e)throw new A.ErrnoError(44);var t=W.basename(r),o=A.lookupNode(e,t),n=A.mayDelete(e,t,!1);if(n)throw new A.ErrnoError(n);if(!e.node_ops.unlink)throw new A.ErrnoError(63);if(A.isMountpoint(o))throw new A.ErrnoError(10);e.node_ops.unlink(e,t),A.destroyNode(o)},readlink(r){var e=A.lookupPath(r).node;if(!e)throw new A.ErrnoError(44);if(!e.node_ops.readlink)throw new A.ErrnoError(28);return Y.resolve(A.getPath(e.parent),e.node_ops.readlink(e))},stat(r,e){var t=A.lookupPath(r,{follow:!e}).node;if(!t)throw new A.ErrnoError(44);if(!t.node_ops.getattr)throw new A.ErrnoError(63);return t.node_ops.getattr(t)},lstat:r=>A.stat(r,!0),chmod(r,e,t){var o;if(!(o="string"==typeof r?A.lookupPath(r,{follow:!t}).node:r).node_ops.setattr)throw new A.ErrnoError(63);o.node_ops.setattr(o,{mode:4095&e|-4096&o.mode,timestamp:Date.now()})},lchmod(r,e){A.chmod(r,e,!0)},fchmod(r,e){var t=A.getStreamChecked(r);A.chmod(t.node,e)},chown(r,e,t,o){var n;if(!(n="string"==typeof r?A.lookupPath(r,{follow:!o}).node:r).node_ops.setattr)throw new A.ErrnoError(63);n.node_ops.setattr(n,{timestamp:Date.now()})},lchown(r,e,t){A.chown(r,e,t,!0)},fchown(r,e,t){var o=A.getStreamChecked(r);A.chown(o.node,e,t)},truncate(r,e){if(e<0)throw new A.ErrnoError(28);var t;if(!(t="string"==typeof r?A.lookupPath(r,{follow:!0}).node:r).node_ops.setattr)throw new A.ErrnoError(63);if(A.isDir(t.mode))throw new A.ErrnoError(31);if(!A.isFile(t.mode))throw new A.ErrnoError(28);var o=A.nodePermissions(t,"w");if(o)throw new A.ErrnoError(o);t.node_ops.setattr(t,{size:e,timestamp:Date.now()})},ftruncate(r,e){var t=A.getStreamChecked(r);if(0==(2097155&t.flags))throw new A.ErrnoError(28);A.truncate(t.node,e)},utime(r,e,t){var o=A.lookupPath(r,{follow:!0}).node;o.node_ops.setattr(o,{timestamp:Math.max(e,t)})},open(r,e,t){if(""===r)throw new A.ErrnoError(44);var n;if(t=void 0===t?438:t,t=64&(e="string"==typeof e?(r=>{var e={r:0,"r+":2,w:577,"w+":578,a:1089,"a+":1090}[r];if(void 0===e)throw new Error(`Unknown file open mode: ${r}`);return e})(e):e)?4095&t|32768:0,"object"==typeof r)n=r;else{r=W.normalize(r);try{n=A.lookupPath(r,{follow:!(131072&e)}).node}catch(r){}}var a=!1;if(64&e)if(n){if(128&e)throw new A.ErrnoError(20)}else n=A.mknod(r,t,0),a=!0;if(!n)throw new A.ErrnoError(44);if(A.isChrdev(n.mode)&&(e&=-513),65536&e&&!A.isDir(n.mode))throw new A.ErrnoError(54);if(!a){var i=A.mayOpen(n,e);if(i)throw new A.ErrnoError(i)}512&e&&!a&&A.truncate(n,0),e&=-131713;var s=A.createStream({node:n,path:A.getPath(n),flags:e,seekable:!0,position:0,stream_ops:n.stream_ops,ungotten:[],error:!1});return s.stream_ops.open&&s.stream_ops.open(s),!o.logReadFiles||1&e||(A.readFiles||(A.readFiles={}),r in A.readFiles||(A.readFiles[r]=1)),s},close(r){if(A.isClosed(r))throw new A.ErrnoError(8);r.getdents&&(r.getdents=null);try{r.stream_ops.close&&r.stream_ops.close(r)}catch(r){throw r}finally{A.closeStream(r.fd)}r.fd=null},isClosed:r=>null===r.fd,llseek(r,e,t){if(A.isClosed(r))throw new A.ErrnoError(8);if(!r.seekable||!r.stream_ops.llseek)throw new A.ErrnoError(70);if(0!=t&&1!=t&&2!=t)throw new A.ErrnoError(28);return r.position=r.stream_ops.llseek(r,e,t),r.ungotten=[],r.position},read(r,e,t,o,n){if(o<0||n<0)throw new A.ErrnoError(28);if(A.isClosed(r))throw new A.ErrnoError(8);if(1==(2097155&r.flags))throw new A.ErrnoError(8);if(A.isDir(r.node.mode))throw new A.ErrnoError(31);if(!r.stream_ops.read)throw new A.ErrnoError(28);var a=void 0!==n;if(a){if(!r.seekable)throw new A.ErrnoError(70)}else n=r.position;var i=r.stream_ops.read(r,e,t,o,n);return a||(r.position+=i),i},write(r,e,t,o,n,a){if(o<0||n<0)throw new A.ErrnoError(28);if(A.isClosed(r))throw new A.ErrnoError(8);if(0==(2097155&r.flags))throw new A.ErrnoError(8);if(A.isDir(r.node.mode))throw new A.ErrnoError(31);if(!r.stream_ops.write)throw new A.ErrnoError(28);r.seekable&&1024&r.flags&&A.llseek(r,0,2);var i=void 0!==n;if(i){if(!r.seekable)throw new A.ErrnoError(70)}else n=r.position;var s=r.stream_ops.write(r,e,t,o,n,a);return i||(r.position+=s),s},allocate(r,e,t){if(A.isClosed(r))throw new A.ErrnoError(8);if(e<0||t<=0)throw new A.ErrnoError(28);if(0==(2097155&r.flags))throw new A.ErrnoError(8);if(!A.isFile(r.node.mode)&&!A.isDir(r.node.mode))throw new A.ErrnoError(43);if(!r.stream_ops.allocate)throw new A.ErrnoError(138);r.stream_ops.allocate(r,e,t)},mmap(r,e,t,o,n){if(0!=(2&o)&&0==(2&n)&&2!=(2097155&r.flags))throw new A.ErrnoError(2);if(1==(2097155&r.flags))throw new A.ErrnoError(2);if(!r.stream_ops.mmap)throw new A.ErrnoError(43);return r.stream_ops.mmap(r,e,t,o,n)},msync:(r,e,t,o,n)=>r.stream_ops.msync?r.stream_ops.msync(r,e,t,o,n):0,munmap:r=>0,ioctl(r,e,t){if(!r.stream_ops.ioctl)throw new A.ErrnoError(59);return r.stream_ops.ioctl(r,e,t)},readFile(r,e={}){if(e.flags=e.flags||0,e.encoding=e.encoding||"binary","utf8"!==e.encoding&&"binary"!==e.encoding)throw new Error(`Invalid encoding type "${e.encoding}"`);var t,o=A.open(r,e.flags),n=A.stat(r).size,a=new Uint8Array(n);return A.read(o,a,0,n,0),"utf8"===e.encoding?t=U(a,0):"binary"===e.encoding&&(t=a),A.close(o),t},writeFile(r,e,t={}){t.flags=t.flags||577;var o=A.open(r,t.flags,t.mode);if("string"==typeof e){var n=new Uint8Array(P(e)+1),a=z(e,n,0,n.length);A.write(o,n,0,a,void 0,t.canOwn)}else{if(!ArrayBuffer.isView(e))throw new Error("Unsupported data type");A.write(o,e,0,e.byteLength,void 0,t.canOwn)}A.close(o)},cwd:()=>A.currentPath,chdir(r){var e=A.lookupPath(r,{follow:!0});if(null===e.node)throw new A.ErrnoError(44);if(!A.isDir(e.node.mode))throw new A.ErrnoError(54);var t=A.nodePermissions(e.node,"x");if(t)throw new A.ErrnoError(t);A.currentPath=e.path},createDefaultDirectories(){A.mkdir("/tmp"),A.mkdir("/home"),A.mkdir("/home/web_user")},createDefaultDevices(){A.mkdir("/dev"),A.registerDevice(A.makedev(1,3),{read:()=>0,write:(r,e,t,o,n)=>o}),A.mkdev("/dev/null",A.makedev(1,3)),Z.register(A.makedev(5,0),Z.default_tty_ops),Z.register(A.makedev(6,0),Z.default_tty1_ops),A.mkdev("/dev/tty",A.makedev(5,0)),A.mkdev("/dev/tty1",A.makedev(6,0));var r=new Uint8Array(1024),e=0,t=()=>(0===e&&(e=N(r).byteLength),r[--e]);A.createDevice("/dev","random",t),A.createDevice("/dev","urandom",t),A.mkdir("/dev/shm"),A.mkdir("/dev/shm/tmp")},createSpecialDirectories(){A.mkdir("/proc");var r=A.mkdir("/proc/self");A.mkdir("/proc/self/fd"),A.mount({mount(){var e=A.createNode(r,"fd",16895,73);return e.node_ops={lookup(r,e){var t=+e,o=A.getStreamChecked(t),n={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:()=>o.path}};return n.parent=n,n}},e}},{},"/proc/self/fd")},createStandardStreams(){o.stdin?A.createDevice("/dev","stdin",o.stdin):A.symlink("/dev/tty","/dev/stdin"),o.stdout?A.createDevice("/dev","stdout",null,o.stdout):A.symlink("/dev/tty","/dev/stdout"),o.stderr?A.createDevice("/dev","stderr",null,o.stderr):A.symlink("/dev/tty1","/dev/stderr"),A.open("/dev/stdin",0),A.open("/dev/stdout",1),A.open("/dev/stderr",1)},staticInit(){[44].forEach((r=>{A.genericErrors[r]=new A.ErrnoError(r),A.genericErrors[r].stack="<generic error, no stack>"})),A.nameTable=new Array(4096),A.mount($,{},"/"),A.createDefaultDirectories(),A.createDefaultDevices(),A.createSpecialDirectories(),A.filesystems={MEMFS:$}},init(r,e,t){A.init.initialized=!0,o.stdin=r||o.stdin,o.stdout=e||o.stdout,o.stderr=t||o.stderr,A.createStandardStreams()},quit(){A.init.initialized=!1;for(var r=0;r<A.streams.length;r++){var e=A.streams[r];e&&A.close(e)}},findObject(r,e){var t=A.analyzePath(r,e);return t.exists?t.object:null},analyzePath(r,e){try{r=(o=A.lookupPath(r,{follow:!e})).path}catch(r){}var t={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};try{var o=A.lookupPath(r,{parent:!0});t.parentExists=!0,t.parentPath=o.path,t.parentObject=o.node,t.name=W.basename(r),o=A.lookupPath(r,{follow:!e}),t.exists=!0,t.path=o.path,t.object=o.node,t.name=o.node.name,t.isRoot="/"===o.path}catch(r){t.error=r.errno}return t},createPath(r,e,t,o){r="string"==typeof r?r:A.getPath(r);for(var n=e.split("/").reverse();n.length;){var a=n.pop();if(a){var i=W.join2(r,a);try{A.mkdir(i)}catch(r){}r=i}}return i},createFile(r,e,t,o,n){var a=W.join2("string"==typeof r?r:A.getPath(r),e),i=V(o,n);return A.create(a,i)},createDataFile(r,e,t,o,n,a){var i=e;r&&(r="string"==typeof r?r:A.getPath(r),i=e?W.join2(r,e):r);var s=V(o,n),c=A.create(i,s);if(t){if("string"==typeof t){for(var u=new Array(t.length),p=0,h=t.length;p<h;++p)u[p]=t.charCodeAt(p);t=u}A.chmod(c,146|s);var d=A.open(c,577);A.write(d,t,0,t.length,0,a),A.close(d),A.chmod(c,s)}},createDevice(r,e,t,o){var n=W.join2("string"==typeof r?r:A.getPath(r),e),a=V(!!t,!!o);A.createDevice.major||(A.createDevice.major=64);var i=A.makedev(A.createDevice.major++,0);return A.registerDevice(i,{open(r){r.seekable=!1},close(r){o?.buffer?.length&&o(10)},read(r,e,o,n,a){for(var i=0,s=0;s<n;s++){var c;try{c=t()}catch(r){throw new A.ErrnoError(29)}if(void 0===c&&0===i)throw new A.ErrnoError(6);if(null==c)break;i++,e[o+s]=c}return i&&(r.node.timestamp=Date.now()),i},write(r,e,t,n,a){for(var i=0;i<n;i++)try{o(e[t+i])}catch(r){throw new A.ErrnoError(29)}return n&&(r.node.timestamp=Date.now()),i}}),A.mkdev(n,a,i)},forceLoadFile(r){if(r.isDevice||r.isFolder||r.link||r.contents)return!0;throw"undefined"!=typeof XMLHttpRequest?new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread."):new Error("Cannot load without read() or XMLHttpRequest.")},createLazyFile(r,e,t,o,n){function a(){this.lengthKnown=!1,this.chunks=[]}if(a.prototype.get=function(r){if(!(r>this.length-1||r<0)){var e=r%this.chunkSize,t=r/this.chunkSize|0;return this.getter(t)[e]}},a.prototype.setDataGetter=function(r){this.getter=r},a.prototype.cacheLength=function(){var r=new XMLHttpRequest;if(r.open("HEAD",t,!1),r.send(null),!(r.status>=200&&r.status<300||304===r.status))throw new Error("Couldn't load "+t+". Status: "+r.status);var e,o=Number(r.getResponseHeader("Content-length")),n=(e=r.getResponseHeader("Accept-Ranges"))&&"bytes"===e,a=(e=r.getResponseHeader("Content-Encoding"))&&"gzip"===e,i=1048576;n||(i=o);var s=this;s.setDataGetter((r=>{var e=r*i,n=(r+1)*i-1;if(n=Math.min(n,o-1),void 0===s.chunks[r]&&(s.chunks[r]=((r,e)=>{if(r>e)throw new Error("invalid range ("+r+", "+e+") or no bytes requested!");if(e>o-1)throw new Error("only "+o+" bytes available! programmer error!");var n=new XMLHttpRequest;if(n.open("GET",t,!1),o!==i&&n.setRequestHeader("Range","bytes="+r+"-"+e),n.responseType="arraybuffer",n.overrideMimeType&&n.overrideMimeType("text/plain; charset=x-user-defined"),n.send(null),!(n.status>=200&&n.status<300||304===n.status))throw new Error("Couldn't load "+t+". Status: "+n.status);return void 0!==n.response?new Uint8Array(n.response||[]):J(n.responseText||"",!0)})(e,n)),void 0===s.chunks[r])throw new Error("doXHR failed!");return s.chunks[r]})),!a&&o||(i=o=1,o=this.getter(0).length,i=o,c("LazyFiles on gzip forces download of the whole file when length is accessed")),this._length=o,this._chunkSize=i,this.lengthKnown=!0},"undefined"!=typeof XMLHttpRequest)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var i={isDevice:!1,url:t},s=A.createFile(r,e,i,o,n);i.contents?s.contents=i.contents:i.url&&(s.contents=null,s.url=i.url),Object.defineProperties(s,{usedBytes:{get:function(){return this.contents.length}}});var u={};function h(r,e,t,o,n){var a=r.node.contents;if(n>=a.length)return 0;var i=Math.min(a.length-n,o);if(a.slice)for(var s=0;s<i;s++)e[t+s]=a[n+s];else for(s=0;s<i;s++)e[t+s]=a.get(n+s);return i}return Object.keys(s.stream_ops).forEach((r=>{var e=s.stream_ops[r];u[r]=function(){return A.forceLoadFile(s),e.apply(null,arguments)}})),u.read=(r,e,t,o,n)=>(A.forceLoadFile(s),h(r,e,t,o,n)),u.mmap=(r,e,t,o,n)=>{A.forceLoadFile(s);var a=T(e);if(!a)throw new A.ErrnoError(48);return h(r,p,a,e,t),{ptr:a,allocated:!0}},s.stream_ops=u,s}},rr=(r,e)=>r?U(h,r,e):"",er={DEFAULT_POLLMASK:5,calculateAt(r,e,t){if(W.isAbs(e))return e;var o;if(o=-100===r?A.cwd():er.getStreamFromFD(r).path,0==e.length){if(!t)throw new A.ErrnoError(44);return o}return W.join2(o,e)},doStat(r,e,t){var o=r(e);f[t>>2]=o.dev,f[t+4>>2]=o.mode,y[t+8>>2]=o.nlink,f[t+12>>2]=o.uid,f[t+16>>2]=o.gid,f[t+20>>2]=o.rdev,R=[o.size>>>0,(D=o.size,+Math.abs(D)>=1?D>0?+Math.floor(D/4294967296)>>>0:~~+Math.ceil((D-+(~~D>>>0))/4294967296)>>>0:0)],f[t+24>>2]=R[0],f[t+28>>2]=R[1],f[t+32>>2]=4096,f[t+36>>2]=o.blocks;var n=o.atime.getTime(),a=o.mtime.getTime(),i=o.ctime.getTime();return R=[Math.floor(n/1e3)>>>0,(D=Math.floor(n/1e3),+Math.abs(D)>=1?D>0?+Math.floor(D/4294967296)>>>0:~~+Math.ceil((D-+(~~D>>>0))/4294967296)>>>0:0)],f[t+40>>2]=R[0],f[t+44>>2]=R[1],y[t+48>>2]=n%1e3*1e3,R=[Math.floor(a/1e3)>>>0,(D=Math.floor(a/1e3),+Math.abs(D)>=1?D>0?+Math.floor(D/4294967296)>>>0:~~+Math.ceil((D-+(~~D>>>0))/4294967296)>>>0:0)],f[t+56>>2]=R[0],f[t+60>>2]=R[1],y[t+64>>2]=a%1e3*1e3,R=[Math.floor(i/1e3)>>>0,(D=Math.floor(i/1e3),+Math.abs(D)>=1?D>0?+Math.floor(D/4294967296)>>>0:~~+Math.ceil((D-+(~~D>>>0))/4294967296)>>>0:0)],f[t+72>>2]=R[0],f[t+76>>2]=R[1],y[t+80>>2]=i%1e3*1e3,R=[o.ino>>>0,(D=o.ino,+Math.abs(D)>=1?D>0?+Math.floor(D/4294967296)>>>0:~~+Math.ceil((D-+(~~D>>>0))/4294967296)>>>0:0)],f[t+88>>2]=R[0],f[t+92>>2]=R[1],0},doMsync(r,e,t,o,n){if(!A.isFile(e.node.mode))throw new A.ErrnoError(43);if(2&o)return 0;var a=h.slice(r,r+t);A.msync(e,a,n,t,o)},varargs:void 0,get(){var r=f[+er.varargs>>2];return er.varargs+=4,r},getp:()=>er.get(),getStr:r=>rr(r),getStreamFromFD:r=>A.getStreamChecked(r)},tr=(r,e)=>e+2097152>>>0<4194305-!!r?(r>>>0)+4294967296*e:NaN,or=[],nr=(r,e,t)=>{var o=((r,e)=>{var t;for(or.length=0;t=h[r++];){var o=105!=t;e+=(o&=112!=t)&&e%8?4:0,or.push(112==t?y[e>>2]:105==t?f[e>>2]:l[e>>3]),e+=o?8:4}return or})(e,t);return k[r].apply(null,o)},ar=r=>{var e=(r-a.buffer.byteLength+65535)/65536;try{return a.grow(e),w(),1}catch(r){}},ir={},sr=()=>{if(!sr.strings){var r={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:("object"==typeof navigator&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",_:"./this.program"};for(var e in ir)void 0===ir[e]?delete r[e]:r[e]=ir[e];var t=[];for(var e in r)t.push(`${e}=${r[e]}`);sr.strings=t}return sr.strings},cr=(r,e)=>{m=!0,((r,e)=>{throw e})(0,new I(r))},ur=r=>r%4==0&&(r%100!=0||r%400==0),pr=[31,29,31,30,31,30,31,31,30,31,30,31],hr=[31,28,31,30,31,30,31,31,30,31,30,31],dr=(r,e,t,o)=>{var n=y[o+40>>2],a={tm_sec:f[o>>2],tm_min:f[o+4>>2],tm_hour:f[o+8>>2],tm_mday:f[o+12>>2],tm_mon:f[o+16>>2],tm_year:f[o+20>>2],tm_wday:f[o+24>>2],tm_yday:f[o+28>>2],tm_isdst:f[o+32>>2],tm_gmtoff:f[o+36>>2],tm_zone:n?rr(n):""},i=rr(t),s={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S","%Ec":"%c","%EC":"%C","%Ex":"%m/%d/%y","%EX":"%H:%M:%S","%Ey":"%y","%EY":"%Y","%Od":"%d","%Oe":"%e","%OH":"%H","%OI":"%I","%Om":"%m","%OM":"%M","%OS":"%S","%Ou":"%u","%OU":"%U","%OV":"%V","%Ow":"%w","%OW":"%W","%Oy":"%y"};for(var c in s)i=i.replace(new RegExp(c,"g"),s[c]);var u=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],h=["January","February","March","April","May","June","July","August","September","October","November","December"];function d(r,e,t){for(var o="number"==typeof r?r.toString():r||"";o.length<e;)o=t[0]+o;return o}function l(r,e){return d(r,e,"0")}function m(r,e){function t(r){return r<0?-1:r>0?1:0}var o;return 0===(o=t(r.getFullYear()-e.getFullYear()))&&0===(o=t(r.getMonth()-e.getMonth()))&&(o=t(r.getDate()-e.getDate())),o}function v(r){switch(r.getDay()){case 0:return new Date(r.getFullYear()-1,11,29);case 1:return r;case 2:return new Date(r.getFullYear(),0,3);case 3:return new Date(r.getFullYear(),0,2);case 4:return new Date(r.getFullYear(),0,1);case 5:return new Date(r.getFullYear()-1,11,31);case 6:return new Date(r.getFullYear()-1,11,30)}}function w(r){var e=((r,e)=>{for(var t=new Date(r.getTime());e>0;){var o=ur(t.getFullYear()),n=t.getMonth(),a=(o?pr:hr)[n];if(!(e>a-t.getDate()))return t.setDate(t.getDate()+e),t;e-=a-t.getDate()+1,t.setDate(1),n<11?t.setMonth(n+1):(t.setMonth(0),t.setFullYear(t.getFullYear()+1))}return t})(new Date(r.tm_year+1900,0,1),r.tm_yday),t=new Date(e.getFullYear(),0,4),o=new Date(e.getFullYear()+1,0,4),n=v(t),a=v(o);return m(n,e)<=0?m(a,e)<=0?e.getFullYear()+1:e.getFullYear():e.getFullYear()-1}var _={"%a":r=>u[r.tm_wday].substring(0,3),"%A":r=>u[r.tm_wday],"%b":r=>h[r.tm_mon].substring(0,3),"%B":r=>h[r.tm_mon],"%C":r=>l((r.tm_year+1900)/100|0,2),"%d":r=>l(r.tm_mday,2),"%e":r=>d(r.tm_mday,2," "),"%g":r=>w(r).toString().substring(2),"%G":w,"%H":r=>l(r.tm_hour,2),"%I":r=>{var e=r.tm_hour;return 0==e?e=12:e>12&&(e-=12),l(e,2)},"%j":r=>l(r.tm_mday+((r,e)=>{for(var t=0,o=0;o<=e;t+=r[o++]);return t})(ur(r.tm_year+1900)?pr:hr,r.tm_mon-1),3),"%m":r=>l(r.tm_mon+1,2),"%M":r=>l(r.tm_min,2),"%n":()=>"\n","%p":r=>r.tm_hour>=0&&r.tm_hour<12?"AM":"PM","%S":r=>l(r.tm_sec,2),"%t":()=>"\t","%u":r=>r.tm_wday||7,"%U":r=>{var e=r.tm_yday+7-r.tm_wday;return l(Math.floor(e/7),2)},"%V":r=>{var e=Math.floor((r.tm_yday+7-(r.tm_wday+6)%7)/7);if((r.tm_wday+371-r.tm_yday-2)%7<=2&&e++,e){if(53==e){var t=(r.tm_wday+371-r.tm_yday)%7;4==t||3==t&&ur(r.tm_year)||(e=1)}}else{e=52;var o=(r.tm_wday+7-r.tm_yday-1)%7;(4==o||5==o&&ur(r.tm_year%400-1))&&e++}return l(e,2)},"%w":r=>r.tm_wday,"%W":r=>{var e=r.tm_yday+7-(r.tm_wday+6)%7;return l(Math.floor(e/7),2)},"%y":r=>(r.tm_year+1900).toString().substring(2),"%Y":r=>r.tm_year+1900,"%z":r=>{var e=r.tm_gmtoff,t=e>=0;return e=(e=Math.abs(e)/60)/60*100+e%60,(t?"+":"-")+String("0000"+e).slice(-4)},"%Z":r=>r.tm_zone,"%%":()=>"%"};for(var c in i=i.replace(/%%/g,"\0\0"),_)i.includes(c)&&(i=i.replace(new RegExp(c,"g"),_[c](a)));var E,g,b=J(i=i.replace(/\0\0/g,"%"),!1);return b.length>e?0:(E=b,g=r,p.set(E,g),b.length-1)},fr=function(r,e,t,o){r||(r=this),this.parent=r,this.mount=r.mount,this.mounted=null,this.id=A.nextInode++,this.name=e,this.mode=t,this.node_ops={},this.stream_ops={},this.rdev=o},yr=365,lr=146;Object.defineProperties(fr.prototype,{read:{get:function(){return(this.mode&yr)===yr},set:function(r){r?this.mode|=yr:this.mode&=-366}},write:{get:function(){return(this.mode&lr)===lr},set:function(r){r?this.mode|=lr:this.mode&=-147}},isFolder:{get:function(){return A.isDir(this.mode)}},isDevice:{get:function(){return A.isChrdev(this.mode)}}}),A.FSNode=fr,A.createPreloadedFile=(r,e,t,o,n,a,i,s,c,u)=>{var p=e?Y.resolve(W.join2(r,e)):r;function h(t){function h(t){u?.(),s||((r,e,t,o,n,a)=>{A.createDataFile(r,e,t,o,n,a)})(r,e,t,o,n,c),a?.(),L()}((r,e,t,o)=>{"undefined"!=typeof Browser&&Browser.init();var n=!1;return q.forEach((a=>{n||a.canHandle(e)&&(a.handle(r,e,t,o),n=!0)})),n})(t,p,h,(()=>{i?.(),L()}))||h(t)}O(),"string"==typeof t?((r,e,t,o)=>{var n=o?"":`al ${r}`;(void 0)(r,(r=>{e(new Uint8Array(r)),n&&L()}),(e=>{if(!t)throw`Loading data file "${r}" failed.`;t()})),n&&O()})(t,h,i):h(t)},A.staticInit();var mr={b:(r,e,t)=>{throw new x(r).init(e,t),r},m:function(r,e,t,o){try{if(e=er.getStr(e),e=er.calculateAt(r,e),-8&t)return-28;var n=A.lookupPath(e,{follow:!0}).node;if(!n)return-44;var a="";return 4&t&&(a+="r"),2&t&&(a+="w"),1&t&&(a+="x"),a&&A.nodePermissions(n,a)?-2:0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},j:function(r,e,t){er.varargs=t;try{var o=er.getStreamFromFD(r);switch(e){case 0:if((n=er.get())<0)return-28;for(;A.streams[n];)n++;return A.createStream(o,n).fd;case 1:case 2:case 13:case 14:return 0;case 3:return o.flags;case 4:var n=er.get();return o.flags|=n,0;case 12:return n=er.getp(),d[n+0>>1]=2,0}return-28}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},y:function(r,e){try{var t=er.getStreamFromFD(r);return er.doStat(A.stat,t.path,e)}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},z:function(r,e,t){er.varargs=t;try{var o=er.getStreamFromFD(r);switch(e){case 21509:case 21510:case 21511:case 21512:case 21524:case 21515:return o.tty?0:-59;case 21505:if(!o.tty)return-59;if(o.tty.ops.ioctl_tcgets){var n=o.tty.ops.ioctl_tcgets(o),a=er.getp();f[a>>2]=n.c_iflag||0,f[a+4>>2]=n.c_oflag||0,f[a+8>>2]=n.c_cflag||0,f[a+12>>2]=n.c_lflag||0;for(var i=0;i<32;i++)p[a+i+17>>0]=n.c_cc[i]||0;return 0}return 0;case 21506:case 21507:case 21508:if(!o.tty)return-59;if(o.tty.ops.ioctl_tcsets){a=er.getp();var s=f[a>>2],c=f[a+4>>2],u=f[a+8>>2],h=f[a+12>>2],y=[];for(i=0;i<32;i++)y.push(p[a+i+17>>0]);return o.tty.ops.ioctl_tcsets(o.tty,e,{c_iflag:s,c_oflag:c,c_cflag:u,c_lflag:h,c_cc:y})}return 0;case 21519:return o.tty?(a=er.getp(),f[a>>2]=0,0):-59;case 21520:return o.tty?-28:-59;case 21531:return a=er.getp(),A.ioctl(o,e,a);case 21523:if(!o.tty)return-59;if(o.tty.ops.ioctl_tiocgwinsz){var l=o.tty.ops.ioctl_tiocgwinsz(o.tty);a=er.getp(),d[a>>1]=l[0],d[a+2>>1]=l[1]}return 0;default:return-28}}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},w:function(r,e,t,o){try{e=er.getStr(e);var n=256&o,a=4096&o;return o&=-6401,e=er.calculateAt(r,e,a),er.doStat(n?A.lstat:A.stat,e,t)}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},d:function(r,e,t,o){er.varargs=o;try{e=er.getStr(e),e=er.calculateAt(r,e);var n=o?er.get():0;return A.open(e,t,n).fd}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},s:function(r,e,t,o){try{if(e=er.getStr(e),e=er.calculateAt(r,e),o<=0)return-28;var n=A.readlink(e),a=Math.min(o,P(n)),i=p[t+a];return z(n,h,t,o+1),p[t+a]=i,a}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},t:function(r){try{return r=er.getStr(r),A.rmdir(r),0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},x:function(r,e){try{return r=er.getStr(r),er.doStat(A.stat,r,e)}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},g:function(r,e,t){try{return e=er.getStr(e),e=er.calculateAt(r,e),0===t?A.unlink(e):512===t?A.rmdir(e):F("Invalid flags passed to unlinkat"),0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},k:()=>1,n:function(r,e,t,o,n,a,i,s){var c=tr(n,a);try{if(isNaN(c))return 61;var u=er.getStreamFromFD(o),p=A.mmap(u,r,c,e,t),h=p.ptr;return f[i>>2]=p.allocated,y[s>>2]=h,0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},o:function(r,e,t,o,n,a,i){var s=tr(a,i);try{if(isNaN(s))return 61;var c=er.getStreamFromFD(n);2&t&&er.doMsync(r,c,e,o,s),A.munmap(c)}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return-r.errno}},a:()=>{F("")},A:(r,e,t)=>nr(r,e,t),e:()=>Date.now(),l:(r,e,t)=>h.copyWithin(r,e,e+t),r:r=>{var e=h.length,t=2147483648;if((r>>>=0)>t)return!1;for(var o,n,a=1;a<=4;a*=2){var i=e*(1+.2/a);i=Math.min(i,r+100663296);var s=Math.min(t,(o=Math.max(r,i))+((n=65536)-o%n)%n);if(ar(s))return!0}return!1},u:(r,e)=>{var t=0;return sr().forEach(((o,n)=>{var a=e+t;y[r+4*n>>2]=a,((r,e)=>{for(var t=0;t<r.length;++t)p[e++>>0]=r.charCodeAt(t);p[e>>0]=0})(o,a),t+=o.length+1})),0},v:(r,e)=>{var t=sr();y[r>>2]=t.length;var o=0;return t.forEach((r=>o+=r.length+1)),y[e>>2]=o,0},f:cr,c:function(r){try{var e=er.getStreamFromFD(r);return A.close(e),0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return r.errno}},h:function(r,e,t,o){try{var n=((r,e,t,o)=>{for(var n=0,a=0;a<t;a++){var i=y[e>>2],s=y[e+4>>2];e+=8;var c=A.read(r,p,i,s,o);if(c<0)return-1;if(n+=c,c<s)break;void 0!==o&&(o+=c)}return n})(er.getStreamFromFD(r),e,t);return y[o>>2]=n,0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return r.errno}},p:function(r,e,t,o,n){var a=tr(e,t);try{if(isNaN(a))return 61;var i=er.getStreamFromFD(r);return A.llseek(i,a,o),R=[i.position>>>0,(D=i.position,+Math.abs(D)>=1?D>0?+Math.floor(D/4294967296)>>>0:~~+Math.ceil((D-+(~~D>>>0))/4294967296)>>>0:0)],f[n>>2]=R[0],f[n+4>>2]=R[1],i.getdents&&0===a&&0===o&&(i.getdents=null),0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return r.errno}},i:function(r,e,t,o){try{var n=((r,e,t,o)=>{for(var n=0,a=0;a<t;a++){var i=y[e>>2],s=y[e+4>>2];e+=8;var c=A.write(r,p,i,s,o);if(c<0)return-1;n+=c,void 0!==o&&(o+=c)}return n})(er.getStreamFromFD(r),e,t);return y[o>>2]=n,0}catch(r){if(void 0===A||"ErrnoError"!==r.name)throw r;return r.errno}},q:(r,e,t,o,n)=>dr(r,e,t,o)},vr=function(){var r,e,o,i,s={a:mr};function c(r,e){var t;return vr=r.exports,a=vr.B,w(),t=vr.C,E.unshift(t),L(),vr}return O(),(r=n,e=G,o=s,i=function(r){c(r.instance)},r||"function"!=typeof WebAssembly.instantiateStreaming||C(e)||B(e)||"function"!=typeof fetch?Q(e,o,i):fetch(e,{credentials:"same-origin"}).then((r=>WebAssembly.instantiateStreaming(r,o).then(i,(function(r){return u(`wasm streaming compile failed: ${r}`),u("falling back to ArrayBuffer instantiation"),Q(e,o,i)}))))).catch(t),{}}();o._webidl_free=r=>(o._webidl_free=vr.D)(r),o._free=r=>(o._free=vr.E)(r),o._webidl_malloc=r=>(o._webidl_malloc=vr.F)(r),o._malloc=r=>(o._malloc=vr.G)(r);var wr,_r=o._emscripten_bind_VoidPtr___destroy___0=r=>(_r=o._emscripten_bind_VoidPtr___destroy___0=vr.H)(r),Er=o._emscripten_bind_Graphviz_Graphviz_2=(r,e)=>(Er=o._emscripten_bind_Graphviz_Graphviz_2=vr.I)(r,e),gr=o._emscripten_bind_Graphviz_version_0=()=>(gr=o._emscripten_bind_Graphviz_version_0=vr.J)(),br=o._emscripten_bind_Graphviz_lastError_0=()=>(br=o._emscripten_bind_Graphviz_lastError_0=vr.K)(),Mr=o._emscripten_bind_Graphviz_createFile_2=(r,e,t)=>(Mr=o._emscripten_bind_Graphviz_createFile_2=vr.L)(r,e,t),Or=o._emscripten_bind_Graphviz_layout_3=(r,e,t,n)=>(Or=o._emscripten_bind_Graphviz_layout_3=vr.M)(r,e,t,n),Lr=o._emscripten_bind_Graphviz_acyclic_3=(r,e,t,n)=>(Lr=o._emscripten_bind_Graphviz_acyclic_3=vr.N)(r,e,t,n),Fr=o._emscripten_bind_Graphviz_tred_3=(r,e,t,n)=>(Fr=o._emscripten_bind_Graphviz_tred_3=vr.O)(r,e,t,n),Gr=o._emscripten_bind_Graphviz_unflatten_4=(r,e,t,n,a)=>(Gr=o._emscripten_bind_Graphviz_unflatten_4=vr.P)(r,e,t,n,a),Dr=o._emscripten_bind_Graphviz_get_layout_result_0=r=>(Dr=o._emscripten_bind_Graphviz_get_layout_result_0=vr.Q)(r),Rr=o._emscripten_bind_Graphviz_set_layout_result_1=(r,e)=>(Rr=o._emscripten_bind_Graphviz_set_layout_result_1=vr.R)(r,e),Cr=o._emscripten_bind_Graphviz_get_acyclic_outFile_0=r=>(Cr=o._emscripten_bind_Graphviz_get_acyclic_outFile_0=vr.S)(r),Br=o._emscripten_bind_Graphviz_set_acyclic_outFile_1=(r,e)=>(Br=o._emscripten_bind_Graphviz_set_acyclic_outFile_1=vr.T)(r,e),Kr=o._emscripten_bind_Graphviz_get_acyclic_num_rev_0=r=>(Kr=o._emscripten_bind_Graphviz_get_acyclic_num_rev_0=vr.U)(r),Qr=o._emscripten_bind_Graphviz_set_acyclic_num_rev_1=(r,e)=>(Qr=o._emscripten_bind_Graphviz_set_acyclic_num_rev_1=vr.V)(r,e),kr=o._emscripten_bind_Graphviz_get_tred_out_0=r=>(kr=o._emscripten_bind_Graphviz_get_tred_out_0=vr.W)(r),Ir=o._emscripten_bind_Graphviz_set_tred_out_1=(r,e)=>(Ir=o._emscripten_bind_Graphviz_set_tred_out_1=vr.X)(r,e),Hr=o._emscripten_bind_Graphviz_get_tred_err_0=r=>(Hr=o._emscripten_bind_Graphviz_get_tred_err_0=vr.Y)(r),xr=o._emscripten_bind_Graphviz_set_tred_err_1=(r,e)=>(xr=o._emscripten_bind_Graphviz_set_tred_err_1=vr.Z)(r,e),Wr=o._emscripten_bind_Graphviz___destroy___0=r=>(Wr=o._emscripten_bind_Graphviz___destroy___0=vr._)(r),Nr=(r,e)=>(Nr=vr.aa)(r,e),Yr=r=>(Yr=vr.ba)(r);function Xr(){b>0||(H(_),b>0||wr||(wr=!0,o.calledRun=!0,m||(o.noFSInit||A.init.initialized||A.init(),A.ignorePermissions=!1,H(E),e(o),H(g))))}function Ur(){}function Sr(r){return(r||Ur).__cache__}function Pr(r,e){var t=Sr(e),o=t[r];return o||((o=Object.create((e||Ur).prototype)).ptr=r,t[r]=o)}o.UTF8ToString=rr,M=function r(){wr||Xr(),wr||(M=r)},Xr(),Ur.prototype=Object.create(Ur.prototype),Ur.prototype.constructor=Ur,Ur.prototype.__class__=Ur,Ur.__cache__={},o.WrapperObject=Ur,o.getCache=Sr,o.wrapPointer=Pr,o.castObject=function(r,e){return Pr(r.ptr,e)},o.NULL=Pr(0),o.destroy=function(r){if(!r.__destroy__)throw"Error: Cannot destroy object. (Did you create it yourself?)";r.__destroy__(),delete Sr(r.__class__)[r.ptr]},o.compare=function(r,e){return r.ptr===e.ptr},o.getPointer=function(r){return r.ptr},o.getClass=function(r){return r.__class__};var zr={buffer:0,size:0,pos:0,temps:[],needed:0,prepare(){if(zr.needed){for(var r=0;r<zr.temps.length;r++)o._webidl_free(zr.temps[r]);zr.temps.length=0,o._webidl_free(zr.buffer),zr.buffer=0,zr.size+=zr.needed,zr.needed=0}zr.buffer||(zr.size+=128,zr.buffer=o._webidl_malloc(zr.size),v(zr.buffer)),zr.pos=0},alloc(r,e){v(zr.buffer);var t,n=e.BYTES_PER_ELEMENT,a=r.length*n;return a=j(a,8),zr.pos+a>=zr.size?(v(a>0),zr.needed+=a,t=o._webidl_malloc(a),zr.temps.push(t)):(t=zr.buffer+zr.pos,zr.pos+=a),t},copy(r,e,t){t/=e.BYTES_PER_ELEMENT;for(var o=0;o<r.length;o++)e[t+o]=r[o]}};function Jr(r){if("string"==typeof r){var e=J(r),t=zr.alloc(e,p);return zr.copy(e,p,t),t}return r}function Zr(){throw"cannot construct a VoidPtr, no constructor in IDL"}function jr(r,e){r&&"object"==typeof r&&(r=r.ptr),e&&"object"==typeof e&&(e=e.ptr),this.ptr=Er(r,e),Sr(jr)[this.ptr]=this}return Zr.prototype=Object.create(Ur.prototype),Zr.prototype.constructor=Zr,Zr.prototype.__class__=Zr,Zr.__cache__={},o.VoidPtr=Zr,Zr.prototype.__destroy__=Zr.prototype.__destroy__=function(){var r=this.ptr;_r(r)},jr.prototype=Object.create(Ur.prototype),jr.prototype.constructor=jr,jr.prototype.__class__=jr,jr.__cache__={},o.Graphviz=jr,jr.prototype.version=jr.prototype.version=function(){return rr(gr())},jr.prototype.lastError=jr.prototype.lastError=function(){return rr(br())},jr.prototype.createFile=jr.prototype.createFile=function(r,e){var t=this.ptr;zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),e=e&&"object"==typeof e?e.ptr:Jr(e),Mr(t,r,e)},jr.prototype.layout=jr.prototype.layout=function(r,e,t){var o=this.ptr;return zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),e=e&&"object"==typeof e?e.ptr:Jr(e),t=t&&"object"==typeof t?t.ptr:Jr(t),rr(Or(o,r,e,t))},jr.prototype.acyclic=jr.prototype.acyclic=function(r,e,t){var o=this.ptr;return zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),e&&"object"==typeof e&&(e=e.ptr),t&&"object"==typeof t&&(t=t.ptr),!!Lr(o,r,e,t)},jr.prototype.tred=jr.prototype.tred=function(r,e,t){var o=this.ptr;zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),e&&"object"==typeof e&&(e=e.ptr),t&&"object"==typeof t&&(t=t.ptr),Fr(o,r,e,t)},jr.prototype.unflatten=jr.prototype.unflatten=function(r,e,t,o){var n=this.ptr;return zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),e&&"object"==typeof e&&(e=e.ptr),t&&"object"==typeof t&&(t=t.ptr),o&&"object"==typeof o&&(o=o.ptr),rr(Gr(n,r,e,t,o))},jr.prototype.get_layout_result=jr.prototype.get_layout_result=function(){var r=this.ptr;return rr(Dr(r))},jr.prototype.set_layout_result=jr.prototype.set_layout_result=function(r){var e=this.ptr;zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),Rr(e,r)},Object.defineProperty(jr.prototype,"layout_result",{get:jr.prototype.get_layout_result,set:jr.prototype.set_layout_result}),jr.prototype.get_acyclic_outFile=jr.prototype.get_acyclic_outFile=function(){var r=this.ptr;return rr(Cr(r))},jr.prototype.set_acyclic_outFile=jr.prototype.set_acyclic_outFile=function(r){var e=this.ptr;zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),Br(e,r)},Object.defineProperty(jr.prototype,"acyclic_outFile",{get:jr.prototype.get_acyclic_outFile,set:jr.prototype.set_acyclic_outFile}),jr.prototype.get_acyclic_num_rev=jr.prototype.get_acyclic_num_rev=function(){var r=this.ptr;return Kr(r)},jr.prototype.set_acyclic_num_rev=jr.prototype.set_acyclic_num_rev=function(r){var e=this.ptr;r&&"object"==typeof r&&(r=r.ptr),Qr(e,r)},Object.defineProperty(jr.prototype,"acyclic_num_rev",{get:jr.prototype.get_acyclic_num_rev,set:jr.prototype.set_acyclic_num_rev}),jr.prototype.get_tred_out=jr.prototype.get_tred_out=function(){var r=this.ptr;return rr(kr(r))},jr.prototype.set_tred_out=jr.prototype.set_tred_out=function(r){var e=this.ptr;zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),Ir(e,r)},Object.defineProperty(jr.prototype,"tred_out",{get:jr.prototype.get_tred_out,set:jr.prototype.set_tred_out}),jr.prototype.get_tred_err=jr.prototype.get_tred_err=function(){var r=this.ptr;return rr(Hr(r))},jr.prototype.set_tred_err=jr.prototype.set_tred_err=function(r){var e=this.ptr;zr.prepare(),r=r&&"object"==typeof r?r.ptr:Jr(r),xr(e,r)},Object.defineProperty(jr.prototype,"tred_err",{get:jr.prototype.get_tred_err,set:jr.prototype.set_tred_err}),jr.prototype.__destroy__=jr.prototype.__destroy__=function(){var r=this.ptr;Wr(r)},r.ready});let R,C;function B(r){return{path:r.path,data:`<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n<svg width="${r.width}" height="${r.height}"></svg>`}}class K{constructor(r){this._module=r}static load(){return(C||(C=G('v7#aSXr_>D@QO:cszY.yv1htz8{/%@_oy)CI1=o==)w[d[gp$vBh$1[.}C*2GrrdrPi~2[9/=iPFYx:oI~zzE23y]x#Le.0Ix1@]H~Xg6L%u/F8&Z6oElSZ1yN%kM`HUH8mS6z(G=1!+,8I61G<Z"C$Ge_~4.oUprv|d`p]i0{T)3J*[jvCW,`$ii]!V#Ze_phMIwfLm;BL!LPnbmv]{0c?%5@WVfIK9YQ75ylSoeHe].Xe<nyMrT_WaSem+AkGgv,wuq+mQA+yIS>li?LU&[,$:Qa,!j%J"trT_e%n.z6r.|>9oO]5vAeapv]+fi88Rg]@up+yS6YgHq.qpQb:B(6aOB2fBy6b3;:%&6wsK|::8y3RTfp[7B7Gs0%b8z_f2^&+qjF!V0rJ]e[GfZ_xE"rv$w<8w>1Z&Ira>ClJ%*cBc=2HcX>l24x@KN{4zFpcjUZ}8Jg<#L=zCM1kbAPBe2LuEG7eTEww?B8u0fA*PM.Q!K8h(TbDN7%$9C1Usm7n2yKRe@[j{z#}7}:YGDrIFUr!f9Hx+0TW6^s`Fy&r4>Ij]r71[Pm&St_wWJ>gHv].$r.)3r%+S97(1&Y8/%G?Ke~+a*."zwMt}.kV+{[H2_7/HCZUsANTR9Ii:^<$Ib+fmbGB64#^:._fY<NJg3Y+*HnPKNg:#7S!_Ed,?TP?o:x#/DFD{n=thUB{o7W:ty|^nXN](.jq|4:}ws2":X(Wr|kwM@08YSr$>Uw4V?H&Z%9T0rOipb<oMMSsO.|@^K=NX_6qZu&u3]?8*g>V24zg2n.ljzT$X~Mb3$U]&[&4c$uo{/Aol|`V7pf71R|"6cjRG?|._fI5<pF0vL$G6=bgK##Q%JZcsS+J{lQrd_:Zh+6r9i?%f!CH8X%oC?k@Td,E618<V6d[S(<Za>Pgu<lg8/ZE}:<e2j^S~DZIJC3;J#Xk4oeUO4WM?)Fj=J=5BbGF(}]LmUP5+|Exn?z@J6gVup#,xMY=]M^TK$1Lnw%xpw5,h4>NVwVu)]YyUW)0Bs[~M~cQ,6z95,15S+DI:#zYDzNb3%Qk1J?]f^$_=_d?<Hr{aw7<meO+el4[]8fl3c&cj:;]AM.H}zv)#w3kmC[s>8#|SxG:sB8]vLpze#cn:@XlKL]?/{4k98z@S#E]Zb..kPK3KD:=kDOP6p#(DOzT@wR"f9b@0uI|*kxJmP]mJvb3k123^%x}&w$8bP>yep>lM?")_,8bRwiC{.rw07oXaj;Gs&Nb:~6DZk9k9osST{(Y{f39?DV(":5X(SHl|P[vO&oE*s&bda=fM+@vOgK>ns_Jj0,j02}UTr*l*/{3Jm5>;s3P5f.z5v7WT4&Ed:63nWl0:a!1$d8sVIm<jXwXK3&:{D5`v`v1FLqCP5*pW{Mu3EWs+B_:Qu+2`KOuBN_#oAcGLWK$1~C!ZkyL(Tkd)_rke~uejAE4u8[}Q,^4nLd1^x3i^RkL>#v3`n0A({/+vS]qyIR6Uk~eUe;ndvlSS<@L@e;?3}CkgeIm0q=|q4?2S{J:zqy+2W`8S:z$`[[r{aw#oTt>bKYUwxr[("FtMp/lE`E}v8nCSZ)kH]*fmX)1EdU[~rvjB^JWEQ=7_60|Tw8tvzV([x$|K$TlG7>@;Tbvf~^4?7pjerGDKcdO@<iErX>w?|(:<$}y?,|K%[)$rkZ:oX|f_%oy22/iu|?jV}|]82rZZJ"KWYSB;6+ejR_4b+y|^N^y_!0=VM^u``QP563/bO5f*FZg,[m.C92.G8Zb:Kk3f2JIT>l538/}qad:r^8yYy0`TR^snd1M{)K~&w$RI]NC40)8Nf[9!3nKZVoHwTi3Zf(m.#B`;j74meYXsv<R={VdT)XFFMrMb,832k[wq]rGN*=vil;o_SU{H,0W$xQZ^zfTt/S>70Y_`ljw!E@qoIu}Uk%"UJy9~c+ZY>p((Pky;O(n2I$|M;&M&RV2JN}IZ]0%5y>aKrGo8>#Mx9zW{WhJ>+T/GtbIh~<yYeab..kXcK7ziSn5O35e>4p{J</eoCS#a4W>Prd"4vW!Qm8A(_$kju+QF=kl^^[qb*=z)<`azT/GkMzT/oe}C0k=ef)U;DJol@$Tn6;[e&O$Nf/&2]Neq"^WrIVq7Mw%l#`2W2?[rj%2BmrcJn#X&7qXl;9Z3V8WO8^rF(:.X]cH]ly|bx=*J}>F}ZN*=hY9EZ__6b:YL<=JjhxmR^`RbxWz%KxbTT.W677/j&/%/m)qF0NS5INVr9.N)e79|Log<G("Wh/Q>e$maTo1J0d}r=Q`F4x$:CexKS8J@GJSk6Z(Xxs65_[SINQVEb8.]+__cIQ+JPS.K<Uj^z6JCfzS|x*0<$B$+HwFQm8/.Whd2m)psFh5OV(qb=b>bSY!QSb%8/,3fdFDgy=~3[Ls/v$n1K[n]Fvr0<xN%PjW6R=X9>=2M/&DW6?[Z2Jl}~c1+D:9V2Jv]w>+S(/G]jyK^ra1|cmJl$Cg}C*10/|M54c3Nh;L7K=e5rZ1Ud:?<Q54SP>Ki.)V%]b2FJ**J;e3]>zXj,qMFpFbnxK+IWjh_EKI{XgFPn7,]&9@44W42y|m(,zg}IP+Tr&6/T.$BRDZ>Y67q4Z:$jKGn.K8jAPZ2%oE3sr`(WWk;k@E;!#AeTm^*gPWh{VGbP>cwcf36*??#$N|>J<A8P0%&(8JndXRl@2L?|,eIu5t7>NQ&n;Kk}L45Af8]%:ji,rQVMblQw~2Mv/QF5C(X%hfoa:d`Z|N!XO^>EN"Xa$HnSng66ylv<[[Y<eWd.zL.*9rwBgb=e?!{/K#IfvmR_8MC]ZdT:/(qC/m3!&=OWjmH40eb5SHy7f5;~nn]MlAl%0bN@`L~GgM]+;LTWb*YG$&1E}]r7^a5uLV,h>z0sP.2K[ZMFGYl16Hny}RN(5H1d7U7MQ;5m5KRJs>i](zTw]<q)<;xAxV5Y>[{&y<K6Z)%yM8(~|,T0@(e9_~rr2;6y$VJ*xKkPx8U7;%ZX6oX6u/soIIrqu+qA{&s:xk>WPxIjM2>b@jJTTjG+Tzf1k9*s2^+kVAr#cS:.qA|OLJlTxH#QE=tX;I8`sb>HKo>[Zk[(ulHL!LPJ=g.X>/x:z;;k{~^RHq3@%/SX2]Su#sTy?89{M)`B.vM1v``trhZESi<w|.@8!dL[Z8I)5l.nj"^3fNQ}^wMM=7[V4m@<^q&o(32)bty<?.Y_l[^/ftxe$*X#ZIn_5aS~^mx;S44`nYZbE8k2_[[0r$`8lu3;[IDR_!C$sg_tMW&(&)i](g.ljp:>GP7t=BYi@y`>7~^rV/_y`STZTt2ED2`!C{<XR;Th~7@X3XO<^aCPH#v#ohmTPA*R&n5~;Ky%Ls]YM+J(p:X;[yyopF5<*+r&1HLJY}Ch::zfrR~M>M4sv!o>&MWFtX>?K6#kfu="n+mGALq[]xu`qw5*62`(T:/>|dxaYG~ak+22Y+2o&wT6%}gp[_WG>e&uh]w+2O[;eV&SY9E~S0F/o>H"4F,YPyZ{U0RF#y/&<ys:x$&Tkg?Pe>[4#Y,8Qk:4cR*_7~jrsfqAeQ&CMBL@XlZV;X9AP@/NK8M,Y"&s0<*`}><hS:z_JJpT^q[/QR[Ew7&l/+vS8Wh2j+fICPp$Yx^_O(yg_T+,X9N#!oXv#]L9c@L~`$#tzdb~|3Jh5HK5r9+B_NFtYZ8v1I6!dv]R]V;t9*?flfl:M3Ml&2}:8M,/|d2UAy`1<bVe$X_H%Ob+JQ#sOVR;yrh|Mf!ps)kN@O8GcQpgCZ>4ljgjbU?mrxYQ**n;a_?%!XOu=luu?)V=#5IxNM,J|y<ZHj^+CcYs;J"bhd1L7c^>6pkgXD`(w@/D>_n,^@e{yO|`P%?l}x*<eUOQ>+9+xQaUH"8={D.&gz9(/UTU6HS$fvy#g4Lqu2Iqu~V4Y_`9BVXk8VzdTQ5xy0xt9T]pm*Nn#Ln?>RWe5HK${UTk:.R/nDFe["q8/^<YI9@x=:#sP6/5GjP_%kCx#59FTi>E*Y!zP7ljJZmk[Gn,;OaG>bG^J!snI&k~&S8%.7__{wI~v/&vvr[_`ndxT;)(X7.w=+SnPA*ODVNX16m#h@!wVnRwv0oB^J6f&2ljg*9K)|q|_HK#~a5YN)e<{DZr)qSLd&&hW+2zYU.ESczOljsGK)K4yzwwmD>DUy2D]o?HKv~3JSl,*V9}?DVxq6r>iDF3235H=,+u|;<!!@;@Uz)u|;<4Q$3sdg>No:f5Z|=0f6pT`^p*/,<f6q3a?<^KFk*g^X+?LQq%?<^rV/n(scCJ>>KV!|JDV,IA*2r})GKa."9j0f`i8cjA(]Y:kX>2_TkL>L(|5:]1Y<Z~pxrhvwTMx,1}ga=UT6YE*Y!3J!9TkK57^3Jd5!N=Uf&"=;2>*n=_l02R_vimmX3E2s&W,4ZA9*2`d3&S8WhUQ=<GW<)%M{R9x01MtTCMks81(TBBR(H.h|tbCM5KIO!Lv.h5A>HnM;?qIQt#C?rrPD<"h%77B"W6]p1Rt|C3z&a4(SCXN`R_dTt<DV56&v{1(=BPFGeq1hcUD~0&a]h~A[PAgrIYtJEi&VxX&~(*Bnf.4A^]hHB*T|Pq1at1Eo@5*;hSBlTXr^QiiVu[Ep*q1dtGFN[4Y<hbBPVB=_9!"iFr|Omj+~tCe6]4R.+kY~Hd%cfkjBXeIKuHOOzPCojOmk+NBwh4)2RyL+Hho]al+|BNLY}}e+(0Y[Pwm(a[h)AJG}I};SthE7joo]Q5"x){E9/<vUjOXWQ{_bf/y(Cho]gr6#8ajSXdLc}:I2+oufXHTTj2)^CJw%NTj+t<Fci?G3R](^CTykEn+!YXNgM;I=ykDM388bjiM~Gl3eZAf+A%DrxdZUj4zwDW5]ao+.Y8Oh54!%LYJ*8P^o+{ulln,3R)LDID998p+HvKmc}3R,L4J6=;HVjrM7I,x/I^ypE0#~R5!:LQJr*8POtrX@S(z;I`y/E6=P^OtpX*T7f:1e"|tqRNNd<lj+XaUW!lxs+FZ:U/%5!ZzaFpln,b44+!C&S%xMPKtwM=K{_Y;<yuF+pQ)^6cqh*OPh%13*(~OD%Y}PV0)7IdBVqJBDkaynqPBNm..^>1EQ)sPF)!P//13Y?SFn?0K=(*KI@Vqn*VK0%O+dqjBQt>{PV@_]CyE03__p*"LpdWqxBPFgULV/t[i|z`9_>/ITR*0!_jDCU03d?~InV*0!_wEn4,b">UHPX23}(/OHjXq|Bq#,b#_<Et+..B?mJIizKg?JIW]LV$)(QdBYqMCS,..)1Tv&faGMVIB1CA6t8VqeC1i6Cr+NN#E6qt8JfNufS.wZeEi9Et;iaJfSuUTPruPM)|J:+Y;RfZuZU5/)HT!0C}pGeyPQ)8KG]Y;IiqFO}5lPIeQB?tHKf6c.jW9>n"B3gX;YLC%DBPFW.IIwnc,iJ$oYqA+&J6m3Ov1cuvUz#*aF)nKsw+fswLgrDmIh&{GYtc8rg;q5;|$8o#C6?qIo9,?S9L?pg(t$J9=[N9h<gyaw_pq9)o3ad{GIlB*zSOV[${)>_AMNY?_v?FwB)DwzGDu4t^JEiC)+iVusn5/V5pY%mtnn)DwD)JR$6"C*a<?8Da,CClg>?:I56:]:$"u$IH,(n[vHX40lJ$UM13nYDl2c8:$=*?SFnAwBM,FZuaK^j>ZXVe~ucE*LGduYQ0qM<{X2Lb[BYW*MG1Y1Fjtj|BMIwV)DwVX`F2)LHCzx1*jD1UMuiSV~L2_v?IwcXyGL1tZnNmi0K;1M<|X!LrxFG*Y"G:.{G<Q}!XXWRcq6}{9HDNyGOfXw{C<:(TC<*c0NV?{mg*)[ERn?ziNQi$GX*_T7zU9{1&uzo]SXQl?UKx]:]>$I+OVsw{(:?KI$q4;@F~u^P;DkNN?SIk!FE<$^*kTewSd0n{xaje>2e8ns,"R$UTQeiPJJ:ya=$hvwbZNXQh?3JT%4;QRkDg`/l41,*hMeaT9Q?$GSUK1~$&@NH+4Gx:$;*wPf,T9Xi]IF{V[~XU?hE*krbEHoq3X3HY!X7CM>F;YvHh,@$}XvtSIjkjHwi*Wax4Q6!k|E^D!KXsID=@ozQ}v1)gJb*"Cy?[FUv^P.J;#iq~X;L6EqlY@ti}FdurC:Dm!{e)(=B!H^fs8A!Z"jCFp&a@hAB8FD=*[")>L{E_nM0u?P*@LIysU8])kA*]LQyRV(^pI,(MCxP]yVxQ7CC|N)Us1Vt8DK:Lv:hAB+QFB_9y"hE2+s87(~BIJp*sP8(eCMgH;};et>N!H|m^,ajdMpG`n/I6+fv?neeZq}"LUNZr_C+(QrDLV(?<H{7ay}>WJ!gzKD)}R0MQVSukTT#Bf:)4H%`Uq{uxipJMVA@u0AR7HjgG)yJw)4exn`w_Vm{jgX)KRMG3e0nk,xMTrSQVi6I~,:]?a???Jq<JIUR0DQTXjzKAiEDDp3x,71?sq!AuEDPQ}s?>FVCaCQA`(yKhiuEQ{>+|vy;C[x8rg22yCB`%k,ku8]L?kMO}9_n4Q*xRu"AhOL0HmxJ3H@YNXqt@,;o}eieR1&i8t<"c;4k`9_<jX@w%E;NvE>7DTxGtFPr""WwpkVca!5#^qy{{E<Y8Q]Wqjd{8fxpMci<jPbN*yKk*u8"8re#|eX:ttFl+OC0CmMnJg3iH?^n4aob7)OSuaS6,1NO8:4iXdAh|ddUF+~0y@!.uRbob714[|K+;U[|2C!S>=L54aVol]Irpy54;oTHCZB8AeI8Ae8?MHaP|jV&%[M8tnNU*j^6=,!1XmVo81tEN8)yF80C4np:NllH~R>>Nl[^*SU?jTUX(2C&h:$%,m0Sf2NbqDW)TW.#Ahv%%pE6|HR/X1|m8%lqj&Ul[]A&6T/<jyiV(q%bop262T4^/f,SO5#=)F<6BKm6+n:g0GL6{b$N1r^Udwc8{ju0~7;;>lnp/c6uBN)A~F26012Da6&a%iVdAk3Sf27%|Z1cgER{0c[a3>w5bneR1wTd*dBebO)j/w!izrpyTdPX47(_fsxFaOy.ZoJFX1~^AqB&rLl`B|V)bu5ATnLWZFK+yrgG93<F+jh&]BS%v%!1?MF<b+{6K+CA)Oc~gg.=+FsrAk2@P3s`$B:1CVe%J9ROW=H1LU"ysH$NY/r*swRKv<bKB2B.|VR3T+R<doIyB./FHdUeD"5Qt616@f#P#4R<`2Md3U@g!o8N[RwX_!l_w)[u["2.0fC>]K89EycR5ObuSI#SQD_a;(OQ>7:<A#Ix:w4LwROlT*SnyxF`GAJ?.%$,a&@<$$6y<A>qA?^^PBa?h}8&K|5,n}`^hU>oTnBI~Bj>@6;2#=rQGr_U"/+gtS]I[FlQr{Z53pA(ix$i(jx/g3pD_EVr2bjn*]&`EaaS5BW{gb"{SywFbYnieO0II|<_mU0rz_QX0pf|x|;SCv#9wy:9PZQ3HB*Wb[3L(bG!r`)URPT)CSnw6n{PppwH*7mX,(W+NXb,Dtp+ik4j0r&KyfK5B/}!,Uhe1w;_l3uXnd[#Ypivz#6DKQ[R|u2.?6FCmMfH&D7^<&:B`z$#s@Kj@#<w[^yWi%e<wlxr>z:Ha4?FT3bn1X$lx&TW0r=3k="QXpYu_%HKGLibzHh"A#Dj_224knN)iF$mWNASjwYuHv8Ap<bSVI5e>m3BP;/xp12L=Z}+RWQ?,?xFYg&UrGG3k`hGnF*Lcgm;gp2%&&F+oFE>Kd[CKOsxqfRfXmk3ipV<8v`KN8J(z.DCxb:DZ?c*m}GA<Nq8Pba)Amy$WMo@i%.=xqM<z}E|.%?^.709|Kwa:{p$>)v|p$1[%AWg:L/]!.z>/2SKd~UoQAzf=r9JplXg+VMbZePgtw@}N*W9;=W8K|,9np1)Znvy>?Kjj]^u99;20c(Rt4YE1+JLLQg`;f0W?{RcuFeU`{QKa&njg:KQk%^bQ3bpan^:z>qr|1kd}fu?HPzVlh1;v>4%wq~@r;8FL|K8~6geBHJ7%DUjZ_3>dq/NX=GtZq#.+V{Z[KcASn6o,}Ac=f44OgQX}]E|[PlF,TA|3mZ&s[7%>zVXN$p+%nzKD))#^A"QsbmOdb&e?"MYXOy<c!v#A<c!kO"93iL]fLwWvml,FagOG"B=aeMLXT$j#CdbttA4XTk3gcdbE4qw;GS7<(mwv63iU*d#Du0Tc%f>!6]{1duap0gYN_lTR5]{2o%2[bJ#.R8rW|{qDQQ,C4*de0h0l|N0O0,=Qkd|La[O1?]1F|;7R5gs.Ond<u3o%2f02oxG;eE]Q,Y0nd=;Pa+38w,`jTK^HN*2f0KUC006!6G:"zZmadfd.+>VCl&X/0Wcds=PQ,Y0[3v#.RkTEdXhAdLd,O2oyz"zl<06k@u@d;u=0=Pn&)M5.RWdI6X|G6DWh.Dp%2l&0/a^7{k#&2ncM5AOjmL6[bW607O]6dhaS6}NM:x#M5p0EcW6TWCl[Ol@(Bt1#*AeTMLHgXgZI(+/!htB~g~]/8o#"/qc1lrGNr)ZN]TeDY9+PhgFeR72wHs3`PBzF]);@vJ5<jydDI<L{o]D5"6y~TPD}P(=D)rvf1}J^]WE|*^X|y!p{`5+}2xjebSwT.98wps4>:!+f_o0W@HV|q/t`_m$F^W[s_JJG=nqQx.pQu>:nlx=l7)]6;9Z~<LN/tkh!Ti$*brZcWMX!0UM~:#VK=e$?bI^6+XZn25%i0T~6:#>G~Qo;*Pa6bOQ/M~#z)?WS9@YwS!XR:QsmX?Hvh%*4wTcl}b|dztH7*pS;5L5ng)a/=J8oIf%*tTze"yPSN+2}he"EtsV~^E2+2&6R]1_HpGhC38cPM.,Y@u>RKn[@6J;*%lECFDV_/<L@=:/)MG5u}d/qVj9e/_p<[>V=fMaZMq0Qrw0c,5jq#AQepX%UQ~JxN=kBq}FQ@V;~qaUuChhDV!M{>O(bLf4`nG7#u%8:UfM0Vg20cRH1w9#rL1wrdeEcFtUg#:^Ll`:e<M[{xegRiSQKgPB"py|5W`qkBw4{3Ss0,.h1ECr4`~QfQ(`AkK&l.YJXLg5nNwe},PIZsxvDnSA+m@EVNsmG`,&<nH[^QQ|FlL.H|`UXqt6BAxIdTadpvwT9E6yZ+pab$~K_b>,$gK=ft)[.<8CHXklNK84Il=KYEPa"^)U?bD12(9fA*Y#IeQ{iOR`~qg3fB&myZKZ`L?74Oi%=Oqu6brQWRw]LS=14WaHm0@DOx=FAzlI$L]IUmu}7E$2a?M^z^Fr$2R[6:!=KOC0$]f29a23}Xj@k3[sKQ:5_bH3PlS@Qq;|8yeH#Jgjy1!^sc}X)Cw+}aV]riE@voKQ#:yfe/v=>Ly?zK{MNFo1>Lq[B:(f&nRDc~Tq4.!Uy?dcPHl<R$,uk3rN,55l]r<:]5q5M.^1Hz57pMLbcT|/U,5{g@e_<sylt9j.Q!(*^l@SK(Nl]j&!N:y<,/C|J.ljX6I#N:BqELC.6ga.S$ylY(}%>&ymG#6qb#~u^ldp]dm/;!,|e/38Yu;XR;=m,|uNqH]}/)xTD^`ySLTDC1q":_yN%44.w2`I"!%w$7dCyKVHo+RzS;M.n30+p=!U+cSkqx$OpVr2$?Ts`bpu)5Y4%6tg]8Gky^yRMT*?i)A5#U=e[x$=qrS_"d^GY@~`@S6zAnA;yjGSQv91b*ll%?!9(=T:g%b:GGjb",gOE1/;:?fpmT_XF#0$<?c@k&L:5*v+HVK*>HMyB.f3qY4z[]#)|o6=6ud/28xxm21ngeslWsk3(S*#+_w6PJ1|Co(0|Q!UK:#R!UL:dn>k/8o;fkbsO)j9pP%A_oN4,Oj*(({Br%sKE[bDc5tIcSo9jRvc}t*gPa]lhO*s|OG"9;nHdXTcK1}Rm:(,gsS:mGu3KpPS}^uaPkS#!F?^gsB;=cp[VdA@dS>%DQIPLU|+90[[+6<;!~r=<;wbe@w.m@NF[[*N}d!UI:#h<H2zq;cp8>d26t3UBo?8>P,/.~TpR[g7DN}II2NSBv~:Qvxb;[yy%LBN/)yY[az7qC#tz=?W_Ev*0S{|*fpUS{n)k^TO}N~XL+sZBqb)D2oRa`[#B@Bq@vp9US=1#C~w,Yhx/!t%dW#C~7:54?d^_nKIzNfTM,=K_yu&!@2@,^vL?4hSS{`b.}S@599I92KUCxj+~&09EI*ysV~atXis`H):HKo{Jg%*]loZSIyRIDa(gRi}H>(b65xY4ZoKuLT::s^4fegOQ,r@8#ELSsa61^$5[aQ)Zxc%`+%y:cx$@FVz4_QJVH;uTM!~E_E=kZBLr{kQBZ^f3S(e,p+yAhRj+i7/GFv5H~>wizx^FzigW@A:xgP7nSzuQ#F:MkZ9rLIN#G!2S+>3F%5SRoFW.[MDc%JuKWt_Gjr#|nrL;SFjIl,^.X>+^u"X|yyh@rK:pGpyBK.2Mp>i^k`,`=]5(GzSq=3o1N4s+;k^~wu3O@3+&1u6l?ihlMO=IL4#,AG8"Igb#pK;e2Q6O7MnMo_Sb/o;dKR^,gWj=#^h$}`E+Vc[SyN}x|0HAqOj9sAeB8|R1w1X+FasS&R]oFY:7I@^,K5eOb!P?0OldHN"1F+<WW<:U=ze$9&<r(K|K|v9Q|;pl>t3t_Ss>iYmc|tq%24F}C?d[B#6B>Hy"<v:5Zr=0^!6I^m+[C14c=K?#:sB7e*.$Ha[#bxr:[gDx6aIAj%xq)1U/DDzz^fIN4Vvk$xT;{Jo*Cm~DfwRw7`sD)QY7h!L;L;Q=?<UYG~a~>[B(de$<[vK"FxlYX=ea{B>js7,;9g{{#+_:QsT<it_$`|dFlt[(U(w`$`=cEj<,25E{;GIC:Q_._xSP%7Z7eXvwiDrhcw+DPDMkkn]tBq8U,DZo_eJhcrK$(gx2W8XCZMwcsAy6K&DW0&>#>;Wc2}[FrN|ILuN![c2I{U?7H+V*%lK!dn*GkGL%:n*zNo&&H[OS5eS%hT6D&(kS5eSryJmyY/S"cfSA[G**B+WU4gx/_>sD[+JP%)6b&PIla,v(oEXA^.@7av3`s<%+|2oA!B>cE@>]py*2GFo4=7D#`rMMOvTJSh<kR7Bp~iKuonZt3L{a:^<Oti&8HP.[,CbD&cNAd"d,6Ty"zrWzbAT5@rChSR3M/@E+dSl[|_TG*2G?~<QyT/!05}OI"*^wRo*hS|^)q5OF`K|L39P>|<i/$EoSkd|F&Rhj:WSJS/Uk*er,1doT*z.7qJec2?q+w8p*v?_2xCy>>Klvig<`dN{B;[A":]GK+LZCwln"Y!y9kLbW^WF%ZN{,|(mPv{aX]oANl|ZV^1y=lgw8EnhPaqL$c%}&wikif6OdQy%lKLGhUkHAVkHh!v}~!zgh7zL>>eXS#!PM##[7pG@c}g.H*">[B"/^`N*">`B"/iklm&RN.:UR2urKeSlZb>QjeU8Eav9*"0OK`APgs|O>k9`oa5OpTKCJiB<`JyX2L6kOyZ9$LDs8DT]l<DGc[t9C1nfY.p$>/n&DH%g}eDDhSS}nb`Lp/"wHV}>Sa8Tru|f&l$tN*Nlt#a~Rey7Sf(X>GR~J=<`opO#1Ggz_]DDvx4GCL+1[}&%&^tX5!F#oc?8xy)*t%pSN0]V{M2oym6<65cin*X<_r#ki]vSmYXjgmyE##RY6zQl3H3#2.FJ4r3HFlwv>8Vxp#NPU7dov?Pjh%brJPW#B>xsK$C+EIQ@m6bLb)=d)jp=|Eut+nV=*5xJVECD4ZmN0K8MUoew]d!U>7ew]dw!C}6Ik:Rbx^1i.IXuu:|R&]s%Pvx7}7cQytn#bdA)H[+SNMT:Zi;HQ|({NvWi&5Wo|_~EpLmWiR<`I+#kSkFacqjTU[~dD@K,rQ@4@Prd},)T"YxSp<}v!+1Cj]IlEM3J^%S+D)[Z}$B_zR5ih&w$3J)56mA`53yiGz~V*vAYw$E*kkeeGYd1PFz=%"N>0q.=8ln7T=3fwTl&X=g,.W`P?W(9C>Q;#bokyT9dCM$6eoUw[F_/Rthhy{OJo^Q3`EiGAD*nBZtv[FB2HGgtPj1_TJ=xc{hE!SP>tRx=_NCnFD23kBHxI}x+(OFYm!GzEV*%Q"Ql$;a}hgII0wKZ.7#ysdutZh?iOS&znL5$RQ51WwidkL,Qp7Y=.Lb)y}>5UU,MWrgeYkwZ:|^ByV2bsXwa*[l7{M?Nl}_]KG$6:?~AHu[Z;>[0q_J4Jr/TI%xIj^wLXDxxMY"r1lnYg"|==l$5{A:qIRz?VMn)Bwi_}nxT="BG1Y&O7z09@F[{=5W1]<s;v*5n*r&d8l[n,^bOK;&:[HBn<,GP5RQBcDcuyuw[WEXG46,VL8?MMw9b:/1H]{t&co+Ag(6OhU7]8m(KwUP`dnwSLkCZbrkyR7~g<=T!HpQlu8sQm8!B[+dU+D;VLNJ^8Yc.Y6]]krKgi].Xu4lZh_pZ32xFJ*{q7.GBk(i8MUmT8L%BVY1b/2RT1b@BS{7yd245^^B_5.ZMSPbl.49=D(dlwjj|u@%dDMr(KXpv+f!A!/LWPrg@Ul0,RXFEbV^c&/ZT[V~vHm/pR#m3@KCr[Kf^Kpj.s?Go#C%Y`L!!okf#$jZXnc?k"^~.FM+1Y,Jeo^:7q<G#?#vy"$:dOrjq50bN,j4LHhWjM.9y*;zqiG@1FU0y/Hjuwfc4q!h,ID+dvGxn;=|5kasleoY)shxT;%lJaa=6`6Biv[1t3|mEfskCPD%{OJ^]F<H[^IbgK;Uoc]}w#b$p$ENNd;VR8)H!kG<55i^J[A,^q[5A>i{Ka5n7U5P0B+!9f>CW63zh)rGV)V:|Ke(/Fl)2EV(Mz^bR|*Z&p<|vJ%rU_/IaT>p@xU!7j07,_Xe$CzefLmBQxl+m3}G+Yp]kSI@prey*V~xo)X"gVc~+?JK{<959~tA8Nm3N2oAE$48[0/pG]UxXX/{|/<<<%.7pXv9T/J39=F(6=OIEeqboTwcApux)lgm{mBhlKT/JAS%O29KvEF_x6d+YG6A[[0^pv?@6M:/{10R@=j`kz$#}TX;Xb|0couU_:V&]G|$cp><*ad7{rfP?[KofbhB8M6MD(]/cT0I|!s]22N2Y8_SsdcH8:4e.N;yr%:3c!bgH6h!b/c+:l9ml%?#:WbW&f2w#6LL87df],&K|sYIn`r&jUZ3M#,vBVu=)0)aTzI26(Oz}hej$`&Vbyi<S`wJR_I%h?Lq$AeB8=6Yit{&;bit{0cnp+%d3#pTj1wyYjeN9jVJ7#KNEK#6MB?,XZRQrP]6.Y@Ds$uU,FJE3My>>{(0vjUn|e[+Sj:RE{pPK>c3U;1N%F`l^kG"$x<SAme},6ONdI_DH"Y6Ty=P+,TAlch~w$poe#flEv+]LwY/?]|LI%.y231=_#i:)_wWnq@<V%1_VEb}gULlYZ=R+ZEk%XQS&)_3GjyTp2%qqK8Hxm[8`m%cEzN,iJ~Kb:e!Po!Yls<#zhkrvrPr1B0("[l]{;CHj6R/<+2kDi_<WlY*JxR}$TfV%gxU^cJqu!glb)x;bvE}5JsmO|.;G,a[|OS+p<;MkpgY]f)3]iQh&PoY:TJSQ+XEMg^>^Iz%wu{%{Ih%+|4@{iym<ZK%{Dl&3$+{wSS6!lMEQ(<wea;,^8w<Y7VU7i~grtEK#b5Js/1pUN=cJZ&Oo=:p|$`Q$#ty{99Y]zSoMGG:x~X#UTTBbl2)tyf$/)YJ=Y%wT>n]XBFJ]1B&y,vw5VZn^x$c_K|4LG6"SF<y9cz((FTq^~=zZu?Drs*ZAG6"SSe/YF{0uR^gk7E`W2>a0%)MZ26>"#W1tVLAuvXymYL"#[_dyK^.W@FAX7/#EKx+W[3^HTM,i9~Ud,iV[UcLDyveZ9<KKY5PHZY6"/1Mxepy6HH0S[;^gaeszptD83?Y[<_bf0pXSny!7~j!yx<#fUxOUo#x2yXYZMr5KJ6:]2vEd#X+9c|(e+YbbzGtsXQk:+1&+L6$n__}L%MCq~2RBKze89TO&16Z^iSgTFe*zym;zlzNKQje=/px:YYwPlB84UJCh@Ozo:R*r8x!Tb2pO$r2GclWIxY$HaM_2j;LT*P^e2R&>[[7>n07O3o|.pw|^WITee^+#ynmuHL{FKYg|wIjMy3PmO3_,**3+xgHJWxBG[lTZ<MmdahZUs:,GEj?}n$Y.z6T_pro]H%L|T[6:O(H_?&MK{%S4UG9>NlUy$%o~v!XGBcYFzoO]>V0ZYVd+c1gvv5P%Rl&c9<XS+YR*akrbMw).4w0U5L7:;sEpOo~x{2uZWm+YLJjMVyFJuxCzVmP[{=%uI>>gTw]_?PoL>9fkTTi{9x=,OBw3A>mJLnFD(eB]#a0mOB"diMn1AN`^kkSfXCE3"O$/aO;t`NKl.&b`Pl:MW9e*/|M+Nzl:/x2JO[ycWH4sLkvGHaI}#06S:tB&tgK,xG^t#_u%>?"Wj[Zd`yJ>4.fSHZR:}qY5%fBC=[hko#SmH0aem#8u#q"v%LJ;J8oIb`]}B;J8wIH~)X]gMrhZesObvMDsF!Hxmp&3?:<;F+([!.i[CyJsMKort3UG}=Qx|[IYHgBZ[3b};erZ^zQp/4L/Q~e0FP#IyozT1@o3N.Xdi.Z+C@L.OF#I+V<KoSn&8qNb?.qg``5NAx=a^>9Fw7,H*5*lo%K>K_}H]IW?@nxDT[WwVp~er*~Vdx3pgjDdVeJoF>R*CheIO9`y}qy^cAJrxgO<bh!^#pzw`]lxVbF@T@i6HxPW_/Qvcpc?3UgP,^;:sLMLS`Cl%Q:L@DEfh,X(/+P*9Y*H^e7."jq!(k9>4ovVvDfSN_2.%[D2)dF%fs_S6z8pdnTx]IcS36V<(y7g[jx%at5Su*%n"wM?l<A%F3oh7:s%<L:dS{Z*#{FMxqt],<NAtM&C!&8>zZm(64/MEcGHg_,<8zV/O<~p??YCAL?m!h!Y&9f@od@5Dc!rdEG7>V@,5Sa{*jYIH`mCo^OFfBuu0Bd)vTf7d)m?Qj?#6BlsjT&{vEuY=SHDO2zDT:IYk$q[,y<Bk05}z_k+BK1U.|fG2s*K1B+>?bej#/;Yjz[p_ZXpodN|UW:<ObErJ`dA`x.:LiwIB&DW|NAeWQG$aIs+&xy.M0gkQhUD=&HJD:a2oKV<t+u~M?wg{h6%lfz0"@wD=De0"@Terc^1pau`2SZQ},V6)q+dgyV,uKP1=d.7#3UCP5a<"ps+&Pq!fF,4pmE32Y$*G+r{Ly9cES#drYiZ6E/dyS4.3qJ[,[>Sj+Fk}m5X/`f+8xyU._hwi}3jMW{MT_d3rZMoLY>ltlnq1Sps/R#QHeC7Ubgz$>co]b%UI0S8(C)gy3HC=4wf!du`yC=kk|h_DMMtI&Ln4DmeFT0(!ZyC&dEXn#TlHRnzLS/c|yt`<Mw+&kyvN`oxMh@n`T[O31*XXoSyRfMdfZ/}WS#@ePC1KzpQ#qIO|7FMTjq,xaeKuZ;Pb!gqdNUWM+fMNLuMqJ>N<t?c,4MlZG^!kl$qd=<vX:7zG`C`V?]+A~V2t6f9d[qgPN6zb:m[=!R2f9G+u`>0|r]sPNY5.WftQmLy}Qwl+izSs~G[b6>.|qiXAPA+QlSgpX93HM@nc)!fvvhGf@AI(MdmGxbKrZZb3+g@PF#IB&amTf,LR&CyNC!8m.g"30A&2EU5HsS$}#2Up*lj`Eo#v5DChSzl#e&IDsCSl4A2Nl67~*U6J}wV0L8:kf1{}HjM1?@a~2|n5_flp#n]w#~=DS4nl5(e"2r6I>f3OBrGlSG{}7I*S])b,wOFUb6E|TA|*3U"#~xoO*aNu3*rZppHT[8GB:7fOMX]dWsi{LM("WK!(?o#/G~^:F+,_yp5*XhDD$<O"_,t)byDq3L{{E{YT:o<SP;KE[kjs[b!VD<n@>qC+TC%!uP^rV0/X57!^ypZv%qF*1U5EgVN_ubK"odswvg<i1rZgUURrZmoO@&fGY_"<ljJ;_;:+[<vTMRKgjw=hS1Ckog9{4n2Sy)`!|gU#ZwrFL+8n+)`F]jKs[H.C)S(L1)`!ny<OVhykP#+=5`&M1s[+8ScA8!ggsR$Yq}%V2/5/5H<RF1<}Xltd7AedAUfB`nfx,Y0n[yYJTjv!nN&`EUO^`b`!U6n`N/<xxHJng`Qb.H!|5Gp}a*Ga4Qb_I^9gE{_vRK}X2)k+*XXE}ASj=Pt@kV6B_0Ki{+PVB=$rS@4`0o#B>wl(Xi^>kLE)3?l(Xu33qd2k[h9v<*f~)5Ee}kqy^{y~iX(%,=O.e[JqYj+o?HKAmrp>>58iQmA2GMp8h9h*:8{=`NLqu~p61Hsl^S221V{)Xf|a|F#N{7{~3N7!.]#r8kmq2N3!&Fsb:7tL&Y~B|O5`=;{Yy{LA.B[>x<xqi*3AL)nxr|#PUq5X$gb0B.GSSOK4D3wJrVkk^lZ,8_FjbEB732^"Xy8O(hW~|SN~1iFi$6;vi[x/&LnqN^pb_Ix~?f0x^sb<~KeS]t@e[4,Gn%q4l}nqL74,&IqS8KVSP!<hdK$X2,V[+~dbsS.=:VG$rW&{Ze$_dk;wqWvhZ[eN9tv}q6mEZN}epIW)LIaV7l99#&=CrK)!oWs":p_B6"Z]R5|7:Tb!>g7#o./ke^yQ$4ijbc=Bq<KK#rCo:OTubmbV.|tc9}LeR{rsJv_D:2K:qNVB&l:<i>ia!yTJ56,/cGY/)KD(y,8nfX.=lcOrzB_ZX0:g<@3}f/5ZUagAmRHXI`K~KN:R~bCwG9N_#RZgxb&Ae)ic@]+hS&z=1,_b.$InGj_Xj"o18WXTe]=}fN{E8Ae~I5D`,+X*VKg:Ok@3F(&LI.)FDuvIUV%GUe1*r$uepr{Y(^NjRG44&zP|ya2f)AqK*}&}$YoZkaW>%jN+iu}mY.&Hy_c;Ln9yl;B3oN[bxR![L^S8B(;xi86/F{qa^w(2Q@n>t!"W8M3;4X:Gy+kMv,Gk6gLC4@i]0SaJa(j%CH1udkcDiB6wvB@IucDnqj@wH2L]=Sxjejuz7qVhoqYhD#IXgF:!*f6*2SVKFb>eR67>#.fJp~Hfui#M?1IJqJZ%}fpGx=L[x8p7..W`l!+F:AKs{u7n&2%6hZTO=5h0~i:ws:%8=F:7xgUp]Kl(n6E]{H{*[2^WhP}vfx$p4X;x~YgmdIW&.,8l<agSIsbp2IlySpp>O8pnJB2Q(,|0.Gk]0HKYu70`E=U6e*T]{=+;H$6.R=$@H([B$d&>J$GQRX*Jw):I;G@G]Fww?JYQXED:7(5W.>*>YM~*1yjEZ[tI#}#;])bUp(8yc/nT/k/.i$T.WQ8ESmYdx!+rUqoB/RI+/;spU_]Vr%0uaWojd>o#nn7#to]Ywd7o_x.:[nYAF%y+cucW|Mk4?aCH?[B);G^gkm^z*<r2!xd/G&5TE"UCDH!AZO5,3gqB&+Sb7/gh&r.p4o}~xr?4y%s(v@CVm1)ml$#drEn[LC1h~Dnp(Qw~$X5b(Zu0IS65e(.gz6Inv`FzyILs{+(0UN3W@:8zX[k]PGE4:_HU;THYzs6*]cEwE(3_WeXjBc5xbsFQE&09r/NT_s&5Wod*mAYeV!_4#~W4kgIyR&=DKgY]JoRnn|J4`j|OVQF!Z[Zb@~d%23fQ^2g&K77x|h;|IFEbJUIWgpeCCQX=]%?[x,qLI2Sys.fJI`/TrIE_7x2nwyT^nY)~Sm*NwI4;mq)j+Zd0;jb7ONw!6K.@TN?ol?ZvE~i}TgC6#s#Fk0c.{F]F*!kXf.>dJ7"V7f+#Ty6QG(4E@]Cti$Q`BZ?i43kd3Jf{)FR]Yz+T90UbvqvQGQ&+hSKWuiiT/eWy^iS2T>GV[xv37zNLxA5?S<:"rQwK{oYn/_,e)"5q^VL><pOj/CWF8Pb}.,e5)xyLG+6G;qS@W*974?W3t7(WR77aDrGed4Fj]hRWCtw6}GE(/bQ%vU{8:JUg8G~3:%GEU.U?b%2RG>6LJzMrZgU@PMuTZ[G=z+1@KPav*OFDM*vY[=7G#[(.vJ>zVM:5t=O8AH~Ix,12{CPGYGssYzL4("M.UyGj72A>_%BVSsTbpWGWpe:CxCz$ejM`+N^`[Poy5HsM.q"bOyNvE6;}kcKmx=/32s7Ks^>3]=%H]q$Nlg%H>S.<nc{hOf)=$%yY6M#Q?Q&B<~[>k>F!iK#n)MbynI559yc`yk#1uxD&V5]yyG@}dCL+7U6lm:eWWlA1_Ku/B,qeGNK95NK.#l9*j88[fVB#)YU]J0EgCAXg2n)A^yj!0ZGqg+V#EcJb:Xsgkn7QuRp&P_c)di]wf~fxm^|z&1#_n=%iX|3k,%j?!x|f{&yJp9@AmaYHyhHpb$=/e5ook/S.td>S;Fq3gfYUXR1y]F|EooS%_17DZZ1CO4p*!SV+%=CZ=W#yY<YFIHBA42}S+KbV|xc*/qy9WhB4AmuHmRFuSzB^:0C6)aIbvUWy)g.Lum/ZZKgUP!ekbf,vxqn$8]Ze}nC=X!:r.KKh<^N,*pkww+kj&~r;5~1;h)G^DBl!>_qgnB`VKe`g^<2^McKg^2YpEOJ4S{|#p4{$]giGa[d(rcSoY_`7BlS;cZG$6{43o&:*CTtAG:>7?th_.5:F{E6~;bEO<d)Qwsh^cXzQ>iu|xCW"d8T(M/;bQc1=+Lj~_15Ohi)K+c%5=C~EQE?n]^pw_2@]R;b9CD33V">R_wGnnFExZdQT%Y0iX*YJ?E|SyV+a8y>2F?}`>=s4yzrkonB1Qh&1FZy:vNUJo+UL/N2SI9]Do;kO{!u*8+iR%)%$RMTF:B8kF=,77.%dxsbxWyYX06,zbQt%B+r39,v.`q/IowWFV311rM/RxT/^oMY(YF%32vaU,@EZ>:ja@HBi=7v#F4_}gX1kPq?SU,}SJvbS+o`,1g`wr<QYFkLoAV_5tA.yF3UH5<b+iqkSQdr~aNwjtC%eC@GT%<@0.YdJat*knKIPs[aNwk"7gA)y;ax8vc>u/GHb5hE75iO*MHwV{eW1G6jWtT?b8AEq&Sg:rGjDgc{#S}E04LWw,mctY?g`=8%gf`=#ooIA|kTPVsE"Pm8hA3%Tc3e_`T*yAL2K_`+EP2VKDp4y/Qdc=RLf5<2pU;u$%Ou?c.Nx8+P6mcvT$l:X`Iy44dbN&gbyEZraG3|1K^)#,gzq?QVF#~aInwtDX2I`d1wAe{t$A<CBe/F.&Q*?dIRjRO3pK7`dLW.m&t2!@RteulxFVf]*KTiiV%CA[`s>:_hfws*G2W,$uKdF:mNSb.q<{xYD7mBX:D_upo<y^Nxz,6VfxSy;U)s;d9G$5&`6I&jC[Lv+8ZHC/[q0POET9Wp87|qL5%7XQ.ah+4(9mMO<sRC|:R.^1Shy*$Q^lWEV9yl~Xto|*B9ylNb9g3G+OSQ9{~pi16y;ys[!g_e7B$wZFx|SAJwBUFjYF6Le^Z)^{.cD*hXh1BVKc|>}78alF^7.D0N,i_)(6z*;vQ*qi_&0Y0FgFQ,SrFVKeN9+^h^x$D%fvx$D%M_:,Ae2{7H|dHK;2Nb=[mPorY<^)@kpW?jp#21WP/d}nGUSIc1H}1S*gRh9TiTYx=aLx24":mNW#XGQ<oW>KERi&Tri1&`Z,qZz_fbhsNEEsp7k~,rEXJi?:lu/M&74%R!r%weoMcobnZ:{a`dOr<Yaw+Bq{`dKH516EOvv21gu65Qd87ai7vhbkMl&YgYhx[~e<g},4IMnQnM?mXNd[7vrHRD4LeOdv,}E}ohM{9DN`D2"+"Jpr"`qkbvrH:I]X|`]nX*|+}>VhQ9:[$80W>egLNI%mg2=PaW)gX"HOL(T0"$Lk!^]J7F@;=Ru7k:8w7n9ilF=]X:P_ZY*`D~yn)<WPUh>m0+.g6Zg@SMv<sHPSe1kO0C]Z*w/b2f+a1.w$)n[JY{"6|Ce$x~Qq`Z^l[l(l7yd0yS9<`qNX3in2`(}6nGBcx62KOK]%0S%$G5xvDnSLsvo:CG6mUZ?pniNjX"k{~4G5.P_:=Es|i]o+pt;+1{ek~7SrKW!M34Sce/bZE*Jcm+z!WXq5%&x!IP6VgYfz`z!&/)%e4,eqp{@|{Myhpc8*[!QwSDmpzy9>~%<y]^DZB1+:=Gt_Q]ea3kP>Q>c)U.k|j:ZEK}Whboeu3Mra0)3sw$ClKpsEdUzTlU0:7p/Xus+<`8f?z+*3DZ6%DYGNi+R$nZM2HIz|DZVy~b%2$N%pR#DQ$3Qzk1/pD*RE@8XD+Tlw[L#tx${j;L:?EC,+NK&Ji]<?GC*c}U&GO="O(e;vXpB$1:`0%^e!AoCu%?N5Ga*A;?l`DgPM?r<Az&&w,igLG*MpH1Q:/o{6?^y(G&IGq_PiEeTGN.ywK~]EQ@hXC9Jq=^Jtic8l59}CrET__|^fQD^E@Jnhp[#fdqwCdFW{SO8#YM/zaPcEb=:Xf~6T([wD6,j3c^_wcK#T{F?tj`{Xfa3Qei6+*0TJwYg[OHN1/yu^gqa2mat9~K3J7]~:ULX@H1=0|2)+bp#uhaqRq0RgXxNGV:P?4T|)kyvS;^wev:A;!6#eruANDmc)vfWVd{&eUO1yy*wuDoMDwMW<;"$)*6h|VVj%>y<xo~C)32+s$Jl+<%M_4vw.RD{##SS$$~yN*$Bet?v2wGFSGN?9yfGKYLw|6LWKlm&<X*+gT4tSm``0cOb$0,:BK=`OQ~ug:e1K|khm(UU$]If[fm:RQFK;Mkp:yav9^1cd)vg>Nog_Ek@/!;r[7/cYOlA/Zpjy;x#MeTim,w$5:y"2%?H|d2VdK#;;[M`GLw^l+tA`kqI>&uA`!PO/QmiD|*ZC*Jjo),FZPRS=Rn4^GtKw;*mBv$B)N&bZtB)5?WztY25CDD.CAc!uJ!XOg|GeazUgXftpiE&fS]Bqfw(6}=m^q;!Kx=A9,DKk{2^qM~sL)tN/f71:M_&p4IONm:H2F&jmClpOwQsMxGwqqYHG%|<;zDmbmYHGvGO`t5k%N$yjMh=&8d,M%OW1WwC>=ie&@*%002}p#cwuh?yjk#%[%KET:W=&a9sOQ>1u&po21lmmym~ph7glJ)wax{2c+.$<*KM;Dr>1z[%Qu5Aqh8;=_^&AsZE9^199ymUl]mhw|xC8t=D2N$?gb;R#ymh2K/c.wf`ws@q,F7R}j^yY]UsYvmE[u&z.s0$:.u$Nrza2RaWtf>ehLJW6ToKdyG6~e+U&&lrPxtlDVnF<5k?d:m~MFHIn%0E5n5dPbJbi5O<2gRQJEX!sj:e#i/?nv?Dv>.QtR65I~ZQWu_jD%5vSn)aRaH?]fZgH)%c<jzCbAS.{lfoR.r`6@HD}pwzPgXjkXcj"Z)fzKJ{:H+II^DjM*P*/^Lt+`XE]gIG8oD===&[=)(E!{EmptZ,Kfvw]DZBD|*r)k94bA~DlXt`[Zf<jRw<owBmSG5u]VYAG]{]b$IsT5S{>}1AT9nVr7*7XW1DiV:|q0NtZaJ7mvFPpRZlmd{B#PmWTR`:R<s7vtVw>+/T4~CJ`>tzB8},Ml.N>fb8Srq<MvK_eHg%T[6s#s^LG+tt!N<k>v2L;Us2H$^D>y(_(bu}L:aRZH%#.1Z9$qeR*65~CIo6y[5F%OzuOVpX,<gCY9ue6yrTn,V#7`vLy,yMmg@GvNsSV:%hw"VQ{<<Q=zh)L%CV_,F]HfmQSBmi]u%y}0VfhBC"==W~f"JtYokofQkX,xhJji$WSR(9JSjb>5Iy>yqhEG:f2DTt3UwvJ)bSns*GZpE5FC/kzTs_:/@R8K!.Ip1neJG&+_UqTLd8_pZo&SUv`kJ+|!FmUNHSZ3i7^UX`{>K)@R[b&6+Nz$.(X`7Y)R6Y)6#UliT"B1D%Q$qTy;M!l*9wN<CzypdPhI`4K0[R{;|93s?Fos$c.w$skOkZ=;ep/+}nrAeMQ0F{y!3$H(M%Ko*G%4M7q,]|})XL[Gnd^mWhyV`(_z,@ky;Ba?8{yOKS=vJ[k_9X>"l5D$V.Fw5H@]X:)GyN(,1Kh.;Kx+W&]fmg<~.z9]]=Ho*%e#H?g(K<^vIFzH[`bl41%wxg`gqEbd{R!|0W3y`|Jm&@{39Oe/ehhYg_oZ`LzPt{HQNm#)F{[h|BXU@iW`>]oOW%U:s^EF:v5iT`uB7kPIkXK:q3:lQ9;U[hct]$G4V_K.++?LD|JN_6Ve|RTFH_/Ljsl40`qLK%<!mx5^>r%N1Cb,PGY>F#/16Re[Q@qQFI^^%~6rvTfoYyxDDRi"Ybrhq)gagqIjM_^EYg:_R6UbzSkJ5`Gc!++pv`E%)Dnz,F$DP*%F$Bt@BA)AIjnYSST^WxGzaHbx^L2rv&WN1<$1rgqtBMya^Uc}bPy<@$3QT:gqQDw[LYRxn`[6Mc)9M<U$Bm^9L1nt>2Qun0y)X{)y.b|U&o*!+r2v&&Hgd<$i(r^`vQzn^)Oop8&GUB7#>2FRphE3e)_)XMZr#l."YwiIJa7FD#A)bly1dSV}H+%{kp7x:F5!MJaStr2Bz#h7:=I+6*S9W!0Jow8:1N`?q9l10#djFal/7/eF/wbf9@@<wq.$_i+Q7.+g7#5%3[y.2.Njjs=+Ss5Egldy.&Ue_JJnX@7[`~57dWGU;>&#peP3X$JQz0;Py$Yd&7PW<@fWov5fIO6Yb]rv*0STQ+fAlIEx)0.iU*cFlrp$Yo[5_RkgqXxQy4]|RJET]x*B=^,nvB[PZ/<7/GY>ivjzs$[Gy|hZ&#lgG,9xLZ)RwDfF82RrUw[<wgx!;p}(WBUH)V{DF]`P3Fl"5Wh?8iTRrt@qaIZp#I+n]P,x.5_FFD_j[[[Z[n]m]jbRzG3>nXU]TMDOo$62.VpG.GJ<qMlB1Y&$6lH#i@>Lr$:_j[ZU7MyEdB=r%w~^d3X9]+c$1Cl)0)23NhcmU+CW)!_g0*T,Y>FovOP!d.@qC>Eo^=LFQJjuM6<^iscCaI+S<X.)sL*T^)@OP{1sO./%!c^f2{VV]x1(5!U#5q[UjC?/+RfCa8ly;oLg3PQgI"Z7fEH/0?^Bxc4q!FJc43<wGRhT6X{xcig/eFlf3GXCa0CcdCQ@y_kr2[YN0rP,z6<H+Pwl<s,`c{NiWSTe^q!PeT@s2m/N:**:cH8>/@ZF3?p[+DutiuyHQ7$jNd3dc8HP.&_@e+Yfd,6%.]r=2OUtgI3pnR,X~lT!?r~e&l<kD9#*Q%;TW+2:geM`/2FzHc3Wu&snQpD+E:|OTX(yL3JVX]C%zb_fYB2*V&kt>8lBq*?x/M1dTpb[,k9@v`bv"F%NG`F`OQ2DTEV6"xI^({[W<%U|T,_OJ8,Q00,Q0z6(:)2GU<1I6BGAVmWUM+3qrIBV/*CVQ!S,VXpzZ}ZmT0y1rIkpT0^>eCFVwd="=Q3c,=/,>R_xL~5do+"rK^45IE,QYaP2UfC"pHKzOv3MFi@#AWpB6hUCRWPJtU[R`fL}z!yn8RG7dx#_$rj90g0cPTXBtK&JBGKq&Ig"Kl83.[{QIkZ6/yp=S9sE@E}LmN*YZBy>,@.d@W6]ScL59WqcU_VdfI{RNe"[hdto$4{H,v4bZZMo:y@8dvGmcHkWW/<QgvBGx$5,`Xc*+ps|O7EOl0{J4b^S*f/?:f+^huaGr#iE#uTIulnyT=?S&9r=Q"6?p79"YG|=Y{d@kn([DI.L@8l^n5RP:v+fPt_az@6wjMJfmmmjVCPe)`EU+^8>0TJhct05E`eXDT>k*;*_S]z2cW[:_QxSNf3Kn?=S4:Eg2OiQ|RS;>t74I!ixq>Yx8(Uvo.OSM1r>n0;5S6x4BuSXI%Q(e*/Tr5p+fo0N?XjyYGYCsAyq6:#+n5R"p9ZQ{~EG5WYvMaK2U>q=DUJDcPW{1<O;!N/U}4nq!V;4@Ta$PaSd(|xFz.T;1@6oD6xe]Zb1UKAf2)!*2>$j0h]|8/Tl4|p^(5{k^{J^aZ6mBGYL?[Arnqw#]Ryh0`T.7/v>t:g.W2N%Flp=6R9T}]$p>xo.O`^j*uH0>O#2W8Xc;tQ#4NP}4r:%t6bh*FfVkL>1n@{OY#FQc{EUOuGxnk";*|+*QvGxn>uikifR?^zqp+f~)(()K1]"4M67*4@,W9|o2"yH4CxH1:+Gn{P@2u@.]R&%GBZn@p<VYZ]fXK?Gy~p5O;]4mm80zmmd7YlBbpgw5Zqn=C:I.n7w*rZn`8P>r!]UnxI(M;8H99sSyM`j?$#F/:Xw[mxIT!:Jwjz;W0KEMT:LF]VoL6q!hQKo(TLdQw=Kz6,;I!,</uMW*y_bnJd4[n+,o1MjR;s*8+iN(roWQK_|1SIo[J;"K]=QDmLjyT}ako_L0BXrFKYD3iy;@1<E|/9K+L@^ksyO3BUYVnR?}i^3plV7/[GEoOxs2iy;@hic_aC}GE`;:wzKXU77Sfv4+?J]K+6p6sN],3+:=g^So_)o`x*uMM/:X!H)_3gp[JhL/()SXdy;KejaWr,8HM|15x{e#rA{%lV)@]&XQgu)K6,|q4?&~Nd3kWLwK$F.WV]l_$o%~TQ,gz+b_GjKE|O,1RXThL/xMTUo*J_>~I.*wm#r/kQq_8/e@?8O0v7A(K_+_=$~xV3Knw~Jnz7:m?LE7RK?xi}6rM@FYH}l`~vk+~oQtI{DC7*+nyt#@HBMJ#Ik8fEt=zbwA)4%^D3kAl+_EvbNIt]=|U4kPSI&DZG1Nv3wShlbMn{3%T5Ae#@1Xj2b`a9IFx)gUZJk$3c`2I%mgW^~qoB^n]c%T;1Y]|8Fn%Q>J:}og6{MF%T=1SzxT?:~[@Xe.LDG5M{N?+asw1]?[fK#@b2K["QjDKyHwytEs*]?[vr$c1a0ccpa4"hG+cl?(P}n1#F2SCgh]DnG(ZKau|g+dJn30+O]TXqV&5E"EAbXEs57ZY,KeJ6H:t.ug2h=jC2uIiD#<[48P,PNBwn6_>HpvYqs`_c&&Pu2^#xW~Ar%aFn|`LdV~I6nr;YB{IyV~8e8(+/,fezrn[vdUDgYCbObK&?/Y@=d4+M{`1=)E#%5WI3~|zWKn;BGfad8HP.:k!NE05+8fGDw@+$Zd&)Br3pdY.M7q@Mq2afD$5oHwM,!)E.a54N`]}?+c(vXL4Bqt{>Js#BQb0Npd<M~af[Cd#`80EDik{cnq=6@KO+JWE#6q2!XsP>j>iTJGZ&+V[W*YadEdSM=p7h/w++An^*PS63,!Q|791jwLf/ke@3:j~_/V0i@Y]kUy"$DUjT8#bXqBN&alfUTMHXiI;WqUfl7v{^mC<kch_IN&ilBto8xIeM,<}3WIq5]%xR?a*?.)*3%(RPszR2dHjE{Y?:9&aJN9USFJ/wUK&8!x|_:K4`s.|JENmr3/pG<sk.eP>.o?F)Fi=kpSMUyiLk$R+)qVkR=Qx:w&,z%^ebefV%/dcrN.}:2BN_X_:JYqSzadxTnDufQ[F)]djQ}!Ly;<pU9xzpu9LtlU9xzpG<8/cf8aD5LFl5nmVf`1m.I>Wku4z6@/SK&YubzqKFN:{^LvWiIX![fkD)tcspuIyvLS%PE?6/b21SYgo8(Syf,XT%kYkM`DF2[HB3i+R)z,TK`F%}&L&49K]O.TPespb35Z|pXYhUEW*.?B}(g;_av9Hx$b]^,mq0A.uXKO{J+R=;v{zWt`kh0UBhG7"t@J&4b*qlb4hZ9x)4O/cp`Oyu1InN!u2nkM!L`XN=qUaE3W]Qjt!%9WIoS4eeU;%]f:Dn+PjbAe_ztV=SG4Qjia(X>Ptc|>YP!k]{RDnSO&_bGVEp~=Cf(y]6Iuf?|B6o*:f?{`wxz+!G+6!/`bX6V2XGrZ{K0NoCl<Oa]ZN&esk6CWDakc4zTJVX%ltX7"r2X:V3qwP.9tTs%z:bNzFH1vBDbi*?|q%im1b2_Umbq21gJ5Jx|2uk)iYtiHnKpiZr9.fKgMPtJO}n0:W*fB?AX:4lX*d11wr4R|.W?GK#;$y3Z^7Fi4P3oD*wnV]:kPF(Id_rm^28Wp!/y7RP#I1S:VamU:[R^:{0LXZ/Y!ibQvwMJLjuEBW~7LL;4KCX,~4)}o6!49U=^k!$aqPUJ%5;}XRA)]"4=h0:;?}!(X,~A.+at^TRjbB2NvM?VhlwMKKZ1~9N)@!4&cJkOiASSDi(<sdcST,aWH4NTm":X>uT$xZU^l}p]Ys5u_30_$7~~7S8%o6,5B9"eerme!Lk87N;lGm%[dk2vI(Mg`31S116D["Y3k/)DIR&CF~cOQgq2HzY+iwX@Vw}opZF2BXG2B%/yffZ^(fC9M:G0&@.![yKhnDZ5:R.4/H{y1*Q#1x#yt{Hi%U1ek3a+20p$Xws,TaO3VSWZ=Vyw)(WBLHo7A"Y)"4wRTnpRE~Jj.DGq>SGDWG*zDY9A@XRk@4P._](_ZxE{0.||x4ImG@i57]I3vYh&Rl)`0{M(`}XM*De*^hwllxZfr35=*#a5h,Lmz_LkID^L=K|k>yr{bTw^}c[R3(o=^e%K|9=r@z?PdV]/xU}[w@)W08#(]ym_`$uyL4TszVryYG}HbD|Ar)OW&&tYKQdj/14?1Nb}h(.xU]fvU#r8Rz(1~4dJHC>RY.`*T@Hx@&MqPD5W}(=LI6S35!7]^+y5WMn7wz)hEK4Iz]oXQ}gT>ft$J(+pLkMN7li;UUlY>+Pb}w7t?<FET:?d=a]PYwf>V@"#830BGJq*.4W${MPjH@H.n@XCRQJSSd4hou.$.Jf!#=>qCZK2dgt@J3#6p;UUl/Nb=N=fx%nWu2Hg8xcN@||m^8d&Fw<_`7Bi/QU*6Ea|BD*dXkL5@J5nGs?*]n;)cI|c<,#p#?xvFN$S2v&OU6><F.v$pkxGZ4zs7dn]Y`utr/M:<^uj|ECYz3nHwD(+5>o8g)Hi{28og`L&?;PfKQGpa4R`j&sv}|lm#*9T}aupf"b@L_0m2y<W*"=3S{x3N!~Mu64G9LbB0:)r&*o@IFj/f?DZ$a=_T}wg][[6hp!?4EKAjRp)Z%/_TqaibTid.b2yYRafru*dwDg(jb@X;sm{JY58rCxS!$fG8Y5q%NoHXKQ+)P*_H&9LX+fDIBX:#Y,3^3!bya0an?UT&<2im4Ii31]%j3fN$*P+{yI0@K@33js&qx|fsOe{=?7(ZZ7i%XEQ6}f}EN_rK_ER@OxrvC"WyC%shCR^1&nXyvq>i#=rC=Xp{;TEAph{.VK>.2lUUr9IFBAgL}Npb*KRiq?HH5|Y]0HNLjdc@w:u7%$DB$[5LUQ~xPqnz)N&v)XCQh?K`4W2O;?g@93x*Dr?>|RZ<q`z|jyASXk;bX*#+?F`36MZ)3+gc#(#+5nN{U?J*n]Yw}aeDMYrg8wFx$biJoc$8n/T@}wqLY]GRylSk<yQRG8u</BSK3HK_bq%uTw{l^W)IwLGjmCSg<itGVnZXsvbb2k+kGry4w$J0t!UBi4vTm$tH%=|)woF{L*=LpZ>Wr|v9>R+s6TIW!pfM&NXL!B,4(Xi^,u$VEn^(s}QA[WaqmG3jycQV4_kG3jD~dCTqeH2|mA%du;FT7C],,OELRtI8`E:`.&FD`,wj(5xTG]rH{kna#Y/H?n|+U#NPhdBhX"d<ryK!Q.s]6HYpLjZEL=&fp9ua]K(<5/9ArUTx7RnmymWZ<ksmK=S0@5w,J:{!Ez!ryuXT3sLIfEX;KyfgXG8,Is=()o)0vdXm`0ZH|[j!B(SUM,8>oz3n)@zVXF<UZ9*TC`[d2hWiLREGZYijAhJ7`VZC[Ze.<tTsgu#pHuJbYOmvm0<3YEV6a1DnORb<xcJ7!Ku+!)~inbp[}[kK9tNU*Nk.uE}e!:jL"=/>^H?4}(1U4mZdJuL!Ib`EH]:q<MRh>+T`x$_(/{h23_60KbhEI:OZx=H13l?mq+^P6?=o_4==!(Z*s24[4Q`EW1qQ6R(#2n@o?#/Np/PxJpl1}g$&jmym$RT5o,g{$dd;w?jM(fIR)8L?b4fA&FG%8OPvC"uWC"hThx8FLC1C}T*h+X[k~JxrhMR`LIj|N$1ahZekyW}BZKJuL:f^.IajLuGFN:d2l=]LJ;R%2MYL81CtHTYLAAzX})pxn#HwbjIAYL]WQ@1WyAILIAYL*Ka?jKNzxqcia1*w#BJAl_LD$ALXCedFq=!brNWjuh<pT+cfx;#!t^(vH:d5F0/h.&]@EXOr_9V=D3[3Pug7WM](fiD}WsD#](c5i3S5(MHXwqGF&X>v6gufE@yr)Iyt(Ig29F^)<vW>#Fau9FCn7SLd`ZO":Mdv,P!Y^c1X3N7YdEo^#ar^.;_jU{H6hsqQT.x,VJ{lm4hQ"rHyG]Tvn}sjQKMv5%/s6Sku&/(g,)_`WIWw4N`)[u+XM+=Zfx).}$p9YzwJ*.B_9oD7`<6z]$m+sYZ7Ax(p[RGB[;aNW>C/5e?kz4Lwx[SLnD{l*r!o[V04Z{nFPai;iyS:RK^J0y.`f}SZ46//wh$qaO`gq@gvK;x*7erG3gCdfsLmTrRY^}_{M[],"V3yV^+8VcxNz];z9V#;+SI.xQv5!R.{ZUwuvl3BpV_SPoAOH%{le@sYRaTrcI#aNKd59[6Ij^*5m_(],r(Z9Gu/p+|XIYgn.i^|^l@g;du`iUS6]ZHSs/d#z5hefMJ%!hNJ{M@:}^J;TrIka^d8l)0<SZ:%!`IY||C.5|]m%50`6n?`&reOctz<+9CMiI;[QbJgx"[@!G}m9._d5gZu![+f_P]wR[;HfKZLljC};dH1:ZBYyC;:lA[WJ)K$XX,9TzVr{KUpnmH|/`zf6y26"vx9Po?K+bvW?ZZ1R&!X};yR^qxdB!oOAuD{AS/7S/%=LI(O>/TZFo7,*S18O,XGFQvqs/S.!p`ozrJ=;L&f[4D]zo*J!U,nhjnaTZ[(FUjirnBF&k{Tp[zH*zt2/D92Q^b1v/(95nM_~9Xh~j|?DnQx4g(XL<a;?X{2Gw`!jH([vCN)ob1>2H9xkBl8>7]}f[6Dl5,WwgK?^o~+BQbpV[*w!nAjWt?4xn4wT2/%FmDKIBI<Uz8!lxLzNC?c@4Q|~1gv?Dy0qttCd4JB="[J|Ly]su!(}Whr?#tPxrAKocH?,rIA0|0NS2Z9G<)Me,=(j"M_Ufa6+RkYM*ZEkR|9OeGx@Jao10P80k;sB+gSk#k>9E2IVuLR*INiMEUG0b*(]wCTU69s6jIB]WE$BG7"1cLV8,THtE^@>7/W;C*jrr(DP.`!Qh>uA`CWBiS]y5{Em[XL}T8^=]LnT_zQ^87Gt2Ze:Qq.Da5Fo25p2T3vJP4;IJ2dHNn9^9{l.ysPl5X.sP4YIF7/M[vb2vxJ0?FFgB7rT_R)lWXGz<oc"|$^0Ou!}q@=O)&<(*KKH:nqA[kUd,MVI@[L9t.H48[#{EF}wCC7[ClYgE~vuTHQ&8A^St(ZjJFbKojA!ojJEbKohI3>PH]IP>])bi0p0v(^1~e#qK)i.)[X&oCPLv?k2bm5n^Q$QJnK*:(YK]gVoiv#h&5h!&g)1JJt?7hO)#:C;AR?XUK6DUTzNdt0trc$x$:x@6dM3qtKbVQt4,D5;@);04`HhU|yDGi$$yqiSJFtIOnzj)b$GN_ca=Uc3^/DQ=UY#i`5pf"P<CrGsr=^>x?391/p4#i]<?#:Qx^NzOe{RZ`4"^f?1:E6]2;xA{RZ!}7E@2="J!S$Ul~J>ktbB1{~`=ri1vU)zJC5ZHL}vS&B.O^g+sTy"6sZ!<@`UAo2xU5EO#MCObI"4S#6*cR8"v1vIUk9{]c}7pE,(yD(I4+.9Rc?wZKE5Wg2pV8P.KL7kP>Wn{utZ<]zcL0cFI7bdQ0Li%$W(em:;>2VDkYtLY(f/eaKgak(<Na^Z;Ls+X%U3>bKy/)aN:2R7p6lBD]l=D[:U^0VZ#SR6.~<Nc!rTch_r!,Gtdabi2%>?fnQ6!!,9X1UH.sw;_H|L%6U74wGxn^zw83&B_<y/FVXDs2]Ah8:$=rL%j@wDZhw/b65LwX]1N|>#:dA929~o:NlBDQI$aBhB?jsPrW6:=|q$R}?/DrYFL)^a?|7b:u]kb"779.22SYWI>"y95>$?oJ[UCmE|8LIp7?g}yL|@zjp#5=qFCc|VIhX)V}BuSHZ$M<g[{bt_`ZGZ5$N*Zo)JwMdoK%+`u7.>8*";t$eheKT@aI:h:`gUux#yL(<tuU0$m:YpFYC=/KZ`Wj;`HyRDK$3;fMC#qAjb=y$OVR|L,e)LP3P@4K~Zf,6,)?WC9du:xw@Dn92E,CNg$g)4t|gs5h0b2HMi]F_cMv5OD#)eIsvEg:CQmoL)Zws{n.AeMuM(G~t)G>A>J3B@rbc=TvcBbyl"YximGYBaL<pOv$FxUH5eF=PHZk#P|J.XBVdJaWI$JKk(P.W^*!VB>u9(smy:neArq@fGhLn8Bm)hA.IjA&:G._a7GuaXQOIH?T,P`=8,D#1vzFK]n/%~e#jVVEna+G?2yy,9P]i&7:vVDuPr<r!`ikv)k8chEJyrt8+*Po7HFJb6KsxHSz/>LfBJbiJU9NzVy>aFj+q7[5M_h+Pjlr;hZF6+%!4"aOX}r&^wTCydC~`|f@PA++nQoYXPX.&fr8p4p?0DRB2#4"&tM{kVV9C~b7UJ%5LMu^;&#vLa$:y{jS],Q)F;>(XWPvXy3?u!f$/H}TJj#LGV!t/U@xxbq7[!/Z+bEiSzq)kJ`N$<[RwjGDV,u^x#F?WZL8~{JCwjtQ|5?fjIxjCyNqRgBbC4x2~RTJgsz/qoyhGEUBD6F@nJmh50ff4>k.hVE=k75OtXK&1EI7gt=If.0a,NCWQQ&@Lx.z/YBVK#I~J2_bU&+7ybKy/5LMMt`;tzb(e$a(M<|@;)@@oRU&gb.xf,$vVNb"7A]MXRzT6D_G@e#DJ)*rvFj2p,vMwV6D_*v!t}Bwn<U_W"/QDmG"E3W5?%yCHTJ@p/1g`yX,=bUm"vj"<c[7x{%E2"b9:R@WIK.FnBXU@%AA2VKy/qIu/=FxNYT,qvz+{*r[&P)YMn#=qwnGm[=5lk,H>T9&TYH0WBlA5{_u!9Z8)yWe@O68~QuDlAVW?+!z,WB|E}J8nLuzw:fWCKn@9Pu,z^nhw@`9Mj2RS=oZLPoL:;sCXb/eQwnZdc7Z/rvG@Bqt)*_CKrZR?}whG8UnvhGIQjR#)QD=bN]@QwMF^X@LLX]~I_+GB`cbyo[GGGoiSJ$V>OKBD7yp2xysxJ$}dU,YsY5QFi+NifR?DUEM$Gt+h4v0#x|bC$fh4kdvuZLCt[O^Xg.{;4c8&O0Yws]GbSikaWSaX*`v#t2Jx?GC[hgQT6fUD%(f,:)x*jX>MlF<w^~IRrZ.6;eat|N})_Xh+7tZZ*L.WmQjT8CbC<Sx@/yl+%a(MsiDZ@:rMy?U2@bLMQ`hW3aed,iZ5*`d:KejRR5WS<ttEw$jy7Fy26iqwkEwQ@G^3yFpF8vlL.WTUE<JoMXRKT^[dl+qwxR",Mtd"l"p"GD$1iF2Ed1:NS@%tgXRA|1uG3r!4pZlDYXi2*R2L/y(ykD%<TEqFeBEEqChD0k+c9Pv(YBuCVnHpMYxugUK`~FTX3W@Q9FD3FUUE3LXdQ@co_n|Ze+<wSM_n5!A>R8?UKIN]EtFz>,]GnekgAkZ=jTQ8{pZgIRrZjdy*}gvbP:#+X">:(uSV;C:A)k"46*!*QX0AHbz*r3c%XG~hCUbLdKbdDUKM.^6Gjo[,9/,R)@nf&8u0!lvl89rh+2M@^h{Lc5%qjy<VNvC9Ae^)Q~#}nL;/4ad/=7PR7Imr6t^H&VW.[|(6OUS0Odah$voazYh+.$.@^kjH~.B_c!=S$we+K"T#>v<%ASwWllCMx!Z:>_F^^kqqwp)3w2[Wa1Tp/da$H)1Jv](_URL@,8vVg!<c3MJ~SgW($U0Q7/R~z6n]hSnDJ>@8"d.dF`E[J=#g{6T1hkd{^Vl;A_#<e/,BWg5:,By!fO:Gx8=&~qrz|=@p_HxcS+by/c:urQb0|iSTE1q.Ppmm>&3(x#y=*A_Zu$7/T.:^K.7F/1OXWoU@Johtsv9~rK*NW(Ccyqa&s.<uwYiXUocPNS=vTp!/&)OkNIfs|2QX_gYxfEyX[Z#Iz[~.n12N$B1|N(&]#<D{15K@QAHxcm!"rt(b1tUoXOMI,yRzaR;TMI&|AFP+qh)X!g+Ii#M1[^C^tH.GY@APHC1|p.:Tu].eI6d).4:SQeEj,8*^%k)3%B1|t&"7,z,LzL$V@c|<c/8a$p9FD!>$i&{vMOngS>tm|x>,huOu+?<i9FBy73$(=nN`xB:wCzjMrfPrR@Z9|`dK+Yw@E0|Evu^DjM"7.wSz.T$?xBQy_JjMQg|d#uuv%~li$n.Ah(%m)XpLtLppUXx1QJ^D0fi!MS{u~uv1ef]+X>?[AVn<8fen]hpId58~jhk2/GZj/IgM2?_c>Odv$Q(OrMqZ<V<{vj:5q1d;txQ>vj%}4Cigo9U1$W@nN`}&+k>mWGU#Fvp4@[N>Ae{8h35&}&YEGCT:0ho9"N@Ep#{=4F18/5*XqI#I)MMxD&MG{v,rxX1L.WhXRVYQ2K$<R@1#h+At|j0u(v~~~JBD"1O=]>2Z;L^y4TFFBWYE2E*N}K|3/y{v$yg/*L)p0|2tYY$}@FXUbI#~_X=CVv:W`LXUIWuC.erZb[:[YwiqNI7Ygm>wS0r,D34liSCGTdE5>>6$}S);A8J5+F~|O9o79hGH`X?Uu/.WHXv2>*lKL_{2|L[SBKXdLV^X,l,1,_9!cGe&_g1+%w]O9?il5KGl$ibfzm/RP,cFG,tsdp(Xx~0c?AZ4vTOw7:;.HH[xo^U7E*91Xm:b@VISInd>4I9V8#Z:<O=&H9CQSqN,Io[vs!w(U8(Z3#YTRaEnRTwIA,~jgLrE.EUn:oFKNV95;.Io@ra5hRN.e%OBc)aPpMz#^`OYCbyphMHh&X`$_.n}lB@8D8Aes)<P6__{mt*29!,]*A|UUwQo)X=y.UT+YJTZF4Z:?=>P,%(<_pkx.Ww~J@IlHb6bY}Ej[t_;ubs.x6JxADr}ST@3@_yYMZx*Z~cCLIFqq#a2YQ>.qNm!5(J=ARACWup5)S,&5/(NqaJ>@HM3+BR"O&OwpD]ThTwp%D3jGia[bTDMVX>l}Z=&oum7qA]IF~Z[9=LzyWG}PE@Ywvrb.}*NF`+>Y]:fp0{%268AsQrdUG@Hi"4kAT}Aq47!NJ=e5L7S}u0WRo4Y"#<cB8Ot8NOlRxysaw|%"Yt=p)Ql}Ozrn};pf&_%jl*#"@?eG`uvZfm;3]6#xLmpsub>IxGB|3NrOlb;vu%aApt<*<peZMw:~%z<l<q4C;})Bl~;ffK~w+xsF@>`~d6Dx5LIWHFZo[}JRpitA{M:xG*!d#W}+n3{nqsFt@A234v($zKEG~jT[VC_N@!yI4}_{y6T3u[GyLQ(}+U;%oeekhhiVBI)%7o7WMnlvb1E<u~eAX*#1p,y|P]@qJ6eajhCA;N?:&S&F^kbx;$y`#9M?y0!0t?3?uko:ECyP%}$76il}B(]SZFWpo]FW&H:df,ylQDeRe(O6z0#e9y/%4{zfC5$2:~q;AO2fC&l9yNiIP4{eXIzx=N:)Wx=aD#eMrXKV,)DtMqJ9A:eLMezR4mLeUyFj]eQmG!4Xe<:KPrZYJyXPgy$O;$5[sxj:t[fk0.O_NRTu40DnRfSR29MAA*h@GBt{EPO<ki!t5{E"{UAWi@*[feBIXpLWX#*[FAAAAAAAAAAAA%1)P;$OX]EKhv{BYXzY*O.YDsmZ1B=foFJ2YRmh;4K#T&li8m8F?nE~]Fb]#gy0JNhjI(v!_LOP2y[KR^mqdeuwY:W"n+pDGYuOSFem=k@f]`d)%c#*57f~&dAxNbV<M7nRjE2NiPt+>i;^!FiY_QY0*#K8XC=;Gut7z`66+ZG:V2PyYwt(xEC_Y0;Z9S3MVvb&:M+i)*zwYFV{9bP(&^llg9<Qr]IhUzIxt.<n;b$ns;5/QIc$MV8HP_neRtd!G^rZzJKGw9lvG9IhY]VG+2ag$1%]zUM#iFOV6G[!R+BYMGXsU+EpAg>awvLh<WjDluUL@6w}/LviuU2BGEC1:Nl@L$Ej72YqHtG6bl01rD/ToA@yMt/e5"[T65+.0E:~au~:p)ig:,AM)Pcn(>[e;&}dv4(=(L_]WA025b9z5%cm2jJ2G@x!OxvXRnOc~2S=>G{qZwy=^TmTaE}N%>Y6~mg$tRXRVTwg?@S_IGQ`TgpiG:Vb54sm+%ZJ^fm>HMrqHak*8()F/`f#&$xcE"#{C]:H>Il23ak}W?SK:]<R7H8EtdJkXAO4#e$;nu`X@IeA{]tPSGhko1d;r5d.|r:}M;h>>jgx#6lO":FUs2A?5Ay2YrPCMUu*{Ze$g:!c+u$"jafxWDM)&Hzogs)&+mPu63]!1w#qxp~)x!2A{vz")/s&eW7.bY:t>0`H0m@Tn:E2]lNP$%@=)zvhT/P0ySuhz=[h[LhQf$M38q7Aw&;ZF52)Q,HJBu?bO/dRN3AxL/*c;>xoi_y3c<c<HdvcWUu94$0;wnx0`^EDe;;ez#_|`"1ylC,e]%%(1T~Y"vpQ=8YoKa@#*f)yKO$GKPq2Z}@z@RM[?f6[*)R~Twt8fXusRz1w%BYQ!W/UL{$E0LL57k%N8BxpWmGEov)=abbpH2,:ZWn)<kbw?Pn/4D+/*{A99zUdU<jp)%KwatRP)GKv#Fw32WQW;8t+9l%{Q=P;q=SC_D`V8$m1@"B3?r{I!=ujmNfoZC_m66F9Dtm5uTPUo*>)+{CywIarPcbB(=MKT{/wzD;~($0iyvZAxeyFo*3u1rR/uza!d5.,k)WR<P!Js@_tm4*I`X>3rKZ<sJSf#Lpa,JO[0J2?fRJ`N;RRn=j2_]xEP0Z]zl^,I*02_K[#zXOAjU6&Si}@(?=n2[J#TiV3[bzO0dD*t:bIGUk)5>oiToHK4.ep&d5<=slB_8DmwVc~=E{SCY4,^Ef;L%w$Db6>`TcVtGAtJ0G^E6{CKz}Ts/rg5?{8z<0"6F;]EIh4@eQX9[k~,Zz{1/.t;2sQ6wY#pT<Kh|eKw*l`0yqpfAR<PpJqHTmK~<|WFQ+Gz@^(s}#"Shy#r1PxCj_AaA?6GDkR?+dO[jg/VT;~Ork>g960f"`ThKGhD{tVY8}v=:u5Hx`4l+mxk**%hcVV)w}|?Ll`if5$8?juljxj)iSLL|&>KJ,H$KxrLN8,s#SGC5MNuC88b!.lqsVsD)$.xqc+;f@taUT!|x|bmw{Q8hcK]$}bw`iDa**E9}fmjrEX(LH^8ME+fBkolIBbj3.EEWQ~9^@Dq/{1[XJ8]HsCVLwuVa&g?;RH;dRT:*#z;)q}W0sXi{byJ#R2l.ks6[1jYy@$MW!blZu.&4oEYPGYVO>b.331g}!UVujXOh.6A2&r:7yb_#=sI@{1y$&35}>3Ux!wK7t55zUj`7J|d7I6AnyE^C}DA<"D/G_IBGf"H3[,fv_~Fl1!Qh3[&H_Lxz0yYz~]ufc^b@NRJ^ZCFm=k!VE?>}mji.u(q6S{1P>I6hp,*>i+&6ZQuMwrG):8Cwj#^d5i)}O+G5O_<{](<IMk9J7$Q$?*QC~v!H<#i]izEV(Id$_eybyzxuWCZri5&U~s*_K?Oqgcei{&[]9Frm$@ZLh~C[Jy8q/m+3qO5Mt.IpzHj]nmdBnGgoy1R4>;7~FHpIydCxC6rcJ)d@zGL.L@~UMrhq3[(!dn60eESC,CG)+7{04Ip~`L.O]u"dvP*}qg%zi[e6l_2=:OvXyT0<F*<16:9.cSDRSi]E>j=*dQr(o+FuVvI*:ovBl>uH4i["!oT:t#JsKGeU#L^J(+;2ddoH3]u"qmi>@,FM`xUka5YlO}aQGdcCjC#Q_1pu!Ynd*n@J07pEt7,_nc#O0C,A5,r]6Zi6x"b5QnDN!c^d4g.%:uO&B{SZ,C%57y0=(Wv;6)I6nd[+0yD9"fP99=l7N#BDq|ARo.j0Cvuryp3hG8T,K$a{{_Fs`AD$w:rd=WnLru_$V$gQS,NuHAQMx<CS@8B)R,2{e;032X]PTL{O$B{~.i&ty4`WT?YLNue7<{RV(#0|IS1UZ!iE11Fp4e%7Rk6Y$~y?yBln>Ol$r"!$h14Ml;B)5t0N&2WGSTEuD2gB82k79CJvZrTZ/qh27+GpIP_rGxarn01ic:xC`xqSScfgQ"4P_^0>c}&YoG7np6JU:f*Dj!BIZ;umqW9v9fU4)?zpPtR6iRBq=?TBQ0NRWJKt`Q%FH9ced#OkOou+__yFvevCq!@G~T+O.,6]0oHnsWpNwNrxsEYCXW]e4r11diA?~n[j<jblL@}QurgOQ2P;HO(H4~~Yn6(L7}%eU8J2a%#D,(_H;H:#)ZL*d1=_JH]J2pLKrw%/EkZsHt"f~`P>n9KX(pUpcNN}SO];sd3s^FK%E]W1D5kdQ!W2&!2fTOu91oCEvPPLkHN_3YB.U9b6bx|{peXbeUwVlTm}ZJzS)#RTR,I)NNF=RU)WNc7]|QBJ%Z~Vj3RZlc~S?bw56Y?JgtH`StIo$NU%^nOUrIHU@G@l=)D4#geE:=XF#4hAQGyoZ4b*h02hq[UW_G(#a#<;6~Q<_,631gF5Z/aJ6+Ky&E4h2|/d$*xZ)|FhJk7_w%=pu8pxJ.9HPVv[OBljoPme9N[u$;F#$bj1/]xE+IR?PV<hTmWARBZVy^i/F;5$90L{TGb#K:W,Hkhm7^gU0Dl86i^ivv`<mD%p!Je34N%^hc?7R6^aukZmFtLm;zorx<>[lPc53#`Z~Ir%o7mg_NW]QEL[)f1<k0SldNDk;/dJyb?zb>}%i"u{fVjqp+ypvQ^fE71`TlU(&qiQrZR={%~w~^Ol?oB{GT#yVRG1n}{%<*ZQy(czUf1v)Q^Y6<)]^CyF!CrKr4IQa6b@Z,KV~ax%!_B">@!*GMIRmuF2R@>{cig+<@5)&nR=9U7qvnz=QZc~z{,NWheE>a,tksO?vatc22qPa~3u=,Yanly13*)&1*SgO2&K_up({Pza~5vv"JD_p5RAsU;Mthkt1&"=$0NA}{TeC>mT+Ep`*lP0U(s3^p>YAq77h`wA}|&_|rFif9d;:!=mWu2}M:d%A!QD_N`NoKx)?G>r;LWRWZfVRN^Fv!jcZF!J+4aCKRypm$VUPQKUjSSi8R6M9#+MD]zP9z0bd!veVnklNt7jmQ;jiV&h1*HAaZ|h|=I96.[c%jv~C{;?Z[)`!*Z2O~L:k?cS6SQtq=v4VjQDk96b=d8?=]Bg~vQPhCp!9<6_uK}Ub~gyw$0PK7^W,J_kvD<ulSJ`{Q,xr_mdE#:,Y)%%fp.fJ&U|@u#};(TJW+Ast:GV]&_1&%I:$UEi13p`HO,k`zy*DAH[UUhx+q%O){#XrqrVW#|Xd`VlX3J^b(XcHfxj/`PtlN?qP>U.x%XNh1$AXF$>`f4!,l<ETYoBm,&?B?k+4DTYu~Z[D9<ppSyNto~.5I^O%B%.$?ea$c#m![R%h97v5mX*]peTjS}yX;sqgTE^v!b04]_*Wk2;.lRqyr)P.W~VKV!&2f?s?mIT[0InFNLE8oF{~Wod62jdP%+p]8I,#2=KhYHDL8}C|s^=a}YWT>P82xnr#JE&cMT/I!sz^NKM*0lO<;Hy9rQY8PjW:R5oUv12tN?5@oymkdIE%zt*`tl{d%_aF[DjW6=zm3NA@@IN(nnqdE)&,gfy?wXAG?S)cm%"1S39H>`R?Z4!2)nw/,n"#s+g2;evXSX?Ee5s@3er?G+<=:4d>`N[ubj|LU[ji`}d>3{pyirHSTEl^#eYnSgl{pn+Ky_a!H%gpxV#E>zIp"mu<%@v[+NT{Y{S9Dxv#@XmK`N@`1,3nj:YpoF:=k=R;e(lf=hMtss8H1L/5Jw=W8<_)2OgLVJc9qEDN5@mB@6h39j&.{(8RHa""M"DZo7lvm)gR`0ov/ss;RWQ~Im,&O|)JX!@t8:"Wn[+Pt9FH~Y8G*TLzQHqR+#ce#l!754e2b:G(%b]TOf9Qo%yS}lrFQ.q)F}|hm8Oh3m0:JA5Hysf9]AcsFa<62GQ3X_ce78mWZUU.E,:3NBa(7E4L{b4`$jR&}=wRNh)t&YRgC$r{vLXZ}ZCm5K14*ckGJGxlTN8kJ(A[Z!=:.h(G{!J`j{U.%JDzFD}uA:]O?,iz}c~kTO*y/RwRsR^t!on2njgqOX?!jogm1HbUjPyQge.o.ZN:a+UT94oEJPr<ps~<T}auq~sm`OKi|E%k_Ir$%Y|S~J6>_J7;HE(vH6)MbnwX4o<k6.WhQc[WW/Qa2wM7FVV?hKilV=nB+$XYtF9wA;`X4{B0bPK{U8b=u!gmoieWti?T1N=F|3~f2xAqGG55`b;%pDK=:DQzc2d6HI%?!]7;fuLv08m@mZG;YD$]>_#wY+LaN/tl=zNVp*vJpN*|sL:9ZFa]}l}l8T)(&/I:c2:E:tWO86T0O!QqiK$@6jH<SH!f}brO4AOlm<"7_%^]IC|#TjXXov!J/@Sw[$~A[uu#LOmvWkD9jvF:5lU61H7]j"f}O(%$jz~,rSg&l52QsqQ6J.nSD3cC1|tNLO#Slip}@x+Wn}U^aDJ2Zt6h8U>p?E}TN<:Jw_/^oC`]j+6fR<10(><MeGem{JR`IeRKH<:TMJCJDF^5u5FVutX7&R7sla|ESFB?8pMPm8ep<p0CDx7"6ownrD_:UazI3]XKsRj]Q$o>U@qVPZxfOm`MLd3a<p6G//Q6{zyq6{@5pr+(F4ATxJKW0Y9h^xAHz=?IiLcE2$8:b4wfz=Zx(&Syi0"k6vg~z)#x;`yOdVdxc.FG|mcJXz:qahv^G9WWiM}4mo8BD0fgjBpbrTm!K_L^Lht)Nb8q1kp$&]JW&7m"Wqt_KY$CfrS2b.lLc&&6/rkMcctV[qyd:kR~!BYc6V%hgC?/TD{Q5hu!/<[9+c<hZT11zq(q[3Y:c3,dzilz1O@DM_=.{}vGr,gdp)ejP0%|PL0p]^(6$Ta%;V/!_CVYdVW0=(*iRMC{_NhH;|Hm:3A@A%GIOzCt|1_tVC0kY2"}gtf*pLmA]GF#hF(&!#?m`uJ+3"(h%ho62@&:iJDW87#r=)<_RfEo3g69ykapr8IMWe_@t;"7>02)L!X_MOBf4/|m0*8/LA;&(Q<>+?/+Gy)|LE<BIH{W@?Dg>v_>sRy7yt$K`]j_HzbkE?4_WCxKf}2vv:}c21Q#(VV6PZ*^.2V$|Zw*OtFv+q6Fe9h|7G4(9:>2yvT)/KE0ZI;&`t&dzG|TE$PLK;<FvdBp9/J?!CA8[igs{1bLN&VMSdJ=kDS>h?mB8kjX)ED51pHexRMxoWEN(|B;IW9&Cl/l"xr%b3rvA)DQXg$cuGs.XIhjZcneT4!VJIi1y/+nSGt_Z/%T[Pf4?FPV!#f,W;#zuVbM(oh(HglOF(c1Gz^}h{<w0[nY?s[@u"^K"c:njnq5]WUo$M`AW4c4>rhI:,h:iHq<lf"}3w.!V1FJUk9.VA>CpY_@Uz3=:+x$?rN<U9+yH8/%}YWYji)A(mMXt}qOf3S;n}Ev8,+rlwZ}%Q)<YMhjH(G=<$*U9n"XEJf<5FTg)zA#+@V0F.B4&(Gy_Bc;f5Ly5%_TX`T7z7"u_Y0U&*6y:E|_N,pd02gbPo$nah)+q^STg7sx%7RJ_c:^1d>8J?!>:Uu4xL>yl*/ubx=qeG1w6!"O_&4raSA$`C$U1{J+g*<6dhNrR<Dg~#]$vz+@VD!;)wAv3n,zUvj*]UjnCCI@&S$<H[{EsUL^:}#iIp"^9M=La5@<LWccqLiGkbP1)|?qSuOU~.piH#Ek.FfW:8F}CNP]AYGZrLShTQB*X<K,LA]7SSmDf)4<Y~A!^@QdLKtLlaH^}e5(D%DZh#*"ZW$MGskg+EYK&MNb~lg;5.Mi"8LUc$($nZ)wF#a=h7Cay]D:D|6MVPI`Ajbr3}ZkPCqD9p7e&#m%>T5Z/Mq2FL{{z)1K2zVoyESdEy+Ti?9LBML,<eN_._!s#?e_~`~4Se9Reh34_.6hR?$D,&EQJG);pF>_UOMVs![Iluw&uxmZ=J8Y!cNpl8%pEsHqXa[L&doq&&DaqNnib!NBaN|p?V^eI)onp#9(d@.c/^|oRj[gPzs9Ma0.iF%cFRNofxvezD(WqdyRrzW4*9.A${c=)7#O|2D*L1v0nP~`V}G|q%of`4;sE+MT0/%#T^@mw9!,[3l}L=Kw]Ueog@_~h>?I|J=0&72hXT9n%Mq.+(~{E?FZAId3Hj}Iy`eXFW#)bLfR)SwS4{RL0{a;vSo&B+O?5$LK(,zOL[f~UuBGqgV"o;SBkK8F}oTFnN^nsW1?Pw$//f?uiPAf]C%DOd!Ing"DSCS4=[hhhZLvx#~D#$!=Hc`9!c?ikEI99qJ^$e4"Rgovj;@W%/<,MR*pycqWs7L5n(T5Kq5S%($*ZgSL`bYbvnFM^XDfD:NGqyzS}Qk}AN"S_;=^A0"~q)|k3YJK_H8pm(Ue5b?1lLyoH=q{LFY@$m^%VXjz12dzng[ryeYoYYX2;4yCO[XhDDGfJ*x3ox^i;v[7Ckk~oW/*Zp,.3>6)#SKc3<po@`5MAY6G$E8wRR$gqMY4Mz&GeenO&wD=B`VpxHQ(e:rI>h@DZ=Sp|R26DL4JvUig:SP"c6K9^!{WE4m+p]8CGFP>OEM>d%dD.,:_Qj*xu8:0!T(,e^jP%jovA^2Ms!K[<bbLm47HTKc?G,3=!x~6HpxZ5/aUiXh4>&3T<3%b>vO/:hkb"6,7X]FR$Ono@Hivmyn_4Khqa#~{t;zQDN#F1xYI?ku&DqDL[X{BJLBPAY91eYSPs>%xvT*n&73R$rh;Wz^3GQ9Kk1H%_LYzzsP8B)wf2=.t]rLF_uI=Hl?XxoK+v3eFhyRM1BB?Sf<.>FGBT6KV~/g;a##%Wai?o0~!@UYgemxd&>e:8.Qs4K|,Qd3uiHn6@|T6yF:Nd{X9=X<_jR001g:V9Pqj]d0=K0+EP|D<=T!/V=Q@7(p)EN6Jthi5ez0$h(^Ui</sS5,qunui1?`ieBcdZM.wHZ=v`xfq)g9nYgC:Fx$%TjT~f9{Y/edXXkdB;$ICJa!oe1[}?#.kc|sk07[,XQHhBEVa[dHxE5F9Gq|wf:"QOrYf8O&=]Ndk!u";H=Fr1.pb,D"5uX{@FHKH,`(&C{C_5Si_+Li^:*NB<iMk@E]Rk(h(#w=|%0>R@~hMLiw0_:O8?l0;;I"#{v2(|e>kHubhmr32ZVGEXFRN5}T*VxfR1n*|3cU_St~isJ)nw&GUrfxr/H;QRno]G}`nd$mo*&*Y3+.lerc`[czi{aAjS7tfV#Att:5[|~U=SlSHeNj?dlg`p8MMXn>8UEX?PEs|eGi&S{.i:{h6.{s;>HDpL[6Hl%[InOpdW@$7,fW3h1PN/xN4Au^L5v)ebvW@u/va6HFk[IJe93<h0b}FPgdp~MA#{RN1ef9O&Kssn!yi!k8OiT5*v4Jd1(cP7GM&G3;:>S$x{X[TvW)QcO+Y=RAxi0]41k)Bq*1Blp%tHXR3B{NfI`!8R$QT?+N^m&Z.ymN63I|SMTeW5!UOd]SDUM46SO!fl86VI.mL[XC#:=pG~dFjxZqLKgOTTvFy&FTxZ1`[+I:V#)Ao1Uv?sv_9dRA[p|gU<dJ*vot/j&k9LPEuob:.#k;eW{Dp`9?k&o{(.@V&LM/BpSc<6TlmbXEux(Y6N)O"/`K++nd^X:;iQMnMS8Ub/C!k072"q$bY)yTjy#9S.oah_7s>>jBkH^B/cfC*G+w{R191V+HiUB$noiST^+oJTz$6M$@.d!l")girAud|<#AI0EJrDk5r@u?@XSva/WSB7)s&Y@OT#iilwC2~&&K!HwbOJ}sr*7$8R,I,nPvpOv+#aah`(kbJ`sfn`P#J~Hpt8c[qj*^erTl=!+"jEBl%qkMD*Zbrq%,mfrUv(EncxF>*oQz*de9Pz2E0p[8uj?(PBjBT~;bdr:Wf!PZb%%S?Ur!uY4lI$.0DFVu05k{,9O|D:lX0qlMc5z2`!18QAfGhu6yPr;;$5L4k`$wIR*D=X+ggp.^<v,yiq`P<3"$syxUx8>*,.g~K<*`75{JWd^C[~Wom+K*i+98=xamDsipq_ikLY]2tR.tVAR$kS`j6>@&_=OZm>HlN&b7o7Ae3Q4o{0m"5,#^7"Fu_1^6yJ~H@FpOzF$5O,JNiP#1@6b{PL;:$+H_~beAO;Z&If:j,d8=i]}Y3Oty!"VIo9R9^Q$~o{;_(lwT94jBh6Z[%1M3$20aW2dBDG[/%sR@?eR3?KLw[nb@228t:KN&k299WvMeX61M)%WvI<FO/KZaQq3Oef7,k5B|T},hfm)2!u?+4SBZ%^H[tmY=|J_4>X]!bEe:>E_d*@aBe,!S?[&h1.X*BaW"(<C?fO=Lp/3YadJDjs8=_1uDl~YW!VRQ?rp>h>_5T4t4>w@,vwm@Z^Y^ICm/Dh2N)W*oLkhy/z|^9up~u9]`ZLPe.$h|jI:ci_h:eS1>s3uGigF<d#6>,g2QxUuW2Lzp/u^#([c*_A2`7.kr#Z.y!G{"2mN;IS%D`5_"NfofyJq;bD0$2/*d:r`v#67oO@}6@fPHgvw1D^)`p@b+EH7PX0;~QMN))V>tg%QgML;9o~UzJyE?A.TUVHu;.78}n_Aad5/K}U)f{&,9Jqs^U:xw^#0,!vn,D21r50u[takw}q5sf8QvFXNH/^Eq;bpUv3zdk+6Caekh|92.64kT)K!^56oXT`fU:=GD;22FLN3y9k`J3(4ls!vCI4Actki&rxII{Ttg^[.DPFh)5=toF,Qwvk>EdP=Ln[IJZ?Je_]^@|p%fXj!`qRT04(V5mpL_K6d>b`oEW)09_ZYi}k~8,$/hZ*.wLp`6~:RSv_c5hx,ylEjw%_)$LlcNJ$@H*vKS58zd[)E%,6&_^"8Z~Q#88E.y6mG*!BiUNQV{q3=Sk{}:yo5jPz6`%I88(Nkh29Jh|PK.Sx^ped])s1.8(L4I:~7d:x!;9Viq`v(/%Hsk>a^PPBX<]y:v7:1R3_0{yXZvywGE=V/Hyg)df41J)}u.#n@_Efx:.GL}d_&I1l><>u`pz19SX9n>;0dm+u+*4~msKFDK|X,0[@9k6,7.6%Sh*#[C_;jbH4&]X72a}>N,QSp&o^k=RXfY<:J{Ujo,x=?il#<|Mc1x:OYGIX6ick/~oR~!!6Qk(w1U*HWO{gpi0.*Q~mwHE9rwY7s$,L:G]OY>rV3MlDQ[;qLAmZs2YLJ!rZ}.t?}Pe.s>/AzO:{D+:I~6xxFX1HBr$TMZOS5U:)iqM47+^{v[[>:+Dbv@l`HOzztn{=VyOx(6tGdLlG}kNYQ&3Rt#O8O>>|C<:6jn0[.nL.uOf0W851*8YsUi*l${CE!fbu4qX{kbW[~G>>nJDTB4MD(r<+@?kTfuoJ,`nGze_2IU[OQ46FF5;d11hXj|^qo5rod[qhdSVl+S4y=qsZD.)@]g(^3Bt<)*,v`J.ney2V05!uZ?^?O6/ZZb:MRp*upVn;)`BG@9/}pwb$#?Cc_@W[2i+XG(hhLuNZ**lpCykzj{!RoZ~:h!)Jv^N?qXVi9P^_@&Auzu.QG|w@Ih=PxH2^`G]H!72N+iLb.XrgX2f(eMb|)Sd;VOjmf,@!luM+*:ivwOqci*o*Pn"r3=TTwjV4J[aR[:K{4q0ygLt>,2MWxU7WPD##&#~=<2UEcz]nsGTqZ<m2yp^aYzw5"li~:"v2?[fG<b&PaM&W9zH$rAz2>=sAoF#dhzSx?;e`Ek9JrA)VMN|"oS!d(oqTy5?fU0Hocbxa(aR/_@/hw54$ZIU&iM_h0))>+hX1mby%kZMM7HTMguG9WHh65zW">!ixx"CCwocfu/T`m@G9?zGBr:24YDn^mg^w9Iq:h;H>H3m[a.R$sNV`."p>rxGqG=0zPBk34f0qKtrSMs5k}Chk$]STi^}ikg=J%Run948q0YW1|;F4<lwBQm,jdsc|VQH1g|y{FD5d(k.tG~p3lF_P`6nn+Ow+_nj=v@7bIpT@#rB]&JWCNRb{otr`B"Q)l*MQGF`Isih[66.,Fi5*U]i"]M.~b3q/^HwK:O7KA/P:7FoXJRqHy<L<}b>A/|p6^kYY)T8fHGi88kG^c[Lhh[KZy!UtnA37O{Q~DKo]]aKh:):uM3]Wz1s[65$OA&|zYHmD6MyPp6xLl`BL!!SI5iB3r<nejG$QQ(x;/4A_TYCkgA?F1]bR`I,g6rodBXV`M+*8H$Zl6s]KShG8RD~*q<D&M@c.V"WzpsbhPm:&$_Z59Hy]h_f80DcE|3%%A!N`4uZ3dm9;rrD@pVG&`q?Wo+d&(W{isG:X/!am[e"TZ7$PaLd,]<}A/54eb1{]|]rCi%FL]0gn`[OBe_3Zb)ZA#^.%|^I[YG:g@`M1A)F8<y;p<Y*LRB#0>uUfd8yCS^h8bl}s+]J2uzY2^kq}"hg28RiF|BIR^|Ce.k+Nh41^9xIZbBJPGu@Md64pr,aA^BWuWR*.W,ZZWwM|Pt2e#d:1|s&zwu)tIb=Pe6X{xU0[&1Q;$]/`0cm(1+n#DWKXU*RUXE73d/t/i8m9Qgq+~&byW%!TbGhv(c6)OA3y71uuxPXD|FDp47f<N3@43|(}d|l2:z$UD6_89]Uma^Qo8"ugHDOXVzE;TzCn+j:tbr7#.NCyQ#ZUQO%}*sFpwKphbxQ+PhdeLURAqf=@<8eU"UeciGr%2`;]yb":K=+T0v>fMiN.a%^D#7V=i8x+gQf)fIvD`W$NhL;{a^DA)[[ReZs#C~su=YrY<;^.3("m%@,HxLy{)N|ibiF.7dt@!6Uq84i?{!"q2q88C~rGWtz1>129w(=}]FUU?J>`86}*dkfxu=ZKgFH/$fIM|kTE:q$:Gkm<=&obu@Cqba9oZzEP^*reF"z$&GR)(y4&]Oi{Q0T,yT$(04}8XlktL;82ez9*orv/cl`6+6}>QoF7f|D@Qu^l%Tag1"nv(W|c@;w@h^`qX#,z7"HGPIyDEFt>3C3)CjDs&#iXK,scKme3W>"VX=q*(fl}/,;wv2;`<JzD>[U;$;tsmQ*aQiFoDEO.,|teMIB?:(h|<?qujnzVlD<~Yy^Adf7x`/+6V13X9{j@SYW.y$XL11d9851^/?O6.Qf}Y>Tn7N2}$ug%|H,Md9?Tz.Wf5[GnuOcb]e42L,<vHP|dK#(SI;m8Q!r*.so+&e~gdW<."geB1/0@z&yC6ePyW0iIQx{ct94"<cP|h")&"XM[u?!3QX}y9SH8}Q%~73c}Lhw"u,ikP@drK8Gj2$e6u&%[Me(}ISk~/Zt=9."~*kq!5n7:$*Q30S2hrra9VS6;CuaUI>lhqS.2%DWawnbZ)>aBG[^.V)4s>&PQ$vMWMLPfk4feAkrZn5`5S]7)HSmj%bUsGW:b0Z`&<X*fT(?ynt/e!gdu2BQbw&{O8k1_c32{R(exp0&tf{/0KJf`8vdPLkI:^%>MiC)wB,0ag$sGhJbCXE)VgtOou~v&LZCTW0}>y{N2j/p263WxD~.&],Xs&CN>O~:todT&=kVtT`o<t~C%X?+U3w~U[WyY)[J%Cq^uB[bJUC01A.eJzEYUD)Eac{$cUo"VJ5hqd(%Ke>|o?D%00Jr:aw]t8=w"T{m41J<(3r8ZYl;{yxc3S:eF!d);V8]CGJjIzO@N~Wgtc#UNR"|E64MCqCY<_+suK;JNizqeM0&M#H;HbPDEYYXaSg7O:>5q?B;h:.ZBOtw`};C@O03tS}Lq1=;5#X8o9vM)U]#A^mw><*YvoN,;C#ijP&+=5?i/y}`"8@aR{KpJ%DLF)1[_x%J#mc!gHORb5~`]a7f*>/|fctELW4JEe2nhw2T0kB8*[#WrQ$,S2e.KOXm/B2is4(clY=K]D4g{Op[q04=0gW[$lz;xfFew[pxfeo2{)&%xHJIVQ0&:x8fvkz3+mf!Lk0D!$u$eJHdy?P%clY~#x5m.RJK8T;4Hl`Of}_f]r:X8wKqvg5rF<]LyjuDw]O*#}RIAD@#Kc^(Cr<u3C6{P/Et<mWZ2aC}[zL?_bO7LL5cD}cKo_dS/nb),bB%"bueH1NpLE]<]aZiy|]Og6=yy(3Z6/x~;kOcamvDbFJj;RRcKM6Y^arCO{Wvtfs@](p65LG*E+5uCv;S#x/(VU:Xr<n0iYWtFX)?pIahV1Man$wL;)yi7Np=.i+s1$"M3m18=f^I}E5w7igx6}QM8bhkYx<ew5`)MGQ@pmR!u2fN=X;;)em&<jrw_|n8t?U7@Y;<L1iRC5LYHSNFKS,4BPB7.Herl/"h3%E)ga+cwIYVdN_Q3)L`UjaA<p^^RylgH)kX#5b__V%X~w9*hW[7:u>MTyg>*tBp^3ZhLs(&Fa"^2l9YjOy,12|*MXQOZDdowbl$$V|2zK!*i<r,Ot7*)G"BtAp`PE)3^CpV7gn@d[`_AYGo8D4HiTtNeToSzsp&}|_z|)l5P{dVp9<TbE9PKp{Q2#;aqtN>*Ke>tnRnsf&h)+<*,#/hOIR?s[K](wUS+[p.!8[n}jXu?lekW#8yGC;SU;a3mQ$#@dT(|<PLYur&q66E{_E^VmDeHmj&Cyh`F@J&scIQFAa%i;5C?p!JqYNjK6U<T*<{}O~[U7<+B9ePDXOWaLDZ.j97vag#SFD_+W0T0Y{u[snM)K@v{jVut6|%L2XXfDEzeb*^Y:MxpN<${0vxFTw8oC*kORGWt]N*7[Rll7W[6UIWzsAsIyRaX^eUHx"A1mON}IO&BZKN1|:ifCMKNJFq:fri{!oxc1OfyqbS6#fHSDJq9pl*EEhJ<T]RcQF.=XfnMWN0Y["WpZW~v<uPIuYU2b:qTh.TESES,F2d.sj;QEB&]Xy49*fx<lxS1So,{]Zn=Guu^qnGhOj3Y`(6"l0UCL{!YGh%[wJ}8Q@ku2BA<q`YU5;y1*.KVZa=E/Io~01h8V%g#dj7+ybbJX,}i&RfEJiG,]ESN>~.y|`>`:Bx5fA8.E}IljYdDDjmk!Rqs/_>y7gZ`rg5QT?T&+6HVB%?+DEo8:Wux`B<|?yEl{h+`d4~)pQPOYD*(yEaA}Y6LKJ7QTn5n#XO#Rio%/K33|_p~%n!9I[jFk)7{)$Tj+MieFsgevRr9MoIg/cFZ%<uCZUJP}CtlsoTY<zLtO4,^S~exxutGH@~v<F$k}?}E=XD<2Dl*k:`)0PN2$4UP=clSQ9PfzgoT!*?TlS6WjnQEs:PKTXg_BAMW6<b>Q{{=A[)rV>?)ptc2_/_wjCWkzEvW_qv<an&]YU+Rsr|OO00_H5$hT":2PrIdBS>c*^"X/a5^j/O}i<#<}rKQet%[0#;Y(|NE~[ZG+E%:Rbe)X2kM0SvVb{<PGe[$5_Djh@P(c?;7[Q6:0^kHf_=0xZ`m$~t"W2n1}ZO2H,?uHC@.;Y<i"1v(D&Ja7~|lKn].9c4*Y6h8/DP1X[1s&0wEwmBE1`LC[_V/`G&Voa.1la@yrk&$9|4Q[Z2&u_Lmv5Q[*LB=CwjgvtBP*_a?ukpk[+]jS.dL9idrh&42:Rvrf4g%8.Z9|@HzuBd9gJ)rhw!ZqQ6W@Uw#pUXo(gTDXycLIXt}70W+==&]HJdPpl+(l4s[4LeS00yW32HH#wz>`z0NYk@}6UOSFAEe(jF)9i0&km1]l${_(8(v&Aona"s.*5y#kUm^Gp6g?cJ4Q=~aDjlGiF@aOpu;D*Ae?q;A?!F%bb>mtoR3{),2|ZNM%X0.W<*2G65Z~|.UE{D.No*}N^%I]iVIQ*]$~<~RR[gF6:L<%Q!6Exza`X(8LZMVSYnN$*i*$c{n9uJ{])BhIHSsNwvo:z@dN^kB)mqeRh`j%0rz7W@n;#7R(MxV1]yD4YUxTDTE~9:ikUr#,;,/$)M7]+qy}|QtQzB4NC27PkoJdfPD@b0#X46sGMgT!J.[jlR}1*US;1z?d,|CF:7L{hh"VPf6%FzhXfbF&g6SrN60%i`2"DT:!&Moyv}:/!VwfIK"W+(fHRjz4V%cjQ_fi?l?%lb@zK#UUkQFswj@^pBjHP({M0xGh#<.ytZR+Dbp+9o};_u+4.8b!h2*(ou.li,wRICdB,Rap7fhY/b_n?2/ojZ7P|sU5(i&mDi{mf;e4o9%Vt[}*}FT@pEyUmC:Vnmr+j@[j)EJz.zaUTrtckat/7rQbVBHFlHz5?5l1fxs+[Sm;zMh_of}n*1U?LDZk]Q[H`v{QtwP0lB:JS2.AT^fo^hD#S+rA5b`1Zk7[M,h!yoEuMto921^t:/GwI?)(yqV<BV`Xy4p;d?5MZXGu;$lJiw(uWvrn##pLKi[lGT[GeoZ+ueZ3aoh7t!RXHPl>=%SCc?n=9SLR=`}G@xqI^Mu}Gm|uY3o*F}=Tx}]9aF|3T0Yo^F;$<z9zsNz$Owl^!==uW)LaN[T[DF~JG;Dap4Y%Y,d&`R,]pzFW(?!HLU6CZ%sU4EPDY!WQCR)5gPD<Uy6fYlsY{Cq&W5B#DrW_/Dm5@yZA{YOF@S9/PMYvZt0KWy:vI{#MQ(=kxJK5bKTP)Z6w["bON*/Fc&$3(:=)2u/$p4V1Mk3ty1uB/j)_sDrx33$"xY]5L0}]H7v0@$^7SROiKm9)P0SRL?F!C,B:X8[%J&m}_2K:u+9<a<Lugo>!{41$HkJ0>c1|x1a?:;woGM`z"kSjSv]<&bx!L5U}6{+1Kx3[ruwr_!K,Q@I]31]]N#}]15$`4L1LyV_H)/]3Qi2GM@f`n(|^AvZHUpZ|er,DLD/Q<2x0;h9[szdF%g]{on{b"U[HT.q)BMpNjeTrCG,C[Y3DV.&TbKMaDRlS,#QhH##zS+3bU7IT0oli8|=oPeQ[P]zd(r8i+6jJ0t4<NW)^N84ID)d80#@(>r?aQ4M>VKdLGIjF[hkDLrEN(`v&@5Y#o#m~,E[#?,D;46|N+5F<L^rvf3=EC}[NG%TmVEYvE?bD5S0KjaLFx8,;*0;1:Q>Kv86yl0"zPlzsq0uiD):@a#N{]L>NvHFS~>XLkCf=*aXsaBv~5b!1i4VHFI8I4GCtsJxw0uXtYLQh$aXP@NSyAj~:Kz50YJtg3.^)mRz|[^:[G0}lh_BqkUk7"&0Iuc{Gw+p0Pg(MdYRFzZ(*4,0IqsPD61pfhA8xh=Lon75sBnd/l]w(,On;Wg/~fd0j4t1.P42XBj6*3(:1rf}(s=HIt~,MvB~)Re,>5%|E)w)fk)Vi1bOB$=~3=s20A]dg4U#/3}0mOhr!6*z|k^MamAQm#gKre^z>6FV~xGI4uBETjV$w#*^>@tV.IeoZ{FL!~]>LSLp@zdE[APouI;M`z^&>`XHb8TD+%zs!Y%NyO<UEi>/(}{m$@.wb%}r3L*R=C+$W/7ykE8";#ftkN:<_Vm,=[6_^a+]3d5=C?eD|wM/A7r2Opc$%g7?:~1kgCh6]UQO/ZZ${@Lrc]*TnR/L}sB|m57e3ZiJF~?rzjCFZKB=<$*KV&.,K*F_IHn!y]w;+i7+Lx"lNnF"6SPQu~BI0jY1A09s=e(9c2"p3Dasf%sQ,H#)F0^Q.5MuZ9yR"M=d4ebBthb})3wUY"a41|[gGg(7HCf/qa;pzM73w6vQz,PSq9U|MNk%lkcm$Rd*=+.+k;+@*H#7qWE~f8E2g@T/%0,hH1M"NrTd{.&H17yAHy@Xjs$|_dpQLoBf+B86)HEO2u.(6+sab`O1.pBu>oU!*;EH:B!ikCDwM.vAhVjo<=Lt|Ce>hs?M0Zw?$EWW_a{F#fY/1={0ln6@3V8H<tn1H?5Bu<LHbf+gJ#rWJBba1{B^a(,hyqO:FQX{:{RE$YxHTXKb1DtwR8ZiGi!0>i.NTi(1h5@t:AxI5W<vm`,ZSkje+Q_3yxdcd8]krv{)0`;IY$cOq`6bPh`;h`npWPCQB{mfEZt(Sg3S@qIgX^ugcTpxQ9t+)1X)0^;:XVt7^aOKYjA!>yBH0NH;YC%6YyD4q.yWNI38sGiP+U;.T6#sml/z!Y*rQUs7ShJ`o@tv]#TLE]iy>zNvM$h{{Cxn_|*`a}0U_}`r_&Xm<.VaI+qF:;W~nnZ_Z1yIejS3wZssqH9l|vh6lwziPPq=,W7v&C,ZEU&x(2lm@h3Am#>XNot5)T8KvEuP.j:upbf?!L828^RzyhoI#Y=FuvRp1=2id!_DpD>dY}uCSc$hN4/psl2DK)Y#Ty=j+Cxb]|:fuj(I+t]i?qE6&]i]9;oCs=:pskG5K"Lz53/)7N3p(QTT)U@Zr1sxhK,{@.z3`0~MTydnBD1kJ!8zFC?OnjX%=j@6lhDW{7sEWd*!)BooxIoG$d^[:ol0t}rl{a)/x0sMLX|trQ@9K+>S:9l+W:5/;X,1!ZEDFxjxYVxGv!s^7/(im{%dAidV6sf_)s2vsx(Jd]5n,QsQkjf4cK/Uo]T"57nmq[*Bub=O04>d1.zcb*lo<Y&$$}t&)m%*Atp][30;lWB}Fq[;$(|&ByE#G6a>aMa)c]8Im`3|DVf"&3"sH>4M83`>NA,G}|={ls.rKVYD~/G$xGyv,ZIw5rtJ{=2f1B4~2vCD^NGmt(~;W4ca9#w1LKVE+1$38_kA5y^uvz[(;*Dp!;M@i7i/*cOe+ot?;zt5aC(fznfo_}#y$KL1OZv.JX9!XvqCJNAUv7lm_;3+|Fx^gjz/Tnv1p~u{d:F]%eL4X:Wmm]:,6`p*^]euC~$FlF}!&CiY03i~H_Gl%G9CuPSzc>;qhfURDKOLI)QI8>+.pGJdc}93w1eysg4jNeIeGSmOFKRvGH}urP7%~9lIYQg#%TpIR<zqq]_$XI]XrDugg~{/{$#C7=sH7}6&XLa$zf9.,68j&k0wH0]mnSbZTzHWbaOa>E{"_6o1OkL9D&*rU<1]JU!Vm9P?o,<D8+x_wDLixifx0utnY1t^U+2qDbJT.WSwZcu77a2fRA}&9wkXc$wlItVh}OWcp?)YLEXF&u@9G]kMrztrNl]XR`J`8!}hDJ@kJ;!]?u5T(@(8U=D[4vzSjaBEYQm|&kK*I7FW^B6c*=25EI~"oNS$k7cuGgIKQwo3Ehc=U?/@b(}0+WK7zn;@9n@"HvP)d!hQ;{r;28]^tC}|V4w|y`CEc/dT|<R`_A_d(Hd~89<c#8O=J%vk5e[6x<&jOjFnEh_Zh2%"I^daxumUiOI*l9EwMBi~==#t}Fy8*_xiB_Yn.K:2w{5$CJ@O4*_Jcvha_E=KdfF6`s!/8jrI_JtKw3nz_eV;e0>,Y6R*_kDy]ytGOf^g@eKRTetE}58=br?"[Cl.{eKS+&Z`7dS(h^:/[+%hM@B0_7/&U;yO[p>O7=f_=ZQCD._*d(15Ztq6@MF#kLjJ"HkOSl~5NWgXAs+w{EFRad4~![L{+a17^V7n~|~lL(]jehI,h/8Cq:*]%;FQFVk^k!I<[D<IQKQirx8pW4s3MuB@>"F:a]yJk_)dH8=Ixl?NGDzY@wx&w3u0KD/u6IRu`ug{In_H<$Xy:74):IkPKHjzhilR<ZZY,p,8Oz4aZz<~>k])e^Dvqhh(?3|nhrdt?+Q"GiN<P?BcJY9RujNY<Ll~m^gGZ_geVAeR*vraW7;y7eX+l^K:y<djw&uikPy?,Z;1A7jr61HD|nLfK]cQ_h,PKfRPiw/28^.TF@gj*Ac[>Tip{|`u4<a~$]t][P#dn;SeBx*;zLGxu<zv!<_#K.x?%IIRnzPV3];jxai7YY(XgtufFx9bS(?JeL#orlS#f^Zxp:9|pj+#u>}Crrh#E/L1wko{nN>hoe.=Vo5Wd1:t`z;RXeP#jr;|_5o}INz^9lEy?QQTtBG(#4Rus)tC[_8qTn&YrAT~,``cYtloZQ3~Q)[vE_ar~8oSu=S&n(DY^m&gEF?G=ox0okabF3ay2cj$%|l$<kFs&(88:5+DR;$Lrv(7(NV77?MDj[%Z;qX9tDT0dWXeuF:g{?68.p_Fstb[/*S^:_08e#^v!&7N5E60g.#(b.vb*A4)<`t.<s<e3M|OLwM0C67d0$%aZ`$h7@~lB7fv]iWSK?>?t;{NGpi|?#4Q*g/FNo^.zgs2ut9ugvRME@W"pnelxDCc+2^BhTp(b:|m*d}Y$J,ts.R~:5hC@$=LN4d;9{sUN&6j*gdG=l+C}aRWO:od>^DHH{(=E2~9)I(jv:=JhJ$[F0vG$ZPO@Sa7BX|K(P^pax~|Mg=BARHElwem(UxmPJlG}YI"aN5}j>LSyk1NrDiC3@RWuK*N0x6y!W>C<I{sikC@~6y;5u}7UWpbUlm4b)YE:wtxVF4b).ePYrZ5alHmNtpHH9ORw$BO;,OqCQ)&g0#o%AE>!v9HNvVx<n+N2zF4d,$%uFXB=*fVfh4hAvN^vZ]6dHR;:L)Sj*QS3+},hW<,Awa:S"!=kgx(f3_K85Gl8h^ukoL58n##U~NW1Vh#q1F9?&dGWQz~gi@0!YZ1I_!2Vri=}etbef|nG!bBRKx5k#j7!&El./8!lgR.}B30B?`lI37mf%z=k1R=vHMAD8c,Hr~IKgLboO[zzi[pOeYM,qMk}rMuuz+E=lS4hCl6PO1}Ir"`*@oJ~BD"82O(rnkV;H9Zb9>v5d>i$zLYjykc,r"~Sr~+T76fCZPbNXz,LT;WbnTc[,XK,"4}H`yml>GVVP%:V}p^hrU_Fj(]0P4F<wA%Ni3T#GGLn!VnU*cVzOSnZR_AFDcT[2`3aR@X#(Y.6QI6Q=dC<qP]yc(Qg`aOdl"w#BXu7j&_zpviifN~Bvi2kJ>6Sv4+RkbpF0E?tL|KC=>oLv*$o%`sm$qYuHZ,sopY5?`i5#X)q_SF&sNGmUGt+pTcJuQ}/WN()"^<>H}"IIMF&;c^?{;U+Ak|/u&[}]d7M53`#e_NYhKTqES+^vxsd&urlf</ye3+eZG#:u^9iF5W_f1m<7wR)?Fu}"GO4|^e6WGRu#pPVP54;c4/O*)l<6WXejFx5"lRI{$a^<hDpGJrb?h.`]W":?Qxf]c7!P<c5.khJO$88V72ja5<#,*=oFTI>C?fXP`uS0C0Hg?[14;{m4[_=eMv)$G,;z%&l:{z%p<y@[TyMNE2YUW`XptRbW}Q:2wLn1x%ccyG.CiY+p$}^>87d}dx;pXL[=GcSWGk/Ccg210$tNR.v{UWf>,ZEjajvij~7xU;Jil0puX9,[io%#KrY02*4kDOVZfi}#C{{.au4+4x1k~rbCML)UYB#P1Rw4iV~!uqYO*MQ{vCU?}6Iv;lkoRJ5f7ZPp&~CtG%L[Un|XwJ6Bt[l<`_vHr6.&iZ]UDIo0~&,1}S{f`_}@izQ/Jb>UdlBDF3/r_W*{[lk|Ga!&4K$GnBrR*uvuao2*{UiiRL4scgG65EilseKpPmL<m*|bEC){MDN0]6=gZ,CY[$(.hbu[^Sk%YN>0;E!A5AOpvH[,s{.{?QrLctv%RyzL1.Sd&DM;sCLS?j){6iv<R}0k(%C5`+cOJq_vBlSMbnsxgY/&U&BYY?GZrPg=(d_5jKV5Ef2fw)Q9.a(PqGR*N51=sK/EBMfQS9CQW&g$&)k{eH@=uXpSd&30}_kTuIc|rFS99K2FMkD>}q9+6P2&PHx0l>vkmUE`68N1U2~}K:6^?!CR$wL;r3ndpM[QDj(ruAe`{;lU*Ai`Ea_uZaT58?qatz_%S8i+%>G]_h/s]2r5]ogq4`eslFCsIXt~d,ipr1hI=ok>k+*YD3HsB^|:kH4K"Y;>TNM{3Zuvb*#,8u{P]hfG9PL(e.va5s`;G.sryEsteHRMOueSUBLY:#>a>s{EWR}k~j8Zylr0y`ofmO%C{.k@u.e7{$S&s!ZDws|q`X)YkFROv6:*RDph1wR>v(EswnKM1S4u%b:Zn9;|P_]P7/CT=hm#N21<qIP6hKs)z]zzDXHZ@[L@v3HEeVSWnU|~jjs>2)<]oJA<]9Ewm7P^lOKIJy:(*oQ`ERXHIc6w{s/untV_nTlt5!xo+n`UF.UJ[J3d,Ptw4#Zf~kCA;b>Ddi;lKftAP|+BB3@v*TDRlZ+pQU,Jd~y]TqXjBS6VNSt4wOxv(q@w5@:PXTgt"Quu%]Sp#I4vr~UzE^Beyb9x4ReTJ[|F*(v##a)B9@Dgqi[%0$x?C/ASeNRIbmLrVI<)_CRp60Y:hOylJgZLtYu!Er^u*`N@$OLlv&~Jh%jxrB}ZWRyC+j<C*J<JDI,41kK!]&*W@%C3"Mox9?6!Gu6|Vk.?,vXt0g[h%IE<ZQ~D30^&ieeI*~,E|bC}fF*S[Gixp~8jhgABw#5Sldd,%@i}m#.<jeEP=@YX=ka^_X(~Zh`CyKJk:[27hSk|hiZX?eq1^8k3yqS/~j!K]IQ1DKaTNN}1@:=csrQfE736">(DY`%}H~evz7;Ay_jPiY;V#8&a(^oW@q%frR*o;S$=L2}K.$7"zjwZh($k~ku0Bph*F)+L;N+I9]Ikc%n%Li*@>jD;|rknlHVZ2lCK#)M^^_6YPV==^/M$obAT5saVo*?G?XwbzGPKFqC>VsNaLlxp]RB8MJC`]&am)q%|6n#_hNR^6F&TUec]uZ7W#JbD]Wqx6`ngS]$G+VDHHnfM/K]]_z}uXhcLOg.xoQ5dNOKDf;|C2"Yh|6a%R_MciU#4dfr!i~bJp!0qae1unxrW2;Rq/E{WbP/1G%#G6OvHh9x>XmF6Z5)51#"9_L|73PsDgQh3(L5pjddlk:7O3qG.NcGh7cK4gwB<._gQD1Gm@>o{|hYNC]p:)vb>>hXJp_1&la.A#N|>rbjI+t@h{n.Gy:$aZYignxjou"p<wPzck0Q#5=xkX97s~19cc>Dw1O=e9Ik=OXj._dl?_W,Qi/E.MDtle`#?xnweXq_n6<oUGl!d<.<#87;rEec/B|hj]>@uS<Y]RnlbdpQA:PivIqQZJMBZ_z8mHKF;(FYsWHQ!k6C@g|nnXjFC%StM_0yx&Fc2?vX".:l(H,*9FnE6}3h~i1xEQ>1^59fpTu~*&{{H2&uPDmgTN@um*ok#_LF.!>7Ogv]l}%1<nE<_OQk7yP})d;,_AT5%l6Nw85|h%PYkD~FK5n(4R%eT^8&wqv(AMfqPFvh"RML)Y(@B=PIeuGXi$U2M2=MAzIqP<7A,=B~`4CyGRtgXo<`BXT$yj;@6qqFyr$01ReHih#[FOSEutz`nAE"CPN:%5jZkgl09[/HGTQuB%`]s)@;3y8GPrxT6Sg!I#<bKo)F1_^&lNw}gJ)OS&HrL$;pLdkeo7]W2).hrhpN5mzpmLl3He/NwC,}+5,H}}piAK}?ue@>NAF[w@GNWS4{[h"y`lI[@4U=J[00yO#%]L#LaZ[Nqu0H]B#xqMwQTuUNPtb9H`xQe9_+hoC2Ad8hPlW9jw7v]T)Cokg!_~x|9m@]NIof133{S~m5K`X2pgu4Q=`Lpn2/VT2E):PoqfZQPuCc`ZgON.WFke#1+(T=KoO|/zS[P*zxd:i97Z9]#M{1TTz=GWPIJ0`J&)mQ*n#{"sgmrhS,{vQd{*B*oH9Hu]TLJNg,dKg1X?xN;]y80Ohj[&e}l8Lax2vKcc9P26R@]PM[_X(eNQU{wj4:VyIv~LB2[d:~1Dib_$cpB=QgzJKv)Id^5C`&z{&<oeF@Fl~s:1&0h`DWvyui"H@)[Mmj@.YDT,$yK<DvmZFcQ$3/o]0D[8l/3/_]UqZ?aR:ZT]K#w@YL3EsTWIm,`zz0X}/pW"0&.lV9(D$3!}$2bZK@#5b,l<I7*Mv|w<Ee&1H5Jn7[tw^F.>zM4MiGJ%Tw?G=*0+pZV2{_{Mk0M<9)x(vx%fR#9SqUU7W]i]#dFz1Y;6PWm#y0l@#Y5Y?Kn*yp`%%l5k_JjLj*8@yU6VV)_~}#"k4F&%q*TBwqHX+,nF[>w:d>@D.heJL6HN;EI$Zg0T+;L;617s.F@q/h5x]F:*dQ{y+$r*X838@$OMNcQM&2y4XYyF*0(YHnAr=j.0CZAY>BH2~B;d$ZD;c9muPf8qUnbA=T3T!]Pa"Cn[I{e?B.oj)cxiW5oc9HRpRDh9fcZ<K;qu~C_nx1?;O~#kAO)v.cPRU9}{3JKGca%>EN%JZ*$e=qhA|h2kMa?{r]CNcc1i&U2Z$i~P&R"go$3N<DHC+79.i7bS2.wB;&%%&#JbcS[st*(/9y[@G],x[GpPIHGyOWDi.|d+mjBZsyF;PpQ~mB&k./XxanB5yt$YF{"9Q5YMUZlcu1:h2cKo0%3?bN^cp,F`WHV$`zicv2KcbWF#?qxt%/b5j5@Y1i[:zTn#n0EZ*v"<ImrF$Um{JhAB@^Hu)3NU=M<QNDl>P;mG=r+tZf84{so>dpdK:|jY71Z;l)2u>vh:e:4hMjGqGe&lAl5ur/NuK"#I1BJLU},CIc82rEL._CaRlYtY{F^ODH=$1(HDsmJCu9xf>i2p0Zbj~FiQ"($$>VbITKP554]ujf1g$`xr_8D+HZ&XWt_.D:"p0|+iMHYt86u,sR&9@2~)~J,;_&Ej1I=H5^+""i8xu!k(Qrg5EF2nR?Ms&*#pRF2M*;FP"tkeumIN0^!K1aCBlF0Z{Hpwb&?Y@f,Br{s|UyBndNDoO0NN]pZzdladg3dg4Q=kx8$wqB}"hhXZ$AX|W!!VFXc$8XMHOsg5Jpf[24!CB[xt}vA5=*5`H2=KvV):};wfa))t2`6q6K,n|3yxC&:]U|(iJi(S%I[wO.(HRujLdlNn3+zf4={1_8.T(3h&6|~U~H{f!wU}e2fuq!"[M4b1h<:0~d9*iOc#<1GkITtN?39Ywi&(:+oGFw6f:;LHFH|9D5)`bHUI+tp~~O=|:.^EtmNydCMm)sW]Ctv^GUmtYMc!ZAZxeU,`nR&`[2o26Xlq_&aB[K,f;Pwi+#G^3],W`R1p"(Itp]Z]j`AgcH),WJQMet8Cv7J9i`.9[1ccJ~`KaT7j|TFtwDoueh3O9Suz[dFsgh1]MslxFbVygLR+ql.+H(x:nmHKGZoLREcG@x$iRJ|5_zVsj>Xyv18<W+|>C&i**h!j^>%gJB?+SPl:wWy8+J(ie&|7sMd4?r|y*$Pyg**DZU{/KP~7Neiduf3+uhWp^4nj[6>G$~uLzOy4ObD+L9#tAB6pq`]Bbz0lAMz0!NNKKV:Jko4A(EMF~eaTUP+gP_*=)7fUQu/hvwTX%sd/|E#i~s"$s8k3ZvXn.>Cw~a{vxtbG"QoTlk;R"66Kl5]Fo<.K4v,Z4~MZ{PcM4{L)!FF)@8*]U3k1>d#b6h&j&u,ucE>qt15w{8.6]ZsEIvS1)LGGIg+?kPSE;Fys.!TEEt_#"(0OAS:WNHB3xxB(Ns?wf`I5CpqliHRKtimg`ytCV*1oPN=RYcBJlsFi"46W]q}q~4.DhS2sTsWCj?1NP_=YLY!Pa;rrxaQfWRxM,+GgBGNY`Lk<5W>~LoBIy8(y3U^S+$O:}VO&@#GJ&|e_],|:FNHT2R5[PZ`/Ez}o:{dBfpX=>_l9Ad{^sZ6i`v%!$^K!oz&G#5LpGcH(8(rBk5a(fP&{@#!lWM>ke5Bt~!&/W+xCP%O!N3X2dbElq!_&08Hj[`[N=kVkiv(/4o:#"C&uZVy@QUCszi+Ki8g6IQxF=Y`uZT3utohc=<Ef@P;dtw+>a`}B3G1+<,=`5VFhYF~6a/1_,%x@rB1.:>eI{i*bE3&oa9@jjs%iyrMFT{UP}Cuc[v`K=:eJ@3"5rG;$uhLsY.e.U1^CcTD%=[cp$Z|Y!gb$fv<JWOOR&Y+;Qnsd|i>h7W^#SiJo4!T+`XN2p+<]r6y,&lP(|gAz`SWCG|C[RIjdl9UHY3?HR*82J~CV8|$`=FKWmr^3m>7DfH3#N?G,.uw,TGS%Wi|^C@BY_;MOzp,fU^1l$EygE&[&C,DO/4Vu<OrCYI/hiPV)%Cdk&)#+aUX0KwqmfRCZc)*H;TqAWLg&|m[9BKS/z/"a94]u<H.QCrVOc@G6%f3<sA?x]!.!B|Ktk"Dm5;v9[F(!hvG1j3a/?AkXmN:]Tsy;gvr^q4:YM}[:hDW~R_XH{OMl=9*,d9CFF|ejZ{<!;esm`Q16`h0Zs6x`>K[=8m/iKa!)dR#07WgR2~2T^u/haPV+hd+!HcEzAFU/V4!S>yRj.t1u!OSyla8*wxM=@6Li8J6K^kpg#aa&3XP3<~<fy4niM74sdWOHaC}T2MSY?z}t1.{FD<C$B{%q}DpGDX$C;Bww}6H]]%fQaq3#5p.@KMbONI^Fnn5eLgK6g2|hntBzRWUkt_O78==X&u~wSR!;wGD:TTbv$Hy9|d`IzYnn!UTJPRkK[d7E<}*mml&m85@"},5d[3&qy5zbmQyae&lrSE3PO}1DP,q`5[_QjPoxnuVRjrY`#L:,/J{xw(goXTdp]J:Yxf<?daj5c!,*4$J9w?GD&.m>6^|(UGReM[^m*6H_x.fd"Ft?J!;Y|*2LjcP]f#~F"ftJKE|*%wQ_#($W2Cqu)P0=qE*eAH{GyghAJjgNa|dmoibN$%[w^>;Bck,Dyu_)n=nT$edFWE7YnWEV$,.nwHn!94]4(F#o!"YEINZ$QQtyQPLE%,^c6y)@Z(GWhEE!W.gbe{2x8B%^HDP0%KYfn=?JN*kuvlZC0Ju7{(dp`]HJ:S;g/CYygvSv`iSf{qn9Qn*1"Bi]Pi:;)TFus$"Z<|)<B:#[F<yN|I}I(B[_V0uUO`cQ}=Mc}nWTyqOQtPucNs1{ljR(Z5UmVR3w2S<KqBSbH8)Om)DC<*!M4s64Mdx>E0,F8;qwLCC+[gy|P^4v}{SNKgf4f71~,&4(>*nVY%|eg&+NMRPoU(w=~TN?,IdyiiV."}r[B9]_FD9$LgX`|v,ePPGx"w^Ne*~9sE|lg2=gj?b=fzbo]<[BfiPk`>r=Ro(,YIo^bvLJc2XI1Q8nb"7,Fo79HL:7x3h]fm^]a}XBbE*6JcDWr[uR.Z)W8`ylbf9_T_:jVx;Vg,y}B(Or[MM7Sc,*sJq+u>,]tI>bjHB.sZR(gL|CYoc|6hnXoI=R!6<v,BVv#aDQtNb[G2>NE013cvyLnEWL>&&zaXO^/V2|>HcVmg>GQUU5kO+_X4kbiSw9#>@#I$q+z]Nl6cqU_Q:vJTcn9P_bJzAH<e$X2:(v~#L4#z|.(9PS.l,0wn=ga=i`mDkzf~U{f`z5}9j6V@33*f^@qB@&uiou2X/cZgJuFlG=R=wQqVo=0qn=th8xg[9969`,CoUhN@uCn7/8*G,3CQXrh)GbdbVmD0&Jvs;Ghp4]KQNf_i_=h3O+PD**!z)S`O+O{U;>w{)9chD3B1_+^kUqzvZzyB7Tc[LjCGtUZG>[ruCRoSA:@emz3uj0[kz85|"Wt_E$k7Wf!C8T~s8@7N=gQ.u}5IyS#Svd5PQ9+f!kLO}<`n9i9:Nhy6pV:iaYO*".?.Of[,RXC9^Y=emH+C{@hLI4L3{k&UgW`[A8L/L]Fv4yL1"$kM;$k$?3i*j^@{sI1okI8Q%[wTzm`)<r%MxO#Whja83a"8dk*HqO`F`+@4dpL2C@8WT5/`Uxy1XX_YJh<&:Cvibq<]>2x/aRXrF6N%aC)zkNtH.U!Xsu1cDV{r+Sp82U^Trk0t%zvmlxK_qx:U"p?L$1)CdtDeZnu9~yM;csHr!B76omMORH7Vpt74vYd*CL|]*Qt;qkT5u,)UvT)|_~s.4mCg}.<COtO96ssd[H&<3&@Lo]f%dNH}pyUcR(&*wF`/JP&$]`wqbEzs@{T+KH$+@`A33%yYD;"fH/&FZ+ZbLDo3cU!kPYM4`&scvQffoNk13i:@~rwpJHd)$f<rMCt`0)<*I,T>zOn7LIE;5RHM0*2:0,sWa[U7g/esGUd9O;&G65Gn=c{Gx8E~3sLC6O5X]C+|AGL3eW#O[aeQNFMY;Cuh&^SwG~M>=[|7!uHdxl5?de%TYv;bd@WfKb:;+Vi`S,Xot/N^FeL;Sy`jgj!#~LoLsZ`81vaQu?eUH&:Q+~/_Yid][}K&bBm*bq#,0E$chTVXrgoo13m7>]M>CH.@3j,HxYy(|DN_<[q:Z&O)+Yqao>iK7rwoxo`ifF#&F#L0lV@qP>kEk]%+bieCb7PYjM8Qd;}b]kaLL`E7L.Ejl":F$%o>=(#V$ab?kz%xzhE|6Ku]1Pqd7B:k??ud[boz!"j8FR<E#jMoRR80vRXS~iwK#To}X!Vjb|Y2]sT|m+<DNLgiwJtKs}YROb^xXR&Dj$)!k#fk8!M7%oJO~.x^.:PB#^R{EX)O`?.P*ZRu$s&sITnqYqD)B52n?aGI?N%fsCXP[(1~)?.Z7`l?68:f8cowbK~Z1`Qu;qzF_ZaH"1h.9+*abcku}G5<{L9/V#tr/E:"QL8!W2fs7+{|x!^@J<P/2bVlcGyb/o9X_0)FLoS<ZoP79XqK@7saehu>/zPUMh=|_z~}WEUbn`VR}T1[I;2lFTQF&B75$d6{F#eY14h?FS8b~Wfr>E)wb<b3CdQiKR`/HLuu"ISaV{VU3DdIBa$[1~?x{pNnCQM`G#yP0UeDb{fGkk@6{4NY2Xs`,Jf?u=w%^(tRoxSoGY#du<qTd<cJX`k[2b`;=Hq1Q|KT$t=}}B~P2zgs?1hy]%z68LV[X20ko^d|<i%BcI5L}z%Kp%6[2ZFC&$)4C6I36GO1.%H0,:{/+lywka{HzL>#bDNyCxba/(0qZ(##dT.fq<d]zS($^%!5tmp_MlZc*;+DEZuVJYA&cWhWdcJ5l>^"%%xP7jjwNkXZpId`Lm$Nu2WesM>|TsBlagDYi=pFxJ|4n|aw~.C@5wpPDpf]4NQcb@Y)O04w`gh/:!L4plJ:7x}uQ~H;11o}.~[=d%^g"O}$(p?5EGN,KaUgGYO%J%h5j[KYm]&rMPhP$PCn}oG4@+Y3xC&eoS=[w@%0Wsvy6[RPvva[wxK}hy{;+/35N_zQm_8D/M,"wB3F:/.)lyU|QhsjzOT.c]nfI/#WE6!UQP<!DhXsxfi2BvFIx3#JaLtSUr5uh{C,3Ww87k}Lctj;6"1Rj}gyXchJacr$H8U(12U3dL],!r.8roPu?8UoBs?7:8s9Z1+m~vRg`w/`j3m&,$mVekH43[mL?qLTQWpr,U(Nasdd%{ZK81D*~M(Ni7lPv}Afb8T?5z#t|K|y6K^2aoLmvf~}mBsS<sbf{u&]!<F:YfG($jZ*g,2L|"DRE;#s@.Lz*ahO]Qh(5*&&8y0ASPn5wKSO&qb`k:Huv.aq|w+>j,?O)Ub*5OL;^V(b9vYs@y;Bo,,CEp6iY[p%uo{[{kF_&vO]Ygq[$TzD5$(Do#E=*F12yb5+N+tF^RK.bv#M&Kdb=}Ht*qZ}z@&wdtsujHfNW12GylLv}tb#HBmPHJOcb3JdgnC;DIq4Gsd(W[t`wNxifT>].x3avI~rF+Z&kv$FQ>fuDI[ep#G@$C8C[s8oy5zI80+!lNFR>ajNc4tU*D;KCg~nWZhs,jow(o{|YFH{TdSo9Z&[>3wzr4;j%$C_sfl6bc:Igc&ZXG/3.f>CK`v(m`kvme,/PRt`gGSe6E7b@Hu/b4*<gvicd,"WfDUMHvE$i3[(]`(i]R"_>tCARRS%:*s,h^XJ}EPq00==bJ0"6"F`xz%1QOkG0iZ`WP(AyU.!viAj>:~f_k0p/EL8`aMz,=)T4C0+sF%G&Y7TAH4(IT%V?y<;4j}(3R`EM!h+~9=LjRHMiGV2rzBdF]NFjPq*OO|:RdxV4sY{`g4c3rqZ+3kc#.+!.GRSGz#M?v#]MO~D1f%N`e>UD~ax@w7Lq+BGOCht:&;ln0LBJG4$J&KB~.56Xd^rF|fpdt@bY!~W[d.Zl%eL@%IiJDSayKk.gL!.KxtP{`.MVn;PtV~vf#}I2pAqTFIq1J7!<vp/o`#*+!*opTD|Y46UOb4(cW*{6bps7EoDu)E#iCRMqTLxn}X3TFp#E:s2SgORr5Ew#L#`&t2*H=,+@Qi^E6/ETq7EW?d=mr$lf^h^C(@rgdS3O?KZq.l4&E4bVW:r7g6CJa"i{2jmgm)DWQ:X]=rx&!?*0/Xi^:[%zg!3uD4ws^>G,L9$/EC}DK0VDEuB_a6(EFmp)?pX<%V1}aph<FNfM~zUr8H,GZ6,tYO5!DX*,9;M+>>=,rTp*p5Y7S9SoqUN>*X$9?2UfEKVz3j+;fqKqD8TA(YRk3&bFrS.)9LB1`/sUDEJw^@T|wUmckOdW1Lx|<8nZsWdob=C5aQkFf#j9dWjFT1K1nct`X..lbf(EC5Yii:I<;Am02Zi8x^qmbB`A~OEQU/FbHYx_yguPURV71~ZI;l^j$mY:~:[DJ(4Y5WyS11%G)^X5a?ha5Ft9tPhnq&fDa/b|/Ol;pvOd+0/_wgiGdv<:r!!a4.C^xg;j"{(0!+|zrtvU[#He!Z?xJO7VZXJZP)V"`=nCD4JEp!L=0si)~cSZcu,g_%1/E,~GXywjhs*KkqY|t_sPiN&qi+Nd45]0^UWy!!n8op68UV@8!|)#<MQnbSM/%j<2;Q1RQi*v!Z*)cO/ekt`pRgT%QBZuyonn%Zg?WldVSl7(5?KD(t%tFmYYxR>f$=ti%Fc+v,C}E_M"kVoZyDEdINm^Sh!g#LsyMQ??jsTPjz5e5hTu[*5@u4IS+8n*ZJt3^iE}~!]#vvp0D1<SDj?eKKAvy<uC=;fYuJjd;$W7W`Md$]7$z5#4GfyFK3?PFL(gC/O_|tP^n!0Ohwx?FUkn9V^YcVNiF6_;AP1hMP~"]wIslUYxXHB`rot(C{0^PSkO!Fc+8<P*C1sv%5Nkb_&{vb+1&v;3,m&!e(W]@xKcc|a/S>Y_aI6mQ/VDFeqw_+T"]4^$*,,%_^{*f"6[hYR;*=;J>_/@@jz*9CG@Bq5ZFn~cC](X:3pM#{e&HsCECJ4g+]=dYigRn3q8?=HIVMOWYb!sR0V4;w"s{33v/[h,7QyI?TM,ZhyDna=jP;<5#c#9_$?xiiGyAjUNWFOpF*mmHBD^J)}l&K9+dm?ykUAhqmaxN5h`^/|I%h4Mhe@wnz)`t>J&?D!E}Gc.F3Hl>Vnwr1z(s4asuQ0yw"4`p}eh32<:`^~M5l%U71ei}6*)x;M.8aaBb]s$ZqGSoAhy3RrxvUrNj"gywq)eLWyj]c&%8*)8ClWz/Rn8.^+yLrm2p9_&e7;EDL@S%jTB{%[*PcrA/k,pr}DEJwS@_Un^}O^B`22Y,V>*Y:k~p?dzOe/bh2B=f;GMc)tW+[iCUMm=}>J3p~)Nj$?zR^#~m$xqU:D9ePGhTn^yxLmY.QKm*]OtI/P/Zl]=D(mss)$]W=)|X3,^OujF:Z(l$[H!e%e[LIG*WbU<)}>,akE;z`hCT3ukmV1nM:a*BMTO.p?1.O!%/P;9IDO~/y(^LvXb$$Jdgk3O!M=PvCld4G|Vr~Mg`qBX!be(ntJgj^g#l!TUk4@|G%fmdB0K.@;C*zxU.(HBc3V@rswG[8xkp1P_<%l|he=KIG?nkSkvNuDE+_J(cisl=mfa`Hk5}Nb#cJ#4A+#~Q(LR>ESth!3:h9:/WT.!q=*6w;/1iksq:<42]Z<o<&*{#o5[f}3?nnC_@L$Gec1(i=3{etPw2JN&1,?"3IXdiRE!2![V85J`!*lAWn%Sog}>D_Dm?T$Car|2&P(S0TDz=B!#<2&+!B#y/2$33%5fOEH4ANQ)+}Dj+)15i]wO#m}m.TBw_qa|Tx;x8gh/@44IJubbi#6sq$BU.fXIwOTnZ~<Vlkg3Eiw`BKT|g%264mz}8~1X[%,/W,@TJrS#DEnkF^(!q_Y6m.F(FzU{y/f.OeLs0$!cWovmJOpnMsI^1O=ukS@}tyCXp3;B(7GqExw#*`S3((xO/Z7]q<S}F"32ObY8OI.8>?T>G;n%J?k`(@*MhX;yCIcH4z(2PoWsy{53S_CM5Y5BR(sg9AU^x4,GYd8;xZP|thVu9*!F%(J_pe,Bw0M1ac7lQjWg{hgQ+@_aB"C&RLkdaLYUY$%4os`E][@]g7"C;9j([V41WGu|v~hM/dtTcS%fcbp_Dev:":]zsxNEx75@Tv),=e6>RL4krld<+<nafz,@v|v"TL~^p.wvXPIvqD&0WtVG@O5i_]BM;/#V9.YY)fO!LBwHO{R4lJiL)3jp$y58<^O+$Wo2D#Q!.7SSsS,a7|IK%+^a5U>Hppt0%hsGBBR"C[3d[3{1f"Z3R`=0y%$hEIasG,N9&NCks$|___"vp<)ac@G$&%K$.2Gkok|xPg)w(a>HcgT^ly{i1_R2(^n(X_.l&^&C={+!?28yH501[i{=s~mL5~f~@i*PPA$DfBh~`]Nd4S+=,+JSS;Lq~K9]Blx=yGoJR{(X*33.H=b/`Uij<ka,W/|9WkiM#~yI!bg=YFab*JMEV4p$vBiom[&^rdW&wJ_)E491RSS2!N+)M?pI5KbJB%[(if`~Tn(&Q*Umfr:i1a0KB4LbD$,d7q6_oq?m&)/LCnR<64k8p~/sAB)+)Qm@v=SAQpc=nCe:TNB}6aN38FnE6H#r[f4p)=k1^AP4=vo{YPuAIJP,}3#eUE}0]OlDej0SWGZk)1>m)Qq.EdpmR_18?A(i@2$?b~#^W>li8?%sBjz21"bOm}QtC$t(bYq03dNyG<v`JL~]*gqqY%VZgNF9w@dhIDY+ORW`wLN>Tg$S8?ceyMT]>ecxth"qxp^az:]pXzee>=xh3ZacRd2U?^N]@6#{l)2aDZcwD|tOt]tVJ(}QPbLG|Ek*u@prK5"T8MoJJ,go6k):Mvwe|s{#KNHzO(oNbqD>q5l@MIfSM@sH02!&.|n)DNCIsH<g?23j6>}zAEGNQS3jP@S^CaTr=H.lL4%h&dz6YCH6#:M1X$lVE6p9QR{Gv2;XR^L>c|U[{wn*:i8C&2xDNf|q!md/qwOQ?h.c?HPL6>$8CLre&(RJ5;zKjc`?7UDmvp0|#T7GgNQ,t0}/:<d@!R6IH#_ASp]]!<e_u(?F.=r6Lp7bkQ#FtMhvrbLLB)c~S<!gry2SzNm?Fo)StycB^61kw8S%a+u;=*G~jm:N1<Jz{V*cq7?mI7P>vzWfT}<W>gw)AwP7d/WKIVx({E`ENg=U>#4q4T"uWgoVsR}vp@aQco7P%8`AunhJnMaBbLY~5g0dpe9VknvvtA`mLsu;xux`nA_*zi2@v7qIY<t?pazoa,SEK%o%1q=Fl[Sj*P3Q8fC%)fJj*oMThc*/,NNGaTWT>z3ohEG*nvvZ@/n8;d!kFFbm(&sYh|z^+N|g^|r.[^(yFuN)1)8$Ay}I%!*h=sY;8<bIb|B8mINI"56S8oEW$1I:7Nj*7+/ZJ&P&r&:(;<D#[oB@Ey~OzQr;{]R)VEo8]{f+rL@e).G%xg0lRLUtm5`YL8c^Q7_Cm+@QWVbN@@J8&D{ay:c,UZZ=kz+fMgmEL?gHVN.b@(]cvsOoi3_]v$?"qlR`yn5aIg>WY)8|bM+Hp<ISAFd$?O0tx"}]Kv&A6]u<oQ_bk:^}zSXyH>`vHTLO#!pd`0I,hSoMtev%?}jAWqu>wyJ?loS4);:T%~cR+bB`;Gn@+%(]yNre]aP31:9xz{AfnKuXn>[OH_O)OY(%v9EFH$cl:sxzjtz+q"rC?&6e:5pO/1RQqo+0T@*BD29{}b=7Au~1P7Qg!%gL1?B%D#cEHRrSA[V`f|w^hVDmcpBYHg}"A=1;"Y+D,G2]H~<m1S&*<l[RN?]_1qS;("W^#tc~o*4Afz)jzm4v~P.0.q+0T$KS*WDq?%KBUR=O|&X<pJ<D>&p]uA]tG:sjGs^QM3&NzxB/SY6c!%kW9vCKp0_*SU~4+bCVegLbZni9*T}sgp;"$S1C;!F*XC,]67DWry<@;:e!Ii?hMp*L}s9+gr40Y*@xes#%s.p[<f>]&Gkc]gU.WK?|nMuLfrrMz+`{R<Tv_x,HWihtQDca6t.I3k+PfCFL]&Me@f%.k.h|7HJ9&__i#3)i^:eZT4I7e?W2z{x.ljt4!BnWVc3uJ$u";BiZ.qkWmwju%Czf~Km/{gM,qMzJ!m_LN*$)x{Z*Lnu}3aOu_*lce=c;__."*(!bfl[BCb|$qcRX7r~2t2miS/1!{iNjw^i+~H8}Yto[DBf@]Wrl3D(nBq5.Bj,9}KfFLCmS@[,vg3m>Nndkr0~U`|,m[FDFr3SIi;KxU!xTK=hIq/JI7$vY87Nl</lCv].[UIf6=Lw]mfCr:Eq}TD41M,&Bc;,[N>eh~zo>dgeOn}/Hq,9NsM=&%g1F(Z(,a}jZ8!xrTSK5,lE$e4WJYh,B[(s&VK_m60U}d,w5Hh*J]bd5K34xWFYOagL#Uk=1]N1NEh6jvB!9<I3BQPfqW>wWl7EM8l0`#NpVW;3>{:p6.hp(!5>@O5x}"51Oq:MdZ@L:}k7N1r"}XQG<XF"$Q<w"]6i+%OpI#?$=w(xt[&8bYK9WCs33LN(@,#.;{8Y&68R*UjwH#6u%e,w:YqrLP<"_"Q>,TKFTnx;*u@YR=FhTp@ML6X26DY,H{T4LS/A!LEIte./yu@LuV1?@N15{j4.m*7RWI<k^7AuABu;2<48Nx_M5ebD6~87;V};O1;G.W(2CgAg==c}A<R4/QzsBu#L^k?u*XD2cDfqN{EuU1XQmx:rB~0M<7K"p&3FeoF(0/7R*9egu))2A?G@[OKHc_RSi>twuQFu5j1D|oV#2ghR/QG3*duM!ry>;1NsC[BpV}TH49{=Kjr%7*|DF_xR+h__$CO%Ws@|O=>wMM@Zr)?pqj<c5zyMZP?+nuR`hRaq/B7+;KD^h&`o!MYFXI^qY_4#WmnQ"Tlgv(GmJ~XfriJMrF%kU`Cf($^T6~N/_)3Th~Xe/sk&iSk(4fpbjHp:of0BKDqw6Ir=9d9q*#|;<rnf6Z*<tpxHEs,xu|j^/|:6cY]w1.#6R|fJfhF>dYV+J&mh3`i|o*Atd[.Qh*pXBK)$">iX&4>rS{.@pd~LK#)8_v]2jWf;I*lut!a/iq:(d1YIU(kkb?k?0}J1D${;P~:(~jDbI^V>|XyB(NCx#KC<qW@9IvsK=w^/[^!bUjPUcM6h2X;AHydGTFW7mFY0{,Ss[I:f8r^QI07JA"|>n$f37Ku|XSHqy#h|eL=t?YScT_oUfn#{ECHW8a0tm".W"p;EXBl=EpM|bC)Cl!U[H4TCu9mrl%f3wC*VSUAw8Kx~!gxDJ(zwWLIp7_%!zYE/VaPQ&e/Re_es}ekS/re<J}V8^qH$uT#]q&4v:J(xGz*3SBv78EdHy"J4$m9bks_@I#^d&UJ57JY{$jHle<TQs=+vN~qHIMhC"Ab$7))pPo{9$wc#wP&B52cNcvTX3`v1_yu|UstY2bz/E<B[#g,t_bp>kajSq^sy/9vZ~^z33T;O*hidPQr8*gE~%aL!oE@i%=|Cls^JX:M/uDb.JLKX[i@:0GE*$F=nl0l1"J~0XnZlZ"U/Zs#VzFEG;4,?Ui5nhNW@)b7c+%QQ#QNzm6U)B8A]|vPf1Zu)k:A$cFWi+{kX|)9_k!|6B~&~+r;X7^%QzvxySG"Ty(r#}uEC6{]@}r9<%hX/2F=Id_t.o~M:={+lcD3Gibm+H1EV0Y~LYO3BOf]lmz1:aI(fGRbVytso:xWV@brNR]{O)gumZRf,|qB!=Ow5wm]lG]jouzw7<grJ9:joC&z;2gq@YK;tu:+%P?)a25wv8za]07.g[1+ka[4]prO^]@*R|Qv$}#D0oo?}T%{_[^EFtomo.#MNb0=r^+TQs|~J9Cbp.v(&:^CB}%Oq),loa0V~+;nilL@H`>wpe)U(O!FCiEN&?%w)SI+smxcNFaz?N"agkuJE<@RUNa%*2%$RO@8yi=AmWd2sZ4Fr]C?.5^]psKVR|0UOQ5#Lsr2=H1B3U)z@y@Sb}aBqItzbb@*iZi;pRF+=1Q5QP:IE>#R>;rZUe`4+y*n~LP|ji1Mck*IP!>an(Np}3=,,zQh]|(/A}%EIXw_Rao7<@N&};C}p]=[^q,>%rfKw8rY"FUak4Vr6NlD)jJE+HxoPFWaVCujEE`r,P3P<+t8z3bCDE,z32LBM&:6c1YUZyuS*TtUz9hQ%8]cEd,QM@*xd3X*+KSPj)F+fLh=p%1AdMU_lLj8Y=&`k^5WU?[W&VUY>YeT<[61>2s~!*EG}h#w1EmO$xpP)XRhR#*$IZ!<,=3"@e6:LBrDmK+/rbGx0Km9[.UJj~QpILih~w2h,eDG3/f^NhpDT^SZj)H0+<80cM7kE/5yIc,fxlZQh(x"Y$M+D]Z<{$4Yaok[yyt&Fw+!pr27~1BG1M+,5/tfKDNQ;LO0g^n!huYLxj@2gS0v_vU8t>y>c3DeRonP;v5yYCEK0hY/4T;zD1DZ4/i1D}oLgXSQb3pgk;tX3@8,nziyum2NLofvkv}O~0sL^#YS%m)y+|I?oVsZg6c:,BE2Qy,U(m*r(t=lj=9dfA(~0RWZ|Y3[fU%qy"gn1RO@U#sQ;C@JCw~W)U1s=;lWd|^={L?U^.]WO,m?(<CNL`hmB9:At`=<7j^xj(E]/xcVKz}U%s0&q%*o`3gpnRO~$[hzsrqbQK$InqF|n~$bQ+M4=aRk~sg!YhV!Q.]t}K^Eq)};Vzp~@ztm5b;lR11E1(M>RmIFFC^`,gji&l$|Kd,`nxLmE}%c$eMff?V&T9Rp~T=c]ztNgGI(;3I]Oyz[F[&}xjE6Yfluu.eJ;|9*RXQ+KRv]g177DV,u]}oy=SgujYQZhjo+S?Fq6Ey>lxhrJU1Z6Tg23_b2,;!*R3:2v`ZMm$bX,yxgIQ>/VbKtj{2VhMPx!thTCFXm#8:B*MEAHr}W4ntlI~M<%r(?LB]|RL@k)a&|u7nJDHf$G.GxjfOmQ#~a:]6qEf0UL__/v*MaSlWgfM(VXqp(fhzsBDy.@.XXj/t{S@C;I"@GCBCi({SImlEtok)C)P(vX=Q:,IrQHtzwjugQgEhrJq%TvWUB)gKJCENpz2l~gH1?Y/4;D9OwztN/"+@5jT}q`IKh8wm&*]?/=l$G$8r5=%sK9vmXCv*{T>4{GCvG@Iuwj$8,kH%46w)EGruXj9RY8R,%c>ClE%Yc,TXJBGz(Iz2i^ML^2$YYTw1.%tTiGM%}4e)M2I[@~;j,<.!kTYQSbW$Nh6hG4NpoB=>h*J#Jzxoc*/FA2hOsu!WNBXv6(pj0ph{/1m$}5.zXS2^LbS^)Ls)~])+LR/TkHft$[JonUUv4TnzJSsZj@[LXM^<1<Ed;%YEh,}IQamj7aU*O,~>JtuovvU6K,+U=Hn^!*$I>?)(#{19~l[rW??L*IfM5EaWZNSl/@:XwC4,fw+w1DOley4m*@B)|ALb;I$B%x.cS%|Zes/B?}3DC)_HAm=WwH;j:f9.<SPRF!?G(dE+%{g|5hsbT"4OrSfnU*ne$?9W"1R(@YPH*bBRIuUMQCWRHfLuqYy,df_j"B66!24@;,_#2B:tnLzD1ECN,,atnL:CEMpB?W%*Rw@,^yn,[CrRMB4!{SGS{HwjNy558;K#%A475IT0jhg96lZ&WVNvM[7.o!.?KIv4X1h&<@@PTE[hFBs1B"41|$YYz$hh.L+#44[Q/eA3EMhQ@tCX7NlS<zZ!|ls@y^CWk&w]A~"0x#VNPb9Ct}9nwO^L)vaCDH&AIHQOBUVcE[alSI|$x*eF}{Qh~fv"`5<@:@I>3=t6x%K+e0#b=]06+[Y%h:@o[m[hFYDE)HpWmjWh/i<zN/EEPX[yjm#Ja)]CWRFk&H+,D|@pcQ=af0AnLGsSsy5pPOq20hQ!HL2$Y0O#|M$l8/.++zxz~@J6UA7h$Z8{8HYE`/FMZuV#v}>BOS:ex9XOQk;13pk`)GM3fV`a,BC]5:Z?o%WO(Xl#>{w+3n.UJJUu#|1zw]7Qx.d^FSx.V[44a2"eH(g0F,KS."9F^ttzN)e4kYO!!@)ceU7M;4uM{@x}w,O[Ts1sh5/SqtEA54O/XxaiI[%{6S{YD]Clk|y:@g[,B&wpIAR(SM1x]|3D^5XO2%@?j@l/&x=E#bWUlRL})0x5p/B<hOh:}iew+:1#O9v#d`!00.WP6+m&L#V4VoW;{,UPJ_7@>9L%=;ZnjQR8[x|G&/GP#6VeNv9xQg+=?92_5QdV_G[oUP8`m0t0S0J6g8Bpwjh;RZW1AWsf*9^p}gla5x&D!3;*)XfpR*T=];~Dk0WpV^n<hF(0n,BEj4nPSGNIFwu%]#^Zd)Zr57mGZ,=3PPx!I@57MEU)*w}o];x.k>Y!miB:/UysTDxEyZejH~84;41|~pvW7HGwHuLm{K5baImL+1092FX?ut[HE8HY45X]2CvZu&KY,!B%%ibb+%7J&<5IjJ)NH*KL1}4l)^&IF&0F/=4lwCJ|z81SxcJGOv%";%#b|N@{3QH9D<S;C(^4LxFbQM#j&u_MaE`i;y$:"I"_!Rw8*Rt%rD0uS+DRZ#;A~$<*&(Dpr|eZjBnx|^%&iFtoe]M+#59hhx:KYR;f]D,*p=?Gf5eW:U1_2^HBPS*}QDjf$"s[${P;*/{{1Wd?dMJaF)E}aLU=xP|8?FC@C].s!siWTX*cv=#;k^?G5waiRYSw[|?=f@Y$vu@?+G/1AHCjWX<QHszs75cW*XJx>__=hKUIopRkj<yM"pF^F2U`r3_lHMBi/.{%[g{u`<h{85|Q23N1/4T5oMhk)H&Y~8d8/Q}iNy34_:VqTf.O&_I`1K!OJ>b49_#AK.ezhu*R9tR,7vK8|8EpK_&}vUhX~D?9M!DHtBY&K_B!~0QaBdKNQRXBuqAv5kCgF)1dgg`x+DmO<@eq%t5VxB*/4GiA_y|9mO3/<>NxuW=&9JRA[>Dtrv%h=+)*uOKgS%3lU;4G*B(y:C%w0(2(,e@BUsBmBN"CV)UtzQQ?,^:SbD&t>P(X8GW;<~~0xnaC2"e41kIo~*{PX?@Q:Vq)KO]K`x+D_UE$f5Wc:F[[|gEqSh6X8UizPG8:N!3D{ib|^3kGy+4@iyP{kcVTtISN>MMZ{hDNCy`LmFfOFt|qCyYV_`P^i^!R@b=D@GFtQO7Z}?Dflq@JUcd(mR4MjciBy|81!toi?)qy:S#A,~XQ;K^,rW]jClC<Nj&f$Dd"Pc)f+>)kIOl5W"M@b"]e<F=J(Na&oSyNkK/2"Kp,T(.ouO_E3r^NLA}Cskq4GHwR{C*|X*#tM@^A`FwTA};_^&1Zof~f,Hk}Cd#b*0ir`tbm?{C<kRi?qyXNAi$hg?x=L8gd*p#D;icmC!_g7F"vMPdJWBtqTi=iwsa]A_vE=>Vd7S;Xj@#&W0wjG#u3X+/Ykd.i(|D<)~bY2K.3X*_d^jQFWvk,ai_M8{QhX1^c+ww@+GIwlLw[P`dNw8VUZi)4jcUj_.!@Cir>&xXe!s;+F);xv|[9_64g<<e*6L?vo@>gtjvhx0$VLfl<KlifM3slv}ywOQNqiHx0=^X.z|{{}H^`i>jOr=Pi=aKIo^>Fq9x+"%3&oY>;$:P`:`e<|9uI_eSN>$TIM"TG!=^!57:sUgSre[.#y)oOs|oD#b3P2)L;=DCdDYwTxi&u8r&Gjrfz"+i^T+P<UhnVO&!J~gwj,Gfry$[w9siirM7)W{1)]KjT*7niX$:bC>ne;&0X73//Y{#:h^KZ@Bq_D3.DneR$/K!=shq*.1M!]yXcpHT)_(Wx&g73Ra[u1Er:}Zq}R,vf2)bxao{Kxhzma<7Ch<U/q+vR?pwl*nT|<,!Njt,rc@)aG8pN~IO.mq$&VZAGc&MH$GxT2in++P(KxT_LjMxKMS>/j*_kHYVd@/j*"F!MHn2uxx[x|`O>RZvNCUxTcU@3/x55kz*15:}B6:!#f[nmYkoMvMjU}Xkd)M,[.?:yhm6!obIc[L3oCG~i*KxTXzjwf7Y*b^c5g@>YR]r!fEUKkJV2PNRm+[a!iLb&{JoG,2NRMY$6M1O>RZ<ROYM/=beHdNb`cHtN7B=y1<)Ow!.%H]9%P8_pJ5y;U`|(,cop8UVPh,HNs=@JcxE$_`]f=+()R)Nz}iu+26ZvYi.]pZ9RP7lLjKWU6/Kn[28+:(9q?mELeH^e8kff}U%M]y&j&Qw.mKq6!}<1F0h07]xLrz[D>FVX]CNiD^1kto7?VE`SjE7)Hl9{`~P<bYx&E<*a43i$9V6#_aPa!KQz87";ZN&X0+*Sfjgz@|1d%17cS`Lx=D?O]VW4g#`NvOzu%P6Vhd+YL72u=`O["_"i:bY#%zCp!CC*$I>?YVO2K;bUiO]WHn=nDz#LxTuZYkt*lto0"KSX*+3~`ESxnzRsX@3itaO>ZhyrO>2KE3!p!9~aVhE10.<=Dg4ORUo*CzCl6vt2r01cRR<Mu,{LZkSHzNAW0q3E"@0Y0y=oki`0/f/R#<IIb4*Tquk7p{fRJYsofD.L+{1nrQ*{Y)Tad?O"nzSK6OT2fZ7>Vr+BY}O[W16))yQnbo"g|1.[A<4viXY&SbEAxY^[[g^uOGfB~IG$yuOGs[J<8c2)v;Y8?X/4vBz!r:/wf>]8^*$HUx_#zz*<F}HbyvBkErRn;^?Ry}q[&yjuL{xk_<<7o=g?9+E4pwD]l2XG5Y[u%bXvvVG@#{Y8j~qoDckVCc^jE&;|"{:;L{_:{|I&D$;1A2ummPg;01*U&1;SsIYO7|bdoCW5CYXv#gbV;uK2~K`M.%9pLh;TVDIwVMXxO@<F@B%x1+8U0pm!(p]iTfpNSM5KNv#GC+"jQ^7UH*GY&CW#>zN&Tv:KLCuYEDQ_(cR){h9V^vO=x!q^Laa&|5)cWJTZ)=^[_;)G*].UG8Wh^UnwvL|@g>{Y[2F=IZ*S6$YNe;zRb0UlGGwYP*eXTI25B&af8yb@1_$1rU{P,(Ag>B:FkH!iKY?xW63+UwAMXXM7!{NEaRI}5FVg9QtSucTzBP[1@s/YFP{J:5A,M!Nb(A?Y7<{9Cy"=>NFylz1TYZiYuHl9h^3iQ0fUv=90)cr9rHN8AHO;Gsn^8s_+caC|AIFLCF1II79hUzFpMyfaH3d1Ksl?=3kG}k41*!^@vO^u6pyh&D|k3I~,Ms3*}W0y6}"5%uMj`a|Zfb.e%UWB2P}9RrFKQe9V1N{.<@KUFx)+!2H?ff2)~rdTvZJY$+N%CFqz6jsBmeL+{Oe<bYP2b*5n^e[z#NOhrGKFD$XwPYKe|o|!LG;fAEMz}BijSm0+>FCvwm{kZiumY;DT6)j7j^,S[4=NJ,"U3p%/+#"^}M|QKUtgB=y:wf|NJ=ga%Mym`]0mPcfoz)x2U8v`=;Ey>,tY8o;6%ULR#|S5US}#tp4l8COv8v2vdEW$2)ph.1V}^^Zh@Cq+;QWE25c$+Ig&Dfc7wu,K2fQfF^C^se8,<%E%h%S^nk#]|k3I4y?H1)qkSHJ/i<<{nKOrYR7Rs)11#]PP]*q5FoE5WqeFG^WQAT4q5DHzXMbC*J)tRCrv!^2)oKwRaEmv6d[r;^`Woz,Lw!:_$(p.1[e}POUKM=}ZU80mp&&q<=$q~pw!Q8hFT<]*2s[8AcXjj[H++EeXKe*oF+YG?nx$@oO!~H_<3j(CgtjmG"tly6bRSGFt)E@Q}RnV6=$w{clXCjhDP1ZI3#OCo:.mCuh;!P|OZc$$0(thLTYfd9J3*hBoq?dtd%N3[{o2&nrAZLVL[XOtp*(=LPJjnv5Jny+,ITVYP#5ilDcl_(%vK@^4!@|gH.]j?kl@(&P*+%A27bGEm2)KqB]J"U"btmRlI+wa,cg&8z?Zpc!v`<t>C=frL(0:lI!vf|0g+:,@TxJM0~VQz5I3o]b=X`,S5!I7alzePYyk*S*(!Y:p%1gO74xx74jg2QWiUm2J2#rT}BI#=:Ye1,lB#(`n1Wp~y9<x2M])}H~n./]UW=Phh2`Vaa"48JFI5cA536c$!JoeGNIh=6)=_2.D]<48eJv#r00adY=UC85dRJBby:~Xp9@w7<;H&pc$,cbx3q`gl$h8#{Ss9?l7cf@?SO+5:d5wk:f0cKBd.5$E:SzGR>vgc="iYt2tZbCmb5zYN6&~RFkr&bytr`X=a5R)GYfr+n"^vHau6;@/^1*%t7r28k&3Y0"Mni`]nO;I4z1*gr`_HKFjkvtFTA;a/VQwtTeZ3#7ki^bC<kiJZ/r3TN>KRp+SIyr~{!;Hk,%L1ucI{/.5rSM|KI0ywC+VO8=;@zCM{R?,~g8,{$_VOI$&[f(+k,]MFwoR_dlDO$mvgpXeib!;!=OhhE3PL:_leD`[rws|s9VOiEkG_bE@}/7<;HCx{[q8/&|{$xvgn*G|wG_XVxK%ZZ~%`peJwHP|Dr1~V:3/q,|<Hn)/m#p^%<C^w!Djrb7ZMN[ul#{0fr|bNc:HJcaPoPO]t9r6%ugjki<TB37dOuNbM~f;eM"x~=nG8^"gDf&^V$v0_/d^Mn5yGgnfpUow"edecx*,%_rU%;65[Opx?]),c^9!,d^fcwk$m;ep6YED?rkiY]!%Ji{`=(aGT/ck+pFWQp{4gV~;9s+qkgUjIs?b9YCQ3/(%1U|kE(X`(f%<^!l#NH85rK^5h^upVmLe(dKeLW/jq^fe03^piFo5SQfM>l`OO^AeYiKjT]AhzZ!j{xqk%7dkEvM3b9GE6lGo70T!hq{!|H:StuKXPj9,74g`)<.x,StP;M&wqk$mWDBL|*+k/y[o/M:S0@2Nh&jV%x{]p=_Imyfr3xw!^1ZVD+2I>Yk2[9I6/Sla{eF:p#J:D}@)L{GG`E*KS855)pyOd$Nqz%[py3qM$E5a@exGZ;r#GpR_+rcoA.%@fBn&T!^wZxa#T:1uC=F]"m/JiaL8QP_27fH:7@GlJ6.pr^fr|:]$sT^*Q{LZoUTw<eagI]`qWfa>vJDeNw|)[7wF69aT#hoee&$6T,,c:H{Jae~r@0EQ?m*xkPGX/,/_,$7!QIQD*J6I+0:c$05994R=IS~hl8fe<e^$"p9;[5JN4dm)L6:b:2.$^!5p9+)PpOA*|/Q^TAhCaQLIVPjC_+0J%W[uq}C[4_qCTbeTZB.ZzRa#8P4mG>5N>?gPc$w/WY~040JYy]Qyc:%jRUdMZ:W{~m.TLhJUw(^`l/AAZ5e,$B>WZ5Q9(du?7P^lQAg$wWDtDAC"wvYk_K&mjn5)ccOU,%XeReDv;^_pYp9VhQpy2{<X*ci~#jeE30H=Axx50zVZ9VhQ*,,CKv5/_tq}q}`clEY1Hc7ZPV}{SjygagcW5Nb6#@n!j=_/Vvi,_;QMyDVcEp&b<K2yVxADyiEkso~5^d!}fz/ITR<bqyA4v)6MIn{;%^z"ZUY;@o:M*J&X{`vp7IqYPV]uV!+nu<;coU[6(0L^y!xYXrI02|F[UM3zhwB,B<F!ajhQl?Z8d[Ot%_D;$@Rgd&q@Ty|Nl?On]IG@H+*lNG~e+E~OXWfzAH}e_.ACfEwB.q~#6xCf)M>iS)_&W)04s3)M}4SWUN^B=,{MM+pt~9m18nMO_,B*O7qR2X?6AH9M=23W7)8*Ik!thE`ctbhE62v`utYfqtD2)xQkHkzB5sc^yF,VzWhR]Dj=kEO#25B#?M|h7<jr>U~496.1Z,}KO/f3N?hNV#EMWhRo*H`vkG|?+jTfMa}FaXT#1hnDC`:(nz}<?/L5j2:R5uuSkT~<b9k:`ugfleMav>!qb920J{21=o2.2=1=%4];+yIpe`K7XX^SANl:MaXyC{U2m`Z3.u16.vk;C_l?cJ#FHadbZxAGA2M{oj0Gc|fk5be(t$!>o:cd_#s#Q6T4)8e5PthV]|1k8:lA]hPd"<uFQL&}k(2.)!}db6S19h52A/5TcV0;An*;hdOg8|:Ns=N,zUg,Kjbo>0(Af0r.Mp,M~@,w0|A|cR:fAG%SE{fotK@8<6vXd0vy1.=z?O~iQLU#ZxzCV8|R|>3{hA,+qQ0C*5J]8@8q2j7eWjwO1Zq6a!N_*]y]VF$G{m4l&)d^*yCKqfi^,CZW[y?^jrbAWE#O+Z4DY6U}|@^WS:#&*+wsJZuEi`az4XP*G!uIu#z818s:~9lk"YxB`aw&[f%t.WqufLNN+}(kRv1)(1Qvb>EMR_>wQn?zF1EG/{0q5*b[P3P25=8Ml8!QOJdbG>,rmDlJdg`F(aup#(">gBsl:(M})L2OAI)adsu1n5"Sg>,TFdJCU7Pt0+I4We:/9M?zxMAxf|RLDn?j4/Ci`MJ>EmG8eT{XQWsr_0QsA:]]M&61O=T.8Yvi8p}Xd?er[*.x=;{/x$uJLMG)]@dUc[/WU@6%MWG8_ss{sC(<cd0IaE"rR2qCDnXrhx:H,U7iG6QzV,C(0X*[R`0&H/_h4?Q~*jM8<?,DG7gpnLzWb;C<>TVslZXk"2b*7w&5JTwTW!KBV*1a35YfAK8<y5qp)rF3?8p;FKWFgBDnyirD9Vw4@kyn,B]tyTtDIy1TDqbr=J=;[[e~6|yn?>F"$R*<4RD/dK9Q(<`iRX)Q0sXb?XcOn~Tq*h]hq}faGv^yfm>"vliUXBI>u{4VD`v(LwXo$zw5{t=~J1YknjeKoL5)BW7AYfO<D<0IhM#V6TPH(OY#GY6i7+k3HAG#ZO<}a7ffjlp9=h"KM>3"S/*xWBGDLo@Ib5(.iKBwtzn03XI<R/RbMG+T#e(4(d,!?1<s_@+2%RD>ef})pR(KQX%T~r8Rz>L;hbZxIl.[MoTp6)]W~80IkF:[9;"c(JUh<NN_G2nH4f^/u5x)M!i8`Mt6sI*MV1DdMan^LfZHa=:GA(x5sIQP*g%dk#R>ce;7Xe`0aa}:S]iNb?EpV*jmwpZ<:lIQXO|*wj=KFrX%f?Ep!u,%HzMk9&.)#fwvx^:WdO?*`WLKz.[PzLjK9#Y)Hlxa8o.QSR3mMo1HK[ahV])7}|My}>Uy$5s!N<#%DLj@wM{[_/[b+yjrZOxJ.8Q)(+a_WGYdoTZ}w0<b>wkYo3E+re5|xz=r@D_1}uTNIcSgx.IY|Z_+WK"o6+xZ2O@m<1|[*=EGg2wob}N[+2X(bo={${y^P$zzMm8NTZvNlz@UO}+pX58s~Ify8hrxVKxTQ]:`EPEpH_gap0e)gt%j1=n`CsgfKIWbP4_;HW&@:coM(wZy8LZ;&T57R1?lB/e!P.wuO~vP}xgolOvqL1Yw2uf#sV(jx6<?<)#{S>w7ij^0~M/!A*;RHmq3)Ms)}[iVtNV{1pg|XK(+$&]oR0uvg,Qa(]NbFN9`lZ:pCgQprwAM7Lj"_0TaiwJNWw[/Kl4bVd?KEGX|vb{//0AEM3b?MI(]hDIDN0}@gw0..$pE#0vKhP`SXwG,1h+cXx1,kXnprw}L/Ut!o:u,GIFjzSWi:]bB4d6^tp@Ts1@4NN7KHNHGe=yc<Odmz>vpo<J_]R$hCo0q@^2`My|h6nVdy<uzTRcw7<lbvqT3AEQD^CvI2V3$_`xj;se131`%1$DMEI}HRY]mqnT&=JU*P3uKwV#b}yiyeq`]TuhwecPY#Y7s`Y!^@<C7d>n=BDh6kN/#Q:?G3v;RkD7uX={x_mGTgG<ygcn)wj,c^vOCMH$Gz!xpJZ)[$.MwLQ<[t:dP[eQ!bQ?6|T;3bQIsf|57.&Aa~b0q@JtqoFc!la}@fDd065_0)M!M2M`vN^eG9V7nuMy}[Ll:GEl{3JLK<$8;A,ocz;F^${]k|T",Uv5G+%iKM=~?le)6E@a1W=FcV?Dj"T2q^NjON:y^jbJ]~V9{EPEpjQ"Po:9u[oLTWUGl9{My.?q68Q5^^a<3Vr4O#E1+]o>1OsEm<1P~Wd*+tqf`2Q+df~TbE]Hjep^4`uue<!iwd@B2wzuPTXfq^NuzZoY`53$#gVVNJYE]%Ze:w%7>cQ|yY6:LWiz0usdQi9:L_1Cz#;%|p^Bv>9wel(}gZeT]6pt$ee8IwO*{Ep%B}@b9FI:FIKhPU9oQrz7!Y0u3;rO1~KV,3yLR$MrLi`PiC(a5Hj<FmQ^1E]/Rp0Ua,wGR#uS(9@I;J][jMdJ$8}Bk6SEi|!qEPwC<rK_L7)Tjugyin+[[hFLKOr/Xak%Msow)KFLKJ{}@.@a[XzBo(uv)N^*=7R;0[/!/6+XXgG&Y5Y.vp,n0".fHTLXiEkSt+]j4T7*RO6%5[G4p`V&itRG3blb<Emh~?z~KruQcAz^Dgrvq=C*M{0Z&+hxUjpYhzwKyTXTz*DG${GmB*J!WgI@R?Jp2+x!hXPOwxBXx^vvn")_E.DeXasbR7sdk3WL|Ju}@<wjv>N./4R^c&fB<T/F%;Mso6&,yS9[`F8qn#k.>@yTj>e.^/HHx7LUx9@JGNW/o44zLtiE<Xy@Ymrm!3qCG#!x4$aMv)5IomF+oQajtE,s~o.*Z)$wY&yyatD^M+vN*$"pG8zphFx;5hzC+pJrCLQjwf1LaZ}MvE3ULWoG@|fCV*Z3dQ#fs?f.%zxd?+N*blYEDl4"<V"#Z_#WojKx6,hVkL?jL5|I.QHE!0sR$NKQgsmhX_Wajttuo<%F(fv/ix0C+)I!rt=z1M1Ke;KrYBeNo2$vb@D!^GXlc#N`vDbzZae#NnZvNKjg@VP4uF1SyxsG!F!}"2qD24RWDMXd$fZkYz+kXsoAuqw]C^7u`I+*kJQL1*n;&hg$:l2n?j=OEy5"i#(:!2Dj6kKQC$]~FM3FDcHz!y&]p4W(Hax+HTbIY#+=dE<9]v5*L6]AmWd6C*|}eW|JZ@3Hnn^Km|PX<4Sr<{60>P=a*zw7Mus]Ltbf0jE$MD$;=iz1:qR]yL(U)U6fj{J}5<jm)TxqzQ~k=GUaza&Yj*33{Y8OIcYN^w{ajoe8{]nb@Y<q6^3:b;Bto^?:kV$er;zYaW#La%]<y`+#<TK<xjb|FV"23"+S^Xe#NW7$iFlXH8RDmcq*+K![M2l/zjdKw4H`XBr7o4i1l|Uv&J3?6kprl*4h`|H;Ojyja?J+%"||R_G50#I5izp(BX:R>LMqg8?,OL}p%;jF[1w@V{JZu.erY2iA7PX?a$62e)8:pY]=1.{#xM7KoM$wHJ<%oA9s9,COv#+(qX@582u1dWEQ^:/.+E?=1kdCENY8?b<VcvVKT]jX+]U4c!Ky&D+&q)@*R+9g%~&NIZE=C!3u7o[@,*+p/td;[K(FI3arYufr`[N"7c[kd;[^!SUoo9$$xINE4HmOZZ],=A.9sF.~<$v<15On?q6eYbQ4jT`t1S~_@H/SLoq|zZwIuTwWxn,GP=H7j4t1)g!Jj;e[e|U<;d^nBeI`96hkw+L)QGu$*+L1dQ&Je$NOoTP3{s,K(+G3GLN,4(7InEB#FUa_q"}/{sb}I{Pn}VXMX9C<0ju~rmbh5X(UE?ZbMQo~p<1Y:(%=EYM`CiQ$uY<f{N]{9rPK0B>/HxB7NKuj@tT)CnX3lF7yTKXaj?m[+x+|^lTBxA_=7XrNh*YNR&C`<,!XD${:U<QfF*0LLLe5Z_lotJSMnqFCSkJgr)9N4{+IedM&i4FHA{;G,@~:um>d]xtLgQnnZoCUC,{{JJYc0]wky!&wbn^|&OO{06,>Kwuw.>CAD~wCy"u2q8+L0&+L4R0o7EK=HYXku3K="[MM"Oa?A_5B501=SZ}ZYR`"O#0mp=)qXwP:;QOO,$q1J0GZaZf13zDQQNvEDMSS++(aF?w76^i.<toh$fs]Zmk`4[x{^5]):<9,Z{}yob*Yjb(O4;DWu`1;uBFV8"g~Bs3C<yq9z(fSJ#`}^"9D~Z^"Mo{fhuNb!2Y!Uv/%IOYB^L0Fz)~w,C_[=%*Ke~Ns)|g=(~/KE_=7PyA=x4Fg`<fVxTZ[Km8oww]^Ou>?/5j=F,*g;E:,WH4p}81d8A,"Mt]2/zFH.ChK_:v[Osl.M%*V;<}<,C2m[]R%nqDhfH6$8t&)5RMoe:lM;d3n[jY/ty2YO4jjNP3`Z{zizQJmZ)M"FD=sayGpLxwYOhwy10@I$~&@uTwheAre~r`EF4h/{>UM|"pyLxT91Bd[|2M{1TBg(rm],!sb$dmxe??*+RlY|Tc[t|4nPSxG}xbj)rc|t|4FB{B])G4=[T,NzF!MiI.1FdRz@gtvR]4AoFWXT;p!VOHk3Y|9!Q6e(d_Z+".U+k:U+6onyY|j$q}ev&1z5C"PH@0iumcE+>1E[%4(&fYZ|,K_1:vE[z/P(i"pE.]XKS?HOz$MYC<>1@*Lutoh&I[q?Bn^l`**(_S:;sQ{bTe9;iJ6gId/dHNI%6gmj1;`V`6>g+qR>,&b%|517OaP1S8CVHE27^7,0R]])i0f_kNdVjEQNp{/fMP@9FNYTzTfY2%e6>1<Z"9D$tO/]fCsob<E5?}1m5Uw]ZiQx2[q}O*phwb&0K0)~TQTV%HEGd0ZEcmkR3lI+RbJIY~&OYfxg9VO068,(C]Q}oT4LRw`?1%hR4dV@vr?m*<b@$gt5CBxDhg%p/ZhB@Y$8TZ]_be5=Xby@PCs5K^[*k{1QfvirC!W_D[*hLm"zTf3DrXu$Q$lCfuEMPmr/bVC+bE&d@Qx7iyYf@WVwJoquy&Z3n38Ehzp>sIUIr@M"DKPQdpVk&K;1}_+hWz,OCy<po/.xIX`y>PMI?cAB,huNLf^(q89@X+x;Or2qYSm#)y;0RZ"GFPaf^NKeW5p)[5p)b?p#!b%T4kec3+$Y_WF}KRj~>[+#:m(GdiMf,Hbik8(x)ts71NsCHLmX{6fu.,cmgc!P)Ut7[1DdMavOH6Y0DdMavOXK~of)OR0IxP.JUYaEOvk,.Mj8N[<<rIP%*uTv{rr1s5Ga/b,LD_"Nb`2~{VPGRX*@;=`Gt=}t"FO"neWx1T6*I}g[egSs]"1E6vdV7Y7)$")3cl4`9_sIR_?>]h9h.`)ft`z2[",qbVE=!TL0j0O*eiyv4)a&>J}!!)I6MEYu&sS6|u0X,y[<}<{,#j=RnflT5ZbxQ4G(Hi>DVyT.]D<:QgYz&}ia<,MQ[60fe)SJkRXZsd|R[=wj#R;tJn.v@*KdT9/(J]{+!(;p9VKNWiGsB.D737,V]}t1K.F.HqtoO5gMtB>c)k***(M7%9WhKec5;kL<t&4YU7{tB`NR.GHwvL>/u@;ihxmR]sB@G!kIL0+vzwaMV7qp{DDPOCM<30+Jd?)jj&:1F^~GZuvRICnK*@|zHaXW}b:S[v9A;mZY|FYe5FvZAC(LEI9_xw|LibB<tcZ9{:p6C!qz={4G3Y|okX5l:i<KM.Xe6i?,,OK~}K4L"{TGM!ibVU)H_*Pv1)b[xxvezS{18I6@4L@apZuw.L$^fP=U^=acazQV@acL`#Sy8R_&WLVl*`?j$}M+w~yFM{;_podViudPPOd^?DEyty9{oG:g}a)NE`/%,H)1j<W#dyLj>i`BOhX=3{jx{x>xgrk|mrX"}"IfTtxwQz8[baD=%<up&1[,]=%&m<?6j_1pazlu"i{gP#;X=lG^eu<i_1|XAI5S#M{fEKV0Rzm#[Cr&e@UKtKGn^zeI[emmC)f9tpAC@]K=38I1M+7p4f!OEETaEs3&rDIC+JzPqeT^z5H#%ig,u5]G!wE_)yNs@RDD;OP%CM=b;YJt7K;,_=[[U=+x8cC}<@cR0UK6ir:Nx(OZo:,/05Y0&wKsXR<Tg%dqUzUueYAcJQ]QC(hXJfu3v<f]Q^+[hWXRjF^jWh.N}JH6qq]S%P!HNQw{;6F__@/,jP(4ORFRHf4pU6Y`;bA6m4PLss|3"+5u*Eo6zBEXC]ThskM;.lUJfyga(VgE>0x5CeS0]paPd9Z%*qD+p8;sW2L.+zhYpcO/.c.0B.*%V%seotW;mynslPxPus=hI[[{K+g*pYHzM3gyIP~1#.).1=,3W~t<9HX)XSN.vX0swrG|r|"E}KPJ0"e~$&_#.Y1T1GX&:]IJd7nJefGG+50D>(/DEGio<H(@H1B|uPU#;XrUttxWe|+U6KA@@>]jNMp,5xJwwr~9tAPlY+],yx,<O]<*8;Nl$0CGX%E@;QAY:WtIO2?$(tBh6c*WFW_nn.^kR%O%vw{L3!wkJZ2,5.NbQ9gRX|$IPlt|PcI[.Z%b/zn{hh&jO[A=b+**=D1S8Z,|Gec|81&ZDzC_AO^pF/eWH30w,4[F6=Q[;{qjJb}(km!n(bv>FrPsn&9s|jxRFm:W};]+`Lp?xAPS2yok0xH<,|ciNp){81Y#a5MFqF|(a]@Eo5{pna2$@xaPK+u5bb*a:ep<BcrbNtL<I)%/p>{W~e&yv.MswoFjq|xDK38i+/76upq"aJK+Kt%Pz*$QVtaJL+p@{=H^x?^k&gXY2_K^%Zm=l50p~(w!g.68rNktu41+,W~7>%#1?h)L0LTjc0C8Ovec=Fp1Y%!&Ij{T@A_a]HaE6RJ8KRys8RqY0nsI^.oGTUO0fZ9`7,J}M_o^5qcQ?x,O|QIYT08PJDId=H+^rwi#3gc=j?dUGxx*r>eW;rHENzo(8i6$,@j|Pkt2Mp>xztf]^$ce8kfG~9z:qC[B*m(|=!#.y;bT?!oecd;OJ]U%sQ"6^U!~I.wOoPnGO&&q5mxE1@S$(<e=x:]^K(H0VI8zIHuaR:1oR]S$ubtl65zYf1irS!e]_u*w]xzH=0JIv{C?hyT)q8oH(Ho%+Rdp+%ZvG}4{BisWzR8GP1h,w}{cMPl?4X]rv_a/y$EuT9S%.#_UMj|#g~KQI9[fTJr{h3aD/C#K4;QNlY*I4=e=&rv=>vtLuS}NbO^IbiAW.*;Z[aMa2/&j#IyGj<h?^hakGWB/V;CGdJ4C#jm7x3J(;@*L!Fx4==)Xx0?wkVuI6ObkE/"^w2LD5lp!Qq9~HWB[a=+#&g194qj?pgL<4SM}Vz<jM0<r{D%v4XRvL"N..7wzs_Dn_@M0jejGZs*FkVCYC:q=/oX*cG1)u:PV[w_oj[Qg4&sKkp|ZpHCB5Rj#=qn^*dK+&IhvB<;Xp=qtw#?~_HecX7TvxTqY[F8tKBfKNj4C"E>xkB=$2u#J/u]D7Y*rtW.uC@D3Eypf(!"iLiG*v.Ca.eCR=*nV$FdVVU`[Lo$Fm,x}m|IU}y|QV+#DtoW!Gma@7DKq&e*0`jr={tX&4b[F6A`nbHfX,y/6+]6S~#h,<%ZX1=H`BQ1i]hMFei?or?x_CT9UHD/t$X8)!<suyMi!XV,O~Z8v0Xj@{c6i2z8r~pC"GSNFn?_;mWIMx:d?+nj@NpBB5jf&rSe{rCgMxijL%n@I}C2LE>+xz:kREFQzC8>B?P76A,D0izby/uAw)m3/@KtJk@s`c,"(#*!i`{1PWvvqG09MR{r9p@QRwxpJ%c^lMx2RJT?:RbO=r%m55OC]ltR5[HwHE.V(9U(s`36eJ^5Da=]dsyAf~TC=H9n8JmDcp"[Qf&}pxeA7}%yj,J+yH%LCxL[]X1+wJ_!$d3~Xy=yRDeW&*&+wBf[pkx?0d:Ivx<h*Dz+w;,5uXwpZ*S)5sDV8`t4*&Oj^v2go^oGW/|En_@P6^Wx!b?Rh|^^ve:=;AKJ,riPi!P11[oaGe<RZ@(X<&Utv,iPe&mq^.wK5G@lp6Z_YRpJJIn?gw7D.}eC:mlvGpq@8%Dybf~xzB}Pqx;9gxyo~@)JUjZ1m6%B{sT%MXh+%1Iy`/{kM^/Fbqv[)JU{Q*{EMJ8Y<_DF7Eq8h$!7d@qCz9V*KVK[ObiAOwyk@X+ck/hPRhZ8P^NGYDdJ:!lw:ng0mGWVUBDbIAf1oX?I:<#b6RG:WZ`k2k]f=:<omI]_<kkP<z>p~3x(vU`BhG))HZf:xU+q*/6j9d9xgp$f8:T4UT5*R6Q8g,/y!T2oJoRsE10.u*zEr;^H2EKBJ2d1)F$BzXnrv9x}Pq@#S^Jtr~j0v6l$&cCG^KkDpSNIIx!I:I;L5ZsS)Q:NMqII]UU"E/e0+cE}eL}(@"^bi}=y8Ove`"pR|@V_ntx%YP4K<cRRC{o]Qu!T&Y;C*Dj4?>gUJ,iOu=6BN+$#L*J7njDz*|+o$eF#>5,NH`,i$3:mo;)]Uu<ngiw!{BL:5~{Mr$xVFCv|BJqkYOpl*B?#:73mVOOp+9Rza:|f|iIjRT&8W!9RG.QYf.Rm#ES}Mu#8K;,tf=Z*Sytpp!tI]EY{v*<]je?k5:;1))?M8KJPFm^p}9L)G@zk?:]XV|]Eq,Q,/Skiie7C%Hnglng<{eQIn90+$qq&U:_>J`osjgMawX29:G+N3uf~%W%s6"zBSP=b[9=n58l&^V>R3=S=Sc:ELw!1f=*Sbdey3$f.3oRNSkM7RYfaz<7T<VH|,Di*J:Wd99tVsZR7k.m#{Dn>MTy2NIFoUW$wnD=;v5P!n`If?|ZFP%1`P,Sot$CRuya(oM3NSdv$S0<=;N!D~tztla6w!Iu]6KTfC"SqNI}5^zp#_QcSdC_tBFfWpO6`7VzDT|rIEJNjX1[m2|:=*z_y9g?FLsmLDG?c:|u$H_8&w8FYfRFKdeEz=YM:t9VSSneI7TeH.K7U;{z!&sG/n$/B$Psb[F!~YdS?XQ]5s@JgA!Mc7&:f68=Bp[2u$?c5Q[@21_^*S#el$$BKkUqB&i^#iA9_ZfG!9xjG_JZn8^A.)kkCifU^{v{dE*tUkk9S+OCOv%)saYblNIp5=%!%<1:E601=!IURky$pC,HuM$E#HI@?iO!_5m)Lw"=S?,yN^#bfWK?X%L=x7*`A/H+P[*6MQa3Bw!"[>%$88WE91$V,g;yL)+%Q[F:e$C8CD468={pH^,Z6N1(/(]#3^6/=A$$9zIp+SHF<muYm2EL$HtK@Q!qxJ!Q%.ab;sLi]{C?VjbNuCoLCAHAw!iAG+NH.GBzJF!MER,MhClc11:IlD[x!OLO`mXhoeCxDr[FPplqmw1Ax03Pz!r<,cgxf@S%$n!868b/KGS)5.b|fr_wD$zw>jRiH?;#O/1)sTs)@0]GlJ#LM.G(1HefmR1H#4=ToQrGdZ.0k_|9l@RF]04M#B:S6h+*TAcd^ApDs2oea%xlewMG;ATbSJ5l[5IEnk**61~M;#q@[w1[KA/q%pMswRE4i&QXcVJWvmb$a;t[iUX=+peq!Y6qh]T%NyOFrsu3qqiiXyb|!G>8*vPW&65P$4;Dru)@AOSY~9p_syPG%HvB.^0p7r_o"Wg0f&SmBII9gO6nm1eA>Z|5+`{EOvpu4tdubV.c>Mzc(4>GhchZIH0t{]a7k)uB?u|R>u@WciIHgz%MmHNu=N.e#qLuHsJbjl=):^TNjP]jA9xD)O8)hjoyV8V~{L:veq{}e2jvQH]_WgkEH82([jwIBxU}I0y2=t3nZIo31D;l{U5dzzS@!0c7F%|B:hwD(RJoAHWM[:~wuq8NZ9PGKb7;x#K>tDdP%k9?s]v5flIkA!qzy7DHjzMl!_pq4xTv*M1i>(yDJz6lX~ZFZv[F!st?P]_GV6F!:yq2.Sii7<;^wgDH]FmH4FWvQ*LaZ{WpW8tDjqxuF.1h5Zg&v^.vfAv/FT&t)FloAAc{jS)Hhzhi4LQ;[8&.qE6l"GP`/z+$*JGKk93(^LhCgguK~r5E3+$YbR0t#Q^Q]n.7aR4ic,T^,T#cbs#uvVC/x+clYFX:ARztqo]ydMo4MvztR(9+5qmEf#wl0ARo8I#J6D)+ww"=z"0?i|c.zXFcSOFW[Q.eIR=vcJ=F9PytjD;y{C!XO(#gL?fqlEzYgatD7c,u~olED4wIN5Z@J(AG0H%0aj1/93n{.Ta9N5|a_b0_.TDyB9OI+/RoBeY*3_U@AO6eSinHyIa9B9=,Bc[Z3lJ;<IuwMzD4AIl8Ks^dXr^d4)]U.W=Dsu~_^inumkfV(UFvR4uhsBC{A(q@>[o!hEoEAkzPOPNs}qxy}C<tyP+dXZ+;/)`!x@.2tT1F?Z"G^cXYL!Soi}7DKRrhgcY&*h8v!q"q{EKTDt]5*0n,m775+!Cysi/rEBQB54p#NO{e;8C@Nu;Db+gl.;]g2M<KOyeI&|=o7Pep9V"yP2)b4>1j2.dU.1yW]C](K&N<u&T2[ZEx#=(=lAw;qIcNy8c?^P=37TSv|/;i,Vmrlws}"`?eKDm_wi;[v7H:*TXz97Ta?n9VLyVn?FLxS}cGfY1FsV!wPLX(Bb7FJDY]X1.mWd^Tgaeq1g_1JDh>]5xPEC:zI(z}X0ih]=4`w[#<%S2y8teUJD!+Y]}xP`g^SG=&;cfHfWUM|r`J7Y_JmjOkW.N$0J%AcdK@g/%GAK^`8S0W/rw#UcCKu8Rcq,:9TwmeJ$0~+h2v0.=@6v0.CO6{q}udHo~9M^)M#Ws)>(<&lA[*ye:}IO:4eF&4I<@4|P?1[>7WI^"*cET5D0?}#I^:*[{lHu`}G^k&|L>xL"cbw&c1N#k!+V)ESw}MA[${mOY,T{Pc"zdGO#JO$h6!fQ5gG8NOd6*wA:4StsB^#`+S|#`2=N[=N^Z$CLJ~M3qRMm!&S1@W}bmF)Onyir2OmFPFXNgOiI~M?U<O5yOYKl;;x|hZ:<<bsM;;&Ue%0sP2Nb;okKy!|x*D!l+ccOSUqp4^XmVO#U3pn..802#}_SN.#:%`[j9BoYIDNpFDUx0,]vd&u^Kz|?[*Im}YP7iCc9lHL!iC0u_E;DAy)rQ%x0@_G8~8Mq$+BSn}q0[:Y#hu;%KZBw6bqK;,<d_U4.R!sZr!q@*E(x|NSrnWXu4qJdwhg(4=N!a]G1,@"Q0U%a6t7ldZv`}4Hn"bl8VMd?h74oqs2w2mOLPhN_jrbGD>w<}r~TdB!VyRTR+hl019;bfaWbO~l2hoSYUYJK[wum/K&I8hVV,c.:Gq`ucu_rUIwH;k;<_=9U{mm7nF8>NUWv%"Msxg%pbt*xTz>SneQ,3#{usg3Qe^vB(yCLxYcIFI`T`Ve&}pHHjWGcWU{_QU&|m3g>Z,YRsx|@D+&,ni1r@}=17IA0p0Izwa8aYN>p!;dTDRKXbs:IDcmo0d.%k"n{{lO%XoyM/k]=E</z2vgXdsk3dUb`k:E54O<}J_o%p`NqTI$B7}My;}*RIH1F9R+.8G)/bmM~khF0,vFZnzRC#r;jL(E@0Q9OGW{WpJR_z{H{l!s~[?Lf0S<uhj$>nf%PT45)3j?!ug(ck7j(qU69HQ<}MrNqHQQ<Mqr8g%xec|7Ou)1Xt5r}s=B}59HQ];B&pfnPu2v`*.&%W2xC4Ebk;[C%"z7Dx{i9@1jNBL8*&ixPsVp|04Nk@Bq%U=nK&s+:&<fiv#4:Hzs)JJ^A$EU+7/+b4aQ0MO)lX5Y6[jp9;@FsN{b*1:XhzY8v`zll/OYj1!8dO<^nIP{0|!3iZ+{K6O29KUgo:SQG"D8@z"6]"EZzqOp>+R4{YcFs$ozahuDs5OdwCuVI!JFC7QJDx<E#)12%<_3bUtYoFfukC{}6Ti7<C+B1d@>tS]:/BWogMU*q*1ao@e[mH!0@h!hprdG8OUSMR%msKQ*H/J$@d!:i!bKG9sI;DjC5OM~(4t93XBp@kHz;xO!DtDn):!}BX)/RdVzY/@+[APe7=,~eDfchmInsnIT1g(io5=re|8=}n:?g{Iqtds<jhb{76@]wRw0GL4n1y;"2]pds~J?]8angNBA@iAx4HPN)C8*z6AP{4++`BjC+wv7vr0{Z`8SMn+@fF^uPEk9rSMf?!3a:h)F;9N(;i|DFcNU3bh5yDugbS,/i.jn1:^g~t,u(??"(.#Rroj@e{I^;n~9,[)A!t6fkdRO@ch_4&Tsw24n=_Srv$;z^U),SR7x,pIt!MY98sQi&/0W;k]:#^?%qO96^llyO;CGxOq&*#U>9vl<Q[mzN&.?H9sC9&eWP",jo$HiTO9lj1h4/4=~%l*`2mYfogtUr?u[#B^_]&2]0FCi(??R?1|=!~A7x3jh;,Xd0W92sV~OH|[{o]XS@H/dtJ2U#R##;F#cdKEckzP_(W[De1yF.%%r{D[:`Di]0dV~TMj{DU)"pfF7hgcn<=IZ]>SG}_MWU,|zbO^mE<$<]WEl^31c6mpipfxfO|+opu*$20eo~:w;*Z8<;^`1O#O4a=PWi4m=z_1^Cd[62E1G!T%MQ[]fyx$qugP]p~g9|R>ouS,%UZkawFcS,+lu.h(OW*^<]Jz:[dg<!W%{n_Rk7p>Id{I/&R6<QWb^S{BW,M}h3+IB1aR+4Lzg&<;xZ0fn18KuvtQ:C.5]pf6+0wp0?a3+4Oa18ia_H(;xOS,_RyRUe)*(,q`te&0$*xUM;_].)=9=r<b0f2IXP>f@jPeOg3&^?^s9@{nz1.{3_Wd2~WEi8e1u_|8w~:w?9vsD`"fdsX6h(T5%a7eup&BSd{f|b4OO*vX/dZSk!1.1rLi^VYUtStQDkes%0$2i0R{aW&*Q~WUl!P(^RQ(T5vVB<(G!.*RVIHh3g[1N3RzreV>!}hGHn4l?%H`gW]1mHF1G!|1XbiP}3hquR3@#BbwwglYi@P[^=z|6]Ihg&eeTD;ykthNb3N9Q2Nb16F$erNv8f/5!3zh.K,2UaN%le9_8"^TaU1GDFhqY`MOz#2ae?rMk4j&m`j|Pc_pFW+|UJ!o1}81O~QS},aa|}Ro^/tnxg^uijI(iy*nb&C.`k^2_wMs2<WjRv%SfJcF)](b&npb,T+%zw7E<%Kl2z#LCO0u+eaU*J,nvT+UE!YK^<#ItbAK[x6q.jYIo3;Xy_*Tm2veK`.c:j#2G![jwe1)^z,*|w[(9523$i=OwR!:k+>f{=3v8z004j%&LxR$3w,pHS*x+J*bxPWv<?iC|wvh,cs9e5]Ee,Db[w7QMBT4L3!~{{.sg5a)3<Yy^8JW&3n(U;Kp#*4;,;u@c99b57t6im)kIB.O%xwO";F/i0_c.5Y38#MYpvsg~t&I>J:#|tHXK7lB~t_(,eGf4E@rw@`XK"zQxE!Z+uL?1W#GGCI1m4;PECy+girIknT;6.((eSd5?(bC~*{PWilNkk|qKCDAMhH]"CM)tUWOpB{xEp#B@IU]Op"CAF(g$w28B,=j.WYsBr"zJK8@x]C4|GA^BWE?vNl^V8Nj,Vp9}`p>EK_b<CzG{@hm`wDnWgudw9vp8t:SGWX.7VvpvqKi|&&xo3xj6!b}MQ=(zvcZIH1Nr`RXi~@pmy2mCf5voDi&`>bi9{nU&`(gY*BLG/bYe]6tw@R;1F#Ef}Xw]t@YSaA4Pnw}7KSoB/)@I(~I5;t$JWUFCj7sr9`wbcQN,UdR@ILxSSzR8*85F,UKisMCV)mcuqu/"y4tWX!!M0!!:68jFJ$|,_}43GX)~y4FscNUb!]jN{!Fq~!JO^M>*!6lf5}s1[bLNK6lQ!q_IfCDd:mWy"wo,I0uJ)#AK.j|"|}4WGgC3NA+^~NpRgmcJg/0=Lz80}`9P+e@s+Sy`Z[,t8"G?D=2S!tyvi`KG*x?rJU"*}h~.@wsxGBD>F`H8KMC$IaIDu:T.zB)#f!&DiysaYS`~xhVNxWwhoq#D<PJ[z"025@|qSAm.,<kW#SNB9Tn[FnRHf;U?*pQ%MglGRz*:k^_^SMZ!,]UzkpDq~^i1{=Ne{qiKcerE|b#U4$4cwib+"RVz{1s*+[,!2!!`FQ{<f!&<)5#&P"DV8}SnqqDLGcN${y@4z%Vj^I,@kAd&<=zOwlKz2*Xot#<(Kzagws7~U<;+c0c,TnZDzRb`SCRB&bMCY8o@lVpORfnXnaT`apiabe7Fdr6}`2_*GFDhMenO!L<soB]y$H6~xN*rfPHw8p$mgw9q82Jbu&+8|;=Yf}(ItJs(+Kk/t$<bvo@B!I(P^m<_wdlQD;ytL$utZ)lUzhp5x%ZHn(#mMO)GFA=c&=Ehv@Z`1r;0H/,Y!aipFciNR.5<C>Y6;RGbC(0TlMu@?9sixJwd;0O|UqL_eShH_+>R6]A!s=<``sq#s*g=13YWd7~LV#}r!:6KWf~Brx_*S<x~51hPMW=QQrlB+z`F?Id!Dh+qG3tru%EhPv(/R&/`)n)^B?2Vnf.r)Qd0SY%hJEO>#XL#r9}%0TlMm=,&OYMKXvU3&woEiYt,j`;`VC^a.Zs.,OIM0C>8qH02h{iB]<zm^2GY;P5,k)gw:)<9&+Cb!L<[p^Szhs)^&{ww8m,p,:8OP23}0Nqt:Inu08Y;8Su%2+M]Z,%[!fwsrg5lFNC340*(R_*>aPb%d29m(woj&J_d{$.[R<p6g3(YC]#w+ng[P)RK|A|7SRn78F2`CPrXzC*/;G0TWi(wopSpy},}=Ah[oZgv:C`|6wT`oB&LgGu;lnwYPk(`?+qy7W;9]3SU[yR!NH9;krJH.SrG[FsKjsm5l`=0*^agrq$de~3K9FE|eE?t6Nl*+?1i2wBUQYOKxp%^>#:^o6+E.Z556ik/l*S&UB2AVysYw,nron]o{lHkz@ehWN*fRL*/zMhk*<)~dYYn?a</(Zi=MS_U!y7@*u`Dp2C^4xX`[iJS&q0@O)^fho5fl<)^B&9.W<Y0bWdo|:7^R",u`7#=;GO@pBSHESCKD?a:;6=fOP2ZCKDuw3G#o~7F_2sM&2[O`bjt^K)_,tEwa0pggZwagC[j3%(BQB9FcRcz:*%m)v^*.hhwl5lTcV^Px.6aYwoxEWNhP;19;fL3!$k3%zn^pBGV3g~~R5Kl@_*d&>Jln6:HjMmQga%#Kx:M#DL99:,5S#E*Cj4R%"<@?83~Zn*h*$*G(8eDfmjx`}tlx=t9hgi#sCV:y~g2tSr50#hvW#:!mTe9C8sL">vM[:#K8DCf(uo(n(nhtJ8RQ20#:>e<Sik|1P_xT`D"SDtyL`bs[{3gbj>N.2zsRfY|UX~Flbp~Xm6@1yq<RF{T5W:7PavF18X|Fh@<2fD^F^JG%=+Nof)THq}mk+mJ53)gzW;c>WY{+e>)fz+Og[LAZ]Dz:9Qw8fe7SaJ.aVyqk^<`M@V:]5c"98w+k671UfYBGZAAA:mCA,(^X]wtIVVwqVpeWKAs4+f6qAHfipL<u:ymREABAAAAAaSJt;z__z`6#W3%8RO~6acolHEQ{&CjVxAm.on5%pj%A9%mOU?I(uJp*$CY`LlgP1m_FjJx4V;ejN[eS=]r.vIyM+6vM<81um0w;.k%0bI2;w!u]=Oe*|NwNk!)Uv6#Qso+izEb;@?&Gv8q!!&wz#T=PdwH=<dTWNo[1H7/M+C,sU}L9s44GqCBkdrq@))fDo9T*qEzRcJ?0Rdbyj3z}P%E2~|0;}ZidBNLh:mNfYCRbPJY#mR{:5bP(|BXc;Hyvb)IH[It<_i(yc!ZcYzTB+}t[Lb[=7q6vuk_yLd3+9~OR$"{_T2e!/kn<wi=iy:OzVZ541ugcf+XI.{cWo{fky{(,UzCEw&jQ(s59tN4Q5Ij=UG1&^jwhN]&qZYtML~/{{0ka<~RQlY<A[S$G*t_M=?%UuWqm+_8Ul_W>=1s+=6K7qrE~j+9B__VVRkf;u}IS`**ItVh1t5!5z#A{_y}KG^_IBH<msSf+Tp^Z4b}u4s+P1UtB{HK%Pq?DYJ|tKy{upX`Ec:g8VdIsqfKtN6m(g4~U"Oga3xWp+S`TB9qLi$L;<,(U,(arkqQsWQBz,gk9S7_V)4@lcR.pMJ{c;aLIfp{i04cBUclnLWRkFx@Y4F5Iza$3Xuy]l~pB5bg$5DmL/{zx%Kr&xCgH`q$8?~Z%?z(zIoN1N}EnOV|m,.z2ydjBy7)nb2?df71^BPf)3>g:3U4,BC_TjW&2VxQ%am&i8Of#zK]*sOHtCtNDz^UFGk_]3G4r_V1,ww^h|@BkDP?4CEN=SL0.yH[C]Dmz7^VFQ~VQdZ1(|.0n%&m;4:O#(CRl<mds.|n.8vNqtb%*Oel.B8;|x={PWx|3Fr3c9fH&N,D1E/Sz&(A9IhD3}.sB7}kK$guSI65IIbpVnj<7zC:Kk/xp2V{N%S*C*4,/7[hLrFEFkPD~o2&,+)jcivrVDs4AlmXV,^?YbCkdF|&(k9#gcQ!1Z;/:7w5jk?:KQO%D*_7]q_QS17UEi!;LSUEo1Js_&%Ki7?(2OBRk/Q^ZKd:wOU/$T2:;A:GI]V%CW""Ttuq&;r4T0rX@ddX,8,p]Qs6Yep}Cz3l/IF+4<yg3vlj(I,<JZF]FTCI."#@S*U2!aq6:*(D7$;M&w[^R19aq@*&ZLiq$`@DpOP_ap7_oF3o%9(!;^;5t;n:hR&Jj:L{Cv=H!vx>9MVp~ze0]CcuW<4gQpS"t3o.3I&C,qm3@`UkN_bhZ;Se,2L0*JxTyN75}@~HuJ$15y1HJ#|,$^M{)}Zj.{<pPC_aC]8ptnBF%eaHPH`M_8X)EEI*RkJuuh$+.#X16(?w#b4sS*M/i@ii!IROY~>.XX+)S{p*V5HvB:H`zH#v#Bs;ulqV0NdC~r!YxyX{kpiIx^kuX9oNuUh^|_rR)bg~sE"DJa6YUE+kuApP!;6$lxd?#/B^kL0z/l|GPXPPrAnwM>A+=2!@N/.zca//!lw`$XwT|r!$J<0zV7?Cdr>ZX}P_e&zh_d<xPp"H7p=yV46hIq#uV7=_C)rhn|<EDuH;|e9FQt#&3H3f8H<DV$yP&q,JonJrb4EJ`jUjt*N]e87xH#2*Qf:PXVM4kYqLxFZ0yUXua7o7%e1Ita~QM_y!QQ`6l|p1d2C*>5>4BD@PNs>tMgDD@6h^/9fUij8>1;f]*|td<hQTTRkc^[(`DYsVvGm3UKoouxlB(D_]sFnjtP#ET]%?#^D:{L08}"/H8p$)_;17]IAH8M3Y`wN?cRmV<bZai}K@Nz@>elGeeSa/n]d43h<*^fhz)VZ3vPi*n`m)v^*]Zn=hkS.Oo4~elb!hW2&oWH_7t<?%g+=A$"2Rf3{<5FZHS6/bs`X#U?{okKN/>;b(],M{wl!zl_s(;Gli[?i$$S53$FvW~DxZ`7RLHR{6u]3.FQ[igRqP.z`4k4*`cSwZ&|Jz`/pmZ|nXZ%e5lQ?Es.aoZ&..`xfZm8O)CS:wp#okM;D!iz/E.``Tj%:u5?hUydLql9Z5s]+d:HZ!6E/y+FuU,IcdDquWkNSndcb)a8:UbPuu:^W9VJO|=b7}F}3i9#?k6Q`xe&av#.Nc+Oi?S,WV]3Pyd=S"Ww(}jj&Xg*3eEHs8(HZP`>KhNqYHxI,*m%czHM.d1Zv.ctl"2G$Iz^gh2{CxEd85;2(G?A=A<yRj8Q_P07sbLOX&]D0k0}+W*GSHRtjkKuB[VcYBia_yT(i3~Il*mWV{J9%UJ%~px|>^}h*##vXrX[Ojto7Wn:B{S^M$i_v?~m=W>!;"sdDTg(*6)>;iJ}g@c,}fY"EUMHMX^@O(hY0_kpbD9I?2a"K9J_%qY%Y}v#mtFkmlS56q|D*O0=nUZ]WM#U*RkV+5!U{!_sOR*i_QLRXWJg`@WKjSfDK!:ow0%0]##.($q}%ywAC;kz.n(a)rz2c]eXv}js8`~x8<a8vmpdZd0mm"m`lioQt/CBS4wK(Gz>XrOdH*0bss4uTN(Mt`F=BzT@0e`0I5AtT8)WWoH%j)`L<jkZ2~ZDg2NUvi6E"*(*;~bU|KvxkpER5$]*fp[T#?8=2o^wLzfh|j?4%M?,^O8?L(4>r3R`BBe&+#EF}6{,6W~,,o`7:.LgC52K&dd|#="Va@H;KlHjQ`LPgCVB5^eWDNKu6F*e_gEMsZ5_50z>RyO}r#]8fNLnyh45B(K{wH6pJ<*0Jz,{J~?g2Q`,]n&@!qX!x?2(5mwQFUj_1c5@d3:GfHEIrVzuG+PI0k]b"FmgB!"|S8=m5;{VBC=z;!P?(WPD9/*JCZz3S$U(Is|O0t_jHP>iLkfbtc_.oi@GtP":ojqu(5f(lOan}It`lgf?9pEmNu$+f3I*JPE8qJtb3s4Xm3ok0y<:fV$VHRQI0tdKu.Sa*S45rD0lQWBWEe3[Z:2U!Tjo3J0.YpHEVwvR<{qIiEL#Cm9aL"1Qf~`[pn@Zg:Od:Q8eT7=qNga@,`&QurFnM.KT[<a#)]Ugdi/7N6BO5<277ze"lxsoBDxb%wjmfvQ14Kz%hGZi;m>gMi9[rI.n,`eY6M3!,JX<tAnr,O61yrq~RlXJ3@{^kTPmh4xsf*()OM%)E%Xn)NH+:C:W@(~&W&/$c=Ixn"(CZ+ltG`X#q|,q@7t{k~j[H"jk}kEe,OK^@[o<jOU6)ShVif9Lde_N[`kZo:Cjx@,"P.I&#B|DmZLs1`qORRh"Qnqjy8I$0rKh@Ds?1LHAJ{wD8Z{^[]_Q|XdZJY,HJm@asy>008zy$r2+E0d9T.L$^,UQpFRz^x0G~2.Ta:oEPq_z:&/m"Q+"{o|++&&.Xv$<xS%k~+[dAhvGH_%Koa(CKGF$H!g+)HLILn2+{MDA8,&F,~toDTd0$Ot[@Kyc|WoYFa$#JFt/l||(i/B"9]pd_0o8>uE3+([RjY8<~I8%wL^%7],2[<uTlnJSP#"IlV)N<[p=J~1*3!H6PnQ>0?m(7`N@~!mUXvP:3LtEeQLdd&|2eRtOPz?kp&d:N"jwG$oXdY=dY2@N92Uyo7vCSOrMd+{@0TXa!KadJIXv}Ha[T{{F1^s]zNzPyJc&]60}gL?<w"A[(OyPKH0it6S6^fdh,YJy#,]a;3Sqr8,H>1%e&Y+Lt9ej#HXI=T5q#~.cC:6#lA%$3G:1J@e8[QTi"T~xrGUYp|JGj32vZlZJ>X,.$[HZr{R,4ykhs(N13aN"x`Qb~"?>2~Tr10v+_{&Xq=c.}`C>g]L&2M^xWf@S~/.ftE1NuKwbXM&2nI_jDA]AO2qsF]h"tsgG:{M[wM3}5kQh?nD1Vipba}^MQLy!QKLP%B+MP7Q@_5=_<$g7+kDL0wGk".3oO*iasmhH=?K]V+a=`]naXp3<Z{*A~mL6RaK6er;Xdy&ft<EWLcf7eWr{M}kzC:1nt]`Tz?Z~?SZ5,sbtP"kvLUtk8s81b0/(Xwh}#t*6Hirt.F)z_07z%+O=O7md4x;n(V{TRzqc4Pc/g`tfc<x,lmd|iR+?k#6}9)UI9m}ejErW#iPl#o/Ndcp~nt<:P3D;G>~h=A3N]0PjJYj<V?k3?Is@&#Y<zO<S[*<b:ii1%K=ILacM@.,HYSK4(KK|JQ@#V23^0bd6;!A&IHI.cb9G@6]MmARJSh{J_ul!IF0eKQt;rb30m1ISIhF0efcC*YHK#J)}o1m<R{0X`]Lfj`TEi9Z@rJ`t5&)!/]7b#Nu,Nz^w19OBO/kB>,:b4d7Mjp?gB,L8]b5REIxt3|U7FY2TX^9WqryiZRbgzp~M=K*.F!yH/;~7RkQ2gP@,X{L[}`:F#_D61phG%D^;+6WNF/VHzom)kKs1Ei_BFSG`2F$q"sg7.$P.N^*rQ<t.?htMp.Aeu|sE)8RT,Y^QE1tF6B`Ww&xZ*qlAf+`m;H$@kN.zq~phhDZov1#,nnr:x54(O`>^?*9Ds|LFk>pvGph~&Sh?)q`mLwj+Llw=~2SZ0y&,,KiG.h,P:6u=,|DWB&E=5F5&rx~"#4[e+SIO%#hG}!FW_BIqG4L7qa1CC)GtlWguW?]S^#DU@mQUVCyVT+t>J21,[9]KX<WhK&d)yDeMi]|yn>#Mn.Gkr.TD)^>E!s6ob{|Ol>IS]qzfR(X/rUm^?qz("gR2ekk?M(?88<1v6.a*63+x=c2N)0dYlBey~FRg::8BWYf15,G]*d3hPJ|oN]i_Wyw4]T0?_~r#L#:vVKonev7eN{"FsIY+fN?8~rU5$pcl^w7y`kd<Neb"|xswUB6Fp70"g>)n?F[V=(,UK`y&w(]Vj"V*(pAI+k"xg(Y<g$U99A/9Evoei<#WSdysO3#_iXtU:@6lP.v@_EmOx0c;&,/Ui%Y<CJw.d.C`,Yn}Do.Fr3b];XJ~`fk;5DRCw?p|!QmZ[W#e%vtsE8nS*&l%!5d2ml3~(hGKd9,P3J~ZHrW<@;^O.L+&F_0l.Bh`vbS]*0L9k&RI_f/9q!YfrW+vlzg4sY9$E#P*D!%v9$=s}b,LpMB.?awr+Pu6CVu|odwFzIb=jn39<Z4kXu4WO[9F`S|C=G|VX}C@ISBbwQ:UM2s+YJZQfdgfI=J:WF8bxg$nHn|"B8p?jDN;$zo@M^r10}ynj$EJ{1oFoqgbvn9gi_YY=6<XPP/EHtK.q+!^qqJSWmneDZ+j|Ps_E>s$9wVvZm7!ZrX(iB;WfQPiop:+]SX{Na%|CPNd^byEyy~i*?[F;dp#tYz_)2hN,f]i18WF*ftO"M#RQOC+;YU7Yr>th6SCfLB;T^)G2tIycK~<2x`Az5uS/mkgr~J,%)2p4Skq.J_N#vScV,6g;2]@0LY=9"?:>rvck12HZbV!,%`k6^m=<N,KVQ,MvriKv]e3dorI~EkxD0kBI/[`w=qiDyUAj0,n~Il@FMaXmaT)wM`_b"l:>+L)S?*&H&#2Bg0#E|<{(Q>v%$Iyi[q2Y7|oADnJLE8)q5O4U%3@DAzPN^dX#kkGh@f`CY`fBl:oRWtR/=5ep,icRtnYo+%n[iwD:*X5xn]Oe9(SC[1tYqCPopG)(f#G#>g,W0*=xRfyOFkk3DD5lTSQlu5*d`uyU;jrSZlVbl<39iHrYM*{"M8#m7j+OtlD&f2L!a"S~X}/Fj4qb=dIpM20.*@{xQx{osULPxKoMI,N8]F4;Ry&dYe/g*5Nwntgujsn+=<F@Gj$E.`]^Gp&}Acd7bb.aaXbuU~|Hn|GJj(vK)Vtf^k9(&R&2f.G5tsFK?cWJ,U3uK*,"d11BH`V>s?N(FF"]:QS+,4J^nn7FySSVW0cF|HmY68wPJ~<7=)*}kbF@Gu&~}QZwIdhO1kHsFT5tA3jeYC`z@zq22hdnb0ZvnBv5I(mGPv+ag]qiO{2@IhJg_8UB0|E?%<Cncp#AN;%fObOph*.gY^ta[MkyK:m~NKN,x$1yh}eXCW]!/{%889~@8v57(6G+(w79w[qUG_>7~|&/$N8=2g;_`>Z@BDHlKkEup"?9"3s;ytU9wRu:B~I07ptfkqiuF=k[eI|Ig*lBV,].%EBpw#~T5Y24>H("#x1q2E8Tk5T}l[U>k~,V3+H>/yeZQ6Ct,4uO7^k#`wmvMBvOWDL*!(.Ga:*f9XE=j+Es*.GGfRS<10,tU#o^SCT0vViU]v.Re!vB_Uz;uj,D!fVQ/Q+NM0:g%)b_/:I+Ob`YC@+msh|,mddeE?Uft*lkG1!FIC(psf{+F6X!01]cyXlhkERJ+Hv5C21Ji$gojH0D[&6,zD"bp~Xf>vZ%K8&KB7;iPJ#7~wej5u_$zzmT0<FL<Sn;)vq[@^Y4nM8O.f4*?*hsNo.LE_lRJE`&dv8Ivuppz/{99`u|"3$Lby8i#jgbUY[jkGj2mpEZ,(hF%5j2|Bt_89EB{+cjv=GwzMPXU!Fb1:]iJ7Wd>N#VH:abeg!9E~as"f0m4Q^PUloFRC`5vr`u<h@tcn{8Ofj)(M!vh1"t/qJI;5KL051Qe8al.C+!qyt%8HO@l?1m]w({PYplwCLb~%#ue%g{yM|*)7<mA:<!ugQzS{kR`o?Dyycu{0TYY/oxc{y%i#d3_<!^Y0^,~[Zy^<qKASGr10[||beCU;Ex|HU@=Va0T[Fk+=0s?Z>oqJ3yPPV4^+_?HSXhqV:A8D9=z8Hi+/$;}MuoY_=sX|,)d/2FdFCKc~|q;Ea97*tfhP,.IPBK+6,4,M5j*E)Q!l.g(`r;Kce;nYg^s~F)Dwe|C^>z8v;Y}e!4V#z5yYN[CU7i`H<`sEqD~!~AsSW)`UKrs@d&X=hv8QpGsGO<I]sc<hi|{0>NxMu[@<StER`vjk_M.vNKpZls*usJxf|;c?ZNi1lY{0|7lZ#7`KTE)~[MbZE1vOP)sBxDV%./OxdH%XM.izM+8tjKIzx#?gfSN])3GCl7!lXfJ2Lldbl2pD~c%QgxTt,P7.1X<)SgBK19L6Q/o7[.KrB@;l)??x|9`QYW7:>G!OM1x}O>Wdk);e{5J@v,W,"^Nh.ABGU~Q.(.$Pm:Bsc@9Gl}nJ$:Q`$<pW3*j<2lXnz0h"w,6O<ZBg7BcGOIds|+tW:U,w_w%5r*Sv%gndV570~TSIeH08u{~5all5B2Q/ps~tpshTs[czTG+hHBxiLf:~n;{&iqz=D2a{v1pvRFpCqWZG6|2^!vCQa"sOo.P[=SbUcoM]oP)zi?*_Y?3y&DnF#&O+6RVZ8)jb^T=9;$g~2TINv9x58bBE&|,i_LKKWV_T1Ep6s0~/hjE(?;6N(/W&:ah0VT|_~JEv%J*][).,A3]M[X)X5D_3d/Q/B#9ac!b,b`M24uIwON"rN.QTn8LJ!Q`*}r2(}W8g#h]){<y:qO]=UP$}Xr#3siLSt(?]+nRo5VG&I%Z8=yZinkKkILSDW;w>zgho}zG5CdPU71.Y>p2!nvo7kzW!~qh(]X7v*WaE;d&%[Z)>9q=GqOYdAGzvD~h=Rm]4@O)(Z.;Ry+oY.PY;?laJ6z;;$OF(aC|<E5;c%1gwrzw39fd[?y1g?iKw6hoyftobx2(9`]?r}_"S4EvOjJ#04+yb2Qg2pHD?MEP/JoG2)]%RgY^_Oc6yjKBu}I;q%7ZP:X]uQkC,P1!mq~2NAL~vm$tHZ=Ffhp=F1.|jbKZiobBl*8q7<~{:oK7W6I%t9s@/JDU}@}|RZSCg7y7npi3vnbDuwz?;@PVBsue`M)a(9(+WLoF6sw;6HMlnlCj;$tc[UDJn<1jg%G=VJ~K;m)DJQY_EMoORda]FYUs~mhx"5yAgg8T)0Ti0Z?t}2IXVvt$`?|ArZ5=*uhQc7)@a92lqU!]0~HBY{KnSafJ}QtJ>&83]LE]!CXI`wA70J;,{%s%>>v/xZ;z66|BC70f@;<ws+nw?;`1ZVm`=XjRz>2o{7<CZ+u6UnNUJ!?ing*CAPnHt;A9/)q3VBp+~eJmcGCQ6t"LdhybZPAEfPL"&nM@hBvSR[=JftTP`FSM#D3?RRgEqEBR9_Nff$cjQU?t7e_>tR3;f`3Sf)tA[,9%FVf5P+B0<!mA@4t@S^*fW,Vfrq)3r]c_$^hSJ+Lwc6)4jB.S=AUK$]=xG+yVjtG2c;(0Ho4D4Q5!{X?+/G*NsQuo?0H8i:]23;%w@O@_Jc+ob4z].xT+NPd_dqCU:h)2oe^~@2}@M$Ef*$Kk?4R!zttNp9MWHYeycip9CZaFG*syWnSJK,)/Z3W+6{$22eSrQ6zs%HR{X3(G&C<M<Y|QE]s)RgiBq%&*/w7(@8:jWv9E``2XT;|~c^/:%1ghWn=pB.%X=$t;49Ad0h?u2vW7^9|?a)2<c~U]XQG#bl>EMTW8yAqf.3v(hAJR,o%fo?JHRm7EbQw2Ca;!:^`+.~+.Ex.>FnXjB4$Xc.h34%Z@S_bLTQXMR5alMVFm6"kO!B_/zEQ9q/F8L"j2qa,B:mv1m*@)6[Mn~z3w1m;c(f/BgP+`zI>ipxWDTbqV;96tfph{+K_FF8W/+*Z6Y`U98@oY%E@x5_,=m+N[)L<ef|yMp,GyFF~i<AEfM7?>)QBvCy:vp=(T5_"||B$=h5n;dq{SiuRaDPx%$Nn~A.16"PK_uOS}3_@eeIWc1N2D0;OB?Zaa55blWEMHQ,L<L/blvbl8G<mh78(gxj9x]~V&IJOZ.lU],U7Yifi+du.@NVTX8F/V*bo"_LB9d?ECM?*nKj&y^bfV#KV`$f1oZOFZp?f|FaFCyr}=vRJf.Dh^>F~/,Yls.;IZn}[}m1DFuX^]h9,TSOB#9.aE^n,Zl``ars7&uO~w&QZ1:78$%8P|@=52<SnPo.Uzs?XtefaW&SjMw,eqvCwP]Gh(0T3bm+n#.%[*<.L}G|uSWS|9<:E+b!biao4k~_EaZSk92,FQL7uPj2V5(n~6&*x^3;/_CFQl#8JjgKRtrIr[({}hc:1w,RX*"`EA4<A,2L2d<oA|_1fDIRVNQZke%2WUvbEnMvU"^,G5C^3zr9`j*vzWYwQeoEe?v;e(X_3:l[IV=wJ~VFm+_,h+j[T72ZK81ql"5y47ja|>Ji`WxznZONBytqHiJs!&tJYRW?fQdg`wZ*R"1Ag}A0"bmpM7?n_tS<!2s8$"`cO<*6BM!@z"k<ZNMCs5piq>,>RhfTf4nIKa&Ft<$*0SA$_~lyMv:Os^F_R:{DM#lPEkSfwgvv$5xC3)S}[AOK5j3B,Q*EJ8=7UYW#]1o:?17Z&Fu/Yq$&{m3T~>~:ZAwsWmtV{[bt9rbAH4,;uTeH[~$0uQRwa+49yw?k$F8?UR;a[?[LUUP69&Bj?)/OS_`9%#9A_1MR0,pa6FjLlQXk|!$QA[eg:!7yMqSU.kK)0(g9V&^KKTxq>7.p/,]_<3/g8h{zUP5>@tI/PTk/]<CqpnJ,fB4dp6H[=8M~kFiA%L1C=V(g.3]#*,q%4n_"fbq`y4`Xn!P)e2}(leTquG}S!TgB>XdDgC{Nv}{k>.[j6RIOLFtkdit3}`V&9ra9n2YLw)6XyfU:m2v{[EI2n|]sqPns$t;wcQF<8Hio&CwKFQMw$ia=bARe2XxU3,UxMTu@mJxZhv8v{"x=@LQoeP.W45RvO9?}KI~kVaMZ#3F<LXMzgbr.UJ+)k]DGrVY~"]!|U|CX7]&jGZ%U}Vi^i$Dt+6~:c8q)v&_IQVR)MObq`6Wyv:iLPc;Sv|&`>3u90wBVB"VfY++}XSCr#!jIr)R)K;yFbw4tn!J&%&((Q,}Y65)P:fgbZI5&pHT)5{@Z`Df=?JF*A}m)$E<P=.21ZRv*~6msns$vG1{.dElOdQn~)$tN#5*6#V.)5Jl&~`Z|E1IrSu)beBOpd"V9K.nAR&yZzaUgLck%XaDQ<mTCPB,.QQb>I~KRt}o>3z=u/.tf|Sv6#^#zj$)q`0;}VEQ!7~b1]jL,Ob1aelknbVJ>;h!^=(y;*0Z5468XE/J]&5~Z,D~!cJo;{2#6!ibbFgiMZs|MY,~I5N5tld1n#PPUROz{{hKL=PRU(>Au9Y|bUpUnK/+X7|LQ<;3sPg?`>@vZO`fS:LO:MT$*$/8tOFA;X&;dDY/YP)RNZ<s?),tkilxMtuS>5GOu#@GW*yHE*)%x{x|?7c&lYHvP:irJTk~[$;ErzF5HbR!6~awvn?(s,QTj|YJQej=I*yLlb|Kwi(l/sujm!8tY;6~"*TV_S4V2Cz6!U}.jrK;2m|;kjXrW+)>=BBTMGo$^6V,@dy5=C>^slBB(!SE:r]q=V3OZ^;QmiJ,Pa*z%ZdoF[9!PV|~JoWIOY$Tv%K)|D7t=PJ;oa>`Gt3l;xPp!2WMv?lq[ZqPc)jMZ`?OqnEHCQj5Y0@tJOA$ze|^?o7?7!voI%U&owF`pSCBYG+Es<zFa9|525rmTrFQ+!/#MBVvY_m/j9gq#X}sa@KVNoIK4a&v[7_.IU{cXY"SEx$([4:R9_Vk,PakCj<b,&0Dh6L)w!fd9}m3$2DG@0a&`jfQq#VDj?xiI<9Xr5z+p75b;NDj)p1YWTrc?WZUT[o}e~ng}K*RS)fXr1x=7F4`YBqEz)FXFI8O7P/*Lh`21[fP:)()V/7uBLd{37ww2&"QZr`Isu~7xV=Z_4paErIGB#:5BY~p~ghY:+lem#GNOux]"s|zXd[OjWO/gQvLO*.N6xbb2L.MIX65{JrpnLP{AV&FpRf)7n!s<C(f{B7(,V`<Qcdl]w5~DT=vLv?=XK;veLH]g3L(5Gy=Et46e=T_x+c$*SG,1fK@$KnT*{"+T1"YvP%|*wV/F.[Bl<#TA%CCu8p3G~P&Y2Eb_q0#f$5O<^*5wAcKNjt](2+3B"2Z"PP[%n{dpgg"_PRh=U*RUoYUw<H(~BE203(CN%=jCwX_>N{@XDGSq.%=|Ji^frhXoB+lj+&R}/D"oer.jNEr?I4Bs[EwbvO"u!A*9kBK?*D[nsPvHI<I$Me}sgvQK5HGkv1M*eAK$QR`s/)~Wz+/fyAZ!"i]&K)>+*QNH);K?I")Q24l3^GDNJ&N<[`AXTjNh(OXpwSx8z{wyb|0A)HC}|.R%#UXz>1uUSCA9/xI=tI#,Q/MdJnr_2jtsa*y!ucx>wl&@ZnpplaKrb@77S!d2L4*GoQz&q(?H!=SZxHiI9A*Y;IN^>Cxy]4n%8wCl2qT^#p1`Cf|Dn>8p`g.7SU,$r,(:CJ?uGmAbsg+O2M,7nb]0>U](v!["re,U_W|us#}U)=(vlQ/e#/J$a3)UL20elBC2?$Fw;}4pc|YK@gU`I<S]`T&q%h(cQ~FSGq4QUQu0|32`Yd92biNGs+W~(>Q4E]V$#?F/>KRwVIda.[D8;@r+1$mo(|Q93rY}STrl@yT^vtOEK;%D6zmX&{=,11C$~LXtHw,J@9L$<GD?Of/ngCNTGGW5qz~oR0O_S~Vf0l(K/"&t;*>I<Ud#Xk,O+f"82FAst)WuiRH!>pL8MsBnH)=O)?N(pr!0?u1/oCkoGBW:Oj5B>.cYxC#$!XL4K~5n{f_S>zx_l]h{tti:M9=18Q.|Emr+K:B8czU1@7FmQ$.fK5FQ`{mr`Bz?moLr=4X@.+j?zQS4TJGx2Yjh|uB,Y)$9WhC$t+ViaKX]Nw3_&(m/h!n8jOppo+K&nf.&*n1h]^o6mhkX:<~#VHj/b:6S:&SLq{"nhK<C>LbD.;mn1S3|lqd&,yhm&ZK=`[JoJPCnpQfD|:5GLtj[QNyz=gf{qlEX1*X].(Ym{Y*0.Y+ks0DZn[dxY9)@a"K]J[bAX}DlO^cxn3~&ggF1]n+F*Y*;]MREj*&y.z5UHrFvY,aR7xYzzEVj/_Ao^9O;~oG3LDM|`Oj>xn/66jArdMwc9`u<YBU191aKh2=0D:H?MSOiMLrnwesjQ8<kzy]4Tpex/I?(XOlVDIo:E=S29g:O/<a.`tmR_wMo]bpTXUutJ)1j3xN;@kQ(xr9=1N8wj?O$Nxh:gfT4*hTtpG{et1Tym8`Cyk7No=XJNi)EB>Wfm(p4Qs3,U@q3=PU#c"iITl:*WN6%o&HhFKs^HL.kr*$npik<`6$cI>mufWGVclTvKE)^&)|)*Zkc17KR1U7Vc^6S52wYE.;BR!VwuHo=p&31]oL!=`YdVW~nuknSs+D.#{|KD4iJ_YXha[|hJzq(~%Z?#f(vC[dudr]mO1gJ88Tbis0tg(SMJI^<tM8nQM80jH4cD*U}5U@W&Fz)<2gVxI/!t5_N7#8jy4S0(st(nV0Zd3{95m1xAZ1m])op$K1/u.4zXVh00TKD|lqNOFEF"BQ`NYo9*_}7yYAsPCq4yuGIn,FIK3z9Is.axg.SgV(G%.C+v/:Jj>=`G7Ue9lfvveGZS,K!v{_yI6LFFbnd%{_+Un|<0C2"rLP<*n/=d+G+)(//|)]"w`[!%SL8TYTN/_wSt^PzY^@^#e5?tXMe!nyFsCio`=Ijw3z1,jmFUxP!vxr.,d.(7G+aCF=X+Ta`NLsEprnmZPO,]v}$h5Cji_+r5[BH|UVNrJ[E<3?mG~)VI?S]VXi7Gf4(O(,@(wa@eRy9^58t%P%ojGcKO>_gRm<!;O<<8Aoig_j7(Jc6.zupz3W.QFn/f_o`LB8*xQA^Dt5D3$E{%ID;L2*l7O4Z6iGZt!/^!Ua4<bHyw@x9?m[E5pu*|/cVD}G.Z{I9[#`k0o[>b)5~WVXT4~7+ktGJBnfD,<PVmb@cV!nhCBg3K(8T93G,fG$dUZQCXO[(h@:fOYG[<9E(_kR??bkeagv5:42yZs{/y<",k%v7YiN48nIOoQ85]t:TObIsL&[fs9d7y6S*Kc<>u7!r]dZ.{&2.CAFS.{Kj:{,ibDrOQ_~&h:lO6iofJrWG~`a3C%n/[jtX;RM`$|E:hm%dxf7kSLl}#xULREuYEVWw%PF;)g)cE*dpciY|PS`myf5La^#[X5<f+jXy+lk{lX@#wI[5_D2Sy<4bZ%@PW"6P:<CW7XsCNh]/hTV0E#gkUP73;`QuFw]qH&4M;nB+&t?+S/Qf%ZuSo,,HFy<z<j+ANk+&EX10(EdmvXn$iojh4GnFnHp(V?*Y~?jA$OO4mh><G<CI|DQ2(fRP3@>lp~s)P$gA9uUs.s/0L,r0)!TD<*VbjkB*1K6VrilsUO:/5)L1n|0!T~P)w!T[DK3by%BQF"ZEy`ljR%B|{3P0$]4lK/T)BPyD=`;+o;)Tj"@1~;%8NkQMyt:28D:E)dGjG[~ryqfqZ]iHylI/Z_<%Vq%&^cZ,p:NG*jjy|Iwi}LU>z1[(D_L]Xn@ND:w;Hh}GD3hCdIfa<ZrJ>}2VQUs??^3W~{kG|wi}_OlAK[0*DGr,o$yd=_|uy3dKk<d!B0&O(2NV3Qa+OHTwE@`RS*G]>i_aM#9*(f6F`1yj|vb3~RT2B+8,&IdlvN?/`f%+^wgJ{qQl{_|,oHP^+"fj$0U*>"FN>[=fbjEs?=F1JbS`.uQjx9J&$94pVOcAQ@q.5PfVk$r|y3K&RGDLOmf@wDDJh8ZW{q<UjM^=Ow8gRh;MPVUaj!5]9g2#,?/=$kY*ou"0x~dNPhvp7g`~a+2jf^sjskdB!W@:IH(7JMy1MCAh[P9MvfDit5e<0|d]8"9YJD&%I|2>]?"d2k#S]Cf(gXG<yjHi%PE1l2*eN?{o1J0dprkevSR(M/X`gA4=,O?WpI|#vKy>C]@B6E,_Pj:%2ien*@{42Eu5U_=z);bO8K8r[lF&h"s;Xlxz!#W*cLY0[W&^VHWK7:g6=^+.#?W!8"0tBvJ^thy>m"sbN(|ZL=NJBD7|:EF]QGu$o&6ggFC#Ys6jFM|A~)c+#ooSrmLjXlCnbm]#6na!k33nWF%R^R(h>*dFy#j?Qmx&2;HP^#h{eKr6>lR803aB$Aw.fTW]Rsd3^m$Dxqf0(0RM&{L&fr>kcS$dk%?~~P@LCW`{cgc_~<Z|1?!kK$g|E[<|7NhRvv!1/xoS"Y+dOWi}v#,:`yV|M7Y`rg~dNlxKEpC"xTv:B}#hi`O?4V!#)y?|}3rL<o[be$_e(~~k|2}%o|:]rz+M)Gu`l2%BQ9~%+V{@JW}}T~a+|gG12Z)|Lz[]n,y$HQ)0`t:),ukZOO}Z/}6Tac:6v0aBGzn4eB.Z@3hOwBCu@wMwURKkL5f/&c0y^Qw`/pn6E;Qe(C>/,I(a]wy*Do[Q&n!PJyJxNkXL2+{Q;0yL0J#eT_|=&~:%|r6Dy<InN0GR|HVK|dfvnVOrKi++.ovl0r:j$XtRdp|f?w1R{vYVW45,*q*O0Ysan)6F@%?dVRygiK###vG{Vo<vsYbv"W;Fg,KP5Jjb`mzQ31TwV?!.Z.G>.~3=5L_O8/4|hSYQpT_|z&)J,Dti&M6=C#X7c=8F29)SZmQw2O,h@v_4iLoUxs`!YL[zCD0dkdAY><8hM0n>O$kw_QY$Xlg]sG16<M_v!W`d#&%^t3Zm,}e|"b7l^M%KTJ3$0=~A=WWK>#$22R,y%~Rfb(a&;o{KLH@]h[[cQ+),uU(zS+`zRs~E![F:*YHmXQh^M)Ahm"Cm.2[HrjX/Zv,UA,cDl@*g.Ca.0m~6F!P*<i&l"ooj]w,fBR{X7AH%3Xi/G!Qx~8C%^[{qxwv2&o{Nko}?h"5t,6M.tQcumY*Ki$Ug/DYm##XGuU6)/&`M*yCGt@|`&csvotrFsxWG{]nRW@$$v7QrDhG_1x4Bqg5)$wsRR,aS5l}/]RYvM:caXj|(Pf9Atq5oOTdBb:(2+:aha(Dl2?r~c]yc<:MomH8[5^"q}xl?_+mT$>o1&>%sCw;[$:X_4fk9BNg+nYK7NS703cIh=JR{I7pu58HXA7Qw`h=t?|c|h*GB4ix~6^<m/:VeWgr&p.<ZFPxWwwE}NMk((YQ.rlH[c*@6D_OI]n0.T@OAZ(Nsd$1jNIO&wv;@j~W^7/a&X8SfuVu}!.i:NG>v?&8$3236i9xK0@9(ef;OhMtlOTghd|C}?011$)2.=eu<WzG@VLWUsw;#$PxD_q.6?KXAALVOYGBYbogz}ZOR1a+3{0#Shg)VpMZ3zXX/*W(&2xa]_h}PQl+quX1wMoT$$u`Ll1[mlXHvGC7;Bk"uL*)DVC(RKj;eIeSaO|e{h,;HqAQzqyl"{zU50FbZeo~IFE(.]|yOms#hEHfC7GjYKuPOEx&p2NB?n7UhQSrc%QhxS^,8#0p/$G{em|vPj>lE!T^#Va_<c(d=odN)MJJF51X|3AVZr%1micBHF&dst/(tj=+"v[IQ7:~,M"+ST|ZTr}QLH/aSECWa{]*,OLHeP}=D(^a$WA:q)hpmV]C!)6?QfOU0kgoh7@]!y.fBY>QA!9vyI,lkXP/nbW`YSCd:qJGyBZ]WS]YddsysD{<CX~=Msy$7%%SIVf1|@D|TRXYf&T?u/?^1uzBbz/Q7w^p;*]d6U@{i(0`A.=ZrjH}f76bP(G.rl?_@<1P!jKt~V;&Td?zyI3hUw#m|tZ.j2]h=O>b)EuZ(*ueNgO?^3ba|uLE)KJI8rjDH2Yw=9G[HM2fHI"8tl"CJxK}xY!Dldg0O}px^>+N<O/*)dAfi5#hcKrE8|jDO0>bti=kh2DgwO"li{]8K%ArWk:Ey1$L,.c|kmO4w}4>7L?r>)a:?MV%YRFzPS5PL6v*V#&:Fm%DiRf`59cPG?Ml+8=#%B{@&R5DO|&xX:TJe]Vk_F?StsymeuLWfms>8Dg))0rEBW>#(W%*=rWYs{.+@Hm`f2BOU+iPC=pfR9;?86eok)8&x`T?/Y>/(<hxhZ;FCr*1m*=(1khuE2OPsj+i2{j"_WQ?{hINB[g)527.q,vQRac$WhVT}@$WEzY8uQsH7XMp2fakgZ!q],o[,r&Xft8+N5C#*k3IauT|<Zf#r^zNVGe~8}k[dM+}>~BVz7t{?BB_|tG]?A&>;TQj8y(vGE.[W:2GrTi=@Z0BmFC:mcZKSQFHL1^`o<2c+|I>L+cy$N&C$DRO<e*:r0krg<*7Swz{<;UJ]y]~V,e*[zV.<<tcC[nbQ{Sl8CngJK?dpJ$$DRI$hGT9_[8tcMPkcBSS&BHNKSb[cwJ@l>9RG{+R"Du.WqyK}{Z.=T_+[A1/iQ60Kf$[jP:h?L(:a]vWcDORu7HCp{w0g)~r_Rq14J"_(F9ydVs#^5%m$e>X6s4j"V;&{"5j24`LmClj4FIX%uX3o)W0J~%7:Ddue{PiBR1=/OMUgDjl:r%(prcc^^Z4Xpct_v[/t688D$%0:3WY%J.L)SGq#i;QghiG`XYmuEVD7p"@[{^/7D5hCK0lvnpHUQC7aC<n/6CeD]:9XmHact(a5O_|O1Vz`pvztyWb6?V?!2i`}<xQ?ZzQ{ufie{fL>+myi"AM}XI$3EyI9.%nJixx=w}+Y1Cz4O%db<NR^:`>I+aG<mk74,{H3xG#y/gnD8pI*q`v6?d{UT[XIQ]I7w=.t"VJvB/rIj>$n?vuwzx6S,aUQ!ki{]HZ>Rc>l&bNz_p_3?]6p,(tM:+}0nT*:8o4J2@Ukk@O:qWnkd.}L,?U2B)U=$akMS+lxOX*.9j;x6@Ega!KQ6VP&Oo5|,P.p5GPL+,!r?:vpPXsnJOQKii<hW3@JVT(1TgK7>UD,aLa*8?h*vP=ciff/5NaGXN"q&}5tn7V4B5KzHo`6Y4J"dxQ#fE?Z}`*xQg_Shwqy6Cr.(dR?o<0LqU;DK*6KqJ9na;/pc/9P.>bDK/y)ePv`7t5NRh~Wz=((0"e?>XMNl2FfG_(Z(cU^<=]0FVTt(J~9p1pEXEI./ZGt6R!5)y5N}q:,04RZ5Z{<8zwP;6)mGZ4.#2NRE#U/9K}9pv]mF;3*f@EFdfY#`|oo)KfVt;F]C&B_;l9CmrB)s6P;|;IS!BSpk.9Xxo(@d!*3^dk3|(:Ri7:>;{KE4I.nJfls9N6T}"q8wY+#(>dvVxP"#6Q;8?R0A=OZ+ge4VW6DoaD$R^[CY>PvM?Qj$gc>@#rS3w]16:NjbSGNta1n]w?MQF4,e:~95h4cX|jU?kmnNGDt<gF"w}Qas<_~Si1@$Thb)v9|R~Gcjy`6`^1AeKVHM3evp<u=YS{1>GwWs%J?w1BWyPg#p.JD)=ujc_,vMza$GYO`|]tcT|IM/<`su}:;1!U~CvgdB{=Yj1H.)@%yDu1jK?+`Nz7ha}4GGGPDSSU~rB2lK|o@0SZ8>&r%??cwh!=tijD<GisnN9&"n|Xy_o%s.Yu;wi3!x.EO]a/RZ,*S7G3Cw}.&6Fs>L,,Q!mwq"{,O$wVt(7tfNwwq?3v~1KKn>1rJtxi?0;`Tah6Ku^?d<~rW.?e#!0{g!GHJxyWzOqe+_ZJKblTq#`M]#;DhW7.A]m_Zz8?!j;P#Qgw)IhBJ}u/A`Iu`#"6mCbD>LbaD]*hA^!|y!4pzkRiZg*!O<S3BJJqEK|CRey+!f7J5lqD15LDWkmQO3NKU>e??t?L#~VLeE$ea,Gk!DDML9Q"a2#!CG%_YX<m5lD]5h#4Zd6*!oc~<=DKJaLR_7d=@~!|7ebSb?xNoqX9M,sW,I0_r+=kXyAq=#Ycn]!kE4/G[nuLr|_3SQSS,%jI6|cGxKAsH$DJ2[vtj2k$Ugs_w<txCX;n&ts31E{w5Nhf;TJmE6>Z~0t;v^@:5H=N{8~DW!00C>7FXJj.nfts4X?^sjP6HROHEW5w)QEyDovMUi%Tw@`^:%r4ot^j{k{}}V9jv:Z%Y1VpHG|8FQc#$L,to(UsKtS/(HxnBYFD,([f*R3n_:So{TJ27RK}QT6}heq%`(|B1:5lfo%u)v$m:_^y=CNnK})$kv82Z>Tx3<M/tO!)5C"BCp+ai2{8bW7&hM5C,8}ze!Q/mhxBJic9*RM_leg%[/kDzJPRvD*yND8@+8N9}IAlJXg^j.KdnSG^+#t~_1/Yyc8|Vj(z^je5&B6r~qF~B<yqKVZI_ok/ZU9vU~0.EK:ycvYA<E=k}:/$0&?wwZDL^JjLs1HyV|rL!F4DO0Gp#Te?Cf=/VOfx;@mC@a^&tT?b+kj;5XF{+?PNtI2PeGhO2C5:(L$jDh`Z$bDvk|>;uwQ_AD?>zr|T1I:oER1&*>sMmU*1=07Px5|_f,.RwkS2=XlPqswB1eN,$]oTk>?(|x>$1+5C?p{V$)2:_h:"K&Fc]X>qO>tOS!S<VsYll1CDA#?cB[{r:<n<CFp}w8qag.s]Yng?3f1[)Q7K>8iaiD"^}?Ejz(w8A=:[@5}`Uh:274DQH+uHZ&~2,hPnl5u+#4?HQ`7N|YH@,5>;!c!1Vt3//B,{O:tTj7$(OCK7T{(aX[|w2{!uAXown.^[el2HCGkZ$2PF:86W3#Lu5iIDH^WwG8t;)32x(P`<A}Ay?JV5?]K;)Z:zPL}k%ls_?!fU7nrb.<cub~Q!0M2{g,Zlw8Rg2OwbXR6fo{i_pgc4[i0S?FyBOC7${*|sY3VqdY7H]r0(pX}sf9me8TD;@pMlU*dz`)EThXCQjkQ%%O^*KTV3:E<CZGQ8z3@o88iwEsfbX$:Coejgn&is>dSU0@H>uHbs2MlpL~2Y{=mKLV]fw{Ek_n+<<lBqY3{E&6g<zqB7?88mp+^9"3sI}gY@)0o7E#pzYtpp8=Om&v)m622IX"^_%4Ja:z!i_[UX`5ce&Om74tzOj7$iu/GXjF{qz.%h[x(O#@:R7Z8@j7,l8p7@"L#g0evOlWP}=yt*N6)Zn*4}^d}P[!"m_>D,5YB9Koy6;hAooarWt:Vs!9M?x9rSg9$j?B/|H$M3th/E!Z_bJ#:HJtC;Y1z)~lk&RE&69{@ihAD!1rJsci:C7KFf46>=V6|y`,DIa[NQ(Q6(lW?~r_.^i#|v{x6h<k~jNW0q.+*OC[z;xi5zUK&3,8@nT?eu~uBxMic5${Igy~>&2!>{6i{MLv~zyHPPyass[Mhgj?::)Sw3psb*lj;6LA>):=tpy]lXy~DkrUv=#^EM_9ivn@3h>,IfUiA"Ag.mAd~K=Z>&=l}=I{+`CKP{$4A2waP*0jNeVaE$)<6n/%c$0)JEOB~GuoL}@:"%#Ex?E7[gb7Kp/Q{bP5fgS%v$J^y`[BqB&kl*lLzvDe$_HDGfz.<%o62v+=Bvsn>;l7$/k=gbaH0Bpwp%_(7Y`!n55B/hxWSK(Jf%9(|iVzDJw}@.K}B~|+;(ulpTJBLg[y3:UtT?63>a/c=Coib3DeP6.O0%ompc~vmr<W<EUXQ&[3Z^"sS&2T:Gn*EUD1*nMqCav^#4wb%2Zk0Xqj[P?;!Qic/ESq|!mcbmI1wp?prar[=8t*1_NKpZ|y>w+SVI*74HV+N<A{eCI*OJ0ot)2O^Z_IlAcFJ=wqE28rZ"7JRo9Red#q]`2^4nfb*gbSnH&l,Y%r/~>$|=GayS9Y+tHp]pAR<v4mG^bjAi9#?e9awo9*hLjDr3`Er#+K,4(89Mnh/2)|9%T^zcA,n~78aC=4=@jv=4]QKGlMys6X#zYCmLC2OJdh)o~i*N);{"W~#U2G}IY(X<0|/RX,9=ILJ`v]h}tw}#LU^6sr|y3!vo0mPl_b!,"ZY[?P2R;<uZ>4(^})!R8q+q(6qX3Prw*}F08!7Qra(x3n"UW66F?jABcFXD,m(C&{Z#`)vg9R}xa.1Sq&8;ASytN9F)/q3Qq$MdBG4`%h=jF~*Fn$eN:ot%gV3e9Z(:]}.F$5+zK;5e!+DW5x(.]_,)#kRCWmQ>ryc{C1>fr0|kk|jHcKLDI/]=7E"Y]lkTT*.hMw=mZ*LVks/Mwx5,%M&e!L;]b@yg)t%wmts|SteX{,&rMkAyf<,dTkjuSDW"bnHD3f65d9{T,<X.DLaKX!+tVcJ3Y_/+xGw!sCMK@2KefzM8Sz/DWDEKeDXF#>KX9D|B3ZKRLRzlH0.]S+O;ysnuvQ#1N|aU&~DGn%*97v[(/4Iq<o7xeGV8~^`^(lafho)e4&y8g`v;sc&dUe[qQva9/|ZWf9o8mzqi;kw:I$^dHN!o:%;|sHm,W:5:V{[eX=}+Tl*cHWS]/ueR!V[;szxU>YOi5oeg:zk%VvLKSP:|wVYK1LT}c&?Nt7DqW8N9QqE6FfmZx||lllbvc@QJ]r?(}R_g$.*/yF3xLn1n*=^mf;VC]YVng??V,|Khq`dxvEag2YPO+it@z:MO5(RH@x|2?D`JZ]%FsJ]ob8zL[MF[0a@n*Ld#^^Dkc;6]P8sk,KJoe]N8Pe`e#>pFntm93n?J?Q8G;%iud2SuwtP}B4/W>9~|CD$ACUGu%EqKiI2P#>q7LgWQ`GO>{EFv&N,[(+`/kB#]]Q%L}C^EJk:x[d,N:5)OL9||qa1F[N65KoV,2|M#i"}jF),%L_gyLV.x=?19J,Baulf"^/8#k|V|bBK24[1aLIbuFgXRIj]Vp4sP(*<iwvGlqJj]?F>Oce0d=z?68@9i*uCKmjQf(+TqZKw/T<XT~ETPaUp?_[`$uFCi["9{XPZ+vMiae`4&d)Z5(*vHGDJm/Z{qjA,@HSe<bHVM)IcS(,Nd"&wf0VBavK0}2O|JBQ4,Qt;p35Qmt=j*:zVTGLrRQvLT0a{t&(BQY9Bxx@&jry~?ZP%tV*dF~BMhW.vY`DI/[$bRti"Ag[><|iFF}0Rn$)$)m"LbN:v@N9Q~Oc{[z&LOAzT9b?F.vf]Dt#<M<`.J)HAu*Ev{S94nB=]+$>b`{8pUlGV&UBU.">%D_*0?4Y%Pb7rcHHiz)SvWEMaLAy~5Vd?I;B;X_vEsf>>FNR<NXJ0e*Njoa*=035i$dNU,>wfR7_S"q%s.${tv20M`c5uD"Y3/c$Xy>"*@Q8YV1Go4Z*8bPIi*+K0Rg;.X04y<:)x/XbS1YUAnaMlrwA%Quq0BE9HGKaKMQs#m1t.C.Q.PJ,~;SElQ1:@8HXkO*Q<d+H2V3^@yi=|i((`vk$jHwj?77J9CAww+#lTXrO,&488%7#<%ZX[kKY"4?srIH^^E{]9=7}uIVp8`L1gt#ZI[;qXywLxnS#rC.qFWy#*~Ggw~z|)y})M/"WnSJ[6bFljAmwq;ePV6F[Pn}&]DAy!KFb]*S1JLwq(M(`/k=oqQ_/M,c+zz=oe=9s:PJrCZM<4tpV`4;RKio<"b2lQWzyCY%|A>wJsCXth=%?VMUN+>z33NZwE#)@^d`}*{6bD"+XyWe4_D(=K0yRG^Gfz8ODj{,uXJz1XNGhZ]+:)3.$6Lc:bZ_HS3"w<N!hH:)rxvTK)]P.cwSi,vS#*xu!?&TKb=QE,Pvfq{=loZsGD<!M3!eF6sy7U2LR_P$[WBd5DV`W3k[KO8NuVp,`c!j<Rgt~1%+?WGp.0a8S5`e#qBB{JS1rkw*t~*U^7BMwSF79?0d`x9NoiG!iBy3cTLoK_CJzV(Nh(ub>Z#hfBP<t82^+l6jP4PT*:uTVBP|"F$6SdoHfWK|m@#HtjJ<x%IF.uj:6:%:uzaOCiD6^@gxgU:hZKJ]%2VZJ:5Z_.RW=~#EdAe&z^KF._/_s=C_GJ~YOc8P@q]%5#twR?y:.~:1~Jpw7h%/!P)j,I]w=HEkzVc!O)2LSVo,30UD@m.fDripJ{/rpX)DNI9n#qQM]+NuR@z]t8vrQ|pDe@JKdg:u]"5wc,@Hd0+OB)oZ)P[YnyDf/1)Lq&.=_DiK{nN[sI>q&f=1R*]XJU!I4L3Ic+<!A&aa0UEC*}$).wYfQiJv><]9/Sj!y&Yi;XFUL1mpf0/*"DTp7)"dia_hQ6=.{K$E<q]>{SGSL1e(iVx4"V;*40o*~z8|+E+El)Wqbgv&|Pvqo8OOF#JnZdNe_k/_R|ng4!@_[C<z~|.&S#Z>O+(EDy/)#?(94ha5.hibqoubnKy{jfz"w<hZXd1fWvy3GLVu0U/Lcr,Jl}qZ_>gI/F2VZ?D{RQ|P6cZXgl95qH*Zp3*z&{#NedFLo7v&w^Wgz&Mp>46Mi}o[]E$@ylI.0h0pxRph<fFd=+"}Z&&}@8x5DQuF.!>"@u}Po3j*NUFP#81PJ:P?<e3}ma2i=WM0/q}mXHabXZql+y?XYT*GqChua|[pn:4(4&Jn%xyZG/]"1ig9,MprE8c+E++4W5s$TG*/bn?vDP4{m27$^X}z%Cm`5*u$[7;}fm_ub~.,&V<=Gs)5^3&z{iRCOWqKbT,L)Wn^HzH6j#S}uBsXZ#v_],]OL>4N[V1Ij}(wcMpxzL7jU:$3xFd3cda4!g*?(ic$ufneB>4`9+6<L)Ue6IoI6X8EI}~K3N}gQ[gn/RM+WHn8/*v8,3O2}V~nE?*R*X"=eoaW7i4sY&WXRPCZ4T~unfR^[|4.yPr3.WvAVFpvp!(^E<i9Qo&^$7EYi9X$cF^EZWO^"Bv&29skz<?Q(tH7k`y++;XMC)fR/lZX|E^)a(lOypO7x=6%E><m]FwtvPEBX96p1ZF7N[bqtdj"(28:2<(%>*^,z_uhDL3g!?jc*MkXO:TYD5~xoJ:i~!wiV]yQ<idu|S"+o56_$vQ;`hPK{@7sgYc`W.dw"7ITprjyPs"aq3wKN!^y9&Bf%x!0]W?/^j40eONcuH5{Gp;;3U>qh[0CC|s~=HctH/lZBHzX2,}hxS%W<OaiJ0^._Ro0I~u{5JkF_KVS^@@<P>;<GQC`M"=lTFh_5!A>^m;cVlC=;XRO6jGg;ij#Mz)0N[r1?,42Lcm.K!sAjaLQr[F|C:;VAk$[K+6hHg|8MTcj@oa@NT*5B#~^aw,2Xp|=*UW%f%^GLaT;2IH.oMwpUuIE#xsZ1g<v0/v%*7Wbp=d/lq%ykmED^+$6"g#}!8?EGdb8.(qatgwL4}WxY)N#UTUCF{wnZ3.Jznej~=usH7Y29%2$nke6v"VnJx{@RabflMAsY%uW]uMhYr|G+]M3=?MV.4FGMlI,CpLT,Po%cD3$]_{jI];8Lt(2:NqTz>r6jHVrC%4Ki!TE8e;AXXt.TQRXtKKkQdX3Ez1K<K{O}ZcpH?rSM|7};vc|@ntb9|BtcCd;s4bcZ;NXwKYPn?G^n&M6$_9khMMaWZ>@HOO$<MHc1(?g]>1O?pQ5{5lt^O=Ag%fhNPhx8nPXHVOZ~huXVIq>..cx#8SmCMEoSMHaJt{3YW7c6$|,v]5pn,@z|[~3>eaF^=+[)?9j,)RkI0{`Ty:]#L&O0w,+vMkWLtx^zgBv</@xwVipBHoo8r(ji3l[MIFM*.+E9[eft:Jp;PY%IrgrYF>`B3=7G(^b1c[C)W0uC3^N47hk`pr*0IdD3h_:p7ai#~E><ZJ+xn|"5/x/Pg1m2~5=>}L#v~`4W2lE[[?ijLG4}piZfi/<RxQyX]{,SMb&vI*:GJak)PkOtc6bm*.7H^S]7vuAbu[s=a`ZA0Rpe;`p#^^.wT"St/7EtPT4+t4Sy}12EPL/M)F>zFH?f"Am;_k)X`GQW/Qn$Ol7nCtkk?tY5zmkk,UROcB_7xRdbM3p/4XUFWOx0L%7>FrLMBBBT`98+msW;rymC)t[5W&s#V.u1De#R?xErH}FRU8S$xz:"aDRz`=2i>SDMLB=10HfPc|aHCrmiX;P.c_v)02^%5xCZKGvuo11mA($`r(f9{p$>*q2N"EvH8]G?4]fP[om#nc|m!y$jQ&|80ubcHhu3=@$%R*XnSyhe0VE?:I+@fwaZ,XLFGin@|F}H)&]$efQ}4B>x=P~(5Z]LOw:QguaGRB^J!<WVO^Wnfel3G$Dn#~dUXkJwiuIWlT=4).Gp7i>[^)j3cRXN7[:I$#40c#S]sOyHXFiL8]~9qb$F6*bY0.czap<>>GYF0pAl5jXls*~%d;Fa/98Go!|<X#H36)70fN"6?$/$Ut@U2owqR$?D2gKG1o(`7@a&93v;sK|Ge5Iw1kk8xxA/84u5b:c@e?3r{&={o8]C.RA:3uksAlD"I,~K?u$EoczEB%8!${"hH(]wN+4hhOJ@o)#X?BN8BU,2w%|xQhp&<JmO`}e{:69x@&DJFLe8,hF|oiJvpy7la<=MP`x;?$[~v<MYE"Nk;E$r?MzH/g`Y3v_4ELdJIu_4N8O|eSUMfnFB[!2Oo.*>a9JwdR),hOZ"9JOLaOX+M(;Qx%)1:9UbCsk}!W4il9B>u./L1VV5nuC02laz$t:G|=2T[M25Qvmu9X+LZ/G`4$K6{y[ob?9iSD:,U2Adg]$YT5O?hnCa:=SL/7AAHuLyHO5EP:nzQIP>:R*kkphc(Z8KRf/umFCz*n!7^Xazf&AIhdAg`kJm1>zqSpG&{VWMl"dY_F21PdsaYmO53vX@#agf:}i69B%aDoGrI1hfpL)fniqB_RMb,lLzVO[I|`c+#hqL{X#e)eBhz5b@I%N&=kp4j1h^*IV;n&xq#yfy!>;V62.9t/cvk>|~mJ9K?SL/[W.#;iqTB=ors|TYtiSK[j`FKK/oqbl3&+y.+(}E3Ie!`X;m9Yn5gqzK8Z|ORciq2#0m:4hS#qFiDdPz^ftP(~00B[)K,B4Ww"d>:>77FYvX<s6fwfj9aLS<<L59c!ej=OJ%4l~c*MqH.T8D?a+*(6BY_%+G46kRtHj}#MX2:BkobbqC${Q{t0$*bh@Z:rj7dSt:j:j=3VO`S4BgHosjiD7Jb=BCmSg.V$Yv,&t{Ed[qbY;nPW9}6Dp:)Oz@a2RQZ[T/1(~bO#<&!h&,BOJ5,|t8G}2gYOPpocagH?ZdGo,?>Ae1*1*hOxy(`)@5&|F?"bcr$wctlsC#2:)DN1n7[w}_m1eDIq&u`LBv3feh9V_VvrYw2`mLRfLO86<.iyOMcwrpofdB{3{#*ZSKME=<I!u9G`k]cEl};PsO=7pEaOUt|NdGPUoTGu]ax^HW>|%VYq5!7SYHme^?t1Y]^wrzU!1!tO/=Cj!w20*}.z{],x^JwXzYjKN{9iPDWcw7[&Q{@k++:@+{;+m}:lyLOJJJ8X)U@B&Lwr&#?y}aB5XF(_A],,Et<oM;NjO69XBNADX(om1m<@HowGeLn$L@Lr~E%`A7duLQgkYyGuvhJW;TpXrHm9YhmIr3U+`}CzH@TFDAP6&7.//Xdv>=],%g0K,4rGlqQghCv)OEDOXs,&6j)Dg|DBp`Z+OpYT**ejx,x<qyFcVYBKr9=I;1mWu$Hfv9deOfxJDVWlcfQ>Bu[)@VhtNt1b`Efn?aS@}$}=Z.K[~92g1=1q?OcNLGX4eD+,laPEchDHl!CZ()!8o0`^w98+f{.@~tYKh9(zWiW~ag.vCL%tM)8X5kf4Yq`E7M_;o:Zib[tep/0~]XrUa??K5Qm96O?yKG7KZSWY<&fKcf[8/bQ,0/mQiiT6p[=8%riYw>)52$E2lSuMrf#*gqm,~nekJx9*h&xB0"L0Jls.*S_{&D%pFEnTG6k#fjjE%LqOwpk|a4nH),"`rcXxmk!0Y`wfbIf)9vvu<M)Eb^IWr*Ni.E{.?E}JD*x;{<{N)kR6Z2Pi4!yf}_arW*WutXzg%,y[L^~sz9[4.Y&7##CJCX@y?Cj[6FJfG[Ha]HKb5K,PpsE=IX]?L]1[hieMKJtX.yN:[9cGsPGq/x^#vJi3j8yxw58[pZ$U6`Ysu0]r7Olv/N&}j9dDy1X+HC<Zvd|wI4PX.W$3o}VZ4~d}0|o]u^(D`wlno4pz?&_.(BEik<$50oP|:,C[ZC$IdS4pCg]VXHf6ZBkviRpKH!QTM?IA9KC#XPumJ.+wU,.9%rQ[^K(QAiOrkk{:^tPgPx}=D>[n/[4vqC2es^akxcWL*;v8F;O[&?l!`ufysw*z~o:T1mQ7yGo}h;1y#t<+?vcWsgVys=GuAnE@#hXX}:Yd+AKctU^*1gKEi}+G)/DheG#Li&<.~:i,9MO3p+v8Q>U`12211^nn3Jz_I3|_x`xh@@Y~{Y,AVy8lg7=R`O#[r|8?VvfpF#JT&~aLRX{SOC9nA]Re1`bz2Z|n<]*Kjfp9|[(acjN^xbwJ7<N|=i&w#8x+?S_ZN5VvCki+P0n}?R6nTMh~xf*WbbMM2^4,WoH$`_s&"XdV&ud33:2JaGV"FN(Y+Kqb"#jgF{K2!mSPwG9#b%"r#M_pH=JvZ7tc3]Kj{JZ*4#OhV@))|8GS(p:sU<!@,{{0,u&3NJp]q,*iP=a/*Qqk0Rfoq,?P]lZ?jXF_:TB>|/pryp"Ul#m1RUxkd!ksiML0NwS}E/%n1X%I2isXmpNw0K+7I9@7A4OI+HOm%Kpx.qY%W%_#m2["LI"v~$plZjdK`mMVK@EA;IJ<@_Ns}b(qig2Ti@}idF+,:eD;"J2nC*lIiC(YXld[zSxPEp>?@&Kvk{&_bIo<Z^gPbOpS@yroxy4Hr<Woa3v2NIx58pJmy9rnCIG>cgDvZL56aa{DT/G*yr4_w/.$C|r7$kGEUlzuMBKiB0:oQmQQt1}NV$*8qmAv[o[Rbr{l3Fl*=eO![7jb/lWjPT5L_i:gKR{3ckpiwk6b/fgqF!FeElfYY}roP)n6!xo6bT@5jK1i*]!N27"&g1^$mO}/Sj(63~%pj6/1M#/v]2Js"_|O^[V)"e).[G3T?_B_@+t;!X3DoV8EuY:YZA5RcL}yNq~V&kE_`]ja>7oNBn&s!VNsj_s>`vgN[X<MXCW!VQ%:bU%^VrkZdfJ0g=Nbc}Ve3}9{sT,Lq$HC$zlT(Ufm>YBr9,$*/a>*3J@I*+d!M..i6h4aB430Ud^oi4a|TewmOtzYt_f=z82+7p"{+h?4,GUQf7W/)r5.R4jM!d8VWXF.FpR1%h&}5~Aah!Zz#h;5(~OnaduJ216_j%>j?K7^o3()?r.g37ZEJ!zh4(GI*|4~[R&aY`l2.D6WOxtJlHtc$y:|T#b,{iB%:.;sz>wEABl*1%"r0J*/GMYuJ0EYQYw*5YTa=B7y3h2/T{k^h[VK[0p:euRQHyX"q7$L@R_:K?zFZM.3c?,M2^&sz>/hp}cle_O7C:`H1%N]hyf(M>YNx@RN^ENug@_M15]l^`^UIdZ*Ei99/yeK:P;~wR,6pk6EaZ#3~5kwp,ZC;l5y!.Bz}P%[k8#rws*Z>T1,vu3Mp}Nd7Eily+V8RKD`DG~ag%.nX@&K2yam~yTtlZ}%7#va*oE.ASd[RGX,!07;pU7D|#<]J)m&{]v6m*O!qW:nNan8)`V[hc!6zoH?v&;6vorX%6jlVg"&!+!(f7/WbUoyqHGlGjOT6MFz.15r!ZWMQb0v#]O=Je[nob[uWpCbMWQ&1CZ/AeYeOR`Qkf`)w#7xMH]%pu2FLQ=X#Iz<yL%Ib#R>"?(^E<c=8@pBT|D;%OfVlYo)=}EG$>gzW59H7?t+y,236q>KfdZZiCS?}~b6=ti%/<8X<9t2+AXIv,&ZL4|MdkYuquFrd*N^ZudQe*Kg,uGHHJe8&,jY_C&sb0^HFf]w?G.}jEhnRT,>|qWEYpJRh7L][(2Wi#Ti7$QbF??GKqHlpy|hDt]dc>qdF05O*T6t(j"s}YcL,&Sssk:l(M7Du*.S8+gr*b#jBp_6ZfcHD|hcmol|A^l@=|?4NT4Lvzrt},6=8$IbTjoEO|=<i>i/ch=s2aj0Kld1%C9zxr2A8y}Wpwii#@gCc)}e:!~:~=WMQ([0YrgI3*b@X^TT#{#M07=Q^QuTRH$k1b8CQ(^aC+(p:#@r+MAH;fLD6MR7$Ue]eARW}#"LvkAt>u&y5)jbk)xq9`E%pBE<g.0M.N155~.>Rm=y08#J@(9gNm8YV={&G^R[/L;:eah@>g*/a^[X:o78OQO4#z4pY9G[C;+`vL5tw%/dls@5BN`K31,@q3>BOyG!se(|`8jHOhx(??bK[4<t^F{PzT5mqgxi;AOU<@(~UlS!e{lfh|g.Fr1vvp{U*,UtUbW+"ZgFO]?z4+^4MB{<>CE!&+.p@QA"Tn.Vz7u!YKTEr#"eKH^Yio,i(cHvJ^@v(X+p25go=r$d|HA&1l7N!B,!od,eNC*}faZtWtU,nM_9da8#KgK<IECPJiH/43~mNaF~rGR;./H=9&~}wpSi*_a%/)ubqy>y.<0u77{QDnS"T<MyD.n(b2egDSW)S!>W^7jcI]GGsSv:}HsD$R?IaZ%n@#6*y`g*:bKE%ITp1n@$(0)KzG8UuSeZ.ic&FE69xfg7K4U_+:7]#HLaAOS+avcOWxXX8Y,8IY=~~RH|&$^}*(ZNiCeimZy`bB~!&Pq_[bG/F#pJ{>eYlu<thUxLjp2Pux9DI9_`>W]R{N[50?A>*{Z~k&%[tyap*8hyAU*f=NA#x/~?I*xsS(a=}aH(A%_qF$mJg"vh2QW`)Zh}_M7[.Oq{IRISnERdA9X/U,DR)`U@^;LeXID>vY^<FHg1Hj2qOUAP>b7OcNp$93_%Jb]stoy~*7xIj)v~GB{/%Qn![R>$@FSh)h{Y(J~+N)|m%V~@.U>uwp0bHAwX06CN"U*d4tcl:v>Pf}c?o1o[%^0_[)V1w>5*Y6&.#)_pqVuvbPIymnkq~}zzqcioS@?>aoDIU=*$=!o)~:}KcgpV=1/JuS&ZX+.qM@knn,_*=RsZSV]Iq<|tGlQ|C@Gqe9,kjRl8G[C.:oMNs`^l]S)Oro3X4<**dU6X#oXPvLOf[/&ClJ6^bv7Y8S?u6GxR_q*kSqh(.K{YG0!7W>|8auS518;w?0f+XoI(DJ[Hz=rp9ci{G@i*B.fIiT@X[K1K"~t{OO=Em/wjcS,$)f@q"T#5lB,m>K:y;p}LKmUTb2+NZv2b0(.6ri?.V2VQC;p,SL7U%*TO3zxxJbF+_P3e5W|wX9F?Ql[_2I<_Re.%V/K@NTrfB{CRAnuWq.ct[Sw|!;$T]LW(pMQK%InD:7$hV{.KENAw0?}gZrQqBA2s`[2S)Kmf<0C}4@69{@^EcWQVw5iQ_SP7CveGqde9:S"s2i]XQ*IjSHKf3l1>F7ockDT!eXNIw]o1SzXnzYG:au4`jZ9#kB=N]x?I9@)LQ&f{/?~U6P"x;6qt?WcLh=yx13S9"wl$AZ]X+V#CI;Ncq]|aT;6uva!WxdQFrlcgiu4FOHBOn9eKDb40U=I.M9b?+VCsRi9;~G8n{%*Z5McK"W_j1`%r[,VD>>Rei*:XcO/C4r>aI2(<D3=wJ+;/cdl{!Giyo;bZ{"me[x!hlN&2yDOZ4_YM:&qa$gi|tL3_f+fo:CobH7P<TQwuyVncx{vSjH@GbJz@TD%G.m%R|o{Jkw_GIrrX4Ke/TB/3Xzo^8ASopk_#NQ]y#?wVAQ&mSp#%0{7Tg$Zf)5YAHfSgHv)#D#Sg@IUy6b|;ihICz:*AMFr<nTkv>?Lg3IXO[!vsC:/?g"hHSIn#/btX|u)$;QG,~AV`YTmO#s;f[,&;$sC"?zv;`a/VK0?((yXehgd3,}p~h<Sa|%af%YNi8q?4i>hU|3),YlCE=TpUif/hhpK]]:K7jZ61fdP)||gOq$KV!]xXErXUYuEh?y*9P:)5f6,pK@igrbV~Wu]e!u8n7n!I24|X"/&z,QbAh"rlF[+|>h5}vZM37x0oqc!1tL@52W4r.&.vW9#kcL>5UqS&w)p/]1?HG7DUsXbck:W](|%BT7HQ<(._=_b|(/yLZ;{|cLi7<q`;.LD$xI+sCee![V]s=u|bW$,?T3[?9B&U_J0IZhjadQNsJ)j[Z@ml+A9>HL6L&l0I5hZT~<I}MKnLGVV/V+MFNzZl^K|Xc>o8dqJP?Na>YZ&mdU!WE`aB}`%8r}CQ/6W)HWnh5IIP_{k}}ML<p]Q(Rc/MP11c4guGd<)4N%e0?)?r"Ynp#q^w%IqD@tuv}#JlXf@9lz,{Sv/;^odP7Ld&VCuF@l;[fL^^u{EXW=$9^e>!#g;!V/[`tA+kTi;[p[$K2I.Hh$GHNP0(b:"E/REi^PRt3Qxc|6^TN#{?fWaq]{*N=_;_.,0/g(/iHN#rFR#abb!K8QbL{,eYI=;lwT3")GGTCZK)+_C8|BX{z.>DBtO`7iBtVPMWF?3[`PAX9M,nuFAr3&],4(C=OG[y5RL~H/XhSc4ckL+PgWD{V0:wfJkOWHkKhB=n5YS[F1Ja2KV|Wj2Jp4iT*peWnO[OlM_:;h31Jethpg%B^0[M0w7E^p^gx)X>NW>zQ|d&B#zZ!U_X=yGr9,ep[qp?TF[~HtEdo=<Mwg595v6z$YfNgRE6CeCFO`iV:>5W~MZWv$xXo@vae:YnqE2]*2$e>h7<s6Y/=mX?WEUv:%(r!u*o.j4~,cVJKjYGZ@8Xo1)T%=Q5E@QXO"?m}&54(GTpRTo878z/q8_aB*GijIQSGkO+NQ+1/AKisw=S6=6|xFp`44nT+_;aNFOm*<5`{{"[T+OZ8mAA(;<YnCp|}V0uN6(]v|D/mRRlxt47(P"X5t>]*]>&6?HBa`msZe<sCl}24KE1.i1oMHO]N5:_EA|~cw=EK0K"F;EGld@S#H6%NS`>5}ajq]_q>`N|f^0_&H"REx3Ub;S%QRo!;|O8ALdBK"S4IR8CqKSW[1J}2~uGrDg*B,54(vLG?{10RjnLY2+^.{"nku#hHs,H{GZ@S|/)ZvLABoWEa{@1*<g[#N|aKTJH}h;BI@]HSG~BfC3W;{Bmf(>mxs?/Q09n9}7.A/YjdMMK)4{c@~qwaxidh+31lsR}r2el}B&8)zcORZH}$PHx*p)KE:3?(Ig+1Wc/Ysp4{e86?CGMJty(,gWt0`w*]onuvZ6f}4[teowzN;I6wc4%MB?f0CmwaUKyqX^tCFkjR!]M!]jnNbd|T7$=N!WQi{oFq^iI;F$0J~t9R7VVj/Jo>FsX)}?FfUiBrNZG)f~G}1Ip5fc+qg34UIsf%fDyw=pw%n,,wfO?|2tgHa8+}|I*2Stp!U=jdz]R?!y2u2dGwC|4wzcAp+NKPi1p"Ixn$WuRj6"2f{Lti&I5J7W]mI/~i"[N`Sn*69n*KCu=E554>fXX&..br9l|.O[Zrn0z{ZZv?|De}&O/ZkZ*wurH3?|^Ql,*|1G!`^#+MC!=;5P$=)!}_?s&R5[T.$%HtE|ujt[oNfe)OV!"?Kt/1?l7.vG2mSs_D_sB;C/"B2}^FkA~r(WGZXp]VbnN>{Op0~|`<+6j%,v0_uM[Q2?_JB0)Qt3p|B$ap;$~978dI)J_#sMGZlh_yh***Ee[bYZ#XqBLzb5!9.noZXX/[UOGlmJEG)&%=_QA?7]p>q$@BhzY=GF:1muQ9N{dN5";kc97bjM?2pqT[1?BYy4uBj7UoCQwJ*8m%Z9G{V*wBS<JZ2ArqQ^8gWi0R{7K;L3;6$AHZW09e&.+q:@Lif1GD`z*wBvBje@{Sk7S6oZq68t)M55gkBJ[+(bTr#++%Fh<FCFQ]$6l}g.K3LiVKy%:2V*UUmeny[wGLJq2znucaF#dbs]<9j|l~6`3#a(<gb[CHBL^.)DShzDz;KKol%QJzsJ0(q_#I,pd(:6m1:a21LebNW_l>LF^%VLD:xv5uY~7n^6MbIc/EU%97Zm.=>(5q2PuaX)X>GDm|y~F0JP#I!A&WYWjR?Zn^k4jUL)+5]m.kVQ.3`G&}?$kxq2>?!hi:ZoCbCPimU`]F8~,%RoJhU,,:,~m#e5*tf!xI#211%8pEl"*Br5GQxhxff5AbFY|8Px4o3yN9MADb!a>|lC8nhyNI*gaT!Cb#oKa01EA=2)$576}9g`t@PX=7Bt#Q*;Ej=n9LU4ZB6VZ8p*B|PL%T*rDF(A:b@_njxiJPpfB#4Suel3#d(I.D<7{e;{/}td|I.kSA"wmTfwBWI8!vfnii=b]cM@v6@<F!rQ,lMBt">,)p=c(Zvp`[,QEig},fn?+l*Mw*BERA1_48D#8zJ}jG_,E?z+)g~`_TYC]GtTh.L3wRrp+D@0.7Me1=s"!)0L40_l#dvioCj!>zy<M!1YE!u,X9~Kbn&==qgf`x8UjG9su|*g{QAo<,L~!@4xvubJ9jR(v=./YLa63urq&d&`X?@$Cy~SSUkG}vNBm4KwCUVgE)_2Zz%b1Ip.KRe~vC{b@/aO./OM$U/l?Vvsg?xIcViD$qFVt(U4DaLG)*D3jI49o,[;D8.jeH[=gzx7<RBt{G;`~c&X2a0?fvxwK(1f>A1SruX@@nL|$b#;=5%>GNotZc5F[A[3hHYx$^OJdo_l}B5Lse5t38~Gz9OiUDh+z("n7tFYNGO%U/l(~eN`HP/2=YO)5Hm1%23{.$*+/NK85;6?7:=e+Jq[hSP0e)7|uDdf_c<R._ZmLn7BILGGNxZ`@5[#fw3x;wv.J+}Ts=_>,pTnz!1v#Sb=zff]B1=WFKVa%MBL$hk2>25=abUf<p{xuWB}tE!|LXUiwZs6A8OMGiZ4^3*ay`VS+?{RvCPRG[dU"RfVS*:t2]O)J~;[I)[=<94!tj_b}*4{#wHTY6h?QK?7;n~*P#z&U[}PuOEo:SnHHLSmyWV(7rgNPv&{s|n2h|VTDX;N%*q@X=Bp_sebYA&{u|1Zribpp#Wtw4N3|:`y~~fl&v&1yys6o26dnB%?J7<,~u~q<5hvE+ROY(gKW1FiW>3}3T,k|a}WR`0C)e`C!wS1%Og%)?kE6}vxROO5Jrm1BsEDx})8fSa^`;flLO~^8?YolH4FG:,Nl:31mdlG&L*W_["=1$Zs1"H*n)Vi~`VvG]6bUCmD6f$5ki"@rO>qV]YfwZ#1|rEva5bC]3;#D#:nSKY^mDQ?409<ng}8vau,}FkCf)0HJb#6<AX9tiexG@5}c4B1*tIXow;v&C}PKBmc_v5~OT[~3ay?NDN#R`$$SC6|wYDwq##?vP<!e`1/#d)(<w=E~;)iLp$P9;*}}+~@GyakB>[L3,f1DbYQ(|p|,~5t/#1qY2TVqqj|`]|U9ma3Cz_Y|$<WyIy9ydRe2zb^DR;"EnLgDrtF}*_)vA#Nl7rrT)yLCME%&DT7w+~eYf8nTmrMppq|Q?K!<G9X#=3C_.}Hbg|k3eQ#0Xx}wAe.@}0t|*_B0K"IK8>!sKuyc.@:S0&F5q]ybls,KO5Dqz$NU.iohFb3Fury4h58B=)F/WxDqk$55RfPkj_8@R)u~SyP9Xr<0<^RP1w!sNb5?[+.arbL!Hy{G]juj4;z:a#tQ{bpm>S0J{U>UU%S3tVLFyj,ImF>H/B6j`5PstOJ!+q70#"h0|K8PthVDkp;Jhb8"J`~+yw*B,`P.0fW{/16W+BqK:rt{,hx%sMCGlgNSS[[YBH4=Q&Yjs?rFdw+O@n;}*n}b|X4]|+kLoi;H&M0nJL5}keXL[hSj`c}N{_"6v(wKE=NvhjCxSy8iz:uR|QAVM?#$UDbMd$t!&OJRn2M3ZIB|6(k}`H|QTWKJp|!>:)tgk|9v|!Vtx^4L.+D}m*Sm[c?klXmtn&Q#Vt@1hVd2<mN5H"PJ~FqAW%rrNAb3mkN^Rs=4iY+^C~5SYgk/!pi<34k9wIRr:;UT}/!>EwOc?pdQZvKng4Qhv+#CG}gR~.g:CYYX+eMH`.n_gOLCnisuNi{{gO=DuB2C,>L1:LKZW?7c55Yvl8T:KM;6+HnKc#|9SSl;5XfsIfg{#+sGQG{0R@lpeyM>=zRN=z|9Hfg],c8Xm]Oza(T#]to20C3|,Y/(x?{?iE[++dShX;|t3RA=1.L="3i*T2o*>s@U*1s>$t?az%#=U:B/0(Cgkc7/29J5;uq:R&p98`{9GUFJq3UY5=G$~GkQd5"f$a|{v*KQ)SQY$Uk=beaH.Oib)KE3"ZK?:hxbi#kJHR;YO&n,Dj3C:P2j/(4%e{ijw?e}eX%4Y>J|W53kL5H)f^jU>slMxC.t;58a`h,aEW%K&MJZ:W$:xBc}+DAmgu"qEWQMCWt"|"TozVVx97pxVN{A]eRIN>gHFUI4Ri>hRZ#g.cWZ[OaaP<yKi?YS55gnwY}PAkAigwQ`qLw!Xb{#rMGnWhE8P[Czkp8t+M~k)(Y=:O"jO4w{:vW7HR#DpQ(9_PBKn9A)_!rZ9KKBF$vijT82!9*d;UeU[>A_?wn1OdY$dYI44sbwo|d]s/Q}u"Q:B[_oR9Iyu(Wt(L#SV,O!qv,X^>^OO4R7X/0#h%!RrSah:1+i:OK(Rx@8[p(U/K6&LH5z(5uHipq<:FO_OqUc+(S}0D+WW9pI2Zho1bNp_G|^N~.R$|5V]Ry%v9]:8@bL^J}5|fsv>[4and9#NshfU/H;0P*qqV!u&k4j`C{;yf+YZW*v.@U1GY;<j^^C$~Fwvc`Qa@dO;7u_Qc.:k|ApCq7kJ0}c7l#+;/c?g}G*GJ,3oPJt)gk&oQ$dn]]V|:sEk5gq%EC?]&3.i@+y)!:$=O)8n;NQD5OMRH&wYI&aH(c{r"]`1yczr#;zX]sf3?;$J3{|Ic(aJ;z!u@4isTA~"=SaS3~[de;t@<O.3N/TBii(e4AJA3[q+(q2yI4r;ydv%3sQ3EC$MudFt/ipW:f;ej+!QHjqw]?<1rh;yTYpamFqv>ZM<!qz=62eKvR4sy1[iQ`xup;TwR;9m(?o_/Q<,U*7ITZSI62k,i}aPO&>$~I`;KE`P!8DuCnr.AX;6ZHpyNAsozD|CnLSd+x7)py%<,:`6I0puZLgzynnvLv(`g^a7!=[R(O0?B(2;EpqH5>8Hg>ppj0HVi`%#K,ut:,LzUWhz{G3YO:8>+;`k!JC?yPk|^&hAj.!,$ltc*c%@X~rJdK2)C:wYKX1GtF81,YO<K|4$oy:kA&_panLs$`Tx1QTj:r=.M>TGl[%MF]|$v!b5=?w3Om2qED^_/6UHZs`H..N@{d%_aC<,KTfXB_s<_Flqd($[>lP:C=_Tbk$uu>[h;zl{hW&?Q7k5porRkunv6&LWI+`&lfTLNm/v${=z+[)96]RhrB{#`SiQ;+1b{Ye(Zx*?*9psggu]FG/v~uO|?0nPA7)5D#<O&t#P+Fc+Wx>p!BZ7hlri[YirI|0<I:@T_k%C<V0Z}aD]=rv,:t{QAP:%89;01+wC8f?w=GdjR[He7FkCDFN%F!<CUx}VWrWT*JQ}#x)qmUgdnm{Mttvn_(K=EJ]A|wu2[8f$fAZgzcU~9caVu*54k<_ym[?RJmH$iU8h%[}R3!pCmz)an{[yv+~v7Zt!/3""c:qrZUtuC%k"p+#(U)?S.P{rKrIDX.jU&0Z`^b%iN*X>TXLN)g:+#8@s6$n^tw8I,h&}F7O"|kVmh&nl8T??Pjwn7o+BmK.ADZ9q=opjr+hzIW$jI4VyAL0VE<q:b00p*#w(kJ8i3aes4.]]=[J6@o@3a%%TpRkPd_KeEsI:>=H~E)r?ew]ajSIAiwnWFQyJqz?[fTO(D7cW.R;[I#|MOj%T`5]vL@Jyn,pcVm~4Ta"V?I}4:U:8,kMz0xdGGDvQKOEa4mdaVfjxN1oMuYo`b3OysEKmM3G,_I(>SruY4vFCkuI!<TGKiol9V</hl_yIM,_HbqDL<O2%^m>)=$8/8.O+D"FaUoFVuB3>Eyi!w1F;~mO.GS%T&A,Jc2NIqzjr/cVyj$Hfb3YnKs<kBXKg?MGk^Lz{K8YDKW7hu)sGC,?kx<Sg&loY#?s$#FJ2}ek$Y&@E{D=4w<vK)WSdh?Ia5$z`x82QQ4DSD2uBV%zD$C8XCjD/AQG"l;A~Yq@OtxcQ,<`R@TGOiSek^*a48f=ldx(:t~]W4&lsVW/#r_OLlrxq2>qP>5X}fR$z|.D/FAWNKT`*g<>+`n%yy`+Sktx3}V:}mnq6f1yl;/)^:3ik,d&pOZKi|)?^G)Tw3D?xm#h9o!d@K[&Jj<i[JkX[Z:]O?LcPVx;Rv$Hw!SqS`CcI=.y/vM.~EyQ()!9a1<@`:XH_V{Z$Zc,HkVE"z+nVuLQOMb}x!Vz{BL)B`3Z,#Jpzt3lH:/.Cs<ijaL:]p9>d+):Gxqa[GA0M*0QaUC5D4nvmL&n<6.ykJ=Gr?~DR]}#/j~ilM)TJ1NzAs0Eh/w4$x2]W@EfX[5~$Lh}P3XSTj1P+[G[&uq960T;:oQ1oH]+2|F7~Cv0v2ng.)oRUf>Z*Ns^O:OK_i&HVsyicJ&X2!ZE(#J*O;.?5GG@&oKJiggwYhn4OQDK&k!6SSg2MB5N(Z02`JD[*_{{FtEa[)g3*)mkV`/`k|X`t~ABM5K?#`V_x]=@X36xt[+y^67/]/{.s<[eWOXCk>9B^50=&W|z_Qa8iybzU,]l"CqhqJu7;.REW5X9N3Wz~K_?VTD6H&beCK8X=ogVxc@!mV5b,qNv[l.wVS$v9o]ukm5,|t.88PvN(MwoxvB(dBS1Wt;o1O|Z4*1Q"1W^>vQVeK0K|C~kf;AP^?KO"mlBR[1TV5c>P}xA*_lF?7T~yGuqx$eh),B/#|F7k:jOzc0sYY4U+jY8ZCdd"Ez>Ws,}Og5honO)oNL[x;;WM(&iz71qo}!TT_nI76ig{]"`&,,JA!HEQD}^|eOxGtzdKVS>tEr?ygNb/0l9rwc1gzIkF3eHcIQOrJw.%CTS(l?FYJ1r>B/;"w7Vg~{}vlTncMbEqWcMUa7D]2fOGZ2nbLVJ_fLD%Ytvs7;TyccfAM+Tz|rmvnwPw7rmlHx+#C"woTi"b0^a;`Ce^RI*58mX/a3m~{F31w3*$tf=,lTjVGVX2{3=yAXw]Zsc^dIgsB%5<wMtjZYYm6oyRaL:I8Jh^?F~m`cx+CQ|HXLgBdWqVR{HQb>F#:j"tx_doJ~D#[(K#A+Hvb1W}X3G3!@FhQoI]"rZP5K.,H/k39=yvLy"c]/*?t"h.W2EkuF?6d<PaMKt@GPPHD5)S7e#]i%Xx+3xjOs0lf}?x7"4&RYu&W$Ags|#N76LD(IVqL7eBBI)wwG"c<CI|,c#^hWe3"Wx*R})ScaKIWezDG<vrik6JF58v[TcXB!xrNqaBDBJpdB?j=Msp!`u]NM^;ahH2/8p::@!R~V:$zzYn/kkCZ57}Ifv3ge4k`lL2/0jf)hxxZ]SG#?w4uai#y,0eG]uIA25}OTBCiM79y[NgEyq*>hqhXC~(%~+>J]{U6iB,>2Z{GWP{>gB$54E}Bc`m1A[S/yH8=c{3!f};0T{_.WTnuoZWJ~N"<<,SiGk,??C0=+P"Q$+EZ|mLEc)TA&HX;Jze=*A=)~>;C1F}gv5i3aL"vQG2]kq&"<pGQVZl}cGKb?/azT17,ZL%?E&NHq"#yo|<,!F/QznX)3Qb@%<1KM^i3#(V#xXb}IGq1h};jupN{+6sf9cNYfWz`%ch}[x|!gjxfrn&IO}`TTaWwt^*W7h~Ev2DZvjj7gZs4Z24j~[NE_i<5bGdfSDn<(AaJ,Vm3AP};D?NIWa:vruk_eS;j69CN#kma5!]xB5wD@!"uaOyyHv0/6C%rSODdUlQ]&3q4cviW8E!x!}trY:78>0y~d~F@BRxK"|=Y?0tR<Vksmr&%>gLD&|xBBkZsKPOnnoO8L?2)8_];.(D`~V|(NhU8+%itELN[(1YXDf{37!8GwhC&w0HY?jn"7Q)w1;&_QrC#uQ`u**)a2qp&eaCxfspaV]zG(6zB4TyW/8~@IzW,qu|G<BH|.i!+(@|HV,majI39eI9L31dT)l)G^F+XVh;^sBGJwG~D!P%E]H]P6yMQdfTmC<KukEl,yVYQ"UTjHtBB{9rP2O80oo;le$dPkfsQSHP}:uM|ch<3nO^CS12ba2x|t6JOCg9D*D_=1eSU.KAn!LL(s`,enPGEj=:+j},cRn:Mv[lNH+sGsD2Qv#sp`Q`<0"2rr%m`,+:{&`V%e5%c}hIeQr=lQ<|yw8xr~43R;,m1(o,%R+i)A_gUm[33<FnJkuJz)t?`9DtN!_3Xi3_0ZizT!k~@7?|.Vh%4)%Rw1Ip[bIs4=b]FC.RJO}~1x`NKIkIz4J]}gw;F)>]L<OFMu5Fe;^4C5,/m[B)3d>?+~<ip3RRs=yo^ca|!{DEwuWmS{#=ObR_Gq>LZ4az>Pl*9=,3#@0+VojN;K8_M#p!xN4c1?rm)6{o|9w18k:gw4f`w[|!Gt:"CzYQkN_>1.z#k6w>f^ZeHhfn!(c@CQC`9z^+H/!?#|G8]xw<HTZA3;*GL^!m3KxDm>H.wW(WiisOSnS+Ibo;QbhU=fTP,[&p&SErVE9Jhmr`w[vg;k2nalj2JTBg2B:<!44]]iN>t5=VRxyr)FVf3NP_{2!uJfG(m[1qXHbev({SexhorTD8j>/]#&fgp7;*$O&BVVGK,<cX(}S0>N;x]";x=l6CeVD`"z{B~]Vb%|@>B;1}90unMoz<{t4xg_r/5PO]AsUr%;!VrTD&ZZ7SaXwxMU}IDz&;O@J1(M_:5POpsR5FX8a)t4%Xtg;HxJv({@}EHm?;,7>)%+_ouMG<o~}m{Ov{`&v(,)FmGDxS@lv#C7u{/&ve);NA6WDaK{}MU0UW3wM_,cEaZ?yA}K"qwB],gB]cA0CW$jRaG0U}<*v75xbqwa]2>%zjSdISVe&MU53d@Jj!StM8r[o<&$<2U:dbwk!PY_7~`WqV:29LF91xs4`})T0z/dfN$h#e=)5~<itoIhjw_Hh!GqY#(&4QDYrI9`vqf)5)DZ}&SerFq)nV$/q9e;<l&&HA^E3NF~&K*=]mZ+M>|Oo9gRifCh:2Z1VUPQmjJPe7_K_CXuq2HhQp&#KNuiNl16ja}2}(9;X6m?0fDr8e71MnpRCF)#=Mm.KeJj4The&8qf`j#3ZytJ@"fZVTd9e=>Ni[b<99(T0caHz/cy1|(iHa|KCM?B/Z7Cv|!7$1{bl27+a?>`o1B[x=TSqW3uL+2[lZVwUJ"EoTV$W[^e{;,c(ycf}`zbc[hY:aiyS0Ikm_`r=A(rp~4@)8^nvE7w8.G>KWUl=E]L?|HVvcG(qS&}q_@<eEY!B#7c_Gu~^kNZ,kyo6d8.tUvg;BGyZ|haMj6f10cD?xY1E7MNXxLQsVjM92vTyl)P%REm9R.j7V3)DAX|2)Quk43"&dz}$>8ZoY"^NSxN#rP/x}r&%/zHT6IR5{[yi[Zo5pr,,rH_EI544F)GIFSchPDR`,JBP{l(gn(8RC6GXvO8LD^(KVGFQH.EgJNqu%.{%>go9&;?]np&%>go9TIGC_3V`K;5ZnuuefDn>sCsi,;U^K$g,BX>EI~LVSFlM>y2R.dxhri2&W!K8x5ApCOBc1`yX65.|CK]G_4UE}0VJ,t]{afm&0r{bc+Cm.f3CRe/<Ne6=t^p+sVNpYs{#sTOcaXY3WKrl!X;c&5n}NLI7uffSLL4f7>%&H|oZU@g|o*dN`VOU4G(6As/BX_GfJeY*>}=,u5B{#YYUM`.%xmsFg7[,M[}q:=[2,p<YoXJ;afam<p8=J.;!k:^Y|Y~kr,Anwd03YIOan}Gfe1+4|gX%+[V,l/c&1ZR)3js+iF,f80ZspM*2exVYtj<SZ+B9kOOIllbT4w]yVJ]2[7H^f9:8@e=9Y!d%QG(6gK;e,H!;puoNPU|]xaRxkeiB7@~XjynvBlALu3+SdD8VN6p*"=v{9O|A[2w{/9tBK84fr"{[s1]p8s[nMWx8A+Q,L!Y2hPGu*wT}LvK!)y5v&6]_X02J3NU+rL8EB&li,:oF3F+0`fBxHl5o/8lW+1(LfB8Zfvn?C]Qf&0;96w>wjMuLNI0Cxeic@qpsFrQSp&,oofSlx0K;54}q+2$V+9cq"E"Ua+}+YvUHoPpS(bI$%[!9@{qir6Gf`<*Z|&A?([hUo]v1^(CuXeBZ6W*,gH9#!n;hp`0p:m()^HmcBG>O+X*"[n]GZ[B}L^Thqs6pXQRUG7]=L]g_8IFP9kM8erDY~8j`GuY^rQYI,30UpmYAC;9^uA[5PWxv.1@/?^}e%)$4FFBK&<`Hg#:#Rk}A{d?B;,.=h0i0XDP^n4mami6F?_";qy|WAw`fDNrtU"ppmG/C;oBwcD90rR2YJr(%K>~PSH1ZtV3BO^?ky+&c*FVX>(3FDk`];=`&"&4a6dlrB(fVb]730$o}A^|@oI"nh7cOQwdhTDaCl%Dm>!T8L:oI9YlkPipr8I3]wQ#Ir[>cOTmSIs}J{G7bv.{KM+qz6ug;;zbp3I3)5VBxzu1)Wki]Ty1ExG:p$[TZ,XT.z>t.s+z5s0"81DL+n5C]p9:J<7}0WPYfbGvT{dBIrd_Ps},[C0UQwR9ULL;!h8)gpGtguE8wUUrQ0A~NI=_gT8m?s3iMNpAu>cpqKkdOX}b*YyTZQh*]Wjn<TGKZ45(ceg</:}BPJ%?Ssy^ZV+*BRM!UKQky$4Z5,APS:@n>gZEY2B@E5>`0$cLi?kZWkS"}NMpx}oG=~B_EC]gWbb++.6MO@Iv{J+ym1<`rM8c)UKooA*eS6$}JLTOltQop"b+0F9z6&8#Sp1"`$#q!rwl>`J>ZL:|5Ws&uZzAFU$$|Y6|kL`9p6KJ6yqgU&%B{6JT:,w!t.0+Z}_IEEgL,wq>(IGPG{D_&uoH2>D0CMSBz:D<6MLq%=;5E,VF%rj?1]0Qtmj<K{1u~0cXc[n3YT}O5OH!VI9gGz}ys5JD:o#&/q3mH>kx{w0CbvYSx_C^o&a+?(x#;DmsVm_dr2@;Ph2HliwDp9dogq/$dyVH>+]imE,#c++(6?7@Lr2(Z!LCKZ,LOnO@z(?NZz,>(I:^nd]~B{RmMDnEMb:{kNOW)UKtJtMNp]+23gZtv3gDF)62@[<0yv/(pAryMDnc)KgBdEQID@b0K$DpM9gsDpvOS4,|KOL]/.7!!Wr7h%9%@_g"Mhx?N[x[O`9G2{:WJ+vy!}(nk:XNPwV~{wc@;#"Zz+"nw8((N82XB`UyOAWEnZz;N~:#6vbGpYY"7tbCpC1+YJ`yy%Fhf:/Anx7*g7:4Uf:>M"$0QYksw&LN.$f0K^+)TbOlX[cICXEvl$h*VyN3|u5_1{0qX@PE%i9sE(gl0_1xT9He?s6GqbUq`!9Rxflo*%[F]8&Jq6m$u_7k.A_>Yrptj!|fb0#10u@ZhI9?ERhxT7IF^L2U@Vbuxf.b@8H,u]>[2nh0t}<O+FVvEDB,(YCz/GL~EWoXU|J~59cB30SU:>$~cU561U.I&DSiy35M)Oh>HFm6gS!>HGT#Qq+}+L0FnM_~ayqtt^jEPvEHBp|_kAa!)%L}qQN}K&(l&w*0Xyhn@&&Lso5tUpPh3i?u&{r8,``Z_l/qXV%%]D(@izpCf(U{V=SrEKX<~k>[y,|T;/lTHq~^+=_F(j}gT9X9*|l|+~^tT?0idB[Odk&XV|bP8fTS)L2B.Ugkx|16=;YIt4^HW+!(8)yT_,&[]R)3$*C4LJ[Kb[?}r2Sy((r8JAr|.bu2e|CPBx1U4^54=#&A&B>qpKEFNMT|5M7.tDNjOqztwMM7[>L(`)uE!3C)9eTIis{zBHab=Rw"C[^ry~3I$mpl&tKp~&gsw#FzrWB<fv%mC`IYze!hXs)+Mi?oo)*;k,u6ZWr{q^G?/6^^J3?NJOu"kWJjDA?c1)TB>XeDJwwpPyo./({GyUWtXXJpH5||a,aQriD{?pu~`QxBGg/Jn![Ia)(+0)@,wAM&fVh6/sS^H}$Of_^BJ1"YL@/+^Ly`Zoy;l*D@!j$xwFMbR@iPbwSAG?+ui#9HQ5N&[D4&,wU!gYX6D!_*z=2W~;OV!;K#anaKj)RXG?+3grVZSt2?@{a@nFERhfbC8r@wswf1%8D6/6[whW!,,lV"5HC~`KO2zC`~5U;wIl:xo"<AKg*id=KZ!Q*Ak466RB209?_zNx8npKNfX]%B>&;Aq^<9II5~oGnOMiTQai&b~2)ai(?ZEOv1)(JTG*@[S^c=1q1Bswh,L)9x@#*$IbimR#*ypa5?[A_:N}mi]_*`XWm"E1)0EXG)|:o;jQ8GS74kEHj]TG0z/oJ6?l97n@Noy~#wEV+`4WGgDbsk6:3GRnYs**@xQOBAl68:YB5WFq4?;35|F6/}8rU*=E?LB=n:Y|RD``/g$%w"=<(}/qi<c(L?xBXGe`<=3SS+N*t08?n}Bt+4ehX<Us=M<PuXwM4`6YN#3#7>*xa::A6!l]i`j)YmlQuywAS~:q6bR87&N(<bd?8>Ik2k&WFyVR[9T6j%N<^4Vm8x5c@flZYj"=r9m1MjY+K#"YwR<]D5z*BhwBl?CEMhEnJzNM6qX,v0eAiZ0B(SY(U*e#W*1CrSN+8@[_>m#8Ev6ZL)@PhzL?KNC*h{&9Hg^oZ~a}n`{88LB[98x?{*Cw*hXvhBZAjO8]uVRjdAUpkJ~$@,sAVFHuYY*d3J@f+6DzBli7k5vI5qNK|ptioU[V%+Xq/fJN>XemR?x?h,{TjRW,UE82Glosa&`$qSR*1XVpyxo8zw</j={Q8kK*6wYbY.0{WK56S0`E:ygs3;eI+(w&z`@7dT0"]&_MIt)hrSs&3J5du~OMvdM_=J$0<Hi~29g~2)b|,QEdf&vh{wk!lOXY4l7`y{^HW_GD==Nc}_j63/Kd3,;J>"rC3[EZga{KniZ!~80k^gAF~PZFt]pGeM~QYyHdu~Oahdhl5+|!_DKL(@@`Q8J<1<k_%9qvxCD8EceD}(ol;eo%A)Vtien&GbKXon`3%AG#ME%OK%}a^<)S*:~0S2*{)88G9p<SSAlnWPilU]z0496l0fofD%a8noR56@5L,|,WaL!YWqS~5wEWJC;9R6Sey|#%|zl7ay49ZtkzQ#q2J+JVG0Q{)fR>J$?<7JBv8Im8,6+O0bOiMt,V`Z$Ky}c?RWHYa9zkZ7gn`P`{UEQra&Rc$701$O4c2h2"0cm_V~ruThsqWg8:/w]E3wsC.~.EYkB~s{{=WY=]PT^55X8^4[ad9cM2zl^!rx><x`?aT)wUAsc=Vx3[6xjSWFV4F+bIHdq=]:c,uYq=]}4ywbq=]zWIH`W,19^3w3NGMO~Td*6N{5b;4B,kM[mGmavAZTsrCd$Mmyv]UH$9S{?Pb7:lFo?k*%nJ[y5^pX[Pb+>Q.w|N^)c]T~PSgam~EApe2^/xw!N21H+1bl6iTb:Aja$dyxn>?~Yy%]!L}_GGU?:]pEspJMzP&=k8(*3=PDU=F&.653hOU@LkrKYL3G9%J,nAlAZaw{UlY5=Q],=qho]xrK]`2O1C(~{JOG*[fpiuyc.^[uq4$wHwb/cCZ$>7FN4vAP.>BjHsyZ",4Ptmm<vW7MW<6qy|wRif#jb`1}9I}zb)93xd[(F:F;)!_f#{)=OmL^)Il0]jdnG`i:LE%],d%%oAU9Srh)H.oEph#x8Y*AqB%M@Ltt]jd#%N+%i)_0S$8R}";&%,6VdQrG~>p2.7&jF&2">k@:X@#LBf(5Kv.(EC/J+mvAOF6HXY#V%.;P+m=8v}9).IliiV*Ua*{Q6j1[]gu5Fg5.k@#p>5zD=^~#}?[nGu3TGdk.]7kBs$7J.QUW9M}";XASX<9B{A?~3WTyRCWzWIp_P>UjNLg|c)@A=Xnf),+A[><RO89_RL.?P7hRlq!sf6$w`iQcH7IZ>{0]MZ@:c5Q=+(N}v=l&,{#fr&foh6*C>j6J3jfLs57qnjikjq<&TR!*fA[/rU],4Zp&%h&9a{dKk%HgkM]iR(]Bt`][?Vq_!>9JGl1YR#6Wvb$F=~>k@CJ$z0^k#jb2r)r&zE.Bt+h$?W]8`f63QKt1M7cCZ[?VTi!C{.cIRn@L;1@qo&o+;mZ0.&d%ioSDp8:&{+kn#{hUe5ZL*$8*;<mb[lfY3Kj(x/{R*:!e@]JK[E:BoM[k:_B[!4zgf4CH/9=8vFD:[qkj,Uc[tp3%#2LWc_0@IwDX/o:0v=8?nU=Ezt]z?C]Fj[R@eV1KEA1SI>0(pFc?<~a0a(Y(3Qn"[]+%h2^5hDsnq5ja~49>7gl,*f2>LmzA`9Q%!+ay)Iv(Ac?C_y&H5=^9K#3?&rVJQ<GaKL4mTz:dc/mx`%o38lHCe{V!^D*Mn{Z_xzsE`m6ys>Vd8*|xfV%kA!vNM7(#?c0hY+dB7p~fJ(nV.B@AoB%7nj)j*7bJKUcx_WQzlDkTUO1ivOoaQY3*uh2LEqhobpsLOs1X*yEFp,iZC<x&NE%?rVQy5.nY3@O_?#7OY`7ZkE7CZ"BDpDVge_.:amFR]Dhn0IMaKFKRc|@f1sm{PEbG:?.Cd_yo#;;GBS)?8yG;{MK5=2Iqyk[?gQ^[%:^_dN&HG;;%Hc&se.`,JZa1OGtlHP"V<M4F{$z"9F#3Q]nXHxVrs]@{B*|HJ4t~7[77vxZjyQL!.n?2_Y!3Q"n0S*;mMg*H/nd[Os=p<VsOKByAh8{V_}M)KmfvwUlwDB7]|$g+2Y2)9M8,?`|_`!UzqYets6.k%CCP=:gm>dkgG+G[Gw!NW)NsaVDsaQiSQ17B,dnC;ciTMso#c_]sl%KDkG:tx4ty}r^ja69=$J=`5TW3xSlR1"7Unf)p^=yu8O0w=;xT@K?qs>r)U;5/YjSH5vGR02wc$>(Ua4xyqF&gpGpR_f9o=.;N;o&AqgP?JRJ?<6168JGmRrp$8d(sG#]LN$,cz8}?zYGlBSK0KK?K7r#}<kBhcRfjC5i+9#x$@Pf+|.XW/&E(H$;!%?%=Wgr+Ujd]f<+4s`prPRa;4tw&x4%(xAK)b;9A(WXqK>2l9i#)i6%XJ(Q3}#d(1r<e?Jt4ea]Q.,>Q.BWN/Kvg{H%qJ"p{JAMO8%zR2]TN8%z@G0/Ly9]|:X4xj}#%7w5"Za%|Os=6LI^:~R#K}_2^UM=@9J1Xa1$U=|yhn@*M6OQ"xx333"v@kWI0Zz*M&]_9RA)4M5g}t"]!gy,#3pZ[<mJp)u6)Cxf5CCt|55^X%YGE|N6~7_hA=yqak:*7)uEll;/W5ryzXnpw#fHvh<#`i/k7vh#|J~]dB]^57uW]o%>9;!<8*uJoR&,dv@7eT8:2(hg*{|`@e7Co$2(`J*Mecspn9RLX1B3F"UJQ=&/.Yq~s5.gc$j}os#h*b[PHPmxX~E&FkJz|#=d3uWdKzA$o:);MgFydCuFGy&1I[qQqdOu,E$$[$*kL}h+He#8OEk*?x2MTU3Sv88]|jx[,x%k}]Es0p*N@V(vIiQf_/<VDPQyVZy3#i,C*yAXwcrBBii6LD^1:&eG#i/hVBeouiUw"}f,Jt&Z*j?v#iDO%GfXN0kwc!maX*}hjNeK}z"}c2R{R8woD(CYyN^2.km]AATT@i2cTg,k@2/r,S"J7O<19SNuYmuhfi,x<TnSrRTs`S|1y<D(`}8aL*rlc:TFM$&;(&$St^k7Lm%V6bi^x1*q/mf%t6}:K0<;s!!hlfM~b1q#h2_%VF4PK*nvLqHzE$IqDE}JylC|c^?^>@?YX%U+n;89iGm^j6P1.4l*aE9lVKP1yF$)e6>#g0`VH~"l]rY|n%O9H=j<jv,lth,<:!"<xvwj[@fhG,_]>kHX#<_?97~Y&z6k#nbqjqOiI06k]!cC%kaJy#OJRTeiTl/*#S!Q%80s]ljf[g,)Yo3Z*{)KpoXh8a?S",_hr}KU(NQJ|n,+W%lC6Y6Tb{.$}%Qy8Rh!wEvab/mGZ3j~i.Fp<g|>eKpSzhGh(uC&WSSR%85nVlgb8xk/);jrT46w*6~wZIj=C`/[2$6^>6!wy|>Tj|SZkR&%=Wv)@2~Hp|t+Dq4~F0"<ku]ws[:a7:)Z*/g72&zxev&YgS;;J)CLG[>k|l~j^ZYUV>&/>e#31|AoMS0cItnskz`7?nY*6xqosxZXy$Ce]O0C3j!d~iUW?m@B.RM~:j*`h7:XYvr[%c2;:!(%Jn?VtoWJC{<S(b2LJ)(Kew!4gVp:mvv5d12=>aMa}1.71R@p4mGSGH?]Blglx5C}(rA6|@S%RO$eEz=kNYX~LN2EGd9A%|"%l1&M?glofR(|+y"SrD4,u=8@]1yb:*kpu?a%"?A]{gAYb(Wv)C&c^E7delS&.aloY{9wM@[dV%=dyxzFv3s1)pNJ?wtoeQ%|s@?eK__,BLZ9^dEl**f:pliK6QW7i9X}b&f8#L$A*99GO2cC>F#l/G$|UbkI62?7"WJvHnEP,S%H&+)Z86N"=3WTKZo9LyG{h7pRE=)wAGwWc~CB~Fd(9CoAI}u{n:cki}^.[~S2p1Flel=)/L*f{P0:+JQ6`<*?k@(cPG&![#j`JXJus>b:_g[*UD>+CI}0tu$mAQUcVWg_U/<!UEQub>4Fno78x%tbt}1T]RL<(lo8?L;xA:>78f0y~`Y=3;"`/E(1)aG{V,%W2(0E|M7[%)NT79dR[K}<q&+u(7.dmuV1!VO3%B3zFBSAryunfGa%&z>V&;I%vqF!%rURcf<gr!9X+*N+^hV_=R<)!L;#>7`>JRyEQaNh.#NE&#6^;O.rq#kN<QUITZbIMVQ?26Xcqw_t><Fe.K!Ks1*m~yosJj@3w+,,}tdW5Bm/r".j+IO0iq|]^AL}7;7U1AY4!F7y[F3!vq9jc1fm7CV%IMo8gYZ^|.O1#q#PcWnjI1$Hk#97OghV5^V`?).s_!>0Tt_;tw78j9P:QnY_vkUzh2AlduA<Z!"g8gjWB,;9E{chujE7/h[C~^{JD>PoP{^]dg$CbVTehvN=if@%Tt/<we[8fNJ7^2MD]nGhBBW1=(dN?gU=>lFCmq#iML!u/n1_Kh[<]wX7mWZ^5ODYS@PP@p58gXt%5|q5rS>0z5Ksp{NpzGvm3PIjG^%5ok9cM92{0V@(Onb$oB0lUc4xZ<%<+dB.NM^]o4is`z|NOX88rB&/zs({<UsHbl*94lP_9Wi>3:U$3O#_$jIOrZ{`ab2.o^3ax!f;P8#7f<hHH<Qd^){n?&Tva^YGmyAu{)E$o5ly&}Ger2MoQ.!?na&?>aLzwxLydgN9tpt=F*"D!<9]mxwqfK*!|JgJ5:ie0BL@gp#AM9{2Mf3Uj!BFf+`?6?X,,15)~I?UIiI*]0`FAdXNknM#M9I?(N#9t.jgm&=x+?>wb$:$0<9h{%Z+0lqb)L1Vid`C:,8h7UE>>5xr)MX7%iZ*V+fZ7:}0Jo;w#{%lMgE[]<c1s{o&q!L}#h`.!x_v7h$*?[Poek^cf@2KyYd/pUx{:;0#f}Lx44wB%g>CwX8keKS]D(f5rxn+,T)Ysu/FW)wbtMSDI:ww#Qa@ax}C0R@X+*lV>(hY:cX_]as>!#ml?GX@5jO`?yM<to#7toGEb}&g&%6s]xckMl[HWv8zP87L_bJZeeb(a,Gct=$&~29YLZxphdfWidB1nuJwYf>$/m&:bjAc+2)cQH&ixp:%a.W$b8oY&ixpR8/c[)yrQF~RM?1+@/`HA2e@1;5g?q[R,/^m(f@e2bp8[n5^X[;!5Vrdw[WFIPfME{)D{TER.&QhMN6]su!HBwd#=*i5T},!N?!I>?{$O=X={3i]B$dg!Ld^W>:$ow3n?G1O",B@x*$IOxm|Sy.$M;!g$PM+Vb^5h@9e,Hf]lyYn6`v9[]nh__@cF!Fz~EOn6`[L..([3$?!&;gP[c%KD{BMWSdJE<]ji+CB)W|BF@5:xrcIM6P8/Z7X3&|Ej{(gIE:4ysrDV)tbV1<0.I)]}9..>FZEor>W4:0y64dC5zZLTt.I)]It!G]ChO?m|C:4afNPFj4:D)<4u4#D@Ad4#zfiwBlcXc"u<5_U@Y(rRj^PMU@2kEN?zcZB2R|HPfWR}Y6FC^WORjUc>o+t2CIZ=Xa&c~}vg9!fdh$O%v7*tPF)1y=PgH~8AuP5lI}94!^Ds4^]vB<ITcyHRAuKlv:+MyTNGKY.tPS)2YE$LHs4_u;"0_.y$WwDX/Y[OCbHT.M8MH?z+&vWs{J,=.`Hp6hivtKQz:[|]qLQ?D.UUd}2Gc{O}G.1EFN*m?85K>Pe7J,RVd4L`gG$poz1pQ8L>;twobE#YeTZTPuf@H"R30t;RG{horwyHz"CEJEA1$p!>+non5eKP|%.=]@kV>U~OC@B9&aYmxvHYO)3m({~CV}su@;Q>Y.VBzp+Ze`N!k1$TDOpk>W|c(t|iQBc!.~#MP|Z)%TJn/itw`cN(E#N$Cqc^%B.&KB=N<:N[LA~1PWc/C#d1UA$X*fs^Y]4ZL>h%@_$uHc!cZ=MqUI2[D(x.W%CHcJM~$,4Jf30)^ZVgh9CsihmcB@U*{6m#}zQ44lOlHfhesXe)vD_vq.1N1urD&Ipi&ib?f;kh^BL2tm7F,:R!y9)NGd#%hGe<#VWY3!XuGkI<g4F?4G!2{XS[L#Z/42L4epoY_`)X7+^D3$wQvLtkAHBsfq?]I7FoC@mLE`.ZJ9a9V;3[mg^v{1LIxhmbW+K$ahe:)]5ti8=}[/3gJd6,HFuB{.3E4)5?n}*geJC3/eOv_b):`kYf"be8t4%}96lq#z4O*YJ^oXhyL;!drUsb3VI7IPh]4sG&i%C}!jB_Fz18UobG0>*}32$y&}KMy"9B5=x[C!L|jj7V.PwK"+D9k,4MKuF.veRbIAA_M%t/1.;9F"niTWQ5?~?#*fxv&hN!AxvG5&CoMaYSgq!]vG9E5Iii}yMB^]26}#_}|U7{0sQCwDl]k5{=|"Ch["vg[;cob!dj<.TG96)4Yc5I:k*[&p7b]/~`R8~vB],9x~x6+XfaB|%NJOE=)lT{{D;z_+RJkVU^/@WpO8@DP+wHb@aW+s*|.uUR?W#Z(L?Zh)}LF,X`lVoVPZC0/v$5wS5GK%SLuD;Snt!zPTh,yR5Y&X)v/2H0n,yL?ZhN<wbjs?Eob%28HgPGkPw}CU+G]mO,%~e?))?$/o&0uuWs[g(`XfCHGxR~Ahm8)=36%j(Hw)biPe_3fa<OFeIdXpi?DTuQ{_h.d1enZsQj+upm:,UU]ILAg{l"j/,Wh4_"}dBbc03}I(D|]B}vxss]4BG;Z(U)I}uHV6Gw]@OWN&YEhdztsYzUd@0>J6"K``|SRUc(<u=,D|B+yTmH#EgbDB{vbu_v1J<)Ut0HVqD8.+}=|_vVPN._|UD:r>(Ti3.1OIM2dNp~7eJHPWXy3[u]Bf[i24+KZdSk00.sETO)w8:elp2cv/4^k8)PvssB2rC?u;F%E~S`q,uW@P2D<yxiI{V?S3ElXy3!wrth/;sOM<1ly~WY/;sRM;h8zWh;4o*_@K@ecxw$S*J,(qCL3{+<FXOPh8G|Ae/Y1"t#5HnP>bV/nFEdXVvMW%gn$1)oI=ZPGDMceQy=dn$~g0EQ|sLO},B;[zMI7%2(UJ",/J#lI~)ssp9Zo=d+f_<DNXeCNcY%0j9#8G)C}Vk*mL~?`Nl577RlU>u6}1D[EwJEm?PopYXV(}=nG1V20WUojVFp0r%]e}IJJYYez/tdcKCxU4V;Zu44{*SliCfYUvD9qydh9@rl)[oC8m[*?=BQ||Qs>l{]C60%44l;DuY;cLKnJ&#o,r*u=?n~!De:m!3v0(WB991n=mO5&Cf#&`|WsGeEKlg}82Od`AfG9/7UE&4]nMfaRDP?9f^0Flky[HqkZ;pmz/uXyRD+k_(F@>pkZEuIWdGJy|%bYIeaDO6Q0K%J2G[^?MFW#w5Fl[aV65<B050P;V_+s_<#(R%R2:j@3=O/8ZDfK%wTc5K%>?NZfnaegA_FrbF+PqZ`XA{TN!^O|.hljE#75y~;v)J8rwP&e[;1:(t6Zy)M_Sw^,]igF]<EtX>Hy<HVKgB2/gB{`JlfG8EcZD)=eiPWW4+PJ`|kXkuNv4G<LB[XU?/^(7k<))%mM658E[..`jVE8UhwS}Wy6Knh;#)?UU0;5,P0w%PGBw{Vbxg=:*z6snQ~2<qPcH|tSyzU?WdIOW671b.;!0W]Cgl>I>u|*w6LbM_W#/Dy}?ym+?0HVUh2F~2g.qN4J5E!^tM0qHDOAJ@2WNwCXK)yzIN5_sQuCZs|h/k#Nhb/Vt16Tob$^E!1+EBc/Gf_jX(K%HB_#EHXkM_K%DY]lOITv6sX@z`fkqq*3O8n4b9bw3Us{KiH|sSp&uxw=qHrD@"fS4MZ{euTluExr?kvO(qBPyzu7B.N*#[?;~K_wMWTcL_~V}IAuP5;<X(346[^epYNjLOuQh+_jvpX+_=E|XS^ki[(if*QFk#p+"DQ;rQHM`EfuH[~E%hL1#i<I/;>52*s*fu/XwS%P:XJuovJh$]55w~iNV9ce=)*"2XRfbD_i:)q/XTb{Xuov&CXcX/MJ>9~)5JZFFC;CbgeFARWJ#;aj<]9kiEo@J>v`SF9]U!YSc:_g8v0_%i^wo9}Gw8U<O2G(|VSh%Ck*0*3*S<AqArB&UMH<]p{Co]l)0r^,<AEFT609sKfHGf0;"FIj5he(Ow+4y_1h+;]G1F4qTcKonF4b<=u6jv/6r5Mx8*>erL,QQOvU,Op*~QGhA>tQlF.6KaIx^5S9D#Q:XfTGIRuV.G|57si.j7bq)KkDS5WTkx_2Ao&}Uu!xyzGRkCgJfYMoxSwif~5w14d:10x<btiI61Fy[@EWooE`rb{*#HSg&zM"tsof!8cKn{b4($"w%N5M|fT4_$<iKDGM4sd)4Cm(g!j?_idg[@UFR?_nc5WyPYOc^8LZ&g.Hf"<9~JTq,kc4aczsm"NX=wh&4@&/(U`h5oaZa]@w<RaiO!yys8gG{n5=LY./J>M8EMo+U+EtH=JNI}0C<EEw(T,q^2oGT/AyMMWT4fQ,H$jnX(NaR4NpyQ]XyxT%Od8K#rq5b}]E_v!^(tqPx^f2l^s<vm0p*}$LX|wF![65RO{oktm7n5_N5+h;6QZQ&M3kNJ;zeGwi.|@kl"&T)6LrAw.Kc32M"3K^<k7z`c7zLqp<;ys/$d{[Mow{0IN_YbfZ/5V8GlB]>fq/$dQDYZ`g~k;7O51tn(Fapn>9wCSkVO}|ILsk#||vGZ2Z:)KDX#<KJ]#||v/miYjeO?h|]$;d/m1f&OLW?ciY|&ZB`g2c07CMhq"7$(9K9x"!4+:).dyBegfCVuCBr(WrRD}0e*(YL9^02kNIYtMDX96cbpRMeXOJsi4IF^7*aP?cg9$]$>r#MgN#*m}N0!_Fj.8+6VO|vieXstDuuu]OAQ](%FOG)2SQj9pgYXqc_0&?nqDuq|yhi]Q;f>:9EHUR)W!@Bj>kL.Lu6kX+B%2x*L?n@p{#A1M*;%Fd7XF,pP6juo9uQs&5ud<*ehTM,S=8^.[b}M#H_dS2F}TeD;DZoXF87%H8h9p^"qVNgk7;x!EhR<?gvpD5Fw]<.G.MpmN8D8fl|0_(Mj_c%KB6oN:*o2U0D]:3`xFBrRJ.xC1B@BV!hdzTQAZWmCDg(#[wUW^v7vtpxFU|Q}OCoP"IGu|l&pRG:S%~UrC8idvHH<f$(H_OrFtC5/.pF[?=?rR:)1$xQ5PghdOf<VzPDd6YKK!O^pd!9^oo;us<080g(uTr}2[D:c(6#~o$,wYn@ON]bS)|^X,B5{[BzBNR*nm<:[A|]uW,E0<j~tjjo"{ri)bT)WIDiM_)=~)?m+f=8v1]~EJe~p%VuvA7u1sntnqN!a%m"D+wsX>~6:{b~zmXg(X(T?j=?_DIN2M~[BrqpN{+09.zhKXH~5$V)*{]nRWz4%xt"NQg*(jS7@ArhOEw5Jx!BLI:*8,|kke~WZglovW6X!)Y3z!YBi0c6Dq/a^vB6hnQJv]_>`T2=w>1wH<Lbm}D:7;L}HEmsD[J=c_y@"LP|v7XmXA:}onZ$k<L2N/,L?DfdvOS~9k6WGRj,ag^SO9Xp^7(xr7eM6{[h,NY=Ey@[v9$!M_XqZ1e<M&]btpb_ygC_$OEsBM;}osv6S@HC!usDkvPPuXeD*u&mw%8lQ%HjZhI|)B{vlbCR(|y<9d@B(e@}y?t<XkWcGVZz#U|fOyKpR"vu;+actKfl_Hccs/:%VtR"v;M+l^,.Q2+T9>?0^f9EhGoS{[xHuotpL,2!=TW%/o3UB2/(9=yrEy2K^(9Kz$?zWIGj9f!wX@/*#VOg%pDgdyW_Y!uDe7XzlRkj23i+kl%.Q.5/x}v&qG`2rwk7;T2,&5+k(Gjf`}_JiTMt{^`6c[_l!Sz(VidH)8I#`aRZ^|I`jTw^A,4t=X+}Qj[fMux_w1{4@ulE_pJ!H!~m9i$WD^c%41EqFuDK#&2hg!;E]e3xgiJk.p]>[B0+ejbC;tpk5ol_Ms|?J;?`aC_Aqz<!,u}5,D7;S8:C4d&yO"r>*2m~#1pV|~@^dl==.9.&4p7^8tZC|_~}M&Y[7Mz9|*e}ti?yyaFKz&602GyuuAfvfk*`k/;kN&#x4F%qRz)S.s{<N5765*"`8Y6}fq/>yD09$erB^w/<!8sWW0eXts/_h+D[?Cr1o6RtC>jtVV{nlYxj~g&:<ERm`fVwRA%z.nEws{?RU)Re2w*xC=[l[fG5L}V/ye")3loo|Qj%].|jY^>gt(JpQ6I|mi/2uqo5gMUiE(DqZCSp](tcn?X(tsHK.lo@(MQk/Gyoh2h>u&M=1{jbXS%c9M1!Kl4!wrq.k?S84evHHL4c2(kxvcH|_[fhGc]hG9,Grc9_d9RZ]17*&iVXpv7%LiQ"7QnwUn]RnC}Ek@un`i&Sp2T}:x@rH<aV$F227.{HNhkbu:=[EALTvsvC{a/P&.rucsK6|KIc|L1|$1*1QC)`R_I5p48Ty*S.NT+lj1#o*(:b[a>x_oU/X+%*0ei5:A2$BkxK{lj+4?rJn=@(|;fH1%Lh&s7~Ez;^Te1};U$ooi73&|frmf6W8B)tl/2>;Kkj`h7S%D7"gtj6SFQ;:(&L&l]W$LdUdur?Mp"z?cWY$+NR&m[WTp9`.J0O1Ipq@>{E//YQ.bJxg;+so<urE>FhKFqzHS]{d/_j39zonXpl,9t]/R4jin5tbDu^M~1/jft8z*&F6kU64^"u`f^.Mihd^x/k/X*w6=wLqQ_=^f335V1kG/!w2)?[ZSM@]Qz5xtYBLv;;1O|RF2v:+9P|]77_Djj<H[4s+9P~AMI%]q]Hb5N_N23UE8Ig&0K?sZmA=+im+:5OhkFNi$7hRu%L_5VxBW$=(3Ycqi0^]#P=HiPP=Mi;r6i$YgyCezbwZ~,K1YIrQ1a[1]1)*"W"tnRcP6zuaai{t)D{QciZ),52l2la5D=+NK3PH?iMI0Q{)0&l`$1`p:Zzgf).+qzV*EfHqel%|~N2qHj38c&kwAY1@r3G+f2glT[rhL>j72Jgl{UES(s:yR}),RzyyAOtjhFjVOKL7aL|1M13Qh@@j`[e)Dg*_IoW(eup3)Z~[9i%GlKM:~!xF.d`Go%w35#g_E?}ZKp,Xgf%tACh~bY/cZDV/[fr?~nw}(v#`?:}(W|>u;cyGX/Z3H|n^{[+|k^|Lh_}m,xx6mBAnd+#o>W>5kstd:C(nBzhUlfi3MVd=UDZ4!%eU>AhfRRMufFn$Np!o`MbpMm!L(n/XA+rkyhN"N<B@rRcF{jZ*DSBU>@+I.P2n<YRy}uKhko/B+qXW4@V7EkM:(2s,,f2<)E:(IL~f0(|<Lq?dWF,]!rQ1$t%XoeoqZr/~};2TT{}5ai9W"8<SFqn"0U&NQ@LMw.V:2#n6uD/>xR`@fG?<CAg:6M.mUtIcj(yAL8D[t&joYYp&oy692xcL7b$E1%!K^7h>E:T7?ae_|&jWSeOqEs#v:T8t+%iEkFwlcg]h1N=3WTtwB{yq$LIExJ5s9[=v/Jn%|LtuMCYDNF/HMGHw=0KOiMEMeO0Uy2?#B)ot@"}"|"Mo{0%dC6Ca`)}e"ewPV5E{wD)EwjTirt[L&PEG:D+DO,T`~QW7OD)2mjhX#V<oR@F@>[k7jnq@)8M/3x0p4hILuhBM+B:MlB#Pt)h{1MbCAsQf7yRHRZoXBtEp2`Cd{H2Xhz|^`;%=%>geP}hAwQ87$[CSjYW<)8={2v+{"0gat:;1,S<Gaxa/M8gpRwp([*c.I9oh03>uR=NO#;=ChLm/X*]8RXGPZloqQWyu"$1_mIBLYhsl/OMcKkJ+PuCA<K]EBLs40`,WVkZq9h/:mScwvL&_w4dKg9o29]CY$En4ADfT89a(l,uv/5e&9ChSI<j+i?]r*$+{P1!Uzx;x(%K3J+%2KqwT|%._P;%m4Pz>05?n*20Uwi~onFhHHEEjA8CTBn@7&9hVEsW}=Ys5tZ[Vw8DY:e1g}"[L7caNO10ggo:[u0jYwH_Z}F281wkDNFzys0?D*HCj{D)F!P)HRcX@PGb]ZVGfKz<XdkBg{0hCeB"zV@),h4s+N{tO+X*LhCF@)QBPO#6&oo>O<O!1&W|y[yt+t)6:mkfR",FaWiE:3hwD%g3L+BM^/4U.~,|K!L$|YK,wv[>l=%d/#yRM0nrk_FECh^K@D`FZo9RVvq?q9$<p%(Kk<1@`)EO}0B);$$Ue%B@S<;4aSw16VQ!vKT%H&+}99;{g=G:pk_Pt{#8+L@kMqL0h09Yfb$mn{$s{^$)6Fb/6dTuo0+8P5N$.Qz:?;,FY,)/gZGB.=w;gp9O+A=VFqr{$`ySyA(^[~`h_t&JqAIXH2_(LR{+?v3)^3uUgE,"Hj9}t$?p)`(__~gRtIV@GpR5N<juOlP>QnyXM+fph9u;vWT}bGeL2gDb<^j(|nE>Q"P%4En*:`:uO)rBz0?1n{chd8v4J.Q!![3*[+hLRve{&*m0|Z*8}y)}G~C[g=!fkz{?]4{vLRto&T8z)A*?d=Wx2:B"0{T|^s&4G@pZ}E^;sTod0G=%js9OwG(g<;OO~rF(u^vu;]05;Kj,$be)v`jWZ9!F!O_ToiJob{`,t,_Df{SRT>kRuaec3dgTgvHw]s1jA|__+9Myn,}=_uM1M!Z}gEyB`0^vqh^d]|R%@nUR|sPAfFwriL)$~hdCO/,.Q?a]jI_,^"R"h3JGEllRzCbNv#G2Wk$n;X#n*+it)P_vUW*eR/BN19i/M{du312FUHe7P9lx{+%:;<A"U7cL,&1ob/sN0cJF,y{|ChpYa[;xP`zzpZ7/pHH4A8[6,<|k:/5w:O&I(mSO7c,^i%ap0$!M3NS)zr6[kral]V<b29`WqK;#7N.z:]7_?&Uv`m,}NDP_!%}ant&Da8aP8`NWe(+d=bGD;Lp;Vuw04YrPuL%W%K:kI^2KKyYbsRC|a1kc0|W$k+Im)Juu_<k4#gSjEHG53F[F)Cmc0gySNxRT*=y9P#Xe&wj$I+iwv^Ivcjj;$QjscD?9fgEiX~k$I%iIviiQ>w+RjSaR+vzV<Q2#Y3_CiLV,tWm@ILT?D,Er)SuJR+(Gkgi)FOB23[*zn_jZBGza4)ERM[&+G;Z)0_BRB`$2U)E^unO{uB){Q<Hh*]$nDb+PVATYw|C*E3?lE7/#f_`Ie#XX7T,w#u:@jGeo0[4dR4I&)DiPi|DGu6W[IDeDy>_KhbE$RfSb]tOE:nnwT(DD:Gd3kWh6K%O^Dst;(B5wIBvcAgMn!4E1uLq|GNFu4=`rI4Yy3:HB*+GibdQ_FdY<jlQ?4gYJ5g#N!_q9m[r1kX(CTiq>Sdxuds<VjJI0*<HgY!^k/h!obWW:h$`^tVsESdI6>xo=E:TMEPqZ!g%nv<3@fzI(XEhyAw]CpF;u}Vvm~8&8MZ5v8{ePcwABPi87PYmiZ:*Ye?CiE}/(oa;=Jagv1W>(;{#@f0$X}`ECrv&gztNu3o9iN?I,|vUV8iKRx{(NV.z6Aa!5%M&(yCJ0uE+m70K{L(U9r7$6DL6@ICeL6VHXL@:w7HBEd.uD*:voXm~Z9gcD2zU4I+VPnf8[l%4>`wCk/#7dE;^Lx4LMA~};//(SJA<c^tO%JJv~fiNTDP)O4Q<ayYc$muAwP.D}uGGAyhNaA%RAihSNN[@pGbBc",;bw$uZ$!uqyQ2Z%FZ]MVoAkO(x>|J:;05$4u%/v5@5,#/Wm=aKq<pgU@@pk!r]+"1R8]+(qgneL3E)?#lOn4qBf^U.Ip8qkeLt&^U.I7{[@UFZvpv=8v=A|Xh6EGC^yUPB2@r)|Ej&&4En*B|r(37+yY!n!H^I+Dz&CL&gqalUX|o/8&;p=p=JE~fS"UU+1Ihyt6[w}We_b~2.9Xj~uy/r7Uh2nhr]O9BNn+9<;jlk66[{THn2;/Gvl&w~(Zlqwq/cL";FR`s/)JBk3A@<W&+D_WIhngV[?kps0&sLI_>*nzHONa}kiUu>wvWX(oDr8_Cl(q:C+0}Avww"4<%vL8Yl]D.whx$SO~}gK,|f.1D1/x[GeHPOY,8lb>2#pv]1R3M+[_oW.9Y>x60)T46FonXrQ9sy+eeIcl8}uh_q|mq_o=L_rczr95LPUT]#iv+V?HR`<6/2hO%XzKtaMfdN9Pdc:&<FL!=.zJyQuhiYzl^@[7?1n)(+P]t@}]iWo~>QMeDqH%A70o@`(&4Ie^kwD_iNmcWnt|T@CVXEiC)phf=38e>yrZt!&$*Pi;Vz@f}1JTWb`#crH6C|/(;j(vB;^[{>?lS.V/,3*,kAS[&D)!?Wq=jiGs>n2RERe$%?r+nPyF/bKLF"El~R(}9]4gtZz3Q(kdK!|<+d8u?f984y>bdtqZ}>4z>n3R~APSm{LCe(fB_6p,4Ceh>y>.31TZ+Ez%tRxARJ}bN[QR}!?B!7Km|We(Cx|nb>Z&G9D"D0:[ad5J`D6D,QQF0Ye&lra+fioAbN8r*lNbRTEBiKR|$x*aR5_G5Ge;SbRsfr".GCDekD*t5a]8w/dxHm$qo+WEzPm,ugb{6cNJHJn2x.j?b,=>`Dm1QDE&Yqo>rnQsO@w?M/Z{B:4<x"eI|t`}D@;,CSoF%>J7Cri|CQuE^#A[&QWB)9t&TVBqnn?$g?()s9JJ&*,iT}&@EM:uHCe8>|r|L6=a/YD"=HbpbLRP`)Mp4r%f}=`Aqu+pgH1cQ($Af)zr6f!]A|bj`9bZ]~w`y(.KSro:(MQ856}XQ#XjmMQ^Tz$LC?vM@(`gOktXG%R+@UMTR}lYeF$RRRU89gDr+D+~;s`=ODPD;VdgH$qFF_@1|K1&4lj|1VeL&h$#DipGca#kK?n3XBgK!POu_U%FFzwu8XPfH_R%az.UU#gRccR"3wB!`N#0.>r2x,u<"c%{I8:YE<iL&mp#Bn27SG+JCgD~ku8[DN7l!Tf[;?E6Yk~lwec_H2P4d_H@}:m<VpNlyEs`}x8ayLnS7~t|/CuoXUXXJOf|]A.}}s+Qc3Q.X%qos$nh4dj1vt`L3{5"R6,i3{B<6TWYD7b]OiY<uFF%2<67,F}3aLKb[PG}J1qgbRzji311+[OSIoQ]O$(U*lJ{|bY(tgbrEi/bQ+X3qsH9,*i6@6fz:^a,]T{@D^7]a+9W{@D@E0QL&L&ROaD@EcgMUs_q_2_@7?zJzWHkxMcDM;Mk|ot@"vRGBI!gL6PznKBMieXF`pg@Wri5Lc:0HlDeydOAQ6KHYO)X[[w9PV0Fp97QumD}O(V`BQ+mHaKZVA6a]iaq*:*p^^PjH|&G&u83iB6(994;(Lb:;g(Gls1XE0TZrU@Q<y8u8wUx%YEfq5fAfVwmYoZ^#dEhf.38QCeFj~yw_xR5glJ,Fe+ZXo:%8b(B.Gs&6A&DA^F>w)WW93zoNfc)K=w;[UY^J<Ds#=[28y6CF>YU5=og)|o$f:ekX!C0^]Nn5{g0Hc6GI/8,BY1Flm+[mWB<zG_Rt=l*aR{<v@PBgfDQR)C!w1y<Hr_V)f>.SIRT5xQ_nz(_.VP[(,B![WT6}$kx`BsZ%T.,,tSmi!k#r/k=jM.IY{35d"T](|WwHG5{h{ez+Kl4]K]=C&KvGSJCE{wb=:[Br%if%<TzW~}kS~DzlF)#x""d&~(_PXU_O$C!v4=*,>LYiR5Ppl$ooR5F]%wQ6A#n)9"<`7hMfXqKhd8M3U1J!yI[&u83pjh]UN?hRKlvqIe(1=w5*?i)ZK5yC*D.mf8M8m!Oeqw}hS)FHs4t/JxPzK%O}kiDD>P)>Af;.P.4/k$__}I8=w8LV(u5)_`E208~^H*yXVI;_f,@n3J@%NJ0:0h#?ve@ujxm%RvbPmYc7Jbfb&uRM>EIyYed}^dj(KKGS1muPLnbsZR6:zL6KtOR@6`$W7ZY;RiA?Cjz1GeyXH4ac(MK&C^ThmrG>@@G>We`.hL}`BFOy;WWckHIzoOc`8uoLypT8C^Th&W.POxJ7V:56]4YHhNH:D8fDXEw]W0R?4DYaD<3L=&CTN8T~FnrQ&a:s~1<,S1871Et|&Sm7g{wZBmhb4HN7,@~d)wj7YN2Q0xO0_,}gLJc7p7P.adjoSl~fSrSlX1D1o~h6o+SpWW6@L%MQRZ4#N;h(j7x;l];fBlMcmo4=0$U$j`"$"d^P77Lo7ahctgh>*%uh[Y^Qpc])"O5h39J4Oi0c."),d0!,R:y$Jp[LUTM5yd/}D~!7^d!Sg:{?D~IHRM.|QhQJ&,_?%qRO&Y!$=907@I!x,@r!vT;IR.m`vxX1O0e/}gbJ4xvXu`jcy#L#d:mW&xn/J><Ua/">o#Df"trH0,y%@hn1lc)w)@w&kTS5bjlT#6E[/4rH<,lo/:p6^dZR&,9GL40cO`y$MQ27rHT],=Lr@eFR/RzE)7Rvs69j>*d8w(z;*,&R(N*JMFRKaKTKSdd$RAo<cSpN^t4%Kst1"WA]5WxUpKTu!4WrQ"@;>3sPaZ@MvA6BJ:R@?*;z^[U1Y3"8X*b=4@bpKei!Z8{|wTO"/1wTRyKFV0$13>h{8+IfH[Zzo/4+IfY>bkcBPwOF}LTyz{"KiFce<5rU+I,9XRGMg0U7%Ngu[,5}Z4q{u,"1Um?Cy+/FVX!w<v^6v4yu3m"0@O.G<,Kt_t4(mSMChdZ1,}y<[2alk&f_x{%l;9)F#S_*%~Z<xe6ux*"H,H@*AXE"ozz;!u6Po@kYHf7y.kji5ROCP!QG^yh+00w:)|2MciEzPH%cgjBFf5%i,1w$?GbGP!Xh*L&[:H)K#h!&Q@^6nBLO{WJ`TN%!VFiOdo^C?_F2{mW9V6P+V;RL0s}T"@0F)u#}D`gxSCvS/zn4?LZ55@_`G@#{;ZKl$7AIel,T9D_l@+A+{C4LxJ0:?_sQ<%XhOZv^R`%|%mRwM5A7+p)"3XbI7J#rVE{ABfQ^np&%iw3OS2"4;p;R}XoP#*HDceOXHSAV(9tmq;emLn;8`X?j&>Ide_(1:HHZSME]V+<RioD8$Xm+C%A+hx&XI}yp3(I~h$Z,%.2&?Wr2hISz+R0:85D2sf>5xZv%Mt/YJkx,lRYG``fRBD67Vs>vy}>O=<c?||hE0/VyM+>G?:lq^d[F/LXHbm@FV7e<P9w"<HK|@yg[<}zHFit|lgTXX^iG^uuC$LY"`q5]@,Z{}D:}/EvS^QQ1PTFFnX2d&Y1"X2j+E0!cJ,4IelHt"@3bT{63+3eOt,|@%MG[PC!P|^xRB2ef#SCjsorxb6P*u>8F],r$2JMKVM~e2MztuV?ggj3l6`>*M#o<pKo|<f&cHej#g~ekk;lVil2>$e}J<KW)tFm715!&1N%czl:=SZte~20rhd>X4#|N^m(<tKR|GJtMiLOBzucHI0$4PtC&YEb28{oQYu9xiGaUmLZv,aCSf]iY13i[a(GY0FJh}|p~g]Ekh;*k$tVZ/9m3j]V#m`<kq#(U=O8?|U5Q=Y>/Q;0cDVNHAN(xfwLrs.#Y&zJloKBDCl/W:+`Uj|x7ZBx$>g8xKYd3^zA{#d%3hmD6kn7i!g(<Ea/>%NQHmXXyUCH%S08oeaco^KCDlGQ3s5{MYt}_Df,^Ln~FND>xoC3/I<M;szuV,JuuIK[ER5zyl>2vgg2riuF9Xd`t9~ah"/y&Z^kLPJN6UKIB]Lb3^!94Kqcxpyw#`CEO*Jh3N5]sbJ>/to`aywi*Aw`hYP&_~ky,kl{Pv&u1CIRhC.!R+`&LRO@sc{#;@Ku=LH9xhQk;9PG%+[R<aIVGDmexLwSg[?Ll?!Gff1)LPo^((3H5;4+As5PKfC^7b{)8V.bqKb[|]&tusU!LQDu*n6vYkiKg$q04yq:>*Y4x2mw)o8#(tvaf&q4f;Uk#8LKqu7m?}teU~<Ut>f3_Bf"[)4*`o]m;AiV^J6QWe^$bVdO6"BHIm"<qU#ODb3Eee!5H}1F{h[Y4QaZCn:`@_f{:B?u%[.=TmcGjw^#qnm*@D~+NtQA8[4vS::2gg:Qd;w5ET69x`;a]4vsI?r|{^yt!t+pD58nxE]#ghEk#2X!d0ti1Mm;YR6C}yPWfiB|p^TeP?nYOTt)/X1#1/N,]d1Ig"(Fiu7"M?U/Ie=b>=7!W~K3&fC@wuPoIkXUESy~E{g^4PczpsH/NTZAi^`x>i&W%Gl}F_,i[CU*vhtK9[#cCd#9gq/JT?Au3ti#zVJ%F~ox*XE<u_gxX$ZedX0r9s,6lMb&7|Y}P@E4Bjyw,X{3v~|dzyseby3grk:TUB%8a9UirG>Vlb${8=4xypTRbqD#Ny1{p:>zz(?A@];Br5Y)9u{c7kg%gJ0VoMyu/.MBA&a?AoIVtEM2BRD3KGYk&oFKAtLhew72dU#]WsuhxmRAABAAAAAAAAABP&fsCX>xhPlPT0p^8Gm@vv;*jb+pkQ=Njpl]$8=FbApnVin$9~<1cnrRoz6]hl}L*ir]aY*E,9$YG&1BrCzm.qx;1;iuoS!`k|XkjQ4W*U!&?E6i0G$sYMvFlQO!_qSh,rC)P*`eo`k~(:7URlx#,zv!uu;yY3>^n*tAUiR8F=yvcuG}UcJu)AOs"=$OX@As/umO8(*rSd?tw4jsm[n&aKi|It}AvX)dGda.oOLW!4~Y2(MM,bfhOIpc=Z1`"R~bDPy5EK<[O7+O?xc!S:(01~6R3{5P|&]RS~ya1<|g$9@zFATO5?*F]Bqa91uiBy6gxHU;ju!*8swF.~q])`=F[uuv|#48xk*@rVhpEvHxp^.(oF/d:E[>{q#~&9yLGTxAhA`[;3&@]x@]7~klj[v~&<^##{^6le1}XkW@hvy&EN*;YnP+kssQSB1e<wG{bE`xH(9yw6,.CoB&C{H~gMMeMo|o(a7y#kSgVzdYvX,=w,n`q^+Q|3|w2[u+rMd;]iC%<N&|G,EmJ8P=+>qWLsg!J,+RRWTk3|l!P_9N(0nGbR_/Y&D]/iSWg`UR`J{MSF=V_ZYdrm;*_zAUGxN#MvQ_Zz3!1#mmC`_stHenRqE}1yqy.|.o)IwB8l@9Y^UaBT+dEk9Jocgrp+cr0G`W.%Pl(_T!_}R<*ZfJUOz^.^2SN/n;+ORY$S>3WFK!P_ykf#F)J.F55M,b=7j>(WzN=GW[YonDrEr%?wkB53_T{?VduY>{mdoH5dLO(8mau&D<9L<u`(<5)qcQ/ua28T)d0%nHmC&FR`i4nAn?*BmHmWZ;&$OlPlR*tU%cd9rQ;vvWJ$f3+Asr]~CWm0;;=57e%]4VxUh][I;^{~p)YFfq/jPwu=%Yg=W6wTWSe;:ff|hveZWWr+&i,0^zv5WGr]LtrL!2&*>rqfp=AVY<|;JTZAu[m_K(bn>dr^k%|mQjV[gpX08BTmIkEwj7SkWjuoT6GCmHS1Q4@fPc)I..4=Gf8PR2:>}p+4^Da#SU4PeF=E8~GRQ`Xm[k0RruoYa>q=8Y$`>CiQFB36_MKr7aBGhS)3E(u(ZEqk~90S@M#SF<i"j?Ko{vfNZ{u;G#KS|4jl^YYww=t>+_V7i.;62YK};NMY)4{iq")7ON5DMIbni4v39~@}Q==!O0w)LH6y{Vi#[#_wH1#d!x;XI^p,&B&c<SR~{%?(AjIbrY!J:<$@YZL+F9:%J6^5WoS>8Q]J^Cd~&9MWHWz>H|ab:xQ>1Nb%v[p~JHDMFvd:C)u|D=}}Wt;W@Tako#qD9Ud,Ozav8va8!Qa}%`JTQO]h)*ED*zaQs.mc2Yaj!`7B+Ce!65VB3C6^L$UID{bj!@}M0IQoRO@fQw!T1+vBfzQ7t9pKaP5=)^aRP.Y;blhE@F5wVZx"lk1y"}VbgX+VE8pfKW)"N6ZDTpIQxC@;~cn}fX,tC0c{KlH5C1L._M[l`IXBcQJ]E*:h}AmXN@?(<WLjCtyLbRE|G(~(ljUZDgWA7vT$(Pis!r`ybb%zlf?v0Y33>*#y(>VVmB:&FyY7uunO!u}N},8FD4h&O:NlY,t!fx=+=yfUt97keYRAKJ9NNv.!~CdN|_yY+"#ZUTx%R|sN&J(Iq3e]V^LHL82:w2Hwn+wv@w8=w4P6uG5k;JLBm7RDvm:mnV=qFftBk)*T]vz`:B1SoXVfe2ltK^qQwVs1XJCd2J{nFD<ix3(QM+`ZZ=?)>81EQ=BrKw`XJl*h)]Bvh2b}BV(U**!0JqwGbU9zWY7^jwqFVAvc1_SrS7{<_N=G=uI_4C@;7@EJNee*{nWig{&%CEy3!R?r#;b:#bv]z!?U#OVa[{T4ktdDb.O>Th1qn!OD2Q,g?ij4uT~uKuRKGhNtxy=V#,RA,x.Z/_n;/)DM`C6w,brGxegK;rc<J`7QLvhw9:iYT0KgH]`W};PviIQh=JEiVq9cB[e2nPLq,xl)8|p&,e%eN#kvyR{Zr]Q+.RaiI|(SW!.o6abC8!y>J?aq&9_ju;+Scg)itXv/O9Y$i<qC|(}KE*lDa&+=xJZ=*/+O[%N.O((#88eX=n6g%If;ES>|PgPZX*N(qjq*#:kTuxEESy,Jl[574cbG|e}c$EJa?N5PWt;)#4!>"q=?yYS4?H8)KaQzI.~qZdFc0!R:=vdKa;y$f6jna]9Sas6tx;k[?nagfM@4M+Si26N="jz1gH?5j81X;LI1nT62T8!0.THP9o]wxkE]B3&9>M<t`N)??c$gA.Gr(]=9^NpNQSrJwGgu+9czKCW,?O%{f1W*W0Zvknnc)xW_tWMjC+_zba&eCCmSzf#oO@y&)B{B{n!j?0rhx!SRqUq(L%=UvW;:+(*vk)V">,".{cpd_&2uU=t&l"W+Jyy9+)K5(.r%v{W#`qM_?_WaM_hk`eb_QsJGvNG&X$DP.(AttN228$)G]#X9c4jFSPzQH=qravxQ3kK<"C7MeA9ZOitSvo#Ly^0f<|>},7>eZ{:9BUWxMUz)!4[&RaL9Mc6lz[J*)2.LuR8vNbLm(dPqeG6}w5~>71#j86LKRuDkM_?iDP!ms3UR>,BoP@^kB^1qzE|JTDsii/0y^A~sKa"K!5/O_=8}CDSXS=50M#$.uJz4uCP&t!Q)pajFZ~UhnZL=5l$(zf"J5]/Q_eLu|1YX4UoeRaQd|5}@0ZZneP<Vm{^LSKBJ8kSu@w]cPo]|B3}Wh?a~<,3FP"%s;h;K>Tl6#{ExQcS@JF$Vy;QKWo>=*+IKq<XBVf#IM?VQ?%FW~DeEVWk$?g^t(U31J#yz0:9x@eIS2dh~|EJB8Li1FkAt#<f~>>I:(vK%wCaTd2r<Q<Bc{4d}fz.Xa(>UkP.)Eh,`ZHx$>@)1."{T4K9Fa7n;U(dWGKE,(+3q@x5:L7.J:87YO3J_KQ5~9$M[~{h|@uLwdk~OmK0]y}hSGP:l31BH8FuWs!1q~}gdcntfEw_X,g$S;!%2s~HOBz(`WP[<D}k;G*K5b|H"/;DI%_761L~|8?CR`[cZo;+[Jr(,g^I^QbAJ)0FV]2@<LFhY7npT17H_B[S#r~wPlC$Z&LG5Yt_eGwmfPoWdc}Ux[#4iq_0?)Y4z.N[${4ycKME0sr^#(d4U4SSU1C:_b>RLw=L%x?ToZ{_LybI:X7>Hv_@8&11TasPD*oVXhp6Aqar_3njN{z4DNB/y{|L6Yz&j$BYDLI%i/(?G*ED;!KOg@]JigET8_Z$+?yrxj:cH/W(OR.3nE{<uHZ},RG:/JOmX,y`BI`V5408u^}WHLU8ZMxcgg|VqdGGn/a.H&qJ/@7~PP|)g11CErbaQoS[c~L24g@!D5E89xzO@C|R"QkP~5~3zE+[aekt&t]FZ1g]4e,F$kN+^p[`{*@(/lLG@0eF@7HmOl|KQvb2@z4K@jZLlQ==R.g67s,HtVW0$W&,dl>3Vq8}NyehgJ/};"!3+*RiR7(ce$tpRRfq@h&.?a}?,ORC8MIG$8WZkb9n8k?>M)V#djaI:T8zA*P!xo4yx$1c=#J{$Cpf&49+b%NW*J).oU}Y|!u.N4lGP{+=^ww}/3$V*p*/p96?*E"r+)qmSLW8a!mujpq]*5MJ5219I;fV+h~F4;Kyv"YwEBj}sOI0tUT|Dkv)Uk2T/pkwpbC.8wjv)7nM4xik36aB|ljW/::*n@(tOG2mj"Z7h<XU;P+rpxbfhR[x8O2pMX>Zg,7*9KkqGydp$dR:]p/iJ_6KH/zu/_{c(.XVRr4zhDt$3bonB92!vr:oD3XNet1?SMBUbBR"sKzYNm}fZ<Q;Ug7X)Ym1x%&k~<$J.g,sjx^|DYk1i?%]H8QI"Wz4jEopxm[EL#*dx=$O2|+N8MsEMzM)YIX&aFCf@TvOG{(]3,9o9pdFzm612VPs|T;^;r#a67CL7[#Zp(ALDb+cBT*#i98=q3:Om^7t%$<`U:6h7=oe=Fi9Ufc`tSxCKak_l}cmY<w|1SS$5%s;FDCk1Zx3|jUZQUm&T6~m{zq}95+%ZR}Z@$4z#u@=wBZjEghg1$LI&40{daVp<h/>>o;xq_,q.}ZjL>BOA9b9jYe22Q/O2,]qH7)Lvr#h>2xf#Q0dv8sp(alX}3}})WpXSn;7~36f5Op8JK?XCkuT`nBHkJGlE/#E`z"*u+np,Y)|}eDF^MHpKu*YA7A>>?p7xRiP7&#%,5E_HRdE%|;dtdC@&n.$Ae]FK*EZ1&zob("FNRVV$YXY5jO:t)?~pHH=<ip$t7{[{Q,e`Up9:HN1f+fJ48d)nh9|nM=+iVpJB8A5vDy;om8xV]qxA.sxi88%5U@nOH5UwIWOHRWkUoy7Tc}Y;JU4I=W<=9Dez[a~?KM?IF^P&f+`c;![)s|NiUF94(V_y.u|r/*o")ATW@Ig;qcq@}eN=H7H/W1*#dxQ/g;mNM=!QjSjDu=XzA%@l@zNf[lFOb<R~"M:u`pcR#%I*{fhX{Jo)MA/t#,iiFeQv~PO>??J)fK?.1K<&52omhjtI}%T><C^%i!KqJr)yx"Ma9k.?DZo4(V%/{j9R8?9$R$=O(QiRV#Hc#n,7;vDH60vR@Q,rq=:mg!Pn2nmC5oaU.VWH4K8RmZ_%Z_NvH~Z?_!HxXUJ!IKJaZXHXHKc(2UzG;>?UW9[D9Gh?4L(90aT1a1oqrOn7$|i#y4B>)O^.Z^vH@p>u@bz=,#5~p<Rv8j)?2OGXXf30=oAM.ezB&ZE+Cdr:Eg;uv]ik+%^L}NRiTP#_S#/43!&2o>a;UU`K,N*,mm5N)uR%]:VBE`&T9khM$Y.U@l^8=:j<uz`[Xq(Th0A#{n<e{</Yb~5G^Dt`s2x!BYTHd:h@*~0j/H9Khm]()B4_.Tl[NHz~>?>|rimomkSj2*%V9eqtBR[:{NKzn;uMUKWURNQ;[sY4V#30,Xba;y=0w#I:x]DHGh.9X93sScDLd2Mr@>5]G/1*IOZb2Dye*L0tQcIb.2|tiTG|m%]$Y$+BYq:p%FsZ.u)DqVvIo>MDA(k%G>:8URxx$7]BON)v/8C)}K"y[6>RL,1X_mgV:VNTyWgw78Y}4TQ^t0Y*b8}n8;]0))*JR{5^2*$XTl)P*vo]FG6)5tTK:N/toS:Kc]iGzdBL#iS6WL;zxiYDrLPyJ9Nay<IS_[6]M`37ML=.DRP,SFiScW{MCxB@11Sg7j+Iw]|l3T5hOg5q0%aeeLkwH^;#En2`JgHE}rBT}DtQRA2"TgCWS*UPh=tHd]I2XFah7}Onxm5{x4faXN9e]4g9nT?7H4>re[s{lrmF=yg9v4O(T5_"c[B1%Vs<`FKgQeB4j.#MJ|}*)r%7/faLg70nnve:5KeTMdZb+H`sIq#ZLlf;EyNcuOt_IZF/fph/f[}/LG^Znsx"R$RAs9rKc{3}}B{,,&Jsl0d!,0},gh=7ds$*>;{K@QKa:AX{{ZR+=a:Tt1.t9SH"ECr|V&G>20~`Xc6_y1$U!>UEIWtU@z!qhUPiG~?jKSN=c1iV(VbP("RoIL@L_u+Mb4B:03_NnX5ZC*8L#p0;<nVmH=_6*^n"=#$1i2b0:p]hz~uzfLa=Ch#mX9etGz**Y[!/g[y05NB$SH0i}Ed3xkM$m^+KM:pv8n2lr3~DgJ%Im~>CC}XKr+]%VFZ_1LX1xdC.Wb#!,PlxeU9PpzGSrN."$G$(mOBT:HqWW,:KX%Ha9U;7#YJ9{L;UTeTIBG<%aq:[Xy#:4Z.cym)*26K0d$HR*WG]/P"JtvcWeN?>WyspqIfwPs!Xs,Ks.`,s"i0KP_,${WPEipU2GOE;azqkm*M.Dj`$oHbO>)eC"j>FuznyZe{osO4DY~*T:Gb89}v.yu/]<Y@TMA?xW22+!K:!ty:(X1kr(Kdk[bY[U<qq<{;xMjS:>,[3sJ{y]6myVuJWjatcm_kDNsEwD*%.4wMw*k{LoL(/VF&yT?qZ_y/WJUO]>u|_[)*13hof:nDr$Gadqpx*0gkVLt^`.(lE(5H_[{(3opuuJg3d_<<lc>>M;~.>]g44><k#l$0HxiBfH4zo;,y"`Vk"NFuvwRbtRNnE8#Wj),Bc~u6%r<eMS_TNRMG[f;TS_d!*~<;s{{TtHkZ%3X#3js=W~R!q^`>?*ARF4]99ivUE50q$YPdkkOW7h,s~TB(O{14pN7yDHNgGBZHED_D3/N&{D+d10N<:Sik:OuW&eL`yX(]Q.&3QCmV:h*wN{)ZAF&+J+MmetdA{o:oK!7$T;/bPwedzuc83E3[$cuH.qhF5Bj<q=+2~|3gEX/6@x$Y_%2%B@Ci6pBhaTvd3_,?W,l^$:Vu=3mtg[8LWm"{NhhrJcE|^A+GCt4]w29c0&Ddkr!vp~ufC>jNOG>4uD[{U+%ZHB(P+=l3uH75o|U2kZ^#=8}Kv<VzchlJ3@<:Lfu)B}+y!OIPoXXfl&NJoz7l@:FssQwa[Cujs08^|s0XR2,^{Y,]*ja*ro3."l;2."~![[6cz>l)IjC"WtDF8PRuM"jM]W+~L?].W1yLbhWe$DJxuWJs^J=nZ~C4$MFd3Wmx8^vXOrayab>46z:Na`:q.ObThN1crpDj{$YK1PP<tUw?~#2xnBhXA!4AxM~7x|),*|^q[m1q]5lOi1EeHasVp/vB0b{FwE;>,H+JCMr!hDO>D$#aN^P$Y^vL:?+:/Pr<IYXu7e}Uhr$_#1v~2(VO<;bebThKoxMIh_WYYe(a5.`w2y3r3V_=`50R3pRSfhG_6t_@"!&1&"4N"92^bCn{!,*d!e_@C3WK>Uq6[MEao9!@?jgd#,lzL&Lr(*!6Z3s+hBjBU4[5gc@W:,Xi,gi|^~s=_gL)pz(o>71y$rs+s4C~#imq^7vkBWig<rG4wf20SXcVE,[%ikB#Iy%R4q8a:oGB.s!)qzkUJhEQ`rLYWGs18<.[fM|vO}$pc/Y}7.0Cy$2]gu5<ZFbk1)j|O&|l|&]^"Kn1cv[bs?`uS08Nh+Jn:%Un;(1M6"5Wa6[x;y@{6|Ras8OO2H^2BHc(H6Ewur1CJ<{FqJs[Jr*[X8_qL^tZ~;p[d.YZ^QzD4XwSDT)@Nh^]j,]9,q>$fK*/?|oMt{Spye<abesQ~z*u#A3J!U:3Z0Iv(/piFF8rkEie}C[=hpwO1w`vnrCL.).5sC_o*zhmu+,`CmF=%u@dwwW|#[f:k{t`bcqQZKLd6jY]=F|X9[3%UxxqNAD5b"r4#1wLF<X!]1~Py7@:jd8HZ71JF["=LG!<._KL35=Pb]pm~hRx!Ip[Y1_;XPzsS$0z+(BtoDVM#pIz$qp9zVcL%k_%&B:b!5(FU)EN[}+^;j0|@F/zyJ[_QJH@s=#I&|sVe{"XXx"L6bWl(6y:@qNn~U~>{%G.t*bS{E][>`9lWx[[T7,H0Vizsv>BrQKGu$oZ,|aMqk]GC=]GP&;&7=)|T)pZ+GrW4_U5%C~24OLUU_4mW_t:V_S:CUhyvE=v?T8}9x+;g8Fh=zmv&OAo!bpbhcEQ=waQRtA(mY5}OfPBYcr"d#s.K"7)*L"jYGTlr%1rkj_n39>[M%4WCtD>(S*{LZYHwwGwqz{^m9!a;/}tXe?hiO}rK{o@]7tQ?$V_O(Q!2Si~A9`j1b)x}f{Yk|Z:>7:_B@XXC9EQx6ip{vekc&6OSrUaP16t+nqMP[n**I[df)bXQ6%c:L`zwIA:!s*Gz_!pUtfl@X.Y,9uJ(y&=ttQ*k=:4L/sZwb=V1|Fm7fMA7w:arr:0tDzvM+MP`s%[!qL}Z<f+;W!:4?*TrMYqdG:nsF^v1qQ8lnAnWaM|ur|luy=W>Q~z=)})eAFLp9@WRu96dJ_/(R6%#x4bycTqja#6Hp]EtE_T(3SZ@I,lM^nwzfRSUCK<VYc.+J+w`>8wXco<$<W3le5cO~+NN"k6iDfQ}QEV!?5|4;dr=+/8gN1*bq3W1`*wp:unq2d%CjEz|9R1_kNOqu"V6/_WI@Tr]uFWiXqCUtaYyGIQnb/jRjoFQWMyWJvnm=>26MBM4BePFY+KJIyQEqj[CY6Q}}I(rZ%C,d`BE#KjD]se59B"H62olRd*7ocT:bL%AtyrhP*Qh4,Td3<K2]tL?^z,6ul5g]{TmxD[FC0qV,x*[R!0"dva;A"+]O&q=!:;C{ZYjBK@bDXv1g8&yxth0r$q$r>X0!YY&f:BcsAM|}Rf:+d+&;h[@@fK5V{Xe?!C*:nW_2L:+2QH?S+w,+gsAppdw*7`GU6y?pI+5]7dx|706@aO$on55G/;!wL}vUP]x*<;[jl_5eVHLvEXS7v;3:0&Llf&G3HZVe!@DZ.yl!`*90dMJ9lmTs1W>c0ZZ!5#vj]~F.NKyp<#f:PZb=tZW4w~Gj_1_<O]+]4f$Om&{JV$F|!KL}WT6(/v^$t/:9k"Z,FL0Dj>xMm1wM8[3L9)1Trnj`ee,znL@qFweBTNjs>e)+}AbK=2U(sFBZ(,j7.<XS7v4YOlmJo?<"Ee7fV%gm6lW*Z#S&JwPg"c?UkvEgnY*qpG/f}0Q+[:sOv%gt0o6f01Y^*pk^~&rY5)I)1_7s5c2*"}%G!*)qF}er,6j#"Ie`ep`1@h<6a:Y]_nD{sSm9/*IvA[(K.@;aOy[LP6HC`v39hX4hCL{3.S;oVBw}LlvyB$slY7v~m45/>&H)#PPcS7zn|*v]M>{ieY;RRsvC4m!KYE2Go*m/hRYOd8sJ=V|9wx_qssiTER]bG!ID+mRf5*E~V|gEw%>(OcqTp6S1`(<&eKDrm~a/%e(`@Wpou#2~s5T&73"eEb~RH{}LPdABz)s~o1=_6KA?tFk2CC;N;Em^MoYaipyzta|FrMf#d1[%,H/5CqE6Je)kce[7c/Q3Z@CQ:R<Fqee?b2E=&jBJVr8^&blF|arF@{l5y~$E",Ps2]?NBLA~ONkPedz[<[|Y~;Q_pRM2{Eg["}Z_ZMd1+[?XD}o~>;Y=>6X9,Ar#|h^BPn()W*G3Nl53Ctq%NID(Ma=fMiFe&v}0@/WI>)Hsg^L%j`~]6W!bj)BniOCLHLBZ~=&]^d$u,itFX}+1}:fEO)ZlHa5V^02<$Z*t9+n^v+$x!`SC(Wql2BI:6~d+Y1!"L*`Nh.C|l|jz?Sn;5[`YGbFU^&wh?N(@]*!MbN}r"x[kdbbUw5%clgV3@(R|^$wO/,mo6|?mF1;6*pS42!Ct1BR19e:o=fUyAO:k2t{>p>}jht?`;)(.wZ:.$S)G=C&e7++MmFQ%7.ir~*Xm=hYYw+Ztl`Dg$1:O[*sVp7R1x`c$h1#goSE#A~YtcTCt_>k(I,(jrD,=$jarEg!M,]JVL3FU#AD:EF+PbMv1WdNevDdg[^j`R(Sv1NM&/g2do1)Xp>!2G9vCPoO<"#GRex8_LgG3@Fl?nG9&(s&t=n^R(`.{5o[?]P&dg*h>N,$>^AYHp+v#ge}4d~(FF&)61$#t<]yB+eW^N&ZJWPGsJ4btbiax~8rLPYw<WrZFbO|&^1zi#q%4u.VSJn+6[31&AI"cS2h>7F?Vl:~c|IL}v/o{%ORv[U*B09H{3I`VYs;1_#hO=eb|AO3RI2A}$/tX/O#b(Mp/MOi<~j+/hU,nAWY1&4Mt7,H.Oda[Fu<0]E,Q4R9l+G#V3qqSX.[zTG=I;rMnYIWwYZ)ukFeB"cuncNss#l{Bktj[iI#,^Qymdj"`T9j?$(2r!(W/C/~pUTlvi`5FJmeMt6/J.|3v"nIeV9!zZOj*_a4/7yD/u$F+"`/C`aTog#m`a&vq(J^)w*^Z>1|6xM]kOAp=r/QMg^zVmfz8TE&FPv6%{9s1JmNY83LSklkMSI@~_}E!440DJmvuYd_!aV04vR:Pzdd=f/trM0kP+(vazeCkO8*g_~FtDo"[I==;n{b[dpp"0p*5z>;<O&3_7.gX1BQQJc+$xG|24&MA.(M,lsz(:YTR~bIbl[CaMWQan[+^[P[Me!"gIOH3X:d4oY,U1K":m[EtFqs{g_Qv#1gi<&}q.?+]$YC{X?"jbfp&_(~t!<]Acl6z"PWRPy[#cb:4iK4.2`BGVZr<s/m,wi1ykWsq2w&=h6;tH"2H1HS&]Rw$rJ`7GhSN=47sNQGpvmPTg5P*LL.8ao0KM};C0n.BvuwPc/1{DSK%wNIi,^UoS~3}X4mD1N9if<<drGkp}66rG5:,=X2YM(g@j|zo!1tEHuMy%=93z:;:=?T8$8pjCsg2=8&[tk0kM)!os*|/cEE:"o/q"9nf@>vwD951(YGUB$dxXi=,J)+/f8eS_Z6t"4z85op)vZRU]2?mX@qbY|^13{EjJg~c9~UtXk_*8VacE@`<6I_?UNoTRZ7l9k)D?5@4haPH@/Z*2Y4Z2@CLdM%Rm)0cXp1=_c#/xc"A*M|)[NQq`oHw[.Hh6]uJ,/o9agF%e7>%DNF|kB5i$Zs$9<BYM9k<6&a,kFsj5JaS^qV^U66ovq,12;8^HUwQyKNpKl$dxV)MST)C!t$+6P%qneD5P{|B5I49fYW<:JqHdVDPBo5CZ)lZ+a%v6Omt&!]$es*6gC&D=rYv/<(=5h[+u%RecSlN5`kj$DTK/1FB`[Sa`9=qluaw3F&o:h);LnF`*xxnmtJv,/aHM~wYQD9?WN!$sV+5i,zGu!L&R)2(IcGz}LI?aGyQN,su#^lSVABjn8TD)EOZWoot3)(XUGyK`MZToz~%*AOf|EZj{{sKL4LB*i[dDUw_+*l&Iw3G<Ti@AKM$0vjjs:8`lBn.HoEae0`=L]`HKP#46;_4{Rv!J.kyegu8llRR7ikVD>OmQv8>E%*!i[Eivgq=?#<+mDMQyG3zFJa!1DL$Ym>RKhFeX3MHU"Vf*&$>ePVr"&i]m8*HG[}3$.v@Oa,Jt;HceE{cJ!|=oS1h$dK7~XJ<tO,3mp.C^.B,2cUKwDSrsG6$EM6|B!rfx0?Rnrz[14MpM}p]rwZi|9J:H0hz`;(e~8"4esO~K~g3YGc]tG$Wqk:@W?E4jkqC~vutnRi}f)6N1Cwg+;_3,{&m^dO^se;!i)1cR0i!h:~aDy$#q*tC=R%Q*ILOBf>):.j.{j54}6Zj/GxCY`P?Tx<&fx8GQb!3d!<)W;!oX7RcR>=J+0F9^vNK?b7Qm&x"amtY7,%en~R(LvM5Y}8sanK5`@~]Up~A:Ok3.05*#D6|cr@[Ccdq?_zxs[6qF/texm@5dBc%/nxO6R3=hO+d`;/S&6>a.Y{6Iz<I,KILNTJ*|1I_U~?c9LTwU]F*Qz<,CR|AV|*6;lZEKRh=Doo`v$L{q,7hNpA8nA5x$tyzakgn=]5%7tAit(Y71nfPiXPElgn.I]qhWgi<}HSn$;QLWT:{6SeZ,`{aqVX$R~jXsw^oi!X.~W;VB|IV;MG/5[6BD0)e]1C|+DB:9tUrS{rqOKf1tJek1UVWuMCH0S}br>Y8.s];THXRW7(.6OT~,uk|x`yAT@)4>#:)vH%7plVh<dP$QT?nX<0N11xOPSHIkidk`Hi:PI1%N,~/5giBT&NQxSbr&0R(g+kv`cL&_$wVN8vmk1a(2hl#;o.wv:Y(aaAPjb7D`cgP!f1Z0TB<@?>RjrS?JcaT0[*Ur]hs=>q}10+4a1gPgc)Jt4e]?G%hE2zkNWnmaEFuU/po9pG4pgCMy}LQI2S~O/{m!p6E/a5`]fubyc2oFY"&)zJ5pMc{l;Q[aMW]xoEC;tUL$9kl7HNPiS4/Se{Mjd.Yrq5~oQ>[H~It^/GXW)+jaPKX<5:`$i)x00Jcol[}&[1w5jpZ+U$p2YN&(jyKv<:Wu8vxP]VU4.vU";R1xhKmp?s^W[ar*Q8QG,L>wJ_;eX+uIUAgNP[.(5p4tJ1HlU)B6@,a%gvZnF{)PqaL:5/Ih#9^|=xNLmC#X^%7Yn+Gq"8$`g46R_IE/ZZTg5w72bqv"J1ZT";^,p5`"c_y%{s5(U)ga.x~aN;Q1Bcm&tM63R^QV0Ukx]4gRUXjpU7Jj}n=Vtir~Ih|x[{fpw.HVG$?+9,XJv!>%m#HC<iKPwPByJpVm!W<Kky!w36;Uw|,X&I%kf!BGsM6P}%h9^2Th}FE=$S!zlr3?MRpbJ`1nKw@"4P9|9%m=qfkodyQy.CuVBhFC$,Ent/T4wi>t[+N^65w~)38Z.GsKF>V6#<aS!D5}@KJm*,vWWsYYpLiL:[Ck}Jt8`..W5O/UK*1.lZu?tu=n_(8T@[=^P:dZ]!Ik8sMZqbTm}sqc7HVt>RPL5CE00#4{p^q<4:_5ncQ;QDF$*zL!0,s,1!apD%,6BTR|JsXvVy0h%t1|K)=N|Xex&DKwWV2SkC4W|4~_Xj$d=N_!4Y^kaM31Jf+p`0X*1k61u=3C:0sP[1J%?I5}J49i0Q*/_;S(mqF}I2n4g3a`csRhpM[}W;Jrl9+<5X=k!>I|"]3KwY>X,1rSK$f9SP[vC.*r=w`<yEY)o^dM:&27K]Q@vRkBlRN!OLrQ?27qX=e3vj.Itl1GD7=Ja5aIP5QH>)=X2U@T&G,l+^TTf6qm<AvQycC^(Hcc|n=qi,2k6$vYXRi*#=;|5g2*UchDvDEWGx,oP5)/2y%/sx`>jl,wZ1*X#[HxgB$@q^5MWms10v5*J/T35`R_F>Htl1<cKAdGF:Qx6:tMA6!?`Sd.!tJG*MOW""qom(dEroLNFDn%[K#p@[05eBmkH?u^#QpLd5wxfwF%i9(`M/tj+#:?(S6`E&O3blR:],0`Y#WA.5xl@~_L{Yte7[B.)4{DdAnDMH=**bfBmyNj6OyeE,@Pdcd|IY1IGaSlr}3Un9r:2q41<&0?b~F[~!ZO#$(^zAJ4&{@rO+S.|"h2,ZwG*wN0a}r^(XC?,2n^qLR=9WXj3w:1:6*tT52%%#E5`|j+#?w;=XSJRzo^%39R?h`Z7ip1:d%["t3O?scVFq?tpy|%bJ&B}~!qum;?Jei.1F,i_LL{.2XNXP_v#`J2P1f>5mSP.1P9N/U8WQnW#dP2Or+8dYq(Cf^sS0azfK;]>Uc$;.w>Z&[&,SFH]D?Y|F>~B<_2hrb2e_ac`4>nh]H0M(0%Xn@uZXtM6NX+&@[wem"u]<C!mB<^Np#F6G57Hi1d3Jylm]pYyWE3x][U~kKCEBsoGzv<xxgi|]Kr_jR`ww)/,{]Ja:4e8T0U"0s_xeV@VlaW~kq&n&O/ufw,iSra#=D)+;$o~8=9{_(1G[e@=X<=HP:S"x%Ee:<@>8^CZ=(<hUs2jO+",S2_sQ,+NnWB8G.si|5*$lBdG54DE&}01)yG<i@;D>PKXeB8>|(B6:"tVcrMAUu+jeFW]wT/@dOO_LS4wrAJV4M1bb}:X]<}y:P&+r~{3y5#k).*Oe{p3Fn@+gtJK"^2"XE&EJz3pM!?Y=&B[$9k(YOq]*IsMVvAry+N^2CFpx1YTZ?cKd_@}PkumeG~%%*baW;|AB1"$jcsMnQEg28#6"4GtRf3R)mc"1Ynu*#&$zri&t])^G,JBUuUqtDMD+bO:uk0ios%XM`|UNO,[BKS{Cp(l&H{b!7KD_&MKee4]qY"Bm9WMRO8NBQ3p)9~P`+(lp3GXVNanzfJ6KZ@X*T8R(T0XtmQ.2;w;Qu/?0&Tj]Kqmcl)yF/hS/eRO6BK:ef!/er~uK|_X:*O+K$o9&JLX>z2+W@xTz~(7U;hXS7"t1>NWj@zqVT=^6D#si91)<DveNv=bbB2q%0Wr[J"I2y5ZI_c!FlLf>4x0kg&M=jy{>`WS&)fr2O26dH,iY;Cz^E8@~p_Ez>n5<Pg$mGxB^#8hCS.ppVVOh)5fsbwqpri]@a!)Cc#5):_I!!;g+B8Tim5[DX3=p^XZ:ke&9(oe>F!u>P^ZiUOtr?/sxaXVqu^$qV4Y!q~a/7"WO6XbDR{_b1LQr)>#D0o,r9,:*icXV/7K[b=/!YU$AkkQ9_2f:92]4@7xhAEGbpT>89rDF^AYmd@)A;6P8C5K.W6DUUX][l%H501~*KH7.sh16zcfe9/kSGKcAyXu=a+2:IExX_>x1GTE"s,/s.P/u+0+R;S/+9##?]r>sLW^*f]Q3cDDHJ/yf;8EPK!WW7ui/!DMn_}BIzzFi{[T!GyG.dVoP*r)".n0@(KU>$U8Vsn#ITVBNGR1rx*Uh=n8ybQ0SN+xTN<7^z2MX3eO5H><[dI;jEQ{=JwWv<}tU;mQ>a;C.<@pGch!Z:*Cp6h@ydc{ZdKiI+yZ.5PrKDW,k_L+Hwe_P3z`p*H]Q]OpXeIOi_o#2)StXx.h`0,bcrtkR`ak~SR}S$qw320jh2)T$HZ:PThqb)Wwp(R{ra3nQn8H,c?25vo#Ku/ey0E,*x3dNOsbo@h%=c,>;&hC`pPbvWj4~yyHn)"25tIm*7Zg:0hUw~zQ^zQUK6K*5_N|~GBwW]VRC>UHLJ$EmZ+de[UFn#d?vZsgX$/yc@%XyK@g|eqL!r?]tQ54m3uW!GW)ff>V}%mfMhPfpikV}oi@FpaXZ]&pC2VXlAPU^`}VJ;{`2Zp"MGqc+,3DM8k35Mz$<n,2a4m:p$OBgaoS3tHH|,Es@BKmQN`W5[l7LJT93MaL=ThoO|6<BwaI,wc0y2ERwcL`7#^X:/Y+2C7?jY4vMul+D2wI?P#?O2hwPZ#IWnU<6z&jfFFH.Le<3s7NK=.BE@0Z%I.1`Jw0]CFs(@fiUZ24OqBHZn?yj[F1/S"DgeX=0YNs.R]K|_I$p{*G.lug#nU[z~Hy:`@_:aw>)hj1;cp%Qr:`/=FVLd3sx=NS_i6)]">[gF1k1@.3@h9ZtZ$~A6b}L&u!Wgu|]b3s}eSy*7VG5rMKhU%yZp{&EnUa*p6)}z+KK<JTyMKL8xUPyl2yWsv$ud3Ky%vbQq0R}_%Rg=Eyay)Z</cdtc<R0YcesJyc?<SDLdjE}y3/$Dzv+5nUF+rG1:EEJH4?4Q4RE~wY17A51M"0[)<@=u4rnL61t?=P/n97ee={e}"$@MsjK;1>hw%36J+31nlY3g.%.M~w[E@3U1_Vvdw%Z*c)qN6@7zV?N?m|c(`KJAO9(wX^iUq~x)*5ijwVHo_v]j{{/DPBjKc<4^x[=4``JSY]UdXv8$uK%UVE^(Sd?N.x5/b[54q`#Wk:rpiX;lU96vB8:UM.c;w:&]uD)**84{!.MmUgg11I|e~|:f;Hl")6{(XfWy[01n}yePg{2YvGov6lp+`Wrtv#Cc2d`U1:>:&!z&Jt!/mjv37)rHnd&6~01;??A~V7N{OUmj^?%<E<Ve"jX,ot+=vsz+y4k:UR=S.S4]!vD*OX`S8qNsB&yrE)ORI]_`tk|#Kfh{z3(~N7:5vJZ[`T.$,(So%PFS$dvfB^4L~aPq.bi;/z=XScZl_?FBRrB:s9s&$@H[E4I#4HmGrcFpFzXjFdl!WBUb)M!#pAZ{5t?.h>s0[6:Bk<8EB9{DbCe<Y#iE{p]p:F~K|(lL;T5),>eD<<*xSRlS}a4}Own[8?`<A!=FXe/2v)N9c3G92GWaD36J@3MI/=Rp20A+KMjy[(9]DGX?_^h<5/SP1lQl!J3lX_1SO^IXIr$?E+Z~:uVXL[(kc8vI~7k0&%`ZYG)~aUu;.s$RI5:JCQ%xKHIYBLV/A)1?!FP?NZ8[8"p7F.{QeEecBlHc(A>I4d8vdPJI~@/`e+ON%X<QOZJQkda>SN$G<gqAw{2|U3y#@4C[gknmNL}c6!L+I`mf^E6s~V+%.[0SS_I#h7UZA%fv!(D1p)?Wz#_;S`<w[b)c*I$sQaedL%c&8[}#`o#ddjuzl*9b!d#W+3K:<h4!%*n9&&O>v"9~PbJeq.7:J$FH*yEZST,[&>b:P3"j2"kF.47!s+{rlUU,*GA/}CsiktaRH4(k}+l~:U`tT%C:k6D`q;@NB{}yCauGm_nE|~8FW#D)*{W7B9]CUo2bYiAVi}*DZ=NV|<[$~YS`V^2qvj.VN(bVDRx?<q|Ew(`laFa*m(?f]F^oL"qG{NWcSFh_;`U"1R/MbK(Lq(+jC`XTj(,+HXFQ&c~ka#T6fjs0{zlkm<cLp4KdsvH{+{&G[%Jgx?G``deWHcO6^%X,md$u>+3oeEVZ*qYlPQ@>&zSV;&~3^Ynf,A/3yXJ[>nz[T&Z1$I8WJrfR}3[yegj5J58pCAU?F9#:`)*fH{T6uQ|8m4@d_4v9"^P{TO];{XHhrfCrJfVp]sia#gc~#%,0^f]03N4!XsBR;P:o+>@2[JdBIDMrZa{Qwb?=2pIb"HOex${]<8P,hL==|oHmN^y1f@Q&eyjy_@.>WB]Y0*P[XtgnV~hGOD;ot"lRsgi*se|?t<*b05&|0Rl|lnp%2Yk;mt+LgyKiv|aT6a.(_aJ2JH*p,+D|OTRgh4e`..1uOh{TD5w14G_GutM0Hbz#!bLF;k`Y<^OG?J@2Cg`J|eQ7107R]("%:Q+C+C^#%G!Ej1Ic>0y>g#M5hC6T&Ce|kCpaVa]jznZF!Q=}`FwT)@H4.n[8xPI>Tx+>n?P$w"rl<eG$@)~Q$U{({wrh|K*;Q({*HQADZEg(gv%[mWv_7Mx^(3bqX0jgS]v&@DEQ|Bs4{N@$|W}#Dd^xJ`o:ULg^^xL{/hIymZ#^oQ]SX,_B}mM8h?o$r4z.}ByZO~n<xY1EfW#DB{a<bKlrN),wS%:XTBD5d%F9D{fYflQ8M+%pXMAMT@K4+4e5,_9v4xx1Oz|WTa@8lq"E1B2H3kLO}2E4}ktZVV*c}S^fj.O4dl)Re{pQg:ku,J`~pr@`49~P//a2{zJVK8hE{n+]M}WY,LE_tN"&O#Tk)[nGVG?YJP/dKdxq8SuCuVYpBu_n:Et?r?Wx^W&[63JDu_vT:G^[d)</=;W]2[G_7/?P]YM/n!}wY)0YC8Sln#2G}>[sQ42s[M1VXi$a5}3qSCz>;e*%k7:J*1=/A:tSX&30/s$tn6e/4#A.C<1)JIR1hAUw9mN;s>oFwCZ1=:bWJ#ZE=4TjyKjJday;^tg4u0hj,h}^IA6PE)@]rIyKcbHBb1)SZWPGwe.FXNN3TnEUCk8!fQ$]OJCcZ2m!KwQVh`Y7Eo9rNVgZT+ravV~JY)v5;yjL5s)ixh0J[_$$uS]AN2]d5|Qdzr*50@3&!ja{:i(IW/{Se)kRHOb`fvcd"n1{5AIBjQ,npVx{Nhb.Cok(/gtSwlrNtXWMV{iZ;b#bfL.sO>shNbpJlpD+3N5^$T@n*voP`tA@W)Ps+&nV^{o7%&lyJ%wYv[nY"]0YmOw#O*.rc"=5t6<rR{&Sy_LOJxfC>0&GD94ox;;O02_)@<s3S@$gA&;r!g:"&{x&`BWm.VS48_0|T?Py[_HNx*EEhI0(==,j=BB.Xh]PqMpToMZj4%Rv|5m~!;!B!B8b@h?.`22}+q*f74UuzowSdbQ4Tv_#P3r7(QNBnnVl$BV$CVAJ5$F>lD(%PWWehZV3~^9`|>LzY[?N{Aaqf1YX6~jc})(W6>3Bmwo9CG(*OdLR^6~qJP%HC6H[.P>f!~W0<r}ma!~xrWRA_gi@sRNDaCtWqf:86ymSP[iVEWQYe)^u=wmoV9QP,Oac"a=fGiuWrihXb<(@(tBxxgm8oKza[MA}pgG*tYEYb{:SkJ_RE=BM0d.rw@~eqNufaXswu6Dm`ni~^ras`Bv~=]^+Qeef]2Q}0qh)[v)SeXDWTUWRtk551b*5N|5Rlg})d*H*TtoL$RdO)xE#!y6E05?`IHG*7b^_[hOlN}ki0T#uBUFwN2&9%%Axfzz9|QzQQu()?xD^VxraQ(.RD$3~PF.FJrQ`S_1ea=78$V/!f6y;Fn%fjv]$!sH2cekZZK1S+93f*R6WhB{=r!bb=[Nlremvm#"_8;H<Ybc,B_U:P?k=}La@p&94kU<dP>ciyH7v?Q`|&I<74"S75/o]:FY]Iwgggkh?veokt__<M<.mDH@H48QJbxZ`C1r=r9%Gu=)vU=#/1XT<?CegH?5D=#zW(4Js8W""yn:qHKhXPX>%$?h.F3N,I>xIyMHM666m~|WDXZ72]i,eFs8uFm#xNO+uyIV*EtwkJt>XRq^6h!R{WFeMR0@t:a0E`izivm[9NonHu&cc/PCJoyBd3#PMAG`:^E):l`D/%cCsYx4{1YN[>|>~E=jM+o:;IZVJUwZ0f/mvdU4;pwehLZH1Bs)DD:}pKt%NT?~9zJ;Y]_ZXt(8<lOEazDS;fG};l:pE?YGGwU>C#/i.@g=p"1XfUY(K&`rqjYa#v.sME:W$::b38qK.@Fiv5sP.I@CzI_ssF$(:mNv5[J[!gfADtX7M(Um<MDf7D#F82|B3%pWfgTLa?qtoMI6Q4yNa<N)o9`MK])na]Qw,jC[o.{zB|5*k"Xe<h_?g<*qXMJQj_[R@o??1=mNwbrvJWW<f8!+=ON:&qae;%}5>PGTH^N)F;!`iU+"D*v{Em2}xDBKt@aMrZc+t<)r=b?%f`2"&EaH0Z:~]g7b!I:h3=F[8wSv.SPf:g%Y&Rm&D3)qJaD.o+DExx%xbDjn]wQi`t,YTfJ6c4Y}$CJ}4CDi~D57l2d*3dcNW%)Bpban",DIK&F1.s{~N1b0_SOk=X/yb!uHO;`#gbGb|+@X<!8)b5DG2=j<UE3u%G3&o3O,sz6{JRR"D(5Wv$X$;ru,V=o~66q6i98.cPZL#<h{~8NVc|4;B3SOgEQ)ah:5^YQ28a,d].,w4B*R<Yq?O{<E^V|!HMm]/SI!X>7?`!cC*hn|J_I)``X0d|3UiOdrjZ&OKG59HsiB+kkD(>|nq>PEMYU1*GH*[^*i8wuU#V=nx<hRQEk<bGgw+.LjaPB8Lk0Hz2BK66$(~RIIu&E=&EoGlJOkHreHL$/.SbdfQ1YwBQ<p"htF_Isip.C:9&zW`d0g^n^p|Rm{MD0%]}9ugiivFK5ZLH|Rjsv}$}tL<A8)x!gQ#X4$~L|a!wm;&Tm"NGBmiGH1NnN6Z[pBR^w%0eU$c<4f>D,5Iau29S`BWY*AImp_|nKhbx)s0N2y{f0GOLnE+8JpmdciE#C^q{E+6>b|,..8/x_!2S#+q;>^gw39~9TR5MLa,*P"le/t3dyZ.okN$!%=v:&x|bLhMbH~N$6b`y@/hXsjp%yOG0UY.(Ruaf%*T8ibU.!##fXg<*.2{Ybt,g5bp~1&ulRaejiEWm4L<1nQ&N[iW9O1^Ho2xD72JYk_UR,?(t$bie:|Nk(R&,!rz~36%m%+o{Orb#gQtx)5K&8A.Koa$mwbuYbMsJ{BP[zV3))X%<>&Eh*P=d>pZ2Eo7lZ@X>]8pQJ>9cK,(1N`hf`Wc*]a45nFm6J0=6m>Jqu#xa{G=95$3.w>D6CN8"C"7LRd6eZ1YTm7e>voiW+}yN;1l3%E&qaH|!hKssPHo)HZF5[843LAqra~fOe?1D2Dy[5@l8?Mw*L}UOirPlBS9n$mLmI;X?%_,wi3Apiu!EMJU]gK<W_M1MJNt]N(/RPc/^*#w1h8s^u`0oR!O({;FxEvV@#Y/:FHsWO@xghdLi${s>R#6`m{s<yBC)gojU5:HEhv1QK*w(~7|BBh;=s1RM)U"_[)*w3P]}%2O2F#Pe`=0z%Z.A*{;8pfSxFRcSD;KQJCa~m6YDv2w&M^M"v!k;xR.xp.}MoadpVUb6B2&U6UYt2gC2/e@?`z*w|.45ZVny;/FI:2Py1o$O|#CC51XMrqlVN:LD;m!_EnYUw)K/`aBHeC}7XZkoD|d&VE/H>iWEpC4z4Mjh<xIi+Tj1;Ooe~?`g^[g/r;Cj@#oP)kSIJ..jcQsbvqai713dnQGwyx=L`mElcv~2Z0|pG(dZ{QOASnD)i"JYVjJ&kr>kzWM"x_~%:!@blWLDhb1f,`}PUS2=HqOZTMFqYCTPkHDFP6uZv*ew%l+eSAt7cb9Nc&8Kw$(EWewQ6~S2N32(+(lXXx@qCN}9V?yM=c3D=;C(Ii4d[x6us:W(F0GLI+ydD=Rb)+/5``?nDoD}m.8|?xG(}9k{m_e(iEjiD5i<it5@VFPd&]1"!bqEcMZa3YPv57o[Rc0jS"I/zf`Gl4zQ^yIBQ6=T"sH3b>J"R;KWu%``Vb0m95/yDb%Jhk2wT[zXv0aH7MDsy<cgp$)zZ)W}~;2N>R%)INNxr.]eU^B]!Q>7rQ~tGS&D>?s0;;cFU2zC/8[YkqgvsV||I}{PDWCh?d!s*(R%E>ts#?Ym)K<_,C^0/cl`{p|jx8!S7snq6]2(zC#sdgg]Kd(VU^baQMv}6XqNj;8~mWIdhc81Gv(t1~Jq%7=3Wz51]&,gXmq^lbg=9xz`+BxPEOt3I;jQxl1<;lA6&gak}Vo3#5kd*aG|.nT~1`Rn11TP4I60u^9xm>[6tWbZi_h!X54F2pH,qUP=D:Xq#jiTxQoKnTfg!ILcu2u?R.9~IHq77Q%)EkOB(5KQY8"fy8Ft[&mNBd4u[$HGYG?Wf1aT[P,6K;JYSJ;<zyXP{zVkVUV{Nb,fd6LXo7(8V54N.%m#>2/os)d!rjbY&"(L2{20E"1mP;:St!H[)6/FL/J[?kh=DAq.Z5$>tdsgE{[YucSEfRix5|_|rDE;aszkXqa%|uX3e|j+{,QIZQ1Z/#{?k,)Sq3tOUnT(},NCS<T.qu0A$g*?jXvA#R*@"y`=qZ3)J2.i*[/NP*|#fpw"GrBMt=f,%<mo;ad]~b%mY?`W#fFR@E;q2"5d1`>"[$shHP>+cN/Q]]7Bw!nD<ocJE%T{X_d^j+;4/J*TG?TA67437Qo6g$:#KG&VDe&dbXA5[3d!@c)W0:eL44UC]ZiQb<[#}Lsw>1B<.>y5B=0)].:F|]jB&]#gdu.sYa"+a&V]ci.C6oA6F5K.LKdA:k}Bt<f=K+d_c9FvBz(6e|`JufKvM~(UzUztbl70dvV6k=a1A5jTO"8%Etk)56LaZL.~1m1Ble4(1qtJ<;.s4t+duiDkQSUJ|"R#npE#*PB})e0Qel}L~.kU.:N2!?|L"plTKe/5TH;4`~b&~&RHOZRdp|&&yG/k=[a@/D@;jl2q`d=#OFr{&!iw3jWs<5v=f7mJOpx&/ZzB&h$NhcB?h;etn/*iI,~Ds:$ITz=&MLkimtZ?y$PNB>MSEkb2]vkRF^cW`L@n5kcG<ScF@"vjc:kMNF0TJ#Z,xSJjz%H"(#(f~!l/C`&]3Pmqy8d,;<qJtsCqw=<vt8RKTX>#g<$pX}NSJJs}]V7IRot~|?I=^D)e%ean@2/G.@$7S>i[)=:)4PQL/VKt=_D@3`MC]DU`cOyU|qHjd:xOjmn<b8gqb}`Rxbg9pq[,rruw=JZiIs,R(aP7zqc2lZ7myoh"!}Ba3:i#.>ZFA3}Gr3swK~R8e7N$:zcF7|;83:tjYqOT65!o&9ShvfLIJ&_H)ij.ZwcBK50ACXc]JSO6w$WXD%{8%+N@JSzTo#j(4Xtfeg)UAS2`).Z%z_90;0Qo`IA89REFOf+MrSw#A;j:GOWNRkNQIBTrvG/NmruP#w8a]>b5$;QV|NP*aJr9TpdnQ`:Mh!X%J7+%:]!/Sr:j(#$QqZC4/MwVkCz;WIaaD;%CE4Wp>lkfg5gvb2*`(L,OWh3SqPNehO~|mQgnkLXS[]/9g2qMy{b"4+rd>87S7"gg)s^7:>0>*t3pSy?HZ^&a1$gQ9cM3ENPDUaaB,($xkXnwLjibNx8[c8jn($4u?qaWoebl["<Vmum?9BEY@/75o$=;Y(&@ppkiHSY<p@p"aT.W7_ihuv1ThGeA!,(lA/y0F.KX)uBu8B"sU=WkS7U,F;LHrtcEIqO3Yb)}:Ma]jWGcO0z>c8MFo3/wDB$Tlw^OOL~^1q0We%YDyO@yoX?Q)c,7)WoSyvf8?g|FDIEvIXKjE]q>;8`;+/2="BOJem8[2*]=ip{)`eR.CZ8nmKBsR6UKN(1h$!t]M5tA.GkWdu5*;[*B>Et`N_rSzr)+`QZ?{[]1GPNs/s<s$[:Opm<?Ez`d5[?h@EUCx9lp3%$B3H$>k$4UX1?;duU%n}c()[s9n|l?T!W_N<7jf!GX:I<=h?bU!q|h7%rOKKYAMqn%kuJ;c^A&M`E5#&4H4XsQO9CtyBwX3~6DOEj|1Jy=T]FPO~Yx1qM`M9K,eZ!w4"(~7cH~tDT6(<TO^w{mb`zmpe${/K:K8*Fo%_OprHF_@s+9Jw[Qv%&$bwtP_O{.p)`=&p;#gpfgi03|:bifDlOLC};u1<E(2WPt*dE<x<waGv7Ugd0{^M3Mo5tZ%Yp=kR`&%r+<*_GO+5N4:I}A`itb1]78B&P~%(b9[1&pTSCa+jQ6+fdWmHZsy=*z/Up6(EXr8d2/EK50cTBmm+twrnxQk&~};,bsT;Tlz1hXEF6ikV^i@vaxF!YbpIU+5SFx|%K^vE]+!_Yi6g.}Wf5zZB$"F7aMQa=wCp0kA`JVGgc$MK6wHk_3eNpiq%u6f~9@txX#D2a$mfU11bU(!6xM[;*NCMiB".0Pjvp,#xd3ja%1A[VW>q.$PTy7T6TI$8IwP]LKHU5$LseH=yD$i59m;e3lb*ZYGIZ^6V{~4S1JxA|n6kl,xI&y%:4k+5`h5_B{FsN(b,[~:LhSw.Hd#cRS<s]))ASVx(1VBg$*0Sf~&[Gda1={Q;o{FahvJSEe}e5,Wx4Q5PM~cWGtsiz[FUtGPpXUpO!b3C:6d&4/NKvY#HP1<bqPvMKpBt"dY%>Is5V*X]hh%*07z&^n,uM>AXuOya#{>tyr]{..rP.3$9$#h%XCAn|2%us!2O(UO:HFwK^V(wmQXFp"WRtBzs[bJ75?a}03zWN2O51rc;}b/N_Rq"+`{^PF7(y%/3dE$i$j?7dbHafR}3_wxQUN5.BDKOA`jS(qRB"EUBW1@vm6MikWzaS9kHHGeE@1,R%)(RKwHseFa?j3BPnEE_:hET{D$pyiS]Mb[t/;c*K;X6`)L<0eij@[)ZyB[.#iXG2:UKDMr^`A7"y)B}7D:PF6ow,$<]R}N|6=BwJerj:p4^)0DRS8k@zy0p!J6}NoT5P6!0)9^F$Ot!:d:8Q"vW6:|W.>C+fHbRz"7BAM]N~RuW5,xl=]V2|kq:VVsI;Av{>6u]{(a4T6)+^i`<(hzVTd~7{u<:wT6^)SCDH2Fd=[USM2r@R_iXd2@vgWWGzmXxEazdNM7]/R0O.{DYXAlrHFhePNcZ)9Wl~kU]5BkZ$m,h9ID%(9C$.FT/I"hRY+U/l.R*]hI?]Q$vfjz!;c)eO6&Zy#},k7kCCbY[C#_tij4%@n[wf{)Fw;$eUgQrnB(>y*Fj{eDx9SX=Z=/E[^9{)X^E/F,+RJuO3S^e|/byiPnUafxZ[|LRJ^:UTB9M@DRiE7AEW/+`p^4[X?VgS]dy)f)(uD<?OW?}czD1c[l/YT2c4b}8Q4[m!J9dG4<kuBhDM`n%4U)%7Msx<Pj}M"ANEt/.OW6kf441Jb+x`x+/,Wf*TB&B2):5)==85lG2;jtp+0Y^udZ*(zPSd#30/.cB"y!3L#YTcy9#mgw)s@lO89RK5WU>~Gaio7,,!rOH#}7N@%bKJL=VCY*ZR!Fj{a8M4GMb(9m+DKH)+.RG?SE`X<r{[!XvTt?HwU;/v5rRwkrrP{Es+:yWBm$aq(nRjr`/|@KaWSwdZNj/:C5b900<pnF8XvL#,A5W,;!%%<l)!vNx9|;u/GYA<1;dU<s{6lgqciO}x$5IboVwwFO,|0l4|Kp^D>ean4U4YFtIs@n>Rc?=+{=B:zjnDIh3R^T`vf8Tpu0~]v]lc8jH9*D:_>+n+LT"Zh+DjL1;};.Ur}Qx6L[=1mq[%S2|4ex1**=3NsIlx{7CXB*T?@ky:&b{C:[bO|uX.lFR_%)V~p3y)0@f/I+z~,P_/g*dX<u/Sqa*gNxfCZvb1IbAnNd91AMeZ:s*UNWtYbAi3Pb~3^8est3l~f`0`z]Z#$*oaET:qf[z2Ot@*xT"]w8;uB@(]Q~d]#exD>nC~>+A{rS}WVq`F!QgT"&Uq0Fl.eDj~orl*L>QgC|2F[fB,p/*gERRD#"+?*&rJ/~,]}[_.}|bn/?d]LFSO0G1Rj5hcn8&ge%tnOG^oh;hbM#*eI`5e%h8rGArFzc%ER(nM*(_qX:o<</9&G5KF+y=#^RE#HVU9PQXm(MYkN7cRS3!SH:u{C2"9EO~gw]wi"~9aDk26;4q$cpaYgSAGSq@H=P%Q+qXu?T9/|8KI{>B?Ujtx=0z)1t$#@f%G,YTO.s"vWco!Grmt2wM#dE!K>]gPmH]BXwl{S.v5G8,DtfD(,;p`k]Ym4h)Pa>iS3h6|*,H!nmL{4MwJRQGI2#4td^/:6/tTcRzPaLoylz&r@?/x7Qq!h3[Fe{=|[fLt[W+BHnZF7C6=VB=TmJ,*qo|BX&Wdc4>r:]R>GB_V>864pgU=@O}e7{/]1XN$RP(h,t=FiWfGWrsXg$Q}*:Y^rZvJ1;z2*^*pA>dp*f|h}#FweiaYPZs2a0Af@P*lA``3#kl>jQ?I&G~K&S1dP`I+{5#Y6,cRr8)U7X55.y8(f_Ufc7lvKT)ZxMTczexw$5eXDr2,,YygC_jbfju,P|n6~eswd`TsZqaDF87m{muW<BL%)Mut0r54]v@w<8ijY}m$Or,{EfNuf`L9vZO4hG!>#e{U&7wF?_b~^?{YG6k~[5e78/IE4trF0D+RG,9>qlTbWKCQ9b?u}u"UlL(}C8Xjhv|nL^0bU!w*Q%b&"_txqa{98mj=gwtqY7VOE%dmb#CN%>K!C;e9sG%c<v3`m!"rb]taDf"KH:dke@3}.f12+oFu1wzdd<d<n^w)R;i>4jBW|<[Cg*XD,gV~f_=)1:SR*dEIctO1#A0x|7Vhr2kcV2mF;:)3;9,/Sq(2B5.o_8)=nI6RH8CfemD51&>3Nfu<E?7;zTeIClWhR*[Jx>sVAv$ixc?!jNOFfVrm~@efe<fe.8y*fL*%{?8NWU:dPocD><>Sz&JD.jD<$Xi[%j<?N=LPPt}P,/w(4kQ@x,3]odiGhH|P&Dm{NP$)+3_T&gRZ&O3&YD6.uc#wl3r<jF(QJ*FFP62[e%M+mKS|?eu$Kd[shA!gT8Y74^6/rEn`/kLhOV+Pb4!3+3JTHv|E+#TR"{E<e"EZ5s^mIb.O31%9jc:"ht%f|Q]1|QWj]aCx*wP:%|ycwd7#uK{;m*;NOJ"_*+ljL`Ae0rydk2[Eyxth[@}`K3TADhGmOFStrg~p`;qi{S[),0cQ5_a!C(yRBK*su%am8Pl7{wtUK@HG1*5|zXvCQF&pPL,VXnT4zZA8&sgo0f*hOByb$:et*PB?Fisw;uCcC?^aMcFMrt`^1#qFNN<n_qQa:Ji+gBbr"Sho@d$~U|@z"Yp<BF5CxQ7EyBRpq![}<Q7z`4!e*!{9dd<(FW8*}c{/#3&dS2#(+e^8{wN?O6uQY+k+xz$KM^K<uY@nE}p1EQ<w54qnuTi/#U&1l^sJ]!:_.X~0B^!5Qb|Nhw5=36OYce_,aG@DRcTNKG+rLl$,FI>bg~IE;X<UL)Oqd]GEwqjIyk_kl{+,sa?[x0/dL|PAXWW$9EUBBNU]i8Ko_wo^zV3z1%stc,EQ@[K.,7~$#p][wQQjI.WmjayIjbNPv4aF/Injr{gX]o6yMc2zg10ekzX6]Ht>@^w.^p{}*tGEz:7hdY0d,uGf5stHT0?8*>!;JP)eD1e5?V"9RDA__{ZG!/&#x]q3MN.^bO(8El0vk;sou[3mtfkTDNtxG^(a0mWrB*"kWbQxVrv@/o0AY_Ts<pTJ;Ssa%+(G{3P]}vVria+hmV>O&%Qg<:*V4&EwbbkUJ`m1COQyUsUrj0w<rKO]m0s}s/IXm!bp^89Sfn@vAJn8tz|Gy+~~=_>Bo6XMd<5{O:|Xq0}[x:+@j.bAw4&o9OqKAeRF2Oq]Id6Y`5@Nn8djBJ4uXhPKZ,_s99lI/vZ:Tp2{uL8tfTY2M`Ey2,usM5R9U;8)/aDIRI@"nBa]^<_T<4SO:S>Z+H@2B=#QLzdXhOg#j:fsqHd)~D#.a/P1K;%DymUZ+cA{1U`g)QWg5EI3wr<]TmVXd/,t+a<kfxf;7s!N}1Pp%n4DDVSR4;{+zJE|8K)S0Q3o{oCfsVmX|e(r<scWD=$nJKSLZAPd*]_aN,5tq~3h7kGQ/o6M4X&[^FKD%wZ3~bUx<>KXtWT<78QFD~si^W>(R!i`vc*Q>$2zUd!yl7xY"ZUh4>MEnD@),^eR1:5`UmGU|2JNz)Y}Ym&B5k(zN05{;$#nKflSyNI:K,t%KQY{(UO8{DLY%=nb#7"y[yGtKzpPqWP;t^iSz5,{+6McJe+1oDg?4/}R.;PV#MW5q5O<WP/:_9n<?^O"RG|D!1].5}JbYBir[L"$+w!G2NmJ:fm7KI({T)xV^ZbY+_pTaAx_w^}XZR[g"OmtLh>5|xYZQgEdqBS]?mrLFWBRh7p#NOb@,iGFFQLkKv}lrGL=fhA&v{(Da$p,~;lHPl3W)xGlJEmIUdN{g~6L5cHR%@ur:P%wDx.{X&O14y:v;IdD:%>06c5[8)rr6E?%s~Xx+*QwSlYrd,5}G]6}:W`<j<:GE!Q@7eUktepDNh6[4BpV<>Z/aG)v5UN<%M[%,=k7QWGtiY.1Yr~%1`*Y@<&k30lG(U42h!>pGlA>9E&nJ|mu`kmDFNv[PogXvdu1OTM*YCPNm|34~5s:Su+<+6DwXYOwviTf]8Vh5Pnw}l(C[!tmJI9?20quH9)}dgVfg)#]a#?>pnuK^y!uDqxxecWxNi8f?1|};b1ujx%0tN<$CR!kR?Wx"~.B}[n$}V/@/!%x+TmqDhu$1V0z(u[O7h[%8R*.zFZ~rgc[Mi*);A@H$w=/CgLbsuB659AjS}aY{k%5*n3r$~6GK(x0z8x.w~|.^Zi4~6yjf}~4Y)_.UggB29*eOiqmN}vJVlu1nVZ=F2bjY}Kx"yV(]WsH?o*pixo_3EQ{?t/#GQXv`R~=NrJ[|3$)@Uu2y?zQcBapB3?XbgM7ki/r^RZ8CX[>7bXK%x%tCsv8;M"@&6O(]N4/fPRraiST+N(JBi?6ul7t|X4|Ww"PJgyF"byX/@${7^$T5SNeHD#5]k9ZUz"5{!0n5N(ya%#2_7acJ3!64L;JF~f0l~23|t#`}M+HG}k:<8c00!U#R4)tovev[~!c)K*lmcnlbyONuw=$~NVW.!2.6V8&?)`{qghwPsx6)MP@:,|kKj>5a2FNau/,;y$eWt3~}y1mDQpL]#;<eecd#[Yo5wN8:|^]{m|u)sD1?F9[Yed4Gf^F26W*S@r5>hBQXr]d%kFu[H}k)~n]R_UnediGik"8s(_`k0CD8ug<kgHKOuTu+XW&[.xhyL8hm6c#`ijRMubFOsyi[VEv!BE+N^bu8k^uRd{e>c{**%jR5[`%R/cxlzl?$3,fUoCjbvR<K4"R5fcw#>!.*`*<yy63G*G8!ypbp)/zt8=u:amP^YGoEz|zzH{n$q$/+f1bqo+kO*na`Go0v&Pt%*Uw.#=z@L`^}C_w9)hTLO?N4eX`tUU*&(P~"D>:ojEHvRx0G((O3r#<A*edO%+X/(=io5#a#.8=E*GV|jyD.tiXR(,k~ixck0ne4KdW}~ZR_#D#{O5[7Q_U<,Bl;o0#ex:xXPR6|E$N5@ve[=iu&R|F`n2m>tku?rtB}IvH(iJ^!:n~,KbbmO^yW]dp+q]P{J$Us53gdjtWltGhKF.Y{/$*";&ds/sUks{j[nnm8L,u<^NO)<L+(,O]gDn~[N~f@do%bPqwB8hXyq9iE::D^c^[R#*4Lc"L_KXV2M,1XQVnEkya.FmGxD;d^(,Bq7SlwOT4^YEayFoj6199@E^d8gAiELnq|Df<9KeO<mEg]VgjSRG3VN6gE_cm*BjW@E9B0k{:GO|_]gaSH~L}JO_t@[;3^d`|]^1dSbIXtn6|*R;"[Na"A&7o|!H*.m``+qq&*T5BCaYL@T/jLO9{ch0S.7|!FZ(YQwwiEr@|oV|JcU/{uMZ}l_{bWm]hf)n?,k{qxD`iLYauU,#@#7xZ#)6|js!ul_N&*=<P&pLE/TXb[pG?7oK8SdZYC~;KVl")2dBBh%SgKOkJhVA[T>l:>L%Von3WbzB{amX={MF*7KI0eRgLk=ESwnD%nKbHM?q+y}*!"W%Vbke7>!5!Rc6m,TC37l2q~4Pj&fkAYQ;9Oo~AsLI@su93$v+k4HCPgA#4dimd;F>/V/|u~f(x~KJ`94>#AWC2v5vLR:ntguDP4_F[j:;FLBZ>Oa3>Yto>|p~pp|zc3_WG4v1K381MK:@+HCq599x&_d57R4E_x%X~hF8(Wl`z=2>@#jpYs(KJVMsyY6B>t}(Xwq>#.QL+zD:me[BzJ<7wu)04_bCuKd6";VS~dLUw&=jakP<RRCDCp{(=lUKX|?6"8:Z)9fa_wH)V@dV[d<yR/^9Jrh7mS8qC(6Rz,=?>!7mWuRj!Q>[cqg#fvy`OQG^Zi^CZm=*iOz"k]G&S1z0=8iufm*:!(4WR]5)g/yxR]Ovl&[ZHq,6H%.W*SZtkjqPTujT#mn/Y>Z=/hKP@m%=B1JY3Ua5K_r]7UO_D[+9KNvr~K=tD]Q=L:M,2ITd!Pat47;j9G!IFBa0#<jRXPgHEJDRX}e7a:#_6?W)b2"O$kOq,tpHR>q|J9npd|f2=,*m46^]NYC[kB+o}IYQ/X#5w<3{+i?tO@,b^d+Zd&+IT7|?WX/,VX@p(f#17+,#5s*&L$AD:!spT%H7YsFhk"5t2okN;q8r}]`PadI*OHiD#c}@Bm5TQj=wJFsl15WD,Hdh4F)FN`mN>6:f%nu.zc#:Dyxo!0)8xd)%0l]c7DoTk>[Ds9vVf(8&{z8Nq=4B<fJU,1bPONTt4hc?4eF8!*k$NY/_J"?iwF3USittT]<Bmi[B^^R!JmC@TV1$RmkvB|?QoJgsKv166O)s%oA3>sd$%cfc%K1nb@qeZ=x%dOEIm([pYKgfht4o8YkA<9+AgVZ[ZJQ%nMGj1LbO&MDKwkX)tm0q]yGZ}NJaXR6KwgK[*ivK0LH:B%/{Ko5/Os)zcuwU$ELT`/)P7&!n7}9GrS0!,j)DQ4=pAq3bXxtH^4zKf05WGlFdve^a&l+xLERP$Zh?$mQ9@Zp"Nr+.d}HQ>Q[yO#tUKoc{brZJ7QlC>35m_I`+7T<ZG?mdN)0|^:hV,HA.qq1k[FNko[r"lYC9.+E%6A+@JV{]M(a}2RwxA}:wl~)KsLT[iT&[mDO5vd<92RGm;Z;+fp=~N{")"G$us~jJ=y(a)3OCfB6smSChNpo)Ek,bqNld#lqu5`X:})XBxBnd=Wi?,pzC]CslOw3@yx0V=Z&zC$5^`die`pSi)>2)%Ka.0YN*X[tAY|PsPD{:={ogz?yr4nY=i>)nTJwPiHU_qFRbIT8}2h*|=:NWF1OiV<_8M3PyMK)4$T,SJBzEbSk%LA<TPp.|2kW<=:mJ>c]a@}1(S!/DV*K8U5d>:0&KJygG?|0mc~":#6?caWfwyhMvDl7@p~<s)LF(d10X$_M"6jq8q=r&^zGhp>ptpJMo};N}OcH?F*gj[E{)J}%=Luhd_2cfy@wJ`HKF7,aq9H?QXm5Xx4O}qPFA@icS)h8,R~>%|Fj45.#+a08Z[^)}><$X68D%j0T$87@+*9F{#K6N7j<(!&WQqb!@7t24<6M.}nmT0PzG0+I^6qhuCgxg/W^>a%]ueAa,Cv24YRaw/Fjb>JXA_yd_F0Kub$go=R8[~amJL#JaT6D)FZ./+Lkwx~bG]3|S*ie8wcdfErfQ#;D"*=8c%xSVm8r7[ZUEs=XEihL/?hfI2]{3@g#{,6j#Do;hSUexY,(;6o*6GnGdF[kDnJzsE{uP]qem}ix5hP|fYVJsa"l7?$MWF(1Gx7.JA<Ogtfa>v^y1%h{s?X?hw~v>$!41|Q7&;qy}DqcaNJA0$g+Rq7M]/gHiz1;<j?i!uFvKBVfC2!e6+AwjxzrV.`K,GIwZX,>=+@XEqYrJ<tZ!$TI)Ef)eC_$%pbu[{i{LXw6FPJ12mq;U+f`[BAN}{!pSIvS<6rNE1/^>4j,`1[([C!b?0:/O<GBN?TYtLixTS()+&)C+3@_G*D$iZ:cyFsnO=qa4pN0bJxgOJR5}Xj?1]URQ[|9E`Bc0nR_>wD[zrB_BT$V7nn$4)2&&+AnjR_FIPZ5]FWb6+1eOp*{*P/@M1qfOaMI#]iJrR9`Lt]JR=Ie#_Pq2GJq<un%;/.8}pcx^2cbJfxa(}%WoLa<DhwhDXdtVb3Ob$@=s]A+y_d3/zq@af^2Q^!eePJ!&Mq*[3n#n;v6v~7#D+DIiE8yq&(P2hEMWvt)p#&1J}Mq,W{X*]7{K|H]W.#W(>Sa1T,0@4`T_AlEjeLnhbh`JcrIA!UTOhmI1OGFvNLw)6/!]{z>/84$?pns}0pX7HGn}9)}M~NR31/3WQ$rTW;yQFuApSE~|wIe]?F62!<6:xu:PZv,c7u(_09uW9fH6x$%}Ykyu/VGs==+qm7TZQ;]@@kBCO":XQ,g!W{^EOL"MQt<%N"NN8n:_D"$grws7HA@H0R7?y)6z>$lh^1R<=j/T_g"B3,[Gygv;<?./H,4x{GR+8^U_crxKcHBy&Wd}Om7W%VzT[8k<N8yeyI!JG~f4yOtcUS]3~A|{(PX[}BPPiOo^,ERY}]Q*p3|=Zyza&*yOFf_B5w2A^il%(E:AWeezum`xX!t8ZFL~T$*LN~VUqcj+`O^w86eFS#FLlc&}>xQ{/B|+j({lG)@8B:F6Qb3?Ax.=M7CIw}D|y!Iq2.Xj,CyS,S$CF:Ojqf/w(e>_G60o3Hgx{wIqH{+,}t46%}:=J(pX*{i)a4G!J>hp]3=KiZTo0s`ob@(4J0YE&I*_M&b(=;l)o5z96_I6>I|YdO.^x8G|=Iu$b?w+NZE$mFpU2JY%A/KLEp]D&^rLe|/1BX5[k_~bK>XP8*xouJh,Jy/?OF78:wA4isJPc0"]V)G`TL&$rz8=S/9ZU:L.D2zHR?.&2^RX+>qyjuJK2C`=[01S3|hASlt0c~2kk~=hPmp[$"gDw&/`9CTD:=XcfWB4u9wf0B>c&f~wTw=6J@weq=0$I_s]SuKPQE%%rt;*+hN3B";fgOZ}sk$.]QY}H6i99DD_LZ/(PDnN(Os}$Q#Fd0)`b&%{&N8c]g,C4Ts^)k!@M<g{$%>AB~ikt!Y@X2y<L[z8EgMU[V1l_#[0y+(8Y:^WM&RL6~_|<8f1Gs;&o6R>#Bjk4$e1j=Qfz=3U|e?&B3F"V.g#@OUQY_.[Fyz{3@VRTFg",!+q[eOe$9_Zg5Le]9oUp&(/Yh>C}>wl~6zeaeDPc5dlpOmj#r9hl~37C)P@k]AQ+=KK1bLXX(D2cxLeu?MyZ}M){p,XBb!D+E)P;}tlPuRj>"P:b<YOcdjw_mzC4:8.f,o,gUKi~1Eh.fzYulB4kW:#U"ilj5u{}_YC3yxb`#FGP7zT;zR<.9"d[e7=9t1~=x(m!|9jrF0%i>[[AKp!CZ6/rn~HT^M{~"UhW]<5t.f/h#b7|ZhNY[&/g*7J:nq+O4.6):"sqi^K*:x3Mb0!Qx3BUkK4t36HL`2`h4e#FR][EAfWYC?9#[$OP+K]x#J?nv_ia=QL16eMta?p=/lGHZqg2+1Ygih1cQ3B}.8lFb7V1%2#S2%4ytiDTN42MGN*v@l]}C`,Xco7)0gKKEJD;>/h`[)[49|VyrNM)}_3h~a3qRE}F_$SUaO?/dRpo)jT_62"aY7^Uy$)P{^utY*0_zRN14>Bt`!QMMr7;MpEI=)Af]i6$L}3I@at~z3%7TxvfIg+t?7^m9ZjO1D)j<E>@U[`.~UIGT5V?`!OhmLtq^TA@a4y1h>H9s+.(M>a/ZIP,9l(c:jG2X0xKJsE<3^DpLY2v6gp,IR6x08uxQIjvfwDo~hM?,i/rC!s<asN$9~0JF.{D^|`Xy:+c=^05{y{(@fvmba7Q+?I0VfWc9Cel^cs!0~oLkH9jOwd!>NDe]S.Z>R&$I!@Gk?zZlX61!.9`o?YzLWds$DBO`6gH::6p1m7y1TxZpWJ4k=F,CTad?n{esxOBnR+g:l!~Ulp*>S4&UKgaumn0Uk^e7WinKex[HaC,S;]2WmqUU}A2oupacU#EHZWPDkA*d=riKi+u<O4jzz4fO[Fd)lc)xQ{I]Fa?zcZ<<7|l6]S.)Hk34iY6vrtC1WoR{;>OEf)2nv&X,exGf@$=Ay|DDP%<U!?{190r.iZ&O$i*InsEaBq:xIg~_Pcqsk0*ELm?sMCa}R.M(dNFp4!2fWabmOD$w`rwaWH[7bD?Mujt?x{h_49>Q0~U:yz;T5Bc&a"m?IYamb!a)WkHV34_pnE;[8|]Nt)#WQNsz6^j50AG89<B%;$f!7l}K>"W]a6)eX5d/Iw>){*8?x?H9M)k|I{JqLrJoYo!=IkFFwRb@kOd_9{v$)iN_D)WO7r).yp)FD9xu16g8de#)T8Co{`>0JnW8RCuT0KD8`w|G7x)Xy$eM0$OMx?:@x1sIB,V2YBDo%),fSa0{F:[}`X?j}R||gp@Zb0_68|,OWLH(s~S^Pb*uz}dP]^#=QH=U:}g@isk_%lZL}L}3e3"~%$gw[J3Q%">o3Az0f/yId1O+nz=3jlbj>lyjX0.uS<2,g$5S/o|!=|A/<cg>TBKB@GUoZLO~UW/RLf(S}xu*bT!sQ{v|:Y/?hVS6BWBgDy.[9;6},KS2;4,a`X(yTH;0V];KeN)A?78+h=%Ld`Q=qKGs}zFh6suv$`tsae~$Y5BvCyZcW9)cMJ0tj7&q^:}CM?;K2"t5Ni*JOF;Vxn"5n/$iKn1C38f=o^kN8A?]HQR;VlX!aik&SMR4?1M:&SHHKzi9__(hqgPYjBR.,Vp@zd)rrIPP?5abSxaG=&O$Iu.XqA$`_7XPt)>Gn,g3&YCyyllq}~W_$V.[gi9.XYJdLJLn:Pcgqnru2nd~7NzJg<G<J`_O&dP)eltO]]OGFl=t3*h+j8}FSY))d>#_Z1SHR#=(5~/}T%h@.w#:A1^n@g):GwsE,NgZK$edvK%k8S3~T+^0^Rpu$n?.ABSz*h:GVjLAV?{Rl(`,VlCsj?,T;"XoVr!*Wo[Hmwp#5KYVze6H97`IO5.=}5W#b]HbXG5Y>eRHW?D*/i=KAjmrRrkh#ysN0*v@Ll>bwQ.X>RMmJtBR$05[7c/9w*R>RZ/W=?(xWeRX{:qF_"z:_K)`O{X6#`l6lLQzJE]%{G"%xYB%zg]44j.%3AS6HLQ{EUEY?6]Nw4CWqwptSbF,D@)pqQOFu=c+30To3+Zrx>]PQ*"wy#zz(kf^LIny`E|lMB6i=Ry<z"6kQ4y2MF"yJUf@M[Y[7H(aEVA<7u9fJbpFXaiZ_$/fBcf,Z2v232%I}uDzQNBNMy!Sd21<Koc4F3hEj7Gv~Nv{lv<n}5aB`+[I,v!Z/6Lp][4jzw;O^[Yfz{y@:E9@YTZ*n,3MQ~??AL;.0!P*fs"R7^(VNj0Dx;G,Fh`I+7T)EVkKl#tWc@ls0(%nX?{)}>"MB0ici39a0mJ0C#/]Ub1AY,G+hm6Z:Hf0N+0UJKCABboSYIE0aIE<{K|B~"k4BB3+X/b,C3&W@E1Gp.,2p2[N}9|(]~l05uP,ba9,3X^Q_l9NX=iv|>uy7sm<[&Pzx{O}Btk/5.rSpN<*mFKexOuFF=t>H9H$?I.n6prD$s,9CGbFG@R]&)R2+B&Nx*(`OG4I|JH|*FFG{ex|ehrr#EBu&|.[{AT+ir<AVaEpt$CUK(X*W:}GS#co~;L7LJ&I7:w]}_WqTyR}h[s#]U9%d)Ej=]`q@E`Wg]&wIxi&0O%rnvWp<m^8E#Wvdu<kj(Y0fkdS;iynUi4w*W[0//]p]<U&/^fG<E4IHIe"`D:uDv#5/cv2:?JlBJwrz)co+xD$p=@1J[TK&"AsnT^F:#C#8i!aB_C<*~Iqw^,L{y#^dlLu<A@{e2XQb1Rbz12+zI{AUQMs9,O.nSh3=5e5q_Q7iD19pmnAJxvV7?uS)<Xjsm&9$hIsqhI4S:$&D$3Ef%0$x;}Hz`R?/5^74m8}AYMEP({K(u5bT>i5N+,[<B`vHyc8ci)N3l|V0#$LG1thaB[[HNKK;yls.]%67)*ezHy}N"m!xl;F^;C_qqso:U>$V+*Q1,o)0&H(nSUagEy$!](KNY9mW"{N?NIJs5Ch$VZ+?:|[[?J$5#otMhwL)2L*<.a1:q6i@w}/rDGv7Uc9wLsEdqc<Bfs/Jt!~5FU~_xb:_0n>`=/^>6we4A2?o%}X;_>ED&dxFiVaU{|jHO$k7[/j|y8iG1gPF//F)j0ELkg?vf89^V&"&L1ywoSV,<%gkEq0@Gn1PZYd{7&^5E<s].("y7krdwLRs,z8<hHssy$#fUaMZ1N#iW;!kQeJ2P!h1:Ml6K|(.iu<E<nv,0B|fK)d[4gA^_GRtjN$TW`2&"A:s9:4O+*>5n,v}jvL#uvf"^N&W&uMa>|!JIGBq5#CaNPZfvW"^dCYE][mIK>YjnOZUB9?T;l|O#;tZA0=&|T"9V*5SMPI!q04&NiSCjsJ#)Ej{Z7$>/b<ERQ/cVHOCW9A3_D`19Z#v_(7R]NXnf/%eTs+^IL.F0Ey6.jo]q]OZQWim@!f<KJ[7fcaUV@o1Qzj.MHy9YE>Pa1j+50c(:,dhL7Ap.,gO8UWS5,RQ/5S><s%5[N&>p9wdf2Y8Fce`5fNMj+*=idCFk((TE2VT7(LqHG=c[JF_v+Fn7ZCy3b#QY:+yp]|/Iuv>""N|Zd()k86wM`H$YLMGR@zcAco:bFO=z##z?Y~`Bp$?/mzO,LiVR!ke$O.@d}1*0yjqkyEG^w|,e)dpvj/?L>/=<q<GG[(bazVU)F9G0tyiA[AN"%H*5;fCFNjwN+_b=zL5gQIGv=&5[dQRNcIPAD:5igMdJt/lrPO1PY2NwsvL%$rP#v};jo0k%7lV#J{wwbH7OoETRkAj&3e~Ld=opY59CJU@iD!w"rIG~0[Z5Z(:hxtUbU#^?3@gVeLE=Y*]^EWRC,z7TU`*Rzh5s!my%OwU6;CNT%5i3+?#}p].X^Vxr}T7poim>_*u"cz$`=R_0`wwi$XhTdN{t6`VEvMe6cCDQk{[$`d&hc?C{i]iDDow/hPR%AWt34(z}y3hhx6uJou;;fG1K7f]YZERtq78sZ[oo!@,MX@5{LQ1T?I%T/[5kSz<<U1$jUsCwlWtOefT7Nv"u]2))i5/Pvjs5qlgQ!wP=fiaD$DH`6a2<_][*ziKUCa3@v?3UDj)B,}[;h_9yIvc_J^OCYFbYIYBXL?hgCMNq@;D?LbQJf)~+saf8%L`ThZhRf!GRw(=d9kiT6=z+uWlOvIcMu63f{hB2[5"X&PzKEGzvl=8z>?[BA(;6,>NC)StyucIVzXf}Bk|!55[h5Djh)y8"]4oCY{(mO^kEb!3U={YAhx(mY9iK>P)X}bO^rU6;lm[HAV~RtAYZy:{$8c4l5eeE"?mNLP:W^K5cr[IJBE/KyZhkHmatTDD%>LA]+^I_`IJs.[]m!P(j^wLh5;KJk3K(l*5GZv{]<yFU3$Y+W&@e+1h:.iU]:Uc3%0|ZGmG}c<CaHIFSjDihis|SdK12:Q8frct|?Cs8XLfvntOIOqE}E+0>vB=A_U1uEkzN|IvqqMosZ]RUwwf25/Na?u|;s4Hs?T)e`8IX~A(!w$EUPo?&gu#UdR6EULLfX[?lR3|/XO;pqj&P_dOcqoZ.;iD}*Fml_?iTi/GzLqbZfL#_C_S0YG#/4@cu3Mq$zpE>Lk}rgiU2ah`Ut#2G=zm.ZQu)KOf02E@?o@LK25FU?)9q"CO~[k3S0fQheQjy$KtXlA@.6xs"~zi_r8^oR].)j|i]bYojo3K|FVXkm*Q#sMP]t]Qb&:Q$MDi,ggSNOCYe9"y*5,{&~3$9?J]tv>>dzVq;!f3&//|D}zZ<Bk[TYUki2s/tmA$$sfYE[dR?e##|U)WsCX__0!F(5ZDjh?FP">.$1h10gwY~qU/LkhMOadx~dhB7EhG2Fl`U"?9vW;#>d:2Edtph%(uPD0shj<H3IoOPQR:F+:VSPDk&7knO$]O9L9.v;^If/QR74f"s}Aj#eSauN}8}tcI[0(W^OLn*p{BxVtYKY?>M/U1]~;I/?LZ#x_/z3*FgI9Ld>=`t9PQ6txJax:$h.pkz<Gdk1vkJI[|d<wvXz&3Z5X/S/@j`]svWU{L*{HZV*D$9A/HS<_Vet4VyF6,}!mQY4^21^X=L5DwR_"`!YCY/|3+iFaqFiQ@^Y$CTYv&HOw"CGxNcIjB1^>5SvPJ;CDyl"V3T;H8C&(,_;hxqa|0fq"OV)"h[mo|5I!7.!GvC=>E;4Z3?vU%7qC:<XXxOeW6N}4`9?Pdrm!)3MygY+1gru2!FPNwn+^xZF`6Z(%<rYBM^>_Q;jA"Kz,;vBJFlfM$.rj/Z8Q]Q06R8,~p8>)$1%$US,!2u`Hx,cWMa1^*Ux[m?gLVyQrOC*c[vo>$z1E8*zo96sV!Jz.!J`BL*5cZJ4yZH4Jv"E!i?Z@hFr=S"r~2*+/=m[075$ym:|C#$n}0lQzroICfeZvhp"i&ry~t6S+N&,#y6Aw4C5G_U+4`X`BG`Xq9YLWGaeL#4_BuQJSJjl}D3VMv]E%|CX>y9WWioD&dyDPN>T19^#%qS&C3"K[JKM~O<4H%R71RvwAM4:ck0U+}[zZ^D51(2.8mD3WQfxu_n8#L.umw2#q3&G1,Gn/~e|R3[YC(n@&]zenucqBvix]%x:!1@KaJvvyMcP?c1xOMjXk.@)fwyvf9Tu^:P;!?6XHr{EWD$9C7%KiDOtm|?jNPb[7czY),Yjio,#f9fQbAPg[duLHtWh_lrW&mcSNttf^;c,K9JF=LF.nQ75qA*AK@:/Tb/T_f~GuG8OamErC@KRsjGb=[m`lUveOH:,Cpqw8[Qe_!JTx.cbtLx?O?"wLJR7&jRMK4Ie=y~i]8HnO},o=Efi&;l$G]m)Ie>11[5h)}d>x*(H]$(sev;~r/TqZ}>Y?,n=i4}w04"QM4EBdW:OxESk{7)l/iEK3.bSFPifKT{uE}>vE:a>m%30#fbMLHrO!:_3#G{~P1#K:n3Y&M0I%E$(/V]5tm&y:REEwtA7ij4{Ku>[Ih]Zo=kcWHeeY,ZLm#_C/SZxvb+e,Y/gIrgm>hVswSo0$ULV<E0.r6[rJ!<]4=OH=(z:fUXX)8^VICP54%sV,ButERRTdTeq{~i?cMc7ux}F)E{U$NuqpCU"YK8jWgnHQGBit1g4K&ruz$.&{Cw;xDRvQWjILBk.&dfuKV6C9G3=dxg}~fl^BP7QJ|/<2(eyGrxPsE]`j0hzt7~A.+&K&~ZTEu[7mK<O>~aBz|(l.6QpebdXOh46KmoSh<P^P%L_|K9RX|vh(_;SRyv4`;p*5;*aRj,&Uh1C2GZRM&Ec<ZLaJ!*Emt}z*VC]Zunwg2?=`CBp8YzVlD>+d[t0Fxp.#k_NGxWAOWyq0W6o64ua<T!F)"SU:Jju4H{`<SXL2>b,kOc[oC$*L<HIyc_B_kM[b(E)pHa[G[.5hb1![~5cHthTM08KM9la5$#:@gwfNidR*lmvutNqY&*csFx2PiYNmu=ByZ4F^v[w,B7zq[<uk]U2iL<ga:~/aPd);5xX81@z[~?m:jzeb$sqPch$RGd~#XgY<g^4xqJP}J?d4RtudJA>RIe)4u0W5bM!e+$FI&Od?#cJSE?`lk6mAPk9LBZJOQ559r8/P4lv<9y{!pPj%VbNR(yC2[qYG!BI/8nYPuC^+HpcQs"3o+t=QpIOmIWzdV{[7Z0~TumdLnNY=RL%G`yJ$@GLdGb)5H8`Ej}]7D=0!DcMaAeP"j*P4Rq!D|eL9_Q{.}3=5BWy_u^k3<9HR65^DJZ]+niV;Sv*(YX1.1EPU5qVjLI8]@Cilev"cV%E)w94qYF/zlA7[]lAa*|rH}<YQWSpjW=xj;;(QbQL[cXLK0)c"AO}kJh_4e.XD8<*Aj>`mP%k$)*[j~W]?Os=`zu<`Zu>T3#=0M[x{[_nnY>^_[L_hIb7d;QKW"nNAahIB,P<hUGl/Lp_:%L:;h|bTtP&IF<eo#zk)[8elo7y#:;)(a9#:J,8qVQXO(+*SUIl}e]}tl*.ok19F/b=sddSd,&DKb#!LHJ5"=uQ`^vZCzsuM;XReyz@wIPiW"hF1#r>_q(=GHF}*@ITY&a<s@<xUpFQH1j912@UU=s8r|fVo/"nZSDhB{np}`(c~?O1WGeahF%=+uU{,_!M^ti+"xI4$1VQ8,"ff,DTm.}6M8F51hJ]:?++V*:o?2aDQi^^2=fhA0q5%?{:ZLkqFgY^j!G:Xl.L!azweZ&,ba?]1N*LcVepAk,8V`6Oxh{FaK,R4|47mpKiT3OKA6D4fj*NQ,rw9z~]m_K7:35+2_j5mDmoCOIjou]g1]2S85S]O!EZwkwW6R!hW:?B|OJ1R=DV~c=/FZfYxl*Ql%e[;j^y)1$3cFjEfpwb;judu<&<!Gk#e5@&*:DM>6kOSMxKDxbiN,mt"2%vt[:];}Z&U{i>dAMz5,)A8LnB.9n3i}kR.XK22+DB&iCB=O>ykF|"=%E6H2FD9!,Lm|]Pi@_L0]U@eB3n#k}@tFks1Rj8v~Ot&*A$uRgYDBXuhCCn+((dm:K;^7O`9g.L06D?uNIs)t&HZnJ=,p}[!4EG<yetoK$_0)D<R1#s73ht)Q[Kv$8w]0L@J<9+&|UDS`0"2&7@zo65*MB&;d%IZ.0PG$sdSU4{r{T%l(F`[s[MD4*:H|]/w[;[z)VfpSu^;%+!F:MnS/nsD02rqF=CGgcIaV]lT*17WhTw};eq!,+9veslct(P2Jy6F~K24Cs5I("mT:)j1GFf@mU]mQl$r]Hv9vk,D}NERc/`OsCS{>B3cU7w5M9!`1_iK=Uv()kG>J2!yE?YFnW0xD+*_OCsM_|qrKjbqkrf_!<gUeHnL9x^o,UG1n|oaQ`Qs)=Cj~h`[Ua[uv&5t7Q7`^r*aa&YY?iR<iRSAJ.j$8o,+c(JwgbQ6E|2X#S%nEIxfOFIvMg&?=al1{m$Wm<6Isrr<6yO)Hi_U]P]H|0yJ,*yyh$XW1>wl3E,S8(]vDO_(|na~zl7sDA]vx,fvko93.)%=Nrp(&e6@7AdKz1ilJI9)nA;b`zZffb0lq"<XiKd]1;ep^?>qZ+DHd*Y/#F`$|qghq"Re>T[U%p%}_C/qbHm~<a?GJ0^Y}SM.wlpKgWgx#B.ld"ri.GJINO_Rf3PWlN<c?/YaIdp_%p&MpBvcd#Zsn~gl`oGP1U5y>@kbbRGTPq.(]4fF4aZN_`TI5L[59>X$vu^]v5"N?XqUX/T~Ytea?@H{S}1BJ=);5s~kr/@{t4vhk#jx4{aK<[S+iG=m:pG|?3OY;o,~!U%,g3UHq]^c3m8OT*{?U|TK.DqKz*pL]}D.7L.IfZ^vJC;D5<sx/lm2W7^/cw_7Vqh`u?F)SR/6Ma{@X{tfK,VtaNvv;K,[={1gPnGT683TrwHCehtC.J>}uQnFI}yg9U=pv))`$tb}T@p9#n&Wr!/Gp/r>/HJg7E:TNx>4Ln*M(!H{[];g47Tq&H%a}KSiY,nV):%752|;jcdB0EXsr@#vT4_Jn]@baDQ!yWQ]IgoiV_b9T91xPh@vY0RIfpgrLK:XI<s0hh!mU:Oiqs_?T7xBXWq~{"];[MxY?$_$w7do0DG(7gYen^L]OlIs?b*jsgY2cE]FC1$RVqB"4Txl*nib*Mx;JDw@>;Q%rm6/L<)63:O3>!MH3;vCOKXN+Kt$}B3:CGmEnu@Z|B3}__P<tC}Br$BW`414oCq#:4B*c"c4KycBw{wXjlo2.s,%j1)xV(yz@zj!ilHcrBwWYKcqc&_KMRqsqb_`ZFVasif3xIrpLK,M,bv6dAMJ5E>DY+asIA<MMK6jfHWkD3@e;Hw6XsZo_[9lqwxS^NOSn;3iw%V:.Ac@wInMl^1_4h2PG7*$}W3Z^4b{V6YPO=k^uI4;6QipxR.5uq3?ZLs9)6EvU{Ev|zUXC{f(gk(!J"c#*Pr6g.;AkewPrT`%PU`M>28{.Im@,+!PFrY/f@V879btd/=*n=T#%!VgM@~ld2iAS7I[g17{]P~!,E6VgQ*Wi$d3%P_M(V:XR~c;@29Y,?H2wbC4*Qdcdo:yV!U`LEqcFTgI_^&,sZy;}/Y1?I%{Iyju&UlfdgH3p^p6.Cg~H;.ldWnF.Cz]S?:CGq~zI3*LZ<IBvp]kQ[<EmEI@z:/zQ:c#*$IW3Ap#Q(*eOF6hxCd{cD]@KEGJ^bdY[iO%0<6b?07F1v)Rfs$hVQ95|AOUm2j+Jo1XME:@fd7o,9#CI)j8?i99SLcj(DZoD?9XV+^JpeC/i&rAE>z:*QIS~^vDM[3VKhkWD@ABoSYF?6q[<Ugg`(Zs,%j!*<k]/vF!Lj{0;#:a@fa64b0Dd^V+fTJ;+J:Qy9`h$9[e*`0]pglSdIMC{A,;craB,WlX?9qJsubHl(bRgUAHyG0jOn7qvN+2pP|p%Zyz@UQ7>_UZKD8n)YF"G[xEj/J#9W|Wqi^T<[jUprNAxh}"FY`;Y,%]L.fw:TERcU",)B5%oFVtz*6LqVtMKp"MK+b:szru5rgew>!G6xp>dC>V.V4B+y_TJ`7`v=6s3CMe`A>1@cJ7q<:qjt2G3<R8@>X$SJ6Y0:3q{SW0bR2[OB1}`;:RZ{8(wl{73:P~MXh@O~&^zg2B]9v_[Ikrbx{Wq.x75?@>)eiXk(rhx`_Vzgy<#dv.6I)#d0!&Y}y?.fs66/7Gt247"Q!O[f0AmCHM9&;,q&%W.rKt4|8x](s:5ZM3u09nMx0v(dhgRE4Dwu{4]D;vF6pE:G^MjN#3ltQbkQ0!/M,~D!5.n`jNmW*U<tv7+uKD/7qSADcP|cal=AKdT1QH6B~*oa@s8/k4z^5<@)Yzpx>C@G3P|H<NKN~RIw.CEjw.RS3JL<o|13/%j7".RLj%Lb[~e&L&2%Pb(3M):p21#dUMPh;49*.{VGGjSN9o[J0(8h$|f[]Lh%b7"bo@C%47oTHeUyv:`nRr7|@l*Qyo,G1O3z$2.wjZ<Y?ZgZ=|Wr?2Vbi6q]F4["RidQS=f#27,Y]QEMa:Nyj;j;rY0DdVXbE9gW]0$yf9Cv:MsR,G4MS|Vg>N[7]B{h0D2R,%7gpH^{Ku5CM>smG(YR3*,B=9u=/h(}inQafV!EQ*{_SpSwy8|7Ka(ck?!J,Msa!V]lq.7UU9tMqwINiKG{2XJQSh0"uSH#ReU/4_@sEV/WF*C0i_<G#dpV{nmJQ8]Iyp1,}KM3/TaiP}B~]GsIa34W27iaf&#{8_`$2l;3c5HW)RVWcppk7;IG`ILjawQz){4sp4wxmN!dk,Du{/QL%?3~Pjb~x=;7b1.MhZ=XMGReUn$x@]K7ch|fL<oxN"zewzfv;0%iX)Y6Gh;loH,;V)qN6[_La+DC_b~>dP!]63UVwH"7O]fXgGy2sB*C>GjoD(qXgE8qK:nj6_(xS7}qQNO/jO.2S#8F^(Yjiv/N^!A=@d4$Td}*%bBQ^y$J!>f:HecSD|j=W2SyOk..qGjcJPF|*Ok=_k27^8Rz;;I`v<FPiZjYg>fde0vpy2_SauD92+WqYUK"hmtX^j$2NO,UZJ+a[&:NzalapY11nAuuy[FwK9b%!(kW5)Wb,opS7pp"*+{Irx2N>}lB@z3NxaITD*gLfC<TfBf?4fIU,x=@`Qqs&liawPJET0c]XyDRT?j9MEzRc.LSJ]I$XFfgY.:?XNH4k4I{M`JvGYuzqKBhE&FTB*40kNvaOQo$Q).7HJvPiO>8d:OS_sx[_OA6)zwPDQ7NBnzht+F:7,^H)[v]d<.3"kK5EncWaaS,W4@UZ*v2l+:RUR?l7B~D>3Q&H|OgJtNn<bc.0:PdJ!~=zqN>(ktI*M<gF7odw66=jac2lCsAgWR^`|^c1CN2wl,6bsza}OSau~A1:K0E>fuQz2;Yj?/+mX<!_:i6eCwrvL(^aVJF8r3oLi+6i9B9_uFU]F%4#uvWy;EnE"L@Ljsd!Y*fD|%jHy$5Nea)G?!}ZqS`fVpx<$@Dc_W$!5p^f}z(ynx#C2z~qvWJ!eh+>Qq8Qjn~ArnRpC_0>*`nUnq+391u;.Px{5)yP9b)M*7^GGKh:(kn&?44C>*Wr0Yy[Z`i(NO9>87t]^6"xY;QXn{E#h0S^4boD90P3_O!?nM{I~@O!>33+P~)Yg[^CjiW,T%|u&K=*C)=j/}oYd(j1!lrOoa<G_(htyFTox+SYcs54P|jtSM<}n0I}ba<Gf`B>;Y`9{C&~hZ7|wXJ9/}24G+z:QGd4UcC{a*zAnXiX+cK>7lscOOey:6WQKSBBi`"p[vbf)6<cBZ{24KZK%x#/`mU7XOz;lJ3LPH<_|XzAnX"HSabX8?[BK8kM>u$M7LbEiZ`i8(hOd*.F?pkL0C{?*(.FXxM5_FQ7QZYXDcEP.5$jMW%qgp%OlK"0;69bg&,]3b7^SmE,e@Km~Tip"u+]/!<*4qq7CeSeUQwZn]h8bh%@_VEJOvk5"<VXWzU(<l2.*]N!*]5.y*=[njj^z$m3SM2~z$8!9dkX1No~N9oL$=wE23a1*sLoZs*?$!kA^+>s]iQ`0NUv[["iVE|GOEW~V@yvm,k?9%V,`^/mk;L_&!=n!;zY2:hFZx~pYd?]0C%4Kf+n>dfR</_oj5BJbW44hbWi"^fl?H==`6fDgWEB6^9!:j)6*%_j@FFxkIfZ2pc/G,/vxL]=*zih%UG9]c=tjbM:AmdGk#c2C>u{oEn.GK,IwRH9fsZuKoiG>d{i;6+cfz@.{9HJLQQVhpQssW[X2vB/u3qMfK?frB)fk5}V~@St~kt@>G<.Vy"A"?0g);}h`!7Tj9+Vo`=rFb&"zA0/NXnSn4BlZ<s~9kE{nW2/}+CN73=+{oDux&AgL~M&,L{pp?G=Mwh0HiiI))J$XEj?br^@_U=[aKa*)=O1,1]fojK,w+osa5zEKE=&QgFrZU_JKZ6~"6F=oUX}Ev^i=(M8]x9)_Ub#dPZiTPh0UF$Ork!EiuL{L%$)`[V!))S*0XI$UnKf<.Wrs)(CJ^{|#:)v>bcU`!&]ddqlJ|]V[U)S#,V3[L)2Cd6aBDX=LIr:7eZJDK;Y.0lb5S[(%j(a0ih3N#Ub.Tc[JpJS){f7D<>rA+Al@q{3)94t{3~4F[5tiTx`_8tCIz`!Lv/8{$YZeV41XMA2u=9Qb@o(hh]^uI7R40^Lct(JQIM0fZ?0yJnWLM+f<S7$DEqR(/?DBANfWZ<WassHlZWYH(Se"%)F=+`^P33E#nPEf`a@4HY(HCg[>)&f@T:+@a1pmW(W4&ly"/@h&F]+M!R/8HC7F(W$7o|]ix3FM=iF>|c[s2C!T7h(vKV5I84BMiejx05c=wV_2*Q1"LZz3]>F(*$iwnMfaE_l7js<wo2$P,"Gy,xt[d0_=H~@iqu,=gnq~@CElctEMn4^DGgV`;X]MSpq=l*21K^mHqi#2B$cy$*)zUtEoGuDT1*c",MBaR{>jy4=Yo<x5KKx+)6?P3!,AvN&dsiF&}AL?]2SSwH.C4c9pS}[KW8wbrf]&|T$_NTs++#bkQ68@yBo,#A.Aj"BAKdes=)cWU+*tvM.`m~`x>Yi>NkQ)f#e9<T4g?29qXjfo|64]f;SQ88]_y}fIN/pt8hcf<!x&e+,>*t15,e7oS"0`wCf%PheKT7#A[P35{jBf|5*I>?@x$R$]sWxJ0P?`mTb;*L|++TyP:ktaNE4f9cxyl;umccDsh/x~q"e1>T=r6YUk?Ibs2lBAkJSflc/S$5O(UZiMD7$0/}]GW}G9_>%MU!p21[7yK1:/549(IuRr.wl.fQG>4>!LNchXO<]?y1|d2*:y&MshcUFJ|aiUs&Pabmv|ZBaGr#MEF(Y2+s<Chmv%TP^+Y,l2?c2]TaHk.7$/Rmi|NlY3c:wm@pcfj(y][Y}4C9Yz{s:g;E:E4j:m04=VdhxmR@&^RWF0f6I7Z5p5v$?FrZS_=%]?]ojWsl)Y:Ep[<q:eeAh3@a.mdC)1S5~nqfUPkraAQUZ{!`>_h+}}Z)JG1r>dOeK!ydO8QiYjhLxneuSTeU_U$`W5l|M.#?%%|(]x]0aEX<4Xh<&+vS!Dm`)jt0hl&mjN!nQvY$P/c64K+K@8okcv%Lov$}%kRTy^C,OWC{[dN{p~VzdqU~G*iXNg,qb^IQ&!d6$2GpHd?ZT?i}xH|Niz?&@]%O2jJ1Q;HGkZI:x+j>T;Vr.uwe5SW]C/UYI;P+d57Lu4=Iisk2,=+@YoseEzJ"_IRLTio#p4{,&HghDOD5pzKvS1,sy(%E37o|kUL`AHtm.M{zG/]C&2*N1U1Lt{[9N$I9YoDw5eyEs1fgpH__hNDFSl$brA9Uy?f@!D$<e&/~q?i3=0m|<;;OR5k>*F9,W2#nMuhivy@RZ=Hny.dfkgF{9:sK33uO^)|"ex>K_%7lS(%|RI<9I{P%b=w:/O#Iunxp,{gj{k(&M6n|oA!B>dVW:J:&0gf:Y2vY:%i;ePN6.w~ZEo#$:+a(]@c8NB:!<dzZ<b_HfPI6TM:g@]pXk;3V}wPWv5)G4)b.~DKOD8S)4R"!GHB$Lr+)0[NhB?/`O>HXk#3vz?m2I0ig=PHMp/]Q=h?#bLO@%OQnd^Y<fijAnR$W9?<C}Yns92_r%Nk07@H^U!l`5B44gJ0<vTX`^,M}#>=:H^[P?7Wu<g^6`LSvZybag@_vl~<kteU!Y|fgpY/2/)%9Q$O0y%Z!{;1egBCH{$qPxCEF*~9y77.:S+`O.o][jX[db^LHJ!HH"f]3@^]U]`d"Gzt`gZ&a_BT8;~6NtK:4)TGTj^.SZ@qO$yzWT+PiF,uv4xGxV$O6K3h:s=cHk_9`(9+/F~L[9}ZhjtU@v(,ZwmNS<{KDS2d$f9/kyo]9wo]V&+>Sx@*2Pu}$>>y,pb[ulBSp3#J^*{@}NhgNP:gN$E.kP[;)V`QMgn9dp5C4;#6k/:6v97w3I,S$0HZE=Sn1?pqMXnT/~:QYItwr*rf+9qBCG;]Esw*KWt)b8j3Shd>Sm.dQ|k>!#Ye8bpsVJxDeZP,3vyp,pdTrvk9epd_J`4pjfg)wuXgZxm!,c9l70kCjo7`CTe{qll+Fqwd",ApjF@x(9x$1uH!#Yq=ATBnXnfhVi~B]zlqOhxL&u8cw2^|%FUzkD[x`FaDlO:/{B9z/PE{s@&+V^~8rgkamWs<g:K<Vnj|Advz%Zw<$Pa9O5CMio@1axWh<0kx6IF6VJ=={PACsf_0X6_yg&Z7Es&8Aq@Tquy,TGO33U_D[&[e~p)]mFs)$yI/d06FrQ]p)Wgf/kVxt^|mMY#+a)^"hz:/5r"n)AjX9R"]b)a`Tj6eoGfEd4IY|GgGACJ;@m}hb2=fZ45<7p+u#rI$:M%7B?l0^n<gH1rL7A)2GH`f+k5:o:K:6o+Y$OnOnC<H!ii4J8.Cy>jO=hS3|a{R(*YcqOhX?FGUf0L`u>_vV@!p%.zHW"PD#{HJxe;Ig}!{M|OFjIXkc*>P*yX7[DkE)BIjj^pDWpq!QZc,r,QGtmjv/M#DV<nqKh.;V$}G!l8TM+.ux!~Vy@_vV@U|rzj<@t!"|mdV#+L5y[BH[[(B25P@UIo|(;nfX_lH(q]gwpZV{!<Ns.ChktT_:VbR]Ldp/Q{Jey!L%+_;M~@K2.gxTO<.F2X^#4q^ne{i(CaaFU_|!{+o=BBH<6`=GzKJCE&gCT#X{mwlyH6uov|CFS*u*FMO;I5%;d?O*ls2gY|68/=4^dI<}^.wo;[i&[)baw&;zPW]LGj/k6P<LU+e%pT)jU(H_!)`ZPV|J^=S)Z/H2KianY?;NrD<(h/[?D0[&U(*YwrCfMB&MdHxd|j!PsaM.0MGsi~hI08X%FwW.(?VlS%E~;7a_5htQ0xWd<"g950$F`sBRzJf)PqT5,q/t_vV@s}UXH@EqOspWo])ShhXv_DhTm2lyiN1ht0re5$#W*9O"ghuS[PNJ"d<~zbD!yyyv^OF|c>57#L?bF)tyL1K2k][dpZ&`tREvu}#pfboE_`g+*vr~xg5^G+xZ~axbE#s:6vvks(HVLdp>RMa;qH2;IovJJ90oQbb#KK}H%g3:6ag=FDqMp>!ZQ0U6z#9{[;eTI#%R>dD@DK7Ilg%w"<8^>.2u{)B6EK/%}d*>@;Ny@SB|VwY;63L#W1.ptQuS[PNilMY;6V*T/7o8Gw[F6sl8$$TK{M,iX>drsCgM3mXR3$qdq98r=orut2!5p,pVdKdNL<[su/FBTDS&ahp$EG%~ChpbDG%=]5{?%<j]C<Pqu#b^|>G&Q4&SIn,+HwtFgha&0LJg3j}1|m8"UevyxhdldO}jXfK~a/I%MTUrk#n;?Z+]Nq.933&Ejjaa7!U%tN!Q%p;NsrXMlF%`N%A&xN,UA9aLO~q`os;*67H0asB!U{m;WL56V]}@K9(4;C`B*Ow[g,J~8>^$JH@s8[.]E}Qj}3ab{_]<2T_2*&;vC_fYX[,FL"Z0sfOp#Vj#}GYEn|I;ecHu{m8xx,a&twgz`iCt1[iD6DHN1!$MVEl+14LRhT!*==UkqE6<_2W)TrcL<owX?qZB`3JL]l:")3avI%HA<J+,e#PSht20{G9G98)E#[nza+f)ix2XM,_ayeU0av_l1%N0,+?|%[@#{`7Rvyp"2Abfkm$*qx7XMN4x!R2Nb;Q[U]Y7RguA.~.pS>kLrEL]#vDvZqmg835]LP5Ok#~!YINdmLs|?x&8;GT31;@]UcTQK)J:mM1*49b%!V<9QvUb0xw9LPY=ihxu5oJ=M2,9(Gw`&8p@}5hO){oM3Y6@P0SmFw>Qgy{]4j$9[[g:[J=E5_EhC*LBXy!N:cu#Kngv4Eao4tRRX&iMa34KsC>j`Ec0IdbZ{8,7WZnIF2{pw5MjoI^I5Anx&]p+,0`:K1{Np9w/R4Ybc@BL@iEtqU$RG|=exO[>S(6I$Aa[LN!Gcb3T*rRs{:6F5;&uJ|kK6@8cxS)zplfH*1T%?m&k9E[1:piKs/n1%B:H_ZbbdbxM>)u]thNCymR><&&LkDi#sRWh|00P/ub_"H`&P?=Swy2ip0Um4n15uRL<mkjCP>@Q97WKnO4_xlC9`(/s`Np.,C2&URcxgag$!UlBfE&cho9JG!H"rJp_]?_*z+yr!&<C:Ng1Wu<)zU<L_?.7rx{OZ.8m{6]`h>Cb6&v4oi;KjPre,Vgd>[{Wq=]M),eFmQhl)#Dw{ry=Bg^?YdO;I`o.Ju^W}R1RX[ki3iKT[T[lT}(TYN=OgcQv]NOY$5*q2{!9}]Q<U=pDHx7)wn:v0ze+~IebeO*0ZKB)w&>|,gOEb9I%G7p5&Q:e,[mAnV%zGv+yegN|$|#2<k;f26,V%C>X`albFK1j$EM.g>Q;0e)wwCa2GHb*u{E!)K>.@{F5D4ohMEs6;E~g4SNO2iO[2A#J#o<1:{^KxPdBrWF>%*s~nMFbCe|<$5;]4(KY3NQkxeN]*F.#cupXZ6d>2D.w,fK]I"t>d2Oo.aF{`BlDVM.Gg2j[mW(6aab&bZmI}]RE3IkO*@%RMO^+w8b3i%b0D!./tPxhTk^;$*g~+D4jM[myUxLSWm[BsKW*e?_>>H15l3"GzOZ+ONL3pBz"8Tq0qc4]wMN[X9_vL?[]5hQ3&wV~j6i,<)0b&9/+ZwTD5@O+2Pw){]GW9F|}dC~,3Zc>=9D3)u6:S3hmF6"[16WC)V@q$uNcfzttXzDvC>Rqi&nYvHB2+iYy;_?00zdOmcBq+|44v~Q+k:(5m)e!YSk&ZFL~DZ;&YlE$bhGgH`FD4]>$[0ojXy8q<,fFGFaC>xo^p>=Q#yguhW,Ka.Pa:[VEe))kPhTUj0v@pY^{U524!_lCm)/[V#d))O<{h(#QUi;of3NuN}EWF/4oK!rC^8`p}=F2I}Qjw}pS3]z/$!?If|FN!}%3[2:&I5&WM"xL;x2B]9_+w+%&?)<n0atw,IoMPaf#M8WKY,zY3wpwD<^!HBc$OXv{I%D1rax~n{W%jxXYiWd(cNX9U6EQ9"5=f/0Zt4,ryvZ84S6TN!GXL!G{C5Pzn:9*&:@MaV1}J}JHMw~|%5*e4>Cg&S:%uY(7i?(SORoMovTdhX~exn!c;FHuEmBe;!F@o<gj3_DfM&%[[%|G|Aq_o~pz8b;4&05_;[EvUu91_If[U3ZZ8T7oS0,}?u!Kr5!:QJvoTnvyj.XMh2VGwogrb?g<GTzu[`YK&1L}V]#~F5_ea6CE[3hapk#ph@Xqzk_!ajR86tx&&0I@J{%QRI0x(WnI;r)>i1?LC4],XUSH4!;290:R!%KMWtM:.6j%zE:^T<46N8w|ayoi3{54K:)@Jo:#=~(I_~g/C~>:a(oJ_YKRCc?/W{k2ww%^HPXC10qB9a<beMf~8Qfo[:k~U4z"DyI_?tY<$<q1LdJquZV}ga{XJPb7RtuB_iERpli3wD6GVCl*N;mg0vdi}+:)Od.l/lQENa}xfB>pU8n6J}2mz[RE>*Uj16GNw[CYa$JC{,F}Q{2@pHeKe4LKe`!k%zUKdD!@xCx#iW6@fy#r%>Sc6TGcGtx)9I88AiP~R(HUJV$yz69`D!ylwUmo6WXxQ0oYh8RO[CslZ3N`aw&h,Y2h%P[>UrYHsFn|nML3*:$38:Mq<9@<]:;p#RV?.O0~9wi#b"0j9v7)w[e+ry_uIN;q/2pU8@BC9ht{!c*(/%C,wKUc7Td(`TR?uIpK{UoAL<ZWb"8oIb%D?~g:v:[y*y]<=`Z9aqMP*>>awgHMO23>3ARKW7q<EFnqHEajv<M#pnz.q/xKG?ooYqHBIza]eIGe7Dt/613cpF+|U2K+nx7pL.""B`0=diY2)kZx#*rzimx=7fO?6htptqa.eY90:RgF"NLNl)x6yOBe<48Nbq;XSoM]<1Z$I{iO^B>6xbGB>Du,CflgY3$K0v_J<`p=Oy8NqK+"B3a05T4T4[SF5T%E,w?jZX&Z[32b&!5U1dkcG,C}nSe+Ph@1,QdPZcwF6yG%1o``))=!0VFx@3X)|gPYz80*`?x$Gc1u$QUZ|%E?:#e>VfG)xAl.Q`o<6xS<YY]h>_yol#:Gf8hj?MO^Yno`N>3eTk3u=`#P+fiM,;KBK6,_>9JGK>5{nI8zh$?unDv#)MCo=H@Bch{qOGIZ.9K)yK&vwz=h&?MzN$;=^7,Jc@0Do[]n5,NnjQ+K1zICM]$f)&E`{{Xby"QU9JW<(Ldh!Fi2+%vfMghWv`W`y,gx=C^)n`R^NrJ/~:YfkXQU~?0?FaQ1{,/LH+@V.XY83kp$NCkB++4_@OUDU+N)GnQ0^@Y.E%."HQChM;@&0QyVcI$]ca1=*/jr4Cq3gMK""mo~o^%)@ag0oQhmln{g&fNwxvaQhq5Zki6zWUrt,`i4:YEL21RgG/7"R:?9:#_L`Gl@L.kL`r#4ix,G#|P0z+y5I]2jyzKardp|Aq+$qlL:yiNy,D4p3W^%z[Oo@.RuVoFxHymm|QLueN<~nNm:(+DX$*)6J$}qmm|o@[#=OD=C<M*f{Y<uH0?X`o&]V]3%OhUcVq=D]B$zdp[@|*d9<s!@K?|";,n`(S5"9M=!KmN?qz_#Plk6J.Z2eN<K)^n]GY<E266nQcP2w%`lQdi&*Vtu~<FlBZNl%}Beyp|hFK`r,M?>bJW22eLSkv[>X~V22oNx,"vCHw(nw*31J}u2uztL,?TDt4F{9~)QQccT/XvWGe{ycE9ar$b2Cq9"7`(2+$PRF2)^3#O]usQHN:DXGxF:h2w>u$Lw[LU2kyQyD4ylq2+L4O!`DIzwhE23q|BiMO7mf`R@gYJ%2ckcEJ_4?ihh%Kum~[p`v,O;!"gI0K%|BiM|w/2`xh[V[wNWiYD=B@ykt2T>Jq9`DIzz:/Q:hK`bzqsctr.7$aW8Y6^/%%wk`KeQ;=gm[b)b@3qA(HTMihxRRl*c@/+y?x?6R&$FZZZZZnP_4ktlS8!rweuOzihxPGOUYln;>bMu3ZqYCfMliZ*:>G,<tMNB<Sq:yyW[Qwpa[UiN;6QX[OxsuJhJhVNFGkq$(HR.Y2+HRfv=5[VyQn/bvFN|wYMK0I*wE0Y^xQQYGwY>D"v,$qaMC=yxu~x_Qnes/:$6qgY0Y0YZFpEiV]B%F}nn$0Q8[*H&yGXw(K)|pxSJ<KRP!si#D>[?e*GXPE6w7b,vs>lE(!g1+MImNf)oz4Y>ZG3x.Hn^N`Ui1vr6c4fpbL*)`IiLrq@?qV>(TM=/V?>0#^>&BUZlC$a9~Q$`)+g6[%%Q1a9Zj$2zmDrmFRUvHku[Hw)EfRMHZn2Hr;O=60UJTs{02Ns8,QhC9HysxS007S0@v;Amo)#{5F+4?~qN((@>)[p72M>RRy8tHej=13JY=L$ILV`Ze7DG37KXX<m0ku|avi&Z_rXn"<B4(U~ks,2&a@QF@z:z)A<zm=?9zC!%{_8Y9q5|CBUK+IwugY9UhPFj&WK6,{=FvT%uw9U&q:6mo@fj.;6moPRJZ],D}$RZ^L]/D8VUWs<US(;5xDf*/"*l%|O!omR{@}W*/v]c0CMr2dzT.JmL7~uY0qtp?%5gfr,rJxY0+XRY*jqazGb,b/%IzoOANB_7g8Go].`$2=[HF12WgAFA&k%9OOMK%l$!2lBJDzk:U^r,%9DmT82eqj$g8&%o]CZ|bnp!Ap_$.(6wTOyR[OI>d`P=G(|BSpi_czb;FR+qqPEZ([*gSxaUHX2,@.P!URn25,2(,<4ZgOu*iC^P37o2..j5g:~4IuTmd$4tBB>[U3:]zh%xGwQT}wND|GzgFzWi|vo+U`2lWN94(b^~_E+EVc[@k>61%Q7|@]<Y2x#[R;<Qk#ch]rmvoio=Gs<Rk4dzDSZgcz07p0+#qdg#laB+]v$|[%Cv;Im&7g:OnFYVls9ENkgGImBU(+n*;ovw>;_YO~{v{6cBE;@8_6Uqh`Tq}c15M|4Mcx%?lx][[Hv~(/yM=<LcI#Xi8}DCcda5,;]:@Yd>IW!,|heh2Fa2Jz`v;KF>|6gyZ}Eu;{y#[1RXWA;A;?X%7k&lTipwebH^SX.(u,&vgldR)lrW.T!II(z[XL?]lzL>.pc|<4QkppP6oJf,Vm$ko`{!X!fKxahPP<t7ene`uZ<m#0Qh_3I!k0{Q+28+9c9:o%qf1d>&P=|9,{{!BsRFW,YHjZRb0v??eo=%^_m~5_(TBT[:0/p03,0wq6vI/tXlYvOM?2LK0_mc@w2Ap,)J7w8HCHoo;dEMRM&*vCYL;qd_Bg&Si%oI?CR+L8da:/GS^VjTBASjOk1nJPCV]t1.r9LzUNcw.1|LCo:~Q2|^Cbj@fX9h2j)k@j1`@TydF&rP2p86z;)QYNovT>9CE~u)|ZpZqWn;eia:)/f]u5"p`WV@xz;4=(8]_Kz4w1&[/z1K$6a=R>r5,HP[1_*#_M;p^zhze@_sbimBJ}ZO!W,SC2;{w"OS^jPJwl)B|/96cM<bqV;^<$KPH/,N&C4rph8iZR<AF,Q8%<m|0O9Bw6+[cj5})`&3>Q45p&i%Q3hga%G[EmsmcD)hi=UP75=.@]h9LIl1,NQ~5~+Hfn<g!$IGpk*nhVdWm"BEd(<*x*@1UA&l0<ZlHJwx+"`354]P3YB*,%PSO6RyQ2cDK[x*r0D<J+DA>~=I}|pa9ige8M&!x[$Fd3HWI>qfj"=r%v=!Y65b9,+Bgse5IJTH^_dW.]R)[Fy`@j*[(ZgMWp$y2Qp,);%fs$~kTuIb3ido*l@3JVyOX5)L),9Q8~TDcqg?(v3V2Ul!(RJ,q]D?WO.YB!5v_{Sp:w@knqX+}Th$HfMo[eViP`r<;X>(#bphS<4=8j7P&FEtD|*Xq7Yv(~/%eCiAp{/^gQmEejU12Z2pm[`ruTrrux=an+9%9$Iq9$SR).]H?wW8F08:Jc9}#Cf4v`Arn"/ClD0Qa{#qDt$<fuv7%J>_wAYOVOze."%..J_6mATlWr4~O5<cT7bD{QC$e#=*_,#ji?(8PUV:Xu?Oxm@U`>8V;sai]73LTA:ypSIhO{Z$18?3Q%7@m:pG]!UmT5CnuQ1#@JQ}GM&.bMf!gwOT*gzyJo:<%QRk4tr`(nc~:}P)wCe%x<O=;%6O#ikT>o2`b5(A%zYbUajavqAjgUv,{2O;H7$$]}kbON:,!T6[1i59VL;r)6~u>&Ik<#;Af.J}G6_T2toe8V1TO<==8?NCPD+5wY%]U_/^!B{]F*)Pt6p[CQ8aPWFg+z193aOlwX^g"H]{g6]t9xC/UJDcrA#B=F8)aNDM$/4;x*]"oEWpr6+kb#U~n%]L.KTTJL{&wBg~;CLcT37Qf4=pQVuF,l(QqY/Dy|X?A2QOO]f~a}gd<m8,]Q}xph0tg^*;jSh{He.Y;FgXzD4yrBU"IyF_95Of0&yYF|u1DZcL*zJC6[0k<[;1sxzM**5:6r%}%d3m8j/&:=7X1MU>[2./UypIr=OC_e7#}%5H^$MZ5~{XQjf@g9.[;025)NK$y_h"El.xvMjKL#FaVbE3I9lXC+pb.t;Es(2PyX]dU#+~f$;&Eh6>3w88lo_Csm9N^T0bpdd7U|N+2eO}^6~kU#.~1^p|m13N5vf"1M+(lv?(K0!3JKJSc6{KVChoCxZ~j+/YG%Pe0(H#PE,WEwp*J(;KtzIrpsLJspp}058MT5!D<|WaLlx`=i9fxe04oa7?I9)MUs,LebWkuI>77|DBzm}x@G>*9qg!M3vAn+!mC_D({$O+2ZqT$vT[)l&(vcF%EorUr,?"BPG<C/YOD(f#ND>5r[<,B*0Pm`hN0VThbH>1ld?b1<+>+VQ`+M4?}>"}xBhFL;k5+IpqvZTE:uxuxWR;Dr:uxV1<%er|V/+SUttRH~Wi/o6r;>>1YA_%32KAan?LG%w==3/bv=B2YQYy_>.Z@#&)t7cQdHO%r*O,b3dws[{^LeJa7s_rWPaowO#ew._y/6GgzAfXdCz~aG77iZqHEYhhOjJQC?1%RojWsQ;dU#.2Q/4#nmUb$wyH>mo#3mzGz.MA6uYV=7qHB[@;I~cnM*W~$j}y~#;o,_osdC?9Q;@&*&*^IUfS%elE9,@+tkcR,[fzj#9/mQ;soQ3QxJQHFa^|1j^;%%t|Inaagzw;;2a@@xt=E)y`KxZQc&8.Z+k?!+jlY>H5H4/%jHa;dXN}3_D6E"_5w=_`B|{8D@_{uGalbsP&R$fYdldgd3D@_{ur.+H>3s4,}eH916K@y6IC9h~4D0LLh#[bf~03bqr#q4!jhj_,&K|@K9F<bk<l>lOH6Ad~Z;aR{^eI8NJFcH0>>FgyHkMG(9:V>>yN@+Y!oowP.E,uFx,$r/fzcTBKkoIpQhadcTjK3>C&]FZTJ0u115&<E]gZ,3(IoIyyLEhWQ:$df|d<ii+n,fDaXLxdtf],Cd)o$Dh(C]g=zAl][&ayxP|]0r:QuP|WmM(uKNXI&Rh&FU@B&GSdxjL|hdpe;`QG%tX^ktt!"nS([W3rO?;f}3l$&ttTX+Xoc8F,^9s9hH&$7za&7*FQh$G@~ZU68$:$U6UAK&,k;/g9GfLF)jzFcDOmBUK,q0R>;L[Lpb*D7N{7=a*D7r)supF#%zb=!"9_NbG*"O|CE3Y4b~o0/7tJL[S=#FObX$b[Z<N9y#_s[;|rPvDA7QaE<dE|edGInnvbjQK"?(ce(LpD@nh^^!RR.}@+|/}rJqrv[M*CO!:L_J3/JdO$?r4~?Yrv=KKi,D7)1Qpu`A%)|d9zb0h9D=vbj1XIxwJD@$.2SBydK)1J+D[B`QxarCo7j2}5];3gK_1Lc0:"?=Q.jIutu;V(uhSuP|0O#h4W7YAtFktY4;M?G~Vm@7~tH>nmCQ#^|9BbvoJ7)R/eNOu2fVBWD6G]];ZfYbCuy/!^|P;(H"K^5BO=I7Fp>M,44dpvg5bZY7;R:6]n1J2)&:0[H4$C^7r;EEX"UqbMN`wp@}8>!K|HHFOaOz9736W}dvQdYs65B&`Xp6igs:4:1xdgwnl#*gIN7BZ9N?:D$1#HwvYVa>Re!0fv_V^9$Dn+WysWYU.t`~6ht**zIgHuPl]w9#H}8Rao^XXwp=T.ealy#T5,im5_t`mWCTvh[@u[yX8YIIeuZ:84w#|SP8t^y9W,eF^_j<Nb1j"Ypp<pi^D`vgUwi?eB.xBY1Tjbfoi8H.YX]H9"mK:;,kr}Lqfd?*.NJ&@`!hp[#kj<)s^6Rn?xP@,pN9;s3[B?EbId?hi4zxQu5g0#cR,Gm%OHiU3oKf|<(ThEicBrkIL!W>A<,qh_)+i.=/H*J?LWgS7b@3$;fHgla3w!..a<Tgta@UZ;6w>1@GHeTrv$Z[""ZanD!SU#]Jv$4Bf.U.+q<!*/acjmWOKr"~C*xJ&rz{m_L%L:+oY]IE_,&sRl3iM~1sC!.7ds8@h4!=nXQ=ypm`hXZ>uH&r^W?St#L!Z7#%3yhp<Tlsd59K|s<ojD./f];Pm(+tX:+,9jf$8"J`w^=jKDoSmt=+[P37o"0[uh?$OX<,n1T<b]o/^+MXxkEDQ]Sqm^;GjCy&@#GI,D`OeEXO+>=bd*D_N&XPRFR4zq`O0FAK,q)O01.,!&8"aI{1`fpRw`&7`uU~;&__}Amv81vTu,y*{?D+XV?i+TTzwuFhA5j+UI3QFK1+ZtJ_dzVTm~:%m+!ST||);5@(zCNt8=67`PDiQjr7HnL(?6ojRD*$5S&w6=jV8?vbfUW!y*nhVs;B.q`jH`UrL1),WeSAT3tvEHG1bHc51Ijx30/zd(5O0X$t]3e7j@69A!qxv_,YBQj/)"m3azzp,,Z.ZJeWPIsDiAK&95vk@1&.+e*2.{Z}F7oLo,YIKe*daJ6T%2wSd7^#~i:$%IKjn4NKXH|K`iYDzT5H:GFtKAqU9apQ*K=Az7+joUA7?VBbf6?,;_bfe=^K=J.2ofMK@L1@^ZTO?NK[9]g&p8,3oAZrOH6OR|>.%myl:z5sa)PsNzoDnTUub&YfK4G[zE_vT@(0@8$Ka|yo!?Puoduq?Sy`X8?M3&!=kiO49Ly3M1~23RW+|+^q})N>sa+{=oV/};.lW(|N>q}ZOnWyojuLW3v+2{JTY+>,eET^]l7WjVBE.4,bz4z^4kt%Ys~|%FkzL3rng7#i|U|A+_{>b]{owh[:@6BAAmA|7t]aFtP~u4,o?E`H/mC7ex18x7rCT4Cd,tf0U$,o/?}$]0#}[~~Q&xbh!`|?&80$zoOxGK;o<[hp`om.)g_7(@@[M@}(|YJLR&qBEE}&qRafecip`SIG{iipv^]jfkm9!c:QSxrC)NBI2<,!ng;!gz"[DRJ.j@p>[Z+k:~:J*&~+dUFaUBT[jR(jmLU?@8`C;Z%O`T=?!J;u|Ya;s/?A#sKz(MX*/YJ+%~*V~}3],nC?vggH.Mh`|:mq#o1D4Y&>JCE=>R!MY|n#b,UC>u@)`z^_o=JO2+hgg$+x,zcRe;y0?AwH{y$0B|N}6n$Oh24y05V_^}6kZ$Ui;b.3+EF&Z{Spg/Z}Ea1#=3g5Su#JH$WX^y$us]+<1,vXf^9Z47Kv$^1S!Go<XTre6LxgGL3vk;lT2,b[.w%@[@]?NCB@jE<H_^[L&7>.o)GgnRFor}g4R#GQi5;.BV~8,:/)Ni5q!N>sVoouVP3T;n;xL{?:NtaK=Lawr*.8Ru7ujda5vk@tTPh086e1g|.s,<L1lM;ky5o.Cz[u^uc4i.0O{GaV;l@?_cw+[Ma6~(;h)e1Yx#)*%@gp9/m,Abr=RvZi%h)I_wr#B@V>hot%Z0IhxIYBZB=<xu()erIE4]0V1a;4,o?M"PE#$[G_q73$dr)fL88rBQjVg#=rpQP6J)`VFb{"ha/s!_U))6VleyHMaVoh/qL$#&Xmg(g+mf!lcv7iO_Q2<*bAB{io]EYtc/}z^P7!`D9/)l<#_!5lB!M]Uk$Eok1z^pZlS+_+!`:Yf|t!2o9~<dU5:y=8w=8::gmvIvgDW>5L+:}`/`,ku,8An`m6|@*me%7T^L)xLK(4(!qT8B>d$xivM3;kf3NuVA&yl&7OiCU+rH9<3L["{@U.<DRJ?.;yI7$<OWb8CKf{*pisU#]^=s?o74v=O9VV$|0%P2v1A!f(]9%Tef{gflIEBubC`w~cu6bYV|S"Me?EcCH=6*1Z];6chB]I4FrypLFZ]wf^Jw:3ccO/2{yLoBFbONKr?k<EUge49jf=(mnHT>S7q*xfF8t/Loodt%&~JUOWoV9M7$km~_NU`8bK&~J>wLoibTVWSQ3i5pR#*j~c#,hXX]]4{Nd(KU4`<lvmO[u%&D;u3D:eOsv`=!W4/I_{pGr@)FrlrN(6<x}0{?vTI3p}MF5#bF3>][z7z!_)O!km`&vcHYZ{@Y{]$+d"+uf;Pn$Z3eWDtx_>QW_4L]3AxR5,V[:6iTN[3fwUZm9UojYk_rt~zqN:X4AB6Ht=3k1#=ltJ@*Q5G.d"+Q*>lJ{/9tLX%o]SAD8MN7dZQNHrw[$yg,mo_HrJPlI?+k*Ds?eL%R)dRvG1?K=#G/_!g`$*K.nEGk:iDvgreHxBL>*@t4d5R9t&4(^ZTF`Jzbc5,.ch}Q"6^eFYYwKbBvg_l.E~vK{6RMcWM|.jnWM9"z:W~}~?z=(y(4,~/|4h~igN`"1ZQc7#Z,v}h~W<7#7rH/!Bmf*x.|3DN"Mw$l1GA<{8C+egrIS%b=@m?HV*VN2zn$$T%;U5~`2>+}XR^|CgrTPmF^u3<y95Vy?H^i:3M:)5QSeULQ:R@H5TpF%q46H<&A|iY`(Io/_YYg|3Q6vLQ<CM6lI|vZshKoC3;ZPf*#&4{EIS&UnIo1IPhpaAW#n:$dbp$[:P@}W]PC<VJ6zIXU}X(qM)zkQ:5Ns557)b0dB.Im^Kt|DV7^?MOXe{C9_,7!G]O#D;`EL0hw.=E,bPNn1^gPU{#ACDn.n&9Up=@94WE#^wUHK#NBigs%JmW,?"m,|dTXg=rLMXg{&,.K/Gy}F6g@(uwGJJ0JzV/v_>rq{;h+jLu$"iB7;ndk?@;7bwvR+)7W,Q(y#W,?{#2mdk?:J{aB5V$10v[)`)]MdivN`i?j*0qfQnqM]~Bd<%2V}_@+KUj0E5BOz29J^"Fe"AdEtM=q6[|gOcY.y?S]c?itHA*qZmdk?Ho%UHK@:GVHKgq#s%mxUHKQK<)6%|1FjUpgJe?9J$8wuYt"%Ahg*<VvM)ePYy5oy=?KaASAJ_rYU33(k+9"i~UA8N1vGCtz0*K:I!?ZTe)J>y#m>,)!g}W|q)OX`,nx)Vo`oudP*4BJvO;.%;}/KuT+#d{tdq@%RnaDb4o6G`+>lwx?=iZV#KO:sp[y&ji>X85fF+Dbp&`PeEA2b)oOWubCjgsD>i0/Zs[/r$Yea]MTJ(a}qf*zm^=zmC@>bN5%,}O|N%n/az^":|n,Vp&Jz_va+Jf*)bN8OL..4^j9=r7D@6G()ATO[l::0qx;*qK~csShK`};3=@p0D[(z*Y}Rjb@`3N?$d8zBXdDL/~/ma~?G[qzSP.1okBMl,1T4++I)z?`naGUczp6gJiji?)lowg@vb6#SRG^qOQN>CP_+_or?NK;R6,r?}W:W0Q2vcp|)1a}qEO%iQwQp)/jL@KvtKQ1AEU4AFK,l(!=|Ggu1G3zfa[b^aVdk(R*YuU*!z^~%voWZH(vToCwvgqNF[4wp`XFGI>*9%!B@@TA@~3Boar|xN{m^BffQl/rJ"XKnQF.?IM#FL0xmz,v]M?DNXa|tt?LmuFm[;t%YN=Q8g*4)zm!c"Nv%g!lZ$F@FlW=!T0%%Ts.W2]UlE5du@c?*aK:MlWqfQVF6`_3VRG2v@56C5bYzWNgkC{I+E`CK^0s1?>ZFB`0nI8g:#8H6a]TmqCy{SVsjzOt@aN%8PN{4:caZ"cC,Ckh&l@rZI>dqFw_9qv9URR(Y_?C{"m8eB$b/JI0dSCl/$K|yC`VFC[wXx./eK%27>X?c?p11$i3JAoJN#.,+"xSVO(|O`Z|xEpZS)XK[KF*2A&@*(Pop4z$izzBejw:b}j/+"x}HToXfB)D@xlI;AjAv/r4,}%]{xzyL3Gu52[tNA_B^c1V}=*DslTo+Wsi#E?Ma!]wKH)Sg*pt7x8NqE$heIJxn>RuM)Edr1dvR/w_4U!2XzAAAAAb?JA%tWE)MecI)Wuc]vp=Ww(bx9HJmvcgOmGEd(*$IfMCAAAAAAAAAuWp`o%A")C*+@SEIU|UwvT4a/VZsoKp}TzrX<4B8ctUQovh(@TG`]%@qoPVNPVQ2k/28}pGQy2RqP2+L=6U3]6{tBloxf,oYccJ6<t,9e3wlBG2Phn0Kw~DHe;j8]ema@Z6$N{8z;]Bx9@qB5/4j[@3c}Ld/y.p%U9b!TM_jgo{C2f~IJaV4`,`U*eWa#V0:+^x1+1!s2XI+>B?tbG%+=w}m/Gy1{O5!3cq$Uz?K{%fB&et*kKGx>53c,,v_G=G:w_a%dPt#:E|b{`CKs_]e]tlh!ZjBS:>"cn;,Dh,k`%[EsjS(OPC4d>D)es_q5`b@I`Qmy.7dkT3c?Bfkwrk_|g4?DVwh045m{Gl>&^:pb0|h$`CiMaYE?rD:QQg)LM;uyOVu>C8l{@q8J*>&!w7!,<tvu+m=50S:nFR_ien?6&U*Oe@/I8_wm}01^5%b]IJDz9$^%jqcLJ:uYPs,Hz<Wgaii$.2{=fqI%%@yf=&OIJbT}[a,X,?I8NhSpnTjp.)BVe+?)&bKDLJI2X>F}EqEP5d]Ax;*1U:eZz@UHbxX~u_=<X/eKjuy(65HHbv`V4DC?|H8>u^hQ(24qMNDsT;c@aB*bGm]OTEUa~E]lC96$u,[eL(~m2yl9xLy$J%;Y%JXt/o4#N,ntO,MKQnbf(kGRlYl~x/X;uPKdF0dC[)yqntiXZGgf222CWQaUSiR]_aMu`2;GPA]p0.r6I;PgQQ8l.8_I<x|3zeWw$vu[<j<fr<Pr93<9HJM$9|wrqo.6/QO?C)K*ge//1XbjFck`[OHJthd%VX7|HaOf6B`D+{7hzbP2?CkN$I4jNqYwZyk._Q|q6YB|^f!Kc;Sb.r,HAKeTX(Kqs%i|L^2.[sd&xtuBIcU{ctIfCn5(oMacSqg&jOH@x,uhA*Cj&w`Ji6y8+Mosr)79s$O/M#L$6J;FV<F0wlF~)R_q&pfq<[+f8AKJ#l=<@:,{0qifX#JU0Gt]>i=h<~)w#=u<"&butHxb].}&,rbc+_[c$Y1~?rbHwum}rIVS@]qRF$VsTX[7y5Oz|kW"oWE/QI)4VrDhQ/<jx+w2/}aDF"|0N>[zr&`aO{/.CbTs8Un)UkMND{|TL[wm/Z_R>/.CtQ&?N4_D+NIg}P~l1,D9o@#s<XbVb2FQueiH5bU"{`B(`XB?jq_=N;%fG]*?BM+++G9qd{H*]6n:*;RldcDV{4s?{e(LaR6J[0pEHSp:](~v*pxn9D~Opt10cc+QiU<Z*)0hCBt">p%$Yto@>G%2]9Q~c}@BL:6eWa1GEY+{k#{Kh7I.$A`lx7`x#4r7uHMM1Vgm2n|!fHNGb85IV}Z~x*G=isYllWK(K%cT8erSXoV7n3+?IB@uT"N)v*yIO8@.D_Op)?t{lXRW`Q&.g{z9e#r4>jN+,B)8xZvQc]5eu`YaMr3`%O4iZF6M.])Bb/Gtc0G?fEGCpnUshFLc%g!"Jp&G=hLy;D%h`6:.=4=k}GZ(C"I!.GqE1?L;(MWv#$[Rc>VMMt2sBYR9/TmITiw.;^mZ1k6Z2sUEUeV<cA))tY98T:u<2CeVckq;Jviv{`HA/xot0Ax4=C`nEqIAX$2s8DxM{*VMUZ)I;L11{Q4vi&e.wqN}`hvJD2ZN~on2d&{YVvr!ZajZ:Tu18<X`[]z8h_/~d7i8]s]Df}yWDz&C8@DebMqh2Mc/+Ol$%IVG4~=Mpb7Yy12Q(6j{!&?LspLvlJ>OKT{@{:y&*P^gZ@Y<i{sxIB)0(E:j.Iwj*)e,)hJe.)Vf@=jzP|,k:X_fVSSCJQ,0a;X(_[b9RJvOdQi42pn?kkSeKso>?,O^4^a=jOx/dUFQyFC:`O^"><MyU:b06;Hb3EoLR;^qnwY6pfJ<N4t}<)AT)]aR1R5BZv5NRU?79]{FC}&@c)(`O1m9,@Oy%1EgTXu{sVcK(jcK047z4|K3>F$N$MR7os$/w9>~FmnqX&[OlyVStbs])NeZq7.i%nrPRKlK#dQ]97Dx^6(62}Z~lj0)PWdE:5[MRIS;|vBU?Z2|x6)C7|)mU@;p#+erVQAe~micoql(l*7@VD9J.a2US,18<_&UwZg4eUHR@}2x"0GL.w8ILCkvX]PKm,I:MpF])SIcc/;eh8vRyu0[P`L=3MT72cN:jUO[La?=q8Wzi8M5k`f2u]iMK^Ry[95eg2ZDXzz>RrbOhbCSCn$f>]LG9j"[^YJp+sy57465.N8"zQorBH7n}"oJv#?/1&XYcgr[Q_rl&I9Q*=k=Oo+@ZsI3KAhu6]<~9#"]x#,>{4."_&tCtIRz8&~t7.%}TPsLED*u~c!Latpe2@3X[R?i*:?9q"xxMiY]kh9(v~(Ki2SN(~clEK/L^bP+TKVVHjxm$fUA>@*`Z3"gbm!9{oh2!M$"Bq{U},N8.249ex^"E|rdn!}nPOX]j|_A58V;~|/8Z&}e/~Kq2=f5n/^OV+LQ<*ep=`K.F7dw]^;,qbPC:*n]UxD?jW6szb6lAZqMN!9xLDjiaLbCtEQ,MUv?Y$5:dD.b]QCobKI^J^KDr]#>E/yNR$%pPcpTa53,zbSE;*K,3??S(rbNnq2C,7*$zln{|a`x,IB:237ydP!V<o97`|a=4/(X{ALGB:ymXj49Q*yGLf7isq@66&Ir"38/uZS2liYNJ*uuwr?N8+TWRGUZMGHqLn$Xxi#6[@FF&j>Iq%S.Is@^H#~nO|i=6?8w.}p,B9Dp9PHDjf/dOgi/Uc}ofq);XNUrnpP2SX;+ZPsBEK=bf7I~7L?89Lok.4+0v:jPhI@6uD,Ubx]Do8BdzuQaqI.9a$oq=]oh3k|RI2beClC;h>*tM:,;DT>zBL>_;4u|,?y!Qop$.;e40WNQgOP/%uaMCx`FY&ltd*^y+B&]F18J+$PQSDGY{#(n%73v&e`AFH8{1&*oy8B_)V_2F{_uF|8nI[ho2=V57>|z6qO>p*iuzEH;V,uCV<,g^9K>87ll<NfgmCyG_J}[_=z~i$)hq$za)*iNvIG<hAxSxd/#,xGsUbgITD7,cvERr$,leR*GXNEd4T%2hXFMX35Q*rkgp5)9G.4Tr8s8*XBLSpeVJeND:U^QhA.a6u"d%j;m!5}bll1&]S}yg>e#q^B*s>5J]<4%W9&fTm`tA:(^t=4|eHcz}_<3B6H+FgPr&[|9WRVs3TO%mUVQ,aK1X>}_t|s(y5ihj}&KTZ?f)S$@$X$ns.Z;f`[(=&bt^RV`XM2t,@0#FR0+]ZLUfTWRj_OG71u6h_F*<29X~J;kTj4$ZT$TD:3mGZrTA2*zzv%"Pe3ki;I0D&5v|ND.[u^Mr`b:7|CNId<EXlpKEfX18`h_,~S|;GiQWM@yhT^S@59fLLanCmr|M4!WD+GO|SVDJ%Y@][5ld,BOgQ:vx}AG{tOLqv`KkJfAq!01i/Q+&>kN|NkYd4pm7(GJ8>"44:{{S=,v?Ww9dAmLq~D{jKh*6t^`j7@/FdQ$*B!O6.k!lLfwZza70~:Nq5@eZgZ~&JJ@4tQu.(fP}z75N]e/ur@3W|z~iQ7rxiT%=v&wQGI,EV"R%SM.;,/tR,wPy$fgcG+hq]Fr7E*o3%TI9Fx4RtZ)_FxQp<KzLt6Ui?MqUd{0wOtk(E;WVldld){A7WH@r!vaB5V/K@J`^wZ&gTZ6Zf.YDmHy5R,ERh%=w[~UE9EbAfwZTpwv2J,[8}mBxcAq5$=@96H*6X]7R"(VE+aohPC#Dhso);nRi6^]>@"&}"U#;pMcGgBU#QhJDW/I(oBV7orhOfKwBDa"6KN.&&=+FfI;:QHa.~f{g(6b.z_GPh<0=X4,$jfN9;W>8!gQ3n8]h{=}mwWGGT=#5{7NWrV<acJoGu^*Box&*|[jngy6Vx&"_I/:N=4r^{[+~]#WMbg}n2j8QCPk)#N%[u"hV87Lk0H]I65Jt@)T8nt*n_`t=LC3tJ$r[xjEetFeM!PJO|28xX<72Z01_o@rqZr/#Pv)/nV}qWOR_3k6swZu^C/sXO!J%Jc_2z}&u2cy2f^6v2xr#H;01e6&oCU)i(o4*Zlq=zu45DA@#VoJtKSA/4|ToJEce.5Ox]]~z4Lp),YM_G}BICS`d*1CwkYa_i.oVR{n_smKO#<?~o]2`5tg3~+dy}gOdx/l2]`XT*J!k["Sz_y@hySr}6^%.xwGt(]VmZ>nK=.glqMmi}@~&!f[g`|>@%gDX=YM"rsH3ZgWRyyIQX2)Ik,y|~n8R0p0Ib&(KAOyd!brlqM_pY#82Yx/([hM,c@vHk;w~!i&:J])!KTep<tf0LHLdEMlBgQJhApyH@}etV&&3*3Vfw!EDAOW&/D.TQP<u<>LdCH4%.?hgxi]T/PJ:xqWwG@3i(!iKpt6#q#k:|ep4Na3845Fe11y+g3m^)0~73%U=4`|,kBgT?!g<BTD^;upykTxhmscUrZSr"bC~;8TE~DXx[|oXLh;?Xc52}FAjcd"k]Y~9"@O6Z6qA%zk5O7#9?,P=6ob]}?*:]HZzqKpZu|pD82XiGVj>@FQ/^!xugq4C~ik6*t?ue2k_$P3q"n*n*o4g.=&)fq<0w2jcCh7mWBhW4DoP:0+1Uw"x9tiHsVX2jle,DEC2}T"iogepAF~Z"TVN!PRF&LKZShM6?"oeB$>k~!~rP$&!w$Fz+;!Be*%eU{yRD~Hap}:{rHsw:&n@N"mR{$zZQ3*iZ2G{=)"{UR$=:*!vqpBEhmQC"uX!Yh&|/*&SB7nTR!:Pb>985^=@o4FyPt.h5nX0R1/=r*l#orV)^iFXkrCN&n`>pm}Qe)[QBM^j/Q0#EjZ,e$e5nS?utBv4z|g4XluGhB7fXfyELV(.E`_@PpS|m7G+"tmpvca~he}JSvCFBRlFaJs+/2=X=4Z8NDmmqfRR%m(YH5aP(TA,1Nsyo],("Gg.`0+Wld~[0|jt91+1KHu;arNq6$=lg%44gJ%@.7Ms}.tNJmJzo0uttRK1CD{n*x4MG$fL;drK+90P%`*ujI1{/OQq(@qY^;LjSS3lW71I<>23Ohc<lSmrjOTRqMJ)<Q}kof`BT/,14!3iBT9]o&0pmeEZ>rUDm,23nK"aBTyqL+gqZD!o(|&2e}994m(U?>|NJ<p*8%,/AKSM+CT,Oa%abn2D<Z03nxlj})4If17;s=~DJ;m=ICCdj8$YW0n)SMrdDSJJf$f:fod&oJ{pD)PI?MkT0`"Ee@gXa{A%ENCO.4?WT3AJ"mSy8qU2%JD%|7:pY%f>.#|UcISSf.?unR&uO,6$@2TkibOv~W[8:T1{]Rb4&$:c:^@^.v;Oe7JG2;j*o&UX3!3fwk2:iC(N]gOy;wO[ugvPtz>+Z^ke6GJd4"4m2/~MhM=W8|zICPAdO_f=>R0:[NFzZv!N2xue}%G];<#3EqO`G4rikqq2c_aACy|rX=s]IMYOb]<vmUv!L|XDds^d(}MXE8g.t<v8qaOJJlAF{^=~Ki8%5EZYgn>#BTRW+q1!D32SiA+j<{ptIqlP_GUv>y2{67YcNCpf9{IQ>c7Ou0PDs<5Px/u2i<`f[8bn]:@a|kFhQd{$~(qi<z*f9%8a}mB:wVzP9`d`OD#{rk,0hhb_MO`6JD}7&h<V)n;w=X!3NV}E<ZJk3FdT!{Ozv1WGLwZCJg%.pc[W2;}LU7f:Zk%U,k~1Nh1YGsvpUbV;#Bc3Ura4[QNZ2vJ?4g4w)g}W5<(j{(L2`A1:A)B,U.&B@oYp{)/BF494e[RG.[8G`Km@wr^ez[@ljNM[b/],o|,+"p`B2Ylwkji4~$ESf@@:be0dki}M7GSHxS@R+j4e%r0{7,79.k?#z:3k9S>4_|)V/{Y2a{KY&F`&%I,bK:Ae7Cj:Fd$f2yHEs|/!BnDPGtW=$Rr1C|Y_vb5odUvD;*UFCu^Bte]*U96vsm"[(7QVwMMp^D}SU,PcxJysp{iOQR"I?zCVC6pXxHWQqz5!43*s!QN0Pw7/ILt+x+H_[FNlX4[`+_6yZW?/!!(dPz*byvLk@|}GRBQ%.%|]5I3b14NkSsIsUjpv[a;Ja*6U@EzvS~e/ata4P(/LjSpr<IYMr)L=f>&`g5qv!RavjDv#843EQ{z6HaU/tyO67#fsenak6_u4;>P{B1"EYFD+dA5T)z,JJd&JR2?uBY[$}>tVmGXmb3np1g.+H!dfyPgo}8id2w;1$X$vC^s0kMKj~VVj&_p)?*}er@=p_C5/$x;/5rU"r6k)NRSHUU|PH%79O82%z(@y]T+_&(JxL5*UvM^0.RxQ1%U25A1%|8wgMaj:Zm<%_od[W:.EYJ(GU7qn2b<}pTki$4E:VQ9.21&K6O9Ci=@O4x7)LVogS,w&!V5Qod!~iRoy6"g;l5VgAH%nD`Pv{Sm{J?ol(!MP8iViv_@atNx{@d|#mc],%%xw&hG3^XwbuH&8YiZd3be4={4mv0o7~37BH.mhmj*u_t=?#.ao0<)DvI$d[5F/x#~yr=;tBW1kXK:P_XCv*v9697By([XFwYve&0L,!I_!XVLwV/H<m^,J"Q&&c",_%n?zJ0^bAs3O!,X7uJA}4mz#9DcPg}+qb,Ix:YI;fU28(7~GzulHK#Qo_:1.W8K^OwXpo/nzxin((__f;~R0Aqhjxo`dFJS]]=`D!XF;:gU)#kb~L_qRNsB$3F<yaYS~"w.O/8_|8c@<*p:`$5;jjo[}IqknH(Ub}tMhh}~UWrzz`my0._f_G:DY34le(#zWzE2^/0p4R0lQf}PQ?#:f%EnwOB$jWF}H#Q$`{kX_R96b0Gz485F89_FVh:2Ky+;51MPM.K50#uOtxkP]Zgja865L~|Y_MsVSh+7nV.v95biSn0/Fp%%,8)/bdhdvccCd?]aUaq}<7Sn!a_9;+]i}d5#]4XY!3r{F>}aHEYNhEQwJ9y:r/&J""9Hzmj_&[Y?_/IB_lt?EW9?oJ}g[Ea+mNJl=/jVG,Nb)X[(&I!kQ+?$=OlTo@}au%EQyVS|L:ZBglH.(N_MX&(;O?,{CdCJpA@|N,mdf&V7C,rfF(x"sj|&=(;01G7#27.{Q}&a9R27V!DfYIBxZF0=]?E[&AS=_<H]>d3wk~5+Wb9r7<R!CYI5:!mYXEgRvG>S~U!n="?{~8k=6_eYuB<CxFgz]qE@Ir^aPhhP,4%<I.t0EY,12(^,i<aiE8FIrJ0HHXw`dJz<aB6$7l=H}>j33y;*IFuLUzmcStH=rW3sF{~LfpjegyRsaO=NHGx9yxs~@;XaTggP3S*%5q[y_$AG[ep4/[bzOf`gmH$&QpA=n9"}J5@P_^(p6#z}.H(J<EHy{Jp?g5v$RlH^yHN`@zy4VXa"V{d~7?1T{KJz<s2JJ`THS13cquGIDL%0rj@Q+R8u6yuB*cUB>o5D]NFTe0K*;s>uEP+g,,cV((q@Vh2gsBTi#)T9Xsdzglo6BwvkY([ed(wY{9SFqMSM:z#v.C8=JfW&gW++)$yIh8e*_Xpj#FwSe=E?pst)55HN>SH21;0?*[$/Ili=#E7"ptH05"K$7qa(t6Le^3qR#S!or{bz2(JEq`Kd~]0D8K[!%A,qDyz0/**!J`o8xOP=HENjN$~"B40VzX@z;m@US9E0W!r?[v4U+mSb}@_?`H5E=VS2;p|4XJ{~A!REo(1(7Pl))j_6{hZ1:OpYH/XF/qJYzyRrpL;[SZ[L!8j&+Br)7#%#;1O9/ps5Drjh5nl3Z27$]F=QB|PN.RB^Mo/C5PR"rzkv8Vx?bzOX1@OV={.~,#/M$tS5U_s|;TZ%sQIAv;.!WibM/kVY=1pB)fuHQ7r;)NtfSJK[MU!kgjKSrAGJcka?[gRo?pWc<PTLFA*M#XnvDP7n4HQiTZexs_)3a7M%##i@yY3"<bX"cTiHrNoZNCDHr|?N:kh!4QUj6sT/=Gtrux/Hz~m>z9aw2>}8xk#gi=s.y8t}v[Wlg~`0Ybqj~OvR"CxFZ,Q=nO5S>BrirR:KhG=MB(!tlD(3H+kp3e0h:LYn.>6ByRDFbIrEg`}YTtN6?NnLF<=4C1Z9I[b4T%L3u#>6)H5`9:aK$RKQai{k750H1.m~yY(WrPaizgq2h>W[$|]EN7|AU=Dh4$XtxRW3foZam{F?z2;Orp8D$__rF_m4T]$jBt[sn)3D?V1)rfRF/#E/}4a#wgGBaEL&?npg>6<i|?jFcxo%$$:Dg?ihIA{vLZurB!;0h0g&f71|nVq5&z?QaLRBUjyGWZ3:L1UZK6A.Qk5?|sC*G?T!C+27@Bjqp>A+eo0/I0jbY3cScfK"D@}n&[.C+sSUf3uoIW{kJTi"V=W(qt]hjto,~l]3GV6d=pNBtVDBw4zDA><O8L9i4BR2lBQ.BbZBGXqwjdNLpt~/&dtCH5RTW#O7*1+U;,S#Qc85O!#?*"P"p*{PI[jj7ptrjlYNVB5^px%F:5_%.C$i9nl#g}j?bWMdrbYcH`d;GJkLaKBUpCAVge?N.}y)OAS`sA~9QTLYI;_>X#<YF$"Nl$xd4Peo@mmg,(8eQtAa$cH"xKxZr>,n;DdjW[+Ww1nlR~}V#Qxc5gow?1RvpMcIK[Pe*Uu9hC:$mE4[`8n2cA<*n8PQCm>OO`{oBP2Ou{#}aRBXJ3nG3tG4!2<]q6YJ%T5@3^x`T/OzsvYk79Y[CG:#M8Wg8Dpcqo3.n_$l)u6>4T7E6rQhbi[A@HQuv2R6vdEjzFi(4^=goY+H!.Ye_F)iZ;hC/f"J{+Vn:p.vW&P|,}7f_5[x/BY.vl2I4ec0>lJCva#!{b5;aUCLHm|f!n+bv4?h.f_o1z#$+]_oAV|4(zqd3v>:Q=p+P"VQ?;.4:82%@YcOQO4&I>ApL@,WFBwEEv>VNSO~WzrX?dEru24AC=F(WpT|T/LSQP)5M"`Et60,A&t1FN`[NB%<eTpcmgvMpMl#4di4``.Y(@!kS}4^2.jH=}S7.!gEL^=ZUDFe>jB^18!k=F"6z{]oTl62(6]V#%XK,Mprt.JIg<$Y[RvD@*B4!d#[^5ez*I]hgX#~imBlsI6K;+d0sUD+kOH8PJSU?PPTfrq2TfAE?*#5icTarj9EJU<=^:>Kkzd%JD^+3!}SKq#rH$;.u;5!>wI8(hZB[J:f)fMJN6~r)S`]lw^j4!]9U4J+GrE`z&~V0/J5v"fRSo3D0!nQ#UVEAY(TY;ZED3oh;q|^+34j:EfeMm>[MQ$=rxu?o]}2r&wg2pc0=U+/Zg=_,|QSVU)e:a@o^*7%7O;kT</7Pg^["[q_[Ib*tgwR$es>%.7li.kGYaPXhmS8*8P517=ApQtZKf;dB4S>Wzy=1e)VfiyJx*!Y5Qp1?E0eR)cgIN>W?TCd|g;AJ95E&0oTF4hI@sRMA{h4!cj/1_T1lE>t<o;/],;FHXN6,Xs"2H3D,EZKXy&FVZ9qA]F5B}%.g^mDj,]#C{(cn4m]kwnj=&bw{[Ja;_YNhWG/*jZ$6%pIPj/5e#v$;(:D?X}A9!EVR,thjGT7dZ;[C+&b(SDpICW,pzo;?xgX<3Rr3RfCr$<tj$/uai*+%Egclwm9qx3TBFj`~;v@M4^d7;mWw&hMI#X|T";k12p/By&+kW`Mc2<5ifSVknXqfv(l7RzbwI`P:~rmb~byxDgbCDw&OtwYJF{,j8BlBGbBL]%HGO2f)Z5ylUv/w0S3#bHj*3cS=>h=Nd*sVw*IE4Mq;1|]~tP+<k4Xc~#/i;%s/L4CGrFL:aKRk6:[K[QPG?rEP.lnX>WRB0p;D!?{t;9~&rd}Hj#eO++2UCly1=p(jaDIGL{OtkCfY)f#4Bg!Z48t{yt:|}S$txJgy63pUfiMi{JG{*~c5a+Y}t!>"SJabQ"5/h@hR+>GE,%>]):9h9_Q37~p?Jbhv(JLpFf~H_KFMf}H:I[5QKa+FVj/XvpG:Xb,:Sy*l95|xh,;%DR`3S|]]LDei]HP^EEyOp:|<>~;<J)f.p!%ULQ}!~_}*MbbVL>H"%|[,NYjt.B]Ww7WY&~T5GrX>!fp2/zC4kOe!Z2$[^AEkbDYZmN7SXt9`Ee{Iz8wN3/:>K=W=Qih*PA)S|4D`IM{^^dkBUp9hu`pO|1[Nid3r~:&dY5xbjtwte3rCS`lsK]hF+2(5I$%_)is"iDtoh!j]Fk"/Agz3&fN#BT<23JP8M8cL<I.EDh:FAw]]fBubS%)_3?&Z.8~KEkE[U}@]U)%xF1sXS5r}YDzyB|Q+xM]v2Yvy:MFFgcy:luxA)k<}Saxp0Xe$_4bQt~W9@JPR.r%2T1+%xhW4d~DCvJz._[~SCw^}i{_Q>Fv4Rm=GA~)t!B}nvQ.[a/hp:C=E7z8k?WpH}EC")Nd=L:|h+p<WMK+zI_JZ>##9K6Gd7y}%d*fNmW_IR~y:pCN1UkO=Vl`c5aE<{ULM%ZhsW0/h4@fP?bXD=tVDi?Ti_gM&6ts/pI7x~F=VOZC7+/@Vem1#iN6H!9x{WLCF|ugAxv~?9W:UZxnrD?QGx|t}:AilcchNe+y&3nz>F1?W~t@_}&N<qha?Mn9txoLfo<M.XEm*5zbEUCd5A?f9jRrqqv%5/fqSCm:I.X/cHd@~J!o^nPoO(7g/~!FUl`&N|+^ewqncb]fO|3kw%S+tfT^djoo!fBt+xwu&VSX%B^u1^.GP80LXN<M8<Y=EonWEr7{0~YVl{.}nZX8)l0mv<aA}Z3eSn=pt:xhIhA[B?mbdccOC%)r2dy*2YH8kU$bbUWQ=SA)X4l83)U]#0{Xm>dWQ6H"}n_km$q)a.u[P},2Di8NY3Nr7c0J/BQD|Z+QAfoQ[xIV2M?lM_TzhvnM8lurb#!Q&g=*V&Q*KH:}}E44:@HRC5Atz$5fx@T^SC`)|&FuS9@1)B"JUQh}Y+(#"gr;lWt#|i9YF&0E4Q?1WDYm;_+Qhj#~lLs1$_V%p}0:4i7F3Vl9WfD!QhT/$zIfxEzP$,@2Ik1&ZGw,w@`e3WPlmvPz,Uf^^Ja}PF4>?w]JAI0`E3u%@Rb8GsJ!*8[tKzJS$*|`|#b=FWHlQdBJ;Kv)+8O^OgMQd6B*2FSJM:OpNe:^Dj]Anvv6wL=`]7]S2@RT]HLMUU3;g7qD`@$:)8#S:w^HWb@#YDh<=+PGj&~8Os0J1K#<!PaVR{96^C$Zik}j5_9?c:ocDN^WK9dw|<^!Na{O(yt@370>*8*3Y>76BkXE^3Y"(eE;30VT>6a;Dxic:Tmg.=sxl5(.aE?Q0:1OgJ,L)t3V^S@]vY/P1P?hi[1ip"`58NC$by!1HF+LH~phe!6(q7Z.=bT:*k:;7h!CicMhC$/LeZ>FgiEc?rnJ7G>D#~}gn]SAIb7N>f.Vq9L]};H"bLj&Sd[m6ge6Yw3MLt/.9}tKr8`!`.|9wPjsd6MJeHDA*"0B:Ym4o"Y*2!4Se#$V$g[r.0h=oj[,_oHtPns>Rp${$0:o~#&t9iQ{kbHR`#%Z`r1Q9hg>|zCJfxW9%Y+&}rXE;s~x&dRO|>qt*=(I~izycECTO*!Xw`Dfsl?iltU7B8?8Fj+2#gOUJ+&LJ,c>no}+}>5&4h:_lA]5cm.njIMJa$YXZfcDE)5[#0#roT7%$<Y<_R<sFAyW8e[Q5a+*O}+N9yQY>OD/n*fEtXrc%LIPK|70<6&!Eh9z/+@%b{=IOiF~wm+F>$H#BG]}r[<yB~r%u9P4H!yZn!C_>w@b4hhghTkL9N,*Ov8f?WF}SUc{G*33L"o0G~XS+|ue]=u[6R{n|VhS=_wJ,9X<%P%1^9Vh|"~7MA0?F0lQ|t$#bo0EWvimvwtV(/6^qAq:+@,UIr/NW;G!8IOYa_Vfd57*jk#8KHX~SgtkLl=yQS]vqQqw6.eY[sZm+Ie2aPjwpL)S%ON&=0*In}eB77)Oa*usB@ENRXuF9.E<u=#!plXAYQX^:bB8F?{=k.u27y4I4~48.t{4bb|W?ioM:Iy%1QI3&#Jxs"wE<tcPx@B&,#L@+[&i[$s_4uP0a7b~,u,Db=tj_q4@9X82|J).((d964vb`OkuSoz6Y*oqxu9KEBa^CT(?8TiV]nJDn?Jw,QUJTSWAf;{1n~rDdX5ZdRMg3EN0g)"tPX/FZtKp2JAlpW#c:PmO{NvS%[/X`].eGDc>oOh}2.jla50*:.O>}_>c:<#u[SwYTW9a;L7k+I0m,Yn9li>om|:2J}I{cjCAGEv.{gjvf&XfcOzkRj&76F6,@?{Kiwkbh[6W/gT(=q7430>?Hqf%{Ru8e!^,{Ta6[pt3j9]jBC45F&r)rPVC9Dr^XW!X}I^#io?+~+sAY[zN.kX]5ZPtOPiEVFsIpY2&G[cZjC]bF~11!mN=_zaF}aO%3(5D)b8~2tUDqnKuZK0nJ8W4$3bz}E"7bye2X%ZrnS?Y2qPvF,@VkfC?Jri/.o)Hl~l0nzse22Ji;xuHw"7;G6j4LzG*g6w4vm~6K*[>OJ$1z)TixnT=2ocDX;7_kH$Bh<d4HV:`VcrlzHeKm48JpIio|eZ`:Ix;jIG@4>H"BbBT(kqa}bqeY]Hk}9HnUEs!/y"5n0!9[oo=(<!gj;7TVK?&B^vRr7g(!kj`Vmgsc1+,bp:Gw!J[C}/Z9ng{?$LY)qB`wC8Q<q=f2Q<mYQ!nu+H3_cQ98/{84r:UTUpSz!nfI|#Z+0oVPoBJh4GO3*X{BBUt2Va.3FH)akm`(MI|La/WWhfE[%,/xEIH3FsYl%m>0v9n(vz>Je||XH7E}<~aBjh_@7Wwv_7kJ:(?=_N(9kwx@tY_y9IyG8i@oTUad(7JUXz56zW=!9wwmVjpoDQD9{vin`jj1TU<`_X4aUE9D@(Xg=~bmG7&=2`~Vz>mT39um`/E0TS_SN?Xh89V<8c11)bYp]EUQHP(F].9wlxFfgFfB]6XU&$LZm:[P,2gxErGv0I3LJeF/`lZV$V(FE?R@eU#caN+,g<:KPAAIgb`#TKKCDPs/]DzBk+X<LxPIrBnc<~8%E4]@m5D,SmOi@H*tK*?*O3yj~M+r,E>;3oO4[5}CXl[=<{`GdisMDvnsp+3fs>83Qk82zu]m1cYX/r1>a;3+yU@I,/.oy|Y0Iuzfqw[Vd*`waFdbF8BS!Jx*aJ78CE<f:&Q}nFD,|0rVL/+%7e*2ai5uqAEc&^lkfFiW~:JAK{fn6ca<~fY4Z%dJt?L`iY^!:{35l[`O/qFS|FO?.a@2l}:M_IKpU6%$w;!rTj%wRdB=2SgMTVP/%^.)|(#bTQYijGuS6}zp<$0EB1g+,p(oU]w/${5H{2a%DSbR+iT_VcAs]<wJI`:Je&)qYv:w@K%z**+BB9Y`GW3ryQ2?I^`fTNJ&2,B%m5TeCI=UurKx:@|[Zwa)rbta+1pxZvdaD"WK4igz|tJyK#4yfOJJL,yl1]T6Hp7&c5"1#nko,cK$_6,i;jvPSn;}8ei7ehBL.sZi9]YOs7,aLA9NAghOFWjp]KtX@`5zy73^eD.Dc_e)hVU%oawOHH/o%los;H@ye/VIA*9miF$k{;axxa}KKKbDQX:u^b#?Js=r1[oBlF~V$>PhkK(q7P{.B1BzQK$y2V0xndsD]"dk:om`5g4YjXgl623xK<ax=$yB;qqY^};Q5wP]QB4mG];9k0S(T3LPHubBJPVT9MX=XH:5Wm1A.QW^V$1lXwOH=,K=C_]*SH~wx6sc5D5qg3!u#[6ZL&H=PZ=d|v=(V!)4oorQR?[;Sby~&;J$<nHnVDDVnumM/,?#8`wifnQnq6X+0EMVyHe@!Ef`2l]DYWnL(3NT4vM[^:;|Bgz%A6BB$2s|3_.iI3Rj}|4:s}*E;m/x6DR/SV4rB_p45M)8Ury7@:[]J8Jb|WD23/c/H}lVP]:@m8Kdgo(S0^MXQZV}+OQJ9aYP`>4);<Lb|IRIi_0y&*>jJQ)4`W(25VG~R@Wf,NP]JtZ4Oh>f4f`c0(<S~:l<~Pw"L^hb^2vYK#~[e_Ro[eYE`$&Ik>AT!Px0aL,5p/+oUE"hK6n@D/aUH=$Yv5f[Jk,QF`^Hf/^+bj="Faqm;ePaqQ1A>a#W4!Cc;n:h]7T:#3TI]"[:HQZjTNOxLsA,)!ZE03MJyo6=IKvAkm9RGll3k?R%)}2{{S.F+#>so.:5|KRUrE5VomiUew>[Tz1{7Y9Z.^A$;dY96$YvcH.Lx%^75}SFnyl`33b%AbI;Z|Vkwl/NQo)ToP|?d{>[BdQ^3gCyxBb7XRwZ9JkmXWb3KNOn:60}`)[9l(,:I@H)@T}bG6O0>ab;%2CDj;Ph0P;se)Ws[hr0sU(N<J]<^j"%,`CE26C_R,Rq=VE3~5D,=1]]=j)5FnW[At)</!gBuX4dObK)cAW.~),zzWtmNB_E(GXnj11T]lcWagJD;NK6VOuqe+&%=eoPD@<x}<0y249=(Cy(lno(|>`lGpJ&}|cH_$#T5vvtXC(8XtlY}Qi|3}5uXG17]ofRc+[<P(Ia|p5e7U)!oaLfXW(`h<=V+ct!k8ewF#p2R}w)f`%[C]!f?DYn,]smw!.:PPXZ!my()0Ij&eXNz1hRjWJoQkb=d,6ZpZ#?)xa1OK+iJ#>IHM&!.1A(A_MqU)LCw0ZPX%iR+}eM/gI+3hF8`$E=A?aBm+{;c,wy;Iys[p|c$}^0K~l&Iem`K.d&Zr~uNoUaqk2TPs<6H5}12,tI#3~$,)H{$I&x&:ytBVR6LN|;e%n"wx6Sv,17kOHocmP3D*"0pH<xjFYJ]Uq6AQv%aIQzeH>l#eD]PzE{v66C2G>bC;9FW<gvFv;%o=pLpcA2hsCioll65Oz6(f44^I%?`IzbfV^<b$h$4Zy97.sZA=9/k#+kaA6x6E`F8Ud%}3O0KK(+a`@H^l)~M[%=8X>1lempOTp:IIr@!;yGs+2e.q"sHa~>=ONIL,;1l`)R=?ao;Y=bFF8C:ZkiXv%7h.$/Pgvrrr&aOziRY,ww}MbGv[?H[Ri^58O#~Qd.BaUVpQq)=cGE04F0R@lrR#ehpw87^1mOx;&83IG!2%EEadmuBL.OfP^364DXdx`_)[5G9K/^@GC&c=aQZobEbc7hcSq)Wf0pPc]?r#`_Kb$p!2&9e29PC;*.B5Pho{o?]b]zO}5&A2s9{y)$s9oSPWc{[l:[O`{p45i!8;eI}61T/HAMtn*1Dm=>AJBdXKmimu)nGKuWRhS=wHKa}k/=/I"Ujgr9{vE]&hFualoWE^kYje/R$B@:6.9Svm&LjwtcDEN<tl$>A}2!<:(ULPo``n?#.4N^e8<+02YbE@A{&&460H}(@@5*dtn;_%Z5`Cl!]3>_"S3M*2JBl|58*4;U5*qa1J]#og5R{D9qrFY=e!~Uuxbknl^Khas4HuIo=~~)MI/lwzBek$).9pq/{m"b~yeD5/u+UsvD2IA4z5`,RQDU!Xy|JZSMI3@_A/9>#7Bh#LwV<EUKF_b3$;a]j=s.`*F_0*R;6gtcM$J!M"RncbJ@wZ"d(#XN*D3}o<YNVQpZ`;(FQ8]X!,HFh;}g/m7{e/XOY40qRUQ7)rd^LT[)ziY[cmjQLV><b4Udrrsbm|~Hn;7>CHP]:?=^x/_ljp=D*"H2."3ie{=w>(Zkp>/UT0:*rl6tK/FKOyczH^hFoVmiY.ZEoOW[QI0qm*`E{~ScljOCh<^l<veLEA!ve[unZMJr7TRL5x:LE+4Eo+~5Rvay$W[)L?7`44U,Jt`dxi1Rw|}Ig}*=~3]p6HIGtl+rl3*h^]`EO^Q@WgWDt.v|;C2v%iTT8<K.&#O6qF(6@cf+9xPl;?sTSY!9&i0{q?SJr0V*@lp4#0+FI(3y$.200KM(FGly+z|@c;E2+QhLb+>|qG6b%x*pe!<O&MkGe:$edSyI"[BG2NS!}_hvLSm?j3@W,SU8Ly>.a7xh#F:M@@Q*35}#mVOy._?"EER@u>3}[T84MqMQp>Il`Im|?8|YO05a@&n3}Ky(3ZZNQ%Qw=L1=2oXc^XS@HlHfQ;{#p{Ns,"*<"3h)>#t$tOg7/"!|S(FPu"ZLN_#5{)dVHZgUiL"LAI4lkqXw|:*!vzNh86%(CEOGWheP%#PR{zj$vh=!;;3uLlX3G6tf69:?kQaHCS$x&*fo9om~0MLD|7WqzxIe11VLtNXc$ADnomFi,wZ,Gv_L!a6O:Y"[dDc:gq@.D6l9EU#[B[h0CKMEPUYylV*[SL@dW7w7dR(cNpMypq%LSJ,[EnK78;35SB4I"4?MFv}Cg#b_):r6/XtkqaeXTjVS~Wn`B:a$M8ENy)/=WsXX<P;vl/"tg8*3Sgc[gdJvpD2,(#(9s,El@B71qe4;)Z7hj@@si"r2H`7+DWer1z4}N]69&9Ua8_M%.@>m0eN8%;Kb[uyWpJ,E5DU+}U@/x}wS]rALa=nrce5u/PDfeX?C[j]pr$/zuDNJh<xA:9Zm6>+23,[RWLKe]u1?<&b_ISlb;#BYh%*Q8X#/EVe!*|>6a^l>tckYXgAfkw6dIxkSby3qad1szD!9H=$Sg,N8Dg`ta.Bje1~`=%$(eiC"c9vLTPjncmP/[im=E+D}Og]Wr,PCMf3ZJ$DEDM<qe,(~Mbwegv+:aN|DD62IBULNSxiX"nK+$7&fR.t#>=}s%):;=Ed{(2(+~*b3cON`!a*r&pdQ%]RR1f3"G5`Q2RPG$mL8Qo4{v2yZ^gxlrw+7F35Dx&.^3$oss<Ii;E0~|AROC^3uKT5>Fj~$[D4}hQ(R3(;nsTiltkA7B^&)*qXgW;ca#ItHXRIf7TLK*x$y_*ug,59kDsxhmMh4E4LgHxO$G67c}Yj)6TM(o~m^=HiObck}doTg2{;[92|0/_0yb~p868A|5"wHr%lgHvUv(mak=5ew?,`j^|;j:tU)3%ZN,3Q$KlV8K:G)1,=BQ!qN`G[NxaRrKc;C?d+lVCHfUo[8hd2/lqH+DhhL{];n_~;6?,_i{i/b*:Y$F;h>6iK9zW$Rnc].[ZBhl"Di*bA;sO?;^07a|E0R9D"A9oZX8I3!r_%]KUy$tVT/D!^Tx]uvYcPF]5)U@.!1b=Z0$2*t&=|XxuB0]+85cq$vUX*9eiZv!]R%C)_cjZR3])u{*NFCE+ef"`x^9KxDTg=Rj`jy@}`}gq3W4idMfFxW.~0`lB(obJ7#p>yfro"e7qCy.cc7S9>gPz+J1,=V_o>x`Ip9elbK!0#s9B&eag}*jB=X,W9eE_Yp$b>TGYVrI19,]|!X<@h)W7Ic0e:m3w3s[RqqP9BD|Xu*;DSK|t{LoSFTxO+sob&z`Obt/(*}eTWIxFv|EZ[nwYsF:9Gjr+?S]+vz{`le[!DD+OjX|H}B`?V8O],L=KDK,T7n{@HaQp05BpYFQ~J)"!O<>@IzD&AIL6np^w`zb|)v+F22~MFK0C88o@LV?G`5L$a`Z$&:]Bv5H>]y0Xhi$G:;]v|D4/KNunZJK?Xm93F)#l%nw&sDpZVu$$6h~b*DQWWBP`Ar@X|V+K*}bn9(zCDJ?:%Y"jU*r%_#GeY2&kB4^(kNX|kmB%B8`?uuTx<sd$~nvZmmK0_B:u{OR.]]}Oqcz+tRHs5i30w!ncE#ly1vrBP|KzRr6.il)a={s=r%.(b9h]VF`Udct@`WH=y@zB89jD0>%maqxGERKzDjv"7xwdeD%BmQ>s!_W@Oyo_6&Ciy@"y?Jx_iBoULN?7c]0OXkhULEoLqU,}odtl|CwWokI^#^Dx#dO~Z+ZuC;U$J<gy/qRb2[nK<AV+BmR@"Dz>_lHnE5R]p2&)*<r!z~C#3SQ9D!_?2DmGnxo3@UGlTY4|M=LYkixSuG<,hD7z#a?6bW)o)O5U$]#92.T7U{|gnIG3*_/}2FO]XDs%ng6u)^%IGahG[sP2C!W{g~#kc0Vh81;HK..BU*g<zi"f&8TwHK0yb)Sbff&{gMEz~dHFA5$0qKA+VC+:Mvuizbds*ByX7EF(wgyy]ob,/Y#>&=xXpMjLIJMIb&]dB*Cn:~O8L2Gaoa=j3N=)vdcZWji@UG55FE7]qGUCon)F|[ua#IjD*)I62+Czsq$LHi<!}IE`h4h?0k{+inkNL.*Tf[J>ja[tTgQg]C*.nl!q%[54~q[jUXCwg;>vo.a2w@RjBhN9ZD@adJ)RM~#:L1IcJIDQU[jTin%z(ceKP[5k8:ud[PyNL{A5Vc9d3GUeKaP*`x(_vo}!H9Q^8URC)8{eSw,/a~B:CZ,bh5GL6Lr%QhhKO$oDz8u?m$QU?+@.8FyW`L`8/3h^d/b9QC6V!HA8}Vj"*hO*+BSF;KVq5KLCZyz,:C>}?Hd<r:b,`oR*0^!$GZnJXjfn4U{Nhcqy5T86ZUiNoZ9sWYI@~E{c&td%`AoEqik<D=.~=v$2`Do+fO6~D1O_E{+h$(gIYG$i<EXH1wV/eJFyq2JH6RU.,H_wcB7Ea8L]NZA?9_)jo|:&pUp{N&gDz(#YR$[?pk)g!AW1vufvgK?x3w{h&3:*ya8|Dr|%$/LclI(h<vWmnJZ3@yldY%v&p&_v=(xLB*J4r&vgnfxmi+}_#Er:3/JoJld`xyqjX+Q/+I`5nZ.GpeM]d=<s`rzqI,1W+^c9Tj{%%pREf;0n?:2VN_mHE:XwM]~Lb/m@Zu@TbD9Bm>B?P0|:=TUz:BwiJ_0$8NVmcXO}MRP_Uo)GJ()xSMOPnoG+^s:{>x5k;aQ]$|y`B$D.3~{cJoLbGFOd~[q(2%G&:MYHg<of!_MWf9[02%?[]]}jpd=dPc394mzC#XW_Cv}Mh!xB$d4%jXeu.oi*!zhob/2D(`$X.cq}ISI4XzwHy}1mwKC_1RaCp:^)&:8RGHk#oz1fws`u""5gZv[^l@2M$VI8lKQ@G0QL3&F$_e1PJUY9MF=?qR".syJwy2>BHO]8V2Cfib{,!SQiO}4i})r3(}!Sy&^j:mP.{/>k|7.=>vV?~Sc|.5T=C+#>FmqP2*u,:D6sT@Z~f=8jT]Fjjz}G;!s6b`<j(;A&e8ndrc$"UfO*ZCJKI.f,sA3W/rnzp*8wdT|Bq7=D+X_@E_AY{5KtD7Qf>*:A#*)}UBt#9X1&X:V7F5UHRa9uMb9#>v]PGLMHMgm<5**%X0e_Sfqx!_[t5Y5f&ghFjgGJ~r]NOCH$%0q!4gy4QL<|OOz4EW4;.)t>y>o^S<`{3n~$1b%dSI."&";yid(aEY$eWbJvaUJ_BzD|9nf,{9VZOO}1#Og?"U+OkQZFe|5z:Mr7872L<ee(w#JCRSgL{l%:5)(D/"skwvM$E|_zbQ@pbh?%+imW(.7@tK}hnl~VfRz&E+cDV6i*l){C*o${geV_$U&B*X=v5,es&FR1#Tt4=1Z{=.{^Bl^`s:q&Uy,hhIum9{zm,m&qK3^*_$bB{)qSS."32e{@J71Cmkb.%1OQB"Q)lOb>aSF#A{G&3vd?gQw0dqh65xi?{u3{[tUx&L/CZw1qOWk"Od?CFji;Vq&&k];dB?eX<hVDx/!4._<&p$$N<$F[ZSfN$wWfI0<9yd:CZB!dY79U+!xc#OxQev[8d9Fo:mR)toe~z@ku|:CrxvEX/VQ`?nkEy&.,h?I$kCk4mj0H<=FC3x8DjBljD?_}&jJ@LrZxUBo_IkU^&@g#~WR,UWqOO:h!4<.$45]nTJ@2(z$IeT_k~Ii?j3[y{a|1Qr%9II&F.D=tv7grdW*Os<o7,#@Vm%D+VG6HFfu*Pu/0b7%guHd24)CWYPFxwhYR3nBWQzcHhWhoqPjV33Pn{e25ukODzrA28?q)=3utYV1kKk;MYYbM*6pV}kiHVBL<iTx2k03MZN>Wk*XnU]/3iKm<HjOq_&^!S8C|O|2W}M3UsbdPT#cOhGs=6/i^:(#T_LJvm19Cs(K0Dm$g#@Z%8!"rzWl5.C+=(jq|dw{[*4,sPTu0`8ptB5z#ic*&*i|jCF%Ek<g6?=fOh(8{_>BD~oKBv,CmIyn#`RGlS8#V:.M:/ed@|Rna}TV(VzQg{a*1;3_)>@"ZVGs}tGWGFkTS+v%>nvR,?<01j%DcB#,PCnOfeR8afz[Z/tr&hY`c7Z8f[!A50OR|+R3E=oB7IBA~kC@N~93Wcgp}i4dObOW*W$#<@,kgpRX+iG;zAx:f!n49X">F/G:7~7*~a0Jko4H$XHzzLfL[7?F`>65dO;U)y:4_.=FF#ZOG_Ql$9zY^p.eh3j#o5&Y3b;a(30LA:k>S=j+V)Y(29L=?lQrGBZbPeo[TxtcjYWUa78LlLAM(*hzuY#@Dk8}F,hJv70p@n:hB[ByMAbsl4_px+X18_s>=,N<n/,iUP,;W"l|uOc|lukL:JOk/Ru"([b!pdxGTI?]0TapQW]=1gyn%AWpZdF3N,"{hT85G_qq0`Xr(aHj7&ll0LggXkJ_;3jpj%?8"/[4p=BBOWlZj.a9BOB$Im>?Cn2}]7+8H<Z%:=E,BOnpR"<<Ai:@?l63s?>hSBrUB}o`(=E}Fm.<1skJJf#3%qMlS;m"C.FaHWz)8%VyUV#ZlNq[%|C@K{>.!rR?Vj`PwuT.oqP5eo#xpI&Mg<dHJN7zN7ftE!F+t2n_O<xRE3DBC,fa=p^<~B?KaLUh~UNPMf?B`T,*&Z;P=0JvXhL0(NOC5!5W]_fmIo>No?QOVzd0WBFZYi?#bFyQ4$50FOU<&D$G.Vreo}?B=`QG1Mc|#jB)T5oW/{]aju/oK6}!4z$6Vw$HV.){_inqJoljxkr(Mj@oS`y.=iX7eEPET|4X0J~2p}ST9%XZu|coHxJ`T``jK[o>)`}Ns84V}`%M4,3f:|*hX{dh}W}@].V<j:1zMdidxPU=p0asLz(J8j:6=jSuTeOmEtF}@Wo4K:Cs&GdA9|7ih9_xkHjNpW$bxQjjypsfv<JHu452MxSk;{y*(ly8um:RM;]%l.:mt?(`,p,0la@^K[a?S*QO!dA)$L+pFBT&AVUd1#cQI#U_}4ThrU/nrlCIB6]JURyFI~c>mXPp0e=$^WHOJtK;e*qie^ZQBsPC@!_r}0~F"p$[n}]vU#a.$2D4.$_"Z)^{A:]AT!mKpSF7c2^<bfb[5LFo4O.Os6RjE`)WmDcBM;ShRyf`Vzn7;_N]3ivpv"<|Kb4_}C{aMK74;g6*!B?O?9y_#^+?{+q{ct7V#t;nN7?T]Lpljq!z9F"C55&tiVMP@yAN.bz,LX@K<&U)]R5)c}KN>3PWydKt)5lwryv_wJ8:($Dh{,s4,jD(OO<+Ov!>gBGNe|^G06&#T"m.E1XU4Q5/E#Zy)O3f2rYHe9OQu{Xf!&OY?5w{q=Ci=x|"^RpC8a9Gb<Nw:rox0Kw`P<XFtN<32EH6[l6O8o<({]r{O&Gcdq@8q0M`s_m.,]VZ=~~]=HV,mOJ)FgO,OSZ`i3n@LuJQ:=Wecd:0E8&S,aY,E7%6!T/@diE9trl>;!V5c<@!6FCCxj@#(D5n?]X?bK&fwXd5"C2vYe.}fG#8YK6:(.ftex[^bzr,[Tm%,sLGTtUZ0eAs#R]HUBK<j"on;YB!t{{?~Yz1D=M.geW},bnH<l^wTF#*$1dUs5Qx[WH8I(O_fG<kYB1m7QwCw2!)S](dm.e[*0l9q?&,V!<~5WJdx.}`mE`d3JZNHGW]E;2xZd^=@3xu677Ef^!TYjG*5f_:XQ^;1(W.s=Fp^N0,GBIRw;6,puPLpp[:^&LP98vj1Ide)#WxbCK<zh(bm^5Rfy.]WsCfTa89n4[ny9<if6W4]=gr~%!(/U]_*4bO#inpTKC.O6#RSFTR5{(=UW{GGGFalx,4Z[g3q3V{6tXDQwiAk`yR}ddEyBe`g"3Laoch4Y%qY0UYZf2oN=m}wFd{5Y:1KvJG185%=,92JcSD>Y1+0Jhm*f2k61%o/<`:&D~?A]>2U"/K0X"d(V2_<tu%lNHNv?4e75vE"C*>6q[i%aH#up>4ooDznaq,bYF.aecY2?3_q@D&JIH,==*=30JkA[l+h6<n;%Fl"Y<LJ41Ot6^m0I<%~K94CE($rzgksZ`agp|7GzHkcn4UA}d{%%RDBtbajgOpD"t|Q^x9_3H{NlCTk$KrO<yQKAu%qA[T8La|iLC2gz/o[{n)I>$erOj&ih5VYri{|jABLzB/DVl)?a[MlwY$`%zBm$$J2aM;7(AGH~J1u^R1&#}zGeR~${w2,=(F`%lAn|t2YqT~b.p?j6=jU|`<sL{Uq{sK!NDSj2OToP+v}(}BHhqI>kf4?8*gr]gu>5CLC>[Og(!C`rx1iI+.|3EC/q%.u%2GLc*fIC#5KxpUCZ9m<2|b,Z^tSjr"dvB;*kx8Ky~JttY);N7~Z+d2vFxvQeQRzu]h*dA`7+%MUIyOLKiGHD8.bE@D=B0vOn|yPx2I7lNc}WWe<tN}xN7%%]40{7zmKnu,4&BKsWwXTlj?2J*:Y{}=p~lQUJ3kdkvi@K6oZABOBfbyJwQ0+uu:"h:yr?[*`CpzsHI+{rMq$=TnS@]H;9SX_{EWT{Y8A}e!NRbp,Ln?PWwELQ6p{l;~:}337uQ3~%tGZ*PWFHo2b@_Rzi/.l15Z<>.Oy!swXi2C~aw}M[pC#q5M0S<tG4gz[H4,>!sodMlp6u3*I&yXq{zd9(|F}AQlDo9Eu+F:Km}y0S%R$@/y=:,1y#vsy!#qOfLHhZ4PBCB{_/.,e88KsSPmBjY7jgHk9^pEeIvavvkCoej3keNcrRap7bpjK=I/`{jr#YJ2c2.d6s+U4SuQWLUv&h9BG$D8V.p#Ypst&d@$3Ba7P2X1/&)B:AP"FXe=X(c(tDKslA58&0jODA;97Oh({S)7O4Wb`m/;SnhO."l&EH{?a"mny?aL+j,})bRS[FFNXO<s`_XkiA*gdLLO7K$ApAZCNY).{^>zxb#`y6ca{H+b3%?:NjeQ=5~+)(ENEt8?h9k0~]JhQ{c1^^=hV1Z;Dh~Tc862SojMvD5E21lzSiQedY3?>R#"S%FL#a!vWjJ[K)~m7TK`rZF[5SH0;}ln]zgmZ0(3=:[*m/Z2/jc!]YFj$6Bb;|+>]5iwXP#yuRiH^H];D|=`SM"61~4P;6H/4*[}*|J!5+[[e*JcfEWh4ME]qN!4v=>5KF>">OB9Iz_N~LD:hu:_!Ie?xw!F7D4.(<d4lp}tK}9w+eu]sr{Hr#tzg~EFtj8B%D8%!VH)_mV`M|"Lx_X1Rw/kgL&L/<j7GKNrhP4T%nseIgW6r@NGke#6#}{SNRWZZDmzW]He#$x{JkUl({CEgYf5/kcrbN0^do5B!sBl~DI]X8uU|7|]&$kj=(#kpIK:|B)Wyu4iTsGTQd&0I$*AHdaEB<8OBO>{K+{[)5DKe5k)xvPPU7EnDN<C_5^.hOQ?WdY[z{ap4:bk2M&DtoUdt*PxB9oAFJKS?TvEu<hg+_.KXVxW}C0m#[cl=*s:5:q`nAN/Sna|4H=xT2mfoZ4wpTLL["{O321[z9T&bUw>]^+ybf}fkcxCL6tdwzs1sJ#R9mE.`|Gj2R+2Vtsr4jl^jfW?|7:kmv,$]~~!~n|sy:8@&8*]^5~g{>>0Ypp<EJ]0M|](V>bRTfvrgPYDa19F+IprsNn*K5KGDr~O77w5z>2bL.QP^pj6DF``imMD^P|X1~>RABO8Fa:1"(gM3k<2yJfeI/l(xNPNY)=U+BSool;v*gP{VI<*n|@%lgnLaZljD&Q=Me[[O};gsr?/ckdH)Bx.@"<HKxbyDgU0nD^,r>b5L=1GB14FB2FC{3SV#s=%?kj8w}IFwpJ?{15eBXKf1hC@c7Dll(yQ<|b}+`jdcgxd/G$+<Y4#4a(B?}_jRSSwt7P)Wz?Hd9%}>emy{PGU8iCs6!(4PXHM<)LQs^eTY!DPXr8d6YQahlGNd{z!`pL7qLM!^{J$Q9x,pn`ptr{sEz4$PGX|Tt)WQ?Ort_`!3^YCK`$[t~jpMD~Pm6|"?dTTIp@F5g.,jiA$&Jbs2&0JYC*7KlKI^C){zJ"V1;V61cg(&2pl`"cW,}|@1wx8!`WktSX~9#oJ"1Q|Y9V6g0Z|HFz>DbXBb;:;|`N^!SYX)f87hc*e2_v1w@?v6x^i:!rKU{Po/JD.,RQG;kH}Q(6@rL?4/#U/l09Bt(j4AyuX0EEu1E@3N!a]sl4Mqg[4vXQrD0$}R?^hq/DihYjwO9qB:Z/]0NV#jiw{v#slp=d^N(/qnS.[;Rc9H4lW3p/l$wdqOTq*yg{tiy(^[]2dkJEKt)c@+@gdG0Pz$@>@Mp@{0>wwM.ag_OpD*,laaY`S4NJhxPg=A<:cqoJY>Nz7koo:>cPRa;%jGexMxxfw5;5Vwwa]>W2An^O^`k/<^aO``^4):7oUH3hh|#nKEh$LUYw{!CZT>FS=L3v"u3|Sz>@i`SW!I_QK[o.J}DrJTB%ULcw]vX20Z(7,W5.0s}Z:sp.]GeQ%J4WNBTGr/gr9Fsy=}+OBUs47!woxGjQ!i4id2u9=Iq</a+UP%_SI(lu)Hin#C.1LN=OJHYs#Q;G$*tU_#R.R@R&g(9pgH7`}?1VvSErC%>1.]RTAV}OR>|u3.qS,NJs2,0kE0n+W~vNimmi.+9XxY(m(c1TOJvi7pW%w`8k4N!/gmrJ)@JBy]0WUrttgh^;Tzs|fCdH/b0+2Ddj`,(~iBeH;VP?UR50k2vcARk)6[F0>iNj,y@?[qX&elJ4!*SLg?kN^RFmLRgRF`{d<J`=>]|2x2*:T]yos%g5bJlzuu|ck8lt,04Z@An_h|6;Sa`#Bme)/Io5jc;W/BC!WYV//?DNK,fjrcd|H2Mm<mM|{Kso1c005J$YR#X*`vry|x>Y$QP`cvmg"]#2Fx&^D7]8tN1@OpZ|b6;gE0IMl6tkWV~cJqODw1NIMV>@.</jA5Z+2f`tcQ&6Y%a;gS9uv(>3;h_tqveh00H7bDaiUY~%YE4iM4,,P3?"4[7=*+L=bq+YdwAENZO!CS[.Ek6eqvo#$LLR>l&2Bl{cGdEHh~G8TV%q)aWUXa|<NxP%}FaC^pU;pEA>;&mUm?CB]HYz(:B*uc(D4T;*!ykCXJaV>?Ck%cYcwuU?36,,Xyo[bcla?Ory>C~gMHBwJh):aaCdn/89=w"&+Ut8#}zgTYDl7C7F]QGMcwamsX7zl<7YON!QrGzxVb)5^GS9&98?fzplCee5Js`$Po=#4q>4`FAjxuF)Mt~;_*"MMGijG<;j=@uOSG@)j@k|)>78^Qv}8ZTq=&$^AB{v[(*Ryr}uSuCN6M}FSd(m"MOmeWpZ;iRu:hS)9[Fx{G,rV&JreZnG;n|[pPe.?2H_`<$JdkOcQ9b{+/I:;{K;lC]>%)kIV#JYoZ9RjkDm]h5p0Bg#&J8ngIk6~qsBxZK1U^6Kpd)l$}{E%+!+1*6ae`a,<5]8?vLT`WVk&zA5O2fO_:8*(tMfc~?YTn0e&N9vUl3<c<#JPXQ?dj"6jrV;8k:|$,n18Z3vE+g$&{8;AdDl153Yoq4y:?D{nz^74RTwob=&F?y8kWC&ky@WuNM!MPuokqij[`@fLT5hmhc0|fFKyDGQ#0_hO0XFO.IY]nxnTP74H,Jc"fNKm1h=$76yg6DXlLOSGG#lpdDCN.}Kp5AMV*1y?l4m~*Ohg`O$c(Z4Wu.p:v`R2qY$4Q{3u1:`]K|$Mjne&Taz:tleF]PC8$o<gXgvJ"<[a"DnPksg6s+j),}B%IO;t?ZtD6{$&]amOe7xQ,C|jOb:0Wc%>U_5gC;#tzMdj1yvj:?bi(MEa64&YI~,|9U<i]s,3"w+=;T5=bejBGw[%t!.Ftom,]]jJ]"o!=oD[hh.PQuFdn)DR`_d(E~^B}!*shyB?`V_}}W>3R(tPa_z|XcMo~htACxd<Oe|4czFpW}9fPGxhWG:0(Pv_qHo?$aq#W>EYc5Z;0/4(ni[[CM}+x0dI8l(+tsuYU<3[Ex}V%=g()g~>LF#lZVbb</@==PJX[m.<R";TP~S~*KwEXPkAT=VMNT!)rGeeQEq66L`v<n/c!#<.,:;u^7ii#jn!uw:F0R#}&<;hNz15ycy~9"u5v%I&aj|c0=|"!0~0|DukfatX~;8Z4Zeg)af|oSV4fL;kyhW.K79Sen0;O/=*z917IPY@OGk6$p{zL24TUE;P|Id>=u^/qP)*_k*5/*b!f_$CO}(($yNCpi]e]~,TLDqIZo%i6|(?/}vxPt@WE]j:Q11Bx=?DB[U/>8=6&#s}Cv8!czcP/AB1r:,LqM#ziuD~z+1r~"p,~`qi9ODdb|]E{eLW=`eLX8/Hn3c"xK+YF;nCbIjU?wae>wme?c19*#:m6rzr.|~%}p,[:y$rYsqlTQ(:hEhgU*t`U<1]qXvXC&u!mM_Q4/P16?:(?TXy2PK/+XT~RvhgJz%?zRHS]}8M4299?|R?(m=~_n@BVx,RAma%z@>JY,_}&)Q?J,W8C?FZM)|AgR2j6g/PW(qk.O,SSDQGK5B"VZRLff"&atf(f]hY%@6[2YpCV6OD~nLW5urC;E$WrwVmjGm?(lNv_#06a!44MEpNEUb$aqVuY%{p2pkTe>~s&1`41?W2{DZjD:(1YF*rg9XTYe09,8`Id%ZIz?S`u&upAM+cbQ=tBS+unv.4){tX#TP:b&[Uv5FVUd_R+.5E]*zyo*f]&a}OE:R5rxa}S0jj~8Wa,|+Us7vZu<b$2n,NpnE}{ZCIT[u$1S#W>^;POYdTxTNc4QUAItu0|%rY,%v8.lLD4YbI{1/3S%~e*w!R)#$:9`wfpsfM75m?Sc*KIPPF}DlJ>gVEYZC{Br`|V/EjeG3O."ca772KH1$_g9oD#>H"Dj}W2M0D5n5Wc;IQ7j7roSS&jo.V/,;)XPG8F|F_p2Wf6$g>_.id8BH|a]U,OD6zHd)bB^GV{[~xB2KE9}vi]Wx:3=O4K*RI`0l{A>&{:y+UfK]eY!CFO7igm:p.fQ*/mP^$v7xqS`?4A#V_O1Dc>$t)>?^JkIi,)ri<g:7ArQ*e=dmf?q3o5n[D2%&B#lyjHnK?S[MH]L`IkajR;`1U%1Xp~#2V*!+)%C3lI/ET)kJ9C4a8OnMOK4[U^9vEFPo[LRbw~QGUrW|U?T:/uIc%|DXxLAa".#RJlr0m*6wGT<f|f=36Pf{"{aUev@:W>l)YuNGs.GuhzFeVG7b12c+=>2j][F?:iKWGjHqE>5]}%H}}fEzfBQqQ2j1YtXNTHD|[8<9"|KgiYA$Li!1qNgY_2{bigi1ueJ+z8G,R=hO+xgdrI?|%#DJ*riR.r7,9Fj(GrP53/(!]}k:R/D$sRePJ]`BF~1]dn:r<5@0>n=zC}ITMM}Kvx4Ya_5rLtpX<7~Jkz>JFmeOb5kLRoCmCW,>Xor`&im_x2j.}jErlFMC5XC+V_8$^6>qKLxIURX1buoiFH_XptH.3b@s(yP180@J8)>mgL&r2(W[4Dyg%=.Ay"YtUBbxu<u[VYSHLS/KI8samBe9OEikZGhk<GDQKzX2)n7N6He%eaAMoZ2dS>fR??H5Vs2`:USId`)=s19s23Hr`KLdNiZuG[ngs@su3MU`JyHt.8jbfY.R0/S6N.oM~,W++#,K)%4qX@P/t8s(HjkOD2/%??MMj45bVcMR,BcRtYN2/HL.#Af(fFsIpuD<k?[l~$x!dC^MwDIM*}z=nNL<?Wd^wA3M~RhYQWR}RPTMApnr]P0=yTu@y}FD(#;%0J>@GO2poYlH3(<z}Rjx4Fy`N*<>Y{zARs^:IAV::?@XSFCeyNawx}!=c/LuV"(m]kawi,C@gN);7uz_Ovi/LQ6vkEG(!4`.$%>NC!SL]R,yZXI`a9CGIN,k&H;*!U^Y7uiW?N3ZoDY}<}6[Cqu=`}z=+r/Djh^wkBs<[THP1NBcOC}}a;WTNO9WJr&g5g(Yuu6=L&*0oLgs((UNpB*ncxIzW>&F^,%SxzUV>).H|no*H5)dg;>[Al!Jn~Y0z<Fg3Qng;tn=/[mg(wTg/DUaa39rc=F$Z)mElJZ9V2c%^!KyV321O{/9T##0GK@Q9=M%I@IFg1(+aM%D/l}c>j#dcK,%.c&Yn^4d>J!Pd9XF.HRX!(Q+v{H.~>n0&2:rx}QK]ukJB{i5Sw,a3Z>VPL2P}DmZa^C#3<iI.93xA9o(,)pb!94%wX+/i"BnlUU1z]*Eqm8)d78/aMAYoNT!wnO+@$l&O1Bo6Z9Ow7?:cZQMG[tl(7Y#1oYqrI*8.*GO+_g=k{Po/P>~E@|z3w[]SIv$+HC9QMYteMe?0V#k%_"yE$Hzh+a:G0@fx]l<fK%Cd4eJ^n$^(UHJFmJy~/reX@)^Wv<M%<u&coOpj)H(hG~EeR?yO+oge?1y$m!Q+.[@]UK,.<3na33T"q~Fo<l#GHW:KhsY?>R@WO+>_;!#`)ukmCc@QCO#e/7Zhk.ZUgTL]+#8ONH!Mi!Hrz!}A~>gC!s/d|(_N{4pL0+/HPX9D@&w0v}o>4e=b%IsQhuMM)Bzxq`G}LF]Dxo%XN>mz,}G?VRFh6cXm9=)_~X%gi+*r%NpSP[EJDe8=^p.KG;,ak,g@q}#&A93t~SgvE;SEMCBkV1T^}cou`jGAP_?102V[dWS~.WSX_Lrk%?E=>a^pS$n&l,xg81J6~M<P/Iz^3%=f;A>QIlhlxG?$y+GN^S9$||}I;&T064a]=)?>/];!b{A;b+*)d/4#tT8+iPu_@B:Q/<J"]omr1DtDh?;g.Jn={w7lFnFusva/G8<RYxekfICtB{9YQkN~I:G@M.^tY"0)y|5[~ou8}ANcPk*)gd<#oz6~23;K_wT,N+XtlGZ0Y!J(2gFjj<UoL6|Ubw1]`hD:7lmq}D2qX#qnS^l0X|;w[Z@G9|n:#H,9mRF6MSj.J~KC0/b~/23l3B2R}"a+yPV$lmOil+<c:nLkG+_S0P]gkWyY7C4lGBWv!t]S*u|f&r*^2hf]/gKxxy$wcXZ3.2&n9I4y(qqC<x%vVeZaR$_sOElIaX#o+eiG[dMp&Im=zNYP)n;9(|xFaZ)*#aNohFzVZd7?*p"#p}V[`!TxC{,5:F@yQt2M!4fI</2;Q4LUJz(]Llq1OC{,zX(=ig6!k#URm[~;8"/T/=[us$K.))*S#.?3]+CZqQ]XH_7]Gvwp/vj0tE1M_0%_3CZ{%(>9?~vu}s14;1Y|X`nYs#_H|kHW]s4FuNG;d.!Tbpvb$`qyp`=&OwGBhS=~}@KR=#2,2<1.GwCSS}y3oxU}&iU~H"Gv|bO@eE4m/x#8+eav,R+]Kc8N/BN8Y]@3ndGgvvx1M}AHg;S=@`Kd@siahxR(gVu@z6C>QM@zOdq@xMedrw<,7X?&$(}T3cO5~!|8_&jB/GDWr`JasNN~r~lqQ_Y|/r4%L2$TS#.CquO5XE;4%%j8QsR#Ha3"CsfToP]Fk>tb||`$dgRWrTgdSJVu_UOWUCDxE=z@.MVAiaL33,F:7i,hJ7JQ<JBeiL.TFhJetSfqAuaF:zsO>1VS_RN2Kg]m|_X~!viu2%4~SMja:XbnftI]5WsE7pJvWem`YG*N2$EC#Av=(<[%F_|4@x1@JEQhB^b;9>GXzmAA~1Yc>p9Q,yQcJbFhA_fLWrfjU92=@rWHhlD2ur__kjtOC4+<KR]1sa&T:aFukmkAs,S_ggwxjPGJBLD^1.q{e.1CFo0g&@s"RNQnG>Z^MIP<4`j0n*G.3v.("BTZ6q2<YP!zDd#>83&Xq:LhM?;"[dYN/kxJ[u$*l]<QE,%wzuV<:MG8$"_QUG4;4H2*Xwcda3c1aPJ^&,$f_HGq7&j18Tj$a?nc<7*4>"~}Ub^I>Y9J<tgOE8}b$98]sf(o?ARnP!>I/@]G;Q*lG,ygLd|bd3152XuR(.^O$,QEVZXh((bk;sR)53^Vsg0H>PDyMjL*UM0I(b]w>Zh:s"6LG%8k:~!qLs8D&m^3t?Hv//ogXI(G#@o@j~[JkT|yB5JAQNJcH0+_VDRJGMJYs7kN0OtA8+JUk!"|c.hFsQ#*Nc&,w/PrI14m1Hi3mL(DNNuNEW85)GB0(O#ExpP!GwrUwbXv;a9gH<?c&cbqgW=(E99yAcejnr{vq6S8Vn)_Gt]HyDwe+f0~MQ8r||4iF8qM|8Sd65c;v5`9q!/Meh^KvfCJL.x/~^dRAITg47I^3JG|@#q`RJ,7x+y}(~O,%cgO1P&@xNI}zdthuT>w&jGr$6V&/0kbnxh;$oQsSH[f2|8[sHu|<n3V878WLlHY|N5AcDunOTfC`wWk>V2[fFHKNBzO~+;uCV18k0v}fU0IRG)!Uf*U{dbqK[!3C`Ioz,j$R=]pNz=atrga$hz:Fmr4nlR#2t!1*dH)cg[bIwVg%*S:vArGx|#4WP??Y3HR==rmoMxd3>Jy1=VOw.9pPm=%PhJkPOOf,<^SL#$cxEFvXCzn=jm;Iv5hm*A9hd/w+}_"TDE3wDT+=%G:ZlC!6@et+[}]H4tz{.*s{K/W:]w$7l9WAg8[Ubu$LGdRNcM#2v]BjRcf@)iaa6_M?t>ta:Q78J.R*>Fd`]fD;?ICn@8cgU8ooksx[zX.6ElAJRrsL(.AYCi"aV?e)`3.)Z4:g#1]@4iX4F4e/Q,L0g{0roYOyn=UQUT])/!M[@QdLb|~M0)BqHnCJ1u+>[oUy;G^5uIiv&agWEo@tm61L|Fu3y;icy&.:SauO3G8$,zPf,nHh{jxp^TFzN`9geK13HC(^V%J123[yHb+;QXm=CzMg1deo*CKj&(9}6E1dYJA*RF|k60$ipJcFNbF+QSu#:7d9T~+hoFQ+xSe%wm/j{8t[R);B)+t=Ch;r)seL|ewq_d5KuN(.14GdGURxUHP<&80@hl8|P}pCyos_4_s*9^V,7{E?qM8Z8ZVnp0tyRf55J]}dKr+SOE3bd#OWOg@w2lA)L5pk:|!(>X{bdaSMoz>Aj.gijae{^go.q1}3A]j.=SU|mM>i32Q0N0fs"tA5"^k<6kBWMh~mR>c{I&k`ak9J!PuSi.26y~BCYc,v[#gRUKxLlQR&4e_d}0(icX<FbHyi6.SuLi#|Nj$|tQh_m72@.Jt0;];hz/"IPf%#dgD!9.|M^pfeAdS>bDWe4alcO&R7+aCQttS!hMkeV!X|uem<tF.4ed[uGUjY>W6J?Y1/TgBx!Pjh{ipV`?@AFjR:~pD:.J##Wt"UDJC9nL)~>l!vI)x#jk0LqCgm(Rx@x/]+twUowBPG#YCF?WX3Q8w/"9@(q6w}&3bcbLjC$HJ}:]|HNvl>aD[hpn,}f<4^ZoS<yd.v}b:Vt0QuT+.t?(f@0"/bi=L7V;?ew2oy&Bsy~~6S/)."TEC9a20~+(@jja#!=pD;~*iv?qgLN)a^Dy8BEc`WLq]q3$yb($IxX_0"zi[gqGdSeC8OF=]l)w1Tb_u@{,.nFj.I]tt=#%*mak_6]Gx=.("d8bU:ZvoRDtnB/oirbTgZuU:oOxkS]{Xytvco?(Ti2(]ct6FUCJd<$<MIuGDzW&C/1;dY`$!jdl~He}>8{:<.osxxa~8Jj8}JgHG@2[F<2/"^dT8$_9]RZ<f:*I]uPSG*nd};`5)d.Wm(vFO@{CVQ,D?}..a)a<uxsr:|p0>5BToshgY[&"7Iv29nt!w%82V2D}amFk))Xii9N!5Z)YMBhVpFf$sPPK"0=#j6pZ.~Lu(t?B1~9;b~U(HCe3#U~{tob.[S}wj89taLZocRdb79#%I~uYZ?/h8+XW;O[ZR:ga7JL"*(~TW[`dFxOEihaQJ8Ez8kD0haRrr%SMFVx7sW$pD)BcGC"Wd,BNF}Fb(QFZ$_[BXx9GtpF[GvH**@$?c<*k9GyyynURx@mfNV}23!>{3?;U1^k#G>!j?*ZkXon*}l&3SXSStYfH|U(:HU{6Dq17m<YJ!9[fW21_w{C`}_0D+[E8wFBkG>[@y[x(Wg781ar03WPXGL#oK?tyS}BI7ow"}uX9mQ*.t5w`N>d(PX"*GdT_e@(TE$3zCzgW]t#S?Q7yqe?GGq&oe>qNBEl_eV0=|MDd6[A{&2m*fK7`PD=u1R;Sgt7$hSl_xTCZT8#xhUb4X}Ubf7XCS;:/gm,P,+OmAIBY]1BYk*!iXc#//Y=UX*W+v20r5S]rU9>]6mAwO<)D0_UT48MwcQA%<g&yv#g2!JfDs4w&O:6bfEC;[97R>[zCx0;lTGl)24$MU#U0$&>$y?!zPHRL{*^b@:U0aLwy_^mG0S5SkyS3c|IFhn@&(C/de`(LYm3:mxmx|YC&>w~`5Od{TXsRPbr<`n8cSzQEEf0d^Hh0bInzI7g2[Gto.?,Q+8_fB|OJq/eNql<:DgMB9LwTN6!Mrkwt8nn{EF]:1^_E8I7W0Sc?dEv/e6[>odI|6z"Y{:M_uekcq;<H}}f$~3ba0D+fDv=/L=vZHdQKb+<GP/U_EU;t,#~FSUZgh{]"f@ed~,>CBX9+|r}pCavsjS0ff~iaGv"W:O:f"B6C:UC:*~(mR.rTw^Z8z{DW%I_[ogEB*jS48]e.3{0.LPR:LK*1*<q6Ir2*eppO[I~Zmov+vhtB=D0G:vG,njWluPFl,qHjn^_ISh9F~~"ZBJmvH&gK4>7`Rw=TMzF_BX8E2dJ=#*Ksg[HaSK)^lyz=Yb`5&c&y2WtDJY{`Ma=iA|"_EFlf?@k?LdV?`XChO6e5i>Ldk[XNX&O=@9otru8"cPgXK/1pO3d78RF|_Zfx~.*i$2&F|H.:O+iT[.7:G5=)5h~`Nnv^S7jo9zxN&,.PepEeOb1AZG{bMEIjriq[J]KuJrF14*T*ZOM0v/mR;G;crW~,Q{%f}otJ^0k7Gq6&@t%N|A`Y?p1?xxIv@zc#O{JbYB%Jv!/oC{qyRw/p@T/BDHgt;(a#P8Y`+_|$H/.RzJZ|^^_|%DT(,lM4YJ$zSwKw1S?Iv4n%/#PH>9VhAQn/$tX$"O79/GmW[L}D3ffU:=q8FlUCD=Pb*})H_O#D)SMl3XT(U7G.P:liSUQo<nsN;OzBLa=f7n^Nn:sEz3;Q8&4tIS6U.smJCNFYA+;>.uB)g9u+T7YT$RgcV0)hl(wyxWg4_5OIV51|9)hDP)"7ea&GcEhes5ld@"u;$?V10CqX1+x79hU$Ceqr+a8F#>~XniT<_+*Vr5$kKNWxj2gGyoZHEIxzGaZXkTw%2f(CJ1h0FH4G:/aFkR{r$ZRQC10S/BnwmYsDxbESpK/%>(/B8%,KLT+jf//(Y81T`^Ze0h[@h0OO&SGD:C#0<9RB~@+UNScf^WQvFr4lZ/[%9:faEr$4Ir{4W8u|q^jPiZHI|L)Dekf#~G]<nr4=hR#3n~uiweiUZZsuEFMqjT<~Y/[R/%wBpQ~D79)lNaPKPNR>_E(Tx.yeuVA8D{DmfX.~{NFU:w[{57c9KFG2QjT0[Dk.gH&(/})?3PQv`I9]&JtkB&wCO=jS&7Np9A$y(~5j!PQ[O6x^QmAKW$HQ6#]U7Y~SW*d?[t^ut`%yC}_Dj`xyk~jKiz(NW&DFaIGVXxF/>?p0LeL$0@.fe_|!AQ10Ju?H=5iBf<Pbn!W;Eq#~S&_/~#[k,O84p??A8!]em>+`%3.Tk8VobQiFm5:.u$rtV=SF5R|7:=]YqnGUz7JccJt}~89E+/jZuU|4CDK2"Wm<YP&]sL021QOOV}2[=1iQi@XY}f`W7u4U+n!Uk(kV>W53<`k[iQr&];<o{14MIe9x#(<E5;KxpBQ:iE3^tUkmf>lnOmc8=Pw7$r$$jcQNL>gCK[J<pzI.2i;X[8t3L6"6}a,,QSClI}ykDTK5Nj;.`8[PT=HvP+gE`uJ]":Ffhf^N+Z=78i$G7fe4?H$)x5"ac:fQw>JQB2t!"]UXVFUi]`92=a;GdKj;[@k<>})4Y);z7pX*TEdlpV6Hp(m.jz{P:b2tWe"bYi%wS{Fx:,vr~{:V4/o/6I.?bFXUo}r>inWW/TD19ra.}%OL6X{!;8_6/1[@:},(SjW$<,X2XK`Gd0kb~|h4rhT]d=eWPk4MrBCeAO/H"T$;;n`t7|#LX#aM>TYd$#K4wG00*)06[:,SQj.C|P9:q%S{;;ab<_xW)egA!A(2ydkN=Xi!w6qf)#Ng"b<8+Lnj%e[J,3bA(_T1B}IrOj&,r9C(&j`HW$OXdQ~Zl_dz(ir[frTfi+#w&dwZQ9Vn6nz~ZIaf%?pxxuO$,&lcWuV$WbK8uTYB*H.7D9Yyt;eQI,,,.})gzh&!^?Tua/L1ifyqg#5_vekMNVX:.*?1W1FF_NPUE7O!42x<0J<o:ecQ0bw4XGA.iscE|MotUo}G>Q1|Gnhj1qIZqG)*PVyEur,mrz&oI.=h?tg;cpF>b#IN*^>r5UbqW4c3O;,+Mn*=_4<i||US?^aOC201hdS)Bn{17_oH(JzfmskMrOWX"}c*$dhx2DZ9{AaQK67S$E)VKFofF_nJ~90*iG$K%MP={^ZG3y9[a^@Vy7e})0Qh%c!J#8f?)T!)&a8aWH:N!m&!R9DArN?5Gh(%)Ws/}JE}(KqAFo_,~D]pUPJBzOb1QC6io?$Fs56WCxTRVo[(5i`[HtQTr2,hc!33%yJyYOKAQBNTMjt(rC7Ce68{T4rXnQaxb6Fs,TRY+l*>b=7q(u+J@dL8f+J,jZ,WN%Boz*>_ZHd4Xlye`bO|Irvrasr90u<+.b0.h&U_ckkgLcDC~=d<vCkIp+4jToBFF~UHuj)a6["!+dMtTexGTX{DVH+?6ORJ>+1xJ*n&.2k}>`8}2<%968T]k<o^f/)z&6.o&,#rOlGtioG)A{ilG_yvHbjCg53#N*i4KEd:KYvN&kf:m)s}m>&7Nb8p:3m5wylHI6~01/Nnis[PWV*U``xn"uJlZe`x7e;hD6R~8HH]f(M9$f[{/OYz;k!PYOy+6@[~(x(Yprkr6S|Za+egC!=8:&z&AH8T8fDT+76zYH9@m#%.Ke;R9~BF8,bft$1o<w:)WJB]1KcJ@Ubx)vu3VY[yp1x"5lh~6rC7{zzSo25C5g0g_6!e!Y|5r=>ZJ7,5>`[B3~E}mLNQm;Wib_8a=U.N3c|.Z{7]0RTeyHfU[(52YJZ,H@z^bawHl;<I]8Q4|~jt<U3@P!:*4S6wAg+=8<`E^+U!Y;tR[5ge#~(.Zxas6c%YgTGvM+Swq_SU@Pfgg{=XD3(X>O`<`@!)9;$Y=Uf(@(kN@4q}]sDbG86{RS^oO!^&^X35BugJ"@pcZTva~&{[70hdcRI^"DvBi8pypd<rXxBo}np?!UHO@qJyoS@fpBLw?R.`Cn{xt^Bh5QyPY3V2LKs3GivpNNy[avYi33p0FJ6GfCNt7P.d2UfDO*:`&1+Cip~B=gxFha41gC|]%h*`YJ0a6(tRT?LFg{TnS6p!`1gYqbPDLVOZn+`}ua}d}6]m#D(~5S)=^5No*V$2@OZ3EfIcgWm_9i"+_9m8YzRma!^jwDh~_k@D=*>jLniax.HKO)wYSX]i>Gj0p0Be[u,rvpXb]WE%Jn&$%49~;OhFQ_|,LuW=@6=40o46jk<aqMF|CQ}nnJB>Fi8:P{7SO^$gUAc!J`KR^Nv_|vuy#$b=l2<gnQnen~)L!N9m}B1@n4k0FZ#=MRA~}?fN1PZ$[z&q;c/(@Gm/cN?C*).LOxp#o,RgTEN_ZnQc5B%lt%uy{p=B>!vFNHe%7.+IN>AoIaK[/WqQu8o(PAH_sH94x9gSM4Ne"EWoy=uCryaO;MuLONq2PH/|X!p<Jx6,s4PJCg)6m2I>b{l63_?8y/Bt/;|=W4%@TJoh,nF&]#h5V~qKbb.>$X=ixWD[kflYX$x)e@^DKX&Qc9GJsedYI<[BOFo<YS)y`^QQx&Vm`t16h[o,~p3@p(GosQB~PPha1kV95ai;E8sr|R[b$9(6SQf.6byAkgKVa{r{~KxDzxg(eI@,Kug="3.kdCD>kiJC_o4F>N.ri|otjdnc3#6*q@w{Hzg0;DtoQ%6>5gJVnR*%7uWpOP)hRTq%ahv4/p9)jKGeP,@_Zr>;u02#@oGg(vJqI,iO/%u3weUZay&6n4yNWO>WD=j~U)[@j&!$!<o#U9yI&h5+]|RSc{PwUGIt<WiBp@4ta+0PN3_.T@<)k?T)~eb)56RkPvCLrE#|?Mrq)mxr|xaFE%.IeH8ZSOHXeF;Ss7+/zW4LSu)vBkuLy~%SlUYY]6T_W?`Pk.m=^sg^|h8MskLN1Bde}e)A^e6&p9[.|a)/j@/LKcn0w.lE*Zq,]iY:0MjiiUcA9#L(N)6Q,?h3$fOxI_l#k5?KgawZNZoWKG?2gXMU5TRLT}7Gwuf?9Rs!5W9W>4XLJJ:|EQ#Ri{Di:hG[<]V#0Qqc%SE,A(:wxM&~Bdz{wMPntmvntlLMuy/8"G)YFKm=&u+h3>@GRVT:=H<ou)"(#fB6BGbS9@$`C`5Ts!2FNM>)|nbMW)>0~;g4@D%D_WFRP,DDmM[RnwY&.d5|8FqIz+^{0.`Qmeq8sy!}M&l0DhC?rU.KTndZ)_5kYoy!=&jV/Fqvl[I?YvQ+zI+_Sa)qB%HvfOej6uolm3]|"cP$Eat^6mJe=Q+z|hn_]fc%]5,m"#ex:=n.Jfl<T@IV[EgerSRqRt`imbR=B+uBva,9K@BlU)$JFj3?6D]P?&`"]NefHzEeNo2msPc>BNBSGGk>3>H^V*4Q68ZA_#il&/kRR*,4l]45K",@r_^n~sm6$@0c^DV4VCfaw*FiALisg:S>E,i61Si{rDvQS<Eu=8oZAiMTQj?{~XH7w(7<Zdpi5;_etxH=vO+d8#f&bx@)EagT5g7jHsP/>9|}PD?RM}93$l{$YhCiF_6o8KrkW<HefH658!xp(jNTg6Rl5dAz/@{>O),uye4*:e^|ti*(Pn95i)+&]ZC6:O}W9hc<GgTA`P7;V:vm[Z7t1w*jD6loq|tt=.!Tp}|?{|wG~N/aw$lG*JH0gJ|,;OopG./T}#V,+)6=rA&"Wu2Uv<w_t0_Bf>]Ch%jfrER{p;v}Gi24<#sMtJ#2Om#04_Fz}fZwL+vA(t3D6)U.986*i+#14|BBH9l_r~JRSz1tTwg4*M4R163D)SN]gqg?nLZ`l_y9Are]a;5|!TLWbVnRSd9f:g"bQcFmuUTW%afwUf5b7C>Na=.z(.J+$BMy,KpuK[Y|Tbe}`Q>(Nt("^9)Hz9kHtb[OpmAHMI6v(dsMt!f$Lk0!OM>.|K|P9Z#uJImg=Q;]%,kEnFxYPzJnpF`fRu{)n#.0=B$kl18lpWMGhxQ]1/(m[w9#(9:gYI46K@#cA%6u/08q4vn=j?HGOEYM0?FTAypqBajs[z`k@xwNNsLQI$Yye@7#U/Y@Pdt.lLFJHI5r0aSny(qi8kehBG2_]ZZ+:qIw@%:~$$im}Mf<&E|::PF{lh0?ONpgJ^8B[XJ9}C%ci*Sb{}C^!^8&S2T:E$!V4B/)Hz:23j,Q99w#t;Dwc^)v[d"fZL@]UC{<1Jvie_Vd1Qh|U_xk$Hs}8(Fu+hx+]Tjhv+**28JI>Qz%kH~Q8<S1x/]/$NC*U))6%qt&CCsv,sCfVq*C.)@)HV{!^y=M@IFXUxDL40oZncFQ+ul>{2n@<Bm4_Mgs~lPusL"KuKtB}$_>I3@f#<bt4k~?yE:Hfs5*@r;Imzy>2uaYJD<7iG}:j`Q8Ab3PpqKAo6.[~=?aF"75SIl*9jY1:!Gal~N8l)&J;vf^{YBgziHz#z}pfLGI(X]Y+*8Y<jS*23(yos?vMJ0$G7t|$5v(di1[!m^zD)pz{/!+_qSU.%W0=CkZxKaReyeerz9P}}5~/aulWrO,3xV/N[N=WGgSmG1H,emUF.&J(GbkUQD0Qrt,|697Jr)ESIAOuj=*1Cj)!YS<}bO[tp/yIjU++z18^W?W{NxkqK;:UalLQzCoMWFn~aYW%yX<7@r0d7|%0*NkI4wC)(bX5A*mXMPolzEW+QzGzE`1Eiep?fUvEYa|*D}O,S$L~JIS>D7Ee%@rO$7pp8%&juAIVdO/XHR(0_E6o!2xE=rZ$rFH&Q?)=vJ?^:8P|R_9f6~IdNzt+~O[LxT5q}jxt6Up>vv_"<nt&Pt9JDcy;SsH.W>6RG;5{+`@=0)%no}HQ?}i*K<Meir/Efe/CbsU?;ig(n!"q8Kq"`ubZ0FU;K`59P_5Q9R$H#"VV77jDq|Ifu]*o(z1zLU,VRt`/(N2IJtjj<G2_Rd1uhHo*+WL).]:SC/KFbJ),Rdz%>!bsi:U0=mI;jGa)}xn)nN/ne&#@m*9y:DkjFixD2+!F^VkB1F|h|FxM"$&9msugSw|ZD})A3QZj&S7=vDV(Lk_%,=t%nrY)Q>Zho3Ipu#SvD3Kw(CcB@6;=;qJ^3eOuL<Y+qIg7@0?DdMuh<6(R?;6;VpwctN#8xQyNx&6W[Fq]=)iJT73]nm]_/1oM=N6Ove3:OM%Jv)pg.k%l1?c0d<U^45Jwo|#P]879y|[gr[2gr%1xk7[D9(&VCt6?1^Crvb+zyxO0H:RQz*@Im|Go&O!!f@_}!=1:10N/YfW~sb_T`[ul?XvOuJPeKZrAj*rM#XUaqlT[5IF&oRGuMM@G~!*bKuYRyAsr}6=!u6}w|GL1s(AoMh5_73P9=8Hv}D^idNWW32Ih2i=zKAbM?43x4u%Yb2XK9jo<Bx+Y}hRj=A*YeCvcFXXvy|[9/g3GncQc0{]0W"*cG7LJ%=:h;zz(E$@O^drR>71?rd[fa~W[_J.%k!BcoE/monBRsrdC?.0v`ko*E@</[GVH?LOMYKv?j&@$?xJGMh&V1~XP8X<pK18b&(8m`RYUC5BAH,#rc<IU*vtC$VC^=)<)8Lor48^?yGJ:vTjZ0vZ:uD9aiQn^C2i7:$2[4!E1VmL`tq$=U(&jQ+CC2mkNa%,,n]=i^tS^iI1QS31s%V=OC9#gd.z(Rg1gpIF(g^=aEh3hc;#F4,N}y6]`;JRdxFI1)@@!]nIOX.hDlB:X>X[[Kdl?udX[H@Y>2,rwda3#Q})b"*:h@?II<*zT$AMaxLO/&HYm]Ji;%i%,Rr*",TK?fd9aD+t*gtW@IUWy(R3^yHcJbN$I0iR(SN<%zdV9~>,,m{Um@qAf^QF$Yk@S9ef4Ku0|)8=R&!.4v72ytEY3rWb8_@74sEACY&T7j"2Oo";!{G87~jFM8fgeeIXTpd:2d<+&6}!T_Xvvphb`FYPH)~kN7*>!ypl@@zR95DA:e9`:NW9BVWzHpc%w.R#bq:S15[5W=corD7/?G_O?y%[jM|lV_[hSE["r(J`Gp,WjTiX^UL1V+`u3IHFA~GqBbKHt}BmQota8x"mbx4|p2*gWhQ@`5>,^m*[T#5Ztr=:Pr0%)3WV/W)a]pETN(zX~I[2vmU^`7EaEeg]qBMUpeeeC,2_U"piaygfi0yW0XCQd<]p?7_%.W]0vGPcFbKm:W3c`$YeNoS=k3Sltf^OMZ*J+>fc<f;!!jy{rz;nAF{[wiCOcI<yHWgHz7|N~:KBO%O)B`@8D&5z4e_kwP!UaI!0/OKgu3F$0RvGT2D$$/1)gc%riYl$%Rpdx/d5G;,kf}5:$luI$Vz40JI3XR%Xwr1Je@B5j"#?:x/V>.u8Of4#%mpSw8!~is}|vT!Qk9JS/Z_$*iF)Y&y:o.tXP]x^NaJ?IYIL7t,p0UD,f3c/`0gfy{WH*4B6>;D2]Y6+vXA/wm&9XnYW|.&6Uc0AYd<Wc{Y:?RKxVxpH(.t&dBx,Xwiv67]8*E0H7<W`sT?PgpHy<,ivShZGEygvLWKb$*p@99EeWvb6E_kol<G)~n)?D2@C`:3aB&w1p0]X@y6VsIrCu"rI^#uuLjmX0_YbN+Tx6SdCH]|8($Y!fQ>sYbN]U3}xN5!bC_Rcc}t/cH%24h:e?M97(D1iXCA`vy9e<Si5ryx^!;j+kLwLIS0Q"vnt_rCO(NpW>e_P"=f&6%1@>M}o$.KQbCygSjQj5B8|4<^3$XmOnKa1n@:er@+}wCbG#QKOdsQD3QFG)*o5F(2__|z+UQra^n=0#|:IN}i$8XaR_j.tv}+mbGOn(uU9i?0]:2z3DQ[2YV~xC`cc^_eRI~T3ieBmyQ5`*DmD,Ozn%?WK@/n^2G2?`oV_7,09E,ccN<?MSUO|I=(X^1(!!^svR`.?iv[e}X*Dg?PWnNVmS|4I#nRM&Y!CN_x_;`gr||Zm&xv;4G4!Z6i>q1mu6LUC,eFq!#De1]r=O9UUa!3%3kw6uF@RC4A%M|oToEjc{2h55H/<1?JG<sWlzy1uY"j{{nD`1ZAg/;8j$F=]XVp4*B:/aK=kZaeV6D|i;@"=Z2:bq>fz`;jq6_wVGwf&7UPQ*ehv2{YSse#V#uG>>;vsY"<~BB<n2|(5r|t^zrhU6}/WUMD%e#z_=vEL63MisTt,>iL4MEt%O|qqp9Bq.|<+@)_Ue$4fnNwf;Yu0KR"m.ZwCbF#=EjjU1BMkYB|i}Z3@Zmtw"Hop=7MK"mJ+fI,c964fDpd=:gL6henqv`z`/tDrgV}|B`q6|dwhB_`T=O,&K|d*_rBX^anOodRxA[xl73nhKWD4Ve7tD#E?%XWpxvsI=IDl.F*DOfN}3TYpSbm7"gp(?JaNME^0~iXVCKZ2u_F}w&1u=GyBn.#33kdk7p+0r%TVTJ!Jh^#Jb+kM.IG*65?IkbIO7y/Y2OeJrKgH4K):fHkA4_HtwM%Qj=t(WECxWR3^8Nioi;l|zJ7;fIFt@S]C54k2d:7#nSe*IdK=D.JMkAh/h#NCU"C?_rkX`ybETk?*mh=2k*d${jX=I%dvQe3U$%^DuQv7U,d#7<Cu~L;SUiw"Z50H1HI++VS!%viI?cYL6tWEKf?eF#">0tp^dpi}8wwhT.Vax/hcs!@7iG+5X$OHV0Oulz%wY0L|im+HUq8Hb91WtZ[%2s87G)i?cB2l<W_yW[9MS;4cZ_%v4`LV6#>0qaTz^/JpAR/EY{rRHQD.Sb;%?/<$6r4{).1$"B#&_1E(lfti&_!v6@4@fx7/qe%H;QE3DxIJbcncea5sFRC^db)rOgo,ASJppS|T.qq!oU[r@&tN?0BkM(!J`gw*JsGok~!Kxn;r,XQ4^x|%Mz/uc*,=#~)EO3m7@Z,n@*7Cmd5,=N?=mXRD?ZW`cLR.up4NAX?&{p4LmiM*BSUP4CJbwveJP]Npo5tgL[(xnk<*C1w~RbVK>z"*B@Zw/2%>2?jRs%DOUE:XJs,X"k?:55t|zvB:]4WZY)MO8"JtYOBd`[{$GxPUVxT[VX7_"_?mbT_[YMGoO[=7y%?&#:?=hChq4%6JuCcB=[uN)w;f@lDZ!U/7~gXU)Y3o(aZ?baG8MP3TgiZe&S:,CJ)_%Fu4*B+BriP#0nzY^HHl>Uog]m{`&IO9DFn0FC#o#JtaQ[.tnCJ5g#~1DQ?ol&VV)SW$n5FTk]`6Jm$!!t5vf.*2Q.#Ua7Bg!f*63me>h9KQ7b4%Vgy&flNn%lVL(%3:]Xk^icFRu$|Sw#|<K<AuNOu"2OH{0,,K^["1:dI?B4yUKpU]m:;66ba3^3n|>GK`"e>ywB:`j+[p%>Ujdv)AO/ICv@82~INdDm?>Dg_KhLY&v3tuZCzELJWSsk^O$`PGl4+eeaitDhP=298v"aQYNZ~|`T*e=F%{3qBIF,;2/4l)|ztb]v:a~|M_]:4M4gs?W39:7tXOV/552o}$YRqxn5pv^*{?E;mc+>g3U{?`tb:;r;#Dx9D&xH>&*E&L8=GA{u]*wC!miT]u1lMD(HWA*l`pl#TA;J"3*mC"<KDWL98mG:wa$ho#n5j2FP6Owz{KD.p01|]cWga$y=EJe{CB]NYHEvq%?1NTcH>&$7>F(`/6?z~+q2t3a.ehH,|3MR_Y6^R;Gym^k$?UyI($>{B0{d(*PIQ*z:]G1%bxH>UUOs$H1:$OJb}~A@>IsJa3B(JchpBr)cg#Na(C5$5S5Jp<Rw/1hlg<P};%s@5fad!`{dS^pgkzMy)Sd8&{AMddd.z.*]*@6;{l&9>n%F2RD]*oW>bEk]6JJNg3Z>_J)]S{Wu&foNlV{W&t@WLL@8{|W4&]G{{4$(}WnBtsugoY%dku6`LHs41x>W6>cFMhuV7UgdQ,q}sHe1J*x5JzC{bq&@?dH]":5$i94"o!lFRB6BQotTM3CL%"SQpf!?a9814c{(~M0_~Vqc}]axK:EwiQj[V]2`?7f?NThf!+#{M|Deev^=L9>6i8ZP}[I43tsQEVQmu:;&uRh7M>43Ocu$@e`H4T8tb[E>#Ox*t@3T<B|$hopd"+sjXVwZkU;&3{n+}jaT"&1#qDm.#0$Fm.c@9l)Agy&8yIcN}.9|i)sS~c:8z1z>zRth>n!zHM<jy?PWu3Zy~+Zo}g;Dqa,9Jkxh:e?9OoQMSW>khrHY]w/U#M7]UU4IU6,mb"fp7UlzWIJe1)Heq`aa.2#b+RD,Jj,,2l|hT1FhdCIXBXd48A0MRX0y[v"g*~nxx~0]L(o>8@R[s_M{)3FKlbGft^pim:TnI}6m}q[&~}m]ved^3~;J,t,zFRO}NnV*K:7x*3vSH}s&h<|$F{;:tOPqT#>jEsc:;/J:"qf+"z#0;<bHl#N#^|,?{0r})Y!;_aBfzx%s{`3Pc15_P`?aoVL^nMiLu9Nbj.=Ht%C;%s^x+sCpA;>$:)2CgLB_9l0PpI2_8yX19+S8SF=&o7)V5<7)bU=QtkLRG2J~"]fycFUt0f*{gVcWGu$j~AOZLkEBF3d:QLI(0)d$ijl0^|0]^%0vAV9p?_BkUGGBb65@t>)F?N^Um*+Fm.Rt7J![M=2=|*25Pl?[<Ws*?^whKsm0Qoe:|kt>ST&go,Vz(j8nbnRZ)^HEc@R,F2vSaN2V"&s%8SMTZ,x9)eDhY[~Qr+="l7f,t{Z*k#NT^k6ZNDge}XhIa`d4IEC]rV(T(^f^ZO[jCOJa@C)LRxF{1koVeSX+rH/*`1?HrY.+IS[OBgg4~wsc*Ln4a1XR!Y{TD[7H;rOcN)rg6a[KxZJ.R[uO[1>R(mRvDde)h[OJd*Bku*$,5E11%Zftdz~fL)x_bpNe<1jX,uxDp0m5&dKbF/4PUF2^n7FjeXqwX1x55Z|/z>+<*jao<IZ2M!FZ}o7K?^C&$|[{F4iU[Uk_(Xj~E_y_vmtcsaEpV8BlONrswMz}Vlzy|jmLFLRV~)>yvqebWu4e+R5]1@L,K:9d(*NR.W#Sf/jhHW84bmL_cy6@3]}$^^T,t,vQZWCq]GVsiPcI#/t>vCipQiW`sV!K!Kk)ZMUI%O#hKKd2;#04.]!gmJ8y:$LgP6{G"*>vfMO,eu!Uwyp&g3#!0QX++H6zZN3hB(i{C=&]|04anpEt>rt/rT=x>r$%,Hm>ch7%dFrpU*Mx}5HTT=&5)K/SPUiG1J9qCg}5PbKZY^0=[I/X^=[0:?2I6T*o/h%w.op{LO2wDHn_1^`>X]r?.:@dFU)aVb>bZSp+$mHbp]/_tg/#&r$eAWYr@wWutq.14vxJFY[c:04":._fZ316YzU(m:SM"qijU]@1!!J/ba^Fu&[Ur%VEMq"OIZJhOyK@!=OCN|3m[hN8)eVF0gu9X3<7[;|p6Ya0GQ!5+06KeMGfKOqUIaGs@ZR}x[GDBWuG{w3b=ND;9Z0JN0xzB+wf!lYjcxCcCC]G4Cm*SbZeJDKNv0>Y3vU_$CE*oMWy$lej9W#u+,,tA;~KEJ#c~GXiz6Y{~0Z{[IxtHGv&T{~0vk75*!MWjn!I!qDAJ3=gl`^F*joZm=Sp9,Ho*Or`(guuEwAVMqos9`Io6#+i5Bk:r[&qF=^7%duQX8Il|+q`Y@)]k2ratQoi3v/%(qD/u~rSNgIs#KvbBbf*tSO,p"Fp)MPTz#+?FjJ_,:lb>Fh4wn.:~0^ad@:*c71u!McKD{"gn1JCCmT2j(sQk?#9#+Zd3oazukl:Dat+_v*[,roV+`3vMdB|vJ+$O,aoPI}TUN#0J}}im}j!l8K=SfGS]Lnhs]r_:wRe0;+Q$Xw?kH`E@vLmLxB7#K9(];fj?}.<REb5IsKq%^sU8IWyRZbfZdGRuj?bJS4c>Na:=80b!7zUPKn4%E=Hz^5}mI:2?HTx;|@6T7MnCG]jxSDUO%O=jpc$B@9l#@{8lVM60UAdAU8Kj[g^,/]?d@%`$+crKMFMkz#ZGQ$kQ9/|DY>pvTJ8d|r77d=o<Cm=03[uCBiwoqfG?+6xGEmqr,uq$!ghKS"<|0~EUnEuBX1=:TjD4^J=7.v@=b7pdHO?Yi$@qHDq:1tE8*BiIDrQZ?Kpm%UsoR{Bf*)a,dxD8Zy9Kz/u~Ad|Bt0C;rpO*|LBEN:$~!g}?AzqsUWYqu:y/Q#*Ba*2}J|Z"|)Q4`T&D)hGHCMHN2d8"v5TtXAlElOlIu@r=)2+!tPMv1gT(P%n=%/xP/YgY$z9Xd}ghG`ULKZ`uX<}[&}E7|oFB,&krEN&.W_O[<>vF$ot#tWR*LpKT_QXZm>?KCg^rfn?eue2~QV&>kMx)vIuP)+_=$Zd(j#,|lCbV6TOuI_J3jWRroQ?2WrKAHD$yKzPqKk|ycqKfseJt]mf/7*+b9Y,O^/[B;"[?@Rg7F11SGyMKmYJyXMX(Hb_bt%`La@5iewzH&:yK^OW6YV5o+3k[wO6_U}Q}):1rD4X;XO,<xV|*$UFu>e=%B_CgdPyJv)?fCN,]Tc#*evwC8M`[j[QBN|,84I0oO#S`LZt,Ripr.461Y{E)Dm.B!7d$^1B(yG>JV_4$W.>M7o_Z|SaDn{CTP<8pFp*bvhV*%wNgG]WS?{Ipq5r<1QchcKRh4TXFvoX?5:g`|+d>Yi,4Lqu40Uz{F2?,kWr:%>mG+YfA0Gsu2%Krfvy">RHu)Q[Dh<HL;A(HLzCyXQRNvy_fmMJ:L%2SsjvnX{GXi8P>jePZYvD4L6u:+6_2S(D?L/<gYnTptICUnsA]vP)5XTf$^..V4l2zOAq,,F2K|k>yr#QJv|AP&dNm>8#fjL|c_9/[)`LDLg^[f582a!{XG3lLR=aukeFr>fD&V+uTEc/yX];^UK7d8dS.WT4@LItAzMF}]<DQB%pRu)$J4`_#tpo=x>skwY?%^AZgD5m>(fW+gHi^p8*$I=iHHkqTP"&L?,$dgf_}kGEr<aq|r_(uEG>c|N!5_V:)r`CU+NOZxf~6h@FN&xCH@Xt^%HO/xAk.Qu>6rgQBqcPi)T)3Y(I|,VQ^AOVC,IE7*F4y*|EZ=W_~J;Mr759O.$"3R4WG/euH<V|=rwD*ecI;rj+eOjo4WD_|,EL]5p7vfou=2NE,["*DS3MM@{n9t#V.Y,cw0yL5i)M+zZXx,rB3l?}VCh+,P}x(q>a~JQD*9iQOq.@.y:+K`DH<{)D7hIp"F#5`]vrEB,zvjg%vSE`zupZvF+pGB`aY@Wj:j3y{N/QOz/Ix5~aq8Q9[3zrs9tZxF,{l`c0;;h(g&;01!Eo5Wy<cv4`Ce4dV)HK^B>@XlpQ]2{0e*3RQ8a^3R=`Ph>>WjzY)z":a!N/rk8%7cZ?XaG_Lp2`wcm}7hi$Lo(TNc7P/p_YCK8xL$IT;0G2OW1)/qEuPmqj%nksliPDP^=K!v7}!)<puP<z|r)"Vm4k;i^HMR"mV&Z1yhV%UFIZMR:2J:0Ak/VDY+VBv]c"];uTNj}h3T.n7kBSDX}Ujat)N5%O<tn>m!AQ`*>Wv1^dl/+HtBCzLi(F$GZ?0tdMb1_B]nG/4Y?^Z2Ny0GKuf!&5vXyU)"VczWs0#kaBt|Z2MF)Me)o?Lm]H0W:F<q?ebHZ?~u_X,QGFYL>B[Wf/1w|L9[>CcSy>q!4fNRs}3^q]97|rx]Hhr,,9CnIV#_(!My|rJ&}Tzx$uyAMq[Ku_EX^A[{YPob;[iDu@A&<d,lR8I^/[c{E8|<qK}$CX0kwd9*Ewp}&A!D,(NciqU%0"+.Izq4x&*Kxn<l/|!wU/3P{%STL/jIJ:.&QnYK>t?O/eTQlrFQ^V_ZMr"V>W)M~t"W+dI)I)j+n?oo?{?CId~@rCT}$YF,(bW>7A8/aDJ0Y13Ys52PXHpJVK:>9="VGd`U`$oxRh4?$~NDNZrLL(=R8CkSm_*vDWK;X%@BD6K3/gv7pe1%ccUXP)Dr1V&Sb#qh.7%#fJUF"Bzd[`YDH{VaDzEM6BA~|WSi9qf[[CP]3R.Dsj}Rh0l7c`_7P"+@UXJ0,x$v+@9fFc?wXW#6DQ[)m[(m;j%n=/h;788@}dgc3werkT!Ni;<5g:Ervh$7#]CfFrrd!l18D7N{T^7d3wwPC8*;*ug$xUu0A:@d&Rd0Gcc3IW:1&!mUDOAq]7`DDYM06^Dn.E1wl"i]>f=Jsq2I}uO|#I=iQy9rI[l2l2":T.T.#EB&[+&!G=yPX|x&efsO3<Hg9!A.M{z`(XEB2XUseb&>3?Uc|BYow[D[3[z}T&<K3naxxBs:D}W]F63#BT"AC<.ihx(82[^`,$(}mqzMuWe$nzj.KU"_$^=PlFRH"mS}o,h5]+fN]2pFNU7wdkoj%PsNA#)3JwjqG60gU#o*<S>k{aASm_!YHU2k%5.*To*x};(;z!(^|7YIDsuIo)w,2fD5,d&?lz!F7g*Kz>zJT;GyvRU~`cpG>{~0z8fJU=#?>VT,#YhXJpAJ8PIa>H5Im`ef<!DE!0zbXjSsE$>BRS{kwGP#zuO0ZTFZQnPk[w@wn7IY$G<Xqt_";i(^C0W2rix}YMg3`McX@M+u.$^0{MPN>JiI4Z6nm`zxF$mH1=/d786d/Evjza4PoKD]wj|u%@i!$|z}AZ6!Z6@+:U|g=0)k"Eu>H&^4.$(1F[e};%{%M$x~%^M*hTOodx{ylowy#D^x9Vg,C4<U`HDGP:fte}DI^ATI|/kiWpo7M:^mM,oQgS.k6B6pSi.u/IZOJv8[dKkQu$?(m}149bR>JcXT%^gY9WSH1lQ=Hbax`%:E%nym|;_/K)Sbmbd4zDv#4iM(@4_hbHzhpM}=_:w[uc]d9gVg9fWNLM:m`8"4|G>?tV%Y2=ijWapgHD1?6Yrf]?PioIGOEO|*0*3"g*ij=a3OZ?SxkW/S1=2hnBO`9Y~vDKYiTzdz,nUDz=GO.9y5}uh@#F=w};MTOc.DoB*J[ta}qSV`Dm+_8ux7q}}g{d0>m?m?n>>B?(V}XGRc`LO(2TAGL?pL=E<?m.4Tlad_qA[{3ykZUHE)/qw);{JsUlzHIuvn&[Tv`B{hMo<CHEDnH7CGJDvnYF0BJDnH:2VJJi2n>(wQ0>x@iLW0.?x,tTYD4!4cr5=%<Q(H{($QL(QB:?^%bRZ*oIe@hrSl^ouyiw]dVFmh)MiI7~pBzMm.WH]A2=v}yydUa3v7Fd3WAoB%.IT9.]oqH|}YBN[BWo$`e$=FG<fTN)Wzqi9KsY_*,$[|`>TYc91<mmu4l=j8EMJYzl2.xIm.nd#%SwiG=&lDKoIL!%v[9swB|RdqUU.t(=bUj@K/#[%_H`n?bH0>1>?)s!e4NQl*]Z/^nHUY88;tP2SPUqT_lwH!b18e&4">gOn:,LCG%rWD.<A`}}`5SBD#S7yj5,FBznO(Ncfms!r/w_xkYl;jxt.^kVcxI%k[E|<hJ,mV.VftD&H%kQ@wN=L97b0Ry}w,zFY>MZysk}:xd^)Pta9d_f!<O<"8Tay~Fh@yv1RPwsIf^Yev?NARs}ASVGw;O[}Ii|K3>@e.VR0>P8+u+b.rnDBHOjt4k?4Sx_t:S]@D|Y8*Ushy&_o;aVO&4VxAqI_2m>:CZV6++8o~ywAq7d1)NJfcxWU(Q5<KDlM*2NFH5G9uya3([(?p|B(?m.4YnF|&Adm.6rNZ+]JO}SO&6BQL[@D.xh2YLIQsO{TW"tM%JSr<??(4<$2~nx=jKGXDwD~rlY]:qur$o/F"{OgE~4KvZY4^n.W6B0?kSc)u2xhyOpfb_w?~mDhLn`ucG]U0&=TR8;`$"rxq|vc#bgvD&8HbF[(b>gTLq>,?)!gg>!x51>L:MvsA/^^Dw@m.Ga%1.av~5X[r_(:$@j!cs_Bc;mHv"C/n+`0YO&px)p{^lSq4*B%<RwCMlTS}_oMPeC<9$$%+6ps=m>Kjk;%/F_AZkgLZhmf<3g]YvwwDGE5v@UdNSQ*2C/R1XKy=m5!p$gU7g0j[&p9Q?Sbim.vv@O"aWmA%:#`,%jehwa)~7[/sY$Uy`$5+AcDZz0hx=MvZd*xl]zq7^!rn(g<*KptH13i[>[2]AR*2L+fa+Q5=Pme;|`HK=EWn2Q8dq=7msQbZEkNG/Ji,y>tYz?$Qb$#r~@d=$wTEKaA`sZ%=qKvPr`AHzB>TkoCnQ/;U"DhJ1++V6j5<jJHv:TzU({nr|3vHJ=q6<dPxJp1[{U?JQERD!nxQQd)fcOV*Q`ghMOA#!HGX~P/Sghc&2P"d<^:Qbxs|r:Xs#ttZ"uP6>M}EKu=q4k:{c{N0yd4I/uzgVZ_vBL#Z:(GZq==U@EN%dCj.%?ISyr*8aW9:Z4./0Bf&4W@PxW&n^HL(I#%efV~V"y{!OiGwV+kE]FKoyx9&8Q5{/?&r__V)%e[&(^@+RTeOwjW6yL6uQGe)"a~jcxf/B#XGv2o==e1Ko$Mi,V4$;d;`KxjR6B/se)m/Y=uM>rf_VeT53yH*bsE5u=dsUIzbs/]$EVVh?=!I!tvi`0~=jYK]ijxD:1x1Z:ns%A@M`an$qN~N4_~WF5KGmob$Q;~JgrZ!r%f/c|U2`>;.$=~T0VaJSW4=T8M96%rs1m#|1p|KI({gJeoP*{D!Z9I(:8)[:p*w?v.HbxDx(0smA?)$BKeCU(8<Y]?agS6B)maO&S?L91vjt2/XMiVal^~2|y]]fMWyL#)x3v,H+poij|d/~#L:Sb4ZWHx)Q3#aIg?p|ht/Xs/:)#,xkzT{PUWy=HzZw*bcw*|wA3FHq8waq8Cv.n$6r]~eCrC:k=6,Fa!C2n?e$Kc!,%l,lx|a9<P@0ck)spOftQy7SYz.7`gwj/!H5[Dhq|q_g,KJ2nvm~wJ8x]tLK^LQpN:!`=79K:CE,BvaIYXoWEsV;.R}PH/s$OCbWcq}zhdFxZ}4;N.sN>3CRkMx?Uo+hTKa[N2RgT5{Euaox@mkhx|m#H9c4/gQqu*RGwqngI0>DMB$AXNWz)z<<PRt8i:Omm~ZcY/GdkS^fjl2=o<Ct+Qc5W%lxG40wN2x"&7$axp}J=[>*Cn.k4&XiC>`5MZtas|H"&y38W$mb/LF,u_$d8K:1iixBOxa@`G0+K4_3[3BwFoanj(_!)An6g#F:2j%M9]%q4ePh">pK]@)|EV!rFwF/S2yyu2Y8%&Oo?H<B_b>!UP%Qgk0dq5S@I9Yo"zR3v;&a=_,ao>LBtLK]r:416uLxd)^@KzeuEGjO5txOEwWKdnHQbGuMHu$9C@eeBX]>sE;y14PwroFt;%G)],&~6Ch?khJL!bh"L}8fNI#cT:2T~e?V;Ly0;<4GZ1{Oll5^SnS3a+Sb2!.p$VN4z94+Z9at0i0rgp;_gz`[8Cq$59E}Z4%*=B_!QIb!:%/o)`?1t)P~yhG!WsAXbMb2l<;Z]7[WP}SV$6%^l$f}+F"mwcu9qTR+Vx%!(q2gb|f>=isN[Z%psC"}*Ct}*o5Lh:;&C#ziuhp_iiTq/EAqmp5H=1]0mjH).,zkw|5*HBbD~2B|/r2!&fl7Jq!S=@gQ+_x8*H|`a90ZJ<:8E<:xI#K<FT>yr?SR3>:n^L9Y[%cl>z}f/+&&vt]3x?_p)Z*!$;dysJ[YUShKL3&LhlaN[YULm`?3"ypIns&B4;S86;wyw%Ofx_n0a40O7eJM!sqfXUzo,]Me3EX$`f<`$5e`!x"uCI>c(87|PuJ)x>#dl#%^OZW{i![y`i7|P!JX.`i^M9T2IZ>FMVQ:xGFDT{Fv_K5UbM^w8gyQ7d;WQd<a>Vph2k9H8(CR=o)1`!u{iijOhCq9kD`@UxdVmuu`)z/vkvcDX(b$p4=b>jlov"2%#/TijqTK[}:fbcxEqYh9S.=xr_7y%I|vl`mFoHRw&$BI%9v8iR^C?@&Dn~=B`CO%D=wR7tnw@F;r=`T|7[fJOp41=ADtHH@wqc5}FvV?<y43c=K4@T:UndF(0=w5"BZ"%:@i]5UTM9!Pa;^Wl6tkC#*>(#k1eU_x6kB[}%`^$Zor(_7g2LiOf03nh4s^:M=n<F47uGH4XoY4M?.?%+1gGx9y|L|!`K=n+#CQIB,_VnZ95Dn}o|hJgieOaa[1Wl"$twFq.0o/vEM_s<x~BF3Wv*e0FT]C49=Z>uqJ?*si#fz[Gm]Y8?*cdy`D89.gyR|sMEt7_/S}l3yXqysmCZW1`W}9qKT}=U(xPKqWT?}dF(^uEH7(]>~)F87JXW8^*cd$%>nF<Msze{PuW|]%?MdlmJ#G<O[p?9rb3HY2T?%17M9#87+@i187+yo_ylfCo09Kz}d)^$s,U~n<xWNRrX&a?:xn]*&1Ul:p<L(Iof(?GVk/p@@f<~$E0f{*|L%d1rYV#,@ypq7@&2yZGeKe}dn(pNyE(=&7lj#"ud}E:(U/ebI}oiPtKvhs7r3/xHg/kNn{SomPBL},pQlWTn:,=M&#Gu6Xo_(ySgdf9B4k9?=f[P;S@I2l2F2MEwWg`K?o/J>F<+^LrY{Xq!?nf*tn`$8JZ~<{7Kohb;8I`(Xb|c+#E0P^MJ7G#YlyhXL7y|Z1G1B9pAWNa#5;3Za4NQdzG&?/0$*BD*F)|_w1?wwgNeu;,/U|d&s$HUF91~<Je32:>,y40Q8`>d/,5:BqvjGoCN_(];#"eg)|Zj8/)zF@}wv$jaI~Oso,/wF_8gU_w3<b!l3k(D(OLJ5=QI?,y@KDnJ*ZB|$*q?u=@@=t,F86&oQ]Fw}Os<Lr{gv0$8.zs{=7b{Ebb#e2&e6eQ2p|0=%.}#^w>"r+x+C7_;d!~uj:EpU`/d|i=Rs]!_LvCIWN_=c[)cfwh^>L@bCIW*1qQyh^>EH.`@ow`PBB:Le&0QSvTt%yn&P87t63BIPzGV9i]mY`7S;wO;&iVN=h&NX"nKjCMnT[0V/<rTzLN*r[PlzqPwTm.R1D8]2uL^/[7_|SbsnZq,1Ru0gT!n1u#jZmpETXelqMHS5;7*ZQB0gXTzNBD}0:ER?E:vVTU.q0x]0w,ZbS?{qs:srlw$=%nfro8[o0TM+LFb/O=ujm%IlUs$)AHj$N>z6ewywu3Tji$Ljb^(]?jrd_L(gW])]NZIZ:6|MtCp^iQ8,f4?oyU0jBg/@25Ej1Hd,}X45bu1H:w(Gu/:c?}VVp/N(Vo2]RY+BsV[bp)A4AO9u@u9@X{Rp6umm@Uao}hJR5zsH60AN3HIJ*JV43uwUudKRS^1nq,9e,t)Curi{|KA_9gnaJkWri6G!E@0^*8^$0_BkL:%3);a1TZ|MDn[~iT7@TqA~m2:>D!Tt)/teXA@E:1Drmu1%mei0qN5u|R?:Ww=0!Rw~FJQ^(DXE/)o@EZ>&41<6BaN}L9>=:c0XpQQLT>Bg$jK}z`$:9];65u+U?:)+=0!R<Nw:t:M,9DH{{aA]nj{RoPng>Jp@y^ykW=]6N|)!w^z3$:1Uq>ujU~WX":"&:3.]wXh!7gNZ?]]>u=IwreQ)RkzGoxG0=0v=Wquey7"dysRp$O{:<?&05K+9E}{8}x~%"Y]4+r~QJ3!g!l|2[%.]TcZ]F~n,)=U]q03TN)~<)^.W`%gya8?)PZk1!aVSO|n2R+3%Vg"AoPn$mBTkW=SH%^g.WzldLpSw`=c&.}GO#;UWFe]UM+IlJy=$9ab.fdJsT_,&mF#YF3MmEMgSn`9N#zk@FNv.J,+cH&we^gJ+F=b2w>[_O%p&P%jYk"A`rCBhJYO!b.4/1T9*wN8!3_J<_v/97,BEVY1^j$8r%^(L;kTP3T$EA(g#3R2w"S0iAJt^eM]G/NuivO:?_1FEm.rg_Uhn<./;8@d&x*XsRA4_3R"=tc_YtKJRmk8[Xs#QuE,[a|ixQTA`fyM_I(~X=j7+/qG1SB0rv|2R~RYkCq~@nEA|v]9=B|#no`@oDUnVnMx9%x[g@*+xVotB({*}rT(iAsB`dDH)a2)+dcwOM@@hig|zjvvq`65f4_Ht)bgI=Wb<oI1_MPQKXmvzcO[x%=[je&z^X)FhUs%:IrhM0jd9kAyQ=0`w90Ft@}f}.]Fm`m.L]>)^$RU~VjlrVU[Yv7_YI%vzCREqs/H[$C|D3kynZquO3LHvZV,,}lrxlhTM"^Cah$1Bea^9U6XkcD$B[ZWhyXI6]>.z"}00+")YjND0[}x`3L},[&!xqz=y8u&gF3T,N@`y7BoQra^H5aII4_iJUgR0~=fUj/ZaWa1?bUNx>nA`21JQbCE]`X7_>f;8b!PMMTZ4z0J#B&=ihx8).klQ<:cMXi[~:&T&4xCM65;<V%vq.)mV({^)]p9jZt82}Fvr[Lr7E>ztA{ZQaZSk)B@2Ayo=$d>bj7</EZuVm.mL?m/x|dYaR]#t>f{S);?%I5(8us#hPUMjkqD24!S(U$j(*vve/p7TbZ$YyfyX*9&3#ncF+Lk$S(/n,!xvazZfN.8<+;B`c}p>#3VJPcQkjW,(Fg[WL:2hLmiByB].SUra+r|kp^/G):7{sgkqD2PwHc}a#l:rlBjq*)o#"$vqyXs_C/NKtTqMUGUhBF:478%9lzyw%e63i}wEFh_eyAFFU[rC~Zy=HHR^E`xvT.r_CFkJqu3Np&]n#&SY]kZT}D)^Is#5ux[tdY[w*v.C?(j>!P3k~v::EO._,iAw=p0B9)w/ot&vL&Y?BnLRk2,z@Ui$vI2Ks}a)RfnuVyHQqB|*YNODI3aL*RdjLl&^nj%=,uD{{hL(zC/|{hAsL@Q;ozJ8Y5][Qs&%o|k:=LK7=$fkY^_`;%O.g{1*VA_|VQh%g4SX}9B{:5+c);wzJuhfOX&I[=4T)m_US?UFu>|$5xIL[R|$Q/AVE%Pc"$CKHvlhMpMR4C`=c^5DU%&wE138I!/^tN1yj2/H/L|mi8DPh}gK2XN!q&kJ;*l/,]8MX~?2TQvH1Je5iBUC67p`+*PoJj:;a[Q]$iJqP_0Vkl!vk9_?]*Y+&J:PM=Fud]`0.[T5g;s%)T`N~T]aQw^3C{sc;KI%rUo;T]^68b6myGu1kjS{9bT7Hf1>KUHPi!d{^fvz|uQvt,Ud9YT+2UodwPoKWiF)%*ropw_Dbw9akxu)NP.PNma[1d,x?6K68KA3pciF.#(^s>^GH5W+&J:#iIs7$:F:l:H]7jUj4mKQLxhc_PpXD~FI38SaL8*i%8]ah!.Oq9KQ5H@+>QDWKQ<Hem[xx1)Rbb)%9mpZ.1W#7wWg!]%_wmn4qi$Jl>Ps2E]r*q`UgX1?c20I`pNh+<OON&/(&P<E`"4>9"(?GoSo=w$?OEN?X=cMo90sK,6||3;rUbuHe}&GJ:*5]58Ul<po]U_@M%[RQl]UXc,w@PXYSh}:fyt0V_1%kiF#Je!7hFK^%sAb0b/Gy`jQhPO^z^%/ckKNJ8~O3]Od3]C(Pa,xFYf:}_,1r}c6diE{ZK)d1f#>zids:jV;9Ua,6}0v7a$P7,Kqsk_D>Q],@7"WSLC&]mDEz7(@mY#+H1d+0u|=}3z73~Z^57=Kl:F80V46^1a]p*?b^u"q^/x2)QM!=[Lj(b>Ke,s*G}fel5K#p*@w)HT$UvwPe.*H5O60wPl^vV}:^g.xKZ3pD*/#7%Q5,/MdtUkl1Freyo"<+d#ewF/)!!$%QP:etlN=1m^6tm0lGDH!:iQR{3vTvF:L>5k)e^O0w)jxs!1n)/O.K4,{C<{(&G:/7h72~Nb)49FcBQgr!31N(:f>m1IsH#NEQ=1s/wU?:lU6Sb^Y0:^txIJZECn~UF!O`"*unEo=3;FGZ7|JYz2c;>P^?E)urC|>w{L?^2XyYoWJPc>gaV(X%Q8=Jqza&IZoEn:&Wxq}z(IIcEmrv%tK$hZ`iVaaxjB,F[`RDv$`,|m$<V!`%@E%@i[H>?he/iN1:`[~/?A/%>)rkR.&K|~n>#JydJpKXlqD@BB&l%oX~!,XP9o,LlyffC?oOP/Y[R(33$p8RqNruQZ2<Q7^C7RqM;Lqp{i8_hA?bJZxUlTcaGXIoC"ms_@$}Jgm<XPsAbrUq7b<u_a:@&|k4ZD]5kizNvhI`Fqv7M72x1EIaa3T%?XP}ghi{FkhAEp*W1zB;$ud]E!WjNQk/].0t`yR.rR!n=rK2CN!K?X&rBe$iq_U929OSoDUK%V}@x~9,d/i,CQ:?kN1d.,xQkOotUJYg}}qIO+^1=fk~KzZR8}?!WE%8F"n4!bSpDRSRSu$(WaQad:o4TCMR1;OVuZ+]*MYB|ew;DZz%WT@5.F2fOMVuq1|$I$#Y6AU3XE_{c2w_J)"MRfx>6o}!@T@sv#(1Zn|7r:L*"[AbYZVv|t8%mM<EMaz$WA=*jxy}/Uo!C%wr8j.Qw;zD{JhMu,V9M1,iDap.d}mz{Q})EL1mFIp4/2U*0v|h*eY@+Pm5F$7d%nF1oIW~=BP<12+g_*@y^]UKT[e$kvggqSf"0z,Lq0,(iHu6,h|gq|oT.zF5fnf%"`n=j>!OYz.y$s)9h.PM!Tm|Pq,qjyP__poTPE$w^4whEce,k`HTPmK9^?S]H&L@}}#K_uE|oHs{T{2a:g$xW_5uzrtn`kjsQhy"CaF}hGf:}si.j7vn+9hPnNd!XnoLRK1Cv+9$K`(}uDW7h%fZ(<q|Xaq!)0N8U>q$uI<~Dm,.%rG*_loX!<Q@F&nY,0&OpH2"9:2DRK123t_i`y#^r,RhNgoSSi90lK3XIUN(2A:;5.s$u(rPS/IoK41y]CKd2[*kN+i%KMFW~jDh&Inm_k!4FOfq9!u2P01}wuVbc}aB9M^Xs"Jd>nDw2Ay1}*SFrNl6>I9Wb#M2LZs0/Cu[~K>5eoh{^O9~fUFVa"f@=O4q$`maDLUWlB%15j:*Kf>i,"rGlhyZPf8e,t(x#!9k^X]<!m&VTO,Q3tbi|?bB+t_2{4caXDX!Um!?y!3a!9.mEOQm;*X|M#|!wrh/YzhoL4r]7e2/^!cx8j=FoCa;e0"yM2=z[=Uv9$8Yo+u1>_~=/&Ws3PGR7m>5Zo0oZ$fcq}le):]r=yNqaWyY|0~L=+8S0QcY*&]ZeQ0heN=yc,|[?LIvN[t@wywKz~R!0ZF4e&+Hfc>[)n@`<e+"zYJB|0Ka>`id)1}9sfM{{B@4r&J[][&hI0c/SWFVX,8g/"2U/,DBkAS$F9>fsM87vj&N+cpSa$^(v0x#B"&K6.@#<y#P%!{[8b9]uTE`ve/uJb_H+oFoDHOwh$3|$$t:RW~ksjsjm~SWsdmYtRTK1t+TNQy[T0|5}Hc{r5_6YT?/I^$]572~IBqy0r_?D&bjqvr5t(PN|qce5Ugm[kHbxQO{959wU=xD)^nohBda8=[j:_g[l7_xZXDC@10AdiuB+bOTvQ0x)gNR1V9?9h;RLYgvxHo"+DqU*UaeVtx!H^grC^DkL=x*1wTiP$wG&}4ItfD^vIt~9mO!44_qMv9#LQs5G*^XcFf5YFUTD8zjIXH$q}IvoK2~IW%3Bz>NO]AUa6HMJr)1}Sh~.nOU}aSw[Gv"CNE{Ljflem+dqNEd+tIaN"5|h/kuzMFq^a%,0,``:.>Ko,c8Me5f}t^XmiMJv/5#xmk(rYKRV_7+?sv2p%/l5/YefGw#7RXB))/j=BEIQA}*yrnE*vX[__Ko@?V6r,QrZfrH=K7rxBMxh:y.Tj"@y;H"w{DBCzr8z+Z|7`7]aQwm>RhFixy9r`KvFSeA_9<HFMqOOZv`Cm|b5.9CB`v*a]FAP#;hs2#usZ9KnZ4J/q|U_[{_y7,Ih6ffkbvREQ:VZx&qT!@9sg[`V,]jHb<thXW*^PUzs%v[Lw$R&){kUN`%v[(C^$x@uA#ywB$v[g5pX$jx]!cC=WirR5bY1#bLRSm.<nmW7Lj$9r>5J+OXi~bJ8L8Jzl*Ww4JTbRB4gw<ro[U9gaxKjSn"OQ<zJAxjGB(Kh&?)#Z4yVC;xBW<;5+6n:i3g(^G4lHuT{C10~kr|]M9I80~UnYW.h:{I}5*_r4swuBPRS/XE_0.~O^jbFC`?fEG@[POBRCixVP1BWN;Gr%R;/JuLC!,=iL{F)D7H$<Vx^2x_#=,&lVOp5}`sl(kcQ>k7]Wvn+5N4ziVAhHP&3?usRqR*3`9_rOW/(WcHubL"|v^rDhAy_*HD*CKF)|fGJaY11gAQzZ!c^e2Lb#DB*X"^X/z,UaAITaR[Q*hBZXYiy9WEfb"@k8ChZG*]K]:$.D!elHjv1<PV2xB()?hpt?hlSXGF"S21RSOi+yNaifGccEIIBJ5HL_G!H1(y+jKBGlnXDB?{Qz9WwJVgA,B)+k3[(igBFgXoq7f2OTXPRzArt@kEK@AIbobHj|eUU.EnATV|eoS6F+u34sVbByt2NVMBfDHbM8FIoh[>C237dr*(yOc@D4wc/S.k3Zt<agT%t~(kDjLSy:>PcL1Y<uB6u7=SC+tBX,yO&CN(HZXoSEHBA),eCXGR&;v;hlBgw~[DyQ3jHEE(x{+XNq"E*C?(,Cy~M5Y@o$fH<hge?pB?WQBy%#nXCD?suOJ)"rIhI%/R(3R+/rb7BDGRjwA7R>u!n`HDA8[GUbB<7)AOR^NPDN)EI6@B<8<CK8t+Uiz>Ja?BMMEx(TIvB8y,U["ATgf7H`tPAmUZFwWsIKojDf7`ElNon"F,#H"KuZL};DKC+|VGO8A`FMIzHDv(kRD6CV]Y<jCFB/hjL5L.>XcRQW5"b9y,U8?No+"*LfP.uX"{X>t1IDK>t_2R;Oi]ys=]KPvUCnDxL0pYYjlVB>Ztc#b#_oA"4hF/y,U,?vnCQD*UEq@Zcm0MUsKDKIJ:70EP0}CJo9*!s)ZpF^Bp&m<KojDdton>W8"CiT@X($drGTfg_Bx`WEH7C5UCy14"SfjbEOGhx[[boUkxFckZZoS8H;X+(L&@wHU)MC"dpf5]_S@t/BtCTeG3t{(GU<iw^O<F0jkG5WOhNlJ>u#n:d?C[Q1B{CCyf=VDcXmkaZ%663WNpJ8HXiryuZR``_G5[E6Sz!%vI{,dwc]*Qs[eUiuVzJ|k;hxW=.j6aSmZ>r+kQ9=QTkhBLm2$!7QaQ}~I_XkaVFt;HJeVt96KekrrG(Obq6AVYJikm#pO,/j^3J,]njy;}S[%g4X.|fRfCL_FdE!j7k|WNWOfIGS$@PiP+@qi(hO$3PH*"hhRi+kg%K]GjI"GSslU_HYMM!RRn$gcZH}mPLLHs3B^iKNlVMXHZ^UUG(ky2Gw<?EufPRv}fm`qg`($,Ud4r(6E6DXgaNzerLH`6rQJX2x/r|ZQA{2+<owvP@[(AOGD<}Tfhz]5:r2RS4Yo`J0>sj9D>uO}i="d[e?0X{QLCSH[>aKm]$fl@WJu)+ro2ZLPgLP1{BWkAeh7A%C<wCH@M9z5:d5_c:B#>%h}kFzmynRyux!x10SRZ+r(llBR;R<!P!~a3&h!I:#xdytLWy)x~_r!G$}<^4wk1#7b6wSm2.P1B@AopX=xJ9A@=0h;AnsmdR+!wM<ufxQzWKD8qrf*dYrd,9+2f%i1(EcL(4I})sk<Yt4M"J*MXV3Z^8EzG6,H$8Gz"lNyfjy>.#0u<ix].;ek5?M;.*^6t_[lPSxqb{a:Fd?1"/aE=Pe*QD_bL2r3Jr5xPl>R[Iq7a9qKyTc=36{yEkkhVZo$kvC;[]%^+ihuAhQOS~Y>Lkdv@mf]x5Ug1U`4?LbRuM2OsPPJBS}/mm1/l[D1j=_j?!+PRW>4ZQ6m^p,@ipHw#XNM|4wDX/+*:}QJ}un?1o%[.mo@B4mfl}bv?nn{1E)?9H<BvnZ:]3R***7QAJtfw?kw0S*ni.LbZ!.%)V=*rC>Zuvxu9xCTus;*^KIj2~K>>FLO`pn6V6Q$:w@mBc&s+lWr6=){6jt`2+7jLh(1o@9Rb:Yg}n"a(5LbH_m`U=vcC+U`NIn>Bh]^qg90Z]_)?11zxW7#y}pa~]>aK~vPRwp~MGN?q02qt~+MOj/z}@14x,"xalMDVw3P6Dw+<Q&s[sX4p~[|Ff3PM$:jUi}HO}!uOYw1tk[R",RieRoX{n];&4,(j5/=E&<jUin!w^3D6B^!8jv7HK5Er%oIm)hi|CHz&Qx*C?*rZeejBaJaNa*6D6lMXJE~_Qt9^jp;),^Ra#pX%d>iFcL9E/@gUK#v=6/D)H!*iwV1yCn?H4_4*vj8n?J!+KGs:qn^_35@F_ekFL"wPX!C$[+aH__40+|)3P@EySXFy|*zE*EdEzM%8KE!x0l24gQ?V?U?D](x/@ZwF1G12_e8;#EPn[aY~3=u()mk!hFPHwE*FdOVSJ:Pc[d.KLC`%l~8_r[0.|AXVmt2>rfo[$9:7~4#]OsQe$I,}O/S9ieSfTx{2)3TstDuJ2z*P]p!.0cq@Pw8:an65Df@2WQ?hXzB@E(`bpMM.F$/@jKS]D]B<*u.b,n1%]q0/:Bi`$WXxDMY&8@4QJYG3V}<V,G:m=6,{qPmUf_Ux#^LM+v||1?oTwdf96tQFL?dXqT=LQ+dx7z^I!V*<cP="_Hdw9keOc=EWgMaO%a[,RK1w%rg^*4tBSB2B.AkAS{n2<|n$)3@%gE<0PL)ZcUu}5}3vhr?~#NIip>Mak.OV`%b82{{U;p%>N^/NX:Iz"nCG1kihpTdzYg38NcPC*_@pyvi>Xo!0?oGe.cYKY0"!G65x1qQ=ihxzO{t;(euvLOo5>S)O0xdMu:ltxJJLuA?(*`1$xNcQC7|!Rk;Z<Uzo3x9"Gb4NZ[7l9&o&!@OTmgoDWef~d:g!1gj^*DyA.AkH=Id$9T^J*^IWXL*oZ1/4{:0;@6P9q[bT{,:FMJ:Dsm`Fdnf0fxh8pz?Kx8D<_`UF{{cA1cawO6#,PH.f`C1e>H8Q6M>$7d,zGln}3OdXpTcGMk!o*^I)W6$a[P$5%CC;lL`R$qhNQZ_#*BBSB?0t)SuY<X;Vg9qU+_g5m44y>L9eVV^Q%]O^mm*p0hMwQz.+)$x;.1P.*Rwz7?fcRsdtV,:2;,{FdebIZ*7/6PSrdB6a7n(eb{<}oX+MMe=|K)=G]3{Vg/nGJvST1m`YbGf@_Xma2B0y#yw>Y3ry3@O{YY*E1EB;2g{L&j!}7FY2iLZNlPa#U!a7,/mu:vU&uJKH{1B6kJu~.|yxJBm8oR&6e{M|yn,8il?%K]t@o}uv+cbu)}<NTe<p<>RZH/JVTT4W1K#W+@ArM;}qu%^g{U[zPJ?34z2DHm.Bh$gD[=*HSO*ST&M001XqIXW#6MTuIp:8J]*u2E~&cv>,ZiPZPt)$&~%KQTPH3ZPB+=1JSPlm&qjQTT<CMiUsQtbzZ{r;LyR<Fth9noh)7Xeh.F#5pbw=lx<`!(:R~+C*;>jaPE#g7x~%hpj1!Swamcaf{X@[/[$9xVW[a1pyfoV_ngF4^w}#56^}kepYeW~u//vqKr@;v"|1FVz~U>TR#=Qo(?pF/yFP)P&o&`%x<_TP~<a@27im.#H[oJ{Oa^j0K1XXe0K|Ru/3XT:IN<(X)#GE(/(@(0Q}0~O5ww{#dQ0*u(t9@QUd9FArMHZ`z*LSm`zj^^k8&]pO`X;e8y<cLh{$^O@gv=fCiqzwXbK60;@Xngce!h9(Dm*I+n<4B[x`~=p0aK8/SoXk<h<cwsATk]sTz"+UIJ1Ff0%o|wGvT:.n_x?&Bv}Z&SY:(eap)D#>NpM"`Mgp,>0q9_AlUZzu.)!"W"|_FFZ,9~Ho??2qcoqj0/)AYK!X|$^FFH@z.4srOu4Lr^`3c,{Id5]H8QO_R,VHNq/p?*trD%ip8Z@Gza57xfdra0vhQbd_?#v~[Ey6w?uE*O5u537^?XRBp:T/YK6?G<5m54XEm8Z<*JTd;l2mGX2kG+59=vZo0%Z*gjl*PHEo^2Sv=B:)!CO~TC03sqO.]|km2r%>X](=K^FBRLN|/7tvyGW#%QHb}VJHN`4i9*$fE/jp;0P:49bw8N:6d@m:NN70llJ8RPr;cWJT8uv"xl|*J0hIYccd5(HoH]cbE<`$H01Lm^c8&_3LvlEMa%M~zu.R>jE`?Zp6+w}IY$!y}pY~Tl!^L|k6+#jhf>R,!nf!Ig5qk+R45cOq`o<~!0sxng1j6QC:l@s%=4wg<~H%tKv,lH~]e_6sBiIqu}naa")g)p%IM2E|CmN>"10Ugv::|@8_X/+8iQi<]O0VM(k1InpI,Lz5Ovml;et885xx2WRobLMkXtZxJ@$[1Ni.OlEP1MpR1AO8?(0bIf#Tc":Tf4M0P0+&lBR#1F$RRIu7j;3C8#dA,*5>T8v:b``&]x*E>kC_pCYDzsV`h3N^+G#n>&!uIm.YT?~~f]k&^"AK7Aec;vPoXh/i2"g>di/y.(9Ui!q0f{rQH^L41w>Ya(U!$B;J+xa&h&rg&i/.dJdT8G$pOi8|h?^vEN?xd7ljX.`B(9bbkTG_.Eq^?&k+y!LCV$cEli#w*SXO>g^:TpaE3L6pcE>iMKNQn&+@jbT0#7yKsACg,yv~qX;_<*K8%S_K@,J_J1b:q{"BB"[h>H.(]H#!<!!BE1]J<u>{iazXh,6Bu`d<d}mS*>d.2,t))L:R^Rb7}YgwJLYqDqBms5L"&bU;Du|Scnn%m8[r%!sNX)/gC@E`JPGrBJYjty2qOX_7oUedUk)%C@~0<+u2rONyEJp&}:G@=}O/^/B*3h&K0Ef{_Jif~he(8gU?D(8RLV`[Hiu/)F.Qhn`|xgB3^Lv@=WkB9SiTb{V+sMq0{*|pcarKV@Uw?iUQ%RLx5*Cqhp,ym@RK?(R#82?y^}1mCCZyjshv04gmJePpC_&/JFZuj!pQ$R3,ua|39cL"9n|m>sA*JnX3]m@`)WXl>Ol"kEi8I_SjCn>e6:>r+9C@E@LAc;oT9e}0CYD*JGMLhEzGRnjQk8Y>umQv**cVV&D9?bj4c,x{VZO#s7vVj.+~QCGx/Xk]2=p7P3mda(y&yunuqW2n*gttz5<54CqcuYYNOD.Nn*B@lGG(^df7vef}BX.AmdW:p0npq/3OFDP@HT;>&+BMxd3=p,Eo>|DSIJw;c.r.bT%.$MC:`M(Jd`*spSd,j}(i?N)GTXVOqny[K:&J$wTLdH]%ss|oe4(o/pB895aFCG>9hX^Hx#qGe$l,z>+Gv7B#rE_^k?#R~6NTq#<vu2lEyV2}>q<{R0fbSfATkhGf|k_MTe|f34@.s_U%`=.~Yvzu|R}VB6s3Fa|;VIJ*Jv{X75h*SQjvip6Ekz(AAAAqUBAYc6"EMJY<C4K"h"$!AKA@FGfFzYj25]W{C4L=iSCEAAAAAAA%AFnW+~EwmRo`]yK^*"uQH4>)#1}A$8n2O@@5r{+C9nUetP>7QkUbsWx2;s94R<aWb$4kPzLt5gpIU||4*):()t5Bbi}v|?HUQ8+&9eO9F|RZNdDl)o,DWi6k!qYS_Lnzezr#<qb4@r%i3+BD<Fc,D}HnGWwO[0X>XJaI~@U$dOm4EA7)sfNq12}1/zB;>l$U<=0Oh^N0f2~W0`0HNP.LQCGcep7#RS4F{p]|yuNghMrMr(i9r8a2T8Q.3xw9zoCr{(j|;kl:#3l{Iu{{<+fkRrE@{`7RywG+9Ir*KT5/vvI><c@`{vY+=KQWms54k)PkdJQkq_4#jIM?/o]hxloLHe6m0sBD"J<b,m/z*pZ)itPAa85$d&z}`5%s*O!=VmqX!pEeae6X=>0zgs@~P4u$LDHiuxVL]{w69d/#72$tv<!+cxx]uL6p`CZl2D{`L|G0a|yx_z>f)[)OP}C&Itx*"RR5/evi%R<CS/u[P5Dzq)ffSZsJWhr*f}@=|l^LbPNxW|PNrTXurzSQ&e;x`Qz&}|0g+=w`QOO}(IJNZK[JR(Z`29HXvdwXN9US$!LuaTsw!=CrQ(6KK,GQW6Rv#PmE1QDS@d%_o!3u+=4ix7r)+%*N2Tj&B{Ktc=iKo=(Q<v++,FoLk"9sy&9kG&|JU+Q!z>niq(tzFa3Ez+vm;*<QhCQ`td0+Cj9h@Dd{*Nv%]p!Uo8T|KaNYLuW3L8_!nWm~za|=b_g8f}HI$!CF&96neNtjGt8UoLqKC[=zv}IBh2I3bi|P0;_>r%&Vu4y#D/9:I!ZRO<Id.^&x$d~Nqwq^<.cTxAOE~o3RuLpQb6QznkJ(q7u2`;!=J4wq{U]!#fp]mB)N@Y|.%iPnSW2gWeg9_Xe$&<K70BPVR!7k@Y/H1L9C1P6:3v~~$F?qo?S(ExyblygsvqL<u&9*`i{jlDk0W9mC`R$[M==5K&YK]R/41Fypb>/(c!YJv1J>C_saveS9/n`pa.3V/G:FGCe6730f&*>oMzNpop0)rO~nE,hBy7=IiczWRkym_zPO%O"bx}4$W5E.mwwRt[;]Tr*~.T|>MaXkj<p/l647Rkrd;Ta9hxp*$>+!(;7u??}7(6uq"/UmcrY#mm1OHyJ:WP931>b:*VFKv}{39nP<C#M@%Wj?N8g8Qquvzv#DpADN{:73zDD{hnoz|G#nj;uZ%f>buSHY9sOV9!)LYm@5VIMIS]Q2(z)&dWz=Kne9!&b{wddwf:+D@QX735qw~/^("6+P2O|yL9]_Q#C"l?t@K%zGlqF+O3g<^wmW!L@TjH&^+7RG"%Lswq1+cB`f+^CIAi+wLCZJ^gZ@C_YC^7Y<6E8i=.kRfw(Y;|{V[YY8c6!>hU.g}$Ul8Nm.mo2N/"U:MFDfesM+>Z83jNLlLNkkpz!^`v/GHh3y+Q3Uh^~mQ)5OKQ3tDyF0>L+WzpK@8pE^2}q1yArnyuPGBF:Qs~a*nNqIPcBp1LChvER0x|aKr^mgi~f#{{}:aAzR.!U;plE&9q0t%//RoVCWsyW5O!gDN#c9Rr~cfzf=&LHl5riTSpJsDGJ2U,w1aw!7>%%"N]s7r7>(dJV*B`_CTTQbHL&!g<>q=#Q{USnb&M#$7Xq9z9&jG@w2{~:WT<Ew_nA[m3Kc%_3&UeVNd4&X2.Y@)+!g8L3;2P|a}?%.fJe6Rj3:omtW&8No2OiKgNcZ,E(eK$P*1"5oPEJHP:~|tkN<.l7_eSz:&4mPDF*0?30l84/VS1#*>imU3lsn`w.*:DQ8.NaBv=;L1y.S+~#`5?arZ|bI:dgCSiYA_6U2x*F7hkc";X/Z=E.<mu!7o,HCqx/#^DRRpHM<]&uGhnN(Pn/Z[0<MA,HiA|uW9/YcACxW3r8UJ!O/r|6/^IrJ21*qX%cj[<3r`bB*mn6ji|[_#J:9_4k~m87?++"(|TuIzyqTeM#06=fJUq)|oOQeV))GNr5h451L*Ajh7$?$C|nv8PP<_J$.O&8<W?L+{~C4{#S5oxD~`/$`h"^<F/*EGd&mr+Mn>Vw+OdjmMSh=@aeQLE6S~Sta5Noyh$RbW1zuWN&VJMF%lME3rM04emo{usHA]=mv!g@foel;J+Wx|3y`i._7Bv0|sYJCaY;`/7.(jBM9kx7;mtUYRw@Moe~/.HHV>jXp]^=)O*n|UNw="FR0kq,k!%iwKc6?.g,v2.QB]weJuH9a&IAf+p6!seHdMn!9uy_y;yK_MC$Hf@X?KR+x|@q9SC1a}B.p/o6R{A,&$MJY[v:f+wW,$(.!70E)*JCGfOG;n~qQLcTQ9ZqqSj&7,[+.60l:=xb!`_Sntf%fNB$<un`+M.eTL8"w`OiYngEcpiY:XB4=^&wG[^jPCrvO/2l/P5%A/KwwFIHY)i%eUf}v"TSTzr1qoEP@s{6#]:+MbZ83|XQCsmA_7koQqIk1(lrPU{t$b[FlVd4;wWDvr`js2s4{(Wrq%=f04}`qvVU/;bsVt2iRP@}E.1_9Z{Q.(@C`[0q%8I(1xsF>QiK&q=y3aI>Y*2K?CGNE~c~g}_QPVnCS1$>zu`9b09Pk!kPA("pc(#Qj#<8,hij2aN*gV#&*mj`84gs,KinskCd)RTvYx]XIYJxpD7N.D9T{7s?L{k/6yB%=I%W)_J0B`hCWcmvU=))O!)E1*>4tQGxiDg]55p}6yZZsw@5U%bb${lo%#>J!t!N/1]2JRcLF;km1xv?];1!^G}%|X,4kX,}u)Kc+>An/Yh@~O~k$zF#bv2qO%5LW7+^F|[^)?b%cEO):x#S/F6*eidJ5D`eGT*/F>LgR+A9E?HTU8)N.~jbA_"`,9D<SDO@&&_N|O7mdz}S2|,]e;9xZ}WXP$q2LHo(y^te=`X;F@TC2H9t*4nNl9ao.F[q<`pVbT4k5(.,id+1CFS:UC!H9X0#t,jfhD$Z}IFx*W,.$75YDi}0*scZ<e>2@9.;|oqiY_zI)&yMAg&{%VKO1Oj=i]}xP_QH)?v{e&0)Y]<1D!vE`H5lh/rC@6%B!%9igIl1s`W5].p/yc39r]jr.Z;lx(0](}ijY}f$CLAS"W.9!4YDK}sO4Ld4dEC?Ir084Io2_1bzbi!^@9&t&DU?Goim_#Pr0433,qg`k(T"v5*^]Rnd|2"Y_sZq*D^FAj[kkNfMEQ]GPDv9m)B>GP6`ku!*&m07s@E5^CdElsdj&O,)4<h^c_U@UHY@]TarD$"osA|(!3n#N$*Q3Vi/peh5m:qMXC4nCSS8Dj/chZBQ6x/uVP;saS<K:udQC&7r"e`_*p%ki0IB&/sEd^!&<`P5^=un,[me{xuTq00qjGn^(?e5m^;RzD.Xeth3NBO:%xl@/i.fD"|r0Qk2FDCD~"DI10OtboMmUMdG4}@&3HQ)Ua{4dxVXVLezpHy0OGTE98rNa~VDAkwp9np=&1wN4@vr1_}RM0f){uOi0>y)/:ATOs?EQ]L)2},]n9zbx+/`7(XX;>)$fq#ca.w`cK#y[WratpfJ`@/QYM6<%@,"tIj1,oZey:N1y5q2^_g?wDC#Gf?h#rp/bdWy_5gTQ0U&*pgKzv9MDoXsyg{E^&y_7@kO"*.nmEH0xu=O?3wptNsOUxK5rcel#<G?M<U1*^i^c+)S$L)}>O$|^.n`Pq_$7s#o4~3FMW^]to!guDiUvd%oAc)ZWcf4_e&bQFw/aS"[%MpK#)KV31By*HX@&5aX5n82,}L*5rxn1$o6+lP/jEFQ55V;b8BF{8bV*y=Gf_Vg?s^d+wT*4wI~m[blpB+.1$~qZut(U.Q$>qfGeE&sn@].OzvouOS,&"tsD:}Hz<"+jzR_g})@HdfP&=*u?8ps@xs"P/=vR$p*b[yxJ2y+dSgfU7qwojZa{0a8yU=%e28/R=t{`W&c6?=WGSc31dD7)_L5H{KtxYg7Q1~}HMQaJYDOD/!sMD.SnNPjFWcVC&VLz<U4UkZEu8&d2BL}k];GT":u*%Vi>l$4]^W6*|:Z"NH6Lf1EH&0:%LAo2y$4F#Qp}}{[*3pYUeCE?q)lvm@iU>k<Xfuxob#1Ab*`[Wh2_njm4wWDs&`f=^6loGi<1zE9*T]E=Y1U+vk$yv[Wu6Jud{NtXDaW<?1c2hGGklN`gZP0x|VUlgi3zo909cmU)d5,$+`}Pj;<$X=e2chZhE@u6JN1Ufi=N2lD=,aV0D<(>*idh~MiWKv{up<(@c+T4Y+%lnW5^<O"kKEh=Z=[u*})k6EdMcE`7$u^5|iIJ{VetJ3HNA(w~_K5~tVr79&,?qLPE@ABUarB>%OumpZd<%}oQB2oc@kE|tfBXa@bnWqzXs(Q2d234Q3b3a(lkmIM8k7UomSFU=xyRstW&$M@=E>w_3NoQ>o2;E%n:_bv4g_"&ef{UnZ6p+4S&R+hCE#x]Pb^yD8:5QPol5M=j#aEpsUdFGdy!:BQ[r)IqB0mUT^zs:a|W7UpQ3;a9t(oBi:,=/83_&<~2nZ57d4yUx>f"f_fe{pW!sZpV4<}/9|2&()*Ts;x<W5$u)NQ4^<%(m!6cMBh@.{7"Fk1WZ[.o?1umn>+qrX<17e,@!}&lz4EBW.g`j`Xj7",EH/3v!kNN0@A=)Vm,}!@hOsa[:M4fl=$:U6x^s@@gqw?9uz+<m2_RIC8txA45KR}]/^ShIfs[2THv"YSVrjXffPUZ+z*Su+BS`rB.BD@2JJ?ykaX%#]DbZBgz0&X5#7LOZ(m8q;2Yq2V+MH?+$HG$8a<y7>>6PLGR_:e@60%URC}#^HAu:]^~SWx$Fr]9{rmoV1{r)t_J>=A@Uk|hXnjL$5JDgi+>z@Uue4}nj9Y6TseNxiej@WWdI%zIH*~0v8e"U_SUAOzb$cF;rSxnQ"DB<"UvXPhteh$jlr0U]JVg><:N/>q;sWk#2eR=W=osmf:qOJ,]kK`q!~HRciy,Xqn>l;Qt9T_V+!RRUpfx=E`$7#pjwivkfZA)bBOw#1V4CF?%&A2U{`SP5[t)c=fqRWt(l#|D&s{/R3k@U}k"{DK4.rN!Z1r<E7of|yQ$U#~]V#[<+~=E(p^]K~P1D$_=rzw4N#P3zMAJw|25[wHRl9uiw_q4d=2wY8AE_eEu8eQE1=!Z=et5wx&oq{bbuxc;}B1t9;ZKE(i]5{8]dOI~Lxe^USOS#W5G?7u2?Ov{s#=,<#W_#g<cxPN7FmH]FR&Hcc2@s~IsX"L:w)k@^&>t8F<.#aZuIFz^d7ek?WpxeY6o219[!#~J}i)OmE:PR]]J%7"jge):}T%H^v"^$Mb0T(`YPXCH*X?exrcntsc~Dn0mH+i[Tq5ddsn]ZxQcx/H$]Q}TlGI?jC|Tg="yEHz`x5TYx|w;#(i6YzkKp>#xQ)o^@jW&OAEZZ?E3*M]QGGQL<[Ys[_YgvH3tx`aFvxo2QjEbI[?:Y3.$h`Q+P!VrwQ$N^S.Cn(U8+C&)7/lAz4X4kJ<I,vgl(lrmodKJgu&BhJ.i~4Kbcqy2|<)$3:VR3WyRPQOL,esN9cBf7>6n&~W1_{8zvZi6SHNAK>k,V=(?S^7:/}kUya,Qp~*j1~,<<g|z8MM7R8%R{fn_H2H~5k6j)O9L5c&p)Tmel`KhOe[3qjJPg:.`U>eeL^i=GIN1~]YgjCnr[$.zDNlkT(Nk|XqjWJjS8}ZFkw/zJ`HydK=<<r@=zRdaO66`A[Ss/a!BSbd:Aq^Ew"i*C%67|iV<l)RsSklb?NgZS9p"mJ$YGseEQKoe]}RI,4+3Sf7H=o:7#+B6=Y^vU8%x3vh#{)$BMdSI^qL84ZE}+#.:dJo}d!=YL,KFj1"(/eyp!7Yw1ek3Cv+1;r`"rBR%?;xRE##yz"f"C2&TGY4otVLiy$I`X3a#D@9iylvoitciX*v=IY6eg2N)li1DvW!&1gyb|Azd_iqgGvSqj_^Y^h9o`NX{RxOH/fG3V,T:o?0z?90z?t/kGWgkspbD9"Ja}`vbMJTNTw+}TGlUiI60D`vHW7:/)I_l6F70~Pt|^UPTXZf]v21,@d>@5;=@M4DV]|F%Xog8h<vMH$tu2s}emI3YLUgBQHpn^%&^gF=3w^0gU:(s;{>";`_w|xE2sOyq0x2m~.YMFa;Hs@(7f0q/U6C9,`sm|&`iIV$E5R,"`b~5z3m^qu!Ff=cF6`3P5aS&Ph!%dVW0jLw$J$_<HpsTxWx#{2S,Q0G8aPfp|0Glf^3r[+q!?zNjoMsAY#c<@6xvbye.=oQWlg=%~0dhn%KVck+tPB6{Rt4b}Xz;c519h%**&^/X_y*hSb({V,(K1x:KN("xt4Lg{~9eJb9+}VP%c_C:~fZX7!/,D%Z:7C^~H@6L8%l%SANuOay8A7ko50NabvhTiJjtK_{i51Z({)[FG_nTih|^GcTa^!GZG.7h+T_jc$ZCe&73$|mF|32?{W|mFVXy>V/QFgN,0ktnTPH0;jf!8[{X1}S4u!cZ/=X"es*6=(aZz^qZ</bo0>?bwr[ltVEXk?2y7+F]Q92MR>npU8CD[Vt*K,EeX5RvF@2]CYlAi|cD{xs}FK@|^"L$*&)$<daM_QGQ39;GL{mR*,W?f"67a1W<rH^BHY>2B|JecU5KV)(DY:<?0$}wwLhGN0ey=OQ,+$/T0u=5s9pd]!dX><Tt~]2puK>O~IG&Z03,Y1~Vtl+4LacS/5F~?7=1],PIjgOkPS#LdT!175%>x44xb._C*A[>`eWlypHc%@>x{B=0DJtM,`mg^@)1*E^FZJUbVZLu^E&__&en&tU4kZqJSGqUYcz]4VZY8WoFC]vpm?SHE:G9hKJ8d>fUa#Ws%::3zBb~/L]uI:l[/h<7`2}Jgk27vk@6nXbQ/nlW>j8lj#^u2*B3uPogI_c/NRMp6pCfkx`J:omDPY<}rHlcuBN=F6BrfYt"_|ft1u>v]_?]_IIpZ;c.BE%L@X8zMHgvG:hhr9ooDco#V%bXtCA;Vwz>/OS/ixxw3l],qvQ=J"OHc/JU$!aZ#eqntdxR,R6]QHQB+He&[9f*RfbNS_CS_Q(e7NH/1Pn5tK:DFBt+4,$;[/9jQjbXv|/oP<59`M=]~kY+eo==VmEHgO`)RPJRdc@j2JC5X@:bfT+gQ_h(N*M*;J0A7Ac{b(I?(f|3Dm+{?!~37[lc2hz5t,_NF"X9hyY>gpD,Ft^3j[+t[5p47{GchuJ|,~9Q?"D5Iq1PAjhtZ&c!kea/,!pigHhw8)vBdY)v]%I5vD,_9gX}~X}R#VeNlI0`<a9|p3;my|z}9NA(8nhTRs*^#l>(,f/^:wk"2q350XMChI~V~us/S`=sxcW3vO:Vy&4xd.T,p@f3o7;Nm8ZF9QPy%aJY.5*1b7,FAz47DdX_MFXmaCEcrQwQucv<Y6lK)++0dI,|39s`K)vd>c39h@c9L9[,M/K27f4K?@bD4k6l4}FrUF]&7B)ley6`%{W_t1!A"e03*b7h2P!Q#Jp{|9}kCt^SzKDpGCq(YFfjP^L:O1ZbubltMo3O6K|H7CET9p!4:^eRL~jkd9q2@L4Ay"dd/pf}$Jlu@@PT@G6[XM<F0$hm,8/z~G0@CEMx;8x+/tXwX&wp>oWaneq.h_t}119G]#l&iCVK{%B&A#k6._ys1cf>5%(gWmb~dJx>Jvm_nJ%1&^Y9>U_in<58>Qi`ak.Z~6RJ@&7:|qa}VZ^t:GsD!_iVBXM71!<%!s(!kyTZTKQH[>iiVeEpZY>)R2CWw^;&5s35iqHF%ec5UyOn?7jWbaHXNbRI`l@2<A}w,n2sMh>:DJu|X}Q>0>~19zt,{7ucT_kqy,&;xu+y,bH}9/V;CVt3HOz_HyM$ox*V&KQpeTl^eyuxC>ajIY(|Z8uUB~68B4^r]%JYuW7nrwW/XI4[6%=Hh:qJxPw%xn=,*M4<?.*Rxe=5&T_=FG[OaV)0yu,y+IYgHY#NOuUPf+ZK=!0d$%l33vmU8y4<!XE)N2<ig`pi&qBEDa:i4v#Yokz6tFm4FL9rEZa[n>PhT9ljtWxU!/BdU)7q|i}f.2{7H2%h[wn>^J^$j!m`9pbvVr4+t.C%T=1_FaPNfCddcXKlK=4mlH6?^O&mSca5${cJ40#vS.v5bok&9OI[+s@4({i=}!SIexN:B^(RG]2,A5~`B/V~HMAc2qt.=Z4z^/bg2:XqUhm09Uc9K@D~N~QdoCQ|<e^H.(3@}J9RXILeP`5aW3qBEy#Cvk+(ugQ&)>b<h>c5w3]gGz}~g?euBbATEY#}l!oo6|[ceC<1dJs)V>ZvKWdzix_`ig_$Drrx^ZiXysEC+wP*KL1I/%|vstk!c[ZZK=mL,fwU/+yR``4w@"ZkL9n(S2{G[Gq"V!rih9d^Rowhs.uv1DOc1~24MxXa1NAznHz"rf+RZ$1QDV211yr=*fVo9aB5mIa_0Ty?vz/`|]P[w"5OQhtV+1.=k~7E<$F$*~segZjo![G.C/vO$?ia:W.o5^?eFZQsVJJhokJG<%0n`?i&2hL}DUgIx(;G;p+&n<>27gD4@xE%dny=ne|,4nmtNVD~0;Uy#j@[cX@pD)2M}y$Di^n6;r.^m&#OYCiU4XAS$GE/emW+34w(%gQWj(cYmfH`Y498t#BhJ^Hn#>3>_@*{*2jzO7(_*yG4/R?J/tM<<ezR)c+O78_33Wx&k(kfyfEnFu:%5%X6N3Dq|(,wB^!6;=Bd28)%ip;?0|a,1Z!+kX%uZ%^:Y$%{k*}gZ4YVko%",~wY$aoaWSHD{*n%j}2<<te1kbX1x751G5H}40o)b=.v"FYA!T$GoRj+K"iV[Yv.MS7komV|,V9=b!v@)h^;TaI>MxDTbK/FLcG3+uH^qTc:V1seYnK4eZ`3kU]|xJw*a6[vwv6<(zMA1s1HYA/kYW8;tt4ecK^"ypWL{xOjWTU5*3z^#0h[l$2h9V$?Tbu!`9g;y6y/+4?dj;5tw3{go"<b[q^GORg`I`]j`S75Be{_]d9]yH$PCZ6OY:CR5wWo#?1@,i=xc,z{`KpozjH^,XNe^lzzEKJVbmvaPLj)=;p+_xE[&o[qpN[gj^T81j/"ufiPL11]8N&nraY1?hy<!i,yd,o#Y01g$g$}iP|"|W6LB9P3NqCj"$IeUV5e6|u$>[or{~6H2iU/6KND9]5eix#=*/:QwMlREDUDg(sOov]Z6_2Z^$Lk%cxR?6oM=2I=K{,`O|mkLQ??_h!5p5w#a1c|h=hi.Ki1]3nF:{]QZHN=P3KaibtCzkN%R4,z*WiPL0:"y*69(e3rev>[!;?_5iZs))lSN"C23BXKR9Zmk2G)Im389JBd322lHQ|cQ9Jol^V:F@5G(34#Ac1+qC#h4lp%/gl7kugpLFYEwflf#5)QwshJ86gq2^(bldBzHSx=IDrW2=;CW(Khu9W;Wr5E1p[0Cj8<kmC]2.1#a7&[o]r1`#a_cEXc:|Q`eByDZ/BIR2xTeg6k#l4z&8kDw+pBwzp:O(UM)Z1LVijS`>@*W5!f1C>vG9Xm4ni|$puKW/f;d1gP83c[xxlHiwqEYnS+OF]`ohgocC,c=5I0i.)J=W@R{{/py9lS0$:R}%s*ZzquX^mPeqSrsNzTL2ecUPGv",}@oEac#lxh*l7sR3Wp:2yvd[D(L+`LbuM~85]Q/_$f(*3Q4<1hI&1$+|Lq=E!5)n.1y}Ohyzh&Vuj||Imm~kXU*6#Cs[)pjA"dU9~+_w/t#WbfP%w(rjPPO5Lct#7;Njj/_cRyB@^JKA{M>51:$:4*yAirPb*`J=H)jsWvIDg4R&b$[D!.uj~2jxNL#VVwI,@3@E7@b*>>|K98T0fP1k}3bGz*aFKJpyXP81o{u{;xc18,/<Xu><h]s!*qb(B>SOJ)dzc?n93_wuOMCb|mt8}~1tB!ym0`Qlg#Phr&#@bcrA?`uYDf=k3w&E1cV~T6y~2mR4_^S6_E4+9>}&o1|al_qmg.h9wk@xC@n2)|#QWMJ/B#TwF(`W5LR{n;1Q,|9brZ7YE>K6ilu:]8[qR:Fqe]<$;^J87Sht5J1n+l?:!1$a1XC=kPda{[p|v}O@RsW*qs4Ya8g*f[?;o.MA?JLKLGB(T&a/HynuVSJ.A9g#hB~j}^lfR:gB7NO?ux2bm88DvEc&tI9yXBYcKEzey0Of~VqI,`~|HM)~<^[N^5R)H>h;v&fut<MBTO^G_3LiG=(|HHa[;.bpK)mD@btdQpnFOGJ6Hem]zcA0SJP=;M_BT#aEbUoEm4HDeiV5ZQHTq<Mwg?{%rM*UeN`F&Ug$PO+^B!4]{a6|PVMb_pH)J#ZRJAma>5LYtM^>#7&F2`L8yx)FjY*`&NEo.Jp6pxnFkn37saBT^YurS;toIH}U%;L4E$bX35@]^N;g_vri?$X>1<4TU?)l/rj<JMFax%V/$v<#R]N@,{ySO~tjcV_km?#4faAJfn5oXI^&w<Fmq*"cl~1d/MLPn8Sd1.:`A.Y8%;%[y)uMMhbMF$<zUuq}fiF/_mOb!bs(t`k+GmCw%mLUD5X7T|.^+wOMPMC4QIN)fri7vJ|pE:ZGhw):d9H&M?b`EEoQbT4PUS&z7;L7rdS>D{!"M7s0lE*(MPG1$r{]ap1^}1Pe:t*L/}Vy^GLw)KO$:9ra]{Nf|r9a0M4T(U$;M{/L3$~#2nM{hUXEftxVGG@syE]H}}g+4%"^^g:O&I/Abdt8zCvgnr2~v|3.?`w{Fap">N%kjw]0E:6*Do9%gQ|ELordP.(Zf;jDNuY0VgOp3"O@C<dBe/[#=Jw{A=mhJT=e6z~SZvm2a{`U}xe|:M%3<pS3rwnNbMtmQj$ta8P$KC^N8F&w"p!^Qk]42>G1IT`~:.1muCUojCU9ivhFY`G|@j;fRaV6]YNh9"FhN:=uVVnUE<:OQj,"B46r]*;BRb3xY+1as2M@!.zpeL5;LXSKY3Oa%,X#YPss~i<Fc=nSz1yKZAQ|374e]z#rm7kR?eUtm?^U.$%<T(azCAf>K4I=jH2P7bm;?E8@%$.y{{Q_G]P(+KBgP#9]Jx)nQY[NU<D4J1>VsR?*]3}a^i3ZA|]Ln3tam#B]WWU3nrfl/u6p*D+rz*:54oVOEU]KB,v@:"$[)[ApPM^Incs)M)~M;^OPNmvQYrqQ$@[@DR%1~J@vM}|Yn#mIeMHbP&yz4~rZ.3a^Qu3h,B]@on*J5)qzeLtX?Hr(u5w}mJG!XfqqYAgZ$o?`b.a,q&tUOu`r3*3WlAgql^<Uf6jQ;F.?:xt.,ndC3Q&lCFQ+]36L1T^,8ak$+=DD;uhXjdTXc$},sQWpNy_BR<EOy<zX$<!i(9@:XJ^Ay&zj3;eT9S&SJp}ctv](l?AR:Wkbt(6dqL$=7S&SGt/ynhGLeQvBQKn{u2dWs*o&gI2#bg[<]@FC!:b?V2(gt:~T}2gE`}UQUk3KO(KlxCNPtF{??SoufsL,k(/u<Olt~J6oomB.:5Fj?NDL}$Uh[{ue)#u~X52&FvvRwoGweAmonB$:zMX4(AB>_FU+=5e`hRr.5gYlUE]k_A#?f@9VW}mIV>BrO*Cg?h?ugbd9yl()Tt9i3|n8My7C_v):{;C$0`Q@}{JW:I+VsiOMszyMx>[HY"x/R,di@^|*%In%^}@FzdK0rMR]]JtS?H6$Dx),<G#T^E(<LgKc__L?JU4@`5ZRUk9RuXDHv@qodH~wAC&mi"~})YZjarvw7wVk_gDlINMxWWfa]MkzE0Eapquo@@JHArHHN3([$/oqb4n4a[`;@RwADOD.|]Q}I"J%:P)nN}v=^gY4{D3V?u1L^*:Q71P<f^ng,l?0{O0"O=E5QHUSHf:*qoOE;On+M69(3mpY*yTb@^[yjSI~={r6heR!"](8J|r::aQC^"gS}CH9,sqgfHQl+Ic#eXKGVVs{/IJ1<q,fs|CN!)V*=~PM`mZ0cug_"VMTx*ONHr~,e$Y5Q8d5TW7wRF+}0#4}[#bUOKzt_=5/E{nej1Np=o_l.xZIMaC%6"y6RPPhU4hQMhP*UVwe_B]WL[+SuGkN8*J#%q7O}P}`%ec0~Ui2x:)G=IP^CI}*|0YY>];BCO4E0P+gya/1ZKq91s;h>]GO{x>wH/eN[)~s>r7.ve=6Qd)_,aed@M;<+5+%Ol1"[,pu=>a`OTbraCbW)NZQx~]_$EkX>44)^A#~nmqpfdL<fAL#jbSMQQ`rj62~FU}iA@:k|q^5C,a"r]N;FTHYDtPCALuErBZSSz}m?KGT&pJzTemSIX~%5SwPf2VmptKr.lmXH<cLMViApOxKH2M*a$mfNNV)b<%s|sN)SFeDx>bzUQk.%%s:B4l&w>(TVz_>Z`HVKFKdo/3PBZBd_PtmAcmuGiZ>!vi:$]L22Vo7G%>>/()oX`mxUYz51G^DW6k[#gDkI::Au#|**t4@K&?Q/Nz[~n%/#HT)m@5DH]mqR)8OBGqMt,&FSeDnMT3{Zy@<%7,YM1]Lq9z|uK=rIE+1@(l5bH$kYrOAZ&?aPBNh=d!BdV{OrkcCO.`wdLi^&nyiTr?BB/D6NyRY3sYK?hq=mdQ^V<}z/PP6FKzpXGyK!6(Q;(/eg&i(1#M}2]Y%F8o6m)BCWBQp_+j_e[%Kw35Ka.%I4]M?JeAm&RPq}%R6A2m*TY06<<ubMs4#R$~uJ49DCrObz)b>4#Y5PCgC*M<WIb:es1RfW^ZVuo@z1Fj?G;bowr%B1OrF0A)uOFXY+_n"9Z*IdJqKI&NmK8Ky]l46v)}*S;ZD#p^(4Q5L7>R<YH8tJrS`M~k:n4<D>"U89efB]xIZ,J60gVY]kQv}@vSN56K4p!a#T%chY|[Z:j,Uhr)DE!=V4g:i6lR^cV3]"{q=ypbi=VpD7gTAz`R6|Y?R)eG=(X)@]nH/[?j]tDjWv^>04|wlG*otaaE|J.xbCy5jn>@g3^|Q?tyh9s2Z"YY*K#sd4lo<.@!xD@x]gW%2B?o<Q}vPt?yYo$,g+qfq0sueJoznUVB7^dm2Tczc1{*@@5eH/Ss&Yg)+|"W~8ld[u$axk"twWc2?L:uorR=shk7{3iMd:83IS/C)t]uGM=kfUv^aIDEkO}xU&!Dk5$4}j)SaonF[I)E}0DjxUxddN_7V68_#Y`X9UVe#E%uZE,]@fl;g4EP[`2zR}DF"4Xz7V^MvQ1TeKp0RpguwKUuz:?{aUb5CI5X|):Y:t5/*h!y{a[4"7$9G5|gSX.DBxLWbu0`0K#KFbmv4SC]RL]O@2w*}tQ^([RS>O,GX(:rpW7]=zQ64[EB{V5nfh,<Nud*t=57Gx;2.~M:V]gb&Bf|??sW*WR;C.^Ft9%POT:i&r,NLg_s>(N4_SPI64,%5xuNU6_g"nxgy:Xr1}U6A63Z<3A`^Z|`1*|G(3|d|(Yfm`?wmPa:JLu+pNi"7_FK2j+}Ry.4|4gyqQ`Vw;MU+cFe01%OO6A~MjG"QU1T<MpWiuCw.!jlPFgG*H/r0@}@9VqwNV,l>6LD_4Kv17Ui}@?I`jVxdi?W_y~iC*ljKyuDC/1$>c2psE!.l7+4^;KcC<_D$[^ZZx,jyshKHu*UX.FEN]*CuZ(1Y:u0CF2@WU{i0vfjJB$[!RslQHa{QN*g/j1l$bc0vp?;rJ^gU&s}"<Y)/eue,mIBsa1qiLlG$.8Lg%BMxH<bP7RMhm}fnRQ<245Hvt/47I5jzUH+BUst+Z=qR6_s|e#}__Tq1P;z}nwqCm!dc]*[Uv(0ARoZOfOfC_+]Y?kh3T5t"6%E>Oc>n?YxfL$AT=+g<NLI7oiv:PJX8X$P<Ip"B`NU0]u=eS`fYg#Z0`we:a_uBfm<ip(pb!/RDKY/!FYHAKzN+z1/*&e[GmBvhnJDG`NHaM=J6#&VQpa,}%K51c6h8vcl9OTd6<I}A?SbBdxZ`di}?>n&6nQMv`"5va10pJwj)L[>F)/AD5B&uvHWP?wo[J<,7{(8,}PbX9#w@vJ6?o+46tcCa539[}E!,!Mr8@LV0&l8wMFLY>.[}_AI]t1.f&nHa>i!u|RY{?wvE{LauV*V<h~k}2%nO>CRGl?1a;Iyx.U,H&!HM[5D<Ni<ha63=mwJ[gm{WV2nQh#LElL~WB_Q&GUXHz?g=C,:7RFXLzhu/k4NGqF=bMOfj{;+<+dEyw"3e%+?(:jl(E(86b5hPL7lIgwYY`#MZ,GR7#WFYcJ_^i&Z{;f}y+"^r,ZXRbyw^{:Fk$z+(Prj}e+mcV.}_3qk@BZC[.5L!.)3fZo0J#aIuSDp64{B1MXem]pc}FxZF}jorG_)ixl_CuYMg[pGWJzT;9[4BC*XH0woQo/z/=}|U8ntC.R@|r~Zjig*K}1Ff~4G0,Tvg4)!AqN?^0id%F&KWDX;(6)sQ@_kY91ax?F1DM;vNQlL4u@#`Fm[S#y#,NOi*k?E;#_,5%YOlq*VzcgJ)3v0tw[(mq_10c/;/o55Igdq6;{R)2dixCTU$<C~h:8Y#7I5./KJ:<WsrYwf5@qPtN,6[%H.$[J5zOCqOm:~^/c!GAAAO~u^?C*6QTp%k5T?s3m)F&N0AOCp&08usa@QZK2iN"Iaq;hr024YPO2Q5Z/5h6qu>:8t>B+n$%WtNZP|sQbR~[xM/R(erI>cT&}EZrohtl7V##!d7+4@?yu^npiJBHrRQ58[[D=cOt.<O,}S#lXvpN}(#38#vs+W2olII6ULBo~).io|8S$kh,O!2(5o5+4jI$RxN~DFWWf!uHKI,{MDi~3XR~}U5=73FFGO.6zO!B>1zhNzK)[_rg4}mZCk4ziq<~U:%c_u%&MhPa^yc6/g)53^W5Ub.[}l&i<}B17)&H3dWc=4.AyO1QS3_~]?F7]aDYS/KJGt6gO6~V>;4Jb)jepI$`TcCxkF_]Y/VdnuE{(RkyXR?)e=%G~L:i]Gp$>20gU9#vD$yr.$_c<Xo0zP(vRJFI#bu{/c>Y0EovJP!6l+gOW|7)!{ds+xybf~*tGv7l)`kb#F}>[{W{2Pr]yJs8obI0&?D3SN0[ZAGPkz;_o}~Ddh,yRQ{G+8oE=@P,O0D$i6,c;%t1S&=t,?gQyti645r&X3WGq/_({#{aWwHsUywFAHr6GXug31P{l3i}~p3.XN*FZz5>cJ_5(3Lj+?Q!L?+Hx1$*mAV.Z%8$htS#}Gz]9Xq|;L~nyHN3]l`.YkzG#B$"?`cLJFcN^pfwL"v>T>r0p[m523UvLb[LuH(8La~,8G^e"T+&qP1DZ6`_rA~0"~.G6_w>2Y6XewAV)q%&IYx~w]*kz@+2%rUPX&X!7PY<JWg0$bBm@Ad0vvV$6B=~z}!;GRs5r{n[g`/bm[fuRlR4CD=k2833ertWY*(ZR"v[%UL=f=Lqy=>j!~vc8k|bxa;C7gFuU~+$^~AsQLk@;gO;<u~ij#f5+3m/=WTMZ~P:F>j{EZ>oQSD6VLckPpTTF.rJo+h55e7(Hv||%EdS4aecuJ0_CABs>ZX[L#=B0Tb:^8R5yw`sBE<KqN^#2H1CR[9grP*"@x?&#np*%H.mL^w|)b=hoTimcaAZ4yK5*5,@tn(Rwwtvt8T"VIfx#%xXze;u/o^k><U2c/wm3la,&>UG/P?r4"$QrMsg`kPrHmNm^(sX.D#.1HLRJlaNLXN`M~?c3oCM4Ora%|0iw`8u+NON<sf3&{Q=bF~al_9V^Fa:P,xyTM}hDc;~$"u2E!ikRZ_4}y3i&kdXzHo&gS9|?a)E,q:`".,<X^0M(4HfOYE6D,a0Ew4Oyy_K1US,O{LL!UP|,61Kd1f)`XUT8X@~C31ZA,PBsoYcVJ,<u?LtWF#f5CB~3DckBy=!`^y{3rcVni&z0_Pz.c|BM7.tCh3djv5wh:IE2T6:"g$Fj"}gLfnbV.E>RTt7v,hP%!bidcFN{E<0~41J6M#&(/_yW!U759T7ih?v>J!k2^d4;Li6/LA,iU(b%3:^)fXI{kVe`#@7$1:4Qn3?7DK&{mBJ6e&(`PE*miV$+k?ME^s^Eyw92ws%2Tg^j>o&Kox7xt"B2PASR/.a2>g(})6o6.gU:c1oPBAQAfWem$QiLI#7>W~G=.u9Tq&$Tn^FdqZ&IV3<ep7y~ra[FgS5L3*WeHZ8)>y{{!ghTz2N=[Z@C]`xw+G@PhE+woYD|&F,5Mi0+@p?MeHmQE0<OA.)sBjKJ=IJ7&oglgM$r$w!XTSyKs9sZpIwKLB<T%u$U7DcU5U__~=tRbq(D|qX,Hm/:X8HxSs=g:c0E!X<8`K~.O+7Y@27`EXH[r3k2xaXudVULYqurj`kDfz1W8YsTI?Y.eOJ#a,iK2iGyFwap>=SzeN/jfiX9*h&g:N1r<0mQ{]=}JOCOMm6$.,J6,[j#_7/#yn4KN0Xq,9<GDEh|=k0B7^XzcfJ(nu#")]Okkp*B~DNEf?o{w/amS&T3Bs$1lq!tzqy(jz*:]EG~{Y8+kb{T$_K&Qa#`U`Q!|2_/r+1g7wP0Eo9Euge7w^ircqGwe*Zj;IL6,F$#T~/9IwQ`PN%HK]ZDGuXN.?O>mh>s}u|&!m+{t~gMiMoR0A?5&S`4W<dmcmi?=kQa|u.SZ5gmSKqVAh^`amSeAJ&$4mHb(,NA`>p[T7j5qH@lufKr[J,LPJ8$5Up3jz0:n&_g<:Qe9_/TA?X3#bt%$=Q)|BOEkC@xRblo8r!{(8)(Bl1FduoVTp#e#2<5W4|!,KUdYbJ2P(Q9PR7w}pWP<(WW3`9)].HY(jx)y1ZpSsAMkJq%=Q<!?[#l4ye+GBN@Yv,+&{_4K~:kPGt?w[&>t(Fg"JW&gRw%fae^rfcY*dY#buQ>dvi_>*qJz+f!Pa*NM|v@+=oojUi=}n,4HOkGuKRbq{5uO{SQmRI;;]{{>!g247p0DLjr1NFc<$2)x*U*xQZoO|CNcP;5`yJ|^6y$9vUkLyI|.9#,@({VihmQ%/ohi0bld`.E+{/JFDvUjR?tpY^g>MyU2IcM[5=YH^EF+R2}7;r!kV,j7:C.n/)Cu~w*GII2G<H?IUa&jt;LbkE^/(^8C}K2uXD^f<)kWH[FM#FBl<1(9`=>USwai1uO=|`c6fx?N.)M_}$52?B%/[dJoZsEJ$2t28K[<ZHwVcOS4]nm3(O>(HQ03k.T}2/6RT%5@FuRrqKW{Eb!EcZ:Kfn%WUu#qeGrLfVeCi&}GPvSWWi5U@J/hSyrf{*r1axHlIUZ^4@uenRo8>Fs:S[vai0^1;mi!5:G2vXY<2QVx|w^|.F3o[ZD4PRWS5?gU0t<5Dxr{83H2JXBMsU]LX*_r+_;PeT3>[O$qG0A^pm^qCj4]F`VUItW5p&<$L`jcN%0K{wj5#*k,;.]*{9S,A[4(fKKk{ip^E;CC*`f=e2@Zk#*[tbONg$*jw4byy<pGJOc~oh.2+s:CB1?>6a#X"B#?hzOp[MiBtd9WBw|MaS:xE.B>"}QJbYLPB.~yArd8</]<{_,we*<b~g751/pf+7TM0>Tvw(peZIQedxr%|p3R$e}9zVNW+lFrF=^@%kklzc&P1(*.gF}W)ra:<0QEif~3fj3As#ts#a4OB!&,i},P/hML)/PyZ4U*FK{lW*+^5q7IvN}f5IdBIugE9dnkzq5OQ|_.7:pLE./KV$u14ciU*r`wVD}7#|I&[bLw"zqSCuB!hSZEclZc?)Lku+5DoE>Q.rQ:k}%M^0Ea4+UC0CxlzU+)Dx^Ov%&P(fP18R}*pY./c)h?^3{R0^7~yNy=G#!6CgZRn;Ir`r)rqQaWICxQ/=1A,0K&Z"S*3.`O7uHrtT&<*RRH6Le;uJT]]&$E$*.tBSb%_psj8z>>XWARGH!Lv+`T9c"|(?_C0WD1),hZhI*gpMuq&tBqd+A*9Gb6a?iP$EJGrWJy67xR3@iZq(,4"wbv+V"H"SN`#I|~!*Ke)zW%8z7T?NISzj}yi%rLCS@w.ILwrFmYCNhRl7~y%SfZY[wl3Qf?l=wZq$Wm(ZW,nNf<AfZ9>gLm*n9(#k*,4lvf$<&2jp=STC1?0{yx<$4PQgYA/57B,oY_ylB_5$b<eE`4nPoP+FE|p7Y;8Rgwn<:<f9m~tj)|D$]%Sor)8IJ`2>ty+Ka&VhTR@(+|?m#+a.%h{f(;MIQrZ*OUH<|aKgBO1fyoN[5Qec5Nv7V+*l%@Xi&rLET0o*6}F;vd;Efh^euH>G3e|),b5C&Q=WjeYj,jWR0Vtt5*nI>IbNDoK)G{UUPP^CoB@(`5lYHF_:Y6@3;zd=o*M>EM,Glx<Q;w~/*l+mg+t*s,(NqhXc6ErxgZZ[%WRKgzWN}W|Or5,c2:UO|?dU>oT}O<c{a$axfIOFB=[N{+(,*t}M.{I"r$hjWG|+a}?L>30O16"=_:odUy#U}UT5eo8?d.687HaLE^0aJ~yB$iVPa7hWyCQq`r4edi^Kp%1i.2Q>h4$Ye!=(e[V_b>`zmCC%W2t$+V6rHqqsv:{!C!R>r@7y~}jeHRw=/]Lj,KSOGDO<Qu[W,kZi6Ry<jH24wxO<kH}@gd}kfwY@Ws@P|mcOb1XS+6E,MG_WFP_1.jk<i+t;PPP|aVB|+%,%u},(}~>I+[ZN;(ufA&ENqj?d,hl3t7sWQ(gup^idGq>I2GR!VwzH`/(^ds2EU3erve84%fd6kKgeL<FAx7&k8aqf6>7W40g*zt[5i~]CkyEvVuol3":DrKoUCS6hUPF]pTrGJ^,=omf%0C@/tgUjs,H62.S.Pa5di!cJ+lksFN>U)mr_4@[i3)Z|hU,_la0=b@LhQ@*Hod49=$=1*TAi7LTv`GX#=?wK;*b"}z|3d|;"mP3=RPZg:f8#+M4.s|ZhOim$1P#J4]Tug;t%YFX!Q%)CPoBxmKfqb.wmJSK3XKg4Fj0,t4r@2C0#6$:t#7<BmY/9YLK6C[AEL;L~<g*(=z,&[mGixU52Uk!ZJJ&qe/X1vY#^H/]`4hPqOY,9]Xkga8IHTHZxB"<v!9H6P8P9H.z+=@_1:{2T&:fPKRP<059rDivCrevyneoQ,{A$2f}W]o%Oz&3`In6,qLa3+0vF,1"XsK>L]dmzn(Dz?hl|6,n.SVvTEvf[icdx%aC.Yeg9zNeIAy<KYP*L_xn1,EKYWk62&thbkwKc:?sLdA(=H{BRtNNNJmYO~^vsqg`{DOkX8Y!EPS2eJ%Y1<Z}hN=.nT}Hk`ra.#t8vjVL<B3:zg4u3IC[6mi+.(70ITZS:Vj3[qhJ4~KG$=jPS$mg=sUvgDh_<oG]o6_RYPkQZN@4CVm|gdxE%CfK*c[/(qwj!fG4+sjir!Z%2Oj}a+0*o9SpPCPc)RDXU<]1|3(1S;z[r&tHi}j>kPx_(U2B?>Z2mP;V:j`O]N%b`]@lE?k@kG~5KC9Jec_nfESLe`dl&.*j4L7caTI]%XKwGF9p|0GkEd5*t:F26}fQENmYPm&Jb_>%GmfSgSCaJ!Oy2piDF},Qj&jfG/z8{o_nO,u[[$T=32t?[pU^yI.2adq!UH!jHRoEkE,+HztbiFHzq?u,>IZ?!x#I^7rAN*6uyUow`YB}H#;]=vncG=W<`qa8<^48vw%X6$cERuIr8&A6I5l%9<=/:.9;$}:6seH"E9,JX+v8,M0(bS5v5R^]LE!20mZs0WAW|)wnijjF;kcA)nkyO5E%kN.9tr~jt*L=hL;p<=J&(nliyswPOA^eB/:w;KOPy<#qRMXE#l>epGhQdr>XEnhFP|"+I#9j@D{&kp_:>Rglpp$ZMJ+6$|RN$$,#+mI{Rt}"sudG+o:<7>%@^*x6gt+TvYNd1U`S+u_Bs$XHjXE<OoFrvQ]j?$hws>p[Q5/a4:!,uv[r:)71lT|`;5ad+?/xSQl]}2a%.3!;b5LZhni2[,d9}X0X9ZaO<mOSD=xqyHO4xVM0SzjCJKO.]UtWmznoVGJ^s*KyyT7LVV%vDs9etr3fx$N9vXH?Sy*%5!)qpb92/OxuxV2:~|OOU&&%na>[|yskel6$C+H.T`e"?,~$1)E~l/fW_TfI#N$6|!~C0%8a+Ai5wY}/k(G_/}o5ZwC5ZQc,{lSvZAQuZ<A#zyq2i.AjUw&C+XT2p6JfuL1)(KZxsvKMZWxeJ_L!^KW_jDm@)Pt,2h`9BHol=?,E5)x9zjp*H528dHHx)s@i{CpB:Kl#9z;K=<HhJ4X~y?k(/y>B<9`4@gD.+3[>iQY=?FpGO(`DVuB[q?4t[_9m|hT9=~dDx531M6Sg]3x[:XL[CR9pCp~2n0LRRI~Kw^&ytz|}K"=5JgX/iM<.~gMBV_2ovY0=+ZIZ)d|3`cj//PZ@1sE;u|yiB}6AV$GYtO6#"ac,527))APOiWO^U[HB,"i0jN~FkMbr}hs77BI1l)]iYgb^#3[MY!(t("Yy;Ob"dY]N#hVZjcIw,BwM&+eVf.H4Y#1*RLO.k{x}i($lU6(v!fgFW:x%c*X4OY/NJ0|7]zvW>NdoO^Mxqefwyg2#dXe{Z6EsQQ{7Vj#Xe|4=B;muI9l>n/J}.|gG:NrYKxr_?awP8ofX>KV^"W,sZ*yuk(JvJNQiGmTH0Uq7=5wL_/tGV6yc)@y!dPsmR=%/KEKGK3KLP8MrH<?+1z`ULbuGI>ld#?wk5xg2$Fl0(Fg8)X7rSB%RI[3O}MKh1:2wkMKyVx|)OwN?[t6SX1F%l0KHr+V:%PENfM+#"RQjq,!opeBq7MSwersgvEn%t$xVbzd?407M@OFX=gI"V$,kUO"Rak+@rw8LH!O:Ie;?]%.JHUd7mja,wXVX4]oo}@uY6!K/qc=)56RJU_t+!<V~LtIM&p4KSp_&I4aLM!jEG`iV]ibW(Pg{ZEa?L0LzGLt}25*#j"7:=BNJL,@OY|qZHg4>5Lc>Req0QC%s1vN8]`)@>~rQ(R0VYO/ies>f]|~8L;^;YedK01Up1MEJ<UxnZ:"[!qN@c/.?I*VmEk<_%]u?kb!]{Kx#59ZoGTKrnGDncn*p+L}K~!tMk*F6&o`ab"7HsO4E;+||{+~mlkm,c3k/3StSe~nJ<H#<3Sh(;:r<zyTuCwJbm*p@E^qaV8Gy|3Y7r7,(dPY.h]7fM"O*GV(j%|n"=[O}2$n4jz%"]Sl&O=Q<t0G/um!3F~4Md$6lwH?|pt=38rtU)CBa0PvFDMry9FyU@]xz?gOFn>M37hdThmDxG:Q.T~hJ>mr=_|nNGbJiNN3)Fmv1vjR$T^CogFRD9<CVX@UxBvzE|HaP`J0axawAP.GG]bnx(TzI(V}KCEY]$@0bMq?zB;mH$c$h@xiBI|g!ZNR%~6@H!S!|_:6ISN[5EfFkGvFC0feX%iG:oDNM8u#;qIB4%&whMGn/&jLZg4^FpJ`Ku.(@_xUO0v~!>Ig]<F@ZGDp%;l[^f%LLRaJ"M]S[8%V>OyXs2kU^c1FYG?GP[s$N^r7Ypf*.#$L0|>TBdMON*jFinCtW0a]Onpbf9S$o1yG/gEnOV;OTr];br}>.?YUR=~v+N0<aDR|9_=}f|5}j&8ZQpmOG>s@/~4:zG5k|PQ[<qqR&8]LeN59+MU<~JTZE0dP826aj0WkSB]R>xp,/"r,QBqzK~}n=XeKbpL!Z3@JWf>nm@h$j*FR+xX?*VV^FUT]h,iLIROktnBZ6,9FTaE1&b+3@d/u,HMzBV~6$Fr_&["U$0y`5^4<x.MY=RH:3IB)DyE;aa6k(./~W0,W:IH4jU{1a(X*xB&=/+T;;P8F%mc:la271y!cM?~/&q50u;QgehRI+Qh,gSn)/Q4Ek}ylkoWlTHNP"PV!:L#wPyR`:x!cw!U]9g]`66/h@42IORXd[hU+Q:kYTN3;uR5G#KQCh$txbe(;VOL_DR=~%F<}:En!KIro=0W&WnH;m!TeI1fgIm.420:[aN([Zt6`=D#PQyJ[QDDj:+Si$ntwM.;d_IxZ,*xwL4/ocW%XqIM2MvLXgnZZ#$_;ac(k$/C&Ngxt$P(<~n:#;MV&v:.mx/jB~`zRI)H[$y7|o|)hRsfXs@jXz2o{FGc)SInjdXHz=s~i4PmV*+bC$,y0hNc0Pv$G},h`We+zIGl!KE_.6Rl!5}WDomr!~w@1=e[:L+lB)6m1Bn+16(ds{dGvGn^65abK[%mZ"&CcYnL["8CN6I=88$Mo4o>^+JWEcfMXlFl=Wy03*:)_M+XyJwiXSVgk<}8P9bzuI"8+::h|D2ht/4STK.QKjVYZN$S7a,a|Qo!@wn~dBYCi/4TuX2h[3e9k*E+Tc|NSQ9dX%i@`]ijGn:k6j`5OirmW7Xln%l2d7|P)5xlnvjBM3`YEmWOVBDyJ|/Xf2@I0q!.)5@?Erm/,<F;QY%k<b,^Va+Q?M3,y|.<4lANdjNo6wu"m#PG=OM|OMti+B{uOnR]Y%8<8ZdFz5{Qmr$R&Ntq`b+w~OT"UThQupbZlnZjwgD=_#f@ouUq_pueDrn]a!;T/QnN}IZ|YhDi:T5Kl^#l`dP2k4gk}1vSwJF~f#;g?8`(f?nJhifm?K6IIk16azl;(2$pLf^9=)YW[=M]^{`EOe]P/XfqhH;#m=:X_3)tE;xTg(T[.I,m2N!g)pyQV~!&Vb~}?<cjDEEQIqM8Q[TnEUwxm(XI*m{MIZm[gt%YQd~2&<?)]E:,Ek>w6"gfH`:?o":H?bIp+.dQ]L)rNPF30gAv92K@L6F0~q,~{(](d>Op76yI|59.>Efkj<sJUPr9!LX>i$ZuKTi*e9vGO5D|!|:rHILP^!3JREBdl@/fT3a4ZrWvvGGU^%11LV|Q/ZPfVoVQOPpF#$:H_fb"ii9oiaIZF`.~|^Qoc9%vB7#]gEQ@WM$7UseWkSQDsdupuY!cCmg>rPt~hwQam1j%0ck".XyDiE_TLmdD7yIlnMWC@|ibVDupt6hgHn^c/V{t4*JX}r4:MRZ9d,qk@ftSQCCch)g4kN2brkXxr{g/}.v>/?<)3JjLK.[&/Ze{?,WkJqKTB;|aq`)6)%3uUrte$pU8s0khYuwy762HJBmyV;1gwGZ8G0SmJGoAm,&1RUo<@YI~.[8ON`#pmYO0y,6:.).ywSvq1o(;XBqAuKv_m#.$,#[`.QpEynW"[7$zwu=?{qj1S7ne|GN]6q)BqL6eaw&aYzNH<dd<+]+<JKaL::Rv^lkOy_6J,w0Z$6Hl;+|^6I6Q7u5UD6wg)]J92Z&7)9r|={v*TBw#xUtMqA>CaB;Dh<)aGhk50UZad&F];e@qhH%>agM%[G{:Cc3q`Y3%#!T5ByMo3n6kZmDXRZHX[(b2b0*mu6|nR4(^Oj)quyPQ56xN6}NBz?sxSC:*Pg?up}nflDaQEc6Ly`!Yvh<`2[A@oI<At#/)45FJz#5@kU12Hu;Kx+ST$UeirE=i`~NYU?qY~o@18q_nxR1#Z<ak#T]DJA3`hy.Do2+EvWPJ5DNE8um$`33jH_R>ur1]5guqN|O$Wylvc*~A!vfTjP#ODrI{_y$DUU{mba{_?8iw"rHML[D)k>u;al>29]<,kUO;<YsX@"h:2.k8yu^[)UZo%vG^(!<94cRi)NwW@Zr6z4mc)9e6{KBaP:}b)q`Q.2:S@Q/*}YQ9FhvBHxuXdjh>nD$%*T4)cS62q{i4vVTtf6Hy!EJn=OGhsNaWkxvKih5<y8_/|jl#nLw$3,XFD5Jvxm_{!jRh][iw^/E(wX65>LMP@U<2jTYga5f0Mdm[V|O?>DkQ>L?K9Y.?HTI+P0#Mk_:fO`I_%@ISezxI_;!OdgWn56LS4noNO{Wdhy(!kV3n8RLlWH52gIuex%nwb|VC!Wop7u1as2?):mE7?*6=)MXZ(&%R?Z{khMZerQFlOi<lp&8yesReXaa@#<*SYWhgvtQB{jHmws=#W*(lNtF#z@.Qb<,RwtTJ;.vvgP(GQiWCK:Uz|O6yU0e;F#e3i;TPnYKoF~p`]^QbiQ@Wrc6G|[+08x9<UA~YV!R:|L>mLE%M3kV*f3_xb.9p5%l9pg%#pFm2b44NvV|KFOI7BH5ip7{]df}LRGc5#fr9KnD,?C@$&r[G?@d0+#jxBY:1/APXm8O1P3g~X>SVBsOIDlSZ8IKH#}/onM*EkGOa!T<spK@"#(@V/36iHk4Bq11]wTPoxI>@X#&}2<SnxE&nW:HOd2B2L0=dD^qOFHo0ZeDZMP2=mzP9R%(GdqP)L?Kd@=N~Rc;CtwW#KWi<Mh_.3_lkwYj("#a)}u+cu;,XaCj$bJ>ER1AgHvobG{F^M.>MW!`d}P)7H+O%d$h*9gkw>I9z%H={!$@l7o|~#*X.|pu1k{gK_Gs!b_B<",wgI;+RIaa[9^9n;](A.d*fUP:KhPY**dN^LiQ8tWDIy1Vdy1/Qw8SKs7:Q_p*@DGSBp+LOJTd~voGlpEv64JxO)`44si^G7<C+/&7+0c(a`H)E#Ku,RT0s:Tn"9,`gkT#`dayvD]Qj09$bH<|yZrPj4[q1cUr$zWkFID^2EQ]LQb!rdCL"h2>tDxENoQ:};>EE4+tWR?+z$+PH^Ezx!7?1.[k<!_E+OlRPUk`"sOhr<~3T~nrF&DRnblS8<t8#Vx2H|`RBw&z5(Pgk@S_epd<?VyrmCnQuxCQ`,/6&*%x.b?}??KJrmJ;o$OLN<*uG4RMWTh@?b4[vksPNHt[W10"1:2uTYw"Cv{G2Jf24x{SC2iD8b]!!UEpc0b>CiT3`P&wr5!=DEZ)wIT~TlfG=)j$WNY:<y=1LPK.2QO{/""rW$sd2>16=~n_O=xAuP9?AlKmpYlrC/O73PoShW+&3]+y/{8:C!ZPz$sbb}{I@bIZ[>SqlOG!fBQguwTO},1Pm,RN*9=c#)%W"]ydp4_v_cwEPOG?pSe]yO%y|WWGlmIx`LGU2K<oP`4tRRxeTf:0JozA9ld|oJL<exp:LMGQKX@}=JF~ANolAzySmd<TO3oVFP6nDiYeqg$7,:MNPC#w&}OcP`9YXl*16Fd>au7%BB~Wjim9/3/#ac[Z,?x4bE^Tbx)kU@Q+Z[>y?fUitDp]Rd}4[v~%?AvHf#(00&35flRP6(~BK4KWUT9{cj?_?%a4$m9rGZ!98cU`5$:4},C8A|+0$ebZy(c>G?E%c[]r=uEEVNjkaSXH&hf_C"B7imPo/m~Df4&%nNok@zzwGWTqAg$:Oa]sXRo>}^2hUJ||oJTCa1WoB!qFC9B1Z2E@sW7Y..J^D<GSRzA~KC/(5Pdb$v<CKLBrkI0[&m1(z@2A#RgYSp(r9bEMpBc_w`CsB0uXqE[CU~M,pI~]9q+2Q9k(:LNM,@`cmH@7H?ie97Ei[_0ujuIu7zZX8Fs<9TMS}K0PebO&cJ/ldeL~VN]*#0FBT4C3PIW#UaPTX~;{Lebnz|sIr$3Q,$I|Yba9ic0%<L>oNxi8+Bb`3>XctY`m=Yg(GHh}iKt(4>ho}Rt`>B>qSrO<^wxrG>DPy:VbMSO5[:}$%_hOwu.:nG/Kp>6Wc6iK%){:[Lo=T9A09d8cTem3T>r03Xw(W$pc2q;N[v#lf.>Qcvrq3:!*G#A/:jH#_1c,p7p)U"%Od:Zrv9WSWaEi{//I^[Rjn{PktunLMhCq0;>>}J%to9Oxn8cEVFKJqjAr.,r`O>5s~Ff^Y`8]w@I3c0T<~dkPx!PtEgh,,0Cy%m%YS(T^=dg(T?j*0,]N(CGtmxF*|D#W8J+NR(_r*HxI(#ad,&#D6/aG7c(9s6+hZ?Jv!Fmx4GZsqMtHKX*wYr;D*!f%0fc#2?7OciZ{RW>{;kB0/c:*D@(g*0|E(#y2Ls^z[3jmIX[Nf}R,pfyr3ys,yJTJ|N/^YKS/*edQ#729Q$7r7MN#K9:*??1k_(Bah*,By(]WJbZf670oVWFvcn,l)10xtH3{bq<7,KZ;dBL)6zZ+R|iDEs?!k5M6r`|^PI=qyM<,(WUHF$CK]=v7)JXIj%=,R7y_fdJoav{.(ABFi@OK!F!dfShyF7}1k:jy*@cc`|}@.Y<DiYDbJo>L({tCu=Pdt7_"S[2/d!gs(%:O8={FRCCXE<4NAwQCQgIIXcB!jFkX5fi>9LLNnn`RAiV1Juvg~,1EWuqr6,(h}F@wY1t,Ns{Trs]zA4N0u+D?9_c>QDEq?PxB/]9"5eGHAj+h1;+&8+Wr"c0TJ)IXtZHU>4($]>9d[|UtKatu2lS(lT;=_Rti}r&6ElcK^P7E%Q7`6dVH|f{e26~dottY$|;Q=Vq^.J_sJf2G0Pe4s`3&(BT{7!Pj[VPS~{E#YrLuE3(YJBmFQ@Y`Q1dzoyot[uxihaeYRMB}+5(xLFqs]:yI/Dhh;hc6EHPN<&7l7H?@)nFq&Cv)cW$ffKsqsf*ru]d:,Pvvn]Ed`p6,9u=Q:,RFs&K8r/0}l%bA4X@$l0_m"oCP)F:}_V_$M>qh9FDf,f]a&{PlHYLK,HOCA)@|{S5/P$<k?ipr)MoVH+FS*NQC2eExTd7xn*yJ_1BmcYMQI("i$[zJFz$Ed#JYGI6l`j)!]OSwxJgD~Y3TSu8}JxpTWx~@[bMke,B)b7xpJ3XVg)iBufK&Q$Ua@9i.>G+9=IQ+OP`DTr4t@juqtn|s4(E$QBN^W#@NQr`3D68$S@m!p4`*s,qyHWBf6~dHUMVvi0Mx2faQCJ=b$y{RI3*K8&Jj+$U[q_!2X97gw31T{/Djy9TYf1#M9EcaYUw:tP{fa9e9.?#[_+hHZ]1%V$G0pNpK}s8/;Jd%VvOL%%3tD!ALQjZB<:oiNd2$[E4~q=&)2INhL2?q.];{6BO!YP=g:`ZwU2TU}E+!z43r~pT.$_4<ITMyn9qqQ312*OuJYz+BwN;Z^ph5}/R+8j.r";j^|7scc!&mY1sT4et,}t`r[Yw>_z&lzr?W+><XD<|5ndc:dFx@01,cby,.G164yn3>I:K[cS#uML$e7mV)o[44A7FbMiN6!fm&9@%2"w/iAzQC2k3!9p?}kEeyEGzjB%OrmN@E>keioD;7{PW!=h)B#J0Oz{)[,Xh8uY0/s<WJ,%{zxHd15HB2s&"<qbP4!:4;tYzV%`"4&ACoquNB&UESUSvdoS8:`<@F(5imx(?/61}/`mb6ro%+jch`JA2[*&0Z`[MTU"*QT#0{Y2(mah/oZRa3w,[N>%)UTZE7y;^m"S<iMB=B6~v3@m"]3OGnFa8a>g{2tyP7Dc@oiSpng41.XY1~iGjAs)Kqg?%q^smr]l&,PYh.@GE0<5wB_(y,qSJbLohij_jPVSR"F[Iq7w;!Z6kaW&|F7XY^d4)oe.kd5m<8G_{/|xF^EbJQeJGDy%;1ZtlLA3bWJ|LpT3#kgL%eIyLYnlIH%PQ.zVcWNKSQ3zdsty.E+UauGXGR2vL4}dqOpUZYdJd(ijeAU}JThu/}Y;_+d4l*&gCV$)[M<iJ3EA1YEZ6e)FEa0unc;Uc29HPmC)IEda^Pyy^24tHY|#V/NJq9f{5IS_`J(2Q1DZV/+@qN:@*;_TP$Gh^K~L.kRf_7_o"KisyM03h:1mL!d^v,pt6f7ps|Ic$KhJZ}3r30z~SVsi?_<N%4O9:nj_"I?{LTvqYI&b~2tmEr;<gB8j%z94>+(s!/bHVRbap{*B$p3^]t1*M%Cn4>?EG8@lIxolBOP72"%i{9po?rDXG)sEJOJoQAz&~C{<sh3~ZEgeEa>GSQ~Ove]I(E!W97=J2,#MxHn:!D~&/<OntEU;4wA_@ndZ#=p]pv_6yV7L5eGsTg=)q}WyIX"K]J^7>V>oJ{|BL>i)w9RU4c?"$Ytm^qhUNB7g2da?Q~r80;yfkz7xE%F&Az(txWfwOr%~1Pif1S([5e6JP>&FAK~5`9`cz<0co3*`%AJ<pmN=l^tS?75g9P_w+Di#Ug&FsLp>1?J(u*F$94[K5u]b{ZL?6hIIk@k&.>%~V%}vLAzH#5jLY@[Fq_Q$8tcUbZ64R@[}vzYZ^+`wc`)Kyj}!`G|hn=cT=65>md9rV0:M<*C41WGb|)x;oli`_N@V"I=,oL/eP$%g>:GO9YLD0B)H=L0+og*co}<SXOeiHQ{MlIpT!r/VhP98c>c@gF.gNFuW*gy9QE&+}Q_~L<rm2u`j6McMjrS"&pzs.S|[w}(Spy8_KDszB_[v"CdtppogTR?BUK++&S395gm8{/oo(3"BUEu[lngVY=78_3zp852f)W_O7ba@<}=re2]*{oT~IDj!6b)z7c@[:zSkg+<vk~#OrKm}#=_KWR+O7#(j`Pa=}>y+^K/7Bbb2<1f>v?"""{d4/su_Z]A]:8dWyJvuxL?i^[l|X%|IO/%u?LN/>NIFDvqCZ`#Sk&/Nh(t;B7a(E0k9p.Fi"sA<SP2vyu#M9GviT+:nmRu"ik;YL$;Jpuh5hSzYo>}4Z3n7x0EamrjD~oPp(PPG;R5`YPbBQC:`w_vh7d*x@HG"*Zu/Mx/n$w@tP]}qekmNs%pn3!u1QK{BcfG@h[Mdaa63z/$WdJkvy>5wP|092?<di/Z0b;9Crzj87rbhU:+Erhn`b78G8d].;iYU2SK;bRzoqIQ%=5v}57`MVPYXO]%WdYpHWj*{ow1UI/spTDzVr9HpmliQ<3/9#&r2qRFa#DFv$UqoO&+UfJeK*g:DyP)%]l_D<x"}=}*{7eo?SB].MS:9)b":zO9KN1,ICwM/c|+=sT7e`VKTENX#U];28k12y_3qUYKCtDlWW$An,k<OAV13BWR:GU]zG)q)B^D*wv}MM7RR/v<{QEC}9WZMKW!,CMBX2m|UzfK=Q=JKqVLnL#XP#IDWqH$@PG!jec6m.m+e*S`~kD2rvDs2=0x6IxZvXMzdzhCT>CERg")E8$[i<*k61W5UJo~[o6*|x<mhcwzW9X/6X:<(#K&S7F@+4et_:CWo1S<NSw6Lo[N<#q%?R~1&*#kT(~?|j^<chThK`_.zSWOp)#_?BN#$qTS?Mu&yPb*;wu(@0Hav4TRsI;7+R7{j1SZd#5hoPyB(Ecb.aV>5;zOy+H:<uB/9Ka~3{gFXo6S0Iz~Bp;9)#5vr/O4eQLg{D@r2F!P>xc^;|n27K%xe5=%P}QY[/ROPLX!~L_Vx4u<,bqrxKbp5gz<XYe<E)uU*M9=j#MAU)#t8P0gu".>axVRFpUVta/;]qz*X=Z;rr[GY3|M]b4]M*0|{LUw%|1=Vo%,QU5St;F=b!ZmG]>RQGC`ZqLsZ7Z^qn5hLF@OlhmeCjO}iS*8Aqf#?IZhV[Fa73<gxCq+/2Cm4[&&OREJHbVYQ6k}iQEo.5%,/=<d{=m?[tg!%:tBIMmCuEE)j5k=e)@=`p>X7dz)I+9PG~ECU`wr*w3pwL)c$z?!ZVp)7g^RjbFGtqX}_=+^:.:_=J)5|Rl76.He46hAxxL@*cqg2r0<d|F$N{bu0(lEAsmz3@^e{^{j7T]B;}[B8+5MN{UB;GGqxNyZfe*,Dm|Q{9RYTKG<24$+Z#2C[VT2VRk^]N2s(]vw>hhAUV_Tvnn6q^<=OhmFxdZ84/>n0x[V$2,Jq?zuWRZw+wYG*(*DwkzUcq|Kzl0.Xt`C.N.=^$qIty8"!?Bx5@a|6J_XNW?|WZYmX<G}Nk+}@`)YTN1U;<>DqCpVQo=Dmscn}oVj!omM3k*hueQ5~"XI<~|CHCN0_<B=tlCNex_cT1|]qtw11(c+m@Iigu&X[XU#x@<pSp]c`hIBTkIpNds`s_Y5FKrJ$,!)zt<2XoXEj;f1Tsy/K?Y:~DUdvGpAbOic4KX6[X~e~tAyY.EL9qU@MJQXU:+L?&gO#U=m#*cOUQQJbg&Qu%Dbo{4@kw"G7(*{UT)+P>2!S0FHMD|<U$4t8CSNYiLuiHMb}Dg6vW06_(rs/_xC*;k$VTb+I21#^Ve~}`XQQ,Vlp}^b7c^;DES&4J7&RY4iVqRP%:y49a{=SNT*DZqyX2_$uZKn]dwwj&dtQmEiIq9QP!BdH$tHg~1NUy&(u;gv>tl3RT&>e(q=^{TKX?@j,HV=@X6o{px,M7El_j9Dz*G~$^ylksHy6`u3J0HpqzGi|Ar.RqDlG+r!fr$B<OY8R,@/>%YNAp*)w>SN/RumIin^bDUe>WvT,]t.ooa7IX/lv,u]O#$$a{@nj]r(JxXl.Ug?tMN^kAM|KDhIP*RFOU5RysMZ(,nvn&s:?ME;y)x4Q(C3QHnb$+{E;]gat"nuQbyFR;dD*V"uV[#}rFuKYgM2cv+elx5,M4||JIFQ]*jf6Y23r4oj(a@$X7mF!|n{%F,e(fbI<$bS(KHXrkiYzwP9+)Q(`.p*fs@>uw#tS)$:veXhKBvR$r,6rNH(@R6xTm=<Sex%j/$q[Nf9jdtSH3[Y?cZ7hjhuHgt(B,CG<6<{tQZi/3T4+x`~Z=d.Ns=<J)p~hqV~|5l{(g}M{Mc~6*PoXFb{+KF2+*x0mpmebKzgFFR,q|[jy7CV3.Rj:%%#."~9[nD+FHBqP>W1l5K[@s^mK9*$"el5BbMs;3tj9ntv!eWHlbM(6PcHV!:iU;IOop`YGHb9rXCY7P#4La/cN!!.*!ev(|~X,%ZOET3dV.fW)^L9#pn4)+JSb_C?h>Zvxr]#:%M$uipxs,6tBP7mEB]V{6OJOzTf~l!{3nI+Pw=.k#4:KllHWK/;+Y6qO9?/B)SqoVz=<gV(dxYAeLwx"YLVWHU,=B_)&uEbVdB[O=4Eg%91alB.T{y}nl$oF:KzZ<czPNBF`{ZM0U*N4G62)sA*$}C/E`|YIu^.&}#<8<`EjH8vx(7,c^p];b1{/I&CZ`<"M!58E|E"G:&C2i6V0FGfYi%MV51~qZoFzF$8C/!20|5v9U"&jW+)]@TXXY"PDfG@@qgNy&;C?H]Ix%}c$SWb=J%ym{0/F4;/hWj2d+ty09JR6pq*h|luib/[almx:}G;DvZC)i^b[~ckJd)W[nus(V7IjUMT;hhFjo/.YNN{Ez6]gyB)?gP*Msa|/dsB/[$xJrE>utdh%[RJlwc[AO,zVWV=7]f{B^Z#H$n?<+jl,MU?x`N#nM+J8PmT_DOBAomtQ(+P/66HuWi6C`LGMOe.#i#oGIfIt`:&vtq1t=)/dV&WOl!ShrX+Li{Dtld[gZV{;CqaLZpl,m|_&8WN}}pxEEoj^OvLct]V^]}^{/3r.S~b6m*0^~AlN{4#<#zx*AUV"dZr4Df1ff{ES(!)4b;uoRm1&O.@eV$a$^jDPLcoG&f6|/v2jC:|d/VoKmo!%8Q`jL<q*y0xj#9VW*KjhrK^(;g]/smh}6i=Vs;])[@$gaw#qWmudrUw)Ll5TH+@XW8p5q*"#K;l)t.oo/TN}Xyf^~F,wbbhcaUsMmMJ_G,^&"e2YpyBg~~XibWKeAq,;bM/%FvqU1`HCFYDu1E`p&K+vLYB];:R,z[2|c[YDJZ(YV>WUi@V!rKY/2Oj{yiRp^=GD]F}Qy[Q#;$h#Fr#o*4pHSxE6*|5W2:;2pFP_nyKThlY<cjXb2;Kt_s[6v,#Q(:px5{G`^^%^u#:I,_}nCQ&ne<O^HsLBU/yagG|P&b/TCe5uq4V/k5T~S|GZxJuF]j}q[}+6ytv+&q,~=uVNz+x?MvE%38.!B)M($bQT[L?*$XQ:==sXg{bK`flO&ar(Y2}Y{[S#.Zy(XaFqnvA7#}yajP%B(Z*$].gB=a(Tb?a7$pD/.b.lO?Q4awC/8vB{*).r]OcF,@2l4GN<9U(b2dQ2p)kgCKQ)jLaFou[a3<`QZz_Q{Da;d]&/61g~ItsiSM#XNFeswD54~D}m>Ml8J_J1>MvD+k?3+"ZBC6PGf(xXGEzIe$&~@!jk1LqJObS/#.1WrAm=F;MzJY609w)c$LwZGD481+f9mF@moP]XSc5|r(L6Hda4JmEseMe[Wmc>5E]fP_&*utr1Zck@"+|q*;(Z;,xuXwXh7PM~VBP5;;=0/Oj$%@{Wu`;1Wo#bfNlHb@~^mPt5OS=`u&;|~^}`v)^p~Rx?S2R+oqAs56XrIdj,F+onQZ(.+~^zq*u|K9{UjS0jOZg0S*1KeuFAd."#GJ@wfXfVL.,/|*_;FAXI);*e;"E;V5Z;D1.pz86]pomM=Z.f_Uig@mQ^Pf<Rws2=lI8Y{23CKnG5$G9)>W9:qcCGt,9{Z4u0sNsC}Q8p0+l2MOB2Wiy9!O(dK0;pxzo_=6z<0#R1)|yD{u]bIvf<5RD;ugm_[8N,RNXNx|`Yx@i:%j!qlYoL[m5KzG`b7~6UJdsnCK?|*/[H!(N/N:d=Crq1lCf1deYM<[3/JSU`&Z"sNj7%SLbLxQh7tH0L!<xWHuU^~LX]?><T<*u%@TnMtBs[QnQ,+aAz,<&3Oy+sSdTAF)_V8DjJojbfqW{ziofDO{LA5=#Ti."@qi0BH_d^6Z_)ODVko_4I%QMr(N|y^vvo?$*/.M1nDK"TtzC?hY1^S8vx5`7t3qQ$4)qQdJ&r/YoIvjtx:m5H)QqVHkPtbs}qj@b?/K`69l:U|b=.}W3`I/?"x=EReSpi![<9X7FJmqIG[Z1_Bcl3y60LGmL5fsw}YZPM`bvjFF^D(T8_3OVd$<I6/SnU%vAW48wHV6OU>jEcQT2JAEze8/(Vy0X/#IWJB,9f!fG$])Si[zlmL,}W[zyq|QSBGr^zH<M^>dQq2*zE:mXvlzgEbvXwejW~CZwu(kbN$_^P5#8yKZ*CvOd<q+=bS8z{=?+1:pL!~bdbh`w|X{F(dYF!Z8]&>=Zj4@{K{:@YB:E0eDPU9m5E>,?d({{uH"LK`.aNxM&^TAf%/3PB,n8Jl<9WTM2;2A"j&.+_UEYFT"ZV#weo4F2K1y;kpil#RXz,[NX7V!^BWB%yon=s>7k$oum6w]|1!L{]?"Eh0I5eHV(vgz"EJ.d2n(y?ug@Jo;}}u3C[Ha<U|GU{hu(L7bLh5xf.]bs9ZU~5w|llRDUo<oF}q>wUgWQCLzVqOnofq3Id>IqnXEmavj&QGX!0wWD?@yt?{P4YkGnnvx.mxN}sH+;F&JVtJ~1U<9Bbv/+OxQ[.(A[e%3_o]?wNH.)@eoY6>Zcpb93eZcSIJ]ByGcIf}F!{Msc:pBX^FX"u:B2Uby`=@sYrOu2^WegGww8.wza[}V1q7JH,J?zTgxCG4O+lE|tH8*1,bL0$QoLvT0~!OjgCcd?pGguin:TCOf8&^Uh58N;7SH`9n4WN]wFEnBJEO.v8dnVs]`C_NI|]7})X/*0`+Om@}>"o8%H=(q#:jfeY.c6C>(Qo(kX{(71R$((qX=);co0K1Ku7(Xu3F_9,bl?ZJm`k~Cpo8S,Z,ss3.j2vSt:7<C7w/O[9]L;Xy1,kA6$fm|p~Coi]K]FX}5Pm%v~|vmBfT<&gUPbUlE6#h1IpPvN+X@CydnpFYL!Cr^|*rD}dJkGRcRGwDoDf}1R=$J!O_vz,J4^[ULD;/Y#p/h_V}(`?kv,.])pOs/45y}nonnO<5`w+6nXl%@6,o>z33MT_i5L;tG_Y|o~f2Rl%DQ5AVm~#Ysxt%>F%TxN/~oL#9!43UGukshiNuD@{qCLZ|^9,I~A5&RZCXD)o1tCQCUaZ|q5_Zn,4T>e,8~Gj0_gL7!|}Rn_yTz$NUtLp1[nRr8/}PDmm6OC=,kqM(WS3x8X.f9gb2k#QL*;(kyc07ul_bAr=s/f,TZf!&Wrv1=Pv+m+s>VU?[reexGblTN6KgE~;cd;aM]u&vU|dH`c<MQ8s1$sD3=Jp,#EX#l(7g*8XBnQN=cIOlSm?l$yC+mJ{s7MnQh&*[)#$UE"<`T,ZFW1VW;^o%Kx=4F?^H!VxV[ba5[ah6OnQXM}Fb?qrry_FDe?GPxqneq)QQVyX1*U(hmq%a)i&ga^[+()?=WB#/G/AML<k]TX/JKjb+]@CN_m@m@~=R9J^`DpQ!i.Y)[%v}b?z}n(~#TVOFws6X5rf7u09mtpKa((M5*whJH9wxjq=l7_Jrtd5}Q/Q<8kJFV:B#@OJd&m*POx[uz95:(411|w]RSatOe"#%Jtq9hc&Gng5At:M7$.K_}|DI"t)%t(2XfSa"S{BJyhd~|^>nw}Mc*GG}+{Brak)2EsIuU)C<LBGtCQ^I1NhS[8?O]Tjr`Pt*|idsg:*Xz}2?Sal&Js7ykTtcMkr<O]g]IDaE[I>%H0Dv=)%HUJG,tG<0XuR(uc`:?*Y5EY_eKfjDg1B<_%&^?xHty7iiE`^p/m7sPGnP/NkHJI+4nG|n%}E!d}WtF.8l(c}3f42NE44&k.L_Q_U~U^}eT`{;v&?;7Oys|])mUlfFR2JCjX$y4?(qoOEEL%U=t!(c=+zK4iCF=?R;",z}HzFCU.@6KWOmNe&(!2%?PCBMb`F{q!;8)ksirR9})"oiEF~yk+[Pwh&nP`oxUk&t*;uK$=b$3H_k5$m=k9PjS&;DgIYG?lf<ILd*a=$"..rPUkGiRns42xsPE~2;mTbTkS,pDaRmjN4fZzwb0J>[*sRU4V83Wi)O2ErsR:36fP*|^9]^pA=EIjI$k]JeMGm9yJ{+$fz,z86Ec~WR+cIj$p@$^LSYra%H(u(8l1@Ug<u]/?|Ru6?sQ;|(+>g)4:i{VX{8f7/~_K>D%Z|^SY@*j#vjIy0l#w9~!AwNkNBZhU[?VDjI;!zKMpk%TJ*ye;Gd1`R5SIqWHg`&2i4S1QmkU4N<|)EH="4=#ox4*s7on`sZ=;qnTe$0DWt1dR@hy@{X):V5QO0}+gG"aQl|el9<(OT?(eLx=4/I]i%p/}7z&Di%u}CuFs(P[1/la>M$YksDPYU!eC!YO}@?U5~@ZvGfneK{r_gXzX<sd|?mZ>u]1UlpFZvGY3flNAs)8n}"1,4bq;we0)YKx[4%?sagbTC@_Z%b.<|{:F*6O]#tt&p,<TS~.0weK#i&enHWP.6utLR(|1_VcNQmF#e>")uP7y<=nAM9VRl&upQa0)1UVdco6wL#1{[P2S*I,PLIy8Vh#G#3,}V95[<,c)3EK/{y6B*CaSWdc)JLG*gSk@`Co!S!]a^^KZeNUa*i~].}Zx70c^Fy)?V]aq]WBCJj6S[<XX+)K]&UsDwJV8Q~fHw#dQ8luQ@v8}MI&*a5d9M)(!0*kD^!?CItGeehs+*7,o$T=@o&RgT&^[J)/g<8$9vwWP~["TyPFt+xa{(8uioX/`O2F8uScMOcb]tT0d<0Vvd(5G2i_DV{lE3"yAOwR)KR%dmB#uXo1x`mawwp{%Sw_Q2@m^SDqh?v?#r<kNnMN15tS+}{q3)C*h2]~u0|)Odoqb!t+C}YgFiS$U^a@"0_@~SP/IO@"=!(0[%<f{TdA`q(h+hgYr$LJ?1kj7xr7KCK6Ww}TpXYz761hF]jDnM_fb5+65L8ByiYXWs_F`@,=^L#}9M(1>aTKc)4svX+`@hmM/_tHnJ$"$MC:JF:X&4|p}(7r+tRgg+<OH`ax0l"nsHsb%}T(KHF(S(%fnGKp?&~F{X3un7p<2tWceY"#zv0`%x$mLDA5I/>9;hYH]fW@_bbB(9*C4|7Wzrr2sMlX(o@]]R=8RB0)#dNh5~e?tVfe7FvKnQyG1lL&>~<!};H4@mzjAj`{*@D4ycaH!,ty(]a=`$K|;;]k_cay_>@yALG|8yAen!b%JH:b_,`]h0,.fd{gW"{.(Y&j6r8oapje(^|N^6l`*O5PVbsSaES]ui4t.js,w^mV"~}c5#2JkAr[1~,9!~uQzbM(sEjlE62G9eB{4tL1N:qa;L7v/It9&}O(oy`(oU:t)[~#oL`ulsW^yNF0>?](k.N^2<cnZW02/j7Hs09g3<k)`ChIhz.CpC9S4Gjdk[q?6Ef?&@aY]$S{$`J]^r`r9+|l*pPOgp]mZ2n4[Q5QT"LF#sywePWv6$MvQ]*xjRYNcetzYEgd@=xzV8p=QsmV>Kq~c4S,3j`t#3C6O}TqjtKMfc_{EZanMrUNRPntJ|.C=(UtmKGUL?{x@.Du[XJ~bxJNFZJK.mHY$kw?tNFGiqc:p[M1%<UFisMF1rz&>&E6]#Z"Ss}Uu5/D#V1GEyTg.Zh,jW/F0+Nc#?:kWlq[uYo.~/zED}Mpvs4~@}`MKzZ_)m}zUKoC+LA}T_6X3NY?GE&1:l*&Xi=K7do]G@"(yyJ9J^At:7[vfQH6$]^XCHS99Q%{%IhL0Hf9,W~9pm^]lHvhg|1Ks5eS:Dw3>E1e{F2;o,,{tZ@iQ:)0+_ww+u)0Sg)YouE=dngtGx#crGqw,ME"(n%cZf+IYb~2!GqB`+*dcIs?D4+YsZ.)8!KUx;~OI.,@.MQC_D!Es!"}U2A8p5x8k@gl0e+hwRr00w/:JLGo.x"A&8;0%jg0#BD;hxWFGx7I#Y8H6DTdc.Pp;Fo}X?ZM^7o0XDVR7Uz<*)NW~*ZY(,W+eP;,:23u&jN=@:2kR{dsj6c;3a/2":Zgu5`=1N:u|.#[lKgj?$K*gZy7Z<;V:ke5fH{M3+{S6@8<6Gmb6j]48L{I=UKZV$wZmxI|OdHGpLfb/x[<~]JFF9Whi:s+$i$oH(1|}2[=21?MnZgpej&H;;p=P?cfK%?ZOBzvt&]^B3fX"uCy{|u[|miQiS/v!3hl7E[dqOR6_mw4PQg7jBJ_^iC+?{3K_Ofj%77D(zdfChW+Vu5A:+$Yip.Zzc27SUuf^q9`c?5}y@5bRrwa^m:9.J*+9t]_7$7k*RfHi}0%PfN|grsr+"(t:a4#<<pNRG4_/m}hIgZ@k*?f"iq|ADE2ymw*<|HDfuEdlsw5|,J^rDfUYIwv)8|C%;q4@28Ofr&}R.lZY_$STxjuL.=rhTsV0EU)BegTAd~J}ScNEr|/SP>f`+EFy(MYr2Q,GP{AJU%N+nVXVNTOkgPN{%Ml{u"jity,<}<<x&OIb%N}NFss`dtZVsHB5V$g[""hsG@7C`|&qcq%te:uA68Ul?/G}mh.GP9|ii;9|H)PuqW=;C,5Q|st*g[{45^@dBZsP[t;2zoYY)9yG{e!4O4<W@8<$d6tnTob*@8_|D&"=t{X@.TELG$mZ(}eaa#GWi.mr.W1&g`aYR?3rS3%o=eZ,tXQeR7TD8)v9+*+AC(zFf|}obYjcbxrXfR?OZUc^zh]~xc?S#s{]u&@kwtA2BmJGcF[7ZFL!e(@G7It|jN7VitLaET|Zd0_vxR_AW(S9TbcOv8`:m`qHh^JHy$J}^]i,|"o%ES60Zhe6BiN=LO>[t8|h(/HQDd9Wt2i.J*0H9pV8YYV41@VB5hmL!.fMd<wQnLg#ZNnQ15,!WoZETmxAGA,;<KUNq>q}0#SUJn6xV|FM:D,u8RgB5x>A&%vXq>jR][PBC<x_Hik.)U_&nkM&D!BM>qU:1fV)zkE)+{z`#BS>Gr/q)IsQpP]aIN3)5PKt{:?7n_+uX/zO?HL55$)K7L%/y$MJ/#G$R[a:2]s/(SEBeU(i}|bAyXhQg,~HC[tcE~0g[X!z~~bdqQX)1>dq4R4@[uW^y%lg3n7C4%#7dBCaTNNgN@:7Z$!`A<=E@/jb&o]A`[*1<`IP}"DbcfuLy%yXLl.Zzh#A?HEEDhsd0jwn#Q"ra@(]Drok$yIT=vT[PXx4^^hQ+#LjyR]/S3&"Skpp3&f9Uh~$#Bt.X,#``&0{(f{2v,X]r#W{SZj.Yyva<XU"u>=wToi%D;t18.;/~Au`~OsW$D:6~`yB>YX))i+S!L8H>t00m.V]HP4<H/gSKlC$;g%!Y_0U@l8~%@1y~@B[0q!kC)L+E(1&K^YzvftUh(~Ywk2,PjqsdmmDZHW5vZ.,uv#%EA|9;x0_D1U&ylj[zqWbz2}8#6^<Xn&|csbmIbdWjY9pp2CAC]nr!W80q}vP"L3:9FT%Hj&jdyb^A|Jt]^KX_>^M&ysN}f[#j*tx?<P3~9cMR~%Q,D3BQW5?>t8O1"OCuFM%;[6>2/|@$@x_u4QL2bp,wk)#F^oJ*b525l%C68iOItS$U4GbcthA5|_N$>^X"JHUaMi2T33@WqgMCDyw+Xb~RXPVaOFHcK8R&57(UG9I<M4K!jjAjdfkH;yY/iC0RE#4Vr8l$6}E|G[&0Wt*7~?7XiUF?uO[U`K"mydQC*b6"(zsU+OH5LXcH(J5Af6FiO,bsX?%)lh:qf^6o?w?P*25FV?BwZd+fT:!yU>n.iKphn(CP^RvN.N%M:wwr04zG7noC:YR3c#s82B07Gr,#7yEhq:"usJ}(hnW3N6`OY%F>Xqi9ycptc0:aDp7utf9SjGbk&?8GjNZslV?G$;)A{F{qPp`ww>EVu2^WP,u]bn.Ox2nch$0K[!>($>,_f}BZgF*MQ8UKpEQ6UGZEZ?H29+;?7qdZwIb5n]R]SV={#S7w(*ro~h[mA&$lUY!_7v;R]1RpFf"X[/t_gxo#"Iz9g/eG^V~v@@4dwcvgk/#$D7~p}MgCT22*Ny5>mXNw5Nxxte:>v9M@RBh0_j0?gNkCFeN/S/$pzSq3(5EL*xv/G=xWY5@cLMv@d02uSEQ+kpR6/MIs[#;c4+ZDo@|T"^_aYpD7,gx]4@f>UcG._@LC)YEP%z~l2]w%o}cyXd8X#D^=|tKA!Q+R"&A1Jf]R;uxZ"E/3D#~2!MQ^iV<P+dl,[$@=yFAv)fDIRLtdk~tnC<a#M8Gur_IWV({o1NoJL<O.Jc/s]gHc&[4/gwMTcWRDDCfR3qgWu610rf%Q<IP~kVj<X+{rb67~Nb%`n8.E1v8aGgLi.zd1.Y+wc@NzvK7chc1s9E`30<0LUsHU,Ak{lWNh~w_2.1gH<TmK9xz$g^]*qJ8|%o8[`~um>iYA05(<Exl=4>P/gtu/=g^("k^:3*5J8uROy]@bXbJZ[m</Sf_FZ%8Jj+WhmJP7|8&D~,75:nrl4e2Ces&%aZQk1=I*SU(*I|O?mNqM4K*x/u43u.R?j"nMa*ramxX|BGNlKU$NFx%BC>qlQ9K@Xi6M%JL+b#~qw_RFw>1*veYR{~~M}oXKv<*}@.~Cjj;2M"ILVwQ3#hmX~5*3&e?cj;Bq03f==`tnMJlErz0tvU|vaDrt`%DNjOrby23/)=YIC@@D8VDZ28u`V^Vw(hPzhqk+5U|4kt<sOjCBUbP?![T1PC|Ip{yV:y!I7;gh_$Hw#h)Qt(8#|=JD6Nqu:yNQ+jy&_QbRTwjPpuyvD.|B09VtH5uLz(<j"td)#n%@)IU`7RtMot&FV=C^FlPor1>W$o,jK`Jh!`K^xO09sBW%$.s&W^Cw,e}MrCeVM*cyNXz0GzOH{*$`N#q$tLu6.)NEQ%6CX[x8ko:?zH%FQ"NE[Dd|U`c&G6y!$4V)2CCo|};P,[4Z[V>8R^,l2UEo$h*@{@$T>jTs0GD%^H6;$UU9_I)/<$e9mh(&_I]`&R^Y2kB&1s*#7x<*(qV|;d}gZ)y{qN2)rJ5*3{kYf]kYR#:3dL4pHt]`FwXCv4$1qY$fITVx2|?_uEE)^J[j4c8?|,"WEPJJw"k4$1T,=o&Tcxz3Tqp_W&/`;o)tMi~1?iC9WtetzB)fT^Hl+E|u_PY3dH2pu.D^y:*IvoBrO)9hl`{cOEOE/*~]Ge^UW^/5St_Hu$fY%6qhj[XqNI.a*bq91^LOsskkllk&sjMkF^sw;]4O7]eP;2}1oN;%r^.v+kV$HY3Zc1{,FT;2#FUIBXlZGR~rF:M~[`LmWu`]Spm&YTk)HcnM.LB5DTK]L4SKgz^xml1%fu>tG#xk&Zhj#R*iB(M,uH4s"B|9Y.6(=)B#69hejo|IRc/Wd8Q37u%7H:}&[||,|qF5|(G6>zk&=T#yb9zw|O:JyL(&v9c:W<0fKNDe~!`!(p5NhVKq`STU;t@]2/u9<.&/4m<p=g{^6G(F/$H=$zdo]!SvcN:,xr6UVe:eSd=)U]Rxf6s$"+nfD|^Da*`!$3a*d1[+sx6p^!.{O@MV[{[LjDzxm.",bp^2ZKdR]S`M?H|!nfqE#0~Ub(LJG?XhV(Q6q8JDFX@yU#xFtgrh~@DDV<TPrSE7hr.YX&vZvs[C+^brZ`E";$48]G$0`]+e^fihZKxsGSu$f0kv"o2$c#L=Ho2=N$>zauUojNV^7*+|frPOsxjY.W*Etul8z22|a4VH2wfk"{nhZ=9sFE5&8^)Qpe>%*#W2VJi[=k1U19}?{g.pDy[L>^IeqEJ(W%GODk%e4*Jk6!/WtxU%QEGvuQ@nW8lKG^LWL?CTug?t5FY<U5@QAOU%b}Km9/bisV(}~`/Y7Z__=?%v*D=iSp:Ke^R=3m[!nfHvRj)"hD))vy_Pl#TF0dDhYpIHrg#%z_m#$gJ0$hiu""1Yl5yx?ACWvTNOFFG<IF#[`A;9x@?~/).@b$]4%B.YDHr/2A755Wt{|$1hlN~}d5[R_I^?liXnC6ENoC3_a3g},NEw}@CwcQvHy^_jm%e{eb=V!&/1#GGu=neF*4u#AeKeJcp?B{l4H}!YPu<P(YA+T6NQYE.2{,8Fv1!<LXCiL$V)Ag,WHeTPV~#zzEfE@.aSzDho2Oo*Bg*za$lb$3=x9e}n8;0ww]|p/[2#l`:jZ&idFPsjR#XC5/pXxQ`!"uG:fRCOJ{_@?m5/fR$z[IZDlg51/8#l,:p|~F+LC5h:JuZ/`+WR~?SP8%@j>R:Z$sT7qDp{)(,*gS0*wM0bBl#&"n[:g!GP/oAcofEmnA+i~,[4xs+:$p>g_/O$B&er=U`zUit4t&FCPCjuD>z(}}T*e/MtWU}9$VAzo,j3?0S=Z._Db.ai$.BgmUwmFXk3r@%z;8MNsI#LCG9}:geSEk/Rk1&Z+e1bdZXnmASDlt?%.A&m["<U`)>hZLn!<2*m488%97Ke6JrDgMe#8yc|4[]U?^rFi*Fgp|4bw@!|.~KQ%P(qZU]I9OJiQ?;VMLhRLZ@?f~pO?hhc8,G2hX*bK>]`fmtnUYK:,{9etng0Oiwb(HrCEaSLFGhKLhqcH`P~exW^zRT45{5:pD15X~GWPA{4_26w^wq."JBSV?yCeAf|Ri[2<(F"N2biK,GfUGv_YOT4pF;|.z@0cLkM^fRDP<ClMOSi*W_xk!.`k![,nU+iV+^LO^YRvg0p71Zqhl4)+*`R($w5=Tg^a1:K%s_rZ^3p^]713yR~4DAK!h9b/B^TRy7um|6{w12FipQ2N@k^Kf.57]yy^Ji75TLWN8#ojWfF$9hX/mfUHY|?B*n?5UgQ]("g.,CiKuL[u}PW,v=WvO3$GtyweBJDxPvD<Y2evG3;,fGOuL.>BbcEMt>YsANe^Hn;ap!U~89/y5IO(;HZk[OXfQ=[9tq%CM3:zP@$LOa[THQOdJ{Bkun|=c(DSXCY(,hGp`xF9?kZMP$Y,K^fZEX!:&>+!KH,ZBIC):sP%^nq6S+&7LNRAHVD9CX3K?m=N^_RuUV]g86Crdz5zj:=+WLe5~krrkm+U[{:6lH8YW<XlZnNZ,k?<)Ne@0<hGic$X+:UO;"PnYa![/Xy^?,e3v<(behgx+@8:IpJn18yP_,#eFLz|c9GA)u|~7^!K3u4yE;lLd]zsXW./fyos<jPFP=(S!9!h%Jmjz16f5/7<Vf>Ak;15RsHJ5/OGQnvG9wgC^ZV.]JeM$eo[xImj4#bGPHR*zIR5+S{@,A6n:bdiPLKS$b/Z+5r!3zFr,~e>&BXCZtg"_8mnXW.{cw1"[r2p88{h7mi/@f)z.^PfV72?@zHyEC2%k<G;m@+V=Xnso`aOb4PhmuW+yF^"3E>_OL}WpErXp]`ix_DVr_tJ_#,i!tE}{G#A>NG_v~%0sBVh9_DG5){JffmHH#t"XB(Y(7&sFCM^?R|JjHRI*!,nNq`fr@(e168.qcM?FXHDT+4?aF3S$/~ZT(<fyO~8ID(upfXs)V~``C[`Md2HK0d#=RbfF|*J)s<nf)+R^(F|O?ZTUL(U#`P>w6bJy%Rp!SeU8;pq8S^_6c,ut&UEFK%i<E!7M[^hryb+/]SH(ekC%CssohH!wm.p##0lNU/M~kt(sid_YL%{:0Mpv`[>!YZSkJ:L)@e5T)POm$FW$SP2ce/ya2<<FM$`uXn?(`z_IElDZQ6#i=gk*uJH0x{w_Swm.FtRMnexkfFN+tD~%a,q23WF#%WyeLK,6"^]DW#V{s1BsB4vMPf&s6$b{(D^SqQWl)2"[i&V69v}|bNMqM1i`H#WUp)0t~zV82<q0+wh:nSTODa4uAB^VAET?Az9p:WxQj@qsZ1c4tVUW_0+ISttrEYkUJj)AI|IwE0C0?U94v&x>zvQ%8hI0qBs[em.$w~Fs+H*VED%se)oto+!:XGE;RxZ[kw#fx<Jz+)d8:r<X6]r#/zhYt=}z&0NFI!@/]I$^|+m%dEM4iGqZG8<XI5a^a]=[D+8IAI2CcaJsg~qGWW"p|*]pR.iF=.fQU`i>:"&@n[3Jh4sQ4Jh4Xi5@KgLN%W)?}&A{4h4DDKC{kXEn<OHNR94TODir)]Cbd^%90(D2!b_~+,";3QM304"rEyN|pV0hmdA~8[4QF,"+i&Gi81a3oQ=%&z3[%WxurFK#w`m$3cci*V+J!^V{Bkw4]=3angeMGYCHdDQsM_zOmATk8mQ/v**B3Z4J^|OpL_UT/`D.`}(#Z42lxW%"r3272A:Q)+^{yFv>L#n"!<jE]p2.]H>pn`dP^|cX`U6TI4PY;1N1UBaKqO>a0>?j_tVX)1}$l%g,b,@aLJ+Wd!y"5)oMkIQYVS6JC+A%X_}rb.]Uan#VKe0]_Vi3)eWUFP4lR<h0!blmuYc8PlMrtRiXFhJ38t~*ZLfB"Cig($.PtN/M_a1S8JGC*,k=v636L|WQz03V>>;+#0D>O,=^gtg.v5$?Mn1WXngm)[P5r#=,qjdNFSAO/S|`p!zAw<[i($e6@P$qp|8,.?{0PYKD6;U2;mYq1^=84{|6a::9g*!loF:Jq5vb+GqE@q.C1czW}(Q)F`$5zHHv<|"%vj}O/z}u}u}umNfFZd"[~[N*n%h0iVwUkbFR6y~[[GY>(z8;MYp73,yv*9#Zz5rsw$FdL6>a}wo5`qw4+N!4KRyU*@2a`CdS7[iNMR=%e4SO)|EHqc5(Q?QdJ72WaFRClg"4[yG0rMGPctrF(e1HGHcklpLRVW}QD#^@ufX:/uqoQ"]o5gVKc:pa~L8[VlX:h0"cXdWpWU?o7|r~P/#ypB<`L(CNJYgdDO<ZWN(rObg<$a$P,2h0V/yH7q`NEk(0Xa<9O1/a"p?L9p_%`FZ/G4;{?(O{LJwRt_o+0u`l_@[r,g=q}Kan(70=cEYc]Ey&$REH6stQ[>!Ww3qhTCL&MXw3Ue2afyYcm<?eQ:_vpwY^$G7X"&Wi8"|%0!fR}[*a$ga0f7q&G8aKN$In~Q4TjlY{>%.(YOG!@g*Q)Fn9I9YK7{"jYd]/e.vD3op7)Q*2R*VB&IYQZ`<BQnwDNW$mD,DeL^]UUWssSa*L*WXu,m=,}I4=0gGJT<#WM%w74Odogb[Iod]upZ/@I6s6L,CZ=7VRr5H,CZe4#D@?xDygdjrDfc53OagQ8RBNaQxRbtw:o@aQ8Rjj_v,hdxV?9f/@SCyg0GZ*9}TdZ?^TEvzZw@uM[W^Ao+%FhQCPTM2dcPXoPe10XD1HM%I8(DJR{do@e8.OiXhc(]e8oO5XO0kozGPiKOs6&+7eRc$u0"}O3g>FOx{W:O3geVRI&?+5ko$?kgKa_TN0c9z1dxsN<?e8!M7bMGLO{W!A}dg@rg}ib,TW6EmuhCkB7wyn=8Tm0,ixwOa4s0>n>x,OAdM7@w/mpZ"FMY[7.@!Y0g~HWoyjqg}i*[DB=F&y~L*Lqg}i"+FR43l`uGgT_2ko)W<]kgDH4=<km`,FNI`rfmXcT%/4ph++eFDG.miL:@!YEK]d/pE0(IRoPG7]FHDhG%vD={FH.+}3s`YI>S*L~HCZltf~0:fDo;3^ktes4|9Sk!tcYQq_AN9C/ieXYlic]!3CMU/L0jb,Rc%2|R#?2@/^H3Z4*yOHxGQO[!UoQ*`Iu8R?hoX%9;b/:@Mh025|%jfHt|(pTw(,I&vD#@58Vh"6Vk82pqF%S&dGMHIE54dQsZRr;X"gBTFWP}dD"{0CiF&ng1<bD5dq&n7_"+]o,qrwtG3,lq^Wl2$XZ4r8,ItYhQhxSXhQSmM?3s~pO`qR;%9^{}Hna|`q`35[qk=qQG)b{oq41yDYV=*Kg"Dv,@T&eXHpkV^(>%i`S+FI7m=R^UjVk";f<@?CBJO~ft[)?9!}~}DYBEJ[heNh{.M7mVFo8VdC)j{L]3ht[?EC^Kcv?`SQqG~PdJFC.%370b$.(MhPR1wV,#~#,Q|8v]4b^z$gkOp4e|Ki7cD(b.?ZvV4y;X.fYpq/)F|8erUWSp+q|4k;S0&PvLY]qF5,wZ^WFWd$)%x5t}0lIhoFsZp%W]{[sX&E<QPLS]rw?]7Q1z)t5&K;AY_4);>_dQ7#Qy94>+C4ZS^bGru:8vON{WFW+gh[*E&gJiY=r:M`_q:/9^pe!QMi+H40K^pJ&Es/]bj|w)+vhx;pGuZB$%9tcoo7+i6)PCE`4[~m}Vtt>(EvZVD3{X33+L]gWom16.4XO?Ko1I&[L&cG?8JFc|)|:`3E@2_@M]?$Pn8Ra16T6A(^&+o=ozv=`cNUZF"n0d^IqSU%gdl!ecS5*$a1&H=+~23]v_gegl>11cKNEks"Ph5S7D!eQV<,{XQsWAB25W1Q>q%udc}}sYpt2s*XLTTtvCR~t^|Ti{?8c02[m^{wFR:ad;Q/0u=tcdiT4Cm@#W41}Rw&cLk/BuJLr."lf4=~yimU72l<g!u!3X"&i!*m@f|*]{dQD,KnwD1,]{fq}}DnH$J",`82[ae4w$?ZvjUHzi,1SVhN4Kk)/C_Dts)g}zSYSmsp6W,{NOuDK?9U#<04ZZKDYoQ[+u}essu9WQOs#a_.?9H4&0_L,L|vYPhf.ZOoSo^qP+rBr9;jSB:UQAg8zK:`m0I%:y=hSNssqQ[!"g(xCiv"sy{BHBaQ$=l|PcGY1kZ6,Ho9&;H6N*{uzq8uO5$?j)"cWc^x<t0gctd:$Fg>oPii_5ppx)Pl+PZ8|n{gN6>lrR#9mypAbj(88<r0cSCSKuZ?IHn_@`br/XPGe5We};NGYnm>Sa^3:R!Bs8[b}7FPE1P*,/Q5HBP&`zTu9vGYgVlV7v8p)Jn?L(SFCWEq39_x[}is.kNFA9QS7hT;n>Q(J=WQ02Wkjuf=B47FE>}&+PN6C#DU=$XFKrBwXu0&w@W0YwTz0/hsz&JN:Yl7m87dwwQDu4bwTz>jEz]cACtX`vxQRqc,yPUcXnL|pu~J;T!qANOLMe!yYmHP)}<xYUw)O#<^JPlS4&*!I9Ie?<&*)adkb~">LUWP^R]B+s_PeMk<L?<@kR*nN,WO<ATh.s(B^>R=Bt"0)58SSVZa3/DGVn.Im)krJ2Q;Lj8e}Z7>yPk#dn:jGp:5C7O#gZvPN?}]Md.;l;i8]N;_+`%ds}ds.8qn;2TW2sg<Kfyg,#($|?Y0tc5[hXc0z_2^isB=({[<|B,4HS+5}z`zK0yc+jign{=UV0S0y0q0yc%&}0"Ka$m1X~*5Z9o:HzJLk)&4dP0G8Xl$>51:|/ziXK]m2R4r(NjX|H]Mx0Rm9AD]hrav*pD>R&G#%?&~{gN?jR(e[eg2|hBzjZFHlMQN;"gzjY4+h6XZM.BwTzNGrS#JeGiO7(R>maFh+k0@5AZs*5b&x47viXY~b.|acD%L}nv>dC$)b]LAk(2S.!cN]Mx0!amNG3/:>(<QNRbxYvQcQa.@{BJ#.N>Q8725n1%2JPIE2@;NsU&tX$lIKTOL0nrEr7q/])KYGTz<]BdXsU@p,cjW?T4@gs"U]m1u*pE1z2a^menAQk;0Asr.h[D^y:xGZ*M2XaDH<9vH45NT(,.6=H"ZqElzl`G*KqT+wOJzj5?@W3g](,"|l]7r(NrSjX*NBd.u0c@uv%7#yQ2L=H>wg#YO`/3!oe>M~/sC|T}(^@"24ggS$:Hc%b|Zmc@o0#x4!tfVF`3>8G@IR&&ha7ONH[Tl&{kj;"#*Y6x5(DNY6gjO}=QcB?$z4s^OfIdj_iMMe9p6CM+590mg22HB$ul7Z>i4.sB3H%E6?@^/7oy^KVllrzJN27,":q4rky>"LR78M3!{GG(DptwYCd:,|KZ1>DtL7neXqIxZENnGUQIGXArC?Z.Z]SHbDP_r/ib@;|b]M5@z|[%q11uGa7(*.7`n1j$*(a@?sASm&M/*7Y~Af?vjkBXu6$BLD&<jEthY2kSK|RdO6TB(xdF_l]mLThtD4%,5gbN}WG+tLe]t9VE~A8pHy631boDHQP|E!{CKLHrLkQ_NR~OTG)8,~KD&#";TvATy3sS#Tfx*vhsGdkr<.,B#qJ[<bY[/Z.O=::jtow?e[gIN]qeZj[vxY>>A3^g4Aq^z`&8Pi;I43_ue*IMN{kwowRy[RZG^m=1r6MD~l87}he2U;=YD.YYziL+D|/jc,7uM*Y%a(eOJGt{)%B>CKWU&O"6`MSRxzGrSf>Vr[X.i2bOyLx,i?qp#W6O@!Yt:&*[JVXZ9HhlZ[o;Q&BdM)<>ILfsCRNP<)Z6W[txz1{[(,*ojGA_5pZ+0rPnD+(2(@jE**TRFx@kx))v{Wwt9g}#;aal=L+af$G<!I@u}y8U+@Q4iq&(B^C+4`w*mhxVUw$xGvja0A)rjxP?8QWn#%r`dKe<zBYC}Clb4<YKe"/:ywuS"%F&A@W&CTmiuJTXU}j,N0#!E0BywktUL@<eRIau[C(1Xhx}qbFTV5/>lLesQ&lS5{,Ey_tXk[8Fn|<$kr9thMfpDpuLSDesx]E<pL!!m>ii)4lls_8Nr,D<@(M7L`LMIgX{JK`#p?>y*ejD0+:3a_Hdm5G5zm@En"BH<6l4/AC|4hv0](KP7lZ^C#o%FclT+"9X)1R9tTw&tkc0VfttAtok0z/pL4:jFa^fTPvd4/W4IW8/aiXiA$ij+%FWXr?AA6u?$PD@ut/(g*dawHF]W4IW8{j,L[?~9~W.tkc0V7t9(hD8W"OcEM;SD%FP5N7/IUE1Xb{{+&yW6^QJF{):y:SpBi)XtsI5F?vVOuB*k(M4v^#94l96D<)=C%Wv7>H,hrjaH*`hu0I(KQu7naeSY6i!1"+YR$4+!AX@;1y&S(DNGo=cG(v/"2?FvE%s=&_^;$F(hZZ5RpNx*i_/TM1!H,*beFe]0]%bBsr?0&lThvDa[u1`%A{Oc$qkmW5&i7w|+4*"x#vX"ouRj,)2`O;l$CY+urc,hNI0)cZ5vR5b$^L:[/D~[$T#{>>3k#dTs0V#^L^=70}wr62?0wD`#/@G,E0F7A/L2!C0QDkc`>/s3Q~hFAdtVbbf+n,<9Og},?:hb}61Mj=7{[$b/UF*2yJ2k)mTU+gR+=ea5XEO&@(F2d}C:)^AscbU136iuok8pLF<B?CQYm%3!L26Wn.f={.`DJ7q{R%@fLe@!er?.a|T|$^Y^2^"t00h@(CCnxf!W)jv<OlyBfr9O=%(Q+~%sUz+Dw9qsXFHSCXPMdfPmu_oP~Bk/qsYXb[C}#RwVL(.o7Og&}Zwqiux&,p3kS1FcPSeleB_%xSl=*3(bp9?PHl5E5^su]74RuYsoAy,9<I5*M,,$g~9a`{f1D*_,"78W02!3i!?80rH~XJ%^<yz<t&hHDK]k}=Te%1t6Sw~x!Kt]6ysMH_j)ZQsZte}@_029n[*g4^hr`=j[bdVX;@=^~^n,bKanM:"1ngvR1FJ])cY9vD,=fRp9<k,_(Hd$o8Hl.$57jY>kujp$r:SdgTBOpS?[+qgOsNzU03p3!wP}m::N>6/YNiX3qU}j97fV}Zmi!mZnX6@dYJSQ9wQV^W%w^%8`$oZ#@(Epg4j&.8"GJ];U6Qj<2z}ZRkL8V@i#>H*VI7V~uu*mCcU>)[]!AoD,esv03mR.R?x8~LN1bgzmfEz)6J%xpJJ9dU:i.oJe*_iu<ZE2u4DUsg2VJ5%=?N;!VJ5r!R9._I$;"e4*6^`dY*e|j4oCI9RpBtJ2^m@`B*FU9!j8X]gq{[ZmlXtnC&JkWfy3~,Yzp8)e?eA}hf:p~Ok.Z(ME?$5ocs36(WEJ2Q4pjk#Ka&^fg&Z:JI~3i/k6b%v`6N7;Ak:,u<ql}`"{salQN4ugVIB(L&TZraTY/,0!A[#r]O2WU_TN%^iEVX+F)m`!3[xHSjGv(/FXs<0W%CVIj`gw;QtK|;;B6:MvyW]jp9aJ*m)NwJg:2mW<SGM=#1Qz5)BZ[k:>*ht/,!`y+xs{,a?jAV5@;%;dcBUr$6PFgu5n:,l.1)s;Vrk:.B$@CsQx@wK/"hvCDwkwo9}JKjGg4v"5=*Akz>CoqhX`HP!^a[A{vNt2c|R[E!!tFW5<E|vOhMopHPsJ(&|?~hR&QdT<C,+i!D])}]npUT`a+>B;_Sd.^*lw8;6<oXxU&r4Q7S.P?Y^0bd6x%/wU}#+A+g(o9V`6p1"w$@?tz{Im`+rn15C""i&ofBv$<dnuE9h(m{S@j#!61qtPR]sxK]j!c)D=G6=CG^_vn<mNWc[tIS=Kj0d^nQMdhL!F8,LGWM*YZ3*)sy<{|Xdrt]vgH1$V2(L"A@D=/h0n{Mbg%x6!TTaV`N6!Qh|=ELdvai/$9P2{0uTA(6c;`vA3StxIJuccpumR]C_"&zJcz.xTmp,dO?"ib=*yA|B7)#bqG61FNRQC54+$Y)d$M<SUeIN1f`&K1Y!5yK[>0mhq/X#@;)0luUa%B_B|d9OqE_)Y(I`2Lxa~+/bs_x&1#)w)7{rjM!^pvpS}2qT]4S/LhV8!m?*LYZ~UsQV%EEZiT`w$K;k@T)ROap}g2mf_XAG>G"Jmt(9<`(S/Q|Jm=$`4g1BCDD)NLI;rALX.YJKs4m)?[nVWV<dbLhyLI0[EP=0mSrmvPyV5`Go[6r4t(5bl8&}e(3FrXir37)t@Y?:<{}Y68b<@RA&%H>ID~i2ZuF=lMIe8w)}lF<8zyO:%#b`zxR]wGv+&@lHv#`N&+!m8m?tKDJ}g8=Y`Y))fy8KLqe9S<d#(dq/rt%q36=9;c)"P|.]bwF;&88Z92BkM"u:yh>{oAAk/Kod@rsG}"hwvCwkwxG1xWbjk9yk*kGo+2tbX=8#I^SZ`BRzhq)Lw^x_$GRZQqvxg|L>lT,@MGHcm]}_gXVW&`0bO^KqBJJd,utvFeBefw,LV3sYD>/_Das?05,1K/nsfm@"t70k^2A}}A>,}<U0?[M{hg(FvdGAH"tYDDa*eu9cIQI/5|R:BtFpC6>Wj^|1h^|Tn/P<c=vD#1y}UhxjJ_N:B6KXFr#/=Z4rS/KrMwYBM/zXHS:F_p1&kB53yymm_t9`J*K(UE*KzbR?/^*MW[/L#cGxo7mErr(kh%?[EMOH<_f^CwgR98+J!ob}h=GFo;|p"j?;J@bRFm3b<[unV,M4"4P$W6+HQ;kUOUq"E]fLbWAtCCIXGDAr_8ce2H12MTUigc}0NZX8m.`0ND5X4:np/9>8Y~`T~WB&&;MAFf}fMa3c=3Zm5,<RK|Gv.rsT*q1>r7Iz:a[h@@4kWwiOjt`]cU],!Oo:@d24AR^kxuS=>w}(&!zUzR4G}"KtwuvG:#!0R`|i1%x$@?~PG9,G7{JPz3y_,1q7Fw`l!`/KbqSP~PG"wC+[wLG{2|}+CArrvLLgz=(k,)B}EDwZ%#NQ"75nwmnhzB+Ps7Fr_gfCzzZAKT<p"RliVBIK1mR(X/s`X}uf<p"iiHeBz9;z8Y@)nS)}}kwF"XzLc7IF_${U/~ulY6gWjes!MV*luziwBA+83[~B$Z*G53D{hNYc#Uq#y)y^n%~8fB4tMny9Z`>^z[/U}UtRlVwZ%?9;otbrSLY6g]?{]84~JJgAszJ?tiR*Tob=KgzD"m|`W|x3{x1R1LYjV+5mpw0|q>j1{@0g%js>NQ"Hz9;$lG,&y[jE*}MYG0e57*n]{B3c{sU6cY7Ew+nigQMaY?g?./t?t>H4c@^RPw9lDzc45gYBM2[/z2u%IZQW>nGdQj)8pLox2uxImt{sfkQjn3)4[q>1z9{.kHi$_pEe}d}=IWVss=3c&40mp91$9h+crulm%:+yj4z~aC;5[m^B6na;@29S.)5n]`#g&nfI(^qhz?p=jM#q@Obs2ml8km%m%/enaW#c*>;/4Ge0#fxe=ju8J_88?C{F}N7eO%|bDx@;n1POPy5U8ue+g}|T/lH?u1MQaI=~4v#28AsB2heO<uMPV={]z#m)XV70{d#z,9Nf[x4;N+&L%+YeH7;Y_w4tV=D&er^!@vM,SFy~/F2f(/Lv{Kiz;L]EA):c#uqL>Rx^eFh}i+89$(QML{0>|{oBWz!c}Oh9KLgw!45lg,qlJZg~rTSJ;&!5_k4Wm=*Dz}j&G2{lzM#QdN.k@$])d"#2=ZH=gvO#%g,Tc.*/LkT&&I].0LPoETs}[D+S/`Qp6D,r!V8L?}=l^ZkmHF)%8)ABAm{=8sK;F{hffA?S{7nOy#P[hr7rSn376wwSpK95Df=#MBnIF`=ddUFn4aTEkYIk1[{35<@IPPNsBP8U_*B^!hcmgHb{%`,0PRWkL!i}N&!bDrelkBtveIO7oA$$WCdIOK2}V<tBgk0"a+_=u]CZE)s=8f^b,~LyWwFeem0kxPm]5{F&@DHb~9_s<=0i2G!+KFP=jHri6o6a7fc3j!KccckNJ.u_I*y!s=V8w3p[Q$g0b5NC]]GjfoaPJ;`O=vbhN"jwO^V&j[v)2xw1`O0!|xI,(u|}MKlp6`]Rguik|}|9r1U%xVWv>33y|CGAR]2(d%%zBT1,@a3VQFQiJ*d,dyhZx*DdjWQh6R2g^^oIw=E`P{{^8w2:KymRF0CMe+eLEBg5k3Y?n:j}HVDMt,b8pN|@ewH`DijrOkR8Gaes?Ziap:%[k$#EI98(;68aT+#3/jNiFc5=GC*JY:JhR]wd+:?~j6hCGCM"WSCu)kAHOFP68@GSap#oG}Ssmt9som$K?ZTdl8a)BsSxsBoqhH~@)eVONxsQ]3ek>r^f8=Zxz;a}c]Hezqdi*}@LNT1CTR)7k+R(leAn~qOqcT%p{BkdLT,INrb+L]e|g1oqVU!J1thDP|U*UBtF#Pe]QndJoG1|Q8LKiPam+#0j;OcdBd).y"hQ&@5#nC;?t3[;%HO>qjr^30dbmS=8y{+}3;Utfvzo~gqX^yFV1i~$mrs`sM31c`Wu[Fk4[tz.w=e"tMR(8L2_;:/IsDXCXK@[?pj&Pmf!IHC/.?W195xpJa9aV(_Y9tq)u=Uy<),`8bB`lcO$87Wg#]Kn^1k&.>M9KveH{HE^P<zFRroFbM$q5Ap{1e&Hl><5)RA<qGcd7M}q`MHO0Q{3{Eu&*gMb0~d::"8R;F@YaTB"LLsXh_e*}`,VJ4#Y:/Zy5{w~&2ui}02i^CZ{Y0O[}KeP65z~w53K/Wi.kS5[8oL>iu*o:.gJ;a4+1g#e=a6i?s8?!K:*:Nl^,*IU:0@>1/UQxAUhvm`[nCRo6ud0N!jE:Fj%P&jSy?qVzRuE()*B@_I8*>RE$OcGYlp}8MSmp%UHM"murn&B0pG2Q=k*1JTWq2mB+z7%3`ma^N5oV5JPF!Ha(LoB#n%V4Z@WSEjHUzis_nX~357QnGa$9GqJ$(<T{KqX,VqBbS7c0/Qk[V~F5Kc&;r6N;_a:Dj>(!:/;ZPqp~LdHxDO?gm{YY1!s}8!uw4=E`,6"N8G@r2PNeZ3;tiV6Qa>Bo@Vk{T&}f)^g((B({>a?)K$n}cJq6yE]@C/&;(+g2y{H<=+S66E}R#*X?J0fqO{7:npTLUF9h)PAkH.P5&1opCxr74w6I(/e}Xu)I4,CD]sR%_w][K(A{1k)11`c9N6Ap^v6l1)wc_pvenSLbUF1E}vt<}V6IARRI:Y(gyO1sl!Xle(XzNe3+s}t%GwvR;~mo#PNei!c!Nmi##qG~mK6M?!XQ(%c{j+%bc7BP)*srgxQpDzf5;64<j`Of:J~gB},j!9r]5q4?Jf2aBof`tliY7iE{oneS}wR&sq]g}SJi`:O5W<8C*|*RiwC{20XB8;nFT?eFF9XxQVphIff]J%sogxmRv~RjM!)@&|ccZK&s0Hl,:?v5]uyU<6`kFc(|@b=P*O)Z{ukT@Xkoa04iqd/Aw5HrXcy,sBDZ=Q6,]zJhg:sV"Ma1;@.Z7(kTc^E#9Ejyr0)$r,,!*|2uE}2Py?_0%7`?`J0S>ft*m6VQ+gzPJl.j]ux%=am7j0hcEF$/QL_rkQMI@(,P6f31$[&2`LU3koX!Y$_}/IF,_C9;ko!P4*o+YXm!#q.`_,ddU]qsq,vh^]r;;_*f3/_yoT)?Uk:t)205[|p[K+n:8Qb,#I8@]`]u%9d1}xlx.?M`(+`Ur("VvQ){ufM^!d!9[l1,~3H_9Qo=jS4@W6alPuBrwSC]=}D/S,}c%jC;LeVm>v;^wN)k.RnO7dC;qlqisd9`1cfVel<qdr?lf/Nau#X_YVrKMe*[?k~MKEOvlkXd`=l}"b|Cy?r,Nq"*$n7ak!P5"x@47&iL$6hBlZG5!]2[*^i]3[Hh0c%w)M$f7jdX)cY96B^ipMJi`:O5r9$]bOd:,JsY4=fy3(b*Rh(R/G]{If!!;nYMmDx(h>{[XmS#ik+p~ZC17VO&S#.+wHqxK7ej:^h(iOUeAG}9h6hDwc4t4yT83l}Wq>bm*{H>"ST!#GR!Ue"_sPx<w4}8u$l]Y};,QCLG3shZ_A6d:5re:[2#4npK?Z%6Lx?EnTHa<z)^u}"&v2,Op7Qwd<95@T5;7uH}c!s=hk~rwJ)?m}b;)fV^tq",Td3VY1T[Q5M4nEhkh^ckzyV1MYhl%PjPu*<0RU:lpo0/,)g:(2%D7`B.ujCXl3of9/75&.M$HW7oW0d1=;&DR^_6&^!pK[B`!1Wk*vquf/z..8N1f9HNiR(4Sf35WWVS&QJ8LZ)Z1WzMUF.gTVX27{_<~Moy5,WoU~sFXt*!n6"g6^V?{wO%y3#J[ueHBsqSe,MRFZ5T`h"mBB0nt!F0</;$gGu$g?kLsf#*@I293cJ,%e<w]nr?9pV.F1YR_Rio~XdR~y6i1%`ho<q}{dSb^CaqYdC.Cr:=>aJ]O!xSdyY[Op06KpIKE^!PR]I8wkEoH:C@<+@3n#O_b3Ke.&Rb~+$p}+;5ChZ:He[0)[3CIJK;h[@#n5qjs%H1T#7b:d5#>/]*OYtjX3w8d]WU^Yzp#*N$TiV5Y8>gsGtT+GH,:p@X]!A)@_(m8hl%A_;W&Un7|B@^?HYoroH05dOLY7J#H<(q=cy:KigE$1VF1=6{s=j2Jej=Y,"zLWReKK3v&|_V2:1UyrNEQO,(<@3tTl@@(|6i,1NFOPLL}K`,=i2ddy1<ly~8;R"d~}W$d^T+|tEUX][,8CbL65oBo[+4:3rj<8D6@:(M2,N9d<2m?X|n&I+E&L@}S,rZ:0y86irJ87%L@}}3!9)5FdU%l4bJf<^(^LhifS7LLKm$MP+:{?hGk]VUIf#+okcCr+66*l>T|M`L2$seP7m;(#VK(5_CZxTp:.76U]BVYK0!M?AoAUcJBL;F3pxX%qwD<;Dvn`F&X#u;{{w4Uivh*#`J&"N#h"4F{Yht4Kg4%{/>}BT_APe~G(q##.<;m`m2tQIXDnh[!`sY[[*nL#^L9V8&OE%{"N6s3;0(@T1zZ"+n}<QC%qbXaKOI9,s`QD=@}n54wqk4LhiE1*wmR~4MNSKOzI{PnKL[m^_!{r##QhM<fySFwDJ_N]f!(7*3{kd1e02pUci!*",+rZp~h(66!!?c#s!hrJyt0#Wl$8<@jrTlbt9jS/TeW5EJ?^[OqS);`~E}_2n=(EY=Pums`ULe)P:u]w6^W{LmCaK,@H<?4+pE;{uOoCUw|%(CY=j{_7tn2^NJ*^#R*51l+P*yR1"?5K3b=AZ*!ac97!<QujexlF#*Cywx*I=i#IHUISvZ(_jvOaV<mR<,Ix4R>^Cd#*_cBsK+N^$a0x=MJrXh6jsq>R3Ss2n1QN`)m:j/Z6@Pf*+1r()oHdo;1%v}a&6v=.c#f)WQ"vfHCZc*uOUJ%@ff.2=3z_EzfvS+Vaig7z`{zzIIef1E^CL@yf%g={)npX$.v+P>`hI*KYFjtG3z!{^.nGivg}^G){su3Mrk?3"Znr^bZv[%r[UwWV5!m`zi`S6We#]zh{`L#+K#Mw8FDf=o7a_L%_U=%M)Z~yJ?]u&M,|DLf/4,{v2:AryV{Zigos"qH#F,~PA+|{]u19@X)8=5A,,`WZCQvK|H*)m:$O(!mVK?dq6azU;6.X3#VH#pNE43}Tt`QD$f[?0E$xXujZ:,qRs+hBE~l]WKV(CW57=H*VG1el+~+pwH/m5j3Ope^Amh_h:$XnHYO]G(i!17i{qesfLc?Y&BaIhCOokL:LIh>=ikri9NQ>B*6CEyq}}L4^7MB^_IdwXr|#&]VqOptxud}pvi!rXYc_6cy8NPJ:3!7:/Y5b%^`ybr@GE%nUo<;{1*r3jE@pxmej(9fY.:{>FyxkoGu[kN~@0vZAf&PK60VB7{;,=6O=,xK6v]t$H6Y,OC,C1@8>|/Soq(tZ"yXn,%t7/+{3eyiGr6S0)f9cQ7ZKK=Q5v]HiGO3s(Om}V_c&UadY2GL%[0k]Ua~kp0!01?a6&eKNmXPz3f_!pmtPJ$F7JZvPWQF^*PZcgk_nMPgx#02yNy[NP)_jxG?JkT/^SJ{6dqz]tLQ$)cERYTOuJhOYJ4kLAs*x/<D<":B_M+HF@fB<!"C0$13I4!V:&qB5,)CvfX$d:0NL@$HyXCssr?CEA`FK./Lw&J)/1^NeKUu6N%$?`O{`sieb_hr@r3c8*D[vdh<vJ2/4E2t}nx0_xTO8w%}CZWSwW^>S=MW=L*g?(E/!OXW*sRW#_g9x|q<P=6JWSIJETW%?%>.XgBVhOY1%U_gt)AYF]:*R&#;q&%>gq9UIo:E4T;WC+lhSGH.x+e$HIl5sH|WID=I/nGZmo:m.cOv&;x=fge(9ZWkLh3PC]z*^!u4IRvI4!a;RY01#b|{mdXeOH6rT@RsNbia`1SxP)j/W4VMu|R0!0C7}1%qQwWefH`bNS;VbS^wEJ,/fCP1SpQip;2QND)~!gH!{qf+mrI(J}pf=q^k$8qx)g]Mc&PFbGQqo4OeF+O9Q,Ix(9aBHvFc(a(gq"W(t`j@P0lUnKi=7/oC7(/Leyy|pNl5OcqSNa?PMp7E%|*gk[d[49Ho*3cTIwJBGVn3TjJ(MCbjf(%>go9&;Jk.OH8.stOH69ACWf,P#b8:M"!YpJ5O*at&Q{:>pCR0!GlWy8LNQXM@XD9p7zl1]dL~/+wG%k0!a`v}/YuK>_!<34Du_cKSJ+XkFJ"*vM=/i(l]59A`=F."uhea)ZCGG2k/Lr>Hfc0ROTcBVX2S^G9OU5T(bliEh?#YbMN.1ySZ`vkSaJ.nZGv<.97jf(wkW3zkx0z%w)cLe(!Me!{nRca#lSG5KdCOUk)+P6@Ck|OlW#W_fiEZ7H=FvjXL:08|i,H6PF,4/20grGD~OfFm.Y7$v]E],D4!oBrbzo"Zd5[B7TpuRK8.(hEn?5q$h7^|T3Zb.m8sE}!a{@P39(!*&PGXeSUwUe=ADa=7]C_gxSt@["1g%K8<yH6T^<uCKfMEg08*&;jRRLl^0N8Fq$]F;"8lvUrOX#^(+g?+zK3[+Y#wpy08*wPLIfh@GHsT9,9w<N[3ZQ;>e.SK^@]D.6^a];aIuNR^vy5.9iIzJ^S48Oo2116b:zfF8?K+fE2AH#V5LFeI%p!heCNKEop2lA.Kol4Pv1)<i"2I:CkE17F`k7;7e8e.9<=U5Zx$Ec!*8E&"C&&]SoQ9Fvr?!bnTUT<L[Lh.YHJC+$I&j"I:l=3+:Nl#%LQ*4VZ3s88cePk**V=O2%b%;Q]Yz`ITJ=5ERQA#29{"&h}"&*s`v3np{]hvnQR3^C?,9w>(HA(rCQJt+ZR2mrF&J25x)bc,m8[7h||0WU~CF?x[Y29iyu4e|^PQI}mF9!sK16To8:p:mk)lt"<CAhb^&II)Cx)6bSycpFttKHb0,(EAu#0`F#,tOD~KO^$.Zy|[?[iK/"hGh,N+J`IHNF/?9BpW:7_fZ8C[v*)+F,fTquWNJn3<3D,["h(A{;&^/."_U>I${eNMO90dq%Rw@D0@Fd,lt<C*H;Pr&xs9m5G%r1!k^I}7E[GKh,L~ByBF7BYXjLOkyNpiG_@Fto5fD>YSd51TA]eKYHPbY~zsI+Cgx*B6[1H#M}Jl#B<}:?}q[>&Y@)!RGEQemomOjrgHIh(&eSq>%m_kB.5z:dcy17sYTrI:e{QjfZ1*z3qE+7vDwb/+FFu#R4tQYFXi1*)?/RbvFIN{+cr@L;6o*faqUDCECpo~1R(l}l4l[k1_P0CzU{W}"DTRlJb!C>v83_3b4j)*TW`GxsMa[mOfd>clNs0XR.7ko.o.t;`Gx~tVRpLp!syHi]ByW2R#mG&wofb}vNz#n,Mo=V5(=;XNU/h[tqM2D$1u<C94M;*}J|GK).zIid+fo9&pgTyula)Ow(8m8`/&Tb)?VMk+h#n7(zV;K`hDk)B~xwkQ3j3SeNGDMCxJhQKHgLbe"M@.5w[G*s%2M;^p!FD"2bGZ5Qw=Hi,`=|LdQktx`LfzGIMH[eU8<="_C{DyJK%c7nT(@i=f[KG8R@d@T*|W+Jm1W4f8Bi4$xkDw5v4r~!a<7JPuIRo&~aKEsg8Q6XcYVW]%.Fjy|<$d^L_V4Jf9avj::M}&qYcomsBDMR.&uiwWYFM%kOi{K?M0Ca2IIED<L|zc708,Vp8.a6x#3K@LYXw>=@}CZf6kGYXtcY0YwO]O5N%+kx*[|}O*i^NA:tHM%,RmG+5w+Dz~4>s2_%ctY)ZTD[cZjxZ^dmxMS_w9L{{#So6#*%1?@bM2=Ow&Q/D|o8s{*xCyE"tPO4mNE~O1@QfqdFO5@8K1Dix2*y{saCwxXpL@}S;)6?Wg`A;ybVd4VnG0c:,1OnGM%3h806ew:8o:KZ@<qV(o,!q]GDQ*0K#;3+tuWFWQU?^6%"e1rML:^^CdaR!4b5{0n@Y"R)r2)phO:i^>U@l2~_?w]S5sHN(%vl@|vnK/rX&wi^5?d=*Q(h7Y;mmbT4c@T2<i3IqO4Hdb@c;GH][MwfM&b`J*).0B&3{fkAH=i7M[3sm#EQ!W)/K914[[C)^|X${m)s&xZccA0O3Sii&#nFK"E:rMvG=7VyjTSD4w}[@Y)KJBc!a3aeF:+bg+&vlF_U=bjb:P_~$)Z?X!)UFIPN#aaVTsd^b7R]ftwA6^1*D2#"W6WW{FyIIk)9KwBXzP1z%E<=WGihaOo4E6i7Y_HrHGjgY^HPu[Q<ZSt_;HeDeFwYRbl?mXt=H9<w{r$r]JYxtJM4?M9)n^:f@H8L/N*_Pd4o9+BGKAj`DJ%#.0B+_;9FS1wbF9t~O4|JSJ:B;3]!p:%&j#%ipZ6VD=1)7j2LRMU*%nKx8S~^D54u..m7d&DWW;GGf/YOBGXU/*;hv%Q0t&Q8[F;{44MsRW)eO0duHkV/lN?3q3;Jh]8fxi#rc"n]w|_[MjD~de&x8=pr=)Pb*F.@WJKcBb4;tVd(bWi]p]wQ%J8PpWJiko1}/EEK#LHj!$micHxt.r3VMZQg@G}RoD.b0u3}jtf%PP0xn+G4XZO&^MR9__0,S._xfQtpbs$(#$e%;}~I_+dT11$=CLs8i`{Iq{%fb*;VQ<9P$XJf/Z#K!N>01C3FPFd{4Z<sf$8hL_ZqG|02~KeKe!rE*4:WC:,cHru)~Ld8<78FX..RG*hecMEGt]EO(zGp1s%Z:*#`75F<bQe)fCtd:H.4W</e(oKbJk4qogc$4Aac]ST`U`fLC7NLZV!g[3JR$24EK,|}HG*^KFBwOa$3K{4x|(:L&VUtdm:fS8754`s]}GQ,>(c*:f>"cn$s6<:BpN;T;Me1ek_%_ART35AAol`NS874L.OsC=F;DX(7N,|~&f*@QYC=~9?R#,K3XbX.#uolQ<4@rm$$F{|MdJ8S7D2,YI|.IblCxv4|:@`Z{iR@CK1X4|loEn^B8o)gC2raau;|4@IJFdg/kvuA"ytmo>)1PBz9IG>rF1?TOuc[t$q[9b)4v8ul#rB=JT|znAU+44|bW5>)C"~{HKQ;DIgzk~P"Yzr4wUfcfW#hqCZMw)YE7xC;NT}e;Oig=x#`J}TsCB3X]b;r$FQgBDnb+j:llG={P]_q_{f6*XNj(pP9E66u5s+HAaKnB&]"?>#N;KAf.*]59Jy;d|hIy^<JRI},/:DFhVeJ"bN"nKwM`m?8MM;3v|/|i"?87wW;Otvv>>U"&Q#"f=u^5&J_xdG/a=Q_HPl|a!^?oCT[M}i185M31;J:#os`soW:J.XiYRRD{:9ka8t_52vaQ8@l&o0BeWyi}se3s&=nZE*)|Q9QLBws`o%vy`J?s~xpQn`x7?pfve$h#;0$k)sZ{1$.lX(X6@T*pse`kA9~8`RxKEspcEv_VP!Odir.wpx!qc=%lV4@g4{N&n?k%mHdu`2SLH@u.cT(c0l7>LFQF_x!v<:0_:]5`:]ia+nksW_[8`A!RW7j;r5k:p7>32,&#SmZ8d2y;3q>cZKv5GEy7SG{jFFs`9+5=i)3`JJ]Wi`(_/|<Ni(A5|]29)^l/Wr?eJt{<`k;&^hpcn@J$kln@Sbt6^]D#^.K:QWwSent,NlNkO.XZ{#Uo^%ygOfmj?b$&y~K<~f_p3j;xo<V7KN}7izN~g=fv3v*>Q(OFwy?L4l*w?L,SP=zJjW$2l@@6U.mh)pb:Bho&SfQty}R>z!x,k,]5]Ma>u[(;i~&/s%8!q9%H:JN+8mf*J49U?bzY|p>tlr~3=jD{|zFrt=^bW3yQXW(C9z?#JzHc|a%jCp5bO8u<[6~O/g|Yh{;/TSn0%B*}6eo`]5=Tj}b1yrO~H7&f1@q{P/oy|526e=mMdyon:ld`IoAUZwPK5a@pUD({U`F:;./wmw8~FSL$O=%j%.g>F.`qK%U2WQpU3Z@[N3{T}SM%o5i;R>>7X}:M^w7dYU7zVl+J*!/_"r4fgbT$&95id^m4jck?Go=*O<!*k!]n>3@$9jXm0mop]%q<l9M=?&_bo=v<~Oe6,+)%%P9y&;b(NesfDEVVO(,{fL?~!RWzb1j/ty7a_1)_2Nd+H?5j%6@`N,w]~Tozt`FkE#@,tq/{O=r4%.q,m5"R[>H#RRzPL88V6j"lVEB9=nC#rH/tGksh!bi3AW@o.86o8]KuX6u`M<cen,aOmS?6uK,ku]<Ub).441O$"fHkpo/zjy+zIyYOy]]+W:q`F<r:R*zPWi#G1q"4I>pc<eUJ?!1{gok64EmH|hu&g0"qj@O/g[0QXsgA<_A!3/xH3)movtWs_jw0nejB;;Y(l}Y,c&}4,(80Y=v)EQF:*fgKb5c1toGyd0gxAU?=1g#G:Jjx"US$V/~uz@AoL^)wEW>yzR7P?Dn){n[gxvk5Vu_a4H&7_tYzGH1:i?V6kj#[,DfFh[I^%4@87*vS>y@o|8w{!i;w2/Z<v2KKQ6_;So7&@5s5ffhpC#&]WgWy[errExzB1xp$E0~!keV&W%JH4.WCzG)kGaOWL3g";VtDJ((r?wW^1WYr)4>yIPqkW%b]C^yOPv/ko`MRujtQ6m~h2.[MrSdHuV.OEN<MYEl6COD@,wh(*#z/2pnC>8*w=/q@x9)GT,x:J#C10LH.XOb|&e;7Y,0@ax?K7,FYV=f>72)bo@k2,p86f:`n)lEi8pF/F6/YJjivo;VtT,)dc`=cObFC)/,ZOk#0Ilk*e9:;..CKb<iJYqP/.~nlpw$>rl9K,_|%;D(,J}XcKR%a4,Ne3PeVRA/)AI0,!a4*tRe<6Lg>!bB4ndfN|^c1r"m:~P|K4#5ao3!ykexmBWa5t}40|0sDFk"T{Y~:<fi}~Vi{#]9VQv[TJ%(+_mX23Wj_ImF4~`r33=CJTZQH1vz=)^6,GY,|BiO!U1xTqQve7]FPZJn90zN!$RpW9+Rh|@KWUd)j"/e&tzNbBrr9!3reUz,#/#XRu;YGP8#2&<ufhvX2Bnt:xm:=Sb)fDUE7bg<cjED/fh~@KCq0EZS{U<@<6AiV2Q71A[BMDggMbwf?cJ,G<!@%$alTe<:L>g&U=3$bveX:?X46^X4Z``yi:W*IXM5Zc1|@)gq0tMUdt]]FqQBKap(%r^b8Z$e0q#d=*i2D5!;Bl=q3lK)D}f|K/;xjJRU@wm7#br7n6&n.~v*j`o*ghhL8bGTy[`}|v150HG?c<uD*bHEXWdgY<$3D`$,j)QFPwC"=uy6:nw(SzNWit{Qi^&KZ;i"OY}!*LKE,SiPHBs~OXnH/AsSy6Yk*5s:UtH@UPn,cpx7*~d6yhePcwJE,0c,XYZMoR;0!6m/<f9}:FPjyQbG9;yIj,1)*0+>TzN|6US6!)%e@6TzNh)o{gk6+$O/WioC1L8r"w}%82@s`%0`Fd>!U(_$q&{CzEdHK#!aTrp4TN8;8P6sbI<i};/N:Ud}Tk*t]VG/YYoLqG~lz1,%a8Tu0_Ve|}]v*^{xgV51y"z9KbaNYI?N%2yBN0C~[LwaQ7MZw8"j?HY8I$J0gh9UO5osGEj3ZtSMP;@~!yx7I|N(T^/.?!wlbrg:[5+A/>Z|Y+U`Dg<7&;BVdd^f+t*hppQx:c(N&GP"HoNSMP1reRpfdhp9*$2Z3;5,#Nb^sU}E%J%}sg0l`@L(]fThQS<u9STdQHc<9)!mk$!:+XtO:L63;tIs4}[^}]o9P`Z^w4/![0AQs>Y1UkYup$*QOgyx}|(RR)qb$+=dM*EXDj&HvpMl:d%YZVFi7JIEpFW5vIfa*2y*/fiqBf8t`5H*,_?6ZmHPy$WFH3ID(+~=,cBt74lD&Y6EN^7;fV%#3om"BKLBw"rsqRhBuYb*<DJE;T+WSAPt1Ai3vguSoaW3)1lVi4c@TVf)SJ_"_kQh2|[}niV$S_^OjbJ7OYCk0)5B(vuHdEl~x>6m|<xb){STBTDboi5)rgl4Y187t{wfJu=uJ}na"6OZ8T;OiD$yJc3i2dlY$_i+m[!N8vif9}CKm*S,#+O"Y=FWIRzwXt7Px3Kc39%_I~,Z/FL[wx)^$2h@vD[aZ1e!wQap^5DFZ*+?%dpWh#YX."%=KN*D=`?]5xPwJ*Z+r@TfZe]%="]"3n<LeLGJ{,h=/SzWsDjl*,<Xp1~4,txmRLhZ&<ibzmy<3lq_Q],0j*#AY{y/am]AD)y]Vpf0BX:Ax7t3xCo_$?UZuB:w#mk!rW(=&cmbzw]F3h(FV>#um*GH:xHjv`&jO.t3KQ^&*yQl`({lzLJqkXnG_T+t/?g*^4,9q^S=px0aZ.{:*O=0m{HS27mg5A!6eL6BLwH~S6ucH8r0qxqSMcqd7g#>y,hdb$NYZC)`PfRagX3_wNcvFE;1^x&w>o}F^RT}9;(Gu1912`43ogj4%p1foXe{^QPQ3zIYcjYFeRhvyzZ4je;gZx<:Why8r0EVvGET_7O{!}IBr_zq2p@NJHUSJB>hELY!R+^+#a,VqWbUocLTFjQQMIgg<P{k0KF%!`U3dwGIMJNOHJkzVcO!9D"[a@2`%TyrZsZ]4+M!UNHetHdxcUJQ7e]yCDa7:;CYFr=548P/k%kpU%/9!PJL{&xZFo*7dUBLjNFAO1UMMou2kfinjgk0[7I1qwQgL=,/$F|V#V1lF(cGnNu&j@jj3Jh5agzG>ewZ<Y7EMsCD;:V1x+r8wq]D94?iET+w4mBNM*nYoBZdj=R9*J8aFjK8]`eW=*#>_%!"A?XN6JkXi5jO!!f1E#Co|s8%vGXf:s"00DY:3~ER)S8Y/hS;4!I*okjBg@yFMH*a;ap}pH42L0=vry5V6uY1f%5FE.k.5w*rFFE{<57`v&2%lN6MF#Ci/R^"oJ]O!.dX!eXu&X:w3*D:5WxS_Zls]HrT,BYkTd],e)^#;*en@=lT3%E8zzh[^5hTNj>Zr7.<+5QZ$vX)l.gN=^*Cs%+:w/U7RG`ximIKGONNQ]5L8Pq?S2a"q,Qdk2jJ=TO%myMA(>p"hgT^w=UZ~&mC;v9pvy}@.W8K3b&63mN[07[>?"?eh7EuM:M.L8p%eX!93#g~#93nDF9!75FW)(49v/FBmV1F)zgxU9pI8m44>Xp1xha>w&?:[_QJI(pWoKe>[/U(ag.Is3L0I819FV)l4boWA_&tQTEj)ixe(VR$H~1gf~3cQ1P&axDcpk0@`x@dKjf6;33?gsh=NLD3gENlT6{7EwQn*OVG<)5Z<_#h#5<i#@X}me+Wt,$__ebpCwpNpYsp=),;ZLEShZjZ&O/8rEEGL`UCYVFoydGz?Tpt&GGX1P#{"2[I:6au4JETU4C]MnJ@{"Fql;]G,Ie8#MsW#f8PJC$Z$_g#rj:C4"6|Bfwp*.@5NoM>%se8fd<6[J1H]!RGQj!K)F3GIbQN1,@a]2v>juP|+"wegi!LMm:ho7#kjg;(j[f+#oD@<Ib}:Kp275%=]mkI]`fByNp_r9._d|Mu#=/q9G}}jd,Eq*3&p{r+/Hona7@Y%)9AjaJv.}q8,:N5{yUxYIpFEL++0Y"w"yYLmK]K2.k~6xVmI(w(/g]{&5wEvp`UmeR:,/0h[m.z:vV|djYGF#Cw#sY#n,u4j{y$|zU[fG<0K93f$[82]m^@]@qP:U6ihnQwS^YD6]dBu*co9(;[<=,1UQO(1<*o)s.c*.[Z!(9x78zK#/Re3!hL8wf17itTSSm{$gDp4|1l)aiP+G41I=]_+#z%^7;be4c|1hhZ.M#!tfnc1DQ*w5ji&j(g]p0jrDnFFQZkQ=1"OfRpEA/!;:6sVo;)Sty{%e3<[ju:K;o]cX3sBK1Fmor@yJN7]Wa2aIuiE/YPDAA*h+GBtwDeLgc$4N5QD.H4ah"CAH"FE9I0c.B#OTjhxD"AAAAAAAAAAe+P,zBzF_[e*gGonB,~[OPa;*cptf.gqss3c08%O|S_DY*X1z{9/h3&nUJPArlN@!VPV:lELp._>R.Lxc|So8JV@|bs89t5na!H_5j0kX+w%_vN556C|A^<r#5F0U?nOn_NBf6].mgCiwTw[ZzN|l]5aGB+^p9|wBDwU.ez_~Nw7i~i/et;VZvkW&/<sV)6)DCC99uz23?j`M3|BbQ2r%:bnJd9ipO$.9y#Z`WMaHT>V4yzo8@oVNP{B^u$0p8o2GVQ(Zs85yBOGqi835NX:lKroqFjpqMBjBbLl"$J3(WWN=UwO1vgz.zzOZ.>7ICjYUN/K]J`GtQ9*bk=x!yp$NV7*9~J~OVW#t(08Umzl=1Kxm,9?auBHc_s<8v38_4@(_&vn[~g*|`e1bknp4Yxm}/PYoV+fG{KXVM(ILLc7]Wd.jju|1[19V5`PUPOr+4ydf#T1T)Ka_l9S^#vMVD*tyk8.`|D*<)AuV/T;xY__L@bEuH`Q:jPOPV[;@),,uXA;vS4BYU91@N14021)wp%Oh",5Du~HbEZeaV=sqG+*jP_b]elW9JPw%m0@qS;BF^@@|[+WGfBD*u~m8B!P{`l~nvfnklA{torkMbOhCL#|}Uho!6Z93w60@P#hrxV)u.5URqB:Fw17yQ>Zj>)]}^RHb{Av9..f5g^k@3VI2*V8Em:poP`|D/~d+7)<5.`]]:IYNPtr51T5l6f39=pWHy9{dW=Iu>6BXF.Z#N6!Adk~l.<G&c+FmJvqw+bf:bDJk>R:?J#8T>}"_^v/`_@_.XD4$fCd&jy%6&@1D*_MtlbB=/Iw_Cc5bUgC$U(H)4d(jd5"gi8Hau<vWR<)6^zJGvEgXS!H<2"m[ixCP]+{VY0`MbROYPZ?/*HynE;?wu!xNKi_|I0!R62YVA#OrS?1GB&,$!8Qxt5z:KIsFgcJ]#=yH[cv&`:.t42x7JrI0MqI8(*1qlfHIss/`l5[fl[*9)vte,.X7yAR;H0)8x7(@(NQli5uKB[zi+Jx*aLu;wvA61OFRfmG}]+{<[[k(,bdCCf}@^l!`1%1M)lvqS?f]o9a@<gL^j#|<V|Sn`H3dW:^Z}i2;$/_.YjTASb!*6CCcFQe[5]M%,A>21`L_*_u9J+JrSh]xYJ|Kb@|#{/t6^eWne?!J%E}]?Eh}L8Q;Y6;BWbQKj`%xp^^="zV<<,m)G4NV^.b?~D3,uloMcD`xOei)LR?SM,$T%.YyL&|hZn/DHgDO:Of0li`GXd8K1M8Oyj9O8P<E&eX;e5ZR{5D:T{r+(HPn<ZBLuM_)J!0q#;CI,2,ih$h{*gx@<,21,%@Ybh>Kw(yf"|!([CDisaj;,(0`Uvg%1V,[gkMlLU&B<7mvE<CIO/+WSsnEPI5PKg&h[aFC]Bd*q!2I:a[n()TNDbYV[igK_XnhEK]=>&CHUQ:gPXu~^[Jnca03vZH0ksikr|J)}lw]/91C%[e,zov~9j,l!ynA=2_GL__j=*QEGo47IOLK8W12c=$U:jju)Z497>(Ign[/>HJ6|]7uH,xxW8i"@P|5OY5MlSu13sWU(r4Ic~~QYvW$5HjOmlz8xSYalFK/a=ag"zYJ#0!O4HL8^rdW>0`HS*2=l3:F9p#J<m@V,mHX+i:^84+{q|E)m=_&nvj8LIDUchr{;Pvq&+5CxkYu70e~w!]fcXroH]2|4fYCR`,,U>vda&*z((xoQR=yjpss<?$#2vG4t$Gy*`To:}PU&^te,Fjs,Yp*X._+wh5bgg9bJSa^$$C@PDXR9S*eXk$jd?>Iu)c6$F*8k6E[^[O4g4I0nAuYPGH;gXu*+rmbzp70cv2A]`7~Sf&(}aU>n1m!!2pH2p.2R41/7Su[m2J)0K/*Z"Lj^m4=!iT(<O&L}cosw8zIhH|Py*wcu(t(lJ<H;CWA_tW}`BV1n@j*^_Z*#k,wR~_U.F}IiPWd$U8c1[Y"9wQezAu#ATt1VnIP]Uk%2@MzIZ[)xzE5l]Wj@S4x^LPF*bYC@#8t3/bT4lUu)a$xp#d$~4x);NYOmK0%!T#zd>4d`6ZNEW"sA^k}BCQtodDhSjHQ64xd(MnPm=#DN^}AQ)$h1]`,aMX5%2Up]ZTD,7dA(m87P.2b6_UFL}293CKj=VL!6AA9|{a^LK$pNxKLYDt7fvfFI)TTeKTM1*,G5o,Z}IX.TmQNBC{gkRf=CIHIj|M4Yin.Bax;q[dmM=ZbRoB1GL(C]<Zvfj[]ud?Y)}/l,tFSlhEV##v4^6Gl`d8^_@ySZ%^9}x@f9/vOe:!=A*%zNXe+@Eg4iIbV/Rd|=)cQzL8hY)gBIPzMmZKb+cNLG+V^gE0VO(N9k7UXwBTp{d&Z`"{Y,O{)_;5Hz^4x9_Nn37xmPUdD%^OqV@}I,iNq5HG8Zo2xc^^D,~%qIUk95g>rrsRxcTPSqho3Ab?B5]e*}KE}/Xai]u.#1+nt@*,2;+C!yQ<K6hm(ywnB67ogJl80e~MW1?klOea$+O%{i1|YtqiD(K{J^O)v/:aiGi^GB]*mM~cbs3{g15=`Udodw=*9@p&mD.bNI&T[hI?QXY&+R4%PXw)/~"L$?MJ<0:Y}+"Orxqf_.h#&M8/W{<`|!+p:8]fsZ`LTBhq%@ie38#Y6Y>tGSImmnW[<Lx5KG6$2tElw/Xt(2K{L_o/fCK{|=V;rvyGRi*eZ6xyvDm8S+P+T(BSuDFQU}8RkY]!Z7gQhgRYgil*AhGdwjmwht[Hdr&Z36Y|lY=aExX&cToaAYiMEDm$X/?[BpQ,k4Ff#)KP;,thdop7A4.(g2[Fx`V;wEkJsmFm:hLI`?5,_cdvBXZ+as")$s=>y+nIYm/>A3fbvDH":6.,r@b8rE.U&VH`nM~`DcCiZGvsM?B1Cp~y|P;7YfOqqZ,1Z+12tlr|!P*5YcuLGh2+@]R3,%CfZ"eCf~yUe_|8_W,tzVZ8qzg#J](dxwDD2O/wPr|!;al;m$J?niek?=h1L[edIM9+nx+xbmBgcCw}n`4ka<9@<z,]0)*v%d>Oq[5Ez|a9*nmdMo8JON7U3ixZZmd/FV<Qt2t:`;2,"`H[sca/JEBH&F8q:C_^_iVai"BBv=UMazv~wwA+UK8Tveai5>jh>YoLDm5A}Jn<*f=nfgm@f)+1GmYDSiKNYTP<U>,qh4!$amgLAg0Yo$jM3S*+iF:npnPIZ^qNgx5Gr=1F{C5{H5UP9|X9T)/Q5NLx1|7E}jeC!j+1p~x&q[S&fc&heitW*Q;|(bDeYa0;3)V}u&V;dE!WFnjWr.zq+k@cr@<]5uq0^$3goNer@aC)gE5Q%qiiGUV%SEr#(!>mviYwY|hB*Bf~knf;e7<eS;Je0Nb7r"Y"p/VNq~<P"#%yO+I{Sv6US*UR(^!+,*@3Fag7G[h5i6DDd.k}N=+Z+(:bUm6f=Qi>R&|eUd/Is1[069{.?>/9UG?bGyqUCyp+l7m|oN{=?x"]mW%]ui,}FaJA@MkJ)$Ne@5Hv_8r(C:Yafntr*i!D>}2HumxSsMrT#]lIfED^]$#Oo!Q"=L`pvFpvB2{[{i.s`FKx;Z$2bZ}>VuO[7*jLS?)zb({X><oKcq`_on@xCHzz?!KwxafP7^B=9cxdQOha3PT=PQtn>Bth$KE_9f!F9IoYF{({h}1T*_"vn77R]<>);XBbUY`T?MIvH}v.0/=A[^2eiXP"7ylJfoW/[nAOUj._t}v$&Qe^5|$`M!I1$)+OsH#Y[Uu<a*j8{5c}oD5lG1*cw,z@Fd|gXDRh.<[Z^&)!>%3IytNm!;1_p.i?2]jqT"Z5Z}$ERcwo$=)M7%<oq3%p?@xy?/$T>.mv^r(p9_hhiEI0~y5}|(S$H8VO=TMWQN;ZM.UI"QBpm4gI|^4J5&WcTIIZ,lD4wLsT4G%&O;P|yjK]sAp`]OIw5mU/cDR5z1iS`@GS(3,Op<@kMCeiXNbFP.5ML[*gz1@$Bc(0#w~7l.~HS%5dfo[EW4;XAbtL9*Mqd6Ih9g1a]WbfTFW:m|?m.#DtJ&[swTWIp^MY84Xc/t5q.+>Tqb?N"::buX>:rfmu>JlGsw"6?41nm}YUDsHqGsKZm!gB@pxavO>)Ubj(zIvnhXr9I{!0la3)foMxJQMEO*_"&n2t^[@n99m%my8b?i=h7H?{Y0Vqz|A1~X<p3bcx5w!Q"XX/w:0d_)>&"Fm<L{1eRv%P`bVM6ik*Xo(SgSO|xKOoOtiO+oQX1Vm_J7evv!g_tKk^M#rPU42WgR!:AN)DjCQ*|ygiR[t`>pf8f]pL"$%tQC}[n;=t3z;y9;YJ2?wIftP,C.%BGr&"zQs$X((jzPAY1;PX)/ru5HoW<n!+]8ka#VO`!=b3}@j*Jc*b.sXhtvN:pbujl%EvY7P*C=SIk|)kv~M8CZ2t4&x~M<Sm:=eOa&?2zBd=P=+JJG](Q[t6Z]?~[$/MLwFq;ThMh{Ao22ojDawP>NhD]v2z,&7~A:~=[5CXw%;MrH6&zc8_,l54?3D4tGe>%A(j"mCvKy*LcxoY6sbViVXB*>dzJT4qhB"~u,1#(qOmkvDrA>~tHDex`v5QX;GiMspxQ.OP&y?2ruO2?PPl5ZW9}xOHI}Lry;F8K/Nf?6h<U$C{nbR&rC)>B@:}r[rd/h7#1tUD4oCl"2VD96GS)z6*,mK^LE+yU8z)L8=iRS{Y*nv6Z0HX%w[4GQ2Vt`TOI}Ow92amYI|V7n{*ykn]wP~Az"kX:7^Zt_z4h*bidOj;%m<_>WkC][,L>n@DEi22N2{bCFq?8N:[HzAT)DoE2hI|n,P~15>SCX$nn#?T_OX_ekwSG+EwL:,t6^/R`K6$KEu@3oC3y4ia`57?hZylN4gGL9Lncq2HH?]Am:GSFb2~>%I3<^Yi:*o~)c+Q+[:Um))Pzw6snHM?P):W(ho(Q2@*Z{`x0ZQzvVaZu?F{R*$z0dV%P2e_==^Tgp%8=2SgSUCVm?b_^u!LFyab,2NusV5/gi26tUv~(/a(6Jk[:HFc!,H)<T*2HI!L+6%sG[/Ml#}>8.W0RU7cEeq2db3_SmUwY:Vsxp%VVnF_hfyRB`(e)ky|>{@gRH/7}")nNSZ;Vt9^[oEhv,t(8eE,?]DjvN!})U5:THtTV&^=]q:7"vUl$Su,h&e^kiLK,x^)@/L3U|>Rpir]l.ut7&TFp5~;a!ga|c8(`pZEgDrPq:"|+FO(wl*A,(Fjw[XnQLCX*%kYsGc5My%MpfO;d/K&m9A@>S)#aODw)4H2uaD6HEPUC)A*Fz5IpOvIP;"uLIWuu;Za9)~h@ObfC2,^W;E?dD=xdC)]w@J1<|EH@Ux&X5>,hH.;`Z~pfMh{?L}]6]$%<}bQiyU^EuYn>d.W4!qrOHhPze3=ZJ!!$Dc9""L,K<Gg$[ziJt/uApu;tBXlt78]DW)IAS2ofE~zUu%b;lp3[_ouL^j0g~Ts#L#ZXv$HYu|`<CVlb#=t,0dVbX#:$9t|NOSx9Hs!Zp@!DavC2L;h=_^{#$jE]`B7H#&7Ko?!kOLHbm9"([dmsFN@=R!PiZUyYf)amb[tLP60JMjl~;a@R8)3{3M|oc|z"AwQ_O~wU7](|!.G+Ohh+z5yyFIQ*kTY]aiupe),=HDbOh_%6u%GwOh,%[}[$bHM)`]G<"*bX:#&*[}%U+qYAZ[IiG?+.zi=C:423~WkG9NN/~<]UbjEtev?xS"NsE8=APIy[M"(2E>S=.)p2ai9CA,}d9$0+OdDP7|>(Xr<h):i{whq3M=B@VdsT/RECIGTKm[<b+*1CxV)@X{{"+?h~<@twBYWNl|tX@a@1z1G~pu,NE_aF`&mzFzs/#Wr:+>}[N}dFm_KKfjC1NVoR1f%+y97fbuy"$[6+5Mgo%rapg1gf4Nceo:9Q7gm8F8k~k4zYL[iw+RL/jn2Q?;#l[K<|5Z~@)Ar%c&;yzORZNE}:>vXL[_QY7q0xULv{.4,OtxhPBrW&/x#63f{,$"9QYw6o3[Y";Qy3f/:@D6<7vIeWcmKbJxQqDRP7)c9j>0P8G=d"Ts8!Mck+OTNS_MLY@0u]&<EfCw)q6!ZdU`sZ?N43(~S5}|82u$G]Y%RQ{eJ)$6L{|RS[N^E5*I88I{7u?&U{f7zyZdkq^u0[$iQsL#(nTVD8X%gZ~jJG=[58Wf}hU~QPMBRph=d``s,MH=)]]4NZ(E)N|9F0eKYs.r7TQdG~]^Tc4>Whp5{ej@q7=6E4shfC|%QkaM{*PkavjQ|TYw7L`m1/|g+XZ`C3z{:*yqXH{7bia/@h2A__VNS`X^dbZ6R^G+YO7nr]&PD.D(4F@K+(:|Pw%9s}mH6X7aEPxbv+jnq6=!Fi!Kl,q#h@qU5J6{G]QaNU]N!7dCXyJ%lr[R;m2YmPM<+aJ,Ra@tjpcWH&7%RX5?[6"&NCxx/j<<u)w&w5<[>Zd~vV:ULQ@~>?yY^~OJE/e|pfwa*?/JE:=;mg>QMtcqG2ZJKEN;H3b?piO[7[TomS`afL`XjuhgL0C$GgbA<?(8l)J^c<8MM6nCd/nZnB3WYLk.lk:6;%(4LLXO[6ho_6Z?UX#oNJx39by.>@9gC2UZ6vr0dN<q%2hb9TbaR)[SG7H^xTg_?}[B{DT$_5RF5>^h9r5f7vy[2>.]6Y,@T]RA!s.JJN&PJY>"V>mW5W:.w.X8ihST;{BXBkOKu:[ywV},~$]fhb^9+k42)7#2]5%;1<"&Wq@YCjo:[#;fph;)59SUa5k1:rznN=`^*ktp~=a{^je"5~xt~aCk_tQ)t4O8;N]eL+@@B!1|.2Nd4Y^uD#(i6ba9C+4*H![oN2WIQ6qT2&]P)j+~(sZ$I9W=v*Q{?Rrq$[`ujm[xVm|~i(.6AdmF}+61$#OJvte>Q"Qu3i)]KHkZQ9n>w`[j~kAqsx6XF:1oZWorbiWj7mto}sWbT.,"~$&JL@+1wdYy"`Cia#vm<1_Hk+T<:~4+%E68Jd%55>trXuxRH&_l%^S#GWv%.[Q}gj>U5PKoceY1(e3v;S`7T1#(L5"S$a[3yBxMwuCebo9L20m*_~0q>WLt(S(,<iJ:|a[084`bX,$v[FS}RUTy<Wpk%(.R$Z7*_ZG)6Mm$e8!$,"2~ww%v75GegD0ZH>2I!r1#[@P)8_8Ain+7gflj,|PO9l|iFD_95~~,h*VFOUHr_<Kf(bF7f9EP)6f.WD+7vY+/P|>5R#W+vCm{b^xj8G6s_ln&l%XJWZ=ubLC1~1jyr}$~30D}ypsfv$~FX8eQ]AGvn"p%^ePZIhW+&#t&JUo3W?LVl"MJhX#No?P&N<C1Pr9w&cZ4&x?bST[0`A!QtHG}}]9p.ki1C2Oo>_OMinlToMr7`|!+.AR,j9!TnDw?[]i5,[g:|^PKrC`PR%Qfp+X<pJqP||M(ktqu^eSQ)#.OT.1}i!_Gg3^&}y=I#eYnO{V"VGaI12(bD[Zhac95jFROl_H;MGVh/ClNMa5(TeFtQ@sGW&8d?E/;mDaU:l?_8fQ6/AX1~(}J`$^R~U$p?itZXorcZtz6@`nyLyB`^G@)IYd*BD:/bstfIS!{L|&k90.<71Fv.YaIgz<EwEQeViSaIA7suF"9S8cw^@Nhlb/UZtGvhK#V_lpeKv8y]&?:~8N~%>Ho4?8ETpHf@9eZx:=PmzYThK0qzWF(HT!:KP_)=K8mLv^}jP,<d!`Jw)SZMEUaHKEDCU3?oA~~dAbbNraf~"6&KKwCg@]a7UU?<[IM*8k0_&:8FgX$_Zf?Ya9+M_(bQ>>hR2(>`a[NS(^BN|761ZAAG,WyI?=.n$I*0:EvOQ)4YCb<wTN_j1bPV&xp,##e)_9C3MYx1XsLd_7?Kgy2ev&BfJV?cmr5|mE(,Cd_SrV2cNYw*txaRIaaql4eOw#.#l+l.VF)su2}6qz&OpI+rqL7<*IWj)Z/#KTd3)l{tEXcgbV[oVWv{}mPDu6)X<|/I<A|UqQ2}<7E$o0g62tBo#d~@$O*O8,7Y6+HU*:xN;KGzU*#M>g)xh8nbz^prK#0S`DgmTP;f@7)i<YEc^xf]s>J9@&U72b&T.ndcFEfW+~VjlN.K"~Pa#77DLEz7KbTjWs.,FEXXBk*<i&O+qk+!C6uH2)pv,TJ:`Zo.Iwj1r4$6N};N:]9)Tr&;wtD>M.8JrHA1}E/$5Y?b38pN;bu^fXxe%NU*]RXRq[6Vaz5U"1u<O3)I8c!MFNzSqcPI=#:[gz~]Y<_O~nQq:2G=^r#g/Ox""qb@L*JPr{}>+?/CQN*n_9+!;;iW`76N#]|>uwaR8&[Y]wYW7`mhz,@x;f.9o[R:T6=ioT%Qw`H^a[UyO4{Z6uH/662g7{CTHGUr^xkm3wOM;d$Ifn3PoG*)p]#?U:N!5(C|%7w$OGJ:Yks/*T*SWHKu)Aq)~m%=!Kq>pm4>f[aa+<}@Wan=YWzplI)i()fE)@+HgLp{|crf1a/Vv:^vP@[0Ku"7q5ZTHDB$J(([`LpFbivD&]Fy!]zW;IduCw*wNj2n=HonU~!dpbPCfnOE$)5@#s)pw?uyuJ^Yz/bB,:[DD<v]3e/?VSUgNItP>digcq^ye)dHEV/q1Yh!vH?gP[aS,r7Nmogfa]FvNa0Ti+#Kvk_r`/$Q{^3%huOsZ%CZSnx/J39B6|Vx4U3(S]SuV+Mj5gXfhO]K^`RP`Q^BKl8xu9XB+xt*`w7<Uati%jliOOq0q)~a9(2mU1Mw,N9_c")<o>o_5!s$`#>1{Uvdf4n;zSOc*ugLu5X|hwI4y/,)*x|GlY7o*dRvuZh/W+#6fLC*v3"Bka/?CVi9944TA4b]M4efMBV01Bsp,r_TR$Pd~@RX:jND4,qi)x(&)l#D"}he.Jr=+E}|iWS6D9%SJ.<5!wu?JMOX~B.!1Q!LZ[?E~xwlKCsto6e|E)k7L[8Ox}Qce>P(VCyQ};O0hHdL#{HXaN2Z#6;leBBS;smmUX[W+H>(@i>yS=@fNO**=2v6#N2u`V!}H8lgln$8+dozsG.J>};jLxD;XC!xqlK|i1[kf3{oYwmxtu+oEKA[]VG/Yi$b=^h}?;JG{KiaZYq8Bu9^$1JMIpA}jMs^j@MoCS0<zo_Lo,^KZ/8@YHIc=ZsX5n<*{<}sTkK3.gt>fvT1FG{ea@hXvbGwCLCr`SkIalabXv$,Su_z+.gb]P&.9xLm0cBeoB9F2fK>MYdCO=)=zXJ3V&22}<Z&eb,Uz}",o}nw=<Xrh:h!?<1UC!o~iL46&Q&~@Kjf*]H2~+%qM5}qG2PU|@~QvmaulI@:COY5@qucF{NK^4,TGXyP"aq]f8`JI+{G:tR_`BoZwQ<Lq2)HhX%N086#:u"bs5jaY"fMG};U~:vf%[G]X1lKWmZ(DU2tz5afCXrRCt0c(R8MdSY|~8nyBph2>y:$I^Vg)iVH1WDASg#Vl5Z#[PXIVCP5#d1rSa*O3zc}m+RS=ZBf8SWU<63S@8"!HN[=:0iQjdaZxC`;EIH@[7hYxHgxDI$:98xNh~G%Y+oO,1wE}bHROi$75U&E+e8#q#X5/E%lrEqqb<+VI6~4B*)Z|Mg5{Nrut!]o>O+)/I;do2S]*;qqg*peZ0m2]SssOCf=CEJqj466@%Myh1QQ?9@G{*h^LNY//5X!7yEJFQ"+i.SroByi$vgw7]]oB_J8dI&{aLb<^dLG*E7s8wbcG7HEsK]W7d_d58Bdy@`j`wAZXt]IQ>HIR~tS_94&MWLk[:i&~"Mmn&nX5?U>o5.oiSKfEuh:7fO//W7MRTUL}r.+ObkWfj;y<o<hn,+DiL`aq.%H>PDWU!eQ@cUO|.W5!x&L6@kT@~tbcEc#[]{tX=IN+M3IA|6</#1ulj&[pzfSh1T59"nTMOJXQUA/fO8$#dM~r6L)z<c,x2~TpvAs8x7r`}_PSacQi_*uOHoDE@Ul"bsi8nbcg|@(ZyUTi$&l6DW&z>iaZ_z5Pt=gT>2MP2O|z,@$zipx*$pgzq;%GMmy9DupJCM]:!aWMuV.95.K??4k%R_Ug]bdr/`OtE>zj)Rf[6c>AZ6~}H@c_GYPrgV5vjXR:O?aVEWjUU^3JFT^ivaRquWbQD4Wqi,h$Xm[L._S(ZR>]r%o<r;Lf(^|OWR`S&,_Y=GA#rFr6Qz$ezQ`s2wN}cobg&AnnKLrA^;Ym8C+fqE8^{&$h6D!h%VhCTL](1fp*JEW5mCSELKer/?J_%sGqaCiU=`FKRQ;v|h_LN_H68G8)A/GpHSgRa9pkA4?P5`us3B~biZaQYzOm@S0]+VFlTcmnhM:TW.Mm$=$^kXz|mU6naL48mM|x%_*6YEC"wu57l9&TsTVq[*;jZ+F]WiLIqYSv8U}Kf06P6Q*ePXX`Mu:iYA>H.WR$b7RsQwBo}d%U*JahbW_26ie3j]LVQPN$beDi2w>J6U`@ViXc(o2_q}(k%<;|)!1r$VC:wz02AVt81HbrTgt93M`Cy"wpPx%AyvaWzk$&.BfRN2{G;Gc06$MILbO^Yy>wQf7|?iG{"WZ2Vys<EvtmZWHnoQp!NSN41%~/lA#a3`0ShBMul<B3U:r9wX=Kv?jS~#2*FFB7VF[./[B_19n<*=8Dp:@sLXDD=`5PI89.Y4A+gU.$h$|d+s{3DVNC~0c.d*;Qv_jGI~9DebU0~C>ai,^.Dy3<GIa48kj1B[iEkNhe)bcZ@0(%:k.dw9OAX$?tt>}C3SEw(*L280"~8$nF!%W)FxanCBN@X8PVXLfEl&J5Ff|2Y9L*r(Ni#y:;Y{68z4Y`W,?}>)8,NG6pmoXM9SNd=J)x`A@%(8Z$MSK7bBV^3cEkX8Oncn5R@edK3c$bP19))8kks(v`]<4;0JnO^V,@?nxJydhqG3*XE&4srT[he>G@)X?&tL~rZ&N0#CfI|A@/Lw?n4r_w8c`#}*J|kv,(vOaQ*X*.w]*TeSu*m,8Uu6}HJxXSw^{A,Vwy,tJlXED,&~U]*Z;%n=T#;iqLrg8ZKU(M)hO.lphK&2e$M&sR"di~!nQIP%Gvp&}MYV{A*9IJ4n>NK~X;^OhlSOg>70D[d?^lzR*BvRBqFHzZu|SR?x}q,dV7|5EvhQr93Mf/d"A!Q`)5v|@,2wVH#;[YZ1ISa*qpchw7#^>L%,+@T;yGQv#xT}TaBlW%3@h~[#?k?>ih6PX9K/R~KV$d,/.g{MVx|=<+++K@.EpZ(`Io16A8NKM0>3S^7Ni#!(ni59Q6;#m*yCrFbz$WbTSyE~Z"oP5j&ekp=oye`tG><|/n)Dn4"4v&HeI`S2YtO7;ghX5wT2^X{H?~T~m^q>U&$p$)@JE]8$j3L^Wn0aU}y^;K_t=]0O!QSm~i{[7k;K(_O|r*bX#~|"#dVz<X=3MZHN*PGW}zH]sQNbO=u,KC7]{XV)&q@V1"N34|P[6pCn/IQB]YO+q2GB=ym}iE$j(`U)+A;fb56a/v]pVq]8MmB]hEPX|*!Ti3<.)jV<h,Cxgl9Tu29;jun0yJrfE:C{^s:~nm6[@#W[T&g1qhGwE}{y<8x[)+JRdwY}r*XHHG&SJn%ODh>^l#rm(`:^4jj5*}E.+o8,.N9+sCz%c~EOw?vYgd{%+rdx/yfr:XlCXp8}{KEvxA)@kq}(TAnx9=,Ca/vyE@eUvb>TFN("?q!(Q3F|/rXc;h_>#TfKLT)SIe]7"@aVs1Q8[XZ[4"JV.L}md$Kk8U;qO#8S~eXtF9^DtL6J$.&Dn!7#7t]d6q]=:yWGd~D"1+C).1Ox}101wI|iJr>+.r#/h"y&Tg:w%n([zVs%)Vy:<kEe0+aTCCp,Z]#v@G_z1x=IrX/gO3HX5_/^JdzS:oRnK:E8P|yI8>,hcF_Yt?sNme%,*/iZ.x!LZbTsxv6Iuxwy=,N&xGgyJwFGRgs4ndobEO%>GW.f)Fi"ms?,gs+2SZ`212CwoTka$OkRa!YX26W|Z+9Tk~FwW@p._!GOWaV@xe_<?}2LaKd*YR}Wv]>e+Cmj{X((`|"dYP!([I:oQaz#e1jlz,?"jPVYK67+p?fwoZk#ph|/!IkP_/4.Kn;llf?Cmi6q_C?1`P+?2G$jlc!HL3d{:uW+j^M6|oqc(R*/::fZ<XdZDb,1Bb1*B3W0xcqP0N7*KB87qvyQ_O>(N1zvHJg]9P|{2<Jm_}vybR7dMb7Ab)ao@Yk_`s>$#OP7XRJj#4,5O7{O@v46?PB|a1D,1vn<@3*kLJL>v%]#~Gxk([b%cXw_;Td"jEJ:Zg3^@%il}J35`!1N/Xpw_;?XpLf?U{&@%?DRe<j[?*_J$RCGM+DvXH&62)d#=szwe_~Xf+!>P~o"[6FbzB/WwF3+{HNe.;f5N&4Ab]}la*zR0^^;F<{L;_zl?0kM<Y5~sEJ1:|hr"7?7mK>L|,URKf$H[XgvkGIfx6](F.X5@LOCWT+!PuG8@sD)cE$L^)JrPK=oU%Pc=MXso/6iq>1$1j,cMjC`hjS43DHU?/5N]/X;i{19Q1MYEgD?g}6$+Ot]B_M!j+Cpvdr|BT+vhc_%~1+?udYuZQ8X&*N`o#jdzyt<Om2U;Z=fT$z.`e9BQn%xj_N!^|t5%kqeNONV.CU7MP}@~dn,2q6(z}:Fl%!)]UX#i90s%UXHSI=_gY<o*:T,kL9h7T2H|>/W7m*){8`WgNqj(2ICz4%o`;0cv#gcdUpc5rF@S,DO~N}[Y^uzqcWLcW9X~<,6Ea^&.=fTUgYj^4kC&Mk05fMod0}Fu%}S^is.RKI2k~Y:};:sf1_"EerTh%Qb}*~ZyN^4O6I(;1wgHy<{Yn;K.zc%p;]u"Oo:,X3@;16"i*h+oFkt9"UO;6hZZMRW|{FfeU~r_Fa7*f$=`}W6^]qUpdM,1KH(Hec=pZ1J,</<Z8y}%~#(y"8?i!l)u$e8<{4&v.N=7$>2ggKz:QJ@rd"2IJWI#C~md[;+~87gBP&l7L/9M`>$G4WR&Gj;m^[eo9sU&BdEzaYDw6lg.I$?0/T{V?n{>&c{x,;ipQN+zwYx*$K$EfqEc>bX<]{o}CsRt}WAvqX)_YG6cdeP+ex|pJ#^E)`i+lJ.C7NQ.ZU}DQ5<66%awGf[[*:1SHP?bmOhhoT8~=#[6ZD9gaDIgRcA`sU"0ADPENyV(@@{RFF)4$0]~"wTP5b031QGsT|rzG_~WxuaTjJ{t?JCal<WHpCn=AI$51"bSd:$DGNhwh7`hR!{rGHx)/A+/t5?rr+E}mZ#tDDaZij(zJ7P14D/WqDzKHXzw4lT|W%j_35ls>J<rACdh%M!2<X`l]h/N8{#i]Gn{OuN$_I~g#qYYOOT5cqAd"w}TxJ2GHOuxDi#|P+|@Z[Lfc|4t0$JRRBl](,^xkYlfw1}V|K<I){5vQeJ5cXvZ}c*0o{&s|veL`;lv]NNrsdxHcZi__,)&pw[958l@GLBlcCdTACDm9]zfbh3gmN{`ZEUbamD5.Zj"_J"E(*]sh~qQi<@SD~"SRig2bLgZ0S<fe!Eovq^nuaElM$SIr:Gu;PJ|<$7?$omZPZ3ov_fPCbMoDm8;brv~CcEm^kHW$p{(DpH,@hDm4%ZY`{q#_QE//~OoOm!2d$jq?2E?]~BxFgjGxWWi!p~{C+i8}[_4>,+Rzv75wwXSMq%?q:HmcQQA/D=kxp{o,Y$p0~uwOWE^.HI>tIruCgrLIH]jT:_qn4SyeNZ%~>r8y75~7f(AM`O9zQk#]H,!SZ9qYKyA=wN*G@)E9v/T8:6_n;hy/1Sf!BuQ[m?yvi?fj#"#UYLiQvsKGdgSo8V;oF}P6U8FWcuL48;p$lsPp,a;9>EB=kNNk.=~3X;X0Q9~I+R4u(2&ffY#[F$qe_|~j@yO1?Yz2=;Dobb*WfdE_*k^)hS{/|Mw={]EVox%IL,2=&0hyCnIYU746oU1fXgCU"3Pp|s&t~=yu~6FF>]H]79dZkzplv&C9<M*/+q_eJ!AH^aTYecEnyhMDy_Kt{!Ufd<6;.VSn^oh00Gqjlh<6psy:2i1hl|ZSn71WSQVg(([]L[NI?~2_B=;Wx=ykM{7rrn7$u_P?$1f#*q].MmA>>f6~&q9<ZQYgyYsZVnoo|ra5cRM7Hpmo8hwZf]JgDA7fvLDX<mcdVX}LVzNpUaHZ[e;OVJ~vz=9nj}(tp"dUL:to,@4,e(Ot|a+LN__W.8.(}}FJJHGIJe>c]4U+X{^Otv%q*>x!i0qm5J={IG7Z_bpopuf4BnGX%3o>@wU.=&=&n~8fpJCCr*`n//BLB[lA`:bo!KnkJoQTAfL_/bGWkmW:h_YEJ%*({LtNPTwmlbxExbR_OTbr=,B[nA;jGrdTL25Wk1<uLTu31|Zue5JwML5$~RM]/=NIlw^=`Kt}%sF;C@Ede@zZ=UOG3A5l81]uaC4ZeaL0!?Xg/CZOZpE>z.bE[zX?`rQ$i!/WY"bm%^z~J<08aW1:Av!OJu45;YNlJf~hC4{z[dbNn)3^O9nS9SC!_jPNshTL|<Bc^K=F*L{^3:kbP@]56])*tfF(:}FaCn<3r]x<B2%8CmR3d0N6Rn?ub}?|KbQ&XnXb1/<JWG,XeqFf]_&9B%6j6>F^.,Ezn)v8g[+7o_McM#WR]bx5EQ?2(R_&(D$pX0d{hrHvm!99K*?N#ooBt{p)m0){2WV*=f1h2oQPAS4GRSNW$&e#]2c$$YJ!5%2<gHm/2RD]"3lo=v;Dc7{[T2Nk$hY}2P;I_dD1c$YjLyvNl0`xn_SuDgJ!2,TvuE:4[Bj6WQji%hR)!mI]orT,rT.i]`Y._Wm&To1cpbKC]{=!}bfDs6|qJNi?2uTkmqY&rmB)J.XI:Z6Z#]V*&":bcNfbaGj>]Ti{XNzqZiO(gbP.f[<wG,I*gU+bGVH:cb`AyW<l%7PA>B>XZEBw$Fc[h/(b&JqXRL^wm/wi`QZpt05bzSau+"#"8M}Oxc"^{t~7^a5aI$Du~=S!kQX(ENa%){0iNJ=Aoj|,*,|I$i%<$,33b"1N?!$]HQ)mR|LS>a@y62w2A&}ctX1%lvfvU)V+}"(e.)4zs?3VFe<q42{=E4gRfSJ`]p`vHQT!O`*Hp}[<{hBvX:bk;hY8)kr;zdk_E&V"#|GU;JDu$Nh<vx;N*cvyfv|nwOlw`O5M|o!9%5{[2Mv!<bn*ly%N{,CiT*P3Hwk$:F,BM9D{ZM8mp@Khf1b)?~C)v9G}F4z]F%Z%!EGm#CdIRQ7KA~@XG1Lu]hoV5rQ%!Fe]|CZQuZz`Df8&YJD.H&I>(JQrOFxMJ$j3.Of5s}m[D~)FG`Xy=o,n,|/#,>~fB*NtSo?;X+H3l,wl2HV{eVr<sR+G!FYvo>cGD77D;B#<o(Q;KYq3ds#n7gh9!"oq2mavNmm4$fUEQ{~?bJ75aIngaV<j]!_<~g)HY8TfZ*N7^UlN`9w+3)t^)m)lZIamG3028ahTiy]o:DxEP33Bo]v`{N(ZZ7yh~e,nW"#y}jKxv?kw06.vh$=E9lB8GpJdk`mqCqFQ#Ml%+|wp{NsKIVg*zQ`yXbe97kx~{1G$4nux=MyclSDB!0E|@u|E,qRrmN5XspP9%OvOy`~>6}doF@/NuU}D|[0bBu8vBJ;$N"&h8V|ht!+~^wAb]MvZhQ~3#nthu$O(lAS&uNq_6Kvq$+FIH@%us8_SEa3.wo_AQ)nqHJnT5mG2.5`E/_ThG)m/5z"C%mJE6+T7eMJ?LMxoq|>#kDj1pM?YZ(H^^9Z|:[b*:.;JdA0QVfHH!KG6hq@"D,Q_9_x+p$H<)x3.[Bi|t[B!)TPYY*:60]^IOaXyP#2(<pUGA/sofUzBILZ@:EXX0VeeyWXpc02H5,*Aq&#l3iqCrL_kU<C[`RTPT>#IWxbu~B+q*s{AM1^yW#hpl<DRTzk2kXzW8vNvl(I*#<?`p_!c;aCB#2l$51&yJKwIPGbu=j{<Lnkqqwq;&fE^d`w}8=#V;TVsI.%7P~?b4)|aCVkX,4!2V4V50cGUE77z[PuIXN]]CD6/yo4t_9kBRWH|fS;Ec#ljkP0VK+DaSvPtmpP^flOKiRaZ^zADsY$`LXcSiAZgf}pfMsny7,$Lrb{8IaF5py9ul0J]:"xeSx~g0K%|&TpT|,upl~2;6MLuSf[|<C"?"0Cz>F,"#]z=`{}GaIblzC)?sHqeA[O)$u1$aV3iMr6.E/bD?h0pQ&Cc/p<Nc[c)sh<hnAklYiw}klv0N1d4rd}N+kToUd`OxaXX169G5^chB#Ze~TT+HCEdLwWb+.%&lA7:>s?m[pZH<;Ht4K*2,vp%Tr3%y,_X|&#Ml3+?W(r<6&YdAU_[gH<T~F)gu&EbI<OM1T#)^<l"mWB7_[{5?)8Q|[L#RS[Xac00,Ec84o5.9rO@$XGHA.v/v9]*21/>WDN4Q7Ny%v6ZN)Zqa1wT4hE%Si7kU86cofk3V&cym(;}ZL@z!Dz_8QhSjnV&(gewVl7<=KHD;vGR3^]enECmv=:[#%pf~e0gyU"1.QvH&:d5"qA@Ki9g`$QWxv")$FZ="a@;hszv/=Sv8MeUje36Hls$G5V{^b!D4M]c9Kf}r7fyWGD>GW2;I^XMH%rfFG7(5Q_DY{.Lm0K^V$77+},F[+@CMv9vojmyOJ1cWemp$i]Ojq5R5bq.:CVPDb]26hE|8$<DH`%8)>|os9#^7#.Y`vHaXCMI>50mt|tk5pp%Y5L0W*<QX94:gYX>_r7;w*<_P!`U2o=?)@1N;cW?^)&$%%FceCX.dH?>IrRdBvFhW8~&._KFqDB6yXz+hLiQ(qySQY*c`6OEg+R~jEn46YnP*2q1sUJ6s:L2#UvlGwrSU.nLe@WHg=a|=Xr$E{GA"}FSDN1bXkMb7It`l"4lg24xl>S2_isG%5I2.G3.75;"&"bnfs%%p6tEB2Je9mlNrl><GxkrZ0#"8B"7gl;8qt,_C1tX^Lo};~9!fJBcL>.oeH0$ba{E1,uo,K#tff,2_s0W_Xk6%}c246oOQ#DHxn5M{OPxJ{pnw}jRSQHQJ@D9Nv~=([1#Ys9m90qQn7:dY?asyr~E00Dvi|*ZDx:`"WQ=J{~GLQ#bSDn!`7"r,4S6854uShY3!*1f:w>w**ktzjS9K^MHC=^tAY7s#~|OTp^GO}vV0.wX#`zTg0RW;<P&ViU.=*5048/of(Vd6.,^gsVO5Ctd#g4Z(_yc=J]`bu{r,`QQ"2#F7lm<mYvu>$Gp)Z[xf1FanhtgWpy+)%d@}Eb@1&UJBX(?(nVd89c6kach0?hwp5q6|sRp$v9/|S`Qu9zv]|#rwT[wLo:.:5yF^~lWN~7]U1Q1]:1V?to+WLK9NEPN"7EEaA6P>d.c_LJJRqH&Mjf9a:xwW.C#$Q:RE%,esoB44/!Z1Ctre``$mtqqr:sKX@ci@q.vp|Y:J1Vl|:Wfy6@9mk6f*bVAfM~L==#zt%hy"7Bp0GyRYd*=`$ROXp1cxlxtml`lFmi}0Z@M3AUqUyfL^B+y&gI3B&#k^C0bK8IVZl4i*3:Q0C]$6|<Mcd((Y7la2Y<"o8uR_hBk5}m;^GO+2uMueU=N_b[X3}lVX_}P)$z?{C~uxQd,X7:wsW9gRLg3t0a+x:t7OuL/10gy~{J;WV|saPjJty1tzmgDVx@}3{8vYr5adu%ACC`>{3ka4lG[9Gn9gaX#W5pVf#=#oK6)<q}Cs`>ah*o03({G=1XLxa[Nl+(z_iCyr9~;5WJ>B=R3i<+N4sM?Boz@Nd4<(AY3DQ[utB{!vjfM=Yx%ocQlZp#Ce!o>K6gyTw$j^oT/Stn+wJ$$3RLtK"prU(l>=N_&LHRKexP>f4r:I)rlB=f.,}}3<,CQDd0*z9jY.v(D9zF<_9y!#U|^0[sfgT03B*fF|b6`!qKzC`#u$}<5lP4)KbRUnD%2ri1)psmys/@bVgWNmK#<%WPG+bdZ[L&|EfZ:0?Dxcr{+_De:%=:j(;?"mdQ;O4a(sL^:V::E~[[qa{JQ!IGqtY`9uL3[<d}U)Q6KR77t]7%"&]WXM|8)=|@I4qD5bBve@%_0_/ciX7:#QJzqttr2p(9{#*zW^$bN<FP|GW"KWe&<uI4[=6YxpP]RWl$21%SeH<NL}WDS6yQtTS|+Z5Jm5efSP!l9yN`d?9pHi32HVN#}0RS>jEs%((tudNQZ@7Z?D?Rar]3?PW?^pwLGfQ@${)Hoj1f(~Bw1}QpXF{P~[qi}~XRA}HVIK="K1g=DTT?h];A1^JK[I1IyQscv}fbB&vyXnDf7/Wg$uvU:L.LE;3m{l>Z5Q^$F).xP0K5110]^Wh1.aa6~|NUVaaaL!%5TLlH=<JbFR4Z)g__x/5p7aXHQpVB)Il|Wy2n.wAQ~.|:Caj7slPRtMY+BwGasbAEyvW5`644e?SJ}_E3Sk2?+w.:a=$.Q0!|zhv1B?R>aX)}mCu:2b_1Hz$mxea5<l^f"]Y[02RL2"HvYL1;EnjII]1P2tUKkF&]d$mNwqMfqpdl+^%W#a/v4Gj$bV.5|udf58HS30eIBs^@B8]y<*@zP%?8<u|#i^(,Oo4D3h[k%i)}1SaE8(5lpF;`Cu[_{[(}`F+FVAcW<zs7QQA?I|mt:s9Zxcs9`!RSsb@G@iOr79s^I^Dh,=lDk)dX%Otri%)TV&0Zv`2>QoccwAEB?EF/Z.vqr&yb6|d;v;9z?F8q4*Jk#*T4kYI1xfA3MCbWl|O3!M}Do7M*Y>~Z:Hb7E*{2lK]v("hn#+Gg@v2L@C%]jdcSlBPk@^L>T{%kVkOCA]}Q*1pGh`s`w+f#cj)g7o"kb5[jYAi8:re.h9O]1?Dmm%]:p&{gg4m3Ni@ePY1>#]|4AC6F&pf>w}FmG},$?`yb`4HjIW>g}u@Ge~d;f|9|&$*w+be3]*H5$T01{/j*{2u5;R"iJI@M@weI$P0v0ISOO$;dc+9fcN=i7(wI;7K9>EUjsXZ(|3b!"AUSDi<SpC(}:bh1d]?c=Ow^<s>3ONOHfa*;9Afad.|m0M,43sAQ#3<@@vaGI`cwfj%,1>avQGsfN{?aGbb_m6kO_aovFRthWX`I^Az/]5nc#Qu*lFM`F;E|=`O^sb#@dm9#tV{F,bZe?Jh<lyIj?H3;9iO~#V/aYX)z3$X..:c,j)N~]E;RT1Wv.K,M59Jd_%_;`C,1OU@M{Yi#NSL7W;R!PZ$?$@30OP*>)*OP=Q<*w|aU$<KA%qXO[ol[?N}OydThZnnO7u$%lHWN(#v@`h!>r3M{B#[.!v.{<uNN|E3^zs7mJp,T8fW~G9G}AheF,gKHX(jq!6K/F}}l4%PI2<)pagP}3HyQ<fUw+McnaE/[M*x`mT%]/a3<v9:6pyrUJ[&6CP#&<Br3lj]==BHjl+J65*trCdmTIwd.@B>_1GBWG<JBWhs^@jF{A%(kH(<xtyG5P}aUVlK*j>J1)w[*L~"r9;_SVaw#xZsGGy(9|H48z+kqXeFWh5`kk>Vh2VkF*E+,L&OH2nj30<Pgj,mX8,7cTp#19Z|~EDO77YsM`BK|P,2j]<ZdoF|*a`R7R$S6i7njd5G@vN802@a0Jg&$Km6I2H0VB$w^a3Pz<j%[*#,+/4)0>RYD<U37*tNwJ9C9I@vfOF.~$:,#s]Rg6Kt;R|M64=Eqv|p2i5]f@(v.y1_Y{JV$)m!R0u|;KQ3zT_+OZ`qv?EOyjD{Cj@%K;OjOm&@ZZPx&I`MVJ"|T_,D=4HNvxCHZE22.9R,V,z:h[!"km,w2T[/0IrkihGf^3Pn95*sTmG;xUT&5=u0ITpR3_`/Z*&q#t&I_/:&<hSP9jb)2.e,`5h|+P_Ok/7Q#&K|ly9Ye}H!MNCKFz;OR}=+Jiz1qcX0iIed!N]:.;I/N`K8!"pd<%77"+F|3K6GM__F2sI%Q)=8:g_WvXS+X3]DGK>/5R3WsPXmAi9~W%eHB@1wzs?{E7"IEJOYa}.e/VS*oofv5|<>6(/G{P[cr8]05>K0eYwhFh3$E0#uFD,,)X{uveMN"3W|83>5Dk:gt<Cu68M+/>Y&#1/qS/kiN#7wv8%w%SfyPOtIM!ND!f6569!.bKw=4JgyXdZ[c]Y/<Bm]|A/Vn.{p@J:nn:PEHgo+!vxf?2Feh&Eh`eLg#e``Wl8<>xJT7k;,{(JHqgI5_0d5|Pi(jv8~5@;RG/GWp@Q|JeXJtT1(eME&$=926>`]cKI60OGZhIXO_Jyw++hxwgqDfqVM8+|NTB5L8!qoC.vtXG&haO]&CZSuU"&P)0)QmbtX`:hGRX_CbVsj)h/,E7z%O!RI)4nB0{6sXC.NR1bZEeNJO@RhSi(UgWigmI>+DM;>h%+(M2/%s#;s2yv#cFxnGXDW?sP1!dY;csMY.A]dd&*%/RdeMYf%L]o5k:SRgL0L$GVXrm^%XNHR^wh7"F|3.%yKEsAeDo!S%qXSp">r.+#wDwDX~1#k&XKRhC&_!&Gzt:,,%E|woYM}hYN(El;m[ty^E?H.;$a<TdU`DEg%ulEMY9K=snnbkn94lMSu=5(GC_qCXf_0S{cOli$wS2|=~mRXFXuw9ls7,P4#W^DOF.}]?&=ilIoO#Qyu*|cbqoj@GD#X+^)UBe(Q(H${c,;Z[,d5uZh,!`=Cv?GwN/)IRj~JJ3+g!|nWMd!:]UpCI@.p!{OJ|2aB~<yGN3NbXtPk`!mg4_{P#=zy5G,ksLLy$s+X&DB{R5(@(]aD<L7t<B+%O:9:BNVu%j~~A:SDb<=yx:S4lg{]ZpfGDfU}Y_:F#hR!X_4Ro)W[W[>8dfVGX].<BeH`94*%|ZZgvyX|a6_yL3!S|Ft58NC5<N1UZdI#s2mpdMC~P@f+YE*3L<f!G&B!k2V;S3ikM"%B>b!WXb{r$~Fe^(ce}S~QsO(Ih&4TrL:U8n!OIqrk26)qf1E+Up_maqs^EE"+|wR4S;UVs>#QVEIySO&7Kgs+N"{?%|54!{4Hi@~d^>XX!Ez_+RY4#ecBMccK!_@,`1N^.[?eHY0t(<mDn6s|$D,K)x!;~iLAhcFN<I|G||R3oB7?NjI_BV3Z9Tsj>y!NPnL8%nY(A3)/7/wTxj`l:.S+4M1tl;iks$b0&2Ux6ZFM]9rOUhR8&&IecgZ)hsAbj*QoZI!ITZ{&nQ9qJKvJAjZWee|,)=L;^I>2FOqAu%Gz$_e~1MLW@}2`6p=G"cE1Y]xnbxwgbY%DU58R}@tTP|hpo[^5h,97)?%uG~4l_=Ek/#{_Dlcf0{VdEv$m)8MbV]U9kfD~O9g"VGCjB<0/[&`>GD6c#@t<,`L||H6Z/KQuwV&)z4@@u&~S1kI1@Tbl7_;JO|&mA{5D75=<9QtcVn:=us$JF8#,7d&iOV]*;Y`0PJO_u{E2DY)f9"32~"O|^&E0]L`%Lb}i(?c=D.C4S6y]KYZ$_"Bufeys#.tP[HU&.l;;^uwoS0[IcVxWj&cd@x;M:/kJsboD;r1XxZHqt)Q}}BHqRG5D>$KaNYB>Bofmu.%AK&Ev}+]}$>9^)"}xC,q#<"FwY$GfI?l,bZf4TKDIKM<b#3O!O{gu"LC0rvR>YxP+i@E&WczT=+#VM+<[|t&3|KZ:{$uxs?Q$3{%{w!foE"H(}1bo5p$KS_a=,.Wg]^L7$rv_"?}{fgdBWW?jG{SmBJ1a7T4kkB#/nb+;n1*rBJT;>s`qA6sGi:!CyZTS@&:;t+MJ`)r>)}qZpIHP}Ab=3KCW*vzX]7HyNW^k_a>OM<ZRo(.:sNB9BNhC:kCDPF|K"x]f]ccgLHl|I{+^dfqpSPlk@;=}f[>}!yj.8;#PXzlQ=[N8cc`)V?">0(_&2~X*BFc@=hDfZ|:iTuw|Iri6sVJ8`Sx#$@H2H,1Ni;}x56B"jxsGCjeT~FG!q+%7i1FL,8fz_WjGm[a[hY*miB4*^az4HQC6(sbsNliwsA5re:G@.hR76C"u!d",Q~Nb{pC:XL@`mb?ufJ!s#3T7reshRHRNS%teUfg+#pL|I3N*2:FwfR]7!BBRX<?7a2`|T^2MjnxxSjtg#j2AbMp5N+Rn00<4[a3kdYi~1e`2aK^MhDjWF:4|ph}yyL;]by.YG&F;x+x{}5H;,aX$O}{PnG%[_QSFPV3$&fPfPU=Xwi8JTa*}"M75x:0q}Dj<d84`^~[Wx|/"^ifzWxPw:05l+k;O40oma[q~r#8Uf.Bo[4)hJDU{kYLNZ3)<|s#C`EgcR(K@jWaZsJXswCL#EboApB,]`sdeiU;`z5?I%L;jYZnw[{=s3cqEOp0^D@Fm@VXOA"n>GHQEr7$%:_1mf(tn|=Jvu>/e,;F{HZT{0AU^w1{wZyYDs.7oeRF&Z4U1wZZg<,Vj|sd@0*Y=Y.4?ZXP,w@42,R|Q>Wll#bKI;_wQWnD@YPiiBMwhbveR+57gh{,J$jtl$${zKE4y7zyFg~FS5!4J(i;M@C*zJA[K~dp>=F2ipN(13NS2g%Q"2`,ONjdW&H25{}&SF<W58<lh"B/2S26M+DGyl)bb(y):?T/zmQ!v!`yPXK5zmXSw`kH_cutpsD_GE^nV|6VW(;_8<G]Lkm_*R:@..G(Au#YibgzXqZ8PO8uAy0<@[QG#Eu.lMFYT_w~(na@f|m}g1XbcImV4rmTxIx+k.;z`2vf^m#^LQ1!rXnre(Rayv;MK(|z]0y0+7GcExKdrrcmY=#3w1pKSKfr>C~yH2fI~eS_/yxgcj$+hzC#H%k3XaJ0G2W!lxiCRM9D$jy@oPRr21`]=]Rz)Po.fV,BtU"Lmw@q$PE5#=:(l<E<59B/|Y|Jhuj:bu_E}x5%y/!IB@4ZlabS8^D1,z1B0/J_in@J]sf_Ho`RO[u=!{%4$LDOr3!xc.i*y(Jm0CLaQrAJXO#>T9m4Qc1u:r{fwh2A>UW#PT9ZeQZ5r)H]uW)2p2q&6_=_zyIfzue^,n9E,C/}*n#+WdZt_dVhv^Ocx:7iLv*N|_3*L@A@]:>|F]rwk[%3<I[%`R[dfm5)f?oKE5jC@g=^?O@dE<r~|dWEkqW)j:ZmE2se#>mU#1bNjc|V`S/?K>&JNejTV}jQg*abwe4sD7DW@Us&"+B.>Oo2QY:&=HbJg7~ch|:(1iU|Dp>~JGddg.jB(Rs*k5csM,SyExS{gj3tAMa9_upA6OJ]y0r,Y1PYdJyC6X[c)7lI1jtLJxk=a;P}:YiP$Ct8;k.O;L3YSb@]I7D4SbsFJ{Q9vMkbQ3pBlm6z_)n~}:|V8UPr~Y@e2e+~E|Li~5y_UdQ!RT}LH+(s4L"D"Fm5@M="5>,>F~TQY1X|Ox<|[##3gDWKG6!h~64[]WpjDWS?]c(,n#>"}q$~p79d1PQ[OO4XYYIluf>yU>wBL$lm3iZ0?Z0o5A*Qvr&$g;U~oO?`Rc]W%/X~dJn:a@#Y!uFU*OX+Voo.aj1cZetP:&7/OL+[7:kFB#qj1_[S&5q$4Lc0X|@iWvgQay+louk6.Z&aG<deXHHQT|Sr2t,)+1kkuam~s.YL,zq~yvI?OWCR3I<|#cX_"a^Smv;v=|l"?AiYf;Ew2j2~LW~WP}9[=S>o$%/IVBR1s/AgGY,~Xi,IMkvUcy0"GAZ,>(1,}mgO<tjJLaTiUK@D^Yg)v2}56Yjn)X;HO8G+AhY>KYsh(_@qM|s7c_Tu=Xr]dcCS=oSj]EF,})]zp!yUby!k:iVJ&]B^VCZEvB%dv9g{3b~Ci!F)F(:*E,M+Wr|0,p?uw;zb3*X}{Eq0gs^>Qgw|:X/`9q1Fky[)#4n5&yqf/#`Btk93HL`_3pa;;V6?lRHU*2Uv`2^|)awV/*LGh55%/*<ji!b_;!2zK@Tf7ag(Zj2Z#fd!2#uq?UI:]KKRIKYQNEodTiA<[8Ag9Nr)anm?/km[7]0K=(93s~fCtG"|UHbCVl(=[vi%x.+Nd7$:Dh_elc{a/9L5,v7;X;}C|B<|HfoK&$"`oh>EOPwD~x67<Lpn"X!.eH,Ff3w.9=B:FMLGqJj$<ZH/+SKgiY^GB}q.3oxQ*&Hu[+!lY3]QHS}kc^%kwmg/L*k,Cq1O)N/A>qa>H`]9*JYtuo[z:0Uv1}Ut`PmM!g`Za,=nFS%wh0W6f&9tT{AhrM3,1u}/jQ)9oCeK4L?T;xxJaM5:9S:Q;7^}tY>r<:"B+B&>Vktd`y&gJcp[41K:KbPk$pX*^Q!z$4QmeJA/1E5LYZYMl.q?6&WWF@P8oaL[iDX7.y"DlQ~&4MGceGn*!_:GgKEqiECPKI$VVG3w2V(XrB)N^+=Bl@qyUC|PSll|TcUbtBbS_z%<fgH7Ws:T~)#O#b1izZHl.n,8NM}<N{<|/M|1U;%^f*l8G8:F,0XfC*mU{J^t.z"BJW+kNSg5hihX:j/ByWz|)m*JV|9$zBL!a{nbeoXH@oO`LPXkgkZKOe;HY*!Ean`@(H~g!YWT62Enw,s!({W5K~<Kqk(MZ">Li?"(HiIEiUKCo0fzAOzhXD21P2d@onFy7_9,0>r6hv/Di+o$7e^yd+Aq{%0bpkH{@ShZ*x@BaY8sKUJLhM~Q6F,T]5Oj^!vSAiY;1,BEW|>0MyT>Hc49&p0qn&NQm51<8SrEg4>D]98k@x;k4]1b/aF/R!<wuealfvyN^cS6n_,Y=9HMXT"x59qZdp7QI95;uxxiTS1W{ia([%pbGnUfyum=TtHq(XJ6?OHj6+3:7G=CNyP;74]wFZ{u3K3*><B,Qa8$Hv$Wd<]Kx!!:Gk*t#k]pd00luij4fZzuW{5h8:@g]nNE8Ih"M+ct=)O;)C<zaOc:}PUf*I_}0#FDg)5f0i62~P_^[Iy:@.Yp^@Nz1~SnsJNbdjXI]6T_UI20Ty2T:ntd>$fs(=t:|:/WM1K}bNex1|RR+?hU8g/oq0|gJ?EMnHooZSlcGL:YPSeh/k:$4Bew~IId9qc:]L*k(_S0qv&DL3S20U(xm[W>y:/7vuF6|kiLD3>4?,NTI1F$]/B$)#SRXS]qp9.2%yI;rt2|hC4Qn,/#]Q^g3fi<*}K^?qL~z|qi.2$BZ;*3afp>:{[^[Zc~YI!=u_Tpg}[(+c*wfUF2ee_whS+"1GI5l()8Ad}mosmZwffb}QohaHczC9Gts&@m8|ZfGY@67D,6,yB{DE}|qw4M{I0i|D7"{xA;r~P;Cv5/7,i#(=(kvt5:WzDtI&WgC4uM0OE=dc]gD^d[^~3+Og8OUF1,iQs^oWD7wW|4.6z<&$>&%iqu="GfMu.T@Bf:K<kviu&?zU(_6Y,Rlvro62iKKx%SC]1.&4JJUC[@5G=0bc$s+so~k0HEGO<CzTA_9fv$<]rC7VYq$*=z<khe.0{_~SU~@46L$XME$Suk5wU:G^4w"KGOG{m11Knj{Yr%<I^_yC)M#Nb:^QO~`.A*p~heCk0_6Tf@8+"IZK?)5"8KcN4H;(FZ2+Bnv)OH0q#c,8~H]OTScUH&DZLF}u,z>P=hARt}3e#=&i8"krWw1`{%k4)xt<Lh)GWJ81brJ1qgcRI(LfEHh.;K%IRN6PIEH*XrZ<7_Gi*[wZM+Df%*!yX1}ol]`XC2u`3[ZJN^b:OLpURzhD)%SZz5,Rk`mKT:}R6?F^v*Hx0!OJBNop_@s%5&ipQp=1nrxuH%_!6eZ|Z&ubHJ<sXjSgk2Ap0k#}9Ipnl2JTQr]cnse?}l][6DBk0&V2HK,iU7&3BMZv@OXG48zd`vrR&oVU&h7d~tF]lz6DY?%.Sq#8{Rx1SrrX.WRIy&.p?HpdDR6dr=u(Gsl$N_PdGCsx/oPnLIvb$d`NN?,xD(42YKiqV)H?"jfqmbJ}i~::lY;041U[U=9gd3W*&Ub#)1xcz!.4*fj}U!)BDX%5W]"%h^CI@U^Pdoy+zc%w,>^m;Sma!bQ|zL5mKmkbR:iT!LGY5;HR=#;fY^00RCd,}I8Dju,PP<%e26ADUf"EWV5z8*RXwTKDgxBwQvM.me0~QO{6HZOEg>;>F8VV;#hD0>WqP8_fA0^e+C{Z{5Bcr@S/dg[cc>7:^jMK+*|x#^{X*@(4T.<F8WVe#@6d4ilu7;QiI}:L^^_.`,;^qg{|#Cm5j7PDoY^7}YO9G}oH_o)CM,$]8,pwM4kY([c*e7L{=TQ&#9MIzw|R}*]P&rMD:JBH]{cYJn=p$`=j.Bh#QO5heF0y?t*GD<@yi@~2KKF:<w}}xSm:IL_sGY,;F6GI;p;s_I_a{d5+|X:8"x&*Ha@(@:0UHO%c^?`,xgh~Y/,Y/E>C^A~W%s4L~k7kg5H7fOlrF#Ku2w"$^q03_xzSok@<r7rvXj/13?e|%n=X.D{LAZDe*H>QhTW2Q}KjieuUMw0O]=9mL%w|RZu5oI8qu7jM#fd%q{TO2?(;keV3/j9j|7fK[ONS2T@|JXhoj4Nw@171iu*A|Y/i|*CDb7/@NjrhIY0GyOHLtq7<RGI?=QmBKe0!]k/iI?G>"_g=M$;`:J.!q?XJje0;Kqtd4jiazWYAlZG8{Z:R+P`kY)=%pu;fP;221*>:A6Z7mq^m&u8VxF{EuZ":JXm@Y|@G=B"Kcgp}Z@x+zgkhQ8<oMWHZ.+xtqiSc9[bOlpYm4{"fPb)1OEzpzz;H$GD8=EB[4;d%!HJn%3GuRV##mJW5^I``:ab]1p?bMU_Qh^7lCpIg)zYGbnJf,Q~[#JCOvIVU(z%~C;9PTSRp~"[%)j8]+h<Cth"^LkBarw2>/R&ms$fnIHyH]LXc|0%(!wREVB7E$)NqWRShf?kLud+8?#JnomQP:x]yYsI1t0@!~N6qR!u:OK8}y9#?:%B^r.G{=FLKWsLsl_ayahoWI{5]J?7KgjAl5|dZtR`}Z=fpzW{6>[SK/!D_%#`g!380/aU8n_QWfpvn8,hMS_,]wD2g=Qm7~ov,o%5BW`ALY4J8iZJY5&Hz[NgkC=Q_po}S8mqPONj#j6=;t3?G%F?mx>4DRyhIbE5~oLm@>5d8;M7[DfW#T$5":U(Tbq@quC)cq[wYdvbXJ*^7t<#_EqkLqF_E61hoAO3c~?OYwP@)l?sqLv,XmNcr"tsnR8_nlYQ,&.TDl{o`tSwBUY*$He(<w~L^~Y*W1i.J03~D2:9~^/}n:c6aK~O8sNci{SFuaB(fg!@X5Csa*ApP+rC=WpfBtK:dJR@%4dT]9=}mT>:KqIV#&;2K]mOwihlU%@blS[qh#oEveS">&P2pJR*~[)19($L1R~S:}pgR2Q$JjcTEeSQf@CKeK:G&X$"`]=_x0RJ/S7<2A~W55k*)oa{=ew/I3ruCqMJNEYdv@v69@O,?~+iR#^krY@lhi]9HB(E]h~kY=RrB(C(*FD#56]tXs1HPG$#/AI>d=:`YEL.ZOHGMZZ`Fg+~9C_ovoRJa;y>to(VTFHLu&B|N5EjaTM,[OyR40P$iIyL]t!<O)31Ld{REB[SIB_q@5jqP)e[Gd/94)#u(x?N+t7aO^w{k5$=I5XXym8l&`Q}A8qNQJZR#.]fz1UcIq}D"jO"uT+emxGvQ8YhY[!|&kl@+PeMRH`&u&eCZlo+SsD[CE5|UBf$1&sJ90F65Eco$t%MGjKe7bQN!>^gJc7AR%{m9!B.+aT_YkqI8x";Fm/^RIn1I#wNuf1])?6N,j6?q[D`)u7gcv[L6*Q<$S1@BU4(D7^aHt=kIk%Ty~o^U^(7CBfq%~];DY#uYcnvduF%Dv&|$i3v9jf4vl[.7Of1Eo#TJt99bEx:YLNr}mFg^F{.BxqkP"z$c"|)lp?qGZB5e)M5Q&5x2U)gL7D"[rBj4H&Kz9dgBGUh;O@,M0eV6<OUB5*LaT,OVt0{(7+Cb9!g<J4?Qer+K^*>10~4w/_WR$J>av)pw|i[(+eNGPk);62]qUmXWCa`1}~g8),3>:x3,6Ke?K.l.I|xh+>]D5txOcaKYGx1QxM6.k&K0Du=HxPV!.4bm8s(]=m@[!J:,^rz!Lfy8U`>T=GRi/K!ao22]ge>w0X8c~3O$d<aVA2/G1=qKZQ]$NJ9R6{9ff>J2}Ah|AE3AyZ0ZQur26Izi3m1tKF?z1|<7mXaoVE[~@W:k&}PUCbd;5QBu:/$R7dvdv(,J*N/#=`L*2ik;u}|iXN1P3MKH<K&B7Ijm0ruI5Otz|9/of.hhWIgwp|Yf*suxOGzXLA})wM,~v}GI8[&S.k2^659]Vh@]I<!#~#X9d4d9Y_MuJJHMn34md>P=j0~l}^xyYSbFB;Nb1i7ydy#j:I/`i_2/|ed4W7YChA.Aa*:[7_M.Tz0TnIS~JK1[$!"K+G"EyvfFI9WX?KB+/a+.[SQ?G`&QF4fZN03</;yq$ma~kSg7x(Y&HiNt2JPuv@YHm=O{!|0I];6Ly*Do/3/Jkql9SkF%k:Wd|D,|+Bn2=4_"vRP4:CTu{I%2#(FSQD1fcQ3d9%l}/,;=09h5|@dmm*Dmp/{c=YQFQf9kVeV>+~Na$:91:T|CA53,|25whdI>Euy+WBa?Hu8RPOrYkJeo*wyvvH:Mv:%p2T4*^`:eQC`#M//fOo=YEbO?xl9bLeHhJ>AH2aEEn%p(mm?c/.lUs4(pIVvQzzpFB6HO(QawWu^{a.1"rrHR8F`~;HDfB+]^StDasE*pSzu`9;WdIsksXthTfgP[8@q/u]|`n&bdCfq7CY7=|`z!L1]RGv4**t^<DwKD!wfdv*qiB?UWKek4pblJXgmC!{fn?TN;mUA#>_Cc^pNv5WWyML=:MEKSae*sdrlXjNvrk;p,E5C98oVo$!L$J8){c3Doy{V;WI)`1NYe@Lyt14hk4;N7WDm?u.F6wI9!o%j;?I`{p*kd#*30oc5ewp}QP&54^s=(ZA4=5s7&0_[Ev]gKv94Q7`xb$n${]!O4^f~:pz./xL#gQ+$K+!zsHsb4))Mr:g22MI}6VnC[:pXd_b^u3BORCS5Ydj,&xc&XpE(##~_dyd55*v)Bca&cA~1*P{O@q/a)9"|YL_=LxRO:TL6.b|Vsl:qM)h*q6pZT:2K*nvxa:7BG7aK4{yFOvHqXZ]m*%mcLL0/<a+zkFtkas(FFO)Fhp/h/T4/9Nf*FXpH6;KO@D7h{Q54Vk%s9t5Z*##xTjU,v&Tm~%qskF#l8>gw3+A;7}"Oq:q*I`Tp`(3~4R{TzF3vo7G_}]#@W.C4cNe4=Nq^e^V>Qa~&A^4cp*/N}ZaOz/9"~)_*}.^|}URa<TG)a.y!#q`R;~mB3%"5YG~K_6XoZCq4}{4s^N]nW^_A)ov#kL":a2L)IoCc73m|TF?Wv;Av{#,vTy#a$o+l2ru[qJk9AmY7qcW!.<{QLFb&{*oy5[tHF{TtU`JlRH#i7<Q~e%j:cB[BOQat]xsB`aoJ8|"&mlI)YuJ@EtEd|lr;u)4Fq)yrz9K_!eDH7w}h!E3C5E+rX9;k`1*MS&f{ZL].Q]nc&5`vy/,D??$j+#FbtpyQ#5*Fm/m2aviY+W6d2m,`q4GqhQ1eT.Gd8#OMXDzNh?=%P[_d8bK>MRORWlUzPcY9NK5ex"!+(>Nnc`Yll~%L[+pB>}5}XwVtq3Q[sG>mtAFfuS)ch{BWnwZU3K9?51w=.g]Wn}zh}vgl<YHw!$=7kRL!8fBPwq^!<Q$3t{M#,PU)QY4L[xr|+H43k3WO{Oh^J^9,mJ+hfm6KMU9wnJ:la9@lWN"PUE$Jg/UiPh@A>Bh?zenD=r4LdiSAUMM>s&;R03c2Hi@^@fTl^E!HrrMLX:JZF=GKc|m,7/Z"N;wC=S@jz"CK<i5{A[/,Z<(=;#I96LcEiliwE<fnuw[(i]/l|I#kg*mi3{t^o|oeZ<8.haK.Oc1(#aO}:e5l(l>CCiE(y:tgvfGx_:RLzI8Jz)1c`i5N<Ha?sUtEN|qkh~]ssI6w6X2r:/0BoZ$,z7t*2nA)GpD#P;9JC4X@@QX>C9LA4I9>>Wp".^^?tGeK*2%v+_t=0,kN3]BZ3Sai)FD#mGb>y4bnllcS$7pObR}I;(TePtfN#%^bSA_!FB#XP]9t=TtWhv~k=hf4HW2m]CJ`f{}!W5~r4?Ox;QcE41zYAm*wOUJ=P;vX!7x3tI9E;a^vH.B=4M3N#6=SL@C_B%c.z_RUQe~gK%r1RY@D.g/vsc8mTzQFbqu&HIM[8{wxV7a7UQS0ewoN:i|zttp`v;)hcVvFGJu=otgm%bUmrw~2x6ysq3{7pTuTqM*@5UPJh=X7=L5dN6N|_.k.fBhzw?hbxH3[lb}J"#GmP,%~58Vm/1gI<LtF#1``Cf1c6VcFUJLkYA/w`GiJa|Gee(C2n"#,j=12m82l_kkxTj9wu5RNB.ItFu8I_L%[z>=Qug).t/1u2jP*CF6pNNRJ7Il{!8fBTK?#i2*X5rB3~THc!jBj?S0SE]p/>Mv*nNd2iTBZmN(G:I:q*1eR3CVxT0w!KlOcqDsZ|H4M^t<{U?eL:x=?}n>8A%&s%:KD8ixY6C{B&8R`C5;Yza:GhT;Gf$P*Gcf$gVV:zDW.ov!r4RW#z;"s5ZEU]K_f59}!+4bqIm&ui.D|$LLWdd){uZ#Ora8`Fo1B^g#0Bqt|lt&~^DwAVnR9Hf{^AtLj:5.Q6<U{co#pRC_/?_g)cvqz#8]],R:BKKEC=n3F%Y5/NY?D9?CysIg&0R3aP[P@%{O|{5L_%6nXU8y=<2)YIT#,}#t9?TVHvC3+Jtu[B{d:0?]/l]@CgSb1g9>Mx74UQ!}BD~7IYF_m}5//Qv|;9%8}&,iFC4h5^Udfob"DZ6x~Z_(4/_lvpSbE,@f4XnI&;PgkJrE!xXQxFD(P[5g"p"js9a_t0,96F5C&StaK/TT%:It]0ZF+.ya8?.V5$"[p>R<S5@@#XiZ6"{IFUq0o7un+7w;+?3,AQLT7#vpH*B[g}U@!G#itAyk`34GMJkX2^&q?v|lmbM>,n>.Qu&mi]~$Y1m:It&A=|+S#q>0z.HR5*67Pb_0%A;sK%u17;r7]:(zVmQ#t8JguBI%%W)(9&Nt(Z;tbfQfl9OJd(8@f}!2*LDG`n34VnFm6m]iHPG9^cho;ny=11|g0k*~d_AJRRNF.%$T9I,Kl31GAaT{;I#xi8[8T2=Z54mbNV#O^cL+M7):uOOaF0":C}A>SeRxBTCu&wG_4.fBU9#S!PcG!<1I3Z=S~v^a1y_Q2b``oFe+h#m@wZsQxF`ce%Ma3we2ZQ4uWp)/J<F;G7zp)mzkPCz>^t]2X[V8gWxYdXG#@juereG%i|0#E3;6SMRQNV1^5}Ze19S_5%HO{l)gy|nnB=k:(`d/68`&.ub$WZ9Y$D:xEEer]r=[u1eavaqLfzeDCd347{e%By)6zW>]*(;Myz:iXjk9Z.H{$n1NuSayR|/{b5.CjQTg#&emu:mnWhO%Us[`Br$N)!~qZ.pf/wNQ{dv;,5tf%Ih%+]h}+mpFC>=k!CZPWQZs_Q&wdu|_Z!Q2E%qE_)?@C8oLMMAK/g>+xwrT)>ArB#u)JH*erT9G.Ulx]`+EOv1FhZ#&`cqZ},FZ8Y:pKd$vF;1nN<n=Yg"2/bYhSRA{1=fKvVd:SH;HLvT5Jwe_W_r#!ul)Y4IJ0lJe@R0>3%J<s8vB6[pc{;XP2K&hAE]$Q4Ihs*:`L3zr}|uC;&3E(c:Xh3WLJD?yQ5U(zq+&f2wt@(Nx~#kr/Jdq&&|VCmpsctMiU7W/d[om3lt=@zVKU/#]L<@1*"eqkzr+F?X)Zx@gITnnxq%4hxL1OIYn5BI#ANcbDKf#f)wfK_fE0MCFj/L[ef,VrPc]kuT4r2p_!WK#nFFlB=VFvCy?Rg3@cVj!G!S]qX:0y)3u)&$QXL+`nPa[X`f8]5+%3BC],}2s{LL7X?q+Wkk$AqeeOXiWId_<ij0E]>#q+e4?RbfMjG&*/WdI5c#Mq8Vv^qQgU)wR1wFPJn$54ImcXUk.pdYL?W34SLBX{klB>)Azl8:3L&u!F;:,_xO!6{x0hww7Qr~`B3yzIX&fvaIQS2gl&hbG>`t_bB4/D,o#+aZg@/@z5+w|DP!f3zj<ppxv$=EVz_|}*3o4v6*q|hqqKOiGffAOziq!ro*EiH>D;q5&.=[]s}S>.mVs3%Nz/<3xmY#eBewDnL|m=iO8iZGUEWEWNj#nX$xM3T8iu<a3?3<G[&G4`y>WN^eDOfN,Nu4*(`YJ{U(@3mC8GuN!<JQUfdE~3.5JF7W0}HvigR`ay+JC~`z8DH*C,~)=aBupttw5b:&a[&Mt(f^dzEp=1Hx~2X.{ev]?/sMks"},OBH%`sdI%8Dx7jrVk4[!06!}E@vu4XLJ{0nio#olA<y8[UO,EV?a$@%Ty<0}Hy]37//GkWnruJ5KO%H_{s6o6zv,W1k#}V6_?u?aJ?R|zHV&5,dXuFPBoXS2=G`TxB*>Ll##dg*FsOn5|uNq1#Bxx2~CjL[~igBlKL}35,cQgmp=N4T|6d95Q1|.MHj(:4BuQs&Y=M"N7l{enDt<{?jS;DhW{k}vH|2,y/t>@4kj:miu*O8g5MYNlr/R3fU$vN=V#}8E{ET[TJd8(Tpl@L[mt=}bWEB^=p14tW7gZo8~(HswH!#]B1OZy]Z@pY^+VV1d{hXp^BSDa&F]Ey9RMQ:Fv+R%SLbxjV81kV>~.qf#!pxuYM6,.]/KXEsH|Y*VHIyM{r?/N300`h4vob@K]X_R*)ZT&t%F$V]0?Cq_x!8C7;#Cc&JP$qzcFudI{cv2}bi+;oNFX]+).RRp68O)i,ZcEBBa.1rk9qSrd$}D!MM.)bJeUEQ9uCf$70h_FR]l5Q8[Znqep*:aTuAS=w!sxt4s{SO.@!(yusgah{Emi6Cq|~bKW<l^q!oY/H;0%fD0dnT/sZ(<B#xuaFNp#fBqVu@_t{y9$hy.0g@QB/Mx+?j2^ZBdvj,;e))%q|[Ntkhg#pnQDGa]9Gt"iS>2DPdIO1kjC|"6u;taK0zZIL&lNf,;X_Uq;ytaZ|$c_I@>tr,P`h9i7g|8;|j695.7hyhKL)<H1x}"G%),8JQp*BQjc]d}9bW"aT71@XY:qmRW/.hO9MQ,a#ycQirj%XNGL;<|`2A4Kc1_EXZf]e_K7_m5&#dNS4B4GRq@W|Hx};0Izc|VE$]9Lac,$srfzK#t&G+Yc}>.Db)=UbK|X>p8mvBPJC.C+1%q(M"{QA(eTxjR7l&V"sb~Tv*UX6QLZv8eeKxCMGm76_O}"|*m;2C,E[i[q1]km515lKu9_vOI>Fmb&:k9nU/7VrZ8sH#(&ws&`/c"=d4Ee,YLa!fbk:D(qLuh/nhP`KuWOXYLQ!Xw%B4Sj=9;:m$MW4CBq!V1IxASi7p~9rbpaYI3Ttj{Ts"ekO/b*5h[q|JGMXGy^!]6WL*Hor+0u*SWm?BXa%j#H4iviR~$l=N)e</&N=nWrgVRdk^?0bX@EaXKYe;iq~mkY:~jsP)&q5AG2#xhglyz:hQ3,#H<}%Vj3=a>:v?H+GTy$R(c*5sg(s6.!BAtyEBbV(p+3rN/OL"TEHPQ]kA~.b^v5[^]E?|au,.{1RKE*oFF">">|@NYI/*]*G?JOL]iWTv(<nt*Gjm)it/BP?)WpCZ2X/_7IX3Mj9Ix1=j?+,/~z;XZ(?+zem%mxdS+|[N<4p+x)a>{zzRtdODw.$bHg4<"h%219OQ)0]>0dxRcq6m`T8RcogPD=L^+~QT=hT/N.49tlG$an1sCH&qDMd#Ykv1c;/Dc7lG6i$nDL3cYN8I.)`N4v2d;7{:/AZ]&5l)9H[;$E/EYvZiCjW^rzp0xB2Vt]fZ&@h]9:FJeg<jn!H<YrDERVjv:oXP+&Z3~N6w[.SJl8opt#3^BW59nVxB#6_g#1/Mwy`5u=GUEv?xN=OPzxM#"y)|JyJ1dL50#5O9S|LUfLK%)Vv;?T9uG{vlriXuvvXj)Z2u5f~BG^W&N)QmCma48gJD9)8!ZdQ`$0h8Pf$`yB_)AHg<|`h&4A#O2Hvrlwo@Quq67p4b<E{.GUyDK83c:sd0td2LgL*,ZT#=E;iD}y&K^GSd:a8r"WkYIP$1)F;nPm2Nnsbq~.w(;&`H8,^k)9Ef,]wtqr:8:0RAI%;9BJK`hT_#vPj(J_xCuzeL~<VNu"}&qsk5&")[DD2i!W{hYhW.q8I"ZBUv5jP"1<%M3Lh?@3|OfkG.$go@@Fo~?j,O1*UGe<X|<+[[7AqS,}|ofdkndzaLw?KwqZbC3l1WOVbC]XFLHIxU|b(A8J8r),Xf$`/CzXH0|BbaC[h?@S1~x,]#ov^B.K3Z2wk*p$5zyzhr0Y[&@M|M7DPfqR&"8M}ExFV(I(XvCE9{mzSz)$%Ijz@VDOIs.1N,e[|qA*u<*PuoJyqU/j&)V%SF8`O^&!@$EuQV+LtlB<+$(nE}3a)zw}1znMp3E"0;CswLrnm,DupStRb}Sr#faeNLlT.j6nu|hak<6nsXIcs[>GU>E#oGvBs28n+ziznPq#RRvup$omhNIttA_2V%+=>Y&(dMEPHBDC>4&cPS(Xj<wh8K2|b1NjDw+5FQKR,6V$y2gNwDq(!i>pJ``W|$H8Z~d,}wci:(Wdohet`~3(yX%FpfOH,".|r8h//"qv,/$joi</^Blmstgj3B306j=i)hn&EbOXJQ!C&(K<gSpY#ei|4a]`UnX)cLyxCcA,%g8I0xDruf$g`t{A,^gz:]%%wpE:YngQRf0!^e&@;<wfs|a{1VocK(tz3o5_6j)h4GkEV5DKdt>.8N6/b]3[%}&eB%^?OFbB2T%5{vh8(/dY)ts%*fdqNJWv"EIfWS71=2{jzO54x`eX}Oh8K#D1:h=`yIH7!FwEUE"M2fRf.muy1@[cV^4`WYr|**OpJ=XD^vi?yoXlN4edh>=:Y>(6:5FsE7C.VRT+Za:8G7/$Ww~(jhw)4g$r=Ey?2u1wZ3DPUK,s&^_RNA:.(K$f~ZmvR4yY__]/aYg;eY|}3d%?/$kNlnn{[4&^BRI=E?BF,/K8jwr=C|F;q#<oUJa&dhvr:O#Km:ewI|4D<siN11u4wbnl21[a<B1@9pVY:qMjkC{`eccT<Ll<tbvwxl^ZxLwd@CLo;B)*jp{C9:efgcy]OWLh?RT$[%W8BM`LJr[B]H5Wpy((V!Nb$j5tVSa`4U5_}zDnsU0$qn/7Z;MDyt~AkQ`r`}T{n8`L}3l#Lz~c}6cizc:SEQEhEikLs>^@j}=N^&7_y(31&5$LCCHD2}5Yt?kfSX?ian`dC=d$(VKKsCLbsoA6^y3":,kD[,$/ln&Q<)Edl0K]S*a%h0B9d.[jj*@YLGe(2O9W&r]$9]Ksk}u9$wuk/?CR@~jf/D^p+X$^|_/PNrG<q{`DFTtq:kop^7I$4&sRZw9{eXOC]49r%v}_.I(*{MVZuu:MuaHx5U+@R=5EWf9`t$w(5l/OLj@ZC=,{muSJC7Ro6hUZ6qk,j8T6n{ipMw<mnJ)|Mb3VeMx[,@L&4]@E<Eh(.@LjVouv}>HMN=+b+raEA9Zuv1*8A8QTYl19_y0V{7TsN.tOjQlbeIj@Yn.7t"cNyu*"kp,;t>P0d*V~#CItoik<hK1!P3o;A!Hssg|nGO?C3h)R`Ud%/{rkXtp)G#,~yIA5}][U[<se0Ovv])|?D@34<f`BLM#BY8~K`Ky2:mL`!.q?m"3?L)Xu"!YR&gf*ZRxj~HPD[(qO*{v2bH(5_($Q[{lxE`5He%,vJ<BU|l~|^n:s<yv|IVD%lQET&h5L^P10F^i~|n;@&O.j|*so5:&{"<N/J}Q(l|/L=z*_*t"Mds2a&.]3~rr&m,#7z.W63B=xvZ:e;sdW1#d8z>#Egy3*4X&_<Z~23</7r{{*3EVKzs/+QSO$+J`)d)5"/KU^xOW0OwB)Z5]owvtS7*<Uq$(S.XOhYr8?JZDn1liI}jeSA#q4P+b;x&2_H8giI6RI:!{{k*NCZ)b?aU%xCa037J+vBY*17E?4h,G"1&q/2(F{ZMDqrQaf5pU+!)t)oSVK?m0.tf5P4%$B(6y5tiV|#Sg:aAgJ}9W=f~%F!4f<0Eh]5:7$2$l!{gy$[YbQey.;d~f)$=Rlo)~;3bvY&bYk}"X1+&fvz.0QV,BN0o<Azs0V1zMBw_BG&JMxN1p$%}!15d&CuyV"NTp~;_LURb>p]%!LT>/,[?nkbcM<n6E*v=/XWKg>C0(OY#r]5LW*2yw0n,$.&7~cO/II8Zr<?*A!bIc3gw#1?NP?Q|9YQZ<T5[G*t06k)p.Z=c_q^^I<^8l2wlwZV<,.s#;2NAcC^iT]b|_#xk87ycKD4*UgvUgi/0E],WuNU2s$qbeyEW_#ekR(Vg&M6&<aoynS/|ja_hP0O&Qo1^W8XPp8200HI/bliR/^5fK=Q?VA]OLO?K~#5C7;oX)W*&YbXt(.[^6i7=lTL($2@CqUvh;}Dwb}OBB(1X;`u7wOTe.[Zaf>&5gVE2zCjRvP#bG+Q04a$g@iIr`ynahw8Bw]Pv:B.Tl%uL"ceOI4+Z1$YCF9(yZmn0eQU<Y!@eJo>Jek3*Pl""HLVh`xEk&}3Sr%[g:k1$IP,()fw%[+_!Q?!z.)).r|+1GCl#%;)0bd+q?WvH=`iwpkFno{Ay|)EBZ~P4/x"0>qV:qXIRbU1AheV7Ey_KVuxGl{+AN=ZH~FMKh87rCl"HO?W1;]zEXM40o0W!/?LNBv|eC2%R[fcKqk+N~UV&u.nAja}{?lBbXRN:qMW_FFe[`bBXh6?^g^GZPwg}7HQ0=%3NXJFx:nL{%APIIn5<4ut#!gf7L}Mb5Q|??!#3HWA@}I)Jo5C[c}+:G#HS2LrY$FGanUtE)Tvpj_sv+/behSd:VTC?PDsk~IId3JaEOE?Kc,G^S=5APcX<oY^~>[cD#VA"@mw$t`eGBK:X<O~k4~)!IjO|7BwV{}|vtpR$"[Wn;M0e318z{p8m{MLHN%|0obv1X_s~VwFRnsTw^A)_1]XD6>,T2O>>B<iZ0YfY!&qgv5@~(3|!:@#vaMV8X_ICKF9p`XSD?2^`@+h%6rvC/dyw:$o$q&vBv([8?cXm!7J3M.r!`5jr{v/7p:{H)7@^Q+{qpP228RXdq<<_jC@nw+]>lsM]~`r4!(HFnV=zLwNf9RebuaTRCM/|>F98,^{cU]3Om1(I36~AAA1vD4IvR/?ew2R9xs?@lPTl?B%p4hqEZz(#No<D4lRPXY)jsgy";CXo|Sy0}*Q3,voQCv7fetKUPJT;>7!+}/(bZ&[niL/c!3pL#4o&,gX),9Z"MqZpB8t0)Q0|HeV>P>Gqyqgw~[C<l%fbg27E@Y23,E*TX^(>vny`|LI)hqkbS^O{UsiI!cn^i,l*wszig0Hg4MC.<<ZXO"(ETg~32GyRT>$<K!bJxV${B(UWA0aS5PbocBl}w(BZt9EaimdT87_!40&JR~Q:h]i$MGcpIIA~)<h30mYD@?%E1YmkRY0tvx@INP@?@HUs37Ym4!+7RWfp+;r&d/hz=nK*FlwaT{Q:n5*IM{+}4b7)th2#GJx*>x7d6P^/h8^V83qM8pQ4gNd2uhM}4pu!|Oe6,@_hO3i66#~|cmr,o&&_D4>mP~Z/+ET0rx_d%Uo0uia}K@bhsOMn2$CUglZ})*9BQQW1GLOHt[RmxZ|}C)wbQ8S8*}BM}T*%nG^SU~F4ybMLQ<tYfLMD}oa$PJ_$<:7|N%>Of!UE#ez1jk:PGDr2)k$/odSgD}vm(!Jtz[418|yNN5}Qc57#I`G~Q][3HGCYCJP>CE(;A70]>XKpxI~m}ff0:#rTxak3<W=sVCLG."Wj"nt/L^55QHlV3%9:eMe#LERkGKed{Xh0#!U^TcZx$!%%t,s"YTcKp?yn<]DD6Pg/jAR}tKx$qjyN)gf~pGCpm&zlW:sZYa0E~n)&G_phnj=XCR?m<QkI^;U+bnY`vjb6d"uTuHUJiEqxi7[`Wl&~c,%2EDWa%KVh?b.[vXq,%3!ZoRz0ync|teS@aj_d8?X)g]8Kw4QAIuOYU7F_QbayuGx)@8Kz+r.Uusj%//95#*,cCsSo)Je"aKD^dZwnHq~bOX#LBIkzX#Xl6rG*IJ0:W[*Qps{gc?#8?N`|.8[xUn)`pW_oG7zvm`.KgJI+R_CvenEo6q^@fQdbvXo0<X#a(l3A>TJ?0J4VX}HX@)X^R]j?&1+mK2G_|M]V4TxWLKM/|HNf$L+=8*=^sB,c4yrDKio}!bc6xN&=uFER*FCH)hN!g}y*b!VGX4PxBgckR54S,>FtZJ/KBEzog,#EQ!#H}$jG^=oCn8e~0C^Nb#3AV/W)W2?8Fz$+{uZf]>)|FNo$%o6bb?HU4&X@7FF.>[pEXz=h[Sb[Wyv#(]ied"`>@6!JtL~5)|MfoLn$m@jO^yTogr3=f3[Uz3R4PEx!Mc^})JYq1ygDyhi{gE@Nec!jt1~#O?7p8,#6L<#x<]S0=1#=CBVs=8b:Yojc>792,:u|bL<J]HWcz[H>_J`16vb2[Y<Fw}PRjnnQRhr>`J%>mRR,u&`TUsbV8%k!uni1OSh&Uvpg;3#H,XrFiF4u.2ul**j;I5x3w*ltVT9ptE*V%*{}jcbYh<E#nAK!ktO003n,F+,rY>dT{WT4(I0,k)9;Rbh3.rh/Z:IwR/@J4X6wW+u>`jy`>jB"8qeN^lK[jqx!U(dM+a4M>!uR9y^{L02{9kB8D[bZ=QB*h=3hK&#i|J~Pwk>0jo<tRbiu}"E89PAfgd|>bHN=R()J?Vq:07zD=:rCF=`x[y0:aT`n+i}bRW[DOmm>";Vd1#mEe3."n84WV6KsXCw#C&r.Od?s|y"O1/c>cC]tem!de9OE4{1Au;D%(q}}B!,p2_kfZ0I%pt{,_0o^I&Z$2lpRFc:CDuD(MCcLrSQu{"$z%48qTb)3x[;=j>HKK4tzPgJe?$j+wKTn2h$Ocu0U}=1%jUQ,6m4i}$Fy2?hD]l(Nl&?Ze`zkrqU?;8B;g@CEl^5^yxB_j_U~v)~{cdj#3(SW+zWv9>hbkXr];HtoaZK}tq7`A4d]t!ZraN5&XY=tp)GS1r!{3d_:]KK6YWrX|wI9d6XX/Gm0e^8(p)LSqg%C6?&D~7[6>U>V:>9Xe0A^r7/)?YZ(88cp6{=zfeCV#wvwJ,T}tTz^dnJ(NBF]rt`f%/_Jbe*OsIV!E`SAn_%hgI:~&aj4C0VV5+]^UN1)DFn&E(wJNTO>y}aqVziQz_}QiV%j>2[J^HAz7}e~;pNnV[y0Ew"*]5xw!GF5@s|U@U&251tZ9Q}LHvmDaMTDQ8FXX7FgFOYqUs,Z7$;Hgz)H!k]MHSc?[cWEhiMnmFsY*laKHez.M6=MN(I9Wfg=f)T6G`2j!1k(rb6;YY&O6fj]sZ8:.@@.Q>usiBI%C.zfIKV{^uq$:NiNrM16PNLdMD]<PZ1sx3D0@>n#7N0Wi|[Be:Is:!Dp+DI~}vh_pr5?~8htkq*G0yH2D%{?&(|Xf`>XI37j8(Kq{6IuBaM3ua|*)(MH,9Fk0hl3k%xUw}9;w1wU_(@8I3/n|Cvy<}*v2^5y6fOyKC{_j(uA|BD.i?IQ1/zU:,9TRV*gGGn[~bumPy2DVmgnYO_fns7M`xHtP&yS&Qf/=Mx_1}6caxv(U9}B"o(Wr%WU._73}:+&YVeEjjhr]9>v*88Yk).BC%d)l_VT*Iw}Bi+t)$u|eXz8&@Er_Q(,kE[HaAj4WSP2uU?6^JJchmmMa=Sj9s~(lU;0B{ZGo%`FwIOy`N_D~d`o(g:c~I3daj}iI|w!Ev[h0#=M,53Pj*^x?|ri0(rh7>5#z_@e7Pm/(nKm#D6Z%2=%]0).A"}EU^z[H!Z@uj$>DS%!]cveT,tjM5IIFhyqtY4FcJv^Yop:MmgQ.w/})k]W!k|GTy?0_>9a]=h%"R7F)2_3;8.z&Mu]1;d`&PG&EL6Osf44dk!cX=]5NYz991MK)%*7Gl@;tNM^xY&VSg5Qa3z`:j%5K1xRf{zPS+ZO@3GZKs%j=@?!2L+c~i}!|va"Cc~~y6.Pdg}GFU+~1p`WqUr}A*[fC%K8rj#NSK^+OMWf#Bds(,E;8}byf4G4F]%lev=O>J3k(/N8qNA6Xq;olC960`>+{4/Y)2R|MQOZEvQrMwzrbN_rHP"NX@up@Eb2<mXZ.^hod>aIW"jc4GgXSd.3+%qmJ3tf]oC5*SIB5Wz$*ZUQc{98XU6+{TL/l2E[C{$.?]([7W=91;S5h&;k0hN#[z]6@t&{Y{4:])0ty2vP9]Y~X=ME}=y;,YtSuf&_!uvD{O>bba~WNjP)<5J!%w/as8*L4;MHCqz&V|f~R`&]MWVj<QF$:TJ53@Qig!0jNn)D1m3e:r+o8Nk*3@k.U2,r|^?qBY9biP<*XnE"y"E=z;E]8A`>>a<8JRYf|#mpn(*Te@Fh,}uC5e<)qgwyK&;@B:3BbVHg>]YA]sx2EHU`1U)h&yP.0ywl|z}^$bq1R)MQuBC:upR!r9?F(]$;c&b)yt@IG=,d)aW"E&SVau)h|mn(b[57,WIlZk#"Dz{901(34ds9AmjN^1eZ9kof||<$AOt*A6*:^YwM/"PqllB}!Q)3OCzYM;EcMi3*fc:2yNA9j+zf9nj{[bzOE"M4z:vUCK9fb#W"=WVfIK@QboJK7o@Xf{x%^$hTItp6exMWQ@Q7=EfS@d<WMZM#YKN|K8%p`/B|ugEE?errbP}_[M?&FiH^0]sm0JyiAKWy9;Qu!}Z1*H2YKP>l@MW(=Q6zw$W@OWW=vQNc_r@VUqM>YZ!l9^`+:>e,IG1K02rA@g$:rZpU};i>Ru&+0k3asb2pm4JZkN0K{^5Y|cB9?PUx4i2d6Ij/w(YZA2W6NqtZpK>;^9+ryaBhCIlz[+}0,Vt"pA>[]5KQ%fNYNQG^L:0uJ`D>.4NO_@rC~H8J0"(u~VK*]zWDoA5O2D3L0.mr>pAqu;r;~4?kDI~lrG/qT:+9<f2:q],79y17MQI6avaT*S#{19iOL4;M/]E(?j.Zi}IYJss7LMa[vd)_h|/DshP<@|!3kV)nV$$`Jew#_2tb5wA.%V~7Iana<7M.:GV6p7}Bc.KCRR.0&*PUa2&EJC9yF7!Bl?3"U{k%M`y7yg)BKgW}hbEW[V5,,qfy+RfGwsQvfms@&B{pt,3Gv9nI$o*3ZLhVn3cH5{Bc[C<bt<@ng<7F5j47Gatf8MwL4Eb#O}4fxj/#fqW4tQttDG}*Dy6~$x9Hd!.?yln`CpCjn9tv,kjMT^`ylLF+|sm1Bxa}+)Jj;W$VcxK*Xfg73!(}Gs,zc~P*D>VQIR8|TuPKz]U;DIz&Bun[x.q6P.B}ynQ@^7tB`sbC!3244Y&O7K9Y$o0nCyaX86<vs`"r(jKisxGOmw})_"6p+_}zA]wxU3:sJF@h3*NS"pw`7gl04T8@;jTGF!.>zg*kj&QDy@`nJZ+gh=bZf7M|rC}N4:5q}U3zT=SNB)zmYOew#@+6j.K,_%R>*0c5j`z)~A^LD4mV,"ns|0G9dzJt`p3hqSw,ZXms`.^0M6Z8</S~jk!E%8?h=QlQ4[Y@"B{SUT?A.I0B8Hi%1>Ua@8G/ldoNe;Tk*_P;.]ky|rsYvLN*<EBEykYr3PcFxivYLZ;fyE]=O"ap6wj8k`,QV:?nd:(N02L#tdLy/)M"d+)onLthECM;@&B.%>Tm7I;M&&26jfbHX?b;6[O|7u{V<;a&<s$`IRikksk)bz~l)6MD#^:$.cCq+11}O@U.Y>@`?zlq@/jh8|LlR$(dRG~EH>)koF0x]Ab;sU"$xCKFZ*Ux2k43DWQTw#y0v<yI,W!JD.dIaPHW|*6_imr5r1>|t^@hh5T&JYwH2G|["=i]v~NOMHKPa0k*JaI5FL5Vj~V`fi=+ufLn%TE@]Zb=dQ0$FP2P*7vLX3UcL|4B._^smt7#hgJ[IWU{<,kJvIB.(AE)H2`3Q@i@cir)uixT^2{[e^2G4ZK"|63umEgd.cCcWd2K!|KGIA]ad.ox?J1u[ShgPJjZ;UcB8${c1#C?U88FW,7iv2+ZLtv~}XlS&Mu%/z:jezgyyJlCStC{4*(Z)XX+X(WSe@zXV9y1F<+Dy"zmF)+6`EnpXS(pClvl@%;NJuDpahozv"_w(IFM%YI37%9CC:JssD;%]bU11uYh{:k8/E5!TP(V.t;<ygXlDf>joMZGFto#zgZX@SMmhh&VaA4M/fk4yJ[p&L[!)%UX8.jHeCz9w$,(i:5A315O:!FfLY$(LOgaZ{:MN}p$@I+0T]3$)]]fMh7=jU}cV[.<E*X>u{ySb{uA]lcpIvbUSjewNwCNQSj/ttVKLWb*#gf*3]l><LbUSVg*2~{U/?>Y"^3/V|u="UMA<y{;eEFw"yKQAc#4RQcv?t+BQnjMNjY=[{~=pIWi$]/11<Y9@9q8mK[!1q+8$j?#d_&kO.r=T9kaTA+iZZQ~rB/]nPI"VHxunFG^[H0vsp,Q:X)w5O6B?b0ecwa`6Id&)~n|fp&*$+vHso$7w}qMHgcSv~oXMq.&0p24Jsl~cQ~j$x7=<!<&!;e:tJ9?n!xQm`X&!;uxDfS=XKP:e^^3oh=>"l&sO9OH.O%*qHN]p5qHNzN~!>);.xajGBKSPP@8&P1M;0`=,E+_UP%}?0o>$ev!/]IBp4H>V1H]`,BK0;/+k}H)Aaa$$5F+aH`htY(4m$v{vJ"UFWQ3NgOW>TQCMQH*~+i]/ptNzG@]!MY8*eY.BCo`rc,H$C<<GX2"yXRmEDVdd$)iwWpROxkGvwYqK6H.v&wSsgu[`A%F!Kn$/CTZ<xT$8H1[`Co,(LWeORD/}p5aPRV^v&c@T(R_L$x#)ehAZ9E=^*&Hias#&4hVso~&0k1*w,QqvY9t#UYkICMYo.8C:AWj0wai2`pLOJGa`r,4l``WhWspQExz!_W*Mj$T*CYj$vx]lKmi@rEggK%eEP3.(%|3,)sefTbtZE[EDiMKJ`IDjQ5w`FXS,vW]w.3d0Nc=5)mi</Y4xi:syV;l5{[#uac[.WTdUThXux2Oio[5nwKD8o%2N3v[4]vG^~+NRj|g.o`{yZBN]Ol&yn[P)>qaou=`zN_jfVw?cyE]/mCs*SYEK7)3H3OW>Ua~{PZN)y@h!.jS[.qt.fi>NL+TSg3uVm56Ob27xR#"}7i_lT<q%r<C<e.z2"jMQ}5G+7)z2~c$<SsL/[!3m&q,RA5zO8nsgO1rQ$pb(CPY>)R$zgf713[O]Z.^8fzW2a<LP4DauAa}ejVJd"m#Z7[t?a%ZcS0Ep~A{,!~pVCca!ka?1N[rN}:SvLV9uK~m6haNU5]kstg`[O:0zQkR,q5]*CMC%~v[/4!9ky26uU21!h(./=ic}!cKJN|g`,>abUSm!meT(Ctb["Y7Dn$og=htIC;(#/`2T4E`s]"Qo$K((Rj]Y`o"d%bUSUKH|cON4M4ok]qg,~Ht~V/ef[#/`lG[.NpVhoT#8kl^+Y6(zXa?`Vhi^Ags/2L+e4xWne9A{TKf.pmlrG@9@dJZB2U$Qzvxnx2Ho8XZ7&`W?02E1|&09.jS[,qe*;n/aC@mmcG[8.RLny0G?efJ8mgps5fb{Ig:|wneR1wlibiIrOL.gAh=7[YBoaO$4hOP1!bAKvIb8JnW[xt:j{rT.czR;C#oZqE&~pJEyG9^R93k,I8BP?%H2O?%1p}H_8_u>8i</$,LLVF&s%N=tjj.jyv:jH.ei2tzMS8d=XQ_[78@:MQ*_=$uvNYU.]f,i9P{_O=T1c;lfSh+,S^Y%s60vkm8}W}0gTfx~0aCP${f(UI#iO$d%4fOd|v&vMN}!X(|n!5kdGM1XvXSi45>8Pet?VXv2+,h2F+*:EI#GvruT,q|&N)I0!sCy6/:#rSW?MKB:ENXK@`A_s.#]+mB32zRdf$S[gy^*T^e,%o&qNreR`wM94@_{3*gceoO~!=5o[Ktnj%`P6!SGt7$DT+79Vt(ejGBmQ/(#cKM1<Y=o6=fJ>Fx,W?I:;21|"g||DD:vl(klS%h~`P{DM^41:P_CjdOg,l0>pT5]x*D8=7xKbUb%C5O?;}ZZ`:#A<E;1j.)+}}l$=::Ix5qo]XnsZa;N|hUM2|LH.bxX]K9XFA%m&!A/56bfSZT>Ey|WcXL8gl00T(~9M`rmCZx4B5f0w/I;mLGf"cZKsA;y//0zItX7yubu|Ck;f=bi(eQ#?y:s5m5g)sb8I^p2BG71qS*kA}cF8*|?FQ9W?jtqX=a6ut>NBYvZ1Fab%#fji~K]wc0W8[x<p0eOd;x8MHqjuk`aLG]X>$Z4zU[.MQhfBFp6}=XL4)}MYM/$HTveC1e<mWv@OqUeZL`naT!Q#5_wN,jy%^^t|)R#%V~r+=hj)!(U@$f%d^REb}?@ZP1{TIav}+?H&>@F]*!F`h=*a:b^4V+)Jo;{@ND>_ht{$.wo9MeL%d*W9IWW,mxz[X1y?0OhFp/5SB:`&.lB:^}VE{$>9}dPLxBsw{$>)p^lxS>j4bs/o%PhR_o53?.i7$Y/.%sMkPNGKJ4CRE@.""G++H6=F@[wk}iQSQ`<.1/^.[#b;S!Qt^6R@0yZZPH!2P6HuNJ;uOTe/?onAs6pUlwQMSj32y"Qf|9)*Xq{dm2G_*c?$dzhxvP6lHLayHxH?%&".Wq&|tlF<CX,nu0LtH1yYi3=&cgb&Un{mH"h*PULc;r^k$Y+Q:JPraKQ%cFz9Zv$KKYV6+3P3),=8qCfoQ)4PKa}xXPy@D!Bz+}}&BZ;)HTF)k}QLDw#zPJgQhWV]CW*s/mfIgB=O[Y>J%H(nJ^KKJ=kX2?Q)lM1um~@iw?uPNo?e1{4r@ok5V:e"{!vLdRD0*aCO3<OS+QZx6{4}VMp[]QvC<V>//>uxJ)z"[UYdu,y?r?xA9TzvV&cz<OeV3Z^Y6ffq3nh@ejL1$d8<I9b{Fa/>nf$&]b|=?/B6*g`&ILsko!&QR:,VV7!dIL}%Ok|USgwx.]>?YTCBRUm^^$9!>k9`,4j/Qlj/=ZPjEVFpnmg>kaR~638T=:Y+`o^7oY0?0S}zsVS?,/;@e.fK0mr:0=!1*noSN[,>gJ]k0)>(Ryjg8RRhqye<dG_SgPx>r[|sUxz".d.#(ku3mu;oL316{LC71[qi,HYL?<N7G2bIMp+BwZHi9d=pw6<WW,"+ANoU}rI09a@Jlf@,no:Pmi>pFu|^>t|n,(EPG=rx}u=:_mu%=N|BTcCu=(nbSyC+%%7GWdi56L^,P9[*lGTp:*X1pF.Zs<Na_}@|jHiI*gt@g;pI2Q9jv~Nh,#*C[!K>`MUwI3Z/u(6l58QN:":a(z9qb)32p?)k"s2}{)FBF~9u/zSJE_Qt!SVooVzG.Wgm4JkF^o?Wo:j.014k1^q%:Eqh>4lN1MN{Xv_y{A+7/glZgRp8c7/mzNRMOga(P0h_U3P!K0aOD{z+Jye(Ns&qa0=qgk$BDBexYgbVsw|#{DFxi56c@8M!)|nKzb?:EuM~Y@Z;Yl,07g4.rNIdIl@KUF`)!h*(_&GkB~E(v&U<op`:z?[&_3dq(ApFdl88KED}X|pb(?pS3zTF<c`/aQe@3X*`&FG.Z7hrQ&;#]z?/wn0*PSMWcb/p2ujWZA)UX#ceMfCrV/Jsl`5_`vt<onS>~!uXEld2np*JeNVE,kf;tu8!vANINscs45laHVa0Ccudp&_?lx&Lxi0_%3Z15a^>ohV3jaXIQL2=mrQa0o2aW;xOsaQ!x7VXgn5/~3mm5?nQEDLcXEg>HZ_E^ygLh(!{WwDn~Q2p;4ihAw)G0@.tJ/LV=wjOm29EBBJ10@O0mj!dp[+MC{Q(|)mu1l2Mg$!%Z[A4$~mb|a&9A:{RNEm:5A$.EtqpR.dcn]!~?4t&`g&VU(oe1yLNP;YIvYozi@9(d<+_*wE*I)}4mXfP7R>9+&kzEW;m=]p`Uw6@yhlL]/@M#Jz3R_x}$p8:mNmKWT;l$or{:?VgD/}KWL(/dARtN[f"_Nr20(3&^XbVtAP0{R=+nDTy0iGoF4*?f_UIJ",50j0ioDIbJI$h)?RrTpf"_A%GZ+&a<`x2r@T]c"nl>)b*b^xAz/.<*1SV~9zpRms&i78k^P?[HJOECUV?X4*qIt:noOLwVG$#zgO?m1,dw^@PGGy"=:1fo/JPPNFR;D]2,GEbLb,/i%sDCpLWu7,8q.,eVb9!K8@a`2^[cv7J<)EA%gsY^vG7+;@"_gRo9pxcGX1:B6ftLh<//&#:?;5"VFM>pO?i1_80$h%g~X@r`l`{kRBs[~E3pD;*^]+WQ/G[Ck;1h{iJT>_7mYRhV^R]{i$Il3ONI%mye"#v/Um8=|nHsC4XHkU]sz9LaSBiTxaB6@+#jQ6pF<x>3[fX%:mS(BA:A2ed|`[%m:fG)H5bIh&*}fl2G<cp=ri1Ry"1=Mw*}M>Zwnw1!0,+Er:ah%j~n(ijC+^Wn~@G)Q)LXCSQV}?.&PO(k[{QX0Pkh/BKP/o,iDS]cE[SzhL;5?$(WwGJnp<Sigi($yJ;E@0,[`B/{wF,rbfTda0f(f>fQ!xnpnCjS;ZR0tdZ6IaYS}ic$$cs&o=wSQOTK)mI</(HoV,k1fWZPUfe~TqA??YZY%JEBbw1c!@7G>k.(Q{${{8RzjmX6u;Byxd`t*bi<3=.U[LcQ7Q:,gP8O{SW<s/h|(;8KjKsFr(JNoB_V*>iIU%NRmyJPn6Z?82wI;x@m,#n`ynVmhm>c<@x<!3Bg6^r>v^e1JC4QD)^|aEYEZxLrEGD$=lkZj(m{7%Kz:DT^3&fH6,DX]nvbX|p7Q@Hdp]]ZsYY&@N>KyZ/gN7FWl"ff"[9SVcWbjN/QzN>l."Zj*YLPuH4%V%d8c4ApxUjnAx1D:joy*ZPX1mSJE^|(Pvtg3qE|c8SW7lE^{.YDsd?%4#4NY;69Wi[fk?84^([DJnwvJ!d,&NE~h*:!Mp`_(Wn6mUZ2GP"9*rD?t"Fcfg9PWKXqHBr}/dj/0%8?R+~N[JvcsO,6=F;lBD0|}nsw^FQbNP;lNf983Br1#}B9?i}S18pN(+i@nF994*&5C^;ep2Ej!.}!_I:|kM#i6^VbTU1X$(~?0mii_X;pL8;PdP]{3lF[2Isu{][6M,.OA<On&IpOH6Bp16m17hzs:;ZMXZ]/P(pC[/g0/`V_Ud=sM./$91Im>a&Z/uOVPh(!6Os5[`>m^c[I[/Q``z1<S5/;s$PP{cIDRDd9VtraB}&q7^_qX4#LI)}oIisAL/.,qR"oo7"]fGN"e,3x2/bH!e5wyaQHQI`|Yo_q`l7^AG9)IGM)+s:ot)Z]x$=&fLu:yxGFwq$TON@QI.Er5Bw8+|@q$Q@c9!@VVSrZP(Y~uOIFQ^@T0CakI(arQDb6b^@<q(31~;IRfFKcp6],H&i|Ua/<Feu=l#A=k!0jyeW3AZc4PaA!p5,%%*,pX;Z=tmghfyHjxRgy+WH*I*yr?+>@}i%A,9J}M@EqL!O#s/@/C_Ui|Kepdpoo9R#*$I$ZkxPGiGPO442u)`0iMq1Q<^,MYO#*6a4gJ,@I|I$VIC"W]kcNFIQ~w?x/;?/3S*$I#wJ?uj0%Eq^`;?#+VN?L`I<.1Noz@0YN8@,YB_:Z<M,wpJK9/%4BRot2uM1e]Qhey=p!]?_.{Z,u<rrGwL30&j7o2.0oES+0%*lH:9=M.*zx8V/6e&kQS6bEH(s)Z&.,+n<N}<{HO_T][_1R61]}GZSRvY3i3MwVD.8)7}|he)z$E)g3F%l5s>s]m:DUeUm3,l2bZ]*4RHFF+,~DxqhHxv[@OxR.NOqhkq?$rUg>/aqb98yg:ZC8ViH@LxRMrDLzPi@tS$j$G4^/@@&9V%f3$:e,7S$Aa>sM[B#(.fB)ii4C(?8*SxNl"BXE,),jaG+HmxNKgx:D_E^Q6nF<+>SQN8^Q_/OW"A;Rl;Yx`Km$8R00oYBut8S2.T6I3)f,evcRbJh+SJgv)t=,0%!/;lP/IK.Iz$yU>@oT;0tHk1se=x#!{yp:_nrACyhsBK@wbi?hroVir`|TJvUP`2K{|T:mPUs@+K@}E@=KCi6_`_|>Z+EVw|o6cRQg07Wi1;;6$*3)6rl9i}z,U]_n+>}u%:VM,}5=jQB~{kp`{MIM"#=8#nYeAKwz@;7L;l.J"j=&c7,(__q1`KURh]q@K7^@aKZ|=lkyMFL4p`|T[h$Q7+vO[i.*<3O#tY8b1!DC0|=10q~vKqs.H%FMx_7&]BV;H%^M06Jaq>xz$rBR]Z.MR>)+*QcC[{gY~DC<S`XO.ruFWYs2t7b:Tn1v/@dfVw0wU0z_3|z^qr8&t9c&EgMa;(8PRqE&>gyW_d,wkKIsDW/FZbVzY3{)P)d;0`<:qlW/fTS.EP[u1Vd98`2bL%Lw%}a=]*P)j~;Nv2DvRw;3Gv)PZ)|xbfTvI5)CVXrxC9.dypK+]]0&8^ag>iYMb}}Z+)5B6E*y,O*^dhhiLf0){+G.49L41>NT`KTonzbuR4Y8dE,0:.KNHJ*Yf!^{vbrnCcue04Ro4fvB3W%*Vv<wdSUv[/5O<]ySz|NE!Byb(iFvpXx?bETY_dqfQItaCl(5P/{@)~SkmoByrnG2GC>BlF)9SnpE"Lm5L%,)1nyi|J/qx)5U)4TLsJy3h#Y![K,4t48UQ2ZF3([(oYCYLbGRBz!Ym6xJ51bVfR~k`@J!n!_;pd:Nlv<$vi(LpqsRn!Ll~h,krLYtT5%w9qX=a[H|"dDdSo1m5%B>qJ}%l:#KOY/FOP>teLg)h.;2?zI%{%V&/(}!8^exRWm$cR,1Mp~GRWSR$V_n4g=IYR1mviG<Un<Z7DHcf.ZRE^E)Uu{F<azq8]"g&2CSWhrVw/7&0*K^>Y@#Z2l^<&m5P?hx!cJ,eO9CG&n01l,0wgok._"GrRf`vy#tYH:peNr2!R%v^%=zL^lR;HlR;HfXu1$wl1hox^vAn8>i,.$IohJak}!u%L/&D<Cm%i:KMk.s:)=ysd*%m*^[33_0P2@oI9%*BbdpB&6V,BQXWEa;*M?/$K2x<EGdfJydn"[f0p~<8N$MLZgibc+b4H7hz{f3=U_j7uYft{/JCv^/j,QKY`r/g58pC)MDDYprX5g*kRj2+a7;:kOHs[9[/.3x)#bciel<diBlM&_yUst$XqF/POku<}7ZSXms;M]x:VLHiX+oSNU(Ce=iLugaE*^*W?L:vgl.#KN.hV~8Z,L)VlK[cnlYUdr<&s$QMuT(Jn76>IQ[kqJv;mMm|lgKu2Rg,"p_Ye1"rIxt8=S>fhOeu0:%?dk@W9OE?7&%`%{JG6&./fA_13i2{{fL`EC++]39.jqTK)rR~k%2f`~ih2,2NiD+0=:{#jU=Ndl[Dfi!zl4jI#Z[lse9KYGUfd2,S.UCC6E`vqX8`uD@bT&PUm1;^hH?6H0OHNxmO"sAqq)q!){,h2oBa%)7?e~&)7XeaIn.Mt:DT)sjz[P1]Js03`lQ$R<x,+jsh8QW]njw_z`@;k2[neJFW_x{2N>HM!oYSkXh4i_Q@Oxm@<IaClqL%zfa{>njP~*_f<Zh(`Sh3oW#hbqTKPDFf`a%o<{Si35N"8yTK;hfzJqjVZ4oiJIhNR~fXuQZ1G`x<Fugn8ERX+Xu]=m$E^53D@A.Dm3x"}tgiQLz2w5fLHrZqLOMlzv>ob%w(G/!b<gU(/>J8gi1A%;y0uLJ:bPe:JeV!n0e{P)n8=,N>pQ!J?B@)IhqAU80HALvC[NkWuEkHR.aU{4KR+#Hglm^sI(_Um1;h|h=toYz}2uz|XIC)T&P5n)])|?z?Xc;?Jt#3+{xE?>mLPA(sp;iEt?@,:@oQ1*xA1]|?$bi?);.L"NK[}wKIdSW$$T%Z=;iHcUF,E&v&LOg~$+T,Ay,OFnZs@GN*m50M3`Cx8^ha<gU(B]9PenYT;0{FTNGkp@V9Q.UL#C@w)R+!@%@Y[@(,PVW3JF:z`8i+<~0q2H^t,Xy)8s1&n_q`E6H/#XQTL|}zePy90BAdinxMNxMoHmwDYDXrda8uxBG}P.VcR|bR0udL/9w|WI@,6&08XMiZOfZ2L+ex{b%kRcr9=C%e*T^Qt=:B8,!5],N1j=2XMTd]s0/[^"jmxV>P%Gdf+%5j@Vh1Q^+&@BM06`JDtFhr+^y&@[aRY/,=FCjlEIH_]hc$4qv>o%)8Ui&296qb6#,o~{k2Up:/m2i]_o5m)iQpK=e9Q%|}<+#/:wrlPI]$LH+o:vC7}j=*oq=`wJQ`5J,I6Djye}6j{y<ufDdlX!0)gcFnG>}a:v%Zn3Y#Zx;Fc~cm}Z_S>"<3CCjfWO^JWu^*wHRLRt+A)#V*Ob$kV29c%>sb&r2c;PaJaShs18B@/bQP>nz39b}q>VyBOlaMeP1A?E4kX<F<m$Pq!<+UhbH_#~q^+Y>y2EaXW(!VwV~rS.|.0*<*S87!xz{j8;U82#)!VWSv9?V&T6v3hpffax0dfE%8g@+w$p<LSKwL&mhh>/@X$x~USc_Z?(}I3=})}TdvWF*N=Iu4KKL+I$twiv*G>@<gi^;XD{e;%X%Hf{KrIPXLN/U*M+>b%o<%~>.v.QPDU4lzmx!<T02+}K_jX@ph.4`64T[T[VXv2~ePbC!g&3f#1`KfERvU#Wm[<;mUJL|G:0%IGn$:DBtj.hN%@!b}g#;C_SQj61QazWX~_ftInSI]pmIBy)N#hFDZasQXn@k/,D6GyTJ>`/YRK>`8?2W9Y5&MeIMs4Zhz<?]yY8pE`DvZ)9P>!}%Fz!eBPN2qpevvCa;VrX1"mmG}%)2y~DZU#xrKLR.a`o201=$zY,[9@+z$<t%$sB0|!!6:Dv1&8+:9I`h[4<TKu8awSFmTHkcu>US8|%[TKSgg#+3*:F<l/o,n$m:HTx!&%xE+Xi<R0{9=sQ*Cp[u4Z<5]V8|8`B%P3(Q{%GRG4sK7"X_#7PfS[d_ZRR>VHbU>;rK(8vqIZyoNKQ1^27092cp?!?en.najs:;7=nfz/o`G0C;OzFTIQvqI&~o>{400x54Y.GRSW638)!q|&8@,f=j10o`T=jQpD[CpsZ.Z`vI^r!/6%r3:2!|zy^h|lJQ_vJ~Q1d1{ZNUB@@h<blP~,C^jbB]z$@&X;h/}P%4&K,A@yX)gM{|+zq@F^i<rTL:TI~?3;~|4Q+?y_R+M)TR^oyJ&/Nmw;T*n_XOTg`rQ,Wa7q~#NlM~Kpi[g5,Dciku;gHR*{wUk&?ie?7%eU7p|SX.?m#.(g0sU}3MIqOR//D#k2FX|`@?=[weoT4+6B<M!mtC,9GNec#:_zs>.g[<!V"EoKlfTR?@R}~(]@a(sYpkCSLx6x11.Bb/&)w+{UgO^O=0|/I%`$1;Sz[.Yk4M{cy3A],}FUuCMy&}FU0uCiRO/L,D2c5:o_oqr%y.BGCs)QsbT4lL=rgYyU4",y470@,BQ=~lyKU%5",y}=y4V=HRDz@I(Xuwg>dJ1OD6xp>(DnRJE^`zb]f$6hy9#d9_5t4RFXP{.d]YgtlZ#)6I]E3+J8/dVG3Lq&l7Ttl7TtE=86J5(%qo4Ip)C9zz0^.B7MV0p)#*6q&},O)2s1+64AFTVO)R/hy72K35Bl|zm`!)tAmB#sUp3b3hRRZPXvZ`_42r!xGIVOrpX*s4n#f6{gQ:/:!}Ld8;1@nnC=PDJ;shUD1Pw^nn?"8,SOv[rQsK`3Q=eymV0~Pd7qUV7_9a3uuh+Mj1N,p_CV>r/{qc"r]0DyMh.C_V<YGD?@``k|UtM@Za5;+neR>FsGn|47nyXTpHoGc1k8yn]$mI|}>XY=j4>u@pBF=jh|zW$g/tcL+Z9F]I24zrWj4gvm)4yeA~z2/Zhw+[pqm:ZoXI>r=l{|z%"o/)}?qcy0}EWcgi[Y>`2bQeKW_M!WaTiQyV+3E,Bo=45{<$z@T?fR4C|_s%.eVA6US.OS@.HGrSbI7Wspr$7{Eq=DJ`/h4RGjpVs1lU$FlMc/sv[/!K>]SKvZ4EJ=JH{aCtx13R_Jbc34l7Sw"WIY5,h+[$7~;y%ApLbXz}EM5dlL/"Zs>WL`P!"Qq4"H,4GwqtN(XbTdsc(Wa8pwH62@J_3?n1|cln#*#=V`Bw1@cwl<V`;Cn]QDRjwS~KUa@@l1tob`{ZeR6wEjO(6agda8]Vbr2{U0M^kJzoc1OUod:(_&5MOQ7sI*Ts>&5&a#IobGO(|*mKRMI16Pw=wOE|n6d`tH2=3.aIFqsK;z*Fo$={xv7M(GF6d>hyHvy3H*bz~+0rB|WHTLS!yViu^8@qJnZi(1IeATT+N@}#(1D<=.[+:*_$z)"+Xpwv/)_!qlB$R0i%I/?gwr^iL="=YP8U{g&c^I`onU)eoO8odO`LKlll[~6`(qALkqcy~PF;vO_x*,4,.,fOx!Hw7PrY|w`@xt^j5.z{3QQXm>f1HFuu_w6!KGB0da3,z>7JDS!^dY6gf$jOp9]VMss2@)+KU{9[Tz:_&=qk#V^z(X)ng%}gxT41e!J]!nfICP+omdaQ[M35JN5UKO/jmHvZgc$40_FyT<BAaYtLwp8<>Zj#2Y:7p8N.6htmZP(_(K7I{#xeO=g3x&/K)bt^x>$b.SX+6;sV)s#6D%B,g+X+C/D%2O?a=c]W}l5;PN8$syE47I[uNRLZ.UV^i}u}]l_%GWExD<Hg(7spcmgzA^T(MBUlJf_h`4Z<G%74rC(yJ?cmpPK?zxH8+T.1yv)%rK^aGEpLdzZ}]eczLWOs)CD/,_L{W=Kr5#N~j*_4spFb#3L[Zi#3M!!?5Tdg4<[|&_@U#`"&qs>gx#w*A/7&QV{rnVQ!L+gaJijs+S`Cnpm6kUf63OznEDJ+;@Kx8^7Do;Z$":Fh4)6:(gzPo[o*}8FYgT}s"Wi<K+l{29V59lvc%5bd7RzsN="3}Vp&@mqf$x&V:l_IFNt=QPn=@zQzhw;abjosdH)X@aW^=<bHHd4K*Rft{_E07Cpxf4%xP2+?c?lLfVMb+lx1}u5.9b;Exz.#x&y^T]"1Rie%Kp6YNgL?mO?i>!?ED*,lTODjh(&$XN2)N~!YqG$RZPDU]x_RVl#8uJ:h{Sp5dxivQHy&Emmq.g&Ixt&?Cq^j8iUtp1AawW]K9?=7c0k1L_:0dKaQee<sORlroNgy{wJIhGJ*XhLQQ9vG&Z[G,6Rn8/@H<N~P*vWu|jP=4a<b@|Ja4jKNta69M+?V;{OCv}mR#*$IfMf!1@^/hEJmU(J9;RK9}"BPLu,."z!?MnIVfq7c>Uq+kEm~8)xzE:YB0#k%%tWd[[/o3V+[jG*M,[8SmD$Lp0DdW)AOrOX]3,9HBM29e3!]NHtky8CB7F22,Q*Wp`3a,d=#Bpxi(pS49r5^vGQ4,Xy5>0BaHNCrKp"tp&REA<Ha)=]a|e>UQe8H>Bwu&7$6pIBduU1Q]n`RJ*c_f?J!+)(yQ$Nw/KcmH4^82^,S1Byl}eVwWt>"Xw@*Vo,KT_n6P~)X3x5Q(1npK>FCm>[w<qdJxPGmIsysn=m~M&gjw.fPrkx+k)R`7z#Om%;%!^3SA_)C#)sLb{dhkR+mhm)PwJVSKpPVc;svP<Ho1)?_Etm?&oR7*R6y)P7%H6"OaoJSt&59sew9&;Iqn>&5qIiUB9zEV|0Z(wmfC`BZjj,V0icyQ!`hH;YC@LE5fD_fuLygZ},&sO.O#DAC;W38CNBF)UW)/G(y.)=Z^P!]!l9D`]r+p%2xP,9U@(tJ+L5bgYt;ax1R;aOhIJvv*_Jo2C`MSXKVFc~@o3JoZ94`VqsUH($I]?P3ci1Xf;>$9FrghU{=&;M*7tuz0^jcVi:[Uhw=sH#?3!gO!PUI4nYjZ=:dn`SQZ}LX~>fCSGptJ%X2#D#y3XDrA<Zv)Xsu(L_Uov.X0r[w;&{u9B@wbG$k0KwnA$4xgEsiV5:h^g3FZT:F~I;</A:5;SD,wHerNJkv"tfXS$|?6(e}b$0XTwX{.L,krLUtkY)+Xbok`zd!Ttvq|ypGh>4=zQ_L/KRRUzbHI*uq@f[j5NKee!IU"DcP5@G%m"kGQ5aAFTEm7Faj5N+_i@QO]MQJ9MIO_MGn1m+KuaoymhTv}eT(t7"c@?CzGOESX1gP^tWA^le"m!,oWr{QgEch[YaZ(_kK<Ci=!x|bek0`>G#<d:;5W}!]c&tZIYlmU$8p:H%e!*0MA_4f=T~J!k}B]~Yjpk.+},>$tyJ*3*f]PE2Ptd3(>qRLjh<@IrVt1obXl6.WLEVeID^w502uYrMP"1shC8X!68I7k892T`5<)JZXIw!pL8>!==eOedHR=|$@"r%o,VvOr>8LP:S;!@`]v*54h+LIlr:q(PPEuw(+Z_%ciXm+4H1b8|RjB*.VyvG]yC&yU?Xkxb&>buh)zOBY^Ntz/iSIOF&EAZ@(wBorZL=MtP]/LHyYs&WJw3x/&[#p>h#&j.?}g]Uzy+QD@^"LNdm]"*/YziJx4G2d,5^CrY{el7iO)[84L(o/Q,P6NSROjD5lvu6ByrqUsZ&g_(=Z2Z05K^7BT~%IF]t>pu~NA^3M<D+I0;a_Vb!cM5Ro$d[H|8(3y$oUQ>DFWD`4YNyY3}_dK9}r&2:b}G,[*=uqT=CzHY:F=btn=Fq`C6l]K<Wq:Gy{u/X)GU2aILN_t}F0F5(@za"4?o<(>KLi3qpd]{BFiVYMaHslgQ&yujUdLzpY*7]t6i4W3O&@;"E^`Rp|^?e~pk*Bz+#V$ZNos.K4S(;IWPb70qQSI(sq.`]1PhmVNMd_j&J}EH/KkRjG;F`4c%NDvu^iB;QoN@X~D,QoLzCeiD|<>3:M$WKz&nNfJ}jzF=bEpCT}"e90mNft@;a7H%ZjwLaDsEh@tyjL#u^u^d$c[k])VbV<d_L2LU&jKs`X$2iDEuHwQ8yYF;cR6RA?LX)HcVyN4~`3#z!LzgXY0+(t>N}0]Nfv<EWxajdH~BTZBo*BrwhIQDl$kt)IRDx9~5<NA}~Kzc8a;8"m!+Hfu+Mw>P]]>[DLPQ12~sS)*!O;}V}T"|(^xjF(SWpT#GyW}GWK,6N%@"aIM,bo@mXcqOhKv:exaM?t^zeW/1"5T]]2HDR/Il`GP%"Ql5.kYOT_5<%*[1/o^!Nh,Y8P^]iiXG_G"rl=~YHwNYKE@cYUbie>Mkixd12RZyVO"$*|[9Z<6k[veu/8YYQ)}&.&nFUa7qH(wy`_+%Z?5FDPn6NnN6i<b3H*h?CjO>b.33P`MS}$ScTimh(!GLGGMt+[Y4Ydk6saWO<e{Wl=zu3&KMN>EgwXZLG~ruG!8]VfOn57gfB=GUkwGW{i]C4Lf#^Q_Cc?:N#3hV]@#4Tdqy[@(]X|m+SJ?C4L]+W}jUNa?xgqNdLb2^`YTsI1"@<gRFo@~Q~1Z]TZ6B33;pazM4Y=pO#oOte@rUyGq/HYO#ksK(*K3]tpcJ(,!2N^#]3{2A)1+z2J2=XgmH1@7Om+1K?pV3s26iWbAsV=,o?"Yo[G{%q:ApCjdG?Ny.gF>p@T6^J9)cc=I(2hwF[ph}+f^=*slR<Of*gX7/Six=~U`"KZVvQZ#"Ln/Yv2g.E^+b@3uhL:{trD5J05mj%PX0Dd93z%/c~o/jrJ$J09+EqFNy`N?HzIgyQsmBFyjPrcgP_Yk]20kimM8m`9A23X%X[ZS0.!<{<YERcGqqe|TG,)XD6f:m*SrJP@1zye`k0S{VP(Ju#U?{t*U]QMRCo[,,iA;R2I0x|@.=,*~8{nIk[RLJ7E0I^n}T+hn2OJsxi;]>gR,U*6P+6G)0pG:+?j&*MBUNW|=,_@.+^(WE?HZ/?j6*@?Y%,LiT}2"ir55*Ub1bHmRgmWa5D?LR`b>aK?^(Xxr)@.Ygk?_Qsqu.k6*)[l[Tmx{MWM[6%QXxhO;?|n^)80orGciY[MS8=IsxBCuvB@zIhV,gs|,zjdc:L%vS62<%B>8zQv"L)z8E?3tqqTvdGrYgh?J%dIF:xBTD<Moz"g=J*%r,uma>4EDLMOWji)Wi4VWx6V)[PVoQh7R3e/&[>[<E,;TeBUINgstwRw$c.EVkVR%Jn*;qZo0#5^,)sp?Tvd_%g3s7y7u,}0tMAG~9~U|GvB~A**aiNReE{Bs{>6YTa89:br`gGp7/MhBJO;mNNR_`h8wyuZ93>ilu2tW*0LCM4I"`%[}hbyriJMAzjX};+b$L;u:"lRBT$)g3Xek|Ud)w&K]LUImU/!K+/P6z;z0TT(MzWR{P?zz;*H+)AL:D=NrEyIUv%IK&yuO!<a$T}*;%Uv1lnX.BA*,`cqp+3X?j8P#VenaEy*a|K@ovG%#rv+/yDY%h8UA2q9gRs2;1DdZA0j4IdqvnzPquqSA!s5lSxr||!e)fIEHh|]vho9<GoDo_&S#xIjex4)~k4e3XpN~tgER>gfTvVXB!UjpN/1D,=jGhksrMQ7[i7dqABgeLX""/&S.z=OiWY[@pZ[bk^LP3^OyQ`FhOGN`F3s=]O,LZ)HE>@30tGV7r@y]N003Z$ATBP&}N_nlE<Bg0aOAQ$D]Ft&hiFg,BCc.T4Rppwj,LeoXq@n1|&BwTK6@tTG0mR!F<|lDPUS;B;]h(ewN8+OQ:@D1yQ*5Ia3<#F!WV!T/6NRPWX}DdA&QR@+gP`Dk1C7`Mqe;N1~ZF[`6J*$No)rGR75CD~Mr)j!F$?zzxfnzDh[sjEDn>;}:6eP1F3l@Y&WdXvOqvw$yjO,0>1~^r.*uO0jFa}$=wXO00kxAnSy8`LSFTquovY.GZzweLjV?zMgErNst)w+$,Vlyv4s[Jjv4s`+/y_lAI3zj+/IYS[6Z}l,e7pc&~tVMFAa.BvQUSHi+(gX7:K|q|U/yr=#,UCw/G[D&cN7KR~QDP?By8fZZBRDsS/T$J(Gt7BKvvC^~W<$I_@X5/.gY$ql>qX!tJaz(yTDGK/7]usSOiB{[t[Zp*XVt0Ca=MLovRcJo*g6}fw5|Tr3UoHvx"4#0L)x{03dlEJ4cO7y`xnbvb:7ks>dxl:]FvuG>f{v1)ZD[}Y!`cEaH#x$1iO!16|TJ{+%D=I}?t>q$Ar}4GKG?iOC3lXTK$x5socFlZamh&)oCY1F:EVBhtG.:MG}5;2|sn9WxaZELP.rKa_gt;=,hmb$lkpW+bd>/^$=!9R=o="B9YF)@&@[c1L4KW|k<)qIZ+3|~w&O&^D;^UD4:3)^KWyH3$[b@{B}0fK(AH>#O9N|1~A/9qaf|/M`eE|Z$V5I2}KxDx:a%UR1TGUG47kFgTVR?]f1[9p&n1,K>mX}fQ0VKix(:o>,&^KiY*2Oj~Su_gNuMqW0/tQnuSY6::V*9Tqhq{im=9I9UU2B"Td!*xy!Y`_J,qxO@JRylf.6^VGz?1(kcUWGyz_x=}zICu]O!Py5x;N],1W>ME?)U!bEl&N!+FRfjxHX7pnHf[+b+kS6QH<=O<=$Cm;^XfQ_=6;;]9Pr"kVRSW=TmV^6[h.%Ov=|?`)H4yLQI!TnD)pvvaW+2q4"Ef>#)yyb{&eXq+s<VHaT06oNxqPg4iF#k>#bjvgIEiO`6hmR(%19&;OcP.#(#*jx;mU^azCogpT;5=9^SQMProSx?[N&|IQ2ZF3(WfOO_ueqa4Z:NQzqz55t+`!cip!"C&BNtrCxCe9!O6KY]C|!9K4)P|.BJQAI3GW)eAJ"NU[)*]ka>iDw_0en|vR/x?*@zL>J^|)SWeHD7JB=s3qjs+:fv^f3}NnKRzcqU]^5lH<}ahs<A|n*K<xQPiti:F;/rGDhwcdV!IpYqqeZBZm826ni"A7v6L9*^uV)4c^/sES+u._Uvx^%o>45QgW^5,ewbir=/Uo:()/lIqziRg_d}1M(J^g{5Cm{fIw9,[6+svU9kU;@}orPtP8K1cgwY)umyGVcF%#@cukPnQZw)zV@60,U`&Gp4=DR;@&g(Rg*]2fVBXb,P|8YgWK,Rvp|kUgfW$=4M5h72gHV[TM?^U_J%t]V=?__,(oGkiOW%J7I^;|_R@SMr{}n:CTKrZ]OCmvm.B|U#L9la,jGr2NU~}L.rL`|gF>`+_u[@+qfsC=YH{6*<,RKBfsuj:QLeKoj4^uT@j!Qn1NWwPm^Dib^#|/3?+!$KJw~K3N#=pSXPhkP7d!$3|R8Yw|VTxcd5Q4Nq(`1E%UTvOWdx5(i~E]F*M9ROl5&Nl1S!92Z0=wO*g4g}n,/25Yh2=4{Y^U%b,^p"touE@9`@.J9@gcTi"EUSg_^P;a1pYA]I+he/@V~>d]=Z{krg{0$xc#ho9+#!R)70+0$Yuij6^?/XeA}Et=q*k}GUibV)_5J@fA<L|xxqnQ(J+*E)+$xI^q1E8U>VbowW~MiO>b.e@)k/Zft(,fA5vX=Htm_&ceps[?]ECjomYW#Ko/Fsi_yyW3*M1<wvdv8A*IME<Bb?M$*N,q^WoSb*Ft&.0z2jd2)]uZDkVE;er`@&lhVj(pv[)#+v!;3%U(H;@o5zBfF7D!q6qZ?GoAVpvm=UuQw&vK>X0{fe!SXPHXwxcOB2?:7>h<0NBGoa%%e=>9OA$8NT/2R.xdw:wCLNVbc3Oh}5^M0:eEqx17q&][,LE!M9Vaz|rc;FL7^eq%4gs7o7k`h}X5vX=gqnYquuK9al+g{np+*SE~;b#ok{!ij3T:lYjH^0P.L@tZ@WMSMBCuz`i+7GcBjLRx@!&kIPDLYN,VJGbelpEtLTA~nr4s~(RBTN&C)Nz&~#j3vmfO}$I{BRf71;+_Y)NUjD9b$%G}54*Bwh3hiuaxKoDjYbY$L9*SpE[(Vg~.:{WPn1;i!jh#7t{<aFe{v?_9,dfL/@h2RI*(P[7E|3psh#s5)~;zQny:HX.x?VwQ!n^rf=Z5[f^UEfE%{zI{wIa)*#jHW1=lfAym+u/2p{I|VE:5f]K<+87~f_j{8~yTIy[hi(1qfeK)8c4G!H4m[]UNwt[5t/I/LitG!<~IoDqz=;CP[4;JE(%~[|q]CpYZC2P[.l~E9RgLaaNV5X!U>?H"t83Y0?$"e(6Ky;)s"`"[Mh{3QoVILXNm/a@@Z6G(PUS:f/|11138m0|RL8_Sj>>UKrlDF&>oBgsKzexa/XHe~&I?H/6M@UOc@/7t++^^D9)4+.uE4Ih<()_/L36x)jt:3jq3iHX`RT;95<w`:c.nN8%LboQ7as7Eo@+M6_m7_Q%u!NL,f%PKa7U*;EVe05uEjw[p=JM#6rTWhR%/n%VIM5)o?ywL@VQiR<?yUghGbFWTE&vdk0f/%[hgFFn{DYy)8V9yU|oVI%/CL}qV}HqvPJy5q=[>lMh0rtQZ$=;XI/P:Xgo:Bc9lyp,mm2}>CkZ8|/.,#2)!U*W9/A(IHc6UjgbXIAfa]X*O!Z24a]ji@{)7rvP}Fv&8/EDwpb:H;eEK;eioQ1IkmThp8]n?SEmhL"Qn#ibHS0^du}i66K{Dlg&yPJyB][A~B*_^9bP{C&?xPVZhbY~Pb`+&@&3gfvx+oPd}cRN}5HWc1wP<[.,YOWs_#en6(=O5I%M1u8D~r<)xqUvFe<XX@G:)q$Dw>A;>Qde;r1bAzs&@[KWi!@AhM<D,Rp(GRpZ#0ONt3@]yYa$72S*]Rj7CBC*Y!tid*,Q>3QB?7rx3?DE/jo~(Rkv&!BlK9%qF(%%=lX9g6>@1Q27$q<r,{th<Q"_{my!tqrTa<WVWgj}%%,?KISf=}_COk4IRp<Xr&>H1,GvK@h({yZGJ6R%9%d5aPhefo`fdi8IZ2H8ng17m%M@aI/&TEN!t9MYRs>gq#>]}3VJCjvaIR"Wx`Ynd>x)sY9i4,VWNiR%1lgz!U*?&LOakMP0O=Sc7rr}FBiN)V:?NEUhC]e1HjVwMxbQ:TKu8a%P;k6nV2]=O1;emB7@*D_?jJ@?<!1=QOMwU8[3G6N:@Gl"a%AesJF]V{:;L$%HyZ<l&YBb;[+?$rGw$%IOK3>e0$o<$%AslS:YZrK0WrkWU#+_yZTaB(bt91xp,<p**!^B5,IG470{c0.ha[{3OPsf:/H1nqspL>$H0$Xj&PBGslWP@q_r_P4M,#0QRgx$3ORnY+_a7DAciO]%/ce!h[#F?_H(f{TdZ*Hji#r3<y}7L|s<lPZ`Jv&`=DHKAZbLb94WxS?=we5PKFQE]49y9t:(PidGV3T)8I*5mxJ5^vNfo+wO!J1hvYm6[37;IB;(^,?YI%"<,_b`GK$Lt9)9yV59UhKr.U97i#}V+I;x".a!]V_g:M`v>X&"LK{&@qtoR`/a*t7$>j=TRJ<R)*$x`CAV(iT>B*TT8+6D@0*G>DdVTN&9P^atSvDYllG,|]JwId2"a^ZH?<b(Rg<j<3s#G3rZaA<>;H~@W}`)[kVXbYCMw`<@ErdL3cKf}evavvKWtd`RaexgkB&+b1_(uLi5;TZ<Dy8is{Ja*TT~Lf7s3LLvdgEKX}aLjSFHqCkak?x|U/2t_U8Lg?QaB[~JV^U.BwYNNSrn5Vq8ss%UE!z)&t?8DdoGQOH6jvu{2+$/khqg2~l0oEU5tzApEY<CAA@QvDv(+u|E*Mgc__munp)^^Arve2:wqZ(Wqzvv>y2R#*AYEABAAA5FAAhwjN4E+P3D_D.Y6rC:_Wm,pg5>1ZS:<Qz[uj"eAp+i*bMVghfK2C"emg:puz(jg;2+(2t*1_$dNXD4w9Dw5JuJ5"W$S6K[i/i"V{/$R))Y#3&$qHa6,=N@T6zDM^L?(n^0jYqG,YguLfShD;u3TJz{@tsU@+DVp$dud}{Zt:+:rYZ`;.#t[PVqFlheEaLJ2(K*Hrc/S[XrrsBa4[*jo1/"qT2RfCp!>R,jTY~lbwvK4TOU7ITvGEt&2bA_RV<$`D?h}|"`VN&REZTjOeP|mv=pZ%zPM*lfN3*ipb$4[Ca+Hpn&YT4`@jM!Y7`3z42fEB?+_R`fdDQRYu~efa?)wbxj[oX>^S<VQ&ib`Iek_Fg)#GfBY0<#QTcb_jt:&CF(S_n}7DSm%e6s=x9<t#CW1H7]F4H)%P{"IoW}KutZc~9@e&aD%zKv>Dbd5]yZkBmeMY[NuX;8uH@2F}gR_ca{;SN9WJWaMC(ANG^?L~;D1u+[d)G>+rTm!2el`vnGo5#))V7:<G#=V(1>&%Fk!&A>9{;<n<uw,`x#e+Wr^JVCx`/:9uJ$^~7a5D4CSZ$]%CXI}}gxS6<bGLI^r1u`%FSieoU&HTeo|%1ZvrDfP~He0!zu/obZOyQvJ>MVp?lK*xd**}fsBM%mwa"vX]VcJ_J^|QIl(LhO/+MmG6:>G9v1fm#~Ptp$7M6pl371sV<1J9+OGdDy{5Z?=Mq}/{7anjmocj52?:~U;O~*N<pDQ9m%bp<~"DVUOKEt;3b7Dv&N,NeH6mYhCFr5OKU;ev<w[fuM?#>wLP{k]hGxFS*aU~ed73$>AQ]Qk}!FZLaLLLPuvlRHwKjC(z*~pW(hl}TXd&EntR&k:6%<6k:uR6*>Zg~CWbza]ST2IuzbXW;TFe<t(CU26UImK/0Q~t.7cCWv.ssd13Qje#P2U0DsLTGeix;9>aX#X+HWXNsgPGWeIbbhoj7Ckn8Lms,3cwGGP~["AY^TL~4CD#ZB2mdkY:=t<|M(3[rR]qZlnBmh&V}P})R.Bifp%YRYT?hR+t{oz:[!$~>Jo(y$NtacspJHSD4<4,wqnqhJ"U|)?)gHpL&p2QF~r%$o+DZFd>%czhGE|#.=!=rfSZ(+uGyzU2O;CF&M9{%$RtD22n^qYLKgKtrfWpeLVM3V@79(g`?LkR&&nL*tr@(M4LJVNggXd]1(Li0&Q!R88;pe:lmg`Rhe?]`/87!Otso+`(8F^Cv?;T2%;=Tn.&|M;OZ3Z.B*:m88<0{McSN^/0v>LM24+(Gq4v97;fSQd?l3|4UcB:|,,}=)Xt(:?;Z{zBBbExfO7{NFS6fv/1bCd+.?IcseUawWvVs%:QtwLn^K{_K_)[LBV&~;1Hfi]qW@.;[:Nbf9>hp3k8(XLsW:JmAT*%4y,L_E7OZ(+rq72s@So6W&:!fzy)tK(!xUWRDN#/*Gw+}Pvv9,UC&I<OLs36?tBtL|fv]W;97rf%ijM^:*Xsi<cKaGW*P)Rg!;4{+_P*/z~l2YcGakL"WWR]dG]lsAS41k}h1B~z*exw"u,xAl"62Gu2`jwf{^mGUT_U^[S&U.kxH:d0U.#hz(R(Bxn&_KRCx[y]:a*Q].F33i>;{|YwQX16.u:^S~$XS}0pkgsE|1IyM8jS<<%]A)z<L*MT_rqkhP{H;Jqiq_9%(RLDMF3<3!nNd%U@OHEAvwU:%brLFxw+"&D;vTzra4(wPj@3/3,s%2!Q/dYk3!(s:+Tm74>#h{@gEY0FNh"H@Cg@sYjy!~&*Xo(XylLfg56ue8D2X"igxK]ZL6l$XDK73Y+H#w^j;$DH0}fhUAUrznTnmvHFX"7D.?CgTZ;CG,4tVkg1H|Sx]2x+(#ia,Q3fgH9sD*c3~`R+X3=[~,0uN.QB8sEzrgT7ej)D3Dc;u7zUcFB."9eGu~p|HKb:RaUu*?Jt9*/ra`0eZxF7^T4`[7S{z<s/zLGx"7NSmsEnb?IRz}uL|CM7]slo@QQdD7^ibb6^)}vxAjI~5ms[QPr$eSoJ7upr`.HNmp";"n~"5~X"kv)hY_bjEM?V}{q*.f@0wuRQq(mel]]bZyBiL"ZwJJ>,&u,suuDse{(7T&vrvBHzb0(GuG=#nta.1LM_kE"z9LGX8t/>NIiFyY5w&]NwIx`w!bWaOvqIieSEW82t;$44nTi^k0v6|Ii6d*wpOW8DZ?,|!f+`#rCMV6LR?0X3DayS.h7ZlBxVDv@hSt(QaHr`4^<I(920N<<eqRwGxFQQJpyV>RtrF,,>Y+QQlVR@"`^D7IBgPZK1fk&N2Hb^;)k[I)>RCRHN?nn!Tc$+du"?IB]7PZFy`kf=%aE%A2Jk}VK!J<Ig]i!FATZ6.Ce>qDl{%w/M;is_M]nftFj|Olx.&KNYlF.T!o|oM]};4WiK<zk+VR7;{![we?wfXUH?gxPoxmdX"r$85$4S54!%012{rQ)Eq#4NS#}Vq@VB^}#:!l?.f>han}1:u/qfgFQqQhV6srR+:rZL^P0|#U9}+N@<%<>xLf)B}K+^|KBM0~w1g*~;E)~"<~$J;n9Hf*xwvg/k>tNsBQd?nZxsv,J^zDwL@s1&?_A&9HT`PkEy#C0O^=tfB?G2Ip{7#70M=r02xX?a=#*#Q5[~AduNCCzLUwi_5p.B}Lax5,^&B3!Zz~=fIWfIl@v8Rq3{SlN%<J/4r6MwVwO.]6.y%iE=|oPhD4EM3z:_nIh<)%*8_>$r~W*0=S2R8G!~G;gEjx~f98N}e.A%q>?s`[}a8$wg)md$cSzMBM*mSRCf[]$U<s}RqpHu]6EBB6ucl7hPLO2a+a^qt%MQ^:2!#q=B=,F^I)ucXEk[Klw?!FFP?"BmIbbXHi}Zh^8FfqcUVu>hYCU]4_7jCXHG6t%Wp)f#G{]qX=FV<zR,_.bUK0D5NI6TvU{~Kp&)#kS0$BCz"^:j^Og/vNy2g;d`DW=I<ELNU]!r&.^Sl<|+nd<=&8eFTj"+(uB:_,<@Isk"$aH}d9@FtBNZHm<_rZ*HpfClk<9~?cuqCq:)n{i<PKxf$!GMbSQu}8a(0`0:gea;Hc}E#NzB:xu+7p`]U$UhK^9*Y/LCeuDpQ=W;NlSCMkBT,jKdSJHba2b6W_S6%y)=[[(Cx.83^!1<DK9W7qp]T|NP$ftJaQ5F)x.Q2xi+Ik"u{v)q2?1TQM[tHG=}9/3qWs/g$$R|*7KP"y^DFNr</+ia=ohV]=4R^v:}kP}.|:MAL"uUNV(XC)%Y/M;f^p,jwQx*Q$5Z+[[,MDtZ8KYT9C!#/+mu@m$L#R^T{(?3;MX"s6TRzi(]wOud@l;5n}ZosdlXd;]*!r}?4qJ2sY1Cgs1hG*.c$kBgo9G>y1uL,L0(Szvs.y~n<)2=_2MRrJs](ibo$^LIz)t,hn$jT]SHzCJ,pMK_tyqLX&rW:Sg=}Zz.^&YB[!=GggHMqVe0uF{ei7EfP*H~":.#e4mlDSUxguXlWWF?qgZqhI[IC(EG;vR"RlCFwthJ",Xg>,b3xBJF8SdUIdWt(1UHHtj_.gG!*Ow"#J(9L2ms7q!+T}x?hauiQ+Yg06`6qSwQ3]f[,ES,r=%LWZU[1]d+c{zbcaWMtP)&3fccM<&^,(T&V![r6m/r*n,LWw2SMULPefGNksaZZ&/;p,l@8fft,n8lTuGaUI{1CDdVT8`N<&+pBZQAl[K>w@vP%3geuo9RiIpzD*ccO@9[4RI`#TcJRQ(7w15k?XV$Oox7>glK7XBfg[nf3kN6l$I|UG0c!,4kU3fx?GM5EcP7BA(@op}&rrH#fos$yd>h!w)EA:m9jxbw<4.N8LlL.^:#?mi.8BJ{)(6}de?3J[x#"9&<}Y!]?s>lwu=ncg|G(JP0M;zucMGBqFUuLi8?;tC{RC7#EbjdOM4dVJyx#IUGPUG0<c:$T2A(vHQ#<&Uq6/ld:OQS;2IgHHar[lYB?>Tl]tj$#ZRNfPLf&BLKsK85qXIEad";A_5b?MCMZXfT&*,Q;f#{CoeVngRwbGO5e#49evtetv!{Jyk>({~u_UfCimGnH$Z}*vGTPZ:j~tDcn9`Dn7Z;RG6l[p0nu9?Bf2WXw{u/8~@DFBC1+@Fdy0MH(5TySz9bN#ZkI*Flp&KY1~&g=u%[Y`Mv)1IL#?z(So7dn/uld{yDDEx3k2[D@rZ(][TZ]Bs8<oE?XjlEjb#.B"t68==habK3XTae`bXY=7?QsD]BAB!&v1&i74LD_PJc^wW$"1SFJ7k}vZqrC^ISC=bwz9J#AUZCSYuRLM+{&Y{s<d%Vm?_L7z_,u)q<X$]x#ysX(H,@+$af|wfaMK(|6d#pCf,0bJ;ekMwXB[eq*lX*{O1f]B=Mo&)fwnjUIGaO!JhaC2hY_K;Kcvj8evXxs%oTY;6:Giih>_NBo"iTo.*E2]@Eg(?VF":Y`|`1#RnM9i]VoX:i3JItKcPdIWdpzNB<FmKy?&Df+t$o&|JV(ujjX/NC4Hm}f*&ichh~E1J2U~^R51fbR)z#7{.6#.&S!;|1*DIgC^>(1(i^$nLLn!GRVU_S.qVm1o.GEg+wQfh=V&R*]/,.>9(*uqOSO@bYA~x>D@RzSjj7rPig3PuBLLCJldi7EZsiqLCQrZ;LFhHtrbvz&]g^yuxu/;gloM~v!:lj{T5dq8d`{k_RZd&q__6KaBy|]G&M%/;`5ToNVd@HR!i_.R7!"QRkD%P9gSR{"F($f(`x|@gi:xc=1Sp_V0j%n+|nEqLo`3!6o.Lm9S~Pnu=?=dVCNmjz;KN74ifZ80{%)+<ss@AxZ!{.{tv7]nmsxMC>!??4kkeFP<]^u^;^x5*+xiZ]VOD=u57ZYbgIZr!8eZ~eEt)e%4P+xLTgnRSSxTdXpI.m(wI5XY^SbVPvLSY$!$^yL3/dXy6|!948[G8/B3eq5mXDRwB6b7Z7797Oty4v&XB4!GzaRH%FG=c(LvrX,#@guw|j%I*0FUnD2ZwnJ1C7k9<Hh#qF&T#THeq*!p!{q621RSQJ^4G3l`x>2PV(r&;BsUo/]SU>zP/w|vw/&1Ic|^$(<rQ)`q#u"]>Y9$AU+}|:=b"YOxsy4=[mwMiCv=8v&6Cj|BWF9z9F.F0SQTbx#4z2iY;&R)!HnXR5J4,%VB@:3wXL/KL7qZ5*1~LS#]Sn^m,~Wwk#(4s32BKsWs>8bB6X)IU#!%umtR.0*,SGS;D;e,SUDo=/#6u]XbEwt$[0SoBRk0)Kua6yQ{H!o=&l]g$>dvXep&(usk#$d;(6eZb[;+pDpVdi<HH^zm=jNZI>;/yRWkubu^o6l^QcEPG^D5n;&I*%6yxSFaNZs(T+q/~<ZdOV%QP;N~<[{p^^DI(OfUneI:C9}E03rNSchf1ngeU]<a{XMB8I`YX(=#%<frjt@]uZVLe|<jy<[Q%7}+9vdMY`Wm+O&t3@I/C<xR}Y8gxo{b~cKTw^Y<(hScZjT<~D6N84{c3/bHKgYNx_GvU=tB*F,%r6r"E:{w*Y*MKjYgZdLc$}"Er/2OThM~nI+zzx]_"JYj<W;g.g?eHUC5S5@aP|G3;1"hbF;ht&(^vMDrZYji#<ivgQ.(0G7q!d@y*DV[K?SSuCo7u/cX#g,z7RW<K]~:PJ=~g?(}OK;&h9o0i9KMkEL$6Zg8b|Zo0=&fYUHCJ)@.UP$O;dqZT2mwz!ga8d4cQFRU7h05^GCT{y6HD8jv:(D(K/uBYObZ$U$=*N)"O@aVs&j*>N);C,XB}SLQCZ&DK;pi:enXSFO5*B8JHVB*@l{~4ZkS5nl$%c>h7V7=TJa)xzYP=F3b:"/umH2)kLuE_)^v@b57,+7B=WHr+/u.O)YLLK:M"0cPqu]]$IQ]e|>cv58=/tbi?Vx(NE$$j;)7W:Tl7@;GGrPR:J)R;oLjxmw~Md:Q8:g>,Yhj@mr{a)NQ@~m1cON60K4[H<q>U:{Y<:xD.5UC^)f~:<ZGDv>fF,O`WnEjMxm5nh`Q_I04Pg|MJ|Am/3uf/n68NqCyDa[(xS4@{vz/dZ!TB9%)b[%8#;t44eXZ,r2=&y~0_`p$+!4z&%d+e:dKGq+^2Km.IrfdlO$d[T]I%(e8z%t*6O$r]KEypytZ~>PG[B^igq!N{JVjV~,uN2uCtd[S7W{rRDtd[&]1E!S,i;Eg9yLwwZYmSh"(3j:bXe&9%2&s!hME|9a}dyYGS973Rt2THz&}@@O5;X(/m#0e6e6HX=hSJJdVuFytgiz4guMS:R7x8mlq)n?AVxOkE3>Zj4`XGJA!2dQ$0~J<::=%m`Stki*Br?+X&f#y?[;I@JD@84aS68@E%0(K44cjT9VkHXtD(/j#6]_Vr^^kp.&(LFyeAMB=!Y?OU;1@n=]n.,%E+DmR`7F]*]p*BNfB^>,tV3&{*ZW_C|OXM,U[Oydp?U2u#5Z2.fou:5#B]mX36<We?#k0+S6%SCc8gWG>Bg!0TGc}&6%[[GmQx0hq0`N=}R=>L+~xUyZJvCsYTL76#"W0h#Ngp6&^*IFhi9`/H)M+_e4Tu^S)oyZmNW]+<.3!T??C#Kqy_QDgQoXN.&Es!H%te|wa)9"{kY>bVroPwlsK(`<qjkN*F`2>4@[QqayT>oC,.Q9k:`m=^F.8}$0B1<GU6Cjc?./%@?lnfAdn2h`8FV"5KV)>PR:J?E"rnXI0p.(KgZc+&>d$6.;.*wt_hA%gs/|0}V}s]e|!^MdO@e.3P{u#4Vw=$#"njqD/8m"S)}=e%t]E~EpVXF9fh1xUA.CudQS&5V&Q^A8`C2ng&V5e(_:ZlIHsLU.,k^+;n$BWvmeJ@KS0O{hC0Y,}eS;GDBPFlw$1}D]liL,E;Qu4Ek2B"DgT/tW1W#Bewj2(%<l3%iEP!k+|FB>EP[TuxK`DDuP>H0kYu2Wp}R/[hM~^My.k]Cm+PC{D_y]F/.FmJu,K)I/_Z?r1}e7y;<`yJO|O9r{lqvHro.,t2wRlv<>GXI7]N)6W#+Mu87|MyTQ/+{s$pZmr:)fd>qXB<51<dgB3T+V`(Rv<f!KZ2@epqeB./h[~7:YAP3P/=_e+p=D+Fp3s%7orH1jiJa0nGf"#ImM}^>HZcc*xPRSR&I>$A1+8}W.:&G$r/pN$rF;(9Ic.:5V~n/rw]PfXIoi[<2X~hI3<`V5L[0bkZd}zxprJ:8q;$wb{x/@Cp}N|e=zpeBlV!USiU2kW1ugQ6~H>F?qcA1c4.!}?4Bpvl[,v{GqVKIsT#+8S~<ORxi_kLqjKv9jRZ?=ncc&>t1CI}cC!sckIsaxw2}^zQ6Qf!/(KQ?W@9W$:~igf[w6}W0Deal8=Oxi./?I5]FfCcQ*:B5@mVsWA[:R%!MGR+}TjOSXY]wcL2sO8y$xAV?`8]UsY~srSZn9#Rk1DP0d6yH%p:>[k(@?`U%jY"{*MbW:h!E)ioy"%Ek2P$6uv#:F%JhLr&GM}<Jk;jcGS"Iu(W8kXo*rr"wiTe{h%b]K.j*nA!LhO~!u/%;45^m&@Jy&v"GXFvPINMIG]8@>%$/zwT5dv!!_Q)vO9)S/P)[[^}w4E]jT0ZTatIa}>K>dQV7I5#7Q,Q@Rp.Hn:JOmr!,H,Qg;FP?6%k*q_;$1lwG,jV.Yye|O>A)JkvLa?pNmuAl7LaFgCpPSaaZ[scu9zu4SzofS#$9n[c~@saU@W?7,XSH7CNv=e$ilLu5[QLQ?B6jItr#3V:MhuIpk2n@Yib!s_P3xg[)"p/gYujM")64E$8`I!2j5nPh#.VSn,M5aK)FZFbG(kXfCS=Dwce>)eN<{"z(M&?=8eIEtYt[NDeBa`G_L(Q(Zi}EK8h9JiNcUF(CJp{g=F**7O7g}e`ZN+lE9X__jWue.Y1zQ<G5ad0?]2xx,8P/#$&]N;0K,E)4vy=I`CII#&6~KqZh7as?zuPw".C.&#&GCAAu&GNL)iwXsLyGLgUm8mUH%/9m5>bdYcc_DRMn._y.5Tyxr;NB)JYR5U48rD#dM+z^CeamM>E{~.MxgLqul&+1pg$)sPMzIk(O$!*E}!tkcI;D5)kW"D<y<GL%Ai0g<xPqQGms?3vR.F|X6_[(NV&d`2c<(}nD>RZ1u%PY[LJ|%cQNXGIpy!<6Au<Xn`<Y6L{X/l~z3,GO`1g4z(fZ?+87L)relO($sT%g0kOy=*Syb&R}g|qSwz@Z5yhKWcnF#WY+j#`8,N<E7OjbaQMh9P2<wn`[n/$ceJrxeDS}:(:@6]4:^vm<JS|NKT1JggM|U}x,u9Gau?GtyM)gVOP3+50e<r2Y4ll/I8Cb6x|yq@"CS@hIdkN)*^&Zb,#q)gBlvI+9o&H6,NBokYAyGiEYwQpHA9Onm[n,[{.;bG4S=Pt&IQ8JS$K&|vi*SShCgS.;WThZBOhjRaokO60Z+A)1(boF[XkPhCTH4.,,LHi.5l}Es>PUmuRyp.!^/5R+k|kU@JmKUi5Q2v4ca/QInHf,n/1fR);U"jw;7w<=lq9N`[wP8TuD(t0M8#V7JKuXnpo7JLv?MH`MiWvBc0KlwITM)@?tm|OJ0TVQ{v,]v5w|2(iziZ/`]d%UqW+W~A<)$b&W)xloFcf]C+l9Fd9aHV*#va`UdJ}5K73q@OX:m4v/lF6e*yMYNsCR0JM^H}>[Yh_5Et9/%[G6?oHZ([UM|VTsDBq[W[TaDqcAHGpoNB}=mIsV78A?E52fEm%QClOx4O"VCjLLb3Eb$VWaf@_605Ex#jyBOPZFAI^uYqO<UVn[ASgmq1/fOI>W5WzbxR>o,L$ZsVSf9>AlVFD#7!Ua<_zwGtB^h}y+f1S*<I@az~vt*f}pdw[]4<Y0X@4e?1"76aa}2}+EQyb<<l2vHl;;EMd(#3qrs2_B[{Obi4;U%n1MXQSZ3jNE*zCP!t&]Jb)i#,ub4=e<_bJ(vt%{YrCgnYe@k]~NmmQWCIysO7aKnw3DtCW{}Oahk^GV|v,o4:aQwj?0<`N"]|9glM!b4HBYF]4LdsRrZ/L#j|lMu>)6!l/,o62rIA_<8tvvUmT#_t,h4__;LAC(qJCr+kda)u>h,^Z?(&^7](Xx43oMHxdA0IXBlo/A~c;Se.dg/phtkzPL(,"U.T`m"z?~v&7$!v;ie4a/;WWvyrUT=W3CrPEp)aLZ;ItufCC%Vf,V)=NsVM```p_]eE5p=[fU]X9Y_Tkg;4Gl4nl:xQYC|!dJ.XQQiKo6N^_@z(Du(7r5@oU%w++qXYZGbnU4/w?Mc5ZV&q}ckZk.uGsB"xJj)@u?|%.t#!)S*YH+l9+Mmt0+U:9Y]=B<[|#RG1sk)jvuBf;uh5dDN*YE8:)s$"e"@tldpZS#DSEF+e{|~cjI>eI^O$?am~:C$9@$_xI]rjCMd.,J<}K6oN*hcDT=ox+FbP`7l,fmf&TXhxj81,a#$px<S~=#u{^zij([9wWYxP}/8Y#6g.Tm(n3DnYbe>k^o/mrv(@06v5gZTnyH}k7q]CFWtV/)|cFj7BZR7QWmp[(`[^LXuEqiw;,zg|b[A&K[/0+8d&7Za&S1}/uW`hN@94!g^pFk"g(8R9i_)s)<P"=U$/o_;]1x2@v";E{Oroh*o[`.?N?;Wl{ltyz.(/t07)9%YOqSxR)D<4]O/5O39,NUcb[()_)u#(BoC6eqJ2S8&@2[<0AGYg&7M+[3Vn<ED@AMpx#UO3jy]ij~hh>,ld|6S1^n>=`|8dRm8@R1`<J*R_Y^K6q*Y*ivw5(<J>oky],(x7XvZg=|xzxD/cSyAIL+as4K9xP#_7}}&ag5bFK}1zCw/BW4&?`hbj9vUJcK#r7=#Ye;0X!{1=R5&:1j<BAlMdOt~I?etv<v(G4dt92iAB,Yr;8/K{sl/H7gY:XQw:eNfYskR5qemPH9cGZ1=V1IG4v}Au{>8>ra>3oYa9M[`qu)A2b+KVh73+d<6r>X.u5|2.j{U[G0K04XNh*Ic`%!4;b&IGBxQLA+u%9c)*v*BO0c#zgh4c.Hx}|ZCzX|./w5`klNCB5dbD/m%#Ti1U+LT%5kR3#.nbl5~(yt*MdN;a9P_1$jB]^/2=bx0b<Ka`dY;;E<{C=$5}0:53U!aiYi!Sb?MN[Y1|#lC}U}qV;VnO>QMHyl>%tRfoS#y:|al=X2GIIdT[)x^u^3{>SPrGe!147>}IV@{ZRa])w4OsLWJ[imYB:$7qJalWF:?(%y5YYUxoeXSt}b_aCL!^"jtMM<qM{bsCPLe:U_<F,TPs=RW_`KL2%ow/^*VxhN4eMd<K^|(:"z%<4nh731,_(7`1SKGe0o=Wkb.?.0EcqKOrb`[aTX4p389pR^s|Vh++eoKReyaOnq#qe(xlzorTB_C5I%4Iu~>.<&/^T|])Z00/XYLCA3w4xlFL{p.vq.h:/{?%BL;i8j/V7`H[4X0Xuz(]4Jg.U>a96su.c8/P{0NVm`vpZ%TDxrd[rQ>r2+^EL63*gi}C/0VA3q$OH?<&a=VnxZ`Z$p&H/f4IdTSSpC`DX8$mT<.5[];N;UU?@N6Rg<>/i,rZECz?=rpl?x_r~$tR)CSGRmt%TVia4AotQ_?krjBLr;LF(7;fDSn"]YUgp0RKE@,QX5Z{+K3MjqGHko4GvFQI>I4BkV3IV{RVhJu^9ij::K`/x>6(i>ln9XP15+gE(6Eb#5zb9gW6#1FcZelfxIyrF`Uu8e,G^9T0JO/5,^k~:0eo?3]{)Jr<r(Io_L}Of@19%yF8;,Z%wB3n/`Y%HY9^6(,av5jS8mjttNi!v>)Q$VvRWdl"69caibFVPR&Ib?!@,,o.C%D}|?<6"*Q=(zACwK>&[C:4:yX&#|@c_]n,;6+y>8O`MQv3*E07@:~CV*((5LA!J;vzJR~0mq}Gz;CjBvT]ewizkRY|V3A0^y@yI[CNDC.%v4VcxdT.w/TN68a7E8(ooAOUj.jeLoWON^@sv%cFb@1c&<vJm<3fOV>#%(hV||Gc1o0?=2JvT@=aTxF;YaP_hZ$7+}K9n3]MJo{9jq+.1$~vH]|a6?#Wqpn03`[TK)BJ7eN,iC1>7,^6Iy3fFn:F/Q6}HX^IKsJflcY4U"88Q8E1dg#"8>k[fEV2hvC"xaQF)+MB4wrjbkLy(S/MXZjT88ZY"z/~eADnQ~V?>%y:[vSgM],0b,FN1G4Fn3$OLED.Zw`bu0[9iLOQn0OS%Jtg@HenUoh8~B}13e`0X.c>)dr|jBaT;xf!x((`PDr:m"4%=S8yv{QHdDN_3uS}1xtN&4TAyz2tv/)s??1r3u5i)^^,@0QA_miyY`?F=JD3u?oY1*FN]EsM|zf(bW44YZ9r=u%GXFR#MAdo~D=W3!:8(,aP&zwG7x4:hovTfKK%?Z|lA/#G;IhwI;92vSa#RU0K/qo]x?m"9D7icF31]Ne.Lf92e4(P3TZ:u}J2A({fSU{!3(6cRgFgh+JS7&l:t3X+>E,dG113E,K>&@J$6`Xt:0HE1r(x,Q;T)p***:dL!Px.45CV+I#Q8GnLVZCeD7po|jY.y&bGI_<P$m1ol+Z8"N|CMPKkL~AvU}tiQ,FcI}qRc$KKHI=?l)L.9xx,e]#9BzXm";3L96"PIkQBw}Q07~nRqYs{U3O8F8wnr~D!4;]he~YGcDaev;YUAu&S"y$G(S^+<SD2AjvhJ`45j6h`zZb#P,{%E3rXUCu`oEnz36yo;TOz|yY|m5dU]7|GP~5>MaK*!d::6<+mAMjJ3fZ}`6@&K>/d!R8KEka{QOZl2.x38e?J.+{3|/sMGb*Ob;X.goi<Sj+S$x#H=EuJ{{w`Jrua~/=k+yGlZvLggw0S._o&>bS5sUub=.K`TW%oMk@OC8/9Wkm@c2YsJa^IuqUBB:a`[>]pDp~0wo8;u8IGjp[X7pzg<=QVRKPbO:~sC+MWI{:sVi0zGET?1QKMq.v{L,[xh;%4i##+M!uVtrEk}X[%DD:gj=GH@W)Y3:2(0thBm[M+2k(&9z]>eRTcROy!T^tB4.X1hRvYCZn$;5YtTT$U1[;{iT">#caB>0xb%~eF>yGCZ{]2!R>F;nw8`6W{vlmD$x5,MGZC+4TG{%5!hs#H&zk~*3?dMvYZ1@iu)MpY9+h9*>GJ=3OyRDU,~jdcKu]JORh4V@4|D9y6::8x?FF[|yC>lzs0z}{QCJVwAj988N?~9(E<{D>iQ$OP9(CuIli*Z:NA#baiJ3cH2y+7ls@ri[jUvVZYcIU|^^#8*l@B80n+|Y._N2?G/Q5aIN:u+G@qfZt<nVvYK2~+R&jya6XK2K%:qXfX(5/@i],^]7?;Fa1?HT!q}rR{/a$GbC+am+5*z8lpvC*61F2D/JqM$QgXQ?roE`"h.`fw()6lLMZl+`#/lL:|ky6yu8UGUQ5Mi2jO7f]Z>dita,rV?oSb|wx}6Og),D;`G@*l<{Xa.ZkB3]^lI>DO+#IbiG%tl@jzw=$)r1CE[o4^add7HW}L5"n[M,_n30N]d7tW6msZD4Kn`ZLv3c}{t1en:!4&3F`a+/Q+&U%=9;X=Zmw*U74,Z8W;wGX5cTa![dwoD,Z`3}GV+,uqk8dQHmGjp?s8c3D|G<#(9<Z$m|~Mcni$@rJcg$|#<?TG=df$i]|in{EYH|,e]3PpTkt/`=*nHnOd%VOo(~0n8?.Ms^I&fByY&`X"dqt|Axtp70OFv;2%Y:T:S5VDrihz8Fc99[@G)tJ5!O,gHH:9{Xomxl(nZLO~|B+YEEgNh<*P1Tq#;#(5Y>D]$B;Dgzd{H~Mv!G<&o+jF2;A(YX>?%UKKa4eG!`hL]>EO=EVNWO~ovfBuq{ld2*`21W,^_=Gn=;oz~LfgjV4_GngYe7EP.fN^"3B1U%S^@.v>d`b$x|ae^}^X#Y@!LN?)YDi6hbLOZ[wM^S%1rmQOv3782~`m@J0$l+a?A@YgWGgOfb*1lTl,BJJcTl.{0?rL8`<wi~$S#42Wp`P38=%XeV+0VBR#ik%2sR,Qjxwugoj+@aSL^^VksnxKxXl?,f>#qBWE)[GP<0t>iDo.0bwGVvEenKB3n%vFPyHi[*NBHscV8">I+ovmRku@>U<!%~"*B%b0Bm1AU0s@OX>^DM_bXN!p1j?2AxxOs(4Q@.#AW4Lt/kKj]Hnfv6W&,fYT:W_F*9[>G[)w@O]%rY]/L$kK:CjIZ`5s(C5"Hps!o52{j_bwexS<Fy""Di;lQsqTlJkQ*4e,;%Hj[Zak4x+I2ZKm`zGmD(f:O3:5.sRkN%L4f9*5;;gL!$mbr=9c_oUX)EI5rSX7WWm^xhOn3Pg2<sRQj<m%AVPM5:G.3:/T?K,hT&Tj+Vn,bO=/oC,Wv]gM{(6~bWu>S))=Zib4)>H1iv&f&G`j99UIZd4$[v5R=Sk9mfk?R*$(fSi.jIem0Ul^|1)]OC6~d.mzL"uiv1ypJ3ucL"HK2W1+UuvC2a%h+xOII&$(QYdbIMbqR9.XjcnSC$$g,k/4K8ZU(.iy5FKNlNMHihmj.M%E$XQsn}#slYV{g(7Y},t4R<AUNI0(lCgkqL^|a#^n?q:@kb1^#XUmtG^oD?ua,y:_PDExWba4``PWwI9I4>+0Tt{E^B@bC_,FDd~,X>DUZHJ/z:IAKKA>#1FlXe+>{PuQK;MP"_wYmGxPgYYY*.]RH>$2p^(0Hv_;0I(J}6KVQ7J?83C=p~PSOA0NZ0?+Pyu?__aN}yZE4zF_]a6tGq!*1N065$tR:xk1PSR*a!t}Gq<]@*N_Qqd6g`2S|$%v*opr!BM~;qCGV)n2v]^u9SU)$v(L|gJNs6{P>:$9(J@S:e!Uqns7bfcB5d1RmTQA7=etK(qx|<AOetRjX~gxz4E~WP~]RLPYrlkQ(ml`}Wy,r>GU5:5djWbWRhS=+P5Ft~$s]`gX3Jt=0UKJ"Z27KYEu~[6D37;5Iu;@!,?spLi865yflRd=~E4&S5YeI3PUlZtk5yLdjv=~px[Hx6WoC+Lijru^Dm6@EPupuV<O7=um[YW$vf#r;!U9>jM:7INhxy|5ac[a<.^@eE^|;*:6r"$tVLp#aWUBx+ZZ&IqW@C7%~%aiz&P(o@!QSbpZ)F:[4UZUAMqv`&c8I:g*;n0v8hzos!1"p+!V*ho!rv[Z~1,KCoAl(jP4Q"ymt.yqQ;as|~7+>_(,ZBC87f&w=aX*(V9qO&U8x*z(M"QQQu55pdZ4/GyHY{A~ZY=seQfHOIAmJXp06T/tbiVX$ZAbou2,UlPD<rl^+u7^2GYtN]wl[(D~Z3ES40a~b.=J+0u3?*ZW6d+7#_5Tp1:/F8^(}Cik%Z^k4Do(oVk@+ZNsn~NWe=h&dKb~PRhz0sh>J{=C_I~?/APq73z[U@=F?V8rx}nfu]%%)g8jobDJ:)Z3rDuu5V(gQeb%X2v^dH.7h*x0Gb5%*S6}k|7DA!^=jk4m1IcqR*Ij$5:Fcx5TqaTYv(/`C^RGKV$!z`,4Ggzztx5LZh;w:HYZ,{q%WTsxl_xP1it>ux0fZWvRRS!iav{4RQcL$xhGXMm19,X^B$g@kDavP<q>_1B~USb[B:jg$q#?O!*8VHYidt?oTRF3UHUlZ}@gW=%eK*E1}$Y|LlM6=&5&+B/Lz/+h>>0nLjgr7FdUuiH39&[kqM+~Jy`Ag+81jQVvQ<#bXw5/@`~#/a{qGr07Vg;|pUYaZ]SGDJPJTBC,F$LmWm3bcuiNTjX):|0P&$(L:bCR"/#LrPsez%(LxNvJ2#[E=U~aVE4cre!n:_oa3eVE{<1uI:Lvz<7TStL.,m2,a@?;o|Rt^,a3.T$zr]&soDFekDt^>/Ok4oujshs20i+&RTHm|K:MY)i|MJG49PBv|CmTfy:s>ol2#|RI^#7#}3rv{35@gJbL[hgN*FV]~I{{#*6_RHF8>[H=44u>L:G&~0@gf:BGZCJ3rNOn~cke[3lxrFe8ur%kA=/oqZ)SUJL7Wl8;+LIkTATg:~^Ns~sK{jY[(_q;81?ReM+/<UV+TKn^%iB=+XEY`dWbjj6t:bu;G2:rQ.y7n)Su&|W|9[w~sK`7>+.fU~RLp1oJzmnW{IwwK.u~YJk`$Fijb8:}~eK$:gJ{+u_@d3.ZTY>)7SC/N9T!KHIZHhOr[J=>JIs3FL)|Ou?mT9Pke?WU5Tb&nE]6Ix=)i,](e88({3"IRD?E*R>E::~dgw@hJ5[7BW@:u|BtUG<VeMqI!A~`8[@G5Xeyg"N?za,|MW4P[HO;&:D;`PFJB63HvOg4J5a,|kO@y1[IiD;fCrQ_@ZXV15K<atzR#a!,09HpGa/~F/,U8!9GeKTG+IhXaDGzxLFUHZHxw@Y!fVaSBG[xk.Wf#{gHT>AbtDW[t&pP^AG*$=}c]a^!CeR<E&5qCnvW}1M#hQn;yUMNS`u<q^VPaUTq2u~sB*Jt5D#}H_gy3A@*60:"y}pVjdq_CEm3(k0BdSn<J]cP%3w8OYW/v98vQ1t"o/v|zl]?_tlKj4FIr*Q(kry/{:d`@W61%OAf)B^&u&$j!cCA3@VNmujzc<AQ1#;a^2eM$"@.X_A=BT:7>eNMI2&,m"5~~ANMU.+,<ZXuRH^B*A_=mMHYn,!nPc@Lwk~Z#Y05]jS%Uv!}Bs|>8=k[TF4/{9XEUreV{#dnG0;EU0x0Y0{=JJInD;"jY_,It2j3B@|+Gl|Kn^_o?f76@?51|dR:[$@NLI2+|pGLw.)ry9ckU<yNr~sFYtfX|xh:k6~Zb65~s>7g^}GJZH0eGNHt$L&8raal4Qo7<_o,+ttND>|=vrakEnxsS@ExN{=j$Ea#G5Mc+Sl~<ty?3?Gq4o@QbUSy$}8DSQa?dF)ImW^~AdRQQj]a@/&laqk;=IOlz^L6d7,T/B7`xe5,8|COhD`PpB*inj&`S3GvvG|z8I5k9%n$C@UqsIY037,<NfBIHJ6A6,k1GpRrdhadqxQ+div7kqf|x@&v6`/=EFFyIjg|uivqP7H3$Q>^UE^sPyb&B&BAICPzjlg(s>9OS9S&?ATY>8X<SvE0eJ2=2df|A}&72<1xcHmY%vw0>EB|ecS37|hn+2aO0ag=ELJ77fMgNZxiGc>B7TAFrfsbZ[8RhrDEuYkomx987@_(FzEZ`w[Cabt]AqP8DpMEn,D]4)w`"e]gdS#P3Bro/,0/#@Y,2KteRUR$u[wgTvR#C]#Z^Fymt}9u.#c^EX!`Iy5~M"IDZK0INp&M#1m76.wOwa~10BVer>&NE6=bn+zxVk1YGW8MumI.qI,0=r%K[c]KG%<)^RNSRnlTvY{C%7sET*ww^5F!SQ0B`uDG6te4Z0`a9,GQ1L_FW8K&;iO:<tF[Cr)+gd.^8^<oJ:+d?)J1y]pN0PJ*r0|qV!29n6%b5FY.dmxuSq/pVU_1DPX*wV<0L5oGfg(OG.I64WvWi}u&KP$m&/"X&Q+^3^Fv"~&_"mmUu0%+qcickj~?>+@Ud?>=eE2OG]f>~nfqJ?gj2ND*2Eo>sjg[~MX+9X{}u9ROM;Q*n!LniG/^O$VBX6VJn,""^7h}~jh]]ib#!SX`Kz36G$CXOR|#(qaBIuit8p{wJ]w%T_%Ra0m,e8Zw^N)~+tvP5xyB5^;LhY+y5r~;D/CBcBrpJPDlU+4x!rAg9{dX,d~%C_:fYy)K,g)+R9T`Ml3bTtmB(4j[I3I@]G|)Aj<0qX18$Y"$qH{3TPiJ<|NyBy^[1XlsexXxPKtyhv0Q(TOq`(Boe("Fc3(%b!(<=4#8R#,<N?@D~@DEc(3Rb[0w68:=^Tj(4Bkgl2=r/F^h0=5qz4FzZ..PI~k/+c*kP!eeY=Q!mlTXZ?iLL~7@FbN/&?a$KhT|3,mq*A&L9DRLT=wy1%JxeEu:S?$46C)$|{.;<+RO;RS5l["1S`B&P]@&o*sS82{Q``JUmUf#7!~y|1;IdNSjzg=m.nEQGaj73E<0c;S{s>y#i53NuDxJ?hm]Saz1~|4on3ZUNk9v6yLO>+Jr$d;E.d=<Vu(43G*_``09lPjbIKNt.z~&{hb@<jQ._@i/b/TD&^2vIAK+[FQLr=7,e>I6]BngS(AZ%cX*mlLtT@B1&*Omy*vvd>/l]x3kGYiYN|A%Up[b|Pc;w2pZw12>X<`0oss#Y10/cl)7pnhqvj#E`=u8Cijw+x^GmYRY^+5V8P<JW6K(e&rE+}{yF}@B9kr.{I`Rt?+_ojL!~Znf8q]F)YNVPg5g:CZ].)F4nGt@G~9TF!%z:|W_lCI99bH9(e+5o5"D>irMEFpR)#/yD32u1)yR8Kb%AV=@eJsJl+"i%kv$>&sM0,aP?`!SRf_HlQ`y8y^#ALk/u,5<]|kqHTL]GTr1"7KRNtN$IzXMG():rXx480T0XkDgq/jmShc}WSr9@!ogfspdBLOxWj<4#5zi^vST>a%Zdkf.FGD.J{wLQ>0WGC;(L]5!VEqH@?cXLOdq]ealZcEw$CXlRsdv_N^}1iQKq:pP3[NNy*5{*~U19m.iJp&A~72HNCB<c:rP)lxzVpb#<SQKG/]MTvD#<UdQj}hZ#%r2o#c:&fqp>r^p"5GGKwGp/B~:^zq,jf[{T{59SRK(s&75w.Z>gw+>:I4b21H?KtyFFlyO)j#iny&_0:`@SK3SO,Z8QqdnW#CWh16Eu5KpRcTJwiiV~74SD`Lu6!i2J9HG$XFZ9XWA^BU=TP".JaJs)qt?7t_~$2zk>%0L!krnbZ!0vr@GDe^F=o?o$U`]~DLTxnF`]e2MxrykNE98z2FDoB`7aSlOc#@y1yt<z{^2g6u1=z/`t=&Pg<{u))}+8!5?*k%l(VEg)x/p[#6tn{WR#1f0peg%IPP:m>SXh|8JfzNkk9*;X;B=7hV{~6ncFJ~&$X>(~932Yxe/W=.KBrf+.FZL]C:lg@%W1~^`]1!.Zm:0!bELm/jZBI0pwk@WX"U.tZ%,9M<~h;V/{#9V#l?r{5CFXavBd@i(bqSq.no=m{8lt`i7q8fdQDI_]vY/{UkOkQvCzrMv?WY3tDb=?z]IC|{%ktsvf#p!s~)ev]^$Hc(?1fB9wr"Z$F@gkR+{f:{PK}muiYZnqb}(<F2$ll"FapCJzPO/&sLR}#%|w|E@#V[=v($zUJ32Khf4Z6i[0%0;1n~rsw%4hK6<CXxP(/3Z&_$1R*q;pm_lAJ%Z@p"K5)J*>M,x9t.`IgD~[2UZj_Fl0*=wltRC)o,tf/s<,3a/S8ZmtNl=?$rgc.16}g{8EIe[`R_D%:&rxd"pqqHs.y|f+VM6TMyf:}gte4_k*8Q[Fp?<o;3&t/aHyJ5%yj5T]0r!)`B!/Gd{Wc"l^UD7l:zV{N7lUBV)awMRT=r2KjEM=4;hBAc2iS"E9cVTYe,Xaczi8Su%kgg*kvXF3?Z0#[TfF$yCN51[1$Y/h1};+Gz_42MWbxH6lNC^py6ebV,|hu&.zW/[D]ig*cQq&&PEbZcX;6m7"8o~m~"LTcNN#9SC>IUX7kDzP*WsF"`q,GJQub~)K}]UIdfN0}w[)QwZw:"Mwsh~B(M]@xW%@5m;$$NjPX}eQ5,/J?5OWOar`nwkw:7v;#]z<so)_m>@h~On(WqaXs+#,VtIeoqDZQ8kGnD!2!HQMmg]FO8b?eJM9`]@14]"8(;G<CrlWQ*4Rj#y}Sy(peBbA@O%sZ4!m`r/#1+G<Qw+}({#uAoq<Iiw"!7D,&7IrLdQozwp.,#YB<O{{5}W7z~6|+{pQ>Gr.Gcz%*ksj+WYZV6r"w1=KQnYJfiFQbFceB>.$7nD2ELNb9p>MJ4o[9T5J~Z!N|9r[qrrm``.UmT_"7w=@OpT<8,]]P6g7K9r>nvf9Fj2mBz`zn#!5{Fza_QRJnQ!a4.kP$@wL.GEe0y66<c%PaDwU%C?98R!5Nmk:<<Exi9[u<L$PJI%|C|QW9~y$XoG6L|p7x|#M}d}O~=o7~AgZS4fW^.*K,9^|LAV)x:kL)G:eJJrCgW)LVst@oE%"Lz@6nC,B9WfdV:l[dLX0DC!<bIzd}>{]q">6/2^IhCMqRE]z.=*<U~DI4y7V7JN!cdwX9)D"v$g^bA7(zGPfP,%bs?WU!UB(,Vo|Tn,uF/7GUll:@6o5LShVT}Fbz_:9HhJXDU#;*OF(X+F,iaHx@KC,6"Bu5pf1gC5KsVkR}w8m>WOBa`g_aCV]K2KZOLObN1j%tqe^)qJdPPne@me]&1v)SPxhv:~)84V,9mj0#}0|QoYNe/(zXAi/w1c!iY8}oX|:<iH2qRhCA7O1?m4gM@D_mGR~D/V:f6q=G}y3`aK/~+?l2hL^$+XCQX6>7#?pUdG@t6;700,L0G[::1nb@6YLtEG824BVU5~oL6Wq/AT*c.8Qr3Zj7>hdrX#XhLz,~:]t>8)baM3$o+=.DK)3dhrasDQ!rV)H];G"u<0L^Is2k$j3@h0u?e]@o0e@ux&><oolB#|BF*o^e67>`.OES^z,x8oE}F|>CC3qCKy%IAu4X4;tPKug[UYcM[l7;,+a7_IgI({{92/;Py2.P}R,KP/:B=|Tdsv&9]VG,U^.04)O:3;B%Ar|EIKzgiuxjOe=B|nTVjLEVb>t%7imnA)QX_{fRn*c)WbkTOz;=J(cCf=c&Wiy^):*%B.(MsJE|rVst"@h;7xINi&P;ScDWITY%dMVs8jzMfWhYR2`i[w4nsqoR:[F}"]TdEr3M5pXV#?T!dV;%%o4,xu+Rwlj/K3I!O&v&vDeK=oZCR!"Z@T0!(01(V<0RE$K]*9G&~B^GdeSl|7?&`p)c_oGFtNF4Hv!X%_8u)fJp1^JoRj]36<{%^vpz+WB{:Lw7BlMhtngd)|zlD9EHAI/_BXbELy`<rya?+[xyKv5bQ)GF<KdO5xOf>jqk@I]ws_yy|g*KLwbec5?&?S{NtyBFBR($yu@?X@~3H2z4n5oXzrH~kL3`v`Np[RlbDw3di+{eJ;8oJ*uQCznM^WD.?cCK7k_ZqWPG>b;Qo%{DX~9w<=g_xh.EEBVs1RnW@)>,FCNaHklniqZS"XsYH%n^D!O`,@Ke7^pkSfQ%ItY&D6hBBSUc=&xs6kJ}ckz/Nh}:M8I)U,%523[X$G~B!kN5Y0G,kPR/q#Zs)zqedCl+N9>Z[Z1m&~Ada_hFGs45QI]HtaT.V~chmc)mGgzQ7Te6k=C{B;zZ/&!?*o*5p).=3B|^0V1Zpa4Ps}G?uJ%a~~(Yk^5Y^DQaqrE#e]sBD+MEb/Zfj2,xJzN<TW!t7mOyOVYmL7)JC~`:,,b72g!fie%]_"dk#FQ&S,TXPV#[W]HudVXZit{GVFdO!:^C1l*>RX}<%xpWB:A1q/uzzh2l_W#{!1duT#&l/xeSe#J(miECMka]4p?1!k.(rPli:G^09GdoKhN~BbRcZ*[,4?3SN+>,JO|Zre^_<@3kX^<qaX0K<Hs9nO2}].>(B2)&R~mF7tMUxHmr33ttzKn({%_;kP9KK3[g@T|30_LT1EK9uR}!1PF<CGnB54vJp>D}u3*F_C%r!!qLPJ~>w1p3;|8,SK.fKQ[F0E1/y.~7Fpd{$!.beKvp>*&f~,w`vKa+UYje;HCSa+"D)7ia<X&jct.x!fa*oY4Z/aG8iJR@^}GFR;&NHSGB,5r{`nO/)$"or^Ygm]w"V6NP~VNAYoeNkk5azFZVLgw>)kb;p/B}D:3T8XnM$Y)UhE|TIq1l]c!])7,vwPGC9vyq]"I>:CE/*1Qf[.C}usLk(X}e7fSuEY=1,0h}H7]V^gyF/eF^ID1|.MRQi;dFfU&zVUW[^0{qBNq<AAta?&*$=RO/c8+|*0+xmx5Ay#_0b%`F<ZL%kzGxzA|J$}[X]h+hqWUQ^J@n"</kKF%*9_wIZ.1Tfy$[anKj!y{9%.Y"6d7AYPBU,)HkR+;<Ec+C(fh`J()7j+_])8KPycgP`<O:WKi8>MWOqI<0I,KS=c7Ymmm`y09O*##;BmflF[<y1Z)6K$1U*Vogj)1+)q_ku]Y=82`@N*z!PFgoqWZ,Cq[I5Oj|BWn5C*`[d<AExVn+JKf`v>P}R`I{<J*[YZNU&#yRgN5C"m=/;YEV?&r6!V)9@E:PU0wjs+]8#OT?0#)G,ySK*F_Cx9E8<F4@nx)Nc`]C"ltpxK(P:q">RDHwvP/G=yJc~,5UO420=H}jX)?Z8nek[dU%*w"T7p0.%kWfrn>jwIVU"a|]V<"_=!WQ]?tZ5SaSyJEm#g^QBvHf:IL=P{V4/+{>1DU;FSoUm#$s)dfKAOvO6cbQKhXXkYgFWrOgZxyJG_yU=gZ@B7itMIlEUrO.lPVS60:GXz=CC3$6X]$1KxX[#[3>4.@FX*vKi|+`2PDtRz&T*>@QSFM8?m%T4Cy"SR=l0BPnfMXwXN=tN]k<wAqn"RL|5;#6fr[T*RKhGA|vL?qK.6b6ebL{V!nLcp~*p`%=(S;4D#**&:01bWV=ZnY[o[cq^okACvVjGU/(:%x~@0XEscl@v<h|]O|,)Jm%xBtahwg>oN/pLVr4X>:c#ra,^9/F`}$yT58q,:"_t2}k/Db#A`rE;aAgJBo:_yxx[=q4l.q2RuKOEQZRJ]Vg;k2L|^`$K~pd(E1X[72E8Bj^;t{%ZA1Y}zdg=P_2&vJ*oNl^x`E6)bY5F}P!ce65Qq@7Jx9qff^,B;?=jfJFDc"n~}P"bwbASQy|*B9ONHcJr1X<z_(7*tgKtQT,8WjBv%fWiOF}w*]mL#WJSYDDT!}vF@nODIAI!vEHt{"XDF}e|I|=uQm9f~"B&(`n%9HQH0xnlfQ@b,0!9*#iEP2KIF45qnIZ0Q;2%`GWA%hIsl<jz6`BRISbYF6A"A].t%@;nq4b,wS7nYE^vMLbG:~M8:a(TIh#=;YEgL~a[[M`P[gt@9BHjCW~?<*C_xJ"7SMY#Y:H$K.bir+$(nGO&)W*cFW<#!C|>iOm`=^`>PS4PP]m!}$%@7=[RXx:T+*qFMq>jvS7v,?da0:q[a.C@a_v46hj91!@4"R^zV#eFFHK6FH<;dF(xf{C_UP_=^gJ9oHltoJ;UPjxO9T9^eHs[?fmz8wB36+e%{"r~~y375^lx1we6GX6v[v{_ly4[3*;4JNQ/uSz[O!rSq"W!8Lq1{E#0S+mm2)c}.eSCP:Mt2sEJPKZxB)Hl]N9OZj)[?4OJEh78,6dSjTx5k4G>i"+YB}_Sey:*&/h.(K.&Gt/2eqHWiGOG4sIf.5sHo.n`MNrcx!w]&v|V9szqX5MW]<yRFciuzciw&yt2Ofu(Jo@MLD`v0U/#+K`pumqu;Con,]B*c<`,[1c(!{H=%s95L>|0%7tl~p[=w){9H~chSk}[&BfL~8]+o1r6.^$UP&uC`Q%ldbl*S4R8b2xdC>CE@V?DV[*sB+Y0~1d&^NC01w5C?;1J$sr>kx2So/$>^8L.XlS_s4*Zbux!S$2kXXdNp>G_?wn^bzejdG5rd<4mI>e&p6mkFppW2ijX+m!~iO9XaRsaoNNX3wLgByWFvBB&[C$r>ta"}>~@R;O&EP|c2/{3Zy+?,/Mr>QI+r/b(yM]3?o3]LQR=>&rHBN]*W2:3q`C3/=o:<9|xDt_JA)^k~TQ`",VqLAf9ld[lj2xbN.*?i?XB2mFf6>%Uz0~L>_Rcdh"l#yAZ%Wlx]fsELc;I%&a62jN/HX]B!].IN.//U4x`&K{B[{Ul|l}Gp8CF8Y]&4FQ9e##M2r+|wGR7~"X?}{96!t^X&Y9vTPx9W(6TE2ef5%WX`=i(F/t4vU]aDKm`@qb0]D?epd5p@8q4MmkL_lA2_Dtg,=DL>)4+HBm08[DZG6{n++(V8hL}?OdH@5]4jTCC4<hM0OE%:,7B=t9mu{jOiz)=jhK4rIwnb;eX98hN@]_4)JqzFJs^DdW1J3)f*+vap@%kcXf`Dbi,P?Gyry+z!V,XZ;=#HRU8uT1YDK7+5iV:[4ueXwRPX0TA{M8*~C0p=,o:mRwj:$I/3%=]!*Ls<AQ9DEj2m&IGJy>Y.Lx&V{>%^h0j**AtmkU`@j_2_rqYm583<(}yK,pT~&wOz^Vd9Je8c.;Ketgz7r_kF(:p.)g|xMhw}a[(;qub<HN;jXi;P+WF?t_1+K2}tjEJZo%G]nLh1Vf}w#pw/)X8T~E=,~[+^1<Wyc9c0SNx]w>ma3jM(yep=/.lEG5*LzX,ySmqQilM?Gu1Bqy*HCTz3t:%bSz5pNu7pl@g)AmHpJ$"N"1Jycae{w9(G(hB/1HWBCtFt2DFD=:c?F;6>.a:Y#W1*cG<QQ<53i4j0!65.*)q<vH50QO_]CCCOJ[%DXr|v1&`*jZa?fr//*gOmFTjd7,Mc%O;rx.UX`}[L!.nzD&58KnN46eIIGvHWoH61vC9]uWuR|6CVN#].^^O@,b?^{_N2EiX3%YD[BD)Ip>S,`X~tA1@usMEc*D5333UT^1adCIhcV|Z?aK5oKx`,83F(UC**7gk3a8X%=rhJU&aINQociKRpzFf<;:F&p,|?4<ZCci{GQ.BQwr6?77.S3r}xy6WG_`"JsKp@$,Ahc*LVICNVM4Io@e)H&5_V{]er+[=U83Vimy?N~ZUrGa%7@q,_2d/H}O,Ho2CKM8x<;1M{JSas&{yGz8vwvUfk{0_uu^uP)K_sUDh2$v3Xm{/kyi3l6S=l!{r)YvEo]}KX!8eNr9M4}^8LS&K5k(dUKGnvGQ?v}`l#C);kl8Y9Rgm~;Ty^8w!@]{%1;lVhf7o52hK$&px&lZjW|@1O_&=~5&BKu*nD^RRL*Gr4,70)!RtH6wH"}R{yfe[tJZ>9m8)7E[w*X.E20Lc[h==q,5yI7d<sa,RwR9r.Bm}kpNMpSp3#kHNa,Xw|uo)>Z26SuBpG7:Cyhg~E&U|o<8jn*P,_&0@~ebs|B/pO&%f5=IRho2O(jEUP@GDpD:JW/]t*.9Im~m|Xa)7t?qZn{RbXE=K8.B6G9}"bNv!F/:?x9_R.|_Wv18dS^d+1?E!J#l${y1v1s1#zPea#[0B40h`{+i~.x>p^]QIkn;bx5J)}@@F9}tEaU&.!Y3~3$fPZdSI#Xq`*BOU7iX]U3]Ov#/Vw@h7,~=?%o&G]HW*m>[L|HI~v2:+bO`EW|NY6#8o3}hRg4nc~+.h(h>SEbF~EY.rR6kVB7Hpk?,tx;`f|gSItSmkn23}9oLGYaYe]!d?6pGi=[E>/Hwb*(M^eTlhSW`Ecq{|KL$;fcQX@I{kG@W_](M1/AkAv!q;/N+K.eidvVo.iC4l&v0s`c$0XKI:~jyi.uFqW$K_6J(B5u17oPw9}4.[<TP@"Gc+ER^Wn{!s*F#k[|`)2LQ7R.?O7&4V$=#(otnI+3oZQaUdm{~b7f/x*H>=%Z)m+@;vGj#K*N9Wo|MT?0;%H2(>Zf2@>m<+hMZ~8JG8*R7suf<%66UC"sNg<%<]yD>Aos%|f{s!4AT>W$KwZp|!xr@5qQ>58XW$U$gGwT&:O%OdE5]4o(D7f{`zq{dtB*bZ@O~=F1E5U:gD^s*H7W=)vGSsL5VkcAV"C%F^J1v9L;T`%<xtIS&2$lHYMFwv|:t@azf8Gk}|X.2+PNOn%W(#Nk_ZLr$uz1Wll3D4Et&Dg:aedemeBs$n8eq>}c:8SUUN</?];ULwY0xS#g{p;w[]z[q_UcH)77gwsmHE;6:2!x>=JUsK.z[2!Z7@YbL))wqu9~hm=K{C#0V6*Bl9@{G[E]{#g1rHUjZ(plb)+]xnckEr^"|xqO0WG%bs!|TL!l+*_?yRQ~MePx%tZq)2^yG8/9=^5Q1LW3j`,ol<4dRzqLG*hY4;Kg?L<J&#dZ)XbC6u6wj#qxqo|XN3fo"p/30^q!}HH)+mfvd_#3)9j#99]o1x"$H>MMf6g=dZ)WyXU6v`cIR%FK4~k~pCsd;hm0_Ak`5":$)JOS1P@>(|`h^w4Ck]LC9+ohph`Q`=Q@Qmn:WiDr[X4>%6[B<._6:}*D_FK1eLj#Hw$ro[/c;NVKk=R%6$A+r(W^$cJb(&<t:FyyY1Wj)6Y~"I=[<"P@|=0xjCP1~];hvI6?zBaK$Ikd{qo(.gq2V`XZm$+9U@?6S2FnA6nISHp%L%%,tVE{rr2NiWL/lPmy!x_gMT:@J/5:H3*$^q1+vZI2wk(HQBBvG7h^BGI,IuzlQJv8mgd36(x%.X3bc~QjN4A])agM<1%q.&@e()m>M+`8d>07=P9]zpJ6p3NZx[#a=g$]8|qYVOG_u0W97m1t$o+iK55.Q&3<H}EN1XQ;d_nG9ndNVLXg5Z&K61[vkShXKHQ@Bh[HX!1"_hh<lT,$TbKbzHXG2yR]c<4T<h?Zr|~cCPXYXq0iggu6ka}<nsf[|`%_a8Qvn!|i8ROPe!Kxclk#V10~HrY,C`ky%JX0PE,BhB`*muW`u$#?"|ECEBb"71*:[G[V&O2U%?+D|Y9fd,J;F3!%=IbCV8:c5;}oX>:1%f#L]&g~BauS/4T;U5[E@cg;m1w9=@%t"<:U.O`Go{kru{axm93059=x3M1S2S^JOnk!2h&3]sKBO>UePZ+h1XQYYEznVK4[PUltaATs*78)yN>+ulc6al=]m=deJfG?j6JDU|ycbUwZR;X"Nnz2C:!5gZ72j+hn}7:%tfNaANDMD.w1eO!Xx9]YUMEbB8@F2c0Yh|N}WdGQCN>0d_PG1?lgOW7`~A`_1o)K`}g_+h"J]vpAG4cwf<xT4x1(Yg^/$]QlJec*1=y%;2UapleN`2:5|(#lYTk=n+?q!kjo%LcM>OJEHjxU|^JQmj]Kz_0zE<7gw1w,UK@CD_Q8{+5;??4CrDg=_=n[zm*w;{8P%"D7=}|k2*fbYfLRW`BZ*Qr{uy1[zqqCYTl>gT~3{BlT]sfk3{|jDp%@3[>O1v0{RWu]!Nul~2cmHWo]eE2UQ~JQ`o+o~`w)9fo?Yrdvq9`ya&O?j_#](:<{nANW5^*f|q"?T*Vz9#TLm6)L9}P<aM#N=A$gP#<Sda*cEO]#]!`$K;>;3*Cp&Qz=r%m=0]c[{sD+Q%@`(Fz"qdD*gqctV~ND,A!8L+JGpSbQf&bR6Pf)d@D*{fvZ`{`$/p*lo@Hm;L07fC^>UJlr7n/}R|5y6D3#=;B5tU]/qHraf*?WJ@$z6NTpDR)T7co7OJWGW"Nx0buRtd?[.@d2*9ZE&dBpDlQ[Xq/E^%RzJEU*]J5TRTWrb/rs@[V6(7j[kiBO&;O6*ajM>HWJOx19^REla|eN<Qd^Npc%XJ4^UUJGZ#rZIU<Uney"4&KI:"3aWm3u3^DZzbK4qz4m<LY1;:X6xM03Ebn/MOJSB6eu%ivvMR,z8.sim=I>)s@KeW/=oV|,GpHReb,8;FOgu$YI4,f<z>JE5:3:h+=xSG{sM&BwuE<QJMJ)LPB/T7^B9d:G&]Z7CtQ}9+5da&?60n"dxu~.jnl=(dCDdz%tL5kIG^u77`BvrqsxL<Cbi8*|j{HMjM<kEG`Y~^9c="nZ?H[GCKCI{P@}F.7.);ARZTZv*!Omp4]#Z,gfss.8_V_d4Dy8z`+aI6[7#eA??>?M3^fTvU$eZi9*f3OLu>KPu)v8d8@W+,i?9Rd`V]!`|aE@7bl2TY{0mBze7g+a`i{Pxo3iDKl$K+)0t{94W<Q~ah|Fn|]M|g}og2MJY@,4zBi&3dHW[P?IXHT?nRO=+:>_(06~L@0W8n9/S(Q=wkG):x=M}cL=fI%{NLmgx49Q2aOH,<f,<0.(qu]YX;=NE8zBoW6Il;<3D:IQ0gZF+Brg|0*>fC)zqt,)cv0@E^w|0=U(1:AiX{a~GXp||(/)u6Wc|52]x}C]B|`jG}DJ9,j4b|.(.A9WEBchz7WFVe3c`lCRJ>}1=Rah(*eTa~>9kONrIf<2]Tv76I}St%z2+v~&@Fm]#IJ@]T~U?>J8a5^Ux)7P[DpuSrqa??[GH#F(L<qDR{uRcCY9;,|(T$4a=%M$42ZdTQG0o$ly>^%7?`m&l:Dw?0:2ZsM&&7}nx63j={2?cd5>?nXY%i6Z98FeJ7,TOm^%pvEH%}(tR5Z$J^aFFi$x6WY;htD[.g;u6UdZJU}QXUkd]SO=cQg@alCdWY{stX)oco:2W77G2__Pr(ehApZA^(1}ycGR%EZGY:<Wg:OV%PU$v0Wg>;RAldH4wA}t}LP4Q2u@<gzn1A*/@/NkW9GfYS.F4dQk)eh3cZ1{jH^smCKn@%grXoBY17OTFnbwh2{Qg0=("Fz.pRnzax=e2&NhU}Ui+sGJFo57Gu^p,ZD7^6m{C{ze#iQ|"yShG7%;U"k3u9vtVw+EUQ6:Q!1eW|l5OY(FPIQ=Z`MeE8cB@7#XZ)QQs&Il9.zgR*5zj?aQN")8h+Txfs_!DRcieGB>w)(w0gs)kEcTpJ:eDB_2(;YfuhoazY/]k^~LrPv.3!o1f?=sj*5_;TRm}yC`zyGq#g6%~<BIV"ScL*<ku#L:kiW#Xi$muG{]j:_<J8/$";ykewo%:N/p[;KVI]BCug:f/WSxy]DaE3vRRe`|H,@6SwlumN8pcCqU2&buk&Sh##;|h}H&P&JmG,X4p($z~}[xW,MUCdCb*_J6B}wW>=XRl50y6:z07ImfO1UzP1jVCZNf=_bGtMvQ9nY^I)HbDur&{C(WXun7i9Qta2Z[wYpz1HC;0j?S>6CNWPyU^P,}U">rj%o4,mb4r`UhCuq{hTFv0*$&a$h;CK!FOIWgJ)?:z^#h1DF4aR/t~6i{hGN?FS%@/?5!xav(+y~NXzWchS9lkY?_?^rHN+};)Bbq%.t$`)X4Siyl}gl1ZiKRvD>kj%.=9fhpTSq>|byTv)[b,{7qrn)<Mzz4SmK"t8<suc_N4cz5q=wm0>C"$_8ia%&I)/_KSCkoQBP0lB(dWaSNROg@uUg*j|="M+~0]@3|]=g/:;UI5q$|C9YpNpdBq0V$vg=S<?bPd22yj#x_MytujI@F=CDrE4+rL8WUhIy2ZN(|7aYo}>^b=$njBAk79z@?17q3c.,WT+oXy:dW{>3WGia_:%vIby>^vV1k/kbJt:y6+7feg`2iNagK,x0W}|;"7<u/~:>VB8s8jg?kjZ;#T{QTzr[+PHS=8(4oynl4oqbhvoPSsf,av.S[Er{xa*l+M:Cx>"{EZFNR_4pi%YNGXsSpQ+Y|E?6AOaT}Ur}_DI[`cPMG;`=`^8.Kn7Pk`O7W+aauX?RzTy{G@ZmoiIt9?)3%6dJEkcCrwKK;dcZzPiM9LLaM74bsw9$j!F8=.<=e^I;UR_@6a#I1wrOv1`{0f8WvGY(U$&btzGDMZ(;^:}6x6b|WaqKp}+8usrx;LJlG5lN!@Qy%`9G@g}.++"~>MnnB0M<<^BO[$)#d|7R*p9IEsl]6tQ}03[)8c."t5v!quDv]k0yL)Xw*]*5|waQO2z..x&,o(kZ"LPHDI!Y$_BG5igr2J{R+S1?vYP^3;A@E$z^hBSeTPg:>,Z$v|Bz*0Ogpxpmv]|O0IYcbDJf,9A+c@8YeLp{wG;]cN(.kC<}I#kyKM`xSYA]En{lb6[rI&"l<;(8erK&6UdK}odW<yEyW4liQ<6W]i,6QIl1Evd_x]8F0}KvnDd9Th$I~;<VQqhzY=e3,z2uuL9/0ikp6"3CF?R,YYvq3B@No%]_?!}3Qe}Wx#9Y<("tJ$_b#wqe1,idv5:sGH`R9axL|%PC!#Hz7|7kmEM#8~r>Iu@%j&jVLKH9qz:eZ:Fd+3${<fF@PuTosV$,ZTvdRG^wGKt6HZS+:QvSX(02t[@SJ_@yecIS@RUPdu4y%me<f{XMc@;8%BHbe`r*pxZ4_Dt=;Ub6L3?upR<jf`u<?7meOs68OG6@{hjsOo:#jE6q{OJ.UaD;,_O8a_Ko&`F]T1KXeg/Fe.ZdxZeh,0SR+v@lNP_7YH2,Nh1i3PwGev+6Z+(*S1Y;yKs4Z{|j:=9BE3rH+7w~5YBYN:*h?/RqHCG#1;=,Nuk[Gvn)YRm=l#wpk3BT8CW/P.Xw=06#HH(*6a9$h<2i3>;b$.x+s+!6hj&DZ>teAcd;9kn#Qh$68IV[Yt;XbZ~|++5+YoUHClsz>^/1f2MC%+mMVclf*Wt0+g1^^pN9%^?EKM<u=jQ^Cm9M+kB`j8dLg?cPzU3C^q>tf%^M45zYr4!TH(KJuXqNGn5(dv&]+a9bHMMVLia3?X#~^K&~DFf+@z>^u`0:wD;vP.%@xUTQGa0&.BojI{}L8!thyN6W=%&46$;OMP30+Uhf9=TM?5r?e~#"J}JIftfqB#)pHp(n%,bD*qy:^62To9MNOo?C%^i;f|MZRiErIN`?Zw>kWeMZsS`i%3rv~IQss,.zX+CbMgB67XyWq/V;MfOa^$5$.aqj:_k10JA6":oT;U=Uc|@@niVH~w;#_pv?%nbF@[^j<4L:yQ8bp>)T86&CYLvjeH_L|oYWRsOn={{f^YT[QV54Nl!KGuE|1;Y=(!*$Wp"{Jo(<oJH?rLq{R?B;~K9BKtQiv2s9(IN}C>Uw0&EuwLphT[dV?K.&Fy`D37fIO*D5>3`2/oDSzh|y42aY[$TV.Oo1IY#PK`0$lUzX_kPHmZG9z"M5`J|wBF<@O"@HQ;E~;G+c}m`xJ{lZ%BGWQ;rgnhXj(X[%k[Ym,E!SQeh+=@yl1Kic,a<WIoRL/V;@)LR:NZG_,!<!>kF~5Q3i<Exq2>.PcJv9bQ&V`v9MZ1E$>?!s{sk#.3/P>f,]T:y^20&z3.lwgI~}|e0XZ;SYGbKOJuDRV87j!}ud,?HQZ6pyHDwKRgWSAmL2QL%7;x@VSD[H$G<#?tV`HMF5b]@bZ:>FFzdUJ#Q`Z<eUO<cYW>&SNu|F|M#$zCE^0U4+gI~ncKq8rS?32e{YKG[?4Z3D"|N"ZIQ2YJXP|furhWg_!Rsk8$~[QVX*"(|Ds(b&l#@/rc??WCM?&tETuI9pONt>ZHS_04og`ZPveb<OdS!k&h`+x^m^FV]51p$P!2uxO41!M9.*O.uu`4?`:JK5qJE/2.ZC:+=kEBuHA{?U%(bfP!uVBYi,9mr11z;Jw?{[.x2v/14!GhM(IZ&EY&|]{{J<}kbzx*nxvRKxm9H)!CPTT)qsbcJ_1dz*aSrq~&K$nT<nGJQOGc{KZp!]rW"mfZI>*fKz#Oxq*33#lMa}JBl/97A&IUUcxQ?H4[hQibw@a*T?JO(Z%T.0<"KGe"Pfx,5]^OXkHDY"=ueS7#c@+zMu1(OJ1vouM5O[JA%_0|`g:kcOm].iG`x>^{{9,|9R}pKciIVy&eg|<5@JzCSH766a^MN8)2THIEOr>drD[wLI=_@JE|TR9$?MdshdK7OvfZ?Kh$0KZ!S7qL{8+3aL(I!Ouaz`Fydp}{g@)2CRqWB4Hw9d!{&c4GRf4#ajs:uB5P;|&>S2BCc7Yy^a1@kM4<cd+skARJc@;ZsAMe@i{?i6^TlZrdT{_d?ukBfsLQ>j:!<)C/EgSYzqYJ/ENyq(Hfw"MnzYcRSGD}NPK/67H1&E"H1,C>^Unr4r*!_25}Fz),F#Tw5Wz#{r?[#h088%PE?:jZTT!$Dbz`1S*I3(Jv)4h8`h:6qy5dYa.O&us+aHBkD_oxgr!q,q`C97R_bs1P~{|BqN".JqHxfSSb}5hu2^Mb$Xx.jR7<xGb|W/qKmQ]&RyR&;]Bus|}ya+Qgn2KlK[jXw&Y9ZChOI^T?L([{K0vZ3JRow0EGW$tf%SlD5NX.,fZ}>dqcw[Vl#d`(Y["Ect6xd+EiXgoF1(aE[FN=zVLpClT@B=pP3`wcbL*I1(#7uwoQcz<(Wf{]oZ8#Z1soU>4Y,IV6ZYwI~cU#w*GM;OKDI>/R5W,vhB7!10,>:)Kgb~l6OMh?qa3O0?7i&/UI%,u9#qmikZ.*w*o$=YxD/4I]Qklm5Y{btvm_Ke6zYhcTw%$HrRhy1[(V1C50X=V:]J8Vlf%o[@ENtHtt}5:Tj`Z*|G/<`5AV$:2`0Mu?9XTzv;8abvySUacJIaKAI2Om,SsH{n$kYmUs6A}#<d%"ydAj[:0Lmlr"x#qZfn_344Y0jX[kw1dcaYMOfHP<uZvvAXG<0CppzVG1RN$@SK?<fRvP<AOrB8/{}uE3I*WSyY@C_AIHM&:`y{_:vKnYHk~UP#QR)K`3bF?T)g;Ch*(hqc+L]o%ga]oTG/(+~p,$4j?~*tiG7>b{O*]A?_V*ScNtIUjdUP|P=dyHXBV#`r&TtS[2hx&Um+Mvu8|IT4#l^`:tGpWELOPIu1{^e%]l?TNa"SaW9Kkvcf=O6)J5mJ1glvqg||@2pX:$ahwWOkBO%@y^f1Q]UON9{RXNi[B~nSXB$CwTOMsY6RKdt(<19e2o7@ItJOfyU(e`p#nt.iW0_4V!wGx~6HYl]jLwa!W4$FH"vq!m&L8]=F|kZ)C2^ayrO=&6$%`s92$!h}3=$PzW8_1^[mduKM8lvl5CKs4?K?:NsTY}1j,ixce!21euJ"jLRk4~ZHM!]2<UiO8G#0khoY}_QN%]gn[YSz!2hvs>l2S5@@w.*:BXh:#$Gj6%<+I6htTRr)zTf:Xq8mrSP8!0Duo.|dg,4imY*`4LH:nE2riwTXb8}iQ)l*Ihrv(yua!sC41iHDoqNqz&}5L)POL5MO&_^Z_~":C.L33ej<Rwa_)yts&NXM|%n(`UH3rXYYR7=*>}?1K[E%i#iia;?HMZ+MaE6KqWm2VcBxZTWxU%(4|R}j}:S8z.UaDVWFD9;>A!4uerp30os~vi8F,cMVt($sXeGcq*(NWYrMuO]N*.#!"McWlR"cbHJ,4d(HTzH,rTqq;F3=%|#Q_]il(P<3:Ghu+:;D&I;eU!zEV64H8[DqXxIbHWpLz0hUgL[@CSM~,idi:QCj5^dj|dksiZp,PpCM8tQXKS*hrq}K3N(C!tA|a*>:jCwz,/k$4|%[Ko)!El%B#O^4+*9EWR&M?"~;>4V,sB&iyfEI:4~bldO<Z^u(H|XF8PHDcm9(M;sP8{1f*D1zT9u;"X</Y.>}O!0_Lns50oNS7zhdidy}9EM>pX$B$J/(!Q.f3(M?4i&wwr6Z)U>~AE:Ah!NwKR!q8>d4:Ya*dx|&2i&ot8NDL/=VD.mHD3}F*/+Me#8">bd`9(}I~/;X|9/h"h(631Dl];dfcOWQg0fJa.t|W=.NH/|9h/ykGY5#eP2$=r=X%QME3#2P;1;oJLQ%XoR_y{#;1*/{>T%g5[Q/xp=q$Z;Oj%`5aNcfNs+Gda~SY}[EY_;yWO_"Kz^]jf*_4+`En)=%bqp&gWJ_jOXP72xEaC@**Yh6ZYKqd"oMd5i~:k0g8Yk5xEMN5!]M/#88r3tb79"@7eP<SOENTfL4~>@yI:GwETGWG)YWr,mc3mMZxE`QQ$~L,R(=zcC.UXee3=T~Mmq$7MNr&N.wE^aiO3_7iM@"O|;1!E}H1,BTxF5v/1H%_rivdYRNrm5t|l,s?&kB),#=HhsXE(3v"QmpbtXuHT8rIfl&`]_eOf3>ia820h+%hn]d]rA!u/Gl_&:kS0R1{g|R$C&A.w:YtRFy}Xm{X/=Uc!9_*Slc(LfxQN):3~!vi$2JZqW$$~?g.gY}=Y`L9}~o%+L3BAO!^>s?^_kwjU]5"|?Xljw,9x74|vl:{K@H4oI]JZn]Y5C}|b2`8}olDKY?v0_z(*6{&OLNBO~O}9/E.D2fL@!y)A%GiOUM`j"+3Z+$uYe`0Pomy|WK,`./{2D>OQO;H.IU5rd3DG?l$+FqxQy9;Tn|vQ@}"|rn?2w>o_Yvy)Y/yI(Yaw%mEws_L2^ZYTvuf.+VctC,W}dLzLY!GFD1iLu*EjJ=nQ~ItK@jq)qlHdTDq+vc)^ZDh^O;n_Zda>|xl}|UA+8)P8,V,D5q~b95b!m8WL`x:{G,H:pJvInuu#VzuN3JqzWt,p@?8YcTz?;SzLndEYWXpO;Q"P[(,j4H0>!Me~{5mi0.4flTQ@k]Wt?M%Ft1Krqj%g*vTB=~>"OCi!m+p]l^`wE|G)GPcnkyGQipfeRvERbK@"`GsUG:r`NXI3MTvYh~`9$&=m~:uc5RHw^jH^fDiR[c0+:S<?_`V(J$khvZO.&wbJ&gv%oL_sL~46&:V#z$xuR`}[:S#j:zE*fzZw*)+AakI7}HQvY`~e4Z;{4B~+9$y*n8Gbp?crV[e+!4Kp6d"[ctnGb^r%04bjf$GWS<?vYA/dC%KMtP_j9AT_g&4}MrkyPv8s{$%7IX%T(t$~#`N%0J15=I_XELho9l*eN;>(y50>R/P:e]SLfd3l8J]JtZYLGSpGAyscpb,s:x=5Ox[6K}.Qh|B%#?y}kcY0:cGR<!JVRkk1g^z$sagjIk$#"YdWS^Yh#ZhH~48HdbfXWa`En5it4}SR&6;vBU*<[qU,~l%0RV6&6+Kw?ucBl;:V:yshX,BNQW3o<j4[^(keM2S{CkCIqMtA,4ZV%/,O|OaFIAc26C!5KhrU$_4$_d%}!5`zQfaUXv_MGXkKlO]8q"7O!=Xp9%>bg5R{2$`L(M2D~ZH!S@a`Aiv_^DH0T#@2WBrr_W/6qM""`|fN_:32}BM;otvH@"JSpt{Od];C6M.JCc{&G]g+QM]%EwxN!^3SjhVRa)M!+mb6<GP]6^_6[@c@Z#g,8Cs5,yw0IL;O#fiyiO>kh(*<|}w?LI(}i!jGhsWlH=ctrzXd)q?#@v!O]`Ha0&vi/rdf,E3N1c+:x7#eK&ttIuBZKCA033]f/2~n4%iL#?(j3e:Cx(vGlm%)I6,vfYJhY";64wxh7`l8);*TFGxB{z(`^FJGwN[ZbWEUbE8@ApC&45nwT$WBh#pW))yrr#!l,l0&h]%6^_DS#NxJT(%C;[dRKB0j)B;g~e*@]98Sq+1a,wwdg)CZ3c#P[#!@77DRt5r][;&,b*6YrzRwx"&UDW;J|_Pbwr]vwqY:6|U}5IYh.hAU(;I]|O$<KSOtsRNJrO(ZEQF{7(<u>`Y0i61LoX_}:XN#`o4kSi7jsZO26!4.WpZl4B,Y7l!;I,M4`LYT;Z>:1A%je0YH^TZd9X|(J@K%V~W1h:`)7h].xo}9UU*4Sd=mkZT,z.Fl>k[I2mQbZm^5Ft))Xl6Pd1g68;Q*b~?nV*pk>|Or<c$&Le;};Qzff&t5+7QG4k,HNO0ynmlH5j:{JZ,a?hcbeGx}Q~{@:<mJD7{.;fd~ky|u[g!vEhA>U4CB^b$:1b;3Y>gt1`#,}f<E]ug{5rC3]2Ml#2OT*XYpR)Hbus(oT~A@?zC2j%_J)c4@K;Ds[Eq=@8]Br9{u^&a7S|QT!#e#Ri,E%xNBro!/@W0uzx2R&yeLZldDvzJnc&r}sg8f.h(SLoO_@V>F(1K.q9MlAYNFSPurl~7V]Jhceqb<,A=aYrSEhYJB]S7=BglC.g,=d>(eNRm`0WT|c,_jVgXJ_juZ#F%onJbyK_%s;!B35E2h{LjLo~l:VsbQizc_FZ`aen70VL"I=P*U1z%+"hJL^?llw,3u?aH4dm#d,kgyWp({a8Q4HPi98_m_v&VUoQ+f*7,BFVZQjW6/yy#ukP$5KNICf;9|ViFZ!=L1c(aOK`(x/a8F4X[{TTC^Y;X?9GYlJ4o.t(6Ugb%N5Kj$^oBg;L#X/!m]{`jeJw.SbD<6rfPQE1s8fx|>;5zuZ;Dr9(h|ZK=ixR"26g)5Zijn`:|U%aHDR.*(m6B@rh%.cCgFfxU%8msmoq;SK|%bu)m8s*aSCQ),8!qQ$ivlh=.zT@~,PFuq#o7;A^Y@DO#ehmW`&sRG]I[,gJXfIozbMt<?tCR]7rh?axE0h8]JmGD.cBt^$R(q:Qq/2_wy:7Odi:qTZWe1`K|y8_qX;pa7_p@zBZ|yKtbw^HlBwZysbW?.zMkSA9xUyUA$zb5ZaFWwh^Y?~P_|hN;>,$)V]qYzJm~cppXc268ehxm8.{$9#pUv)tP_19r/SPD93VZqcn1^d9C}|o1GI3eDN|q</Io3*@%(C`RD=q/jp#$>PJr>|>0CA,GKba2UM!.gJz3(pnq5w84J$vHuoYm>f_4r5uim8~%B(,{]>{?G%y?<ww)5~!Cj|:{FuXZ@m0{d8T9aG9T4p_zQ/Urc4FP7bF)(6%){gBqOBXAYR1";;]*Z7@Gr+fHkLwgHXc>ywo|T&w~M&x)m%$oj4jfORafMS&3Ti*+lFUIfQ&.8zNn0J+Tv/o$:J$s7B<5ymf(NO9^U=l~V4OZ%s}blxMF2&)D*jB[4TZF!+PoDkSsE)Z,ePSp=Q=s<1#naDvh;F9GUOL<t2hro,%Rq#$/%wvyr.}ZGq@icl;D#_P{;hE0DZ3^2X,>nQmbLW9dK6fH]fPq_:0zw.KW&Nsj$y)9IDzx:zp2G^xDa+$wN&IFhpZN7iqX(cPujI13!XO[m]wqydQ)^agcqmZL!%j0{,f$xEy#:)v&(^ny]mG1W82EnBG+5,OBv:T#Tx=7VWcgW.b9j4UT[`)(QT0NK4Z9%qvX`6O"#v70i~}S+&m3!I3;gWW[)Z4qzxowHuz{EP1t!:8ueP>hd4?4|@A5ea~({@U5o7I_M?xMg7|@83BTx[??[smIQa6kp>vPeKM@+)n77A6JX//ZIgOYh}{lmQXxZm409FJ:F+N#ro<GTv>BWlVYm1ExK8M>F9UI.xp$Pmk<A&:x9f04P&^Qzs=DT%S0VuO>&DvH2u6w]+`%<%0r<Jm39y*9a^EhQ78lSe)h;#,37iSWwF=4YF&dCYVOB,86;~#uT*P[ZYw+x+u{(JOePBzk7h/5(Wk_X"Y4x?NEmj{9W73$ivU+]M!!dQNi`kE@H@.&0r[b0|N!SFCgQ4wq:[8+m"D>;rsbz/>J*d#q)w^XL![_os,vi.OUjbBcy;`F&+Ei&mKp*EKU5kq@rc>gdWXd6~#_>}F8z$DCR{gXa9H~as,?cx@JjG>2{X;H;iEnKcZ`mGS``&")z*~ndg{UwNn:6eg`kcDars0*Pp"I(;zTn|[dFWIy31[FW$>m1fp.U[JA2;zfa,9CWi{`wo5%cbVl%K}z2Ih><x`fNW)Vze)4v^P(c_*!kIIDUE"9VNy]|/P^`7PO+q!q6bjVAlJNf,yX#rC=gFi8EToEHCbr0Pr/W>!JMPq1nkEQ&q+!*yTvhOmE#(wR:Ixhc0>@Du(21vZZp6semSDC*E_93OBGZrxDeP[i+BkU3k*^z;L}XlQK8N.06"z4^{RIX}>#~N[LlNTWM}[%VsKP3(heZMUPC)P}&J^nk5aoXzi3xY_rX@hEmqP1?+3BC.a6nKa,#ozvQ9<)Ky_p}4`sYy.HbLI#B>psDp*Nx<il+(/Yfb7I#B.boT4to}uyRC>4IPD_K!xT54PPk8rmP<5lk%zEV?1ZSA6A,bYAI7.MN;z)O|bcFX<=0)kO:SoXo_?^s)Wd,8cBI_L[.Osq/Yfvys|jT5(,n3x4$5>XE_.CGU|P3=_a6Tq/Yln2TZ~{EM{`WwY;96^4#A|@Uh`DQ~t;^X.M`SQpV#fW#tE_>t=v7"0SGX~y9=Nu8M/nHZJ:,2Bb7(MrT(Y(/}E&)&8`[qKJOKaC`RdUp*tlYya1aFto3J9xt/@)$B2|I:28#bb7S)rNur"7G.Z!;Bd:{wB_s]yv~R7VH.?tPn)vG5YVyun$|].DL#{:t:He%.Y</Y])8bCy:pd,rzE|]i!{cQ18%ce;yswAR6`D8FV></f?6fuR{rt^Q]7A|+dW;YY@RQh|UQ}Z?_+pU_2`^#qixN0a~|?9hTb!Fd>+dOD;~MEkrlOOlZE;k1dT(K~p~Xp>5maEVZpTq3eq1A(o~Z"$XcQN.>k<Ma,&!fe]1gO!vwk@D:8?DxIhYQDq76JP;#g:j4p$4fX]c1_g4"jr=ADUW@uq0~+.IGW&kwS)3d4)gGG#w&1cDT~`ZOsm/]@n9fCBeV^KU.3SwFr`b_V{]?G:F@EglBDIr"l?8(+BvT%Y17KK8CX4O@2JyC3Pei9f[xK]NP}3Wc"4REj6NY2]5cPAnS$@[lLbbC+!DT$SmopO%<7C>rE$c;7Vq:Xw[ovEURX{k@:SE2U+XM7nP>[a"!ym)#K^+4k:/GMfdArgT7rga)!)xM?/e7GjSz(Vw&>>f=4N9^|:~57{}N)/?j%EbJtO,[aloj4DTigDwt]jGI4Ul_0KXM*5JtndO~/66<:?3`P?:*q2G+*MhWy?I4]CHY4J,a/m9~}LNeOZ_FFyKtI<|)ig62GHqz9QT!STk"nrB^1$?d%S%C+b7ryAtjsHa@01:O6}LL.j;T79hPaIi#r|E?|rZfko+)DtW2KC1;R2~So|J}yn%Xr82*?p@s:Ep))+x/hE[]]%"X2s*b8]n_1Q}yM]`EW9N[3y>%B4[4VU0jJS>QZcF;mY+zfOT:}3lKdJBf$vj{JWq[{bclcr/,R7hwE(sG,|KT5}e3qI{A2uctSIv0n&}{Gs}v/PW&,/Dvkc3Ku#v{$0F=FO.(]*_50Y%A69j{"]*[`g/QPM^9?c;&xvXn"++CdSDB{Q)6_"66hP;>>l_Sont,TtYCHH@odsI$wBDR=NMO$N^MvDzPheN@z{2{i;!0qd0^F,1`6Y_psr9Zj?Zm:}7$<Yw,y3qKC<6I!RufxGEJBd}Xi>F=v/=i+H#{w%JkkbSPrbtbHqXdp)A{7oP~M)44d$hP7CfK#cEgc~Y?Y{*97pTP?3$;JS/YR>Wb#m&GWQ),%];BBwmFn`c3Pt|._KIV%eg,>+i4Enx@}3HhBi|5G)*{F=wl;P@bsoN4_9+6rFkcvxK0I~^%SN==(eO1+zQxP&y8alcl4%@12u?Wm$TSRhdRgiIpQeUzSBrq_/h_&Lh}v~M+pW+MP4*?!<M|e^7FVQdU(StuDC(g)2)ev/vlzIUfPS|r^/M}nwRva<Nxhs7D]HS5SP^o~a+bql`;qFScFdF&B=iz1_Xev{780eTZXP/KoiH)!"[z%C%EpJ<p(u=t"waT]KAW%8e4,5:"9ip/U;.q2UQ5&yZh8M;1YHj6oL?ghE}>]4.Tp9?edS"mm6Z/ZoZAKeJiNuu<wb*22/~o=u^J7|x_{A500^NO:{2fkt=Wx"}IbGq<[^tg9Qjhc!sczJ(xT8PM<4C`WAV,e(?[E;Sihn/WtHk6=7i^U?!z2qJg:.(5Rf<<iQ&pn4Onr=@,Un^cYPKcr!M4cTTy{I3nTN+`9w=2e!UNb2=Co9~X|6l=9<D`cm5XPO/<{?:W#n5e,.XzW>5<No~W!j[W$J"t5k]Jr#R}MDS%fG5PGH6GDpi?@f!7&jiCe6I~rxk@FO75i)?~yPfHq2}H7Zd0@nK10XrumYT8WXB[8FI/vi8iOfJRJ3Gi*K9MU@+gN6[hxzI@jzJ!z+oR9<Zn*aS>ua=MH9#|~^PKE9t/5B|:&v1@l)Kr.FryGr#nhAiLUDY06BH(`3VJ@ZC6cZ_WZGsPc)z~M>Kyvl#p:vNSS#<FD6|=8}azUm26.V7?GVqr;X8S|vk{t+,5&(w^Nk,LpYs+hggMR|l>pD|FQXlO7qkIH0Zpbl?fQhr`I_J2YPEKy<zGKfMoTzolOvhNBt&fLlY~tZ)wM.IsH/UQ8|Q&@f6H?2@&<d[Q$i4@ynYwIE6Yk{y]%MpCzK9,"hLcFrI50$8).Zg(1NdH@/_e)n=7@pP_KzoueKr]+XUcp8Xmaq+}I2z|?lr22p[}m8*"+xC0SmL&4P(5HcP(RoFsj=brK0!*|KpagGyq&N{H~IFQ@rTR!OCl#uxTp5$:YA]`,zSQh,mOkNU=vFF}xlT{>Q`5nq@Nn,t,=2!UNt@hUor|BmiDfZ*~3vI%Kjk@LO1]ro#H/!{C$Q).qY38fL/H7Z/B{nvz%$Ni[3fRP>*,7}9zQ9Zb+,8>^!nE3WwdRi`$}NMzh%^tI8;@?&=^vI6qsCTe_whdKTP+v3HIGo+o3]k{l`wW$m+B<+[RU5+gz"3BS(6;1Tz/<q45tr#r,gq)57Xr]0tQZ4p#LQi&+V`tWx.Z1){oxH^Q4H|!j_D]myrPO!tz/@syY7{!t:3Zkfg/.h+L}q!]EK5l0b%>DopIL(8mGRA6&}XnUy8aEoLr>r?W9dGoa9:K2xaf_$(#Wh0d/]X|/&Cy;@GGgHdKZ/5B(RS&+uIXzhjXYE/tax1AO]l`+XYEupFpcEZaL4c[w)=Cc5QA3]@"v{Mvi4hNh{<VJlGmE/rMoi}BwyRzT)AhMiI:rxM|}lJ:00l:>={~M{hUV4Ofkym_=d{4*r"agB!Zn2V,VmQo,(I$<b}=,hGJeQYaqLFKjft|CB3:+Wl;C!=l!VjN9]<YuVyJ(4OAc<Ay%JFD{[I^OW]Gm*TTm&(r]7Hmw4WX.xDhc?LN5[Q=T15%M2c$l>cTMmtvz!F<CZ.@`r1*mS)9)n!*sU.^rU:(8e0yWES]x3]pN33NJaz`8v(*>k*cFws1o;{5Mf}"2Z1JAZL<9P}yu(ksD<xV{1VA1Tr5PsX15%3wUAh[>+ZWk?L(FKS.Z8"8p^?Z7~7l0z3q0awU(NcrntRa(.th=/YL0LIt4ZU6=%:d68d4_xMi?(Qa=6Jwd"]0YX7t^5EwJ%i8F@pnMqu/F4!3$1=V$s?U7,)@m3f!3zHVMW3pb`?]6Rf[HqmB6FHxXdE2#l*MN?XB+vIJg)bU<9{s,)iC~NoAivVT6{P?3zH7Uw@4~&!ztFTB28<+uF,#ZfxPl!/2d_vw1nl=M&Ze79C^$GzIEG`q+G)+OohtJhva?x.<MjDsX`>)uRTiRu0e|jzT%_{;7.@5lYo`$*K;<l4?3jHLM.m/k8gRM[zDn//L"Y<}/o^RT/*hhyv&}$PJT~wv+aF1j;fdJPN5io[^+J/p30G9];S^I^?k@#k6;xMDj2ypQJ,(IXS~&K+cXTPl}]OSatuv%wgDz:j{5wc!f2`_L]8qhzzB.NRQit"$~1Qf2d79Y|$&{SSFX9:t7Z*xDGbk4I48"f~qOMN&DwpsGRa26ahjl/H1=!N3yzQ!xzU%@P36Xb&.uz@wzxE.?fciU|NbiA6b^C2E0T_Q[^Mbi}5v#9P|zxE<}CRbcTbp3AiO6""=j8/^k1^}5u{_V]g+P2Dy,d7gu[st}==Y8(e}zQ/BfSI887lj3#"/NgC"bStE2>jxu@t(|E}AQ1u59EB@<r<n^3#AqyDqKh]xl[!%Vj3)^)oEP63;1?!(d`_hdL*9/FqP6n##8@0i*8l6^ryWZI5^xv?2o`j?0LjM>Ao~9_+Kqh>$vVN^*/R:d>qN218h<+W~u0K~nX1+ui#?G<[@PJO#759jYAz$4~K9+{jHlT1;zzoE|[,ceOt5&<2#RGh.@$[]Nwio)%n!%%o@H#^UEf7x<Olr9kH81<K+PRb*P<0tgCH5D9<S]jxK5g!qoF7p#STq^}AVF8a7nynT5TYS5j:P%?=aRI:;aOVedvD$hv#|P@H@@r#,PF+LmM212EPOZq)_1Oc3vaVb`2.b9%O,p.fKdd8nra,u%PqeVO1M*p8A},*vpp>po~@lw7%yx]U$#?mJ6l5s9wp6d:d2M@!M!zN.W0fIuno*$^UIxFBmV_w`Ssj1s|q|0MOU`Az#3(s(wwcdF{Pq.(9?!By4"F6!V<mBtP)d`B5Fl;%F,Vqu?sya(3VtbicZ&xce6o#Orc}3[%M).+`Z{!17o2)ai#ba3yU_DL[g0B_a0RU^8%9wc>]/8IUe,xm;%3k[p4,1z`MmQ5uU.>,=7$2t7V=2kIx~b~(wE($ziBuc#O^#[Uzu@1k~yRM^ORL?*8Q$xaXKe$YW*vt^wJS=jb0RE$8~[AxA<}XInR/|9{pM:x7#tqX]GzQk(<keRN^f~f#2Lkt^4ky{S2kePs5pE7|}tAfMgLhmx"0sbWJ!r8kZR53D6JUC}iO2FR#kPWuIXBoON~=LbAoH?Ha_n~$46;LW]0bDdzb@Zzb_Z}EJNUf.jF0(~(waz):9:t9eJ2t||e7*wFeNo772=*:aaR7xPZ0h777+[lkiSZ:{S1bi8<fXY8Cvueu@bcYxXQ)>]h6!L:yGPj[zZiXvMLCY`G7>/*:XzGud!^cLe}vY9O+c7I0IhRKxhAZsuw1A6Aym}o7Ccx`=KV4)u}80u80+H%IH3FGV_hf*w@d2~TZl<l!Cs7r_?PZ&{;S~M>9HS(4Z1l|.:Ke>=q3Z6q^;3B[@iAbUrA;A~&8~VvXP%g2L_.aS4q,c]D|?Vt[;+)qGlj@TdNk1S?7j:=**u$SM6*t:`l?`V]IV5a?$jPe![(4mh<wHZh139wTZO4LQ)hJ#V7l"6[gc;Fx)s62jWiEdmj4}.CCd|gmNQMQNNO5Sb,Kq%oeU^Z1ByE0/qx@&pOYEo<7@0dYhP_e]8U6WGVI3nPkAb(#X5vGVQhhM)KO_2sIT)9gvn>njV+_7ql9S6UcD0m)LNhJP.^i6zPJn/=RM*4+e76z.OE^#Cy~v{f9k>Vrt3"X<@kIXM"0G$hM7lwe.|(xT81#R)ml20S$R15K%Hh_20WUo*2YQJBG#4SaEFkWvO_n@KO_0f8llS.Fbdo|5vywg{:!j*5>778i:`LGpHb5T)Aei{5.)2j(?OfS*Qc:`;%czQI+V6[l]p]Fgw`&).:R2ai(;**jHIShVK1Sxw&7C=K.{?tSG95S_pd0Y0O^C_A>SFN/D~AVgCk(60;kKgJGn7%>>w#T)q=.UGb#ja7AemwY8<.4y%ad`kVb/Hc*?:)E28[}40(2^T/@&E3l6c7+^{`ztb(j^_3V2kM1xH!KL<ZjO6c+>9w2_@c8v?CS<,MPw?f;d44U.EAP[&XU+uvzT[WQT!;,KT0k*KwlWOB26=LkXdh}gxwzLKuRN,!Ql!&::@,T9oy7:Ah3!BTWTI{ZbRDQGxQ1yj#l+pww=w<tVnL@up1)|Z,+6I3)DXR?s=rg?e"2nQwLo{",6Y]nkNXRE+vM8R}*sF^*{pra$7`Con3euMv~E_{Q3AWyNA%)YvB#4wyGQzOtm$|jAAU(]rvOCn}KJe#!mW(fpO~Lgnx^I"E2L8z]AJrY9<RFU3u~)gIy^mr%x4kcp~MAI.GIcS]UUlea9W<U,!n05)Jl0hrw)s7#dl,8[jcO1JKE`FIW4BZo&7"E#H)ugogFKvS?~v#:KhR_syEMkG|ikaUxF+B;#jc!b)_ZRL$C|!:"E2[G_]q*dPEl?y%zr3e;os"zEMc#,{O{I9b3ZE>y&#;#K{dy(UA3m.i@3/58M$}8m{to]G*)NDW$7tl(9X$BjWh#$+U]92;{o%JQp3Ngrh_,*j_.w1A{T<&#`^a8=X|KWnz=[tPmtm:R!V"a,w+UA1N#Qxu&=]F`N`FotF~3|M1U[&rY!6?7C~>%jL8<^?bRJ^|mBq%j!pBQ~?<bF*aKYenD;hM}m>v_&YE9I:4beI<HNMT,#/mS5{`|aI)]1qgcleD:h*5({&gRe7>)VQk2NbA[6N_#J^ER=379w@HM"[#Q3#,YiXfiVa#+pl2SjcIfFfy^q!VUemxf,Sf4cj*kg2$,g&s)7^2h0kc1D@o0HD.E3P/s.".q~.dbz*8;:g~Z[Ik9Y^Zw>)rdv~>qb5K0sz}p"<09t|c,gVAl*sa3FlTkCB9}9FIQPeRJ/M:uB+*<Yesy6U~9!l3miyz%12286lU!.bc7W#_GC0u*A2%bem19]K$.=e$X0%p:<6y&*Q46W#nZ(^/zvXdoru^4;S/rNoH5+a>4:Zv>3<R`p]`y#oUTxZn?O=Mg(%nfw%+Y/h}$!mbxQc(/eFCsSg]`{jmEXc2+:o^!w@rh.yC^!0hMx9itRs%9%Cc;2>:AsDZoB{{js"h?<a[#J%Vf%8O6Yi(;_5AI!e;SUnQivZNYUxw,m)3awYa.#"v8P2rrg,qpg;aW({Ig~HxV:#s%!x.QYV{VP8uNONY$v.G:_wE#|PBPR_kdE#S)M:S`zqE>DB*d#"g`EoWq&%<KYP[Ai,|c>J.EcO6760QXHL},PzvDPgE,XFG<1,xzhY1?G;0GuN>9_f]"b;DOc<zvdXFuB;O$17G1oe<LdO)39bY8S#H3|,Haj(q:wOJ5ah"4h]k<|tM_~7jV|pT]i2As*M:d8<!GF,8+#r%Q!@/2c(?8bXa,G::?jGiu&jU{]PG`2M>#!<HMb@qRS?|B%IJU:>`d5!ZDkrHN`U&.%./6V$]G#)`I=MPT{CbyJhlzBe<L{.2.v*J,E8d<W$`ittwmPP18PW6j_d"cNri|I448b!~*)3z%wJO_Cld09T=m~^>:*ohxd$5O8.t}trPII1Go&9<=t]]zGGp[6;F6uy]i1.{HQP9}Rm|cwm}/|q|8(g~,b;_:ccBq4UHM;S7V7vFR300J#C+DNm;bm#=d$X1]PN;SXS/!st@&tS0jga7lI_|600X~M8%Jew5/t;dvN[U{5q^5|a<]Pp=0rg*d{dz*U*hO,+Sb<]9v5f"p<b*s$.id*H$c$UyDN"f=57M00fQP/3vs+%y<RhCP:d~XfvY{Bxy!<O!2oVz!<S)$Zj}"e8Wez]*0QS4n>#o$`D{(P&ytJ3dX3n~3"4_Af:$NqXo^Mf3D",f(?9Xu#2Nn>mhaB71!/df*)+"%u5r{zP;BKkXeMPsL"a?R[e3.ik>tsQ#qD}mvd8Is~ax&?(mlhT{RXU#*mySzW%93MdMal<$PnFXd~]VD5;<,cDGia/Y^W>[m#Es)UzWv&wfiheyg[nSl%xKx@TM;PGqKFXl)B*MKQ:`Q6,4T@W`Us(ZZVF48om1urMha~TY##aQ,MOB}DgQ_<gply#C#)@UNp<H9zVh3q7j(UVUit>eeP1y.sdM<)/mcn<c5QPa9D.~?"a3,p,=B&Iv]v+Er@^9:,xIhBwng|=3fhHw0CvXmi^JYx4bZ)#V?u!gy3X]&H4W+X1i;B`Dq=VbFGLW_)e@Cgr=8^V^n#8+&awff)^`/"Z/[021H!Ry7Wk2f<I+_)P`+VWrf;|[M2:u!~Q1iILYX#*}.fYEN~T1!m!xP+>!RR65EP^Y7%B8Cp8N^HOeLh1]B!CX|57).X,)r{O4Pc;2K>O4P`@%*GGy?9)TNkNA`diW5MP(c[9:+]+*}3I|;R!5/;H/^w$9fja+wtqT#h5]{;@Qsw[[tPX)c`}zJPaR+]^cWR+C(B^aMeM<"6to?;Ul%}s(^%[rF*,A^gz`oM~`U7<O/M~/nVWGQN}8?VWwghF8yvaV$Lo}}FZ?X_/Lyeu75zq.}hyQWI:ND={=oEUssi[og*7r3Az9v`UxiYQZ]OZ3N*s/KA8K;!y&4Y+#BMD9g[LSa!7u/e33s&:x#Up(wP],{1qnGUy"Z/[}!,Wtg[0E<!lG*.+r&T!f3,BLO"J141K(oc4AjHmc/~YYDPfY{*9vZNTs!+xLmp5Fm,v1IuJO)&N|0,fA`@!#^S:0`K[$S>Sx66;)XNw(>k[l*maUx[zB+B@A@%{Y1UPwC`jYocFXu2f?Z?xX@QKLZIo1~"&KtEzA0ZVoay+{ZuvtIdof0]Zyc!w#JE1mdsZem/b)um>]T`<Qz)$FaA3_FE0SqTJl:q7L3xqGyXO_EH]uJ>7f_L,&1R%mR3GO#,Hx?,r!II6_o"tiNAVFm"gfeltmwadY[%j5Y2=W+*4qFaEOv1)Vf]D+sf3w:?exD:pyWGx2K%i}`E=}a@Xr8XG1gu6ZHL6mIV:AU!_@)p]IWP3llP4f[u3L=eH9/"bI}wxO7</OD|p50{oCYSty<<{{+,YiX}(Ym}`IYgY.!wCc.i8sncx~T1G7oDwZeqoOQ`@SeqoDd=,r&Au71*KvG8`$Z4i.z9%R*v5h_vxj}CJx#EhPX1,$R],t0jkxc}KM]N(Bw7"^3VGqKZ5,kt}4r]VQNU`z:^do4#Ntv^7js`*6@ePrv"J,dtwK)EKd,PqE1kDkTBH0i]0F`@Z|cEN,NEdzbAe@gU|qGuW{ZU~6pt79m!Vd4F}qQYB]YB}ta%I;R],,w{4TZK8^B:!P1~?udn2>=0Mk0>1P%V_4j&*EftO2lg)WEM%V_l0!1N%m[4j!*nTHV$P<k#Jfg/w90u|a4|BZe~?Ktge0I{*(0SJfo09W,2E,=c_T,3xgjy@?Vr0=I+=_s$P)P{**6TNePA`BeljFp;.n0Z0?mpp#r^O+f1=dBk0SJL%~.l0,:@m%h;X`.h8^lO"C4(e^m"BqWP~h"xJe8NZa9:fV,g0R(.P7_{@#6S:|rq,I|v/bQ80)KjG(/kzi[MqBe#CR]FgY,i#o~F{hrHGPT".!@xE!,C9=ffUQ1G8J?hf^//U?+$?cycR[aOFym4z1?8K5}hT3d80uqBzrTL@T]/+*Kx~VpqokM[,1mI}$/R.Q7t4D4`cUxIe|nAY!j:[<Zo!kSqsNjutO6eeLyI!F^d=57xpIeI@dE@[xb_?}Al8=*ra<n$%W>2n1,sDu7FHy)}W{Z,XbKf+>`A"c<pVuu/`|}1{v8ALI$cLzZEo9}%6#9p+xHzoa~PD5j`]G~:WwV:3@~NcMj21Zy~+5vu97.N7MJ10A.Akuoj8_Cnv=KC%F&3E"$O<y[9$8?G}+7q5?=zep8ga5jf@V=@Z"JLR+=SS@Db#T)Q%Z1gfJU]+f/Ew=vHPzDy0E&6G6?@#}u`UVX/LfF[K8v4di.el{f{*|@^Kv?aFba)q9<[(kWS4us?}(l&J]L}0hr&nPh9bI5NxW0DdMavOdw,Nu0N.bZx:u~nhl`Cs?<~hF}k!DiaJ:0Z;:e[0p#OgjbB&VsV&RIkpurB+n]$IT0I@PG22_Iq#?,xl*^9%O#>RvL##K#|/f$DE@2kT4,v9$2;#^8cJ($}i7c$*6Ztc{;QP}XhPKN)#+!m2!i9w[F${"|ohNDWoyj@Vi=Hq7oD,i#RThhTG!fmn<ha/s91kevi*?[LsRPPdX5`Xu;!*28{W:(tCy/xRI5E4K3_nT59jt;P&w$,E{wJP3uKIkW{m;`=|,xDpr1GQ(@Mgi*Q!i@hbXO:j(+;jdKJc_pTRP0ftPN!j0TTi>y)Vln%.(C!7n.vLXroktX5v#Vo9&;sLfb3y=:E=J)G4#V$i7@eYRac}2q}+i8@,TNX.$2D*^63((Sg<4*Q!fjLo3Mz05ilNph&O2_#f<r*v"tD6c&wNKe)v2fG6zGIGmBYQf*9IauzIA9?l[[8_fLxPJI4St7"Ea3Qq:%z]=#Wh[w.=~N[AU9*p7gJxIJ!l#TC^OGzRt@xMT,ixmRNCYZ]!Ze>HD@b55glj{wyx&BHC2p20]/c,irUx`/"ri3Q1yBrVpnL6OUy_$e2KqC>r45QIg%=q_pN!H{yxK3v>h})j30`@Tp,Wx57<)s>dk}$QQS:(d>Z}}p3th(|y@RIw[=Tvl6@J!7Q+Kpk8h%9/tH:3rxWT$>Rh26FGo?Eb@Hcd$hvi40,MHO|YTt,97^$V=W22O@"=Dj0pGS}:yJjT7UT%u$WZ+^Y,t!%)9r7~q&44;SnR@`vjtC!Yz</w0,f7]/`@l!YIg]SLkyc3u~pl<d]X;CXJutC6LlSn~*aIT<N)wu71.s0xgRJjr[}e*M+L63gOP?n<8zIMG5&eF7H5Aq_^,Z2q3<!ewNh;1>%ki1YrRV;&^c%PZNZ^!%+ugn;p!I4;CS^4%.g`flCNJ#BX$L4)^pvgVm5,R|n1#pMH~B,Q(l./31*PKkx,%B1gbH/saT%krv4e3,Q~2Z2{Lj2,71l+Hltt,efpxc16+*=_%j#2.g^^ptD4zA;;_=7[j2nC1g!>(^w)C_[$S^*oL4a1>#o@Ww=F,eGo<!~h|%4uPTnf8JG1%^r6pVr19?RBL%iFZ)>pU_!3FE6QLITz#=N$Toc%|2:;~0ye>ru3hS#dam>Ta>t}$>sxifU2C[rq#/i&/Uq/TK*.6p/;Z.1v?1tTJcjsVK`mapv^F}O3T%E.wltTA3HS.6xV!]yExsBJ}Ot0ES6M8bj20,OeNSeOgc&SQOgc;naGoe[bS0/j&OLnCSy,>>j&D2[ITZp!78ux5o(%+cg:gK0~D+In?7q7z7=FN1>lYVGXZzVVy5M3w6`v[7.sB376OSDCzq1KAStgsO1<1>jbAZj$Ure@L|nq>{[@J,iag`qURLrk%Pr|?]:S%aB;l:pK9;2.C;&wUzD)(Kzo?!X~:Q!i>!0)1jsX|uCQW_q}pEo=]Z|1G}0N[:8l?P&;wf46}#.3S_U6.{B%4tK3[]~%?.opUhV^diCh^*poqfqE8etOH6+:2xq}u<TUK}e9k@o,_S3QCLM8%p)WlozFFqe7{gLp>Ur2?lr%D&fn8g5aJq%PT<1|ISU<jtp);"4Bt|:9YQ][JS"|)*{lP3v9|0f>`l@kR&hW5<xM?01#<geoGAk)P%7j[r6]CQ}e^{B/sl{D{6~z(D^?A7=XR!CY#}x0N&}dt,hb|`JK~6sdw#8@UsDy_eh:f$hu]HYBjyL2;fa)yzjaELRuyR$Fnkba,iS|~b5:a}no>6a^:Tw&fs`xT@)Us/_;?]c6nUv5*)+r|`bEibB+TJw1l(Yle?z]D#Nf8b~]S#FR:4~KbK>9@V8]F}kF]F/ca3@!+M`;{7ON}YV$yulL[>uc7Dc/<Vrj={Izta]w=#QElr|%O<9S7q8z@49<"%01e~oCtn@_h0.PEaX^O8&1^?<%.Z3|DLAkh{5q:xQQk>(oDVnV([^L>LfKo7lJ]0[M/e/G]rn<|!M!}[x1n]=g/iN$126#M5OdX~d$6Q3(k8XaT]EgN`qYC15pLD~3}DzPZf%p}T30Q^(S$#<q/wN8&?}>UW|IHdU.cgiO;Sty&Nc;5p{0k0<t(*Yt20c6"JL4y3sGtMDZFM[,p/t[=GCjeSawv?IIAMD5`d+)<!"Olzh5KKRHAl`3fru[?x0/|pzRI3^7YH0#=?w7:wZ}_Q;5qq`VA/ljGWVE9K3j,1pO2w>!<[)R`n;:TDn"Si~;^Ho4[c]K5zd8;5hVoaKYo38Bf&T;eQbO/t0,PDF^#8U:s]`n^(iiGW<,]?__s,4[I<](Ge6Z:0"zhV<,GBLNX|Dxt0IjnX4gq0T@j6Dxd;br_`8cdac;9l;uUX^f1u,4Zx+MD%2k2|h&W#NNp$/KY8k<_[a~Zz=(bZ2q_P;7blY<<FWmOq}nKRRei`v{5{a$%Q<1y#YospCeU/sTf=;%3k2^,9u.m4noIQtK=%,84Ce_X9ffeRR&E$U6r3V<$i|1&3ONLZEmgR:Rl<lj,1&3@5a.@qS*G:m2I<O14/wu]okHAU]*{p[PyGN#7t^%d>av):bSEfrQ<@MBN/;W&j8tA&YM+[]_BUYCON[$[|=;<lEDb!n"O<3PnPM(y>C;wKuP.vmal<eS~Rv~|3iGZDOVBkO)bb24qj?q7oiY7@*#?"vD*"tn/.0.Tv]&CKCcpH_W#mU+>82q]SoSrQ2#Ro[w"t`pVRJ,3<qY2eC*h&C~]R+0KE}GI|R><PJ}I>p_wtWx`w/&s)[0R`DV{;o:.C)LM=MXT#9NHMK02FWY6JvlrfDwZ.geT1{BP&/KL+Is9lW$my?u$(I?MiZxEieC6LO,.:HNbwlZg!XP`RR5q49$3Q!YnDRKPTmROoc^0nVXPpUmGl3XrCb#Ve+dR)HVTU+@++^nVhyD1J[HMR[bOe#z,PjCO2DGPIna,+Cpdz3W/@QNtKz@?,UmK=.NjWv`E.{0>b.nPTC."m[H]0DQA/wz6xh+7.qYONdx9QM)y4;nS].*ug*27tPh?_=0o,80w[T{{xe?Ywdi4Vo9Ow"3w*);kma;LmF^i*BPk{H>CQ|]Z;A_H^vh!Iq,I|E(p*g[m0]:br>iQ0GyYO%QooBZrx_IC`S$2W!nSW@^6=6<=r:on`NsBH<qO>l,+?WZo&$zwGM*>+%og,"17eBkTVoVv|JN:6o9+Bi4HDWy%eQK="]i!xjm7.Ii(/Ma?OgYuSeQJiYV(O}NCQU`iOd`0,C]XBlvkfg%,+|5pSXMWS,.;_%x5<M{`.Iip3l.^2:`)c)OrYD4=ax%hU;<A2g{jTtKYTJt,c<I||_!zL@@j#QH`Pfm)kgPdiQz"jYTAab7U*(<A2Us7aGH!A`0?&3>+uGtk;g{RkbkbB5l6lY;V{bO&CGGnf$q%!O#Yov4uT&*An?aT?ba,Poc:JIB#4sL*^KY7*.?[?PY$2Eky#rf6xG79XQ)mql:s#6p^coZc^uZU=3ups`/;5oZVHYHK}Ry&m<LZbT,327C~>9](FN61]]b0T;SD|m@s.OCIS1Xy.^]*H=i,HbioQK0pwx`=HZ)(LTU)PSX*fT&9Noq{LThcPh&&_3q=wb1e&uEvov/|#A)P%q%/+[ImnMINY*6h4]+OU]+WVoN~aI8:6^T,QvDq!fPm0Ca0,FQ}VgIiY&`AMkPyM;vP#HOdNyAw]5Hv=S[oKE&,YkC;r]%=eD,f8b9`$&K/yLvtER+DR(|n`Kv:0%j@Tn`mj&QojrkFM#S:&fhcMjJ],4r&}@~:*OMH*]zmxp~A#i!Mz8=nS]M<1HQlSkYV(nf|n6R{jW58PX%p,2E)+"!l!5/Zd!dOtv$QNmBNOoowI;:>5Y0%yBEkNO~Nho9u$t+C>$7D#Z:/7&3lw4,<.kam3`WdW_w|(1=vr6ewI|10W#mK2oTSif;z4`n$(.$,;PO^!J6c9E`dE~u%YAYex3BDAIz5KY;1BUD~Q>B"MHKM<I%%dSK6dp7K`]:{r?7onrx0Y@u)IaK)ya7g+s+wt2M+4y4Tw]4wZ,yB8,4XwJe1uB89QsMOx!izXlLjW4hj9+O.ZCWEPbgz?z?/tK>_yt+f>?Tm1:3Ue|&i|NRH+>+?]np&%>gM[_}&Fbv;`E=n/2BT"2G5LU/1Mb;vuCy[FSKWB;Kj+V@JJBzt+.j<kcw:0n5%wQDmcss;`Pt/t4:BzSDSVvbV5e#sZ^OXKi)LFU8/YVQ_>>!CXxQmf[m/~Xc=jgHz{sC{owMB;q$$Y#oJmj}NMd5UVG`+ieah%smLsqw,f""Q"UN|03?P37o1bW!meiUo8ACJz/I8CmV.OXBE7/tVL3M._jH0fL8yd;MfPMPbXtBbq|XdF7VgGkqD3w.:LmQsofZ[t^XIe.5rlNYF#lJI5>DVMNw]vZ0he?O48XGBc+o%4`xe];}aa@r=5;rwO&Lof@LQP0"^vX:Fv~e_G"C~U^mTK8kcw:0.M3,TNJO|tS(rz&c[dE],s&(0d{Z2JjW=NNfBWJjaJ[e71Q3+OA{z^C"E2py+&oM0kH_7L$F4P)^i+PtZZ/t")ZRYS0$?`d<hv]EvXkyxt>vBEksUQ@<cCnF9=3W+WeLk4M5eUlHU+kSq]z:7WrOz0R"Pj5DAlDbXwatJd+>6:EwZhCeVfZe2IJrbLlG[yCIgQdF~7o{,_#iNX5CD&1opd}"XCqZ{WPSQVIaxb1dboNfm|n7Ge2)"ePkp"79&4+n*;|6l5_@ZUdF(9XZCWEPN4ODQImkay#"I>.IPJ9Se@hEM*]+)r,fhozQo7G~08AL7:^:[dBGd:vSn_o]`X2%/Ht~Tnu)tVlbt6W+Ql,O_)Qladj|[P:uj|[Prj#r{HgX>&}D<_p>~B!Pm>"u|h:&}Dz/3r{H<Oo>(j}JTnu)!C:2:kmBlb%!Iwh:tP$(Ql0,Ql10ibc966na,|GQMY9$MzUA8m2PL"Q=Td3`Ng++T|GQK}GQvj[&Cx:>b$rHf$W9tx.fK{.fX,Dm#nb$)LVQ|?<UGO_;N38`2!mzK4jdHZpPW*JD/@#Mdy)";*_8UPQpOSify3f>72jzlZVf=#YVQscOPjW[V@"0OlLY6sw9jFXS`O@6ML<d$EVVM"Fl$Esg[VrI0xW*.OSLHf1~g{*{T#B~Vgwi?XSZRZYDnmy[i#E2SKHO0Y4f%WO5=QX(??bmK_@d[WejmLyZEoO1F.*qEHpkLBf]C10cu;Oc8.ABv]Pb98YMJ=)y%^O/!zu.?qL8_5$BbW^.[RS0(rvV|]GkzDM1J.6:UC`h4ovDFC<[R]yn1U}0%49fq@J0pfoZnOT,/UcHeY&(PD6i~QCFs%NN!@pg)G&<jNXi;+tPDBJ0%PZwRpja$i|/$QYw~jEEAB28.E=7Jb.Iv*>FK7AQJl$I;d$fNx89BT}DU$THSf=Y)^cO3g)7aQdIRSsY]^%kBQbUn*=A$?5v?mWc&E+O2Tv%x(1=*hp$Dx)gYmCNHlG]]@qgSf>xK&]S}e*L7PwF_01C|H<Pjod"hQy((^a4(^ERaNOcVFyNqX|DM%UXqgt/>]n0r=rc45R,^GM%Sx/7}pREwh&iB&Z!V<f^6cTydB;;.38%p{5E{?P`#Z~Toz:>:M1k+|]b)^/%LB7cK,OsvDcFGvS?=#|nY}$xaPJ7~=wu<ntKj:Qbs@53%u&BLtGO_8oA5@+oo7.#YawX24xLTcK/HYuFqiqBTPFUQ+TK9cWyaV4SqGzMeywihgZF?B1H0ymmBw:0q!%3^`Q|8bVF/}@egVYVoe5363p3kX=)4z9cW0~?)?*g0#VH[GkN"Jlk{w:0QYI}KbM*9gay8xM*YfayOb>nPIum2[+"YO`U_qVlVH:XS+;Y<naXTZ|LQ+161?Zv7Zef?p/`q:,zCwmy`fdYS+<*O*&BJ@Pu<nVW0BGsg!&<;qtQ44q7,AVYqMFQbfH%&:GwMgnU"&r=UP/UAMzZEo4Xmy/`RKF<Um9pRF<q@]3f0.}9phw2[z`J0G8`|e3C!E!E28/}{BJB5EA8)N`Uri[!p<@dVfYBGd?>C5K3f,t:wfBt#*5G7,.:F>ck,Kpi*tB*M0(^q+:afb#bCsbJom&[bXG++o@U#<7yxE>NCyZ<4tUF)yYNIE;WC4w0n+ACdFagK`W!%EEv{42M0|Nm~W{4K7jp}E(^IYAH8|EvQMP+O^I*3Z[dTfr4hLoX5U2Ri2+EfX2uYW8SSJRu&`5ABMf4>t$>cr~l<r<?lVP![0,f"JHf4K5][I)^VNZBJ@9i]$q;.}RV,N$F)~|1sAQXZ&d9(^ZZSc:idj:wWGBKrEN*4#?`yq;j:wUlu~H7q8m21C}OA8)dbG.XAev4Y&g>QUyLh[?fFkZ&k@O@l5G6*;D{v!l}HqRZ^{>+0qO3S(3TpuDrq*6+p7?!0)LrV:ZncgP&Xfx$X4v~p/y}O&+7_"SkU$hPPGVU:|(qb2mlj.o:y>%j>qt+nR>xjEM*,P`0]Zn</wF0Q_svq9dg"2OCl>xVkqmaP=MNU&d1(Jspuv(8u|JEV,fa<C.Q4u_%|Ic*,P^SyS`@cw,CH#R!K(%r^u#I5pC6yfl.,a9iNThe[h%73j9dkQb8[<Lb[%+X$cTzCRL]X9<wJf[A?^g<.?Crug5KF4oQ?0[x$`L0z[Pke6+7Uah_W8_/F{.ZG.N~*_*3KbqHeVeD&oN~idP5~HOc^5NH1a~,ET.#%jNRI<wXW%?35KBi4g]goR}RLBvE62xci8@3#]S;_A;&4(o3!1)4fubdA:<ex!@l|5WJ7YCjg1@3f.L$2`>qA6vLON.6FZa6L6Ua3SGMI[U#||^O16V8q!BJ_xx{wl.#RtB##%[eQ6B>`6VUh.~6[0.:Z8N3/Rg]@0u.Y7t$tGwTS_rpNxk6G~]/%KgarO>/Wn]e?q%IfuadAZuQ(&fkT&.&yrBPgdVUg7hy@1kT_@Ngd^fTr!vDqfJl2c_ZCDZd6,ba|+WVlS^57m8xqo<)8dXGlB!S_H~5A*x6uW/PY/&jS,kS5?cJHTQfMF|Bka6>@0HK"MG|Zb/wmIF6jk>qNUa1[z30)]O6w@53+dmq.lb>KlF+V}^Ok|$6Nr/a`wjht;QZW,vhjVz}Y_V{oiH~Oxhw#e2_/0"NEj;;+VirlG:>l.OtD@tTG&zGZ_/X4V)w$`lrbUOOHg0TaL*w7ry`G4lb}%&+dN(*pzwb;vsidxKIdK,zRh~pby`V+qe40[bK*^^vZ0]b3Sik08C{Kr=nEZ:Kz6v9?Ze`qH8t#x08@jyds*|56Mbd;SFs=I3XFlTbSI[D8l><Jr?O=QF#`mxdX^TlY.=:&g9B;CbX7{E;!;!hea">[,0s/3NU5cPTIF~)pLqylwz/(^So3DZVvhJb+MmBG[HU~wd#_X0;>mI5.^{cKaFZ>SyCet~V<sA3kDA:kS]09R(QiEZvdqUfZ*P&J:a5.HfMiP(kb!iWw.3x:b_^cKe!6K{w.CJyd@l|XPNE]c^p05k^9qSJDspo"i2g[;0<Z?[8z70RUIP*"R}%jHEI.?Yc:]sZVD"XrlzlZ&N;0qe8wQ1$_w`Cdu4*d$Pi.@g$b,1m8H[yC`XvgPF8zFC8OiSx^I5c7_PT>EmnPTSM]Q1ao`Ak4SS/K?52sE7_8mp{2T!{1QNN;V|nE_H~ADqKv?^vf`N8c+C[2MBD1JV;&j~=(Vm;l*.73G"%7hIPXw#pSFU3<x:42#m[PnwMYx<|yPrU@Te{)sgQkQ=upI|T[hp`_6N^_c3>fx8*bY$R],/!Ka]Rth31E[kQzZ07yyjiWSBP1^Lzbix2Bzy2b;FhEmi,"7_a7llhX1&ISEem*/V{4g@`&|2P~|L3FSWX?6ex*^Lv8;1,<?+)FxjG!(sQH9I%[R:,YbtM3b,j|Mo[$[<v~pa<2zhz~g<mC8CA~E[nZiiPqNl)wP/tJA&u_(|)"W7kSR]Q4BT)|SDA~)"4hh`n?=b6$+fyP+eG<jnP@LrqVV%3s*[^]eyA4.eOg]g/BtKoIbh5uwbQ5Om=Wd=GcB^QE:)7/^s=8,4iN^hhUiAe)t),e5LNsI6,x)cw86<yzb}1>f7u=?&q~J&s"dn+,6@sjiA8&M,),jFlTbZx#Y94L3@:drM$%1d31qG~7l5V6YkbU.s(@[tpuSNUnB<@E4h*kx}eVqVPwPdY6g~3B~s,_o]n8Q$/u`t~bf3cS?IUe$gf>g=p7vgA%&gfh3`/P&fP,pJOFC3?/|dc=/V@1kz~E_0If4umrokGm{^S2bHteAb/Bfs9hhHYaITs!R}FMus<MXlZWpem*R?Ld[gF]X]C4L&uJX2FYu0T^EJq,(]BCxmC#*X|$^;t~TAUAK(z5I=kb$l}z~{xTuim(!3"4vd/LN:>/Xsu4o/f7uo@RHP7|Cd|]l1#RuDkIE&Lc8o%[{N740+EivTw/K2PRf}$3oK*Fqrz9eQkNLhEM%YT?=rKY0v6qzb4G1_ET,*W*$|%6[=J+u()7nZ}#0keq@Mb9:8lzvZ*@q)eQ6Xu1)fp@0crxPx8E2<,aObiO!IjvemEb#s#|/%6X>qUc]Zby2C:QOHIwpT,+"ms*D#.iXkgLq$xAJf+9LVQ@*ewF8pB/|)YS#oCru/Fw{mQ8@Ias4C{I:9.NPm}0tsQ6@<&<PHs^{xr<nXQt{,WLx/J!3l%JEL=q@6cyJ#.eZ86!{_z/O}*iQc$.q^]P!e;l["7:;n)ky#%ddzl_1v&Q^P1i=X#{8$C#W^gpQxI$`PP<>Sz]wQRGP8kKLf:2pp9Eh+tw2yF=H8_l=)Y$1kb(bv.rw7%JW$9rpI~7lKs0Vuk:j7wR):yLexkS)1o3OVB[&`OomN:_hP<DThAAAd/.!UO?}^syC<(>E8no(sv*)ii"n{XW?Ku2nW)2JVzLoaCKfx]eX^fxcAx4@:k|maE,0iloQ1V0|[L1FJQ/A2=h7(q<`2E^>Tm/@]v6k**_o.;>1OhQj^##PpN](YiN!0`c1tei*{*/4ZQZSSz/IH(_ae*Bm"x}e$YuogO169)W!WwzNNRhRHB&JQvS%iO/*iHVr(c0I.hLv0gVH>rGhYIZxdE4(N13I2+:kW6L)aOm10ZRAZx|eIS|$m!EkebK0HO]mk)OI*)sHUc3FC#McO=qkT=*^0z2)FN+w_;0^bN2^]6:m<=Eeg&duvtr%KXTs3WnccmJ8]Mp^;"7_dcMqnlqNIvzna[ZUc[0YVS7dcPH6pp<(^4qNqUWN!*5g?W?+ntlgBVYFz}`,{&P2=we/`CJo^>M}4rdBY;8M@E6c<$waxQ6Dn}hLTQE.8|Ie5e%n80[iD6&R7DPY"]q/;8`lU?CZ{RvXi=*(J`H9iKw)HE2cpUlJ;tx#eG6C{maG@m|Ed)P&1@~qqVDv&OZ*!Y=Mi>I.S4bD$uWC"Ta}YxBBS1u*/mw00cXX&K8udDnF7v=n=d0R;`Vk+AqW#^fm9u8WgsNLkoQtRS&Ku+kuns,.]q%"SxWv)tD.69i7/hi=zb!X&b3D%&V9Sp.Ddn1JoiDQ~p?sV?q.=pWK.E7;yZ[;bBsq)Pj#pUsZINJp1|P/}$KI^.<38%$B_jXSGLQOVuThND+A:66p.$gZ4$e#j&&$iUf=!YAS<%gy|6Y0,RoC9`JJ12&3ab6qPx_V0~>?BM`%([g+ABjQ3)DXNUDCpqPck8=?m&9js<^mNatK7(et5I_UHBlv~n%LvDzyi=obR82l~pK+)M3fS9(HY0:)=P1@Jz7p6N|>_jtA4_{@82IONzl1&Drvvj2pL$rT)GX,sz.&USy.Njhx<#I%z1M&=NDM>J*md#Hz>RV[WZ^*MxBkHM(e.3bHwXlT4RrgQ=9@+ky~XZYO`*(QQxd/p_[/&026*,$^Xh5iRLV+ZCqoKFgR&PFST%OL`:mS=TDlWZ>@(dIRkTRD.P=MMza=q9$>a3_E]YcQN/=[QEX2)z{/G5Qo(*eOF6DJGWP0r`@0o,b[m&ZpiWE4S.g{"7krFnRBy_CQ}})@mO22nqmG]l+,ODc:dD%CxL~=B[U?ZY!G2<|%Paj/>p3::*AL|%B.ommX]peHIG&LquhiISB&9@vF`SWo|n6g;iQkKOvCe:J8%A0Z2$ef]d.}uUI:TKn?PVR[D~GFlUFK/;*sV)u77Hb,vS%T]C7)PuUqVQD$uNwJ*jqulGkLy).6>J,$Mcoir>L%~5H*Jw=A22)VPcZ=5M/WTwkVyf=M6;%ESMTI8"=uCcGvG?rFD)6an+w?z,R&suG^pJ!3z,voc)e^pfC*#"q%e8JvY,*Wj+NPJ##=<Ecq`75/kgb{A}zpNRlg3OYi*6k#}i8DkCEC@(zeG`(vQq5PFCz8,c"U2)W:%Ng.ptVQ.`1QXSa/{q1br[]^J/l84&}B*$yRSC]tjpR4+:T{,sF~I+6r,;s"I>dUR/2+.z)7`}&;296bP}c6J8PRh[U:%NtB*FkC5uG0;nJTHOjR?k_nCqGgily"0CbtHvLfM^jx+iU.O6w@(=H%UUV?*v/Fb%bHNYZ1[g^o5$IB]I>&k54D8K2k]e7+LB/qA4$IHUKowvnhLn1[Wt>sa&dLZi.E#h%YMG|]NJlxQzkWvO@?h8{wWG=izTsBpTFxPI>pK+eV#g|U3t{{k1@^omVQ$(&Kh%J3Dd9zS^]S&Ng1:y@{Ie_v)Y=e2_%EbWSzzgu=v(g"@T6:cT/%iC?O/jYVd/km>P#1bedE9DKVQcy_oR?|iez4HWZtE20G}6]tGf&+97mIXiV@0Q&[yMgw#k|K+NPj&_HaqgEPHQigvr$TNd:NF%l4YPt)wvFn<".m#xVq,)!t92_0H<j?V*_$hXjSt.BFaqv(>3;Slz/MigXFzTTM~*!;6!.@R5zAP[n=}I.4E8c(.@c!SOkcWC_U~tY*E,kzXX+N$3Z4g|Ugwo;H&P<G1bCCk/gGk|:cqyc7yb0ON"PW,Nnes)%87l)`9s03oc/3,aAT#/}38*umQj#2G,_igT:{oBIptkb!k=db;*.z`&rSWofr|vTQi76d/@QiXw6t`4HzV6=cPdh,t4%k0S[_=N_UZ*R0m_$2n>FS,*}T]?RMLf#j/@b($K8kS^iO&ClhY6x]>*Vfcpq[r:EP6|J7=p(p1gAy=?GSLgIiyO3Tfl)in#4eLh#*El$_I!#f8H{_e8_woDnW?pr#HB7~v}3s7?=T;dVF]ibjT1*,wc$osoeCLO)rGS+|tHstLOKR{x$B5EaNB5Sobe7B@r[JHvB%^&AeiP$Lwo,uXv~u/09cN,U.]6.R4ZCWe0kKDR0bYoP54a!H`gyX4_}Xc#M*j]3/M)R%^`)J<(K{yyL3UR`Xqo)MtvN"./uAlvtb"(UX[l>t9DquG`5I/tN%Hlt"(9xmEZ?33S%f3^gO6&@|Ke`%BIz::o2e:S[gtd:K85*;J;NiY$sgxP$x:I!o0_VzC="81,L;L+*#HzPKTjoL?>!4T9KG9j@Bo?=n.BO4kyyY>xe<U;+nKMRI~DlW3^6DY;g!L9FD|H@6=@M7lh}*mqeanI@0o~*F9g[E6kr"i["`d@t8S$}okgQL#)2h*30T_4OfIh~DGZgI{?wWQR5n6`00[<<V=*KOu7Hoc7LAkCw{t`8(1.0fx@S5bQcu4I}0;qP!@zgg)85e#K=6CyAZY`nB;jI5u$ChM(>g?Flv#rDy;@,jZ<ty&Z)P2Hi+l*.0:G{H=i|H#Sb2l^06b:G6Kk@I^MhjLn9vqpT<tjH3C1S6`C54@$erH=.{h[C_M:=3~:3bd!DhSk1u2K~"s|%pi8"dlvBd~j1Us^c4J4_J?kFdq!P*IroEFk)AAAlB[2AAdL7n&"bX|uizm#Ce!AH"!k<7~>_o25%ZOa4L2X)ABAEAuW:CQAkKgm4To:@%1W.+4maixnvc?au;G6:ZF4]*;@KtjST;+4iUq:qYbpBqAY0;><FdiB`Q|p"Qu5jeEr1tde=J,ol=y>?YwZ%MTRK1CsEe0%%x(;jbACMt.@@%3:}nae;tc]cNQX^a<na`8q>dVaV2Wf"c&J`or/GxiB%6fe?Z@ltPJ^*l*YzH=^?9VQ)2WFC:Hs`"ttH0IuU+s(.o[#uL>V9D1sU8AWaC;Q:dl+SrB=>?qqa&it}4o`6d#N/`9u%o#{OU][)>kr]][qFZ/t_z0oTW3B7^WEP`Wx|kb@"c*QNAgHH};qZT7=M~5jAxSHhkB5c}!S;;"_XbK1$}WOx"PsN0XmfmSr3en%{V7=q#}hcIm[E`X%sn}f=/2X;j:Edqk#FS}+^kxQ)ivzWt)<<0PVg==u{X;9LQyX[E8V[zLTBN3.;Owr:48)q=NUm*:l{:(m1Kwtzy3NPL={.o87.X[yhM1UFosZ.1>/IIwv|j.>3c,N*1r*NH9S<QGsT9d1RkwQM@?ab[&aiodQb5{m81je0c=2xM/@bJqnISf:za#[$7^Q.9%Oi0*6S~n6tKk:nRt`yi">wL_jcw+tP4E>}S?I:S3Hr,fEFwyWB,3d)${]17IlDqVhFTAvH="i@1,i<EW|A]A6oH^J}a4@GD6=UFT"8CrrX*%0W4v#Kj`E7yl3>;Pzb}C5}6wq]nP6%i_^=WlSSA11,0;B1@?.SPJq:]K?lk}u^25ctex~t5~27J`@ND}7fmw71CTrc,!*kq7&[fO:Csk|a9ZQL!5:G:R=uvwjP47yKy5&~BuLlb}#sfQrKjoD&zTdD}~d[0KQD9/0NtjvQTjq>c1V4!94Z)jO/o(K/^XPru_[7oRmNXRkvg")D,;v1@^W_!cLn546^4E*OF7]U1!46F&t(oo$&}=_"&I![M.le~Sg#:lwuQo_9&pZ"xXagbO48*e52oad8bJ6]_aLL61pRsDO+7A,3.%?7icsg#xvLoGkDt/fdVn%I&twZBsy>`%Q2]]4%90KfB/co,mz"eC.pRAV2fl0gt2h>j9s&=FQzw.*0V0kB%Ny7ygO+:X:ZBXs?myO#<mj_<o(x`8:6_F*4l2?gRFwPfOx!YTRlt0:w#[#/JUVUOR2:KE&4:Q~PmdOC2Um9KLUW`bWCJUA][mNX"1nL6A,PKS%(u.V14,,R%6yrP0tTY}/d*K(*>|:SF1$*h!8|vQx=iz*+$O.$Buhr<Ii>T_0M%&6h`09YmC;Bro*#0!{(`>MZpJ}|a<tDvxKj<C,WD:n:Q/f[.1Te3bCcadh`_y,%+Q{<:+,/txL?`=H]~!?V=Dvu0W(FJ6SE|Z/OHP^ibiQ3~R9z)y@M5#2<vEVL!VLFTm:,Y/h}N=JnCTI1`o5s;24&EfhbL&Erf{CZN5*2C0&@!9&XQ@*(1RB#x]p/`mru8!/x*uCs=x*CO|::(RU=byv;1U%.J@G.2=5V!zrcE6_.I2F`/Lc]//zsz2dP,22~eS3s^[g184DOWc^q]8r:^1we!g@F?rdIba@4Y<k#d4??Wgd<(T)bJVz*uA/oj8iMbE+x7}crR!%m~FgLUdMgM8,&XYl9YDYr}9#+snm:zIrq6gJwZBiS+IjyRxFS[Gn:6WL,3Qrnwrs*:=/s,Y@7.2kU#lsm]aJ<)9H8;S]vtHt{4fFWv:K#vyWzw/{q&CX*:c#|iWNk[2LU}q*.h4#|.cvz926xceULgw2?2TIgATr,=P:F@]ym!8JXprZ"fjH{b*esxtCW7WOV_GoF5b?D&n`n6lV@/2wNpivGpz[i5_&)m5/V3zU6H,J/hH>()@BL$7cnIWbQ?}hmqCJy7R<OtLOQ|sKfe&S$l=&nZA6SGnu8FA^0H~Rcq+)=+f$ip%QMf(>2(F:Hot441c$S^";(wc];gNu=D@?nrIin^+|KR)PN177L7%0lbrTYL(3pNTx^z`{V?|zize{k~6ItT~|Gz?>*=d7QPK1~{Q|!}ULg7/p|"6IE0}$?P7GElFxoTh?;L//AW$UT*L,;rMX5vz@@b_[_/u<XJ/b~tqE~C=7*W41>S"DZakv5{nD3K~SbeSA8N9H=3|UoZLzrA17MjeAVN$|;XR|F{.<9$dx"&jz!J1+,UVle"1%"kYt2n@0=[TLE^zkhCD3BE"?7ahw]$:9[@"#d5S9AuC{2OX.ME(20zC?Ac"JZ*"$O<R6"9L8<>POWE5UuQ7:%:Xpp%=S5Tw5*AFFsjdHf1sa,p;9)?9k^>`LUG/t+Si?;bT/<8!YK<N8@:g5Lk/`WBvBFO1_>zhF>}63o2#DFFiYl[8VrB4&T9Dg#G1B~83GJ6Ec?N;bS}oyd|8WO4p_^/R5.Y(N>:M!~Hq=Y?q,mV)6o)_<&5ePnW]wt7KJJv*}l{sf6nup[iIIS/)5ZL$dN:ZupSKgyGL)=!ACY]<JYcV16U71,e*>c,/ROkRG35>gj(Hx:d9yCK,909Ii4:k@?^B^uG]_CncJK&LrAmngp1sl`>ZoY>JbKs[(=V2~iT7g;G#kjjL;`)ygs(wrT/J)R)X/1RK]b%sgcH(oOY$+oat,jKH/SX73yQ7J~/K_d2[NaC7H77;fpX14f,zzz3jiu"6]5KlOx0f3+Q2u^~1M!v@&kx^QBkP;FcStJb$tIP;tuCcCwK{Weq[P!>>.R5z[x:u54Q/pg@+!V/#5?e_/oR{o*A.0<G7q.2_X;?Wa!]ddz6*^:kHxX,+p9j.,>d".hhuuL|BMZe,m^hXlnEi;*n>?7tY6lR/,`koq3#Z}1`r@B0I]RqEN%@K<JG6p?m/V!+!@T5%wkaGB[D}GO^b}%>2S_+w8~*|exF~@Z9CH;l|~MA9(+Z(9Z*`j{qU8f)/b_m>oK!7+@`LFkKzwlyM!%WXTk9x#S(zpdx_U!R8uqn*`2i3${>I#QV^q^9/>/Iaz4<MM"D>ge=Bl{n77z[x`Th0KmW>AiG}wlBVl8/omM@]|0qhy5+cQ]T1(3E2nhhO9CZzGCtja,,:6[9h(D.:#+NiK"jDws<oPv~%0qq:QW#@4YA>{pWrNfs=XFK9@]HH%cP$66!iY<@+L]aBWS==j;v(XLl*W$18m)p0p)pMIR<?T_#vijAO1?x&Iw5kKVc;TeoKdBk}5@^7tRyL~&)f](&M*w9TET#fmhweE*^0w^{Qjg[_2HW@^/95&t=4P;tn/3ai5wdu=wP@?U`blaVz51_tQjE#~70yQ2URMn7K^uw*)+%w(+cJ6@OWO;#~`Yoh=m.ICWV*jei&>#Bl^Tl^sU=E[IO{,y&),iza"gBAq}K~4g&<FE^8}bT$[Z:QaIHnM|;W%wZG&)}=a_qOR)B,BfRnJY6FItpJ,O8]{*7;6_lt0kS?vFWmvMGl!ZHaY:ystQgMqOSs2se4nrrW7^Hinh>%l8&[=Pd=|jg7&WtsRFxp}:2Hs68!0tr&2MnD7~w<(jZ$(S0&ki_xEMBs#cI=E*$B/$4,:q.>$rs3qpZTAX7j}T,ps%4+EO&ypd.`Im{j=e?F]|l1xKinS1cI%.pMBy>+un@hpVY}b6OC@4^T&G:.ij#b1/54aig>~a1^XN%?3j2;=dX*}<3:+~6et}"{+S5b.:[6;;#@*8*>?!.BWJH]WiC(ok}|w=7n$WH#I5RL2YRve6m3Inke0.8z#"t6^a%miq_khqs>2v1_#(d@i9@M7chBLW78e}5W*EGn?%S;ZK]ON+)#}ORe]95IjIkPf^Gl~PexZ*]@2Z6~ifd6)NDW_pCw`(13%ZX(ZwP!!NoLWXuh9+zSm=Hg;C&FH3`[`}UEeKWk}trPhTnkF}~oUIuL$O,+314z,{@u4md(<M/$v"|v?gg97*^pn==FNV]L{lEsv2&pb}Y,Jo^o=y6cP06+(Vi{L>sW6z?GB|vaB)]g,Z8TIMMg/`Wxr0{BPSp!W71/BTJ7OKE{&/9P^=U!_[H~Dk~0>6ixBW0_G)+*15w21d!^4EiuOjyRC)RO;4unTPQwLM9pIGE]_2Iyo;1PU+@YMv&,K(ugM6)Iiy#L)nlAK^iB:Zu.zE]/i73t&eHxWo=Q{SX44JR%b7<Mcm>BOR}l,zhcw9cr7u#?QT~UX4iGK2Y.DCU8.zv=l=[H0}AEi^v(*HHg*r}buRef,_wt{?*RpZjkuXuOnjc!DAelWr{MQNWSA[_Z%V=ym!rqZdd[b~OIG:{=H6(t60*TLP^U2T|Pg4!.x9:[1PN}(57y^;[!CcP`7Z5*CY`8yyt=xI|7Og]|Ut:cv#[Dd>ef>(>t%[FOJ4uyclTm#Vyq]5:K+y&uQq+R>vTk4.Hit(!,g9%7~AmoWq}4;vyj@p}18r"=V7k6."5/R<@FIYCHAYH5"?bl~1RT2_jZ%u6,~.BdO7U8hv~rjGhhXI(A~2Uha$zh^23zVfe(6Q};BZ0tcjGd$p]{GOLIm#!?HT0(I(!ON*nHKxO$P:c6shdRL+$(t,4d;i*unt=*gAG,^?+hKU!40xQJev4cAkXr!cCW?eX_Q2&.,vW?DT]@tA,LBN_>`QtrrQ@xQv|I9.kxW[|cqKHm~oXQ#w*hX+2wTXRs9:<?SyWjnz2u5)2PZ^OvI>m@#I[KX*E,*$kBqoudCKR9UA(jibda1kis50)*:y81:zIP(cl.>0+Ag,>%0C8/I1+k7sUY`ck!zyD(G3Pe9p[nmV/UPN7jj$B"E~!x?8wt?yd|HsUEQ6?"|SFzp}?7w@ZZ8=n,zm:I;2{viSzGpMTagB7y%RJux]t,vU<w>r$:Co3hSZ{}ucV>UoFmH%/2S!Cz8HG)Nr${9)CH^6=~u&YI&=8IOn)[p6iNnt9;rl*Ix@F%$.bmMmJK8Hn$fNW5Xk0O<SD{/8dnwIjx^MX5]kkY&WY,i.F"uY.H*5~d%wCdh!5P%kNu&(T80E.mksQj^PZ!fXv3GO[JRIs0y(eI|B(rL+6,ch+Uq[zjpuxLMO#;{N[QOPFfiL3!_73Q>hSv|be$@`qrxTd_,zrbCb|1)u<gZ"0.hD.nk@9Bx)f>_Zt/Y);JVY>SEFpA1j%YbVN%zB:)1}Ke64N@bNnOuM9.%%TV%<|?LQ^tr+J?2V_5Zo6HnKF<R}J:r80ctdC:v6y"lWW9j{p}]#2,R>9:>M8qWu}={_]&o^Ny_o)92X[4,26>E(X*}Pq6ID)O)4$z[!r%_h+qHHnV|SC<gr=I^0wZ;0SlDzH6PMQ2:f6b{vWJ[,Z$Wb<(CvwiW0Cv9WrDi6r_0Fa/EuZR1#bPJad6bF11$O;5b;@$kmtRPTWQ`]ECm?./M12.2D<^=D`N,Q4d!!v(+Fw0M`h0&}KGiDIl0"9~onrPvF}+%N<Y)#$K<}eN*tKUU5heF}%_c#KrUsbrv+|MaX6L!V{9Gn,ePrdXBP|t~vt|)B>G}sY]7^3P9hM)eZuVk>?#z4]9V[`SCOMJiYuI^uI4j/RYjcvFZLr;c)d&a@o4kDmsW}9IWI@H11]r6w<8IE:W+1W.9!p:hLb{j|AgNXgTr[,5,!r.4)h4!:jM+|z4jHZ4bM`A"zW5u(@T8SR,r8`3I)1=Vvi`ah75,fv(ol:45PKsp@p_<4R`_dr."@L)7L{,BuF8_SZT5w;GS&TI>3HD>U;@#%_ul_+R5Ho3>jaG@zjW+T<0zoZ88jl?!Tr;V8OnU<nCSEsC(n0os&U5]x>972|ZE!*m7t1vtL1upS>Ma{E1j(n5dqke^C|7vG7:m/s=[]yk/Tioj"J%a~hfgtiJpU>OwLefB<k0V0Hdi~[|_.ih^1mK[W7}]_t00M7or&K`a>pY}7cHQL"mHR)bmz5|WbQpzqc/;"$3TjWLl6Z:ujJ~~E4DsJw,*YgBSw_b5"/AM_KvZ4}?eM#&ewA|VHnf#>)O,vSON&v=Ne4",=.$r2jaYw*b7{74ie07b5k*y.!.6P?ME=~7&4#gO4Hk_69d)^{knpM+7I~ShCX~<GvDr1T,mxW]E!XY#*;|g_z*B8pGqJ<ZL/U6T&w=*`CdnbG%SfEMd,,Np?Mw8+P`fc2Cpnpyq>Ua[N3K_3GftS"O?ICX<kZVGkX.XMVWkN&c*hQv$7Xuf$s;r8;6PQs)nDSYO78p3y_3_.C65I&|]yk:J{6B7Ns+J|mHSQ2?phqlB4,Fz@Q,e6:p)TB7TnOcdOzBZL0~;:qk6QTU=~itPZ[IFQ>,_HB70#/EqL%G[%Wd%(91}gOIY}u975,Auw&St/orH<PuXx]wDb]_HuC}Apx%Y;Q{6<B/DhaU)AqcTD&lNrf6#DwQs2{/wsx&HjHD/+F%bQ()8HmGuWzZ5}!7gqMUynHuabVU4?KmX%3b?^txjOMIP`7H:.$HXMQI<gSaU]k^&(4o7CYK)adlU$jdUp}2FiP_v9*D[h)B|kOp!=MAEBB1!@KFK$Ff#B%F"G|":AH@1T"@kaTG[v|.f!ZYM0p8[2z{SmZ+/=IJ>E7&fkvaB:fBP`e%)3FsE+&BvO6CX(MZl;%qL1JT37chC9h7E*H)=|:/T3/Lzcuw[K6?r}:Z,`k<*`}GnY1*Su9&%[Qai7]Om"adr@8K@hP?Twc{npK[^iZSP0^Wq!KA}#6k(r[K,F}#/0r|x{j[Wc&Pf#r=}$(JOo1TGyK.}dwqaIVq~},)/ubHf[cpmVe5kUXFX&>Z}<8Lwf^xxgy4!A=QhR@hv6"ZW0m,i3&m66*|m?:3[Z)24t!$djJ.mxnmG%N;in%1gvQs.K]:V6"mhl[;0m[$vO70:|02[Vmt*6vr[e2:Q]T,~(HLZyMb9K^Z7nNzZjch3QUUq5K})D/0$*`.H)h3.rn}V=]BgOaN/Ky8G,D]P|1zC9E3#mY1/Ha67gLByz_@z7O)I5W!UTa@DmRzIx8e=X`5=lXU7bLUX51y(Hkd&,*$Ue.><d7"D(Ok}sC/Lz;WUf]?8v!f`#6x_QY3_9sRd_jMjwDjfGs<nH30feJR=Far<7$6C3bWH+|_J/@o.g+.d@!vR0rqH?zul{Thvoc=Nv?:^mI(ry"t#.y$oVrn.z+LPt_oAZR4fzZs3_bMD>)]s6~h=m2q%y5Q<ZYTF,@J[[d4o._)~`tR/P=,:z$xP0&pgqFmB~:nxqxCf(J!!Ab"m=cyMUuDHqp4k15AH[SSlp^Z5`g^Cf/yOA5=7RhY;*<0w*!/p:mAQaaF[[r3$2nyKAz03b?U"/l;=M:U6d$&l;?O[8>Ug2WHDpd^tUl[C&&B[TTx1Wf4.|$YpZ~9g_)CeVOH,pyUSpS`tb6Q=%FPHymR|y:lKQ}Q.O1BAn{Ghrr@*HpU36hGSimI>5`^YcVO7<x*npvavH6moyujWw_ng|hEU#6JYXnqoED<^_k;kk|/bN#vnC=0;cGd)vPIU<^RLY*n!)PQmo%qc{QONPlQgnK8b(_7P?`,b,.Q!3b>CLw_Ne4+n5o3>_"gItvT0nrM42uNx`NdMWb+SE[zR@+y=O3/D/?R6VmQDhIV9xFAbWE=K2dJZ>`8[U`asgyXL1qlLy3T#&:#X&|1E.UTUq)/nk4cLOu*U@jk*zR;`Ts[@s|W691&?$6}Nsqh_#M>]SS|ohyi<~/y,loxj9BtiDcrp"_l8n:MWE{UM/eS>E_~klB>N#H3*K9I|guALT=6927vP}%]=v7e8bP1jdgt4NAcIh)i}[dZJQuRG{$MX>fVtUP[H;i,X|,MHRPB&(QKD]pw^$Z"jpU`LU]HUsKCTM1%@Hzd?b]>nsIbK?:`xoTo#SDQH5;xl+<sm)%cS.b(heJlH,>rLCx,tKW;d1P)_CTg]dtEwD(tYR0Kx{e<L6D@G@/ClqPzW10[Yx_;}>vuI0U,0scvv${f3Z$:+;;Y[X;@p3:YlJkn=;ji_HE9HFweSF[VIu<_.$@fqx$0?+05/kxy>8(wirhh<({T4b~!JNdw?p:fF%eb!laYBR8Sm4S?|)<2%_J#q/RKkj+SJQ;_gJ3pq;I3nU;3IFoxHVJq/=WD5+^a$7/$3?)Pi&~R/zgE|_,KF~VJsbBFf.NUPD1_UWy^I;|U{)Q|VuhfzsktbjAV*ue0V*7z|K7MYN1Y:0=%_$=(O*70E9K/<>c:M%(LMUY[a6t[LpA"R/rdIh~LF^?hiU/)]Hda#Gg3#}B#JL/$Z[#B6"c[ph3WXam&;^i5fayto:]H:31iDl3p3phy>fc^nfEv|>.4.aV9&+qW^d=Lbzl,r{."gm>y^AAW!WyKp:%$3XN"#NQqZ,>!_5Exq|3qg41Q`_Oj=i4@dSZ8{@Wrsw}wMgSdxKOi<~_VnZp{yLKX93,g,l}7V,cGp/Go1W$C%C8;VBjc|]k68$sEGyBFcwdyg}atPKTD$g6I7lqUms~C|,<.I|I5%8T63RShKlxDBfuH9/5iVyjesc2LSMrLI2U"J9m+vw<uYL1{S/Nt5ku)B{18X=~g}Bqs!4)}`Bt*@XD~]/[/^4#sdMb7j.e,<^bG$>m4N:j^dr7DN_]B{%]QB>f0KclfJiT;5h{7c>RLH$WK`EtSKV@UzstKy]G}#c*AdVR=l9LvD[E5IzB##C/Fm(N>DC}EEL|0yeFN`Wmv*3}><pH&}T2)cert.1~Nku?aLq&]:dWH56HLi_E5ICD|z<Ai}T}kNl<qQ.(%e83v9.yoP#N`lT[!;9,XlfnR=!0(Tc{&G<uW2zG{^5$nS:.kHk$NvJyr#.u.)O/?scMek1!Wz:&sd+Uf]w$Ba2Hc^2)JF~LZOVTbd&B`F~.Bn?{]}:pI5M8v7PkQ!?:^c4EDzzavG}?xe/w6qI0?L&l>8QSf*N~h)Ne.)!MTLc,#Z7~1fY7v/2d7$!(Tg0viQv%fx2U(nkvX`)RQXg6s^C8nMqUA}y)W;|HrqDJf.SSYYt~ZG{qW`X+Sq0?W{tz"/$!p2s^Gbp$u.#H&h7osff.:6uhK~}ST:r|RXD+VOyC}J$+Q+bEyGwr]pfI%S(Y[Kd!|*VOSk&E%7T83;Y/i5F57x)<aCz=*rq^5Q]4BL<3e`s^Q)>:j8?%A)}]m{NX7_gKN+A%x&y*F}ewk8<ElW$!nx>8/{#i7cdsvPI!!<F3M2dse,PpCDOM>c[Q#_<v}Je_Ov6[XN:K13_`*,i6g?Tm0!g/8ywr}Yxv#*MuzaT~CWq*4/+#k~=(ZvV=|4uRo72`OD`m+e25LuUj5tJ$U+gnOCw2}Sy`Q)/jHEM/T7(HT1C_`9fZ$k2iQrqF.x7{FBFtv[0306NBKwU>raMaMy8O,=thjFgv7/(o#ai@EQ>X[5KG`g$XZwH]{+)v`rVE,`L!?m3Esb=!54Q;<$3;8wQ%gY~vdx?ZP3L>Jq]_9MY&CMW|_0Tqt&d>;W>hz%M0e_n8V><t1Qw6OjW%OLYC~6uNh~9WA8d/fbA/vVg[04L4K|GgceCJO`qF|d+zAq+hY2G<>OAFIK5<v63Q17"r[O"Mo$[ORS8~9$=^VfvqVJ&)ZD$5G#M`A?7W]7%xl$W]@ImcMWx4v37(4m2F<etMMB8_H(#{4lXJFgS@*@/EB=FBv?Cde+R&OUtg523sy68=8Wc:%w}ZpKexu:YVDm&~@~i~]8?))98E2bQxJ+W+{%qHqk,_3.|:$Za=%c%P<O|Da7A*F&DknSv<zl^?l{J/PeF.*IKUB}=CfcrQc}($2tB,p_dmOIm.wZX#pFJ4?$p0Nut<;3&*$kf1tlTt;2S;Hsl[jR[QVc;m@f,5hj)Sd]!M;Rt+;xyPcf(MNI.S*<HtLD^</mgtm"]YI9iAekH|`)3[WtWnZ6|o;H_[d:Ch&E==$]vb$R8]KRA)V>C3RB=9fp]:Ov(|z9qEB"M^oToygBDXRh:.=wLn=||9:{8)kkIb#{t:bF__!)hOwr(_yI87@<go}xO"+mn3(zzfp,._ke`sKHAS!^WW+$B?7K:_A}LTa>;XH6&Oy.uF7MOzdLRXLeEgx`$#+,w7po}UoHy%N@+&>iUd)LD]:Rk1.x37P^7KEUAfas@<z~lf?cx^S=[w{s5mTE>&y2*cb2u,L%tiJ4q/Ro7Q69:}M/~JT6hP3{[/H*tFqRZXSsP]44%q+.DNZ(6OEc99|ZQ6VG7W.HjUPBcgK9Nc`ZBJs+5+D:e4ycXCta[2rqUxxW)r?4fj%[5F=>Aq=I{z6$sA<NB"$:U7,|Z<h.%lsusH@%2n"U~Ik+qp)kTsxVUjJChTT^slM~=Iq[W0,1,*nhJdi+eq901EJ=Of#vd1&i,IA"j1<t]4[2LlJVhH%!Kd9mt|v!1Y<)Su/p78e,4*X2^6_LzXnVZjr4YF1t&fgefS6"U`2_zC(#0ay{_1V2G$Sj"p<DK}_|3r?w*0TtsU:Ij~dL[=vhIgFh5ztKTe#)hQt))7r!!p@Q7O#{+ymZQlx}7_y$Rk$p=eYV#.5?G%g7Hk]_2YQ{xY@CAF#t<u>4n/kIh<Lsu{A?.Q/RCD1kSC8Z5zMajxS.^05TQb#3AzS6YVFIVR$Fn|S(OG9V|?^@j+ktiSVsSOxSxaI3Y:IRP233pE}~|HFv8cwi>(}^$vzz25DUBu+W(P9Xk7*!/Cb^anOqm{Ec],JV}}i,{cKo|fJ%V5_CAIDGJzx=.P@Swi]0CfsP2|/Rc0^V8h~R?c"2u+/M|PsIyr6G{VIRcDH[8/gkRPx~}k;fjqxx|NmOs68v@Itv"LREfP}|NrdOS]yHnxJorqNF(^Y/Tri5c{te9VrizGW/JA^TTg6`8h6AY5|;{{Q#D5y=5r?*Tye>p_xoMmfv%]qJc,5E4^>iUv4Kt!"`laRwO?%c5@ZXk[h;Fh+]E[GKDgQ?~=c+]czI,Hj+".b`0NE&0y:u56m3xoN;gaj^`1*P(n+Hn]^v`>N?i}[)V8[]eoyTgsPZkfnmXv/[C{0hcHV{=n_:zp52p7SyV7bKJTQ)4YP{E81u0DB;$k@n>MBn9/>BS``k6PN}exI[Z/Ch00zC*QMo|Tti_vFDgH`oEOniG^kb~q[2[L+9_)}=kE@Q8SfQiZ,+blq.hms^y4?(np9p6cC>gc8V<Y`,DO|Zh["kHnGYu?Q]a#LBJaFYUA@v{nsme,&[UU46.SvQ4#WD+pm2@m7Z]YDw}Vh<<JF[$Gs=sXHipR}n:ClYpH<LiK.u8c;PKd"Y?!>,q`)[06[]M$H.O`{ql#Ra",w(IjbY?wOJWc%,nY;z:"^>/BMi|QiRta^/C2"z^Z|T8xu{])lz*n+H`PK3iLzWk2MZA${w>hGMEenPM:Im25q6?[ons$/!IC"|OW,;[T0J2`Jzi<#;mbW/6GQrL^CNjSbzt!YQ_=0kOLpozKC8V{D%7Ap|)/x(vR%N"/RAb0;]2Fh1X~RrUN@^]q1Jge9T}@Hi%cw6:IR`@)tR!GDFhN7HEXs|1}`#roMyXpp:Zm]%l8E6$$<^75&~bfc)Bbc18VoTW4m]SL&,+Eon<+FRl3RL(d?0rNqdUQ2LRM*sQI^ljTFiyLLQL2a!|k:}du:/k_wc:r!Pj($``.q]uy><dHO$Ev5M@e4D)9W~dfo(~bhq8u&.j,">Sy5n{{UlodNef#>?e1<;?H2@>>t&KN_USR&"n:a]C3@,Zu93Wq0L%{"OX7B5H7&a(tY1X*Nh{dj4Yuxtsozj3G_4:l4g]XTMDt]G6?di8==_6/UNG$&=Ek<i,MHaxV5Bl+iXV~98k)is;Hgyio6:x<^*+ebQ(E$x_+Btxe{%TvR?h,%7z^bK+k9;9{wKF_VwFR9WW5BL1)j(srZxtJ+vjD}pb{C6j~_bL<$.:GKKR!/E,Nc}>Pm|04Ke&_rM}*<8,`%dJ&7v_P}enLDGAo5tHwcxmvNyqiC[{Wld_X{$vmLY~#jsl]<YP~[Zn~SCZUSIzl"dQ2!w;GH#WXfxV~7a:cu/onFR9,kz1bmsm86J3N?nLdp/a7@Q24]LyQ^:L78E=f^8"^ZajqwRxBuE>|O}+(f;k{PF@Jw1];^^jO6*F%XBtqHIQw(EbOasHtJP/M|E;""ibH9_E_@,sQ8pu9=SNMfO4O8?,J/>z;kGt72=H@1NH;%|;r6w]ylCL<X*`>qIvWHXRt@hTC#%v%+(QumK+>a>Tw6+_g>:,3UuXqAgIKijCBO,R!X[3$1CihGpzk!d(g.NwE/|y{*8t+/[a}E1=Xs.eoP=jqTM[a))8"Sf<m~Qsal_j2rQUB#iM^UB({$LpU[{w0bV"ZJtOUr!n;@v$|),x!EybLqxDg9u(h?Z:O78C95@L&d;C0WZH**31#tm%<FHts~A1"lpZBb):,EOjxk?W?Q<&)WRN9|Q1n*O|U}`2[T@TMRNy4uO[)~#?XdZ1>.7Z043JeDutVsSNra7WsILby+g:UNQ/{bq!{Ka@&,U;Y",bCKV(@Aucg~3N&AxQ4{m^E=/X4fJma~A/#GKo~~m4r5%9PyXm.wN95ZA]U$m8#3a!56!fVux[hYKX*hGyE~;!wn~<|y&mz$G?x>axg3f"Z:.i1b]YjP<T#,,JB_+uwN:){M<V#@Bti=kYmo;kUG@zHXU>ObP(N0K37R*=PL+5g.r`c{$fiRKd(=[Azkpd@=OdV%b1)^DC|Eio^>gB}d<PjIT&).@C)RQn>3W2(NDeo}O1<lM7|A#HB&dXy1_)W9GKKpv<O2i/o^vq)yYMRB*d(3[OB^nhK)xip![Syq@*K*o#Yx.W5hRo>>U"WVTL_xR`t!77u7qt=~*J%U?V39yN4e7fahr+_=7q+%3*JI.>zUPTrJM(k_jpWCTES.3R#!kZ?2,RTnxXv+ed]FP6/U((N!..>uW,Vm#6E@@?/z2wyn%zKN_JE"[?yavx(;o(^H5}K/>^Y~vfv{eOb1e2XF&3iBRD>!}~UQ.YPs2d$=E0UyC,nF8CZK(}UlfKdP<!gvB&gsI*&&P6J,f!h0k3y,Ba9m.)lnolU/5,s8pJi~m}(j%5h)4tI|X@QWu+BB7hugT"%@ZX,{)jRkyv=6TMBO/TH=Gx!{:0>rN,M$RHtdB~;$gn"^?UO"@z+?]B1w;VY48!2v!rGHr#}2zSj=N0m~6zekc*P{~y0lYUkRFip&hN7YKu,."5=q+lhb;R$eQe_IgrW*FWqz~L%xG{C!>xIdJ:xA?9?zQ~^b~w}(4Fb@*;OYC,X1uMvNigg|$I&c>DR%U<C]>NiN1D.g:dZ,D$3cVA<1TRGbL+}n_#kJ/?dcWlZzfJAat[xBqA_<S_Pa#q5JMtfMh=i~82V:IB]Qf)+A@Jl2]p`[c$.<cacmyTOd+irwyDY@hTp=Y|gp&uI.kih=Re6l2Z~lQ2fxRa4)Bq(gl7,L&icREqK@R_4l|:rJ%rv5zNSg:SA*?GF3wVr(_x!~%HVG~sb1t^?z~|uF;<GQ`/a"tCm"0(n=2n=ERQ0a|HLB2$~{Kt@uol##Rk`!o#w&H(U)"|K|JhK$<h]<Tlcge_=SlkZe`%@r.js,BV|@J}b8SGuts.O{oQH|gdseVbM_lIk!`fUsr]XcZ<a7udV)XjB;;j^7UNl#NA5XGGj}e/|^*#~r?r1T(eTj])MhErA@ZCPYu8=D9rX6{iEYLm7*(F`4{4){/Q){R^|I!8J%I!7efL}dSF`g):I7G+sv7Yxg6H5j)F?#m8z;ATjYKA802C^ls*tw($umE~8pt&D"3^@Hs%]LL5$!]eVgRpndv{DB>J!>GV="Iwa6W#>Api(jbF?Z4{[v5:9MD[NK)r0J60&Jw*RY7xT[S)3W%r^H8Shm]E6z]27=Q$&uY^J?D=&#+f{gKO!(QY?3~7apE($7*{*1y6xGTj~:B1#TKx1l:ouHZ:.:DNv<%wGxQ/KJ;8R##_Y!`bQ(cflK<>y~`bV`DErO$7@IfOxk+BG,2*lkaf&4pc,W=MI1GiR,<TX9<{5sWnE0A~6w[*JOM=N55UvMB~0a*3wx{Y`;Pfbhw(Rc9CWjU3I>+JtkakRs2G*A0yY>!I,z^(i(^{F:vH|YVb&QFQDJHrQwzkDM68&dR4s*Rq}d47Mc{RY+Sg?1k?T+ELvZg}mWRpXM,^u.auRYIZ^vG~6d[+C!`{8CkIs>(j+{{b:_M~0FT(+TadSJIKlJE/?m^C5:&Lbo~u!]yxT`}@=8f)Qpx,`11hnw{5^5|<rDC6m|c4C7)Um~bT[GKuj)IGmT,]4[>WG4g~mLfyye?y=tS3P.XU^QU=#p^yE+D:BdzqZgLL{p)su:nr^g5Zc{{|fqn6,v(`#0#~gAd$=rzAq?4s6eX$)~(x~wX*PyBun5:Uk0lnF{Wb/`F*qTm(Is8}]B|bZzX^XTIob7N&,b#t#W<``U3]tK>T9BIJn$y|cMsE^EBNkX85;1Q3N*R#6JS887pIFe:[#68$@xswX5F^aY%fLnM"uRek[BA#{):_DM&XZg;]$j:E?C=Xn;fw8_SbtFPK@}$BB#2xPgDxp$hDp4(B{fUN_*BfC]:4?%aO}O{M`uu8xN/?JB<*#}}`GU^A5|1#2]:l_st6)m=H)EB/9ag|K_,}3J!5H;,mVH0;1[KM>bVe4~+z(c5zOTJF1=(o*z9V&Xa/WJfZ)Qk]B`IRc=I^K)pr3sg8+|Rc|K1gz5D2eda9t7t#1_f}S*<f"&pEjmXi&4Ug!z(n&M5STs5w!g/}L7H6+~3^]$laD"LBG[80~XbYx<?$jRo;RdQf5[pXA5W:ca)0j8<_w9PQvjiKi{T`vIK|t<jLH,9eQm:zY)%tF#mN,WQc+1,X{BaAD^0VR!("5U*5iC8^pIno6%E{~h80jXj57OG&,;hCv3WFa`N_+uYG`y~"I+ua@5Z(Dim#CEW?(X5&Ok%{<{me}FOiNoSb$|CLtG`WtaCFF[t5k=^],UUyI?6r}tNi|or@J*nTg=c<AvfEVJi|={{_=Sm8?Z9g5&;vMaH_BH%$|lwAwqNo.xhx`/!]_v`t_,[tRt%1nLI&QWQw;h}>i?<*p5<c88z;0k0eFQoh8fHwHudQfZOW][5|ab2ZNL.cFLQ6)69w=kk^E&z?7gFTM^%244U]{0L3*,{jyNeQkDfq,5:usl!|n&rmOKqA!mB:bEfV*1T9u,3]jIWXYz;`17<D(@`8wrX79QZlnDq21;PlGLI3,zS"A1n~a+(7;y4+:ls3>>>nLO|~<xK]>&24LRYE:o>7LBg9Q#K,+$S&Es}P2l|Q0=eV*gS5Z"OvJs>+wB;$xrwCyd/0uMpUc2"pq.yJ1:).EJMgq)0l6rftY1h@qu.ct3vq*V;::qBlg6#Bj"kI&z!TmIdu4#t3gq2Gn$o+X3@I@qN0Yod_a|y$V4ErZA$dluUbpA@)9dfVl^3B47CbOnE4bDd8h&Qma"?A!g*85mf`K[Ifi}y=s1`~4"dEqe#p@:*&BeZ^]8]Y^BohFT/yzGw>~uYb;b?`~[?s@]Hk{>h5.&{En{|LfC=C1rPVKWwVK+|v(i"T5}tE*dj<"t^d^NK{:;rwf|iAdpxh[D~pHKNWF~W&d#bYmw/fT)w"0OH8w0Ktvc1Y&x/,j>&N3zhDx,`uboV(3Cnhd/8eA[d3{[TO,&wDw)$5]230v@Mm$%G<T4}K4}_FWJ}aFayeL/rp<GTHPvFBBh%`[9E(jn|{=CzLsX@q0BA~{(fz&}?N6}_;=#JY/ihB4dtKx|z=D"C+]L{KLQ]BZO4c=GxCYHuZk&m<[`GzrDS]L>IFE1Lc$Kbi.*8eRv1yHEC_dNIL2aUp0=QMm6W!ZkNUX5J{iYDAy%b=VP*}rxUy1c22|"a+1eh+X+6]/4dxZ8H=h=97.2.yA_`w:,|dt}XjEK=4Z$#ot[lXk8]s|k]}*135Dhu:lG;P,@?yG6ER!}L+%?HDL<>b.G]ta#(=|sG3Bw;umZRfdF#(S;%qGZrgoQT3I|Gf{0B^Mbk@H[.gvCKp|V`FD%lW"l@y4i7|iTYN*,3es}!0l|?X_v:Kz*(L37N5MJ}K,cbg_]YD21uF*D_K6tQ)<y_18yE[o@<2OmQ5P~v[7|B$17M`G]|6DNSRQ(<{%727n)yOW{%@132a*.Ph[jVpz9!e/0oi2fe6?2].2[PP(O=0T<V0WdO80N}bdu1n|Hzvg9OC#q,Ieze$(oiU~I^)c$NCkg9:5X/J9`N;Y~VyW"[<wX[L`"}~rW!T#!Qg3I]t4Bx<om,WwEpR7U`D;*o#D17O"GUlyr6BQG%sgYw04U&vg|vvSA8Ift5>}QTYcvbP>K]+(Tn`$$?W3+Np<)^K+e5^O=73/h0U5cqbohq_.~i8!fHT]k6aHdE+orcb?[P=OD)#x|ax?+q:~h_]>qIZ=Ql=u56JtWtmW(L]BprzeR6%|LPG4kW>++^`b+ip_puZ`eM{1g&]IKlHHTdfdNFpiUJjHN+goVGBwVT_#4eD1(@BUDsg;6rM_3X*{xS>G6=X<iC#*[gD}$HpCYvs"o`[:gVRS2M8l4yvgWMXKPovc&OwjXJOcM%y[RP.gU*&7DCT7)+^y.J:PziB2%gEI=|sP+C2c/#OtG1Q>IX:S#/,=G#0)(]z7~@|zYn`A<M8d=YQ<?#F~K<x1@AF(tSwUF<}f3E/SabtH#GI>05VSY={>GkQc,]%&+=&i$8"80MGjw9juA6>Z#i>pX4h.DTeRbN^!;2>]`<jL,uf&7@;Qf2&b!IUL`)HOTwJn_tVlfJ6:NSFu<J%^_Ut~9fss)I<%Hp"B2<@6ziW}kBp4QEN_sk6r0BBIAvBac2E"A^N47ZZJW9CwBZu$De=@b:08yEtJ$I^kms]of;oi&V=B(1{09UAJ=P`<{dFmq@U$7*T=w))Q7d5W8/W8wIvCs<{`XfD=7vjtV(d0pUjel9F<&OZUMBo_}YBHkO9lseoe;u<;%1%a<?g"DQS/FKB?HC)_GqlE<.vFL>D6MwNd":G^Wz(3?MQR>HgtAGS)ycbLU[r(4D4&/V}DzrW9DX~41t!VHoYEva)G6f_XdndnIf}CY;4domH}8O),_k.p;MpUDj<{0()2BbkuO$1or#[?%]6],7*&podbslQeLVp3uU:mXt^dQU,Bjk)NJ,/Gly.>pI;D]iMgr5n,bt,>8gT[RJn9P:Yz!+)iAK7tN1C)_Se=N2v(+r,iSkHFQ4rljA:";L:M@Y4PK~BS?oIUZ/D$K=k?KQO/&<10`{n7H0/>OE;z,uF5i)p}IKZ0/=2BDd2pDE>E`F^Kk!0Woij34u6yLXT^n8GHa;Yj.<TLWG"yUD/0EcGRFwS"]j!hNGU*&a=Sfx<BI(#sK0Yv_XEn*Z*~[O_|@!9R31x@<k>.cqq71x7Z"nhKXstfjMk)X]$E=IR*hKu_ZNPL3U7jfXd3fcPKd8_=d[1K<|~P=/[z>/E,&@B@4=a2E6`*v[iHzfAU@^fDcF9nwZ2lH%>2Au^k6[e5:wq:5p%KUjNp~]AP2QDzgd+5*!>5#7T[n7PtF{4Ex"@nfZ?qbdG{O:^Dof`ceyi=Q4bTVG}ZQ0l8VKSElw,vmf@r^W~oe`BCe!g"t,__W~$Kp3w=e]{vw~d_RHE{Mrg&%]Z(rr!*$`~Rq6Eu;zD}{Z&u0kYe3ir*mmQKYc<muUxHJuf.$lB;Yc87/M+kJ|@jTqcvHX#1?gpH9H&9Bz1Og|;]d:1qMaUetrvu]6C*cImJA_?!&|d}.=NwpuP6m,[0D0Nd=|A*kR)W9r_&I`b|VTS*2|ao#"f8vBe1Sib<15vwh]G(t8W0y&~}_(1df$rB1?sPS|"BK`Y9JS[SHPdwhf=iZ,;`&G0Mu2.7OGmhaUEZ#$}065"@7h@M{kxl5O*Glr72rly^P7iX`GmYRi{N_f0z^p<OvqPhf/$O4#{2p#lL"TjOC:Kl[gp6%8J%ArV#Bd8y|O#;nD=.DUEU4:?wVawOW5QbB>6KX0dem61lDae({D$5D"ww/!JAR+4DvX::/r#Y7ym~r0;LcQ,55{5F*(Oa#ocob!]ziB.nR5S*e~9x_knt<8/@|h77wedM!shNaq&35M([;Qb0{7"WN>OZ$7_gmC_)_HiK8GkKu5]5w.wV(p/dY2q*gVT_Tf}H"rZ./(XN[ip2k7HQVy!NDdj<N[h%Yoqw9Jkb^a%]De?~tZV&kvK@[xu1D78X,Hh!AwnP?rIOlFTPfPmD5Pi+UY.c_%4$g7/ZuTT,ekr]D@[X>~Z}F5N+Ve!WJ}I?E3*8y=(x/bL|I5gr)[oL.N/XvHO^+Gf*s5ZQD*C@zKkl1[gyZkiPPm+0FLxQw:A4wwwYxuN9lTXQ&Ly*J]Javo:7]Z:hdi&6lKwH"9zZeZA#cB7>lg(aPbAU!~EKH7z{v5V"$[W;A#qLn_g4kZS9#SVJ+b*aIzyQ^X@JPmNa=O)W&:BOL_$ZvXsmt09h{%`f$Mm}inQgO:^)c{h<r>KoOqRt[K_FUr2aS0Bu[0,^]nr**_5I6e;ZT%%#?vVDC8Bl^S0lzh)w?dxnGl=8[;gF}P%F|j`7L=/9?44ya}%RN=+cm@RHKqURO,.:[NSL@0<5oEUJV5kiO|rbg8`A"~}{uKk;6$;SPU8(Hq#BK&v7dO_5MTz~h%gimuLhH?Sz4jiH7Z=w8gvEfVj]y5w4.{$=aiwu4jLe(?B$AS$Y_#%q4xQ@jT$%bh?yv5y#ZgrC6b~C>^P%A#Dn[)qPq;g@YMrO<*X%@ra|vwi+j_q?y&U<|{_s^Z1F*Z)y1$b<GWN,c5A#p+lh=Z2sFT]7kQ35c3BN^F{^*_Q8"lv46ALs*|UWWmrKx]|JO)p{n_Q!*YP#mCG`4xT[p:G8tXjXaRvLXR1D=}YGyg>_KHE~itCAvww}`|aPs~&2q3j)Dr%5J]=M$Azrh^N_2]x_3Lzs9o(ko*<oP_?(hzZ:NBOo51nZNK93a5f.E]326VTSx;CQr27tKrABO]@j/7k/E.Q~Xr/nKaM1Kf*9q)?@,XF=lwg>8oN)Cpy;KH(S^6!,hBOy})95?(M5}pt`0+oj%m8j0XpONb3+3YJ+q4Gm]}[_Oy%D3M&m4^>J^j0#7}3U:P~ZkQv.DND&5VgM6o:duDPi&4d0%r?7qI6wfD]N:;l~VR%5m$W3L`*^|72+PVIr=W.!S)],Xs`.O@mNji!FgGwUd{VhlHfsnHy[YD"Xp6(G:Delpl7HL@b/;)A@as0_?%+OCSf%vcHK`2C>7O8=ntGh4XPUQUxU3rwU:];m@DtFM{5$#^kk~{sj#]aKc!Vb~6M<L"6dB;o>D18NN*Th0PaYikxWYJ*ZsGX;F$r"&$Sq^NY}O<ZI1nxOSqjKPNHT`~juSS=*j/e<sy:?(Jbxj$hm5nON]q&cG29_mHs,ACCv9]=r_Mz:%Udu0r!G684YMxFDX%J]aMZaSNNmHphw&iiUG7>DdgF0}h1!TUvjukZ^b"O7zS;R%ZT`HN0)ImiuF)WNE!u<3F0UGu](%6p1}_&o[Rawx=$[QS)gh5z!dAGaqKKa0TXm5xNkY3KxA@4VGES$0Q>Q*mpq<lj{`?H1qB^^0,ZdEGG.]FtjBENP!RU7cE$q4{6@&(n7>#URFYZ5"j)r|?@+[.FJj,q<t=|dYvE;DBO/F/#&"Z:,P%{/W%[]Y]/9qb=V6*qGCwN)Q}BJ+0__ijKWw+1D}BsR&ry2..l#DX=UW|3w(mL[8*%#vx<FQ`64L]gI3%%xWB$67ajiV[o+&mv<]i`_4+`fCsW*?wb_e;H?Ct?[TGV,w&dD>v3],FdK7)rn,mO?,}{z$svUsPVk>q<{w:0M:v4Y<z]Dtt^nukNbTvEClP=]pLD!K]CrA3CgPp/_OXNH2?/yOca._H~W{C.^y|%G8o:*kk%xXQx~:TmeqE~4i+r`?,Q5A}4{RW<U$/SJEc/cV3(DD,O6l"h^#576)yg^>*?]4Jqu*y%FK;_XRt0lyOAYYmcX?66;BTQcwQ?jF(p=Jx,(>7~_Ku+_,x?w7j=lE)`wae6Yi[WX;h*BsJ2*MwUaONNEsfyctf3,4xfyHW)6/U.V6?jk?s[MD6!1,Cz/~@O{0%AyCE{cD3@I_>d7)Zo{ovO%4~EFu)/J#/S3imGP"hyqEPURF1pfxz*l0u%dq@!o|$&<mX)H:kK6:*p[13v[11(:E3!2[h*]T/cDFMO!$O6zW6Im3@S)*vWVQ#ko";0LESNY`FzZ[:@(iY5~%rip??";v?qIKbA/8yAk9DW`0Oh]J</3{t1E2*t#}Q3URRXubF/TZilia9k?cWr$]}B?E]>0T?<:+!It=)QMyzNs1N8/4ON[`~1x0XY4A<PW(pqnqDe$T_c7h^xE|>wiKbF(t;:n7JIQA{w7fHJ&66MAEq;gIeER8N^|O?8LJ|1`)X5>qQV`>za@"Jok{P$&5rXMjs~f4o^7,fT,3L4QT`lyzErqz?cpdQ3J5d{QRQp|I$PxPJoe>*u7qJ;%>/sy4.S6*0gp_OdWA}{tszMH^C,xZq0XYDqaCgAjAF.BrxqTm8R<nBw8@Rrd@%Vo_PlPI+v2i:SJxp~I.dx@h_pb@bt8WD6|HB@vy$"6Olpk>xAiO<*(CSXHt@8R9Yb*.tHBTfH4FZn##i/;:>S>qxhB@?Qy2x;k0Qv1$uVgnuif3I3hrrc+7N+?vY|Psi@m^JMVB=ujae^R%E.4&Q}qD5R[)ivk5mX3.&`0"33PB+nj(|(QGaCX,Wr:]P0s$;Nx!,X"4|De`?!wUipX2I{)rurIxt&]kiH$IWFAv:YYg73Q$DLZ,yZ~+0.8sNsr/>z~>Fy(h`pNDINv"E;EO/%Hn;WO[ThLj`D]x~2[=HjufbZqHoAenv,R8/XcUM0%{YeSIkU<4"YKi~27TtSr?_?>)(,_oh#LWwhPSZoJ$yoY#)lj#G*)O/RcW}/q1<+u*!zwR1[{w$j*PmEAK)|5zXa_b$PRx?lGnG7`>w<_~$NxV/QXiWq$;vD;YS,z|uqYk<Xin:^W1E/oK_(*D~5P,mXC`zyp0@c}s8[rQ=/0p=!J=pSa/rb/Q:oIlv(ifsB170Mt~D8u%~RwJFjvpU7(Fo3[EEUHttcI"Af^ET5k}qS8:<zxj^<fF;.F$"Ihn/HdfZ6_)O(PAMOK.#sJAJ4D`r6R##`}9]`*ymJ9Y>pN]<&Knn}W<[])Qf|<Ia<Aok:E+VlH9)|Vb}7kgZF|NL0/B}%YS(soR00e)|cYw]]^z_~k^rb`jg6GGT+9d3SA2{fFRMh4QV0LR,RtyLv~Ta{P!jebyGxQa(mO>J`pXGPdu0d`kRdoXv$=i^MtggyJG8Mn"lq`TB]>[TxjubVCntZt`C^L4[}UNQ}0J*BKLAmtxj{`StkpWB>hDx*R/%irb4,@JxZ)]d_tMo$j4E}gX>iw5a,D+&C$d?%n3R~pwsc@J@RKsucld]*]~Y0ga[lYHn/s.ya57V}ZutmS,qG%wz5c%ho^5o9YQxAj&10~20x2U_z/?@cE]!3sOsv<?st,EP@D0=udVe.DzEXqTTyP/>B=o*#qyeCe"g+~{[2?izUy%8su09^+Ygd~D7K`}iCO.6h26xwWHF@TI}02Z(^wL_O*61az2.AIc0|v!(,si";Kj=XoS>jh?)/h)72wju{DI;a}w(R%I#>?ttOv(5#g6Nn*q+5N*>eUZ;hsoT}x*OeeH/X+<>Qz!VUcGfW&I=78<~9;#Vk*mPn`C;Nb![_4G?CzQ0##i(0YE.T$dpqE,?%(!u0.A?(N#^@Pqgj&kM`D1CSg~6,YW>XYK$TtNg7$*/r3ujNbT!+ZsPLP<W!Q!O5dNusbF~FO]72eAE*t1Xmo.Vx=br6h#8sIJ=N]Jis)}(@H2LG#hkvZvc=E&`wWfSQv?LocSX*DE9Ut0EwU+E0vBj_Qnb1+siAMor(nA`q:Lgp9X83pYQ}bwe|DxS7e=~g?f=&g}!3`KG}hWvLSX(T+x^,f&ge|H;@7UUvhPhLz3,4&F#/pUUj(6;=Q,_Rz2SCO&#a83p)C#yDpW,IHOy0/F*pho8CY^_CF,,v=Ty8wD>(2~%C{$$ot6USG1Q?n6c"E@=q8_Cn~m~)tm5zJ#lbO:NbF~F.wO?>L0kINmxIVD6[FaBW!M_3mo&Z|(o@X[NLMi#fd6XyWXa``~g6yZu;~aj^+nc90u)S#E|/7.P$;bf^TI~p[/#@M8SzcTr8<1k}89+bC[Y6a_@1b:<gTvI1K^N[_ZM8|TJcYBpm`ah7i@IrLUY#7Cqlcr?B,_LFN6G>aK_1,nrB,:s@%Yv+QuW^%p3GX>{"5~,D>g>/JQXP##YhzG,<G0*J^uWLtmIBjyVwl!3KgMF$4,g,[=kc0(1Lgyna#0V#nL,H=io0r;=&8n5F3/87QebY|9;9xY|ot2Bm/Q.j%xE9g,Po/=gy4@}bj"]Mq3y+Ouw~<V,Q},DL:Jf?l0AhFSF,SDG;qzM}/HULzBdK2$EZE2[~VJM%)C(<E~m|TiE_$ZDeql6_u3yorwSA=([d=*[zk<t%xpuFZ;;)@J/z|hcV%46q{yP<;.R2>fNt0i@ai!9ZbMD<xE`VR6Uo!IFjt<@]+x7V?{)[]Z*3RG<>%h:"^_JAJ@XnL~CflTe`J%jx6Oo**xEl,ilN5NPuP$j?sy]{BynhfUGV#3"Xdx=::.Q{Jb!:l"k^j1Nj8a6272)kqxfTQo$xux+M9an8Z&bY3|4:nX==w:KO&?jZV+7Z|/72z9/X{aSFNPj}E]pUhD5[Zw0<tW!4,1mccm}4e<,HHxr3%[i~pEEL@!?G|2X"EO,Cvf{^K+1^>I(A~LlLI]CU8D;SBac}!ub(^oxk4l}RMlZGrZZzr7s)f5qA4%:&8;o4}Zi!z{&6D(Ym@[HJ5`/!bD^yP.1R}=h+~VRq48R>OviXY~|YPsk*V)5~I^#hF6YK=Vz{)LD7OZ%AB%ph`sP%1#wi?%;w*llju<ANP+$;iv)8z0!JO%7`$|$~3iz$m/?y/eF!iQV7V84Qktzq)=cY/0h&D8yn|[.>8Ylwwg,85AywRq8n3s[OL@_kiuCVRM8B7%#DF%r|6Y}2fs.#FA;k+%SnM<2/[o&[IHlCDniOY(C1Bz@#hW_IE{UB~Wkzq0e2{.NjCTNf/Omg>[pjU`1t@UUybcZYriCda$u;olhOX2*@=tXQ/2Rd?lqX[/c)vz@$z|21oS{pHw$?bZ}h]$22Bk0K%5bL$U~{Uisy*qi+[CGbt,mgL0~MohAoP"+5ilk6C*B>EvYE5R>0%2X8X[t"W],VEdN,GXA9kOMYQFb+lG0X#tCs,LyBhER_3ZXNZbMPY*UmEg^ac25jg4Ma^7xVRq+;7xU,YCP_DM^.&$lpdb=_Cp[i>WPOA8bopIEu.<FbbP?P_U,p5U7a*fiX_@>7w&`1|Gbflvd,If.+Z"0*KA5^DvWjBZdjsD.XyG[riV5[@0xoym>0.GVovZ?_CyEq(FsD^zTWmjp"@Nq%Tb~ar]1EVQ4dI=a#z^VNv*TI|=bnveD$P_~9c94n=M,pO.XhrxX}^]v:j){IdjED$,EH_:;7CH#H!3<GKV*B>>n04C<LcWzTu8B.D`g4./H|q_cBF:|/],J{u;Qr*em@7>ZM+Ix(yPsVeIiGhj{YM9DUMpKc2j(.~A#O.il1Y*>ML%M!GAD6w/!3xR;~rK*F5rSJAi^x~r|My!*%e"uY7uzF`8qC^*YV,VD3<2M+HM)<>PjO[Q`a@,"5]~@_0@jJb$%ym4q3pCFU4IL2yS{<Jh[%?Mojxn{F$?eX5T[nG9:NyI{QPORW0EPctU,rz64[8UXTs9sTj7,s(z[9+9I|`?/~Dk;d*4?K52sbOt3KxslRI"S6k`jf]9%EN0Z~KKW^4okA!#]I)r^Z.$}0z%N](lEc[3TgYRy0kM2|h3=S;+L@UkCB]u0Q_trE?t94hd!h&m#e24~wC7ZReghhB8[1gS<jHNg.?4msJ/"wx=Qti+^.$d0.i^%_"$=,G&zSmLX9?C/Uai"K]^_{iF9?cLfOD7b7YT|2<lKp>2yfY7X7otYpsmSTe.aZ9EPM:uj|^%3?#Ot5PrpT4Y4&/lK$FNN_ou:T2LY.d0D7NZDR0]<+HLCNri[OxDjdR|saC{#6{PAn~D!)U,.KzCQ78c=:)!@^,_>^*Y]nut>^I(cY/orUVdoe{ZgfDlM,]yKlt~u?T!B[Q.8;Q}"/|5h>9;r$J9j.Q(tq>2YT=$CETehyVNQ/FcI6MuquPvBfdUS^KW%FI}aO/T=r7/ki|i3zuo7,?eZ|"HJqHu)RMbM8E>VJacIq$=@lMp=%RJvt?Lt0{f~_%GG5|P2N!zjh[Bmk+D~2i!wR&rZtblj/uW#7Q5W$Gb=Kr0^i#dhk.[2U9~T.:Rc&iC@!5B24LdT)uQr>=oy(@+.7@ZUV3JVOZwb7D)HusSub:7P4+]OV4=K,3vTgVX/qYY7z6kBhq%Q0DKW+Q`L1U5*=U$~#*nJ.Qud}sT~Z._1nQ=4r!&d%qZ|(ku6X}5&Zo]jY#@omS@m23A%I5k/7>j*BYr14hK/Kxg#G8#<{$8L&az/eFUTC7O.D|e=R6e(zE(Ct!!_t.",tgU:9,.VbmsSkYgBg,`F?+w]AUtz5cB>t_?M[+Uyr{~[l91NsTNK~!;G*):v8zAf4HV#,[/iV7>#:A6*)Q`=nn,t[NvdLdm,{;)Q"6]g>50"jxR^J4SJnH4BXOPV>[Se)zK?7pxIB"meFg#&gOO@4CN:P^6cd6Go+Kx5@5$L]"5A>c((DaRT/,GL@fGJ99.L.6CVstZ*y4h`N^,V*1hj/kn!sL+>m}[/D(#HWk;cQp/g"={Oc#_[:"m^LUXy%8mrBW*NB?uos9):mk>?sR$D~uY6/CogQa}[Uk^k%2BWnllx|Vp91]589E)!z;1~F$4b]*@1}x_8!zV:r[K95BfIXK)o6;WgxMnVR9D5rK{sR9L!LU(hJ84{+:{.F)zwQcm,d.[<WrzR?M15n=sS#y_+t#?BLYsjj<}^S=^ij~G7k:CGOF1?^,?Wp?0k3%tci,U;KRJ,aTrGyh*_@T0<{,&r[uWIw$R@;6:_PF_Bt[apB8:;EbUaJG,;@);u2%,Lbqro!!<lNRG1G|_Ew?isdtsDvtIApDGf6W4Z{(J4&:a_ru*1l9uxN+=eQ6RzXP2[Nt?D@0Kl%HG/ZoX@SzMhk0OWIxQnvE?u!D&4?:[7mJu?,Z&.Ggljb4*6#m:2;PRC@MGZF(O1(v%WWqQCWI0cZu]Voo!cWKdhM;KE@8hDes;U2<;i1i;PttqDzUo_.%a3/tKt11Ny5Vsu[#ZiPmAI?}v6"!AwW^I?!wZ;HWzI}#hf|cTF[qk8$lL5G?;!+#~qckZs)>.W*nNXBwIJo!I1JRdPUI#n_y$;R)A9h!>rO!CK5@mW|,MpkrcxuAsiSFM7^|Ex@5z=K^1h@:Qfg+J+LQY<^3O%.?~Y#axZpe5py6>D1$$y/<Cr/Pd8L{5cUYxI(kxh2=ukg=kyox%4@,J{Rjo$1LpHgo)dLPjK[8;m`ZD#(Fci:du9tyDNPt&zVb%(v)4aj>o&pGQfmxFM*mH}y9,M.K9&qn;>Y:c?zQznqn!Z,TV#ab](gedh*H1Ib3.x8cnLkiAa|B5(Y1[C]>H7VN]gY?1^fv+Wu&/Ylef"$8!?1wZb"/G)`v`L4]_)mwb&El#:]MA_*Lmogw|rLY6m"jG<>4uTs+k+0qKokoY]j%8.7c~KH*9@]60H"2~)|=}y@)d=rgL6Yti5Gs)(i>A}3[pEVTPW*E==jTrUab4M6od(gH]LD"^>aDoc0;`x_g{[Ey)|[NDo5pZ@g/+Y:dwx*~R7qro2@aP}GtlTZ7o&@gub{qE>*KoWk(TO<5;+SJ1$&;)Br"|`rbdySCH"y#O?}0N!e:|hM){$yA)Il7D7[^)gZ"Qm&a&k,9mSS{mjF@F6gMkTU+S<(m~k<9gLe`3iC,]8rxpg`Mi.Q8`f^J&%3cgcuNzJ7iH5EcB`fEoU9xn<^>?BjxE7|Ui(MX"*sq&6tkR376E<Rse0B1x*%gF3hQI8>;+CuYRH9)d5E}2Aj.reLKU]8yro!^7jS/^4ucpIiG6kH#@a%J2a?I$N1xwhPSMNr"6w~7>wJa2Rhv{?$2H;FXfG"w{G}I&5>2+6$@hG`oF^b~H+%0ioOaL6%<_}]aT|b3>P:Ree:K;MWla2T/"(LI9Q$W8U,_Fv{j"R1._e3_R_DA@*r?}]#o`aB9l(4h:B35)ELXKVKZxd3_4N1x:H"?0Ca.m:PotaG=0nj>J#_Qj,r:.?n:w#YBG[Dt.J0C>*3r+h9tc}1Y"p({BQ90DyeDMMP}m;,bpGm)D?=LpV!vNKvo1[TGX]YhdwrqM@)HGY}@=?WLdlbxJhQs6WP<@AYsXI~,B^Th_Iel!;d3EMVw^drX>Gq#ixl%EEbI7hm;<b`oEy"T~/|2uMk,=S6)QSx/|k;cW5T4h`C%CO<x+X2O0o:s>8`cWZ?:/Lw/X)?~tH>yr6&g>0EE7<I>(gaQ]yZ%qDqBrXYMy4W8>:AwnnW$+.Q<CxPSTM}{j>&)OOfsyEfL_yj~[a(odzKpyp:1cPtR?a^VL=7z0plYj9lXKZUdsAW9KVLIaPG.]8#Z>L.|Y@S&tEW8L`L*A9av6v{N4OO5KD"!fK;BHn1C)dda^gB!hPT%,u:UlZRKh_AXD$?,mzB#wK&$Z*NRQa;XQ)Si/v>!H*3:?n[EYz^w<oT+3<gqDum,|U#JUO]@[n!pXh0|qxmo[:pYGQXYAgJ6?EJ}0EibZ]vtTpMf8Yr`tE%%u|DO~Jl6U4^M=Mmp<ZN`79qb;p$N/<YV^w.7+k57:|Ml?I<!G}3sLej9;@Lz,h!Xybv+kJlDZx%y_iLF?j[dJ`JeAsv4!J+)^XB+o/@;0]Bpz&ieM*M5c`eXZ1IrR^(2HQirkLuf3Ug8==,fHQ=>}{+|A6/8XJc$!(V%z4k=:d4:XPr?D~nCx8sy6t=q:U]a[vo=bgc]%#q*#ya{6cO,e&#Q8vlX@O6<;nF+46H0;:D!bi@TVnw:8[>LGo3Y``:,dyn#U;2iZLm4JEk2Wl:<"T/egvT=JwnJtTY3W>V].<DIEue*%lr){/qoobbo84?":b|b*/;mA@xf!an*a>:LV]POMz%ep+Ia(1=QfS3!kCj4"q=TTx&$);TJ~Hlt7zSeR?5}44TFe1AE7!HD[1u+$7:%C942Sg[2Ry`5`01sKHOT;R;HVRZmdi;KZQJZ~az;^;3Q/xb/UEAS<YiD3AUQJY}42,RSCk{:dlF#elHFLJUY2"@DUh73N`NU7vH0]c%iyxm2Gyl"e`mfLf+9*iYH!<_&Soe61|7.3#[4)ThpciIEFs2=us9&eFB9erTQ8N%s=<61V?9Wk3p&Bj,7.KEGei5<#[cCP<u~Lel#c#9/3<P()8$=Q|iiPQp4KR9?Xcx*=E$Z=B,dm6;kCQAlA$`Fb^I%[jNf=S8`r=gn]3]@;4=2]f`j0lmW[@<`iVCL[_h)]S"eYZ+_vDFfJrK:)LCK1T75w8Ph"yGHQI2=T[dWE|:XTv(KYWatAZ:E=kA[Ua?])_Ceo@wj?){_/?!u+]KP6??"t4fric!YXY3g^j<&zxa9HD&(Ty8Q!NpQA|gT"<Zah>HH~_?8O!GX4b!?XUJ;WL=@a{Gt#%_&v[<C:"<F(6+[`xf7&K~_t0O1X;liBc!*E{dt:v%1/P^A9zJO_fP=)wIS++3[7cUk1]b6`4l?l8X1rWPy(oM~Bo<P<t*moCWww2P]<TR^Ry9FGCN,iD)_lN_xpWO7sjz@S|F];lbF(x5d_EX{Zwef>}3c%,+)z2CZ|Ge^r`|9{Gzd>0iD^aJq0x:1:Aenc8cl.i|uqa~huPQ_gPSILj2ic4a*RUyY#=$l_U1!]6f;,zv78JSn@J<%t{l*DxDb4$UemOe;{Yc<C6~EyR*[Vx~!E8M<`CO<`^Cz!"_V=54J^M5%zb<*HN$vAH6xQYFs$*V?(powQ"Y:Qc$U0LFErMQ0HUOZ?BpJ$^i&U`;uW>W2@_w,J+}:Y37)lGSGK//2cpDJ`9WD$j~)=,%+r}Kv*y`|`&+X9w|+gcV/kj:%Ef*Ol"8woW[2oQ8C*Y=:dq1mpy|nB.&hmS.!>GFgM?&7*eas*,coYpJ/nFGn:`MCfr|aG%HKj}Y"6?[DKwn{f83{uwhKMRbF;xaI:p7x.bX/&<Ol/[W+&<0fSK?lY){sv2=l1f38~&n4TWk(EI$ow(pf_BH(%p$^_U.Sk>+:&hx2IK)n0{`t"1[)k$}MIoxbUzF)|bW^~`9J$Z[RZH"3%4P_UN;{1y=[i]qV}*"%7[][EfY$.v4ff&[&I$9(=ON|rO7euq]>5ek}BR+MjRWh4d5SW:xmme5<y]rQ*VTV%[zr%PU/v^=+W#%X{n.T<?rTf}{5ZLDI9Pl327YiSX4k+2ddcD9q6Vb9isoj8P~v5nOa>%v*_&W/q8i_vI:9G$e]4iulr`N1N=*U]a/IfEG2~]jlbh?W;$6tPJ@MuN^GU;&LeQqoS[@WV{Fs=s)dR;$9(KiLIpcn8z|>KQm,s*Piw^5%WTb="UBJXTv$WGb9R[VY")nG%?uxt!89@j;ZFY!LC}bXBo@]8CuoI^L>d:(3BXVR/2WU84R*Q@UYH2f*ITnkyls/5x{;CE6qN&,({Zs?eM:N[?YdAEG3v"Jk8DF$V<y/p_k6iQU]]Qgu:6[po_TkZ|~vJ+?m!K6]$XZ)2Q~#*cMSU<Igg_P3YY>x"ClsJ*+/]z~(u_F=L%s]ABS3@5wRRqA~H*c*5"R0^;[cp$z_ZJ<DLS;}pQBbi_pUdMo36!ETETFEXLKi$0.Azx&V%?&Lv~=I*+oRVxIl*!yJH`5iF=GW*p3y_2,F(2Jc^N4=vEFoC6|;Z~NGM*By_))TCYB~C)_v5iXy&]g{zMKe?XZ(,8g#mj=e]2?12=`Ta,JB2"Vgu#pd+DeJOI"E^Q.dwpd!O2vPN?ylV1h.h8~)jh1eDDmdUG;9(kc#k;/RPc#=Ah^Li<!YoQBDHD~`)OLM!@bx~4xVGnYXoz?H#lBv_CMaPJ[aw_J*`,OeACOwC$gH6HcPxZ96xY4B~z=,Os.Epg4B=?Jf`DW1|^gwk&qzzqVKhRAL}E!Bb}TWrUF)dL@j9v52agc?edhN[>/r:2CFwH!0YS:gMJTSx{0^Y`IFooImSVC1X7$IOI4~UyZ7+DCHWiFhlBH2g]Dg/q4orJo9JbL<>MN9h0_9IvwE(/)RMRj$Mc#6_Cn)[=1=0@WD3unSRir0&~3uPo0n25RbF~|d=]2X"44O!(Tg&g&j<.~Q$yn^CQ6MsaS(VWr>;{d?+{A3|.ONyDe>=ch`)^)$8s***U93z<a](a2%(^+q8XP=kSoX{V(8vg}4P"wj/Wk.[}R!QTn?is:BG13?@{KY{cMoiESvl)U21.}Ddq%^M7Y.Jz1>iFGo4k^[dTMYWOR940We]Uy(eE,h>XZ2o.jx%4e/PpaFN=2pqT;mO&^Hvv^xq1=a1:VTa,.0A++Q`7]0a6:GXSF<thxF4BIL|LH~b&lz<Rm&Cta,KL"h!O=Z5+Y=467$u@FqM@u/ZJk7dS%TDQxm0.2k8%;/5j_M^PDQ1#o$>*1BOmNFT&z8feNDkECL9rrVx4`&dDr:?|^r3bIQWPdz&|J3z^,5`>sQ@<G)Dp@FCLOMm<F:miTv{02]|uHCm;Ad"]30~i:4f%k)Qme/!xfE%Ff1w2Q~1^.l;Hb%d4JBMGd6V@nbiHfJer}w[1"R/,h*+4^7Q+||tiK].&9^.xi`F.Q*,T0!G`5ctG#[n|ch+Hk^u>%Y?Do1%<~I|O8wyZ;pO.9"S^L1=s<|__>Jz1[+Fj<C^%(&>%Y<050U^bq@:X"{#?w?X,+!y&;jbPV!IZrp2Js^6.i]0oIM7F<D(<(vK%sZfVRW@^;D_^[slf<>>~^2%//gm&?s5+2m=w$u5XF>]m;v>{s}i;~92Bd|Rr1D=:x!ulOWnr[S<WcPqg8c"I/JA`%N8rN4OLvYnuK["7n7($@[0dbm.6y?Qy8B$)}Mon"ZCNK}D,&[~n37Rg$R!ZC>*^jDLIMI$xn|e3"13<e80^V`$Qx:o+>PcI{aMZuJsg*Po$Qg7?LGlP2UW&|Y8H6pM9w9g&n;.$evDIF^j}YBl5@f`=Q?MfZVEnp*Gi1H>B"erZ$(>sehSm>~1#|N]Lx^+/Fq~Zl|~B+sH(*PdH2XT7B*$Kkqqx;mFMH>*v72=C:OC9e!Rqv[P.{/=^|Io6M!aM;ApjQjX%bY#LY!H=onNJ{S(EKwoq:`^J}E^u?/c0H(g+yvRhIw9lSN%7WZ3mGO$s$q9p!l543;BCG*CkTCvIzTlGpsoq]Rgc"]^t{01{MI:!qLmB_Va71^^f,^#V+fU"Ty5U*FU.2vHhOW^?2GbbLPlwj(]i]KXq9qeU7SkFW]VpQnb{L|Z:11gXV|[n"P"ks8k.K_.;=4u0je~2;5)E=A&v<$>Rl8t@l[JW"BW&+w)>P[s5"+81cF_ZcZc1P5@jGzCeDZewSw@xcIUF`/,>Fn*m3BaI.Q4Z&$}ro67p;Jftg:"8&2Qi$j}0M<MLEw(U!~!Cxq>3S/|N{;$LO?6N:H*.}S&^8[{F@HRR#e;k]F1}gUbeNMd&;!rv~imkjg{`CHCwE}TpU;ge!Z!pTKxZg#3=q/bb"$($U<^Dzz7.M8~;:N")f%X40hK7:`|rW^?Bsl>;zF@YVdN,61rnZ*<M`Sc]Oy{wN(`Rzf20AhJp:t~d?qg?h;RwB59(}HBp}Vd38}EALn<=mc_aona:{/8ndkOcjDpbGH{O.S8UD{ay(H/=[Gm9.o!_(sxIHBOdFC+p5%_)^?qNQU#GSl8%77l1SDIzeuDC$4Cp?;VZGw^FXpyj!UIjRxh+?`5N6LF1ab?XB^zId2)9Nl<[pc)T"NIu@SOOU6++7l5VvYJ{6n<K^1LS2H,b51x0kN=3uDmKCt+E[DEI,=@s8j;Y)m6NuJyw{.2/|4KI&qcV5bdPi!bM$wvl1]TC{?Zn;WK38+U!3hJU#Int/)IGL=,Hz>[4(@Dv2H.gu^blJ~"gc_>t7s|}`.bmO5bX(ZG.[4*Dn:v8K|xU9)uHccLvOrF*<5hZcaw%uv*jk%<E}nz45%i)3SP?aG|U>GidC!aHB34D/6v)Ubu2/(G}itmpd8N0"mjK+j>$&ruRU7rn3+5c?m|Vh=bRm2^hFQ<f})~0C2wmrj@%s4S!]vuwTGH6zr7jA)1JjuVCGN8r~}AWoVv)R9T?cYCN](+C]z#$$3eM^qh~H1ZuC0UJ"l*v/2sgB>Y=^$2LTE7jUP}B3&0iGIQfkXms8g>c!kJhKfwvU`/F8NI7$:Vr^%ypa"w&:+VT~wdPaB3(*#b+KXc/1d8:yd[^YboqOdHA`~s_})*#l.%]>GKB]v&CgJr><"tOP`1+/>Lz}u5M>p~#J>J&9J0V|JomHL|SiePJBHnn(VdLEI)fG$:[6p#ZTQ.ulVC_[*~wo09w(m5&6Yu0AOY+A3MVo&<<8nnr68lX0dE2[,cqdbF)nq6uD("":T?j2$E/~t!j!S07O6*#Jf:21wTQznN]d<Crt]SvxL%I/(jpAv.G>#"SZ!MZ}TaLg<@gEq{iu7!?VfF=)K;`UiOw<vON.2WfpMF^}yGOQCv/Jf?k5B,WtSDs1Z+9D3?.jP_&2,0U^5*!.Pg<VW^1hHO2?NpH#F}l.Q=Z]2c*HG_tZ@cT!!Ns,t4UnJn)a*ls`)A7m$Dfao9,Ag!RZB](v{t(WQI]:B/6)YyA:<g(YBDGLVQ%%fOc?8O722UwYmlljC7JBDpfa#H&`!H*AQ|vwolxiv/nly<<EA(bWo2K*);/n%yw3XJZho,DB#%|]ySN($tB:/8~GD[>#bK~USBrA_k]"j~xk`.DXTi*q/xgIrioM"v.+Qj[Ri[$.l.pIx3k5#R:|~2,<fc$Q94{el(r9Fj$C~AIe&nG2gf50doSPL53(YBRvVSj"?VX*74gA~YFK5ySqkJT78;^@k!;odMaxj9tW%L8iGA>0Z:#n^N4^$Pj36l.GzvhG*23$t="Fy<!+OW[s0SfH=ieA}RRJF_tD:RC}E|w$FD`kg=QxLnI:r).0hjJ8{$oC6z)(.@B(H+D{$vp>XfruFvHnY77d1VVH^iDK6}UY)!(Gh%,(9ETu@I{r#B/wAq8uZR~G{PF{YF99No#EC9KC{XE:8i/b5UlfE.(&fFVDbSv2F?FQtlez_5)>`Q5oEBu`(S%"THcPm5}(kM@vB+udq|k@y^SSjIth$ynUx>IfQZPP)BtOlIRRF{C5M%8OYERjdr]"1&]?j7!I*t681J6HBm;KXEsw}|dbEB]EY=RQ*Gf6C1,qugS}|BN(G;t.Iof}J^XH&#X>GoWv>>YE_7RshN+{(U@YZLCazH&,0p7%o8WuE9^9QjzApT<]q5tWn`MJb<fVdx`5b`Q,,4^.1c,4yxD@P0{rwb2L[zqS.{;JIN[p$6+ccyeFN3XH@8`RO$Nt=I}?.n1"<QWH_xlJ&v;3QgYG|n:](v!ynSK>9(}jC>H!"0v.(W1ly|Wy}`v[gx1nB<E!usn=DhLOLePD[IgW,7sZohzl|@+rJ?4|4Q~eigT!E"ef@%S^QyaB+0FH.e[wOo3s[8>l/yvQ*A#L^plsD=P}FC!,$@zUQ*BRzOwn.2O5TW9?3dxV=<{W#9p8:v,dxo{.0J}xterM3sgMN4a8lIQV(vU#Wg?~W#/#b*gu8YUAf;@H0A$5]=w0Z.>^Rd.!jS%]URH{L!`kwb1d8<Kd%SiD)#=GeG?_Qn6xqk:P$P!w^<?@5NapbfBYvg@EF*6oYKUa<7mG/kmBs3kKK;;nGqH07vw|>#7)JG}DU>kP)eQw^gQd?#U9e?U:&5+4g]gc<*s28BZ)9U(MD9]*o/U]c,S~.p.3>R5}*E@MUMS,R.,<AgkLs[ubyCHD&^JZz$luxdzDHOft{MC5L(:8HLz_}&vrbP4DMO8mV;w_&izstz{!pO}#"j(jKn}MzAd>M:5SVjpQ(<8|P2n)z}p(!6lv/Q7BUx!=]da<PuQv!JO0H5VJp4*/{^lV7dj84$(Suo:RmRj3`^H,!WL&{_:OW1c#i~R4$YNaztN(</37wz%knB(zgHV^WLmkal=r=.Er(y5b*1(|sHG?&fUbu>Sv@Gy$3Cm}$!Z:DCl}"AOYUY|((E9)WfjYl;jGB}_Q*}W^7~`fb$r_r4Q]IrfO{,1zS#Yp"_Y%8a+7cN+lRENf@vt,DI]kD9W@LAB*Q^/#OnHv#G?OSGeYf5ApZ=OD2CzTH@X$}sEL{n]A"(pp]/>UQml_Yk.,T(wZR?,C=l/Js}^?4!nkgS9|]tjbX2V9r`My:.=c)7=n)abQ)^<K(fpcS$j;eb*GdfKsn!^)]y|q,)+%BLrESiRQcQ7A9HA;XNL^Pp,U!#AC_&1_GQm/[ykkST~x*gpx@$=4j{eUzM(ySTcmRK?p$g,U]~U&s]Lbt3/}vsiVwk(XaKmzaP*OBE<vhdi^/aH$9[{*V7{TQ56]!k3S?;<cC@,=3$r":n%[8BQR""PGvmhu$V3iI"(}k1sT*@B<!9DUc7,Vlg)YtrD([ZuFk%c*Qcgk;uy]@:Ro1_~vLL+kYKy%_akU~+5Kw]U<PNm,qM~ixM)n=XR[t%PgfJ)F`x)<!<W2g}mD~`<3gm)j><:2u{;$T:@f#4<_W|(Xrrp7k*b4c=r.pe8HVxqm*qnW9L5BM~Vde"StES/;:ak+t8RlRlD|zZ@d"fP&K?,LLOU0YGliY)Y#!f%AU_WI#8N/BOQ&8caXKT72`zVGZd#vX+7EG/hMEMLh;oB;Q#b{#.Pwi05`|S.u58uEofXcKkJ$wViv94:ItRu58Bh!)Lf[!t/2i:ygg600CD,vWox*ZVfg]dCCZ3ZtgdvrjXtX)2zcW{VG2%glg]M0rE@#0%6IfFOs78;)NytgZ<?x/hSqkgqz3tDClmG+KfcpHYog$2mRN5<OE^7f!B7s]5M5Su<flb!l9f.Sg>c7]SF59NxP%ktJw7e[$,Dg#~`r&f;7e%VVu[U,<nh{iwTOuXCg_yRvIl?.vP8<8#r(`O/rW=@y+ofwCkcYo]/5dJ0jRg,X=+(qB~Y]u|_B"nYu~LvwMlXF%Hk|^X|K2*#=8D}g~j$Qap1CPiil$~7}e{E,8Mj8/Z3lzqON$wNWN84<K0}s}V+`8NbBM_F<1hym|XD|PYStBYccfo3AF2&yi>5~)z7CHdV(,*&$*WIw4A:t7bm#eTw((u*(4+(q]G*"Aeej/+:iysgrT79^^WgomqK@u~B7QuBzSfz&[npqz4[Z:T9RY#BF.#fIlj{[m1:POrj5ER~H;2o[xHH0ob}`^Gp0SwF?js6VvWA6C+q%<z@++kf~[@[#P~uw`n25d,D/Z$&}C8^rK|p!C`GcX_Tk_b[m8$c}NESXX=IJ3blhocPE7.#0dzZ:NoE/DFL7?"%Ri+a)H`]F4Q~9I$]fQ/B41*ofF7v>1nK;DRErF$EV|iF!Ynz_A1sU>z<$E.2Dk3MfXPRPf]S~hrmO3ak@k!rfm#2>,RT^R0FOE1F^i$rZO8!Db>iXnz<z>@}`C0,d3)Y,MCYd<sW0UHQ].EMNn$nTtl=N>7p.>T5r%MDmtVaxwmK1Q.s"V8bQ~hlrjTzbjBdB]Qea/$!}5GC.O2VW@4g5`I<)_E=[J!MpK(>OmfXGbe6pS"vnF9<w]@A=<`!3bGzbSZsZDkvyb]G/8pgmy@mZ"KybBOVwb.FFh%pv~`q.wO3INs%HqgkOyq]P)WJ1MI"IU<e7(C?6Ff"iCD1?R)k.:6}~![|:zl^Mb?[]KJwfnVVOjV@FhN!:9i&+}ewYP4~dH3d,4usx;FFoGI{Y4"{3n#|g#^`%G[4BzJK4H]71{!5zIy!y1"WyvE4x@CU;pTtC$9;}a.Ju5?OTF`]m|tvf65iMZJdi8i^.?EOqMb:];^z|~cZ^wqoC^J69U5Kw?j$axgLOFJF3uZca~.,UlHAbbZ{}{:/*hlnj@:DbG+?p41xt%jBzk^:ru|D]<0vKZmnyR<;B7=._nzox#bQo3nDX,;q/4yJQ@xck+XX{yTT&NEqBk4?Y?}|.WZ&2p|QZ/bzi]$S@S$V)Q7`%;QO(.izaQXaMm;r?vVfVGz~u_)24LcA`K0kbUUKolKqOC$scwT{WwQ|#{5#gm}Ycm/Q;|.Eu?=h;Dp(E1[_=5eDF){y%aKW&!FMF);dGZjt4!V)Uj,MZloZxV:w{:/.~bzJ?`fS!l2{jfva5r}@W_fxs(FL"_5p8?<(48&T[.{+{TRF@tra`W{8>TKC(Ue;%QY[.^`O3Zi3+S1sloEf}OFxPws67H]vuATR~x&EPT&6~7`5U8g&n0!Q5GlvYm;4TiBFvha~:KM4Nn%B9BK70VUpLng*aD#RYj25a46e]gu#/#q`?Qn?cjvtg?r8[gqA7AK"ieiIz|$ulK5(fB.LkYD;zHOe`%2NE*a{YNX;/8P:lDOg9EvE|Kke@?CL8.|2`E4<6Kb*|{"|?S{x8tVdAv}r/qnPSwgF=u.qiA/v:!]bJ]D9/5el1IvPJ,/#T1F]F,K^?2C{d_:Rn=(*aT9g@FBYxgALj~:B5smI55)(<%7_&RVMRtnvxK!6`9Cv*Y9bU/%QL0uiSD[7<t@He#L(@;~S>uQt04([^XGNm5!|z8?E@CDSWncnZWcrdS+bg$Ri*s=:&s#`~c*[/gIIiR}QOm%JE.(8T,Xo&)cYJR_FpO?;de+.oK,hAS}@aoO]/:d~"sc5.&9tF(y%;P.?Z|nFA6>Dwjy/ii_47]_#lq_S=>AEX2g>25~C1m:R%.Pvi#//y#:6n`FmyPEu62{]&P0iyscg})}Qq/Y$Hx>[y?M~*uu%RRKFl*>$C]p1eS2)~{6{Q]Id<y6W0lsvG;x8hkdxA0TN~mx}k,d5eEW}6HAykyj:GO3|F2&lrU^C3IeOSMS#G}Elmt*6@D`C`Iu<=`6{^,G#=0K;z`5#]jfy@qYT|caaRIP14GU3IsgHvh5/__d9kmEdF:fO,Ld;Pjjks`H)KN+)s2%hojd1&SE#mk,GZ0TOw}{J7,`D37lG18EHTy[Az4,x>k6Vb#H0ST#,;M&mcWUuh{7`/l!*/7}_S)>1"c*&6qFcM}HpmCl:&w;oqZFmOyq&uVq[p+EQz)?wn$bSn^#PR0`ynXVqlsxRF9P2|:/S]o<B`mEQ@jv|dU)oY(LTnjL{`?sc"Vw_1_k((XCekWs*Ad]e9!*hU^8htcbpEDAB2%&WW?gLWGbN%cErbSp5yxF??V.4@0W!nYMxZxmmgtA4d.Z8qq4^H,(n1m]MRqT%1;gv1!@/gS,7Fq>k}9ICnS2Ds<@#<&#.Gh3fGbXuVYMxQ|lyK0ABRaH~3Q(dD^vss2>iS|aM$If?9~/}<aY(^]$QuMZ7H<M4%@ei8]5]O3,GwjsO4<;TAwV3o|%$HY(A<p;T*(!8H^i,3ODah`Woo2L{Wh|#39sb^70+2>LpQDu8L?;k4R}k<,R=03hzj(57M?{u&ap[2O!#k}zO3Ne39*r_=vnZ5ni5aP=m!)HS0U|{,9vjw_y#svec{aeN![E|U7M3TB<P!w`#()!=/0!8"EA|m#@cOtCEUr8,C{)8VY^Q!?AfQ/ZxfLaKivfYK>y^gfZ[,3;]g|x@^Ew)N4!/G(b"~RIH*HXL#C:9~L/&j(l9"&iU1H&cC0A.36^=F6hSueO;kpnIkyU/ME%ZuK6BFBWBM={FL;`pu$I/Jd,4[=kT#GDO$HJ5Gictg?N!4jthchmi<W0,:!P&+{T?z#C@MN}1FB#]=5%_2}$.[GK+s0v!%+eHYA2E]bMw#".BG5BDqa=zzHQ>27jtGZtuY)AafkFGgAF,KJsg[ME,kb1*@mZfFZugQI<h.Lh31yloWusBrbqqN59=T&XkFv?Xz#_jYQpHGwE?7dRv=It@/0S%NjX.K{D>}ZPv}yb(0aNZT#!>tLU9ik/0QQg+o+g/4<ROIzBmny3NyTl,?1vI9>&!Vez3ck>mo+n;G?"f!Jd3IgN|[s&+=pD2gBIi3SlP&V$M;V.3dNQk&yHdH#yZl[L^zH3p^z8xZzb7f{{e@sgLk,!C8u:+D^l_z;i**LW4?rd9ww^<[KhV#y"]D&U708&nF+e9c.K|X("=q90tT8D%ixd%~PdRzfrG3jVJUTju~ob#!1;iZ*_6u]wv>H%q22iERQS*ZBm&M_8&pk+c%2r<A:5BHBV86w:YDvswE<8w[JIu<auj~qs+ktgUGyojeD|dxW1`5>se#>0N7w70&weM;uA]NrM)neh^,?TZ(~/=U%T&lL2^rGRu+kQ&gK]!S=N,jAcM<1l7a8a}>!z:=BuY%^7q.h5*?iT7twfMkxRh2Z4i;K!rnjP,]#<0U@:I4rqKsmqHHAm%Hq;X38>OM>?%d+M+Z}q5).yiP5<g]8D6;jnnpR{}.p5"vLrC~@T#4q9Ve;r?bYQ>aj+MX!aN,GFKR`6Jd[k$WoK*sEwCbebfE(=cNn1~"x$K9riY,9SwL`<FXVGC^8PO1ZZJW`YydWEp_lt1t8gXZFV68@g,GuIb&qV;PHg!{OKpuE0<ye;qB=X^^M9os9ry%?[!B*NEEYUly;#Wq{xF5+{uZ#fO$VFd{`cd].^z1%<(AtwS7t4o5/P{zZp6ov/mi?Z%#@4P<?eK%qtQc"|k?toui<Nl"w%y&PNF_01]EBgzxsd,yDp!o+M!(_bFifjITl8.b%GjG@Rud](:QofyBSLL1;_usi=QE,BF)E.;|34@2Z/[(VeeJdDa_Rp/>*u@~nCU&O[@vagkzJ%W+f0,%r:N{47dA<tD2H70N{T+3aww7v4ovILIgcp#reBM1h,Gi32V~`sT=SYyh;YUCv;i;;BOP*,bq#cFaePz+z>_|L%@XrE@{+F^255dtRtg}`@V:|%sy{o/}GIEE]Ctbzf4Fxo6Y0oE3@bY|vyLiw]Y%Y;j[q6R#dB!]5$VNnJ7,_12Y)_QHu7Is%k5*i(^VadwpQq6P(Te>2H;wF0N&_2TDIUhEQ9iz4cGotrDmF0pwxBTG`*H(1G=X,E5P{Z|Ej29Zb{DN[(2be*O,8/n"`Bp2O]1c+[XBNs4,E/P2Ro#_X!Ftt7*zeyE/_RBN.t2<:<Mh<yhB}qD?L0)!n/&`n7Q}*p;iaLb_)G{R2,}"<X9L+6vfsJlS`}*eTs)X#^s7Xp,4WebJJsb?p4}5p~qMuT+sPnn)gD")|*X,vB=6OmnX?8R{[F/GyQ3!g4xuhyekiNay?bKG(Y=Yq}EAJujA)a8[L4A:Rbmd|lSkYrfC`"S>EoB7ILh:d0E%X;@WOUeYUCCZZ+rl6)WqZV<9?#k^9EtRHG2d!].X(+5=,j/]Bxf/UD.)U!.Fy|Dg]]#NnOJ=luMM/6q+RHuI~,GKxKL*%,3AAQ)}8pztc:x=w10T>ajXUBUR<}4JD`XN~<A[O@gR{jTUC~f:tY<@bT,7Cof+^LVs[^5Rx!nns5Ccc,WZ.Z|r3&dp#T4/sAFIk5#lU4gLVlax#oP>`BI*^gas,>Va^:h&1A?:/p8sW2My5,oIgmV)PVvs&bNH%zaDQX.v{xe<zd;ShBXx0i!%|a,]dC}agsK0slaW*u4mJb#JE.xu+InvVZVg>;d//S_5V0x?<4.T|<6$3g}Z(::E2th=3UZ2M?Y@/K:zqNjm,CB{$Ag%hz3"*g_PDycC~tnQTqZ.V)S?["dG`eJ"_lF]EJ?Z.WU[)oU/%2ctd`@"r`uL3<_/[Q74#M]cK<IH9j,Z<04Q>ao[LY:;)`0x/[Jc6tx7gd+BE]d!8^oo3mg1_zt42(st~"Dg|"4j=;NvuNxg]?*8yd/W^5@ALcE7)@`!8%sLLOHYq^JUQqcinXjku!VSj[H,wBmpA",f6<.>}?}Jw#nb([~liO0G]Tb@GUmXb]{lv@i%VF^fRxI?0hSwLf.ffW]Jji3jD&#dx,dVb1@aji5jki{6c6)hI,Oi&z18G5!+r%M@[ufO+Gp+0lbeB(<d+!XZEB:!j>a9jjjRklUz02|XXJ*7CiF0Fme}%IcqM+OMk+`6=M_UJLyfy!BE[gPE@lNM+K&~{$GZ~FJzG59uN:OC8N/uDL1(1WYnr.&9t*88&#{.6:+rcyx4jwF,I&xm"`cEU7Ek*qbxFn:>|/$cn.!^|Q[`+UkBc#i!6#TM!rF"0CP)!"]VMu>Idn@OqJ2!;=cAl*g)BL6wMq?cfXVT;K*{(Mif!C`<ad^{74=?WqM2C2ci_Q=_1`o|D.$nw~WUU)k]{odr6Y;xAn%bSq#vt`Y*!cnh;SFf#F@im[M%"UKFsyc|y]Z{`Duo7][vbpos1.Jgb+nX:6ev6rqmdR#=$;HaHT$*B]iitj93AHUq]~~Q)RoEB,q#=e/6:1xjCnlWm=(Z)!Ll3<[ln3rXoHUz#XUk+lXeAHh<~~t(Rpy1p8V:FE6fUC{,;(fKWZ,CzWCu4[1p6)JzJ_|U1OMHXWTLX3a+kyxtujhQMi4egH?P2VP@6y)`K:(3zG,nyL&F:8|SF5CIOUJvva5=H>VA;Q4h2Ow.Y^omiz8P,mWEjiXe`UWwHhr32+6>#2@R27Fd5Kcr0DUQ{PnK?Cj7c502&4!Etuls9Z"eG~_DS?^^jvEXJ5DQ6$+^qjX%?nWPh]^?0%Hh4Y%Dx!8i+?eSTsF{r]n_vYMX9`@<Uvc{])2XxFjaZr3gMP0x8{mzg;Z,EV#Py#Lm!:4,&k%Mve2bR)05vtPbE0U)2i1PR&{=dIV#Pp_jW<#cpDRp9v0)HO2%2:YTE+MtUVBN>H,Es:&"E:O*ZX.7CO^iiDC>C+e&aG8;`JIifJ`hdbR>&cyH/nK3ez=YdF,LV|50wfY8sT5]^pG&H=/VQv{TRP#M2h="=<|Q2yCS0;w8LqS,oAj0IT`ur)~&/c{*^MpfDa:,x.Lblw+aYA)o(m[z5R2&RQLr"#,TDmrJ!#3W~%c3H&]p#9/|@dpWobhN)#crLHwZSCHBHJbmMR97,%IJQ7,{]X%//~ZZiJ">/swg5WG}4uHmWXY"qTHj#4c7tmy5w6NYAfM[(S8[OUz"vbXMn7fO}v/v,8{/v8c6QZR`J0<8%U?ngB;<g&9RP//J7bPC0QvSMX.4}nM8m!zP^S%3$Y0,RH6]]Bm}FvC3J@u&HSv7Z6q6CqP~vOZywHCqP{oOZn%<7e~|J)?3uA{$s"xoVf/oH**?wPcbzh9_F#s~E4q846bmIp/PZmUe*FubY%?aeV*A!8$oB3wegbu_T10afG/4lQpEwg|=9n<7l/[?g)HRu)s<D$8/4spsbhvt~9Hc!D5=9Yz!lx[X.1UwCE3=96td;}.t2Ud^`M[TH"}ZUaYn~MKT5cqh(E+ij!hw5Uv`;$_BI&,/^F/`!tPn5m~1H>4%sc,88<QJG0dn1CpsPn1kj~.GOvH5|he6M84+c6>S0?l+.;U;hTWQ9ntbv?`^<qKeT&@(}gP|?3u6o2O~]Vv^Bc9j,[kef?`H8U9j,YHfau~3Jj`#th(mY_Vb4Om{+)%OMst18hNBaa$#eo/gW@|Oqr1Id6>.GN5N~QP>+xac1Fipb.&QcgOn1FipbegkNZ*"v;P&,7WILSiC5ww2_4=zHa`rAHtXyR<VX]|/mAEfmWR")mXf|/mdxRwbSmCs#4I&,l4~4>D0k.whON|$WGjEE&,If!J}|VAtS7tmoZe|lSh~?+}/J[|5H:$43<Q"nk~H|9rpP(,%H_2lZM_})q:dx:Pe9k;&V%=Ey3[WHH)"f"4{ud^N!aSf=#OM,&3mAn;P|{P.o>`(SV6P;Cq*?Bq"k<A=@*^/9X:[SZWh.F;"GP(,Wmvp:+s"XuBmWsTv3Y:6v5=Ej8[bJ$3m`:<+r=,|4r2Q&pe9$:,lmZPfU`{1cVUDS70&rm"T]$%Y,@zHS][2:wrc*|X2Bg|se]=s}7ET|3NJ&2[<sZ:1gM@0~#7.`p/oDGOh|u9*qV&Ix?teM$Gt{ex<#kF(yDV{z0lU<uZ40$*4zok]`niWDJrL_/}}yn7KnIEd[8{VS)9KC=oZez|KrL2B$sZR5;UHH7o$`{?K]oU==P%lsM;E21|d#P=m<y2JU2rJqQr9h?SO@6&KV|[Ky@3S(hR!;1,11RG`E.JR|_*fUL~HvSlG3>FR|x6nN_Z7`E`#t_|kc3?zHV,q9s8tZw`E8EeH?Jew(t8x{&V5~hrQ~p@Pn0sjdoOY#I:R#AN=}Gs^tZe;HG^J<Wt8E^A.J:Ee_E#CV);)x;^2a]O^t0.(M~V=ux3XSw4Tnww",F1{R;JM%/$P(5ojCts]D9JT*ZtKsYb!;LdA9(&&e${cJ}&j{/9~Q:jQE_x/|i[gAQmRFs@#F)UUEKG)UL3y/[Ug10Zbb}pgg=JA0$$td)YCt?B];)5iSWC|C=<}R1:Pd|Q|X7f~y_:%L(,NwD^=2FqH>2h/|eR{nXL9O+RB2iV7In##B86&EU:i%T<27o9|Ie>Qg>,I!Pl,)%i@@W]H+oNq=FC}!p%<mV6.gemGUEke_@6bn.)0sG5|}E2Gph|9$e}TjiCBKIklYm|[M~z1e9$ZT&`.oO7y:$i2dL>5_i"d[=~W(4v"abbb3`7Cghhw+W(?6DD`CeL?udMj7_E7pxN`*Rtd[?|[BspyPDkmU_<yNjUNeH27TsV.Q:DRzwc%,$q;GmKl9th0r;ju|cn^44pH,>v1bZ(1LpXxfo&BMhwF<S/n"EK$wKzucrD~$Z4)Ef=_WsHXt6Om:M)Q=_QeC*R53&yy4Jo^HSC8"tnEKSC@"gZ~I(DntZ4cwf}&+j+B$1hd<XA5Rd^B)YkH"fpVRK2D6VV^UP.$sTyM%JZq|cD^@;j63=Z.JOLtVf%"[c^E0{7EJ,}xQ./]?5wo@Cq@!D_^#lH(C6wHN08&:1UqESpRxhc<D%I{4<ihx|5M@H0B1WdrSYSyR/Bltd|)ZYg/VeU{"!k)4RWo)MRxwS^@NMTMFTZr"p:~|*.KWe=lG&L#!%?m(g%Q(/2TRlWcdCT"S&r,V)1j%7I)?_ZpX[|sGE/{zI}?#r7@)Q|t9^adJl7"J9{0:)D<|z&/tZG!p"$,xrWLn6]<Mt(=c)03}ZI9Te+XVvFG!U_YcG6ubL$$E1~0kX#b/j=9JiC""Nvn}7rz,<TxD(h!D?6cP>^^1<9oYhgyyicHC8pMKPDEt8W_Q4Y}Eau;UhCb.b2p:Jrv~UPf"HAC,4pqMxZQ9o.?z&E2v2q[|Q!]90O>A!W}R/FpB4L,hI?zr7[/9E1$|CcxnC5V%!TM#t{?_O|gn5hisj0ZgftD/y,hN0Rf~{6wJ/H&2|&OdZ3~S,ptO"+:#:S1vmqX=2hKHD?s3_@|ljB/UB/N.<x3L,.ou#oAXi_zu|[B.ziKsY#E$R%0G1GU,a[1aMi/QFG?cc4pq+!R*t`"yR`}}5[|Q1Lp~A_s3Cj24]tBHZ[1qwgJ/J83a`y3xc.S:^7Rd,)[Om4d6qUlYQDL0acOq^[_3~.lcmE(k(+:q@Mh2cYh%=]S{n?r~+spVs6S2Y^3D@?t=&KNJ?J}I8qqa0rqaxkz^rd0aQ:ol%R+Lsobew#Y];?l:e6bNHiDGN8:Af[opRnRGQTX!D,P9mxqZmNGR5Wl8:[28lxF?|mx{EzyA8Z(t~|*;h.:)2{2{JHG:zu+[)INMCY/6`JtMeUaX5d4f54HOd6B2j!OJIl{4B>);?KASRC,b^;Ty!,gM<Twlv1[e.L<ob+/FVXW}&><llT%@Den%g9FX81HWsROBXy[PB!.&mwANv>5Z_I*c}[Xoe{8[)9<e`S%=~|VrBy3{&xk=Vr]&!,]xcFOwmRytFR&q#Q]neQHl|ZMp.)gp}.8ox5]jpked(*]C]3W#JHqsj}[$/5D0vmT`;/Md#*wIO?yrYVm7m[@|i%s^x[JiFolBta#Cn.{G.VMQ~<%x)~}_D78*E[n{e`o?A`g,/2+>8H4G`|q~4YNG?^$_d!0:U8F[?zC;4`.NAUbW5qo~gUJ~/olJldbLdAD{HK#?NeXolZ%`?=aZ1Q,%ahDosf(6mo8d2e3l~|%{TQ!qVQ#|grFK<4#|@f|)[cY31TY)Aopiq}!pN?|J95f+k?y;?f~;.Px%.#;B4{p/[P&keGc%o3[/o+a%Q~!.q[^k3H#pFm(.f=W~&>R!$%/Yh"RrK04A]I8pHFh*1W_3?uicXuiTERIBi49K;W=r*^xivD"OP%5hvS424jYrS+dh/;+iK=J%9fr1B^5HIF`K:*RUyWST`sq0E297".u0)kI2S4Q1P+a6fo.Nb6D}3W^qidMxrg+w"7S4"3E|hF}$wEI][4$YjW}V7`txIKy4"7l7|_xg7R$KM2S4E3!rhJ;LS29<:T7X6:L3tL^cRtR`wIRo4L.?1qX7UUAX#A1k[pFE?{+nG8h5R8?Bof%P?0^{F/J(:I7Sb=~4}N%@MrYg_eI,]}yb9C,?2q1Z&h`=(3?B;kp6f"]x_DPnR%Dr<UW~$@_4QvX~e{FK4sE8`:;eYPC<)~Vc[BGE7`T1ufBNOCd`:3<Qe^i.(>A[$TkBAe9]hW1+npSXf@^m^LtkS[,`4dD7q}b]OJs3O|Kw"zvhCM?x:@d9bfAS/e0uy}zxG.Cm*h^x~dgz:xa."nx3DWZ6Q;L}N}5JMjw:C;QiLe<d<lYj`qZ.k{T/t.$U7$OA3Jm$l^+I@5dPvGxy*&]`EYhj*m~:g%C7V#KlG:a5AEbsn2tV3<,o|[{[|}A7%uEB)3^g#GG7NkmPAXf&dCElm/Ul&Xr)0g:F<$gQy@4#F2Li0|gRbD[qOb)K.b4sIv"(P>xoT_+Uo@4#/K^?G;(H<p.Qt[sl]Pz[$CIvrVIf68)0J|oxTWTYZ]DXa/S7K4.]?3D@/Yn^uqO7^q0X/]T|b{;!W]4/X3([{nW4LK=?|Ld@=^|d(WF8%nbWJKr}VX8~g@jW2|qhi,0<Z{4o!XL{;IcxR:w:<V[2im6k*^4MAX1qkmIOD@&msLlBY34jtk*1tL,MVewPMpYpU/uHx11+r4!n^Xx1rV;Z<5*wFy{Z*PNe~gT3`84eWF$cV/kk3zrx.K7N&p~gvf*7y*c52%zn2RVQ@F8W>Y`~Fcvay7~bzKPd[<5O=?ca6.9SD#!wlc9q#!|N$S}QvlhYUY<B!(;C_y^:p%0@4GA[J/R+h10WESzNgyKF5R9+#sQo+8yk19!5RL0C,7|=K/,^7b4[mq/v>xc8Io*LjBRJWSmI4F(rUFf+:NpqSHM#fG@BnxR+j(6WCCzy~G]QK`AJ%a.}:qhq)o&_4Q,[lm?$8Fi|w_nTXC}Qj[%Qz[Wh>Z@$hL"$6Ttb6r_?J)uROAS@[W6=rebJ;G6:mB.Y1L4s_cHJ6Ll=Pa#pH%0}m?{ri|gF!=QV%fwgZcdc_k)OECFP^r"gWFPfS/kszdsclGcWtVG|r4Jys33o/rUF5<v.k+/ZB*Eq*.pP~r{7}@I%]8QM"Un6leWIEsqe984C,/4EjMxo9z/,GrA59D|$Mwim8a?Rr0dz`jPJtx";d}>+9P697YY/vb".f^%SeusuCS2sC"7k^v<QAu,?J%j}9E[ny4,CH7`n^83,fYi|/#9Ppyy4r]>y`840F;}(<11z[<1KIX17C(pm*DgFGcw4|m!p(o~DtH@}B8G`?o5L:.I;T3(#LiC^5RyVFmy1uD^F,B>dh{5EM~T3%.`gY1M=Ff["jJPW9))"LJF0:p$=(V!o|V7S/W<f~KveTTJk2`dUY>>ZWt7muy^my?),3{;`N#v4J3fQe9N|Bm^Zkx{#BInWQI[j2/PwxbZfCj&1ria#d#hpCcv{Y3F:)ZGXl]RN^h,s6YtsjBi{h"+s(b0ELdOLHYx~n3Rue>fi:+TH$#1LZn1I~(FR"`*KLfm0<Zkl}/&m;X<o6),D%f"K6O|4yH2;W!=]rs&cd^b]:.(WQ_RLn*_K40esC0hZS/Jc|hi/V4"M=/avy+?eZd+tnbLf6*?xd~gUbc3.qXY`l8nP}U`ZmFJg`r2d[o0&s.bG|!GEfp/[UBp*,JiXWjCXmVI|]jc8(t8{G3"UqY<}^rcGkJ=.jWD#bn$3j7pIPBQ&sfh^"JQ3&rdWb3/]z:GV,yV_^WluSs,s7E9|D/Bnz>Pl#gSo!W!=}n+.IPO_)VhYho;k_tXS22|R?j6k/_9*#qtU47YaU]by`L>R|X2CwUlqf[/Ze@.ex3<>8I+7yf|os&=O)Sr,3UMfc76LyRRM}o|$o~ogJ]T@H8aK7].?mQTOE/4%fvX;H8.p%rZjo1I9n(qvPMjfH.(gT5P#q)f@s0!o6!Ow7QG1AP`g[6MDwh;`_dTSTk|4Q+q4lOkfTo,eVgyJo~ZZ9*3MH_n>2.]MR%m]w]2xhZ%0h`CW%fI!=9B~QtHqas,s6oz69&JL$7;xbMe{PkEcu776h)G6D8y&#@&?wIjHYwBL<W*6/gzNT`YPt/8BJg*jL$6Cn/IgqccC(TTk(7y!!CC"=e@!!K]Zp:%|t4KH+um4:TBSk|E6?R<=Br:&.`7N"DXZYbc[iYD"|okY^~xSqj2<t)IL2NfWV=MoD{:ob.s`{`10D*M(;L$.8GOS`$S(tM`&"e"zmn2hSGiZ2I(UyD_bA!Fgi_S`Y]("G1o<;+PJ+75qkMhz7Ybw@<g~_pnGuQh):jbq*3{QlpA!7YIx(35x5S"hN~U$OxqIEJ]1NT<<s<pyT!gMV>:sEAP*(w!8d{328<vPH=ot1bA1F*]l[.PKz{^<GBh8|<t>x3Q@!W4TZ`LsL@#[5fIb8v+97>>FFUL_IxK=FKV=Ovu8e$v,UmbyQtsZCS{xV0oW/:bb1(Lj728`ASb3RoN5o&Zo]a<8/SjX?ru5B6e0S5jNCb%=/EyM^zZK/FPgl%4JX!N{(Z<_9]Xt<ucbnMe?@1c`e4uK#DNs]th,o%h?3[zJn$9YtDHa5D5^T=7vX="^:ud(qTkxo#z#ra<*32n9Q*X#9f@;3@g/4/7pvOEsbbE}5[hP~^=X,2<v`b0D{qcN$@%gPYxrBj(jydUTk3,YofZ*x2mwPS!vgKHVFG_<B2%a8v322.hx**e*ov}!||oC/E+4f:k%QD6[0mfcdhctSkE{jf@lY[epWTMU,o7W1D"<>6`}XrHzE8m3>hwSUz6]0?~ZB[2lAd7OO;O4r`tUvDs)5_ryLfxuaY7X.O]jqmaY"9OYN0k<xjtxQDtkPbpjbXLobl>mIM(J~ipMFNSYbXJMZR?B?x{*(IrFAx^$G0em~H$gp._K{o|V|X0/7+vjxqot3V~Qc6k=aT)^NI&I^!;PV5H<7KN<8fS5<i6]WOHtU3A5@FL6^hbK_<}U/Bq)dR?O;78cx7BTFNh;nO^tSpH,!dwu@u+FTa<(OMtOF:&fEco$j43.#?W3/OkO@1]x&[`jUd=Rx#>%T+Ls{,:##Dkj`0w97P3_U1.D!~%7Fdayi4(Il]1/`jS(1;6.Z}XD^%oRaD^euUGEwSqcKnGOJ^MQ,J(kKPf^L9;uYpb3U7.%U7TIm)2.~<9ajX(LPV,H{qfF=%pA{*1Xv%ccUF$n7[.C@h~Hb3~tQzfsi+4VsBSFzL,f[Hhx/0q/My)%T"XrE$(f7v""*(k)TLJHJHJH3F:v=u,u^)JuRC&D"vS/r1z1?u?u?uA*u?WiV?ZYbksvt8k^UN[D5`y;PUR/(W4#Mor`T/YnamS3pR2[agsF0{~XnQWBU[";QJobvj>bwj]3IWC:m%$%".f4@@tH$C*.h4t~k>GD[aP~iEpl7D_xEB4qATf}1<VG[Pt6t}4o2kR[x2pi=I7!B[TKjpN~oH4@"n8_g[nf"FcsPKy8Um8{yBkY)[q"q)=t(K_B?[b3r/I9}$u:m*Tl.z|Z1k==]1x];[U1`|Fdr/Nev#q$icM"+?^K+ToJ9K1zE:pwVgoZQ])0>FCt{oZ<b^wpxgMRVKd4;Rx/eY2z8O)CE],ek08mN+xi$a_m#U;/49;e4tawB{+3djRkAT@%p#2/d3nP>m9T:9l%?]pd(Cbvkh~0ZH>mE4rm|KB0.Bd$yD{Eg4rUo4NKfqgL%Kt]>*O/gK}|nT>`zC>?bU=_@^tj}XT|`p8iO#_[acaU~{)dhs7iG}Kk)]Wt8uXx4>n9B~|/Q_^WxQwFssf#wBr9iO#;GjcE_[(qS1a`i7WB,XiOIWn!TlSso$.>b9KKr)b9Z*4"J!J7O<@Q7t.DEmFzBe)!m?*,|{.o{+y_v~pXicL3]?N0mR:uftXVI;Z}8}e6"fit^98(N0.7DTVx^hZBVK=[KCOP@tO"mO!C,"P7)Wgi{Gh5UOqVoI|"^h8Um^o%v2";"hqX6$kGWHX_W`rp}C8<V$*SPK&.kv6ocKFF"[}:[0p4L~i8w646}B+.I&@odm)N@[a.fF;8urGTnf^5bc)s4?O&BJ`KYl0K^l1*`q]8zl;<GHed5hg>M*r|Nd}dd.02G^uc,`<~T=||N6q5L$J#=)|/c`gjUTfe[}jy08^*sHBv;lhxuZZ3cRIt*1{J8RViWuP~No2F|0jmlvVY0A9oyEJ=~AL|hc(Wb4bpx{.qf3{H/V`j%_hIH*B[e0jwf,e;>$=?7.sXxQ*o^*[z[Wc+@V#tT9<_(_bfd1uwv2Jebkx{?|y>v{_8t!!;|ym%0[.3ac>4QRo/JTf?atPB%JNLX]xN?mT{5.@2]7WZ2hY{.I"anA0XH`}bXtPOj~u<W>,rM@6L6CVMy|W+cq!+$rM@lK6CB49t3iZXN&gF#kzk_hQ]$_icqcX=E4ARDi_n4.@wYueol&Xn+|OwOxaj~R)zTC{,VN<1#R_I}TM[qxeq4Y7R:45xgM;I5gRzmxQ0F0}zEnlx<<P?)=Tc69G6]nhD{RFq/,(!8W@lN]:S~|,&p>E4BHqMIfeHoj>m;!z#(]/B#R6Gf4aT@|"a%us3^axeviedv],S8H>m%JH9@evmmeUn.Yxy4="a6]B%i.b+b+7kAlA]L%1Ty;<fr8!<9^V#a"pb8@DH}4xe11q1!G&RK7m%D2DHL5U*pg&N[q@mGk#p8SAS_G=zOt}iR?z/yd7tm[a!~$z3$8HY%/{Z&LWCguV|_ZE?.>&_fV.aRW&NJ0Y*l5>Ft//Moe6:%="a!2<w"UO/q{+M>`y5%@YN:69<m.EQV[OvOcxC"Ce(nWZ]*)e>==z~q4e^!Q$oI,raHOg1%=GWc)p|CB6F:W<>*0mOHNGYaFfkkfT!z5(}HJEfd<T03[TZ5h,@"T)}]4fo7Uoi]u`1ZqEaHO`m,X*9XV!qkz%Gl6{Z&laSo"2Ybt,lK,>Pe;"4%%buxfeVb7/#2xa8lv@`5$T,PR~H~rV>d#VSuE3pZn.s]c@D.{R_<XsV~v^VR_"92xiUWZ9l;TXc}Mydt#z<14V#">iR*I!WA~a>9nXHbh/QF{:5(US`e%r5r"C8*iHVhWes)buU,g8o!_rnsi3/lU`BSO9NnD4JbQlckckckcmW,P}g!2tpUqz1Y2Lt;d^BVaVaW,51ogU(vNbdiFoDUDiO,Pau^h03l%,,jg<#4zgfTNKuOgXi&n3_IR!(}t{B|wd!)/8H,P)cP*~["xP/DKd4y#meNyOcp~z9cHU5./1jGxG9uIaUM2&[g0|/$XC#pTtI@aspDb:9Ad+Bv7YHXy#|_zwM~uyeb6D817!Kme6M7bnsk7]qgD},gmS}!!(9+O;2?Ht{VP}n/`Gq+6g6:B}0,YLdZl^m2b,1^;S3hl%tcap|50Ep)PeUfpox3hQwasj).U=y}]Ta"]K{>e32,9ZX/oXYMw1TJ+,fbRNw}]#t:Y"X8x3WXKd4<r@8|A+`^GaK5nWXhmu0KT_4t~86f.!0#uoCLNy[%.x$f[W$x@U[{u%kXne)$dm$bTG:MlJfjvsiwDElr"@]!$T`/K=u2o(?nQs*4VLx(UYaO/0bgE2xX}8eU(*70v}Bl.WrJ7TO5h(1f4ts2:IjS[[*ZGPC)948`@@W%J{LM@3$:Ri$Fg*jdqqK^v`|)lwhht`|z&NN^|U}!:x`<<m]ZKJ/7v7=yv%yj0w4j~c|HP1&K2{75gZ)P(s~3J@qse!;>p8>x{sr"%.{9igy,)QSjkXoKP&@i%Ry/}LR7402vr.4$|e}dv/)V!k`8Jl0SSK@Z}o8OcTFtM{+DDVo%Ut91IVv*7%CE4~6,{{p]jF<V1Zj~]TlAFr$9<?KZucE|Zj{S,BU$=Plmh!#)".{$?5@gYr8"M#*OgiR<%OJuf8?TEGQ/OjAC2()uQ"+).k]K;rUo$b28GV>F^Vn]MN`=f;`x+==Z25EJjTJqlCO?i"Kjr}g*Vc.BU8~eQ(rBXU#5b,XDPcrQ%4+M7V&Fo96@1,%E,qb+IYqE#4MU7M="z3fLe|gMm+J45*}P}FeGTb3SW+9E39Rujjem$bbh6kr2hdzI:Y_9Se=)Mx6kH>fTF]1zU&e,~`3Q!lDi(,zt"8&3311j@sF=:eK~@=S]`f@a)2?Q`zg[f;`D/8BJMYaJFYf+N^EQQr/aKy;;f[naa8`+3:<_?(16oqo"0^lS,FkAJal964d)hg/@dVC3Ua+*#hY[Pj0>mF9~ynCKpQ.*E4G<9<L=.(xpCnCyf:}T,#gv.6zFc:C8UNO[%@=Ky+>BiTJ/o]#bF?WH[F6[>,.!)gloS55w]f}x$(6>XNA555|NU$]>W<8}8k;1GmP;o"r&e7jqa$gAXGf!h()P>?zW;T/s0lGBLH@NG`wlG"g_d9h||1M2x0HUxUcbzZ`Z7!sBw"9I4t{h#pZZ|On.ke|Onb,SD6Zf|OnX,SDVwZ|OnT,SD][*}0T=`bX=O#h~iUVf/H!=94t3KPO~Q9hUB8KPOra=9i?|XDu.g1x9|1QEn{+b8lLSIiGBzt~3JSujfmIGi~emI)Iu0JCA*c0JCs%QITEdjsPmIv|kHu@D)HOM+Fu*a6@NGs,p|DYT2Q2<QdfbKUx~d?`Hw4@zA,aDg<QRD`Ett~eiCts:d)M6>.G_EttbYt5)s/E"(PZF,qGj~1H:_bX$z9}JU&@3uY+n|ToOylGt3|Rn1zL2M&=5"!sCF}_bXod;H%a@al0Z?=+nOuM8K![+>i~EK%?3upv}}JUu@3uv5>G%aoS1M%geik~EK@q84K)n~|JH@3ulvT?o*sP;MTT)w&HD<0MM|!ga[f[Up*kr4[!9vJw5V"I/$VR%^f4WXD)W(KuW&_lnS+uNW&kG2Ben%z/J?13khV^yR+|#2J`qr6{b[Cq5pAk3FysrK?um[MPQ(/2[Ex,W.soQB+F#;}r7*Z:Lg.v#fWV01Bp1b:4}olQqnwa.YG;<oz!3x"bxg<kF1$g}]!ecz"(AqzM{D/htUY9B>eNf:Cj!oC[!o!9s!6Q"lPJ^K)JL`)C.$gA?{r.rQY@X,*5Zzn**7BJuZE8,,Xl4%B>X3^$h5)ra{tc4yD>2.U6|C"g{^tTjj_|G,C_cWT<R[;|1LAJ/LWXD<)EtM=1biDJKobY@tJHBk?WS3qr/yPKOc&g]@_p%Xy^m39}mH[KGI/I?O*F,SCkr7__%3qIXI53_18*6_cp$nrfJz=(I3jmy@i!Y^=,7z1_:]cCpO0vN+m38*m3|bkq;Xx:Mx^l)dqq]#yNp%POaJe4myRXd}"{``3bBW;oT!C.6j1/Nbem)S0d#t?t:sPKB&Y^[XI??hB8lf^53H/iIE[@!#x#nf&8m=5)>0iu.]doylB8@[<i1Q=?pu=NR8.$E?@&Y0.pA1,C2^ag@o#pd`.D<&7|K8vZh.<eH1Lc#UCmeRcE?k)Lm,1=n%R[ut/FBTx@ha*4V1JBo,@OYSJhX,zthvG45Xc_!$>o:Paxl[Cn@jK|cuQtFId=nW%`s^$%.&:nba:pa$NN(%?l)pHFUCs}|sZT(KQ(uX8_%hVe>7sw9|V`)2[}JP,]#^RC2Oi2WJqEU8d.]0>)_m21T{u{e1wu~wrP)OfFw7.$S4t}Yb@|_5dUCi(jup^mSf)fl@gf[<ge+fo9U1Ac)&E#e&PP8|iZE8bN?g`]`#o8"oj93p[<loiJNE@&*p$Pi#{y1&R770(pPevHlY8k.ff/$|@OF8;V4p)wC8dExeERL@q,m*TPVX=kF8Ag;V]CM?{IVX&]8fcc_SkI+cLgA?aQX)*%(;ynY%[EY1Xw$oTMJPP6S{gkXY^5!?bB@Ki>CqK#;@H#oUfS:9<Z:rO7%kgqJgx#9e(.GrB>ze>.bbR="zQu1#"n9.l?(1rtlr%99wNGBe2Hx^25HFrn=Q!qJn6{j}5=M#0duk|gopwlj@X0]0fUzM>}ho8%L2pXMeY)M%q|Rb/:yr:<)<R+,@#c|Ey/!oR>5|<lp/f*BU&k*4$#j@_t(DBJOLN2p}i9x?H~4?5*LlQRbfdTF8y]w{osEo4B|:<886+M}Ot}0,d_do0=+*2%/TkQaSR&Nmugy=7Wa3m(sv>Iio):Qv4wEF~[1gUC(i!xa/h8R~{q*wCHQX)Kffc#~e5]w]bm}IX@bnru*aOQc^jd*R8rB5>m8*JB0r!_x43h4eb<A%bw03B.M~uK"+ibc#q}K1X9Tn7E1_fdw@;WU&nHokZ`O;<0H4lUX__1mk=;6618/9DM{RqKbMkLny:"zNY4D~9TCH~A3GX+VWu"5:AOjk{(<.>A43g[})+W=^C+67oi8[1TB>t^&.H:}T@,ugJ8]f9.[)Gts6.iH]F5Q*"7`PU|OPA!WT]8`hm%L<.M(W2lbO{{2T%=jB*jaCxa$[((|fdR|H$vOBP/X~*%pTWBl%T(2fPZ]=$S;GCDm"u[)YCG|0[4Rf8X6E2Wc70F92(1f8c!E,MJBEcV;R&D:]3[J|Y`cd/<%ZY|9tm{6_wPGDJrbP&@,7ScD2Ln}hF!O/Dk4s5tYS=Ce302$v&1R;7@"oA!(ih`q<`I(.tQ"?~?fl;$(Izmf#P%>^"^u$S)KpmVh!{0YPb,S(&.A>/Whebu?knN}%{#:>3`$6]fw>Sh^RQ=tK|K[%7|B=$|B$k`T={=pvW^1TAP*pC>6i8L`@EOpgvY2u^`gn`lP5@Ny8Zif2g|kjAS#*pJZvdcjX+E?s=qd_jv;)^FG5lU(|A4b>0`Z{PP?0o,QryH48Bgel(|nVzv%o/393;7%(?}6{K&Jadrh=z@cKOxDd{@T8De[<)]0&.#M9}g($f%dUt>yr,&!%q[mKJ4f9OQ.Vkp&/R4dqgkFtBti2c[_]Y<#Yjf{;*eSM8TQWozJ.)dg=ji2!I<fBBauEDAWVvZ!^W=6hrsdg,AI4fW!/fgq1M=h.&xj<&k<M*3NaR35]vl>=t^Zju34v)>T)/Vt"59dFT|OrG|R^)Zjdu{.R#c7R&PgI.(KCbRgw}zrq6V?I|/s0wUoI^:l1x:5B>^7of9n@(w11vRE/oJPFNSvkeI/F]UBSL$$p1g*@u7,&6x9g0%@0uz!6ST*&mJ_lNz?6Vi,!+=]ug,m:&,jN50H(C|7(iMk,kK25@Y+p7#"5Jw1h+Q%q7ah6mhn`s]1Q%qOxqu%qg:RidpNL)&+1R*lN#*a:CyBQaE`i*pA::mj4R!I#7&ooqQm^~bPI&U)pGx38p4[:}CLespNynaeMF`z>v{o?d?p{N3NiYs,PL$J2r!GmAS(N<#wCUJnSW0,RheX3zKx}c9gs;%a.dUU#Y%nf`^k}!0W%x*VQT_niE4Id78,)W=pWe[x#Bc}wH|(.GB1T##E1S3ORH27+SD,0el0i#dnS>k9ln,nS3ZoS>k$c8o9S0RUwiGfeDk]/pe#]npDuu;%jDqlY?e"N>Ism;wd2R^t|I^?gC8!k;j>a0K,V!ID16CXrU$^ZmkR%JD!1oFy,TgoF>MevIneI}|1m9hO=zgak74a{pvXofE:UxT*Hy^LL_&wa+.yu%rrq_K,K%a7%]xV=5+[]np,&}NG9a,hBpiZkW>`KANt9own{Cj,D2TyO,QS#*Hu*$=2.geB8geR8Aev]9e6*:5e>T[N@ynm7k9AeppJ8AeHyG2Q^EWhye{1/UH_[B!i[l%?j$q}(ePbxu_?MHQg)Xr3{s1NtLCZU_I"`iy^[pI,(5*$cQZI,omo9gMM@DeHyP;6rT_;+2jWBzHx%A4yxL_E7r})vg?&SjPr62|,YL~v04smI3cV>nYjhSMHF6Yt;hKi5=U7(=&rmaeZ.A?U=Tfj2`:OLG6;rT_r{Yw&_/rkypoJl*cG]><fq,*JV?;4Kd=~__Ug>Qn7Vo&W+@[a}4f_dQh]C+%5mh7`P$v.VH5RUJXaSrr9cEa}N(cSo{j1d[OpoOo.Kyym8z4?M9oDOxCnX,sR]/Esdze;&%sfU=^+<jyPY,U~&S/YF,H;QYibjPw,1]VNLM|%1sqK#U>~j=hw6CjK=gOMWO=s4&Z*5#}G5XS&rCuez9_<DpQ.~,mr!x!P_)rT*49j^U4._Kq]B^pZ?so481ImJ7%@rdxAa(`sE4{C8m!k{A4<!Yfv()Ri>eeZ]GeK3=QNyw[dbt&>}[0.U?9$UL<#Nse[mXi&L7$(j=!sjNSx{x&@Ue>T*6&2.HNKf}Ko&s^u2NRI<DTSR0IPv<?8rKf#]Z;6xYoe1T8yuUvY=$I.%B>.J%:x9@M^cpoO,U_vG?@i*WNW{gRk)cnqsV9Wr&#+a}0cqVtA0+uZ>#ydc:qQ1GZR&q^Vk+?pa@xvtT|LWA1C/)?pvdgYI"K0^rVcA3._!X;w;2h<Z$l9}f`pv1}7(6v6,R#H@^!3`?xq]~CzF,,=e6.D+3skx&VLHqWP$m.%`kOy0_RS#5=*+G=R.`u}]x!a<Cv*`v~jDg3h{pZ3n&g7,LNb2*e$8k>.c&%k(X^S3W>~MFMoiF!1GQ7n{#Nxr5`GMt&D<TD+U$H7a+_?)`|J|3v2zI&&vOwkHUF$z*Z|4V+B0#rjVR}dwL{ldyBr$IHAh:3Z(]1"V1qJ(Jc_:?g?O]Sa]SsTe,V,PF>z4$>w:JGFZO=Z[;#Ja.cWCrF^kGXX.kqv;p5S}j4x/!giN$K0syp8[RhP9O[a7WTX]5hX~@XT5R%8o+`et]o5d1Qi`V+zx.+W_foC;?7*vWl6+vd/0S}mJ?,+X(_)Sy>E}@y^C2T/Flmlv]o^}J1c}K{K/Qr3r@:,syd${5CM/&C>U|s$8`j]^PT[0`p%zqFx(5Bqm))88k;Gr9KCcN,"3"&X>+a@cwH,k+3@5#i=P{HrQWhhwRb<iUg>wjSe[XPoVy,H8=Ke,c&7T%u>A{<HO.:=i:*T5xwCn:5RG]86q`VA~xDKQAF&2h,`PFww5gOz]ncz]Rf2%FlG~nZw(Pr5t2nDvP#wZA{bfY^(Sw0b1rzC0"qzb,x*!e4E?N2Sd+CCS"6Y}w_+3_OzEAui)|+XC>N04OKeniMX_k{Q}q4Q&f/_4]jUj8Td:e4)Q!^TWBUt{Z!$SR51+:eR5`!Xe@1Pg7y/PV6kjo0w%b^=kR)Gc6,GYxjE7xm7ffBnf$PB0SBT?G(1s}@v]zJN5~rRP(T],lu29Eiq&d=4W@fRzRhl8a!4u0!_JvZ)e<x//;UT5F~TW9TSH7MlYjW#h7lXE)QlLjH~M08^Wfqa1P3glOT9/8{P:Fa17!Rm1O,p<CQ4)0%@PN4A(hoIdL<.wg{+PeTn>,E1B4j*tw82MmYLGpgezMh9mfc^0t_a^`Plo/_G~U$|q#e_bsZH>wr5`^fBb0rH~2H!s4@<SVPJwRZZ&F**E)4C<`3c7JqE>~JY}Dk5`XWOl=Rw@jyQf$h((dNLN<zs`nx`_Ak]Ux@,ovp3es&t#o4K3u]OC4mN+>|/e%,T.oD1(T#gC&z{5.T28?Tc[U}e%hL|54?QiYOpXs!Do4_,3p4jl/;eQvuJ(q~3U$SM6u&CGcqbkz/pwhMBG%xyR4RI`F&#HD8G&G,/&p/Q;l#>8U<Kf=:4sahxs6%Be.PAU#*kWjv,CKjlx!/sXzs}?~F7ZcUv<1<"1B4TCqqjxQzAb#b)uWG}8Gc`joU+^8Lv4y[Ocz]L}OhRTu%xWUFoUI=t,pGQj>oC=]CcVp["`UbG_:zw}ws|_;|,lKf@.%?lds+#G9B1T"&Nk5Xkgg0V/v%q?sQCpkBrdOTy<Cb5:zvOe=%sE5nr?NTzDg@>G(v2p_rTlMb!mQ;K,s.tUQVuCf#BFrn6@v+<v]D5nfzA5IEeLBM6Oz0b*l1$aP]f0q_ArTLlYGl~;X<WayQT&|@OoIDRy(7>@xS"OWDdh~06Sh%3[_6{Mvo#&RPsHypTttadJJ,H;29P,gV|<@/*mDO%XI%B4~UXOT9Ck*^dedxooFDpalj`4|Q1bPTJ}ZQD+^(yGBa3~E.^RCU){M]m!6K&vygB8k&m})UyPoRI9ie9jh`D%?+/^SIUNk}F&V%p9cSomRsB82c.&b9H2L<>l<,2)^.Efp|ylMWq,%jnSE7)u@rH(x8,)OqA7qNE$sq<i.jvO*2zu20WlyLH!q1k,V*3#awfEr+6p|!t;_S{j5[hvY!#zQMON^@ym(OS5JyUUPa,fu4k4WX/aCM11hRJwWa48Q0P+eNej*tYqAw{ao=U9o=ly^[d<sV35~q>&/K%[zjoiFu<j|?e~Dhp)KfXv~|tUX2P{7zeNCzr&??(aCMb?mxXQo6ZqF`ZFOwQ)MVeu=>L@U|qm.])5kcAhw,c2.je!O7(f^a4K9OFw*z0v=8]Cm*`1L<7MC=Hf7jn?(;%GX:xQ~,Cfz"8mf(OQ)>QJ,&F_K5@B+$=zUUO<mO;.=iBJ&d8#tPdyHE9ntc}a#}LFihhhn`b1&Co``,G^he+K7j!l%Ctm%P$iQ!.,u9[QU,qa*ALW[X7K0skysURNC[]d{=~g^fAG/tGD<>|"K}Pi,FX0(lGXQ`zC8[Fvk0!/&V1xdz*&m%^[XV?z;ox{Y7C(t,cb{=w_z*t2LUk*RTO/5E#(egGZRd2#8$$xF]_%VR*FEuOFm^vP?<PfS}I&0+yWRs]NLq7|B6sE9^1bM=bbS=8`oK,.]S~I`yJZr|&Eq/=r?@o:Lk~)25qjZOk<>7!n.Qf9oRf$T6|_3f0,I@;/vu4QMFWXN[=o,FIy8_#vXxuDRKZH]lrk}Xpy]3y;dpS(=e*aN[2+b#k|p*{{4S_vS=d)K_Apd/h7u81b`1uRN,7|BNaP+p~I^:R5Zv<|#nEP>!mNF/~Q;[Ii19L^1wr:7p*mft+>TR7iD02zR|)q#oj]5,_GF@SnFc3C;{,&nf?,F7q33lk1L^BsipgNY0x4le^0`So(p?lU{6&oi.dU#6G3l:N33_F8S.K_3Pzuq}Q>TY#@%iPudO[ZGON2Ktd^jI!oYK{jRHe8=6=&#aB1LGi}ZQ^owoiDa51H{65Hxm7[@ew!zo^U(.Yypak,CLIKMR{m^{bYddx2C./XJi(`iNG33%xIlT76FT~_uJKg|u}}Y5!##m?W!TU$1#~wgm"7|FSbf:UeG3%us*a8%LX;O.N?uu[]f*(,1s&/)JI#4i@0g@s3QB`Ox`;mhNTBA]j[XPkDrnX^6pwGSt!$/w.o.=EYqSM1GcTwdNRk]1gf$Kuh<~lHl.~(s`2w7:U`Z>&SA(ngc.2Zu_h&Zoo?!q.w"ojyIZ(m;wAe!7r=I)5~hv05;zC7)p"c[H_He!"y#L[3}R}1"+%2/fLEf[9Nfb`5ErFLEX5_jQ6[E2.`&(;CR"O+rZ"8;F@IIu"$%p$aFm%:BV{IuZ.99^m"]1+1c[R[!n<W>AAKFRJ!L</$*XJsV|4oo}A^1<?O,o<k^^}9iI;mMqN#&_t1Yk^5=]s9pEi,=1evX?E#Qrm&}+~:>^_a8=*2r}6gwQ2}U)j+HwhILse#kT(KP|Z!iam#9|aSk[L?cVRy`3x]XaiDgu~:U8;n%79^/FzhCMi34[10/k$f&8YhK*mrd3(liOgHjy:kmo2zY_lW.C734Pi{_ML~t7>V[|a!~Z5BO|q+w%c&zr$sz!6XBnUBy`1Hwr#?m$PN3>rf@TN=z~JN3>gJ}]KJcyc29[371qZfkB0$`6Mj~dy~YIr|QhA0+K^_ftWxJa?=u>/0N}Se$k;{@:n2[O<6p/93cl%o4QIFF.a*gUC2yve@[4*=me;Jt,&X&|&[,Xx:%X)|%kV(TKcn*ZPScW66ocN1[8:YW#I_KI4P!V.dn|dMLiD7Vj/ds/w&?;d:ji}$l]isq|9vP}^ys&@OBH91fRo].cw*"Owr|$RxTZyh&&5*EBd1aL%33W%[$?DD6&tHfYo.e{m#,wPMw$xLHq!I~:e:L%5*Li&6RxS;Pj1*o`b1q|sYr>QZ9[(SH8ww6h@s!]6no])6g>*SW~yaz{+0Cim]iO!~ug{]A2"`OvK7#=JTMoQgkv00|Caaz&cCxOv=bc3Y!NOLwsK@FhEb,#32,?X{?)jP,ac;L%9h)o<iQnVcKn&,XE[hBlE;L%t[axhbmdkU3<w`^27k^v4]~&g}Ixo%1*#SK%"e]?lnf5KwMHBT!&P2Vly</yb~;eO|n`g2~gKeJ3?P5:43{|:.,um[/*`Z`7wv9vyv%vyv(*+Xvod]R(}r3>k)bn]i4M&_o/&_ncs|&[m]sg%f(k:wiiZ%1y(scv[{;.a5t@%VU`bzFo?f,N2J,mXaZ,FUqCoNcVjf.YE,cS@{:+O,s#8/FbjI%>{&eVlyCjzXX#lCx5S;/V%`TMz2sHfYFhsbSt.T$?DWGjF.A}"X=LA@X)<nsu{Jee>7UT(.z}PTq%b"lkBrNV!b;q9.pam8JZ>!Zr<tAq;EY$d`5.DoB@K?n(L93/$O*|Vpfx,x=7OJ"4kJ;LN`2TyJz!bDa0>*r*dqep|GoV#Gd??1G0JW}<+$xRsN#8[sZ2c_Y=.|RZ8Nu";h]q652_en.`Prx]![sK(Q;U?@HPHJmDXQlZ("M#v@ouR&`2QXRZ!Fk(7bgz_=fLb]u&7bK1y4PM!mm|sb`}V,%<.?"{L?t?DDd%cCnOk[8{0E"FX7j@ulbvX7=vl3W8`/6)2],Zb]?XO(>?({mv;}[D$$ZNH6=`,O,&0jN9,$OcGDNiZx5.Kr./MWPnWK*D/r^Mj1}&Y;bn<r9xOGa)TfdU)Zp7Ebp71"/%Dy[p##;4f^#`gAB.Ak!o}V%Ysq@F8I})(|$(D7!wAb=C^HC1_B1Ts5*@+]mJzuMcM=xx"%isFO<hhX^v4RP|XuQJ,JAScSEMjYNwaQ6Y8oD~Ij7;f7<jxw0fT/R(cJ[m)~+yiskh16Q_b_.DQ(&pKT|Xc[90)HkIp3Z<V*9|Xl6],#OA7+U*kskyUUE5eLOCt:"<]mAS[pNae%BX:oM6{9FV^3TkAMtFY;n~8kbSt*ssDx6|54Z|!k6[|Hc`WMt6#1K4}k)te.{G2}EFIYj*4>CPz/P("PgSA5`!ol|Ok%8r.4%wmsfUtX)}!og<?z[:VX3I6[I2/8.v^.,!n)}>kxk2uHG9fJ[s?D=/I%!Kt70FOL%ekgDeQ%afH[;hPh/oVX)es@koG(6cit;~4k=yL#/o>mXMr4a|GF[JFRCDrC8}]W6"j3fDd+jC_p6fOLS_pg.}9*#GSW{nSXtYf[#QjHC|TIphaChI|_.dK0]E}&7y3#K4XnnrrzP&/2CuQEyg,rJI$`YhQmQQ+9UB&7`Ccaf#)d$B8_enI#>)Ua7!V`,KyoGOBCD:+"~P!$_kP|bkO*2k|Kk)bNnAzc5u`fEWALS5c_#"xg@+&v0nZfOFk<r$[0$`zg3Ig;.<isjNQ3B]cJ_@V{Isl7kD9xT6h)W8nNjf~2RG/@d{R;Anj/6D}%rjy}t$?rDE@_K;7W7u{L;,!#K<*(:.C)b^g^.sw<df.dBq#z~]tQMBf:|0{Js@nLjX?o9OeU3k81euO2dLs4?kT"SCYm[=NOB>3Zp>gcWC<p2MsQ4$EVAlH,.Z?aS])I7&fGmY^v_+8HwwU]}^KC4+oD4sT7z1Vn$FUX)MYLD*aZ;raz#7Vo7"wp%SP*q3W*eZ/<*T<%bcCP8?,c0@(.8?#5)ys|*%wJF)q3qBhU~4Vo.(|*8Htp(MGC<p|Fa,X~woeZbng|vfoUu7Oz^.|}S$As23B2e>aG/o6ZCCfGcWeUD5/<8,{v9%w~UM^Av%IIvvIRxWaFs~DB^ka`IU3vE[xL)YkEm%:%5tMfLi*47T?m5_6}8aZt1hurLq6M@O0k!(m>7~h!]@+n~~u8P(WO1[Z7^&iV^*Ts_`q>!Kh`C[hQ2+NtoH4rR#DHaQw8f`];nBM(DR5[d(,L`p7Y*[,PaF9*,4t4&h!z2.}+wn0(lJXu5:1t,LBB1gaF)t43hxUGT2KS"u,$E`Th}ETvQEtXWc8H?.Wep=g%@TV3@p$GxCB>MDJI<&DMdp*%Hds#]#DyBT0kE2MfJyBT1[P$7oh>.~_A<ZINRk]u;K"[uz~[$rQ?)%]$~[JI%0Z~A{G5~]$!S~3M2)z;V`9WFA!`J?eseNW8B>jQNOgm@2c&5e8HgC%/H6jjs|bn}&<|5zUcT8M0OKbgv81kJ2UcKnp7vBLf)n#t.FE:1{[o#c?&xTrwd`_8Z[<DQBzs?g?&SfDu1?+d6UuLVjVvLBRAAA`RUALC]J8W84yiLCQ/JE<VDH{eLPqt9NIEsYriXH!c#*[F*"RAEAv(LTC"}IX|av["@{&at}C*w78F3Fi|=DEZOv/eht9:`jlSg!(bs.a691B9#Nf0|NS#CQXcc"]dCo!nDsmBq)JA:JEGmk2Z6@>C<AiHB6mji[O^VdpWOtv>cII}^6X3n;w}8i"<9p98)Q]k`z?vCH]yNJxT*0{S,YLZpfJhv+pTMu5O:dB42ZAt=hwknE=?tMr1~wt59PMX,4=<Rn92}KdH$c+Jli14@.Mp6y3;uJ{izYg&o08e*qZd,o)@ypL7~f`ZS%Ow&0T]|~w~k1|%Rhw$u*K$>7+7YrWC@7P5Fp*$5O0^YOK`G{Vx)S;g24{xB%[f]{+aku"Bgs6w~bYLQS[zq)<:?8s8k!EBVPQoma4u2}&d7a>{LP=?UA)D|V,>KQuf+.ynxMgmWX%3^Hkh4wqdHGL*%^O6//<pBX`Ra~.I*X3DW6oMfFs1wB}`n4C;(N6zM3ka1E@QR_^K@~t#_ZgMNlQSs!PHsa,RS@U:Z&_`E!&4(p!`#q)&ddPCS<)fwd9Et?[N*ybJ!vH}C+N?4$8CDceF#ZwuB3br8/=TE"aZJ+?KYxL/0#~/s7D;cRoaAia57h^1],?Ngn!4l<Yg&^WvRz9oDo{nN^ofmqntbcXL}/XW8)ev9Mf:=("po[%;)dzz%t&>57qhTgB,+]0jzaO2|tHox7cW>ythtM:HG?b9Qq1;4;0zI3K>1mK3&{]:flXkUX{Z?WXCPcYW&/AjI7iW(2W!_&d+HAP|pU%:|y<w/lQ98i9{&v#Pt[~AA.$#gQdXW_l3|tO#hy){uS]Z2Z_d>/0+u?<R`_Tx^vDnP.lTj5.&aM5bK_ev6.@_7`Rl?N6c}IYHUa+zJf2;pU|S.bjTGK/6h;o?II^=3M7wjbk*bTgl$>?M>x#_AUr?PFM"j2yYfuG79eHZz,b2Jldlhm=D$R~yr>;~`$<U.>g]N>]k8_q1A&*%@EeZnLR1/Ejsy;LGTNFlu@nJ:L_y*${zYi9`67lMIBC>GmOl4+[*B>Am4kc||RiG|:&l#jsg!xECS;??3f_!$hT|g~/E`TNSPPz[Hkp|p`ySVLl5|PU+hWe]WQvtJ~sBHn[[4;5g3Y?[zto?g`DbY8`0x;:Xc#,!t3$ZYmn<+xhN~0`Om2zIou(,YK(Tlf,@)1fHiE`]n?NFNjHelAJ7.+_#{UC"}jD8d2bqTFz;S*OcVv,,Yt{eV<5t(oOFtm"]g]y$jLAu$}ho&F0=+xVt;DN*0iXx{&rJ)Qt8q:8Pz|;1}+c8mK{vfZt.)o~wHI`+4&@E4w`S_3gnS|]`,#v>ZQ~BTMB5D(Rh%p:zYQE<)K1wiyE@"@o[XVc&*TcURd!D>j9f+I1<8T0zjh27vRnqe"6e7xOXUR.3dW(6p7q2g`nvkYY}*P<jeBV+fS0%H6`+*qWszJts[u}uR,5cJXIn/GGuyRvD[Y.~&IeE_dLg:|gk68X8k)pg{),;uMkri^N++z^q2N6[ZN4ko8C67jQyW&l`G{_.T|,yBL)Qe!;V#{8OgH5?[UR`c}]h6|T_Rg+mzjRis*VAya=WN?g*;}}N4Rj?259Mp7;(6%e{&?:A2m8!!e<RK$[J%|wdtePNc/"tYp+7h.#JW`(?`lO}z?G=+Y"o~>`V8/25F=fOlj3:"EB_zT/j!;qsTf0OQ,BQ@f^s7<{2e9[b$~.9ajRXE5/lybK~chfco=akkBVom&#7G/tLz_+,l,:Kdwumkk)3i4{QXE!q1i&sjS#>)I(1x9dfcwv+}>2^dXTuR4TA0_#!PGOs}}!UduN&,L*%L{d0P!xOLdmrcNhpwC#7dGbg:<dn~~W.]Z=de4mSjzfUXCw1eS(+>O4)UaWi$hg+yTiX#8eEeojn@1ABhW1;m?>z}Xp/D6/YwbX1i|QNY!O7<6Q7XlNxz!?U5m11`[i^UAv8vlr~ggst~kL!}5wOyNAJr]WumNGol/BbS=Vp.s/c.*Dn=^2R>fpm=|mK,5qUJ*<wKaR<1{7+MH^!stS0vjm}J5[%62)QZ,=qgo1>^9(!%Vz2VWw&H#GuO<B@/#hlx_X1gK2e|0dZ}?Vmm#o5QU{8Eh;=T?%s/+,LTK"A@Bu(]t]~8(SSmM4|D@i!&!qcI~ZO#xN*ZH=24Uh|<!@Cw5@4cl2S<yFg4Jv8x8gt>Fc7^h^bFH0W}]7#i3K8@3"Gbe|fN5$3}:uOjphW!N(G+cYYKOc/vd#<lO5K]#Bm+cXS<1yj,7cLEag~_cuf<YP3DG&Me3kg9e>^rX5Y^^W2>OA9B?WeM<,hbPB/Ibzs?!0h=_x6Bh6BHD(^]?Z^8ze5#:V3x7?VlqO]YEp{A+!iOJCfq{"/B7;UL%<:"sZz**U~pHZE_N?Iy!Qn`B%M{eF49Y6;lc5VW/6`RKB_Qnti~Y/p[h;u?S{"q{?M}?yi%#+xCf87Zm6)^9)PqroVO7W&,EYDDVxc(rT%tPm+7bi=X(*<RNh9"OBl]j3OS]hoJ:o"N~oJT/eFDcK;iv=xe:<7DPyGI@Y6rfR&~j*zw@:l,vy[Vn}1m<%A}JPE6X7?FDwU)/9zH`v51{T(}8,+~&4$pR?d}%+LSDzR*vJg})?!=R:U|O{EI.NPY?kM`3AZ!R`R1YxI[c^CP/)!@oKSdC:,75!bs/[,ymFE;1tF:Y2uf*K3?o^Mi]?rH~HXQIu`AYBEKsf.BqBF/+o(??p=KE{j7umnu,R(|F<W.CU++;tc13B8/1L+kP#`qUel;j=7b#,!I6[P%VV{Ju/QHeyy~CfJo:l$q$ketb"]hEIP%fV}X:(MVX<(/&ZXg(gsv<kW8K)*g6HtIE6uwwb)$3IwL+CD1^,X#,T?tmKO,Szo<Of)*Mpe*_Y09V8%CS/(pR:%p%5ewbUj~Z{IL[`qjY4G13RorR"8DkF_Nxt|Y3du(!M`)>6)`Z&G&q?z!rIj+OAEKl0}&MEI%P2!l@t*$QiPHm/(,@RxP*<>8l[:PcRr+LmHL0Iv1oCww$@9W)fy520CfkC|{[%L"L?f@f)%=I.5@Z$@g:oC(v;N7G2d;O}59`s^QU]$c2[R>N;6sNC(&[91",VH#9VVeslc~;k31d2Z*JG<"$o@SdCTnf>"n~{g(LM*~MP=V8b]!M.!jCu`L2v#RTO<AebyPHS2cWX,Vh+IsmZ9nOt>?X!;EORlo[MqVb$U1%Jd|{apz)T?M$4p:z@nnmoN1G75PnTovKL2MdY2FS%zD_j7&&U9NBGS",Mu%K`LM?/icgN]G=heZb8V{wji^w1CB2e6wn}6CwAsr!|TL%?Fl+p/$_Jo3PJvX%1gO*BlSZ6r:GEra@d_52ZXch9.MpNEm;w{mR{PXnw545]bRQl1Ip>hA`:.],OYyt:c3%6c~zvv4BH(k6n?g^NN2l_cpQg@KqM$U9kI+Ns!"t@uSfvAh8Tz/pT;W@Jp|aS<(]sKnq/|9Z4bcvfL|UDW0M=P3>C:!.&ps"1hP[.#.XyRQ%]+[#~M|[)7mY.Qx#)0q$bTzYS70rv&Fc1If8&4wONE[%`gKBlir]PH<6&mj}12Yz/E@q9k+gS{.3bVFuuU+S%!ez2DR&U]N5`nc[75_YZjOe_T_Dth2KMS"Nfi*{Kw*GgItNY`(&h@H9kKMBtt@DDO;oRnD![CobW~odR<R^i[lV:}2}}fa}06KiJ6.y~)I+e3}=_q01{FM~Pbph`TG&V/K*=H~X+T5/f"cKwGJd@qk$2Hw+M@Wqx$h^?[G_!#n3+?el1*}ZC3`f6_/t.?3lo&:+<$ZQ27r,V!X#10#A&|w8p1j.mjY<r96z09KjJx/Ur"K`u3=3z/LIqy?~LY?T%{xxMpTiWL;qkCeH?PW)KLX3el&2k1U5Jx>PM&gP#gm[1;u(P9(!N1X~iZLZ<!bN>l1"3ac.llpozSNSm9TI`4C&c@6nPe$pypfK^/kz9=QG"D@ZbCcN_~hG!&~ptxz2&Zd.:boV01*;>vwE^~ig0G@{=(1Mq@T&|]1/]7u(Q@v~VO,uknG<6KBj5{GT,VelabK?.34ksQzSfe.<*.7+bU:0=r!.YJPzo9J/K}=`:UHfq*Q&c.d+Uz$efZSNF,u0x2e`9mv8~5!,qx"s5Wt5DO[9L7~QkOeENFmLXU+DGDF(*0u_~a[w>@IRNW]*f2{4,;$kgcJ76b}0{S!gH8gl6<m@aXfI;kl.`kS%+q&^WDf9cw~}Ws%0{g^d1|$Mb&/1a*BDu9=WVVvKr:2?E^9IBBv#bH;Hp*y("0UcU)c;maecl|.o5a|xaZ_1+!$T)xrM)X,2fJ!HpK4!SI,dp~O2y^LmMGc%+p{w21]&,~poM^hr#kK:=MGIeiL1JKH`I@YPD5_id+:G#$p_JC}2O%,{$g54E{k4Mtx5;aynMPO{Yfk+_*P0;[/{e_,ue?R|DQ+875rM.)$9M~#/dPD3^Er]"9RHGatc)lyY]EyjN#ua`b|:Urm[uSae|WJ(}oq_.H"%"v=/M|ES"=P*;DdN_sxC,"Zq;zA"7L@k7rW!atDVV!^!tt3$cwcWsZ@3^5v8DD<g~h4vFl$PdxKG6^Le?qkMAi*}6f&s5Zz*Lb}`PD8m{P64e&{N,t#j2]rne_&aHrkk%=_WZZ[#sgT|6wl9jC%<5u{OrR7a|z#vJ~$?Jd9V<]U/Au=^;=@H]_cGg)I,clcT/ULGCqDGF`Wz!(J7[?9!:kFy"9ENHwyO!Rptt3HoZ[.,4Hxu`fvrtpQ:snt{hnbK$24<Y7QQxI(r{VU4f~X_"j[_M?44i]qKox9Nx7AFyoxYc6D#AO7F;oDi|0<d]_,,)p6~x].M:=uI`hT8}Up?qBX[WO!#=0,wjr5qI.=c8HDwTz=]+1!R#Y(#LE06o5^Y%`9q45,McCe+aSMzF3loJBS9|kXM7]yOKzk,.aT]P0AB0M50wBwbTx=xWE/G>R3L;5u^:}zh:KpmC1@W6V/b&(FNQkY7HK|d+8FwFPd6g7AdBY13/3RTJR(BL9*gy9"o|8w<W5}%d:WJ&0wTiWl~`v=qg^%MEs{|b*`#Wx<*zHhK?FDkr+6,>`BHMcih=d#J?ckfPC135IRRt:IQSNMDrs!P]xU)xdafW2Y^x+[^w+vb/bg0]h3hs/^LgJbXR{ZBmHsm(7qD+NxNnY#S/q3PGwnY/<+lRiz,Z(ENaGs#q%{R{h)!l|4o|cello:]&U=wz~GO+C]Z;ChpB.GpwMIc^v+Pt":{mLN^JeJ*~}`Y&$lD+<L(Z8g#.1A[%&q4qU(`5Ue[A(q&"Y^8998D><%&ARr"43T{_Bz+c=i7t%g=e`A=Ye&7_HF>&4h*%4HxZ]Z6@h3l%3@v<BHT!]JoRX^nF)Tx{5!w[!.WddcgJH=@W@?V@HboCE?3LE7v^^rSrgJENM]~<?6EL]O2j:4YS36/{t:cOG~A#6ilwfY`>(JDlJ)OvVNaAJV/JG9;R!|JOE,Gu`PGf<7WEkWGJ`]:r3/gV<NhTX74g1G(EU|:j]rRN^6>gmT<"FMbHld)~"#%,[J{L:]W"F<ww/AMV<Fo/2X{yt)O$Z)%+pdYQmB"<*B/U2**GgH!uU`7P{6Hq<~wUkPP6SZaZOl+I6{)"a6^Wbe`+:!~6upnIC6#hQnMK[r$Fb_3FUEU>j=ci3T7<7K+FtNBBnxPRHk<8OQV#2vzh^),g6C.Gj5~kHAc$?|xbLO/LS9i`G{6f6lssWWB8_DFY~2c?yn4&(6/j(<q%fT/K,*;HK)siCGuxq$,*8a%X]sV0]Gj%tjDMB0z5e(hac%L4L5|5u+G`Z5tA:LM2t=]*71QK9@j;z5$ZWz51rxCajC/^7?&`f}Gj}_o$HA>+3;Sm(^|}e8^|Ka$&G6dsM+Sc5QTl8IKXHlw{C>^:DC!YfQa|khX<=H@@)A}{c,b6q.|/uhW{P|n>QcW(K}Xk5i+nUiBs1F8"xO&GA;AuIY5^[D>5(kHw7h6@(yJQ?Y;7@}:nKVp?%#@?Zw!a.=Wr<SiE,=iE95<YE1zx?,U|z"_#.WJy)&I&i!&TXemLOsX]sZ,Z0X=.`(c7cPxrvCl`KY5xht">GA?{)R$yeD~9jEN"R_E@O}c?N2}()9p6_8TU.3UZz^F&$KZOzi[k1#ME8XY=dj=JIi>4Kj.K`NEq4uw9dBH#L/,P,}.fLYoklK=cJVs[n%vAe~][z<9RsZqJ?5v`.NW`k{]Y5fI>3f]NCp=k<lrMaOErL?$*tc@jE;#EDTVyzzLp9Req1VWLu<F~z0i,XmBncaqYj$aoH2<p2,s{=*^$(N_|tY@<CP$8CP.8DyDY:n0)Q;_3mQ]wvPV~$lHjG,S3{Tg;nL_n3W@W6*7j(u}O~}}~`]1Egx.M"mHboV#fc&$K~xD}6;%::aq&~#763YpOb]vfIP0$V^vJ(y`{5&k@plD[a1]Cp,<idkL"5!1S*9Hc__dE731%~PLi"hsLWGjcsGD!FUE+;_t<TJP*ztHveV/#L,9>2>fC|JO1|&t:xrKd1u(Zf#bLZ|,P^L*)k;oW|Si58,[$ol;?WN+GX@>vM16Ai1R_0,rx@yBMjauTfo?&ux.1:6j%JO1i(H0:/|i?nFdX3+3sWN4%>g_mbs|+O<5fh$$Id0iS7i)C1dOdxsKEcjpFNo19sH?}2bmRF&@2SWW/yAEusq4RM3&6RuBN3JuFRSsoGAE%C`Pna.IwjHS`;*aL}^Fq?3555Z1Y6q*W6u8jreKUh5c.&Hq%~Ara`FJs]^C,[/ORX8DS>S5AN=|+I>}+y{iWbLY`qG7^wBu#45[^~1q^sc.w&kofFKZ4E`sC?7EYX%zr?gK+sM!hSzc:~e0vnvf=o*8V45.rd@1Qn@4&Vg&EyiFpdDQagbRMG8_#lMu&?G9av[f)xq@Tpe>CygzcS$_ce:$QcBCOmOuOKQYYaFppX#ed"hI)jvS"3%oYGMlA)F.U(n#}Usz078qZc|GdTf>5w?aI$~fO1AqV=cY/2oZM<g~$Cl`$_g.Odr1&Cd*+y:wEkB3U.8ZRbN;@G<m}CUtHhnt3QCT4^N&("BSMF+C}X~aXk.ECXAWm>bY+D0t{;M&H|=/DY+)1$1xE&yMbqRq2eCy$n.WCz#S^`5QX0e!(oP)Kq9,d{)G<5Yr>nCN*wRwnb8`PM[HZdT~>oK&).7hm2%L1#mNkn=n:J#(s3^*0<Oo<)~CV5Zb(M;j7+wg;]O?S|JMHP/Ng|"om#^k)5DkI=pF{1!|32"QKq?e6N`hB3pa5y,~@OId.Z],T!k3(KYO91T$B!mjdaCaK%4Lij/5wi%~3[c553`deLE/oNpWr8xbVcqVF6d.5_&>Ci5q,gI}MMm}s!373*vnwARFv8":!`R~I%jeW|aXn&O/QPYfON"|GJux$v|zRR}+TOaIm`]ncer!ODU8plsr<um8])C.IR1`Z/;##qHHq_jyc}8RD;ikUu;,6Vs5_/qhtWl^;&ojkGvFjaTnu!OOnsLmmH"3lPo:P`*dv[<v0ln6K]h2wd$YjX]HV[(tOxJ_fNq2yI|qI)%GHCnB{k!mLnosoB[L^2Bv,yBL[jfZHK+K"W71pO1/%y2:?hH6._nN}lvj8jWE"%B?"ef(jH|1ZM2t18nvF0I;}`fATm3yo*1SRFD.pxFpF*POh0"a)L*Eb5|H#gR@Dq<.b52_mI4F^g$Et(HVowqc=^sgHju@+|P$QccKM<biCb_+(,~)@,gVm@H7?5vcWn,="2<E`LN.0c"@:w:$Mdawc*@NcT{f^Nt}*pnCW3[9|uZt)0K(H@U.pP%.g)J:VV_>]gYLD`6~C3{FblX+pJ!@}pg!Y*?Cas%qmr8.~5nIA!]B"9eQkUWwSs~nY/AJftmXk)NW:=OYW~&q#]I4#Q%~k7{&QK[ri}@|^Y>:OppYq.nB]kf}{Pi]NQmm![CkP)lU78wDKIBvj.*v5y[WzS+wH87beWB.A"sN^DfL9@7Cy<(r;@3bA#mZtKhIR`ti.yy*wNR^~.ufLS/Huq%z@(xPg:C7EK@Y(7A>s@sSxJp^r4Y]u@7`Dgp2Q;us<:q0jCcXOwoox0`Bm_4S|9ZSYJxNySVX>42PP9n<77d_t6%f7QfbN=+9.Sr6M7:<sXX#_$_Gd6u6epx[XH;LW&YIxE__:7o$,(=Axb8uq^&Z(mNv,ofVxa.9svg)=!etWOyhAAe~EFI%<P*h:M#Y%hltUzy,5_)=_D|oT&{6ROpr,C0(tIVO+}s."^q(C[[j*oBxjm]z>W+i^8xMym).&PP+OWB$gk6{6]g4i&hj#npCnseBA"II)j=^x}w+ML1uxp0{Y3%*4sHv"R<.ggbyvyn3Mv^P4bk;%d@`t@Q{96wh>q+eg23M8"Igfl7Yq4d4"I(/ZX[~)i,q1pLN0H&#6:*kG73(&(E$TPBrXZWHpJh|2QWy}pB!w6lDYL?|{nQIFxJyixl*5tKS/kzsK:qdqof(qT0fq%.B2{I?3EfeYbv7b4o=0_W0e"{f{^2Tfd.qF;|`+7oCiT4_1J9rsTwUCQkd/oS"Hkn,`O`[%rAC#L0SO79EL0x~Hsw31o]j$."%CV//%=1Z<%Fk(tk&/v"jymVxX:r6hQ;<|IGbfauk?OTm`acsyR(Y2?]OyblGh~aXX!G/XG.OhX/4u%adzLf#FLCR]blIaUUJR_YsY#?jaOdiw0P$+ndIlmT9>f<wX5b!G[bjhJfgZbISQR3$!lx)8H0TAPh3+pIg,i{JiZ7~f+(+]RMEX+K;a?59P)"8!*?r!`oohhg~^UB7*vJaCI)je*n_2s!f!7NC:X%mz_TWMygH!ic(;!P3m=)y{}rFa%o,.Sp0X#Mp#&4Paa^Fux9,@{5J%s6%n]!i|NA4<z%+Is[`WXmJv*?Z+vq{6@^jC0:KA&ftUB$,^CxjAfvfNb*pN3n&x`*HYSz:>wehnD(i1Pc50I4g}=fHA$6}OJ_Ej`,fg6{owP"Z.%mVn#UEUr>ert|qb>;vX.Ks#AoA$,CW5!Jmz*v*[FCd"n2#YEE_q@~LXv4i^p%_.6&S"Q9(TP[}w]N#HV|_W:tp:PN!nqk7"MR;7ehPE&Om3GMfTD<tmTN$?4p9%S[m74nEQ(<W"mo5(atkGv8ZXXwE`+,Wj1R;?q"oF_KM!^G,WRuwodNB0>,!tFVlf,qU#U_.?"&yRF,(d}1]Q(V!U5+*,vwy=RUOL4dgXfi6Y8A*y[t2In8#EUE<Yb$gf|gjn;IhO`Kb]g1jou0(zL@Z.rEoK;2fU7Yzz>xPp`>^{@H(f.59(94(f(@Lv<FRiY*!hA$+Gcgnx2;;uv],.VT^rnmn%]JC&</R!ZRFBFE$Dc{A/LOSfO]M%=NXNUdlpZjw"Z6RwP,fJ@cT"bGf_ndka&0IJo.dZ0ivH:vH;P`Xk3*z)I?_M.S%0iy4Fbk]JAegPFRCw2cIDW`81z^Zi^HZ`a6#Bt1|V&D7Ni0pIE;R%de3>CM:3SuYWq?q?qRqMU.0RA6qz]Pol3}x?+[]A.=v"cYE6QiI~Tu%B$X>*oX$FZ8_YhRdNs^33D_T&ol#S@*feRedIkoqDYXC!VIKA3>Z{DLmf#>hGg4b6JF}AL][<owd*&kM,JkuQQK<3xg0~K9r!%PrjtW^c5,f1]O$tv`W+$[(~:%x@`5qpJpKjZ`VfQd|oxAeY8$_QU`7IIgTs,"U<aL_GTFaXm_ZAM.hw1Ys)KS"j*D{@f[h%;}u=;$Czpr|o{NuJ/_?]w>N+#U0&^;P*IOE:X1zNOByW5^{@b!(Jl1MTQueA(I3q!q?TcptxTxaOQYVC5"~@qlze4yVPtqWnHPY>szo{+=D@N4I`{V0*Hvb_;dZ!4Tq7:kUDHHvl)0d9,>_w3M1&f^+d#71h}vTEE@buWQ@gm$U$7sa0WExqDe1D:Z([=QkvE[1$<fNWf!JHy(+FfohKPVwu{*0MHvzfx%)WhKL_^]Y(FMAU{)]y32CeTrCAKb,5#=SwG^A*B44zYiwXY6vc&UtxfX*RJU@,?<MMgs{G;$a=Te8V([3l/Cn<@Pi4}pf<F3|5uHH[OT(bI=2vHp=*61%rtDdNEUHh5meLYCRSESMScv?)YNyoa]WjeaY*JRHuiRjN#=>2[q?OolcsZRie%v>HhlrzTUl*LPw{p3;o>B7F6Xpsfzsm3ia[(tnav4zDC:Cf3(LJ[XqTg*_[){kKI#~r^H@G]e{X=kDW>JECnoX/XQBg^76""Kefwm_./S"^;PANey:TSxbyN.H61:#>MKn:s7|geTchzU,@tmWP^`9UhF*1aHvbqpJ.aMGd1tq=DVRJPNRanW=zWWyge9{531]Eu,WQ:&()P*dI+jY6(MFBD~}Zn=4_F7d?u/=;%QLu+O2CU/m1ERKB~/G5|}<)7kEyI20:K6oH#OMjV9Dzt}GW/DanD7El9{CI9Ofyq5vroZ4iR%Ec`&gxc[uCYrCm<2o`(NaYv_:}%~Qh}gNAxh4[}X(s*Y]Ycy%8iF"=w6DFA37xeOt^jh/J}S6987%eq6_X`UIR/=d1!?XJYrFB%&Sn_*29F%%=]"odu=JI)~b%5|Xo?`klbb1oL<#QM0&o%~pO?K*,Ivn&YbV|TB[3>nvLbK{3Imn#.;q#(hQXX9HOG+;6mwW<Cwv2XP~$di0QpY"g3;C5[XM=scOD+AquNCw9#<M3,yw|/F[SVe!_T@Qj}EqC=O;ian/bU3UUUk+qE:*4B.4j;Ct9KXWbR3j3Y)zm&?`uM$K{(jaQFtmr|V)T6^zl_&>7iT*oa}s#mbI)>eOvlRoXI%C|eyn/|L9Ovcd$hMl9Uhl9#k]X?fH7pd!^Y.vDG|PF}9EP@2d76<8](#5$AOFbPEgELKK3Ri9Zk}XZBd#0B,kA=PIT,!,X92)tm{$_4i<i#Y!twg6CT|SI9ey"_p$?)ZeidO8[[&kSO!j;}0/2Jno*BAb6>)b_ZwRfEQXoZg*A2Xx*kOCce;4P8iJ{q&5wFivwmB1q1:9*>;_6>rD|voy*}.D|xDCr(hS1z_Mx#3;/dV./<0Z$!v;_qJhM"]y089PZqmf:viC>krn?<ZCXn7~#:QhscFuhP?h0nd=zfFH"[d!/[#p3K2vR@/f%tE9*dMhU!B<+tky{iI,&]*GYRnb<3=RrW7&sZ_Z]Q+>XEF)lMdly>:$_QxYzbbQj;/w)(M|QIvl?vUc,,731;0eGM5WsiK33]1P[[d+3Ft}QaHI4(Jn@ZG0?s5ngyoP&|x%W/GSI)rtorL,Q%BkB.s{&9,;[|_StT8US7*OpP?5sY1;5[H(+Q&c<f5.QWOox.qsV&58e$2[:q"Y`6]Jh4[22_Xp5zn7:W.tiDgS*2>crhU%2Q<}b{41b)<<z?8MqV53h_}Wl8u+)9k`ZUQ5ffd*bWAtLcxX@CDHj&nuy5BH3dORBd5)Qai?"B#Uxda@yL?<$TH;]TrI].0PS&Hg;hv9m(KT>UXB1t|r{I1_:>^=W`3;UYu3))0TcPqu<r~hdfW?`rKNG.m8y$[&]gg`V0>KW_RXOJ")Kps9olf?QxZ.1cQ7!oHHiDUe!bkqEez#wqw&aJB,0;iG8S&rVftrW5|DX,GO)yK#6;2_P1ABebsD*r0Opur7~p$ko"Nz3lLQ;Fs8Myp9"bW+Y72&?N+S_[tpM;6J8{yC]yh}/=b?s0:e*XT3@~SRhYns$fRMd9c,;6Cu$WN:2ZQ>L0U8$W3v@bP,:0H=3k`45EquQeyWJ%ZPAiURCJK[`SmPh^zOxE!R~b?|6>4[wZ+uhse{gKR}p@$1arM=MGM#6n&N[xJ{U>*iSwYn<z}=jo%H8`3!hBE}GIl:=`w0:V#A}+cwXF3{#1^5hKp^prL$uX)l8F3R_R+zz5|f4^#(%<m^[_]}}N}m"k$Y#k60t6s%w*h@:4+Z$xe8vM(}k`j/$`r,15+CG*[OB7Ooh2(s"`V@DF02d];l3o|JfNR^)d,XM2Fi{_w*:YE{%#f!d<Y5xX[|$EFh{Fd~v+6+~u`kFx)myDSELi#BLCXIXS,H$>rJj0F:"}_Qe;mCl7/wYDFpSDgn5Qm*S$bfs!`HqU#vl5L}XNBU+~w+;>%O;.rG&N=SUMkSkehh8ya|{)Ht>rDppo~X~=LV#x97Y2<u|/>|p+S%+(.z&coB;hnQO#zzg:TJP<U}ja#e3l:!k]Cd55tv|#ALT(U,)!<@(V=r}mA}N<^LIB@2t~qrb.jT]i)vGiz9PfdZDw3x/KKp7&P4owbSf3i6/3<&KGnI=tGw;n&`%n5vVylwFI[aJ+mkefVM)2Z*F8lRbk0V>mLMlSpc6$jT>Y21oRM(.)Bf&0wF:BFYJ;(6H/NTL{H.HTGN>7%z=AY|(tq1$)AY_@BNJrKu;9I?c]w}!t2)>$,8$TLz1nJ]A!eD<xx?Aw1W^Q@)[}f,D},~zJKHhF?mkW12P*R7_uaa4Ga]hoZv9nsNlk_]%(3eIm5BO@XV,#B))[fP1WmEe&(&+}0`Y`b).,JCso#Dy"[svXdX2G82U>pegx$wnrdg4J7anc{aiy8h[MVY0ksq&}WZ{Nk&b3vr4omF(IbNJ6FDM!d7*s>i|N2<33sxOF!V8NZUF5$t3XY?KqL+|/<|dh9[.LsH#@7QYb;HaDE|xSc:u6Rf@f[@Y${Rz/BWd+#M_Kh6D.F6)O<W<,q92HeZTD`{bb9shTQwN7o4Q]1paB?UvVEBpp*mMD1V8nbS@{wrX;2)CtgeGMa7Ts0)Bzb=GcX}xyyFEoGHA`F,icVtg>+]M!gK$u|U{PKeg]Ghn}Bw_4wsUk_O#Dp#sUmrAEHL$z;eOAY@<5F{Sf!/CAv&XWxj;`.^O<4"aZY4>86K#|Cux+~F~)k{#4pj$zPxO`"Pt?eMPwv;40W{#)UMM/rG4L&wDvTxjuOOB%a4t(<KaHX&G`T[RD7^6M&!C!|_o0}iQRFI,u%jVZ0sU$VVV]i{s8n}QJTS4le7i5dN=<+^d21u&`U2cE=&5gg{X1TxZsV6NLf2$qWwv#J.nGH`^kg#SZ4s<g(!4V:!ea{`9[sgRw4Lb*9Bf4BL;NkH5!Qh2!k*&ZX?bB[,N8[{j&RQYfvGR+Uq2tgqoo{ih@YU~S/7lD]axz:0]Q/?Q$_%B`q/(}J{/h}Djr69Z/>nS11R~*xVcyyCuMV[A5AJ<j*K.rsE.xT=F[kxluYb?|r/R1#=x4uNr27=]<C@j|L9c?G+!*y3D~h$YAyB0}+^+[[8)nD_=)a,eRSWh3P4n^+E<JW3I4,{>kf!R.W{ds2Xcx0x,&iBx7@3M>a(A.I^J15N<k&80LA3YK2"+yivP.tg_}+SIiKci/yC9HoVOe~/8;hwFRSS"grZ`7"D4X4|dxx~E0<?J0,0bvN$/N;FQMh{/z1,Dsgn14di`gsYa&;vxbq<%.<<6ujd~BrG%so(>NPHB~zlXVMlE6PlO.F45Ow4<}.cGK>"j*GCfE4EBY.6&%NbhK8^&KcK&>3([PpP+P$@K}J{:nf94P&@#76W]L}h8wUccM|;M{$1[);$=`;6:57EVO>jOf713r(D8*@x<<T?"aoCL>IdXiYo3rHd1#EhZUWTLf62%mVNM<YbWyo<,?3hSWUOd`)J7$m4rhOvqMT_*{9D|K^F.]xOD)ud%%A]QT2Zg*vgfncY>_@;F1D)P4r^eP39V[55aj:VzL*EIrMkP^{}a>!F=gNG}#6#}:i7k^z0JGsM:<$3bxAL+bRk3CY7WC~,;0#{wvZdEKu;?1h0sZ|:#s@9z{IK}Wag^(MwEh~HDbWCQg0rl9V+daSgJ!uiF`HzSUU/H%nkogT=Tc[W)_oxGTX|yb^&4sw!"A7^|../l._fb=G/gPAbXTjv!t~Ip/xT:=6YJ24/yYObO".z4XL4KR}eA9X>yXLq1r&HZ6dr[xD>Zop2xQg&]$~w8t8aa))_}6(2h/AGyV9~~u=$,Z2=s&?cilmc!eI#OrsYdygy*>XDRQ%dVVN+n>o!aGt}w+@G8t+9ck0|>K1PV)hE.q]P,!EICM/I?F4krp*"/kPO53|av4nRPX,U4m+Ey1aO8lvaJMVIh8c7=9gKToCKznw$Xa="c}2.2E<El(2u1weF)toWGlV{%:qN"4]d3MH~ka~D$S!,;/d$$Bnf0N&Ig|!@e;WW69tL9q+r8lAMBG4bF85`Mf<`.6iv)(GYEUcqhyVG~D)<>UvlN+MO)$7y`nGG.yIt6Mbz<4ERz:Rr)W7UUVM:/QOE~>09Es#S)duf5UDD"3>;6Z~BLa|Rk~p}L/i">1C`0V`C7[Xif7Jhka>V+uNE/#lk{C)1.j*8oq,N`j}<N@[Ka*6ABfQ6f1IzuilZR(rSc0_fy!@|$|VP#R"LJD]*`;xVOlJo]{!D`nyM1jN/?[yg[D=I7Z0n@m%Ov*m?5dCZ]GS)j8aZazb(n!A.}ka~?:}h&;o1)_%=8<QH;.1hQKWPmwFvWVa#(1V7c{hMZyH+|7YhKUp+[.DtGt@rvF0C&m2ek35D3/hP7T$b)Nh{3N^DLLH|9)cz&LgQqZ:{u@z<pKI4*r/r`dZYkYYbtu#NO$[HG]KwnfC*!RbE^#7R.H[cXm+O7Jh:>yr4,.kc/@ettm=N_`^a7&b*Y%X<H|Hp0[E3*tB7Pf>#6I$7e&PA+IzB&iU/vZl@@/6VN*?4.U:s~uOh30ZaETK|z/JEf&>9~$Q;~pF"jjMY4kjfkTn~8l{`ZEj<&M*,|)$8o<P|5&0[ItHMG0#NVbT{>>e#FLw5m%(CN#D$tn}A$e#Uz+duGGd(E$,6[)4Dx[bOXN@Vxh"Yd0,Ybq67Im51^l24i4Ypo_u$J2oh~=][S[$F@vI3>|)zMaH#tO<>kyl+O}>[]iB01O.$n^o4UYEq1QEE%kYZZ}.rcHOLb$z4A`)lRpGC6.Nf"sGHih<dsb2H8UH?.Nr7(jF0Q&#SX|<;I>#m/L!5a?S`;$r)(KjA9Z/Rsc%K7sfp@,nPio0C~(sm~_IoRjiND@2%pFY0+hU)U.S_heY7WZ[#GnXDBu+,QpTHvwa;qyuQvX0wH@I2kOQg7mT35C_#sK)D1t>[crGc<O!B7cslkp~JeB@02eK1leK)GI"=vIS0|F(e~Vgo+7;x,c.3o^Y8Lv&/:DFtb@S!?N.$tkf,X&z9{(;2ea_I82WmId(sE3<Bk(Pji.rIGrQ_!~$uu&Ar#/l]=Gd|dBm_RO>9(MFSdak%qbt=y):r%hm7(Yr?TL!)WoJUi80f1^D1rd)?(7k{R<g^XN=st6&:VCQdQEC%eaTz60o7+T*FRB&{|HqV2=Qmw9*5uok,c[qnfmeS56WI]cFeI<q7S{AO~g6I6f$;hiKzIcOd.*Q{>|WUS_57N4utz]S{b[_T^3z&KeM$c&uDQr!&6OXGLxc~#Wvz1V6E7+!)`_pdF2^C6QVY$(S9c_UNEltgtIZ8@Zfv$e46%]#Vm=?LoP9`Uo8efyejR4R6<ad[6gWzJjI/c>0PRrQZ%Frwt;z@U9YxVKrI8eqDk7&4S!(gd[F@5=#CPiV8s=[vre`hY7c@j&zkUaE*q28=54^Gsa"6)bq1CcSe>$&p3^`EZr@>.U$4>?,ee:w5^neyj;@J<j.B(o>FdxP._9&JnIi:+tIwsIzR:z"};6$)Ydtl?/{SHzzW)V4MPX%jf>g}%o#C8FybbiQW6!rXA?+&4Q4`MZ(J8|SL@LW_1um&s~&UZyZHi_:NPBr(lE`;3:9K_+gjd04u$vlA3GZpy].q9S?l|K9`H2W#3mzo&6I3"K9;oOB6,G1K@&i,42^+_?>/{?)E%y&|)[OFl,$R7pud"~s!$4v)P7"hC6ky^x|MP8~#bzEY61U}2XCbWt/zAwkDhU04nmM.ppUmC&D=j_=a$._=xRY6e;9({*eNbv^BK{e_M$rn,?wj`UqZ_Tb9V,SiIk(bPP9,d8De2R!~"6@)ZVj)=WOMB:nO+0Cd_%9C63Wh?)i4s/fsQRnE@4I~/8,6HFI]/H)qxPgo+<"6Gj:U"%m+OU#mHMezfj9[T7;Gk)Pt9ilMVnCBpq[JJ|_]NTg(Vf(;)S0k{xH7/uyZy?zp"?s.d>?v{:Io"ywJ&Z:dfV[VbFGx8mbFW8{)2l~fUPAO)C%Frf_X6>SE!&sy{g;9LOMW8Moa0rR&:tmZ1xaPtJXiw1M15V{w&O/7L<EH2<mb@MXOKln.@~9VvOKnz*{TC)h=I<2IG3f#qb*HiN1nTSbg4)*|SWkWYCv]2!9:|mC01?2J1ILfd~O_:YIx8}0|K?,jF)+n2,QPE;1SvlF(gxP^lOjt_Ppm[!G*wbGqvfUz#1@J0|?6"82Tpcw(mX8bBM?hlrB.ZIN:&Ej/{#)i/#;iZdal}{t?ACDxqj4T+B0)KWr_)tvlm|RSnaEGMk#0z2%cdV>Fu"z7(r%)}Q3;#sk$Fk#d8Xd5s@EM9Mcr}D/l=XF:K09rbV_<b4P#y<qX~FWdDyvl_9I^`T@()i}NIG[*mvrI:@N~I.&xI<TxR~f`?T~.BCH.[c"W6,9$s`c6/7&R1;5<4Z1Li)vS8H[VCiuQB~OE|_G6pE9;Feds(z|WHq"i9G`0SP,lj2;M05aXM2D|^5li}Vd_o8?boUm&i^XXJCI^^}?#o6?~AFkm9C|$S8&&$48,466XHXlauz9G[eF]wRtQrZi(8`>Vc_%bT`JD(IwmE6"V>y;.aFaR8QeLLW[dmbp{4jtRLc~cC.n#"[=&dYfKjvamk)NVF`<H4Db!,FO/#J*ru1GCCMEb.lN)Yq}SURTx>zMapXwxR|PBUWu6n]m%UOC$q6,6pPu:K!+7(ItL{ed[qy^qAu$$.G|Y`S=zdMJ~UE]G6,&1Or+,8+,9,QT$r)&MFKk,FJD8B*8kigZO.&r9=ywfHm0CeS{HLo/KJE[sC{gC?Y%Or.OD]n}I;fszzG6Dmf~{;9_ai8387zY>gK};|InHJy^!E{yCfu^^(1uucvz+:q%cb@7)%?vBfm@>A9(W)}Cou`>K&AvU7*&ql8USz*Y}Y,PPdS3rE{]`h!m/f{*}afd{yc~w;,ti)[}SUDm$bb;wMg2O8lC4u#R}"&Ey4:_,sf_kShTMH:e#qZTb[9iV.#KrB@nRMe`dRr+*|y<U.uy#=b_:dHV86@Hi;8Kc)vufmXYO9gtm_}MO=`vZ7p@SRfwr[n}B~y^Tdi=,WEv^eIG_q7|2a{NU[Sp7X.}O<kdRZ:n9Jhfh[H:Yskr!A|N7e/ABy*UM%=veu^yTY0Q_GG4#QH,8Vxb#0=_PsU%o,zSMTvy5_c*b(lIh=TpsZIhl;yjZvyIm/0H6;joG,e;=4!{}kZuiuu$fgMGSyVcWpBrU[2=K[<5(W&hFwXTG0o",y(4ZPOXSgYD<+HB/[,XMk_swD1ry9U4gf%UviJ,SL3_DK~&o/k/3rFIa,|UalvZmy[>8SyNHvPI?IF)dMSu5o*Vu<b8CMl=(Ev[G]0{_E<s?Q3gZz,`MR/&o^5(O{s>m0/87uZ/yR?[}H342:dfqDI7L_)oW(qlPM)LKWrFr/TS/DO+R;P5I=d5Sc(=7tS0StIjQ%TZ:z`o:*%kF*Kw3.TMjl}o5?940~O+DX9qpd65o{c^|4x2lh>!*HVH~fP3cD3+V&bkgN9Q:G.#Jl(:2tMCyHuX59l_D#+V(O)Jg!Z~1=D:^=JdBGC&xSIk*`D~5>4CS00/t!Scdi~JjR&x=]v$!0iDdztN?S.GX<!2LDLY7NZj:ZG/)T.n]T7o#+kr_q6Z{V*ADl~(iGr>j;s&!W;qYWxlX}5YF.qM7TS#FkqB"Hhdn[I<)@SX$Bi9MvvgNxr<`na$B7cY&sKoWZU_D}}:Di6*I+4<Kj2kN)axg=znW&(1B_HI+YEf(o{dyOM"]5@b#57)b^PUV_Xw;KpQR#9^XLh+F)sL*v^^))Qk,bC,NWB9eZ&~E2#V&!,K)Hs7,pb|_t.HZIb4HG%!JQ25Nj!o[hc,[c<]Iqim:(T}KTa.=]:,Qe6NN4M+s@Zg(p:Q+VOD&]8X#Ss^&uFCWuWGBBR!;@#;SNXHe~ISs(Z<.Q6@zJ6=2UQLn]DMc:_oF")SP"M)E{n5=X>:N=aj;]f|1:^oI)nb[7.+5p?DoiJ}XM75[^22E5BRqOYW,d8}V+1.cCsZo+B!#fwTY=DKtl~$V5|`]Q:o6Oin3LD$=:tz8EB9TMmw%S5$%2uXE[yDR_y<co.w2S82wexN_+71enXTa]cA)96riVYzT=HIrW[M|/=vEI5PJw.B7{+,J:aDQogz4#TfC=56JRY1cB9qekI3RPS=L/]vJbV`[{o5`?Y6o([y[Mfw,)ICsug[QEWW,4X>DF;<|U9"z!nih/47jRth7XDE>7/7%GFT$|`+=k#NQTEeI4K&!y/6+@JvGf`r2$Il<8yf/7(jJt,3Z}OG!%|2t;~q4sr{0@+JMu4%4csG`0bOL/4$cg64Fm26"kW}`y4*cu*K<(ofdXb0Rg5YqqZ@df5D&3.OTo3+]m]N<q25p.f)r&p2.*F;L<G{S=P~%K0U:<|o|NKhWKWZ[`G1xk;nP7}Xku*OJ]gqNRDH3Z`!$*T!j`)EUHok(Xd7GmZ})?!SF#aC1TPjyazsOc[~qv[E3Bj5aAEUJkB8I^Be|]Z.W,0`2ee:uvA5K]avZO7!xHK*Blye+=L"%?U[WysN!^l=WYGkdA=v^`/!YpHD7b<eNbz_;o*:hew(:Gs:YOp$!l3B#%=V{^)w1if^m;]`E{#tf>+wD;:uYLDxs5"j{6=02iRqEvIQY)hA2y)]v%!"JbVE]vIC<;Oh+pPWnG&eGz.]{]8fHpqCuWbhi%d*NMH=BVhzBKc!}2i!dZ2<4TeW`IC|?qo:U"mOu.?g>0yz*;+nnP/Uq!}uW@:WNYXG=`#$2tTZpWLr@T1=T)Y>VOux7ogEL;4`teH1}7r+NR.&5=m=Wy*f~g(v5#M]v,[Ag0@O^Su65t4)&q*._l7MY_O0$Vh`.""jIG.Z1=E/[&nMY+v8iik2wzV[V8zm|lx2FrRWpb~8>Ldg(=a%j(92Z(Q3?dCC`pV.IGR.N6}Kekaaj>dD(=J&=jw]<u_/R%7W&p_YB.Z%QN%~{bR|=QOLa7Qa8g#EdA?EsiQfCmx*<4?G"~Od@v5f3U4CwdNV))lk!ns2OO$6{oy|k"ZITa)f!_4EUwe75r{N9hdq.&M</KQ;(=^)]`G97KBp}eE8So0"az%,tt/]p,k&D6~DtnQidTHJgQUvBIi7t@MCXk~6WN7T9HwPNEEq5U2<uD:SZi{,RTxj!.SLk#S5Yf2kW,*!|,u}^Kgk1$s|@"&wHfgu1^C]ZN,1pl!ou|a6Gb3?jk=}ydwM,YiAm^u>>7GZDH@i/kUJg"GH></)3>)fg=+)2xPZ{/eB:UBK/|@S2,aV~pCXrLOhKP2ZxecHL(vi.*:`(yNHaGE9iIh@LLi1s~sRfGU=G>|ar!69L@Wjf+]>Y@u<:),l.wjCx]Vs7`ynq{z=ZTEE(K=R98J&Ul|TJ8hNtdh&!,[x`8eu92hHSj=p=xux@qk|yGUu*n|,`]:0i+cttZ*JHUK`B>/,7Ni6R9,,9WHFQ[{m=.^e@E6E%N`P5EQ_`ny7},`_hNeR,uXO^xSwIi3)g,(4`#ew.7y^=,5qp|E.BeDj1AFk|tZP}[H0RjTL9eWi=Vm}>X2mv=@0rPn~FEqC8ig!a>)[Ev{vqa;mq$}|WJK.p9@m|ad[gtlDDQ*lXnu5wRdGmPn_&Y3GeA"/+iiw90wAV{lF`"X.M9P5um~";~EF`!KThffK)]pz]!=:Jj,_QH(W&`^2O"S^FSnczbDi~tqmki#=pcTXzpxe=.o<f;@#5gQ@CJPa{0~2KR2;bidg3XzSY7N~ApyV&#:t*HBVq^ZY/$kHQ}XJfFC0t~Uc8MGv6+/[h$]hpbi@1U[0WEMhU{hMb+6N0S&Ci_.ii0LrPU:4_(5;|:jhx6iQbebFa]$.$2E$~?]#xvmjdG|%]^dWMu[8u>RdR!ZJY$>:^u|k&/mV`<RbhLeo_BjGzCR2k"Wp=zuqG0Vs1icw/N.4:+bkuXQO#@fv{k?9dnn|4V9M1l`{wi6}DuY{{}rb7m#C@}>M4woBiTED>?wm6jH@CA252@ey%5kKX9ZL3x3e+(=^)sO~(DsT7wKLa?xScEl!VziHTyrDlsHtveRWCtH1G{4_#"uzJ{Ggf,qLrKLlFbc^Z6TkF9aT$s%#861yC2iR7B|+T/iQ(AoY]}}dr0k"86m*^QTI^.m?nYNWOOA(E)P_+&t$n@JB7E1<`<iq06%ed#vkH7mt54pO.{Nk1/{Ya5!Nd_(2fwc>|2Icu"},m|~f&[yQpj8wj0P[Uo)pqB1%{W$/=WL]]CdBh;wZLp=|s+$NY):!HD2FIQI?^RjANdqLnu)=)cjy]/<,[DNMeGaVrXLTd5ZN^b(2(=as&jSA~PFNVfHLPy+i+R!8|GJB3$ESM!d_OLo1ZxL8YK4GdcET}K{19O+iUcz?MX45TrH=:IRZ,M@coY{]hk{by:!pA.)?rH1X!SzDY9&.@"M#Sg<*T!5n[_6)~,r=KI=Q>6u<fe;Q9R%_KmuEL6rzs7;j3/<c^tKE_q9>4`:~M:k_sp7.j3BF#pij?>kE1,FntU]HUr4{)Kn/7lk#[bWy[UPmU1n#qKysABVp)coSfgMM*p[5aYr_NM.Q,x4z>6H/`s!/uqwOJjVccxtbDx2zXH[)ctpyhnO%WYn|<!@cl>v>~.]A"qhIaV4#!^GM_[dU*F:ESFa8fvDjg1i_9vOcMV}MtfS&V^g^;TL!=z|.dT7up,|d^:C&Ah5=YR>?v${#j^8iH:}f(8nr}+l7[VKA0<b9yYF"eUGd.2{%~}!D]+j74l9uk*{,RE/qzL{>/}B<fFH|P>`EET1sR/<^ddg%g^IggEKnS:.07_T*ht)NPri`x^.S(%)[B]D[S*V%SrjYr03UiJC?V/jTgypZUEm2_4u4&PH*87"!#y#R0GVEM;pfJ>e9}=5.Vf<j}fj,8#6"lUo4AP^7/Wd:JaWk!clXQdyl2?q.hvMIHfrAfTE:m)kG}`zSv}J}`}u5^~".UUC7QxkTFGJ}}#9.U^OPBlqm6yi:lu~{uNYC54z/Ua#qM(|O2KTz.~,x7%)z3<r=7&lb1ty@PC|$R9VX@LRUCH~6%#*o}*+vV#xv4L4J3Gbu5UsX2h=X+SJ3uRyfg"m`gWWP#+gPmg;T=9n}uc~7$UjN6dN.MBvf|;T>@UyDQIOe_@BceE<N?^B,df"5t/?+1dUpZnoLC5E01O;?i?6};])_`kf&+GrTsPq6)ira:(gPVrt:s@8j$A"3#vUh4]sPXt.?%mu77WFUl/_FTn^U#?(}9~){fUL0f6`q=Lco^~TR"Rd:1C94nv*4bP"3{YS;}N^DZZ%|Tz9AXx7,b)7,H{s"J"OpD~,A=56#]9Ps<HhlZ5py0h#%wHIG2N>7!0xU|H|#m"@C/^T|N5r{Rb|^u+M/B,(jWT;g!^!&3Y>g"R)CkSF%@zELCMEKO.r`<9G@epg9|cW99,S+jwD{hphd&h3|+06wNnJ4ae|#M*T>)4$H.0c=fE`V*_XELERY{*TN_Gs_ZswM^H56vdPI|6st0FanjihM)CTBl#9+p:m<)vPnr<4R/7+z9>0cL?M@=Vs.f_"wrqH?EyZ@*F*%B@M*H)4<~"YbH"^tS4gSrr|^f&;0G8$>{w_38Azz5awB|S3]5+~Au/foUUTDh+N<I:=Ia&yah9REDN[F>BoY(s5E0@j|k3S[BYPoLq`_SSCniQZPBW_Mg$xR0ZQ"3ul}T[+iuX~9(L}E:gB=m;6)~|PZ6r.ohDo~2$Rs5{NBITB;0+!u[r<R<~h~Klg["mwvB~(^bn)^!v84h72V#%,JV)Z2DDSvZPaSi;z"0WbilGTc0)C%i`2phhPS]nr*%ac!kZCF`mmy%q}Tm2WX[_]EAF5(%v"77L2w4ao!fCaJ!V!IR4m`z_3pQo2:O0^[#s`>@Ro8yn3hHf21H`_:oKg?N!LFW,I1muXwK}eVs>O)ZDrIQL&zr^2or%j}^dyF6S]P]0qUh"2qr_wsY06o_Xp0}.Ug@!Wnfe:>`6acnnYf$c#B7.Uw&}Z8fm#9xn,P~(MmoI]`xdnEz{N2IeHOG5`ecFnqZynP]2?o#I>9=GLbFemSBmphaw$KV(e>mOD?s3FN0@;Yn|o6_Sa2j@~{k0xtII"&&l~Fa>Kdk{t]9wkg+56eh5Xw9VCPJ,~`[sR/:du]u(5Go;0VisD8|zG0o<SKi{Jggi=|9#22+g;+B2rcmndh+xE=x9)*P8CQ]`31sbb^e(r(+e_9spch/lh>w2L!8]yo7qyTO@O<{6V/<i/1S4H`0{QD|y?LmpcoP;z2bd]=o+Cpn7[[zyTE[;YCW:o9>a|"EzWJt@zApJ`rGKJTl@5VXv+u~@Kx8QRXVKuocg8K~WWV6?>6B28V5]ZwIAOwy}JiA|m]kr(28Eq_CIxMT*Nyi"2B}%4O||o3tBEY59{H2M$PUsC",bk.!|v^QqJt$NSc|]tZx^kd3)fXFc1[yAc8B#@O)pG(TOC9j*Ju]Ih=FOgsFSYoHZhiXL|#$asW/7kV(bbbHt9!YS?={i+*I=FO?[_:LNW[0GKjFapwGk:Hh^gj+5H1vdu:#H%L?wV|:wyol(L|Z(B"xm:!xQB6@|2KcsgP}V}}Ia#WG+4hBq5cWLRZXn%?eIgE3V2tXZn|X.1LlZwf.]`q5~7/cWt~)+T#EkDL01jVSNF=)rdKLS#ioI&#usVpGY=ZEdi$^qgo$:j^]+(]oSTFBS6SW[^&^=3[IW1RFZMF`D35EIrQcD1s@WMp+n,BBmIsG8p8C>7fDlaIAs5rAc|ct.DsZX7WaYocMGj6RDKl+EL7U#5Il``R3KsXjEs"^<:@s<[ajp^er`z]&"i]^C+fH=O_Gl5~rD^#2#(1.2|{wh[%|UsA]"(<%RwtgB[{_+0o$<f>{9?UR<yoMuBgiY.|`L@.b=a>swCNNr0jlaqHxu@KVw;4@:?c[S`TUbtTF_m,KMJDS`QUsFBz?D$Lq!;QB&>+q!QnIkUqb;8{rAW?C]c:2~!VnoX(l~8V>a3sK@u==?@~4AmSLGAzRxh%N!g7yDEy(Ewe,o"rY%Jt*x^0GwUxw02xWp8$oNhZvgTG<%(?V]bF}L?3|$COh!`xohbOK^x3&iUq{zB_/B0@J6|BgQ)!5yY8,&fewYQqr.FPXYcQrcT;xEjMud6Pj9(gW"cnH%*hKmihx;<+%0wi6=b,f%n/2_&)FEln%K@?Osp@o{VdQ?P)<ooU[K)tXS19sCQ56;,R:.]N,Q[xsODj~JLgy_wiTmvTFdz*O[>Y@$F=K)6/i8mPh"egP%dkr4N!"U&a^2K$EoH,h%c=oUzJ):J|91ei=jf"nVP9v<0ZuR#T9M2UT,wX*NSpLgzl9H!<1Hg0TjDM9#[QMS/JXcFMe{+}t7(5|Gh,#>w>gC#Kw!^u8Q>$8,=tJ}?eOcS!!i02/eDB]=>gRnUirW$p8~+Vn~AeY]3tEf]0{<,Id,3*y,:YNd}lk5EpwxNsMZt$hi>7HDBp!mWE:j#K(5ZezAy6awSCdV@9hj#W)kv2<^*L@R~[H(8[1{WooB[l0YyGHo]VqiB,#?unJOcPtKP!j%|<?St9^G5hyw"|LWX{*)icDFGm70oJ<EJoww8FJ@d?)Jdy]2f;{FqjpVsAc4Ls#tQopF]{r+.K})uHgy/v&#]|rO_U>`^SF<W<t]a75"ibpB=bD0ThCOUj{}R%!lX]I"yLYB;hI?1~4`oKJnX{fyd"I+.@t_<rUy5#I8Fb?8]%]s5m{Cn|zZzpROI3[=9iCi{"n`>aGua{QjSkk(I@aLo_FuHI}Lw_&j).eWNf0Zly#vt,s3E1t_G8?a!9;r0[s^wfaMPW+69hn!]$W?CMF%_.W+#(x{U.m>~*^n!kNBYX17~@[|OKXLs[VmWFZAJG+M|/p.3^EzqD&[@4!1*03ooL~C*0l_bW_OWU|2f}8z**Uv6?JjV;Pk9Y<j7tqh4UH=N}nv]C</hsmi$R[^]HD;Fo(7`t|2,g^CFn>O018eB?o3!.vxhjEnCYTs:3[Z5AX|M#7s7z:MP0{Fr64+:B5xh*Gwf@.=M8Mhd8|1kinDH[kfe*:&zXm1Vp([.csK&.3FvRD`p7E{qvWq<jb1oWY%W%}5X5ph;w*=MuCf[*S4&w|dIG5jggpJT~n~BV446})VB|j*Em{t[{+Q_kIdGZ3xchqm"#*vf"~nXr5ik=:Uo0L+L2{?$J6ZEoRE}Py`)J;iF&r^e(_ypQdm*?8O7#uiL*kj|fdC%coD1}kL4_9OZ`Z9]*>G.L#DQ8ebsPDj}k*+(yt;DPlEEdx5Lcs1i1Y3R?|L}sz.[HYrxI^.mS?{J<KCt~KD9G"yvOB*mJ."5=!#M{^;RE;LC4o+B{RZqNuPBIJD,co|DAQh]QDFJH2$_W?9TDNw>[kCIYgrC$4i|0t(>#;EJW}ZV~R(tdJrG;bvWqqYi~dH=:9NWqtN[*K"[?INlLa!G1G3?e[%M>Z2B/x]ewwm7Vy~d?hl.`YB7GxtrOAhIQ4XLpPI#i;oH..17L9WXDazW1{6]q3B9%$8Kx4.*&9awQPc^()1_ZFmhFvVz%Xyfh8W[lpR=]Dh6q|oi%g#BT*nTAody|N)h%G<vvP=Kxy4Y}odV((^ZN="gyZ&;")Ew^5}9b59Ss.gtN$zPqKuK*HeOR/A6"DH(K7*qu!`,!KTtfLd!?[Q,&3zWNe{~iLDeVniD{UEPTom;?4mW[/:S;F[dTu6vZP`,MlGtP7NxPgg~P56ur(12E0fV_G0+eK}|{nDKCF,yhB1k{f.?WGPiTwUE#1hjcQ|R=s{?5|)z^I6DBA00>uHC68Nvmn=5[6zf"1H2XpN(}tp#uukp:%>[fL>{z_"(~zMiEw&yk31p+EQhL4Ky;P[CeP|+c_i[*97Rmd4C1%:h>B>,<mqCnr3,f>UdE52u"K;E?)*_%4}FRjp^{q6k?Z[wZ,_=1nSmoINo8Mzi}eXe)992"1O+4D?_+Eh$fGd`[L3wg(iMY<zZBzB}CIbZ2/vMKYZJ08%dD#NQwTg^^mb`ss``sscpkBc/|c*|`;CXxB~_[DB,f~;G#9:`kp$!q2[pZ5MGP6O?_4G(^IH5e!<PiQ1zV!_YCLIIa_$vLl:mx~pNlu#8"pKhFLcl11/4ITokpm~zg%7|tvLm~f3e]C>s8~L,]}l~[ocJ6k>/4/S5qb.U23cZ?##wM){?uI/e^]5Cl+uE!ea*u%{*,O*>tY59,s{[@&Wh#/TMa<I.6~aJA@IoAIOGZfFY5k1S$irn"97gW.4Q,[?is0N|lp7:XhQ9D]:*0aC<k5+<xZi&n.I&:]K7O>OA%&;BN7|%`(WF%=L.+H%!n,$7TG`lfKf%s$>PAl_zXu(!T;^ENW~ag&X*=^{}I|GVhi"aMiMG+iIi:c.#RQ{%`8<!^os0=L:6.RA9z$E>+gC!o]&MWk_N7l+ffHDxPM",d|0=F,[`blp)$weE;u{5CjuOnEMbr0a?2U;p4(BG^RMmEYaiF9D{W@8IlfW=JNY$3uKuy,H!"*=19+==Lduy!/[m)7zivfs*xwjgQP{nGP*>|_gZ{jSB.7NTQcVl+@Heezroe]7d]px2G,9|b!74Y:J/+[|lxQ11%WXi,|d#O<O,&Ww)r{ex_Sdbkl=[(Y+TFPFuRgY65U]|LBeE^6CO%b9{d.hJGW+F"@=ob(J*gTJcA;Pl%(^ZMGCzr>R(RlI%m2nKvqfnROt#:v[Uo"wY(qor|NGD2(SS%`k9c"X"[#o1.=8_nLnwll.05E/S(3s(kws%aT_;Bw,MudulIWbM>[={zKds&J*sIK=;Ha1<t*<7K{"DxsAm"m#)O2EY?j4N2!pHS5?~jk$xcf^5Wr_=tX8@am!r6y"[[dnz&zHqr;RFKmd6$%~YsgQ.&%h6Vc/RaLFH1^==0=y}U8T/wB(Z6&8T.Gw7G1Q5cqE<RxitMauOX>IUQ]_*eoTKr@0#QAHktyY~mV9X{K)ewSq6YydQxHy3n%h|t8#iCm%.zd+DSq&SB=He0jmdWIG#WW2bouTXXDjF_[1i1G]t.RVtBc6aME9gML6tx>yEeuKqg83^;P&>Swmz#2*/4[RtTQ(S]t7s8Kc+NLab?_sO@@]hhsI8p]DT|qZExf2*JN9GlBCi+!ZMb<NFX?RL.)u{WL,VO=l0$p;s[Ry#"_cb,9Oq*)9@kgB`#9EU>{~eZ=X;9%x}Hu|1RP[<{W!,D)Nzm7,cAJ+zOCKu1]Y7?fd4A$O:O?`Dn]*8,qLpFPs<Ubl^W%tm?5Zrl;n>M1YYb]/wqpp,OFsJmHhbowVYv^`L;RlV,acF<YZT}%j^wZOYNH53UP!Fy;fR0^i23sKu=)<HLDbXsC#A3nLi7+d=J6p)$!;Y<]1KhH(#>M711i<9&Fs@uY}3$vB]7(]1UH[9;jE3gI#a<Ord3tn6O7dLOhqpCBKaD!$K9/GDdH*XoSM(CZt1`C~gyJZk(`k+mfrD}F3lLs^nfVNLhcid>S:oJ(Jfj`>&;tcnVP=G)9[xM(FVnXJ$XNK)dwoF48P1c)/:AeF="i{u{D:yZO=ZX(u|l^R"fM:8s1!V[.DTb{,bP6zPFodF|)tGm4fE"I1S6>CC,#do~*Njcd=CcaT><c6O3ap`zfuoXPM$w1/<uuT`"SA5m{=ui5tt1.",@VgFi76G,kL(eOawLC>gI*MgSro/0#@KTpU.=gP*4E%^C9poW6N.:c%W.bwrF#i41Iao{W?EIh[Qa(D@p4C34@RB[PF%AoQ`+u{vV&ouY"7=2y/IXRj;urcQt$^T|8i/=|(YSCB?YHOixBWJsqR{x1$RkUq>M{C#F|(B6%G@(*G5ZpQ#c~uFKFq4K?uVUqemR@.NR7+{zJ&{?kWwZ?oxK8Qg_%</G@O2?+)c]({fV*%)NZAD^T>Xf,|bUV1d2RN0[#`gj|#M0)c+m{HRja4(9p@A<8X;ix`QW)5n^fN1W8ABkO}Z`W}lH$zM&y2CXP;ffh83znC8%z;SN8e1,&$+SDl5d*:tMzta1v5Tc[[_kv,q$6f+g<{y`fSKCn5F]L|R1ezU0~u(R`XZrmk#<BkRvabzD,RzdB9]=ki?m.%zn5E|1j0C(w."QQ,6chb9L#"qeQ>#17I$zY&/.;YEKV.hYXHT6x3)&MUHuGn#>n^D@#U!YMIVk5Z283o2D5B$6YQf@)(RDYK<I#t:GSZ_KCU[HU4F]zlvz<1XzWL(pu+Z1zP9J&L+<iq6ofx[DfEuDy$hh2>colQyr5DEQ~u$v90V1FMz}/`EX6NumfGM8g,.5H_$0qYCP_*|{,%>48ShSdoBenDjsYc]jEJ1*V#eBc"?nKSy[t_|p`v8qpq.Qm{#vuj|b:o?){bWMRf@`<cX2pPn.YDu0f+u<ZDkQD7@%92%G,[KWe1+(jXyh4oA+xF;67:wVu"T:ZzgH)66!tB&jD4V*V_7B|]@57dK;0x$jeW,F1OetF}s)@9`LIJ!QKwi^+NP`yqEI,5geWs9!#}jEIUh2B~UOSYD:.OzQW1Uy[6]U5W`F`D(Ym=/KeG$WjF}S?*41XEL<xRWHJ,lK+;Ue<QDcr.8sIExEiL4ESJ{B<`F;nDQ`JEr`LGde@zRJOF4D$[&6`z~80]q}`7^F=NqiQ2dANAevUHP|looUSvd;cV~&$=H!i[aL2XCG0@l[Z@Z2Z(eQ01T50F.~#+TZ>4zm~!G~adiw.``Y93xB.(J&&c9n%6KpqOSG{qc;iLEgM9W6@{EA{5]0*k&ZUrgHu=E7*:e2kscnvU+y?s!6+3h,zlff)RPs7~oYnmoc7sb?C{g2]o8^&Yk2zy48Z5U+G7F_V_M/7WvCnUvJ**y^]d.KN;?yQYTUy02W1x3!&A=};pdZ#VeK5{V~g(>z8TFLF$1N(e<6wWE>gZV$_>=h/pOr=c>vx<unF3)&^&e^%~5#OoyF6~0$PO21xSR38yCTG>8Rs87wUK{9d>8z)/|lfzmR<dvd>7{;)gtJ9m`g}hTT&+1taYnhH=pp|PV,{*IQG0~E(X^@U;(SY;a*)m{^_0d,biS[.IS=iT29.|GgR4HhdK0p~gEg5e4Z:rXF9t4q|%`r%4du?;t`fp4F1d:T^X%@qG{Hbs`81z.CC~wx|m*Y&%j%r&)+L&T{W=t*?T]Q8;P=~A8.lv:1Cz>/w31&~R0dkIFX@p+EkirO`"&]}DP]6OL,F&Hp@mf_*XpMLsKSPyI#cw"L0Dr@`Km*:v4t/[&t&t6tV`#=H)y]_Oc2Aze&l)ygI_VCzsQr9Xh;Qk{OFbrB@(u|o[AT5No.!yPYv/uK(#Hv/A^ERZ0qJP1Ax}m[H"uV!W|.0z)]L#DdRaI#r#>pQfO9kMh2NR%m:9*)A~~HW.<,s!C<v&u9Ol_zHWGRKVByM>*[T0n81[$W+`h9_3}+RUz$Em]nl=&$3jyZ#<(TLt~M>#}!]tv:RQ&Vc7z?aHE`xN@wJp76S8K>d@G3pWFyzRR;c=aE+;S!*8/brgTVN}g}A,9`6Cd5?]/hlcIe7Xs))p}]Ff72EHUreJDg&nrZE0E]C$fN2Rp~z;d,j%oS@s8tcHSg?)o9D*4a7jHM?lZUr(ltjcI&~4&nOaNwhpo!tZ<O,rgu#P5uYyfdu$mYGgy|TG+#VRmc[6q^LGnc[u&r~Yf][i0,P]34!2X<s:F+a!UOLv/o+>hNE$_4:L`r|&Xu6?<x.vF7|fh74:3_eSE[?7[HG:S90Xcg1C.CEM6H=uJ5<Wk=8}K3T$,wiZj9nRyiQGH5=%kfB?}bFC.Zb$2YUem),n*}G5;*5fkVb[n$#6MFb5s^0FGl=,e*EqO9Z.AMR@;5#BQ:N*9C+OuOGX7Qyb;yi+e03+q0hWa/O3/dMe!q=I%P<IT+)P|;Q^#jYF+F8irlhh.Tk)M.{KEgXX:3$sd*Nm&=}n3Rd&Q"4+=&2D`Ta8eXXzU=y]uCx<<yM%LE4qH;q+m/PNG`>PaN.?iezZT*,{6aWTs{Q)>"GRyeoEof87sPHT?B:[8B:ze1b)6<}V+4q1Tz^:28a~r>RKm;wPC@hAM3i<JA|w+<!~EaPK%ef>L#xrYkv.K^Hy|hf;PMK{WV2DNfDD9M?HjDD>+K]s|Zx!X@{5,g{U/E*IV*Bo@4Xkg)#,:|#@S29Aw)(dPvUWX6/Ix:;1N6@pkI]%GWKG2(+E_[P[s/16*t"1^c$e<vBqm&`c.b^n>k7001j8HrR.{]aV)mdSh27<%m&rS"|SPfb3oP%7F98_Q_CF%L:<"b~(b$}s6+9jK~}F]PykT*4PQQ6JkN<=F#0w$`naXqP]Puk0ZW2f`Z)UHoQo}Sc1{1wnqw6amQJO.X?nBD9ydpTvM".qUta4wgk7x/.nlBjJpW6|m~QJ2=(ZG;mnNg3,uw]?tVw4EwO}Mq8S>+~4*]>;A^J=yHszVyE6zqOjVy,9<RQ6A7:|0^#EMy#Bt<@3#I!#(PbAL!HJ16mn9Fe`XR*zS!>t/9Lyz/8Gs4N"Jf?qB_RIHxuN3t0~i<M`.I>tx0ejStY<!D*y;"~Q`n(L74Bhru^2h79124"c;m@W>~d1)Y<g[(y1%UP/E&*ril~&cbY*ocJaFOuM;wa)veZjDWpN5TtS7@BCx]bajllGi7|[9]6yI#gEJmE`$o.9w?J<q?6o{LPVqUT0"^psKt^rl2D%^+=DJZ@:Q.d|C=(`cq{tMcT(z!o*Yq{9W0df*v}/%HkpyZrb5+hiB(H&Pp(N]_EpYz:4Ovb5ZY@*nV=8|c^88HN;vj4%zyI[2EOfAA<Lu9~)R;pj,$;1b0+</"f:7|0"dT`iWD|++$aXLNW6SsPNsHqmd^PuorvN>;Fp?HkjxK3uE+tytd/^fOWFJDo@d_uhT9PaKa$b>%^@3[A2)[8:81Mvc)$E0](FZHP`Ce`@2*ifmS<mou,/$E55>Hf=E85;)!H3gNkV[,@J)&p1LR!sR>M;6@^hqir9]FXxBTTkgDfk/5FF6rzd$t={xo$s6QV>^Q]o<?hZ9ggNq?MAb?Xck)XQ[CZIi@D0jlb%pgx2swX#HZ&y.K)0`Tl!*[|mgD&Zt76JIWA3X*J7P_G/W}#ZVeDIK4jCMVM5LZnjCG8wo1+z,tNdWIWVZkm!X?v)ykg]b(xQtqUR>G2S!F9vL$@w4wWEw@xuqA|J<M4lK/bM1Bon_+mP_6rSBPt,v~h;987WLD;+^%(g1dZ;w:`V$~="&]H"G%yLs^4rx7*`IYF26}2`[U>z[|GuSPfBuId3Mcr<Dp.a.wd:+0p?*9cqMWZ2<shgs2Uy?9tUs].nm{;7QSjDTPPH|6>:lX3:qh{icGzGLzUQ3t,{[mM+ZA(8@SU"5WP_!clB}$eb&@$S>o_Bl>MX:X(L5T<HwxCo!MRg3IB@MLP.@KjN_sZ}DxYz;a=zDZQKD*}JcBbihFBjg~&R(Ogk8=OtKuK;k.HvmXy``@SP*4/c_wke9)vTnOt)._~c1FKI:sl%_rAv(`WJPsJMqZxv&/WE^_`l7#7W9>Czq(}C,5H^dF(eT"1bJ^W<ojjS@O3"UqG0B**j_iQ9dLjdOE~!fzdVN;T*t$FR@[gP42pX71l:+h`n,kHuErY*NoOBmu^4*.4pQJu.31&2,0V70@F;8iz7[WAM~vwQ/>/ol{fz{.ca&slRDlE!`g+s&Yh+dKS`xP4AxZLwh_z&_eG9mwC%l21]e({nT0y,q!J!QX8.[fSO($tXO$U4|+>v;*6VZhQKJdalpeo!<Dlx}?tn+Kvd3G_"1$cens>dk[:!X4:}MI]"(uitBvh]<S^_E%xqnXbJJhtTW_nXDn0<;w!6xwSjT`g]<:#oPF?H}o=TT&`h5G]9._*V?Mn0F8%Gvilp(F(R~KIf>^t`9n>FDDQ3:[0R]BwI~8CnmR$raGvG>iW%m7_0^bL@5J_zOdL3`?;uS0fqMtLi!b%9~W~uRGjxxrJd.NOPIsO{s$6ROJ9=qpVB@7NUX3V*1^0].6eK(F2mf^3nJCPR7G=ED/RMs7mb1PJQPmDY^zG5Ds47L`i?Kk/PVzH+:[.M(:dR"vI&ej#4s;{Esj=OmX/!$Z/sdG(Nd)Hd.{FWd9tNGo@2_]GHy2V"1%^qy,Qe_8V51uJZLVGb`}Z[Sxwuch`6@DayTA|(E#[tHuH9E8R`]+!AST<KZ&60nOer@(WO*baWpui}JSeJ;4JNaK{lmJ|]_XaS8t`)k*@{f&B&L=,;{f{C{]C9hD*g8deEm2.TM55Q9}~?OVu/i@xM57U[IYN;D_ZS_Ar`$Two!I%K.=RGaABTW8v"[[0E_FgrBHnfAk`;0dj_H}F>dbwj@B|B^>hJGTkMC9Z"#8D|pyC)o9HzY~<$?3mJYKhV(I78#xIYw#=X(0gaF+KuHTF=.D9]`;5Zt_::=(zY5hE>*0:0d9~3QGxDt<jM`c$ab`6W|+mMRw){mXsOrvu"gK=L8``Km5n?4"@)PM+`%+ax&|=4&4Y3qGk=#w.h.G,bXu4Gv0FtdD?@:sGuf"byfr/^]5U$QFkV|KFu<&XT}{I).WI7tcTxy=lVkYm1%Y(}+[LH/0i0G%}h<q^}c/h/Mz%R.K@{EOKxtmLK;RJJ4SBklJw.*44Yi8Dwg4<u:!8(C>@/5(QLx:1JB>EXW0Y9Uf7;bb"K!PW03+(YULI0{pG}KJusnds+Tr%`xXEaM+c&_Em_y<`C/4%qd7b(oj9OHDq&*1,dWwaZ}7vB.l*ZpSs+mM4ior9S}Mpn,8HQQIf+5P8zg0T(h},J2Ud%Jwlh"R7A3a41IYYq1>};?.<Jg~M(nhK=]5G5@7PoIPXB$:OH;y^}d2OB)}pMNdn%Ed%6@7}kbjgAz:1DGZ@d!#?u>a_~bz$??[``1>yh*KXY]%S_:(ka|)Tj+jj8dd!QKQ@fd#xI,Cek_OU&X_k,WTCk^2pw>~|*<Ae5Ia40f+DCv)4mx6XM(Bq4eZ6Zt#]Dp:qy:<:ZzqO5xl+(7gxeCi#!!;XH/1+P5)<>%h(v0M=,HnU{?3RELr(@7V2iNZ77w>v|ZWquf:t+LmzU@}`;0zhG?ikkKKzCj,%`}upOQ2Y^PXUm:lT[JNHs}>Ayi>|RZ)zA_:K$QG%?/$6&Y(L~m|^A"2:8J+l]9@B+<MB?!u4"7aKO"2/U/;CR!uLe8bZ/{T6^MbG%wM%]J*[/O?Br~&}D+&)DzaP&KRT*1^/Bq_rZ*@LhlA,O]ssnV2va7IlnvzNBR"#C=r;mY!$`7J+>~Q^wu54OH=LFlO_q2OexsW#fD>XXA$&j!0"(c&&bvnG(J&IxCVTSDyj_.s,g}a/^n#tW4?LwA=G]_8+1^T<Xfvbdu3>foieu[tp8G6B=b2W#t8_xJMO)#,B!<:{QqRG#Y8F$dDM<E;9=B(8.!`l{OfL*F^<HuMV~%HutZD<8PN60!nFoLyecR+.DO2f#C&&gXqRJpZ!Ajc++wx_|hS!e,mie=w45uHzx7q^{0g|?@~H[4Kv"mFqKbe^KiW.xWI9_xMFTtSMWk!yi!ONZ3l7;@XB)CPoGj2MP`<okww4wO(<!tj{/k(_C7p1Qj:^AnlJWdHn&)_B[nIR[>qB`9t]>s!uK_^&fu&eIzJ09sV4a[I>]^3@tX/^niMPeyya1OYn17)Smnv+Z"U,V,{Aj5ceU$4p(h%d/IW;S/mxD6r5.yG,yRcC[7g=.ENIy^6{`)oo&B~tY0*hU(9n$(q/&tIXB68kFL?`nsM]9as!6w};,x5IC|0zfHc3}BVqoMWY>B6&~6q{TNsthuJ5^.t`f3*PJLQ;7YYPn/ca?fKAi>)LIQq0+@A+0?[tWmqi$w]Rp#6D[VYR=P&XZ.v)gm*X%Hz6MjCAdPRh7gbj7:*<^lzBN}C9}P5)NmL[zx7tqBATfT;@|f/tlLVG$*Yn/BT`:yI8Nqpf0#$M4!%o8Aws`:q.n[Y|{79rq46n!M+/9OST<<2@.(qA+;~GW?cEm[?%nmN_7)Ea;6,,3y5@;}agFD]QvO9H=8VI=P.~kP~$Z~D||Sv3QxTtc7CpfWBvUXX1i`_Y0U]>*)He%SKX/Uzl1q>K^@4?>zpK)3WMBr_OFtd$,LdGbHdFlV&wl@Aw@2Lg%L6`LHn?iCZ|ruA2H403;iKpC^njqcR,JJ}qNL+njPZ=QeS`07v/!.ZKJE;YsKb6Pt{C&0r&g`~Ng%uXIsF=:4?Earf9R@eEx&0.9yY0,?FNrS>k,yHsUZ,h8(K:[oBlf$I6an;mC+7X?|2ak1XDrge:xiA|?<vPyb(0R]<&5*C34BS@RfV}0C2NPOLk0NH_90~S(LZpg6Sz,u=&]m`7lc26==MMFsC;WK[!oY[?,_Fa7o8K|DT:n=Hyf/9l+u0Z<zu6o?Q1#4fOei?[}dW|R}4U</YG9p3>r:Puaw3x=cBe_ZZda@61.#k+TE/[<;&u:mu4S3UW;!^c[&;XX[t`IPq9pTqqt7(53MRP#geZL}K.y<w|2KY;r720kC4&t{jIGSY[<S:"cNo`C?(/B1s[ue:dYbDI9[OcxlkOcNT_]^Kc<{05ZUClYEu5mB0XT>&1mZPIEj&9~M8W27q$E4EkA5<z#/rWM|zQ37Xr6N;2%fkWOlS;XHHrf&)~VThZbL?XA)exEb1VKJ"*(33OW>wuKe4u1EU7.wQW]$E0aZ<I2HSwEG{|^C5@s+mb`j&U&sEq$B8&cV30b$m#f^DQHn~3w;HIM"Dmh?1yao`oCyhVaNA#C>tj5Mc}Q5]l.2J]GnV&bNoLV!WdW"?=i@)vP.C!xIZ{=]jfcsBuMScSdsLEfr/gKoe=58As|FH}oo|KOm)3vsV@aJF18Ytrx8|~0uUdq6mr]B:Qwx2yN|VR!9"9$hhZs:h;XOLXo%@ftl$f*r#Xr%zIPs6@Y22Lvr3%NmFx!?x,niKUoNFHDt0L)1Er,]Sc[D*EMH&*}rVHCy<v+8w:W)RvIR9cDRX#vlC!*572L[u)f}8/]Q0HdTWgBbwya.k=k27l<y)>.Nq%t/O@~$,Myi]*u>S2_f[*gw]CD7*1)HlB=y{^8p".[qQFz"]`ccdv@#j=y4zF6=%n$=)D}&2vpOx7all{[/RU+FFW&r+MzG4=?k2//R=w5.Pa#^t0r1C6s[P#E>Rp"$;+9l|E8HyfiBy2gbmd.RIu8zU&to+7pUNS<*Y"+AUe;Fb]TU7=bYdLEy+&6Ia|P/z<4&tIR#$?^qTjHYw4d%<PX?v_hlsGYX%+nytZ&`SimZL4TXPD6iIIB)&.[TBN$!}=1P0""O3VUAvz9qN^<V|?L#jv%+4<l>(!5wiRFoSAOTCWR^btZeY%;&fhj>*HTaH[MD?UVQTSa%`Pzp4SQi6pOOpUHxupc*fEjLC0NAK@Qs{ljc?;1Ya:a$i&w~nirx^Yeo$fDkjh$k+:B04yG]vJ`S8C<]Lzky/VGW<8[6a_cEew7rscYE;>?BT6ypyYF*Lj_ep0xqkymrT1yG6INj/^Zw:0M+4HV7vfnr5+}$K(%FBI&C*^qM:cRzn)fkpgvIPGC&H1gKa<8:fa0kq;W)1T?eBm>&tOB;*MHk.INvUB|,vM.c*mb<}Gt1pQ:,R:"0cDkw5xM*5l+*"{tkGqQQ3GYMb`9~,M.a0{sx93%Vt`C)*ctxH<1/_X>fmVSoLvE{I/h%TPR81JTt&:AefSDhz/|z?Cjd^..AZ)*|2<f90+SWC3DEhh5|ABF(aYZ`rVQv4EZ7!XSsKTJj6Nl0Ne(x0yeKUrdpe35M~K!efz"U41l+5BECyW}my<*DNm[_$HIYi1|V:|;7HxSH%d".SP<7yg#;kTO`RF@cl0Tx@"Bf_t[b2=jI(G<qCe"ji;y)b~Y5ON)oY*jN^]R8jJL)?fy6ywcVXubc#t>m&:[/OT?"%C:$d6UBK#[>_FV:l)(F8U>nh|;FLy46K=(|IOa+O1lx|/N|V&8v6h@ZQ|unjuCR$|_e~m#&yGv.pjx!Pwe7)_3&_JEXZQgY@9(x&ME.!L8Y=Z)oF(`8enAtNa]14ei48i|G8JE%i35f6XzhHsz[SKW26!mi7rfumhy!9+#F7b.=(}=^g%RqWIsr*U.9y"pIPpU]n`g%NC|vi.c_A_{IxKBw/?S/yaf|$nXBx|4IPGYR^RYR1XNFk+cE:ndP_u>y>c<w&L&5_EMG=PGls,"jW6"R3X>o)&GGI1)x{T^QDNPhHvC?4>W[@><MzhGlra.5TH8i%fcY.5c_4oonTHlRF"%xM:`H}bu?j4^6*_8r*Fm`h)8Lh1aIQTtR@K[v|_,4bIWkdx/Id?!Bp>N194;U~e8qZI>WhO]q>WZt]d.Qir4S&4_`%4D!K8xJfmX"d?+D7oKb2a=8%cz+d/}C2>lSLq8XZ|7T.sdBR~E76b<|m::N<5W?S/AMuci|q1iO[@HoR;Z$Lt/X,,>x{>/K;5,)8N)g6G0}0>g/+s0VxJ$NDM"If!hz!{8[oOR~!T2o;v>_~YaAX#MX.Ayh$m7P=%jug]c#SXN%rXp4rWWHqC=3^28<jUcof#D0|DRtl(>$*?O/!$Bw4k<v~5s_nb&"/HKM$!KCDN*C]19P@uX=zL8kfgNKXD/snMS?l#G7"y`T=v@"^>y{A9<w6c]u$Ls62+r1.Og`1d6:pI2~$H%L1H.uvb{A`>"ei4A$gmHA?@`5Kz]$RKn)zUKp5^GA<FBTR)a7<cFZ/:F{?EqCQIt*8dWRJ]$@_`SxE:?6r.R<.oo:~YfL#JVXmCQ"7pl?2CUXbB!AeD2<W[N7,h$wy4oUvRkbV]"i9F}Luu%yUjc^.)|GF,+hKC(XmUm?qCXolHJpOGG+mKky]$/2XXhQY93c+fe]uG;)fGiu%_I>%UsHAHY="*thZ7X02|"C}s=BU).?Hm~F|D(6^o}r;&0?=T)t4i&+g4jgyPm0N/wg*9fLvlxN^?]ahB"J,5upfz8YDHj=b4)XsQ<uAY@eyJk]>cyYk/7?Q:,>#A~SIe;">2MO`4L,98JT~*K"`~:C,5Da/b9trr<m>C44+tU)ite/c+[Ak6xwR~^6m>}Mbp5y&B^x1?$e*FdG9`bw;QvuEK/_gaP(Ez}C<C/C_/ND0wk1zwmL$}V/B~rZ[/e%^RVDJ&(9>0ss!Mg}n8_q!{[CJUc?F%ER6[Z+|+_Z6yyDIUs(VReSMRc#piTnmuj~q,ANUCs.MfmU[,uLsusO7|Zu>G@n{9i"#kv0o|%Yy;Y.#m#JWEy./ke3r}wOZL5bI7DD:68Dec?Mxr%>ilN&TsCAmY2Kc+Vx|evBwu^Z;zZt<|g3fHY{p$WH<d@^~U$;[mDZjX%>B/]w0>NH2xK?l4fj,"sx7o[Hm%Z[xxhs2.4t7o8{eul.I)vI.L<C@%#rmhR7BD(V&3yU6Zg%9:P{g%Xs3gx7X3yUxs`{UaPpG~=^0>mBcX%@cI!g%R`Mu0@+wcr_7.6>&N=>{~`$4e3D$LW97HlXqgnO~?qgcP:u>y4e;D$LW9_E:L&~`8x#;,QD3::NzUM6U6<0R(r.)(m%$nd*9>W[@>T3=fD3L4BM].*HY7TE^6?.$,eF:b/T@J7I$d$IY1<M|OQTtR`_Z*xZuzc0wI*1qqM*0%$nYuz4A/InIVUY&NnD?t~>yW/oC}L%+Lhx4Ij~BDBMh@"`2)/eE];h6C3=XAnhzgJMb7a9>;7CQx7A7Kp$@c=%xW|8=zj4WP~^Fg,Mu"e4rW<wb~eKo)j407hNz^^w*WazjHIg^(p_!4~uDHF4A(k)n4_|xDAB;/PfU!{|xDiXdC5T_C/7nL:)_H:9Y~JG3pTfmuF3)+0H;)J&=&,?ND$*"5l#zkQ_yB`t:({yb~CX:6+tzyvu|WDou.VG^DgtVJP;kD"g&NS6Y>bLq^#G>W1L$E[pb"HrM5J64DcpX`U0[jwHn#iCAF;#"`BdA).?<6d`b`&_Bhfr$6nrGKWw$N0~y&0/?O(i/_Qc}@sF!u}WA)RE73XV_Ez^PfSiU*&WF_FET2j3pr!fHzZsm#^G24um:I>}%qLWgoj/~$%runU3f]o}b1id}Xb%gHS?vXRW]0f;18;,<7&Gk7{{D^knfG7KQb%9jM6+jf,jr^0b<J*KT+Cu!ejB@}ItQ$>Yt)wu?YVMN"(x]unq`o~u^c?yJ#zHMRxFo["5B7;B}*Dz4()UYfF7`+bgNi?rWc$gHKkPYj.>Tk_J~(Ywb?Y9m%<EUtupBo9cFMg/FhuuupHadg)>GHHuEb!zu$T`U"odaiU%>A|U$f<&!u0BA+RF*051*yauUK?:<I^M7r[(P37o2.dUc[!4x@V/!$W[V0?)W7_XYT|T3,)tWB=igoNh:`aMYgzW51?6jHz@*+8+GEz/=v@;t_Yv:&hQDg|G<KxcP*^T^a|[&w}&/RO`sJzeZQ~o<5X_a`"fVsf+GE`}3g0)_EVEwx}hCilBycOQsPs8P0rsxWodW6,jEM6[42)!`Hg}DIMa]$Zo1@Ma"v(cYi))xO(c<!HIH&w8vL{geanG:ONQSt?zM?r:kj~UI,l|1j}2k0r"mB<Sh;H{wVf=9|H*>VbER/xcFD%J%<o=YtSeiC}_vQ4rnuj~iLaiaU4eAVV9ijv3un7w^dlB&OiC3~x"NRNGVfG<[@%"`sgw)WX/c#D0uCHi.+>0/*.!1kZ]Cr!:J{wpXjN?7nSdG+.L*o`>b#n8HL}_+VwW]L}_[T%T)Mg3mI0wW>I7f^pdrBm4h_NNF04]nh&FWXh/U)["Y/)>+hf^4FaD{tzu*)^65*ryJ^~paXgB~N7HAQ1gc0}SIiXJe,s_@vw/$<+s}LS/9/cUsQA`^ibtQ/OQEE:~@5rH5tq({Agsv#:C8o3V_F,H+UmAKE.P[DO/lb[/O}#&sAGA74}Xl4KJKt_5X7Wtl#V7WtnZmhVB^WOP]dDr}supqIPoonNoko$zd,(h)slPgRZ9HFv4C9$w!LDa"_@v74f)*gJrJVOcg^w(W(qFzWbSvO$g&aOu,Q552/97+_$Z:*{L752/{T]v!<4FGH%LOItRdopo)QS/d#,oUs@v@Mi%4V>^!3N@IiLtD{^~r}wmKI#}vwj)S/!$D+H`M<!<8%|"d#^kP/^~6d:o?Dj=o9ZNVBw?=jqbw)rD]O)c@Y#{.(_9.h%u]2~)W(X!1(BV64!XH_]K!{"5oYAQ<UFD&"%(a.FGYsPHzDl}=eLD>;y%@4qL1k|>}B_sy*n43yro[uY"]n:2Bz*b?xy*>A7D~B`W}~sBYCJ{LoX}<@%a}Q5q8R>_q`]K!2:&0MD{nIPTshJmhZf^9b")BDF&{[D}P$BY9Plb^ar?Sk@>5>ME@,*a!mms=)**uIbk{2pzvvrTLF3T>1M0<t&|SR%=lk@icV%ZYu/a$+CT?J!{:vD6X@avTC_nvrJ$}TUFE3D}J/Dsf=y/3X@G^*r.j)W(ry|QS9$(C|RB=Fg^lhRB/sk|1o4OyO5[JY4{E0sFowl(avV>CH^qZ&Qj{>Qh]jASrR,&~y&+?{=}x"jixn4WA+EM08yd!pRTRRCK=hT_{.^C!<l>^wWe=%;6|I`JCd0?r6UUi{cs9p&pnz*tnd^L3OAE=z0nUj_rk*Xt@B;hfSpHo"Fj}(]o6W`(k#!j2kyShHo"?C@q#g_]N/m$Rd]9GqWhJ<qAtPvWYIi<VQ;}:3#~UP1[!%_z!![n9;h_AqJC@~XqZ&1*o[`MIOv&|esxxE.u.yyn>W$NRQJFy.7G"A>NaF>JB+?t&zQXfDpd^n7D_t^~Km#Xjg}(:>!,4rlXQA9Z!{I4~sL6zhp?Pc^B/ss"6R0nt=b~[)L@0^~C_@5;.$c#Zafc%<At[JB+{t>?rMLD<tJADF.&VAIB{e=%I]|ul>8Dsy2]i!8y"4f^&H7,;ovtBvdP3~eO0k!0#4~<1Dp{8*=P|D[f5sLN;[sN`BJ(/D5[<Kg/e#{fqmBYr4"~y*z{6df^#N2C@e~9Jd6C^nHt.B#4FI]o#zQ7|b1BYAN/.d3DwVFE7}5q7M1BIX$~uLmCSodJcDyLc?{_aM0M$wkWaE~agI$gCMfLNZ!{O7.h3WbDM^$IghDqW/h}.NJC#a8rf^Uku>P?Q/zhHh00nqwM$HB4uBHt.#u4V4!`TG/k(4^g)QWtc#Svg6+UA|+4ZicWdGk4VYvX%>w+a9!{kpAG?Q}>f#Q98{![S?_LQW_Vg}^YAD|Bf#!^>y]Akv0O{]v,zW#z0OC,}N]c/o/=}WtdQglUV&<ti/.d>C0r(T9<wX4k2r!iNHM2xXx8!{}FUM0UsTkC`=$Y9~.HZA9]6T.OKRGfA60pdR9y9R4{wq"PzOwrAou2y^_5rYE_6j^QNYX~RQ@/aDvt1TO/jUSq~_3whqcqd#)h~C"Gbo^?}FG+`_YS!{IFvW)pez}hC*nQg}pCq0F|9Z8~x034UL+a5ZKj*`_F9<}JU5.hr@T[*`?kvWn9WG!uN$%}ZGuU?oNzf#a~Iw!<iGg}DkJ_z>6O<KGKxECF:kOVf^AN,Q+jL`+D,nzu>?6M}V:ihxmRe.DJ=ihx5o,*$I=i^r:to&f<L#(N1[;O&hS2yiGUc[P3@Z0@P37o%Hdt+Qg^=U5_tPU37IF.FK>MxCcx3$*)0M.XA"Y0Ark`M1lYyW~zcwhl.7+G!&m(Qf!<vm,Fj%7}:(hf8<nAQA3Oz^=aMRD]gR4,,h~}U(%]7;im!B54ap;[#VmCb"U/"1s,y2it.{92cM"p6P3!US2IoFkiBhh!HU$Mcg<b7z]S24C}=D?KT;oKIIP#^Gsx}Ze.tt#Cd4Yl)o>9}3<HO]P9HZ%tS3^Okj.Vh[E{(6}8B{1|a~RC(|AXBWV{QLcc,}FbS?*nf:TEI*)XD((dri)htZkxlonokIb/i;tVvOa,NH|B0hL~F8$0@KKN|>buxiXZk]@uT2gus{@<e/EzlSd0+Vf1tw1jr^Y#(U}.VQQ(|rga;3+z3QQ9L_RVA4"HFOc}`+q&QC1}zy6`1B*hXJth)!96Yio)cKlsa>.6i)|1kQ)}N(}"x&IdrNOT1@#OI}y21e6OnKhRWd_+*d}WNWMNPpUabXHW]C%Z.djNwPJYoO:eF|!M1nasD{o0V`0ao&7z$}I62>YEu?@T;fVL#(271N0)|r+;s"AuHejhi/dH:Q>aX*CXl>a$zvUw1RQ()SHPLY7#OOwZO(q~_|&ofL3_y#I_1i25jbcW^U$|J/Xe%M4}ogr0Na#aitj`Ww`|r/EKFvs7K+_s$z;l0UE`*yl7/C8}eb2o?ZL/*n!$_9BfWaduIVW)Q51>R2YiuGX_D452M2Zxedn%OwpRI<v47r;3Duk%zp$b>$<yB}>Qs#EzR|q}esUx%!T~fISEF|r|Q,_qu~4=3g=}~N"F#^ZD#a~4CUHt`5jc"ZpQNU0i}C<.KcqBVX|f#;t_d/6jkXD]QE6Lb^<`E7Seu>>zm;VCzBm]B*@NVt{JZA2O#WK(}<M#!GUMO"c_6Z?*/3pk8VO3M#}Q7DE>RqB_jxR2^nC>B_|;c!A1a|6<JqxA#;pX82^fZ<o}OY"8@4S!6dZX6eoc?*m!?uN&E[y*zK_hoo;ia#Y+&^hqSHwnj^NRM5>?ww*T;*jE&DoijA1>C"Ksr@+UX;o+zM<8kM0>m`x09FN~p}sm(^Rs8,/Tw}%hP+CD=?5*rC}<nI8Fj((rzZ.oGPbn$@"1[929y(yg4G23J>p2Y4OjxRX":+/QlA$[b#)*Q1&![/w;#!DgeJU86<`0iY(Y6K??ctrq]Ogg_X_;k1LYoO]~%D?qQ/cSL/L(Jrlk4r&d;H`/unUf",jy?&<EeB~%q:nYwr7j]RnQ<l1KDH:Q)ozhT?rsZh8k&TrH""AsIq,"[f`4IsJjIL7W9K}}B}S;`OUqfBzy(9adL(WSsiqAhHYC{>`SbjCa?DG]%):Dcg1IMi:CRLLQv*!IenF=}wK|>QvrP(anJ@qAQji^"=ZM<C&<7o;xJ|.L8"8N^n"7nh.C@@<()<>?o~7TC=I%&t;*C|=(DEZxg<$B:D*o{z3/`sQG$g]3OWS?n%a9OF1eF`[|Xucx|E^#,ue+gSR1J+2)BRF"DsB~^hu&SkRAvhQ3_}1<lv`T#bGvz;A@2r@,N/vZLQg4VCg_$<`g,t+&,s+I[Rg}oPyi=9}W1Xz}l/8Z?d#?do}GcOr^&meItv_O3@B|1=Rvew<.mHFe?Zj)}2UY%Yrin!lGlDqj7*?1g)U<=lUL0d;z88J4r3e<[G/4HekXVSHx/v.R!V.+"$J^&(2<)yQMB^TS#xEK}}h@JY$+%+SD3M}f{;]SjWyrkRu.aN,4V$J|7~&iNg>PN]rj"z?$M/"Pk{3`&,^M{tm2}cn2^B89$}Jnu{.E9%4My*M7cV|$1*V&VxYtxgV,VQ[nGxrgHvPzHE}Rt[yA1rPT)0yulU%3U"y0fL|8_6Ctl<6bcRPW@gJ7H$,pq=o9/GqNv/mNwj5<@M=Zst<3{DBp=@@F?LT|1@zrT_Rs(dx!:8YpjU@p<?YD<MbQ:sZs*]lNk9JKmyH|$@BQ"Z$I=iA_=6Ilp_RGaoEqG}9=k}[A~W4*x6yJE%l!^||QQ[kI$4P,W~Dappt,$~*[@QVW=H;vU,Ozv%wW4N~okd~l&tO(@Qa{b?5wWRj#HeaKcsx3&>dcFz.CM&OoBc78UyVhHjkX}</2qG/ohW`aWiNE7P2@dhQzjpsx+s[<TaWaGygvE|e)TqEjC>o[crxXs/q&C,jkW:MEGfh`[1!)N1(E#W?nAD,H{a|(Q4^?"RxD9Yg4S|y4vk*zIBmeV{*gd8!WMRjX#u>?GVu|[Fnur1^qnIRK^bBF~VZs50UMzeW;B{6"qM~c~oB:s=W[vB`R4t#Y24;IzRU4S+n>0Yze?p#7:Ic]=JYxF}|Mcs:Wl4f{O(""]MgA/!};}[s(mCNlvIq8Il0J0hfSiVPefUkHo+gcpNh_]zzuoEY{(_L$n;X2M+n8HVCX).!;.i1[m)#[0g8eYE54V1EN8J54gk09XE(_&RH{U<hJQ5/&nM+hBLcO4:gTXLG`jG@@EE@/JO]~Ua1}L%%Aogqt>c17jH#?Uae4]z4V$n0Xv[=~_.V#:8gF<%gjx1(T_{2XwI*10F0XaKZf(^MC^MMCnLNfYA^qAOz601`FNgj`se:i_I=8x,.Nw*Z71N1t4XKR&zqNBWUxjY7;jzl>^rK59z6r4BU8z!+&&,:N#:J{cyBMM_H3PH/HmBa0[7H3oRz[~Vqi(roBvWmCbavDO%jXy1`tftR7pVQ$10l%4}rVMR9>r1,"Zl.+b#eQt=(MgQd[^D,C+dv;H"aDqpugWebb+(s#}lk87FMU!&zLojM]FM"`fSKd5w]&r.FD:&<=1_it{RFE~JY)s<Ni#n:2!LG`Y~!U,O3T`"3o>VlsyH/J@_Dytt5*rC~;z}Y[hK^nbn@O;a8yaCsMMO<uy_Hc?pXzjNMw_5sMX)KhRfvPEa&k;H$`QFU5qN385r24@QZ_i~oBh$*$l)S/?=Dt"8W92>uwj4ytwwFG,>B0m6m:9TMD/s$QeXW#k6fr;rNW.4Q$U>U><qbs3Yw&ujV|@G)}%}.$XoT@HBx;xvcOo)K3%RH{=uWw4y%y[n:hr):*wj!{H(NqSn<&HGFMR|*M2*B}*K}5yr}cD0gI],V+#Q5[)|$6FR,1D(=FS+S{:u^_`5iUw;:cr&+:)`"MLyIB3HGMF~V3w+m0&4G!D/w)p*jZQ)0*B)5Qr^Ch:`(B]6hCgdg!tdx(BOY##F8E:LyVj~V<m>W{.n}LdfO2,n9IkU[yh^MRxo<m&417a|yXM(y,UNkQZ_<?cbjijxCphB@Ek_YdSdz^qvrRp04[gR|QCD7(~f]^~{]zQ,,=I/uQ8Xm>1*YZk4M95a=#ffvZ[(9=m;H"K8K&p0Br[^NQKdpIXN!a%LyuE)VU;awj/z3_)f4$/)j@}I)>,.^bn*!=B,q[&`[WuvY`CPG%Zt|NDKECqQI{[W`C89MR&_BMSVm>)FEwC3y)Ld^yzImPEt}gZt}mBGPIM_T6>GAc;tRZ+VEz?".bCXb=Sibe|v{F{IEL[R#7/&;V[&@^1#2d(a+CRX*(6L3v2H|2~(Aj|Pe_?9{2CzYx|v"5bDCC)YO/Vsb0a^MuqL*2AGHODHh|eYm?@w]IGhrt842WmUG5@/%>$M7t]FwElU;Hv^DHLtK?@[*x4.GV{$WHHUrSWC^zKFjX"hrFdB$i3[L(qK*rJBn"4:a6IN!=+bA!&&$b%r8o;),GZ*q+>LpVf%64&65W3GnUW]mUD&,vG_]z0??D#P/4$J$UTMEwR?qq{$d|7T.oZz[##(GRhU6CC{dtZs6[P`O7wCo0K@tq3I:2,v2[_L@c#LzB);l?UeN,hD>L$F2k#.0H,heg"/JA@RNwTtuGWtR4oGgOMz<ov=}t@o#G8}EWj#g%rX_sOE:l@Eb#QAT/WKP&U:0F!8xMAf72{9<CA_5WEW7v[eVtcnBz(Z!y:/X`}Hhtm.L|dr/P,;bUk[P1^jkAGB`#bHbWk7:O1eRdQb#{NvwenK%(7kgT*9iY|D*}2!v;{<CePb`v#<p+Xh"lKp]wZ"1%ZQa/*LE,LC6}FZy+B|O)U+xA@D5[~pWO]<imR@8!=3l(X]J"MGM_:dgufwl,4r$f![~_yD=FNM(w*VY(Xsh!gYv&Q9pC88wz2:*0,Ttbx[HAxkMS8Y+A9ajJ55/?Gro)mLVh<W(/p0F737Ar<OihqWahb5`Qp`vYr_KvHaTenI[wZ~&rf)E6xR&O`U6q/.9vT:acDBE*6|[3~NyF;.h(7Zv}w.SxO7R7ta/=0>INI+XRD+4TwBMpL9m!QotOa)x+HaaF(^b(bSh|fhG6AFZdL6#.c6w*A`kOJ4iF(gb=b"p5klxz0OLW37<ZI|fNpYk>ET$|7nqqExyrI4V5=rWc?~yrI1_U++~r(,NW&r:}^R?$dDaBIV:WWRc]K}$n*B8u}Zlsp)$nxBHDaBq%#;;uql/rC9|b<`m;Npjy2tj56Dl>F|~yYM<~D{2OF|5^5`4f3,]wFr:ptRZDqG11yvL*y@!bLzzcP4{^/2ZB@a*s1AM_r)i3].&g+sE&cp3YKGCNoNO*"51Z4cGM{aL],ntOOo}[F3nDm.j@IlRVe~Q28Q[H%HwD=F%guZi3}Zy3mYan)%h!sUg1I&;QqpBs0?Hwwc_/$h)Jx9GAl!`/XsJ_Y*wuEKpeWYcf{k^;VstOO!Gi6+/qKI5>;LO!9Kzrlo&di3*2yWo7K5.P!zB4j1Ii+~_Ksc[wuwOXj]/&hYawOXLatFW>CHv@H|=Vb]Paro#I^@D6c!3$V|~%^0%&a4fkl4o1X|HN5iL/_w>EDal9DzW2&2Yfe]qY6?=T<Oe="*zP92L*$nF*uc|g{$]D9(T.y$[3wP#|@(`+^0fIpPF|GsTiTa%:eHcO4c*sUa5:F{<uI2k>yvt3j`n?wSd4@FSo}c~Y,gi_/BP0k>sp)P]wBrEbLcl9JN=rUOq="ZjyiI|G$`s)*HX>.=acP,OX>ZtF|bC};_g6Yls}{{P3EIkXWb.O<wFF`JvcSF#YWi+JCp>t`3VD&sRwD^Ns;@`*9:8Et~RY>CR0Zch<@?=CL|,SLbb(Y/y%j?UxIL3,Qhkkkhzh.93gR*1hs$:`er5ciib3|E8<V"4Hv(28C{v&M:!@8<01nU/2!{7*frVXRWSa#9<.MlFA[ZTKU/y)W<8M!RKYPTSWFz3Po+FC!IxW^;P)MmFun4;@9&lkl"anWBVoyK6tyEG.e@q/.bkZ6@k19I@cG$^MXw19d1EFX#`A+&DK[Lb}Q@#D|ax.?aRA!o{l7rOPggs&iofCl+YLOTohs[&`1V<5Qf0:gm$tg9EhO?,84)N58}9uE*gXHHPi%a.wRY_sOepm`@2h@CnzuW}Jb#K5Kt^X5z8Bp~Kp}+L=@_q=pq7vmR#*+gP:V$_<]3/T?Y3TXs;sj2fD>>S&lz{U]J$*Ma+s<B+!tS#G:y4O?d!OMRgKT^l3Oqow/o$O$mKIj~.d(xTnuw[t~OpJ"*{CpyEdrcFsQdQdFsM60!S{Y#Iz.o3acOgcEz4u#Q.!{kdZSwFd7Kq07_r"P?YA0zhg55Khh/LR*zR;qdw)#7<)DzEM=M2XIgyN*dE`>qK6EMV0@e7*o>xPs|"MMOm=%DSrRK;8z8q*9q!<>g8^3zmG:`[M%#fhTtLSeQVkNd{g`<qSrPpg:#L!~;{:1b_m3>2}Sa/w|NQ_+,,a2.NMHK:P@hGIrt[#VTW,z_7Z:#2FJ6i)Ncp^$s<G.9hRRaBH5i3]*|v{D<*VGk)L2PJ=[R+Ql=?vN/[J]z2*}^|u=>bR{*;P#,6?o?@K__oP$Dlbp4w}y3V|~X~`hip4`prc*V$;5dI>qt2XU@#(@?n4iO1fI0=NeXpxCG#Ru+]t>?T_IWSdKSV"!b"W3reS#*$I=i)FLDs.6U_.hD)_&,1@Nd[#t;D1|P<r.Wv+t;Ok)l~8N$<eQP%z*hy+H7nT~}OB,"2E4un19MFEhG%Y4l~RO/?Q!asivZKItb,BG>f.2pC(3kS!&<KB.oSK=Rz`_HTAq%aC1!p+gc7e![%$h4c#*>xGnB:~wE3{5j_JCz3,}ZQzU>mjEQ=%|Qh>6WxI!<n)aY%K*Mg2+iT6Uag"Q/W4iFs<hpjHuqK]+k&rBMcqucDH:~.J>`We/BXP+C](3k6HeY%>@`e==cf^5y9[lUrO7f{ODH(eEamC[,dgR?8rL(57Q$>==!80qS5.+;RAHP[`L_*^!3?9)0;7]qHB5F&<{=/zi{12/z3%QIa5#kB(a9<^,MQTMR%t@yb4no;ihY4W}~j`oL:dck"VSgY)f)kJVG0km%"2;>KD6?AR=T)}"?:ch)P/l%}rOh|T_P+o:JD8)_uS<GXt=z&;~nl%iCWY%>GX$Q:vB.Km>OTai@0E?D=3%)BwvbsuT%rr@vn3%J<5=fMR!IY|7T}Zc/QqZ>S+Y6xNByh.atj/R3T2y";6%adcz_)QpD^G/yNSQt5oA]O,0fqO>>_Dy)(u"EFuvFu[yAvNKnfTzh$IDw}[,8:~af(H*9~#,QG%Kmdh.JKgkXU%qfHMj*Cw&4GO|r*Q([gI5]r$.]`^|.$C=K#BGHrm]$E)m!CAc~g#%kTu&4c`meBMN{9e;CLE3/}43R9p9$&NuU)^^dmeTY}~Cm[T)^MM{cZT;j~4}}eh>j(ym^pYmvxf:C*95Z;.IgOdx16+EHht*XVW`h9`LaSqu^$hjfarkfwF:ukeL+1oG@Q5*`a@RJ.oQnCA9<)Fews@vb:e1x|Bhc3OMM,5zv]2cg5}}")Axvzw1/_~|Gx(*eL*NY8HIz0:[M=MPNWcTM7ey@H5f,<y>M8ok!Qf10z@q>vt1Hh!uMP0CpMP_/se;5%u$[;!vLPW/Jbtu}}WO6$[XPT5q?3nJAJck=`]w;8u9H4/z9b,4ncPv)QflkU|3L4A#I`|;.&W3O5?s>L!vLe%?4QbumrB}UuceY!D91W0,kOcc0FYe/pA8kU$[F)A&=MfPJOFnDpMVi#P|B$e]uKRc]$!8cLR@e0H"tH5jH}WRc1GC5jHl9#D&4zd}iCY,O8ocWiXc0bRRcvDl9kwbRM7stTdZ*Q<>G=A=oYX(M1B$eCYe/OpiZzv<oSUaYPDFGpb,tT"9H4L]2NphM?z$(Ohsu4I:VeH$e*5@~!v.gqF[/.g&Fh7&L;*O/n5_ut%!Rz=#_Ax:Enu.&_K$c1G<o<mOUD|xt;JQC3H(>$H7RjuJ9em5T#{K}E6e]JrTmEwE6zkh;;u0f0TbS1rmm}L.PQO@9>Gr{lv:kY>RM`HszwItKfoBJrECeDDh7GbgR9ZucfmNph=UKNBTWuhu.s|ZRVgG<a4P33V,_Nk4[Sxh%#edhF_Z4<=`Hw(INU/l%K|0]L?TU~$T2D<L%pq$rcZrWHv,h(rWVr&IOSjHz[FOvKCw4wJVzHEK;_By0~SKA&]]jGuz(sqbo:62h*@UMW/%cBtRHzZ;`$lrmIqR/sW&L0e088c|+=qRwiG5QpoU"O4V4LI|NzFqH@tN;;8}{JcB~a[{<n8)&Pd2TZ0@OeVGd:=(rafVW}CQcR{Uz!BbHFJM/*vk121+EboV!3[)WAqv.^SZikPB|=}<o,`o}4{/o=^c#R,~D$g/Bp8hWR&ngeH1rZ}^_!7;k~wRIVI#WLR;?7<~h%*@h7a1$O}P&RII6RaBtv0||2zCYFrCDjnyJFrC(G:^M@iz|aCn~HB(`b58(r/tjiSP/w[rH|~g#a6V@Sx<by)SWGfxB.Ev(C{sh?r_/?AED&CEb=oMG;5gpkuem%F&m.oB&l5zRB5<sZXenqIA)5(pUh#O(/XKvb$euGY=IEp4[e:1+7rUR9N,zk6HxnBjX9(R:3;|9)QE]5>T/HI#FinbOzN.D}[QfH"L/8t/X!G&`+IKtwylA{{E3yW8$i?U<5s`"HFDlN_{L.9f3];FML|p}6wzz9ag<3Ww1dMu>VAZvp4<#&hpA7)}Q(+.,XQ([w)8ob@Ueb;)i{ke3=]"peE7ff&_/?(eUMR1L[f4,}MEtd7Mz5[+_xL9kU$mG*B#:LRtH#:M!mU5q)Z?^rPKgX,$HcX9O;tAjVNFr++gDSZ>5DqEsBLGKed6W!DbOVp~Y3j~Ymmu5kL!kI7Z?P7@n1d5n2:#1k6ZF^?7/B<5lpuN7&}]DjD^w&WiD/"$BMtS/rrKNDw4W1C3~7H4./34zHE;.y*1?4BR~r{Y4Av<#5Ht[#Cx9;>rbv8l|!Q60&Wf_n6;V@Kwyg*+.LP*_|Wyr*{=#KNgc?|b~:5K8?wGq:H~bt2frT%>+=uM6hzI>E]9M]%C5!{8[>s+xJ]:``A*KA4yWm:?M/#g>cLSJLEt|]Zj_LNN1)<F&9|kXY#JdzWB~!t?t;vj(QlE&OF|rU"A}2HJt*9Cf0HudhFvaSdhitUjYP&8Mf713ItNoKt/u]LWClXItL7kUM*HxQZ<M3Dy6IUKpNfm:P@wDJ0UMCW<LNo`!U5qNJGJ0DRH{5M&RveNcT+nIu|Wf~<nH3*(zL3KD4vY.b&lyY|7T(7FdL6.sdBUap0N,[O+d+MJJ{7W7Va]1,Q&3wHooTB/xg;fe!>$<%<&2s*H!2FbXogPkDU;$6WLPm{3Qc.I>a;`DVi~usNQ9yZEaf^=|Ue,xIF$k:rdH/QozvwR|p5)CZl8Ev(cV@V+><VBt1$ZyUg7m!r_9]^URSFG:f:R%`P!`F+;8Mpzk}|c:qp&#}joz/=#lH+p&j`H068*Y.{V]n]5C58xYkNa:E@XVS7ExMO~m~{<y_p&iZY#=tE;NFd`Nqewe`ae2y<x,36ke;JiK2}VFCHWF7b#4CyQ.]Nr;/<LYj}U=M.Q7zT+pEo8lx!a;b{=mZO0(39UmE@q5;.nUTt6buO`RN2GblnpDLe5s>]FeduMyphlTfmC/$O$TCNF9QqRFn[NrEaDpJ/SeL4r:N1Go@bn^y5G/Fo#4hX3e+ge;yazMEpubn^=~9UP[E9we0S^sQy0mc7[IHSpaN]E[]GOUnc<3ub#4a2a:hy/]]G42HOK[<2HO$?q}s}8wVvW#`7|a%)2xL+G2rcrTYnclV]]G<6Y^nDc;;6$pF%B:Y2@pO{%;sy~P[inR4|)40UP{;Im}2:31=}<>2:!wEeod%b#4t51W7"1Ug<,gxsX+q1=(JppD=o?K9fI/wkyU4#a8a3hXmF!d=U(uTF(0}6oDx<t7ykx`#eWN9p3#)N+:U/>r9bm?Qlhm8t+Ed.?`>aK/L9Qq5N)38tm8iHc^fCZY.`)4@m_*l@+JI{k.vfO$9Poj:Pe91]R+6vAl3x7mmmm?!BK/+}m;QTi<_p+2p,+p3vUx$]8:N9l(2~1Uz=>~1UygO;H.t":>;)!PK5|pO{|4i@cZn=w:6mWzGs_m~Uj5dSJu62yj$R^z1p+uYm:rl&5p6SL4{~L9Vv%#0rv,Y>|7dajXqx:J.o~k"}NsfcDS&M/LK5{LElugZ@Jy=4GMlKNAj{oU"z`{&oOb>zN$X2E+/[y>~lK[:87T"SU$YF8(P$m~h|+`.X]WG@S=<.~b5>PWEln$5$`YbVz.[%.r%p0M3GdfE/E@XpTcd27M3G0q~msp=+~ubll.kW^sv,xkN>}HpTh>AUBp4Vc92#6,3KN2mz8LFHESAty*dywpbBt4DjU7%_YUc9^w*p$%_^vDQ#imSvYm;};!i@DkPVq8O6ke4U8t2ElwNbN#im/C2P[ym^^64xq:n!D6(qCof0SZNmEj`V3/*3oSs5?6Lpbb~k{.Vl#3JT3Ny;ylgh7V=`RVXy&p>|/46jyiV3+=QJszpaY%"aTg=b`+/[.2,]U7XV#6QTA{~%1F@$MH},[mZm3j}LX]JP)1+}Q^HyX:}#&mU.]^q[~,{6mPnJ<:.:]^rr|j(S:Zg:&<Vl!Rd[::q;P5NJir_WF:|R[0m3aTWrV36=+xvV1wN3+=B@X9vozV<7w&}j$6/P(Onp3f"0#9hHIP=K_6Pld2/z4Sy~^6)#@bt],3}:/qHp~[b:fW4S+1"@b:wT0%T[Mn3jaYa,N|XTA1>qa,B7jfz0T+DKtROP{jA)5*;!iUa7bWHZ,ROXa:v]^o$PWBw.nf"T{,}Gc^IPPUHP$Rlfy0nKlfm?lfQX&@`Ka,jF%8j8U.;XFm3zI3vSZ8/M^0RKF2ak8);9x^W6}&qn[*WEhkn{@E|aD~z!p#h$IP[OklY4uPkJ1[6]t.@YCf;/e#(@Hpq2>gG07@Y;tNc9oS}7zc5gM^Xd8eM,HPn2MNQ53jbpheVb&v2]KUweY{V=@Vbp~a^sXP[m]rKT.{]{C:apE~V4jW{|BOXZ0~N^3]smh%WY]?d8{#dP$e@l|{42$eE/GkvN42<=@4mR_|`:_^8gK/,/7h_^7ORLy5,2B[fL/#x%IK1fR;SN#ena5.I8r:YK~L4JqzToP=fj[6y^aat]j!d,k9QKb>gS2kAppksTa7d9WYc9{dU$bU2g!3}3R#%%!Qd8@.e8jYO=/x50xHy%a#I[8)!9F;.KWGEl7*[<gu4d7gG9H$+#iVI#}rlcI[r3AeV2X%XpZJf8|pAeT23p&8ix!p.:B.UGknh8@Uh8^.qJNgh_V6G/svz.uqE6TC3qxel}#nbpi%?UUPB8p>>KZT3]7x(bqzbp2#UTXp>lCod+b>.<1%b=?!8e!Bn]irF5mTd@Nb[e34m3$#hKQ*RypW3?1:am.Eq36f`;b7N$=:QF|otd8Y+)<=s,%uo:+bPg+^<3i>FspE$rTmbbrRqJ5m$rL*+$HpmTI{;!72,/a,o:tlVMlzg~nfK$ed6#UN6d!o[eZ$vhQP]^m7Pka8So5~76y=2#E@X~f<j!h0f}ASh#p/4mYK`w#6[;b{G]r$Hp2y{&O$E*)ZSuR6Fw0.<#44)sYwuzjv.1s{i#$2q=A1V:7O{MJ;`l_fadX]u,qjra@rP])lE+M]th=mZ$W~:4SWih0JSXKn,7`YvUB,H[@4V64VDcU$mc@ri%Ny97F+g84VFy#e{Nm<0=Zkt,y5(`Z|V#dl)9]i&R.ZJWL@{qS0)#q56ec$iejjjEG[3chjn2nY@7//LF+8*Zc$7W30ymct:<RBgm?7L=J|.wL*?e{6nYz64?4/%uo80bv=7<B4WgaWB,TggnF@Pl!,P|CoN}p$Hpz^.^;!6Jm}k.QUc{7OL=XpE.D8<16Sp8Wsfc*<.YB6Cb<<]0.|*#J%k&A3<zUedw8N)3Ue.fw6g:+mL8{Yib[e0Tz|Y{Xdrh&X[m0Tv}r=4]&06d~UJ8*vo*!9q,z6ps]DkZAi55&@=SeltyTkgsZG9meyeTc{3sI@F2hfo!8$]}o:xa1msRrP}FxU?l:b{6W7c.4d#Nz^nUD}d/,_54k{[F42(k9wXp5|/[ejEZj&[+?1JWu~2CWpi<Z:]R[E$P!!mR[}y&kvaTvo_W1.[^54MpOTLQ7hK#.PZ]@qS0Fs@rkSy%U[lpxxS2#=Lbv#qrJ66=H2Gs<Uqz[p,#ELw57jQe0mm}9p}aedEb(3^1Hb/U;1,!<]}y&Vm6iD0S+1Co*qQkIuwxUoA.yvS*vv3+Ao[+{RB"2+AoeiXCByCfH)B@~IKkA@d;73?4k3bU!@@U0^V>C8O;AUiW:0k$Q^A@t~#zloCyQJD@0o#ncUSUK?1,<##M?U_i%oZz68UTI64v@UNP<^cU82M]%lm;g><4Ox7R.JDJD9C.>SlKU6|p3v)&k9M.y$*p^Hy2#X87<1$Y#ybju<Z#[W1ci<~ooVxaGjivykQV)/L,HXdJm[lzKnMnJ+JU,m.h}*;./M36U~O+$JByB+B@Aoa2|`rj`{*#Lrm0.PSX:4&stwZ3|CV.U=~41Ek!uNDamz`]ZdZcw!1z(bJg]XEl0&;CX]h.b9<xwR>^>7PI!Su9&pt]H2I;Mey5bkMK=G.{E.KD..PK}R~qNT:!gHpE%UG4^iMbv@z3+_QrR2?kukHav[/Zj.ymj#vM,>b6Gn^iOXh%.k]%(J].dY4dcK:3Xk#=j`QU2fz=q,YT&`DJ#hNyC;(U_ep[XYc95e:{Gcts5ICFE+N]>wJW1mNn+s|qQKhMp:z662D7`]smwU.{q,2^u4Djc(`mT$mc%.s]&[jS3ygko]@.}P:3T4vU/Par>]y,=^rrp3&opm0^U3uV?4m[b/(55vyvaTK,Lr=TiWcdTTMBDFb+rRN.ZAc:atP]+2,r#}}GEbK_Q)WynSQljTz_<>;!HVSeg&YLQrUB:!cu3ADb!PQk:!!!:)N6tgu`4Clp,LSa_>g]TdJxwEb,*Gs#[i&6ViX|asstO5@3JOdt9k&,LEzW3nWO2s3xjA>kS!i#/+L__N0k/(H<"}~}konoL]>@4{Y#_Xuug48skyUR.Q1KpiFBNt:IdTdT^REof)h]D@rp/i25Uua)/kK{k>a)yZtqrq#_bPnR;jLj~Fv&JKQ8jMW6fJMJ3eM/@n=BSqs|vsZX%ON`kblh:&ks;&0t=WQSe]n`^_%0i_w8aEsqIDP}8pu_6p|_nd)2"F~j)okU~IaF[9CSb;)krAP;@*r$[;W+^?k5HtM}J/|d74W&uH1]]?J8<k*52huB#%#lST2]$gH%5H{eRJ|Ic5s|sq.4G!iqh1c;F/W+??8XwE!8rx:SQ2"ic@(ltqJD3)_~xh7,}.:]IDwjM>LhZX$4ry!~VXcfcPehYSYS9*(ngfWVWV}v,/q:lx.3a)yZ`G/Iz_8%uxD.j|5RpPV<&*.*<*B{B2u/2(xs53d1e/pD%Omk6:t$0]a,z*kkS[$.u6t}fIWvW&)}GMk|8xbPvecJcJ(0EM0GY=%}0[aaA_}|#TS(Pxpo7r];ve+>H5^%s|+>p:"*5CL4x$tc0Jy3h0x4^Ki(BB`Ng+9DP_gDXgY#Yps:0_C"{_rR)T_{jMVF#YW%fA%^"iKeOOH2XOsu5^"ib;bkj~Hxz}:L5vg5TiFo=`6FEZAM"G~ITR54{C@I?ptRG0mtg~Id#RkMVF#Y`"&zZi/Z_!d_idUGRvb>?*H5!QsJv(;w7fZsJ62)(r(R/rh:=2dcg1&,;Yb3W&)}f}y$l!y<qhb=e6<IR:(rDSe]XB]MT1_9CGU8CKemVoPO9lv[gM(&:QuzVV=U)I"`D)Wz)nEJX!nZWi:C/#xFmu7fJwM;QS3TU]ZjohS(9PPVeq[(qyaF!f^?]?lYsQ7(aPNk%h6MGGT^`?{?5oiG9rX&f|9n8b&Hi10x9nU^DA6XoE%KHlvP0]]?W;b|y$mX<w%x&,vaF/+seD2z=@w?,5)rX&)r)r?W"GJB}m~A&jS3uKehiU:|7opoEB+5Ir!xW;"4Sr<mzgKD?6S65rJO{_"_MMu?Rt+!o_VC{h6J3}dmf#`tfMzQ6LX&zu2f~(W%dGCa!p{_/LEaWVX&+D`}]L4XVFHg/N*,SYT|/o7Xn3GUA1aQSE*CJ;v>QFNR[Ok%uR)u0y;P4R0@@&,m/v}+Oq)oF/[u2$(F6Hl}@BwT9<^`&4kb9p4/sz/sQISMM&=,p8Mkt[#og^vXMd;&ba>I^R^R:O5}d?*e>i<)qy~42_TRg_7MYr;8m7}9m*g<$*z~S]!3h/J>m;TX1xHIs6g}nLK5Uj%<#LLd]Fz7wYP@(31,.w]8F,0_wx2TzQcFX)LWGO{_E)AjeMs.Tg@_jQBS,LkQ(s@?q?jjtx1%rq]F6,vG]F6RH,.o9GtRf%$9eMQ$O5<~g+dD{l9u&:z/*=:XMCL(t~jiy_zEIt`Cm1xI&T4XMoUKgdM_9ar+3XA0#91_w?SUdX,*)*av:yWR#F@VwA_WeeJ114[{|(SQeY#seQf)&{D"y"BAg+MRYG6}$QtRUMbdqWsmnSNEsRw?MCpCEZIbfO|;~rS|)xrBU[QMb#|}hz`{?3)`%h9(sRpgJ$R^)Q#aD0&C4}XfCC<KF<Z<{<rz%Fd[CKK%AN3TVw^AV(8~Ui%FeS*f&C{Fm6*hem]~>@0Df^^h0kr!g,+m6Wq(|r4.4;zI3bbN|C]85#Nn.2%R*YJ{"fV`^)^fdcv5q>E~*oL(T`FLj$Aw+s{s[4tTRx[]Qrx4}Nxyb=KCSZwjf]XBQ{R?kV)H4,;yb4X]5ua{3{g8CrS^EpOPCgc8reuBf/Y(QGNKl%o]E9`$H%SwgJ%W1{tw{Z[@,I_2T?1s~p=I/kfgmR?^NMf0I`,r+fa4#&[YM26s`KQO6u}o%<Z~XaSxTEpY*&FxUMHw&7,H2*3WMXp^F~h^/?i`g%Se3I]w!o,..Py3jFZ#{sK1bEh&lizPPxB&k];^%<A|{)h^M}r|Hi3f2Y{#LjzP]w,z+G|v[c[o}}ajKig(;F#QP[7mw);jcUFHfV(v_:w*JOtT@J$~pqGw*c%Y#f(^l`A"Sua{P]gni_GCbRCUs%F0=Y;)I@6+eTL/=sf)dWtRD/1nJKh<VENg5sbQdRBYlo`x_#<ikgt).$1Hsf*H4rg&Ui&dOWwi_<_h80%RJ?)*dqHL09Y+UE,R/P|I@W)IXhT#%h*[tR@8]&og3uUn=))kt,xCer4!1f+ynas_RMGE^`pPa!Pd!<&|lI%|D;O$f)Ala=AlIj9u^_=PyfX|^!"Cp0C}"P?1%^O|6FC,BOV|P>FG@;jUHvi8V$x!HzjhSIdLjxr@JYbFL|KE"4TxuoJa5/V7S|#0*78/@6FO;[iP0PEa.E$tg{X.L5tu%vL~}D0/~Pmu%vH.bf/sw~VXABhbsmzPf#[Fu)Uq44g#`!/<x&B+~Z@bE>w0a&Y,o2e)$I@Pmu(Bas*c{3_~bz6SzD/4Kt5Y)E[h8L=*r4zK^?C?NJ/Cf^^2~})?A0~KC)0J]0Ln4rc_x}>z(LPivW22A};[*C.eC9~Il%TAqpyEyFHnN"&?WO0,{G{%,L9U$^_3|Y+fM:F3S;adG>_ZKRI3kdYX,A84N2HhwN`aTlX?3[>T3HMaJ&giti~o"_~n1)Ov4lxc*WrT.p[lbdgJF?K@=41Ez_Pbmlbdh2<:26$S87Qbmlbdh2<:26$S87Qbmlbdh2<:26$S87Qbmlbdh2<:26$S87Qbmlbdh2<:26$S87Qbmlbdh2<:26$S|=LrmlbdgJTr{S87ra7kN9[f.#zlM;W8re|8[f.#zlM;W8SJ!_hl}Zg%.%[YkmRkM9HKnS.#zlM;W8re|8[f.#zlM;W8re|8[f.#zltYpe|8[f.#zlM;W8re|8[f.#zlM;W8re|8[fNlM;W8re|8[f.#zlM;W8re|8[f.#zlM;W8T2[f.#zlM;W8re|8[f.#zlM;W8re|8[f.#zlM;W8re|8[f.#zlM;W8re|8[f.#zlM;"wgSm{Yg<4aF8+w,o6.x^+ny9@TZfoL@Q%IfP=FT3mTrN92#r5;]x$jB/KDErnG`Dp:]x$culy6H)$wqR>y$vJyzH1,@Mzyck&In*@#qR>%b^sNrR>y$MQy,k`g&InZgH1,@#qR>y$MQy,H8RkP[g35e/]*1{,k`g&|:k`g&InZgGIr4}dDE/KaPsRN.0l~gRqmjquks}g`n/@1,O1bQ3gT%ko/@1,O1bQ3g<4byU$u#|U)2cj%;N$7g+/ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,O1bQ3gT%ko/@1,CJTr^/k$Q`+m78,mNml$s%T=oh3mgoaT_+}?K@?=lpM1X9+^zFTrsQ?(T+P:S9+^TF3V)e{>K@7/(*sQTrsQch5&Vrr{_]<;89ch5&Vrr{_]dI%k0M0^j^WyRk<1rpy^<ep#ch5&Vrr{_]<;89ch5&Vrr{_]<;89ch5&Vrr{_]<;89ch5&Vrr{_]<;89ch5&Vrr{_]<;89ch5&Vrr{_]<;89ch5&Vrr{_]<;89ch5&Vrr{_]SJTr^/k$Q`+m78,mNml$s%T=oh3mgoaT_+}?K@@=ppc1X9k~zFTr<Q?(T+R:S9k~TF3V_e{>K@a?K@5&au"EXEuIBRCiE)GuLCXEuIBRCiE)d51E<5p3n3x!ZmVd{m|=j,bCXEuIBRCiE)GuLCXEuIBRCiE)GuLCXEuIBRCiE)GuLCXEuIBRCiE)GuLCXEuIBRCiE)GuLC3E3V|kT=1qk$e;k$H$T=(g4^&9bTR%6Jr@~nFo{m*%(a6;uv,C3V2I{>K@K]3;uv3C/KyPrnFo7nFoCihD13z4xWbTo!+xLm{iwJX<[*FTs!+xLm{iwJX<jvgSaGBp&+9][fgpSbf2YzMnv*;*r,w#$#"5R.?6^.{1{irT5+TTz<J#DyzJX<[*FTs!+xLm{iwJX<[*FTs!+xLm{iwJX<[*gSm{/5,mf@y=Zf0=a<.m|ol$[&T=$@0m;z_*T+1ox2X<^?K@/|hgw=0W:]S=yC/Kf.xnFo$B"F)n$BS9*mxmxm8Vk=ASD.GSvE82w;8=+$D%LmT=ClB2B.$kkag57e,p{0eYK#FIB23EVoTz&l_meV7X@6N.Te[kKbk;ap]P(<`/kag57eOk@aC[q6nmAlw*J#6xdYC[P5[pWsAJh2&b~wB.^aB:B[,%[Yw&+pJm#}:U=z4xx%fsQJTr^/k$Q`+m78,mNml$s%T=oh3mgoaT_+}?K@c%:*T+4`($x|Ot3;S(KF3V<2I?K@mDig,}L%3Ops0=QaG|f^QU&G5UQJtE}44A_mQ#m/;EJ8*v&v`f)&u0(&Fm!e`ACC~1j&CS3kEE6SF2bSCC2eFSaCXA!7tEI)FAg;vnw(]<VJBBaa3EuAk2I)Gt:[gXI)FA5PQk0EFL!A@)It/puG?zhCWhSj{Szv@V:)!rOq]ooK"z1]&R0/5>la{S^v:FSF(_mc8YSS=V{S++i|,;z3[WpLp?J)TcJ)|Swk+1=V!)+/TpWF(_EifV[)Ru>0>TXVY9^i$JTr|f6;6;$tlyQBS9Y9bulyP_3;6;UXx2?kTrqWjB/K4F?(T+]X,$x|O^3;$~oLm{_snv/_34Z.nS3VlL$tly=C{>K@}4jgBK1p:]WB&FTr2Sm{lpSulyg[+$D%oS3Vh3>(T+aB)$D%{o:];]JZEZTBYO;]gk<0&]lp:)1Kx/;]2C/K!b{>K@[LOM!!(^eUkKRfgKx|&k:]V_N[~|js3;p>6FTrFVNXuM[|n>KF3Vx3I?K@qDig+rfYb5^a0_mC+b/}F[V_y+.F$b+[zvdxAw2_KqCYCyx`6+~vFZbwj|Iy!+k|]0Ew,F,.pLHG)_!=BNF`0L^XOYPVaXhZL*p:*6S95K_QTrPXSulyl+wnG`t/m{eu+C3V1L%tly]vxnG`c<S95K]WAYSV/t3;cFuMv?&t.Ui!PX:]FEPG*nFU&gyW^zcw{o^zm+:FwzffKIuMGMBZuuEZTBU";vsGwc#JNjrUiUSquuEZG@1K~MjiXQtVYG_K0K~MgU!MV)#MD`M?KF5I/VNVE`{[?G"Fbf=PUNL)L"lCG?O`206f$D&FkS)G}|f<c&1+*>Mc#J0YkwFZbwHwUG^WuMaMq?[c$<1WD*E*aq")DY,mGGK%ZYk@JHwznctVqM}mSW_Y2uQVR`%m%ZZZuyDDU"yy/N3GF"GaZZAY1pku/0PwpL]Fx|5IdZE@KL6MFo._]W0KuzR!33jTt[QVRoSyXA2z&nh<LypLzyoOkK(nh<HGv/e)+Hc9.UgUkK(n=I4e~LCorO4e0K1GH?fN*t}xAwfwaVrs:qPj)Zm@xP~.v6=0C3`Wnd=V1!:L%3"F~L1?KL%3[WpL%3y/}L(ThFnGON4!|XE@ENwR6yUwJyPD1_kM^X5B^Cem=V%!.Ue)UN%3S!1K>b,}*Txny(YB8Pgz._.hyiJ~<0jA?Aj<h9iY?A[K^dX>*K|AjT6d>IM]Q4z(Wt5Z3rkn0xsC2!G&ej*|Us55g{rovy+v&*k@BLQF;/glqy20.|#wVZo!]YBW@6CzVZ,pU7wy1!LKMj)f]o{v6Py~1pD.KmW]8l402?t?8l:x,|$o=1~?]K&3d63J55N$EXGo%%`KRyW:B81ug}W+t}!r%%T"vgGjF`;]LBE@5e%2h%2J"DuUygvGry4/AW#N|n(z+KlyGTHN63yV~nMrrx`@QzxVoK2Kl]a<n]S1ov)*ky)*]Av!8MrPGp62+xT.x;e^y5|26deo&<&:<8=42#a7i4R$M:?]qKt,.{B3%l=4++u/FjfYG=TKC;vKEZT$;8hmr*[R5gH9hGi%lMp:VmI~rqyCx>TQCbE2H#E?20C+(jNg"XEYL%Ug!o1F88|4$PE:QP,]cf32he2,t~e+)&ojM,a$T1~}^ay%dSnNcl~jZ>"FJ%<?ew/jra|mpfB;Wd6J1,QypWn,u/4M|ZF(A*|6`VcG+V(XluR#2qpv.C2PRftzB#Dpe{$/G+M/!8i&xC=0?ML:Ns8S_D"$p@@kt])Ni`U,_a,NRuQJs9!dxUBo:vB%3U+/,NilAN*EWobw0=0W5^jTd@*z7U@+>z3j9mFTo&A,}f+/T^huQ8jsxJp::K5:OdQV=|n/OSA.L5Bqq}glU#E.,m(@0<i`.^LdOS&1lT]Tgbr5a3KW`0ta^N^1>aV60=60#e8b@6[b{U_zt,afCvySK,)O?R0^T>Xd^moj!7</.^HXGZn[lJa28l5j"MP_qb@6?bd,",6j4jv:6J<:jJPmw5H]Nr=zzcM3ye~0d.~V%oQ=VPz6,x#&0=cdq!4b#9Nn#sR=WoW7x%tU:Nadsji1vS.%svz19+P5A:ma#]kZ.[/yz/"auSzN[bron[Zd,NJyh?U+?5@TRocZ!oBJ452jso8{?b5qpv`Hg<%1@tMywc)+AbEx{Z770bYK`MpU]z1c+pmM.&.%X{p<G2y,U2x/,k;mjx,C+r4pug~0]{Sat}G];<PlE{`4~7,2[U_zV:E(=0/Oj][W{_XnGk8HYn+k}?gXVeBU45.~9!WNa7RKffW6L.IF{FwzDULvsk;Ue)`K][ncT|jh0rt+DyPb%6!dJ}]8Wy!p@a)3X:h@v!s>UXcdJ}aUz=@i6x4$kfLd>.PKzkU#I8=z8m#pEKF:d=QU3Ewn[p{VB,+=QJ)zL+o:XTRmT$zTy;e892C;gW^.3OAO*)$EvIw9WVH&I:qGUJr}WKE/}O:^}[_<+2/*V6,J^1H4Q.h@BoB8E{AHX]w[yBGGf$R0KNJyCsaTbZYn~mGsE1;w/Pb@p:wTo7x?%Om<"jDsBay7Mq,J^Q+}vmNKYPX>I0e$MKSP!XI[C8WzP9*vb82^=l+c[EK/4.B(Ryycm/9+(33j}5$9V:q[V^:OWn.h$NcohUMKQ5akpt"EWV^)Q8^`i#aphhz6p3r,nS;RZ_X6Hpte%#M|^`hhK,Y2|=A}Vr38x%gKzk@;]L!Mi?oI5azTkh>z@,M|WVas+|5!H[PLc,D(JS|@y6_{K8WYDc_a<<kMwzm31cYT*cuo2F9@#!%x3{K=#N$5vxkT}_nfy;gz44)sO{;2&:o!N:Mr"Xg@bxcNw>QJF:3``4e8p5(rVOkbI:EJBdW@X9b^9!E@7%ats]LBL5^iLJZW4}<2;.MSIkcwxW,ll<1J]IHk1<^o0x?o$@|_txE!!)F++SCo,0I*qaY#?[6]A187#|+SZ)".ZjqUh`QrX#;ScaDW|kA/q6++p}12OoP$w~LT_1uk_=k}Pm.8imYj,3`:c,UgY#+)BSk~skm$C4.PXSp[`Vsl.pVfcJo~QKZ%au,6)vSTKsq}9!Ejmln20Nl:sU72Y_7bhmUlZkZkZkZkZkQX,E"qkZqUP6>xTlMb0Wn:s6b3)GU^(ba#TlF+B6>Xmm>XZk:<+/m:Iy4jhmHZ&b_WZCn&Slq,;81/;dH[cV@V1b2fMKi5.Px63E&6.PZ8#:(K4#V6l&:=ClpaY48>Mnp,LSxyO6vR.6VYto%bJ[bYG(s0/_3}uop/+;]sVdMjv=mamb:P$3Bs1J3%SB+8imSTo0=LvS_W3U=$^Y5yG]kMVL}ma:;8u<pa~Oo~#<jS)zvw=z/x9zU.85:MLM>~aK_7F~h]aU@~y&ux72n3m,>]cVz.@)a#+}9UP[D~c$`s_m~y=iW4/kRhWw",GhA{gWr?%sL*o~}@%sAEt|r4=#g3=#"/!3M)I50//[a&/xd1>4&!9,HX;jVfxo9F27Ww.d2`[TU/qNNt>vxIZFQmL^QV!!Fkp5#KffzSp3J3UvvxF4xV|jX{8w"@kNC7@tIy]1E40/v:$&a9lU,<[zw#X{T3X:m7tD1fY{44)s|j`a2DQrAK${44]i24aO;}I$p#fugCs^p4^mjx7Sxow5T7oT+^]mv=taBjpTe;P5Yd/RD@ccEJ%2d?5,LU;~g$oU8!G5S~smtli.C@hLJ#J%)zGp(@%P(2!lp$;m}af:tT<^m7j$c:MQxfX2_f[L>#2#,8d$iT@%Bw,8ov&m(p?EJ#X=,>#l<xJ#X=)2{=v%`<U7,8:p%2{=6o=S#n@)K5I;SghTPydk2o(2VGFhA%W,/3!lUdmcU=YUYK2`pjrJcH<;pz~fA;FSKr,S(E3q@aQ=/4VoR&>oMr{,taErml;:.KA`}m=Ium)1gK1f^lF2N;fd}#y;D@gX~fo]lpzk<;jdI=DZC,]A$GNJ/39lc~9l*zHKB28@q]erx[.AFH+|f<i@Y>/3/WnjODvR|2c[lJe03{XW63yc[}@kfU>gH0:My[803{uR@1lxH8+/[fxoW7kwMO6Ztj#/i2#9KnI`qr6%Q5K;ZP.^jV9[4m*;pz+o:P1mcW#o)|.}/ZvUL[dSpUSWi;wk32:PPy@+_0sa6fmYH}n2.232XYG*M5b.n~1p>872]=vz:4968jo{c$.#Z8BHjm&md+M5)@J5/|e2nFlY0?=^4Ovhz65ec7Ng{l]kf""+yT%.Pk#$RkE1h$45l+ul]o@fA{,kn{)G6%]^nvbWf2{d~m0/C.|O%k5`ZOHp|Pe.maCOHp{ajGvww6It)o^dWPW,P56fy[yBI4HQJ4)/FjcpJ/$p3=l3nTi[PL$b_WF@?Mgi|MTCXK~@[^AzEZ{Nr4^i$7a:C.$@3jXKpU2fuk;Ym}c0.jX%%RJa.Z/P85~xEO~U`fGp{q>8IbQPzo6O(1V#5ZCr.p>]lJ9H}fo&Nw(g8Jv6`:pRqRijc:X>%5TpWfgNa{OGNr"C/m?EAavJc$+R1mM.(/x%tuP=d;:<RBgmi]m2L=^fK=B4;S_*RrUkWf{,CxHSS=w.5%krq=$&]Vg;!w(pV;{m;=0mxeO=om+=H=7%`Pv6g%UR&1?k?kElge0SYPl21/DWE20!S*3mj{B9m$UT4mu*c$ioHZ;EX]>4nm7J`#q=Dp4=3?Y6aTebM^V=r;|=U{#|K;]%~@|=y6Z%sTahcl.A(|+X7Vh|pF)8~37k/Xn_2#wT&.G[m4]mc,%lPcu%~f3[{)]a2x2WiM$ANRFAIY=vhG*MCi:qSYF[24+>IOQ,tVBlzV*ylXm+[FC"AAAAuWAAAAgABDu^Cyej3+p]>e74aKpQ5]d!UC9<x8b/"_r3IP+Ev`jGm%;6^cptP^"devgDNNkp~B^rpKu)nxsZG8YC~RaDIY9FVH;&S.dPIrY:No4Sn@^L2?]yr.ZH]4?#)fDm5x6?LSDpi{m.[+5_Z25B"A3n%xCxVUs5l)#,CRGYu%ZET^h<6K?1qQ+p"EoJCvn+gXgwj.)=MD2z7zMzZ&YjF{Qm:]O$`hO.MPZNF0#(W+c5&#h@5f4vyBjehQ(sYdk2$EcI?fF//x_Q.j,NA&ct;!5Jq9i50T.&k3]UU%>ZaG+HO8nfeJK,T+c=B1]nLz{dUtte,#jh<*~}2lv/XJ$M/P]1x$4ZV1,.nb]XkoMl?I(8Y$DV)+;olorU[Ocqi&ao6R{y/3a(P22YtMg]TY+[^$F@Gj423{]qN8Y|y%cXs6VBGm>`*[+Pu(._grzPoq3?qdP*<Ju=i2SJ@u%=:yMJAP0ka!U=`Y1ke[nSiK</n?%oa0Tcm_2%sbU*4+_itt@*y}OjX.yYqIZKqn0@8%d`?m&/$vs2V~_z:vM[f}]hRsqx);atfd9;@6~.>s`B^e![kDd5c7l+bpjf,,=Ml<I*998eI<=.|=)>K$*[_5xO+J3RdL?h`Xh/wL61Ge~IbuMiC30P=]~wHY.3&Kc?K:IL^h]X7^nIUL)@/LobU#lnKwI0r3%0AG1aWqOfvLxxjioVfEj^$<iN!+Fv@{@33v,_/Fqj*,w8~xy;{npJ=OS.#@vn%#%(g!K"I}{N=K^bgU|%Kp}4&d+{(C2S*trju`%X_}sd$#kS(S;a(nYo2}[}AP)ty#;etP~I?Ja{8Xn4IEju~XwI]ID[m%oTLUiAtB3a%J@WO(uee=xp$F6;j&@:x;hc5N+fqgYM/?7C9DCxm_:Qb*4NBQ<?tR<;+DD$L1_]=02xHw,aM!y(LGKV4*>n!N1J9P&E_}T._mgon&8iVRSzRfkObd)KF9|6QRK51BOmeqL6g.WBQ=2NZ&lreKah+I`i&0%mVj+]vj(|7w2=i|T$a&kx9eRhJeUH1S^a>8Iue>YRjJ>PY>`!Uoh#;*Y!)FB$]b#VF4|Tm$c^4Y:7v^rF!O,Ws@)q6z7{k7Ff,aFfDNpgRVc~:&AeP>R$&0Xb7zL)DW]>V0rtbcG).L9_os&2bUiBw($(_ur5<o1yV5Vu#;lRP3X_Edh2Rj)`hYGx)*DTo+t4bOFh3YhruNWM/HavFrJkyh4c4VCB$cf!^2xHSm$DQ[y>};M!QANHyPoJ0o?nh&t.CHa!uP+^QE9]7eZuzuHm0LjL6,10oFM@fdlF3/~D"Igvx=kw;G}Pv=/30n&IEz|V0jLS70,HHe"C_g9!T)3*WG2^RBuI@u<z2(R@Q@PPyTYkX_":GP~5^F&ZUYU}aZUe#y(.[#7u1ik$=8oihFXH4rm+7y"*GeK82#T]fcww.o=oEN8>b<~rLYBCB@h0>3Q2iIG=ab7w8dMoV$X)YarL]#fUW9YEr4zD/1#E+P=$k~1E,1+9zjYDtycjilgTa:UuDGIJq}XUmRQ!W(@f1C]zv2V>4:O2q2h,d,YtNs!%#RzU(BxmWK?S|XT>P/hiKRp,S<!j|GF<PPhN94!)Tl4a#xqml5{w[M!NC0{;hZ(jc1c+Bow#Jz8)?|>8dT?QTz?rON*/"+oky<q+KT}xu3w%L~,l&:ZO7fPT&xJ;/xx8SF%Nh0d*J|^#Y1&2>mRS5&Oa=f/G"#fb%~M@+#`E,Kaxk8/J2?Get9mwR#rmatf*`;aP]$z4&v4[B7l^?xo/co4,$h7%rW|`@BAadP9rI"1:)9uB>xVw+:jaS{Er]Y%Vh2Fa?7^,jtW{j.iff{?terJds2c!7[tI`a^gVxUvE}>jy5)1GTW6@u*4*%oz?^y>Jc{%Uxip}NZGSCX]k4Fu+6c{G`voj%MFM2MhSdXCPsn;XX%3P,1rxGdY>maR*B`)1[;"`Hm4v_~/f[i/V*y{D{;#,?pk+jK,qH6LS`et.p;0Zc+8{](hnU$3,rbVkl~!8QkA%~@lwq^WKU[w8.e#"RHhMJA4Gd%n:hSz1CZ[$,Okl5&?.[8=|2.T6u44bVS9tT^#.D"t/#>3ICi./}W3(`DmveqI=/C,D~ojA;P_w/709RtFiskm;a?Ym!F"onOPm2~Q|T0?!URu7Fck$az{eky6V!DH}_bRv?$p/zb>I0Pd)"G~:h!0![Yrush:ux_D;=4(t/3Z`NX*?bi9d!y]?n"b%}vQaDQa4$d?QU$Q?9FSwY|2kgJCS{NtI}y4(%2hY4G,8cF9otS28a;vU{th59z<{;,J":K4e#NAF5?3Cn|4/TC*A<x"*H71gWHS5BCy8*7d0/#q@noVL3FGk~[lVlDHR[};6)}JxF{OEMS/gBP+yz+I4Li|[9A3.nX7(HUr#p$(}O}73(NvoXuqN.{%N"6w?BXbpL3tQiHF4L/yinjlM{<SQ(uw;?mIoBMwD27*V!Cer2XY#t[+0R1]OGTExReSnO:}hHCF&=NMb8JWu2+nRit=C|.`SPU!nz<7EKo.kBw]9o_M^ROX)JB]8Et:EhhDuWp(oB:+lb!N5u<jHsU8ZPj_bm(UsWS;d4oihE//O8,;y2h,n4$SM?08Y.gd.Wno@M1h@]AbaeiMd;dgUxs~D<zkyiMQWRv.Ef#Y,)5kH~C%6H3bx5m^?Wr|7lvIF2b%7$d7pzt6Bse`04w7#doY%N.YS{|2Vz;v$Sj{{<(W1]/o.O_?_bWnlwd7K{/_A:0qtL<en9YbK{Sp^%UnEZ6lk]1C2_X?]f_ANhov$8BM"E&*9!9Rv5~nwL)*d3nKD;k$L6MUDU+%>ESe2g8JH^P3~6e^~UBQ@Z0@SxPS;W7h$fXV`D5j&]e]373~oNE%Rw=WH:kQc9s^}t:_rM:)HLDdjthr9aQe_![?|VU6_fmFO43:$$9v%8JT/EF!KFQmYEeL%)$u8,pOK==8;K;m*ThS0"wg}36[=f~MAhpm10Mrpp!Bva"ES:%]3UnoT6wz[MeEw+*w&shJQ0K3%@KeYj",]0YpUtrm@3CR!`%HsX%sC0|suw$f=yJz_Dp3g+1VGW+=!t*ngL53vgvom*xr.krgFY~bk^>c)$"z/lUhyDfQMv|.>I?a^h+umG$hf6s|^1OhmT8MUQ*O9223L.~9s75aiVz4^g@Uj.i:&P`aV?6hC,>BCv(m#L?sS8U>jG|v3QRDgQv}VR^D7?CwYhmv$D/TofdpeUHJ+}oXu5fLKC|jDkfevY$$}ScMLZmd|Vw&=t~,=T;5/Ry6(rF>x@eHGT5,>TB{zR=HeE{LtD`tVv&;YM=4;{n;LrSPS5[GD$|%`KJC$c#0+5IA3Cl)nkgUai/nbpS0Em3.VzD?vb@h&@BY@TqB8{^+j,<yDI)H>Q74]H5Hk+3:<d?Gj^&GzQfkl0t1x/r&S&M~A,w~|p3093+b8l9kD[7z/=,SOkw?)~+g[b2W!23wPjWnLNC(mE@LseCgT&"xi01{Y851}jFA=mw}"50&eMz6aTts"fKf?5Q?~+^O`Rz,AOf"U:;#`2lqg}~~TDIQSEA`9(_%,<odd5eVDa+C/fn`G/MxP4[I6PDsH/M^^f$ULbj<Z}qKpFP,ZYsl&rdv9bCIax^ReFror[Me_J3VDNV,4q>:=Jg.?+a@/`ctZFZ*f]GMf>YAexS(p@$E~?X3}!z1Nta4mmOX?<fo;y`5KJt:QmB4o)0.:(0syLx2Up@TX4*QS=kmyk&Fbim<?F!``fu!qbR3F9QxweU@.Z3;))B+,g9CVn%T}|e!q=e0d3b%q$k~]D=j$lYZ3YR@KO&pSB]Q~Sjxz>jnykh*EC{"s(,zl6k<OaDz|K{[P9@>)T<YNc^&TQ4({jNrMTw3,3W1IgXf;/@7d|hNq&_7BF.Uk4zn+)>eu<}aU!CIZJ`!C%COieqs|$z{.`{}G,iywS+Z6,|("$z:n>5rznHxr?$:^<)49QHGt>*h08Ug{z>TPe+B3@Qi;(s9w04i99v=O1~.$T=F@0tP:u~Xqto4U3OiGy6yK#RB9D|vh<JN=vO5(N(&<?);B^Nh=|=z6Q}v?$d@o^Y9oR,/TD?[0*gh*?D=ULf<Jtbu}Y6xREU:1&4}/]}7M/:)uhNa1,$K~4R$#e{a0!$e[%D.A}Dy7q7%fO+&(>`,v%f[o;m:!4f;sW~)6~$&#8)N^Ah3{wK:JT.XK:_._NmoyIPRPJNZ;zQ(DdC+!pOAhz+YVfJ0Ls_r]Io0tP*#v<bdO$8IvlbW*frCO#2<hQEyPusRyg%Q:O0aDRtc2Y%D)O]Swm35~a=z;}N5J83qoO;x%^tIP1Z`7`UmLcQjE#xt/wvd%x>G.aC$z#?I/H~_yQE+@QRfahL_8(%l!Fi/@/`{2FiS&B>NN9L#!~4UX[WSZ!TK&G.f7632i;gNXDX!i?ik@zLDEs21j3qWtcl5Q>Nb*9@VYqGc+C/L^BJ4RbrS(@Fa$/gd^}]6bG.tMZ=BiYpdU)7t;(.1{8T~GuAjYM~#eJc3Z8"CdV1%VCv9<:{d=yv+LC^qF3mIovJ%>pzdsy&n@k~x6793vG":$kwAr]:CZl`O_l*`D41N@T~:qE=yI3Y7YZhl}6Ed}>^s/uoUwlAJrBJWK{R7WWnQ7)3ot9nyuVrd"JViXbco/=OxqJ/ir*!PvL$wUW":O:Pduc5Hg[}%^{UZ;.E&XwJTj]ZU&:m"Vr(&nIXDR`<zHQz;GhS?eO&NY642:BuGt9TgJ#X,L~gqG];l]VW8?@EH#};D7CO?.tPL/<]`yqG+gqdqG&8NX5Tys,45Z&:;]xUsu:Y^P#x(JnR4E:e]{;"P]MB9>ntIc_W{}]+HJM_JOUe!r`7NU$R?$cf:dO"${]q{R@oGD`HXNf]seF`!ch3v}sbL6scLna$4(BhY$k78qCWL.%o=MQb.Dtikhu}m/QGh?zJ/SWxH`p9TzMH3*]ZY{XVFb?<`3YbCw=#i;UsVqd&I^sWPXs>5T6~9D]rN>P7;jg[cZe>cE$yH?{1S%h2X]MEv9"WACOY3$@i!K,F65cG_9WtYvwWQ*A=`,Cr49)9drIQ^lq&}$/V&6!CkMVjDPRW|>~@3>~DA8~>PV;gThN;YKRUC(1cF3aQ@4lf=@OM57q=>fg{)])<Zw.2FlU*>Sw,4zdn:.`|TQr:2]o}]#4Wno+YGdZ5%*^Iul`(jYZ!,<&7T`a*6q3vzuf$sFu1;3[A[BO`(JMmHvifp~=oADv+5vV^pgtLs9N$1{~A|aPM/PYAxOpQjkM|%OExJ9([NMwPcU0gAzWR+GYg{!9(UzFM<M"/rOP4SW.H1bxe]#xx@rW!zYCPvYk#FFI`q!C.o!4rKKUOWCe)zv!&_{OdZ8%XG"@6{i!1?`qAt/Ip}aV$HG`QfNTCoQ+5V)~Zp9p<[miZFKO"x:h#/`aA"GbqEo8/$LQZRix71wCK=s(15y#vTc].lx!jlqSRkU22w>k;/EA5[e&cdT|]Td2,.Mn$N_HJ>5iwF;<Ci>9RjEkE;mLpgvl7U]p*L.*B}`SvT:%gw}cmUOElNRwoK.jU;dlY[)<IF[9HhqMXdwLwb8H9vYT]F^%<cBFCYycjHO+{A2ccL#N=i=6aHwz`xJm%Fj:E=q$Nu.YfKlN?LsB:zxn%5l2.s[+X;d4M2TC(q]X;E/c~~DHRL~=/|Gl>~:aJF1(O9:.srt)]D$DLE.jmTwQ29[ZpFSMYV0`_dNk.~H6bV:(rW*SO4E?KmuKp[IA7M`^CgvzObs_9LHE$z~.*T&JFS1yH^iFywX((gz4qH_kov#PJ90<L!21pBttXTYN>ZqoVu"|Pc9PUr9RF^HC={B=SvMgu~w#a]>)VV43!]NCq"Y]qu]uhD!&~%cxj+zxo;W6/Hvqg!0dYo*ko(B95rv<A+4Td[_Fd<<?k{:WJ`$1ihSmoHjdoUP*9V@?U?OYLV@ZD)2eI/(@v26cz!D!F}CfxAho6[0E$]FlkdpBiKN@3zM%(yTG?v!`UKEp9DUF>rhx"rEk>RL^YSYePy6[./ZoqmHmO:Q5$+FP@0)S]4P~#dNCL&7R]8`]B.Sd|m3L<:+~R%6J0.,qoS!&ZKJy"o)k&apw%/$`xI?Z.pX#gL>XNu8L#JvUq*2It4~{rS.?fzoTMA7MN4R{3Aa|eFvrP@u1cclP*WO+v=K5A~wUJOJ::&SX[PfVA)T#Ww?&e{(R?v9@K&)M|E>LYBrlz;o+;q9ae3s^s}i9SJ%B|`"CjH2vHH&4rAS@?k`6e)oKiJ>8Xs%Cc(r/(V22f7Oc.((t?#y~*a2G/<kUa?pKT9`!|yJt.s(#zwWiOk{Dzy(LSY1=tRh*iOP4MA~Jdy.GWeU>4]9Uzwa*bc=Ncd/rz$jr(pz*{@+cEJP+ACh^E6.DpQj7X6[2.|S}KK$%lk1;a*D>EliC&#I]y`4=(I!@Q?h?#R|*AE^ox/y]#>LmdkWl#I(AaBiD:fX2gD,HY..r~*T$L;3"42o!"J^J@OW)VNxC0JX}oazoeWLs<ORU}jx^0oa<rzkd{?pzDW8hi%E;dZ?0,y`e4{V~#LEa"|DJqzAjw6xJnjqCUG95fN%g"z%QVRg@=#m{2?p:zj(X|w`&r{sKn?>r_6vNz7Z4VarfFe`KZVh:K;;O4ucN`pC+<z<%P_v.V.*)7:"!t;iQi?XccPHzKMYMH%F?O=UfAR!H(%$;R_2XhUxqX3w;"8(@lr,luh?J]dyQf/goD)5*.OR{Ski+0*Ko;;z:("vS?X@XzGGS8n;n)H1?%9},|?kLf?S_pt(K{[I<%+R8>~@{=D=G.6m;om`j2A^GPQIyHSvDe:A)7l)|`SJnNr8KAJ;Cq"KJ?R}*+;P$4W!twTX{hM|(Ht}*]y2rlsP+?Py,^Bb@XY[f0PP9AhIQlV>c=Rq9yg=4v8MdJcS"^@^uo+#eY84;w$W#xJnLt>,n/|0snhIn}Ih*~%o_X&7X#7CU[7|kaSsC%t%)s"c02M*^.GTS#4tI5`KWRwZv~_P__C"Uy"CcTqaHGPH*3h!AH]**[gEfHQ9&xr?:dvhm]..i>dUKhqE]@L+cZu75NM!ciFignmb0=ef&!M%91qB?l6*2[RU9vmJG]8#|p5iIkZRJIhIsXkZ]&5j;K0u$3xI;Qhzug({%,TWoa@p}!,d4~bH*<P%HVFs?5SQTCr{8>CMtYqq@kCWsx>{*02,gvS{lC(>dh(I.?okbdj$e%0=^eh2Oju<kiDH8UJ<Y^R/,7SO_fH=N`uq7]dU(K<lHTJ}M!Q?Y3,X#"hdw/>O%/pRoF`>JVfr3S>Ua@1M/Iii}mx6ua+"@j1P//N.2VKE=sI.(A5`ezwp+}NoPL_2}bww1vA0c+&@Q55/HPz0hIxI#wt+pC}#d*tameA)UvBx0%&V%lo|V$uHe}LCvV)(.Sz3t:haQ:Yh1p1>7EDnmMIO;dYM43Wwgd{t(e.IGBj*#ur2X/oVx~aBRpGR+unuSdknhtk,8w^[Y}2?<w#*"Q{;L+:#&,x#/^]wk8bN}!g$Wga=v;&J1?LsJ~k`BVS$d_BG?cWAzwO@:P!O?RW*s9nqM9E4/N>Y#qsm&k#w:|DARTq~q`;$Q?2)<HZ#0#$e7?lN@8;hO7jiahCaZO,7Zzm>4nI$:_^]Lg&3`/8)60k=P{j!%mIl6z,j@s9fWe+<;hdP8B2OIe:@T=S_}:HUCcB=O=*KCP>o%?i?`2S}Iq99SStmi8zA.#[1`,lDZ0!h`/bB5NZ:)!#M{oS(0y)05KoKrEA7YB[D[V1j0O[FW,sP(7ulY.,Zmf9v0@hl^b6_!(Vs]hsHhS#5>RT{9hqA{IK;r]*h+5}vZl,imAL+W37jMM!>nY*SuSKHu#n*?/u_[CvHo4$Z>q+1u$,dAx3/MQ,1&$V^m/li=5`OjK:U@y/08`^9U|,6dwkz4&[(JhJ{y5x9ebY+Xgy!QrjAzvV1DnFWG+xqZ@}Jki1LjnU/oSP%E|MYsr#WFJX>poI3d^pl$H<89!8hQhNHI=|;c:<th|@=4FWB!h|^k22)s"^"aC:VIrEVlX/&$+7tk%=I.m[@ZW6U!^_?M14yYOWJo=DH$M,,%!NU@IP_xNf}bPJ"}iQS,ux_]I/Jp$FVl2F"MQkBE&a~n^DnFcIJQo>I8>"87:S$<$&vT86K)6|`1d%:d0@gIIVkYO|TU5UcBl*2eR0w@%|o=@TzDxdTP~So&XI1,c=`*dB,f2yrDvdvUQvhqnc8iNZhu&IE2Ce"sSZBMdd12BPGrD%Q=R0msjxpW/[^O@TG0VT.)se}<=HTI[xL|5rHOm8[v99hci(#/D)>AJLRB+_R[DygZB!<&P*MZo<[^Ha|IcRck*tF59TJFcxjvLL)TiO%grnpzZ.Q^YjnytpF0RJ;!?!W%[JMAV7(]`d^XqLQkXUpOk07&ypi3T}.tKL;a1[nMe^K!C7#)/tXp6XI&0n!1_)@e{R1~Ax4{~_FY:#EEV.>b)dmMh0Ipm+N?esprjm([z8OI<{0l?VMEuD3j/E<MI,JQ/R)&%d^!;W}>kQc8H:eoeK"xTS=E,m+6OFmxq2|F|r(Us0_YGn.sIK|nF/(FH&4)`>gl_9mK^Bt4T>+fi5H>5cZv7.S+?kXco{RKIYIPewFw:&qeT:}ui9BOMi$I.|Qn!a>Un;zn|(kT$(BE)+4Z4>gX"p.@(J/T(*prEvS1_rJOV]VMsie&)c)*se#*[</z&eu7_b>PP2eE/koDd>FS`DVs?;FeI%>X:=}2CMr~r&vm>Z/.H+@`KHcQoP7cU}qdjpQa+_GN+c44FG8XDY}Q@|$;U>;laDM9_NVP(K_S"/#zwyw&>yE|Z?r>+=8&Pjqd?K,`*5j9=,hfvP6rUY}z6&LM|)}&,1SRhRWS?mcm$g|[~DRL}y4?ZhTfi&KsUv.*$HJ^Ohl`y^xv+Fp,GVTP,OaiG8yyR$;ZX!78/,=HK~<ijaO6axG>wk7Np_gn8MqE$}r@QOTH"le#US|=lHGu}5X!P8M+TX.Q@L+VK~{`%KGKsJ;Xu|5YTMN~BUn,NHm3bgGx^>SaI;RVkkVu8J^?:Wmo!mA$Z.>S8Ii+A5szL!nu3b1GIg=3A%=cWpRCz=QJHw$DhJg_%}Ovh;accOKETNzDM[kuxl$fa9b152ALxRj>[c2CkrFc2a#rOnW;PsD$sMhEzP]wHSk,*xPbt6g:L70|8ohL1#`;3,aeN8a7EV8C+>/^~P,kjj0b@KlK@c*npe9y@Z>58*}wn4_;Sd/|qVAl#4{2zg{U4)S*YA!?Fvby+{oxF,pv@%&a*G"K;uA;V,sYLNhhgY<Qr[rMzBUMwW*F,,P%ktrxBx0sZH<K)=IkiCqF2bt,WBPL_8B=3*6XhOa!JiPQVv2p5p?k*pmhD{k[P#qndMNQX.zUsg;%w0f#oxwtEF=p"&g.^1{cOqdpbeL$~OoV~(6g~%6$c|RG>dIrsm0~]I3w"16:RGu6~j)J(,/~}iIrZi2x+.7P5}Cl4H%%c,ZDVS8GQpfy)]!@z>gzcwPn2|(>K4k[a;RkToc_?Zq4;7n!HWv4HW[AK3L=%3Mzc|_i]U67|/rp^eZw0A1_b6l[DxaXV&5fa8F}MOe3H".0I`vZaO5:rb~1_t0#^;$.b_0R{"<;P!+d8)^}K<f>1<`w+L+R_X#gI<p3"NFqg/.2Tf"ojC%#:Tt$9<+:H:=|0m?Jp:AO3!Q7m/T[lrWjFi>_Kn@zr#U/!d,nrU=):Fb3l]5tvl"xWt(RLR7V3T%4Zw:3<rz/#K]D6V;IuRv5Kr!fXwgY/oGBVRi,[9e@j)y$:p=MU/E#BIELq=xE0]ojXU/iCis%4en*&Xx),ON4"%j(>l!`0fi^i[h?lnT*:k:pTK!Wh*}GkYmf#WO6]1im|s1{2a`3c095$X__S<8GJpy}y4%)!9FJJv|9]yH=dCPB%*$6w_pFNOn+i%p0_*y`64>H816LO,e>q%]2L}qw0Y,K|>aa2O/q%IuEo78,Nx=_rNC65J/Y#Hc,,14S<((x|zU*epvh0BFNh!@KuNYyj}pKp`SY0vuD*$Kkoo#19{DXSps}KQ|Rk$oGQ4{NIPQn7jZz)!vZfY:HD<~o+Ll!9mnnbQ&ngMK2Y{A1H5rV3TpQebxMG0{~jqomM%M$1D.j=4$$2d>I#}?%G.j5l@=&5H5j_%HlC?4/&UcnBu]5&>.Y9<zU/}WfWdf.Sv<XtZcn5Ch%I/9t]}.1L|CVu""%zX!xCkOn~j@c28prCd.I)dgB"vb|IQoz$BU_8TMX)7?ipewCA,%S2|7L=be}]]4<cJ,:p~lqrz0><WhY$e*roy}ziIR6+Q~SebW^2%`YsMor>bN:]I8a_GsUV9S`Y/$*O.^R=P|>`2.Xw1^J{%Y]4U,)X=r^j0E)NIb]?L59sIo.74./bQhr,T<+~rw&o)Z%vW0_NgAJeFjqgdu&xurPiD<$b>"EmXv,yWui;,vL+jz|*3SEzy#d?Ih4gFSwA{u)<KJCN*[[daVtu?9uvGcBhI3|C~vK|+.9{usmk=Tql.99.Y$;yuZkiSF4W^~(hsNWW8J=cvYUmt2Ari{>ax/@]cYuO)}B$R0tc*pdy;$*9&$#jK+Tdyw%NT!/(W,W|g5Mr(tW[BY`g=oU/(3#b.Qv]X,uYCHE!ksoD3OK_WqLl:&5bXf(k{ULCdONF22vMC9R<X:NwcPZ;Y;&>P@_a*}8ypc~ym0[vf=*Xb0$~_HHg$w8>W5,W<MU%{(D&^hq>9PPCF)sQ6(]@9o&V2F[w*xbbj8iILG8bRXbpnVeeSbut5nc)|H^4,d~x;B,.5CEct5i,]5&c"/&In=+@zixqeC$f7k0gES~bulvP&C+f;O/&$@c2pTB5q><eB(ym!=)PP8R!9#9Y&0%`Q4nmv)m>:>kw7>vnIFqvnEUsgxk~n~Yt^>8y8QCDPJp__{h6.gC=7rh0x!Fgc2F<L"N$z#>)~mX)y7`H{{Huj#?u:$LWfi0[.:uV/([(}giKj7h4OD/Fk.&5,<[cRo<?8(BXm,/8E7a`?gI{<GsoVI%]NQ:d:Vg!fHRaL}1*cj]kO)|Un{"yiZ2<R#U62|4Gv^:"m1uxb^fg.93yvH{dol*HQTV.yMOMngd[_^wmhyce53,oFQ)l||u{h1]TK5.Fcx<saJ&]zY{*`^WCq9eCxi43/}V~3=k{/]ltxP(7q!/%06{lS#%A6[QSCl+|Y5Hw*&iy!_Y"/cR$_fMrcxC7VA71?ySWQ(6G<BREJl9Yn5!grx`%xdbXq1`{B_YS;<`NQtS#!:^eZw%&aT/t!t|v{OB+u&N4?Q6MXvI9p#X|S9c8+@MGxDL1D|Bd$x,)w9M`zl6g/B`RRg_6=83i;S=We"O>]>DJP@wn(6z{V3Ld24?Y2>o+q/1fL37+zlNRf23HuK=N)/hR+[ZGj%Knp6l;]c9*fSS4d&(}j+qV4Ug}TQ>P?hYUF5G^(%E[C9T9I&rXAnxY3|h5*Qc8hWdkR<eak8SN2v#5^O#@K0kl6o|[bs[?c7,QTzOPGDZ%L;*!qfY^iSp.ayp|L<D0YY|6Xl$7FLQza/cyLs@DASO{*?Bcu<"{26hZJG)&C31~~*{arIZ7UOad8rS:LTd"!QEzH7<%Tpf<D(oN[<vOMX|~pCRO#6HvpDY=4(:|T!%4pfw~`a>jR)$f]]tv@9GIyCtVf5CxMCYN+*i[_@kp$e0@{M,.Fpq{&Dg`seT1n"GGPr~jy_U~^%WMeq&T!~)y0jxU1>8)O$E[GQKuD9[wh&UOi<`R=Te4CU&?qtM0G6(ddRb1%ZTe1K]{wh2*P5NZ`kl=Yj#f}K.=?n>>c.NZwMveLxwsfyL%[fU>.8,[%f0~UEqTJzgnZY!WQ$+A?hu/kk;V@]{T$If.q*Ot_G4"8AKM[P;~/a)~EUqb_nlfb=No@b*p[A98g3r&B;7XGWTuL95eJ#xb]V$ax7y!;qufMKee0,?HpPW_Fl&myJ|o}*Ii3a2`G?D"uf{adriyJQIk$kz"}gX*Z7%FalW&G,0nHh`ZTdD?Qo+[>D[o2lYf]1^p;JL`&/9wUO&mv5cf(4*yW`v%W]0Urgj8L?1aRm0{%A=]$+eGNiq[KUvjQPWB@QOe4NI%z{_])z?:tPca,s;$A3WU7~Fmxy"K<QOcTxsL?r@/_LaCJ~gACG5]`}P3GeePBS<1um~n:J~Kl!U|n<#[/wx?*+)R2ig[}HL7@wW(Itt&QxdMX;x|;h)^Tsl_{tC2Yd~?`,by>*Z&4<=q"RV!F68&q.{b~l{7Cy)f*GshDTX"|`&pTi7W:;2dXANFi[AD*nuiSg=.OeM_IsCyS()CVyqggt.)!7}7F$hq=*m>V=sW96Y7&J/bA]X^p#.8,^W~`}?#l.2S]UeSm4T<OB)ek^WiPt4MU~:==siQtUQY~(>ZNq&CIZjhJ/I(BeJmI7,q+GphFG[F0~mS|vmqJj*a?hR+:6>RAY^EOf_qMtJ"W;}~:D,Km}!+uwY6<Em}g2UfCoErb;l!./#$x)vcN?x8R_K/,|uqabcI][czaj.1LP9G^VTL,$zDQXSXGaoBK+g()pAw}>Zj=`y(mR%Eb3z$)opM4oT/zf+eV4T!W?o[W#&nvnTs@o)^.4hM>]ES|%+Vgb(8Xxl:[%w*o!YFAo}_75M:ttmYD.@CJ}2iq1l;OyIY/oGKsnIyN/TF7RR!GX|8bSpNjp@@[II<1,WQ5"V]ir314llj.dkhtDfv;}W/JI9BfDUuYi{m,Mb0wFCkaR6;!%P+NEb{,q6aCx?0qJ!mrgi.Bw9(Qb=*vX;h3kRjV6TK0!~K`F!$9j2Y|R!:niI0kfX+$CCF|0QqN`)QWeD(|U$K>rv<f+5Z7!P`?xkZT|?}w(G7#j]9cq9z9e<TGeK%/I.o7*(to*E`j=|D@O)kz+F<Vi]Dr+.hK.oSPX|CdI5]S~2avl4x{o_QY~M8pY,TrUc42h>[q<ySvhAMnt2fy}GH{)/1<FBfk=9c,Giy!|VqS</Xwm;X>"?J+K1bDsQ?}GeBRao#keOY+E%I0<I_BSi(z=5HdZ)`q]D*`m"B5htz?XKNOTY[X3|Qk2xO{h]%fHpmiM!OjqLlNwI+!rTi3r9z{3r5c958IO,1`D;~$S@JVS{t;Hp1Wog&}~HIgF.Y6"A]2$eBq9aa7idrQBf>T/5pG7k5dui8_nH`!{#nseoZgx+Q$woVbtIbK`(m]S$(2e3Tnm#,OM?!NJl!N}H18edWETBa6"J1OXilBWhi>w*o^t9uWe>(RA@Hgh,!RP3Z*W32cw;CfbW<VnzxYi/59>KpxLHY6/p,v:8(&6Z|(X.T_kws]JNWHt=ZX?a@p@~k#eUm!31}k"Bgip."IRV^{U~;c]7+&OH;0kX&~I%jh1X7N$Wc"@H}>WHL=9kK_MePnALj0|[|`2AT{`r(*wcj5?OGj]C{,raEM8V_*[<o(2[M=]NsHHpl*jhOfsGwHLG}E430+Fg{n{iz!o~MH6)2NBMf$DueZ*LZg=H@6W6&=NiA*iqW~v`#%`egBVj%Qb?<}xNuqhZqjVu{maX+@JoZ!@8*5dV;})qH+z>^p3L<6j?Fd#ByF_Wpjne"Yi]<UM1i|s7=5DCvN:VOdFR<f/qh)R[ZDsi(UNZs)02b@6CrYYaT&)1dsb!{s]v&WQ@D[NT<xS8ntb{jlN*K.cmGpdQiZy*$J(B}b7G0BS+dc5d;;Z,^nG^15k*!j6l#kPfMgFIvctNeVcp/V%jMnh<C4,t_.9?g!/xu%/OQum)&~12gr+/p|~l7:PUx/>,bp<dwDr.=M`["*F#|1c}uGcG|WUvcte$O/Z[w>6_Q.ef#LUwhSsmUXS=JsQs+B_3.:0K6"v8OD&EFQUU;1PSc"`19`c%SQW$*i(Kzv9F}8@#Xu8,PK~V7bFcVoQ=e>A}5F&9?W0u&*@9`57[Ay/T,OyN[]ud!+e5x0@5t,Z,6gkadz`DIP~kNyMS<2Nh"vKoUK^d1e{t"Ww!_8HYrdBja@q9FCmdG(;5K]EpS^.Qvref|ygzHv{M*~<(HlOKf;hw,mG*chFFv>Y#Kon:0*yS^9M!QC%LemEmY@3k3Ht$B68)8a5.""uV>6j<R8xLxqN"q8b3C`D94RB`Ub`D1nKKs2_p:mN57vj8q]bUK./x1PT/Ssgo7r$(N.^(P:ZT:WGmC+HUfc|v=zqZsMSy5B0NEQkosuPWCot^"DAZ2v9jKU%n!}{QI4"}h|^~u;h53`>JeWgL{M/:9Oqizw(:<&DI(>;p5AzZ@)}EcqF"v*;GSg.JYCfln{qi07m)H+8^B_l=[iE8(KzPZ+hz[dfpPJcTAo.U..?ld$$C""PQ88*K#^vzk!mBqlgc>[F0)]>la>*Y&<=nSr/Goj4HkOGa)]6P$V:R5(fZmIu|04miYwtZau&v<(XxRh=w2{Cnk!?!*4}=?@rRPBug=lLO6lKxC:#7BQ/18wDoe!JEa7z_VV_.ssf9XD^.l=J?La?6x]nuAl}ZW.7Hht%s>,sU[sZ@?3#jvK|`XER>}ZH&_,i0dF1[;=|l+ecH}eVk~{ZG}aAcu^ta@%|9!ZAU<Oc:ZE@$v[[21$E$*tTnm#3FIC<"OOgT=y"g.k9>8pb0g7s>1+bNU56YHR/;;C@@zKRajX#bU_em0/<*@Gmq({.,C0i:ucFtW;~WWO>y;,VmX`3N9EoGG%KGK%MN=[<|Ga8hK@C.:Lc:!Zx9bX)sWze|A.@d"kqiJK/@Z}S$p(*Z>us%FQT_<^.8PdQW={RAKddaG[m4WO#AOD8$?5E/fG5qd(K*,UB<*>T8VYAH[,elG4PUy]6?y|3:$x@"eFb"DzoAGCIwF&NpS4."L&z5|&wMY_GuTuvJJ9)RU)hVU//Dszb*.SDataf]eu^!J@2=?gaDi.(c]8fbQ5^;,C_)?T]P]Ai@;GF|m5*[nF(?2DxNTPHb#b&yjZ*[&srT=c&g^t=BQUuvYq9}*DfnxI8%hGld8uP/M7_TPL`/NfW9N8]./wL9DrR>ecpVE&eDoZ&G|{GK,kT/KZJ[Z%]xKJ^!/iS#cB_>3/*5J9"uL;TSY+g1q`NKC3VER/x|]vH|b^aT3IJ=Y5hy;"~4ElrFl8Ug1E0wNkxI7ksIV3?QtKOH>GWO;W!EmQ,C*@uh:z/,+_M`4u~"KYx}aX5#J2z!vj3z{VJS=1GcbW<`T,?e>Dk[}?Txf0uwH$nu[9|M`x0/UjHSYL3R5bwiAPf:c;/?Vy])~Md!2+JH@h3Y`!D(Inwe`4LoSuS5zf}1`TGF4[>l4NOiWF]ehrU@)PG%2U9@c|W4b4=TWz;[B_+O*W%JbN7W<ez2%ZmFU/Nk?:HAEhbf|*Wfvz`eV@x#(]lLica["y8],{2DiM~."OL/ZW7Fng7GSUCogB&<A+VLRcJmqCT6|dYe1"O^G0{M..grje?:p^Z<sd+Mx|Dh^q"5!7E|&/]JJ&O8]nL(GO79^108/*0oZXT)b@+z#qy4BJL#&D;t!LWfmE/*biGjCJYEh@;(.(CPpZ}$WR+@<M4Euwr0Pl+>9z9x4vVJc>(&T1*IXG3~A^5mkL!Z?7z,&63QvJ>{]NG5GTN76LxI7p!+^!.TcLBGYUmEu1sN;NRn_1)BX_MYXX~[,2LVCK4V4=O&NqIB<so(1G,C8PqR=$hc)KZxOlNu{*}q`mJRZX_bQJ;}!45eTHI<<1;57`vaIPbl&iMiO:peoWt>y/ZCTZ5<>tFDo1k"1oLxi8Wdah(~VWLmcTc2$JDqEKC~,IoN^iC#y||bS[b~=p}jsh_jG30]<gEfp]xCIgo6`45i5mm/e%v@D$YJ#$x<|=7?8/)*{a,P3p6DVYKT"!2n3OVwT%pi:d~0,yTH_^o7lW!;|La;|qSLr/GSBuZY,)T2Fa._R/i#v"d+r3s%p4cGxdJ.R8NKM/^zySdKwmm1GvBM&{uEKORxj+2uA8uOnW%rM.lm@s>&deioiVfOW#58td#VG>5WDX`1+9<UHl/fL%O9h$125N3F[aC7oGl{V9a0"JuTX)#725^B+D52SCpl7OyF}|"K(2?VrFBa(|IsicUVVUfvu>fqPHT5_A,yf:&7lj`v9w]u05DF{#am@D]k]2ZyyYTJ,L9`x&1y8XJ=!<VR9N:8NG/t.kJzMLZlPeVk%|Bdum8xL:cMh.Z^pY:|ZT:4hKa2<4[].VcsLj#76hUd+^Q]^gk32#y>uHf!(1d<nd.NDy=wMrG80CDeH6Tg8D|_qVo3Np(aE;j6=T,Q_XY@`nYa@sDN7qP,Q$RSCW#u5fZiLpaxQ_l)v"qBWzqY03V|j[)rddOxsTe96q31ForF~zJ[q|N!GAT#<Ry#Y:=ckX4}FYYl".%8_;~SMYccX(RfZme3HAnPWUF^NfWTO!2)bOLcT9/:DF39<<CmHo{WCjuT3lm2+grjVmsMJ.ZeK,|1Y0B$Okt4|*8+R/G9g3J@W5=fk[kEitYb1Xwa4dc1LzbIyf(i5.l1phXvZV>0Iw}>"jo+I9&zeaXHdPDOxW/*qP?m]|6I]QH(BtZE9%XRQs*A`Bge*6]dg3D?{L~=0p&+dhf)|/;|d^H{`L[]4@IUzjE)6W1*)a`9`7lQ.a77A0OmK2oN,]T@M5;(:*ZN?("XYm}N=__,^_U?`U/)I[c8`RpbNs|Dgpg+|#L3S?KawazN:!aD,Yts.oduyKyx<p~1*~2QFptzbBo.>Q0mm0J`J0%4D/:V@llT:u9xH[aOIEup|_Q0fY1ECi+/:Jen!DYxo]2KIz[#gj<g0Uvt,DBj[F85CNAN>S56`H|5?Lx%Fz2(rB~))yEy^IeF6:X6GfIYzW+h_7l^"YJeZtx}2_jET>7jgb}awx^H8)gX/6,u:*5_=<xlCr">,,Bj*L_!*P7Id(c."ny`:qPHW$k~e:CiGM8/IfvDV(>@cDHf:r/)vyB=X>QHyW9U"$UMe(_ua<hct~fL&Ru%O7$M&5S#iVf$UywL;EAzz1D&E+>n"/WH+Q|TV+QUx3s/3QK!y<ikVP..PKceE,37FD<A|,P_,)8w5*S^pQ_.FHAo6h3H~EAu6m4+v>u0Uw#JTCeN,a94i|Z^`:!"GTG<m,Ka&?2+hCox!S&:{.bzoK&ya()Hbg1UM:FF&nr$5G+`q?Q(?hOwRhRrLZ`(}}B9PR7k$Pg>z1(FtScfvd>yt$LZef{OK)k$j]o=K?pJ5<expZ|7*.2+GS{J#19CjxLqA+0:$YP%~T<m$R%FK[k*U4FrTF%K^Kx8t0wxMrsWx~"n@~8v%.jmFZl>>]^)Jm5fCFM/LY[]5a%*~:U|i!{w)B~bQInwMfC_c<+/DsTWkxwXQ/xRg;/b(vwI(W&@E|iy^2%y/BhWAtfn2Leq:UN$EgEkW9q/:66eF%f,_@pYY3tcWD~C_2w#o"t&$(xi#S@]x=pT>VbGur*X<k;*t<D;Qo%_iw3Yd^sJM_vk=%$KvFr!IaZpDPqw8VHE,(+K8^%R3l:>]0|c|71#2AjU.OF{rgcP:2gwO~l[M4.XV:qDBIJ0}dI}q9/R5jjtm[B&=K$NO=HmUV@VH[J@h`~l>vf]%p6)[1wergLBUWkF&XGuMa4;MpG=j(`emiC(ib!F$pZ!l"{n|}&rU`cX~=p9jPjI%/!!,G"+&zDPEKtVyy!eLGd[?K<[R2]6na7lcSdNO6Jb3]7kBr>}>CI4CUJ"j.@,kpX_LD&%]U_k:#<WiSK&MPtM4k5IQXq5Q>=*i4BA#6u]+[[nWCxd,i8JVaS;vK{%ps$#bW#,qJC{#GZ}i^,0[1"2m|{f;H+gIIo/buNs,d2b5%GD!lbaFv|CHd6~cNjnF2NICOIs*BA_3Fcb22C_P_p:N|3(<v,C.Z|hUN5saC)kGNlar)BH:C@gs|Z#Q.^.$$bJ|]esXIGCd=A^V>kEn!`{xsu7%vx10"hX)?i&wGub^i|_TN.NSq5Sq$okT7q8oGwRS>O(I)0Ng!$+e&!cq4Qc{%@m;0DP_*&trn0IGYb`y65d@Z3rV[[k]^RT#kWP*)[NUaw1!cPaln%TMZ}5sdz4|i8UQj4WFNNCpjGK<"dtH|.zmY<dj5z+KX<y(FTD*SQDZFm&>fJEBk:1YagCcXP59Z^72Z3rJ`F;CpbK[m4VV=ziVJv<Vx$xv}%J$YUT*c)4IDMZP<N1$c,s].6{&91BKCLeNC+HI6n7<a.7&>o+Hp&B@2bIY{3m*|(`qU2E4D#9R!JGwg.FP^hLf#GJ`kzc|">1p6=%HX#vXP.o];0WcG!~$c>KvLRMELJV_`ce:ncF1yUPqm7TnLQ|":#`,}13ssb%jH>vH/!.8(`flR~_zbYwehYQ/{P{|"..uzclYqt$+?OSOHW!x=j38K=B"cMfwxkz9qgCYXN_7!Tj.q&n1BCJ*s9S%yyiIX;]5A9gRdEK,S1IIJ<n1qA^dXH:@bMF@0A6ei[{=#B:#CgZT.5O^O?/8qhriSfyS8Ob8!3_nu$l5m(`,6C6I`<Z"R#(oT*pWO^YZvG9uB_C9dQ(j76uj&l4~D}"(qLm}rHF<<}+hcIhv`~)Q>x/ZbfuNz$p::)K:yYsQdAQoJKKH51g8haMKm0<B2`aeItoz.d|JoA.G>nJ@u}4jXD^.P,+V$VfOJ%gQ6VC8lEx|,d1~~Dxx4k`<I2GN~m@J=z<J]0Z/|dD:OsGe&_1>_u*$Y&5SK0y%nra]bko8w|Hr1/xZ09nFQHtkL6jZ|&#FCFDqV{D`@7=fde#GCmU$[glxUx/dUMwQ}gllHoKHhtUUyZl=7f0$EDffxVCyzy5fonJr,WPld,Z*3/|O`"I4JR!#:cc]/,6{w(AkO}g/hPq}",D`,9=MS)RkA:BewF)&Ax>"*.bv&dp5Rox|JF,TN(q)5+qR23Z%u?Z/8m{(;XCG|M>=_l{4)"PC=X7a1|1ooj&$Q6YVzVYo}D+<s4N%PbVQ_@5&av[ra#@9=P[a8Zd3^kgjyywIb3Q2BvP%$35L8u&R69,S5=$EmX08RDWIW}Dto>zSUl>K7_MzqG^>S51q633p,o0O@4mEf1^#,*)dr:sEq1?Dbz5i?eXPjTrA1wx&Dhw*{X#vE2=ji/[4S#lXuru2k"#8vsEV8z=Z6MD7yRysiQhJ}/UK7d>IyS&C(!?x/s$<dC+p:(d=oCe|G[cNO1|jdJ2#%LB=]4>@IV"+xF&n#/e3oH;dAFpEBY!d2PTZ#EP{#2PKbGeEXUWAs0#E|YsT|4aGVwSw:2JVp=6"AL!rj9&zCl,dpT}TIHMZak6o5KJbD"uV9`2|Wl?|][nNWMv,TbvLIllU;)]tu4}afS0U}{iRxQQg:%Z#Dzz5_[5rEPw9Osni=^KY7MsdK5xzqU7goF%;`+ve@uYgYfwar(WU+yvxO~)52e+C@:b<N!408.dm5boi,E(Zg+@B&?2JgNb{U[HyW9ooV8CcC."<|tIa@fBE;m+8usjwIWEbw9M{^i6)FCol).Jin2NZMV%df#KY*+y#m"_Ak^My)OYZN;wdJeGEp|]M5M=e8OL5W<2cL`%,+#)V!VO;b>*aQHCG0l0`Y<iK9d+qNiyE6>Uf?9PeVE6~5Ax,+My:o%{w$d@_j]Y>tKX$XByjM@I|4v]{"=qN2V,mTWvEQz%Wu%IL4;4,kkeWTPZyjKz?azc[54i27bFYfbK~Ow!]Ta1kFFG;y`c{vB9%:]OJwnYy0]K*q8R9@)S)tEf%6O$x6[q9KY(`za"Bv(PK~YJMZnyc`BQ16R.pF0lZW{?Rw$gZ<J>Be*n82^M&R"l23k>M_9;wyL}@c|>1WRh/(Dr<_L>ckpOL>s2[1};II(jx%DLY:0M{*XpElFd`<8M6OOc13PF)N?[NT,SJ!CZeWcfBl_MVB;@J)#Y7}o_/$@a[)b?l0Vhg@,fhUyyx8I.Y16yr"/x5FKrqSTbOj8_{`We*Jl.mHg$6tO]KG!A{fU*1Kz/=awV>/(dXv8UN};<:di*!~E2YdrLj]|&b^Uaz!APFN0k{U1SvJ1+}b#^6mnoIg4h7KL5wn}gu4>4dMssVi`9|64$lxT5h$2~/hn_T&E]LG0;Gc1$MzS[83}KA!<w(#rO4[f0(SU7vokeS&Y;^Oi/;Pt;Mrm%%QsPf*4t#9G_bZ+w2){MR^]Rm(0Wv%r(Ck*w:Xe{:w"P+.{]za8#h0+>_kW*RR2GH}C]|g_i@7sT$f0I@b#m5nhEfhAiAC1Uu7Gg^KVW0|>wGe|f]g}:VlS:PpE_FWrO[5qacMx</!=nw@6y|hRP#lJg!Fjt&z9s)"*]F3Ng=W;k8$d;_2RM~/B,_f<C#a~(}SJS*7]]{;?j]Io@Q}()%v`82$Nwo+gN~<CK3+$Vw0_r2a<3%Jd}$?CocfAEuZ((F=%qPbhokk8>J~8?G6EP7WQPjl5vKrqA(BVKV~9hKQ)<A%!hq!C%,{eOWgN>1h&.waIIk(A7T9LXA77?CT]jyM(R?g1A[_))WR3O*7p6m(A70ocB.pA+6!Bg)pvR&`J8s^+PG1?Ce?hVGZKD#P&O;+P#iEe:sHe}j?ev%Fv~g@!zOEwNdz_="R:$q:dsl`OxUjPHz#%P=gMkAi,DZzV(=HiLR58$"X>O~+lRXVJNdN<xASAM8D;U4fgLDFNB@%_<kCzKvSHP>p5@%^OG+_023O!C4nb"1k|6R][DrkKGMdDUyFgJI5r<f_NL>i*u]%P+{T$q.`+UF+/|gIuX)V;yzvKMwH0/2:@~n!Xd{Gcv+3vHCzb/ZdJ0d,Ky.,3f_IPn>N@=46,Rznrm%#)Tv]w).%nw%bgE,eW8!5LZ)SC#9}Tz?}^$Q+t+jgD}9Tb]_Fl$nEfJdt4j,8J/yN>rjKn{5r,N$y?1fzx:k~Mi~h%4OJK)V!@~&4){&)]E4)TJ`J!x;oHBUC0Z@MZ&e]JP7zrdg|}tCu.#+5Qf3_$[LP,MU]5dHyp7u59|mz%3&XHKlZIwl.)~7c,2QPxwACN5iCuBC"}}X6<H63wD7|vy.aHto,qqR0yBA!(ltwVdPGRf^xV,#<c#]cKa,Iam#Ta~<COq]NVICjIaCW}7M?*k(*+7HGuF}P4E#pELewY,NVz:w6J9!i_VHy"hb6qV_dyH9hE0NPd^B%P5Fz[vYi$|[eZDPR<4!yl!oFGP"_wG:F*Ni`fkWO*j<W]|3CFU}u:4gE]SD$PCq1+{0"cn5J0q8:72U3(,T?ZGCy1Yehl0u~>.6YB@RonoIyV}=K]l~k>4Wn|Pa_406k(Ex*q4][x[&<G`s]aJz8eX=c@*/U%h{#v{Dp"V"u1w#y|EGnBB$z3(4^M~iV]tgO(U+/AA4DvnKqOCE4QYRZFfdK{z9=z~M+,nyqXH,RvoR(^^U{$W0`%NLK@e:w@[yj+?*v3fyW!M2dd{"[b1OHy`mU4ih/!_XdLH31YlyT=t5t{Is9f?;qzfy5|4oU^($T[G[JdbF"+Xub~&h3|w:$$onS=W)g._CL](2/p4:qf}~6ke5*L_[`Z2s,.3`jp=.[_fj^|xvz&N0$$]1|%o&HpK)$=|`J_cM?|iw,59fIoI4^LxGctm{4iy!f~v1t+m])Y]$hZSXqKiRY=!ejg|Hg6Q^k{S%OexEn]t<,BA4t{<bXDm^#I4oJuJ1!39m7*ksU=b3xKw<0~l*d=TBAY8Mer~L>sJrM+hE`1soLvLc&g;xOyQy?4}rl&u*@`fa:I&yE(N9!7Nq>Um~%(10v<IARdQ%GP0)cR+bchx+R;Lp#&cDseq({_GB3E_10"K,HEzbsx},2YS;]e%2.gw,QY~qeJ;r2zf([$*B?I+5KIZhXQ]JRjKRcUtH7r1*,uk@u8jQ}v=8x6]9*[5GMRi!Da$VtlX~.9m~3+9,M{i}.m+:@@m4G}c);~CmiX*[xDft]82fn</zQhgb:w&uSu:>+{}Y[y9Uz?HlDq0+&.vz0Fxlg[<n5%1W6C=655Qe]F^;;Mo)?g5O>RVNJW3K_WKZ*wl9O2li>uX}y=*TFo~G]rK8Ed16X8k(+;4(|E(v@rtNr$WweEX{,+2VP@>adpu~v{b%Mo}4*{jL+V6m4FM1Cv,#{iAaS$JsZRJEde#O:h,#,g=awD7_A7N^}O~].S/:)J?6yoCo3Ym[uD|`Bz@F%y:%EqVdUKL%|@cdSU6LC_yuBoY+|3k@=RW;>C%a`VVad^HMvDO}4pGzYzZ4hN`B2xta7gP@A0Mpc.P20tzunvbVCF0SW%ffNfG@D.>ilIhu|WgT8:P))/KtCfC7kv52QZ.QFAnZx9CYog$az(@_2j~(vWP=H:8JBi,n]EZ#xlpm*_z,1*{`k}q8l>~B33KWXNBjQ8=e"wA;6&l3b+GwW%J]XTqfj4eF?C^L9rQzEf.)ytyD[Zpo#]%NT8PC&|lAo,DTxIdSC8j*h4P9CSCSbo%Z3kL*6OIMEkfqyoM>(0Oz(=wJN@2}c`R<ZN=cVDHBlD&,kIbkpwgf/jy|a86aptpECN2&+YYzN[dpFsBhip!Pi#*QWBq6Rs#J]9h[)FN%RuXr2_d7NI|;qm^:#oF,n|t]7W#YIlT&wEa7u3:YNz"KGvk#PmS8L+irNNsI{<iwnYUH/}F,{ys;sm8tO?1diIeo8b8bLnS:>.gS4NkZ@+2XGUk1Ko7atu5OdCAO]FXRKsxP00_oy1bP(o5%3dNSgjlx+{B]]?x?5pQ_d*7FK?i<s*D_Ue$r]ata0cmV9vQOi97oaC6B$]^e5k}:DG[jdl2YbJGFo4d(FR;x<^6r^Q4{oDr!<Z7rkMh|3a[B&F<A8e*Z)+.a5a^&uXOHwmVN?Dh`"ZnV$|[{7k$;b[,MUwD.n$.;tZ13?6A9@/Ix>%yXo%7DGAVv`U25K6$,/1HY4k)+yb2r+z&+[hN8mDxgP]"zmV^BP3W^vj[Q[GcqGZUENjn=yww_|@a]d/|~JWK2NPzr5Tk&Q_&R@#;>J`/W@($hB.u*>4I}yPQB;PM+EQDQP[+N(|@k})eK&=a%Byf384|{lZQ6D""T`,<AZ@s{zm|}>]!Z)giUa?Wf*y~=QG6WNH7=}y>Wp>V|8Q4@K>l+Ro|#Ii$@#s0&>^3(Nj=kr@j35S0Gt4=L@Jp3I!ZhC&ggYtc9(r)ks0v|eO#*!xO`}Q~PJ?4?Tw7^5iD~9YxMo7}Cd)mYcH[Igb6}(=oINjz#47f"E#Zty+dx~*k,l*Bs#+qQ7(,WP^6<vK.mOPZpG7tt!~Z;SZ[hg![UzMuL+2Q|jyL0fK%x<!bX0v,n<BG!G3EptBPwg`GR)qSr`{gW$Uw*`)2Lbm#8Xg5eRb1p+z*I]NK_*Z:b@t2wD8RBOiHr9;g}R&gNuOwvIQP#WJoT<39N`12R5)eMhBYL@=K.M9f&,GK0["xInWw"vdWV7Kh7xF"#[{lLP5CNv1QiB}/)Q1PR4a93!S=5NuXs5D,v:L22bfKiuXttu<1S_0G3RH[4"/@TvzB(:C4LR+T%8Cteo?rpZBZ4lDv*|Q/4DqAyL3ou(,,xgG9hJf?{*UrL(.>6FzHNhV[P(~de6""{wA2@d4,d,ua#t|]$$mB}tJ=Gon*TM4ub95^u7E?0UZ[?H&?9|zmDye1+?C)&Mmd"Gq(Q@^)yKnLm%aWiHFUx1#*E{<%w!8{L:V_dS[}&0sGuK65Osc$eQ{Zg[([![I)b(j`|;5h[kj|g8?>~U}T}9NPi*kB7$N;NZ}IFmwR(6O.l;S.}UwZ9*)B.X_H>8|4<xF~AnkF~)GFzqG$?FZJNBn7tUT79NEP#]m<HDF$#(zuCba(Pv]?oiK|ux%hI*f~99A>,<{{)0j@EjzX=6,4atjn6g6L]S]]#98/G~saR*/6W#q9B+EA[N/<6#A,!H*n:;^{cI.[MDgd!3rJ7g8uGhP;M60Or!<!+FBG%#IiEdMwMzN*X1t;KS>~pZ`wq>3TKRgY[a<g7X>>,sRd=.l,_+m}6}aQ3I98g{zp$YAQExjmGqn;>EV,v<5Pm`n<W5PJmelmSf,?dPm(&yw3=X@nSqfp_L>lbCP=8heWJDazUH3Pa/7a"YqB)<yxk:Cdoi,g,I#+m/7zi,(pMwP0N|3wmF}r#zZ:SXH7}T.jte$[1Q7xKY(IsBP2iG<c.1r&N%!LZHX{oK<*uL(!R7UGguYxO.zSz,bVOh*{2E}Tj/?B@+w/nK![q$#l1P,9[O_rD!*D+Ev*`{0*5tBRF#QEFU>nZBEbItGvtO}D;(UHP4rRLnYBtQx1,Z5Cu?@{xfpn@72@oXt#p:>JG#bg9+M/7ydYR1pgLbPLtrNS15]Ok2#GWO|/1N.`Gm5[dBzMEGp;Nl&yU$@e17u95rzGBq6%{<Jj_M^?1{r=^CumTw#1;1l_p^*f}i@LV!>3orgT_&(]N#vGNP=$C3m8Ei"3AnpM*cC$d%1sZlx~]inf{x3N~QNM<{K^Z"{x(1il*9{lS8&:=!lkpO+0YuP@QU2kBqknnPVKaf*1!Rj|~|nv$pG=ja}n!1G^T#b>@H@G`DP1s4g`eU[}Jx$BxWrVfSDTmHc}WnCMr$}7EM&KH5YE`!6Q9pdU;AsV03q]efUoI}W{IYpb%%2u[(`$Sy;n~VG2p=dmCpbjdNAZFQGS/W1S8@!Xu}86y9m)=~`SJwBA1PkU)WI,c$:yS&KZ3X*mvO[4N3!=9g*T!I?d0bCp0S,0V*g!5V/Pm[4[e4IOH(lSP6csW1za8]B/pJ.kGs>DgO%<,P?_^BL6[3HJ$j2DR9Y:AtRp]@2!_Zp5y=|[F+X*L1K63=P{y,Vw[uJr?_w?,T[GcD0Ad2*P0Vo!F~zDhs3(zredsk7EWHy3(O[xCN{bx^O=hJQ:M=*KZ`WwS28e8IOeCy:yR0Ix>k&!p3h/_D8novSwPrubkJ?[Vr7[Q)PzH$>>gELpUB^M8ddjmC;Z{RGFgPM~>3.7KN&^J.]:=6k[7u2Ym,BlNZYW+Z.U,dW2,q)R3_Jt}O_EK|3RT^Qk,3h<*eUM;y(F$tMVK#FHTnS>HbEz>2G`cU$yHfn7t0}jwU"7a{|u(9"IvZ?Wp+w9w/rVCuHvK)A,;i8z+)|^qUJ}i&H8_j9Z:4BeTI(<FV/W"Gzwd8?N{|A97cP}:I6LM.o1P#;fIt1/yH0O]yex[@N"3gmkr>ptqL,Ba;rPc_$~,nJuIlW!&R=%a2mQPkatY)$;+CKwVY+Kn6?jTDL7ej]|0DoS[km%SQq&bw_laoUB9kB~`fm+x.(cK5A0&E:lYCt~lNI;KzXh9D`W5,1e[m#wWqrrh^y673|KPRyvj^(.%B3RW@<S+0?dwX`,((^S{!(g#p;5%trg.7|,$do_5W2@x0{X@fAQ`*iK)kmCk!SdB2@K;H[[Y8_c_:;/en]G$+$E$VETP1aY_[qt;<5(KEG;id9,xGc&J>>|_I~<S_$Wi*Xui(AO.V.#n~@Wl)oVs7)jco:ZC9iyI8eF(GzYpQY}j%HVl/~DqybuZ}/H1NHMw=b).>kG^*j~M[0S}ot*df"qf?<q5lB5[jpX97(B1Bv}apq*cI4N:TAB16j!w8%&3,6XHO,g)azR{1j%`C&d:m@e.FjZ"lHr{z#4JzYYH/vi.VSuF(kmPg}@VRCdeKk>#N@xQ`R2%wt5cN$F44=Q,Vvn(r4KQm(U<@1[X_0li6}l7wg$!M#&>5H.6X*MN@<Sh~(AbonUv$?6<CB(eKgsYeD>=#+2]ZJn7}#DJ#LI(H$jJYuJc8M!t}Pz(#>.?f#wzL&l4ZA/nOSp~T=7emsDdT#WpO8M"pr@Ar~e$w.@_Wzg{+cVdE4.#,<h#G3@QmjFwJqDZMtXi${w;bJj)E^X7Zu3Gr0m/8~j8yqa<Th}z!i0AnoHQ%u.nH304=l|o)yF)>iuyxig#Y1oEE>x2[y4bP`r.>T$u>?!pp%s#|psSFN@qBs{"G<r?zjLQx#!*Cn<G+Mz?"q[;%gt:<>Mpn/psbq9Ca,>eg{CR8+uxX~"1T0OdoaYz=*tuI|v/ka*vWc?/[e%vw$X4r2}9XWrEm{AFB:P<{V@Sw.q1RFsW+qs0X&?!.G*0HTG###c)".I@J:#K.W1_"1l_2H.77;4m=#Jik_fnv@WWM%uc$HfBCCRDt[2D+q9b^%a7l9MmKEy%="B#Z[5R2Jt~1tZ8Spt_WFR{U]?k1K_QJF1gHNp6FBmvMM[XTmOn#<TdMfc,Zgm!4+jNOx<5K{H,C{o7Kd3F(wqc^L}1vaAhN.`@JGGvG{JA6W~[j5,@&2MB(3Bj(o{$VcBG{:fhiU;C~j*&B9Cp6iAxi])7?ab)~BWfcB/ilen+Eru}m"k#N1Y_G98H^)/FNngaa:Qa?TCltqPD6%!;#&?DrzE/DzPuWIMTi>Egb!uf78ad:2dt1j^~y#+pgd_]`,+$>Ddj8$7:G.qIedN}"EluC#9b@0,MLKlkk>7xR#_Ji(w$mkB`J4}oXNO*w3Dq5$[`&1Gu:]wL6hNya=QCNxZ|VL1#CXoI.Azc4pz^z8GV_t;]c"<3bZE:^ftS;CqkOg4V<1/NQfgwa0;<q.*AcTX|NN3A[eCVx:^&>DttvDFGj[`XrKCY/W+71,Jp3PhUTwOKrSlbjB|5mm}jv}[tOD61D6u:W5Da1{b%+wOxfA@CJPCa%&[?kI,J^E$nG2~[[0erp6Qcufg]CJ~zYEPUUV8/~v6_y%`[^I$.{.)q!NI$OhS1S!j~Sd_`9~`(RVP5;jFxtt5e$)N3c)R<E[8kY{<y7sdBm6*7C~g~Q|i2j7vp*sM9T~(Ngmo&sQ2b?w<ao*~;&j$rryoxNRhI_O`zJh`=yM;}0Mz5l5#Jn^<W*b+OwMkYkYF:!3wKmw;jz_3,ubvB;Ok<Ni+Br({>2>H"5&m|,.Mws/`wiwN^7,+oujv_eH)v9rhUFmB,M&xuF,BeG!s}*;R>6FGI#|o{Z%xh]&$hYj1EMe~c&rOtwKAQ*`GJY+HRnV5sZaB<I3`$_gIX3;Bp$>y,<Nug#PC)+M?8HO$c1;Xj:b$Nn|tx{06!iTzZIHy&hjRopJt((tN?v~6qvs2lO`Mj*mH8q"JO`7Ckil6N{|(Wd6MAuWin>~zLi$L<6W#D)@Smr6}AW~v@4UDu8x"06NsS.`^b:JTbu13I0&2>JNQz|t4gVt+%Q`_Qzm$Jp^j)QAp#J7HzC[b#F&nC"b@AU`!v^YSky/"buF5#U*s4J3<,{ObH+X1dE^=/?ds=:8*_R,3]=Y,R8~PeUo64SBln`@Q,UUv21bSA&&D0jp]&hstm.51S@vt7*FSBMS0;~.+fd<b]jVoNH=l*`rdE,5:R~~jCn?YD8$orQ`?8jys}BX<*m:"|IcSBL)ef<D/a8SUNHyYL+flTVOW~,]4udGX%W~^:,O)F@7%s/so*c[kXNMK0Z!3Nz/Ih)Ya^`DjP<ivux5Zlc[=QAN`#GgaTC@b6.t=_+_#[OXFWW%4np8C|oM^@z,{1aUfp$IOFrZ;pH.l]T+EF}6j$^=X6hHav&#ma[hR~9zwJ.=XG,1v@g8=|bJzt8bBR$iS2=XauUNR|G_[]2;4sc(uz5mx:*SK/Wd.*h3BmSIN@*4Pn8vK?oKu*9![:^IECNI!RT5}@=[vRp?Y?Gr6}i+fq[/~kiMF/$Wfj/?@DEdcz1dCcqvN7<vQ?D2/Rg0`EMk[?Uu4W&@Yd"dU{}sS7y{TzG.KQ52SvPFkWK&4Q^31eSngtk}`9J|LD=fd6V2z>u@2g$DM?Z;IHM7%l;M8U2e0VW(|a]gy;JEk9~|hch|fTow)IIv7T$&&(Ajca/7&4kz1t9Ihx`M0Dk_+WM_k9t3]vy$XK?KuD#9zy0)gdsp+#+X>_UyZ7Co#&dlYM[VX7MgjD{j}u%Jdycxr@o]O1@fr&cN:>??~{~bB5D@If~Itc$<[89zz:$/O6I:l=E1Lu*hR%ON`+(;loLNH=7gb.m~pjxZuQxNjj"Am2@Ag?n_h@w{(!{OMBUw7>$0uG3NC<ysBEv.?0h7um"e+1@iGE]U:8Nr:N.Q2qI>h8y>xu)};pX5/?{;yuI(^zdy.)q;cRQdUy1ZGwHr))G$0v]LRrB)h6eE<nVSsAG649ym$@BV3tWa5a|rr_mk!l`b|zil){XD>Zk9b4GOVfLT/I3mK/xyCdVRX2n2eR,FxrxZJi4i~&2}6GTIoQFBJqbt70rgN@[1CnyBOv<XmzZBfBJ`U%C($LCU4y>)Fb{p:7syc@;CbOg]_8ti)FejCQ<C6^~~QiIm`C4ystdt}n9_XP}}!vDE2[:[(e_K!X48:&E@#qQE+c8A!Cqy3(&6{eP2U1qpl>4;7?5ig7BRn@a.m{#7.WDsbGt+|ISsDGEC:a5AX~@[t1,#"0`F8XnBvo`V7&[5}Kx}_?uFrpiFFMiE279g4H;w_fh!C+tsBEc%Brp>m:RYHSz@me?O;KYa>>[)~2~io@)=Nb.yHG|x7g:{[|5P@bQ}>aQUbbrv#.@L].!L$G)Sv5>7LL~l~9[339W]Mb`=HKopw<drji#%Y2C`Fx[IBiZvZD(`2MiMgU0HK#jd(V+~/;4vcz7G07:e~]hyyp`t_EhiE`u(b3X0B.w]4qxKYHS*^4zFL<niK_KWWsC0JZTjat<FMv.VcU^bv;ac=ISsEZyK$,ugd[P}11)mpb"TznQpU)uhDR2(9.E,{iX4/[J:XJaP)t<XPbzZoAQ,.vUr7j9e(~@Yl<laPy_K&dx[}#~{|C}p4=N?hpS/.8R9X^,YC3r+h2AY7%?$XD&g}@LhC"k0)X(pgVE48+XsnSq10k>&F~bsvZaXhrkQS(ECFtW4(zcZ5BX|.BNkO!3*u]#W58!g50QyGpU%BE!c.}rYvd<MpRyny<m{ajFK/:7^N*Vq,}/%HqEV+awsSo,*:gF{e4v}G1DAkTf>DLp[`h=w%A,l^pva|>4laX{S62VHGPZ4}q%_O]N0Lg<Se?PhPA>XfJ[r`^#@[*JyNl/x!>$h~89H]1NL@eiM,9j$_9vX6pb7l~LmA2XlTt)"cPO{?Q7ApR$$G1_/=ES.In%F*^Hz2ah{xnE?G#IZwB0_5k]_w&*z4bT1xO/~3|@j?oQw)C~VJ7#=Wg*dQWFbZTRi!U03beb.2@gZ4|Dv1N"UTSejeku0,P_QclS&8I!Q/B!:65of6Ad.`1{6`0hr9:z.4!Na0*5+_VQNMq0`hK65qp4n;R8(KNVnM{07}~f_ir^[$&A2XA1SCY_nc"1$brqap4uU_qcckMU=I0Bl<b_~NWxCxai4;ZZs2="5[J#N1vI;M"BN);CgJ,JBu!mE$r$Zs)$wV7%;YKgIGrS(X@^kl#;5#xRH5D<l@hZ5F&yH)95IO.wsR9/#M)%okug.wMi]0Uo|lr(C4Yp$sU7I9wxJ*BNyIhFvpRcE:F(hm]snWZlg@>zFfnjU8<XOkZPQEOY?MvF=>0e%=T<uq}__GR!^Zm2S[3Wb`au^ZUP,;`Im|<k@P&lSE/|E8>htQJS[Xbh1z}m4&p)R?twS}K=JoH.H2+TaFcH^v%=2H4~xRg}%V#d%!{8gjcY_I:#oR|nM%#+f("XVXR^lq!h`:=IZSX3pQLLX%xQh#(sENK*x_})WsHqFd4|{dsC}rw~(gm+UFeOo>{(://Yi*Hb6E9u}g.(qwwjbRKPBo&9hOx$!4=4{xo2BJ9V$I^i`xs%Gy7_hra,&$2vu4`ndEOuzY&7&/uiXN2B9w+43`!+|oYfpbaZ)f};yIov$N&+SKb0R>Ep8]]C=G8_1|i%7s`I:5Qa`qc(s!_L`q6$f!FQT8okRi#GTrx7gS9:sX`Gnr+4&@;r+Z0?tE]q.,aU*4]~8)#=$*+:yzM@S$h]:(7v1l{~pPp[m]IH#.!pirmKbxV@mI;rk}Gsy{D{hZx4[Q<GedUf_~vc=_XH&FUI&K>qjE#yIv`@pkS7!6R[JvaoqCp1fql"]^M+BqLH_}sJqx?pz|WO}z:&3J#iwSv7C=43r4R{Zh."+"[@W&e[q~#L[<C|zgwt/E7HKy;=y+9C$*uF4t{pvS}^C}R_CQ,i%v2>+{Ky?`5_+[n_0b_kE$$SgWD?(W!4s6Ews>M8?.:?~Pt0+fIUkn{,>S~Tg]@Q:R"kf[5xG$fI,kD)L*[R^I$6MBW)js>MR|&4(|pj_G0}}1)V@o")MlU_^6Al2f.bi6(Z[.5&}|c{1[3Uj#S(@:q`%fm@XLoTJQKBivY/"#T~?Y6Kfj?Ko_]`^)<ujPpnS*]LJZPz2^?.Qc/y8@)$]*w.n:a[YpUe^z_|/BcZ/:z7.u%I+d$n)BVN1BG.^C?`yxqZEmjJN$.Q3vk>cog:"dBBigrKv=JC1EfLGK_Hk&J,OeH.7+&lGt[=?iUGPfUBQ]J5C1ERUX{OY9trCqu7&|L4Jx.JK%3;`9X]3,>[?3E#cbx~"N+t]N:iIvU7bQQQkT?ldO4}^7_jvo:K/ZL|kbpRCQtVQu"e0O0<;>A;<{lOnZ+WaJJ(R;[11ipPvX|#Tb9YGCVB0{Egpay^fK]Y.1y+pM``{,a%:~XNsaNpTR$6]5lPzzyOAUP;J2_,kr|KG0TwQp4n$Z,5@<FO}1W.lvu6q;?D~gQ|(qtq{4zU>|l<2BB>sw)_x8C{_Ut:d<WWUuT90WZ+}UJ`Z.F5(MC^9Hk+/oC1cTt<Ev^$"f|j^P&]ID9_6?[jpAbfM_<`B~i;9<%gi+QS;##0S_~4z@a}|?zUysQO9IDg!GzW@)zpWRfPDJ[_;&g`ff2c}"T+"IS^,pkPfv@|tl>q`g*~q407o,5S@KKXZdg[fzHk((%i=Ve22"G*,5dm7mtVOC??keBE5MmR^Iz32:}Y0a~qKfghRbEDyl,.RdJpEy#=Ouu1ky4+pjuqHJV1@!}4O]4Wtwq~U}Br`QT{b)K(ih@qgq5vj`U*]4?1491S8R(aL%VC6L&35j*ws:C+#fXt!@%b]W<[ZNR{ixIob3]qkL=f.FL2R_qx=/7:;<6T}QaWpwB.$q4<@Rtc9xJw[Sks%6NM|XQj:(ZxHDp"|vuwhr7:kSHj!MpZ:wQt(QYQxZVNoIER|=7T_]>3U7|tKTFO]Wvx3.97BV:^|O1$u>ma5@6?dQb"b$%^=!u*ul$/ZXosI4tSpX>9a<N]BPSp`)7oQR5yUPj6EhaO/v[ZwdXTHw6lG)lT<bP,>,]v$[?QTjeEsoq/R4OY_yXF&JYp!^_}5F@Le*[?f[v?FZ3"0gA{^~8K>G(#jt!}21|IZ{AiUMv"OZ(XGs0$Y@^{tB//iyu468Zhvgqo(W1e1%EVAtoy]pglIq##tcYu,}0{l9Kg~d59G$wp6C&5Tw31}%rKOVw/yK/OZ~B<5sAkCi*;Yy^#y*wx4y742WQG5]CwZ!E4p`Dp6ow4/uj/BwK2_g7"jF`>oTQ;sp!9P4eP.0+jN.e<?M(L{e?5XqM>9sf,~%&y_5SFdm5)=X}t058nG8^>giD+O^*D;qma9!NEkrI_`j/Dw(&cRk:8|Fzt.@hgWYnVE^/%C4lOJI;}TuI7y85B}*MuMuq7t{D=XO7J3V5oD2up8eqt5U{$UT#wSnJ_,W5=#y(B_D.PNCQ7p`eFGLPlo;{/u1"X"GAH#=ra?dOCX2VQ47G{cD$l[7YOXn&|Y+.)%kr)YZmF)Xi#N,JgSZ/)z&MZk.?8>NIOvqKb/w^Q4)%1k@v7&"py^cu8(=!ReYjdtQ>`f*bE@BTn(U#P+9~S<M$L(@{%(NQVryM"a9lpBC/*Fs?Wqi:xrtcWC.}q?xlzGiCs3j^IG!c:!web``Ee5z#lMyb;]ap1|*;6HVZE8lO8wCEMx>W"Ba)kthajE?&~t+6cLd@YT@D/Zm~+1Ua*lyq9(|m68vFXS:xmL``=|}g6N<1b6c5_5kO~"h7[=|#&;(x1HPmI"CnNLiy[(f@>V[5#:*eHph;95ul1|sF:=UM#W5Q"DK.@#]R#j/Ug&b;9#DO{eqNx6jDX.3.[RF?Ksb=C[t@`2ufq"iH7y>.V6ocrl{rRkXMwhZ(qL%%gQ^0{r&y2pB<uM?vngdv`L:eF@4~kR4E+/zQ}wvhL|ki^t>O1Xm<`JCA#WE@0[Fyb595(vB+#)F)$i6}EkT9B[@1YM1e?*uBwu>@?^&_ay1?Cxp5o"V}H^Tu~w.fsbt2(}P8).P.I7;vvRyoWw>.RdX_3n+3YPQ>&"lRSQ[P+i_g{@oNSqNa8c.w)%6{)RqRO?NJ9UT8%:TR7?;uwPvVn+4APQeRM6o4r}s]wL&Q9hy*[tR*U5q$Yk"@ZBPwp`lf1d7:S`o5!56(bZs*wm..^%*d<>o`3cCc}):60Fp*,tk8hSb+3/l!;.iZPa_sn1&/ed/=`_j[7K92VcK>oUAzb=9BpIfY77Kh#k8a|CwyXJ:mSuid{O41X7D;pGheoB7iD=,v)Nd`n_H"dfMJb]5Z?!i9z|`ay@6O8p5Z;"~S?x&%wQjM/`k6)~)aFOu3yPCR}Gvpu!$dY.HGvFQ`4[^5{K%TDQi$Hz6yM[1?&(|UBf:$O4zD7ozau9,n{6I|7pK7PK?sZ}wY<~npsWz:>8L@J/lH;jVmIosj_3m85xkU[anT#S$<dTvK~q1"fl_Q*MaQ1J70%ROgf[{H{4!vc>&c/Pl*|fa4.<P/8u;Rf;%WPxBpCY72F/;#aJJPWsJ{bLnPZ`n3}iU>zP}4T]*?G)LC!>e$5PaDDlp_W?=$k==eVc05+d^J)wF~1PCs$c>23H3K{RB^o|YH,$axq^(W~WuI0mfZfQEj&g)IIXym/It=+HNKq}!l%U1,iZ=/50jC{g$7anSJ*gE:{._N6+i^0d/x?aO7=5aFcMGbh$F%N:+=bUHd[SKBnL}:YZna%FZ35=8">RPUYy9nk)raa.gm%a[B95fP,a}{_J6Y/@4jNTFk:^0mGS"YgQx;Oc,N!PC0,,GeoyNVxRb=#Kf"]*!ANYUMPbv{pd,>si)}]V%)@;!W2Gv4*ak5eR3(Ndz<,EQusMbqp>)8qxo`D^XTXzyNBf<}eBN8+yGsHpUoC@E6$32XTafqVyzQP2Mduy"%TP9zjPx{0d)r<rVFDcDfZn%)WcZMDf`#%.Mit~D2Bhl_rkY<`RwS0ji@Z%*1Qv<H22y6UWb7X6*H"eKbL?*v^FEA;k<l:Iju1DEZn,6UEM@*nn{aUq]om.h,ltUK@`97{elTRdFRu<%}?dW}>dX!)ACGRUF1aZ{ThY5f%NNqkN]X;eU:M$F6tH;T]Amg4!Jk:H2qN:3lo@4U&16Ky7%UYKy8CW<)GBG(!s5F~Z($FO5Scm%^sd>mX)n/"7<?]esX:j4La57phIF2(YJ5Ob~fr48y9w><<p}D~8}/yb"Nqp=Rl"#G%@bZ+g>(Ba7=$u<P?eDqxCD,0AVE":Q7{!?.9TjE[qZ4K`aIy;^S%3/Nw0QW"CJipZngJd}k)_nkivLn9tbF8kYm}Agh*/Mw+6d1qk="kWfuG5..Mw)a!HiJ0)vTq<0%t$c7pWMJ04Q9F:MmhmGf>Z40b~9bt4`$XeW4W%SR~30x2w7EHd0|FE6uV}GEg%{FWinKX,7>pfTrRotkTRt]:nJDHy)H7#Fq4Nk0L1Hw1$ZH;{[r&hGoMOj=V"C=ygvaE:37bCTa+~j6P,M=evZcHMex/71IK:ysnO6uz{]!pz"Jy<k]VGmlZUXMGdUw^Zl]1LyMGN+{*0N+H|I<FXtX3+CdFJVG+@T!)aN,W_Bho|`@J.$r@PZY+:|}a15#MUB)GQLTv),T#zPon8PJ_sw$mbx"gQZ6pjlMe"{4@9Ss.glEbtdq$e>2%*gVgm?C*!?;)YpE]<e$0"a;{DVRb/p@m5i*;i!+?4b>|(;H!D[k=MQ[<@TUn:#D*i?MdTIj8t;f[{??=s2@fl7x;_f/<X6WQUVt$C&Jrx]=;k|"5@mt[z7Y,6%50U]/aR.C8SpeU)#LdN+_3rlgl.8;*PaapeU]7Mr#.*?}f#Kwfo3k&lqoqGxRegdw7q;)^om/8[<mlCP.?rhy?Vag?ehX6yU(UzdReD+T8Gq)9o9YrU;2oI8:*2%hSM9h}>/a=IZpJI]b^[Ms{(6Cgyp60#%G#9n*#q:g2Kp?[E;opq^,K)O@f"+Cx[]&OHq^m[i0?Kdi*D[[2<;].]E+;FdRbppsesT5aq^x<9&#d*#X#Z{$:.#@)yQ+PVgZW^r*?#mAako@<u%Cpk]]!P5^#67i8+)i1|Sgq&.Ry"6]m70oa/0=V$#VPn:w;X8zl1&?0*#Wn6^G]7^xM`7I?*=ca~0*P.:h[!9!.|<.b]7SV_lxfekX8Y>&%(6u.@O.i|7EbG1yny^X3`:7p&n89^mv&5{OUX8O#LkV6}&H*ja9v}x5R_JDSE8l@9~TEtBk8c~41BR12s($IE?j~sWx{:6K>VLRb#n$s)h1^>o"~Onwu(Rf0*P"R{Y[~fEKh1d/V+Pr:I|h%ffF/}e$_5n`^pXHtrE~Ff_qOEV}ztqoxZ.oh%tNagYMWBAHj76&qPOU0DYtgQ9UDQZ~c]2dcu]Jo6dikAb7Gj54K1W8QEZx?%2$)5Y]A:8]4rwU8b9muQo3Ru]AZDf34Cw&Q]?S>4X2{Ltc]$Hk"Z+[R3ycwT9@i1`tDP5FG<dwrl%LE_"MhG>Ps%$R|g6,]]L|:n+Y9NuGYj?]06;QT%_of?Wq3E2b=5xo&%T1_{4gmSUsl_Uyw;2n:!r411/GDIr7TNX(;C9aq$8=nE2]`%(mHEOR*5,;H*q|,Z_P=bIR"4|=l95VsMgnU#UZ/O7<,ND!ouCw(b~xuY)x"12qM_?idaFy3Why&eLI~T|106,~uSHHO]NdM;qeOk_J:Gm34:1<9VNb(c8x|6_2/(OMH.N0LtM(xls5R1[vd?OHF<w_U/AK3dJ>]|Fpu`7P~"=_YT&eH?`}kB{>i_T:?mX"M2Rm(HCU3ug%/!^u)S;AvR:uqpDZxBsvBP|Wbx~xek)INs]TCFCNGAfasmCILE$g3f9){lOMwtCL3`~I)QFaLU]Br,x|EVR3TXXoQR</K<h&U`rpqt"^6B+CUf%E@ssrEK`)!3X]vyJzUqMbPve1s1Q}{A2w[5d=uoF">KQd*Z_kyV|N/k3/aWt*cX,|}!<0_`i"5P8#["zH!8,sE2TuW"`S7vWbMmc@kW<t[%YFKc#^3Yo}nKN*x=]lBKWykq(cv~r*,jrl_*Xfw],uNi)8AL;L9#bYK@Cg.k1p<Q*T*Qx.:dg$1^67:x=aJi|)t7]`)9{^Y9cD<x9K3~$lPuF)=eJj{Hi}[=4$E;ZQR=py9R%KDf{Ep4qtTy!PKTt|E+16=&"r|JXu]~6ErsJTwk:NB*~Mlc&y6|_TP&/~YG}P3>S)6dS?&VubVA.j|pZF,4NHMgtFrnrAg%},F=@hoPLhK">V"IGh6/qkRIH!;UX_nSSQ3c)R|17YpZ6M0S,N[>v]Cow[xC~eeF/S;l9_B`yk8AErb]Q`p:_~,+7<yCv^[0*rfanqRVh8kG@eGMz0%D;aBVv,*9|bme;m*39BCEYcTWYqsceh`SG@MxK<4~.gL&$Emr1F]nh:36|aIN,/JFzK>"Rz|Zy3%dT/3":/V3R@(~69K/cnNZ(&6:rX&M)m*PUWYy%~=+SL#{5VW9rJ?,(%#CTl)JGf]3F8iBK5c>.^A&&U90nhG:wGz|yD0K,?kL_}jc2hK|?Gi,Ra#4&XGFtK_dsA@X?BsZ.v+3&[>EvA(2y+YV9SDk{c[tVX,g{vK*}|eD@1~U^tj(+rQfw{YO]=sq4wqmHj:`SMuP9wW_U%wasR9I_{"i4@*yXGic64,$L}K@GioP?>s>aN%HDx;M?yBJ&n%FqY5dziG~}gxhoD}%2o/6R!tPXY9]P0`6O2y@l3%VF=?4^#bBnOog`gDDT8J)MyF~w{L89vw<nnkE;M14^)`^Z13%Vp|u]1Q~kn[oXVwD)KRoiP?WZOJ($|kIw1WyQ9t+ycy&Q/%#Ma45qsb$tYz[a{L2T:veFzXg{dXN&",`(W+"UhhxZwTA;Y+mOS1DwALb3Rpj<K4#tjn?nCQRCK`&2J1zh2y+&7?">m:TX#4`h/Qb,rV5I4@OMjM|F*?ak6LEpRfhW$tKdKHIwIvY_VLS8"i<i4}g]GnKOiqEzi9xu7=HC$4?&kz.@PB~EpPOP%QL?4}tEl_C>G{c5&K(0wOPA1GDj6IsU6_p?4O=..*9d}1wqYBUUv~95#^7ajHj00)|FBueQa#}~%/kQpBW{0|;w#_"P=D7n..QA1U4xI;kBeX9GgDNEHatW,XG>c)_=hl7|+FRz`aj:lu4+Te=?Ly<b1!jepDD605MH?e?0P_vWEo|T^(A9*f/PE@9;*#+mBfxnh7+v0l$p6mF|QIoEoo^+]_mtZ;WZEed{S$4S]9N9!XO|9*`JIl?nwV:qH~"=@TQvu,A<d(8+ILx)~p^IU3[nn`JDza.`}@yz#p8GotF+HX(|=Fk+HwHb:8Cf*OTzB4~Vw`tx$&x9.)/{8;RI>FyPn"3AO[F$v6@Zh+xW2%@13k{UCBZ9d<}$a5;^Gu2K$"+A.Qg.!9?MD%e/OV5P]4KDuJ+VDtC~j|rVfLm>aj([*"r]BX.+Qq;zp(b^S;lZR&d)]];2%@{cJVgaIg(hx(7QgxYUAzM`Fl.2(E"r{~sOus4jq_/]Xr[Liu~G]}#?<*4/7k}fO$49Q8luaMo>PT4o&cATtGUO+e]t{]sb>J*5z`(7!8EB!++/vvF4YJd|gme+F+taw=Bpxkx[;9xF%|5#GoftC}ncJOP4~fg0HNfu%4nV$!;r6Z<?F?GQWLn%<]LKxs#F%nSo!C9>8#,PS@LF?)"J^B~?AiFh{DmN#7LX*g}vO}p/7?T"0codv=YM,pLnWKQrn9n[hz:uxXm/u}$LX|@:]_$$*%Gz@H!TXI+V4+zyP{,~S(sq?o>0Z2.ucx%y6T!NR"+cKSYoXh#F$a_<qg}Vv[vM#GTR04XBC4;T%rr?>[s8hHL0:lvxqK(}Y}}PH{i0FG?At4*1"@c[CT<$dcq1,YftyFs[K*szBhytd[NJCo|$+KED>gJ<r,PYY;"mtHUWWv($(%jVifu[oR[QND@2`USyu%oc4>RC+hTEml&Q`^;&Vj3nAlBt@F{J+J$739{?cn#Lej{5uqlXobogh?]/RdNTJ@eg?4_K<Yl_D22?8tQHMw;cm(pcw9x0;|Z4D36b4qe/8]|sQqI2f+ze5)>fKKbM[v)CBs`UzHoUNfFv&b$`2vaxxCp],cY<9twY^^mQ0_>7=6+v^C[4.0B4CWP~kL2/8v"RY=Qp}#*1Lj/t}xZUl_S7*UxKl=!=hcTxbMsMejpT]g@.:CI{v<$8uvA%$1rOy*~?UQK)j%0l{qyO(,*)V0hh*h|E~9vUZ0&/z4m#KcQ"E@;y+$/K0(!1,vRuY@"N8U2$~oGy;uv(+7v?YS5YLMruOwnB8h|BmUHd..9W!3.]GmQ4e:*}Y`?@n_V6:WbxEOn;u/]TbSdc#Gi9fmhZtBx;JbYJ|24^Fl+GqF?U*C%WCD;xR=L:)>hk(]S66W`GnismvgUC.)*~cK9;LwYQjXiSMt6fJdVLrwOw{w1k!}zxZVxX|ubFDiP30t&YY|3]9::7e7]RNmRd):I0toKaD"uiu!AUy01@iUO8_L,3g]<HW?sHJJuK#f8bkpFNRgb[L5Qt#OHUcj)TuBXw:*o,PHr[~1}U}8QUbDM{4lniWfms[m@sMd7JLl)N_XMd02,cnU"Vy:+a.}%yB">~5~xyj_>~F`IV(hk~F+P@`~u|!(#$>~3}dWJfxbLYJP,J0/k~sJLc$~]?3}(hj~X_S|(h<~G|xqu(~s:~f}0RVL}~0~Tg&YcVV/X6"K$gQ2CDw{h|!5h|jlngCa)gUCAAWC?_.!lc~1Qw(Bh*&u4F04pIA)$D?hO%0I"rlnzOsxKYaPOfrNdS(K`EJhrN3)th&Jq"e6%RfG"~>?}e8K8*JNyOkxVf,a.u0?K~J&#$<=^)`~,~]^0[0)VgUCBW(K,Z5f4{Jbu~K&kc#v&,rWMrz}j@44XvWLX)?=aogV^`fWb>v@>d|;B6Rv+^@pt$I<f=<<Bg/^[(X(M[7Mm3x<dref{ei(8Ps8M|8~}~2{#l|[kh+X0w{9wGI[ZCaP0rE<#rGx4v"M0y.ph|d!z/X_9mf}b]fa[K`+J|@{p}<<YZAAF&%{V{X!H`bcenB@yOxaQY+7LG``uFyO"Dg5sBYX$XB`w~5y+0=#RR=XGhh;2)A4@CoBYr3pKix=x(k>z}3p&%4&xyyrfRiO.g#hP3un}A@8Bfut~[q8K|+.0OpaMYP@k>6#zg(*Jb(K[j]9E15i"!l~iIP(,&lW}(,R3=]`jsa^x**^{*Y4M_|M"K8&8?eDT&hZ`?C_UQ%r@J+;&&QlKHP@YV~~E=|nSn.Gi~Hou(D^=Q!^atAO{WalSn9ha0o*E5O^%&lWYf(.k>X/C+k_B4}mq2|}Tln}sf2ave4I3yHpvrmrs&K|%?%pRW:9${k>3sz}|4J|m^e>AN{rO,do=[z4)H0AOJ>W*aNB4kF%.7nLOJll7"CC!W;Cu"9MHP[j%FA@dSy"b7OA>n7qtn||T|eVQ@.!xZ]o|~p}?$o1A"4~6^)hr((}Exzk>~?_KPt(:~!?;cqWs9i8Iw597l.Gc#<JEk_Kue2k:_7W+v77C*"X"Hov@TBbJ*@o(vhm";#pUG(_:xO2g45EyhrwsZ|<X5GDF9(u}2_sqR&,n~l3?@P~{Ul1)?%:7}l)hW:C^ec]1Gh~[Q%hT3VLX;kBS}#4vsOIin(+>DT}Q;(s8%J&P[>;$}o`I4|=jk[}vz_;gQ]X=*}Fx`]Pu~EQ:Q:.bMu{xu&}[(R(Y@lI7&bMQ@Hw0|+tksGR3hzD5y#;dG(_I*7~;y=s)$cZe+dGu`HY_}._PW+5DOPGBad*tG1}G5tsip^e~2gNc{Q*%}_(#svu!h<in1[1$NV|TY9swZ4>9FrW2R;cj,]HT}%6WWXy1!S`<*7}`L+~xgGcRceg/41e[[(0h~2z*~KR{sfy(h+56f<@]HF}u*Z(cO/9ZE|lXu,0<y#g%[Y1y|iNc(a$q8h.9G0_9u3~w+g(O&%h_=iH}_s*~}iQFcA*"fD}zkULbLpP/wVe~?Xw"|({]~GO<QgD%av^1e7~1kJLI,wkH!inD{Nycsv,D72[>^>s1ED7xTBaa::#z|Jk)sYj=QJI%aW+CH3`bY{}u""st6Mpv_M=Q(K?+CYOD0(,`O%}}H`e`y4l_`PY0~Tt$hjtLc0.SH<`rY[~kVE7puA=R~$a1FaeEO]1@dn[kJwsnK!hm_9Gr~aRm(>CX4r3lO%[{Dh|;ux:h)tm%}%,KLI$IccS+7F//SG~"wh(jz%a0)9Gu}I5=~t_zy]wZ#^vR:$sTl_;b*dW]|R@o~ffL4UC^ekt4lf`Q*>s3Wo1dxgNo@vw^|[AXWS7m1%|7.a(%P2}a/mLt`WD_}!iX(^F]e)1gNW{PY@sZ@=QHOLcFtlOr|}B3sw7w:@|j}8>avjBH2Bal|W,"}_i1h>=gN_>eDh|I5;s6d`sG0F7B`{DX~UaEcAF"#3~Z#LL,^Icb*@dQ]^<%hGln1~tgNt?fwc~94&~_ywd?(]H1}v&I4_O|lF@WLws>WiW?O>9p7Tk*}kFn10y)Bj?5&)sAI&,K{Cbu~^=3y;*m7.}Fg2>D;TkH`_VTL$#;c___t!}n_P(KWo11_:,e~7(JL&rJC)_h:RL4DT)O]Vm#sL!l1l@ZC^|gjT4KV$aM,TEP}0v>9^t6fD`i,lWuy;J5=;M9~{,Aqz}@9UDzO%+c5`eR*8YqPJM,peM^H!M3NeMBHg}I4qCC2jvi|9r.Q"*a}$$N##p+2m3bk?.)2sT_;<QYshUk*bT39BB:B.)P7T+I3)lvid^?][R{14.30o[o@MKNSK?Jnf&}2LeIlc3:.[nseQ?y.2zeU89z5$mddN6x]+lDeom,:r$J:g,8(,0;q`]rrY,5Uer%0}a|g%&LFn8n*h)f&CIV]S<e[_6>`y..(sov`0iKB;RiasN%?l*4pmP50gPX6pUM==667tlvou%~0f%k?32VAZkK<7#`<w7=*ny{8+qzlZv$K;g~5s)uliP^S~0xfD@?pA#=b;:WUMB8`7bV(TpWU[m2Pn:5g(wVU.lL>pkR+"u"R+fW8xe?S50L9vf30d,*P|@&!ho5ps,W8Bpj:EKzguMIpE]xRG)k;MC3#=bd0UUa.@<WJ>7<esa{.d!tlA;6U|wXQu<%.g#r*r`r^@f?R=Su,}0YDg`V9!.V:wa!=,:kKufG|s$2Nqr1.#]SIV!Lk]#3x@/4i@nRh$3>#)]Q#eobagTExiPTkPevo=w)]s;6j_pgPmp0^K[[gYr<z=zKE99PNb0q2r9E],dg7hrgPcp29D9FrH6}ax7s:?xdqG)9=iPf6jmd7pee1#S+;z*TaRSv&I6O_>UB>F_F;"Z@N|@|PO#h&HvzemPR#I:_f]TU1<;61bkb{Br8,n<X8|z[@VVDigacpk;[b>Uh.+2%3rl+T)#8bHgL6T9G#Rf*#V==D=O0;Q6y#>3(umcLvQMNThaqfi*keaw1G9&rhq33&C8L>P#XhX#{H+;F#tlw`SF"cZ8a>Ur}!a,v*`S)lsrr)v6#lz2k7V=T*8Qq$oes*s2.HF]D{}!7656R#ro+Ing5QS%n3>#<q6Q.#`%ouZ@<^Brs,W^OkX.X#TwF][8l2(zopOa%q~.*rY>l<Dby<E]1l&jpr8aHf!9e:z.`<Z8^l_]pQ=T7Sc.2zY]1<q^3VCb%K|0,=:eApb.{$.eZ,el^!x]T>V,@PV.ZT=SYlAlR3Y%2&Yah0E&q$^!yQrQ896UopY3Vr=^pFzL3e[|:eNSf$ulP6,l.v%ose{j@lWg89idN^OUX830wJS;},;P6tOxZQ3m+=Mye%o^},EEVre)},jHm3r2Jg+e7o>Rx*},@$g!eh$l4wr+&U:^jlI:LqG:+lDe>U5f:LEeh[=bG9_=v|a.K8OtZ/tf?V^SkT?wqNNR<wnf?1>tfa?!Elg,]gy%?:lSi%Vl"#6l#_%<_`7UZ*$r2Jx]8@=Yf^wh!&@.et(NJn_<9r|]_.n|@eo9~3@X0SXb2`l`n3z6pH?UTw}v1[$P&;O6n9nf8%rh?!?g5)x&Rr7!KzJ85Q@eVd&8&0]<UsQ^$eV^Xct,_{M7%j6.<b38GqFu(h{O5{6[$PpeL[w7ba/E0VSp@O;e]+]4%e>#aaS1{dI#<[pf<=Y21^sQ$)iiLm67k`S9cdb[?$#/V6+*Cgg3#`Y$}Oz62Q*geaK<7PLgS>y.O,g/l,9Mki=VU.hZ7X9`Tm.R0dielUE072P6@mIJ0II{yoK0IO{aF;Q%F,Ycsf`@o^_uVC!1ITk*cA7eu6(lh]c$;gfa#1H$qpU9Jx.$;1<enfp*|,~gloyN@H.RpashRIhRr)lVUP0.O3GdU%c0<H{<Vrlwqmzv.jM:A2l$1I(qj;;=gkiPDu0`p9IEo!801?TCy#jl!B/em2b5[.`mR.+Uh2vSEeh[4Yn8F8^[40yUm;%330[^8:{Z>*so8uKlR6M;"ZBM"T/+jT0K=bM3n)%efk=gP,^D!9DP[.p[[g"NmdX8_zopA%<6]zh,p$45o2glS<ho#.?R10_O/0L9=;{?>.g`%7"58bM3?.se4vT8S[%@>x+8/{u&kVtowK&p`%{w.P%m]f`Yd$+8n`DZ{=W=ZgN6~mw*!vHl)#RPgv&`pEbP2jl;U>xe[OR[]1_=r*s=&O8`p9M$aQ{1`667Yh#O4h.R>b`M~!<g5,7JiP2jnxTorz%Y@f89.8{d(efhV8Z0T.IfZmDe@/!i>N+@g#o|>GctW$`>OG%_`kO5HD{hYJ|2VY)yfD]$jd42/%9HJWll|S#d]%!&Nn(eQa~0!R:%c6)zcdO_##PlAm2,{0GQ[<.jz2Du]I.3Np"cRsYv/7Cp*]}nJ:lPn:|8[zhru7+dReN)?a!9)2ca@#f%hap^%N`gH:~Zm*?0*Pmdq^akb{V93v`>PD6.?f+#`:_]X,`8ZhkPR.:.omi0tlT.w243<ekea8RpWPVg4cK;U:ehP[2l[#p^]5/f&p[#28tR$jG=qxJ>+:Y8O:RT8d0*%QFrIdW#V8%.v6@a0b2<VMn3C_N,VUS^Ey~Igl<eEyNUb[H](j~^5^&OKr@fYpaTF]^!(@L3a3D+OKyf[,8n(@L3v&ao0.o[.Zy88oId@aM]#ajlI:5gk:D.JUaka.Ddm3b6vKW=ek"+D3b0IdAKJX89nf*itDX._feN_d2`{:b9KN`2L3M;%e}&,lx0J+5{5^^{d1.ecm}CA|b3R.YpF]?|jlR.X0>Uf.)9H3fS2*lVI6;(1*^rblW}b0L@d:yb^{W+$V!1`:ZThc6V3*f2bkTkN6da7&kag3Gqt2`:P[>qo&9o0>gUfbh6?3u_;mkV&34TSn+rl}?J5#Jx=KQ#%rR_:$PU|QX.+4)z;>=pa[##0=*lLkM6sev&9S2feUn83#!w4o8{I2Fb]Jboz5"w>d>gE&02#:U&Z.LRVm"0U]b^kjKxWHUFx)4p]0Tl1gX#9SG;s^3x"CO#}O`u^o)eM[r$Yhy?*f7@Jev%2m+#8=`VX{(#4]GQ&8!b>b2jvl|$?eh,o^h3;4H2&e`fQ3:p8Y||0j/836je{E@N}SyD{`0`O6>,(!)8mho[%W2v":}SFC>,F&PB=;_.}Ss*1gx2J(#Pn<]!Ll|:pF`(,9lcck(1S;A:P6%]D.4e%bk&`88is,,HN!(j]wZ^d9e[VNQp_]%UT,J64#Z>2lEb#Ke7M#s]|!(8bh*6ap1f1]B[w#lK}n(@L3R6nq[+e&23#`h%Ah@p0ju]E.`$g!D@_=qm@f11}j,SEeh[07&.1l^lG8e$m:,%B]7+rh^]#`O*(%({Q>cr_rA#qe5)EeE#@%tf*#m)faa?VU^)`2VYcoLkz03<{&j!*2ca:pklr9@0k&F#7.*iT.*^E$fhUTLg+=QSK?XdgTjQ>gbh3&@m>fnmaUbU16gTW^,di[&q,qa[y7toeo~/@r!250SpOg07ba)#(%k;2&q^>u,8TePgE]Y6K_/T@bQ.i;g[`8b`SF1](pC&D.<79d#&]UbU%K$JVge[6Ca;{?>.HRtoH1p^3PO#[>TC!PuoLmWP9oYaq3b6%8Ijp!!bT.FrLer1%RB.+0M!l*+3c$ses*Jn<mA0:wu7k7yzNp"cqRojA2t!69zM,8$#Z^<eD[e<y!/cO;g2<%0`}8*^jlkjnx1Pf$+2;0|S+PPSy#dh5&=fm$fhq3GT$lipYam3caI3S<99z$tlw#BP#S&7%_y0{Hl]*l!`RfYaiTVa6pA%=6;Y`8B{3`r|~piJipY>Q,lVFCnq|m<%?r+=lT(2=ft7dhYd(eY3Sk{1Wh_P*:_.%p.|&eRrmVPgc^!VhYea1m+lwh)%Rrs7ehKnu*YxL6`6@<mlZ0kedbH6MyTl@fX8i8v%ofM[dksmA;uUZ0+8"5>#s]?+qeKkc.)9%p$O{Q[i5&Z,f]oqLkHgv0kVYHWo(%=fl^h*VnmP)jjx`PPkWbt0}79o@*f2Z<I::j#@bPp6)z(et,}0_POf(?&qeIx#2iW9Z^.:j.:n,60.X#h{$O7o/8Gkhy{Z9g.:UlcP^o*)opl]u9&.|%l;3%iPd$&2]r:pR3Le3<?Oc%G#,d0*u%}H*;a=j?1U9Oe0*?TC{Q$l.bxP~1gPX6iQl;?$=fW8baMbp{<gpcovqdKUeai[@_y0M1}a07Ikq3~8]0u.3`f7dag*Fnzo]m~8ga"+oo60uUl.h8r9ElY!fFHk)x*:JfF#}%>.E:W9uUWlP6tbyIVaHgL6Nn[OR[P6`z#0&.]mi3O$Yal^O6=;~89.}m)j]0opi0k]OSe^q0$m*;{&Z8+2uHAq}OHq6pLp,f8m+#uHF;x0`fG;k2MbI6Rf$#)9b=0aA[c0}mAZZE}gQNT[0O{=}&"oAfS3R.X03`Rfvls,N1~,Flo*dripHd1<#d`Z$ph<!@mgK9,:~8@*1.JP;U`?!@t;79#bP6?xL9|nId50tbNU~g_=]0?%1Q%#RhA[M[=69&%#[7~0)]MQ[<@;Z8bayTnQEe4mY3X6&UYvz7aak3b:gB/eN[Z8k:tSV]W=Bo#iC#FYkZiT?U(89`6h.2iXSh>#Rh[Ic8}mrpw8ul+#DI+;&`f7IkkpIpE]I3)jOUu,^r/_L3?.1GXoEr)|OV=T8PLgua38o933c^rhq3u*3%&p[3Gq>#0.gMO3+d3`[<qd<6Va%&kq/L56$1`6m]%UZ0/f|g3&{0kP<+]%zGxO,KQ6%p>f:=!H3`+]cQ4me*mQ#dz*N$Z,,$gb/SgT(.Ee?q{Z?V2fR6"wEJHSd$"/Y%I6dr{dV&ve_?E+*w!=cQbkqZ*EE9Xaz&]rLeA[7^s;Ijaa`YT>HqIk#@oq`m(e3KQkg7=bj]I:o^CqA3p;eki[aka.Va_=!H)esyGJ]ja.4{<^vjU[]12o?0`PN(9jc567M#Y2Z01PI:TSQfD]5?4{C*@UV8Kd70*b<|G#Q[V./2KnSp<=;ej.Erx<"eLkBX`{[0oaw3|n2z{@2&LFw%69%#e>aF2oU[<S2#F[d9`8YBNC8/p[s^im${yoX=t9+)x9b[V.m367h`,]b%7@_{$3ReR,1O8X?!02MTSP$Bc18`L[<S5Y.h>tbC[Gzb/Svox<cICRO"xYn2p`yo8e6b/Svot869!4e?P1!=e:Sb*(Brn$&`BR(qOlQV,jx$_rqxW?RPHqo3u9&2[.HPzoOIL2SbK6:).+7Uc(rp~koQV&Vso51bE&41R.FnnVha9nf0DVVl50=^,8(2sSP1x<t1^g1ly<A0T.`(7X`{6pyz{@Vsf8dhWJMl?H/eNS@f"+a9U].<T.Zgy7p))bf%3oANea(1aN|@t9Fe(P{j%66.`m?._fqhX=.Z!fLBL^o[3c)j30L7@zZrdf*#C&;1X={862/SX:6pH.x[bpq~t9mYaS"c*c@Nj{C40ph85gR+xHAleox]w[[g]%h]<eoV%P,qbh[{TSoq"b*`z#osa<y!Ijt:f95{0&07ysi<Y8Pf*#=]w0T*Q1>lz[PsND77K*"3sk#1<x`:>&B#t[u<u%qpF4]?~<.|(@M{r`(@"{;z;q$:&3S~J/hW&bk&@%Y:_0I(W.|}R4V6BP0dg.r26f"jLk"+RdA[KniT2bh>?.0x|@7^]?TC7o*1H.,$r:31Ni[7c^5xm3mqPkT.Cb@Hol1u99NkQTsl{Tx3^eTMy;A:o(p;*1o[L3N_^eh55$.N%6o[00v9b4>0UPh]h/?w&ezE>9$Y$]LeLlqPr*q~z+f1u=o8?w(r7.wl>wjr;4:%}!~QO<=Dr$?w(r%.P}@f]eL#!Hfdy7@<xUb{WoRhPm{}/+T]`@z+s0}7o:iYh*;r)9E+#H,{rhvaT{J#Ledc6lRMIq7!X8daJM1PS[q^*U|@z+c{Hs;a2iS+.SgVc(YmQ]^;]!Or)73QX]N_wh3)^%+=z+?#~^lr?s$PQfVlnYH9I8m:~7YH3`)#<d/Tp^VZ|$07|m#&#p>,_f.R:H3QB>Qn9;|,m/WUtaG1yn`6+(]uU.W;~nIk:#jeL9<ec}m92{?_}^J^z+oaR.5DeN<wUoIkoT6UX8X=CbI9tl<y:%@_tDw`3nR%X;B!!GGf?R;SSP|:=|n2;8UzIw%]Zj6,JPrk&l~jd7da%&:U*]L:ge.?*=)]%P5#Hd:=MaMTpfP=oyW8b$8.>x+rE99.d8*bVP%6@!88z*4D;U}Z^{G9!hk`b1X$}S50$OW=?_f53V%](73n<lw0N8E&O6C*jV@0%3>#H/8nUbM3^S"R4pu;{a+j"P3</.+8WP0`l{X/g%V(;gT"DhS!alS>T.?=_`|S#SF]r^m9rhg3w*k=|Pd$v]$3>##%`ZI;Mayf"jo=|c7m5&dr?_ak)#2UbUX8xeK;`:Eeh.#,Y2$HEVq$E9!ik?W}Jb2^4lwTr{UI4n!bi^pDtYp`MTZmusab"g:_%g,n_KG6Ip@my<H#O[w<A]02MTZmy<;z,=B~ZkApApu#O&Ar"P#N/<:Nm7{V]r;tAc:c$#/VM6;?_dOE55HBm7YvCJVDJSWi<?Qp"P$6R*vx#9L>fv}#+2I=Axc%Yr[_z/=;Fn+)~fk.#&BI>z7NcbLNjb^S8;H3O&6Nm7%.3a[h@D$J|2(v]^.eYh"/Ob16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nbw~6Ib2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16b:Nl0Sb2Nb16d2Nb167&RrVfVld2Nb16>;)6b:yU1Y+ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yU"5"5KpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:;66ba3yUKpU]m:I^s;V]m:;6qr@na3|V{r[|*`u[A/"3}V{r[|*`u[A/Al&.i!!.ba]JU!HkY*+H{bm.@|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/"3}V{r[|*`u[A/fwy9K~<&{9{(b{+z$`l~#m~YeWgIQE^B[:~>4%DWBc/c%:[>o_%T@2_E.X/ctGT1P@k,6!2:g@]`o_Gs79%7K87ym8w"x]heZ)A?t_XqMV1M`>qnF~PLME+C.>ynb|Y8H)G?Nh75XpKqHLP;/>s_>e_e*ub)O?x_+$#,4t6E#,UEZtrELv1).?@u`ImeM!7(UEa"r1}h[9w(HL"SFB;hKC04pIttHO:"pEZtpIrPXqxI;R}4*BqboO}x`K_jPO`E~|]Ft?L&04pIWuBf|z"DrLt8Pp~D`E(DVC?hYji+1ULZ2Grtfx)>D}E:9>KNc~pPZ_9>(mMqrBH}2}d+UE6n+hFB}BB!V[Ap4hn`SI|$}Wmfc,*H3N>"r1pL3e:Fq`{C0_ZF;(OJHX!MzH0Ioi(v`Ki|r|%@fsc@1_1_/}1)$*qF}x3I9rn?AonQ"]kcBgARzEeQj+wQg4$Lf~_Efp(H(j3;;tIGbH5bJNz{Hb;gRE@Bc"UELt:Aaf;3zb2u*Z`IPAA"#T?9ZF)U1CbRZ%@j.`6%{iD=ECFX0t;Bj|EEylTxH7/bhNPbSdI!#4KxH7zvH7@M,7p14u6Fn7q^]BQ!"RCRQQ>v)W)DX,5QaL&6aSKvxdyWG9@Q@A7y8:zzF"D`<s?DyWPByW,Z7yYGbdL,XQtW?d!"&C4eET51?B$G%t`~2}iBGsc~f=zC8sc~}]m>XIm";&$Na"x(t5{>;Q=9GOc~2}lglhdKptdWFAR|f_Dskxzte(Ft3394M@8/o17dC1q]2R(KOoQ7l7YOy#g5^Q7/{z@h~:m8+9~2%po}#Y(s>o#a.~Sm&>zHqPH^{r#~~,L/:_dml~97rWu3WL&{`ansZcq(w#;cS~k5h(pMhnq*=G,_Gb>~cxEcGA~SF*a#.~Bv.Qxdmb})a#*~~C1E*_dmq~QLsW%@]3#}+RiWkFX4C{x]PW[}])=)0[}}2`2>qI~~ZFC,l[hCi|16)~lFX45`2^.sH:C00<)Rg~9n^~NttW8))R1|$l`~P?f$)spfdnv/Lct|{L$>;A~SRJR:ecki=[hykrh0saC]9hM4Q?)9u)fk0gZP2caKi2i|DbMcwT"e.O:H"Fd#`/nQM$m2H}M]:>Wy~0T,pY^`PJqmE}<Oz`Q;)W.,meeXD+`{FB&~Ga+Vu5pNvlzlQ7*1Kv5U[QFWk8}NHtPb7(I;eciid7p%tZzd7zxrUAkG"6988u|xWz^Wy8;amkX5.KqRr&12[fxD`2||vxbZ+A/G>TArhd]bS[9v3d[fxDFm||vxeq9R`Na4Vd]b2N^yo&ylQ7QR/[FS"41n<C^+,dgFPR,*PDzlQ7FicY]p>y8n~1>7`6!k)J1R[fc]{@IzyG$n@i`?x$^n~WT894TBnG@Z(F@YWV>lVUW5feeX]9X>Mir?:u*E`?HeQAI;eeeX[QK5@=)s4(*Auyj7wKQ]N3Xn[fxD3b~r`Y4:FNoufzwie{W*E<TYc.saoApM[;zu9Rv1wZuMVAk;ndiCu}*Xo%UY4AVAoua]f%?PBY]C8u+ED2]d^A2&elR.np4i"Sf<>GxmQnX:>Ju84i[y$n0B.#I0J<Yg{zoOaT[czqc:_#0=PzVvI<>Fp57lcLU{9=Ty#jW2thZG[(Pj6!l/,:+XLcA!qK{PP{.NA(yM_jcr$SEwplRU"LVcrcL;eca#+[ZW]4uOpmn=u;M#NPMO<F`1KW/[ZW"Iy+(p"xDv%S04JImG)t)z0l1;Ioo)y_q+dnfBQoSuN3QALH+ZsIp^bx0(3KsesN1mscA^z,M7*{?%5w#WKL/R/[ZWOMOV4Z}7}_TpFi1cGU!54T4$>Yt<T.Mu/%m[=8}aC0LYsJ`,Np)9Jz/F,{y&3dzU9t*!+[!X$>zarTGT5*ilJ)q7BpJ/t,xJTO[;fjYQZD+EMP"uTlQ6bl:"nesN)1z/ivd*)^8bv4v7bJ@BYLJ3rX~y>GyJir?k6io#|!*LMy>HIb;Sk&N<TO0J,JonyKyf8Prd6,hm`%gjSSdLn(o+oU<7BA<>;vg&yl{5fY~L`M!WgxEbsB:g>.6nkHB#?R@bhS)K;v$P=M%]W%kOm7nE}|5zierGSIy_Np|T/DGR1X{PS^uSA(^5L)NEHGSGvd&,5glH.cL;@+Wo,[tak:RcK"oz^^eMat_JSk)jl3oM[;?5SSxWvjCG?I@ey,w/:a[zZYX}>|?HKy2UIcu4ekLK;G_vF:||#h5O]Ky=.Di42%_CR6Rb{+G5M~UL2kDq7xF8bYOgU+`C}a@Gd5M~BM<AE$_MjU=<8c<[5YB#?RgbJH|]L>Ek8gnOS7f@s1/woBsN_ZK55&CSxI,H7Ks6(7)TbYmvJ/t,jT{Z*9q|2TgP7z!kM}$dIt/K~9UoV"A(aMcysNP]P5X.qq{5U{R4xx?J`Pht@0Nh*Oa8#d~9}cV"sF&JyKWCA]cH/_#FHe([^C}a*zSYt2FkN2u"qm,T9wi&]caEZ*(s[f?1wbH1Ktx:RL.,9xdZHnTAiju{`h`MYK#h.W1O,1I5|b&?IHi<+Rv@PvnjXk.@{JttF3{]p0O=>+BYWXa2GAVvQ{ATSh5/TX/4nb~r*YKh,x17#zA%nL<`HxZbiG.4wlLh0Qccx(rQZhgIn~Gk_G4&fL2<JBw(;QJ}HGScL;?Z%!{RzwsXpTOzI>aiH7}+vesNxOK54VMn,t)n@:$y%i%1@V/[0b_eIT[hh#v?ROd[>1IXCLlvVjySHBnM{$%Ts2;y@xnu>8}axzLYWr;FZSlLYH1oR2u&M(^fbft/t,qO[Y*9)Z8vI$_D}<=?P{2Eu4}8lBsN)ZK5WbH+{f5W}zc&{YxLAX]o)qQm]ayl1_kMM!0Q"}=*t=p4:16x0~DN;CCajqHkM$t[OnX`QSTA06#iXbe&9XlNjDqI.#rzQT.C"5X]"C}8@,`Sc?y`=C_yT:^,{clMB<24_!BwA!O3jUs?vX;Dyw,"e$+BYX*Ni#?RxYLw}SrOn/^Q0ffcQbS>y<3ihYJlYSWasI7?wvZ[(2M2eM*$)Ni(=L/t<3;v.qpCCrm6P5U3.;@t!OK&A@6Xf[}Zz$Y?YLSl$Cb&AjNPN*):s@uz|?110R0LrZQZh,3u*Lp/1E]FESBG7U]t7`xbe*Jw{L6ElHF*`kM+R/fUn5E=dD|Z*9.ZQzRB&r]W4NiiGhpDu6KX1XnUVMA.gABF*I+2AIdclG:a+|482Y7l0Tf&buLOr$=[^j(W;iMY,$=tkpf7to7[jesN#+M>pNmOBv;u?^,;R,^(ihA.t~06)*iLkN.:TWT_txcXV%)NK0;=[SG]4AT_D,[JoemesN9+#Fav/7XbCz&L3Q1L"=EQIi1/X$cYFXlB/q^9yI2*Y%*(tP0zxvQQP:!/pj^_o.>5X{{2`VoBgRcfFG6qT[nen3gklesN7+/,%[Q@WaL^S!1TGr]uEHcy+q/u,VT?/dPL4`%/:1/4$bc+(DN<STCHz9Lp3LIUgW{PRmxJ&M8=(mx5>CU[.3+ZDg,K{Ce/>/Sa3B.@i&3M!7nULNK5Ls5w~ReWo`qS04H_7ZPedC3oK4_,]:u/^1s&hu)mB5$V{PijxJ}%xuTwo@4oM@}3S/kKP:3X*z$$T?YR?%c1Y`okg#xf{1Z5kw}Sw&EbgZ7:lOY:8QK?GJQ=xj)jHx}M[;G{ub`RcfZt!s<{JImOpEXf{1YMLw}S>I{_)(;u^le6tFLz2KF[(fNM/OXT9#s&^`39/b39Ma.LJSLk1~"D1sNz2hD})><~J+MumW>VE2=qGS#rGS!rGS9rGS5rGS2rGSs)9!%RUHyj(/%aOx2sPx@9Uwj~t4!~b4*,Kce/]X%YQqS)EDGc*]!C,u|}TtfMP[[:C~Y`J^~~ZzaKf`zI>0FMkiLLz4rcG~h;^eM+KPp7Sfil%LlRVD}Gq6]``o35aMF6*EEGTLW{2M{XBRza6QWc!#XD;d&JsItN+R"y{:V&cVM!K.Yc.1/DWVC`3&XTWtOp@iQcj7U)r!fZl;lSNCha~"5k88oTlPw56QHx?oj+9NJEEge@<MuaR{f5z,LY{hNps1>BJ7Nu48HwFNU]"/TB,J;GKN]M(IdI6[9Yz;9Bzec@<x8v@:9:`E6%*N0]U+Z,3X[C{2Pxdi<.fNRgYt"GNcRd@CdI:xSaE)@E|JUd8P:]"4.iKxRHYk8WSj3:~Nzuma2*>L(td%tMCB.y}j^g_7.i5GYcfYSFo$vzUdSC;OdIziE5c4NOgPq"cD23<ry&RFCBI7,1?m7#wYl.$;Pxe10o;S>:V4;M<EpDcVdIbi240D*D9gC%=NzD!e^_}p+a!c+WM1YQuJ{Bf8Hw]ZgaKVj"tvHB]Nxdma2*Ufc$MZe4&tw.:k:YZ;8d<MI0kN5B{8Vgq@p727SfZls)%KyWduZ:|2U@!!Zh+:=C~Xq@/o6^JaVG0i1YdFIp>M@oa|`4`#(Cy]BqkOn:^oR1KsyO,f")c]uT_D0w!i<g5YZA76#zz]aPsD^y5to]wmP"6iQ$"ah_jc"AXR<]A!wthtIt#7!$f23n>`|DiW)WiXb[rKk(5d49?dnxw"YL/YRj4(x~icZ<?;4Q^Tj*N8hPg6mI51+W4hkCsLq/T`Y3V{>r|`,R+g}UIA15,gjnO{Jq>M$W>]PO;EZBKFG[L}vU<]HEC5A&hmph$^=nk(>G<B)MfGq&9K}IDdLAk(GS2WSirLpRx*~OC!E!+s@TEf6tA22oCy`}YQbXx~yEu2h/P7gPYk<%U6y%K}FSQRqn2i:g}Z66]F_Ic7xKXE/a5Jf]Fv?y4;nFKeTExPIK/p]^1BlB8q2!i7!^CQOVq&MtvF[mgYK%$X=Q{ToLLTZZ.d(qyzgi_g=21weiWvnB#y)|XJ?Vr1$>9qxW`LqX=B)j5P1(MhfgGthjpu_c9u45kW76;#n1=HWuO&`0;~DB$*~hSX>9C{Si0]+W:XtH@Zat)H+s.B)lFg]"$q`Z]rSx[kF~B0v%)Ul"H0nZsuBsK+O}<N3BF2tbXDq7:l+X<g>9)d}Dt_{ow[04QGnOac}lDPMHHxmc,OM3GD5Vrdg=!yjX^@)6dK@>hBGQsy$>_WbF8iE=bpQE=vO:iign~>%cJ%O=?K+a`iI,>6!$9kdd&F"Y^s{X@SO`Yw$>:_IOJEV;u=EI~@keP9~SsAH1R@VI1Dr,Jf@IX;sJiw_}/L]=0|qY0hHPZ{!bY$AlT5fSM7!@/S~hS}BOGBF=!1WFbK!<zw[#y~xDCfT3D20*?G`]$Dp#T{(c`?"iv,@^YV8N+HC5k]R6kcp@Zc.o7M#W(fi&t7h6<]1kuBQtf/xYKRBMy]A9[tW7rvytu)r@e2&$25#htt5LKf{H`tLS,XD!Y"#hzO5VP`7x!{7+?rWZpL,sb6TQYE}"SK]Q&G%/@tx~4ay+FE:1$e2D(XS{"B}:Fu>BPfgG"]#9x=E.o)yeqPntX*e@<4tK}XNurB^Vx~rxn@cDe7%JbXdq6W(y$>4&K!3uEA{F+TgZcdZh>94tt[C$`B$36]C"vnjih_Ym!/}`=F,Xcu,3rt$]@=~Z`5:`m4I:/4IouM5]#@:OCFhH^HxgPjQoz*$>qw.29VEC4f}Mkb(!!W=Q!gZLLeQzikbP~@$"YE+sYZIDp@G9P=JN&KD;uP+s=CVo>}IX:X@>&RIevy$>Q2t#^9bPwokwTcve~^+sY7)lk4NHVg=Bu_SpD?a]|I(yLO/zm]QC4S]IxQ;bgnimrK>s7;)LuSEX[oiZh_wcMvsfM3_umux/^C&/y~TdA%mZ`a$ef4<Q)t{uU}]ba`4OAmNBmZcQRZ%WZhZx|6R~1EOFOtVOL$V8$1CO"[VU1[}vz3`J]w::P0KIxOjI4W~8<yl7XUt8SfEUHNLyeXy*v(O65BKrgDOqotdZ@gqYnz*$9,X{_K:+^W#L)t]QnEtQ[9h9{ThA%[9?p5XMW:7UD5b5.id4IrCS]Cp(V7sM#(M06Qj9hG^R#S}UaMHO,]bS6Q.ay8euzIsY#5BwM6_C7Qz~DX&IQMt~TC9v*M;Y1Ys+yKo}"VI}]S>E/!0W6Qwur9rDCK%J$Y>2VKBgJr:lOXk9d9wwDz57{iWr1&;HD*G%z{UgFt@M0BQwc]!*{B)gxCbclrZZSBS?3&wIeHNLJ`/=TXcM:D{ZNrsfzt:Y]`t}RCr__c")d]I,WGXzpLn"Kc.F*cB!za1Y|LBIF]8idutMwjW+;FZhuyGXmKxUJ8gnfWx?N<6Q}CFV0(DNbNFHc!+9AJHr>ZC+}3#vm%^n"u|FhpQrdc$+yV%`R/:4/I7h;tV{}!lZUj]Lr4fG`D%5Gx?dkR.<s$yV;BTG=1KI)/B&PxZdKUfdoTjHI0ui^6hHbh/JVNFh%(:`{1ZXyYsM3&BVn:5L]OkQkpEOv2out]*ApcIFC+j/9+%Gu2kNK7HwyC4+Z([[u_UjplX@]6.i7L]17~j^#*vE++zEHxPxQYRPL{sI[Zzt,H7vu;vxo)$jJr_M[;1`c*<ImRj7()B!dFO74b.PKxJLkfz1np*V,EHTfcOzxS"GXw5c/>iC6F4g1=HezO{ilKBeD?y4aBe>F&lk+Y^1=5sNORJno&f?]TrW01O[m4K7VAD7]ZHUi!NK0HdyhR(i+)vv~k21i!hV+}=HwRTj?+%zm#bj/W9bgC`d_k1D4M042Cx$[[VR4+lL8tWCkKJ%!I|@Q^~*^+lL8tvW!G3m?7^&gGZjg&WA")%GfM^[y5OK"B;a$*DKY!NKH+7Mtu`FqYBF=ML?wUGcdNDb*XAUcRt+vzu?rH*XXf=_;DI*WQ.cf@:+auA2MA4wNwGZXzSBWJ<SbfjG;+zUpbeg&O&9U0>c{xhogMN1:4mkSCL7`(IuuJeXqm^7KwQB*L84!+It@zA$w5g*AoN1|T$:w!Dy=X`,zaEgS&D+^vCZACBIvvJ$g@3nRK+B6MUsEgXz4?|T`zAEb)J$sMY*M=]knq45V+kz{B#COsyqF@UKtY7J1n(9]aLo.ZjUFv.8+Wl,7VnOy5IK4Z:M+J19P^Qc8U/,)39L(BeBp#fx48P&}`x5g*Mx5C,EkqnzaV}YzUtPsG*pBl{5RR]`{BSa8y(L]D&{0Q4!MZ>y^WTJ~bcYCy*CID.L/0U@{y$KGNcFHGgW9Z}[Opw2hj#zuG/EziJVn,CK)Z6qTjUwU[n^[gC+OmMU&R,WzWlFr*z9/0n~`aa!FK`YlzW3I$rNgW+E0|F+%T*(#2qS<}LI]&AEP~Ku#!h@<W7*WhaIf;4!Z@^yJtGyQ.j:EU(nU*huae9z<19vEU4!^y6z[Ydz~X!_?Ls%Bo&y5ts4]{.>`5!M{B]V~[G6TCp7&+hNoNRbYkg<M`MK[CTG0?{[Vj|M}B>Rwb&ZMcg,)X^F8X4E}R`jN`p+6@Kz!zxC;6[xF`lZ>O+/3i1KmH_F9).BBUC+Rw10nHqAw.VJb9D`|TnZgy_n2y_n!y;IQPxgE@)+mGX.jq0p7P5!u+/zXC{cEXl~4Iw?_+RM/W.M:H/rC+GzBOJadzIMiVbZ2K&|e@bXGEu]!+^5e+[MdC0ar#g<:ya05B":P>Sju+2niuso/16q.y2XBHwG^,Q@5WQr>K=19Rgjj~(}5qX@VzV0:X,1OKciO>ZGn<Lydx2Hwd,P=1[&C`5K{IJ%~[5!4LiV~X&Of(.Gx/:HWOezRII/9c>ia9FKcfQjiU>)_n*rFUd@UzvY}KHzhs{,*}p|&R9+Ax"Z532SlGc&Oo4+/Kj0.HS,%Q/blEL`r+lBwPojx=G%}aKUXLaZRHB~r7I0,R.Rc*xG~CvZ^,G%rxfZ]yyZnN(z/A+13KZr]a@1M+@F`aIN.e3B4)vLQIJyx%$ozBv5JK#C}^Wh~R$rC+tK~W)GAbW:^,%Z!wQph5)cu5~RDKH$tM(+UoiGAbZ[,rbG%!})~FcR@C_#~548._TvizLZuzo,%tpJCVwg#M?M=@cU{_ka$}V@|y^n/JveZ9P>GUe@1Zm.GRnxX0RIcR(RNL5ZM]4)H^X!2(ZMXMYTGpee*/=nVEOw>1LZeK2Z#Fkv/ATC#5^JLq+6{39Z%MkjeXPB5B"x/I!?IwIB9E6oj72!wLKN7A?O@r^DYGTj}v3@WG^6ks1|=yq"SItkDdK4q6@/izwt%RhI*<DHfolL}HRa&OcXIoe@5@`LSD>B]&:1Pc%U/b:G6V6KEoui"v(MlDfuSg,HOf3?lZqc#z]v]up>OC[$9Xjx_aGjOykMJaZ391Xfz5PrH*D@k+.MSz`VkK,Ox?0@]???zjmzJIgxZJ"I[k8R%+d,UoKGfOQW<,r|Z@E,B0!B]o/;n7Q`t@4jMaMuVV}j9RWc%zSN,cbDLS!+lZcz[W~H]VKa0|%Mt4"K)x?TS@Rw%IaX^LlR7K:Ix?HwEB7JB~ffN`nLW?~92G4e},fYafnbav&1|2#beh8O<y,2!v_4rT/tG%Ocju"G/QJaQ^cz=y.taG9lz|xcPxzY3*7i{%ksK`CyOMgvaGjiZVRj`y4d9Ms+rtlFnHh<gASaJXus+mh@?5+$EHoLsL.DBjksh@^MOB}D[z=t0QCac@mNrqI<bi"X"YUY"||2*ZCMVO[uvHd8J%L,*L41h5<QSv)^.CIe@V3!$!9}x=kzHZ:+4nYE<3br9PlZ}Wob>6"m2Sk3_c3{n|djVz"Z^B<37;fG03Ac;5_LiZmI&V/B/YGI.^dc*rh@>Z*y{v=dSg;HJo$yQx/j0Zc+}b*r!M?JANz5{3xpk@mL|>~N@V;af+rwwGCG3|B+QUlXFVm`{`T6NlGLwqR`p@`y?M76$Urq(<tRFy"LFyQUXBd}=I.nw@[TBXdNP~br*/Sj]y+Vtz99mS?o#3cFwbU@}ykX*w+K/LP^:r1=njlj"WhD)K3Bzqq+hyixSvuKIe5gbrE3`,9R3+S0z;[g=wjY9DYuB3$Vv*gj9!sn^I*!M@j+.zDqF14jyZ/DLy8MIJ7_O+A,&zyNnQjSjia.6+EjU+}+VM;wuK1,r7}$Ujx*gx)NKbwjIz%WpHtk[FM/5I]{,mJ%m44W#Nj^PPQm=I;yVMPEdvq6eGij~+Q0]HjE&V*=>ilEi+(yyZrJTDJ%y5r+QVW)by]]T@rL"Nrcoi1*txd8$Ke[KaBj?PMD#!Vy$UR^iC{_??CFd<;+YwuXPtNx6V1p!P[&g<UjuK>Z53AECH#cR3"Wa=._l~Rj/!GKeZxH~[Z[FUkz7yWMMt}MN>SV&My+6@3@/y4ZAKCV(zRogRyj[i#*hxIDcBjd*N3p3pWQ?,}$VPIHMjhYg>&@n,{ZVYaf6wBF8a5Z"qxgiZ6W~DbdZR`[CZczM[KaW2>/+y[X8agc8Y$5C*+G3EXhqSCj~y:XvxmSW2=cEe"Yw!)yBY1b1HE6)Z|Z{L8vq2##_ajzvz;aOEJRo7!+[i!w#O5QCFp7)59z]tO"nH%Zh]v5v|F`Z@;?sU8qkwn0:t/}EjHKMNVTwbwzDKqGc@/TQaAU:t>/g!uLON*OiP*26eWI~AJawg~Y!W*DEP/w7PH7pwmNBai!&i;H2!fR8+3uw0QUQ8~Rr16Ly{uMbLBOBGOsYo$M~y!MBGIeSC?1hfuz8Xrdnx??cf*m[$kz[zS,/tdt##7P!MkLhI4,_z!G9a8Q(fz{71(I7i=zcMcZ,TVXwkhjjX#50zooF1](qo{vz/;0RLsUfJIJ9+"FZ<oq=>9_9(EH9Wo8f</b>V7},${hTR(}"*P)F@Ft,}+})n6(Lx2L7JqWS=ka=JhR7n[gPvN<+!D*?GrcG&Prx$5Z)_BKgL;5*6k3FE1)GhsMo!<i[iv*fHZa@)=xRHVqoSr2xp>t=@dH;E7Jgo$@gap}Y<@v4Npd?<DoG?L)D"pC&bAUXtRW=Vo6Q(~l~9,?~v]L8eS!E=UkB$RZ,J~EfE^9B**w7A&bVFFEA$A<9?K)b"ZA6XKG.;a}7P*nQ*CHnYh%6aG_?rDqUYp6cE)n7(d""*eHDcrD`UJhQ<0?Yw2[4QwAswWYw_*t7@MH;EjJnj>+hX*)v|,n+?K)F`*t3)Z.2kcOYfKU^P"V.:7+I^iN"V,d?y][J`WH#8qxBFgMnxBF]wg;&Yn|Zjjzd.KYJwHD4Tv.$rb!>!s.]$=n0+$1_+st|Yp?4tU[&9f;,1wiq"7F&W.ua+1XlbrLf;y.Nfi!R*]wo,KFbBMHYobfmfX<5iq*ka]YIYafL=NQ|QAK[lA+.r.#d,_XHO1W,B64wwQ8zPkPrUSS,`t[KFzBuMnL8?fLrUzPyMAw8^yCq*{o^XOhmxm+KXU@|MnY~HMH/">&`X)MBG?f[VaoL,nO)5Gi>Z1PkPH$n;Mf,;MwjmnPrUme=j<z&9,H#8({fL=#&QRakQAx:2d*gM{cSOVH;}VKqO^5njXX,BVn,r7I&QTcm4;(>enh>hi!19:Ox?bw%qKZ$th@WW/"z|DZ]vQNf!&i,%1|/">&1|p6$rb!(?KzAD%Fg;Swg+WztY]EVnw@1R5LU[yC&9z|k+Wz50AD4TF5eG#yUBdI/"]&Mfi!&iq*+r/_r>.}>enh>J$ZSN!ju?bwJS7YD+vZF}/[lak^ZNg2$IN@*~skOj<TJJsnSS]){l.)H&,)5M,)XSn?H`j?oid+]~,j4HN$@c16lNSL:7|WrVx~FJc+P8k7tZ]w3yZeJ:tyc?+r7S}RcwtNnwn`,I.sAE4H3g;1JgQWd+CkJzG{E%n20,EzG{2/OvPY$Gg5e;G7COb`bj6*AI0(:umt+:1pd7+x/caOd8R7HML]8/a^lmPc`nC/+hW%}@w+w%.[,0Fh)]^1s/h|]XQn2+>vvk*MrO~|w7^9jz}>e]?irP>5ZReJPL+(.1u{k>[:ta*NmRJjT@qH3|"tHh9w_?}8_=R7gwecgBvIbC_f~F(FRD!"fS/T9"&1y2lRgL,7bK^sI]RnGJ8Abgi)JcX}J4O+$KEu,&L]o#Wly,GIZtHMg7=[:t8Yyu^v7v+q]CR"7v)[JFet"ER!uJ7p6E{wn9he7RCSL^Qh.?4eDm+l+fIg$+M)hFSv3)ry>ri1Ojf|?zjE}x3)qy$*IgH%yS)32iatuJW}z<a?D#1[CTTZ?:rPwt&hE~Psl.[qiYbHnnKt0dTH8F[t&EH;"0f4H6NcXz?!Ez/i^`IrnP_sT5.>{;0~+9CX0|t134)H>W)D6GR?!zjk^gt429EzEB*[@jp.V(Qe8fx:r?X4}UNxLgD0!!rm23@chv=y#$|zksgghpvZLK?P|0d4]*Tv{gLYXFmgzb)!i!c%VwT;c7wlS;UTI8Ueng,O5uq@DCl*xtpIGC^QGu$oc4wIz(~%bP&Ls0EHGu,&3$EHe>xe2W[dScXr5"6Fe"?%pI?7qAyrI%Z6J|I^;hkkl&}:UE{:r%tg93a"V,V.Y/UEY0P6PDo0wP)yj`>J2"w((Le[R[e7_S)Dc41A$L7un7T1,!(tb7ztDtvRjlznDPcY$P4coot?W:cwh55w1rUVPn+/yEbgfpMs<AbgdDot0ly,Tiy,qpn^S%<{3=(l)O[:f@Mr7s)JP;`7#)Sp2Q"y$"NQu32$..xgRnf>dPYVbgkO=xOY7/c5E~:f{=[<}8"U,PLwyJwv|uOP_!B:>3>2~EB]_bh//}a#?U3PB%W9f%q^a:=`1K(T$R;`|ET^[~>TQ%e[|N~*M<|N=T*^Gm~Gpi^|!~dE}|yFDcQS|}D|,vq["iZdJ?90lRh?$q2o"rqn~M~^4FE=~d>=z;X3(__}$@rbYc$n])4`wpKL7Jb%"AQS:iB@"ig_FE8#8*nFd;l;<TL^UFx29~!vO1"5{fz&ApB73_]}H;,vI[cxPLJ|m!(oTfAoS;8Xc%P]K{%9:K/Hf99%gbAktl;ux{9|%94U3PB%=E/>"{S!*wj85bqT|gHb49/T|{eImT[S9)+wR$tv96IkH6q;;m)WL.i|os~=tW|AUkZ@vj]`+_d[9#IhSM9xmv[x]Spf)c6VW%n^U)K<ub:>?LUVB4twOUDnf:h/Vb%5/3VxZAHLE2&n^yVEW)`B]y0X03lv@,KfosiiKCe4|OUNJrh70l8dXYGrs:C^*g5NL<{qP;bL"b#}poC1ekxR``K]Y6uHze?bGrs:JL[H)4vE`ZOYUyfYhqAq:.*UcR,%JL609|Y%c45@QVTWyOq?7|0XyFC,L<lsjvq?QiWU{vs&4|MPyF*+3IlsDvq?2|uJyF1+41]CXO4N_Lpi0|aF/vY||E1Fl+3IksmW])U}wgh7:XzG.+<8/$}_qlr{Vb(V])F`J>ILQy&n+}^n,v"?bEPL;x;czk[bs:+34l,v_?37o/WVe=Fdv*,0zxb~#j$_SmNb@$Ihki$E|6wVG`.vK|a;0FL_cxOL<{z8o?e[.stR])1~%9pi,sKqpiS;.v<?]6@~}x5e4skgO*f]m!_2tS`][fw*h.;mxU&N0v;SS{F;%)H~T:.v`{,00FL}23/v@pAoM!3$D~b?])v~2>])^%(}Qgp*hq~Ev.+0#!jzq~{q7nkLBMrjX]@bhs2mq?n|e5xFy^R&NLuwV!N0>20(uQxg](hFw%2$ezNbkC2U8v$HKfS~=Z,vy?yPQW3#&n$}DX,vT)$5cuy(w+77,[Q(}^!dPg+3M{S+PWn#(_!}}."}v2.v.~z,])Ku]E=>0f|[@3hF6^VJ#n>a{>^)lrTgXF8l|D`=9NV^^m*wvaQ3"^kkYv(_0s&iq?N~lR,va?bENLBv(_Ap[m#}zF`]o=W9&n]JTxH~"#])"tf{l6))k!x&SfaTkemi6v$ldhGyQx]b*k}w*Cq$><SFLxk!j8i.dQ}6PIicu`QVPWbDq?I~sM,v)~,L9tm#"BO8y_%mHLMu(_6}zH,v~>FmqB7:{kZ=VBq?H~)E,v[>/aOW^7(_eC~B]s`=i"V!ws7,V!gWe"&nwskc?zX*!si!sPZ[z;wn#o$JxU[nV!Shj7Yhuv[QgW#|!r1FSvvwXq~~SD>w:~MhAT+etFh7caW[3NnSO]iBQf8mtC?*S|[~L{S3"sw~d:zk{sE}%ain+~F]*OszgffqjPY6tbOU8cwt>~pqjPMe!Q2BnU(K0FfR!DB]_v6Clb4*qejl8>o1[~"`~yA"DK~sVKSEe~``Ux(hu~0/7M]4!T.)Zi8h>~y(nI{s`|SX?Q*~=Ct~M/+%vz3zOY5,WY|I7v&Bn?B)^FlO#YH/S|`s[|.V@9)~o[I`~~Z<{~eUkI6_h~a3X4,)k!jMJ~|7Q!J8Q$A,1U"J~5TNdwvHSJyc#v({G@vZK%.[9$^~;_$Nt(h~q^Ba~~$}HwLc}~j|.FB"!~o?IVqW#}(<inbv5yt(2~P~j<]XtWfsO~8_nIX?X4j_}s|~^}@9S||~L~!;`e`~K~u;zkrWz~n)ZSAtf~f))h~s8}|}}FA"e~P)!T_s+$6}?Azd)(x~!(TE_svOcZrW>y*m4Gd)twTRP7T!qn<P7jW4FFgBVF4oQfr_j?8Wn?s++)T!"~)|kRG^ydyrr.k>5`piVLFFgBy~E)|yc<k*/peMA$HQvqKKI@q?fU)I2nB0=C3I#)EFyn{z%DTJ$ClKxv`T3P_}UJn/^HwF}mv0;%VgHdz*z6:peM@{9<X8qoi.`._bF*Ata1SU}sq<?~ioqKAu$52Ib2sWo~m,>pe>>3A"n~e,>ps0G7?~c`QdsWn~G,tW`sAl?~V`%a(hm~*+po>2u(9Zm`3Zb+UzK@UzkiXL[sq~`8nW]qSEm2Qd0`U%V(;l.Cm2;c0`clq~7;ZZW.%qq~6;2yM[#}&~k|(A>~aLQq_)^Ej|zA>~ZL_e_)uDj|:DfWZLsW_)Ve$}P"n(5FCHr?`Oh~mXqW;vlXr(v?QN#~uWTL~)rc$}LY2yv?|I>~BwP@5qI0)I%Hlt>F:WpE&W^X,OYj]Py=`U"Vsa[pZZ)QO&@clG|q8WmvMl5dWi7n+h6_^z3`.tODnLd~/C;#@c2DsVx(HMaBF5G;L8?B`~1])0}@K"thXqYj([]`[Qiaso~Z5h`Bv_TEmI9h*B>>LcZFOYsCcYEBYLrdE7_:k@X47tEz*/y/&D8G{JwGf6$a?OUE~~^>)0O>q64QXqZ@7W^`n_!(/>/Cz($~lnRc*Ba4dtDf0q(g"}sL.jyACH_IrvVOfyi4vD@M$@tW6yAtRc*Bg`tn`uQ_`79&[]u{uDa&3X5yy+NW5E:UeK!}pY]~@Y0iTm{b!B]s#UUN<ni<bFQ)EzDH``HrI7Qt6I+KJ%+ZJa"E@UD0OMlY]ECF]f{kuvs&$)6aim7bd1kX4CDiZQs#2R"Vn1LD=f{kAZrV"G<#c8IUJnr1.hBL4q=y!zYB7~Xyno5F>(2?>rE+mtjI"P0#IBwPO>IA;Y[=:_|L26j3%[BEGY:y{Qw0W%iL]EBF(I"ItGqRP!1v"F,Fh/+9gq#fR/pt)NpzET,ZfThzlC*t%ngM]`.P:[iQHSjWUcJ9vB|uzHRjZ>I3iM*5*4vv[hXJH&Z&vbdmh.SHP`iB6fe][e8J(IU8in%}UuzW|X?`+~EIEh)M?:<n5y7{7g9r_y>aD7h@TsG"8B_kj(PA:J6{gA}qX|9+`rSDDi9Zu/8$OM|Y4U_t1JS@r0TsS|5>"sh?cb&feG3#LrZqwm4Qs<4|nH4`igp}QyJ`aC9R6}W_L,!&iLe~t7c~N!o}F>kuYG={a]KIHCZ(,i?btnlt4Iaix+w,%_pFLKz}*zWlp55GTL>8S^<~o`d}@9(j|7#sP7Tc:{|CF}J4kUi_52b85FY`aOm_QZH(jubJi7>t3Y{}dLisAOOI2yG_P4ht^vkCo(By/JHAq!.rq_5+,rqb"rB7Xc<shLcg:0|}=Z,~nJe*%#MEg..3Z8m(2DaYpG/O{@Jb(NZE;(;IWenL8r@/k^J8W|S*`&]pb+ej):nI%>5Va2s>Sc"5Ar;7sp+58BL)142IXtYM"mx{%v9yb~[pW<;Hr_p+GU3{Z+014O}MP(%cL|rU(tCK"M~&>pXLZlVtbsZ}JHVJi7rBi_)0k[O2FT#9YW^aLq!ZB7d2^>SHW(GtCxGwWBR|h`opN:[*WR2>nzw9rYN{R.W|dY]&B"?UWHn:/b5Qj2B=R~+J^j8u0dP,F${%oIrteLA^OSTyT<Ml.rX8re$%@+@5tqyLlSdMfR)bv{+">vpCyWlBbXBtAp3T`a?1f`}b^otNKu#4VnIR#G:_j_UtXIIzoOkK3}YK]4nUAt|[Nq1js6E}cZz:H@KI|$tWVO2}0.DbAD5T;I3+`~b0K9kb&}}D?Zj8^<b*:?>C+Pf2QOFxKwAJF*/.K"5D1|#ai083w@PWnEf=8H?w]%?Qo+2>vtxcWiy$sp:z~a5"EX42rz4sWD9a>J7`FY~qAZ6G2h)<`Zq=m>=[AI:1B:be,.x2p<JFi~%_V_<Z~R[odMBHDy^UzN{/77i|/u:&hCfSmqi=%K}`~MQ@FtPX/sXO6$yQ2/XK;vQd=?aT?HyJ2P>sYv2/@P!WoW>]z^0~"M<0cw]<2+]/hT@Q^?ql#sJ7t>``{a"M6[wNm}*zuYgD5E{~df%#eg~&yu+IU+)%[@d.zux_6NPdJ+=zU+~x2|7JF5gZ4G2hTvnD7r{Da5U6cCfg<tTU*XevG:m|:Jps_A/<e+|I^`MTm:rU&{(>R$Bqx+qGkPhsGUV_&<9*JM*[VO,>jou@Uo!@js1LX_,L"O|Xm$3Y>@Bu,Z10rLc(+:J{yQZ3}pfV9A8Z$w{M@&0LgdHN3IOqQJ,~2C|qkuaLpBYv%`*I>HMz`W.QfYly@)CK<R@c)uR|*ay=1=l<}lrj2+UOuBPO7}vFiReMEoj(}1dB2wdJ)zb~AfYs#2>}_Lt>]=:CZV)(rM2`2VQihN~zrWGNwKKI"F]r?9%Ytn"tCd,4{3SBfn,tLnDyvaLIW"nMTfz9:EeD|HNsQFN;[b*`Kv@ao?Ah}{(geYi(bp]l#J`Qq"sO##J^DZ8J9!khtVuQA>Cs.*SmjvP{cn]Bj%CZyE0?a7L|KYIj_vw.|I6sib/}9Jiq>s`2|YN*CX_Q0|+56jlbLOeuC}N[gF0|m4|19F$F>QZLf$xZl#"Oe~P5m>C!n>XbK/gC,]~Dit{fMr*i+x[C`tEzlH7%(3WGVEG),Ml%sn?&@[]1(1OyGb;[~G.{0mW~lrFrv>a=,[wSX{|g3[k^Q&dS2X.yE=;{f1JUL?QxSwKMfa<~7P?z8|9;5sHQ9>oW/LXK6MoE*Z;Jtg?>2E5~6<GV8:vb7{=?Zyk_@XX@wvC)dW2BMqAl?5bJyK85,^~mj){N"Rm(h]N+R4f~;CZ~7Ra_y%cY<dnKh6<E|<weCx7t}h6h*jxJJGI$aRnHg`Td*)rIa0&PhN{hrS90s9G:Wg*Kw=:6ri/Lw@Yq|Q_lGKhRKOs@h90zaF6AmuHBSJwKHUV[kM8~UeaFMOnBkh`[{aJ4W|z@^&}BieVxX}R|A4h@;2:Q.`;UF?j0eO^h=oMQ>&J]iQP:u9F*UH!4gsNNbd#[;QuCz.HkZZYLYFSG}IV0s|&?C(0N=s[oh>#$.|T5~qQZ((^s!w.&7xfD!PQ)6PM(8X=AEAPFL/]6Bqkvch]Z2>G^cg3GI`Cza{Pw^rmD`4SrQ9o}cj<lLgL;`O<_&%j50CGZ?9<bhL~DQt/!r9P6g=qLR#vP!iigRZvXLvnq?A!"n7.&%O$pDDZSwz=G=Pwuij%~:TdH`&`YiS=xED?9dK2*4tKX62|zF1$`<K#n}.fIj+@Hstf(x=@zp|1zCwxzFM4>xLtdVKcM1`u%YF7I:F^pW@1>E(vkl]Y+wtRqu+EJG/OR.e8sAGP|Q6(m)SQL5EasHtB/}UQ4XQe=g@gw,u&y3Yr|Eb%d[1~hks]1Un|+wb;~yH]ghJ+DlRUqb#zaQj(zs|5HdqTelt?QWk.md$I_>mumpl&Ru>Tx3+?b{`&D{p_97EWGZX([R/GLqQ3v)iT(re,VLyaL{:ZOLq?{H1y;O(BVNZ"e<_Xn;W{iR{Y{9C{r|.u4<3uA9h[p9^{TTxLIk}H6;>t%$j>yNRMq=.pe+6I{^iQ^dGc5hWJsBi)G^)w{ufRW%W;J$wGb:~5Fi(3JmI^?bMF:iW1.@du~&*N2O`~ObWQfl1$2#gl`]P,*:{slcs=v<s+fZ])|Y(o(PC#$u{%WJ!+PQp<oy0[RHZ?xvdC`S,CMAErs<y{sG$}PQp(TrVhUa1+RJb?mY^{iB!Q0e/[oHyMBVV*jpx6ChgEcCMaQ_d.0rV/;X4zg=7mG$friZQ_d[pxL.j)w(nElacBZs&=C0J8CDg2w2{0)~}W:y@!c*t<k!MsxBz7YQ9vmq*P3M^*0NM0K|OG)g7A)B1NMy2*Z&]?ISqG_*0NMzz^PE)lqAdIeR}?DV|:%!:4I%fEWB"@IztxC)(zPENnnTvK,i5pBJ5Wa{I8LvGb2<W^>T&Affl(39#$@,3KS:i(Y,yJ5@1"2XvaQ9SeO(KPB?Ql@!c#Mn#Dlkn;["0vG04l5ygIa}os&aObmgk,Uopr~mf*j5BXudsi3%RO{7Loj"+CQmH{mY_<6AN3ps!<*_N[3f?)j{"WGWl?|TU.j`tJdp[*?tGd}.jM,i5`X!/|@eW&<xq+,Iig7i"]`%w&H`]w=jW9;E%V|z?(|n?/4(z`IcLUH%0;w50x80R9}"1P@c|laPL5]BK9sHPzW$jwszzfC_IML:zFBrx0y?Wy"i5wY;7|e2w;QgJ#j_$sRFBrxrFbGy"i5hB,5;hg7l7)@rP`:8lGK#jLrq+VE=RTVX7PBrxcykRy"i5I@1D7(!c^4sB;hg7etU"|eIa=Oel)0D:;SdJ#jBppZXBrxDFH,?mAcSqg7AU``t5=hg7v|;AsP/u@p.uXksMI5))G5W^vurV"otNm(O12%<P2%CNX>UoIV{I0(!Y~YYG.jW"`YfMsx.>I*,!fWWhB3{6tI#jSmCazT8MwPR{`W8C_IjW_IRN%p{(_92:R34Q!(ec}Zs&ua"VImrVCWGRAOCDJ52TO58u`?JYej+n||Kw}$0/glPOLM:bvGl.j?N+94&OE5Vmc3%NRLrw9/n8?.^Pa*X2rV?XH!HH{(]`VBbDsb9!Iz97@[D+z_0peWUu0R7}ZI,vTO+0C:9*4QIhEa~>||`Z=V)!n~:gioPO&R">;<~(mceXb:c5C3i>W7iVu]qN(32whLnR&a9tnuvaiA)P%/UQi:^z6Lm%p+G!!WGUSI:{!LI6aQ))7Z;XLjqIjvCM6SVdu1$*B51IIO[HzSZdQ}V[cS7+S<3brz*H+>Si{/.1*w)_M<ODL|l>$~/sulfn5D<srr@6Ma0I4e6&EES8bbNYF$@LO}g_mU`8k6Xl1;1SRzgktj&8cc]8Bwja.Y{x0Xp>FZl5#}Dd:*sIKD]_kMSO1R8U:bEo;3N~9SMOlfywDq~r[BB"KdJ&J[:P8sk/qW=,6#`~_~@>7P4tI,7M]}UrhWgGl1Jlru_s62afu_.1)~G(&453n4H>dGZ|/W|hh`,Arss1cZP;zEyMF[xqt~vn.Ba~YBl1pF5y%`xan~%+Ic1:qPe|K;>~HT(0yl>.r8w|F)+kP,Y#9J(h{*eD9_?wd~dw`sXK|4X}_BmWCmD7w$)B4@&H[~){85]}Thk^AOWNAA(hd.>jtcO2.`6}%RmW"(uD*}hyxka)[q,~6UrWO.x6=}I!fn1RCScZOu#g3`8pI4b"9G.>`u_|[Wks9y{sk_+|6hC$9Td@W;6}Z:iWL`7T@@fp5y5`5ar~PU.Q};`eL}CN=s#`41>}L0s/H,jtd+[|b44%/[</psZi_srOgN3^$=%h4r(hi~sx|s)|pe*Di}!jSW4r4XYq]/=2!hNc_O_s%8pCR[&H/}b4&~X>iH+@0Rr~_gnWW^41bVXm4yh#q1?}63:9Ke6k_s]J]Xg_Ve4}ba#j7~{PRqb:r8U~+%>s3tkh}MMP(hb];<*}0pqPC?Ve5}xWnauiC_#g]~89>MA;nW{(E[>~i!H.J~9C&>9?x6_}J;(hz]o`9hG0^E[*r8+~]=mWL)E[ws_v#hsvbZ{>UBnn`($an;%6:},AQ4GA7M).UBT}pShWhk_BT~,wS4#Cj_>9{6d+*|A5r~Be.QU^r8a|~ukW<CTL!?zgl`ev7"},N2est_L4J7/C#,OD8}P"8sD^cnlhm_9~c7d+*[I`o~t*V4i?`u)~L."P{}C|)pw~H.2Lwckn%l)hBUq,x67d,Da?rW[,6#a|QNULJ1VL^@de8}D@9G&{}Vn1A$`el~q}z[gJ6C|v,WJcJo+7B|OD&s=h|~g~!&bZ]ypCD?oV@9&wdGp[5"Uj)^W;ys3WSLLi;Jh`HTt(!<?Q[|$LcW%$QLj.(EG{y|V(<R>OShWxi/*~w#Kcd5.`y~/T8A7}~qR4LB0[a|iV#Dx,pF@9n?8B}SG?W;r(IT@9e{`a%MO+Oj?}^igWx(hn;+Cj@HO)*Z7}r(~}Xr@~UMx:q4k6M8@~pN/&}4/75yb`la^.&S/Fr|qW8+5SU|kx3ha9XO}sI0Yl15PT5yX`67&~HeQq9.]|nWxhVLg|9ah~*6P|:gY;Yc*&E]1!ls(F@~TPx:h|!C7W`9alz/P@:}JT:Li~n0]e[|.1$s<:qW$+6#W7f^Oj!~d/_Npg@JVEu~uvIcZ{0[=96&cZ2|I[]~EM1!*~`2Lcn|TU~S@_P@+C3M+k>~c){LW]RK9sb>VL5@>;2~n.>D(}SHgWGFW4q~i4>~0`7)(}92n.I~AFKcP0,gr(]}9n+~I[D<B~*2n.V2E694mq0/ubeWN;,Is?G~aA8s!"}AK}9gTL&|o%jWf`4tcw/>HI#?F~p2eEjWpmP@%~z7PL2|9a<s#|lemZiK"1PLk~;>m~8_l!#Bs@R&4F|z(_E~L$.vu|~aaW^by3N}>p*,Y(o@,vR]odtsm2vd^]`2Y(QjyFV:$NlW!a=22}Bg#hk^?$v~E].vD]4t!|.bS4oHub3GwupZ/t;Mia8E06hF;cdNeCeR>)UHeDIX>G!dLx=TbAk5vKja8ExzhFqzs&)}sPCNA4s&qrT_IB`_RN=)sPCN)srV0aXD5L5BU,7~1+4F9(ecEH2/CDdN{"|N2MxQkHrn"}ecnuPc{{yX?hPO^|xWRB_/e"941[ccCH2/Sv9uS4xwzRe&_se~K?0aF~v2WWo_ecD0y/Tw)4(f~%O1I}PM"V"Ee~EMJjaR2ya2de}!8Zd!4Gms$Init%67TmIuRw3?J~UEbE"d7pblSi!~Un5ym}+r>~QIbE0vExcZp|vg>~rHbEHm]u,)qSj.|G7bhK@D`=a);m~wPB+5buO3RZ@)k7x,Dxz!:~3OVL8?ez:~:lbE2pYtC}nE9~y#]>+#@|w?w~k|5huNA"BaI./S+sec4hc4kI0X3YQ./S.[I!#*Ic~7<]+fQk5R#/)=Z!C94icuw]w%|U&C6[X=x/uO%0si#a#}_nrNQcl7QTK)`wu8<Zw$WMtHaST&lS(n[PI}j9QxOg30lrs.Sw]G+7fwxpTDBT>=+_9b6ZKSa]klNDJ*mEu>Vd2X6c+4fN0&KCqB<WG*4V~,?GZc5GRW!*kKq$Aw<*vLvLpm{pZPUihc9uKj#HNJU8dwL$64kHm/ZRLA6xYP|<_"Qx56e5ewW!qz8E[8V$>]qMrqwuU+y0W&S+8:OYw2Bw&a045"dOOX.n]<g2Neqn"BQ3Qi!2S@!uD1W{mnHx^WI*Bq<]$Gz8Elp}KFiNZ4QGkxQ>a4%el3#a8GtOI.Q(kibI5XgP%_hDfy>oEf<Zh&Sa7:YH&&?OUeT/F>I<K")[l9D^h4.R*AGMjB#HYtYd2zqQ7O+X@^g$9:}RwC$e[;F7?n4hWT+IF`df|cJ:%p*+?LI]E+dD?Shmh26IgN=kIz$q(;wIdEE6e0gk@/@1Tv_u1F|b;t@$I6=&ImLS>ms!:WAZ(4HN;&9XQC3:&3uW{}FNUb$;#a:wuWF[@jhJn`K$HNO<Ahg)2[Om2t1NMWcdz`|@0<e/5|<=tJ)?)SxcOd2]LHzvF/cNo)8y[b*?XNb<Fq:=*NwSzyQ;ijHgu#njk4>`p>Zy&q,3.)Z"YcWty_GFVv,#{Non~Gt;oA#y)m[L:OXn"Z0sIGjvQcJ%U!d4GQ{No^x(kZ:CbNmo1#ZIRfB:WTtOTNYtk+={~*G1c8XwvhBb^wg8?IHm[:X![?hT<B_i7485ob*`xN:d|_HF3w)u~U_<PgGwZLJkn?ja!F{=6^BtuIw$6SIB2TD:2SFHf(`)XXVUCJO~hwiA2:S&ujpom+8S$ZrT~z{e>lgsm9]N7cU./9fa[LhmV}8E$|aCUCS.#7vaD(`<4HdEm!x!Q{KIRS<n%k]i[*>L;Nw%Zhv34t8G>Z=e,Dfje4h91+/USHY7e435KV^5#YtckRR=PTYb_gx*.:}Y%vOr.;_b1z6UEsOyoyp&0f1YO<8B|Dqu*vcjCNcDB9.i?sYYH`+g,[#fBx{Xbh>:fNZAq=GFxmEEAQjt#h4K~j/jk9)iErzw?FK}EVFum_[G{{"MS3GFL}bQ7Ad*3Jz*fWyqSN;(k(LV[QBI>m?hS$>H/Yf]$9@xM@?CO2u9*XsiZw#hO<[5;CFDz>;Y2IdlS}<9AXo"WXV}ovO[Ee`6Qq>UMfgwccD4*m=tFr}0t*lYyL6aZ`(,JhA&UY:Z#op<buw4q?xC;G>/h7Vw5{[:?&@^QSfZ[*:k<f3BODoBjPV}>9HYM.TT}0D^|S<Ub7b$w(PTl}r75zyidG%6iC<KlMDPZnJ7^52QRdp@Mc//CiZ0/wf7VwHZ8M;dO/>WYRGl0K@d_/@{9SZb24=c3kF?#KFgmzbm~LuC"[j9EXNbwAmpWKcGtx8MplrMgL|M(zHZ@>(5MCrF^TPByIiXQzHZnp}/d,Vd{Tc:&JbK+elGI^K`z/<oE~sY_k?x{:"`!V|2_"Ucg:OatR.4NpLb6Jz1v3#;D5UJ.;CQ9X*?46CCK"t^U+:2by64&M3<|GBEhpj$f{H6?hgJ]$h[aV(MT3}blP8SG#(S/BRnTF_Q1:GT~^yCN0gvD^otQ7|/r>pHKpY8ilEM*EAYAk1%iuJiaD0U8EuhT4mY"cl%#ZnDoBo,fv77AX(D?DSifff*HOKOML@nfgL`(%rPg57F,Hm]9!y^Hgg".=3J4X@lO;|obnJYsX%JK>|T1N_BYW}>/W43z/]h+qc}uPzddGIqyan`GO+rEK!<ohh{q7>dx?3rt~NJ@_$D5aI}f2KHv(rb>m$VK!utN56Md3N/31(;h]"(bFic(p9*&3FNn"n9a7[Zb*)p.U6z{4j@A>{R}|.w@(<<[$:GYGz0"%#sBRRl$P(p((vax`j"k!K&OM=FASnK&%`C"Aq:]hCRP/_2wlDM7&th.gP{%>uuXz:qnK,q/>"&ztTZjCbIv(XfZGy~>2:{T/R!A(az"ly]%f:{I)EUU15K@J)2bfWzbmkzHB_[;*xWbHWX!%KFr8!@N/nyT}Tj]zPp.B%XbNB,lof60G:`y9qMaW!X?$c#R&1;$D_m`Yhr~bx0>]{35Za2kjQp9Sb8M?hL9Vl1INaO`.?xVpbaC6p4%t)8LQ7607=kS=XO"W(%3}KTGsbTQ.1pXNPyFqC9MP6/d0o2[$.s+8{w7#bS9)N1q>Q.ptO3PB9(t3`61Zq2QmFSw{h2xGup&x7k~M:qESSwdAJX@Q}}IL.uv<gDCJ{lt:OKVAJ(S%HD/Va7JwBLSKP``m*}Oh(X%UIr_H>LRw4jW>/=iaoi]CZh}UluzZ*aV}VJ<qw4%t7Ql?kHWT:pk5|906HBVf7c>{<B37utk]jyq$`j0]Z)qc+n}HOuyy]ouypxz&hlXA?{lFhLMW9vzYi{8S85Jt"F%lE$z4|9b#aMcKVD471&v.NG#a&9IDV@Uc,I%d2V?XV3a6@;F*NO$!#Rel://uzY;tLk@M<RjM^7`8WDU62<ghRG[rX>+u`0<qs6b"Ae]lqU^jfHZYYpl7!2Y*@^&JUDDwe*b8OZT$|[g_&J,]QJ<fG$sqGY@@^(IhVGSV`&9Ztlh%iKavr3`mEQn9/t5UE(8VEjUKH(r5~L#F+8atMqIuWCq+n&qM/]jD_rg]IJ*%Dt1R@=}wIMI$:PnmFmCtTP;&yMYL&9H2V5npjB>I,c`l9!fTf)6KYecR1.""8FA=<fA.(c)"l2DRWxYV7^nKwvdO2Z_r36?8+/RI&9[k01]&RIY;,)DN"Ax3)pSW&R&tvj;f>$):gg~].t%kzXXDp]4AEE;SY^ML:l<t2G}eg?Xzt;K]$9lO.,!I7f,lcU_)+f5*zsz(<7|6!dZ("1eYF3lhdG{T}}8!u7nCkG!LpIX}2B%cac)i#:HSuit)8*ivW"AwqC>tQ.`j+4(RR|_yE)^@tv,$<;Ft2tAa<;IY`4xf_Ix]ZUH/v#=<!XBz%yLFu+{8JHTbH3rhhG1S/b$wLb3S|yEtKo?;}ooT^x8Y>ls.;WZEZ^xMkXhVvW;}n^0zjx_q`]hlO?~$22U}0.7(%Y4hlGaH5vtcj8w(k>C"K&qp84"=fcmh%%C!amRJ7^xMwz)jF@0iyRF0|Qr|ta*Ho90Y<P_P(ZR<UH#r:ZMzNo?:PpQuZI)nx{A17Lv#xxzKirpweXm":9&Z^h]/F"q7"vzM]o?vM~x8a">Lxw`f`B^w=_>;Zyx_K0ZE?<*fnv2~g_k(rQ|zEzpzLdiu)^4Y{]v$fn3oECklLUU4[Lf(`;|>AUNB9d)Z@5"d,}dIS*5[]fNfsZ;WuJ.|`]!*r]PT#[MrRC0D8!t{V31t3Z^kT}z*e)@(t{lH4LZOi:Uq$NJ"=G`;hxF3Ce@FDq_B#dwZ}lnN9B1Vp;N&@4*h[n%s+*4cOt2b?_.CM(,2`;gE$Jhi|H?_nZ6Ub+=}CJq?hG8v<tGI/Ib^[*kh#c?&wG32.@jGdbhDm|_la)x1h"RcL&rzBM3Lh_CJ];phCz8b&U(CS2fteh|_}9Fx~QKA,4"u+rO{$9~$*tH*aC_@Z0qqW%[|_lOo@;=$DCF`%Dq#KJ,_CJuZ"R([;H[lsb>)[Bj|vxU#)n7zBD.ioTwGD+t2hw"oC9t7097B7Fd/v<FSQ:odvc,Qmo&NP)73t{]WmdL?`B]_5,jnWGg.4V}DC.,5.4r{A2d2P[!9Xws=z78Oa&o`bLSt1):3Lr}4G2AlEu8vcO*N%r"Zxc,tgo6L()1*h=L+khB:&W)0qUa&}!~M"u>9)Z}V4g&eW&IBo_mj!huzBKCcC!]?>1U?$QVMs{ZRsPW9!FGnwL&Eyjh_{N4,Kmyv?J]lMu3T~]!9u7/M!W8:sEvAe:_Y2ymhB:#giw<cZ{zxPySm{,VrOML:]v7vv&OutcviB#56WqcuF`@MVr!?x%*_>;Bp3rYXzcx&uub/!rd?cdCI;D$ibRaMQyQdW:^;*drR1GzcE?b2L)$zWvWb:Nm@."EpM>77/RT*7)56p%<ZsCE?;e6pTb8c6{e0OuEd:uzgEq1IK!FL`;uSg<Ne,aZ>ZUuyRn=9,+XJTv8I@wVm5tMNn[Wb9k97(*|nQhDJD(,7y`7Oryo!}ezKQ=qa1qg/`l;tSGBtiSf](2"[:xc?%eWEvIrN_W@=vD>MMv%&Q6R/23CD&C1>CaScii)%B(X58{DbD|F}9F^7[rfa;(zMY!{jy)exqdbv?;l@PpRXbQ{y"nRpD8hS)%2_V5wn$YVq*6^`d[Vx?g3Wy05N`GmP7kv`s"lh2z{a=BGC:I#@ocp/)3=qfaw`~XM6>Bk[jvWtiCah1GfA8nzSQ`6.|P/[.7o9Xn$gd*<B8a]v#jAG`l<t,hk0Kdpqm||NM:>?LgMKz/Q/7b1;0PtJ[[%9GlHfbA@JW?g3k<1R)SA=5b6yOw_(k&o:YLkk/)X$~%ki*B}f^l%y_uYK(rva9t&uR)@Dk>0v6R@T)qva6?[SZj*vJqIYoG%FahN:d0)nbc~*EV"otuUV/;E{bkndjfv`/b8o_cU2"<}O{9uP>yxq8v,^~(dSr{Mbfaa&Dbk_cy;I`H7BX}S$@SUw(JT[kf^}fLwq#a<(^L>__F4`:yV);d{]7wSzki4UG`gyVKWM#}r{C~ZYknww%_ky;Ky]gEX}{0KaKtAiUh(O2U_FH^whA2j[{u?Dl8mz/Z3vt`j1ykYik+jGC_P2AwSZf&fNa2$u2#W2ur8uXJjY!947vhq$Ku6@?Kg):SPS_lDrb*6B@"X&?XWk;n@<`ihDYOY0HAb1{7Cy}Cu_qR9Y?M80jZw$6?~+<t~S6E:)4h,RGnE%u29~J|(1:@,0SBYq7^4RKG&8,&nNK2<Cq_dSq{IBXjBNn|(1C]5cfHRvW}n{*Sm_#.JBhuRQ.tx9s/ILHIt_PS~A6;e!e2*JnNO"QVqa1VFTp1pg?NR&WdlZ;U*=?=hE6+we9+.;*&bYh+_8K[kND,JHc:aT{iE=p/K6B3*H@y]CM,?Ukdtyo&%)PVHapb*:id.QIR~QTqhkSnbX}h{V{iDgjS~A7BwfxD"2{q%~]BB7|hftrz,ieEE67O;hB,7b:Ok6y{TdGGFQ~hEa*Kn,x<s!>N?(bLaC!/VR~O=dv2iRl(jRi8l)$W}WX[2GPhsM2M#G2G:g8I=@B"tKU4q&Hp:!j1x(&M*!tJ?^q6!4L$]n#a(!,+2RAbAVDt+[~+zd#aP=u=%QqXf@j~rv1;N7fNE<]Gen;=bGRd!8hX+#rO^R$.x7=K>:(tx/$3D1eqfO|5f4VxNv045njlCrFCCmr%7fvc+i,gn,omy`>?TyU7f/L3`Pby%]{c<@w_GE7?QzkX?b/[m94)_lA$3b~aGYs#[/%d2zaT5eo}MO?as:NXc!7%pLgkxL+AIb"I[D0Q/!(S:BB9_8iwKx58ixC?dbPaQ&464c>WP@T$VZRVs8D]?6xNZSoQpS*be0m:ylY2+7Gr6l}t"]MYR@Nv{N=_M"3Eg".+NY[(k^~zeqg+GE4:7G&HzH{Q)i"ZP=+MIuM:O1TA,^Dk26"ME<T*_j17OX/VPm8*B;9dkIJ9Z3fdoc~}@b7EKkf?},,Or"0CfYe/?Fuh*Y1mXXCWauWwKPr]uCi7}T`!]MFFsK2#oouIb;Px+hA/BpRZ1mBRTvVfwvdIqj)/z_U#G#|TM!$Cahd=|W!k3p3kEt^=WY6]t.khS/T3TB:vBM%ypak(U&tQ1._okB*mEAKZg4`;O+>MGaVgla|#?O]Ty~9^U?Yd.C<K3}LtZ)f!QqNjm]E)]_OW%t7|q75zmq?%2tN/Nwf)k6u@blil8&6eeaW=LU.Z9v>O~0k$DO1/zX4m5ek@Qk8ksaoukb]],UZ`66mT!Zr|bKpA4"`HQQ!0T6i`gO+FHZd?"*>Y_[YCi2?D`9ud_/~m;R0#S/Ws3@[JMb>:rS:P?LDHywINTYFx]W$E5w5"(dJI(#!B0cZ;]lhl+Ehlm#>`_@aai=UAclQos9CD~9(=L?XXAu!Vs7QDw{TD/12Wxejn^[Shn;SH"S`kC`2%_)@T$zLB2d;cRm;qYLX"0CIfyFQ`3%0yc$oZ#NiQpZYbiGZ6g].tv^Mhd@2kj|Nc#}rv^#.BY.3jbNRc+S*ETY#x8l8RWS"a:,(2U~)5N86cazaT4#+GW]ky!PWm?j%l.tMsNh(4?]Lo94,2{4^md*Jm4C7;+F"N.>>vq!r5i<H{QpQuuQ!PsD8Lnu?x<{[n_6P]"YFFmL.nUeVGCm;"a1W]SQawq"#eUdSzG_(DV23[b5:knNnX3l7RQET,5ri.UG_hP?D5CJ8^f4HB=BvyU2k,OtOdRGCm.H;Fp4y!eBg#WXP{oOoiA#3RVtfivojHC2Pxpj(EX0kCE]tz.tsNy7<[W1n)k68<4R]MKX+ydIpsF0+Ri]=cPH)q7{vxlT22njcZAX:XJgT7?;/57eVcaBjd$F{MGe>^{SefKo?Em9PBtHWm?`=;yBTGKl^IZ;CHGaYurB)%~oGGo0j6S;BH1ql|dx@="qE_pN!15%Rarn]<n&z5s3OCoQ|:u:fS[Q#*)pCmdfvx7*I|&+dMP[$96Zx_@)KWramV`XXrAa&9OD:`UgtG[StjgzDRnh</I?k!+GGs!r;t6=kh;cFi|WklO81CL0Nd3w(Ey`Afr{[hxUwW{QPZ&9RwF^!$9y3U?t=Fte6{_yP7fZ.0*f8T0UZ>J.hKWpqSC4#Of2W`$@rX9r6Z8?LuI"|$TlMO%:P|=;>MKR/wt5K;,zy5fz7{5z`NFT:)g6|1_QuK;~~fVHuF;.Omr]U%X[$5s<,s9i]u8!3xekADH}$^kh%aTc>t0dq8"52[l/x~Vr!J":*a5u!#*rqw6c$hNG;S^ZV78.1&n2F7Y7h*l1KwE_Ki[t){`;KmDRC[yqG_vZs0Vz#hp!ZxDz@Q|Ds5SC;yW>t2<f2@bbn=D|b9gGKR}lkGl<V{tES&bE4xS/_)Lk*1f]mHkBI_/:)`~;99fOD#C_3PVh>Z^4,Fi([?cRo]V9$@{1c%d0C~r{%Z22fVr_Z=yhA!5N>&"Myn2v>Z!SVr6Bt_D[$9*+{M1|xFa>1t(w/kv?]bN??>2>_^j2PajDkS{]/A5FNg285Q_F9zF69hB:}r)1OOU@(2u7sAi*56VNeL]I9ux}Cs5;3}cd|BrLNy4[FnE.OuOz7?cdPxk*dcHHCVKH@av0mhxGBK;l{@Q.vUfB:nc}_l<"PmRCBDLnt@1xS?0$56cY2@6af|E|AKYwox[rfaa4vDC@x%vr`2BjAk%rfalayW.h0Q/?Z4QRFK9&Q6QuKa|u<?#K{n@GJ`=;+diC3L7xL?.3.nYEnj?;YH"X!YomC?@3z4R,Yv?gc3!GWuN2yQ[:d)?M^:LgT1_YwcM3w$L<%LPHs_FQ7m>AEE@dr{,kNm1H?&XNAGs1)Z{]V4eYRRrBA=i@]aiqu>vqHO6}pXZ>W}|h<yr7?FxTJF`lq%h|j1,H+O.:_Q_BRUc[bHX}8i`/=FQ}G>gz7Y1x9r#a"t<wfL2RXFg>p7VG{]1i,H7id!n&2:2WAR2w)xnGow]CMw4q$[?<w)Gk)x{/QoYylok8b|Mg3ZYh&z=y7Wqr@)jYzLK2C>]l%R{a1,nU5?=4jn6T8vi3,GIenQW5(SR(nPWP&0/eErCG4nZEo2wn..&IZAI>bU1%%O[M_P_/*VtJr%Dnn&JAx@Rc5IVMY7KRR{"1;j?f_>ySQ8W`y$U>!a.KmZkp^[$bL++q,;IF.)Q<cp:gLn,h/*h5a1KFZB4H%Xbjyu`N"PB,fk7tm4[H>sw84y!>:#UDL#w*x6En:ljf>RMQyE[_hw[Ek!:|c!GI;0yWVB3V&e5o7m!;i?X!ZnEc,P%H3/wywY&ORHI=*sbW^60L"}o=rb_KorwYrjExoqUycuBVcg:v&,%m9sQKJ#0~Py7hsj6v=qiyQ(Wu$Ho&/3G9n8=6KSuD1u`seW~NNd/:E?r_PcC)9WfG+Ca8](n4$eoCW{/gyFCCNdo`8KK"944uP5tGJHzzPz#jW+NRR[ec{/y/Cr`##7^z1b[n?zm.9QP(:h2f/7&qs&nVDqqr)RY1ar!q2=Dy{KGEB;E&Fxt]5H?wU*!?(_b~m}(}:_=$QV^l7,RBYIP#BUBX0:mh$`&U;3ML}xn>@zlI5huRk.C^s~~{6$nb6G&YyOCI&2}~|+DyU]|n,}}g8a={T|8=y)M7YC3w*]@U0~$vo^#_k|U&TO+{=T!rsTa1j?/#I*!p;T$}fs6hq:nF6vC^$__4avi^$K%maF.tB`g~sVqWcuD~j{?|$<Q&JdzSaG3yc}1usW6)P@1~c*9Ta?saDGO75H|eawB*)sqee6Cwcxc+l*[O5Iy/Pw]~t`CT,cxDz7AMvg4(Ua|I"r6}1_DU&(UaC|{qcKM?I`mBz70$?kOyy_b<?DVLWt%:X~WL?J[uY6+k#Z!/^k9~{Bygaw^p"}&d5yL}BKw@Ua2"]`2D_s*d0ay/GauyM&yGHy||M1a1H5zyn05yl_,I]~P7d+%~Cz5y?~dyH!d`;^||Kt.dyETYE%0PxRS^`sU(xRMup0[i=[bA27JJ6Y7M!"p0Ur^`b)a13pg7rTT"T^5biWHhm<b2C)||_g6Jx]G:P64%.X]miHeD$~yb[~J}81*KeDW*J{kalA3b@s<EW?o=2BZ~4d4x/.FOz+dY5y[JfFs(F*xH|~%+V*&Nr^y%78`dD[9kRLZ:,Iw~h1z7v~c0c+B{{jTL^_,}UL}/DUv~]yc+}`0pS+GM9h2J+xz7_I4Rrxd578dl782KG697p0(z;nA~~Iz!sSqPQZia(+VRY+T`^~.4,d`,e5C3BZm{Yd[OTCE5C3brkx33lpBF,djxTY;M~0[O#YE5+rcK.d=,eYxqu~.wc+]`#YiW`L!fS68i|NY+eED,p0HBz/XQXXaQpE:btswvvPpECTcvsD`,Nmim9G6up0Hu.h^xU!IDb<,^(,OY5S#}}$s<})DkJ(EjdVpc8n:Zv!@>:i!2l)B)S0on/$DjCK1=j|*XcpATiE#%>`sjX0jml/EIO]|7`#"{pfT#f[l_W[=Hu&YWD3.;{_p19CwIqevXVVAXBXzPw}jTCh;U_2n;a&oy[g^C_qDdJNA9m%.KChJV&M^:K4tP?jJ!Lcly?W~Lr~MtJLi!}}WB3y2[,}js6eLdZQcxGo|})|2ys[78(slVOjPXS6ygsIN@>|E=QL#.DU=swUP@<|m,QLAF=d,;V,S%.[LIri1_/dmHMvp0BuQp8S6`r?@,n.eita$#xZ@sN&Fddq||wY6{QYV[06,doaxjc3"KDUAt7TS=2y6Nk2C2S6tf0IMjh~7&Oj,|{3QLXgiaA#<QY++>Nm&s[ROj"IYRP@(|Ju,up0"".[%GEfGO<:Uacw,[%G:t:H3R,>!ecO>)sx5KH[|a]`;0MTT4%Mr<,g6Wvdk0+W~Zb|iNHq_(F!D>oIxk0nHOP)i0q?I1>;{<kF}+{{)lg(j+h_+<DE/o`<8xss;SyFb22X1s]B^#Oq^?ykQ,Ovwyz+}F[KvRPQa:kRG%<[{DVhlQR;a3|2$:6bt:]*RIq:;+0v,6_1k90bQ&_lWhsb0RA)L8d|D6KLqb^;k6/OTIYxAx)OX,^9Sec}MN^~_E8$BN5yc|&BOW5gU4~zEB(?MJ6};i%QOj&|@pQL(_],Fg%~Jd#OXx0!>}M#2y%@+rKB,d5Dg5Nm%sHPOj9|:bQLO,DUn~kcc+6?HH,d5DRYaf)<D[XHNw0!ccG`ayb^k6,d1DQY$z"K#_w=$stNP@4|OPhIz7HH!Y,Im~DvZQ7u+)"K9+b<nz[Oa*9/5K118}_sCf9|_w~rA)}q"W}Z>>}0^V54}h^`Gx2yZ@[amW}y1!.}7Cd+igS65b5NY+5}tCQLh+y|RCz7^zYwzRA`Ua{(+[b}PLUZ0a5EzOY+!5#0IS,?5ysinDnGt%?>%$;0JTbK>#7m^9:!5w||5tKLkZA?`siC,dhDf5EJ$?p0&!y/)xw@M1#Rbiuy1MPdaNhxH`+}epJ%co&F"rzLR5<h5@i@[`yt__ytM.j6,d.+WYK#1|KzPQ.d.+RY{7tRx=~IB8,d)+fY{7n(FR"v$9SZY12g07rzrwGo+}_n2y"?jEmW;xI`8~0sB!/RG5||]Sc+}_63fW0>rP|a?J"Vrx6aEzwcuyM|N>ToKNR^]`f{?hKNTt]`W%FYnubT,B1|"1a4a+7DZET6}u~GvytW_"}~472acQlV8eQHNN.08KG5q7vMvi!yuSb*A4uoe6:Y(NY+x}>?>9p$zz}Qq%y2/_(^*)0jr(~ZFouO@vKjAdL}i|KFi?ff,Z}Q"Voy#Vgyw"2MmyIj1:Oi5@Lf&4Ln)GaQHK4O5D:N;ulRB7uxkoL6x=]`e?p0>cz/e;4yQ~B+PLar+tp0VX=[DgIVO1+<KhOUh*3!]`;]c+PzNd|WqwzRPt3e~}Nu2|{<nIj?$WA"<).nr(@)tor(@)`w}s@)lA}s@)R8}s@)v&qW@)z2u{17+y4we)cZ,O,~b4?/d?|4h?D0JrsW!c(h@@{{kBTN]=o142)hp,Ft`sR8@_nIoc{am/qPXL>F"s]Q`s^I}"}~V/h5`X"~O/o_Ve|/26!T^Hei_~Ft_~)wB@]&D~*O84z7lF8Yxq:sR%0R[sW]DU:s<$1!@s8$[&a*,I(v+04{`huyWBmR{h&5`M$`GnR`TM8J`dI.`X2V1ZPv~LJN5yOX`X2|W!yd+y4*;/~~oht*.1i~jP..KdrK`Yafi~2mP@n|g5;,7h=gm~.;3Fk0e!2y6?gt`ISLU*!DKuiWewCHJvRLq^Z"QGc+._6(8}OZTL/Iy"[OF@9/=aRh8]m0Z~/;g@w[1,.H}&Y*lN:Y#r*>e(sQT?$?Q6uz;!r>Ou6k.Y9*&&FRI1#ET%[iHL/WvQ|R;amCZ|9)?&,@~&CnGu#gKsvEi^nSZ|oZRP^[8_S/8m4ekoADY(Z,T_H2QYXXe_+^^sL^;Q5L,CX%XIl<*bgZD0M_BuX_Wy2L#hCct}8ev.d$fW6^`GQ[q="_ivDsr8*~P=`~#s.&J]c=is}k=V5@;2SQz,{1$s$Edg.M71VJxs!X&r?@!8sM${;mE%$U;37<escRqG.[Xr2}B)m(&`Q|v{~~(al>h#OL_.AN:tW2*e,DT%z8RLhm<4c_9WW_&vN}DCWn<y8&Kfk(}ojp7Tp:[>)+.}BIKqRDFMTaU@(E3|9T+fo8XXA"O>2TS*YP;y8Z,Xw>^?#=O!6$6GXY>kW_Ys?Q^<Ko(sUZyn&VsWqkwK:n717|YlX^Vy[[;Qodg#_6_w:2JWDo7YSWWgx3dRszdRf~HX3}0Vu`1I/}5~z}x=3vv+z)3j3Tk/_>)yo~H#x3rH2N)yo~~TP|#o{_sL?}I`p>];X<S@JLN0Q_7g"Wc8L)0R([rw9iQ*sD?9pI8~Y!@&~G~~@J.&fk1{(B7MxwBiXn#[QQ+j:>X$!$=[719Rm_0F3>/(b_mj:>$F4|4C#^&Rm_)Z&8:J0U.@~7d~Iw7$1m71VJ~`wX^`m1vDx[agWW|*0<_~kqOY`1Hcrolbc_#r$jcWebE>br6JA[mIjxrLPQwST%jG8s7(khCThwjGOW{`3Te"7s,Mcs>gG&RLF&.AmI`feGm.CJ{$V:$sPFx3o$SN<a;}<Lr>"f9{+15|^)@&$`mi[a;}9RSCw9Z,l$/~epY_%ZL*.0rWG*3TZtM|[!0[h^UlGkY1~stc!G3gzOZRtsd`lI+m&+ccKq_3dP#H;s)|;2FC|?TF#~Y8FVUHkM!pj|Hcx>nox_?U$}mBd_RkQmE`KcXBTkam$Ysi4h7jh[7gBo&V>30R,?rwkzR*J<L4JH1}LQ7shirsx,zrEt,&YrmIcy9>LxM10FF{$*+r[+!GCDL1`;":`+b,9>?$M4^YCnIRz}TQaZ(9ptgdT+NIDeOjE.nwya$GQBz>?Rt>8/]>4FzW9fhQe=pUz,yxB}cbI&8[71VJB{en[&%u1>Il~/mLp}/H#^aJB{XwJ3m.7ev=+|K/a}W*,H0?Z|>9Ib8~I&r>x_}~ar.&3APn2>;M*Mb_}n@*h0/sHfL|.M+Y)6k}m5c9P(gj%+q0/sN8%xf_^[QQRSt[9{C(*6T*s.A47s2}yMs|HV"rjB[w3o?x+V"rEOc34rGbT%&.NW&Mz/2basPsJCPJ/AFX8~tnh.*,P4Tw]`";xyq>wt!WKY~10hRgNIbi"#A?&P[KO|`&cE0FNVDh;xr3QiD06+^MOe2GrXy#7s:VT%HWn.m1lNgCT|_G>||lxDA"OG84vJR}FLwnmpQ@:P7>{RWw[oA@sJA{mV*`Q|y?PD_kJ8#w=HZl2}m$jg_U=iykv@rw>]JY&I5>tGb~qh:r^ip~b<l>_)Zb=iEOd0&rIx2RwYWUa#"`VYV"ziW[P|B>m(&)WnW[+CrFl>jdsQP3Ba!ifJg^!n8(]psGb+M:BC50QY|ZM4`j:2Y27s.NtsF;b~.HJ|}M#hC]9>jVmi)PF7YYfhKq`3QY_xM|_~SE3X3B_&X5J.+jz,NI`SpCM*lNcC!r;.9>U%TcyCQ}m$leC)a@le:&7I=bBDiM}lu+m(r:lI)YA"dxSniz,EiMezjv+gZ{]x"x&[c%0r@p+"Oj).`GPCmGFMl~>kO|Ory@pG5}^)<&wF$nLY8sg<kEu}hv">Hx|6()[Y$G+XYW^>KqOYb~A+gW1mx8A:!7~?e8dbOj/*nwZZ$GV$*skLQ9<bb~8uD~BBMqXmf>b!*s&N~A0]//!rP.+$QkY~/HrGa77u7sc}<>i"|(c%s#3$2_XwF(eZu>:#2_o%ZnT%G)hEk|4i[(DzZ|0};Q`r_#m)[Z>y3oVuugh{PL9yx3AY%Zr^#s%kc~NA&|C.k~2LV_1Yv$@rZZhTz|G$,$O:Q}fM:&GNsGwZn)cJ7}=;A((U[}b6LRqf)5/]<ET%_9mWG$G&"/ZRWBr|@*8rKzR(+b[_4FEz2]rszr<oz,$H,sYc5$_m71jPz~t|Mq5PN|2Pz~DUHV511TRfezy"R|wn/@,%q>.zR*}Ev;cJi(o|Q|CLUV_a|_x:k>2;`OXLs>wJM1f){;=(z<B1QY1|e(1|ugL(9GsWfj^E^Q1T!~WDvj/J}ikoc|)sKmPQ4$lNLZB~f?v>{"V_*W`[`{}&6*)&a|)suJ7]6T&&RQIqx3Ww.z4AT~|no>&}>_:^)D[SXwHl~EZxyY/z%ytNQ5X1>F)`8N:c:OB6HaZ|WvC?[7rSr"aD3H{K&eCCc0,HvcKC&Z/IzzK%?h(f8<hc1McQ((9.aYqblxuYKk^@oaia~ct!XOOjHhz2sFDr;](B9,s&P2+QBV~bwGQiNWs[QC!rvwLM#:M|c~4=tOBJap!^83"+6b=/bU?G:n^N@y+<.o@#u}]Moz%ZC0Xn/thZ1B,nE>9xh7wzN/6HIzoOE6Pgc,geotbnXX|X@o`38iw>2d>u`vF$HI]W!M`/}1KqN{B4H`O|d^<3@|4KQ)MV1Ru>Fj0p=NFM)D4>B8Aehc#,H@rbV*mJ4rn.l&,2_$5TR!uJgijK1e9Sn5]cg|=;89Eptl~):&Uvq+^,R(kNg),,tW3{g_IO]",hW[wFhq;Xb|~H6/=Pps]DAi)H1|y0x7}Oi}i0]14O2syD&WEHfsrw]T@zb|)GQijN=/bnxcDNGM[dq{)7Qbn]szt;YngG<y2O4{R)`E.yd4FVxtVEC{?&P@js,v)r+vi|pFt$g_x>YzHUuM<0pCbLi"e)m>,`L4L8^|tA6FgAKQmbdSOud;d?@R3XVjcYJ(3$%&z!R1"?aFhq><p_Wfi!*p9mM;VPI(%e8%$OuGDe<vaP+dawm1Rs4$FdL6f!o>^_yQEuP&Cn_H6/>cs|*DhckHUgW_xZUH%4I3$9rm+lTEoLQ}VDpLfGl/a_gY1wWQ/JyWlB*5Kq?ozvm46Tn/bvP*.laCa/yKh`&RRz8P3r6XVjSCo|Jfs)MCa_;$EEYta_"3}Vk*dnDzQo/}J#Nk*:mr8,Qhx}_uR7#D(Lu>M:{0+w:2IO]"3["@~GQijNTPv>:F"FMi0>S":Czna_6kaCl4*N[BxduxGLYVicH7?DqeG&AeT%:`8sIq9^9Z71+Wz_<9>&_Bs>UBR)mLV}AS7{m4a|5u>aasEoh.7/.9Vw]`8=OLt>wt,PwbwQx?S@yuzr)Hz,o35yCN%6vD;an3@9gDU[5;8h>|g9Csz<i>#`8Z~dbnLZ$w+Pg_&mqL;SK@$h[kU_bc2BV>zm5TEpmT1DGVuZX*_yO|chi_(keG<FUn7O/@kGA~F)p>250i7lq])V@>;Qnw#[dk)nhTm.8;)$9`1y%0@NFzfw9`Hc(g8~SEq><|Q|.bl>^YQ]P|jc[H7>do7@rx/s!:+bL*%Z_I3ssqWn(|*,+jk}gbW_w<E#)*l(1hrB>n+rqrpUMGS[^0C(.[jzAMi.e(asIV2QbMi.mL=_ChK_bJ:|ij9jjs^kkowFJ/&_k11i@{5}75c~YsF>r_>v8MXu!|>IteTB1{$*7rnY`3ZR"iYln,R]9^;Ju!$=bs.%Zkqn.sbyxNfPNU4|jOP%[RS):P_r7wmGx+&Cc~v?gB)@;Q`K+C>8{b},SkiuBaE$KX;w#G+b3?wZktb~Q|noZ6>mND2>L@RQ=e2_Sv,rLE}M:_$e}lA)`G@[<9kgy[Tx%ZqiM|a,.@Ya>st=:J4P71TPm~|nv>QuV_te:}>xWny+Rnst#h7XuzNw^Uwg$G>vd~?[X_m+O|~Wo_:v>r@t={tLV|JY|&NW;kQk$?Hc0g7ll/_~T>lWYCnG;}8eubbP)JOjS:`G^YkG_p#s#:L|,wS@Q%u|Oj?&,Q7+#=*}:"CNTk|0/m.8yk6[1SPNhwM#e_"H[K62e(M#zFOi+brVyrW8BaPX`&^W&$Z5`sNN1}tk$Ga~cJw}Zvf|}]~scWd=Akc=}~lg@DLz(ezuM|_~lW[vrba@_Pw93ET%~!RLmnm.>i71tRX|!Xz>3)t>;sEEh47%4T4=G?$]b_lNNbsCc_OLD(c~>_SLuuo0S@bg7/V~gx6f)_ct_%4T1>xq$MV**n.&)Jkoz08sKkNWui$G{(+s8(4T&BU_`Ga{cZ;rY/@{(BI~.AJOE`8D*>eTC~SuR$~#MM?3@<H=(!+%o.:Zs7{{BM}Er]`,(I7#~91P:2I>*g+QPq.xPs.lNVr:<W9$G3}yrv:CN0QDvC]p&)NUB|mV^|AcF`9~d/pwBsn)E[LTD~Idlxi/JYW)F0j{tE|oH&6[u:wVXu3Yg{9QyrE*z~q"M|wEbj7L%~eALqk&u:5q:t|YI@mvt#}=c{RaE(ijxbjxm_DQYT+#sE80APG1Gm:OO+UD)wb%G2;|6*~>uFOWrns1WyNKZJ:&[u:5Qo{"<pf{Z?y8BReEf0Hs,$$HDyT|1L~rB7OXmW6!CDegBv*H/z4}C8^KA]s0i:RiOq2S]4:bL}+vo>FPD76?oBRqs.duN/DsC$dsMiX_5<yrLg85n^gBmCJtg6$>!f$NATN{pgF?Wzc|tT%{gC&sNUOqNK;7ixo@sJ>5c0RfY2sU)mS?,Y`X<0PXlCxY|nb)*BN9*xOCq.5"J|<uK~&!ZnH?VHDR%z?Qrj"$rMb/6F:vq(yUmklT_S)8o"OpM^:kDEVB]&6*X>*/l/SEbyGsg/r1=`J,aPr_%YrZ_y}qx^j81*B8zb/}QGu>oMycb%?JRqB*L)!y4BdvV~v?YrlbisYM9S6}<X`&vW"}YOL>bMe`tQ{MX2#t>Q.HP9g#hmT}abqmt/igII_d$m"*7Ro_+09xtnDuWhGuY`CAFJ0:7$h^O9Ag=2[[$S~DRFDrb>w4_|bis@TN8&{+2[?4OG4I="!~`h?zr!9z$k0v;FJDxZL|8n.AHA(^0h+rA/7{QkK$IVW]Gv.5{wueO49RI,{`}w5C4L)L,H#_4Z%rsx2j_6gpm1`X<pEGnG5IkWDY.&jWFh>aXQ$_$h#[iQSB7}PcQ|Yt7s{=4hQ@as3wXd91b~O!PqA*Qn?Zyk:)_~w}(sGirs/41};s*>8>g9d(kBV`<.4G^;B7VuYLItnG0|LCYn!^Snr|u*m>V*gr2|;czSbne~MPME+b;D1Z&{`yekeLTy%>zd/JBwAY_4Bq#u1E#Yd~TzL|g11TED=9`R+bS9|$<R8hWv7sOH%!$M|9Q~)NX`0|;03rbAtg4C$(!Dz_$X=YTOa2+C)t5C|9rQ2~XUv>n.N?|s*>={{}HBX_[cn?xj`xHIZ[%upZuuiis~{1M|zLS_I2Qqw^op:M:_Ge(0m_]Rc#bUu]^8bn5fi>`f1hqI.V"efGBJB{W^B(c~1,rk2}EXe_}[wM3SG="Pl|&0~|}]EH[XF@Xs)E&W|]i(RBasz^,&%hI/,QcrJSmWLRI1nLJE{)N~X!r>*>8~2$sW^>Qx17+x$iHL0C8~}~TsU(+]]#h/uQ+B?Q**;)x/7~`Ba#P?mv+kdW.}3)7rl:g6dAr|"(;&He*B9%90HIF|PKr_JnYOu~4O<2y_dBqc2x,Iy{/MJp:<0~5zc~*gO(KV1F?FZy%Qss10W~5zUnV)~vI.%1/il}.KE2)374L4Lzx3mWp}ms5WY_.Z0gK.b~j_n}*OdR[J0r5Ipw"7_>^07>vNI2AYT~?RO|m(z</v},6HK|suK~knZ_si,)4!cMPQFdHRDh6KlP0I9sPb;2t]2CS?p_Cve|%H}1HC(k^;7=+j7n"?&:!D"`3S}!lWa:w9}1dg1hds2jT4_T2;sV353wx3`2ow/!k{2(9rSn(ms_<9)T8~SL;II|#gJ`1Y85`w}{bnKVx3vb/2<uafL{0ruE;<e}>#u>Q*&&g*!>Crm.~wGw"7!@G;*rd+XRQGMOP|5;EJK|@:ysS{]E(v+>k2H.%|DxzZ3?,})xan37S_*nj(%eTkQk?3D=fAbUP|X$V^~+eWz38~8~f.7h`ib~m(c~xwz>V6QcgAR)(kQ(dWyrf))Rb([Sb:4:=}Bib_OJHX<`o>)`^8[&o*$HHwk}rYs>c@!&~:9~H"0}$e/?Spt(xul>5rumuuPQsE$r]f.#sal>6sn}bnzK,V`d.JfJh_m<l{&uV#U[XA!r:bPK9{7s0Igj)r4B$rK*_}[Xd)c%t`!mF%+Cc=cB?EV1Km"#S@@RD*DK}bR4PJc~2,6~sJ[&H+sXNX&2ujN{"~e>xed+0@$hEj;glx_;5;c%Q1*&(s$}Lq{*E.Uff{!,gz[_JcZ]H=;8D}5Hh!NPf(/:2R"!&C|42s2,i%,`<^fQ>f^`%kfC+FNiGcbS,VW2J|RMg_3xxaBzKN|C:}LRr>z`h>]!J/WN7splu@gLV|D)A(!^%&.~a"9mpNIS9=7sARW_0LmXIHT8s/9|1;^53D]}=uLsrcY|@4NX<QGOpPT)Z|VY)<2#6}t`MqD8:2rGR_sf~sO}QXEpS1Ai.~K:zrJS`bd_Svx|[3c(s(r|x{8^lWA<d=mL?G)Z/tnIo@bg7I~6W@vIc<<4>NAu]>>it_#XeNw5ouk!<nAA/u.eEU`;@cfd,O";$P.JkSgY#<a9Bq&!gVCS[Gw!C0;Te*wgeT$J"hEmV|Dcaqbf%~UnL`$LPwYw.VEs,M@S_uYn*!V}0pT+k@^7FV(masPVlVDA5}^"6H_`jOquruDN>~IfasN1;[Y>*~1a?f3x4TN0qFgt(6cZ<@Hcz?43[9nsbwUnOt#uWJ"[r0g{1Jt#jvZ2.GxQ"l9JaK}c+O5[.,7xJ+#3KAGZTnq@YE?u^g([pExn^CqE3Ynl@6#r)yRWVj63YA&R"6Czm+Ucz^aL7ZKz~vrVsX<bSs!BbUj`xLx]zaa)c_MNQn2R/C|2J8:+9d,DEz{YMSg@{o$!:q1P+B;r3crVr:JKxk}7*e$[6DH+1~3A:J^hW<JNs_g9C(|6o~ok~(b<t|8{i3qw!|8xV|lLGX%WUod_zwb~cr[6,]dGhsH.)%[i_qegF0e((Kt/>#a~!ib_&|&Q!z4Qoi/jn&8C1WcGv3"kUn4!NM$f+BF>]u!UFC)3F?p1qSJ<Q|Z"J|9gm1O3XsLqHK5R*tB:m>j}5OD0>i@96LEtCovuyu"Ikh`KF*Qo]`b_iqB96:xj"&F+!WDZI0g_GRqv8FY`@Mo~Oobn1cHUx<5{iH>u.EqgzDWou0O&~9V)KChD6r_l<1iw)x?9B`6[,=d3Y@jC;PsnYbN|.P914ODS7>wnW{*U6/:LXf<FHRs4dWK|Z3K~prQ8k_T2.hsu!34)Hqd?.UiYVdvzq>*R"Y*BG^U4q1H$NoR0G}@CMGRQLo!sO^4T;:KC{_5L_x$.)J"WDN:4H}=u?&;>%2h>@s[0lvAEZt5e[M$&fW7D?ZeX/OM){9(^DR?vGT_)>WW(rqgrolcs_WWnTq@DAVPqjoT*3o5)KIk[n(jx.29J7R#L9rF%?=nm>TsMC(&BSq_6@y:QI0~5@&_h{c:ueJfgt+PYZzou:_:u9^PDakRHu|an=&%AW3U]j4i_%1oFDx5q^=gWjq4TmOB75i5(lOd}<uxH%L!tS|H;S#t?83<E2>3DFVSHZ]^$:>aHQi/e1]Gw%Tn{+{KmBJ,Dg5!s+4;n{"FUw}z([FmK,k#Jh7+!E1jhmCyEMyC=jTAVb<R204tuajIs<IERc)8ZU_}w"Wh@i=O(W<>ZUHcr7sm39<aFg|45Zxj^L<"k;>pvuFJ:a=YhSoDPVjs>>U|BE5vo;cM}C%SzIJx3n(jt]EEt;BS"d}2;q>sQP/Mi?|fQ|&PeD7B:W)O^!}*08|QCt3^%d(|aLkrOu6cLhl~da=N~ja]a3GI==[AmM#Xxc?ylOv%T:a{{Mi}:dKi@9.FY[C;G@40yBU`.:TUYM0`Z&8"(uL8"A*+3O+w*uy1iGkf((r:XGM[_nC@>js%[vsBlXnK`accco_hy6Oj9mqB=,8x1oJ!^j>PkT}xC4;M%QAba{eqheY2>GuhSrfeM;cx~4Kp</bxB(h*)^UZL?nOSy|qvan_7cYPayK0[c@Bu&}AcEWyyDuxaZ6+x|c[sG$0}~pljYj<}[)@&I;LLk%m|ezs|Fzj4uBS78$GE%6yaV0#a+7e]QR3Fm!U[A=:53LJmVHN/i/ACn1[W!$@c<zLIFu|Mf713D<C"wwLq0jg>fJI4jS0Y&6/_pM)WuuKku~4m/ekTCi"Cq@Q7,i$VQx|xasZ!WV|GS+yXn[._l{j,kE6?5>~D55EFOJAW["Nq8([!6x&}KB}&(u|1Ll]&Rq4)6,&aUp8CH}Z@<&~CAWud=CxFel9^XE86XCu/%KS`SRh)|2u)v~oOVn>c{iY[#sO%`f/5XLAR):#[d[`f7u?<%*]JQQv(#rXe.uX2CXV:npbPSA"tTTk3?[Sdmd4RRr>Vy+@TX)fleTB2B.3X5p%l{EEhs)*HPZ`>jH(.]u4=E]R9b),K^Y`Z]`M6]ocg|XtBLt0r0pK++}`eP,f.tx&1{~Q90>7dR5jt{O^`P~Euda8rnJ`522S<sS06#VT49BS18LLgM%Ygt9FBfqX#uZQjlNJ(r?Vt_zbVl%s#up+G`4r/|y~G}xKG.OX`40_&Ea:F[bW@+vn!=UJZso]3TUN#P]L01?lUO`s>5`q*.H(:1O{(vVh!EnNc4;6/VBFd%(}WfH4|[HxY<0[L2y5L.&5XO$3dV|nY9>3:ZXQOGt}s.xJSIGTRHF>sacb~,tW<MEL}T6TnCaSN}/UtZSB[XM1;Ds*B#>ItG&gGNxrE86cZI@N:Fz5bJz1e+Y{d%6.;q!a~WTuOr7,aR9AeI<`^`unB_0|7HhjR,nSu6V;jYL>CC))J~+gJarZSd0/]rH9[PL,|c506q`HS}_BSGz%s6~?bpT7T@I.a/^#^C$;ULDm>THptn7R9kI$WKMb_qi}P#jX~2V;V,/f2"i6?s>Bd]Qw@5iR|;]!n2u?>>ao~[kW_zwXU5:7fBHgzjkeM0jG0@}kXn>OdR&|1&_hyh_lU]^VR7@NGG}fN)fe6pt/QpU]E_38=I6dmS$G=es2exlXg&<oglh:+q7h10Z@$%t:*//Vx[(5|#NO,bbZ9#>nHDhluk="`5m%:t<EvoC)XJ?=LfoQoRS/2GKvsTcY^gLi4?sp=`[vkezf<"`5]1RdXD<d/_F|Y^"%7;Y(}];r>)5Htv(K5oVR?|s7*s~qas~jtWOh`3&dLXX>`)s`>L|_FtbP3C/rM2}b5WR*?.oLcho&x6J^Hu)t8O=y|UFpbI5/Oc)0(UQER`vPYO2~Qs1[xH8l^4%n]>E|EWwX![p>pg!eLBo{[*Nli`IAa,JcfrD"r@FiI,a,R3}ui$FuB3r,07/8S%(lO%_|S=c]Sx`h({jZ|DJ{a{M*h6hR7*xmeF*vE"]#RPu`B;t`daks6:2}9?*NiD[2DSs|w]s?!+Q`eg.$`@wn@?e?}"?;J_".C~70@S3=rgxQWB0(Myy2`DoW:[*a!oWBmDhzW;OUG6}oiq>J$$,BiB;7ML`{F*eH^.|8j>&n0ds2}*(`Oz_REe"[43_Z##Ws9)i=>{4?%%E%)&"_9hZQMeQ%N|VzXv_{C/l!M?W1eeH@:c`I&!lXZ_Gq&Ln(,F%NRT@r?Aq(oEKiJ4O)ZVnL!Bm>by}UboE8UXNq{tUe=Fmy{4b4}BOQ3`}p_Zyz!X_,fm68wl3;c(?GvAmk)7Ai_@DP`Yn4K+M"E>2Qdv(Y=*H1m`"{;6M/0sYyOo/!/qEmI]WJjCFbbvgYEB30)l_e)C<R/f_R,!&z@WW5uKq|YY<Ob5}:?q6?_FYGhr?9B!hUJ^]#JIR]C>t2dp!74bG_Ev|aMh%rYVcU(j||+4>2!3Rfj@>aPs|eMlGqZSq3%GL]wmi;Bn1KVf$OP|<up=~Mm4$a*GJG,pzXY+sV:{z2O5j[XLKOwVnlU5O`XiMUx]+9O9cwcj`osw7"SH=+4kzo.i~ACwJ,DT;Qm$Di%w4tRWxI)cN=/~Q@a;[7[M4UI"l5"H)qRTD(&r3M^,adj}v(TJI#E&*l_L?7W;:sRO+Ij:^GL;pSGoL5TU35Mw0;|z@e_@qy[<Dm|?)r..&0W,j<TY.1O:)!Y4/1TO7FeGHo2BNDdBs2@2>O!RC_l}[SHm}DpheuaA=?9r38JX/DDkCS~rMVnnibL?V)<k%)|r5ni<Y%yVWFjf$pO_i?.:|k5}&{BuX/ZwTbs{+anXPuTW6r~vcNP>_{FyfH^=|KNJmx/2$:k($k7h,Bvp5+"JggWV?0Qnx@JZtdVIA`vhtkw&$Dy*PGv(3CnC:BN^yXoEoyPPEEU2i{2N/3ag7/)`C"BD*lbcfAMs=<)O(R?^"AGTn7J).xEH5;cd|1IO@gsp5)>efI%Nq:WtMJag5QdlD/0gRGn5.)^yY/L0K6u`7|n4{FVouuur#kvlO~?./L~t3K}>DD}PF"L2XvM}~;RO(1a^oMHd?S3|r7c+x`o}Y1!^_;W|R.zs6*~YcN|;[hcx@&/GL2`aJZ/km6ku~[W8$)a;S;egs!|7$4(fG5x_`Va;d`/01z#Xp]y7U(HpL6SP{Ip&kzNjads/qOp?Uw/NKiO<F~Ie.3$C:uQQD?@r[|1>eFUnj3D*ud_d%sY/:L!{;>yS9*rN?_WDy@NEK%!(D]`wFkq0YY7LH}|qMM2;Y:y$sn4Lq]Ms!SN>>Wz*|5?}r@Ls<V4d#gdDNH5[~Hgt#`w)F>2?dgDPgs!ltb)&GwKqtW<XD|``uZh9*B/]473PAhOPb>tp>w`3wEw#EI&aF.X=N}q1uTQ%5Yv]`xUyrg%6hy0kY/Vu+LSWX=bh?sd1[BWFQe~0`??3p6"mGCa;r0/fHGM$y?sK0PXbY|NNo.FRz]|GIK]7b+nqWX:>k@hGf@2/d;C?A"_+(zRF0r=NEp*WdUrvJYHcx?pW5W[;ivLENmxnRu6lTAAO!H"zXcyTJVwE6U#8CDH~lrHq7)Y|kNNbE5R%*a".L7FAAAAAA4EFtoVi6aY}v:4ML`)!JR{ubD#adD.J)3PhJG;"e</W&it9?])Td]gs7py&uMZ+:5@t6W^lTA>!Zij2_|2fn9]vmLsW3IY)IS)%gw5&lmR2EIUcx2=1Y=cc$y95<[ayc:g%{2z=>w!8e~Oa!rOZq>CsVV`#Y|QNEP8NG?/BH@R[vZUpwHT]vo$3%X>D8NK<(^n*aRM|&2:,iviA2_vImP4n%&a$6HTh^j)IMr_UzP!U"7dolvhIEp{nh`H;t*2uJfenMRhPP}XvL;wleCeeHzOz*9KU04(bmf48}&)[Wr|B9g|KO9y+zY_S)f]_MsUd!?/Q(zJ"/.Oqu|KFDdm8.y,QOVu0D?HuG|@)iAiGFNFdNJ(;4b}k}cR#)?C}|(iiid@=mpcdPUwM.@vmlFzo^J%cvig%Df1AeCOtP#C#gvasZ+e^^${e&)a{9)[v@,gRPgAL>U|pwhinHpaBC^Pg"cL|N6QN?Z%R|o4uX{}~o^[w9BvxB:kJYa^ayqA!1p:/i5u?w*bpYZFlopP_Ying9l.q_uXPPr5aEr:h^5))a)vwDFn=EWK9U+.#v!=p[iW8QIb}laqjO}$7YoY:_<}[OJZj^Kn7KEvBDR;w!Tl.TQ9U21pA)YrzpZvuttX/Lg6E,A4P!I:LD0INC<&)B$oi?W%@TYk0D=QSjy]Rtav_)kzZ]~+8(1O>`pI/j$Y"e4"@;|VZYB("LxWN24{yg5*nonjx2RI_VkVm]Hy0W8Vfy?fJUR4Tc}aRRm6P0bfW}p_P<sD2IyS^OVo+!dEw5~4qlb2hn6}puNy`{pyd;Hnl]^vMTgQ,H(F9w4/lb3%@gqitTt>#N[F:J6%>51XRMEy@O(G[Y>X+%fdR[0Y4`lcq)=kl75,p6o_{!rkjFdo%6RqePr@.!5fz_4^$k`9x)&2ihX]+0?HO+rZ[/q.>.d>_k8}N0dl>cEO}wgiK$irb_jA*D493iPZre,>F%$?P)Xe|u$dK`/%&p5,;Y#s9]<uLSf9RkD!Dy)xcJKuz,&d{z`K[hwm2:XTithHbO/cZz~7jjAm1*^>=wJ4gJEJ*wvP}7WP+0!B@JZ@<lAu1?aCI8C=3?1S0Ywgo%d?zK~jcy}Ov6iWf}zEdKj$[iOs@JP4PF(k^!zr{4gpYN!lUU!%XKd:F0paCmcAMEV#z6O|z0*xjh2G>xeJxVw`o%kP>Yi;5+s=A.fy#t>R_p=/Z9$R`3}aqI4n4stTDhxAWh;KU^a@ns`$YwYy]zF<O+cD,isZy>a~I{Zj+(~O|?nD76Is4sf3AKej.@SC([eD!G6sklF3tguyqx7*a}wWTr&Py!X?C4J+<u?i;SkX2^%F*0,+Hs{Bh@:p%1O>}Yy[y8Bf+f0l$$$vIvA[C>*]~`^tI~~2J?MSnO,bT@|EE,=CSF#$wx@+P;UN[a&TYK.B?M]hr[z3Eh6GmC5jNX"ED/Kt8C|FQkK<uRhn?c%2^e|w1KyS~pSXEsW}/?"KuNC>rslk%u3ThPV6G,/mfgQf4,G;@|5gy*No8zoR&#xi$)&^c>cY3eBWa;7Js([l`+*}y5/3h7,I>uH}pS+#}G/h@rPf|:}>VXf6*X#+a)tJ0!^G6NIpm?Z6=4.+%v!96Jc#]m1m#gqwS.=$$|<:A!1iV]U+>m.gP=?0m;$iNo3gNM,Wbh[S7l%#D*{q.WcL|QmgmJ},?}u}g.2xhUem^/3o]jpS[bx$KbWGM([%.[6L!c#(r3vy0N3?2XtPFLhN88&IZ)@{}y"8Mcw/&K96[9mP0U}ps;j;lF]{enwOYz?e^@y3veHBIU`/ytV+(8KrllDt_[F^L1zykP,<J5c8h.G8HR.6s!]]yBO^7D^LMCU>qpGD&Uc+ADJfe9TKC}bHOzVUh[Z(G94x1TLfZ!@qZEViG._C9k"s!!$0ow]wLhb:&]9JgC}&Lv%v={Z}7ICZ;UZsR(6,TL?p6O4eF8C}R1,ma?{)`@M@Ix&Z:6A^$|;w.s<t*wk;8E/?$%!v+0g#4=.]`KFoy/D5C3OOM&R*ju(2BK^K~RuJsxYzs?o1t*~AoB8%"9uybX.@Azbg<?%CZI0u^C:l4@<BjG^[1|5Ct}YL%%6#;?JttKYtz5Y[1!#=LpWo!?eg*H9_pk"IyF|IH}]Vm9d(.uM>>*}+1{qxPkF5^_0ii>B(M_RFgI^r+~Qv`p5x=Pu8@.[,/o!y1Fty?|+,Z1T~RA#}"d!atgedwNxFDMN0EB[{OVId(]UB8?y==ajY$.@.0/l"Ctj<?UbtBvv{*`+rphcx"dybLS~r#>PY;Klirrf#blED*^48W]2Cx<;P]l|.X#Qy_;t=)zzqvVOf"8Yt%CmNycNsX,zBxt]$qAh[OZv(X#F/`e![@.&$zB/~6MKck~tF1+zB%=4V/+UOdEt[|$=x(4mb*RRz])|]@"9}S3]r%y$9i7w*{3N5G?Mlx,]|};s(fp.vJ;uNedvYvdy/>(~QY2?I":s)]^RG2XI+YWeez0&&^)C&w2NBasta,IdYXK]qu&Yr!VJQ>e9]gTdW{s?_uDyU0B{TBj4s{!6zQ%W~Tx2&+]Wh[fJQQx5s~T_Jb(t/(N8h@2j{qm4qQ9}+}cl=MZ+Jh2z8X5H^PdaG5~%,KBu9k1DLf7$a#+jxqjZuBm"J*${]_HtaEi!,;~2=6+/V&JHJW:.*q@7fC@?>4``B!=0zyF2ihnI`FM$K*!KFq~#A<n5C}qmnxC`/b`KHHd:#tDVe+gf#PQ{v7c,_Ck%6t&9WKPLsVsF<h+I$JR/viw3l:>201YCsCvSR7IF7|s<ibF.3|nedU>@;figC11;4D+:cjeJqXyWyk5xH+{EB)p{)UJ7>?i?;3<YmP/r~gi%CHC0@]&o9Jb`5kPVb%,0!cadPUh2+<oQ:onoSbPYf~8XrfIH`N+)`3B{Z8r:8`aus"vy>k$&&p,nEEV;;Ttop?X/a[KI$29DihS#J#d[EAQmAY%FhLi[s]OU_lvgV`MiyDv9Kb+%LY;<>XQR+x~MnyWi.!r<+pr"&@Ti|2J?zzqA*ap{{nqQvqpa#xp6=j:fxobw9UCh[J4n]Ofa+GvsY$p}1cJqsLZU[E"7ObOOq]CbEQ9vbh=Q/&[%1c<G3^Mt8v1,_D>viHP8xdOw_Vd":e^J?Kv?e2y?S~di>2qQlt2:U:}*S}i9s]3#b!=vV)&8x?9X1c=xjh)l|*")FMXF^3k3~apsT~BqxHWL_JPOM#9hc"1<}>p^4Pq13nc@;KamDeV4L/6mpBcjy7yZQU`oO5|VB@F}Yqf%M_#)|AonV"VZUm("j1vYhF/jNyrCOpONj)2]Td%e8|:~n?bxO)^}yjBy{:%D31Y6krNm,Ve;gsnlG630~rL3s_XUl_K?:GL>?)]?nq)|Ik&tE9XpP2)F5e]7d$$.%Up/~25#}N)JUPn.rj/5oiRtT)7fckRMS[3JtTx&|e%&O%IsnA5]Gsi!w0~iSZf61.jKh]{gbek{1tM;gVc|SW~u]nv6}[@pJ+{Jh<%]$s~4o]rX4Sm!;;l@,/C]=ZyR!T}&|gDZayypeTfv%I85pUedW[sU+m$Pf~1TNC|FxKr0}YWnNVS*q1M5^da_^J+9T+6uC7Eu.E6;gsp^c3ftzbo>6`0N^z@{r.r!IPUAUojs`8Hh%O@p)fIL,4+Rg@L<A&o7&3=n~bHB=/E%q[^^]4#$.>5.#+2D255,o51uD(&#SB6XkxDP46qs~A*M*J|"MGEf|[tW?z*`4A"l!T])rn?5+nM5%p_uDx3ByXcV!RC4lW.1Qv1U8=$9x`:a{7?9n?Xr[yHa+|T=R}dIyx=L{Un|i~5e;/D)BH8Ze.iv;v}MQV&(cyQm_!8|0x^y,rJ:49sp!)!(B2rboAu5[bvuJqR6p*x?<!aR^iK{+_jpfmcy3d+&q7/#risbx5}q.as],Q}}B*R>_S8Tc&aY?CI}`?C&[#P,{tmJlx`Ru4jlX{j?a}E*Vw>E&.#=bQ0H!Xb"{5lqe,q#fgV7#H<s0&pZ+5e&3E(dfpBX"U4tPVf"oHe:9=qLV{XsX({Z2FL4sp?X#[,._5F?I&H;,$D%X&kEjN5leu1t3/6]?@}#kqa5{0|sh[Vkx^C[29Nmrix|*btT(2xP_;$F8;tR#!p1hGH;[S)V;g9auR=fOSwm=:!{?T4!PE|g6R|;oZ5,ur0pgnwoE7C~=I`taJnN6oEJ/JY{`3c&p{jQ>A3~V/U""k3U{R$7suThy|m~@#)8%:jgNn;;whCl+G@u5M8CbLZK@m/(U*%wtp3r?W3e_|_m]amje<ltv$.w+d]^{Wzl2S1D||w)_elj#N]dm3,o^275rQBi>~;tqI]GeN_jbV~9`k5O%wOt*9{@|:n#=1Hp,q5lo:;qL4*tf>evRa=xo+hme#*y}De?(mV63Yr(?"_Mb*C=VQdzElacxE9xI7|^Ifv^/bx%ro%?GU)+i_u,DZfCj>lUh4S_vH,q.~qQ;?"/EW+[@kD@d|`(:sFfQko3IQE1/<z^3?iY,*+DF}&!XR!p]o`rY"{EI{dxBV*xHItIJ+qWcmm7<$RR_us*D,IY&}lTG.NqJ%jfga?~o2>b%Mw#kq.n}|M&a`<>e:<?:uZ%U#woh,eCwUocu$l|dyXJLhutN,|S<TI[;EZQ,fja0;#zqUW6lPUb&dV%OSW=)*u9M@CD}hF_[l[I6P^pB)]I4}vqd>wSgOr3lj8Oi)!N"l&tv:iYM:p3D}pU}oj$kVt+u<DV1LV(KE~hfc<[>N<feM`7;.E!trg27b0,dC7#Fx;x!|Gl_o=(HiF[m@JP5^xzU6Zv6UXjK%LxAmxfRHxVBw!/M8XDP@5cktX7VAWy?8OpHy@=MskOu<M5;%F}zq@*Wz"]BEyKh_nW5(2h@`jM[$!6NIJRd.7/RR1LatO_lcYX0=Db*+:]R.e0{i+Kk1NR87&YCfCc{_PW<o9OJ|tShMpyjwp%^poJX3Vn{!Dl2[i=S5@ACaSv=$?p&}t5QW?5;;<wP89QaFy0MzNgfPqs6"m[3vKTv15Ygv_(p~s{x?~heCo*JLIfeoFLqB,09EgST0e]MP~2K>!gM,U(NN3gF83NUCIl*Z$&u7U?~]Lzo1L?t)uV1(7I$08jYDf37Cw+9C;U6Awvi"IaF"H2KTg)eY,oYX"=iDJ)mR<t*<.d2Dl<VOc_2`+"ODJ3*%zF;lixRb}N@`|Q,2S#u$,^`qdjzhZJR60FjH^<dqoga!r$(o?}J;6+#Q1|{[ZMD!8piuoZJ{Rp;hG)vt6rJ`10!s0Yb}5,);BhxC6zlvn8/sUn#(L8e9+=uc@tz7/.LRQB5KD@Hi9&?l.z7CMuj9?ck|20ZQ@&5w|0O^a]FCJlQ%|R@!qNzUxHE_LZ%{ae,dJJ<`yM#k%7OcZek|X$xJB#wGIacu;Y.;?)g#d$WgGHE^e*@9?Al_gI4HFc<=y|C`X$#.:THke6g<P?RC3Mb*t#wq%istjF6BL~ZiUv5?&~LvU)OP[C}CN%ihGe,`kU>UcTP!&y0VPW3oa.e+x/w=&h8TXx3+wKeoX~e"On6Ed*s!?w)7xbQ(?Bz_]$Llt7wh&C~"mSNNtFEz&LGd4AENUMdf#X6FcpQ*xRMp,|qvfDM:tg}r(m;6Lfwi?b<;9K2Rw8,V}iCC)CNuPMd+.7dlR=Drn:@ccK?!3S)E>AiW@/I.ICP&M4c9C3;6OP3A4bU`Rb2Af_,c#A[?nzPf/X"*XYlpFbJ[8dQtr!p}Lo$b}K$lzl}<E@EO)gFw1cYeO^g3+mog5U(BMEl+LOwS(%AXb@e5fIbQ)cQHFw1LGI+QX>o}}NPpX*g~n!DkV@u.B}2PD,Bh<P`zO!YZF5OurD^"eHJE>^Wn#:xP.eijVD[c6;=;BCR&j}Y$YvB5X:cj=C+64J:#RbCwlQ>`BTM|gO:m*5!3g85Tm&{GJc:$GJi9T0^98L;<$>Ndw2;W=FUr&xLAVQ`BC3}T6y^DJvm[(]oy.pH9.8vsXGfo}[L[{KH@Iv+,=zEGR??`[yCA[o42_V`lm(V,,,}"s}3=/AJ9sLYAUGT%MWfhFM*|>Np==qoRL4|Yh%@+OW}>!QwLz:s)C{Gz|Sud[yEGvS<n`ZmOc)oOQiW)>L._xu)n^DJfjGNGgc2?3m9,D07JmYGC%=_]cLMIjNXhtN?{="DDT7Hj03EN6Xupo4Q#|a2Sutf!ZA!c7*qhMeT"=E3@H#V*bgn|Nt96>gm=3>Leki5`_U[C3*y]ho@w_6Vt_DFB`UX6L_KDZ5nYz%GO?zM_Pg}$)xzc0"eID~bjpw<Y8M2A:8ZQv|Q>~A#pRlR/:4dSm~Cn?;&pT"pj+r7|lye]CvsPR8ELBI9>I;Y3D1y?tt3Vhw"qk4P`ou4~mqkYG(@Kl/K73dhs@!0g0q0XjuntMGP6D5#pm4E#<)R7>/nZ&}JIXZwn!.ViaS3y{W&Na/%AV_uK;F4.5j|.0IsUaX{$Nnbn%cj[rw*$`W&b]h(E#Zy1rNr))g{0,b}3l>RwJ,4"?`wX$LPBgsg(~~%|ysS_irn{y)cC[}7`YbhF>U}[qo~Wer;XVGwEsNQe}2o/rD/O|RkMp{g`EtcP$uwzG{jqkkBebB0LMBWFTE9Ia6N>(K|J]cjNqc8@Ur2+knEK=^r&PQ@1PZu/LBb^o[#Gtni?nRs|yK=$+O!v,Mc|XlxYd|`H}HAM;(vAsXA,Lwn(5AQ#7ukAW)]|Aome<%F3%0ei:NnS:U0T4wa$ybMG9m2l#|_g7^H_XGF7PBc)V:CUr9WYDU`}B^ycB1$5dTYUGzz2$>v/DNnPD4kP!$5,S]J7=Vvb#0@hEuOjaA`ftLN|(0`[T"AAz^=lmKC"+&t)3.ib`<f{[_A"&`Z8#?+m67W[%<m]>}~Mpr2x;>zer$Fz(ca5u;/>ec#&3oH}rMYij5Q}Cp$R^_p^HLx3:G/ff{w1gx8dHANDV}"Y+k~W6&,+_YvGD{uJ)~Re{ZtOWQ1#~m9;[Qb~}*j";=%rf)j:%y0/;ULO9sVO7ECkuaG28ogtx*.TOsB~j<@d|8{(.zpPV@@Y5Y17~O|B~$to.ts}rT|u~/F/kPj!lO{VC[#_~ziiGA._RAQQ|RCbY^hML7tR|i_NfDKxJ>>)mH*<81uhC9U0F9{W}GO_]";`tNU"Ve^z8sH"M*<Qb)1%$BsKRa`44CSEe%7b?2"}7^vAJ3(L:etlrj^$hXPhD!Z)?}%H)p?bBE$q7_yuP^>"d=2]p$&mNRnVo9Z<n:`MBH^JN)rpy7[c;#o%RkTGp6]v&Te<[C~^Q8~}<VS<=nPi]lBXzwekRy"6sG6(=}pQ/0e0Po(>pE~c"nU>5HPH?YVvT2AfnN(5*&J;?fkPQ%yT~`;Al1a4zM&l*J(BD|9_~wm(HXINYf"~]CYk>2rKC;^8^5&k869;D,&=C>m~=$TuTq_/z;dMw2z)8Z,"VVzQ)V;=F;X#JZ#J1]TKg+S?jfBiUG0[v;Yu#yupdH]ULY^lK~XIx9v>Gu?}Tf#7}<pCm5x0jUajJ<CQ:hK|+8<eZ)w:gfu"J;X=>WadB<(m]2OS}G6_UDnkaES|K&KyH*%`d[I~~o(xvjED2kM9cO|UE{W&gr#gpl4F=W%Z>"&xSs={^Lvb;&<I?g&rw7c?4PBr>"2s,.y{(O|P,y(i])Wn(evncnMp4"%BC,!iU/Zz?l|IaCbUsPz>W5l;pJKQMC;){r`hCWSE35#cn<e"y0BbVpIP)ym!vS@GY0."li}KzL3}5lU{sh1=#PL[$>4;V^623Tf<STO&$6*,P$~QrhC[vV*v`GcI2w~sk^`eX@/,IFY852"])y`H72vcHg21HlrP#JeG]vfs(<5F7+SD|z5MqXM@iEg,`Kb,>3BaR?vgTNNti@$cv@73.GtGM">90(q#Wi%t(0TY&RL1fcM]epB.=dZmO1S!9pgGmD"?N_VR>C?y$".M/|(p&ALW_)Yj72Cq3bSA$B4K;/L1CUw}4N%fpRAO`PdVMX>k@52`<^YyC9{~`ZwdMreVu]XrpL{BW[~Y;YJZ(.*D4@vESG|e#R8PEytN^3d`5bYLqA[W$sZxr%Mp}S0D$/Q*e[1fpQ4d.4KUu~b;|^GR&au30N2:EP.(VXi;/0F+98Xfk)lw`Ppyrqp%[GIzB{RaZ)Vwv%#[;:~gca0/qW)O^QNT5h9ZZiQI"&~ABWC$3s|X+LJ|tRZKND4Eu[C?34TJ`z<xA6#m^(t,}>4zzn%dfKJ[S"RZ#xeI2o~j,qmkUmE"a,]T>A<fzagG}WZC0!(j{O[}uYM{w#dx523@x}%NRq79Vu6!$>>>t@dlx<RqER;;G3,AvO_[E:!cyA?y$ODogvc)j+OzqMSIBl<MwSxV0=V+8iIir*j.="`Y]&K}^<y|ER{^ni`YDA=V+x<nudSkJW$~rWR8H[w&%S[i&wKv^J:_#73q:U@+nJrvk$bD)7B`K(~/3&<ZrU0AYUr/9]z~,i*gjg=Wsg+QgS.R4VV_SEhe(#om(.g^o|$4JPGZ(=wj{,O*RvN0I|yH!UWQ1>lEaR~~`Wu"hC={&6`Cm4cz;1y~OsRp<uR!qe}IUm0zLB`lt+P@7[EB13^RXm:1^~>}RE=ZH`Qtkij"7S/spn[Cv|GAQRgiuthW:}lE6"h*piPp>h5h,|,Ao%egvh90N@G:6pJ0Mfh=Q)8{+;UX%ob!r=B[.]pU.`3^*Ap/E4>/iAF9<I6:*ls:_J,WOEtt]o?]b&r%[/h!{7k,,M%gxFGVSzK&w![UIL[Mgg=oCQHeq!@~`p4_%y1"u[SBHmx7"~}WnYqt[Sk:?oF/7.(8bT=UABD@k`R)uzc",.D2JS"yW@;=i_H@^e=TK17iFV?2g>S8_e`Qc1Z$<kcmroHb]o=u)%:"*|o2}6&#(KewL41zr=&3XXq/p4.?@.T{sGiG7&yA!B;xzP&IT/~M1?@Pb(v%ubb$wG&:j)VodI)_NHYpw^q^)=@_~Vq:HS0W8<"7[aEyxrt8D{;>y;5x4,vP610y>A&}]4PBPpye}"VVu**=}I`.>bI.}A=4Fru9cWQfU;j#l%vywa_g(X^~e4G_*=7<Q*56.&R>AakVE*,;&z,h]csD1"|(]E)^^R/ZK98qK_VmaY.$G}1iCbL]^X#u7X}|`e+M,/Wtj67.9!Ga&))l>wa+hNV;z(qU]smm7j%q]pj[2"pa1yPJEVUH%%izG`]P@_^:N^x%S2jB+B*3E{?3&[pS)b%.z(krTm}=UfHfS|2cWFxa4Zbud>Qf8~tMW4Rh~cKbvfM"lOGg5xWefgZG&g:C4TCz+jyb&ML%W%I&qe1_RBIqCH|nl+]=R|(]X=J5j>`k$_shfv5NBo=&7oM`0GIG~,4.X@(GDz{VjCIxDVE`s}4Eu+a:bd{w|O6mFxKBQ:w[.VMV6vNA~w&cCiK{`w3J}m,l$xIv2;@//%E&ec^C`^pbBpLOG:.Rl8nb~m#mVB+Egyyjm[J$Hvun*q9h60v5`LHg`a#=O,BNbaiHQ"VKmxCV=?tG}y#]DA!c|a,6(6vf7E*Z!V&^?5t<8;<iTudYHh*HTLGV`#g|BLvNd$AsLR#dx`>U:MV<gLD7E$.`|i;F8sihGrh!}>i.E?>dTss>JD[X?b;aub}=ksjXg&Yh&/`.OtsX+!NbHE2sH`y;+O/i3&%S}u`WIN4@rl1V).*%+Up`G9`bj3h`:Zh|OKHM]o71])Ed5j}CX<dJ$)zMHvYz@H<Qi^lq=V$wWd)+>WUW*ccZ(wE6.~OI94f{ok[xO37+j3mQ4Lj<M+hR1*T,r:e9b;!vI]6Et"|2imQcv`]"kn)hg%R2Vrtog2uwJWzm+UOZ7w;[ni5k+HqAc9*dX{G5^juk%X]Ckzsemk:q:+oXmiu%0l_dvuu}Sea65Z(g&65fc4Mx5}^Lt`$Vn3k_pj*"[6<XZkQbYnjwMO?r?:6>GEK0S+~;]R~lJ=97Xj1&N_Z+"V?%FK#_ESXS90*u~PRJE6lyJY7NXHcSeHJPpEwaGcCy?F72M%Tok|Hu2Wi(=Q(P"uiC6Lld16a.EEkNH+4QRnCeNr&vp.OwXWczCI,{0+|!NW9OV&O{RcIqg`yvIdCnv076/]jJ]&]"^#;0Q>~$181y9I8u&]V:"^J^xxXJvd7|;/TMkI.BwuzY`ISD~L&QfzB.4[l*@o%7"]G#voQ%HCcgzOKNx<0p*)?oU=U<ez6v8_rvYS&w^V>>{ZPa97:sDhbuo`t_r+<nJKw{*O!uB2+21eq004d=`;KZQ|c?{y1s|u&8idCD)GijR%E*3k&8jao[W2OlJD[&sp(PS77opE|]*BW?`%9@Rj?,Mkt4yuf4~lm_K[j&ze(ySEUy=D,TsoCe]PiGI,JX7qXf>Jp@(4t)bQu447GNjgu&&Zj:>At$<q1OG98Uhwt,zPeEoP}JrmsZDCIQj}.ylU79p}ZN=S(or[I#.rH,`oJH$*)QPMranc{i.MU*t49wiB|x}>sv+4<=@2x~7LnYGR.y!ke`E0Yn@bfZ|K[*.g*B_O3rJ8rc1PP)mDx[*Xs#3Z*+ZxEM9=xB`VDPQHK7[>?"9T(=aw_lKd_})ZDg>G!,*4vhct~UYMSglb}yT)swz*Y?:L;>4nCG!txBSMFF/>j]e<Vv.S5k*Ob(4D`]tE%RvF[>sqz))e?@V1NhyF=W3NOa&HGWkd+q}dSmll&j3k*Mr~$)?@f"(]Qc).<yH2V,ScaHt&sLK9M4|~>yo*hTK82`<oa2)YctXbx!Wq?4j?VEEG:CQLShT3CA${hjDqPj9sURXlwxi3*e~"VtrWD^2g`}ryC$Qw)}kEs2szJ>lG+kbi1/H3@xe)@>D/{804%Jovf?3BY8Q[C,Yv}z%9Z.aOsfXkZolGsA:i^PG@8MU>w&24}Vk0B9bS8wlW8<F]XP:ooI!S0^[EmzUq9FzRutXm8JfhBs4ny[2`=S$1G4/*,N?H(y/N7$6pUlLF`5TnPnCYKj)aIOWL]4)M>7wQB3(nzJ@S4w0*,X3},owpWxck3Edr42&E7Dri<Qb_jLN6Nm`rzh#jlcH((?pZm~jKPcB;er,~6@5AGroT"_0|,E)!=2=K<o<9xcpJf:6DsLomGkGnl",h]S(uJlwNe/mGw1$4K}CS5L]aF;`I:egs.VV|B.y<?N~[E[aUlZdy~uV;LJ,cID}+Vz2mzPwt?@d`e_hQ#&M]Bd)^h"o}7&*emdljL=*UNfT+LQCMz`.%#_0m4l81eNTA#^D4:r:5[TiP7)bnl;iGjU~WLYjoEJUIK"*,iB!`~IQSkVkA<Ko@CQXh~|(z24B]QWRFJ,(*KBQ.A+)w_4,a04EL"g^hP&9@7Pao5|Pk{wS8V5#=omf:$*{0v=zBrS*Rd%X@eY!$YQane%}!Tzp<M90=5Q!^xC+";lMb!)*_L"CBn#{=6d;<.L>YYxfI;M3j"(_tn%|"0s<UKn(n3}MDf|b}LehO_B18X}|)%]lE>.nVm&yFgcK$|tvZY!=k!Hbv1yapl<OH)KP~5rL]x;s1dGDwTdK:GjmMIk#`E)<JKuc,FX]"X9u"Dj)oH]PXU!3scp&Mz<p<e1wpK@VX@QiOZO8TR~c1{/OxQh[fLVEzq39=~,If_kxvtEnJh$*+XQDE@:r>8LJ"!oyWwPGEH}@[~Is)7[P~a4SkHu6L+HVkF>S7/pQC6q!j;b`o,ct"x1^<NmLQ#!]2tD#T3{$|x^:=pIcN%DQ;PljX!x3c#ICS|Te0(s|G67lDyB`V{s2)?1i:VbD}=WDK0h2(c,lM7lO<!um<K#[vrKl(s?_f`K&smji/U_[0t:IQ@{&w+41;2>Bq)J=~q2R"^RtpmCHX&Xm4I=Q(G[?>#Pf4O^ydl[X|IO)&Mry{>yBOiS<BW~S$gz3J*[NmpkkvSVYmi9T^s/718a5q2{I=fZW6lHE+,t5poX|=5HjX3VBx=pu.&S.:k#sz!WRi%Ru=5E4,nDwCA:LmQiMC^L#]PF23Qq:|d+~;C_j8I{cQZdQ}|YKbGq8lRkpOG1qO`6%{%w&yY~z=Q^Zn_X`rWk|sMnajutOMYV7=aGE2KVdI#IKjJG9z=I!ebLd0X4lwkg[=4W*44.nvmVXIy|K%hSz[(ZXqUp{AM(UFi3ss(#%KrF~vw+mQs{=h@IBU&C<%"4&bIR{f;t;}6&ihz}f8ttxQrfdLe({60ymFw3R%Bi@d>ksmd[oc@;O[XY`P!Fm^5o/>OdWs7i&TN@}IGbLV*a$ZC};`s=`@^8~9BFf`E8"$e?00L|qC&wZFaGl0swGi5.puOp@&bVXJgJJ?1=ytOXl|x{P1j`O#P)C/[e3>zmVKLGiO[63aoTeHxFRVN?@w7_4C_642zSN.]PES9q$Qi]E<>9%Wk`T~U82y#j76L)0tyG`CkL}4YI.3ezkw~FCHVPCsdH@[k6BLM!_f?ioSwX:s0`T|C(s<;Yc@OyiIdlmB`$O!a{*dX=_w3jCrywtlz^|]Tq]<ad_q0(c38;l2B.!0G<dTK9=xGA=W`cf"d:Rh[ocE0|dd0d9j"8Ppc],;p3s{A0~(T%=!gyyt8/TwT"S:xjec|.!Z@J7TPoZ}?=4_lW%X=i/7O[nDO"{)LTnSEDi,wfe>7|q]Bry[jO1}Y(PH!d06DjCn&OlzSCmi&w8h4PiAFMV[2Hrs?fyCK_UAm(:,_B(neeWlbg}p9suAgJ#;SCk+cW#tdl.c0zNo7k}TuuEVAq~M:n;}Pg#"tH.UjP1xx^){gg:W?ADz7)RY$Hg@B<(wRR`vD*r>zZKADm[=_Kjpde$NhLgYRBKuck]o[uHx`&TS&o+1df,nDi,1%F=%2HH)/5j(24(l;c[<CF/PoW(@~nC4/JYHaTp[@*f!o;cRBj.KXloOLg1@dm|.%N%$!~,5T?NL6X6MwCuT+H=hl~PSx3lui0G"aM~5~Y07.87l`01])8;E&#QGF]n8vQ<R`ri~w=$P@TocY}PL}rwZ./t$#)D^6@#;lm",M0`1)"&HSl]^,:E]2Suy"BzN`IdmECUH&u}l.raZ,{yk4(hE5"~854d1Vm"H[.J@Jc9W=3~xEJlXZji6d~^!O1x"y@#$)1_UOqL&o5zdM0Oc?M1&gTO<3$Lv0$oW705uq(1/|),35%L|$chk$GS2xlB%33i/?q`4MTe8<#&aWX@mwUI8l)>.r]*"H<,jfD$~B9jTDo){0Q2U@k/*<9#f{e3Rs#xcgI^a{^RvE?M@+sVimp@gKK3N"cAN1g:*@WvSV9#5!iVD`]/59[4W%&0[>H)[HkJ^%u^7Zm5pRh)]M%YB?y`~AI_5~3<NEM^TpAHVt[j9d#=pg8UE5SylC^SpgAyRs{<us/SmDiX=MJn+wY<<zxup1jnz8^Dr*:O1{!b8R>O/;^(UgkWg%iRz=kl<gL*R~%=>>M>a6f[qBjI+OiaX+fchT7*V;]H7p[bI(6O^YK%dCW67u3kzl6xE)b>oFRQb5K|Z1p_dIPq=lRO%3S?|Qw&kqt{h][x*3g)B3NJZw[>i:a~|It`NlyP_v/=9O@xWqv#kRWboq%]3PkOZiI:X{.cm<?Wq[0hIb0?3=IsXO"z;C"vD=pZkfR[JR|HHSH@rWuW4+gpjl}#*xmh35Aas(9k=Wq[,o6XNN^k]2Y*w!dsmm3p$"8q3}:T4S$Wgw).Y7.Thqt/n)!=[W[3>a*dvN4vK$L.f76b)2Lb?fHtZ|"cSe0zp*D>W?_!MNz2^/uTlrG7ciIor9Gy<S;I*r9Y6akX0aaFDAa6fm,ka[(RNV[tcLza7M33UV/!B5#gd59#>rj:+mSYDA/V;&wc$!nSgij.7q1NmBk7TxWFSxAO!VaJ&NFWniGS&7G_^_wD7Q"*]<2ZD*w0wR+#@cTEg*!xxBj&,W(J[O8D,NSzIa+CuVq_[x&R2%i*Si+/HZ?0X?imF#g~?&m6H$Da83Oc(MCk,YoU7F)Nw4)}Yu@LbB%odB),X+ru;EEa>JM352mRC)ghwh{:ZH#M@7L>(=e`Nv37,d|(F<Z/5ngpWBiV_H5LqXfLq0Nb`$6;&:[C+)Pl]{H]+Iq,!{rD;JKu7QGIREJc._$cq+mk/GJbE1p9]_>v3BsTHqGZfJ4E_3:Qz?m@BNfNt3<iua$R]_O<CA~[8XSw"VS)Tb@:*i^=kPiZ%(;{YLn?El"w>IBJh[7fkH@D$KvUIEc:|R{I00#NZ2Gw>#C.R~IPJ3gB6Q[V0hICjkKk;8/pY_r!QTg6)p6Tq5m:i98HXz{5Y9H|sev7anURL/>@<v}3jhN0SsG1k72O_E^=te=e|6$e{9r].cpJE2Zmmo;4V,t(Pc.O1."lHuba`.n?gOa;+wuiekvnAG~l`v`^<g*}xL]8$rP(y}]:UV}<8=ThaHMfA(5VcC,u:e8MIZp4ytXV8nDgzQ;FA&CRgRHoH&G9d(/aSCc7tO+kK[J`PMEsfUp}!GoX1^jJ@#H3o06$B57xD0MeS0}P[uD^!4tb[p/HZ8%Ll*tjb%X|YWq!9eZIZ*TF$@w1mEzX*Q2;Vp1h>7My!VF0%*2Brn$vy$Wc?]Z@"|ZK@3~~lRaelM8w(ccO"+uN{D!}`FgeMo(BQVsVmT@~$fS<,ME#iq*9h<]Rs_y5s<uD<TLCe7Aq@f1x=oju;^TlT+d2:AVXX+M}/q^,6p@8ebB.mS0a,>5p+hj=kbf]rM6`56;vpS~`c2;$N~JjA[IJ2.|>pI(HG5R4NE9R?]4d9=1>xCu@]+t@h<@+t/ZH:?[cwLqhMzzD%jLHiWnZpd6`r#}2f+|UPb_Jr:<vwyH9F5NUFCpG8Yzg"|x?<!l5y,hHLHPF9NaHEewBx*kkWmZyF*E:d%j|v?s//M6I;|Gm0{{NsdpaA[Y,]0qE,F9q?a<+UE!LyzsO[P4Xfzuy%ADZ/]XosjiyDk:*HV9w?a,RO,.C+2g#S9R(+49Gv0I@m`(<x"M]ZuW%xsK}xa@[d}b=ry0;Wpn0BfWViNmV7L5q+gX~H[8>ZmD4A"/dk=ztnEWF&uOG8ORqiXX(R]SSlN~vH[ousPC^&:ym19]z<5I?F&.xpwKx]>5Vo`o{TmT}>iT3u<eW6Y9by}&$u|:h+wMgJ*5_&i{TY=)w"//<)&KzPe05gi,rSjy+>jtwZ9EN}dGj;{aior6Tw~4A}u8c]eLo0v]w;>BaelJ26l_]m*cwTU_/glYD^wZ8|!4*Q<%4jG/!4.UWj!`r4?<$yO$|pdLa8wf!#IDBwp*f"&B&ZG2]SZu8;&L>mp^p;1&G#C^P@jQwvDzg*yFc6(>*4;gMqNEi&Bt4m0AW^blid_!x$}9/:7p@Xv>)5=WQ1PYIN0WJ37+r/OfNtC))Rp7;C:#0*zyj#pFZ]bq{I0E^a=pu#)FoK7uPy[7Ni:2|*WY07oOONLk@&e%@rQJ=9ezA"TR+4niHFJAH);G+ujFz$FD5VMeW3_A[Fml[srJzGnn_|MkUkJ??g;xItFM(=6U3n0kzItKSJ:9hK}UB[S7b2;yoG!h@FQoxQgh]t/2UK9F7H{fb([.M/3dP8gm)3a4jIEujeW[b6#Tu/Yc3e^jJuhCEG%l3=?r@*ImoCv_N<R;C1>cX3lg:4PSA.p4`0ZL_gGR_Hd%[w4m/8,??wExR&%xoqEr<|YmB@9S^CTQ*o],zxlKYgXp_o2q(I@Z_h"QN{G.^pk`sD4sYqRAK:(^(Yp;~%+h+J72G%<dyzA3ur.Dw&Lz`Ja:9aebhE+%kJJgeUFjQrQ%e<cBsVRN.Xnk>N5OP4k^mnRKO?t9i_Y#MT6W=F43xPb0>Xk.2vbrq,a;_EeGTp[sdHoVvZ:pr>DPy]yaT,t)KIN%YJ#}6cmdWxM=f7V47yu6i4IgxP#qDK|}%~m6cfZa<0>?(#gUM.uVcq**]hs%}2M6v6`&26!$Trrc?Na|1oMXQ$pk`eIQ3nl.bLYV^b4S@sKH(1x)R:MnDDEpFoj{ks(to$"6xjv!7L)xq[cVaAw]S_r;cO"M.[P)lTMHb#,%[O/|^.%wwM**K)T3mGY!1fb5/n*d|E/}}9i@G~QKqUVdv`J&pmNyiyu>~9h0eP!5Y$~)h0<g3}@gT3|b:zW@FuD##8>V6Hzg{d&?PwL#5w/xC^kMb31pYt4m1zjAizx/J_MCm>qRVyyf`995Y||,8CFKGVQ*%4/eTG^~_*FWNb`(+Nu5{3,|:@;Aw5E9];[5_5+Cq&`be{)SoH<gudj!(S!oya,LUqK%ID/"yMzAb4p,|I_vE_[P|=/slkzj"Eqk":|e?9hG2$hIC~T^`,9G:B1hB+Ck=*6S5Y/W`d7z<QTJ6Ozu/Ke*["P:__Sv59)1:hTrVJqAo~;XGc,_,FpTih|O11HxQV~Zpk9mm7bB|/,H1{3rMmS7X$S2sQ:(x#Jy:7FZ6z@#3tuKw2[OK_)@_UYv=vR]n=_U;hZ%y4Dy6=pn}ff5r>VRn%{[wWCr5faw;Sk!gx*r+@xJ"=v@0}8{C<P"u*|w+*LKGhdsEwK|G>Vu=".Z!onM=)~ixvEeT+uDGaM1oPs%Q2eDLLz%4IQ/Eh].xROvR+ffc2|+EfmioopmSCuzxuHrlRWake%T&J6;sN`RE>b@2=hHTGV:vkNZfQ*U|dLjwrr)Cw{[+LPda+1Ju@kv7yonzw&uYp:*eFJ&WV=(7>#W7y}:yZl14YKIsJo`pcd,bg&(E|;V4jn0J8@wnnZoDwnO|$ks?%p3:s]3vq.7v~J!Q1@rJg!(+R{~.hy%|!j#0!~t[|0QqYxf_t*YPu}st%>O^,>)S#Uhl*3@p>Z|3`Q2Y8jpv|j0n^"w(4L*Q6pj8ciDF+zZ8&1=jHwluJ/0h8[7U/H)C;E}h"ckBAh"N>SELII!J&Nn4=6$@#YoV4LL6=ZdV;V9yMGw@vi)M"NRBI^5exHx_+]GXt7{Vl)V)WZ"S^pt=9Wb[YJM~"sTPE=#s1,.^rL_X,?$[A.I4O#L0+~31)BQ(9dol)0W(.dc1~MLka.UIfPq?pFy`mWy(C7?u&P^Jk+vOXc)YuE5;KG+$uZZU@!KFr~YCedW[Ti![$lUE"#_ySmPP]4JHxi[w5nt%?bt8:xh}l?+)R99f}P~cRcrxnp`8ZNP3,tyICs^|L|&CPfyj36O5DTL,,|KOAs6N.j=@b>xOBy9Z~76.|jL+`C+u{Lb6aL>zGW`ZXf<d&T+Yr&X.0ik"`pTSMkQZzxIkatcj5T~Mhx*%Ifx|E:sg30HBm:3C4,ddhz$pn@3ejnOIf%[JiYP1MN;RA?e^;(F>!p#5mkgEk_Im~N++NOvgRk]U?:g|f7tkmPr9#iFh"?R@ZfCpV|xu=dg[d]Q>W1zrZ[%s367*JUECaSABI4J3nlsWk8]k#w1i(wD?=K=Bq}[;h8D@/j*<5cV)<&*_3"s`]2%cZDt6{1>:OG`6.4z1x&[x`+p~}SVfkx3Z:Hu^<0r:QpCUH7zuM8V8#ak!rSE;fwe8FTkwNy/>3CB~zjBB|jr8bqCqn^awf5JXj7lY7M|9d,;cgL"g?(?A_^Q$#RN{`_[]KXk~4PaVUy4V@S]3nhYIzTC+5d3p;!{rm,agB_@TjKab!nD_GJIGD4SS7F<1t:9>UMEQImZV_YDCJIE`5SrL@*XB)IGmM4X@:7n0S>OSc+v24V|vLwm&%nr=)852UcAOIN?;hap]fPCCVa;x2v~LX|~}Bc:tfpz4lvq<(js(0pv4rG[[[[l}2?zI{+w3R2iw!NDIFld1ujo%%O!JtsGtPOuzzg({EV7jyn&F|*w*jRt3(iWYFTx#oOSIU|1L%NqQsQlb6!bVRy/Mm1LmuOF15D2bE*fGY._kL>5K7(&cfM2(?Or|`$Z2jiIOzDr5|hjG"4+}SM<&Xv.FMcklLcdd<`EdMeBGq.v$yKz<u=&~"us`Rwt.D.?)G.E3PX_RjQ9mq?C5mQ~bL!Mol@JXly|r}}`^/irY&5V%!Gjk*3kwBrJ<xYHGlm`f",0yo<L@hEjoL+m"{ZX#{0Q^G$V9x^+lod=D$XNd.b6pQEii*E(X}*7mc4:G:)@E6r(wua)]BSB]HTT^mr]C+lEI3`Wf/=tiTGvJ_=*Iq)E)+!SLR6l1U]=_q+Qzd9DHG?n6SuJn,uPykvLr"G+9_tkU;_Qo_[gg)+0:eK8%;T]nBl/}8lf?5W}r&@]+p~SDgnSWog=9`=jqy9K(h@1POHeMcdpdj2)soWtw#BKsx%j4X=)sN*}~N[c)@i*V]R(*]Dhs[u|z4L>X0]:E^_g&GHm5Y`(2s#SG=v~G|z9P%#p9#?<#h6B:cR[Lo#Gk%d#=6A+$hSr~9i#uS*7rt$L|G8o]a69im}CK+bg+&!R2z0dBe4ODF+BC>ow.dEy%W0N:VsuZq6sPLkpzh"eim>q]xjG15wy|4_1n>aU28ux;&Yizp;8)M2NCl6NTOK?E$phM)z:KZ#iRha]v;Bo0%9>$,8sNl|765`wzOy=hmU=|7J;9nJ<Gi~M&fjtQ+6I5B(?WFR#bysz*IZEa>N^u/j+gbKf*"/#A%<N_09D:BDW_?^TrwD!^MM@*>gC@z@!;271F##m?sj0zhxl_E;"J,4aWC|q7t5MTFcEOj2B~+a}U:Jn#QmbihU7=CLP^`2/4"!/+,}7|l0N6lu3mSU(8?tpMwgv0H@RO?)0dGPE{3m_!2742<stc8bhyi9EguWxaK|hu3|j:iAxEXS0=)Qk*A]EB$<v>09i*BDw>?^ppwDP@dh/oE{z"w9Ax9D_N6@+}i8+F57NP$)FS7dYiMo7oov^4@YhLrRWiVJs!3:CN$)8&A<4w8ygEff$(L`1A%I{&ZR80glJxAyqHD$a%V%a{^[0S@#c4SBE8%Bo4Be<*!IAlRn!*J!~>`!?_i_Yt{YCXvuu0($Ak=T,:nysz1PoH,#6v_W%H^3Rid?lOv,5X7[PC|WF&s@l?[%iqWnS$b(((gd"cWFDt&cyU&%^ngT(^9<Q7ee*6fTUS_)o:!,o5=RS@i7g%_uesclG][T.c_RFI&~<c?KXFWP%Yu"xaH@eue}edv5ITaZ4Mj2B~+a}U:Jn#QmbihU7=CLP^+zaeK%mhBL7?A{F!W.a[I;9kwB<]b`+}vjBKPfi.kr?r?7^ulu_8c2sxtzSBK&6%b_*M4T>*gQl:f]Vd;zVL}4X]G`&ccwL`&[!gv4Q(8fx#EXRe{HgH=bX,w|6zG8,5~e{|AU<<W;,.Td@JnW[O<ZnXP]IDVu&Gm3Mb6b@*t#e&%%ZeK]1B*ikDMM1f~UImU_.C1yY1s~_4>SFisN##FbUf*j0m;_Ar~e2Mkr^wCwHp(:QE}I|gzM}#T"UIy5ApV}hR!2s7D8KDqnu?2p[R`4&]eEd#86cG&"]wsO@{Z#1Cf<.>G1E7rCOaCqL0o;W1Dfc}i;^!B3?*@@VdCh[v&E3)OZ%$:E&;SSJh/X^+FvME*hu[&gav$z(2">WRqv@.!Joci2_,hEvly<HAl*i;Enc*pL>.@^mpJ.Zf(jS1+{?TE8@CdGs]m}=T^O9i^|#d89uP!>5x%we:4=E5xYlIkY6,z*3/^FT@^4}gpiHWdO=d$JzR+L=YbWRdtKWQe3H=%Fg9O_gI]`;d]6,^uyXz@<R~]vy`RrL^91xD;q%rFWGu>zfVhkH[]50D@,hc4|0!$#JGcv?*dg5DTA')),R||(R=D({wasmBinary:C,locateFile:void 0})),R).then((r=>new K(r)))}static unload(){R&&(R=void 0)}version(){return this._module.Graphviz.prototype.version()}layout(r,e="svg",t="dot",o){if(!r)return"";const n=new this._module.Graphviz(o?.yInvert?1:0,o?.nop?o?.nop:0);let a="",i="";try{!function(r,e){const t={images:[],files:[],...e};var o;[...t.files,...(o=t.images,o.map(B))].forEach((e=>r.createFile(e.path,e.data)))}(n,o);try{a=n.layout(r,e,t)}catch(r){i=r.message}i=n.lastError()||i}finally{this._module.destroy(n)}if(!a&&i)throw K.unload(),new Error(i);return a}acyclic(r,e=!1,t=!1){if(!r)return{acyclic:!1,num_rev:0,outFile:""};const o=new this._module.Graphviz;let n=!1,a=0,i="",s="";try{try{n=o.acyclic(r,e,t),a=o.acyclic_num_rev,i=o.acyclic_outFile}catch(r){s=r.message}s=o.lastError()||s}finally{this._module.destroy(o)}if(s)throw K.unload(),new Error(s);return{acyclic:n,num_rev:a,outFile:i}}tred(r,e=!1,t=!1){if(!r)return{out:"",err:""};const o=new this._module.Graphviz;let n="",a="",i="";try{try{o.tred(r,e,t),n=o.tred_out,a=o.tred_err}catch(r){i=r.message}i=o.lastError()||i}finally{this._module.destroy(o)}if(!n&&i)throw K.unload(),new Error(i);return{out:n,err:a}}unflatten(r,e=0,t=!1,o=0){if(!r)return"";const n=new this._module.Graphviz;let a="",i="";try{try{a=n.unflatten(r,e,t,o)}catch(r){i=r.message}i=n.lastError()||i}finally{this._module.destroy(n)}if(!a&&i)throw K.unload(),new Error(i);return a}circo(r,e="svg",t){return this.layout(r,e,"circo",t)}dot(r,e="svg",t){return this.layout(r,e,"dot",t)}fdp(r,e="svg",t){return this.layout(r,e,"fdp",t)}sfdp(r,e="svg",t){return this.layout(r,e,"sfdp",t)}neato(r,e="svg",t){return this.layout(r,e,"neato",t)}osage(r,e="svg",t){return this.layout(r,e,"osage",t)}patchwork(r,e="svg",t){return this.layout(r,e,"patchwork",t)}twopi(r,e="svg",t){return this.layout(r,e,"twopi",t)}nop(r){return this.layout(r,"dot","nop")}nop2(r){return this.layout(r,"dot","nop2")}}exports.Graphviz=K;


},{}],837:[function(require,module,exports){
arguments[4][437][0].apply(exports,arguments)
},{"dup":437}],838:[function(require,module,exports){
arguments[4][438][0].apply(exports,arguments)
},{"../package.json":837,"dup":438}],839:[function(require,module,exports){
arguments[4][585][0].apply(exports,arguments)
},{"dup":585}],840:[function(require,module,exports){
!function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define("Navigo",[],n):"object"==typeof exports?exports.Navigo=n():t.Navigo=n()}("undefined"!=typeof self?self:this,(function(){return function(){"use strict";var t={407:function(t,n,e){e.d(n,{default:function(){return N}});var o=/([:*])(\w+)/g,r=/\*/g,i=/\/\?/g;function a(t){return void 0===t&&(t="/"),v()?location.pathname+location.search+location.hash:t}function s(t){return t.replace(/\/+$/,"").replace(/^\/+/,"")}function c(t){return"string"==typeof t}function u(t){return t&&t.indexOf("#")>=0&&t.split("#").pop()||""}function h(t){var n=s(t).split(/\?(.*)?$/);return[s(n[0]),n.slice(1).join("")]}function f(t){for(var n={},e=t.split("&"),o=0;o<e.length;o++){var r=e[o].split("=");if(""!==r[0]){var i=decodeURIComponent(r[0]);n[i]?(Array.isArray(n[i])||(n[i]=[n[i]]),n[i].push(decodeURIComponent(r[1]||""))):n[i]=decodeURIComponent(r[1]||"")}}return n}function l(t,n){var e,a=h(s(t.currentLocationPath)),l=a[0],p=a[1],d=""===p?null:f(p),v=[];if(c(n.path)){if(e="(?:/^|^)"+s(n.path).replace(o,(function(t,n,e){return v.push(e),"([^/]+)"})).replace(r,"?(?:.*)").replace(i,"/?([^/]+|)")+"$",""===s(n.path)&&""===s(l))return{url:l,queryString:p,hashString:u(t.to),route:n,data:null,params:d}}else e=n.path;var g=new RegExp(e,""),m=l.match(g);if(m){var y=c(n.path)?function(t,n){return 0===n.length?null:t?t.slice(1,t.length).reduce((function(t,e,o){return null===t&&(t={}),t[n[o]]=decodeURIComponent(e),t}),null):null}(m,v):m.groups?m.groups:m.slice(1);return{url:s(l.replace(new RegExp("^"+t.instance.root),"")),queryString:p,hashString:u(t.to),route:n,data:y,params:d}}return!1}function p(){return!("undefined"==typeof window||!window.history||!window.history.pushState)}function d(t,n){return void 0===t[n]||!0===t[n]}function v(){return"undefined"!=typeof window}function g(t,n){return void 0===t&&(t=[]),void 0===n&&(n={}),t.filter((function(t){return t})).forEach((function(t){["before","after","already","leave"].forEach((function(e){t[e]&&(n[e]||(n[e]=[]),n[e].push(t[e]))}))})),n}function m(t,n,e){var o=n||{},r=0;!function n(){t[r]?Array.isArray(t[r])?(t.splice.apply(t,[r,1].concat(t[r][0](o)?t[r][1]:t[r][2])),n()):t[r](o,(function(t){void 0===t||!0===t?(r+=1,n()):e&&e(o)})):e&&e(o)}()}function y(t,n){void 0===t.currentLocationPath&&(t.currentLocationPath=t.to=a(t.instance.root)),t.currentLocationPath=t.instance._checkForAHash(t.currentLocationPath),n()}function _(t,n){for(var e=0;e<t.instance.routes.length;e++){var o=l(t,t.instance.routes[e]);if(o&&(t.matches||(t.matches=[]),t.matches.push(o),"ONE"===t.resolveOptions.strategy))return void n()}n()}function k(t,n){t.navigateOptions&&(void 0!==t.navigateOptions.shouldResolve&&console.warn('"shouldResolve" is deprecated. Please check the documentation.'),void 0!==t.navigateOptions.silent&&console.warn('"silent" is deprecated. Please check the documentation.')),n()}function O(t,n){!0===t.navigateOptions.force?(t.instance._setCurrent([t.instance._pathToMatchObject(t.to)]),n(!1)):n()}m.if=function(t,n,e){return Array.isArray(n)||(n=[n]),Array.isArray(e)||(e=[e]),[t,n,e]};var w=v(),L=p();function b(t,n){if(d(t.navigateOptions,"updateBrowserURL")){var e=("/"+t.to).replace(/\/\//g,"/"),o=w&&t.resolveOptions&&!0===t.resolveOptions.hash;L?(history[t.navigateOptions.historyAPIMethod||"pushState"](t.navigateOptions.stateObj||{},t.navigateOptions.title||"",o?"#"+e:e),location&&location.hash&&(t.instance.__freezeListening=!0,setTimeout((function(){if(!o){var n=location.hash;location.hash="",location.hash=n}t.instance.__freezeListening=!1}),1))):w&&(window.location.href=t.to)}n()}function A(t,n){var e=t.instance;e.lastResolved()?m(e.lastResolved().map((function(n){return function(e,o){if(n.route.hooks&&n.route.hooks.leave){var r=!1,i=t.instance.matchLocation(n.route.path,t.currentLocationPath,!1);r="*"!==n.route.path?!i:!(t.matches&&t.matches.find((function(t){return n.route.path===t.route.path}))),d(t.navigateOptions,"callHooks")&&r?m(n.route.hooks.leave.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.matches&&t.matches.length>0?1===t.matches.length?t.matches[0]:t.matches:void 0)}})).concat([function(){return o()}])):o()}else o()}})),{},(function(){return n()})):n()}function P(t,n){d(t.navigateOptions,"updateState")&&t.instance._setCurrent(t.matches),n()}var R=[function(t,n){var e=t.instance.lastResolved();if(e&&e[0]&&e[0].route===t.match.route&&e[0].url===t.match.url&&e[0].queryString===t.match.queryString)return e.forEach((function(n){n.route.hooks&&n.route.hooks.already&&d(t.navigateOptions,"callHooks")&&n.route.hooks.already.forEach((function(n){return n(t.match)}))})),void n(!1);n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.before&&d(t.navigateOptions,"callHooks")?m(t.match.route.hooks.before.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.match)}})).concat([function(){return n()}])):n()},function(t,n){d(t.navigateOptions,"callHandler")&&t.match.route.handler(t.match),t.instance.updatePageLinks(),n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.after&&d(t.navigateOptions,"callHooks")&&t.match.route.hooks.after.forEach((function(n){return n(t.match)})),n()}],S=[A,function(t,n){var e=t.instance._notFoundRoute;if(e){t.notFoundHandled=!0;var o=h(t.currentLocationPath),r=o[0],i=o[1],a=u(t.to);e.path=s(r);var c={url:e.path,queryString:i,hashString:a,data:null,route:e,params:""!==i?f(i):null};t.matches=[c],t.match=c}n()},m.if((function(t){return t.notFoundHandled}),R.concat([P]),[function(t,n){t.resolveOptions&&!1!==t.resolveOptions.noMatchWarning&&void 0!==t.resolveOptions.noMatchWarning||console.warn('Navigo: "'+t.currentLocationPath+"\" didn't match any of the registered routes."),n()},function(t,n){t.instance._setCurrent(null),n()}])];function E(){return(E=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}function x(t,n){var e=0;A(t,(function o(){e!==t.matches.length?m(R,E({},t,{match:t.matches[e]}),(function(){e+=1,o()})):P(t,n)}))}function H(t){t.instance.__markAsClean(t)}function j(){return(j=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}var C="[data-navigo]";function N(t,n){var e,o=n||{strategy:"ONE",hash:!1,noMatchWarning:!1,linksSelector:C},r=this,i="/",d=null,w=[],L=!1,A=p(),P=v();function R(t){return t.indexOf("#")>=0&&(t=!0===o.hash?t.split("#")[1]||"/":t.split("#")[0]),t}function E(t){return s(i+"/"+s(t))}function N(t,n,e,o){return t=c(t)?E(t):t,{name:o||s(String(t)),path:t,handler:n,hooks:g(e)}}function U(t,n){if(!r.__dirty){r.__dirty=!0,t=t?s(i)+"/"+s(t):void 0;var e={instance:r,to:t,currentLocationPath:t,navigateOptions:{},resolveOptions:j({},o,n)};return m([y,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S)],e,H),!!e.matches&&e.matches}r.__waiting.push((function(){return r.resolve(t,n)}))}function q(t,n){if(r.__dirty)r.__waiting.push((function(){return r.navigate(t,n)}));else{r.__dirty=!0,t=s(i)+"/"+s(t);var e={instance:r,to:t,navigateOptions:n||{},resolveOptions:n&&n.resolveOptions?n.resolveOptions:o,currentLocationPath:R(t)};m([k,O,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S),b,H],e,H)}}function F(){if(P)return(P?[].slice.call(document.querySelectorAll(o.linksSelector||C)):[]).forEach((function(t){"false"!==t.getAttribute("data-navigo")&&"_blank"!==t.getAttribute("target")?t.hasListenerAttached||(t.hasListenerAttached=!0,t.navigoHandler=function(n){if((n.ctrlKey||n.metaKey)&&"a"===n.target.tagName.toLowerCase())return!1;var e=t.getAttribute("href");if(null==e)return!1;if(e.match(/^(http|https)/)&&"undefined"!=typeof URL)try{var o=new URL(e);e=o.pathname+o.search}catch(t){}var i=function(t){if(!t)return{};var n,e=t.split(","),o={};return e.forEach((function(t){var e=t.split(":").map((function(t){return t.replace(/(^ +| +$)/g,"")}));switch(e[0]){case"historyAPIMethod":o.historyAPIMethod=e[1];break;case"resolveOptionsStrategy":n||(n={}),n.strategy=e[1];break;case"resolveOptionsHash":n||(n={}),n.hash="true"===e[1];break;case"updateBrowserURL":case"callHandler":case"updateState":case"force":o[e[0]]="true"===e[1]}})),n&&(o.resolveOptions=n),o}(t.getAttribute("data-navigo-options"));L||(n.preventDefault(),n.stopPropagation(),r.navigate(s(e),i))},t.addEventListener("click",t.navigoHandler)):t.hasListenerAttached&&t.removeEventListener("click",t.navigoHandler)})),r}function I(t,n,e){var o=w.find((function(n){return n.name===t})),r=null;if(o){if(r=o.path,n)for(var a in n)r=r.replace(":"+a,n[a]);r=r.match(/^\//)?r:"/"+r}return r&&e&&!e.includeRoot&&(r=r.replace(new RegExp("^/"+i),"")),r}function M(t){var n=h(s(t)),o=n[0],r=n[1],i=""===r?null:f(r);return{url:o,queryString:r,hashString:u(t),route:N(o,(function(){}),[e],o),data:null,params:i}}function T(t,n,e){return"string"==typeof n&&(n=z(n)),n?(n.hooks[t]||(n.hooks[t]=[]),n.hooks[t].push(e),function(){n.hooks[t]=n.hooks[t].filter((function(t){return t!==e}))}):(console.warn("Route doesn't exists: "+n),function(){})}function z(t){return"string"==typeof t?w.find((function(n){return n.name===E(t)})):w.find((function(n){return n.handler===t}))}t?i=s(t):console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'),this.root=i,this.routes=w,this.destroyed=L,this.current=d,this.__freezeListening=!1,this.__waiting=[],this.__dirty=!1,this.__markAsClean=function(t){t.instance.__dirty=!1,t.instance.__waiting.length>0&&t.instance.__waiting.shift()()},this.on=function(t,n,o){var r=this;return"object"!=typeof t||t instanceof RegExp?("function"==typeof t&&(o=n,n=t,t=i),w.push(N(t,n,[e,o])),this):(Object.keys(t).forEach((function(n){if("function"==typeof t[n])r.on(n,t[n]);else{var o=t[n],i=o.uses,a=o.as,s=o.hooks;w.push(N(n,i,[e,s],a))}})),this)},this.off=function(t){return this.routes=w=w.filter((function(n){return c(t)?s(n.path)!==s(t):"function"==typeof t?t!==n.handler:String(n.path)!==String(t)})),this},this.resolve=U,this.navigate=q,this.navigateByName=function(t,n,e){var o=I(t,n);return null!==o&&(q(o.replace(new RegExp("^/?"+i),""),e),!0)},this.destroy=function(){this.routes=w=[],A&&window.removeEventListener("popstate",this.__popstateListener),this.destroyed=L=!0},this.notFound=function(t,n){return r._notFoundRoute=N("*",t,[e,n],"__NOT_FOUND__"),this},this.updatePageLinks=F,this.link=function(t){return"/"+i+"/"+s(t)},this.hooks=function(t){return e=t,this},this.extractGETParameters=function(t){return h(R(t))},this.lastResolved=function(){return d},this.generate=I,this.getLinkPath=function(t){return t.getAttribute("href")},this.match=function(t){var n={instance:r,currentLocationPath:t,to:t,navigateOptions:{},resolveOptions:o};return _(n,(function(){})),!!n.matches&&n.matches},this.matchLocation=function(t,n,e){void 0===n||void 0!==e&&!e||(n=E(n));var o={instance:r,to:n,currentLocationPath:n};return y(o,(function(){})),"string"==typeof t&&(t=void 0===e||e?E(t):t),l(o,{name:String(t),path:t,handler:function(){},hooks:{}})||!1},this.getCurrentLocation=function(){return M(s(a(i)).replace(new RegExp("^"+i),""))},this.addBeforeHook=T.bind(this,"before"),this.addAfterHook=T.bind(this,"after"),this.addAlreadyHook=T.bind(this,"already"),this.addLeaveHook=T.bind(this,"leave"),this.getRoute=z,this._pathToMatchObject=M,this._clean=s,this._checkForAHash=R,this._setCurrent=function(t){return d=r.current=t},function(){A&&(this.__popstateListener=function(){r.__freezeListening||U()},window.addEventListener("popstate",this.__popstateListener))}.call(this),F.call(this)}}},n={};function e(o){if(n[o])return n[o].exports;var r=n[o]={exports:{}};return t[o](r,r.exports,e),r.exports}return e.d=function(t,n){for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]})},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e(407)}().default}));

},{}],841:[function(require,module,exports){
arguments[4][544][0].apply(exports,arguments)
},{"dup":544}],842:[function(require,module,exports){
arguments[4][545][0].apply(exports,arguments)
},{"../package.json":841,"dup":545,"fable-serviceproviderbase":838}],843:[function(require,module,exports){
arguments[4][550][0].apply(exports,arguments)
},{"dup":550}],844:[function(require,module,exports){
arguments[4][551][0].apply(exports,arguments)
},{"dup":551}],845:[function(require,module,exports){
arguments[4][552][0].apply(exports,arguments)
},{"../package.json":844,"dup":552,"fable-serviceproviderbase":838}],846:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libNavigo = require('navigo');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Router',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// When true, addRoute() will NOT auto-resolve after each route is added.
	// This is useful in auth-gated SPAs where routes should only resolve after
	// the DOM is ready (e.g. after login).  Can also be set globally via
	// pict.settings.RouterSkipRouteResolveOnAdd — either one enables the skip.
	SkipRouteResolveOnAdd: false,

	// Document title management.  When a DefaultTitle is set (or a per-route title
	// is passed to addRoute), the router keeps document.title in step with the
	// current route: a route with a title renders `<title><TitleSuffix>`, a route
	// without one falls back to DefaultTitle so a title never lingers from the
	// previous page.  All three are empty by default, so with no configuration the
	// router does not touch document.title (fully backward compatible).
	DefaultTitle: '',
	TitleSuffix: ''
}

class PictRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Initialize the navigo router and set the base path to '/'
		this.router = new libNavigo('/', { strategy: 'ONE', hash: true });

		// BEFORE the Routes option is processed below, because that calls addRoute, which writes here.
		// Route pattern -> handler, so renavigate()/reenter() can run a route the router is already on.
		this._routeHandlers = {};
		// Set by the `already` hook every route carries; read by navigate() to report whether the
		// router actually resolved.  See navigate().
		this._lastNavigateDeclined = false;

		if (this.options.Routes)
		{
			for (let i = 0; i < this.options.Routes.length; i++)
			{
				if (this.options.Routes[i].path && this.options.Routes[i].template)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].template);
				}
				else if (this.options.Routes[i].path && this.options.Routes[i].render)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].render);
				}
				else
				{
					this.pict.log.warn(`Route ${i} is missing a render function or template string.`);
				}
			}
		}

		// This is the route to render after load
		this.afterPersistView = '/Manyfest/Overview';

	}

	get currentScope()
	{
		return this.AppData?.ManyfestRecord?.Scope ?? 'Default';
	}

	forwardToScopedRoute(pData)
	{
		this.navigate(`${pData.url}/${this.currentScope}`);
	}

	onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	/**
	 * Compose a document title from a page title and the configured suffix.  An empty page title
	 * falls back to DefaultTitle so a titleless route never inherits the previous page's title.
	 *
	 * @param {string} pTitle - the page-specific title (may be empty)
	 * @returns {string}
	 */
	composeTitle(pTitle)
	{
		let tmpTitle = (typeof pTitle === 'string') ? pTitle : '';
		if (!tmpTitle) { return this.options.DefaultTitle || ''; }
		let tmpSuffix = this.options.TitleSuffix || '';
		return tmpSuffix ? (tmpTitle + tmpSuffix) : tmpTitle;
	}

	/**
	 * Set document.title from a page title (applying the configured suffix).  Public so async / entity
	 * pages can set their title once the record loads, after the route handler has already run.
	 *
	 * @param {string} pTitle - the page-specific title
	 */
	setDocumentTitle(pTitle)
	{
		if (typeof document === 'undefined') { return; }
		document.title = this.composeTitle(pTitle);
	}

	// Whether the router should manage document.title at all: only once a DefaultTitle or TitleSuffix is
	// configured, or a per-route title is supplied.  Keeps the no-configuration path from touching the DOM.
	_managesTitle(pTitle)
	{
		return (pTitle !== undefined) || !!this.options.DefaultTitle || !!this.options.TitleSuffix;
	}

	// Apply a route's title on match.  A per-route title (string or (pData)=>string) wins; a route with no
	// title resets to DefaultTitle so the previous page's title does not linger.
	_applyRouteTitle(pTitle, pData)
	{
		if (typeof document === 'undefined' || !this._managesTitle(pTitle)) { return; }
		let tmpResolved = (typeof pTitle === 'function') ? pTitle(pData) : pTitle;
		document.title = this.composeTitle(tmpResolved);
	}

	/**
	 * Add a route to the router.
	 *
	 * @param {string} pRoute - the route pattern
	 * @param {function|string} pRenderable - a handler function or a template string
	 * @param {string|function} [pTitle] - optional document title for this route: a string, or a
	 *        (pData)=>string resolved on match.  Requires DefaultTitle/TitleSuffix configured (or this
	 *        arg present) for the router to touch document.title.
	 */
	addRoute(pRoute, pRenderable, pTitle, pHooks)
	{
		let tmpHandler = null;
		if (typeof(pRenderable) === 'function')
		{
			tmpHandler = (pData) =>
				{
					this._applyRouteTitle(pTitle, pData);
					return pRenderable(pData);
				};
		}
		else if (typeof(pRenderable) === 'string')
		{
			// Run this as a template, allowing some whack things with functions in template expressions.
			tmpHandler = (pData) =>
				{
					this._applyRouteTitle(pTitle, pData);
					this.pict.parseTemplate(pRenderable, pData, null, this.pict)
				};
		}
		if (tmpHandler)
		{
			// Remember the handler so renavigate() can run it for a route the router is already on.
			// Keyed WITHOUT the leading slash, which is how the underlying router reports a matched
			// route's path -- so a lookup by pattern and a lookup off a live match agree.
			this._routeHandlers[this._routeKey(pRoute)] = tmpHandler;
			this.router.on(pRoute, tmpHandler, this._composeHooks(pRoute, pHooks));
		}
		else
		{
			// renderable isn't usable!
			this.pict.log.warn(`Route ${pRoute} has an invalid renderable.`);
			return;
		}

		// By default, resolve after each route is added (legacy behavior).
		// Applications can skip this by setting SkipRouteResolveOnAdd: true in
		// the provider config JSON, or globally via
		// pict.settings.RouterSkipRouteResolveOnAdd.  Either one will prevent
		// premature route resolution before views are rendered.
		if (!this.options.SkipRouteResolveOnAdd && !this.pict.settings.RouterSkipRouteResolveOnAdd)
		{
			this.resolve();
		}
	}

	/**
	 * Navigate to a given route (set the browser URL string, add to history, trigger router)
	 *
	 * RETURNS WHETHER THE ROUTE ACTUALLY RESOLVED.  Navigating to the route you are already on is a
	 * no-op by design -- the underlying router declines to run the handler again -- and that is usually
	 * right.  What was missing is any way to KNOW: navigate() returned nothing, so a caller could not
	 * tell "went there" from "did nothing", and code that assumed it had moved would leave whatever was
	 * on screen exactly where it was.  This does not change the behaviour, only reports it.
	 *
	 * The answer comes from the router's own signal rather than by comparing URL strings: every route
	 * carries an internal `already` hook (see _composeHooks) that the router fires when it declines.
	 *
	 * Note for asynchronous route hooks: if an application's before-hook resolves asynchronously the
	 * router has not finished by the time this returns, and this reports true (it did not decline).
	 * That is the same answer callers effectively assumed before this existed.
	 *
	 * @param {string} pRoute - The route to navigate to
	 * @param {object} [pOptions] - options for the underlying router (for example
	 *        { updateBrowserURL: false } for an application that writes the URL itself)
	 * @returns {boolean} true when the route resolved, false when the router was already on it
	 */
	navigate(pRoute, pOptions)
	{
		this._lastNavigateDeclined = false;
		if (pOptions) { this.router.navigate(pRoute, pOptions); }
		else { this.router.navigate(pRoute); }
		return !this._lastNavigateDeclined;
	}

	/**
	 * Navigate to a route, and run its handler even if the router is already on it.
	 *
	 * For the legitimate "enter this route again" case: something has rendered over the route without
	 * telling the router (a form opened in place, a modal took the pane), so the router's idea of what
	 * is on screen and what is actually on screen have come apart, and asking to go there again has to
	 * mean something.  Prefer giving that state a route of its own where you can; use this where you
	 * cannot.
	 *
	 * @param {string} pRoute - The route to navigate to
	 * @param {object} [pOptions] - options for the underlying router, as navigate()
	 * @returns {boolean} true when the handler ran, either by navigation or by re-entry
	 */
	renavigate(pRoute, pOptions)
	{
		if (this.navigate(pRoute, pOptions)) { return true; }
		return this.reenter(pRoute);
	}

	/**
	 * Run the handler for the route the router is currently on, without touching history.
	 *
	 * @param {string} [pRoute] - the route pattern to re-enter; defaults to the last resolved route
	 * @returns {boolean} true when a handler was found and run
	 */
	reenter(pRoute)
	{
		let tmpMatch = this.lastMatch();
		let tmpHandler = pRoute ? this._routeHandlers[this._routeKey(pRoute)] : null;
		// A caller re-entering by the URL it navigated to ('/thing/12') is not naming the pattern the
		// handler is stored under ('/thing/:id'), so fall back to whatever the router actually
		// resolved. That is also the no-argument case: re-enter wherever we are.
		if (!tmpHandler && tmpMatch && tmpMatch.route)
		{
			tmpHandler = this._routeHandlers[this._routeKey(tmpMatch.route.path)];
		}
		if (typeof tmpHandler !== 'function') { return false; }
		tmpHandler(tmpMatch || {});
		return true;
	}

	/**
	 * The router's last resolved match, or null.  Handy for a caller that wants to know where it is
	 * without reaching into the underlying router.
	 *
	 * @returns {object|null}
	 */
	lastMatch()
	{
		if (!this.router || typeof this.router.lastResolved !== 'function') { return null; }
		let tmpResolved = this.router.lastResolved();
		return (tmpResolved && tmpResolved[0]) ? tmpResolved[0] : null;
	}

	/**
	 * Build the hook set handed to the underlying router for one route.
	 *
	 * Always installs an `already` hook, which the router fires when it declines to re-run a handler
	 * for the route it is already on.  An application's own `already` hook still runs, after ours.
	 *
	 * @param {string} pRoute - the route pattern
	 * @param {object} [pHooks] - optional before / after / leave / already hooks from the caller
	 * @returns {object}
	 */
	// One spelling for a route, so a pattern given as '/x' and a match reporting 'x' agree.
	_routeKey(pRoute) { return String(pRoute || '').replace(/^\/+/, ''); }

	_composeHooks(pRoute, pHooks)
	{
		let tmpHooks = Object.assign({}, pHooks || {});
		let fCallerAlready = tmpHooks.already;
		tmpHooks.already = (pMatch) =>
		{
			this._lastNavigateDeclined = true;
			if (typeof fCallerAlready === 'function') { fCallerAlready(pMatch); }
		};
		return tmpHooks;
	}

	/**
	 * Navigate to the route currently in the browser's location hash.
	 *
	 * This is useful in auth-gated SPAs: when the user pastes a deep-link
	 * (e.g. #/Books) and then logs in, calling navigateCurrent() will force
	 * the router to fire the handler for whatever hash is already in the URL.
	 * Unlike resolve(), navigate() always triggers the handler even if Navigo
	 * has already "consumed" that URL.
	 *
	 * If the hash is empty or just "#/", this is a no-op and returns false.
	 *
	 * @returns {boolean} true if a route was navigated to, false otherwise
	 */
	navigateCurrent()
	{
		let tmpHash = (typeof (window) !== 'undefined' && window.location) ? window.location.hash : '';
		if (tmpHash && tmpHash.length > 2 && tmpHash !== '#/')
		{
			let tmpRoute = tmpHash.replace(/^#/, '');
			this.navigate(tmpRoute);
			return true;
		}
		return false;
	}

	/**
	 * Trigger the router resolving logic; this is expected to be called after all routes are added (to go to the default route).
	 *
	 */
	resolve()
	{
		this.router.resolve();
	}
}

module.exports = PictRouter;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;
},{"navigo":840,"pict-provider":845}],847:[function(require,module,exports){
arguments[4][556][0].apply(exports,arguments)
},{"dup":556}],848:[function(require,module,exports){
arguments[4][557][0].apply(exports,arguments)
},{"dup":557}],849:[function(require,module,exports){
arguments[4][558][0].apply(exports,arguments)
},{"./Pict-Code-Highlighter.js":847,"./Pict-Section-Code-DefaultConfiguration.js":848,"./demos":850,"dup":558,"pict-view":1053}],850:[function(require,module,exports){
arguments[4][559][0].apply(exports,arguments)
},{"../Pict-Section-Code.js":849,"dup":559}],851:[function(require,module,exports){
arguments[4][560][0].apply(exports,arguments)
},{"dup":560}],852:[function(require,module,exports){
arguments[4][561][0].apply(exports,arguments)
},{"./providers/Pict-Provider-Content.js":853,"./views/Pict-View-Content.js":854,"./views/PictView-Content-Demo.js":855,"dup":561}],853:[function(require,module,exports){
arguments[4][562][0].apply(exports,arguments)
},{"../Pict-Content-CSS.js":851,"dup":562,"pict-provider":845,"pict-section-code":849}],854:[function(require,module,exports){
arguments[4][563][0].apply(exports,arguments)
},{"../Pict-Content-CSS.js":851,"dup":563,"pict-provider-theme/source/Theme-Diagram-Adapter.js":843,"pict-view":1053}],855:[function(require,module,exports){
arguments[4][564][0].apply(exports,arguments)
},{"../providers/Pict-Provider-Content.js":853,"./Pict-View-Content.js":854,"dup":564}],856:[function(require,module,exports){
arguments[4][580][0].apply(exports,arguments)
},{"dup":580}],857:[function(require,module,exports){
arguments[4][581][0].apply(exports,arguments)
},{"./Pict-Section-Excalidraw-DefaultConfiguration.js":856,"./views/PictView-Excalidraw-Iframe.js":859,"./views/PictView-Excalidraw-React.js":860,"dup":581,"pict-view":1053}],858:[function(require,module,exports){
arguments[4][582][0].apply(exports,arguments)
},{"dup":582}],859:[function(require,module,exports){
arguments[4][583][0].apply(exports,arguments)
},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":856,"dup":583,"pict-view":1053}],860:[function(require,module,exports){
arguments[4][584][0].apply(exports,arguments)
},{"../Pict-Section-Excalidraw-DefaultConfiguration.js":856,"../utils/Excalidraw-Form-Factor.js":858,"dup":584,"pict-view":1053}],861:[function(require,module,exports){
/**
 * Default configuration for the Pict Section Form Host provider.
 *
 * Every knob a developer needs to embed a pict-section-form lives here in one
 * place.  The whole point of the host is that these four questions --
 *
 *     1. What form? ................. Form (the manifest)
 *     2. Rendered where? ............ DestinationType + DestinationAddress
 *     3. Data stored where? ......... DataAddress
 *     4. What runs on lifecycle? .... Hooks
 *
 * -- are answered in a single object instead of being scattered across a
 * metacontroller view, a DataBroker provider, application settings and a pile
 * of container <div> conventions.
 */
module.exports = (
{
	// PictProvider plumbing.  A host can be added multiple times under distinct
	// hashes; each instance drives its own form region.
	"ProviderIdentifier": "Pict-Section-Form-Host",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 20,

	// The form manifest ({ Descriptors, Sections, ReferenceManifests, PickLists,
	// ... }) -- the same shape pict-section-form consumes.  Leave false to
	// construct the host empty and call loadForm(manifest) later.
	"Form": false,

	// Where the form is mounted:
	//   'div'    -- render straight into an element in the host document (default)
	//   'iframe' -- boot a genuinely independent child pict INSIDE an iframe and
	//               render the form there.  The child owns its own document, CSS
	//               cascade and event handlers (true isolation); the parent host
	//               talks to it over a postMessage bridge and mirrors the form
	//               data back into DataAddress.  See the iframe options below.
	"DestinationType": "div",

	// CSS selector of the element the form (div mode) or the iframe (iframe mode)
	// is mounted into.  If the element does not exist and CreateDestinationElement
	// is true, the host appends one to <body>.
	"DestinationAddress": "#Pict-Form-Host-Container",

	// When the DestinationAddress element is missing, create it (appended to the
	// document body) instead of erroring.  Handy for programmatic, headless and
	// test scenarios.
	"CreateDestinationElement": true,

	// iframe-mode tuning (ignored in div mode).
	"IframeTitle": "Pict Form",
	"IframeClass": "pict-section-form-host-iframe",
	// Inline style applied to the generated iframe element.
	"IframeStyle": "width: 100%; height: 100%; min-height: 240px; border: 0;",
	// Extra <style> text injected into the iframe document head.  Use it to give
	// the isolated document a base look (the child pict injects the form's own
	// CSS on top of this).
	"IframeDocumentCSS": "",
	// The scripts that boot the runtime INSIDE the iframe realm.  The child needs
	// window.Pict and window.PictSectionFormHost present before it runs.  Provide
	// the URLs here (e.g. ['./pict.min.js', './pict-section-form-host.min.js']);
	// when left false the host auto-clones the host document's own external
	// <script src> tags into the iframe, which works when the app loads those
	// runtimes as separate script tags.
	"IframeScripts": false,
	// Optional URL of an externally hosted child page (for a cross-origin child).
	// When set, the iframe uses this src instead of a generated same-origin
	// srcdoc; that page is responsible for including the pict + host runtime and
	// the child bootstrap.  The postMessage protocol is identical either way.
	"IframeSrc": false,

	// The Pict state address the form marshals to and from.  Anything
	// pict.resolveStateFromAddress understands works: 'AppData',
	// 'AppData.MyRecord', 'Bundle.Thing', etc.  The object is auto-created if
	// it does not exist yet.
	"DataAddress": "AppData",

	// Render the form as soon as loadForm() (or initial load from the Form
	// option) completes.
	"AutoRenderOnLoad": true,

	// After each render, push the data at DataAddress into the freshly rendered
	// inputs.
	"AutoMarshalToViewAfterRender": true,

	// Fill DataAddress with the manifest's declared Default values for any
	// fields that are missing when the form loads.
	"PopulateDefaultObject": true,

	// Run the manifest solvers once immediately after the first render.
	"SolveOnLoad": true,

	// When embedding the SAME manifest in more than one host on a page, set this
	// true so the host rewrites the manifest's hashes and data addresses to be
	// unique per instance (via the metacontroller's createDistinctManifest).
	// Each instance then keeps its own data under DataAddress.  Leave false when
	// every host on the page uses a manifest with distinct Section hashes.
	"DistinctManifest": false,

	// Optional override for the metacontroller class the host drives.  Defaults
	// to pict-section-form's PictFormMetacontroller (lazy-required so importing
	// this module never hard-fails when pict-section-form is absent).  Tests and
	// advanced hosts can inject a compatible prototype here.
	"MetacontrollerPrototype": false
});

},{}],862:[function(require,module,exports){
/**
 * Iframe child runtime for pict-section-form-host.
 *
 * This is the code that runs INSIDE the iframe, in the iframe's own realm. It
 * boots a genuinely independent pict instance whose `document`, `window`,
 * `HTMLInputElement` and CSS cascade are all the iframe's own -- so the embedded
 * form renders natively, with no parent monkey-patching, no cross-document
 * `instanceof` hazards, and no CSS mirroring. The form is driven by a plain
 * div-mode `PictSectionFormHost` living in that child pict; the only thing that
 * crosses the frame boundary is data, over a small postMessage protocol.
 *
 * The runtime is shipped as a function whose source is injected into the iframe
 * document (see the parent host's iframe path). It depends only on two globals
 * being present in the iframe realm before it runs:
 *
 *   window.Pict                  -- the pict library
 *   window.PictSectionFormHost   -- this module's browser bundle
 *
 * The parent guarantees those by injecting the appropriate <script> tags (from
 * `IframeScripts`, or auto-cloned from the parent document) ahead of this
 * runtime.
 *
 * Message protocol (envelope carries `{ channel, type, frameId, ... }`):
 *
 *   parent -> child : init, loadForm, setData, marshalToView, marshalFromView, solve, destroy
 *   child  -> parent: ready, loaded, data, error
 *
 * `data` messages carry the child's current form data and a `reason`
 * ('init' | 'change' | 'save' | 'setData' | 'solve'); the parent mirrors them to
 * its own DataAddress and fires onSave when the reason is 'save'.
 */

const CHANNEL = 'pict-section-form-host';

// The container the child form renders into, inside the iframe body.
const CHILD_CONTAINER_ID = 'PictSectionFormHost-Child-Container';

// The child's local data address. It never leaves the iframe; data crosses the
// boundary as plain objects in `data` messages.
const CHILD_DATA_ADDRESS = 'AppData.PictSectionFormHostForm';

/**
 * The runtime that executes inside the iframe. Written as a named function so it
 * can be `.toString()`-injected; it closes over nothing but the constants above,
 * which are inlined by the parent alongside it.
 *
 * @param {Object} pConstants - { CHANNEL, CHILD_CONTAINER_ID, CHILD_DATA_ADDRESS }
 */
function pictSectionFormHostIframeChildMain(pConstants)
{
	var CHANNEL = pConstants.CHANNEL;
	var CONTAINER_ID = pConstants.CHILD_CONTAINER_ID;
	var DATA_ADDRESS = pConstants.CHILD_DATA_ADDRESS;

	var _frameId = null;
	var _parentOrigin = null;
	var _pict = null;
	var _host = null;

	function post(pType, pExtra)
	{
		if (!window.parent)
		{
			return;
		}
		var tmpMessage = { channel: CHANNEL, type: pType, frameId: _frameId };
		if (pExtra)
		{
			for (var tmpKey in pExtra)
			{
				if (Object.prototype.hasOwnProperty.call(pExtra, tmpKey))
				{
					tmpMessage[tmpKey] = pExtra[tmpKey];
				}
			}
		}
		// Before init we do not yet know the parent origin; '*' is safe for the
		// ready handshake because it carries no data. Afterward we target the
		// recorded origin.
		window.parent.postMessage(tmpMessage, _parentOrigin || '*');
	}

	function postData(pReason)
	{
		var tmpData = null;
		try
		{
			tmpData = _host ? _host.getFormData() : null;
		}
		catch (pError)
		{
			tmpData = null;
		}
		post('data', { reason: pReason, data: tmpData });
	}

	function buildHost(pConfig)
	{
		if (typeof (window.Pict) !== 'function')
		{
			post('error', { message: 'pict is not present in the iframe realm (window.Pict missing).' });
			return false;
		}
		if (typeof (window.PictSectionFormHost) !== 'function')
		{
			post('error', { message: 'pict-section-form-host is not present in the iframe realm (window.PictSectionFormHost missing).' });
			return false;
		}

		_pict = new window.Pict({ Product: 'PictSectionFormHost-Iframe-Child' });

		// The rendered form's inline handlers resolve `window._Pict` (pict's
		// default browser address). `new Pict()` does not set that global the way
		// safeLoadPictApplication would, so wire it here -- to the CHILD pict --
		// so in-frame interaction (onchange -> dataChanged) works.
		window._Pict = _pict;

		_host = _pict.addProvider('PictSectionFormHostChild',
			{
				DestinationType: 'div',
				DestinationAddress: '#' + CONTAINER_ID,
				DataAddress: DATA_ADDRESS,
				PopulateDefaultObject: (pConfig && typeof (pConfig.PopulateDefaultObject) === 'boolean') ? pConfig.PopulateDefaultObject : true,
				SolveOnLoad: (pConfig && typeof (pConfig.SolveOnLoad) === 'boolean') ? pConfig.SolveOnLoad : true,
				// When the child host collects the DOM (marshalFromView), relay it
				// out as a 'save' so the parent can fire its onSave.
				onSave: function () { postData('save'); },
				onAfterRender: function () { /* rendered; data relayed separately */ }
			}, window.PictSectionFormHost);

		return true;
	}

	// Relay in-frame edits back to the parent so its DataAddress mirror stays
	// current. psf commits an input to the child's AppData on the element's own
	// (bubble-phase) change handler; a bubble-phase listener here therefore sees
	// already-committed data.
	function installChangeRelay()
	{
		document.addEventListener('change', function ()
		{
			postData('change');
		}, false);
	}

	function handleInit(pMessage, pOrigin)
	{
		_frameId = pMessage.frameId;
		_parentOrigin = pOrigin;

		if (!buildHost(pMessage.config || {}))
		{
			return;
		}
		installChangeRelay();

		if (pMessage.manifest)
		{
			_host.loadForm(pMessage.manifest);
		}
		if (pMessage.data && typeof (pMessage.data) === 'object')
		{
			_host.setFormData(pMessage.data);
		}

		post('loaded', {});
		postData('init');
	}

	function handleMessage(pEvent)
	{
		var tmpMessage = pEvent.data;
		if (!tmpMessage || tmpMessage.channel !== CHANNEL)
		{
			return;
		}
		// Only accept messages from our parent window.
		if (pEvent.source !== window.parent)
		{
			return;
		}
		// After init, enforce the origin we handshook with and our frame id.
		if (_parentOrigin && pEvent.origin !== _parentOrigin)
		{
			return;
		}
		if (_frameId && tmpMessage.frameId && tmpMessage.frameId !== _frameId)
		{
			return;
		}

		switch (tmpMessage.type)
		{
			case 'init':
				handleInit(tmpMessage, pEvent.origin);
				break;
			case 'loadForm':
				if (_host && tmpMessage.manifest)
				{
					_host.loadForm(tmpMessage.manifest);
					if (tmpMessage.data && typeof (tmpMessage.data) === 'object')
					{
						_host.setFormData(tmpMessage.data);
					}
					post('loaded', {});
					postData('loadForm');
				}
				break;
			case 'setData':
				if (_host)
				{
					_host.setFormData(tmpMessage.data || {});
					postData('setData');
				}
				break;
			case 'marshalToView':
				if (_host)
				{
					_host.marshalToView();
				}
				break;
			case 'marshalFromView':
				if (_host)
				{
					// Fires the child host's onSave -> postData('save').
					_host.marshalFromView();
				}
				break;
			case 'solve':
				if (_host)
				{
					_host.solve();
					postData('solve');
				}
				break;
			case 'destroy':
				if (_host)
				{
					_host.destroy();
				}
				break;
			default:
				break;
		}
	}

	window.addEventListener('message', handleMessage, false);

	// Announce readiness. The parent replies with 'init'. '*' is acceptable here
	// because the ready message carries no data.
	post('ready', {});
}

module.exports =
{
	CHANNEL: CHANNEL,
	CHILD_CONTAINER_ID: CHILD_CONTAINER_ID,
	CHILD_DATA_ADDRESS: CHILD_DATA_ADDRESS,
	childMainFunction: pictSectionFormHostIframeChildMain,

	/**
	 * Build the inline script source that boots the child runtime inside the
	 * iframe document.
	 *
	 * @returns {string} JavaScript source to inline in the iframe.
	 */
	buildChildRuntimeSource: function ()
	{
		var tmpConstants = JSON.stringify(
			{
				CHANNEL: CHANNEL,
				CHILD_CONTAINER_ID: CHILD_CONTAINER_ID,
				CHILD_DATA_ADDRESS: CHILD_DATA_ADDRESS
			});
		return '(' + pictSectionFormHostIframeChildMain.toString() + ')(' + tmpConstants + ');';
	}
};

},{}],863:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DefaultConfiguration = require('./Pict-Section-Form-Host-DefaultConfiguration.js');
const createPictSectionFormHostMetacontroller = require('./views/Pict-View-Form-Host-Metacontroller.js');
const libPictSectionFormHostIframeBridge = require('./services/Pict-Section-Form-Host-Iframe-Bridge.js');
const libPictSectionFormHostIframeChild = require('./Pict-Section-Form-Host-Iframe-Child.js');

// The lifecycle hooks the host exposes.  Each maps to a moment in the form's
// life; handlers registered via `on()` or provided in configuration run in
// registration order and receive a single context object.
const _HOOK_NAMES =
[
	'onBeforeLoad',
	'onAfterLoad',
	'onBeforeRender',
	'onAfterRender',
	'onSave'
];

/**
 * PictSectionFormHost
 *
 * A cohesive programmatic container around pict-section-form.  Give it a form
 * manifest, a place to render (a div or an iframe), a Pict state address to
 * store the data at, and optional lifecycle hooks -- and it wires up the
 * metacontroller, section views, container elements and two-way data binding
 * that a raw pict-section-form setup would otherwise make you assemble by hand.
 *
 * @example
 * const tmpFormHost = pict.addProvider('MyForm', {
 *         Form: require('./My-Form-Manifest.json'),
 *         DestinationType: 'div',
 *         DestinationAddress: '#My-Form-Container',
 *         DataAddress: 'AppData.MyForm',
 *         onSave: (pContext) => console.log('saved', pContext.Data)
 *     }, require('pict-section-form-host'));
 * // With `Form` configured the host loads and renders itself on initialize.
 * // Programmatic control:
 * tmpFormHost.setFormData({ FirstName: 'Ada' });
 * const tmpData = tmpFormHost.getFormData();
 * tmpFormHost.marshalFromView();          // pull the DOM back into AppData + fire onSave
 * tmpFormHost.loadForm(otherManifest);    // swap the whole form config in place
 *
 * @extends libPictProvider
 */
class PictSectionFormHost extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Merge the host defaults under the caller options.  We intentionally do
		// NOT deep-clone pOptions so hook functions passed in configuration
		// survive; the base PictProvider clones only its own default block.
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {Record<string, any>} */
		this.options;

		// --- Resolved configuration ------------------------------------------
		this._dataAddress = (typeof(this.options.DataAddress) === 'string' && this.options.DataAddress.length > 0)
			? this.options.DataAddress
			: 'AppData';
		this._destinationType = (this.options.DestinationType === 'iframe') ? 'iframe' : 'div';
		this._destinationAddress = this.options.DestinationAddress || '#Pict-Form-Host-Container';

		// The current form manifest.  `false` until loadForm() / the Form option.
		this._formManifest = (this.options.Form && typeof(this.options.Form) === 'object') ? this.options.Form : false;

		// --- Internal state --------------------------------------------------
		// div mode: a dedicated metacontroller + section views in THIS pict.
		this._metacontroller = null;
		this._metacontrollerHash = `PictSectionFormHost-Metacontroller-${this.Hash}`;
		/** @type {Array<any>} */
		this._sectionViews = [];

		// iframe mode: a bridge to a child pict running inside the iframe.  The
		// form lives entirely in the child; only data crosses the boundary, and
		// it is mirrored into this._dataAddress in the parent state.
		this._iframeBridge = null;

		this._loaded = false;
		this._rendered = false;
		// Carried across the async iframe load so onAfterLoad reports correctly.
		this._pendingIsSwap = false;

		// --- Lifecycle hooks -------------------------------------------------
		/** @type {Record<string, Array<Function>>} */
		this._hooks = {};
		for (let i = 0; i < _HOOK_NAMES.length; i++)
		{
			this._hooks[_HOOK_NAMES[i]] = [];
		}
		this._seedHooksFromOptions();
	}

	/**
	 * PictProvider lifecycle -- once the provider is initialized, auto-load the
	 * form when a manifest was supplied in configuration.  Best-effort: a
	 * missing DOM or manifest is logged, never thrown, so a half-built page does
	 * not crash the whole application.
	 *
	 * @returns {any} The base onAfterInitialize result.
	 */
	onAfterInitialize()
	{
		if (this._formManifest && !this._loaded)
		{
			try
			{
				this.loadForm();
			}
			catch (pError)
			{
				this.log.error(`PictSectionFormHost [${this.Hash}] auto-load failed: ${pError}`, pError);
			}
		}
		return super.onAfterInitialize();
	}

	// =========================================================================
	//  Lifecycle hooks
	// =========================================================================

	/**
	 * Register a lifecycle hook handler.
	 *
	 * @param {string} pHookName - One of: onBeforeLoad, onAfterLoad, onBeforeRender, onAfterRender, onSave.
	 * @param {Function} fHandler - Handler invoked with a single context object.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	on(pHookName, fHandler)
	{
		if (!this._hooks.hasOwnProperty(pHookName))
		{
			this.log.warn(`PictSectionFormHost [${this.Hash}] on() called with unknown hook [${pHookName}]. Known hooks: ${_HOOK_NAMES.join(', ')}.`);
			return this;
		}
		if (typeof(fHandler) !== 'function')
		{
			this.log.warn(`PictSectionFormHost [${this.Hash}] on(${pHookName}) requires a function handler.`);
			return this;
		}
		this._hooks[pHookName].push(fHandler);
		return this;
	}

	/**
	 * Seed hook handlers from the configuration object.  Both a top-level
	 * `onSave: fn` and a grouped `Hooks: { onSave: fn }` are supported.
	 *
	 * @private
	 */
	_seedHooksFromOptions()
	{
		const tmpGrouped = (this.options.Hooks && typeof(this.options.Hooks) === 'object') ? this.options.Hooks : {};
		for (let i = 0; i < _HOOK_NAMES.length; i++)
		{
			const tmpName = _HOOK_NAMES[i];
			if (typeof(this.options[tmpName]) === 'function')
			{
				this._hooks[tmpName].push(this.options[tmpName]);
			}
			if (typeof(tmpGrouped[tmpName]) === 'function')
			{
				this._hooks[tmpName].push(tmpGrouped[tmpName]);
			}
		}
	}

	/**
	 * Invoke every handler registered for a hook.  A handler that throws is
	 * logged and does not abort the others or the host operation.
	 *
	 * @param {string} pHookName - The hook to fire.
	 * @param {Record<string, any>} [pContext] - Context passed to each handler.
	 * @returns {void}
	 * @private
	 */
	_invokeHook(pHookName, pContext)
	{
		const tmpHandlers = this._hooks[pHookName] || [];
		const tmpContext = Object.assign(
			{
				Host: this,
				HookName: pHookName,
				DataAddress: this._dataAddress
			}, pContext);
		for (let i = 0; i < tmpHandlers.length; i++)
		{
			try
			{
				tmpHandlers[i](tmpContext);
			}
			catch (pError)
			{
				this.log.error(`PictSectionFormHost [${this.Hash}] hook [${pHookName}] handler ${i} threw: ${pError}`, pError);
			}
		}
	}

	// =========================================================================
	//  Loading / configuration
	// =========================================================================

	/**
	 * Load (or reload / swap) the form.  This is the single entry point that
	 * builds the whole form region: prepares the destination, bootstraps the
	 * section views from the manifest, wires their data binding to DataAddress
	 * and -- when AutoRenderOnLoad is set -- renders.
	 *
	 * Call it with a new manifest to swap the entire form configuration in place
	 * while keeping the same host, destination and data address.
	 *
	 * @param {Record<string, any>} [pFormManifest] - The form manifest. Defaults to the currently configured Form.
	 * @param {Record<string, any>} [pOptionsOverride] - Optional { DataAddress, DestinationType, DestinationAddress } overrides applied before loading.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	loadForm(pFormManifest, pOptionsOverride)
	{
		if (pFormManifest && typeof(pFormManifest) === 'object')
		{
			this._formManifest = pFormManifest;
		}
		if (pOptionsOverride && typeof(pOptionsOverride) === 'object')
		{
			this._applyDestinationOverrides(pOptionsOverride);
		}

		if (!this._formManifest || typeof(this._formManifest) !== 'object')
		{
			this.log.error(`PictSectionFormHost [${this.Hash}] loadForm() called with no manifest to load.`);
			return this;
		}

		const tmpIsSwap = this._loaded;

		this._invokeHook('onBeforeLoad', { Manifest: this._formManifest, IsSwap: tmpIsSwap });

		// iframe mode is driven entirely by the child pict over the bridge.
		if (this._destinationType === 'iframe')
		{
			return this._loadFormIframe(tmpIsSwap);
		}

		// Tear down any previously loaded sections so a swap starts clean.
		if (tmpIsSwap)
		{
			this._teardownFormSections();
		}

		// Ensure the AppData object we marshal into exists.
		this._ensureDataObject();

		// Prepare the destination (div element or iframe + inner container).
		this._prepareDestination();

		// Create the dedicated metacontroller for this host (once).
		this._ensureMetacontroller();
		// Keep the metacontroller's marshal destination in sync with the current
		// data address (it can be retargeted via loadForm's override argument).
		this._metacontroller.viewMarshalDestination = this._dataAddress;

		// Resolve the manifest actually bootstrapped -- optionally namespaced so
		// the same form can be embedded by several hosts on one page.
		let tmpEffectiveManifest = this._formManifest;
		if (this.options.DistinctManifest && typeof(this._metacontroller.createDistinctManifest) === 'function')
		{
			tmpEffectiveManifest = this._metacontroller.createDistinctManifest(this._formManifest, this.UUID);
		}

		// Bootstrap the section views + generate the container metatemplate, all
		// with the marshal destination pointed at this host's data address so
		// default population lands in the right place.
		this._withMarshalDestination(() =>
		{
			this._metacontroller.bootstrapPictFormViewsFromManifest(tmpEffectiveManifest);
			this._captureSectionViews();
			this._metacontroller.generateMetatemplate();
		});

		this._loaded = true;

		if (this.options.AutoRenderOnLoad)
		{
			this.render();
		}

		this._invokeHook('onAfterLoad', { Manifest: tmpEffectiveManifest, IsSwap: tmpIsSwap });

		return this;
	}

	/**
	 * Swap the form configuration.  Alias for loadForm(pManifest) that reads as
	 * intent at the call site.
	 *
	 * @param {Record<string, any>} pFormManifest - The new form manifest.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	setConfiguration(pFormManifest)
	{
		return this.loadForm(pFormManifest);
	}

	/**
	 * Reload the currently configured manifest from scratch.
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	reload()
	{
		return this.loadForm(this._formManifest);
	}

	// =========================================================================
	//  Rendering
	// =========================================================================

	/**
	 * Render (or re-render) the form into its destination.  Fires onBeforeRender
	 * / onAfterRender around the work and, per configuration, pushes the current
	 * data into the freshly rendered inputs.
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	render()
	{
		if (!this._loaded)
		{
			this.log.warn(`PictSectionFormHost [${this.Hash}] render() called before the form was loaded; loading now.`);
			return this.loadForm();
		}

		// In iframe mode the child pict owns rendering; a parent render() just
		// re-pushes the current data and re-runs onBeforeRender/onAfterRender.
		if (this._destinationType === 'iframe')
		{
			this._invokeHook('onBeforeRender', { Manifest: this._formManifest });
			if (this._iframeBridge)
			{
				this._iframeBridge.marshalToView();
			}
			this._rendered = true;
			this._invokeHook('onAfterRender', { Manifest: this._formManifest });
			return this;
		}

		this._invokeHook('onBeforeRender', { Manifest: this._formManifest });

		// Destination can be torn out from under us between renders (SPA nav,
		// etc.); make sure it is present.
		this._prepareDestination();

		this._withMarshalDestination(() =>
		{
			this._metacontroller.generateMetatemplate();
			this._metacontroller.render();
		});

		if (this.options.AutoMarshalToViewAfterRender)
		{
			this.marshalToView();
		}

		if (this.options.SolveOnLoad)
		{
			this.solve();
		}

		this._rendered = true;

		this._invokeHook('onAfterRender', { Manifest: this._formManifest });

		return this;
	}

	// =========================================================================
	//  Data marshaling
	// =========================================================================

	/**
	 * Push the data at DataAddress into the rendered form inputs (data -> DOM).
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	marshalToView()
	{
		if (this._destinationType === 'iframe')
		{
			// Push the parent mirror into the child form.
			if (this._iframeBridge)
			{
				this._iframeBridge.setData(this.getFormData());
			}
			return this;
		}
		this._withMarshalDestination(() =>
		{
			for (let i = 0; i < this._sectionViews.length; i++)
			{
				this._sectionViews[i].marshalToView();
			}
		});
		return this;
	}

	/**
	 * Pull the current form input values back into the data at DataAddress
	 * (DOM -> data), then fire the onSave hook with the resulting data object.
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	marshalFromView()
	{
		if (this._destinationType === 'iframe')
		{
			// Ask the child to collect its DOM; it replies with a 'save' data
			// message which mirrors into DataAddress and fires onSave (async).
			if (this._iframeBridge)
			{
				this._iframeBridge.marshalFromView();
			}
			return this;
		}
		this._withMarshalDestination(() =>
		{
			for (let i = 0; i < this._sectionViews.length; i++)
			{
				this._sectionViews[i].marshalFromView();
			}
		});
		this._invokeHook('onSave', { Data: this.getFormData() });
		return this;
	}

	/**
	 * Semantic alias for marshalFromView() -- reads as "collect what the user
	 * entered and persist it into AppData (+ onSave)".
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	save()
	{
		return this.marshalFromView();
	}

	/**
	 * Run the manifest solvers, then reflect any computed values back into the
	 * inputs.
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	solve()
	{
		if (this._destinationType === 'iframe')
		{
			if (this._iframeBridge)
			{
				this._iframeBridge.solve();
			}
			return this;
		}
		if (!this.pict.providers.DynamicSolver)
		{
			return this;
		}
		this._withMarshalDestination(() =>
		{
			this.pict.providers.DynamicSolver.solveViews();
		});
		this.marshalToView();
		return this;
	}

	// =========================================================================
	//  Data accessors
	// =========================================================================

	/**
	 * Get the live data object the form marshals into (the object at DataAddress).
	 *
	 * @returns {Record<string, any>} The data object.
	 */
	getFormData()
	{
		return this.pict.providers.DataBroker.resolveMarshalDestinationObject(this._dataAddress);
	}

	/**
	 * Replace the form's data object wholesale and push it into the view.
	 *
	 * @param {Record<string, any>} pData - The new data object.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	setFormData(pData)
	{
		const tmpData = (pData && typeof(pData) === 'object') ? pData : {};
		// Update the parent mirror immediately so getFormData() is current.
		this.pict.setStateValueAtAddress(this._dataAddress, null, tmpData);
		if (this._destinationType === 'iframe')
		{
			if (this._iframeBridge)
			{
				this._iframeBridge.setData(tmpData);
			}
			return this;
		}
		if (this._rendered)
		{
			this.marshalToView();
		}
		return this;
	}

	/**
	 * Semantic alias for setFormData() -- reads as "load this record into the
	 * form".
	 *
	 * @param {Record<string, any>} pData - The record to load.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	loadData(pData)
	{
		return this.setFormData(pData);
	}

	/**
	 * Get a single value from the form data by descriptor hash (or address).
	 *
	 * @param {string} pHash - The descriptor hash or data address.
	 * @returns {any} The value.
	 */
	getValueByHash(pHash)
	{
		return this.pict.manifest.getValueByHash(this.getFormData(), pHash);
	}

	/**
	 * Set a single value in the form data by descriptor hash (or address) and
	 * reflect it in the view.
	 *
	 * @param {string} pHash - The descriptor hash or data address.
	 * @param {any} pValue - The value to set.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	setValueByHash(pHash, pValue)
	{
		this.pict.manifest.setValueByHash(this.getFormData(), pHash, pValue);
		if (this._rendered)
		{
			this.marshalToView();
		}
		return this;
	}

	// =========================================================================
	//  Accessors
	// =========================================================================

	/**
	 * @returns {any} The dedicated metacontroller instance driving this host (or null).
	 */
	getMetacontroller()
	{
		return this._metacontroller;
	}

	/**
	 * @returns {Array<any>} The section-form views this host owns.
	 */
	getSectionViews()
	{
		return this._sectionViews.slice();
	}

	/**
	 * @returns {string} The Pict state address the form marshals to/from.
	 */
	getDataAddress()
	{
		return this._dataAddress;
	}

	/**
	 * Point the form at a different data address.  Takes effect on the next
	 * marshal / render.
	 *
	 * @param {string} pDataAddress - The new state address.
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	setDataAddress(pDataAddress)
	{
		if (typeof(pDataAddress) === 'string' && pDataAddress.length > 0)
		{
			this._dataAddress = pDataAddress;
			// iframe mode keeps its data in the child; the parent only needs the
			// new mirror address, which subsequent child data messages write to.
			if (this._metacontroller)
			{
				this._metacontroller.viewMarshalDestination = pDataAddress;
			}
			for (let i = 0; i < this._sectionViews.length; i++)
			{
				this._sectionViews[i].viewMarshalDestination = pDataAddress;
			}
		}
		return this;
	}

	/**
	 * @returns {string} 'div' or 'iframe'.
	 */
	getDestinationType()
	{
		return this._destinationType;
	}

	/**
	 * @returns {any} The generated iframe element in iframe mode, else null.
	 */
	getIframeElement()
	{
		return this._iframeBridge ? this._iframeBridge.iframe : null;
	}

	/**
	 * @returns {any} The iframe bridge in iframe mode, else null.
	 */
	getIframeBridge()
	{
		return this._iframeBridge;
	}

	/**
	 * @returns {boolean} Whether the form has been loaded.
	 */
	isLoaded()
	{
		return this._loaded;
	}

	/**
	 * @returns {boolean} Whether the form has been rendered at least once.
	 */
	isRendered()
	{
		return this._rendered;
	}

	// =========================================================================
	//  Teardown
	// =========================================================================

	/**
	 * Tear the whole host down: remove the section views and metacontroller (div
	 * mode) or the iframe + its child pict (iframe mode).
	 *
	 * @returns {PictSectionFormHost} this (chainable).
	 */
	destroy()
	{
		if (this._destinationType === 'iframe')
		{
			if (this._iframeBridge)
			{
				this._iframeBridge.destroy();
				this._iframeBridge = null;
			}
			this._loaded = false;
			this._rendered = false;
			return this;
		}

		this._teardownFormSections();

		if (this._metacontroller && this.pict.views[this._metacontrollerHash])
		{
			delete this.pict.views[this._metacontrollerHash];
		}
		this._metacontroller = null;

		this._loaded = false;
		this._rendered = false;

		return this;
	}

	// =========================================================================
	//  Internals -- metacontroller
	// =========================================================================

	/**
	 * Resolve (and cache on the pict instance) the host metacontroller class,
	 * built by wrapping pict-section-form's PictFormMetacontroller.  Lazy so
	 * importing this module never hard-requires pict-section-form.
	 *
	 * @returns {Function} The host metacontroller class.
	 * @private
	 */
	_resolveHostMetacontrollerClass()
	{
		let tmpBasePrototype = this.options.MetacontrollerPrototype;
		if (!tmpBasePrototype)
		{
			// eslint-disable-next-line global-require
			const libPictSectionForm = require('pict-section-form');
			tmpBasePrototype = libPictSectionForm.PictFormMetacontroller;
		}
		if (typeof(tmpBasePrototype) !== 'function')
		{
			throw new Error('PictSectionFormHost could not resolve a PictFormMetacontroller prototype from pict-section-form. Is pict-section-form installed?');
		}
		return createPictSectionFormHostMetacontroller(tmpBasePrototype);
	}

	/**
	 * Ensure a PictApplication is present on the pict instance, creating a
	 * minimal default one if the host was dropped onto a bare pict.
	 *
	 * @private
	 */
	_ensureApplication()
	{
		if (this.pict.PictApplication)
		{
			return;
		}
		try
		{
			// eslint-disable-next-line global-require
			const libPictApplication = require('pict-application');
			this.pict.addApplication('PictSectionFormHostDefaultApplication', {}, libPictApplication);
		}
		catch (pError)
		{
			this.log.warn(`PictSectionFormHost [${this.Hash}] could not ensure a default PictApplication: ${pError}`);
		}
	}

	/**
	 * Create the dedicated metacontroller view for this host if it does not
	 * exist yet.  Per-instance template / renderable / destination hashes keep
	 * multiple hosts from colliding.
	 *
	 * @private
	 */
	_ensureMetacontroller()
	{
		if (this._metacontroller)
		{
			return;
		}

		// pict-section-form's layout providers assume a PictApplication is
		// present (they read pict.PictApplication.options for grid quantization,
		// etc.).  A real consumer always has one; when the host is dropped onto
		// a bare pict instance we stand up a minimal default application so the
		// form machinery has the context it expects.
		this._ensureApplication();

		const tmpHostMetacontrollerClass = this._resolveHostMetacontrollerClass();

		const tmpContainerSelector = this._getContainerSelector();
		const tmpMetaTemplateHash = `PictSectionFormHost-Metatemplate-${this.Hash}`;
		const tmpRenderableHash = `PictSectionFormHost-Metacontainer-${this.Hash}`;

		const tmpMetacontrollerOptions =
		{
			// Never auto-render or auto-populate globally; the host drives both,
			// scoped to its own section views.
			"AutoRender": false,
			"AutoPopulateAfterRender": false,
			"AutoPopulateDefaultObject": !!this.options.PopulateDefaultObject,
			"HostMarshalDestination": this._dataAddress,

			"MetaTemplateHash": tmpMetaTemplateHash,
			"DefaultRenderable": tmpRenderableHash,
			"DefaultDestinationAddress": tmpContainerSelector,

			"Templates":
			[
				{
					"Hash": tmpMetaTemplateHash,
					"Template": "<!-- PictSectionFormHost metatemplate pending generateMetatemplate() -->"
				}
			],
			"Renderables":
			[
				{
					"RenderableHash": tmpRenderableHash,
					"TemplateHash": tmpMetaTemplateHash,
					"DestinationAddress": tmpContainerSelector
				}
			]
		};

		this._metacontroller = this.pict.addView(this._metacontrollerHash, tmpMetacontrollerOptions, tmpHostMetacontrollerClass);
		this._metacontroller.viewMarshalDestination = this._dataAddress;
	}

	/**
	 * Collect the section-form views this host's metacontroller owns (tagged at
	 * bootstrap) and point them at the host data address.
	 *
	 * @private
	 */
	_captureSectionViews()
	{
		this._sectionViews = [];
		const tmpViewHashes = Object.keys(this.pict.views);
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			const tmpView = this.pict.views[tmpViewHashes[i]];
			if (tmpView && tmpView.isPictSectionForm && tmpView._pictFormHostMetacontrollerHash === this._metacontrollerHash)
			{
				tmpView.viewMarshalDestination = this._dataAddress;
				this._sectionViews.push(tmpView);
			}
		}
	}

	/**
	 * Remove this host's section views from the pict view registry (used on
	 * config swap and destroy).
	 *
	 * @private
	 */
	_teardownFormSections()
	{
		for (let i = 0; i < this._sectionViews.length; i++)
		{
			const tmpView = this._sectionViews[i];
			if (tmpView && tmpView.Hash && this.pict.views[tmpView.Hash])
			{
				delete this.pict.views[tmpView.Hash];
			}
		}
		this._sectionViews = [];
		if (this._metacontroller)
		{
			// Clear the manifest so a subsequent bootstrap does not try to merge
			// against the old one.
			if (typeof(this._metacontroller.clearManifestDescription) === 'function')
			{
				this._metacontroller.clearManifestDescription();
			}
			else
			{
				this._metacontroller.manifestDescription = null;
			}
		}
	}

	// =========================================================================
	//  Internals -- destination (div / iframe)
	// =========================================================================

	/**
	 * The CSS selector the metacontroller renders its container metatemplate
	 * into (div mode). It is the developer's DestinationAddress.
	 *
	 * @returns {string} The container selector.
	 * @private
	 */
	_getContainerSelector()
	{
		return this._destinationAddress;
	}

	/**
	 * Ensure the render destination exists, creating it if configured to.
	 *
	 * @private
	 */
	_prepareDestination()
	{
		if (this._destinationType === 'iframe')
		{
			this._ensureIframeBridge();
		}
		else
		{
			this._ensureDivDestination();
		}
	}

	/**
	 * Ensure the div-mode destination element exists in the host document.
	 *
	 * @private
	 */
	_ensureDivDestination()
	{
		const tmpExisting = this.pict.ContentAssignment.getElement(this._destinationAddress);
		if (tmpExisting && tmpExisting.length > 0)
		{
			return;
		}
		if (!this.options.CreateDestinationElement)
		{
			this.log.warn(`PictSectionFormHost [${this.Hash}] destination [${this._destinationAddress}] not found and CreateDestinationElement is false.`);
			return;
		}
		if (typeof(document) === 'undefined' || !document.body)
		{
			return;
		}
		// Create an element that satisfies the configured selector where we can.
		const tmpElement = document.createElement('div');
		const tmpSelector = this._destinationAddress;
		if (tmpSelector.charAt(0) === '#')
		{
			tmpElement.id = tmpSelector.slice(1);
		}
		else if (tmpSelector.charAt(0) === '.')
		{
			tmpElement.className = tmpSelector.slice(1);
		}
		else
		{
			tmpElement.id = tmpSelector;
			this._destinationAddress = `#${tmpSelector}`;
		}
		document.body.appendChild(tmpElement);
	}

	// =========================================================================
	//  Internals -- iframe mode (child pict over a postMessage bridge)
	// =========================================================================

	/**
	 * The iframe-mode load path.  Ensures the bridge (and the child pict inside
	 * the iframe) exists, then hands the manifest + current data to the child.
	 * onAfterRender / onAfterLoad fire asynchronously when the child reports the
	 * load completed.
	 *
	 * @param {boolean} pIsSwap - Whether this is a configuration swap.
	 * @returns {PictSectionFormHost} this (chainable).
	 * @private
	 */
	_loadFormIframe(pIsSwap)
	{
		this._pendingIsSwap = pIsSwap;
		this._ensureDataObject();
		this._ensureIframeBridge();

		this._invokeHook('onBeforeRender', { Manifest: this._formManifest });

		// Hand over the manifest.  Only pass data when the mirror actually holds
		// a record, so a fresh load lets the child populate manifest defaults
		// rather than being wiped by an empty object.
		const tmpMirror = this.getFormData();
		const tmpData = (tmpMirror && typeof(tmpMirror) === 'object' && Object.keys(tmpMirror).length > 0) ? tmpMirror : null;

		if (this._iframeBridge)
		{
			this._iframeBridge.loadForm(this._formManifest, tmpData);
		}

		this._loaded = true;
		return this;
	}

	/**
	 * Resolve the script URLs to load into the iframe realm: the explicit
	 * `IframeScripts` list when provided, otherwise the external `<script src>`
	 * URLs of the host document (so the iframe loads the same runtime).
	 *
	 * @returns {Array<string>} Script URLs.
	 * @private
	 */
	_resolveIframeScripts()
	{
		if (Array.isArray(this.options.IframeScripts) && this.options.IframeScripts.length > 0)
		{
			return this.options.IframeScripts.slice();
		}
		const tmpScripts = [];
		if (typeof(document) !== 'undefined' && document.querySelectorAll)
		{
			const tmpElements = document.querySelectorAll('script[src]');
			for (let i = 0; i < tmpElements.length; i++)
			{
				const tmpSrc = tmpElements[i].getAttribute('src');
				if (tmpSrc)
				{
					tmpScripts.push(tmpElements[i].src || tmpSrc);
				}
			}
		}
		return tmpScripts;
	}

	/**
	 * Create the iframe bridge (once).  Resolves the mount element, the runtime
	 * scripts and the child config, then mounts the iframe and starts the
	 * handshake.
	 *
	 * @private
	 */
	_ensureIframeBridge()
	{
		if (this._iframeBridge)
		{
			return;
		}

		// Ensure a mount element for the iframe.
		this._ensureDivDestination();
		const tmpMountSet = this.pict.ContentAssignment.getElement(this._destinationAddress);
		const tmpMount = (tmpMountSet && tmpMountSet.length > 0) ? tmpMountSet[0] : null;
		if (!tmpMount)
		{
			this.log.error(`PictSectionFormHost [${this.Hash}] iframe mount [${this._destinationAddress}] not found and could not be created.`);
			return;
		}

		this._iframeBridge = new libPictSectionFormHostIframeBridge(
			{
				pict: this.pict,
				log: this.log,
				frameId: `PSFH-${this.UUID}`,
				mountElement: tmpMount,
				scripts: this._resolveIframeScripts(),
				iframeSrc: (typeof(this.options.IframeSrc) === 'string' && this.options.IframeSrc.length > 0) ? this.options.IframeSrc : null,
				iframeAttributes:
				{
					id: `PictSectionFormHost-Iframe-${this.UUID}`,
					title: this.options.IframeTitle,
					class: this.options.IframeClass,
					style: this.options.IframeStyle
				},
				iframeDocumentCSS: (typeof(this.options.IframeDocumentCSS) === 'string') ? this.options.IframeDocumentCSS : '',
				childConfig:
				{
					PopulateDefaultObject: !!this.options.PopulateDefaultObject,
					SolveOnLoad: !!this.options.SolveOnLoad
				},
				onData: (pData, pReason) => this._onChildData(pData, pReason),
				onLoaded: () => this._onChildLoaded(),
				onError: (pMessage) => this.log.error(`PictSectionFormHost [${this.Hash}] iframe error: ${pMessage}`)
			});
		this._iframeBridge.mount();
	}

	/**
	 * Handle a data message from the child pict: mirror the data into the
	 * parent's DataAddress and, when the child reports a save, fire onSave.
	 *
	 * @param {Record<string, any>} pData - The child's current form data.
	 * @param {string} pReason - Why the child sent it (init | change | save | setData | solve | loadForm).
	 * @private
	 */
	_onChildData(pData, pReason)
	{
		this.pict.setStateValueAtAddress(this._dataAddress, null, (pData && typeof(pData) === 'object') ? pData : {});
		if (pReason === 'save')
		{
			this._invokeHook('onSave', { Data: this.getFormData() });
		}
	}

	/**
	 * Handle a load-completed message from the child pict: fire onAfterRender and
	 * onAfterLoad (the asynchronous counterparts of the synchronous div path).
	 *
	 * @private
	 */
	_onChildLoaded()
	{
		this._rendered = true;
		this._invokeHook('onAfterRender', { Manifest: this._formManifest });
		this._invokeHook('onAfterLoad', { Manifest: this._formManifest, IsSwap: this._pendingIsSwap });
	}

	/**
	 * Apply { DataAddress, DestinationType, DestinationAddress } overrides passed
	 * to loadForm().
	 *
	 * @param {Record<string, any>} pOverrides - The overrides.
	 * @private
	 */
	_applyDestinationOverrides(pOverrides)
	{
		if (typeof(pOverrides.DataAddress) === 'string' && pOverrides.DataAddress.length > 0)
		{
			this._dataAddress = pOverrides.DataAddress;
		}
		if (pOverrides.DestinationType === 'iframe' || pOverrides.DestinationType === 'div')
		{
			this._destinationType = pOverrides.DestinationType;
		}
		if (typeof(pOverrides.DestinationAddress) === 'string' && pOverrides.DestinationAddress.length > 0)
		{
			this._destinationAddress = pOverrides.DestinationAddress;
		}
	}

	// =========================================================================
	//  Internals -- data helpers
	// =========================================================================

	/**
	 * Make sure the object we marshal into exists at DataAddress.
	 *
	 * @private
	 */
	_ensureDataObject()
	{
		let tmpObject = this.pict.resolveStateFromAddress(this._dataAddress);
		if (!tmpObject || typeof(tmpObject) !== 'object')
		{
			this.pict.setStateValueAtAddress(this._dataAddress, null, {});
		}
	}

	/**
	 * Run a function with the global DataBroker marshal destination temporarily
	 * pointed at this host's data address, then restore it.  Because the host's
	 * section views also carry their own viewMarshalDestination, this only
	 * matters for the manifest's default-population and solver passes, which
	 * read the global broker -- but restoring keeps a host application's own
	 * default marshal location untouched between host operations.
	 *
	 * @param {Function} fOperation - The operation to run.
	 * @returns {any} The operation result.
	 * @private
	 */
	_withMarshalDestination(fOperation)
	{
		const tmpBroker = this.pict.providers.DataBroker;
		const tmpPrevious = tmpBroker.marshalDestination;
		tmpBroker.marshalDestination = this._dataAddress;
		try
		{
			return fOperation();
		}
		finally
		{
			tmpBroker.marshalDestination = tmpPrevious;
		}
	}
}

module.exports = PictSectionFormHost;

module.exports.default_configuration = _DefaultConfiguration;

// Re-export the building blocks so advanced hosts and tests can reach them.
module.exports.PictSectionFormHostIframeBridge = libPictSectionFormHostIframeBridge;
module.exports.iframeChild = libPictSectionFormHostIframeChild;
module.exports.createPictSectionFormHostMetacontroller = createPictSectionFormHostMetacontroller;

},{"./Pict-Section-Form-Host-DefaultConfiguration.js":861,"./Pict-Section-Form-Host-Iframe-Child.js":862,"./services/Pict-Section-Form-Host-Iframe-Bridge.js":864,"./views/Pict-View-Form-Host-Metacontroller.js":865,"pict-application":842,"pict-provider":845,"pict-section-form":874}],864:[function(require,module,exports){
const libIframeChild = require('../Pict-Section-Form-Host-Iframe-Child.js');

/**
 * Parent-side bridge to an iframe that runs its own child pict.
 *
 * The bridge builds the iframe, injects the pict runtime plus the child runtime
 * into the iframe realm, and proxies the host's API to the child over a small
 * postMessage protocol. It owns exactly one iframe and speaks only to that
 * iframe's window (correlating by `event.source` and, after the handshake, by a
 * frame id and origin).
 *
 * Same-origin by default: the iframe is built with `srcdoc`, whose content runs
 * at the parent's origin, so postMessage stays within one origin. A caller that
 * wants a cross-origin child hosts a page carrying the child runtime elsewhere
 * and passes its URL as `IframeSrc`; the protocol is identical either way.
 */
class PictSectionFormHostIframeBridge
{
	/**
	 * @param {Object} pOptions - Bridge options.
	 * @param {any} pOptions.pict - The parent pict instance.
	 * @param {any} pOptions.log - A logger.
	 * @param {string} pOptions.frameId - A unique id correlating this bridge to its iframe.
	 * @param {any} pOptions.mountElement - The DOM element the iframe is placed inside.
	 * @param {Array<string>} pOptions.scripts - Script URLs to load into the iframe realm (before the child runtime).
	 * @param {Object} pOptions.iframeAttributes - { id, title, class, style }.
	 * @param {string} pOptions.iframeDocumentCSS - Extra CSS for the iframe document.
	 * @param {string} [pOptions.iframeSrc] - Optional URL for a cross-origin child page (skips srcdoc).
	 * @param {Object} pOptions.childConfig - { PopulateDefaultObject, SolveOnLoad } passed to the child host.
	 * @param {Function} pOptions.onData - (data, reason) => void, called when the child reports data.
	 * @param {Function} pOptions.onLoaded - () => void, called when the child reports a load completed.
	 * @param {Function} pOptions.onError - (message) => void.
	 */
	constructor(pOptions)
	{
		this.pict = pOptions.pict;
		this.log = pOptions.log;
		this.frameId = pOptions.frameId;
		this.mountElement = pOptions.mountElement;
		this.scripts = Array.isArray(pOptions.scripts) ? pOptions.scripts : [];
		this.iframeAttributes = pOptions.iframeAttributes || {};
		this.iframeDocumentCSS = pOptions.iframeDocumentCSS || '';
		this.iframeSrc = pOptions.iframeSrc || null;
		this.childConfig = pOptions.childConfig || {};

		this.onData = (typeof (pOptions.onData) === 'function') ? pOptions.onData : function () {};
		this.onLoaded = (typeof (pOptions.onLoaded) === 'function') ? pOptions.onLoaded : function () {};
		this.onError = (typeof (pOptions.onError) === 'function') ? pOptions.onError : function () {};

		this.iframe = null;
		this.ready = false;
		this._outbound = [];
		this._messageHandler = null;
		this._targetOrigin = this.iframeSrc ? this._originOf(this.iframeSrc) : this._selfOrigin();

		// The manifest/data to hand the child at init (whatever was requested
		// before it announced ready).
		this._pendingInit = { manifest: null, data: null };
	}

	_selfOrigin()
	{
		try
		{
			return window.location.origin;
		}
		catch (pError)
		{
			return '*';
		}
	}

	_originOf(pUrl)
	{
		try
		{
			return new URL(pUrl, window.location.href).origin;
		}
		catch (pError)
		{
			return '*';
		}
	}

	/**
	 * Create the iframe and start the handshake. Idempotent: a second call with
	 * the iframe still present is a no-op.
	 */
	mount()
	{
		if (this.iframe && this.iframe.parentNode)
		{
			return;
		}
		if (typeof (document) === 'undefined' || !this.mountElement)
		{
			this.onError('iframe mode requires a browser document and a mount element.');
			return;
		}

		const tmpIframe = document.createElement('iframe');
		tmpIframe.id = this.iframeAttributes.id || ('PictSectionFormHost-Iframe-' + this.frameId);
		if (this.iframeAttributes.class)
		{
			tmpIframe.className = this.iframeAttributes.class;
		}
		if (this.iframeAttributes.title)
		{
			tmpIframe.setAttribute('title', this.iframeAttributes.title);
		}
		if (this.iframeAttributes.style)
		{
			tmpIframe.setAttribute('style', this.iframeAttributes.style);
		}

		// Listen for this iframe's messages. Installed before the document loads
		// so the child's 'ready' is never missed.
		this._messageHandler = (pEvent) => this._handleMessage(pEvent);
		window.addEventListener('message', this._messageHandler, false);

		this.mountElement.innerHTML = '';
		this.mountElement.appendChild(tmpIframe);
		this.iframe = tmpIframe;

		if (this.iframeSrc)
		{
			// Cross-origin (or externally hosted) child page. It is responsible
			// for including the pict runtime + the child runtime itself.
			tmpIframe.setAttribute('src', this.iframeSrc);
		}
		else
		{
			tmpIframe.setAttribute('srcdoc', this._buildDocument());
		}
	}

	_buildDocument()
	{
		let tmpScripts = '';
		for (let i = 0; i < this.scripts.length; i++)
		{
			tmpScripts += '<script src="' + this._escapeAttribute(this.scripts[i]) + '"></' + 'script>';
		}
		const tmpRuntime = libIframeChild.buildChildRuntimeSource();
		return '<!doctype html><html><head><meta charset="utf-8">'
			+ '<style id="PICT-CSS"></style>'
			+ '<style>' + this.iframeDocumentCSS + '</style>'
			+ tmpScripts
			+ '</head><body>'
			+ '<div id="' + libIframeChild.CHILD_CONTAINER_ID + '"></div>'
			+ '<script>' + tmpRuntime + '</' + 'script>'
			+ '</body></html>';
	}

	_escapeAttribute(pValue)
	{
		return String(pValue).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
	}

	_handleMessage(pEvent)
	{
		const tmpMessage = pEvent.data;
		if (!tmpMessage || tmpMessage.channel !== libIframeChild.CHANNEL)
		{
			return;
		}
		// Only our iframe's window.
		if (!this.iframe || pEvent.source !== this.iframe.contentWindow)
		{
			return;
		}
		// After the child echoes our frame id, enforce it.
		if (tmpMessage.frameId && tmpMessage.frameId !== this.frameId)
		{
			return;
		}

		switch (tmpMessage.type)
		{
			case 'ready':
				this._onChildReady();
				break;
			case 'loaded':
				this.onLoaded();
				break;
			case 'data':
				this.onData(tmpMessage.data, tmpMessage.reason);
				break;
			case 'error':
				this.log.error(`PictSectionFormHost iframe child error: ${tmpMessage.message}`);
				this.onError(tmpMessage.message);
				break;
			default:
				break;
		}
	}

	_onChildReady()
	{
		this.ready = true;
		// Hand the child its identity + the initial form.
		this._send('init',
			{
				config: this.childConfig,
				manifest: this._pendingInit.manifest,
				data: this._pendingInit.data
			});
		// Flush anything queued while the child was booting.
		for (let i = 0; i < this._outbound.length; i++)
		{
			this._postNow(this._outbound[i].type, this._outbound[i].payload);
		}
		this._outbound = [];
	}

	_send(pType, pPayload)
	{
		if (!this.ready)
		{
			this._outbound.push({ type: pType, payload: pPayload });
			return;
		}
		this._postNow(pType, pPayload);
	}

	_postNow(pType, pPayload)
	{
		if (!this.iframe || !this.iframe.contentWindow)
		{
			return;
		}
		const tmpMessage = Object.assign({ channel: libIframeChild.CHANNEL, type: pType, frameId: this.frameId }, pPayload || {});
		this.iframe.contentWindow.postMessage(tmpMessage, this._targetOrigin);
	}

	// --- Proxied host API ----------------------------------------------------

	/**
	 * Load (or swap) the form in the child. Before the child is ready this seeds
	 * the init handshake; after, it sends a loadForm message.
	 *
	 * @param {Object} pManifest - The form manifest.
	 * @param {Object} [pData] - Optional data to load with the manifest.
	 */
	loadForm(pManifest, pData)
	{
		if (!this.ready)
		{
			this._pendingInit.manifest = pManifest;
			this._pendingInit.data = (pData && typeof (pData) === 'object') ? pData : this._pendingInit.data;
			return;
		}
		this._send('loadForm', { manifest: pManifest, data: (pData && typeof (pData) === 'object') ? pData : null });
	}

	setData(pData)
	{
		this._send('setData', { data: pData });
	}

	marshalToView()
	{
		this._send('marshalToView', {});
	}

	marshalFromView()
	{
		this._send('marshalFromView', {});
	}

	solve()
	{
		this._send('solve', {});
	}

	destroy()
	{
		this._send('destroy', {});
		if (this._messageHandler)
		{
			window.removeEventListener('message', this._messageHandler, false);
			this._messageHandler = null;
		}
		if (this.iframe && this.iframe.parentNode)
		{
			this.iframe.parentNode.removeChild(this.iframe);
		}
		this.iframe = null;
		this.ready = false;
		this._outbound = [];
	}
}

module.exports = PictSectionFormHostIframeBridge;

},{"../Pict-Section-Form-Host-Iframe-Child.js":862}],865:[function(require,module,exports){
/**
 * A thin subclass of pict-section-form's PictFormMetacontroller that the host
 * drives for a single embedded form region.
 *
 * Why a subclass at all?  The stock metacontroller is designed to be the single
 * global form controller for an application.  Three of its behaviors have to be
 * scoped down so that several independent hosts (or a host living alongside a
 * host application's own forms) do not collide:
 *
 *   1. Manifest source.  The stock metacontroller auto-bootstraps its section
 *      views from `fable.settings.DefaultFormManifest` -- one global slot.  We
 *      fall back to the per-instance `options.HostManifest` instead.
 *
 *   2. View scoping.  `filterViews()` (which every render / metatemplate call
 *      funnels through) walks *all* of `pict.views` and returns *every*
 *      section-form view in the application.  We restrict it to the section
 *      views this metacontroller actually created, tagged at bootstrap time, so
 *      one host never renders another host's sections into its container.
 *
 *   3. Marshal destination.  Section views this host owns are pointed at the
 *      host's own data address so their two-way binding is isolated.
 *
 * Everything else -- section-view creation, metatemplate generation, solve
 * orchestration, render -- is inherited unchanged.
 *
 * The class is produced by a factory rather than declared at module scope so
 * that `require('pict-section-form-host')` never hard-requires pict-section-form
 * just to load the class hierarchy -- the base prototype is passed in lazily by
 * the host the first time a form is actually loaded.
 *
 * @param {Function} pBaseMetacontrollerPrototype - pict-section-form's PictFormMetacontroller class.
 * @returns {Function} The PictSectionFormHostMetacontroller subclass.
 */
function createPictSectionFormHostMetacontroller(pBaseMetacontrollerPrototype)
{
	class PictSectionFormHostMetacontroller extends pBaseMetacontrollerPrototype
	{
		constructor(pFable, pOptions, pServiceHash)
		{
			super(pFable, pOptions, pServiceHash);

			this.serviceType = 'PictSectionFormHostMetacontroller';

			// The address (e.g. 'AppData.MyForm') this metacontroller's section
			// views marshal to and from.  When set, it wins over the global
			// DataBroker.marshalDestination so hosts stay isolated from each
			// other and from the host application's own default data location.
			this._hostMarshalDestination = (this.options && typeof(this.options.HostMarshalDestination) === 'string')
				? this.options.HostMarshalDestination
				: null;
		}

		/**
		 * Per-instance marshal destination.  The stock metacontroller proxies
		 * this straight to the shared DataBroker; the host override keeps an
		 * instance-local address so multiple hosts do not stomp on one another.
		 */
		get viewMarshalDestination()
		{
			return this._hostMarshalDestination || this.pict.providers.DataBroker.marshalDestination;
		}

		set viewMarshalDestination(pValue)
		{
			this._hostMarshalDestination = pValue;
		}

		/**
		 * Resolve the manifest for a bootstrap call.  When the stock async-init
		 * path calls this with no argument, supply the host's own manifest
		 * instead of reaching for the single global settings slot.  After the
		 * base creates the section views, tag each one as belonging to this
		 * metacontroller and point it at the host's data address.
		 *
		 * @param {Record<string, any>} [pManifestDescription] - The manifest to bootstrap.
		 * @param {string} [pAfterSectionHash] - Section hash to insert after.
		 * @returns {Array<any>} The section list the base method returns.
		 */
		bootstrapPictFormViewsFromManifest(pManifestDescription, pAfterSectionHash)
		{
			let tmpManifestDescription = (pManifestDescription && typeof(pManifestDescription) === 'object')
				? pManifestDescription
				: ((this.options && this.options.HostManifest && typeof(this.options.HostManifest) === 'object')
					? this.options.HostManifest
					: null);

			if (!tmpManifestDescription)
			{
				// The host drives bootstrap explicitly once it has resolved (and
				// possibly rewritten) the manifest.  Quietly no-op the stock
				// auto-initialization call so it does not log a spurious
				// "no manifest" error against the single global settings slot.
				return [];
			}

			const tmpSectionList = super.bootstrapPictFormViewsFromManifest(tmpManifestDescription, pAfterSectionHash);

			const tmpMarshalDestination = this._hostMarshalDestination
				|| (this.options && typeof(this.options.HostMarshalDestination) === 'string' ? this.options.HostMarshalDestination : null);

			for (let i = 0; i < (tmpSectionList || []).length; i++)
			{
				const tmpView = this.pict.views[`PictSectionForm-${tmpSectionList[i].Hash}`];
				if (tmpView)
				{
					// Ownership tag consumed by the filterViews scope below.
					tmpView._pictFormHostMetacontrollerHash = this.Hash;
					if (tmpMarshalDestination)
					{
						tmpView.viewMarshalDestination = tmpMarshalDestination;
					}
				}
			}

			return tmpSectionList;
		}

		/**
		 * Scope the base view filter to the section views this metacontroller
		 * owns.  Because generateMetatemplate / regenerateFormSectionTemplates /
		 * renderFormSections / marshalFormSections all route through here -- and
		 * several of them are called internally with no filter argument -- this
		 * single override is what keeps a host's render confined to its own
		 * sections.
		 *
		 * @param {Function} [fFilterFunction] - Caller-supplied view filter.
		 * @param {Function} [fSortFunction] - Caller-supplied view sort.
		 * @returns {Array<any>} The filtered (host-scoped) view list.
		 */
		filterViews(fFilterFunction, fSortFunction)
		{
			const tmpHostHash = this.Hash;
			const fScopedFilter = (pView) =>
			{
				if (!pView)
				{
					return false;
				}
				if (pView.isPictSectionForm)
				{
					// Drop section views owned by a different host / the global controller.
					if (pView._pictFormHostMetacontrollerHash !== tmpHostHash)
					{
						return false;
					}
					if (typeof(fFilterFunction) === 'function')
					{
						return fFilterFunction(pView);
					}
					// No explicit filter: honor the section's default-render flag,
					// exactly as the base filterViews would have.
					return (pView.sectionDefinition && ('IncludeInDefaultDynamicRender' in pView.sectionDefinition))
						? !!pView.sectionDefinition.IncludeInDefaultDynamicRender
						: true;
				}
				if (typeof(fFilterFunction) === 'function')
				{
					return fFilterFunction(pView);
				}
				return true;
			};
			return super.filterViews(fScopedFilter, fSortFunction);
		}

		/**
		 * Marker so host code (and anyone walking pict.views) can tell a
		 * host-owned metacontroller apart from a plain one.
		 *
		 * @returns {boolean} Always true.
		 */
		get isPictSectionFormHostMetacontroller()
		{
			return true;
		}
	}

	// Inherit the base metacontroller's default configuration so pict.addView
	// merges the well-known defaults (AutoPopulateDefaultObject, MetaTemplateHash,
	// OnlyRenderDynamicSections, ...) before the host's per-instance overrides.
	PictSectionFormHostMetacontroller.default_configuration = pBaseMetacontrollerPrototype.default_configuration;

	return PictSectionFormHostMetacontroller;
}

module.exports = createPictSectionFormHostMetacontroller;

},{}],866:[function(require,module,exports){
arguments[4][674][0].apply(exports,arguments)
},{"dup":674}],867:[function(require,module,exports){
arguments[4][675][0].apply(exports,arguments)
},{"dup":675}],868:[function(require,module,exports){
arguments[4][676][0].apply(exports,arguments)
},{"dup":676}],869:[function(require,module,exports){
arguments[4][677][0].apply(exports,arguments)
},{"dup":677}],870:[function(require,module,exports){
arguments[4][678][0].apply(exports,arguments)
},{"dup":678,"pict-provider-theme/source/Theme-Diagram-Adapter.js":843,"pict-section-content":852}],871:[function(require,module,exports){
arguments[4][679][0].apply(exports,arguments)
},{"dup":679}],872:[function(require,module,exports){
arguments[4][680][0].apply(exports,arguments)
},{"./Pict-MDE-CodeMirror.js":866,"./Pict-MDE-DragAndReorder.js":867,"./Pict-MDE-Formatting.js":868,"./Pict-MDE-ImageHandling.js":869,"./Pict-MDE-RichPreview.js":870,"./Pict-Section-MarkdownEditor-DefaultConfiguration.js":871,"dup":680,"pict-section-content":852,"pict-view":1053}],873:[function(require,module,exports){
arguments[4][586][0].apply(exports,arguments)
},{"dup":586}],874:[function(require,module,exports){
arguments[4][587][0].apply(exports,arguments)
},{"./application/Pict-Application-Form.js":875,"./providers/Pict-Provider-DynamicLayout.js":879,"./providers/Pict-Provider-DynamicTemplates.js":883,"./providers/Pict-Provider-FormPersistence.js":884,"./providers/Pict-Provider-InputExtension.js":886,"./providers/inputs/Pict-Provider-Input-Diagram.js":898,"./providers/inputs/Pict-Provider-Input-RichText.js":907,"./providers/inputs/util/Themeify-SVG.js":914,"./services/ManifestConversionToCSV.js":923,"./services/ManifestFactory.js":924,"./services/Pict-Service-DynamicFormDependencyManager.js":925,"./views/Pict-View-DynamicForm.js":940,"./views/Pict-View-Form-Metacontroller.js":941,"./views/support/Pict-View-PSF-DebugViewer.js":944,"./views/support/Pict-View-PSF-LifeCycle-Visualization.js":945,"./views/support/Pict-View-PSF-SupportBase.js":948,"dup":587}],875:[function(require,module,exports){
arguments[4][588][0].apply(exports,arguments)
},{"../Pict-Section-Form.js":874,"dup":588,"pict-application":842}],876:[function(require,module,exports){
arguments[4][589][0].apply(exports,arguments)
},{"dup":589,"pict-provider":845}],877:[function(require,module,exports){
arguments[4][590][0].apply(exports,arguments)
},{"dup":590,"pict-provider":845}],878:[function(require,module,exports){
arguments[4][591][0].apply(exports,arguments)
},{"dup":591,"pict-provider":845}],879:[function(require,module,exports){
arguments[4][592][0].apply(exports,arguments)
},{"dup":592,"pict-provider":845}],880:[function(require,module,exports){
arguments[4][593][0].apply(exports,arguments)
},{"dup":593,"pict-provider":845}],881:[function(require,module,exports){
arguments[4][594][0].apply(exports,arguments)
},{"./Pict-Provider-DynamicFormSolverBehaviors.js":876,"./Pict-Provider-ListDistilling.js":887,"./Pict-Provider-MetaLists.js":888,"./inputs/Pict-Provider-Input-AutofillTriggerGroup.js":893,"./inputs/Pict-Provider-Input-Chart.js":895,"./inputs/Pict-Provider-Input-DateTime.js":896,"./inputs/Pict-Provider-Input-EntityBundleRequest.js":899,"./inputs/Pict-Provider-Input-FacetFilter.js":900,"./inputs/Pict-Provider-Input-HTML.js":901,"./inputs/Pict-Provider-Input-Link.js":902,"./inputs/Pict-Provider-Input-Markdown.js":903,"./inputs/Pict-Provider-Input-ObjectEditor.js":904,"./inputs/Pict-Provider-Input-PreciseNumber.js":905,"./inputs/Pict-Provider-Input-Select.js":908,"./inputs/Pict-Provider-Input-TabGroupSelector.js":909,"./inputs/Pict-Provider-Input-TabSectionSelector.js":910,"./inputs/Pict-Provider-Input-TabularTriggerGroup.js":911,"./inputs/Pict-Provider-Input-Templated.js":912,"./inputs/Pict-Provider-Input-TemplatedEntityLookup.js":913,"dup":594,"pict-provider":845}],882:[function(require,module,exports){
arguments[4][595][0].apply(exports,arguments)
},{"dup":595,"pict-provider":845}],883:[function(require,module,exports){
arguments[4][596][0].apply(exports,arguments)
},{"../providers/Pict-Provider-DynamicInput.js":877,"../templates/Pict-Template-ControlFromDynamicManifest.js":926,"../templates/Pict-Template-ControlFromDynamicManifestForHash.js":927,"../templates/Pict-Template-DyanmicView-Value.js":928,"../templates/Pict-Template-DyanmicView-ValueByHash.js":929,"../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js":930,"../templates/Pict-Template-Metatemplate-Input.js":931,"../templates/Pict-Template-Metatemplate-InputWithHashAddress.js":932,"../templates/Pict-Template-Metatemplate-InputWithView.js":933,"../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js":934,"../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js":935,"../templates/Pict-Template-Proxy-PluckJoinUnique.js":936,"../templates/Pict-Template-TabularEditingControls.js":937,"../templates/Pict-Template-TabularRowLabels.js":938,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js":891,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js":892,"dup":596,"pict-provider":845}],884:[function(require,module,exports){
arguments[4][597][0].apply(exports,arguments)
},{"dup":597,"pict-provider":845}],885:[function(require,module,exports){
arguments[4][598][0].apply(exports,arguments)
},{"dup":598,"pict-provider":845}],886:[function(require,module,exports){
arguments[4][599][0].apply(exports,arguments)
},{"dup":599,"pict-provider":845}],887:[function(require,module,exports){
arguments[4][600][0].apply(exports,arguments)
},{"dup":600,"pict-provider":845}],888:[function(require,module,exports){
arguments[4][601][0].apply(exports,arguments)
},{"dup":601,"pict-provider":845}],889:[function(require,module,exports){
arguments[4][602][0].apply(exports,arguments)
},{"../views/Pict-View-DynamicForm.js":940,"dup":602,"pict-provider":845}],890:[function(require,module,exports){
arguments[4][603][0].apply(exports,arguments)
},{"dup":603,"pict-provider":845}],891:[function(require,module,exports){
arguments[4][604][0].apply(exports,arguments)
},{"dup":604}],892:[function(require,module,exports){
arguments[4][605][0].apply(exports,arguments)
},{"dup":605}],893:[function(require,module,exports){
arguments[4][606][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":606}],894:[function(require,module,exports){
arguments[4][607][0].apply(exports,arguments)
},{"dup":607}],895:[function(require,module,exports){
arguments[4][608][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"./Pict-Provider-Input-Chart-CSS.js":894,"dup":608}],896:[function(require,module,exports){
arguments[4][609][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":609}],897:[function(require,module,exports){
arguments[4][610][0].apply(exports,arguments)
},{"dup":610}],898:[function(require,module,exports){
arguments[4][611][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"./Pict-Provider-Input-Diagram-CSS.js":897,"./util/Themeify-SVG.js":914,"dup":611,"pict-section-excalidraw":857}],899:[function(require,module,exports){
arguments[4][612][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":612}],900:[function(require,module,exports){
arguments[4][613][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":613}],901:[function(require,module,exports){
arguments[4][614][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":614}],902:[function(require,module,exports){
arguments[4][615][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":615}],903:[function(require,module,exports){
arguments[4][616][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":616,"marked":839}],904:[function(require,module,exports){
arguments[4][617][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":617,"pict-section-objecteditor":957}],905:[function(require,module,exports){
arguments[4][618][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":618}],906:[function(require,module,exports){
arguments[4][619][0].apply(exports,arguments)
},{"dup":619}],907:[function(require,module,exports){
arguments[4][620][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"./Pict-Provider-Input-RichText-CSS.js":906,"dup":620,"marked":839,"pict-section-markdowneditor":872}],908:[function(require,module,exports){
arguments[4][621][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":621}],909:[function(require,module,exports){
arguments[4][622][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":622}],910:[function(require,module,exports){
arguments[4][623][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":623}],911:[function(require,module,exports){
arguments[4][624][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":624}],912:[function(require,module,exports){
arguments[4][625][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":625}],913:[function(require,module,exports){
arguments[4][626][0].apply(exports,arguments)
},{"../Pict-Provider-InputExtension.js":886,"dup":626,"marked":839}],914:[function(require,module,exports){
arguments[4][627][0].apply(exports,arguments)
},{"dup":627}],915:[function(require,module,exports){
arguments[4][628][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"dup":628}],916:[function(require,module,exports){
arguments[4][629][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"dup":629}],917:[function(require,module,exports){
arguments[4][630][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"dup":630}],918:[function(require,module,exports){
arguments[4][631][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"dup":631}],919:[function(require,module,exports){
arguments[4][632][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"dup":632}],920:[function(require,module,exports){
arguments[4][633][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js":921,"dup":633}],921:[function(require,module,exports){
arguments[4][634][0].apply(exports,arguments)
},{"dup":634,"pict-section-tuigrid":1041}],922:[function(require,module,exports){
arguments[4][635][0].apply(exports,arguments)
},{"../Pict-Provider-DynamicLayout.js":879,"dup":635}],923:[function(require,module,exports){
arguments[4][636][0].apply(exports,arguments)
},{"dup":636,"fable-serviceproviderbase":838}],924:[function(require,module,exports){
arguments[4][637][0].apply(exports,arguments)
},{"dup":637,"fable-serviceproviderbase":838}],925:[function(require,module,exports){
arguments[4][638][0].apply(exports,arguments)
},{"../providers/Pict-Provider-DynamicInput.js":877,"../providers/Pict-Provider-DynamicInputEvents.js":878,"../providers/Pict-Provider-DynamicRecordSet.js":880,"../providers/Pict-Provider-DynamicSolver.js":881,"../providers/Pict-Provider-DynamicTabularData.js":882,"../providers/Pict-Provider-DynamicTemplates.js":883,"../providers/Pict-Provider-Informary.js":885,"../providers/Pict-Provider-MetatemplateGenerator.js":889,"../providers/Pict-Provider-MetatemplateMacros.js":890,"../providers/layouts/Pict-Layout-Chart.js":915,"../providers/layouts/Pict-Layout-Custom.js":916,"../providers/layouts/Pict-Layout-Record.js":917,"../providers/layouts/Pict-Layout-RecordSet.js":918,"../providers/layouts/Pict-Layout-Tabular.js":919,"../providers/layouts/Pict-Layout-TuiGrid.js":920,"../providers/layouts/Pict-Layout-VerticalRecord.js":922,"../services/ManifestFactory.js":924,"dup":638,"fable-serviceproviderbase":838}],926:[function(require,module,exports){
arguments[4][639][0].apply(exports,arguments)
},{"dup":639,"pict-template":1051}],927:[function(require,module,exports){
arguments[4][640][0].apply(exports,arguments)
},{"dup":640,"pict-template":1051}],928:[function(require,module,exports){
arguments[4][641][0].apply(exports,arguments)
},{"dup":641,"pict-template":1051}],929:[function(require,module,exports){
arguments[4][642][0].apply(exports,arguments)
},{"dup":642,"pict-template":1051}],930:[function(require,module,exports){
arguments[4][643][0].apply(exports,arguments)
},{"dup":643,"pict-template":1051}],931:[function(require,module,exports){
arguments[4][644][0].apply(exports,arguments)
},{"dup":644,"pict-template":1051}],932:[function(require,module,exports){
arguments[4][645][0].apply(exports,arguments)
},{"dup":645,"pict-template":1051}],933:[function(require,module,exports){
arguments[4][646][0].apply(exports,arguments)
},{"dup":646,"pict-template":1051}],934:[function(require,module,exports){
arguments[4][647][0].apply(exports,arguments)
},{"dup":647,"pict-template":1051}],935:[function(require,module,exports){
arguments[4][648][0].apply(exports,arguments)
},{"dup":648,"pict-template":1051}],936:[function(require,module,exports){
arguments[4][649][0].apply(exports,arguments)
},{"dup":649,"pict-template":1051}],937:[function(require,module,exports){
arguments[4][650][0].apply(exports,arguments)
},{"dup":650,"pict-template":1051}],938:[function(require,module,exports){
arguments[4][651][0].apply(exports,arguments)
},{"dup":651,"pict-template":1051}],939:[function(require,module,exports){
arguments[4][652][0].apply(exports,arguments)
},{"dup":652}],940:[function(require,module,exports){
arguments[4][653][0].apply(exports,arguments)
},{"../../package.json":873,"./Pict-View-DynamicForm-DefaultConfiguration.json":939,"dup":653,"pict-view":1053}],941:[function(require,module,exports){
arguments[4][654][0].apply(exports,arguments)
},{"../services/Pict-Service-DynamicFormDependencyManager.js":925,"./Pict-View-DynamicForm.js":940,"./support/Pict-View-PSF-AppData-Visualization.js":943,"./support/Pict-View-PSF-DebugViewer.js":944,"./support/Pict-View-PSF-LifeCycle-Visualization.js":945,"./support/Pict-View-PSF-Solver-Visualization.js":946,"./support/Pict-View-PSF-SpecificSolve-Visualization.js":947,"dup":654,"pict-view":1053}],942:[function(require,module,exports){
arguments[4][655][0].apply(exports,arguments)
},{"dup":655,"pict-provider":845}],943:[function(require,module,exports){
arguments[4][656][0].apply(exports,arguments)
},{"./Pict-View-PSF-SupportBase.js":948,"dup":656}],944:[function(require,module,exports){
arguments[4][657][0].apply(exports,arguments)
},{"./Pict-View-PSF-SupportBase.js":948,"dup":657}],945:[function(require,module,exports){
arguments[4][658][0].apply(exports,arguments)
},{"./Pict-View-PSF-SupportBase.js":948,"dup":658}],946:[function(require,module,exports){
arguments[4][659][0].apply(exports,arguments)
},{"./Pict-View-PSF-SupportBase.js":948,"dup":659}],947:[function(require,module,exports){
arguments[4][660][0].apply(exports,arguments)
},{"./Pict-View-PSF-SupportBase.js":948,"dup":660}],948:[function(require,module,exports){
arguments[4][661][0].apply(exports,arguments)
},{"./Pict-Provider-PSF-Support.js":942,"dup":661,"pict-view":1053}],949:[function(require,module,exports){
/**
 * Pict-MDE-CodeMirror: Helper module for PictSectionMarkdownEditor
 *
 * Handles CodeMirror editor instance creation, extension configuration,
 * keyboard shortcuts, paste handling, and the data URI collapse extension.
 */

/**
 * Attach CodeMirror editor creation methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Create a CodeMirror editor instance inside a container element.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to mount the editor in
	 * @param {number} pSegmentIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	pView._createEditorInContainer = function _createEditorInContainer(pContainer, pSegmentIndex, pContent)
	{
		let tmpCM = pView._codeMirrorModules;

		// Build the extensions array
		let tmpExtensions = [];

		// Keyboard shortcuts for formatting, inter-segment navigation, and image paste handling
		// IMPORTANT: Must be added BEFORE consumer extensions (e.g. basicSetup) so that
		// our domEventHandlers fire before CM6's internal keymap handlers.
		tmpExtensions.push(
			tmpCM.EditorView.domEventHandlers(
			{
				keydown: (pEvent, pEditorView) =>
				{
					// Ctrl/Cmd + B = bold
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'b')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'bold');
						return true;
					}
					// Ctrl/Cmd + I = italic
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'i')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'italic');
						return true;
					}
					// Ctrl/Cmd + E = inline code
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'e')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'code');
						return true;
					}

				},
				paste: (pEvent, pEditorView) =>
				{
					// Check clipboard for image data
					let tmpItems = pEvent.clipboardData && pEvent.clipboardData.items;
					if (!tmpItems)
					{
						return false;
					}
					for (let i = 0; i < tmpItems.length; i++)
					{
						if (tmpItems[i].type.startsWith('image/'))
						{
							pEvent.preventDefault();
							let tmpFile = tmpItems[i].getAsFile();
							if (tmpFile)
							{
								pView._processImageFile(tmpFile, pSegmentIndex);
							}
							return true;
						}
					}
					return false;
				},
				drop: (pEvent, pEditorView) =>
				{
					// Intercept image file drops at the CodeMirror level to prevent
					// the browser from inserting the image as a raw DOM element.
					// Without this, both CodeMirror's default drop behavior AND the
					// container-level handler fire, causing rendering artifacts.
					if (pView._dragSourceIndex >= 0)
					{
						return false; // segment-reorder drag, not a file drop
					}
					if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
					{
						return false;
					}
					let tmpFile = pEvent.dataTransfer.files[0];
					if (tmpFile.type && tmpFile.type.startsWith('image/'))
					{
						pEvent.preventDefault();
						pEvent.stopPropagation();
						pView._processImageFile(tmpFile, pSegmentIndex);
						// Clean up the dragover visual indicator on the container
						let tmpContainer = pEditorView.dom.closest('.pict-mde-segment-editor');
						if (tmpContainer)
						{
							tmpContainer.classList.remove('pict-mde-image-dragover');
						}
						return true;
					}
					return false;
				}
			})
		);

		// Add consumer-provided extensions (e.g. basicSetup, markdown())
		if (tmpCM.extensions && Array.isArray(tmpCM.extensions))
		{
			tmpExtensions = tmpExtensions.concat(tmpCM.extensions);
		}

		// Wrap long lines instead of scrolling horizontally. Markdown is prose, and
		// a horizontally-scrolling editor in a narrow pane is unusable. On by
		// default; a consumer can disable it with LineWrapping: false.
		if (pView.options.LineWrapping !== false)
		{
			tmpExtensions.push(tmpCM.EditorView.lineWrapping);
		}

		// Update listener for content changes, focus, and cursor tracking
		tmpExtensions.push(
			tmpCM.EditorView.updateListener.of((pUpdate) =>
			{
				if (pUpdate.docChanged)
				{
					pView._onSegmentContentChange(pSegmentIndex, pUpdate.state.doc.toString());
				}

				// Track focus changes to toggle the active class
				if (pUpdate.focusChanged)
				{
					if (pUpdate.view.hasFocus)
					{
						pView._setActiveSegment(pSegmentIndex);
						// Position sidebar at cursor on focus
						pView._updateSidebarPosition(pSegmentIndex);
					}
					else
					{
						// Small delay so clicking a sidebar button doesn't immediately deactivate
						setTimeout(() =>
						{
							if (pView._activeSegmentIndex === pSegmentIndex)
							{
								// Check if focus moved to another segment or truly left
								let tmpSegEl = pView._resolveInstanceElement(`PictMDE-Segment-${pSegmentIndex}`);
								if (tmpSegEl && !tmpSegEl.contains(document.activeElement))
								{
									pView._clearActiveSegment(pSegmentIndex);
									pView._resetSidebarPosition(pSegmentIndex);
								}
							}
						}, 100);
					}
				}

				// Track cursor/selection changes to move the sidebar
				if (pUpdate.selectionSet && pUpdate.view.hasFocus)
				{
					pView._updateSidebarPosition(pSegmentIndex);
				}
			})
		);

		// Collapse long data URIs in image markdown so the editor is readable
		let tmpCollapseExtension = pView._buildDataURICollapseExtension();
		if (tmpCollapseExtension)
		{
			tmpExtensions.push(tmpCollapseExtension);
		}

		// Make read-only if configured
		if (pView.options.ReadOnly)
		{
			tmpExtensions.push(tmpCM.EditorState.readOnly.of(true));
			tmpExtensions.push(tmpCM.EditorView.editable.of(false));
		}

		// Allow consumer to customize extensions
		tmpExtensions = pView.customConfigureExtensions(tmpExtensions, pSegmentIndex);

		let tmpState = tmpCM.EditorState.create(
		{
			doc: pContent || '',
			extensions: tmpExtensions
		});

		let tmpEditorView = new tmpCM.EditorView(
		{
			state: tmpState,
			parent: pContainer
		});

		pView._segmentEditors[pSegmentIndex] = tmpEditorView;

		// -- Inter-segment arrow-key navigation --
		// Use a capture-phase DOM listener so we intercept ArrowDown/ArrowUp
		// BEFORE CodeMirror's internal keymap handlers process them.
		tmpEditorView.contentDOM.addEventListener('keydown', function (pEvent)
		{
			if (pEvent.key !== 'ArrowDown' && pEvent.key !== 'ArrowUp')
			{
				return;
			}
			// Don't interfere if a modifier key is held (selection, etc.)
			if (pEvent.shiftKey || pEvent.ctrlKey || pEvent.metaKey || pEvent.altKey)
			{
				return;
			}

			let tmpState = tmpEditorView.state;
			let tmpCursorPos = tmpState.selection.main.head;
			let tmpLine = tmpState.doc.lineAt(tmpCursorPos);
			let tmpColumnOffset = tmpCursorPos - tmpLine.from;

			if (pEvent.key === 'ArrowDown')
			{
				// Only navigate when cursor is on the very last line
				if (tmpLine.to < tmpState.doc.length)
				{
					return; // not on last line — let CM handle it
				}

				// Find next segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpOrderedIndices.length - 1)
				{
					return; // last segment — nowhere to go
				}

				let tmpNextInternalIndex = tmpOrderedIndices[tmpLogicalIndex + 1];
				let tmpNextEditor = pView._segmentEditors[tmpNextInternalIndex];
				if (!tmpNextEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the next editor and place cursor on the first line
				let tmpFirstLine = tmpNextEditor.state.doc.line(1);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpFirstLine.to - tmpFirstLine.from);
				tmpNextEditor.focus();
				tmpNextEditor.dispatch({ selection: { anchor: tmpFirstLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpNextInternalIndex);
			}
			else if (pEvent.key === 'ArrowUp')
			{
				// Only navigate when cursor is on the very first line
				if (tmpLine.number > 1)
				{
					return; // not on first line — let CM handle it
				}

				// Find previous segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex <= 0)
				{
					return; // first segment — nowhere to go
				}

				let tmpPrevInternalIndex = tmpOrderedIndices[tmpLogicalIndex - 1];
				let tmpPrevEditor = pView._segmentEditors[tmpPrevInternalIndex];
				if (!tmpPrevEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the previous editor and place cursor on the last line
				let tmpLastLine = tmpPrevEditor.state.doc.line(tmpPrevEditor.state.doc.lines);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpLastLine.to - tmpLastLine.from);
				tmpPrevEditor.focus();
				tmpPrevEditor.dispatch({ selection: { anchor: tmpLastLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpPrevInternalIndex);
			}
		}, true); // <-- capture phase

		// -- Capture-phase drop listener for image files --
		// Safari processes native contenteditable drops before CodeMirror's
		// bubble-phase domEventHandlers fire, which can insert a raw <img>
		// element into the editor DOM.  A capture-phase listener fires first
		// and lets us preventDefault() before the browser acts.
		tmpEditorView.contentDOM.addEventListener('drop', function (pEvent)
		{
			if (pView._dragSourceIndex >= 0)
			{
				return; // segment-reorder drag
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}
			let tmpFile = pEvent.dataTransfer.files[0];
			if (tmpFile.type && tmpFile.type.startsWith('image/'))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
				// Clean up the dragover visual indicator
				let tmpEditorEl = pView._resolveInstanceElement(`PictMDE-SegmentEditor-${pSegmentIndex}`);
				if (tmpEditorEl)
				{
					tmpEditorEl.classList.remove('pict-mde-image-dragover');
				}
			}
		}, true); // <-- capture phase
	};

	/**
	 * Build a CodeMirror extension that visually collapses long data URIs
	 * inside markdown image syntax.
	 *
	 * The extension uses Decoration.replace() to hide the long base64 portion
	 * and show a compact widget instead, e.g. "data:image/jpeg;base64...28KB".
	 * The actual document content is unchanged -- only the visual display
	 * is affected.
	 *
	 * Returns null if the required CodeMirror modules (Decoration, ViewPlugin,
	 * WidgetType) are not available.
	 *
	 * @returns {object|null} A CodeMirror ViewPlugin extension, or null
	 */
	pView._buildDataURICollapseExtension = function _buildDataURICollapseExtension()
	{
		let tmpCM = pView._codeMirrorModules;

		// All three classes are required -- degrade gracefully if not available
		if (!tmpCM || !tmpCM.Decoration || !tmpCM.ViewPlugin || !tmpCM.WidgetType)
		{
			return null;
		}

		let tmpDecoration = tmpCM.Decoration;
		let tmpViewPlugin = tmpCM.ViewPlugin;
		let tmpWidgetType = tmpCM.WidgetType;

		// Minimum data URI length before collapsing (short URIs are left alone)
		let tmpMinLength = 200;

		// Widget class: renders the collapsed placeholder inline
		class DataURIWidget extends tmpWidgetType
		{
			constructor(pLabel)
			{
				super();
				this.label = pLabel;
			}

			toDOM()
			{
				let tmpSpan = document.createElement('span');
				tmpSpan.className = 'pict-mde-data-uri-collapsed';
				tmpSpan.textContent = this.label;
				tmpSpan.title = 'Data URI (click to expand in image preview below)';
				return tmpSpan;
			}

			eq(pOther)
			{
				return this.label === pOther.label;
			}
		}

		/**
		 * Scan the visible ranges of the document for data URIs inside image
		 * markdown and build a DecorationSet that replaces the long portion.
		 *
		 * Pattern:  ![alt](data:image/TYPE;base64,LONGSTRING)
		 *
		 * We keep "![alt](data:image/TYPE;base64," visible and replace only the
		 * long base64 payload plus the closing ")" with a compact widget.
		 */
		function buildDecorations(pEditorView)
		{
			let tmpDecorations = [];
			let tmpDoc = pEditorView.state.doc;

			for (let tmpVisRange of pEditorView.visibleRanges)
			{
				let tmpFrom = tmpVisRange.from;
				let tmpTo = tmpVisRange.to;
				let tmpText = tmpDoc.sliceString(tmpFrom, tmpTo);

				// Match: ![...](data:image/...;base64,...) -- we need positions of the base64 payload
				let tmpRegex = /!\[[^\]]*\]\(data:([^;]+);base64,/g;
				let tmpMatch;

				while ((tmpMatch = tmpRegex.exec(tmpText)) !== null)
				{
					// tmpMatch[0] is "![alt](data:image/png;base64,"
					// tmpMatch[1] is the MIME subtype, e.g. "image/png"
					let tmpPayloadStart = tmpFrom + tmpMatch.index + tmpMatch[0].length;

					// Find the closing parenthesis -- scan forward from payloadStart
					let tmpPayloadEnd = -1;
					let tmpSearchFrom = tmpPayloadStart;
					let tmpDocLength = tmpDoc.length;

					// Scan character by character in the document for the closing ')'
					// We need to handle this carefully since the payload could be huge
					// and span beyond the visible range.
					// Search up to 5MB worth of characters (way more than any realistic image).
					let tmpMaxScan = Math.min(tmpDocLength, tmpSearchFrom + 5 * 1024 * 1024);
					let tmpChunkSize = 4096;

					for (let tmpPos = tmpSearchFrom; tmpPos < tmpMaxScan; tmpPos += tmpChunkSize)
					{
						let tmpEnd = Math.min(tmpPos + tmpChunkSize, tmpMaxScan);
						let tmpChunk = tmpDoc.sliceString(tmpPos, tmpEnd);
						let tmpParenIdx = tmpChunk.indexOf(')');
						if (tmpParenIdx >= 0)
						{
							tmpPayloadEnd = tmpPos + tmpParenIdx;
							break;
						}
					}

					if (tmpPayloadEnd < 0)
					{
						// No closing paren found -- skip this match
						continue;
					}

					// Calculate the payload length (base64 data between comma and closing paren)
					let tmpPayloadLength = tmpPayloadEnd - tmpPayloadStart;

					if (tmpPayloadLength < tmpMinLength)
					{
						// Too short to bother collapsing
						continue;
					}

					// Build a human-readable size label
					let tmpSizeBytes = Math.round(tmpPayloadLength * 0.75); // base64 to bytes approx
					let tmpSizeLabel;
					if (tmpSizeBytes >= 1024 * 1024)
					{
						tmpSizeLabel = (tmpSizeBytes / (1024 * 1024)).toFixed(1) + 'MB';
					}
					else if (tmpSizeBytes >= 1024)
					{
						tmpSizeLabel = Math.round(tmpSizeBytes / 1024) + 'KB';
					}
					else
					{
						tmpSizeLabel = tmpSizeBytes + 'B';
					}

					let tmpMimeType = tmpMatch[1] || 'image';
					let tmpWidgetLabel = `\u2026${tmpSizeLabel})`;

					// Replace from the start of the base64 payload to after the closing paren
					let tmpWidget = tmpDecoration.replace(
					{
						widget: new DataURIWidget(tmpWidgetLabel)
					});

					tmpDecorations.push(tmpWidget.range(tmpPayloadStart, tmpPayloadEnd + 1));
				}
			}

			return tmpDecoration.set(tmpDecorations, true);
		}

		// Create the ViewPlugin
		let tmpPlugin = tmpViewPlugin.fromClass(
			class
			{
				constructor(pEditorView)
				{
					this.decorations = buildDecorations(pEditorView);
				}

				update(pUpdate)
				{
					if (pUpdate.docChanged || pUpdate.viewportChanged)
					{
						this.decorations = buildDecorations(pUpdate.view);
					}
				}
			},
			{
				decorations: (pPlugin) => pPlugin.decorations
			}
		);

		return tmpPlugin;
	};
};

},{}],950:[function(require,module,exports){
arguments[4][675][0].apply(exports,arguments)
},{"dup":675}],951:[function(require,module,exports){
arguments[4][676][0].apply(exports,arguments)
},{"dup":676}],952:[function(require,module,exports){
/**
 * Pict-MDE-ImageHandling: Helper module for PictSectionMarkdownEditor
 *
 * Handles image operations: file picker, file processing (hook or base64
 * fallback), markdown insertion, preview thumbnail rendering, and
 * drag-and-drop for image files onto the editor.
 */

/**
 * Attach image handling methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Open a file picker to select an image for insertion into a segment.
	 * Called by the sidebar image button onclick handler.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView.openImagePicker = function openImagePicker(pSegmentIndex)
	{
		let tmpFileInput = pView._resolveInstanceElement(`PictMDE-ImageInput-${pSegmentIndex}`);
		if (!tmpFileInput)
		{
			pView.log.warn(`PICT-MarkdownEditor openImagePicker: file input not found for segment ${pSegmentIndex}.`);
			return;
		}

		// Wire the change handler fresh each time (in case it was already used)
		tmpFileInput.onchange = () =>
		{
			if (tmpFileInput.files && tmpFileInput.files.length > 0)
			{
				pView._processImageFile(tmpFileInput.files[0], pSegmentIndex);
			}
			// Reset the input so the same file can be re-selected
			tmpFileInput.value = '';
		};

		tmpFileInput.click();
	};

	/**
	 * Process an image File object from any input method (picker, drag, paste).
	 *
	 * If the consumer has overridden onImageUpload and it returns true, the
	 * consumer handles the upload and calls the callback with a URL.
	 * Otherwise, the image is converted to a base64 data URI inline.
	 *
	 * @param {File} pFile - The image File object
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._processImageFile = function _processImageFile(pFile, pSegmentIndex)
	{
		if (!pFile || !pFile.type || !pFile.type.startsWith('image/'))
		{
			pView.log.warn(`PICT-MarkdownEditor _processImageFile: not an image file (type: ${pFile ? pFile.type : 'null'}).`);
			return;
		}

		let tmpAltText = pFile.name ? pFile.name.replace(/\.[^.]+$/, '') : 'image';

		// Check if the consumer wants to handle the upload
		let tmpCallback = (pError, pURL) =>
		{
			if (pError)
			{
				pView.log.error(`PICT-MarkdownEditor image upload error: ${pError}`);
				return;
			}
			if (pURL)
			{
				pView._insertImageMarkdown(pSegmentIndex, pURL, tmpAltText);
			}
		};

		let tmpHandled = pView.onImageUpload(pFile, pSegmentIndex, tmpCallback);

		if (tmpHandled)
		{
			// Consumer is handling the upload asynchronously
			return;
		}

		// Default: convert to base64 data URI
		if (typeof (FileReader) === 'undefined')
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader not available in this environment.`);
			return;
		}

		let tmpReader = new FileReader();
		tmpReader.onload = () =>
		{
			pView._insertImageMarkdown(pSegmentIndex, tmpReader.result, tmpAltText);
		};
		tmpReader.onerror = () =>
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader error.`);
		};
		tmpReader.readAsDataURL(pFile);
	};

	/**
	 * Insert markdown image syntax at the cursor position in a segment editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The image URL (data URI or remote URL)
	 * @param {string} [pAltText] - The alt text (default: 'image')
	 */
	pView._insertImageMarkdown = function _insertImageMarkdown(pSegmentIndex, pURL, pAltText)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertImageMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpAlt = pAltText || 'image';
		let tmpInsert = `![${tmpAlt}](${pURL})`;

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});

		tmpEditor.focus();

		// Update the image preview area for this segment
		pView._updateImagePreviews(pSegmentIndex);
	};

	/**
	 * Scan the content of a segment for markdown image references and render
	 * preview thumbnails in the preview area below the editor.
	 *
	 * Matches the pattern ![alt](url) and creates <img> elements for each.
	 * The preview area is hidden when there are no images.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateImagePreviews = function _updateImagePreviews(pSegmentIndex)
	{
		let tmpPreviewEl = pView._resolveInstanceElement(`PictMDE-ImagePreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		// Match markdown image syntax: ![alt text](url)
		let tmpImageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
		let tmpMatches = [];
		let tmpMatch;
		while ((tmpMatch = tmpImageRegex.exec(tmpContent)) !== null)
		{
			tmpMatches.push(
			{
				alt: tmpMatch[1] || 'image',
				url: tmpMatch[2]
			});
		}

		if (tmpMatches.length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		// Build preview HTML
		let tmpHTML = '';
		for (let i = 0; i < tmpMatches.length; i++)
		{
			let tmpAlt = tmpMatches[i].alt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			let tmpResolvedURL = pView._resolveImageURL(tmpMatches[i].url);
			let tmpURL = tmpResolvedURL.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
			tmpHTML += `<div class="pict-mde-image-preview-item"><img src="${tmpURL}" alt="${tmpAlt}" /><span class="pict-mde-image-preview-label">${tmpAlt}</span></div>`;
		}

		tmpPreviewEl.innerHTML = tmpHTML;
		tmpPreviewEl.classList.add('pict-mde-has-images');
	};

	/**
	 * Wire drag-and-drop events for image files on a segment editor container.
	 *
	 * These events are separate from the segment-reorder drag events.
	 * File drags are distinguished from segment reorder drags by checking
	 * dataTransfer.types for 'Files' and ensuring _dragSourceIndex is -1.
	 *
	 * @param {HTMLElement} pEditorContainer - The .pict-mde-segment-editor element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireImageDragEvents = function _wireImageDragEvents(pEditorContainer, pSegmentIndex)
	{
		pEditorContainer.addEventListener('dragover', (pEvent) =>
		{
			// Only handle file drags, not segment-reorder drags
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.types || pEvent.dataTransfer.types.indexOf('Files') < 0)
			{
				return;
			}
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'copy';
			pEditorContainer.classList.add('pict-mde-image-dragover');
		});

		pEditorContainer.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if actually leaving the element
			if (!pEditorContainer.contains(pEvent.relatedTarget))
			{
				pEditorContainer.classList.remove('pict-mde-image-dragover');
			}
		});

		pEditorContainer.addEventListener('drop', (pEvent) =>
		{
			pEditorContainer.classList.remove('pict-mde-image-dragover');

			// Only handle file drops, not segment-reorder drops
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}

			let tmpFile = pEvent.dataTransfer.files[0];
			if (tmpFile.type && tmpFile.type.startsWith('image/'))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
			}
		});
	};
};

},{}],953:[function(require,module,exports){
arguments[4][678][0].apply(exports,arguments)
},{"dup":678,"pict-provider-theme/source/Theme-Diagram-Adapter.js":843,"pict-section-content":852}],954:[function(require,module,exports){
arguments[4][679][0].apply(exports,arguments)
},{"dup":679}],955:[function(require,module,exports){
arguments[4][680][0].apply(exports,arguments)
},{"./Pict-MDE-CodeMirror.js":949,"./Pict-MDE-DragAndReorder.js":950,"./Pict-MDE-Formatting.js":951,"./Pict-MDE-ImageHandling.js":952,"./Pict-MDE-RichPreview.js":953,"./Pict-Section-MarkdownEditor-DefaultConfiguration.js":954,"dup":680,"pict-section-content":852,"pict-view":1053}],956:[function(require,module,exports){
arguments[4][697][0].apply(exports,arguments)
},{"dup":697}],957:[function(require,module,exports){
arguments[4][698][0].apply(exports,arguments)
},{"./Pict-Section-ObjectEditor-DefaultConfiguration.js":956,"./views/PictView-ObjectEditor-Node.js":958,"./views/PictView-ObjectEditor-NodeArray.js":959,"./views/PictView-ObjectEditor-NodeBoolean.js":960,"./views/PictView-ObjectEditor-NodeNull.js":961,"./views/PictView-ObjectEditor-NodeNumber.js":962,"./views/PictView-ObjectEditor-NodeObject.js":963,"./views/PictView-ObjectEditor-NodeString.js":964,"./views/PictView-ObjectEditor.js":965,"dup":698}],958:[function(require,module,exports){
arguments[4][699][0].apply(exports,arguments)
},{"dup":699,"pict-view":1053}],959:[function(require,module,exports){
arguments[4][700][0].apply(exports,arguments)
},{"./PictView-ObjectEditor-Node.js":958,"dup":700}],960:[function(require,module,exports){
arguments[4][701][0].apply(exports,arguments)
},{"./PictView-ObjectEditor-Node.js":958,"dup":701}],961:[function(require,module,exports){
arguments[4][702][0].apply(exports,arguments)
},{"./PictView-ObjectEditor-Node.js":958,"dup":702}],962:[function(require,module,exports){
arguments[4][703][0].apply(exports,arguments)
},{"./PictView-ObjectEditor-Node.js":958,"dup":703}],963:[function(require,module,exports){
arguments[4][704][0].apply(exports,arguments)
},{"./PictView-ObjectEditor-Node.js":958,"dup":704}],964:[function(require,module,exports){
arguments[4][705][0].apply(exports,arguments)
},{"./PictView-ObjectEditor-Node.js":958,"dup":705}],965:[function(require,module,exports){
arguments[4][706][0].apply(exports,arguments)
},{"../Pict-Section-ObjectEditor-DefaultConfiguration.js":956,"./PictView-ObjectEditor-NodeArray.js":959,"./PictView-ObjectEditor-NodeBoolean.js":960,"./PictView-ObjectEditor-NodeNull.js":961,"./PictView-ObjectEditor-NodeNumber.js":962,"./PictView-ObjectEditor-NodeObject.js":963,"./PictView-ObjectEditor-NodeString.js":964,"dup":706,"pict-view":1053}],966:[function(require,module,exports){
// The container for all the Pict-Section-Form related code.

// The main dynamic view class
module.exports = require('./services/RecordsSet-MetaController.js');
//module.exports.default_configuration = require('./views/Pict-View-DynamicForm-DefaultConfiguration.json');

// The application container
module.exports.PictRecordSetApplication = require('./application/Pict-Application-RecordSet.js');

// Export the providers
module.exports.RecordSetProviderBase = require('./providers/RecordSet-RecordProvider-Base.js');
module.exports.RecordSetProviderMeadowEndpoints = require('./providers/RecordSet-RecordProvider-MeadowEndpoints.js');
module.exports.ColumnDataProvider = require('./providers/Column-Data-Provider.js');
module.exports.AssociationManager = require('./providers/RecordSet-AssociationManager.js');
module.exports.DependentManager = require('./providers/RecordSet-DependentManager.js');
module.exports.CardManager = require('./providers/RecordSet-CardManager.js');

// Joined-entity association views (embeddable read-tab editor + bulk associate screen)
module.exports.AssociationEditorView = require('./views/associate/RecordSet-AssociationEditor.js');
module.exports.AssociateBulkView = require('./views/associate/RecordSet-AssociateBulk.js');
module.exports.AssociateMatrixView = require('./views/associate/RecordSet-AssociateMatrix.js');
module.exports.AssociateUnlinkView = require('./views/associate/RecordSet-AssociateUnlink.js');

// Bulk delete screen (batch delete, with optional advanced reassociation of relationships)
module.exports.BulkDeleteView = require('./views/delete/RecordSet-BulkDelete.js');

},{"./application/Pict-Application-RecordSet.js":967,"./providers/Column-Data-Provider.js":968,"./providers/RecordSet-AssociationManager.js":970,"./providers/RecordSet-CardManager.js":971,"./providers/RecordSet-DependentManager.js":972,"./providers/RecordSet-RecordProvider-Base.js":975,"./providers/RecordSet-RecordProvider-MeadowEndpoints.js":976,"./services/RecordsSet-MetaController.js":978,"./views/associate/RecordSet-AssociateBulk.js":985,"./views/associate/RecordSet-AssociateMatrix.js":986,"./views/associate/RecordSet-AssociateUnlink.js":987,"./views/associate/RecordSet-AssociationEditor.js":988,"./views/delete/RecordSet-BulkDelete.js":998}],967:[function(require,module,exports){
const libPictApplication = require('pict-application');
const libPictSectionForm = require('pict-section-form');

const libPictSectionRecordSet = require('../Pict-Section-RecordSet.js');
const libDynamicSolver = require('../providers/RecordSet-DynamicRecordsetSolver.js');
const libFilterDataProvider = require('../providers/Filter-Data-Provider.js');
const libFilterPersistenceView = require('../views/Filter-PersistenceView.js');
const libPictDynamicFormDependencyManager = require('pict-section-form').PictDynamicFormDependencyManager;

/**
 * Represents a PictSectionRecordSetApplication.
 *
 * This is the automagic controller for a dynamic record set application.
 *
 * @class
 * @extends libPictApplication
 */
class PictSectionRecordSetApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & import('fable')} */
		this.pict;
		// Add the pict recordset meta controller service
		this.pict.addServiceType('PictSectionRecordSet', libPictSectionRecordSet);
		//FIXME: this is probably wrong, but needed for now?
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);

		this.pict.addView('PictFormMetacontroller', {}, libPictSectionForm.PictFormMetacontroller);

		this.fable.addProviderSingleton('DynamicRecordsetSolver', libDynamicSolver.default_configuration, libDynamicSolver);

		// for filter data/persistence management
		this.fable.addProviderSingleton('FilterDataProvider', libFilterDataProvider.default_configuration, libFilterDataProvider);
		this.pict.addView('FilterPersistenceView', libFilterPersistenceView.default_configuration, libFilterPersistenceView);

		// add the dependencies for dynamic controls
		this.fable.addAndInstantiateSingletonService('PictDynamicFormDependencyManager', libPictDynamicFormDependencyManager.default_configuration, libPictDynamicFormDependencyManager);
	}

	onInitialize()
	{
		// Add the PictSectionRecordSet service
		this.pict.instantiateServiceProvider('PictSectionRecordSet', this.options);
		// Initialize the views for the foundation metacontroller service
		this.pict.PictSectionRecordSet.initialize();

		// Initialize the parent class
		return super.onInitialize();
	}

	onAfterInitialize()
	{
		if (this.pict.CSSMap)
		{
			this.pict.CSSMap.injectCSS();
		}
		// Now add the routes
		this.pict.providers.RecordSetRouter.addRoutes(this.fable.providers.RecordSetRouter.pictRouter);

		return super.onAfterInitialize();
	}
};

module.exports = PictSectionRecordSetApplication

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"Name": "A Simple Pict RecordSet Application",
	"Hash": "PictRecordSetApplication",

	//"MainViewportViewIdentifier": "PictRecordSetPrimaryView",

	"pict_configuration":
		{
			"Product": "DefaultPictRecordSetApplication",
		}
});

},{"../Pict-Section-RecordSet.js":966,"../providers/Filter-Data-Provider.js":969,"../providers/RecordSet-DynamicRecordsetSolver.js":973,"../views/Filter-PersistenceView.js":982,"pict-application":842,"pict-section-form":874}],968:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'ColumnDataProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/** Terminology for Column Data Provider (to avoid confusion):
 * A "Record Set" is a collection of records rendered as a list with columns.
 * A "Column Visibility Override" is a per-column user choice (true = show, false = hide)
 *   that overrides the column's default visibility (visible unless DefaultHidden).
 * Columns with no override entry render at their default visibility.

 * Behavior Summary:
 * - Save the per-recordset override map to LocalStorage under a key derived from
 *   Record Set and View Context.
 * - Mirror the override map into pict.Bundle._ActiveColumnState[RecordSet] so reads
 *   are synchronous and consistent within a session (the Meadow record provider reads
 *   this at fetch time to widen Lite projections before the list view composes columns).
 * - Clear both on "Reset to defaults".

 * Storage Key Structure:
 * - Column_Meta_{RecordSet}_{ViewContext} : stores the Column Meta JSON.

 * Object Shape for Column Meta:
 * {
 *   RecordSet: string, (auto-filled on save)
 *   ViewContext: string, (auto-filled on save; 'List' for the list view)
 *   Overrides: { [ColumnKey: string]: boolean },
 *   LastModifiedDate: string (ISO date) (auto-filled on save)
 * }

 * Host override contract:
 * - To persist column choices somewhere other than LocalStorage (e.g. a per-user
 *   server-side preference), register your own provider AS 'ColumnDataProvider'
 *   BEFORE PictSectionRecordSet.initialize() runs — the section only registers this
 *   one when no provider with that hash exists yet. Load remote prefs at app start
 *   and seed them through setColumnVisibilityOverride (or write the Bundle mirror
 *   directly); the read methods here must stay synchronous.
*/

class ColumnDataProvider extends libPictProvider
{
	/**
	 * @param {import('pict')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - The options for the provider
	 * @param {string} [pServiceHash] - The service hash for the provider
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// This allows unit tests to run
		this.storageProvider = this;
		this.keyCache = {};
		if ((typeof(window) === 'object') && (typeof(window.localStorage) === 'object'))
		{
			this.storageProvider = window.localStorage;
		}
	}

	/**
	 * Resolve the LocalStorage key for a record set's column visibility overrides.
	 *
	 * @param {string} pRecordSet - The record set the overrides belong to
	 * @param {string} [pViewContext] - The view context (defaults to 'List')
	 * @return {string} The storage key for the column meta record.
	 */
	getColumnStorageKey(pRecordSet, pViewContext)
	{
		return `Column_Meta_${pRecordSet}_${pViewContext || 'List'}`;
	}

	/**
	 * Get the column visibility override map for a record set.
	 *
	 * Bundle-first: the session mirror in pict.Bundle._ActiveColumnState wins; on a
	 * miss the stored meta is read and seeded into the Bundle so every later read
	 * (including the Meadow provider's fetch-time read) is synchronous and consistent.
	 *
	 * @param {string} pRecordSet - The record set to get overrides for
	 * @param {string} [pViewContext] - The view context (defaults to 'List')
	 * @return {Record<string, boolean>} The override map (empty object when none).
	 */
	getColumnVisibilityOverrides(pRecordSet, pViewContext)
	{
		if (!pRecordSet)
		{
			return {};
		}
		const tmpActiveColumnState = this.pict.Bundle._ActiveColumnState;
		if (tmpActiveColumnState && tmpActiveColumnState[pRecordSet] && tmpActiveColumnState[pRecordSet].Overrides)
		{
			return tmpActiveColumnState[pRecordSet].Overrides;
		}
		/** @type {Record<string, boolean>} */
		let tmpOverrides = {};
		const tmpColumnMetaJSON = this.storageProvider.getItem(this.getColumnStorageKey(pRecordSet, pViewContext));
		if (tmpColumnMetaJSON)
		{
			try
			{
				const tmpColumnMeta = JSON.parse(tmpColumnMetaJSON);
				if (tmpColumnMeta && typeof(tmpColumnMeta.Overrides) === 'object' && tmpColumnMeta.Overrides !== null)
				{
					tmpOverrides = tmpColumnMeta.Overrides;
				}
			}
			catch (pError)
			{
				this.pict.log.warn(`ColumnDataProvider: could not parse stored column meta for [${pRecordSet}]: ${pError.message}`);
			}
		}
		this._seedBundleColumnState(pRecordSet, tmpOverrides);
		return tmpOverrides;
	}

	/**
	 * Set (and persist) a single column visibility override for a record set.
	 *
	 * @param {string} pRecordSet - The record set the column belongs to
	 * @param {string} pViewContext - The view context ('List' for the list view; falsy defaults to 'List')
	 * @param {string} pKey - The column key
	 * @param {boolean} pVisible - Whether the column should be visible
	 * @return {Record<string, boolean>} The updated override map.
	 */
	setColumnVisibilityOverride(pRecordSet, pViewContext, pKey, pVisible)
	{
		const tmpOverrides = this.getColumnVisibilityOverrides(pRecordSet, pViewContext);
		tmpOverrides[pKey] = (pVisible === true);
		this._seedBundleColumnState(pRecordSet, tmpOverrides);
		const tmpColumnMeta =
		{
			RecordSet: pRecordSet,
			ViewContext: pViewContext || 'List',
			Overrides: tmpOverrides,
			LastModifiedDate: new Date().toISOString(),
		};
		this.storageProvider.setItem(this.getColumnStorageKey(pRecordSet, pViewContext), JSON.stringify(tmpColumnMeta));
		return tmpOverrides;
	}

	/**
	 * Clear all column visibility overrides for a record set (Reset to defaults).
	 *
	 * @param {string} pRecordSet - The record set to clear overrides for
	 * @param {string} [pViewContext] - The view context (defaults to 'List')
	 * @return {boolean} True when the overrides have been cleared.
	 */
	clearColumnVisibilityOverrides(pRecordSet, pViewContext)
	{
		this.storageProvider.removeItem(this.getColumnStorageKey(pRecordSet, pViewContext));
		if (this.pict.Bundle._ActiveColumnState && this.pict.Bundle._ActiveColumnState[pRecordSet])
		{
			delete this.pict.Bundle._ActiveColumnState[pRecordSet];
		}
		return true;
	}

	/**
	 * Write the session mirror of a record set's override map into the Bundle.
	 *
	 * @param {string} pRecordSet - The record set the overrides belong to
	 * @param {Record<string, boolean>} pOverrides - The override map to mirror
	 */
	_seedBundleColumnState(pRecordSet, pOverrides)
	{
		if (!this.pict.Bundle._ActiveColumnState)
		{
			this.pict.Bundle._ActiveColumnState = {};
		}
		this.pict.Bundle._ActiveColumnState[pRecordSet] = { Overrides: pOverrides };
	}

	/** ===== SIMPLE KEY-VALUE CACHE ============= */

	/**
	 * @param {string} pKey - The key to get from the cache
	 * @return {any} - The value associated with the key, or null if not found
	 */
	getItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			return this.keyCache[pKey];
		}
		return null;
	}

	/**
	 * @param {string} pKey - The key to set in the cache
	 * @param {any} pValue - The value to associate with the key
	 */
	setItem(pKey, pValue)
	{
		this.keyCache[pKey] = pValue;
		return true;
	}

	/**
	 * @param {string} pKey - The key to remove from the cache
	 * @return {boolean} - True if the item was removed, false if it was not found
	 */
	removeItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			delete this.keyCache[pKey];
			return true;
		}
		return false;
	}
}

module.exports = ColumnDataProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":845}],969:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'FilterDataProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

/** Terminology for Filter Data Provider (to avoid confusion):
 * A "Record Set" is a collection of records that can be filtered.
 * A "Filter Experience" is a saved state of filters for a given record set.
 * A "Filter Experience Hash" is a unique identifier for a Filter Experience (display name converted to a hash).
 * A "Filter Experience Encoded URL Param" is the URL-encoded representation of the filter state for a Filter Experience.
 * A "Filter Display Name" is a user-friendly name for a Filter Experience to select/view in the UI.
 * A "Filter Clauses" is a list of all saved filters in the "Filter Experience" for a given Record Set.
 * A "Filter Meta" is the metadata associated with a Filter Experience, including the Filter Clauses and Filter Display Name.

 * Behavior Summary:
 * - Save Filter Meta to LocalStorage under a key derived from Record Set, View Context, and Filter Experience Hash.
 * - Load Filter Meta from LocalStorage using the same key.
 * - Remove Filter Meta from LocalStorage when requested.
 * - List all Filter Experiences for a given Record Set by scanning LocalStorage keys.
 * - Manage default and last used Filter Experiences for each Record Set and View Context. (last used takes priority over default on load, if the check is enabled)

 * Storage Key Structure:
 * - Filter_Meta_{RecordSet}_{ViewContext}_{FilterExperienceHash} : stores the Filter Meta JSON.

 * Object Shape for Filter Meta (filter experience):
 * {
 *   RecordSet: string, (auto-filled on save)
 *   ViewContext: string, (auto-filled on save)
 *   LastModifiedDate: string (ISO date) (auto-filled on save)
 *   FilterClauses: Array<{ Label: string, ExactMatch: boolean, Value: string }>,
 *   FilterDisplayName: string,
 *   FilterExperienceHash: string, (display name converted to hash)
 *   FilterExperienceEncodedURLParam: string, (URL-encoded filter state)
 
 * Object Shape for Filter Experience Settings:
 * {
 *   ExcludedFromSelection: boolean,
 *   RememberLastUsedFilterExperience: boolean,
 *   LastUsedFilterExperienceHash: string | null,
 *   LastUsedFilterExperienceURLParam: string | null,
 *   DefaultFilterExperienceHash: string | null,
 *   DefaultFilterExperienceURLParam: string | null,
 *   FallbackDefaultExperienceURLParam: string | null,
 * }
*/

// TODO: would nice to convert the comments above to actual types for better clarity and enforcement, but could use help on how to do that.

class FilterDataProvider extends libPictProvider
{
	/**
	 * @param {import('pict')} pFable - The Fable instance
	 * @param {Record<string, any>} [pOptions] - The options for the provider
	 * @param {string} [pServiceHash] - The service hash for the provider
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// This allows unit tests to run
		this.storageProvider = this;
		this.keyCache = {};
		if ((typeof(window) === 'object') && (typeof(window.localStorage) === 'object'))
		{
			this.storageProvider = window.localStorage;
		}
		// use this to track if we have unapplied filter changes
		this.filterExperienceModifiedFromURLHash = false;
	}

	onBeforeInitialize()
	{
		return super.onBeforeInitialize();
	}

	/** ===== UTILITY for Filter Experience ============= */

	/**
	 * Using the information in the FilterClauses, try to generate a contextual default filter name for the display name of the current experience.
	 *
	 * @param {object} pFilterExperience - The filter experience to generate the default filter name for
	 * @param {string} [pRecordSet] - The current record set
	 * @param {string} [pViewContext] - The current view context
	 * @return {string} - The generated default filter name
	 */
	generateContextualDefaultFilterName(pFilterExperience, pRecordSet, pViewContext)
	{	
		// if there is a display name, use that
		if (pFilterExperience && pFilterExperience.FilterDisplayName && pFilterExperience.FilterDisplayName.length > 0)
		{
			return pFilterExperience.FilterDisplayName;
		}
		// otherwise, generate one based on the clauses
		const tmpDisplayClauseLimit = 3;
		const tmpRecordSet = pFilterExperience?.RecordSet || pRecordSet || '';
		const tmpClauses = pFilterExperience?.FilterClauses || this.pict.Bundle._ActiveFilterState[tmpRecordSet]?.FilterClauses || [];
		const displayClauses = tmpClauses.length > tmpDisplayClauseLimit ? tmpClauses.slice(0, tmpDisplayClauseLimit) : tmpClauses;
		if (tmpClauses && tmpClauses.length > 0)
		{
			let tmpStringSuffix = '';
			if (tmpClauses.length > tmpDisplayClauseLimit)
			{
				
				tmpStringSuffix = `... (${tmpClauses.length} total filters)`;
			}
			const clauseSummaries = displayClauses.map((clause) => {
				return `${clause.Label || clause.FilterByColumn}`;
				// TODO: We could provide exact values, but we need to account for all the internal/external entity look ups, plus selection handlers on each filter to update the value entered
				// 		 For now, let's just show the column/label since this is a generated suggestion name and will likely to be edited by the user to something more meaningful before saving, but this is an area we could enhance in the future to make the generated names more descriptive
				//return `${clause.Label || clause.FilterByColumn} ${clause.ExactMatch ? 'IS' : 'CONTAINS'} ${clause.Value || clause?.Values?.join(',') || '(unset)'}`;
			});
			return `${clauseSummaries.join(' AND ')}${ tmpStringSuffix }`;
		}
		// give up, fall back to default name
		return `New ${pRecordSet} ${pViewContext} Filter`;
	}

	/**
	 * Re-render all views affected by a filter change.
	 * @param {object} tmpFilterExperience - The filter meta record that was changed/added.
	 * @param {string} pRecordSet - The record set to check.
	 * @param {string} pViewContext - The current view context
	 */
	navigateToFilterExperienceRoute(tmpFilterExperience, pRecordSet, pViewContext)
	{
		// The search term (the /FilteredTo/ segment) is part of the saved experience — restore
		// it alongside the structured filter clauses.
		const tmpSearchSegment = (tmpFilterExperience && tmpFilterExperience.SearchFilterURLParam) ? `/FilteredTo/${tmpFilterExperience.SearchFilterURLParam}` : '';
		// go to the new url with the search segment + the filter experience encoded param
		if (tmpFilterExperience?.FilterExperienceEncodedURLParam && tmpFilterExperience?.FilterExperienceEncodedURLParam?.length > 0)
		{
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}${tmpSearchSegment}/FilterExperience/${tmpFilterExperience.FilterExperienceEncodedURLParam}`);
		}
		else if (tmpSearchSegment)
		{
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}${tmpSearchSegment}`);
		}
		else
		{
			console.info('No FilterExperienceEncodedURLParam found for the current filter experience; navigating to base record set URL.');
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}`);
		}
	}

	/**
	 * Apply the expected filter experience to load on application load for a given record set and view context. Last Used takes priority over Default. 
	 * This is the main entry point to set the default/latest filter experience on app load for a given record set and view context.
	 * @param {string} pRecordSet - The record set to set the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the default filter experience has been set
	 */
	applyExpectedFilterExperience(pRecordSet, pViewContext)
	{
		const applyLastUsed = this.getRememberLastUsedFilterExperience(pRecordSet, pViewContext);
		const tmpDefaultFilterExperience = this.getDefaultFilterExperience(pRecordSet, pViewContext);
		const tmpFallbackDefaultExperienceURLParam = this.getFallbackDefaultFilterExperienceSettings(pRecordSet, pViewContext);
		if (applyLastUsed)
		{
			// first try to set last used filter experience as default on load
			const tmpLastUsedFilterExperience = this.getLastUsedFilterExperience(pRecordSet, pViewContext);
			if (tmpLastUsedFilterExperience)
			{
				this.pict.log.info(`Applying last used filter experience on load for record set: ${pRecordSet} with view context: ${pViewContext}`);
				// if we are already on the last used filter experience by URL, skip loading it again
				if (this.isCurrentFilterExperience(pRecordSet, pViewContext, tmpLastUsedFilterExperience.FilterExperienceHash))
				{
					return true;
				}
				this.loadFilterMeta(pRecordSet, pViewContext, tmpLastUsedFilterExperience.FilterExperienceHash, true);
				return true;
			}
		} 
		// if no last used filter experience, fall back to default filter experience on load
		else if (tmpDefaultFilterExperience && tmpDefaultFilterExperience.FilterExperienceHash)
		{
			this.pict.log.info(`Applying default filter experience on load for record set: ${pRecordSet} with view context: ${pViewContext}`);
			// if we are already on the default filter experience by URL, skip loading it again
			if (this.isCurrentFilterExperience(pRecordSet, pViewContext, tmpDefaultFilterExperience.FilterExperienceHash))
			{
				return true;
			}
			this.loadFilterMeta(pRecordSet, pViewContext, tmpDefaultFilterExperience.FilterExperienceHash, true);
			return true;
		}
		// finally, check for a fallback default experience URL param to load (could be server/customer provided)
		else if (tmpFallbackDefaultExperienceURLParam && tmpFallbackDefaultExperienceURLParam.length > 0)
		{
			this.pict.log.info(`Applying fallback default filter experience URL param on load for record set: ${pRecordSet} with view context: ${pViewContext}`);
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${pRecordSet}/${pViewContext}/FilterExperience/${tmpFallbackDefaultExperienceURLParam}`);
			return true;
		}
		// no filter experience to apply
		return false;
	}

	/** ===== CRUD Filter Experiences ============= */

	/**
	 * Initialize the filter experience settings for a given record set and view context if they do not already exist.
	 * @param {string} pRecordSet - The record set to initialize the settings for
	 * @param {string} pViewContext - The current view context
	 * @param {object} [pAdditionalSettings] - Additional settings to initialize with (pass through for future use)
	 * @return {string} - The filter experience settings object stringifyed (as if it was just read from storage).
	 */
	initializeFilterExperienceSettings(pRecordSet, pViewContext, pAdditionalSettings)
	{
		for (const recordSet in this.storageProvider)
		{
			if (recordSet.startsWith(`Filter_Meta_${pRecordSet}_${pViewContext}_` ) && recordSet.endsWith(`_SETTINGS`))
			{
				return this.storageProvider.getItem(recordSet);
			}
		}
		const defaultSettings = {
			ExcludedFromSelection: true, // this one is excluded from the selection list (it's just settings, not a real filter experience)
			RememberLastUsedFilterExperience: false,
			LastUsedFilterExperienceHash: null,
			LastUsedFilterExperienceURLParam: null,
			DefaultFilterExperienceHash: null,
			DefaultFilterExperienceURLParam: null,
			FallbackDefaultExperienceURLParam: null, // in case the default filter experience is deleted, what URL param to fall back to (could be a server/customer provided fallback)
		};
		// if additional settings were provided, merge them in
		if (pAdditionalSettings && typeof(pAdditionalSettings) === 'object')
		{
			Object.assign(defaultSettings, pAdditionalSettings);
			// ex: set 'FallbackDefaultExperienceURLParam' here for future use
		}
		// save the default settings to storage
		this.storageProvider.setItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`, JSON.stringify(defaultSettings));
		return JSON.stringify(defaultSettings);
	}

	/**
	 * Set options like Last Used / Default hashes, which are stored in the settings object for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the setting for
	 * @param {string} pViewContext - The current view context
	 * @param {object} pSettings - The settings to update
	 * @return {object} - The filter experience settings object
	 */
	updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, pSettings)
	{
		let tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		let tmpSettings = tmpSavedSettings ? JSON.parse(tmpSavedSettings) : {};
		// if we've never saved settings before, initialize them first
		if (!tmpSettings)
		{
			tmpSavedSettings = this.initializeFilterExperienceSettings(pRecordSet, pViewContext);
			tmpSettings = tmpSavedSettings ? JSON.parse(tmpSavedSettings) : {};
		}
		// always update the last modified date, recordSet, and viewContext for tracking
		pSettings.RecordSet = pRecordSet ? pRecordSet : tmpSettings.RecordSet;
		pSettings.ViewContext = pViewContext ? pViewContext : tmpSettings.ViewContext;
		pSettings.LastModifiedDate = new Date().toISOString();
		// merge in the new settings
		tmpSettings = Object.assign({}, tmpSettings, pSettings);
		this.storageProvider.setItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`, JSON.stringify(tmpSettings));
		return tmpSettings;
	}	

	/**
	 * Get a single filter experience by its hash for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the filter experience for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to get
	 * @return {object} - The filter experience object
	 */
	getFilterExperienceByHash(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		if (!pRecordSet || !pViewContext)
		{
			console.error('No record set or view context provided to get filter experience.');
			return null;
		}
		if (!pFilterExperienceHash || pFilterExperienceHash.length === 0)
		{
			console.warn('No filter experience hash provided to get filter experience.');
			return null;
		}
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		return tmpFilterExperience;
	}

	/**
	 * List all available filter experiences (from the Filter Meta data) for a given record set and return them as an array of filter meta objects.
	 * @param {string} pRecordSet - the record set to list the filter experiences for
	 * @param {string} pViewContext - the current view context	 
	 * @return {Array<object>} - An array of filter meta objects for the given record set.
	 */
	getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext)
	{
		let tmpFilterExperiences = [];
		for (const recordSet in this.storageProvider)
		{
			if (recordSet.startsWith(`Filter_Meta_${pRecordSet}_${pViewContext}_`))
			{
				const tmpFilterMetaJSON = this.storageProvider.getItem(recordSet);
				if (tmpFilterMetaJSON)
				{
					const tmpFilterMeta = JSON.parse(tmpFilterMetaJSON);
					tmpFilterExperiences.push(tmpFilterMeta);
				}
			}
		}
		return tmpFilterExperiences;
	}

	/**
	 * Resolve a key in the LocalStorage keyspace for a filter experience for a given record set.
	 * @param {string} pRecordSet - The record set to resolve a key for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The scope to resolve a key for
	 *
	 * @return {string} A string that points to the record.
	 */
	getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		let tmpFilterExperienceHash = (typeof(pFilterExperienceHash) === 'string') ? pFilterExperienceHash : null;
		if (!tmpFilterExperienceHash || tmpFilterExperienceHash.length === 0)
		{
			console.warn('No filter experience hash provided to resolve storage key.');
			return '';
		}
		return `Filter_Meta_${pRecordSet}_${pViewContext}_${tmpFilterExperienceHash}`;
	}

	/**
	 * Check if a filter experience exists for a given record set and filter experience hash.
	 * @param {string} pRecordSet - The record set to check.
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to check.
	 * @return {boolean} - True if the filter experience exists, false otherwise.
	 */
	checkIfFilterExperienceExists(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterMetaJSON = this.storageProvider.getItem(tmpKey);
		return (tmpFilterMetaJSON !== null);
	}

	/**
	 * Save the application metadata (list of Filters, last loaded FilterExperienceHash, etc.)
	 * @param {string} pRecordSet - The record set to save the filter for; 
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The name of the filter to load
	 * @param {boolean} pSkipSaveAsLastUsed - Whether to skip saving this as the last used filter experience - useful when loading last used filter itself
	 * @return {boolean} - Returns true when the filter experience has been loaded.
	 */
	loadFilterMeta(pRecordSet, pViewContext, pFilterExperienceHash, pSkipSaveAsLastUsed)
	{
		// We get this every time in case the user has multiple tabs open
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		if (!tmpFilterExperience)
		{
			// check if this is the "last used" filter experience, since that one is special and we can have the URL param stored separately for unsaved searches
			const tmpLastUsedAndUnsavedExperience = this.isLastUsedFilterExperienceHash(pRecordSet, pViewContext, pFilterExperienceHash);
			if (tmpLastUsedAndUnsavedExperience)
			{
				const tmpLastUsedFilterExperience = this.getLastUsedFilterExperience(pRecordSet, pViewContext);
				this.setCurrentFilterName(tmpLastUsedFilterExperience, pRecordSet, pViewContext, 'My Last Used Filter Experience');
				this.navigateToFilterExperienceRoute(tmpLastUsedFilterExperience, pRecordSet, pViewContext);
				// clear the unapplied changes flag since we just loaded a filter experience
				this.filterExperienceModifiedFromURLHash = false;
				return true;
			}

			this.pict.log.warn(`No filter experience available to remove for record set: ${pRecordSet} with filter experience hash: ${pFilterExperienceHash}`);
			return false;
		}
		// update the current filter name in the UI
		this.setCurrentFilterName(tmpFilterExperience, pRecordSet, pViewContext);
		// re-render views if needed
		this.navigateToFilterExperienceRoute(tmpFilterExperience, pRecordSet, pViewContext);
		// update the last used filter experience
		if (!pSkipSaveAsLastUsed)
		{
			this.setLastUsedFilterExperience(tmpFilterExperience, pRecordSet, pViewContext);
		}
		// clear the unapplied changes flag since we just loaded a filter experience
		this.filterExperienceModifiedFromURLHash = false;
		
		return true;
	}

	/**
	 * Remove a filter meta from storage for a given record set and filter experience hash.
	 * @param {string} pRecordSet - The record set to remove the filter for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to remove
	 * @return {boolean} - Returns true when the filter meta has been removed.
	 */
	removeFilterMeta(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		// TODO: add confirmation dialog in the UI before removing?
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		if (!tmpFilterExperience)
		{
			this.pict.log.warn(`No filter experience available to remove for record set: ${pRecordSet} with filter experience hash: ${pFilterExperienceHash}`);
			return false;
		}
		// check if the filter being removed is set as last used or default; if so, clear those settings too
		if (this.isLastUsedFilterExperienceHash(pRecordSet, pViewContext, pFilterExperienceHash))
		{
			this.pict.log.info(`The filter experience being removed is set as the last used filter experience. Clearing last used filter experience settings.`);
			this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { LastUsedFilterExperienceHash: null, LastUsedFilterExperienceURLParam: null });
		}
		if (this.isDefaultFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash))
		{
			this.pict.log.info(`The filter experience being removed is set as the default filter experience. Clearing default filter experience settings.`);
			this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { DefaultFilterExperienceHash: null, DefaultFilterExperienceURLParam: null });
		}
		if (this.isCurrentFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash))
		{
			this.pict.log.info(`The filter experience being removed is the current active filter. Navigating to base record set URL.`);
			this.pict.views['PRSP-Filters'].handleReset(null, pRecordSet, pViewContext);
		}
		// remove the filter meta from localStorage
		this.storageProvider.removeItem(tmpKey);
		// NOTE: I think we want to keep the last used filter experience even if the user deletes it from the list? (so they can undo)

		return true;
	}

	/**
	 * Save the application metadata (list of Filters, last loaded FilterExperienceHash, etc.)
	 * @param {string} pRecordSet - The record set to save the filter for; TODO: should this have a default?
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the settings have been saved.
	 */
	saveFilterMeta(pRecordSet, pViewContext, pSilent, pDisplayNameOverride)
	{
		const activeFilterExperienceClauses = this.pict.Bundle._ActiveFilterState[pRecordSet]?.FilterClauses || [];
		const filterDisplayName = (pDisplayNameOverride && String(pDisplayNameOverride).trim())
			? String(pDisplayNameOverride).trim()
			: this.getCurrentFilterName({ FilterClauses: activeFilterExperienceClauses }, pRecordSet, pViewContext);
		const tmpFilterExperienceHash = filterDisplayName.replace(/[^a-zA-Z0-9_-]/g, '');

		if (this.checkIfFilterExperienceExists(pRecordSet, pViewContext, tmpFilterExperienceHash))
		{
			this.pict.log.info(`Filter experience with hash 'Filter_Meta_${pRecordSet}_${pViewContext}_${tmpFilterExperienceHash}' already exists for record set ${pRecordSet}. Overwriting.`);
			// TODO: add a confirmation dialog in the UI and compare before overwriting?
		}

		// TODO: BUG: Gotta have a more complex merge happen here for multiple tabs
		const newFilterExperience = {
			RecordSet: pRecordSet,
			ViewContext: pViewContext,
			FilterClauses: activeFilterExperienceClauses,
			FilterDisplayName: filterDisplayName,
			FilterExperienceHash: tmpFilterExperienceHash,
			FilterExperienceEncodedURLParam: window.location.hash.split('/FilterExperience/')?.[1] || '',
			// The search term (the /FilteredTo/ segment) is part of the saved experience too.
			SearchFilterURLParam: window.location.hash.split('/FilteredTo/')?.[1]?.split('/FilterExperience/')?.[0] || '',
			LastModifiedDate: new Date().toISOString(),
		}
		// Save the specific filter metadata to localStorage
		this.storageProvider.setItem(`Filter_Meta_${pRecordSet}_${pViewContext}_${tmpFilterExperienceHash}`, JSON.stringify(newFilterExperience));
		// Also set the last used filter experience (this one is reserved and continually updated)
		this.setLastUsedFilterExperience(newFilterExperience, pRecordSet, pViewContext);
		// they should never get here if they have unsaved changes and navigate away since we check for that in the router, but just in case, we can clear the flag that tracks whether there are unapplied changes since we just saved
		this.filterExperienceModifiedFromURLHash = false;

		return true;
	}

	/** ===== LAST USED Filter Experience ============= */

	/**
	 * Save the application metadata as the last used filter experience (continually updated).
	 * @param {object} pFilterExperience - The new filter experience object to save as last used
	 * @param {string} pRecordSet - The record set to save the filter for;
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the filter experience has been saved.
	 */
	setLastUsedFilterExperience(pFilterExperience, pRecordSet, pViewContext)
	{
		const activeFilterExperienceClauses = this.pict.Bundle._ActiveFilterState[pRecordSet]?.FilterClauses || [];
		const filterDisplayName = this.getCurrentFilterName({ FilterClauses: activeFilterExperienceClauses }, pRecordSet, pViewContext);
		const tmpFilterExperienceHash = filterDisplayName.replace(/[^a-zA-Z0-9_-]/g, '');

		// NOTE: We probably don't want to save EVERY. SINGLE. SEARCH. so if no filter experience is provided (new unsaved search), we can just redirect to the url param rather than create a new saved filter experience
		const filterMetaSettings = { 
			LastUsedFilterExperienceHash: pFilterExperience?.FilterExperienceHash || tmpFilterExperienceHash,
			LastUsedFilterExperienceURLParam: pFilterExperience?.FilterExperienceEncodedURLParam || window.location.hash.split('/FilterExperience/')?.[1] || '',
		}
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, filterMetaSettings);

		return true;
	}

	/**
	 * Remove the last used filter experience for a given record set and view context. (used on "Clear" action to get back to empty filter state)
	 * @param {string} pRecordSet - The record set to remove the last used filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the last used filter experience has been removed.
	 */
	removeLastUsedFilterExperience(pRecordSet, pViewContext)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { LastUsedFilterExperienceHash: null, LastUsedFilterExperienceURLParam: null });
		return true;
	}

	/**
	 * Get the last used filter experience for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the last used filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {object} - The last used filter experience (takes priority over default if both exist)
	 */
	getLastUsedFilterExperience(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		if (!tmpSettings.RememberLastUsedFilterExperience)
		{
			return null;
		}
		const lastUsedFilterExperienceHash = tmpSettings.LastUsedFilterExperienceHash;
		const tmpKey = this.getFilterStorageKey(pRecordSet, pViewContext, lastUsedFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		return tmpFilterExperience;
	}

	/**
	 * Check if the given filter experience is the last used filter experience for the given record set and view context.
	 * @param {string} pRecordSet - The record set to check
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to check
	 * @return {boolean} - True if the given filter experience is the last used filter experience, false otherwise
	 */
	isLastUsedFilterExperienceHash(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		const tmpLastUsedFilter = this.getLastUsedFilterExperience(pRecordSet, pViewContext);
		if (!tmpLastUsedFilter)
		{
			return false;
		}
		return (tmpLastUsedFilter.FilterExperienceHash === pFilterExperienceHash);
	}

	/**
	 * Set whether to remember the last used filter experience across sessions.
	 * @param {string} pRecordSet - The record set to set the setting for
	 * @param {string} pViewContext - The current view context
	 * @param {boolean} pRemember - Whether to remember the last used filter experience
	 */
	setRememberLastUsedFilterExperience(pRecordSet, pViewContext, pRemember)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { RememberLastUsedFilterExperience: pRemember });
		return true;
	}

	/**
	 * Get whether to remember the last used filter experience across sessions.
	 * @param {string} pRecordSet - The record set to get the setting for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Whether to remember the last used filter experience
	 */
	getRememberLastUsedFilterExperience(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		return tmpSettings.RememberLastUsedFilterExperience;
	}

	/** ===== CURRENT Filter Experience ============= */

	/**
	 * Check if the given filter experience hash is the current active filter for the given record set.
	 * @param {string} pRecordSet - The record set to check.
	 * @param {string} pViewContext - The current view context.
	 * @param {string} pFilterExperienceHash - The filter experience hash to check.
	 * @return {boolean} - True if the given filter experience hash is the current active filter, false otherwise.
	 */
	isCurrentFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		// NOTE: Could be an confusing issue if we have the same URL param with different display names
		const tmpExperienceURLParam = window.location.hash.split('/FilterExperience/')?.[1] || '';
		// look in the map for the filter experience with the given hash
		const filterExperiences = this.getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext) || [];
		const matchingExperience = filterExperiences.find((pExperience) => pExperience.FilterExperienceHash === pFilterExperienceHash);
		if (matchingExperience && (matchingExperience.FilterExperienceEncodedURLParam === tmpExperienceURLParam))
		{
			return true;
		}
		return false;
	}
	
	/**
	 * Get the current filter name from the UI input (or generate a default one)
	 * @param {object} pFilterExperience - The filter experience to get the current filter name for
	 * @param {string} pRecordSet - The record set to get the filter name for
	 * @param {string} pViewContext - The current view context
	 * @return {string} - The current filter name
	 */
	getCurrentFilterName(pFilterExperience, pRecordSet, pViewContext)
	{
		/* @type {HTMLInputElement} */
		const tmpValue = this.pict.ContentAssignment.readContent('#FilterPersistenceView-CurrentFilterNameInput');
		if (tmpValue && tmpValue.trim().length > 0)
		{
			return tmpValue.trim();
		}
		return this.generateContextualDefaultFilterName(pFilterExperience, pRecordSet, pViewContext);
	}

	/**
	 * Set the current filter name in the UI input
	 * @param {object} [pFilterExperience] - The filter experience to set the current filter name for
	 * @param {string} [pRecordSet] - The record set to set the filter name for
	 * @param {string} [pViewContext] - The current view context
	 * @param {string} [pNewName] - The new name to set
	 * @return {boolean} - Returns true when the name has been set
	 */
	setCurrentFilterName(pFilterExperience, pRecordSet, pViewContext, pNewName)
	{
		const tmpDisplayName = pNewName || this.generateContextualDefaultFilterName(pFilterExperience, pRecordSet, pViewContext);
		this.pict.ContentAssignment.assignContent('#FilterPersistenceView-CurrentFilterNameInput', tmpDisplayName);
		return true;
	}

	/** ===== DEFAULT Filter Experience ============= */

	/**
	 * Set the default filter experience to load on application load for a given record set and filter experience hash.
	 * @param {string} pRecordSet - The record set to set the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to set as default on load
	 * @param {boolean} pSetAsDefault - Whether to set as default or not
	 * @return {boolean} - Returns true when the default filter experience has been set
	 */
	setDefaultFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash, pSetAsDefault)
	{
		const tmpStorageKey = this.getFilterStorageKey(pRecordSet, pViewContext, pFilterExperienceHash);
		const tmpFilterExperienceJSON = this.storageProvider.getItem(tmpStorageKey);
		let tmpFilterExperience = tmpFilterExperienceJSON ? JSON.parse(tmpFilterExperienceJSON) : null;
		if (!tmpFilterExperience)
		{
			this.pict.log.warn(`No filter experience available to set as default for record set: ${pRecordSet} with filter experience hash: ${pFilterExperienceHash}`);
			return false;
		}
		// if already default, do nothing
		if (pSetAsDefault && this.isDefaultFilterExperience(pRecordSet, pViewContext, tmpFilterExperience.FilterExperienceHash))
		{
			this.pict.log.info(`Filter experience 'Filter_Meta_${pRecordSet}_${pViewContext}_${pFilterExperienceHash}' is already set as default on load. No action taken.`);
			return true;
		}
		// if unsetting default, but not currently default, do nothing
		if (!pSetAsDefault && !this.isDefaultFilterExperience(pRecordSet, pViewContext, tmpFilterExperience.FilterExperienceHash))
		{
			this.pict.log.info(`Filter experience 'Filter_Meta_${pRecordSet}_${pViewContext}_${pFilterExperienceHash}' is not currently set as default on load. No action taken.`);
			return true;
		}
		// update the settings
		// NOTE: We may probably want an customer-based fallback is there user default settings are cleared. For now, we will just clear it until we know that pattern.
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { DefaultFilterExperienceHash: pSetAsDefault ? pFilterExperienceHash : null });
		return true;
	}

	/**
	 * Remove the default filter experience for a given record set and view context. (used on "Clear" action to get back to empty filter state)
	 * @param {string} pRecordSet - The record set to remove the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {boolean} - Returns true when the default filter experience has been removed.
	 */
	removeDefaultFilterExperience(pRecordSet, pViewContext)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { DefaultFilterExperienceHash: null });
		return true;
	}

	/**
	 * Get the default filter experience to load on application load for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {object} - The default filter experience to load on application load (used if no last used filter experience is found or they clear filters back to default)
	 */
	getDefaultFilterExperience(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		const tmpExpectedHash = tmpSettings.DefaultFilterExperienceHash;
		if (!tmpExpectedHash || tmpExpectedHash.length === 0)
		{
			return null;
		}
		// look up the filter experience by hash (it's expected all Default hashes are saved filter experiences)
		return this.getFilterExperienceByHash(pRecordSet, pViewContext, tmpExpectedHash);
	}

	/**
	 * Check if the given filter experience is the default filter experience to load on application load for the given record set and view context.
	 * @param {string} pRecordSet - The record set to check
	 * @param {string} pViewContext - The current view context
	 * @param {string} pFilterExperienceHash - The filter experience hash to check
	 * @return {boolean} - True if the given filter experience is the default filter experience on load, false otherwise
	 */
	isDefaultFilterExperience(pRecordSet, pViewContext, pFilterExperienceHash)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return false;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		return (tmpSettings.DefaultFilterExperienceHash === pFilterExperienceHash);
	}

	/**
	 * Get the fallback default filter experience URL param to load on application load for a given record set and view context.
	 * @param {string} pRecordSet - The record set to get the fallback default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @return {string|null} - The fallback default filter experience URL param to load on application load (could be server/customer provided)
	 */
	getFallbackDefaultFilterExperienceSettings(pRecordSet, pViewContext)
	{
		const tmpSavedSettings = this.storageProvider.getItem(`Filter_Meta_${pRecordSet}_${pViewContext}_SETTINGS`);
		if (!tmpSavedSettings)
		{
			return null;
		}
		const tmpSettings = JSON.parse(tmpSavedSettings);
		return tmpSettings.FallbackDefaultExperienceURLParam || null;
	}

	/**
	 * Set the fallback default filter experience URL param to load on application load for a given record set and view context. Expected to be used for server/customer provided fallbacks.
	 * @param {string} pRecordSet - The record set to set the fallback default filter experience for
	 * @param {string} pViewContext - The current view context
	 * @param {string} pURLParam - The fallback default filter experience URL param to set
	 * @return {boolean} - Returns true when the fallback default filter experience URL param has been set
	 */
	setFallbackDefaultFilterExperienceSettings(pRecordSet, pViewContext, pURLParam)
	{
		this.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, { FallbackDefaultExperienceURLParam: pURLParam });
		return true;
	}

	/** ===== SIMPLE KEY-VALUE CACHE ============= */

	/**
	 * @param {string} pKey - The key to get from the cache
	 * @return {any} - The value associated with the key, or false if not found
	 */
	getItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			return this.keyCache[pKey];
		}
		return false;
	}

	/**
	 * @param {string} pKey - The key to set in the cache
	 * @param {any} pValue - The value to associate with the key
	 */
	setItem(pKey, pValue)
	{
		this.keyCache[pKey] = pValue;
		return true;
	}

	/**
	 * @param {string} pKey - The key to remove from the cache
	 * @return {boolean} - True if the item was removed, false if it was not found
	 */
	removeItem(pKey)
	{
		if (pKey in this.keyCache)
		{
			delete this.keyCache[pKey];
			return true;
		}
		return false;
	}
}

module.exports = FilterDataProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":845}],970:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-AssociationManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

/**
 * Central registry + data layer for joined-entity ASSOCIATIONS (the `XxxYyyJoin` convention: a join
 * row carrying its own `ID<Join>` plus an `ID<X>` and an `ID<Y>` pointing at either side).
 *
 * One `Association` is defined ONCE, symmetrically, with a `SideA` and a `SideB`. The UI (the
 * read-tab Association Editor and the Bulk Associate screen) resolves which side is "this side" by
 * matching the rendering recordset's name against the two sides — so opting Book→Authors and
 * Author→Books in are independent, light-config decisions.
 *
 * All join + display reads/writes go through the shared, cached `pict.EntityProvider` (the same one
 * the picker uses), so there is no bespoke REST plumbing and lookups de-duplicate across the app.
 */
class PictRecordSetAssociationManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.pict;

		/** @type {Record<string, Record<string, any>>} - Registered associations keyed by hash. */
		this.associations = {};

		/** @type {Record<string, any>} - Lazily-created EntityProviders scoped to a non-default URL prefix. */
		this._scopedEntityProviders = {};

		/** @type {string} - EntityProvider cache scope for join-list reads; cleared on every join write so
		 * the editor and pickers never show a stale (cached) association list after an add or remove. */
		this._cacheScope = 'RecordSetAssociation';
	}

	/**
	 * Invalidate the cached join-list reads after a write so the next list reflects it immediately
	 * (pict's EntityProvider caches getEntitySet by filter for ~10s; clearScope no-ops on the default
	 * empty scope, which is why join reads run under a dedicated scope).
	 * @param {Record<string, any>} pEntityProvider - the (scoped) EntityProvider used for the join.
	 */
	_clearAssociationCache(pEntityProvider)
	{
		try
		{
			if (pEntityProvider && (typeof pEntityProvider.clearScope === 'function'))
			{
				pEntityProvider.clearScope(this._cacheScope);
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`AssociationManager: association cache clear failed: ${pError.message || pError}`);
		}
	}

	/**
	 * Normalize one side definition, filling the light-config defaults: `Entity` falls back to
	 * `RecordSet`, `IDField` to `ID<Entity>`, `DisplayField` to `Name`, `SearchFields` to
	 * `[DisplayField]`, and `Sort` to `DisplayField`.
	 *
	 * @param {Record<string, any>} pSide
	 * @return {Record<string, any>}
	 */
	_normalizeSide(pSide)
	{
		const tmpSide = pSide || {};
		const tmpEntity = tmpSide.Entity || tmpSide.RecordSet;
		const tmpDisplayField = tmpSide.DisplayField || 'Name';
		const tmpIDField = tmpSide.IDField || `ID${tmpEntity}`;
		return {
			RecordSet: tmpSide.RecordSet || tmpEntity,
			Entity: tmpEntity,
			// The field on THIS SIDE's record that identifies it for association purposes — the picker
			// value, the display lookup key, and (by default) the value stored in the join. Usually the
			// primary key (`ID<Entity>`), but can be any unique field (e.g. ObservationManifest is keyed
			// by 'Name' on its join, so its side is { IDField: 'Name' }).
			IDField: tmpIDField,
			// The column on the JOIN ENTITY that references this side. Defaults to IDField — the common
			// case where the join column has the same name as the side's id field. Set it when the join
			// names this side differently: ProjectObservationManifestJoin stores the manifest by
			// 'ObservationManifestName', so the manifest side is { IDField: 'Name', JoinField: 'ObservationManifestName' }.
			JoinField: tmpSide.JoinField || tmpIDField,
			DisplayField: tmpDisplayField,
			SearchFields: (Array.isArray(tmpSide.SearchFields) && tmpSide.SearchFields.length > 0) ? tmpSide.SearchFields : [ tmpDisplayField ],
			// No default sort: alphabetical-by-display sorts empty values first (blank rows). The picker's
			// natural (PK) order is predictable; a host can opt into a Sort column explicitly.
			Sort: tmpSide.Sort || false,
			Title: tmpSide.Title || false,
			URLPrefix: tmpSide.URLPrefix || '',
			// Extra fields rendered as disambiguation chips in the picker (and the editor list), e.g.
			// ['ISBN'] or [{ Field: 'PublicationYear', Label: 'Year' }]. Passed to the picker as EntityTags.
			ChipFields: Array.isArray(tmpSide.ChipFields) ? tmpSide.ChipFields : [],
			// Pin-to-top: value-ids (or a `(context) => ids | Promise<ids>` resolver) for THIS side's records
			// to float to the top of the add-picker's first browse page. Forwarded to the picker as
			// PriorityValues; a function form receives the anchor context (which record is being associated to)
			// so a host can pin a runtime-derived record — e.g. an Organization side pinning the anchor line
			// item's project Prime Contractor. Only meaningful on the OTHER (picked) side.
			PriorityValues: tmpSide.PriorityValues || false,
			// Columns for the matrix screen's record table — for picking complex records by several fields.
			TableColumns: this._normalizeColumns(tmpSide.TableColumns, tmpDisplayField),
		};
	}

	/**
	 * Normalize a side's TableColumns into `{ Key, DisplayName, Template? }` entries (string shorthand →
	 * `{ Key, DisplayName: Key }`). Defaults to a single column on the DisplayField when unset.
	 *
	 * @param {Array<string|Record<string, any>>|undefined} pColumns @param {string} pDisplayField
	 * @return {Array<Record<string, any>>}
	 */
	_normalizeColumns(pColumns, pDisplayField)
	{
		if (!Array.isArray(pColumns) || pColumns.length < 1)
		{
			return [ { Key: pDisplayField, DisplayName: pDisplayField } ];
		}
		return pColumns.map((pColumn) =>
		{
			if (typeof pColumn === 'string') { return { Key: pColumn, DisplayName: pColumn, DefaultHidden: false }; }
			return { Key: pColumn.Key, DisplayName: pColumn.DisplayName || pColumn.Key, Template: pColumn.Template || false, DefaultHidden: (pColumn.DefaultHidden === true) };
		});
	}

	/**
	 * Build a FoxHound LIKE filter for a search term across one or more fields (single → AND, multiple →
	 * OR'd in a paren group), mirroring the picker's entity search. Used by the matrix table fetch.
	 *
	 * @param {Array<string>} pSearchFields @param {string} pTerm
	 * @return {string}
	 */
	_buildSearchFilter(pSearchFields, pTerm)
	{
		const tmpEncoded = encodeURIComponent(`%${pTerm}%`);
		if (pSearchFields.length === 1)
		{
			return `FBV~${pSearchFields[0]}~LK~${tmpEncoded}`;
		}
		const tmpInner = pSearchFields.map((pField, pIndex) => `${pIndex === 0 ? 'FBV' : 'FBVOR'}~${pField}~LK~${tmpEncoded}`).join('~');
		return `FOP~0~(~0~${tmpInner}~FCP~0~)~0`;
	}

	/**
	 * URL-encode each value and comma-join, for `INN`/`NIN` filter lists. Numeric ids pass through; this
	 * keeps string keys (e.g. manifest names with spaces) intact when a side is keyed by a name column.
	 * @param {Array<string|number>} pValues
	 * @return {string}
	 */
	_encodeList(pValues)
	{
		return (Array.isArray(pValues) ? pValues : []).map((pValue) => encodeURIComponent(pValue)).join(',');
	}

	/**
	 * Fetch one page of a side's records for the matrix table (search across its SearchFields + optional
	 * Sort, offset/limit paging). Returns the raw records + a `hasMore` flag.
	 *
	 * @param {string} pAssociationHash @param {string} pRecordSetName
	 * @param {string} pSearch @param {number} pCursor @param {number} pPageSize
	 * @return {Promise<{records: Array<Record<string, any>>, hasMore: boolean}>}
	 */
	fetchSidePage(pAssociationHash, pRecordSetName, pSearch, pCursor, pPageSize)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pRecordSetName);
		if (!tmpSides)
		{
			return Promise.resolve({ records: [], hasMore: false });
		}
		const tmpSide = tmpSides.thisSide;
		const tmpEntityProvider = this._entityProvider(tmpSide.URLPrefix);
		const tmpStanzas = [];
		if (pSearch) { tmpStanzas.push(this._buildSearchFilter(tmpSide.SearchFields, pSearch)); }
		if (tmpSide.Sort) { tmpStanzas.push(`FSF~${tmpSide.Sort}~ASC~0`); }
		const tmpFilter = tmpStanzas.filter(Boolean).join('~');
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySetPage(tmpSide.Entity, tmpFilter, pCursor, pPageSize, (pError, pRecords) =>
			{
				const tmpList = (!pError && Array.isArray(pRecords)) ? pRecords : [];
				if (pError) { this.pict.log.warn(`AssociationManager: matrix fetch failed for ${tmpSide.Entity}.`, pError); }
				return resolve({ records: tmpList, hasMore: (tmpList.length >= pPageSize) });
			});
		});
	}

	/**
	 * Register (or replace) an association definition.
	 *
	 * @param {string} pHash - Unique association hash (the `Association` key hosts reference).
	 * @param {Record<string, any>} pDefinition - `{ JoinEntity, JoinURLPrefix?, DefaultJoinValues?, SideA, SideB }`.
	 * @return {Record<string, any>|false} The normalized association, or false on invalid input.
	 */
	addAssociation(pHash, pDefinition)
	{
		if (!pHash || !pDefinition || !pDefinition.JoinEntity || !pDefinition.SideA || !pDefinition.SideB)
		{
			this.pict.log.error(`AssociationManager: addAssociation called with invalid definition for [${pHash}].`, pDefinition);
			return false;
		}
		const tmpAssociation = {
			Hash: pHash,
			JoinEntity: pDefinition.JoinEntity,
			JoinURLPrefix: pDefinition.JoinURLPrefix || '',
			DefaultJoinValues: pDefinition.DefaultJoinValues || {},
			// Per-join config columns the editor renders as inline-editable on each association row — for
			// "rich" joins that carry settings (e.g. Journal/Spreadsheet/Ordinal). Each entry:
			// { Field, Label?, Type? ('checkbox'|'number'|'text'|'select'), Options?, Width? }.
			JoinEditableFields: Array.isArray(pDefinition.JoinEditableFields) ? pDefinition.JoinEditableFields : [],
			// The defaults lifecycle hook — the overridable seam the host implements. An async
			// `(context) => Array<{ value, joinValues? }>` returning the OTHER side's key values (+ optional
			// per-join config) to seed for an anchor record. PSRS owns APPLYING them (dedupe + createJoin),
			// so every association synthesizes defaults the same way; the host only decides what they are.
			SynthesizeDefaults: (typeof pDefinition.SynthesizeDefaults === 'function') ? pDefinition.SynthesizeDefaults : false,
			// Opt-in: auto-run synthesizeDefaults the first time the editor opens an anchor with zero joins.
			AutoSynthesizeWhenEmpty: (pDefinition.AutoSynthesizeWhenEmpty === true),
			SideA: this._normalizeSide(pDefinition.SideA),
			SideB: this._normalizeSide(pDefinition.SideB),
		};
		this.associations[pHash] = tmpAssociation;
		return tmpAssociation;
	}

	/**
	 * @param {string} pHash
	 * @return {Record<string, any>|undefined}
	 */
	getAssociation(pHash)
	{
		return this.associations[pHash];
	}

	/**
	 * The hashes of every registered association that has the given recordset on either side (matched by
	 * RecordSet or Entity, the same way resolveSides matches). Drives reassociation-on-delete: to reassign
	 * a record's relationships before deleting it, we need every many-to-many join it participates in.
	 *
	 * @param {string} pRecordSetName
	 * @return {Array<string>}
	 */
	getAssociationsForRecordSet(pRecordSetName)
	{
		const tmpHashes = [];
		for (const tmpHash of Object.keys(this.associations))
		{
			const tmpAssociation = this.associations[tmpHash];
			if (tmpAssociation.SideA.RecordSet === pRecordSetName || tmpAssociation.SideA.Entity === pRecordSetName
				|| tmpAssociation.SideB.RecordSet === pRecordSetName || tmpAssociation.SideB.Entity === pRecordSetName)
			{
				tmpHashes.push(tmpHash);
			}
		}
		return tmpHashes;
	}

	/**
	 * Resolve which side of an association is "this side" (the rendering recordset) vs the "other side"
	 * (the one being associated). Matches on `RecordSet` first, then `Entity`.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @return {{ association: Record<string, any>, thisSide: Record<string, any>, otherSide: Record<string, any> }|false}
	 */
	resolveSides(pAssociationHash, pThisRecordSetName)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		if (!tmpAssociation)
		{
			this.pict.log.warn(`AssociationManager: no association registered for hash [${pAssociationHash}].`);
			return false;
		}
		if (tmpAssociation.SideA.RecordSet === pThisRecordSetName || tmpAssociation.SideA.Entity === pThisRecordSetName)
		{
			return { association: tmpAssociation, thisSide: tmpAssociation.SideA, otherSide: tmpAssociation.SideB };
		}
		if (tmpAssociation.SideB.RecordSet === pThisRecordSetName || tmpAssociation.SideB.Entity === pThisRecordSetName)
		{
			return { association: tmpAssociation, thisSide: tmpAssociation.SideB, otherSide: tmpAssociation.SideA };
		}
		this.pict.log.warn(`AssociationManager: recordset [${pThisRecordSetName}] is neither side of association [${pAssociationHash}].`);
		return false;
	}

	/**
	 * The EntityProvider to use for a given URL prefix. The shared (cached) `pict.EntityProvider` for the
	 * default prefix; a lazily-created, prefix-scoped instance otherwise (mirrors the recordset provider).
	 *
	 * @param {string} [pURLPrefix]
	 * @return {any}
	 */
	_entityProvider(pURLPrefix)
	{
		if (!pURLPrefix)
		{
			return this.pict.EntityProvider;
		}
		if (!this._scopedEntityProviders[pURLPrefix])
		{
			const tmpProvider = this.pict.instantiateServiceProviderWithoutRegistration('EntityProvider');
			tmpProvider.options.urlPrefix = pURLPrefix;
			this._scopedEntityProviders[pURLPrefix] = tmpProvider;
		}
		return this._scopedEntityProviders[pURLPrefix];
	}

	/**
	 * The join entity's identity column for an association (`ID<JoinEntity>`).
	 * @param {Record<string, any>} pAssociation
	 * @return {string}
	 */
	getJoinIDField(pAssociation)
	{
		return `ID${pAssociation.JoinEntity}`;
	}

	/**
	 * Compose a side's ChipFields into display chip strings for a record — the same `ISBN` / `{Field,
	 * Label, Template}` spec the picker's EntityTags uses, so the editor's current-associations list shows
	 * the same disambiguation chips as the add picker.
	 *
	 * @param {Array<string|Record<string, any>>} pChipFields
	 * @param {Record<string, any>} pRecord
	 * @return {Array<any>}
	 */
	composeChips(pChipFields, pRecord)
	{
		if (!Array.isArray(pChipFields) || pChipFields.length < 1 || !pRecord)
		{
			return [];
		}
		return pChipFields
			.map((pSpec) =>
			{
				if (typeof pSpec === 'string') { return pRecord[pSpec]; }
				if (pSpec && typeof pSpec === 'object')
				{
					const tmpValue = pSpec.Template ? this.pict.parseTemplate(pSpec.Template, pRecord) : pRecord[pSpec.Field];
					if (tmpValue === undefined || tmpValue === null || tmpValue === '') { return ''; }
					return pSpec.Label ? `${pSpec.Label}: ${tmpValue}` : tmpValue;
				}
				return '';
			})
			.filter((pChip) => (pChip !== undefined && pChip !== null && pChip !== ''));
	}

	/**
	 * Fetch the raw join rows for one anchor record (this side's id).
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || pThisID === undefined || pThisID === null || pThisID === '')
		{
			return Promise.resolve([]);
		}
		const tmpEntityProvider = this._entityProvider(tmpSides.association.JoinURLPrefix);
		const tmpFilter = `FBV~${tmpSides.thisSide.JoinField}~EQ~${encodeURIComponent(pThisID)}`;
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySet(tmpSides.association.JoinEntity, tmpFilter, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`AssociationManager: failed to list ${tmpSides.association.JoinEntity} for ${tmpSides.thisSide.IDField}=${pThisID}.`, pError);
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, '', { Scope: this._cacheScope, NoCount: true });
		});
	}

	/**
	 * Fetch the join rows for MANY "this side" ids at once (`FBL~<thisIDField>~INN~<ids>`). Drives the
	 * dual-column matrix screen's existing-pair dedup, so cross-linking never creates duplicate joins.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {Array<string|number>} pThisIDs
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	listJoinRecordsForIDs(pAssociationHash, pThisRecordSetName, pThisIDs)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || !Array.isArray(pThisIDs) || pThisIDs.length < 1)
		{
			return Promise.resolve([]);
		}
		const tmpEntityProvider = this._entityProvider(tmpSides.association.JoinURLPrefix);
		const tmpFilter = `FBL~${tmpSides.thisSide.JoinField}~INN~${this._encodeList(pThisIDs)}`;
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySet(tmpSides.association.JoinEntity, tmpFilter, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`AssociationManager: failed to list ${tmpSides.association.JoinEntity} for ${tmpSides.thisSide.IDField} IN (${pThisIDs.join(',')}).`, pError);
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, '', { Scope: this._cacheScope, NoCount: true });
		});
	}

	/**
	 * The other-side ids currently associated with one anchor record (for culling the picker).
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<Array<any>>}
	 */
	/**
	 * Does this join row reference a real other-side record? An unset key (undefined / null / '') is
	 * not an association; nor is 0 / '0' on an id-keyed side, where 0 is never a real auto-increment id
	 * (Meadow ids start at 1). Some hosts park sentinel rows in the join table — e.g. a "default set"
	 * keyed by IDProject = 0 that a SynthesizeDefaults hook reads — and those must not surface as broken
	 * "#0" rows in the editor. The 0-guard is gated to id-keyed sides (JoinField === IDField) so a
	 * name-keyed side, where '0' could pathologically be a real key, is never affected.
	 *
	 * @param {Record<string, any>} pJoin - a join row.
	 * @param {Record<string, any>} pOtherSide - the resolved other side.
	 * @return {Boolean}
	 */
	_joinReferencesRealRecord(pJoin, pOtherSide)
	{
		const tmpValue = pJoin[pOtherSide.JoinField];
		if ((tmpValue === undefined) || (tmpValue === null) || (tmpValue === ''))
		{
			return false;
		}
		if ((pOtherSide.JoinField === pOtherSide.IDField) && ((tmpValue === 0) || (tmpValue === '0')))
		{
			return false;
		}
		return true;
	}

	async listAssociatedIDs(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return [];
		}
		const tmpJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID);
		return tmpJoins
			.filter((pJoin) => this._joinReferencesRealRecord(pJoin, tmpSides.otherSide))
			.map((pJoin) => pJoin[tmpSides.otherSide.JoinField]);
	}

	/**
	 * Resolve the other-side records currently associated with one anchor, decorated for the list UI:
	 * `{ JoinID, OtherID, Display, OtherRecord, JoinRecord }`. One join row per item (so the remove
	 * button can delete the exact join record), with the other-side display resolved in a single
	 * `FBL~<otherIDField>~INN~<ids>` fetch.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	async listAssociatedRecords(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return [];
		}
		const tmpJoinIDField = this.getJoinIDField(tmpSides.association);
		const tmpJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID);
		// Drop sentinel / unset rows (e.g. a "default set" keyed by other-side id 0) so they don't
		// surface as broken "#0" rows; everything downstream works off the real-association set.
		const tmpRealJoins = tmpJoins.filter((pJoin) => this._joinReferencesRealRecord(pJoin, tmpSides.otherSide));
		const tmpOtherIDs = tmpRealJoins.map((pJoin) => pJoin[tmpSides.otherSide.JoinField]);

		let tmpByID = {};
		if (tmpOtherIDs.length > 0)
		{
			const tmpEntityProvider = this._entityProvider(tmpSides.otherSide.URLPrefix);
			const tmpFilter = `FBL~${tmpSides.otherSide.IDField}~INN~${this._encodeList(tmpOtherIDs)}`;
			const tmpOthers = await new Promise((resolve) =>
			{
				tmpEntityProvider.getEntitySet(tmpSides.otherSide.Entity, tmpFilter, (pError, pRecords) =>
				{
					if (pError)
					{
						this.pict.log.warn(`AssociationManager: failed to resolve ${tmpSides.otherSide.Entity} display records.`, pError);
						return resolve([]);
					}
					return resolve(Array.isArray(pRecords) ? pRecords : []);
				});
			});
			for (let i = 0; i < tmpOthers.length; i++)
			{
				tmpByID[tmpOthers[i][tmpSides.otherSide.IDField]] = tmpOthers[i];
			}
		}

		return tmpRealJoins
			.map((pJoin) =>
			{
				const tmpOtherID = pJoin[tmpSides.otherSide.JoinField];
				const tmpOtherRecord = tmpByID[tmpOtherID] || {};
				const tmpDisplay = (tmpOtherRecord[tmpSides.otherSide.DisplayField] !== undefined && tmpOtherRecord[tmpSides.otherSide.DisplayField] !== null && tmpOtherRecord[tmpSides.otherSide.DisplayField] !== '')
					? tmpOtherRecord[tmpSides.otherSide.DisplayField]
					: `#${tmpOtherID}`;
				return {
					JoinID: pJoin[tmpJoinIDField],
					OtherID: tmpOtherID,
					Display: tmpDisplay,
					Chips: this.composeChips(tmpSides.otherSide.ChipFields, tmpOtherRecord).map((pChip) => ({ Text: pChip })),
					OtherRecord: tmpOtherRecord,
					JoinRecord: pJoin,
				};
			});
	}

	/**
	 * Create one join row linking an anchor record to an other-side record. Stamps any configured
	 * `DefaultJoinValues` (e.g. a constant tenant id). The join's GUID is auto-generated server-side.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @param {string|number} pOtherID
	 * @param {Record<string, any>} [pJoinValues] - Optional extra columns to stamp on the join row (e.g.
	 *   per-association config like { Journal: 1, Ordinal: 3 } from a synthesized default).
	 * @return {Promise<Record<string, any>>}
	 */
	createJoin(pAssociationHash, pThisRecordSetName, pThisID, pOtherID, pJoinValues)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return Promise.reject(new Error(`AssociationManager: cannot create join for [${pAssociationHash}] from [${pThisRecordSetName}].`));
		}
		const tmpRecord = Object.assign({}, tmpSides.association.DefaultJoinValues, pJoinValues || {});
		tmpRecord[tmpSides.thisSide.JoinField] = pThisID;
		tmpRecord[tmpSides.otherSide.JoinField] = pOtherID;
		const tmpEntityProvider = this._entityProvider(tmpSides.association.JoinURLPrefix);
		return new Promise((resolve, reject) =>
		{
			tmpEntityProvider.createEntity(tmpSides.association.JoinEntity, tmpRecord, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				this._clearAssociationCache(tmpEntityProvider);
				return resolve(pBody);
			});
		});
	}

	/**
	 * Delete one join row (the row a list item carries as `JoinRecord`, or any record with the join id).
	 *
	 * @param {string} pAssociationHash
	 * @param {Record<string, any>} pJoinRecord
	 * @return {Promise<Record<string, any>>}
	 */
	removeJoin(pAssociationHash, pJoinRecord)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		if (!tmpAssociation || !pJoinRecord)
		{
			return Promise.reject(new Error(`AssociationManager: cannot remove join for [${pAssociationHash}].`));
		}
		const tmpJoinID = pJoinRecord[this.getJoinIDField(tmpAssociation)];
		const tmpEntityProvider = this._entityProvider(tmpAssociation.JoinURLPrefix);
		return new Promise((resolve, reject) =>
		{
			tmpEntityProvider.deleteEntity(tmpAssociation.JoinEntity, tmpJoinID, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				this._clearAssociationCache(tmpEntityProvider);
				return resolve(pBody);
			});
		});
	}

	/**
	 * Update the config columns of an existing join row (a "rich" join's per-association settings, e.g.
	 * Journal / Spreadsheet / Ordinal). Merges pValues over the join record and PUTs it.
	 *
	 * @param {string} pAssociationHash
	 * @param {Record<string, any>} pJoinRecord - the full join row (as carried by listAssociatedRecords).
	 * @param {Record<string, any>} pValues - the columns to change.
	 * @return {Promise<Record<string, any>>}
	 */
	updateJoin(pAssociationHash, pJoinRecord, pValues)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		if (!tmpAssociation || !pJoinRecord)
		{
			return Promise.reject(new Error(`AssociationManager: cannot update join for [${pAssociationHash}].`));
		}
		// Minimal update — the join id + only the changed columns. The read-decorated join row can carry
		// derived, non-column fields (e.g. a joined ModuleConfig) that the server rejects on write; Meadow
		// updates only the fields provided, so a minimal record is both correct and safe.
		const tmpJoinIDField = this.getJoinIDField(tmpAssociation);
		const tmpRecord = Object.assign({ [tmpJoinIDField]: pJoinRecord[tmpJoinIDField] }, pValues || {});
		const tmpEntityProvider = this._entityProvider(tmpAssociation.JoinURLPrefix);
		return new Promise((resolve, reject) =>
		{
			tmpEntityProvider.updateEntity(tmpAssociation.JoinEntity, tmpRecord, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				// Meadow returns a non-2xx error in the body (not the callback) — surface it as a failure.
				if (pBody && pBody.ErrorCode)
				{
					return reject(new Error(`AssociationManager: join update rejected (ErrorCode ${pBody.ErrorCode}).`));
				}
				this._clearAssociationCache(tmpEntityProvider);
				return resolve(pBody);
			});
		});
	}

	/**
	 * Repoint every join row that references `pFromID` (on the given recordset's side) so it references
	 * `pToID` instead — the many-to-many half of reassociation-on-delete ("this author's books now belong
	 * to that author"). For each of the from-record's joins: if `pToID` is ALREADY joined to the same
	 * other-side record, the from-join is deleted (repointing it would create a duplicate pair); otherwise
	 * the join's this-side column is repointed via a minimal update, which preserves any rich-join config
	 * columns (Journal/Ordinal/…). `pToID`'s existing joins are snapshotted up front so the dedup read is
	 * clean, and each repoint extends the dedup set so two from-joins to the same other-side record can't
	 * duplicate either.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName - the recordset being deleted-from (pFromID and pToID are ids on THIS side).
	 * @param {string|number} pFromID - the id being removed; its joins move away.
	 * @param {string|number} pToID - the replacement id; the joins move to it.
	 * @return {Promise<{ repointed: number, deletedDuplicate: number, failed: number }>}
	 */
	async repointJoins(pAssociationHash, pThisRecordSetName, pFromID, pToID)
	{
		const tmpResult = { repointed: 0, deletedDuplicate: 0, failed: 0 };
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || pFromID === undefined || pFromID === null || pFromID === '' || pToID === undefined || pToID === null || pToID === '')
		{
			return tmpResult;
		}
		// Self-repoint is a no-op: moving a record's joins onto itself changes nothing, and a later delete
		// of pFromID would then strand exactly the joins we thought we "kept".
		if (String(pFromID) === String(pToID))
		{
			return tmpResult;
		}

		const tmpFromJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pFromID);
		const tmpToJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pToID);

		// The other-side ids pToID already links — repointing a from-join onto any of these would duplicate
		// the pair, so those from-joins are dropped instead.
		const tmpToOtherIDs = {};
		for (let i = 0; i < tmpToJoins.length; i++)
		{
			const tmpOtherID = tmpToJoins[i][tmpSides.otherSide.JoinField];
			if (tmpOtherID !== undefined && tmpOtherID !== null && tmpOtherID !== '')
			{
				tmpToOtherIDs[`${tmpOtherID}`] = true;
			}
		}

		for (let i = 0; i < tmpFromJoins.length; i++)
		{
			const tmpJoin = tmpFromJoins[i];
			const tmpOtherID = tmpJoin[tmpSides.otherSide.JoinField];
			const tmpReal = (tmpOtherID !== undefined) && (tmpOtherID !== null) && (tmpOtherID !== '');
			try
			{
				if (tmpReal && tmpToOtherIDs[`${tmpOtherID}`])
				{
					// pToID already links this other-side record — drop the would-be duplicate join.
					await this.removeJoin(pAssociationHash, tmpJoin);
					tmpResult.deletedDuplicate++;
				}
				else
				{
					// Repoint this side's column on the join row to pToID.
					await this.updateJoin(pAssociationHash, tmpJoin, { [tmpSides.thisSide.JoinField]: pToID });
					if (tmpReal) { tmpToOtherIDs[`${tmpOtherID}`] = true; }
					tmpResult.repointed++;
				}
			}
			catch (pError)
			{
				tmpResult.failed++;
				this.pict.log.error(`AssociationManager: repointJoins failed for a [${pAssociationHash}] join (${pThisRecordSetName} ${pFromID} -> ${pToID}): ${pError.message || pError}`);
			}
		}
		return tmpResult;
	}

	/**
	 * The per-join config columns an association exposes as inline-editable (empty for a plain join).
	 * @param {string} pAssociationHash
	 * @return {Array<Record<string, any>>}
	 */
	getJoinEditableFields(pAssociationHash)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		return (tmpAssociation && Array.isArray(tmpAssociation.JoinEditableFields)) ? tmpAssociation.JoinEditableFields : [];
	}

	/**
	 * Whether an association has a host-provided defaults synthesizer registered.
	 * @param {string} pAssociationHash
	 * @return {boolean}
	 */
	hasDefaultSynthesizer(pAssociationHash)
	{
		const tmpAssociation = this.associations[pAssociationHash];
		return !!(tmpAssociation && (typeof tmpAssociation.SynthesizeDefaults === 'function'));
	}

	/**
	 * Synthesize default associations for one anchor record — THE consistent defaults lifecycle function.
	 * PSRS owns the "apply" half (dedupe against existing joins, then createJoin each new one with its
	 * config); the host owns only WHAT the defaults are, via the association's overridable
	 * `SynthesizeDefaults(context)` hook. No-op when no hook is registered.
	 *
	 * The hook receives `{ association, thisSide, otherSide, thisID, existingJoins, manager, pict }` and
	 * returns `Array<{ value, joinValues? }>` — `value` is the OTHER side's key value (what goes in the
	 * join's other JoinField), `joinValues` is optional extra config to stamp on that join row.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {string|number} pThisID
	 * @return {Promise<{ created: number, skipped: number }>}
	 */
	async synthesizeDefaults(pAssociationHash, pThisRecordSetName, pThisID)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides || !this.hasDefaultSynthesizer(pAssociationHash) || pThisID === undefined || pThisID === null || pThisID === '')
		{
			return { created: 0, skipped: 0 };
		}
		const tmpExistingJoins = await this.listJoinRecords(pAssociationHash, pThisRecordSetName, pThisID);
		const tmpExisting = {};
		tmpExistingJoins.forEach((pJoin) =>
		{
			const tmpValue = pJoin[tmpSides.otherSide.JoinField];
			if (tmpValue !== undefined && tmpValue !== null && tmpValue !== '') { tmpExisting[`${tmpValue}`] = true; }
		});

		let tmpDefaults = [];
		try
		{
			tmpDefaults = await tmpSides.association.SynthesizeDefaults(
				{
					association: tmpSides.association,
					thisSide: tmpSides.thisSide,
					otherSide: tmpSides.otherSide,
					thisID: pThisID,
					existingJoins: tmpExistingJoins,
					manager: this,
					pict: this.pict,
				});
		}
		catch (pError)
		{
			this.pict.log.error(`AssociationManager: SynthesizeDefaults hook for [${pAssociationHash}] threw: ${pError.message || pError}`);
			return { created: 0, skipped: 0 };
		}

		let tmpCreated = 0;
		let tmpSkipped = 0;
		const tmpList = Array.isArray(tmpDefaults) ? tmpDefaults : [];
		for (let i = 0; i < tmpList.length; i++)
		{
			const tmpDefault = tmpList[i] || {};
			const tmpValue = (tmpDefault.value !== undefined) ? tmpDefault.value : tmpDefault.Value;
			if (tmpValue === undefined || tmpValue === null || tmpValue === '' || tmpExisting[`${tmpValue}`])
			{
				tmpSkipped++;
				continue;
			}
			try
			{
				await this.createJoin(pAssociationHash, pThisRecordSetName, pThisID, tmpValue, tmpDefault.joinValues || tmpDefault.JoinValues || {});
				tmpExisting[`${tmpValue}`] = true;
				tmpCreated++;
			}
			catch (pError)
			{
				this.pict.log.warn(`AssociationManager: synthesize createJoin failed for [${pAssociationHash}] value [${tmpValue}]: ${pError.message || pError}`);
				tmpSkipped++;
			}
		}
		return { created: tmpCreated, skipped: tmpSkipped };
	}

	/**
	 * Build a `createEntityPicker` config for one side, optionally culling a live set of ids (a function
	 * so the cull re-evaluates on every search as associations change).
	 *
	 * @param {Record<string, any>} pSide - A normalized side.
	 * @param {(() => Array<any>)|false} pGetExcludedIDsFn - Returns ids to exclude (NIN), or falsy for none.
	 * @param {Record<string, any>} [pOverrides] - Extra picker options (DestinationAddress, ValueAddress, Mode, OnChange, …).
	 * @param {Record<string, any>} [pPriorityContext] - Anchor context merged into a function-form PriorityValues
	 *   resolver's argument (e.g. `{ ThisID, ThisRecordSet }`), so a host pin can be derived from the anchor record.
	 * @return {Record<string, any>}
	 */
	_pickerConfigForSide(pSide, pGetExcludedIDsFn, pOverrides, pPriorityContext)
	{
		const tmpConfig = {
			Entity: pSide.Entity,
			ValueField: pSide.IDField,
			TextField: pSide.DisplayField,
			SearchFields: pSide.SearchFields,
			Sort: pSide.Sort,
		};
		// Disambiguation chips (ISBN, year, …) — the picker renders these as badges on each option/chip.
		// TagLast so they sit AFTER the label ("Title  ISBN  Year"), matching the editor list rows.
		if (Array.isArray(pSide.ChipFields) && pSide.ChipFields.length > 0)
		{
			tmpConfig.EntityTags = pSide.ChipFields;
			tmpConfig.TagLast = true;
		}
		// Pin-to-top (module policy): forward the side's PriorityValues to the picker's DataProvider. A
		// function form is wrapped so the host resolver receives the anchor context (which record we're
		// associating to) — the prime-contractor-at-top case needs the anchor to resolve its project.
		if (pSide.PriorityValues)
		{
			tmpConfig.PriorityValues = (typeof pSide.PriorityValues === 'function')
				? (() => pSide.PriorityValues(Object.assign({ side: pSide, manager: this, pict: this.pict }, pPriorityContext || {})))
				: pSide.PriorityValues;
		}
		if (typeof pGetExcludedIDsFn === 'function')
		{
			tmpConfig.BaseFilter = () =>
			{
				const tmpIDs = pGetExcludedIDsFn();
				return (Array.isArray(tmpIDs) && tmpIDs.length > 0) ? `FBL~${pSide.IDField}~NIN~${this._encodeList(tmpIDs)}` : '';
			};
		}
		// Field decoration (module policy, resolved per entity by the metacontroller): when this side's
		// entity is opted in, the picker offers a ⚙ to pin an extra column onto each row (the "six
		// Volkerts" disambiguation). Caller overrides still win in the Object.assign below.
		if (this.pict.PictSectionRecordSet)
		{
			this.pict.PictSectionRecordSet.applyFieldDecoration(tmpConfig, pSide.Entity);
		}
		return Object.assign(tmpConfig, pOverrides || {});
	}

	/**
	 * Picker config for the OTHER side of an association (the records being associated), culling the
	 * currently-associated ids.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pThisRecordSetName
	 * @param {(() => Array<any>)|false} pGetExcludedIDsFn
	 * @param {Record<string, any>} [pOverrides]
	 * @param {Record<string, any>} [pAnchorContext] - The anchor record context (e.g. `{ ThisID, ThisRecordSet }`),
	 *   passed to a function-form PriorityValues resolver on the other side so a pin can be derived from the anchor.
	 * @return {Record<string, any>|false}
	 */
	buildOtherPickerConfig(pAssociationHash, pThisRecordSetName, pGetExcludedIDsFn, pOverrides, pAnchorContext)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
		if (!tmpSides)
		{
			return false;
		}
		const tmpPriorityContext = Object.assign(
			{ association: tmpSides.association, thisSide: tmpSides.thisSide, otherSide: tmpSides.otherSide },
			pAnchorContext || {});
		return this._pickerConfigForSide(tmpSides.otherSide, pGetExcludedIDsFn, pOverrides, tmpPriorityContext);
	}

	/**
	 * Picker config for the ANCHOR side of an association (the bulk screen's "pick a record to associate
	 * to" control). No cull.
	 *
	 * @param {string} pAssociationHash
	 * @param {string} pAnchorRecordSetName
	 * @param {Record<string, any>} [pOverrides]
	 * @return {Record<string, any>|false}
	 */
	buildAnchorPickerConfig(pAssociationHash, pAnchorRecordSetName, pOverrides)
	{
		const tmpSides = this.resolveSides(pAssociationHash, pAnchorRecordSetName);
		if (!tmpSides)
		{
			return false;
		}
		return this._pickerConfigForSide(tmpSides.thisSide, false, pOverrides);
	}
}

module.exports = PictRecordSetAssociationManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":845}],971:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'RecordSetCardManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	CSS: /*css*/`
	.psrs-card-trigger { display: inline-flex; align-items: center; gap: 0.25rem; cursor: pointer; }
	.psrs-card-trigger-label { text-decoration: underline; text-decoration-style: dotted; text-underline-offset: 0.15em; }
	.psrs-card-trigger:hover .psrs-card-trigger-label { text-decoration-style: solid; color: var(--theme-color-brand-primary, #156dd1); }
	.psrs-card-trigger-icon { display: inline-flex; font-size: 0.82em; color: var(--theme-color-text-muted, #6b7686); }
	.psrs-card-trigger:hover .psrs-card-trigger-icon { color: var(--theme-color-brand-primary, #156dd1); }

	.psrs-card-popover { position: absolute; z-index: 4000; min-width: 16rem; max-width: 22rem; max-height: 70vh; overflow-y: auto;
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
		border-radius: 12px; box-shadow: 0 16px 40px rgba(15, 23, 42, 0.20); padding: 0.95rem 1.05rem;
		opacity: 0; transform: translateY(-4px); transition: opacity 0.12s ease, transform 0.12s ease; pointer-events: none; }
	.psrs-card-popover.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }
	.psrs-card-head { display: flex; align-items: flex-start; gap: 0.7rem; margin: 0 0 0.6rem; }
	.psrs-card-img { flex: 0 0 auto; width: 2.6rem; height: 2.6rem; border-radius: 8px; overflow: hidden;
		background: var(--theme-color-background-tertiary, #f1f3f6); display: flex; align-items: center; justify-content: center; }
	.psrs-card-img img { width: 100%; height: 100%; object-fit: cover; }
	.psrs-card-title { font-size: 1.02rem; font-weight: 700; line-height: 1.2; color: var(--theme-color-text-primary, #1f2733); }
	.psrs-card-subtitle { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 0.1rem; }
	.psrs-card-fields { display: grid; grid-template-columns: auto 1fr; gap: 0.3rem 0.85rem; align-items: baseline; margin: 0.2rem 0 0; }
	.psrs-card-label { font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; }
	.psrs-card-value { font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); word-break: break-word; }
	.psrs-card-bool { display: inline-flex; align-items: center; justify-content: center; width: 1.05rem; height: 1.05rem; border-radius: 4px;
		border: 1.5px solid var(--theme-color-border-default, #c7cdd6); color: #fff; vertical-align: middle; }
	.psrs-card-bool-on { background: var(--theme-color-brand-primary, #156dd1); border-color: var(--theme-color-brand-primary, #156dd1); }
	.psrs-card-bool .pict-icon { font-size: 0.8em; }
	.psrs-card-custom { font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); }
	.psrs-card-actions { display: flex; flex-wrap: wrap; gap: 0.4rem; margin-top: 0.85rem; padding-top: 0.7rem; border-top: 1px solid var(--theme-color-border-light, #eef1f5); }
	.psrs-card-action { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.82rem; font-weight: 600;
		text-decoration: none; padding: 0.3rem 0.7rem; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d7dce3);
		background: var(--theme-color-background-secondary, #f5f6f8); color: var(--theme-color-text-secondary, #45505f); }
	.psrs-card-action:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); }
	.psrs-card-action .pict-icon { font-size: 0.9em; }
	/* Audit stripe — a thin Created/Updated line + ID/GUID copy buttons, shown above the actions when on. */
	.psrs-card-audit { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem 0.8rem; margin-top: 0.7rem; padding-top: 0.55rem;
		border-top: 1px dashed var(--theme-color-border-light, #eef1f5); font-size: 0.7rem; line-height: 1.35; color: var(--theme-color-text-muted, #6b7686); }
	.psrs-card-audit-info { display: flex; flex-wrap: wrap; align-items: center; gap: 0.15rem 0.5rem; }
	.psrs-card-audit-info b { font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
	.psrs-card-audit-sep { opacity: 0.45; }
	.psrs-card-audit-copy { display: inline-flex; gap: 0.3rem; margin-left: auto; }
	.psrs-card-copy { display: inline-flex; align-items: center; gap: 0.2rem; cursor: pointer; font: inherit; font-size: 0.68rem; font-weight: 600;
		border: 1px solid var(--theme-color-border-light, #e1e6ec); border-radius: 6px; padding: 0.08rem 0.4rem;
		background: var(--theme-color-background-secondary, #f5f6f8); color: var(--theme-color-text-muted, #6b7686); }
	.psrs-card-copy:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
	.psrs-card-copy.psrs-card-copied { border-color: #2e9e5b; color: #2e9e5b; }
	.psrs-card-copy .pict-icon { font-size: 0.85em; }
	.psrs-card-audit-toggle { display: inline-flex; align-items: center; gap: 0.3rem; margin-left: auto; font-size: 0.74rem; font-weight: 600;
		color: var(--theme-color-text-muted, #6b7686); cursor: pointer; white-space: nowrap; }
	.psrs-card-audit-toggle input { cursor: pointer; margin: 0; }
	`,
	CSSPriority: 600,
};

/**
 * RecordSetCardManager — a global registry of "record preview cards". A card is a small, meaningful
 * view of one record plus links to its most important actions, defined entirely in CONFIGURATION per
 * recordset (no code). Any list, record view, or dashboard can drop a trigger (`{~RecordCard:~}` tag or
 * `triggerHTML()`); clicking it fetches the record (cached EntityProvider) and shows an anchored popover
 * card next to the trigger.
 *
 * Config shape (registered via settings.RecordCards or registerCard()):
 *   {
 *     Entity: 'Author',                              // Meadow entity to fetch (default: the recordset name)
 *     Title: 'Name',                                 // a field name OR a '{~...~}' template
 *     Subtitle: '{~D:Record.City~}, {~D:Record.Country~}',
 *     Image: 'PhotoURL',                             // optional image field/template
 *     Fields: [ { Label: 'Books', Value: 'BookCount' }, ... ],   // labeled values (field OR template)
 *     Template: '<custom markup with {~D:Record.X~}>',          // alternative to Fields (full control)
 *     Actions: [ { Label:'View', Icon:'Eye', Route:'#/PSRS/Author/View/{~D:Record.GUIDAuthor~}' },
 *                { Label:'Download', Icon:'Download', URL:'{~D:Record.FileURL~}' } ]   // Route | URL | Handler
 *   }
 */
class RecordSetCardManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// recordset name -> normalized card config
		this._cards = {};
		this._popoverElementID = 'PSRS-RecordCard-Popover';
		this._dismissBound = false;
		this._openForKey = null;

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('PSRS-RecordCard-CSS', this.options.CSS, this.options.CSSPriority);
		}
	}

	/**
	 * Register a card layout for a recordset. Pre-compiles the config into a pict template so render is a
	 * single parseTemplateByHash against the fetched record.
	 * @param {String} pRecordSetName
	 * @param {Object} pCardConfig
	 */
	registerCard(pRecordSetName, pCardConfig)
	{
		if (!pRecordSetName || !pCardConfig || (typeof pCardConfig !== 'object'))
		{
			this.log.warn(`RecordSetCardManager: ignoring invalid card config for [${pRecordSetName}].`);
			return;
		}
		const tmpConfig =
		{
			Entity: pCardConfig.Entity || pRecordSetName,
			IDField: pCardConfig.IDField || `ID${pRecordSetName}`,
			GUIDField: pCardConfig.GUIDField || `GUID${pCardConfig.Entity || pRecordSetName}`,
			TemplateHash: `PSRS-RecordCard-${pRecordSetName}`,
			Config: pCardConfig,
		};
		this._cards[pRecordSetName] = tmpConfig;
		this.pict.TemplateProvider.addTemplate(tmpConfig.TemplateHash, this._buildCardTemplate(pCardConfig));
	}

	hasCard(pRecordSetName)
	{
		return !!this._cards[pRecordSetName];
	}

	/** A config value is a field name unless it already contains a template expression. */
	_valueTemplate(pValue)
	{
		if (pValue == null) { return ''; }
		const tmpValue = String(pValue);
		return (tmpValue.indexOf('{~') !== -1) ? tmpValue : `{~D:Record.${tmpValue}~}`;
	}

	/** Compile a card config into a pict template string (resolved against the record at render time). */
	_buildCardTemplate(pConfig)
	{
		let tmpHead = '<div class="psrs-card-head">';
		if (pConfig.Image)
		{
			tmpHead += `<div class="psrs-card-img"><img src="${this._valueTemplate(pConfig.Image)}" alt="" /></div>`;
		}
		tmpHead += `<div><div class="psrs-card-title">${this._valueTemplate(pConfig.Title || `ID${''}`)}</div>`;
		if (pConfig.Subtitle)
		{
			tmpHead += `<div class="psrs-card-subtitle">${this._valueTemplate(pConfig.Subtitle)}</div>`;
		}
		tmpHead += '</div></div>';

		let tmpBody = '';
		if (pConfig.Template)
		{
			tmpBody = `<div class="psrs-card-custom">${pConfig.Template}</div>`;
		}
		else if (Array.isArray(pConfig.Fields) && (pConfig.Fields.length > 0))
		{
			tmpBody = '<div class="psrs-card-fields">';
			pConfig.Fields.forEach((pField) =>
			{
				tmpBody += `<span class="psrs-card-label">${pField.Label || ''}</span><span class="psrs-card-value">${this._valueTemplate(pField.Value)}</span>`;
			});
			tmpBody += '</div>';
		}

		let tmpActions = '';
		if (Array.isArray(pConfig.Actions) && (pConfig.Actions.length > 0))
		{
			tmpActions = '<div class="psrs-card-actions">';
			pConfig.Actions.forEach((pAction) =>
			{
				const tmpIcon = pAction.Icon ? `<span class="psrs-card-action-icon">{~I:${pAction.Icon}~}</span>` : '';
				const tmpLabel = `${tmpIcon}<span>${pAction.Label || 'Open'}</span>`;
				if (pAction.URL)
				{
					tmpActions += `<a class="psrs-card-action" href="${this._valueTemplate(pAction.URL)}" target="_blank" rel="noopener" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
				}
				else if (pAction.Route)
				{
					tmpActions += `<a class="psrs-card-action" href="${this._valueTemplate(pAction.Route)}" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
				}
				else if (pAction.Handler)
				{
					tmpActions += `<button type="button" class="psrs-card-action" onclick="_Pict.providers.RecordSetCardManager.closeCard(); ${pAction.Handler}">${tmpLabel}</button>`;
				}
			});
			tmpActions += '</div>';
		}

		return `<div class="psrs-card">${tmpHead}${tmpBody}${tmpActions}</div>`;
	}

	// --- Trigger HTML (used by the {~RecordCard:~} template tag and by callers directly) ---

	/**
	 * The clickable inline trigger: a label + a small preview icon. Degrades to plain text when no card is
	 * registered for the recordset.
	 * @param {String} pRecordSetName
	 * @param {String|Number} pID
	 * @param {String} pLabel
	 * @return {String}
	 */
	triggerHTML(pRecordSetName, pID, pLabel)
	{
		const tmpLabel = (pLabel == null) ? '' : String(pLabel);
		if (!this.hasCard(pRecordSetName) || pID == null || pID === '')
		{
			return tmpLabel;
		}
		const tmpIcon = (typeof this.pict.icon === 'function') ? this.pict.icon('Info', { ariaLabel: 'Preview' }) : '';
		const tmpSafeID = String(pID).replace(/'/g, '');
		return `<span class="psrs-card-trigger" onclick="event.stopPropagation();_Pict.providers.RecordSetCardManager.openCard('${pRecordSetName}','${tmpSafeID}',this)">`
			+ `<span class="psrs-card-trigger-label">${tmpLabel}</span><span class="psrs-card-trigger-icon">${tmpIcon}</span></span>`;
	}

	// --- Open / render / position ---

	/**
	 * Open the preview card for a record next to an anchor element. The record is fetched through the
	 * cached EntityProvider unless a full record object is passed.
	 * @param {String} pRecordSetName
	 * @param {String|Number|Object} pIDOrRecord
	 * @param {HTMLElement} pAnchorElement
	 */
	openCard(pRecordSetName, pIDOrRecord, pAnchorElement, pOptions)
	{
		const tmpOptions = pOptions || {};
		// A registered card, or a synthesized default card so any entity gets a preview (rich callers).
		let tmpCard = this._cards[pRecordSetName];
		if (!tmpCard) { tmpCard = this._defaultCard(pRecordSetName, tmpOptions); }
		if (!tmpCard) { return; }

		const tmpKeyID = (pIDOrRecord && (typeof pIDOrRecord === 'object'))
			? ((pIDOrRecord[tmpCard.IDField] != null) ? pIDOrRecord[tmpCard.IDField] : '')
			: pIDOrRecord;
		const tmpKey = `${pRecordSetName}:${tmpKeyID}`;
		if (this._openForKey === tmpKey && this._isOpen())
		{
			this.closeCard();
			return;
		}

		// The audit stripe + the "more data" body both need the FULL record (the explorer passes only the few
		// Lite columns). Only RICH cards render those, so only rich cards fetch — a normal recordset card keeps
		// its exact existing behavior (no extra fetch) even when the global audit toggle is on.
		const tmpWantFull = !!tmpOptions.Rich;
		if (pIDOrRecord && (typeof pIDOrRecord === 'object'))
		{
			const tmpID = pIDOrRecord[tmpCard.IDField];
			if (tmpWantFull && (tmpID != null) && this.pict.EntityProvider)
			{
				return this._fetchAndShow(tmpCard, tmpID, pAnchorElement, tmpKey, tmpOptions, pIDOrRecord);
			}
			return this._renderAndShow(tmpCard, pIDOrRecord, pAnchorElement, tmpKey, tmpOptions);
		}
		if (!this.pict.EntityProvider) { return; }
		return this._fetchAndShow(tmpCard, pIDOrRecord, pAnchorElement, tmpKey, tmpOptions, null);
	}

	/** Fetch the full record (and, when the audit stripe is on, its creating/updating user names) then show. */
	_fetchAndShow(pCard, pID, pAnchorElement, pKey, pOptions, pFallbackRecord)
	{
		this.pict.EntityProvider.getEntity(pCard.Entity, pID, (pError, pRecord) =>
		{
			const tmpRecord = (pError || !pRecord) ? pFallbackRecord : pRecord;
			if (!tmpRecord)
			{
				this.log.warn(`RecordSetCardManager: could not load ${pCard.Entity} ${pID} for its preview card.`, pError);
				return;
			}
			const fRender = () =>
			{
				if (this.getAuditEnabled())
				{
					return this._resolveAuditUsers(tmpRecord, () => this._renderAndShow(pCard, tmpRecord, pAnchorElement, pKey, pOptions));
				}
				return this._renderAndShow(pCard, tmpRecord, pAnchorElement, pKey, pOptions);
			};
			// Rich cards checkbox-render schema booleans → ensure the entity's (cached) schema first.
			if (pOptions && pOptions.Rich) { return this._ensureSchema(pCard.Entity, fRender); }
			return fRender();
		});
	}

	/**
	 * Resolve + cache the set of BOOLEAN columns for an entity (so rich cards show 0/1 bits as checkboxes).
	 * Uses the host-supplied `SchemaSource(entity, cb) -> (err, schema)` — meadow JSON-schema (`properties[].type`)
	 * or Stricture (`Columns[].DataType`). No source / fetch failure → no booleans (values render verbatim).
	 */
	_ensureSchema(pEntity, fComplete)
	{
		if (!this._schemaBooleans) { this._schemaBooleans = {}; }
		if (this._schemaBooleans[pEntity]) { return fComplete(); }
		if (typeof this.SchemaSource !== 'function') { this._schemaBooleans[pEntity] = {}; return fComplete(); }
		let tmpSettled = false;
		const fDone = (pSchema) =>
		{
			if (tmpSettled) { return; }
			tmpSettled = true;
			const tmpBooleans = {};
			if (pSchema && pSchema.properties)
			{
				Object.keys(pSchema.properties).forEach((pKey) => { if (pSchema.properties[pKey] && (pSchema.properties[pKey].type === 'boolean')) { tmpBooleans[pKey] = true; } });
			}
			else if (pSchema && Array.isArray(pSchema.Columns))
			{
				pSchema.Columns.forEach((pColumn) => { if (pColumn && (pColumn.DataType === 'Boolean')) { tmpBooleans[pColumn.Column] = true; } });
			}
			this._schemaBooleans[pEntity] = tmpBooleans;
			fComplete();
		};
		try { this.SchemaSource(pEntity, (pError, pSchema) => fDone(pError ? null : pSchema)); }
		catch (pError) { fDone(null); }
	}

	/** Synthesize a card for an entity that has none registered, so every record still gets a preview. */
	_defaultCard(pRecordSetName, pOptions)
	{
		const tmpEntityConfig = (pOptions && pOptions.EntityConfig) || {};
		const tmpEntity = tmpEntityConfig.Entity || pRecordSetName;
		return {
			Entity: tmpEntity,
			IDField: tmpEntityConfig.IDField || `ID${pRecordSetName}`,
			GUIDField: tmpEntityConfig.GUIDField || `GUID${tmpEntity}`,
			TemplateHash: null,   // no pre-compiled template — default cards always render the rich (dynamic) body
			Config: { _Default: true, Title: (tmpEntityConfig.Display && tmpEntityConfig.Display.Title) || null, Actions: [] },
		};
	}

	/** Resolve creating/updating user display names onto the record (cached lookups) before a sync render. */
	_resolveAuditUsers(pRecord, fComplete)
	{
		const tmpEntityProvider = this.pict.EntityProvider;
		if (!tmpEntityProvider || (typeof tmpEntityProvider.getEntity !== 'function')) { return fComplete(); }
		const tmpJobs = [];
		if (pRecord.CreatingIDUser) { tmpJobs.push({ Field: 'CreatingUserName', ID: pRecord.CreatingIDUser }); }
		if (pRecord.UpdatingIDUser) { tmpJobs.push({ Field: 'UpdatingUserName', ID: pRecord.UpdatingIDUser }); }
		if (tmpJobs.length < 1) { return fComplete(); }
		let tmpPending = tmpJobs.length;
		tmpJobs.forEach((pJob) =>
		{
			tmpEntityProvider.getEntity('User', pJob.ID, (pError, pUser) =>
			{
				if (!pError && pUser)
				{
					pRecord[pJob.Field] = [ pUser.NameFirst, pUser.NameLast ].filter((pPart) => (typeof pPart === 'string') && pPart.trim().length > 0).join(' ')
						|| pUser.FullName || pUser.Name || pUser.LoginID || `User ${pJob.ID}`;
				}
				tmpPending--;
				if (tmpPending <= 0) { fComplete(); }
			});
		});
	}

	_renderAndShow(pCard, pRecord, pAnchorElement, pKey, pOptions)
	{
		const tmpOptions = pOptions || {};
		// A default card (no pre-compiled template) or a rich caller renders the dynamic body (all columns +
		// audit stripe). Otherwise the existing pre-compiled card template renders verbatim (no behavior change).
		const tmpRich = !!tmpOptions.Rich || !pCard.TemplateHash;
		let tmpHTML = '';
		if (!tmpRich)
		{
			// Cards use synchronous template tags ({~D:~}, {~I:~}, formatters) so a sync parse is correct and
			// avoids a flash; the record is already in hand here.
			try { tmpHTML = this.pict.parseTemplateByHash(pCard.TemplateHash, pRecord); }
			catch (pError) { this.log.error(`RecordSetCardManager: card render failed for ${pCard.TemplateHash}.`, pError); return; }
		}
		else
		{
			tmpHTML = this._buildRichCardHTML(pCard, pRecord, tmpOptions);
		}
		const tmpPopover = this._ensurePopover();
		if (!tmpPopover) { return; }
		tmpPopover.innerHTML = tmpHTML;
		if (!tmpRich)
		{
			// Drop any field whose value rendered empty so a card never shows a "LABEL: (blank)" row — the
			// configured Fields are static, but which ones have data varies per record. (The rich body skips
			// empties as it builds, so this only applies to the pre-compiled path.)
			const tmpValueCells = tmpPopover.querySelectorAll('.psrs-card-fields .psrs-card-value');
			for (let i = 0; i < tmpValueCells.length; i++)
			{
				if (String(tmpValueCells[i].textContent || '').trim() !== '') { continue; }
				const tmpLabelCell = tmpValueCells[i].previousElementSibling;
				if (tmpLabelCell && tmpLabelCell.classList.contains('psrs-card-label')) { tmpLabelCell.remove(); }
				tmpValueCells[i].remove();
			}
			const tmpFieldsBox = tmpPopover.querySelector('.psrs-card-fields');
			if (tmpFieldsBox && (tmpFieldsBox.children.length === 0)) { tmpFieldsBox.remove(); }
		}
		this.pict.CSSMap.injectCSS();
		this._openForKey = pKey;
		this._lastShow = { Card: pCard, Record: pRecord, Anchor: pAnchorElement, Key: pKey, Options: tmpOptions };   // for the audit re-render
		this._position(tmpPopover, pAnchorElement);
		tmpPopover.classList.add('is-open');
		this._bindDismiss();
	}

	// --- Rich card body (all columns + audit stripe) + the audit/copy actions ---

	/** Build the dynamic card HTML: head + all meaningful columns + (when on) the audit stripe + actions. */
	_buildRichCardHTML(pCard, pRecord, pOptions)
	{
		const tmpConfig = pCard.Config || {};
		const tmpTitle = (tmpConfig.Title ? this._resolveText(tmpConfig.Title, pRecord) : '') || this._deriveTitle(pRecord, pCard);
		let tmpHead = `<div class="psrs-card-head"><div><div class="psrs-card-title">${this._escapeHTML(tmpTitle)}</div>`;
		const tmpSubtitle = tmpConfig.Subtitle ? this._resolveText(tmpConfig.Subtitle, pRecord) : '';
		if (tmpSubtitle) { tmpHead += `<div class="psrs-card-subtitle">${this._escapeHTML(tmpSubtitle)}</div>`; }
		tmpHead += '</div></div>';

		// Skip the field the title already shows, so the body doesn't repeat it as a "Name: …" row.
		let tmpSkipField = null;
		if (tmpConfig.Title && (String(tmpConfig.Title).indexOf('{~') < 0)) { tmpSkipField = tmpConfig.Title; }
		else if (!tmpConfig.Title && pRecord.Name) { tmpSkipField = 'Name'; }
		let tmpBody = '';
		const tmpBooleanFields = (this._schemaBooleans && this._schemaBooleans[pCard.Entity]) || {};
		const tmpFields = this._richFields(pRecord, tmpSkipField, tmpBooleanFields);
		if (tmpFields.length > 0)
		{
			tmpBody = '<div class="psrs-card-fields">';
			tmpFields.forEach((pField) =>
			{
				const tmpValueCell = pField.IsBoolean ? this._boolHTML(pField.BoolOn) : this._escapeHTML(pField.Value);
				tmpBody += `<span class="psrs-card-label">${this._escapeHTML(pField.Label)}</span><span class="psrs-card-value">${tmpValueCell}</span>`;
			});
			tmpBody += '</div>';
		}

		const tmpAudit = this.getAuditEnabled() ? this._auditStripeHTML(pCard, pRecord) : '';
		const tmpActions = this._richActionsHTML(tmpConfig, pRecord, pOptions);
		return `<div class="psrs-card">${tmpHead}${tmpBody}${tmpAudit}${tmpActions}</div>`;
	}

	/** Every real data column (skipping id/guid — surfaced via copy buttons — audit, nulls + objects). */
	_richFields(pRecord, pSkipField, pBooleanFields)
	{
		const tmpBooleans = pBooleanFields || {};
		const tmpFields = [];
		Object.keys(pRecord || {}).forEach((pKey) =>
		{
			if (pKey === pSkipField) { return; }
			if (/^(ID|GUID)/.test(pKey)) { return; }
			if (/^(CreateDate|UpdateDate|CreatingIDUser|UpdatingIDUser|DeletingIDUser|DeleteDate|Deleted|CreatingUserName|UpdatingUserName)$/.test(pKey)) { return; }
			const tmpValue = pRecord[pKey];
			if ((tmpValue == null) || (tmpValue === '') || (typeof tmpValue === 'object')) { return; }
			// Schema booleans render as a checkbox glyph, not their raw 0/1.
			if (tmpBooleans[pKey])
			{
				tmpFields.push({ Label: this._humanizeLabel(pKey), IsBoolean: true, BoolOn: ((tmpValue === 1) || (tmpValue === '1') || (tmpValue === true) || (String(tmpValue).toLowerCase() === 'true')) });
				return;
			}
			let tmpDisplay = String(tmpValue);
			// Hide values that are only null/undefined tokens (e.g. a "null null" address from concatenated
			// empty parts) — they shouldn't reach the user looking like broken software.
			if (/^(null|undefined|nan)(\s+(null|undefined|nan))*$/i.test(tmpDisplay.trim())) { return; }
			// Humanize ISO timestamps instead of dumping the raw `2026-06-21T05:47:01.000Z`.
			if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(tmpDisplay)) { tmpDisplay = this._fmtDate(tmpDisplay); }
			tmpFields.push({ Label: this._humanizeLabel(pKey), Value: tmpDisplay });
		});
		return tmpFields;
	}

	/** A checkbox glyph for a schema-boolean value — filled when on, an empty box when off. */
	_boolHTML(pOn)
	{
		const tmpCheck = (pOn && (typeof this.pict.icon === 'function')) ? this.pict.icon('Check') : '';
		return `<span class="psrs-card-bool${pOn ? ' psrs-card-bool-on' : ''}">${pOn ? tmpCheck : ''}</span>`;
	}

	/** The thin audit stripe: Created/Updated date + user, plus ID/GUID copy buttons (value shown on hover). */
	_auditStripeHTML(pCard, pRecord)
	{
		const tmpInfo = [];
		if (pRecord.CreateDate) { tmpInfo.push(`<span>Created <b>${this._escapeHTML(this._fmtDate(pRecord.CreateDate))}</b>${pRecord.CreatingUserName ? ` by <b>${this._escapeHTML(pRecord.CreatingUserName)}</b>` : ''}</span>`); }
		if (pRecord.UpdateDate) { tmpInfo.push(`<span>Updated <b>${this._escapeHTML(this._fmtDate(pRecord.UpdateDate))}</b>${pRecord.UpdatingUserName ? ` by <b>${this._escapeHTML(pRecord.UpdatingUserName)}</b>` : ''}</span>`); }
		const tmpIcon = (typeof this.pict.icon === 'function') ? this.pict.icon('Copy') : '';
		let tmpCopies = '';
		const tmpID = pRecord[pCard.IDField];
		const tmpGUID = pRecord[pCard.GUIDField];
		if ((tmpID != null) && (tmpID !== '')) { tmpCopies += this._copyButtonHTML('ID', tmpID, tmpIcon); }
		if (tmpGUID) { tmpCopies += this._copyButtonHTML('GUID', tmpGUID, tmpIcon); }
		if ((tmpInfo.length < 1) && !tmpCopies) { return ''; }
		return `<div class="psrs-card-audit"><div class="psrs-card-audit-info">${tmpInfo.join('<span class="psrs-card-audit-sep">·</span>')}</div>`
			+ `<div class="psrs-card-audit-copy">${tmpCopies}</div></div>`;
	}

	_copyButtonHTML(pLabel, pValue, pIcon)
	{
		const tmpValue = this._escapeAttribute(String(pValue));
		return `<button type="button" class="psrs-card-copy" title="${tmpValue}" data-copy="${tmpValue}" onclick="event.stopPropagation();_Pict.providers.RecordSetCardManager.copyValue(this.getAttribute('data-copy'),this)">${pIcon}<span>${this._escapeHTML(pLabel)}</span></button>`;
	}

	/** The card's configured actions (View, …) + the global Audit toggle pushed to the right. */
	_richActionsHTML(pConfig, pRecord, pOptions)
	{
		let tmpActions = '';
		(Array.isArray(pConfig.Actions) ? pConfig.Actions : []).forEach((pAction) => { tmpActions += this._actionHTML(pAction, pRecord); });
		const tmpAuditToggle = (pOptions && (pOptions.Audit === false)) ? ''
			: `<label class="psrs-card-audit-toggle"><input type="checkbox" ${this.getAuditEnabled() ? 'checked ' : ''}onclick="event.stopPropagation();_Pict.providers.RecordSetCardManager.toggleAudit()" /><span>Audit</span></label>`;
		if (!tmpActions && !tmpAuditToggle) { return ''; }
		return `<div class="psrs-card-actions">${tmpActions}${tmpAuditToggle}</div>`;
	}

	/** Build one action anchor/button, resolving its Route/URL template + icon against the record. */
	_actionHTML(pAction, pRecord)
	{
		const tmpIcon = (pAction.Icon && (typeof this.pict.icon === 'function')) ? this.pict.icon(pAction.Icon) : '';
		const tmpLabel = `${tmpIcon}<span>${this._escapeHTML(pAction.Label || 'Open')}</span>`;
		if (pAction.URL)
		{
			return `<a class="psrs-card-action" href="${this._escapeAttribute(this._resolveText(pAction.URL, pRecord))}" target="_blank" rel="noopener" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
		}
		if (pAction.Route)
		{
			return `<a class="psrs-card-action" href="${this._escapeAttribute(this._resolveText(pAction.Route, pRecord))}" onclick="_Pict.providers.RecordSetCardManager.closeCard()">${tmpLabel}</a>`;
		}
		if (pAction.Handler)
		{
			return `<button type="button" class="psrs-card-action" onclick="_Pict.providers.RecordSetCardManager.closeCard(); ${pAction.Handler}">${tmpLabel}</button>`;
		}
		return '';
	}

	/** Resolve a field-name-or-template config value against a record into a plain string. */
	_resolveText(pValue, pRecord)
	{
		try { return this.pict.parseTemplate(this._valueTemplate(pValue), pRecord); }
		catch (pError) { return ''; }
	}

	_deriveTitle(pRecord, pCard)
	{
		return pRecord.Name || pRecord.Title || pRecord.DisplayName
			|| `${pCard.Entity} #${(pRecord[pCard.IDField] != null) ? pRecord[pCard.IDField] : ''}`;
	}

	/** `MaterialCode` → `Material Code`, `mix_id` → `mix id`. */
	_humanizeLabel(pKey)
	{
		return String(pKey).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
	}

	/** Human-readable date — `Jun 21, 2026 05:47` (or `Jun 21, 2026` with no time) from an ISO string. */
	_fmtDate(pDate)
	{
		const tmpString = String((pDate == null) ? '' : pDate);
		const tmpMatch = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(tmpString);
		if (!tmpMatch) { return tmpString; }
		const tmpMonths = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
		const tmpMonth = tmpMonths[parseInt(tmpMatch[2], 10) - 1] || tmpMatch[2];
		let tmpResult = `${tmpMonth} ${parseInt(tmpMatch[3], 10)}, ${tmpMatch[1]}`;
		if (tmpMatch[4]) { tmpResult += ` ${tmpMatch[4]}:${tmpMatch[5]}`; }
		return tmpResult;
	}

	_escapeHTML(pValue)
	{
		return String((pValue == null) ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	_escapeAttribute(pValue)
	{
		return String((pValue == null) ? '' : pValue).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	// --- Audit toggle (global, persisted) + clipboard copy ---

	/** Whether the audit stripe is globally enabled (localStorage, with an in-memory fallback). */
	getAuditEnabled()
	{
		try
		{
			if (typeof window !== 'undefined' && window.localStorage) { return window.localStorage.getItem('RecordSetCardManager.AuditStripe') === 'true'; }
		}
		catch (pError) { /* fall through to the in-memory copy */ }
		return !!this._auditEnabled;
	}

	setAuditEnabled(pEnabled)
	{
		this._auditEnabled = !!pEnabled;
		try
		{
			if (typeof window !== 'undefined' && window.localStorage) { window.localStorage.setItem('RecordSetCardManager.AuditStripe', String(!!pEnabled)); }
		}
		catch (pError) { /* in-memory only */ }
	}

	/** Flip the global audit setting and repaint the open card so its stripe shows/hides immediately. */
	toggleAudit()
	{
		this.setAuditEnabled(!this.getAuditEnabled());
		if (!this._lastShow) { return; }
		const tmpLast = this._lastShow;
		if (this.getAuditEnabled())
		{
			return this._resolveAuditUsers(tmpLast.Record, () => this._renderAndShow(tmpLast.Card, tmpLast.Record, tmpLast.Anchor, tmpLast.Key, tmpLast.Options));
		}
		return this._renderAndShow(tmpLast.Card, tmpLast.Record, tmpLast.Anchor, tmpLast.Key, tmpLast.Options);
	}

	/** Copy a value (an ID / GUID) to the clipboard with a brief confirmation on the button. */
	copyValue(pValue, pButton)
	{
		try
		{
			if ((typeof navigator !== 'undefined') && navigator.clipboard && (typeof navigator.clipboard.writeText === 'function'))
			{
				navigator.clipboard.writeText(String((pValue == null) ? '' : pValue));
			}
		}
		catch (pError) { /* clipboard unavailable */ }
		if (pButton && pButton.classList)
		{
			pButton.classList.add('psrs-card-copied');
			setTimeout(() => { if (pButton.classList) { pButton.classList.remove('psrs-card-copied'); } }, 1100);
		}
	}

	_ensurePopover()
	{
		if (typeof document === 'undefined') { return null; }
		let tmpPopover = document.getElementById(this._popoverElementID);
		if (!tmpPopover)
		{
			tmpPopover = document.createElement('div');
			tmpPopover.id = this._popoverElementID;
			tmpPopover.className = 'psrs-card-popover';
			document.body.appendChild(tmpPopover);
		}
		return tmpPopover;
	}

	/** Anchor the popover under the trigger, flipping above / clamping horizontally near the viewport edge. */
	_position(pPopover, pAnchorElement)
	{
		if (!pAnchorElement || (typeof pAnchorElement.getBoundingClientRect !== 'function')) { return; }
		const tmpRect = pAnchorElement.getBoundingClientRect();
		// Measure with the card laid out but invisible.
		pPopover.style.top = '-9999px';
		pPopover.style.left = '0px';
		const tmpWidth = pPopover.offsetWidth;
		const tmpHeight = pPopover.offsetHeight;
		const tmpScrollX = window.scrollX || window.pageXOffset || 0;
		const tmpScrollY = window.scrollY || window.pageYOffset || 0;
		const tmpGap = 6;

		let tmpLeft = tmpRect.left + tmpScrollX;
		const tmpMaxLeft = tmpScrollX + window.innerWidth - tmpWidth - 8;
		if (tmpLeft > tmpMaxLeft) { tmpLeft = Math.max(tmpScrollX + 8, tmpMaxLeft); }

		let tmpTop = tmpRect.bottom + tmpScrollY + tmpGap;
		// Flip above when there's not enough room below.
		if ((tmpRect.bottom + tmpHeight + tmpGap > window.innerHeight) && (tmpRect.top - tmpHeight - tmpGap > 0))
		{
			tmpTop = tmpRect.top + tmpScrollY - tmpHeight - tmpGap;
		}
		// Clamp vertically so a tall (rich) card never runs off-screen — it scrolls internally past max-height.
		const tmpBottomLimit = tmpScrollY + window.innerHeight - 8;
		if (tmpTop + tmpHeight > tmpBottomLimit) { tmpTop = Math.max(tmpScrollY + 8, tmpBottomLimit - tmpHeight); }
		pPopover.style.left = `${Math.round(tmpLeft)}px`;
		pPopover.style.top = `${Math.round(tmpTop)}px`;
	}

	_isOpen()
	{
		const tmpPopover = (typeof document !== 'undefined') ? document.getElementById(this._popoverElementID) : null;
		return !!(tmpPopover && tmpPopover.classList.contains('is-open'));
	}

	closeCard()
	{
		const tmpPopover = (typeof document !== 'undefined') ? document.getElementById(this._popoverElementID) : null;
		if (tmpPopover) { tmpPopover.classList.remove('is-open'); }
		this._openForKey = null;
	}

	/**
	 * One-time document handlers that dismiss the card on an outside click or Escape. Browser-level events
	 * with no inline-handler equivalent — bound once, guarded so they never stack.
	 */
	_bindDismiss()
	{
		if (this._dismissBound || (typeof document === 'undefined')) { return; }
		this._dismissBound = true;
		document.addEventListener('click', (pEvent) =>
		{
			if (!this._isOpen()) { return; }
			const tmpPopover = document.getElementById(this._popoverElementID);
			if (tmpPopover && tmpPopover.contains(pEvent.target)) { return; }
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('.psrs-card-trigger')) { return; }
			this.closeCard();
		});
		document.addEventListener('keydown', (pEvent) =>
		{
			if ((pEvent.key === 'Escape') && this._isOpen()) { this.closeCard(); }
		});
	}
}

module.exports = RecordSetCardManager;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-provider":845}],972:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-DependentManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

/**
 * Registry + data layer for ONE-TO-MANY dependents: child entities that carry a foreign-key column
 * pointing back at a recordset's id (e.g. a `Sample` row with an `IDItem` column pointing at the `Item`
 * it belongs to). This is the one-to-many counterpart to the many-to-many `RecordSetAssociationManager`,
 * and it exists for reassociation-on-delete: when a duplicate parent record is deleted, its dependent
 * children are repointed to a replacement parent FIRST so they are never orphaned.
 *
 * Declared per recordset via `RecordSetDependents: [{ Entity, FKField, Title?, DisplayField?, SearchFields?,
 * ChildIDField?, URLPrefix? }]` and registered by the metacontroller. All reads/writes flow through the
 * shared, cached `pict.EntityProvider` (the same one associations + the recordset providers use).
 */
class PictRecordSetDependentManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.pict;

		/** @type {Record<string, Array<Record<string, any>>>} - Normalized dependents keyed by recordset name. */
		this.dependents = {};

		/** @type {Record<string, any>} - Lazily-created EntityProviders scoped to a non-default URL prefix. */
		this._scopedEntityProviders = {};

		/** @type {string} - EntityProvider cache scope for dependent-list reads; cleared after every repoint. */
		this._cacheScope = 'RecordSetDependent';
	}

	/**
	 * The EntityProvider for a URL prefix — the shared cached one for the default prefix, else a lazily
	 * created prefix-scoped instance (mirrors the association manager + recordset provider).
	 * @param {string} [pURLPrefix]
	 * @return {any}
	 */
	_entityProvider(pURLPrefix)
	{
		if (!pURLPrefix)
		{
			return this.pict.EntityProvider;
		}
		if (!this._scopedEntityProviders[pURLPrefix])
		{
			const tmpProvider = this.pict.instantiateServiceProviderWithoutRegistration('EntityProvider');
			tmpProvider.options.urlPrefix = pURLPrefix;
			this._scopedEntityProviders[pURLPrefix] = tmpProvider;
		}
		return this._scopedEntityProviders[pURLPrefix];
	}

	/**
	 * Invalidate the cached dependent-list reads after a write so a subsequent list reflects it immediately.
	 * @param {Record<string, any>} pEntityProvider
	 */
	_clearDependentCache(pEntityProvider)
	{
		try
		{
			if (pEntityProvider && (typeof pEntityProvider.clearScope === 'function'))
			{
				pEntityProvider.clearScope(this._cacheScope);
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`DependentManager: dependent cache clear failed: ${pError.message || pError}`);
		}
	}

	/**
	 * Normalize one dependent definition, filling the light-config defaults: `ChildIDField` falls back to
	 * `ID<Entity>`, `DisplayField` to `Name`, `SearchFields` to `[DisplayField]`, `Title` to `Entity`.
	 *
	 * @param {Record<string, any>} pDependent
	 * @return {Record<string, any>|false} The normalized dependent, or false when it is missing Entity/FKField.
	 */
	_normalizeDependent(pDependent)
	{
		if (!pDependent || !pDependent.Entity || !pDependent.FKField)
		{
			return false;
		}
		const tmpDisplayField = pDependent.DisplayField || 'Name';
		return {
			Entity: pDependent.Entity,
			// The column on the CHILD entity that references this recordset's id (e.g. Sample.IDItem).
			FKField: pDependent.FKField,
			// The child's own identity column, needed to address it on update. Defaults to ID<Entity>.
			ChildIDField: pDependent.ChildIDField || `ID${pDependent.Entity}`,
			DisplayField: tmpDisplayField,
			SearchFields: (Array.isArray(pDependent.SearchFields) && pDependent.SearchFields.length > 0) ? pDependent.SearchFields : [ tmpDisplayField ],
			Title: pDependent.Title || pDependent.Entity,
			URLPrefix: pDependent.URLPrefix || '',
		};
	}

	/**
	 * Register the one-to-many dependents for a recordset (replaces any previously registered set).
	 *
	 * @param {string} pRecordSetName
	 * @param {Array<Record<string, any>>} pDependents
	 * @return {Array<Record<string, any>>} The normalized, registered dependents.
	 */
	addDependents(pRecordSetName, pDependents)
	{
		if (!pRecordSetName || !Array.isArray(pDependents))
		{
			this.pict.log.error(`DependentManager: addDependents called with invalid arguments for [${pRecordSetName}].`, pDependents);
			return [];
		}
		const tmpNormalized = [];
		for (let i = 0; i < pDependents.length; i++)
		{
			const tmpDependent = this._normalizeDependent(pDependents[i]);
			if (!tmpDependent)
			{
				this.pict.log.error(`DependentManager: skipping invalid dependent (needs Entity + FKField) for [${pRecordSetName}].`, pDependents[i]);
				continue;
			}
			tmpNormalized.push(tmpDependent);
		}
		this.dependents[pRecordSetName] = tmpNormalized;
		return tmpNormalized;
	}

	/**
	 * The normalized dependents registered for a recordset (empty when none).
	 * @param {string} pRecordSetName
	 * @return {Array<Record<string, any>>}
	 */
	getDependentsForRecordSet(pRecordSetName)
	{
		return Array.isArray(this.dependents[pRecordSetName]) ? this.dependents[pRecordSetName] : [];
	}

	/**
	 * Fetch the child records currently pointing at an id through a dependent's FK column.
	 *
	 * @param {Record<string, any>} pDependent - a normalized dependent.
	 * @param {string|number} pParentID
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	listDependentRecords(pDependent, pParentID)
	{
		if (!pDependent || pParentID === undefined || pParentID === null || pParentID === '')
		{
			return Promise.resolve([]);
		}
		const tmpEntityProvider = this._entityProvider(pDependent.URLPrefix);
		const tmpFilter = `FBV~${pDependent.FKField}~EQ~${encodeURIComponent(pParentID)}`;
		return new Promise((resolve) =>
		{
			tmpEntityProvider.getEntitySet(pDependent.Entity, tmpFilter, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`DependentManager: failed to list ${pDependent.Entity} for ${pDependent.FKField}=${pParentID}.`, pError);
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, '', { Scope: this._cacheScope, NoCount: true });
		});
	}

	/**
	 * Repoint every child of `pFromID` (through the dependent's FK column) to `pToID` — the one-to-many
	 * half of reassociation-on-delete. Each child gets a MINIMAL update (`{ childID, FKField: toID }`);
	 * this relies on Meadow-endpoints treating a partial body as a partial update, the same assumption the
	 * association manager's `updateJoin` makes. No dedup is needed — a foreign key simply repoints.
	 *
	 * @param {Record<string, any>} pDependent - a normalized dependent.
	 * @param {string|number} pFromID
	 * @param {string|number} pToID
	 * @return {Promise<{ repointed: number, failed: number }>}
	 */
	async repointDependent(pDependent, pFromID, pToID)
	{
		const tmpResult = { repointed: 0, failed: 0 };
		if (!pDependent || pFromID === undefined || pFromID === null || pFromID === '' || pToID === undefined || pToID === null || pToID === '')
		{
			return tmpResult;
		}
		// Self-repoint is a no-op (and a later delete of pFromID would then strand the children we "kept").
		if (String(pFromID) === String(pToID))
		{
			return tmpResult;
		}
		const tmpEntityProvider = this._entityProvider(pDependent.URLPrefix);
		const tmpChildren = await this.listDependentRecords(pDependent, pFromID);
		for (let i = 0; i < tmpChildren.length; i++)
		{
			const tmpChild = tmpChildren[i];
			const tmpUpdate = { [pDependent.ChildIDField]: tmpChild[pDependent.ChildIDField], [pDependent.FKField]: pToID };
			try
			{
				await new Promise((resolve, reject) =>
				{
					tmpEntityProvider.updateEntity(pDependent.Entity, tmpUpdate, (pError, pBody) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						// Meadow returns a non-2xx error in the body (not the callback) — surface it as a failure.
						if (pBody && pBody.ErrorCode)
						{
							return reject(new Error(`DependentManager: ${pDependent.Entity} update rejected (ErrorCode ${pBody.ErrorCode}).`));
						}
						return resolve(pBody);
					});
				});
				tmpResult.repointed++;
			}
			catch (pError)
			{
				tmpResult.failed++;
				this.pict.log.error(`DependentManager: repointDependent failed for ${pDependent.Entity}.${pDependent.FKField} (${pFromID} -> ${pToID}): ${pError.message || pError}`);
			}
		}
		this._clearDependentCache(tmpEntityProvider);
		return tmpResult;
	}
}

module.exports = PictRecordSetDependentManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":845}],973:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Solver",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicSolver class is a provider that solves configuration-generated dynamic views.
 */
class RecordSetDynamicRecordsetSolver extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicSolver class.
	 *
	 * @param {object} pFable - The fable object.
	 * @param {object} pOptions - The options object.
	 * @param {object} pServiceHash - The service hash object.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & {
		 *		instantiateServiceProviderIfNotExists: (hash: string) => any,
		 *		ExpressionParser: any,
		 *		PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>
		 *	}} */
		this.pict;
		/** @type {import('pict') & { instantiateServiceProviderIfNotExists: (hash: string) => any, ExpressionParser: any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		// Initialize the solver service if it isn't up
		this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
	}

	/**
	 * Checks the solver and returns the solver object if it passes the checks.
	 *
	 * Automatically converts string solvers to have an Ordinal of 1.
	 *
	 * @param {string|object} pSolver - The solver to be checked. It can be either a string or an object.
	 * @param {boolean} [pFiltered=false] - Indicates whether the solvers should be filtered.
	 * @param {number} [pOrdinal] - The ordinal value to compare with the solver's ordinal value when filtered.
	 * @returns {object|undefined} - The solver object if it passes the checks, otherwise undefined.
	 */
	checkSolver(pSolver, pFiltered, pOrdinal)
	{
		let tmpSolver = pSolver;
		if (tmpSolver === undefined)
		{
			return;
		}
		if (typeof(tmpSolver) === 'string')
		{
			tmpSolver = {Expression:tmpSolver, Ordinal:1};
		}
		if (!('Expression' in tmpSolver))
		{
			this.log.error(`Dashboard solver ${pOrdinal} is missing the Expression property.`, { Solver: pSolver });
			return;
		}
		if (!(`Ordinal` in tmpSolver))
		{
			tmpSolver.Ordinal = 1;
		}

		// This filters the solvers
		if (pFiltered && (tmpSolver.Ordinal != pOrdinal))
		{
			return;
		}

		return tmpSolver;
	}

	/**
	 * Runs each RecordSet solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 * @param {array} pCellSolverArray - An array of Solvers from the groups to solve.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Array<Record<string, any>>} pRecords - The records to solve against.
	 */
	executeCellSolvers(pManifest, pCellSolverArray, pOrdinal, pRecords)
	{
		// This is purely for readability of the code below ... uglify optimizes it out.
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;

			// Solve the group RecordSet solvers first
		for (let j = 0; j < pCellSolverArray.length; j++)
		{
			let tmpSolver = this.checkSolver(pCellSolverArray[j].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `CellSolver-${j}`;

			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`Cell solving RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}

			const tmpRecords = Array.isArray(pRecords) ? pRecords : pRecords ? Object.values(pRecords) : [];
			for (let l = 0; l < tmpRecords.length; l++)
			{
				let tmpRecord = tmpRecords[l];
				tmpSolver.ResultsObject = {};
				const tmpSolverRecord = this.buildCellContextRecord(tmpRecord, pRecords, pManifest);
				let tmpSolutionValue = this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpSolverRecord, tmpSolver.ResultsObject,
					pManifest, tmpRecord);
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`Cell solver [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
				}
			}
			tmpSolver.EndTimeStamp = Date.now();
		}
	}

	/**
	 * @param {Record<string, any>} pRecord - The record to build the context for.
	 * @param {Array<Record<string, any>>} pRecords - The records to build the context from.
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 */
	buildCellContextRecord(pRecord, pRecords, pManifest)
	{
		return Object.assign({}, pRecord, this.buildGlobalContextRecord(pRecords, pManifest));
	}

	/**
	 * @param {Array<Record<string, any>>} pRecords - The records to build the context from.
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 */
	buildGlobalContextRecord(pRecords, pManifest)
	{
		return {
			Pict: this.pict,
			AppData: this.pict.AppData,
			Bundle: this.pict.Bundle,
			RecordSubset: pRecords,
			Manifest: pManifest,
		};
	}

	/**
	 * Executes the section solvers at a given ordinal (or all if no ordinal is passed).
	 *
	 * @param {import('manyfest')} pManifest - The manifest for the RecordSet.
	 * @param {Array} pGlobalSolverArray - The array of view section solvers.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Array<Record<string, any>>} pRecords - The records to solve against.
	 */
	executeDashboardSolvers(pManifest, pGlobalSolverArray, pOrdinal, pRecords)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;

		for (let i = 0; i < pGlobalSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pGlobalSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `DashboardSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`Dashboard solving equation ${i} ordinal ${tmpSolver.Ordinal}`);
			}
			tmpSolver.ResultsObject = {};
			const tmpRecord = this.buildGlobalContextRecord(pRecords, pManifest);
			let tmpSolutionValue = this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, pManifest, tmpRecord);
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`[${tmpSolver.Expression}] result was ${tmpSolutionValue}`);
			}
			tmpSolver.EndTimeStamp = Date.now();
		}
	}

	/**
	 * Checks if the given ordinal exists in the provided ordinal set.
	 *
	 * If not, it adds the ordinal to the set.
	 *
	 * @param {number} pOrdinal - The ordinal to check.
	 * @param {Object} pOrdinalSet - The ordinal set to check against.
	 * @returns {Object} - The ordinal object from the ordinal set.
	 */
	checkAutoSolveOrdinal(pOrdinal, pOrdinalSet)
	{
		if (!(pOrdinal.toString() in pOrdinalSet))
		{
			pOrdinalSet[pOrdinal.toString()] = { DashboardSolvers:[], CellSolvers:[] };
		}
		return pOrdinalSet[pOrdinal];
	}

	/**
	 * Solves the views based on the provided view hashes or all views in pict.
	 *
	 * If non-dynamic views are also passed in, they are solved as well.
	 *
	 * This algorithm is particularly complex because it solves views in
	 * order across two dimensions:
	 *
	 * 1. The order of the views in the view hash array.
	 * 2. Precedence order (based on Ordinal)
	 *
	 * The way it manages the precedence order solving is by enumerating the
	 * view hash array multiple times until it exhausts the solution set.
	 *
	 * In dynamic views, when there are collisions in precedence order between
	 * Section Solvers and Group RecordSet Solvers, it prefers the RecordSet
	 * solvers first.  The thinking behind this is that a RecordSet solver is
	 * a "tier down" from the core Section it resides within.  These are
	 * leaves on the tree.
	 *
	 * @param {Record<string, any>} pManifestDefinition
	 * @param {Array<Record<string, any>>} pRecords - The records to solve against.
	 */
	solveDashboard(pManifestDefinition, pRecords)
	{
		let tmpSolveOutcome = {};
		tmpSolveOutcome.StartTimeStamp = Date.now();

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		const tmpCellDefinitions = Object.values(pManifestDefinition.Descriptors);
		for (const tmpCell of tmpCellDefinitions)
		{
			if (!Array.isArray(tmpCell?.PictDashboard?.Solvers))
			{
				continue;
			}
			for (const tmpRawSolver of tmpCell.PictDashboard.Solvers)
			{
				if (tmpRawSolver)
				{
					const tmpSolver = this.checkSolver(tmpRawSolver, false);
					const tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
					tmpOrdinalContainer.CellSolvers.push({ CellHash: tmpCell.Hash, Solver:tmpSolver });
				}
			}
		}
		if (Array.isArray(pManifestDefinition.GlobalSolvers))
		{
			// Add the section solver(s)
			for (const tmpRawSolver of pManifestDefinition.GlobalSolvers)
			{
				if (tmpRawSolver)
				{
					const tmpSolver = this.checkSolver(tmpRawSolver, false);
					let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
					tmpOrdinalContainer.DashboardSolvers.push({ Solver: tmpSolver });
				}
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort();
		const tmpManifest = this.pict.PictSectionRecordSet.getManifest(pManifestDefinition.Scope);
		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicRecordsetSolver [${this.UUID}]::[${this.Hash}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			this.executeCellSolvers(tmpManifest, tmpOrdinalContainer.CellSolvers, Number(tmpOrdinalKeys[i]), pRecords);
			this.executeDashboardSolvers(tmpManifest, tmpOrdinalContainer.DashboardSolvers, Number(tmpOrdinalKeys[i]), pRecords);
		}

		tmpSolveOutcome.EndTimeStamp = Date.now();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastSolveOutcome = tmpSolveOutcome;
	}
}

module.exports = RecordSetDynamicRecordsetSolver;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":845}],974:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-LinkManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictRecordSetLinkManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.pict;

		// An array of link templates with a hash, name template and uri template.
		// Format:
		// {
		//   Name: "View Record",
		//   URL: "#/PSRS/{~D:Record.Payload.RecordSet~}/View/{~DVBK:Record.Data:Record.Payload.GUIDAddress~}",
		//   Default: true
		// }
		this.linkTemplates = [];
	}

	/**
	 * TODO: Add the ability to add routes that are scoped to particular entity types
	 *
	 * @param {string} pNameTemplate - The name template for the record link.
	 * @param {string} pURLTemplate - The URL template for the record link.
	 * @param {boolean} pDefault - Whether this is a default link template.
	 *
	 * @return {Record<string, any>} - The link template object that was added.
	 */
	addRecordLinkTemplate(pNameTemplate, pURLTemplate, pDefault)
	{
		let tmpDefaultAction = (typeof(pDefault) !== 'undefined') ? pDefault : false;

		const tmpLinkTemplateObject = (
			{
				Name: pNameTemplate,
				URL: pURLTemplate,
				Default: tmpDefaultAction
			});

		this.linkTemplates.push(tmpLinkTemplateObject);

		return tmpLinkTemplateObject;
	}
}

module.exports = PictRecordSetLinkManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":845}],975:[function(require,module,exports){

const libPictProvider = require('pict-provider');

/**
 * Default configuration for the RecordSetProvider provider.
 * @type {Record<string, any>}
 */
const _DefaultProviderConfiguration = {
	ProviderIdentifier: 'Pict-RecordSetProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 1, // initialize after other providers if initialized during app init
	AutoSolveWithApp: false,
};

/**
 * @typedef {Object} RecordSetSearchRangeFacet
 * @property {string} Field - The field to facet on. Only indexed fields can be faceted.
 * @property {any} Start - The start of the range. (ex. 1900)
 * @property {any} End - The end of the range. (ex. 2025)
 * @property {any} Gap - The gap between range values. (ex. 25)
 * TODO: Support auto-generating ranges based on the data at rest?
 */

/**
 * @typedef {Object} RecordSetSearchFacetPayload
 * @property {boolean} [ReturnRecords] - If false, search will return facets only, not records.
 * @property {Array<string>} Fields - Requests to facet on all unique values of the given fields.
 * @property {Array<RecordSetSearchRangeFacet>} Ranges - Requests to facet on given ranges of field values.
 * TODO: support facet on custom query?
 */

/**
 * @typedef {Object} RecordSetResult
 * @property {Array<Record<string, any>>} Records - The records returned from the provider.
 * @property {Record<string, Record<string, number>> & { ByRange?: Record<string, number> }} Facets - The facets returned from the provider.
 */

/**
 * @typedef {Object} RecordSetFilter
 * @property {string} [Entity] - The entity name. Can be used as an override to achieve LiteExtended, etc.
 * @property {string} [FilterString] - A meadow endpoint style filter to apply.
 * @property {number} [Offset] - The starting record number for pagination.
 * @property {number} [PageSize] - The starting record number for pagination.
 * @property {RecordSetSearchFacetPayload} [Facets] - The faceting config for the search.
 */

/**
 * Base record set provider.
 * @extends libPictProvider
 */
class RecordSetProviderBase extends libPictProvider
{
	/**
	 * Creates an instance of RecordSetProvider.
	 * @param {import('pict')} pFable - The Fable object.
	 * @param {Record<string, any>} [pOptions] - Custom options for the provider.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict')} */
		this.fable;
		/** @type {import('pict')} */
		this.pict;

		/** @type {Record<string, any>} */
		this._FilterSchema = { };
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async getRecord(pIDOrGuid)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecord(${pIDOrGuid})`);
		return { };
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pGuid - The ID or GUID of the record.
	 */
	async getRecordByGUID(pGuid)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecordByGUID(${pGuid})`);
		return { };
	}

	/*
	get availableFilters()
	{
		return { IDBook: [ 'NumericMatch', 'NumericRange', 'ExternalJoinBookByAuthor' ], Title: [ 'StringMatch', 'StringRange' ] };
	}
	*/

	getGUIDField()
	{ 
		return `GUID${ this.options.Entity }`;
	}

	getIDField()
	{ 
		return `ID${ this.options.Entity }`;
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecords(pOptions)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecords(${JSON.stringify(pOptions)})`);
		return { Records: [], Facets: { } };
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 *
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getDecoratedRecords(pOptions)
	{
		const tmpRecords = await this.getRecords(pOptions);
		await this.decorateCoreRecords(tmpRecords.Records);
		return tmpRecords;
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {string} [pFilterString] - The filter string to apply.
	 * @param {number} [pOffset] - The starting record number for pagination.
	 * @param {number} [pPageSize] - The number of records to return.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecordsInline(pFilterString = '', pOffset = 0, pPageSize = 250)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecordsInline(${pFilterString}, ${pOffset}, ${pPageSize})`);
		return { Records: [], Facets: { } };
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 */
	async getRecordSetCount(pOptions)
	{
		this.pict.log.info(`RecordSetProviderBase.getRecordSetCount(${JSON.stringify(pOptions)})`);
		return { Count: 0 };
	}

	/**
	 * Create a new record.
	 *
	 * @param {Record<string, any>} pRecord - The record to create.
	 * @return {Promise<Record<string, any>>} - The created record.
	 */
	async createRecord(pRecord)
	{
		this.pict.log.info(`RecordSetProviderBase.createRecord(${JSON.stringify(pRecord)})`);
		return pRecord;
	}

	/**
	 * Update a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to update.
	 * @return {Promise<Record<string, any>>} - The updated record.
	 */
	async updateRecord(pRecord)
	{
		this.pict.log.info(`RecordSetProviderBase.updateRecord(${JSON.stringify(pRecord)})`);
		return pRecord;
	}

	/**
	 * Delete a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to delete.
	 * @return {Promise<void>}
	 */
	async deleteRecord(pRecord)
	{
		this.pict.log.info(`RecordSetProviderBase.deleteRecord(${JSON.stringify(pRecord)})`);
	}

	/**
	 * Read a record.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async readRecord(pIDOrGuid)
	{
		this.pict.log.info(`RecordSetProviderBase.readRecord(${pIDOrGuid})`);
		return { };
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async readRecords(pOptions)
	{
		this.pict.log.info(`RecordSetProviderBase.readRecords(${JSON.stringify(pOptions)})`);
		return { Records: [], Facets: { } };
	}

	/**
	 * Clone a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clone.
	 * @return {Promise<Record<string, any>>} - The cloned record.
	 */
	async cloneRecord(pRecord)
	{
		return this.createRecord(this.cleanRecord(pRecord));
	}

	/**
	 * Remove any intrinsic identifiers from a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clean.
	 */
	cleanRecord(pRecord)
	{
		return pRecord;
	}

	/**
	 * @return {Record<string, any>} The schema of the record.
	 */
	get recordSchema()
	{
		return { };
	}

	/**
	 * Abstract decoration method for core records. Subclasses should implement this method to decorate records with additional information.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The records to decorate.
	 * @return {Promise<void>}
	 */
	async decorateCoreRecords(pRecords)
	{
	}

	/**
	 * @return {Promise<Record<string, any>>} The schema of the record.
	 */
	async getRecordSchema()
	{
		throw new Error(`getRecordSchema must be implemented in a sub-class`);
	}

	/**
	 * @return {Array<string>} The keys of the filter schema.
	 */
	getFilterSchemaKeys()
	{
		return Object.keys(this._FilterSchema);
	}

	/**
	 * @param {string} pFilterKey - The filter key to get the schema for.
	 *
	 * @return {Record<string, any>} The schema for the filter clause.
	 */
	getFilterClauseSchemaForKey(pFilterKey)
	{
		return this._FilterSchema?.[pFilterKey];
	}

	/**
	 * @return {Record<string, Record<string, any>>} The schema for the filter clauses.
	 */
	getFilterSchema()
	{
		//FIXME: risk here that the schema hasn't been loaded - but don't want to make this async...
		/** @type {Record<string, Record<string, any>>} */
		const tmpSchema = {};
		for (const tmpKey of this.getFilterSchemaKeys())
		{
			tmpSchema[tmpKey] = this.getFilterClauseSchemaForKey(tmpKey);
		}
		return tmpSchema;
	}

	/**
	 * @param {string} pFilterKey - The filter key to add the clause for.
	 * @param {string} pClauseKey - The clause key to add.
	 */
	addFilterClause(pFilterKey, pClauseKey)
	{
		let tmpClause = this.getFilterClauseSchemaForKey(pFilterKey)?.AvailableClauses?.find?.((c) => c.ClauseKey == pClauseKey);
		if (!tmpClause)
		{
			this.pict.log.error(`RecordSetProviderBase.addFilterClause() - No filter clause schema found for key ${pFilterKey} and clause ${pClauseKey}.`);
			return;
		}
		tmpClause = JSON.parse(JSON.stringify(tmpClause));
		tmpClause.Hash = `${pFilterKey}-${pClauseKey}-${this.pict.getUUID()}`;
		tmpClause.Label = tmpClause.Label || tmpClause.DisplayName;
		// Stamp the owning recordset so per-clause re-renders (which rebuild the render record
		// from the live clause alone) can still resolve their provider and remove control.
		if (!tmpClause.RecordSet && this.options.RecordSet)
		{
			tmpClause.RecordSet = this.options.RecordSet;
		}
		const tmpClauses = this.getFilterClauses();
		tmpClauses.push(tmpClause);
	}

	/**
	 */
	clearFilterClauses()
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			return;
		}
		tmpClauses.length = 0; // Clear the array
	}

	/**
	 * @param {string} pSpecificFilterClauseHash - The hash of the specific filter clause to remove.
	 */
	removeFilterClause(pSpecificFilterClauseHash)
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			this.pict.log.error('RecordSetProviderBase.removeFilterClause() - No filter clauses found.');
			return;
		}
		const tmpClauseIndex = tmpClauses.findIndex((c) => pSpecificFilterClauseHash == c.Hash);
		if (tmpClauseIndex < 0)
		{
			this.pict.log.error(`RecordSetProviderBase.removeFilterClause() - Filter clause with hash ${pSpecificFilterClauseHash} not found.`);
			return;
		}
		tmpClauses.splice(tmpClauseIndex, 1);
	}

	/**
	 * @return {Array<Record<string, any>>} The filter clauses.
	 */
	getFilterClauses()
	{
		let tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			tmpClauses = [];
			this.pict.Bundle._ActiveFilterState = this.pict.Bundle._ActiveFilterState || {};
			this.pict.Bundle._ActiveFilterState[this.options.RecordSet] = this.pict.Bundle._ActiveFilterState[this.options.RecordSet] || {};
			this.pict.Bundle._ActiveFilterState[this.options.RecordSet].FilterClauses = tmpClauses;
		}
		return tmpClauses;
	}

	// --- Quick Filters -----------------------------------------------------------------------------
	// A curated, one-interaction set of filters surfaced at the top of the drawer (fuzzy-search Title,
	// Created range, Created-by, …) so common filtering skips the "Add filter → pick field → pick type"
	// hunt. Each quick filter reuses a real clause descriptor from the field's AvailableClauses; its live
	// clause lives in the same FilterClauses array (tagged `QuickFilter:true`, keyed by `QuickFilterKey`)
	// so it serializes / applies / clears like any other clause — the drawer's clause list just skips it.

	/**
	 * Resolve the quick-filter definitions for this record set. Precedence: a `QuickFilters` array config
	 * (curated) → those; `QuickFilters: false` → none (explicit per-record-set opt-out); otherwise clever
	 * defaults derived from the schema — UNLESS `pAllowCleverDefaults` is false (the host put quick filters
	 * in opt-in-only mode, so a record set shows the bar only when it sets an explicit `QuickFilters`
	 * array). Each definition resolves to a concrete clause descriptor from the field's `AvailableClauses`.
	 *
	 * @param {boolean} [pAllowCleverDefaults] - false → no clever defaults (opt-in only). Default true.
	 * @return {Array<{Field:string, Label:string, Control:string, ClauseKey:string}>}
	 */
	getQuickFilterDefinitions(pAllowCleverDefaults)
	{
		const tmpConfig = this.options.QuickFilters;
		if (tmpConfig === false) { return []; }
		let tmpEntries;
		if (Array.isArray(tmpConfig)) { tmpEntries = tmpConfig; }
		else if (pAllowCleverDefaults === false) { tmpEntries = []; }
		else { tmpEntries = this._deriveDefaultQuickFilters(); }
		const tmpDefinitions = [];
		for (let i = 0; i < tmpEntries.length; i++)
		{
			const tmpEntry = (typeof tmpEntries[i] === 'string') ? { Field: tmpEntries[i] } : (tmpEntries[i] || {});
			const tmpDefinition = this._resolveQuickFilterDefinition(tmpEntry);
			if (tmpDefinition) { tmpDefinitions.push(tmpDefinition); }
		}
		this._seedRelativeDateDefaults(tmpDefinitions);
		return tmpDefinitions;
	}

	/**
	 * Seed a date-range quick filter to a trailing window on FIRST use.
	 *
	 * A clause can only hold literal bounds, so "default to the last year" cannot
	 * be stored as configuration — a date baked in when the dashboard was authored
	 * silently means "365 days before the day someone generated this", and rots.
	 * `DefaultRelativeDays: 365` on the clause descriptor instead resolves against
	 * TODAY, here, every time the bar is built.
	 *
	 * Seeds ONLY when the user has no value of their own: an explicit pick, a
	 * cleared filter, or a restored filter experience all win, because overriding
	 * those would make the control feel broken. That is also why it seeds the
	 * clause rather than forcing it on every render.
	 *
	 * @param {Array<Record<string, any>>} pDefinitions - Resolved quick-filter definitions.
	 * @private
	 */
	_seedRelativeDateDefaults(pDefinitions)
	{
		if (!Array.isArray(pDefinitions)) { return; }
		this._SeededRelativeDates = this._SeededRelativeDates || {};
		for (const tmpDefinition of pDefinitions)
		{
			if (tmpDefinition.Control !== 'daterange') { continue; }
			if (this._SeededRelativeDates[tmpDefinition.Field]) { continue; }
			const tmpSchema = this.getFilterClauseSchemaForKey(tmpDefinition.Field);
			const tmpClause = (tmpSchema && Array.isArray(tmpSchema.AvailableClauses))
				? tmpSchema.AvailableClauses.find((pClause) => pClause.ClauseKey === tmpDefinition.ClauseKey) : null;
			const tmpDays = tmpClause ? parseInt(tmpClause.DefaultRelativeDays, 10) : NaN;
			if (!(tmpDays > 0)) { continue; }
			// Mark it seeded BEFORE the bounds check: a user who clears the filter
			// must not have it re-seeded from under them on the next render.
			this._SeededRelativeDates[tmpDefinition.Field] = true;
			const tmpCurrent = this.getQuickFilterDateRangeValue(tmpDefinition.Field);
			if (tmpCurrent.Start || tmpCurrent.End) { continue; }
			const tmpStart = new Date();
			tmpStart.setDate(tmpStart.getDate() - tmpDays);
			this.upsertQuickFilterDateRange(tmpDefinition.Field, tmpDefinition.ClauseKey, 'start', tmpStart.toISOString().slice(0, 10));
		}
	}

	/**
	 * Clever defaults (zero config): the common things people filter on, detected by canonical Meadow
	 * column names on the fetched schema. Primary text (Title→Name), the audit date ranges, the audit
	 * user references. Absent `_Schema` (non-Meadow provider) → no defaults.
	 *
	 * @return {Array<{Field:string, Label?:string}>}
	 */
	_deriveDefaultQuickFilters()
	{
		const tmpProperties = (this._Schema && this._Schema.properties) || null;
		if (!tmpProperties) { return []; }
		const fHas = (pField) => Object.prototype.hasOwnProperty.call(tmpProperties, pField);
		const tmpDefaults = [];
		// `RequireControl` pins a default to its intended control: a "Created" default is only useful as
		// a date range, a "Created by" only as an entity picker. If the field can't offer that (e.g. a
		// schema that types its dates as plain strings), the default is dropped rather than degrading to
		// an odd text-search-a-timestamp. Host-configured QuickFilters carry no RequireControl, so they
		// take whatever clause the field offers.
		if (fHas('Title')) { tmpDefaults.push({ Field: 'Title' }); }
		else if (fHas('Name')) { tmpDefaults.push({ Field: 'Name' }); }
		if (fHas('CreateDate')) { tmpDefaults.push({ Field: 'CreateDate', Label: 'Created', RequireControl: 'daterange' }); }
		if (fHas('UpdateDate')) { tmpDefaults.push({ Field: 'UpdateDate', Label: 'Updated', RequireControl: 'daterange' }); }
		if (fHas('CreatingIDUser')) { tmpDefaults.push({ Field: 'CreatingIDUser', Label: 'Created by', RequireControl: 'entity' }); }
		if (fHas('UpdatingIDUser')) { tmpDefaults.push({ Field: 'UpdatingIDUser', Label: 'Updated by', RequireControl: 'entity' }); }
		return tmpDefaults;
	}

	/**
	 * Resolve one quick-filter config entry to a renderable definition: pick the clause (explicit
	 * `ClauseKey`, else the best for a quick filter) from the field's AvailableClauses + classify it to a
	 * control type. Returns null when the field has no usable clause.
	 *
	 * @param {Record<string, any>} pEntry @return {{Field:string, Label:string, Control:string, ClauseKey:string}|null}
	 */
	_resolveQuickFilterDefinition(pEntry)
	{
		if (!pEntry || !pEntry.Field) { return null; }
		const tmpFieldSchema = this.getFilterClauseSchemaForKey(pEntry.Field);
		const tmpAvailableClauses = tmpFieldSchema && Array.isArray(tmpFieldSchema.AvailableClauses) ? tmpFieldSchema.AvailableClauses : null;
		if (!tmpAvailableClauses || tmpAvailableClauses.length < 1) { return null; }
		const tmpClause = pEntry.ClauseKey
			? tmpAvailableClauses.find((pClause) => pClause.ClauseKey === pEntry.ClauseKey)
			: this._pickQuickClause(tmpAvailableClauses);
		if (!tmpClause) { return null; }
		const tmpControl = this._controlForClauseType(tmpClause.Type);
		if (!tmpControl) { return null; }
		// A default that demands a specific control (e.g. date range) is dropped when the field can't offer it.
		if (pEntry.RequireControl && tmpControl !== pEntry.RequireControl) { return null; }
		return {
			Field: pEntry.Field,
			Label: pEntry.Label || tmpFieldSchema.DisplayName || pEntry.Field,
			Control: tmpControl,
			ClauseKey: tmpClause.ClauseKey,
		};
	}

	/**
	 * Choose the clause a quick filter should drive for a field: an entity selected-value, else a fuzzy
	 * string match, else a range — i.e. the simplest one-interaction clause the field offers.
	 *
	 * @param {Array<Record<string, any>>} pAvailableClauses @return {Record<string, any>|undefined}
	 */
	_pickQuickClause(pAvailableClauses)
	{
		return pAvailableClauses.find((pClause) => pClause.Type === 'DistinctSelectedValueList')
			|| pAvailableClauses.find((pClause) => pClause.Type === 'InternalJoinSelectedValue' || pClause.Type === 'InternalJoinSelectedValueList')
			|| pAvailableClauses.find((pClause) => pClause.Type === 'StringMatch' && pClause.ExactMatch === false)
			|| pAvailableClauses.find((pClause) => pClause.Type === 'DateRange')
			|| pAvailableClauses.find((pClause) => pClause.Type === 'NumericRange')
			|| pAvailableClauses[0];
	}

	/**
	 * Map a clause Type to the quick-bar control that drives it.
	 * @param {string} pType @return {string|null}
	 */
	_controlForClauseType(pType)
	{
		switch (pType)
		{
			case 'StringMatch': return 'text';
			case 'DateRange': return 'daterange';
			case 'DistinctSelectedValueList': return 'distinct';
			case 'InternalJoinSelectedValue':
			case 'InternalJoinSelectedValueList': return 'entity';
			default: return null;
		}
	}

	/**
	 * The entity's soft-delete column name. Subclasses with schema access override this
	 * (the Meadow provider resolves the column whose Type is 'Deleted').
	 * @return {string}
	 */
	getDeletedField()
	{
		return 'Deleted';
	}

	/** @return {boolean} Whether the show-deleted clause is currently active for this record set. */
	getShowDeletedFilterValue()
	{
		return this.getFilterClauses().some((pClause) => pClause.ShowDeletedKey === 'ShowDeleted');
	}

	/**
	 * Toggle the show-deleted clause: a RawFilter stanza that references the Deleted column
	 * explicitly, which suppresses the automatic `Deleted = 0` delete tracking so soft-deleted
	 * rows enumerate. It is a real clause in the active filter state, so it serializes into the
	 * filter experience (and the route URL) and clears with Clear like any other clause. The
	 * clause list UI skips it (no filter view for RawFilter) — the drawer checkbox is its face.
	 *
	 * @param {boolean} pOn - Whether deleted records should be included.
	 * @return {boolean} The resulting state.
	 */
	setShowDeletedFilterValue(pOn)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpIndex = tmpClauses.findIndex((pClause) => pClause.ShowDeletedKey === 'ShowDeleted');
		if (pOn === true)
		{
			if (tmpIndex < 0)
			{
				tmpClauses.push(
					{
						Type: 'RawFilter',
						ShowDeletedKey: 'ShowDeleted',
						Label: 'Show deleted',
						Value: `FBL~${this.getDeletedField()}~INN~0,1`,
					});
			}
			return true;
		}
		if (tmpIndex >= 0)
		{
			tmpClauses.splice(tmpIndex, 1);
		}
		return false;
	}

	/** @param {string} pField @return {any} The current value of a field's quick-filter clause, or ''. */
	getQuickFilterClauseValue(pField)
	{
		const tmpClause = this.getFilterClauses().find((pClause) => pClause.QuickFilterKey === `Quick-${pField}`);
		return tmpClause ? tmpClause.Value : '';
	}

	/**
	 * Upsert (or, when the value is empty, remove) a field's quick-filter clause with a scalar value.
	 * Creates the clause from the field's descriptor on first use, tagged so it renders in the quick bar
	 * and serializes/applies like any clause.
	 *
	 * @param {string} pField @param {string} pClauseKey @param {any} pValue
	 */
	upsertQuickFilterClauseValue(pField, pClauseKey, pValue)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpQuickFilterKey = `Quick-${pField}`;
		const tmpExistingIndex = tmpClauses.findIndex((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
		const tmpEmpty = (pValue === undefined || pValue === null || pValue === '');
		if (tmpEmpty)
		{
			if (tmpExistingIndex >= 0) { tmpClauses.splice(tmpExistingIndex, 1); }
			return;
		}
		if (tmpExistingIndex >= 0)
		{
			tmpClauses[tmpExistingIndex].Value = pValue;
			return;
		}
		const tmpClause = this._createQuickFilterClause(pField, pClauseKey, tmpQuickFilterKey);
		if (!tmpClause) { return; }
		tmpClause.Value = pValue;
		tmpClauses.push(tmpClause);
	}

	/** @param {string} pField @return {{Start:any, End:any}} The current DateRange quick-filter bounds. */
	getQuickFilterDateRangeValue(pField)
	{
		const tmpClause = this.getFilterClauses().find((pClause) => pClause.QuickFilterKey === `Quick-${pField}`);
		const tmpValues = (tmpClause && tmpClause.Values && typeof tmpClause.Values === 'object' && !Array.isArray(tmpClause.Values)) ? tmpClause.Values : {};
		return { Start: tmpValues.Start || '', End: tmpValues.End || '' };
	}

	/**
	 * Set one bound of a field's DateRange quick-filter clause (create on first use, remove when BOTH
	 * bounds are empty). Bounds live at `clause.Values.Start` / `.End` (the DateRange contract).
	 *
	 * @param {string} pField @param {string} pClauseKey @param {'start'|'end'} pWhich @param {any} pValue
	 */
	upsertQuickFilterDateRange(pField, pClauseKey, pWhich, pValue)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpQuickFilterKey = `Quick-${pField}`;
		let tmpClause = tmpClauses.find((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
		const tmpValue = (pValue === undefined || pValue === null) ? '' : pValue;
		if (!tmpClause)
		{
			if (tmpValue === '') { return; }
			tmpClause = this._createQuickFilterClause(pField, pClauseKey, tmpQuickFilterKey);
			if (!tmpClause) { return; }
			tmpClause.Values = {};
			tmpClauses.push(tmpClause);
		}
		if (!tmpClause.Values || typeof tmpClause.Values !== 'object' || Array.isArray(tmpClause.Values)) { tmpClause.Values = {}; }
		// Case-INSENSITIVE on purpose. This was `pWhich === 'start'`, so a caller
		// passing 'Start' fell through to the else and wrote the END bound -- which
		// inverts the filter: a "last 365 days" default became "everything before
		// 365 days ago". Nothing about the parameter says it is case-sensitive, so
		// the comparison is forgiving rather than the callers being careful.
		if (String(pWhich).toLowerCase() === 'start') { tmpClause.Values.Start = tmpValue; }
		else { tmpClause.Values.End = tmpValue; }
		const fEmpty = (pVal) => (pVal === undefined || pVal === null || pVal === '');
		if (fEmpty(tmpClause.Values.Start) && fEmpty(tmpClause.Values.End))
		{
			const tmpIndex = tmpClauses.findIndex((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
			if (tmpIndex >= 0) { tmpClauses.splice(tmpIndex, 1); }
		}
	}

	/** @param {string} pField @return {Array<any>} The current entity quick-filter selected value(s). */
	getQuickFilterEntityValue(pField)
	{
		const tmpClause = this.getFilterClauses().find((pClause) => pClause.QuickFilterKey === `Quick-${pField}`);
		return (tmpClause && Array.isArray(tmpClause.Values)) ? tmpClause.Values : [];
	}

	/**
	 * Set a field's entity quick-filter clause to the picked value(s) (create on first use, remove when
	 * empty). Selected ids live at `clause.Values` (the entity-reference contract).
	 *
	 * @param {string} pField @param {string} pClauseKey @param {any} pValue scalar or array
	 */
	upsertQuickFilterEntity(pField, pClauseKey, pValue)
	{
		const tmpClauses = this.getFilterClauses();
		const tmpQuickFilterKey = `Quick-${pField}`;
		const tmpArray = (Array.isArray(pValue) ? pValue : ((pValue === undefined || pValue === null || pValue === '') ? [] : [ pValue ]))
			.filter((pVal) => pVal !== undefined && pVal !== null && pVal !== '');
		const tmpIndex = tmpClauses.findIndex((pClause) => pClause.QuickFilterKey === tmpQuickFilterKey);
		if (tmpArray.length === 0)
		{
			if (tmpIndex >= 0) { tmpClauses.splice(tmpIndex, 1); }
			return;
		}
		if (tmpIndex >= 0) { tmpClauses[tmpIndex].Values = tmpArray; return; }
		const tmpClause = this._createQuickFilterClause(pField, pClauseKey, tmpQuickFilterKey);
		if (!tmpClause) { return; }
		tmpClause.Values = tmpArray;
		tmpClauses.push(tmpClause);
	}

	/**
	 * Clone a field's clause descriptor into a fresh, tagged quick-filter clause (no value set yet), or
	 * null when the descriptor is missing. Shared by the text / date / entity upserts.
	 *
	 * @param {string} pField @param {string} pClauseKey @param {string} pQuickFilterKey
	 * @return {Record<string, any>|null}
	 */
	_createQuickFilterClause(pField, pClauseKey, pQuickFilterKey)
	{
		const tmpDescriptor = this.getFilterClauseSchemaForKey(pField)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pClauseKey);
		if (!tmpDescriptor)
		{
			this.pict.log.error(`RecordSetProviderBase quick filter: no clause schema for field ${pField} / clause ${pClauseKey}.`);
			return null;
		}
		const tmpClause = JSON.parse(JSON.stringify(tmpDescriptor));
		tmpClause.Hash = `${pField}-${pClauseKey}-${this.pict.getUUID()}`;
		tmpClause.Label = tmpClause.Label || tmpClause.DisplayName;
		tmpClause.QuickFilter = true;
		tmpClause.QuickFilterKey = pQuickFilterKey;
		if (!tmpClause.RecordSet && this.options.RecordSet)
		{
			tmpClause.RecordSet = this.options.RecordSet;
		}
		return tmpClause;
	}

	/**
	 * @param {string} pSpecificFilterClauseHash - The hash of the specific filter clause to move.
	 * @param {number} pOrdinal - The ordinal position to move the filter clause to.
	 */
	moveFilterClauseTo(pSpecificFilterClauseHash, pOrdinal)
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			this.pict.log.error('RecordSetProviderBase.moveFilterClauseTo() - No filter clauses found.');
			return;
		}
		if (pOrdinal < 0 || pOrdinal >= tmpClauses.length)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseTo() - Invalid ordinal ${pOrdinal}.`);
			return;
		}
		const tmpClauseIndex = tmpClauses.indexOf((c) => pSpecificFilterClauseHash == c.Hash);
		if (tmpClauseIndex < 0)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseTo() - Filter clause with hash ${pSpecificFilterClauseHash} not found.`);
			return;
		}
		const tmpClause = tmpClauses.splice(tmpClauseIndex, 1)[0];
		tmpClauses.splice(pOrdinal, 0, tmpClause);
	}

	/**
	 * @param {string} pSpecificFilterClauseHash - The hash of the specific filter clause to move.
	 * @param {number} pOrdinalOffset - The ordinal offset to move the filter clause by.
	 */
	moveFilterClauseBy(pSpecificFilterClauseHash, pOrdinalOffset)
	{
		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[this.options.RecordSet]?.FilterClauses;
		if (!Array.isArray(tmpClauses))
		{
			this.pict.log.error('RecordSetProviderBase.moveFilterClauseBy() - No filter clauses found.');
			return;
		}
		const tmpClauseIndex = tmpClauses.indexOf((c) => pSpecificFilterClauseHash == c.Hash);
		if (tmpClauseIndex < 0)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseBy() - Filter clause with hash ${pSpecificFilterClauseHash} not found.`);
			return;
		}
		const tmpNewOrdinal = tmpClauseIndex + pOrdinalOffset;
		if (tmpNewOrdinal < 0 || tmpNewOrdinal >= tmpClauses.length)
		{
			this.pict.log.error(`RecordSetProviderBase.moveFilterClauseBy() - Invalid new ordinal ${tmpNewOrdinal} (offset of ${pOrdinalOffset} for original ordinal ${tmpClauseIndex}).`);
			return;
		}
		const tmpClause = tmpClauses.splice(tmpClauseIndex, 1)[0];
		tmpClauses.splice(tmpNewOrdinal, 0, tmpClause);
	}
}

module.exports = RecordSetProviderBase;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":845}],976:[function(require,module,exports){

const libRecordSetProviderBase = require('./RecordSet-RecordProvider-Base.js');

/**
 * @typedef {import('./RecordSet-RecordProvider-Base.js').RecordSetFilter} RecordSetFilter
 * @typedef {import('./RecordSet-RecordProvider-Base.js').RecordSetResult} RecordSetResult
 */

/**
 * Class representing a data change detection provider for Pict dynamic forms.
 * @extends libRecordSetProviderBase
 */
class MeadowEndpointsRecordSetProvider extends libRecordSetProviderBase
{
	/**
	 * Creates an instance of RecordSetProvider.
	 * @param {import('pict')} pFable - The Fable object.
	 * @param {Record<string, any>} [pOptions] - Custom options for the provider.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict') & {
		 *      log: any,
		 *      services:
		 *      {
		 *			PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>,
		 *			[key: string]: any,
		 *		},
		 *      instantiateServiceProviderWithoutRegistration: (hash: String) => any,
		 *      PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>
		 *  }} */
		this.pict;
		this.fable = this.pict;
		/** @type {string} */
		this.Hash;
		/** @type {string} */
		this.UUID;
		//TODO: make this typedef better
		/** @type {Record<string, any>} */
		this._Schema;
		/**
		 * Single-flight handle for the deferred `<Entity>/Schema` load, so the
		 * background load kicked off at initialization and any on-demand
		 * `getRecordSchema()` share one network round-trip (and one filter-schema
		 * build). Null when idle / not yet loaded.
		 * @type {Promise<Record<string, any> | null> | null}
		 */
		this._SchemaInitPromise = null;
		/** @type {Record<string, Record<string, any>>} */
		this._Experiences = { };
		/** @type {Record<string, Record<string, any>>} */
		this._FiltersByField = { };
	}

	/** @return {import('pict/types/source/Pict-Meadow-EntityProvider.js')} */
	get entityProvider()
	{
		if (!this._EntityProvider)
		{
			/** @type {import('pict/types/source/Pict-Meadow-EntityProvider.js')} */
			//TODO: figure out a pattern to share this with other consumers, to consolidate cache
			this._EntityProvider = this.pict.instantiateServiceProviderWithoutRegistration('EntityProvider');
			if (this.options.URLPrefix)
			{
				this._EntityProvider.options.urlPrefix = this.options.URLPrefix;
			}
		}

		return this._EntityProvider;
	}

	/**
	 * Fetch (and cache) the DISTINCT values of a column present in this recordset's data, via
	 * Meadow's `<Entity>s/Distinct/<Column>` endpoint. Drives the `ScopeToRecordSet` filter knob
	 * (an entity picker limited to `FBL~<Column>~INN~<these values>`) and the
	 * `DistinctSelectedValueList` filter type (a dropdown whose options ARE these values).
	 * Cached per column; the cache is cleared on create/update/delete through this provider.
	 *
	 * @param {string} pColumn
	 * @param {{ Filter?: string } | ((pError: Error|null, pValues: Array<any>) => void)} [pOptions] - Optional; `Filter` is a FoxHound stanza appended as `/FilteredTo/<Filter>` on the distinct query.
	 * @param {(pError: Error|null, pValues: Array<any>) => void} [fCallback]
	 */
	getRecordSetColumnDistinct(pColumn, pOptions, fCallback)
	{
		// Back-compat: (pColumn, fCallback)
		let tmpOptions = pOptions;
		let tmpCallback = fCallback;
		if (typeof tmpOptions === 'function')
		{
			tmpCallback = tmpOptions;
			tmpOptions = {};
		}
		tmpOptions = tmpOptions || {};
		// Unfiltered fetches keep the bare-column key (synchronous peeks elsewhere read it);
		// filtered fetches get their own key so the two never cross-pollinate.
		const tmpCacheKey = tmpOptions.Filter ? `${pColumn}::${tmpOptions.Filter}` : pColumn;
		this._scopeDistinctCache = this._scopeDistinctCache || {};
		if (Array.isArray(this._scopeDistinctCache[tmpCacheKey]))
		{
			return tmpCallback(null, this._scopeDistinctCache[tmpCacheKey]);
		}
		if (!this.options.Entity || !this.entityProvider || !this.entityProvider.restClient)
		{
			return tmpCallback(new Error('RecordSet provider cannot resolve a distinct request (missing Entity or rest client).'), []);
		}
		// De-duplicate CONCURRENT fetches for the same key. The cache above is only
		// written when a response lands, so callers that re-check it while a request
		// is still in flight all miss and each issue their own identical request.
		// The quick-filter views remount on every render epoch and re-check exactly
		// that way, so one filter apply fanned out into a dozen duplicate distinct
		// queries -- the bulk of the delay between clicking Apply and seeing rows.
		// Queue the extra callbacks against the outstanding request instead.
		this._scopeDistinctInFlight = this._scopeDistinctInFlight || {};
		if (Array.isArray(this._scopeDistinctInFlight[tmpCacheKey]))
		{
			this._scopeDistinctInFlight[tmpCacheKey].push(tmpCallback);
			return;
		}
		this._scopeDistinctInFlight[tmpCacheKey] = [];
		const tmpURL = `${this.options.URLPrefix || ''}${this.options.Entity}s/Distinct/${pColumn}${tmpOptions.Filter ? `/FilteredTo/${tmpOptions.Filter}` : ''}`;
		const tmpEntityProvider = this.entityProvider;
		/**
		 * Settle this key: cache the outcome, then notify the caller that issued the
		 * request plus everyone who asked for the same key while it was in flight.
		 *
		 * @param {Error|null} pSettleError
		 * @param {Array<any>} pValues
		 */
		const fSettleDistinct = (pSettleError, pValues) =>
		{
			// A create/update/delete may have reset the cache while this was in
			// flight; re-seat it rather than throwing on a null.
			this._scopeDistinctCache = this._scopeDistinctCache || {};
			this._scopeDistinctCache[tmpCacheKey] = pValues;
			const tmpWaiting = (this._scopeDistinctInFlight || {})[tmpCacheKey] || [];
			if (this._scopeDistinctInFlight) { delete this._scopeDistinctInFlight[tmpCacheKey]; }
			tmpCallback(pSettleError, pValues);
			for (let i = 0; i < tmpWaiting.length; i++)
			{
				tmpWaiting[i](pSettleError, pValues);
			}
		};
		const fHandleDistinctResult = (pError, pResponse, pBody) =>
		{
			if (pError || (pResponse && pResponse.statusCode > 299) || !Array.isArray(pBody))
			{
				this.pict.log.warn(`RecordSet [${this.options.RecordSet || this.options.Entity}] distinct fetch for [${pColumn}] failed; the scoped filter falls back to unscoped.`, { Error: pError && pError.message, URL: tmpURL });
				return fSettleDistinct(pError || new Error('distinct fetch returned a non-array'), []);
			}
			const tmpValues = [ ...new Set(pBody.map((pRecord) => pRecord && pRecord[pColumn]).filter((pValue) => pValue != null)) ];
			return fSettleDistinct(null, tmpValues);
		};
		// Route through POST /:Entity/Query (Distinct mode) when the endpoint
		// supports it — a long /FilteredTo/ stanza on the Distinct GET is the same
		// URI-length hazard the Query route exists to sidestep. Falls back to GET.
		const fResolveSupport = (typeof tmpEntityProvider.resolveEntityQuerySupport === 'function')
			? tmpEntityProvider.resolveEntityQuerySupport.bind(tmpEntityProvider)
			: (pEntity, pPrefix, fCb) => { return fCb(null, false); };
		fResolveSupport(this.options.Entity, this.options.URLPrefix, (pSupportError, pSupportsQuery) =>
		{
			if (pSupportsQuery)
			{
				const tmpBody = { Distinct: true, Columns: pColumn };
				if (tmpOptions.Filter)
				{
					tmpBody.Filter = tmpOptions.Filter;
				}
				return tmpEntityProvider.restClient.postJSON({ url: `${this.options.URLPrefix || ''}${this.options.Entity}s/Query`, body: tmpBody }, fHandleDistinctResult);
			}
			return tmpEntityProvider.restClient.getJSON(tmpURL, fHandleDistinctResult);
		});
	}

	/**
	 * @return {Array<string>} - The fields to ignore for filter availability.
	 */
	get ignoreFilterFields()
	{
		if (Array.isArray(this.options.IgnoreFilterFields))
		{
			return this.options.IgnoreFilterFields;
		}
		return [];
	}

	/**
	 * Columns that look like foreign keys but must NOT be prefetched as connected
	 * entities. Configure with `IgnoreConnectedEntityFields`.
	 *
	 * @return {Array<string>} - The field names to skip when inferring connected entities.
	 */
	get ignoreConnectedEntityFields()
	{
		if (Array.isArray(this.options.IgnoreConnectedEntityFields))
		{
			return this.options.IgnoreConnectedEntityFields;
		}
		return [];
	}

	/**
	 * Infer which columns are foreign keys worth prefetching as connected entities.
	 *
	 * Any `ID*` column other than the recordset's own primary key is treated as a
	 * reference. That inference is right for a normalized table and wrong for a
	 * DENORMALIZED one: a reporting/lake table routinely carries a source id
	 * (`IDDocument`, `IDProject`) as plain data, and prefetching it bulk-reads the
	 * DECORATED entity endpoint with an INN list of every distinct value on the
	 * page — a slow, paged fan-out that blocks the record bind and fetches records
	 * nothing renders.
	 *
	 * Two exclusions:
	 *   - `IgnoreConnectedEntityFields`, per recordset, for denormalized columns.
	 *   - Lake physical primary keys (`IDC<customer>_<Table>`), always: they do not
	 *     name an entity, so the read 404s and aborts the bind.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The page of records just read.
	 * @param {string} pEntity - The recordset's own entity name (its PK is never a reference).
	 * @return {Array<string>} - The ID columns to hand to the connected-entity cache.
	 */
	inferConnectedEntityIDFields(pRecords, pEntity)
	{
		const tmpIDFields = [ 'CreatingIDUser', 'UpdatingIDUser' ];
		if (!Array.isArray(pRecords) || !pRecords.length)
		{
			return tmpIDFields;
		}
		const tmpIgnored = this.ignoreConnectedEntityFields;
		for (const tmpColumn of Object.keys(pRecords[0]))
		{
			if (!tmpColumn.startsWith('ID') || tmpColumn === `ID${pEntity}`)
			{
				continue;
			}
			if (tmpIgnored.indexOf(tmpColumn) > -1)
			{
				continue;
			}
			// Lake physical PK (IDC182_PD_HmaMixSieveWide) — not an entity name.
			if (/^IDC\d+_/.test(tmpColumn))
			{
				continue;
			}
			tmpIDFields.push(tmpColumn);
		}
		return tmpIDFields;
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async getRecord(pIDOrGuid)
	{
		if (!this.options.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		// FIXME: The GUIDS are returning false to isNaN so this doesn't work
		if (typeof pIDOrGuid === 'string' && isNaN(parseInt(pIDOrGuid)))
		{
			return this.getRecordByGUID(pIDOrGuid);
		}
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Reading ${this.options.Entity} record by ID`, { ID: pIDOrGuid });
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.getEntity(this.options.Entity, pIDOrGuid, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pResult);
			});
		});
	}

	getGUIDField()
	{ 
		if (this._Schema?.MeadowSchema?.Schema?.length)
		{
			for (let field of this._Schema.MeadowSchema.Schema)
			{
				if (field.Type == 'AutoGUID')
				{
					return field.Column;
				}
			}
		}
		return `GUID${ this.options.Entity }`;
	}

	getIDField()
	{
		if (this._Schema?.MeadowSchema?.Schema?.length)
		{
			for (let field of this._Schema.MeadowSchema.Schema)
			{
				if (field.Type == 'AutoIdentity')
				{
					return field.Column;
				}
			}
		}
		return `ID${ this.options.Entity }`;
	}

	getDeletedField()
	{
		if (this._Schema?.MeadowSchema?.Schema?.length)
		{
			for (let field of this._Schema.MeadowSchema.Schema)
			{
				if (field.Type == 'Deleted')
				{
					return field.Column;
				}
			}
		}
		return 'Deleted';
	}

	/**
	 * Get a record by its ID or GUID.
	 *
	 * @param {string|number} pGuid - The ID or GUID of the record.
	 * @param {boolean} [pIncludeDeleted] - When true, also match soft-deleted records (the explicit
	 *                                      Deleted filter suppresses the automatic `Deleted = 0`).
	 */
	async getRecordByGUID(pGuid, pIncludeDeleted)
	{
		if (!this.options.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Reading ${this.options.Entity} record by GUID`, { GUID: pGuid });
		}
		let tmpFilterString = `FBV~${ this.getGUIDField() }~EQ~${encodeURIComponent(pGuid)}`;
		if (pIncludeDeleted === true)
		{
			tmpFilterString += `~FBL~${ this.getDeletedField() }~INN~0,1`;
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.getEntitySet(this.options.Entity, tmpFilterString, (pError, pResult) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				if (pResult.length > 1)
				{
					this.pict.log.error(`Multiple ${this.options.Entity} records found for GUID ${pGuid}`, { Records: pResult });
				}
				resolve(pResult[0]);
			});
		});
	}

	_prepareFilterState(pEntity, pOptions, pFilterExperienceResultAddress = 'Records')
	{
		const tmpClauses = [].concat(this.pict.Bundle._ActiveFilterState?.[pOptions.RecordSet || pOptions.Entity || this.options.Entity]?.FilterClauses || []);
		const tmpExperience = Object.assign({}, this.pict.Bundle._ActiveFilterState?.[pOptions.Entity || this.options.Entity]?.Experience || {});
		if (!tmpExperience.ResultDestinationAddress)
		{
			tmpExperience.ResultDestinationAddress = `Bundle._ActiveFilterState[\`${this.options.RecordSet}\`].${pFilterExperienceResultAddress}`;
		}
		if (!tmpExperience.Entity)
		{
			tmpExperience.Entity = pEntity;
		}
		if (pOptions.FilterString && typeof pOptions.FilterString === 'string' && pOptions.FilterString.trim().length > 0)
		{
			tmpClauses.push({ Type: 'RawFilter', Value: pOptions.FilterString });
		}
		// (The show-deleted switch needs no special handling here: it is a real RawFilter clause in
		// the active filter state — see setShowDeletedFilterValue on the base provider — so it rides
		// the FilterClauses concat above into both the records and count fetches.)
		return [ tmpClauses, tmpExperience ];
	}

	/**
	 * Derive the Lite `ExtraColumns` for a list fetch from the manifest's displayed
	 * columns. Lite already returns the ID-prefixed, GUID-prefixed, CreatingIDUser and
	 * UpdateDate fields plus a computed Value, so we only request the remaining scalar
	 * display columns — and only ones that are real, non-blob schema columns. Returns
	 * [] (caller then does a safe full fetch) if the manifest columns or schema are
	 * unavailable.
	 * @param {string} pEntity - The entity being listed.
	 * @param {Record<string, any>} pOptions - The list options (carries RecordSetConfiguration).
	 * @return {Array<string>} The ExtraColumns to request.
	 */
	_deriveLiteExtraColumns(pEntity, pOptions)
	{
		const tmpConfig = pOptions && pOptions.RecordSetConfiguration;
		let tmpDescriptors = null;
		if (tmpConfig && this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.manifestDefinitions)
		{
			const tmpManifestHash = tmpConfig.RecordSetListDefaultManifest || (Array.isArray(tmpConfig.RecordSetListManifests) ? tmpConfig.RecordSetListManifests[0] : null);
			const tmpManifest = tmpManifestHash ? this.pict.PictSectionRecordSet.manifestDefinitions[tmpManifestHash] : null;
			tmpDescriptors = (tmpManifest && tmpManifest.Descriptors) || null;
		}
		const tmpSchemaColumns = (this._Schema && this._Schema.MeadowSchema && Array.isArray(this._Schema.MeadowSchema.Schema)) ? this._Schema.MeadowSchema.Schema : [];
		if (!tmpDescriptors || tmpSchemaColumns.length < 1)
		{
			return [];
		}
		const tmpColumnType = {};
		for (const tmpColumn of tmpSchemaColumns)
		{
			if (tmpColumn && tmpColumn.Column)
			{
				tmpColumnType[tmpColumn.Column] = tmpColumn.Type;
			}
		}
		const tmpBlobTypes = { 'Text': true, 'JSON': true };
		const tmpColumns = [];
		for (const tmpKey of Object.keys(tmpDescriptors))
		{
			// ID*/GUID*/owner/update come back in every Lite record for free.
			if (tmpKey.startsWith('ID') || tmpKey.startsWith('GUID') || tmpKey === 'CreatingIDUser' || tmpKey === 'UpdateDate')
			{
				continue;
			}
			// Only request real, non-blob columns (a computed/templated manifest column
			// that is not a DB column would otherwise error the query).
			if (!(tmpKey in tmpColumnType) || tmpBlobTypes[tmpColumnType[tmpKey]])
			{
				continue;
			}
			if (!tmpColumns.includes(tmpKey))
			{
				tmpColumns.push(tmpKey);
			}
		}
		// Column chooser: union in user-shown schema-tier columns so a toggled-on column's data is
		// actually fetched. Same gauntlet as the descriptors; gated on the config flag so stale
		// stored overrides can never widen queries for lists that don't use the chooser.
		if (tmpConfig && tmpConfig.RecordSetListColumnChooser === true && this.pict.providers.ColumnDataProvider)
		{
			const tmpRecordSet = (pOptions && pOptions.RecordSet) || tmpConfig.RecordSet || pEntity;
			const tmpOverrides = this.pict.providers.ColumnDataProvider.getColumnVisibilityOverrides(tmpRecordSet, 'List');
			for (const tmpKey of Object.keys(tmpOverrides))
			{
				if (tmpOverrides[tmpKey] !== true)
				{
					continue;
				}
				if (tmpKey.startsWith('ID') || tmpKey.startsWith('GUID') || tmpKey === 'CreatingIDUser' || tmpKey === 'UpdateDate')
				{
					continue;
				}
				if (!(tmpKey in tmpColumnType) || tmpBlobTypes[tmpColumnType[tmpKey]])
				{
					continue;
				}
				if (!tmpColumns.includes(tmpKey))
				{
					tmpColumns.push(tmpKey);
				}
			}
		}
		return tmpColumns;
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecords(pOptions)
	{
		if (!this.options.Entity && !pOptions.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		const tmpEntity = pOptions.Entity || this.options.Entity;

		// Lite projection (opt-in via RecordSetListLiteFetch): request only the columns
		// the manifest displays so the list stops pulling blob columns (FormData, etc.).
		// Lite (partial) records are NOT written to the entity cache (see getEntitySetPage) —
		// the list renders them straight from state — so they can never poison the global
		// cache that full-record consumers (row-click View, {~E:~}) rely on. The list's
		// reference entities (Project/User) are full records and stay in the global cache,
		// batched reliably by the connected-entity prefetch + the stale-read prune fix.
		const tmpLiteFetch = (this.options.RecordSetListLiteFetch === true) || !!(pOptions && pOptions.RecordSetConfiguration && pOptions.RecordSetConfiguration.RecordSetListLiteFetch);
		let tmpProjection = null;
		if (tmpLiteFetch)
		{
			// Ensure the entity schema is loaded so we only request real, non-blob columns.
			if (!this._Schema)
			{
				await this.getRecordSchema();
			}
			const tmpExtraColumns = this._deriveLiteExtraColumns(tmpEntity, pOptions);
			if (tmpExtraColumns.length > 0)
			{
				tmpProjection = { Mode: 'LiteExtended', ExtraColumns: tmpExtraColumns };
			}
		}

		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Reading ${tmpEntity} records`, { Options: pOptions });
		}
		return new Promise((resolve, reject) =>
		{
			const [ tmpClauses, tmpExperience ] = this._prepareFilterState(tmpEntity, pOptions);
			if (tmpProjection)
			{
				tmpExperience.Projection = tmpProjection;
			}
			if (this.options.FilterEndpointOverride)
			{
				// Call the filtering endpoint with the clauses and experience.
				this.entityProvider.restClient.postJSON({
					url: `${ this.options.URLPrefix }${ this.options.FilterEndpointOverride }/${ pOptions.Offset || 0 }/${ pOptions.PageSize || 250 }`,
					body: { Clauses: tmpClauses, Experience: tmpExperience },
				}, (pError, response, result) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					this.fable.manifest.setValueByHash(this.pict, tmpExperience.ResultDestinationAddress, result);
					const recordsReturn = result;
					const IDFields = this.inferConnectedEntityIDFields(recordsReturn, tmpEntity);
					this.pict.EntityProvider.cacheConnectedEntityRecordsWithoutCount(recordsReturn, IDFields, ['User', 'User'], false, () =>
					{
						resolve({ Records: recordsReturn, Facets: { } });
					});
				});
				return;
			}
			this.pict.providers.FilterManager.loadRecordPageByFilterUsingProvider(this.entityProvider, tmpClauses, tmpExperience, pOptions.Offset || 0, pOptions.PageSize || 250, (pError) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				const recordsReturn = this.pict.resolveStateFromAddress(tmpExperience.ResultDestinationAddress);
				const IDFields = this.inferConnectedEntityIDFields(recordsReturn, tmpEntity);
				// Use the NoCount (lazy-page) batch: counts are very costly in this MySQL,
				// and the count-based variant serializes one slow COUNT per reference entity,
				// stalling the queue so later entities (e.g. Project) never batch and fall
				// back to per-row fetches. NoCount fetches each batch in one paged request
				// with real concurrency (maxOperations).
				this.pict.EntityProvider.cacheConnectedEntityRecordsWithoutCount(recordsReturn, IDFields, ['User', 'User'], false, () =>
				{
					resolve({ Records: recordsReturn, Facets: { } });
				});
			});
			// using a space here, otherwise you get a `//` in the URL which breaks some stuff
		});
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {string} [pFilterString] - The filter string to apply.
	 * @param {number} [pOffset] - The starting record number for pagination.
	 * @param {number} [pPageSize] - The number of records to return.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async getRecordsInline(pFilterString = '', pOffset = 0, pPageSize = 250)
	{
		return this.getRecords({ FilterString: pFilterString, Offset: pOffset, PageSize: pPageSize });
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 */
	async getRecordSetCount(pOptions)
	{
		if (!this.options.Entity && !pOptions.Entity)
		{
			throw new Error('Entity is not defined in the provider options.');
		}
		const tmpEntity = pOptions.Entity || this.options.Entity;
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Counting ${tmpEntity} records`, { Options: pOptions });
		}
		//TODO: lite support / other variants?
		return new Promise((resolve, reject) =>
		{
			const [ tmpClauses, tmpExperience ] = this._prepareFilterState(tmpEntity, pOptions, 'Count');
			// The record count is identical for every page of the same filter, yet the list re-counts on each
			// pagination click. A COUNT is expensive on some database engines, so cache it keyed by the compiled
			// filter signature: same filter -> serve the cached count (no request); changed filter -> re-count.
			// Mutations through this provider clear the cache (see createRecord / updateRecord / deleteRecord).
			const tmpCountCacheKey = `${ tmpEntity }::${ JSON.stringify(tmpClauses) }`;
			if (this._RecordSetCountCache && this._RecordSetCountCache.Key === tmpCountCacheKey)
			{
				// Publish the cached count to the result address so downstream consumers behave identically to a fetch.
				this.fable.manifest.setValueByHash(this.pict, tmpExperience.ResultDestinationAddress, this._RecordSetCountCache.Count);
				return resolve({ Count: this._RecordSetCountCache.Count });
			}
			if (this.options.FilterEndpointOverride)
			{
				// Call the filtering endpoint with the clauses and experience.
				this.entityProvider.restClient.postJSON({
					url: `${ this.options.URLPrefix }${ this.options.FilterEndpointOverride }/Count`,
					body: { Clauses: tmpClauses, Experience: tmpExperience },
				}, (error, response, result) =>
				{
					if (error)
					{
						return reject(error);
					}
					const tmpCount = result?.Count || 0;
					this.fable.manifest.setValueByHash(this.pict, tmpExperience.ResultDestinationAddress, tmpCount);
					this._RecordSetCountCache = { Key: tmpCountCacheKey, Count: tmpCount };
					resolve(result);
				});
				return;
			}
			this.pict.providers.FilterManager.countRecordsByFilterUsingProivider(this.entityProvider, tmpClauses, tmpExperience, (pError) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				const tmpCount = this.pict.resolveStateFromAddress(tmpExperience.ResultDestinationAddress);
				this._RecordSetCountCache = { Key: tmpCountCacheKey, Count: tmpCount };
				resolve({ Count: tmpCount });
			});
		});
	}

	/**
	 * Create a new record.
	 *
	 * @param {Record<string, any>} pRecord - The record to create.
	 */
	async createRecord(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.info(`Creating record ${this.options.Entity}`, { Record: pRecord });
			}
			this.entityProvider.restClient.postJSON({
				url: `${this.options.URLPrefix}${this.options.Entity}`,
				body: pRecord,
			}, (error, response, result) =>
			{
				if (error)
				{
					return reject(error);
				}
				// A new record changes the total; drop the cached count so the next render re-counts.
				this._RecordSetCountCache = null;
				// Mutations can introduce/retire column values; drop the distinct cache so
				// ScopeToRecordSet scoping and DistinctSelectedValueList dropdowns refresh.
				this._scopeDistinctCache = null;
				this._scopeDistinctInFlight = null;
				// Drop this list's scoped cache too, so the next render re-fetches fresh.
				if (typeof this.pict.EntityProvider.clearScope === 'function')
				{
					this.pict.EntityProvider.clearScope(`RSList::${ this.options.RecordSet || this.options.Entity }`);
				}
				resolve(result);
			});
		});
	}

	/**
	 * Update a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to update.
	 */
	async updateRecord(pRecord)
	{
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Updating record ${this.options.Entity} ${pRecord[this.getIDField()]}`);
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.restClient.putJSON({
				url: `${this.options.URLPrefix}${this.options.Entity}`,
				body: pRecord,
			}, (error, response, result) =>
			{
				if (error)
				{
					return reject(error);
				}
				// An edit can move a record in or out of the active filter; drop the cached count to be safe.
				this._RecordSetCountCache = null;
				// Mutations can introduce/retire column values; drop the distinct cache so
				// ScopeToRecordSet scoping and DistinctSelectedValueList dropdowns refresh.
				this._scopeDistinctCache = null;
				this._scopeDistinctInFlight = null;
				// Drop this list's scoped cache too, so the next render re-fetches fresh.
				if (typeof this.pict.EntityProvider.clearScope === 'function')
				{
					this.pict.EntityProvider.clearScope(`RSList::${ this.options.RecordSet || this.options.Entity }`);
				}
				resolve(result);
			});
		});
	}

	/**
	 * Delete a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to delete.
	 */
	async deleteRecord(pRecord)
	{
		if (this.pict.LogNoisiness > 1)
		{
			this.pict.log.info(`Deleting record ${this.options.Entity} ${pRecord[this.getIDField()]}`);
		}
		return new Promise((resolve, reject) =>
		{
			this.entityProvider.restClient.delJSON({
				url: `${this.options.URLPrefix}${this.options.Entity}/${pRecord[this.getIDField()]}`,
				body: pRecord,
			}, (error, response, result) =>
			{
				if (error)
				{
					return reject(error);
				}
				// A delete changes the total; drop the cached count so the next render re-counts.
				this._RecordSetCountCache = null;
				// Mutations can introduce/retire column values; drop the distinct cache so
				// ScopeToRecordSet scoping and DistinctSelectedValueList dropdowns refresh.
				this._scopeDistinctCache = null;
				this._scopeDistinctInFlight = null;
				// Drop this list's scoped cache too, so the next render re-fetches fresh.
				if (typeof this.pict.EntityProvider.clearScope === 'function')
				{
					this.pict.EntityProvider.clearScope(`RSList::${ this.options.RecordSet || this.options.Entity }`);
				}
				resolve(result);
			});
		});
	}

	/**
	 * Read a record.
	 *
	 * @param {string|number} pIDOrGuid - The ID or GUID of the record.
	 */
	async readRecord(pIDOrGuid)
	{
		return this.getRecord(pIDOrGuid);
	}

	/**
	 * Read records from the provider.
	 *
	 * @param {RecordSetFilter} pOptions - Options for the read operation.
	 * @return {Promise<RecordSetResult>} - The result of the read operation.
	 */
	async readRecords(pOptions)
	{
		return this.getRecords(pOptions);
	}

	/**
	 * Clone a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clone.
	 */
	async cloneRecord(pRecord)
	{
		return this.createRecord(this.cleanRecord(pRecord));
	}

	/**
	 * Remove any intrinsic identifiers from a record.
	 *
	 * @param {Record<string, any>} pRecord - The record to clean.
	 */
	cleanRecord(pRecord)
	{
		delete pRecord[this.getIDField()];
		delete pRecord[this.getGUIDField()];
		return pRecord;
	}

	/**
	 * The "list entry" display template for an entity — how one of its records should read as a single line
	 * in a picker option / selected chip. Returns a pict template string (rendered against the raw record by
	 * the picker's TextTemplate), or null to fall back to a single display field.
	 *
	 * This is deliberately a small, overridable seam: today it hard-knows `User` (whose name lives across
	 * NameFull / NameFirst+NameLast and needs an Email/LoginID disambiguator), but the intent is that this
	 * eventually reads a per-entity template off the Stricture schema instead of branching here.
	 *
	 * @param {string} pEntityName - The entity (e.g. 'User').
	 * @return {string|null}
	 */
	getEntityListEntryTemplate(pEntityName)
	{
		// Register the User branching fall-backs once. addTemplate is idempotent (keyed by hash), so the
		// guard is just to avoid the churn of re-registering on every descriptor build.
		if (!this._entityListEntryTemplatesRegistered)
		{
			this._entityListEntryTemplatesRegistered = true;
			// Name fallback: when NameFull is empty, compose it from the parts.
			this.pict.TemplateProvider.addTemplate('RSP-EntityListEntry-User-NameParts', '{~D:Record.NameFirst~} {~D:Record.NameLast~}');
			// Disambiguator fallback: when Email is empty, use the LoginID.
			this.pict.TemplateProvider.addTemplate('RSP-EntityListEntry-User-Login', '{~D:Record.LoginID~}');
		}

		switch (pEntityName)
		{
			case 'User':
				// "<name> (<email>)" — name is NameFull, else NameFirst+NameLast; the parenthetical is Email,
				// else LoginID. Stable across the three name-field variations and unique enough to tell apart
				// many same-named users.
				return '{~DWTF:Record.NameFull:RSP-EntityListEntry-User-NameParts~} ({~DWTF:Record.Email:RSP-EntityListEntry-User-Login~})';
			default:
				return null;
		}
	}

	/**
	 * @param {string} pSchemaField - The schema field name.
	 * @param {Record<string, any>} pColumn - The full column definition from the schema.
	 * @param {Record<string, any>} [pMeadowSchemaField] - The meadow schema field definition.
	 */
	getFieldFilterClauses(pSchemaField, pColumn, pMeadowSchemaField)
	{
		/** @type {Record<string, any>} */
		let tmpRangeClause;
		let tmpFieldFilterClauses = this.options.FieldFilterClauses?.[pSchemaField];
		if (!Array.isArray(tmpFieldFilterClauses))
		{
			let tmpFieldType = pColumn.type;
			if (pMeadowSchemaField && typeof pMeadowSchemaField.Type === 'string')
			{
				tmpFieldType = pMeadowSchemaField.Type.toLowerCase();
			}
			tmpFieldFilterClauses = [];
			const tmpFieldHumanName = this.getHumanReadableFieldName(pSchemaField);
			const isUserAuditField = ['CreatingIDUser', 'DeletingIDUser', 'UpdatingIDUser'].includes(pSchemaField);
			const customFilterClauses = this.options.Filters?.[pSchemaField];
			// The entity's own identity column (AutoIdentity / AutoGUID) — i.e. the primary key.
			const isOwnIdentityField = pMeadowSchemaField && (pMeadowSchemaField.Type === 'AutoIdentity' || pMeadowSchemaField.Type === 'AutoGUID');
			const isForeignKeyLike = pSchemaField.startsWith('ID') || pSchemaField.startsWith('ParentID') || isUserAuditField || customFilterClauses;
			if (isForeignKeyLike)
			{
				for (const customField of Array.isArray(customFilterClauses) ? customFilterClauses : [customFilterClauses])
				{
					// The table the picker pulls from: an explicit RemoteTable, else this
					// recordset's declared Entity when the column is our own primary key (the PK
					// references our own records), else the name peeled from the column for a
					// plain foreign key. Peeling alone is the defect — a lake PK like
					// `IDC182_HMA_MixDesign` peels to a table name that is not the entity name.
					const remoteTableName = customField?.RemoteTable || (isOwnIdentityField ? this.options.Entity : pSchemaField.split('ID')[1]);
					const fieldName = this.getHumanReadableFieldName(pSchemaField);
					tmpFieldFilterClauses.push(Object.assign(
					{
						"Label": `${ fieldName }`,
						"Type": "InternalJoinSelectedValueList",
						"ExternalFilterByColumns": remoteTableName === 'User' ? [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ] : [ 'Name' ],
						"ExternalRecordDisplayTemplate": remoteTableName === 'User' ? '{~D:Record.Data.NameFirst~} {~D:Record.Data.NameLast~}' : '{~D:Record.Name~}',
						// The picker's option/selected display: a per-entity "list entry" template (the seam that
						// will eventually live on the Stricture schema). Disambiguates beyond a single column.
						"EntityListEntryTemplate": this.getEntityListEntryTemplate(remoteTableName),
						"CoreConnectionColumn": pSchemaField,
						"RemoteTable": `${ remoteTableName }`,
						"URLPrefix": this.options.URLPrefix,
						"JoinExternalConnectionColumn": `ID${ remoteTableName }`,
						"JoinInternalConnectionColumn": pSchemaField,
						'DisplayName': `Selected Records`,
						'Ordinal': tmpFieldFilterClauses.length + 1,
						'FilterKey': pSchemaField,
						'ClauseKey': `${pSchemaField}_Selected`
					}, customField));
				}
			}
			// The primary key is also a plain integer key, so it ALSO falls through to the
			// Exact / In Range clauses below. A real foreign key gets only the picker; ordinary
			// columns are matched by type.
			if (!isForeignKeyLike || isOwnIdentityField)
			{
				switch (tmpFieldType)
				{
					case 'string':
					case 'autoguid':
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Exact`, Label: `${tmpFieldHumanName} Exact Match`, DisplayName: `Exact Match`, Type: 'StringMatch', FilterByColumn: pSchemaField, ExactMatch: true, Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Fuzzy`, Label: `${tmpFieldHumanName} Partial Match`, DisplayName: `Partial Match`, Type: 'StringMatch', FilterByColumn: pSchemaField, ExactMatch: false , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpRangeClause = { FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Range`, Label: `${tmpFieldHumanName} In Range`, DisplayName: `In Range`, Type: 'StringRange', FilterByColumn: pSchemaField , Ordinal: tmpFieldFilterClauses.length + 1 };
						tmpRangeClause.MinimumLabel = `Minimum ${tmpFieldHumanName}`;
						tmpRangeClause.MaximumLabel = `Maximum ${tmpFieldHumanName}`;
						tmpFieldFilterClauses.push(tmpRangeClause);
						break;
					case 'date':
					case 'datetime':
					case 'createdate':
					case 'updatedate':
					case 'deletedate':
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Exact`, Label: `${tmpFieldHumanName} Exact Match`, DisplayName: `Exact Match`, Type: 'DateMatch', FilterByColumn: pSchemaField, ExactMatch: true , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Fuzzy`, Label: `${tmpFieldHumanName} Partial Match`, DisplayName: `Partial Match`, Type: 'DateMatch', FilterByColumn: pSchemaField, ExactMatch: false , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpRangeClause = { FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Range`, Label: `${tmpFieldHumanName} In Range`, DisplayName: `In Range`, Type: 'DateRange', FilterByColumn: pSchemaField , Ordinal: tmpFieldFilterClauses.length + 1 };
						tmpRangeClause.MinimumLabel = `Minimum ${tmpFieldHumanName}`;
						tmpRangeClause.MaximumLabel = `Maximum ${tmpFieldHumanName}`;
						tmpFieldFilterClauses.push(tmpRangeClause);
						break;
					case 'boolean':
						// A boolean is stored 0/1 — offer ONE Yes/No control, not the Exact/Partial/In-Range
						// set that made booleans confusing to filter. It COMPILES as an exact NumericMatch
						// (EQ 0/1), so no new pict Filter.js type is needed; `FilterRenderType` routes it to
						// the Yes/No <select> view (RecordSet-Filter-BooleanMatch).
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Boolean`, Label: `${tmpFieldHumanName}`, DisplayName: `Yes / No`, Type: 'NumericMatch', FilterRenderType: 'BooleanMatch', FilterByColumn: pSchemaField, ExactMatch: true, Ordinal: tmpFieldFilterClauses.length + 1 });
						break;
					case 'deleted':
					case 'integer':
					case 'decimal':
					case 'autoidentity':
					case 'createiduser':
					case 'updateiduser':
					case 'deleteiduser':
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Exact`, Label: `${tmpFieldHumanName} Exact Match`, DisplayName: `Exact Match`, Type: 'NumericMatch', FilterByColumn: pSchemaField, ExactMatch: true , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpFieldFilterClauses.push({ FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Match_Fuzzy`, Label: `${tmpFieldHumanName} Partial Match`, DisplayName: `Partial Match`, Type: 'NumericMatch', FilterByColumn: pSchemaField, ExactMatch: false , Ordinal: tmpFieldFilterClauses.length + 1 });
						tmpRangeClause = { FilterKey: pSchemaField, ClauseKey: `${pSchemaField}_Range`, Label: `${tmpFieldHumanName} In Range`, DisplayName: `In Range`, Type: 'NumericRange', FilterByColumn: pSchemaField , Ordinal: tmpFieldFilterClauses.length + 1 };
						tmpRangeClause.MinimumLabel = `Minimum ${tmpFieldHumanName}`;
						tmpRangeClause.MaximumLabel = `Maximum ${tmpFieldHumanName}`;
						tmpFieldFilterClauses.push(tmpRangeClause);
						break;
					default:
						this.pict.log.warn(`Unsupported field type ${pColumn.type} for field ${pSchemaField}`, { Schema: pColumn });
				}
			}
		}
		return tmpFieldFilterClauses;
	}

	/**
	 * @param {(error?: Error) => void} fCallback - The callback function.
	 */
	onInitializeAsync(fCallback)
	{
		super.onInitializeAsync((pError) =>
		{
			//FIXME: load the most recent experience from local storage using the other provider
			//       how do we control the initialization order of the providers?
			if (this.options.FilterExperiences && typeof this.options.FilterExperiences === 'object' && !Array.isArray(this.options.FilterExperiences))
			{
				this.pict.Bundle._ActiveFilterState = this.pict.Bundle._ActiveFilterState || {};
				this.pict.Bundle._ActiveFilterState[this.options.RecordSet] = this.pict.Bundle._ActiveFilterState[this.options.RecordSet] || {};
				const tmpEntityFilterState = this.pict.Bundle._ActiveFilterState[this.options.RecordSet];
				tmpEntityFilterState.Experience = tmpEntityFilterState.Experience || {};
				for (const tmpKey of Object.keys(this.options.FilterExperiences))
				{
					const tmpExperience = this.options.FilterExperiences[tmpKey];
					if (!tmpExperience.FilterCriteriaHash && !Array.isArray(tmpExperience.FilterClauses))
					{
						this.log.warn(`Filter experience ${tmpKey} has invalid Criteria`, { Experience: tmpExperience });
						continue;
					}
					if (tmpExperience.FilterCriteriaHash)
					{
						// load from hash
						const tmpClauses = this.pict.providers.FilterManager.getFilterCriteria(tmpExperience.FilterCriteriaHash);
						if (!tmpClauses)
						{
							this.pict.log.warn(`Filter experience ${tmpKey} filter criteria hash ${tmpExperience.FilterCriteriaHash} not found`, { Experience: tmpExperience });
							continue;
						}
						//TODO: handle Ordinal / generate if missing
						this._Experiences[tmpKey] = JSON.parse(JSON.stringify(tmpExperience));
						this._Experiences[tmpKey].FilterClauses = JSON.parse(JSON.stringify(tmpClauses));
						for (const tmpClause of this._Experiences[tmpKey].FilterClauses)
						{
							tmpClause.FilterCriteriaHash = tmpExperience.FilterCriteriaHash;
							if (!tmpClause.FilterByColumn && !tmpClause.CoreConnectionColumn && !tmpClause.JoinInternalConnectionColumn)
							{
								this.log.warn(`Filter experience ${tmpKey} clause does not have filter by column configured`, { Clause: tmpClause });
								continue;
							}
							if (tmpClause.FilterDefinitionHash)
							{
								const tmpFilter = this.pict.providers.FilterManager.getFilter(tmpClause.FilterDefinitionHash);
								if (!tmpFilter)
								{
									this.pict.log.warn(`Filter experience ${tmpKey} filter criteria hash ${tmpClause.FilterDefinitionHash} not found`, { Experience: tmpExperience });
									continue;
								}
								Object.assign(tmpClause, tmpFilter); //TODO: is there a risk of leakage here?
								if (tmpClause.FilterByColumn && typeof tmpClause.Type === 'string')
								{
									if (tmpClause.Type.startsWith('InternalJoin'))
									{
										tmpClause.JoinInternalConnectionColumn = tmpClause.FilterByColumn;
									}
									else if (tmpClause.Type.startsWith('ExternalJoin'))
									{
										tmpClause.CoreConnectionColumn = tmpClause.FilterByColumn;
									}
								}
							}
						}
						if (tmpExperience.Default && !tmpEntityFilterState.FilterClauses)
						{
							tmpEntityFilterState.FilterClauses = JSON.parse(JSON.stringify(this._Experiences[tmpKey].FilterClauses));
							for (const tmpClause of tmpEntityFilterState.FilterClauses)
							{
								tmpClause.Hash = `${tmpClause.FilterByColumn}-${tmpClause.Type}-${this.pict.getUUID()}`;
							}
						}
						continue;
					}
					this._Experiences[tmpKey] = JSON.parse(JSON.stringify(tmpExperience));
					if (tmpExperience.Default && !tmpEntityFilterState.FilterClauses)
					{
						tmpEntityFilterState.FilterClauses = JSON.parse(JSON.stringify(tmpExperience.FilterClauses));
					}
				}
			}
			if (pError)
			{
				return fCallback(pError);
			}
			// Do NOT fetch the per-entity `<Entity>/Schema` at initialization. The
			// application initializes EVERY registered record-set provider (an app
			// can register dozens), so fetching here — even non-blocking — makes boot
			// fire one `<Entity>/Schema` round-trip per record set, whether or not
			// that record set is ever viewed (tens of round-trips against a remote
			// API on a landing page that shows no lists). Defer entirely: the
			// List/Read/Create/Dashboard views each `await getRecordSchema()` before
			// rendering, so the schema loads lazily for the record sets actually
			// viewed. The one exception is a manifest-provided schema, which costs no
			// round-trip — prime that eagerly so filters are ready with zero latency.
			if (this.options.ProvidedSchema && typeof this.options.ProvidedSchema === 'object')
			{
				this._ensureEntitySchemaAsync().catch((pSchemaError) =>
				{
					this.fable.log.error(`Error initializing entity schema for ${this.options.Entity}: ${pSchemaError?.message || pSchemaError}`, { Stack: pSchemaError?.stack });
				});
			}
			return fCallback();
		});
	}

	/**
	 * @param {string} pEntity - The schema field name.
	 * @return {string} - The human-readable name for the entity.
	 */
	_getHumanReadableEntityName(pEntity)
	{
		return pEntity.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
	}

	/**
	 * @param {string} pSchemaField - The schema field name.
	 * @return {string} - The human-readable name for the schema field.
	 */
	getHumanReadableFieldName(pSchemaField)
	{
		if (!this._Schema || !this._Schema.properties || !this._Schema.properties[pSchemaField])
		{
			return pSchemaField;
		}
		if (pSchemaField === this.getIDField())
		{
			return `${this._getHumanReadableEntityName(this.options.Entity)} Unique Database ID`;
		}
		if (pSchemaField === this.getGUIDField())
		{
			return `${this._getHumanReadableEntityName(this.options.Entity)} Unique Identifier`;
		}
		if (pSchemaField === 'CreatingIDUser')
		{
			return 'Created By User';
		}
		if (pSchemaField === 'CreateDate')
		{
			return 'Date Created';
		}
		if (pSchemaField === 'UpdatingIDUser')
		{
			return 'Last Updated By User';
		}
		if (pSchemaField === 'UpdateDate')
		{
			return 'Date Last Updated';
		}
		if (pSchemaField.startsWith('ID'))
		{
			return this._getHumanReadableEntityName(pSchemaField.split('ID')[1]);
		}
		if (pSchemaField.startsWith('ParentID'))
		{
			return 'Parent ' + this._getHumanReadableEntityName(pSchemaField.split('ID')[1]);
		}
		return pSchemaField.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
	}

	/**
	 * Load the entity schema (and derive the filter schema from it) exactly once,
	 * sharing a single in-flight network round-trip across every caller.
	 *
	 * The `<Entity>/Schema` fetch used to run inline in `onInitializeAsync`,
	 * blocking each provider's init callback; against the serial provider-init
	 * queue that turned N record sets into N back-to-back round-trips at startup.
	 * The fetch is now deferred and pulled in on demand by `getRecordSchema()`.
	 * Caching the promise here guarantees the deferred background load and any
	 * on-demand call never double-fetch — nor double-run the append-only
	 * `initializeFilterSchema()`. A manifest can still hand the schema over up
	 * front via `options.ProvidedSchema` (resolves synchronously, no round-trip).
	 * Resolves with the schema (or null when the endpoint does not support a
	 * Schema capability); a failed/unsupported load clears the cached handle so a
	 * later attempt can retry.
	 *
	 * @return {Promise<Record<string, any> | null>} the loaded entity schema
	 */
	_ensureEntitySchemaAsync()
	{
		if (this._Schema)
		{
			return Promise.resolve(this._Schema);
		}
		// A caller can hand this provider its schema up front (options.ProvidedSchema) -- the app
		// manifest bundles each entity's schema so boot skips the per-entity /Schema round trip. It
		// is the same object the /Schema endpoint returns, so every downstream reader behaves
		// identically. When it is absent we fall through to the (deferred) network fetch.
		if (this.options.ProvidedSchema && typeof this.options.ProvidedSchema === 'object')
		{
			this._Schema = this.options.ProvidedSchema;
			// Seed the entity provider's capability cache from the supplied schema, the same as the
			// fetch path below, so reads still detect POST /Query support without a probe.
			if (this.entityProvider && typeof this.entityProvider.primeEntityCapabilityFromSchema === 'function')
			{
				this.entityProvider.primeEntityCapabilityFromSchema(this.options.Entity, this._Schema, this.options.URLPrefix);
			}
			this.initializeFilterSchema();
			return Promise.resolve(this._Schema);
		}
		if (this._SchemaInitPromise)
		{
			return this._SchemaInitPromise;
		}
		this._SchemaInitPromise = (async () =>
		{
			this.fable.log.info('Initializing RecordSetProvider-MeadowEndpoints');
			const tmpCheckSession = this.pict.services.PictSectionRecordSet ? this.pict.services.PictSectionRecordSet.checkSession.bind(this.pict.services.PictSectionRecordSet) : async () => true;
			const tmpSupported = await tmpCheckSession('Schema');
			if (!tmpSupported)
			{
				return null;
			}
			// Go through the entity provider's SHARED schema cache rather than
			// fetching the URL ourselves. The capability probe reads the same
			// `<Entity>/Schema`, and when each side had its own single-flight the
			// identical schema was fetched twice per recordset. Requires
			// pict >= the release that adds getEntitySchema; older builds fall
			// back to the direct read.
			const tmpSchema = await new Promise((resolve, reject) =>
			{
				if (typeof this.entityProvider.getEntitySchema === 'function')
				{
					return this.entityProvider.getEntitySchema(this.options.Entity, this.options.URLPrefix, (pError, pResult) =>
					{
						if (pError)
						{
							return reject(pError);
						}
						return resolve(pResult);
					});
				}
				this.entityProvider.restClient.getJSON(`${this.options.URLPrefix}${this.options.Entity}/Schema`, (pError, pResponse, pResult) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					return resolve(pResult);
				});
			});
			this._Schema = tmpSchema;
			// The schema response carries the endpoint's version/capability
			// metadata; seed the entity provider's capability cache from it so
			// reads avoid a redundant capability probe.
			if (this.entityProvider && typeof this.entityProvider.primeEntityCapabilityFromSchema === 'function')
			{
				this.entityProvider.primeEntityCapabilityFromSchema(this.options.Entity, tmpSchema, this.options.URLPrefix);
			}
			// Derive the filter schema from the entity schema now that it is loaded.
			// This is append-only, so the single-flight promise keeps it to one run.
			this.initializeFilterSchema();
			return this._Schema;
		})()
			.then((pSchema) =>
			{
				// A no-op (unsupported) load leaves `_Schema` null; drop the cached
				// handle so a subsequent call can retry the capability probe.
				if (!this._Schema)
				{
					this._SchemaInitPromise = null;
				}
				return pSchema;
			})
			.catch((pError) =>
			{
				this.fable.log.error(`Error fetching schema: ${pError?.message || pError}`, { Stack: pError?.stack });
				this._Schema = null;
				this._SchemaInitPromise = null;
				throw pError;
			});
		return this._SchemaInitPromise;
	}

	/**
	 * Backwards-compatible callback wrapper around {@link _ensureEntitySchemaAsync}.
	 * @param {(error?: Error) => void} fCallback - The callback function.
	 */
	initializeEntitySchema(fCallback)
	{
		this._ensureEntitySchemaAsync().then(() => fCallback(null)).catch((pError) => fCallback(pError));
	}

	initializeFilterSchema()
	{
		const tmpSchema = this._Schema;
		if (!tmpSchema || !tmpSchema.properties)
		{
			return;
		}
		const tmpProperties = tmpSchema?.properties;
		// loop through the schema and add the columns to the tableCells
		let tmpOrdinal = 0;
		for (const tmpSchemaField in tmpProperties)
		{
			if (this.ignoreFilterFields.includes(tmpSchemaField))
			{
				continue;
			}
			++tmpOrdinal;
			const tmpColumn = tmpProperties[tmpSchemaField];
			// The Meadow schema endpoint nests its canonical column array (the one carrying each column's
			// semantic Type — CreateDate/UpdateDate/CreateIDUser/… — which is what distinguishes a date
			// column from a plain string; the JSON-schema `type` flattens both to "string"). Read the
			// nested path, falling back to the legacy flat path for older endpoints.
			const tmpMeadowSchemaArray = tmpSchema.MeadowSchema?.MeadowSchema?.Schema || tmpSchema.MeadowSchema?.Schema;
			const tmpMeadowSchemaField = Array.isArray(tmpMeadowSchemaArray) ? tmpMeadowSchemaArray.find((f) => f.Column === tmpSchemaField) : undefined;
			let tmpFieldFilterSchema = this._FilterSchema[tmpSchemaField];
			if (!tmpFieldFilterSchema)
			{
				this._FilterSchema[tmpSchemaField] = tmpFieldFilterSchema = { };
			}
			if (!tmpFieldFilterSchema.FilterKey)
			{
				tmpFieldFilterSchema.FilterKey = tmpSchemaField;
			}
			if (!tmpFieldFilterSchema.RecordSet)
			{
				tmpFieldFilterSchema.RecordSet = this.options.RecordSet;
			}
			if (!tmpFieldFilterSchema.DisplayName)
			{
				tmpFieldFilterSchema.DisplayName = this.getHumanReadableFieldName(tmpSchemaField);
			}
			if (!tmpFieldFilterSchema.Description)
			{
				tmpFieldFilterSchema.Description = `Filter by ${tmpFieldFilterSchema.DisplayName}`;
			}
			if (!tmpFieldFilterSchema.HelpText)
			{
				tmpFieldFilterSchema.HelpText = `Filter by ${tmpFieldFilterSchema.DisplayName} for the ${this._getHumanReadableEntityName(this.options.Entity)} entity.`;
			}
			if (tmpFieldFilterSchema.Ordinal == null)
			{
				tmpFieldFilterSchema.Ordinal = tmpOrdinal;
			}
			if (!Array.isArray(tmpFieldFilterSchema.AvailableClauses))
			{
				tmpFieldFilterSchema.AvailableClauses = [];
			}
			const tmpFieldFilterClauses = this.getFieldFilterClauses(tmpSchemaField, tmpColumn, tmpMeadowSchemaField);
			if (Array.isArray(tmpFieldFilterClauses) && tmpFieldFilterClauses.length > 0)
			{
				for (const tmpFilterClause of tmpFieldFilterClauses)
				{
					//TODO: allow customization of filter order
					tmpFilterClause.Ordinal = tmpFieldFilterSchema.AvailableClauses.length + 1;
					tmpFieldFilterSchema.AvailableClauses.push(tmpFilterClause);
				}
			}
		}
		if (typeof this.pict.providers.FilterManager.filters === 'object')
		{
			for (const tmpFilterKey of Object.keys(this.pict.providers.FilterManager.filters))
			{
				const tmpFilterClause = this.pict.providers.FilterManager.filters[tmpFilterKey];
				// Two recognised host-declared filter shapes:
				//   (1) Foreign-key join — `CoreConnectionColumn` equals this recordset's
				//       PK (e.g. a Sample filter whose data flow joins on IDSample). Folded
				//       into `_FilterSchema[FilterKey]` for back-compat with the existing
				//       behaviour.
				//   (2) Plain column filter — declares `FilterByColumn` and wants to surface
				//       as the column's filter entry. Folded into
				//       `_FilterSchema[FilterByColumn]` so the Add Filter popover / Quick
				//       Filter resolver find it under the same slot the schema-derived
				//       entries use.
				// Optional per-recordset scoping: when the filter clause declares a
				// `RecordSet`, only fold into providers whose `options.RecordSet` matches.
				// Lets a host register the same `FilterByColumn` under different definitions
				// per dashboard without cross-pollination.
				if (tmpFilterClause.RecordSet && tmpFilterClause.RecordSet !== this.options.RecordSet)
				{
					continue;
				}
				const tmpIsCoreConnection = (tmpFilterClause.CoreConnectionColumn === this.getIDField());
				const tmpHasFilterByColumn = !!tmpFilterClause.FilterByColumn;
				if (!tmpIsCoreConnection && !tmpHasFilterByColumn)
				{
					continue;
				}
				const tmpSlotKey = tmpIsCoreConnection ? tmpFilterKey : tmpFilterClause.FilterByColumn;
				if (this.ignoreFilterFields.includes(tmpSlotKey))
				{
					continue;
				}
				let tmpFieldFilterSchema = this._FilterSchema[tmpSlotKey];
				if (!tmpFieldFilterSchema)
				{
					this._FilterSchema[tmpSlotKey] = tmpFieldFilterSchema = { };
				}
				if (!tmpFieldFilterSchema.FilterKey)
				{
					tmpFieldFilterSchema.FilterKey = tmpSlotKey;
				}
				if (!tmpFieldFilterSchema.RecordSet)
				{
					tmpFieldFilterSchema.RecordSet = this.options.RecordSet;
				}
				const tmpFieldHumanName = this.getHumanReadableFieldName(tmpSlotKey);
				if (tmpFilterClause.DisplayName)
				{
					tmpFieldFilterSchema.DisplayName = tmpFilterClause.DisplayName;
				}
				if (!tmpFieldFilterSchema.DisplayName)
				{
					tmpFieldFilterSchema.DisplayName = tmpFieldHumanName;
				}
				if (!tmpFieldFilterSchema.Description)
				{
					tmpFieldFilterSchema.Description = tmpFilterClause.Description || `Filter by ${tmpFieldFilterSchema.DisplayName}`;
				}
				if (!tmpFieldFilterSchema.HelpText)
				{
					tmpFieldFilterSchema.HelpText = tmpFilterClause.HelpText || `Filter by ${tmpFieldFilterSchema.DisplayName} for the ${this._getHumanReadableEntityName(this.options.Entity)} entity.`;
				}
				if (tmpFieldFilterSchema.Ordinal == null)
				{
					tmpFieldFilterSchema.Ordinal = tmpOrdinal;
				}
				if (!Array.isArray(tmpFieldFilterSchema.AvailableClauses))
				{
					tmpFieldFilterSchema.AvailableClauses = [];
				}
				tmpFieldFilterSchema.AvailableClauses.push(tmpFilterClause.ClauseName ? Object.assign(tmpFilterClause, { DisplayName: tmpFilterClause.ClauseName }) : tmpFilterClause);
				if (!tmpFilterClause.FilterKey)
				{
					tmpFilterClause.FilterKey = tmpSlotKey;
				}
				if (!tmpFilterClause.ClauseKey)
				{
					tmpFilterClause.ClauseKey = tmpFilterKey;
				}
				if (!tmpFilterClause.DisplayName)
				{
					tmpFilterClause.DisplayName = tmpFieldHumanName;
				}
				tmpFilterClause.Ordinal = tmpFieldFilterSchema.AvailableClauses.length + 1;
			}
		}
	}

	/**
	 * @return {Promise<Record<string, any>>} The schema of the record.
	 */
	async getRecordSchema()
	{
		if (!this._Schema)
		{
			await this._ensureEntitySchemaAsync();
		}
		return this._Schema;
	}

	/**
	 * Abstract decoration method for core records. Subclasses should implement this method to decorate records with additional information.
	 *
	 * @param {Array<Record<string, any>>} pRecords - The records to decorate.
	 * @return {Promise<void>}
	 */
	async decorateCoreRecords(pRecords)
	{
		if (!this.options.RecordDecorationConfiguration)
		{
			return;
		}
		if (!Array.isArray(this.options.RecordDecorationConfiguration))
		{
			this.pict.log.error('RecordDecorationConfiguration is not an array', { RecordDecorationConfiguration: this.options.RecordDecorationConfiguration });
			return;
		}
		this.pict.Bundle[this.Hash] = { CoreEntityRecordSubset: pRecords };
		const config = [{ Type: 'SetStateAddress', StateAddress: `Bundle[${this.Hash}]` }].concat(this.options.RecordDecorationConfiguration);

		try
		{
			await new Promise((resolve, reject) => this.pict.EntityProvider.gatherDataFromServer(config, (err) =>
			{
				if (err)
				{
					return reject(err);
				}
				resolve();
			}));
		}
		catch (error)
		{
			this.pict.log.error(`MeadowEndpointsRecordSetProvider: Error gathering data from server for record decoration: ${error.message}`, { Stack: error.stack });
		}
	}
}

module.exports = MeadowEndpointsRecordSetProvider;

},{"./RecordSet-RecordProvider-Base.js":975}],977:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libPictRouter = require('pict-router');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-Router',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictRecordSetRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('pict') & { PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')> }} */
		this.pict;

		this.pictRouter = null;
	}

	onInitialize()
	{
		if (!('PictRouter' in this.pict.providers))
		{
			this.pictRouter = this.pict.addProvider('PictRouter', { RouterMode: 'memory' }, libPictRouter);
		}
		else
		{
			this.pictRouter = this.pict.providers.PictRouter;
		}
		return super.onInitialize();
	}

	addRoutes(pRouter)
	{
		//FIXME: not working
		this.pictRouter.addRoute('/PSRS/404', '{~D:Pict.views[RSP-RecordSet-Error-NotFound].render()~}');
		// TODO: Create some kind of state tracking to see if these routes have already been added
		//this.pictRouter.addRoute('/PSRS/:RecordSet/List/:Begin/:Cap', "{~LV:Record~}");
		this.pict.views['RSP-RecordSet-List'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Read'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Create'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Dashboard'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-Associate'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-AssociateMatrix'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-AssociateUnlink'].addRoutes(pRouter);
		this.pict.views['RSP-RecordSet-BulkDelete'].addRoutes(pRouter);

		this.pict.PictSectionRecordSet.addRoutes(pRouter);
	}

	/**
	 * Navigate to a given route (set the browser URL string, add to history, trigger router)
	 * 
	 * @param {string} pRoute - The route to navigate to
	 */
	navigate(pRoute)
	{
		this.pictRouter.navigate(pRoute);
	}
}

module.exports = PictRecordSetRouter;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":845,"pict-router":846}],978:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const ViewDefinitionRecordSetErrorNotFound = require('../views/error/RecordSet-Error-NotFound.json');
const ViewRecordSetList = require('../views/list/RecordSet-List.js');
const ViewRecordSetRead = require('../views/read/RecordSet-Read.js');
const ViewRecordSetCreate = require('../views/create/RecordSet-Create.js');
const ViewRecordSetDashboard = require('../views/dashboard/RecordSet-Dashboard.js');
const ViewRecordSetAssociate = require('../views/associate/RecordSet-AssociateBulk.js');
const ViewRecordSetAssociateMatrix = require('../views/associate/RecordSet-AssociateMatrix.js');
const ViewRecordSetAssociateUnlink = require('../views/associate/RecordSet-AssociateUnlink.js');
const ViewRecordSetBulkDelete = require('../views/delete/RecordSet-BulkDelete.js');

//_Pict.addProvider('BooksProvider', { Entity: 'Book', URLPrefix: 'http://www.datadebase.com:8086/1.0/' }, require('../source/providers/RecordSet-RecordProvider-MeadowEndpoints.js'));
const ProviderBase = require('../providers/RecordSet-RecordProvider-Base.js');
const ProviderMeadowEndpoints = require('../providers/RecordSet-RecordProvider-MeadowEndpoints.js');

const ProviderLinkManager = require('../providers/RecordSet-Link-Manager.js');
const ProviderAssociationManager = require('../providers/RecordSet-AssociationManager.js');
const ProviderDependentManager = require('../providers/RecordSet-DependentManager.js');
const ProviderCardManager = require('../providers/RecordSet-CardManager.js');
const libProviderColumnData = require('../providers/Column-Data-Provider.js');

const ProviderRouter = require('../providers/RecordSet-Router.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
	{
		DefaultMeadowURLPrefix: '/1.0/',
		// Field-decoration policy for the entity pickers this module builds (the association editors, the
		// entity quick-filters, and the bulk-delete replacement picker). Opt-in: a decorated picker grows a
		// ⚙ that lets a user pin an extra record column (e.g. VendorCode) onto each dropdown row, to tell
		// same-named records apart. `Global` decorates every entity; `Entities` keys it per entity (a value
		// of true / false, or an object { IgnoreFields:[…] }); `IgnoreFields` hides business-noise columns on
		// every decorated picker. Resolved per entity by resolveFieldDecoration(); the app overrides the
		// whole object via fable.settings.FieldDecoration.
		FieldDecoration: { Global: false, Entities: {}, IgnoreFields: [] }
	};

const libFormsTemplateProvider = require('pict-section-form').PictFormTemplateProvider;

class RecordSetMetacontroller extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any, addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any, newManyfest: (rec: any) => any }} */
		this.fable;
		this.pict = this.fable;
		/** @type {any} */
		this.log;
		/** @type {any} */
		this.options;
		/** @type {string} */
		this.UUID;

		this.childViews = {
			list: null,
			create: null,
			read: null,
			dashboard: null
		};

		/** @type {Record<string, import('pict-provider')>} */
		this.recordSetProviders = {};
		/** @type {Record<string, Record<string, any>>} */
		this.recordSetProviderConfigurations = {};

		/** @type {Record<string, Record<string, any>>} */
		this.dashboardConfigurations = {};

		/** @type {Array<(pCapability: string) => Promise<boolean>>} */
		this.sessionProviders = [];

		/** @type {Record<string, Record<string, any>>} */
		this.manifestDefinitions = {};
		/** @type {Record<string, import('manyfest')>} */
		this.manifests = { Default: this.pict.manifest };

		this.has_initialized = false;

		//FIXME: this duplicates a behavior in pict-section-form - figure out how we want this coupled dependency to work.
		this.fable.addProviderSingleton('PictFormSectionDefaultTemplateProvider', libFormsTemplateProvider.default_configuration, libFormsTemplateProvider);

		this.pict.MetaTemplate.addPatternBoth('{~ProcessCell:', '~}', (pHash, pData, fCallback)=>
		{ 
			const field = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return fCallback(null, this.pict.manifest.getValueByHash(pData.Payload, field));
		}, async (pHash, pData, fCallback) =>
		{
			const field = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let value = this.pict.manifest.getValueByHash(pData.Payload, field);
			const IDPrefixes = ['Parent', 'Child', 'Creating', 'Updating', 'Deleting'];
			let sanitizedField = field;
			for (let p of IDPrefixes)
			{
				sanitizedField = sanitizedField.replace(`${ p }ID`, 'ID');
			}
			if (sanitizedField?.startsWith('ID'))
			{
				if (!value)
				{
					return fCallback(null, '');
				}
				const remote = field.split('ID')[1];
				// Capture the raw foreign-key id before `value` is overwritten with the resolved name —
				// a registered preview card opens on the id, not the display string.
				const tmpForeignID = value;
				try
				{
					const entity = await new Promise((resolve, reject) =>
					{
						this.pict.EntityProvider.getEntity(remote, value, (pError, pResult) =>
						{
							if (pError)
							{
								return reject(pError);
							}
							resolve(pResult);
						});
					});
					// A dangling reference (the target row no longer exists — e.g. a system user id that
					// was never seeded) comes back as the endpoint's error body rather than an entity.
					// Render the raw id, unlinked: it carries more information than a blank cell, and
					// matches how a found-but-nameless entity already renders.
					if (!entity || (entity.Error && entity.StatusCode))
					{
						return fCallback(null, value);
					}
					if (remote === 'User')
					{
						// Compose what the user record actually has; fall back through the common
						// name fields rather than printing "undefined undefined".
						const tmpUserName = [ entity.NameFirst, entity.NameLast ].filter((pPart) => (typeof(pPart) === 'string') && pPart.trim().length > 0).join(' ');
						value = tmpUserName || entity.FullName || entity.Name || entity.LoginID || value;
					}
					else if (entity?.Name)
					{
						value = entity.Name;
					}
					else if (entity?.Title)
					{
						value = entity.Title;
					}
					else if (entity?.Hash)
					{
						value = entity.Hash;
					}
					if (this.pict.PictSectionRecordSet.recordSetProviderConfigurations[remote])
					{
						// A registered preview card supersedes the plain link: the trigger opens the anchored
						// mini-card (which carries its own "view" action/route). Degrades to the link when no
						// card is registered for the referenced record-set.
						const tmpCardManager = this.pict.providers.RecordSetCardManager;
						if (tmpCardManager && tmpCardManager.hasCard(remote))
						{
							value = tmpCardManager.triggerHTML(remote, tmpForeignID, value);
						}
						else
						{
							const url = this.pict.parseTemplateByHash('PRSP-Read-Link-URL-Template', { Payload: { Payload: { RecordSet: remote, GUIDAddress: `GUID${ remote }` }, Data: entity }});
							value = `<a href="${ url }">${ value }</a>`;
						}
					}
				}
				catch (e)
				{
					this.pict.log.error(`[RecordSet-MetaController]  Unable to fetch entity: ${ e }`);
					return fCallback(e, '');
				}
			}
			return fCallback(null, value);
		});
	}

	/*
		"DefaultRecordSetConfigurations":
			[
				{
					"RecordSet": "Book",

					"RecordSetType": "MeadowEndpoint", // Could be "Custom" which would require a provider to already be created for the record set.
					"RecordSetMeadowEntity": "Book",   // This leverages the /Schema endpoint to get the record set columns.

					"RecordSetURLPrefix": "http://www.datadebase.com:8086/1.0/"
				},
				{
					"RecordSet": "Author",

					"RecordSetType": "MeadowEndpoint",
					"RecordSetMeadowEntity": "Author",

					"RecordSetURLPrefix": "http://www.datadebase.com:8086/1.0/"
				},
				{
					"RecordSet": "RandomizedValues",

					"RecordSetType": "Custom" // This means the `PS-RSP-RandomizedValues` provider will be checked for to get records.
				}
			]
	 */

	/**
	 * @param {string} pRecordSet - The RecordSet name to get the configuration for.
	 *
	 * @return {Record<string, any>} - The registered configuration for the RecordSet
	 */
	getRecordSetConfiguration(pRecordSet)
	{
		return this.recordSetProviderConfigurations[pRecordSet];
	}

	/**
	 * Resolve a column name to the record-set it references, so a form can mount an entity Picker and the
	 * read view can resolve the name. Two sources, in order:
	 *
	 *   1. The record-set config's explicit `ForeignKeyEntities` map ({ ColumnName: EntityName }). This is
	 *      how non-conventional references are declared — prefixed/suffixed columns (ParentIDSample,
	 *      ItemIDTestSpecificationSet, LinkedIDUser, IDMaterialParent, …) and any override. Mapping a
	 *      column to a falsy value explicitly opts it OUT (keeps it a plain input).
	 *   2. The plain `ID<Entity>` convention — a column named exactly `ID` + an entity that is a
	 *      registered record-set (IDOrganization → Organization). No prefix heuristics; anything that
	 *      isn't a clean `ID<Entity>` must be declared in the map above.
	 *
	 * Returns false for the row's own id, IDCustomer, non-references, and references this app doesn't
	 * manage as a record-set (which then stay plain inputs).
	 *
	 * @param {string} pFieldName - the schema column name.
	 * @param {Record<string, any>} [pRecordSetConfiguration] - the owning record-set's configuration.
	 * @param {string} [pOwnIDField] - the row's own id field, excluded (e.g. 'IDTestSpecification').
	 * @return {string|false} the referenced record-set name, or false.
	 */
	resolveForeignEntity(pFieldName, pRecordSetConfiguration, pOwnIDField)
	{
		if (!pFieldName || (typeof pFieldName !== 'string')) { return false; }
		// 1. Explicit per-record-set mapping wins (declares exceptions; a falsy value opts a column out).
		const tmpMap = pRecordSetConfiguration && pRecordSetConfiguration.ForeignKeyEntities;
		if (tmpMap && Object.prototype.hasOwnProperty.call(tmpMap, pFieldName))
		{
			return tmpMap[pFieldName] || false;
		}
		// 2. Plain ID<Entity> convention, validated against the registered record-sets.
		if ((pFieldName === pOwnIDField) || (pFieldName === 'IDCustomer')) { return false; }
		if (!pFieldName.startsWith('ID')) { return false; }
		const tmpRemote = pFieldName.slice(2);
		if (!tmpRemote) { return false; }
		return this.recordSetProviderConfigurations[tmpRemote] ? tmpRemote : false;
	}

	/**
	 * @param {Record<string, any>} pRecordSetConfiguration - The RecordSet configuration to load.
	 */
	loadRecordSetConfiguration(pRecordSetConfiguration)
	{
		if (typeof pRecordSetConfiguration !== 'object')
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfiguration called with invalid configuration.`);
			return false;
		}
		if ((!('RecordSet' in pRecordSetConfiguration)) || (pRecordSetConfiguration.RecordSet === ''))
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfiguration called with invalid configuration. Missing RecordSet.`);
			return false;
		}

		// Normalize the whole-row-click opt-in to a STRICT boolean. The action-cell and column-header
		// templates branch on it with TIfAbs's TRUE/FALSE operators, which test `=== true` / `=== false`.
		// An absent (undefined) or loose ('true') value would satisfy neither branch, leaving the actions
		// column empty — so coerce it to a real true/false here, once, for every render path.
		pRecordSetConfiguration.RowClickOpensRecord = (pRecordSetConfiguration.RowClickOpensRecord === true || pRecordSetConfiguration.RowClickOpensRecord === 'true');

		// Bulk-delete opt-ins, normalized to STRICT booleans (the List title-bar button and the delete
		// screen branch on them the same way RowClickOpensRecord does, via TIfAbs TRUE/FALSE operators).
		pRecordSetConfiguration.RecordSetAllowBulkDelete = (pRecordSetConfiguration.RecordSetAllowBulkDelete === true || pRecordSetConfiguration.RecordSetAllowBulkDelete === 'true');
		// Advanced delete — reassign a record's relationships to a replacement before deleting it.
		pRecordSetConfiguration.RecordSetAdvancedDelete = (pRecordSetConfiguration.RecordSetAdvancedDelete === true || pRecordSetConfiguration.RecordSetAdvancedDelete === 'true');

		// The bulk-delete screen reuses the recordset filter experience under the 'BulkDelete' view context.
		// The filter search box builds its navigation URL from RecordSetFilterURLTemplate-<Context>; inject a
		// BulkDelete template so a filter search navigates to the bulk-delete filtered route rather than the
		// filter view's hardcoded List fallback. A host-provided template always wins.
		if (pRecordSetConfiguration.RecordSetAllowBulkDelete && !pRecordSetConfiguration['RecordSetFilterURLTemplate-BulkDelete'])
		{
			pRecordSetConfiguration['RecordSetFilterURLTemplate-BulkDelete'] = `/PSRS/${pRecordSetConfiguration.RecordSet}/BulkDelete/FilteredTo/{~D:Record.FilterString~}`;
		}

		// One-to-many dependents (child entities with an FK back at this recordset) drive advanced-delete
		// reassociation. Register them with the DependentManager now — the provider is registered in
		// initialize() before any config loads, and this path also covers runtime loadRecordSetDynamically.
		if (Array.isArray(pRecordSetConfiguration.RecordSetDependents) && this.pict.providers.RecordSetDependentManager)
		{
			this.pict.providers.RecordSetDependentManager.addDependents(pRecordSetConfiguration.RecordSet, pRecordSetConfiguration.RecordSetDependents);
		}

		let tmpExtraColumnHeaderTemplateHash = `RecordSet-List-ExtraColumnHeader-${pRecordSetConfiguration.RecordSet}`;
		pRecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash = tmpExtraColumnHeaderTemplateHash;
		let tmpExtraColumnRowTemplateHash = `RecordSet-List-ExtraColumnRow-${pRecordSetConfiguration.RecordSet}`;
		pRecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash = tmpExtraColumnRowTemplateHash;
		if (pRecordSetConfiguration.RecordSetListHasExtraColumns)
		{
			let tmpRecordSetExtraColumnHeaderTemplate = pRecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplate;
			if (tmpRecordSetExtraColumnHeaderTemplate === undefined)
			{
				tmpRecordSetExtraColumnHeaderTemplate = '';
			}
			let tmpRecordSetExtraColumnRowTemplate = pRecordSetConfiguration.RecordSetListExtraColumnRowTemplate;
			if (tmpRecordSetExtraColumnRowTemplate === undefined)
			{
				tmpRecordSetExtraColumnRowTemplate = '';
			}
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnHeaderTemplateHash, tmpRecordSetExtraColumnHeaderTemplate);
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnRowTemplateHash, tmpRecordSetExtraColumnRowTemplate);
		}
		else
		{
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnHeaderTemplateHash, '');
			this.fable.TemplateProvider.addTemplate(tmpExtraColumnRowTemplateHash, '');
		}

		let tmpProvider = false;

		const providerConfiguration = Object.assign({}, {Hash: `RSP-Provider-${pRecordSetConfiguration.RecordSet}`}, pRecordSetConfiguration);
		this.recordSetProviderConfigurations[providerConfiguration.RecordSet] = providerConfiguration;

		switch (pRecordSetConfiguration.RecordSetType)
		{
			case 'MeadowEndpoint':
				// Create a Meadow Endpoints provider
				// Allow the Record Set to optionally point to a different entity
				if (`RecordSetMeadowEntity` in pRecordSetConfiguration)
				{
					providerConfiguration.Entity = pRecordSetConfiguration.RecordSetMeadowEntity;
				}
				else
				{
					providerConfiguration.Entity = pRecordSetConfiguration.RecordSet;
				}
				if (`FilterEndpointOverride` in pRecordSetConfiguration)
				{
					providerConfiguration.FilterEndpointOverride = pRecordSetConfiguration.FilterEndpointOverride;
				}
				else
				{
					providerConfiguration.FilterEndpointOverride = null;
				}
				// Default the URLPrefix to the base URLPrefix
				if (`RecordSetURLPrefix` in pRecordSetConfiguration)
				{
					providerConfiguration.URLPrefix = pRecordSetConfiguration.RecordSetURLPrefix;
				}
				else
				{
					providerConfiguration.URLPrefix = '/1.0/';
				}
				if (`RecordSetIgnoreFilterFields` in pRecordSetConfiguration)
				{
					providerConfiguration.IgnoreFilterFields = pRecordSetConfiguration.RecordSetIgnoreFilterFields;
				}
				else
				{
					providerConfiguration.IgnoreFilterFields = [ 'Deleted', 'DeletingIDUser', 'DeleteDate' ];
				}
				// Columns that look like foreign keys but are denormalized data, so the
				// provider must not bulk-prefetch them as connected entities.
				if (`RecordSetIgnoreConnectedEntityFields` in pRecordSetConfiguration)
				{
					providerConfiguration.IgnoreConnectedEntityFields = pRecordSetConfiguration.RecordSetIgnoreConnectedEntityFields;
				}
				if (`RecordSetFieldFilterClauses` in pRecordSetConfiguration)
				{
					providerConfiguration.FieldFilterClauses = pRecordSetConfiguration.RecordSetFieldFilterClauses;
				}
				// A pre-supplied schema (e.g. bundled into an app manifest) lets the provider skip
				// the per-entity /Schema fetch at initialization. Absent, the provider fetches as before.
				if (`RecordSetSchema` in pRecordSetConfiguration)
				{
					providerConfiguration.ProvidedSchema = pRecordSetConfiguration.RecordSetSchema;
				}

				tmpProvider = this.recordSetProviders[pRecordSetConfiguration.RecordSet] = this.fable.addProvider(providerConfiguration.Hash, providerConfiguration, ProviderMeadowEndpoints);
				break;
			default:
			case 'Custom':
				// Create a custom provider
				if (`ProviderHash` in providerConfiguration)
				{
					if (!(providerConfiguration.ProviderHash in this.fable.servicesMap))
					{
						this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfiguration called with invalid configuration. ProviderHash ${providerConfiguration.ProviderHash} not found.  Falling back to base.`);
						tmpProvider = this.recordSetProviders[providerConfiguration.RecordSet] = this.fable.servicesMap[providerConfiguration.ProviderHash];
					}
					else
					{
						tmpProvider = this.recordSetProviders[providerConfiguration.RecordSet] = this.fable.addProvider(providerConfiguration.Hash, providerConfiguration, ProviderBase);
					}
				}
				else
				{
					tmpProvider = this.recordSetProviders[providerConfiguration.RecordSet] = this.fable.addProvider(providerConfiguration.Hash, providerConfiguration, ProviderBase);
				}
				break;
		}

		return tmpProvider;
	}

	/**
	 * @param {Array<Record<string, any>>} pRecordSetConfigurationArray - An array of RecordSet configurations to load.
	 */
	loadRecordSetConfigurationArray(pRecordSetConfigurationArray)
	{
		if (!Array.isArray(pRecordSetConfigurationArray))
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfigurationArray called with invalid configuration.`);
			return false;
		}
		if (pRecordSetConfigurationArray.length === 0)
		{
			this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfigurationArray called with empty configuration.`);
			return false;
		}
		for (let i = 0; i < pRecordSetConfigurationArray.length; i++)
		{
			if (!this.loadRecordSetConfiguration(pRecordSetConfigurationArray[i]))
			{
				this.fable.log.error(`RecordSetMetacontroller: ${this.UUID} loadRecordSetConfigurationArray called with invalid configuration:`,pRecordSetConfigurationArray[i]);
			}
		}
	}

	/**
	 * @param {Record<string, any> | string} pRecordSet - The RecordSet configuration or hash to load dynamically.
	 * @param {string} [pEntity] - (optional) The Entity type to use (defaults to the RecordSet name if not provided).
	 * @param {string} [pDefaultFilter] - (optional) The default filter to use.
	 */
	loadRecordSetDynamically(pRecordSet, pEntity, pDefaultFilter)
	{
		if (typeof(pRecordSet) === 'object')
		{
			const tmpRecordSetProviderHash = `RSP-Provider-${pRecordSet.RecordSet}`;
			this.loadRecordSetConfiguration(pRecordSet);

			return this.fable.providers[tmpRecordSetProviderHash].initializeAsync((pError) =>
				{
					if (pError)
					{
						this.log.error(`RecordSet [${pRecordSet.RecordSet}] dynamically loaded with error: ${pError.message || pError}`, { Stack: pError.stack });
						return;
					}
					this.log.trace(`RecordSet [${pRecordSet.RecordSet} dynamically loaded.`);
				})
		}

		if (typeof(pRecordSet) === 'string')
		{
			const tmpRecordSet = pRecordSet;
			const tmpRecordSetProviderHash = `RSP-Provider-${tmpRecordSet}`;

			const tmpEntity = (typeof(pEntity) === 'string') ? pEntity : tmpRecordSet;
			const tmpDefaultFilter = (typeof(pDefaultFilter) === 'string') ? pDefaultFilter : '';
			const tmpRecordSetConfiguration = {
				"RecordSet": tmpRecordSet,


				"RecordSetType": "MeadowEndpoint",
				"RecordSetMeadowEntity": tmpEntity,
				"RecordSetDefaultFilter": tmpDefaultFilter,

				"RecordSetURLPrefix": "/1.0/"
			};

			this.loadRecordSetConfiguration(tmpRecordSetConfiguration);
			return this.fable.providers[tmpRecordSetProviderHash].initializeAsync(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`RecordSet [${tmpRecordSet}] dynamically loaded with error: ${pError.message || pError}`, { Stack: pError.stack });
						return;
					}
					this.log.trace(`RecordSet [${tmpRecordSetConfiguration.RecordSet} dynamically loaded.`);
				});
		}

		this.log.error(`RecordSet MetaController loadRecordSetDynamically called with invalid parameter (expected an Object or String - parameter was ${typeof(pRecordSet)}.`);
		return false;
	}

	/**
	 * @param {Record<string, any>} pRoutePayload - The route payload containing the RecordSet and optional Entity and DefaultFilter.
	 */
	handleLoadDynamicRecordSetRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet List view route handler called with invalid route payload.`);
		}

		const tmpRecordSet = pRoutePayload.data.RecordSet;

		const tmpEntity = pRoutePayload.data.Entity ? pRoutePayload.data.Entity : tmpRecordSet;
		const tmpDefaultFilter = pRoutePayload.data.DefaultFilter ? pRoutePayload.data.DefaultFilter : '';

		return this.loadRecordSetDynamically(tmpRecordSet, tmpEntity, tmpDefaultFilter);
	}

	/**
	 * @param {import('pict-router')} pPictRouter - The Pict Router to add the routes to.
	 */
	addRoutes(pPictRouter)
	{
		pPictRouter.addRoute('/PSRS/:RecordSet/LoadDynamic', this.handleLoadDynamicRecordSetRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/LoadDynamic/:Entity', this.handleLoadDynamicRecordSetRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/LoadDynamic/:Entity/:DefaultFilter', this.handleLoadDynamicRecordSetRoute.bind(this));
		return true;
	}

	/**
	 * @param {string} pCapability - The capability to check for.
	 */
	async checkSession(pCapability)
	{
		for (const sessionProvider of this.sessionProviders)
		{
			if (!await sessionProvider(pCapability))
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * @param {string} pNameTemplate - The name template for the record link.
	 * @param {string} pURLTemplate - The URL template for the record link.
	 * @param {boolean} pDefault - Whether this is a default link template.
	 *
	 * @return {Record<string, any>} - The link template object that was added.
	 */
	addRecordLinkTemplate(pNameTemplate, pURLTemplate, pDefault)
	{
		return this.fable.providers.RecordSetLinkManager.addRecordLinkTemplate(pNameTemplate, pURLTemplate, pDefault);
	}

	/**
	 * Reassociation-on-delete: repoint every relationship that references `pFromID` in `pRecordSet` so it
	 * references `pToID` instead — both many-to-many joins (via the AssociationManager) and one-to-many
	 * dependent children (via the DependentManager). Returns per-relationship results plus an aggregate
	 * `failed` count. The CALLER must not delete `pFromID` unless `failed === 0`: there are no DB
	 * transactions, so deleting before a clean repoint would orphan the children/joins we just moved.
	 *
	 * @param {string} pRecordSet
	 * @param {string|number} pFromID - the record being deleted (its relationships move away).
	 * @param {string|number} pToID - the replacement record the relationships move to.
	 * @return {Promise<{ associations: Array<Record<string, any>>, dependents: Array<Record<string, any>>, repointed: number, deletedDuplicate: number, failed: number, selfRepoint: boolean }>}
	 */
	async repointRecordRelationships(pRecordSet, pFromID, pToID)
	{
		const tmpResult = { associations: [], dependents: [], repointed: 0, deletedDuplicate: 0, failed: 0, selfRepoint: false };
		if (pFromID === undefined || pFromID === null || pFromID === '' || pToID === undefined || pToID === null || pToID === '' || String(pFromID) === String(pToID))
		{
			tmpResult.selfRepoint = (String(pFromID) === String(pToID));
			return tmpResult;
		}

		const tmpAssociationManager = this.pict.providers.RecordSetAssociationManager;
		if (tmpAssociationManager)
		{
			const tmpHashes = tmpAssociationManager.getAssociationsForRecordSet(pRecordSet);
			for (let i = 0; i < tmpHashes.length; i++)
			{
				const tmpRepoint = await tmpAssociationManager.repointJoins(tmpHashes[i], pRecordSet, pFromID, pToID);
				tmpResult.associations.push(Object.assign({ Association: tmpHashes[i] }, tmpRepoint));
				tmpResult.repointed += tmpRepoint.repointed;
				tmpResult.deletedDuplicate += tmpRepoint.deletedDuplicate;
				tmpResult.failed += tmpRepoint.failed;
			}
		}

		const tmpDependentManager = this.pict.providers.RecordSetDependentManager;
		if (tmpDependentManager)
		{
			const tmpDependents = tmpDependentManager.getDependentsForRecordSet(pRecordSet);
			for (let i = 0; i < tmpDependents.length; i++)
			{
				const tmpRepoint = await tmpDependentManager.repointDependent(tmpDependents[i], pFromID, pToID);
				tmpResult.dependents.push(Object.assign({ Entity: tmpDependents[i].Entity, FKField: tmpDependents[i].FKField }, tmpRepoint));
				tmpResult.repointed += tmpRepoint.repointed;
				tmpResult.failed += tmpRepoint.failed;
			}
		}

		return tmpResult;
	}

	initialize()
	{
		if (this.has_initialized)
		{
			this.fable.log.warn(`RecordSetMetacontroller: ${this.UUID} already initialized and initialized was called a second time.`);
			return this;
		}

		this.fable.addProvider('RecordSetLinkManager', {}, ProviderLinkManager);

		// Joined-entity association manager — the registry + data layer behind the Association read-tab
		// and the Bulk Associate screen. Associations are parsed from settings.Associations below.
		this.fable.addProvider('RecordSetAssociationManager', {}, ProviderAssociationManager);

		// One-to-many dependent manager — the registry + data layer for child entities that carry a foreign
		// key back at a recordset (RecordSetDependents). Drives advanced-delete reassociation. Registered
		// before any recordset config loads so loadRecordSetConfiguration can register dependents inline.
		this.fable.addProvider('RecordSetDependentManager', {}, ProviderDependentManager);

		// Record preview cards — a global registry of small, config-driven record cards (popover on a
		// trigger). Layouts are parsed from settings.RecordCards below.
		this.fable.addProvider('RecordSetCardManager', {}, ProviderCardManager);

		// Column visibility persistence — only register the built-in localStorage provider when the
		// host hasn't supplied its own (the documented seam for server-side per-user persistence).
		if (!('ColumnDataProvider' in this.fable.providers))
		{
			this.fable.addProvider('ColumnDataProvider', libProviderColumnData.default_configuration, libProviderColumnData);
		}

		// Add the subviews internally and externally
		this.pict.addTemplate(require('../templates/Pict-Template-FilterView.js'));
		this.pict.addTemplate(require('../templates/Pict-Template-FilterInstanceViews.js'));
		this.pict.addTemplate(require('../templates/Pict-Template-RecordCard.js'));
		this.pict.addTemplate(require('../views/filters').Base);
		this.childViews.errorNotFound = this.fable.addView('RSP-RecordSet-Error-NotFound', ViewDefinitionRecordSetErrorNotFound);
		this.childViews.list = this.fable.addView('RSP-RecordSet-List', this.options, ViewRecordSetList);
		this.childViews.read = this.fable.addView('RSP-RecordSet-Read', this.options, ViewRecordSetRead);
		this.childViews.create = this.fable.addView('RSP-RecordSet-Create', this.options, ViewRecordSetCreate);
		this.childViews.dashboard = this.fable.addView('RSP-RecordSet-Dashboard', this.options, ViewRecordSetDashboard);
		this.childViews.associate = this.fable.addView('RSP-RecordSet-Associate', this.options, ViewRecordSetAssociate);
		this.childViews.associateMatrix = this.fable.addView('RSP-RecordSet-AssociateMatrix', this.options, ViewRecordSetAssociateMatrix);
		this.childViews.associateUnlink = this.fable.addView('RSP-RecordSet-AssociateUnlink', this.options, ViewRecordSetAssociateUnlink);
		this.childViews.bulkDelete = this.fable.addView('RSP-RecordSet-BulkDelete', this.options, ViewRecordSetBulkDelete);

		// Initialize the subviews
		this.childViews.list.initialize();
		this.childViews.read.initialize();
		this.childViews.create.initialize();
		this.childViews.dashboard.initialize();
		this.childViews.associate.initialize();
		this.childViews.associateMatrix.initialize();
		this.childViews.associateUnlink.initialize();
		this.childViews.bulkDelete.initialize();

		// Now initialize the router

		if (this.fable.settings.hasOwnProperty('Filters') && typeof this.fable.settings.Filters === 'object')
		{
			for (const tmpFilterKey of Object.keys(this.fable.settings.Filters))
			{
				const filterArray = Array.isArray(this.fable.settings.Filters[tmpFilterKey]) ? this.fable.settings.Filters[tmpFilterKey] : [this.fable.settings.Filters[tmpFilterKey]];
				for (let x = 0; x < filterArray.length; x++)
				{
					if (!filterArray[x].DisplayName)
					{
						filterArray[x].DisplayName = filterArray[x].Label || tmpFilterKey;
					}
					this.pict.providers.FilterManager.addFilter(filterArray[x].FilterKey || `${ tmpFilterKey }${ x ? `_${ x }` : '' }`, filterArray[x]);
				}
			}
		}

		if (this.fable.settings.hasOwnProperty('FilterCriteria') && typeof this.fable.settings.FilterCriteria === 'object')
		{
			for (const tmpFilterCriterionKey of Object.keys(this.fable.settings.FilterCriteria))
			{
				this.pict.providers.FilterManager.addFilterCriteria(tmpFilterCriterionKey, this.fable.settings.FilterCriteria[tmpFilterCriterionKey]);
			}
		}

		if (this.fable.settings.hasOwnProperty('Associations') && typeof this.fable.settings.Associations === 'object')
		{
			for (const tmpAssociationKey of Object.keys(this.fable.settings.Associations))
			{
				this.pict.providers.RecordSetAssociationManager.addAssociation(tmpAssociationKey, this.fable.settings.Associations[tmpAssociationKey]);
			}
		}

		if (this.fable.settings.hasOwnProperty('RecordCards') && typeof this.fable.settings.RecordCards === 'object')
		{
			for (const tmpRecordCardKey of Object.keys(this.fable.settings.RecordCards))
			{
				this.pict.providers.RecordSetCardManager.registerCard(tmpRecordCardKey, this.fable.settings.RecordCards[tmpRecordCardKey]);
			}
		}

		if (this.fable.settings.hasOwnProperty('DefaultRecordSetConfigurations'))
		{
			this.loadRecordSetConfigurationArray(this.fable.settings.DefaultRecordSetConfigurations);
		}

		for (const [ tmpManifestKey, tmpManifest ] of Object.entries(this.fable.settings.Manifests || {}))
		{
			if (!tmpManifest || !tmpManifest.Scope || !tmpManifest.Descriptors)
			{
				this.pict.log.error(`RecordSetDashboard: Invalid manifest: ${tmpManifestKey}.`, tmpManifest);
				continue;
			}
			if (tmpManifestKey !== tmpManifest.Scope)
			{
				this.pict.log.error(`RecordSetDashboard: Manifest key ${tmpManifestKey} does not match manifest scope ${tmpManifest.Scope}.  This is bad.  Fix it.`);
			}
			if (!tmpManifest.Form)
			{
				this.generateManifestTableCells(tmpManifest);
			}
			this.manifestDefinitions[tmpManifest.Scope] = tmpManifest;
			this.manifests[tmpManifest.Scope] = tmpManifest.Form ? tmpManifest : this.pict.newManyfest(tmpManifest);
		}

		// App-level field-decoration policy overlays the module default (see _DEFAULT_CONFIGURATION /
		// resolveFieldDecoration). One object drives the whole fleet of entity pickers this module builds.
		if (this.fable.settings.hasOwnProperty('FieldDecoration') && typeof this.fable.settings.FieldDecoration === 'object')
		{
			this.options.FieldDecoration = Object.assign({}, this.options.FieldDecoration, this.fable.settings.FieldDecoration);
		}

		this.has_initialized = true;

		// Load pict-router if it isn't loaded
		if (!('RecordSetRouter' in this.fable.providers))
		{
			this.fable.addProvider('RecordSetRouter', {}, ProviderRouter);
			this.fable.providers.RecordSetRouter.initialize();
		}

		return true;
	}

	getManifest(pScope)
	{
		return this.manifests[pScope];
	}

	/**
	 * Resolve the field-decoration policy for one entity into the two flags the picker widget consumes.
	 *
	 * Policy shape (this.options.FieldDecoration, overridable via fable.settings.FieldDecoration):
	 *   {
	 *     Global: false,                                  // decorate every entity picker
	 *     Entities: { Organization: true, Contract: { IgnoreFields: [ 'IDVendor' ] }, Foo: false },
	 *     IgnoreFields: [ 'IDCustomer' ]                  // hidden on every decorated picker (business noise)
	 *   }
	 * An entity value of `true` opts it in, `false` opts it out (even when Global is on), and an object opts
	 * it in and contributes its own IgnoreFields. The picker widget already hides the audit / value / text
	 * columns itself; here we add the policy's IgnoreFields, the entity's IgnoreFields, and GUID<Entity>
	 * (the picker does not auto-hide the GUID column).
	 *
	 * @param {string} pEntity - The entity the picker searches (e.g. 'Organization').
	 * @return {{ Enabled: boolean, IgnoreFields: Array<string> }}
	 */
	resolveFieldDecoration(pEntity)
	{
		const tmpPolicy = (this.options && typeof this.options.FieldDecoration === 'object' && this.options.FieldDecoration) || {};
		let tmpEnabled = (tmpPolicy.Global === true);
		let tmpEntityIgnore = [];
		const tmpEntityPolicy = (tmpPolicy.Entities && pEntity) ? tmpPolicy.Entities[pEntity] : undefined;
		if (tmpEntityPolicy === true)
		{
			tmpEnabled = true;
		}
		else if (tmpEntityPolicy === false)
		{
			tmpEnabled = false;
		}
		else if (tmpEntityPolicy && typeof tmpEntityPolicy === 'object')
		{
			tmpEnabled = (tmpEntityPolicy.Enabled !== false);
			if (Array.isArray(tmpEntityPolicy.IgnoreFields))
			{
				tmpEntityIgnore = tmpEntityPolicy.IgnoreFields;
			}
		}
		if (!tmpEnabled)
		{
			return { Enabled: false, IgnoreFields: [] };
		}
		const tmpIgnoreFields = [].concat(
			Array.isArray(tmpPolicy.IgnoreFields) ? tmpPolicy.IgnoreFields : [],
			tmpEntityIgnore);
		if (pEntity)
		{
			tmpIgnoreFields.push(`GUID${pEntity}`);
		}
		return { Enabled: true, IgnoreFields: tmpIgnoreFields };
	}

	/**
	 * Stamp the resolved field-decoration flags onto a picker config, in place. The single call every
	 * picker-creation site in this module uses so the policy is applied identically everywhere.
	 *
	 * @param {Record<string, any>} pConfig - A picker config (createPicker / createEntityPicker).
	 * @param {string} pEntity - The entity the picker searches.
	 * @return {Record<string, any>} The same config, decorated when the entity is opted in.
	 */
	applyFieldDecoration(pConfig, pEntity)
	{
		if (!pConfig)
		{
			return pConfig;
		}
		const tmpDecoration = this.resolveFieldDecoration(pEntity);
		if (tmpDecoration.Enabled)
		{
			pConfig.AllowFieldDecoration = true;
			pConfig.DecorationIgnoreFields = tmpDecoration.IgnoreFields;
		}
		return pConfig;
	}

	/**
	 * Register a manifest at runtime, after initialization. This is the
	 * equivalent of adding a manifest to `fable.settings.Manifests` before
	 * init, but callable after the fact.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to register. Must have `Scope` and `Descriptors`.
	 */
	addManifest(pManifest)
	{
		if (!pManifest || !pManifest.Scope || !pManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetMetacontroller: addManifest called with invalid manifest.`, pManifest);
			return;
		}
		if (!pManifest.Form)
		{
			this.generateManifestTableCells(pManifest);
		}
		this.manifestDefinitions[pManifest.Scope] = pManifest;
		this.manifests[pManifest.Scope] = pManifest.Form ? pManifest : this.pict.newManyfest(pManifest);
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to generate table cells for.
	 */
	generateManifestTableCells(pManifest)
	{
		if (!pManifest || !pManifest.Descriptors || !pManifest.Scope)
		{
			this.pict.log.error(`RecordSetDashboard: No manifest or descriptors found for ${pManifest}.  Cannot generate table cells.`);
			if (pManifest)
			{
				pManifest.TableCells = [];
			}
			return;
		}
		const tmpTableCells = Object.entries(pManifest.Descriptors || {}).filter(([ key, descriptor ]) => descriptor.PictDashboard).map(([ key, descriptor ]) =>
		{
			const tmpPictDashboard = descriptor.PictDashboard;
			if (tmpPictDashboard?.Equation && !tmpPictDashboard.ValueTemplate)
			{
				//FIXME: is this the right mapping?
				if (tmpPictDashboard.EquationNamespaceScope === 'Full')
				{
					tmpPictDashboard.ValueTemplate = '{~SBR:Record.Data.PictDashboard.Equation::Pict.PictSectionRecordSet.getManifest(Record.Data.ManifestHash)~}';
				}
				else
				{
					tmpPictDashboard.ValueTemplate = '{~SBR:Record.Data.PictDashboard.Equation:Record.Payload:Pict.PictSectionRecordSet.getManifest(Record.Data.ManifestHash)~}';
				}
			}
			if (!tmpPictDashboard.ValueTemplate)
			{
				tmpPictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
			}
			return {
				Key: key,
				DisplayName: descriptor.Name || key,
				ManifestHash: pManifest.Scope,
				PictDashboard: tmpPictDashboard,
				// Column-chooser default visibility: a descriptor can ship hidden-by-default and be
				// turned on by the user (when the recordset enables RecordSetListColumnChooser).
				DefaultHidden: (descriptor.DefaultHidden === true),
			};
		});
		pManifest.TableCells = tmpTableCells;
	}

}

module.exports = RecordSetMetacontroller;

RecordSetMetacontroller.default_configuration = _DEFAULT_CONFIGURATION;

},{"../providers/Column-Data-Provider.js":968,"../providers/RecordSet-AssociationManager.js":970,"../providers/RecordSet-CardManager.js":971,"../providers/RecordSet-DependentManager.js":972,"../providers/RecordSet-Link-Manager.js":974,"../providers/RecordSet-RecordProvider-Base.js":975,"../providers/RecordSet-RecordProvider-MeadowEndpoints.js":976,"../providers/RecordSet-Router.js":977,"../templates/Pict-Template-FilterInstanceViews.js":979,"../templates/Pict-Template-FilterView.js":980,"../templates/Pict-Template-RecordCard.js":981,"../views/associate/RecordSet-AssociateBulk.js":985,"../views/associate/RecordSet-AssociateMatrix.js":986,"../views/associate/RecordSet-AssociateUnlink.js":987,"../views/create/RecordSet-Create.js":989,"../views/dashboard/RecordSet-Dashboard.js":997,"../views/delete/RecordSet-BulkDelete.js":998,"../views/error/RecordSet-Error-NotFound.json":999,"../views/filters":1027,"../views/list/RecordSet-List.js":1037,"../views/read/RecordSet-Read.js":1038,"fable-serviceproviderbase":838,"pict-section-form":874}],979:[function(require,module,exports){
const libPictTemplate = require('pict-template');
const libFilterViews = require('../views/filters/index.js');

/**
 * Specialized instruction for rendering the filter view and plumbing in required context.
 *
 * Based on the Pict base {~V:...~} template instruction.
 *
 * ## Async render architecture (see renderAsync below)
 *
 * The async path is tuned to get the dashboard records list painted before any
 * speculative filter-list REST lookups complete. Three things collaborate to
 * make that happen:
 *
 * 1. **Parallel filter fan-out.** Every filter clause starts its own
 *    `renderWithScopeAsync` in a single pass, instead of chaining through a
 *    sequential `Anticipate` queue. Template parsing, `onBefore*`/`onProject*`
 *    microtask hops, and the synchronous DOM walks done inside each filter's
 *    `onAfterRender` all happen concurrently rather than serialized across N
 *    filters. Results are collected into an indexed array so final output
 *    order still matches the clause order.
 *
 * 2. **Per-filter transaction isolation.** Each filter render gets its own
 *    synthetic `RootRenderable` carrying a fresh `TransactionHash`. Any
 *    `virtual-assignment` sub-renders that the filter's dynamic form spawns
 *    (notably `PSRSFilterProxyView`, which pict-section-form uses to host
 *    each filter's input) push into THIS transaction's queue, not the
 *    dashboard's. The dashboard's outer `renderAsync` callback fires as soon
 *    as every filter has its template string - without waiting on any of
 *    the nested input-initialize work.
 *
 * 3. **Deferred post-render drain.** The filter's post-render pipeline
 *    (`onAfterRenderAsync`, which is what runs pict-section-form's
 *    `runInputProviderFunctions('onInputInitialize', ...)` and therefore
 *    triggers `EntityBundleRequest.gatherDataFromServer` for any
 *    speculative-load inputs) is intentionally NOT run inline. It is queued
 *    via `setTimeout(..., 0)` so it fires on the next macrotask, giving the
 *    browser a tick to paint the dashboard first.
 *
 * ### Render-epoch race guard
 *
 * Between the dashboard callback firing and the setTimeout actually running,
 * the user may have navigated away / applied a different filter experience /
 * cleared filters. The `PRSP-Filters` view owns a monotonic `_renderEpoch`
 * counter that gets bumped on every mutating action (`performSearch`,
 * `handleClear`, `handleReset`, `addFilter`, `removeFilter`). Each scheduled
 * drain captures the epoch at schedule time and bails out if a newer render
 * has invalidated it, so a stale REST response can never clobber a filter
 * container that now belongs to a different experience.
 */
class PictTemplateFilterInstanceViewInstruction extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~FIV:', '~}');
		this.addPattern('{~FilterInstanceViews:', '~}');


		if (!('__TemplateOutputCache' in this.pict))
		{
			this.pict.__TemplateOutputCache = {};
		}
	}

	_getViewForFilterClause(pClause)
	{
		// Quick-filter clauses are surfaced in the Quick Filters bar (RecordSet-Filters._renderQuickFilters),
		// not the drawer's clause list — skip them here so they aren't rendered twice. Both the sync and
		// async render loops treat a null view as "skip this clause".
		if (pClause && pClause.QuickFilter) { return null; }
		// The show-deleted switch is a RawFilter clause whose face is the drawer-footer checkbox
		// (RecordSet-Filters._renderShowDeletedControl) — without this skip it would fall through to
		// the Base filter card, which renders a debug dump for types with no real filter view.
		if (pClause && pClause.ShowDeletedKey) { return null; }
		// A clause may render as a different type than it compiles as: `FilterRenderType` picks the
		// filter VIEW while `Type` still drives pict's Filter.js compile. Boolean columns use this —
		// they compile as an exact NumericMatch (EQ 0/1) but render the Yes/No BooleanMatch control.
		const tmpRenderType = pClause.FilterRenderType || pClause.Type;
		let tmpViewHash = `PRSP-FilterType-${tmpRenderType}`;
		const tmpCustomViewHash = `${tmpViewHash}-${pClause.CustomFilterViewHash}`;
		if (tmpCustomViewHash in this.pict.views)
		{
			tmpViewHash = tmpCustomViewHash;
		}
		/** @type {import('../views/filters/RecordSet-Filter-Base.js')} */
		let tmpView = this.pict.views[tmpViewHash];
		if (!tmpView)
		{
			const tmpViewPrototype = libFilterViews[tmpRenderType] || libFilterViews.Base;
			if (!tmpViewPrototype)
			{
				this.pict.log.error(`Pict: Filter Instance Views Template Render: No view prototype found for filter type [${pClause.Type}]`);
				return null;
			}
			//FIXME: is this safe? will this view get rendered at other times?
			tmpView = this.pict.addView(tmpViewHash, { }, tmpViewPrototype);
		}
		return tmpView;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set specified in record`);
			return '';
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set configuration found for [${tmpRecordSet}]`);
			return '';
		}
		let tmpViewContext = pRecord.ViewContext;
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}
		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}

		let tmpRenderGUID = this.pict.getUUID();
		let tmpResult = '';

		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[pRecord.RecordSet]?.FilterClauses || [];
		//FIXME: lookup by hash instead?
		for (let i = 0; i < tmpClauses.length; i++)
		{
			const tmpClause = tmpClauses[i];
			/** @type {import('../views/filters/RecordSet-Filter-Base.js')} */
			const tmpView = this._getViewForFilterClause(tmpClause);
			if (!tmpView)
			{
				continue;
			}

			const tmpRecord = Object.assign({}, pRecord, tmpClause);
			//tmpRecord.ClauseAddress = `Bundle._ActiveFilterState['${pRecord.RecordSet}'].FilterClauses[${i}]`;
			tmpRecord.ClauseAddress = `_ActiveFilterState[\`${pRecord.RecordSet}\`].FilterClauses[${i}]`;
			tmpView.prepareRecord(tmpRecord);
			tmpView.renderWithScope(tmpClause, '__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, tmpRecord, pState && pState.RootRenderable);

			tmpResult += this.pict.__TemplateOutputCache[tmpRenderGUID];
			// TODO: Uncomment this when we like how it's working
			//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

		}
		return tmpResult;
	}

	/**
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to call with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set specified in record`);
			return fCallback(null, '');
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter Instance Views Template Render: No record set configuration found for [${tmpRecordSet}]`);
			return fCallback(null, '');
		}
		let tmpViewContext = pRecord.ViewContext;
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}

		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}

		const tmpClauses = this.pict.Bundle._ActiveFilterState?.[pRecord.RecordSet]?.FilterClauses || [];
		if (tmpClauses.length === 0)
		{
			return fCallback(null, '');
		}

		// Snapshot the current render epoch so the deferred drain below can
		// detect a filter re-render that happened between schedule time and
		// now (see class doc-comment, "Render-epoch race guard").
		const tmpFiltersView = this.pict.views['PRSP-Filters'];
		const tmpRenderEpoch = tmpFiltersView ? tmpFiltersView._renderEpoch : 0;

		const tmpResults = new Array(tmpClauses.length).fill('');
		const tmpDeferredDrains = [];
		let tmpRemaining = tmpClauses.length;
		let tmpCallbackFired = false;

		const tmpFinalize = () =>
		{
			if (tmpCallbackFired || tmpRemaining > 0)
			{
				return;
			}
			tmpCallbackFired = true;
			// Fire the dashboard callback first so the paint lands on the
			// current tick, then defer the filters' onAfterRender work (which
			// runs pict-section-form's input-initialize pass and fires any
			// EntityBundleRequest REST calls) to the next macrotask.
			fCallback(null, tmpResults.join(''));
			if (tmpDeferredDrains.length === 0)
			{
				return;
			}
			setTimeout(() =>
			{
				// Epoch guard: bail out if a newer render has invalidated us.
				if (tmpFiltersView && tmpFiltersView._renderEpoch !== tmpRenderEpoch)
				{
					return;
				}
				for (let d = 0; d < tmpDeferredDrains.length; d++)
				{
					try
					{
						tmpDeferredDrains[d]();
					}
					catch (pError)
					{
						this.log.warn(`Pict: Filter Instance Views Template Render: Error draining deferred filter transaction`, pError);
					}
				}
			}, 0);
		};

		//FIXME: lookup by hash instead?
		for (let i = 0; i < tmpClauses.length; i++)
		{
			const tmpClause = tmpClauses[i];
			/** @type {import('../views/filters/RecordSet-Filter-Base.js')} */
			const tmpView = this._getViewForFilterClause(tmpClause);
			if (!tmpView)
			{
				tmpRemaining--;
				continue;
			}

			const tmpRenderGUID = this.pict.getUUID();
			const tmpRecord = Object.assign({}, pRecord, tmpClause);
			tmpRecord.ClauseAddress = `_ActiveFilterState[${pRecord.RecordSet}].FilterClauses[${i}]`;
			tmpView.prepareRecord(tmpRecord);

			// Synthetic per-filter root renderable: nested virtual-assignment
			// renders from this filter's subtree push into the filter's own
			// transaction queue instead of the dashboard's.
			const tmpFilterTransactionHash = `FilterInstance-${tmpView.Hash}-${tmpRenderGUID}`;
			this.pict.TransactionTracking.registerTransaction(tmpFilterTransactionHash);
			/** @type {import('pict-view').Renderable} */
			const tmpFilterRootRenderable =
			{
				RenderableHash: '__Virtual',
				TemplateHash: null,
				ContentDestinationAddress: null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: tmpFilterTransactionHash,
				RootRenderableViewHash: tmpView.Hash,
			};

			tmpDeferredDrains.push(() =>
			{
				tmpView.onAfterRenderAsync(() =>
				{
					// Remove the per-filter transaction we registered above
					// once its drain completes. Pict-View will also attempt
					// to unregister during its own onAfterRenderAsync chain;
					// whichever call hits first wins, the other is a no-op.
					this.pict.TransactionTracking.unregisterTransaction(tmpFilterTransactionHash);
				}, tmpFilterRootRenderable);
			});

			tmpView.renderWithScopeAsync(tmpClause, '__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, tmpRecord, tmpFilterRootRenderable,
				(pError) =>
				{
					if (pError)
					{
						this.log.warn(`Pict: Filter Instance Views Template Render: Error rendering view [${tmpView.Hash}]`, pError);
						//TODO: should we fail the whole render?
						tmpResults[i] = '';
					}
					else
					{
						tmpResults[i] = this.pict.__TemplateOutputCache[tmpRenderGUID] || '';
						// TODO: Uncomment this when we like how it's working
						//delete this.pict.__TemplateOutputCache[tmpRenderGUID];
					}
					tmpRemaining--;
					tmpFinalize();
				});
		}
		// Handle the case where every filter was skipped synchronously (no valid view).
		tmpFinalize();
	}
}

module.exports = PictTemplateFilterInstanceViewInstruction;

},{"../views/filters/index.js":1027,"pict-template":1051}],980:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Specialized instruction for rendering the filter view and plumbing in required context.
 *
 * Based on the Pict base {~V:...~} template instruction.
 */
class PictTemplateFilterViewInstruction extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~FV:', '~}');
		this.addPattern('{~FilterView:', '~}');


		if (!('__TemplateOutputCache' in this.pict))
		{
			this.pict.__TemplateOutputCache = {};
		}
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let [ tmpViewHash, tmpViewContext ] = pTemplateHash.split(':');
		tmpViewHash = tmpViewHash.trim();
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set specified in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return '';
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set configuration found for [${tmpRecordSet}] in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return '';
		}
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: Filter View Template Render: View not found for [${tmpViewHash}]`);
			return '';
		}

		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}

		let tmpRenderGUID = this.pict.getUUID();

		/** @type {import('pict-view')} */
		const tmpView = this.pict.views[tmpViewHash];

		tmpView.render('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState && pState.RootRenderable);

		let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
		// TODO: Uncomment this when we like how it's working
		//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

		return tmpResult;
	}

	/**
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to call with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let [ tmpViewHash, tmpViewContext ] = pTemplateHash.split(':');
		tmpViewHash = tmpViewHash.trim();
		const tmpRecordSet = pRecord.RecordSet || '';
		if (!tmpRecordSet)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set specified in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return fCallback(null, '');
		}
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations?.[tmpRecordSet];
		if (!tmpRecordSetConfiguration)
		{
			this.pict.log.error(`Pict: Filter View Template Render: No record set configuration found for [${tmpRecordSet}] in template hash [${pTemplateHash}] for view [${tmpViewHash}]`);
			return fCallback(null, '');
		}
		if (tmpViewContext)
		{
			tmpViewContext = tmpViewContext.trim();
		}
		else
		{
			tmpViewContext = 'Default';
		}
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: Filter View Template Render: View not found for [${tmpViewHash}]`);
			return fCallback(null, '');
		}

		pRecord = pRecord || {};
		if (!pRecord.RecordSet)
		{
			pRecord.RecordSet = tmpRecordSet;
		}
		if (!pRecord.RecordSetConfiguration)
		{
			pRecord.RecordSetConfiguration = tmpRecordSetConfiguration;
		}
		if (!pRecord.ViewContext)
		{
			pRecord.ViewContext = pRecord.DashboardHash ? `${tmpViewContext}-${pRecord.DashboardHash}` : tmpViewContext;
		}
		let tmpRenderGUID = this.pict.getUUID();

		/** @type {import('pict-view')} */
		const tmpView = this.pict.views[tmpViewHash];

		return tmpView.renderAsync('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState && pState.RootRenderable,
			(pError, pResult) =>
			{
				if (pError)
				{
					this.log.warn(`Pict: Filter View Template Render: Error rendering view [${tmpViewHash}]`, pError);
					return fCallback(pError, '');
				}

				let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
				// TODO: Uncomment this when we like how it's working
				//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

				return fCallback(null, tmpResult);
			});
	}
}

module.exports = PictTemplateFilterViewInstruction;

},{"pict-template":1051}],981:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * The `{~RecordCard:RecordSet^IDAddress^Label~}` template tag — drops an inline preview-card trigger
 * (a label + a small icon) anywhere a record is referenced (lists, record views, dashboards). Clicking
 * it opens the recordset's configured preview card in an anchored popover (see RecordSet-CardManager).
 *
 * Three `^`-separated parts (the third is optional):
 *   1. RecordSet name (literal, e.g. `Author`).
 *   2. The record id — a literal number OR an address resolved against the current data (`Record.IDAuthor`).
 *   3. The visible label — an address (`Record.Name`) OR a literal string. Defaults to the id.
 *
 * Unlike `{~E:~}` this renders synchronously (no fetch): it only emits the trigger; the record is fetched
 * lazily on click. When no card is registered for the recordset it degrades to the plain label.
 */
class PictTemplateProviderRecordCard extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~RecordCard:', '~}');
		this.addPattern('{~RC:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		const tmpParts = String(pTemplateHash).trim().split('^');
		if (tmpParts.length < 2)
		{
			this.log.warn(`Pict: RecordCard tag needs at least RecordSet^id — got [${pTemplateHash}].`);
			return '';
		}

		let tmpRecordSet = tmpParts[0].trim();
		let tmpID = tmpParts[1].trim();
		let tmpLabel = (tmpParts.length > 2) ? tmpParts[2].trim() : '';

		// Resolve the recordset: a literal name stays, an address (Record./AppData.) is looked up. This
		// lets a shared template (e.g. an association row) drive the card's recordset from data — an empty
		// result degrades to the plain label.
		if (/^(Record|AppData)[.[]/.test(tmpRecordSet))
		{
			tmpRecordSet = this.resolveStateFromAddress(tmpRecordSet, pRecord, pContextArray, null, pScope, pState);
		}

		// Resolve the id: a literal number stays, otherwise it is an address into the data.
		if (isNaN(Number(tmpID)))
		{
			tmpID = this.resolveStateFromAddress(tmpID, pRecord, pContextArray, null, pScope, pState);
		}

		// Resolve the label: an address (Record./AppData.) is looked up, otherwise it is a literal.
		if (tmpLabel && /^(Record|AppData)[.[]/.test(tmpLabel))
		{
			tmpLabel = this.resolveStateFromAddress(tmpLabel, pRecord, pContextArray, null, pScope, pState);
		}
		if (tmpLabel == null || tmpLabel === '')
		{
			tmpLabel = (tmpID == null) ? '' : String(tmpID);
		}

		const tmpManager = this.pict.providers.RecordSetCardManager;
		if (!tmpManager)
		{
			return String(tmpLabel);
		}
		return tmpManager.triggerHTML(tmpRecordSet, tmpID, tmpLabel);
	}

	/** Async entry just defers to the synchronous render (no fetch happens here — it is click-driven). */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpCallback = (typeof fCallback === 'function') ? fCallback : () => '';
		return tmpCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}
}

module.exports = PictTemplateProviderRecordCard;

},{"pict-template":1051}],982:[function(require,module,exports){
const libPictView = require('pict-view');

const _DEFAULT_CONFIGURATION_FilterPersistenceView = (
{
	ViewIdentifier: 'FilterPersistenceView',

	DefaultRenderable: 'FilterPersistenceView-Container',
	DefaultDestinationAddress: '#FilterPersistenceView-Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: /*css*/`
.prsp-exp { display: flex; flex-direction: column; gap: 0.4rem; }
.prsp-exp-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
.prsp-exp-row { display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem; }
.prsp-exp-row > span:empty { display: none; }
.prsp-exp-select, .prsp-exp-name { font: inherit; font-size: 0.9rem; padding: 0.42rem 0.6rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-exp-select { flex: 0 0 auto; width: 230px; min-width: 0; max-width: 100%; }
/* When a host layers select2 (or a similar widget) on the stored-filter <select>, its container
   defaults to display:block at the row's full width, pushing Save/Delete onto a second line. Pin it to
   a fixed-width inline flex item so the controls stay on one row. */
.prsp-exp-row .select2-container { flex: 0 0 auto !important; display: inline-block !important; width: 230px !important; max-width: 100%; vertical-align: middle; }
.prsp-exp-select:focus, .prsp-exp-name:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.prsp-exp-btn { flex: 0 0 auto; white-space: nowrap; }
.prsp-exp-validation { font-size: 0.8rem; color: var(--theme-color-status-error, #cf5b5b); }
.prsp-exp-validation:empty { display: none; }
`,
	CSSPriority: 500,

	Templates:
		[
			{
			Hash: 'FilterPersistenceView-Container',
			Template: /*html*/`
<!-- DefaultPackage pict view template: [FilterPersistenceView-Container] -->
<div id="FilterPersistenceView-Content" class="prsp-exp">
	<span class="prsp-exp-label">Filter experience</span>
	<div class="prsp-exp-row">
		<select id="FilterPersistenceView-StoredFiltersSelect" class="prsp-exp-select" name="StoredFilterName" title="Load a saved filter experience"
			onchange="_Pict.views['FilterPersistenceView'].setFilterExperienceToSelection(event); _Pict.views['FilterPersistenceView'].loadFilterPersistenceSettings(event);">
			<!-- Options populated dynamically -->
		</select>
		<button type="button" class="prsp-filters-btn-text prsp-exp-btn" id="FilterPersistenceView-SaveFilterButton" title="Save the current search + filters as a named experience" onclick="_Pict.views['FilterPersistenceView'].promptSaveFilterExperience(event)">Save</button>
		<button type="button" class="prsp-filters-btn-text prsp-exp-btn" id="FilterPersistenceView-DeleteFilterButton" title="Delete the selected experience" onclick="_Pict.views['FilterPersistenceView'].deleteFilterPersistenceSettings(event)">Delete</button>
	</div>
	<span id="FilterPersistenceView-CurrentFilterNameInput-ValidationMessage" class="prsp-exp-validation"></span>
</div>
<!-- DefaultPackage end view template:  [FilterPersistenceView-Container] -->
		`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'FilterPersistenceView-Renderable',
				TemplateHash: 'FilterPersistenceView-Container',
				DestinationAddress: '#FilterPersistenceView-Container',
				RenderMethod: 'replace'
			},

		],

	Manifests: {}
});

class viewFilterPersistenceView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_FilterPersistenceView, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.currentRecordSet = null;
		this.currentViewContext = null;
		this.filterExperienceSelection = null;
		this.filterExperienceInitialized = false;
	}

	/**
	 * Re-assert this view's own template before rendering so a host/server template override
	 * doesn't replace the slimmed experiences control (mirrors RecordSet-Filters).
	 *
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onBeforeRender(pRenderable)
	{
		if (this.pict.TemplateProvider && Array.isArray(_DEFAULT_CONFIGURATION_FilterPersistenceView.Templates))
		{
			for (const tmpTemplate of _DEFAULT_CONFIGURATION_FilterPersistenceView.Templates)
			{
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template);
			}
		}
		return super.onBeforeRender(pRenderable);
	}
	

	/**
	 * Initializes the filter persistence view UI for a given record set and view context. This will render the UI and populate it with the relevant filter experiences for the given context.
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {function} pCallback - A callback function to be executed after initializing the UI.
	 * @returns {boolean} - Returns true when the UI has been initialized.
	 */
	initializeFilterPersistenceViewUI(pRecordSet, pViewContext, pCallback)
	{
		if (!pRecordSet || !pViewContext)
		{
			this.pict.log.error('RecordSet and ViewContext are required to open the Filter Persistence UI.');
			return false;
		}

		if (!this.filterExperienceInitialized)
		{
			this.pict.providers.FilterDataProvider.initializeFilterExperienceSettings(pRecordSet, pViewContext);
			this.filterExperienceInitialized = true;
		}
		this.currentRecordSet = pRecordSet;
		this.currentViewContext = pViewContext;
		// Implement the logic for toggling filter persistence UI here
		this.render('FilterPersistenceView-Renderable', undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		
		// set checkbox for "Remember Last Used Filter Experience" based on provider setting
		const checkboxElement = document.getElementById('OptionalSettings-RememberLastUsed');
		if (checkboxElement)
		{
			// @ts-ignore
			checkboxElement.checked = this.pict.providers.FilterDataProvider.getRememberLastUsedFilterExperience(this.currentRecordSet, this.currentViewContext);
		}
		// build the select options for available filter experiences
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.handleModifiedFiltersState();

		// if a callback function was provided, execute it after the UI has been generated
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		};
		return true;
	}

	/**
	 * Updates the current filter experience name in the input field based on the current filter experience applied for the given record set and view context. This is used to ensure that if the filter experience was modified outside of the UI (ex: through the URL hash), we can reflect that in the input field and also handle the button states accordingly to prevent unintended consequences of saving in an invalid state.
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {boolean} pIgnoreCurrentExperienceURLParam - Whether to ignore the current experience when updating the input field, use this when in a modified state and the url is now outdated, to generate a new name.
	 */
	updateDisplayNameInputWithCurrentFilterExperience(pRecordSet, pViewContext, pIgnoreCurrentExperienceURLParam = false)
	{
		const tmpFilterExperienceList = this.pict.providers.FilterDataProvider.getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext);
		// get the current filter experience hash from the URL
		const tmpExperienceURLParam = this.pict.providers.PictRouter?.router?.current?.[0].hashString?.split?.('/FilterExperience/')?.[1] || '';
		// look in the map for the filter experience with the given hash
		const filterExperiences = this.pict.providers.FilterDataProvider.getAllFiltersExperiencesForRecordSet(pRecordSet, pViewContext);
		// BUG?: We are doing a double lookup here to match both the name and the encoded URL param, because just looking up by URL param alone can lead to issues if there are multiple experiences with the same URL param but different names.
		const matchingExperience = filterExperiences.find((pExperience) => pExperience.FilterExperienceHash === tmpFilterExperienceList.find((exp) => exp.FilterExperienceEncodedURLParam === tmpExperienceURLParam)?.FilterExperienceHash);
		// If we found a matching experience (both name and encoded URL param), set it as the current filter name and the active selection in the selector	
		if (!pIgnoreCurrentExperienceURLParam && matchingExperience && (matchingExperience.FilterExperienceEncodedURLParam === tmpExperienceURLParam))
		{
			this.pict.providers.FilterDataProvider.setCurrentFilterName(matchingExperience, pRecordSet, pViewContext);
			this.filterExperienceSelection = matchingExperience.FilterExperienceHash;
			// check if the current filter experience is set as default on load, so we can set the button states accordingly
			const isDefault = this.pict.providers.FilterDataProvider.isDefaultFilterExperience(pRecordSet, pViewContext, this.filterExperienceSelection);
			this.handleSelectionButtonStates(isDefault);
		}
		else
		{
			this.pict.providers.FilterDataProvider.setCurrentFilterName(null, pRecordSet, pViewContext, null);
			this.filterExperienceSelection = null;
			this.handleSelectionButtonStates(null);
		}
	}

	/**
	 * Toggles the filter persistence UI for a given record set and view context
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {function} pCallback - A callback function to be executed after toggling the UI.
	 * @returns {boolean} - Returns true when the UI has been toggled.
	 */
	openFilterPersistenceUI(pRecordSet, pViewContext, pCallback)
	{
		// hide the button that was just clicked on (will use a different button to close the UI)
		if (document.getElementById('PRSP_Filter_Button_Manage'))
		{
			document.getElementById('PRSP_Filter_Button_Manage').style.display = 'none';
		}
		// render the UI for managing filter persistence settings
		this.initializeFilterPersistenceViewUI(pRecordSet, pViewContext, pCallback);
		return true;
	}
	
	/**
	 * Handles the state of the filter experience when it has been modified from the URL hash instead of through the UI, which can lead to an invalid state for saving if the user tries to save without realizing the current experience was modified outside of the UI.
	 * This method will show a warning message and disable the save/set as default/remove as default/delete buttons to prevent unintended consequences of saving in that state, and will prompt the user to load a filter experience through the UI or refresh the page to reset the state before they can save. It will also disable the current filter name input and set a warning message in it to indicate that the user needs to apply or reset filters changes to be able to save settings. If the filter experience is not in that modified state, it will ensure the buttons are enabled and the current filter name input is enabled and populated with the current filter experience name for better visibility when saving.
	 */
	handleModifiedFiltersState()
	{
		// if the current filter experience was modified from the URL hash, show a warning toast to the user that they need to load a filter experience through the UI or refresh the page to reset the state before they can save, since saving in that state could lead to unintended consequences of saving an unintended filter experience as the default or overwriting an existing filter experience without realizing it
		if (this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash)
		{
			// disable the save and set as default buttons to prevent saving in this state
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SaveFilterButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-DeleteFilterButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-CurrentFilterNameInput-ValidationMessage', 'Please apply or reset filter changes to enable saving settings.');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'title', 'The current filter experience has been modified. Please apply or reset filter changes to enable saving settings and set a default filter experience.');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'disabled', 'disabled');
		}
		else
		{
			// re-enable the buttons in case they were disabled from being in a modified state, to allow saving and setting default again
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-SaveFilterButton', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-SetAsDefaultButton', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-DeleteFilterButton', 'disabled');
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-CurrentFilterNameInput-ValidationMessage', '');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'title', '');
			this.pict.ContentAssignment.removeAttribute('#FilterPersistenceView-CurrentFilterNameInput', 'disabled');
		}
		// regardless of the modified state, update the current filter name input to match the current filter experience for better visibility when saving and to ensure it reflects any changes that may have happened to the filter experience from the URL hash or elsewhere
		this.updateDisplayNameInputWithCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash);
	}

	/**
	 * Updates the filter experience settings for a given record set and view context.
	 * @param {string} pRecordSet - The identifier of the record set.
	 * @param {string} pViewContext - The context of the view.
	 * @param {object} pSettings - The settings to update.
	 * @returns {boolean} - Returns true when the settings have been updated.
	 */
	updateFilterExperienceSettings(pRecordSet, pViewContext, pSettings)
	{
		if (pRecordSet && pViewContext)
		{
			this.pict.providers.FilterDataProvider.initializeFilterExperienceSettings(pRecordSet, pViewContext);
			this.currentRecordSet = pRecordSet;
			this.currentViewContext = pViewContext;
			// for any settings that may have changed, update those without replacing the whole settings object
			this.pict.providers.FilterDataProvider.updateFilterExperienceSettingsFromStorage(pRecordSet, pViewContext, pSettings);
			// build the select options for available filter experiences
			this.buildSelectOptionsForAvailableFilterExperiences();
		}
		return true;
	}

	/**
	 * Sets the filter experience to load based on user selection.
	 * @param {Event} event - The event object.
	 * @returns {boolean} - Returns true when the filter experience has been set.
	 */
	setFilterExperienceToSelection(event)
	{
		event.preventDefault();
		event.stopPropagation();

		this.filterExperienceSelection = this.pict.ContentAssignment.readContent('#FilterPersistenceView-StoredFiltersSelect');
		// check if the selected filter experience is set as default on load, so we can set the button states accordingly
		const isDefault = this.pict.providers.FilterDataProvider.isDefaultFilterExperience(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection);
		this.handleSelectionButtonStates(isDefault);
		// set the current filter name in the provider to match the selection
		const tmpSelectedFilterExperience = this.pict.providers.FilterDataProvider.getFilterExperienceByHash(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection);
		let tmpBackupDisplayName = '';
		if (!tmpSelectedFilterExperience)
		{
			tmpBackupDisplayName = `New ${this.currentRecordSet} ${this.currentViewContext} Filter`;
		}
		this.pict.providers.FilterDataProvider.setCurrentFilterName(tmpSelectedFilterExperience, this.currentRecordSet, this.currentViewContext, tmpBackupDisplayName);
		// update the save button to text to be "Update" instead of "Save" if the selected filter experience is the current one, to indicate that clicking it will update the existing filter experience instead of creating a new one
		if (this.filterExperienceSelection && this.pict.providers.FilterDataProvider.isCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection))
		{	
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonTextText', 'Update');
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonTextText', 'Save');
		}
		return true;
	}

	/**
	 * Closes the filter persistence UI.
	 * @returns {boolean} - Returns true when the UI has been closed.
	 */
	closeFilterPersistenceUI()
	{
		this.currentRecordSet = null;
		this.currentViewContext = null;
		this.filterExperienceSelection = null;
		this.handleSelectionButtonStates(null);
		// show the button that was hidden when opening the UI
		if (document.getElementById('PRSP_Filter_Button_Manage'))
		{
			document.getElementById('PRSP_Filter_Button_Manage').style.display = 'inline-block';
		}
		// Clear the content of the Filter Persistence View (if it's still on the DOM - it will re-render next time it's opened either way, but this is to ensure we don't have stale content if the view is still around in the DOM)
		if (document.getElementById('FilterPersistenceView-Content'))
		{
			document.getElementById('FilterPersistenceView-Content').innerHTML = '';
		}
		return true;
	}

	/**
	 * Builds the select options for available filter experiences. Sets the current filter as selected and indicates it in the option text.
	 * @returns {boolean} - Returns true when the options have been built.
	 */
	buildSelectOptionsForAvailableFilterExperiences()
	{
		let optionList = []
		const filterExperienceList = this.pict.providers.FilterDataProvider.getAllFiltersExperiencesForRecordSet(this.currentRecordSet, this.currentViewContext);
		// add a default option at the top
		optionList.push('<option value="">-- Select a stored Filter Experience --</option>');
		// iterate through the filter experiences and build the option elements
		for (const key in filterExperienceList)
		{ 
			// skip excluded ones (if needed for hidden/internal use)
			if (filterExperienceList[key].ExcludedFromSelection) 
			{
				continue;
			}
			// if the current filter is the active/default one, mention that in the option text for clarity
			const isCurrent = this.pict.providers.FilterDataProvider.isCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, filterExperienceList[key].FilterExperienceHash);
			const isDefault = this.pict.providers.FilterDataProvider.isDefaultFilterExperience(this.currentRecordSet, this.currentViewContext, filterExperienceList[key].FilterExperienceHash);
			let addOnText = '';
			if (isCurrent)
			{
				addOnText += ' (Current)';
			}
			if (isDefault)
			{
				addOnText += ' (Default)';
			}
			const optionElement = `<option ${ isCurrent ? 'selected' : ''} value="${filterExperienceList[key].FilterExperienceHash}">${filterExperienceList[key].FilterDisplayName || filterExperienceList[key].FilterExperienceHash}${addOnText}</option>`;
			optionList.push(optionElement);
		}
		/* @type {HTMLSelectElement} */
		const storedFiltersSelect = document.getElementById('FilterPersistenceView-StoredFiltersSelect');
		if (storedFiltersSelect)
		{
			storedFiltersSelect.innerHTML = optionList.join('\n');
		}
		// after rebuilding the options, if there is a current selection, ensure the save button text is correct based on whether the current selection is the active filter experience or not
		if (this.filterExperienceSelection && this.pict.providers.FilterDataProvider.isCurrentFilterExperience(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection))
		{	
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonText', 'Update');
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#FilterPersistenceView-SaveFilterButtonText', 'Save');
		}
		return true;
	}

	/**
	 * Toggles the "Remember Last Used Filter Experience" setting in the Filter Data Provider.
	 * @param {Event} event - The event object.
	 * @returns {boolean} - Returns true when the setting has been toggled.
	 */
	toggleRememberLastUsedFilterExperience(event)
	{
		event.preventDefault();
		event.stopPropagation();

		const checkboxElement = document.getElementById('OptionalSettings-RememberLastUsed');
		// @ts-ignore
		const rememberLastUsed = checkboxElement ? checkboxElement.checked : false;

		this.pict.providers.FilterDataProvider.setRememberLastUsedFilterExperience(this.currentRecordSet, this.currentViewContext, rememberLastUsed);
		this.pict.log.info(`Remember Last Used Filter Experience has been ${rememberLastUsed ? 'enabled' : 'disabled'}.`);
		return true;
	}

	/**
	 * Loads the filter persistence settings for the current selection of filter experiences.
	 * @param {Event} event - The event object.
	 * @returns {boolean} - Returns true when the settings have been loaded.
	 */
	loadFilterPersistenceSettings(event, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();
		const selectedFilterExperienceHash = this.filterExperienceSelection;
		if (!selectedFilterExperienceHash)
		{
			this.pict.log.warn('No filter experience selected to load.');
			return false;
		}
		this.pict.providers.FilterDataProvider.loadFilterMeta(this.currentRecordSet, this.currentViewContext, selectedFilterExperienceHash);
		this.pict.log.info(`Filter persistence settings have been loaded for filter: ${selectedFilterExperienceHash}`);
		this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = false;
		// if a callback function was provided, execute it after loading the settings (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}

	/**
	 * Saves the filter persistence settings for the current selection of filter experiences.
	 * @param {Event} event - The event object.
	 * @param {function} [pCallback] - A callback function to be executed after saving the settings.
	 * @returns {boolean} - Returns true when the settings have been saved.
	 */
	/** HTML-escape a value for safe display in the modal. */
	_escapeHTML(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	/** Describe a single active filter clause in plain English (e.g. "Date Created between A and B"). */
	_describeFilterClause(pClause)
	{
		const tmpLabel = pClause.Label || pClause.FilterByColumn || 'Filter';
		const tmpType = String(pClause.Type || '');
		const tmpValues = Array.isArray(pClause.Values) ? pClause.Values.filter((v) => v !== null && v !== undefined && v !== '') : [];
		const tmpValue = (pClause.Value !== null && pClause.Value !== undefined && pClause.Value !== '') ? pClause.Value : null;
		if (/Range/i.test(tmpType))
		{
			const tmpLow = (tmpValues.length > 0) ? tmpValues[0] : (tmpValue != null ? tmpValue : '…');
			const tmpHigh = (tmpValues.length > 1) ? tmpValues[1] : '…';
			return `${tmpLabel} between ${tmpLow} and ${tmpHigh}`;
		}
		if (/Select/i.test(tmpType))
		{
			const tmpList = tmpValues.length ? tmpValues : (tmpValue != null ? [ tmpValue ] : []);
			return tmpList.length ? `${tmpLabel} is ${tmpList.join(', ')}` : `${tmpLabel} is set`;
		}
		const tmpSingle = (tmpValue != null) ? tmpValue : (tmpValues.length ? tmpValues.join(', ') : null);
		const tmpOp = pClause.ExactMatch ? 'is' : 'contains';
		return (tmpSingle != null) ? `${tmpLabel} ${tmpOp} "${tmpSingle}"` : `${tmpLabel} is set`;
	}

	/**
	 * @returns {{ summary: string, count: string }} A plain-English summary of the current
	 * search + filter clauses, and the matched record count (from the rendered list total).
	 */
	_describeCurrentFilter()
	{
		const tmpParts = [];
		const tmpFilterView = this.pict.views['PRSP-Filters'];
		const tmpSearchTerm = (tmpFilterView && typeof tmpFilterView._searchTermFromURL === 'function') ? tmpFilterView._searchTermFromURL() : '';
		if (tmpSearchTerm)
		{
			const tmpCfg = this.pict.PictSectionRecordSet && this.pict.PictSectionRecordSet.recordSetProviderConfigurations
				? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this.currentRecordSet] : null;
			const tmpFields = (tmpCfg && Array.isArray(tmpCfg.SearchFields) && tmpCfg.SearchFields.length) ? tmpCfg.SearchFields : [ 'Name' ];
			tmpParts.push(`${tmpFields.join(' / ')} like "${tmpSearchTerm}"`);
		}
		const tmpClauses = (this.pict.Bundle._ActiveFilterState[this.currentRecordSet] || {}).FilterClauses || [];
		for (const tmpClause of tmpClauses) { tmpParts.push(this._describeFilterClause(tmpClause)); }
		const tmpSummary = tmpParts.length ? (tmpParts.join('. ') + '.') : 'No filters — matches all records.';
		const tmpCountEl = document.getElementById('PRSP_Pagination_Description_Records_Total');
		const tmpCount = (tmpCountEl && tmpCountEl.textContent) ? tmpCountEl.textContent.trim() : '';
		return { summary: tmpSummary, count: tmpCount };
	}

	/**
	 * Prompt for a name (via pict-section-modal when available) and save the current search +
	 * filters as a named experience. The modal previews the filter in plain English and the
	 * number of records it matches. Falls back to the generated name with no prompt if the
	 * modal section is not registered in the host app.
	 *
	 * @param {Event} pEvent
	 */
	promptSaveFilterExperience(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); pEvent.stopPropagation(); }
		if (!this.currentRecordSet || !this.currentViewContext) { return false; }
		const tmpProvider = this.pict.providers.FilterDataProvider;
		if (tmpProvider.filterExperienceModifiedFromURLHash)
		{
			this.pict.log.warn('The current filter experience was modified from the URL hash; apply or reset before saving.');
			return false;
		}
		const tmpClauses = (this.pict.Bundle._ActiveFilterState[this.currentRecordSet] || {}).FilterClauses || [];
		const tmpCurrent = this.filterExperienceSelection ? tmpProvider.getFilterExperienceByHash(this.currentRecordSet, this.currentViewContext, this.filterExperienceSelection) : null;
		const tmpSuggested = (tmpCurrent && tmpCurrent.FilterDisplayName) || tmpProvider.generateContextualDefaultFilterName({ FilterClauses: tmpClauses }, this.currentRecordSet, this.currentViewContext);

		const fSave = (pName) =>
		{
			tmpProvider.saveFilterMeta(this.currentRecordSet, this.currentViewContext, false, pName);
			this.buildSelectOptionsForAvailableFilterExperiences();
			this.pict.log.info(`Filter experience '${pName}' saved.`);
		};

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			fSave(tmpSuggested);
			return true;
		}
		const tmpEscaped = this._escapeHTML(tmpSuggested);
		const tmpDescription = this._describeCurrentFilter();
		const tmpCountLine = tmpDescription.count
			? `<p style="margin:0 0 0.8rem;color:var(--theme-color-text-secondary,#45505f);">Matches <strong>${this._escapeHTML(tmpDescription.count)}</strong> record${tmpDescription.count === '1' ? '' : 's'}.</p>`
			: '';
		tmpModal.show(
			{
				title: 'Save filter experience',
				content: `<p style="margin:0 0 0.75rem;color:var(--theme-color-text-secondary,#45505f);font-size:0.9rem;line-height:1.45;">Give this filter a name to save it, then load it again any time to come back to these records, or whatever matches it down the road.</p><div style="margin-bottom:0.6rem;padding:0.6rem 0.8rem;border-radius:8px;background:var(--theme-color-background-tertiary,#eceef2);font-size:0.9rem;line-height:1.4;color:var(--theme-color-text-primary,#1f2733);">${this._escapeHTML(tmpDescription.summary)}</div>${tmpCountLine}<p style="margin-bottom:0.4rem;">Name this filter experience:</p><input type="text" id="prsp-exp-name-input" class="pict-input" style="width:100%;" value="${tmpEscaped}" autofocus>`,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Save', Style: 'primary' } ],
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') { return; }
				const tmpEl = document.getElementById('prsp-exp-name-input');
				const tmpName = (tmpEl && tmpEl.value && tmpEl.value.trim()) ? tmpEl.value.trim() : tmpSuggested;
				fSave(tmpName);
			});
		return true;
	}

	saveFilterPersistenceSettings(event, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();

		if (!this.currentRecordSet || !this.currentViewContext)
		{
			this.pict.log.warn('Missing a record set or view context to save filter persistence settings. Skipping save. CurrentRecordSet: ' + this.currentRecordSet + ', CurrentViewContext: ' + this.currentViewContext + ')');
			return false;
		}

		if (this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash)
		{
			this.pict.log.warn('The current filter experience has been modified from the URL hash and not through the UI, so it may not be in a valid state to save. Please load a filter experience through the UI or refresh the page to reset the state before saving.');
			return false;
		}

		this.pict.providers.FilterDataProvider.saveFilterMeta(this.currentRecordSet, this.currentViewContext, false);
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.pict.log.info('Filter persistence settings have been saved.');
		// if a callback function was provided, execute it after saving the settings (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}

	/**
	 * Sets the filter experience as the default for the current record set and view context.
	 * @param {Event} event - The event object.
	 * @param {boolean} isDefault - Whether to set as default or not.
	 * @param {function} [pCallback] - A callback function to be executed after toggling the default setting.
	 * @returns {boolean} - Returns true when the settings have been set as default.
	 */
	toggleFilterExperienceAsTheDefault(event, isDefault, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();

		const selectedFilterExperienceHash = this.filterExperienceSelection;
		if (!selectedFilterExperienceHash)
		{
			this.pict.log.warn('No filter experience selected to set as default.');
			return false;
		}
		// set or unset the default filter experience on load in the provider
		this.pict.providers.FilterDataProvider.setDefaultFilterExperience(this.currentRecordSet, this.currentViewContext, selectedFilterExperienceHash, isDefault);
		this.handleSelectionButtonStates(isDefault);
		
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.pict.log.info(`Filter experience ${selectedFilterExperienceHash} has been ${isDefault ? 'set' : 'unset'} as the default on load.`);
		// if a callback function was provided, execute it after setting the default (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}

	/**
	 * Handles the button states for the filter experience selection.
	 * @param {boolean} isDefault - Whether the filter experience is set as default or not.
	 */
	handleSelectionButtonStates(isDefault)
	{
		if (!this.filterExperienceSelection)
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-LoadFilterButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-DeleteFilterButton', 'style', 'display: none;');
			return;
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-LoadFilterButton', 'style', 'display: inline-block;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-DeleteFilterButton', 'style', 'display: inline-block;');
		}
		// handle the set/remove default buttons separately when we have a selection
		if (isDefault)
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'style', 'display: none;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'style', 'display: inline-block;');
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-SetAsDefaultButton', 'style', 'display: inline-block;');
			this.pict.ContentAssignment.setAttribute('#FilterPersistenceView-RemoveAsDefaultButton', 'style', 'display: none;');
		}
	}

	/**
	 * Deletes the filter persistence settings for the current selection of filter experiences.
	 * @param {Event} event - The event object.
	 * @param {function} [pCallback] - A callback function to be executed after deleting the settings.
	 * @returns {boolean} - Returns true when the settings have been deleted.
	 */
	deleteFilterPersistenceSettings(event, pCallback)
	{
		event.preventDefault();
		event.stopPropagation();

		const selectedFilterExperienceHash = this.filterExperienceSelection;
		if (!selectedFilterExperienceHash)
		{
			this.pict.log.warn('No filter experience selected to delete.');
			return false;
		}
		this.pict.providers.FilterDataProvider.removeFilterMeta(this.currentRecordSet, this.currentViewContext, selectedFilterExperienceHash);
		this.buildSelectOptionsForAvailableFilterExperiences();
		this.pict.log.info(`Filter persistence settings have been deleted for filter: ${selectedFilterExperienceHash}`);
		// if a callback function was provided, execute it after deleting the settings (toasts, etc.)
		if (pCallback && typeof pCallback === 'function')
		{
			pCallback();
		}
		return true;
	}
}

module.exports = viewFilterPersistenceView;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_FilterPersistenceView;
},{"pict-view":1053}],983:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The theme custom properties the add-filter popover paints from. Copied onto it while it sits on
 * <body>, so it keeps the host's theme after leaving a scoped container. Same approach as
 * pict-section-picker's _THEME_TOKENS (PictView-Picker.js).
 * @type {Array<string>}
 */
const _ADD_FILTER_THEME_TOKENS =
[
	'--theme-color-brand-primary', '--theme-color-text-primary', '--theme-color-text-secondary',
	'--theme-color-text-muted', '--theme-color-border-default', '--theme-color-border-light',
	'--theme-color-background-panel', '--theme-color-background-tertiary',
];

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_SUBSET_Filter =
{
	ViewIdentifier: 'PRSP-SUBSET-Filters',

	DefaultRenderable: 'PRSP_Renderable_Filters',
	DefaultDestinationAddress: '#PRSP_Filters_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: /*css*/`
.prsp-filters { width: 100%; }
.prsp-filters *, .prsp-filters *::before, .prsp-filters *::after { box-sizing: border-box; }
.prsp-filters-bar { display: flex; align-items: center; gap: 0.5rem; margin: 0; }
.prsp-filters-search { position: relative; flex: 1 1 auto; display: flex; align-items: center; min-width: 0; }
.prsp-filters-search-ic { position: absolute; left: 0.75rem; display: inline-flex; align-items: center; color: var(--theme-color-text-muted, #6b7686); pointer-events: none; font-size: 0.95rem; }
.prsp-filters-input { width: 100%; font: inherit; font-size: 0.95rem; padding: 0.5rem 0.85rem 0.5rem 2.2rem;
	border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px;
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-filters-input:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.prsp-filters-toggle { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.4rem; font: inherit; cursor: pointer;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-secondary, #45505f); }
.prsp-filters-toggle:hover { border-color: var(--theme-color-brand-primary, #156dd1); }
.prsp-filters.has-filters .prsp-filters-toggle { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
.prsp-filters.drawer-open .prsp-filters-toggle { background: var(--theme-color-background-tertiary, #eceef2); }
.prsp-filters-toggle-ic { display: inline-flex; align-items: center; }
.prsp-filters-toggle-ic svg { width: 1.05em; height: 1.05em; display: block; }
.prsp-filters-toggle-count { display: none; align-items: center; justify-content: center; min-width: 1.3em; height: 1.3em;
	padding: 0 0.35em; border-radius: 999px; font-size: 0.74rem; font-weight: 700;
	background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-on-brand, #fff); }
.prsp-filters.has-filters .prsp-filters-toggle-count { display: inline-flex; }
.prsp-filters-apply { flex: 0 0 auto; font: inherit; font-weight: 650; cursor: pointer; padding: 0.5rem 1.15rem; border-radius: 8px;
	border: 1px solid var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-text-on-brand, #fff); }
.prsp-filters-apply:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 88%, #000); }
.prsp-filters-btn-text { font: inherit; cursor: pointer; padding: 0.4rem 0.85rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: transparent; color: var(--theme-color-text-secondary, #45505f); }
.prsp-filters-btn-text:hover { background: var(--theme-color-background-tertiary, #eceef2); }

/* Slide-out drawer (CSS grid trick: 0fr -> 1fr animates height). The inner is a *pure* clip box; all the
   visible card chrome lives on .prsp-filters-drawer-card inside it. That way, on collapse the chrome shrinks
   *with* the animating height instead of vanishing instantly — the old rule gated padding/border/background
   on .drawer-open, so closing the drawer stripped the card in one frame while the height still animated for
   0.18s, making the quick-filters bar look like it popped out of the panel before disappearing. */
.prsp-filters-drawer { display: grid; grid-template-rows: 0fr; transition: grid-template-rows 0.18s ease; }
.prsp-filters.drawer-open .prsp-filters-drawer { grid-template-rows: 1fr; }
.prsp-filters-drawer-inner { overflow: hidden; min-height: 0; }
.prsp-filters-drawer-card { margin-top: 0.6rem; padding: 0.95rem 1.1rem;
	border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; background: var(--theme-color-background-panel, #fff); }
.prsp-filters-add { position: relative; margin: 0.4rem 0 0.2rem; }
.prsp-addfilter-trigger { display: inline-flex; align-items: center; gap: 0.35rem; }
/* Drawer footer: filter experience on the left, Clear/Reset/Apply on the right. */
.prsp-filters-footer { display: flex; align-items: flex-end; justify-content: space-between; gap: 1.5rem; flex-wrap: wrap;
	margin-top: 0.85rem; padding-top: 0.75rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
.prsp-filters-experiences { flex: 0 1 auto; min-width: 0; }
.prsp-filters-actions { flex: 0 0 auto; display: flex; align-items: center; gap: 0.5rem; }

/* Quick Filters — a curated, one-interaction bar at the top of the drawer (above the clause list).
   Painted post-render into #PRSP_QuickFilters; hidden via :empty when the record set has none. */
.prsp-quickfilters { display: flex; align-items: center; flex-wrap: wrap; gap: 0.55rem 0.9rem;
	margin-bottom: 0.7rem; padding-bottom: 0.75rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.prsp-quickfilters:empty { display: none; }
.prsp-quickfilters-label { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b7686); }
.prsp-quickfilter { display: inline-flex; flex-direction: column; gap: 0.2rem; min-width: 0; }
.prsp-quickfilter-name { font-size: 0.72rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
.prsp-quickfilter-input { font: inherit; font-size: 0.9rem; width: 13rem; max-width: 100%; padding: 0.4rem 0.7rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-quickfilter-input:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
.prsp-quickfilter-daterange { display: inline-flex; align-items: center; gap: 0.35rem; }
.prsp-quickfilter-date { width: 9.5rem; }
.prsp-quickfilter-dash { color: var(--theme-color-text-muted, #6b7686); }
/* Entity quick control: the pict-section-picker mounts into this host (its own .pps chrome themes it). */
.prsp-quickfilter-entityhost { display: inline-block; width: 14rem; max-width: 100%; vertical-align: middle; }
/* Show-deleted switch (RecordSetListShowDeletedFilter): a labeled checkbox in the drawer actions row.
   Painted post-render into the host label; :empty hides it for record sets that haven't opted in. */
.prsp-filters-showdeleted { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; user-select: none;
	font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); margin-right: 0.35rem; }
.prsp-filters-showdeleted:empty { display: none; }
.prsp-filters-showdeleted-checkbox { width: 1.05rem; height: 1.05rem; cursor: pointer; accent-color: var(--theme-color-brand-primary, #156dd1); }

/* Module-owned "Add filter" popover (replaces the old native <select> pickers). */
/* Moved to <body> on open and placed in document coordinates, so no ancestor overflow:hidden — the filter
   card, the slide-out drawer — can clip it, and it rides page scroll together with its trigger. */
.prsp-addfilter-pop { position: absolute; z-index: 30; min-width: 280px; max-width: 360px; display: none; }
.prsp-addfilter-pop.open { display: block; }
/* Transparent full-viewport backdrop: catches outside clicks to close (no document listener). */
.prsp-addfilter-backdrop { position: fixed; inset: 0; z-index: 0; }
.prsp-addfilter-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(70vh, 460px);
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
.prsp-addfilter-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
.prsp-addfilter-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
.prsp-addfilter-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.prsp-addfilter-list { flex: 1 1 auto; overflow-y: auto; }
.prsp-addfilter-empty { padding: 0.7rem 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; }
.prsp-addfilter-field { border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
.prsp-addfilter-field:last-child { border-bottom: none; }
.prsp-addfilter-field-btn { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; width: 100%;
	font: inherit; font-size: 0.9rem; text-align: left; cursor: pointer; padding: 0.5rem 0.75rem; border: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
.prsp-addfilter-field-btn:hover { background: var(--theme-color-background-tertiary, #eceef2); }
.prsp-addfilter-chev { display: inline-flex; flex: 0 0 auto; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; transition: transform 0.15s ease; }
.prsp-addfilter-field.is-expanded .prsp-addfilter-chev { transform: rotate(90deg); }
.prsp-addfilter-clauses { display: flex; flex-direction: column; }
.prsp-addfilter-clause { display: flex; align-items: center; gap: 0.4rem; width: 100%; text-align: left; cursor: pointer;
	font: inherit; font-size: 0.85rem; padding: 0.4rem 0.8rem 0.4rem 1.6rem; border: none; background: transparent; color: var(--theme-color-text-secondary, #45505f); }
.prsp-addfilter-clause:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 10%, transparent); color: var(--theme-color-brand-primary, #156dd1); }
.prsp-addfilter-clause-ic { display: inline-flex; font-size: 0.8rem; }
`,
	CSSPriority: 500,

	Templates:
	[
		{
			// One coherent control: a search row (search input + a filters icon button that
			// shows the active-filter count and toggles the drawer + a Search button), and a
			// slide-out drawer beneath it holding the filter clauses, "add filter", the saved
			// Filter Experiences dropdown, and Clear / Reset / Apply. Search, Apply and Enter
			// all submit the form -> handleSearch (apply search + current filters).
			Hash: 'PRSP-SUBSET-Filters-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template] -->
	<div class="prsp-filters" id="PRSP_FilterBar">
		<form id="PRSP_Filter_Form" class="prsp-filters-bar" onsubmit="event.preventDefault(); event.stopPropagation(); _Pict.views['PRSP-Filters'].handleSearch(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}'); return false;">
			{~T:PRSP-SUBSET-Filters-Template-Input-Fieldset~}
			{~T:PRSP-SUBSET-Filters-Template-Button-Fieldset~}
		</form>
		<div class="prsp-filters-drawer" id="PRSP_Filter_Drawer">
			<div class="prsp-filters-drawer-inner">
				<!-- The card carries all the panel chrome and lives *inside* the clip box, so it collapses
				     together with the animating height (see .prsp-filters-drawer-card in CSS). -->
				<div class="prsp-filters-drawer-card">
					<!-- Quick Filters: a curated, one-interaction bar painted post-render into this host
					     (empty when the record set has no quick filters → CSS :empty hides it). -->
					<div class="prsp-quickfilters" id="PRSP_QuickFilters"></div>
					<div id="PRSP_Filter_Instances" class="prsp-filters-clauses">
						{~FIV:Record~}
					</div>
					{~T:PRSP-SUBSET-Filters-Template-AddFilter-Fieldset~}
					<div class="prsp-filters-footer">
						{~T:PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset~}
						{~T:PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset~}
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-Input-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-Input-Fieldset] -->
	<span class="prsp-filters-search">
		<span class="prsp-filters-search-ic">{~I:Search~}</span>
		<input id="search_filter" class="prsp-filters-input" type="text" name="filter" placeholder="Search…" autocomplete="off" aria-label="Search">
	</span>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-Input-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-Button-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-Button-Fieldset] -->
	<button type="button" class="prsp-filters-toggle" id="PRSP_Filter_Toggle" title="Filters" aria-label="Filters" onclick="_Pict.views['PRSP-Filters'].toggleFilterDrawer()">
		<span class="prsp-filters-toggle-ic" id="PRSP_Filter_Icon"></span>
		<span class="prsp-filters-toggle-count" id="PRSP_Filter_Count"></span>
	</button>
	<button type="submit" class="prsp-filters-apply prsp-filters-apply-search" id="PRSP_Filter_Button_Apply">Search</button>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-Button-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset] -->
	<div class="prsp-filters-experiences">
		<div id="FilterPersistenceView-Container"></div>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset] -->
	<div class="prsp-filters-actions">
		<label class="prsp-filters-showdeleted" id="PRSP_ShowDeleted_Host" title="Include soft-deleted records in the results"></label>
		<button type="button" class="prsp-filters-btn-text" id="PRSP_Filter_Button_Clear" title="Clear all filters to a blank state" onclick="_Pict.views['PRSP-Filters'].handleClear(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">Clear</button>
		<button type="button" class="prsp-filters-btn-text" id="PRSP_Filter_Button_Reset" title="Reset all filters to the last saved/defaulted state" onclick="_Pict.views['PRSP-Filters'].handleReset(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">Reset</button>
		<button type="button" class="prsp-filters-apply" id="PRSP_Filter_Button_ApplyDrawer" onclick="_Pict.views['PRSP-Filters'].handleSearch(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">Apply</button>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-SUBSET-Filters-Template-AddFilter-Fieldset',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-SUBSET-Filters-Template-AddFilter-Fieldset] -->
	<div class="prsp-filters-add">
		<button type="button" class="prsp-filters-btn-text prsp-addfilter-trigger" id="PRSP_Filter_Button_Add" title="Add a new filter clause" onclick="_Pict.views['PRSP-Filters'].toggleAddFilterPopover(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">{~I:Plus~} Add filter</button>
		<div class="prsp-addfilter-pop" id="PRSP_AddFilter_Popover"></div>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-SUBSET-Filters-Template-AddFilter-Fieldset] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-Popover',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-Popover] -->
	<div class="prsp-addfilter-backdrop" onclick="_Pict.views['PRSP-Filters'].closeAddFilterPopover()"></div>
	<div class="prsp-addfilter-panel">
		<div class="prsp-addfilter-search">
			<span class="prsp-addfilter-search-ic">{~I:Search~}</span>
			<input type="text" id="PRSP_AddFilter_Search" placeholder="Search filters…" autocomplete="off" value="{~D:AppData.PRSPAddFilter.Search~}" oninput="_Pict.views['PRSP-Filters'].searchAddFilter(this.value)" onkeydown="if (event.key === 'Escape') { event.preventDefault(); _Pict.views['PRSP-Filters'].closeAddFilterPopover(); }">
		</div>
		<div class="prsp-addfilter-list" id="PRSP_AddFilter_List">
			{~T:PRSP-AddFilter-List~}
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-AddFilter-Popover] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-List',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-List] -->
	{~TS:PRSP-AddFilter-Field:AppData.PRSPAddFilter.Fields~}
	{~NE:AppData.PRSPAddFilter.IsEmpty^<div class="prsp-addfilter-empty">No filters found.</div>~}
	<!-- DefaultPackage end view template: [PRSP-AddFilter-List] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-Field',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-Field] -->
	<div class="prsp-addfilter-field {~D:Record.ExpandedClass~}">
		<button type="button" class="prsp-addfilter-field-btn" onclick="_Pict.views['PRSP-Filters'].toggleAddFilterField('{~D:Record.FilterKey~}')">
			<span class="prsp-addfilter-field-name">{~D:Record.DisplayName~}</span>
			<span class="prsp-addfilter-chev">{~I:ChevronRight~}</span>
		</button>
		<div class="prsp-addfilter-clauses">
			{~TS:PRSP-AddFilter-Clause:Record.ClausesToShow~}
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-AddFilter-Field] -->
`
		},
		{
			Hash: 'PRSP-AddFilter-Clause',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-AddFilter-Clause] -->
	<button type="button" class="prsp-addfilter-clause" onclick="_Pict.views['PRSP-Filters'].addFilter(event, '{~D:AppData.PRSPAddFilter.RecordSet~}', '{~D:AppData.PRSPAddFilter.ViewContext~}', '{~D:Record.FilterKey~}', '{~D:Record.ClauseKey~}')">
		<span class="prsp-addfilter-clause-ic">{~I:Plus~}</span>
		<span>{~D:Record.DisplayName~}</span>
	</button>
	<!-- DefaultPackage end view template: [PRSP-AddFilter-Clause] -->
`
		},
		{
			// Quick Filters bar contents (painted into #PRSP_QuickFilters post-render). A small label +
			// one compact control per definition; each control drives a real, tagged clause.
			Hash: 'PRSP-QuickFilters-Bar',
			Template: /*html*/`
		<span class="prsp-quickfilters-label">Quick filters</span>
		{~TS:PRSP-QuickFilter-Item:Record.Filters~}
`
		},
		{
			// One quick filter: a name + exactly one control, chosen by the single-element-array slot
			// (text / date range / entity picker) populated for this item's control type.
			Hash: 'PRSP-QuickFilter-Item',
			Template: /*html*/`
		<div class="prsp-quickfilter">
			<span class="prsp-quickfilter-name">{~D:Record.Label~}</span>
			{~TS:PRSP-QuickFilter-Text:Record.TextSlot~}
			{~TS:PRSP-QuickFilter-Date:Record.DateSlot~}
			{~TS:PRSP-QuickFilter-Entity:Record.EntitySlot~}
			{~TS:PRSP-QuickFilter-Distinct:Record.DistinctSlot~}
		</div>
`
		},
		{
			// Text control (fuzzy match) — commits on change, which the browser fires on Enter and on blur
			// (never per-keystroke, so the re-render that an apply triggers can't steal focus mid-type).
			Hash: 'PRSP-QuickFilter-Text',
			Template: /*html*/`
		<input class="prsp-quickfilter-input" type="text" value="{~D:Record.Value~}" placeholder="{~D:Record.Placeholder~}" autocomplete="off"
			onchange="_Pict.views['PRSP-Filters'].applyQuickFilterText('{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Field~}', '{~D:Record.ClauseKey~}', this.value)">
`
		},
		{
			// Date-range control — a from/to pair driving one DateRange clause (Values.Start / .End).
			Hash: 'PRSP-QuickFilter-Date',
			Template: /*html*/`
		<span class="prsp-quickfilter-daterange">
			<input type="date" class="prsp-quickfilter-input prsp-quickfilter-date" value="{~D:Record.StartValue~}" aria-label="{~D:Record.Label~} from"
				onchange="_Pict.views['PRSP-Filters'].applyQuickFilterDate('{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Field~}', '{~D:Record.ClauseKey~}', 'start', this.value)">
			<span class="prsp-quickfilter-dash">–</span>
			<input type="date" class="prsp-quickfilter-input prsp-quickfilter-date" value="{~D:Record.EndValue~}" aria-label="{~D:Record.Label~} to"
				onchange="_Pict.views['PRSP-Filters'].applyQuickFilterDate('{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Field~}', '{~D:Record.ClauseKey~}', 'end', this.value)">
		</span>
`
		},
		{
			// Entity control — a pict-section-picker mounts into this host (post-render, in
			// _mountQuickFilterEntity), so the quick filter reuses the real entity picker.
			Hash: 'PRSP-QuickFilter-Entity',
			Template: /*html*/`
		<span class="prsp-quickfilter-entityhost" id="{~D:Record.HostID~}"></span>
`
		},
		{
			// Distinct-values control — a multi-select pict-section-picker mounts into this host
			// (post-render, in _mountQuickFilterDistinct), its options the column's distinct values.
			Hash: 'PRSP-QuickFilter-Distinct',
			Template: /*html*/`
		<span class="prsp-quickfilter-entityhost" id="{~D:Record.HostID~}"></span>
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Filters',
			TemplateHash: 'PRSP-SUBSET-Filters-Template',
			DestinationAddress: '#PRSP_Filters_Container',
			RenderMethod: 'replace'
		},
		{
			RenderableHash: 'PRSP_AddFilter_Popover',
			TemplateHash: 'PRSP-AddFilter-Popover',
			ContentDestinationAddress: '#PRSP_AddFilter_Popover',
			RenderMethod: 'replace',
		},
		{
			RenderableHash: 'PRSP_AddFilter_List',
			TemplateHash: 'PRSP-AddFilter-List',
			ContentDestinationAddress: '#PRSP_AddFilter_List',
			RenderMethod: 'replace',
		},
	],

	Manifests: {},
};

//FIXME: export this from PSF?
const libPictViewDynamicForm = require('pict-section-form/source/views/Pict-View-DynamicForm.js');

const DynamicInputViewSectionDefinition = (
{
	"Hash": "PSRSDynamicInputs",
	"Name": "Custom Dynamic Inputs",
	"ViewHash": "PSRSFilterProxyView",

	"AutoMarshalDataOnSolve": true,
	"IncludeInMetatemplateSectionGeneration": false,

	"Manifests":
	{
		"Section":
		{
			"Scope": "PSRSDynamic",
			"Sections":
			[
				{
					"Hash": "PSRSDynamicInputs",
					"Name": "Dynamic Inputs"
				}
			],
			"Descriptors":
			{
				"PSRS.DynamicInputPlaceholder":
				{
					"Name": "DynamicInputPlaceholder",
					"Hash": "DynamicInputPlaceholder",
					"DataType": "String",
					"Macro":
					{
						"HTMLSelector": ""
					},
					"PictForm":
					{
						"Section": "PSRSDynamicInputs"
					}
				}
			}
		}
	}
});
class ViewRecordSetSUBSETFilters extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_SUBSET_Filter, pOptions);
		super(pFable, tmpOptions, pServiceHash);
		/** @type {import('fable') & import('pict') & { PictSectionRecordSet: import('../Pict-Section-RecordSet.js') }} */
		this.pict;

		if (!this.pict.views[DynamicInputViewSectionDefinition.ViewHash])
		{
			const tmpViewConfiguration = Object.assign({}, DynamicInputViewSectionDefinition);
			this.pict.addView(tmpViewConfiguration.ViewHash, tmpViewConfiguration, libPictViewDynamicForm);
			this.pict.views[DynamicInputViewSectionDefinition.ViewHash].viewMarshalDestination = 'Bundle';
		}
		for (const tmpView of Object.values(require('./filters')))
		{
			if (tmpView.default_configuration.ViewIdentifier && !this.pict.views[tmpView.default_configuration.ViewIdentifier])
			{
				this.pict.addView(tmpView.default_configuration.ViewIdentifier, {}, tmpView);
			}
		}
		this.chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

		// Use a lookup table to find the index.
		this.lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
		for (let i = 0; i < this.chars.length; i++)
		{
			this.lookup[this.chars.charCodeAt(i)] = i;
		}
		this.newFilterSearchApplied = false;
		this.addFilterCallback = null;
		this.removeFilterCallback = null;
		// Consolidated filter control state: drawer open/closed, and the last-applied search
		// string per record set (so a search no longer clears the search box on re-render).
		this._drawerOpen = false;
		this._searchString = {};
		// Render-epoch counter, bumped any time the filter list is re-rendered
		// or a new filter experience is applied. Deferred filter post-render
		// work (e.g. the setTimeout-scheduled transaction drain in
		// Pict-Template-FilterInstanceViews) captures the epoch at schedule
		// time and compares against the current value before running, so a
		// stale callback doesn't clobber DOM that now belongs to a different
		// filter experience.
		this._renderEpoch = 0;
		// Add-filter popover state (module-owned, replaces the old native <select> pickers).
		this._addFilterOpen = false;
		this._addFilterRecordSet = null;
		this._addFilterViewContext = null;
		this._addFilterSearch = '';
		this._addFilterExpandedKey = null;
		// FilterKeys to hide from the add-filter popover (e.g. internal/audit columns). Host apps
		// set this; it is merged with a per-record-set config `FilterFieldBlacklist`.
		this.filterFieldBlacklist = [];
	}

	/**
	 * Bump the render epoch. Call this whenever the active filter clauses are
	 * about to change in a way that would invalidate in-flight filter renders.
	 *
	 * @return {number} The new epoch value.
	 */
	bumpRenderEpoch()
	{
		this._renderEpoch++;
		return this._renderEpoch;
	}

	/**
	 * Sets a callback function to be executed after a filter is added.
	 * @param {function} pCallback - The callback function to be executed after a filter is added.
	 */
	setAddFilterCallback(pCallback)
	{
		this.addFilterCallback = pCallback;
	}

	/**
	 * Sets a callback function to be executed after a filter is removed.
	 * @param {function} pCallback - The callback function to be executed after a filter is removed.
	 */
	setRemoveFilterCallback(pCallback)
	{
		this.removeFilterCallback = pCallback;
	}

	/**
	 * Removes the callback function for adding a filter.
	 */
	removeAddFilterCallback()
	{
		this.addFilterCallback = null;
	}

	/**
	 * Removes the callback function for removing a filter.
	 */
	removeRemoveFilterCallback()
	{
		this.removeFilterCallback = null;
	}

	/**
	 * @return {string} - The marshalling prefix configured for filters. Usually 'Bundle.'
	 */
	getInformaryAddressPrefix()
	{
		return `${this.pict.views[DynamicInputViewSectionDefinition.ViewHash].viewMarshalDestination}.`;
	}

	/**
	 * @param {string} pAddress - The address of the informary to get the value from.
	 *
	 * @return {any} - The value at the given address, using the informary marshalling prefix.
	 */
	getInformaryScopedValue(pAddress)
	{
		const tmpCompositeAddress = `${this.getInformaryAddressPrefix()}${pAddress}`;
		return this.pict.resolveStateFromAddress(tmpCompositeAddress);
	}

	//NOTE: two methods below copied from the pict-section-form metacontroller
	//TODO: consider subclassing the dynamic view to somehow mark these as filter views so we can only operate on those views

	/**
	 * Marshals data from the view to the model, usually AppData (or configured data store).
	 * @returns {any} The result of the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalFromView();
			}
		}
		return super.onMarshalFromView();
	}

	/**
	 * Marshals the data to the view from the model, usually AppData (or configured data store).
	 * @returns {any} The result of the super.onMarshalToView() method.
	 */
	onMarshalToView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalToView();
			}
		}
		return super.onMarshalToView();
	}

	/** Toggle the slide-out filter drawer beneath the search bar. */
	toggleFilterDrawer()
	{
		this._drawerOpen = !this._drawerOpen;
		const tmpBar = document.getElementById('PRSP_FilterBar');
		if (tmpBar) { tmpBar.classList.toggle('drawer-open', this._drawerOpen); }
		return this._drawerOpen;
	}

	/**
	 * The current search term, read back from the active route URL (the source of truth) so
	 * the search box stays populated across re-renders and reflects bookmarked/filtered URLs.
	 * performSearch builds `.../FilteredTo/FBVOR~<field>~LK~<encoded %term%>~...` from the
	 * SearchFields, so the term is the first LK value in the FilteredTo segment.
	 *
	 * @return {string}
	 */
	_searchTermFromURL()
	{
		const tmpCurrent = this.pict.providers.PictRouter && this.pict.providers.PictRouter.router && this.pict.providers.PictRouter.router.current
			? this.pict.providers.PictRouter.router.current[0] : null;
		const tmpUrl = (tmpCurrent && (tmpCurrent.url || tmpCurrent.hashString)) || '';
		if (tmpUrl.indexOf('FilteredTo/') < 0) { return ''; }
		const tmpFilteredPart = (tmpUrl.split('FilteredTo/')[1] || '').split('/FilterExperience')[0];
		// A free-text search builds one `LK~%token%` clause PER token PER search field. Pull EVERY token value
		// (matching only the first truncated a multi-word search like "bridge over stream" to "bridge"), strip the
		// % wildcards, and drop the consecutive per-field repeat of each token, to rebuild the full search term.
		const tmpMatches = tmpFilteredPart.match(/LK~([^~/]+)/g);
		if (!tmpMatches) { return ''; }
		const tmpTokens = [];
		for (const tmpRawMatch of tmpMatches)
		{
			let tmpValue = tmpRawMatch.replace(/^LK~/, '');
			try { tmpValue = decodeURIComponent(tmpValue); } catch (pError) { /* leave raw */ }
			tmpValue = tmpValue.replace(/^%+|%+$/g, '');
			if (tmpValue.length > 0 && tmpValue !== tmpTokens[tmpTokens.length - 1]) { tmpTokens.push(tmpValue); }
		}
		return tmpTokens.join(' ');
	}

	/** The number of active (structured) filter clauses for a record set. */
	getActiveFilterCount(pRecordSet)
	{
		const tmpClauses = this.pict && this.pict.Bundle && this.pict.Bundle._ActiveFilterState && this.pict.Bundle._ActiveFilterState[pRecordSet]
			? this.pict.Bundle._ActiveFilterState[pRecordSet].FilterClauses : null;
		return Array.isArray(tmpClauses) ? tmpClauses.length : 0;
	}

	/**
	 * Repaint the filter-bar chrome after a (re)render: the filters icon (outline vs filled
	 * + count badge), the active-filter highlight, the persisted drawer-open state, and the
	 * search input value (so applying a search no longer clears the search box).
	 *
	 * @param {string} pRecordSet
	 */
	_paintFilterControls(pRecordSet)
	{
		const tmpBar = document.getElementById('PRSP_FilterBar');
		if (!tmpBar) { return; }
		const tmpCount = this.getActiveFilterCount(pRecordSet);
		tmpBar.classList.toggle('has-filters', tmpCount > 0);
		tmpBar.classList.toggle('drawer-open', !!this._drawerOpen);
		const tmpIcon = document.getElementById('PRSP_Filter_Icon');
		if (tmpIcon) { tmpIcon.innerHTML = (tmpCount > 0) ? ViewRecordSetSUBSETFilters.FilterIconFilled : ViewRecordSetSUBSETFilters.FilterIconOutline; }
		const tmpCountEl = document.getElementById('PRSP_Filter_Count');
		if (tmpCountEl) { tmpCountEl.textContent = (tmpCount > 0) ? String(tmpCount) : ''; }
		const tmpInput = document.getElementById('search_filter');
		if (tmpInput) { tmpInput.value = this._searchTermFromURL(); }
	}

	/**
	 * Paint the Quick Filters bar into #PRSP_QuickFilters from the record set's quick-filter definitions
	 * (host config or clever defaults), each control seeded with its clause's current value. Phase 1
	 * renders the text controls; date/entity controls follow. Empty → the bar's :empty CSS hides it.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext
	 */
	_renderQuickFilters(pRecordSet, pViewContext)
	{
		if (!document.getElementById('PRSP_QuickFilters')) { return; }
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || typeof tmpProvider.getQuickFilterDefinitions !== 'function')
		{
			this.pict.ContentAssignment.assignContent('#PRSP_QuickFilters', '');
			return;
		}
		// Build one item per definition, populating exactly one control slot (text / date / entity).
		// `quickFiltersAutoDefault` (host-settable, default on) gates the clever schema defaults: a host
		// can set it false to make quick filters opt-in (only record sets with an explicit config show).
		const tmpEntityMounts = [];
		const tmpDistinctMounts = [];
		const tmpItems = tmpProvider.getQuickFilterDefinitions(this.quickFiltersAutoDefault).map((pDefinition) =>
		{
			const tmpBase = { Field: pDefinition.Field, ClauseKey: pDefinition.ClauseKey, Label: pDefinition.Label, RecordSet: pRecordSet, ViewContext: pViewContext };
			const tmpItem = { Label: pDefinition.Label, TextSlot: [], DateSlot: [], EntitySlot: [], DistinctSlot: [] };
			if (pDefinition.Control === 'text')
			{
				tmpItem.TextSlot = [ Object.assign({}, tmpBase, { Value: tmpProvider.getQuickFilterClauseValue(pDefinition.Field), Placeholder: `Search ${pDefinition.Label}…` }) ];
			}
			else if (pDefinition.Control === 'daterange')
			{
				const tmpRange = tmpProvider.getQuickFilterDateRangeValue(pDefinition.Field);
				tmpItem.DateSlot = [ Object.assign({}, tmpBase, { StartValue: tmpRange.Start, EndValue: tmpRange.End }) ];
			}
			else if (pDefinition.Control === 'entity')
			{
				const tmpHostID = `PRSP_QuickEntity_${pRecordSet}_${pDefinition.Field}`;
				tmpItem.EntitySlot = [ Object.assign({}, tmpBase, { HostID: tmpHostID }) ];
				tmpEntityMounts.push(Object.assign({}, tmpBase, { HostID: tmpHostID }));
			}
			else if (pDefinition.Control === 'distinct')
			{
				const tmpHostID = `PRSP_QuickDistinct_${pRecordSet}_${pDefinition.Field}`;
				tmpItem.DistinctSlot = [ Object.assign({}, tmpBase, { HostID: tmpHostID }) ];
				tmpDistinctMounts.push(Object.assign({}, tmpBase, { HostID: tmpHostID }));
			}
			return tmpItem;
		});
		const tmpHTML = (tmpItems.length > 0) ? this.pict.parseTemplateByHash('PRSP-QuickFilters-Bar', { Filters: tmpItems }) : '';
		this.pict.ContentAssignment.assignContent('#PRSP_QuickFilters', tmpHTML);
		// Entity / distinct controls: mount (or re-mount) a picker into each host after the wholesale re-render.
		tmpEntityMounts.forEach((pMount) => this._mountQuickFilterEntity(pRecordSet, pViewContext, pMount));
		tmpDistinctMounts.forEach((pMount) => this._mountQuickFilterDistinct(pRecordSet, pViewContext, pMount));
	}

	/**
	 * Mount (idempotently) a pict-section-picker into a quick-filter entity host, configured from the
	 * field's entity clause descriptor (RemoteTable / search columns / value column), single-select.
	 * On change it upserts the clause + applies. Re-runs after each render (the bar repaints wholesale),
	 * mirroring the form adapter's re-mount pattern. No-op if the picker module isn't registered.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {Record<string, any>} pMount
	 */
	_mountQuickFilterEntity(pRecordSet, pViewContext, pMount)
	{
		if (!document.getElementById(pMount.HostID)) { return; }
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpPickerProvider || typeof tmpPickerProvider.createEntityPicker !== 'function' || !tmpProvider) { return; }
		const tmpDescriptor = tmpProvider.getFilterClauseSchemaForKey(pMount.Field)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pMount.ClauseKey);
		if (!tmpDescriptor || !tmpDescriptor.RemoteTable) { return; }
		const tmpSearchFields = Array.isArray(tmpDescriptor.ExternalFilterByColumns) && tmpDescriptor.ExternalFilterByColumns.length > 0 ? tmpDescriptor.ExternalFilterByColumns : [ 'Name' ];
		// ScopeToRecordSet knob: limit the picker to the values present in this recordset's data
		// (FBL~<col>~INN~<distinct>) so it doesn't list the whole remote table. Pre-fetch the
		// distinct set, then re-mount once it resolves so the first open is already scoped.
		let tmpScopeBaseFilter = undefined;
		if (tmpDescriptor.ScopeToRecordSet && tmpDescriptor.FilterByColumn && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
		{
			const tmpScopeColumn = tmpDescriptor.FilterByColumn;
			if (!tmpProvider._scopeDistinctCache || !Array.isArray(tmpProvider._scopeDistinctCache[tmpScopeColumn]))
			{
				tmpProvider.getRecordSetColumnDistinct(tmpScopeColumn, () => this._mountQuickFilterEntity(pRecordSet, pViewContext, pMount));
			}
			tmpScopeBaseFilter = () =>
			{
				const tmpVals = (tmpProvider._scopeDistinctCache || {})[tmpScopeColumn];
				return (Array.isArray(tmpVals) && tmpVals.length > 0) ? `FBL~${tmpScopeColumn}~INN~${tmpVals.join(',')}` : '';
			};
		}
		const tmpPickerConfig =
		{
			DestinationAddress: `#${pMount.HostID}`,
			// Quick filters stay single-select for a fast pick (the full drawer entity filter can be multi).
			Mode: 'single',
			Entity: tmpDescriptor.RemoteTable,
			ValueField: tmpDescriptor.JoinExternalConnectionColumn || `ID${tmpDescriptor.RemoteTable}`,
			SearchFields: tmpSearchFields,
			TextField: tmpSearchFields[0],
			// Composed, disambiguated option/chip label (e.g. "Brian Smith (brian@…)") — falls back to
			// TextField when the entity has no list-entry template.
			TextTemplate: tmpDescriptor.EntityListEntryTemplate || undefined,
			Placeholder: `Select ${pMount.Label}…`,
			// A filter's natural zero state is "Any" — the pinned clear row / inline × empty the
			// selection, OnChange(null) flows through the upsert, and the clause is removed.
			AllowClear: true,
			ClearLabel: 'Any',
			OnChange: (pValue) => this.applyQuickFilterEntity(pRecordSet, pViewContext, pMount.Field, pMount.ClauseKey, pValue),
			BaseFilter: tmpScopeBaseFilter,
		};
		// Field decoration (module policy): when this entity is opted in, the picker offers a ⚙ to pin an
		// extra column onto each row to tell same-named records apart. Resolved per entity by the
		// metacontroller; GUID / audit / value / text columns are hidden.
		if (this.pict.PictSectionRecordSet)
		{
			this.pict.PictSectionRecordSet.applyFieldDecoration(tmpPickerConfig, tmpDescriptor.RemoteTable);
		}
		const tmpView = tmpPickerProvider.createEntityPicker(`Quick-Picker-${pRecordSet}-${pMount.Field}`, tmpPickerConfig);
		if (!tmpView) { return; }
		tmpView.render();
		const tmpCurrent = (typeof tmpProvider.getQuickFilterEntityValue === 'function') ? tmpProvider.getQuickFilterEntityValue(pMount.Field) : [];
		tmpView.setValue((Array.isArray(tmpCurrent) && tmpCurrent.length > 0) ? tmpCurrent[0] : '');
	}

	/**
	 * Create any filter clauses a record set DEFAULTS to, before its first fetch runs.
	 *
	 * `DefaultRelativeDays` seeds a trailing date window, but the seed only ever ran as a
	 * side effect of `getQuickFilterDefinitions`, and the only thing that calls that is this
	 * view's own `onAfterRender` -- which happens AFTER the records have already come back.
	 * So the date landed in the input box while the grid showed everything, and the customer's
	 * "default to the last year" quietly meant "last year, once you press Apply". There is no
	 * staged-vs-applied split to respect here: the seed writes into the same
	 * `_ActiveFilterState[...].FilterClauses` array the fetch reads, so the fix is purely a
	 * matter of running it earlier.
	 *
	 * Seeding is safe to force: `_seedRelativeDateDefaults` is once-per-field, refuses to
	 * write over a bound that already has a value, and can only ever create a clause for a
	 * field that configured `DefaultRelativeDays`. Call this AFTER any URL / filter-experience
	 * hydration so a shared link still wins.
	 *
	 * The schema must resolve first -- `DefaultRelativeDays` is read off the filter schema,
	 * which is only built once the entity schema returns.
	 *
	 * @param {string} pRecordSet - The record set whose defaults should be seeded.
	 * @return {Promise<void>}
	 */
	async seedDefaultFilterClauses(pRecordSet)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || (typeof tmpProvider.getQuickFilterDefinitions !== 'function'))
		{
			return;
		}
		try
		{
			if (typeof tmpProvider.getRecordSchema === 'function')
			{
				await tmpProvider.getRecordSchema();
			}
			// Asking for the definitions performs the seed; everything else it does is a read.
			tmpProvider.getQuickFilterDefinitions(this.quickFiltersAutoDefault);
		}
		catch (pError)
		{
			// A default that cannot be resolved must never block the page from loading.
			this.pict.log.warn(`[PRSP-Filters] Could not seed default filter clauses for [${pRecordSet}]: ${pError.message}`);
		}
	}

	/**
	 * The distinct-value filter a clause should actually fetch with: its static `DistinctFilter`
	 * narrowed by the CURRENT selection of every field named in `CascadeFrom`.
	 *
	 * This is what makes one quick filter depend on another — pick a Site and the Product list
	 * collapses to the products that Site actually has. A parent with nothing picked narrows
	 * nothing, so the child lists everything, which is the right zero state for a filter.
	 *
	 * `CascadeFrom` names FIELDS, and every filter definition's key equals its `FilterByColumn`,
	 * so a field name is also the column to constrain. The returned string feeds both the fetch
	 * and the provider's distinct cache key, so each distinct parent selection caches separately
	 * and switching back to a previous Site is instant.
	 *
	 * @param {Record<string, any>} pProvider - The recordset provider (`RSP-Provider-<RecordSet>`).
	 * @param {Record<string, any>} pDescriptor - The clause descriptor.
	 * @return {string} The FoxHound filter stanza chain, or '' for no filter.
	 */
	resolveCascadedDistinctFilter(pProvider, pDescriptor)
	{
		let tmpFilter = pDescriptor.DistinctFilter || '';
		const tmpParentFields = Array.isArray(pDescriptor.CascadeFrom) ? pDescriptor.CascadeFrom : [];
		if ((tmpParentFields.length === 0) || !pProvider || (typeof pProvider.getQuickFilterEntityValue !== 'function'))
		{
			return tmpFilter;
		}
		for (const tmpParentField of tmpParentFields)
		{
			const tmpValues = pProvider.getQuickFilterEntityValue(tmpParentField);
			if (!Array.isArray(tmpValues) || (tmpValues.length === 0)) { continue; }
			// A value carrying a comma would split the IN list, so those are skipped rather
			// than silently widening the child list to the wrong set.
			const tmpUsable = tmpValues.filter((pValue) => String(pValue).indexOf(',') === -1);
			if (tmpUsable.length === 0) { continue; }
			tmpFilter += `${tmpFilter ? '~' : ''}FBL~${tmpParentField}~INN~${tmpUsable.join(',')}`;
		}
		return tmpFilter;
	}

	/**
	 * The quick-filter fields that declare `CascadeFrom` containing `pParentField`.
	 *
	 * @param {Record<string, any>} pProvider @param {string} pParentField
	 * @return {Array<Record<string, any>>} Quick-filter definitions that depend on the parent.
	 */
	resolveCascadeChildren(pProvider, pParentField)
	{
		if (!pProvider || (typeof pProvider.getQuickFilterDefinitions !== 'function')) { return []; }
		return pProvider.getQuickFilterDefinitions(this.quickFiltersAutoDefault).filter((pDefinition) =>
		{
			if (pDefinition.Control !== 'distinct') { return false; }
			const tmpDescriptor = pProvider.getFilterClauseSchemaForKey(pDefinition.Field)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pDefinition.ClauseKey);
			return !!tmpDescriptor && Array.isArray(tmpDescriptor.CascadeFrom) && tmpDescriptor.CascadeFrom.indexOf(pParentField) !== -1;
		});
	}

	/**
	 * After a parent selection changes, DROP each dependent child's staged selection and re-mount
	 * its picker against the newly narrowed option list.
	 *
	 * The selection is dropped rather than kept because a child value that the new parent does not
	 * have would otherwise stay staged and commit an unsatisfiable filter — the user picks a
	 * different Site and the grid comes back empty with no visible reason why.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pParentField
	 */
	refreshCascadeChildren(pRecordSet, pViewContext, pParentField)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider) { return; }
		for (const tmpChild of this.resolveCascadeChildren(tmpProvider, pParentField))
		{
			if (typeof tmpProvider.upsertQuickFilterEntity === 'function')
			{
				tmpProvider.upsertQuickFilterEntity(tmpChild.Field, tmpChild.ClauseKey, []);
			}
			this._mountQuickFilterDistinct(pRecordSet, pViewContext,
				{
					Field: tmpChild.Field, ClauseKey: tmpChild.ClauseKey, Label: tmpChild.Label,
					RecordSet: pRecordSet, ViewContext: pViewContext,
					HostID: `PRSP_QuickDistinct_${pRecordSet}_${tmpChild.Field}`,
				});
		}
	}

	/**
	 * Mount (idempotently) a multi-select pict-section-picker into a quick-filter distinct host,
	 * its options the clause's static `Options` or the column's distinct values (fetched + cached
	 * on the recordset provider; re-mounted once the fetch resolves so the options fill in). The
	 * picker substring-filters static options client-side, so search works without a server trip.
	 * On change it STAGES the clause (Values array) — Apply / Search commits. No-op if the picker
	 * module isn't registered.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {Record<string, any>} pMount
	 */
	_mountQuickFilterDistinct(pRecordSet, pViewContext, pMount)
	{
		if (!document.getElementById(pMount.HostID)) { return; }
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpPickerProvider || typeof tmpPickerProvider.createPicker !== 'function' || !tmpProvider) { return; }
		const tmpDescriptor = tmpProvider.getFilterClauseSchemaForKey(pMount.Field)?.AvailableClauses?.find?.((pClause) => pClause.ClauseKey === pMount.ClauseKey);
		if (!tmpDescriptor || !tmpDescriptor.FilterByColumn) { return; }
		let tmpValues;
		if (Array.isArray(tmpDescriptor.Options) && tmpDescriptor.Options.length > 0)
		{
			tmpValues = tmpDescriptor.Options;
		}
		else
		{
			// CascadeFrom narrows this list by whatever its parent filters currently hold, so the
			// filter is resolved per mount rather than read straight off the descriptor.
			const tmpDistinctFilter = this.resolveCascadedDistinctFilter(tmpProvider, tmpDescriptor);
			const tmpCacheKey = tmpDistinctFilter ? `${tmpDescriptor.FilterByColumn}::${tmpDistinctFilter}` : tmpDescriptor.FilterByColumn;
			tmpValues = (tmpProvider._scopeDistinctCache || {})[tmpCacheKey];
			if (!Array.isArray(tmpValues) && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
			{
				tmpProvider.getRecordSetColumnDistinct(tmpDescriptor.FilterByColumn, { Filter: tmpDistinctFilter },
					() => this._mountQuickFilterDistinct(pRecordSet, pViewContext, pMount));
				tmpValues = [];
			}
		}
		const tmpOptions = (Array.isArray(tmpValues) ? tmpValues : []).map((pValue) => ({ Value: pValue, Text: String(pValue) }));
		const tmpView = tmpPickerProvider.createPicker(`Quick-Distinct-${pRecordSet}-${pMount.Field}`,
		{
			DestinationAddress: `#${pMount.HostID}`,
			// Multi-select: "any of the checked values" is the natural distinct-filter semantic.
			Mode: 'multi',
			Options: tmpOptions,
			Placeholder: `Select ${pMount.Label}…`,
			OnChange: (pValuesArray) => this.applyQuickFilterDistinct(pRecordSet, pViewContext, pMount.Field, pMount.ClauseKey, pValuesArray),
		});
		if (!tmpView) { return; }
		tmpView.render();
		const tmpCurrent = (typeof tmpProvider.getQuickFilterEntityValue === 'function') ? tmpProvider.getQuickFilterEntityValue(pMount.Field) : [];
		tmpView.setValue(Array.isArray(tmpCurrent) ? tmpCurrent : []);
	}

	/**
	 * Apply a text quick filter: upsert (or clear) its tagged clause, then run the standard search +
	 * serialize path. Commits on blur / Enter (not per-keystroke) so the re-render never steals focus.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {string} pValue
	 */
	/**
	 * Flip the show-deleted switch (the drawer-footer checkbox, RecordSetListShowDeletedFilter
	 * recordsets). The switch is a REAL clause — a RawFilter referencing the Deleted column, which
	 * suppresses the automatic `Deleted = 0` so soft-deleted rows enumerate — upserted into the
	 * active filter state and applied through the normal search flow. Because the clause changes
	 * the serialized filter experience, the route URL always changes: the fetch reliably fires,
	 * and the state survives reloads and shared links. Clear/Reset drop it like any clause.
	 *
	 * @param {string} pRecordSet - The record set the toggle belongs to
	 * @param {string} pViewContext - The view context (List, Dashboard)
	 * @param {boolean} pChecked - Whether deleted records should be included
	 */
	toggleShowDeletedFilter(pRecordSet, pViewContext, pChecked)
	{
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (!tmpProvider || typeof tmpProvider.setShowDeletedFilterValue !== 'function')
		{
			return;
		}
		tmpProvider.setShowDeletedFilterValue(pChecked === true);
		this.handleSearch(null, pRecordSet, pViewContext);
	}

	/**
	 * Paint the show-deleted checkbox into its drawer-footer host (next to Clear/Reset/Apply),
	 * seeded from the clause's presence. Painted post-render like the quick bar; empty when the
	 * record set hasn't opted in via RecordSetListShowDeletedFilter.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext
	 */
	_renderShowDeletedControl(pRecordSet, pViewContext)
	{
		if (!document.getElementById('PRSP_ShowDeleted_Host')) { return; }
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet?.recordSetProviderConfigurations?.[pRecordSet] || {};
		if (tmpRecordSetConfiguration.RecordSetListShowDeletedFilter !== true)
		{
			this.pict.ContentAssignment.assignContent('#PRSP_ShowDeleted_Host', '');
			return;
		}
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		const tmpChecked = (tmpProvider && typeof tmpProvider.getShowDeletedFilterValue === 'function' && tmpProvider.getShowDeletedFilterValue()) ? 'checked' : '';
		this.pict.ContentAssignment.assignContent('#PRSP_ShowDeleted_Host',
			`<input class="prsp-filters-showdeleted-checkbox" type="checkbox" ${tmpChecked} onchange="_Pict.views['PRSP-Filters'].toggleShowDeletedFilter('${pRecordSet}', '${pViewContext}', this.checked)"> Show deleted`);
	}

	applyQuickFilterText(pRecordSet, pViewContext, pField, pClauseKey, pValue)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterClauseValue === 'function')
		{
			tmpProvider.upsertQuickFilterClauseValue(pField, pClauseKey, (pValue === undefined || pValue === null) ? '' : String(pValue).trim());
		}
		// Stage the clause into the active filter state but DON'T fetch — the
		// user explicitly clicks Apply / Search to commit. Avoids two URL fetches
		// (one stale, one not) when adjacent inputs change in quick succession
		// (e.g. the From / To dates of a DateRange both fire `change` events
		// within ~50ms — the GE-only fetch finishes after the GE+LE fetch and
		// overwrites the recordset state with stale data).
	}

	/**
	 * Stage one bound (`start`/`end`) of a field's DateRange quick-filter clause.
	 * Doesn't fire the search — that waits for the user to click Apply / Search,
	 * so the From and To inputs change once each without racing the fetch.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {'start'|'end'} pWhich @param {string} pValue
	 */
	applyQuickFilterDate(pRecordSet, pViewContext, pField, pClauseKey, pWhich, pValue)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterDateRange === 'function')
		{
			tmpProvider.upsertQuickFilterDateRange(pField, pClauseKey, pWhich, (pValue === undefined || pValue === null) ? '' : pValue);
		}
	}

	/**
	 * Stage a field's entity quick-filter selection. Doesn't fire the search —
	 * commit happens on Apply / Search.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {any} pValue
	 */
	applyQuickFilterEntity(pRecordSet, pViewContext, pField, pClauseKey, pValue)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterEntity === 'function')
		{
			tmpProvider.upsertQuickFilterEntity(pField, pClauseKey, pValue);
		}
		// An entity filter can be a cascade parent too (pick a Project, narrow the Mix Designs).
		this.refreshCascadeChildren(pRecordSet, pViewContext, pField);
	}

	/**
	 * Stage a field's distinct quick-filter selection (the Values array of its
	 * DistinctSelectedValueList clause). Doesn't fire the search — commit happens
	 * on Apply / Search.
	 *
	 * @param {string} pRecordSet @param {string} pViewContext @param {string} pField @param {string} pClauseKey @param {Array<any>} pValues
	 */
	applyQuickFilterDistinct(pRecordSet, pViewContext, pField, pClauseKey, pValues)
	{
		this.bumpRenderEpoch();
		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		if (tmpProvider && typeof tmpProvider.upsertQuickFilterEntity === 'function')
		{
			tmpProvider.upsertQuickFilterEntity(pField, pClauseKey, pValues);
		}
		// Anything declaring CascadeFrom on this field now has a different option list.
		this.refreshCascadeChildren(pRecordSet, pViewContext, pField);
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	handleSearch(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) { pEvent.preventDefault(); pEvent.stopPropagation(); } // don't submit the form
		this.newFilterSearchApplied = true;
		const tmpSearchString = this.pict.ContentAssignment.readContent(`input[name="filter"]`);
		// Remember the applied search so the re-render below doesn't blank the search box.
		this._searchString[pRecordSet] = tmpSearchString ? String(tmpSearchString) : '';
		this.performSearch(pRecordSet, pViewContext, this._searchString[pRecordSet]);
	}

	/**
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @param {string} [pFilterString] - The filter string to apply, defaults to a single space if not provided
	 */
	performSearch(pRecordSet, pViewContext, pFilterString)
	{
		this.bumpRenderEpoch();
		const tmpPictRouter = this.pict.providers.PictRouter;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRecordSet];
		let filterExpr = '';
		if (pFilterString)
		{
			/** @type {Array<string>} */
			const searchFields = tmpProviderConfiguration?.SearchFields ?? [ 'Name' ];
			// Tokenize the query on whitespace: AND one clause per token, and within each token OR across the
			// search fields inside a parenthesized group (FOP..FCP). This lets a value split across columns —
			// e.g. a person's NameFirst + NameLast — still match a multi-word query like "Derek Woods" (no single
			// column ever contains the whole phrase, so the old whole-phrase-per-field chain returned nothing).
			// Each token's OR group is self-contained by its paren, so the group is anchored (no unconstrained
			// all-FBVOR match-everything bug) AND the tokens AND cleanly with each other and any other clauses.
			const tmpSearchTokens = String(pFilterString).split(/\s+/).map((pToken) => pToken.trim()).filter((pToken) => pToken.length > 0);
			filterExpr = tmpSearchTokens.map((pToken) =>
			{
				const tmpEncoded = encodeURIComponent(`%${pToken}%`);
				if (searchFields.length === 1) { return `FBV~${searchFields[0]}~LK~${tmpEncoded}`; }
				const tmpTokenClause = searchFields.map((filterField, filterIndex) => `${filterIndex === 0 ? 'FBV' : 'FBVOR'}~${filterField}~LK~${tmpEncoded}`).join('~');
				return `FOP~0~(~0~${tmpTokenClause}~FCP~0~)~0`;
			}).join('~');
		}
		let tmpURLTemplate = tmpProviderConfiguration[`RecordSetFilterURLTemplate-${pViewContext}`] || tmpProviderConfiguration[`RecordSetFilterURLTemplate-Default`];
		if (!tmpURLTemplate)
		{
			if (pViewContext === 'Dashboard' || pViewContext === 'List')
			{
				tmpURLTemplate = `/PSRS/${pRecordSet}/${pViewContext}/FilteredTo/{~D:Record.FilterString~}`;
			}
		}
		let tmpURL;
		if (tmpURLTemplate)
		{
			tmpURL = this.pict.parseTemplate(tmpURLTemplate,
				{
					RecordSet: pRecordSet,
					FilterString: filterExpr,
				});
		}
		else
		{
			tmpURL = `/PSRS/${pRecordSet}/List/FilteredTo/${filterExpr}`;
		}
		if (tmpURL.endsWith('FilteredTo/') || tmpURL.includes('FilteredTo//'))
		{
			tmpURL = tmpURL.replace(/\/FilteredTo\//, '');
		}
		this.render(undefined, undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		this.serializeFilterExperience(this.pict.Bundle._ActiveFilterState[pRecordSet]?.FilterClauses).then((pFilterExperienceSerialized) =>
		{
			if (pFilterExperienceSerialized)
			{
				tmpURL += `/FilterExperience/${encodeURIComponent(pFilterExperienceSerialized)}`;
			}
			//FIXME: this doesn't force a re-render if other filters have changes, but aren't in the URL - so we either need to put them in the URL, or force a re-render based on the filter states
			tmpPictRouter.router.navigate(tmpURL);
			// always store the last used filter experience search, even if they don't save it
			this.pict.providers.FilterDataProvider.setLastUsedFilterExperience(null, pRecordSet, pViewContext);
		});
		// new search means this can't be out of date anymore
		this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = false;
		this.newFilterSearchApplied = false;
	}

	/**
	 * Clear all filter clauses for the given record set and view context.
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	handleClear(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.ContentAssignment.assignContent('input[name="filter"]', '');
		this._searchString[pRecordSet] = '';
		this.pict.Bundle._ActiveFilterState[pRecordSet].FilterClauses = [];
		this.pict.providers.FilterDataProvider.removeDefaultFilterExperience(pRecordSet, pViewContext);
		this.performSearch(pRecordSet, pViewContext, '');
	}

	// NOTE: Reset means to default state, Clear means to no filters at all
	/**
	 * Reset the filters to default state or fallback to to clear everything if no default exist for the given record set and view context.
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	handleReset(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.providers.FilterDataProvider.removeLastUsedFilterExperience(pRecordSet, pViewContext);
		this.pict.log.info(`Clearing filters for record set: ${pRecordSet} in view context: ${pViewContext}`);
		// Apply default filter experience if it exists, otherwise just clear
		const tmpDefaultFilterExperience = this.pict.providers.FilterDataProvider.getDefaultFilterExperience(pRecordSet, pViewContext);
		if (tmpDefaultFilterExperience)
		{
			this.pict.log.info(`Applying default filter experience for record set: ${pRecordSet} in view context: ${pViewContext}`);
			this.pict.providers.FilterDataProvider.applyExpectedFilterExperience(pRecordSet, pViewContext, tmpDefaultFilterExperience.FilterExperienceHash, false);
			this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = false;
		}
		else 
		{
			this.handleClear(pEvent, pRecordSet, pViewContext);
		}
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @returns {boolean} - Always returns false to prevent default action
	*/
	handleManage(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) pEvent.preventDefault();
		this.pict.log.info(`Managing filters for record set: ${pRecordSet} in view context: ${pViewContext}`);
		this.pict.views.FilterPersistenceView.openFilterPersistenceUI(pRecordSet, pViewContext);
		return false;
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 */
	toggleAddFilterPopover(pEvent, pRecordSet, pViewContext)
	{
		if (pEvent) { pEvent.preventDefault(); }
		if (this._addFilterOpen)
		{
			return this.closeAddFilterPopover();
		}
		this._addFilterOpen = true;
		this._addFilterRecordSet = pRecordSet;
		this._addFilterViewContext = pViewContext;
		this._addFilterSearch = '';
		this._addFilterExpandedKey = null;
		this._buildAddFilterFields(pRecordSet);
		this.render('PRSP_AddFilter_Popover', undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		this._paintAddFilterOpenState();
	}

	/** Close the add-filter popover. */
	closeAddFilterPopover()
	{
		this._addFilterOpen = false;
		this._addFilterExpandedKey = null;
		this._paintAddFilterOpenState();
	}

	/**
	 * Filter the add-filter field list by a search term, re-rendering only the list so the
	 * search input keeps focus.
	 * @param {string} pValue - The search term.
	 */
	searchAddFilter(pValue)
	{
		this._addFilterSearch = pValue || '';
		this._buildAddFilterFields(this._addFilterRecordSet);
		this.render('PRSP_AddFilter_List', undefined, { RecordSet: this._addFilterRecordSet, ViewContext: this._addFilterViewContext });
	}

	/**
	 * Expand or collapse a field's available clauses in the add-filter popover.
	 * @param {string} pFilterKey - The field whose clauses to toggle.
	 */
	toggleAddFilterField(pFilterKey)
	{
		this._addFilterExpandedKey = (this._addFilterExpandedKey === pFilterKey) ? null : pFilterKey;
		this._buildAddFilterFields(this._addFilterRecordSet);
		this.render('PRSP_AddFilter_List', undefined, { RecordSet: this._addFilterRecordSet, ViewContext: this._addFilterViewContext });
	}

	/**
	 * (Re)build the add-filter popover's field list into AppData from the record set's filter
	 * schema, honouring the current search term and the expanded field.
	 * @param {string} pRecordSet - The record set whose filter schema to read.
	 */
	_buildAddFilterFields(pRecordSet)
	{
		const tmpProvider = this.pict.providers[`RSP-Provider-${pRecordSet}`];
		const tmpSchema = (tmpProvider && typeof tmpProvider.getFilterSchema === 'function') ? tmpProvider.getFilterSchema() : {};
		const tmpRecordSetConfig = this.pict.PictSectionRecordSet?.recordSetProviderConfigurations?.[pRecordSet] || {};
		const tmpBlacklist = [].concat(this.filterFieldBlacklist || [], Array.isArray(tmpRecordSetConfig.FilterFieldBlacklist) ? tmpRecordSetConfig.FilterFieldBlacklist : []);
		const tmpSearch = (this._addFilterSearch || '').toLowerCase();
		const tmpFields = Object.values(tmpSchema)
			.filter((pField) => Array.isArray(pField.AvailableClauses) && pField.AvailableClauses.length > 0)
			.filter((pField) => !tmpBlacklist.includes(pField.FilterKey))
			.filter((pField) => !tmpSearch || String(pField.DisplayName || pField.FilterKey).toLowerCase().includes(tmpSearch))
			.sort((pA, pB) => String(pA.DisplayName || pA.FilterKey).localeCompare(String(pB.DisplayName || pB.FilterKey)))
			.map((pField) =>
			{
				const tmpExpanded = (pField.FilterKey === this._addFilterExpandedKey);
				return {
					FilterKey: pField.FilterKey,
					DisplayName: pField.DisplayName || pField.FilterKey,
					ExpandedClass: tmpExpanded ? 'is-expanded' : '',
					ClausesToShow: tmpExpanded ? pField.AvailableClauses : [],
				};
			});
		this.pict.AppData.PRSPAddFilter =
		{
			RecordSet: pRecordSet,
			ViewContext: this._addFilterViewContext,
			Search: this._addFilterSearch || '',
			IsEmpty: tmpFields.length === 0,
			Fields: tmpFields,
		};
	}

	/** Reflect the add-filter popover's open/closed state on its container element. */
	_paintAddFilterOpenState()
	{
		const tmpPopover = document.getElementById('PRSP_AddFilter_Popover');
		if (!tmpPopover) { return; }
		if (this._addFilterOpen)
		{
			this._portalAddFilterPopover(tmpPopover);
			tmpPopover.classList.add('open');
			this._positionAddFilterPopover(tmpPopover);
		}
		else
		{
			tmpPopover.classList.remove('open');
			this._restoreAddFilterPopover(tmpPopover);
		}
	}

	/**
	 * Move the add-filter popover to <body>, so no ancestor overflow:hidden can clip it, carrying the
	 * resolved theme tokens with it. Same approach as pict-section-picker's _portalPop.
	 *
	 * @param {HTMLElement} pPopover - the #PRSP_AddFilter_Popover element.
	 */
	_portalAddFilterPopover(pPopover)
	{
		this._sweepPortaledAddFilterPopover(pPopover);
		if (pPopover.parentElement === document.body) { return; }
		const tmpTrigger = document.getElementById('PRSP_Filter_Button_Add');
		const tmpComputed = (tmpTrigger && typeof window.getComputedStyle === 'function') ? window.getComputedStyle(tmpTrigger) : null;
		document.body.appendChild(pPopover);
		if (tmpComputed)
		{
			_ADD_FILTER_THEME_TOKENS.forEach((pToken) =>
			{
				const tmpValue = tmpComputed.getPropertyValue(pToken);
				if (tmpValue && tmpValue.trim() !== '') { pPopover.style.setProperty(pToken, tmpValue.trim()); }
			});
		}
	}

	/**
	 * Return a closed popover to its slot beside the trigger and drop everything the portal wrote. If a
	 * re-render already put a fresh popover in the slot, the portaled one is stale and is removed.
	 *
	 * @param {HTMLElement} pPopover - the #PRSP_AddFilter_Popover element.
	 */
	_restoreAddFilterPopover(pPopover)
	{
		if (pPopover.parentElement === document.body)
		{
			const tmpSlot = document.querySelector('.prsp-filters-add');
			if (!tmpSlot || tmpSlot.querySelector('.prsp-addfilter-pop'))
			{
				pPopover.remove();
				return;
			}
			tmpSlot.appendChild(pPopover);
		}
		pPopover.style.top = '';
		pPopover.style.left = '';
		_ADD_FILTER_THEME_TOKENS.forEach((pToken) => pPopover.style.removeProperty(pToken));
		const tmpPanel = /** @type {HTMLElement} */ (pPopover.querySelector('.prsp-addfilter-panel'));
		if (tmpPanel) { tmpPanel.style.maxHeight = ''; }
	}

	/**
	 * Remove any add-filter popover left on <body> by an earlier open, except the one to keep.
	 *
	 * @param {HTMLElement|null} pKeep - the popover to keep, or null to remove them all.
	 */
	_sweepPortaledAddFilterPopover(pKeep)
	{
		if (typeof document === 'undefined') { return; }
		document.querySelectorAll('body > [id="PRSP_AddFilter_Popover"]').forEach((pNode) =>
		{
			if (pNode !== pKeep) { pNode.remove(); }
		});
	}

	/**
	 * Place the portaled add-filter popover against its trigger in document coordinates (viewport rect
	 * plus scroll), flipping above when there's more room there. Being absolute on <body>, it then moves
	 * with the page like its trigger, so one placement per open is enough.
	 *
	 * @param {HTMLElement} pPopover - the #PRSP_AddFilter_Popover element (already display:block).
	 */
	_positionAddFilterPopover(pPopover)
	{
		const tmpTrigger = document.getElementById('PRSP_Filter_Button_Add');
		if (!tmpTrigger) { return; }
		const tmpPanel = /** @type {HTMLElement} */ (pPopover.querySelector('.prsp-addfilter-panel'));
		const tmpRect = tmpTrigger.getBoundingClientRect();
		const tmpGap = 6;
		const tmpMargin = 8;
		const tmpVH = window.innerHeight;
		const tmpVW = window.innerWidth;
		const tmpScrollX = window.scrollX || 0;
		const tmpScrollY = window.scrollY || 0;
		const tmpWidth = pPopover.offsetWidth || 300;
		pPopover.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.left, tmpVW - tmpWidth - tmpMargin)) + tmpScrollX)}px`;
		const tmpSpaceBelow = tmpVH - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		// Prefer the natural downward direction; only flip above when the room below is genuinely cramped.
		if (tmpSpaceBelow >= 220 || tmpSpaceBelow >= tmpSpaceAbove)
		{
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceBelow, 460))}px`; }
			pPopover.style.top = `${Math.round(tmpRect.bottom + tmpGap + tmpScrollY)}px`;
		}
		else
		{
			// Measured after the max-height is set; no transform, which would re-anchor the fixed backdrop.
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceAbove, 460))}px`; }
			pPopover.style.top = `${Math.round(tmpRect.top - tmpGap - pPopover.offsetHeight + tmpScrollY)}px`;
		}
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @param {string} pFilterKey - The key of the filter to add
	 * @param {string} pClauseKey - The key of the clause to add
	 */
	addFilter(pEvent, pRecordSet, pViewContext, pFilterKey, pClauseKey)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.log.info(`Adding filter: ${pFilterKey} with clause: ${pClauseKey} to record set: ${pRecordSet} in view context: ${pViewContext}`);
		this.pict.providers[`RSP-Provider-${pRecordSet}`].addFilterClause(pFilterKey, pClauseKey);
		//FIXME: we need the record from the original render here but no longer have it...
		this.render(undefined, undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		if (this.addFilterCallback) this.addFilterCallback();
	}

	/**
	 * @param {Event} pEvent - The DOM event that triggered the search
	 * @param {string} pRecordSet - The record set being filtered
	 * @param {string} pViewContext - The view context for the filter (ex. List, Dashboard)
	 * @param {string} pSpecificFilterKey - The key of the specific filter to remove
	 */
	removeFilter(pEvent, pRecordSet, pViewContext, pSpecificFilterKey)
	{
		if (pEvent) pEvent.preventDefault();
		this.bumpRenderEpoch();
		this.pict.log.info(`Removing filter: ${pSpecificFilterKey} from record set: ${pRecordSet} in view context: ${pViewContext}`);
		this.pict.providers[`RSP-Provider-${pRecordSet}`].removeFilterClause(pSpecificFilterKey);
		//FIXME: we need the record from the original render here but no longer have it...
		this.render(undefined, undefined, { RecordSet: pRecordSet, ViewContext: pViewContext });
		if (this.removeFilterCallback) this.removeFilterCallback();
	}

	/**
	 * Gets the filter schema for the given record set.
	 * @param {string} pRecordSet - The record set to get the filter schema for
	 * @return {Array<any>} - The filter schema for the given record set
	 */
	getFilterSchema(pRecordSet)
	{
		const tmpRecordsetProvider = this.pict.providers['RSP-Provider-' + pRecordSet];
		return Object.values(tmpRecordsetProvider.getFilterSchema()).flatMap((pFilter) => pFilter.AvailableClauses || []);
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered. The consolidated filter
	 * control's markup is owned by this module now, so re-assert its templates here — this
	 * neutralizes any host/server template override that previously replaced the filter UI,
	 * letting apps brand the control via CSS (theme tokens) rather than by swapping markup.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable about to be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Re-assert ONLY the consolidated-control chrome (the wrapper, search row, filter toggle +
		// Search button, the Filter Experiences container, and Clear/Reset/Apply) so the module owns
		// that markup. Deliberately NOT the add-filter dropdown or per-clause templates: host apps
		// (e.g. Headlight) layer their own styled add-filter popover and clause UI on top, and
		// re-asserting those clobbers them — re-exposing bare native <select> dropdowns and a dead
		// remove button. Those host overrides register at init and must survive each re-render.
		const tmpChromeTemplateHashes =
		[
			'PRSP-SUBSET-Filters-Template',
			'PRSP-SUBSET-Filters-Template-Input-Fieldset',
			'PRSP-SUBSET-Filters-Template-Button-Fieldset',
			'PRSP-SUBSET-Filters-Template-ManageFilters-Fieldset',
			'PRSP-SUBSET-Filters-Template-DrawerActions-Fieldset'
		];
		if (this.pict.TemplateProvider && Array.isArray(_DEFAULT_CONFIGURATION_SUBSET_Filter.Templates))
		{
			for (const tmpTemplateHash of tmpChromeTemplateHashes)
			{
				const tmpTemplate = _DEFAULT_CONFIGURATION_SUBSET_Filter.Templates.find((pTemplate) => pTemplate.Hash === tmpTemplateHash);
				if (tmpTemplate)
				{
					this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template);
				}
			}
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const res = super.onAfterRender(pRenderable);
		// Add-filter popover sub-renders (the panel + its list) only repaint that widget — skip the
		// heavy post-render pass below and just keep the open/closed class in sync.
		if (pRenderable?.RenderableHash === 'PRSP_AddFilter_Popover' || pRenderable?.RenderableHash === 'PRSP_AddFilter_List')
		{
			this._paintAddFilterOpenState();
			return res;
		}
		// Any full re-render rebuilds the add-filter slot, so the popover is closed — reset its state.
		this._addFilterOpen = false;
		this._sweepPortaledAddFilterPopover(null);
		this.onMarshalToView();

		// NOTE: This is where we ensure the filter experience is applied after a render.
		const tmpRouteUrl = this.pict.providers.PictRouter?.router?.current[0]?.url || this.pict.providers.PictRouter?.router?.current[0]?.hashString;
		const tmpRecordSet = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[0];
		const tmpViewContext = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[1];
		if (tmpRecordSet && tmpViewContext)
		{
			this.pict.providers.FilterDataProvider.applyExpectedFilterExperience(tmpRecordSet, tmpViewContext);
		}

		// Consolidated filter control: whenever the search row is in the DOM, refresh the
		// search box, the filters icon/count + drawer state, and surface the saved Filter
		// Experiences dropdown in the drawer. (Guarded on the DOM element rather than the
		// renderable hash because the list embeds this view via {~FV:~}.)
		if (document.getElementById('PRSP_Filter_Icon'))
		{
			let tmpFilterRecordSet = tmpRecordSet;
			let tmpFilterViewContext = tmpViewContext || 'List';
			if (!tmpFilterRecordSet && this.pict.Bundle && this.pict.Bundle._ActiveFilterState)
			{
				tmpFilterRecordSet = Object.keys(this.pict.Bundle._ActiveFilterState)[0];
			}
			if (tmpFilterRecordSet)
			{
				this._paintFilterControls(tmpFilterRecordSet);
				this._renderQuickFilters(tmpFilterRecordSet, tmpFilterViewContext);
				this._renderShowDeletedControl(tmpFilterRecordSet, tmpFilterViewContext);
				// (Re)render the experiences dropdown only when its container is empty — i.e. on
				// a fresh filter render — not on every sub-render (add-filter dropdown, etc.).
				const tmpExpContainer = document.getElementById('FilterPersistenceView-Container');
				if (this.pict.views.FilterPersistenceView && tmpExpContainer && !tmpExpContainer.querySelector('#FilterPersistenceView-Content'))
				{
					this.pict.views.FilterPersistenceView.initializeFilterPersistenceViewUI(tmpFilterRecordSet, tmpFilterViewContext);
				}
			}
			if (this.pict.CSSMap && typeof this.pict.CSSMap.injectCSS === 'function') { this.pict.CSSMap.injectCSS(); }
		}

		return res;
	}

	/**
	 * Encodes the filter experience to a string.
	 * @param {Record<string, any>} pExperience - The filter experience to serialize.
	 * @return {Promise<string>} - The serialized filter experience as a string.
	 */
	async serializeFilterExperience(pExperience)
	{
		if (!pExperience || typeof pExperience !== 'object')
		{
			return '';
		}
		const tmpExperience = JSON.parse(JSON.stringify(pExperience));
		for (const tmpClause of tmpExperience)
		{
			//FIXME: avoiding saving search results to the URL but this pattern isn't ideal
			delete tmpClause.SearchResults;
			delete tmpClause.SearchResultsOffset;
			delete tmpClause.LoadMoreEnabled;
		}
		return this.encode(await this.compress(JSON.stringify(tmpExperience)));
	}

	/**
	 * Decodes the filter experience from a string.
	 * @param {string} pExperience - The serialized filter experience as a string.
	 * @return {Promise<Record<string, any>>} - The serialized filter experience as a string.
	 */
	async deserializeFilterExperience(pExperience)
	{
		if (!pExperience || typeof pExperience !== 'string')
		{
			//TODO: if the default filters expand, how we wanna handle that?
			return null;
		}
		return JSON.parse(await this.decompress(new Uint8Array(this.decode(pExperience))));
	}

	/**
	 * @param {string} string - The string to compress.
	 * @param {CompressionFormat} [encoding='gzip'] - The encoding to use for compression, defaults to 'gzip'.
	 * @return {Promise<ArrayBuffer>} - The compressed byte array.
	 */
	async compress(string, encoding = 'gzip')
	{
		const byteArray = new TextEncoder().encode(string);
		const cs = new CompressionStream(encoding);
		const writer = cs.writable.getWriter();
		writer.write(byteArray);
		writer.close();
		return new Response(cs.readable).arrayBuffer();
	}

	/**
	 * @param {Uint8Array} byteArray - The byte array to decompress.
	 * @param {CompressionFormat} [encoding='gzip'] - The encoding to use for compression, defaults to 'gzip'.
	 */
	async decompress(byteArray, encoding = 'gzip')
	{
		const cs = new DecompressionStream(encoding);
		const writer = cs.writable.getWriter();
		// @ts-ignore
		writer.write(byteArray);
		writer.close();
		return new Response(cs.readable).arrayBuffer().then((arrayBuffer) =>
		{
			return new TextDecoder().decode(arrayBuffer);
		});
	}

	/**
	 * @param {ArrayBuffer} arraybuffer - The ArrayBuffer to encode to Base64.
	 * @return {string} - The Base64 encoded string.
	 */
	encode(arraybuffer)
	{
		let bytes = new Uint8Array(arraybuffer),
			i,
			len = bytes.length,
			base64 = '';

		for (i = 0; i < len; i += 3)
		{
			base64 += this.chars[bytes[i] >> 2];
			base64 += this.chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
			base64 += this.chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
			base64 += this.chars[bytes[i + 2] & 63];
		}

		if (len % 3 === 2)
		{
			base64 = base64.substring(0, base64.length - 1) + '=';
		}
		else if (len % 3 === 1)
		{
			base64 = base64.substring(0, base64.length - 2) + '==';
		}

		return base64;
	};

	/**
	 * @param {string} base64 - The Base64 encoded string to decode to an ArrayBuffer.
	 * @return {ArrayBuffer} - The decoded ArrayBuffer.
	 */
	decode(base64)
	{
		let bufferLength = base64.length * 0.75,
			len = base64.length,
			i,
			p = 0,
			encoded1,
			encoded2,
			encoded3,
			encoded4;

		if (base64[base64.length - 1] === '=')
		{
			bufferLength--;
			if (base64[base64.length - 2] === '=')
			{
				bufferLength--;
			}
		}

		const arraybuffer = new ArrayBuffer(bufferLength),
			bytes = new Uint8Array(arraybuffer);

		for (i = 0; i < len; i += 4)
		{
			encoded1 = this.lookup[base64.charCodeAt(i)];
			encoded2 = this.lookup[base64.charCodeAt(i + 1)];
			encoded3 = this.lookup[base64.charCodeAt(i + 2)];
			encoded4 = this.lookup[base64.charCodeAt(i + 3)];

			bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
			bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
			bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
		}

		return arraybuffer;
	};
}

// Funnel icons for the filters toggle — outline when no filters are set, filled when set.
// currentColor so they follow the (themeable) toggle text color.
ViewRecordSetSUBSETFilters.FilterIconOutline = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 5.5h17l-6.6 7.8v4.7l-3.8 2v-6.7z"/></svg>';
ViewRecordSetSUBSETFilters.FilterIconFilled = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.5 5.5h17l-6.6 7.8v4.7l-3.8 2v-6.7z"/></svg>';

module.exports = ViewRecordSetSUBSETFilters;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_SUBSET_Filter;


},{"./filters":1027,"pict-section-form/source/views/Pict-View-DynamicForm.js":940,"pict-view":1053}],984:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Base_View = (
{
	ViewIdentifier: 'PRSP-RecordSet-View-Base',

	DefaultRenderable: 'PRSP_Base_Recordset',
	DefaultDestinationAddress: '#PictRecordSetContainer',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
		[
			{
			Hash: 'PRSP-Base-View-Template',
			Template: /*html*/`
<!-- DefaultPackage pict view template: [PRSP-Base-View-Template] -->
<!--
	If this is being rendered, the RecordSet view has not taken control of its render function.
	While the view may not need custom templating it is strongly encouraged to still override 
	the template and put informative messaging into an HTML comment.

Record JSON:
\`\`\`json
{~DataJson:Record~}
\`\`\`
-->
<!-- DefaultPackage end view template:  [PRSP-Base-View-Template] -->
		`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Base_Recordset',
				TemplateHash: 'PRSP-Base-View-Template',
				DestinationAddress: '#PictRecordSetContainer',
				RenderMethod: 'replace'
			}
		],

	Manifests: {}
});

class viewPictSectionRecordSetViewBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_Base_View, pOptions);
		super(pFable, tmpOptions, pServiceHash);
		/** @type {import('pict') & {
		 *   log: any,
		 *   instantiateServiceProviderWithoutRegistration: (hash: String) => any,
		 *   instantiateServiceProviderIfNotExists: (hash: string) => any,
		 *   TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking'),
		 *   PictSectionRecordSet: InstanceType<import('../Pict-Section-RecordSet.js')>,
		 * }} */
		this.pict;
	}

	addRoutes(pPictRouter)
	{
		this.pict.log.trace(`View [${this.options.ViewIdentifier}]::[${this.Hash}] addRoutes called.`);
		return true;
	}

	/**
	 * Custom-view override hook. A record set can replace the built-in List / View / Edit / Create
	 * screen with an entirely custom pict view by setting `RecordSetConfiguration.RecordSetCustomViews`,
	 * e.g. `{ View: 'MyViewHash', Edit: 'MyViewHash', Create: 'MyViewHash', List: 'MyViewHash' }`.
	 *
	 * When a route for `pAction` fires and a custom view is configured (and registered), the route
	 * context is stashed at `AppData.PictRecordSetCustomView` = `{ Action, RecordSet, GUIDRecord }` and
	 * the custom view is driven: its `onRecordSetCustomView(context)` is called if present, else it is
	 * `render()`ed. Returns true when it handled the route (the caller must then return without
	 * rendering the generic screen); false to fall through to the built-in rendering.
	 *
	 * @param {string} pAction - 'List' | 'View' | 'Edit' | 'Create'
	 * @param {Record<string, any>} pProviderConfiguration
	 * @param {Record<string, any>} [pRoutePayload]
	 * @return {boolean}
	 */
	delegateToCustomView(pAction, pProviderConfiguration, pRoutePayload)
	{
		const tmpCustomViews = pProviderConfiguration && pProviderConfiguration.RecordSetCustomViews;
		const tmpViewHash = tmpCustomViews && tmpCustomViews[pAction];
		if (!tmpViewHash || !this.pict.views[tmpViewHash])
		{
			if (tmpViewHash && !this.pict.views[tmpViewHash])
			{
				this.pict.log.warn(`RecordSet [${pProviderConfiguration && pProviderConfiguration.RecordSet}] configures a custom ${pAction} view [${tmpViewHash}] but no such view is registered; falling back to the built-in screen.`);
			}
			return false;
		}
		const tmpContext =
		{
			Action: pAction,
			RecordSet: (pRoutePayload && pRoutePayload.data && pRoutePayload.data.RecordSet) || (pProviderConfiguration && pProviderConfiguration.RecordSet) || '',
			GUIDRecord: (pRoutePayload && pRoutePayload.data && pRoutePayload.data.GUIDRecord) || '',
			RoutePayload: pRoutePayload || null,
		};
		this.pict.AppData.PictRecordSetCustomView = tmpContext;
		const tmpView = this.pict.views[tmpViewHash];
		if (typeof tmpView.onRecordSetCustomView === 'function')
		{
			tmpView.onRecordSetCustomView(tmpContext);
		}
		else
		{
			tmpView.render();
		}
		return true;
	}
}

module.exports = viewPictSectionRecordSetViewBase;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_Base_View;

},{"pict-view":1053}],985:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Bulk Associate screen — a purpose-built page for reconciling one anchor's joins in a single pass
 * ("which books belong to THIS store?"). The anchor recordset (the route's `:RecordSet`) is one side of
 * the association; the user picks an anchor record, then sees a searchable, paged table of the OTHER
 * side's records with a checkbox each. The rows currently joined to the anchor are PRE-CHECKED; checking a
 * new row stages an add, unchecking a linked row stages a remove, and "Apply changes" commits both at once
 * (create the newly-checked joins, delete the newly-unchecked ones). This makes the screen reflect the
 * current associations as one editable whole rather than an add-only picker.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-Associate` and parameterized by route:
 *   /PSRS/:RecordSet/Associate/:Association
 *   /PSRS/:RecordSet/Associate/:Association/:AnchorID
 *
 * Light opt-in: a recordset advertises the screen in its nav by listing `RecordSetBulkAssociations`, but
 * the route works for any association whose side matches `:RecordSet`. Data flows through the shared
 * `RecordSetAssociationManager` (listAssociatedRecords + fetchSidePage + createJoin/removeJoin); the anchor
 * picker comes from `pict-section-picker` (soft dependency); column visibility persists through the
 * `ColumnDataProvider`. The other-side table needs no picker — a nice robustness win over the old cull-picker.
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociateBulk = (
	{
		ViewIdentifier: 'PRSP-AssociateBulk',

		DefaultRenderable: 'PRSP_Renderable_AssociateBulk',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		// The other-side page size for the reconcile table (record offset paging via "Load more").
		ReconcilePageSize: 50,

		CSS: /*css*/`
		.prsp-bulk { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-bulk-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-bulk-card { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); display: flex; flex-direction: column; gap: 0.6rem; }
		.prsp-bulk-card-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bulk-picker-host { max-width: 520px; }
		.prsp-bulk-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		.prsp-bulk-hint { color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; font-style: italic; padding: 0.5rem 0.2rem; }
		.prsp-bulk-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-bulk-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bulk-stats strong { color: var(--theme-color-brand-primary, #156dd1); font-size: 1.05rem; }
		.prsp-bulk-apply { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
			background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.prsp-bulk-apply:hover { background: var(--theme-color-brand-primary-hover, #1259ad); }
		.prsp-bulk-apply[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-bulk-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; flex-wrap: wrap; }
		.prsp-bulk-search { flex: 1 1 220px; display: flex; align-items: center; gap: 0.4rem; padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }
		.prsp-bulk-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
		.prsp-bulk-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-tools { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-bulk-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bulk-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-colchooser-wrap { position: relative; }
		.prsp-bulk-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-bulk-colchooser-wrap.is-open .prsp-bulk-colchooser-backdrop { display: block; }
		.prsp-bulk-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-bulk-colchooser-wrap.is-open .prsp-bulk-colchooser { display: block; }
		.prsp-bulk-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-bulk-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bulk-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-bulk-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-bulk-colrow.is-on .prsp-bulk-colrow-check { visibility: visible; }
		.prsp-bulk-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-bulk-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-bulk-tablewrap { max-height: 56vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-rtbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-rtbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-rtbl-th-check { width: 1.8rem; text-align: center; cursor: pointer; }
		.prsp-rtbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-rtbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-rtbl-row.is-selected { background: color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 9%, transparent); }
		.prsp-rtbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-rtbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-rtbl-check { display: inline-flex; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-rtbl-row.is-selected .prsp-rtbl-check { visibility: visible; }
		.prsp-rtbl-headcheck { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bulk-more { display: block; width: 100%; padding: 0.45rem; cursor: pointer; font: inherit; font-size: 0.85rem; border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0);
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bulk-more:hover { background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); }
		.prsp-bulk-empty { padding: 0.9rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; font-style: italic; text-align: center; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociateBulk-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociateBulk-Template] -->
		<div class="prsp-bulk">
			<div class="prsp-bulk-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-bulk-sub">{~D:Record.Subtitle~}</p>
			</div>
			<div class="prsp-bulk-card">
				<span class="prsp-bulk-card-label">{~D:Record.AnchorLabel~}</span>
				<div class="prsp-bulk-picker-host" id="{~D:Record.AnchorPickerHostID~}"></div>
				{~NE:Record.PickerMissing^<div class="prsp-bulk-note">The entity picker (pict-section-picker) is not registered, so the anchor cannot be chosen.</div>~}
			</div>
			{~TS:PRSP-AssociateBulk-Hint:Record.HintSlot~}
			{~TS:PRSP-AssociateBulk-Body:Record.BodySlot~}
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociateBulk-Template] -->
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-Hint',
				Template: /*html*/`<div class="prsp-bulk-hint">{~D:Record.Hint~}</div>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Body',
				Template: /*html*/`
		<div class="prsp-bulk-bar">
			<div class="prsp-bulk-stats" id="{~D:Record.StatsID~}"></div>
			<button type="button" class="prsp-bulk-apply" id="{~D:Record.ApplyButtonID~}" onclick="_Pict.views['RSP-RecordSet-Associate'].applyReconcile()">{~I:Check~} Apply changes</button>
		</div>
		<div class="prsp-bulk-card">
			<div class="prsp-bulk-toolbar">
				<div class="prsp-bulk-search">
					<span class="prsp-bulk-search-ic">{~I:Search~}</span>
					<input type="text" placeholder="Search {~D:Record.OtherLabel~}…" autocomplete="off" oninput="_Pict.views['RSP-RecordSet-Associate'].searchSide(this.value)">
				</div>
				<div class="prsp-bulk-tools">
					<div class="prsp-bulk-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-bulk-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleColumnChooser()">{~I:Settings~} Columns</button>
						<div class="prsp-bulk-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-Associate'].closeColumnChooser()"></div>
						<div class="prsp-bulk-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<div class="prsp-bulk-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-Table',
				Template: /*html*/`
		<table class="prsp-rtbl">
			<thead><tr><th class="prsp-rtbl-th-check" title="Select all loaded" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleSelectAll()"><span class="prsp-rtbl-headcheck">{~D:Record.SelectAllIcon~}</span></th>{~TS:PRSP-AssociateBulk-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-AssociateBulk-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-AssociateBulk-Empty:Record.EmptySlot~}
		{~TS:PRSP-AssociateBulk-More:Record.MoreSlot~}
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-rtbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleRow('{~D:Record.OtherID~}')"><td class="prsp-rtbl-td-check"><span class="prsp-rtbl-check">{~I:Check~}</span></td>{~TS:PRSP-AssociateBulk-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Empty',
				Template: /*html*/`<div class="prsp-bulk-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociateBulk-More',
				Template: /*html*/`<button type="button" class="prsp-bulk-more" onclick="_Pict.views['RSP-RecordSet-Associate'].loadMore()">Load more</button>`
			},
			{
				Hash: 'PRSP-AssociateBulk-Chooser',
				Template: /*html*/`
		<div class="prsp-bulk-colchooser-list">{~TS:PRSP-AssociateBulk-ColRow:Record.Rows~}</div>
		<div class="prsp-bulk-colchooser-foot"><button type="button" class="prsp-bulk-colreset" onclick="_Pict.views['RSP-RecordSet-Associate'].resetColumns()">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-AssociateBulk-ColRow',
				Template: /*html*/`<button type="button" class="prsp-bulk-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-Associate'].toggleColumn('{~D:Record.Key~}')"><span class="prsp-bulk-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociateBulk',
				TemplateHash: 'PRSP-AssociateBulk-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociateBulk extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociateBulk, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._anchorRecordSet = null;
		this._associationHash = null;
		this._anchorID = null;
		this._thisSide = null;
		this._otherSide = null;
		this._otherRecords = [];    // the loaded page(s) of other-side records to reconcile
		this._cursor = 0;           // record offset for paging
		this._hasMore = false;
		this._search = '';
		this._searchTimer = null;
		this._selected = {};        // String(OtherID) -> true : the CURRENT checked state, spans pages
		this._originalLinked = {};  // String(OtherID) -> joinRecord : snapshot of what was linked at load
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/** @return {number} The other-side page size for the reconcile table. */
	_pageSize()
	{
		return this.options.ReconcilePageSize || 50;
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/Associate/:Association/:AnchorID', this.handleAssociateRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Associate/:Association', this.handleAssociateRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — parse the anchor recordset, association, and optional preset anchor id, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleAssociateRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Associate route handler called with invalid route payload.`);
		}
		this._anchorRecordSet = pRoutePayload.data.RecordSet;
		this._associationHash = pRoutePayload.data.Association;
		this._anchorID = (pRoutePayload.data.AnchorID !== undefined && pRoutePayload.data.AnchorID !== '') ? pRoutePayload.data.AnchorID : null;

		// Use the recordset's RecordSetBulkAssociations Title (the opt-in label) as the screen title.
		this.options.ScreenTitle = false;
		const tmpRecordSetConfiguration = this.pict.PictSectionRecordSet
			? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this._anchorRecordSet] : null;
		const tmpBulkConfiguration = (tmpRecordSetConfiguration && Array.isArray(tmpRecordSetConfiguration.RecordSetBulkAssociations))
			? tmpRecordSetConfiguration.RecordSetBulkAssociations.find((pEntry) => pEntry.Association === this._associationHash) : null;
		if (tmpBulkConfiguration && tmpBulkConfiguration.Title)
		{
			this.options.ScreenTitle = tmpBulkConfiguration.Title;
		}

		return this.renderScreen();
	}

	/** A DOM/address-safe key for this screen's pickers + table. */
	get safeKey()
	{
		return `${String(this._anchorRecordSet)}_${String(this._associationHash)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	/** @return {string} */
	_anchorLabel() { return this._thisSide ? (this._thisSide.Title || this._thisSide.RecordSet || this._thisSide.Entity) : ''; }
	/** @return {string} */
	_otherLabel() { return this._otherSide ? (this._otherSide.Title || this._otherSide.RecordSet || this._otherSide.Entity) : ''; }

	/** Persistence scope for this association's other-side column visibility (distinct from list/matrix). */
	_columnScope() { return `Reconcile_${this._associationHash}_${this._otherSide && this._otherSide.RecordSet}`; }

	/**
	 * Load the anchor's current links (seeding the checked state + link snapshot), fetch the first page of
	 * the other side, paint the screen, and mount the anchor picker + reconcile table.
	 * @return {Promise<boolean>}
	 */
	async renderScreen()
	{
		const tmpSides = this.manager ? this.manager.resolveSides(this._associationHash, this._anchorRecordSet) : false;
		if (!tmpSides)
		{
			this.pict.log.warn(`AssociateBulk: association [${this._associationHash}] could not be resolved for [${this._anchorRecordSet}].`);
			return false;
		}
		this._thisSide = tmpSides.thisSide;
		this._otherSide = tmpSides.otherSide;
		// A fresh shell renders an empty search box, so start from an empty search term to stay in sync.
		this._search = '';

		const tmpHasAnchor = (this._anchorID !== undefined && this._anchorID !== null && this._anchorID !== '');

		// Seed the checked state + link snapshot from the anchor's current associations (ALL of them, not
		// just the first page), so a linked record on a page the user never scrolls to is still handled.
		this._selected = {};
		this._originalLinked = {};
		this._otherRecords = [];
		this._cursor = 0;
		this._hasMore = false;
		if (tmpHasAnchor)
		{
			const tmpItems = await this.manager.listAssociatedRecords(this._associationHash, this._anchorRecordSet, this._anchorID);
			for (let i = 0; i < tmpItems.length; i++)
			{
				const tmpKey = String(tmpItems[i].OtherID);
				this._originalLinked[tmpKey] = tmpItems[i].JoinRecord;
				this._selected[tmpKey] = true;
			}
			await this._fetchPage(true);
		}

		const tmpAnchorLabel = this._anchorLabel();
		const tmpOtherLabel = this._otherLabel();

		const tmpBodyData = {
			OtherLabel: tmpOtherLabel,
			StatsID: `${this.safeKey}_Stats`,
			ApplyButtonID: `${this.safeKey}_Apply`,
			ChooserID: `${this.safeKey}_Chooser`,
			TableID: `${this.safeKey}_Table`,
		};

		const tmpRecord =
		{
			Title: this.options.ScreenTitle || `Assign ${tmpOtherLabel} to a ${this._singular(tmpAnchorLabel)}`,
			Subtitle: `Pick one of the ${tmpAnchorLabel}, then check the ${tmpOtherLabel} it should be linked to. Applying adds the newly-checked and removes the unchecked.`,
			AnchorLabel: `${tmpAnchorLabel}`,
			AnchorPickerHostID: `${this.safeKey}_Anchor`,
			PickerMissing: !this.pict.providers['Pict-Section-Picker'],
			HintSlot: tmpHasAnchor ? [] : [ { Hint: `Choose one of the ${tmpAnchorLabel} above to begin.` } ],
			BodySlot: tmpHasAnchor ? [ tmpBodyData ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociateBulk: render error.`, pError);
						return resolve(false);
					}
					this._mountAnchorPicker(tmpSides, tmpRecord.AnchorPickerHostID);
					if (tmpHasAnchor)
					{
						this._renderTable();
						this.updateStats();
					}
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/**
	 * Fetch one page of the OTHER side's records (search + offset paging). Reuses fetchSidePage by passing
	 * the OTHER side's RecordSet name so it resolves that side as "this side".
	 * @param {boolean} pReset - reset the offset + replace the loaded records (vs append the next page).
	 * @return {Promise<void>}
	 */
	async _fetchPage(pReset)
	{
		if (pReset) { this._cursor = 0; }
		const tmpResult = await this.manager.fetchSidePage(this._associationHash, this._otherSide.RecordSet, this._search, this._cursor, this._pageSize());
		this._otherRecords = pReset ? tmpResult.records : this._otherRecords.concat(tmpResult.records);
		this._hasMore = tmpResult.hasMore;
	}

	/**
	 * Mount the anchor (this side) picker — single select, preselected to the current anchor.
	 * @param {Record<string, any>} pSides @param {string} pHostID
	 */
	_mountAnchorPicker(pSides, pHostID)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpPickerHash = `${this.safeKey}_AnchorPicker`;
		const tmpValueAddress = `AppData.PRSPBulkAnchor.${this.safeKey}`;

		const tmpConfig = this.manager.buildAnchorPickerConfig(this._associationHash, this._anchorRecordSet,
			{
				DestinationAddress: `#${pHostID}`,
				ValueAddress: tmpValueAddress,
				Placeholder: `Search ${pSides.thisSide.Title || pSides.thisSide.RecordSet || pSides.thisSide.Entity}…`,
				OnChange: (pValue) => { this.selectAnchor(pValue); },
			});
		if (!tmpConfig)
		{
			return;
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		// setValue (not render) so the picker (re)seeds + resolves the preset anchor's display without
		// firing OnChange (which would loop back into selectAnchor).
		this.pict.views[tmpPickerHash].setValue((this._anchorID !== undefined && this._anchorID !== null) ? this._anchorID : null);
	}

	/**
	 * The anchor picker's OnChange — switch the anchor and repaint (loads its current links + first page).
	 * @param {string|number} pAnchorID
	 * @return {Promise<void>}
	 */
	async selectAnchor(pAnchorID)
	{
		this._anchorID = (pAnchorID !== undefined && pAnchorID !== '') ? pAnchorID : null;
		await this.renderScreen();
	}

	/** Effective visibility for a column (stored override wins, else `!DefaultHidden`). */
	_isColumnVisible(pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(), 'Reconcile') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @return {Array<Record<string, any>>} The currently-visible other-side columns. */
	_visibleColumns()
	{
		return this._otherSide.TableColumns.filter((pCol) => this._isColumnVisible(pCol));
	}

	/** Build the row models for the loaded other-side records (pre-checking current links) and render the table. */
	_renderTable()
	{
		const tmpColumns = this._visibleColumns();
		const tmpIDField = this._otherSide.IDField;
		const tmpRows = this._otherRecords.map((pRecord) =>
		{
			const tmpID = pRecord[tmpIDField];
			return {
				OtherID: tmpID,
				RowID: `${this.safeKey}_row_${tmpID}`,
				Selected: !!this._selected[String(tmpID)],
				Cells: tmpColumns.map((pCol) => ({ Value: pCol.Template ? this.pict.parseTemplate(pCol.Template, pRecord) : pRecord[pCol.Key] })),
			};
		});
		const tmpAllSelected = (tmpRows.length > 0 && tmpRows.every((pRow) => pRow.Selected));
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			SelectAllIcon: this.pict.icon(tmpAllSelected ? 'Check' : 'Minus'),
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: this._search ? `No ${this._otherLabel()} match the search.` : `No ${this._otherLabel()} found.` } ] : [],
			MoreSlot: this._hasMore ? [ {} ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateBulk-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Table`, tmpHTML);
	}

	/** Debounced server-side search of the other side (resets to page 0). @param {string} pTerm */
	searchSide(pTerm)
	{
		this._search = pTerm;
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(async () =>
		{
			await this._fetchPage(true);
			this._renderTable();
		}, 250);
	}

	/** Load the next page of the other side and append it. @return {Promise<void>} */
	async loadMore()
	{
		this._cursor += this._pageSize();
		await this._fetchPage(false);
		this._renderTable();
	}

	/**
	 * Toggle a row's checked state (the row click). Updates the selection map + row class + stats.
	 * @param {string|number} pOtherID
	 */
	toggleRow(pOtherID)
	{
		const tmpKey = String(pOtherID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; }
		else { this._selected[tmpKey] = true; }
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_row_${pOtherID}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!this._selected[tmpKey]);
		}
		this.updateStats();
	}

	/**
	 * Select / clear all the LOADED rows (the header checkbox). Only affects records currently loaded — a
	 * linked record on an un-loaded page is left untouched (it stays in the selection/link maps), so this
	 * never silently unlinks something off-screen.
	 */
	toggleSelectAll()
	{
		const tmpIDField = this._otherSide.IDField;
		const tmpAllSelected = (this._otherRecords.length > 0 && this._otherRecords.every((pRecord) => this._selected[String(pRecord[tmpIDField])]));
		for (let i = 0; i < this._otherRecords.length; i++)
		{
			const tmpKey = String(this._otherRecords[i][tmpIDField]);
			if (tmpAllSelected) { delete this._selected[tmpKey]; }
			else { this._selected[tmpKey] = true; }
		}
		this._renderTable();
		this.updateStats();
	}

	/**
	 * Diff the current checked state against the link snapshot: `toCreate` are ids checked now but not
	 * originally linked; `toRemove` are the join records originally linked but now unchecked. Iterating the
	 * MAPS (not the rendered rows) is what makes an off-screen linked row a correct no-op.
	 * @return {{ toCreate: Array<string>, toRemove: Array<Record<string, any>> }}
	 */
	_computeReconcileDiff()
	{
		const tmpToCreate = [];
		const tmpToRemove = [];
		for (const tmpKey of Object.keys(this._selected))
		{
			if (this._selected[tmpKey] && !this._originalLinked[tmpKey]) { tmpToCreate.push(tmpKey); }
		}
		for (const tmpKey of Object.keys(this._originalLinked))
		{
			if (!this._selected[tmpKey]) { tmpToRemove.push(this._originalLinked[tmpKey]); }
		}
		return { toCreate: tmpToCreate, toRemove: tmpToRemove };
	}

	/** Recompute the pending-change stats line + the Apply button's enabled state. */
	updateStats()
	{
		const tmpDiff = this._computeReconcileDiff();
		const tmpAdd = tmpDiff.toCreate.length;
		const tmpRemove = tmpDiff.toRemove.length;
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`,
			`<strong>${tmpAdd}</strong> to add &middot; <strong>${tmpRemove}</strong> to remove`);
		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Apply`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = ((tmpAdd + tmpRemove) < 1);
		}
	}

	/**
	 * Apply the staged changes — create the newly-checked joins and remove the newly-unchecked ones (confirm
	 * via the host modal), then repaint (which re-seeds from the now-current links, self-healing any partial
	 * failure).
	 * @return {Promise<void>}
	 */
	async applyReconcile()
	{
		if (this._anchorID === undefined || this._anchorID === null || this._anchorID === '')
		{
			return;
		}
		const tmpDiff = this._computeReconcileDiff();
		if (tmpDiff.toCreate.length < 1 && tmpDiff.toRemove.length < 1)
		{
			this._toast('No changes to apply.', 'info');
			return;
		}

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`Add ${tmpDiff.toCreate.length} and remove ${tmpDiff.toRemove.length} ${this._otherLabel()}?`,
				{ title: 'Apply changes', confirmLabel: 'Apply', cancelLabel: 'Cancel', dangerous: (tmpDiff.toRemove.length > 0) });
			if (!tmpOk)
			{
				return;
			}
		}

		let tmpCreated = 0;
		let tmpRemoved = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpDiff.toCreate.length; i++)
		{
			try
			{
				await this.manager.createJoin(this._associationHash, this._anchorRecordSet, this._anchorID, tmpDiff.toCreate[i]);
				tmpCreated++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`AssociateBulk: failed to create join for ${tmpDiff.toCreate[i]}.`, pError);
			}
		}
		for (let i = 0; i < tmpDiff.toRemove.length; i++)
		{
			try
			{
				await this.manager.removeJoin(this._associationHash, tmpDiff.toRemove[i]);
				tmpRemoved++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`AssociateBulk: failed to remove a join.`, pError);
			}
		}
		this._toast(`Added ${tmpCreated}, removed ${tmpRemoved}${tmpFailed > 0 ? `, ${tmpFailed} failed` : ''}.`, tmpFailed > 0 ? 'error' : 'success');

		await this.renderScreen();
	}

	// --- Column chooser (mirrors the unlink/matrix screens, scoped per association's other side) ---

	/** Open/close the column chooser. */
	toggleColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1) { return; }
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser();
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close the column chooser (backdrop outside-click). */
	closeColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render the chooser rows. */
	_renderColumnChooser()
	{
		const tmpRows = this._otherSide.TableColumns.map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName, Visible: this._isColumnVisible(pCol) }));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateBulk-Chooser', { Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Chooser`, tmpHTML);
	}

	/** Toggle one column's visibility (persisted; refuses to hide the last visible column). @param {string} pKey */
	toggleColumn(pKey)
	{
		if (!this.columnProvider) { return; }
		const tmpCol = this._otherSide.TableColumns.find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol) { return; }
		const tmpVisible = this._isColumnVisible(tmpCol);
		if (tmpVisible && this._visibleColumns().length <= 1) { return; }
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(), 'Reconcile', pKey, !tmpVisible);
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Clear column overrides — back to developer defaults. */
	resetColumns()
	{
		if (this.columnProvider) { this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(), 'Reconcile'); }
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Crude singularizer ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/**
	 * Non-blocking notification via the host modal's toast, when available.
	 * @param {string} pMessage @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociateBulk;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociateBulk;

},{"pict-view":1053}],986:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Matrix Associate screen — a dual-TABLE bulk-link tool for one association. Unlike the chip-picker
 * screens, each side is a full record table with configurable columns (per-side `TableColumns`) and a
 * checkbox per row — built for connecting complex records (Materials ↔ Pay Items, with several codes
 * and data points on both sides) where a single label can't disambiguate. Multi-select rows on BOTH
 * sides; a live stats line shows the pending count; "Link selected" creates the CROSS-PRODUCT of joins
 * (every left record × every right record), skipping pairs that already exist.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-AssociateMatrix` and parameterized by route:
 *   /PSRS/AssociateMatrix/:Association                 (left = the association's SideA)
 *   /PSRS/AssociateMatrix/:Association/:LeftRecordSet  (left = the named side)
 *
 * Records + columns flow through the shared `RecordSetAssociationManager` (fetchSidePage + TableColumns).
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociateMatrix = (
	{
		ViewIdentifier: 'PRSP-AssociateMatrix',

		DefaultRenderable: 'PRSP_Renderable_AssociateMatrix',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		MatrixPageSize: 25,

		CSS: /*css*/`
		.prsp-matrix { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-matrix-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-matrix-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap; position: sticky; top: 0; z-index: 2;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-matrix-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-matrix-stats strong { color: var(--theme-color-brand-primary, #156dd1); font-size: 1.05rem; }
		.prsp-matrix-stats .prsp-matrix-eq { color: var(--theme-color-text-muted, #6b7686); margin: 0 0.15rem; }
		.prsp-matrix-link { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
			background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.prsp-matrix-link:hover { background: var(--theme-color-brand-primary-hover, #1259ad); }
		.prsp-matrix-link[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-matrix-cols { display: flex; gap: 1rem; align-items: flex-start; }
		.prsp-matrix-col { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 0.5rem;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); }
		.prsp-matrix-col-head { display: flex; align-items: baseline; justify-content: space-between; gap: 0.5rem; }
		.prsp-matrix-col-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-matrix-col-count { font-size: 0.78rem; color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
		.prsp-matrix-col-head-right { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-matrix-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-matrix-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-colchooser-wrap { position: relative; }
		/* Transparent full-viewport backdrop catches the outside click to dismiss (no document listener);
		   only present while open, with the popover stacked above it. */
		.prsp-matrix-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-matrix-colchooser-wrap.is-open .prsp-matrix-colchooser-backdrop { display: block; }
		.prsp-matrix-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-matrix-colchooser-wrap.is-open .prsp-matrix-colchooser { display: block; }
		.prsp-matrix-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-matrix-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-matrix-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-matrix-colrow.is-on .prsp-matrix-colrow-check { visibility: visible; }
		.prsp-matrix-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-matrix-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-matrix-colreset:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-matrix-search { display: flex; align-items: center; gap: 0.4rem; padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }
		.prsp-matrix-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
		.prsp-matrix-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-matrix-tablewrap { max-height: 56vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-mtbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-mtbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-mtbl-th-check { width: 1.8rem; }
		.prsp-mtbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-mtbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-mtbl-row.is-selected { background: var(--theme-color-background-selected, #e3edfb); }
		.prsp-mtbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-mtbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-mtbl-check { display: inline-flex; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-mtbl-row.is-selected .prsp-mtbl-check { visibility: visible; }
		.prsp-matrix-empty { padding: 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.88rem; font-style: italic; text-align: center; }
		.prsp-matrix-more { display: block; width: 100%; padding: 0.45rem; cursor: pointer; font: inherit; font-size: 0.85rem; border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0);
			background: transparent; color: var(--theme-color-brand-primary, #156dd1); }
		.prsp-matrix-more:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-matrix-cross { flex: 0 0 auto; display: flex; align-items: center; align-self: center; color: var(--theme-color-text-muted, #6b7686); font-size: 1.4rem; }
		.prsp-matrix-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		@media (max-width: 820px) { .prsp-matrix-cols { flex-direction: column; } .prsp-matrix-cross { align-self: center; transform: rotate(90deg); } }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociateMatrix-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociateMatrix-Template] -->
		<div class="prsp-matrix">
			<div class="prsp-matrix-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-matrix-sub">{~D:Record.Subtitle~}</p>
			</div>
			<div class="prsp-matrix-bar">
				<div class="prsp-matrix-stats" id="{~D:Record.StatsID~}">{~T:PRSP-AssociateMatrix-Stats:Record~}</div>
				<button type="button" class="prsp-matrix-link" id="{~D:Record.LinkButtonID~}" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].associateMatrix()">{~I:Plus~} Link selected</button>
			</div>
			{~NE:Record.PickerMissing^<div class="prsp-matrix-note">The entity provider is not available, so this screen cannot run.</div>~}
			<div class="prsp-matrix-cols">
				{~T:PRSP-AssociateMatrix-Panel:Record.Left~}
				<div class="prsp-matrix-cross">{~I:Plus~}</div>
				{~T:PRSP-AssociateMatrix-Panel:Record.Right~}
			</div>
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociateMatrix-Template] -->
	`
			},
			{
				// One side's panel shell: head + search (rendered once) + an empty table container the
				// table sub-render targets, so searching/paging never disturbs the search input's focus.
				Hash: 'PRSP-AssociateMatrix-Panel',
				Template: /*html*/`
		<div class="prsp-matrix-col">
			<div class="prsp-matrix-col-head">
				<span class="prsp-matrix-col-label">{~D:Record.Label~}</span>
				<div class="prsp-matrix-col-head-right">
					<span class="prsp-matrix-col-count" id="{~D:Record.CountID~}"></span>
					<div class="prsp-matrix-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-matrix-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].toggleColumnChooser('{~D:Record.Column~}')">{~I:Settings~} Columns</button>
						<div class="prsp-matrix-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].closeColumnChooser('{~D:Record.Column~}')"></div>
						<div class="prsp-matrix-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<div class="prsp-matrix-search">
				<span class="prsp-matrix-search-ic">{~I:Search~}</span>
				<input type="text" placeholder="Search {~D:Record.Label~}…" autocomplete="off" oninput="_Pict.views['RSP-RecordSet-AssociateMatrix'].searchSide('{~D:Record.Column~}', this.value)">
			</div>
			<div class="prsp-matrix-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Chooser',
				Template: /*html*/`
		<div class="prsp-matrix-colchooser-list">{~TS:PRSP-AssociateMatrix-ColRow:Record.Rows~}</div>
		<div class="prsp-matrix-colchooser-foot"><button type="button" class="prsp-matrix-colreset" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].resetColumns('{~D:Record.Column~}')">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-AssociateMatrix-ColRow',
				Template: /*html*/`<button type="button" class="prsp-matrix-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].toggleColumn('{~D:Record.Column~}','{~D:Record.Key~}')"><span class="prsp-matrix-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Table',
				Template: /*html*/`
		<table class="prsp-mtbl">
			<thead><tr><th class="prsp-mtbl-th-check"></th>{~TS:PRSP-AssociateMatrix-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-AssociateMatrix-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-AssociateMatrix-Empty:Record.EmptySlot~}
		{~TS:PRSP-AssociateMatrix-More:Record.MoreSlot~}
	`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Empty',
				Template: /*html*/`<div class="prsp-matrix-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-mtbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].toggleRow('{~D:Record.Column~}','{~D:Record.Value~}')"><td class="prsp-mtbl-td-check"><span class="prsp-mtbl-check">{~I:Check~}</span></td>{~TS:PRSP-AssociateMatrix-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-More',
				Template: /*html*/`<button type="button" class="prsp-matrix-more" onclick="_Pict.views['RSP-RecordSet-AssociateMatrix'].loadMoreSide('{~D:Record.Column~}')">Load more</button>`
			},
			{
				Hash: 'PRSP-AssociateMatrix-Stats',
				Template: /*html*/`<strong>{~D:Record.LeftCount~}</strong> {~D:Record.LeftLabel~} <span class="prsp-matrix-eq">×</span> <strong>{~D:Record.RightCount~}</strong> {~D:Record.RightLabel~} <span class="prsp-matrix-eq">=</span> <strong>{~D:Record.PairCount~}</strong> link{~D:Record.PairPlural~}`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociateMatrix',
				TemplateHash: 'PRSP-AssociateMatrix-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociateMatrix extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociateMatrix, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._associationHash = null;
		// Per-column state (Left / Right): the resolved side, loaded records, paging, search, selection.
		this._side = { Left: this._blankSide('Left'), Right: this._blankSide('Right') };
		this._searchTimers = { Left: null, Right: null };
	}

	/** @param {'Left'|'Right'} pColumn @return {Record<string, any>} A blank per-side state. */
	_blankSide(pColumn)
	{
		return { Column: pColumn, side: null, records: [], cursor: 0, hasMore: false, search: '', selected: {} };
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** A DOM/address-safe key for this screen. */
	get safeKey()
	{
		return `${String(this._associationHash)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/AssociateMatrix/:Association/:LeftRecordSet', this.handleMatrixRoute.bind(this));
		pPictRouter.router.on('/PSRS/AssociateMatrix/:Association', this.handleMatrixRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — resolve the association + which side is on the left, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleMatrixRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet AssociateMatrix route handler called with invalid route payload.`);
		}
		this._associationHash = pRoutePayload.data.Association;
		this._side = { Left: this._blankSide('Left'), Right: this._blankSide('Right') };
		const tmpAssociation = this.manager ? this.manager.getAssociation(this._associationHash) : null;
		if (!tmpAssociation)
		{
			this.pict.log.warn(`AssociateMatrix: association [${this._associationHash}] is not registered.`);
			return this.renderMatrix();
		}
		// Left side: the named :LeftRecordSet, else the association's SideA. The other side goes right.
		const tmpLeftRecordSet = pRoutePayload.data.LeftRecordSet || tmpAssociation.SideA.RecordSet;
		const tmpSides = this.manager.resolveSides(this._associationHash, tmpLeftRecordSet);
		this._side.Left.side = tmpSides ? tmpSides.thisSide : tmpAssociation.SideA;
		this._side.Right.side = tmpSides ? tmpSides.otherSide : tmpAssociation.SideB;
		return this.renderMatrix();
	}

	/**
	 * Paint the screen shell, then fetch + render both tables.
	 * @return {Promise<boolean>}
	 */
	renderMatrix()
	{
		if (!this._side.Left.side || !this._side.Right.side)
		{
			this.pict.log.warn(`AssociateMatrix: could not resolve sides for [${this._associationHash}].`);
			return Promise.resolve(false);
		}
		const tmpLeftLabel = this._sideLabel('Left');
		const tmpRightLabel = this._sideLabel('Right');

		const tmpRecord =
		{
			Title: this.options.ScreenTitle || `Bulk-link ${tmpLeftLabel} & ${tmpRightLabel}`,
			Subtitle: `Check ${tmpLeftLabel} on the left and ${tmpRightLabel} on the right, then link every selected ${this._singular(tmpLeftLabel)} to every selected ${this._singular(tmpRightLabel)}.`,
			StatsID: `${this.safeKey}_Stats`,
			LinkButtonID: `${this.safeKey}_Link`,
			PickerMissing: !this.pict.EntityProvider,
			Left: this._panelRecord('Left'),
			Right: this._panelRecord('Right'),
			// Initial stats (zero selected).
			LeftCount: 0, RightCount: 0, PairCount: 0, PairPlural: 's', LeftLabel: tmpLeftLabel, RightLabel: tmpRightLabel,
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociateMatrix: render error.`, pError);
						return resolve(false);
					}
					this.pict.CSSMap.injectCSS();
					this.updateStats();
					Promise.all([ this._fetchSide('Left'), this._fetchSide('Right') ]).then(() => resolve(true));
				});
		});
	}

	/** @param {'Left'|'Right'} pColumn @return {Record<string, any>} The panel shell record. */
	_panelRecord(pColumn)
	{
		return {
			Column: pColumn,
			Label: this._sideLabel(pColumn),
			CountID: `${this.safeKey}_${pColumn}_Count`,
			TableID: `${this.safeKey}_${pColumn}_Table`,
			ChooserID: `${this.safeKey}_${pColumn}_Chooser`,
		};
	}

	/** The ColumnDataProvider persistence scope for a side (distinct from the List view's per-entity scope). */
	_columnScope(pColumn)
	{
		return `Matrix_${this._associationHash}_${pColumn}`;
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/**
	 * Effective visibility for a column: a stored user override wins, else the developer default
	 * (visible unless `DefaultHidden`).
	 * @param {'Left'|'Right'} pColumn @param {Record<string, any>} pCol
	 * @return {boolean}
	 */
	_isColumnVisible(pColumn, pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(pColumn), 'Matrix') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @param {'Left'|'Right'} pColumn @return {Array<Record<string, any>>} The currently-visible columns. */
	_visibleColumns(pColumn)
	{
		return this._side[pColumn].side.TableColumns.filter((pCol) => this._isColumnVisible(pColumn, pCol));
	}

	/** @param {'Left'|'Right'} pColumn @return {string} */
	_sideLabel(pColumn)
	{
		const tmpSide = this._side[pColumn].side;
		return tmpSide ? (tmpSide.Title || tmpSide.RecordSet || tmpSide.Entity) : '';
	}

	/**
	 * Fetch page 0 for a side (fresh search / first load), store the records, and render its table.
	 * @param {'Left'|'Right'} pColumn @return {Promise<void>}
	 */
	async _fetchSide(pColumn)
	{
		const tmpState = this._side[pColumn];
		tmpState.cursor = 0;
		const tmpResult = await this.manager.fetchSidePage(this._associationHash, tmpState.side.RecordSet, tmpState.search, 0, this.options.MatrixPageSize);
		tmpState.records = tmpResult.records;
		tmpState.hasMore = tmpResult.hasMore;
		this._renderSideTable(pColumn);
	}

	/**
	 * Fetch + append the next page for a side ("Load more").
	 * @param {'Left'|'Right'} pColumn @return {Promise<void>}
	 */
	async loadMoreSide(pColumn)
	{
		const tmpState = this._side[pColumn];
		tmpState.cursor += this.options.MatrixPageSize;
		const tmpResult = await this.manager.fetchSidePage(this._associationHash, tmpState.side.RecordSet, tmpState.search, tmpState.cursor, this.options.MatrixPageSize);
		tmpState.records = tmpState.records.concat(tmpResult.records);
		tmpState.hasMore = tmpResult.hasMore;
		this._renderSideTable(pColumn);
	}

	/**
	 * Debounced search for a side — re-fetches page 0. Only the table container repaints, so the search
	 * input keeps focus.
	 * @param {'Left'|'Right'} pColumn @param {string} pTerm
	 */
	searchSide(pColumn, pTerm)
	{
		this._side[pColumn].search = pTerm;
		if (this._searchTimers[pColumn])
		{
			clearTimeout(this._searchTimers[pColumn]);
		}
		this._searchTimers[pColumn] = setTimeout(() => { this._fetchSide(pColumn); }, 250);
	}

	/**
	 * Build the row models for a side and render its table into the panel's table container.
	 * @param {'Left'|'Right'} pColumn
	 */
	_renderSideTable(pColumn)
	{
		const tmpState = this._side[pColumn];
		const tmpColumns = this._visibleColumns(pColumn);
		const tmpIDField = tmpState.side.IDField;
		const tmpRows = tmpState.records.map((pRecord) =>
		{
			const tmpID = pRecord[tmpIDField];
			return {
				Column: pColumn,
				Value: tmpID,
				RowID: `${this.safeKey}_${pColumn}_row_${tmpID}`,
				Selected: !!tmpState.selected[String(tmpID)],
				Cells: tmpColumns.map((pCol) => ({ Value: pCol.Template ? this.pict.parseTemplate(pCol.Template, pRecord) : pRecord[pCol.Key] })),
			};
		});
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			// One-or-zero-element slot drives the empty-state line (TS parses inner tags; NE would not).
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: `No ${this._sideLabel(pColumn)} found.` } ] : [],
			MoreSlot: tmpState.hasMore ? [ { Column: pColumn } ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateMatrix-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Table`, tmpHTML);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Count`, this._selectedCount(pColumn) ? `${this._selectedCount(pColumn)} selected` : '');
	}

	/**
	 * Open/close a side's column chooser popover (the "Columns" button). Re-renders its rows on open.
	 * @param {'Left'|'Right'} pColumn
	 */
	toggleColumnChooser(pColumn)
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_${pColumn}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1)
		{
			return;
		}
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser(pColumn);
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close a side's column chooser (the backdrop's outside-click handler). @param {'Left'|'Right'} pColumn */
	closeColumnChooser(pColumn)
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_${pColumn}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render a side's column-chooser rows (every declared column, checked when effectively visible). */
	_renderColumnChooser(pColumn)
	{
		const tmpRows = this._side[pColumn].side.TableColumns.map((pCol) => (
			{
				Column: pColumn,
				Key: pCol.Key,
				DisplayName: pCol.DisplayName,
				Visible: this._isColumnVisible(pColumn, pCol),
			}));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateMatrix-Chooser', { Column: pColumn, Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Chooser`, tmpHTML);
	}

	/**
	 * Toggle one column's visibility — persisted through the ColumnDataProvider (localStorage; a host can
	 * register its own provider for server-side prefs). Refuses to hide the last visible column.
	 * @param {'Left'|'Right'} pColumn @param {string} pKey
	 */
	toggleColumn(pColumn, pKey)
	{
		if (!this.columnProvider)
		{
			return;
		}
		const tmpCol = this._side[pColumn].side.TableColumns.find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol)
		{
			return;
		}
		const tmpCurrentlyVisible = this._isColumnVisible(pColumn, tmpCol);
		if (tmpCurrentlyVisible && this._visibleColumns(pColumn).length <= 1)
		{
			return;
		}
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(pColumn), 'Matrix', pKey, !tmpCurrentlyVisible);
		this._renderSideTable(pColumn);
		this._renderColumnChooser(pColumn);
	}

	/** Clear a side's column overrides — back to the developer defaults. */
	resetColumns(pColumn)
	{
		if (this.columnProvider)
		{
			this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(pColumn), 'Matrix');
		}
		this._renderSideTable(pColumn);
		this._renderColumnChooser(pColumn);
	}

	/**
	 * Toggle a row's selection (the row click). Updates the selection set + the row's visual state + the
	 * stats, without re-rendering the whole table (so scroll + focus are preserved).
	 * @param {'Left'|'Right'} pColumn @param {string|number} pValue
	 */
	toggleRow(pColumn, pValue)
	{
		const tmpState = this._side[pColumn];
		const tmpKey = String(pValue);
		if (tmpState.selected[tmpKey])
		{
			delete tmpState.selected[tmpKey];
		}
		else
		{
			tmpState.selected[tmpKey] = true;
		}
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_${pColumn}_row_${pValue}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!tmpState.selected[tmpKey]);
		}
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_${pColumn}_Count`, this._selectedCount(pColumn) ? `${this._selectedCount(pColumn)} selected` : '');
		this.updateStats();
	}

	/** @param {'Left'|'Right'} pColumn @return {number} */
	_selectedCount(pColumn)
	{
		return Object.keys(this._side[pColumn].selected).length;
	}

	/** Recompute the live stats line + the link button's enabled state. */
	updateStats()
	{
		const tmpLeft = this._selectedCount('Left');
		const tmpRight = this._selectedCount('Right');
		const tmpPairs = tmpLeft * tmpRight;
		const tmpStatsHTML = this.pict.parseTemplateByHash('PRSP-AssociateMatrix-Stats',
			{ LeftCount: tmpLeft, RightCount: tmpRight, PairCount: tmpPairs, PairPlural: (tmpPairs === 1) ? '' : 's', LeftLabel: this._sideLabel('Left'), RightLabel: this._sideLabel('Right') });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`, tmpStatsHTML);

		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Link`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = (tmpPairs < 1);
		}
	}

	/**
	 * Create the cross-product of joins for the checked rows — every left record linked to every right
	 * record — skipping pairs that already exist (one INN lookup). Confirms first for large sets.
	 * @return {Promise<void>}
	 */
	async associateMatrix()
	{
		const tmpLeftIDs = Object.keys(this._side.Left.selected);
		const tmpRightIDs = Object.keys(this._side.Right.selected);
		if (tmpLeftIDs.length < 1 || tmpRightIDs.length < 1)
		{
			this._toast('Check records on both sides first.', 'info');
			return;
		}
		const tmpTotal = tmpLeftIDs.length * tmpRightIDs.length;
		const tmpLeftSide = this._side.Left.side;
		const tmpRightSide = this._side.Right.side;

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpTotal > 100 && tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`This will create up to ${tmpTotal} links. Continue?`,
				{ title: 'Bulk link', confirmLabel: `Link ${tmpTotal}`, cancelLabel: 'Cancel' });
			if (!tmpOk)
			{
				return;
			}
		}

		// Existing pairs (one INN lookup over the checked left ids) so we never duplicate a join.
		const tmpExisting = await this.manager.listJoinRecordsForIDs(this._associationHash, tmpLeftSide.RecordSet, tmpLeftIDs);
		const tmpExistingSet = {};
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExistingSet[`${tmpExisting[i][tmpLeftSide.IDField]}|${tmpExisting[i][tmpRightSide.IDField]}`] = true;
		}

		let tmpCreated = 0;
		let tmpSkipped = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpLeftIDs.length; i++)
		{
			for (let j = 0; j < tmpRightIDs.length; j++)
			{
				if (tmpExistingSet[`${tmpLeftIDs[i]}|${tmpRightIDs[j]}`])
				{
					tmpSkipped++;
					continue;
				}
				try
				{
					await this.manager.createJoin(this._associationHash, tmpLeftSide.RecordSet, tmpLeftIDs[i], tmpRightIDs[j]);
					tmpCreated++;
				}
				catch (pError)
				{
					tmpFailed++;
					this.pict.log.error(`AssociateMatrix: failed to link ${tmpLeftIDs[i]} <-> ${tmpRightIDs[j]}.`, pError);
				}
			}
		}

		const tmpParts = [];
		if (tmpCreated > 0) { tmpParts.push(`${tmpCreated} link${tmpCreated === 1 ? '' : 's'} created`); }
		if (tmpSkipped > 0) { tmpParts.push(`${tmpSkipped} already existed`); }
		if (tmpFailed > 0) { tmpParts.push(`${tmpFailed} failed`); }
		this._toast(tmpParts.length ? tmpParts.join(', ') + '.' : 'Nothing to link.', tmpFailed > 0 ? 'error' : 'success');

		// Clear both selections and repaint the tables so the next batch starts clean.
		this._side.Left.selected = {};
		this._side.Right.selected = {};
		this._renderSideTable('Left');
		this._renderSideTable('Right');
		this.updateStats();
	}

	/** Crude singularizer for the subtitle copy ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/**
	 * Non-blocking notification via the host modal's toast, when available.
	 * @param {string} pMessage @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociateMatrix;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociateMatrix;

},{"pict-view":1053}],987:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Bulk Unlink screen — the removal counterpart to Assign/Matrix. Pick one anchor record (a specific
 * book OR a specific store), see ALL of its current associations in a selectable record table
 * (configurable columns + a column chooser + search), check the ones to drop, and "Unlink selected"
 * deletes those join rows at once. The anchor side is the route's `:AnchorRecordSet`, so the same screen
 * unlinks from either side.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-AssociateUnlink` and parameterized by route:
 *   /PSRS/AssociateUnlink/:Association/:AnchorRecordSet
 *   /PSRS/AssociateUnlink/:Association/:AnchorRecordSet/:AnchorID
 *
 * Data flows through the shared `RecordSetAssociationManager` (listAssociatedRecords + removeJoin);
 * column visibility persists through the `ColumnDataProvider` (the same host-overridable seam).
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociateUnlink = (
	{
		ViewIdentifier: 'PRSP-AssociateUnlink',

		DefaultRenderable: 'PRSP_Renderable_AssociateUnlink',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
		.prsp-unlink { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-unlink-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-unlink-card { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); display: flex; flex-direction: column; gap: 0.6rem; }
		.prsp-unlink-card-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-unlink-anchor-host { max-width: 520px; }
		.prsp-unlink-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-unlink-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-unlink-stats strong { color: var(--theme-color-status-error, #b62828); font-size: 1.05rem; }
		.prsp-unlink-btn { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-status-error, #b62828);
			background: var(--theme-color-status-error, #b62828); color: #fff; }
		.prsp-unlink-btn:hover { background: var(--theme-color-status-error-hover, #9c2020); }
		.prsp-unlink-btn[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-unlink-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; flex-wrap: wrap; }
		.prsp-unlink-search { flex: 1 1 220px; display: flex; align-items: center; gap: 0.4rem; padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }
		.prsp-unlink-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
		.prsp-unlink-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-tools { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-unlink-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-unlink-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-colchooser-wrap { position: relative; }
		.prsp-unlink-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-unlink-colchooser-wrap.is-open .prsp-unlink-colchooser-backdrop { display: block; }
		.prsp-unlink-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-unlink-colchooser-wrap.is-open .prsp-unlink-colchooser { display: block; }
		.prsp-unlink-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-unlink-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-unlink-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-unlink-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-unlink-colrow.is-on .prsp-unlink-colrow-check { visibility: visible; }
		.prsp-unlink-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-unlink-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-unlink-tablewrap { max-height: 56vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-utbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-utbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-utbl-th-check { width: 1.8rem; text-align: center; cursor: pointer; }
		.prsp-utbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-utbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-utbl-row.is-selected { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 9%, transparent); }
		.prsp-utbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-utbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-utbl-check { display: inline-flex; color: var(--theme-color-status-error, #b62828); visibility: hidden; }
		.prsp-utbl-row.is-selected .prsp-utbl-check { visibility: visible; }
		.prsp-utbl-headcheck { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-unlink-empty { padding: 0.9rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; font-style: italic; text-align: center; }
		.prsp-unlink-hint { color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; font-style: italic; padding: 0.5rem 0.2rem; }
		.prsp-unlink-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociateUnlink-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociateUnlink-Template] -->
		<div class="prsp-unlink">
			<div class="prsp-unlink-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-unlink-sub">{~D:Record.Subtitle~}</p>
			</div>
			<div class="prsp-unlink-card">
				<span class="prsp-unlink-card-label">{~D:Record.AnchorLabel~}</span>
				<div class="prsp-unlink-anchor-host" id="{~D:Record.AnchorPickerHostID~}"></div>
				{~NE:Record.PickerMissing^<div class="prsp-unlink-note">The entity picker (pict-section-picker) is not registered, so this screen cannot run.</div>~}
			</div>
			{~TS:PRSP-AssociateUnlink-Hint:Record.HintSlot~}
			{~TS:PRSP-AssociateUnlink-Body:Record.BodySlot~}
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociateUnlink-Template] -->
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Hint',
				Template: /*html*/`<div class="prsp-unlink-hint">{~D:Record.Hint~}</div>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Body',
				Template: /*html*/`
		<div class="prsp-unlink-bar">
			<div class="prsp-unlink-stats" id="{~D:Record.StatsID~}"></div>
			<button type="button" class="prsp-unlink-btn" id="{~D:Record.UnlinkButtonID~}" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].unlinkSelected()">{~I:Trash~} Unlink selected</button>
		</div>
		<div class="prsp-unlink-card">
			<div class="prsp-unlink-toolbar">
				<div class="prsp-unlink-search">
					<span class="prsp-unlink-search-ic">{~I:Search~}</span>
					<input type="text" placeholder="Filter {~D:Record.OtherLabel~}…" autocomplete="off" oninput="_Pict.views['RSP-RecordSet-AssociateUnlink'].searchItems(this.value)">
				</div>
				<div class="prsp-unlink-tools">
					<div class="prsp-unlink-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-unlink-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleColumnChooser()">{~I:Settings~} Columns</button>
						<div class="prsp-unlink-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].closeColumnChooser()"></div>
						<div class="prsp-unlink-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<div class="prsp-unlink-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Table',
				Template: /*html*/`
		<table class="prsp-utbl">
			<thead><tr><th class="prsp-utbl-th-check" title="Select all" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleSelectAll()"><span class="prsp-utbl-headcheck">{~D:Record.SelectAllIcon~}</span></th>{~TS:PRSP-AssociateUnlink-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-AssociateUnlink-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-AssociateUnlink-Empty:Record.EmptySlot~}
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-utbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleRow('{~D:Record.JoinID~}')"><td class="prsp-utbl-td-check"><span class="prsp-utbl-check">{~I:Check~}</span></td>{~TS:PRSP-AssociateUnlink-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Empty',
				Template: /*html*/`<div class="prsp-unlink-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociateUnlink-Chooser',
				Template: /*html*/`
		<div class="prsp-unlink-colchooser-list">{~TS:PRSP-AssociateUnlink-ColRow:Record.Rows~}</div>
		<div class="prsp-unlink-colchooser-foot"><button type="button" class="prsp-unlink-colreset" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].resetColumns()">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-AssociateUnlink-ColRow',
				Template: /*html*/`<button type="button" class="prsp-unlink-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-AssociateUnlink'].toggleColumn('{~D:Record.Key~}')"><span class="prsp-unlink-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociateUnlink',
				TemplateHash: 'PRSP-AssociateUnlink-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociateUnlink extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociateUnlink, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._associationHash = null;
		this._anchorSide = null;
		this._otherSide = null;
		this._anchorID = null;
		this._items = [];           // current associations: { JoinID, OtherID, Display, OtherRecord, JoinRecord, Chips }
		this._selected = {};        // selected JoinIDs to remove
		this._search = '';
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/** A DOM/address-safe key for this screen. */
	get safeKey()
	{
		return `${String(this._associationHash)}_${String(this._anchorSide && this._anchorSide.RecordSet)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/AssociateUnlink/:Association/:AnchorRecordSet/:AnchorID', this.handleUnlinkRoute.bind(this));
		pPictRouter.router.on('/PSRS/AssociateUnlink/:Association/:AnchorRecordSet', this.handleUnlinkRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — resolve the association + anchor side, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleUnlinkRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet AssociateUnlink route handler called with invalid route payload.`);
		}
		this._associationHash = pRoutePayload.data.Association;
		this._items = [];
		this._selected = {};
		this._search = '';
		const tmpAssociation = this.manager ? this.manager.getAssociation(this._associationHash) : null;
		if (!tmpAssociation)
		{
			this.pict.log.warn(`AssociateUnlink: association [${this._associationHash}] is not registered.`);
			this._anchorSide = null;
			this._otherSide = null;
			return this.renderUnlink();
		}
		const tmpAnchorRecordSet = pRoutePayload.data.AnchorRecordSet || tmpAssociation.SideA.RecordSet;
		const tmpSides = this.manager.resolveSides(this._associationHash, tmpAnchorRecordSet);
		this._anchorSide = tmpSides ? tmpSides.thisSide : tmpAssociation.SideA;
		this._otherSide = tmpSides ? tmpSides.otherSide : tmpAssociation.SideB;
		this._anchorID = (pRoutePayload.data.AnchorID !== undefined && pRoutePayload.data.AnchorID !== '') ? pRoutePayload.data.AnchorID : null;
		return this.renderUnlink();
	}

	/** @return {string} */
	_anchorLabel() { return this._anchorSide ? (this._anchorSide.Title || this._anchorSide.RecordSet || this._anchorSide.Entity) : ''; }
	/** @return {string} */
	_otherLabel() { return this._otherSide ? (this._otherSide.Title || this._otherSide.RecordSet || this._otherSide.Entity) : ''; }

	/** Persistence scope for this anchor side's column visibility (distinct from list/matrix scopes). */
	_columnScope() { return `Unlink_${this._associationHash}_${this._anchorSide && this._anchorSide.RecordSet}`; }

	/**
	 * Paint the screen shell and mount the anchor picker; load + render the table when an anchor is set.
	 * @return {Promise<boolean>}
	 */
	async renderUnlink()
	{
		if (!this._anchorSide || !this._otherSide)
		{
			this.pict.log.warn(`AssociateUnlink: could not resolve sides for [${this._associationHash}].`);
			return false;
		}
		const tmpHasAnchor = (this._anchorID !== undefined && this._anchorID !== null && this._anchorID !== '');
		if (tmpHasAnchor)
		{
			this._items = await this.manager.listAssociatedRecords(this._associationHash, this._anchorSide.RecordSet, this._anchorID);
		}

		const tmpBodyData = {
			OtherLabel: this._otherLabel(),
			StatsID: `${this.safeKey}_Stats`,
			UnlinkButtonID: `${this.safeKey}_Unlink`,
			ChooserID: `${this.safeKey}_Chooser`,
			TableID: `${this.safeKey}_Table`,
		};
		const tmpRecord = {
			Title: this.options.ScreenTitle || `Unlink ${this._otherLabel()} from a ${this._singular(this._anchorLabel())}`,
			Subtitle: `Pick a ${this._singular(this._anchorLabel())}, then check the ${this._otherLabel()} to unlink and remove them together.`,
			AnchorLabel: this._anchorLabel(),
			AnchorPickerHostID: `${this.safeKey}_Anchor`,
			PickerMissing: !this.pict.providers['Pict-Section-Picker'],
			HintSlot: tmpHasAnchor ? [] : [ { Hint: `Select a ${this._singular(this._anchorLabel())} above to see its current links.` } ],
			BodySlot: tmpHasAnchor ? [ tmpBodyData ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociateUnlink: render error.`, pError);
						return resolve(false);
					}
					this._mountAnchorPicker(tmpRecord.AnchorPickerHostID);
					if (tmpHasAnchor)
					{
						this._renderTable();
						this.updateStats();
					}
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/** Mount the anchor (this side) picker — single select, preselected to the current anchor. */
	_mountAnchorPicker(pHostID)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpPickerHash = `${this.safeKey}_AnchorPicker`;
		const tmpValueAddress = `AppData.PRSPUnlinkAnchor.${this.safeKey}`;
		if (!this.pict.AppData.PRSPUnlinkAnchor) { this.pict.AppData.PRSPUnlinkAnchor = {}; }
		this.pict.AppData.PRSPUnlinkAnchor[this.safeKey] = (this._anchorID !== undefined && this._anchorID !== null) ? this._anchorID : null;

		const tmpConfig = this.manager.buildAnchorPickerConfig(this._associationHash, this._anchorSide.RecordSet,
			{
				DestinationAddress: `#${pHostID}`,
				ValueAddress: tmpValueAddress,
				Placeholder: `Search ${this._anchorLabel()}…`,
				OnChange: (pValue) => { this.selectAnchor(pValue); },
			});
		if (!tmpConfig)
		{
			return;
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		this.pict.views[tmpPickerHash].setValue((this._anchorID !== undefined && this._anchorID !== null) ? this._anchorID : null);
	}

	/**
	 * The anchor picker's OnChange — load that anchor's links and repaint.
	 * @param {string|number} pAnchorID @return {Promise<void>}
	 */
	async selectAnchor(pAnchorID)
	{
		this._anchorID = (pAnchorID !== undefined && pAnchorID !== '') ? pAnchorID : null;
		this._selected = {};
		this._search = '';
		await this.renderUnlink();
	}

	/** Effective visibility for a column (stored override wins, else `!DefaultHidden`). */
	_isColumnVisible(pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(), 'Unlink') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @return {Array<Record<string, any>>} The currently-visible other-side columns. */
	_visibleColumns()
	{
		return this._otherSide.TableColumns.filter((pCol) => this._isColumnVisible(pCol));
	}

	/** @return {Array<Record<string, any>>} The items matching the current search filter (client-side). */
	_filteredItems()
	{
		const tmpTerm = (this._search || '').trim().toLowerCase();
		if (!tmpTerm)
		{
			return this._items;
		}
		const tmpColumns = this._visibleColumns();
		return this._items.filter((pItem) =>
		{
			if (String(pItem.Display).toLowerCase().includes(tmpTerm)) { return true; }
			return tmpColumns.some((pCol) =>
			{
				const tmpValue = pCol.Template ? this.pict.parseTemplate(pCol.Template, pItem.OtherRecord) : pItem.OtherRecord[pCol.Key];
				return (tmpValue !== undefined && tmpValue !== null) && String(tmpValue).toLowerCase().includes(tmpTerm);
			});
		});
	}

	/** Build the row models for the (filtered) current associations and render the table. */
	_renderTable()
	{
		const tmpColumns = this._visibleColumns();
		const tmpItems = this._filteredItems();
		const tmpRows = tmpItems.map((pItem) => (
			{
				JoinID: pItem.JoinID,
				RowID: `${this.safeKey}_row_${pItem.JoinID}`,
				Selected: !!this._selected[String(pItem.JoinID)],
				Cells: tmpColumns.map((pCol) => ({ Value: pCol.Template ? this.pict.parseTemplate(pCol.Template, pItem.OtherRecord) : pItem.OtherRecord[pCol.Key] })),
			}));
		const tmpAllSelected = (tmpRows.length > 0 && tmpRows.every((pRow) => pRow.Selected));
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			SelectAllIcon: this.pict.icon(tmpAllSelected ? 'Check' : 'Minus'),
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: this._search ? `No ${this._otherLabel()} match the filter.` : `This ${this._singular(this._anchorLabel())} has no ${this._otherLabel()} linked.` } ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateUnlink-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Table`, tmpHTML);
	}

	/** Debounced client-side filter of the loaded links. @param {string} pTerm */
	searchItems(pTerm)
	{
		this._search = pTerm;
		this._renderTable();
		this.updateStats();
	}

	/**
	 * Toggle a link's selection (the row click). Updates the set + row state + stats.
	 * @param {string|number} pJoinID
	 */
	toggleRow(pJoinID)
	{
		const tmpKey = String(pJoinID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; }
		else { this._selected[tmpKey] = true; }
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_row_${pJoinID}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!this._selected[tmpKey]);
		}
		this.updateStats();
	}

	/** Select-all / clear-all the currently-filtered rows (the header checkbox). */
	toggleSelectAll()
	{
		const tmpFiltered = this._filteredItems();
		const tmpAllSelected = (tmpFiltered.length > 0 && tmpFiltered.every((pItem) => this._selected[String(pItem.JoinID)]));
		this._selected = {};
		if (!tmpAllSelected)
		{
			for (let i = 0; i < tmpFiltered.length; i++) { this._selected[String(tmpFiltered[i].JoinID)] = true; }
		}
		this._renderTable();
		this.updateStats();
	}

	/** @return {number} */
	_selectedCount() { return Object.keys(this._selected).length; }

	/** Recompute the stats line + the unlink button's enabled state. */
	updateStats()
	{
		const tmpSelected = this._selectedCount();
		const tmpTotal = this._items.length;
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`,
			`<strong>${tmpSelected}</strong> of ${tmpTotal} ${this._otherLabel()} selected to unlink`);
		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Unlink`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = (tmpSelected < 1);
		}
	}

	/**
	 * Remove every selected link (confirm via the host modal), then reload the anchor's links + repaint.
	 * @return {Promise<void>}
	 */
	async unlinkSelected()
	{
		const tmpSelectedJoinIDs = Object.keys(this._selected);
		if (tmpSelectedJoinIDs.length < 1)
		{
			return;
		}
		const tmpItemsByJoin = {};
		for (let i = 0; i < this._items.length; i++) { tmpItemsByJoin[String(this._items[i].JoinID)] = this._items[i]; }

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`Unlink ${tmpSelectedJoinIDs.length} ${this._otherLabel()} from this ${this._singular(this._anchorLabel())}?`,
				{ title: 'Unlink', confirmLabel: `Unlink ${tmpSelectedJoinIDs.length}`, cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}

		let tmpRemoved = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpSelectedJoinIDs.length; i++)
		{
			const tmpItem = tmpItemsByJoin[tmpSelectedJoinIDs[i]];
			if (!tmpItem) { continue; }
			try
			{
				await this.manager.removeJoin(this._associationHash, tmpItem.JoinRecord);
				tmpRemoved++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`AssociateUnlink: failed to remove join ${tmpItem.JoinID}.`, pError);
			}
		}
		this._toast(`${tmpRemoved} unlinked${tmpFailed > 0 ? `, ${tmpFailed} failed` : ''}.`, tmpFailed > 0 ? 'error' : 'success');

		this._selected = {};
		await this.renderUnlink();
	}

	// --- Column chooser (mirrors the matrix's, scoped per anchor side) ---

	/** Open/close the column chooser. */
	toggleColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1) { return; }
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser();
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close the column chooser (backdrop outside-click). */
	closeColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render the chooser rows. */
	_renderColumnChooser()
	{
		const tmpRows = this._otherSide.TableColumns.map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName, Visible: this._isColumnVisible(pCol) }));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-AssociateUnlink-Chooser', { Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Chooser`, tmpHTML);
	}

	/** Toggle one column's visibility (persisted; refuses to hide the last visible column). @param {string} pKey */
	toggleColumn(pKey)
	{
		if (!this.columnProvider) { return; }
		const tmpCol = this._otherSide.TableColumns.find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol) { return; }
		const tmpVisible = this._isColumnVisible(tmpCol);
		if (tmpVisible && this._visibleColumns().length <= 1) { return; }
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(), 'Unlink', pKey, !tmpVisible);
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Clear column overrides — back to developer defaults. */
	resetColumns()
	{
		if (this.columnProvider) { this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(), 'Unlink'); }
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Crude singularizer ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/** Non-blocking notification via the host modal's toast, when available. */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociateUnlink;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociateUnlink;

},{"pict-view":1053}],988:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Association Editor — a small, embeddable widget that manages one many-to-many association from
 * the perspective of a single anchor record (e.g. the Authors of THIS book). It renders:
 *   - a searchable entity picker of the OTHER side, with the currently-associated rows culled out, and
 *   - a list of the current associations, each with a remove button.
 *
 * It is instantiated once per (anchor recordset, association) by the read view's Association tab, with
 * a unique Hash. All join + display data flows through the shared `RecordSetAssociationManager`; the
 * picker comes from `pict-section-picker` (a soft dependency — the host registers it as
 * `Pict-Section-Picker`). Instance-specific state is passed via the render Record (not a per-instance
 * AppData address), so the shared templates stay address-stable across instances.
 *
 * Configuration (set by the read view when it creates the instance):
 *   - AssociationHash {string}  - the association to manage.
 *   - ThisRecordSet {string}    - the anchor recordset name (resolves which side is "this side").
 *   - ThisID {string|number}    - the anchor record's id (re-set before each render).
 *   - DefaultDestinationAddress - the tab body to render into.
 *   - PickerMode {'single'|'multi'} - the add control: 'single' (default) stages one pick that an
 *       explicit Add button (or Enter) commits; 'multi' stages chips that one Add commits together.
 *       Driven from the RecordSetReadTabs Association entry's PickerMode.
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_AssociationEditor = (
	{
		ViewIdentifier: 'PRSP-AssociationEditor',

		DefaultRenderable: 'PRSP_Renderable_AssociationEditor',
		DefaultDestinationAddress: '#PRSP_AssociationEditor_Container',
		DefaultTemplateRecordAddress: false,

		// Show the "Add defaults" affordance when the association has a defaults synthesizer. Set false
		// on an instance where synthesis is directionally meaningless (e.g. anchored on the type side of
		// a "seed a project with default types" synthesizer) — the synthesizer stays registered for the
		// side it applies to; this just hides the button on the side it does not.
		AllowSynthesize: true,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
		.prsp-assoc { display: flex; flex-direction: column; gap: 0.85rem; padding: 0.25rem 0 0.5rem; }
		.prsp-assoc-add { display: flex; flex-direction: column; gap: 0.35rem; }
		.prsp-assoc-add-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-assoc-add-row { display: flex; align-items: flex-start; gap: 0.5rem; }
		.prsp-assoc-picker-host { flex: 1 1 auto; min-width: 0; max-width: 460px; }
		.prsp-assoc-add-btn { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.9rem; font-weight: 600;
			padding: 0.45rem 0.85rem; border-radius: 8px; border: 1px solid var(--theme-color-brand-primary, #156dd1);
			background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.prsp-assoc-add-btn:hover { background: var(--theme-color-brand-primary-hover, #1259ad); }
		.prsp-assoc-list { display: flex; flex-direction: column; gap: 0.3rem; }
		.prsp-assoc-list-head { display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; }
		.prsp-assoc-list-title { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-assoc-count { font-size: 0.78rem; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-assoc-row { display: flex; align-items: center; gap: 0.6rem; padding: 0.45rem 0.6rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px;
			background: var(--theme-color-background-primary, #fff); }
		.prsp-assoc-row:hover { border-color: var(--theme-color-border-default, #d7dce3); }
		.prsp-assoc-row-name { flex: 0 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1f2733); font-size: 0.92rem; }
		.prsp-assoc-row-chips { flex: 1 1 auto; display: flex; flex-wrap: wrap; gap: 0.3rem; min-width: 0; }
		.prsp-assoc-chip { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 600; line-height: 1.25;
			padding: 0.05rem 0.4rem; border-radius: 5px; white-space: nowrap;
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
		.prsp-assoc-status { flex: 0 0 auto; display: inline-flex; align-items: center; font-size: 0.68rem; font-weight: 700; line-height: 1.2; text-transform: uppercase; letter-spacing: 0.03em;
			padding: 0.08rem 0.42rem; border-radius: 999px; white-space: nowrap; }
		.prsp-assoc-status.is-expired { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 14%, transparent); color: var(--theme-color-status-error, #b62828); }
		.prsp-assoc-status.is-pending { background: color-mix(in srgb, var(--theme-color-status-warning, #b7791f) 16%, transparent); color: var(--theme-color-status-warning, #97650f); }
		.prsp-assoc-row-id { flex: 0 0 auto; font-size: 0.74rem; color: var(--theme-color-text-muted, #6b7686); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.prsp-assoc-remove { flex: 0 0 auto; display: inline-flex; align-items: center; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.2rem; border-radius: 5px; font: inherit; }
		.prsp-assoc-remove:hover { color: var(--theme-color-status-error, #b62828); background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 10%, transparent); }
		.prsp-assoc-empty { padding: 0.7rem 0.2rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.88rem; font-style: italic; }
		.prsp-assoc-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		.prsp-assoc-head-right { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-assoc-synth-btn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.76rem; font-weight: 600;
			padding: 0.2rem 0.55rem; border-radius: 6px; border: 1px solid var(--theme-color-border-default, #d7dce3);
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45596b); }
		.prsp-assoc-synth-btn:hover { background: var(--theme-color-background-secondary, #e2e6ec); }
		.prsp-assoc-row-cfg { flex: 0 0 auto; display: flex; align-items: center; gap: 0.65rem; }
		.prsp-assoc-cfg { display: inline-flex; align-items: center; gap: 0.25rem; font-size: 0.78rem; color: var(--theme-color-text-secondary, #45596b); white-space: nowrap; cursor: default; }
		.prsp-assoc-cfg input[type="checkbox"] { cursor: pointer; }
		.prsp-assoc-cfg-num { width: 3.4rem; font: inherit; font-size: 0.8rem; padding: 0.1rem 0.3rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 5px; }
		.prsp-assoc-cfg-sel { font: inherit; font-size: 0.8rem; padding: 0.05rem 0.2rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 5px; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-AssociationEditor-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-AssociationEditor-Template] -->
		<div class="prsp-assoc">
			<div class="prsp-assoc-add">
				<span class="prsp-assoc-add-label">{~D:Record.AddLabel~}</span>
				<div class="prsp-assoc-add-row">
					<div class="prsp-assoc-picker-host" id="{~D:Record.PickerHostID~}"></div>
					<button type="button" class="prsp-assoc-add-btn" id="{~D:Record.AddButtonID~}" onclick="_Pict.views['{~D:Record.ViewHash~}'].addStaged()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.views['{~D:Record.ViewHash~}'].addStaged(); }">{~I:Plus~} {~D:Record.AddButtonLabel~}</button>
				</div>
				{~NE:Record.PickerMissing^<div class="prsp-assoc-note">The entity picker (pict-section-picker) is not registered, so associations cannot be added here.</div>~}
			</div>
			<div class="prsp-assoc-list">
				<div class="prsp-assoc-list-head">
					<span class="prsp-assoc-list-title">{~D:Record.ListLabel~}</span>
					<span class="prsp-assoc-head-right">
						<span class="prsp-assoc-count">{~D:Record.Count~}</span>
						{~TS:PRSP-AssociationEditor-SynthBtn:Record.SynthesizeSlot~}
					</span>
				</div>
				{~TS:PRSP-AssociationEditor-Row:Record.Items~}
				{~TS:PRSP-AssociationEditor-Empty:Record.EmptySlot~}
			</div>
		</div>
		<!-- DefaultPackage end view template:  [PRSP-AssociationEditor-Template] -->
	`
			},
			{
				Hash: 'PRSP-AssociationEditor-Empty',
				Template: /*html*/`<div class="prsp-assoc-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-AssociationEditor-Row',
				Template: /*html*/`
		<div class="prsp-assoc-row">
			<span class="prsp-assoc-row-name">{~RecordCard:Record.CardRecordSet^Record.OtherID^Record.Display~}</span>
			{~TS:PRSP-AssociationEditor-Status:Record.StatusBadgeSlot~}
			<span class="prsp-assoc-row-chips">{~TS:PRSP-AssociationEditor-Chip:Record.Chips~}</span>
			<span class="prsp-assoc-row-cfg">{~TS:PRSP-AssociationEditor-EditField:Record.EditFields~}</span>
			<span class="prsp-assoc-row-id">#{~D:Record.OtherID~}</span>
			<button type="button" class="prsp-assoc-remove" title="Remove association" onclick="_Pict.views['{~D:Record.ViewHash~}'].removeItem({~D:Record.JoinID~})">{~I:Trash~}</button>
		</div>
	`
			},
			{
				Hash: 'PRSP-AssociationEditor-Chip',
				Template: /*html*/`<span class="prsp-assoc-chip">{~D:Record.Text~}</span>`
			},
			{
				// A read-only status pill derived from the join record's lifecycle dates (Expired /
				// Not yet effective). Present only when a date column signals it — see _computeStatusBadge.
				Hash: 'PRSP-AssociationEditor-Status',
				Template: /*html*/`<span class="prsp-assoc-status {~D:Record.Class~}" title="{~D:Record.Title~}">{~D:Record.Text~}</span>`
			},
			{
				Hash: 'PRSP-AssociationEditor-SynthBtn',
				Template: /*html*/`<button type="button" class="prsp-assoc-synth-btn" title="Pull the inherited default associations in so you can customize them" onclick="_Pict.views['{~D:Record.ViewHash~}'].synthesizeDefaults()">{~I:Download~} Customize Defaults</button>`
			},
			{
				// One editable per-join config control (a "rich" join's settings, e.g. Journal / Spreadsheet
				// / Ordinal). The kind flags pick the input; onchange writes through to the join row.
				Hash: 'PRSP-AssociationEditor-EditField',
				Template: /*html*/`{~TIfAbs:PRSP-AssociationEditor-EditCheckbox:Record:Record.IsCheckbox^TRUE^~}{~TIfAbs:PRSP-AssociationEditor-EditNumber:Record:Record.IsNumber^TRUE^~}{~TIfAbs:PRSP-AssociationEditor-EditSelect:Record:Record.IsSelect^TRUE^~}{~TIfAbs:PRSP-AssociationEditor-EditText:Record:Record.IsText^TRUE^~}`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditCheckbox',
				Template: /*html*/`<label class="prsp-assoc-cfg"><input type="checkbox" {~D:Record.CheckedAttr~} onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.checked)" />{~D:Record.Label~}</label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditNumber',
				Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<input type="number" class="prsp-assoc-cfg-num" value="{~D:Record.Value~}" onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.value)" /></label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditSelect',
				Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<select class="prsp-assoc-cfg-sel" onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.value)">{~TS:PRSP-AssociationEditor-EditOption:Record.Options~}</select></label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditText',
				Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<input type="text" class="prsp-assoc-cfg-sel" value="{~D:Record.Value~}" onchange="_Pict.views['{~D:Record.ViewHash~}'].updateField({~D:Record.JoinID~},'{~D:Record.Field~}',this.value)" /></label>`
			},
			{
				Hash: 'PRSP-AssociationEditor-EditOption',
				Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_AssociationEditor',
				TemplateHash: 'PRSP-AssociationEditor-Template',
				ContentDestinationAddress: '#PRSP_AssociationEditor_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetAssociationEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_AssociationEditor, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;

		// The other-side ids currently associated (the live cull set the picker reads via a closure).
		this._otherIDs = [];
		// The current list items (so removeItem/updateField can find the exact join record by JoinID).
		this._lastItems = [];
		// Guard so AutoSynthesizeWhenEmpty runs at most once per anchor (no re-synthesize loop).
		this._autoSynthesizedFor = null;
	}

	/** @return {any} The association manager provider. */
	get manager()
	{
		return this.pict.providers.RecordSetAssociationManager;
	}

	/** @return {string} A DOM/address-safe key derived from this instance's Hash. */
	get safeKey()
	{
		return String(this.Hash).replace(/[^A-Za-z0-9]/g, '_');
	}

	/**
	 * Load the current associations and (re)paint the whole widget, then mount the picker. This is the
	 * editor's entry point — the read view's Association tab calls it (not the framework `render()`),
	 * so the async data load happens before the template renders (the read-view pattern).
	 *
	 * @return {Promise<boolean>}
	 */
	async renderEditor()
	{
		const tmpSides = this.manager ? this.manager.resolveSides(this.options.AssociationHash, this.options.ThisRecordSet) : false;
		if (!tmpSides)
		{
			this.pict.log.warn(`AssociationEditor [${this.Hash}]: association [${this.options.AssociationHash}] could not be resolved for [${this.options.ThisRecordSet}].`);
			return false;
		}

		const tmpThisID = this.options.ThisID;
		let tmpItems = [];
		if (tmpThisID !== undefined && tmpThisID !== null && tmpThisID !== '')
		{
			tmpItems = await this.manager.listAssociatedRecords(this.options.AssociationHash, this.options.ThisRecordSet, tmpThisID);

			// Opt-in: synthesize the default associations the first time an empty anchor is opened.
			const tmpAssociation = this.manager.getAssociation(this.options.AssociationHash);
			if (tmpAssociation && tmpAssociation.AutoSynthesizeWhenEmpty && (tmpItems.length === 0)
				&& this.manager.hasDefaultSynthesizer(this.options.AssociationHash) && (this._autoSynthesizedFor !== `${tmpThisID}`))
			{
				this._autoSynthesizedFor = `${tmpThisID}`;
				const tmpSynth = await this.manager.synthesizeDefaults(this.options.AssociationHash, this.options.ThisRecordSet, tmpThisID);
				if (tmpSynth && (tmpSynth.created > 0))
				{
					tmpItems = await this.manager.listAssociatedRecords(this.options.AssociationHash, this.options.ThisRecordSet, tmpThisID);
				}
			}
		}

		// Per-join editable config controls (for "rich" joins) — empty array for a plain link.
		const tmpEditableFields = this.manager.getJoinEditableFields(this.options.AssociationHash);
		// Auto record-preview-card: when a card is registered for the other side, each row's name becomes a
		// preview-card trigger (the {~RecordCard:~} tag degrades to the plain name when CardRecordSet is '').
		const tmpCardManager = this.pict.providers.RecordSetCardManager;
		const tmpCardRecordSet = (tmpCardManager && tmpCardManager.hasCard(tmpSides.otherSide.RecordSet)) ? tmpSides.otherSide.RecordSet : '';
		// Stamp the view hash + the editable controls on each row.
		for (let i = 0; i < tmpItems.length; i++)
		{
			tmpItems[i].ViewHash = this.Hash;
			tmpItems[i].EditFields = this._buildEditFields(tmpEditableFields, tmpItems[i]);
			tmpItems[i].CardRecordSet = tmpCardRecordSet;
			tmpItems[i].StatusBadgeSlot = this._computeStatusBadge(tmpItems[i].JoinRecord);
		}
		this._lastItems = tmpItems;
		this._otherIDs = tmpItems.map((pItem) => pItem.OtherID);

		const tmpOtherLabel = tmpSides.otherSide.Title || tmpSides.otherSide.RecordSet || tmpSides.otherSide.Entity;
		const tmpPickerPresent = !!this.pict.providers['Pict-Section-Picker'];
		const tmpRecord =
		{
			ViewHash: this.Hash,
			PickerHostID: `${this.safeKey}_Picker`,
			AddButtonID: `${this.safeKey}_AddBtn`,
			AddButtonLabel: (this.options.PickerMode === 'multi') ? 'Add selected' : 'Add',
			AddLabel: `Add ${tmpOtherLabel}`,
			ListLabel: `Current ${tmpOtherLabel}`,
			Count: `${tmpItems.length} ${tmpItems.length === 1 ? 'record' : 'records'}`,
			Items: tmpItems,
			// One-or-zero-element slot drives the empty-state line (TS parses inner tags; NE would not).
			EmptySlot: (tmpItems.length === 0) ? [ { EmptyText: `No ${tmpOtherLabel} associated yet — use the search above to add some.` } ] : [],
			PickerMissing: !tmpPickerPresent,
			// The "Add defaults" button shows only when the host registered a defaults synthesizer AND this
			// instance opts in (AllowSynthesize, default true) — an embedding anchored on the side the
			// synthesizer does not apply to sets AllowSynthesize:false to hide it.
			SynthesizeSlot: ((this.options.AllowSynthesize !== false) && this.manager.hasDefaultSynthesizer(this.options.AssociationHash)) ? [ { ViewHash: this.Hash } ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`AssociationEditor [${this.Hash}]: render error.`, pError);
						return resolve(false);
					}
					this._mountPicker(tmpSides, tmpRecord.PickerHostID);
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/**
	 * Create (or reconfigure) the other-side entity picker into its host element and render it. The
	 * picker's BaseFilter culls the currently-associated ids via a closure over `this._otherIDs`, so it
	 * re-evaluates on every search as associations change.
	 *
	 * @param {Record<string, any>} pSides - resolved sides from the manager.
	 * @param {string} pPickerHostID - the picker host element id.
	 */
	_mountPicker(pSides, pPickerHostID)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpPickerHash = `${this.safeKey}_PickerView`;
		const tmpValueAddress = `AppData.PRSPAssocPicker.${this.safeKey}`;
		const tmpMulti = (this.options.PickerMode === 'multi');
		// Reset the scratch value so the picker mounts empty (and re-culls) after each add.
		if (!this.pict.AppData.PRSPAssocPicker) { this.pict.AppData.PRSPAssocPicker = {}; }
		this.pict.AppData.PRSPAssocPicker[this.safeKey] = tmpMulti ? [] : null;

		const tmpConfig = this.manager.buildOtherPickerConfig(this.options.AssociationHash, this.options.ThisRecordSet, () => this._otherIDs,
			{
				Mode: tmpMulti ? 'multi' : 'single',
				DestinationAddress: `#${pPickerHostID}`,
				ValueAddress: tmpValueAddress,
				Placeholder: `Search ${pSides.otherSide.Title || pSides.otherSide.RecordSet || pSides.otherSide.Entity}…`,
				// No add-on-select: a single-select pick just stages the value and moves focus to the Add
				// button (so Enter commits). Multi mode stages chips; the Add button commits them.
				OnChange: tmpMulti ? undefined : (() => this._focusAddButton()),
			},
			// Anchor context for a function-form PriorityValues resolver on the other side — lets a pin be
			// derived from the record we're associating to (e.g. a line item's project prime contractor).
			{ ThisID: this.options.ThisID, ThisRecordSet: this.options.ThisRecordSet });
		if (!tmpConfig)
		{
			return;
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		this.pict.views[tmpPickerHash].render();
	}

	/** Move focus to the Add button so a single-select pick can be committed by pressing Enter. */
	_focusAddButton()
	{
		const tmpButton = document.getElementById(`${this.safeKey}_AddBtn`);
		if (tmpButton)
		{
			tmpButton.focus();
		}
	}

	/**
	 * Commit the staged selection(s) — the Add button (and Enter). Reads the picker's value: a single
	 * scalar, or (multi mode) an array of ids. Creates a join for each, then reloads + repaints so the
	 * new rows appear and are culled from the picker.
	 *
	 * @return {Promise<void>}
	 */
	async addStaged()
	{
		const tmpStaged = this.pict.AppData.PRSPAssocPicker ? this.pict.AppData.PRSPAssocPicker[this.safeKey] : null;
		const tmpIDs = (this.options.PickerMode === 'multi')
			? (Array.isArray(tmpStaged) ? tmpStaged.slice() : [])
			: ((tmpStaged === undefined || tmpStaged === null || tmpStaged === '') ? [] : [ tmpStaged ]);
		if (tmpIDs.length < 1)
		{
			return;
		}
		// Seed-on-first-customize: while this anchor is inheriting the default set (no associations of its own)
		// and the association has a defaults synthesizer, materialize those defaults FIRST — otherwise adding the
		// first item breaks inheritance and the rest of the inherited set silently disappears. Any staged id the
		// synthesizer already created is then skipped so it is not duplicated. Best-effort (never blocks the add).
		let tmpPresent = null;
		if (((this._otherIDs || []).length === 0) && this.manager.hasDefaultSynthesizer(this.options.AssociationHash))
		{
			try
			{
				const tmpSynth = await this.manager.synthesizeDefaults(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID);
				if (tmpSynth && (tmpSynth.created > 0))
				{
					const tmpSeeded = await this.manager.listAssociatedRecords(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID);
					tmpPresent = new Set((tmpSeeded || []).map((pItem) => `${pItem.OtherID}`));
				}
			}
			catch (pError)
			{
				this.pict.log.warn(`AssociationEditor [${this.Hash}]: seed-on-add synthesize failed.`, pError);
			}
		}
		let tmpFailures = 0;
		for (let i = 0; i < tmpIDs.length; i++)
		{
			if (tmpPresent && tmpPresent.has(`${tmpIDs[i]}`)) { continue; }
			try
			{
				await this.manager.createJoin(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID, tmpIDs[i]);
			}
			catch (pError)
			{
				tmpFailures++;
				this.pict.log.error(`AssociationEditor [${this.Hash}]: failed to create association for ${tmpIDs[i]}.`, pError);
			}
		}
		if (tmpFailures > 0)
		{
			this._toast(`${tmpFailures} association(s) could not be added.`, 'error');
		}
		await this.renderEditor();
	}

	/**
	 * Remove one association (a list row's remove handler). Confirms via the host modal, deletes the
	 * join, then reloads + repaints.
	 *
	 * @param {string|number} pJoinID - the join record id to delete.
	 * @return {Promise<void>}
	 */
	async removeItem(pJoinID)
	{
		const tmpItem = this._lastItems.find((pItem) => String(pItem.JoinID) === String(pJoinID));
		if (!tmpItem)
		{
			return;
		}
		const fRemove = async () =>
		{
			try
			{
				await this.manager.removeJoin(this.options.AssociationHash, tmpItem.JoinRecord);
			}
			catch (pError)
			{
				this.pict.log.error(`AssociationEditor [${this.Hash}]: failed to remove association.`, pError);
				this._toast('Could not remove the association.', 'error');
				return;
			}
			await this.renderEditor();
		};

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm(`Remove the association with "${tmpItem.Display}"?`,
				{ title: 'Remove association', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}
		return fRemove();
	}

	/**
	 * Derive a read-only lifecycle badge from a join record's conventional date columns, so an expired
	 * (or not-yet-effective) association is obvious at a glance — e.g. an expired material↔producer link
	 * where the row would otherwise look identical to an active one. Zero-config: it keys off the
	 * `ExpirationDate` / `EffectiveDate` columns when present. Returns a one-or-zero-element slot.
	 * @param {Record<string, any>} pJoinRecord
	 * @return {Array<Record<string, any>>}
	 */
	_computeStatusBadge(pJoinRecord)
	{
		const tmpJoin = pJoinRecord || {};
		const fParseDate = (pValue) =>
		{
			if (!pValue) { return null; }
			const tmpString = String(pValue);
			if (tmpString.indexOf('0000-00-00') === 0) { return null; }
			const tmpDate = new Date(tmpString);
			return Number.isNaN(tmpDate.getTime()) ? null : tmpDate;
		};
		const tmpNow = new Date();
		const tmpExpiration = fParseDate(tmpJoin.ExpirationDate);
		if (tmpExpiration && (tmpExpiration.getTime() < tmpNow.getTime()))
		{
			return [ { Text: 'Expired', Class: 'is-expired', Title: `Expired ${ tmpExpiration.toLocaleDateString('en-US') }` } ];
		}
		const tmpEffective = fParseDate(tmpJoin.EffectiveDate);
		if (tmpEffective && (tmpEffective.getTime() > tmpNow.getTime()))
		{
			return [ { Text: 'Not yet effective', Class: 'is-pending', Title: `Effective ${ tmpEffective.toLocaleDateString('en-US') }` } ];
		}
		return [];
	}

	/**
	 * Shape an association's editable join-config fields into per-row render data (current value + the
	 * kind flags the row template dispatches on).
	 * @param {Array<Record<string, any>>} pFields - the association's JoinEditableFields.
	 * @param {Record<string, any>} pItem - one decorated association row (carries its JoinRecord).
	 * @return {Array<Record<string, any>>}
	 */
	_buildEditFields(pFields, pItem)
	{
		if (!Array.isArray(pFields) || pFields.length < 1)
		{
			return [];
		}
		const tmpJoin = pItem.JoinRecord || {};
		return pFields.map((pField) =>
		{
			const tmpType = pField.Type || 'text';
			const tmpRaw = tmpJoin[pField.Field];
			return {
				ViewHash: this.Hash,
				JoinID: pItem.JoinID,
				Field: pField.Field,
				Label: pField.Label || pField.Field,
				IsCheckbox: (tmpType === 'checkbox'),
				IsNumber: (tmpType === 'number'),
				IsSelect: (tmpType === 'select'),
				IsText: (tmpType === 'text'),
				CheckedAttr: ((tmpType === 'checkbox') && (tmpRaw === 1 || tmpRaw === true || tmpRaw === '1')) ? 'checked' : '',
				Value: (tmpRaw === undefined || tmpRaw === null) ? '' : tmpRaw,
				Options: (Array.isArray(pField.Options) ? pField.Options : []).map((pOption) =>
				{
					const tmpValue = (pOption && typeof pOption === 'object') ? pOption.Value : pOption;
					return { Value: tmpValue, Label: (pOption && typeof pOption === 'object') ? (pOption.Label || pOption.Value) : pOption, SelectedAttr: (`${tmpRaw}` === `${tmpValue}`) ? 'selected' : '' };
				}),
			};
		});
	}

	/**
	 * Persist one per-join config change (a "rich" join's editable column). Writes through to the join
	 * row in place so focus is kept; reverts to the server state on failure.
	 * @param {string|number} pJoinID @param {string} pField @param {any} pValue
	 * @return {Promise<void>}
	 */
	async updateField(pJoinID, pField, pValue)
	{
		const tmpItem = this._lastItems.find((pItem) => String(pItem.JoinID) === String(pJoinID));
		if (!tmpItem || !tmpItem.JoinRecord)
		{
			return;
		}
		// Meadow booleans are 1/0.
		const tmpValue = (pValue === true) ? 1 : ((pValue === false) ? 0 : pValue);
		try
		{
			await this.manager.updateJoin(this.options.AssociationHash, tmpItem.JoinRecord, { [pField]: tmpValue });
			tmpItem.JoinRecord[pField] = tmpValue;
		}
		catch (pError)
		{
			this.pict.log.error(`AssociationEditor [${this.Hash}]: failed to update join field ${pField}.`, pError);
			this._toast('Could not save the change.', 'error');
			await this.renderEditor();
		}
	}

	/**
	 * Seed the default associations for this anchor via the association's `SynthesizeDefaults` hook (the
	 * "Add defaults" button). PSRS dedupes + creates; the host decides what the defaults are. Reloads after.
	 * @return {Promise<void>}
	 */
	async synthesizeDefaults()
	{
		if (!this.manager.hasDefaultSynthesizer(this.options.AssociationHash))
		{
			return;
		}
		let tmpResult = { created: 0, skipped: 0 };
		try
		{
			tmpResult = await this.manager.synthesizeDefaults(this.options.AssociationHash, this.options.ThisRecordSet, this.options.ThisID);
		}
		catch (pError)
		{
			this.pict.log.error(`AssociationEditor [${this.Hash}]: synthesize defaults failed.`, pError);
			this._toast('Could not add the defaults.', 'error');
			return;
		}
		this._toast((tmpResult.created > 0) ? `Added ${tmpResult.created} default${tmpResult.created === 1 ? '' : 's'}.` : 'No new defaults to add.', (tmpResult.created > 0) ? 'success' : 'info');
		await this.renderEditor();
	}

	/**
	 * Non-blocking notification via the host modal's toast, when available.
	 * @param {string} pMessage @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetAssociationEditor;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_AssociationEditor;

},{"pict-view":1053}],989:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__Create =
{
	ViewIdentifier: 'PRSP-Create',

	DefaultRenderable: 'PRSP_Renderable_Create',
	DefaultDestinationAddress: '#PRSP_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Create-Basic-Template',
			Template: /*html*/`
				<!-- DefaultPackage pict view template: [PRSP-Create-Basic-Template] -->
				<h1>{~D:Record.RecordSet~} Create</h1>
				<div>
					{~T:PRSP-Create-RecordCreate-Template~}
				</div>
				{~T:PRSP-Create-RecordButtonBar-Template~}
				<!-- DefaultPackage end view template:  [PRSP-Create-Basic-Template] -->
				`
		},
		{
			Hash: 'PRSP-Create-RecordButtonBar-Template',
			Template: /*html*/`
				<style>
					.record-button-bar-hidden
					{
						display: none;
					}
					.record-button-bar
					{
						display: flex;
						margin-top: 15px;
					}
					.record-button-bar > button
					{
						margin-right: 10px;
					}
				</style>
				<div class="record-button-bar">
					<button id="PRSP-Create-ClearButton" type="button" onclick="_Pict.views['RSP-RecordSet-Create'].clear()">Clear</button>
					<button id="PRSP-Create-SaveButton" type="button" onclick="_Pict.views['RSP-RecordSet-Create'].save()">Save</button>
				</div>
			`
		},
		{
			Hash: 'PRSP-Create-Link-Name-Template',
			Template: `Create`
		},
		{
			Hash: 'PRSP-Create-Link-URL-Template',
			Template: `#/PSRS/{~D:Record.Payload.Payload.RecordSet~}/Create`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Create_Basic',
			TemplateHash: 'PRSP-Create-Basic-Template',
			DestinationAddress: '#PRSP_Container',
			RenderMethod: 'replace'
		}
	],

	Manifests: {},
};

class viewRecordSetCreate extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__Create, pOptions);

		super(pFable, tmpOptions, pServiceHash);
		this.RecordSet = null;
		this.providerHash = null;
		this.manifest = null;
		this.defaultManifest = null;
	}

	handleRecordSetCreateRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Create view route handler called with invalid route payload.`);
		}

		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;

		if (this.delegateToCustomView('Create', tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderCreate(tmpProviderConfiguration, tmpProviderHash);
	}

	async clear()
	{
		await this.onBeforeClear();
		this.renderCreate(this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this.RecordSet], this.providerHash);
	}

	async save()
	{
		await this.onBeforeSave();
		const resultingRecord = await this.pict.providers[this.providerHash].createRecord(this.pict.AppData[`${ this.RecordSet }Details`]);

		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/View/${ resultingRecord[this.pict.providers[this.providerHash].getGUIDField()] }`);
	}

	async onBeforeClear()
	{
		// Hook that gets called before clear.
	}

	async onBeforeSave()
	{
		// Hook that gets called before save.
	}

	async onBeforeRenderCreate(pRecordConfiguration, pProviderHash)
	{
		// Hook that gets called before "renderCreate".
	}

	async renderCreate(pRecordConfiguration, pProviderHash)
	{
		await this.onBeforeRenderCreate(pRecordConfiguration, pProviderHash);
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetCreate: No provider found for ${pProviderHash} in ${pRecordConfiguration.RecordSet}.  Create Render failed.`);
			return false;
		}

		let tmpRecordCreateData =
		{
			"RecordSet": pRecordConfiguration.RecordSet,

			"RecordConfiguration": pRecordConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,
		};

		if (pRecordConfiguration.RecordSet !== this.RecordSet)
		{
			this.RecordSet = pRecordConfiguration.RecordSet;
		}

		this.pict.AppData[`${ this.RecordSet }Details`] = {};

		this.providerHash = pProviderHash;
		tmpRecordCreateData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();

		if (pRecordConfiguration.RecordSetCreateManifestOnly)
		{
			this.pict.TemplateProvider.addTemplate(`PRSP-Create-RecordCreate-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Create-RecordCreate-Template] -->
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordCreate') }</div>
				<!-- Manifest dynamic pict end template: [PRSP-Create-RecordCreate-Template] -->
			`);
		}
		else
		{
			// Construct a default manifest based on the RecordSchema:
			this.defaultManifest = 
			{
				"Form": "DefaultManifest",
				"Scope": "Default",
				"Descriptors": {},
				"Sections": 
				[
					{
						"Name": "",
						"Hash": "DefaultSection",
						"Solvers": [],
						"ShowTitle": false,
						"Groups": [
							{
								"Name": "",
								"Hash": "DefaultGroup",
								"Rows": [],
								"RecordSetSolvers": [],
								"ShowTitle": false
							}
						]
					}
				]
			}
			let rowCounter = 1;
			for (const p of Object.keys(tmpRecordCreateData.RecordSchema.properties))
			{
				const exclusionSet = [this.pict.providers[this.providerHash].getIDField(), this.pict.providers[this.providerHash].getGUIDField(), 'CreatingIDUser', 'UpdatingIDUser', 'DeletingIDUser', 'Deleted', 'CreateDate', 'UpdateDate', 'DeleteDate', 'Deleted', 'IDCustomer', 'ExternalSyncDate', 'ExternalSyncGUID']; // IDCustomer: meadow-endpoints/retold tenancy discriminator — server-managed, never settable via the API
				if (exclusionSet.includes(p))
				{
					continue;
				}
				const tmpDescriptor =
				{
					"Name": `${ this.pict.providers[pProviderHash].getHumanReadableFieldName?.(p) || p }`,
					"Hash": `${ tmpRecordCreateData.RecordSet }-${ p }`,
					"DataType": "String",
					"PictForm": 
					{
						"Row": `${ rowCounter }`,
						"Section": "DefaultSection",
						"Group": "DefaultGroup"
					}
				};
				rowCounter += 1;
				switch (tmpRecordCreateData.RecordSchema.properties[p].type)
				{
					case 'string':
					case 'autoguid':
						tmpDescriptor.DataType = 'String';
						break;
					case 'datetime':
					case 'date':
					case 'createdate':
					case 'updatedate':
						tmpDescriptor.DataType = 'String';
						tmpDescriptor.PictForm.InputType = 'DateTime'
						break;
					case 'boolean':
					case 'deleted':
						tmpDescriptor.DataType = 'Boolean';
					case 'integer':
					case 'decimal':
					case 'autoidentity':
					case 'createiduser':
					case 'updateiduser':
					case 'deleteiduser':
						tmpDescriptor.DataType = 'Number';
						break;
					default:
						tmpDescriptor.DataType = 'String';
				}

				const tmpForeignEntity = this.pict.PictSectionRecordSet.resolveForeignEntity(p, pRecordConfiguration, this.pict.providers[this.providerHash].getIDField());
				if (tmpForeignEntity && this.pict.providers['Pict-Section-Picker'])
				{
					// Foreign-key column → searchable entity Picker (edit) + resolved name (read).
					tmpDescriptor.PictForm.InputType = 'Picker';
					tmpDescriptor.PictForm.Entity = tmpForeignEntity;
					const tmpForeignConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpForeignEntity];
					if (tmpForeignConfig && tmpForeignConfig.SearchFields) { tmpDescriptor.PictForm.SearchFields = tmpForeignConfig.SearchFields; }
				}
				// Per-record-set label override (e.g. Contract/Project IDOrganization → "Prime Contractor").
				if (pRecordConfiguration.FieldLabels && pRecordConfiguration.FieldLabels[p]) { tmpDescriptor.Name = pRecordConfiguration.FieldLabels[p]; }
				this.defaultManifest.Descriptors[`${ tmpRecordCreateData.RecordSet }Details.${ p }`] = tmpDescriptor;
			}
			this.pict.TemplateProvider.addTemplate(`PRSP-Create-RecordCreate-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Create-RecordCreate-Template] -->
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordCreate', true) }</div>
				<!-- Manifest dynamic pict end template: [PRSP-Create-RecordCreate-Template] -->
			`);
		}

		this.renderAsync(`PRSP_Renderable_Create_Basic`, tmpRecordCreateData.RenderDestination, tmpRecordCreateData,
			async function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetCreate: Error rendering create ${pError}`, tmpRecordCreateData);
					return false;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetCreate: Rendered create ${tmpRecordCreateData.RecordSet}`, tmpRecordCreateData);
				}
				else
				{
					this.pict.log.info(`RecordSetCreate: Rendered create ${tmpRecordCreateData.RecordSet}`);
				}
				for (const s of this.manifest?.Sections || [])
				{
					this.pict.views[`PictSectionForm-${ s.Hash }`].render();
					this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
				}
				return true;
			}.bind(this));
	}

	_generateManifestTemplate(config, section, useDefaultManifest)
	{
		const tmpManifestHash = config.RecordSetCreateDefaultManifest || config.RecordSetCreateManifests?.[0];
		const tmpManifest = JSON.parse(JSON.stringify(useDefaultManifest ? this.defaultManifest : this.pict.PictSectionRecordSet.getManifest(tmpManifestHash)));
		if (!tmpManifest)
		{
			this.pict.log.error(`RecordSetCreate: No manifest found for ${ config.RecordSet }. Create Render failed.`);
			return '';
		}
		if (!tmpManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetCreate: No manifest descriptors found for manifest ${ tmpManifestHash }. Create Render failed.`);
			return '';
		}

		this.manifest = tmpManifest;
		let sectionsTemplate = '';
		for (const s of tmpManifest?.Sections || [])
		{
			delete this.pict.views[`PictSectionForm-${ s.Hash }`]
		}
		this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(tmpManifest);

		for (const pickList of tmpManifest?.PickLists || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
		}

		for (const s of tmpManifest?.Sections || [])
		{
			const viewSectionID = `PSRS-Create-${ section }-Section-${ s.Hash }`;
			sectionsTemplate += /*html*/`<div id="${ viewSectionID }"></div>`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].viewMarshalDestination = 'AppData';
			this.pict.views[`PictSectionForm-${ s.Hash }`].options.DefaultDestinationAddress = `#${ viewSectionID }`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].rebuildCustomTemplate();
		}
		return sectionsTemplate
	}


	addRoutes(pPictRouter)
	{
		pPictRouter.addRoute('/PSRS/:RecordSet/Create', this.handleRecordSetCreateRoute.bind(this));
		return true;
	}
}

module.exports = viewRecordSetCreate;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__Create;


},{"../RecordSet-RecordBaseView.js":984}],990:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Dashboard_HeaderList =
{
	ViewIdentifier: 'PRSP-Dashboard-HeaderList',

	DefaultRenderable: 'PRSP_Renderable_HeaderList',
	DefaultDestinationAddress: '#PRSP_HeaderList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Dashboard-HeaderList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-HeaderList-Template] -->
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-HeaderList-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_HeaderList',
			TemplateHash: 'PRSP-Dashboard-HeaderList-Template',
			DestinationAddress: '#PRSP_HeaderList_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetDashboardHeaderList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_Dashboard_HeaderList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardHeaderList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_Dashboard_HeaderList;


},{"pict-view":1053}],991:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationBottom = (
	{
		ViewIdentifier: 'PRSP-Dashboard-PaginationBottom',

		DefaultRenderable: 'PRSP_Renderable_PaginationBottom',
		DefaultDestinationAddress: '#PRSP_PaginationBottom_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-PaginationBottom-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-PaginationBottom-Template] -->
	<nav id="RSP_Lower_Pagination_Container">
	{~T:PRSP-Dashboard-Pagination-Template-Description~}
		{~T:PRSP-Dashboard-Pagination-Template-Buttons~}
	</nav>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-PaginationBottom-Template] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationBottom',
					TemplateHash: 'PRSP-Dashboard-PaginationBottom-Template',
					DestinationAddress: '#PRSP_PaginationBottom_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardPaginationBottom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationBottom, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardPaginationBottom;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationBottom;


},{"pict-view":1053}],992:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationTop = (
	{
		ViewIdentifier: 'PRSP-Dashboard-PaginationTop',

		DefaultRenderable: 'PRSP_Renderable_PaginationTop',
		DefaultDestinationAddress: '#PRSP_PaginationTop_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-PaginationTop-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-PaginationTop-Template] -->
	<nav id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
		{~T:PRSP-Dashboard-Pagination-Template-Description~}
		{~T:PRSP-Dashboard-Pagination-Template-Buttons~}
	</nav>
	<div>
		{~TS:PRSP-Dashboard-Pagination-Template-Pages:Record.PageLinksLimited~}
	</div>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-PaginationTop-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Description',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Description] -->
	<div>
		Showing
		<span id="PRSP_Pagination_Description_Records_Start">{~D:Record.PageStart~}</span> to
		<span id="PRSP_Pagination_Description_Records_End">{~D:Record.PageEnd~}</span> of
		<span id="PRSP_Pagination_Description_Records_Total">{~D:Record.TotalRecordCount.Count~}</span> total records.
	</div>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Description] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Buttons',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Buttons] -->
	<ul style="list-style-type: none; padding: 0; display: flex; justify-content: center;">
		{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
		{~TS:PRSP-Dashboard-Pagination-Template-Button-Page~}
		{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
	</ul>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Buttons] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Button-Previous',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Previous] -->
	<li><a href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">&laquo; Previous</a></li>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Previous] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Button-Next',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Next] -->
	<li style="margin-left: 15px;"><a href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next &raquo;</a></li>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Next] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Button-Page',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Page] -->
	<li><a href="#" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Page] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Pagination-Template-Pages',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Pagination-Template-Button-Pages] -->
	<a href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}" class="page-offset_{~D:Record.RelativeOffset~}">{~D:Record.Page~}</a>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Pagination-Template-Button-Pages] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationTop',
					TemplateHash: 'PRSP-Dashboard-PaginationTop-Template',
					DestinationAddress: '#PRSP_PaginationTop_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardPaginationTop extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationTop, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardPaginationTop;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationTop;


},{"pict-view":1053}],993:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Dashboard_RecordList =
{
	ViewIdentifier: 'PRSP-Dashboard-RecordList',

	DefaultRenderable: 'PRSP_Renderable_RecordList',
	DefaultDestinationAddress: '#PRSP_RecordList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Dashboard-RecordList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordList-Template] -->
	<section id="PRSP_List_Container">
		{~T:PRSP-Dashboard-RecordList-Template-Table~}
	</section>
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-RecordList-Template] -->
`
		},
		{
			Hash: 'PRSP-Dashboard-RecordList-Template-Table',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordList-Template-Table] -->
	<table id="PRSP_List_Table" tablespacing="0" cellpadding="0" cellspacing="0" style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
		<thead>{~T:PRSP-Dashboard-RecordListHeader-Template~}</thead>
		<tbody id="PRSP_RecordList_Container_Entries">
			{~T:PRSP-Dashboard-RecordListEntry-Template~}
		</tbody>
	</table>
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-RecordList-Template-Table] -->
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_RecordList',
			TemplateHash: 'PRSP-Dashboard-RecordList-Template',
			DestinationAddress: '#PRSP_RecordList_Container',
			RenderMethod: 'replace'
		}
	],

	Manifests: {}
};

class viewRecordSetDashboardRecordList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_Dashboard_RecordList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardRecordList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_Dashboard_RecordList;


},{"pict-view":1053}],994:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListEntry = (
	{
		ViewIdentifier: 'PRSP-Dashboard-RecordListEntry',

		DefaultRenderable: 'PRSP_Renderable_RecordListEntry',
		DefaultDestinationAddress: '#PRSP_RecordListEntry_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					// TODO: Add extras template here; it's in the header but not here yet.
					Hash: 'PRSP-Dashboard-RecordListEntry-Template',
					Template: /*html*/`
		{~TSWP:PRSP-Dashboard-RecordListEntry-Template-Row:Record.Records.Records:Record~}
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListEntry-Template-Row',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListEntry-Template] -->
	<tr>
		{~TSWP:PRSP-Dashboard-RecordListEntry-Template-Row-Cell:Record.Payload.TableCells:Record.Data~}
		{~T:PRSP-Dashboard-RecordListHeader-Template-Extra-Row~}
		{~T:PRSP-Dashboard-RecordListAction-Template-Cell~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListEntry-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template-Extra-Row',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template-Extra-Row] -->
	{~TBR:Record.Payload.RecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash~}
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Extra-Row] -->
	`
//	{~TBR:Record.Payload.RecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash~}

				},
				{
					Hash: 'PRSP-Dashboard-RecordListEntry-Template-Row-Cell',
					Template: /*html*/`
		<td style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
			{~TBDA:Record.Data.PictDashboard.ValueTemplate~}
		</td>
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListEntry-Template-Entry-Cell-Datum',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListEntry-Template-Entry-Cell-Datum] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListAction-Template-Cell',
					// FIXME: Needs a better way of getting the appropriate link templates in (likely requiring piping the RecordSet to the link manager)
					Template: /*html*/`
		<td style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
			<ul>
			{~TSWP:PRSP-Dashboard-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
			</ul>
		</td>
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListAction-Template-Cell-Datum',
					// These use the new TemplateByReference template expression, which uses the values in these addresses to lookup the template hash then renders those template with the current Record state.
					// This is part one of refactoring to include metatemplate resolution ase a core behavior pict itself rather than a pict-section-form capability
					Template: /*html*/`
					<li><a href="{~TBR:Record.Data.URL~}">{~TBR:Record.Data.Name~}</a></li>
	`

				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListEntry',
					TemplateHash: 'PRSP-Dashboard-RecordListEntry-Template',
					DestinationAddress: '#PRSP_RecordListEntry_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardRecordListEntry extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListEntry, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardRecordListEntry;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListEntry;


},{"pict-view":1053}],995:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListHeader = (
	{
		ViewIdentifier: 'PRSP-Dashboard-RecordListHeader',

		DefaultRenderable: 'PRSP_Renderable_RecordListHeader',
		DefaultDestinationAddress: '#PRSP_RecordListHeader_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template] -->
	<tr>
		{~TS:PRSP-Dashboard-RecordListHeader-Template-Header:Record.TableCells~}
		{~T:PRSP-Dashboard-RecordListHeader-Template-Extra-Header~}
		{~T:PRSP-Dashboard-RecordListActions-Template-Header~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Manifest-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template] -->
	<tr>
		{~TS:PRSP-Dashboard-RecordListHeader-Template-Header:Record.ManifestOhz~}
		{~T:PRSP-Dashboard-RecordListHeader-Template-Extra-Header~}
		{~T:PRSP-Dashboard-RecordListActions-Template-Header~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template-Header] -->
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333);">
		{~D:Record.DisplayName~}
	</th>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Template-Header] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-RecordListHeader-Template-Extra-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListHeader-Template-Extra-Header] -->
{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListHeader-Extra-Header] -->
	`
//	{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}

				},
				{
					Hash: 'PRSP-Dashboard-RecordListActions-Template-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-RecordListActions-Template-Header] -->
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333);">
		Actions
	</th>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-RecordListActions-Template-Header] -->
	`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListHeader',
					TemplateHash: 'PRSP-Dashboard-RecordListHeader-Template',
					DestinationAddress: '#PRSP_RecordListHeader_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboardRecordListHeader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListHeader, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardRecordListHeader;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListHeader;


},{"pict-view":1053}],996:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_Title =
{
	ViewIdentifier: 'PRSP-Dashboard-Title',

	DefaultRenderable: 'PRSP_Renderable_Title',
	DefaultDestinationAddress: '#PRSP_Title_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-Dashboard-Title-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Title-Template] -->
	<header id="PRSP_Title_Container">
		<h1 id="PRSP_Title">{~D:Record.Title~}</h1>
		<h2 id="PRSP_Subtitle">{~D:Record.Subtitle~}</h2>
	</header>
	<!-- DefaultPackage end view template:	[PRSP-Dashboard-Title-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Title',
			TemplateHash: 'PRSP-Dashboard-Title-Template',
			DestinationAddress: '#PRSP_Title_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetDashboardTitle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_Title, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetDashboardTitle;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_Title;

},{"pict-view":1053}],997:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');

const viewHeaderDashboard = require('./RecordSet-Dashboard-HeaderDashboard.js');
const viewTitle = require('./RecordSet-Dashboard-Title.js');
const viewFilters = require('../RecordSet-Filters.js');
const viewPaginationTop = require('./RecordSet-Dashboard-PaginationTop.js');
const viewRecordList = require('./RecordSet-Dashboard-RecordList.js');
const viewRecordListHeader = require('./RecordSet-Dashboard-RecordListHeader.js');
const viewRecordListEntry = require('./RecordSet-Dashboard-RecordListEntry.js');
const viewPaginationBottom = require('./RecordSet-Dashboard-PaginationBottom.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__Dashboard = (
	{
		ViewIdentifier: 'PRSP-List',

		DefaultRenderable: 'PRSP_Renderable_List',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Dashboard-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Template] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-Dashboard-Title~}
		{~V:PRSP-Dashboard-HeaderDashboard~}
		<section id="PRSP_Filters_Container">
			{~FV:PRSP-Filters:Dashboard~}
		</section>
		{~V:PRSP-Dashboard-PaginationTop~}
		{~V:PRSP-Dashboard-RecordList~}
		{~V:PRSP-Dashboard-PaginationBottom~}
	</section>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Template-Form-With-Recordset-Data',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Template-Form-With-Recordset-Data] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-Dashboard-Title~}
		{~V:PRSP-Dashboard-HeaderDashboard~}
		<section id="PRSP_Filters_Container">
			{~FV:PRSP-Filters:Dashboard~}
		</section>
		{~V:PRSP-Dashboard-PaginationTop~}
		{~T:PRSP-Dashboard-RecordDashboard-Template~}
		{~V:PRSP-Dashboard-PaginationBottom~}
	</section>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template-Form-With-Recordset-Data] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Template-Form',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Dashboard-Template-Form] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-Dashboard-Title~}
		{~V:PRSP-Dashboard-HeaderDashboard~}
		{~T:PRSP-Dashboard-RecordDashboard-Template~}
	</section>
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template-Form] -->
	`
				},
				{
					Hash: 'PRSP-Dashboard-Template-Record',
					Template: /*html*/`
	<!-- DefaultPackage end view template:  [PRSP-Dashboard-Template] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_List',
					TemplateHash: 'PRSP-Dashboard-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Form_With_Recordset_Data',
					TemplateHash: 'PRSP-Dashboard-Template-Form-With-Recordset-Data',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Form',
					TemplateHash: 'PRSP-Dashboard-Template-Form',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetDashboard extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__Dashboard, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.childViews = {
			headerList: null,
			title: null,
			paginationTop: null,
			recordList: null,
			recordListHeader: null,
			recordListEntry: null,
			paginationBottom: null
		};
	}

	handleRecordSetDashboardRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			return;
			//throw new Error(`Pict RecordSet List view route handler called with invalid route payload.`);
		}
		if (!pRoutePayload.data || !pRoutePayload.data.RecordSet)
		{
			return;
		}

		//_Pict.PictSectionRecordSet.recordSetProviderConfigurations['Book'], 'RSP-Provider-Book'
		// FIXME: Not in love with this but good enough to start.
		// FIXME: Typescript mumbo jumbo
		// if (!('PictSectionRecordSet' in this.pict))
		// {
		// 	return false;
		// }
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		if (!tmpProviderConfiguration)
		{
			this.pict.log.error(`RecordSetDashboard: No record set configuration found for ${pRoutePayload.data.RecordSet}.  List Render failed.`);
			this.fable.providers.RecordSetRouter.pictRouter.navigate('/PSRS/404');
			return;
		}
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		const tmpFilterString = pRoutePayload.data.FilterString || '';
		const tmpSerializedFilterExperience = pRoutePayload.data.FilterExperience || '';

		const tmpOffset = pRoutePayload.data.Offset ? pRoutePayload.data.Offset : 0;
		const tmpPageSize = pRoutePayload.data.PageSize ? pRoutePayload.data.PageSize : 100;

		if (pRoutePayload.data.DashboardHash)
		{
			return this.renderSpecificDashboard(pRoutePayload.data.DashboardHash, tmpProviderConfiguration, tmpProviderHash, tmpFilterString, tmpSerializedFilterExperience, tmpOffset, tmpPageSize);
		}
		return this.renderDashboard(tmpProviderConfiguration, tmpProviderHash, tmpFilterString, tmpSerializedFilterExperience, tmpOffset, tmpPageSize);
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/FilteredTo/:FilterString', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard/:Offset', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/Dashboard', this.handleRecordSetDashboardRoute.bind(this));

		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/FilteredTo/:FilterString', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/:Offset/:PageSize', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash/:Offset', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/SpecificDashboard/:DashboardHash', this.handleRecordSetDashboardRoute.bind(this));
		pPictRouter.router.resolve();
		return true;
	}

	onBeforeRenderList(pRecordListData)
	{
		return pRecordListData;
	}

	dynamicallyGenerateColumns(pRecordListData)
	{
		pRecordListData.TableCells = [];
		const tmpEntity = pRecordListData.RecordSetConfiguration.Entity;
		this.excludedByDefaultCells = [
			'ID' + tmpEntity,
			'GUID' + tmpEntity,
			'CreateDate',
			'CreatingIDUser',
			'DeleteDate',
			'Deleted',
			'DeletingIDUser',
			'UpdateDate',
			'UpdatingIDUser',
			'IDCustomer', // meadow-endpoints/retold tenancy discriminator — server-managed, hidden from every record view
			'ExternalSyncDate', 'ExternalSyncGUID', // external-sync auditing stamps (Headlight integration sync)
		];

		const tmpSchema = pRecordListData.RecordSchema;
		const tmpProperties = tmpSchema?.properties;
		// loop throught the schema and add the columns to the tableCells
		for (const tmpColumn in tmpProperties)
		{
			if (tmpProperties.hasOwnProperty(tmpColumn))
			{
				// Check if the column is excluded by the default list of columns (or is not a GUID/ID)
				if (this.excludedByDefaultCells.includes(tmpColumn) === false)
				{
					pRecordListData.TableCells.push({
						Key: tmpColumn,
						DisplayName: tmpProperties?.[tmpColumn].title || tmpColumn,
						ManifestHash: 'Default',
						PictDashboard:
						{
							ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
						},
					});
				}
			}
		}
		return pRecordListData;
	}

	/**
	 * @param {string} pDashboardHash
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 *
	 * @return {Promise<void>}
	 */
	async renderSpecificDashboard(pDashboardHash, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize)
	{
		if (!pRecordSetConfiguration)
		{
			this.pict.log.error(`RecordSetDashboard: No record set configuration found for ${pDashboardHash}.  List Render failed.`);
			return;
		}
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetDashboard: No provider found for ${pProviderHash} in ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			return;
		}

		let tmpManifestDefinition;
		if (pDashboardHash)
		{
			tmpManifestDefinition = this.pict.PictSectionRecordSet.manifestDefinitions[pDashboardHash];
		}
		let tmpTitle = pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet;
		if (tmpManifestDefinition && tmpManifestDefinition.TitleTemplate)
		{
			tmpTitle = this.pict.parseTemplate(tmpManifestDefinition.TitleTemplate, pRecordSetConfiguration);
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordDashboardData =
		{
			"Title": tmpTitle,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
			"DashboardHash": pDashboardHash,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordDashboardData.RecordSet);
		}
		// Fetch the records
		tmpRecordDashboardData.Records = await this.pict.providers[pProviderHash].getDecoratedRecords(tmpRecordDashboardData);
		// Get the total record count
		tmpRecordDashboardData.TotalRecordCount = await this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordDashboardData);
		// Get the record schema
		tmpRecordDashboardData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordDashboardData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		const tmpOffset = Number(tmpRecordDashboardData.Offset);
		tmpRecordDashboardData.PageEnd = tmpOffset + tmpRecordDashboardData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordDashboardData.PageStart = (tmpRecordDashboardData.Records.Records.length > 0) ? (tmpOffset + 1) : 0;

		// Compute the number of pages total
		tmpRecordDashboardData.PageCount = Math.ceil(tmpRecordDashboardData.TotalRecordCount.Count / tmpRecordDashboardData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordDashboardData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordDashboardData.Offset / tmpRecordDashboardData.PageSize)
			});
		tmpRecordDashboardData.PageLinks = [];
		for (let i = 0; i < tmpRecordDashboardData.PageCount; i++)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/FilteredTo/${tmpRecordDashboardData.FilterString}/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordDashboardData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordDashboardData.PageLinks.length, tmpRecordDashboardData.PageLinkBookmarks.Current + 10);
		tmpRecordDashboardData.PageLinksLimited = tmpRecordDashboardData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/FilteredTo/${tmpRecordDashboardData.FilterString}/0/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/0/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordDashboardData.PageLinks.length)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/FilteredTo/${tmpRecordDashboardData.FilterString}/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/SpecificDashboard/${pDashboardHash}/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordDashboardData.PageLinkBookmarks.Previous = tmpRecordDashboardData.PageLinkBookmarks.Current - 1;
		tmpRecordDashboardData.PageLinkBookmarks.Next = tmpRecordDashboardData.PageLinkBookmarks.Current + 1;
		tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordDashboardData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordDashboardData.PageLinkBookmarks.Next >= tmpRecordDashboardData.PageLinks.length)
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Next];
		}

		if (pDashboardHash && !tmpManifestDefinition.Form)
		{
			tmpRecordDashboardData.TableCells = tmpManifestDefinition?.TableCells;
		}
		if (!tmpRecordDashboardData.TableCells && !tmpManifestDefinition.Form)
		{
			// Put code here to preprocess columns into other data parts.
			/*
				"RecordSetDashboardManifestOnly": false,

				"RecordSetListManifests": [ "Bestsellers", "Underdogs", "NewReleases" ],
				"RecordSetDashboardManifests": [ "Bestsellers" ],
			 */
			if (pRecordSetConfiguration.RecordSetDashboardManifestOnly)
			{
				const tmpManifestHash = pRecordSetConfiguration.RecordSetDashboardDefaultManifest || pRecordSetConfiguration.RecordSetDashboardManifests?.[0];
				const tmpManifest = this.pict.PictSectionRecordSet.getManifest(tmpManifestHash);
				if (!tmpManifest)
				{
					this.pict.log.error(`RecordSetDashboard: No manifest found for ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
				}
				else
				{
					// @ts-ignore
					tmpRecordDashboardData.TableCells = tmpManifest.TableCells;
				}
			}
			if (!tmpRecordDashboardData.TableCells)
			{
				if (tmpRecordDashboardData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
				{
					tmpRecordDashboardData.TableCells = tmpRecordDashboardData.RecordSetConfiguration.RecordSetListColumns.map((key) =>
						{
							if (typeof key === 'object')
							{
								if (!key.DisplayName)
								{
									key.DisplayName = key.Key; //FIXME: use schema?
								}
								if (!key.ManifestHash)
								{
									key.ManifestHash = 'Default';
								}
								if (key.PictDashboard && !key.PictDashboard.ValueTemplate)
								{
									key.PictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
								}
								return key;
							}
							return {
								Key: key,
								DisplayName: key, //FIXME: use schema?
								ManifestHash: 'Default',
								PictDashboard:
								{
									ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
								},
							};
						});
				}
				else
				{
					this.dynamicallyGenerateColumns(tmpRecordDashboardData);
				}
			}
		}

		tmpRecordDashboardData = this.onBeforeRenderList(tmpRecordDashboardData);

		if (!tmpManifestDefinition.Form)
		{
			this.pict.providers.DynamicRecordsetSolver.solveDashboard(tmpManifestDefinition, tmpRecordDashboardData.Records.Records);
		}
		else
		{
			this.pict.AppData['PSRS-Dashboard-Data'] = tmpRecordDashboardData.Records.Records;
			this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordDashboard-Template', /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Dashboard-RecordDashboard-Template] -->
				<div>${ this._generateFormManifestTemplate(tmpManifestDefinition, 'RecordDashboard') }</div>
				<!-- Manifest dynamic pict end template: [PRSP-Dashboard-RecordDashboard-Template] -->
			`);
		}

		this.renderAsync(tmpManifestDefinition.Form ? (tmpManifestDefinition.WithRecordsetData ? 'PRSP_Renderable_Form_With_Recordset_Data' : 'PRSP_Renderable_Form') : 'PRSP_Renderable_List', tmpRecordDashboardData.RenderDestination, tmpRecordDashboardData,
			function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetDashboard: Error rendering list ${pError}`, tmpRecordDashboardData);
					return;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`, tmpRecordDashboardData);
				}
				else
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`);
				}
				for (const s of tmpManifestDefinition?.Sections || [])
				{
					this.pict.views[`PictSectionForm-${ s.Hash }`].render();
					this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
				}
			}.bind(this));
	}

	_generateFormManifestTemplate(tmpManifest, section)
	{
		if (!tmpManifest)
		{
			this.pict.log.error(`RecordSetDashboard: No manifest found for dashboard. Render failed.`);
			return '';
		}
		if (!tmpManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetDashboard: No manifest descriptors found for manifest. Render failed.`);
			return '';
		}

		this.manifest = tmpManifest;
		let sectionsTemplate = '';
		for (const s of tmpManifest?.Sections || [])
		{
			delete this.pict.views[`PictSectionForm-${ s.Hash }`]
		}
		this.pict.views.PictFormMetacontroller.clearManifestDescription();
		this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(tmpManifest);

		for (const pickList of tmpManifest?.PickLists || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
		}

		for (const s of tmpManifest?.Sections || [])
		{
			const viewSectionID = `PSRS-Dashboard-${ section }-Section-${ s.Hash }`;
			sectionsTemplate += /*html*/`<div id="${ viewSectionID }"></div>`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].viewMarshalDestination = 'AppData';
			this.pict.views[`PictSectionForm-${ s.Hash }`].options.DefaultDestinationAddress = `#${ viewSectionID }`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].rebuildCustomTemplate();
		}
		return sectionsTemplate
	}

	/**
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 *
	 * @return {Promise<void>}
	 */
	async renderDashboard(pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize)
	{
		if (!pRecordSetConfiguration)
		{
			this.pict.log.error(`RecordSetDashboard: No record set configuration found.  List Render failed.`);
			return;
		}
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetDashboard: No provider found for ${pProviderHash} in ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			return;
		}
		if (pRecordSetConfiguration.RecordSetDashboardManifestOnly)
		{
			const tmpManifestHash = pRecordSetConfiguration.RecordSetDashboardDefaultManifest || pRecordSetConfiguration.RecordSetDashboardManifests?.[0];
			const tmpManifest = this.pict.PictSectionRecordSet.getManifest(tmpManifestHash);
			if (!tmpManifest)
			{
				this.pict.log.error(`RecordSetDashboard: No manifest found for ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			}
			else
			{
				return this.renderSpecificDashboard(tmpManifestHash, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize);
			}
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordDashboardData =
		{
			"Title": pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Fetch the records
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordDashboardData.RecordSet);
		}
		const [ tmpRecords, tmpTotalRecordCount, tmpRecordSchema ] = await Promise.all([
			this.pict.providers[pProviderHash].getDecoratedRecords(tmpRecordDashboardData),
			this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordDashboardData),
			this.pict.providers[pProviderHash].getRecordSchema(),
		]);
		tmpRecordDashboardData.Records = tmpRecords;
		// Get the total record count
		tmpRecordDashboardData.TotalRecordCount = tmpTotalRecordCount;
		// Get the record schema
		tmpRecordDashboardData.RecordSchema = tmpRecordSchema;

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordDashboardData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		const tmpOffset = Number(tmpRecordDashboardData.Offset);
		tmpRecordDashboardData.PageEnd = tmpOffset + tmpRecordDashboardData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordDashboardData.PageStart = (tmpRecordDashboardData.Records.Records.length > 0) ? (tmpOffset + 1) : 0;

		// Compute the number of pages total
		tmpRecordDashboardData.PageCount = Math.ceil(tmpRecordDashboardData.TotalRecordCount.Count / tmpRecordDashboardData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordDashboardData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordDashboardData.Offset / tmpRecordDashboardData.PageSize)
			});
		tmpRecordDashboardData.PageLinks = [];
		for (let i = 0; i < tmpRecordDashboardData.PageCount; i++)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/FilteredTo/${tmpRecordDashboardData.FilterString}/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/${i * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordDashboardData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordDashboardData.PageLinks.length, tmpRecordDashboardData.PageLinkBookmarks.Current + 10);
		tmpRecordDashboardData.PageLinksLimited = tmpRecordDashboardData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/FilteredTo/${tmpRecordDashboardData.FilterString}/${tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/${0}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordDashboardData.PageLinks.length)
		{
			if (tmpRecordDashboardData.FilterString)
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/FilteredTo/${tmpRecordDashboardData.FilterString}/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			else
			{
				tmpRecordDashboardData.PageLinksLimited.push(
					{
						Page: tmpRecordDashboardData.PageCount,
						RelativeOffset: (tmpRecordDashboardData.PageCount - 1) - tmpRecordDashboardData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordDashboardData.RecordSet}/Dashboard/${(tmpRecordDashboardData.PageCount - 1) * tmpRecordDashboardData.PageSize}/${tmpRecordDashboardData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordDashboardData.PageLinksLimited[tmpRecordDashboardData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordDashboardData.PageLinkBookmarks.Previous = tmpRecordDashboardData.PageLinkBookmarks.Current - 1;
		tmpRecordDashboardData.PageLinkBookmarks.Next = tmpRecordDashboardData.PageLinkBookmarks.Current + 1;
		tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordDashboardData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.PreviousLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordDashboardData.PageLinkBookmarks.Next >= tmpRecordDashboardData.PageLinks.length)
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = false;
			tmpRecordDashboardData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordDashboardData.PageLinkBookmarks.NextLink = tmpRecordDashboardData.PageLinks[tmpRecordDashboardData.PageLinkBookmarks.Next];
		}

		// Put code here to preprocess columns into other data parts.
		/*
			"RecordSetDashboardManifestOnly": false,

			"RecordSetListManifests": [ "Bestsellers", "Underdogs", "NewReleases" ],
			"RecordSetDashboardManifests": [ "Bestsellers" ],
		 */
		if (tmpRecordDashboardData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
		{
			tmpRecordDashboardData.TableCells = tmpRecordDashboardData.RecordSetConfiguration.RecordSetListColumns.map((pKey) =>
				{
					if (typeof pKey === 'object')
					{
						const tmpTableCell = pKey;
						if (!tmpTableCell.DisplayName)
						{
							tmpTableCell.DisplayName = tmpTableCell.Key; //FIXME: use schema?
						}
						if (!tmpTableCell.ManifestHash)
						{
							tmpTableCell.ManifestHash = 'Default';
						}
						if (!tmpTableCell.PictDashboard)
						{
							tmpTableCell.PictDashboard = {};
						}
						if (!tmpTableCell.PictDashboard.ValueTemplate)
						{
							tmpTableCell.PictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
						}
						return tmpTableCell;
					}
					return {
						Key: pKey,
						DisplayName: pKey, //FIXME: use schema?
						ManifestHash: 'Default',
						PictDashboard:
						{
							ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
						},
					};
				});
		}
		else
		{
			this.dynamicallyGenerateColumns(tmpRecordDashboardData);
		}

		tmpRecordDashboardData = this.onBeforeRenderList(tmpRecordDashboardData);

		const tmpManifest = { Scope: 'Default', Descriptors: { }, TableCells: tmpRecordDashboardData.TableCells };
		for (const tmpCell of tmpRecordDashboardData.TableCells)
		{
			tmpManifest.Descriptors[tmpCell.Key] = { Hash: tmpCell.Key, PictDashboard: tmpCell.PictDashboard };
		}
		this.pict.providers.DynamicRecordsetSolver.solveDashboard(tmpManifest, tmpRecordDashboardData.Records.Records);

		this.renderAsync('PRSP_Renderable_List', tmpRecordDashboardData.RenderDestination, tmpRecordDashboardData,
			function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetDashboard: Error rendering list ${pError}`, tmpRecordDashboardData);
					return;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`, tmpRecordDashboardData);
				}
				else
				{
					this.pict.log.info(`RecordSetDashboard: Rendered list ${tmpRecordDashboardData.RecordSet} with ${tmpRecordDashboardData.Records.Records.length} records.`);
				}
			}.bind(this));
	}

	onInitialize()
	{
		this.childViews.headerList = this.pict.addView('PRSP-Dashboard-HeaderDashboard', viewHeaderDashboard.default_configuration, viewHeaderDashboard);
		this.childViews.title = this.pict.addView('PRSP-Dashboard-Title', viewTitle.default_configuration, viewTitle);
		this.childViews.filters = this.pict.views['PRSP-Filters'] || this.pict.addView('PRSP-Filters', { }, viewFilters);
		this.childViews.paginationTop = this.pict.addView('PRSP-Dashboard-PaginationTop', viewPaginationTop.default_configuration, viewPaginationTop);
		this.childViews.recordList = this.pict.addView('PRSP-Dashboard-RecordList', viewRecordList.default_configuration, viewRecordList);
		this.childViews.recordListHeader = this.pict.addView('PRSP-Dashboard-RecordListHeader', viewRecordListHeader.default_configuration, viewRecordListHeader);
		this.childViews.recordListEntry = this.pict.addView('PRSP-Dashboard-RecordListEntry', viewRecordListEntry.default_configuration, viewRecordListEntry);
		this.childViews.paginationBottom = this.pict.addView('PRSP-Dashboard-PaginationBottom', viewPaginationBottom.default_configuration, viewPaginationBottom);

		// Initialize the subviews
		this.childViews.headerList.initialize();
		this.childViews.title.initialize();
		this.childViews.paginationTop.initialize();
		this.childViews.recordList.initialize();
		this.childViews.recordListHeader.initialize();
		this.childViews.recordListEntry.initialize();
		this.childViews.paginationBottom.initialize();

		return super.onInitialize();
	}
}

module.exports = viewRecordSetDashboard;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__Dashboard;


},{"../RecordSet-Filters.js":983,"../RecordSet-RecordBaseView.js":984,"./RecordSet-Dashboard-HeaderDashboard.js":990,"./RecordSet-Dashboard-PaginationBottom.js":991,"./RecordSet-Dashboard-PaginationTop.js":992,"./RecordSet-Dashboard-RecordList.js":993,"./RecordSet-Dashboard-RecordListEntry.js":994,"./RecordSet-Dashboard-RecordListHeader.js":995,"./RecordSet-Dashboard-Title.js":996}],998:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The Bulk Delete screen — select a batch of a recordset's records and delete them together (to clean up
 * duplicates / bad imports). A searchable, paged record table with a checkbox per row + select-all; "Delete
 * selected" removes them all after a confirm.
 *
 * Two modes:
 *   - Basic: just delete the checked records.
 *   - Advanced (opt in per recordset via `RecordSetAdvancedDelete`): for each record being deleted, pick ONE
 *     replacement record (same recordset); all of that record's many-to-many joins and one-to-many
 *     dependents are REPOINTED to the replacement first (via the metacontroller's reassociation
 *     orchestrator), and the record is only deleted when its repoint succeeds cleanly. This is the "delete
 *     the misspelled Author, move his books to the correct one" workflow.
 *
 * Registered ONCE by the metacontroller as `RSP-RecordSet-BulkDelete` and parameterized by route:
 *   /PSRS/:RecordSet/BulkDelete                       (bulk selection)
 *   /PSRS/:RecordSet/BulkDelete/Record/:RecordID      (single record, Advanced — the Read view's advanced path)
 *
 * Data flows through the registered recordset provider (getRecords + deleteRecord) and the reassociation
 * orchestrator on `pict.PictSectionRecordSet`. The replacement picker comes from `pict-section-picker`
 * (soft dependency); confirm/toast come from `pict-section-modal`; column visibility persists through the
 * `ColumnDataProvider`.
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_BulkDelete = (
	{
		ViewIdentifier: 'PRSP-BulkDelete',

		DefaultRenderable: 'PRSP_Renderable_BulkDelete',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,
		AutoRender: false,
		AutoRenderOrdinal: 0,
		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		BulkDeletePageSize: 50,

		CSS: /*css*/`
		.prsp-bdel { display: flex; flex-direction: column; gap: 1rem; padding: 0.25rem 0 1rem; }
		.prsp-bdel-header h2 { margin: 0 0 0.2rem; font-size: 1.25rem; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-sub { margin: 0; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
		.prsp-bdel-card { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary, #fff); display: flex; flex-direction: column; gap: 0.6rem; }
		.prsp-bdel-card.is-hidden { display: none; }
		.prsp-bdel-card-label { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bdel-modes { display: inline-flex; gap: 0.35rem; }
		.prsp-bdel-mode { padding: 0.4rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; cursor: pointer; font: inherit; font-size: 0.86rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-panel, #fff); user-select: none; }
		.prsp-bdel-mode:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-mode.is-active { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
		.prsp-bdel-bar { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
			border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 12px; padding: 0.7rem 1rem; background: var(--theme-color-background-secondary, #f7f8fa); }
		.prsp-bdel-stats { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bdel-stats strong { color: var(--theme-color-status-error, #b62828); font-size: 1.05rem; }
		.prsp-bdel-btn { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; font: inherit; font-size: 0.92rem; font-weight: 600;
			padding: 0.5rem 1rem; border-radius: 8px; border: 1px solid var(--theme-color-status-error, #b62828);
			background: var(--theme-color-status-error, #b62828); color: #fff; }
		.prsp-bdel-btn:hover { background: var(--theme-color-status-error-hover, #9c2020); }
		.prsp-bdel-btn[disabled] { opacity: 0.5; cursor: not-allowed; }
		.prsp-bdel-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; flex-wrap: wrap; }
		.prsp-bdel-filters:empty { display: none; }
		.prsp-bdel-tools { display: flex; align-items: center; gap: 0.6rem; }
		.prsp-bdel-colbtn { display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; font: inherit; font-size: 0.78rem; padding: 0.2rem 0.5rem;
			border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bdel-colbtn:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-colchooser-wrap { position: relative; }
		.prsp-bdel-colchooser-backdrop { position: fixed; inset: 0; z-index: 30; display: none; }
		.prsp-bdel-colchooser-wrap.is-open .prsp-bdel-colchooser-backdrop { display: block; }
		.prsp-bdel-colchooser { position: absolute; right: 0; top: 0.3rem; z-index: 40; min-width: 200px; display: none;
			background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
		.prsp-bdel-colchooser-wrap.is-open .prsp-bdel-colchooser { display: block; }
		.prsp-bdel-colchooser-list { max-height: 50vh; overflow-y: auto; padding: 0.25rem; }
		.prsp-bdel-colrow { display: flex; align-items: center; gap: 0.5rem; width: 100%; text-align: left; cursor: pointer; font: inherit; font-size: 0.86rem;
			padding: 0.4rem 0.55rem; border: none; border-radius: 6px; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
		.prsp-bdel-colrow:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-bdel-colrow-check { flex: 0 0 auto; display: inline-flex; width: 1em; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
		.prsp-bdel-colrow.is-on .prsp-bdel-colrow-check { visibility: visible; }
		.prsp-bdel-colchooser-foot { display: flex; justify-content: flex-end; padding: 0.35rem 0.5rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-bdel-colreset { font: inherit; font-size: 0.8rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
		.prsp-bdel-tablewrap { max-height: 52vh; overflow: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.prsp-btbl { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.prsp-btbl thead th { position: sticky; top: 0; z-index: 1; text-align: left; padding: 0.5rem 0.6rem; background: var(--theme-color-background-tertiary, #eceef2);
			color: var(--theme-color-text-secondary, #45505f); font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
		.prsp-btbl-th-check { width: 1.8rem; text-align: center; cursor: pointer; }
		.prsp-btbl-row { cursor: pointer; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-btbl-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
		.prsp-btbl-row.is-selected { background: color-mix(in srgb, var(--theme-color-status-error, #b62828) 9%, transparent); }
		.prsp-btbl-row td { padding: 0.4rem 0.6rem; color: var(--theme-color-text-primary, #1f2733); max-width: 22rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.prsp-btbl-td-check { width: 1.8rem; text-align: center; }
		.prsp-btbl-check { display: inline-flex; color: var(--theme-color-status-error, #b62828); visibility: hidden; }
		.prsp-btbl-row.is-selected .prsp-btbl-check { visibility: visible; }
		.prsp-btbl-headcheck { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bdel-more { display: block; width: 100%; padding: 0.45rem; cursor: pointer; font: inherit; font-size: 0.85rem; border: none; border-top: 1px solid var(--theme-color-border-light, #e8ebf0);
			background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-secondary, #45505f); }
		.prsp-bdel-more:hover { background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); }
		.prsp-bdel-empty { padding: 0.9rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; font-style: italic; text-align: center; }
		.prsp-bdel-note { color: var(--theme-color-status-error, #b62828); font-size: 0.86rem; }
		.prsp-bdel-reassign-row { display: flex; align-items: center; gap: 0.8rem; padding: 0.5rem 0.2rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.prsp-bdel-reassign-row:first-child { border-top: none; }
		.prsp-bdel-reassign-name { flex: 0 0 40%; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1f2733); font-size: 0.92rem; }
		.prsp-bdel-reassign-arrow { flex: 0 0 auto; color: var(--theme-color-text-muted, #6b7686); }
		.prsp-bdel-reassign-picker { flex: 1 1 auto; min-width: 0; }
		`,
		CSSPriority: 500,

		Templates:
		[
			{
				Hash: 'PRSP-BulkDelete-Template',
				Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-BulkDelete-Template] -->
		<div class="prsp-bdel">
			<div class="prsp-bdel-header">
				<h2>{~D:Record.Title~}</h2>
				<p class="prsp-bdel-sub">{~D:Record.Subtitle~}</p>
			</div>
			{~TS:PRSP-BulkDelete-ModeCard:Record.ModeSlot~}
			<div class="prsp-bdel-bar">
				<div class="prsp-bdel-stats" id="{~D:Record.StatsID~}"></div>
				<button type="button" class="prsp-bdel-btn" id="{~D:Record.DeleteButtonID~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].confirmBulkDelete()">{~I:Trash~} Delete selected</button>
			</div>
			{~TS:PRSP-BulkDelete-Toolbar:Record.ToolbarSlot~}
			<div class="prsp-bdel-card">
				<div class="prsp-bdel-tablewrap"><div id="{~D:Record.TableID~}"></div></div>
			</div>
			{~TS:PRSP-BulkDelete-ReassignCard:Record.ReassignSlot~}
			{~NE:Record.PickerMissing^<div class="prsp-bdel-note">The entity picker (pict-section-picker) is not registered, so replacement selection is unavailable.</div>~}
		</div>
		<!-- DefaultPackage end view template:  [PRSP-BulkDelete-Template] -->
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ModeCard',
				Template: /*html*/`
		<div class="prsp-bdel-card">
			<span class="prsp-bdel-card-label">Mode</span>
			<div class="prsp-bdel-modes" id="{~D:Record.ModeToggleID~}">{~T:PRSP-BulkDelete-ModeToggle:Record~}</div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ModeToggle',
				Template: /*html*/`
		<div class="prsp-bdel-mode{~NE:Record.BasicActive^ is-active~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].setMode('Basic')">Delete only</div>
		<div class="prsp-bdel-mode{~NE:Record.AdvancedActive^ is-active~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].setMode('Advanced')">Reassign &amp; delete</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-Toolbar',
				Template: /*html*/`
		<div class="prsp-bdel-card">
			<div class="prsp-bdel-toolbar">
				<span class="prsp-bdel-card-label">Filter {~D:Record.RecordLabel~}</span>
				<div class="prsp-bdel-tools">
					<div class="prsp-bdel-colchooser-wrap" id="{~D:Record.ChooserID~}_Wrap">
						<button type="button" class="prsp-bdel-colbtn" title="Choose columns" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleColumnChooser()">{~I:Settings~} Columns</button>
						<div class="prsp-bdel-colchooser-backdrop" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].closeColumnChooser()"></div>
						<div class="prsp-bdel-colchooser" id="{~D:Record.ChooserID~}"></div>
					</div>
				</div>
			</div>
			<!-- The recordset's own filter experience (quick filters + Add filter) renders here; applying a
			     filter navigates to /BulkDelete/FilteredTo/... which re-lists through the same provider path. -->
			<div class="prsp-bdel-filters" id="PRSP_Filters_Container"></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-Table',
				Template: /*html*/`
		<table class="prsp-btbl">
			<thead><tr><th class="prsp-btbl-th-check" title="Select all loaded" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleSelectAll()"><span class="prsp-btbl-headcheck">{~D:Record.SelectAllIcon~}</span></th>{~TS:PRSP-BulkDelete-HeaderCell:Record.Columns~}</tr></thead>
			<tbody>{~TS:PRSP-BulkDelete-Row:Record.Rows~}</tbody>
		</table>
		{~TS:PRSP-BulkDelete-Empty:Record.EmptySlot~}
		{~TS:PRSP-BulkDelete-More:Record.MoreSlot~}
	`
			},
			{
				Hash: 'PRSP-BulkDelete-HeaderCell',
				Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
			},
			{
				Hash: 'PRSP-BulkDelete-Row',
				Template: /*html*/`<tr id="{~D:Record.RowID~}" class="prsp-btbl-row{~NE:Record.Selected^ is-selected~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleRow('{~D:Record.RecordID~}')"><td class="prsp-btbl-td-check"><span class="prsp-btbl-check">{~I:Check~}</span></td>{~TS:PRSP-BulkDelete-Cell:Record.Cells~}</tr>`
			},
			{
				Hash: 'PRSP-BulkDelete-Cell',
				Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>`
			},
			{
				Hash: 'PRSP-BulkDelete-Empty',
				Template: /*html*/`<div class="prsp-bdel-empty">{~D:Record.EmptyText~}</div>`
			},
			{
				Hash: 'PRSP-BulkDelete-More',
				Template: /*html*/`<button type="button" class="prsp-bdel-more" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].loadMore()">Load more</button>`
			},
			{
				Hash: 'PRSP-BulkDelete-Chooser',
				Template: /*html*/`
		<div class="prsp-bdel-colchooser-list">{~TS:PRSP-BulkDelete-ColRow:Record.Rows~}</div>
		<div class="prsp-bdel-colchooser-foot"><button type="button" class="prsp-bdel-colreset" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].resetColumns()">Reset to defaults</button></div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ColRow',
				Template: /*html*/`<button type="button" class="prsp-bdel-colrow{~NE:Record.Visible^ is-on~}" onclick="_Pict.views['RSP-RecordSet-BulkDelete'].toggleColumn('{~D:Record.Key~}')"><span class="prsp-bdel-colrow-check">{~I:Check~}</span><span>{~D:Record.DisplayName~}</span></button>`
			},
			{
				Hash: 'PRSP-BulkDelete-ReassignCard',
				Template: /*html*/`
		<div class="prsp-bdel-card{~NE:Record.Hidden^ is-hidden~}" id="{~D:Record.ReassignCardID~}">
			<span class="prsp-bdel-card-label">Reassign related records to</span>
			<div id="{~D:Record.ReassignID~}"></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-Reassign',
				Template: /*html*/`
		{~TS:PRSP-BulkDelete-ReassignRow:Record.Rows~}
		{~TS:PRSP-BulkDelete-ReassignEmpty:Record.EmptySlot~}
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ReassignRow',
				Template: /*html*/`
		<div class="prsp-bdel-reassign-row">
			<span class="prsp-bdel-reassign-name" title="{~D:Record.Display~}">{~D:Record.Display~}</span>
			<span class="prsp-bdel-reassign-arrow">{~I:ArrowRight~}</span>
			<div class="prsp-bdel-reassign-picker" id="{~D:Record.PickerHostID~}"></div>
		</div>
	`
			},
			{
				Hash: 'PRSP-BulkDelete-ReassignEmpty',
				Template: /*html*/`<div class="prsp-bdel-empty">{~D:Record.EmptyText~}</div>`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_BulkDelete',
				TemplateHash: 'PRSP-BulkDelete-Template',
				ContentDestinationAddress: '#PRSP_Container',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetBulkDelete extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_BulkDelete, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { PictSectionRecordSet: any }} */
		this.pict;

		this._recordSet = null;
		this._config = null;
		this._presetRecordID = null;    // single-record advanced entry (from the Read view)
		this._records = [];             // the loaded page(s)
		this._recordsByID = {};         // String(id) -> record (accumulates across pages, for confirm lookups)
		this._cursor = 0;
		this._hasMore = false;
		this._filterString = '';        // the FilteredTo route segment (the recordset filter search string)
		this._filterExperience = '';    // the serialized filter experience from the route
		this._selected = {};            // String(recordID) -> true
		this._mode = 'Basic';           // 'Basic' | 'Advanced'
		this._replacement = {};         // String(recordID) -> replacementID
	}

	/** @return {any} The registered recordset provider. */
	get provider()
	{
		return this.pict.providers[`RSP-Provider-${this._recordSet}`];
	}

	/** @return {any} The column-visibility persistence provider (localStorage; host-overridable). */
	get columnProvider()
	{
		return this.pict.providers.ColumnDataProvider;
	}

	/** @return {number} */
	_pageSize() { return this.options.BulkDeletePageSize || 50; }

	/** @return {boolean} Whether advanced (reassign) delete is enabled for this recordset. */
	_advancedEnabled() { return !!(this._config && this._config.RecordSetAdvancedDelete === true); }

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/Record/:RecordID', this.handleBulkDeleteRoute.bind(this));
		// Filtered variants (the recordset filter experience navigates here, ViewContext = 'BulkDelete').
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleBulkDeleteRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/FilteredTo/:FilterString', this.handleBulkDeleteRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete/FilterExperience/:FilterExperience', this.handleBulkDeleteRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/BulkDelete', this.handleBulkDeleteRoute.bind(this));
		return true;
	}

	/**
	 * Route handler — parse the recordset + optional single record, then paint.
	 * @param {Record<string, any>} pRoutePayload
	 */
	handleBulkDeleteRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet BulkDelete route handler called with invalid route payload.`);
		}
		this._recordSet = pRoutePayload.data.RecordSet;
		this._presetRecordID = (pRoutePayload.data.RecordID !== undefined && pRoutePayload.data.RecordID !== '') ? pRoutePayload.data.RecordID : null;
		this._filterString = pRoutePayload.data.FilterString || '';
		this._filterExperience = pRoutePayload.data.FilterExperience || '';
		this._config = this.pict.PictSectionRecordSet ? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this._recordSet] : null;
		this._records = [];
		this._recordsByID = {};
		this._cursor = 0;
		this._hasMore = false;
		this._selected = {};
		this._replacement = {};
		// The Read view's advanced path deep-links a single record; force Advanced + preselect it.
		this._mode = this._presetRecordID ? 'Advanced' : 'Basic';
		if (this._presetRecordID) { this._selected[String(this._presetRecordID)] = true; }
		return this.renderScreen();
	}

	/** A DOM/address-safe key for this screen. */
	get safeKey()
	{
		return `${String(this._recordSet)}`.replace(/[^A-Za-z0-9]/g, '_');
	}

	/** @return {string} A label for the records being deleted. */
	_recordLabel() { return (this._config && this._config.Title) || this._recordSet || 'records'; }

	/** @return {Array<string>} The recordset's search fields (config, else the display field). */
	_searchFields()
	{
		if (this._config && Array.isArray(this._config.SearchFields) && this._config.SearchFields.length > 0) { return this._config.SearchFields; }
		return [ this._displayField() ];
	}

	/** @return {string} The best display field for a record (config override, else a common name column). */
	_displayField()
	{
		if (this._config && this._config.RecordSetBulkDeleteDisplayField) { return this._config.RecordSetBulkDeleteDisplayField; }
		if (this._config && Array.isArray(this._config.SearchFields) && this._config.SearchFields.length > 0) { return this._config.SearchFields[0]; }
		return 'Name';
	}

	/** Column persistence scope for the bulk-delete table. */
	_columnScope() { return `BulkDelete_${this._recordSet}`; }

	/** @return {Array<Record<string, any>>} The table columns (RecordSetListColumns, else a single display column). */
	_columns()
	{
		if (this._config && Array.isArray(this._config.RecordSetListColumns) && this._config.RecordSetListColumns.length > 0)
		{
			return this._config.RecordSetListColumns.map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName || pCol.Key, DefaultHidden: (pCol.DefaultHidden === true) }));
		}
		return [ { Key: '__display', DisplayName: this._recordLabel(), DefaultHidden: false } ];
	}

	/**
	 * Fetch one page of the recordset's records (or the single preset record). The FilterString is encoded
	 * the same way the List view encodes it before handing it to the provider.
	 * @param {boolean} pReset
	 * @return {Promise<void>}
	 */
	async _fetchPage(pReset)
	{
		if (pReset) { this._cursor = 0; }
		const tmpIDField = this.provider.getIDField();
		let tmpRecords = [];
		if (this._presetRecordID)
		{
			// The single-record advanced flow fetches exactly that record (documented raw-filter read).
			const tmpResult = await this.provider.getRecordsInline(`FBV~${tmpIDField}~EQ~${encodeURIComponent(this._presetRecordID)}`, 0, 1);
			tmpRecords = (tmpResult && Array.isArray(tmpResult.Records)) ? tmpResult.Records : [];
			this._hasMore = false;
		}
		else
		{
			// Reuse the recordset's filter machinery: getRecords composes the route FilterString (encoded the
			// same way the List encodes it) over the recordset's active filter clauses + default filter +
			// delete suppression. So the bulk-delete list respects the same filters as the List.
			const tmpOptions = { RecordSet: this._recordSet, RecordSetConfiguration: this._config, Offset: this._cursor, PageSize: this._pageSize() };
			if (this._filterString) { tmpOptions.FilterString = encodeURIComponent(this._filterString); }
			const tmpResult = await this.provider.getRecords(tmpOptions);
			tmpRecords = (tmpResult && Array.isArray(tmpResult.Records)) ? tmpResult.Records : [];
			this._hasMore = (tmpRecords.length >= this._pageSize());
		}
		this._records = pReset ? tmpRecords : this._records.concat(tmpRecords);
		// Index every loaded record so confirm can find a selected record even after it scrolls off (paging
		// is client-side "Load more", so selection survives; a filter change re-lists via the route).
		for (let i = 0; i < tmpRecords.length; i++)
		{
			this._recordsByID[String(tmpRecords[i][tmpIDField])] = tmpRecords[i];
		}
	}

	/**
	 * Paint the screen shell, load the first page, render the table (+ the reassign section in Advanced mode).
	 * @return {Promise<boolean>}
	 */
	async renderScreen()
	{
		if (!this.provider)
		{
			this.pict.log.error(`BulkDelete: no provider registered for recordset [${this._recordSet}].`);
			return false;
		}
		// Rehydrate the filter experience from the route into the recordset's active filter state (so the
		// same clauses drive the fetch), mirroring how the List view rehydrates filters from the URL.
		if (this._filterExperience && this.pict.views['PRSP-Filters'])
		{
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(this._filterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${this._recordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}
		await this._fetchPage(true);

		const tmpAdvanced = (this._mode === 'Advanced');
		const tmpModeData = {
			ModeToggleID: `${this.safeKey}_ModeToggle`,
			BasicActive: !tmpAdvanced,
			AdvancedActive: tmpAdvanced,
		};
		const tmpToolbarData = {
			RecordLabel: this._recordLabel(),
			ChooserID: `${this.safeKey}_Chooser`,
		};
		const tmpReassignData = {
			ReassignCardID: `${this.safeKey}_ReassignCard`,
			ReassignID: `${this.safeKey}_Reassign`,
			Hidden: !tmpAdvanced,
		};

		const tmpRecord =
		{
			Title: this._presetRecordID ? `Reassign & delete this ${this._singular(this._recordLabel())}` : `Delete ${this._recordLabel()}`,
			Subtitle: this._presetRecordID
				? `Choose a replacement for each related record, then delete.`
				: `Select the ${this._recordLabel()} to delete, then remove them together.${this._advancedEnabled() ? ' Use "Reassign & delete" to move related records to a replacement first.' : ''}`,
			StatsID: `${this.safeKey}_Stats`,
			DeleteButtonID: `${this.safeKey}_Delete`,
			TableID: `${this.safeKey}_Table`,
			PickerMissing: (this._advancedEnabled() && !this.pict.providers['Pict-Section-Picker']),
			// Mode toggle only when advanced is enabled AND this is not the single-record preset flow.
			ModeSlot: (this._advancedEnabled() && !this._presetRecordID) ? [ tmpModeData ] : [],
			// The search/columns toolbar is not useful for the single-record preset flow.
			ToolbarSlot: this._presetRecordID ? [] : [ tmpToolbarData ],
			// The reassign card exists whenever advanced is enabled (hidden until Advanced mode).
			ReassignSlot: this._advancedEnabled() ? [ tmpReassignData ] : [],
		};

		return new Promise((resolve) =>
		{
			this.renderAsync(this.options.DefaultRenderable, this.options.DefaultDestinationAddress, tmpRecord,
				(pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`BulkDelete: render error.`, pError);
						return resolve(false);
					}
					this._renderTable();
					if (!this._presetRecordID && this.pict.views['PRSP-Filters'])
					{
						// Render the recordset's filter experience into #PRSP_Filters_Container (ViewContext
						// 'BulkDelete', so its apply navigates back to /BulkDelete/FilteredTo/...). Mirrors the
						// filter view's own in-place re-render call.
						this.pict.views['PRSP-Filters'].render(undefined, undefined, { RecordSet: this._recordSet, ViewContext: 'BulkDelete' });
					}
					if (tmpAdvanced) { this._renderReassign(); }
					this.updateStats();
					this.pict.CSSMap.injectCSS();
					return resolve(true);
				});
		});
	}

	/** Effective visibility for a column (stored override wins, else `!DefaultHidden`). */
	_isColumnVisible(pCol)
	{
		const tmpOverrides = this.columnProvider ? this.columnProvider.getColumnVisibilityOverrides(this._columnScope(), 'BulkDelete') : {};
		if (tmpOverrides && Object.prototype.hasOwnProperty.call(tmpOverrides, pCol.Key))
		{
			return tmpOverrides[pCol.Key] === true;
		}
		return !pCol.DefaultHidden;
	}

	/** @return {Array<Record<string, any>>} The currently-visible columns. */
	_visibleColumns()
	{
		return this._columns().filter((pCol) => this._isColumnVisible(pCol));
	}

	/** Resolve a cell value for a column on a record (the synthetic __display column uses the name heuristic). */
	_cellValue(pRecord, pColumn)
	{
		if (pColumn.Key === '__display') { return this._displayName(pRecord); }
		return pRecord[pColumn.Key];
	}

	/** A human-friendly display name for a record (first present of the common name columns, else #id). */
	_displayName(pRecord)
	{
		if (!pRecord || typeof pRecord !== 'object') { return ''; }
		const tmpFields = [ this._displayField(), 'Name', 'Title', 'FullName', 'DisplayName', 'Label', 'Description', 'Code' ];
		for (let i = 0; i < tmpFields.length; i++)
		{
			const tmpValue = pRecord[tmpFields[i]];
			if (tmpValue !== undefined && tmpValue !== null && String(tmpValue).trim() !== '') { return String(tmpValue).trim(); }
		}
		return `#${pRecord[this.provider.getIDField()]}`;
	}

	/** Build the row models for the loaded records and render the table. */
	_renderTable()
	{
		const tmpColumns = this._visibleColumns();
		const tmpIDField = this.provider.getIDField();
		const tmpRows = this._records.map((pRecord) =>
		{
			const tmpID = pRecord[tmpIDField];
			return {
				RecordID: tmpID,
				RowID: `${this.safeKey}_row_${tmpID}`,
				Selected: !!this._selected[String(tmpID)],
				Cells: tmpColumns.map((pCol) => ({ Value: this._cellValue(pRecord, pCol) })),
			};
		});
		const tmpAllSelected = (tmpRows.length > 0 && tmpRows.every((pRow) => pRow.Selected));
		const tmpTableRecord = {
			Columns: tmpColumns.map((pCol) => ({ DisplayName: pCol.DisplayName })),
			Rows: tmpRows,
			SelectAllIcon: this.pict.icon(tmpAllSelected ? 'Check' : 'Minus'),
			EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: this._filterString ? `No ${this._recordLabel()} match the filter.` : `No ${this._recordLabel()} found.` } ] : [],
			MoreSlot: this._hasMore ? [ {} ] : [],
		};
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-Table', tmpTableRecord);
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Table`, tmpHTML);
	}

	/** Load the next page of records and append it. @return {Promise<void>} */
	async loadMore()
	{
		this._cursor += this._pageSize();
		await this._fetchPage(false);
		this._renderTable();
	}

	/**
	 * Toggle a record's selection (the row click). Re-renders the reassign section in Advanced mode so its
	 * per-record replacement pickers track the selection.
	 * @param {string|number} pRecordID
	 */
	toggleRow(pRecordID)
	{
		const tmpKey = String(pRecordID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; delete this._replacement[tmpKey]; }
		else { this._selected[tmpKey] = true; }
		const tmpRowElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_row_${pRecordID}`);
		if (tmpRowElements && tmpRowElements.length > 0)
		{
			tmpRowElements[0].classList.toggle('is-selected', !!this._selected[tmpKey]);
		}
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	/** Select / clear all the LOADED rows (the header checkbox). */
	toggleSelectAll()
	{
		const tmpIDField = this.provider.getIDField();
		const tmpAllSelected = (this._records.length > 0 && this._records.every((pRecord) => this._selected[String(pRecord[tmpIDField])]));
		for (let i = 0; i < this._records.length; i++)
		{
			const tmpKey = String(this._records[i][tmpIDField]);
			if (tmpAllSelected) { delete this._selected[tmpKey]; delete this._replacement[tmpKey]; }
			else { this._selected[tmpKey] = true; }
		}
		this._renderTable();
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	/** Switch Basic/Advanced mode (show/hide the reassign card + repaint the toggle). @param {string} pMode */
	setMode(pMode)
	{
		this._mode = (pMode === 'Advanced') ? 'Advanced' : 'Basic';
		const tmpToggleElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_ModeToggle`);
		if (tmpToggleElements && tmpToggleElements.length > 0)
		{
			const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-ModeToggle', { BasicActive: (this._mode !== 'Advanced'), AdvancedActive: (this._mode === 'Advanced') });
			this.pict.ContentAssignment.assignContent(`#${this.safeKey}_ModeToggle`, tmpHTML);
		}
		const tmpCardElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_ReassignCard`);
		if (tmpCardElements && tmpCardElements.length > 0)
		{
			tmpCardElements[0].classList.toggle('is-hidden', (this._mode !== 'Advanced'));
		}
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	/** Render the reassign section (a replacement picker per selected record) + mount the pickers. */
	_renderReassign()
	{
		const tmpIDField = this.provider.getIDField();
		const tmpSelectedIDs = Object.keys(this._selected).filter((pKey) => this._selected[pKey]);
		const tmpRows = tmpSelectedIDs.map((pID) => (
			{
				RecordID: pID,
				Display: this._displayName(this._recordsByID[pID] || {}),
				PickerHostID: `${this.safeKey}_repl_${String(pID).replace(/[^A-Za-z0-9]/g, '_')}`,
			}));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-Reassign',
			{
				Rows: tmpRows,
				EmptySlot: (tmpRows.length === 0) ? [ { EmptyText: `Select ${this._recordLabel()} above to choose replacements.` } ] : [],
			});
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Reassign`, tmpHTML);
		for (let i = 0; i < tmpRows.length; i++)
		{
			this._mountReplacementPicker(tmpRows[i].RecordID, tmpRows[i].PickerHostID, tmpSelectedIDs);
		}
	}

	/**
	 * Mount a single-select replacement picker over the same recordset entity, culling every id selected
	 * for deletion (so a record can't be its own or another victim's replacement).
	 * @param {string|number} pRecordID @param {string} pHostID @param {Array<string>} pExcludeIDs
	 */
	_mountReplacementPicker(pRecordID, pHostID, pExcludeIDs)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider)
		{
			return;
		}
		const tmpIDField = this.provider.getIDField();
		const tmpSafeID = String(pRecordID).replace(/[^A-Za-z0-9]/g, '_');
		const tmpPickerHash = `${this.safeKey}_ReplPicker_${tmpSafeID}`;
		const tmpValueAddress = `AppData.PRSPBulkDeleteRepl.${this.safeKey}.R${tmpSafeID}`;
		if (!this.pict.AppData.PRSPBulkDeleteRepl) { this.pict.AppData.PRSPBulkDeleteRepl = {}; }
		if (!this.pict.AppData.PRSPBulkDeleteRepl[this.safeKey]) { this.pict.AppData.PRSPBulkDeleteRepl[this.safeKey] = {}; }

		const tmpConfig = {
			Entity: this.provider.options.Entity,
			ValueField: tmpIDField,
			TextField: this._displayField(),
			SearchFields: this._searchFields(),
			DestinationAddress: `#${pHostID}`,
			ValueAddress: tmpValueAddress,
			Placeholder: `Search a replacement ${this._singular(this._recordLabel())}…`,
			BaseFilter: () => `FBL~${tmpIDField}~NIN~${(pExcludeIDs || []).map((pValue) => encodeURIComponent(pValue)).join(',')}`,
			OnChange: (pValue) => { this._replacement[String(pRecordID)] = pValue; this.updateStats(); },
		};
		// Field decoration (module policy): opt-in ⚙ to pin an extra column onto each replacement row so
		// same-named candidates are distinguishable. Resolved per entity by the metacontroller.
		if (this.pict.PictSectionRecordSet)
		{
			this.pict.PictSectionRecordSet.applyFieldDecoration(tmpConfig, this.provider.options.Entity);
		}
		tmpPickerProvider.createEntityPicker(tmpPickerHash, tmpConfig);
		// createEntityPicker builds the picker view but does not paint it into the host — render it, then
		// restore any prior choice (a fresh row has none, so setValue is conditional).
		this.pict.views[tmpPickerHash].render();
		if (this._replacement[String(pRecordID)] !== undefined)
		{
			this.pict.views[tmpPickerHash].setValue(this._replacement[String(pRecordID)]);
		}
	}

	/** @return {number} */
	_selectedCount() { return Object.keys(this._selected).filter((pKey) => this._selected[pKey]).length; }

	/** Recompute the stats line + the Delete button's enabled state. */
	updateStats()
	{
		const tmpSelectedIDs = Object.keys(this._selected).filter((pKey) => this._selected[pKey]);
		const tmpCount = tmpSelectedIDs.length;
		let tmpStats = `<strong>${tmpCount}</strong> selected to delete`;
		if (this._mode === 'Advanced')
		{
			const tmpMissing = tmpSelectedIDs.filter((pKey) => (this._replacement[pKey] === undefined || this._replacement[pKey] === null || this._replacement[pKey] === '')).length;
			if (tmpMissing > 0) { tmpStats += ` &middot; ${tmpMissing} still need a replacement`; }
		}
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Stats`, tmpStats);
		const tmpButtonElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Delete`);
		if (tmpButtonElements && tmpButtonElements.length > 0)
		{
			tmpButtonElements[0].disabled = (tmpCount < 1);
		}
	}

	/**
	 * Delete the selected records (confirm via the host modal). In Advanced mode, each record's
	 * relationships are repointed to its chosen replacement first, and the record is deleted only when the
	 * repoint has zero failures (there are no DB transactions, so a partial repoint must not orphan rows).
	 * @return {Promise<void>}
	 */
	async confirmBulkDelete()
	{
		const tmpSelectedIDs = Object.keys(this._selected).filter((pKey) => this._selected[pKey]);
		if (tmpSelectedIDs.length < 1)
		{
			return;
		}
		const tmpAdvanced = (this._mode === 'Advanced');

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpMessage = tmpAdvanced
				? `Reassign related records and delete ${tmpSelectedIDs.length} ${this._recordLabel()}? This cannot be undone.`
				: `Delete ${tmpSelectedIDs.length} ${this._recordLabel()}? This cannot be undone.`;
			const tmpOk = await tmpModal.confirm(tmpMessage,
				{ title: 'Delete', confirmLabel: `Delete ${tmpSelectedIDs.length}`, cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}

		let tmpDeleted = 0;
		let tmpFailed = 0;
		let tmpBlocked = 0;
		for (let i = 0; i < tmpSelectedIDs.length; i++)
		{
			const tmpID = tmpSelectedIDs[i];
			const tmpRecord = this._recordsByID[tmpID];
			if (!tmpRecord)
			{
				tmpFailed++;
				continue;
			}
			if (tmpAdvanced)
			{
				const tmpTo = this._replacement[tmpID];
				if (tmpTo === undefined || tmpTo === null || tmpTo === '' || String(tmpTo) === String(tmpID))
				{
					// No (usable) replacement chosen — skip rather than silently orphan or delete unremapped.
					tmpBlocked++;
					continue;
				}
				const tmpRepoint = await this.pict.PictSectionRecordSet.repointRecordRelationships(this._recordSet, tmpID, tmpTo);
				if (tmpRepoint.failed > 0)
				{
					// A relationship failed to move — do NOT delete (it would orphan the un-moved rows).
					tmpFailed++;
					this.pict.log.error(`BulkDelete: repoint for ${this._recordSet} ${tmpID} -> ${tmpTo} had ${tmpRepoint.failed} failure(s); skipping delete.`);
					continue;
				}
			}
			try
			{
				await this.provider.deleteRecord(tmpRecord);
				delete this._selected[tmpID];
				delete this._replacement[tmpID];
				tmpDeleted++;
			}
			catch (pError)
			{
				tmpFailed++;
				this.pict.log.error(`BulkDelete: delete failed for ${this._recordSet} ${tmpID}.`, pError);
			}
		}

		this._toast(`Deleted ${tmpDeleted}${tmpFailed > 0 ? `, ${tmpFailed} failed` : ''}${tmpBlocked > 0 ? `, ${tmpBlocked} skipped (no replacement)` : ''}.`,
			(tmpFailed > 0 || tmpBlocked > 0) ? 'error' : 'success');

		// The single-record advanced flow returns to the list once its record is gone.
		if (this._presetRecordID && tmpDeleted > 0)
		{
			this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${this._recordSet}/List`);
			return;
		}

		await this._fetchPage(true);
		this._renderTable();
		if (this._mode === 'Advanced') { this._renderReassign(); }
		this.updateStats();
	}

	// --- Column chooser (mirrors the associate screens) ---

	/** Open/close the column chooser. */
	toggleColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (!tmpWrapElements || tmpWrapElements.length < 1) { return; }
		if (tmpWrapElements[0].classList.contains('is-open'))
		{
			tmpWrapElements[0].classList.remove('is-open');
			return;
		}
		this._renderColumnChooser();
		tmpWrapElements[0].classList.add('is-open');
	}

	/** Close the column chooser (backdrop outside-click). */
	closeColumnChooser()
	{
		const tmpWrapElements = this.pict.ContentAssignment.getElement(`#${this.safeKey}_Chooser_Wrap`);
		if (tmpWrapElements && tmpWrapElements.length > 0)
		{
			tmpWrapElements[0].classList.remove('is-open');
		}
	}

	/** Render the chooser rows. */
	_renderColumnChooser()
	{
		const tmpRows = this._columns().map((pCol) => ({ Key: pCol.Key, DisplayName: pCol.DisplayName, Visible: this._isColumnVisible(pCol) }));
		const tmpHTML = this.pict.parseTemplateByHash('PRSP-BulkDelete-Chooser', { Rows: tmpRows });
		this.pict.ContentAssignment.assignContent(`#${this.safeKey}_Chooser`, tmpHTML);
	}

	/** Toggle one column's visibility (persisted; refuses to hide the last visible column). @param {string} pKey */
	toggleColumn(pKey)
	{
		if (!this.columnProvider) { return; }
		const tmpCol = this._columns().find((pCol) => String(pCol.Key) === String(pKey));
		if (!tmpCol) { return; }
		const tmpVisible = this._isColumnVisible(tmpCol);
		if (tmpVisible && this._visibleColumns().length <= 1) { return; }
		this.columnProvider.setColumnVisibilityOverride(this._columnScope(), 'BulkDelete', pKey, !tmpVisible);
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Clear column overrides — back to developer defaults. */
	resetColumns()
	{
		if (this.columnProvider) { this.columnProvider.clearColumnVisibilityOverrides(this._columnScope(), 'BulkDelete'); }
		this._renderTable();
		this._renderColumnChooser();
	}

	/** Crude singularizer ("Books" -> "Book"). */
	_singular(pLabel)
	{
		return (typeof pLabel === 'string' && pLabel.length > 1 && pLabel.slice(-1).toLowerCase() === 's') ? pLabel.slice(0, -1) : pLabel;
	}

	/** Non-blocking notification via the host modal's toast, when available. */
	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'info' });
		}
	}
}

module.exports = viewRecordSetBulkDelete;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_BulkDelete;

},{"pict-view":1053}],999:[function(require,module,exports){
module.exports={
	"ViewIdentifier": "RecordSet-Error-NotFound-View",

	"DefaultRenderable": "RecordSet-Error-NotFound",
	"DefaultDestinationAddress": "#PRSP_Container",

	"AutoRender": false,

	"Templates":
	[
		{
			"Hash": "RecordSet-Error-NotFound-Content",
			"Template": "<div class=\"header\"><h1>404 - Our Legal Contract is <em>Your</em> Legal Contract</h1><h2>Feel safe in a space where nobody breaks the rules.</h2></div> <div class=\"content\"> <h2 class=\"content-subhead\">A Binding Agreement</h2><p>By using our postcard sending site, you agree to abide by the following terms and conditions:</p> <h2 class=\"content-subhead\">Intellectual Property Rights</h2><p>All content, including but not limited to text, images, graphics, logos, and software, provided on our site is the property of our company or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, or otherwise use any content without the prior written consent of the respective owners.</p> <h2 class=\"content-subhead\">User Content</h2><p>By uploading or submitting any content (such as text, images, or personal information) to our site, you grant us a worldwide, royalty-free, non-exclusive license to use, reproduce, modify, adapt, publish, translate, and distribute such content for the purpose of providing our services. You represent and warrant that you have the necessary rights to grant us this license.</p> <h2 class=\"content-subhead\">Privacy Policy</h2><p> We are committed to protecting your privacy. Our Privacy Policy outlines how we collect, use, and disclose your personal information. By using our site, you consent to the collection, use, and disclosure of your information as described in our Privacy Policy.</p> <h2 class=\"content-subhead\">Limitation of Liability</h2><p> We make every effort to ensure the accuracy and reliability of the information provided on our site. However, we cannot guarantee that our site will be error-free, uninterrupted, or free of viruses or other harmful components. In no event shall we be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with your use of our site.</p> <h2 class=\"content-subhead\">Governing Law</h2><p> These terms and conditions shall be governed by and construed in accordance with the laws of the world, without regard to its conflict of law provisions. Any disputes arising out of or relating to these terms and conditions shall be subject to the exclusive jurisdiction of the courts of the world.</p> <p>By using our postcard sending site, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. If you do not agree to these terms and conditions, please refrain from using our site.</p></div>"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "RecordSet-Error-NotFound",
			"TemplateHash": "RecordSet-Error-NotFound-Content"
		}
	]
}

},{}],1000:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

class ViewRecordSetSUBSETFilterBaseRange extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseAddress = pRecord.ClauseValuesAddress + '.Start';
		pRecord.EndClauseAddress = pRecord.ClauseValuesAddress + '.End';

		pRecord.StartClauseDescriptor =
		{
			Hash: this.fable.DataFormat.sanitizeObjectKey(`${pRecord.Hash}_Start`),
			Address: pRecord.StartClauseAddress,
			//TODO: figure out a nice pattern for extracting a name for the field from the filter - and allow the filter author to provide the label here
			Name: pRecord.MinimumLabel || `Minimum ${pRecord.ExternalFilterByColumn || pRecord.ExternalFilterByColumns?.[0] || pRecord.FilterByColumn || pRecord.FilterByColumns?.[0] || 'Value'}`,
			DataType: pRecord.DataType || 'String',
			PictForm: pRecord.PictForm || {},
		};

		pRecord.EndClauseDescriptor =
		{
			Hash: this.fable.DataFormat.sanitizeObjectKey(`${pRecord.Hash}_End`),
			Address: pRecord.EndClauseAddress,
			Name: pRecord.MaximumLabel || `Maximum ${pRecord.ExternalFilterByColumn || pRecord.ExternalFilterByColumns?.[0] || pRecord.FilterByColumn || pRecord.FilterByColumns?.[0] || 'Value'}`,
			DataType: pRecord.DataType || 'String',
			PictForm: pRecord.PictForm || {},
		};
	}
}

module.exports = ViewRecordSetSUBSETFilterBaseRange;

},{"./RecordSet-Filter-Base":1001}],1001:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_SUBSET_Filter =
{
	ViewIdentifier: 'PRSP-FilterType-Base',

	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	// Themeable filter-clause chrome. Every filter type renders through the shared
	// PRSP-Filter-Base-Template wrapper below (each type only plugs in its own value
	// input via getFilterFormTemplate()), so styling it here themes every clause for
	// every host app. This view (PRSP-FilterType-Base) is always constructed, and
	// pict-view registers a view's CSS into the global cascade at construction, so
	// these rules apply to all clauses regardless of which type rendered them.
	//
	// Host apps brand by defining the --theme-color-* tokens; the hardcoded values are
	// sensible fallbacks. CSS-first: native <select>s are de-nativized with
	// appearance:none + a custom chevron rather than swapped for a combobox widget
	// (that is a later upgrade with cross-browser quirks of its own).
	CSS: /*css*/`
.prsp-filters-clauses { display: flex; flex-direction: column; gap: 0.5rem; }

.prsp-filter { display: flex; align-items: flex-end; gap: 0.5rem; }
.prsp-filter *, .prsp-filter *::before, .prsp-filter *::after { box-sizing: border-box; }
.prsp-filter-body { flex: 1 1 auto; min-width: 0; display: flex; flex-wrap: wrap; align-items: flex-end; gap: 0.4rem 0.75rem; }

/* Inputs rendered by pict-section-form inside a clause. Match the consolidated
   control's search box so clauses stop looking like bare native controls. */
.prsp-filter label { font: inherit; font-size: 0.78rem; font-weight: 600; display: block;
	margin: 0 0 0.2rem; color: var(--theme-color-text-secondary, #45505f); }
.prsp-filter input, .prsp-filter select, .prsp-filter textarea { font: inherit; font-size: 0.92rem; width: 100%;
	padding: 0.45rem 0.7rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.prsp-filter input:focus, .prsp-filter select:focus, .prsp-filter textarea:focus { outline: none;
	border-color: var(--theme-color-brand-primary, #156dd1);
	box-shadow: 0 0 0 3px color-mix(in srgb, var(--theme-color-brand-primary, #156dd1) 16%, transparent); }
/* De-nativize the <select>: drop the platform arrow, add a themed chevron + room for it. */
.prsp-filter select { appearance: none; -webkit-appearance: none; -moz-appearance: none; cursor: pointer;
	padding-right: 1.9rem;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7686' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
	background-repeat: no-repeat; background-position: right 0.6rem center; background-size: 1.05em; }

/* Remove (trash) control — one per clause, inherited by every filter type. */
.prsp-filter-remove { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
	width: 2.05rem; height: 2.05rem; padding: 0; cursor: pointer; line-height: 1;
	border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-muted, #6b7686); }
.prsp-filter-remove:hover { border-color: var(--theme-color-status-error, #d64545); color: var(--theme-color-status-error, #d64545);
	background: color-mix(in srgb, var(--theme-color-status-error, #d64545) 12%, transparent); }
.prsp-filter-remove .pict-icon { font-size: 1.05rem; }
`,
	CSSPriority: 500,

	Manifests: {},

	DefaultRenderable: 'PRSP_Renderable_Filter_Base',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-Base-Form',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-Base-Form] -->
	{~DJ:Record~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-Base-Form] -->
`
		},
		{
			// The shared clause wrapper for every filter type. The type view plugs its own
			// value input in via getFilterFormTemplate(); the themed remove control is
			// inherited here (calls the base removeClause() method, reached through the
			// always-registered PRSP-FilterType-<Type> view) so no host app re-implements one.
			Hash: 'PRSP-Filter-Base-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-Base-Template] -->
	<div class="prsp-filter" id="PRSP_Filter_Container_{~D:Record.Hash~}" data-i-filter-hash="{~D:Record.Hash~}">
		{~TBR:Context[0].getClauseBodyTemplate()~}
		<button type="button" class="prsp-filter-remove" title="Remove this filter" aria-label="Remove this filter"
			onclick="_Pict.views['PRSP-FilterType-{~D:Record.Type~}'].removeClause(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}', '{~D:Record.Hash~}');">
			{~I:Trash~}
		</button>
	</div>
	<!-- DefaultPackage end view template:	[PRSP-Filter-Base-Template] -->
`
		},
		{
			// Clause body as its own form, so Enter in any of its inputs commits the value (the browser
			// fires change before submit) and then applies the search. Ids are namespaced by clause hash,
			// and the hidden submit is bound to this form by id, so it can never submit a form the clause
			// does not own — e.g. a host form the filters were rendered inside.
			Hash: 'PRSP-Filter-Base-Body-Form',
			Template: /*html*/`
		<form class="prsp-filter-body" id="PRSP_Filter_Clause_Form_{~D:Record.Hash~}"
			onsubmit="event.preventDefault(); event.stopPropagation(); _Pict.views['PRSP-Filters'].handleSearch(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}'); return false;">
			{~TBR:Context[0].getFilterFormTemplate()~}
			<button type="submit" id="PRSP_Filter_Clause_Submit_{~D:Record.Hash~}" form="PRSP_Filter_Clause_Form_{~D:Record.Hash~}" hidden tabindex="-1" aria-hidden="true"></button>
		</form>
`
		},
		{
			// Clause body for types that render a form of their own inside it (forms cannot nest).
			Hash: 'PRSP-Filter-Base-Body',
			Template: /*html*/`
		<div class="prsp-filter-body">
			{~TBR:Context[0].getFilterFormTemplate()~}
		</div>
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Filter_Base',
			TemplateHash: 'PRSP-Filter-Base-Template',
			DestinationAddress: '#PRSP_Filter_Base_Container',
			RenderMethod: 'replace',
		}
	],
};

class ViewRecordSetSUBSETFilterBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_SUBSET_Filter, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Hook to prepare state on the render record before rendering.
	 *
	 * @param {Record<string, any>} pRecord - The record used for view rendering.
	 */
	prepareRecord(pRecord)
	{
		pRecord.ClauseValueAddress = pRecord.ClauseAddress + '.Value';
		pRecord.ClauseValuesAddress = pRecord.ClauseAddress + '.Values';

		pRecord.ClauseDescriptor =
		{
			Address: pRecord.ClauseValueAddress,
			Hash: this.fable.DataFormat.sanitizeObjectKey(pRecord.Hash),
			//TODO: figure out a nice pattern for extracting a name for the field from the filter - and allow the filter author to provide the label here
			Name: pRecord.Label || pRecord.ExternalFilterByColumn || pRecord.ExternalFilterByColumns?.[0] || pRecord.FilterByColumn || pRecord.FilterByColumns?.[0] || 'Value',
			DataType: pRecord.DataType || 'String',
			PictForm: pRecord.PictForm || {},
		};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-Base-Form';
	}

	/**
	 * The template hash for the clause body that wraps getFilterFormTemplate(). A type whose own
	 * template contains a <form> overrides this to return 'PRSP-Filter-Base-Body'.
	 *
	 * @return {string}
	 */
	getClauseBodyTemplate()
	{
		return 'PRSP-Filter-Base-Body-Form';
	}

	/**
	 * Remove this filter clause from its record set and re-render the filter control.
	 *
	 * Lives on the base view so every filter type inherits a single, themeable remove
	 * affordance and no host application has to re-implement one. Delegates to the
	 * consolidated control view (the canonical re-render path) and falls back to the
	 * record-set provider directly if that view is somehow unavailable.
	 *
	 * @param {Event} pEvent - The DOM event that triggered the removal.
	 * @param {string} pRecordSet - The record set being filtered.
	 * @param {string} pViewContext - The view context for the filter (e.g. List, Dashboard).
	 * @param {string} pHash - The hash of the specific filter clause to remove.
	 */
	removeClause(pEvent, pRecordSet, pViewContext, pHash)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
		}
		const tmpFiltersView = this.pict.views['PRSP-Filters'];
		if (tmpFiltersView && typeof tmpFiltersView.removeFilter === 'function')
		{
			return tmpFiltersView.removeFilter(pEvent, pRecordSet, pViewContext, pHash);
		}
		// Fallback: the consolidated control view isn't present, so remove directly.
		const tmpProvider = this.pict.providers[`RSP-Provider-${pRecordSet}`];
		if (tmpProvider && typeof tmpProvider.removeFilterClause === 'function')
		{
			tmpProvider.removeFilterClause(pHash);
		}
	}

	/**
	 * @return {string} - The prefix for the informary address.
	 */
	getInformaryAddressPrefix()
	{
		return this.pict.views['PRSP-Filters'].getInformaryAddressPrefix();
	}

	/**
	 * @param {string} pInformaryAddress - The address of the informary to get the value from.
	 *
	 * @return {any} - The value at the informary address.
	 */
	getInformaryScopedValue(pInformaryAddress)
	{
		return this.pict.views['PRSP-Filters'].getInformaryScopedValue(pInformaryAddress);
	}
}

module.exports = ViewRecordSetSUBSETFilterBase;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_SUBSET_Filter;

},{"pict-view":1053}],1002:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/**
 * BooleanMatch — a Yes / No filter for boolean columns. A boolean is stored as 0/1, so under
 * the hood the clause is an exact NumericMatch (`Type: 'NumericMatch'`, `ExactMatch: true`),
 * which pict's Filter.js compiles to `FBV(OR)~<col>~EQ~<0|1>` with no new compile-path type.
 * The clause only differs in how it is *rendered*: the generator tags it
 * `FilterRenderType: 'BooleanMatch'` so the FilterInstanceViews template routes it here (a
 * Yes/No <select>) instead of the numeric text box — see Pict-Template-FilterInstanceViews.
 *
 * Staging only: changing the dropdown mutates the live clause's `Values` but does NOT fire a
 * search — the user commits with Apply / Search (the stage-then-Apply contract, matching the
 * other filter views).
 */
const _DEFAULT_CONFIGURATION_Filter_BooleanMatch =
{
	ViewIdentifier: 'PRSP-FilterType-BooleanMatch',

	CSS: /*css*/`
.prsp-filter-boolean { min-width: 8rem; }
`,

	Templates:
	[
		{
			Hash: 'PRSP-Filter-BooleanMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-BooleanMatch-Template] -->
	<div class="prsp-filter-boolean">
		<label>{~D:Record.Label~}</label>
		<select aria-label="{~D:Record.Label~}"
			onchange="_Pict.views['PRSP-FilterType-BooleanMatch'].selectValue(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}', this.value)">
			<option value="" {~D:Record.BooleanAnySelected~}>Any</option>
			<option value="1" {~D:Record.BooleanYesSelected~}>Yes</option>
			<option value="0" {~D:Record.BooleanNoSelected~}>No</option>
		</select>
	</div>
	<!-- DefaultPackage end view template: [PRSP-Filter-BooleanMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterBooleanMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		// The current selection comes off the live clause's Values (Value as a fallback for
		// clauses restored from an older-shaped filter experience). '' => Any (no constraint).
		const tmpCurrent = (Array.isArray(pRecord.Values) && (pRecord.Values.length > 0)) ? String(pRecord.Values[0])
			: ((pRecord.Value !== undefined && pRecord.Value !== null) ? String(pRecord.Value) : '');
		pRecord.BooleanAnySelected = (tmpCurrent === '') ? 'selected' : '';
		pRecord.BooleanYesSelected = (tmpCurrent === '1') ? 'selected' : '';
		pRecord.BooleanNoSelected = (tmpCurrent === '0') ? 'selected' : '';
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-BooleanMatch-Template';
	}

	/**
	 * Stage the Yes/No selection onto the live clause. '' clears the constraint (Any); '1'/'0'
	 * set an exact match. Staging only — the search fires on Apply / Search, not here.
	 *
	 * @param {Event} pEvent
	 * @param {string} pClauseInformaryAddress
	 * @param {string} pClauseHash
	 * @param {string} pValue - '' | '1' | '0'
	 */
	selectValue(pEvent, pClauseInformaryAddress, pClauseHash, pValue)
	{
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			this.pict.log.error(`[Filter-BooleanMatch] No clause found for address: ${pClauseInformaryAddress}`);
			return;
		}
		if (pValue === '' || pValue === null || pValue === undefined)
		{
			tmpClause.Values = [];
			delete tmpClause.Value;
		}
		else
		{
			tmpClause.Values = [ pValue ];
			tmpClause.Value = pValue;
		}
	}
}

module.exports = ViewRecordSetSUBSETFilterBooleanMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterBase.default_configuration, _DEFAULT_CONFIGURATION_Filter_BooleanMatch);

},{"./RecordSet-Filter-Base":1001}],1003:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_DateMatch =
{
	ViewIdentifier: 'PRSP-FilterType-DateMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-DateMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-DateMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-DateMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterDateMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Hook to prepare state on the render record before rendering.
	 *
	 * @param {Record<string, any>} pRecord - The record used for view rendering.
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-DateMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterDateMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterDateMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_DateMatch);

},{"./RecordSet-Filter-Base":1001}],1004:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_DateRange =
{
	ViewIdentifier: 'PRSP-FilterType-DateRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-DateRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-DateRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-DateRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterDateRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	/**
	 * FIXME: this be wrong
	 *
	 * @param {(error?: Error) => void} fCallback
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		return super.onBeforeInitializeAsync((pError) =>
		{
			/** @type {import('pict/types/source/filters/FilterClauseLocal')} */
			//this.filter = this.addFilterClauseType('DateRange');

			return fCallback(pError);
		});
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-DateRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterDateRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterDateRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_DateRange);


},{"./RecordSet-Filter-Base-Range.js":1000}],1005:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/**
 * DistinctSelectedValueList — a dropdown/checkbox filter whose options ARE the distinct
 * values of a column on the CORE entity (no join), fetched from Meadow's
 * `<Entity>s/Distinct/<Column>` endpoint through the recordset provider's cached
 * `getRecordSetColumnDistinct()`. The clause's `Values` array holds the selection; pict's
 * Filter.js compiles it to an OR-chain of `FBVOR~<col>~EQ~<value>` stanzas inside one
 * paren group.
 *
 * Clause config:
 *   - FilterByColumn {string} - the core-entity column the options come from / filter on.
 *   - Options {Array<any>} - optional STATIC option list; when present the distinct fetch is skipped.
 *   - DistinctFilter {string} - optional FoxHound stanza appended as `/FilteredTo/<...>` on the
 *     distinct query (e.g. `FBV~Deleted~EQ~0` to keep soft-deleted rows' values out of the list).
 *
 * Selected values missing from the option list (e.g. restored from a saved filter experience
 * whose value no longer appears in the data) are unioned in so they stay visible and
 * un-checkable. Selection toggles by option INDEX, never by value — values can contain
 * quotes that would break inline onclick attributes.
 *
 * Staging only: toggling checkboxes mutates the live clause but does NOT fire a search —
 * the user commits with Apply / Search (the stage-then-Apply contract).
 */
const _DEFAULT_CONFIGURATION_Filter_DistinctSelectedValueList =
{
	ViewIdentifier: 'PRSP-FilterType-DistinctSelectedValueList',

	CSS: /*css*/`
.prsp-filter-distinct { min-width: 12rem; }
.prsp-filter-distinct-options { display: flex; flex-direction: column; gap: 0.15rem; max-height: 11rem; overflow-y: auto;
	padding: 0.35rem 0.5rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3);
	background: var(--theme-color-background-primary, #fff); }
.prsp-filter-distinct-option { display: flex; align-items: center; gap: 0.45rem; cursor: pointer;
	font-size: 0.92rem; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.prsp-filter-distinct-option input[type="checkbox"] { width: auto; margin: 0; cursor: pointer; }
.prsp-filter-distinct-note { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0; }
`,

	Templates:
	[
		{
			Hash: 'PRSP-Filter-DistinctSelectedValueList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-DistinctSelectedValueList-Template] -->
	<div class="prsp-filter-distinct">
		<label>{~D:Record.Label~}</label>
		<div class="prsp-filter-distinct-options">
			{~TS:PRSP-Filter-Distinct-Loading:Record.DistinctLoading~}
			{~TS:PRSP-Filter-Distinct-Empty:Record.DistinctEmpty~}
			{~TSWP:PRSP-Filter-Distinct-Option:Record.DistinctOptions:Record~}
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-Filter-DistinctSelectedValueList-Template] -->
`
		},
		{
			Hash: 'PRSP-Filter-Distinct-Option',
			Template: /*html*/`
	<label class="prsp-filter-distinct-option">
		<input type="checkbox" {~D:Record.Data.CheckedAttribute~}
			onchange="_Pict.views['PRSP-FilterType-DistinctSelectedValueList'].toggleOption(event, '{~D:Record.Payload.ClauseAddress~}', '{~D:Record.Payload.Hash~}', {~D:Record.Data.OptionIndex~})">
		<span>{~D:Record.Data.Text~}</span>
	</label>
`
		},
		{
			Hash: 'PRSP-Filter-Distinct-Loading',
			Template: /*html*/`
	<span class="prsp-filter-distinct-note">Loading values…</span>
`
		},
		{
			Hash: 'PRSP-Filter-Distinct-Empty',
			Template: /*html*/`
	<span class="prsp-filter-distinct-note">No values available.</span>
`
		},
	],
};

class ViewRecordSetSUBSETFilterDistinctSelectedValueList extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-DistinctSelectedValueList-Template';
	}

	/**
	 * The ordered raw option values for a clause: the static `Options` list when configured,
	 * else the provider's cached distinct values, with any selected values missing from the
	 * list unioned onto the end.
	 *
	 * @param {Record<string, any>} pClause
	 * @param {Record<string, any>} pProvider - The recordset provider (`RSP-Provider-<RecordSet>`).
	 * @return {Array<any>}
	 */
	_optionValues(pClause, pProvider)
	{
		let tmpValues = Array.isArray(pClause.Options) ? pClause.Options.slice() : null;
		if (!tmpValues)
		{
			const tmpCacheKey = this._distinctCacheKey(pClause, pProvider);
			const tmpCached = (pProvider && pProvider._scopeDistinctCache) ? pProvider._scopeDistinctCache[tmpCacheKey] : null;
			tmpValues = Array.isArray(tmpCached) ? tmpCached.slice() : [];
		}
		if (Array.isArray(pClause.Values))
		{
			for (const tmpSelected of pClause.Values)
			{
				if (!tmpValues.some((pValue) => pValue === tmpSelected))
				{
					tmpValues.push(tmpSelected);
				}
			}
		}
		return tmpValues;
	}

	/**
	 * This clause's static `DistinctFilter` narrowed by the current selection of every field named
	 * in `CascadeFrom` — the same rule the quick-filter bar applies, so the drawer control and the
	 * quick control always offer the same option list for a field. A parent with nothing selected
	 * narrows nothing.
	 *
	 * @param {Record<string, any>} pClause @param {Record<string, any>} pProvider
	 * @return {string} The FoxHound filter stanza chain, or '' for no filter.
	 */
	_resolveDistinctFilter(pClause, pProvider)
	{
		let tmpFilter = pClause.DistinctFilter || '';
		const tmpParentFields = Array.isArray(pClause.CascadeFrom) ? pClause.CascadeFrom : [];
		if ((tmpParentFields.length === 0) || !pProvider || (typeof pProvider.getQuickFilterEntityValue !== 'function'))
		{
			return tmpFilter;
		}
		for (const tmpParentField of tmpParentFields)
		{
			const tmpValues = pProvider.getQuickFilterEntityValue(tmpParentField);
			if (!Array.isArray(tmpValues) || (tmpValues.length === 0)) { continue; }
			// A value carrying a comma would split the IN list, so those are skipped.
			const tmpUsable = tmpValues.filter((pValue) => String(pValue).indexOf(',') === -1);
			if (tmpUsable.length === 0) { continue; }
			tmpFilter += `${tmpFilter ? '~' : ''}FBL~${tmpParentField}~INN~${tmpUsable.join(',')}`;
		}
		return tmpFilter;
	}

	/**
	 * The provider cache key for this clause's distinct values. The resolved filter is part of the
	 * key, so each parent selection caches on its own and going back to a previous one is instant.
	 *
	 * @param {Record<string, any>} pClause @param {Record<string, any>} pProvider
	 * @return {string}
	 */
	_distinctCacheKey(pClause, pProvider)
	{
		const tmpFilter = this._resolveDistinctFilter(pClause, pProvider);
		return tmpFilter ? `${pClause.FilterByColumn}::${tmpFilter}` : pClause.FilterByColumn;
	}

	/**
	 * Map the option values to render rows ({ Text, OptionIndex, CheckedAttribute }).
	 *
	 * @param {Record<string, any>} pClause
	 * @param {Record<string, any>} pProvider
	 * @return {Array<{ Text: string, OptionIndex: number, CheckedAttribute: string }>}
	 */
	_composeOptionList(pClause, pProvider)
	{
		const tmpSelected = Array.isArray(pClause.Values) ? pClause.Values : [];
		return this._optionValues(pClause, pProvider).map((pValue, pIndex) => (
		{
			Text: String(pValue),
			OptionIndex: pIndex,
			CheckedAttribute: tmpSelected.some((pSelectedValue) => pSelectedValue === pValue) ? 'checked' : '',
		}));
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		const tmpProvider = this.pict.providers['RSP-Provider-' + pRecord.RecordSet];
		pRecord.DistinctLoading = [];
		// No static Options: make sure the distinct values are fetched (cached on the provider),
		// re-rendering just this clause's container once they resolve. Errored fetches cache []
		// so this can't loop.
		if (!Array.isArray(pRecord.Options) && pRecord.FilterByColumn
			&& tmpProvider && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
		{
			const tmpCacheKey = this._distinctCacheKey(pRecord, tmpProvider);
			if (!tmpProvider._scopeDistinctCache || !Array.isArray(tmpProvider._scopeDistinctCache[tmpCacheKey]))
			{
				pRecord.DistinctLoading = [ {} ];
				const tmpClauseAddress = pRecord.ClauseAddress;
				const tmpClauseHash = pRecord.Hash;
				tmpProvider.getRecordSetColumnDistinct(pRecord.FilterByColumn, { Filter: this._resolveDistinctFilter(pRecord, tmpProvider) },
					() => this._reRenderClause(tmpClauseAddress, tmpClauseHash));
			}
		}
		pRecord.DistinctOptions = this._composeOptionList(pRecord, tmpProvider);
		pRecord.DistinctEmpty = (pRecord.DistinctLoading.length === 0 && pRecord.DistinctOptions.length === 0) ? [ {} ] : [];
	}

	/**
	 * Toggle an option's membership in the live clause's `Values` by option index. Staging
	 * only — the search fires on Apply / Search, not here.
	 *
	 * @param {Event} pEvent
	 * @param {string} pClauseInformaryAddress
	 * @param {string} pClauseHash
	 * @param {number} pOptionIndex
	 */
	toggleOption(pEvent, pClauseInformaryAddress, pClauseHash, pOptionIndex)
	{
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			this.pict.log.error(`[Filter-DistinctSelectedValueList] No clause found for address: ${pClauseInformaryAddress}`);
			return;
		}
		const tmpProvider = this.pict.providers['RSP-Provider-' + tmpClause.RecordSet];
		const tmpOptionValues = this._optionValues(tmpClause, tmpProvider);
		if (pOptionIndex < 0 || pOptionIndex >= tmpOptionValues.length)
		{
			return;
		}
		const tmpValue = tmpOptionValues[pOptionIndex];
		if (!Array.isArray(tmpClause.Values))
		{
			tmpClause.Values = [];
		}
		const tmpSelectedIndex = tmpClause.Values.findIndex((pSelectedValue) => pSelectedValue === tmpValue);
		if (tmpSelectedIndex >= 0)
		{
			tmpClause.Values.splice(tmpSelectedIndex, 1);
		}
		else
		{
			tmpClause.Values.push(tmpValue);
		}
		this._reRenderClause(pClauseInformaryAddress, pClauseHash);
	}

	/**
	 * Re-render this clause's container (the checkbox list repaints on toggle / fetch resolve).
	 *
	 * @param {string} pClauseInformaryAddress
	 * @param {string} pClauseHash
	 */
	_reRenderClause(pClauseInformaryAddress, pClauseHash)
	{
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			return;
		}
		const tmpRecord = Object.assign({ ClauseAddress: pClauseInformaryAddress }, tmpClause);
		this.prepareRecord(tmpRecord);
		this.render(null, `#PRSP_Filter_Container_${pClauseHash}`, tmpRecord);
	}
}

module.exports = ViewRecordSetSUBSETFilterDistinctSelectedValueList;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterBase.default_configuration, _DEFAULT_CONFIGURATION_Filter_DistinctSelectedValueList);

},{"./RecordSet-Filter-Base":1001}],1006:[function(require,module,exports){
const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/**
 * Shared base for the four entity-reference filter types — Internal/External join × single/list.
 *
 * These were ~95% duplicate views, each with the same bespoke "search results | selection" table UI
 * and identical search/add/remove logic. This base consolidates all of it. Subclasses supply only the
 * two seams that actually differ:
 *   - `getSearchEntity(pClause)` — internal join searches `RemoteTable`, external `ExternalFilterByTable`.
 *   - `isMultiSelect()` — the `…List` variants append; the plain `…SelectedValue` variants replace.
 *
 * Rendering uses the same mechanism as before (the input template is emitted during the clause's
 * template parse, via `getFilterFormTemplate()`), so the consolidation is behavior-preserving. The
 * input template is itself a seam (`getEntityInputTemplate()`) so a host can swap the table UI for a
 * picker-backed input (a pict-section-form `Picker` InputType) without the module changing.
 *
 * Host-injected contextual scoping rides through `getContextScopeFilter(pClause)` — extra FoxHound
 * stanzas AND-applied to the entity search (project / spec-year / …). The module never learns what
 * those contexts mean; the host overrides the hook to read its own app state.
 */
const _DEFAULT_CONFIGURATION_EntityReference =
{
	ViewIdentifier: 'PRSP-FilterType-EntityReference-Base',

	// When set (by a host), entity clauses delegate their input to this pict-section-form InputType
	// (rendered via {~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}) instead of the built-in
	// table UI — e.g. 'Picker' to use pict-section-picker. Default false → the table UI.
	EntityInputType: false,

	Templates:
	[
		{
			// Table UI (default). Two cells: live search results | current selection.
			Hash: 'PRSP-Filter-EntityRef-Table',
			Template: /*html*/`
	<table><tbody><tr>
		<td valign="top">{~T:PRSP-Filter-EntityRef-SearchResults~}</td>
		<td valign="top">{~T:PRSP-Filter-EntityRef-SelectedValues~}</td>
	</tr></tbody></table>
`
		},
		{
			// Picker / form-input delegation (opt-in via EntityInputType). Renders one dynamic input
			// on the shared PSRSFilterProxyView from the clause's ClauseDescriptor (whose PictForm
			// InputType is stamped in prepareRecord). Bound to the clause's Values address.
			Hash: 'PRSP-Filter-EntityRef-Input',
			Template: /*html*/`
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SearchResults',
			Template: /*html*/`
	<form id="PRSP_Filter_{~D:Record.Hash~}_Search_Form" onsubmit="_Pict.views['{~D:Context[0].Hash~}'].performSearch(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}'); return false;">
		<input id="PRSP_Filter_{~D:Record.Hash~}_Search_Value" type="text" placeholder="Search..." value="{~D:Record.SearchInputValue~}" />
		<button type="submit" id="PRSP_Filter_{~D:Record.Hash~}_Button_Search" onclick="_Pict.views['{~D:Context[0].Hash~}'].performSearch(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}')">Search</button>
	</form>
	<table>
		<thead><tr><th colspan="2">{~D:Record.Label~}</th></tr></thead>
		<tbody>{~TSWP:PRSP-Filter-EntityRef-SearchResults-Entry:Record.SearchResults:Record~}</tbody>
	</table>
	<button type="button" id="PRSP_Filter_{~D:Record.Hash~}_Button_LoadMore" class="is-hidden" onclick="_Pict.views['{~D:Context[0].Hash~}'].loadMore(event, '{~D:Record.ClauseAddress~}', '{~D:Record.Hash~}', {~D:Record.SearchResultsOffset:0~})">Load More</button>
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SelectedValues',
			Template: /*html*/`
	<table>
		<thead><tr><th colspan="2">Selection</th></tr></thead>
		<tbody>{~TSWP:PRSP-Filter-EntityRef-SelectedValues-Entry:Record.SelectedValues:Record~}</tbody>
	</table>
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SearchResults-Entry',
			Template: /*html*/`
	<tr><td><button onclick="_Pict.views['{~D:Context[0].Hash~}'].handleAdd(event, {~DVBK:Record.Data:Record.Payload.ExternalFilterTableLookupColumn~}, '{~D:Record.Payload.ClauseAddress~}', '{~D:Record.Payload.Hash~}')">Select</button></td><td>{~TFA:Record.Payload.ExternalRecordDisplayTemplate:Record~}</td></tr>
`
		},
		{
			Hash: 'PRSP-Filter-EntityRef-SelectedValues-Entry',
			Template: /*html*/`
	<tr><td><button onclick="_Pict.views['{~D:Context[0].Hash~}'].handleRemove(event, {~DVBK:Record.Data:Record.Payload.ExternalFilterTableLookupColumn~}, '{~D:Record.Payload.ClauseAddress~}', '{~D:Record.Payload.Hash~}')">Remove</button></td><td>{~TFA:Record.Payload.ExternalRecordDisplayTemplate:Record~}</td></tr>
`
		},
	],
};

class ViewRecordSetSUBSETFilterEntityReferenceBase extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions.PageSize)
		{
			pOptions.PageSize = 15;
		}
		super(pFable, pOptions, pServiceHash);
	}

	// --- Seams the subclasses override (the only real differences between the 4 types) ---

	/** @param {Record<string, any>} pClause @return {string} The entity to search (RemoteTable / ExternalFilterByTable). */
	getSearchEntity(pClause)
	{
		return pClause.RemoteTable || pClause.ExternalFilterByTable;
	}

	/** @param {Record<string, any>} pClause @return {string} The value/ID column on the searched entity. */
	getLookupColumn(pClause)
	{
		return pClause.ExternalFilterTableLookupColumn || `ID${this.getSearchEntity(pClause)}`;
	}

	/** @return {boolean} True for the `…List` (multi-select) variants. */
	isMultiSelect()
	{
		return true;
	}

	/**
	 * Host-injectable contextual search scope. Returns extra FoxHound filter stanza(s) AND-applied to
	 * the entity search (e.g. "only this project's line items"). Default: the clause's static
	 * `ContextScopeFilter` if any, else none. Hosts override this to read app state — the module never
	 * learns what a "project" or "spec year" is.
	 *
	 * @param {Record<string, any>} pClause @return {string|Array<string>}
	 */
	getContextScopeFilter(pClause)
	{
		// ScopeToRecordSet knob: scope the entity search to the values present in the recordset's
		// data (FBL~<col>~INN~<distinct>), fetched + cached on the recordset provider. The first
		// search may be unscoped until the fetch resolves; subsequent searches are scoped.
		if (pClause && pClause.ScopeToRecordSet && pClause.FilterByColumn)
		{
			const tmpProvider = this.pict.providers['RSP-Provider-' + pClause.RecordSet];
			if (tmpProvider && typeof tmpProvider.getRecordSetColumnDistinct === 'function')
			{
				if (!tmpProvider._scopeDistinctCache || !Array.isArray(tmpProvider._scopeDistinctCache[pClause.FilterByColumn]))
				{
					tmpProvider.getRecordSetColumnDistinct(pClause.FilterByColumn, () => {});
				}
				const tmpVals = (tmpProvider._scopeDistinctCache || {})[pClause.FilterByColumn];
				if (Array.isArray(tmpVals) && tmpVals.length > 0)
				{
					return `FBL~${pClause.FilterByColumn}~INN~${tmpVals.join(',')}`;
				}
			}
		}
		return pClause.ContextScopeFilter || '';
	}

	/** @return {string} The template hash for the clause's value input (table UI, or the opt-in delegated input). */
	getFilterFormTemplate()
	{
		return this.options.EntityInputType ? 'PRSP-Filter-EntityRef-Input' : 'PRSP-Filter-EntityRef-Table';
	}

	/** @return {string} The clause body template: the table UI carries its own search form, so it can't sit in another. */
	getClauseBodyTemplate()
	{
		return this.options.EntityInputType ? super.getClauseBodyTemplate() : 'PRSP-Filter-Base-Body';
	}

	/** @param {Record<string, any>} pRecord */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.PictForm = Object.assign({}, pRecord.PictForm);
		if (this.options.EntityInputType)
		{
			// Delegated input: a csv string round-trips through the informary at `.StringArrayValue`,
			// while the picker adapter writes the real ARRAY to `.Values` (what Filter.js reads) via
			// ValueArrayAddress. Keeping the informary off `.Values` avoids a Number field defaulting it
			// to "0". The descriptor also carries everything the picker needs + the contextual scope hook.
			pRecord.ClauseDescriptor.Address = pRecord.ClauseAddress + '.StringArrayValue';
			pRecord.ClauseDescriptor.DataType = 'String';
			pRecord.ClauseDescriptor.PictForm.InputType = pRecord.ClauseDescriptor.PictForm.InputType || this.options.EntityInputType;
			pRecord.ClauseDescriptor.PictForm.Entity = pRecord.ClauseDescriptor.PictForm.Entity || this.getSearchEntity(pRecord);
			pRecord.ClauseDescriptor.PictForm.ValueField = pRecord.ClauseDescriptor.PictForm.ValueField || this.getLookupColumn(pRecord);
			pRecord.ClauseDescriptor.PictForm.Multiple = this.isMultiSelect();
			pRecord.ClauseDescriptor.PictForm.SearchFields = pRecord.ClauseDescriptor.PictForm.SearchFields
				|| pRecord.ExternalFilterByColumns || (pRecord.ExternalFilterByColumn ? [ pRecord.ExternalFilterByColumn ] : [ 'Name' ]);
			// Composed, disambiguated option/chip label (the entity's "list entry" template); falls back to a
			// single display field when unset.
			pRecord.ClauseDescriptor.PictForm.TextTemplate = pRecord.ClauseDescriptor.PictForm.TextTemplate || pRecord.EntityListEntryTemplate;
			pRecord.ClauseDescriptor.PictForm.ValueArrayAddress = pRecord.ClauseValuesAddress;
			pRecord.ClauseDescriptor.PictForm.GetContextScopeFilter = () => this.getContextScopeFilter(this.getInformaryScopedValue(pRecord.ClauseAddress) || pRecord);
			// JoinEntity compound display (host opt-in on the clause): show each searched row joined to a
			// parent entity's field — e.g. a LineItem disambiguated by its Project. The picker fetch-then-
			// merges the join (Meadow can't join in one read). Forwarded straight through; no-op when unset.
			if (pRecord.JoinEntity || pRecord.ClauseDescriptor.PictForm.JoinEntity)
			{
				const tmpPF = pRecord.ClauseDescriptor.PictForm;
				tmpPF.JoinEntity = tmpPF.JoinEntity || pRecord.JoinEntity;
				tmpPF.JoinField = tmpPF.JoinField || pRecord.JoinField;
				tmpPF.JoinEntityValueField = tmpPF.JoinEntityValueField || pRecord.JoinEntityValueField;
				tmpPF.JoinEntityDisplayField = tmpPF.JoinEntityDisplayField || pRecord.JoinEntityDisplayField;
				if (tmpPF.JoinEntityFirst === undefined && pRecord.JoinEntityFirst !== undefined) { tmpPF.JoinEntityFirst = pRecord.JoinEntityFirst; }
				if (tmpPF.JoinSeparator === undefined && pRecord.JoinSeparator !== undefined) { tmpPF.JoinSeparator = pRecord.JoinSeparator; }
			}
			// Saved-filter seeding: mirror the live clause's Values array into the csv `.StringArrayValue`
			// the input reads, so a reloaded/persisted filter shows its current selections on render.
			const tmpLiveClause = this.getInformaryScopedValue(pRecord.ClauseAddress);
			if (tmpLiveClause && Array.isArray(tmpLiveClause.Values))
			{
				tmpLiveClause.StringArrayValue = tmpLiveClause.Values.join(',');
			}
		}
		else
		{
			pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		}
		if (!pRecord.ExternalFilterTableLookupColumn)
		{
			pRecord.ExternalFilterTableLookupColumn = this.getLookupColumn(pRecord);
		}
		if (!pRecord.SearchResults) { pRecord.SearchResults = []; }
		if (!pRecord.SelectedValues) { pRecord.SelectedValues = []; }
	}

	// --- Table UI search/select methods (consolidated from the 4 legacy views) ---

	loadMore(pEvent, pClauseInformaryAddress, pClauseHash, pCurrentOffset = 0)
	{
		this.performSearch(pEvent, pClauseInformaryAddress, pClauseHash, pCurrentOffset + this.options.PageSize);
	}

	performSearch(pEvent, pClauseInformaryAddress, pClauseHash, pOffset = 0)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause)
		{
			this.pict.log.error(`[Filter-EntityReference] No clause found for address: ${pClauseInformaryAddress}`);
			return;
		}
		tmpClause.SearchResultsOffset = pOffset;
		const tmpSearchInputValue = pOffset > 0 ? tmpClause.SearchInputValue : this.pict.ContentAssignment.readContent(`#PRSP_Filter_${tmpClause.Hash}_Search_Value`);
		tmpClause.SearchInputValue = tmpSearchInputValue;
		if (!tmpSearchInputValue)
		{
			tmpClause.SearchResults = [];
			tmpClause.LoadMoreEnabled = false;
			this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
			return;
		}
		const tmpFilterByColumns = tmpClause.ExternalFilterByColumns || (tmpClause.ExternalFilterByColumn ? [ tmpClause.ExternalFilterByColumn ] : [ 'Name' ]);
		const tmpSearchStanza = tmpFilterByColumns.map((pColumn) => `FBVOR~${pColumn}~LK~${encodeURIComponent(`%${tmpSearchInputValue}%`)}`).join('~');
		const tmpScope = this.getContextScopeFilter(tmpClause);
		const tmpScopeStanza = Array.isArray(tmpScope) ? tmpScope.filter(Boolean).join('~') : tmpScope;
		const tmpMeadowFilter = [ tmpScopeStanza, tmpSearchStanza ].filter(Boolean).join('~');
		this.pict.EntityProvider.gatherDataFromServer(
			[
				{
					Entity: this.getSearchEntity(tmpClause),
					Filter: tmpMeadowFilter,
					Destination: pOffset > 0 ? `${this.getInformaryAddressPrefix()}${pClauseInformaryAddress}.SearchResultsAppend` : `${this.getInformaryAddressPrefix()}${pClauseInformaryAddress}.SearchResults`,
					RecordStartCursor: pOffset,
					PageSize: this.options.PageSize,
					URLPrefix: tmpClause.URLPrefix,
				}
			],
			() =>
			{
				if (pOffset > 0 && tmpClause.SearchResultsAppend?.length > 0)
				{
					tmpClause.SearchResults = tmpClause.SearchResults.concat(tmpClause.SearchResultsAppend);
				}
				const tmpLoadedRecords = pOffset > 0 ? tmpClause.SearchResultsAppend : tmpClause.SearchResults;
				delete tmpClause.SearchResultsAppend;
				tmpClause.SearchResultsOffset = pOffset;
				tmpClause.LoadMoreEnabled = tmpLoadedRecords && tmpLoadedRecords.length >= this.options.PageSize;
				this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
				if (tmpClause.LoadMoreEnabled)
				{
					this.pict.ContentAssignment.removeClass(`#PRSP_Filter_${tmpClause.Hash}_Button_LoadMore`, 'is-hidden');
				}
			});
	}

	handleAdd(pEvent, pRecordLookupValue, pClauseInformaryAddress, pClauseHash)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause) { return; }
		const tmpRecordLookupColumn = this.getLookupColumn(tmpClause);
		const tmpRecordToAdd = (tmpClause.SearchResults || []).find((pRow) => pRow[tmpRecordLookupColumn] == pRecordLookupValue);
		if (!tmpRecordToAdd) { return; }
		const tmpValue = tmpRecordToAdd[tmpRecordLookupColumn];
		if (tmpValue == null) { return; }
		if (!tmpClause.SelectedValues) { tmpClause.SelectedValues = []; }
		if (!tmpClause.Values) { tmpClause.Values = []; }
		if (this.isMultiSelect())
		{
			if (tmpClause.SelectedValues.some((pSV) => pSV[tmpRecordLookupColumn] == pRecordLookupValue)) { return; }
			tmpClause.SelectedValues.push(tmpRecordToAdd);
			if (!tmpClause.Values.some((pV) => pV == tmpValue)) { tmpClause.Values.push(tmpValue); }
		}
		else
		{
			tmpClause.SelectedValues = [ tmpRecordToAdd ];
			tmpClause.Values = [ tmpValue ];
		}
		this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
	}

	handleRemove(pEvent, pRecordLookupValue, pClauseInformaryAddress, pClauseHash)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpClause = this.getInformaryScopedValue(pClauseInformaryAddress);
		if (!tmpClause) { return; }
		const tmpRecordLookupColumn = this.getLookupColumn(tmpClause);
		const tmpIndex = (tmpClause.SelectedValues || []).findIndex((pRow) => pRow[tmpRecordLookupColumn] == pRecordLookupValue);
		if (tmpIndex < 0) { return; }
		const tmpRemoved = tmpClause.SelectedValues.splice(tmpIndex, 1)[0];
		const tmpValue = tmpRemoved[tmpRecordLookupColumn];
		tmpClause.Values = (tmpClause.Values || []).filter((pV) => pV !== tmpValue);
		this._reRenderClause(tmpClause, pClauseInformaryAddress, pClauseHash);
	}

	/** Re-render a clause's container (the table UI re-paints on every search / add / remove). */
	_reRenderClause(pClause, pClauseInformaryAddress, pClauseHash)
	{
		const tmpRecord = Object.assign({ ClauseAddress: pClauseInformaryAddress }, pClause);
		this.prepareRecord(tmpRecord);
		this.render(null, `#PRSP_Filter_Container_${pClauseHash}`, tmpRecord);
	}
}

module.exports = ViewRecordSetSUBSETFilterEntityReferenceBase;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterBase.default_configuration, _DEFAULT_CONFIGURATION_EntityReference);

},{"./RecordSet-Filter-Base":1001}],1007:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateMatch =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinDateMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-DateMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-DateMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-DateMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinDateMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Hook to prepare state on the render record before rendering.
	 *
	 * @param {Record<string, any>} pRecord - The record used for view rendering.
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-DateMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinDateMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinDateMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateMatch);

},{"./RecordSet-Filter-Base":1001}],1008:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateRange =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinDateRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-DateRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-DateRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-DateRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinDateRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-DateRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinDateRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinDateRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_DateRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1009:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericMatch =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinNumericMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-NumericMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-NumericMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-NumericMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinNumericMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-NumericMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinNumericMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinNumericMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericMatch);

},{"./RecordSet-Filter-Base":1001}],1010:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericRange =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinNumericRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-NumericRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-NumericRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-NumericRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinNumericRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-NumericRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinNumericRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinNumericRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_NumericRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1011:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// External-join (through a junction table), single-select entity-reference filter. Shared base;
// entity seam = ExternalFilterByTable, single-select (replace, not append).
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinSelectedValue',
};

class ViewRecordSetSUBSETFilterExternalJoinSelectedValue extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.ExternalFilterByTable;
	}

	isMultiSelect()
	{
		return false;
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinSelectedValue;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":1006}],1012:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// External-join (through a junction table), multi-select entity-reference filter. Shared base;
// entity seam = ExternalFilterByTable.
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinSelectedValueList',
};

class ViewRecordSetSUBSETFilterExternalJoinSelectedValueList extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.ExternalFilterByTable;
	}

	isMultiSelect()
	{
		return true;
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinSelectedValueList;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":1006}],1013:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoinStringMatch =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinStringMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoinStringMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoinStringMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoinStringMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinStringMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoinStringMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinStringMatch;
module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinStringMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoinStringMatch);


},{"./RecordSet-Filter-Base.js":1001}],1014:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_ExternalJoin_StringRange =
{
	ViewIdentifier: 'PRSP-FilterType-ExternalJoinStringRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-ExternalJoin-StringRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-ExternalJoin-StringRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-ExternalJoin-StringRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterExternalJoinStringRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-ExternalJoin-StringRange';
	}
}

module.exports = ViewRecordSetSUBSETFilterExternalJoinStringRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterExternalJoinStringRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_ExternalJoin_StringRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1015:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateMatch =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinDateMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-DateMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-DateMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-DateMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinDateMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-DateMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinDateMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinDateMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateMatch);

},{"./RecordSet-Filter-Base":1001}],1016:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateRange =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinDateRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-DateRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-DateRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-DateRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinDateRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'DateTime';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-DateRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinDateRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinDateRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_DateRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1017:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericMatch =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinNumericMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-NumericMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-NumericMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-NumericMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinNumericMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-NumericMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinNumericMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinNumericMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericMatch);

},{"./RecordSet-Filter-Base":1001}],1018:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericRange =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinNumericRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-NumericRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-NumericRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-NumericRange-Template] -->
`
		},
	],
};

class ViewRecordSetSUBSETFilterInternalJoinNumericRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-NumericRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinNumericRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinNumericRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_NumericRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1019:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// Internal-join, single-select entity-reference filter. Shared base; entity seam = RemoteTable,
// single-select (replace, not append).
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinSelectedValue',
};

class ViewRecordSetSUBSETFilterInternalJoinSelectedValue extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.RemoteTable;
	}

	isMultiSelect()
	{
		return false;
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinSelectedValue;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":1006}],1020:[function(require,module,exports){
const ViewRecordSetSUBSETFilterEntityReferenceBase = require('./RecordSet-Filter-EntityReference-Base');

// Internal-join, multi-select entity-reference filter. All behavior lives in the shared base; this
// only names the view type and points the entity seam at RemoteTable.
const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinSelectedValueList',
};

class ViewRecordSetSUBSETFilterInternalJoinSelectedValueList extends ViewRecordSetSUBSETFilterEntityReferenceBase
{
	getSearchEntity(pClause)
	{
		return pClause.RemoteTable;
	}

	isMultiSelect()
	{
		return true;
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinSelectedValueList;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterEntityReferenceBase.default_configuration, _DEFAULT_CONFIGURATION);

},{"./RecordSet-Filter-EntityReference-Base":1006}],1021:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringMatch =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinStringMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-StringMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-StringMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-StringMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinStringMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-StringMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinStringMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinStringMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringMatch);

},{"./RecordSet-Filter-Base":1001}],1022:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringRange =
{
	ViewIdentifier: 'PRSP-FilterType-InternalJoinStringRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-InternalJoin-StringRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-InternalJoin-StringRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-InternalJoin-StringRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterInternalJoinStringRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-InternalJoin-StringRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterInternalJoinStringRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterInternalJoinStringRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_InternalJoin_StringRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1023:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_NumericMatch =
{
	ViewIdentifier: 'PRSP-FilterType-NumericMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-NumericMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-NumericMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-NumericMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterNumericMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-NumericMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterNumericMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterNumericMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_NumericMatch);

},{"./RecordSet-Filter-Base":1001}],1024:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_NumericRange =
{
	ViewIdentifier: 'PRSP-FilterType-NumericRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-NumericRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-NumericRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-NumericRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterNumericRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * @param {Record<string, any>} pRecord
	 */
	prepareRecord(pRecord)
	{
		super.prepareRecord(pRecord);

		pRecord.StartClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.StartClauseDescriptor.PictForm = pRecord.PictForm || {};
		pRecord.EndClauseDescriptor.DataType = pRecord.DataType || 'Number';
		pRecord.EndClauseDescriptor.PictForm = pRecord.PictForm || {};
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-NumericRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterNumericRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterNumericRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_NumericRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1025:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBase = require('./RecordSet-Filter-Base');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_StringMatch =
{
	ViewIdentifier: 'PRSP-FilterType-StringMatch',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-StringMatch-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-StringMatch-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.ClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-StringMatch-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterStringMatch extends ViewRecordSetSUBSETFilterBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-StringMatch-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterStringMatch;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterStringMatch.default_configuration, _DEFAULT_CONFIGURATION_Filter_StringMatch);

},{"./RecordSet-Filter-Base":1001}],1026:[function(require,module,exports){

const ViewRecordSetSUBSETFilterBaseRange = require('./RecordSet-Filter-Base-Range.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_Filter_StringRange =
{
	ViewIdentifier: 'PRSP-FilterType-StringRange',

	Templates:
	[
		{
			Hash: 'PRSP-Filter-StringRange-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-Filter-StringRange-Template] -->
	{~IWVDA:PSRSFilterProxyView:Record.StartClauseDescriptor~}
	{~IWVDA:PSRSFilterProxyView:Record.EndClauseDescriptor~}
	<!-- DefaultPackage end view template:	[PRSP-Filter-StringRange-Template] -->
`
		}
	],
};

class ViewRecordSetSUBSETFilterStringRange extends ViewRecordSetSUBSETFilterBaseRange
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	getFilterFormTemplate()
	{
		return 'PRSP-Filter-StringRange-Template';
	}
}

module.exports = ViewRecordSetSUBSETFilterStringRange;

module.exports.default_configuration = Object.assign({}, ViewRecordSetSUBSETFilterStringRange.default_configuration, _DEFAULT_CONFIGURATION_Filter_StringRange);

},{"./RecordSet-Filter-Base-Range.js":1000}],1027:[function(require,module,exports){

module.exports =
{
	Base: require('./RecordSet-Filter-Base.js'),

	DateMatch: require('./RecordSet-Filter-DateMatch.js'),
	DateRange: require('./RecordSet-Filter-DateRange.js'),
	NumericMatch: require('./RecordSet-Filter-NumericMatch.js'),
	NumericRange: require('./RecordSet-Filter-NumericRange.js'),
	BooleanMatch: require('./RecordSet-Filter-BooleanMatch.js'),
	StringMatch: require('./RecordSet-Filter-StringMatch.js'),
	StringRange: require('./RecordSet-Filter-StringRange.js'),

	DistinctSelectedValueList: require('./RecordSet-Filter-DistinctSelectedValueList.js'),

	InternalJoinDateMatch: require('./RecordSet-Filter-InternalJoinDateMatch.js'),
	InternalJoinDateRange: require('./RecordSet-Filter-InternalJoinDateRange.js'),
	InternalJoinNumericMatch: require('./RecordSet-Filter-InternalJoinNumericMatch.js'),
	InternalJoinNumericRange: require('./RecordSet-Filter-InternalJoinNumericRange.js'),
	InternalJoinStringMatch: require('./RecordSet-Filter-InternalJoinStringMatch.js'),
	InternalJoinStringRange: require('./RecordSet-Filter-InternalJoinStringRange.js'),
	InternalJoinSelectedValue: require('./RecordSet-Filter-InternalJoinSelectedValue.js'),
	InternalJoinSelectedValueList: require('./RecordSet-Filter-InternalJoinSelectedValueList.js'),

	ExternalJoinDateMatch: require('./RecordSet-Filter-ExternalJoinDateMatch.js'),
	ExternalJoinDateRange: require('./RecordSet-Filter-ExternalJoinDateRange.js'),
	ExternalJoinNumericMatch: require('./RecordSet-Filter-ExternalJoinNumericMatch.js'),
	ExternalJoinNumericRange: require('./RecordSet-Filter-ExternalJoinNumericRange.js'),
	ExternalJoinStringMatch: require('./RecordSet-Filter-ExternalJoinStringMatch.js'),
	ExternalJoinStringRange: require('./RecordSet-Filter-ExternalJoinStringRange.js'),
	ExternalJoinSelectedValue: require('./RecordSet-Filter-ExternalJoinSelectedValue.js'),
	ExternalJoinSelectedValueList: require('./RecordSet-Filter-ExternalJoinSelectedValueList.js'),
};


},{"./RecordSet-Filter-Base.js":1001,"./RecordSet-Filter-BooleanMatch.js":1002,"./RecordSet-Filter-DateMatch.js":1003,"./RecordSet-Filter-DateRange.js":1004,"./RecordSet-Filter-DistinctSelectedValueList.js":1005,"./RecordSet-Filter-ExternalJoinDateMatch.js":1007,"./RecordSet-Filter-ExternalJoinDateRange.js":1008,"./RecordSet-Filter-ExternalJoinNumericMatch.js":1009,"./RecordSet-Filter-ExternalJoinNumericRange.js":1010,"./RecordSet-Filter-ExternalJoinSelectedValue.js":1011,"./RecordSet-Filter-ExternalJoinSelectedValueList.js":1012,"./RecordSet-Filter-ExternalJoinStringMatch.js":1013,"./RecordSet-Filter-ExternalJoinStringRange.js":1014,"./RecordSet-Filter-InternalJoinDateMatch.js":1015,"./RecordSet-Filter-InternalJoinDateRange.js":1016,"./RecordSet-Filter-InternalJoinNumericMatch.js":1017,"./RecordSet-Filter-InternalJoinNumericRange.js":1018,"./RecordSet-Filter-InternalJoinSelectedValue.js":1019,"./RecordSet-Filter-InternalJoinSelectedValueList.js":1020,"./RecordSet-Filter-InternalJoinStringMatch.js":1021,"./RecordSet-Filter-InternalJoinStringRange.js":1022,"./RecordSet-Filter-NumericMatch.js":1023,"./RecordSet-Filter-NumericRange.js":1024,"./RecordSet-Filter-StringMatch.js":1025,"./RecordSet-Filter-StringRange.js":1026}],1028:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * The list's column chooser: a small right-aligned "Columns" button above the table that opens a
 * popover of checkbox rows — the host-curated columns first, then the entity's remaining scalar
 * schema columns — letting the user show/hide columns per record set. Choices persist through the
 * ColumnDataProvider and repaint body-only through the list view (the filter bar is never touched).
 *
 * Renders nothing unless the active record set's configuration sets RecordSetListColumnChooser: true
 * (the list view only populates Record.ColumnChooserSlot when the flag is on).
 */

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_ColumnChooser = (
	{
		ViewIdentifier: 'PRSP-List-ColumnChooser',

		DefaultRenderable: 'PRSP_Renderable_ColumnChooser',
		DefaultDestinationAddress: '#PRSP_ColumnChooser_Container',
		DefaultTemplateRecordAddress: false,

		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		// Mirrors the add-filter popover chrome (fixed + JS-positioned so no ancestor overflow can
		// clip it; transparent backdrop catches outside clicks) with its own class namespace.
		CSS: /*css*/`
	.prsp-colchooser-bar { display: flex; justify-content: flex-end; margin: 0 0 0.35rem; }
	.prsp-colchooser-trigger { display: inline-flex; align-items: center; gap: 0.35rem; cursor: pointer; font: inherit; font-size: 0.88rem;
		padding: 0.3rem 0.65rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px;
		background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
	.prsp-colchooser-trigger:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
	.prsp-colchooser-pop { position: fixed; z-index: 30; min-width: 260px; max-width: 340px; display: none; }
	.prsp-colchooser-pop.open { display: block; }
	.prsp-colchooser-backdrop { position: fixed; inset: 0; z-index: 0; }
	.prsp-colchooser-panel { position: relative; z-index: 1; display: flex; flex-direction: column; max-height: min(70vh, 460px);
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
		border-radius: 10px; box-shadow: 0 10px 28px rgba(17, 24, 39, 0.14); overflow: hidden; }
	.prsp-colchooser-search { flex: 0 0 auto; display: flex; align-items: center; gap: 0.4rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.prsp-colchooser-search-ic { display: inline-flex; color: var(--theme-color-text-muted, #6b7686); font-size: 0.9rem; }
	.prsp-colchooser-search input { flex: 1 1 auto; min-width: 0; font: inherit; font-size: 0.9rem; border: none; outline: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
	.prsp-colchooser-list { flex: 1 1 auto; overflow-y: auto; padding: 0.25rem 0; }
	.prsp-colchooser-empty { padding: 0.7rem 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.86rem; }
	.prsp-colchooser-group { padding: 0.45rem 0.8rem 0.2rem; font-size: 0.72rem; font-weight: 650; letter-spacing: 0.04em; text-transform: uppercase; color: var(--theme-color-text-muted, #6b7686); }
	.prsp-colchooser-row { display: flex; align-items: center; gap: 0.5rem; width: 100%; font: inherit; font-size: 0.9rem; text-align: left; cursor: pointer;
		padding: 0.4rem 0.8rem; border: none; background: transparent; color: var(--theme-color-text-primary, #1f2733); }
	.prsp-colchooser-row:hover { background: var(--theme-color-background-tertiary, #eceef2); }
	.prsp-colchooser-check { display: inline-flex; flex: 0 0 auto; font-size: 0.85rem; color: var(--theme-color-brand-primary, #156dd1); visibility: hidden; }
	.prsp-colchooser-row.is-checked .prsp-colchooser-check { visibility: visible; }
	.prsp-colchooser-footer { flex: 0 0 auto; display: flex; justify-content: flex-end; padding: 0.45rem 0.7rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.prsp-colchooser-reset { font: inherit; font-size: 0.84rem; cursor: pointer; border: none; background: transparent; color: var(--theme-color-text-muted, #6b7686); padding: 0.15rem 0.3rem; border-radius: 5px; }
	.prsp-colchooser-reset:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eceef2); }
	`,
		CSSPriority: 500,

		Templates:
		[
			{
				// The {~V:~} slot in PRSP-List-Template renders this with the full list data as Record;
				// the one-or-zero-element ColumnChooserSlot array gates the whole control on the
				// RecordSetListColumnChooser flag with no JS branch.
				Hash: 'PRSP-List-ColumnChooser-Template',
				Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-ColumnChooser-Template] -->
	{~TS:PRSP-List-ColumnChooser-Button:Record.ColumnChooserSlot~}
	<!-- DefaultPackage end view template:  [PRSP-List-ColumnChooser-Template] -->
`
			},
			{
				Hash: 'PRSP-List-ColumnChooser-Button',
				Template: /*html*/`
	<div class="prsp-colchooser-bar">
		<button type="button" class="prsp-colchooser-trigger" id="PRSP_ColumnChooser_Trigger" title="Choose which columns to show" onclick="_Pict.views['PRSP-List-ColumnChooser'].toggleColumnChooser(event, '{~D:Record.RecordSet~}')">{~I:Settings~} Columns</button>
		<div class="prsp-colchooser-pop" id="PRSP_ColumnChooser_Popover"></div>
	</div>
`
			},
			{
				Hash: 'PRSP-ColumnChooser-Popover',
				Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-ColumnChooser-Popover] -->
	<div class="prsp-colchooser-backdrop" onclick="_Pict.views['PRSP-List-ColumnChooser'].closeColumnChooser()"></div>
	<div class="prsp-colchooser-panel">
		<div class="prsp-colchooser-search">
			<span class="prsp-colchooser-search-ic">{~I:Search~}</span>
			<input type="text" id="PRSP_ColumnChooser_Search" placeholder="Search columns…" autocomplete="off" value="{~D:AppData.PRSPColumnChooser.Search~}" oninput="_Pict.views['PRSP-List-ColumnChooser'].searchColumnChooser(this.value)" onkeydown="if (event.key === 'Escape') { event.preventDefault(); _Pict.views['PRSP-List-ColumnChooser'].closeColumnChooser(); }">
		</div>
		<div class="prsp-colchooser-list" id="PRSP_ColumnChooser_List">
			{~T:PRSP-ColumnChooser-List~}
		</div>
		<div class="prsp-colchooser-footer">
			<button type="button" class="prsp-colchooser-reset" onclick="_Pict.views['PRSP-List-ColumnChooser'].resetColumns()">Reset to defaults</button>
		</div>
	</div>
	<!-- DefaultPackage end view template: [PRSP-ColumnChooser-Popover] -->
`
			},
			{
				Hash: 'PRSP-ColumnChooser-List',
				Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-ColumnChooser-List] -->
	{~TS:PRSP-ColumnChooser-Row:AppData.PRSPColumnChooser.CuratedRows~}
	{~NE:AppData.PRSPColumnChooser.HasSchemaRows^<div class="prsp-colchooser-group">More columns</div>~}
	{~TS:PRSP-ColumnChooser-Row:AppData.PRSPColumnChooser.SchemaRows~}
	{~NE:AppData.PRSPColumnChooser.HasAuditRows^<div class="prsp-colchooser-group">Audit columns</div>~}
	{~TS:PRSP-ColumnChooser-Row:AppData.PRSPColumnChooser.AuditRows~}
	{~NE:AppData.PRSPColumnChooser.IsEmpty^<div class="prsp-colchooser-empty">No columns found.</div>~}
	<!-- DefaultPackage end view template: [PRSP-ColumnChooser-List] -->
`
			},
			{
				Hash: 'PRSP-ColumnChooser-Row',
				Template: /*html*/`
	<button type="button" class="prsp-colchooser-row {~D:Record.CheckedClass~}" onclick="_Pict.views['PRSP-List-ColumnChooser'].toggleColumn('{~D:Record.Key~}')">
		<span class="prsp-colchooser-check">{~I:Check~}</span>
		<span class="prsp-colchooser-name">{~D:Record.DisplayName~}</span>
	</button>
`
			}
		],

		Renderables:
		[
			{
				RenderableHash: 'PRSP_Renderable_ColumnChooser',
				TemplateHash: 'PRSP-List-ColumnChooser-Template',
				ContentDestinationAddress: '#PRSP_ColumnChooser_Container',
				RenderMethod: 'replace'
			},
			{
				RenderableHash: 'PRSP_ColumnChooser_Popover',
				TemplateHash: 'PRSP-ColumnChooser-Popover',
				ContentDestinationAddress: '#PRSP_ColumnChooser_Popover',
				RenderMethod: 'replace'
			},
			{
				RenderableHash: 'PRSP_ColumnChooser_List',
				TemplateHash: 'PRSP-ColumnChooser-List',
				ContentDestinationAddress: '#PRSP_ColumnChooser_List',
				RenderMethod: 'replace'
			}
		],

		Manifests: {}
	});

class viewRecordSetListColumnChooser extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_ColumnChooser, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this._chooserRecordSet = null;
		this._chooserSearch = '';
	}

	/**
	 * Open/close the chooser popover (the trigger button's handler).
	 *
	 * Open/closed is derived from the popover's DOM class, not an instance flag — a full list
	 * re-render replaces the popover element (visually closed), so a flag would go stale and
	 * demand a double-click to reopen.
	 *
	 * @param {Event} pEvent - The DOM click event
	 * @param {string} pRecordSet - The record set whose columns to manage
	 */
	toggleColumnChooser(pEvent, pRecordSet)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpPopoverElements = this.pict.ContentAssignment.getElement('#PRSP_ColumnChooser_Popover');
		if (tmpPopoverElements.length && tmpPopoverElements[0].classList.contains('open'))
		{
			return this.closeColumnChooser();
		}
		this._chooserRecordSet = pRecordSet;
		this._chooserSearch = '';
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_Popover', undefined, { RecordSet: pRecordSet });
		this._paintColumnChooserOpenState(true);
	}

	/** Close the chooser popover. */
	closeColumnChooser()
	{
		this._paintColumnChooserOpenState(false);
	}

	/**
	 * Filter the chooser's column list by a search term, re-rendering only the list so the
	 * search input keeps focus.
	 * @param {string} pValue - The search term.
	 */
	searchColumnChooser(pValue)
	{
		this._chooserSearch = pValue || '';
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_List', undefined, { RecordSet: this._chooserRecordSet });
	}

	/**
	 * Flip a column's visibility (a chooser row's handler). Delegates to the list view — which
	 * persists the override and repaints the rows body-only — then repaints the chooser rows
	 * truthfully (the list view may have refused, e.g. hiding the last visible column).
	 * @param {string} pKey - The column key to toggle.
	 */
	toggleColumn(pKey)
	{
		const tmpListView = this.pict.views['RSP-RecordSet-List'];
		if (!tmpListView || !tmpListView._lastRecordListData || !Array.isArray(tmpListView._lastRecordListData.ColumnCandidates))
		{
			return;
		}
		const tmpCandidate = tmpListView._lastRecordListData.ColumnCandidates.find((pCandidate) => pCandidate.Key === pKey);
		if (!tmpCandidate)
		{
			return;
		}
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		const tmpOverrides = tmpColumnProvider ? tmpColumnProvider.getColumnVisibilityOverrides(this._chooserRecordSet, 'List') : {};
		const tmpCurrentlyVisible = tmpListView._effectiveColumnVisibility(tmpCandidate, tmpOverrides);
		tmpListView.setColumnVisibility(this._chooserRecordSet, pKey, !tmpCurrentlyVisible);
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_List', undefined, { RecordSet: this._chooserRecordSet });
	}

	/** Clear all overrides for the record set and repaint with default visibility (footer button). */
	resetColumns()
	{
		const tmpListView = this.pict.views['RSP-RecordSet-List'];
		if (!tmpListView)
		{
			return;
		}
		tmpListView.resetColumnVisibility(this._chooserRecordSet);
		this._buildColumnChooserRows();
		this.render('PRSP_ColumnChooser_List', undefined, { RecordSet: this._chooserRecordSet });
	}

	/**
	 * (Re)build the chooser's row models into AppData from the list view's pristine column
	 * candidates (single source of truth) + the current overrides, honouring the search term.
	 */
	_buildColumnChooserRows()
	{
		const tmpListView = this.pict.views['RSP-RecordSet-List'];
		const tmpListData = tmpListView && tmpListView._lastRecordListData;
		const tmpCandidates = (tmpListData && tmpListData.RecordSet === this._chooserRecordSet && Array.isArray(tmpListData.ColumnCandidates))
			? tmpListData.ColumnCandidates : [];
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		const tmpOverrides = tmpColumnProvider ? tmpColumnProvider.getColumnVisibilityOverrides(this._chooserRecordSet, 'List') : {};
		const tmpSearch = (this._chooserSearch || '').toLowerCase();
		const fSearchMatch = (pCandidate) => !tmpSearch || String(pCandidate.DisplayName || pCandidate.Key).toLowerCase().includes(tmpSearch);
		const fMapRow = (pCandidate) => (
			{
				Key: pCandidate.Key,
				DisplayName: pCandidate.DisplayName || pCandidate.Key,
				CheckedClass: tmpListView._effectiveColumnVisibility(pCandidate, tmpOverrides) ? 'is-checked' : '',
			});
		const tmpCuratedRows = tmpCandidates.filter((pCandidate) => pCandidate.Source === 'Curated').filter(fSearchMatch).map(fMapRow);
		const tmpSchemaRows = tmpCandidates.filter((pCandidate) => pCandidate.Source === 'Schema').filter(fSearchMatch).map(fMapRow);
		const tmpAuditRows = tmpCandidates.filter((pCandidate) => pCandidate.Source === 'Audit').filter(fSearchMatch).map(fMapRow);
		this.pict.AppData.PRSPColumnChooser =
		{
			RecordSet: this._chooserRecordSet,
			Search: this._chooserSearch || '',
			CuratedRows: tmpCuratedRows,
			SchemaRows: tmpSchemaRows,
			AuditRows: tmpAuditRows,
			// A group divider only earns its place when rows are showing above it.
			HasSchemaRows: (tmpSchemaRows.length > 0) && (tmpCuratedRows.length > 0),
			HasAuditRows: (tmpAuditRows.length > 0) && ((tmpCuratedRows.length + tmpSchemaRows.length) > 0),
			IsEmpty: (tmpCuratedRows.length + tmpSchemaRows.length + tmpAuditRows.length) === 0,
		};
	}

	/**
	 * Reflect the popover's open/closed state on its container element.
	 * @param {boolean} pOpen - Whether the popover should be open.
	 */
	_paintColumnChooserOpenState(pOpen)
	{
		const tmpPopoverElements = this.pict.ContentAssignment.getElement('#PRSP_ColumnChooser_Popover');
		if (!tmpPopoverElements.length)
		{
			return;
		}
		tmpPopoverElements[0].classList.toggle('open', !!pOpen);
		if (pOpen)
		{
			this._positionColumnChooserPopover(tmpPopoverElements[0]);
		}
	}

	/**
	 * Position the (fixed) popover against the trigger button, flipping above when there's more
	 * room there — same approach as the filters view's add-filter popover, so no ancestor
	 * overflow:hidden can clip it.
	 *
	 * @param {HTMLElement} pPopover - the #PRSP_ColumnChooser_Popover element (already display:block).
	 */
	_positionColumnChooserPopover(pPopover)
	{
		const tmpTriggerElements = this.pict.ContentAssignment.getElement('#PRSP_ColumnChooser_Trigger');
		if (!tmpTriggerElements.length)
		{
			return;
		}
		const tmpPanel = /** @type {HTMLElement} */ (pPopover.querySelector('.prsp-colchooser-panel'));
		const tmpRect = tmpTriggerElements[0].getBoundingClientRect();
		const tmpGap = 6;
		const tmpMargin = 8;
		const tmpVH = window.innerHeight;
		const tmpVW = window.innerWidth;
		const tmpWidth = pPopover.offsetWidth || 280;
		// Right-align the popover to the (right-aligned) trigger, clamped into the viewport.
		pPopover.style.left = `${Math.round(Math.max(tmpMargin, Math.min(tmpRect.right - tmpWidth, tmpVW - tmpWidth - tmpMargin)))}px`;
		pPopover.style.right = 'auto';
		const tmpSpaceBelow = tmpVH - tmpRect.bottom - tmpGap - tmpMargin;
		const tmpSpaceAbove = tmpRect.top - tmpGap - tmpMargin;
		// Prefer the natural downward direction; only flip above when the room below is genuinely cramped.
		if (tmpSpaceBelow >= 220 || tmpSpaceBelow >= tmpSpaceAbove)
		{
			pPopover.style.top = `${Math.round(tmpRect.bottom + tmpGap)}px`;
			pPopover.style.bottom = 'auto';
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceBelow, 460))}px`; }
		}
		else
		{
			pPopover.style.top = 'auto';
			pPopover.style.bottom = `${Math.round(tmpVH - tmpRect.top + tmpGap)}px`;
			if (tmpPanel) { tmpPanel.style.maxHeight = `${Math.max(160, Math.min(tmpSpaceAbove, 460))}px`; }
		}
	}
}

module.exports = viewRecordSetListColumnChooser;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_ColumnChooser;

},{"pict-view":1053}],1029:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_HeaderList =
{
	ViewIdentifier: 'PRSP-List-HeaderList',

	DefaultRenderable: 'PRSP_Renderable_HeaderList',
	DefaultDestinationAddress: '#PRSP_HeaderList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-List-HeaderList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-HeaderList-Template] -->
	<!-- DefaultPackage end view template:	[PRSP-List-HeaderList-Template] -->
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_HeaderList',
			TemplateHash: 'PRSP-List-HeaderList-Template',
			DestinationAddress: '#PRSP_HeaderList_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetListHeaderList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_HeaderList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListHeaderList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_HeaderList;


},{"pict-view":1053}],1030:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationBottom = (
	{
		ViewIdentifier: 'PRSP-List-PaginationBottom',

		DefaultRenderable: 'PRSP_Renderable_PaginationBottom',
		DefaultDestinationAddress: '#PRSP_PaginationBottom_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-PaginationBottom-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-PaginationBottom-Template] -->
	<nav id="RSP_Lower_Pagination_Container">
	{~T:PRSP-List-Pagination-Template-Description~}
		{~T:PRSP-List-Pagination-Template-Buttons~}
	</nav>
	<!-- DefaultPackage end view template:  [PRSP-List-PaginationBottom-Template] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationBottom',
					TemplateHash: 'PRSP-List-PaginationBottom-Template',
					DestinationAddress: '#PRSP_PaginationBottom_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListPaginationBottom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationBottom, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListPaginationBottom;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationBottom;


},{"pict-view":1053}],1031:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_PaginationTop = (
	{
		ViewIdentifier: 'PRSP-List-PaginationTop',

		DefaultRenderable: 'PRSP_Renderable_PaginationTop',
		DefaultDestinationAddress: '#PRSP_PaginationTop_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-PaginationTop-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-PaginationTop-Template] -->
	<nav id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
		{~T:PRSP-List-Pagination-Template-Description~}
		{~T:PRSP-List-Pagination-Template-Buttons~}
	</nav>
	<div>
		{~TS:PRSP-List-Pagination-Template-Pages:Record.PageLinksLimited~}
	</div>
	<!-- DefaultPackage end view template:  [PRSP-List-PaginationTop-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Description',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Description] -->
	<div>
		Showing
		<span id="PRSP_Pagination_Description_Records_Start">{~D:Record.PageStart~}</span> to
		<span id="PRSP_Pagination_Description_Records_End">{~D:Record.PageEnd~}</span> of
		<span id="PRSP_Pagination_Description_Records_Total">{~D:Record.TotalRecordCount.Count~}</span> total records.
	</div>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Description] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Buttons',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Buttons] -->
	<ul style="list-style-type: none; padding: 0; display: flex; justify-content: center;">
		{~TIfAbs:PRSP-List-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
		{~TS:PRSP-List-Pagination-Template-Button-Page~}
		{~TIfAbs:PRSP-List-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
	</ul>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Buttons] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Button-Previous',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Previous] -->
	<li><a href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">&laquo; Previous</a></li>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Previous] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Button-Next',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Next] -->
	<li style="margin-left: 15px;"><a href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next &raquo;</a></li>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Next] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Button-Page',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Page] -->
	<li><a href="#" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Page] -->
	`
				},
				{
					Hash: 'PRSP-List-Pagination-Template-Pages',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Pagination-Template-Button-Pages] -->
	<a href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}" class="page-offset_{~D:Record.RelativeOffset~}">{~D:Record.Page~}</a>
	<!-- DefaultPackage end view template:  [PRSP-List-Pagination-Template-Button-Pages] -->
	`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_PaginationTop',
					TemplateHash: 'PRSP-List-PaginationTop-Template',
					DestinationAddress: '#PRSP_PaginationTop_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListPaginationTop extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_PaginationTop, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListPaginationTop;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_PaginationTop;


},{"pict-view":1053}],1032:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordList =
{
	ViewIdentifier: 'PRSP-List-RecordList',

	DefaultRenderable: 'PRSP_Renderable_RecordList',
	DefaultDestinationAddress: '#PRSP_RecordList_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: /*css*/`
		tr#PRSP_List_Table_Empty:not(:first-child) {
			display: none;
		}
	`,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-List-RecordList-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordList-Template] -->
	<section id="PRSP_List_Container">
		{~T:PRSP-List-RecordList-Template-Table~}
	</section>
	<!-- DefaultPackage end view template:	[PRSP-List-RecordList-Template] -->
`
		},
		{
			Hash: 'PRSP-List-RecordList-Template-Table',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordList-Template-Table] -->
	<table id="PRSP_List_Table" tablespacing="0" cellpadding="0" cellspacing="0" style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
		<thead>{~T:PRSP-List-RecordListHeader-Template~}</thead>
		<tbody id="PRSP_RecordList_Container_Entries">
			{~T:PRSP-List-RecordListEntry-Template~}
			{~T:PRSP-List-RecordList-Template-EmptyTable~}
		</tbody>
	</table>
	<!-- DefaultPackage end view template:	[PRSP-List-RecordList-Template-Table] -->
`
		},
		{
			Hash: 'PRSP-List-RecordList-Template-EmptyTable',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordList-Template-EmptyTable] -->
	<tr id="PRSP_List_Table_Empty">
		<td colspan="100%" style="text-align: center; padding: 10px;">No records found.</td>
	</tr>
	<!-- DefaultPackage end view template:	[PRSP-List-RecordList-Template-EmptyTable] -->
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_RecordList',
			TemplateHash: 'PRSP-List-RecordList-Template',
			DestinationAddress: '#PRSP_RecordList_Container',
			RenderMethod: 'replace'
		}
	],

	Manifests: {}
};

class viewRecordSetListRecordList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordList, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListRecordList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordList;


},{"pict-view":1053}],1033:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListEntry = (
	{
		ViewIdentifier: 'PRSP-List-RecordListEntry',

		DefaultRenderable: 'PRSP_Renderable_RecordListEntry',
		DefaultDestinationAddress: '#PRSP_RecordListEntry_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		// Record-list row chrome. Host apps brand it via --theme-color-* tokens; the hardcoded values
		// are fallbacks.
		CSS: /*css*/`
/* Vertically center every cell's content so the text lines up with the action control (it was
   top-aligned, which read as off next to the centered action cell). */
#PRSP_List_Table td { vertical-align: middle; }

/* Deleted rows (visible via the show-deleted filter) read as ghosts of themselves. */
.prsp-list-row.prsp-row-deleted td { opacity: 0.55; }

/* Row-as-button (opt-in via the RowClickOpensRecord record-set config flag): clicking anywhere in the
   row — except the action cell — follows the record's default link. */
.prsp-list-row.prsp-row-clickable { cursor: pointer; }
.prsp-list-row.prsp-row-clickable:hover { background: var(--theme-color-background-hover, var(--theme-color-background-tertiary, #f1f3f7)); }

/* Per-row action menu: a subtle three-dot trigger, revealed on row hover, that opens a small popover
   of the record's links (View, …). Clicks inside it never trigger the row navigation. */
.prsp-row-actions { white-space: nowrap; text-align: right; width: 1%; }
.prsp-row-actions-wrap { position: relative; display: inline-block; }
.prsp-row-actions-trigger { display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
	border: none; background: transparent; line-height: 1; padding: 0.2rem 0.5rem; border-radius: 6px; font-size: 1.05rem;
	color: var(--theme-color-text-muted, #6b7686); opacity: 0; transition: opacity 0.12s ease, background 0.12s ease, color 0.12s ease; }
.prsp-list-row:hover .prsp-row-actions-trigger, .prsp-row-actions-wrap.open .prsp-row-actions-trigger { opacity: 1; }
.prsp-row-actions-trigger:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
.prsp-row-actions-menu { position: absolute; right: 0; top: calc(100% + 2px); z-index: 30; min-width: 9rem; display: none;
	background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3);
	border-radius: 9px; box-shadow: 0 10px 26px rgba(17, 24, 39, 0.16); padding: 0.25rem; text-align: left; }
.prsp-row-actions-wrap:hover .prsp-row-actions-menu, .prsp-row-actions-wrap.open .prsp-row-actions-menu { display: block; }
.prsp-row-actions-menu ul { list-style: none; margin: 0; padding: 0; }
.prsp-row-actions-menu li > a { display: block; padding: 0.4rem 0.65rem; border-radius: 6px; text-decoration: none; white-space: nowrap;
	color: var(--theme-color-text-primary, #1f2733); font-size: 0.9rem; }
.prsp-row-actions-menu li > a:hover { background: var(--theme-color-background-tertiary, #eceef2); }
`,
		CSSPriority: 500,

		Templates:
			[
				{
					// TODO: Add extras template here; it's in the header but not here yet.
					Hash: 'PRSP-List-RecordListEntry-Template',
					Template: /*html*/`
		{~TSWP:PRSP-List-RecordListEntry-Template-Row:Record.Records.Records:Record~}
	`
				},
				{
					Hash: 'PRSP-List-RecordListEntry-Template-Row',
					// The whole row is a click target for the record's default link — opt-in via the
					// RowClickOpensRecord record-set config flag (which adds prsp-row-clickable). The onclick
					// only fires when that class is present, skips clicks inside the action cell, and follows
					// the default link (data-prsp-default) only — so a host-overridden action cell with no
					// default link makes the row click a harmless no-op.
					Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-List-RecordListEntry-Template] -->
		<tr class="prsp-list-row{~NE:Record.Payload.RecordSetConfiguration.RowClickOpensRecord^ prsp-row-clickable~}{~NE:Record.Data.Deleted^ prsp-row-deleted~}" onclick="if (this.classList.contains('prsp-row-clickable') &amp;&amp; !event.target.closest('.prsp-row-actions')) { var tmpDefaultLink = this.querySelector('.prsp-row-actions a[data-prsp-default]'); if (tmpDefaultLink) { tmpDefaultLink.click(); } }">
			{~TSWP:PRSP-List-RecordListEntry-Template-Row-Cell:Record.Payload.TableCells:Record.Data~}
			{~T:PRSP-List-RecordListHeader-Template-Extra-Row~}
			{~T:PRSP-List-RecordListAction-Template-Cell~}
		</tr>
		<!-- DefaultPackage end view template:  [PRSP-List-RecordListEntry-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Template-Extra-Row',
					Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-List-RecordListHeader-Template-Extra-Row] -->
		{~TBR:Record.Payload.RecordSetConfiguration.RecordSetListExtraColumnRowTemplateHash~}
		<!-- DefaultPackage end view template:  [PRSP-List-RecordListHeader-Extra-Row] -->
	`
				},
				{
					Hash: 'PRSP-List-RecordListEntry-Template-Row-Cell',
					Template: /*html*/`
			<td style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
				{~TBDA:Record.Data.PictDashboard.ValueTemplate~}
			</td>
		`
				},
				{
					Hash: 'PRSP-List-RecordListEntry-Template-Entry-Cell-Datum',
					Template: /*html*/`
		<!-- DefaultPackage pict view template: [PRSP-List-RecordListEntry-Template-Entry-Cell-Datum] -->
		`
				},
				{
					// The action cell renders the three-dot hover menu when RowClickOpensRecord is set, else the
					// original always-visible link list. (Hosts such as LIMS override this whole template; those
					// lists keep their custom actions and — without the flag — their original row behavior.)
					Hash: 'PRSP-List-RecordListAction-Template-Cell',
					// FIXME: Needs a better way of getting the appropriate link templates in (likely requiring piping the RecordSet to the link manager)
					Template: /*html*/`
			<td class="prsp-row-actions" style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px;">
				{~TIfAbs:PRSP-List-RecordListAction-Menu:Record:Record.Payload.RecordSetConfiguration.RowClickOpensRecord^TRUE^~}
				{~TIfAbs:PRSP-List-RecordListAction-List:Record:Record.Payload.RecordSetConfiguration.RowClickOpensRecord^FALSE^~}
			</td>
		`
				},
				{
					Hash: 'PRSP-List-RecordListAction-Menu',
					Template: /*html*/`
				<div class="prsp-row-actions-wrap">
					<button type="button" class="prsp-row-actions-trigger" aria-label="Actions" title="Actions" onclick="event.stopPropagation(); this.parentNode.classList.toggle('open');">{~I:More~}</button>
					<div class="prsp-row-actions-menu">
						<ul>
							{~TSWP:PRSP-List-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
						</ul>
					</div>
				</div>
		`
				},
				{
					Hash: 'PRSP-List-RecordListAction-List',
					Template: /*html*/`
				<ul>
					{~TSWP:PRSP-List-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
				</ul>
		`
				},
				{
					Hash: 'PRSP-List-RecordListAction-Template-Cell-Datum',
					// These use the new TemplateByReference template expression, which uses the values in these addresses to lookup the template hash then renders those template with the current Record state.
					// This is part one of refactoring to include metatemplate resolution ase a core behavior pict itself rather than a pict-section-form capability
					Template: /*html*/`
						<li><a {~NE:Record.Data.Default^data-prsp-default="1"~} href="{~TBR:Record.Data.URL~}">{~TBR:Record.Data.Name~}</a></li>
		`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListEntry',
					TemplateHash: 'PRSP-List-RecordListEntry-Template',
					DestinationAddress: '#PRSP_RecordListEntry_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListRecordListEntry extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListEntry, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListRecordListEntry;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListEntry;

},{"pict-view":1053}],1034:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_RecordListHeader = (
	{
		ViewIdentifier: 'PRSP-List-RecordListHeader',

		DefaultRenderable: 'PRSP_Renderable_RecordListHeader',
		DefaultDestinationAddress: '#PRSP_RecordListHeader_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: false,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-RecordListHeader-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordListHeader-Template] -->
	<tr>
		{~TS:PRSP-List-RecordListHeader-Template-Header:Record.TableCells~}
		{~T:PRSP-List-RecordListHeader-Template-Extra-Header~}
		{~T:PRSP-List-RecordListActions-Template-Header~}
	</tr>
	<!-- DefaultPackage end view template:  [PRSP-List-RecordListHeader-Template] -->
	`
				},
				{
					// Per-column header dispatch: a sortable column (opt in via RecordSetListSortable / column
					// Sortable) renders a clickable, indicator-bearing header; otherwise the plain header. Exactly
					// one slot is populated per cell in RecordSet-List._stampSortState, so this stays a no-op change
					// for every list that has not opted into sorting.
					Hash: 'PRSP-List-RecordListHeader-Template-Header',
					Template: /*html*/`{~TS:PRSP-List-RecordListHeader-Header-Sortable:Record.SortableSlot~}{~TS:PRSP-List-RecordListHeader-Header-Plain:Record.PlainSlot~}`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-Plain',
					Template: /*html*/`
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333);">
		{~D:Record.DisplayName~}
	</th>
	`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-Sortable',
					Template: /*html*/`
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; background-color: var(--theme-color-background-tertiary, #f2f2f2); color: var(--theme-color-text-primary, #333); cursor: pointer; user-select: none; white-space: nowrap;" title="Sort by {~D:Record.DisplayName~}" onclick="_Pict.views['RSP-RecordSet-List'].sortByColumn('{~D:Record.RecordSet~}', '{~D:Record.Key~}')">
		{~D:Record.DisplayName~}{~TS:PRSP-List-RecordListHeader-Header-ChevronUp:Record.AscendingSlot~}{~TS:PRSP-List-RecordListHeader-Header-ChevronDown:Record.DescendingSlot~}
	</th>
	`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-ChevronUp',
					Template: /*html*/`<span style="margin-left: 4px; opacity: 0.85;">{~I:ChevronUp~}</span>`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Header-ChevronDown',
					Template: /*html*/`<span style="margin-left: 4px; opacity: 0.85;">{~I:ChevronDown~}</span>`
				},
				{
					Hash: 'PRSP-List-RecordListHeader-Template-Extra-Header',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordListHeader-Template-Extra-Header] -->
{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}
	<!-- DefaultPackage end view template:  [PRSP-List-RecordListHeader-Extra-Header] -->
	`
//	{~TBR:Record.RecordSetConfiguration.RecordSetListExtraColumnsHeaderTemplateHash~}

				},
				{
					Hash: 'PRSP-List-RecordListActions-Template-Header',
					// Unlabeled, shrink-to-fit actions column: width:1% + nowrap collapses it to the width of the
					// row's action control (the hover "⋯" trigger), and the other columns absorb the slack.
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-RecordListActions-Template-Header] -->
	<th style="border-bottom: 1px solid var(--theme-color-border-default, #ccc); padding: 5px; width: 1%; white-space: nowrap; background-color: var(--theme-color-background-tertiary, #f2f2f2);"></th>
	<!-- DefaultPackage end view template:  [PRSP-List-RecordListActions-Template-Header] -->
	`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_RecordListHeader',
					TemplateHash: 'PRSP-List-RecordListHeader-Template',
					DestinationAddress: '#PRSP_RecordListHeader_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetListRecordListHeader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_RecordListHeader, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListRecordListHeader;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_RecordListHeader;

},{"pict-view":1053}],1035:[function(require,module,exports){
/**
 * RecordSet-List-Sort
 *
 * Pure helpers for the OPT-IN sortable-column-header feature of the record set list. Kept free of view/DOM state
 * so the semantics -- which columns are sortable, the current sort parsed from the FoxHound filter string, the
 * click-toggle cycle, and rewriting the filter string -- are unit-testable on their own.
 *
 * Default behavior is unchanged: a column is sortable ONLY when the record set opts in with
 * RecordSetListSortable:true (whole list) or an individual column sets Sortable:true; a column can always opt out
 * with Sortable:false. The sort itself rides the existing FoxHound `FSF~<field>~<ASC|DESC>~0` stanza already
 * carried in the list's filter string, so there is no new transport -- a header click just rewrites that stanza
 * and re-navigates the list route.
 */

// A column is sortable when it opts in explicitly, or the whole list is sortable and the column has not opted out.
function columnIsSortable(pRecordSetConfiguration, pColumn)
{
	if (!pColumn) { return false; }
	if (pColumn.Sortable === true) { return true; }
	if (pColumn.Sortable === false) { return false; }
	return !!(pRecordSetConfiguration && pRecordSetConfiguration.RecordSetListSortable === true);
}

// Parse the active sort (if any) out of a list filter string -> { Field, Direction } or null. The filter string
// may arrive URI-encoded (it rides in the route), so decode defensively.
function parseSort(pFilterString)
{
	if (!pFilterString || typeof pFilterString !== 'string') { return null; }
	let tmpDecoded = pFilterString;
	try { tmpDecoded = decodeURIComponent(pFilterString); } catch (pDecodeError) { /* already decoded */ }
	let tmpMatch = /FSF~([^~]+)~(ASC|DESC)~/i.exec(tmpDecoded);
	if (!tmpMatch) { return null; }
	return { Field: tmpMatch[1], Direction: tmpMatch[2].toUpperCase() };
}

// The next sort state when a header is clicked: an unsorted column (or a different column) sorts ASC; ASC becomes
// DESC; DESC clears back to the natural order (null). A three-state cycle so a click can always undo itself.
function toggleSort(pCurrentSort, pKey)
{
	if (!pCurrentSort || pCurrentSort.Field !== pKey) { return { Field: pKey, Direction: 'ASC' }; }
	if (String(pCurrentSort.Direction).toUpperCase() === 'ASC') { return { Field: pKey, Direction: 'DESC' }; }
	return null;
}

// Rewrite a filter string's sort: strip any existing FSF stanza (fixed 4-token arity: FSF~field~dir~idx, so it
// is `~`-safe) and append the new one. Every other stanza (FBV filter clauses, etc.) is preserved untouched, so
// sorting composes with an active filter.
function applySort(pFilterString, pSort)
{
	let tmpDecoded = '';
	if (pFilterString && typeof pFilterString === 'string')
	{
		try { tmpDecoded = decodeURIComponent(pFilterString); } catch (pDecodeError) { tmpDecoded = pFilterString; }
	}
	let tmpStripped = tmpDecoded.replace(/~?FSF~[^~]+~[^~]+~[^~]+/gi, '');
	tmpStripped = tmpStripped.replace(/^~+/, '').replace(/~+$/, '');
	if (!pSort || !pSort.Field) { return tmpStripped; }
	let tmpSortStanza = 'FSF~' + pSort.Field + '~' + (String(pSort.Direction).toUpperCase() === 'DESC' ? 'DESC' : 'ASC') + '~0';
	return tmpStripped ? (tmpStripped + '~' + tmpSortStanza) : tmpSortStanza;
}

module.exports = { columnIsSortable, parseSort, toggleSort, applySort };

},{}],1036:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_List_Title =
{
	ViewIdentifier: 'PRSP-List-Title',

	DefaultRenderable: 'PRSP_Renderable_Title',
	DefaultDestinationAddress: '#PRSP_Title_Container',
	DefaultTemplateRecordAddress: false,

	// If this is set to true, when the App initializes this will.
	// While the App initializes, initialize will be called.
	AutoInitialize: false,
	AutoInitializeOrdinal: 0,

	// If this is set to true, when the App autorenders (on load) this will.
	// After the App initializes, render will be called.
	AutoRender: false,
	AutoRenderOrdinal: 0,

	AutoSolveWithApp: false,
	AutoSolveOrdinal: 0,

	CSS: false,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PRSP-List-Title-Template',
			Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Title-Template] -->
	<header id="PRSP_Title_Container">
		<h1 id="PRSP_Title">{~D:Record.Title~}</h1>
		<h2 id="PRSP_Subtitle">{~D:Record.Subtitle~}</h2>
		{~TIfAbs:PRSP-List-Title-CreateButton-Template:Record:Record.RecordSetConfiguration.RecordSetListShowCreateButton^TRUE^~}
		{~TIfAbs:PRSP-List-Title-BulkDeleteButton-Template:Record:Record.RecordSetConfiguration.RecordSetAllowBulkDelete^TRUE^~}
	</header>
	<!-- DefaultPackage end view template:	[PRSP-List-Title-Template] -->
`
		},
		{
			Hash: 'PRSP-List-Title-CreateButton-Template',
			Template: /*html*/`
	<!-- Optional list "New" action; opt in per record set via RecordSetConfiguration.RecordSetListShowCreateButton. -->
	<button type="button" class="prsp-list-title-create" title="Create a new record" onclick="_Pict.views['RSP-RecordSet-List'].createNew('{~D:Record.RecordSet~}')">{~I:Plus~} New</button>
`
		},
		{
			Hash: 'PRSP-List-Title-BulkDeleteButton-Template',
			Template: /*html*/`
	<!-- Optional list "Delete records" action; opt in per record set via RecordSetConfiguration.RecordSetAllowBulkDelete. -->
	<button type="button" class="prsp-list-title-bulkdelete" title="Select and delete a batch of records" onclick="_Pict.views['RSP-RecordSet-List'].openBulkDelete('{~D:Record.RecordSet~}')">{~I:Trash~} Delete records</button>
`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PRSP_Renderable_Title',
			TemplateHash: 'PRSP-List-Title-Template',
			DestinationAddress: '#PRSP_Title_Container',
			RenderMethod: 'replace'
		},
	],

	Manifests: {},
};

class viewRecordSetListTitle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION_List_Title, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = viewRecordSetListTitle;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_List_Title;

},{"pict-view":1053}],1037:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');

const viewHeaderList = require('./RecordSet-List-HeaderList.js');
const viewTitle = require('./RecordSet-List-Title.js');
const viewFilters = require('../RecordSet-Filters.js');
const viewPaginationTop = require('./RecordSet-List-PaginationTop.js');
const viewRecordList = require('./RecordSet-List-RecordList.js');
const viewRecordListHeader = require('./RecordSet-List-RecordListHeader.js');
const viewRecordListEntry = require('./RecordSet-List-RecordListEntry.js');
const viewPaginationBottom = require('./RecordSet-List-PaginationBottom.js');
const viewColumnChooser = require('./RecordSet-List-ColumnChooser.js');
const libSort = require('./RecordSet-List-Sort.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__List = (
	{
		ViewIdentifier: 'PRSP-List',

		DefaultRenderable: 'PRSP_Renderable_List',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
	.prsp-list-loading { width: 100%; padding: 0.25rem 0 0.5rem; }
	.prsp-list-loading-inner { display: inline-flex; align-items: center; gap: 0.55em; color: var(--theme-color-text-muted, #64748b); font-size: 1rem; padding: 0.5rem 0.25rem 0.7rem; }
	.prsp-list-spinner { display: inline-flex; animation: prsp-list-spin 0.9s linear infinite; }
	@keyframes prsp-list-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
	/* Skeleton ghost rows: a few light, theme-colored bars that fill the loading area so the preserved
	   row height doesn't read as a white void. A bottom fade blends the last rows into the page. */
	.prsp-list-skeleton { position: relative; animation: prsp-list-skeleton-pulse 1.8s ease-in-out infinite; }
	@keyframes prsp-list-skeleton-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.7; } }
	.prsp-list-skeleton-row { height: 2.6rem; margin: 0 0 0.7rem; border-radius: 8px; background: var(--theme-color-background-tertiary, #eceef2); }
	.prsp-list-skeleton-row:nth-child(4n) { width: 94%; }
	.prsp-list-skeleton-row:nth-child(5n) { width: 97%; }
	.prsp-list-skeleton-fade { position: absolute; left: 0; right: 0; bottom: 0; height: 4.5rem; background: linear-gradient(to bottom, transparent, var(--theme-color-background-primary, #fff)); pointer-events: none; }
	`,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-List-Template',
					Template: /*html*/`
	<!-- DefaultPackage pict view template: [PRSP-List-Template] -->
	<section id="PRSP_List_Container">
		{~V:PRSP-List-Title~}
		{~V:PRSP-List-HeaderList~}
		<section id="PRSP_Filters_Container">
			{~FV:PRSP-Filters:List~}
		</section>
		<div id="PRSP_ColumnChooser_Container">{~V:PRSP-List-ColumnChooser~}</div>
		<div id="PRSP_PaginationTop_Container">{~V:PRSP-List-PaginationTop~}</div>
		<div id="PRSP_RecordList_Container">{~V:PRSP-List-RecordList~}</div>
		<div id="PRSP_PaginationBottom_Container">{~V:PRSP-List-PaginationBottom~}</div>
	</section>
	<!-- DefaultPackage end view template:  [PRSP-List-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-Template-Record',
					Template: /*html*/`
	<!-- DefaultPackage end view template:  [PRSP-List-Template] -->
	`
				},
				{
					Hash: 'PRSP-List-LoadingShell',
					Template: /*html*/`
	<div id="PRSP_List_Loading" class="prsp-list-loading">
		<div class="prsp-list-loading-inner">
			<span class="prsp-list-spinner" aria-hidden="true">{~I:Refresh~}</span>
			<span class="prsp-list-loading-label">Loading…</span>
		</div>
		<div class="prsp-list-skeleton" aria-hidden="true">
			{~TS:PRSP-List-Skeleton-Row:Record.SkeletonRows~}
			<div class="prsp-list-skeleton-fade"></div>
		</div>
	</div>
	`
				},
				{
					Hash: 'PRSP-List-Skeleton-Row',
					Template: /*html*/`<div class="prsp-list-skeleton-row"></div>`
				}
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_List',
					TemplateHash: 'PRSP-List-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetList extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__List, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.childViews = {
			headerList: null,
			title: null,
			paginationTop: null,
			recordList: null,
			recordListHeader: null,
			recordListEntry: null,
			paginationBottom: null,
			columnChooser: null
		};

		// Identity (`RecordSet::FilterString::FilterExperience`) of the list currently painted into the DOM.
		// When a route only changes the page (Offset/PageSize) and this still matches, we re-render just the
		// rows + pagination instead of the whole view — see handleRecordSetListRoute / _paintRecordList.
		this._renderedListIdentity = null;

		// The last fully-composed list data (carrying the pristine ColumnCandidates) and the arguments of
		// the last render call — together they let a column-visibility toggle repaint the rows from data
		// already in hand (or, when a Lite fetch is missing the column, rerun the same render to refetch).
		this._lastRecordListData = null;
		this._lastListRenderArgs = null;
	}

	handleRecordSetListRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet List view route handler called with invalid route payload.`);
		}

		//_Pict.PictSectionRecordSet.recordSetProviderConfigurations['Book'], 'RSP-Provider-Book'
		// FIXME: Not in love with this but good enough to start.
		// FIXME: Typescript mumbo jumbo
		// if (!('PictSectionRecordSet' in this.pict))
		// {
		// 	return false;
		// }
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		if (this.delegateToCustomView('List', tmpProviderConfiguration, pRoutePayload)) { return true; }

		// Seed the initial-load filter from the recordset's RecordSetDefaultFilter when the URL supplies none (a plain
		// /PSRS/<set>/List with no /FilteredTo/ segment). This is how a recordset's default sort/filter (e.g. a
		// FSF~<dateColumn>~DESC~0 date-spine sort) actually reaches SQL on first paint -- otherwise the empty filter
		// yields primary-key order. Any user filter/sort produces a /FilteredTo/... URL, so pRoutePayload wins thereafter.
		const tmpFilterString = pRoutePayload.data.FilterString || (tmpProviderConfiguration && tmpProviderConfiguration.RecordSetDefaultFilter) || '';
		const tmpFilterExperience = pRoutePayload.data.FilterExperience || '';

		const tmpOffset = pRoutePayload.data.Offset ? pRoutePayload.data.Offset : 0;
		const tmpPageSize = pRoutePayload.data.PageSize ? pRoutePayload.data.PageSize : 100;

		// Surgical page render: when only the page changed (same RecordSet, FilterString, and
		// FilterExperience), re-render just the rows + pagination rather than the whole list view. A full
		// re-render rebuilds the filter view — including all of its picker/control state — which is by far
		// the most expensive part of a list paint and entirely wasted when only paging. Requires the list to
		// already be in the DOM (its rows container exists); otherwise we fall through to a full render.
		const tmpListIdentity = `${pRoutePayload.data.RecordSet}::${tmpFilterString}::${tmpFilterExperience}`;
		const tmpRenderBodyOnly = (this._renderedListIdentity === tmpListIdentity)
			&& (this.pict.ContentAssignment.getElement('#PRSP_RecordList_Container').length > 0);
		this._renderedListIdentity = tmpListIdentity;

		return this.renderList(tmpProviderConfiguration, tmpProviderHash, tmpFilterString, tmpFilterExperience, tmpOffset, tmpPageSize, tmpRenderBodyOnly);
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString/:Offset/:PageSize', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/FilteredTo/:FilterString', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/:Offset/:PageSize/FilterExperience/:FilterExperience', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/:Offset/:PageSize', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List/:Offset', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.on('/PSRS/:RecordSet/List', this.handleRecordSetListRoute.bind(this));
		pPictRouter.router.resolve();
		return true;
	}

	/**
	 * Navigate to the Create form for a record set. Backs the optional list title-bar "New" button
	 * (opt in per record set via RecordSetConfiguration.RecordSetListShowCreateButton). Routes through
	 * the section router so it works in both hash and memory router modes; falls back to the active
	 * route's record set when called without an argument.
	 * @param {string} [pRecordSet] - The record set to create a new record in.
	 * @return {boolean} True when navigation was issued.
	 */
	createNew(pRecordSet)
	{
		const tmpRecordSet = pRecordSet || this.fable?.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet;
		if (!tmpRecordSet)
		{
			this.log.warn(`RecordSetList: createNew called but no record set could be resolved.`);
			return false;
		}
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ tmpRecordSet }/Create`);
		return true;
	}

	/**
	 * Navigate to the Bulk Delete screen for a record set. Backs the optional list title-bar "Delete
	 * records" button (opt in per record set via RecordSetConfiguration.RecordSetAllowBulkDelete). Routes
	 * through the section router; falls back to the active route's record set when called without an argument.
	 * @param {string} [pRecordSet] - The record set to bulk-delete records from.
	 * @return {boolean} True when navigation was issued.
	 */
	openBulkDelete(pRecordSet)
	{
		const tmpRecordSet = pRecordSet || this.fable?.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet;
		if (!tmpRecordSet)
		{
			this.log.warn(`RecordSetList: openBulkDelete called but no record set could be resolved.`);
			return false;
		}
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ tmpRecordSet }/BulkDelete`);
		return true;
	}

	onBeforeRenderList(pRecordListData)
	{
		return pRecordListData;
	}

	// OPT-IN sortable column headers. Stamp each header cell with whether it is sortable + the active sort, so the
	// header template can render a clickable header + a direction indicator. Off unless the record set opts in
	// with RecordSetListSortable:true or a column sets Sortable:true (see RecordSet-List-Sort.js). The single-
	// element-array slots drive the header template's conditional branches (the pict {~TS:~} pattern). Idempotent.
	_stampSortState(pRecordListData)
	{
		if (!pRecordListData || !Array.isArray(pRecordListData.TableCells))
		{
			return pRecordListData;
		}
		const tmpConfiguration = pRecordListData.RecordSetConfiguration || {};
		const tmpCurrentSort = libSort.parseSort(pRecordListData.FilterString);
		for (let i = 0; i < pRecordListData.TableCells.length; i++)
		{
			const tmpCell = pRecordListData.TableCells[i];
			const tmpSortable = libSort.columnIsSortable(tmpConfiguration, tmpCell);
			tmpCell.Sortable = tmpSortable;
			tmpCell.RecordSet = pRecordListData.RecordSet;
			const tmpActive = !!(tmpSortable && tmpCurrentSort && tmpCurrentSort.Field === tmpCell.Key);
			tmpCell.SortAscending = tmpActive && (tmpCurrentSort.Direction === 'ASC');
			tmpCell.SortDescending = tmpActive && (tmpCurrentSort.Direction === 'DESC');
			tmpCell.SortableSlot = tmpSortable ? [ tmpCell ] : [];
			tmpCell.PlainSlot = tmpSortable ? [] : [ tmpCell ];
			tmpCell.AscendingSlot = tmpCell.SortAscending ? [ 1 ] : [];
			tmpCell.DescendingSlot = tmpCell.SortDescending ? [ 1 ] : [];
		}
		return pRecordListData;
	}

	// A sortable header was clicked: cycle its sort (unsorted -> ASC -> DESC -> unsorted), rewrite the list's
	// FoxHound filter string (preserving any active filter clause), and re-navigate the list route from page 0.
	// The sort rides the FSF stanza through the normal fetch, so any provider that honors FoxHound sorting works.
	sortByColumn(pRecordSet, pColumnKey)
	{
		const tmpArguments = (this._lastListRenderArgs && this._lastListRenderArgs.Args) || [];
		const tmpFromManifest = !!(this._lastListRenderArgs && this._lastListRenderArgs.Method === 'renderListFromManifest');
		// renderList Args: [config, providerHash, filterString, filterExperience, offset, pageSize].
		// renderListFromManifest Args: [manifest, config, providerHash, filterString, filterExperience, offset, pageSize].
		const tmpFilterString = tmpFromManifest ? tmpArguments[3] : tmpArguments[2];
		const tmpFilterExperience = tmpFromManifest ? tmpArguments[4] : tmpArguments[3];
		const tmpPageSize = (tmpFromManifest ? tmpArguments[6] : tmpArguments[5]) || 100;
		const tmpNextSort = libSort.toggleSort(libSort.parseSort(tmpFilterString), pColumnKey);
		const tmpNewFilterString = libSort.applySort(tmpFilterString, tmpNextSort);
		let tmpRoute = `/PSRS/${ pRecordSet }/List`;
		if (tmpNewFilterString)
		{
			tmpRoute += `/FilteredTo/${ encodeURIComponent(tmpNewFilterString) }`;
		}
		tmpRoute += `/0/${ tmpPageSize }`;
		if (tmpFilterExperience)
		{
			tmpRoute += `/FilterExperience/${ encodeURIComponent(tmpFilterExperience) }`;
		}
		this.fable.providers.RecordSetRouter.pictRouter.navigate(tmpRoute);
		return false;
	}

	/**
	 * Paint a loading shell into the list destination synchronously, before the data
	 * fetch, so the previous page doesn't sit silently while a slow query runs. The
	 * real list render (RenderMethod 'replace' into the same destination) overwrites
	 * it when data arrives. Opt out with RecordSetListShowLoadingShell:false.
	 * @param {Record<string, any>} pRecordListData
	 */
	_projectLoadingShell(pRecordListData)
	{
		try
		{
			const tmpConfig = pRecordListData && pRecordListData.RecordSetConfiguration;
			if (tmpConfig && tmpConfig.RecordSetListShowLoadingShell === false)
			{
				return;
			}
			if (!pRecordListData || !pRecordListData.RenderDestination)
			{
				return;
			}
			// When the list is already on screen, scope the spinner to just the rows area so the title,
			// filters, and pagination stay put (and the expensive filter view isn't disturbed). On the first
			// render the rows container doesn't exist yet, so fall back to the whole list destination.
			const tmpRowsElements = this.pict.ContentAssignment.getElement('#PRSP_RecordList_Container');
			const tmpRowsContainerPresent = tmpRowsElements.length > 0;
			const tmpDestination = tmpRowsContainerPresent ? '#PRSP_RecordList_Container' : pRecordListData.RenderDestination;
			// Fill roughly the visible viewport with ghost rows (each skeleton row occupies ~53px), capped to
			// the preserved height so a short list doesn't over-fill, and clamped to a sane range.
			const tmpViewportHeight = (typeof window !== 'undefined' && window.innerHeight) ? window.innerHeight : 800;
			let tmpFillHeight = tmpViewportHeight + 200;
			if (tmpRowsContainerPresent)
			{
				// Pin the rows area to its current height before swapping in the spinner, so the page doesn't
				// collapse and yank the content below it — pagination, the page's footer/colored fill — up into
				// the fold and back. The floor is released once the real rows render (see _paintRecordList).
				const tmpCurrentHeight = tmpRowsElements[0].offsetHeight;
				if (tmpCurrentHeight > 0)
				{
					tmpRowsElements[0].style.minHeight = `${ tmpCurrentHeight }px`;
					tmpFillHeight = Math.min(tmpCurrentHeight, tmpFillHeight);
				}
			}
			const tmpSkeletonRowCount = Math.max(6, Math.min(60, Math.ceil(tmpFillHeight / 53)));
			this.pict.CSSMap.injectCSS();
			// Render the spinner + enough skeleton ghost rows to fill the visible area (so no white void shows).
			const tmpLoadingShellData = { SkeletonRows: new Array(tmpSkeletonRowCount).fill(0) };
			this.pict.ContentAssignment.assignContent(tmpDestination, this.pict.parseTemplateByHash('PRSP-List-LoadingShell', tmpLoadingShellData));
		}
		catch (pError)
		{
			// The loading shell is purely cosmetic; never let it break the list render.
			this.log.warn(`RecordSetList: loading shell render failed: ${ pError && pError.message }`);
		}
	}

	/**
	 * The schema columns that never become list columns automatically: the entity's own
	 * identity pair plus the audit stamps. (Hosts that want one of these in the column
	 * chooser declare it as a curated column, optionally with DefaultHidden.)
	 *
	 * @param {string} pEntity - The entity name (for the ID/GUID identity columns)
	 * @return {Array<string>} The excluded column names.
	 */
	_getExcludedSchemaColumns(pEntity)
	{
		return [
			'ID' + pEntity,
			'GUID' + pEntity,
			'CreateDate',
			'CreatingIDUser',
			'DeleteDate',
			'Deleted',
			'DeletingIDUser',
			'UpdateDate',
			'UpdatingIDUser',
			'IDCustomer', // meadow-endpoints/retold tenancy discriminator — server-managed, hidden from every record view
			'ExternalSyncDate', 'ExternalSyncGUID', // external-sync auditing stamps (Headlight integration sync)
		];
	}

	dynamicallyGenerateColumns(pRecordListData)
	{
		pRecordListData.TableCells = [];
		const tmpEntity = pRecordListData.RecordSetConfiguration.Entity;
		this.excludedByDefaultCells = this._getExcludedSchemaColumns(tmpEntity);

		const tmpSchema = pRecordListData.RecordSchema;
		const tmpProperties = tmpSchema?.properties;
		// loop throught the schema and add the columns to the tableCells
		for (const tmpColumn in tmpProperties)
		{
			if (tmpProperties.hasOwnProperty(tmpColumn))
			{
				// Check if the column is excluded by the default list of columns (or is not a GUID/ID)
				if (this.excludedByDefaultCells.includes(tmpColumn) === false)
				{
					pRecordListData.TableCells.push({
						'Key': tmpColumn,
						'DisplayName': tmpProperties?.[tmpColumn].title || tmpColumn,
						'PictDashboard': {
							'ValueTemplate': '{~ProcessCell:Record.Data.Key~}'
						}
					});
				}
			}
		}
		return pRecordListData;
	}

	/**
	 * Map column name -> Meadow column Type from the entity schema, when available. The schema
	 * endpoint nests the canonical column array at MeadowSchema.MeadowSchema.Schema (with a
	 * legacy flat MeadowSchema.Schema fallback). Returns null when neither is present (e.g.
	 * non-Meadow providers) so callers can skip type-based exclusions.
	 *
	 * @param {Record<string, any>} pRecordSchema - The schema from getRecordSchema()
	 * @return {Record<string, string>|null} Column name -> Type map, or null.
	 */
	_getMeadowColumnTypes(pRecordSchema)
	{
		const tmpSchemaColumns = pRecordSchema?.MeadowSchema?.MeadowSchema?.Schema || pRecordSchema?.MeadowSchema?.Schema;
		if (!Array.isArray(tmpSchemaColumns) || tmpSchemaColumns.length < 1)
		{
			return null;
		}
		/** @type {Record<string, string>} */
		const tmpColumnTypes = {};
		for (const tmpColumn of tmpSchemaColumns)
		{
			if (tmpColumn && tmpColumn.Column)
			{
				tmpColumnTypes[tmpColumn.Column] = tmpColumn.Type;
			}
		}
		return tmpColumnTypes;
	}

	/**
	 * Whether a column candidate is effectively visible: an explicit user override wins,
	 * otherwise the candidate's default (visible unless DefaultHidden).
	 *
	 * @param {Record<string, any>} pCandidate - A ColumnCandidates entry
	 * @param {Record<string, boolean>} pOverrides - The per-recordset override map
	 * @return {boolean}
	 */
	_effectiveColumnVisibility(pCandidate, pOverrides)
	{
		if (pOverrides && (pCandidate.Key in pOverrides))
		{
			return (pOverrides[pCandidate.Key] === true);
		}
		return (pCandidate.DefaultHidden !== true);
	}

	/**
	 * Compute the visible TableCells for a paint from the pristine candidate list + the user's
	 * current overrides. Cells are per-paint shallow copies so host hooks can mutate them without
	 * bleeding into the candidates. An override set that hides everything falls back to the
	 * default-visible set (a fully empty table is a confusing dead end).
	 *
	 * @param {Array<Record<string, any>>} pCandidates - The pristine ColumnCandidates
	 * @param {string} pRecordSet - The record set (for the override lookup)
	 * @return {Array<Record<string, any>>} The visible cells, in candidate order.
	 */
	_computeVisibleTableCells(pCandidates, pRecordSet)
	{
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		const tmpOverrides = tmpColumnProvider ? tmpColumnProvider.getColumnVisibilityOverrides(pRecordSet, 'List') : {};
		let tmpVisibleCells = pCandidates
			.filter((pCandidate) => this._effectiveColumnVisibility(pCandidate, tmpOverrides))
			.map((pCell) => Object.assign({}, pCell));
		if (tmpVisibleCells.length < 1)
		{
			this.log.warn(`RecordSetList: column visibility overrides for [${pRecordSet}] hid every column; rendering the default-visible set instead.`);
			tmpVisibleCells = pCandidates
				.filter((pCandidate) => pCandidate.DefaultHidden !== true)
				.map((pCell) => Object.assign({}, pCell));
		}
		return tmpVisibleCells;
	}

	/**
	 * Compose the column-chooser candidate pool and reduce TableCells to the visible subset.
	 *
	 * No-op unless the recordset opts in with RecordSetListColumnChooser: true — the flag off
	 * leaves TableCells exactly as the existing paths computed it (including the manifest's
	 * shared array reference).
	 *
	 * Candidates are two tiers, in order:
	 *  - Curated: the host-declared columns (manifest Descriptors or RecordSetListColumns),
	 *    shallow-copied (the shared manifest TableCells entries are never mutated), default
	 *    visible unless the column/descriptor declares DefaultHidden: true.
	 *  - Schema: remaining scalar entity columns (identity/audit fields and blob Text/JSON
	 *    columns excluded), default hidden, rendered via the generic ProcessCell template
	 *    (entity-reference ID* columns resolve names exactly like dynamic columns do).
	 *
	 * The pristine candidates ride on pRecordListData.ColumnCandidates (module-owned — host
	 * hooks must not mutate it); TableCells becomes per-paint copies of the visible subset.
	 *
	 * @param {Record<string, any>} pRecordListData - The list data (TableCells already computed)
	 * @return {Record<string, any>} The same list data, candidates composed.
	 */
	_composeColumnCandidates(pRecordListData)
	{
		// Always an array (empty = render nothing): a missing address would make the chooser
		// button's {~TS:~} iterate the record object's own keys instead of rendering nothing.
		pRecordListData.ColumnChooserSlot = [];
		const tmpConfig = pRecordListData.RecordSetConfiguration;
		if (!tmpConfig || tmpConfig.RecordSetListColumnChooser !== true)
		{
			return pRecordListData;
		}

		// Curated tier: shallow copies of whatever the host declared, flagged with source + default.
		const tmpCandidates = (pRecordListData.TableCells || []).map((pCell) =>
			Object.assign({}, pCell, { Source: 'Curated', DefaultHidden: (pCell.DefaultHidden === true) }));
		const tmpCuratedKeys = {};
		for (const tmpCell of tmpCandidates)
		{
			tmpCuratedKeys[tmpCell.Key] = true;
		}

		// Schema tier: every remaining scalar entity column, default hidden.
		const tmpExcludedColumns = this._getExcludedSchemaColumns(tmpConfig.Entity);
		const tmpProperties = pRecordListData.RecordSchema?.properties;
		const tmpMeadowColumnTypes = this._getMeadowColumnTypes(pRecordListData.RecordSchema);
		const tmpBlobTypes = { 'Text': true, 'JSON': true };
		const tmpSchemaCandidates = [];
		for (const tmpColumn in tmpProperties)
		{
			if (!tmpProperties.hasOwnProperty(tmpColumn) || tmpCuratedKeys[tmpColumn] || tmpExcludedColumns.includes(tmpColumn))
			{
				continue;
			}
			// When the Meadow schema is available, only offer real non-blob columns — a JSON-schema-only
			// property is not fetchable by a Lite projection, and blob columns are why Lite exists.
			if (tmpMeadowColumnTypes && (!(tmpColumn in tmpMeadowColumnTypes) || tmpBlobTypes[tmpMeadowColumnTypes[tmpColumn]]))
			{
				continue;
			}
			tmpSchemaCandidates.push(
				{
					Key: tmpColumn,
					DisplayName: tmpProperties[tmpColumn].title || tmpColumn,
					ManifestHash: 'Default',
					PictDashboard: { ValueTemplate: '{~ProcessCell:Record.Data.Key~}' },
					Source: 'Schema',
					DefaultHidden: true,
				});
		}
		tmpSchemaCandidates.sort((pA, pB) => String(pA.DisplayName).localeCompare(String(pB.DisplayName)));

		// Audit tier: the identity pair + audit stamps, with friendly labels, trailing the schema
		// tier. Default hidden; the create/update/delete user references resolve names via the same
		// ProcessCell path as any other entity-reference column. (Pair with the show-deleted filter
		// — RecordSetListShowDeletedFilter — to make the three Deleted* columns meaningful.)
		const tmpAuditColumnLabels =
		{
			[`ID${tmpConfig.Entity}`]: 'ID',
			[`GUID${tmpConfig.Entity}`]: 'GUID',
			'CreateDate': 'Created',
			'CreatingIDUser': 'Created by',
			'UpdateDate': 'Updated',
			'UpdatingIDUser': 'Updated by',
			'Deleted': 'Deleted',
			'DeleteDate': 'Deleted on',
			'DeletingIDUser': 'Deleted by',
		};
		const tmpAuditCandidates = [];
		for (const tmpColumn of Object.keys(tmpAuditColumnLabels))
		{
			if (!tmpProperties || !tmpProperties.hasOwnProperty(tmpColumn) || tmpCuratedKeys[tmpColumn])
			{
				continue;
			}
			tmpAuditCandidates.push(
				{
					Key: tmpColumn,
					DisplayName: tmpAuditColumnLabels[tmpColumn],
					ManifestHash: 'Default',
					PictDashboard: { ValueTemplate: '{~ProcessCell:Record.Data.Key~}' },
					Source: 'Audit',
					DefaultHidden: true,
				});
		}

		pRecordListData.ColumnCandidates = tmpCandidates.concat(tmpSchemaCandidates, tmpAuditCandidates);
		pRecordListData.TableCells = this._computeVisibleTableCells(pRecordListData.ColumnCandidates, pRecordListData.RecordSet);
		// One-or-zero-element array driving the chooser button render (the {~TS:~} conditional trick).
		pRecordListData.ColumnChooserSlot = [ { RecordSet: pRecordListData.RecordSet } ];
		return pRecordListData;
	}

	/**
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 * @param {boolean} [pBodyOnly] - When true, re-render only the rows + pagination (page change), leaving the filter view intact.
	 *
	 * @return {Promise<void>}
	 */
	async renderList(pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize, pBodyOnly)
	{
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetList: No provider found for ${pProviderHash} in RecordSet ${(pRecordSetConfiguration || {}).RecordSet}.  List Render failed.`);
			return;
		}

		// Remember how this list was rendered so a column-visibility change can rerun the exact same
		// render (the manifest delegation below overwrites this with its own, which is what we want).
		this._lastListRenderArgs = { Method: 'renderList', Args: [ pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize ] };

		if (pRecordSetConfiguration.RecordSetListManifestOnly)
		{
			const tmpManifestHash = pRecordSetConfiguration.RecordSetListDefaultManifest || pRecordSetConfiguration.RecordSetListManifests?.[0];
			const tmpManifest = this.pict.PictSectionRecordSet.manifestDefinitions[tmpManifestHash];
			if (!tmpManifest)
			{
				this.pict.log.error(`RecordSetList: No manifest found for ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			}
			else
			{
				return this.renderListFromManifest(tmpManifest, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize, pBodyOnly);
			}
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordListData =
		{
			"Title": pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Paint a loading shell before the (potentially slow) fetch so the prior page
		// doesn't sit silently; the real list render replaces it when data arrives.
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordListData.RecordSet);
		}
		this._projectLoadingShell(tmpRecordListData);
		// Fetch the records
		const [ tmpRecords, tmpTotalRecordCount, tmpRecordSchema ] = await Promise.all([
			this.pict.providers[pProviderHash].getRecords(tmpRecordListData),
			this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordListData),
			this.pict.providers[pProviderHash].getRecordSchema(),
		]);
		tmpRecordListData.Records = tmpRecords;
		// Get the total record count
		tmpRecordListData.TotalRecordCount = tmpTotalRecordCount;
		// Get the record schema
		tmpRecordListData.RecordSchema = tmpRecordSchema;

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordListData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		tmpRecordListData.PageEnd = Number(tmpRecordListData.Offset) + tmpRecordListData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordListData.PageStart = (tmpRecordListData.Records.Records.length > 0) ? (Number(tmpRecordListData.Offset) + 1) : 0;

		// Compute the number of pages total
		tmpRecordListData.PageCount = Math.ceil(tmpRecordListData.TotalRecordCount.Count / tmpRecordListData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordListData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordListData.Offset / tmpRecordListData.PageSize)
			});
		tmpRecordListData.PageLinks = [];
		for (let i = 0; i < tmpRecordListData.PageCount; i++)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinks[tmpRecordListData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordListData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordListData.PageLinks.length, tmpRecordListData.PageLinkBookmarks.Current + 10);
		tmpRecordListData.PageLinksLimited = tmpRecordListData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${0}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordListData.PageLinks.length)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordListData.PageLinkBookmarks.Previous = tmpRecordListData.PageLinkBookmarks.Current - 1;
		tmpRecordListData.PageLinkBookmarks.Next = tmpRecordListData.PageLinkBookmarks.Current + 1;
		tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordListData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordListData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordListData.PageLinkBookmarks.Next >= tmpRecordListData.PageLinks.length)
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Next];
		}

		// When there is only a single page there is nothing to paginate: hide the page
		// buttons and the previous/next links. The "Showing X to Y of Z" summary stays.
		if (tmpRecordListData.PageCount <= 1)
		{
			tmpRecordListData.PageLinksLimited = [];
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		// Put code here to preprocess columns into other data parts.
		if (tmpRecordListData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
		{
			tmpRecordListData.TableCells = tmpRecordListData.RecordSetConfiguration.RecordSetListColumns.map((key) =>
				{
					if (typeof key === 'object')
					{
						if (!key.DisplayName)
						{
							key.DisplayName = key.Key; //FIXME: use schema?
						}
						if (!key.ManifestHash)
						{
							key.ManifestHash = 'Default';
						}
						if (!key.PictDashboard)
						{
							key.PictDashboard =
							{
								ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
							};
						}
						return key;
					}
					return {
						Key: key,
						DisplayName: key, //FIXME: use schema?
						ManifestHash: 'Default',
						PictDashboard:
						{
							ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
						},
					};
				});
		}
		else
		{
			this.dynamicallyGenerateColumns(tmpRecordListData);
		}
		this._composeColumnCandidates(tmpRecordListData);
		this._lastRecordListData = tmpRecordListData;
		tmpRecordListData = this.onBeforeRenderList(tmpRecordListData);

		this._paintRecordList(tmpRecordListData, pBodyOnly);
	}

	/**
	 * @param {object} pManifest
	 * @param {Record<string, any>} pRecordSetConfiguration
	 * @param {string} pProviderHash
	 * @param {string} pFilterString
	 * @param {string} pSerializedFilterExperience
	 * @param {number} pOffset
	 * @param {number} pPageSize
	 * @param {boolean} [pBodyOnly] - When true, re-render only the rows + pagination (page change), leaving the filter view intact.
	 *
	 * @return {Promise<void>}
	 */
	async renderListFromManifest(pManifest, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize, pBodyOnly)
	{
		if (!pRecordSetConfiguration)
		{
			this.pict.log.error(`RecordSetList: No record set configuration found.  List Render failed.`);
			return;
		}
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetList: No provider found for ${pProviderHash} in ${pRecordSetConfiguration.RecordSet}.  List Render failed.`);
			return;
		}

		// Remember how this list was rendered so a column-visibility change can rerun the exact same
		// render. When renderList delegated here this overwrite wins — a rerun skips re-resolving the
		// manifest — and hosts that call renderListFromManifest directly are covered the same way.
		this._lastListRenderArgs = { Method: 'renderListFromManifest', Args: [ pManifest, pRecordSetConfiguration, pProviderHash, pFilterString, pSerializedFilterExperience, pOffset, pPageSize ] };

		let tmpTitle = pRecordSetConfiguration.Title || pRecordSetConfiguration.RecordSet;
		if (pManifest && pManifest.TitleTemplate)
		{
			tmpTitle = this.pict.parseTemplate(pManifest.TitleTemplate, pRecordSetConfiguration);
		}

		const tmpEncodedFilterExperience = pSerializedFilterExperience && encodeURIComponent(pSerializedFilterExperience);
		if (tmpEncodedFilterExperience)
		{
			// shove filter xp into the active filters for this recordset
			const tmpExperienceFromURL = await this.pict.views['PRSP-Filters'].deserializeFilterExperience(pSerializedFilterExperience);
			if (tmpExperienceFromURL)
			{
				this.pict.manifest.setValueByHash(this.pict.Bundle, `_ActiveFilterState[${pRecordSetConfiguration.RecordSet}].FilterClauses`, tmpExperienceFromURL);
			}
		}

		let tmpRecordListData =
		{
			"Title": tmpTitle,

			"RecordSet": pRecordSetConfiguration.RecordSet,
			"RecordSetConfiguration": pRecordSetConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"FilterString": pFilterString ? encodeURIComponent(pFilterString) : undefined,

			"Records": { "Records": [] },
			"TotalRecordCount": { "Count": -1 },

			"Offset": pOffset || 0,
			"PageSize": pPageSize || 100,
		};

		// TODO: There are still problems with the way these have nested data.  Discuss how we might move that around
		// Paint a loading shell before the (potentially slow) fetch so the prior page
		// doesn't sit silently; the real list render replaces it when data arrives.
		// Seed any configured default filter clauses (e.g. DefaultRelativeDays) BEFORE the
		// fetch, so the first paint is already filtered the way the dashboard is configured
		// rather than filtered only once the user presses Apply.
		if (this.pict.views['PRSP-Filters'] && (typeof this.pict.views['PRSP-Filters'].seedDefaultFilterClauses === 'function'))
		{
			await this.pict.views['PRSP-Filters'].seedDefaultFilterClauses(tmpRecordListData.RecordSet);
		}
		this._projectLoadingShell(tmpRecordListData);
		// Fetch the records
		tmpRecordListData.Records = await this.pict.providers[pProviderHash].getDecoratedRecords(tmpRecordListData);
		// Get the total record count
		tmpRecordListData.TotalRecordCount = await this.pict.providers[pProviderHash].getRecordSetCount(tmpRecordListData);
		// Get the record schema
		tmpRecordListData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();

		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordListData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		// Get the "page end record number" for the current page (e.g. for messaging like Record 700 to 800 of 75,000)
		const tmpOffset = Number(tmpRecordListData.Offset);
		tmpRecordListData.PageEnd = tmpOffset + tmpRecordListData.Records.Records.length;
		// 1-based start record number for the "Showing X to Y" counter (the raw 0-based Offset would read "0 to ..." on page 1)
		tmpRecordListData.PageStart = (tmpRecordListData.Records.Records.length > 0) ? (tmpOffset + 1) : 0;

		// Compute the number of pages total
		tmpRecordListData.PageCount = Math.ceil(tmpRecordListData.TotalRecordCount.Count / tmpRecordListData.PageSize);

		// Generate each page's links.
		// TODO: This is fast and cool; any reason not to?
		// Get "bookmarks" as references to the array of page links.
		tmpRecordListData.PageLinkBookmarks = (
			{
				Current: Math.floor(tmpRecordListData.Offset / tmpRecordListData.PageSize)
			});
		tmpRecordListData.PageLinks = [];
		for (let i = 0; i < tmpRecordListData.PageCount; i++)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinks.push(
					{
						Page: i + 1,
						RelativeOffset: i - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${i * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinks[tmpRecordListData.PageLinks.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		//FIXME: short-term workaround to not blow up the tempplate rendering with way too many links
		const linkRangeStart = Math.max(0, tmpRecordListData.PageLinkBookmarks.Current - 10);
		const linkRangeEnd = Math.min(tmpRecordListData.PageLinks.length, tmpRecordListData.PageLinkBookmarks.Current + 10);
		tmpRecordListData.PageLinksLimited = tmpRecordListData.PageLinks.slice(linkRangeStart, linkRangeEnd);
		if (linkRangeStart > 0)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/0/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.unshift(
					{
						Page: 1,
						RelativeOffset: -tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/0/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}
		if (linkRangeEnd < tmpRecordListData.PageLinks.length)
		{
			if (tmpRecordListData.FilterString)
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/FilteredTo/${tmpRecordListData.FilterString}/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			else
			{
				tmpRecordListData.PageLinksLimited.push(
					{
						Page: tmpRecordListData.PageCount,
						RelativeOffset: (tmpRecordListData.PageCount - 1) - tmpRecordListData.PageLinkBookmarks.Current,
						URL: `#/PSRS/${tmpRecordListData.RecordSet}/List/${(tmpRecordListData.PageCount - 1) * tmpRecordListData.PageSize}/${tmpRecordListData.PageSize}`
					});
			}
			if (tmpEncodedFilterExperience)
			{
				tmpRecordListData.PageLinksLimited[tmpRecordListData.PageLinksLimited.length - 1].URL += `/FilterExperience/${tmpEncodedFilterExperience}`;
			}
		}

		tmpRecordListData.PageLinkBookmarks.Previous = tmpRecordListData.PageLinkBookmarks.Current - 1;
		tmpRecordListData.PageLinkBookmarks.Next = tmpRecordListData.PageLinkBookmarks.Current + 1;
		tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = true;
		tmpRecordListData.PageLinkBookmarks.ShowNextLink = true;
		if (tmpRecordListData.PageLinkBookmarks.Previous < 0)
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.PreviousLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Previous];
		}
		if (tmpRecordListData.PageLinkBookmarks.Next >= tmpRecordListData.PageLinks.length)
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		else
		{
			tmpRecordListData.PageLinkBookmarks.NextLink = tmpRecordListData.PageLinks[tmpRecordListData.PageLinkBookmarks.Next];
		}

		// When there is only a single page there is nothing to paginate: hide the page
		// buttons and the previous/next links. The "Showing X to Y of Z" summary stays.
		if (tmpRecordListData.PageCount <= 1)
		{
			tmpRecordListData.PageLinksLimited = [];
			tmpRecordListData.PageLinkBookmarks.ShowPreviousLink = false;
			tmpRecordListData.PageLinkBookmarks.ShowNextLink = false;
		}
		tmpRecordListData.TableCells = pManifest?.TableCells;

		if (!tmpRecordListData.TableCells)
		{
			if (tmpRecordListData.RecordSetConfiguration.hasOwnProperty('RecordSetListColumns'))
			{
				tmpRecordListData.TableCells = tmpRecordListData.RecordSetConfiguration.RecordSetListColumns.map((key) =>
					{
						if (typeof key === 'object')
						{
							if (!key.DisplayName)
							{
								key.DisplayName = key.Key; //FIXME: use schema?
							}
							if (!key.ManifestHash)
							{
								key.ManifestHash = 'Default';
							}
							if (key.PictDashboard && !key.PictDashboard.ValueTemplate)
							{
								key.PictDashboard.ValueTemplate = '{~ProcessCell:Record.Data.Key~}';
							}
							return key;
						}
						return {
							Key: key,
							DisplayName: key, //FIXME: use schema?
							ManifestHash: 'Default',
							PictDashboard:
							{
								ValueTemplate: '{~ProcessCell:Record.Data.Key~}',
							},
						};
					});
			}
			else
			{
				this.dynamicallyGenerateColumns(tmpRecordListData);
			}
		}

		this._composeColumnCandidates(tmpRecordListData);
		this._lastRecordListData = tmpRecordListData;
		tmpRecordListData = this.onBeforeRenderList(tmpRecordListData);

		this.pict.providers.DynamicRecordsetSolver.solveDashboard(pManifest, tmpRecordListData.Records.Records);

		this._paintRecordList(tmpRecordListData, pBodyOnly);
	}

	/**
	 * Paint the computed record-list data into the DOM.
	 *
	 * Full render (pBodyOnly falsy): render the whole `PRSP_Renderable_List` (title, header, filters,
	 * pagination, rows) into the list destination — the original behavior.
	 *
	 * Body-only render (pBodyOnly true): only the page changed, so re-render just the rows and the two
	 * pagination strips into their stable containers, leaving the filter view (and its picker/control state)
	 * completely untouched. Each child is rendered with the freshly-computed record passed as an object, so
	 * it produces exactly what the inline `{~V:~}` render would have.
	 *
	 * @param {Record<string, any>} pRecordListData - The fully-computed list data (records, pagination, cells).
	 * @param {boolean} [pBodyOnly] - When true, surgically re-render only rows + pagination.
	 * @return {void}
	 */
	_paintRecordList(pRecordListData, pBodyOnly)
	{
		// Stamp the opt-in sort state onto the header cells before the header repaints (no-op unless sorting is on).
		this._stampSortState(pRecordListData);
		const fLogRendered = function (pError)
		{
			if (pError)
			{
				this.pict.log.error(`RecordSetList: Error rendering list ${pError}`, pRecordListData);
				return;
			}
			if (this.pict.LogNoisiness > 0)
			{
				this.pict.log.info(`RecordSetList: Rendered list ${pRecordListData.RecordSet} with ${pRecordListData.Records.Records.length} records.`, pRecordListData);
			}
			else
			{
				this.pict.log.info(`RecordSetList: Rendered list ${pRecordListData.RecordSet} with ${pRecordListData.Records.Records.length} records.`);
			}
		}.bind(this);

		if (!pBodyOnly)
		{
			this.renderAsync('PRSP_Renderable_List', pRecordListData.RenderDestination, pRecordListData, fLogRendered);
			return;
		}

		// Page-only change: re-render the two pagination strips (current page + "showing X of Y") and the
		// rows, each into its own stable container. The filter view, title, and header list are left as-is.
		this.childViews.paginationTop.renderAsync('PRSP_Renderable_PaginationTop', '#PRSP_PaginationTop_Container', pRecordListData, null, () => { });
		this.childViews.paginationBottom.renderAsync('PRSP_Renderable_PaginationBottom', '#PRSP_PaginationBottom_Container', pRecordListData, null, () => { });
		this.childViews.recordList.renderAsync('PRSP_Renderable_RecordList', '#PRSP_RecordList_Container', pRecordListData, null,
			function (pError)
			{
				// Release the height floor that was pinned while the spinner showed (see _projectLoadingShell),
				// now that the real rows are back in and the container can size to its content again.
				const tmpRows = this.pict.ContentAssignment.getElement('#PRSP_RecordList_Container');
				if (tmpRows.length)
				{
					tmpRows[0].style.minHeight = '';
				}
				fLogRendered(pError);
			}.bind(this));
	}

	/**
	 * Set a column's visibility for the currently rendered list (called by the column chooser).
	 *
	 * Persists the override, then repaints the rows + pagination body-only from the data already
	 * in hand — except when a Lite-fetched list is showing a schema-tier column whose values were
	 * never fetched, in which case the same render is rerun so the provider widens the projection.
	 *
	 * @param {string} pRecordSet - The record set the column belongs to (stale-chooser guard)
	 * @param {string} pKey - The column key
	 * @param {boolean} pVisible - Whether the column should be visible
	 * @return {boolean} The column's resulting visibility.
	 */
	setColumnVisibility(pRecordSet, pKey, pVisible)
	{
		const tmpListData = this._lastRecordListData;
		if (!tmpListData || tmpListData.RecordSet !== pRecordSet || !Array.isArray(tmpListData.ColumnCandidates))
		{
			this.log.warn(`RecordSetList: setColumnVisibility for [${pRecordSet}.${pKey}] ignored — that list is not the one currently rendered.`);
			return false;
		}
		const tmpCandidate = tmpListData.ColumnCandidates.find((pCandidate) => pCandidate.Key === pKey);
		if (!tmpCandidate)
		{
			this.log.warn(`RecordSetList: setColumnVisibility for unknown column [${pKey}] on [${pRecordSet}] ignored.`);
			return false;
		}
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		if (!tmpColumnProvider)
		{
			return this._effectiveColumnVisibility(tmpCandidate, {});
		}
		// Keep at least one column visible — an all-hidden table is a confusing dead end.
		if (pVisible !== true)
		{
			const tmpOverrides = tmpColumnProvider.getColumnVisibilityOverrides(pRecordSet, 'List');
			const tmpVisibleCount = tmpListData.ColumnCandidates.filter((pCandidate) => this._effectiveColumnVisibility(pCandidate, tmpOverrides)).length;
			if ((tmpVisibleCount <= 1) && this._effectiveColumnVisibility(tmpCandidate, tmpOverrides))
			{
				this.log.warn(`RecordSetList: refusing to hide the last visible column [${pKey}] on [${pRecordSet}].`);
				return true;
			}
		}
		tmpColumnProvider.setColumnVisibilityOverride(pRecordSet, 'List', pKey, (pVisible === true));

		// Lite projections omit unrequested columns entirely, so a newly shown schema- or audit-tier
		// column with no data in the fetched records needs one refetch (the provider reads the override
		// map at fetch time and widens the projection). Curated/manifest columns are always fetched or
		// solved, and schema/audit keys are flat — a first-record key check is sound. (The identity pair,
		// CreatingIDUser, and UpdateDate ride free in every Lite record, so they pass the key check.)
		const tmpRecords = (tmpListData.Records && Array.isArray(tmpListData.Records.Records)) ? tmpListData.Records.Records : [];
		const tmpNeedsRefetch = (pVisible === true)
			&& (tmpCandidate.Source !== 'Curated')
			&& (tmpListData.RecordSetConfiguration && tmpListData.RecordSetConfiguration.RecordSetListLiteFetch === true)
			&& (tmpRecords.length > 0)
			&& !(pKey in tmpRecords[0]);
		if (tmpNeedsRefetch)
		{
			this._rerunLastListRender();
		}
		else
		{
			this._repaintWithColumnState();
		}
		return (pVisible === true);
	}

	/**
	 * Clear every column-visibility override for the currently rendered list and repaint with the
	 * defaults (called by the column chooser's Reset). Never needs a refetch: resetting only
	 * restores curated columns (always fetched) and hides schema extras.
	 *
	 * @param {string} pRecordSet - The record set to reset (stale-chooser guard)
	 * @return {boolean} True when the reset happened.
	 */
	resetColumnVisibility(pRecordSet)
	{
		const tmpListData = this._lastRecordListData;
		if (!tmpListData || tmpListData.RecordSet !== pRecordSet)
		{
			this.log.warn(`RecordSetList: resetColumnVisibility for [${pRecordSet}] ignored — that list is not the one currently rendered.`);
			return false;
		}
		const tmpColumnProvider = this.pict.providers.ColumnDataProvider;
		if (tmpColumnProvider)
		{
			tmpColumnProvider.clearColumnVisibilityOverrides(pRecordSet, 'List');
		}
		this._repaintWithColumnState();
		return true;
	}

	/**
	 * Repaint the rows + pagination (body-only) from the last composed list data, with TableCells
	 * recomputed from the pristine candidates + current overrides. onBeforeRenderList is re-invoked
	 * — it is the documented seam where hosts append custom cells, and rebuilding TableCells from
	 * candidates each paint means hook mutations apply exactly once per paint. (Hosts that decorate
	 * Records in the hook must keep that decoration idempotent; the hook already re-runs on every
	 * page change.) No loading shell: the data is already in hand, so the swap is immediate.
	 *
	 * @return {void}
	 */
	_repaintWithColumnState()
	{
		const tmpSourceData = this._lastRecordListData;
		if (!tmpSourceData || !Array.isArray(tmpSourceData.ColumnCandidates))
		{
			return;
		}
		let tmpPaintData = Object.assign({}, tmpSourceData);
		tmpPaintData.TableCells = this._computeVisibleTableCells(tmpSourceData.ColumnCandidates, tmpSourceData.RecordSet);
		tmpPaintData = this.onBeforeRenderList(tmpPaintData);
		this._paintRecordList(tmpPaintData, true);
	}

	/**
	 * Rerun the last list render with the same arguments (body-only — the list shell and filters
	 * are already on screen). Used when a column toggle needs a refetch under Lite.
	 *
	 * @return {Promise<void>|undefined}
	 */
	_rerunLastListRender()
	{
		if (!this._lastListRenderArgs)
		{
			return;
		}
		const tmpArgs = this._lastListRenderArgs.Args.concat([ true ]);
		return this[this._lastListRenderArgs.Method](...tmpArgs);
	}

	onInitialize()
	{
		this.childViews.headerList = this.pict.addView('PRSP-List-HeaderList', viewHeaderList.default_configuration, viewHeaderList);
		this.childViews.title = this.pict.addView('PRSP-List-Title', viewTitle.default_configuration, viewTitle);
		this.childViews.filters = this.pict.views['PRSP-Filters'] || this.pict.addView('PRSP-Filters', { }, viewFilters);
		this.childViews.paginationTop = this.pict.addView('PRSP-List-PaginationTop', viewPaginationTop.default_configuration, viewPaginationTop);
		this.childViews.recordList = this.pict.addView('PRSP-List-RecordList', viewRecordList.default_configuration, viewRecordList);
		this.childViews.recordListHeader = this.pict.addView('PRSP-List-RecordListHeader', viewRecordListHeader.default_configuration, viewRecordListHeader);
		this.childViews.recordListEntry = this.pict.addView('PRSP-List-RecordListEntry', viewRecordListEntry.default_configuration, viewRecordListEntry);
		this.childViews.paginationBottom = this.pict.addView('PRSP-List-PaginationBottom', viewPaginationBottom.default_configuration, viewPaginationBottom);
		this.childViews.columnChooser = this.pict.addView('PRSP-List-ColumnChooser', viewColumnChooser.default_configuration, viewColumnChooser);

		// Initialize the subviews
		this.childViews.headerList.initialize();
		this.childViews.title.initialize();
		this.childViews.paginationTop.initialize();
		this.childViews.recordList.initialize();
		this.childViews.recordListHeader.initialize();
		this.childViews.recordListEntry.initialize();
		this.childViews.paginationBottom.initialize();
		this.childViews.columnChooser.initialize();

		return super.onInitialize();
	}
}

module.exports = viewRecordSetList;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__List;


},{"../RecordSet-Filters.js":983,"../RecordSet-RecordBaseView.js":984,"./RecordSet-List-ColumnChooser.js":1028,"./RecordSet-List-HeaderList.js":1029,"./RecordSet-List-PaginationBottom.js":1030,"./RecordSet-List-PaginationTop.js":1031,"./RecordSet-List-RecordList.js":1032,"./RecordSet-List-RecordListEntry.js":1033,"./RecordSet-List-RecordListHeader.js":1034,"./RecordSet-List-Sort.js":1035,"./RecordSet-List-Title.js":1036}],1038:[function(require,module,exports){
const libPictRecordSetRecordView = require('../RecordSet-RecordBaseView.js');
const libViewAssociationEditor = require('../associate/RecordSet-AssociationEditor.js');

// Identity + audit field names stamped on (virtually) every Meadow entity. These are
// surfaced through the record audit header (the first-class activity line + the Details
// modal), not inline in the record body. The entity's own ID/GUID field names are added
// at suppression time via the provider's getIDField()/getGUIDField().
// Audit / sync-bookkeeping fields suppressed from the record body and surfaced in the Details modal.
// ExternalSyncDate / ExternalSyncGUID are the external-sync auditing stamps (Headlight integration sync).
const _AUDIT_FIELD_NAMES = ['CreatingIDUser', 'UpdatingIDUser', 'DeletingIDUser', 'Deleted', 'CreateDate', 'UpdateDate', 'DeleteDate', 'ExternalSyncDate', 'ExternalSyncGUID'];

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION__Read = (
	{
		ViewIdentifier: 'PRSP-Read',

		DefaultRenderable: 'PRSP_Renderable_Read',
		DefaultDestinationAddress: '#PRSP_Container',
		DefaultTemplateRecordAddress: false,

		// If this is set to true, when the App initializes this will.
		// While the App initializes, initialize will be called.
		AutoInitialize: false,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called.
		AutoRender: false,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: false,
		AutoSolveOrdinal: 0,

		CSS: /*css*/`
			/* Soft-deleted record banner (the ViewDeleted route) — quiet alarm, theme-token driven. */
		.prsp-read-deleted-banner { display: flex; align-items: center; gap: 0.5rem; margin: 0 0 0.85rem; padding: 0.55rem 0.85rem;
			border: 1px solid var(--theme-color-status-error, #c0504d); border-radius: 8px; font-size: 0.92rem;
			color: var(--theme-color-status-error, #c0504d);
			background: color-mix(in srgb, var(--theme-color-status-error, #c0504d) 8%, transparent); }
		.prsp-audit-header { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin: 0 0 1rem; }
			.prsp-audit-line { display: inline-flex; align-items: center; gap: 0.4rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; }
			.prsp-audit-line .pict-icon { font-size: 0.8rem; }
			.prsp-audit-line strong { color: var(--theme-color-text-secondary, #45505f); font-weight: 600; }
			.prsp-audit-button { display: inline-flex; align-items: center; gap: 0.4rem; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-muted, #6b7686); border-radius: 8px; padding: 0.35rem 0.65rem; font: inherit; font-size: 0.82rem; cursor: pointer; transition: all 0.15s ease; }
			.prsp-audit-button:hover { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
			.prsp-record-related:empty { display: none; }
			.prsp-audit-anchor { position: relative; }
			.prsp-audit-popover { position: absolute; top: calc(100% + 8px); right: 0; min-width: 380px; width: max-content; max-width: 90vw; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; box-shadow: 0 14px 36px rgba(15, 23, 42, 0.18); padding: 1rem 1.1rem; z-index: 40; display: none; }
			.prsp-audit-popover.is-open { display: block; }
			.prsp-audit-dl { display: grid; grid-template-columns: auto auto; gap: 0.6rem 1rem; align-items: baseline; margin: 0; }
			.prsp-audit-dl dd { white-space: nowrap; }
			.prsp-audit-dl dt { color: var(--theme-color-text-muted, #6b7686); font-size: 0.74rem; text-transform: uppercase; letter-spacing: 0.03em; white-space: nowrap; }
			.prsp-audit-dl dd { margin: 0; color: var(--theme-color-text-primary, #1f2733); font-size: 0.9rem; }
			.prsp-audit-dl dd small { color: var(--theme-color-text-muted, #6b7686); }
			.prsp-audit-dl dd.is-deleted { color: var(--theme-color-status-error, #b62828); }
			.prsp-audit-guid { display: inline-flex; align-items: center; gap: 0.4rem; }
			.prsp-audit-guid code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.8rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-secondary, #f5f6f8); padding: 0.1rem 0.4rem; border-radius: 5px; }
			.prsp-audit-copy { border: 0; background: transparent; color: var(--theme-color-text-muted, #6b7686); cursor: pointer; padding: 0.1rem 0.3rem; border-radius: 4px; font-size: 0.85rem; }
			.prsp-audit-copy:hover { color: var(--theme-color-brand-primary, #156dd1); }
			/* Tufte: in view mode the record VALUES are the foreground. Read-only fields render as
			   text (not boxed inputs), so the data outweighs its labels and section chrome. */
			.prsp-record-read input.input[readonly], .prsp-record-read input.input[disabled], .prsp-record-read textarea[readonly], .prsp-record-read textarea[disabled], .prsp-record-read select[disabled] { background: transparent !important; border-color: transparent !important; box-shadow: none !important; padding-left: 0 !important; padding-right: 0 !important; height: auto !important; min-height: 0 !important; opacity: 1 !important; cursor: default !important; color: var(--theme-color-text-primary, #1f2733) !important; -webkit-text-fill-color: var(--theme-color-text-primary, #1f2733) !important; font-weight: 600 !important; font-size: 1.1rem !important; }
			.prsp-record-read .label { font-size: 0.68rem !important; font-weight: 600 !important; text-transform: uppercase !important; letter-spacing: 0.05em !important; color: var(--theme-color-text-muted, #6b7686) !important; margin-bottom: 0.05rem !important; }
			.prsp-record-read .section-header { background: var(--theme-color-background-selected, #e3edfb) !important; color: var(--theme-color-brand-primary, #156dd1) !important; font-size: 0.74rem !important; font-weight: 700 !important; text-transform: uppercase !important; letter-spacing: 0.06em !important; padding: 0.4rem 0.8rem !important; border-radius: 6px !important; border-bottom: 0 !important; margin: 1.1rem 0 0.7rem !important; }
				/* Record header — a readable title (the record's own name, via a heuristic) with the entity
				   type as an eyebrow, instead of a raw "RecordSet GUIDField [guid]" string. */
			.prsp-read-head { margin: 0 0 1.1rem; }
			.prsp-read-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); }
			.prsp-read-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); }
				/* Read-view association tabs — pill nav, shared by the Tab and Split layouts (single source;
				   layouts style only their own nav container). */
			.psrs-tab { padding: 0.4rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; cursor: pointer; font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-panel, #fff); user-select: none; transition: all 0.15s ease; }
			.psrs-tab:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
			.psrs-tab.is-active { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
			.psrs-tab-body { display: none; }
			.psrs-tab-body.is-active { display: block; }
		`,
		CSSPriority: 500,

		Templates:
			[
				{
					Hash: 'PRSP-Read-RecordRead-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-RecordRead-Template] -->
						<div>
							{~TSWP:PRSP-Read-RecordRead-Template-Row:Record.DisplayFields:Record.Record~}
						</div>
						{~T:PRSP-Read-RecordButtonBar-Template~}
						<!-- DefaultPackage end view template:  [PRSP-Read-RecordRead-Template] -->
					`
				},
				{
					Hash: 'PRSP-Read-RecordRead-Template-Row',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-RecordRead-Template] -->
						<div>
							<span style="font-style: italic;">{~D:Record.Data.DisplayName~}</span>
							<span style="font-weight: bold;">{~DVBK:Record.Payload:Record.Data.Key~}</span>
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-RecordRead-Template] -->
					`
				},
				{
					Hash: 'PRSP-Read-RecordButtonBar-Template',
					Template: /*html*/`
						<style>
							.record-button-bar-hidden
							{
								display: none;
							}
							.record-button-bar
							{
								display: flex;
								margin-top: 15px;
							}
							.record-button-bar > button
							{
								margin-right: 10px;
							}
						.record-button-bar > button.prsp-read-delete-btn
							{
								margin-left: auto;
								margin-right: 0;
								border: 1px solid var(--theme-color-status-error, #b62828);
								background: var(--theme-color-status-error, #b62828);
								color: #fff;
								border-radius: 6px;
								cursor: pointer;
							}
						.record-button-bar > button.prsp-read-delete-btn:hover
							{
								background: var(--theme-color-status-error-hover, #9c2020);
							}
						</style>
						<div class="record-button-bar">
							<button id="PRSP-Read-CancelButton" type="button" onclick="_Pict.views['RSP-RecordSet-Read'].cancel()">Cancel</button>
							<button id="PRSP-Read-SaveButton" type="button" onclick="_Pict.views['RSP-RecordSet-Read'].save()">Save</button>
							<button id="PRSP-Read-EditButton" type="button" onclick="_Pict.views['RSP-RecordSet-Read'].edit()">Edit</button>
							<button id="PRSP-Read-DeleteButton" type="button" class="prsp-read-delete-btn" onclick="_Pict.views['RSP-RecordSet-Read'].deleteRecord()">Delete</button>
						</div>
					`
				},
				{
					Hash: 'PRSP-Read-RecordTab-Template',
					Template: /*html*/`<!-- Placeholder for tabs, something has gone wrong if this comment is rendered. -->`
				},
				{
					Hash: 'PRSP-Read-RecordTabNav-Template',
					Template: /*html*/`<!-- Placeholder for tabs, something has gone wrong if this comment is rendered. -->`
				},
				{
					// Readable record header, shared by all three layouts: the record's display name (heuristic)
					// over a small entity-type eyebrow, falling back to the GUID field + value when the record
					// has no obvious name. DisplayTitle / TitleEyebrow are computed in renderRead().
					Hash: 'PRSP-Read-Header-Template',
					Template: /*html*/`
						<div class="prsp-read-head">
							<div class="prsp-read-eyebrow">{~D:Record.TitleEyebrow~}</div>
							<h1 class="prsp-read-title">{~D:Record.DisplayTitle~}</h1>
						</div>`
				},
				{
					Hash: 'PRSP-Read-Basic-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-Basic-Template] -->
						{~T:PRSP-Read-Header-Template~}
						<!--
						{~DJ:Record~}
						-->
						<div>
							{~T:PRSP-Read-RecordRead-Template~}
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-Basic-Template] -->
						`
				},
				{
					Hash: 'PRSP-Read-Split-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-Split-Template] -->
						<style>
							.psrs-split-tabnav { display: flex; justify-content: flex-end; gap: 0.4rem; margin: 0.4rem 0 0.2rem; }
							#PRSP-Read-Tab-Nav { display: inline-flex; gap: 0.35rem; flex-wrap: wrap; }
							.psrs-tab { padding: 0.4rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; cursor: pointer; font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-panel, #fff); user-select: none; }
							.psrs-tab:hover { background: var(--theme-color-background-tertiary, #eceef2); color: var(--theme-color-text-primary, #1f2733); }
							.psrs-tab.is-active { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; }
							.psrs-split-view { display: flex; height: 100%; }
							.psrs-left-panel { overflow: auto; }
							.psrs-right-panel { overflow: auto; flex: 1 1 auto; }
							#psrs-resize { flex: 0 0 auto; padding-left: 10px; padding-right: 10px; cursor: col-resize; }
							#psrs-resize > div { width: 1px; height: 100%; background-color: var(--theme-color-border-default, rgba(0,0,0,0.2)); }
							.psrs-tab-body { display: none; }
							.psrs-tab-body.is-active { display: block; }
							/* Collapsed (default): no association is open, so the record takes the full width and the
							   association pane + resizer are hidden until a tab is chosen. */
							.psrs-split-view.psrs-collapsed .psrs-right-panel,
							.psrs-split-view.psrs-collapsed #psrs-resize { display: none; }
							.psrs-split-view.psrs-collapsed .psrs-left-panel { min-width: 100% !important; width: 100%; }
						</style>
						{~T:PRSP-Read-Header-Template~}
						<div class="psrs-split-tabnav">{~T:PRSP-Read-RecordTabNav-Template~}</div>
						<div class="psrs-split-view psrs-collapsed">
							<div class="psrs-left-panel" style="min-width: {~D:Record.SplitLeftWidth~};">
								{~T:PRSP-Read-RecordRead-Template~}
							</div>
							<div id="psrs-resize"><div></div></div>
							<div class="psrs-right-panel">
								{~T:PRSP-Read-RecordTab-Template~}
							</div>
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-Split-Template] -->
						`
				},
				{
					Hash: 'PRSP-Read-Tab-Template',
					Template: /*html*/`
						<!-- DefaultPackage pict view template: [PRSP-Read-Tab-Template] -->
						{~T:PRSP-Read-Header-Template~}
						<!--
						{~DJ:Record~}
						-->
						<style>
							/* Tab layout owns only its nav container; the pill styling for .psrs-tab /
							   .psrs-tab-body is shared from the view's persistent CSS block. */
							#PRSP-Read-Tab-Nav { display: flex; flex-wrap: wrap; gap: 0.35rem; width: 100%; margin: 0 0 1.25rem; padding-bottom: 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
						</style>
						<div class="psrs-tab-view">
							<div id="PRSP-Read-Tabs-Container">
								{~T:PRSP-Read-RecordTabNav-Template~}
								{~T:PRSP-Read-RecordTab-Template~}
							</div>
						</div>
						<!-- DefaultPackage end view template:  [PRSP-Read-Tab-Template] -->
						`
				},
				{
					Hash: 'PRSP-Read-Link-Name-Template',
					Template: `View`
				},
				{
					Hash: 'PRSP-Read-Link-URL-Template',
					// TODO: Double payload pattern...
					// Soft-deleted rows (visible via the show-deleted filter) route to ViewDeleted, whose
					// lookup explicitly includes deleted records — a plain View would find nothing.
					Template: `#/PSRS/{~D:Record.Payload.Payload.RecordSet~}/View{~NE:Record.Payload.Data.Deleted^Deleted~}/{~DVBK:Record.Payload.Data:Record.Payload.Payload.GUIDAddress~}`
				},
				// --- Record audit header (themeable; apps brand via --theme-color-* tokens) ---
				{
					Hash: 'PRSP-Read-RecordAuditHeader-Template',
					Template: /*html*/`
						{~TS:PRSP-Read-DeletedBanner-Template:AppData.PRSP_RecordAudit.DeletedBannerSlot~}
						<div class="prsp-audit-header">
							<div class="prsp-audit-activity">{~TS:PRSP-Read-RecordAudit-Line-Template:AppData.PRSP_RecordAudit.ActivitySlot~}</div>
							<div class="prsp-audit-anchor">
								<button type="button" class="prsp-audit-button" title="Identity and audit detail" onclick="_Pict.views['RSP-RecordSet-Read'].toggleRecordAudit()">{~I:Info~}<span>Details</span></button>
								<div class="prsp-audit-popover" id="PRSP-Read-AuditPopover">
									<dl class="prsp-audit-dl">
										<dt>{~D:AppData.PRSP_RecordAudit.IDFieldName~}</dt><dd><span class="prsp-audit-guid"><code>{~D:AppData.PRSP_RecordAudit.IDValue~}</code><button type="button" class="prsp-audit-copy" title="Copy" onclick="_Pict.views['RSP-RecordSet-Read'].copyValue('{~D:AppData.PRSP_RecordAudit.IDValue~}')">{~I:Copy~}</button></span></dd>
										<dt>{~D:AppData.PRSP_RecordAudit.GUIDFieldName~}</dt><dd><span class="prsp-audit-guid"><code>{~D:AppData.PRSP_RecordAudit.GUIDValue~}</code><button type="button" class="prsp-audit-copy" title="Copy" onclick="_Pict.views['RSP-RecordSet-Read'].copyValue('{~D:AppData.PRSP_RecordAudit.GUIDValue~}')">{~I:Copy~}</button></span></dd>
										{~TS:PRSP-Read-RecordAudit-Created-Template:AppData.PRSP_RecordAudit.CreatedSlot~}
										{~TS:PRSP-Read-RecordAudit-Updated-Template:AppData.PRSP_RecordAudit.UpdatedSlot~}
										{~TS:PRSP-Read-RecordAudit-Deleted-Template:AppData.PRSP_RecordAudit.DeletedSlot~}
										{~TS:PRSP-Read-RecordAudit-ExternalSync-Template:AppData.PRSP_RecordAudit.ExternalSyncSlot~}
									</dl>
								</div>
							</div>
						</div>
					`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Line-Template',
					Template: /*html*/`<span class="prsp-audit-line">{~I:Refresh~} {~D:Record.Label~} by <strong>{~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</strong> &middot; {~DateFormat:Record.Date^MMM D, YYYY - h:mm A~}</span>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-UserName-Template',
					Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Created-Template',
					Template: /*html*/`<dt>Created</dt><dd>{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~} <small>by {~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</small></dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Updated-Template',
					Template: /*html*/`<dt>Last updated</dt><dd>{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~} <small>by {~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</small></dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-Deleted-Template',
					Template: /*html*/`<dt>Deleted</dt><dd class="is-deleted">{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~} <small>by {~E:User^Record.UserID^PRSP-Read-RecordAudit-UserName-Template~}</small></dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-ExternalSync-Template',
					Template: /*html*/`<dt>External sync</dt><dd>{~TIfAbs:PRSP-Read-RecordAudit-ExternalSyncDate-Template:Record:Record.HasDate^TRUE^~}{~NE:Record.NeverSynced^Never synced~}</dd>`
				},
				{
					Hash: 'PRSP-Read-RecordAudit-ExternalSyncDate-Template',
					Template: /*html*/`{~DateFormat:Record.Date^MMM D, YYYY - h:mm A~}`
				},
				{
					// Soft-deleted record banner (the ViewDeleted route, or a record deleted out from
					// under a normal View). The one-or-zero-element DeletedBannerSlot drives it.
					Hash: 'PRSP-Read-DeletedBanner-Template',
					Template: /*html*/`<div class="prsp-read-deleted-banner">{~I:Warning~} This record has been deleted{~TIfAbs:PRSP-Read-DeletedBanner-Date-Template:Record:Record.HasDate^TRUE^~}.</div>`
				},
				{
					Hash: 'PRSP-Read-DeletedBanner-Date-Template',
					Template: /*html*/` on {~DateFormat:Record.Date^MMM D, YYYY - h:mm A~}`
				},
			],

		Renderables:
			[
				{
					RenderableHash: 'PRSP_Renderable_Read_Basic',
					TemplateHash: 'PRSP-Read-Basic-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Read_Split',
					TemplateHash: 'PRSP-Read-Split-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				},
				{
					RenderableHash: 'PRSP_Renderable_Read_Tab',
					TemplateHash: 'PRSP-Read-Tab-Template',
					DestinationAddress: '#PRSP_Container',
					RenderMethod: 'replace'
				}
			],

		Manifests: {}
	});

class viewRecordSetRead extends libPictRecordSetRecordView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION__Read, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.layoutType = 'Basic';
		this.action = 'View';
		this.tabs = [];
		this.RecordSet = null;
		this.providerHash = null;
		this.activeTab = null;
		this.mouseHandler = null;
		this.manifest = null;
		this.defaultManifest = null;
		this.GUID = null;
	}

	initializeDragListener()
	{
		let isResizing = false;
		const handleMouseMove = (event) =>
		{
			const resizer = document.getElementById("psrs-resize");
			const leftPanel = document.querySelector(".psrs-left-panel");
			const rightPanel = document.querySelector(".psrs-right-panel");
			if (!isResizing || !(resizer.parentNode instanceof HTMLElement && leftPanel instanceof HTMLElement && rightPanel instanceof HTMLElement))
			{
				return;
			}
			const containerRect = resizer.parentNode.getBoundingClientRect();
			const newLeftWidth = event.clientX - containerRect.left;
			const newRightWidth = containerRect.width - newLeftWidth - resizer.offsetWidth;
			leftPanel.style.width = `${newLeftWidth}px`;
			leftPanel.style.minWidth = `${newLeftWidth}px`;
			rightPanel.style.width = `${newRightWidth}px`;
		}
		if (!this.mouseHandler)
		{
			this.mouseHandler = (event) =>
			{
				isResizing = true;
				document.body.style.userSelect = "none";
				document.addEventListener("mousemove", handleMouseMove);
				document.addEventListener("mouseup", () =>
				{
					isResizing = false;
					document.body.style.userSelect = "";
					document.removeEventListener("mousemove", handleMouseMove);
				});
			};
		}
		const resizer = document.getElementById("psrs-resize");
		resizer.removeEventListener('mousedown', this.mouseHandler);
		resizer.addEventListener("mousedown", this.mouseHandler);
	}

	onAfterRender(pRenderable)
	{
		if (this.layoutType == 'Split')
		{
			this.initializeDragListener();
		}
		
		this.pict.CSSMap.injectCSS();
		this._bindAuditDismiss();
		return super.onAfterRender(pRenderable);
	}

	handleRecordSetReadRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}

		this.action = 'View';
		this.viewingDeletedRecord = false;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;
		tmpProviderConfiguration.GUIDRecord = pRoutePayload.data.GUIDRecord;
		// Remember the record on screen so navigateTab() can build the stable tab route for it.
		this._activeReadRecordSet = pRoutePayload.data.RecordSet;
		this._activeReadGUIDRecord = pRoutePayload.data.GUIDRecord;

		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, pRoutePayload.data.GUIDRecord);
	}

	/**
	 * The deleted-record read route (`/PSRS/:RecordSet/ViewDeleted/:GUIDRecord`): identical to the
	 * View route except the record lookup explicitly includes soft-deleted rows (a normal View of a
	 * deleted record finds nothing — delete tracking filters it out — and renders broken). The flag
	 * also rides the read data as ViewingDeletedRecord, which drives the deleted banner.
	 */
	handleRecordSetReadDeletedRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}

		this.action = 'View';
		this.viewingDeletedRecord = true;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;
		tmpProviderConfiguration.GUIDRecord = pRoutePayload.data.GUIDRecord;

		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, pRoutePayload.data.GUIDRecord);
	}

	handleRecordSetEditRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}

		this.action = 'Edit';
		this.viewingDeletedRecord = false;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[pRoutePayload.data.RecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${pRoutePayload.data.RecordSet}`;

		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = pRoutePayload.data.RecordSet;
		tmpProviderConfiguration.GUIDRecord = pRoutePayload.data.GUIDRecord;

		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }

		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, pRoutePayload.data.GUIDRecord);
	}

	/**
	 * The tabbed read route (`/PSRS/:RecordSet/View/:GUIDRecord/:Tab`): the read view's own tab clicks navigate
	 * here (via navigateTab) so the active tab is a real URL. When the requested record is already on screen this
	 * is a DOM-only setTab (no reload); a cold deep-link renders the record and lands on the requested tab (stashed
	 * in _pendingReadTab, consumed by the first paint). The base View route without a tab still works unchanged.
	 */
	handleRecordSetReadTabRoute(pRoutePayload)
	{
		if (typeof(pRoutePayload) != 'object')
		{
			throw new Error(`Pict RecordSet Read view route handler called with invalid route payload.`);
		}
		const tmpRecordSet = pRoutePayload.data.RecordSet;
		const tmpGUIDRecord = pRoutePayload.data.GUIDRecord;
		const tmpTab = pRoutePayload.data.Tab;
		// Already viewing this exact record → just switch the tab in place (setTab toggles the DOM; no re-fetch).
		if ((this.action === 'View') && !this.viewingDeletedRecord && (this._activeReadRecordSet === tmpRecordSet) && (this._activeReadGUIDRecord === tmpGUIDRecord))
		{
			return this.setTab(tmpTab);
		}
		// Cold deep-link: render the record, landing on the requested tab (via _pendingReadTab on first paint).
		this.action = 'View';
		this.viewingDeletedRecord = false;
		const tmpProviderConfiguration = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpRecordSet];
		this.layoutType = tmpProviderConfiguration?.ReadLayout || 'Basic';
		const tmpProviderHash = `RSP-Provider-${tmpRecordSet}`;
		tmpProviderConfiguration.RoutePayload = pRoutePayload;
		tmpProviderConfiguration.RecordSet = tmpRecordSet;
		tmpProviderConfiguration.GUIDRecord = tmpGUIDRecord;
		this._activeReadRecordSet = tmpRecordSet;
		this._activeReadGUIDRecord = tmpGUIDRecord;
		// A custom view owns its own paint and never consumes _pendingReadTab; stage the pending tab ONLY for the
		// generic renderRead path below, so a delegated view can't leave a stale tab to leak onto the next read.
		if (this.delegateToCustomView(this.action, tmpProviderConfiguration, pRoutePayload)) { return true; }
		this._pendingReadTab = tmpTab;
		return this.renderRead(tmpProviderConfiguration, tmpProviderHash, tmpGUIDRecord);
	}

	addRoutes(pPictRouter)
	{
		pPictRouter.addRoute('/PSRS/:RecordSet/View/:GUIDRecord', this.handleRecordSetReadRoute.bind(this));
		// A specific tab on the read view, as a stable/deep-linkable route (see navigateTab + handleRecordSetReadTabRoute).
		pPictRouter.addRoute('/PSRS/:RecordSet/View/:GUIDRecord/:Tab', this.handleRecordSetReadTabRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/ViewDeleted/:GUIDRecord', this.handleRecordSetReadDeletedRoute.bind(this));
		pPictRouter.addRoute('/PSRS/:RecordSet/Edit/:GUIDRecord', this.handleRecordSetEditRoute.bind(this));
		return true;
	}

	async cancel()
	{
		await this.onBeforeView();
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/View/${ this.GUID }`);
	}

	async save()
	{
		await this.onBeforeSave();
		await this.pict.providers[this.providerHash].updateRecord(this.pict.AppData[`${ this.RecordSet }Details`]);
		await this.onBeforeView();
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/View/${ this.GUID }`);
	}

	async edit()
	{
		await this.onBeforeEdit();
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/Edit/${ this.GUID }`);
	}

	/**
	 * Delete the record being viewed. Basic path: confirm via the host modal, delete, and return to the
	 * list. When the recordset opts into advanced delete (`RecordSetAdvancedDelete`), the modal also offers
	 * "Reassign & delete", which hands off to the Bulk Delete screen preselected to this one record — so the
	 * relationship-remapping UI (replacement picker) is reused rather than duplicated here.
	 * @return {Promise<void>}
	 */
	async deleteRecord()
	{
		const tmpRecord = this.pict.AppData[`${ this.RecordSet }Details`];
		const tmpProvider = this.pict.providers[this.providerHash];
		if (!tmpRecord || !tmpProvider)
		{
			return;
		}
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const tmpConfig = this.pict.PictSectionRecordSet ? this.pict.PictSectionRecordSet.recordSetProviderConfigurations[this.RecordSet] : null;
		const tmpAdvancedEnabled = !!(tmpConfig && tmpConfig.RecordSetAdvancedDelete === true);

		if (tmpAdvancedEnabled && tmpModal && typeof tmpModal.show === 'function')
		{
			const tmpChoice = await tmpModal.show(
				{
					title: 'Delete record',
					content: '<p>Delete this record, or reassign its related records to a replacement first?</p>',
					buttons:
					[
						{ Hash: 'cancel', Label: 'Cancel' },
						{ Hash: 'reassign', Label: 'Reassign & delete…' },
						{ Hash: 'delete', Label: 'Delete', Style: 'danger' },
					],
				});
			if (tmpChoice === 'reassign')
			{
				const tmpIDField = tmpProvider.getIDField();
				this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/BulkDelete/Record/${ tmpRecord[tmpIDField] }`);
				return;
			}
			if (tmpChoice !== 'delete')
			{
				return;
			}
			return this._performDelete(tmpRecord, tmpProvider);
		}

		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			const tmpOk = await tmpModal.confirm('Delete this record? This cannot be undone.',
				{ title: 'Delete record', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
		}
		return this._performDelete(tmpRecord, tmpProvider);
	}

	/**
	 * Delete the record through the provider and return to the list (toasting the outcome).
	 * @param {Record<string, any>} pRecord @param {any} pProvider @return {Promise<void>}
	 */
	async _performDelete(pRecord, pProvider)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		try
		{
			await pProvider.deleteRecord(pRecord);
		}
		catch (pError)
		{
			this.pict.log.error(`RecordSetRead: delete failed for ${ this.RecordSet }.`, pError);
			if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Could not delete the record.', { type: 'error' }); }
			return;
		}
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast('Record deleted', { type: 'success' }); }
		this.fable.providers.RecordSetRouter.pictRouter.navigate(`/PSRS/${ this.RecordSet }/List`);
	}

	/**
	 * Build the record audit header state — the first-class activity line plus the data the
	 * Details modal renders. Identity (ID/GUID) and the create/update/delete stamps are read
	 * straight off the fetched record; the acting-user names resolve lazily via {~E:User^…~}
	 * in the templates (cachetrax-cached), so nothing is pre-resolved here. Stored at
	 * AppData.PRSP_RecordAudit for the templates to consume.
	 *
	 * @param {Record<string, any>} pRecord - The fetched record.
	 */
	_prepareRecordAuditState(pRecord)
	{
		if (!pRecord || typeof pRecord !== 'object')
		{
			this.pict.AppData.PRSP_RecordAudit = false;
			return;
		}
		const tmpProvider = this.pict.providers[this.providerHash];
		const tmpIDField = tmpProvider ? tmpProvider.getIDField() : 'ID';
		const tmpGUIDField = tmpProvider ? tmpProvider.getGUIDField() : 'GUID';

		const tmpHasCreate = this._validAuditDate(pRecord.CreateDate);
		const tmpHasUpdate = this._validAuditDate(pRecord.UpdateDate) && (pRecord.UpdateDate !== pRecord.CreateDate);
		const tmpDeleted = !!pRecord.Deleted && this._validAuditDate(pRecord.DeleteDate);

		let tmpActivitySlot = [];
		if (tmpHasUpdate)
		{
			tmpActivitySlot = [{ Label: 'Updated', Date: pRecord.UpdateDate, UserID: pRecord.UpdatingIDUser }];
		}
		else if (tmpHasCreate)
		{
			tmpActivitySlot = [{ Label: 'Created', Date: pRecord.CreateDate, UserID: pRecord.CreatingIDUser }];
		}

		const tmpIDValue = (pRecord[tmpIDField] != null) ? pRecord[tmpIDField] : '';
		this.pict.AppData.PRSP_RecordAudit =
		{
			RecordSet: this.RecordSet,
			DisplayName: this._computeDisplayName(pRecord),
			IDFieldName: tmpIDField,
			GUIDFieldName: tmpGUIDField,
			IDValue: tmpIDValue,
			GUIDValue: (pRecord[tmpGUIDField] != null) ? pRecord[tmpGUIDField] : '',
			ActivitySlot: tmpActivitySlot,
			CreatedSlot: tmpHasCreate ? [{ Date: pRecord.CreateDate, UserID: pRecord.CreatingIDUser }] : [],
			UpdatedSlot: tmpHasUpdate ? [{ Date: pRecord.UpdateDate, UserID: pRecord.UpdatingIDUser }] : [],
			DeletedSlot: tmpDeleted ? [{ Date: pRecord.DeleteDate, UserID: pRecord.DeletingIDUser }] : [],
			// The ViewDeleted route's banner: present whenever the record is soft-deleted (whether the
			// user arrived via ViewDeleted or the record was deleted out from under a normal View).
			DeletedBannerSlot: (!!pRecord.Deleted) ? [{ Date: pRecord.DeleteDate, UserID: pRecord.DeletingIDUser, HasDate: this._validAuditDate(pRecord.DeleteDate) }] : [],
			// External-sync auditing stamp — surfaced in the Details modal for entities that carry the field.
			ExternalSyncSlot: ('ExternalSyncDate' in pRecord) ? [{ Date: pRecord.ExternalSyncDate, HasDate: this._validAuditDate(pRecord.ExternalSyncDate), NeverSynced: !this._validAuditDate(pRecord.ExternalSyncDate) }] : []
		};
	}

	/**
	 * Compute a human-friendly display name for a record using an opinionated heuristic: first +
	 * last name, then a single descriptive field (FullName, Name, Title, …), else ''. Callers fall
	 * back to the GUID. Lets the page title read "Krishna Pavia Tester" instead of a raw GUID.
	 * @param {Record<string, any>} pRecord
	 * @return {string}
	 */
	_computeDisplayName(pRecord)
	{
		if (!pRecord || typeof pRecord !== 'object')
		{
			return '';
		}
		const tmpFirst = pRecord.NameFirst || pRecord.FirstName;
		const tmpLast = pRecord.NameLast || pRecord.LastName;
		if (tmpFirst || tmpLast)
		{
			return [tmpFirst, tmpLast].filter(Boolean).join(' ').trim();
		}
		const tmpCandidateFields = ['FullName', 'Name', 'Title', 'DisplayName', 'Label', 'Subject', 'Description', 'Code', 'Hash'];
		for (const tmpField of tmpCandidateFields)
		{
			if (pRecord[tmpField] != null && String(pRecord[tmpField]).trim() !== '')
			{
				return String(pRecord[tmpField]).trim();
			}
		}
		return '';
	}

	/**
	 * Whether an audit date value is present and meaningful (guards null/empty and the Meadow
	 * "0000-00-00" zero-date sentinel).
	 * @param {any} pValue
	 * @return {boolean}
	 */
	_validAuditDate(pValue)
	{
		if (!pValue)
		{
			return false;
		}
		return String(pValue).indexOf('0000-00-00') !== 0;
	}

	/**
	 * Toggle the anchored identity + audit popover open or closed. The content is rendered inline
	 * with the record (so the {~E:User^…~} names resolve during the read render); this just flips
	 * its visibility — no overlay.
	 */
	toggleRecordAudit()
	{
		const tmpPopover = document.getElementById('PRSP-Read-AuditPopover');
		if (tmpPopover)
		{
			tmpPopover.classList.toggle('is-open');
		}
	}

	/**
	 * Bind the one-time document handlers that dismiss the audit popover on an outside click or
	 * Escape. Browser-level events with no inline-handler equivalent — bound once and guarded so
	 * re-renders don't stack listeners.
	 */
	_bindAuditDismiss()
	{
		if (this._auditDismissBound || typeof document === 'undefined')
		{
			return;
		}
		this._auditDismissBound = true;
		document.addEventListener('click', (pEvent) =>
		{
			const tmpPopover = document.getElementById('PRSP-Read-AuditPopover');
			if (!tmpPopover || !tmpPopover.classList.contains('is-open'))
			{
				return;
			}
			if (tmpPopover.contains(pEvent.target) || (pEvent.target.closest && pEvent.target.closest('.prsp-audit-button')))
			{
				return;
			}
			tmpPopover.classList.remove('is-open');
		});
		document.addEventListener('keydown', (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				const tmpPopover = document.getElementById('PRSP-Read-AuditPopover');
				if (tmpPopover)
				{
					tmpPopover.classList.remove('is-open');
				}
			}
		});
	}

	/**
	 * Copy a record value (ID or GUID) to the clipboard from the audit popover, with a toast.
	 * @param {string} pValue
	 */
	copyValue(pValue)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const fToast = (pMessage, pType) =>
		{
			if (tmpModal && typeof tmpModal.toast === 'function')
			{
				tmpModal.toast(pMessage, { type: pType || 'success' });
			}
		};
		if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(pValue).then(() => fToast('GUID copied to clipboard')).catch(() => fToast('Could not copy GUID', 'error'));
		}
		else
		{
			fToast('Could not copy GUID', 'error');
		}
	}

	/**
	 * Remove identity + audit descriptors from a (cloned) manifest so they don't render inline
	 * in the record body — they live behind the audit header's Details modal instead. Also
	 * prunes any section left with no descriptors (e.g. an emptied "Audit Trail" section). The
	 * entity's own ID/GUID field names are suppressed alongside the shared audit fields.
	 * @param {Record<string, any>} pManifest - The cloned manifest to mutate.
	 */
	_suppressAuditDescriptors(pManifest)
	{
		if (!pManifest || !pManifest.Descriptors)
		{
			return;
		}
		const tmpProvider = this.pict.providers[this.providerHash];
		const tmpSuppress = _AUDIT_FIELD_NAMES.concat('IDCustomer'); // IDCustomer: meadow-endpoints/retold tenancy discriminator — server-managed
		if (tmpProvider)
		{
			tmpSuppress.push(tmpProvider.getIDField());
			tmpSuppress.push(tmpProvider.getGUIDField());
		}
		for (const tmpKey of Object.keys(pManifest.Descriptors))
		{
			const tmpFieldName = tmpKey.split('.').pop();
			if (tmpSuppress.indexOf(tmpFieldName) >= 0)
			{
				delete pManifest.Descriptors[tmpKey];
			}
		}
		// Drop sections that no longer have any descriptors (so an emptied titled section like
		// "Audit Trail" doesn't render as a bare heading).
		if (Array.isArray(pManifest.Sections))
		{
			const tmpUsedSections = {};
			for (const tmpKey of Object.keys(pManifest.Descriptors))
			{
				const tmpSectionHash = pManifest.Descriptors[tmpKey] && pManifest.Descriptors[tmpKey].PictForm && pManifest.Descriptors[tmpKey].PictForm.Section;
				if (tmpSectionHash)
				{
					tmpUsedSections[tmpSectionHash] = true;
				}
			}
			pManifest.Sections = pManifest.Sections.filter((pSection) => tmpUsedSections[pSection.Hash]);
		}
	}

	onBeforeRenderRead(pRecordReadData)
	{
		this.formatDisplayData(pRecordReadData);
		return pRecordReadData;
	}

	formatDisplayData(pRecordListData)
	{
		pRecordListData.DisplayFields = [];
		const tmpSchema = pRecordListData.RecordSchema;
		const tmpProperties = tmpSchema?.properties;
		// loop throught the schema and add the columns to the tableCells -- just show all for now.
		for (const tmpColumn in tmpProperties)
		{
			pRecordListData.DisplayFields.push({
				'Key': tmpColumn,
				'DisplayName': tmpProperties?.[tmpColumn].title || tmpColumn,
			});
		}
		return pRecordListData;
	}

	async onBeforeEdit()
	{
		// Hook that is called when transitioning to edit mode. 
	}

	async onBeforeSave()
	{
		// Hook that is called before saving.
	}

	async onBeforeView()
	{
		// Hook that is called when transitioning to view mode. 
	}

	async onBeforeTabChange()
	{
		// Hook that is called when transitioning between tabs.
	}

	async renderRead(pRecordConfiguration, pProviderHash, pRecordGUID)
	{
		// Get the records
		if (!(pProviderHash in this.pict.providers))
		{
			this.pict.log.error(`RecordSetRead: No provider found for ${pProviderHash} in ${pRecordConfiguration.RecordSet}.  Read Render failed.`);
			return false;
		}

		let tmpRecordReadData =
		{
			"RecordSet": pRecordConfiguration.RecordSet,

			"RecordConfiguration": pRecordConfiguration,

			"RenderDestination": this.options.DefaultDestinationAddress,

			"Record": false,

			// Split layout: the starting width of the record (left) pane; the rest goes to the tabs
			// (right) pane. Any CSS width ('40%', '360px', …); default 50%. The divider stays draggable.
			"SplitLeftWidth": pRecordConfiguration.RecordSetReadSplitLeftWidth || '50%',
		};

		this.GUID = pRecordGUID;

		if (pRecordConfiguration.RecordSet !== this.RecordSet)
		{
			this.RecordSet = pRecordConfiguration.RecordSet;
			this.activeTab = null;
		}

		this.providerHash = pProviderHash;

		// If the record configuration does not have a GUID, try to infer one from the RecordSet name
		// TODO: This should be coming from the schema but that can come after we discuss how we deal with default routing
		tmpRecordReadData.GUIDAddress = this.pict.providers[pProviderHash].getGUIDField();

		tmpRecordReadData.Record = await this.pict.providers[pProviderHash].getRecordByGUID(pRecordGUID, this.viewingDeletedRecord === true);
		tmpRecordReadData.RecordSchema = await this.pict.providers[pProviderHash].getRecordSchema();
		tmpRecordReadData.ViewingDeletedRecord = (this.viewingDeletedRecord === true);
		this.pict.AppData[`${ tmpRecordReadData.RecordSet }Details`] = tmpRecordReadData.Record;

		// Build the audit header state (first-class activity line + the Details modal) for this record.
		this._prepareRecordAuditState(tmpRecordReadData.Record);

		if (pRecordConfiguration.RecordSetReadManifestOnly)
		{
			this.pict.TemplateProvider.addTemplate(`PRSP-Read-RecordRead-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Read-RecordRead-Template] -->
				<div class="prsp-record-read">
				{~T:PRSP-Read-RecordAuditHeader-Template~}
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordRead', null, true) }</div>
				{~T:PRSP-Read-RecordButtonBar-Template~}
				<div class="prsp-record-related" id="PRSP-Read-Related"></div>
				</div>
				<!-- Manifest dynamic pict end template: [PRSP-Read-RecordRead-Template] -->
			`);
		}
		else
		{
			// Construct a default manifest based on the RecordSchema:
			this.defaultManifest = await this._buildDefaultManifest(tmpRecordReadData.RecordSet);
			this.pict.TemplateProvider.addTemplate(`PRSP-Read-RecordRead-Template`, /*html*/`
				<!-- Manifest dynamic pict template: [PRSP-Read-RecordRead-Template] -->
				<div class="prsp-record-read">
				{~T:PRSP-Read-RecordAuditHeader-Template~}
				<div>${ this._generateManifestTemplate(pRecordConfiguration, 'RecordRead', null, true, this.action, this.defaultManifest) }</div>
				{~T:PRSP-Read-RecordButtonBar-Template~}
				<div class="prsp-record-related" id="PRSP-Read-Related"></div>
				</div>
				<!-- Manifest dynamic pict end template: [PRSP-Read-RecordRead-Template] -->
			`);
		}

		if (this.layoutType !== 'Basic')
		{
			this.tabs = await this._structureTabs(pRecordConfiguration, tmpRecordReadData.Record);
			this.pict.TemplateProvider.addTemplate('PRSP-Read-RecordTab-Template', /*html*/`
				<!-- DefaultPackage pict view template: [PRSP-Read-RecordTab-Template] -->
				${ this.tabs.map((t) => t.Template).join('') }
				<!-- DefaultPackage end view template:  [PRSP-Read-RecordTab-Template] -->
			`);
			this.pict.TemplateProvider.addTemplate('PRSP-Read-RecordTabNav-Template', /*html*/`
				<!-- DefaultPackage pict view template: [PRSP-Read-RecordTabNav-Template] -->
				<div id="PRSP-Read-Tab-Nav">
					${ this.tabs.map((t) => t.TabTemplate).join('') }
				</div>
				<!-- DefaultPackage end view template:  [PRSP-Read-RecordTabNav-Template] -->
			`);
		}

		// Readable record header: the record's own name (heuristic — Name / Title / DisplayName / …),
		// with the entity type (camelCase split) as an eyebrow. Falls back to the GUID field + value
		// when the record has no obvious display field. Computed before onBeforeRenderRead so apps can
		// still override DisplayTitle / TitleEyebrow there.
		const tmpReadableName = this._computeDisplayName(tmpRecordReadData.Record);
		tmpRecordReadData.DisplayTitle = tmpReadableName || `${ tmpRecordReadData.GUIDAddress } [${ pRecordConfiguration.GUIDRecord }]`;
		tmpRecordReadData.TitleEyebrow = String(pRecordConfiguration.RecordSet || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2');

		tmpRecordReadData = this.onBeforeRenderRead(tmpRecordReadData);

		this.renderAsync(`PRSP_Renderable_Read_${ this.layoutType }`, tmpRecordReadData.RenderDestination, tmpRecordReadData,
			async function (pError)
			{
				if (pError)
				{
					this.pict.log.error(`RecordSetRead: Error rendering read ${pError}`, tmpRecordReadData);
					return false;
				}

				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.info(`RecordSetRead: Rendered read ${tmpRecordReadData.RecordSet} with ${tmpRecordReadData.RecordConfiguration.GUIDRecord} []`, tmpRecordReadData);
				}
				else
				{
					this.pict.log.info(`RecordSetRead: Rendered read ${tmpRecordReadData.RecordSet} with ${tmpRecordReadData.RecordConfiguration.GUIDRecord} []`);
				}
				for (const s of this.manifest?.Sections || [])
				{
					this.pict.views[`PictSectionForm-${ s.Hash }`].render();
					this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
				}
				for (const t of this.tabs)
				{
					// Isolate each tab's render: the tabs share one sequential loop, so without this a single
					// tab that throws (e.g. an association editor whose list is large enough to overflow the
					// template-render stack) would blank not just itself but every tab AFTER it in the loop.
					// Catch, log, drop a small notice into the failed tab's body, and keep rendering the rest.
					try
					{
						if (t.renderAsync)
						{
							await t.renderAsync();
						}
						else
						{
							t.render();
						}
					}
					catch (pTabError)
					{
						this.pict.log.error(`RecordSetRead: tab "${ t.Title || t.Hash }" failed to render: ${ pTabError && (pTabError.message || pTabError) }`, pTabError);
						const tmpTabBody = t.Hash ? document.getElementById(`PSRS-Tab-${ t.Hash }`) : null;
						if (tmpTabBody && (tmpTabBody.innerHTML.trim() === ''))
						{
							tmpTabBody.innerHTML = `<div class="psrs-tab-error">This tab could not be displayed.</div>`;
						}
					}
				}
				if (this.action == 'Edit')
				{
					document.getElementById('PRSP-Read-EditButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-SaveButton').classList.remove('record-button-bar-hidden');
					document.getElementById('PRSP-Read-CancelButton').classList.remove('record-button-bar-hidden');
				}
				else if (this.viewingDeletedRecord === true)
				{
					// A deleted record can't be edited (the Edit route's lookup excludes deleted rows) —
					// the ViewDeleted page is read-only.
					document.getElementById('PRSP-Read-EditButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-SaveButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-CancelButton').classList.add('record-button-bar-hidden');
				}
				else
				{
					document.getElementById('PRSP-Read-EditButton').classList.remove('record-button-bar-hidden');
					document.getElementById('PRSP-Read-SaveButton').classList.add('record-button-bar-hidden');
					document.getElementById('PRSP-Read-CancelButton').classList.add('record-button-bar-hidden');
				}
				// Delete is available only in read (View) mode: not while editing, and not on a record that is
				// already soft-deleted (the ViewDeleted page is read-only).
				const tmpDeleteButton = document.getElementById('PRSP-Read-DeleteButton');
				if (tmpDeleteButton)
				{
					if (this.action == 'Edit' || this.viewingDeletedRecord === true)
					{
						tmpDeleteButton.classList.add('record-button-bar-hidden');
					}
					else
					{
						tmpDeleteButton.classList.remove('record-button-bar-hidden');
					}
				}
				// Split opens to the record alone via the Full Record tab; other tabbed layouts default to the first
				// tab — unless a stable-route deep-link (/PSRS/:RecordSet/View/:GUIDRecord/:Tab) requested a specific
				// tab, which wins for this first paint and is then consumed.
				this.setTab(this._pendingReadTab || this.activeTab || (this.layoutType === 'Split' ? 'FullRecord' : this.tabs?.[0]?.Hash));
				this._pendingReadTab = null;
				return true;
			}.bind(this));
	}

	/**
	 * Switch tabs via a STABLE ROUTE (`#/PSRS/<RecordSet>/View/<GUIDRecord>/<tab>`) so the active tab lives in the
	 * URL — deep-linkable, bookmarkable, browser back/forward — instead of a URL-less DOM toggle. The tab buttons
	 * call this; the `:Tab` route (handleRecordSetReadTabRoute) applies it in place (setTab is DOM-only, so an
	 * already-open record just switches tabs, no reload). Falls back to a direct setTab when the record identity
	 * or window isn't available (e.g. a host that hasn't wired routing).
	 * @param {string} t - the tab Hash
	 */
	navigateTab(t)
	{
		// Only a live View has a stable per-tab route (/PSRS/:RecordSet/View/:GUIDRecord/:Tab). In Edit mode a tab
		// switch must stay a DOM-only toggle — rewriting the hash to a View URL would re-fetch the record and silently
		// discard the in-progress edit. On a soft-deleted (ViewDeleted) page there is no /ViewDeleted/:Tab route, and
		// the stashed identity may still point at a previously-viewed live record, so a View hash would jump off the
		// deleted record (or re-render it through the live lookup that filters it out). Toggle in place in both cases.
		if ((this.action === 'Edit') || (this.viewingDeletedRecord === true))
		{
			return this.setTab(t);
		}
		const tmpRecordSet = this._activeReadRecordSet;
		const tmpGUID = this._activeReadGUIDRecord;
		if (tmpRecordSet && tmpGUID && (typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/PSRS/${ tmpRecordSet }/View/${ tmpGUID }/${ t }`;
			return true;
		}
		return this.setTab(t);
	}

	async setTab(t)
	{
		// Guard against a stale/unknown tab hash (a bookmarked tab renamed across deploys, or one conditionally
		// skipped for this particular record): in a tabbed layout the record body itself lives inside a tab, so
		// activating a hash that matches no tab would leave every body hidden and blank the whole record. Clamp to
		// the first real tab. Split's synthetic 'FullRecord' has no tab body (it collapses the pane), so leave it be.
		if ((this.layoutType !== 'Split') && t && Array.isArray(this.tabs) && (this.tabs.length > 0) && !this.tabs.some((tmpReadTab) => (tmpReadTab.Hash === t)))
		{
			t = this.tabs[0].Hash;
		}
		// Split layout opens to the record alone via the "Full Record" tab. Choosing an association tab
		// expands its editor beside the record; choosing "Full Record" (or re-choosing the active tab)
		// collapses back to the record-only view. Other layouts always activate the target.
		const tmpSplit = (this.layoutType === 'Split');
		const tmpNewActive = (tmpSplit && (!t || t === 'FullRecord' || t === this.activeTab)) ? 'FullRecord' : t;
		if (this.activeTab !== tmpNewActive)
		{
			await this.onBeforeTabChange();
		}
		this.activeTab = tmpNewActive;
		if (tmpSplit)
		{
			const tmpSplitView = document.querySelector('.psrs-split-view');
			if (tmpSplitView)
			{
				tmpSplitView.classList.toggle('psrs-collapsed', (tmpNewActive === 'FullRecord'));
			}
		}
		const tabSet = document.querySelectorAll('.psrs-tab');
		const tabBodySet = document.querySelectorAll('.psrs-tab-body');
		for (const tb of tabSet)
		{
			tb.classList.remove('is-active');
			if (tmpNewActive && tb.id == `PSRS-TabNav-${ tmpNewActive }`)
			{
				tb.classList.add('is-active');
			}
		}
		for (const tb of tabBodySet)
		{
			tb.classList.remove('is-active');
			if (tmpNewActive && tb.id == `PSRS-Tab-${ tmpNewActive }`)
			{
				tb.classList.add('is-active');
			}
		}
	}

	async _buildDefaultManifest(recordSet)
	{
		// Construct a default manifest based on the RecordSchema:
		const defaultManifest = 
		{
			"Form": "DefaultManifest",
			"Scope": "Default",
			"Descriptors": {},
			"Sections": 
			[
				{
					"Name": "",
					"Hash": "DefaultSection",
					"Solvers": [],
					"ShowTitle": false,
					"Groups": [
						{
							"Name": "",
							"Hash": "DefaultGroup",
							"Rows": [],
							"RecordSetSolvers": [],
							"ShowTitle": false
						}
					]
				}
			]
		}
		let rowCounter = 1;
		const providerHash = `RSP-Provider-${ recordSet }`;
		const schema = await this.pict.providers[providerHash].getRecordSchema();
		for (const p of Object.keys(schema.properties))
		{
			const exclusionSet = [this.pict.providers[this.providerHash].getIDField(), this.pict.providers[this.providerHash].getGUIDField()].concat(_AUDIT_FIELD_NAMES, 'IDCustomer');
			if (exclusionSet.includes(p))
			{
				continue;
			}
			const tmpDescriptor =
			{
				"Name": `${ this.pict.providers[providerHash].getHumanReadableFieldName?.(p) || p }`,
				"Hash": `${ this.pict.providers[this.providerHash].options.Entity  }-${ p }`,
				"DataType": "String",
				"PictForm": 
				{
					"Row": `${ rowCounter }`,
					"Section": "DefaultSection",
					"Group": "DefaultGroup"
				}
			};
			rowCounter += 1;
			switch (schema.properties[p].type)
			{
				case 'string':
				case 'autoguid':
					tmpDescriptor.DataType = 'String';
					break;
				case 'datetime':
				case 'date':
				case 'createdate':
				case 'updatedate':
					tmpDescriptor.DataType = 'String';
					tmpDescriptor.PictForm.InputType = 'DateTime'
					break;
				case 'boolean':
				case 'deleted':
					tmpDescriptor.DataType = 'Boolean';
				case 'integer':
				case 'decimal':
				case 'autoidentity':
				case 'createiduser':
				case 'updateiduser':
				case 'deleteiduser':
					tmpDescriptor.DataType = 'Number';
					break;
				default:
					tmpDescriptor.DataType = 'String';
			}

			const tmpForeignEntity = this.pict.PictSectionRecordSet.resolveForeignEntity(p, this.pict.PictSectionRecordSet.recordSetProviderConfigurations[recordSet], this.pict.providers[this.providerHash].getIDField());
			if (tmpForeignEntity && this.pict.providers['Pict-Section-Picker'])
			{
				// Foreign-key column → searchable entity Picker (edit) + resolved name (read, see the view-mode override).
				tmpDescriptor.PictForm.InputType = 'Picker';
				tmpDescriptor.PictForm.Entity = tmpForeignEntity;
				const tmpForeignConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[tmpForeignEntity];
				if (tmpForeignConfig && tmpForeignConfig.SearchFields) { tmpDescriptor.PictForm.SearchFields = tmpForeignConfig.SearchFields; }
			}
			// Per-record-set label override (e.g. Contract/Project IDOrganization → "Prime Contractor").
			const tmpReadRSConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[recordSet];
			if (tmpReadRSConfig && tmpReadRSConfig.FieldLabels && tmpReadRSConfig.FieldLabels[p]) { tmpDescriptor.Name = tmpReadRSConfig.FieldLabels[p]; }
			// JSON/object columns → embedded ObjectEditor (read-only tree in View, editable in Edit). Driven by the
			// schema column type, with a per-record-set ObjectEditorFields list to opt in string-typed JSON blobs.
			// Gated on the pict-section-form ObjectEditor input being registered (graceful on older form versions).
			const tmpObjectEditorFields = (tmpReadRSConfig && Array.isArray(tmpReadRSConfig.ObjectEditorFields)) ? tmpReadRSConfig.ObjectEditorFields : [];
			if (tmpDescriptor.PictForm.InputType !== 'Picker' && this.pict.providers['Pict-Input-ObjectEditor'] &&
				(schema.properties[p].type === 'object' || schema.properties[p].type === 'json' || tmpObjectEditorFields.includes(p)))
			{
				tmpDescriptor.DataType = 'Object';
				tmpDescriptor.PictForm.InputType = 'ObjectEditor';
			}
			defaultManifest.Descriptors[`${ recordSet }Details.${ p }`] = tmpDescriptor;
		}
		return defaultManifest;
	}

	_generateManifestTemplate(config, section, specificManifest, setBaseManifest, action = this.action, defaultManifest)
	{
		// Look for a manifest by the action (if there is no specific manifest passed) and fallback to view if the action manifest isn't present.
		const tmpManifestHash = specificManifest || config[`RecordSetReadDefaultManifest${ action }`] || config[`RecordSetReadManifests${ action }`]?.[0] || config[`RecordSetReadDefaultManifestView`] || config[`RecordSetReadManifestsView`]?.[0];
		// Make sure the copy of the manifest doesn't mutate the original (for read only handling).
		const tmpManifest = JSON.parse(JSON.stringify(defaultManifest ? defaultManifest : this.pict.PictSectionRecordSet.getManifest(tmpManifestHash)));
		if (!tmpManifest)
		{
			this.pict.log.error(`RecordSetRead: No manifest found for ${ config.RecordSet }. Read Render failed.`);
			return '';
		}
		if (!tmpManifest.Descriptors)
		{
			this.pict.log.error(`RecordSetRead: No manifest descriptors found for manifest ${ tmpManifestHash }. Read Render failed.`);
			return '';
		}
		else if (action == 'View' && !config.RecordSetReadOverrideReadOnly)
		{
			// If we are in view mode, apply the read only type unless overriden.
			for (const x of Object.keys(tmpManifest.Descriptors))
			{
				if (!tmpManifest.Descriptors[x].PictForm)
				{
					tmpManifest.Descriptors[x].PictForm = {};
				}
				// Entity-reference (Picker) fields stay a Picker but render read-only (the resolved entity
				// name as plain text, no dropdown); everything else becomes plain read-only text.
				if (tmpManifest.Descriptors[x].PictForm.InputType === 'Picker') { tmpManifest.Descriptors[x].PictForm.ReadOnly = true; continue; }
				// ObjectEditor stays an ObjectEditor but renders its read-only tree (not a plain text field).
				if (tmpManifest.Descriptors[x].PictForm.InputType === 'ObjectEditor') { tmpManifest.Descriptors[x].PictForm.ReadOnly = true; continue; }
				tmpManifest.Descriptors[x].PictForm.InputType = 'ReadOnly';
			}
		}
		// Suppress identity + audit fields from the body; they surface via the audit header's Details modal.
		if (config.RecordSetReadSuppressAuditFields !== false)
		{
			this._suppressAuditDescriptors(tmpManifest);
		}
		if (setBaseManifest)
		{
			this.manifest = tmpManifest;
		}
		let sectionsTemplate = '';
		// Clear any stale views in PictSectionForm before reinstantiating (if we don't the read only state doesn't get cleared).
		for (const s of tmpManifest?.Sections || [])
		{
			delete this.pict.views[`PictSectionForm-${ s.Hash }`]
		}
		this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(tmpManifest);

		for (const pickList of tmpManifest?.PickLists || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
		}

		for (const s of tmpManifest?.Sections || [])
		{
			const viewSectionID = `PSRS-Read-${ section }-Section-${ s.Hash }`;
			sectionsTemplate += /*html*/`<div id="${ viewSectionID }"></div>`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].viewMarshalDestination = 'AppData';
			this.pict.views[`PictSectionForm-${ s.Hash }`].options.DefaultDestinationAddress = `#${ viewSectionID }`;
			this.pict.views[`PictSectionForm-${ s.Hash }`].rebuildCustomTemplate();
		}
		return sectionsTemplate
	}

	async _structureTabs(config, record)
	{
		const validTabs = config.ReadLayout == 'Tab' ? 
		[
			{
				Type: 'Record',
				RecordSet: config.RecordSet,
				Title: config.RecordSetReadTabTitle || 'Record',
				Hash: 'Record',
				Template: /*html*/`
					<div id="PSRS-Tab-Record" class="psrs-tab-body">{~T:PRSP-Read-RecordRead-Template~}</div>
				`,
				TabTemplate: /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-Record" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('Record')">${ config.RecordSetReadTabTitle || 'Record' }</div>
				`,
				render: () => {}
			}
		] : config.ReadLayout == 'Split' ?
		[
			// Split layout: a leading "Full Record" tab that collapses the association pane back to the
			// record-only view (the record itself lives in the left pane, so this body stays empty).
			{
				Type: 'FullRecord',
				Hash: 'FullRecord',
				Title: config.RecordSetReadFullRecordTabTitle || 'Full Record',
				Template: /*html*/`
					<div id="PSRS-Tab-FullRecord" class="psrs-tab-body"></div>
				`,
				TabTemplate: /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-FullRecord" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('FullRecord')">${ config.RecordSetReadFullRecordTabTitle || 'Full Record' }</div>
				`,
				render: () => {}
			}
		] : [];

		for (const t of config.RecordSetReadTabs)
		{
			if (!t.Title)
			{
				this.pict.log.info('Skipping tab that is missing title.');
				continue;
			}
			if (!t.Hash)
			{
				t.Hash = t.Title.replaceAll(' ', '');
			}
			if (t.Type == 'Manifest' || t.Type == 'AttachedRecord')
			{
				let recordSetConfig = null;
				let tmpManifest = null;
				if (t.Type == 'AttachedRecord')
				{
					const getMethod = async (remote, id) => {
						if (this.pict.providers[`RSP-Provider-${ remote }`])
						{
							return await this.pict.providers[`RSP-Provider-${ remote }`].getRecord(id);
						}
						else
						{
							return await new Promise((resolve, reject) =>
							{
								this.pict.EntityProvider.getEntity(remote, id, (pError, pResult) =>
								{
									if (pError)
									{
										resolve(null);
									}
									resolve(pResult);
								});
							});
						}
					};

					const getJoin = async (remote, field, value) => {
						let result = null;
						if (this.pict.providers[`RSP-Provider-${ remote }`])
						{
							result = await this.pict.providers[`RSP-Provider-${ remote }`].getRecordsInline(`FBV~${ field }~EQ~${ value }`);
						}
						else
						{
							result = await new Promise((resolve, reject) =>
							{
								this.pict.EntityProvider.getEntitySet(remote, `FBV~${ field }~EQ~${ value }`, (pError, pResult) =>
								{
									if (pError)
									{
										resolve(null);
									}
									resolve(pResult);
								});
							});
						}
						return result?.[0] || null;
					};
					
					if (!t.RecordSet)
					{
						this.pict.log.info(`Skipping attached record tab because no recordset was included.`);
					}
					recordSetConfig = this.pict.PictSectionRecordSet.recordSetProviderConfigurations[t.RecordSet];
					if (!recordSetConfig)
					{
						this.pict.log.info(`Skipping attached record tab because recordset ${ t.RecordSet } is not registered.`);
						continue;
					}
					t.Manifest = recordSetConfig.RecordSetReadDefaultManifestView || recordSetConfig.RecordSetReadManifestsView?.[0];
					tmpManifest = recordSetConfig.RecordSetReadManifestOnly ? this.pict.PictSectionRecordSet.getManifest(t.Manifest) : await this._buildDefaultManifest(recordSetConfig.RecordSetMeadowEntity || recordSetConfig.RecordSet);
					if (!tmpManifest)
					{
						this.pict.log.info(`Skipping manifest tab because manifest ${ t.Manifest } is not registered or default manifest could not be constructed.`);
						continue;
					}
					if (!t.JoinField)
					{
						t.JoinField = this.pict.providers[`RSP-Provider-${ t.RecordSet }`].getIDField();
					}
					if (t.JoiningRecordSet)
					{
						if (!t.BaseField)
						{
							t.BaseField = this.pict.providers[`RSP-Provider-${ config.RecordSet }`].getIDField();
						}
						if (!record[t.BaseField])
						{
							this.pict.log.info(`Skipping attached record tab because field ${ t.BaseField } does not exist on this record.`);
							continue;
						}
						const tempJoin = await getJoin(t.JoiningRecordSet, t.BaseField, record[t.BaseField]);
						if (!tempJoin?.[t.JoinField])
						{
							this.pict.log.info(`Skipping attached record tab because joining field ${ t.JoinField } does not exist on this record.`);
							continue;
						}
						const tempRecord = await getMethod(recordSetConfig.RecordSetMeadowEntity || recordSetConfig.RecordSet, tempJoin[t.JoinField]);
						this.pict.AppData[`${ t.RecordSet }Details`] = tempRecord;
					}
					else
					{
						if (!record[t.Joinfield])
						{
							this.pict.log.info(`Skipping attached record tab because joining field ${ t.JoinField } does not exist on this record.`);
							continue;
						}
						const tempRecord = await getMethod(recordSetConfig.RecordSetMeadowEntity || recordSetConfig.RecordSet, record[t.Joinfield]);
						this.pict.AppData[`${ t.RecordSet }Details`] = tempRecord;
					}
				}
				if (!tmpManifest)
				{
					tmpManifest = this.pict.PictSectionRecordSet.getManifest(t.Manifest);
				}
				t.Template = /*html*/`
					<div id="PSRS-Tab-${ t.Hash }" class="psrs-tab-body">${ this._generateManifestTemplate(config, 'RecordTab', t.Manifest, false, 'View', recordSetConfig && !recordSetConfig.RecordSetReadManifestOnly ? tmpManifest : null) }</div>
				`;
				t.TabTemplate = /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-${ t.Hash }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ t.Hash }')">${ t.Title }</div>
				`;
				t.render = () =>
				{
					// @ts-ignore
					for (const s of tmpManifest?.Sections || [])
					{
						this.pict.views[`PictSectionForm-${ s.Hash }`].render();
						this.pict.views[`PictSectionForm-${ s.Hash }`].marshalToView();
					}
				};
				validTabs.push(t);
			}
			else if (t.Type == 'View')
			{
				if (!t.View)
				{
					this.pict.log.info(`Skipping view tab because no view was included.`);
					continue;
				}
				const tmpView = this.pict.views[t.View];
				if (!tmpView)
				{
					this.pict.log.info(`Skipping view tab because view ${ t.View } is not registered.`);
					continue;
				}
				t.Template = /*html*/`
					<div id="PSRS-Tab-${ t.Hash }" class="psrs-tab-body"></div>
				`;
				t.TabTemplate = /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-${ t.Hash }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ t.Hash }')">${ t.Title }</div>
				`;
				tmpView.options.DefaultDestinationAddress = `#PSRS-Tab-${ t.Hash }`;
				t.render = () =>
				{
					this.pict.views[`${ t.View }`].renderAsync();
				};
				validTabs.push(t);
			}
			else if (t.Type == 'Association')
			{
				// An embeddable join-management widget for one association, anchored on THIS record.
				// Opt-in is light: a RecordSetReadTabs entry naming an Association registered in
				// settings.Associations. The manager resolves which side is "this side" from the
				// rendering recordset, so opting in Book->Authors and Author->Books are independent.
				const tmpAssociationManager = this.pict.providers.RecordSetAssociationManager;
				if (!tmpAssociationManager || !t.Association)
				{
					this.pict.log.info(`Skipping association tab because no association was included (or the manager is missing).`);
					continue;
				}
				const tmpSides = tmpAssociationManager.resolveSides(t.Association, config.RecordSet);
				if (!tmpSides)
				{
					this.pict.log.info(`Skipping association tab because association ${ t.Association } could not be resolved for ${ config.RecordSet }.`);
					continue;
				}
				const tmpEditorHash = `RSP-AssocEditor-${ config.RecordSet }-${ t.Association }`;
				if (!this.pict.views[tmpEditorHash])
				{
					this.pict.addView(tmpEditorHash, Object.assign({}, libViewAssociationEditor.default_configuration,
						{
							ViewIdentifier: tmpEditorHash,
							AssociationHash: t.Association,
							ThisRecordSet: config.RecordSet,
							DefaultDestinationAddress: `#PSRS-Tab-${ t.Hash }`,
							PickerMode: t.PickerMode || 'single',
						}), libViewAssociationEditor);
				}
				const tmpEditorView = this.pict.views[tmpEditorHash];
				tmpEditorView.options.AssociationHash = t.Association;
				tmpEditorView.options.ThisRecordSet = config.RecordSet;
				tmpEditorView.options.ThisID = record[tmpSides.thisSide.IDField];
				tmpEditorView.options.DefaultDestinationAddress = `#PSRS-Tab-${ t.Hash }`;
				tmpEditorView.options.PickerMode = t.PickerMode || 'single';
				t.Template = /*html*/`
					<div id="PSRS-Tab-${ t.Hash }" class="psrs-tab-body"></div>
				`;
				t.TabTemplate = /*html*/`
					<div class="psrs-tab" id="PSRS-TabNav-${ t.Hash }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ t.Hash }')">${ t.Title }</div>
				`;
				t.renderAsync = async () =>
				{
					tmpEditorView.options.ThisID = record[tmpSides.thisSide.IDField];
					tmpEditorView.options.DefaultDestinationAddress = `#PSRS-Tab-${ t.Hash }`;
					await tmpEditorView.renderEditor();
				};
				validTabs.push(t);
			}
		}
		return validTabs;
	}

	onInitialize()
	{

		// Add the route templates for the read view
		this.pict.PictSectionRecordSet.addRecordLinkTemplate('PRSP-Read-Link-Name-Template', 'PRSP-Read-Link-URL-Template', true);

		return super.onInitialize();
	}
}

module.exports = viewRecordSetRead;

module.exports.default_configuration = _DEFAULT_CONFIGURATION__Read;


},{"../RecordSet-RecordBaseView.js":984,"../associate/RecordSet-AssociationEditor.js":988}],1039:[function(require,module,exports){

// pict-section-tabbar — a compact, host-agnostic tab-bar control.
//
// ONE small, professional tab control: underline-active tabs with optional FontAwesome icons, submenu groups,
// pin zones, and configurable overflow — a pure string-builder plus a tiny runtime, with no framework dependency.
//
// A tab def is either a LEAF (navigates on click) or a GROUP (a def with a `Children` array — renders as a
// dropdown submenu; picking a child navigates and the group tab then reads active and shows a "Group ▸ Child"
// breadcrumb). Any top-level def may carry `Pin: 'left'|'center'|'right'` to park it in a zone of the bar.
//
// CONFIGURABLE (per bar, via container modifier classes — see containerClass()):
//   Overflow strategy — how top-level tabs behave when they don't all fit:
//     .hltabs--menu   : overflow LEAF tabs collapse into a "More ▾" dropdown (recommended).
//                       Group tabs stay put (they are their own dropdowns).
//     .hltabs--wrap   : tabs wrap onto additional rows.
//     .hltabs--scroll : the row scrolls horizontally (the default).
//   Display mode:
//     (default)          : icon + label.
//     .hltabs--icon-only : icon only (labels are still read out / shown in the dropdowns).
//     .hltabs--text-only : label only.
//
// It is intentionally NOT a pict-view — a tab host may be a pict view OR a plain provider — so it exports cheap,
// host-agnostic pieces: TABBAR_CSS, TABBAR_TEMPLATES (the `HL-TabBar-Item` pict template, which just injects each
// record's pre-built HTML), buildTabs() (shapes tab defs into render records), containerClass() (builds the
// modifier class string), renderTabsHTML() (a whole-bar HTML string for plain providers), and layout() (the
// runtime: opens/closes dropdowns and, for `.hltabs--menu`, moves overflow leaves into "More ▾").
//
// A host either:
//   (A) pict view — spread TABBAR_CSS + TABBAR_TEMPLATES into the view, render
//       `<div class="{~containerClass~}">{~TS:HL-TabBar-Item:Record.Tabs~}</div>`, build `Record.Tabs` via
//       buildTabs(), and call layout() from onAfterRender; OR
//   (B) plain string host — inject TABBAR_CSS once, assign renderTabsHTML(...) into your container, and call
//       layout() after each paint.
// layout() is needed for the `menu` overflow strategy and to bind the dropdown runtime (groups also open via the
// module-init runtime, but calling layout() is recommended).

const TABBAR_CSS = /*css*/`
	.hltabs { position: relative; display: flex; align-items: stretch; gap: 0.1rem; margin: 0; padding: 0;
		border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
	.hltab { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.4rem; white-space: nowrap;
		cursor: pointer; border: none; background: transparent; font: inherit; font-size: 0.85rem; font-weight: 500; line-height: 1.2;
		color: var(--theme-color-text-secondary, #45505f); padding: 0.55rem 0.9rem; border-bottom: 2px solid transparent; margin-bottom: -1px;
		transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease; }
	.hltab:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-secondary, #f0f2f6); }
	.hltab:focus-visible { outline: 2px solid var(--theme-color-brand-primary, #5650e6); outline-offset: -2px; }
	.hltab .icon { font-size: 0.92em; opacity: 0.8; }
	.hltab.is-active { color: var(--theme-color-brand-primary, #5650e6); font-weight: 650; border-bottom-color: var(--theme-color-brand-primary, #5650e6); }
	.hltab.is-active .icon { opacity: 1; }
	.hltab.is-overflow, .hltabs-group.is-overflow { display: none; }

	/* --- Pin zones: park a top-level item to the center or right of the bar. The first center/right item opens a
	   flex gap; everything after it rides along in that zone. Left is the natural order (no marker). --- */
	.hltabs-zone-center, .hltabs-zone-right { margin-left: auto; }

	/* --- Group (submenu) tab: an inline dropdown, same visual family as "More". --- */
	.hltabs-group { position: relative; flex: 0 0 auto; display: inline-flex; align-items: stretch; }
	.hltab-groupbtn .hltabs-more-caret { font-size: 0.72em; opacity: 0.6; margin-left: 0.1rem; }
	.hltabs-crumb { opacity: 0.65; font-weight: 500; }
	.hltabs-crumb-sep { font-size: 0.65em; opacity: 0.5; margin: 0 0.2rem; }
	.hltabs-more.is-open .hltabs-more-caret, .hltabs-group.is-open .hltabs-more-caret { transform: rotate(180deg); }

	/* --- Overflow: scroll --- */
	.hltabs--scroll { flex-wrap: nowrap; overflow-x: auto; overflow-y: hidden; scrollbar-width: thin; -webkit-overflow-scrolling: touch; }
	.hltabs--scroll::-webkit-scrollbar { height: 6px; }
	.hltabs--scroll::-webkit-scrollbar-thumb { background: var(--theme-color-border-default, #d7dce3); border-radius: 3px; }

	/* --- Overflow: wrap --- */
	.hltabs--wrap { flex-wrap: wrap; }

	/* --- Overflow: menu (JS-managed; overflow-x clipped so a too-wide row never scrolls the page, overflow-y
	   visible so the "More"/group dropdowns can escape below the bar) --- */
	.hltabs--menu { flex-wrap: nowrap; overflow-x: clip; overflow-y: visible; }
	.hltabs-more { position: relative; flex: 0 0 auto; margin-left: auto; display: inline-flex; align-items: stretch; }
	.hltabs-more-btn { display: inline-flex; align-items: center; gap: 0.35rem; white-space: nowrap; cursor: pointer; border: none; background: transparent;
		font: inherit; font-size: 0.85rem; font-weight: 500; line-height: 1.2; color: var(--theme-color-text-secondary, #45505f);
		padding: 0.55rem 0.8rem; border-bottom: 2px solid transparent; margin-bottom: -1px; }
	.hltabs-more-btn:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-secondary, #f0f2f6); }
	.hltabs-more-btn.is-active { color: var(--theme-color-brand-primary, #5650e6); border-bottom-color: var(--theme-color-brand-primary, #5650e6); }
	.hltabs-more-btn .icon { font-size: 0.9em; opacity: 0.85; }
	.hltabs-more-caret { transition: transform 0.15s ease; }
	/* Dropdown panel — shared by "More" and group tabs. position:FIXED so it escapes the tab row's overflow-x:clip
	   (which contains the row) instead of being clipped by it; the runtime (_HLTabBar._position) sets top/left under
	   the trigger on open and clamps it into the viewport. */
	.hltabs-menu { position: fixed; top: 0; left: 0; z-index: 2000; min-width: 12rem; max-height: 70vh; overflow-y: auto;
		background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px;
		box-shadow: 0 8px 24px rgba(20, 27, 39, 0.14); padding: 0.3rem; display: none; }
	.hltabs-more.is-open > .hltabs-menu, .hltabs-group.is-open > .hltabs-menu { display: block; }
	.hltabs-menu-item { display: flex; width: 100%; align-items: center; gap: 0.55rem; white-space: nowrap; text-align: left; cursor: pointer;
		border: none; background: transparent; font: inherit; font-size: 0.85rem; color: var(--theme-color-text-secondary, #45505f); padding: 0.45rem 0.6rem; border-radius: 6px; }
	.hltabs-menu-item:hover { background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-primary, #1f2733); }
	.hltabs-menu-item.is-active { color: var(--theme-color-brand-primary, #5650e6); font-weight: 650; }
	.hltabs-menu-item .icon { font-size: 0.92em; opacity: 0.85; }
	/* Menu items always show their label, even when the bar itself is icon-only. */
	.hltabs-menu .hltab-label { position: static; width: auto; height: auto; overflow: visible; clip: auto; white-space: nowrap; }

	/* --- Display: icon-only (labels visually hidden for tabs that HAVE an icon, so nothing goes unlabelled) --- */
	.hltabs--icon-only .hltab.has-icon .hltab-label,
	.hltabs--icon-only .hltabs-more-label { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
	.hltabs--icon-only .hltab.has-icon { padding: 0.55rem 0.7rem; }

	/* --- Display: text-only --- */
	.hltabs--text-only .hltab .icon, .hltabs--text-only .hltabs-more-btn > .icon:first-child { display: none; }

	/* --- Folded group in the "More" menu: a small section label above the group's children (moved from the
	   group's own dropdown when the bar is too narrow to show the group inline). --- */
	.hltabs-menu-grouplabel { padding: 0.35rem 0.6rem 0.15rem; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); }
	.hltabs-menu-grouplabel:not(:first-child) { margin-top: 0.25rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); padding-top: 0.45rem; }
`;

const TABBAR_TEMPLATES =
[
	{
		// Each record carries its own pre-built HTML (leaf button OR group dropdown) — pict {~D:~} injects it raw.
		Hash: 'HL-TabBar-Item',
		Template: /*html*/`{~D:Record.HTML~}`
	}
];

function _escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
}

// --- HTML builders (shared by the pict-template path and the string path) --------------------------------

/** A leaf tab button. pExtraClass parks it in a pin zone (or is ''). */
function _leafHTML(pDef, pActiveKey, pOnClick, pExtraClass)
{
	const tmpIcon = pDef.Icon ? `<span class="icon"><i class="${ _escapeHTML(pDef.Icon) }"></i></span>` : '';
	const tmpActive = (String(pActiveKey) === String(pDef.Key)) ? 'is-active' : '';
	const tmpHasIcon = pDef.Icon ? 'has-icon' : '';
	const tmpExtra = pExtraClass ? (' ' + pExtraClass) : '';
	const tmpOnClick = (typeof pOnClick === 'function') ? pOnClick(pDef) : '';
	return `<button type="button" class="hltab ${ tmpActive } ${ tmpHasIcon }${ tmpExtra }" data-tabkey="${ _escapeHTML(pDef.Key) }" title="${ _escapeHTML(pDef.Label) }" onclick="${ tmpOnClick }">${ tmpIcon }<span class="hltab-label">${ _escapeHTML(pDef.Label) }</span></button>`;
}

/** One item inside a group's dropdown. */
function _menuItemHTML(pChild, pActiveKey, pOnClick)
{
	const tmpIcon = pChild.Icon ? `<span class="icon"><i class="${ _escapeHTML(pChild.Icon) }"></i></span>` : '';
	const tmpActive = (String(pActiveKey) === String(pChild.Key)) ? 'is-active' : '';
	const tmpOnClick = (typeof pOnClick === 'function') ? pOnClick(pChild) : '';
	return `<button type="button" class="hltabs-menu-item ${ tmpActive }" data-tabkey="${ _escapeHTML(pChild.Key) }" title="${ _escapeHTML(pChild.Label) }" onclick="${ tmpOnClick }">${ tmpIcon }<span class="hltab-label">${ _escapeHTML(pChild.Label) }</span></button>`;
}

/** A group (submenu) tab: a dropdown button + its menu. Active (and breadcrumbed) when one of its children is. */
function _groupHTML(pDef, pActiveKey, pOnClick, pExtraClass)
{
	const tmpChildren = Array.isArray(pDef.Children) ? pDef.Children : [];
	const tmpActiveChild = tmpChildren.find((pChild) => String(pChild.Key) === String(pActiveKey)) || null;
	const tmpIcon = pDef.Icon ? `<span class="icon"><i class="${ _escapeHTML(pDef.Icon) }"></i></span>` : '';
	const tmpHasIcon = pDef.Icon ? 'has-icon' : '';
	const tmpActive = tmpActiveChild ? 'is-active' : '';
	const tmpExtra = pExtraClass ? (' ' + pExtraClass) : '';
	// Active-child breadcrumb ("Group ▸ Child") on the group button; otherwise just the group label.
	const tmpLabelInner = tmpActiveChild
		? `<span class="hltabs-crumb">${ _escapeHTML(pDef.Label) }</span><i class="fas fa-angle-right hltabs-crumb-sep"></i>${ _escapeHTML(tmpActiveChild.Label) }`
		: _escapeHTML(pDef.Label);
	const tmpMenu = tmpChildren.map((pChild) => _menuItemHTML(pChild, pActiveKey, pOnClick)).join('');
	return `<div class="hltabs-group ${ tmpActive }${ tmpExtra }" data-groupkey="${ _escapeHTML(pDef.Key) }">`
		+ `<button type="button" class="hltab hltab-groupbtn ${ tmpActive } ${ tmpHasIcon }" title="${ _escapeHTML(pDef.Label) }" onclick="if(window._HLTabBar){window._HLTabBar.toggleGroup(this);}return false;">`
		+ `${ tmpIcon }<span class="hltab-label">${ tmpLabelInner }</span><span class="icon hltabs-more-caret"><i class="fas fa-chevron-down"></i></span>`
		+ `</button>`
		+ `<div class="hltabs-menu hltabs-group-menu">${ tmpMenu }</div>`
		+ `</div>`;
}

/** Full markup for one top-level item (leaf or group). */
function _itemHTML(pDef, pActiveKey, pOnClick, pExtraClass)
{
	if (pDef && Array.isArray(pDef.Children) && pDef.Children.length)
	{
		return _groupHTML(pDef, pActiveKey, pOnClick, pExtraClass);
	}
	return _leafHTML(pDef, pActiveKey, pOnClick, pExtraClass);
}

/** Stable-order top-level defs by pin zone (left → center → right); mark the first center/right item so CSS can
 *  open the flex gap. Returns [{ def, zoneClass }] in render order. */
function _orderByPin(pTabDefs)
{
	const tmpDefs = Array.isArray(pTabDefs) ? pTabDefs : [];
	const fRank = (pPin) => (pPin === 'right') ? 2 : ((pPin === 'center') ? 1 : 0);
	const tmpIndexed = tmpDefs.map((pDef, pIndex) => ({ def: pDef, index: pIndex, rank: fRank(pDef && pDef.Pin) }));
	tmpIndexed.sort((pA, pB) => (pA.rank - pB.rank) || (pA.index - pB.index));
	let tmpSeenCenter = false;
	let tmpSeenRight = false;
	return tmpIndexed.map((pEntry) =>
	{
		let tmpZoneClass = '';
		if ((pEntry.rank === 1) && !tmpSeenCenter) { tmpSeenCenter = true; tmpZoneClass = 'hltabs-zone-center'; }
		else if ((pEntry.rank === 2) && !tmpSeenRight) { tmpSeenRight = true; tmpZoneClass = 'hltabs-zone-right'; }
		return { def: pEntry.def, zoneClass: tmpZoneClass };
	});
}

/**
 * Shape tab definitions into the render records the shared item template consumes. Each record carries its
 * pre-built `HTML` (the item template injects it raw). Legacy fields (Label/Icon/…) are kept for any consumer
 * still referencing them, but the shared template only needs HTML.
 * @param {Array<{Key:String, Label:String, Icon?:String, Children?:Array, Pin?:String}>} pTabDefs
 * @param {String} pActiveKey - the currently-active tab's Key (may match a group's child).
 * @param {(pTab:Object)=>String} pOnClick - returns the onclick JS for a leaf/child tab (e.g. the host's setTab call).
 * @return {Array<Object>}
 */
function buildTabs(pTabDefs, pActiveKey, pOnClick)
{
	return _orderByPin(pTabDefs).map((pEntry) =>
	{
		const tmpDef = pEntry.def;
		const tmpIsGroup = !!(tmpDef && Array.isArray(tmpDef.Children) && tmpDef.Children.length);
		const tmpActive = tmpIsGroup
			? (tmpDef.Children.some((pChild) => String(pChild.Key) === String(pActiveKey)))
			: (String(pActiveKey) === String(tmpDef.Key));
		return {
			Key: tmpDef.Key,
			IsGroup: tmpIsGroup,
			HTML: _itemHTML(tmpDef, pActiveKey, pOnClick, pEntry.zoneClass),
			// Legacy fields (leaf only) — harmless for groups; retained for backward compatibility.
			Label: tmpDef.Label,
			Icon: tmpDef.Icon || '',
			ActiveClass: tmpActive ? 'is-active' : '',
			IconClass: tmpDef.Icon ? 'has-icon' : '',
			OnClick: (!tmpIsGroup && (typeof pOnClick === 'function')) ? pOnClick(tmpDef) : '',
		};
	});
}

/**
 * Build the container class string from options: { overflow: 'menu'|'wrap'|'scroll', display: 'both'|'icon'|'text' }.
 * @param {{overflow?:String, display?:String}} [pOptions]
 * @return {String}
 */
function containerClass(pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpClasses = [ 'hltabs' ];
	const tmpOverflow = tmpOptions.overflow || 'scroll';
	tmpClasses.push((tmpOverflow === 'menu') ? 'hltabs--menu' : (tmpOverflow === 'wrap') ? 'hltabs--wrap' : 'hltabs--scroll');
	if (tmpOptions.display === 'icon') { tmpClasses.push('hltabs--icon-only'); }
	else if (tmpOptions.display === 'text') { tmpClasses.push('hltabs--text-only'); }
	return tmpClasses.join(' ');
}

/**
 * Render a complete tab bar as an HTML STRING — for hosts that build their DOM as strings (plain providers)
 * rather than pict templates. Same tabs/options as buildTabs + containerClass. The onClick expression is a
 * controlled JS string (single-quoted), placed verbatim in the onclick attribute.
 * @param {Array} pTabDefs @param {String} pActiveKey @param {(pTab:Object)=>String} pOnClick
 * @param {{overflow?:String, display?:String}} [pOptions]
 * @return {String}
 */
function renderTabsHTML(pTabDefs, pActiveKey, pOnClick, pOptions)
{
	const tmpItems = _orderByPin(pTabDefs).map((pEntry) => _itemHTML(pEntry.def, pActiveKey, pOnClick, pEntry.zoneClass)).join('');
	return `<div class="${ containerClass(pOptions) }">${ tmpItems }</div>`;
}

// --- Runtime (browser): dropdown open/close (groups + "More") and the `menu` overflow partition -----------

/** Install the shared dropdown runtime (a single global so only one dropdown — group or More — is open at a
 *  time, with outside-click / scroll / Escape closing it) and the resize→relayout schedule. Idempotent. */
function _ensureRuntime()
{
	if (typeof window === 'undefined') { return null; }
	if (window._HLTabBar) { return window._HLTabBar; }
	const RT =
	{
		_open: null,
		close()
		{
			if (RT._open) { if (RT._open.classList) { RT._open.classList.remove('is-open'); } RT._open = null; }
		},
		toggle(pWrap)
		{
			if (!pWrap) { return; }
			const tmpWasOpen = pWrap.classList.contains('is-open');
			RT.close();
			if (!tmpWasOpen) { pWrap.classList.add('is-open'); RT._open = pWrap; RT._position(pWrap); }
		},
		toggleGroup(pButton) { RT.toggle((pButton && pButton.closest) ? pButton.closest('.hltabs-group') : null); },
		/** The dropdown is position:fixed so it escapes the tab row's overflow-x:clip (and never clips at the view
		 *  edge). Anchor it under its trigger: right-zone groups + the "More" menu right-align to the trigger's right
		 *  edge (they sit at the far right); everything else left-aligns. Then clamp into the viewport. It closes on
		 *  scroll/resize, so a single position on open is enough. */
		_position(pWrap)
		{
			const tmpMenu = pWrap.querySelector(':scope > .hltabs-menu');
			const tmpTrigger = pWrap.querySelector(':scope > button');
			if (!tmpMenu || !tmpTrigger) { return; }
			const tmpRect = tmpTrigger.getBoundingClientRect();
			const tmpViewport = document.documentElement.clientWidth;
			const tmpMargin = 8;
			tmpMenu.style.top = Math.round(tmpRect.bottom + 3) + 'px';
			const tmpWidth = tmpMenu.offsetWidth;   // measured now that .is-open made it display:block
			const tmpRightAlign = pWrap.classList.contains('hltabs-zone-right') || pWrap.classList.contains('hltabs-more');
			let tmpLeft = tmpRightAlign ? (tmpRect.right - tmpWidth) : tmpRect.left;
			if ((tmpLeft + tmpWidth) > (tmpViewport - tmpMargin)) { tmpLeft = tmpViewport - tmpMargin - tmpWidth; }
			if (tmpLeft < tmpMargin) { tmpLeft = tmpMargin; }
			tmpMenu.style.left = Math.round(tmpLeft) + 'px';
			tmpMenu.style.right = 'auto';
		},
	};
	window._HLTabBar = RT;
	let tmpScheduled = false;
	const fSchedule = () =>
	{
		if (tmpScheduled) { return; }
		tmpScheduled = true;
		window.requestAnimationFrame(() => { tmpScheduled = false; layout(); });
	};
	window.addEventListener('resize', fSchedule);
	document.addEventListener('click', (pEvent) => { if (RT._open && !RT._open.contains(pEvent.target)) { RT.close(); } }, true);
	window.addEventListener('scroll', () => { if (RT._open) { RT.close(); } }, true);
	document.addEventListener('keydown', (pEvent) => { if (pEvent.key === 'Escape') { RT.close(); } });
	return RT;
}

function _buildMenuItemFromTab(pTab)
{
	const tmpItem = document.createElement('button');
	tmpItem.type = 'button';
	tmpItem.className = 'hltabs-menu-item';
	tmpItem.innerHTML = pTab.innerHTML;   // icon + label, cloned from the tab
	if (pTab.classList.contains('is-active')) { tmpItem.classList.add('is-active'); }
	tmpItem.addEventListener('click', () => { const tmpRT = _ensureRuntime(); if (tmpRT) { tmpRT.close(); } pTab.click(); });
	return tmpItem;
}

function _buildMore()
{
	const tmpWrap = document.createElement('div');
	tmpWrap.className = 'hltabs-more';
	const tmpButton = document.createElement('button');
	tmpButton.type = 'button';
	tmpButton.className = 'hltabs-more-btn';
	tmpButton.setAttribute('title', 'More tabs');
	tmpButton.innerHTML = '<span class="icon"><i class="fas fa-ellipsis"></i></span><span class="hltabs-more-label">More</span><span class="icon hltabs-more-caret"><i class="fas fa-chevron-down"></i></span>';
	tmpButton.addEventListener('click', (pEvent) => { pEvent.stopPropagation(); const tmpRT = _ensureRuntime(); if (tmpRT) { tmpRT.toggle(tmpWrap); } });
	const tmpMenu = document.createElement('div');
	tmpMenu.className = 'hltabs-menu';
	tmpWrap.appendChild(tmpButton);
	tmpWrap.appendChild(tmpMenu);
	return tmpWrap;
}

/** Move a folded top-level item into the "More" menu. A leaf becomes one menu item; a GROUP becomes a small
 *  section label + its child items (cloned from the group's own dropdown so their inline-onclick navigation is
 *  preserved), so the whole group stays reachable from More. */
function _appendFoldedToMenu(pItem, pMenu)
{
	if (pItem.classList.contains('hltabs-group'))
	{
		const tmpButton = pItem.querySelector(':scope > .hltab-groupbtn');
		const tmpLabel = document.createElement('div');
		tmpLabel.className = 'hltabs-menu-grouplabel';
		tmpLabel.textContent = (tmpButton && tmpButton.getAttribute('title')) || '';
		pMenu.appendChild(tmpLabel);
		const tmpChildren = pItem.querySelectorAll(':scope > .hltabs-group-menu > .hltabs-menu-item');
		Array.prototype.forEach.call(tmpChildren, (pChild) =>
		{
			const tmpClone = pChild.cloneNode(true);   // inline onclick (navigation) survives the clone
			tmpClone.addEventListener('click', () => { const tmpRT = _ensureRuntime(); if (tmpRT) { tmpRT.close(); } });
			pMenu.appendChild(tmpClone);
		});
	}
	else
	{
		pMenu.appendChild(_buildMenuItemFromTab(pItem));
	}
}

/** Partition one `.hltabs--menu` bar: when the tabs don't all fit, collapse the overflowing ones into a "More ▾"
 *  dropdown — LEAVES and GROUPS alike (a folded group lists its children under a label in the menu). The active
 *  tab is never folded; folding runs over the rest right-to-left (the left-cluster groups first, then the pinned
 *  zone last) until the row fits. Fit is tested by SUM-OF-WIDTHS, not element positions: a pinned (margin-left:auto)
 *  item sits at the right edge and its leading gap is empty slack, so a position-based test would falsely read
 *  "overflowing" forever; summing widths ignores where the auto-margin distributes that slack. */
function _layoutMenuBar(pBar)
{
	const tmpRT = _ensureRuntime();
	if (tmpRT) { tmpRT.close(); }
	const tmpPriorMore = pBar.querySelector(':scope > .hltabs-more');
	if (tmpPriorMore) { pBar.removeChild(tmpPriorMore); }
	// Top-level items = leaf tabs (.hltab, but NOT the group buttons which are .hltab inside .hltabs-group) + groups.
	const tmpItems = Array.prototype.filter.call(pBar.children, (pChild) => pChild.classList
		&& (pChild.classList.contains('hltabs-group') || (pChild.classList.contains('hltab') && !pChild.classList.contains('hltab-groupbtn'))));
	tmpItems.forEach((pItem) => pItem.classList.remove('is-overflow'));
	if (tmpItems.length === 0) { return; }
	const tmpAvailable = pBar.clientWidth;
	if (tmpAvailable <= 0) { return; }   // not laid out yet — a later render/resize will fix it

	let tmpGap = parseFloat(getComputedStyle(pBar).columnGap || getComputedStyle(pBar).gap || '0');
	if (!(tmpGap >= 0)) { tmpGap = 0; }
	const tmpWidths = tmpItems.map((pItem) => pItem.offsetWidth);
	const tmpOverflow = new Set();
	// Total row width for the currently-visible items (+ the More button when present). Auto-margins only add
	// empty slack, so sum-of-widths ≤ clientWidth is the true "fits" test.
	const fFits = (pMoreW) =>
	{
		let tmpCount = 0;
		let tmpWidth = 0;
		for (let i = 0; i < tmpItems.length; i++) { if (!tmpOverflow.has(i)) { tmpWidth += tmpWidths[i]; tmpCount++; } }
		if (pMoreW > 0) { tmpWidth += pMoreW; tmpCount++; }
		return (tmpWidth + tmpGap * Math.max(0, tmpCount - 1)) <= (tmpAvailable + 1);
	};
	if (fFits(0)) { return; }   // it all fits — no "More"

	// Build "More" and park it at the END of the left cluster (before the first pinned item), so a right-pinned
	// tab stays pinned right and "More" reads where the folded tabs used to be.
	const fIsZoned = (pItem) => pItem.classList.contains('hltabs-zone-right') || pItem.classList.contains('hltabs-zone-center');
	const tmpMore = _buildMore();
	const tmpFirstZoned = tmpItems.find((pItem) => fIsZoned(pItem));
	if (tmpFirstZoned)
	{
		// Park "More" at the end of the left cluster, before the pinned item. `.hltabs-more` carries
		// margin-left:auto (which pushes it right when it's the LAST child); cancel it here so it doesn't fight the
		// pinned item's own auto-margin and get shoved off the right edge — the pinned item still floats right.
		tmpMore.style.marginLeft = '0';
		pBar.insertBefore(tmpMore, tmpFirstZoned);
	}
	else { pBar.appendChild(tmpMore); }
	const tmpMoreW = tmpMore.offsetWidth;
	const tmpMenu = tmpMore.querySelector('.hltabs-menu');

	// Fold order: right-to-left over the left-cluster items first (the ones that squeeze), then the pinned
	// (center/right-zone) items last, and NEVER the active tab.
	const tmpLeft = [];
	const tmpZoned = [];
	tmpItems.forEach((pItem, pIndex) => { (fIsZoned(pItem) ? tmpZoned : tmpLeft).push(pIndex); });
	const tmpFoldOrder = tmpLeft.slice().reverse().concat(tmpZoned.slice().reverse())
		.filter((pIndex) => !tmpItems[pIndex].classList.contains('is-active'));

	for (let i = 0; (i < tmpFoldOrder.length) && !fFits(tmpMoreW); i++)
	{
		const tmpIndex = tmpFoldOrder[i];
		tmpOverflow.add(tmpIndex);
		tmpItems[tmpIndex].classList.add('is-overflow');
		_appendFoldedToMenu(tmpItems[tmpIndex], tmpMenu);
	}
	if (!tmpMenu.children.length) { pBar.removeChild(tmpMore); }
}

/**
 * (Re)partition every `.hltabs--menu` bar under pRoot and ensure the dropdown runtime is bound. Hosts call this
 * from onAfterRender. No overflow work for scroll/wrap bars (pure CSS) — but it still installs the runtime.
 * @param {Document|Element} [pRoot]
 */
function layout(pRoot)
{
	if (typeof document === 'undefined') { return; }
	_ensureRuntime();
	const tmpRoot = pRoot || document;
	const tmpBars = tmpRoot.querySelectorAll ? tmpRoot.querySelectorAll('.hltabs--menu') : [];
	Array.prototype.forEach.call(tmpBars, (pBar) => _layoutMenuBar(pBar));
}

// Install the dropdown runtime as soon as the module loads in a browser, so group tabs toggle even for hosts
// that never call layout() (e.g. scroll/wrap plain-provider bars).
_ensureRuntime();

module.exports = { TABBAR_CSS, TABBAR_TEMPLATES, buildTabs, containerClass, renderTabsHTML, layout };

},{}],1040:[function(require,module,exports){
arguments[4][715][0].apply(exports,arguments)
},{"dup":715}],1041:[function(require,module,exports){
arguments[4][716][0].apply(exports,arguments)
},{"./Pict-Section-TuiGrid-DefaultConfiguration.json":1040,"./Pict-TuiGrid-Editors.js":1044,"./Pict-TuiGrid-Headers.js":1045,"dup":716,"pict-view":1053}],1042:[function(require,module,exports){
arguments[4][717][0].apply(exports,arguments)
},{"dup":717}],1043:[function(require,module,exports){
arguments[4][718][0].apply(exports,arguments)
},{"dup":718}],1044:[function(require,module,exports){
arguments[4][719][0].apply(exports,arguments)
},{"./Pict-TuiGrid-Editor-Number.js":1042,"./Pict-TuiGrid-Editor-Text.js":1043,"dup":719}],1045:[function(require,module,exports){
arguments[4][720][0].apply(exports,arguments)
},{"dup":720}],1046:[function(require,module,exports){
'use strict';

// The shared Workspace shell + generic-content CSS (the `.pw-*` family, promoted out of ProjectWorkspace so it is
// no longer a side-effect of whichever workspace paints first). Entity-specific styling (maps, staffing, logos,
// label managers, …) stays in each workspace config's `CSSExtra`. The tab-bar CSS comes from pict-section-tabbar.

const libTabBar = require('pict-section-tabbar');

const WORKSPACE_CSS = /*css*/`
	.pw-wrap { padding: 1.25rem 1.5rem 2rem; }
	.pw-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
	.pw-head-id { min-width: 0; }
	.pw-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); margin: 0; }
	.pw-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
	.pw-subtitle { font-size: 0.86rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.3rem 0 0; }
	.pw-head-actions, .pw-head-btns { display: inline-flex; gap: 0.4rem; flex: 0 0 auto; align-items: center; flex-wrap: wrap; }
	.pw-btn { font-size: 0.82rem; font-weight: 600; padding: 0.42rem 0.85rem; border-radius: 7px; border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); cursor: pointer; display: inline-flex; align-items: center; gap: 0.4rem; text-decoration: none; }
	.pw-btn:hover { border-color: var(--theme-color-brand-primary, #5650e6); color: var(--theme-color-text-primary, #1f2733); text-decoration: none; }
	.pw-btn.is-link { background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); color: #fff; }
	.pw-btn.is-link:hover { color: #fff; opacity: 0.94; }
	.pw-btn.is-light { background: var(--theme-color-background-secondary, #f0f2f6); }
	.pw-btn.is-danger { color: var(--theme-color-status-danger, #c0392b); border-color: var(--theme-color-status-danger, #c0392b); background: transparent; }
	.pw-back { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; align-self: center; }
	.pw-back:hover { color: var(--theme-color-brand-primary, #5650e6); }

	.pw-tabnav { border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); margin: 0.6rem 0 0; }
	.pw-panel { border: 1px solid var(--theme-color-border-default, #d7dce3); border-top: none; border-radius: 0 0 8px 8px; background: var(--theme-color-background-panel, #fff); padding: 1.4rem 1.5rem; min-height: 12rem; }
	.pw-panel.pw-panel-standalone { border-top: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; }

	.pw-state { padding: 1.6rem 0.4rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.92rem; }
	.pw-empty { text-align: center; color: var(--theme-color-text-muted, #8a94a3); padding: 2.2rem 0; }
	.pw-empty .fa-inbox, .pw-empty .fa-circle-info { font-size: 1.6rem; opacity: 0.5; }
	.pw-empty p { margin-top: 0.5rem; font-size: 0.9rem; }
	.pw-error { font-size: 0.88rem; color: var(--theme-color-status-danger, #c0392b); }
	.pw-spinner { display: inline-block; width: 1.4rem; height: 1.4rem; border: 3px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: pw-spin 0.8s linear infinite; vertical-align: middle; }
	.pw-spinner-inline { width: 1rem; height: 1rem; border-width: 2px; }
	@keyframes pw-spin { to { transform: rotate(360deg); } }

	/* Overview field groups */
	.pw-group { margin: 0 0 1.4rem; }
	.pw-group:last-child { margin-bottom: 0; }
	.pw-group-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6);
		background: var(--theme-color-background-selected, #eef1f8); padding: 0.35rem 0.7rem; border-radius: 6px; margin: 0 0 0.7rem; display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; }
	.pw-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr)); gap: 0.85rem 1.4rem; }
	.pw-field.pw-field-wide { grid-column: 1 / -1; }
	.pw-field-label { display: block; font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.1rem; }
	.pw-field-value { font-size: 1.02rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); word-break: break-word; }
	.pw-field-value.pw-field-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; font-weight: 500; }
	.pw-desc { white-space: pre-wrap; font-weight: 500; font-size: 0.98rem; color: var(--theme-color-text-primary, #1f2733); }

	/* Generic related-data tables (childlist / render) */
	.pw-toolbar { display: flex; gap: 0.5rem; margin-bottom: 0.9rem; align-items: center; flex-wrap: wrap; }
	.pw-tablewrap { overflow-x: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
	.pw-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.86rem; }
	.pw-table thead th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); white-space: nowrap; }
	.pw-table tbody td { padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; color: var(--theme-color-text-secondary, #45505f); }
	.pw-table tbody tr:last-child td { border-bottom: none; }
	.pw-table tbody tr:hover td { background: var(--theme-color-background-secondary, #f7f9fb); }
	.pw-table .pw-num { text-align: right; font-variant-numeric: tabular-nums; }
	.pw-cell-strong { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
	.pw-muted { color: var(--theme-color-text-muted, #8a94a3); }
	.pw-row-actions { white-space: nowrap; text-align: right; }
	.pw-row-actions .pw-btn { padding: 0.2rem 0.5rem; font-size: 0.74rem; margin-left: 0.25rem; }
	.pw-embed-host { min-height: 4rem; }
	.pw-status-pill { font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.14rem 0.55rem; border-radius: 999px; background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-brand-primary, #5650e6); }

	${ libTabBar.TABBAR_CSS }
`;

module.exports = { WORKSPACE_CSS };

},{"pict-section-tabbar":1039}],1047:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libTabBar = require('pict-section-tabbar');

// The base association-editor from pict-section-recordset (used for kind:'assoc' tabs) is an OPTIONAL peer: a host
// that uses assoc tabs installs pict-section-recordset; without it, assoc tabs degrade gracefully. The require is
// built from a computed path so the bundler + typechecker treat it as a runtime-only, optional dependency.
let libRecordSetAssociationEditor = null;
try { libRecordSetAssociationEditor = require([ 'pict-section-recordset', 'source/views/associate/RecordSet-AssociationEditor.js' ].join('/')); }
catch (pError) { /* assoc tabs unavailable without pict-section-recordset */ }

// Host-settable defaults. These let an application wire the framework ONCE (next to `setDefaultDestination`)
// instead of threading the same value through every workspace config:
//   - DEFAULT_REST_CLIENT_NAME: which fable service speaks to the record API. A host that registers its client
//     under a name other than `RestClient` (and may also have a differently-based `RestClient` registered) sets
//     this so the base resolves the right one — otherwise the read hits the wrong base URL.
//   - libRecordSetAssociationEditor: the base association editor. The optional require above is written as a
//     computed path so bundlers/typecheckers treat pict-section-recordset as runtime-only; some bundlers
//     (e.g. browserify) will not include a computed require at all, leaving it null and breaking every assoc
//     tab. `setAssociationEditorLib()` lets such a host inject the editor it already bundles.
let DEFAULT_REST_CLIENT_NAME = 'RestClient';
function setDefaultRestClientName(pName) { if (pName && (typeof pName === 'string')) { DEFAULT_REST_CLIENT_NAME = pName; } }
function setAssociationEditorLib(pLib) { if (pLib) { libRecordSetAssociationEditor = pLib; } }

/**
 * pict-section-workspace base provider — owns everything every entity workspace shares: the REST + format helpers,
 * the GUID-bridge loader, tab routing, permissions, the shell render (header + tab bar + body panel), and the four
 * tab content-kind resolvers (render / embed / assoc / childlist). A concrete workspace is either the base + a
 * declarative config (registered by the factory) or a thin subclass that adds bespoke `render:` tab methods.
 *
 * Config is read from `this.workspaceConfig` — the factory sets `options.WorkspaceConfig`; a subclass may override
 * the getter. See Pict-Section-Workspace.js for the config schema.
 */
class PictSectionWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._record = null;
		this._id = 0;
		this._activeTab = null;
		this._mode = 'view';
		this._assocRenderQueue = Promise.resolve();
	}

	// --- config + identity -----------------------------------------------------------------------------------
	get workspaceConfig() { return this.options.WorkspaceConfig || {}; }
	get identifier() { return this.workspaceConfig.Identifier; }
	get entityName() { return this.workspaceConfig.Entity.Name; }
	get idField() { return this.workspaceConfig.Entity.IDField || `ID${this.entityName}`; }
	get collection() { return this.workspaceConfig.Entity.Collection || `${this.entityName}s`; }
	get guidField() { return this.workspaceConfig.Entity.GUIDField || `GUID${this.entityName}`; }
	readEndpoint(pID) { const fn = this.workspaceConfig.Entity.ReadEndpoint; return fn ? fn(pID) : `${this.entityName}/${pID}`; }
	/** URL segment for the workspace routes (#/<prefix>/Workspace/…). Defaults to the entity name; a config may
	 *  override it when the route noun differs from the entity (e.g. PhysicalAsset records under #/Asset/Workspace). */
	get routePrefix() { return this.workspaceConfig.RoutePrefix || this.entityName; }

	get containerSelector() { return `#${this.identifier}-Container`; }
	get bodySelector() { return `#${this.identifier}-Body`; }
	get view() { return this.pict.views[this.identifier]; }
	get record() { return this._record || {}; }
	get idRecord() { return this._id; }

	get state()
	{
		const tmpKey = this.identifier;
		if (!this.pict.AppData[tmpKey]) { this.pict.AppData[tmpKey] = { Loading: false, Message: '', Tab: '' }; }
		return this.pict.AppData[tmpKey];
	}

	// --- REST + helpers --------------------------------------------------------------------------------------
	/** Name of the fable service that speaks to the record API (getJSON/putJSON/postJSON). Override per workspace
	 *  via config `RestClientName`, or app-wide via `setDefaultRestClientName()`; defaults to `RestClient`. Falls
	 *  back to a couple of common names so a host that registered its client under a different name still resolves. */
	get restClientName() { return this.workspaceConfig.RestClientName || DEFAULT_REST_CLIENT_NAME; }
	get restClient()
	{
		const tmpFable = this.pict.fable || {};
		return tmpFable[this.restClientName] || tmpFable.RestClient || tmpFable.HeadlightRestClient || this.pict.RestClient || this.pict.HeadlightRestClient || null;
	}
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	/** Shared display formatter — the currency/percent/number/id/date/bool switch every workspace overview used. */
	_formatValue(pValue, pFormat)
	{
		if (pValue === null || pValue === undefined || pValue === '') { return '—'; }
		switch (pFormat)
		{
		case 'currency': { const tmpN = Number(pValue); return isNaN(tmpN) ? String(pValue) : `$${tmpN.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`; }
		case 'percent': { const tmpN = Number(pValue); return isNaN(tmpN) ? String(pValue) : `${tmpN}%`; }
		case 'number': { const tmpN = Number(pValue); return isNaN(tmpN) ? String(pValue) : tmpN.toLocaleString(); }
		case 'date': { const tmpS = String(pValue); return (tmpS.indexOf('T') > -1) ? tmpS.slice(0, 10) : tmpS; }
		case 'bool': return (pValue === true || pValue === 1 || pValue === '1') ? 'Yes' : 'No';
		default: return String(pValue);
		}
	}

	// --- permissions -----------------------------------------------------------------------------------------
	get permissions() { return this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService); }
	can(pEntity, pAction)
	{
		const tmpSvc = this.permissions;
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return true; }
		return !!tmpSvc.can(pEntity, pAction);
	}
	/** Default: fail-open until the capability map is ready, then require <Entity>-Read. A config can override. */
	canRead()
	{
		const tmpCfg = this.workspaceConfig.Permissions || {};
		if (typeof tmpCfg.Read === 'function') { return !!tmpCfg.Read(this); }
		const tmpSvc = this.permissions;
		if (!tmpSvc || !tmpSvc.currentUserReady || !tmpSvc.currentUserReady()) { return true; }
		return this.can(this.entityName, 'Read');
	}

	// --- load ------------------------------------------------------------------------------------------------
	/** True in edit or create mode — used to swap the tab body for the configured EditContent (a CRUD form host). */
	get isEditing() { return (this._mode === 'edit') || (this._mode === 'create'); }
	get mode() { return this._mode; }

	async loadAsync(pID, pTab, pMode)
	{
		this._id = parseInt(pID, 10) || 0;
		this._mode = (pMode === 'edit') ? 'edit' : 'view';
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Message = '';
		this._activeTab = this._normalizeTab(pTab);
		tmpState.Tab = this._activeTab;
		this.renderWorkspace();
		try
		{
			const tmpRecord = await this._getJSON(this.readEndpoint(this._id));
			if (!tmpRecord || !tmpRecord[this.idField]) { throw new Error(`${this.entityName} ${this._id} not found.`); }
			this._record = tmpRecord;
			this._resolvedCards = {};
			if (typeof this['hydrateAsync'] === 'function') { await this['hydrateAsync'](tmpRecord); }
			tmpState.Loading = false;
			this.renderWorkspace();
			this._resolveCardsAsync();   // best-effort; re-renders the overview when related names arrive
			await this._enterTab(this.isEditing ? '__edit__' : this._activeTab);
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the ${this.entityName.toLowerCase()}: ${(pError && pError.message) || pError}`;
			this.renderWorkspace();
		}
	}

	async openByGUIDAsync(pGUID, pMode)
	{
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Message = '';
		this._mode = (pMode === 'edit') ? 'edit' : 'view';
		this.renderWorkspace();
		const tmpRows = await this._getJSON(`${this.collection}/FilteredTo/FBV~${this.guidField}~EQ~${encodeURIComponent(pGUID)}`);
		const tmpRecord = (Array.isArray(tmpRows) && tmpRows.length > 0) ? tmpRows[0] : null;
		if (!tmpRecord)
		{
			this._record = null;
			tmpState.Loading = false;
			tmpState.Message = `No ${this.entityName.toLowerCase()} found for ${pGUID}.`;
			this.renderWorkspace();
			return;
		}
		return this.loadAsync(tmpRecord[this.idField], this._activeTab, this._mode);
	}

	/** Enter CREATE mode (no record). Subclasses implement hydrateCreateAsync(pArg) to seed the working form. */
	async startCreateAsync(pArg)
	{
		this._id = 0;
		this._mode = 'create';
		this._record = {};
		this._resolvedCards = {};
		const tmpState = this.state;
		tmpState.Loading = false; tmpState.Message = ''; tmpState.Tab = this._activeTab;
		if (typeof this['hydrateCreateAsync'] === 'function') { await this['hydrateCreateAsync'](pArg); }
		this.renderWorkspace();
		await this._enterTab('__edit__');
	}

	// --- tabs ------------------------------------------------------------------------------------------------
	get tabDefs() { return this.workspaceConfig.Tabs || []; }
	/** Tab defs for RENDERING: resolves any function-valued Label against `this` (dynamic labels, e.g. "Projects (N)"). */
	_resolvedTabDefs()
	{
		const fResolve = (pTab) =>
		{
			const tmpTab = Object.assign({}, pTab);
			if (typeof tmpTab.Label === 'function') { try { tmpTab.Label = tmpTab.Label(this); } catch (pError) { tmpTab.Label = ''; } }
			if (Array.isArray(tmpTab.Children)) { tmpTab.Children = tmpTab.Children.map(fResolve); }
			return tmpTab;
		};
		return this.tabDefs.map(fResolve);
	}
	_leafTabs()
	{
		const tmpOut = [];
		for (const tmpTab of this.tabDefs)
		{
			if (Array.isArray(tmpTab.Children) && tmpTab.Children.length) { tmpOut.push(...tmpTab.Children); }
			else { tmpOut.push(tmpTab); }
		}
		return tmpOut;
	}
	validTabKeys() { return this._leafTabs().map((pTab) => pTab.Key); }
	defaultTab() { const tmpLeaves = this._leafTabs(); return tmpLeaves.length ? tmpLeaves[0].Key : ''; }
	_normalizeTab(pTab) { const tmpKeys = this.validTabKeys(); return (tmpKeys.indexOf(pTab) > -1) ? pTab : this.defaultTab(); }
	_activeLeaf() { return this._leafTabs().find((pTab) => pTab.Key === this._activeTab) || null; }

	navigateTab(pTab)
	{
		if (this._id && (typeof window !== 'undefined') && window.location) { window.location.hash = `#/${this.routePrefix}/Workspace/${this._id}/${pTab}`; }
		else { this.setTab(pTab); }
	}
	openTabAsync(pID, pTab)
	{
		const tmpID = parseInt(pID, 10);
		if (this._record && (Number(this._record[this.idField]) === tmpID) && !this.state.Loading) { return Promise.resolve(this.setTab(pTab)); }
		return Promise.resolve(this.loadAsync(tmpID, pTab));
	}
	setTab(pTab)
	{
		this._activeTab = this._normalizeTab(pTab);
		this.state.Tab = this._activeTab;
		this.renderWorkspace();
		return this._enterTab(this._activeTab);
	}
	async _enterTab(pTab)
	{
		// '__edit__' is the pseudo-tab for the edit/create body — its OnEnter lives on EditContent.
		const tmpLeaf = (pTab === '__edit__') ? { Key: '__edit__', OnEnter: (this.workspaceConfig.EditContent || {}).OnEnter } : this._leafTabs().find((t) => t.Key === pTab);
		if (tmpLeaf && tmpLeaf.OnEnter)
		{
			const tmpFn = (typeof tmpLeaf.OnEnter === 'function') ? tmpLeaf.OnEnter : this[tmpLeaf.OnEnter];
			if (typeof tmpFn === 'function') { try { await tmpFn.call(this, this); } catch (pError) { this.pict.log.warn(`${this.identifier}: OnEnter(${pTab}) failed: ${(pError && pError.message) || pError}`); } }
		}
	}

	// --- render ----------------------------------------------------------------------------------------------
	renderWorkspace()
	{
		if (!this.view) { return; }
		const tmpCfg = this.workspaceConfig;
		const tmpState = this.state;
		if (!this.canRead()) { this.pict.ContentAssignment.assignContent(this.containerSelector, `<div class="pw-wrap"><div class="pw-empty"><i class="fas fa-lock"></i><p>You don’t have access to ${this._esc(this.entityName)} records.</p></div></div>`); return; }
		// Create mode has no record yet (the form is the body), so it renders even without one.
		if (tmpState.Loading && !this._record && (this._mode !== 'create')) { this.pict.ContentAssignment.assignContent(this.containerSelector, `<div class="pw-wrap"><div class="pw-state"><span class="pw-spinner pw-spinner-inline"></span> Loading…</div></div>`); return; }
		if (tmpState.Message && !this._record && (this._mode !== 'create')) { this.pict.ContentAssignment.assignContent(this.containerSelector, `<div class="pw-wrap"><div class="pw-state">${this._esc(tmpState.Message)}</div></div>`); return; }

		const tmpRec = this.record;
		const tmpHead = tmpCfg.Header || {};
		const tmpTitle = tmpHead.Title ? tmpHead.Title(tmpRec, this) : (tmpRec.Name || `${this.entityName} ${this._id}`);
		const tmpEyebrow = (typeof tmpHead.Eyebrow === 'function') ? tmpHead.Eyebrow(tmpRec, this) : (tmpHead.Eyebrow || this.entityName);
		const tmpSubtitle = tmpHead.Subtitle ? tmpHead.Subtitle(tmpRec, this) : '';
		const tmpExtra = (typeof tmpHead.Extra === 'function') ? (tmpHead.Extra(this) || '') : '';
		// Edit/Create with a configured EditContent: no tab bar — the edit body (a form host) IS the whole panel.
		const tmpEditBody = this.isEditing && this.workspaceConfig.EditContent;
		const tmpTabs = tmpEditBody ? '' : libTabBar.renderTabsHTML(this._resolvedTabDefs(), this._activeTab,
			(pTab) => `_Pict.providers.${this.identifier}.navigateTab('${pTab.Key}')`, { overflow: 'menu' });

		const tmpHTML = `
			<div class="pw-wrap">
				<div class="pw-head">
					<div class="pw-head-id">
						<p class="pw-eyebrow">${this._esc(tmpEyebrow)}</p>
						<h1 class="pw-title">${this._escTitle(tmpTitle)}</h1>
						${tmpSubtitle ? `<div class="pw-subtitle">${this._escTitle(tmpSubtitle)}</div>` : ''}
					</div>
					<div class="pw-head-actions">${this._headerActionsHTML()}${tmpExtra}</div>
				</div>
				${tmpEditBody ? '' : `<div class="pw-tabnav">${tmpTabs}</div>`}
				<div class="pw-panel${tmpEditBody ? ' pw-panel-standalone' : ''}" id="${this.identifier}-Body"></div>
			</div>`;
		this.pict.ContentAssignment.assignContent(this.containerSelector, tmpHTML);
		libTabBar.layout(document);
		// Post-header hook (e.g. mount a QR thumbnail canvas into a header slot painted by Header.Extra).
		if (typeof tmpHead.AfterRender === 'function') { try { tmpHead.AfterRender(this); } catch (pError) { /* decorative */ } }
		this._renderActiveBody();
	}

	/** Titles/subtitles may already contain intentional markup (a status pill); allow it through but escape plain strings. */
	_escTitle(pValue) { return (typeof pValue === 'string' && /<[a-z]/i.test(pValue)) ? pValue : this._esc(pValue); }

	_headerActionsHTML()
	{
		const tmpActions = (this.workspaceConfig.Header && this.workspaceConfig.Header.Actions) || [];
		const tmpBtns = tmpActions.map((pAction) =>
		{
			if (pAction.When && !pAction.When(this)) { return ''; }
			const tmpIcon = pAction.Icon ? `<i class="${this._esc(pAction.Icon)}"></i>` : '';
			const tmpStyle = pAction.Style ? ` ${pAction.Style}` : '';
			const tmpTag = /^https?:|^#\//.test(pAction.OnClick || '') ? 'a' : 'button';
			const tmpAttr = (tmpTag === 'a') ? `href="${this._esc(pAction.OnClick)}"` : `onclick="_Pict.providers.${this.identifier}.${pAction.OnClick}"`;
			return `<${tmpTag} class="pw-btn${tmpStyle}" ${tmpAttr}>${tmpIcon}<span>${this._esc(pAction.Label)}</span></${tmpTag}>`;
		}).join('');
		const tmpList = (this.workspaceConfig.Header && this.workspaceConfig.Header.ListRoute);
		// The list Back link is a view-mode affordance — edit/create modes use their own Cancel action.
		const tmpBack = (tmpList && !this.isEditing) ? `<a class="pw-back" href="${this._esc(tmpList)}"><i class="fas fa-arrow-left"></i> Back</a>` : '';
		return `${tmpBtns}${tmpBack}`;
	}

	backToList() { const tmpList = (this.workspaceConfig.Header && this.workspaceConfig.Header.ListRoute); if (tmpList && typeof window !== 'undefined') { window.location.hash = tmpList; } }
	/** Default Edit action — the generic PSRS edit form for entities without a bespoke edit workspace. */
	goToEdit() { const tmpG = this.record[this.guidField]; if (tmpG && typeof window !== 'undefined') { window.location.hash = `#/PSRS/${this.entityName}/Edit/${tmpG}`; } }
	goToList() { this.backToList(); }

	/** Re-paint only the active tab body (used after a tab's own async load completes). */
	repaintBody() { this._renderActiveBody(); }

	_renderActiveBody()
	{
		const tmpBody = this.bodySelector;
		// Edit/Create mode with a configured EditContent: the edit body replaces the tab body entirely.
		const tmpLeaf = (this.isEditing && this.workspaceConfig.EditContent)
			? { Key: '__edit__', Content: this.workspaceConfig.EditContent }
			: this._activeLeaf();
		if (!tmpLeaf) { this.pict.ContentAssignment.assignContent(tmpBody, ''); return; }
		const tmpContent = tmpLeaf.Content || { kind: 'overview' };
		// Exit every embed view whose tab is not the active one, so a stale embed doesn't linger.
		this._exitInactiveEmbeds(tmpLeaf);
		switch (tmpContent.kind)
		{
		case 'overview': this._renderOverview(tmpBody); break;
		case 'render': this._renderBespoke(tmpLeaf, tmpContent, tmpBody); break;
		case 'embed': this._renderEmbed(tmpLeaf, tmpContent, tmpBody); break;
		case 'assoc': this._renderAssoc(tmpLeaf, tmpContent, tmpBody); break;
		case 'childlist': this._renderChildList(tmpLeaf, tmpContent, tmpBody); break;
		default: this.pict.ContentAssignment.assignContent(tmpBody, `<div class="pw-empty"><p>Unknown tab.</p></div>`);
		}
	}

	/** Resolve FieldGroups Card fields (FK → related record) to display names, then re-render the overview. */
	async _resolveCardsAsync()
	{
		const tmpGroups = this.workspaceConfig.FieldGroups || [];
		const tmpTargets = [];
		for (const tmpGroup of tmpGroups)
		{
			for (const tmpField of (tmpGroup.Fields || []))
			{
				const tmpID = this._record ? this._record[tmpField.Key] : null;
				if (tmpField.Card && (tmpID != null) && (Number(tmpID) > 0)) { tmpTargets.push({ Key: tmpField.Key, RecordSet: tmpField.Card, ID: tmpID }); }
			}
		}
		if (!tmpTargets.length) { return; }
		await Promise.all(tmpTargets.map(async (pTarget) =>
		{
			const tmpRec = await this._getJSON(`${pTarget.RecordSet}/${pTarget.ID}`);
			if (tmpRec && !tmpRec.Error) { this._resolvedCards[pTarget.Key] = tmpRec.Name || tmpRec.DisplayName || tmpRec.Title || String(pTarget.ID); }
		}));
		if (this._activeLeaf() && (this._activeLeaf().Content || {}).kind === 'overview') { this._renderOverview(this.bodySelector); }
	}

	// --- content kind: overview (FieldGroups) ----------------------------------------------------------------
	_renderOverview(pBodySel)
	{
		const tmpGroups = this.workspaceConfig.FieldGroups || [];
		const tmpRec = this.record;
		if (!tmpGroups.length) { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><i class="fas fa-circle-info"></i><p>No overview configured.</p></div>`); return; }
		const tmpHTML = tmpGroups.map((pGroup) =>
		{
			const tmpFields = (pGroup.Fields || []).map((pField) =>
			{
				let tmpVal;
				if (typeof pField.Value === 'function') { tmpVal = pField.Value(tmpRec, this); }
				else if (pField.Card && this._resolvedCards && this._resolvedCards[pField.Key] !== undefined) { tmpVal = this._resolvedCards[pField.Key]; }
				else { tmpVal = this._formatValue(tmpRec[pField.Key], pField.Format); }
				const tmpCls = `pw-field${pField.Wide ? ' pw-field-wide' : ''}`;
				const tmpValCls = `pw-field-value${pField.Mono ? ' pw-field-mono' : ''}`;
				return `<div class="${tmpCls}"><span class="pw-field-label">${this._esc(pField.Label)}</span><div class="${tmpValCls}">${this._escTitle(tmpVal)}</div></div>`;
			}).join('');
			return `<div class="pw-group"><div class="pw-group-head"><span>${this._esc(pGroup.Name)}</span></div><div class="pw-grid">${tmpFields}</div></div>`;
		}).join('');
		this.pict.ContentAssignment.assignContent(pBodySel, tmpHTML);
	}

	// --- content kind: render (bespoke) ----------------------------------------------------------------------
	_renderBespoke(pLeaf, pContent, pBodySel)
	{
		const tmpFn = (typeof pContent.ref === 'function') ? pContent.ref
			: ((this.workspaceConfig.Renderers && this.workspaceConfig.Renderers[pContent.ref]) || this[pContent.ref]);
		if (typeof tmpFn !== 'function') { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><p>Missing renderer: ${this._esc(pContent.ref)}</p></div>`); return; }
		try
		{
			const tmpOut = tmpFn.call(this, this, pBodySel);
			if (typeof tmpOut === 'string') { this.pict.ContentAssignment.assignContent(pBodySel, tmpOut); }
		}
		catch (pError) { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-error">Render failed: ${this._esc((pError && pError.message) || pError)}</div>`); }
	}

	// --- content kind: embed (host a full view via openInto) -------------------------------------------------
	_embedRefs() { const tmpOut = []; for (const tmpLeaf of this._leafTabs()) { if (tmpLeaf.Content && tmpLeaf.Content.kind === 'embed') { tmpOut.push(tmpLeaf); } } return tmpOut; }
	_embedTarget(pContent) { return (pContent.style === 'provider') ? this.pict.providers[pContent.ref] : this.pict.views[pContent.ref]; }
	_exitInactiveEmbeds(pActiveLeaf)
	{
		for (const tmpLeaf of this._embedRefs())
		{
			if (tmpLeaf.Key === (pActiveLeaf && pActiveLeaf.Key)) { continue; }
			const tmpTarget = this._embedTarget(tmpLeaf.Content);
			if (tmpTarget && typeof tmpTarget.exitEmbed === 'function') { try { tmpTarget.exitEmbed(); } catch (pError) { /* best-effort */ } }
		}
	}
	_renderEmbed(pLeaf, pContent, pBodySel)
	{
		const tmpHost = `${this.identifier}-Embed-${pLeaf.Key}`;
		this.pict.ContentAssignment.assignContent(pBodySel, `<div id="${tmpHost}" class="pw-embed-host"></div>`);
		const tmpTarget = this._embedTarget(pContent);
		if (!tmpTarget || typeof tmpTarget.openInto !== 'function') { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><p>Embedded view “${this._esc(pContent.ref)}” is not available.</p></div>`); return; }
		try
		{
			if (pContent.style === 'provider') { tmpTarget.openInto(...(pContent.args || []), this._id, `#${tmpHost}`); }
			else { tmpTarget.openInto(this._id, `#${tmpHost}`); }
		}
		catch (pError) { this.pict.log.warn(`${this.identifier}: embed ${pContent.ref} failed: ${(pError && pError.message) || pError}`); }
	}

	// --- content kind: assoc (RecordSet association editor) --------------------------------------------------
	_renderAssoc(pLeaf, pContent, pBodySel)
	{
		const tmpHost = `${this.identifier}-Assoc-${pLeaf.Key}`;
		this.pict.ContentAssignment.assignContent(pBodySel, `<div id="${tmpHost}"></div>`);
		const tmpManager = this.pict.providers.RecordSetAssociationManager;
		// Resolve the editor lib first: a config `editorLib` (registered via EditorLibs) wins, otherwise the base
		// editor (the optional pict-section-recordset peer, or whatever `setAssociationEditorLib` injected). Gate on
		// the RESOLVED lib — not the module-level var — so an injected/per-tab editor works even when the optional
		// require did not resolve (e.g. a bundler dropped the computed require).
		const tmpLib = (pContent.editorLib && this.pict.__workspaceEditorLibs && this.pict.__workspaceEditorLibs[pContent.editorLib]) || libRecordSetAssociationEditor;
		if (!tmpLib || !tmpManager || (typeof tmpManager.getAssociation !== 'function') || !tmpManager.getAssociation(pContent.ref))
		{
			this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><p>Association “${this._esc(pContent.ref)}” is not registered.</p></div>`); return;
		}
		const tmpHash = `${this.identifier}-AssocEditor-${pContent.ref}`;
		let tmpEditor = this.pict.views[tmpHash];
		if (!tmpEditor)
		{
			this.pict.addView(tmpHash, Object.assign({}, tmpLib.default_configuration,
				{ ViewIdentifier: tmpHash, AssociationHash: pContent.ref, ThisRecordSet: pContent.thisRecordSet || this.entityName, DefaultDestinationAddress: `#${tmpHost}`, PickerMode: pContent.pickerMode || 'single' },
				pContent.editorOptions || {}), tmpLib);
			tmpEditor = this.pict.views[tmpHash];
		}
		tmpEditor.options.ThisID = this._id;
		tmpEditor.options.DefaultDestinationAddress = `#${tmpHost}`;
		this._assocRenderQueue = this._assocRenderQueue
			.then(() => tmpEditor.renderEditor())
			.catch((pError) => { this.pict.log.warn(`${this.identifier}: assoc ${pContent.ref} render failed: ${(pError && pError.message) || pError}`); });
	}

	// --- content kind: childlist (FK children grid) ----------------------------------------------------------
	async _renderChildList(pLeaf, pContent, pBodySel)
	{
		this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-state"><span class="pw-spinner pw-spinner-inline"></span> Loading…</div>`);
		const tmpParentField = pContent.parentField || this.idField;
		const tmpCollection = pContent.collection || `${pContent.ref}s`;
		const tmpFilter = `${tmpCollection}/FilteredTo/FBV~${tmpParentField}~EQ~${this._id}~FBV~Deleted~EQ~0/0/${pContent.cap || 500}`;
		const tmpRows = (await this._getJSON(tmpFilter)) || [];
		if (this._activeTab !== pLeaf.Key) { return; }   // user moved on
		const tmpCols = pContent.columns || [ { Key: 'Name', Label: 'Name' } ];
		if (!tmpRows.length) { this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-empty"><i class="fas fa-inbox"></i><p>${this._esc(pContent.empty || `No ${(pContent.ref || 'record').toLowerCase()} records.`)}</p></div>`); return; }
		const tmpHead = tmpCols.map((pCol) => `<th${pCol.Num ? ' class="pw-num"' : ''}>${this._esc(pCol.Label)}</th>`).join('');
		const tmpBody = tmpRows.map((pRow) => `<tr>${tmpCols.map((pCol, pIdx) =>
		{
			const tmpVal = this._formatValue(pRow[pCol.Key], pCol.Format);
			const tmpCls = (pIdx === 0) ? 'pw-cell-strong' : (pCol.Num ? 'pw-num' : (pCol.Muted ? 'pw-muted' : ''));
			return `<td${tmpCls ? ` class="${tmpCls}"` : ''}>${this._escTitle(tmpVal)}</td>`;
		}).join('')}</tr>`).join('');
		this.pict.ContentAssignment.assignContent(pBodySel, `<div class="pw-tablewrap"><table class="pw-table"><thead><tr>${tmpHead}</tr></thead><tbody>${tmpBody}</tbody></table></div>`);
	}
}

// Host-config hooks (also re-exported from the factory index next to `setDefaultDestination`).
PictSectionWorkspaceProvider.setDefaultRestClientName = setDefaultRestClientName;
PictSectionWorkspaceProvider.setAssociationEditorLib = setAssociationEditorLib;

module.exports = PictSectionWorkspaceProvider;

},{"pict-provider":845,"pict-section-tabbar":1039}],1048:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * pict-section-workspace base view — a thin shell. It paints one container div and hands all rendering to the matching
 * provider (same Identifier), which string-renders the header + tab bar + active tab body into it. The factory
 * builds this view's default_configuration (Identifier, container template, shared + extra CSS).
 */
class PictSectionWorkspaceView extends libPictView
{
	get provider() { return this.pict.providers[this.options.ViewIdentifier]; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider && (typeof tmpProvider.renderWorkspace === 'function')) { tmpProvider.renderWorkspace(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PictSectionWorkspaceView;

},{"pict-view":1053}],1049:[function(require,module,exports){
'use strict';

/**
 * pict-section-workspace — a declarative, config-driven tabbed workspace for a single entity record.
 *
 * A workspace config:
 *   {
 *     Identifier, Ordinal,
 *     Entity:  { Name, IDField?, Collection?, GUIDField?, ReadEndpoint?(id) },
 *     Header:  { Eyebrow, Title(rec), Subtitle?(rec), Actions:[{Label,Icon?,Style?,OnClick,When?(prov)}], ListRoute },
 *     Permissions?: { Read?(prov) },                              // default: <Entity>-Read, fail-open until ready
 *     Tabs:    [ { Key, Label, Icon?, Pin?, Children?:[…leaf], Content:{kind,ref,…}, OnEnter? } ],
 *     FieldGroups?: [ { Name, Fields:[{Key,Label,Wide?,Mono?,Format?,Value?(rec,prov)}] } ],   // for kind:'overview'
 *     Renderers?: { <ref>: (prov, hostSelector) => htmlString|void },                          // for kind:'render'
 *     ProviderClass?, ViewClass?,   // subclass overrides (bespoke methods live here)
 *     CSSExtra?, EditorLibs?: { <name>: assocEditorLib },
 *     Create?: { Route }, Edit?: { Route },
 *   }
 *
 * Content kinds per tab leaf:
 *   overview   — FieldGroups grid (the base owns it)
 *   render     — Content.ref is a Renderers[ref] fn or a provider method name; paints into the tab body
 *   embed      — Content.ref is a ViewIdentifier hosted via openInto/exitEmbed (style:'provider' → a provider host,
 *                with Content.args prepended before the record id)
 *   assoc      — Content.ref is a RecordSetAssociationManager association hash; editorLib names an EditorLibs entry
 *   childlist  — Content.ref is the child Entity; {collection?, parentField?, columns:[{Key,Label,Num?,Format?}], cap?, empty?}
 */

const PictSectionWorkspaceProvider = require('./Pict-Section-Workspace-Provider.js');
const PictSectionWorkspaceView = require('./Pict-Section-Workspace-View.js');
const { WORKSPACE_CSS } = require('./Pict-Section-Workspace-CSS.js');

// Where the workspace view mounts by default. Override per workspace via config `DestinationAddress`, or set a
// global default with the exported `setDefaultDestination()`.
let DEFAULT_DESTINATION = '#Pict-Application-Container';
function setDefaultDestination(pSelector) { if (pSelector) { DEFAULT_DESTINATION = pSelector; } }

// App-wide config hooks that live on the provider module (symmetric with setDefaultDestination):
//   setDefaultRestClientName(name) — the fable service the base uses for record reads/writes (default 'RestClient').
//   setAssociationEditorLib(lib)   — inject the RecordSet association editor when the optional computed require did
//                                    not resolve in the host's bundle (keeps kind:'assoc' tabs working).
const setDefaultRestClientName = PictSectionWorkspaceProvider.setDefaultRestClientName;
const setAssociationEditorLib = PictSectionWorkspaceProvider.setAssociationEditorLib;

/** Register a workspace's provider + view pair with a pict application. */
function createWorkspace(pPict, pConfig)
{
	const tmpId = pConfig.Identifier;
	const tmpDest = pConfig.DestinationAddress || DEFAULT_DESTINATION;
	const tmpProviderClass = pConfig.ProviderClass || PictSectionWorkspaceProvider;
	const tmpViewClass = pConfig.ViewClass || PictSectionWorkspaceView;

	if (pConfig.EditorLibs) { pPict.__workspaceEditorLibs = Object.assign(pPict.__workspaceEditorLibs || {}, pConfig.EditorLibs); }

	pPict.addProvider(tmpId,
		{ ProviderIdentifier: tmpId, AutoInitialize: true, AutoInitializeOrdinal: pConfig.Ordinal || 230, WorkspaceConfig: pConfig },
		tmpProviderClass);

	pPict.addView(tmpId,
		{
			ViewIdentifier: tmpId,
			DefaultRenderable: `${tmpId}-Wrap`,
			DefaultDestinationAddress: tmpDest,
			AutoRender: false,
			CSS: WORKSPACE_CSS + (pConfig.CSSExtra || ''),
			// The container template, plus any ExtraTemplates a workspace needs registered so its bespoke
			// `render` tabs can paint them via pict.parseTemplateByHash (e.g. a migrated workspace reusing its
			// original per-tab templates + shared controller templates verbatim).
			Templates: [ { Hash: `${tmpId}-Template`, Template: `<div id="${tmpId}-Container"></div>` } ].concat(pConfig.ExtraTemplates || []),
			Renderables: [ { RenderableHash: `${tmpId}-Wrap`, TemplateHash: `${tmpId}-Template`, DestinationAddress: tmpDest, RenderMethod: 'replace' } ],
		},
		tmpViewClass);

	return { Identifier: tmpId };
}

/**
 * Register the standard workspace bridge routes on the app router. pRouter is the application's router provider
 * instance (exposes .pictRouter, .currentView, ._renderRouteView, .pict). Emits:
 *   /<Entity>/Workspace/:ID            /<Entity>/Workspace/:ID/:Tab
 *   /PSRS/<Entity>/View/:GUIDRecord    (+ optional Edit/Create bridges)
 * The :Tab whitelist is derived from the live config so it can never drift from the tab manifest.
 */
function registerWorkspaceRoutes(pRouter, pConfig)
{
	const tmpEntity = pConfig.Entity.Name;
	const tmpPrefix = pConfig.RoutePrefix || tmpEntity;   // workspace-route noun (defaults to the entity name)
	const tmpId = pConfig.Identifier;
	const tmpRouter = pRouter.pictRouter;
	const fProvider = () => pRouter.pict.providers[tmpId];

	tmpRouter.addRoute(`/${tmpPrefix}/Workspace/:ID`, (pRouteData) =>
	{
		pRouter.currentView = tmpId;
		pRouter._renderRouteView(tmpId);
		const tmpP = fProvider(); if (tmpP) { tmpP.loadAsync(parseInt(pRouteData.data.ID, 10)); }
	});

	tmpRouter.addRoute(`/${tmpPrefix}/Workspace/:ID/:Tab`, (pRouteData) =>
	{
		const tmpP = fProvider();
		const tmpTargetID = parseInt(pRouteData.data.ID, 10);
		const tmpMounted = (pRouter.currentView === tmpId) && tmpP && (Number(tmpP.idRecord) === tmpTargetID);
		pRouter.currentView = tmpId;
		if (!tmpMounted) { pRouter._renderRouteView(tmpId); }
		if (tmpP) { tmpP.openTabAsync(tmpTargetID, pRouteData.data.Tab); }
	});

	tmpRouter.addRoute(`/PSRS/${tmpEntity}/View/:GUIDRecord`, (pRouteData) =>
	{
		pRouter.currentView = tmpId;
		pRouter._renderRouteView(tmpId);
		const tmpP = fProvider(); if (tmpP) { tmpP.openByGUIDAsync(pRouteData.data.GUIDRecord); }
	});

	// Edit → open the workspace (read for now) unless the config routes it elsewhere.
	if (pConfig.Edit && pConfig.Edit.Route === 'workspace')
	{
		tmpRouter.addRoute(`/PSRS/${tmpEntity}/Edit/:GUIDRecord`, (pRouteData) =>
		{
			pRouter.currentView = tmpId;
			pRouter._renderRouteView(tmpId);
			const tmpP = fProvider(); if (tmpP) { tmpP.openByGUIDAsync(pRouteData.data.GUIDRecord, 'edit'); }
		});
	}

	// Create → enter create mode (startCreateAsync). Optional CloneRoute passes a source GUID to clone from.
	if (pConfig.Create && pConfig.Create.Route)
	{
		tmpRouter.addRoute(pConfig.Create.Route, () =>
		{
			pRouter.currentView = tmpId;
			pRouter._renderRouteView(tmpId);
			const tmpP = fProvider(); if (tmpP) { tmpP.startCreateAsync(null); }
		});
		if (pConfig.Create.CloneRoute)
		{
			tmpRouter.addRoute(pConfig.Create.CloneRoute, (pRouteData) =>
			{
				pRouter.currentView = tmpId;
				pRouter._renderRouteView(tmpId);
				const tmpP = fProvider(); if (tmpP) { tmpP.startCreateAsync((pRouteData.data && pRouteData.data.GUIDRecord) || null); }
			});
		}
	}
}

module.exports = {
	createWorkspace,
	registerWorkspaceRoutes,
	setDefaultDestination,
	setDefaultRestClientName,
	setAssociationEditorLib,
	PictSectionWorkspaceProvider,
	PictSectionWorkspaceView,
	WORKSPACE_CSS,
	// Legacy aliases (the framework was extracted from the Headlight config app) — kept so existing subclasses
	// that `extends HeadlightWorkspaceBaseProvider` keep resolving after adopting the published package.
	HeadlightWorkspaceBaseProvider: PictSectionWorkspaceProvider,
	HeadlightWorkspaceBaseView: PictSectionWorkspaceView,
};

},{"./Pict-Section-Workspace-CSS.js":1046,"./Pict-Section-Workspace-Provider.js":1047,"./Pict-Section-Workspace-View.js":1048}],1050:[function(require,module,exports){
arguments[4][730][0].apply(exports,arguments)
},{"dup":730}],1051:[function(require,module,exports){
arguments[4][731][0].apply(exports,arguments)
},{"../package.json":1050,"dup":731,"fable-serviceproviderbase":838}],1052:[function(require,module,exports){
arguments[4][732][0].apply(exports,arguments)
},{"dup":732}],1053:[function(require,module,exports){
arguments[4][733][0].apply(exports,arguments)
},{"../package.json":1052,"dup":733,"fable-serviceproviderbase":838}],1054:[function(require,module,exports){
'use strict';

/**
 * Certification kinds + per-type configuration — shared, pure data/helpers (no pict / DOM / network) so the
 * #/Certifications workspace and the #/CertificationTypes management screen use ONE source of truth (mirrors the
 * Permission-Catalog / Task-Catalog convention).
 *
 * The holder poly-join (CertificationEntityPolyJoin) is polymorphic: a Certification can be held by a User, Material,
 * Lab, Equipment, Test, MixDesign, … HOLDER_KINDS knows how to list/search/label each (list route = Scope+'s', single
 * = Scope). `Certifiable` kinds are offered when certifying; every kind (plus a generic fallback) resolves existing
 * holders.
 *
 * Each CertificationType carries a small per-type CONFIG in the cascading Configuration service — namespace
 * CERT_CONFIG_NAMESPACE, ONE NamespaceValue per type (`CertificationType-<id>`), blob { HolderKinds, AppliesToKinds,
 * DefaultValidityYears }. It declares which kinds a type certifies (holders) and certifies-for, so the workspace can
 * pre-scope + simplify. Absent config falls back to built-in defaults (defaultConfigFor) — most certifications certify
 * PEOPLE for materials/labs; lab/plant-flavored ones default to Labs.
 */

// `Search` is the columns a kind is found by; Users use the shared user search instead (access/User-Search.js).
const HOLDER_KINDS =
[
	{ Kind: 'User', Label: 'User', One: 'User', Plural: 'Users', IDField: 'IDUser', Certifiable: true, Search: null, Ph: 'users by name, login ID or email' },
	{ Kind: 'Material', Label: 'Material', One: 'Material', Plural: 'Materials', IDField: 'IDMaterial', Certifiable: true, Search: [ 'Name' ], Ph: 'materials' },
	{ Kind: 'Lab', Label: 'Lab', One: 'Lab', Plural: 'Labs', IDField: 'IDLab', Certifiable: true, Search: [ 'Name' ], Ph: 'labs' },
	{ Kind: 'Equipment', Label: 'Equipment', One: 'Equipment', Plural: 'Equipments', IDField: 'IDEquipment', Certifiable: true, Search: [ 'Name' ], Ph: 'equipment' },
	{ Kind: 'Test', Label: 'Test', One: 'Test', Plural: 'Tests', IDField: 'IDTest', Certifiable: true, Search: [ 'Name' ], Ph: 'tests' },
	{ Kind: 'Product', Label: 'Product', One: 'Product', Plural: 'Products', IDField: 'IDProduct', Certifiable: true, Search: [ 'Name' ], Ph: 'products' },
	{ Kind: 'Organization', Label: 'Organization', One: 'Organization', Plural: 'Organizations', IDField: 'IDOrganization', Certifiable: true, Search: [ 'Name' ], Ph: 'organizations' },
	{ Kind: 'PayItem', Label: 'Pay Item', One: 'PayItem', Plural: 'PayItems', IDField: 'IDPayItem', Certifiable: false, Search: [ 'Name' ], Ph: 'pay items' },
	{ Kind: 'MixDesign', Label: 'Mix Design', One: 'MixDesign', Plural: 'MixDesigns', IDField: 'IDMixDesign', Certifiable: false, Search: [ 'Name' ], Ph: 'mix designs' },
];
const HOLDER_KIND_BY_TYPE = HOLDER_KINDS.reduce((pAcc, pKind) => { pAcc[pKind.Kind] = pKind; return pAcc; }, {});

// Kinds that can be CERTIFIED (holders) and kinds a type can CERTIFY-FOR — the option lists for the two dropdowns.
const HOLDER_CERTIFIABLE_LIST = HOLDER_KINDS.filter((pKind) => pKind.Certifiable).map((pKind) => pKind.Kind);
const APPLIES_TO_KIND_LIST = [ 'Material', 'Lab', 'Test', 'Equipment', 'Product', 'Organization', 'PayItem' ];

// Configuration service: one blob per CertificationType.
const CERT_CONFIG_NAMESPACE = 'CertificationTypeConfig';
const configNamespaceValue = (pIDCertificationType) => `CertificationType-${Number(pIDCertificationType)}`;

const DEFAULT_HOLDER_KINDS = [ 'User' ];
const DEFAULT_APPLIES_KINDS = [ 'Material', 'Lab' ];

/** Built-in defaults for a type that has no saved config yet — lab/plant-flavored types default to certifying Labs. */
function defaultConfigFor(pType)
{
	const tmpText = `${(pType && pType.Name) || ''} ${(pType && pType.Verb) || ''} ${(pType && pType.Hash) || ''}`.toLowerCase();
	const tmpLabbish = /\b(lab|laborator|plant|facility|batch)\b/.test(tmpText);
	return {
		HolderKinds: tmpLabbish ? [ 'Lab' ] : DEFAULT_HOLDER_KINDS.slice(),
		AppliesToKinds: DEFAULT_APPLIES_KINDS.slice(),
		DefaultValidityYears: 0,
	};
}

/** Merge a stored (possibly partial/empty) config over the type's defaults; sanitize the kind lists. */
function normalizeConfig(pRaw, pType)
{
	const tmpDefault = defaultConfigFor(pType);
	const tmpRaw = (pRaw && (typeof pRaw === 'object')) ? pRaw : {};
	const fClean = (pArr, pAllowed, pFallback) =>
	{
		if (!Array.isArray(pArr)) { return pFallback.slice(); }
		const tmpClean = pArr.filter((pKind) => pAllowed.indexOf(pKind) > -1);
		return tmpClean.length ? tmpClean : pFallback.slice();
	};
	const tmpConfigured = !!(pRaw && (Array.isArray(pRaw.HolderKinds) || Array.isArray(pRaw.AppliesToKinds) || (pRaw.DefaultValidityYears != null)));
	return {
		HolderKinds: fClean(tmpRaw.HolderKinds, HOLDER_CERTIFIABLE_LIST, tmpDefault.HolderKinds),
		AppliesToKinds: fClean(tmpRaw.AppliesToKinds, APPLIES_TO_KIND_LIST, tmpDefault.AppliesToKinds),
		DefaultValidityYears: (Number(tmpRaw.DefaultValidityYears) >= 0) ? Number(tmpRaw.DefaultValidityYears) : tmpDefault.DefaultValidityYears,
		Configured: tmpConfigured,
	};
}

// Suggested starter certification types — offered to a customer whose catalog is empty (the #/CertificationTypes
// "get started" panel). Adopting one creates the real CertificationType record and applies the bundled config, so a
// fresh tenant gets a running start instead of a blank list. Curated from the common DOT materials-QA credentials
// (mostly people certified for tests/materials; includes a Lab-held example to show the polymorphism).
const STARTER_TYPES =
[
	{ Name: 'Concrete Field Testing Technician', Verb: 'Test Concrete', Hash: 'CONC-FIELD', Description: 'Field tests on fresh concrete — slump, air content, temperature, and casting cylinders.', HolderKinds: [ 'User' ], AppliesToKinds: [ 'Test', 'Material' ], DefaultValidityYears: 5 },
	{ Name: 'Asphalt Plant & Field Technician', Verb: 'Sample Asphalt', Hash: 'HMA-TECH', Description: 'Sampling and plant/field testing of hot-mix asphalt.', HolderKinds: [ 'User' ], AppliesToKinds: [ 'Material', 'Test' ], DefaultValidityYears: 5 },
	{ Name: 'Nuclear Density Gauge Operator', Verb: 'Operate Gauge', Hash: 'NUC-GAUGE', Description: 'Operate a nuclear moisture/density gauge for in-place density testing.', HolderKinds: [ 'User' ], AppliesToKinds: [ 'Equipment', 'Test' ], DefaultValidityYears: 2 },
	{ Name: 'Aggregate Sampling & Testing', Verb: 'Sample Aggregate', Hash: 'AGG-TECH', Description: 'Sampling and gradation/quality testing of aggregates.', HolderKinds: [ 'User' ], AppliesToKinds: [ 'Material', 'Test' ], DefaultValidityYears: 5 },
	{ Name: 'Soils & Embankment Field Technician', Verb: 'Test Soils', Hash: 'SOIL-TECH', Description: 'Field density, moisture, and Proctor testing of soils and embankment.', HolderKinds: [ 'User' ], AppliesToKinds: [ 'Material', 'Test' ], DefaultValidityYears: 5 },
	{ Name: 'Qualified Testing Laboratory', Verb: 'Qualify Lab', Hash: 'LAB-QUAL', Description: 'A laboratory qualified to perform specified material tests.', HolderKinds: [ 'Lab' ], AppliesToKinds: [ 'Test', 'Material' ], DefaultValidityYears: 3 },
];

module.exports =
{
	HOLDER_KINDS, HOLDER_KIND_BY_TYPE, HOLDER_CERTIFIABLE_LIST, APPLIES_TO_KIND_LIST,
	CERT_CONFIG_NAMESPACE, configNamespaceValue,
	defaultConfigFor, normalizeConfig, STARTER_TYPES,
};

},{}],1055:[function(require,module,exports){

const libPictSectionForm = require('pict-section-form');
const libPictSectionRecordSet = require('pict-section-recordset');
const libPictSectionPicker = require('pict-section-picker');
const libPictSectionAccordion = require('pict-section-accordion');
const libPictDataExplorer = require('pict-dataexplorer');
const libPictSectionDataImport = require('pict-section-dataimport');
const libPictTemplatePreprocessor = require('pict-template-preprocessor');
const libInlineDocumentation = require('pict-section-inlinedocumentation');
// The full-page "Headlight Academy" browser — reuses the inline-doc pipeline above (TOC + AcademyContent docs).
const AcademyProvider = require('./help/Academy-Provider.js');
const AcademyView = require('./help/Academy-View.js');

// pict-section-navigation (published npm module): powers the app's topic navigation,
// the ⌘K launcher, and the KPI jumbotrons. Config lives in source/navigation-graph.js
// (the nav tree) + source/navigation-topics.js (topics + KPIs).
const libPictSectionNavigation = require('pict-section-navigation');
const libNavigationGraph = require('./navigation-graph.js');
const libMasterListCatalog = require('./master-lists/Headlight-MasterLists.js');
const libMasterListBuilder = require('./master-lists/MasterList-Builder.js');
const libMasterListAssociations = require('./master-lists/MasterList-Associations.js');
const libConnectionsGenerated = require('./master-lists/Connections.generated.js');
const libAssociationChipDecoration = require('./master-lists/Association-Chip-Decoration.js');
const libReadViewTabBarDecoration = require('./views/ReadView-TabBar-Decoration.js');
const libUserRoleMembershipFilter = require('./user-role-filter/UserRoleMembershipFilter.js');
// Resolves "whose work is this?" once per session — which inspections the signed-in user reaches, and
// which teams they are on. A LENS, not a permission: see the header of [[InspectionScope-Service.js]].
const libInspectionScopeService = require('./access/InspectionScope-Service.js');
const libTabBar = require('./views/TabBar.js');
const libChildListTab = require('./views/ChildListTab.js');
const libSpecSetMaterialsTab = require('./views/SpecSetMaterialsTab.js');
const libMaterialSpecSetsTab = require('./views/MaterialSpecSetsTab.js');
const libOrganizationAddressTab = require('./views/OrganizationAddressTab.js');
const libMaterialOrgAssociationEditor = require('./views/MaterialOrganizationAssociationEditor.js');
// Platform documentation registry: route → AcademyContent doc, across every feature area. Docs are managed in
// AcademyContent (seeded via source/help/PlatformDocs-Seed.js) and surfaced in the F1 / `?` panel via the
// displayContent bridge; cross-tenant reads go through the API's PlatformDocument endpoint.
const libPlatformDocs = require('./help/PlatformDocs.js');
// The segmented CodeMirror markdown editor (same component the inline-doc module wraps and the Email Notifications
// editor reuses) — powers in-panel editing of platform docs. CodeMirror bundle is already vendored + loaded app-wide.
const libPlatformDocMarkdownEditor = require('pict-section-markdowneditor');
const libPlatformRecordCards = require('./record-cards/Platform-RecordCards.js');

// the user's chosen navigation style is persisted
// here. 'Sidebar' (a persistent docked rail) is the default; 'Hub' / 'List' / 'Palette'
// render the navigation as the Configurations home screen instead.
const NAV_STYLE_STORAGE_KEY = 'headlight-platform-config-nav-render-type';
const NAV_STYLE_DEFAULT = 'List';

// Scoped styles for the platform-documentation help panel's topic nav bar (shipped inline with the injected
// content so it needs no global CSS). Theme-aware via the shared --theme-color-* vars; active topic reads as a chip.
const PLATFORM_HELP_STYLE =
	'<style>'
	+ '.platform-help-nav { display:flex; flex-wrap:wrap; gap:0.35rem; padding:0 0 0.7rem; margin:0 0 0.8rem; border-bottom:1px solid var(--theme-color-border-light, #f0f2f6); }'
	// The pill color rules are scoped under `.platform-help-nav` on purpose: the panel body carries the
	// `.pict-content` class, whose `.pict-content a { color: brand-primary }` (specificity 0,1,1) would
	// otherwise beat a bare `.platform-help-navlink-active` (0,1,0) and paint the ACTIVE pill's text the brand
	// blue over its blue background — unreadable. The two-class scope (0,2,0) outranks it. Keep the scope.
	+ '.platform-help-nav .platform-help-navlink { font-size:0.78rem; font-weight:600; line-height:1; padding:0.32rem 0.6rem; border-radius:999px; text-decoration:none;'
	+ ' color:var(--theme-color-text-muted, #6b7686); background:var(--theme-color-background-subtle, #f4f6fa); border:1px solid var(--theme-color-border-light, #e6eaf1); }'
	+ '.platform-help-nav .platform-help-navlink:hover { color:var(--theme-color-text, #22303f); background:var(--theme-color-background-hover, #e9eef5); }'
	+ '.platform-help-nav .platform-help-navlink-active { color:#ffffff; background:var(--theme-color-primary, #2f6fed); border-color:var(--theme-color-primary, #2f6fed); }'
	+ '.platform-help-loading { color:var(--theme-color-text-muted, #8894a4); font-style:italic; }'
	// Edit affordances (shown only to editors): the pencil in read mode + the editor toolbar/buttons in edit mode.
	+ '.platform-help-editbar { display:flex; align-items:center; gap:0.5rem; margin:0 0 0.7rem; }'
	+ '.platform-help-editbar-spacer { flex:1 1 auto; }'
	+ '.platform-help-editbtn { font-size:0.76rem; font-weight:600; padding:0.28rem 0.6rem; border-radius:6px; cursor:pointer;'
	+ ' color:var(--theme-color-text-muted, #6b7686); background:var(--theme-color-background-subtle, #f4f6fa); border:1px solid var(--theme-color-border-light, #e6eaf1); }'
	+ '.platform-help-editbtn:hover { color:var(--theme-color-text, #22303f); background:var(--theme-color-background-hover, #e9eef5); }'
	+ '.platform-help-editmode { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; padding:0.2rem 0.5rem; border-radius:999px; }'
	+ '.platform-help-editmode-canonical { color:#ffffff; background:var(--theme-color-status-warning, #b8860b); }'
	+ '.platform-help-editmode-override { color:#ffffff; background:var(--theme-color-primary, #2f6fed); }'
	+ '.platform-help-editmount { min-height:16rem; border:1px solid var(--theme-color-border-light, #e6eaf1); border-radius:8px; }'
	+ '.platform-help-input { flex:1 1 auto; font:inherit; font-size:0.9rem; padding:0.4rem 0.55rem; border-radius:6px;'
	+ ' border:1px solid var(--theme-color-border-medium, #d5dbe3); background:var(--theme-color-background-primary, #fff); color:var(--theme-color-text-primary, #1f2733); }'
	+ '.platform-help-editnote { font-size:0.8rem; color:var(--theme-color-text-muted, #6b7686); margin:0 0 0.6rem; }'
	+ '.platform-help-btn { font-size:0.82rem; font-weight:600; padding:0.4rem 0.85rem; border-radius:6px; cursor:pointer; border:1px solid transparent; }'
	+ '.platform-help-btn-primary { color:#ffffff; background:var(--theme-color-primary, #2f6fed); }'
	+ '.platform-help-btn-ghost { color:var(--theme-color-text, #22303f); background:transparent; border-color:var(--theme-color-border-medium, #d5dbe3); }'
	+ '.platform-help-btn-danger { color:var(--theme-color-status-danger, #c0392b); background:transparent; border-color:var(--theme-color-status-danger, #c0392b); }'
	+ '.platform-help-btn[disabled] { opacity:0.55; cursor:default; }'
	+ '</style>';
const libHeadlightConfigurableApplication = require('headlight-configurable-application');

// First-draft per-record-set foreign-key → entity mappings for the PSRS entity-Picker feature. Clean
// `ID<Entity>` columns (IDOrganization, IDContract, IDRole, …) resolve automatically by convention; this
// map declares the exceptions the convention can't infer — prefixed / suffixed / self-referential columns.
// Applied to DefaultRecordSetConfigurations below as RecordSetConfiguration.ForeignKeyEntities.
const PSRS_FOREIGN_KEY_ENTITIES =
{
	RoleEdge:         { ParentIDRole: 'Role', ChildIDRole: 'Role' },
	Material:         { IDMaterialParent: 'Material' },
	Lab:              { IDLabParent: 'Lab' },
	Sample:           { ParentIDSample: 'Sample', SampledByIDUser: 'User', WitnessIDUser: 'User', AuthorizedIDUser: 'User', CMSIDUser: 'User' },
	Role:             { LinkedIDUser: 'User' },
	MixSpecification: { ApprovingIDUser: 'User' },
	Contract:         { ItemIDTestSpecificationSet: 'TestSpecificationSet', MaterialIDTestSpecificationSet: 'TestSpecificationSet' },
	// Line/bid items live under a Contract + Project — surface both as named columns AND first-class
	// entity-picker filters (an ID<Entity> column resolves to the referenced entity for display, and its
	// filter becomes the entity picker rather than a raw numeric match). LineItem also references its BidItem.
	LineItem:         { IDContract: 'Contract', IDProject: 'Project', IDBidItem: 'BidItem', IDPayItem: 'PayItem', IDFundingCategory: 'FundingCategory' },
	BidItem:          { IDContract: 'Contract', IDProject: 'Project', IDPayItem: 'PayItem', IDOrganization: 'Organization' },
};

// Per-record-set field-label overrides (RecordSetConfiguration.FieldLabels): the IDOrganization on a
// Contract / Project is the prime contractor.
const PSRS_FIELD_LABELS =
{
	Contract: { IDOrganization: 'Prime Contractor' },
	Project:  { IDOrganization: 'Prime Contractor' },
};
const HeadlightDynamicInputsBundle = require('headlight-dynamic-inputs-bundle');

const libPlatformConfigurationRouter = require('./providers/PlatformConfiguration-Router.js');

// PSRS filter data/persistence management
const libFilterDataProvider = require('pict-section-recordset/source/providers/Filter-Data-Provider.js');
const libFilterPersistenceView = require('pict-section-recordset/source/views/Filter-PersistenceView.js');

// PSRS dynamic recordset solver (required for manifest-based list rendering)
const libDynamicRecordsetSolver = require('pict-section-recordset/source/providers/RecordSet-DynamicRecordsetSolver.js');

// Views
const configEmptyView = require('./views/Empty.json');
const ConfigurationIndex = require('./views/ConfigurationIndex.js');
// Configurations home + per-topic dashboard pages.
const ConfigurationNavigation = require('./views/ConfigurationNavigation.js');
const TopicPage = require('./views/TopicPage.js');
const DataExplorer = require('./views/DataExplorer.js');
const SamplePlanProvider = require('./sample-plan/SamplePlan-Provider.js');
const SamplePlan = require('./views/SamplePlan.js');
const SamplePlanDashboardProvider = require('./sample-plan/SamplePlanDashboard-Provider.js');
const SamplePlanDashboard = require('./views/SamplePlanDashboard.js');
const SamplePlanCopy = require('./sample-plan/SamplePlanCopy-View.js');
const ObservationListProvider = require('./observations/ObservationList-Provider.js');
const ObservationListView = require('./views/ObservationList.js');
const DocumentListProvider = require('./documents/DocumentList-Provider.js');
const DocumentFrameSwitcherProvider = require('./documents/DocumentFrameSwitcher-Provider.js');
const DocumentListView = require('./views/DocumentList.js');
const InspectionScheduleProvider = require('./inspections/InspectionSchedule-Provider.js');
const InspectionScheduleView = require('./views/InspectionSchedule.js');
const DocumentThroughputProvider = require('./documents/DocumentThroughput-Provider.js');
const DocumentThroughputView = require('./views/DocumentThroughput.js');
// Customer Support console (#/Support): support calls are Support-Call Documents under a revolving monthly Support
// Project, worked through the SupportCallWorkflow, with screenshot/file attachments as Observations. See [[Support-Provider.js]].
const SupportProvider = require('./support/Support-Provider.js');
const SupportView = require('./views/Support.js');
// The merge-tickets wizard (fold duplicate/misfiled Support-Call tickets into a parent). See [[Support-Merge-Provider.js]].
const SupportMergeProvider = require('./support/Support-Merge-Provider.js');
// Customer-facing read-only open-cases dashboard (#/SupportPortal) for the Support-View tier. See [[SupportPortal-Provider.js]].
const SupportPortalProvider = require('./support/SupportPortal-Provider.js');
const SupportPortalView = require('./views/SupportPortal.js');
// Form Concierge (#/FormConcierge): super-user screen that drives the plansheet form pipeline through the same-origin
// façade (endpoints/FormConcierge-Service.js). See [[FormConcierge-Provider.js]].
const FormConciergeProvider = require('./form-concierge/FormConcierge-Provider.js');
const FormConciergeView = require('./views/FormConcierge.js');
// Asset-type metadata descriptors: the vocabulary every asset screen renders through, so the tooling
// is driven by the asset type rather than compiled against one standard. See [[AssetDescriptor.js]].
const libAssetDescriptorProvider = require('./assets/AssetDescriptor-Provider.js');
const PhysicalAssetDashboardProvider = require('./assets/PhysicalAssetDashboard-Provider.js');
const PhysicalAssetDashboardView = require('./views/PhysicalAssetDashboard.js');
const libImportantFilesProvider = require('./important-files/ImportantFiles-Provider.js');
const libImportantFiles = require('./views/ImportantFiles.js');
const libBulkUploadProvider = require('./providers/BulkUpload-Provider.js');
const libBulkUpload = require('./views/BulkUpload.js');
const libProjectFundingProvider = require('./project-funding/ProjectFunding-Provider.js');
const libProjectFunding = require('./views/ProjectFunding.js');
const libChangeOrdersProvider = require('./providers/ChangeOrders-Provider.js');
const libChangeOrders = require('./views/ChangeOrders.js');
const libPictSectionFormHost = require('pict-section-form-host');
// LIMS Samples — the configuration-based Sample screens rebuilt from web/lims. The create/edit/view forms are
// rendered from the customer's configured ManifestSchema via the shared manifest-packaging-service, and persisted
// through the shared web/providers/* LIMS providers (same save pipeline the LIMS app uses: QR minting, storage-
// location join, sample-log). See memory config-app-lims-samples. These shared providers extend pict-provider and
// the config-app bundler resolves ../../providers/* exactly as the base class resolves web/providers/Session-Provider.
const libManifestPackagingService = require('manifest-packaging-service');
// Reusable per-customer "custom metadata" form: renders an entity's CustomProperties blob via a ManifestSchema-
// driven pict-section-form (read-only/edit theme swap) with an entitlement-gated raw-JSON advanced toggle. See
// memory config-app-entity-metadata.
const libEntityMetadataFormProvider = require('./entity-metadata/EntityMetadataForm-Provider.js');
const libUtilityProvider = require('../../providers/UtilityProvider.js');
const libLocationProvider = require('../../providers/LocationProvider.js');
const libSampleProvider = require('../../providers/SampleProvider.js');
const libSampleLogProvider = require('../../providers/SampleLogProvider.js');
const libLineItemProvider = require('../../providers/LineItemProvider.js');
const libTestInstanceProvider = require('../../providers/TestInstanceProvider.js');
const libHeadlightSamples = require('@paviasystems/headlight-samples');
const libDocumentProvider = require('../../providers/DocumentProvider.js');
const libGeoProvider = require('../../providers/GeoProvider.js');
const libQRCodeProvider = require('../../providers/QRCodeProvider.js');
const libScanToOpenProvider = require('./providers/ScanToOpen-Provider.js');
const libRecordExtensionProvider = require('../../providers/RecordExtension-Provider.js');
const libFormInitialBundleProvider = require('../../providers/FormInitialBundle-Provider.js');
// SampleWorkspace is now a config-driven pict-section-workspace (registered via workspace-configs); its provider
// subclass is required by Sample.config.js. SampleFormHost (its manifest form runner, below) stays here.
// The Headlight Workspaces framework (pict-section-workspace) + the config-driven workspaces registered on it.
const libWorkspaceConfigs = require('./workspace-configs');
const DatalakeCatalog = require('./views/DatalakeCatalog.js');
const libDatalakeCatalogProvider = require('./providers/DatalakeCatalog-Provider.js');
const libDataDownloader = require('./views/DataDownloader.js');
const libDataDownloaderProvider = require('./providers/DataDownloader-Provider.js');
const DatalakeDataset = require('./views/DatalakeDataset.js');
const libDatalakeDatasetProvider = require('./providers/DatalakeDataset-Provider.js');
const DatalakeProjectionEditor = require('./views/DatalakeProjectionEditor.js');
const libDatalakeProjectionEditorProvider = require('./providers/DatalakeProjection-Editor-Provider.js');
const libNavigationTopics = require('./navigation-topics.js');
const libModuleAccess = require('./access/Module-Access.js');
const CustomerProvisioning = require('./views/CustomerProvisioning.js');
const ProjectClone = require('./views/ProjectClone.js');

// Providers
const libContractAdminProvisioningProvider = require('./providers/ContractAdminProvisioning-Provider.js');
const libCustomerProvisioningProvider = require('./providers/CustomerProvisioning-Provider.js');
const libProjectCloneProvider = require('./providers/ProjectClone-Provider.js');
const libMasterListRegistryProvider = require('./providers/MasterList-Registry-Provider.js');
const libCustomerRecordManifestsProvider = require('./providers/CustomerRecordManifests-Provider.js');
const libMasterListManager = require('./views/MasterListManager.js');
const libObservationTypeEditorProvider = require('./providers/ObservationType-Editor-Provider.js');
const libObservationTypeEditor = require('./views/ObservationTypeEditor.js');
const libArtifactTypeEditorProvider = require('./providers/ArtifactType-Editor-Provider.js');
const libArtifactTypeEditor = require('./views/ArtifactTypeEditor.js');
// ProjectWorkspace is now a config-driven pict-section-workspace (registered via workspace-configs); its provider
// subclass is required by Project.config.js.
const libProjectBulkDeleteProvider = require('./providers/ProjectBulkDelete-Provider.js');
const libProjectEditWorkspaceProvider = require('./providers/ProjectEditWorkspace-Provider.js');
const libProjectEditWorkspace = require('./views/ProjectEditWorkspace.js');
const libProjectCreateWorkspaceProvider = require('./providers/ProjectCreateWorkspace-Provider.js');
const libProjectCreateWorkspace = require('./views/ProjectCreateWorkspace.js');
// Approval-workflow visual editor (pict-section-flow graph over the 'ApprovalWorkflow' Configuration blob;
// replaces Home's editor). The provider is the data layer; the two views are the list + graph editor.
const libApprovalWorkflowProvider = require('./providers/ApprovalWorkflow-Provider.js');
const libApprovalWorkflowList = require('./views/ApprovalWorkflowList.js');
const libApprovalWorkflowEditor = require('./views/ApprovalWorkflowEditor.js');
const libApprovalWorkflowBindings = require('./views/ApprovalWorkflowBindings.js');
// Email Notifications (Email Rules) — migrated from Home's EmailRules.vue.
const libEmailNotificationsProvider = require('./providers/EmailNotifications-Provider.js');
const libEmailNotificationsList = require('./views/EmailNotifications-List.js');
const libEmailNotificationsEditor = require('./views/EmailNotifications-Editor.js');
const libConfigViewerProvider = require('./providers/ConfigViewer-Provider.js');
const libConfigViewer = require('./views/ConfigViewer.js');
const libDocumentationProvider = require('./providers/Documentation-Provider.js');
const libDocumentation = require('./views/Documentation.js');
const libEntitlementsProvider = require('./providers/Entitlements-Provider.js');
const libEntitlements = require('./views/Entitlements.js');
const libCertificationsProvider = require('./providers/Certifications-Provider.js');
const libCertifications = require('./views/Certifications.js');
const libATMDashboardConfigProvider = require('./providers/ATMDashboardConfig-Provider.js');
const libATMDashboardConfig = require('./views/ATMDashboardConfig.js');
const libAssetTypeDescriptorProvider = require('./providers/AssetTypeDescriptor-Provider.js');
const libAssetTypeDescriptor = require('./views/AssetTypeDescriptor.js');
const libSampleListColumnsConfigProvider = require('./providers/SampleListColumnsConfig-Provider.js');
const libSampleListColumnsConfig = require('./views/SampleListColumnsConfig.js');
const libSampleQRCodeConfigProvider = require('./providers/SampleQRCodeConfig-Provider.js');
const libSampleQRCodeConfig = require('./views/SampleQRCodeConfig.js');
const libPrinterCodes = require('./views/PrinterCodes.js');
const libScanSamplesPage = require('./views/ScanSamplesPage.js');
const libEntityDestinationsConfigProvider = require('./providers/EntityDestinationsConfig-Provider.js');
const libHeadlightDashboards = require('headlight-dashboards');
const libDashboardAccessConfigProvider = require('./providers/DashboardAccessConfig-Provider.js');
const libDashboardAccessConfig = require('./views/DashboardAccessConfig.js');
const libEntityDestinationsConfig = require('./views/EntityDestinationsConfig.js');
const libConfigScreens = require('./config-screens/Config-Screens.js');
const libCertificationTypesProvider = require('./providers/CertificationTypes-Provider.js');
const libCertificationTypes = require('./views/CertificationTypes.js');
const libAssetCatalogSyncProvider = require('./providers/AssetCatalogSync-Provider.js');
const libAssetCatalogSync = require('./views/AssetCatalogSync.js');
// AssetWorkspace is now a config-driven pict-section-workspace (registered via workspace-configs); its provider
// subclass is required by Asset.config.js. The AssetLocationMap ProjectCenterMap instance (below) still binds to it.
const libProjectContractTypesProvider = require('./providers/ProjectContractTypes-Provider.js');
const libProjectTypes = require('./views/ProjectTypes.js');
const libContractTypes = require('./views/ContractTypes.js');
const libRecordDatesProvider = require('./providers/RecordDates-Provider.js');
const libRecordDates = require('./views/RecordDates.js');
const libProjectStaffingProvider = require('./providers/ProjectStaffing-Provider.js');
const libSuperUserGrantProvider = require('./providers/SuperUserGrant-Provider.js');
const libSuperUserGrant = require('./views/SuperUserGrant.js');
// Internals (ported from the standalone web/internals app): Headlight-only service/application version screens.
const libInternalsServiceCatalog = require('./internals/Internals-ServiceCatalog.js');
const libInternalsServiceVersions = require('./internals/Internals-ServiceVersions.js');
const libInternalsServiceVersionsMultiEnv = require('./internals/Internals-ServiceVersionsMultiEnv.js');
const libManageCustomersProvider = require('./providers/ManageCustomers-Provider.js');
const libManageCustomers = require('./views/ManageCustomers.js');
const libCustomersListProvider = require('./providers/CustomersList-Provider.js');
const libCustomers = require('./views/Customers.js');
const libActivityObservabilityProvider = require('./providers/ActivityObservability-Provider.js');
const libUserActivity = require('./views/UserActivity.js');
const libUserLoginOverview = require('./views/UserLoginOverview.js');
const libProjectActivity = require('./views/ProjectActivity.js');
const libConfigCloneProvider = require('./providers/ConfigClone-Provider.js');
const libConfigClone = require('./views/ConfigClone.js');
const libRoleCloneProvider = require('./providers/RoleClone-Provider.js');
const libRoleClone = require('./views/RoleClone.js');
const libAccessWorkspaceProvider = require('./providers/AccessWorkspace-Provider.js');
const libAccessWorkspace = require('./views/AccessWorkspace.js');
const libPermissionMatrixProvider = require('./providers/PermissionMatrix-Provider.js');
const libPermissionVisualizerProvider = require('./providers/PermissionVisualizer-Provider.js');
const libEffectivePermissionsService = require('./services/Effective-Permissions-Service.js');
const libGroupCompositionProvider = require('./providers/GroupComposition-Provider.js');
const libUserGroupGrantsProvider = require('./providers/UserGroupGrants-Provider.js');
const libRoleAssignmentProvider = require('./providers/RoleAssignment-Provider.js');
const libDataMapper = require('./views/DataMapper.js');
const libDataImportProvider = require('./providers/DataImport-Provider.js');
const libDataImport = require('./views/DataImport.js');
const libContractPackageImportProvider = require('./providers/ContractPackageImport-Provider.js');
const libContractPackageImport = require('./views/ContractPackageImport.js');
const libProjectCenterMap = require('./views/ProjectCenterMap.js');
const libObservationLocationMap = require('./views/ObservationLocationMap.js');
// ContractWorkspace is now a config-driven pict-section-workspace (registered via workspace-configs); its
// provider subclass is required by Contract.config.js. LineItemBidItemMap (the project-scoped Bid Item Mapping
// tab body, embedded by the Project workspace's Bid Item Mapping tab) stays registered here.
const libLineItemBidItemMapProvider = require('./providers/LineItemBidItemMap-Provider.js');
const libProjectContractorMatrixProvider = require('./providers/ProjectContractorMatrix-Provider.js');
// UserWorkspace is now a config-driven pict-section-workspace (registered via workspace-configs); its provider
// subclass is required by User.config.js.
const libUserCreateWorkspaceProvider = require('./providers/UserCreateWorkspace-Provider.js');
const libUserCreateWorkspace = require('./views/UserCreateWorkspace.js');
const libContractCreateWorkspaceProvider = require('./providers/ContractCreateWorkspace-Provider.js');
const libContractCreateWorkspace = require('./views/ContractCreateWorkspace.js');
// Inspection CREATE. Creating an inspection means creating its asset join, its project scope and its document
// packet too — BridgeDocumentManager.createInspection() does all of that, and that service is already live
// app-wide (the HeadlightPanels view instantiates it). This screen is the form over that call.
const libInspectionCreateWorkspaceProvider = require('./providers/InspectionCreateWorkspace-Provider.js');
const libInspectionCreateWorkspace = require('./views/InspectionCreateWorkspace.js');
const libErrorLogViewerProvider = require('./providers/ErrorLogViewer-Provider.js');
const libErrorLogViewer = require('./views/ErrorLogViewer.js');
const libMyHeadlightProvider = require('./providers/MyHeadlight-Provider.js');
const libMyHeadlight = require('./views/MyHeadlight.js');
const libReportProjectAssignment = require('headlight-report-project-assignment');
const libContractProjectTypesImportProvider = require('./providers/ContractProjectTypesImportProvider.js');
const libContractProjectTypesSettingsAdapter = require('./providers/ContractProjectTypesSettingsAdapter.js');
const libRecordPhotoUploadAfterSave = require('./providers/RecordPhotoUploadAfterSave.js');
const libProjectTypeComprehensionBuilder = require('./providers/ProjectTypeComprehensionBuilder.js');
const libTypeComprehensionSaveProvider = require('./providers/TypeComprehensionSaveProvider.js');
const libTypeComprehensionReadProvider = require('./providers/TypeComprehensionReadProvider.js');

// Default Manifests — List views
const manifestUserList = require('./default_manifests/User-List.json');
const manifestCustomerList = require('./default_manifests/Customer-List.json');
const manifestOrganizationList = require('./default_manifests/Organization-List.json');
const manifestProjectList = require('./default_manifests/Project-List.json');
const manifestContractList = require('./default_manifests/Contract-List.json');
const manifestRoleList = require('./default_manifests/Role-List.json');
const manifestObservationManifestList = require('./default_manifests/ObservationManifest-List.json');
const manifestArtifactTypeList = require('./default_manifests/ArtifactType-List.json');
const manifestReportNamedInstanceList = require('./default_manifests/ReportNamedInstance-List.json');
const manifestObservationTagList = require('./default_manifests/ObservationTag-List.json');
const manifestUserRoleJoinList = require('./default_manifests/UserRoleJoin-List.json');
const manifestRoleEdgeList = require('./default_manifests/RoleEdge-List.json');
const manifestRolePermissionList = require('./default_manifests/RolePermission-List.json');
const manifestProjectTagTypeList = require('./default_manifests/ProjectTagType-List.json');
const manifestDocumentApprovalWorkflowList = require('./default_manifests/DocumentApprovalWorkflow-List.json');
const manifestDocumentApprovalStateList = require('./default_manifests/DocumentApprovalState-List.json');
const manifestDocumentApprovalStepList = require('./default_manifests/DocumentApprovalStep-List.json');
const manifestObservationApprovalWorkflowList = require('./default_manifests/ObservationApprovalWorkflow-List.json');
const manifestObservationApprovalStateList = require('./default_manifests/ObservationApprovalState-List.json');
const manifestObservationApprovalStepList = require('./default_manifests/ObservationApprovalStep-List.json');
const manifestContractTypeList = require('./default_manifests/ContractType-List.json');
const manifestProjectTypeList = require('./default_manifests/ProjectType-List.json');

// Default Manifests — View (read) manifests
const manifestUserView = require('./default_manifests/User-View.json');
const manifestCustomerView = require('./default_manifests/Customer-View.json');
const manifestOrganizationView = require('./default_manifests/Organization-View.json');
const manifestProjectView = require('./default_manifests/Project-View.json');
const manifestRoleView = require('./default_manifests/Role-View.json');
const manifestObservationManifestView = require('./default_manifests/ObservationManifest-View.json');
const manifestArtifactTypeView = require('./default_manifests/ArtifactType-View.json');
const manifestReportNamedInstanceView = require('./default_manifests/ReportNamedInstance-View.json');
const manifestObservationTagView = require('./default_manifests/ObservationTag-View.json');
const manifestUserRoleJoinView = require('./default_manifests/UserRoleJoin-View.json');
const manifestRoleEdgeView = require('./default_manifests/RoleEdge-View.json');
const manifestRolePermissionView = require('./default_manifests/RolePermission-View.json');
const manifestProjectTagTypeView = require('./default_manifests/ProjectTagType-View.json');
const manifestDocumentApprovalWorkflowView = require('./default_manifests/DocumentApprovalWorkflow-View.json');
const manifestDocumentApprovalStateView = require('./default_manifests/DocumentApprovalState-View.json');
const manifestDocumentApprovalStepView = require('./default_manifests/DocumentApprovalStep-View.json');
const manifestObservationApprovalWorkflowView = require('./default_manifests/ObservationApprovalWorkflow-View.json');
const manifestObservationApprovalStateView = require('./default_manifests/ObservationApprovalState-View.json');
const manifestObservationApprovalStepView = require('./default_manifests/ObservationApprovalStep-View.json');
const manifestContractTypeView = require('./default_manifests/ContractType-View.json');
const manifestProjectTypeView = require('./default_manifests/ProjectType-View.json');

// Default Manifests — Edit manifests
const manifestUserEdit = require('./default_manifests/User-Edit.json');
const manifestCustomerEdit = require('./default_manifests/Customer-Edit.json');
const manifestOrganizationEdit = require('./default_manifests/Organization-Edit.json');
const manifestOrganizationCreate = require('./default_manifests/Organization-Create.json');
// Generated View/Edit/Create manifests for the catalog master-list entities (see build-catalog-manifests.js) —
// registered into Manifests + wired onto their recordset configs below so their forms are sectioned/curated
// instead of raw-schema. Keyed for that wiring.
const libCatalogManifests = require('./default_manifests/catalog-manifest-index.js');
const CATALOG_MANIFEST_ENTITIES = new Map(libCatalogManifests.ENTITIES.map((pEntry) => [ pEntry.Entity, pEntry ]));
const manifestProjectEdit = require('./default_manifests/Project-Edit.json');
const manifestRoleEdit = require('./default_manifests/Role-Edit.json');
const manifestObservationManifestEdit = require('./default_manifests/ObservationManifest-Edit.json');
const manifestArtifactTypeEdit = require('./default_manifests/ArtifactType-Edit.json');
const manifestReportNamedInstanceEdit = require('./default_manifests/ReportNamedInstance-Edit.json');
// Cross-app reuse: the forms app's RNI metadata editor (Name/Hash/archetype/flags + the Options JSON
// pict-section-code editor, gated by the ReportNamedInstance-EditJSON entitlement). Registered below and
// wired as the ReportNamedInstance record set's custom View/Edit/Create screen via RecordSetCustomViews.
const libReportNamedInstanceMetadataEditor = require('../../headlight-form-editor/source/views/ReportNamedInstance-Create.js');
const manifestObservationTagEdit = require('./default_manifests/ObservationTag-Edit.json');
const manifestUserRoleJoinEdit = require('./default_manifests/UserRoleJoin-Edit.json');
const manifestRoleEdgeEdit = require('./default_manifests/RoleEdge-Edit.json');
const manifestRolePermissionEdit = require('./default_manifests/RolePermission-Edit.json');
const manifestProjectTagTypeEdit = require('./default_manifests/ProjectTagType-Edit.json');
const manifestDocumentApprovalWorkflowEdit = require('./default_manifests/DocumentApprovalWorkflow-Edit.json');
const manifestDocumentApprovalStateEdit = require('./default_manifests/DocumentApprovalState-Edit.json');
const manifestDocumentApprovalStepEdit = require('./default_manifests/DocumentApprovalStep-Edit.json');
const manifestObservationApprovalWorkflowEdit = require('./default_manifests/ObservationApprovalWorkflow-Edit.json');
const manifestObservationApprovalStateEdit = require('./default_manifests/ObservationApprovalState-Edit.json');
const manifestObservationApprovalStepEdit = require('./default_manifests/ObservationApprovalStep-Edit.json');
const manifestContractTypeEdit = require('./default_manifests/ContractType-Edit.json');
const manifestProjectTypeEdit = require('./default_manifests/ProjectType-Edit.json');

// Dashboard views and providers
// Shared dashboard chart/data provider (used by the Activity Observability views). The Analytics dashboard
// views that also used it were retired.
const PlatformDashboardDataProvider = require('./views/dashboards/PlatformDashboard-DataProvider.js');

/** @typedef {import('fable')} Fable */

const customLoginPageOptions = {
	title: 'HeadLight Platform Configuration',
	titleStyles: `
		z-index: 1;
		text-shadow:  5px 9px 2px var(--bulma-black);
		word-wrap: break-word;
		overflow-wrap: break-word;
		text-align: center;
		font-size: 4rem !important;
		margin: 0 0 5vh 0;`,
	wallpaperStyles: `
		background-image: url('../../images/headlight-config-bg.jpg');
		background-size: cover;
		background-repeat: no-repeat;
		background-color: var(--bulma-grey);
		background-blend-mode: multiply;`,
	closePanelsOnLogout: true,
};

class PlatformConfiguration extends libHeadlightConfigurableApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		// A keyboard scanner opens Sample Details here (the panels' scan handler); form apps leave it off.
		this.pict.providers.HeadlightQR.enableWedge();
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;

		// Expose the pict instance as the conventional `window.pict` global. This headlight
		// bootstrap only sets `window._Pict`, but pict-section-modal resolves its panel
		// chrome icons (the resize/collapse-tab chevrons) via `window.pict.icon(...)`, so
		// without this the help panel's collapse tab renders without its chevron glyph.
		if (typeof window !== 'undefined' && !window.pict)
		{
			window.pict = this.pict;
		}

		// Font Awesome passthrough for pict.icon(). The navigation graph, the topic jumbotrons, and the
		// ConfigurationNavigation topic buttons author icons as Font Awesome classes (e.g. 'fas fa-city'),
		// but pict's Icon provider is an SVG registry keyed by PascalCase names — so an FA class misses and
		// every surface that renders through pict.icon() (the ⌘K launcher Palette, the Hub category pages,
		// the Sidebar, the List) shows the registry's "?" fallback. Font Awesome is loaded by html/index.html,
		// so emit an <i class="fa…"> for FA-class names and defer to the original SVG lookup for the provider's
		// own PascalCase names (Search, Menu, ChevronDown, …).
		const tmpIconProvider = this.pict.providers.Icon;
		if (tmpIconProvider && (typeof tmpIconProvider.get === 'function') && !tmpIconProvider._FontAwesomePassthrough)
		{
			tmpIconProvider._FontAwesomePassthrough = true;
			const tmpRegistryGet = tmpIconProvider.get.bind(tmpIconProvider);
			tmpIconProvider.get = (pName, pOpts) =>
			{
				if ((typeof pName === 'string') && (pName.indexOf('fa-') > -1))
				{
					const tmpOpts = pOpts || {};
					let tmpClass = 'pict-icon';
					if ((typeof tmpOpts.class === 'string') && (tmpOpts.class.length > 0)) { tmpClass += ' ' + tmpOpts.class; }
					let tmpStyle = '';
					if ((typeof tmpOpts.size === 'number') && (tmpOpts.size > 0)) { tmpStyle = ` style=\"font-size:${tmpOpts.size}px\"`; }
					else if ((typeof tmpOpts.size === 'string') && (tmpOpts.size.length > 0)) { tmpStyle = ` style=\"font-size:${tmpOpts.size}\"`; }
					let tmpAria = ' aria-hidden=\"true\"';
					if ((typeof tmpOpts.ariaLabel === 'string') && (tmpOpts.ariaLabel.length > 0)) { tmpAria = ` role=\"img\" aria-label=\"${tmpOpts.ariaLabel.replace(/\"/g, '&quot;')}\"`; }
					return `<span class=\"${tmpClass}\"${tmpStyle}${tmpAria}><i class=\"${pName.replace(/\"/g, '&quot;')}\"></i></span>`;
				}
				return tmpRegistryGet(pName, pOpts);
			};
		}

		// Prevent the router from resolving the current URL as each route is
		// registered. The router would otherwise resolve '/' (the first route
		// added) and render the default Dashboard view before the route the user
		// deep-linked to has been registered. A single explicit resolve happens
		// in onAfterLoginAsync once every route — including the PSRS routes — is
		// registered. (Also set on the PictRouter provider config in the router.)
		this.pict.settings.RouterSkipRouteResolveOnAdd = true;

		// Template preprocessor — register + instantiate first so its render-speedup wrappers install
		// automatically before the form/recordset services build their templates (mirrors the LIMS app).
		this.pict.addServiceType('PictTemplatePreprocessor', libPictTemplatePreprocessor);
		this.pict.instantiateServiceProvider('PictTemplatePreprocessor');

		// Add the pict form and recordset services
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);
		this.pict.addServiceType('PictSectionRecordSet', libPictSectionRecordSet);

		// Document render service — renders a Document on the server and opens the same-origin HTML form viewer/editor
		// (Report/{GUID}/index.html — editable when the document isn't Locked). Used by the Documents list. Never Fieldbook.
		this.pict.addServiceType('HeadlightDocumentRender', require('../../../lib/service/web-headlight-document-render/Web-Headlight-Document-Render.js'));
		this.pict.instantiateServiceProviderIfNotExists('HeadlightDocumentRender');

		// Observation render service — schema-driven observation → HTML in many formats (full / card / strip / tooltip /
		// thumbnail / marker), intelligent about built-in AND custom schemas. The one place observations become HTML;
		// consumed by the Observation workspace, the Explorer map/list, the dashboards' geo popups, and card decks.
		this.pict.addServiceType('HeadlightObservationRender', require('../../../lib/service/web-headlight-observation-render/Web-Headlight-Observation-Render.js'));
		this.pict.instantiateServiceProviderIfNotExists('HeadlightObservationRender');

		this.dynamicInputsBundle = new HeadlightDynamicInputsBundle(this.pict);
		this.dynamicInputsBundle.attachProviders();
		this.dynamicInputsBundle.attachInstructions();
		// The Leaflet view the GeolocationSelectorWithMap input renders its map with (e.g. the Location map picker).
		// Registered with its own configuration, which carries the 'GeolocationSelector' renderable the input
		// renders; it renders only when a map field mounts, never at load. A field with no coordinates yet opens on
		// the continental US (the input's own no-fix default) rather than Leaflet's default of Honolulu.
		const libGeolocationSelectorView = HeadlightDynamicInputsBundle.getViewMap().GeolocationSelector;
		this.pict.addView('GeolocationSelector', Object.assign({}, libGeolocationSelectorView.default_configuration,
			{ RenderOnLoad: false, LeafletInitialCenter: [ 39.5, -98.35 ], LeafletInitialZoom: 4 }), libGeolocationSelectorView);

		// PSRS filter data/persistence management (required by ComplexFilterProvider)
		this.pict.addProvider('FilterDataProvider', libFilterDataProvider.default_configuration, libFilterDataProvider);
		this.pict.addView('FilterPersistenceView', libFilterPersistenceView.default_configuration, libFilterPersistenceView);

		// PSRS dynamic recordset solver (required for manifest-based list/dashboard rendering)
		this.pict.addProviderSingleton('DynamicRecordsetSolver', libDynamicRecordsetSolver.default_configuration, libDynamicRecordsetSolver);

		// Add shared PSRS styling providers (Bulma-styled templates for tables, pagination, filters)
		this.pict.addProvider('ComplexFilterProvider',
			{
				endCapTemplate: '',
			},
			require('../../providers/ComplexFilterProvider.js'));

		this.pict.addProvider('ImprovedTabularRecordSetProvider',
			{
				// Optional extra action slot in the list title bar (sits after the title, before the record
				// count). The built-in "New" button is rendered by ImprovedTabularRecordSetProvider itself.
				endCapTemplate: '',
				includePrint: false,
				overrideURLTemplate: `#/PSRS/{~D:Record.Payload.Payload.RecordSet~}/View/{~DVBK:Record.Payload.Data:Record.Payload.Payload.GUIDAddress~}`,
			},
			require('../../providers/ImprovedTabularRecordSetProvider.js'));

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require('headlight-rest-client'));
		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });

		// Reads through this.fable.HeadlightRestClient, so it is registered after it. The Tests tab and the TestInstance
		// popover share its per-sample scopes, so they show the same result for a test.
		this.fable.serviceManager.addServiceType('HeadlightSamples', libHeadlightSamples);
		this.fable.serviceManager.instantiateServiceProvider('HeadlightSamples', {});
		const tmpQuickSummaries = this.pict.services && this.pict.services.HeadlightQuickSummaries;
		if (tmpQuickSummaries && (typeof tmpQuickSummaries.addRecordDecorator === 'function'))
		{
			tmpQuickSummaries.addRecordDecorator('TestInstance', (pSummaryRecord, pRecord) => this.fable.HeadlightSamples.decorateTestInstanceSummary(pSummaryRecord, pRecord));
		}

		// Project cloning service (used by the ProjectClone workflow view). It is a
		// fable service (extends fable-serviceproviderbase) that reads
		// this.fable.HeadlightRestClient, so it is registered after the rest client
		// is instantiated above. Not an npm package — required by path from lib/.
		this.fable.serviceManager.addServiceType('ProjectCloningAdapter', require('../../../lib/service/headlight-project-cloning-adapter/Headlight-Project-Cloning-Adapter.js'));
		this.fable.serviceManager.instantiateServiceProvider('ProjectCloningAdapter', {});

		// The canonical type-save (build comprehension -> push -> pointer -> prune -> statuses).
		// Registered as a fable service so both the editor's PSRS wrap and the spreadsheet
		// ImportProvider resolve it via this.fable.TypeComprehensionSaveProvider.
		this.fable.serviceManager.addServiceType('TypeComprehensionSaveProvider', libTypeComprehensionSaveProvider);
		this.fable.serviceManager.instantiateServiceProvider('TypeComprehensionSaveProvider', {});

		// The read-side counterpart: shared hydration of statuses / default dates / allowed
		// project types / prototype for a type. The bespoke Project/Contract Type editors
		// resolve it via this.fable.TypeComprehensionReadProvider.
		this.fable.serviceManager.addServiceType('TypeComprehensionReadProvider', libTypeComprehensionReadProvider);
		this.fable.serviceManager.instantiateServiceProvider('TypeComprehensionReadProvider', {});

		// Effective-permissions aggregation — the swap seam for the Access workspace's Effective visualization
		// (and, later, the UI permission-expression layer). Composes the Permissions/* endpoints client-side
		// today; swappable for a server aggregation endpoint later without touching any view. Reads the rest
		// client, so registered after it is instantiated. Reached via this.fable.EffectivePermissionsService.
		this.fable.serviceManager.addServiceType('EffectivePermissionsService', libEffectivePermissionsService);
		this.fable.serviceManager.instantiateServiceProvider('EffectivePermissionsService', {});

		this.AppData.Interactive = true;

		// Application views
		this.pict.addView('Empty', configEmptyView);
		this.pict.addView('ConfigurationIndex', ConfigurationIndex.default_configuration, ConfigurationIndex);
		this.pict.addView('ConfigurationNavigation', ConfigurationNavigation.default_configuration, ConfigurationNavigation);
		this.pict.addView('TopicPage', TopicPage.default_configuration, TopicPage);
		this.pict.addView('CustomerProvisioning', CustomerProvisioning.default_configuration, CustomerProvisioning);
		this.pict.addView('ProjectClone', ProjectClone.default_configuration, ProjectClone);

		this.pict.addProvider('ContractAdminProvisioning', libContractAdminProvisioningProvider.default_configuration, libContractAdminProvisioningProvider);
		this.pict.addProvider('CustomerProvisioningProvider', libCustomerProvisioningProvider.default_configuration, libCustomerProvisioningProvider);
		this.pict.addProvider('ProjectCloneProvider', libProjectCloneProvider.default_configuration, libProjectCloneProvider);
		// Master List configuration tool: the registry provider (data + ConfigFragment persistence
		// + live apply) and its product-manager-facing editor screen.
		this.pict.addProvider('MasterListRegistry', libMasterListRegistryProvider.default_configuration, libMasterListRegistryProvider);
		this.pict.addView('MasterListManager', libMasterListManager.default_configuration, libMasterListManager);
		this.pict.addProvider('ObservationTypeEditor', libObservationTypeEditorProvider.default_configuration, libObservationTypeEditorProvider);
		this.pict.addView('ObservationTypeEditor', libObservationTypeEditor.default_configuration, libObservationTypeEditor);
		this.pict.addProvider('ArtifactTypeEditor', libArtifactTypeEditorProvider.default_configuration, libArtifactTypeEditorProvider);
		this.pict.addView('ArtifactTypeEditor', libArtifactTypeEditor.default_configuration, libArtifactTypeEditor);
		// Reusable project-scoped bulk-delete tool for the workspace's long lists (line/bid items, equipment,
		// personnel, labels). Gated by the 'Project-BulkDelete' entitlement (access/Task-Catalog.js).
		this.pict.addProvider('ProjectBulkDelete', libProjectBulkDeleteProvider.default_configuration, libProjectBulkDeleteProvider);
		this.pict.addView('ProjectCenterMap', libProjectCenterMap.default_configuration, libProjectCenterMap);
		// A second instance of the same Leaflet picker for the bespoke Project CREATE screen — bound to the
		// ProjectCreateWorkspace provider's working center and its own #PCW-MapHost (see ProjectCenterMap's
		// configurable ProviderName / MapHostID).
		this.pict.addView('ProjectCreateMap', Object.assign({}, libProjectCenterMap.default_configuration,
			{ ViewIdentifier: 'ProjectCreateMap', ProviderName: 'ProjectCreateWorkspace', MapHostID: 'PCW-MapHost' }), libProjectCenterMap);
		// Bespoke Project EDIT workspace: a hand-built form that locks the Financial & Schedule fields once the
		// project is Active (the manifest recordset form can't express per-record read-only). Router bridges
		// #/PSRS/Project/Edit/<GUID> to it.
		this.pict.addProvider('ProjectEditWorkspace', libProjectEditWorkspaceProvider.default_configuration, libProjectEditWorkspaceProvider);
		this.pict.addView('ProjectEditWorkspace', libProjectEditWorkspace.default_configuration, libProjectEditWorkspace);
		// Bespoke Project CREATE workspace: the curated create form that "+ New" opens (via the router bridge
		// #/PSRS/Project/Create) instead of the plain manifest form. Starts blank, POSTs a Project, then lands
		// on the bespoke read workspace for the new record.
		this.pict.addProvider('ProjectCreateWorkspace', libProjectCreateWorkspaceProvider.default_configuration, libProjectCreateWorkspaceProvider);
		this.pict.addView('ProjectCreateWorkspace', libProjectCreateWorkspace.default_configuration, libProjectCreateWorkspace);
		// Approval-workflow editor: the pict-section-flow graph editor over the 'ApprovalWorkflow' Config
		// blob (list + read-only graph now; editing in a later phase). The flow view self-registers all its
		// internal services; its Form properties panels (P2) resolve a 'PictFormMetacontroller' fable service
		// type, so register that from pict-section-form here (idempotent; pict-section-form is already a dep).
		if (!this.pict.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))
		{
			this.pict.addServiceType('PictFormMetacontroller', libPictSectionForm.PictFormMetacontroller);
		}
		this.pict.addProvider('ApprovalWorkflow', libApprovalWorkflowProvider.default_configuration, libApprovalWorkflowProvider);
		this.pict.addView('ApprovalWorkflowList', libApprovalWorkflowList.default_configuration, libApprovalWorkflowList);
		this.pict.addView('ApprovalWorkflowEditor', libApprovalWorkflowEditor.default_configuration, libApprovalWorkflowEditor);
		this.pict.addView('ApprovalWorkflowBindings', libApprovalWorkflowBindings.default_configuration, libApprovalWorkflowBindings);
		// Email Notifications (Email Rules) editor — migrated from Home's EmailRules.vue. Meadow EmailRule
		// entities + per-handler Configuration blobs; list now, editor in a later phase.
		this.pict.addProvider('EmailNotifications', libEmailNotificationsProvider.default_configuration, libEmailNotificationsProvider);
		this.pict.addView('EmailNotificationsList', libEmailNotificationsList.default_configuration, libEmailNotificationsList);
		this.pict.addView('EmailNotificationsEditor', libEmailNotificationsEditor.default_configuration, libEmailNotificationsEditor);
		// Bid Item Mapping embed (hosted by the config-driven ContractWorkspace's "Bid Item Mapping" tab).
		this.pict.addProvider('LineItemBidItemMap', libLineItemBidItemMapProvider.default_configuration, libLineItemBidItemMapProvider);
		// Project-level contractor matrix: ONE generic grid provider (ProjectContractorMatrix-Provider) registered
		// as TWO parameterized instances — one for line items, one for bid items — each embedded into a host div on
		// the bespoke Project workspace (openInto('Project', id, mount), like ProjectStaffing). Manages the M:N
		// LineItemOrganizationJoin / BidItemOrganizationJoin (contractors ↔ items) with a per-chip DBE toggle.
		this.pict.addProvider('ProjectContractorMatrixLine', Object.assign({}, libProjectContractorMatrixProvider.default_configuration,
			{
				ProviderIdentifier: 'ProjectContractorMatrixLine', AutoInitializeOrdinal: 223,
				ItemEntity: 'LineItem', ItemsSet: 'LineItems', ItemIDField: 'IDLineItem', ItemNumberField: 'ItemNumber', ItemNameField: 'Name', SortField: 'ItemNumber',
				JoinEntity: 'LineItemOrganizationJoin', JoinsSet: 'LineItemOrganizationJoins', JoinPKField: 'IDLineItemOrganizationJoin',
				MountSelector: '#PW-LineContractorHost', ItemNoun: 'Line item',
			}), libProjectContractorMatrixProvider);
		this.pict.addProvider('ProjectContractorMatrixBid', Object.assign({}, libProjectContractorMatrixProvider.default_configuration,
			{
				ProviderIdentifier: 'ProjectContractorMatrixBid', AutoInitializeOrdinal: 224,
				ItemEntity: 'BidItem', ItemsSet: 'BidItems', ItemIDField: 'IDBidItem', ItemNumberField: '', ItemNameField: 'Name', SortField: 'Name',
				JoinEntity: 'BidItemOrganizationJoin', JoinsSet: 'BidItemOrganizationJoins', JoinPKField: 'IDBidItemOrganizationJoin',
				MountSelector: '#PW-BidContractorHost', ItemNoun: 'Bid item',
			}), libProjectContractorMatrixProvider);
			// Equipment ↔ contractor: the same matrix, but its rows are DERIVED from ProjectEquipmentJoin (Equipment is
			// a shared master list, not project-owned), the join is a true ternary (stamp IDProject on write, filter the
			// load by it), there is no per-link DBE column, and a "+ Add equipment" control adds equipment to the project.
			this.pict.addProvider('ProjectContractorMatrixEquipment', Object.assign({}, libProjectContractorMatrixProvider.default_configuration,
				{
					ProviderIdentifier: 'ProjectContractorMatrixEquipment', AutoInitializeOrdinal: 225,
					ItemEntity: 'Equipment', GateEntity: 'Project', ItemsSet: 'Equipments', AddItemsSet: 'Equipments',
					ItemIDField: 'IDEquipment', ItemGUIDField: 'GUIDEquipment', ItemNumberField: '', ItemNameField: 'Name', SortField: 'Name',
					JoinEntity: 'ProjectEquipmentJoin', JoinsSet: 'ProjectEquipmentJoins', JoinPKField: 'IDProjectEquipmentJoin',
					JoinProjectField: 'IDProject', ItemsViaJoin: true, SupportsDBE: false,
					MountSelector: '#PW-EquipmentContractorHost', ItemNoun: 'Equipment',
				}), libProjectContractorMatrixProvider);
		// Bespoke User CREATE workspace: the curated create form that "+ New" opens (via the router bridge
		// #/PSRS/User/Create) instead of the plain manifest form. POSTs a User, then sets the login password
		// (POST /1.0/Password), then lands on the bespoke read workspace for the new record.
		this.pict.addProvider('UserCreateWorkspace', libUserCreateWorkspaceProvider.default_configuration, libUserCreateWorkspaceProvider);
		this.pict.addView('UserCreateWorkspace', libUserCreateWorkspace.default_configuration, libUserCreateWorkspace);
		// Bespoke Contract CREATE workspace: the curated create form that "+ New" opens (via the router bridge
		// #/PSRS/Contract/Create) instead of the plain manifest form. POSTs a Contract, then lands on the
		// bespoke read workspace for the new record.
		this.pict.addProvider('ContractCreateWorkspace', libContractCreateWorkspaceProvider.default_configuration, libContractCreateWorkspaceProvider);
		this.pict.addView('ContractCreateWorkspace', libContractCreateWorkspace.default_configuration, libContractCreateWorkspace);

		this.pict.addProvider('InspectionCreateWorkspace', libInspectionCreateWorkspaceProvider.default_configuration, libInspectionCreateWorkspaceProvider);
		this.pict.addView('InspectionCreateWorkspace', libInspectionCreateWorkspace.default_configuration, libInspectionCreateWorkspace);
		// Error Log Viewer: read-only diagnostics page (recent HLWebErrorLog artifacts — per-day chart + table).
		this.pict.addProvider('ErrorLogViewer', libErrorLogViewerProvider.default_configuration, libErrorLogViewerProvider);
		this.pict.addView('ErrorLogViewer', libErrorLogViewer.default_configuration, libErrorLogViewer);
		// "My Headlight": the signed-in organization's own config landing — starting with the customer logo.
		this.pict.addProvider('MyHeadlight', libMyHeadlightProvider.default_configuration, libMyHeadlightProvider);
		this.pict.addView('MyHeadlight', libMyHeadlight.default_configuration, libMyHeadlight);
		// Shared Report->Project assignment view (headlight-report-project-assignment), rendered into this app's
		// container. No FormGroups injected here, so the materials-only bulk-add modal stays hidden.
		this.pict.addView('ReportNamedInstanceProjectForms', Object.assign({}, libReportProjectAssignment.default_configuration,
			{ DefaultDestinationAddress: '#PlatformConfiguration-Application-Container' }), libReportProjectAssignment);
		// pict-section-picker: the searchable entity picker the recordset Association editor uses.
		this.pict.addProvider('Pict-Section-Picker', libPictSectionPicker.default_configuration, libPictSectionPicker);
		// pict-section-accordion: multi-step container (accordion / wizard / stepper); drives the Support merge wizard.
		this.pict.addProvider('Pict-Section-Accordion', libPictSectionAccordion.default_configuration, libPictSectionAccordion);

		// pict-dataexplorer: the operational-database "folders" explorer (Database -> Data Explorer). The
		// provider owns createExplorer; the DataExplorer host view builds + renders the tree on demand and
		// reuses the post-login RecordSetCardManager cards for the record ⓘ popouts.
		this.pict.addProvider('Pict-DataExplorer', libPictDataExplorer.default_configuration, libPictDataExplorer);
		this.pict.addView('DataExplorer', DataExplorer.default_configuration, DataExplorer);

		// Sample Plan editor: a project's material sampling/testing plan as a master/detail navigator built on
		// pict-dataexplorer (Section/Line-Item → Material → Rule, satisfaction rollups, layered AcademyContent docs).
		this.pict.addProvider('SamplePlan', SamplePlanProvider.default_configuration, SamplePlanProvider);
		this.pict.addView('SamplePlan', SamplePlan.default_configuration, SamplePlan);
		// Net-new SamplePlan dashboard (a shareable provider + a thin standalone view; embed elsewhere via openInto).
		this.pict.addProvider('SamplePlanDashboard', SamplePlanDashboardProvider.default_configuration, SamplePlanDashboardProvider);
		this.pict.addView('SamplePlanDashboard', SamplePlanDashboard.default_configuration, SamplePlanDashboard);
		// Sample Plan Copy: on a route with no menu entry, on purpose.
		this.pict.addServiceType('SamplePlanService', require('headlight-lims-sampleplan'));
		this.pict.addView('SamplePlanCopy', SamplePlanCopy.default_configuration, SamplePlanCopy);
		this.pict.addProvider('ObservationList', ObservationListProvider.default_configuration, ObservationListProvider);
		this.pict.addView('ObservationList', ObservationListView.default_configuration, ObservationListView);
		this.pict.addProvider('DocumentList', DocumentListProvider.default_configuration, DocumentListProvider);
		this.pict.addView('DocumentList', DocumentListView.default_configuration, DocumentListView);
		// A record's documents opened side by side with a quick-switch rail, each in its own frame running the longhand form page.
		this.pict.addProvider('DocumentFrameSwitcher', DocumentFrameSwitcherProvider.default_configuration, DocumentFrameSwitcherProvider);
		this.pict.addProvider('InspectionSchedule', InspectionScheduleProvider.default_configuration, InspectionScheduleProvider);
		this.pict.addView('InspectionSchedule', InspectionScheduleView.default_configuration, InspectionScheduleView);
		// Customer Support console. The provider owns the triage list / create-edit / approval-action surface; the
		// SupportCallFormHost (below) renders the customer's configured Support-Call manifest into #Support-FormHost.
		this.pict.addProvider('Support', SupportProvider.default_configuration, SupportProvider);
		this.pict.addView('Support', SupportView.default_configuration, SupportView);
		// The merge-tickets wizard (pict-section-accordion in wizard mode): folds duplicate/misfiled tickets into a parent.
		this.pict.addProvider('SupportMerge', SupportMergeProvider.default_configuration, SupportMergeProvider);
		// Read-only customer-facing open-cases portal (#/SupportPortal) for the Support-View tier — curated fields + the
		// caller-facing acknowledgement/resolution updates, no triage or internal notes.
		this.pict.addProvider('SupportPortal', SupportPortalProvider.default_configuration, SupportPortalProvider);
		this.pict.addView('SupportPortal', SupportPortalView.default_configuration, SupportPortalView);
		// Form Concierge: files + one markdown request → plansheet form sessions (create / update / build / examples).
		this.pict.addProvider('FormConcierge', FormConciergeProvider.default_configuration, FormConciergeProvider);
		this.pict.addView('FormConcierge', FormConciergeView.default_configuration, FormConciergeView);
		// The support-call dynamic-form runner (pict-section-form-host): the Support provider drives loadForm on demand
		// with the fetched Support-Call manifest, marshaling to AppData.DocumentData.ReportData.FormData so the
		// ObservationImageSet attachment field and the production document save agree on one FormData object.
		this.pict.addProvider('SupportCallFormHost',
			{
				ProviderIdentifier: 'SupportCallFormHost',
				DestinationType: 'div',
				DestinationAddress: '#Support-FormHost',
				DataAddress: 'AppData.DocumentData.ReportData.FormData',
				CreateDestinationElement: false,
				AutoRenderOnLoad: true,
			}, libPictSectionFormHost);
		this.pict.addProvider('DocumentThroughput', DocumentThroughputProvider.default_configuration, DocumentThroughputProvider);
		this.pict.addView('DocumentThroughput', DocumentThroughputView.default_configuration, DocumentThroughputView);
		this.pict.addProvider('InspectionScope', libInspectionScopeService.default_configuration, libInspectionScopeService);
		this.pict.addProvider('AssetDescriptor', libAssetDescriptorProvider.default_configuration, libAssetDescriptorProvider);
		this.pict.addProvider('PhysicalAssetDashboard', PhysicalAssetDashboardProvider.default_configuration, PhysicalAssetDashboardProvider);
		this.pict.addView('PhysicalAssetDashboard', PhysicalAssetDashboardView.default_configuration, PhysicalAssetDashboardView);
		// Important Project Files: a standalone project-scoped folder/file manager (Phase 1 = read-only navigator).
		this.pict.addProvider('ImportantFiles', libImportantFilesProvider.default_configuration, libImportantFilesProvider);
		this.pict.addView('ImportantFiles', libImportantFiles.default_configuration, libImportantFiles);
		this.pict.addProvider('BulkUpload', libBulkUploadProvider.default_configuration, libBulkUploadProvider);
		this.pict.addView('BulkUpload', libBulkUpload.default_configuration, libBulkUpload);
		this.pict.addProvider('ProjectFunding', libProjectFundingProvider.default_configuration, libProjectFundingProvider);
		this.pict.addView('ProjectFunding', libProjectFunding.default_configuration, libProjectFunding);
		// Contract ▸ Change Orders (ProjectWorkspace tab): list/browse/view the project's ChangeOrder headers +
		// their LineItemChangeOrder lines. Phase 1 (read); create/edit via pict-section-form-host in Phase 2.
		this.pict.addProvider('ChangeOrders', libChangeOrdersProvider.default_configuration, libChangeOrdersProvider);
		this.pict.addView('ChangeOrders', libChangeOrders.default_configuration, libChangeOrders);
		// The change-order dynamic-form runner (pict-section-form-host): renders the Default-ChangeOrder
		// HeadlightDynamicForm manifest into #CO-FormHost. Registered empty (no Form) so the ChangeOrders provider
		// drives loadForm/getFormData/save on demand for create/edit.
		this.pict.addProvider('ChangeOrderFormHost',
			{
				ProviderIdentifier: 'ChangeOrderFormHost',
				DestinationType: 'div',
				DestinationAddress: '#CO-FormHost',
				DataAddress: 'AppData.ChangeOrderForm',
				CreateDestinationElement: false,
				AutoRenderOnLoad: true,
			}, libPictSectionFormHost);

		// Reusable entity custom-metadata form (see EntityMetadataForm-Provider): the provider drives loadForm into
		// the caller's host bound to the record's CustomProperties address; AutoRenderOnLoad is OFF so the provider
		// sets the read/edit theme BEFORE rendering. The ManifestPackagingService (registered below) supplies the
		// client-side manifest compose; registration order is fine (the provider resolves the service at call time).
		this.pict.addProvider('EntityMetadataForm', libEntityMetadataFormProvider.default_configuration, libEntityMetadataFormProvider);
		this.pict.addProvider('EntityMetaFormHost',
			{
				ProviderIdentifier: 'EntityMetaFormHost',
				DestinationType: 'div',
				DestinationAddress: '#EMF-Body',
				DataAddress: 'AppData.EntityMetaValues',
				CreateDestinationElement: false,
				AutoRenderOnLoad: false,
			}, libPictSectionFormHost);

		// --- LIMS Samples -------------------------------------------------------------------------------------
		// The configuration-based Sample screens rebuilt from web/lims. The shared manifest-packaging-service
		// loads the customer's configured LIMS-Sample-{Create,Edit,View} ManifestSchema; the shared web/providers/*
		// LIMS providers own the Sample CRUD/read fan-out and the save pipeline (QR minting, storage-location join,
		// sample-log). The base class already provides HeadlightQRCodeHash + SessionProvider + HeadlightRestClient;
		// MPS reuses the existing HeadlightRestClient (so it hits the app's /1.0/ base, not QA).
		this.pict.addAndInstantiateServiceType('ManifestPackagingService', libManifestPackagingService);
		this.pict.addProvider('CustomerRecordManifests', libCustomerRecordManifestsProvider.default_configuration, libCustomerRecordManifestsProvider);
		this.pict.addProvider('UtilityProvider', libUtilityProvider.default_configuration, libUtilityProvider);
		this.pict.addProvider('LocationProvider', libLocationProvider.default_configuration, libLocationProvider);
		this.pict.addProvider('SampleLogProvider', libSampleLogProvider.default_configuration, libSampleLogProvider);
		this.pict.addProvider('SampleProvider', libSampleProvider.default_configuration, libSampleProvider);
		this.pict.addProvider('LineItemProvider', libLineItemProvider.default_configuration, libLineItemProvider);
		this.pict.addProvider('TestInstanceProvider', libTestInstanceProvider.default_configuration, libTestInstanceProvider);
		this.pict.addProvider('DocumentProvider', libDocumentProvider.default_configuration, libDocumentProvider);
		this.pict.addProvider('GeoProvider', libGeoProvider.default_configuration, libGeoProvider);
		// QRCodeProvider backs the Sample QR thumbnail + "Print Label" (printDecoratedEntity). The base class already
		// provides HeadlightQuickSummaries (printable decoration) + HeadlightQRCodeHash; RecordExtension is registered
		// below. Scans (keyboard scanner and camera) go through HeadlightQR's scan handlers, which the panels register.
		this.pict.addProvider('QRCodeProvider', (libQRCodeProvider.default_configuration || {}), libQRCodeProvider);
		// Off here (scans open Sample Details); a micro app turns it on to open the scanned record's screen.
		this.pict.addProvider('ScanToOpen', libScanToOpenProvider.default_configuration, libScanToOpenProvider);
		this.pict.addProvider('RecordExtension', libRecordExtensionProvider.default_configuration, libRecordExtensionProvider);
		this.pict.addProvider('FormInitialBundle', libFormInitialBundleProvider.default_configuration, libFormInitialBundleProvider);
		// The Sample dynamic-form runner (pict-section-form-host): renders the customer's configured
		// LIMS-Sample-{View,Create,Edit} manifest into #Sample-FormHost. DataAddress 'AppData' makes the form marshal
		// to AppData.SampleDetails.* exactly as the LIMS app does (descriptor DataAddresses are SampleDetails.*), so
		// the SampleWorkspace provider reads/writes AppData.SampleDetails directly. Registered empty; the provider
		// drives loadForm/getFormData/save on demand per mode.
		this.pict.addProvider('SampleFormHost',
			{
				ProviderIdentifier: 'SampleFormHost',
				DestinationType: 'div',
				DestinationAddress: '#Sample-FormHost',
				DataAddress: 'AppData',
				CreateDestinationElement: false,
				AutoRenderOnLoad: true,
			}, libPictSectionFormHost);

		// Register the config-driven Headlight Workspaces (pict-section-workspace): each config becomes a
		// provider + view pair; the router registers the matching bridge routes in onBeforeLoadDataAsync.
		libWorkspaceConfigs.registerWorkspaces(this.pict);

		// Data Lake (materialized projections): the catalog of imported clones + computed projections.
		this.pict.addProvider('DatalakeCatalogProvider', libDatalakeCatalogProvider.default_configuration, libDatalakeCatalogProvider);
		this.pict.addView('DatalakeCatalog', DatalakeCatalog.default_configuration, DatalakeCatalog);
		// Data Downloader: gated download page for the desktop apps we ship (first of three binary apps).
		this.pict.addProvider('DataDownloaderProvider', libDataDownloaderProvider.default_configuration, libDataDownloaderProvider);
		this.pict.addView('DataDownloader', libDataDownloader.default_configuration, libDataDownloader);
		this.pict.addProvider('DatalakeDatasetProvider', libDatalakeDatasetProvider.default_configuration, libDatalakeDatasetProvider);
		this.pict.addView('DatalakeDataset', DatalakeDataset.default_configuration, DatalakeDataset);
		this.pict.addProvider('DatalakeProjectionEditorProvider', libDatalakeProjectionEditorProvider.default_configuration, libDatalakeProjectionEditorProvider);
		this.pict.addView('DatalakeProjectionEditor', DatalakeProjectionEditor.default_configuration, DatalakeProjectionEditor);

		// Configuration viewer/editor: provenance-aware cascading config + record CustomProperties.
		this.pict.addProvider('ConfigViewer', libConfigViewerProvider.default_configuration, libConfigViewerProvider);
		this.pict.addView('ConfigViewer', libConfigViewer.default_configuration, libConfigViewer);
		this.pict.addProvider('Documentation', libDocumentationProvider.default_configuration, libDocumentationProvider);
		this.pict.addView('Documentation', libDocumentation.default_configuration, libDocumentation);
		// Reused forms-app RNI metadata editor. Keep the hash 'ReportNamedInstanceCreate' — its template's inline
		// handlers reference _Pict.views.ReportNamedInstanceCreate — and override the container + return routes so
		// it renders inside the config app and returns to the Document Types list (see RecordSetCustomViews below).
		this.pict.addView('ReportNamedInstanceCreate', Object.assign({}, libReportNamedInstanceMetadataEditor.default_configuration,
			{
				ContainerDestination: '#PlatformConfiguration-Application-Container',
				DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
				AfterSaveRoute: '#/PSRS/ReportNamedInstance/List',
				ListRoute: '#/PSRS/ReportNamedInstance/List',
			}), libReportNamedInstanceMetadataEditor);
		this.pict.addProvider('Entitlements', libEntitlementsProvider.default_configuration, libEntitlementsProvider);
		this.pict.addView('Entitlements', libEntitlements.default_configuration, libEntitlements);
		this.pict.addProvider('Certifications', libCertificationsProvider.default_configuration, libCertificationsProvider);
		this.pict.addView('Certifications', libCertifications.default_configuration, libCertifications);
		this.pict.addProvider('ATMDashboardConfig', libATMDashboardConfigProvider.default_configuration, libATMDashboardConfigProvider);
		this.pict.addView('ATMDashboardConfig', libATMDashboardConfig.default_configuration, libATMDashboardConfig);
		// Sample configuration screens: choose the Samples-list columns (writes the MasterListCatalog Configuration
		// that drives #/PSRS/Sample/List) + the sample QR-code format (Customer.CustomProperties.CustomSampleGUID).
		this.pict.addProvider('AssetTypeDescriptor', libAssetTypeDescriptorProvider.default_configuration, libAssetTypeDescriptorProvider);
		this.pict.addView('AssetTypeDescriptor', libAssetTypeDescriptor.default_configuration, libAssetTypeDescriptor);
		this.pict.addProvider('SampleListColumnsConfig', libSampleListColumnsConfigProvider.default_configuration, libSampleListColumnsConfigProvider);
		this.pict.addView('SampleListColumnsConfig', libSampleListColumnsConfig.default_configuration, libSampleListColumnsConfig);
		this.pict.addProvider('SampleQRCodeConfig', libSampleQRCodeConfigProvider.default_configuration, libSampleQRCodeConfigProvider);
		this.pict.addView('SampleQRCodeConfig', libSampleQRCodeConfig.default_configuration, libSampleQRCodeConfig);
		this.pict.addView('PrinterCodes', libPrinterCodes.default_configuration, libPrinterCodes);
		// Scan Samples as a page of its own (#/ScanSamples), the LIMS top nav's Scanning Cart: the panel's cart, separately kept.
		this.pict.addView('ScanSamplesPage', libScanSamplesPage.default_configuration, libScanSamplesPage);
		this.pict.addProvider('EntityDestinationsConfig', libEntityDestinationsConfigProvider.default_configuration, libEntityDestinationsConfigProvider);
		this.pict.addView('EntityDestinationsConfig', libEntityDestinationsConfig.default_configuration, libEntityDestinationsConfig);
		this.installDashboards();
		this.pict.addProvider('DashboardAccessConfig', libDashboardAccessConfigProvider.default_configuration, libDashboardAccessConfigProvider);
		this.pict.addView('DashboardAccessConfig', libDashboardAccessConfig.default_configuration, libDashboardAccessConfig);
		libConfigScreens.registerConfigScreens(this.pict);
		this.pict.addProvider('CertificationTypes', libCertificationTypesProvider.default_configuration, libCertificationTypesProvider);
		this.pict.addView('CertificationTypes', libCertificationTypes.default_configuration, libCertificationTypes);
		this.pict.addProvider('AssetCatalogSync', libAssetCatalogSyncProvider.default_configuration, libAssetCatalogSyncProvider);
		this.pict.addView('AssetCatalogSync', libAssetCatalogSync.default_configuration, libAssetCatalogSync);
		// Third ProjectCenterMap instance — the asset Location tab's interactive Leaflet map, bound to the
		// AssetWorkspace provider's working center (center/hasCenter/setCenter) + its own #AW-MapHost.
		this.pict.addView('AssetLocationMap', Object.assign({}, libProjectCenterMap.default_configuration,
			{ ViewIdentifier: 'AssetLocationMap', ProviderName: 'AssetWorkspace', MapHostID: 'AW-MapHost' }), libProjectCenterMap);
		// Read-only 2-marker (Capture + User) map for the Observation workspace's Location tab (its own #OW-MapHost).
		this.pict.addView('ObservationLocationMap', libObservationLocationMap.default_configuration, libObservationLocationMap);
		// The same read-only map for the Location workspace's Details tab: one marker at the Location's coordinates.
		this.pict.addView('LocationViewMap', Object.assign({}, libObservationLocationMap.default_configuration,
			{ ViewIdentifier: 'LocationViewMap', ProviderName: 'LocationWorkspace', MapHostID: 'LW-MapHost', LeafletDestinationAddress: 'LW-MapHost' }), libObservationLocationMap);
		this.pict.addProvider('ProjectContractTypes', libProjectContractTypesProvider.default_configuration, libProjectContractTypesProvider);
		this.pict.addView('ProjectTypes', libProjectTypes.default_configuration, libProjectTypes);
		this.pict.addView('ContractTypes', libContractTypes.default_configuration, libContractTypes);
		this.pict.addProvider('RecordDates', libRecordDatesProvider.default_configuration, libRecordDatesProvider);
		this.pict.addView('RecordDates', libRecordDates.default_configuration, libRecordDates);
		this.pict.addProvider('ProjectStaffing', libProjectStaffingProvider.default_configuration, libProjectStaffingProvider);
		this.pict.addProvider('SuperUserGrant', libSuperUserGrantProvider.default_configuration, libSuperUserGrantProvider);
		this.pict.addView('SuperUserGrant', libSuperUserGrant.default_configuration, libSuperUserGrant);
		// Internals version screens (Headlight-only; gated in the router + nav): one shared inventory provider
		// feeds both the single-environment and cross-environment version views.
		this.pict.addProvider('InternalsServiceCatalog', libInternalsServiceCatalog.default_configuration, libInternalsServiceCatalog);
		this.pict.addView('ServiceVersions', libInternalsServiceVersions.default_configuration, libInternalsServiceVersions);
		this.pict.addView('ServiceVersionsMultiEnv', libInternalsServiceVersionsMultiEnv.default_configuration, libInternalsServiceVersionsMultiEnv);
		this.pict.addProvider('ManageCustomers', libManageCustomersProvider.default_configuration, libManageCustomersProvider);
		this.pict.addView('ManageCustomers', libManageCustomers.default_configuration, libManageCustomers);
		this.pict.addProvider('CustomersList', libCustomersListProvider.default_configuration, libCustomersListProvider);
		this.pict.addView('Customers', libCustomers.default_configuration, libCustomers);
		this.pict.addProvider('ActivityObservability', libActivityObservabilityProvider.default_configuration, libActivityObservabilityProvider);
		this.pict.addView('UserActivity', libUserActivity.default_configuration, libUserActivity);
		this.pict.addView('UserLoginOverview', libUserLoginOverview.default_configuration, libUserLoginOverview);
		this.pict.addView('ProjectActivity', libProjectActivity.default_configuration, libProjectActivity);
		this.pict.addProvider('ConfigCloneProvider', libConfigCloneProvider.default_configuration, libConfigCloneProvider);
		this.pict.addView('ConfigClone', libConfigClone.default_configuration, libConfigClone);
		this.pict.addProvider('RoleCloneProvider', libRoleCloneProvider.default_configuration, libRoleCloneProvider);
		this.pict.addView('RoleClone', libRoleClone.default_configuration, libRoleClone);

		// Data Mapper: the visual data-mapper (pict-section-mapping) embedded against the PDO /1.0/mapper surface.
		this.pict.addView('DataMapper', libDataMapper.default_configuration, libDataMapper);

		// Data Import: the generic single-entity importer (pict-section-dataimport) for simple reference
		// entities (Materials, Pay Items, ...). The DataImportManager provider supplies Headlight schema +
		// push seams so the wizard runs entirely through HeadlightRestClient (no pict.EntityProvider).
		this.pict.addProvider('Pict-Section-DataImport', libPictSectionDataImport.default_configuration, libPictSectionDataImport);
		this.pict.addProvider('DataImportManager', libDataImportProvider.default_configuration, libDataImportProvider);
		this.pict.addView('DataImport', libDataImport.default_configuration, libDataImport);

		// Contract Package Import: the bespoke multi-entity importer (Contract → Project → Bid Item → Line
		// Item) — reuses DataImportManager's ordered push + engine, driven by an entity-aware GUID strategy.
		this.pict.addProvider('ContractPackageImportManager', libContractPackageImportProvider.default_configuration, libContractPackageImportProvider);
		this.pict.addView('ContractPackageImport', libContractPackageImport.default_configuration, libContractPackageImport);

		// Access & Permissions workspace: the cohesive RBAC screen (roles, permission groups, the permission
		// matrix, the effective-permissions visualizer, per-user role assignment) — replaces the raw lists.
		this.pict.addProvider('AccessWorkspace', libAccessWorkspaceProvider.default_configuration, libAccessWorkspaceProvider);
		this.pict.addView('AccessWorkspace', libAccessWorkspace.default_configuration, libAccessWorkspace);
		this.pict.addProvider('PermissionMatrix', libPermissionMatrixProvider.default_configuration, libPermissionMatrixProvider);
		this.pict.addProvider('PermissionVisualizer', libPermissionVisualizerProvider.default_configuration, libPermissionVisualizerProvider);
		this.pict.addProvider('GroupComposition', libGroupCompositionProvider.default_configuration, libGroupCompositionProvider);
		this.pict.addProvider('UserGroupGrants', libUserGroupGrantsProvider.default_configuration, libUserGroupGrantsProvider);
		this.pict.addProvider('RoleAssignment', libRoleAssignmentProvider.default_configuration, libRoleAssignmentProvider);

		this.pict.addProvider('ContractProjectTypesImportProvider', libContractProjectTypesImportProvider.default_configuration, libContractProjectTypesImportProvider);

		// Dashboard data provider — shared with the Activity Observability views. (The Analytics dashboard views
		// that also consumed it were retired, so only the provider remains.)
		this.pict.addProvider('PlatformDashboardData', PlatformDashboardDataProvider.default_configuration, PlatformDashboardDataProvider);

		// In-app documentation (pict-section-inlinedocumentation). Registered under its own
		// ProviderIdentifier ('Pict-InlineDocumentation') because its own views resolve the
		// provider by that hash. Its constructor registers the doc browser views; the content
		// is loaded from /docs/ and wired up after login in _initializeHelpDocumentation().
		this.pict.addProvider('Pict-InlineDocumentation', libInlineDocumentation.default_configuration, libInlineDocumentation);

		// The full-page Headlight Academy (route #/Academy[/:Topic]). Its provider reads the inline-doc TOC + fetches
		// articles through that provider, so it stays in sync with the panel and the doc editor.
		this.pict.addProvider('Academy', AcademyProvider.default_configuration, AcademyProvider);
		this.pict.addView('Academy', AcademyView.default_configuration, AcademyView);

		// the navigation section holds the app's
		// configuration graph and registers the render-type views (Navigation-Hub/Sidebar/
		// Palette/List). OnNavigate routes for real by setting the hash route.
		this.pict.addProvider('Pict-Navigation', { NavigationGraph: libNavigationGraph }, libPictSectionNavigation);
		this.pict.providers['Pict-Navigation'].onNavigate = (pNode) =>
		{
			if (pNode && typeof pNode.Route === 'string' && pNode.Route.charAt(0) === '#')
			{
				window.location.hash = pNode.Route.replace(/^#/, '');
			}
		};

		this.pict.ContentAssignment.removeClass('.is-loading-splash', 'is-hidden');
	}

	/**
	 * Called during initialization to register templates.
	 */
	registerTemplates()
	{
		super.registerTemplates();
		for (const templateSet of Object.values(HeadlightDynamicInputsBundle.getThemeMap()))
		{
			this.pict.providers.PictFormSectionDefaultTemplateProvider.injectTemplateSet(templateSet);
		}
	}

	/**
	 * Change the theme to one of the available themes.
	 *
	 * @param {string} pTheme - The theme to change to.
	 */
	changeTheme(pTheme)
	{
		const newTheme = 'PictProvider-Theme-' + pTheme;
		this.pict.log.info(`Changing theme to: ${newTheme}`);
		this.theme = newTheme;
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.formTemplatePrefix = newTheme;
		}
	}

	onInitialize()
	{
		this.changeTheme('Read');

		this.pict.addView('HeadlightLogin', {}, require('headlight-view-login'));

		this.pict.views.PictFormMetacontroller.viewMarshalDestination = 'AppData';

		return super.onInitialize();
	}

	onAfterInitialize()
	{
		this.pict.views.PictFormMetacontroller.generateMetatemplate();
		return super.onAfterInitialize();
	}

	async onInitializeAsync(fCallback)
	{
		this.pict.views.PictFormMetacontroller.viewMarshalDestination = 'AppData';
		this.pict.instantiateServiceProvider('PictSectionRecordSet', this.options);
		this.pict.PictSectionRecordSet.sessionProviders.push(async (capability) =>
		{
			return this.pict.providers.SessionProvider.getSession().then((session) => session.LoggedIn).catch((error) => false);
		});
		// NOTE: Router must be added BEFORE PSRS initialize so router hooks attach to PSRS routes
		this.pict.addProvider('PlatformConfigurationRouter', libPlatformConfigurationRouter.default_configuration, libPlatformConfigurationRouter);
		// Initialize the views for the recordset metacontroller service
		this.pict.PictSectionRecordSet.initialize();

		await super.onInitializeAsync(fCallback);
	}

	async onAfterInitializeAsync(fCallback)
	{
		try
		{
			// Register CSS for the PSRS read-page template overrides through the
			// Pict CSS cascade rather than inline <style> tags in the templates.
			this.pict.CSSMap.addCSS('PlatformConfiguration-PSRS-Read-CSS', /*css*/`
				.record-button-bar-hidden { display: none; }
				.record-button-bar { display: flex; justify-content: flex-end; margin-top: 15px; gap: 10px; }
				.psrs-split-view { display: flex; height: 100%; gap: 1.25rem; align-items: flex-start; }
				.psrs-left-panel { overflow: auto; }
				.psrs-right-panel { overflow: auto; }
				#psrs-resize { width: 1px; padding-left: 10px; padding-right: 10px; cursor: col-resize; display: none; }
				#psrs-resize > div { width: 1px; height: 100%; background-color: rgba(0,0,0,0.5); }
				/* Read-tab folder chrome (.psrs-tab / #PRSP-Read-Tab-Nav / .psrs-tab-body) is styled once,
				   scoped to #PRSP-Read-Tabs-Container, in css/platform-configuration.css. Do NOT redeclare it
				   here — the old unscoped copies fought that block (centered nav, boxed active tab). */

				/* Generic read-view tab strip → the app's shared TabBar look (see ReadView-TabBar-Decoration.js,
				   which rewrites each tab into an icon+label button, and views/TabBar.js for the canonical look).
				   Compact underline-active tabs + FontAwesome icons + horizontal-scroll overflow, matching the
				   bespoke workspaces. Scoped under the app container id so it outranks the .psrs-split-tabnav pill
				   rules (css/platform-configuration.css) AND the module's own .psrs-tab CSS by specificity — no
				   !important. MIGRATION: fold into pict-section-recordset alongside the _structureTabs change. */
				${ libTabBar.TABBAR_CSS }
				#PlatformConfiguration-Application-Container .psrs-split-tabnav { display: block; margin: 0.25rem 0 0; }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav {
					display: flex; align-items: stretch; flex-wrap: nowrap; justify-content: flex-start;
					width: 100%; gap: 0.1rem; margin: 0.25rem 0 0; padding: 0;
					overflow-x: clip; overflow-y: visible;
					border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
				/* "Full Record" stays first/left; drop the auto-margin that scattered the strip to the right. */
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav #PSRS-TabNav-FullRecord { margin-right: 0; }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab {
					flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.4rem; white-space: nowrap;
					cursor: pointer; border: none; border-radius: 0; background: transparent;
					padding: 0.55rem 0.9rem; margin-bottom: -1px; border-bottom: 2px solid transparent;
					font: inherit; font-size: 0.85rem; font-weight: 500; line-height: 1.2;
					color: var(--theme-color-text-secondary, #45505f);
					transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease; }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab:hover { color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-secondary, #f0f2f6); }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab:focus-visible { outline: 2px solid var(--theme-color-brand-primary, #5650e6); outline-offset: -2px; }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab .icon { font-size: 0.92em; opacity: 0.8; }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab.is-active { color: var(--theme-color-brand-primary, #5650e6); font-weight: 650; background: transparent; border: none; border-bottom: 2px solid var(--theme-color-brand-primary, #5650e6); }
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab.is-active .icon { opacity: 1; }
				/* Overflow tabs the TabBar menu-layout moved into the "More" dropdown must actually hide. The id-scoped
				   .psrs-tab rule above would otherwise out-rank TabBar's .hltab.is-overflow display:none (2 ids vs
				   2 classes) and leave them taking space, shoving the More button off-screen — so hide them id-scoped. */
				#PlatformConfiguration-Application-Container #PRSP-Read-Tab-Nav .psrs-tab.is-overflow { display: none; }
				/* Fuse the tab strip to the content below it (Project .pw-panel folder look): no gap under the strip,
				   and in the collapsed / Full Record state the record card fills full width, drops its top border +
				   top radius, and connects under the strip's bottom border so tabs + record read as one card. */
				#PlatformConfiguration-Application-Container .psrs-split-view.psrs-collapsed .psrs-left-panel { padding: 0; }
				#PlatformConfiguration-Application-Container .psrs-split-view.psrs-collapsed .pcfg-record-panel { border-top: none; border-top-left-radius: 0; border-top-right-radius: 0; }
				/* Manifest-form boolean captions render via Bulma's .is-checkbox / .control-status at the base 16px/600,
				   which dwarfs the shrunk field labels (e.g. a Material's "Brand Name Required" / "Active" towered over
				   NAME, CATALOG CODE, …). Bring the checkbox caption down to the field-label scale so it reads as a
				   label, not a heading, in both the read and the manifest edit/create forms. */
				#PlatformConfiguration-Application-Container p.control.control-status { font-size: 0.82rem; font-weight: 600; }
				#PlatformConfiguration-Application-Container p.control.control-status .control-status-icon { font-size: 1rem; }
			`, 500);

			this.pict.CSSMap.injectCSS();

			// Set PSRS child view destination addresses
			this.pict.PictSectionRecordSet.childViews.read.options.DefaultDestinationAddress = '#PlatformConfiguration-Application-Container';
			this.pict.PictSectionRecordSet.childViews.list.options.DefaultDestinationAddress = '#PlatformConfiguration-Application-Container';
			this.pict.PictSectionRecordSet.childViews.dashboard.options.DefaultDestinationAddress = '#PlatformConfiguration-Application-Container';
			// The Create child view defaults to '#PRSP_Container' which this app does not render — point it at the
			// shared application container so `/PSRS/<entity>/Create` routes actually mount their form. Affects every
			// configurable record-set (ContractType, ProjectType, User, etc.).
			this.pict.PictSectionRecordSet.childViews.create.options.DefaultDestinationAddress = '#PlatformConfiguration-Application-Container';
			// The association screens (bulk Assign / Matrix / Unlink) also default to '#PRSP_Container';
			// point them at the shared container so #/PSRS/<entity>/Associate/<association> (and the
			// Matrix / Unlink routes) actually render in this app.
			[ 'associate', 'associateMatrix', 'associateUnlink' ].forEach((pChildViewKey) =>
			{
				const tmpChildView = this.pict.PictSectionRecordSet.childViews[pChildViewKey];
				if (tmpChildView && tmpChildView.options)
				{
					tmpChildView.options.DefaultDestinationAddress = '#PlatformConfiguration-Application-Container';
				}
			});

			// Activate Bulma-styled template overrides for PSRS views
			this.pict.providers.ComplexFilterProvider.prepareComplexFilter();
			this.pict.providers.ImprovedTabularRecordSetProvider.prepareTable();

			// Bulma color classes emitted by list-cell {~TIfAbs:~} status mappings (e.g. Project Status tag)
			this.pict.TemplateProvider.addTemplate('PSRS-StatusTag-Success', 'is-success');
			this.pict.TemplateProvider.addTemplate('PSRS-StatusTag-Info', 'is-info');
			this.pict.TemplateProvider.addTemplate('PSRS-StatusTag-Danger', 'is-danger');

			// Override the default PSRS record button bar with Bulma-styled buttons
			this.pict.TemplateProvider.addTemplate('PRSP-Read-RecordButtonBar-Template', /*html*/`
				<div class="record-button-bar">
					<button id="PRSP-Read-EditButton" type="button" class="button is-link" onclick="_Pict.views['RSP-RecordSet-Read'].edit()"><span class="icon"><i class="fas fa-pen-to-square"></i></span><span>Edit</span></button>
					<button id="PRSP-Read-SaveButton" type="button" class="button is-success" onclick="_Pict.views['RSP-RecordSet-Read'].save()"><span class="icon"><i class="fas fa-floppy-disk"></i></span><span>Save</span></button>
					<button id="PRSP-Read-CancelButton" type="button" class="button is-warning" onclick="_Pict.views['RSP-RecordSet-Read'].cancel()"><span class="icon"><i class="fas fa-xmark"></i></span><span>Cancel</span></button>
				</div>
			`);

			// Match the Create page's button bar to the Bulma-styled Read bar (the
			// default template ships bare buttons + an inline <style>). Reuses the
			// .record-button-bar CSS registered in the PSRS Read CSS block above.
			this.pict.TemplateProvider.addTemplate('PRSP-Create-RecordButtonBar-Template', /*html*/`
				<div class="record-button-bar">
					<button id="PRSP-Create-SaveButton" type="button" class="button is-success" onclick="_Pict.views['RSP-RecordSet-Create'].save()"><span class="icon"><i class="fas fa-floppy-disk"></i></span><span>Save</span></button>
					<button id="PRSP-Create-ClearButton" type="button" class="button is-warning" onclick="_Pict.views['RSP-RecordSet-Create'].clear()"><span class="icon"><i class="fas fa-eraser"></i></span><span>Clear</span></button>
				</div>
			`);

			// Register meta template patterns for human-readable entity names
			this.pict.MetaTemplate.addPattern('{~RecordSetPageItemName:', '~}', (pHash, pData, fCallback) =>
			{
				const recordSet = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
				// Prefer the Read view's display-name heuristic (NameFirst/Last, Name, Title, …); fall back to a literal Name, then the GUID.
					return this.pict.AppData.PRSP_RecordAudit?.DisplayName || this.pict.AppData[`${recordSet}Details`]?.Name || this.pict.AppData[`${recordSet}Details`]?.[`GUID${recordSet}`];
			});
			this.pict.MetaTemplate.addPattern('{~ParsedEntityType:', '~}', (pHash, pData, fCallback) =>
			{
				const recordSet = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
				return recordSet.replace(/([a-z])([A-Z])/g, '$1 $2');
			});
			// Format a numeric value with thousands separators (e.g. 20748629 -> "20,748,629")
			this.pict.MetaTemplate.addPattern('{~CommaNumber:', '~}', (pHash, pData, fCallback) =>
			{
				const value = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
				if (value === null || typeof (value) === 'undefined' || value === '' || isNaN(Number(value)))
				{
					return (value === null || typeof (value) === 'undefined') ? '' : value;
				}
				return this.pict.DataFormat.formatterAddCommasToNumber(Math.round(Number(value)));
			});

			// Resolve a Sample.Status CODE to its friendly label for the Samples list column (and anywhere else).
			// Mirrors the LIMS resolveSampleStatusName: prefer a live customer-curated vocabulary
			// (AppData.SampleStatusVocab, if loaded), else the historical SiteManager 13-code set, else the raw code.
			const tmpSampleStatusLabels =
			{
				'N/A': 'N/A', 'LOGD': 'Logged', 'RECV': 'Received', 'INFO': 'Info', 'PREA': 'Preauthorized',
				'PEND': 'Pending', 'TEST': 'In Testing', 'TSTR': 'Test Run', 'FAIL': 'Failed',
				'FAIC': 'Failed with Comments', 'PASS': 'Passed', 'PASC': 'Passed with Comments', 'VOID': 'Voided',
			};
			this.pict.MetaTemplate.addPattern('{~SampleStatusName:', '~}', (pHash, pData, fCallback) =>
			{
				const value = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
				if (value === null || typeof (value) === 'undefined' || value === '') { return ''; }
				const tmpVocab = (this.pict.AppData && this.pict.AppData.SampleStatusVocab) || {};
				return tmpVocab[value] || tmpSampleStatusLabels[value] || String(value);
			});

			// Override the Basic layout template (default for all entities)
			this.pict.TemplateProvider.addTemplate('PRSP-Read-Basic-Template', /*html*/`
				<!-- Platform Configuration entity page template (Basic) -->
				{~T:PRSP-Read-Header-Template~}
				<div class="pcfg-record-panel">
					{~T:PRSP-Read-RecordRead-Template~}
				</div>
				<!-- End entity page template (Basic) -->
			`);

			// Match the Create page to the Read Basic panel framing (the default
			// Create template is a bare <h1> + unstyled form). Wraps the create form
			// + button bar in the same soft panel used by the read/edit views.
			this.pict.TemplateProvider.addTemplate('PRSP-Create-Basic-Template', /*html*/`
				<!-- Platform Configuration entity create template -->
				<div class="prsp-read-head"><div class="prsp-read-eyebrow">New</div><h1 class="prsp-read-title">{~ParsedEntityType:Record.RecordSet~}</h1></div>
				<div class="pcfg-record-panel">
					{~T:PRSP-Create-RecordCreate-Template~}
					{~T:PRSP-Create-RecordButtonBar-Template~}
				</div>
				<!-- End entity create template -->
			`);

			// Override the Split layout template (the default for records with connections). The record is
			// the page; its connection tabs are a right-justified strip ON TOP (.psrs-split-tabnav). The view
			// opens collapsed (record full-width); choosing a connection tab expands its editor beside the
			// record, and re-choosing it collapses back. The module's "Full Record" collapse toggle is hidden
			// in CSS (#PSRS-TabNav-FullRecord) so only connection tabs show.
			this.pict.TemplateProvider.addTemplate('PRSP-Read-Split-Template', /*html*/`
				<!-- Platform Configuration entity page template (Split) -->
				{~T:PRSP-Read-Header-Template~}
				<div class="psrs-split-tabnav">{~T:PRSP-Read-RecordTabNav-Template~}</div>
				<div class="psrs-split-view psrs-collapsed">
					<div class="psrs-left-panel column">
						<div class="pcfg-record-panel psrs-details-body">
							{~T:PRSP-Read-RecordRead-Template~}
						</div>
					</div>
					<div id="psrs-resize"><div></div></div>
					<div class="psrs-right-panel column">
						{~T:PRSP-Read-RecordTab-Template~}
					</div>
				</div>
				<!-- End entity page template (Split) -->
			`);

			this.pict.views.HeadlightPanels.setPanelConfiguration({
				PanelOptions: {
					Context: 'PlatformConfiguration',
				},
				// This app runs in application mode (not document/form mode), so the
				// bottom navbar is configured to omit the document-context buttons:
				// Solver Log, Download, and Save. The Brand button (Approval Actions
				// toggle) is kept in the config so the Brand template can still render
				// without errors, but its wrapper is hidden via `is-hidden`.
				NavBar: {
					hideNavbar: false,
					colorClass: 'is-dark',
					location: 'bottom',
					Brand: {
						id: 'HeadlightPanels-NavBar-Brand',
						name: 'Approval Actions',
						displayName: '',
						hideIcon: 'always',
						iconClass: '',
						buttonClass: 'is-hidden',
						wrapperClass: 'is-hidden',
						onclick: '',
					},
					Buttons: [
						{
							id: 'HeadlightPanels-NavBar-Help-Button',
							name: 'Documentation',
							displayName: null,
							hideIcon: null,
							iconClass: 'fa-circle-question',
							buttonClass: 'is-dark',
							wrapperClass: null,
							onclick: '_Pict.PictApplication.toggleHelp()',
						},
						{
							id: 'HeadlightPanels-NavBar-Validations-Button',
							name: 'Validation Logs',
							displayName: null,
							hideIcon: null,
							iconClass: 'fa-exclamation-triangle',
							buttonClass: 'is-dark',
							wrapperClass: null,
							onclick: '_Pict.views.HeadlightPanels.handlePanelToggle(\'Validations\')',
						},
						{
							id: 'HeadlightPanels-NavBar-FullScreen-Button',
							name: 'screenResize',
							displayName: null,
							hideIcon: null,
							iconClass: 'fa-up-right-and-down-left-from-center',
							buttonClass: 'is-dark',
							wrapperClass: 'is-hidden-mobile is-hidden-tablet-only',
							onclick: '_Pict.providers.DocumentProvider.handleScreenResize()',
						},
						{
							id: 'HeadlightPanels-NavBar-Actions-Button',
							name: 'actions',
							displayName: null,
							hideIcon: null,
							iconClass: 'fa-bars',
							buttonClass: 'is-dark',
							wrapperClass: null,
							onclick: '_Pict.views.HeadlightPanels.handlePanelToggle(\'Navigation\')',
						},
					],
				},
				CustomNavigationList: [
					{
						Hash: 'Customers',
						Name: 'Customers',
						Icon: 'fas fa-city',
						Address: '#/PSRS/Customer/List',
						PanelSource: null,
					},
					{
						Hash: 'Users',
						Name: 'Users',
						Icon: 'fas fa-users',
						Address: '#/PSRS/User/List',
						PanelSource: null,
					},
					{
						Hash: 'Projects',
						Name: 'Projects',
						Icon: 'fas fa-folder-open',
						Address: '#/PSRS/Project/List',
						PanelSource: null,
					},
					{
						Hash: 'Roles',
						Name: 'Roles',
						Icon: 'fas fa-user-shield',
						Address: '#/PSRS/Role/List',
						PanelSource: null,
					},
					{
						Hash: 'ObservationTypes',
						Name: 'Observation Types',
						Icon: 'fas fa-clipboard-check',
						Address: '#/PSRS/ObservationManifest/List',
						PanelSource: null,
					},
					{
						Hash: 'Organizations',
						Name: 'Organizations',
						Icon: 'fas fa-building',
						Address: '#/PSRS/Organization/List',
						PanelSource: null,
					},
					{
						Hash: 'DocumentTypes',
						Name: 'Document Types',
						Icon: 'fas fa-file-lines',
						Address: '#/PSRS/ReportNamedInstance/List',
						PanelSource: null,
					},
					{
						Hash: 'ObservationTags',
						Name: 'Observation Tags',
						Icon: 'fas fa-tags',
						Address: '#/PSRS/ObservationTag/List',
						PanelSource: null,
					},
					{
						Hash: 'Settings',
						Name: 'Settings',
						Icon: 'fas fa-cog',
						Address: null,
						PanelSource: 'settings',
					},
				],
			});

			this._updateUserProfile();

			this.pict.providers.PlatformConfigurationRouter.initialize();
			this.pict.providers.RecordSetRouter.initialize();

			this.pict.views.HeadlightLogin.isUserLoggedIn((error, loggedIn) =>
			{
				if (error)
				{
					this.pict.log.error(`Error checking login status: ${error.message || error}`, { error });
				}
				if (!loggedIn)
				{
					// Reveal the login page by dismissing the boot splash. When the user
					// IS logged in we deliberately leave the splash up: route resolution
					// and the first view render replace the container content (removing
					// the splash) exactly when content is ready, so the user sees one
					// continuous splash instead of a hide-then-reshow flicker.
					this.pict.ContentAssignment.addClass('.is-loading-splash', 'is-hidden');
					this.pict.views.HeadlightLogin.customizeLoginPage(customLoginPageOptions);
					this.pict.views.HeadlightLogin.show();
				}
				else
				{
					this.onAfterLogin().catch((error) =>
					{
						this.pict.log.error(`Error loading data after login: ${error.message || error}`, { error });
					});
				}
				super.onAfterInitializeAsync(fCallback);
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error initializing Platform Configuration: ${error.message || error}`);
			super.onAfterInitializeAsync(fCallback);
		}
	}

	onAfterLoginAsync(fCallback)
	{
		super.onAfterLoginAsync(async (pError) =>
		{
			try
			{
				// onAfterLoginAsync runs on EVERY loginAsync() pass — the initial boot, an interactive
				// login, AND a logout (logout() calls loginAsync() to re-evaluate the now-dead session).
				// Refresh the navbar avatar/initials here so the chrome always matches the live session.
				// Previously _updateUserProfile() ran only at page-load init, so logging out and back in as
				// a different user left the prior user's initials in the header until a manual reload.
				this._updateUserProfile();
				if (!this.loggedIn)
				{
					// Logged out: arm onAfterLogin() to run again on the next sign-in (it is one-shot per login).
					this._afterLoginPromise = null;
					this.pict.views.HeadlightLogin.customizeLoginPage(customLoginPageOptions);
				}
				else
				{
					// Run the post-login setup (recordset configs, nav-gate filter, KPI counts, doc/nav shell).
					// onAfterInitializeAsync only calls onAfterLogin() when the user is ALREADY logged in at
					// page load, so an INTERACTIVE login (the login form, or switching users) never triggered it —
					// which left Analytics unfiltered in the nav, the KPI strip empty, and PSRS recordset configs
					// unloaded until a manual reload. Run it here too; it self-guards to once per login and must
					// complete before the PSRS routes are registered + resolved below.
					await this.onAfterLogin();

					this.pict.providers.RecordSetRouter.addRoutes(this.pict.providers.RecordSetRouter.pictRouter);

					// Master Lists: load the cascading per-list configuration (merged Global -> Customer -> Project -> User) and apply it to
					// the live recordset configs before the first route renders, so a deep-linked list
					// shows its curated columns immediately.
					try
					{
						await this.pict.providers.MasterListRegistry.loadAndApplyAllAsync();
					}
					catch (pMasterListError)
					{
						this.pict.log.error(`Master list config load failed: ${pMasterListError.message || pMasterListError}`);
					}

					// Master-list associations: register the join definitions so the Material / PayItem /
					// Test Specification read views show their association editor tabs (pict-section-recordset
					// >= 1.17). The API stamps the tenant (IDCustomer) onto each join from the session.
					try
					{
						const tmpAssociationManager = this.pict.providers.RecordSetAssociationManager;
						if (tmpAssociationManager)
						{
							Object.keys(libMasterListAssociations.ASSOCIATIONS).forEach((pKey) =>
							{
								tmpAssociationManager.addAssociation(pKey, libMasterListAssociations.ASSOCIATIONS[pKey]);
							});

							// Project <-> ObservationManifest: the showcase for the new PSRS capabilities — a
							// NAME-keyed side (the join references the manifest by ObservationManifestName), a RICH
							// join (per-row Journal/Spreadsheet/Ordinal config), and an overridable defaults hook.
							tmpAssociationManager.addAssociation('ProjectObservationManifest',
								{
									JoinEntity: 'ProjectObservationManifestJoin',
									JoinURLPrefix: '/1.0/',
									JoinEditableFields:
									[
										{ Field: 'Journal', Label: 'Journal', Type: 'checkbox' },
										{ Field: 'Spreadsheet', Label: 'Spreadsheet', Type: 'checkbox' },
										{ Field: 'Ordinal', Label: 'Order', Type: 'number' },
									],
									SideA: { RecordSet: 'Project', IDField: 'IDProject', DisplayField: 'Name', SearchFields: [ 'Name', 'Status' ], Title: 'Project' },
									SideB: { RecordSet: 'ObservationManifest', IDField: 'Name', JoinField: 'ObservationManifestName', DisplayField: 'DisplayName', SearchFields: [ 'Name', 'DisplayName' ], Title: 'Observation Type' },
									// The overridable defaults seam: seed a project from its customer's default manifest
									// set (the IDProject=0 rows), carrying each one's Journal/Spreadsheet/Ordinal config.
									// This is directional — it only makes sense anchored on a Project ("seed this project
									// with its default types"); anchored on a type the question ("seed which projects?") has no
									// sensible answer, so synthesis is a no-op there (and the editor hides the button via
									// AllowSynthesize:false on the manifest-side instance).
									SynthesizeDefaults: async (pContext) =>
									{
										if (!pContext.thisSide || (pContext.thisSide.RecordSet !== 'Project')) { return []; }
										const tmpRestClient = pContext.pict.fable.HeadlightRestClient || pContext.pict.HeadlightRestClient;
										const fGet = (pURL) => new Promise((resolve) => { tmpRestClient.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody)); });
										const tmpProject = await fGet(`Project/${pContext.thisID}`);
										const tmpCustomer = (tmpProject && (tmpProject.IDCustomer != null)) ? tmpProject.IDCustomer : 0;
										let tmpDefaults = await fGet(`ProjectObservationManifestJoins/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~${tmpCustomer}`);
										if (!Array.isArray(tmpDefaults) || (tmpDefaults.length === 0))
										{
											tmpDefaults = await fGet('ProjectObservationManifestJoins/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~0');
										}
										return (Array.isArray(tmpDefaults) ? tmpDefaults : []).map((pJoin) =>
											({ value: pJoin.ObservationManifestName, joinValues: { Journal: pJoin.Journal, Spreadsheet: pJoin.Spreadsheet, Ordinal: pJoin.Ordinal, Priority: pJoin.Priority } }));
									},
								});

							// User <-> Project: the user's project assignments (ProjectUserJoin). Anchored on the
							// User side in the bespoke User workspace's Projects tab. Plain link/unlink for v1 — the
							// API stamps IDCustomer from the session; the project role (IDRole) is not edited here yet.
							tmpAssociationManager.addAssociation('ProjectUser',
								{
									JoinEntity: 'ProjectUserJoin',
									JoinURLPrefix: '/1.0/',
									SideA: { RecordSet: 'Project', IDField: 'IDProject', DisplayField: 'Name', SearchFields: [ 'Name', 'Status' ], Title: 'Project' },
									SideB: { RecordSet: 'User', IDField: 'IDUser', DisplayField: 'NameLast', SearchFields: [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ], ChipFields: [ 'NameFirst', 'Email' ], Title: 'User' },
								});

							// (Project <-> Equipment is a TERNARY join — ProjectEquipmentJoin carries IDProject + IDEquipment +
							// IDOrganization, used many-to-many. It is NOT an association-editor tab: the Connections ▸ Equipment
							// tab is the ProjectContractorMatrixEquipment M:N grid instead, so no addAssociation is registered.)

							// Personnel (ProjectContactJoin): the GENERATED ContactProject association keys the Contact
							// side on 'Title' (DisplayField + SearchFields), but Title is a job-title descriptor that is
							// frequently blank (e.g. LADOTD certified-payroll "crew" contacts) — so the picker would
							// search job titles (a last-name search returns nothing) and every current-personnel row
							// would render as "#<id>". Override the Contact side to display + search by NAME (NameFull,
							// falling through NameFirst/NameLast on search), with Title as a disambiguation chip —
							// mirroring the ProjectUser registration. Project stays on SideB (the Personnel tab anchors
							// on Project); addAssociation replaces the generated entry by hash.
							tmpAssociationManager.addAssociation('ContactProject',
								{
									JoinEntity: 'ProjectContactJoin',
									JoinURLPrefix: '/1.0/',
									SideA: { RecordSet: 'Contact', IDField: 'IDContact', DisplayField: 'NameFull', SearchFields: [ 'NameFull', 'NameFirst', 'NameLast', 'Email' ], ChipFields: [ 'Title' ], Title: 'Personnel' },
									SideB: { RecordSet: 'Project', IDField: 'IDProject', DisplayField: 'Name', SearchFields: [ 'Name', 'Status' ], Title: 'Project' },
								});

							// AASHTO element type <-> defect (PhysicalAssetElementTypePhysicalAssetDefectJoin): which defects apply to
							// an element type. The catalog Sync (#/AssetCatalogSync) seeds this join from the public lake; this tab
							// surfaces it and lets an admin add/remove links. Plain link/unlink — the base association editor handles it.
							tmpAssociationManager.addAssociation('PhysicalAssetElementTypeDefect',
								{
									JoinEntity: 'PhysicalAssetElementTypePhysicalAssetDefectJoin',
									JoinURLPrefix: '/1.0/',
									SideA: { RecordSet: 'PhysicalAssetElementType', IDField: 'IDPhysicalAssetElementType', DisplayField: 'Name', SearchFields: [ 'Name', 'Code', 'Section' ], ChipFields: [ 'Code' ], Title: 'Element Type' },
									SideB: { RecordSet: 'PhysicalAssetDefect', IDField: 'IDPhysicalAssetDefect', DisplayField: 'Name', SearchFields: [ 'Name', 'Code' ], ChipFields: [ 'Code' ], Title: 'Defect' },
								});

							// LineItem <-> Organization: the "Organizations" tab on a Line Item read view (associating a
							// Contractor to a line item). Registered INLINE to OVERRIDE the generated plain association of
							// the same hash (addAssociation replaces by hash; the generated read-tab still points at it), so
							// the Organization picker can (2) show each org's IDOrganization to disambiguate same-named
							// contractors, and (1) float THIS line item's project Prime Contractor (Project.IDOrganization)
							// to the top of the list. The pin needs runtime context (the anchor line item -> its project),
							// so it closes over the app REST client here — like ProjectUser / ProjectObservationManifest.
							tmpAssociationManager.addAssociation('LineItemOrganization',
								{
									JoinEntity: 'LineItemOrganizationJoin',
									JoinURLPrefix: '/1.0/',
									SideA: { RecordSet: 'LineItem', IDField: 'IDLineItem', DisplayField: 'Name', SearchFields: [ 'Name', 'ItemNumber' ],
										TableColumns: [ { Key: 'ItemNumber', DisplayName: 'Item Number' }, { Key: 'Name', DisplayName: 'Name' }, { Key: 'Quantity', DisplayName: 'Quantity' } ] },
									SideB:
									{
										RecordSet: 'Organization', IDField: 'IDOrganization', DisplayField: 'Name', SearchFields: [ 'Name', 'Type', 'VendorCode' ],
										TableColumns: [ { Key: 'Name', DisplayName: 'Name' }, { Key: 'VendorCode', DisplayName: 'Vendor Code' }, { Key: 'Type', DisplayName: 'Type' } ],
										// (2) The Organization's Vendor Code, shown as a chip after the name on each picker option AND
										// each current-association row — many contractors share similar names, so the code disambiguates.
										// (Matches the app-wide Organization identifier chip; see Association-Chip-Decoration.js.)
										ChipFields: [ { Field: 'VendorCode', Label: 'Vendor' } ],
										// (1) Pin the project's Prime Contractor to the top of the add-picker's browse list. The
										// anchor is the Line Item (pContext.ThisID); walk LineItem -> its Project -> IDOrganization.
										PriorityValues: async (pContext) =>
										{
											const tmpAnchorID = pContext && pContext.ThisID;
											if ((tmpAnchorID === undefined) || (tmpAnchorID === null) || (tmpAnchorID === '')) { return []; }
											const tmpRestClient = pContext.pict.fable.HeadlightRestClient || pContext.pict.HeadlightRestClient;
											if (!tmpRestClient) { return []; }
											const fGet = (pURL) => new Promise((resolve) => { tmpRestClient.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody)); });
											const tmpLineItem = await fGet(`LineItem/${tmpAnchorID}`);
											const tmpIDProject = tmpLineItem && tmpLineItem.IDProject;
											if (!tmpIDProject) { return []; }
											const tmpProject = await fGet(`Project/${tmpIDProject}`);
											const tmpPrime = tmpProject && tmpProject.IDOrganization;
											return ((tmpPrime !== undefined) && (tmpPrime !== null) && (Number(tmpPrime) > 0)) ? [ Number(tmpPrime) ] : [];
										},
									},
								});

								// Material <-> Organization: the "Organizations" tab on a Material read view. The join
								// (OrganizationMaterialJoin) carries an ExpirationDate the base editor already flags with a
								// read-only "Expired" badge; expose it as an inline-editable `date` on each relationship row
								// so a user can set / update / backfill that expiration. The generated association is a plain
								// link, so we enrich the already-registered definition in place rather than restating its
								// sides; the custom editor subclass (registered with the bespoke view tabs below) renders the
								// `date` kind the base editor does not know.
								const tmpMaterialOrgAssociation = tmpAssociationManager.getAssociation('MaterialOrganization');
								if (tmpMaterialOrgAssociation)
								{
									tmpMaterialOrgAssociation.JoinEditableFields = [ { Field: 'ExpirationDate', Label: 'Expires', Type: 'date' } ];
								}

								// Project <-> Organization (ProjectOrganizationJoin): the "Contractors" tab on the bespoke
								// Project workspace — link external organizations (contractors) to a project. The generated
								// OrganizationProject association is a plain link; enrich it in place so (a) the join's
								// DisadvantagedBusiness boolean is an inline "DBE" checkbox per row, and (b) the Organization
								// picker is findable by vendor code and disambiguated by it (many contractors share names).
								const tmpOrgProjectAssociation = tmpAssociationManager.getAssociation('OrganizationProject');
								if (tmpOrgProjectAssociation)
								{
									tmpOrgProjectAssociation.JoinEditableFields = [ { Field: 'DisadvantagedBusiness', Label: 'DBE', Type: 'checkbox' } ];
									if (tmpOrgProjectAssociation.SideA)
									{
										tmpOrgProjectAssociation.SideA.SearchFields = [ 'Name', 'VendorCode', 'Type' ];
										tmpOrgProjectAssociation.SideA.ChipFields = [ { Field: 'VendorCode', Label: 'Code' } ];
									}
								}
						}
					}
					catch (pAssociationError)
					{
						this.pict.log.error(`Master list association registration failed: ${pAssociationError.message || pAssociationError}`);
					}

					// Identifier chips on EVERY association (after all associations are registered above):
					// (A) give each side a default code chip (Material Code / Item Code / Vendor Code / …) so
					// similarly-named records are distinguishable in the inline current-associations list AND the
					// add-picker; (B) extend the add-picker's user-selectable ⚙ field-decoration choice to the
					// current-associations list rows (one per-entity choice decorates both). App-local; best-effort.
					try
					{
						const tmpChipManager = this.pict.providers.RecordSetAssociationManager;
						if (tmpChipManager)
						{
							libAssociationChipDecoration.applyDefaultAssociationChips(tmpChipManager);
							libAssociationChipDecoration.patchAssociationListDecoration(tmpChipManager);
						}
					}
					catch (pChipError)
					{
						this.pict.log.error(`Association chip decoration setup failed: ${pChipError.message || pChipError}`);
					}

					// Users list "Role" filter → full role-membership union (base User.IDRole + UserRoleJoin +
					// UserContextRole). Patches the User record provider to expand the marked membership clause at
					// fetch time; best-effort (degrades to the stock UserRoleJoin filter if it can't patch).
					try
					{
						libUserRoleMembershipFilter.patchUserRoleMembershipFilter(this.pict);
					}
					catch (pRoleFilterError)
					{
						this.pict.log.error(`User role-membership filter patch failed: ${pRoleFilterError.message || pRoleFilterError}`);
					}

					// Read-view tab strip -> shared TabBar look: rewrite the generic read view's tab templates so
					// EVERY master-list read view gets the compact underline tabs + icons + scroll overflow the
					// bespoke workspaces already have (paired with the CSS injected in the read-page CSS block).
					// One patch lifts all generic read entities at once; setTab is untouched (buttons keep .psrs-tab + id).
					try
					{
						const tmpReadView = this.pict.views['RSP-RecordSet-Read'];
						if (tmpReadView)
						{
							libReadViewTabBarDecoration.patchReadViewTabBar(tmpReadView);
							// Overflow -> "More" dropdown (the shared TabBar menu strategy the bespoke workspaces use)
							// so tabs that don't fit stay reachable instead of scrolling off unreachably.
							libReadViewTabBarDecoration.wrapReadViewMenuOverflow(tmpReadView, libTabBar);
						}
					}
					catch (pReadTabError)
					{
						this.pict.log.error(`Read-view tab-bar decoration setup failed: ${pReadTabError.message || pReadTabError}`);
					}

					// FK child-list tabs — register one ChildListTab view instance per (parent, child, FK)
					// relationship the connection graph surfaces, so the read view's { Type: 'View' } child-list
					// tabs (emitted by MasterList-Builder) resolve. Registered from the full generated set (not
					// just the seed defaults) so a GUI-enabled child list always has its view ready.
					try
					{
						const tmpEntityConnections = libConnectionsGenerated.EntityConnections || {};
						Object.keys(tmpEntityConnections).forEach((pEntity) =>
						{
							(tmpEntityConnections[pEntity].ChildLists || []).forEach((pChild) =>
							{
								const tmpViewID = libMasterListBuilder.childListViewId(pEntity, pChild);
								if (this.pict.views[tmpViewID]) { return; }
								this.pict.addView(tmpViewID, Object.assign({}, libChildListTab.default_configuration,
									{
										ViewIdentifier: tmpViewID,
										ParentRecordSet: pEntity,
										ChildRecordSet: pChild.RecordSet,
										FilterField: pChild.FilterField,
										BaseField: `ID${ pEntity }`,
										DisplayField: pChild.DisplayField,
										Columns: pChild.Columns,
										ChipFields: pChild.ChipFields,
										Title: pChild.Title
									}), libChildListTab);
							});
						});
					}
					catch (pChildListError)
					{
						this.pict.log.error(`Child-list tab registration failed: ${pChildListError.message || pChildListError}`);
					}

					// Bespoke "view" read tabs (Type:'View' tabs pointing at a hand-written view rather than a
					// ChildListTab). SpecSetMaterials shows the materials transitively reachable from a Test
					// Specification Set's specs; MaterialSpecSets is its reciprocal — the specification sets a
					// material's specs belong to — see Headlight-MasterLists ViewTabs on TestSpecificationSet / Material.
					try
					{
						if (!this.pict.views['SpecSetMaterials'])
						{
							this.pict.addView('SpecSetMaterials', Object.assign({}, libSpecSetMaterialsTab.default_configuration), libSpecSetMaterialsTab);
						}
						if (!this.pict.views['MaterialSpecSets'])
						{
							this.pict.addView('MaterialSpecSets', Object.assign({}, libMaterialSpecSetsTab.default_configuration), libMaterialSpecSetsTab);
						}
						// The Organization view's Split-layout "Addresses" tab: a master/detail editor for the org's
						// OrganizationAddress children (click a row to edit its form in the right panel).
						if (!this.pict.views['OrganizationAddresses'])
						{
							this.pict.addView('OrganizationAddresses', Object.assign({}, libOrganizationAddressTab.default_configuration), libOrganizationAddressTab);
						}
						// The Material↔Organization relationship tab (Material read view's "Organizations", and the
						// reciprocal Organization read view's "Materials"): a RecordSet-AssociationEditor subclass
						// that adds an inline date editor for each relationship's ExpirationDate (set / update /
						// backfill / clear). The association is symmetric — its ExpirationDate JoinEditableField
						// applies to both sides — so register the subclass for each anchor recordset. Pre-registered
						// under the hash the read view derives for the tab so it is reused instead of the plain base
						// editor (RecordSet-Read._buildValidTabs only creates one when absent).
						[ 'Material', 'Organization' ].forEach((pThisRecordSet) =>
						{
							const tmpEditorHash = `RSP-AssocEditor-${ pThisRecordSet }-MaterialOrganization`;
							if (!this.pict.views[tmpEditorHash])
							{
								this.pict.addView(tmpEditorHash,
									Object.assign({}, libMaterialOrgAssociationEditor.default_configuration,
										{
											ViewIdentifier: tmpEditorHash,
											AssociationHash: 'MaterialOrganization',
											ThisRecordSet: pThisRecordSet,
											PickerMode: 'single',
										}), libMaterialOrgAssociationEditor);
							}
						});
					}
					catch (pViewTabError)
					{
						this.pict.log.error(`View-tab registration failed: ${pViewTabError.message || pViewTabError}`);
					}

					// Record preview cards: register the config-driven mini-card layouts so every foreign-key
					// reference to these entities (Customer, Project, Contract, Organization, User, …) renders
					// as a clickable popover card in list + read views; association-row names pick them up too.
					try
					{
						const tmpCardManager = this.pict.providers.RecordSetCardManager;
						if (tmpCardManager)
						{
							Object.keys(libPlatformRecordCards.RECORD_CARDS).forEach((pKey) =>
							{
								tmpCardManager.registerCard(pKey, libPlatformRecordCards.RECORD_CARDS[pKey]);
							});
							// Rich cards (the Data Explorer) checkbox-render schema booleans — give the card manager a
							// way to resolve an entity's column types through the authenticated REST client.
							tmpCardManager.SchemaSource = (pEntity, fCallback) => this.pict.fable.HeadlightRestClient.getJSON(`${pEntity}/Schema`, fCallback);
						}
					}
					catch (pRecordCardError)
					{
						this.pict.log.error(`Record card registration failed: ${pRecordCardError.message || pRecordCardError}`);
					}

					// Every route (application + PSRS) is now registered. Resolve the
					// current browser hash exactly once so a deep-linked route loads
					// directly, falling back to the default route only when no hash is
					// present — the initial route is never rendered ahead of it.
					this.pict.providers.PlatformConfigurationRouter.resolveCurrentRoute();
				}
			}
			catch (error)
			{
				this.pict.log.error(`Error during onAfterLoginAsync: ${error.message || error}`);
			}
			finally
			{
				fCallback(pError);
			}
		});
	}

	/**
	 * Show the user profile panel
	 */
	showProfile()
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Profile', 'open');
	}

	/**
	 * Update the user profile display in the navbar
	 */
	_updateUserProfile()
	{
		const session = this.AppData.CurrentUser;
		if (session?.LoggedIn)
		{
			let userHash = session.LoginID;
			if (!userHash)
			{
				userHash = session.Email;
			}
			if (!userHash)
			{
				userHash = `${session.NameFirst} ${session.NameLast}`;
			}
			if (!userHash)
			{
				userHash = 'no user name';
			}
			const userColor = this.pict.providers.UtilityProvider.stringToHSLColor(userHash, 75, 50);
			this.pict.ContentAssignment.setAttribute('#Header_ProfileIcon', 'style', `color: ${userColor};`);
			this.pict.ContentAssignment.assignContent('#Header_ProfileName', `${session.NameFirst.charAt(0)}${session.NameLast.charAt(0)}`);
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#Header_ProfileIcon', 'style', '');
			this.pict.ContentAssignment.assignContent('#Header_ProfileName', 'Profile');
		}
		this._syncSuperUserShell();
	}

	/**
	 * Reflect the level-5 super-user state in the app chrome: show the "Level 5" badge, hide the standard top-nav
	 * topic links, and reveal the two super-user destinations (Manage Customers + Grant Access). Runs on every
	 * profile update (login + user switch). UI only — the server stays authoritative. The single level check is
	 * _isSuperUser() (kept in one place, per the forward-compatibility note).
	 */
	_syncSuperUserShell()
	{
		if (typeof document === 'undefined') { return; }
		const tmpSuper = this._isSuperUser();
		const tmpBadge = document.getElementById('Header_SuperUserBadge');
		if (tmpBadge) { tmpBadge.classList.toggle('is-hidden', !tmpSuper); }
		document.querySelectorAll('.pc-topnav-standard').forEach((pElement) => pElement.classList.toggle('is-hidden', tmpSuper));
		document.querySelectorAll('.pc-topnav-super').forEach((pElement) => pElement.classList.toggle('is-hidden', !tmpSuper));
		// Customer Support is a top-level destination for anyone who can use the Support console (super-users +
		// Support-Agent / Support-Manage holders) — not just level-5, so support staff get it prominently too.
		const tmpEP = this.fable.EffectivePermissionsService;
		const tmpCanSupport = tmpSuper || !tmpEP || (typeof tmpEP.canHash === 'function' && (tmpEP.canHash('Support-Agent') || tmpEP.canHash('Support-Manage') || tmpEP.canHash('Document-Update')));
		document.querySelectorAll('.pc-topnav-support').forEach((pElement) => pElement.classList.toggle('is-hidden', !tmpCanSupport));
	}

	onInteractiveLogin()
	{
		// headlight-view-login already calls PictApplication.loginAsync() on a successful
		// authenticate, and THEN calls this onInteractiveLogin() hook. Calling loginAsync()
		// again here would run the entire login -> data-load -> route-resolve cycle a SECOND
		// time; the second cycle's main-viewport render (Empty) lands after resolveCurrentRoute
		// and blanks the screen. So this hook only paints a loading splash while that single
		// login cycle runs — route resolution is owned by onAfterLoginAsync -> resolveCurrentRoute(),
		// which honors the deep-linked hash.
		this.pict.ContentAssignment.assignContent('#PlatformConfiguration-Application-Container', `<div class="is-loading-splash"><h1 class="title">Loading...</h1></div>`);
	}

	/**
	 * Run the post-login setup once per sign-in. Called from BOTH onAfterInitializeAsync (page load when already
	 * signed in, not awaited) and onAfterLoginAsync (every login pass, awaited before the route resolves). Every
	 * caller gets the SAME run, so the login pass waits for the setup already in flight: returning early instead let
	 * the first page paint before the nav permission gate was installed, listing entries the user can't open.
	 * Re-armed on logout (onAfterLoginAsync's not-logged-in branch).
	 * @return {Promise<void>}
	 */
	onAfterLogin()
	{
		if (!this._afterLoginPromise)
		{
			this._afterLoginPromise = this._runAfterLogin();
		}
		return this._afterLoginPromise;
	}

	/**
	 * The post-login setup itself; reached only through onAfterLogin().
	 * @return {Promise<void>}
	 */
	async _runAfterLogin()
	{
		this._updateUserProfile();

		// Permission-expression layer (Phase 2): resolve the current user's capability map ONCE, before the
		// recordset configs load + the nav gate installs below, so create buttons + nav entries can be gated
		// synchronously. Fail-open on error (the service leaves its cache un-ready → gates show everything);
		// the server stays authoritative regardless.
		const tmpEffectivePermissions = this.fable.EffectivePermissionsService;
		const tmpCurrentUser = (this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		if (tmpEffectivePermissions && tmpCurrentUser.UserID)
		{
			try
			{
				await tmpEffectivePermissions.loadCurrentUserAsync(tmpCurrentUser.UserID, tmpCurrentUser.CustomerID);
			}
			catch (pError)
			{
				this.pict.log.warn(`Could not resolve current-user capabilities for UI gating: ${pError && pError.message ? pError.message : pError}`);
			}
		}

		if (!(await this._microAppAccessAllowedAsync()))
		{
			return;
		}

		// Work out which inspections belong to this session BEFORE any screen fetches, so a field user
		// never sees the whole program paint and then narrow. Never fatal: the service fails closed on
		// its own and reports it through the scope object.
		const tmpInspectionScope = this.pict.providers.InspectionScope;
		if (tmpInspectionScope)
		{
			try { await tmpInspectionScope.resolveAsync(); }
			catch (pError) { this.pict.log.warn(`Could not resolve the inspection scope: ${ pError && pError.message ? pError.message : pError }`); }
		}

		// Stamp the list "+ New" create-button gate onto the LIVE record-set configs. The providers are
		// registered from `fable.settings.DefaultRecordSetConfigurations` during MetaController init — BEFORE the
		// effective-permissions map is available — and each config is COPIED at registration, so mutating the
		// source options array (below) never reaches the live providers. The list title template reads
		// `Record.RecordSetConfiguration.RecordSetListShowCreateButton`, which resolves to the MetaController's
		// `recordSetProviderConfigurations[<RecordSet>]` (getRecordSetConfiguration). Fill in only the configs that
		// have NOT already decided the flag (a hand-written literal like Organization, or the master-list registry,
		// sets an explicit true/false — honor those); everything else is gated by can(entity,'Create').
		const tmpRecordSetService = this.pict.services && this.pict.services.PictSectionRecordSet;
		if (tmpEffectivePermissions && tmpRecordSetService && tmpRecordSetService.recordSetProviderConfigurations)
		{
			Object.keys(tmpRecordSetService.recordSetProviderConfigurations).forEach((pRecordSet) =>
			{
				const tmpConfig = tmpRecordSetService.recordSetProviderConfigurations[pRecordSet];
				if (!tmpConfig || typeof tmpConfig.RecordSetListShowCreateButton === 'boolean')
				{
					return;
				}
				tmpConfig.RecordSetListShowCreateButton = tmpEffectivePermissions.can(pRecordSet, 'Create');
			});
		}

		// Form-mode UI elements (Save/Solver/Download buttons + Brand/Approval-Actions
		// toggle) are excluded at the HeadlightPanels configuration level via the
		// NavBar override passed to setPanelConfiguration() above. This app runs in
		// application mode, not document/form mode, so those buttons are not rendered.

		// Load recordset configurations for PSRS entities. Route resolution is
		// deferred to onAfterLoginAsync (after the PSRS routes are registered), so
		// no navigation happens here — that is what kept the default route from
		// rendering ahead of a deep-linked route.
		if (Array.isArray(this.options.DefaultRecordSetConfigurations))
		{
			// Whole-row click opens the record's View (with a "⋯" actions menu revealed on row hover) across
			// every config-app list. This is opt-in per record set via the recordset module's
			// RowClickOpensRecord flag; set it here rather than on each of the ~20 literals so they all get the
			// interaction. A config can still opt out by declaring RowClickOpensRecord:false in its own literal.
			this.options.DefaultRecordSetConfigurations.forEach((pRecordSetConfiguration) =>
			{
				if (!pRecordSetConfiguration || typeof pRecordSetConfiguration !== 'object')
				{
					return;
				}
				if (!('RowClickOpensRecord' in pRecordSetConfiguration))
				{
					pRecordSetConfiguration.RowClickOpensRecord = true;
				}
				// Permission-expression layer (Phase 2): gate the list "New" button by the current user's
				// create right. The button lives in ImprovedTabularRecordSetProvider's title template, which
				// reads this flag off the entity's own config (Record.RecordSetConfiguration) — reliable
				// regardless of route timing. An explicit `false` in a literal is honored as an opt-out.
				if (tmpEffectivePermissions && pRecordSetConfiguration.RecordSet)
				{
					pRecordSetConfiguration.RecordSetListShowCreateButton = (pRecordSetConfiguration.RecordSetListShowCreateButton === false)
						? false
						: tmpEffectivePermissions.can(pRecordSetConfiguration.RecordSet, 'Create');
				}
			});
			this.pict.services.PictSectionRecordSet.loadRecordSetConfigurationArray(this.options.DefaultRecordSetConfigurations);
		}

		// ContractType / ProjectType editor: bind the PSRS providers through the
		// Settings adapter so list-shaped Settings keys round-trip as friendly
		// newline-joined text in `_DisplaySettings`. Both the manifest descriptors
		// and the user-facing inputs see the text form; the API still sees the
		// canonical Settings.* shape.
		this._installSettingsAdapterForRecordSets([ 'ContractType', 'ProjectType' ]);
		// New User creation: the generic form's "Login Password" is a raw column that POSTing does NOT turn into a
		// login credential — only POST /1.0/Password does (what "Reset Password" calls). Wire the create so it makes
		// that follow-up call automatically, so a user can sign in with the password the admin set at creation.
		this._installUserPasswordOnCreate();
		// Records with a photo field: the photo route needs a saved record, so upload a held photo after the save.
		this._installPhotoUploadAfterSave([ 'Location' ]);

		// Bring the in-app documentation online (loads the sidebar, topics, and renders the
		// doc browser into the help panel). Safe to call more than once — it self-guards.
		this._initializeHelpDocumentation();

		// bind ⌘K (launcher) + F1 (help) and dock the
		// navigation rail if the user's style is Sidebar. Self-guards against re-running.
		// Load the customer's enabled Modules (CustomerModuleJoin) AND install the nav permission gate BEFORE the
		// navigation shell renders, so the nav's FIRST paint is already filtered — no flash of hidden/ungated
		// entries before capability + module gating catches up. The current user's capability map was resolved
		// above (loadCurrentUserAsync), so EffectivePermissionsService is ready here; modules fail closed until
		// loaded; and the shell then paints the already-gated graph.
		await this.loadCustomerModulesAsync();
		this._applyCustomerNavGate();
		// Dock the rail / bind the launcher and render the (now-gated) navigation shell.
		this._initializeNavigationShell();
		// KPI counts that feed the nav-page jumbotrons (non-blocking).
		this.loadDashboardStatsAsync();
	}

	/**
	 * @returns {*} the registered inline documentation provider, or null if not present.
	 */
	get _helpProvider()
	{
		return (this.pict.providers && this.pict.providers['Pict-InlineDocumentation']) || null;
	}

	/**
	 * Where this app's documentation comes from, what it opens on, and what it calls itself.
	 *
	 * This exists because a micro app built on this one (pict-microapp) is a DIFFERENT PRODUCT to a
	 * different audience: a bridge inspector opening the Academy should not land on "Platform
	 * Configuration — Overview" and a table of contents about Pay Items and Customer Provisioning.
	 * Every place that used to hard-code 'docs/', 'overview.md' or "Headlight Academy" reads this
	 * instead, so a subclass re-points the whole documentation surface by overriding one getter.
	 *
	 * ContentHashPrefix namespaces this app's AcademyContent rows. AcademyContent has no application
	 * column, so the Hash is the only place a per-app dimension can live — two apps sharing a prefix
	 * would overwrite each other's docs on push.
	 *
	 * @returns {{DocsBaseURL:String, TopicsURL:String, LandingArticle:String, ContentHashPrefix:String, Title:String, Subtitle:String}}
	 */
	get documentationProfile()
	{
		return (
			{
				DocsBaseURL: 'docs/',
				TopicsURL: 'docs/_topics.json',
				LandingArticle: 'overview.md',
				ContentHashPrefix: 'Doc-PlatformConfig-',
				Title: 'Headlight Academy',
				Subtitle: 'Guides and reference for configuring your platform.',
			});
	}

	/**
	 * Initialize the in-app documentation browser once. Loads the sidebar and topic map named by
	 * documentationProfile, renders the browser into the help panel container, and shows the landing
	 * article. Relative URLs resolve against the app's served path, so this works regardless of the
	 * mount point.
	 */
	_initializeHelpDocumentation()
	{
		const tmpProvider = this._helpProvider;
		if (!tmpProvider || this._helpInitialized)
		{
			return;
		}
		this._helpInitialized = true;
		// Published so the Academy view and provider read the same profile the help panel does, without
		// either of them reaching back into the application class.
		this.AppData.DocumentationProfile = this.documentationProfile;
		this._createHelpPanel();

		// In-place documentation editing persists to the AcademyContent Meadow entity, keyed by a stable
		// per-doc Hash. AcademyContent is session-scoped — the server owns the tenant/default layering — so
		// a platform (Customer 1) session edits the default and any other customer edits their own override.
		// Editing is gated on the AcademyContent-Update capability (Permission-Catalog.json / entitlements).
		const tmpCanEdit = !!(this.fable.EffectivePermissionsService && this.fable.EffectivePermissionsService.can('AcademyContent', 'Update'));

		// Layer AcademyContent over the shipped static docs/: a doc resolves to its AcademyContent row
		// (customer override or platform default) when one exists, else the static file. Wrap the provider's
		// document fetch so every load path (route sync, nav clicks, in-doc links) goes through the layering.
		this._installAcademyContentDocLoader(tmpProvider);

		tmpProvider.initializeDocumentation(
			{
				DocsBaseURL: this.documentationProfile.DocsBaseURL,
				TopicsURL: this.documentationProfile.TopicsURL,
				ContainerAddress: '#InlineDoc-Container',
				EditEnabled: tmpCanEdit,
				// Document content editing persists to AcademyContent (see below). The topic↔route binding
				// editor is held back for now: topics still load from the static _topics.json, so enabling it
				// would let bindings be saved but appear to revert on reload. onTopicsSave is wired ahead of
				// layering the topics LOAD from AcademyContent (the follow-up that turns this on).
				TopicManagerEnabled: false,
				onSave: (pSaveData, fCallback) => this._saveAcademyDoc(pSaveData, fCallback),
				onTopicsSave: (pTopics, fCallback) => this._saveAcademyTopics(pTopics, fCallback),
			},
			() =>
			{
				// Load the persisted route→topic bindings before the first route sync so a route-bound topic
				// resolves on open. Show the overview by default, then sync to the current route if the panel is
				// open. Skip the overview preload on an AcademyContent-help route so its async fetch can't land over
				// the doc that updateHelpForRoute is about to drive into the panel (updateHelpForRoute shows a
				// loading state immediately, so the panel is never blank).
				this._loadRouteBindingsAsync(() =>
				{
					const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
					if (!this._helpHashForRoute(tmpHash.replace(/^#/, '') || '/'))
					{
						tmpProvider.loadDocument(this.documentationProfile.LandingArticle);
					}
					this.updateHelpForRoute();
				});
			});
	}

	/** The HeadlightRestClient (Meadow REST over the /1.0 API) used for AcademyContent persistence. */
	get _academyRestClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	/** Stable AcademyContent Hash for a documentation path — namespaced so help docs never collide with
	 *  other AcademyContent producers (e.g. the Sample Plan MSM docs) or with another app's doc set. */
	_academyDocHash(pPath)
	{
		return `${ this.documentationProfile.ContentHashPrefix }${ String(pPath || '').replace(/^\/+/, '') }`;
	}

	/**
	 * Read a doc's markdown by Hash, or null when no row exists. Callback: (error, markdown|null).
	 *
	 * Goes through the bespoke `PlatformDocument/:Hash` endpoint — the SAME route the F1/? area docs use —
	 * which reads the canonical customer-1 copy plus the caller's own override and prefers the override,
	 * for any authenticated session regardless of tenant.
	 *
	 * This used to be a plain Meadow read (`AcademyContents/FilteredTo/...`), which was wrong twice over
	 * and failed silently both times — a doc that will not load falls back to the shipped static file, so
	 * the page still renders and nothing looks broken.
	 *
	 * First, that route is TENANT-SCOPED. Measured on QA as a customer-117 session: an exact-Hash read
	 * returns only that customer's own rows, so Headlight's canonical customer-1 documentation could
	 * never reach a tenant through it, no matter what was pushed. Every logged-in user is supposed to
	 * get help; only this endpoint delivers that, and it is already proven to — PlatformDocumentIndex
	 * serves customer-1 rows to customer-117 sessions today.
	 *
	 * Second, the old hashes carried a '/' ('PlatformConfigDoc/overview.md'). URL-encoded into a
	 * FilteredTo segment the %2F breaks the filter, and the server answers HTTP 200 with
	 * {Error:'UNAUTHORIZED ACCESS IS NOT ALLOWED', ErrorCode:405} — the same shape it uses to refuse a
	 * broad table read. So every academy doc lookup failed on the hash alone. Hence 'Doc-<App>-' with no
	 * separator that needs escaping.
	 *
	 * The endpoint is namespace-gated to hashes beginning 'Doc-', which is why the app doc prefixes are
	 * 'Doc-<App>-' — and why they carry no '/', since the Hash travels in a path parameter.
	 */
	_loadAcademyDoc(pHash, fCallback)
	{
		const tmpClient = this._academyRestClient;
		if (!tmpClient) { return fCallback(null, null); }
		tmpClient.getJSON(`PlatformDocument/${ encodeURIComponent(pHash) }`, (pError, pBody) =>
		{
			if (pError) { return fCallback(pError, null); }
			// The endpoint answers {} when no row exists for the hash — that is "fall back to the file".
			const tmpContent = (pBody && typeof pBody === 'object' && !Array.isArray(pBody)) ? pBody.Content : null;
			return fCallback(null, (typeof tmpContent === 'string' && tmpContent.length) ? tmpContent : null);
		});
	}

	/**
	 * Wrap the inline-doc provider's _fetchDocument so an AcademyContent doc (override/default) wins over
	 * the shipped static file, with the static file as the fallback. Idempotent. Only .md documents are
	 * layered; images and other assets pass straight through to the static server.
	 */
	_installAcademyContentDocLoader(pProvider)
	{
		if (pProvider._academyLoaderInstalled) { return; }
		pProvider._academyLoaderInstalled = true;
		const tmpBaseFetch = pProvider._fetchDocument.bind(pProvider);
		pProvider._fetchDocument = (pURL, fCallback) =>
		{
			const tmpCb = (typeof fCallback === 'function') ? fCallback : () => {};
			if (pProvider._ContentCache[pURL]) { return tmpCb(null, pProvider._ContentCache[pURL].html); }
			if (!/\.md($|[?#])/.test(String(pURL || ''))) { return tmpBaseFetch(pURL, tmpCb); }
			const tmpPath = String(pURL || '').replace(/^docs\//, '');
			this._loadAcademyDoc(this._academyDocHash(tmpPath), (pError, pMarkdown) =>
			{
				if (pError || pMarkdown == null) { return tmpBaseFetch(pURL, tmpCb); }
				const tmpHTML = pProvider._ContentProvider.parseMarkdown(pMarkdown, pProvider._createLinkResolver(), pProvider._createImageResolver(pURL), pProvider._VocabularyResolver);
				pProvider._ContentCache[pURL] = { html: tmpHTML, markdown: pMarkdown };
				return tmpCb(null, tmpHTML);
			});
		};

		// Layer the SIDEBAR (TOC) and TOPICS (route→doc map) the same way as bodies: an AcademyContent row
		// (PlatformConfigDoc/_sidebar.md, PlatformConfigDoc/_topics.json — session-scoped, so customer-1 = platform
		// default) wins over the shipped static file. This makes the whole doc set — structure included — publishable
		// to a tenant/platform purely as data (an hldi comprehension of AcademyContent upserts), no app deploy. Falls
		// back to the static file whenever no row exists (so local dev + un-seeded environments are unchanged).
		const tmpBaseSidebar = pProvider._loadSidebar.bind(pProvider);
		pProvider._loadSidebar = (fCallback) =>
		{
			const tmpCb = (typeof fCallback === 'function') ? fCallback : () => {};
			this._loadAcademyDoc(this._academyDocHash('_sidebar.md'), (pError, pMarkdown) =>
			{
				if (pError || pMarkdown == null) { return tmpBaseSidebar(tmpCb); }
				try { pProvider.pict.AppData.InlineDocumentation.SidebarGroups = pProvider._parseSidebarMarkdown(pMarkdown); }
				catch (pParseError) { return tmpBaseSidebar(tmpCb); }
				return tmpCb();
			});
		};
		const tmpBaseTopics = pProvider._loadTopics.bind(pProvider);
		pProvider._loadTopics = (pTopicsURL, fCallback) =>
		{
			const tmpCb = (typeof fCallback === 'function') ? fCallback : () => {};
			this._loadAcademyDoc(this._academyDocHash('_topics.json'), (pError, pJSON) =>
			{
				if (pError || pJSON == null) { return tmpBaseTopics(pTopicsURL, tmpCb); }
				let tmpParsed = null;
				try { tmpParsed = JSON.parse(pJSON); }
				catch (pParseError) { return tmpBaseTopics(pTopicsURL, tmpCb); }
				if (tmpParsed && (typeof tmpParsed === 'object') && !Array.isArray(tmpParsed))
				{
					pProvider.pict.AppData.InlineDocumentation.Topics = tmpParsed;
					return tmpCb();
				}
				return tmpBaseTopics(pTopicsURL, tmpCb);
			});
		};
	}

	/**
	 * Upsert an AcademyContent row (by Hash) with the given content, as THIS session's customer: update the
	 * caller's own row when they already have one, else create it (the server stamps IDCustomer).
	 *
	 * WHOSE ROW IS THIS? is answered by PlatformDocument, not by a Meadow read, and that is the whole point.
	 * PlatformDocument already resolves canonical-vs-override and now reports the IDCustomer and row id of
	 * whichever copy it served. Asking Meadow instead means reading by Hash, which fetches the canonical
	 * customer-1 row the caller does not own; MyCustomer is a post-fetch per-record assertion, so it refuses
	 * the ENTIRE read — and a tenant could never author their first override. Interpreting that refusal is not
	 * a way out: it says "a row you do not own matched", which cannot distinguish "only canonical exists" from
	 * "canonical plus your override exists", so treating it as "no row" would POST a duplicate override on
	 * every edit after the first.
	 *
	 * If the endpoint answers without an IDCustomer (an API older than this change), fall back to the Meadow
	 * probe. That path still works for a caller editing a doc only they hold, and fails loudly rather than
	 * silently duplicating rows.
	 */
	_upsertAcademyContent(pHash, pTitle, pContent, fCallback)
	{
		const tmpCb = (typeof fCallback === 'function') ? fCallback : () => {};
		const tmpClient = this._academyRestClient;
		if (!tmpClient) { return tmpCb('Documentation store unavailable.'); }
		const tmpCustomerID = Number((this.AppData.CurrentUser && this.AppData.CurrentUser.CustomerID) || 0);

		tmpClient.getJSON(`PlatformDocument/${ encodeURIComponent(pHash) }`, (pError, pBody) =>
		{
			if (pError) { return tmpCb(pError); }
			const tmpServed = (pBody && typeof pBody === 'object' && !Array.isArray(pBody)) ? pBody : {};
			const tmpServedCustomer = Number(tmpServed.IDCustomer || 0);

			// Served nothing at all — no canonical, no override. Straight create.
			if (!tmpServed.Hash) { return this._createAcademyContent(pHash, pTitle, pContent, tmpCb); }

			// Served a row but the API did not say whose: older API, use the legacy probe.
			if (!tmpServedCustomer) { return this._upsertAcademyContentViaMeadow(pHash, pTitle, pContent, tmpCb); }

			// The copy on screen is the caller's own — update it in place.
			if (tmpCustomerID && (tmpServedCustomer === tmpCustomerID) && tmpServed.IDAcademyContent)
			{
				return tmpClient.putJSON('AcademyContent',
					{ IDAcademyContent: tmpServed.IDAcademyContent, Hash: pHash, Title: pTitle || tmpServed.Title, Content: pContent },
					(pPutError) => tmpCb(pPutError || null));
			}

			// The copy on screen belongs to someone else (the canonical customer-1 doc) — author an override.
			return this._createAcademyContent(pHash, pTitle, pContent, tmpCb);
		});
	}

	/** Create this customer's own row for a hash. The server stamps IDCustomer from the session. */
	_createAcademyContent(pHash, pTitle, pContent, fCallback)
	{
		const tmpClient = this._academyRestClient;
		return tmpClient.postJSON('AcademyContent', { Hash: pHash, Title: pTitle || pHash, Content: pContent },
			(pPostError) => fCallback(pPostError || null));
	}

	/**
	 * The pre-PlatformDocument upsert, kept only as the fallback for an API that does not report IDCustomer.
	 * Reads by Hash and matches the caller's own row; refused outright when a row the caller does not own is
	 * in range, which is exactly the limitation the primary path exists to avoid.
	 */
	_upsertAcademyContentViaMeadow(pHash, pTitle, pContent, fCallback)
	{
		const tmpClient = this._academyRestClient;
		const tmpCustomerID = Number((this.AppData.CurrentUser && this.AppData.CurrentUser.CustomerID) || 0);
		tmpClient.getJSON(`AcademyContents/FilteredTo/FBV~Hash~EQ~${ encodeURIComponent(pHash) }`, (pError, pBody) =>
		{
			if (pError) { return fCallback(pError); }
			const tmpRows = Array.isArray(pBody) ? pBody : [];
			const tmpOwnRow = tmpRows.find((pRow) => Number(pRow.IDCustomer) === tmpCustomerID);
			if (tmpOwnRow)
			{
				const tmpPayload = Object.assign({}, tmpOwnRow, { Title: pTitle || tmpOwnRow.Title, Content: pContent });
				return tmpClient.putJSON('AcademyContent', tmpPayload, (pPutError) => fCallback(pPutError || null));
			}
			return this._createAcademyContent(pHash, pTitle, pContent, fCallback);
		});
	}

	/** onSave handler: persist an edited doc's markdown to AcademyContent (the provider re-displays it). */
	_saveAcademyDoc(pSaveData, fCallback)
	{
		const tmpCb = (typeof fCallback === 'function') ? fCallback : () => {};
		const tmpPath = (pSaveData && pSaveData.Path) ? pSaveData.Path : '';
		if (!tmpPath) { return tmpCb('No document path to save.'); }
		this._upsertAcademyContent(this._academyDocHash(tmpPath), tmpPath, (pSaveData && pSaveData.Content) || '', tmpCb);
	}

	/** onTopicsSave handler: persist the topic ↔ route bindings to AcademyContent as a JSON doc. */
	_saveAcademyTopics(pTopics, fCallback)
	{
		const tmpCb = (typeof fCallback === 'function') ? fCallback : () => {};
		let tmpJSON = '';
		try { tmpJSON = JSON.stringify(pTopics || {}); }
		catch (pError) { return tmpCb('Could not serialize topics for save.'); }
		this._upsertAcademyContent(this._academyDocHash('_topics.json'), 'Documentation Topics', tmpJSON, tmpCb);
	}

	/**
	 * Attach pict-section-modal's resizable/collapsible panel behavior to the help dock
	 * (drag handle + collapse tab + width persistence). Idempotent. The modal view is
	 * registered by the inline-documentation provider as 'Pict-Section-Modal'.
	 */
	_createHelpPanel()
	{
		if (this._helpPanelHandle)
		{
			return;
		}
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.panel !== 'function')
		{
			this.pict.log.warn('Pict-Section-Modal panel API unavailable — help panel not created.');
			return;
		}
		this._helpPanelHandle = tmpModal.panel('#PlatformConfig-HelpPanel',
			{
				position: 'right',
				width: 440,
				minWidth: 300,
				maxWidth: 820,
				collapsible: true,
				collapsed: true,
				persist: true,
				persistKey: 'platformconfig-help',
				onResize: () => { this._applyHelpPush(); },
				onToggle: (pCollapsed) =>
				{
					this._helpPanelOpen = !pCollapsed;
					if (!pCollapsed)
					{
						this.updateHelpForRoute();
					}
					this._applyHelpPush();
				},
			});
		// Always greet the user with the panel CLOSED. The modal's persist:true would otherwise restore a
		// previously-open panel — and since it opens before the deep-linked route resolves, it would show an
		// empty doc (which reads as "the documentation is broken"). Width stays persisted; only the open/closed
		// state is forced shut on load. The user opens it deliberately via Help, and it loads the live route then.
		this._helpPanelOpen = false;
		if (this._helpPanelHandle && typeof this._helpPanelHandle.collapse === 'function')
		{
			this._helpPanelHandle.collapse();
		}
	}

	/**
	 * Push the main content in by the docked help panel's width when it's open, so the panel sits beside the
	 * content instead of overlapping it. Reset to 0 when closed. Called on open/close (onToggle) + drag-resize
	 * (onResize). The panel is fixed (top→bottom on the right), so we only shift the content section horizontally.
	 */
	_applyHelpPush()
	{
		if (typeof document === 'undefined') { return; }
		const tmpWrapper = document.querySelector('.app-wrapper-container');
		if (!tmpWrapper) { return; }
		if (this._helpPanelOpen)
		{
			const tmpDock = document.getElementById('HelpDock');
			const tmpPanel = document.getElementById('PlatformConfig-HelpPanel');
			// Prefer the dock's measured width (panel + resize edge); fall back to the panel's set width.
			const tmpWidth = (tmpDock && tmpDock.offsetWidth) || (tmpPanel && (parseInt(tmpPanel.style.width, 10) || tmpPanel.offsetWidth)) || 440;
			tmpWrapper.style.marginRight = `${tmpWidth}px`;
		}
		else
		{
			tmpWrapper.style.marginRight = '';
		}
	}

	/**
	 * Open or close the documentation panel (expand/collapse the resizable modal panel).
	 * The panel's onToggle callback keeps `_helpPanelOpen` and the route-aware content in step.
	 *
	 * @param {boolean} [pForceOpen] - true to open, false to close; omit to toggle.
	 */
	toggleHelp(pForceOpen)
	{
		// Ensure the browser + panel exist (e.g. toggled before onAfterLogin completed).
		this._initializeHelpDocumentation();
		const tmpHandle = this._helpPanelHandle;
		if (!tmpHandle)
		{
			return;
		}
		const tmpOpen = (typeof pForceOpen === 'boolean') ? pForceOpen : !this._helpPanelOpen;
		if (tmpOpen)
		{
			tmpHandle.expand();
		}
		else
		{
			tmpHandle.collapse();
		}
	}

	/**
	 * Point the documentation panel at the topic mapped to the current route (route-aware
	 * help, _topics.json). No-op unless the browser is initialized and the panel is open,
	 * so navigation incurs no doc fetches while help is closed. Called by the router on
	 * every route change and by toggleHelp when the panel opens.
	 */
	updateHelpForRoute()
	{
		const tmpProvider = this._helpProvider;
		// _helpSuppressRouteDoc: a host feature (e.g. the Sample Plan Docs button) is driving the panel's content
		// for this open, so don't load the route's app documentation over it.
		if (this._helpSuppressRouteDoc || !tmpProvider || !this._helpInitialized || !this._helpPanelOpen)
		{
			return;
		}
		// Keep the header "Add help for this page" button in sync with the edit gate whenever the panel is live.
		this._syncAddPageHelpButton();
		const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
		const tmpRoute = tmpHash.replace(/^#/, '') || '/';
		// AcademyContent-managed route docs (platform help). When the route has one, drive the panel with
		// it via the displayContent bridge and stop — the file-based _topics.json flow owns every other route.
		if (this._showAcademyHelpForRoute(tmpRoute))
		{
			return;
		}
		// If a host feature left its own content in the shared panel (e.g. the Sample Plan's sampling-manual docs),
		// restore the app documentation first — navigateToRoute would otherwise leave that foreign content in place
		// when the route maps to no topic, so "?" on another page would keep showing the sampling manual.
		if (this._helpShowingForeignDocs)
		{
			this._helpShowingForeignDocs = false;
			tmpProvider.loadDocument(this.documentationProfile.LandingArticle);
		}
		// navigateToRoute leaves the current doc in place when no topic matches the route.
		tmpProvider.navigateToRoute(tmpRoute);
	}

	// ── AcademyContent-managed help (platform docs) ────────────────────────────
	// A parallel to the file-based _topics.json help: routes in the PlatformDocs registry resolve to a doc stored
	// in the AcademyContent table (Hash-keyed, seeded via source/help/PlatformDocs-Seed.js) rather than a file.
	// We fetch by Hash and inject into the shared inline-doc panel with the same displayContent bridge the Sample
	// Plan editor uses — reusing the panel, its markdown parser, and its open/close host with no library change.

	/**
	 * If the route has an AcademyContent-managed help doc, render it into the panel and return true; else false
	 * (so updateHelpForRoute falls through to the file-based route help). Called only while the panel is open.
	 * @param {string} pRoute @returns {boolean}
	 */
	_showAcademyHelpForRoute(pRoute)
	{
		const tmpHash = this._helpHashForRoute(pRoute);
		if (!tmpHash)
		{
			return false;
		}
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || (typeof tmpContentView.displayContent !== 'function'))
		{
			return false;
		}
		this._renderPlatformHelp(tmpHash);
		return true;
	}

	/**
	 * Nav-link click target (from the in-panel doc nav): show a specific platform help doc by Hash.
	 * Referenced from injected HTML as `_Pict.PictApplication.openPlatformHelpDoc('<hash>')`.
	 * @param {string} pHash
	 */
	openPlatformHelpDoc(pHash)
	{
		this.toggleHelp(true);
		this._renderPlatformHelp(pHash);
	}

	/**
	 * Fetch a platform help doc by Hash from AcademyContent and inject it (nav bar + parsed markdown) into the
	 * shared documentation panel. Shows a loading state immediately, then swaps in the content when it resolves.
	 * Sets `_helpShowingForeignDocs` so the file-based flow restores the app docs when the user leaves this route.
	 * @param {string} pHash
	 */
	_renderPlatformHelp(pHash)
	{
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || (typeof tmpContentView.displayContent !== 'function'))
		{
			return;
		}
		this._helpShowingForeignDocs = true;
		this._activePlatformHelpHash = pHash;
		// Make sure the inline-doc content container exists before we write into it. On a platform-doc route the
		// module's loadDocument (which is what normally renders the content view's template) is intentionally
		// skipped, so on a FRESH panel open #InlineDoc-Content-Body has not been created yet and displayContent
		// would land nowhere — leaving the panel blank. Render the content view once to create it.
		if ((typeof document !== 'undefined') && !document.getElementById('InlineDoc-Content-Body') && (typeof tmpContentView.render === 'function'))
		{
			tmpContentView.render();
		}
		tmpContentView.displayContent(this._platformHelpHTML(pHash, '<p class="platform-help-loading">Loading…</p>'));
		// Fetch the doc AND the area's topic index together, so the nav can include topics the static registry
		// doesn't know (customer-authored / newly created). Both are cached, so this is instant after the first hit.
		const tmpArea = libPlatformDocs.areaFromHash(pHash);
		Promise.all([ this._fetchAcademyDoc(pHash), this._fetchAreaIndex(tmpArea) ]).then((pResults) =>
		{
			// Ignore a stale fetch (the user clicked another doc / left the route) or a panel that has since closed.
			if ((this._activePlatformHelpHash !== pHash) || !this._helpPanelOpen)
			{
				return;
			}
			const tmpDoc = pResults[0];
			// The article body couldn't be resolved (PlatformDocument returned no Content for this Hash — a
			// tenant that can't read the canonical customer-1 doc, or a topic with no row yet). Show a calm,
			// cause-agnostic end-user empty state rather than the old developer "seed the platform docs"
			// instruction; the sibling-topic nav above still lets the reader jump to any article that resolved.
			const tmpMarkdown = (tmpDoc && tmpDoc.Content)
				? tmpDoc.Content
				: '_This help topic isn’t available right now._';
			// displayContent (pict-section-content's view) renders the parser's KaTeX/Mermaid placeholders itself
			// once window.katex / window.mermaid are on the page (loaded in index.html) — no extra pass needed.
			tmpContentView.displayContent(this._platformHelpHTML(pHash, this._parseHelpMarkdown(tmpMarkdown)));
		});
	}

	/**
	 * Fetch + cache an area's topic index (canonical + the caller's own topics) from the PlatformDocumentIndex
	 * endpoint, so the nav can show topics the static registry lacks. Resolves an array of {Hash, Title}.
	 * @param {string} pArea @returns {Promise<Array>}
	 */
	_fetchAreaIndex(pArea)
	{
		if (!this._platformAreaIndexCache) { this._platformAreaIndexCache = {}; }
		if (!pArea) { return Promise.resolve([]); }
		if (this._platformAreaIndexCache[pArea] !== undefined) { return Promise.resolve(this._platformAreaIndexCache[pArea]); }
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient) { return Promise.resolve([]); }
		return new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`PlatformDocumentIndex/${encodeURIComponent(pArea)}`, (pError, pBody) =>
			{
				this._platformAreaIndexCache[pArea] = (!pError && Array.isArray(pBody)) ? pBody : [];
				resolve(this._platformAreaIndexCache[pArea]);
			});
		});
	}

	/**
	 * Fetch + cache a single documentation record by Hash. Resolves the record (or null on miss/error).
	 *
	 * Reads the bespoke `PlatformDocument/:Hash` endpoint, which serves the canonical (customer-1) doc — and the
	 * caller's own override if they have authored one — to ANY authenticated session regardless of tenant, as a
	 * single `{Hash, Title, Content}`. A missing doc (or endpoint) resolves null, which the panel renders as a
	 * "not loaded yet" note.
	 * @param {string} pHash @returns {Promise<object|null>}
	 */
	_fetchAcademyDoc(pHash)
	{
		if (!this._academyHelpCache)
		{
			this._academyHelpCache = {};
		}
		if (this._academyHelpCache[pHash] !== undefined)
		{
			return Promise.resolve(this._academyHelpCache[pHash]);
		}
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient)
		{
			return Promise.resolve(null);
		}
		return new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`PlatformDocument/${encodeURIComponent(pHash)}`, (pError, pBody) =>
			{
				this._academyHelpCache[pHash] = (!pError && pBody && pBody.Content) ? pBody : null;
				resolve(this._academyHelpCache[pHash]);
			});
		});
	}

	// ── AcademyContent-backed route→topic bindings (supersedes the static topics.json for platform help) ──────
	// Which help topic F1 opens on a route was historically fixed in the static registry (PlatformDocs.js Routes)
	// and the inline-doc module's docs/_topics.json. To let admins bind topics to routes AND add new route-bound
	// topics that persist, bindings live in a single AcademyContent row (Hash 'Doc-RouteBindings', Content = JSON
	// { Routes: { "<route>": "<Doc-Area-Topic hash>" } }). It layers the same way docs do — a customer-1 session
	// edits the canonical bindings, any other customer edits their own override — and resolves cross-tenant through
	// the PlatformDocument endpoint. A persisted binding wins; routes with none fall back to the static registry.

	/** Load (or reload) the resolved route→topic binding map into this._routeBindings. */
	_loadRouteBindingsAsync(fCallback)
	{
		const fDone = (typeof fCallback === 'function') ? fCallback : () => {};
		if (!this._routeBindings) { this._routeBindings = {}; }
		this._fetchAcademyDoc('Doc-RouteBindings').then((pDoc) =>
		{
			this._routeBindings = this._parseRouteBindings(pDoc && pDoc.Content);
			fDone();
		});
	}

	/** Parse a bindings-row Content string into a flat { route: hash } map (tolerant of a bare map or a { Routes } wrapper). */
	_parseRouteBindings(pContent)
	{
		if (!pContent) { return {}; }
		try
		{
			const tmpParsed = JSON.parse(pContent);
			if (tmpParsed && (typeof tmpParsed === 'object'))
			{
				const tmpMap = (tmpParsed.Routes && (typeof tmpParsed.Routes === 'object')) ? tmpParsed.Routes : tmpParsed;
				return (tmpMap && (typeof tmpMap === 'object') && !Array.isArray(tmpMap)) ? tmpMap : {};
			}
		}
		catch (pError) { /* corrupt bindings row → fall back to the static registry */ }
		return {};
	}

	/**
	 * The help-doc Hash F1 should open for a route: a persisted binding (longest-matching route prefix) wins, else
	 * the static registry. '' when neither has one (the caller then falls back to the file-based route help).
	 * @param {string} pRoute @returns {string}
	 */
	_helpHashForRoute(pRoute)
	{
		const tmpRoute = String(pRoute || '');
		const tmpBindings = this._routeBindings || {};
		let tmpHash = '';
		let tmpBest = -1;
		Object.keys(tmpBindings).forEach((pKey) =>
		{
			if (tmpBindings[pKey] && ((tmpRoute === pKey) || (tmpRoute.indexOf(pKey + '/') === 0)) && (pKey.length > tmpBest))
			{
				tmpHash = tmpBindings[pKey];
				tmpBest = pKey.length;
			}
		});
		return tmpHash || libPlatformDocs.hashForRoute(tmpRoute);
	}

	/**
	 * Persist a route→topic binding (or remove it when pHash is falsy): read-modify-write the caller's own bindings
	 * row so a customer's override keeps the canonical bindings it started from. Refreshes the cache + in-memory map.
	 * @param {string} pRoute @param {string} pHash @param {Function} fCallback (error|null)
	 */
	_bindRouteToHashAsync(pRoute, pHash, fCallback)
	{
		const fDone = (typeof fCallback === 'function') ? fCallback : () => {};
		const tmpRoute = String(pRoute || '').replace(/^#/, '');
		if (!tmpRoute) { return fDone('No route to bind.'); }
		this._fetchAcademyDoc('Doc-RouteBindings').then((pDoc) =>
		{
			const tmpMap = this._parseRouteBindings(pDoc && pDoc.Content);
			if (pHash) { tmpMap[tmpRoute] = pHash; }
			else { delete tmpMap[tmpRoute]; }
			const tmpJSON = JSON.stringify({ Routes: tmpMap });
			this._upsertAcademyContent('Doc-RouteBindings', 'Documentation Route Bindings', tmpJSON, (pError) =>
			{
				if (this._academyHelpCache) { this._academyHelpCache['Doc-RouteBindings'] = undefined; }
				this._routeBindings = tmpMap;
				fDone(pError || null);
			});
		});
	}

	/** Render markdown → HTML via the inline-doc provider's content parser (falls back to the raw string). */
	_parseHelpMarkdown(pMarkdown)
	{
		const tmpProvider = this._helpProvider;
		return (tmpProvider && tmpProvider._ContentProvider && (typeof tmpProvider._ContentProvider.parseMarkdown === 'function'))
			? tmpProvider._ContentProvider.parseMarkdown(pMarkdown)
			: pMarkdown;
	}


	/**
	 * The panel body for an import help doc: a nav bar linking every import topic (active one highlighted) above
	 * the rendered content. Hand-built HTML so the nav links carry reliable inline click handlers (matches the
	 * Sample Plan spec-index approach). A scoped <style> ships with it so it needs no global CSS.
	 * @param {string} pHash @param {string} pBodyHTML
	 */
	_platformHelpHTML(pHash, pBodyHTML)
	{
		const fEscape = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
		// Nav shows the sibling topics in the SAME feature area (not every doc across the app).
		// Nav = the curated static topics (order + friendly labels) MERGED with any discovered topics (customer-
		// authored or newly created) that the static registry doesn't know — those use their Title as the label.
		const tmpArea = libPlatformDocs.areaFromHash(pHash);
		const tmpStatic = libPlatformDocs.docsInArea(tmpArea);
		const tmpKnown = {};
		tmpStatic.forEach((pDoc) => { tmpKnown[pDoc.Hash] = true; });
		const tmpDiscovered = (this._platformAreaIndexCache && this._platformAreaIndexCache[tmpArea]) || [];
		const tmpTopics = tmpStatic.concat(tmpDiscovered
			.filter((pDoc) => pDoc && pDoc.Hash && !tmpKnown[pDoc.Hash])
			.map((pDoc) => ({ Hash: pDoc.Hash, Nav: pDoc.Title || pDoc.Hash })));
		const tmpEditMode = this._platformDocsEditMode();
		let tmpNav = tmpTopics.map((pDoc) =>
		{
			const tmpActiveClass = (pDoc.Hash === pHash) ? ' platform-help-navlink-active' : '';
			return `<a href="#" class="platform-help-navlink${tmpActiveClass}" onclick="_Pict.PictApplication.openPlatformHelpDoc('${fEscape(pDoc.Hash)}'); return false;">${fEscape(pDoc.Nav)}</a>`;
		}).join('');
		// Editors can append a new topic to the area (customer-1 admins add a canonical topic; customer admins add their own).
		if (tmpEditMode && tmpArea)
		{
			tmpNav += `<a href="#" class="platform-help-navlink" title="Add a topic to this area" onclick="_Pict.PictApplication.addPlatformHelpTopic('${fEscape(tmpArea)}'); return false;"><i class="fas fa-plus"></i> Topic</a>`;
		}
		// Editors get a pencil (edit the doc) and — when this topic isn't already what opens on the current page — a
		// "Set as this page's help" pin that binds it to the route (persisted in AcademyContent, no topics.json).
		let tmpBindBtn = '';
		if (tmpEditMode)
		{
			const tmpRoute = ((typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '').replace(/^#/, '') || '/';
			if (this._helpHashForRoute(tmpRoute) !== pHash)
			{
				tmpBindBtn = `<button class="platform-help-editbtn" title="Make this the help topic that opens on this page" onclick="_Pict.PictApplication.bindCurrentHelpToRoute('${fEscape(pHash)}'); return false;"><i class="fas fa-thumbtack"></i> Set as this page’s help</button>`;
			}
		}
		const tmpEditBar = tmpEditMode
			? `<div class="platform-help-editbar"><span class="platform-help-editbar-spacer"></span>${tmpBindBtn}<button class="platform-help-editbtn" onclick="_Pict.PictApplication.editPlatformHelpDoc('${fEscape(pHash)}'); return false;"><i class="fas fa-pen"></i> Edit</button></div>`
			: '';
		return `${PLATFORM_HELP_STYLE}<div class="platform-help"><nav class="platform-help-nav">${tmpNav}</nav>${tmpEditBar}<div class="platform-help-body">${pBodyHTML}</div></div>`;
	}

	// ── Platform-doc editing (customer-1 canonical + customer overrides) ───────
	// One in-panel markdown editor (pict-section-markdowneditor, the component the inline-doc module wraps and the
	// Email editor reuses) serves both modes; the difference is only WHERE the write lands — the canonical
	// customer-1 row, or the caller's own override — which the server derives from the session. The override read
	// path already exists (PlatformDocument), so a customer's save shows for their users at once, and a revert is a
	// delete of their own row.

	/** True for a customer-1 super-user (role index 5, customer 1). UI gate only; the server is authoritative. */
	_isSuperUser()
	{
		const tmpUser = this.pict.AppData.CurrentUser;
		return !!(tmpUser && (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1));
	}

	/**
	 * True when the session may impersonate a customer's account on #/ManageCustomers: a HeadLight (customer 1) user of
	 * at least level 2 who is either a level-5 super-admin OR holds the `Customer-Impersonate` capability (granted to
	 * internal support staff via Entitlements). UI gate only — the server (Authentication.authorizeImpersonation) is
	 * authoritative. Fail-open before the capability map loads, matching the app's other capability gates.
	 * @return {boolean}
	 */
	canImpersonate()
	{
		const tmpUser = this.pict.AppData.CurrentUser;
		if (!tmpUser || (Number(tmpUser.CustomerID) !== 1) || !(Number(tmpUser.UserRoleIndex) >= 2)) { return false; }
		if (Number(tmpUser.UserRoleIndex) >= 5) { return true; }
		const tmpService = this.fable && this.fable.EffectivePermissionsService;
		if (!tmpService || (typeof tmpService.canHash !== 'function') || (typeof tmpService.currentUserReady !== 'function')) { return true; }
		if (!tmpService.currentUserReady()) { return true; }
		return !!tmpService.canHash('Customer-Impersonate');
	}

	/**
	 * Impersonate a customer's configuration admin, then reload to the start screen as that admin. The SINGLE client
	 * seam for "become a customer's admin" (per the forward-compatibility note — the future level-4 cross-customer
	 * flow reuses this method + the same server route). The server resolves the admin and enforces the gate; here we
	 * just call it and react. On "no config admin yet" the session is unchanged and we route to Grant Access.
	 * Referenced from injected HTML as `_Pict.PictApplication.impersonateCustomerAdmin(<IDCustomer>)`.
	 * @param {Number} pIDCustomer
	 */
	impersonateCustomerAdmin(pIDCustomer)
	{
		const tmpIDCustomer = Number(pIDCustomer);
		if (!Number.isFinite(tmpIDCustomer) || (tmpIDCustomer < 1)) { return; }
		const tmpRestClient = this.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient) { return; }
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const fToast = (pMessage, pType) => { if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast(pMessage, { type: pType || 'error' }); } };
		tmpRestClient.getJSON(`Authentication/ImpersonateCustomerAdmin/${tmpIDCustomer}`, (pError, pBody) =>
		{
			if (pError)
			{
				fToast(`Could not impersonate: ${(pError && pError.message) ? pError.message : pError}`, 'error');
				return;
			}
			if (pBody && (pBody.Status === 'NoConfigAdmin'))
			{
				// No config admin for this customer yet — send the super-user to Grant Access to seed one. (The server
				// signals this via `Status`, not `Error`, so the rest client passes the body through instead of throwing.)
				fToast('This customer has no configuration admin yet — grant one in Grants first.', 'warning');
				if (typeof window !== 'undefined' && window.location) { window.location.hash = '#/GrantAccess/' + Number(tmpIDCustomer); }
				return;
			}
			if (!pBody || (pBody.Success === false))
			{
				fToast(`Could not impersonate: ${(pBody && pBody.Message) ? pBody.Message : 'the server declined the request.'}`, 'error');
				return;
			}
			// Success — reload to the start screen as the customer's configuration admin.
			if (typeof window !== 'undefined' && window.location)
			{
				window.location.hash = '#/';
				window.location.reload();
			}
		});
	}

	/**
	 * Impersonate a SPECIFIC account by IDUser (the account picker on #/ManageCustomers), then reload as that user.
	 * Same super-user gate + session-replacement as impersonateCustomerAdmin, but the caller chooses which account
	 * (the server route `Authentication/Impersonate/:IDUser` accepts any target for a level-5/customer-1 session).
	 * Referenced from injected HTML via `_Pict.providers.ManageCustomers.impersonateAccount(<IDUser>)`.
	 * @param {Number} pIDUser
	 */
	impersonateUser(pIDUser)
	{
		const tmpIDUser = Number(pIDUser);
		if (!Number.isFinite(tmpIDUser) || (tmpIDUser < 1)) { return; }
		const tmpRestClient = this.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient) { return; }
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const fToast = (pMessage, pType) => { if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast(pMessage, { type: pType || 'error' }); } };
		tmpRestClient.getJSON(`Authentication/Impersonate/${tmpIDUser}`, (pError, pBody) =>
		{
			if (pError)
			{
				fToast(`Could not sign in as that account: ${(pError && pError.message) ? pError.message : pError}`, 'error');
				return;
			}
			if (pBody && (pBody.Success === false))
			{
				fToast(`Could not sign in: ${(pBody && pBody.Message) ? pBody.Message : 'the server declined the request.'}`, 'error');
				return;
			}
			// Success — the session is now that account; reload to the start screen as them.
			if (typeof window !== 'undefined' && window.location)
			{
				window.location.hash = '#/';
				window.location.reload();
			}
		});
	}

	/**
	 * True when the session may manage the customer team — a level-5 super-user who also holds the "Manage Customer
	 * Team" entitlement (CustomerTeam-Update). Fail-open before the capability map loads (matching the app's other
	 * gates). UI gate only; this feature's writes ride the super-user's own access, and the data is UX/data only.
	 */
	_canManageCustomerTeam()
	{
		if (!this._isSuperUser()) { return false; }
		const tmpService = this.fable && this.fable.EffectivePermissionsService;
		if (!tmpService || (typeof tmpService.canHash !== 'function') || (typeof tmpService.currentUserReady !== 'function')) { return true; }
		if (!tmpService.currentUserReady()) { return true; }
		return !!tmpService.canHash('CustomerTeam-Update');
	}

	/** True when the session holds a CustomerAdmin role. UI gate only. */
	_hasCustomerAdmin()
	{
		const tmpUser = this.pict.AppData.CurrentUser;
		const tmpRoles = tmpUser && tmpUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin'));
	}

	/** True when the session can edit help content — the AcademyContent-Update capability granted by the
	 *  "Edit in-app help documentation" entitlement. UI gate only; the server enforces the actual writes. */
	_canEditAcademyContent()
	{
		const tmpService = this.fable && this.fable.EffectivePermissionsService;
		return !!(tmpService && (typeof tmpService.can === 'function') && tmpService.can('AcademyContent', 'Update'));
	}

	/**
	 * Which doc-edit mode the session gets, or null (read-only). A customer-1 session edits the CANONICAL rows; any
	 * other customer edits their own per-customer OVERRIDE. Editing is unlocked by the AcademyContent-Update
	 * capability (the "Edit in-app help documentation" entitlement) — with a CustomerAdmin role / customer-1
	 * super-user still qualifying so the gate never regresses for existing admins. The server enforces the writes.
	 * @returns {'canonical'|'override'|null}
	 */
	_platformDocsEditMode()
	{
		const tmpCanEdit = this._canEditAcademyContent() || this._hasCustomerAdmin() || this._isSuperUser();
		if (!tmpCanEdit) { return null; }
		return this.isHeadlightSession() ? 'canonical' : 'override';
	}

	/**
	 * Enter edit mode for a doc: fetch the caller's OWN AcademyContent row (the canonical row for a customer-1
	 * session, the customer's override otherwise) for its id + current markdown, then mount the editor. When the
	 * caller has no row yet (a customer editing a canonical topic for the first time) we seed from the canonical
	 * content so they start from the platform default; saving then creates their override.
	 * Referenced from injected HTML as `_Pict.PictApplication.editPlatformHelpDoc('<hash>')`.
	 * @param {string} pHash
	 */
	editPlatformHelpDoc(pHash)
	{
		const tmpMode = this._platformDocsEditMode();
		if (!tmpMode) { return; }
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || (typeof tmpContentView.displayContent !== 'function')) { return; }
		this.toggleHelp(true);
		this._activePlatformHelpHash = pHash;
		tmpContentView.displayContent(this._platformHelpHTML(pHash, '<p class="platform-help-loading">Loading the editor…</p>'));

		this._loadEditableDoc(pHash).then((pOwnRow) =>
		{
			if (this._activePlatformHelpHash !== pHash) { return; }
			const tmpRegistryDoc = libPlatformDocs.docByHash(pHash);
			this._editingDoc =
			{
				Hash: pHash,
				ID: (pOwnRow && pOwnRow.IDAcademyContent) || 0,   // 0 → save creates a new row (an override)
				Title: (pOwnRow && pOwnRow.Title) || (tmpRegistryDoc && tmpRegistryDoc.Title) || pHash,
				Mode: tmpMode,
				HasOverride: !!(pOwnRow && pOwnRow.IDAcademyContent && (tmpMode === 'override')),
				IsKnownTopic: !!tmpRegistryDoc,   // a registry (canonical) topic → the delete is a "revert"; else it's their own topic
			};
			const fSeed = (pStartingMarkdown) => { this._renderPlatformDocEditor(pStartingMarkdown || ''); };
			if (pOwnRow && (pOwnRow.Content != null)) { fSeed(pOwnRow.Content); }
			else { this._fetchAcademyDoc(pHash).then((pResolved) => fSeed((pResolved && pResolved.Content) || '')); }
		});
	}

	/**
	 * Fetch the caller's OWN AcademyContent row for a Hash — the id and current markdown the inline editor
	 * needs — or null when they have not authored an override.
	 *
	 * Resolved from PlatformDocument for the same reason as the other ownership lookups: a Meadow read by
	 * Hash fetches the canonical customer-1 row, which the caller does not own, and the MyCustomer post-fetch
	 * assertion then refuses the entire read. For a tenant that returned null on every topic with a platform
	 * default, which the editor reads as "no override" — so it would create a fresh row on each save instead
	 * of updating the one it already made.
	 * @param {string} pHash @returns {Promise<object|null>}
	 */
	_loadEditableDoc(pHash)
	{
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient) { return Promise.resolve(null); }
		const tmpCustomerID = Number((this.AppData.CurrentUser && this.AppData.CurrentUser.CustomerID) || 0);
		return new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`PlatformDocument/${encodeURIComponent(pHash)}`, (pError, pBody) =>
			{
				if (pError || !pBody || Array.isArray(pBody) || !pBody.Hash) { return resolve(null); }
				const tmpServedCustomer = Number(pBody.IDCustomer || 0);
				if (!tmpServedCustomer || !tmpCustomerID || (tmpServedCustomer !== tmpCustomerID)) { return resolve(null); }
				return resolve(pBody);
			});
		});
	}

	/** Render the editor shell into the panel and mount the markdown editor seeded with pMarkdown. */
	_renderPlatformDocEditor(pMarkdown)
	{
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || (typeof tmpContentView.displayContent !== 'function')) { return; }
		tmpContentView.displayContent(this._platformDocEditorHTML());
		this._mountPlatformDocEditor(pMarkdown);
	}

	/** The editor shell: a toolbar (title + mode badge + Save/Cancel), an optional error/confirm row, the mount. */
	_platformDocEditorHTML()
	{
		const fEscape = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
		const tmpDoc = this._editingDoc || {};
		const tmpCanonical = (tmpDoc.Mode === 'canonical');
		const tmpModeChip = tmpCanonical
			? '<span class="platform-help-editmode platform-help-editmode-canonical">Platform default</span>'
			: '<span class="platform-help-editmode platform-help-editmode-override">Your customer</span>';
		const tmpNote = tmpCanonical
			? 'Editing the platform-default documentation — visible to every customer.'
			: 'Editing your customer’s copy. It overrides the platform default for your users only.';
		const tmpError = tmpDoc.Error
			? `<p class="platform-help-editnote" style="color:var(--theme-color-status-danger, #c0392b);">${fEscape(tmpDoc.Error)}</p>`
			: '';
		// A known (registry) topic's delete reverts to the platform default; the caller's own new topic is just deleted.
		const tmpKnown = !!tmpDoc.IsKnownTopic;
		const tmpDeleteLabel = tmpKnown ? 'Revert to platform default' : 'Delete this topic';
		const tmpConfirmQ = tmpKnown ? 'Delete your customer’s copy and revert to the platform default?' : 'Delete this topic for your customer?';
		let tmpRevertArea = '';
		if (tmpDoc.ConfirmRevert)
		{
			tmpRevertArea = '<div class="platform-help-editbar" style="margin-top:0.7rem;">'
				+ `<span>${fEscape(tmpConfirmQ)}</span><span class="platform-help-editbar-spacer"></span>`
				+ `<button class="platform-help-btn platform-help-btn-danger" onclick="_Pict.PictApplication.confirmRevertPlatformHelpDoc(); return false;">${fEscape(tmpKnown ? 'Revert' : 'Delete')}</button>`
				+ '<button class="platform-help-btn platform-help-btn-ghost" onclick="_Pict.PictApplication.cancelRevertPlatformHelpDoc(); return false;">Keep it</button></div>';
		}
		else if (tmpDoc.HasOverride)
		{
			tmpRevertArea = '<div class="platform-help-editbar" style="margin-top:0.7rem;">'
				+ `<button class="platform-help-btn platform-help-btn-danger" onclick="_Pict.PictApplication.revertPlatformHelpDoc(); return false;">${fEscape(tmpDeleteLabel)}</button></div>`;
		}
		return `${PLATFORM_HELP_STYLE}<div class="platform-help">`
			+ `<div class="platform-help-editbar"><strong>${fEscape(tmpDoc.Title || '')}</strong> ${tmpModeChip}<span class="platform-help-editbar-spacer"></span>`
			+ '<button class="platform-help-btn platform-help-btn-primary" onclick="_Pict.PictApplication.savePlatformHelpDoc(); return false;">Save</button>'
			+ '<button class="platform-help-btn platform-help-btn-ghost" onclick="_Pict.PictApplication.cancelPlatformHelpEdit(); return false;">Cancel</button></div>'
			+ `<p class="platform-help-editnote">${fEscape(tmpNote)}</p>`
			+ tmpError
			+ '<div id="PlatformDoc-Editor-Mount" class="platform-help-editmount"></div>'
			+ tmpRevertArea
			+ '</div>';
	}

	/** Mount (or re-render) the markdown editor into the shell, seeded with the doc's markdown. */
	_mountPlatformDocEditor(pMarkdown)
	{
		if (!this.pict.AppData.PlatformDocEditor) { this.pict.AppData.PlatformDocEditor = {}; }
		this.pict.AppData.PlatformDocEditor.Segments = [ { Content: (pMarkdown == null) ? '' : String(pMarkdown) } ];
		if (!this.pict.views['PlatformDoc-Editor'])
		{
			this.pict.addView('PlatformDoc-Editor',
				{
					ViewIdentifier: 'PlatformDoc-Editor',
					TargetElementAddress: '#PlatformDoc-Editor-Mount',
					ContentDataAddress: 'AppData.PlatformDocEditor.Segments',
					AutoRender: false,
					EnableRichPreview: true,
					ReadOnly: false,
				}, libPlatformDocMarkdownEditor);
		}
		try { this.pict.views['PlatformDoc-Editor'].render(); }
		catch (pError) { this.pict.log.warn('Platform doc markdown editor failed to render', { error: String(pError) }); }
	}

	/** Read the edited markdown back out of the editor. */
	_capturePlatformDocEditor()
	{
		const tmpView = this.pict.views['PlatformDoc-Editor'];
		if (tmpView && (typeof tmpView.marshalFromView === 'function')) { try { tmpView.marshalFromView(); } catch (pError) { /* editor gone */ } }
		const tmpSegments = (this.pict.AppData.PlatformDocEditor && this.pict.AppData.PlatformDocEditor.Segments) || [];
		return tmpSegments.map((pSeg) => (pSeg && pSeg.Content) || '').join('\n\n');
	}

	/**
	 * Save the editor's markdown to AcademyContent: PUT the existing row (the canonical row, or an existing
	 * override), or POST a new override (IDCustomer omitted → the server stamps the caller's customer). On success
	 * reload + re-render read mode; on error keep the editor open with an inline message. Referenced from HTML.
	 */
	savePlatformHelpDoc()
	{
		const tmpDoc = this._editingDoc;
		if (!tmpDoc) { return; }
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient) { return; }
		const tmpMarkdown = this._capturePlatformDocEditor();
		const tmpRecord = { Hash: tmpDoc.Hash, Title: tmpDoc.Title, Content: tmpMarkdown };
		const fDone = (pError) =>
		{
			if (pError)
			{
				this.pict.log.warn('Platform doc save failed', { hash: tmpDoc.Hash, error: String(pError) });
				tmpDoc.Error = 'Could not save — the server rejected the write (you may not have permission at this scope).';
				this._renderPlatformDocEditor(tmpMarkdown);
				return;
			}
			if (this._academyHelpCache) { this._academyHelpCache[tmpDoc.Hash] = undefined; }
			this._editingDoc = null;
			this._renderPlatformHelp(tmpDoc.Hash);
		};
		if (tmpDoc.ID) { tmpRestClient.putJSON('AcademyContent', Object.assign({ IDAcademyContent: tmpDoc.ID }, tmpRecord), fDone); }
		else { tmpRestClient.postJSON('AcademyContent', tmpRecord, fDone); }
	}

	/** Leave edit mode without saving. Referenced from injected HTML. */
	cancelPlatformHelpEdit()
	{
		const tmpHash = this._editingDoc ? this._editingDoc.Hash : this._activePlatformHelpHash;
		this._editingDoc = null;
		this._renderPlatformHelp(tmpHash);
	}

	/** Arm the two-step revert confirm (customer override only). Referenced from injected HTML. */
	revertPlatformHelpDoc()
	{
		if (!this._editingDoc || !this._editingDoc.HasOverride) { return; }
		this._editingDoc.ConfirmRevert = true;
		this._renderPlatformDocEditor(this._capturePlatformDocEditor());
	}

	/** Cancel the revert confirm, staying in the editor. Referenced from injected HTML. */
	cancelRevertPlatformHelpDoc()
	{
		if (!this._editingDoc) { return; }
		this._editingDoc.ConfirmRevert = false;
		this._renderPlatformDocEditor(this._capturePlatformDocEditor());
	}

	/**
	 * Delete the caller's own override row → revert to the platform default. The bespoke read endpoint then serves
	 * the canonical customer-1 content again. Referenced from injected HTML.
	 */
	confirmRevertPlatformHelpDoc()
	{
		const tmpDoc = this._editingDoc;
		if (!tmpDoc || !tmpDoc.ID || !tmpDoc.HasOverride) { return; }
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient || (typeof tmpRestClient.deleteEntity !== 'function')) { return; }
		tmpRestClient.deleteEntity('AcademyContent', tmpDoc.ID, (pError) =>
		{
			if (pError)
			{
				this.pict.log.warn('Platform doc revert failed', { hash: tmpDoc.Hash, error: String(pError) });
				tmpDoc.ConfirmRevert = false;
				tmpDoc.Error = 'Could not revert — the server rejected the delete.';
				this._renderPlatformDocEditor(this._capturePlatformDocEditor());
				return;
			}
			if (this._academyHelpCache) { this._academyHelpCache[tmpDoc.Hash] = undefined; }
			this._editingDoc = null;
			this._renderPlatformHelp(tmpDoc.Hash);
		});
	}

	/**
	 * Begin adding a new topic to an area (editors only): show an inline title form in the panel. Referenced from HTML.
	 * @param {string} pArea
	 */
	addPlatformHelpTopic(pArea)
	{
		if (!this._platformDocsEditMode() || !pArea) { return; }
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || (typeof tmpContentView.displayContent !== 'function')) { return; }
		// Capture the route we're adding from so the new topic can be route-bound. If the page has no resolved help
		// yet, the new topic becomes its help (auto-bound as primary); otherwise it just joins the area's topic list.
		const tmpRoute = ((typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '').replace(/^#/, '') || '/';
		this._addingTopic = { Area: pArea, Route: tmpRoute, BindPrimary: !this._helpHashForRoute(tmpRoute), Error: '' };
		this.toggleHelp(true);
		tmpContentView.displayContent(this._platformNewTopicHTML());
		try { const tmpInput = document.getElementById('PlatformDoc-NewTopic-Title'); if (tmpInput) { tmpInput.focus(); } }
		catch (pError) { /* no focusable input */ }
	}

	/** The inline new-topic form (title input + Create/Cancel). */
	_platformNewTopicHTML()
	{
		const fEscape = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
		const tmpAdd = this._addingTopic || {};
		const tmpNote = (this._platformDocsEditMode() === 'canonical')
			? 'New platform-default topic — visible to every customer once you save it.'
			: 'New topic for your customer only.';
		const tmpError = tmpAdd.Error
			? `<p class="platform-help-editnote" style="color:var(--theme-color-status-danger, #c0392b);">${fEscape(tmpAdd.Error)}</p>`
			: '';
		return `${PLATFORM_HELP_STYLE}<div class="platform-help">`
			+ '<div class="platform-help-editbar"><strong>Add a topic</strong></div>'
			+ `<p class="platform-help-editnote">${fEscape(tmpNote)}</p>`
			+ tmpError
			+ '<div class="platform-help-editbar"><input id="PlatformDoc-NewTopic-Title" type="text" class="platform-help-input" placeholder="Topic title" />'
			+ '<button class="platform-help-btn platform-help-btn-primary" onclick="_Pict.PictApplication.createPlatformHelpTopic(); return false;">Create</button>'
			+ '<button class="platform-help-btn platform-help-btn-ghost" onclick="_Pict.PictApplication.cancelAddPlatformHelpTopic(); return false;">Cancel</button></div>'
			+ '</div>';
	}

	/** Re-render the new-topic form (e.g. to surface a validation/save error). */
	_renderNewTopicForm()
	{
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView && (typeof tmpContentView.displayContent === 'function')) { tmpContentView.displayContent(this._platformNewTopicHTML()); }
	}

	/**
	 * Create the new topic: slug the title into a unique `Doc-<Area>-<Slug>` hash, POST a starter AcademyContent
	 * row (a customer-1 session creates a canonical topic; a customer creates their own), then open it in the
	 * editor. Referenced from injected HTML.
	 */
	createPlatformHelpTopic()
	{
		const tmpAdd = this._addingTopic;
		if (!tmpAdd) { return; }
		let tmpTitle = '';
		try { const tmpInput = document.getElementById('PlatformDoc-NewTopic-Title'); tmpTitle = tmpInput ? String(tmpInput.value || '').trim() : ''; }
		catch (pError) { tmpTitle = ''; }
		const tmpSlug = tmpTitle.replace(/[^A-Za-z0-9]+/g, ' ').trim().split(/\s+/).filter((pWord) => pWord.length > 0)
			.map((pWord) => pWord.charAt(0).toUpperCase() + pWord.slice(1)).join('');
		if (!tmpTitle || !tmpSlug)
		{
			tmpAdd.Error = 'Give the topic a title with at least one letter or number.';
			this._renderNewTopicForm();
			return;
		}
		// Uniquify the hash against the area's known (registry) + discovered topics.
		const tmpExisting = {};
		libPlatformDocs.docsInArea(tmpAdd.Area).forEach((pDoc) => { tmpExisting[pDoc.Hash] = true; });
		((this._platformAreaIndexCache && this._platformAreaIndexCache[tmpAdd.Area]) || []).forEach((pDoc) => { if (pDoc && pDoc.Hash) { tmpExisting[pDoc.Hash] = true; } });
		let tmpFinalSlug = tmpSlug;
		let tmpCounter = 2;
		while (tmpExisting[`Doc-${tmpAdd.Area}-${tmpFinalSlug}`]) { tmpFinalSlug = tmpSlug + tmpCounter; tmpCounter++; }
		const tmpHash = `Doc-${tmpAdd.Area}-${tmpFinalSlug}`;
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient) { return; }
		tmpRestClient.postJSON('AcademyContent', { Hash: tmpHash, Title: tmpTitle, Content: `# ${tmpTitle}\n\n` }, (pError) =>
		{
			if (pError)
			{
				this.pict.log.warn('Platform doc topic create failed', { hash: tmpHash, error: String(pError) });
				tmpAdd.Error = 'Could not create the topic — the server rejected the write (you may not have permission).';
				this._renderNewTopicForm();
				return;
			}
			// Drop the area index cache so the new topic is re-discovered. When the page had no help yet, bind the
			// new topic to this route so F1 opens it here; then open it in the editor.
			if (this._platformAreaIndexCache) { this._platformAreaIndexCache[tmpAdd.Area] = undefined; }
			const tmpRoute = tmpAdd.Route;
			const tmpBindPrimary = !!tmpAdd.BindPrimary;
			this._addingTopic = null;
			if (tmpBindPrimary && tmpRoute)
			{
				this._bindRouteToHashAsync(tmpRoute, tmpHash, () => this.editPlatformHelpDoc(tmpHash));
			}
			else
			{
				this.editPlatformHelpDoc(tmpHash);
			}
		});
	}

	/** Dismiss the new-topic form, back to the current doc. Referenced from injected HTML. */
	cancelAddPlatformHelpTopic()
	{
		this._addingTopic = null;
		// Return to the platform topic we were viewing; if there was none (the header "Add help for this page" flow
		// on a file-based route), re-resolve the route's normal help instead of rendering a blank/stale panel.
		if (this._activePlatformHelpHash) { this._renderPlatformHelp(this._activePlatformHelpHash); }
		else { this.updateHelpForRoute(); }
	}

	/**
	 * Bind the topic being viewed to the current route so F1 opens it on this page (persisted in AcademyContent).
	 * Referenced from injected HTML as `_Pict.PictApplication.bindCurrentHelpToRoute('<hash>')`.
	 * @param {string} pHash
	 */
	bindCurrentHelpToRoute(pHash)
	{
		if (!this._platformDocsEditMode() || !pHash) { return; }
		const tmpRoute = ((typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '').replace(/^#/, '') || '/';
		this._bindRouteToHashAsync(tmpRoute, pHash, () => this._renderPlatformHelp(pHash));
	}

	/** A help Area slug derived from a route (the first path segment) — the namespace for its `Doc-<Area>-<Topic>` hashes. */
	_deriveHelpAreaFromRoute(pRoute)
	{
		const tmpFirst = String(pRoute || '/').replace(/^\/+/, '').split('/')[0] || '';
		return tmpFirst.replace(/[^A-Za-z0-9]+/g, '') || 'General';
	}

	/**
	 * The header "Add help for this page" entry point — available on ANY route (works whether the page currently
	 * shows a platform doc, a file-based doc, or nothing). Creates a topic in an area derived from the route and,
	 * when the page has no platform topic yet, binds the new topic to the route so F1 opens it here.
	 */
	addHelpForCurrentRoute()
	{
		if (!this._platformDocsEditMode()) { return; }
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (!tmpContentView || (typeof tmpContentView.displayContent !== 'function')) { return; }
		const tmpRoute = ((typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '').replace(/^#/, '') || '/';
		this.toggleHelp(true);
		// We're taking over the shared panel with our own content; flag it so leaving the route restores app docs.
		this._helpShowingForeignDocs = true;
		// Not viewing a platform topic while the add form is up — so Cancel re-resolves the route rather than
		// restoring a stale topic from a previously-visited platform route.
		this._activePlatformHelpHash = '';
		this._addingTopic = { Area: this._deriveHelpAreaFromRoute(tmpRoute), Route: tmpRoute, BindPrimary: !this._helpHashForRoute(tmpRoute), Error: '' };
		// The content body only exists after the content view has rendered once (a file-based route may not have
		// created it). Render it, then show the new-topic form in place.
		if ((typeof document !== 'undefined') && !document.getElementById('InlineDoc-Content-Body') && (typeof tmpContentView.render === 'function'))
		{
			tmpContentView.render();
		}
		tmpContentView.displayContent(this._platformNewTopicHTML());
		try { const tmpInput = document.getElementById('PlatformDoc-NewTopic-Title'); if (tmpInput) { tmpInput.focus(); } }
		catch (pError) { /* no focusable input */ }
	}

	/** Show/hide the header "Add help for this page" button by the current edit gate. */
	_syncAddPageHelpButton()
	{
		if (typeof document === 'undefined') { return; }
		const tmpButton = document.getElementById('PlatformConfig-AddPageHelp');
		if (!tmpButton) { return; }
		if (this._platformDocsEditMode()) { tmpButton.classList.remove('is-hidden'); }
		else { tmpButton.classList.add('is-hidden'); }
	}

	// ── Navigation style (pict-section-navigation) ─────────────────────────────

	/** The persisted navigation style ('Sidebar' | 'Hub' | 'List' | 'Palette'); default List. */
	get navigationStyle()
	{
		let tmpStyle = null;
		try { tmpStyle = (typeof window !== 'undefined' && window.localStorage) ? window.localStorage.getItem(NAV_STYLE_STORAGE_KEY) : null; }
		catch (pError) { tmpStyle = null; }
		const tmpProvider = this.pict.providers['Pict-Navigation'];
		const tmpValid = tmpProvider ? tmpProvider.getRenderTypes().some((pType) => pType.Key === tmpStyle) : false;
		return tmpValid ? tmpStyle : NAV_STYLE_DEFAULT;
	}

	/** Persist + apply a navigation style. Returns the applied style. */
	setNavigationStyle(pStyle)
	{
		try { if (typeof window !== 'undefined' && window.localStorage) { window.localStorage.setItem(NAV_STYLE_STORAGE_KEY, pStyle); } }
		catch (pError) { /* private mode — non-fatal */ }
		this.pict.AppData.NavRenderType = pStyle;
		this.applyNavigationStyle(pStyle);
		return pStyle;
	}

	/**
	 * Apply a navigation style to the app shell. Rail styles (Sidebar) dock the
	 * persistent navigation rail and shift the content right; page styles (Hub/List/
	 * Palette) undock it (the Configurations screen renders the nav as a home screen).
	 *
	 * @param {string} [pStyle]
	 */
	applyNavigationStyle(pStyle)
	{
		const tmpProvider = this.pict.providers['Pict-Navigation'];
		if (!tmpProvider) { return; }
		const tmpStyle = pStyle || this.navigationStyle;
		if (tmpProvider.isRailRenderType(tmpStyle))
		{
			tmpProvider.renderSidebarDocked('#PlatformConfig-NavSidebar');
			this.pict.ContentAssignment.addClass('body', 'pc-nav-docked');
			this.syncNavSidebarActive();
		}
		else
		{
			this.pict.ContentAssignment.removeClass('body', 'pc-nav-docked');
		}
	}

	/** Move the docked rail's active highlight to match the current route (no-op for page styles). */
	syncNavSidebarActive()
	{
		const tmpProvider = this.pict.providers['Pict-Navigation'];
		if (!tmpProvider || typeof tmpProvider.isRailRenderType !== 'function' || !tmpProvider.isRailRenderType(this.navigationStyle)) { return; }
		const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
		tmpProvider.setActiveByRoute(tmpHash);
		const tmpView = this.pict.views['Navigation-Sidebar-Docked'];
		if (tmpView && typeof tmpView.syncActive === 'function') { tmpView.syncActive(); }
	}

	/**
	 * Paint (or clear) the return-context banner. When a user jumps from a Project/Contract Type editor into a
	 * prototype's first-class editor, ProjectContractTypes-Provider stows `AppData.PrototypeSetupContext`; this shows a
	 * bar with a link back to the type. Back on the type editor route (the ReturnHash), the context is cleared.
	 * Called from the router `before` hook so it stays correct on every route.
	 */
	syncTemplateContextBanner()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement('#PlatformConfig-TemplateContextBanner').length === 0) { return; }
		const tmpCtx = this.pict.AppData.PrototypeSetupContext;
		const tmpHash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
		const tmpOnType = !!(tmpCtx && tmpCtx.ReturnHash && tmpHash && (tmpHash === tmpCtx.ReturnHash));
		if (!tmpCtx || !tmpCtx.ReturnHash || tmpOnType)
		{
			if (tmpOnType) { this.pict.AppData.PrototypeSetupContext = null; }
			tmpCA.assignContent('#PlatformConfig-TemplateContextBanner', '');
			return;
		}
		const tmpName = String(tmpCtx.TypeName || 'this type').replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
		tmpCA.assignContent('#PlatformConfig-TemplateContextBanner',
			`<div style="background:var(--theme-color-brand-primary,#2e7d74);color:#fff;padding:0.5rem 1.25rem;font-size:0.85rem;display:flex;align-items:center;gap:0.7rem;flex-wrap:wrap;">`
			+ `<i class="fas fa-wand-magic-sparkles"></i><span>Editing the template for <b>${tmpName}</b></span>`
			+ `<a href="${tmpCtx.ReturnHash}" style="color:#fff;font-weight:700;text-decoration:underline;">← Back to type</a></div>`);
	}

	/**
	 * One-time wiring of the navigation shell: bind the ⌘K/Ctrl+K launcher hotkey and the
	 * F1 help hotkey, then apply the stored navigation style (docking the rail if Sidebar).
	 */
	_initializeNavigationShell()
	{
		if (this._navShellInitialized) { return; }
		this._navShellInitialized = true;

		const tmpProvider = this.pict.providers['Pict-Navigation'];
		if (tmpProvider && typeof tmpProvider.bindLauncherHotkey === 'function')
		{
			// ⌘K / Ctrl+K opens the command-palette launcher overlay; Escape closes it.
			tmpProvider.bindLauncherHotkey();
		}
		this._bindGlobalHelpHotkey();
		this.applyNavigationStyle(this.navigationStyle);
	}

	/**
	 * F1 toggles the documentation panel. A browser-level global shortcut has no inline
	 * handler equivalent, so this addEventListener is a documented exception to the pict
	 * "inline handlers only" rule (same category as the navigation launcher hotkey).
	 */
	_bindGlobalHelpHotkey()
	{
		if (typeof document === 'undefined' || this._helpHotkeyBound) { return; }
		this._helpHotkeyBound = true;
		document.addEventListener('keydown', (pEvent) =>
		{
			if (pEvent && pEvent.key === 'F1')
			{
				pEvent.preventDefault();
				this.toggleHelp();
			}
		}, true);
	}

	/** True when the logged-in session belongs to the Headlight customer (CustomerID === 1). */
	isHeadlightSession()
	{
		const tmpUser = this.pict.AppData.CurrentUser;
		return !!(tmpUser && Number(tmpUser.CustomerID) === 1);
	}

	/**
	 * Install the pict-section-navigation global filter. The filter runs on every nav surface —
	 * the sidebar, the topic/list pages, and the ⌘K launcher search — so it is the single place to
	 * gate visibility. Gates today:
	 *   - `Hidden: true` (item OR its category) drops the entry everywhere. A category-level Hidden
	 *     drops all of its children, which leaves the category with zero items so it disappears too.
	 *     Used to pilot Analytics out of the nav (see navigation-graph.js).
	 *   - `Headlight: true` items (e.g. Customers) are gated to the Headlight session. The predicate
	 *     reads the session live, so it stays correct no matter when CustomerID is populated.
	 *   - `SuperUser: true` items (e.g. Grant Access) are platform-super-user only; `AlsoSuperUser: true`
	 *     items are always shown to super-users. Otherwise super-users pass the SAME capability gate as
	 *     everyone else (which they satisfy as allow-all), so a HeadLight super-admin keeps the full
	 *     capability-gated management surface for its own tenant instead of a stripped platform-only one.
	 *   - the capability gate (`_navItemPermitted`): a Module, an explicit Capability, or `<Entity>-Read`
	 *     derived from a `#/PSRS/<Entity>/List` route.
	 */
	_applyCustomerNavGate()
	{
		const tmpProvider = this.pict.providers['Pict-Navigation'];
		if (!tmpProvider || typeof tmpProvider.setGlobalFilter !== 'function') { return; }
		tmpProvider.setGlobalFilter((pItem, pCategory) =>
		{
			if (pItem.Hidden || (pCategory && pCategory.Hidden)) { return false; }
			const tmpSuperUser = this._isSuperUser();
			// `SuperUser: true` destinations (e.g. Grant Access) are platform-super-user only.
			if (pItem.SuperUser && !tmpSuperUser) { return false; }
			// Super-users always keep their platform tiles (SuperUser / AlsoSuperUser) regardless of capability.
			if (tmpSuperUser && ((pItem.SuperUser === true) || (pItem.AlsoSuperUser === true))) { return true; }
			// Everyone else — INCLUDING level-5 HeadLight super-users, for every non-platform tile — passes the normal
			// Headlight / module / capability gate. Super-users satisfy the capability checks (EffectivePermissionsService
			// treats IsSuperUser as allow-all), so a HeadLight (customer-1) super-admin sees the full management surface
			// again — Users, Access & Permissions, Entitlements, project assignments — and administers HeadLight's own
			// tenant; every other customer's users still see only the tiles their granted capabilities permit.
			return (!pItem.Headlight || this.isHeadlightSession())
				&& (!pItem.CustomerModule || this._customerHasModule(pItem.CustomerModule))
				&& this._navItemPermitted(pItem);
		});
	}

	/**
	 * A micro app whose manifest names `Access.RequiredModule` (the LIMS micro app: 'LIMS') signs out a user the
	 * customer's permission enforcement refuses that module, as legacy apps do through permissions-control. Every
	 * other session, and the config app itself, passes.
	 * @return {Promise<boolean>} false when the user was refused and is being signed out
	 */
	async _microAppAccessAllowedAsync()
	{
		const tmpMicroApp = this.pict.providers.MicroApp;
		const tmpModule = tmpMicroApp && tmpMicroApp.manifest && tmpMicroApp.manifest.Access && tmpMicroApp.manifest.Access.RequiredModule;
		if (!tmpModule || this._isSuperUser())
		{
			return true;
		}
		const tmpCurrentUser = (this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		const tmpEffectivePermissions = this.fable.EffectivePermissionsService;
		const tmpHasPermission = !!(tmpEffectivePermissions && tmpEffectivePermissions.currentUserReady() && tmpEffectivePermissions.canModule(tmpModule));
		if (tmpHasPermission)
		{
			return true;
		}
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		const tmpConfiguration = await new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`Configuration/For/PermissionsEnforcement/In/Customer/${tmpCurrentUser.CustomerID}`, (pError, pBody) => resolve(pError ? null : pBody));
		});
		const tmpEnforcement = libModuleAccess.resolveModuleEnforcement(tmpConfiguration, tmpCurrentUser.CustomerID, tmpModule);
		if (!libModuleAccess.isModuleAccessDenied(tmpEnforcement, tmpHasPermission))
		{
			return true;
		}
		const tmpAppName = (tmpMicroApp.manifest.Branding && tmpMicroApp.manifest.Branding.Title) || tmpMicroApp.manifest.Name || 'this app';
		const tmpPanels = this.pict.views.HeadlightPanels;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast({ type: 'is-danger', message: `You don't have access to ${tmpAppName}. Ask your administrator if you need it.` });
		}
		this.logout();
		return false;
	}

	/**
	 * Does the current customer have a Module enabled (a CustomerModuleJoin for the session's customer with `now`
	 * inside [StartDate, EndDate])? This is the ENTITY-level per-customer enablement (a level-5 admin toggles it
	 * in Manage Customers), NOT the role-permission `Module-<X>-Access` gate that EffectivePermissionsService
	 * .canModule() checks. Fail-CLOSED: unknown until loadCustomerModulesAsync() has populated AppData
	 * (awaited at login before the nav gate installs), so a gated download never flashes before it's confirmed.
	 * @param {String} pModuleHash
	 * @return {Boolean}
	 */
	_customerHasModule(pModuleHash)
	{
		const tmpState = this.pict.AppData.CustomerModules;
		if (!tmpState || !tmpState.Ready) { return false; }
		return (tmpState.Hashes || []).indexOf(pModuleHash) > -1;
	}

	/**
	 * Load the current customer's enabled modules into AppData.CustomerModules. Reads are customer-scoped on the
	 * server, so this returns only the session customer's CustomerModuleJoin rows; we keep the ones whose
	 * [StartDate, EndDate] window contains now. Best-effort — a failure yields an empty (fail-closed) set.
	 * @return {Promise<{Ready:Boolean, Hashes:Array}>}
	 */
	async loadCustomerModulesAsync()
	{
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		try
		{
			const tmpRows = await new Promise((resolve, reject) =>
			{
				tmpRestClient.getJSON('CustomerModuleJoins/0/500', (pError, pBody) => pError ? reject(pError) : resolve(pBody));
			});
			const tmpNow = (new Date()).toISOString();
			const tmpHashes = (Array.isArray(tmpRows) ? tmpRows : [])
				.filter((pRow) => (!pRow.StartDate || String(pRow.StartDate) <= tmpNow) && (!pRow.EndDate || String(pRow.EndDate) >= tmpNow))
				.map((pRow) => pRow.ModuleHash)
				.filter((pHash) => !!pHash);
			this.pict.AppData.CustomerModules = { Ready: true, Hashes: tmpHashes };
		}
		catch (pError)
		{
			this.pict.AppData.CustomerModules = { Ready: true, Hashes: [] };
		}
		return this.pict.AppData.CustomerModules;
	}

	/**
	 * Permission-expression layer: may the current user see this nav entry? Gated by the resolved capability
	 * map — an explicit `Module`/`Capability` on the entry, else derived from a `#/PSRS/<Entity>/List` route
	 * (needs `<Entity>-Read`). Entries with no derivable capability (bespoke topics) are always shown, and
	 * everything shows until the capability map has loaded (fail-open; the server stays authoritative).
	 * @param {Object} pItem
	 * @return {Boolean}
	 */
	_navItemPermitted(pItem)
	{
		const tmpEffectivePermissions = this.fable.EffectivePermissionsService;
		if (!tmpEffectivePermissions || !tmpEffectivePermissions.currentUserReady())
		{
			return true;
		}
		if (pItem.Module)
		{
			return tmpEffectivePermissions.canModule(pItem.Module);
		}
		if (pItem.Capability)
		{
			return tmpEffectivePermissions.canHash(pItem.Capability);
		}
		const tmpMatch = /#?\/PSRS\/([A-Za-z0-9_]+)\/(List|Read)/.exec(String(pItem.Route || ''));
		if (tmpMatch)
		{
			return tmpEffectivePermissions.canHash(`${tmpMatch[1]}-Read`);
		}
		return true;
	}

	/**
	 * Role-aware dashboards, embedded: the shared dashboard host plus this app's answer to each action a dashboard can
	 * take. Micro apps inherit these; a dashboard never needs to know which app it is in.
	 */
	installDashboards()
	{
		const tmpDashboards = libHeadlightDashboards.install(this.pict,
			{
				AppChrome: false,
				RouteBase: '/Dashboards',
				DestinationAddress: '#PlatformConfiguration-Application-Container',
				// A micro app that lands on /Dashboards names its own home for people with no landing dashboard.
				getFallbackRoute: () =>
				{
					const tmpMicroApp = this.pict.providers.MicroApp;
					return (tmpMicroApp && tmpMicroApp.manifest && tmpMicroApp.manifest.Dashboards && tmpMicroApp.manifest.Dashboards.FallbackRoute) || null;
				},
				// A micro app can show each dashboard's Description under its title.
				getShowDescriptions: () =>
				{
					const tmpMicroApp = this.pict.providers.MicroApp;
					return !!(tmpMicroApp && tmpMicroApp.manifest && tmpMicroApp.manifest.Dashboards && (tmpMicroApp.manifest.Dashboards.ShowDescriptions === true));
				},
				// A micro app guards /PSRS/:RecordSet/* by its Entities list; a dashboard the person was granted gets its
				// recordset added so the list's paging and search links work.
				onRecordSetPrepared: (pRecordSet) =>
				{
					const tmpMicroApp = this.pict.providers.MicroApp;
					const tmpEntities = tmpMicroApp && tmpMicroApp.manifest && tmpMicroApp.manifest.Routes && tmpMicroApp.manifest.Routes.Entities;
					if (Array.isArray(tmpEntities) && tmpEntities.length > 0 && !tmpEntities.includes(pRecordSet))
					{
						tmpEntities.push(pRecordSet);
					}
				},
			});
		const fNavigate = (pRoute) =>
		{
			libWorkspaceConfigs.noteRouteChange(window.location.hash, pRoute);
			return this.pict.providers.PictRouter.navigate(pRoute);
		};
		tmpDashboards.actions.registerHandler('Sample.Open', (pAction) => fNavigate(`/Sample/Workspace/${pAction.IDSample}`));
		tmpDashboards.actions.registerHandler('Sample.Receive', (pAction) => fNavigate(`/Sample/Workspace/${pAction.IDSample}`));
		tmpDashboards.actions.registerHandler('Project.Open', (pAction) => fNavigate(`/Project/Workspace/${pAction.IDProject}`));
		tmpDashboards.actions.registerHandler('Material.Open', (pAction) => fNavigate(`/Material/Workspace/${pAction.IDMaterial}`));
		// A sample's form opens in that sample's Documents tab, where the rest of its work is; anything else renders in a new tab.
		tmpDashboards.actions.registerHandler('Document.Open', (pAction) =>
		{
			const tmpSampleWorkspace = this.pict.providers.SampleWorkspace;
			if ((pAction.IDSample > 0) && tmpSampleWorkspace && (typeof tmpSampleWorkspace.openSampleDocument === 'function'))
			{
				tmpSampleWorkspace.openSampleDocument(pAction.IDSample, pAction.IDDocument);
				return;
			}
			this.pict.HeadlightDocumentRender.openDocument(pAction.IDDocument, { target: '_blank' });
		});
		tmpDashboards.actions.registerHandler('Sample.Create', (pAction) =>
		{
			const tmpSampleWorkspace = this.pict.providers.SampleWorkspace;
			if (tmpSampleWorkspace && typeof tmpSampleWorkspace.prefillNew === 'function')
			{
				tmpSampleWorkspace.prefillNew({ IDProject: pAction.IDProject, IDLineItem: pAction.IDLineItem, IDMaterial: pAction.IDMaterial, SampleType: pAction.SampleType });
			}
			fNavigate('/PSRS/Sample/Create');
		});
	}

	/** Resolve a topic config from a route like '/Users' (leading '#' optional), or null. */
	topicForRoute(pRoute)
	{
		const tmpRoute = '#' + String(pRoute || '').replace(/^#/, '');
		const tmpConfigs = libNavigationTopics.TOPIC_CONFIGS;
		return Object.keys(tmpConfigs).map((pKey) => tmpConfigs[pKey]).find((pTopic) => pTopic.Route === tmpRoute) || null;
	}

	/**
	 * Fetch the platform KPI counts into AppData.DashboardStats — used by the Dashboard view
	 * and the nav-page jumbotrons. Mirrors the Dashboard loader so counts are available even
	 * when the Dashboard itself is never visited. Re-renders the active nav page on completion
	 * so its KPI values update from placeholders to real numbers.
	 */
	loadDashboardStatsAsync(fCallback)
	{
		const fDone = (typeof fCallback === 'function') ? fCallback : (() => {});
		if (!this.pict.AppData.DashboardStats)
		{
			this.pict.AppData.DashboardStats = {};
			libNavigationTopics.KPI_ENDPOINTS.forEach((pStat) => { this.pict.AppData.DashboardStats[pStat.Key] = '...'; });
		}
		const tmpSession = this.pict.AppData.CurrentUser;
		if (tmpSession)
		{
			this.pict.AppData.DashboardStats.UserName = `${tmpSession.NameFirst || ''} ${tmpSession.NameLast || ''}`.trim() || 'User';
		}
		const tmpRestClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		if (!tmpRestClient)
		{
			this.pict.log.warn('HeadlightRestClient not available for KPI counts.');
			return fDone();
		}

		let tmpCompleted = 0;
		const tmpTotal = libNavigationTopics.KPI_ENDPOINTS.length;
		libNavigationTopics.KPI_ENDPOINTS.forEach((pStat) =>
		{
			tmpRestClient.getJSON(pStat.Endpoint, (pError, pBody) =>
			{
				this.pict.AppData.DashboardStats[pStat.Key] = (!pError && pBody != null) ? (pBody.Count != null ? pBody.Count : pBody) : '--';
				// Re-paint as each count lands (debounced) so the jumbotron fills progressively and never
				// blocks on the slowest — or a non-responding — endpoint. The old all-complete gate left the
				// strip on placeholders until every count returned (or forever, if one never called back),
				// which is the "KPIs don't load until reload" race.
				this._scheduleKpiRefresh();
				if (++tmpCompleted >= tmpTotal)
				{
					fDone();
				}
			});
		});
	}

	/**
	 * Re-paint the active nav page's KPI strip from the latest DashboardStats. Targets the strip DOM
	 * in place (not a full view render) so it can't be dropped by the route latest-wins guard and does
	 * not rebuild the whole nav. Works for the Settings full browser and the scoped topic pages alike.
	 */
	_refreshNavPageKpis()
	{
		const tmpRoute = (typeof window !== 'undefined' && window.location && window.location.hash ? window.location.hash : '').replace(/^#/, '');
		const tmpTopic = (tmpRoute === '/Settings' || tmpRoute === '/Configurations' || tmpRoute === '' || tmpRoute === '/')
			? libNavigationTopics.TOPIC_CONFIGS.Settings
			: this.topicForRoute(tmpRoute);
		if (!tmpTopic) { return; }
		this.pict.AppData.NavKpis = libNavigationTopics.buildKpiRecords(this.pict.AppData.DashboardStats, tmpTopic.KpiKeys, this.isHeadlightSession());
		if (this.pict.ContentAssignment.getElement('.nav-kpi-strip').length > 0)
		{
			const tmpHTML = (this.pict.AppData.NavKpis || []).map((pKpi) => this.pict.parseTemplateByHash('Nav-Kpi-Card', pKpi)).join('');
			this.pict.ContentAssignment.assignContent('.nav-kpi-strip', tmpHTML);
		}
	}

	/** Debounced trigger for _refreshNavPageKpis — coalesces the rapid per-count updates into one paint. */
	_scheduleKpiRefresh()
	{
		if (this._kpiRefreshTimer) { clearTimeout(this._kpiRefreshTimer); }
		this._kpiRefreshTimer = setTimeout(() => { this._kpiRefreshTimer = null; this._refreshNavPageKpis(); }, 100);
	}

	/**
	 * Wrap the PSRS MeadowEndpoints providers for the named recordsets with the
	 * Settings translation adapter. Each provider's `getRecord` / `getRecords`
	 * gets `toDisplay` applied to outgoing records; `createRecord` / `updateRecord`
	 * apply `fromDisplay` to incoming records.
	 *
	 * @param {Array<string>} pRecordSetNames
	 */
	_installSettingsAdapterForRecordSets(pRecordSetNames)
	{
		const tmpMetaController = this.pict.services.PictSectionRecordSet;
		if (!tmpMetaController || !tmpMetaController.recordSetProviders)
		{
			this.pict.log.error('SettingsAdapter wiring: PictSectionRecordSet service or providers not available.');
			return;
		}
		for (const tmpRecordSet of pRecordSetNames)
		{
			const tmpProvider = tmpMetaController.recordSetProviders[tmpRecordSet];
			if (!tmpProvider)
			{
				this.pict.log.warn(`SettingsAdapter wiring: provider for ${tmpRecordSet} not found — skipping.`);
				continue;
			}
			const tmpOriginalGetRecord = tmpProvider.getRecord ? tmpProvider.getRecord.bind(tmpProvider) : null;
			const tmpOriginalGetRecordByGUID = tmpProvider.getRecordByGUID ? tmpProvider.getRecordByGUID.bind(tmpProvider) : null;
			const tmpOriginalReadRecord = tmpProvider.readRecord ? tmpProvider.readRecord.bind(tmpProvider) : null;
			const tmpOriginalGetRecords = tmpProvider.getRecords ? tmpProvider.getRecords.bind(tmpProvider) : null;
			const tmpOriginalCreate = tmpProvider.createRecord ? tmpProvider.createRecord.bind(tmpProvider) : null;
			const tmpOriginalUpdate = tmpProvider.updateRecord ? tmpProvider.updateRecord.bind(tmpProvider) : null;
			if (tmpOriginalGetRecord)
			{
				tmpProvider.getRecord = async (pIDOrGuid) =>
				{
					const tmpRecord = await tmpOriginalGetRecord(pIDOrGuid);
					libContractProjectTypesSettingsAdapter.toDisplay(tmpRecord);
					await this._loadTypeStatusesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadTypeDefaultDatesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadContractTypeAllowedProjectTypesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadPrototypeIntoDisplay(tmpRecordSet, tmpRecord);
					return tmpRecord;
				};
			}
			if (tmpOriginalGetRecordByGUID)
			{
				tmpProvider.getRecordByGUID = async (pGuid) =>
				{
					const tmpRecord = await tmpOriginalGetRecordByGUID(pGuid);
					libContractProjectTypesSettingsAdapter.toDisplay(tmpRecord);
					await this._loadTypeStatusesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadTypeDefaultDatesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadContractTypeAllowedProjectTypesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadPrototypeIntoDisplay(tmpRecordSet, tmpRecord);
					return tmpRecord;
				};
			}
			if (tmpOriginalReadRecord)
			{
				tmpProvider.readRecord = async (pIDOrGuid) =>
				{
					const tmpRecord = await tmpOriginalReadRecord(pIDOrGuid);
					libContractProjectTypesSettingsAdapter.toDisplay(tmpRecord);
					await this._loadTypeStatusesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadTypeDefaultDatesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadContractTypeAllowedProjectTypesIntoDisplay(tmpRecordSet, tmpRecord);
					await this._loadPrototypeIntoDisplay(tmpRecordSet, tmpRecord);
					return tmpRecord;
				};
			}
			if (tmpOriginalGetRecords)
			{
				tmpProvider.getRecords = async (pOptions) =>
				{
					const tmpResult = await tmpOriginalGetRecords(pOptions);
					if (tmpResult && Array.isArray(tmpResult.Records))
					{
						tmpResult.Records.forEach((pRecord) => libContractProjectTypesSettingsAdapter.toDisplay(pRecord));
					}
					else if (Array.isArray(tmpResult))
					{
						tmpResult.forEach((pRecord) => libContractProjectTypesSettingsAdapter.toDisplay(pRecord));
					}
					return tmpResult;
				};
			}
			if (tmpOriginalCreate)
			{
				tmpProvider.createRecord = async (pRecord) =>
				{
					// ProjectType / ContractType: route through the canonical comprehension
					// save (the type + its prototype shell, then statuses; contract types also
					// carry default-date definitions). The spreadsheet ImportProvider uses the
					// same provider, so editor- and import-created types are identical.
					if (tmpRecordSet === 'ProjectType')
					{
						return this._typeSaveProvider.saveProjectType(pRecord, true);
					}
					if (tmpRecordSet === 'ContractType')
					{
						return this._typeSaveProvider.saveContractType(pRecord, true);
					}
					return tmpOriginalCreate(pRecord);
				};
			}
			if (tmpOriginalUpdate)
			{
				tmpProvider.updateRecord = async (pRecord) =>
				{
					if (tmpRecordSet === 'ProjectType')
					{
						return this._typeSaveProvider.saveProjectType(pRecord, false);
					}
					if (tmpRecordSet === 'ContractType')
					{
						return this._typeSaveProvider.saveContractType(pRecord, false);
					}
					return tmpOriginalUpdate(pRecord);
				};
			}
			this.pict.log.info(`SettingsAdapter wired to ${tmpRecordSet} PSRS provider.`);
		}
	}

	/**
	 * Wrap the User recordset provider's createRecord so a new user's "Login Password" actually establishes a
	 * login credential. The generic create form exposes LoginPassword (a raw User column), but POSTing it to
	 * /1.0/User does NOT set the credential the login checks — that is only done by POST /1.0/Password (exactly
	 * what the bespoke "Reset Password" action calls). So: capture the entered password, keep it OUT of the User
	 * POST (never persist the plaintext column), create the user, then set the credential in the follow-up call
	 * the server honors. On failure the user still exists (password-less, same as before this fix) and the admin
	 * is told to use Reset Password. Idempotent.
	 */
	_installUserPasswordOnCreate()
	{
		const tmpMetaController = this.pict.services.PictSectionRecordSet;
		if (!tmpMetaController || !tmpMetaController.recordSetProviders) { return; }
		const tmpProvider = tmpMetaController.recordSetProviders['User'];
		if (!tmpProvider || (typeof tmpProvider.createRecord !== 'function') || tmpProvider._userPasswordOnCreateWrapped)
		{
			if (!tmpProvider) { this.pict.log.warn('User password-on-create wiring: User PSRS provider not found — skipping.'); }
			return;
		}
		tmpProvider._userPasswordOnCreateWrapped = true;
		const tmpOriginalCreate = tmpProvider.createRecord.bind(tmpProvider);
		tmpProvider.createRecord = async (pRecord) =>
		{
			let tmpPassword = '';
			let tmpRecordToCreate = pRecord;
			if (pRecord && pRecord.LoginPassword)
			{
				tmpPassword = String(pRecord.LoginPassword);
				tmpRecordToCreate = Object.assign({}, pRecord);
				delete tmpRecordToCreate.LoginPassword;   // don't persist the plaintext column; the credential is set below
			}
			const tmpResult = await tmpOriginalCreate(tmpRecordToCreate);
			const tmpIDUser = tmpResult && (tmpResult.IDUser || (tmpResult.Record && tmpResult.Record.IDUser));
			if (tmpPassword && tmpIDUser)
			{
				try
				{
					await this._setUserPasswordAsync(tmpIDUser, tmpPassword);
				}
				catch (pError)
				{
					this.pict.log.error(`User create: could not set the initial password for user ${tmpIDUser}: ${pError && pError.message ? pError.message : pError}`, pError);
					const tmpModal = this.pict.views['Pict-Section-Modal'];
					if (tmpModal && (typeof tmpModal.toast === 'function'))
					{
						tmpModal.toast('User created, but the login password could not be set — open the user and use “Reset Password”.', { type: 'warning', duration: 8000 });
					}
				}
			}
			return tmpResult;
		};
		this.pict.log.info('User password-on-create wired (POST /1.0/Password after User create).');
	}

	/**
	 * Upload a photo held by the form's ObservationPhoto field once the record saves (see RecordPhotoUploadAfterSave).
	 *
	 * @param {Array<string>} pRecordSetNames - recordsets whose entity has a photo field
	 */
	_installPhotoUploadAfterSave(pRecordSetNames)
	{
		libRecordPhotoUploadAfterSave.installPhotoUploadAfterSave(this.pict, pRecordSetNames);
	}

	/**
	 * Set a user's login credential via POST /1.0/Password (the same endpoint the UserWorkspace "Reset Password"
	 * action uses). Raw fetch with the session cookie — the JSON rest client can't carry this bespoke endpoint.
	 * @param {Number} pIDUser @param {String} pPassword @returns {Promise}
	 */
	_setUserPasswordAsync(pIDUser, pPassword)
	{
		const tmpClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
		const tmpPrefix = (tmpClient && tmpClient.options && tmpClient.options.ServerURL) || '/1.0/';
		return fetch(`${tmpPrefix}Password`,
			{
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ IDUser: pIDUser, NewPassword: pPassword }),
			}).then((pResponse) =>
		{
			if (!pResponse.ok) { throw new Error(`server returned ${pResponse.status}`); }
			return pResponse.json().catch(() => null).then((pBody) =>
			{
				if (pBody && (pBody.Success === false)) { throw new Error(pBody.Error || 'password not set'); }
				return pBody;
			});
		});
	}

	/**
	 * @returns {*} The shared HeadlightRestClient used for the non-CRUD /Statuses
	 * endpoints, or null when it isn't registered.
	 */
	get _typeStatusRestClient()
	{
		return (this.fable && this.fable.HeadlightRestClient) ||
			(this.pict && this.pict.fable && this.pict.fable.HeadlightRestClient) ||
			(this.pict && this.pict.HeadlightRestClient) ||
			null;
	}

	/**
	 * The primary-key field name for a type recordset.
	 *
	 * @param {string} pEntity - 'ProjectType' | 'ContractType'
	 * @returns {string}
	 */
	_typeStatusIDField(pEntity)
	{
		return (pEntity === 'ContractType') ? 'IDContractType' : 'IDProjectType';
	}

	/**
	 * @returns {*} the shared TypeComprehensionSaveProvider fable service (owns the
	 * build-comprehension -> push -> pointer -> prune -> statuses save for both types).
	 */
	get _typeSaveProvider()
	{
		return (this.fable && this.fable.TypeComprehensionSaveProvider) ||
			(this.fable && this.fable.serviceManager && this.fable.serviceManager.instantiateServiceProvider('TypeComprehensionSaveProvider', {})) ||
			null;
	}

	/**
	 * Fetch a type's status lists from GET /1.0/{Entity}/:id/Statuses and write
	 * them into `record._DisplaySettings.*` so the editor textareas render them.
	 * No-ops (leaving empty display values) when the record has no id yet or the
	 * endpoint is unreachable.
	 *
	 * @param {string} pEntity
	 * @param {Object} pRecord
	 * @returns {Promise<Object>} the same record
	 */
	async _loadTypeStatusesIntoDisplay(pEntity, pRecord)
	{
		if (!pRecord)
		{
			return pRecord;
		}
		const tmpID = pRecord[this._typeStatusIDField(pEntity)];
		const tmpClient = this._typeStatusRestClient;
		if (!tmpID || !tmpClient)
		{
			return pRecord;
		}
		const tmpPayload = await new Promise((resolve) =>
		{
			tmpClient.getJSON(`${pEntity}/${tmpID}/Statuses`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.warn(`Could not load ${pEntity} statuses for ID ${tmpID}.`, { Error: pError.message });
					return resolve(null);
				}
				return resolve(pBody || null);
			});
		});
		if (!pRecord._DisplaySettings)
		{
			pRecord._DisplaySettings = {};
		}
		Object.assign(pRecord._DisplaySettings, libContractProjectTypesSettingsAdapter.statusPayloadToDisplay(tmpPayload || {}));
		return pRecord;
	}

	/**
	 * Fetch a contract type's allowed project types from
	 * GET /1.0/ContractType/:id/AllowedProjectTypes (a flat array of numeric
	 * IDProjectType values) and write two display values onto the record:
	 *   - `_DisplaySettings.AllowedProjectTypeIDs`       — comma-joined IDs; the
	 *     Edit picker (Entity ProjectType, ValueField IDProjectType) binds
	 *     this and renders each as its ProjectType Name.
	 *   - `_DisplaySettings.AllowedProjectTypeNamesText` — comma-joined Names,
	 *     for the read-only View manifest (no picker to resolve IDs → Names).
	 * No-ops for non-ContractType recordsets, and when the record has no id yet
	 * or the endpoint is unreachable.
	 *
	 * @param {string} pEntity
	 * @param {Object} pRecord
	 * @returns {Promise<Object>} the same record
	 */
	async _loadContractTypeAllowedProjectTypesIntoDisplay(pEntity, pRecord)
	{
		if (pEntity !== 'ContractType' || !pRecord)
		{
			return pRecord;
		}
		const tmpID = pRecord[this._typeStatusIDField(pEntity)];
		const tmpClient = this._typeStatusRestClient;
		if (!tmpID || !tmpClient)
		{
			return pRecord;
		}
		const tmpIDs = await new Promise((resolve) =>
		{
			tmpClient.getJSON(`${pEntity}/${tmpID}/AllowedProjectTypes`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.warn(`Could not load ${pEntity} allowed project types for ID ${tmpID}.`, { Error: pError.message });
					return resolve([]);
				}
				return resolve(Array.isArray(pBody) ? pBody.map((pV) => String(pV)) : []);
			});
		});
		// Resolve IDs → Names for the read-only View. The Edit picker resolves
		// names itself from its ProjectType option set, so this lookup is only
		// needed for the View text.
		const tmpNames = await new Promise((resolve) =>
		{
			if (tmpIDs.length === 0) return resolve([]);
			// Scope to this customer + a real page size — a bare `ProjectTypes` relies on the server default row cap
			// (~250) and can silently omit rows, leaving names blank on the read-only View for large catalogs.
			const tmpCustomerID = this.AppData.CurrentUser && this.AppData.CurrentUser.CustomerID;
			const tmpProjectTypesURL = tmpCustomerID
				? `ProjectTypes/FilteredTo/FBV~IDCustomer~EQ~${tmpCustomerID}/0/5000`
				: 'ProjectTypes/0/5000';
			tmpClient.getJSON(tmpProjectTypesURL, (pError, pBody) =>
			{
				if (pError || !Array.isArray(pBody)) return resolve([]);
				const tmpNameByID = {};
				for (const tmpType of pBody)
				{
					if (tmpType && tmpType.IDProjectType != null) tmpNameByID[String(tmpType.IDProjectType)] = tmpType.Name || '';
				}
				return resolve(tmpIDs.map((pID) => tmpNameByID[pID]).filter((pName) => pName && pName.length > 0));
			});
		});
		if (!pRecord._DisplaySettings)
		{
			pRecord._DisplaySettings = {};
		}
		Object.assign(pRecord._DisplaySettings,
			libContractProjectTypesSettingsAdapter.allowedProjectTypesPayloadToDisplay(tmpIDs, tmpNames));
		return pRecord;
	}

	/**
	 * Parse a type record's Settings defensively — it arrives as a parsed object
	 * (`Settings`) or, on some reads, a `SettingsJSON` string.
	 *
	 * @param {Object} pRecord
	 * @returns {Object}
	 */
	_parsePrototypeSettings(pRecord)
	{
		if (pRecord && pRecord.Settings && typeof pRecord.Settings === 'object')
		{
			return pRecord.Settings;
		}
		if (pRecord && typeof pRecord.SettingsJSON === 'string' && pRecord.SettingsJSON.length > 0)
		{
			try
			{
				const tmpParsed = JSON.parse(pRecord.SettingsJSON);
				return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : {};
			}
			catch (pError)
			{
				return {};
			}
		}
		return {};
	}

	/**
	 * Surface the (normally hidden) prototype on the type's View screen: write the prototype
	 * project's / contract's name into `_DisplaySettings.PrototypeProjectName` /
	 * `PrototypeProjectName` resp. `PrototypeContractName`. No-ops when there is no prototype
	 * pointer yet or the rest client is unavailable.
	 *
	 * (Name only — the PSRS read view's template set doesn't render HTML/clickable inputs, and
	 * HPC has no in-app Contract view, so no "open" link is shown for either.)
	 *
	 * @param {string} pEntity - 'ProjectType' | 'ContractType'
	 * @param {Object} pRecord
	 * @returns {Promise<Object>} the same record
	 */
	async _loadPrototypeIntoDisplay(pEntity, pRecord)
	{
		if ((pEntity !== 'ProjectType' && pEntity !== 'ContractType') || !pRecord)
		{
			return pRecord;
		}
		const tmpClient = this._typeStatusRestClient;
		if (!tmpClient)
		{
			return pRecord;
		}
		const tmpSettings = this._parsePrototypeSettings(pRecord);
		const tmpIsContract = (pEntity === 'ContractType');
		const tmpProtoEntity = tmpIsContract ? 'Contract' : 'Project';
		const tmpProtoIDField = tmpIsContract ? 'IDContract' : 'IDProject';
		const tmpProtoID = Number(tmpIsContract ? tmpSettings.PrototypeIDContract : tmpSettings.PrototypeIDProject) || 0;
		if (!tmpProtoID)
		{
			return pRecord;
		}
		const tmpPrototype = await new Promise((resolve) =>
		{
			tmpClient.getEntitySet(tmpProtoEntity, `FBV~${tmpProtoIDField}~EQ~${tmpProtoID}`, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`Could not load prototype ${tmpProtoEntity} ${tmpProtoID}.`, { Error: pError.message });
					return resolve(null);
				}
				return resolve((Array.isArray(pRecords) && pRecords[0]) ? pRecords[0] : null);
			}, 0, 1);
		});
		if (!tmpPrototype)
		{
			return pRecord;
		}
		if (!pRecord._DisplaySettings)
		{
			pRecord._DisplaySettings = {};
		}
		const tmpName = (typeof tmpPrototype.Name === 'string') ? tmpPrototype.Name : '';
		if (tmpIsContract)
		{
			pRecord._DisplaySettings.PrototypeContractName = tmpName;
		}
		else
		{
			pRecord._DisplaySettings.PrototypeProjectName = tmpName;
		}
		return pRecord;
	}

	/**
	 * Read a type's default-date definitions directly off the ProjectTypeDefaultDate /
	 * ContractTypeDefaultDate entity (filtered by the type id) and write them into
	 * `record._DisplaySettings.DefaultDates` for the Tabular RecordSet input — the same
	 * way the prototype joins load. No-ops when the record has no id yet or the rest
	 * client is unavailable.
	 *
	 * @param {string} pEntity - 'ProjectType' | 'ContractType'
	 * @param {Object} pRecord
	 * @returns {Promise<Object>} the same record
	 */
	async _loadTypeDefaultDatesIntoDisplay(pEntity, pRecord)
	{
		if (!pRecord)
		{
			return pRecord;
		}
		const tmpIDField = this._typeStatusIDField(pEntity);
		const tmpID = pRecord[tmpIDField];
		const tmpClient = this._typeStatusRestClient;
		if (!tmpID || !tmpClient)
		{
			return pRecord;
		}
		const tmpDateEntity = (pEntity === 'ContractType') ? 'ContractTypeDefaultDate' : 'ProjectTypeDefaultDate';
		const tmpRows = await new Promise((resolve) =>
		{
			tmpClient.getEntitySet(tmpDateEntity, `FBV~${tmpIDField}~EQ~${tmpID}`, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.warn(`Could not load ${tmpDateEntity} for ${tmpIDField} ${tmpID}.`, { Error: pError.message });
					return resolve([]);
				}
				return resolve(Array.isArray(pRecords) ? pRecords : []);
			}, 0, 200000);
		});
		if (!pRecord._DisplaySettings)
		{
			pRecord._DisplaySettings = {};
		}
		const tmpDates = tmpRows.map((pRow) => ({
			Hash: (pRow && typeof pRow.Hash === 'string') ? pRow.Hash : '',
			Name: (pRow && typeof pRow.Name === 'string') ? pRow.Name : '',
		}));
		pRecord._DisplaySettings.DefaultDates = tmpDates;
		// The read-only View binds to this pre-formatted string: a plain text input over the
		// object array renders "[object Object],..." (see ContractType-View.json). The Edit grid
		// still reads the structured DefaultDates array above.
		pRecord._DisplaySettings.DefaultDatesText = this._formatDefaultDatesForDisplay(tmpDates);
		return pRecord;
	}

	/**
	 * Render the default-date type definitions as a human-readable, read-only string —
	 * "Name (Hash)" per entry (or whichever of the two is present), comma-joined.
	 *
	 * @param {Array<{Hash?: string, Name?: string}>} pDates
	 * @returns {string}
	 */
	_formatDefaultDatesForDisplay(pDates)
	{
		const tmpDates = Array.isArray(pDates) ? pDates : [];
		return tmpDates
			.map((pRow) =>
			{
				const tmpName = (pRow && typeof pRow.Name === 'string') ? pRow.Name.trim() : '';
				const tmpHash = (pRow && typeof pRow.Hash === 'string') ? pRow.Hash.trim() : '';
				if (tmpName && tmpHash) return `${tmpName} (${tmpHash})`;
				return tmpName || tmpHash;
			})
			.filter((pText) => pText.length > 0)
			.join(', ');
	}

	/** Read the first entity matching a single-field equals filter, or null. */
	_readEntityByFilter(pEntity, pField, pValue)
	{
		const tmpClient = this._typeStatusRestClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient) return resolve(null);
			tmpClient.getEntitySet(pEntity, `FBV~${pField}~EQ~${pValue}`, (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords) || pRecords.length === 0) return resolve(null);
				return resolve(pRecords[0]);
			}, 0, 50);
		});
	}

	/** Parse a SettingsJSON string into an object (tolerant). */
	_parseSettingsJSON(pSettingsJSON)
	{
		if (typeof pSettingsJSON !== 'string' || pSettingsJSON.length === 0) return {};
		try
		{
			const tmpParsed = JSON.parse(pSettingsJSON); return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : {};
		}
		catch (pError)
		{
			return {};
		}
	}

	async onAfterLogout()
	{
		this.pict.ContentAssignment.addClass('#HeadlightLogin-Standard-Wrap', 'is-active');
		this.pict.ContentAssignment.removeClass('#HeadlightLogin-Standard-Wrap', 'is-hidden');
		this.pict.views.HeadlightLogin.customizeLoginPage(customLoginPageOptions);
		this.pict.views.HeadlightLogin.show();
	}
}

module.exports = PlatformConfiguration;

module.exports.default_configuration = (
	{
		Name: 'PlatformConfiguration',
		Hash: 'PlatformConfigurationApplication',
		InitializeOnLoad: true,
		AutoRender: false,
		// This is a ROUTER-DRIVEN application: the PlatformConfigurationRouter decides which
		// view occupies the application container, via resolveCurrentRoute() after login. The
		// base HeadlightConfigurableApplication still calls this.render() during its post-login
		// data-load cycle (onAfterLoadDataAsync), which paints MainViewportViewIdentifier into
		// the SAME container the router renders into. Pointing it at a real screen (it used to be
		// the KPI-tile 'PlatformConfigurationDashboard') made that screen flash on every load/deep-link
		// before the router resolved the intended route. 'Empty' renders nothing, so the router is the
		// single source of truth for what the user sees. (That Dashboard view has since been removed —
		// its stats were unreliable — and '/Dashboard' now redirects to the configuration home.)
		MainViewportViewIdentifier: 'Empty',
		Document:
	{
		Required: false,
	},
	});

module.exports.default_configuration.pict_configuration = (
	{
		'Product': 'PlatformConfiguration',
		'ProductVersion': '1.0.0',

		'PictApplicationConfiguration':
	{
		AutoRenderMainViewportViewAfterInitialize: false,
	},
		'IsHeadlightWebApplication': true,

		'Login':
	{
		Required: true,
	},

		'Manifests':
	{
		// List manifests
		'User-List': manifestUserList,
		'Customer-List': manifestCustomerList,
		'Organization-List': manifestOrganizationList,
		'Project-List': manifestProjectList,
		'Role-List': manifestRoleList,
		'ObservationManifest-List': manifestObservationManifestList,
		'ArtifactType-List': manifestArtifactTypeList,
		'ReportNamedInstance-List': manifestReportNamedInstanceList,
		'ObservationTag-List': manifestObservationTagList,
		'UserRoleJoin-List': manifestUserRoleJoinList,
		'RoleEdge-List': manifestRoleEdgeList,
		'RolePermission-List': manifestRolePermissionList,
		'ProjectTagType-List': manifestProjectTagTypeList,
		'DocumentApprovalWorkflow-List': manifestDocumentApprovalWorkflowList,
		'DocumentApprovalState-List': manifestDocumentApprovalStateList,
		'DocumentApprovalStep-List': manifestDocumentApprovalStepList,
		'ObservationApprovalWorkflow-List': manifestObservationApprovalWorkflowList,
		'ObservationApprovalState-List': manifestObservationApprovalStateList,
		'ObservationApprovalStep-List': manifestObservationApprovalStepList,
		'ContractType-List': manifestContractTypeList,
		'ProjectType-List': manifestProjectTypeList,
		'Contract-List': manifestContractList,

		// View (read) manifests
		'User-View': manifestUserView,
		'Customer-View': manifestCustomerView,
		'Organization-View': manifestOrganizationView,
		'Project-View': manifestProjectView,
		'Role-View': manifestRoleView,
		'ObservationManifest-View': manifestObservationManifestView,
		'ArtifactType-View': manifestArtifactTypeView,
		'ReportNamedInstance-View': manifestReportNamedInstanceView,
		'ObservationTag-View': manifestObservationTagView,
		'UserRoleJoin-View': manifestUserRoleJoinView,
		'RoleEdge-View': manifestRoleEdgeView,
		'RolePermission-View': manifestRolePermissionView,
		'ProjectTagType-View': manifestProjectTagTypeView,
		'DocumentApprovalWorkflow-View': manifestDocumentApprovalWorkflowView,
		'DocumentApprovalState-View': manifestDocumentApprovalStateView,
		'DocumentApprovalStep-View': manifestDocumentApprovalStepView,
		'ObservationApprovalWorkflow-View': manifestObservationApprovalWorkflowView,
		'ObservationApprovalState-View': manifestObservationApprovalStateView,
		'ObservationApprovalStep-View': manifestObservationApprovalStepView,
		'ContractType-View': manifestContractTypeView,
		'ProjectType-View': manifestProjectTypeView,

		// Edit manifests
		'User-Edit': manifestUserEdit,
		'Customer-Edit': manifestCustomerEdit,
		'Organization-Edit': manifestOrganizationEdit,
		'Organization-Create': manifestOrganizationCreate,
		'Project-Edit': manifestProjectEdit,
		'Role-Edit': manifestRoleEdit,
		'ObservationManifest-Edit': manifestObservationManifestEdit,
		'ArtifactType-Edit': manifestArtifactTypeEdit,
		'ReportNamedInstance-Edit': manifestReportNamedInstanceEdit,
		'ObservationTag-Edit': manifestObservationTagEdit,
		'UserRoleJoin-Edit': manifestUserRoleJoinEdit,
		'RoleEdge-Edit': manifestRoleEdgeEdit,
		'RolePermission-Edit': manifestRolePermissionEdit,
		'ProjectTagType-Edit': manifestProjectTagTypeEdit,
		'DocumentApprovalWorkflow-Edit': manifestDocumentApprovalWorkflowEdit,
		'DocumentApprovalState-Edit': manifestDocumentApprovalStateEdit,
		'DocumentApprovalStep-Edit': manifestDocumentApprovalStepEdit,
		'ObservationApprovalWorkflow-Edit': manifestObservationApprovalWorkflowEdit,
		'ObservationApprovalState-Edit': manifestObservationApprovalStateEdit,
		'ObservationApprovalStep-Edit': manifestObservationApprovalStepEdit,
		'ContractType-Edit': manifestContractTypeEdit,
		'ProjectType-Edit': manifestProjectTypeEdit,
	},

		// Field-decoration policy for the entity pickers the recordset module builds (the association
		// editors, the entity quick-filters, and the bulk-delete replacement picker). Opt-in per entity: a
		// decorated picker grows a ⚙ that lets a user pin an extra record column (e.g. VendorCode) onto each
		// dropdown row to tell same-named records apart (the "six Volkerts" problem). IDCustomer is dropped
		// everywhere (single-tenant noise); the picker hides the audit / value / text columns itself and the
		// recordset adds GUID<Entity>. Resolved per entity by pict-section-recordset resolveFieldDecoration().
		'FieldDecoration':
	{
		'Global': false,
		'Entities': { 'Organization': true, 'Contract': true, 'Project': true, 'LineItem': true },
		'IgnoreFields': [ 'IDCustomer' ],
	},

		'DefaultRecordSetConfigurations':
	[
		{
			'RecordSet': 'User',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'User',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ],
			// Quick Filters (opt-in across Headlight; see ComplexFilterProvider) — common user lookups + audit.
			'QuickFilters': [ 'NameLast', 'Email', { 'Field': 'CreateDate', 'Label': 'Created' }, { 'Field': 'CreatingIDUser', 'Label': 'Created by' } ],
			'RecordSetListColumns':
			[
				{ Key: 'NameFirst', DisplayName: 'First Name' },
				{ Key: 'NameLast', DisplayName: 'Last Name' },
				{ Key: 'Email', DisplayName: 'Email' },
				{ Key: 'LoginID', DisplayName: 'Login ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'User-List',
			'RecordSetListManifests': [ 'User-List' ],
			'RecordSetDashboardDefaultManifest': 'User-List',
			'RecordSetDashboardManifests': [ 'User-List' ],
			'RecordSetListHasExtraColumns': false,
			// The "Role" filter (IDRole). User.IDRole is ONLY the base level (0-5: Field Personnel / Office Staff /
			// …); the rich named roles an admin actually assigns (e.g. "Lab Technician") live in UserRoleJoin, so a
			// plain FBV~IDRole~EQ~<rich role> matches nobody. REPLACE the auto-generated FK-EQ clause with an
			// external-join-through-UserRoleJoin membership filter: pick one or more Roles, resolve the users who
			// HOLD them (UserRoleJoin.IDUser where IDRole IN picks), and INN the User list to those. Mirrors the LIMS
			// DestinationLab pattern (Sample→SampleLabJoin→Lab). NOTE: this covers customer-level (UserRoleJoin)
			// grants; base-level (User.IDRole) and project/lab (UserContextRole) grants are a separate concern.
			'FieldFilterClauses':
			{
				'IDRole':
				[
					{
						'FilterKey': 'IDRole',
						'ClauseKey': 'IDRole_Membership',
						'Label': 'Role',
						'DisplayName': 'Assigned to',
						'Type': 'ExternalJoinSelectedValueList',
						'ExternalFilterByColumns': [ 'Name' ],
						'MaximumSelectedExternalRecords': 20,
						'ExternalRecordDisplayTemplate': '{~D:Record.Data.Name~}',
						'CoreConnectionColumn': 'IDUser',
						'JoinTable': 'UserRoleJoin',
						'JoinTableExternalConnectionColumn': 'IDRole',
						'JoinTableCoreConnectionColumn': 'IDUser',
						'ExternalFilterByTable': 'Role',
						'ExternalFilterByTableConnectionColumn': 'IDRole',
						// Marker: UserRoleMembershipFilter.patchUserRoleMembershipFilter expands this clause at fetch time
						// into the FULL union of role holders (base User.IDRole + UserRoleJoin + UserContextRole). The
						// stock UserRoleJoin resolution above is the safe fallback if that expansion ever fails.
						'RoleMembershipUnion': true,
						'Ordinal': 1,
					},
				],
			},
			'RecordSetIgnoreFilterFields':
			[
				'IDUser',
				'GUIDUser',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'ExternalSyncDate',
				'ExternalSyncGUID',
				'IDCustomer',
				// Secrets + opaque internal fields — nonsense (and unsafe) to expose as filter options.
				'LoginPassword',
				'PasswordResetKey',
				'LastSessionID',
				'UIHash',
				'SettingsJSON',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'User-View',
			'RecordSetReadManifestsView': [ 'User-View' ],
			'RecordSetReadDefaultManifestEdit': 'User-Edit',
			'RecordSetReadManifestsEdit': [ 'User-Edit' ],
		},
		{
			'RecordSet': 'ObservationManifest',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ObservationManifest',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'DisplayName', 'Category' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'DisplayName', DisplayName: 'Display Name' },
				{ Key: 'Category', DisplayName: 'Category' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ObservationManifest-List',
			'RecordSetListManifests': [ 'ObservationManifest-List' ],
			'RecordSetDashboardDefaultManifest': 'ObservationManifest-List',
			'RecordSetDashboardManifests': [ 'ObservationManifest-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDObservationManifest',
				'GUIDObservationManifest',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
				'SettingsJSON',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ObservationManifest-View',
			'RecordSetReadManifestsView': [ 'ObservationManifest-View' ],
			'RecordSetReadDefaultManifestEdit': 'ObservationManifest-Edit',
			'RecordSetReadManifestsEdit': [ 'ObservationManifest-Edit' ],
		},
		{
			'RecordSet': 'ArtifactType',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ArtifactType',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ArtifactType-List',
			'RecordSetListManifests': [ 'ArtifactType-List' ],
			'RecordSetDashboardDefaultManifest': 'ArtifactType-List',
			'RecordSetDashboardManifests': [ 'ArtifactType-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDArtifactType',
				'GUIDArtifactType',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'Schemata',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ArtifactType-View',
			'RecordSetReadManifestsView': [ 'ArtifactType-View' ],
			'RecordSetReadDefaultManifestEdit': 'ArtifactType-Edit',
			'RecordSetReadManifestsEdit': [ 'ArtifactType-Edit' ],
		},
		{
			'RecordSet': 'ReportNamedInstance',

			// Reuse the forms app's rich metadata editor (Fields | JSON pict-section-code) for View/Edit/Create
			// instead of the generic PSRS form. The List stays on PSRS for browsing + filtering. PSRS delegates
			// via RecordSet-RecordBaseView.delegateToCustomView -> the view's onRecordSetCustomView().
			'RecordSetCustomViews': { 'View': 'ReportNamedInstanceCreate', 'Edit': 'ReportNamedInstanceCreate', 'Create': 'ReportNamedInstanceCreate' },

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ReportNamedInstance',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Hash' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'Hash', DisplayName: 'Hash' },
				{ Key: 'DefaultReport', DisplayName: 'Default' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ReportNamedInstance-List',
			'RecordSetListManifests': [ 'ReportNamedInstance-List' ],
			'RecordSetDashboardDefaultManifest': 'ReportNamedInstance-List',
			'RecordSetDashboardManifests': [ 'ReportNamedInstance-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDReportNamedInstance',
				'GUIDReportNamedInstance',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
				'OptionsJSON',
				// Internal sort key — not a meaningful thing for a user to filter reports by.
				'Ordinal',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ReportNamedInstance-View',
			'RecordSetReadManifestsView': [ 'ReportNamedInstance-View' ],
			'RecordSetReadDefaultManifestEdit': 'ReportNamedInstance-Edit',
			'RecordSetReadManifestsEdit': [ 'ReportNamedInstance-Edit' ],
			// View honors the manifest InputTypes so boolean fields render as checkboxes, not "0"/"1" (no pickers here).
			'RecordSetReadOverrideReadOnly': true,
		},
		{
			'RecordSet': 'Project',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Project',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Description', 'Status', 'ExternalProjectID' ],
			// Quick Filters (opt-in across Headlight; see ComplexFilterProvider) — common project lookups + audit.
			'QuickFilters': [ 'Name', 'Status', { 'Field': 'CreateDate', 'Label': 'Created' }, { 'Field': 'CreatingIDUser', 'Label': 'Created by' } ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'Status', DisplayName: 'Status' },
				{ Key: 'ExternalProjectID', DisplayName: 'External ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'Project-List',
			'RecordSetListManifests': [ 'Project-List' ],
			'RecordSetDashboardDefaultManifest': 'Project-List',
			'RecordSetDashboardManifests': [ 'Project-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDProject',
				'GUIDProject',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'ExternalSyncDate',
				'ExternalSyncGUID',
				'IDCustomer',
				'IDProjectType',
				'IDContract',
				'IDOrganization',
				'CustomProperties',
				'Description',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'Project-View',
			'RecordSetReadManifestsView': [ 'Project-View' ],
			'RecordSetReadDefaultManifestEdit': 'Project-Edit',
			'RecordSetReadManifestsEdit': [ 'Project-Edit' ],

			// The Project view manages its connections via association tabs (the bespoke "Project view"):
			// Observation Types links the manifests to this project with per-row Journal/Spreadsheet/Ordinal
			// config + "Add defaults". More project connections (forms, tags, …) become further tabs here.
			'ReadLayout': 'Tab',
			'RecordSetReadTabs':
			[
				{ Type: 'Association', Association: 'ProjectObservationManifest', Title: 'Observation Types', PickerMode: 'single' },
			],
		},
		{
			'RecordSet': 'Contract',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Contract',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Description', 'Status', 'PrimaryProjectNumber', 'ExternalContractID' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'PrimaryProjectNumber', DisplayName: 'Primary Project #' },
				{ Key: 'Status', DisplayName: 'Status' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'Contract-List',
			'RecordSetListManifests': [ 'Contract-List' ],
			'RecordSetDashboardDefaultManifest': 'Contract-List',
			'RecordSetDashboardManifests': [ 'Contract-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDContract',
				'GUIDContract',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
				'ExternalSyncDate',
			],
			// The bespoke ContractWorkspace owns the read (the router GUID bridge intercepts
			// /PSRS/Contract/View); the list above is just the browse surface.
		},
		{
			'RecordSet': 'Role',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Role',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Description', 'PermissionLevel', 'Type' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'PermissionLevel', DisplayName: 'Permission Level' },
				{ Key: 'Type', DisplayName: 'Type' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'Role-List',
			'RecordSetListManifests': [ 'Role-List' ],
			'RecordSetDashboardDefaultManifest': 'Role-List',
			'RecordSetDashboardManifests': [ 'Role-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDRole',
				'GUIDRole',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
				'LinkedIDUser',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'Role-View',
			'RecordSetReadManifestsView': [ 'Role-View' ],
			'RecordSetReadDefaultManifestEdit': 'Role-Edit',
			'RecordSetReadManifestsEdit': [ 'Role-Edit' ],
		},
		{
			'RecordSet': 'ObservationTag',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ObservationTag',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Tag', 'TagType', 'Description' ],
			'RecordSetListColumns':
			[
				{ Key: 'Tag', DisplayName: 'Tag' },
				{ Key: 'TagType', DisplayName: 'Tag Type' },
				{ Key: 'Global', DisplayName: 'Global' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ObservationTag-List',
			'RecordSetListManifests': [ 'ObservationTag-List' ],
			'RecordSetDashboardDefaultManifest': 'ObservationTag-List',
			'RecordSetDashboardManifests': [ 'ObservationTag-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDObservationTag',
				'GUIDObservationTag',
				'IDCustomer',
				'IDOrganization',
				'IDBidItem',
				'IDLineItem',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ObservationTag-View',
			'RecordSetReadManifestsView': [ 'ObservationTag-View' ],
			'RecordSetReadDefaultManifestEdit': 'ObservationTag-Edit',
			'RecordSetReadManifestsEdit': [ 'ObservationTag-Edit' ],
			// View honors the manifest InputTypes so boolean fields render as checkboxes, not "0"/"1" (no pickers here).
			'RecordSetReadOverrideReadOnly': true,
		},
		{
			'RecordSet': 'Organization',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Organization',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Type', 'City', 'State', 'VendorCode' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'Type', DisplayName: 'Type' },
				{ Key: 'City', DisplayName: 'City' },
				{ Key: 'State', DisplayName: 'State' },
				{ Key: 'Approved', DisplayName: 'Approved' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'Organization-List',
			'RecordSetListManifests': [ 'Organization-List' ],
			'RecordSetDashboardDefaultManifest': 'Organization-List',
			'RecordSetDashboardManifests': [ 'Organization-List' ],
			'RecordSetListHasExtraColumns': false,
			// Show the list "+ New" affordance, like the catalog master lists. Those get their create button
			// from MasterListRegistry.applyEntryToLiveConfig (which gates it by can(entity,'Create')); this
			// hand-written literal is not a catalog entry, so it opts in here directly. A `true` here still
			// yields to the permission gate if that path ever covers literals (it only overrides an explicit
			// `false`). Create routes through the sectioned Organization-Create manifest (below), not the raw
			// schema form.
			'RecordSetListShowCreateButton': true,
			'RecordSetIgnoreFilterFields':
			[
				'IDOrganization',
				'GUIDOrganization',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'ExternalSyncDate',
				'ExternalOrganizationID',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'Organization-View',
			'RecordSetReadManifestsView': [ 'Organization-View' ],
			'RecordSetReadDefaultManifestEdit': 'Organization-Edit',
			'RecordSetReadManifestsEdit': [ 'Organization-Edit' ],
			// Honor the View manifest's own InputTypes instead of PSRS's blanket View-mode read-only rewrite,
			// so the boolean fields (Approved, Disadvantaged Business) render as checkboxes rather than "0"/"1"
			// text. Every non-boolean View descriptor is already declared `ReadOnly`, so the view stays read-only
			// except those checkboxes (which have no Save action to persist a toggle).
			'RecordSetReadOverrideReadOnly': true,
			// Route "+ New" through a dedicated, sectioned create manifest (Identity / Details / Contact /
			// Address) instead of the auto-generated raw-schema form — same gating pattern ContractType /
			// ProjectType use. `RecordSetCreateManifestOnly` is what PSRS checks before honoring the create
			// manifest; without it the schema fallback wins.
			'RecordSetCreateManifestOnly': true,
			'RecordSetCreateDefaultManifest': 'Organization-Create',
			'RecordSetCreateManifests': [ 'Organization-Create' ],

			// Split layout: the record on the left, its connection tabs on the right. The "Addresses" tab is a
			// bespoke master/detail editor (OrganizationAddressTab) for the org's OrganizationAddress children.
			'ReadLayout': 'Split',
			'RecordSetReadTabs':
			[
				{ 'Type': 'View', 'View': 'OrganizationAddresses', 'Title': 'Addresses' },
				// Materials this organization supplies/produces — the reciprocal of the Material read view's
				// "Organizations" tab. Each relationship's ExpirationDate is editable inline (set / update /
				// backfill / clear) via the MaterialOrganizationAssociationEditor subclass registered for the
				// Organization side; this literal's tabs are otherwise deliberately minimal, so it is added here.
				{ 'Type': 'Association', 'Association': 'MaterialOrganization', 'Title': 'Materials' },
			],
		},
		{
			'RecordSet': 'UserRoleJoin',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'UserRoleJoin',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'IDUser', 'IDRole' ],
			'RecordSetListColumns':
			[
				{ Key: 'IDUser', DisplayName: 'User ID' },
				{ Key: 'IDRole', DisplayName: 'Role ID' },
				{ Key: 'ProxyIDRole', DisplayName: 'Proxy Role ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'UserRoleJoin-List',
			'RecordSetListManifests': [ 'UserRoleJoin-List' ],
			'RecordSetDashboardDefaultManifest': 'UserRoleJoin-List',
			'RecordSetDashboardManifests': [ 'UserRoleJoin-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDUserRoleJoin',
				'GUIDUserRoleJoin',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'UserRoleJoin-View',
			'RecordSetReadManifestsView': [ 'UserRoleJoin-View' ],
			'RecordSetReadDefaultManifestEdit': 'UserRoleJoin-Edit',
			'RecordSetReadManifestsEdit': [ 'UserRoleJoin-Edit' ],
		},
		{
			'RecordSet': 'RoleEdge',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'RoleEdge',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'ParentIDRole', 'ChildIDRole' ],
			'RecordSetListColumns':
			[
				{ Key: 'ParentIDRole', DisplayName: 'Parent Role ID' },
				{ Key: 'ChildIDRole', DisplayName: 'Child Role ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'RoleEdge-List',
			'RecordSetListManifests': [ 'RoleEdge-List' ],
			'RecordSetDashboardDefaultManifest': 'RoleEdge-List',
			'RecordSetDashboardManifests': [ 'RoleEdge-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDRoleEdge',
				'GUIDRoleEdge',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'RoleEdge-View',
			'RecordSetReadManifestsView': [ 'RoleEdge-View' ],
			'RecordSetReadDefaultManifestEdit': 'RoleEdge-Edit',
			'RecordSetReadManifestsEdit': [ 'RoleEdge-Edit' ],
		},
		{
			'RecordSet': 'RolePermission',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'RolePermission',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Hash', 'Context' ],
			'RecordSetListColumns':
			[
				{ Key: 'Hash', DisplayName: 'Permission Hash' },
				{ Key: 'Allowed', DisplayName: 'Allowed' },
				{ Key: 'IDRole', DisplayName: 'Role ID' },
				{ Key: 'Context', DisplayName: 'Context' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'RolePermission-List',
			'RecordSetListManifests': [ 'RolePermission-List' ],
			'RecordSetDashboardDefaultManifest': 'RolePermission-List',
			'RecordSetDashboardManifests': [ 'RolePermission-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDRolePermission',
				'GUIDRolePermission',
				'IDContext',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'RolePermission-View',
			'RecordSetReadManifestsView': [ 'RolePermission-View' ],
			'RecordSetReadDefaultManifestEdit': 'RolePermission-Edit',
			'RecordSetReadManifestsEdit': [ 'RolePermission-Edit' ],
			// View honors the manifest InputTypes so boolean fields render as checkboxes, not "0"/"1" (no pickers here).
			'RecordSetReadOverrideReadOnly': true,
		},
		{
			'RecordSet': 'Customer',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'Customer',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Code' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'Code', DisplayName: 'Code' },
				{ Key: 'Enabled', DisplayName: 'Enabled' },
				{ Key: 'Timezone', DisplayName: 'Timezone' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'Customer-List',
			'RecordSetListManifests': [ 'Customer-List' ],
			'RecordSetDashboardDefaultManifest': 'Customer-List',
			'RecordSetDashboardManifests': [ 'Customer-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDCustomer',
				'GUIDCustomer',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'CustomProperties',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'Customer-View',
			'RecordSetReadManifestsView': [ 'Customer-View' ],
			'RecordSetReadDefaultManifestEdit': 'Customer-Edit',
			'RecordSetReadManifestsEdit': [ 'Customer-Edit' ],
			// View honors the manifest InputTypes so boolean fields render as checkboxes, not "0"/"1" (no pickers here).
			'RecordSetReadOverrideReadOnly': true,
		},
		{
			'RecordSet': 'ProjectTagType',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ProjectTagType',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'TagType', 'Name' ],
			'RecordSetListColumns':
			[
				{ Key: 'TagType', DisplayName: 'Tag Type' },
				{ Key: 'Name', DisplayName: 'Display Name' },
				{ Key: 'Ordinal', DisplayName: 'Ordinal' },
				{ Key: 'IDProject', DisplayName: 'Project ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ProjectTagType-List',
			'RecordSetListManifests': [ 'ProjectTagType-List' ],
			'RecordSetDashboardDefaultManifest': 'ProjectTagType-List',
			'RecordSetDashboardManifests': [ 'ProjectTagType-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDProjectTagType',
				'GUIDProjectTagType',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ProjectTagType-View',
			'RecordSetReadManifestsView': [ 'ProjectTagType-View' ],
			'RecordSetReadDefaultManifestEdit': 'ProjectTagType-Edit',
			'RecordSetReadManifestsEdit': [ 'ProjectTagType-Edit' ],
		},
		{
			'RecordSet': 'DocumentApprovalWorkflow',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'DocumentApprovalWorkflow',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'FromStatus', 'ToStatus' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Transition Name' },
				{ Key: 'FromStatus', DisplayName: 'From Status' },
				{ Key: 'ToStatus', DisplayName: 'To Status' },
				{ Key: 'IDProject', DisplayName: 'Project ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'DocumentApprovalWorkflow-List',
			'RecordSetListManifests': [ 'DocumentApprovalWorkflow-List' ],
			'RecordSetDashboardDefaultManifest': 'DocumentApprovalWorkflow-List',
			'RecordSetDashboardManifests': [ 'DocumentApprovalWorkflow-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDDocumentApprovalWorkflow',
				'IDCustomer',
				'EdgeOptions',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'DocumentApprovalWorkflow-View',
			'RecordSetReadManifestsView': [ 'DocumentApprovalWorkflow-View' ],
			'RecordSetReadDefaultManifestEdit': 'DocumentApprovalWorkflow-Edit',
			'RecordSetReadManifestsEdit': [ 'DocumentApprovalWorkflow-Edit' ],
		},
		{
			'RecordSet': 'DocumentApprovalState',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'DocumentApprovalState',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Hash' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'State Name' },
				{ Key: 'Hash', DisplayName: 'Hash' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'DocumentApprovalState-List',
			'RecordSetListManifests': [ 'DocumentApprovalState-List' ],
			'RecordSetDashboardDefaultManifest': 'DocumentApprovalState-List',
			'RecordSetDashboardManifests': [ 'DocumentApprovalState-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDDocumentApprovalState',
				'GUIDDocumentApprovalState',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'DocumentApprovalState-View',
			'RecordSetReadManifestsView': [ 'DocumentApprovalState-View' ],
			'RecordSetReadDefaultManifestEdit': 'DocumentApprovalState-Edit',
			'RecordSetReadManifestsEdit': [ 'DocumentApprovalState-Edit' ],
		},
		{
			'RecordSet': 'DocumentApprovalStep',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'DocumentApprovalStep',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Ordinal' ],
			'RecordSetListColumns':
			[
				{ Key: 'IDDocumentApprovalState', DisplayName: 'State ID' },
				{ Key: 'Ordinal', DisplayName: 'Ordinal' },
				{ Key: 'IDRole', DisplayName: 'Role ID' },
				{ Key: 'IncludeHigherRoles', DisplayName: 'Higher Roles' },
				{ Key: 'PerformLock', DisplayName: 'Lock' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'DocumentApprovalStep-List',
			'RecordSetListManifests': [ 'DocumentApprovalStep-List' ],
			'RecordSetDashboardDefaultManifest': 'DocumentApprovalStep-List',
			'RecordSetDashboardManifests': [ 'DocumentApprovalStep-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDDocumentApprovalStep',
				'GUIDDocumentApprovalStep',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'DocumentApprovalStep-View',
			'RecordSetReadManifestsView': [ 'DocumentApprovalStep-View' ],
			'RecordSetReadDefaultManifestEdit': 'DocumentApprovalStep-Edit',
			'RecordSetReadManifestsEdit': [ 'DocumentApprovalStep-Edit' ],
			// View honors the manifest InputTypes so boolean fields render as checkboxes, not "0"/"1" (no pickers here).
			'RecordSetReadOverrideReadOnly': true,
		},
		{
			'RecordSet': 'ObservationApprovalWorkflow',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ObservationApprovalWorkflow',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'FromStatus', 'ToStatus' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Transition Name' },
				{ Key: 'FromStatus', DisplayName: 'From Status' },
				{ Key: 'ToStatus', DisplayName: 'To Status' },
				{ Key: 'IDProject', DisplayName: 'Project ID' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ObservationApprovalWorkflow-List',
			'RecordSetListManifests': [ 'ObservationApprovalWorkflow-List' ],
			'RecordSetDashboardDefaultManifest': 'ObservationApprovalWorkflow-List',
			'RecordSetDashboardManifests': [ 'ObservationApprovalWorkflow-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDObservationApprovalWorkflow',
				'IDCustomer',
				'EdgeOptions',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ObservationApprovalWorkflow-View',
			'RecordSetReadManifestsView': [ 'ObservationApprovalWorkflow-View' ],
			'RecordSetReadDefaultManifestEdit': 'ObservationApprovalWorkflow-Edit',
			'RecordSetReadManifestsEdit': [ 'ObservationApprovalWorkflow-Edit' ],
		},
		{
			'RecordSet': 'ObservationApprovalState',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ObservationApprovalState',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Hash' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'State Name' },
				{ Key: 'Hash', DisplayName: 'Hash' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ObservationApprovalState-List',
			'RecordSetListManifests': [ 'ObservationApprovalState-List' ],
			'RecordSetDashboardDefaultManifest': 'ObservationApprovalState-List',
			'RecordSetDashboardManifests': [ 'ObservationApprovalState-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDObservationApprovalState',
				'GUIDObservationApprovalState',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ObservationApprovalState-View',
			'RecordSetReadManifestsView': [ 'ObservationApprovalState-View' ],
			'RecordSetReadDefaultManifestEdit': 'ObservationApprovalState-Edit',
			'RecordSetReadManifestsEdit': [ 'ObservationApprovalState-Edit' ],
		},
		{
			'RecordSet': 'ObservationApprovalStep',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ObservationApprovalStep',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Ordinal', 'ObservationType' ],
			'RecordSetListColumns':
			[
				{ Key: 'IDObservationApprovalState', DisplayName: 'State ID' },
				{ Key: 'Ordinal', DisplayName: 'Ordinal' },
				{ Key: 'ObservationType', DisplayName: 'Obs Type' },
				{ Key: 'IDRole', DisplayName: 'Role ID' },
				{ Key: 'IncludeHigherRoles', DisplayName: 'Higher Roles' },
				{ Key: 'PerformLock', DisplayName: 'Lock' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ObservationApprovalStep-List',
			'RecordSetListManifests': [ 'ObservationApprovalStep-List' ],
			'RecordSetDashboardDefaultManifest': 'ObservationApprovalStep-List',
			'RecordSetDashboardManifests': [ 'ObservationApprovalStep-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDObservationApprovalStep',
				'GUIDObservationApprovalStep',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ObservationApprovalStep-View',
			'RecordSetReadManifestsView': [ 'ObservationApprovalStep-View' ],
			'RecordSetReadDefaultManifestEdit': 'ObservationApprovalStep-Edit',
			'RecordSetReadManifestsEdit': [ 'ObservationApprovalStep-Edit' ],
			// View honors the manifest InputTypes so boolean fields render as checkboxes, not "0"/"1" (no pickers here).
			'RecordSetReadOverrideReadOnly': true,
		},
		{
			'RecordSet': 'ContractType',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ContractType',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Hash', 'Description' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'Hash', DisplayName: 'Hash' },
				{ Key: 'Description', DisplayName: 'Description' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ContractType-List',
			'RecordSetListManifests': [ 'ContractType-List' ],
			'RecordSetDashboardDefaultManifest': 'ContractType-List',
			'RecordSetDashboardManifests': [ 'ContractType-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDContractType',
				'GUIDContractType',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
				'SettingsJSON',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ContractType-View',
			'RecordSetReadManifestsView': [ 'ContractType-View' ],
			'RecordSetReadDefaultManifestEdit': 'ContractType-Edit',
			'RecordSetReadManifestsEdit': [ 'ContractType-Edit' ],
			// Route the "+ New" affordance through the same friendly Settings editor
			// used for Edit, instead of the PSRS auto-generated raw-schema form.
			// `RecordSetCreateManifestOnly` is the gate PSRS checks before honoring
			// `RecordSetCreateDefaultManifest`; without it the schema fallback wins.
			'RecordSetCreateManifestOnly': true,
			'RecordSetCreateDefaultManifest': 'ContractType-Edit',
			'RecordSetCreateManifests': [ 'ContractType-Edit' ],
		},
		{
			'RecordSet': 'ProjectType',

			'RecordSetType': 'MeadowEndpoint',
			'RecordSetMeadowEntity': 'ProjectType',

			'RecordSetURLPrefix': '/1.0/',
			'SearchFields': [ 'Name', 'Hash', 'Description' ],
			'RecordSetListColumns':
			[
				{ Key: 'Name', DisplayName: 'Name' },
				{ Key: 'Hash', DisplayName: 'Hash' },
				{ Key: 'Description', DisplayName: 'Description' },
				{ Key: 'Ordinal', DisplayName: 'Order' },
			],
			'RecordSetListManifestOnly': true,
			'RecordSetListDefaultManifest': 'ProjectType-List',
			'RecordSetListManifests': [ 'ProjectType-List' ],
			'RecordSetDashboardDefaultManifest': 'ProjectType-List',
			'RecordSetDashboardManifests': [ 'ProjectType-List' ],
			'RecordSetListHasExtraColumns': false,
			'RecordSetIgnoreFilterFields':
			[
				'IDProjectType',
				'GUIDProjectType',
				'Deleted',
				'DeleteDate',
				'DeletingIDUser',
				'IDCustomer',
				'IDProgram',
				'SettingsJSON',
			],

			'RecordSetReadManifestOnly': true,
			'RecordSetReadDefaultManifestView': 'ProjectType-View',
			'RecordSetReadManifestsView': [ 'ProjectType-View' ],
			'RecordSetReadDefaultManifestEdit': 'ProjectType-Edit',
			'RecordSetReadManifestsEdit': [ 'ProjectType-Edit' ],
			// Route the "+ New" affordance through the same friendly Settings editor
			// used for Edit, instead of the PSRS auto-generated raw-schema form.
			// `RecordSetCreateManifestOnly` is the gate PSRS checks before honoring
			// `RecordSetCreateDefaultManifest`; without it the schema fallback wins.
			'RecordSetCreateManifestOnly': true,
			'RecordSetCreateDefaultManifest': 'ProjectType-Edit',
			'RecordSetCreateManifests': [ 'ProjectType-Edit' ],
		},
	].concat(libMasterListBuilder.buildRecordSetConfigurations(libMasterListCatalog))
	// Lightweight recordset registrations for the FK-picker targets the generated manifests reference but that
	// aren't catalog/literal record sets (OrganizationAddress, AccountType, MixType, …) — enough for the picker
	// to resolve options + display names. Duplicates of real literals (Organization/Contract/Project) are
	// dropped by the dedupe below (first occurrence wins).
	.concat(libCatalogManifests.PICKER_TARGETS.map((pTarget) =>
		({ 'RecordSet': pTarget.Entity, 'RecordSetType': 'MeadowEndpoint', 'RecordSetMeadowEntity': pTarget.Entity, 'RecordSetURLPrefix': '/1.0/', 'SearchFields': pTarget.SearchFields })))
	.map((pRecordSetConfiguration) =>
	{
		const tmpDefaults = { 'RowClickOpensRecord': true };
		if (PSRS_FOREIGN_KEY_ENTITIES[pRecordSetConfiguration.RecordSet]) { tmpDefaults.ForeignKeyEntities = PSRS_FOREIGN_KEY_ENTITIES[pRecordSetConfiguration.RecordSet]; }
		if (PSRS_FIELD_LABELS[pRecordSetConfiguration.RecordSet]) { tmpDefaults.FieldLabels = PSRS_FIELD_LABELS[pRecordSetConfiguration.RecordSet]; }
		const tmpConfig = Object.assign(tmpDefaults, pRecordSetConfiguration);
		// Catalog entities with generated manifests (build-catalog-manifests.js): route read + create through
		// them so the forms are sectioned/curated (Data Audit section, entity pickers, boolean checkboxes)
		// rather than the raw /Schema form. OverrideReadOnly lets a view with boolean fields render checkboxes.
		const tmpCatalogManifest = CATALOG_MANIFEST_ENTITIES.get(tmpConfig.RecordSet);
		if (tmpCatalogManifest)
		{
			const tmpEntity = tmpConfig.RecordSet;
			tmpConfig.RecordSetReadManifestOnly = true;
			tmpConfig.RecordSetReadDefaultManifestView = `${ tmpEntity }-View`;
			tmpConfig.RecordSetReadManifestsView = [ `${ tmpEntity }-View` ];
			tmpConfig.RecordSetReadDefaultManifestEdit = `${ tmpEntity }-Edit`;
			tmpConfig.RecordSetReadManifestsEdit = [ `${ tmpEntity }-Edit` ];
			tmpConfig.RecordSetCreateManifestOnly = true;
			tmpConfig.RecordSetCreateDefaultManifest = `${ tmpEntity }-Create`;
			tmpConfig.RecordSetCreateManifests = [ `${ tmpEntity }-Create` ];
			if (tmpCatalogManifest.OverrideReadOnly) { tmpConfig.RecordSetReadOverrideReadOnly = true; }
			// Externally-synced master lists (NoCreate on the catalog entry, e.g. PhysicalAsset): suppress the list
			// "+ New" button. Edit/Create routes are bridged to the workspace/list in the router.
			const tmpRawCatalogEntry = libMasterListCatalog.find((pEntry) => pEntry && pEntry.Entity === tmpEntity);
			if (tmpRawCatalogEntry && tmpRawCatalogEntry.NoCreate) { tmpConfig.RecordSetListShowCreateButton = false; }
			// Curated list columns (name / codes / type / key text — never raw FK ids or 0/1 booleans).
			if (!tmpConfig.RecordSetListColumns && Array.isArray(tmpCatalogManifest.ListColumns) && (tmpCatalogManifest.ListColumns.length > 0))
			{
				tmpConfig.RecordSetListColumns = tmpCatalogManifest.ListColumns;
			}
		}
		return tmpConfig;
	})
	// A picker target that is already a full literal/catalog config keeps that config — drop the lightweight
	// duplicate (first occurrence wins, so the richer literal/catalog entry survives).
	.filter((pConfig, pIndex, pArray) => (pArray.findIndex((pOther) => pOther.RecordSet === pConfig.RecordSet) === pIndex)),
	});

// Register the generated catalog master-list manifests (build-catalog-manifests.js) into the manifest map the
// recordset module reads via getManifest. Assigned after the literal so the config wiring above can reference
// them by hash; done before the merge guard below so they get the same ReferenceManifests normalization.
Object.assign(module.exports.default_configuration.pict_configuration.Manifests, libCatalogManifests.MANIFESTS);

// PSRS merge guard. pict-section-form's `bootstrapPictFormViewsFromManifest` merges a newly
// bootstrapped manifest into the previously bootstrapped one and writes into the prior
// manifest's `ReferenceManifests` WITHOUT first checking that object exists. So bootstrapping
// an Edit manifest that declares ReferenceManifests (the ProjectType / ContractType default-date
// grids) right after any manifest that does NOT — e.g. opening a ContractType from its View —
// throws "Cannot read properties of undefined (reading '<reference-manifest>')". Normalize every
// registered manifest to declare a ReferenceManifests object so the merge is always safe. The
// require()d manifest objects are shared singletons, so mutating them here normalizes what PSRS
// reads via getManifest. Remove once the upstream framework guards the merge.
for (const tmpManifest of Object.values((module.exports.default_configuration
	&& module.exports.default_configuration.pict_configuration
	&& module.exports.default_configuration.pict_configuration.Manifests) || {}))
{
	if (tmpManifest && typeof tmpManifest === 'object' && !tmpManifest.ReferenceManifests)
	{
		tmpManifest.ReferenceManifests = {};
	}
}

},{"../../../lib/service/headlight-project-cloning-adapter/Headlight-Project-Cloning-Adapter.js":12,"../../../lib/service/web-headlight-document-render/Web-Headlight-Document-Render.js":28,"../../../lib/service/web-headlight-observation-render/Web-Headlight-Observation-Render.js":29,"../../headlight-form-editor/source/views/ReportNamedInstance-Create.js":835,"../../providers/ComplexFilterProvider.js":1577,"../../providers/DocumentProvider.js":1579,"../../providers/FormInitialBundle-Provider.js":1585,"../../providers/GeoProvider.js":1586,"../../providers/ImprovedTabularRecordSetProvider.js":1588,"../../providers/LineItemProvider.js":1591,"../../providers/LocationProvider.js":1592,"../../providers/QRCodeProvider.js":1604,"../../providers/RecordExtension-Provider.js":1605,"../../providers/SampleLogProvider.js":1606,"../../providers/SampleProvider.js":1607,"../../providers/TestInstanceProvider.js":1609,"../../providers/UtilityProvider.js":1612,"./access/InspectionScope-Service.js":1057,"./access/Module-Access.js":1058,"./assets/AssetDescriptor-Provider.js":1069,"./assets/PhysicalAssetDashboard-Provider.js":1071,"./config-screens/Config-Screens.js":1081,"./default_manifests/ArtifactType-Edit.json":1104,"./default_manifests/ArtifactType-List.json":1105,"./default_manifests/ArtifactType-View.json":1106,"./default_manifests/Contract-List.json":1122,"./default_manifests/ContractType-Edit.json":1123,"./default_manifests/ContractType-List.json":1124,"./default_manifests/ContractType-View.json":1125,"./default_manifests/Customer-Edit.json":1129,"./default_manifests/Customer-List.json":1130,"./default_manifests/Customer-View.json":1131,"./default_manifests/DocumentApprovalState-Edit.json":1132,"./default_manifests/DocumentApprovalState-List.json":1133,"./default_manifests/DocumentApprovalState-View.json":1134,"./default_manifests/DocumentApprovalStep-Edit.json":1135,"./default_manifests/DocumentApprovalStep-List.json":1136,"./default_manifests/DocumentApprovalStep-View.json":1137,"./default_manifests/DocumentApprovalWorkflow-Edit.json":1138,"./default_manifests/DocumentApprovalWorkflow-List.json":1139,"./default_manifests/DocumentApprovalWorkflow-View.json":1140,"./default_manifests/ObservationApprovalState-Edit.json":1174,"./default_manifests/ObservationApprovalState-List.json":1175,"./default_manifests/ObservationApprovalState-View.json":1176,"./default_manifests/ObservationApprovalStep-Edit.json":1177,"./default_manifests/ObservationApprovalStep-List.json":1178,"./default_manifests/ObservationApprovalStep-View.json":1179,"./default_manifests/ObservationApprovalWorkflow-Edit.json":1180,"./default_manifests/ObservationApprovalWorkflow-List.json":1181,"./default_manifests/ObservationApprovalWorkflow-View.json":1182,"./default_manifests/ObservationManifest-Edit.json":1183,"./default_manifests/ObservationManifest-List.json":1184,"./default_manifests/ObservationManifest-View.json":1185,"./default_manifests/ObservationTag-Edit.json":1186,"./default_manifests/ObservationTag-List.json":1187,"./default_manifests/ObservationTag-View.json":1188,"./default_manifests/Organization-Create.json":1189,"./default_manifests/Organization-Edit.json":1190,"./default_manifests/Organization-List.json":1191,"./default_manifests/Organization-View.json":1192,"./default_manifests/Project-Edit.json":1214,"./default_manifests/Project-List.json":1215,"./default_manifests/Project-View.json":1216,"./default_manifests/ProjectTagType-Edit.json":1220,"./default_manifests/ProjectTagType-List.json":1221,"./default_manifests/ProjectTagType-View.json":1222,"./default_manifests/ProjectType-Edit.json":1223,"./default_manifests/ProjectType-List.json":1224,"./default_manifests/ProjectType-View.json":1225,"./default_manifests/ReportNamedInstance-Edit.json":1226,"./default_manifests/ReportNamedInstance-List.json":1227,"./default_manifests/ReportNamedInstance-View.json":1228,"./default_manifests/Role-Edit.json":1229,"./default_manifests/Role-List.json":1230,"./default_manifests/Role-View.json":1231,"./default_manifests/RoleEdge-Edit.json":1232,"./default_manifests/RoleEdge-List.json":1233,"./default_manifests/RoleEdge-View.json":1234,"./default_manifests/RolePermission-Edit.json":1235,"./default_manifests/RolePermission-List.json":1236,"./default_manifests/RolePermission-View.json":1237,"./default_manifests/User-Edit.json":1262,"./default_manifests/User-List.json":1263,"./default_manifests/User-View.json":1264,"./default_manifests/UserRoleJoin-Edit.json":1265,"./default_manifests/UserRoleJoin-List.json":1266,"./default_manifests/UserRoleJoin-View.json":1267,"./default_manifests/catalog-manifest-index.js":1268,"./documents/DocumentFrameSwitcher-Provider.js":1270,"./documents/DocumentList-Provider.js":1271,"./documents/DocumentThroughput-Provider.js":1273,"./entity-metadata/EntityMetadataForm-Provider.js":1274,"./form-concierge/FormConcierge-Provider.js":1279,"./help/Academy-Provider.js":1280,"./help/Academy-View.js":1281,"./help/PlatformDocs.js":1282,"./important-files/ImportantFiles-Provider.js":1283,"./inspections/InspectionSchedule-Provider.js":1284,"./internals/Internals-ServiceCatalog.js":1285,"./internals/Internals-ServiceVersions.js":1286,"./internals/Internals-ServiceVersionsMultiEnv.js":1287,"./master-lists/Association-Chip-Decoration.js":1288,"./master-lists/Connections.generated.js":1289,"./master-lists/Headlight-MasterLists.js":1290,"./master-lists/MasterList-Associations.js":1291,"./master-lists/MasterList-Builder.js":1292,"./navigation-graph.js":1294,"./navigation-topics.js":1295,"./observations/ObservationList-Provider.js":1296,"./project-funding/ProjectFunding-Provider.js":1297,"./providers/ATMDashboardConfig-Provider.js":1299,"./providers/AccessWorkspace-Provider.js":1300,"./providers/ActivityObservability-Provider.js":1301,"./providers/ApprovalWorkflow-Provider.js":1302,"./providers/ArtifactType-Editor-Provider.js":1303,"./providers/AssetCatalogSync-Provider.js":1304,"./providers/AssetTypeDescriptor-Provider.js":1305,"./providers/BulkUpload-Provider.js":1308,"./providers/CertificationTypes-Provider.js":1309,"./providers/Certifications-Provider.js":1310,"./providers/ChangeOrders-Provider.js":1311,"./providers/ConfigClone-Provider.js":1312,"./providers/ConfigViewer-Provider.js":1314,"./providers/ContractAdminProvisioning-Provider.js":1315,"./providers/ContractCreateWorkspace-Provider.js":1316,"./providers/ContractPackageImport-Provider.js":1317,"./providers/ContractProjectTypesImportProvider.js":1318,"./providers/ContractProjectTypesSettingsAdapter.js":1319,"./providers/CustomerProvisioning-Provider.js":1322,"./providers/CustomerRecordManifests-Provider.js":1326,"./providers/CustomersList-Provider.js":1328,"./providers/DashboardAccessConfig-Provider.js":1329,"./providers/DataDownloader-Provider.js":1330,"./providers/DataImport-Provider.js":1331,"./providers/DatalakeCatalog-Provider.js":1332,"./providers/DatalakeDataset-Provider.js":1333,"./providers/DatalakeProjection-Editor-Provider.js":1334,"./providers/Documentation-Provider.js":1335,"./providers/EmailNotifications-Provider.js":1336,"./providers/Entitlements-Provider.js":1337,"./providers/EntityDestinationsConfig-Provider.js":1338,"./providers/ErrorLogViewer-Provider.js":1340,"./providers/GroupComposition-Provider.js":1341,"./providers/InspectionCreateWorkspace-Provider.js":1342,"./providers/LineItemBidItemMap-Provider.js":1346,"./providers/ManageCustomers-Provider.js":1350,"./providers/MasterList-Registry-Provider.js":1351,"./providers/MyHeadlight-Provider.js":1352,"./providers/ObservationType-Editor-Provider.js":1353,"./providers/PermissionMatrix-Provider.js":1355,"./providers/PermissionVisualizer-Provider.js":1356,"./providers/PlatformConfiguration-Router.js":1357,"./providers/ProjectBulkDelete-Provider.js":1358,"./providers/ProjectClone-Provider.js":1359,"./providers/ProjectContractTypes-Provider.js":1360,"./providers/ProjectContractorMatrix-Provider.js":1361,"./providers/ProjectCreateWorkspace-Provider.js":1362,"./providers/ProjectEditWorkspace-Provider.js":1363,"./providers/ProjectStaffing-Provider.js":1365,"./providers/ProjectTypeComprehensionBuilder.js":1366,"./providers/RecordDates-Provider.js":1368,"./providers/RecordPhotoUploadAfterSave.js":1369,"./providers/RoleAssignment-Provider.js":1370,"./providers/RoleClone-Provider.js":1371,"./providers/SampleListColumnsConfig-Provider.js":1372,"./providers/SampleQRCodeConfig-Provider.js":1373,"./providers/ScanToOpen-Provider.js":1374,"./providers/SuperUserGrant-Provider.js":1375,"./providers/TypeComprehensionReadProvider.js":1377,"./providers/TypeComprehensionSaveProvider.js":1378,"./providers/UserCreateWorkspace-Provider.js":1379,"./providers/UserGroupGrants-Provider.js":1380,"./record-cards/Platform-RecordCards.js":1382,"./sample-plan/SamplePlan-Provider.js":1385,"./sample-plan/SamplePlanCopy-View.js":1387,"./sample-plan/SamplePlanDashboard-Provider.js":1388,"./services/Effective-Permissions-Service.js":1397,"./support/Support-Merge-Provider.js":1399,"./support/Support-Provider.js":1400,"./support/SupportPortal-Provider.js":1401,"./user-role-filter/UserRoleMembershipFilter.js":1402,"./views/ATMDashboardConfig.js":1403,"./views/AccessWorkspace.js":1404,"./views/ApprovalWorkflowBindings.js":1405,"./views/ApprovalWorkflowEditor.js":1406,"./views/ApprovalWorkflowList.js":1407,"./views/ArtifactTypeEditor.js":1408,"./views/AssetCatalogSync.js":1409,"./views/AssetTypeDescriptor.js":1410,"./views/BulkUpload.js":1411,"./views/CertificationTypes.js":1412,"./views/Certifications.js":1413,"./views/ChangeOrders.js":1414,"./views/ChildListTab.js":1415,"./views/ConfigClone.js":1416,"./views/ConfigViewer.js":1417,"./views/ConfigurationIndex.js":1418,"./views/ConfigurationNavigation.js":1419,"./views/ContractCreateWorkspace.js":1420,"./views/ContractPackageImport.js":1421,"./views/ContractTypes.js":1422,"./views/CustomerProvisioning.js":1423,"./views/Customers.js":1424,"./views/DashboardAccessConfig.js":1425,"./views/DataDownloader.js":1426,"./views/DataExplorer.js":1427,"./views/DataImport.js":1428,"./views/DataMapper.js":1429,"./views/DatalakeCatalog.js":1430,"./views/DatalakeDataset.js":1431,"./views/DatalakeProjectionEditor.js":1432,"./views/DocumentList.js":1433,"./views/DocumentThroughput.js":1434,"./views/Documentation.js":1435,"./views/EmailNotifications-Editor.js":1437,"./views/EmailNotifications-List.js":1438,"./views/Empty.json":1439,"./views/Entitlements.js":1440,"./views/EntityDestinationsConfig.js":1441,"./views/ErrorLogViewer.js":1442,"./views/FormConcierge.js":1443,"./views/ImportantFiles.js":1444,"./views/InspectionCreateWorkspace.js":1445,"./views/InspectionSchedule.js":1446,"./views/ManageCustomers.js":1447,"./views/MasterListManager.js":1448,"./views/MaterialOrganizationAssociationEditor.js":1449,"./views/MaterialSpecSetsTab.js":1450,"./views/MyHeadlight.js":1451,"./views/ObservationList.js":1452,"./views/ObservationLocationMap.js":1453,"./views/ObservationTypeEditor.js":1454,"./views/OrganizationAddressTab.js":1455,"./views/PhysicalAssetDashboard.js":1456,"./views/PrinterCodes.js":1457,"./views/ProjectActivity.js":1458,"./views/ProjectCenterMap.js":1459,"./views/ProjectClone.js":1460,"./views/ProjectCreateWorkspace.js":1462,"./views/ProjectEditWorkspace.js":1463,"./views/ProjectFunding.js":1464,"./views/ProjectTypes.js":1465,"./views/ReadView-TabBar-Decoration.js":1467,"./views/RecordDates.js":1468,"./views/RoleClone.js":1469,"./views/SampleListColumnsConfig.js":1470,"./views/SamplePlan.js":1471,"./views/SamplePlanDashboard.js":1472,"./views/SampleQRCodeConfig.js":1473,"./views/ScanSamplesPage.js":1474,"./views/SpecSetMaterialsTab.js":1475,"./views/SuperUserGrant.js":1476,"./views/Support.js":1477,"./views/SupportPortal.js":1478,"./views/TabBar.js":1479,"./views/TopicPage.js":1480,"./views/UserActivity.js":1481,"./views/UserCreateWorkspace.js":1482,"./views/UserLoginOverview.js":1483,"./views/dashboards/PlatformDashboard-DataProvider.js":1484,"./workspace-configs":1516,"@paviasystems/headlight-samples":21,"headlight-configurable-application":30,"headlight-dashboards":45,"headlight-dynamic-inputs-bundle":47,"headlight-lims-sampleplan":11,"headlight-report-project-assignment":293,"headlight-rest-client":20,"headlight-view-login":307,"manifest-packaging-service":25,"pict-dataexplorer":546,"pict-section-accordion":553,"pict-section-dataimport":566,"pict-section-form":874,"pict-section-form-host":863,"pict-section-inlinedocumentation":662,"pict-section-markdowneditor":955,"pict-section-navigation":691,"pict-section-picker":711,"pict-section-recordset":966,"pict-section-recordset/source/providers/Filter-Data-Provider.js":969,"pict-section-recordset/source/providers/RecordSet-DynamicRecordsetSolver.js":973,"pict-section-recordset/source/views/Filter-PersistenceView.js":982,"pict-template-preprocessor":729}],1056:[function(require,module,exports){
/**
 * Pure builder for the role/permission matrix.
 *
 * Turns a role's saved grants (RolePermission rows with Allowed=1) + denies (Allowed=0) — plus any pending
 * in-flight edits — into the tri-state grid the view renders, and turns edits back into the per-cell save
 * actions. A cell is `on` (granted), `off` (denied), or `none` (no record → inherit/default), cycling in
 * that order, exactly like the home app's `PermissionsManager`. No pict / DOM / network dependencies.
 *
 * The "edits" object is a sparse `{ '<hash>': 'on'|'off'|'none' }` map holding ONLY cells whose state
 * differs from what is saved — so it doubles as the batched save set (`diffChanges`). Setting a cell back to
 * its saved state removes it from the map.
 */

const Catalog = require('./Permission-Catalog.js');

// The tri-state cycle order — matches the home app's `toggleStatus = ['none', 'on', 'off']`.
const TRI_STATES = [ 'none', 'on', 'off' ];

// --- Catalog sources -------------------------------------------------------
// The matrix renders one of two catalogs behind the SAME tri-state machinery: the STATIC entity/module/
// association catalog (Permission-Catalog) or a DYNAMIC reports/forms catalog built from the live
// ReportNamedInstance set. A "catalog source" is the small interface buildRows()/applyAllToggle() need —
// the action columns, the row descriptors ({ Key, Label, Kind }), per-row action membership, hash builder,
// and section titles. `Key` is the permission-hash prefix (an entity name, or `DocumentType-<RNI.Hash>`);
// `Label` is what the row shows. The provider holds the active source and routes its lookups through it.

/**
 * The static entity/module/association catalog source (the default — preserves the original behavior).
 * @returns {Object}
 */
function staticCatalogSource()
{
	return {
		Mode: 'entities',
		actions: () => Catalog.AVAILABLE_ACTIONS,
		entities: () => Catalog.entityList().map((pEntity) => ({ Key: pEntity, Label: pEntity, Kind: Catalog.rowKind(pEntity) })),
		actionsForKey: (pKey) => Catalog.actionsForEntity(pKey),
		hasAction: (pKey, pAction) => Catalog.entityHasAction(pKey, pAction),
		buildHash: (pKey, pAction) => Catalog.buildHash(pKey, pAction),
		sections: () => [ { Key: 'entity', Title: 'Entities' }, { Key: 'module', Title: 'Module access' }, { Key: 'association', Title: 'Associations' } ],
	};
}

// The base report/form actions every ReportNamedInstance declares (before per-report workflow statuses).
const REPORT_BASE_ACTIONS = [ 'Create', 'View', 'Update', 'Delete' ];

/**
 * A dynamic reports/forms catalog source built from ReportNamedInstance records. Each report/form becomes a
 * `DocumentType-<Hash>` row declaring Create/View/Update/Delete + one `View-<Status>` per approval-workflow
 * state — exactly the row set the home app's applyDocPermissions() injects (PermissionsManager.vue).
 * @param {Array<{ Hash: string, Name: string }>} pReportNamedInstances
 * @param {Object} [pStatusesByHash] - { '<RNI.Hash>': ['Draft','Approved', ...] } workflow states per report
 * @returns {Object}
 */
function reportCatalogSource(pReportNamedInstances, pStatusesByHash)
{
	const tmpStatuses = pStatusesByHash || {};
	const tmpPerKey = {};
	const tmpColumns = REPORT_BASE_ACTIONS.slice();
	(pReportNamedInstances || []).forEach((pRNI) =>
	{
		if (!pRNI || !pRNI.Hash)
		{
			return;
		}
		const tmpKey = `${Catalog.REPORT_ENTITY_PREFIX}${pRNI.Hash}`;
		const tmpStatusActions = (tmpStatuses[pRNI.Hash] || []).map((pStatus) => `View-${pStatus}`);
		tmpStatusActions.forEach((pAction) =>
		{
			if (tmpColumns.indexOf(pAction) < 0)
			{
				tmpColumns.push(pAction);
			}
		});
		tmpPerKey[tmpKey] = { Label: pRNI.Name || pRNI.Hash, Actions: REPORT_BASE_ACTIONS.concat(tmpStatusActions) };
	});
	return {
		Mode: 'reports',
		actions: () => tmpColumns,
		entities: () => Object.keys(tmpPerKey).map((pKey) => ({ Key: pKey, Label: tmpPerKey[pKey].Label, Kind: 'report' })),
		actionsForKey: (pKey) => (tmpPerKey[pKey] ? tmpPerKey[pKey].Actions : []),
		hasAction: (pKey, pAction) => (tmpPerKey[pKey] ? tmpPerKey[pKey].Actions.indexOf(pAction) > -1 : false),
		buildHash: (pKey, pAction) => `${pKey}-${pAction}`,
		sections: () => [ { Key: 'report', Title: 'Reports & Forms' } ],
	};
}

/**
 * Coerce an array or Set of hashes to a Set.
 * @param {Set<string>|Array<string>} pValue
 * @returns {Set<string>}
 */
function toSet(pValue)
{
	return (pValue instanceof Set) ? pValue : new Set(pValue || []);
}

/**
 * The state a cell would have from saved data alone (ignoring edits).
 * @param {string} pHash
 * @param {Set<string>} pGrant
 * @param {Set<string>} pDeny
 * @returns {'on'|'off'|'none'}
 */
function savedState(pHash, pGrant, pDeny)
{
	// Coerce so callers can pass arrays or Sets (e.g. the provider's "All" toggle passes the raw hash arrays).
	const tmpGrant = toSet(pGrant);
	const tmpDeny = toSet(pDeny);
	if (tmpGrant.has(pHash))
	{
		return 'on';
	}
	if (tmpDeny.has(pHash))
	{
		return 'off';
	}
	return 'none';
}

/**
 * The effective state of a cell = its edit if present, else its saved state.
 * @param {string} pHash
 * @param {Set<string>} pGrant
 * @param {Set<string>} pDeny
 * @param {Object} pEdits
 * @returns {'on'|'off'|'none'}
 */
function effectiveState(pHash, pGrant, pDeny, pEdits)
{
	if (pEdits && Object.prototype.hasOwnProperty.call(pEdits, pHash))
	{
		return pEdits[pHash];
	}
	return savedState(pHash, pGrant, pDeny);
}

/**
 * Compute the per-entity "All" meta-toggle state: `on` only if every available cell is on, `off` only if
 * every available cell is off, otherwise `none` (mixed / indeterminate). Mirrors `computeMetaToggleState`.
 * @param {Array<{ Available: boolean, State: string }>} pCells
 * @returns {'on'|'off'|'none'}
 */
function metaState(pCells)
{
	const tmpAvailable = (pCells || []).filter((pCell) => pCell.Available);
	if (!tmpAvailable.length)
	{
		return 'none';
	}
	const tmpCounts = { on: 0, off: 0, none: 0 };
	tmpAvailable.forEach((pCell) =>
	{
		tmpCounts[pCell.State] = (tmpCounts[pCell.State] || 0) + 1;
	});
	if (tmpCounts.on && !tmpCounts.off && !tmpCounts.none)
	{
		return 'on';
	}
	if (tmpCounts.off && !tmpCounts.on && !tmpCounts.none)
	{
		return 'off';
	}
	return 'none';
}

/**
 * The next state in the tri-state cycle (none -> on -> off -> none).
 * @param {string} pState
 * @returns {'on'|'off'|'none'}
 */
function cycleState(pState)
{
	const tmpIndex = TRI_STATES.indexOf(pState);
	return TRI_STATES[(tmpIndex + 1) % TRI_STATES.length];
}

/**
 * Write a cell's target state into an edits map, normalizing: if the target equals the saved state the cell
 * is no longer a change, so its key is removed (keeping `edits` == the minimal save set).
 * @param {Object} pEdits - mutated in place
 * @param {string} pHash
 * @param {string} pState
 * @param {Set<string>} pGrant
 * @param {Set<string>} pDeny
 * @returns {Object} the same edits object
 */
function setEdit(pEdits, pHash, pState, pGrant, pDeny)
{
	if (pState === savedState(pHash, pGrant, pDeny))
	{
		delete pEdits[pHash];
	}
	else
	{
		pEdits[pHash] = pState;
	}
	return pEdits;
}

/**
 * Build the matrix model: the action columns + a row per catalog entity with a tri-state cell for each
 * action (or an unavailable placeholder where the entity doesn't declare that action).
 * @param {Set<string>|Array<string>} pGrantHashes - hashes saved Allowed=1
 * @param {Set<string>|Array<string>} pDenyHashes - hashes saved Allowed=0
 * @param {Object} [pEdits] - sparse pending edits { '<hash>':'on'|'off'|'none' }
 * @param {Object} [pCatalogSource] - a catalog source (defaults to the static entity catalog)
 * @returns {{ actions: Array<string>, rows: Array<object> }}
 */
function buildRows(pGrantHashes, pDenyHashes, pEdits, pCatalogSource)
{
	const tmpGrant = toSet(pGrantHashes);
	const tmpDeny = toSet(pDenyHashes);
	const tmpEdits = pEdits || {};
	const tmpSource = pCatalogSource || staticCatalogSource();
	const tmpActions = tmpSource.actions();

	const tmpRows = tmpSource.entities().map((pEntity) =>
	{
		const tmpSupported = tmpSource.actionsForKey(pEntity.Key);
		const tmpCells = tmpActions.map((pAction) =>
		{
			const tmpHash = tmpSource.buildHash(pEntity.Key, pAction);
			const tmpAvailable = tmpSupported.indexOf(pAction) > -1;
			const tmpSaved = savedState(tmpHash, tmpGrant, tmpDeny);
			const tmpState = effectiveState(tmpHash, tmpGrant, tmpDeny, tmpEdits);
			return {
				Hash: tmpHash,
				Action: pAction,
				Available: tmpAvailable,
				State: tmpState,
				SavedState: tmpSaved,
				Changed: tmpAvailable && (tmpState !== tmpSaved),
			};
		});
		return {
			Entity: pEntity.Label,
			Key: pEntity.Key,
			Kind: pEntity.Kind,
			Cells: tmpCells,
			MetaState: metaState(tmpCells),
		};
	});

	return { actions: tmpActions, rows: tmpRows };
}

/**
 * Cycle a single cell to its next tri-state, returning a NEW edits map.
 * @param {string} pHash
 * @param {Set<string>|Array<string>} pGrantHashes
 * @param {Set<string>|Array<string>} pDenyHashes
 * @param {Object} [pEdits]
 * @returns {Object} the new edits map
 */
function toggleCell(pHash, pGrantHashes, pDenyHashes, pEdits)
{
	const tmpGrant = toSet(pGrantHashes);
	const tmpDeny = toSet(pDenyHashes);
	const tmpEdits = Object.assign({}, pEdits || {});
	const tmpNext = cycleState(effectiveState(pHash, tmpGrant, tmpDeny, tmpEdits));
	return setEdit(tmpEdits, pHash, tmpNext, tmpGrant, tmpDeny);
}

/**
 * Set every available cell of an entity to a target state ("All" toggle), returning a NEW edits map.
 * @param {string} pKey - the row key (an entity name, or `DocumentType-<RNI.Hash>`)
 * @param {string} pTargetState - 'on'|'off'|'none'
 * @param {Set<string>|Array<string>} pGrantHashes
 * @param {Set<string>|Array<string>} pDenyHashes
 * @param {Object} [pEdits]
 * @param {Object} [pCatalogSource] - a catalog source (defaults to the static entity catalog)
 * @returns {Object} the new edits map
 */
function applyAllToggle(pKey, pTargetState, pGrantHashes, pDenyHashes, pEdits, pCatalogSource)
{
	const tmpGrant = toSet(pGrantHashes);
	const tmpDeny = toSet(pDenyHashes);
	const tmpEdits = Object.assign({}, pEdits || {});
	const tmpSource = pCatalogSource || staticCatalogSource();
	tmpSource.actionsForKey(pKey).forEach((pAction) =>
	{
		setEdit(tmpEdits, tmpSource.buildHash(pKey, pAction), pTargetState, tmpGrant, tmpDeny);
	});
	return tmpEdits;
}

/**
 * The batched save set — a shallow copy of the (already-minimal) edits map. Each entry is a per-cell save
 * action the provider executes: `on` -> Grant, `off` -> Deny, `none` -> delete the existing RolePermission row.
 * @param {Object} [pEdits]
 * @returns {Object}
 */
function diffChanges(pEdits)
{
	return Object.assign({}, pEdits || {});
}

/**
 * Collapse raw RolePermission rows to one per Hash (last wins — guards against accidental duplicate rows,
 * which the schema has no unique constraint to prevent — plan risk #3).
 * @param {Array<{ Hash: string }>} pRows
 * @returns {{ byHash: Object, hashes: Array<string> }}
 */
function dedupRolePermissionRows(pRows)
{
	const tmpByHash = {};
	(pRows || []).forEach((pRow) =>
	{
		if (pRow && pRow.Hash)
		{
			tmpByHash[pRow.Hash] = pRow;
		}
	});
	return { byHash: tmpByHash, hashes: Object.keys(tmpByHash) };
}

module.exports =
{
	TRI_STATES,
	REPORT_BASE_ACTIONS,
	staticCatalogSource,
	reportCatalogSource,
	savedState,
	effectiveState,
	metaState,
	cycleState,
	setEdit,
	buildRows,
	toggleCell,
	applyAllToggle,
	diffChanges,
	dedupRolePermissionRows,
};

},{"./Permission-Catalog.js":1060}],1057:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

// The role index at which the server itself stops narrowing document reads to a user's own reach and
// opens them to the whole customer (Project.ts buildUserProjectMembershipJoinQuery). Matching it here
// means an administrator's program view comes from the same line the API already draws, rather than a
// second, drifting definition of "admin".
const PROGRAM_ROLE_INDEX = 4;

// Meadow filter-length safety: ids per INN chunk, and the page size each chunk is paged through.
const INN_CHUNK = 100;
const PAGE_SIZE = 2000;
// Dossier documents are the reach spine; this is the cap on that one read.
const DOSSIER_CAP = 4000;

/**
 * InspectionScopeService — answers "whose work is this?" once per session.
 *
 * Three questions, resolved at login and cached for the session:
 *
 *   1. WHICH TIER is this user — program (an administrator who should see everything) or scoped?
 *   2. WHICH INSPECTIONS can they reach?
 *   3. WHICH TEAMS are they on, and which do they lead?
 *
 * ── An honest warning about what this is ───────────────────────────────────────────────────────
 *
 * This is a LENS, not a permission. The Inspection endpoints do not scope per user: every non-admin
 * role reads Inspection with `MyCustomer`, which is a post-fetch per-record assertion that the
 * controller has already satisfied by injecting the session's IDCustomer into the query. There are no
 * query hooks on the Inspection bundle. So a scoped user who types a URL, or calls the REST API
 * directly, still sees every inspection in their customer.
 *
 * Narrowing what the app SHOWS is worth doing on its own — a field inspector opening a program of 825
 * inspections to find their twelve is a bad tool. But do not describe this as access control, and do
 * not let it be the reason a sensitive field is considered protected. Making it enforced is a change
 * to `api/headlight/ts_source/bundles/process/Inspections.ts`, not to this file.
 *
 * ── Ownership is not reach, and the difference is the whole design ─────────────────────────────
 *
 * There are two different answers to "their inspections", and conflating them produces a field tool
 * that still opens on hundreds of rows:
 *
 *   OWNERSHIP — what is MINE. `InspectionUserJoin` rows naming me, plus the assignments of teams I am
 *   on. This is what an inspector means by "my inspections", and it is what the app shows by default.
 *
 *   REACH — what I am ALLOWED to open. Derived from documents: `Documents/Lite` narrows rows to
 *   documents the caller reaches by project membership or by a role/team grant, so anything reached
 *   that way is reach the server already agrees with. It is much wider than ownership — on the live
 *   customer a lead inspector owns ~142 inspections but can reach every inspection in the 166
 *   projects he belongs to.
 *
 * The app defaults to OWNERSHIP and keeps REACH as the ceiling: it is what a "show everything I can
 * see" affordance would widen to, and what an enforcement change would narrow to. Never widen the
 * default view to reach — that is the difference between a tool that opens on your twelve bridges and
 * one that opens on eight hundred.
 *
 * ── Fail CLOSED ────────────────────────────────────────────────────────────────────────────────
 *
 * If resolution fails, a scoped user gets an EMPTY reach, not an unfiltered one. That is the opposite
 * of the sibling UserRoleMembershipFilter, which degrades open — and deliberately so: that filter
 * widens a list the user already had, while this one is the only thing keeping a field tool from
 * opening as a program tool. An empty screen is a visible, reportable bug; a silently unfiltered one
 * is not.
 */
class InspectionScopeService extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		/** Resolved once per session. Null until resolveAsync() completes. */
		this._scope = null;
		/** The in-flight resolution, so concurrent callers share one pass. */
		this._resolving = null;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	/**
	 * The signed-in user's id.
	 *
	 * The session packet spells this `UserID`, NOT `IDUser` — the entity column name and the session
	 * field name differ. Reading `IDUser` here yields undefined and builds `FBV~IDUser~EQ~undefined`,
	 * which returns nothing and looks exactly like "this user has no work".
	 *
	 * @return {Number}
	 */
	get idUser()
	{
		return Number(this.currentUser.UserID) || 0;
	}

	get idCustomer()
	{
		return Number(this.currentUser.CustomerID) || 0;
	}

	/**
	 * Is this session entitled to the whole program?
	 *
	 * Deliberately keyed on the session's role index rather than a capability. `canHash()` returns TRUE
	 * before its map has loaded, so gating a NARROWING on a capability would show everyone everything
	 * during the window this service runs in — the precise bug being fixed. A capability may WIDEN
	 * (see options.ProgramCapability), never narrow.
	 *
	 * @return {Boolean}
	 */
	isProgramTier()
	{
		if (Number(this.currentUser.UserRoleIndex) >= PROGRAM_ROLE_INDEX) { return true; }
		const tmpCapability = this.options.ProgramCapability;
		if (tmpCapability)
		{
			const tmpPermissions = this.fable.EffectivePermissionsService;
			if (tmpPermissions && (typeof tmpPermissions.currentUserReady === 'function') && tmpPermissions.currentUserReady())
			{
				return !!tmpPermissions.canHash(tmpCapability);
			}
		}
		return false;
	}

	/** The resolved scope, or null before resolveAsync(). @return {Object|null} */
	get scope() { return this._scope; }

	// --- REST helpers ---

	_get(pURL)
	{
		return new Promise((resolve) => this.restClient.getJSON(pURL, (pError, pBody) => resolve(pError ? null : pBody)));
	}

	/**
	 * Chunked, paged INN fetch. Paged to exhaustion on purpose: a truncated page here silently drops a
	 * user's own inspections, which is indistinguishable from not being assigned to them.
	 *
	 * @param {String} pEntity
	 * @param {String} pField
	 * @param {Array<Number>} pIDs
	 * @param {String} [pExtra] - extra filter clauses, leading with '~'
	 * @return {Promise<Array<Object>>}
	 */
	async _innFetch(pEntity, pField, pIDs, pExtra)
	{
		const tmpIDs = [ ...new Set(pIDs.map(Number).filter(Boolean)) ];
		const tmpOut = [];
		for (let i = 0; i < tmpIDs.length; i += INN_CHUNK)
		{
			const tmpChunk = tmpIDs.slice(i, i + INN_CHUNK);
			let tmpOffset = 0;
			for (;;)
			{
				const tmpRows = await this._get(`${ pEntity }/FilteredTo/FBL~${ pField }~INN~${ tmpChunk.join(',') }${ pExtra || '' }/${ tmpOffset }/${ PAGE_SIZE }`);
				const tmpArray = Array.isArray(tmpRows) ? tmpRows : [];
				tmpOut.push(...tmpArray);
				if (tmpArray.length < PAGE_SIZE) { break; }
				tmpOffset += PAGE_SIZE;
			}
		}
		return tmpOut;
	}

	// --- Resolution ---

	/**
	 * Resolve the session's scope. Safe to call repeatedly; the first call does the work.
	 *
	 * @param {Boolean} [pForce] - re-resolve even if already cached
	 * @return {Promise<Object>} the scope
	 */
	resolveAsync(pForce)
	{
		if (this._scope && !pForce) { return Promise.resolve(this._scope); }
		if (this._resolving && !pForce) { return this._resolving; }
		this._resolving = this._resolveAsync().then((pScope) =>
		{
			this._scope = pScope;
			this._resolving = null;
			return pScope;
		});
		return this._resolving;
	}

	async _resolveAsync()
	{
		const tmpScope =
		{
			Tier: 'scoped',
			IDUser: this.idUser,
			IDCustomer: this.idCustomer,
			// What is mine (personal + team assignment) — the default view.
			InspectionIDs: [],
			// What I may open (server-agreed document reach) — the ceiling, not the default.
			ReachIDs: [],
			Teams: [],
			LedTeamIDs: [],
			Ready: false,
			Degraded: false,
			Message: '',
		};

		if (!tmpScope.IDUser)
		{
			// No identity means no defensible scope. Fail closed and say why.
			tmpScope.Ready = true;
			tmpScope.Degraded = true;
			tmpScope.Message = 'The session did not report a user id, so this view could not be narrowed to your work.';
			return tmpScope;
		}

		if (this.isProgramTier())
		{
			tmpScope.Tier = 'program';
			tmpScope.Ready = true;
			// A program user still gets their teams resolved — "my team" is an identity question, not a
			// reach question, and an administrator may well lead a crew.
			await this._resolveTeamsAsync(tmpScope);
			this._log(tmpScope);
			return tmpScope;
		}

		try
		{
			// Teams first: a team's assignments are part of what is MINE, so they have to be resolved
			// before ownership is computed.
			await this._resolveTeamsAsync(tmpScope);

			const [ tmpReach, tmpMine, tmpTeamOwned ] = await Promise.all(
				[
					this._reachFromDocumentsAsync(),
					this._ownedByMeAsync(),
					this._ownedByMyTeamsAsync(tmpScope),
				]);
			tmpScope.ReachIDs = tmpReach;
			tmpScope.InspectionIDs = [ ...new Set([ ...tmpMine, ...tmpTeamOwned ]) ];
			tmpScope.OwnedByMe = tmpMine.length;
			tmpScope.OwnedByMyTeams = tmpTeamOwned.length;
			tmpScope.ReachFromDocuments = tmpReach.length;
			tmpScope.Ready = true;
		}
		catch (pError)
		{
			tmpScope.Ready = true;
			tmpScope.Degraded = true;
			tmpScope.InspectionIDs = [];
			tmpScope.Message = `Could not work out which inspections are yours (${ pError && pError.message ? pError.message : pError }).`;
		}

		this._log(tmpScope);
		return tmpScope;
	}

	/**
	 * Reach spine A — inspections whose dossier the server says this user can read.
	 *
	 * The sort stays on a Document column on purpose: sorting a gated read by a joined table's column
	 * drops the grant branch server-side, and a user who reaches their work ONLY through a team grant
	 * then sees nothing.
	 *
	 * @return {Promise<Array<Number>>}
	 */
	async _reachFromDocumentsAsync()
	{
		const tmpDocumentType = this.options.DossierDocumentType || 'Inspection-Dossier';
		const tmpRows = await this._get(`Documents/Lite/FilteredTo/FBV~IDCustomer~EQ~${ this.idCustomer }~FBV~DocumentType~EQ~${ encodeURIComponent(tmpDocumentType) }~FBV~Deleted~EQ~0~FSF~IDDocument~DESC~0/0/${ DOSSIER_CAP }`);
		const tmpDocumentIDs = (Array.isArray(tmpRows) ? tmpRows : []).map((pRow) => pRow.IDDocument).filter(Boolean);
		if (!tmpDocumentIDs.length) { return []; }
		const tmpJoins = await this._innFetch('InspectionDocumentJoins', 'IDDocument', tmpDocumentIDs, '~FBV~Deleted~EQ~0');
		return [ ...new Set(tmpJoins.map((pJoin) => Number(pJoin.IDInspection)).filter(Boolean)) ];
	}

	/**
	 * Ownership — inspections this user is personally named on.
	 *
	 * @return {Promise<Array<Number>>}
	 */
	async _ownedByMeAsync()
	{
		const tmpOut = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpRows = await this._get(`InspectionUserJoins/FilteredTo/FBV~IDUser~EQ~${ this.idUser }~FBV~Deleted~EQ~0/${ tmpOffset }/${ PAGE_SIZE }`);
			const tmpArray = Array.isArray(tmpRows) ? tmpRows : [];
			tmpOut.push(...tmpArray.map((pRow) => Number(pRow.IDInspection)).filter(Boolean));
			if (tmpArray.length < PAGE_SIZE) { break; }
			tmpOffset += PAGE_SIZE;
		}
		return [ ...new Set(tmpOut) ];
	}

	/**
	 * Ownership — inspections assigned to any team this user is on.
	 *
	 * A crew shares its work, so a member should see the crew's inspections, not only the ones their
	 * own name happens to sit on. Resolved through the same InspectionUserJoin table as personal
	 * assignment: the team's roster, then every inspection any of them is named on.
	 *
	 * @param {Object} pScope - the scope being built; its Teams must already be resolved
	 * @return {Promise<Array<Number>>}
	 */
	async _ownedByMyTeamsAsync(pScope)
	{
		const tmpTeamIDs = (pScope.Teams || []).map((pTeam) => pTeam.IDTeam);
		if (!tmpTeamIDs.length) { return []; }
		const tmpMembers = await this._innFetch('TeamUserJoins', 'IDTeam', tmpTeamIDs, '~FBV~Deleted~EQ~0');
		const tmpMemberIDs = [ ...new Set(tmpMembers.map((pRow) => Number(pRow.IDUser)).filter(Boolean)) ];
		if (!tmpMemberIDs.length) { return []; }
		const tmpJoins = await this._innFetch('InspectionUserJoins', 'IDUser', tmpMemberIDs, '~FBV~Deleted~EQ~0');
		return [ ...new Set(tmpJoins.map((pRow) => Number(pRow.IDInspection)).filter(Boolean)) ];
	}

	/**
	 * Resolve the teams this user belongs to, and which of them they lead.
	 *
	 * Degrades quietly: a user without Team-Read gets no teams rather than a failed session. Team
	 * membership widens what the app OFFERS; it is not what keeps the reach honest.
	 *
	 * @param {Object} pScope - mutated in place
	 */
	async _resolveTeamsAsync(pScope)
	{
		const tmpMemberships = await this._get(`TeamUserJoins/FilteredTo/FBV~IDUser~EQ~${ this.idUser }~FBV~Deleted~EQ~0/0/200`);
		const tmpRows = Array.isArray(tmpMemberships) ? tmpMemberships : [];
		if (!tmpRows.length) { return; }

		const tmpTeamIDs = [ ...new Set(tmpRows.map((pRow) => Number(pRow.IDTeam)).filter(Boolean)) ];
		const tmpTeams = await this._innFetch('Teams', 'IDTeam', tmpTeamIDs, '~FBV~Deleted~EQ~0');
		const tmpNameByID = {};
		tmpTeams.forEach((pTeam) => { tmpNameByID[pTeam.IDTeam] = pTeam.Name || `Team ${ pTeam.IDTeam }`; });

		const tmpLeaderRoleIDs = await this._leaderRoleIDsAsync();
		pScope.Teams = tmpTeamIDs.map((pIDTeam) =>
		{
			const tmpRowsForTeam = tmpRows.filter((pRow) => (Number(pRow.IDTeam) === pIDTeam));
			// A user can hold several roles in one team — the membership is not 1:1 — so leadership is
			// "any of my rows in this team names a leader role".
			const tmpLeads = tmpRowsForTeam.some((pRow) => (tmpLeaderRoleIDs.indexOf(Number(pRow.IDRole)) > -1));
			return { IDTeam: pIDTeam, Name: tmpNameByID[pIDTeam] || `Team ${ pIDTeam }`, IDRoles: tmpRowsForTeam.map((pRow) => Number(pRow.IDRole)), Leads: tmpLeads };
		});
		pScope.LedTeamIDs = pScope.Teams.filter((pTeam) => pTeam.Leads).map((pTeam) => pTeam.IDTeam);
	}

	/**
	 * The IDRole values that mean "leads this team".
	 *
	 * Resolved by GUID rather than hardcoded, because the label role is a per-customer row and its id
	 * differs between environments. Configured ids are honored too, for a deployment that wants to pin
	 * them. Cached for the session.
	 *
	 * @return {Promise<Array<Number>>}
	 */
	async _leaderRoleIDsAsync()
	{
		if (this._leaderRoleIDs) { return this._leaderRoleIDs; }
		const tmpConfigured = (this.options.LeaderRoleIDs || []).map(Number).filter(Boolean);
		if (tmpConfigured.length) { this._leaderRoleIDs = tmpConfigured; return tmpConfigured; }

		const tmpGUID = this.options.LeaderRoleGUID;
		if (!tmpGUID) { this._leaderRoleIDs = []; return this._leaderRoleIDs; }
		const tmpRows = await this._get(`Roles/FilteredTo/FBV~GUIDRole~EQ~${ encodeURIComponent(tmpGUID.replace('{IDCustomer}', String(this.idCustomer))) }~FBV~Deleted~EQ~0/0/5`);
		this._leaderRoleIDs = (Array.isArray(tmpRows) ? tmpRows : []).map((pRow) => Number(pRow.IDRole)).filter(Boolean);
		return this._leaderRoleIDs;
	}

	// --- Consumption ---

	/**
	 * The Meadow filter clause that narrows a query to this session's inspections, or '' for a program
	 * user.
	 *
	 * An empty reach yields an impossible clause rather than no clause. Omitting it would turn "you
	 * have no inspections" into "here is the entire program", which is the one failure this service
	 * exists to prevent.
	 *
	 * @param {String} [pField] - the id column on the entity being filtered
	 * @return {String} a clause beginning with '~', or ''
	 */
	inspectionClause(pField)
	{
		const tmpField = pField || 'IDInspection';
		const tmpScope = this._scope;
		if (!tmpScope || (tmpScope.Tier === 'program')) { return ''; }
		if (!tmpScope.InspectionIDs.length) { return `~FBV~${ tmpField }~EQ~0`; }
		return `~FBL~${ tmpField }~INN~${ tmpScope.InspectionIDs.join(',') }`;
	}

	/**
	 * A short, stable signature of the current scope, for cache keys. A provider that caches rows under
	 * its filter signature must include this, or switching users serves the previous user's work.
	 *
	 * @return {String}
	 */
	signature()
	{
		const tmpScope = this._scope;
		if (!tmpScope) { return 'unresolved'; }
		if (tmpScope.Tier === 'program') { return 'program'; }
		return `u${ tmpScope.IDUser }:n${ tmpScope.InspectionIDs.length }`;
	}

	/** Whether a scoped user's view should carry a "this is only your work" note. @return {Boolean} */
	get isNarrowed()
	{
		return !!(this._scope && (this._scope.Tier !== 'program'));
	}

	_log(pScope)
	{
		this.pict.log.info(`InspectionScope: tier=${ pScope.Tier } user=${ pScope.IDUser } inspections=${ pScope.InspectionIDs.length }`
			+ ` (mine=${ pScope.OwnedByMe != null ? pScope.OwnedByMe : '-' } team=${ pScope.OwnedByMyTeams != null ? pScope.OwnedByMyTeams : '-' } reach=${ pScope.ReachFromDocuments != null ? pScope.ReachFromDocuments : '-' })`
			+ ` teams=${ pScope.Teams.length } leads=${ pScope.LedTeamIDs.length }${ pScope.Degraded ? ' DEGRADED' : '' }`);
	}
}

module.exports = InspectionScopeService;
module.exports.PROGRAM_ROLE_INDEX = PROGRAM_ROLE_INDEX;
module.exports.default_configuration =
{
	ProviderIdentifier: 'InspectionScope',
	AutoInitialize: true,
	AutoInitializeOrdinal: 25,

	// The document type whose grants stand in for "who works this inspection".
	DossierDocumentType: 'Inspection-Dossier',
	// IDRole values on TeamUserJoin that mean "leads this team". Leave empty to resolve by GUID below;
	// set explicitly to pin them for a deployment.
	LeaderRoleIDs: [],
	// The per-customer label role that marks a team lead. A Role row only because that is the column's
	// type — it carries no permissions and is never assigned through UserRoleJoin. Seeded by
	// tmp/HDOT-Team-Seed-Onetime/seed-inspection-teams.cjs.
	LeaderRoleGUID: 'SEED-ROLE-C{IDCustomer}-TEAMLEADER',
	// A capability that may WIDEN a user to the program view. Never used to narrow.
	ProgramCapability: '',
};

},{"pict-provider":845}],1058:[function(require,module,exports){
'use strict';

/**
 * Module access: may this user open an app that requires a module (e.g. the LIMS micro app requires 'LIMS')?
 *
 * The same decision legacy apps make through @paviasystems/permissions-control checkModulePermission
 * (lib/permissions-control/source/PermissionsControl.js checkEnforcement + checkPermission). Keep the two in step:
 * a user is refused only when the customer's PermissionsEnforcement configuration enforces the module and the user
 * lacks Module-<Module>-Access. A customer that doesn't enforce it lets everyone in.
 *
 * Pure functions, no pict / network, so they test in isolation.
 */

const NOT_ENFORCED = [ 'Default', 'Level' ];

/**
 * Resolve how a customer enforces a module action, from its PermissionsEnforcement configuration
 * (`Configuration/For/PermissionsEnforcement/In/Customer/<IDCustomer>`).
 *
 * @param {any} pConfiguration - the configuration value (may be empty)
 * @param {number} pIDCustomer
 * @param {string} pModule - e.g. 'LIMS'
 * @param {string} [pAction] - defaults to 'Access'
 * @return {string} 'Strict', 'Default', or whatever the configuration names ('Mine', 'Level', 'Hybrid', ...)
 */
function resolveModuleEnforcement(pConfiguration, pIDCustomer, pModule, pAction)
{
	const tmpConfiguration = pConfiguration || {};
	const tmpAction = pAction || 'Access';
	const tmpCustomerIDs = (tmpConfiguration.Configuration && tmpConfiguration.Configuration.CustomerIDs) || [];
	if (Array.isArray(tmpCustomerIDs) && tmpCustomerIDs.includes(pIDCustomer))
	{
		return 'Strict';
	}
	const tmpModules = (tmpConfiguration.EnforcementTypes && tmpConfiguration.EnforcementTypes.Module) || {};
	const fAction = (pItem, pActionName) =>
	{
		const tmpItem = tmpModules[pItem];
		return (tmpItem && tmpItem.Actions) ? tmpItem.Actions[pActionName] : undefined;
	};
	return fAction(pModule, tmpAction) ||
		fAction(pModule, 'DefaultAction') ||
		fAction('DefaultScope', tmpAction) ||
		fAction('DefaultScope', 'DefaultAction') ||
		'Default';
}

/**
 * @param {string} pEnforcement - from resolveModuleEnforcement
 * @param {boolean} pHasPermission - whether the user holds Module-<Module>-Access
 * @return {boolean} true when the user must be refused
 */
function isModuleAccessDenied(pEnforcement, pHasPermission)
{
	if (NOT_ENFORCED.includes(pEnforcement))
	{
		return false;
	}
	if (pEnforcement === 'Mine')
	{
		// Mine compares a record's creator; a module has no record, so legacy refuses.
		return true;
	}
	if (pHasPermission)
	{
		return false;
	}
	return (pEnforcement !== 'Hybrid');
}

module.exports = { resolveModuleEnforcement, isModuleAccessDenied };

},{}],1059:[function(require,module,exports){
module.exports={
	"AvailableActions": [
		"Access",
		"Create",
		"Delete",
		"Read",
		"Update",
		"Approve",
		"Grant",
		"Associate",
		"Disassociate",
		"View",
		"Advanced"
	],
	"AvailablePermissionMap": {
		"AcademyContent": [ "Create", "Read", "Update", "Delete" ],
		"Module-ContractAdmin": [ "Access" ],
		"Module-FormsEditor": [ "Access" ],
		"Module-PlatformConfiguration": [ "Access" ],
		"Module-Internal": [ "Access" ],
		"Module-HeadLight": [ "Access" ],
		"Module-Materials": [ "Access" ],
		"Module-LIMS": [ "Access" ],
		"Module-SamplePlan": [ "Access" ],
		"Module-ApprovalWorkflowEditor": [ "Access" ],
		"Module-ApprovalWorkflowBindingEditor": [ "Access" ],
		"Module-EmailNotificationEditor": [ "Access" ],
		"Module-LabelTypeEditor": [ "Access" ],
		"Module-HEADLIGHT_ACADEMY": [ "Access" ],
		"Module-HEADLIGHT_FIELDBOOK": [ "Access" ],
		"Module-HEADLIGHT_PROJECT": [ "Access" ],
		"Module-HEADLIGHT_PROFILE": [ "Access" ],
		"Module-HEADLIGHT_CUSTOMERS": [ "Access" ],
		"Module-HEADLIGHT_TRACKER": [ "Access" ],
		"Module-HEADLIGHT_PORTAL": [ "Access" ],
		"Module-HEADLIGHT_VAULT": [ "Access" ],
		"Account": [ "Create", "Delete", "Read", "Update" ],
		"AccountBudget": [ "Create", "Delete", "Read", "Update" ],
		"AccountLedger": [ "Create", "Delete", "Read", "Update" ],
		"AccountType": [ "Create", "Delete", "Read", "Update" ],
		"AppData": [ "Create", "Delete", "Read", "Update" ],
		"Artifact": [ "Create", "Delete", "Read", "Update" ],
		"ArtifactType": [ "Create", "Delete", "Read", "Update" ],
		"ArtifactTypeSpecification": [ "Create", "Delete", "Read", "Update" ],
		"AssetClassification": [ "Create", "Delete", "Read", "Update" ],
		"AssetType": [ "Create", "Delete", "Read", "Update" ],
		"AssetTypeManifest": [ "Create", "Delete", "Read", "Update" ],
		"BidItem": [ "Create", "Delete", "Read", "Update" ],
		"BidItem-Organization": [ "Associate", "Disassociate" ],
		"BidItem-Project": [ "Associate", "Disassociate" ],
		"Category-Project": [ "Associate", "Disassociate" ],
		"Certification": [ "Create", "Delete", "Read", "Update" ],
		"CertificationType": [ "Create", "Delete", "Read", "Update" ],
		"ChangeOrder": [ "Approve", "Create", "Delete", "Read", "Update" ],
		"Comment": [ "Create", "Read", "Delete", "Update" ],
		"ConcreteAggregate": [ "Create", "Delete", "Read", "Update" ],
		"ConfigEntry": [ "Create", "Delete", "Read", "Update" ],
		"Contact": [ "Create", "Delete", "Read", "Update" ],
		"Contact-Organization": [ "Associate", "Disassociate" ],
		"Contact-Project": [ "Associate", "Disassociate" ],
		"Contract": [ "Create", "Delete", "Read", "Update" ],
		"ContractType": [ "Create", "Delete", "Read", "Update" ],
		"ContractTypeDefaultDate": [ "Create", "Delete", "Read", "Update" ],
		"ContractTypeDefaultFunding": [ "Create", "Delete", "Read", "Update" ],
		"Core": [ "Create", "Delete", "Read", "Update" ],
		"Customer": [ "Create", "Delete", "Impersonate", "Read", "Update" ],
		"Customer-Module": [ "Associate", "Disassociate" ],
		"CustomerTeam": [ "Read", "Update" ],
		"CustomMetadata": [ "Advanced" ],
		"DeliveryTicket": [ "Create", "Delete", "Read", "Update", "Approve" ],
		"Document-Comment": [ "Associate", "Disassociate" ],
		"Document-ElectronicSignature": [ "Associate", "Disassociate" ],
		"Document-Observation": [ "Associate", "Disassociate" ],
		"Document": [ "Create", "Delete", "Read", "Update" ],
		"DocumentApprovalLog": [ "Create", "Delete", "Read", "Update" ],
		"DocumentArchive": [ "Create" ],
		"DocumentArtifact": [ "Create", "Delete", "Read", "Update" ],
		"DocumentMetadata": [ "Create", "Delete", "Read", "Update" ],
		"DocumentArtifact-Document": [ "Associate", "Disassociate" ],
		"ElectronicSignature": [ "Create", "Delete", "Read", "Update" ],
		"ElectronicSignature-Comment": [ "Associate", "Disassociate" ],
		"EmailRule": [ "Create", "Delete", "Read", "Update" ],
		"EmailRuleSchedule": [ "Create", "Delete", "Read", "Update" ],
		"Entity-Poly": [ "Associate", "Disassociate" ],
		"EntityDestinations": [ "Configure" ],
		"DashboardAccess": [ "Configure" ],
		"Equipment": [ "Create", "Delete", "Read", "Update" ],
		"Equipment-Organization": [ "Associate", "Disassociate" ],
		"Equipment-Project": [ "Associate", "Disassociate" ],
		"EstimateSummary": [ "Create", "Delete", "Read", "Update" ],
		"FormAccess": [ "Configure" ],
		"Fund": [ "Create", "Delete", "Read", "Update" ],
		"Fund-Document": [ "Associate", "Disassociate" ],
		"Fund-Project": [ "Associate", "Disassociate" ],
		"Funding-Category": [ "Associate", "Disassociate" ],
		"FundingAdjustment": [ "Create", "Delete", "Read", "Update" ],
		"FundingCategory": [ "Create", "Delete", "Read", "Update" ],
		"FundingCategory-LineItem": [ "Associate", "Disassociate" ],
		"FundingCategory-Project": [ "Associate", "Disassociate" ],
		"FundingSource": [ "Create", "Delete", "Read", "Update" ],
		"FundingSource-Contract": [ "Associate", "Disassociate" ],
		"FundingSource-Fund": [ "Associate", "Disassociate" ],
		"FundingSource-FundingCategory": [ "Associate", "Disassociate" ],
		"FundingSource-LineItem": [ "Associate", "Disassociate" ],
		"FundingSource-Project": [ "Associate", "Disassociate" ],
		"Inspection": [ "Create", "Delete", "Read", "Update" ],
		"Team": [ "Create", "Delete", "Read", "Update" ],
		"TeamUserJoin": [ "Create", "Delete", "Read", "Update" ],
		"LabTeamJoin": [ "Create", "Delete", "Read", "Update" ],
		"DocumentAccessJoin": [ "Create", "Delete", "Read", "Update" ],
		"Inspection-Document": [ "Associate", "Disassociate" ],
		"Inspection-PhysicalAsset": [ "Associate", "Disassociate" ],
		"InspectionStatus": [ "Create", "Delete", "Read", "Update" ],
		"InspectionType": [ "Create", "Delete", "Read", "Update" ],
		"InspectionType-ReportNamedInstance": [ "Associate", "Disassociate" ],
		"Inspection-User": [ "Associate", "Disassociate" ],
		"Lab": [ "Create", "Delete", "Read", "Update" ],
		"LabMaterialAssignment": [ "Create", "Delete", "Read", "Update" ],
		"LabTestApproval": [ "Create", "Delete", "Read", "Update" ],
		"LabTestDefault": [ "Create", "Delete", "Read", "Update" ],
		"Lab-Project": [ "Associate", "Disassociate" ],
		"Lab-Sample": [ "Associate", "Disassociate" ],
		"Lab-User": [ "Associate", "Disassociate" ],
		"LineItem": [ "Create", "Delete", "Read", "Update" ],
		"LineItem-Lot": [ "Associate", "Disassociate" ],
		"LineItem-Organization": [ "Associate", "Disassociate" ],
		"LineItem-Project": [ "Associate", "Disassociate" ],
		"LineItem-Sample": [ "Associate", "Disassociate" ],
		"LineItemChangeOrder": [ "Approve", "Create", "Delete", "Read", "Update" ],
		"Location": [ "Create", "Delete", "Read", "Update" ],
		"Lot": [ "Create", "Delete", "Read", "Update" ],
		"ManifestSchema": [ "Create", "Delete", "Read", "Update" ],
		"ManifestSchemaPartial": [ "Create", "Delete", "Read", "Update" ],
		"ManifestSchema-ManifestSchemaPartial": [ "Associate", "Disassociate" ],
		"Material": [ "Create", "Delete", "Read", "Update" ],
		"Material-LineItem": [ "Associate", "Disassociate" ],
		"Material-Organization": [ "Associate", "Disassociate" ],
		"Material-PayItem": [ "Associate", "Disassociate" ],
		"MaterialsAudit": [ "Configure" ],
		"MaterialsFormDashboard": [ "Read" ],
		"MixDesign": [ "Create", "Delete", "Read", "Update" ],
		"MixDesignApproval": [ "Create", "Delete", "Read", "Update" ],
		"MixSpecification": [ "Create", "Delete", "Read", "Update" ],
		"MixSpecification-Material": [ "Associate", "Disassociate" ],
		"MixType": [ "Create", "Delete", "Read", "Update" ],
		"Module": [ "Create", "Delete", "Read", "Update" ],
		"Observation-Artifact": [ "Associate", "Disassociate" ],
		"Observation-Comment": [ "Associate", "Disassociate" ],
		"Observation-ElectronicSignature": [ "Associate", "Disassociate" ],
		"Observation-Organization": [ "Associate", "Disassociate" ],
		"Observation": [ "Create", "Delete", "Read", "Update" ],
		"ObservationApprovalLog": [ "Create", "Delete", "Read", "Update" ],
		"ObservationArchive": [ "Create" ],
		"ObservationManifest": [ "Create", "Delete", "Read", "Update" ],
		"ObservationManifest-Project": [ "Associate", "Disassociate" ],
		"ObservationRequirementSpecification": [ "Create", "Delete", "Read", "Update" ],
		"ObservationSet": [ "Create", "Delete", "Read", "Update" ],
		"ObservationSet-Observation": [ "Associate", "Disassociate" ],
		"ObservationTag": [ "Create", "Delete", "Read", "Update" ],
		"ObservationTag-Project": [ "Associate", "Disassociate" ],
		"Organization": [ "Create", "Delete", "Read", "Update" ],
		"Organization-Project": [ "Associate", "Disassociate" ],
		"OrganizationAddress": [ "Create", "Delete", "Read", "Update" ],
		"PartialPayEstimate": [ "Create", "Delete", "Read", "Update" ],
		"PartialPayment": [ "Create", "Delete", "Read", "Update" ],
		"PayItem": [ "Create", "Delete", "Read", "Update" ],
		"PaymentFundingSnapshot": [ "Create", "Delete", "Read", "Update" ],
		"PaymentFundingSnapshotHistory": [ "Create", "Delete", "Read", "Update" ],
		"PaymentForm": [ "Create", "Delete", "Read", "Update" ],
		"Permission": [ "Grant", "Read" ],
		"PhysicalAsset": [ "Create", "Delete", "Read", "Update" ],
		"PhysicalAssetDefect": [ "Create", "Delete", "Read", "Update" ],
		"PhysicalAssetElementType": [ "Create", "Delete", "Read", "Update" ],
		"PhysicalAssetMaterial": [ "Create", "Delete", "Read", "Update" ],
		"PlantMixApproval": [ "Create", "Delete", "Read", "Update" ],
		"PD": [ "Create", "Delete", "Read", "Update" ],
		"Product": [ "Create", "Delete", "Read", "Update" ],
		"ProductionPlant": [ "Create", "Delete", "Read", "Update" ],
		"ProductionPlantMaterialApproval": [ "Create", "Delete", "Read", "Update" ],
		"Program": [ "Create", "Delete", "Read", "Update" ],
		"Project": [ "Create", "Delete", "Read", "Update", "BulkDelete" ],
		"Project-ReportNamedInstance": [ "Associate", "Disassociate" ],
		"ProjectFile": [ "Create", "Delete", "Read", "Update" ],
		"ProjectFileFolder": [ "Create", "Delete", "Read", "Update" ],
		"ProjectOffice": [ "Create", "Delete", "Read", "Update" ],
		"ProvisionalProgressPayment": [ "Create", "Delete", "Read", "Update" ],
		"ProjectTagType": [ "Create", "Delete", "Read", "Update" ],
		"ProjectType": [ "Create", "Delete", "Read", "Update" ],
		"ReportArchetype": [ "Create", "Delete", "Read", "Update" ],
		"ReportNamedInstance": [ "Create", "Delete", "Read", "Update", "EditJSON" ],
		"Role": [ "Create", "Delete", "Read", "Update" ],
		"RoleContextMembership": [ "Create", "Delete", "Read", "Update" ],
		"RoleEdge": [ "Create", "Delete", "Read", "Update" ],
		"RolePermission": [ "Create", "Delete", "Read", "Update" ],
		"Sample": [ "Create", "Delete", "Read", "Update" ],
		"SampleLog": [ "Create", "Delete", "Read", "Update" ],
		"SamplePlanEntry": [ "Read", "Update" ],
		"SampleStatus": [ "Create", "Delete", "Read", "Update" ],
		"SampleListColumns": [ "Configure" ],
		"SampleLock": [ "Override" ],
		"SampleQRCode": [ "Configure" ],
		"SentEmail": [ "Read" ],
		"Source-Project": [ "Associate", "Disassociate" ],
		"SubLot": [ "Create", "Delete", "Read", "Update" ],
		"Support": [ "Agent", "Manage", "View" ],
		"Test": [ "Create", "Delete", "Read", "Update" ],
		"Test-Lab": [ "Associate", "Disassociate" ],
		"TestData": [ "Create", "Delete", "Read", "Update" ],
		"TestInstance": [ "Create", "Delete", "Read", "Update" ],
		"TestInstance-Document": [ "Associate", "Disassociate" ],
		"TestInstance-Lab": [ "Associate", "Disassociate" ],
		"TestInstance-Sample": [ "Associate", "Disassociate" ],
		"TestInstanceData": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecification": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecification-Material": [ "Associate", "Disassociate" ],
		"TestSpecificationRequirement": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecificationSet": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecificationSet-Test": [ "Associate", "Disassociate" ],
		"User": [ "Read", "Create", "Update" ],
		"User-Lab": [ "Associate", "Disassociate" ],
		"User-Project": [ "Associate", "Disassociate" ],
		"User-Role": [ "Associate", "Disassociate" ],
		"UserContextRole": [ "Create", "Delete", "Read", "Update" ],
		"UserEntityAction": [ "Create", "Delete", "Read", "Update" ],
		"UserPermission": [ "Create", "Delete", "Read", "Update" ],
		"UserManagementPermissionsDetail": [ "Read" ],
		"UserManagementPermissionsEdit": [ "Read" ]
	}
}

},{}],1060:[function(require,module,exports){
/**
 * The permission-hash catalog — the axes of the role/permission matrix.
 *
 * `Permission-Catalog.json` is a verbatim mirror of the home app's `static_permissions.json`, which is in
 * turn the same set the resolver hardcodes (`api/permissions/.../EndpointBase.js`). A permission hash is
 * `"<Entity>-<Action>"`; the matrix is rows = entities (~150) x cols = the 10 actions, with a cell only
 * togglable where the entity declares that action. No pict / DOM / network dependencies — pure data + string
 * helpers so the matrix builder and its tests run in isolation.
 */

const CATALOG = require('./Permission-Catalog.json');

const AVAILABLE_ACTIONS = CATALOG.AvailableActions;
const PERMISSION_MAP = CATALOG.AvailablePermissionMap;

// Report/form permissions are DYNAMIC rows (not in the static catalog): a permission hash
// `DocumentType-<ReportNamedInstance.Hash>-<Action>`, where <Action> is Create/View/Update/Delete OR a
// compound `View-<WorkflowStatus>` (e.g. View-Approved). The reports catalog source (Access-Matrix-Builder)
// enumerates these from the live ReportNamedInstance set; here we only need to parse them.
const REPORT_ENTITY_PREFIX = 'DocumentType-';

// The wire Context values the permission endpoints speak vs. the membership keys the seed catalog
// (CustomerProvisioning-RoleCatalog) uses. Kept here as the single source of truth (plan risk #4).
const CONTEXT_TO_MEMBERSHIP = { Customer: 'CustomerMembership', Contract: 'ContractMembership', Project: 'ProjectMembership' };
const MEMBERSHIP_TO_CONTEXT = { CustomerMembership: 'Customer', ContractMembership: 'Contract', ProjectMembership: 'Project' };

/**
 * Split a permission hash into its entity + action. The action is the final `-`-delimited segment; the
 * entity is everything before it (so association hashes like `BidItem-Organization-Associate` parse to
 * entity `BidItem-Organization`, action `Associate`).
 * @param {string} pHash
 * @returns {{ Entity: string, Action: string }}
 */
function parseHash(pHash)
{
	const tmpHash = String(pHash || '');
	// Report/form hashes (`DocumentType-<RNI.Hash>-<Action>`) need special handling: the RNI hash itself can
	// contain dashes, and the action may be a compound `View-<Status>`. Mirror the home app's rule
	// (PermissionsManager.vue): if the second-to-last segment is `View`, the action is those last two
	// segments; otherwise it is the last segment. The entity is everything before the action.
	if (tmpHash.indexOf(REPORT_ENTITY_PREFIX) === 0)
	{
		const tmpTokens = tmpHash.split('-');
		const tmpAction = (tmpTokens.length >= 2 && tmpTokens[tmpTokens.length - 2] === 'View')
			? `${tmpTokens[tmpTokens.length - 2]}-${tmpTokens[tmpTokens.length - 1]}`
			: tmpTokens[tmpTokens.length - 1];
		return { Entity: tmpHash.slice(0, tmpHash.length - tmpAction.length - 1), Action: tmpAction };
	}
	const tmpIndex = tmpHash.lastIndexOf('-');
	if (tmpIndex < 0)
	{
		return { Entity: tmpHash, Action: '' };
	}
	return { Entity: tmpHash.slice(0, tmpIndex), Action: tmpHash.slice(tmpIndex + 1) };
}

/**
 * Is this a report/form permission entity (a `DocumentType-<RNI.Hash>` row)?
 * @param {string} pEntity
 * @returns {boolean}
 */
function isReportRow(pEntity)
{
	return String(pEntity || '').indexOf(REPORT_ENTITY_PREFIX) === 0;
}

/**
 * Compose a permission hash from an entity + action.
 * @param {string} pEntity
 * @param {string} pAction
 * @returns {string}
 */
function buildHash(pEntity, pAction)
{
	return `${pEntity}-${pAction}`;
}

/**
 * The actions a given entity declares (the togglable cells in its matrix row).
 * @param {string} pEntity
 * @returns {Array<string>}
 */
function actionsForEntity(pEntity)
{
	return PERMISSION_MAP[pEntity] || [];
}

/**
 * Does an entity declare an action (i.e. is that matrix cell real, not a dash)?
 * @param {string} pEntity
 * @param {string} pAction
 * @returns {boolean}
 */
function entityHasAction(pEntity, pAction)
{
	return actionsForEntity(pEntity).indexOf(pAction) > -1;
}

/**
 * Every entity in the catalog, in declaration order.
 * @returns {Array<string>}
 */
function entityList()
{
	return Object.keys(PERMISSION_MAP);
}

/**
 * A `Module-*` access row (e.g. `Module-LIMS`) — only declares the `Access` action.
 * @param {string} pEntity
 * @returns {boolean}
 */
function isModuleRow(pEntity)
{
	return String(pEntity || '').indexOf('Module-') === 0;
}

/**
 * An association row (an `X-Y` link entity) — declares `Associate`/`Disassociate` rather than CRUD.
 * @param {string} pEntity
 * @returns {boolean}
 */
function isAssociationRow(pEntity)
{
	return actionsForEntity(pEntity).indexOf('Associate') > -1;
}

/**
 * Bucket an entity into the matrix section it belongs to.
 * @param {string} pEntity
 * @returns {'module'|'association'|'entity'}
 */
function rowKind(pEntity)
{
	if (isModuleRow(pEntity))
	{
		return 'module';
	}
	if (isAssociationRow(pEntity))
	{
		return 'association';
	}
	return 'entity';
}

/**
 * Map a wire Context to the seed-catalog membership key (Customer -> CustomerMembership, ...).
 * @param {string} pContext
 * @returns {string}
 */
function contextToMembership(pContext)
{
	return CONTEXT_TO_MEMBERSHIP[pContext] || pContext;
}

/**
 * Map a seed-catalog membership key back to its wire Context.
 * @param {string} pMembership
 * @returns {string}
 */
function membershipToContext(pMembership)
{
	return MEMBERSHIP_TO_CONTEXT[pMembership] || pMembership;
}

module.exports =
{
	AVAILABLE_ACTIONS,
	PERMISSION_MAP,
	CONTEXT_TO_MEMBERSHIP,
	MEMBERSHIP_TO_CONTEXT,
	REPORT_ENTITY_PREFIX,
	parseHash,
	buildHash,
	actionsForEntity,
	entityHasAction,
	entityList,
	isModuleRow,
	isAssociationRow,
	isReportRow,
	rowKind,
	contextToMembership,
	membershipToContext,
};

},{"./Permission-Catalog.json":1059}],1061:[function(require,module,exports){
'use strict';

/**
 * Project edit access: may this user change a Project record from the config app (and the micro apps built on it)?
 *
 * Mirrors the server. The config app sends no x-application-name on Project writes, so the API decides a Project
 * update with the legacy Meadow rule in api/headlight/source/modules/schemas/MeadowSchema-Project.json (the
 * top-level Authorization block), not the permissions engine:
 *   - level 5 (Administrator): Allow;
 *   - level 4 (Executive): MyCustomer, the project is in the user's customer;
 *   - levels 1-3 (User, Manager, Director): Mine, the user created the project (Project.CreatingIDUser);
 *   - level 0 (Readonly): Deny.
 * Keep the two in step. The server stays the final authority; this only stops the screens offering a save it refuses.
 *
 * Pure functions, no pict / network, so they test in isolation.
 */

/**
 * @typedef {object} ProjectEditUser
 * @property {number|string} [UserID]
 * @property {number|string} [UserRoleIndex] - the user level (0-5)
 * @property {number|string} [CustomerID]
 */

/**
 * @typedef {object} ProjectEditRecord
 * @property {number|string} [IDCustomer]
 * @property {number|string} [CreatingIDUser]
 */

/**
 * Is this user an administrator of the project: Headlight level 5, or level 4 in the project's own customer?
 *
 * @param {ProjectEditUser} pUser - pict.AppData.CurrentUser
 * @param {ProjectEditRecord} pProject - the loaded Project record
 * @return {boolean}
 */
function isProjectAdministrator(pUser, pProject)
{
	const tmpUser = pUser || {};
	const tmpLevel = Number(tmpUser.UserRoleIndex);
	if (tmpLevel >= 5)
	{
		return true;
	}
	if (!pProject)
	{
		return false;
	}
	return (tmpLevel === 4) && (Number(pProject.IDCustomer) === Number(tmpUser.CustomerID));
}

/**
 * May this user save changes to the Project record? A project administrator, or a level 1-3 user who created it.
 *
 * @param {ProjectEditUser} pUser - pict.AppData.CurrentUser
 * @param {ProjectEditRecord} pProject - the loaded Project record (must carry CreatingIDUser for the creator case)
 * @return {boolean}
 */
function canEditProject(pUser, pProject)
{
	if (isProjectAdministrator(pUser, pProject))
	{
		return true;
	}
	if (!pProject)
	{
		return false;
	}
	const tmpUser = pUser || {};
	const tmpLevel = Number(tmpUser.UserRoleIndex);
	const tmpUserID = Number(tmpUser.UserID);
	// Mine applies to levels 1-3 only: level 4 gets MyCustomer alone, so a level-4 creator in another customer is refused.
	return (tmpLevel >= 1) && (tmpLevel <= 3) && (tmpUserID > 0) && (Number(pProject.CreatingIDUser) === tmpUserID);
}

module.exports = { isProjectAdministrator, canEditProject };

},{}],1062:[function(require,module,exports){
/**
 * Date handling for role assignments that start or end on a given day.
 *
 * A start date grants from the first moment of that day and an end date lasts through its last second,
 * both in the project's (or customer's) time zone, so "the 15th" means the whole 15th wherever the work
 * is. The browser's own zone is the fallback. No pict / DOM / network dependencies.
 */

const DAY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Whether a string names an IANA time zone this browser knows.
 *
 * @param {string} pTimeZone - ex. "America/Chicago".
 *
 * @return {boolean} true when Intl accepts it.
 */
function isValidTimeZone(pTimeZone)
{
	if (!pTimeZone || (typeof pTimeZone !== 'string'))
	{
		return false;
	}
	try
	{
		new Intl.DateTimeFormat('en-US', { timeZone: pTimeZone });
		return true;
	}
	catch (pError)
	{
		return false;
	}
}

/**
 * The zone to use: the one given when valid, else the browser's.
 *
 * @param {string} [pTimeZone] - Preferred IANA zone.
 *
 * @return {string} an IANA zone.
 */
function resolveTimeZone(pTimeZone)
{
	return isValidTimeZone(pTimeZone) ? pTimeZone : new Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Wall-clock parts of an instant in a zone.
 *
 * @param {number} pTime - Epoch milliseconds.
 * @param {string} pTimeZone - IANA zone.
 *
 * @return {{ Year: number, Month: number, Day: number, Hour: number, Minute: number, Second: number }} the parts.
 */
function getZonedParts(pTime, pTimeZone)
{
	const tmpParts = {};
	new Intl.DateTimeFormat('en-US',
		{
			timeZone: pTimeZone, hourCycle: 'h23',
			year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
		})
		.formatToParts(new Date(pTime))
		.forEach((pPart) =>
		{
			tmpParts[pPart.type] = Number(pPart.value);
		});
	return { Year: tmpParts.year, Month: tmpParts.month, Day: tmpParts.day, Hour: tmpParts.hour, Minute: tmpParts.minute, Second: tmpParts.second };
}

/**
 * The instant at which a zone's clocks read a given wall-clock time.
 *
 * Corrected twice so a day that crosses a daylight saving change still lands on the right hour.
 *
 * @param {Array<number>} pWallClock - [ year, month (1-12), day, hour, minute, second ].
 * @param {string} pTimeZone - IANA zone.
 *
 * @return {number} epoch milliseconds.
 */
function zonedWallClockToTime(pWallClock, pTimeZone)
{
	const tmpAsUTC = Date.UTC(pWallClock[0], pWallClock[1] - 1, pWallClock[2], pWallClock[3], pWallClock[4], pWallClock[5]);
	let tmpTime = tmpAsUTC;
	for (let i = 0; i < 2; i++)
	{
		const tmpParts = getZonedParts(tmpTime, pTimeZone);
		const tmpOffset = Date.UTC(tmpParts.Year, tmpParts.Month - 1, tmpParts.Day, tmpParts.Hour, tmpParts.Minute, tmpParts.Second) - tmpTime;
		tmpTime = tmpAsUTC - tmpOffset;
	}
	return tmpTime;
}

/**
 * Convert a picked day to the instant it begins or ends in a zone.
 *
 * @param {string} pDay - "YYYY-MM-DD" from a date input.
 * @param {string} [pTimeZone] - IANA zone; the browser's when missing.
 * @param {boolean} pEndOfDay - true for 23:59:59, false for 00:00:00.
 *
 * @return {string} an ISO instant, or '' when the day is empty or malformed.
 */
function dayToInstant(pDay, pTimeZone, pEndOfDay)
{
	const tmpMatch = DAY_PATTERN.exec(String(pDay || ''));
	if (!tmpMatch)
	{
		return '';
	}
	const tmpTime = pEndOfDay ?
		[ Number(tmpMatch[1]), Number(tmpMatch[2]), Number(tmpMatch[3]), 23, 59, 59 ] :
		[ Number(tmpMatch[1]), Number(tmpMatch[2]), Number(tmpMatch[3]), 0, 0, 0 ];
	return new Date(zonedWallClockToTime(tmpTime, resolveTimeZone(pTimeZone))).toISOString();
}

/**
 * The instant a role starting on this day takes effect.
 *
 * @param {string} pDay - "YYYY-MM-DD".
 * @param {string} [pTimeZone] - IANA zone.
 *
 * @return {string} an ISO instant, or ''.
 */
function dayStartToInstant(pDay, pTimeZone)
{
	return dayToInstant(pDay, pTimeZone, false);
}

/**
 * The last instant of a role ending on this day.
 *
 * @param {string} pDay - "YYYY-MM-DD".
 * @param {string} [pTimeZone] - IANA zone.
 *
 * @return {string} an ISO instant, or ''.
 */
function dayEndToInstant(pDay, pTimeZone)
{
	return dayToInstant(pDay, pTimeZone, true);
}

/**
 * The day an instant falls on in a zone.
 *
 * @param {any} pInstant - ISO string or Date; empty and unparseable values read as unset.
 * @param {string} [pTimeZone] - IANA zone.
 *
 * @return {string} "YYYY-MM-DD", or ''.
 */
function instantToDay(pInstant, pTimeZone)
{
	const tmpTime = pInstant ? new Date(pInstant).getTime() : NaN;
	if (!Number.isFinite(tmpTime))
	{
		return '';
	}
	const tmpParts = getZonedParts(tmpTime, resolveTimeZone(pTimeZone));
	return `${tmpParts.Year}-${String(tmpParts.Month).padStart(2, '0')}-${String(tmpParts.Day).padStart(2, '0')}`;
}

/**
 * Today in a zone, for a date input's `min`.
 *
 * @param {string} [pTimeZone] - IANA zone.
 *
 * @return {string} "YYYY-MM-DD".
 */
function todayIn(pTimeZone)
{
	return instantToDay(new Date(), pTimeZone);
}

/**
 * Where an assignment stands in its window: StartDate inclusive, ExpirationDate exclusive, expiry wins.
 *
 * Same rule as api/permissions source/lib/UserContextRole-Window.js, which decides what the user can do;
 * this only labels it.
 *
 * @param {any} pStartDate - ISO string, or empty.
 * @param {any} pExpirationDate - ISO string, or empty.
 * @param {Date} [pNow] - The moment to evaluate at.
 *
 * @return {'Scheduled'|'Active'|'Expired'} the state.
 */
function getWindowState(pStartDate, pExpirationDate, pNow = new Date())
{
	const tmpNow = pNow.getTime();
	const tmpExpiration = pExpirationDate ? new Date(pExpirationDate).getTime() : NaN;
	if (Number.isFinite(tmpExpiration) && (tmpExpiration <= tmpNow))
	{
		return 'Expired';
	}
	const tmpStart = pStartDate ? new Date(pStartDate).getTime() : NaN;
	if (Number.isFinite(tmpStart) && (tmpStart > tmpNow))
	{
		return 'Scheduled';
	}
	return 'Active';
}

module.exports = { isValidTimeZone, resolveTimeZone, dayStartToInstant, dayEndToInstant, instantToDay, todayIn, getWindowState };

},{}],1063:[function(require,module,exports){
'use strict';

/**
 * Task Catalog — the human-facing "what can this subject do?" layer for the Entitlements screen.
 *
 * The RBAC system underneath is fine-grained: capabilities are `<Entity>-<Action>` hashes (Permission-Catalog.js),
 * granted to a Role / Permission Group as RolePermission rows and composed via RoleEdge. Admins shouldn't have to
 * think in those terms. This catalog maps each capability bundle to ONE human **task** ("Manage users", "Import
 * reference data"). Turning a task on for a subject grants its bundle (via a lazily-created Permission Group + a
 * RoleEdge — one group per (customer, task), reused across roles); off removes the RoleEdge.
 *
 * Pure data + helpers — no pict / DOM / network — so it unit-tests in isolation (mirrors Permission-Catalog.js).
 *
 * === DRAFT: the hashes below are a first cut. Verify each against access/Permission-Catalog.json before trusting
 * a task, and tune the bundles with domain knowledge — this file is meant to be curated. ===
 *
 * Task shape:
 *   Key         : stable slug (also the Permission Group name suffix, Task-<Key>)
 *   Label       : the toggle's human label
 *   Area        : grouping header on the screen
 *   Description : one line explaining what it lets someone do
 *   Broad       : true → a coarse, powerful grant; the screen flags it and asks for extra confirmation
 *   RequiresPermissionLevel : e.g. 'CustomerAdmin' / 'RoleManager' — set the subject role's tier (coarse editors
 *                 that gate on PermissionLevel rather than a capability). Omit for pure capability tasks.
 *   Capabilities: { <MembershipScope>: [ '<Entity>-<Action>', … ] } — the hashes granted. Most live at
 *                 'CustomerMembership'; add 'ProjectMembership' / 'ContractMembership' where a task is scoped deeper.
 */

// The master lists an administrator curates (Headlight-MasterLists.js) are the source of truth for the per-list
// entitlement tasks — we generate one task per list (below) so entitlements track the registry rather than drifting
// from a hand-kept copy.
const libMasterLists = require('../master-lists/Headlight-MasterLists.js');

const CURATED_TASKS =
[
	// ── People & Access ────────────────────────────────────────────────────────
	{
		Key: 'manage-users', Label: 'Manage users', Area: 'People & Access',
		Description: 'Create and edit user accounts (accounts are deactivated, not deleted). Assigning roles to users lives under "Manage roles & permissions".',
		Capabilities: { CustomerMembership: [ 'User-Read', 'User-Create', 'User-Update' ] },
	},
	{
		Key: 'manage-teams', Label: 'Manage teams and document grants', Area: 'People & Access',
		Description: 'Create teams, enroll people in them with a role, grant a team (or a role) documents, and record which labs a team staffs, from Settings → Teams. Members of a granted team can open and edit those documents, and reach their projects, without being added to the project. A team linked to a lab is granted every test form for that lab\'s tests; link it to each lab it works, since a lab\'s child labs are not included.',
		Capabilities: { CustomerMembership: [ 'Team-Read', 'Team-Create', 'Team-Update', 'Team-Delete', 'TeamUserJoin-Read', 'TeamUserJoin-Create', 'TeamUserJoin-Update', 'TeamUserJoin-Delete', 'DocumentAccessJoin-Read', 'DocumentAccessJoin-Create', 'DocumentAccessJoin-Update', 'DocumentAccessJoin-Delete', 'LabTeamJoin-Read', 'LabTeamJoin-Create', 'LabTeamJoin-Update', 'LabTeamJoin-Delete' ] },
	},
	{
		// UX gate for the #/FormAccess screen (EntityOwnershipAssignment/Document). Saving still needs CustomerAdmin on
		// the config service.
		Key: 'configure-form-access', Label: 'Configure who can open new forms', Area: 'People & Access',
		Description: 'Choose, for each type of form, the roles that can open and edit a new one as soon as it is created, on any project, without being a project member. Affects forms created afterwards; existing forms keep their access.',
		Capabilities: { CustomerMembership: [ 'FormAccess-Configure' ] },
	},
	{
		Key: 'manage-roles', Label: 'Manage roles & permissions', Area: 'People & Access', Broad: true,
		Description: 'Use the Access workspace to build roles and permission groups and grant capabilities. This is how access itself is administered — grant sparingly.',
		RequiresPermissionLevel: 'RoleManager',
		Capabilities: { CustomerMembership: [ 'Role-Read', 'Role-Create', 'Role-Update', 'Role-Delete', 'Permission-Grant' ] },
	},
	{
		Key: 'manage-customer-team', Label: 'Manage Customer Team', Area: 'People & Access', Broad: true,
		Description: 'Platform super-users only: mark internal employees as Headlight platform admins (who may impersonate a customer’s configuration admin) from the Manage Customers screen. Grant sparingly.',
		Capabilities: { CustomerMembership: [ 'CustomerTeam-Read', 'CustomerTeam-Update' ] },
	},
	{
		Key: 'impersonate-customers', Label: 'Impersonate customer accounts', Area: 'People & Access', Broad: true,
		Description: 'Sign in as a customer’s configuration-admin account from the Manage Customers screen to administer that customer’s configuration. For internal HeadLight support staff (customer 1, level 2+). Grant only to trusted staff.',
		Capabilities: { CustomerMembership: [ 'Customer-Impersonate' ] },
	},
	{
		Key: 'support-view', Label: 'View support cases (read-only)', Area: 'People & Access',
		Description: 'See your organization’s open support cases and the updates from the support team in the read-only portal (#/SupportPortal). No filing or triage. For customer stakeholders who just need visibility.',
		Capabilities: { CustomerMembership: [ 'Support-View' ] },
	},
	{
		Key: 'support-agent', Label: 'Self-serve support (tier-1)', Area: 'People & Access',
		Description: 'File and track your own support calls in the Support console (#/Support). Tier-1 self-service — the categories a caller may file under are set per customer. For customer end-users.',
		Capabilities: { CustomerMembership: [ 'Support-Agent' ] },
	},
	{
		Key: 'support-manage', Label: 'Manage the Support console', Area: 'People & Access',
		Description: 'Full support management: triage every call, run the approval workflow, all request categories, and see the support metrics. For HeadLight support staff and customer support leads.',
		Capabilities: { CustomerMembership: [ 'Support-Agent', 'Support-Manage' ] },
	},
	{
		Key: 'manage-certification-types', Label: 'Manage certification types & setup', Area: 'People & Access',
		Description: 'Create and edit certification types and configure what each one certifies (users, labs, materials, equipment, tests) and certifies-for — the setup behind the Certifications screen. (Saving customer-level configuration may also require a customer administrator.)',
		Capabilities: { CustomerMembership: [ 'CertificationType-Read', 'CertificationType-Create', 'CertificationType-Update', 'CertificationType-Delete' ] },
	},

	// ── Projects & Contracts ────────────────────────────────────────────────────
	{
		Key: 'manage-projects', Label: 'Manage projects', Area: 'Projects & Contracts',
		Description: 'Create and edit projects and their settings.',
		Capabilities: { CustomerMembership: [ 'Project-Read', 'Project-Create', 'Project-Update' ] },
	},
	{
		Key: 'bulk-delete-project-records', Label: 'Bulk delete project records', Area: 'Projects & Contracts', Broad: true,
		Description: 'Unlock the bulk-delete tools on a project — select and remove many of its line items, bid items, equipment links, personnel links, and labels at once. Line/bid item deletes are recoverable soft-deletes; equipment/personnel/labels are unlinked from the project (the shared records stay). A powerful batch action; grant sparingly.',
		Capabilities: { CustomerMembership: [ 'Project-BulkDelete', 'LineItem-Delete', 'BidItem-Delete' ] },
	},
	{
		Key: 'manage-project-staffing', Label: 'Manage project staffing', Area: 'Projects & Contracts',
		Description: 'Add and remove the people on a project from the project\'s Staffing tab, and set their project role (PE, Assistant PE, Contractor Approver, ADA, HQ AE, …).',
		Capabilities: { CustomerMembership: [ 'User-Read', 'Role-Read', 'User-Project-Associate', 'User-Project-Disassociate', 'User-Role-Associate', 'User-Role-Disassociate' ] },
	},
	{
		Key: 'manage-contracts', Label: 'Manage contracts', Area: 'Projects & Contracts',
		Description: 'Create and edit contracts. (Bid items and line items are their own entries under Master Lists.)',
		Capabilities: { CustomerMembership: [ 'Contract-Read', 'Contract-Create', 'Contract-Update' ] },
	},
	{
		Key: 'manage-project-contract-types', Label: 'Manage project & contract types', Area: 'Projects & Contracts',
		Description: 'Create and edit Project Types and Contract Types — their status lifecycles, default dates, allowed project types, default funding, and the prototype each new project/contract is cloned from. Unlocks the Project Types and Contract Types screens.',
		Capabilities: { CustomerMembership: [ 'ProjectType-Read', 'ProjectType-Create', 'ProjectType-Update', 'ProjectType-Delete', 'ContractType-Read', 'ContractType-Create', 'ContractType-Update', 'ContractType-Delete' ] },
	},
	{
		Key: 'manage-organizations', Label: 'Manage organizations', Area: 'Projects & Contracts',
		Description: 'Maintain the organizations (contractors, agencies) directory.',
		Capabilities: { CustomerMembership: [ 'Organization-Read', 'Organization-Create', 'Organization-Update' ] },
	},
	{
		Key: 'manage-important-files', Label: 'Manage important project files', Area: 'Projects & Contracts',
		Description: 'Organize a project’s important files: create and rename folders, move files and folders between them, and add or remove files. Anyone who can see a project can already browse and download its important files read-only — this unlocks changing them.',
		Capabilities: { CustomerMembership: [ 'ProjectFile-Read', 'ProjectFile-Create', 'ProjectFile-Update', 'ProjectFile-Delete', 'ProjectFileFolder-Read', 'ProjectFileFolder-Create', 'ProjectFileFolder-Update', 'ProjectFileFolder-Delete' ] },
	},

	// ── Field Data ──────────────────────────────────────────────────────────────
	{
		// Enabled 2026-10-04. An "observation type" = one ObservationManifest (Name/DisplayName/Category/IDCustomer)
		// + its ObservationRequirementSpecification rows (each → a shared ArtifactType). Every one of those writes is
		// gated by the per-entity `<Entity>-<Action>` capability — HeadlightController.allowsCreate/Update/Delete →
		// hasPermissionInContext('<Entity>-Create' …) — so granting this task is what actually lets a customer admin
		// manage their OWN types through the #/ObservationType editor (nothing to change server-side to "open writes":
		// the schema Authorization block's Deny/MyCustomer is VESTIGIAL in meadow-endpoints 4.x and is not the gate).
		// Customer scoping is enforced by the server, not this grant: ObservationManifest + ArtifactType carry
		// IDCustomer, so HeadlightController.checkAndInferRecordIDCustomer stamps the caller's customer onto every
		// create and rejects cross-customer writes; ObservationRequirementSpecification has NO IDCustomer, so
		// ObservationManifestBundle.enforceRequirementSpecCustomerScope scopes its writes to the parent manifest's
		// customer. Net: a customer can only create/edit their own types — never the global (IDCustomer 0) platform
		// defaults (they clone a default to customize it). We include the full ObservationRequirementSpecification
		// CRUD set because the editor creates/updates AND deletes requirement rows when a type is edited.
		Key: 'manage-observation-types', Label: 'Manage observation types', Area: 'Field Data',
		Description: 'Build and edit your organization’s observation types — their requirements and artifact types. New and edited types are automatically scoped to your organization; the shared platform defaults stay read-only (clone one to customize it).',
		Capabilities: { CustomerMembership: [ 'ObservationManifest-Read', 'ObservationManifest-Create', 'ObservationManifest-Update', 'ObservationRequirementSpecification-Read', 'ObservationRequirementSpecification-Create', 'ObservationRequirementSpecification-Update', 'ObservationRequirementSpecification-Delete', 'ArtifactType-Read', 'ArtifactType-Create', 'ArtifactType-Update' ] },
	},
	{
		Key: 'manage-observation-tags', Label: 'Manage observation tags', Area: 'Field Data',
		Description: 'Maintain the tags used to categorize observations.',
		Capabilities: { CustomerMembership: [ 'ObservationTag-Read', 'ObservationTag-Create', 'ObservationTag-Update', 'ObservationTag-Delete' ] },
	},
	{
		Key: 'manage-document-types', Label: 'Manage document types', Area: 'Field Data',
		Description: 'Maintain report/document definitions.',
		Capabilities: { CustomerMembership: [ 'ReportNamedInstance-Read', 'ReportNamedInstance-Create', 'ReportNamedInstance-Update' ] },
	},
	{
		// UX-only gate (not server-enforced): unlocks the raw-JSON metadata editor for report named instances in the
		// Forms Editor. Sits beneath "Manage document types" — a document-type editor manages RNIs through the guided
		// form; this additionally lets a power user hand-edit the raw Options JSON (bypassing the guided fields).
		Key: 'edit-report-json', Label: 'Edit report JSON (advanced)', Area: 'Field Data',
		Description: 'Allow hand-editing the raw Options JSON of a report named instance in the Forms Editor. Without it the JSON view is read-only. This is a UX gate — it controls the editor affordance, not server-side write permission.',
		Capabilities: { CustomerMembership: [ 'ReportNamedInstance-EditJSON' ] },
	},
	{
		// UX-only gate (not server-enforced): unlocks the raw-JSON "Advanced" view of a record's per-customer custom
		// metadata (its CustomProperties blob) in the record workspaces. Without it only the guided metadata form is
		// shown; with it a power user can toggle to see/edit the raw JSON directly (bypassing the guided fields). See
		// the EntityMetadataForm provider — reusable across entity types (Project first).
		Key: 'edit-custom-metadata-json', Label: 'Edit custom metadata JSON (advanced)', Area: 'Projects & Contracts',
		Description: 'Allow toggling a record’s Custom Properties to the raw-JSON editor (bypassing the guided metadata form). Without it the guided form is shown and the raw JSON is hidden. This is a UX gate — it controls the editor affordance, not server-side write permission.',
		Capabilities: { CustomerMembership: [ 'CustomMetadata-Advanced' ] },
	},
	{
		// UX gate for the bespoke #/ATMDashboardConfig screen. Unlocks editing the Audit of Testing & Materials /
		// Sample Plan Checklist dashboard configuration — the validation rules (MaterialsAudit namespace) and the
		// display columns (AppDashboards SamplePlan). The screen writes cascading config at Customer/Project scope;
		// the Configuration/Put server gate stays authoritative.
		Key: 'configure-atm-dashboard', Label: 'Configure the Audit of Testing and Materials dashboard', Area: 'Field Data',
		Description: 'Configure the Audit of Testing & Materials (ATM) / Sample Plan Checklist dashboard — the validation rules (which conformance checks run, the pass/fail vocabulary, accepted-quantity basis) and which columns the checklist shows. Sets customer-wide defaults with optional per-project overrides.',
		Capabilities: { CustomerMembership: [ 'MaterialsAudit-Configure' ] },
	},

	// ── Sample Configuration ─────────────────────────────────────────────────────
	{
		// UX gate for the bespoke #/SampleListColumnsConfig screen. Unlocks choosing which columns the config
		// app's Samples list (#/PSRS/Sample/List) shows + their header labels, saved as a cascading
		// MasterListCatalog Configuration (Platform / Customer / My Settings). The Configuration/Put server gate
		// stays authoritative.
		Key: 'configure-sample-list-columns', Label: 'Configure the Samples list columns', Area: 'Sample Configuration',
		Description: 'Choose which columns the Samples list shows and rename their headers. Save as a platform default, a customer-wide default, or a personal preference.',
		Capabilities: { CustomerMembership: [ 'SampleListColumns-Configure' ] },
	},
	{
		// UX gate for the bespoke #/SampleQRCodeConfig screen. Unlocks configuring how new sample QR codes are
		// generated (standard vs SiteManager/legacy format), stored on the customer's CustomProperties.
		Key: 'configure-sample-qr-code', Label: 'Configure sample QR codes, labels and scanning', Area: 'Sample Configuration',
		Description: 'Configure how new sample QR codes are generated and what the printed label shows, whether Fieldbook on iPad shows its QR scanner, and the status a sample takes when it is scanned into a location (Sample QR Codes and Sample Scanning screens), for your customer.',
		Capabilities: { CustomerMembership: [ 'SampleQRCode-Configure' ] },
	},
	{
		// UX gate for the #/EntityDestinations screen: where scanned labels and emailed links open, per role.
		Key: 'configure-entity-destinations', Label: 'Configure where records open', Area: 'Sample Configuration',
		Description: 'Choose where a scanned QR label or an emailed link takes each person, by role and record state, for your customer.',
		Capabilities: { CustomerMembership: [ 'EntityDestinations-Configure' ] },
	},
	{
		// UX gate for the #/DashboardAccess screen. Saving still needs CustomerAdmin on the config service.
		Key: 'configure-dashboard-access', Label: 'Configure dashboard access', Area: 'Sample Configuration',
		Description: 'Choose which dashboards each role sees, the one they open first, and what data each dashboard shows them, and which classic dashboards Fieldbook offers on a project (Dashboard Access and Fieldbook Dashboards screens), for your customer.',
		Capabilities: { CustomerMembership: [ 'DashboardAccess-Configure' ] },
	},
	{
		// Read by the Sample workspace (samples/SampleWorkspace-Provider.js canOverrideLock). Browser-side only: the API
		// doesn't refuse changes to a locked sample, so this is a convenience, not a control.
		Key: 'override-sample-lock', Label: 'Change locked samples', Area: 'Sample Configuration', Broad: true,
		Description: 'Edit, delete and change the line items and tests of a sample that is locked. Without this, a locked sample is read-only apart from its documents and notes.',
		Capabilities: { CustomerMembership: [ 'SampleLock-Override' ] },
	},

	// ── Communications ──────────────────────────────────────────────────────────
	{
		Key: 'manage-email-notifications', Label: 'Manage email notifications', Area: 'Communications',
		Description: 'Configure the email notification rules.',
		Capabilities: { CustomerMembership: [ 'EmailRule-Read', 'EmailRule-Create', 'EmailRule-Update', 'EmailRule-Delete' ] },
	},

	// ── Documentation ─────────────────────────────────────────────────────────────
	{
		Key: 'edit-documentation', Label: 'Edit in-app help documentation', Area: 'Documentation',
		Description: 'Edit the in-app help pages in place (the ✎ Edit button in the documentation panel). Edits are saved as THIS customer’s override of the platform default; platform super-users editing edit the default that every customer inherits.',
		Capabilities: { CustomerMembership: [ 'AcademyContent-Read', 'AcademyContent-Create', 'AcademyContent-Update', 'AcademyContent-Delete' ] },
	},

	// ── Contract Administration ─────────────────────────────────────────────────────
	// The financial arc (funds, funding sources, categories, accounts) — its own Entitlements tab. The per-entity
	// management tasks below are the re-homed Pay & Funding master lists (see MASTER_LIST_TASKS); these two carry
	// the grants NOT covered by list CRUD: the funding-wiring association verbs, and module access.
	{
		Key: 'associate-funding', Label: 'Wire funding to contracts, projects & line items', Area: 'Contract Administration',
		Description: 'Link funding sources, funds, and categories to contracts, projects, and line items — the associations the project-funding screen creates. Does not include editing the funds/sources themselves (those are the management tasks in this tab).',
		Capabilities: { CustomerMembership: [
			'FundingSource-Contract-Associate', 'FundingSource-Contract-Disassociate',
			'FundingSource-Fund-Associate', 'FundingSource-Fund-Disassociate',
			'FundingSource-FundingCategory-Associate', 'FundingSource-FundingCategory-Disassociate',
			'FundingSource-Project-Associate', 'FundingSource-Project-Disassociate',
			'FundingSource-LineItem-Associate', 'FundingSource-LineItem-Disassociate',
			'Fund-Project-Associate', 'Fund-Project-Disassociate',
			'Fund-Document-Associate', 'Fund-Document-Disassociate',
			'FundingCategory-Project-Associate', 'FundingCategory-Project-Disassociate',
			'FundingCategory-LineItem-Associate', 'FundingCategory-LineItem-Disassociate' ] },
	},
	{
		Key: 'access-contract-admin', Label: 'Access the Contract Administration module', Area: 'Contract Administration',
		Description: 'Open the Contract Administration surface (payments, change orders, funding) — the module gate that lets the funding screens load.',
		Capabilities: { CustomerMembership: [ 'Module-ContractAdmin-Access' ] },
	},

];

// ── Master Lists — one explicit task per curated list, generated from the registry ────────────────────────────
// Each grants Read/Create/Update on the list's entity. `Domain` (from the registry) is kept for optional
// sub-grouping on the screen. New/renamed lists flow through automatically; the screen shows them individually.
const MASTER_LIST_TASKS = (libMasterLists || []).map((pList) =>
({
	Key: `manage-list-${pList.Entity}`,
	Label: `Manage ${pList.Label || pList.Entity}`,
	// Pay & Funding lists live under the dedicated Contract Administration tab; everything else stays in Master Lists.
	Area: (pList.Domain === 'Pay & Funding') ? 'Contract Administration' : 'Master Lists',
	Domain: pList.Domain || '',
	MasterList: true,
	Description: `Add and edit entries in the ${pList.Label || pList.Entity} list.`,
	Capabilities: { CustomerMembership: [ `${pList.Entity}-Read`, `${pList.Entity}-Create`, `${pList.Entity}-Update` ] },
}));

// ── Administration — coarse tasks last (they set a PermissionLevel tier, not a capability bundle) ──────────────
const ADMIN_TASKS =
[
	{
		Key: 'core-platform-admin', Label: 'Core Platform Administration', Area: 'Administration', Broad: true,
		Description: 'Broad administrative editing for the settings that aren’t individually entitled — approval workflows, cascading configuration, in-app help, the data lake, and reference-list setup. A powerful, all-in role; grant only to trusted administrators.',
		RequiresPermissionLevel: 'CustomerAdmin',
		Capabilities: {},
	},
];

const TASKS = CURATED_TASKS.concat(MASTER_LIST_TASKS, ADMIN_TASKS);

/** All tasks, in catalog order. */
function getTasks() { return TASKS; }

/** A task by Key, or null. @param {string} pKey */
function getTask(pKey) { return TASKS.find((pTask) => pTask.Key === pKey) || null; }

/** Tasks grouped by Area, in catalog order: [ { Area, Tasks:[…] }, … ]. */
function tasksByArea()
{
	const tmpOrder = [];
	const tmpByArea = {};
	TASKS.forEach((pTask) =>
	{
		if (!tmpByArea[pTask.Area]) { tmpByArea[pTask.Area] = { Area: pTask.Area, Tasks: [] }; tmpOrder.push(tmpByArea[pTask.Area]); }
		tmpByArea[pTask.Area].Tasks.push(pTask);
	});
	return tmpOrder;
}

/** Flatten a task's capability hashes across every membership scope → [ { Scope, Hash }, … ]. @param {object} pTask */
function taskGrants(pTask)
{
	const tmpGrants = [];
	const tmpCaps = (pTask && pTask.Capabilities) || {};
	Object.keys(tmpCaps).forEach((pScope) => (tmpCaps[pScope] || []).forEach((pHash) => tmpGrants.push({ Scope: pScope, Hash: pHash })));
	return tmpGrants;
}

module.exports = { TASKS, getTasks, getTask, tasksByArea, taskGrants };

},{"../master-lists/Headlight-MasterLists.js":1290}],1064:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */
/**
 * User search — the one way HPC finds people by what an admin types.
 *
 * A person is matched on first name, last name, email and login ID (LADOTD login IDs are employee numbers, e.g.
 * `00266863@ladotd`). The query is split on whitespace and every word must match one of those fields, so a full
 * name ("Gayle Ritchie"), a reversed one ("Ritchie, Gayle"), a login ID or an email all find the person. It is a
 * single `Users/FilteredTo` request: each word becomes a parenthesized OR group across the fields, and the groups
 * AND together with the caller's scope (customer, Deleted) — verified on QA that the server honors the grouping.
 *
 * The filter itself is pict-section-picker's `buildSearchFilter`, a pure function, reused rather than rebuilt.
 */

const libPictSectionPicker = require('pict-section-picker');

/** User columns a person is found by (stricture DDL: lib/headlight_model/ddl/systemmanagement/Account.mddl). */
const USER_SEARCH_FIELDS = [ 'NameFirst', 'NameLast', 'Email', 'LoginID' ];

/** Results come back in name order, so a capped page is the first N people alphabetically. */
const USER_SORT = 'FSF~NameLast~ASC~0~FSF~NameFirst~ASC~0';

const DEFAULT_PAGE_SIZE = 50;
const MAX_PAGE_SIZE = 250;

/**
 * @typedef {Object} UserSearchOptions
 * @property {string | (() => string)} [Scope] - FoxHound stanzas ANDed onto the search, e.g.
 *   `FBV~IDCustomer~EQ~10~FBV~Deleted~EQ~0`; a function is read at call time (pickers outlive a customer switch).
 * @property {number} [Start] - Record offset (default 0).
 * @property {number} [PageSize] - Records per request (default 50, never above 250).
 */

/**
 * @typedef {Object} UserPickerOption
 * @property {number} Value - IDUser.
 * @property {string} Text - The person's display label.
 * @property {string} Tag - Login ID (else email), drawn as a pill so two people with the same name can be told apart.
 * @property {Record<string, any>} Record - The User record.
 */

/**
 * Tidy what the user typed into search words: `~` is FoxHound's separator, a comma separates "Last, First", and
 * `*` reads as a wildcard.
 *
 * @param {any} pQuery - The raw search text.
 * @returns {string} The cleaned query (single-spaced, trimmed; '' when nothing is left).
 */
function cleanQuery(pQuery)
{
	return String(pQuery == null ? '' : pQuery).replace(/[~,]/g, ' ').replace(/\*/g, '%').replace(/\s+/g, ' ').trim();
}

/**
 * Filter stanzas matching every word of the query against any of the fields (one OR group per word, ANDed).
 *
 * @param {Array<string>} pFields - Entity columns to LIKE-match.
 * @param {any} pQuery - The raw search text.
 * @returns {string} FoxHound filter stanzas, or '' for an empty query.
 */
function buildSearchFilter(pFields, pQuery)
{
	return libPictSectionPicker.prototype.buildSearchFilter.call(null, pFields, cleanQuery(pQuery));
}

/**
 * @param {any} pQuery - The raw search text.
 * @returns {string} FoxHound filter stanzas matching people by name, email or login ID, or '' for an empty query.
 */
function buildUserSearchFilter(pQuery)
{
	return buildSearchFilter(USER_SEARCH_FIELDS, pQuery);
}

/**
 * @param {UserSearchOptions} [pOptions]
 * @returns {number} The requested page size, clamped to 1..250.
 */
function pageSize(pOptions)
{
	const tmpSize = Math.floor(Number(pOptions && pOptions.PageSize) || DEFAULT_PAGE_SIZE);
	return Math.min(Math.max(tmpSize, 1), MAX_PAGE_SIZE);
}

/**
 * The `Users/FilteredTo` URL for a search. An empty query browses the scope, still in name order.
 *
 * @param {any} pQuery - The raw search text.
 * @param {UserSearchOptions} [pOptions]
 * @returns {string} A URL relative to the API root (`Users/FilteredTo/<filter>/<start>/<count>`).
 */
function buildUserSearchURL(pQuery, pOptions)
{
	const tmpOptions = pOptions || {};
	const fScope = tmpOptions.Scope;
	const tmpScope = (typeof fScope === 'function') ? fScope() : fScope;
	const tmpFilter = [ buildUserSearchFilter(pQuery), tmpScope, USER_SORT ].filter(Boolean).join('~');
	const tmpStart = Math.max(Math.floor(Number(tmpOptions.Start) || 0), 0);
	return `Users/FilteredTo/${tmpFilter}/${tmpStart}/${pageSize(tmpOptions)}`;
}

/**
 * Run a user search.
 *
 * @param {(pURL: string) => Promise<any>} fGetJSON - The caller's API GET (relative URL → parsed body).
 * @param {any} pQuery - The raw search text.
 * @param {UserSearchOptions} [pOptions]
 * @returns {Promise<Array<Record<string, any>>>} Matching User records in name order ([] for an error body).
 */
async function searchUsersAsync(fGetJSON, pQuery, pOptions)
{
	const tmpRows = await fGetJSON(buildUserSearchURL(pQuery, pOptions));
	return Array.isArray(tmpRows) ? tmpRows : [];
}

/**
 * How a person is shown: their name, else their login ID, else their email.
 *
 * @param {Record<string, any>} pUser - A User record.
 * @returns {string} The display label.
 */
function userLabel(pUser)
{
	if (!pUser)
	{
		return '';
	}
	const tmpName = `${pUser.NameFirst || ''} ${pUser.NameLast || ''}`.trim();
	return tmpName || pUser.LoginID || pUser.Email || `User #${pUser.IDUser}`;
}

/**
 * The picker option for a person: their label, tagged with their login ID (else email) unless that is already the label.
 *
 * @param {Record<string, any>} pUser - A User record.
 * @returns {UserPickerOption} The option.
 */
function userPickerOption(pUser)
{
	const tmpText = userLabel(pUser);
	const tmpTag = [ pUser.LoginID, pUser.Email ].find((pValue) => pValue && (pValue !== tmpText)) || '';
	return { Value: Number(pUser.IDUser), Text: tmpText, Tag: tmpTag, Record: pUser };
}

/**
 * A pict-section-picker DataProvider over the user search: `(term, page) => { results, hasMore }`. An empty term
 * browses the scope page by page; a failed request shows an empty list.
 *
 * @param {(pURL: string) => Promise<any>} fGetJSON - The caller's API GET.
 * @param {UserSearchOptions & { ToOption?: (pUser: Record<string, any>) => UserPickerOption }} [pOptions]
 * @returns {(pTerm: any, pPage: number) => Promise<{ results: Array<UserPickerOption>, hasMore: boolean }>}
 */
function userPickerDataProvider(fGetJSON, pOptions)
{
	const tmpOptions = pOptions || {};
	const tmpPageSize = pageSize(tmpOptions);
	const fToOption = tmpOptions.ToOption || userPickerOption;
	return (pTerm, pPage) =>
	{
		const tmpSearch = Object.assign({}, tmpOptions, { Start: (Number(pPage) || 0) * tmpPageSize, PageSize: tmpPageSize });
		return searchUsersAsync(fGetJSON, pTerm, tmpSearch)
			.then((pRows) => ({ results: pRows.map(fToOption), hasMore: (pRows.length >= tmpPageSize) }))
			.catch(() => ({ results: [], hasMore: false }));
	};
}

module.exports =
{
	USER_SEARCH_FIELDS,
	MAX_PAGE_SIZE,
	cleanQuery,
	buildSearchFilter,
	buildUserSearchFilter,
	buildUserSearchURL,
	searchUsersAsync,
	userLabel,
	userPickerOption,
	userPickerDataProvider,
};

},{"pict-section-picker":711}],1065:[function(require,module,exports){
/**
 * ApprovalWorkflow-Dot — turn a workflow blob into a graphviz DOT graph.
 *
 * This is the input to the graphviz-WASM renderer: graphviz does the whole diagram (layout, spline edge
 * routing with proper attachment + arrowheads, non-overlapping labels, crossing minimisation) — the thing
 * we were hand-reconstructing in pict-section-flow. Each node/edge carries a stable `id` (s0…, e0…) so the
 * renderer can map an SVG click back to the model via the returned NodeMap / EdgeMap.
 *
 * Pure (no graphviz / DOM here) so it's unit-testable on its own.
 */

const libModel = require('./ApprovalWorkflow-Model.js');

/** Escape a string for a DOT double-quoted label. */
function _escape(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n');
}

/** Wrap text to ~pMax chars per line at word boundaries, joined with real newlines (escaped later). */
function _wrap(pText, pMax)
{
	const tmpWords = String(pText || '').split(/\s+/).filter(Boolean);
	const tmpLines = [];
	let tmpCurrent = '';
	tmpWords.forEach((pWord) =>
	{
		if (tmpCurrent && (tmpCurrent.length + 1 + pWord.length) > pMax)
		{
			tmpLines.push(tmpCurrent);
			tmpCurrent = pWord;
		}
		else
		{
			tmpCurrent = tmpCurrent ? `${tmpCurrent} ${pWord}` : pWord;
		}
	});
	if (tmpCurrent) { tmpLines.push(tmpCurrent); }
	return tmpLines.join('\n');
}

/** Recursively flatten a transition's branches into { ToStatus } entries (incl. nested). */
function _flattenBranchTargets(pBranches)
{
	const tmpOut = [];
	(pBranches || []).forEach((pBranch) =>
	{
		tmpOut.push({ ToStatus: pBranch.ToStatus });
		if (Array.isArray(pBranch.Branches) && pBranch.Branches.length)
		{
			tmpOut.push(..._flattenBranchTargets(pBranch.Branches));
		}
	});
	return tmpOut;
}

/**
 * Build a DOT string + the id→model maps.
 * @param {Object} pWorkflow  the normalized working blob
 * @param {Object} [pOptions]
 * @return {{ Dot: String, NodeMap: Object, EdgeMap: Object }}
 *   NodeMap: { '<nodeId>': '<Status>' }
 *   EdgeMap: { '<edgeId>': { SourceStatus, TransitionIndex, IsBranch, ToStatus } }
 */
function blobToDot(pWorkflow, pOptions)
{
	const tmpStates = (pWorkflow && Array.isArray(pWorkflow.States)) ? pWorkflow.States : [];
	const tmpIdByStatus = {};
	const tmpNodeMap = {};
	tmpStates.forEach((pState, pIndex) =>
	{
		tmpIdByStatus[pState.Status] = `s${pIndex}`;
		tmpNodeMap[`s${pIndex}`] = pState.Status;
	});

	let tmpDot = 'digraph approval {\n';
	tmpDot += '  rankdir=TB;\n';
	tmpDot += '  bgcolor="transparent";\n';
	tmpDot += '  nodesep=0.45;\n';
	tmpDot += '  ranksep=0.55;\n';
	tmpDot += '  splines=spline;\n';
	// fontname is a single PostScript face ("Helvetica") that graphviz has built-in width metrics for — a
	// comma font-stack makes it fall back to Times metrics and mis-size the label boxes. The rendered SVG still
	// asks the browser for Helvetica/Arial/sans-serif via the CSS in the editor view.
	tmpDot += '  node [shape=box, style="rounded,filled", fontname="Helvetica", fontsize=11, penwidth=1.6, margin="0.16,0.09"];\n';
	tmpDot += '  edge [shape=normal, fontname="Helvetica", fontsize=10, penwidth=1.6, arrowsize=0.85];\n';

	// State nodes: label = wrapped display name; fill = light tint, border + font tuned per state colour.
	tmpStates.forEach((pState, pIndex) =>
	{
		const tmpColor = libModel.stateColor(pState.Status);
		const tmpTint = libModel.stateTint(pState.Status);
		const tmpLabel = _wrap(pState.StateName || pState.Status, 22);
		tmpDot += `  s${pIndex} [id="s${pIndex}", label="${_escape(tmpLabel)}", fillcolor="${tmpTint}", color="${tmpColor}", fontcolor="#2c3e50"];\n`;
	});

	// Transition edges (+ flattened branch edges, dashed). Edge colour = destination state's colour.
	const tmpEdgeMap = {};
	let tmpEdgeIndex = 0;
	tmpStates.forEach((pState) =>
	{
		const tmpSourceId = tmpIdByStatus[pState.Status];
		(pState.Transitions || []).forEach((pTransition, pTransitionIndex) =>
		{
			if (tmpIdByStatus.hasOwnProperty(pTransition.ToStatus))
			{
				const tmpEid = `e${tmpEdgeIndex++}`;
				const tmpColor = libModel.stateColor(pTransition.ToStatus);
				tmpDot += `  ${tmpSourceId} -> ${tmpIdByStatus[pTransition.ToStatus]} [id="${tmpEid}", label="${_escape(pTransition.Action || '')}", color="${tmpColor}", fontcolor="${tmpColor}"];\n`;
				tmpEdgeMap[tmpEid] = { SourceStatus: pState.Status, TransitionIndex: pTransitionIndex, IsBranch: false, ToStatus: pTransition.ToStatus };
			}
			_flattenBranchTargets(pTransition.Branches).forEach((pBranch) =>
			{
				if (tmpIdByStatus.hasOwnProperty(pBranch.ToStatus))
				{
					const tmpEid = `e${tmpEdgeIndex++}`;
					const tmpColor = libModel.stateColor(pBranch.ToStatus);
					tmpDot += `  ${tmpSourceId} -> ${tmpIdByStatus[pBranch.ToStatus]} [id="${tmpEid}", label="${_escape(pTransition.Action || '')}", color="${tmpColor}", fontcolor="${tmpColor}", style="dashed"];\n`;
					tmpEdgeMap[tmpEid] = { SourceStatus: pState.Status, TransitionIndex: pTransitionIndex, IsBranch: true, ToStatus: pBranch.ToStatus };
				}
			});
		});
	});

	tmpDot += '}\n';
	return { Dot: tmpDot, NodeMap: tmpNodeMap, EdgeMap: tmpEdgeMap };
}

module.exports = { blobToDot };

},{"./ApprovalWorkflow-Model.js":1068}],1066:[function(require,module,exports){
/**
 * ApprovalWorkflow-GraphRenderer — render a workflow as a graphviz SVG and make it interactive.
 *
 * This replaces the pict-section-flow canvas: graphviz (WASM) does the entire diagram — layout, spline edge
 * routing with proper attachment + arrowheads, non-overlapping labels, crossing minimisation. We inject its
 * SVG, add mouse pan/zoom (by mutating the SVG viewBox), and delegate clicks on graphviz's `.node` / `.edge`
 * groups back to the model via the id maps from ApprovalWorkflow-Dot.
 *
 * One renderer instance per editor; `render(workflow)` re-runs graphviz and re-wires. graphviz loads once
 * (WASM inlined in the package, so it bundles — no .wasm to serve).
 */

const libDot = require('./ApprovalWorkflow-Dot.js');

// Pointer travel (client px) between press and release below which the gesture is a CLICK, not a pan.
// A real mouse/trackpad click almost always jitters a few pixels; too tight a value here swallows the
// click (it looks like a tiny drag) so nodes/edges never open their panel. Pan begins past this.
const DRAG_THRESHOLD = 6;

let _graphvizPromise = null;

function _loadGraphviz()
{
	if (!_graphvizPromise)
	{
		// Required lazily so the (large) WASM module only initialises when a graph is actually shown.
		//
		// We pull in the graphviz build DIRECTLY by its file path rather than the package entry. The umbrella
		// entries (@hpcc-js/wasm main/browser) are thin wrappers whose .load() does a runtime `import('./graphviz.js')`
		// (or bare `require('./graphviz.cjs')`) to fetch the real module — browserify can't resolve those, so the
		// bundled code throws "require is not defined" at render time. dist/graphviz.cjs is the whole graphviz module
		// with the WASM inlined as base64 and browser instantiation (WebAssembly.instantiate): no dynamic import, no
		// bare require, so browserify bundles it cleanly. (browserify 17 ignores the package `exports` map, so the
		// explicit dist path resolves; this file is browser-only, so node's exports enforcement never applies.)
		const libGraphviz = require('@hpcc-js/wasm/dist/graphviz.cjs');
		_graphvizPromise = libGraphviz.Graphviz.load();
	}
	return _graphvizPromise;
}

class ApprovalGraphRenderer
{
	/**
	 * @param {HTMLElement} pContainer  the element the SVG is injected into
	 * @param {Object} pCallbacks       { onNodeClick(status), onEdgeClick({SourceStatus,TransitionIndex,IsBranch,ToStatus}) }
	 */
	constructor(pContainer, pCallbacks)
	{
		this.container = pContainer;
		this.callbacks = pCallbacks || {};
		this._nodeMap = {};
		this._edgeMap = {};
		this._statusOrder = null; // states in the laid-out top-to-bottom order (for the steps rail)
		this._svg = null;
		this._view = null;      // current viewBox { x, y, w, h }
		this._baseView = null;  // graphviz's natural bounds (for fit)
		this._panning = false;
		this._didPan = false;
		this._panStart = null;
		this._renderSeq = 0;

		// Panning tracks the pointer across the whole window (so a fast drag off the SVG still works). Bound
		// once; they read the current _svg/_view, so they survive re-renders.
		this._boundMove = (pEvent) => this._onPointerMove(pEvent);
		this._boundUp = (pEvent) => this._onPointerUp(pEvent);
		if (typeof window !== 'undefined')
		{
			window.addEventListener('pointermove', this._boundMove);
			window.addEventListener('pointerup', this._boundUp);
		}
	}

	/** Render the workflow. Options: { keepView } preserves the current pan/zoom across a re-render. */
	async render(pWorkflow, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpBuilt = libDot.blobToDot(pWorkflow);
		this._nodeMap = tmpBuilt.NodeMap;
		this._edgeMap = tmpBuilt.EdgeMap;

		const tmpSeq = ++this._renderSeq;
		const tmpGraphviz = await _loadGraphviz();
		if (tmpSeq !== this._renderSeq) { return; } // a newer render superseded this one

		let tmpSvgText;
		try { tmpSvgText = tmpGraphviz.dot(tmpBuilt.Dot); }
		catch (pError) { this.container.innerHTML = `<div class="apw-graph-error">Could not render the workflow diagram.</div>`; return; }

		this.container.innerHTML = tmpSvgText;
		const tmpSvg = this.container.querySelector('svg');
		if (!tmpSvg) { return; }
		this._prepareSvg(tmpSvg, !!tmpOptions.keepView);
		this._wireSvg(tmpSvg);
		this._computeStatusOrder(tmpSvg);
		if (typeof this.callbacks.onRendered === 'function') { this.callbacks.onRendered(); }
	}

	/**
	 * Record the states in the order graphviz laid them out, top to bottom (each `.node` group's vertical
	 * position). The steps rail reads this so it lists states in the SAME order the diagram shows — which, for
	 * a cyclic workflow, graphviz derives from the graph, not the stored array order.
	 */
	_computeStatusOrder(pSvg)
	{
		const tmpNodes = [];
		pSvg.querySelectorAll('.node').forEach((pEl) =>
		{
			const tmpStatus = this._nodeMap[pEl.getAttribute('id')];
			if (tmpStatus == null) { return; }
			let tmpY = 0;
			try { tmpY = pEl.getBBox().y; } catch (pError) { tmpY = 0; }
			tmpNodes.push({ Status: tmpStatus, Y: tmpY });
		});
		tmpNodes.sort((pA, pB) => pA.Y - pB.Y);
		this._statusOrder = tmpNodes.map((pNode) => pNode.Status);
	}

	/** The states in diagram (top-to-bottom) order, or null before the first successful render. */
	getStatusOrder()
	{
		return this._statusOrder ? this._statusOrder.slice() : null;
	}

	/** Make the SVG fill the container and take over its viewBox for pan/zoom. */
	_prepareSvg(pSvg, pKeepView)
	{
		const tmpViewBox = (pSvg.getAttribute('viewBox') || '0 0 100 100').split(/\s+/).map(parseFloat);
		this._baseView = { x: tmpViewBox[0], y: tmpViewBox[1], w: tmpViewBox[2], h: tmpViewBox[3] };
		if (!pKeepView || !this._view)
		{
			this._view = Object.assign({}, this._baseView);
		}
		pSvg.removeAttribute('width');
		pSvg.removeAttribute('height');
		pSvg.setAttribute('width', '100%');
		pSvg.setAttribute('height', '100%');
		pSvg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
		pSvg.style.display = 'block';
		pSvg.style.cursor = 'grab';
		pSvg.style.touchAction = 'none';
		this._svg = pSvg;
		this._applyView();
	}

	_applyView()
	{
		if (!this._svg || !this._view) { return; }
		const tmpV = this._view;
		this._svg.setAttribute('viewBox', `${tmpV.x} ${tmpV.y} ${tmpV.w} ${tmpV.h}`);
	}

	/** Reset pan/zoom to fit the whole diagram. */
	fit()
	{
		if (this._baseView)
		{
			this._view = Object.assign({}, this._baseView);
			this._applyView();
		}
	}

	/** Zoom by a factor around the diagram centre (for the on-canvas +/- buttons). <1 zooms in. */
	zoomBy(pFactor)
	{
		if (!this._svg || !this._view) { return; }
		const tmpV = this._view;
		const tmpCX = tmpV.x + (tmpV.w / 2);
		const tmpCY = tmpV.y + (tmpV.h / 2);
		tmpV.w *= pFactor;
		tmpV.h *= pFactor;
		tmpV.x = tmpCX - (tmpV.w / 2);
		tmpV.y = tmpCY - (tmpV.h / 2);
		this._applyView();
	}

	_wireSvg(pSvg)
	{
		pSvg.addEventListener('click', (pEvent) => this._onClick(pEvent));
		pSvg.addEventListener('wheel', (pEvent) => { pEvent.preventDefault(); this._onWheel(pEvent); }, { passive: false });
		pSvg.addEventListener('pointerdown', (pEvent) => this._onPointerDown(pEvent));
	}

	_onClick(pEvent)
	{
		// A drag-pan ends in a click; ignore it so panning doesn't open panels.
		if (this._didPan) { this._didPan = false; return; }
		const tmpGroup = pEvent.target && pEvent.target.closest ? pEvent.target.closest('.node, .edge') : null;
		if (!tmpGroup) { return; }
		const tmpId = tmpGroup.getAttribute('id');
		if (!tmpId) { return; }
		if (this._nodeMap[tmpId] && typeof this.callbacks.onNodeClick === 'function')
		{
			this.callbacks.onNodeClick(this._nodeMap[tmpId]);
		}
		else if (this._edgeMap[tmpId] && typeof this.callbacks.onEdgeClick === 'function')
		{
			this.callbacks.onEdgeClick(this._edgeMap[tmpId]);
		}
	}

	/** Client pixel → SVG-coordinate point, using the current viewBox. */
	_toSvg(pClientX, pClientY)
	{
		const tmpRect = this._svg.getBoundingClientRect();
		const tmpV = this._view;
		return {
			x: tmpV.x + (((pClientX - tmpRect.left) / tmpRect.width) * tmpV.w),
			y: tmpV.y + (((pClientY - tmpRect.top) / tmpRect.height) * tmpV.h),
		};
	}

	_onWheel(pEvent)
	{
		if (!this._svg || !this._view) { return; }
		const tmpFactor = (pEvent.deltaY < 0) ? 0.85 : (1 / 0.85);
		const tmpPoint = this._toSvg(pEvent.clientX, pEvent.clientY);
		const tmpV = this._view;
		// Keep the point under the cursor fixed while scaling.
		tmpV.x = tmpPoint.x - ((tmpPoint.x - tmpV.x) * tmpFactor);
		tmpV.y = tmpPoint.y - ((tmpPoint.y - tmpV.y) * tmpFactor);
		tmpV.w *= tmpFactor;
		tmpV.h *= tmpFactor;
		this._applyView();
	}

	_onPointerDown(pEvent)
	{
		if (pEvent.button !== 0 || !this._view) { return; }
		this._panning = true;
		this._didPan = false;
		this._panStart = { X: pEvent.clientX, Y: pEvent.clientY, VX: this._view.x, VY: this._view.y };
		if (this._svg) { this._svg.style.cursor = 'grabbing'; }
	}

	_onPointerMove(pEvent)
	{
		if (!this._panning || !this._svg || !this._view) { return; }
		const tmpMoveX = pEvent.clientX - this._panStart.X;
		const tmpMoveY = pEvent.clientY - this._panStart.Y;
		// Until the pointer has travelled past DRAG_THRESHOLD this is still a (jittery) click, not a pan:
		// don't move the view and don't set _didPan, so _onClick still opens the node/edge panel.
		if (!this._didPan && (((tmpMoveX * tmpMoveX) + (tmpMoveY * tmpMoveY)) <= (DRAG_THRESHOLD * DRAG_THRESHOLD))) { return; }
		this._didPan = true;
		const tmpRect = this._svg.getBoundingClientRect();
		this._view.x = this._panStart.VX - ((tmpMoveX / tmpRect.width) * this._view.w);
		this._view.y = this._panStart.VY - ((tmpMoveY / tmpRect.height) * this._view.h);
		this._applyView();
	}

	_onPointerUp()
	{
		this._panning = false;
		if (this._svg) { this._svg.style.cursor = 'grab'; }
	}

	/** Outline the node for a given business Status (used by the steps rail). */
	highlightStatus(pStatus)
	{
		const tmpId = Object.keys(this._nodeMap).find((pKey) => this._nodeMap[pKey] === pStatus);
		this.highlight('node', tmpId || null);
	}

	/** Highlight a node/edge by id (adds a class graphviz elements can be styled by). */
	highlight(pKind, pRefMatch)
	{
		if (!this._svg) { return; }
		this._svg.querySelectorAll('.apw-selected').forEach((pEl) => pEl.classList.remove('apw-selected'));
		if (!pRefMatch) { return; }
		// pRefMatch is an id (s#/e#).
		const tmpEl = this._svg.querySelector(`#${pRefMatch}`);
		if (tmpEl) { tmpEl.classList.add('apw-selected'); }
	}

	destroy()
	{
		if (typeof window !== 'undefined')
		{
			window.removeEventListener('pointermove', this._boundMove);
			window.removeEventListener('pointerup', this._boundUp);
		}
	}
}

module.exports = ApprovalGraphRenderer;

},{"./ApprovalWorkflow-Dot.js":1065,"@hpcc-js/wasm/dist/graphviz.cjs":836}],1067:[function(require,module,exports){
/**
 * ApprovalWorkflow-Help — inline contextual help for the approval-workflow UI.
 *
 * Renders a small (i) icon (via the `apw-help` span written directly in the view templates) that, when
 * clicked, pops an anchored explanation of what a control/section does and how to use it. A single popover
 * element is managed on document.body so it works from any view (editor, list, bindings) and dismisses on
 * outside-click / Escape.
 *
 * Inline template handlers reach this through the `window.ApprovalWorkflowHelp` global (set on load) —
 * unusual for a pict module, but this is a cross-view UI utility, not a view, so routing through a single
 * `_Pict.views.X` would be arbitrary. Templates call: ApprovalWorkflowHelp.show('<topicId>', this).
 */

// Topic content. Body is trusted HTML (authored here, never user input).
const HELP =
{
	'list.overview':
	{
		Title: 'Approval workflows',
		Body: '<p>An <b>approval workflow</b> governs how a document (or observation) moves between statuses — for example <i>Draft → Submitted → Approved</i>.</p>'
			+ '<p>Each workflow is a set of <b>states</b> (statuses) connected by <b>transitions</b> (the actions people take to move between them). Open one to see it as a diagram, or bind workflows to document types with <b>Document bindings</b>.</p>',
	},
	'editor.graph':
	{
		Title: 'Reading the diagram',
		Body: '<p>Each <b>box</b> is a state; its coloured header shows the status, and the body shows its display name. Each <b>arrow</b> is a transition — the label is the action, and the arrow is coloured to match the state it leads to.</p>'
			+ '<p><b>Click an arrow</b> to read who can perform it and what it does. <b>Drag the background</b> to pan and <b>scroll</b> to zoom; the toolbar has zoom and fit controls.</p>',
	},
	'editor.edit':
	{
		Title: 'Editing a workflow',
		Body: '<p><b>Edit</b> lets a customer admin change this workflow. Click a state or transition to edit it in the side panel, or use <b>Add state</b>.</p>'
			+ '<p>In a panel, <b>Apply to diagram</b> puts your edits onto the diagram so you can see them — but nothing is stored yet. Moving to another panel or pressing <b>Save</b> applies them for you.</p>'
			+ '<p>Changes are held until you press <b>Save</b> — <b>Discard</b> reverts everything to the last saved version. Saving writes back the shared configuration this and the field apps read. Settings this screen has no controls for, such as branches, triggers and actor tags, are kept as they are.</p>',
	},
	'transition.action':
	{
		Title: 'Action',
		Body: '<p>The verb a person performs to make this transition — for example <i>Submit</i>, <i>Approve</i>, or <i>Reject</i>. It appears as the label on the arrow.</p>',
	},
	'transition.target':
	{
		Title: 'Goes to state',
		Body: '<p>The state the entity moves into when this action is taken. Only existing states appear here — add the state first if you need a new destination.</p>',
	},
	'transition.flags':
	{
		Title: 'Transition options',
		Body: '<ul><li><b>Locks / Unlocks entity</b> — whether the document becomes locked (read-only) or unlocked after this action. An action can lock or unlock, not both.</li>'
			+ '<li><b>Is an approval</b> — marks this as a formal approval step (used for approval tracking and permissions).</li>'
			+ '<li><b>Allowed on locked</b> — lets this action run even while the entity is locked.</li></ul>',
	},
	'transition.actors':
	{
		Title: 'Who can perform this action',
		Body: '<p>The people allowed to take this transition. Add any mix of:</p>'
			+ '<ul><li><b>Roles</b> — anyone with a given role (optionally only project members, or the lab from the form).</li>'
			+ '<li><b>A specific user</b>.</li>'
			+ '<li><b>Special groups</b> — Administrators, the user who created the entity, higher-level users, or a minimum project level.</li></ul>'
			+ '<p>If no one is assigned, the action can’t be performed.</p>',
	},
	'state.name':
	{
		Title: 'Display name',
		Body: '<p>The human-readable name shown on the state box and in the generated sentences (e.g. “Waiting for Project Engineer Approval”).</p>',
	},
	'state.status':
	{
		Title: 'State hash (identity)',
		Body: '<p>The state’s internal identity — the value transitions reference as their destination. Renaming it automatically updates every transition that points at this state, so links aren’t broken.</p>',
	},
	'state.transitions':
	{
		Title: 'Transitions out of this state',
		Body: '<p>The actions that lead <b>out</b> of this state. Click one to edit its action, destination, options, and who can perform it, or use <b>Add transition</b> to create a new one.</p>',
	},
	'bindings.overview':
	{
		Title: 'Document bindings',
		Body: '<p>Bindings decide <b>which approval workflow governs each document type</b>. Pick a workflow for a document type and press <b>Save</b>.</p>'
			+ '<p>A document type with no binding of its own uses the <b>Default</b>.</p>'
			+ '<p>Bindings apply at two levels — the <b>customer default</b> that every project inherits, and per-<b>project</b> overrides. Use the <b>Scope</b> switch to choose which you are editing.</p>',
	},
	'bindings.scope':
	{
		Title: 'Binding scope',
		Body: '<p><b>Customer default</b> is the organization-wide set of bindings. Every project inherits it unless it sets its own.</p>'
			+ '<p><b>Specific project</b> lets one project <b>override</b> individual bindings — the rest still fall back to the customer default. Pick a project to view or edit its overrides; a project marked <i>customized</i> already has some.</p>'
			+ '<p>Saving a project writes only the rows that differ from the customer default, so the two stay in sync except where you deliberately diverge.</p>',
	},
	'bindings.dots':
	{
		Title: 'The status dots',
		Body: '<ul><li><b>Green dot</b> — this type <b>is governed</b> by an approval workflow (the one shown in the dropdown).</li>'
			+ '<li><b>Hollow dot</b> — this type is <b>not governed</b>; documents of this type skip approvals.</li>'
			+ '<li><b>Blue-ringed dot</b> (project scope only) — this project <b>overrides the customer default</b> for this type. Rows without the ring inherit the default.</li></ul>'
			+ '<p>Hover any dot for its exact meaning.</p>',
	},
	'bindings.default':
	{
		Title: 'Default binding',
		Body: '<p>The fallback workflow applied to any document type that doesn’t have its own binding set below.</p>',
	},
};

let _popover = null;

function _ensureCSS()
{
	if (typeof document === 'undefined' || document.getElementById('apw-help-css')) { return; }
	const tmpStyle = document.createElement('style');
	tmpStyle.id = 'apw-help-css';
	tmpStyle.textContent = /*css*/`
		.apw-help { display: inline-flex; align-items: center; justify-content: center; cursor: pointer; color: var(--bulma-text-weak, #9aa4b2);
			font-size: 0.82em; margin-left: 0.3em; vertical-align: middle; transition: color 0.12s; }
		.apw-help:hover { color: var(--bulma-link, #156dd1); }
		.apw-help-pop { position: fixed; z-index: 9999; background: var(--bulma-scheme-main, #fff); border: 1px solid var(--bulma-border, #d6dbe4);
			border-radius: 10px; box-shadow: 0 8px 30px rgba(20,40,80,0.20); overflow: hidden; font-size: 0.86rem; color: #2c3e50; }
		.apw-help-pop-head { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; padding: 0.5rem 0.75rem;
			background: var(--bulma-scheme-main-bis, #f4f6fa); border-bottom: 1px solid var(--bulma-border, #e6e9ef); font-weight: 700; }
		.apw-help-pop-close { border: none; background: transparent; cursor: pointer; font-size: 1.1rem; line-height: 1; color: var(--bulma-text-weak, #8a93a3); }
		.apw-help-pop-close:hover { color: #2c3e50; }
		.apw-help-pop-body { padding: 0.7rem 0.8rem; line-height: 1.5; }
		.apw-help-pop-body p { margin: 0 0 0.5rem; } .apw-help-pop-body p:last-child { margin-bottom: 0; }
		.apw-help-pop-body ul { margin: 0.25rem 0 0.5rem; padding-left: 1.1rem; } .apw-help-pop-body li { margin-bottom: 0.25rem; }
	`;
	document.head.appendChild(tmpStyle);
}

function _onDocDown(pEvent)
{
	if (_popover && !_popover.contains(pEvent.target)) { hide(); }
}

function _onKey(pEvent)
{
	if (pEvent.key === 'Escape') { hide(); }
}

/** Show the help popover for a topic, anchored under the clicked icon. */
function show(pTopicId, pAnchorEl)
{
	const tmpTopic = HELP[pTopicId];
	if (!tmpTopic || typeof document === 'undefined') { return; }
	hide();
	_ensureCSS();
	const tmpPop = document.createElement('div');
	tmpPop.className = 'apw-help-pop';
	tmpPop.innerHTML = `<div class="apw-help-pop-head"><span>${tmpTopic.Title}</span>`
		+ `<button class="apw-help-pop-close" aria-label="Close" onclick="ApprovalWorkflowHelp.hide()">&times;</button></div>`
		+ `<div class="apw-help-pop-body">${tmpTopic.Body}</div>`;
	document.body.appendChild(tmpPop);
	_popover = tmpPop;

	// Position under the icon, kept inside the viewport.
	const tmpWidth = 320;
	tmpPop.style.width = `${tmpWidth}px`;
	const tmpRect = pAnchorEl.getBoundingClientRect();
	let tmpLeft = tmpRect.left;
	if (tmpLeft + tmpWidth > window.innerWidth - 8) { tmpLeft = window.innerWidth - tmpWidth - 8; }
	if (tmpLeft < 8) { tmpLeft = 8; }
	let tmpTop = tmpRect.bottom + 6;
	// If it would run off the bottom, flip above the icon.
	if (tmpTop + tmpPop.offsetHeight > window.innerHeight - 8)
	{
		tmpTop = Math.max(8, tmpRect.top - tmpPop.offsetHeight - 6);
	}
	tmpPop.style.left = `${tmpLeft}px`;
	tmpPop.style.top = `${tmpTop}px`;

	// Dismiss on outside click / Escape (added on the next tick so this very click doesn't close it).
	setTimeout(() =>
	{
		document.addEventListener('mousedown', _onDocDown, true);
		document.addEventListener('keydown', _onKey, true);
	}, 0);
}

function hide()
{
	if (_popover)
	{
		_popover.remove();
		_popover = null;
		document.removeEventListener('mousedown', _onDocDown, true);
		document.removeEventListener('keydown', _onKey, true);
	}
}

/** The (i) icon markup for a topic (for use inside view templates). */
function icon(pTopicId)
{
	return `<span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('${pTopicId}', this)"><i class="fas fa-circle-info"></i></span>`;
}

const _module = { HELP, show, hide, icon };

// Expose for inline template onclick handlers.
if (typeof window !== 'undefined')
{
	window.ApprovalWorkflowHelp = _module;
}

module.exports = _module;

},{}],1068:[function(require,module,exports){
/**
 * ApprovalWorkflow-Model — the pure data layer for the config-app approval-workflow editor.
 *
 * There are no pict / DOM / REST dependencies here on purpose: everything is a pure transform over the
 * Configuration-blob shape the editor reads and writes, so it is unit-testable in isolation and reused
 * verbatim by the provider (persistence) and the editor view (rendering).
 *
 * The blob shape (NamespaceKey 'ApprovalWorkflow', one per document/observation type) is documented in
 * api/approvals/docs/WorkflowConfig.md. The editor only understands part of it, so the working model IS the
 * stored blob: every field it has no control for (Branches, Triggers, Criteria, BackPropagateTo, actor Tags, ...)
 * round-trips untouched, and every edit changes only the fields it names.
 *
 * A `Status` is a state's identity; `ToStatus` on a transition references some state's `Status`.
 */

const libRules = require('@paviasystems/approval-workflow-rules');

// The boolean transition flags the editor has checkboxes for. Absent means false to the approvals engine, so a flag
// is only written when its meaning changes; an explicit false in the stored blob stays until someone turns it on.
const TOGGLE_FLAGS = [ 'LockEntity', 'UnlockEntity', 'IsApproval', 'AllowOnLocked' ];
const COMMON_ACTOR_TAGS = [ 'Primary', 'Secondary', 'Backup', 'Override' ];

// The seed for a brand-new workflow: Draft → Submitted → { Rejected, Approved }, Rejected → Draft. Submit locks the
// document, so the actions out of Submitted need AllowOnLocked or the engine refuses them.
const NEW_DEFAULT_WORKFLOW_CONFIG =
{
	States:
	[
		{
			Status: 'Draft', StateName: 'Draft',
			Transitions:
			[
				{ Action: 'Submit', ToStatus: 'Submitted', Actors: [ 'CreatingUser' ], LockEntity: true },
			],
		},
		{
			Status: 'Submitted', StateName: 'Submitted',
			Transitions:
			[
				{ Action: 'Approve', ToStatus: 'Approved', Actors: [ 'Admin' ], IsApproval: true, AllowOnLocked: true },
				{ Action: 'Reject', ToStatus: 'Rejected', Actors: [ 'Admin' ], UnlockEntity: true, AllowOnLocked: true },
			],
		},
		{
			Status: 'Rejected', StateName: 'Rejected',
			Transitions:
			[
				{ Action: 'Revise', ToStatus: 'Draft', Actors: [ 'CreatingUser' ], UnlockEntity: true },
			],
		},
		{
			Status: 'Approved', StateName: 'Approved',
			Transitions: [],
		},
	],
};


// --- State coloring (Home's computeColor, verbatim thresholds) ---------------------------------------

/**
 * The fill color for a state node, keyed off substrings of its Status (Home computeColor).
 * @param {String} pStatus
 * @return {String} hex color
 */
function stateColor(pStatus)
{
	const tmpStatus = String(pStatus || '').toLowerCase();
	if (tmpStatus.includes('appr') || tmpStatus.includes('review'))
	{
		return '#449606';
	}
	if (tmpStatus.includes('submit') || tmpStatus.includes('pend'))
	{
		return '#2196F3';
	}
	if (tmpStatus.includes('reject'))
	{
		return '#D84028';
	}
	return '#6F727A';
}

/**
 * A light tint of a state's color, used as the state node's body fill so states are visibly color-coded
 * (not just a title chip). Keyed off the same computeColor buckets.
 */
function stateTint(pStatus)
{
	switch (stateColor(pStatus))
	{
		case '#449606': return '#eef7e6'; // approved / review — green
		case '#2196F3': return '#e6f2fd'; // submitted / pending — blue
		case '#D84028': return '#fbeae6'; // rejected — red
		default: return '#eef0f2';        // other — grey
	}
}

// --- Blob load / save / edit --------------------------------------------------------------------------

/**
 * The working model for a freshly-read blob: a deep copy, with States guaranteed to be an array.
 * @param {Object} pBlob
 * @return {Object}
 */
function normalizeLoadedBlob(pBlob)
{
	const tmpWorkflow = JSON.parse(JSON.stringify(pBlob || {}));
	if (!Array.isArray(tmpWorkflow.States))
	{
		tmpWorkflow.States = [];
	}
	return tmpWorkflow;
}

/**
 * The body to persist for a working model: a deep copy, so nothing later mutates what was sent.
 * @param {Object} pWorkflow
 * @return {Object}
 */
function prepareBlobForSave(pWorkflow)
{
	return normalizeLoadedBlob(pWorkflow);
}

/**
 * Apply the transition panel's values, touching only what actually changed. Lock and Unlock are exclusive when one
 * is newly turned on.
 * @param {Object} pTransition - Mutated.
 * @param {{ Action?: String, ToStatus?: String, LockEntity?: Boolean, UnlockEntity?: Boolean, IsApproval?: Boolean, AllowOnLocked?: Boolean }} pPatch
 * @return {Boolean} true if anything changed
 */
function applyTransitionPatch(pTransition, pPatch)
{
	let tmpChanged = false;
	[ 'Action', 'ToStatus' ].forEach((pField) =>
	{
		if ((pPatch[pField] !== undefined) && (String(pTransition[pField] == null ? '' : pTransition[pField]) !== pPatch[pField]))
		{
			pTransition[pField] = pPatch[pField];
			tmpChanged = true;
		}
	});
	const tmpNewlyOn = {};
	TOGGLE_FLAGS.forEach((pFlag) =>
	{
		if ((pPatch[pFlag] !== undefined) && (!!pPatch[pFlag] !== !!pTransition[pFlag]))
		{
			if (pPatch[pFlag])
			{
				pTransition[pFlag] = true;
				tmpNewlyOn[pFlag] = true;
			}
			else
			{
				delete pTransition[pFlag];
			}
			tmpChanged = true;
		}
	});
	if (tmpNewlyOn.LockEntity)
	{
		delete pTransition.UnlockEntity;
	}
	if (tmpNewlyOn.UnlockEntity)
	{
		delete pTransition.LockEntity;
	}
	return tmpChanged;
}

/**
 * Call a function on a transition and on every branch under it, at any depth.
 * @param {Object} pEdge
 * @param {(pEdge: Object) => void} fVisit
 */
function _visitEdgeTree(pEdge, fVisit)
{
	fVisit(pEdge);
	if (Array.isArray(pEdge.Branches))
	{
		pEdge.Branches.forEach((pBranch) => _visitEdgeTree(pBranch, fVisit));
	}
}

/**
 * Renaming a State's Status rewrites everything that references it: ToStatus on every transition and nested branch,
 * and BackPropagateTo. Mutates + returns the workflow.
 * @param {Object} pWorkflow
 * @param {String} pOldStatus
 * @param {String} pNewStatus
 */
function renameStatusCascade(pWorkflow, pOldStatus, pNewStatus)
{
	if (pOldStatus === pNewStatus)
	{
		return pWorkflow;
	}
	for (const tmpState of (pWorkflow.States || []))
	{
		for (const tmpTransition of (tmpState.Transitions || []))
		{
			_visitEdgeTree(tmpTransition, (pEdge) =>
			{
				if (pEdge.ToStatus === pOldStatus)
				{
					pEdge.ToStatus = pNewStatus;
				}
				if (Array.isArray(pEdge.BackPropagateTo))
				{
					pEdge.BackPropagateTo = pEdge.BackPropagateTo.map((pStatus) => ((pStatus === pOldStatus) ? pNewStatus : pStatus));
				}
			});
		}
	}
	return pWorkflow;
}

/**
 * Remove a state and everything that references it: transitions and branches (at any depth) that go to it, and its
 * entries in BackPropagateTo. Mutates + returns the workflow.
 * @param {Object} pWorkflow
 * @param {String} pStatus
 */
function removeStateCascade(pWorkflow, pStatus)
{
	const tmpPruneBranches = (pEdge) =>
	{
		if (Array.isArray(pEdge.Branches))
		{
			pEdge.Branches = pEdge.Branches.filter((pBranch) => pBranch.ToStatus !== pStatus);
			pEdge.Branches.forEach(tmpPruneBranches);
		}
		if (Array.isArray(pEdge.BackPropagateTo))
		{
			pEdge.BackPropagateTo = pEdge.BackPropagateTo.filter((pTarget) => pTarget !== pStatus);
		}
	};
	pWorkflow.States = (pWorkflow.States || []).filter((pState) => pState.Status !== pStatus);
	pWorkflow.States.forEach((pState) =>
	{
		if (Array.isArray(pState.Transitions))
		{
			pState.Transitions = pState.Transitions.filter((pTransition) => pTransition.ToStatus !== pStatus);
			pState.Transitions.forEach(tmpPruneBranches);
		}
	});
	return pWorkflow;
}

/**
 * Why a working model must not be written.
 * @param {Object} pWorkflow
 * @return {Array<String>} empty when it can be saved
 */
function findSaveProblems(pWorkflow)
{
	return libRules.checkWorkflow(pWorkflow).filter((pFinding) => pFinding.Severity === 'error').map((pFinding) => pFinding.Message);
}

/**
 * The states in DIAGRAM order — the top-to-bottom flow the graphviz layout reads — as an array of indices
 * into pWorkflow.States. States are layered by shortest distance from a start state (one nothing transitions
 * into); a fully-cyclic or disconnected component is seeded from its lowest-index state, and ties within a
 * layer keep the existing array position. Pure; the editor's steps rail uses this so the list reads in the
 * same order as the diagram instead of the arbitrary stored order.
 * @param {Object} pWorkflow
 * @return {Array<Number>} original state indices, in diagram order
 */
function flowOrder(pWorkflow)
{
	const tmpStates = (pWorkflow && Array.isArray(pWorkflow.States)) ? pWorkflow.States : [];
	if (!tmpStates.length)
	{
		return [];
	}
	const tmpIndexByStatus = {};
	tmpStates.forEach((pState, pIndex) => { tmpIndexByStatus[pState.Status] = pIndex; });
	// Distinct outgoing targets (transitions + flattened branches), first-seen order, as state indices.
	const tmpTargets = tmpStates.map((pState) =>
	{
		const tmpSeen = {};
		const tmpOut = [];
		const tmpConsider = (pToStatus) =>
		{
			if (tmpIndexByStatus.hasOwnProperty(pToStatus) && !tmpSeen[pToStatus])
			{
				tmpSeen[pToStatus] = true;
				tmpOut.push(tmpIndexByStatus[pToStatus]);
			}
		};
		(pState.Transitions || []).forEach((pTransition) =>
		{
			tmpConsider(pTransition.ToStatus);
			_collectBranchEdges(pTransition.Branches, []).forEach((pBranchEdge) => tmpConsider(pBranchEdge.ToStatus));
		});
		return tmpOut;
	});
	const tmpInDegree = tmpStates.map(() => 0);
	tmpTargets.forEach((pOut) => pOut.forEach((pTargetIndex) => { tmpInDegree[pTargetIndex]++; }));
	const tmpRank = tmpStates.map(() => -1);
	const tmpQueue = [];
	let tmpHead = 0;
	const tmpDrain = () =>
	{
		while (tmpHead < tmpQueue.length)
		{
			const tmpIndex = tmpQueue[tmpHead++];
			tmpTargets[tmpIndex].forEach((pTargetIndex) =>
			{
				if (tmpRank[pTargetIndex] < 0)
				{
					tmpRank[pTargetIndex] = tmpRank[tmpIndex] + 1;
					tmpQueue.push(pTargetIndex);
				}
			});
		}
	};
	// BFS from every start state (in-degree 0)…
	tmpStates.forEach((pState, pIndex) => { if (tmpInDegree[pIndex] === 0) { tmpRank[pIndex] = 0; tmpQueue.push(pIndex); } });
	tmpDrain();
	// …then seed any leftover (fully-cyclic / disconnected) component from its lowest-index state.
	for (let tmpI = 0; tmpI < tmpStates.length; tmpI++)
	{
		if (tmpRank[tmpI] < 0) { tmpRank[tmpI] = 0; tmpQueue.push(tmpI); tmpDrain(); }
	}
	return tmpStates.map((pState, pIndex) => pIndex).sort((pA, pB) => (tmpRank[pA] - tmpRank[pB]) || (pA - pB));
}

// --- Sentence generation (ActorSpec.computeActors + the transition template, verbatim) ---------------

/**
 * Collect the role PermissionLevels and user IDs referenced by every actor across the workflow, so the
 * provider can pre-resolve their display names in ONE pass before the (synchronous) node bodies render.
 * @param {Object} pWorkflow
 * @return {{ RoleLevels: Array<String>, UserIDs: Array<String> }}
 */
function collectActorReferences(pWorkflow)
{
	const tmpRoleLevels = new Set();
	const tmpUserIDs = new Set();
	for (const tmpState of (pWorkflow.States || []))
	{
		for (const tmpTransition of (tmpState.Transitions || []))
		{
			for (const tmpActor of (tmpTransition.Actors || []))
			{
				const tmpSpec = _readActorSpec(tmpActor);
				if (tmpSpec.Type === 'Users')
				{
					tmpSpec.Settings.forEach((pID) => tmpUserIDs.add(String(pID)));
				}
				else if (ROLE_ACTOR_TYPES.includes(tmpSpec.Type))
				{
					tmpSpec.Settings.forEach((pLevel) => tmpRoleLevels.add(String(pLevel)));
				}
				else if (!KEYWORD_ACTOR_TYPES.includes(tmpSpec.Type))
				{
					// Legacy "bare permission-level" actor (the default branch) — the type IS the level.
					if (tmpSpec.Type)
					{
						tmpRoleLevels.add(String(tmpSpec.Type));
					}
				}
			}
		}
	}
	return { RoleLevels: Array.from(tmpRoleLevels), UserIDs: Array.from(tmpUserIDs) };
}

const ROLE_ACTOR_TYPES = libRules.ROLE_ACTOR_TYPES;
const KEYWORD_ACTOR_TYPES = libRules.KEYWORD_ACTOR_TYPES;
const _readActorSpec = libRules.readActorSpec;

/**
 * One row per person-selector in a transition's actor list, so an editor can show and remove one role or user at a
 * time while the stored actors keep their shape, order and tags.
 * @param {Array<any>} pActors
 * @param {Object} pNames
 * @return {Array<{ ActorIndex: Number, SettingIndex: Number, Label: String, Tags: Array<String> }>} SettingIndex -1 means the whole actor
 */
function actorRows(pActors, pNames)
{
	const tmpRows = [];
	(Array.isArray(pActors) ? pActors : []).forEach((pActor, pActorIndex) =>
	{
		const tmpSpec = _readActorSpec(pActor);
		if (tmpSpec.Settings.length < 2)
		{
			tmpRows.push({ ActorIndex: pActorIndex, SettingIndex: -1, Label: actorFragment(pActor, pNames), Tags: tmpSpec.Tags });
			return;
		}
		tmpSpec.Settings.forEach((pSetting, pSettingIndex) =>
		{
			tmpRows.push({ ActorIndex: pActorIndex, SettingIndex: pSettingIndex, Label: actorFragment({ Type: tmpSpec.Type, Hashes: [ pSetting ], Tags: tmpSpec.Tags }, pNames), Tags: tmpSpec.Tags });
		});
	});
	return tmpRows;
}

/**
 * Remove one row (see actorRows) from an actor list. Other settings on the actor stay in its own form; an actor left
 * with no settings is removed. Mutates pActors.
 * @param {Array<any>} pActors
 * @param {Number} pActorIndex
 * @param {Number} pSettingIndex - -1 removes the whole actor.
 */
function removeActorRow(pActors, pActorIndex, pSettingIndex)
{
	const tmpActor = pActors[pActorIndex];
	if (tmpActor === undefined)
	{
		return;
	}
	const tmpSpec = _readActorSpec(tmpActor);
	if ((pSettingIndex < 0) || (tmpSpec.Settings.length < 2))
	{
		pActors.splice(pActorIndex, 1);
		return;
	}
	const tmpRemaining = tmpSpec.Settings.filter((pSetting, pIndex) => pIndex !== pSettingIndex);
	if (typeof tmpActor === 'string')
	{
		pActors[pActorIndex] = `${tmpSpec.Type}:${tmpRemaining.join(',')}`;
	}
	else if (tmpSpec.Field === 'Settings')
	{
		tmpActor.Settings = tmpRemaining.join(',');
	}
	else
	{
		tmpActor[tmpSpec.Field] = tmpRemaining;
	}
}

/**
 * Set the tags of one row (see actorRows). A row that shares its actor with other roles or users moves to an actor of
 * its own, right after, so the others keep their tags. A string actor with tags becomes an object. Mutates pActors.
 * @param {Array<any>} pActors
 * @param {Number} pActorIndex
 * @param {Number} pSettingIndex - -1 means the whole actor.
 * @param {Array<String>} pTags
 * @return {Boolean} true if anything changed
 */
function setActorRowTags(pActors, pActorIndex, pSettingIndex, pTags)
{
	const tmpActor = pActors[pActorIndex];
	if (tmpActor === undefined)
	{
		return false;
	}
	const tmpTags = Array.from(new Set((pTags || []).map((pTag) => String(pTag).trim()).filter(Boolean)));
	const tmpSpec = _readActorSpec(tmpActor);
	if ((tmpSpec.Tags.length === tmpTags.length) && tmpTags.every((pTag) => tmpSpec.Tags.includes(pTag)))
	{
		return false;
	}
	if ((pSettingIndex >= 0) && (tmpSpec.Settings.length > 1))
	{
		const tmpSetting = tmpSpec.Settings[pSettingIndex];
		const tmpField = ((tmpSpec.Field === 'IDs') || (tmpSpec.Field === 'Values')) ? tmpSpec.Field : 'Hashes';
		removeActorRow(pActors, pActorIndex, pSettingIndex);
		pActors.splice(pActorIndex + 1, 0, { Type: tmpSpec.Type, [tmpField]: [ tmpSetting ], Tags: tmpTags });
		return true;
	}
	if (typeof tmpActor === 'string')
	{
		pActors[pActorIndex] = tmpSpec.Settings.length ? { Type: tmpSpec.Type, Hashes: tmpSpec.Settings, Tags: tmpTags } : { Type: tmpSpec.Type, Tags: tmpTags };
		return true;
	}
	tmpActor.Tags = tmpTags;
	return true;
}

/**
 * The tags to suggest: the usual ones, then any others this workflow uses.
 * @param {Object} pWorkflow
 * @return {Array<String>}
 */
function actorTagOptions(pWorkflow)
{
	const tmpTags = new Set(COMMON_ACTOR_TAGS);
	for (const tmpState of ((pWorkflow && pWorkflow.States) || []))
	{
		for (const tmpTransition of (tmpState.Transitions || []))
		{
			(Array.isArray(tmpTransition.Actors) ? tmpTransition.Actors : []).forEach((pActor) => _readActorSpec(pActor).Tags.forEach((pTag) => tmpTags.add(pTag)));
		}
	}
	return Array.from(tmpTags);
}

/**
 * Read a comma-separated tag list. A tag that differs from a known one only by case takes the known spelling, because
 * the services match tags exactly.
 * @param {String} pText
 * @param {Array<String>} pKnown
 * @return {Array<String>}
 */
function parseActorTags(pText, pKnown)
{
	return Array.from(new Set(String(pText || '').split(',').map((pTag) => pTag.trim()).filter(Boolean).map((pTag) =>
	{
		return (pKnown || []).find((pOption) => pOption.toLowerCase() === pTag.toLowerCase()) || pTag;
	})));
}

/**
 * Add an actor. A new role/user joins an existing untagged actor of the same Type rather than repeating it; an exact
 * repeat is ignored. Mutates pActors.
 * @param {Array<any>} pActors
 * @param {any} pActor - An object for role/user actors, a string for keyword/level actors.
 */
function addActorSpec(pActors, pActor)
{
	if (typeof pActor === 'string')
	{
		if (!pActors.includes(pActor))
		{
			pActors.push(pActor);
		}
		return;
	}
	const tmpExisting = pActors.find((pOther) => pOther && (typeof pOther === 'object') && (pOther.Type === pActor.Type) && Array.isArray(pOther.Hashes) && !(pOther.Tags && pOther.Tags.length));
	if (!tmpExisting || (pActor.Tags && pActor.Tags.length))
	{
		pActors.push(pActor);
		return;
	}
	pActor.Hashes.forEach((pHash) =>
	{
		if (!tmpExisting.Hashes.includes(pHash))
		{
			tmpExisting.Hashes.push(pHash);
		}
	});
}

/**
 * The human-readable fragment for a single actor. `pNames` pre-resolves display strings:
 *   { RoleNameByLevel: { '<level>': 'Role Name' }, UserNameByID: { '<id>': 'First Last' } }
 * Mirrors ActorSpec.computeActors' switch (including the trailing " [tag1,tag2]").
 * @return {String}
 */
function actorFragment(pActor, pNames)
{
	const tmpNames = pNames || {};
	const tmpRoleNames = tmpNames.RoleNameByLevel || {};
	const tmpUserNames = tmpNames.UserNameByID || {};
	const tmpSpec = _readActorSpec(pActor);
	// A code with no matching role still shows, so an actor that matches nobody is visible rather than blank.
	const tmpResolveRoles = (pLevels) => (pLevels || []).map((pLevel) => tmpRoleNames[String(pLevel)] || String(pLevel));

	let tmpFragment;
	switch (tmpSpec.Type)
	{
		case 'HigherUserLevelInProject':
			tmpFragment = 'Users in the project who are higher level than the creating user';
			break;
		case 'MinimumUserLevelInProject':
			tmpFragment = 'Users in the same project who are at least level ' + parseInt(tmpSpec.Settings[0], 10);
			break;
		case 'Admin':
			tmpFragment = 'Administrators';
			break;
		case 'CreatingUser':
			tmpFragment = 'User who created the entity to be approved';
			break;
		case 'UserRole':
			tmpFragment = 'Users with a role in ' + tmpResolveRoles(tmpSpec.Settings).join(', ');
			break;
		case 'UserRoleProjectMembership':
			tmpFragment = 'Users with a role in ' + tmpResolveRoles(tmpSpec.Settings).join(', ') + ' who are also members of the project';
			break;
		case 'FormLabRole':
			tmpFragment = 'Users in the selected lab (from the form) with a role in ' + tmpResolveRoles(tmpSpec.Settings).join(', ');
			break;
		case 'FormLabUser':
			tmpFragment = 'Users in the selected lab (from the form)';
			break;
		case 'FormMaterialLabInitialUser':
			tmpFragment = 'First-contact users for the lab and material on the form';
			break;
		case 'FormMaterialLabEscalationUser':
			tmpFragment = 'Escalation users for the lab and material on the form';
			break;
		case 'FormMaterialLabRole':
			tmpFragment = 'Users assigned to the lab and material on the form with a role in ' + tmpResolveRoles(tmpSpec.Settings).join(', ');
			break;
		case 'ProjectEntitlement':
			tmpFragment = 'Users with a project entitlement in ' + tmpResolveRoles(tmpSpec.Settings).join(', ');
			break;
		case 'ProjectRole':
		{
			const tmpRoles = tmpResolveRoles(tmpSpec.Settings);
			tmpFragment = tmpRoles.length ? ('Users with a project role in ' + tmpRoles.join(', ')) : 'Users with a nonexistent project role';
			break;
		}
		case 'Users':
		{
			const tmpUsers = (tmpSpec.Settings || []).map((pID) => tmpUserNames[String(pID)] || `Unknown user ${pID}`);
			if (!tmpUsers.length) { tmpFragment = 'Unknown User'; }
			else if (tmpUsers.length === 1) { tmpFragment = tmpUsers[0]; }
			else { tmpFragment = 'One of ' + tmpUsers.join(', '); }
			break;
		}
		default:
		{
			// Legacy bare-permission-level actor: the Type is itself a level to resolve.
			const tmpRoleName = tmpRoleNames[String(tmpSpec.Type)];
			if (tmpRoleName)
			{
				tmpFragment = 'Roles in ' + tmpRoleName;
			}
			else
			{
				tmpFragment = tmpSpec.Type || 'Unknown actor';
				if (tmpSpec.Settings && tmpSpec.Settings.length)
				{
					tmpFragment += ':' + tmpSpec.Settings.join(', ');
				}
			}
			break;
		}
	}
	if (tmpSpec.Tags && tmpSpec.Tags.length)
	{
		tmpFragment += ` [${tmpSpec.Tags.join(',')}]`;
	}
	return tmpFragment;
}

/**
 * The full actor clause: every actor fragment joined by " and " (Home renders them underlined, joined
 * with " and ").
 */
function actorsClause(pActors, pNames)
{
	const tmpActors = Array.isArray(pActors) ? pActors : [];
	if (!tmpActors.length)
	{
		return 'No one';
	}
	return tmpActors.map((pActor) => actorFragment(pActor, pNames)).join(' and ');
}

/**
 * Escape a string for safe interpolation into node-body HTML (sentences carry user-entered role names).
 */
function _escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/**
 * Format a scalar criteria value for display (booleans read naturally).
 */
function _formatCriteriaValue(pValue)
{
	if (typeof pValue === 'boolean')
	{
		return pValue ? 'true' : 'false';
	}
	return String(pValue);
}

/**
 * Human-readable text for ONE branch condition object. Handles the condition Types seen in real workflow
 * data (HasProjectSetting, FormDataMetadata, …) and falls back to a Key/Value or Type readout. This is a
 * deliberate improvement over Home, which renders the raw object as "[object Object]".
 */
function criteriaConditionText(pCondition)
{
	if (pCondition == null)
	{
		return '';
	}
	if (typeof pCondition === 'string')
	{
		return pCondition;
	}
	switch (pCondition.Type)
	{
		case 'HasProjectSetting':
			return `the project setting "${pCondition.SettingKey}" is ${pCondition.Not ? 'not ' : ''}set`;
		case 'FormDataMetadata':
			return (pCondition.Value !== undefined)
				? `${pCondition.Key} is ${_formatCriteriaValue(pCondition.Value)}`
				: `${pCondition.Key} is set`;
		case 'True':
			return 'always';
		case 'False':
			return 'never';
		case 'EntityOwner':
			return `${pCondition.UserID ? `user ${pCondition.UserID}` : 'the person acting'} ${pCondition.Not ? 'does not own' : 'owns'} the document`;
		case 'ChangeOrderThreshold':
		{
			const tmpParts = [];
			if (pCondition.MinDays !== undefined)
			{
				tmpParts.push(`the schedule changes by at least ${pCondition.MinDays} days`);
			}
			if (pCondition.MinAmount !== undefined)
			{
				tmpParts.push(`the cost changes by at least ${pCondition.MinAmount}`);
			}
			if (pCondition.PercentContractChange !== undefined)
			{
				tmpParts.push(`the contract changes by at least ${pCondition.PercentContractChange}%`);
			}
			return tmpParts.length ? tmpParts.join(' or ') : 'a change order threshold is reached';
		}
		case 'DocumentHasObsWithLabel':
			return pCondition.LabelValue ? `an observation on the document has the ${pCondition.LabelType} label "${pCondition.LabelValue}"` : `an observation on the document has a ${pCondition.LabelType} label`;
		case 'RecordNotFound':
			return `no record matches ${pCondition.QueryString}`;
		default:
		{
			const tmpKey = pCondition.Key || pCondition.SettingKey || pCondition.Type || 'a condition';
			return (pCondition.Value !== undefined) ? `${tmpKey} is ${_formatCriteriaValue(pCondition.Value)}` : String(tmpKey);
		}
	}
}

/**
 * Human-readable text for a branch's Criteria, which may be an array of condition objects (the engine takes the
 * branch when ANY matches, hence " or "), a single object, or a legacy string.
 */
function criteriaText(pCriteria)
{
	if (Array.isArray(pCriteria))
	{
		const tmpParts = pCriteria.map(criteriaConditionText).filter(Boolean);
		return tmpParts.length ? tmpParts.join(' or ') : 'a condition';
	}
	if (pCriteria && typeof pCriteria === 'object')
	{
		return criteriaConditionText(pCriteria);
	}
	if (typeof pCriteria === 'string' && pCriteria)
	{
		return pCriteria;
	}
	return 'a condition';
}

/**
 * Render the branch re-route lines for a transition, recursing into nested branch.Branches (indented).
 * @return {String} HTML
 */
function _branchLinesHTML(pBranches, pStateMap, pDepth)
{
	let tmpHTML = '';
	for (const tmpBranch of (pBranches || []))
	{
		const tmpTarget = pStateMap[tmpBranch.ToStatus] || tmpBranch.ToStatus || '(unset)';
		const tmpPrefix = pDepth > 0 ? '↳ ' : '';
		tmpHTML += `<br><span class="apw-branch">${tmpPrefix}If ${_escapeHTML(criteriaText(tmpBranch.Criteria))}, instead goes to ${_escapeHTML(tmpTarget)}.</span>`;
		tmpHTML += _branchLinesHTML(tmpBranch.Branches, pStateMap, pDepth + 1);
	}
	return tmpHTML;
}

/**
 * The full transition sentence (the transition node's body). Mirrors Home's transition <p>:
 *   "{Actors} can {Action} and go to {StateName-of-ToStatus}. This locks/unlocks the entity. This is an
 *    approval. This transition is allowed on locked entities." (+ branch re-route lines).
 * `pStateMap` maps Status → StateName. Returns an HTML string (actors + target emphasized).
 * @return {String}
 */
function transitionSentence(pTransition, pStateMap, pNames)
{
	const tmpStateMap = pStateMap || {};
	const tmpTargetName = tmpStateMap[pTransition.ToStatus] || pTransition.ToStatus || '(unset)';
	const tmpActors = actorsClause(pTransition.Actors, pNames);
	const tmpAction = pTransition.Action || '(no action)';

	let tmpHTML = `<span class="apw-actors">${_escapeHTML(tmpActors)}</span> can `
		+ `<span class="apw-action">${_escapeHTML(tmpAction)}</span> and go to `
		+ `<span class="apw-target">${_escapeHTML(tmpTargetName)}.</span>`;

	if (pTransition.LockEntity)
	{
		tmpHTML += ' <b>This locks the entity.</b>';
	}
	else if (pTransition.UnlockEntity)
	{
		tmpHTML += ' <b>This unlocks the entity.</b>';
	}
	if (pTransition.IsApproval)
	{
		tmpHTML += ' <b>This is an approval.</b>';
	}
	if (pTransition.AllowOnLocked)
	{
		tmpHTML += ' <b>This transition is allowed on locked entities.</b>';
	}
	tmpHTML += _branchLinesHTML(pTransition.Branches, tmpStateMap, 0);
	return tmpHTML;
}

/**
 * Build the { Status → StateName } lookup for a workflow.
 */
function buildStateMap(pWorkflow)
{
	const tmpMap = {};
	for (const tmpState of (pWorkflow.States || []))
	{
		tmpMap[tmpState.Status] = tmpState.StateName;
	}
	return tmpMap;
}

/**
 * Flatten a transition's branches (including nested branch.Branches) into a list of conditional edges, accumulating the
 * criteria text down the nesting. Each entry: { Branch, ToStatus, CriteriaText }.
 */
function _collectBranchEdges(pBranches, pParentCriteria)
{
	const tmpEdges = [];
	for (const tmpBranch of (pBranches || []))
	{
		const tmpCriteria = pParentCriteria.concat([ criteriaText(tmpBranch.Criteria) ]).filter(Boolean);
		tmpEdges.push({ Branch: tmpBranch, ToStatus: tmpBranch.ToStatus, CriteriaText: tmpCriteria.join(' and ') });
		if (Array.isArray(tmpBranch.Branches) && tmpBranch.Branches.length)
		{
			tmpEdges.push(..._collectBranchEdges(tmpBranch.Branches, tmpCriteria));
		}
	}
	return tmpEdges;
}

/**
 * Plain-language rows for what a transition carries beyond the controls on its panel, so an admin can see it's there.
 * @param {Object} pTransition
 * @param {Object} pStateMap - Status → StateName.
 * @return {Array<{ Label: String, Detail: String }>}
 */
function otherTransitionSettings(pTransition, pStateMap)
{
	const tmpStateMap = pStateMap || {};
	const tmpNameOf = (pStatus) => tmpStateMap[pStatus] || pStatus;
	const tmpRows = [];
	const tmpHandled = new Set([ 'Action', 'ToStatus', 'Actors', ...TOGGLE_FLAGS ]);
	const tmpAdd = (pKey, pLabel, pDetail) =>
	{
		tmpHandled.add(pKey);
		if (pTransition[pKey] !== undefined)
		{
			tmpRows.push({ Label: pLabel, Detail: pDetail(pTransition[pKey]) });
		}
	};
	tmpAdd('Branches', 'Conditional routes', (pBranches) => _collectBranchEdges(pBranches, []).map((pEdge) => `If ${pEdge.CriteriaText}, goes to ${tmpNameOf(pEdge.ToStatus)}`).join('. '));
	tmpAdd('Criteria', 'Only offered when', (pCriteria) => criteriaText(pCriteria));
	tmpAdd('Triggers', 'Also does', (pTriggers) => (Array.isArray(pTriggers) ? pTriggers : []).map((pTrigger) => TRIGGER_LABELS[pTrigger && pTrigger.Event] || (pTrigger && pTrigger.Event) || 'Unknown').join(', '));
	tmpAdd('BackPropagateTo', 'Can be pre-approved from', (pStatuses) => (Array.isArray(pStatuses) ? pStatuses : []).map(tmpNameOf).join(', '));
	tmpAdd('BackPropagateCriteria', 'Pre-approval only when', (pCriteria) => criteriaText(pCriteria));
	tmpAdd('InferBackPropagateCriteria', 'Pre-approval conditions', (pValue) => (pValue ? 'Taken from the route into this state' : 'Not inferred'));
	tmpAdd('InvalidatesApproval', 'Cancels earlier approvals', (pValue) => (pValue ? 'Yes' : 'No'));
	tmpAdd('CreateLineItem', 'Creates line items', (pValue) => (pValue ? 'Yes' : 'No'));
	tmpAdd('RequireProjectSetting', 'Needs project setting', (pValue) => String(pValue));
	tmpAdd('AdditionalRequiredFields', 'Required form fields', (pFields) => (Array.isArray(pFields) ? pFields.join(', ') : String(pFields)));
	Object.keys(pTransition).filter((pKey) => !tmpHandled.has(pKey)).forEach((pKey) =>
	{
		tmpRows.push({ Label: pKey, Detail: `${JSON.stringify(pTransition[pKey])} (not read by the approvals service)` });
	});
	return tmpRows;
}

const TRIGGER_LABELS =
{
	ProjectFilePromote: 'Publishes the document as a project file',
	LockDocumentSample: 'Locks the document\'s samples',
	UnlockDocumentSample: 'Unlocks the document\'s samples',
	SetDocumentSampleStatus: 'Sets the status of the document\'s samples',
	LIMSClaim: 'Claims the document for LIMS',
};

module.exports =
{
	TOGGLE_FLAGS,
	NEW_DEFAULT_WORKFLOW_CONFIG,
	ROLE_ACTOR_TYPES,
	KEYWORD_ACTOR_TYPES,
	stateColor,
	stateTint,
	normalizeLoadedBlob,
	prepareBlobForSave,
	applyTransitionPatch,
	renameStatusCascade,
	removeStateCascade,
	findSaveProblems,
	findUnreachableStates: libRules.findUnreachableStates,
	findDanglingTargets: libRules.findDanglingTargets,
	workflowsEqual: libRules.deepEqual,
	workflowChanges: libRules.workflowChanges,
	workflowNameProblem: libRules.workflowNameProblem,
	checkWorkflow: libRules.checkWorkflow,
	actorRows,
	removeActorRow,
	setActorRowTags,
	actorTagOptions,
	parseActorTags,
	addActorSpec,
	flowOrder,
	collectActorReferences,
	actorFragment,
	actorsClause,
	criteriaText,
	criteriaConditionText,
	transitionSentence,
	buildStateMap,
	otherTransitionSettings,
};

},{"@paviasystems/approval-workflow-rules":1}],1069:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const libAssetDescriptor = require('./AssetDescriptor.js');
// The compiled-in FHWA SNBI vocabulary. Kept ONLY as the fallback for an asset type that has no
// published descriptor yet, so this provider is a no-op change for the Bridge type until its
// descriptor is authored. Delete this require (and the file) once every live type has one.
const libSNBI = require('./SNBI-Dictionary.js');

/**
 * AssetDescriptorProvider — loads, caches and version-resolves asset-type metadata descriptors.
 *
 * Every screen that renders asset metadata asks this provider for an accessor and then stops caring
 * what kind of asset it is looking at. That indirection is the whole point: a bridge's SNBI codes, a
 * culvert's barrel material and a sign's retroreflectivity all arrive through the same surface.
 *
 * ── Which version renders an asset ─────────────────────────────────────────────────────────────
 *
 * A descriptor decides how stored data is DISPLAYED and what the next ingestion EXPLODES, so "which
 * version" is a correctness question, not a preference:
 *
 *   1. The version the asset's data was written against (`PhysicalAsset.ManifestVersion`), when the
 *      asset carries one. Data written under an older vocabulary keeps rendering under that
 *      vocabulary instead of being reinterpreted by a newer one.
 *   2. Otherwise the newest PUBLISHED version. Drafts are invisible here — that is what makes the
 *      editor safe to work in against live data.
 *   3. Otherwise nothing, and the caller gets the fallback.
 *
 * `ManifestVersion` is 0 on every asset today and written by nothing; step 1 exists so that ingestion
 * can start stamping it without a second change here.
 */
class AssetDescriptorProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		/** IDAssetType -> Promise<Array<manifest row>>, so concurrent callers share one fetch. */
		this._manifestsByType = {};
		/** `${IDAssetType}:${Version}` -> normalized descriptor. */
		this._descriptorCache = {};
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	_get(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/** Drop every cached manifest and descriptor — call after saving a descriptor. */
	invalidate(pIDAssetType)
	{
		if (pIDAssetType == null)
		{
			this._manifestsByType = {};
			this._descriptorCache = {};
			return;
		}
		delete this._manifestsByType[Number(pIDAssetType)];
		const tmpPrefix = `${ Number(pIDAssetType) }:`;
		for (const tmpKey of Object.keys(this._descriptorCache))
		{
			if (tmpKey.indexOf(tmpPrefix) === 0) { delete this._descriptorCache[tmpKey]; }
		}
	}

	/**
	 * Every manifest row for an asset type, newest version first. Cached as the PROMISE so a burst of
	 * callers on first paint issues one request, not a dozen.
	 *
	 * @param {Number} pIDAssetType
	 * @return {Promise<Array<Object>>}
	 */
	manifestsForTypeAsync(pIDAssetType)
	{
		const tmpID = Number(pIDAssetType);
		if (!tmpID) { return Promise.resolve([]); }
		if (this._manifestsByType[tmpID]) { return this._manifestsByType[tmpID]; }

		const tmpPromise = this._get(`AssetTypeManifests/FilteredTo/FBV~IDAssetType~EQ~${ tmpID }~FBV~Deleted~EQ~0~FSF~Version~DESC~0/0/100`)
			.then((pRows) => (Array.isArray(pRows) ? pRows.slice().sort((pLeft, pRight) => (Number(pRight.Version) - Number(pLeft.Version))) : []))
			.catch((pError) =>
			{
				// A missing descriptor must degrade to the fallback, never blank a screen.
				this.pict.log.warn(`AssetDescriptor: could not load manifests for asset type ${ tmpID }: ${ pError.message || pError }`);
				delete this._manifestsByType[tmpID];
				return [];
			});

		this._manifestsByType[tmpID] = tmpPromise;
		return tmpPromise;
	}

	/**
	 * Normalize one manifest row into a descriptor, cached by (type, version).
	 *
	 * @param {Number} pIDAssetType
	 * @param {Object} pRow
	 * @return {Object} the normalized descriptor
	 */
	_descriptorFromRow(pIDAssetType, pRow)
	{
		const tmpKey = `${ Number(pIDAssetType) }:${ Number(pRow.Version) || 0 }`;
		if (this._descriptorCache[tmpKey]) { return this._descriptorCache[tmpKey]; }
		// Meadow serves the ManifestJSON column as a parsed `Manifest` object; normalize handles either.
		const tmpManifest = (pRow.Manifest != null) ? pRow.Manifest : pRow.ManifestJSON;
		const tmpDescriptor = libAssetDescriptor.normalizeDescriptor(tmpManifest);
		tmpDescriptor.ManifestVersion = Number(pRow.Version) || 0;
		tmpDescriptor.IDAssetTypeManifest = pRow.IDAssetTypeManifest;
		this._descriptorCache[tmpKey] = tmpDescriptor;
		return tmpDescriptor;
	}

	/**
	 * Resolve the descriptor for an asset type, honoring the asset's own stamped manifest version when
	 * it has one.
	 *
	 * @param {Number} pIDAssetType
	 * @param {Number} [pManifestVersion] - PhysicalAsset.ManifestVersion; 0/absent means "published"
	 * @return {Promise<Object|null>} the normalized descriptor, or null when the type has none
	 */
	async descriptorForTypeAsync(pIDAssetType, pManifestVersion)
	{
		const tmpRows = await this.manifestsForTypeAsync(pIDAssetType);
		if (!tmpRows.length) { return null; }

		const tmpStampedVersion = Number(pManifestVersion) || 0;
		if (tmpStampedVersion > 0)
		{
			const tmpStampedRow = tmpRows.find((pRow) => (Number(pRow.Version) === tmpStampedVersion));
			if (tmpStampedRow)
			{
				const tmpStamped = this._descriptorFromRow(pIDAssetType, tmpStampedRow);
				if (!libAssetDescriptor.isEmpty(tmpStamped)) { return tmpStamped; }
			}
		}

		// Newest published version. Rows are already newest-first.
		for (const tmpRow of tmpRows)
		{
			const tmpDescriptor = this._descriptorFromRow(pIDAssetType, tmpRow);
			if ((tmpDescriptor.Status === 'published') && !libAssetDescriptor.isEmpty(tmpDescriptor))
			{
				return tmpDescriptor;
			}
		}
		return null;
	}

	/**
	 * An accessor for an asset type — the call every renderer makes.
	 *
	 * Falls back to the compiled-in SNBI vocabulary when the type has no published descriptor, so the
	 * Bridge type renders identically before and after its descriptor is authored.
	 *
	 * @param {Number} pIDAssetType
	 * @param {Object} [pOptions] - { SetKey, ManifestVersion }
	 * @return {Promise<Object>} an accessor (never null)
	 */
	async accessorForTypeAsync(pIDAssetType, pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpDescriptor = await this.descriptorForTypeAsync(pIDAssetType, tmpOptions.ManifestVersion);
		if (tmpDescriptor)
		{
			return new libAssetDescriptor.AssetDescriptorAccessor(tmpDescriptor, { SetKey: tmpOptions.SetKey });
		}
		return this.fallbackAccessor(tmpOptions.SetKey);
	}

	/**
	 * The compiled-in SNBI vocabulary, shaped as a descriptor accessor.
	 *
	 * This exists so that introducing the descriptor layer is provably inert: every call the dashboard
	 * used to make against SNBI-Dictionary.js resolves to the same answer through this path. It is
	 * deliberately the ONLY place left that references that module.
	 *
	 * @param {String} [pSetKey]
	 * @return {Object} an accessor over a descriptor built from SNBI-Dictionary.js
	 */
	fallbackAccessor(pSetKey)
	{
		if (!this._fallbackDescriptor)
		{
			this._fallbackDescriptor = libAssetDescriptor.normalizeDescriptor(buildDescriptorFromSNBIDictionary());
		}
		return new libAssetDescriptor.AssetDescriptorAccessor(this._fallbackDescriptor, { SetKey: pSetKey || 'SNBISubmission' });
	}
}

// Friendly names for the SNBI code-group prefixes. Lifted verbatim out of the dashboard so the
// fallback renders exactly what the dashboard used to render on its own.
const _SNBI_GROUPS =
{
	BID: 'Identification', BL: 'Location', BCL: 'Classification', BC: 'Condition', BG: 'Geometry',
	BLR: 'Load rating', BAP: 'Appraisal', BIR: 'Inspection', BRH: 'Railings', BW: 'Work',
	BE: 'Element', BCS: 'Condition state', BF: 'Feature', BH: 'Highway', BN: 'Navigation',
	BRR: 'Railroad', BIE: 'Inspection event', BSP: 'Span', BSB: 'Substructure',
	BPS: 'Posting status', BEP: 'Posting evaluation',
};
const _SNBI_GROUP_ORDER = [ 'BID', 'BL', 'BCL', 'BC', 'BG', 'BLR', 'BAP', 'BIR', 'BRH', 'BW', 'BSP', 'BSB', 'BF', 'BH', 'BN', 'BRR', 'BE', 'BCS', 'BIE', 'BPS', 'BEP' ];
// The scalar metrics the dashboard offered for map coloring, by group.
const _SNBI_METRIC_GROUPS =
{
	BC: [ 'BC01', 'BC02', 'BC03', 'BC04', 'BC05', 'BC06', 'BC07', 'BC08', 'BC09', 'BC10', 'BC11', 'BC14', 'BC15' ],
	BLR: [ 'BLR01', 'BLR02', 'BLR03', 'BLR04', 'BLR05', 'BLR06', 'BLR07', 'BLR08' ],
	BG: [ 'BG01', 'BG02', 'BG03', 'BG04', 'BG05', 'BG06', 'BG07', 'BG08', 'BG09', 'BG10', 'BG11', 'BG12', 'BG13', 'BG14', 'BG15' ],
};
// The nine collection pseudo-entries the flat dictionary carries alongside real data items.
const _SNBI_COLLECTIONS = [ 'Elements', 'Features', 'Inspections', 'PostingEvaluations', 'PostingStatuses', 'Routes', 'SpanSets', 'SubstructureSets', 'Works' ];

/**
 * Build a descriptor-shaped object from the compiled-in SNBI dictionary, so the fallback path and the
 * descriptor path are the same code.
 *
 * @return {Object} a raw (un-normalized) descriptor
 */
function buildDescriptorFromSNBIDictionary()
{
	const tmpMetricCodes = {};
	for (const tmpGroupKey of Object.keys(_SNBI_METRIC_GROUPS))
	{
		for (const tmpCode of _SNBI_METRIC_GROUPS[tmpGroupKey]) { tmpMetricCodes[tmpCode] = true; }
	}

	const tmpFields = [];
	const tmpCollections = [];
	const tmpCodes = Object.keys(libSNBI.SNBI);
	for (let i = 0; i < tmpCodes.length; i++)
	{
		const tmpCode = tmpCodes[i];
		const tmpEntry = libSNBI.SNBI[tmpCode];
		if (_SNBI_COLLECTIONS.indexOf(tmpCode) > -1)
		{
			tmpCollections.push({ Key: tmpCode, Label: tmpEntry.label, Help: tmpEntry.help, Ordinal: i, ItemFields: [] });
			continue;
		}
		// Group prefix = the leading letters of the code (BC01 -> BC). The descriptor makes this
		// explicit per field; only the fallback still has to infer it.
		const tmpGroup = String(tmpCode).replace(/\d.*$/, '');
		const tmpValueMap = libSNBI.VALUES[tmpCode];
		const tmpValues = tmpValueMap
			? Object.keys(tmpValueMap).map((pRaw, pIndex) => ({ Value: pRaw, Label: tmpValueMap[pRaw], Ordinal: pIndex, Neutral: (pRaw === 'N') }))
			: [];
		tmpFields.push(
			{
				Code: tmpCode,
				Label: tmpEntry.label,
				Group: tmpGroup,
				Ordinal: i,
				DataType: tmpValues.length ? 'enum' : (tmpEntry.units ? 'number' : 'string'),
				Units: tmpEntry.units,
				Help: tmpEntry.help,
				Explode: true,
				Metric: !!tmpMetricCodes[tmpCode],
				Format: { ValueDisplay: 'code-and-label' },
				Scale: { Kind: tmpValues.length ? 'categorical' : 'continuous', Direction: 'none', Neutral: tmpValueMap && tmpValueMap.N ? [ 'N' ] : [] },
				Values: tmpValues,
			});
	}

	return (
		{
			DescriptorVersion: libAssetDescriptor.DESCRIPTOR_VERSION,
			Status: 'published',
			AssetType: { Key: 'Bridge', Label: { Singular: 'Bridge', Plural: 'Bridges' }, Identity: { Field: 'ExternalSyncGUID', Label: 'Structure #' } },
			MetadataSets:
			[
				{
					Key: 'SNBISubmission',
					Label: 'FHWA SNBI Submission',
					Standard: 'FHWA SNBI (AASHTO, March 2022)',
					Source: 'FHWA',
					Role: 'primary',
					Shape: 'document',
					Groups: _SNBI_GROUP_ORDER.map((pKey, pIndex) => ({ Key: pKey, Label: _SNBI_GROUPS[pKey] || pKey, Ordinal: (pIndex + 1) * 10 })),
					Fields: tmpFields,
					Collections: tmpCollections,
				},
			],
			Dashboard: { DefaultSet: 'SNBISubmission', DefaultMetric: null },
		});
}

module.exports = AssetDescriptorProvider;
module.exports.buildDescriptorFromSNBIDictionary = buildDescriptorFromSNBIDictionary;
module.exports.default_configuration =
{
	ProviderIdentifier: 'AssetDescriptor',
	AutoInitialize: true,
	AutoInitializeOrdinal: 20,
};

},{"./AssetDescriptor.js":1070,"./SNBI-Dictionary.js":1072,"pict-provider":845}],1070:[function(require,module,exports){
(function (Buffer){(function (){
'use strict';

/**
 * AssetDescriptor — the asset-type metadata descriptor: schema, normalizer, validator and accessors.
 *
 * An asset type's descriptor says what data the type carries and how to render it: the named metadata
 * SETS, their GROUPS, and per-field label / units / help / data type / coded values / display scale.
 * It lives in `AssetTypeManifest.ManifestJSON` — one row per (IDAssetType, Version), one row holding
 * the WHOLE descriptor — and it replaces what used to be compiled into the app as SNBI-Dictionary.js
 * plus three more hard-coded maps inside the dashboard.
 *
 * The point is that nothing downstream should know what a bridge is. A bridge's SNBI vocabulary, a
 * culvert's barrel material and a sign's retroreflectivity are the same shape to every renderer; the
 * only difference is the descriptor the asset type carries. The test this schema has to pass is that
 * the dashboard, the workspace and the ingestion config all read a culvert exactly the way they read
 * a bridge.
 *
 * This module is pure — no pict, no DOM, no network — so it can be unit tested headlessly and reused
 * by ingestion. The loading, caching and version resolution live in AssetDescriptor-Provider.js.
 *
 * ── Shape ──────────────────────────────────────────────────────────────────────────────────────
 *
 *   {
 *     DescriptorVersion: 2,
 *     Status: 'published' | 'draft',
 *     AssetType: { Key, Label: { Singular, Plural }, Icon, Identity: { Field, Label }, SearchFields[] },
 *     MetadataSets: [ {
 *       Key,            // written to PhysicalAssetMetadata.MetadataSetGUID and PhysicalAssetDataSnapshot.Type (<= 64)
 *       Label, Description, Standard, Source,
 *       Role: 'primary' | 'secondary' | 'imagery',
 *       Shape: 'document' | 'flat',
 *       MatchKey: { SourceField, AssetField },
 *       Period: { Kind: 'annual' | 'none', EffectiveDateFrom, Parse },
 *       Groups: [ { Key, Label, Ordinal, Icon } ],
 *       Fields: [ {
 *         Code,         // stable key; written to PhysicalAssetMetadata.Address (<= 255)
 *         ExternalID, Label, Group, Ordinal,
 *         DataType: 'enum'|'string'|'text'|'number'|'integer'|'date'|'boolean',
 *         Units, Help,
 *         Explode,      // ingestion writes a PhysicalAssetMetadata row for this field
 *         Metric,       // offered as a dashboard color-by / filter metric
 *         Filterable,
 *         Format: { Decimals, Pattern, ValueDisplay: 'label-only'|'code-and-label'|'raw' },
 *         Constraints: { Min, Max, MaxLength, Required },
 *         Scale: { Kind: 'ordinal'|'continuous'|'categorical', Direction, Min, Max, Neutral[], Palette },
 *         Values: [ { Value, Label, Ordinal, Neutral } ],
 *         Equivalent: [ { Set, Code } ]     // the same measure in another set, for cross-standard trends
 *       } ],
 *       Collections: [ { Key, Label, Help, Ordinal, TitleField, TargetEntity, ItemFields[], Collections[] } ]
 *     } ],
 *     ConditionStates: [ { Key, Label, Color, Ordinal } ],
 *     Dashboard: { DefaultSet, DefaultMetric, BrowseColumns[], Map: { DefaultCenter, DefaultZoom } },
 *     Properties: []   // LEGACY: the flat custom-property editor's array. Preserved, never interpreted here.
 *   }
 */

const DESCRIPTOR_VERSION = 2;

const DATA_TYPES = [ 'enum', 'string', 'text', 'number', 'integer', 'date', 'boolean' ];
const SCALE_KINDS = [ 'ordinal', 'continuous', 'categorical' ];
const SCALE_DIRECTIONS = [ 'ascending-good', 'descending-good', 'none' ];
const VALUE_DISPLAYS = [ 'label-only', 'code-and-label', 'raw' ];
const SET_ROLES = [ 'primary', 'secondary', 'imagery' ];
const SET_SHAPES = [ 'document', 'flat' ];

// Column widths the descriptor's own keys are written into downstream. Enforced here so a bad
// descriptor fails in the editor rather than per-row, halfway through an ingestion run.
const LIMITS =
{
	SetKey: 64,        // PhysicalAssetMetadata.MetadataSetGUID / PhysicalAssetDataSnapshot.Type
	FieldCode: 255,    // PhysicalAssetMetadata.Address
	Units: 24,         // PhysicalAssetMetadata.Units
	Source: 64,        // PhysicalAssetMetadata.Source
};

/**
 * Coerce anything into an array.
 *
 * @param {*} pValue
 * @return {Array}
 */
function toArray(pValue)
{
	return Array.isArray(pValue) ? pValue : [];
}

/**
 * A trimmed string, or the fallback when there is nothing there.
 *
 * @param {*} pValue
 * @param {String} [pFallback]
 * @return {String}
 */
function toText(pValue, pFallback)
{
	const tmpText = (pValue == null) ? '' : String(pValue).trim();
	return tmpText.length ? tmpText : (pFallback == null ? '' : pFallback);
}

/**
 * One of a fixed set of values, or the first (the default).
 *
 * @param {*} pValue
 * @param {Array<String>} pAllowed
 * @param {String} [pFallback]
 * @return {String}
 */
function toEnum(pValue, pAllowed, pFallback)
{
	const tmpValue = toText(pValue);
	if (pAllowed.indexOf(tmpValue) > -1) { return tmpValue; }
	return (pFallback != null) ? pFallback : pAllowed[0];
}

/**
 * A finite number, or null.
 *
 * @param {*} pValue
 * @return {Number|null}
 */
function toNumberOrNull(pValue)
{
	if ((pValue == null) || (String(pValue).trim() === '')) { return null; }
	const tmpNumber = Number(pValue);
	return Number.isFinite(tmpNumber) ? tmpNumber : null;
}

/**
 * Normalize one coded value.
 *
 * @param {Object} pValue
 * @param {Number} pIndex
 * @return {Object}
 */
function normalizeValue(pValue, pIndex)
{
	const tmpValue = pValue || {};
	return (
		{
			Value: String((tmpValue.Value == null) ? '' : tmpValue.Value),
			Label: toText(tmpValue.Label, String((tmpValue.Value == null) ? '' : tmpValue.Value)),
			Ordinal: (toNumberOrNull(tmpValue.Ordinal) == null) ? pIndex : Number(tmpValue.Ordinal),
			Neutral: !!tmpValue.Neutral,
		});
}

/**
 * Normalize one field.
 *
 * @param {Object} pField
 * @param {Number} pIndex
 * @return {Object}
 */
function normalizeField(pField, pIndex)
{
	const tmpField = pField || {};
	const tmpCode = toText(tmpField.Code);
	const tmpFormat = tmpField.Format || {};
	const tmpConstraints = tmpField.Constraints || {};
	const tmpScale = tmpField.Scale || {};
	const tmpValues = toArray(tmpField.Values).map(normalizeValue);

	// A field with a value list is an enum whether or not it said so — the value list IS the claim.
	const tmpDataType = toEnum(tmpField.DataType, DATA_TYPES, tmpValues.length ? 'enum' : 'string');

	return (
		{
			Code: tmpCode,
			ExternalID: toText(tmpField.ExternalID, tmpCode),
			Label: toText(tmpField.Label, tmpCode),
			Group: toText(tmpField.Group),
			Ordinal: (toNumberOrNull(tmpField.Ordinal) == null) ? pIndex : Number(tmpField.Ordinal),
			DataType: tmpDataType,
			Units: toText(tmpField.Units) || null,
			Help: toText(tmpField.Help),
			// Default true: a field declared in a descriptor is worth storing unless told otherwise.
			Explode: (tmpField.Explode == null) ? true : !!tmpField.Explode,
			Metric: !!tmpField.Metric,
			Filterable: (tmpField.Filterable == null) ? !!tmpField.Metric : !!tmpField.Filterable,
			// Does this field appear on the asset detail panel? Default TRUE: every descriptor written
			// before this flag existed showed all of its fields, and a new opt-OUT must not silently blank
			// those screens. Hiding is a curation choice the owner makes, never a default.
			Visible: (tmpField.Visible == null) ? true : !!tmpField.Visible,
			Format:
				{
					Decimals: toNumberOrNull(tmpFormat.Decimals),
					Pattern: toText(tmpFormat.Pattern) || null,
					// How a coded value reads on screen. This is the declared replacement for the old
					// dictionary's regex guess ("is the raw value all digits?").
					ValueDisplay: toEnum(tmpFormat.ValueDisplay, VALUE_DISPLAYS, 'code-and-label'),
				},
			Constraints:
				{
					Min: toNumberOrNull(tmpConstraints.Min),
					Max: toNumberOrNull(tmpConstraints.Max),
					MaxLength: toNumberOrNull(tmpConstraints.MaxLength),
					Required: !!tmpConstraints.Required,
				},
			Scale:
				{
					Kind: toEnum(tmpScale.Kind, SCALE_KINDS, (tmpDataType === 'number' || tmpDataType === 'integer') ? 'continuous' : 'categorical'),
					Direction: toEnum(tmpScale.Direction, SCALE_DIRECTIONS, 'none'),
					Min: toNumberOrNull(tmpScale.Min),
					Max: toNumberOrNull(tmpScale.Max),
					Neutral: toArray(tmpScale.Neutral).map((pEntry) => String(pEntry)),
					Palette: toText(tmpScale.Palette) || null,
				},
			Values: tmpValues,
			Equivalent: toArray(tmpField.Equivalent)
				.map((pEntry) => ({ Set: toText(pEntry && pEntry.Set), Code: toText(pEntry && pEntry.Code) }))
				.filter((pEntry) => (pEntry.Set && pEntry.Code)),
			Aliases: toArray(tmpField.Aliases).map((pEntry) => String(pEntry)),
		});
}

/**
 * Normalize one collection, recursively.
 *
 * @param {Object} pCollection
 * @param {Number} pIndex
 * @return {Object}
 */
function normalizeCollection(pCollection, pIndex)
{
	const tmpCollection = pCollection || {};
	const tmpKey = toText(tmpCollection.Key);
	return (
		{
			Key: tmpKey,
			Label: toText(tmpCollection.Label, tmpKey),
			Help: toText(tmpCollection.Help),
			Ordinal: (toNumberOrNull(tmpCollection.Ordinal) == null) ? pIndex : Number(tmpCollection.Ordinal),
			TitleField: toText(tmpCollection.TitleField) || null,
			// When set, the collection materializes into a real table on ingestion rather than staying
			// inside the stored document (Elements -> PhysicalAssetElement).
			TargetEntity: toText(tmpCollection.TargetEntity) || null,
			ItemFields: toArray(tmpCollection.ItemFields).map((pEntry) => String(pEntry)),
			Collections: toArray(tmpCollection.Collections).map(normalizeCollection),
		});
}

/**
 * Normalize one group (a section within a metadata set).
 *
 * @param {Object} pGroup
 * @param {Number} pGroupIndex
 * @return {Object}
 */
function normalizeGroup(pGroup, pGroupIndex)
{
	const tmpGroup = pGroup || {};
	const tmpGroupKey = toText(tmpGroup.Key);
	return (
		{
			Key: tmpGroupKey,
			Label: toText(tmpGroup.Label, tmpGroupKey),
			Ordinal: (toNumberOrNull(tmpGroup.Ordinal) == null) ? (pGroupIndex * 10) : Number(tmpGroup.Ordinal),
			Icon: toText(tmpGroup.Icon) || null,
		});
}

/**
 * Normalize one metadata set.
 *
 * @param {Object} pSet
 * @param {Number} pIndex
 * @return {Object}
 */
function normalizeSet(pSet, pIndex)
{
	const tmpSet = pSet || {};
	const tmpKey = toText(tmpSet.Key);
	const tmpMatchKey = tmpSet.MatchKey || {};
	const tmpPeriod = tmpSet.Period || {};
	return (
		{
			Key: tmpKey,
			Label: toText(tmpSet.Label, tmpKey),
			Description: toText(tmpSet.Description),
			Standard: toText(tmpSet.Standard),
			Source: toText(tmpSet.Source),
			Role: toEnum(tmpSet.Role, SET_ROLES, (pIndex === 0) ? 'primary' : 'secondary'),
			Shape: toEnum(tmpSet.Shape, SET_SHAPES, 'document'),
			MatchKey:
				{
					SourceField: toText(tmpMatchKey.SourceField) || null,
					AssetField: toText(tmpMatchKey.AssetField, 'ExternalSyncGUID'),
				},
			Period:
				{
					Kind: toEnum(tmpPeriod.Kind, [ 'none', 'annual' ], 'none'),
					EffectiveDateFrom: toText(tmpPeriod.EffectiveDateFrom) || null,
					Parse: toText(tmpPeriod.Parse) || null,
				},
			Groups: toArray(tmpSet.Groups).map(normalizeGroup),
			Fields: toArray(tmpSet.Fields).map(normalizeField).filter((pField) => (pField.Code.length > 0)),
			Collections: toArray(tmpSet.Collections).map(normalizeCollection).filter((pCollection) => (pCollection.Key.length > 0)),
			Rules: toArray(tmpSet.Rules),
		});
}

/**
 * Normalize a raw ManifestJSON object (or string) into a complete descriptor. Always returns a usable
 * descriptor — a manifest that carries no descriptor at all yields an empty one rather than throwing,
 * so callers can treat "no descriptor yet" and "descriptor with nothing in it" the same way.
 *
 * @param {Object|String} pManifest - the parsed ManifestJSON, or the raw string
 * @return {Object} the normalized descriptor
 */
function normalizeDescriptor(pManifest)
{
	let tmpManifest = pManifest;
	if (typeof tmpManifest === 'string')
	{
		try { tmpManifest = JSON.parse(tmpManifest); }
		catch (pError) { tmpManifest = {}; }
	}
	if (!tmpManifest || (typeof tmpManifest !== 'object')) { tmpManifest = {}; }

	const tmpAssetType = tmpManifest.AssetType || {};
	const tmpLabel = tmpAssetType.Label || {};
	const tmpIdentity = tmpAssetType.Identity || {};
	const tmpDashboard = tmpManifest.Dashboard || {};
	const tmpMap = tmpDashboard.Map || {};

	return (
		{
			DescriptorVersion: (toNumberOrNull(tmpManifest.DescriptorVersion) == null) ? DESCRIPTOR_VERSION : Number(tmpManifest.DescriptorVersion),
			// A descriptor is a draft until it is explicitly published. Rendering resolves to the newest
			// PUBLISHED version, so an in-progress edit cannot change what every asset looks like.
			Status: toEnum(tmpManifest.Status, [ 'draft', 'published' ], 'draft'),
			AssetType:
				{
					Key: toText(tmpAssetType.Key),
					Label:
						{
							Singular: toText(tmpLabel.Singular, toText(tmpAssetType.Key, 'Asset')),
							Plural: toText(tmpLabel.Plural, toText(tmpLabel.Singular, toText(tmpAssetType.Key, 'Assets'))),
						},
					Icon: toText(tmpAssetType.Icon) || null,
					Identity:
						{
							Field: toText(tmpIdentity.Field, 'ExternalSyncGUID'),
							Label: toText(tmpIdentity.Label, 'Identifier'),
						},
					SearchFields: toArray(tmpAssetType.SearchFields).map((pEntry) => String(pEntry)),
				},
			MetadataSets: toArray(tmpManifest.MetadataSets).map(normalizeSet).filter((pSet) => (pSet.Key.length > 0)),
			ConditionStates: toArray(tmpManifest.ConditionStates).map((pState, pIndex) =>
				{
					const tmpState = pState || {};
					const tmpStateKey = toText(tmpState.Key);
					return (
						{
							Key: tmpStateKey,
							Label: toText(tmpState.Label, tmpStateKey),
							Color: toText(tmpState.Color) || null,
							Ordinal: (toNumberOrNull(tmpState.Ordinal) == null) ? (pIndex + 1) : Number(tmpState.Ordinal),
						});
				}),
			Dashboard:
				{
					DefaultSet: toText(tmpDashboard.DefaultSet) || null,
					DefaultMetric: toText(tmpDashboard.DefaultMetric) || null,
					BrowseColumns: toArray(tmpDashboard.BrowseColumns).map((pColumn) =>
						({ Field: toText(pColumn && pColumn.Field), Label: toText(pColumn && pColumn.Label, toText(pColumn && pColumn.Field)) }))
						.filter((pColumn) => (pColumn.Field.length > 0)),
					Map:
						{
							DefaultCenter: (Array.isArray(tmpMap.DefaultCenter) && (tmpMap.DefaultCenter.length === 2))
								? [ Number(tmpMap.DefaultCenter[0]), Number(tmpMap.DefaultCenter[1]) ]
								: null,
							DefaultZoom: toNumberOrNull(tmpMap.DefaultZoom),
						},
				},
		});
}

/**
 * Is there anything in this descriptor to render from?
 *
 * @param {Object} pDescriptor - a normalized descriptor
 * @return {Boolean}
 */
function isEmpty(pDescriptor)
{
	if (!pDescriptor || !Array.isArray(pDescriptor.MetadataSets)) { return true; }
	return !pDescriptor.MetadataSets.some((pSet) => (pSet.Fields.length > 0) || (pSet.Collections.length > 0));
}

/**
 * Validate a descriptor for the problems that would fail LATE — during an ingestion run or a render —
 * rather than at the moment someone saves it.
 *
 * @param {Object} pDescriptor - a normalized descriptor
 * @return {Array<{Severity: String, Path: String, Message: String}>} problems, worst first
 */
function validateDescriptor(pDescriptor)
{
	const tmpProblems = [];
	const tmpDescriptor = pDescriptor || {};
	const tmpSets = toArray(tmpDescriptor.MetadataSets);

	const tmpSeenSetKeys = {};
	for (const tmpSet of tmpSets)
	{
		const tmpPath = `MetadataSets[${ tmpSet.Key }]`;
		if (tmpSeenSetKeys[tmpSet.Key])
		{
			tmpProblems.push({ Severity: 'error', Path: tmpPath, Message: `Duplicate metadata set key "${ tmpSet.Key }".` });
		}
		tmpSeenSetKeys[tmpSet.Key] = true;

		if (tmpSet.Key.length > LIMITS.SetKey)
		{
			tmpProblems.push({ Severity: 'error', Path: tmpPath, Message: `Set key is ${ tmpSet.Key.length } characters; the column holds ${ LIMITS.SetKey }.` });
		}
		if (tmpSet.Source.length > LIMITS.Source)
		{
			tmpProblems.push({ Severity: 'error', Path: tmpPath, Message: `Source is ${ tmpSet.Source.length } characters; the column holds ${ LIMITS.Source }.` });
		}

		const tmpGroupKeys = {};
		for (const tmpGroup of tmpSet.Groups) { tmpGroupKeys[tmpGroup.Key] = true; }

		const tmpSeenFieldCodes = {};
		for (const tmpField of tmpSet.Fields)
		{
			const tmpFieldPath = `${ tmpPath }.Fields[${ tmpField.Code }]`;
			if (tmpSeenFieldCodes[tmpField.Code])
			{
				tmpProblems.push({ Severity: 'error', Path: tmpFieldPath, Message: `Duplicate field code "${ tmpField.Code }" in this set.` });
			}
			tmpSeenFieldCodes[tmpField.Code] = true;

			if (tmpField.Code.length > LIMITS.FieldCode)
			{
				tmpProblems.push({ Severity: 'error', Path: tmpFieldPath, Message: `Field code is ${ tmpField.Code.length } characters; the column holds ${ LIMITS.FieldCode }.` });
			}
			if (tmpField.Units && (tmpField.Units.length > LIMITS.Units))
			{
				tmpProblems.push({ Severity: 'error', Path: tmpFieldPath, Message: `Units is ${ tmpField.Units.length } characters; the column holds ${ LIMITS.Units }.` });
			}
			if (tmpField.Group && !tmpGroupKeys[tmpField.Group])
			{
				tmpProblems.push({ Severity: 'warning', Path: tmpFieldPath, Message: `Group "${ tmpField.Group }" is not declared in this set, so the field renders ungrouped.` });
			}
			if ((tmpField.DataType === 'enum') && (tmpField.Values.length < 1))
			{
				tmpProblems.push({ Severity: 'warning', Path: tmpFieldPath, Message: 'Declared as an enum but carries no values, so raw codes will show instead of meanings.' });
			}
			if (tmpField.Metric && !tmpField.Explode)
			{
				tmpProblems.push({ Severity: 'error', Path: tmpFieldPath, Message: 'Offered as a dashboard metric but not exploded, so no values are stored to color or filter by.' });
			}
			const tmpSeenValues = {};
			for (const tmpValue of tmpField.Values)
			{
				if (tmpSeenValues[tmpValue.Value])
				{
					tmpProblems.push({ Severity: 'warning', Path: tmpFieldPath, Message: `Duplicate coded value "${ tmpValue.Value }".` });
				}
				tmpSeenValues[tmpValue.Value] = true;
			}
		}

		for (const tmpField of tmpSet.Fields)
		{
			for (const tmpEquivalent of tmpField.Equivalent)
			{
				const tmpTargetSet = tmpSets.find((pSet) => (pSet.Key === tmpEquivalent.Set));
				if (!tmpTargetSet)
				{
					tmpProblems.push({ Severity: 'warning', Path: `${ tmpPath }.Fields[${ tmpField.Code }].Equivalent`, Message: `Points at set "${ tmpEquivalent.Set }", which this descriptor does not declare.` });
				}
				else if (!tmpTargetSet.Fields.some((pField) => (pField.Code === tmpEquivalent.Code)))
				{
					tmpProblems.push({ Severity: 'warning', Path: `${ tmpPath }.Fields[${ tmpField.Code }].Equivalent`, Message: `Points at "${ tmpEquivalent.Set }.${ tmpEquivalent.Code }", which that set does not declare.` });
				}
			}
		}
	}

	const tmpDashboard = tmpDescriptor.Dashboard || {};
	if (tmpDashboard.DefaultSet && !tmpSeenSetKeys[tmpDashboard.DefaultSet])
	{
		tmpProblems.push({ Severity: 'error', Path: 'Dashboard.DefaultSet', Message: `Names set "${ tmpDashboard.DefaultSet }", which this descriptor does not declare.` });
	}
	if (tmpDashboard.DefaultMetric)
	{
		const tmpSet = tmpSets.find((pSet) => (pSet.Key === tmpDashboard.DefaultSet)) || tmpSets[0];
		if (tmpSet && !tmpSet.Fields.some((pField) => (pField.Code === tmpDashboard.DefaultMetric) && pField.Metric))
		{
			tmpProblems.push({ Severity: 'warning', Path: 'Dashboard.DefaultMetric', Message: `"${ tmpDashboard.DefaultMetric }" is not a metric field in the default set, so the dashboard opens uncolored.` });
		}
	}

	return tmpProblems.sort((pLeft, pRight) => ((pLeft.Severity === pRight.Severity) ? 0 : ((pLeft.Severity === 'error') ? -1 : 1)));
}

/**
 * The serialized byte length of a descriptor, so a save can refuse to write one the column will
 * silently truncate into unparseable JSON.
 *
 * @param {Object} pManifest - the whole manifest object being written
 * @return {Number} bytes
 */
function serializedByteLength(pManifest)
{
	const tmpJSON = JSON.stringify(pManifest || {});
	if ((typeof TextEncoder !== 'undefined'))
	{
		try { return new TextEncoder().encode(tmpJSON).length; } catch (pError) { /* fall through */ }
	}
	if ((typeof Buffer !== 'undefined') && Buffer.byteLength) { return Buffer.byteLength(tmpJSON, 'utf8'); }
	return tmpJSON.length;
}

/**
 * An accessor over one normalized descriptor — the surface every renderer uses, and the replacement
 * for the compiled-in dictionary's label/units/help/decodeValue/readable functions.
 */
class AssetDescriptorAccessor
{
	/**
	 * @param {Object} pDescriptor - a normalized descriptor
	 * @param {Object} [pOptions] - { SetKey } to bind the accessor to one metadata set
	 */
	constructor(pDescriptor, pOptions)
	{
		this.descriptor = pDescriptor || normalizeDescriptor({});
		const tmpOptions = pOptions || {};
		this.setKey = toText(tmpOptions.SetKey) || this.descriptor.Dashboard.DefaultSet
			|| (this.descriptor.MetadataSets.length ? this.descriptor.MetadataSets[0].Key : '');

		// Index once: these are read per-cell across thousands of rows.
		this._fieldIndex = {};
		this._groupIndex = {};
		for (const tmpSet of this.descriptor.MetadataSets)
		{
			this._fieldIndex[tmpSet.Key] = {};
			this._groupIndex[tmpSet.Key] = {};
			for (const tmpField of tmpSet.Fields) { this._fieldIndex[tmpSet.Key][tmpField.Code] = tmpField; }
			for (const tmpCollection of tmpSet.Collections) { this._fieldIndex[tmpSet.Key][tmpCollection.Key] = null; }
			for (const tmpGroup of tmpSet.Groups) { this._groupIndex[tmpSet.Key][tmpGroup.Key] = tmpGroup; }
		}
		this._collectionIndex = {};
		for (const tmpSet of this.descriptor.MetadataSets)
		{
			this._collectionIndex[tmpSet.Key] = {};
			for (const tmpCollection of tmpSet.Collections) { this._collectionIndex[tmpSet.Key][tmpCollection.Key] = tmpCollection; }
		}
	}

	/**
	 * What this kind of asset is CALLED, for prose.
	 *
	 * Screens that serve every asset type have to name the thing on screen without knowing what it
	 * is — "3 bridges mapped" when the type is bridges, "3 culverts mapped" when it is culverts. The
	 * fallbacks are deliberately the generic words rather than a blank, so a type with no descriptor
	 * yet reads as "assets" instead of producing "3  mapped".
	 *
	 * @return {String}
	 */
	get singularLabel()
	{
		return this.descriptor.AssetType.Label.Singular || 'Asset';
	}

	/** @return {String} the plural display label for this asset type */
	get pluralLabel()
	{
		return this.descriptor.AssetType.Label.Plural || 'Assets';
	}

	/**
	 * The bound metadata set's name, spaced for prose like "No <X> data on file".
	 *
	 * Set keys are written as identifiers ('SNBISubmission'), which read badly mid-sentence, so the
	 * camel humps become spaces — and an acronym run keeps its shape: SNBISubmission -> SNBI Submission.
	 *
	 * @return {String}
	 */
	get setLabel()
	{
		if (!this.setKey) { return 'metadata'; }
		return this.setKey
			.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
			.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
	}

	/** The bound metadata set, or null. @return {Object|null} */
	get set()
	{
		return this.descriptor.MetadataSets.find((pSet) => (pSet.Key === this.setKey)) || null;
	}

	/** Bind to a different metadata set. @param {String} pSetKey @return {AssetDescriptorAccessor} */
	forSet(pSetKey)
	{
		return new AssetDescriptorAccessor(this.descriptor, { SetKey: pSetKey });
	}

	/** The field definition for a code in the bound set, or null. @param {String} pCode @return {Object|null} */
	field(pCode)
	{
		const tmpFields = this._fieldIndex[this.setKey];
		return (tmpFields && tmpFields[pCode]) ? tmpFields[pCode] : null;
	}

	/** A collection definition in the bound set, or null. @param {String} pKey @return {Object|null} */
	collection(pKey)
	{
		const tmpCollections = this._collectionIndex[this.setKey];
		return (tmpCollections && tmpCollections[pKey]) ? tmpCollections[pKey] : null;
	}

	/** Display label for a code — falling back to the code itself. @param {String} pCode @return {String} */
	label(pCode)
	{
		const tmpField = this.field(pCode);
		if (tmpField) { return tmpField.Label; }
		const tmpCollection = this.collection(pCode);
		return tmpCollection ? tmpCollection.Label : String(pCode == null ? '' : pCode);
	}

	/** Units for a code, or null. @param {String} pCode @return {String|null} */
	units(pCode)
	{
		const tmpField = this.field(pCode);
		return tmpField ? tmpField.Units : null;
	}

	/** Help text for a code. @param {String} pCode @return {String} */
	help(pCode)
	{
		const tmpField = this.field(pCode);
		if (tmpField) { return tmpField.Help; }
		const tmpCollection = this.collection(pCode);
		return tmpCollection ? tmpCollection.Help : '';
	}

	/**
	 * The human meaning of a raw coded value, or null when the field is not enumerated or the value is
	 * not one this descriptor knows.
	 *
	 * @param {String} pCode
	 * @param {*} pRaw
	 * @return {String|null}
	 */
	decodeValue(pCode, pRaw)
	{
		const tmpField = this.field(pCode);
		if (!tmpField || (pRaw == null) || (pRaw === '')) { return null; }
		const tmpValue = tmpField.Values.find((pEntry) => (pEntry.Value === String(pRaw)));
		return tmpValue ? tmpValue.Label : null;
	}

	/**
	 * A display-ready string for a code + raw value, per the field's declared Format.ValueDisplay —
	 * not inferred from the shape of the value.
	 *
	 * @param {String} pCode
	 * @param {*} pRaw
	 * @return {String}
	 */
	readable(pCode, pRaw)
	{
		if ((pRaw == null) || (pRaw === '')) { return ''; }
		const tmpField = this.field(pCode);
		const tmpRaw = String(pRaw);
		if (!tmpField) { return tmpRaw; }

		const tmpDecoded = this.decodeValue(pCode, pRaw);
		if (tmpDecoded != null)
		{
			if (tmpField.Format.ValueDisplay === 'raw') { return tmpRaw; }
			if (tmpField.Format.ValueDisplay === 'label-only') { return tmpDecoded; }
			// 'code-and-label': show the code beside its meaning when the code is a NUMBER, because a
			// numeric code is itself information — a rating of 5 is meaningfully between 4 and 6, and
			// inspectors read and speak those numbers. A letter code (N, PO, C01) carries no such
			// ordering, so showing it beside its meaning is just noise. A descriptor that wants the
			// other behavior says so with 'label-only' or 'raw'.
			return /^[0-9]+$/.test(tmpRaw) ? `${ tmpRaw } · ${ tmpDecoded }` : tmpDecoded;
		}

		if (((tmpField.DataType === 'number') || (tmpField.DataType === 'integer')) && (tmpField.Format.Decimals != null))
		{
			const tmpNumber = Number(tmpRaw);
			if (Number.isFinite(tmpNumber))
			{
				const tmpFixed = tmpNumber.toFixed(tmpField.Format.Decimals);
				return tmpField.Units ? `${ tmpFixed } ${ tmpField.Units }` : tmpFixed;
			}
		}
		return tmpField.Units ? `${ tmpRaw } ${ tmpField.Units }` : tmpRaw;
	}

	/**
	 * Groups of the bound set in display order, each with its fields.
	 *
	 * @return {Array<{Key: String, Label: String, Ordinal: Number, Icon: String|null, Fields: Array}>}
	 */
	groups()
	{
		const tmpSet = this.set;
		if (!tmpSet) { return []; }
		const tmpByGroup = {};
		for (const tmpField of tmpSet.Fields)
		{
			const tmpKey = tmpField.Group || '';
			if (!tmpByGroup[tmpKey]) { tmpByGroup[tmpKey] = []; }
			tmpByGroup[tmpKey].push(tmpField);
		}
		const tmpGroups = tmpSet.Groups.slice();
		// Fields pointing at a group the set never declared still have to render somewhere.
		for (const tmpKey of Object.keys(tmpByGroup))
		{
			if (!tmpGroups.some((pGroup) => (pGroup.Key === tmpKey)))
			{
				tmpGroups.push({ Key: tmpKey, Label: tmpKey || 'Other', Ordinal: 9000, Icon: null });
			}
		}
		return tmpGroups
			.map((pGroup) => Object.assign({}, pGroup, { Fields: (tmpByGroup[pGroup.Key] || []).slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal)) }))
			.filter((pGroup) => (pGroup.Fields.length > 0))
			.sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal));
	}

	/**
	 * Groups of the bound set in display order, carrying only the fields the owner left visible.
	 *
	 * This is what a detail panel should render. `groups()` stays the complete picture, because an
	 * editor has to show you the field you hid in order to let you unhide it.
	 *
	 * @return {Array<{Key: String, Label: String, Ordinal: Number, Icon: String|null, Fields: Array}>}
	 */
	visibleGroups()
	{
		return this.groups()
			.map((pGroup) => Object.assign({}, pGroup, { Fields: pGroup.Fields.filter((pField) => pField.Visible) }))
			.filter((pGroup) => (pGroup.Fields.length > 0));
	}

	/**
	 * Codes the bound set declares and the owner hid.
	 *
	 * A renderer that buckets stored values into declared groups typically sweeps whatever is left into
	 * a trailing "other" pile. Without this list a hidden field does not disappear -- it moves to that
	 * pile, which is worse than leaving it where it was. Callers subtract these before sweeping.
	 *
	 * @return {Array<String>}
	 */
	hiddenCodes()
	{
		const tmpSet = this.set;
		return tmpSet ? tmpSet.Fields.filter((pField) => !pField.Visible).map((pField) => pField.Code) : [];
	}

	/**
	 * The dashboard's color-by / filter metrics, grouped for an option list.
	 *
	 * Hidden fields are excluded: colouring a map by a value the owner removed from the detail panel
	 * produces a legend the reader cannot look up anywhere.
	 *
	 * @return {Array<{Group: String, Fields: Array}>}
	 */
	metrics()
	{
		return this.groups()
			.map((pGroup) => ({ Group: pGroup.Label, Fields: pGroup.Fields.filter((pField) => (pField.Metric && pField.Visible)) }))
			.filter((pGroup) => (pGroup.Fields.length > 0));
	}

	/** Every field in the bound set that ingestion should write metadata rows for. @return {Array} */
	explodedFields()
	{
		const tmpSet = this.set;
		return tmpSet ? tmpSet.Fields.filter((pField) => pField.Explode) : [];
	}

	/**
	 * The distinct values of a metric in display order: the descriptor's declared order when it has
	 * one, so a rating legend reads 9→0 rather than alphabetically.
	 *
	 * @param {String} pCode
	 * @param {Array<String>} pObserved - values actually present in the data
	 * @return {Array<String>}
	 */
	orderValues(pCode, pObserved)
	{
		const tmpField = this.field(pCode);
		const tmpObserved = toArray(pObserved).map((pEntry) => String(pEntry));
		if (!tmpField || (tmpField.Values.length < 1)) { return tmpObserved.slice().sort(); }
		const tmpOrder = {};
		tmpField.Values.forEach((pValue) => { tmpOrder[pValue.Value] = pValue.Ordinal; });
		return tmpObserved.slice().sort((pLeft, pRight) =>
			{
				const tmpLeft = (tmpOrder[pLeft] == null) ? 99999 : tmpOrder[pLeft];
				const tmpRight = (tmpOrder[pRight] == null) ? 99999 : tmpOrder[pRight];
				return (tmpLeft === tmpRight) ? String(pLeft).localeCompare(String(pRight)) : (tmpLeft - tmpRight);
			});
	}

	/**
	 * Is a raw value neutral for a metric — "not applicable" rather than a point on the scale? Neutral
	 * values are colored gray rather than placed on the good→bad ramp.
	 *
	 * @param {String} pCode
	 * @param {*} pRaw
	 * @return {Boolean}
	 */
	isNeutralValue(pCode, pRaw)
	{
		const tmpField = this.field(pCode);
		if (!tmpField) { return false; }
		const tmpRaw = String(pRaw);
		if (tmpField.Scale.Neutral.indexOf(tmpRaw) > -1) { return true; }
		const tmpValue = tmpField.Values.find((pEntry) => (pEntry.Value === tmpRaw));
		return !!(tmpValue && tmpValue.Neutral);
	}
}

module.exports =
{
	DESCRIPTOR_VERSION: DESCRIPTOR_VERSION,
	DATA_TYPES: DATA_TYPES,
	SCALE_KINDS: SCALE_KINDS,
	SCALE_DIRECTIONS: SCALE_DIRECTIONS,
	VALUE_DISPLAYS: VALUE_DISPLAYS,
	SET_ROLES: SET_ROLES,
	SET_SHAPES: SET_SHAPES,
	LIMITS: LIMITS,
	normalizeDescriptor: normalizeDescriptor,
	normalizeSet: normalizeSet,
	normalizeGroup: normalizeGroup,
	normalizeField: normalizeField,
	normalizeValue: normalizeValue,
	validateDescriptor: validateDescriptor,
	serializedByteLength: serializedByteLength,
	isEmpty: isEmpty,
	AssetDescriptorAccessor: AssetDescriptorAccessor,
};

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":364}],1071:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
// Metadata vocabulary comes from the asset TYPE's descriptor, resolved at load time through the
// AssetDescriptor provider — not from a dictionary compiled into this screen. A type with no
// published descriptor falls back to the built-in SNBI vocabulary, so an un-authored bridge type renders identically
// until their descriptor is authored. See [[AssetDescriptor.js]].
const libAssetDescriptor = require('./AssetDescriptor.js');


/**
 * PhysicalAssetDashboard — the agency's physical-asset command center: MAP · BROWSE · OVERVIEW over the whole
 * PhysicalAsset inventory, colored / filtered by the FHWA SNBI data backfilled onto each asset (see
 * docs/module-reference/Physical-Assets/SNBI-Asset-Metadata.md). Standalone DashboardMode screen (#/AssetDashboard);
 * the thin view [[PhysicalAssetDashboard.js]] paints this provider into #PAD-Host.
 *
 * Data (plain Meadow): the inventory for the SELECTED asset type (PhysicalAssets — full rows for OriginLat/Long); a chosen
 * scalar metric per asset from PhysicalAssetMetadata (MetadataSetGUID=<the descriptor's metadata set>, Address=<code>);
 * and, on drill-in, the whole stored object from PhysicalAssetDataSnapshot. Map = Leaflet (window.L). Works on the
 * inventory alone; the metric coloring/filters light up as metadata rows land.
 */

// Categorical palette for distinct metric values (SNBI ratings are codes/ratings, not a known good→bad scale yet).
const _PAL = [ '#2f7d4f', '#3a7ca5', '#6a6fae', '#c98a2e', '#b23b32', '#7f8b3d', '#5a8bce', '#c2708f', '#9a6fb0', '#4f9d69', '#b5734e', '#8894a4' ];
const _NOVAL = '#c8d0da';

class PhysicalAssetDashboardProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#PAD-Host';
		this._mode = 'map';            // 'map' | 'browse' | 'overview'
		this._metric = '';             // selected SNBI code, '' = none (uniform)
		this._filterValue = '';        // browse: filter to one metric value
		this._search = '';
		this._assets = [];             // [{ id, name, struct, lat, lng, year, classification }]
		this._assetsLoaded = false;
		this._metricValues = {};       // IDPhysicalAsset -> value (for _metric)
		this._metricFor = '';          // code the values are loaded for
		this._loading = false;
		this._error = '';
		this._loadGen = 0;
		this._map = null; this._markerLayer = null; this._markers = []; this._searchTimer = null;
		this._detailTarget = 0; this._detail = null;
		this._covers = {};             // IDPhysicalAsset -> { ArtifactID, ArtifactVersion, Source, License, Attribution, SourceURL, Date, File }
		this._coversLoaded = false;
		// The asset type on screen, and the metadata set within its descriptor that the metric values
		// and the detail panel read.
		//
		// This screen serves EVERY asset type, so the type is a selection rather than a constant. It
		// is remembered per customer, because an asset manager returning to the dashboard almost always
		// wants the type they were last looking at. The 1 is only the last-resort seed; _loadAssetTypes
		// replaces it with a real choice.
		//
		// The set starts EMPTY on purpose. It used to start at the literal 'SNBISubmission', which the
		// accessor treats as an explicit binding and therefore prefers over the descriptor's own
		// Dashboard.DefaultSet -- so every asset type that is not a bridge bound to a set it does not
		// have, and rendered nothing at all. Empty lets the descriptor answer, and _loadDescriptor copies
		// the resolved key back here for the metadata and snapshot queries.
		this._idAssetType = this._rememberedAssetType() || 1;
		this._metadataSet = '';
		this._descriptorAccessor = null;
		this._assetTypes = [];
		this._assetTypesLoaded = false;
	}

	/** Storage key for the remembered asset type — per customer, so switching customers does not carry over. */
	get _assetTypeStorageKey() { return `Headlight.AssetDashboard.IDAssetType.${ this.idCustomer || 0 }`; }

	/** @return {Number} the asset type this user last looked at, or 0 */
	_rememberedAssetType()
	{
		try { return Number((typeof localStorage !== 'undefined') && localStorage.getItem(this._assetTypeStorageKey)) || 0; }
		catch (pError) { return 0; }
	}

	_rememberAssetType(pIDAssetType)
	{
		try { if (typeof localStorage !== 'undefined') { localStorage.setItem(this._assetTypeStorageKey, String(pIDAssetType)); } }
		catch (pError) { /* private browsing; the dashboard still works, it just forgets */ }
	}

	/** The asset type the user picked, applied and repainted. @param {String|Number} pIDAssetType */
	async setAssetType(pIDAssetType)
	{
		const tmpID = Number(pIDAssetType) || 0;
		if (!tmpID || (tmpID === this._idAssetType)) { return; }
		this._idAssetType = tmpID;
		this._rememberAssetType(tmpID);
		// Everything below the type is now stale: the descriptor, the metric and its values, the
		// inventory, the covers and any open detail all belong to the type we just left.
		this._descriptorAccessor = null;
		this._metadataSet = '';
		this._metric = ''; this._metricValues = {}; this._metricFor = '';
		this._assets = []; this._assetsLoaded = false;
		this._covers = {}; this._coversLoaded = false;
		this._detail = null; this._detailTarget = 0;
		await this.loadAsync();
	}

	/**
	 * The asset types this customer actually has, for the type selector.
	 *
	 * If the remembered type is not among them (a new customer, a deleted type), fall back to the
	 * first one rather than querying an inventory that cannot exist.
	 *
	 * @param {Number} pGen - the load generation, for the latest-wins guard
	 */
	async _loadAssetTypes(pGen)
	{
		const tmpRows = await this._get(`AssetTypes/FilteredTo/FBV~IDCustomer~EQ~${ this.idCustomer }~FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/200`);
		if (pGen !== this._loadGen) { return; }
		this._assetTypes = Array.isArray(tmpRows) ? tmpRows : [];
		this._assetTypesLoaded = true;
		// A customer can have assets whose IDAssetType has no AssetType row (HDOT is in exactly that
		// state: 1,366 assets on type 1, and no type records at all). Leave the seeded type alone —
		// the inventory query and the descriptor fallback both still work.
		if (!this._assetTypes.length) { return; }
		if (!this._assetTypes.some((pType) => (Number(pType.IDAssetType) === this._idAssetType)))
		{
			this._idAssetType = Number(this._assetTypes[0].IDAssetType);
		}
	}

	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get idCustomer() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }
	get providerName() { return 'PhysicalAssetDashboard'; }
	get L() { return (typeof window !== 'undefined' && window.L) ? window.L : null; }
	_get(pURL) { return new Promise((resolve) => this.restClient.getJSON(pURL, (e, b) => resolve(e ? null : b))); }
	_esc(pV) { return String(pV == null ? '' : pV).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

	async loadAsync()
	{
		const gen = ++this._loadGen;
		this._loading = true; this._error = ''; this._paint();
		try
		{
			if (!this._assetTypesLoaded) { await this._loadAssetTypes(gen); }
			await this._loadDescriptor(gen);
			if (!this._assetsLoaded) { await this._loadAssets(gen); }
			if (!this._coversLoaded) { await this._loadCovers(gen); }
			if (this._metric && this._metricFor !== this._metric) { await this._loadMetric(this._metric, gen); }
		}
		catch (e) { this._error = (e && e.message) || String(e); }
		finally { if (gen === this._loadGen) { this._loading = false; this._paint(); } }
	}
	/**
	 * Resolve the descriptor for the asset type on screen. Everything this screen renders about asset
	 * metadata — group headings, metric choices, value meanings, units — comes from here.
	 *
	 * @param {Number} pGen - the load generation, for the latest-wins guard
	 */
	async _loadDescriptor(pGen)
	{
		const tmpProvider = this.pict.providers.AssetDescriptor;
		if (!tmpProvider) { return; }
		const tmpAccessor = await tmpProvider.accessorForTypeAsync(this._idAssetType, { SetKey: this._metadataSet });
		if (pGen !== this._loadGen) { return; }
		this._descriptorAccessor = tmpAccessor;
		// Adopt whatever the accessor bound to, even when the named set is missing from the descriptor:
		// the metadata and snapshot queries key on this string, and the accessor's answer is the best one
		// available.
		if (tmpAccessor.setKey) { this._metadataSet = tmpAccessor.setKey; }
		// A descriptor may name the metric the dashboard should open on.
		const tmpDefaultMetric = tmpAccessor.descriptor.Dashboard.DefaultMetric;
		if (!this._metric && tmpDefaultMetric && tmpAccessor.field(tmpDefaultMetric)) { this._metric = tmpDefaultMetric; }
	}

	async _loadAssets(pGen)
	{
		const out = []; let off = 0;
		for (;;)
		{
			const rows = await this._get(`PhysicalAssets/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}~FBV~IDAssetType~EQ~${this._idAssetType}~FBV~Deleted~EQ~0/${off}/500`);
			if (pGen !== this._loadGen) { return; }
			const arr = Array.isArray(rows) ? rows : [];
			arr.forEach((a) => out.push({ id: a.IDPhysicalAsset, name: a.Name || `Asset ${a.IDPhysicalAsset}`, struct: a.ExternalSyncGUID || '', lat: Number(a.OriginLatitude), lng: Number(a.OriginLongitude), year: a.YearBuilt || '', classification: a.IDAssetClassification || 0 }));
			if (arr.length < 500) { break; }
			off += 500;
		}
		this._assets = out; this._assetsLoaded = true;
	}
	async _loadMetric(pCode, pGen)
	{
		const map = {}; let off = 0;
		for (;;)
		{
			const rows = await this._get(`PhysicalAssetMetadatas/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}~FBV~MetadataSetGUID~EQ~${encodeURIComponent(this._metadataSet)}~FBV~Address~EQ~${encodeURIComponent(pCode)}~FBV~Deleted~EQ~0/${off}/1000`);
			if (pGen !== this._loadGen) { return; }
			const arr = Array.isArray(rows) ? rows : [];
			arr.forEach((r) => { map[r.IDPhysicalAsset] = (r.Value != null && r.Value !== '') ? r.Value : r.MetadataValue; });
			if (arr.length < 1000) { break; }
			off += 1000;
		}
		this._metricValues = map; this._metricFor = pCode;
	}
	// Cover photos: one PhysicalAssetMetadata set per asset (MetadataSetGUID='CoverPhoto'), Address/Value rows carrying
	// the Artifact id + provenance (Source, License, Attribution). Populated from the latest inspection Dossier's elevation
	// photo, or a documented public-domain image. Read here in one query and grouped by asset.
	async _loadCovers(pGen)
	{
		const map = {}; let off = 0;
		for (;;)
		{
			const rows = await this._get(`PhysicalAssetMetadatas/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}~FBV~MetadataSetGUID~EQ~CoverPhoto~FBV~Deleted~EQ~0/${off}/2000`);
			if (pGen !== this._loadGen) { return; }
			const arr = Array.isArray(rows) ? rows : [];
			arr.forEach((r) => { const id = r.IDPhysicalAsset; const v = (r.Value != null && r.Value !== '') ? r.Value : r.MetadataValue; (map[id] = map[id] || {})[r.Address] = v; });
			if (arr.length < 2000) { break; }
			off += 2000;
		}
		this._covers = map; this._coversLoaded = true;
	}
	_coverFor(pID) { const c = this._covers[pID]; return (c && (c.ArtifactID || c.SourceURL)) ? c : null; }
	_coverUrl(pCover) { if (!pCover) { return ''; } if (pCover.ArtifactID) { const base = (this.restClient && this.restClient.serverURL) || '/1.0/'; return `${base}Artifact/Media/${pCover.ArtifactID}/${pCover.ArtifactVersion || 1}`; } return pCover.SourceURL || ''; }
	// small provenance badge — inspection photo vs a documented public-domain fill
	_coverBadge(pCover) { const s = (pCover.Source || '').toLowerCase(); if (s.indexOf('public') >= 0 || s.indexOf('domain') >= 0 || s.indexOf('wikimedia') >= 0 || s.indexOf('commons') >= 0) { return { icon: 'fa-creative-commons-pd', text: 'Public domain' }; } return { icon: 'fa-clipboard-check', text: 'Inspection photo' }; }
	_coverHeroHTML(pID)
	{
		const c = this._coverFor(pID); if (!c) { return ''; }
		const url = this._coverUrl(c); if (!url) { return ''; }
		const badge = this._coverBadge(c);
		const src = c.Source || (c.ArtifactID ? 'Inspection Dossier' : 'External');
		const cap = `${this._esc(src)}${c.Attribution ? ` · ${this._esc(c.Attribution)}` : ''}${c.License ? ` · ${this._esc(c.License)}` : ''}`;
		return `<div class="pad-cover"><img class="pad-cover-img" src="${this._esc(url)}" alt="${this._esc(this.assetWord)} cover photo" loading="lazy" referrerpolicy="no-referrer" onerror="this.closest('.pad-cover').style.display='none'">
			<span class="pad-cover-badge"><i class="fas ${badge.icon}"></i> ${this._esc(badge.text)}</span>
			<div class="pad-cover-cap" title="${cap}">${cap}</div></div>`;
	}
	_hasCoords(a) { return Number.isFinite(a.lat) && Number.isFinite(a.lng) && (Math.abs(a.lat) > 0.001 || Math.abs(a.lng) > 0.001); }
	_valueOf(a) { return this._metric ? (this._metricValues[a.id] != null ? String(this._metricValues[a.id]) : '') : ''; }
	// distinct metric values → { color, count, order }. Numeric ratings (e.g. NBI condition 0–9) get an ordered red→green
	// ramp (low = poor = red, high = good = green); non-numeric (e.g. 'N') is neutral gray; otherwise a categorical palette.
	_valueColors()
	{
		if (!this._metric) { return {}; }
		const counts = {}; this._assets.forEach((a) => { const v = this._valueOf(a); if (v !== '') { counts[v] = (counts[v] || 0) + 1; } });
		const vals = Object.keys(counts);
		const numeric = vals.filter((v) => v !== 'N' && v !== '' && !Number.isNaN(Number(v)));
		const map = {};
		if (numeric.length >= 2 && numeric.length >= vals.filter((v) => v !== 'N').length)
		{
			const nums = numeric.map(Number); const min = Math.min(...nums); const max = Math.max(...nums);
			vals.forEach((v) => { if (v === 'N' || Number.isNaN(Number(v))) { map[v] = { color: '#9aa3af', count: counts[v], order: 9999 }; } else { const t = (max > min) ? (Number(v) - min) / (max - min) : 0.5; map[v] = { color: this._ramp(t), count: counts[v], order: Number(v) }; } });
		}
		else { vals.sort((x, y) => counts[y] - counts[x] || (x < y ? -1 : 1)).forEach((v, i) => { map[v] = { color: _PAL[i % _PAL.length], count: counts[v], order: i }; }); }
		return map;
	}
	// red (0) → amber (0.5) → green (1) sequential ramp
	_ramp(t) { const x = Math.max(0, Math.min(1, t)); const stops = [ [ 178, 59, 50 ], [ 217, 138, 46 ], [ 63, 125, 79 ] ]; const seg = x < 0.5 ? 0 : 1; const f = x < 0.5 ? x / 0.5 : (x - 0.5) / 0.5; const a = stops[seg]; const b = stops[seg + 1]; const c = a.map((v, i) => Math.round(v + (b[i] - v) * f)); return `rgb(${c[0]},${c[1]},${c[2]})`; }
	_orderedValues(pColors) { return Object.keys(pColors).sort((x, y) => (pColors[x].order - pColors[y].order) || (x < y ? -1 : 1)); }
	/**
	 * The descriptor accessor for the asset type on screen. Resolved once per load; until then (and for
	 * a type with no published descriptor) this is the built-in SNBI fallback, which renders identically.
	 */
	/** What one of these is called ("Bridge", "Culvert", "Sign"). @return {String} */
	get assetWord() { return this.descriptor.singularLabel; }
	/** What many of them are called. @return {String} */
	get assetWordPlural() { return this.descriptor.pluralLabel; }
	/** Lower-case plural, for mid-sentence prose. @return {String} */
	get assetWordPluralLower() { return this.assetWordPlural.toLowerCase(); }
	/** Lower-case singular, for mid-sentence prose. @return {String} */
	get assetWordLower() { return this.assetWord.toLowerCase(); }
	/**
	 * The indefinite article ("a"/"an") for a word, chosen by its leading SOUND (not just the letter) so generated
	 * copy reads naturally for whatever the asset type is: "an aboveground storage tank", "a bridge", "a utility pole"
	 * (yoo-sound), "an hour" (silent h).
	 * @param {String} pWord @return {String}
	 */
	_article(pWord)
	{
		const w = String(pWord == null ? '' : pWord).trim().toLowerCase();
		if (!w) { return 'a'; }
		if (/^(uni(?![aeiou])|use|usu|uti|utu|ubiq|eu|ewe|one)/.test(w)) { return 'a'; }   // vowel letter, consonant ("yoo"/"w") sound
		if (/^(hour|honest|hono|heir)/.test(w)) { return 'an'; }                           // consonant letter, silent h → vowel sound
		return /^[aeiou]/.test(w) ? 'an' : 'a';
	}
	/** "a <word>" / "an <word>" with the correct article for prose. @param {String} pWord @return {String} */
	_withArticle(pWord) { return `${this._article(pWord)} ${pWord}`; }
	/** The metadata set's name, for prose like "No X on file". @return {String} */
	get setWord() { return this.descriptor.setLabel; }

	get descriptor()
	{
		if (!this._descriptorAccessor)
		{
			const tmpProvider = this.pict.providers.AssetDescriptor;
			this._descriptorAccessor = tmpProvider ? tmpProvider.fallbackAccessor(this._metadataSet) : new libAssetDescriptor.AssetDescriptorAccessor(null);
			// Same reason as _loadDescriptor: the queries read this string, and before the descriptor has
			// loaded it may still be empty.
			if (!this._metadataSet && this._descriptorAccessor.setKey) { this._metadataSet = this._descriptorAccessor.setKey; }
		}
		return this._descriptorAccessor;
	}
	_metricLabel(pCode) { if (!pCode) { return 'No metric'; } const u = this.descriptor.units(pCode); return this.descriptor.label(pCode) + (u ? ` (${u})` : ''); }
	_metricHelp(pCode) { return pCode ? this.descriptor.help(pCode) : ''; }
	// Human-readable form of a raw coded value (e.g. BAP01 'F' → "Fair (noticeable reduction)"); numeric → "value units".
	_valLabel(pCode, pRaw) { return this.descriptor.readable(pCode, pRaw); }
	// Compact version for chips/legend/cells — drops the parenthetical clarifier (e.g. "Fair (noticeable reduction)" → "Fair").
	_valShort(pCode, pRaw) { return this._valLabel(pCode, pRaw).replace(/\s*\([^)]*\)/g, ''); }

	// =========================================================== interactions ===========================================================
	setMode(pMode) { if ([ 'map', 'browse', 'overview' ].indexOf(pMode) < 0 || this._mode === pMode) { return; } if (this._map && pMode !== 'map') { try { this._map.remove(); } catch (e) { /* */ } this._map = null; this._markers = []; if (this._searchTimer) { clearTimeout(this._searchTimer); this._searchTimer = null; } } this._detailTarget = 0; this._detail = null; this._mode = pMode; this._syncHash(); this._paint(); }
	setMetric(pCode) { this._metric = pCode || ''; this._filterValue = ''; if (this._metric && this._metricFor !== this._metric) { this.loadAsync(); } else { this._paint(); } }
	setFilterValue(pV) { this._filterValue = pV || ''; this._paint(); }
	setSearch(pV)
	{
		this._search = String(pV || '');
		// On the map, drive the markers in place (no shell rebuild — keeps input focus and avoids a Leaflet remount):
		// matches light up and everything else fades immediately, then we ease-zoom to the matches once typing settles.
		if (this._mode === 'map' && this._map)
		{
			this._restyleMapMarkers();
			this._updateMapSearchInfo();
			if (this._searchTimer) { clearTimeout(this._searchTimer); }
			this._searchTimer = setTimeout(() => { this._searchTimer = null; this._fitMapToSearch(); }, 280);
		}
		else { this._renderBody(); }   // browse mode: repaint the list only, keep the search input focused
	}
	_matchAsset(pAsset, pTermLower) { if (!pTermLower) { return true; } return ((pAsset.name || '').toLowerCase().indexOf(pTermLower) >= 0) || ((pAsset.struct || '').toLowerCase().indexOf(pTermLower) >= 0); }
	// Restyle the existing circle markers for the current search term: match = emphasized w/ a blue ring; non-match = faded.
	_restyleMapMarkers()
	{
		if (!this._markers) { return; }
		const t = this._search.trim().toLowerCase(); const sel = this._detailTarget;
		this._markers.forEach((pM) =>
		{
			// the open (selected) asset always wins — amber ring, brought to front — so you can see which one the sidebar shows.
			if (sel && pM.a.id === sel) { pM.m.setStyle({ color: '#f59e0b', weight: 3, fillColor: pM.base, fillOpacity: 1 }); pM.m.setRadius(8); try { pM.m.bringToFront(); } catch (e) { /* */ } return; }
			if (!t) { pM.m.setStyle({ color: '#ffffff', weight: 1, fillColor: pM.base, fillOpacity: 0.9 }); pM.m.setRadius(5); return; }
			if (this._matchAsset(pM.a, t)) { pM.m.setStyle({ color: '#2563eb', weight: 2.5, fillColor: pM.base, fillOpacity: 1 }); pM.m.setRadius(7); try { pM.m.bringToFront(); } catch (e) { /* */ } }
			else { pM.m.setStyle({ color: '#ffffff', weight: 0, fillColor: pM.base, fillOpacity: 0.12 }); pM.m.setRadius(3); }
		});
	}
	// Fit the map to the matched (and mappable) assets; capped zoom so a single match doesn't slam to street level.
	_fitMapToSearch()
	{
		if (!this._map || !this._markers) { return; }
		const t = this._search.trim().toLowerCase();
		const pts = this._markers.filter((pM) => (!t || this._matchAsset(pM.a, t)) && this._hasCoords(pM.a)).map((pM) => [ pM.a.lat, pM.a.lng ]);
		if (!pts.length) { return; }
		try { this._map.fitBounds(pts, { padding: [ 40, 40 ], maxZoom: 14 }); } catch (e) { /* */ }
	}
	_updateMapSearchInfo() { const ca = this.pict.ContentAssignment; if (!ca) { return; } const el = ca.getElement('#PAD-SearchInfo'); if (el && el.length) { el[0].innerHTML = this._searchInfoHTML(); } }
	_searchInfoHTML()
	{
		const term = this._search.trim(); if (!term) { return ''; }
		const found = this._assets.filter((a) => this._matchAsset(a, term.toLowerCase()));
		if (!found.length) { return `<div class="pad-search-info none"><i class="fas fa-magnifying-glass"></i> No ${this._esc(this.assetWordLower)} matches <span class="pad-si-term">${this._esc(term)}</span></div>`; }
		const notMapped = found.length - found.filter((a) => this._hasCoords(a)).length;
		return `<div class="pad-search-info"><i class="fas fa-location-crosshairs"></i> <b>${found.length}</b> match${found.length === 1 ? '' : 'es'} for <span class="pad-si-term">${this._esc(term)}</span>${notMapped ? ` <span class="pad-mut">· ${notMapped} not mapped</span>` : ''}</div>`;
	}
	openAsset(pID) { const id = Number(pID) || 0; if (id) { try { window.location.hash = `#/Asset/Workspace/${id}`; } catch (e) { /* */ } } }
	_syncHash() { try { const h = `#/AssetDashboard/${this._mode}`; if (window.location.hash !== h) { window.history.replaceState(null, '', h); } } catch (e) { /* */ } }
	applyViewFromRoute(pV) { if ([ 'map', 'browse', 'overview' ].indexOf(pV) >= 0) { this._mode = pV; } }

	// On the map the detail lives in the docked sidebar — update it (and the marker highlight) in place so the map view
	// never resets as you click between assets. In Browse it's a modal, so a full paint is right.
	_renderDetailSurface() { if (this._mode === 'map' && this._map) { this._restyleMapMarkers(); this._renderSide(); } else { this._paint(); } }
	async showDetail(pID)
	{
		const id = Number(pID) || 0; if (!id) { return; }
		this._detailTarget = id; this._detail = { loading: true }; this._renderDetailSurface();
		try
		{
			const snap = await this._get(`PhysicalAssetDataSnapshots/FilteredTo/FBV~IDPhysicalAsset~EQ~${id}~FBV~Type~EQ~${encodeURIComponent(this._metadataSet)}~FBV~Deleted~EQ~0~FSF~EffectiveDate~DESC~0/0/1`);
			const row = Array.isArray(snap) && snap[0] ? snap[0] : null;
			// Meadow serves the SnapshotJSON column parsed as `Snapshot` (an object); fall back to the raw string form.
			let obj = null; if (row) { if (row.Snapshot != null && typeof row.Snapshot === 'object') { obj = row.Snapshot; } else if (row.SnapshotJSON) { try { obj = JSON.parse(row.SnapshotJSON); } catch (e) { obj = null; } } }
			if (this._detailTarget !== id) { return; }
			this._detail = { loading: false, snapshot: obj, effective: row ? row.EffectiveDate : null };
		}
		catch (e) { if (this._detailTarget === id) { this._detail = { loading: false, snapshot: null, error: (e && e.message) || String(e) }; } }
		if (this._detailTarget === id) { this._renderDetailSurface(); }
	}
	closeDetail() { this._detailTarget = 0; this._detail = null; this._renderDetailSurface(); }

	// =========================================================== paint ===========================================================
	_paint()
	{
		const ca = this.pict.ContentAssignment; if (!ca) { return; }
		this._paintHeading();
		ca.assignContent(this._mount, this._shellHTML());
		if (this._mode === 'map') { try { setTimeout(() => this._mountMap(), 0); } catch (e) { /* */ } }
	}
	// Repaint ONLY the browse list, leaving the toolbar (and its focused search <input>, a sibling of
	// #PAD-Body) untouched — a full _paint() would rebuild the input and drop focus/caret while typing.
	_renderBody()
	{
		const ca = this.pict.ContentAssignment; if (!ca) { return; }
		ca.assignContent('#PAD-Body', this._bodyHTML());
	}
	_shellHTML() { return `${_PAD_STYLE}<div class="pad">${this._toolbarHTML()}<div id="PAD-Body" class="pad-body">${this._bodyHTML()}</div>${this._detailModalHTML()}</div>`; }
	_toolbarHTML()
	{
		const P = this.providerName;
		const mbtn = (m, label, icon) => `<button class="pad-vbtn${this._mode === m ? ' on' : ''}" onclick="_Pict.providers.${P}.setMode('${m}')"><i class="${icon}"></i> ${label}</button>`;
		// One asset type is not a choice — a select with a single option is noise — so the selector
		// appears only when the customer actually has more than one kind of asset.
		const tmpTypeSelect = (this._assetTypes.length > 1)
			? `<select class="pad-sel" title="Asset type" onchange="_Pict.providers.${P}.setAssetType(this.value)">`
				+ this._assetTypes.map((pType) => `<option value="${this._esc(pType.IDAssetType)}"${(Number(pType.IDAssetType) === this._idAssetType) ? ' selected' : ''}>${this._esc(pType.Name || ('Type ' + pType.IDAssetType))}</option>`).join('')
				+ '</select>'
			: '';
		const metricOpts = `<option value=""${!this._metric ? ' selected' : ''}>Color: none</option>` + this.descriptor.metrics().map((g) => `<optgroup label="${this._esc(g.Group)}">${g.Fields.map((f) => `<option value="${this._esc(f.Code)}"${this._metric === f.Code ? ' selected' : ''}>${this._esc(f.Label)}</option>`).join('')}</optgroup>`).join('');
		return `<div class="pad-toolbar">
			<div class="pad-views">${mbtn('map', 'Map', 'fas fa-map-location-dot')}${mbtn('browse', 'Browse', 'fas fa-table-list')}${mbtn('overview', 'Overview', 'fas fa-gauge-high')}</div>
			<div class="pad-filters">
				${tmpTypeSelect}
				${this._loading ? '<i class="fas fa-circle-notch fa-spin pad-spin"></i>' : ''}
				${(this._mode === 'browse' || this._mode === 'map') ? `<span class="pad-search"><i class="fas fa-search"></i><input type="search" placeholder="${this._mode === 'map' ? `Find ${this._withArticle(this.assetWordLower)} — name or identifier…` : 'Search name or structure #…'}" value="${this._esc(this._search)}" oninput="_Pict.providers.${P}.setSearch(this.value)"></span>` : ''}
				<select class="pad-sel" onchange="_Pict.providers.${P}.setMetric(this.value)">${metricOpts}</select>
			</div>
		</div>`;
	}
	/**
	 * Name the screen after the asset type on it.
	 *
	 * The view ships neutral copy ("Asset Dashboard") because it renders before the descriptor is
	 * known; once it is, the heading says what the user is actually looking at. Painted on every
	 * repaint rather than once, because switching asset type has to rename the page too.
	 */
	_paintHeading()
	{
		const tmpPlural = this.assetWordPlural;
		this.pict.ContentAssignment.assignContent('#PAD-Heading',
			`<i class="fas fa-map-location-dot"></i> ${ this._esc(tmpPlural) }`);
		this.pict.ContentAssignment.assignContent('#PAD-Subheading',
			`Map, browse and analyze the ${ this._esc(tmpPlural.toLowerCase()) } in this inventory.`);
	}

	_bodyHTML()
	{
		if (this._error) { return `<div class="pad-empty pad-err"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._error)}</div>`; }
		if (this._loading && !this._assets.length) { return `<div class="pad-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading the asset inventory…</div>`; }
		if (this._mode === 'overview') { return this._overviewHTML(); }
		if (this._mode === 'browse') { return this._browseHTML(); }
		return `<div class="pad-maprow"><div id="PAD-MapHost" class="pad-map"></div>${this._sidebarHTML()}</div>`;
	}
	_legendHTML()
	{
		const mapped = this._assets.filter((a) => this._hasCoords(a)).length;
		if (!this._metric) { return `<div class="pad-legend"><div class="pad-legend-h">${mapped.toLocaleString()} ${this._esc(this.assetWordPluralLower)} mapped</div><div class="pad-legend-note">Pick a metric to color the map by ${this._esc(this.setWord)} values.</div></div>`; }
		const colors = this._valueColors(); const entries = this._orderedValues(colors);
		const noVal = this._assets.filter((a) => this._hasCoords(a) && this._valueOf(a) === '').length;
		return `<div class="pad-legend"><div class="pad-legend-h">${this._esc(this._metricLabel(this._metric))} <span class="pad-legend-n">${entries.length} values</span></div>${this._metricHelp(this._metric) ? `<div class="pad-legend-help">${this._esc(this._metricHelp(this._metric))}</div>` : ''}<div class="pad-legend-code">${this._esc(this._metric)}</div>
			<div class="pad-legend-list">${entries.map((v) => `<div class="pad-legend-i"><span class="pad-dot" style="background:${colors[v].color}"></span><span class="pad-legend-v" title="${this._esc(v)}">${this._esc(this._valShort(this._metric, v))}</span><span class="pad-legend-c">${colors[v].count}</span></div>`).join('')}${noVal ? `<div class="pad-legend-i"><span class="pad-dot" style="background:${_NOVAL}"></span><span class="pad-legend-v pad-mut">no value</span><span class="pad-legend-c">${noVal}</span></div>` : ''}</div>
			${entries.length ? '' : '<div class="pad-legend-note">No values yet for this metric — the SNBI backfill may still be running.</div>'}</div>`;
	}

	// =========================================================== MAP ===========================================================
	_mountMap()
	{
		const L = this.L; const ca = this.pict.ContentAssignment;
		if (!L || !ca) { return; }
		const hostList = ca.getElement('#PAD-MapHost'); if (!hostList || !hostList.length) { return; }
		const host = hostList[0];
		if (this._map) { try { this._map.remove(); } catch (e) { /* */ } this._map = null; }
		const withCoords = this._assets.filter((a) => this._hasCoords(a));
		this._map = L.map(host).setView([ 20.9, -157.5 ], 7);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(this._map);
		const colors = this._valueColors();
		this._markers = [];
		withCoords.forEach((a) =>
		{
			const v = this._valueOf(a); const base = this._metric ? (v !== '' ? (colors[v] ? colors[v].color : _NOVAL) : _NOVAL) : '#2f7d74';
			const m = L.circleMarker([ a.lat, a.lng ], { radius: 5, weight: 1, color: '#ffffff', fillColor: base, fillOpacity: 0.9 });
			m.bindTooltip(`${this._esc(a.name)}${this._metric && v !== '' ? ` · ${this._esc(this.descriptor.label(this._metric))}: ${this._esc(this._valShort(this._metric, v))}` : ''}`);
			m.on('click', () => { try { this.showDetail(a.id); } catch (e) { /* */ } });
			m.addTo(this._map); this._markers.push({ a: a, m: m, base: base });
		});
		// Apply any active search (emphasize matches / fade the rest) and fit — to the matches when searching, else to all.
		this._restyleMapMarkers();
		this._updateMapSearchInfo();
		if (this._search.trim()) { this._fitMapToSearch(); }
		else { const pts = this._markers.map((pM) => [ pM.a.lat, pM.a.lng ]); if (pts.length) { try { this._map.fitBounds(pts, { padding: [ 24, 24 ] }); } catch (e) { /* */ } } }
		setTimeout(() => { if (this._map) { try { this._map.invalidateSize(); } catch (e) { /* */ } } }, 60);
	}

	// =========================================================== BROWSE ===========================================================
	_browseHTML()
	{
		const P = this.providerName; const s = this._search.trim().toLowerCase();
		const colors = this._metric ? this._valueColors() : {};
		let rows = this._assets;
		if (s) { rows = rows.filter((a) => this._matchAsset(a, s)); }
		if (this._metric && this._filterValue) { rows = rows.filter((a) => this._valueOf(a) === this._filterValue); }
		const total = rows.length; const shown = rows.slice(0, 500);
		const valueChips = this._metric ? `<div class="pad-chipbar"><button class="pad-chipf${!this._filterValue ? ' on' : ''}" onclick="_Pict.providers.${P}.setFilterValue('')">All ${this._esc(this.descriptor.label(this._metric))}</button>${this._orderedValues(colors).slice(0, 16).map((v) => `<button class="pad-chipf${this._filterValue === v ? ' on' : ''}" onclick="_Pict.providers.${P}.setFilterValue('${this._esc(v)}')" title="${this._esc(v)}"><span class="pad-dot" style="background:${colors[v].color}"></span>${this._esc(this._valShort(this._metric, v))} <span class="pad-mut">${colors[v].count}</span></button>`).join('')}</div>` : '';
		const body = shown.map((a) =>
		{
			const v = this._valueOf(a); const col = this._metric && v !== '' && colors[v] ? colors[v].color : null;
			return `<tr onclick="_Pict.providers.${P}.showDetail(${a.id})">
				<td class="pad-b-name">${this._esc(a.name)}</td>
				<td><span class="pad-chip">${this._esc(a.struct || '—')}</span></td>
				<td>${a.year ? this._esc(a.year) : '<span class="pad-mut">—</span>'}</td>
				${this._metric ? `<td>${v !== '' ? `<span class="pad-mval" title="${this._esc(v)}"><span class="pad-dot" style="background:${col}"></span>${this._esc(this._valShort(this._metric, v))}</span>` : '<span class="pad-mut">—</span>'}</td>` : ''}
				<td class="pad-b-act"><i class="fas fa-arrow-right"></i></td>
			</tr>`;
		}).join('');
		return `${valueChips}<div class="pad-count">${total.toLocaleString()} ${this._esc(this.assetWordPluralLower)}${total > 500 ? ' · showing first 500' : ''}</div>
			<table class="pad-table"><thead><tr><th>${this._esc(this.assetWord)}</th><th>Structure</th><th>Year</th>${this._metric ? `<th title="${this._esc(this._metric)}">${this._esc(this._metricLabel(this._metric))}</th>` : ''}<th></th></tr></thead><tbody>${body || `<tr><td colspan="5" class="pad-empty-sm">No ${this._esc(this.assetWordPluralLower)} match.</td></tr>`}</tbody></table>`;
	}

	// =========================================================== OVERVIEW ===========================================================
	_overviewHTML()
	{
		const total = this._assets.length; const mapped = this._assets.filter((a) => this._hasCoords(a)).length;
		const withYear = this._assets.filter((a) => a.year && String(a.year).length >= 4).length;
		const P = this.providerName;
		const coveredIds = this._assets.filter((a) => this._coverFor(a.id)).map((a) => a.id);
		const stat = (v, label) => `<div class="pad-stat"><div class="pad-stat-v">${(typeof v === 'number' ? v.toLocaleString() : v)}</div><div class="pad-stat-l">${label}</div></div>`;
		const kpis = `<div class="pad-stats">${stat(total, this.assetWordPlural)}${stat(mapped, 'On the map')}${stat(coveredIds.length, 'With cover photo')}${stat(this._metric ? Object.keys(this._metricValues).length : 0, this._metric ? `With ${this._esc(this._metric)}` : 'Metric — pick one')}</div>`;
		// featured cover-photo strip — a glance at the imagery, click a tile to open that asset on the map
		let featured = '';
		if (coveredIds.length)
		{
			const tiles = coveredIds.slice(0, 12).map((id) => { const a = this._assets.find((x) => x.id === id); const c = this._coverFor(id); const url = this._coverUrl(c); const nm = a ? a.name : `Asset ${id}`; return `<button class="pad-cov-tile" title="${this._esc(nm)}" onclick="_Pict.providers.${P}.openCover(${id})"><img src="${this._esc(url)}" alt="" loading="lazy" referrerpolicy="no-referrer" onerror="this.closest('.pad-cov-tile').style.display='none'"><span class="pad-cov-tile-cap">${this._esc((nm.split(':').pop() || nm).trim())}</span></button>`; }).join('');
			featured = `<div class="pad-card"><div class="pad-card-h"><i class="fas fa-images"></i> Cover photos <span class="pad-mut" style="font-weight:600;text-transform:none;letter-spacing:0;margin-left:auto">${coveredIds.length} ${this._esc(this.assetWordPluralLower)}</span></div><div class="pad-cov-strip">${tiles}</div></div>`;
		}
		let dist = '';
		if (this._metric)
		{
			const colors = this._valueColors(); const entries = this._orderedValues(colors); const max = Math.max(1, ...entries.map((v) => colors[v].count));
			dist = entries.length ? `<div class="pad-card"><div class="pad-card-h"><i class="fas fa-chart-simple"></i> Distribution — ${this._esc(this._metricLabel(this._metric))}</div>
				<div class="pad-dist">${entries.map((v) => `<button class="pad-distrow" onclick="_Pict.providers.${this.providerName}.setMode('browse');_Pict.providers.${this.providerName}.setFilterValue('${this._esc(v)}')">
					<span class="pad-dist-l" title="${this._esc(v)}"><span class="pad-dot" style="background:${colors[v].color}"></span>${this._esc(this._valShort(this._metric, v))}</span>
					<span class="pad-dist-track"><span class="pad-dist-fill" style="width:${Math.round(100 * colors[v].count / max)}%;background:${colors[v].color}"></span></span>
					<span class="pad-dist-c">${colors[v].count}</span></button>`).join('')}</div></div>`
				: `<div class="pad-card"><div class="pad-card-h"><i class="fas fa-chart-simple"></i> Distribution — ${this._esc(this._metricLabel(this._metric))}</div><div class="pad-empty-sm">No values yet — the SNBI backfill may still be running.</div></div>`;
		}
		else { dist = `<div class="pad-card"><div class="pad-empty-sm">Pick a metric (SNBI condition, load rating, geometry) to see its distribution and color the map.</div></div>`; }
		return `${kpis}${featured}${dist}`;
	}
	// open an asset's detail from a cover tile (jump to the map so its sidebar + marker show)
	openCover(pID) { const id = Number(pID) || 0; if (!id) { return; } this.setMode('map'); setTimeout(() => this.showDetail(id), 60); }

	// =========================================================== SIDEBAR (map) ===========================================================
	_sidebarHTML() { return `<div id="PAD-Side" class="pad-side">${this._sidebarInnerHTML()}</div>`; }
	_renderSide() { const ca = this.pict.ContentAssignment; if (!ca) { return; } const el = ca.getElement('#PAD-Side'); if (el && el.length) { el[0].innerHTML = this._sidebarInnerHTML(); } }
	_sidebarInnerHTML()
	{
		const searchInfo = `<div id="PAD-SearchInfo" class="pad-si-wrap">${this._searchInfoHTML()}</div>`;
		if (this._detailTarget) { return searchInfo + this._sideDetailHTML(); }
		return searchInfo + this._legendHTML() + `<div class="pad-side-hint"><i class="fas fa-hand-pointer"></i> Click any ${this._esc(this.assetWordLower)} to read its ${this._esc(this.setWord)} data here.</div>`;
	}
	_sideDetailHTML()
	{
		const id = this._detailTarget; const P = this.providerName;
		const a = this._assets.find((x) => x.id === id) || { id: id, name: `Asset ${id}` };
		const d = this._detail || {};
		let body;
		if (d.loading) { body = `<div class="pad-side-msg"><i class="fas fa-circle-notch fa-spin"></i> Loading SNBI data…</div>`; }
		else if (d.error) { body = `<div class="pad-side-msg">Couldn't load this record: ${this._esc(d.error)}</div>`; }
		else if (!d.snapshot) { body = `<div class="pad-side-msg">No ${this._esc(this.setWord)} data on file for this ${this._esc(this.assetWordLower)} yet.</div>`; }
		else
		{
			const b = d.snapshot; let callout = '';
			if (this._metric && b[this._metric] != null && b[this._metric] !== '')
			{
				const v = String(b[this._metric]); const colors = this._valueColors(); const col = colors[v] ? colors[v].color : _NOVAL;
				callout = `<div class="pad-side-metric"><span class="pad-dot" style="background:${col}"></span><div class="pad-side-metric-t"><div class="pad-side-metric-l">${this._esc(this._metricLabel(this._metric))}</div><div class="pad-side-metric-v">${this._esc(this._valLabel(this._metric, v))}</div></div></div>`;
			}
			body = callout + this._detailPropsHTML(b);
		}
		const sub = `${a.struct ? `<span class="pad-chip">${this._esc(a.struct)}</span>` : ''}${a.year ? `<span class="pad-mut">Built ${this._esc(a.year)}</span>` : ''}${d.effective ? `<span class="pad-mut">SNBI ${this._esc(String(d.effective).slice(0, 10))}</span>` : ''}`;
		return `<div class="pad-side-detail">
			${this._coverHeroHTML(id)}
			<div class="pad-side-top">
				<div class="pad-side-h"><span class="pad-side-name">${this._esc(a.name)}</span><button class="pad-side-x" onclick="_Pict.providers.${P}.closeDetail()" title="Close"><i class="fas fa-xmark"></i></button></div>
				${sub ? `<div class="pad-side-sub">${sub}</div>` : ''}
			</div>
			<div class="pad-side-scroll">${body}</div>
			<div class="pad-side-foot"><a class="pad-btn" href="#/Asset/Workspace/${id}"><i class="fas fa-arrow-up-right-from-square"></i> Open asset</a></div>
		</div>`;
	}
	// Shared SNBI-snapshot renderer (docked sidebar + browse modal): collection counts, then scalar codes grouped by
	// prefix and laid out as a responsive label/value grid so natural pairs (lat/long, min/max span) sit together, units shown.
	_detailPropsHTML(pSnapshot)
	{
		const b = pSnapshot || {};
		const acc = this.descriptor;
		const colls = Object.keys(b).filter((k) => Array.isArray(b[k]) && b[k].length).map((k) => `<span class="pad-chip" title="${this._esc(acc.help(k) || k)}">${this._esc(acc.label(k))}: ${b[k].length}</span>`).join(' ');
		// Scalars present on this record, bucketed into the descriptor's declared groups and rendered in
		// its declared order. A code the descriptor does not carry still renders, in a trailing group.
		const present = {};
		Object.keys(b).forEach((k) => { const v = b[k]; if (Array.isArray(v) || (v && typeof v === 'object')) { return; } if (v === '' || v === null) { return; } present[k] = v; });
		// Fields the owner hid come out BEFORE the grouping pass. Dropping them from the groups alone
		// would not hide them -- whatever is left in `present` falls through to the "Other" pile below, so
		// a hidden field would simply move there, stripped of its group and its label.
		acc.hiddenCodes().forEach((pCode) => { delete present[pCode]; });
		const grpHTML = acc.visibleGroups().map((g) =>
		{
			const rows = g.Fields.filter((f) => (present[f.Code] !== undefined)).map((f) => { const pair = [ f.Code, present[f.Code] ]; delete present[f.Code]; return pair; });
			return rows.length ? `<div class="pad-dt-grp"><div class="pad-dt-grp-h">${this._esc(g.Label)}</div><div class="pad-props">${rows.map((pair) => this._propHTML(pair[0], pair[1])).join('')}</div></div>` : '';
		}).join('');
		const leftoverKeys = Object.keys(present);
		const leftoverHTML = leftoverKeys.length ? `<div class="pad-dt-grp"><div class="pad-dt-grp-h">Other</div><div class="pad-props">${leftoverKeys.map((k) => this._propHTML(k, present[k])).join('')}</div></div>` : '';
		return `${colls ? `<div class="pad-dt-colls">${colls}</div>` : ''}${(grpHTML + leftoverHTML) || '<div class="pad-mut">—</div>'}`;
	}
	_propHTML(pCode, pVal)
	{
		const acc = this.descriptor;
		const lbl = acc.label(pCode); const u = acc.units(pCode); const hlp = acc.help(pCode); const val = String(pVal);
		const dec = acc.decodeValue(pCode, pVal);  // enum → human meaning; null for numeric/text
		// Coded field → show the meaning (raw code kept in the tooltip). Numeric/text → value + units.
		const valHtml = dec != null
			? `${this._esc(dec)} <span class="pad-prop-u">(${this._esc(val)})</span>`
			: `${this._esc(val)}${u ? `<span class="pad-prop-u"> ${this._esc(u)}</span>` : ''}`;
		const disp = dec != null ? dec : val;
		const ttl = `${pCode}${u ? ' · ' + u : ''} = ${val}${hlp ? ' — ' + hlp : ''}`;
		const wide = (disp.length > 20 || lbl.length > 26) ? ' pad-prop--wide' : '';
		return `<div class="pad-prop${wide}" title="${this._esc(ttl)}"><div class="pad-prop-l">${this._esc(lbl)}</div><div class="pad-prop-v">${valHtml}</div></div>`;
	}

	// =========================================================== DETAIL (SNBI snapshot) ===========================================================
	_detailModalHTML()
	{
		if (this._mode !== 'browse') { return ''; }  // on the map the detail lives in the docked sidebar, not a modal
		const id = this._detailTarget; if (!id) { return ''; }
		const a = this._assets.find((x) => x.id === id) || { id, name: `Asset ${id}` }; const P = this.providerName; const d = this._detail || {};
		let content = '<div class="pad-mut"><i class="fas fa-circle-notch fa-spin"></i> loading SNBI record…</div>';
		if (!d.loading)
		{
			if (!d.snapshot) { content = `<div class="pad-mut">No ${this._esc(this.setWord)} data on file for this ${this._esc(this.assetWordLower)} yet.</div>`; }
			else { content = `<div class="pad-dt-scroll">${this._detailPropsHTML(d.snapshot)}</div>`; }
		}
		return `<div class="pad-modalbg" onclick="_Pict.providers.${P}.closeDetail()"><div class="pad-modal" onclick="event.stopPropagation()">
			<div class="pad-modal-h"><i class="fas fa-cube"></i> ${this._esc(a.name)}<button class="pad-modal-x" onclick="_Pict.providers.${P}.closeDetail()"><i class="fas fa-xmark"></i></button></div>
			<div class="pad-modal-sub">${a.struct ? `Structure ${this._esc(a.struct)}` : ''}${d.effective ? ` · SNBI as of ${this._esc(String(d.effective).slice(0, 10))}` : ''}</div>
			${content}
			<div class="pad-modal-act"><button class="pad-btn ghost" onclick="_Pict.providers.${P}.closeDetail()">Close</button><a class="pad-btn" href="#/Asset/Workspace/${id}"><i class="fas fa-arrow-up-right-from-square"></i> Open asset</a></div>
		</div></div>`;
	}
}

const _PAD_STYLE = /*html*/`<style>
	.pad { --b:var(--theme-color-border-light,#e4e9ef); --b2:var(--theme-color-border-medium,#d5dbe3); --mut:var(--theme-color-text-muted,#8894a4); --ink:var(--theme-color-text-primary,#1f2733); --sec:var(--theme-color-text-secondary,#45505f); --brand:var(--theme-color-brand-primary,#2e7d74); --bg2:var(--theme-color-background-secondary,#f4f6f9); --card:var(--theme-color-background-primary,#fff); font-size:14px; color:var(--ink); }
	.pad-toolbar { display:flex; flex-wrap:wrap; align-items:center; gap:0.7rem 1rem; padding:0.1rem 0 0.9rem; }
	.pad-views { display:inline-flex; border:1px solid var(--b2); border-radius:9px; overflow:hidden; }
	.pad-vbtn { border:none; background:var(--card); color:var(--sec); font-size:0.82rem; font-weight:700; padding:0.45rem 0.85rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.4rem; border-right:1px solid var(--b); } .pad-vbtn:last-child { border-right:none; } .pad-vbtn:hover { background:var(--bg2); } .pad-vbtn.on { background:var(--brand); color:#fff; }
	.pad-filters { display:inline-flex; align-items:center; gap:0.5rem; margin-left:auto; } .pad-spin { color:var(--brand); }
	.pad-sel { font-size:0.82rem; padding:0.42rem 0.5rem; border:1px solid var(--b2); border-radius:8px; background:var(--theme-color-background-input,#fff); color:var(--ink); }
	.pad-search { display:inline-flex; align-items:center; gap:0.4rem; border:1px solid var(--b2); border-radius:8px; padding:0.28rem 0.55rem; background:var(--theme-color-background-input,#fff); color:var(--mut); } .pad-search input { border:none; outline:none; font-size:0.85rem; background:transparent; color:var(--ink); width:14rem; }
	.pad-empty { padding:2.5rem; text-align:center; color:var(--mut); border:1px dashed var(--b2); border-radius:12px; } .pad-err { color:#b23b32; } .pad-empty-sm { color:var(--mut); font-size:0.85rem; padding:1.4rem; text-align:center; }
	/* map */
	.pad-maprow { display:grid; grid-template-columns:1fr 22rem; gap:0.9rem; align-items:start; } @media (max-width:900px){ .pad-maprow { grid-template-columns:1fr; } .pad-side-detail { max-height:none; } }
	.pad-map { height:70vh; min-height:28rem; border:1px solid var(--b); border-radius:12px; overflow:hidden; z-index:0; }
	.pad-legend { background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.8rem 0.9rem; align-self:start; } .pad-legend-h { font-size:0.9rem; font-weight:800; display:flex; align-items:center; justify-content:space-between; gap:0.4rem; } .pad-legend-n { font-size:0.72rem; color:var(--mut); font-weight:600; } .pad-legend-note { font-size:0.78rem; color:var(--mut); margin-top:0.4rem; } .pad-legend-help { font-size:0.76rem; color:var(--sec); margin-top:0.35rem; line-height:1.35; } .pad-legend-code { font-size:0.64rem; color:var(--mut); font-weight:700; letter-spacing:0.05em; margin-top:0.3rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; } .pad-dt-u { color:var(--mut); font-size:0.7rem; }
	.pad-si-wrap:empty { display:none; } .pad-si-wrap { margin:0 0 0.65rem; } .pad-search-info { font-size:0.78rem; line-height:1.35; color:var(--sec); background:var(--bg2); border:1px solid var(--b); border-radius:8px; padding:0.4rem 0.55rem; } .pad-search-info i { color:var(--brand); } .pad-search-info.none { color:var(--mut); } .pad-search-info.none i { color:var(--mut); } .pad-si-term { font-weight:800; color:var(--ink); }
	/* map sidebar (docked detail) */
	.pad-side { align-self:start; } .pad-side-hint { font-size:0.74rem; color:var(--mut); padding:0.6rem 0.2rem 0; display:flex; align-items:center; gap:0.4rem; } .pad-side-hint i { color:var(--brand); }
	.pad-side-detail { background:var(--card); border:1px solid var(--b); border-radius:12px; display:flex; flex-direction:column; overflow:hidden; max-height:70vh; }
	.pad-cover { position:relative; flex:0 0 auto; height:168px; background:#0d1117; overflow:hidden; } .pad-cover-img { width:100%; height:100%; object-fit:cover; display:block; }
	.pad-cover-badge { position:absolute; top:0.5rem; left:0.5rem; display:inline-flex; align-items:center; gap:0.3rem; font-size:0.64rem; font-weight:800; letter-spacing:0.02em; color:#fff; background:rgba(13,17,23,0.72); border-radius:999px; padding:0.2rem 0.55rem; backdrop-filter:blur(2px); }
	.pad-cover-cap { position:absolute; left:0; right:0; bottom:0; padding:0.85rem 0.7rem 0.45rem; background:linear-gradient(transparent,rgba(0,0,0,0.75)); color:rgba(255,255,255,0.92); font-size:0.66rem; font-weight:600; line-height:1.3; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
	.pad-side-top { padding:0.7rem 0.8rem; border-bottom:1px solid var(--b); flex:0 0 auto; }
	.pad-side-h { display:flex; align-items:flex-start; gap:0.5rem; } .pad-side-name { font-size:0.9rem; font-weight:800; line-height:1.25; flex:1; word-break:break-word; }
	.pad-side-x { border:none; background:transparent; color:var(--mut); cursor:pointer; font-size:1rem; line-height:1; padding:0.05rem 0.15rem; flex:0 0 auto; } .pad-side-x:hover { color:var(--ink); }
	.pad-side-sub { display:flex; flex-wrap:wrap; align-items:center; gap:0.35rem 0.5rem; margin-top:0.45rem; font-size:0.74rem; }
	.pad-side-scroll { padding:0.75rem 0.8rem; overflow:auto; flex:1 1 auto; } .pad-side-msg { color:var(--mut); font-size:0.82rem; padding:1.4rem 0.3rem; text-align:center; }
	.pad-side-foot { padding:0.6rem 0.8rem; border-top:1px solid var(--b); flex:0 0 auto; } .pad-side-foot .pad-btn { width:100%; justify-content:center; }
	.pad-side-metric { display:flex; align-items:center; gap:0.55rem; background:var(--bg2); border:1px solid var(--b); border-radius:9px; padding:0.5rem 0.65rem; margin:0 0 0.85rem; } .pad-side-metric .pad-dot { width:0.85rem; height:0.85rem; } .pad-side-metric-l { font-size:0.64rem; color:var(--sec); font-weight:700; text-transform:uppercase; letter-spacing:0.03em; } .pad-side-metric-v { font-size:1.05rem; font-weight:800; margin-top:0.05rem; }
	.pad-props { display:grid; grid-template-columns:repeat(auto-fill,minmax(8.5rem,1fr)); gap:0.5rem 0.7rem; } .pad-prop { min-width:0; } .pad-prop--wide { grid-column:1 / -1; }
	.pad-prop-l { font-size:0.66rem; color:var(--sec); font-weight:600; line-height:1.2; } .pad-prop-v { font-size:0.86rem; font-weight:700; color:var(--ink); word-break:break-word; margin-top:0.05rem; } .pad-prop-u { font-size:0.7rem; font-weight:600; color:var(--mut); }
	.pad-legend-list { display:flex; flex-direction:column; gap:0.3rem; margin-top:0.6rem; max-height:56vh; overflow:auto; } .pad-legend-i { display:flex; align-items:center; gap:0.45rem; font-size:0.82rem; } .pad-legend-v { flex:1; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; } .pad-legend-c { color:var(--mut); font-weight:700; } .pad-mut { color:var(--mut); }
	.pad-dot { width:0.7rem; height:0.7rem; border-radius:50%; display:inline-block; flex:0 0 auto; border:1px solid rgba(0,0,0,0.15); }
	/* browse */
	.pad-chipbar { display:flex; flex-wrap:wrap; gap:0.4rem; margin:0 0 0.7rem; } .pad-chipf { border:1px solid var(--b2); background:var(--card); color:var(--sec); font-size:0.76rem; font-weight:700; border-radius:999px; padding:0.28rem 0.7rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; } .pad-chipf:hover { background:var(--bg2); } .pad-chipf.on { background:var(--brand); color:#fff; border-color:var(--brand); }
	.pad-count { font-size:0.78rem; color:var(--mut); margin:0 0 0.5rem; }
	.pad-table { width:100%; border-collapse:collapse; font-size:0.87rem; } .pad-table th { text-align:left; font-size:0.64rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--sec); font-weight:800; border-bottom:1px solid var(--b); padding:0.45rem 0.5rem; } .pad-table td { padding:0.5rem; border-bottom:1px solid var(--b); vertical-align:middle; } .pad-table tr { cursor:pointer; } .pad-table tr:hover td { background:var(--bg2); }
	.pad-b-name { font-weight:600; } .pad-chip { font-size:0.72rem; font-weight:600; color:var(--sec); background:var(--bg2); border-radius:5px; padding:0.08rem 0.45rem; } .pad-mval { display:inline-flex; align-items:center; gap:0.35rem; font-weight:700; } .pad-b-act { text-align:right; color:var(--mut); } .pad-table tr:hover .pad-b-act { color:var(--brand); }
	/* overview */
	.pad-cov-strip { display:grid; grid-template-columns:repeat(auto-fill,minmax(9rem,1fr)); gap:0.6rem; } .pad-cov-tile { position:relative; border:1px solid var(--b); border-radius:9px; overflow:hidden; cursor:pointer; padding:0; background:#0d1117; aspect-ratio:4/3; } .pad-cov-tile img { width:100%; height:100%; object-fit:cover; display:block; transition:transform 0.25s ease; } .pad-cov-tile:hover img { transform:scale(1.05); } .pad-cov-tile-cap { position:absolute; left:0; right:0; bottom:0; padding:0.5rem 0.45rem 0.3rem; background:linear-gradient(transparent,rgba(0,0,0,0.78)); color:#fff; font-size:0.66rem; font-weight:700; text-align:left; line-height:1.2; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
	.pad-stats { display:grid; grid-template-columns:repeat(auto-fit,minmax(9rem,1fr)); gap:0.7rem; margin:0 0 0.9rem; } .pad-stat { background:var(--card); border:1px solid var(--b); border-radius:11px; padding:0.7rem 0.9rem; } .pad-stat-v { font-size:1.5rem; font-weight:800; line-height:1; } .pad-stat-l { font-size:0.68rem; color:var(--mut); margin-top:0.3rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:700; }
	.pad-card { background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.9rem 1rem; margin:0 0 0.9rem; } .pad-card-h { font-size:0.8rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--sec); margin:0 0 0.75rem; display:flex; align-items:center; gap:0.45rem; } .pad-card-h i { color:var(--brand); }
	.pad-dist { display:flex; flex-direction:column; gap:0.35rem; } .pad-distrow { display:flex; align-items:center; gap:0.6rem; border:none; background:none; cursor:pointer; width:100%; padding:0.1rem 0; } .pad-distrow:hover .pad-dist-l { color:var(--ink); } .pad-dist-l { width:8rem; flex:0 0 auto; font-size:0.82rem; color:var(--sec); font-weight:600; display:flex; align-items:center; gap:0.4rem; text-align:left; } .pad-dist-track { flex:1; height:0.7rem; background:var(--bg2); border-radius:5px; overflow:hidden; } .pad-dist-fill { display:block; height:100%; border-radius:5px; } .pad-dist-c { width:3rem; text-align:right; font-weight:800; }
	/* detail modal */
	.pad-modalbg { position:fixed; inset:0; background:rgba(20,28,38,0.42); display:flex; align-items:center; justify-content:center; z-index:9000; } .pad-modal { background:var(--card); border-radius:14px; padding:1.1rem 1.25rem; width:min(40rem,94vw); box-shadow:0 12px 40px rgba(0,0,0,0.25); }
	.pad-modal-h { font-size:1rem; font-weight:800; display:flex; align-items:center; gap:0.5rem; } .pad-modal-h i { color:var(--brand); } .pad-modal-x { margin-left:auto; border:none; background:transparent; color:var(--mut); cursor:pointer; font-size:1rem; } .pad-modal-x:hover { color:var(--ink); } .pad-modal-sub { font-size:0.8rem; color:var(--mut); margin:0.3rem 0 0.9rem; }
	.pad-dt-colls { display:flex; flex-wrap:wrap; gap:0.35rem; margin:0 0 0.8rem; } .pad-dt-scroll { max-height:52vh; overflow:auto; } .pad-dt-grp { margin:0 0 0.7rem; } .pad-dt-grp-h { font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--sec); margin:0 0 0.3rem; } .pad-dt-items { display:flex; flex-wrap:wrap; gap:0.3rem 0.5rem; } .pad-dt-item { font-size:0.78rem; color:var(--ink); background:var(--bg2); border-radius:5px; padding:0.1rem 0.45rem; } .pad-dt-item b { color:var(--sec); font-weight:700; }
	.pad-modal-act { display:flex; justify-content:flex-end; gap:0.5rem; margin-top:1rem; } .pad-btn { border:none; background:var(--brand); color:#fff; font-size:0.84rem; font-weight:700; border-radius:8px; padding:0.5rem 0.95rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; text-decoration:none; } .pad-btn:hover { filter:brightness(1.05); } .pad-btn.ghost { background:transparent; color:var(--sec); border:1px solid var(--b2); }
</style>`;

module.exports = PhysicalAssetDashboardProvider;
module.exports.default_configuration = { ProviderIdentifier: 'PhysicalAssetDashboard' };

},{"./AssetDescriptor.js":1070,"pict-provider":845}],1072:[function(require,module,exports){
'use strict';

// SNBI data-item dictionary — code -> { label, units, help }, plus VALUES (coded-value -> human-readable meaning for
// the enumerated data items, e.g. Approach Alignment "F" = "Fair"). Labels are authoritative from the FHWA SNBI JSON
// Schema; units + help + value meanings are from the AASHTO SNBI March 2022 publication. Group prefixes: BID=Identification,
// BL=Location, BCL=Classification, BC=Condition, BG=Geometry, BLR=Load Rating, BAP=Appraisal, BIR=Inspection, BRH=Railings,
// BW=Work; collection items BE/BCS=Elements, BF/BH/BN/BRR=Features, BIE=Inspection events, BSP=Spans, BSB=Substructure, BPS/BEP=Posting.

const SNBI = {
	BAP01: { label: "Approach Roadway Alignment", units: null, help: "Operating-speed reduction from the bridge/approach alignment vs. the rest of the highway: G = good (no reduction), F = fair (noticeable), P = poor (substantial)." },
	BAP02: { label: "Overtopping Likelihood", units: null, help: "Likelihood the waterway overtops the bridge deck: 0 = never, 1 = remote (once per 100+ yr), 2 = very low, 3 = low, 4 = moderate, 5 = high, 6 = very high (every 2 yr or more)." },
	BAP03: { label: "Scour Vulnerability", units: null, help: "Scour appraisal result: 0 = not done; A = stable; B = stable via designed countermeasures; C/D = scour critical; E = not done (temp countermeasure); U = unknown foundations." },
	BAP04: { label: "Scour Plan of Action", units: null, help: "Scour plan-of-action status: 0 = not required; N = required but not implemented; Y = required and implemented." },
	BAP05: { label: "Seismic Vulnerability", units: null, help: "Seismic evaluation result: 0 = not evaluated; N = evaluation not required; A = meets criteria (no retrofit); B/C = full/partial retrofit in place; D = retrofit not yet in place." },
	BC01: { label: "Deck Condition Rating", units: null, help: "NBI component condition rating of the deck (top, underside, edges), 0-9 (9 = excellent, 5 = fair, 0 = failed); N = deck does not exist." },
	BC02: { label: "Superstructure Condition Rating", units: null, help: "NBI component condition rating of the superstructure and its primary load-carrying members, 0-9 (9 = excellent, 0 = failed); N = not applicable." },
	BC03: { label: "Substructure Condition Rating", units: null, help: "NBI component condition rating of the substructure (piers, abutments, piles, footings), 0-9 (9 = excellent, 0 = failed); N = not applicable." },
	BC04: { label: "Culvert Condition Rating", units: null, help: "NBI component condition rating of the culvert, 0-9 (9 = excellent, 5 = fair, 0 = failed); N = bridge is not a culvert." },
	BC05: { label: "Bridge Railings Condition Rating", units: null, help: "NBI component condition rating of the bridge railings, 0-9 (9 = excellent, 0 = failed); N = no bridge railings present." },
	BC06: { label: "Bridge Railings Transitions Condition Rating", units: null, help: "NBI condition rating of the transition from bridge railing to approach guardrail, 0-9 (9 = excellent, 0 = failed); N = no transitions present." },
	BC07: { label: "Bridge Bearings Condition Rating", units: null, help: "NBI component condition rating of the bridge bearings, 0-9 (9 = excellent, 0 = failed); N = bridge has no bearings." },
	BC08: { label: "Bridge Joints Condition Rating", units: null, help: "Condition rating of the bridge deck joints, 0-9 (9 = excellent, 5 = fair, 1 = failed/ineffective, 0 = failed/safety hazard); N = no deck joints." },
	BC09: { label: "Channel Condition Rating", units: null, help: "Condition rating of the channel at the bridge, 0-9 (9 = excellent, 5 = fair, 0 = failed); N = bridge does not cross over water." },
	BC10: { label: "Channel Protection Condition Rating", units: null, help: "Condition rating of channel protection devices/countermeasures, 0-9 (9 = excellent, 0 = failed); N = no water crossing or no devices exist." },
	BC11: { label: "Scour Condition Rating", units: null, help: "Condition rating for observed or measured scour, 0-9 (9 = no scour, 5 = moderate, 0 = bridge closed and beyond repair); N = bridge does not cross over water." },
	BC12: { label: "Bridge Condition Classification", units: null, help: "FHWA-calculated class from the lowest of the deck, superstructure, substructure and culvert ratings: G = Good (7-9), F = Fair (5-6), P = Poor (0-4)." },
	BC13: { label: "Lowest Condition Rating Code", units: null, help: "FHWA-calculated lowest condition rating code (0-9) among the deck, superstructure, substructure and culvert ratings." },
	BC14: { label: "NSTM Inspection Condition", units: null, help: "Condition rating of Non-Redundant Steel Tension Members (NSTM), 0-9 (9 = excellent, 0 = failed); reported only when an NSTM inspection is required." },
	BC15: { label: "Underwater Inspection Condition", units: null, help: "Condition rating of underwater substructure members from the underwater inspection, 0-9 (9 = excellent, 0 = failed); reported only when required." },
	BCL01: { label: "Owner", units: null, help: "Coded agency that owns the bridge, in a State/Federal/county/city/railroad/transit/private hierarchy (e.g. S01 = State DOT, L01 = county, T = transit, P = private, R = railroad)." },
	BCL02: { label: "Maintenance Responsibility", units: null, help: "Coded agency with primary maintenance responsibility for the bridge, using the same agency code list as Owner (B.CL.01)." },
	BCL03: { label: "Federal or Tribal Land Access", units: null, help: "Codes for Federal/Tribal land the bridge's highway leads to or crosses (N = not applicable; BIA, BLM, NPS, USACE, USBR, USFS, USFWS, X = other); pipe-separate multiples." },
	BCL04: { label: "Historical Significance", units: null, help: "Historic status code: 1 = on National Register; 2 = eligible; 3/4 = in a historic district; 5 = potentially eligible; 6 = State/local register; 7 = not determined; N = not eligible." },
	BCL05: { label: "Toll", units: null, help: "Toll status code: 1 = toll bridge (no FHWA agreement); 2 = toll bridge under FHWA agreement; 3/4 = carries a toll road (without/with agreement); N = not tolled." },
	BCL06: { label: "Emergency Evacuation Designation", units: null, help: "Whether the route carried on the bridge is a designated emergency evacuation route: Y = yes, N = no." },
	BCS01: { label: "Element Quantity Condition State One", units: null, help: "Element quantity in Condition State 1 (Good), to the nearest whole unit of measure; CS1-CS4 quantities together sum to the element total quantity." },
	BCS02: { label: "Element Quantity Condition State Two", units: null, help: "Element quantity in Condition State 2 (Fair), to the nearest whole unit of measure; CS1-CS4 quantities together sum to the element total quantity." },
	BCS03: { label: "Element Quantity Condition State Three", units: null, help: "Element quantity in Condition State 3 (Poor), to the nearest whole unit of measure; CS1-CS4 quantities together sum to the element total quantity." },
	BCS04: { label: "Element Quantity Condition State Four", units: null, help: "Element quantity in Condition State 4 (Severe), to the nearest whole unit of measure; CS1-CS4 quantities together sum to the element total quantity." },
	BE01: { label: "Element Number", units: null, help: "AASHTO MBEI element number (from SNBI Table 22) identifying each bridge element reported to FHWA, e.g. 12 = RC deck, 107 = steel girder, 510 = wearing surface." },
	BE02: { label: "Element Parent Number", units: null, help: "For a protective-system element (e.g. wearing surface or protective coating), the element number of the parent element it protects; omitted if none." },
	BE03: { label: "Element Total Quantity", units: null, help: "Total quantity of the element, to the nearest whole unit of measure (ft, sq ft, or each per the element); equals the sum of condition-state quantities CS1-CS4." },
	BEP01: { label: "Legal Load Configuration", units: null, help: "AASHTO legal load configuration evaluated: Type 3, 3S2, 3-3, SU4-SU7 trucks, NRL (notional rating load), or EV2/EV3 emergency vehicles." },
	BEP02: { label: "Legal Load Rating Factor", units: null, help: "Rating factor for the legal load configuration in B.EP.01 (dimensionless, truncated to two decimals)." },
	BEP03: { label: "Posting Type", units: null, help: "Type of load posting for configurations rating below 1.0: G=gross, A=single axle, D=tandem axle, T=truck, C=no commercial, S=speed, L=lanes, V=vehicles, X=other." },
	BEP04: { label: "Posting Value", units: "tons", help: "Weight limit shown on the posting sign, rounded down to the nearest U.S. ton; reported only for configurations rating below 1.0." },
	BF01: { label: "Feature Type", units: null, help: "Type of each feature above, below, or carried on the bridge (with sequential number): H=highway, R=railroad, P=pathway, W=waterway, F=flood relief, B=urban, D=dry terrain, X=other." },
	BF02: { label: "Feature Location", units: null, help: "Where the feature sits relative to the bridge: C=carried on bridge, A=above, B=below, T=top level, L=lower level (double-deck bridges)." },
	BF03: { label: "Feature Name", units: null, help: "The commonly known name(s) of the feature; multiple names are separated by pipe (|) delimiters, most common first." },
	BG01: { label: "NBIS Bridge Length", units: "feet", help: "NBIS bridge length in feet (to 0.1 ft), measured along the roadway centerline between undercopings of abutments or spring lines of arches." },
	BG02: { label: "Total Bridge Length", units: "feet", help: "Total bridge length in feet (to 0.1 ft), measured along the roadway centerline from back-to-back of backwalls or paving notch to paving notch at abutments." },
	BG03: { label: "Maximum Span Length", units: "feet", help: "Length of the longest span in feet (to 0.1 ft), measured centerline-of-bearing to centerline-of-bearing along the roadway centerline." },
	BG04: { label: "Minimum Span Length", units: "feet", help: "Length of the shortest span in feet (to 0.1 ft), measured centerline-of-bearing to centerline-of-bearing; equals the maximum span for single-span bridges." },
	BG05: { label: "Bridge Width Out-to-Out", units: "feet", help: "Minimum out-to-out bridge width in feet (to 0.1 ft), measured perpendicular to the roadway centerline (sum of all levels for double-deck bridges)." },
	BG06: { label: "Bridge Width Curb-to-Curb", units: "feet", help: "Usable roadway width in feet (to 0.1 ft): sum of the most restrictive curb-to-curb distances, excluding medians, sidewalks and inadequate shoulders." },
	BG07: { label: "Left Curb or Sidewalk Width", units: "feet", help: "Minimum left curb or sidewalk width in feet (to 0.1 ft), from face of bridge rail to face of curb; 0.0 when none or the curb does not extend past the rail." },
	BG08: { label: "Right Curb or Sidewalk Width", units: "feet", help: "Minimum right curb or sidewalk width in feet (to 0.1 ft), from face of bridge rail to face of curb; 0.0 when none or the curb does not extend past the rail." },
	BG09: { label: "Approach Roadway Width", units: "feet", help: "Minimum usable approach roadway width in feet (to 0.1 ft), measured curb-to-curb within 100 ft of the bridge, excluding medians and sidewalks." },
	BG10: { label: "Bridge Median", units: null, help: "Bridge median type: 0 = no median; 1 = open median; 2 = closed mountable median; 3 = closed non-mountable median." },
	BG11: { label: "Skew", units: "degrees", help: "Skew angle in whole degrees between a substructure unit centerline and the line perpendicular to the roadway centerline; 0 = no skew (report max if they vary)." },
	BG12: { label: "Curved Bridge", units: null, help: "Horizontal curvature: CU = curved girder(s); CP = piecewise straight girders; CK = kinked girder(s); N = not curved." },
	BG13: { label: "Maximum Bridge Height", units: "feet", help: "Maximum height in feet (to nearest foot) from top of deck to ground line or water surface elevation, whichever yields the larger value." },
	BG14: { label: "Sidehill Bridge", units: null, help: "Whether any portion of the bridge is a sidehill structure: Y = yes, N = no." },
	BG15: { label: "Irregular Deck Area", units: "square feet", help: "Actual total deck area in square feet (to 0.1 sq ft), reported only for bridges with irregular geometry obtained from plans or field measurement." },
	BG16: { label: "Calculated Deck Area", units: "square feet", help: "Deck area in square feet (to 0.1 sq ft) computed by FHWA as Total Bridge Length x Bridge Width Out-to-Out; not reported by the agency." },
	BH01: { label: "Functional Classification", units: null, help: "FHWA functional class of the highway: 1=Interstate, 2=Other Freeway/Expressway, 3=Other Principal Arterial, 4=Minor Arterial, 5=Major Collector, 6=Minor Collector, 7=Local." },
	BH02: { label: "Urban Code", units: null, help: "Census/HPMS urbanized-area code for the highway at the bridge; 99999=rural area under 5,000 population, 99998=small urban area 5,000-49,999." },
	BH03: { label: "NHS Designation", units: null, help: "National Highway System designation for the highway: Y=on the NHS, N=non-NHS." },
	BH04: { label: "National Highway Freight Network", units: null, help: "Freight network designation: 1=Primary Highway Freight System, 2=Interstate not on PHFS, 3=Critical Rural Freight Corridor, 4=Critical Urban Freight Corridor, N=not on NHFN." },
	BH05: { label: "STRAHNET Designation", units: null, help: "Strategic Highway Network designation: 1=STRAHNET route, 2=STRAHNET Connector route, N=not a STRAHNET route." },
	BH06: { label: "LRS Route ID", units: null, help: "State-defined LRS Route ID reported to HPMS to uniquely identify the route; N if no LRS Route ID has been assigned." },
	BH07: { label: "LRS Mile Point", units: "miles", help: "Location of the bridge along the LRS route, given as the mile point to the nearest thousandth of a mile." },
	BH08: { label: "Lanes On Highway", units: "lanes", help: "Number of traffic lanes on the highway feature (excludes sidewalks, bike paths, and railroad tracks)." },
	BH09: { label: "Annual Average Daily Traffic", units: "vehicles per day", help: "Annual average daily traffic (all vehicles, including trucks) from the most recent count for the highway feature." },
	BH10: { label: "Annual Average Daily Truck Traffic", units: "trucks per day", help: "Annual average daily truck traffic (vehicle classes 4-13) from the most recent count for the highway feature." },
	BH11: { label: "Year of Annual Average Daily Traffic", units: null, help: "The 4-digit calendar year of the traffic count reported in Annual Average Daily Traffic (B.H.09)." },
	BH12: { label: "Highway Maximum Usable Vertical Clearance", units: "feet", help: "Maximum usable vertical clearance for a 10-ft-wide vehicle over the highway, to the nearest tenth of a foot; 99.9 = 100 ft or greater / no restriction." },
	BH13: { label: "Highway Minimum Vertical Clearance", units: "feet", help: "Minimum vertical clearance over the highway feature, to the nearest tenth of a foot; 99.9 = 100 ft or greater / no restriction." },
	BH14: { label: "Highway Minimum Horizontal Clearance, Left", units: "feet", help: "Minimum horizontal clearance on the left for a highway passing below the bridge, to the nearest tenth of a foot; 0 = undivided two-way highway, 99.9 = 100 ft or greater." },
	BH15: { label: "Highway Minimum Horizontal Clearance, Right", units: "feet", help: "Minimum horizontal clearance on the right for a highway passing below the bridge, to the nearest tenth of a foot; 99.9 = 100 ft or greater." },
	BH16: { label: "Highway Maximum Usable Surface Width", units: "feet", help: "Maximum usable surface width of the highway carried on or passing below the bridge, to the nearest tenth of a foot; 99.9 = 100 ft or greater." },
	BH17: { label: "Bypass Detour Length", units: "miles", help: "Extra travel distance (nearest mile) to bypass the bridge; 0 = ground-level bypass available, 999 = no detour exists." },
	BH18: { label: "Crossing Bridge Number", units: null, help: "Bridge number(s) of the bridge directly above or below this one at a multi-level interchange; not reported when no such bridge exists." },
	BID01: { label: "Bridge Number", units: null, help: "Unique bridge number assigned per agency policy for each bridge meeting the NBIS bridge definition; once assigned it is not changed." },
	BID02: { label: "Bridge Name", units: null, help: "The commonly known name(s) for the bridge, most common first; report multiple names separated by a pipe (|) delimiter." },
	BID03: { label: "Previous Bridge Number", units: null, help: "The bridge number previously associated with this bridge before it was replaced or renumbered; report 0 if there is no previous bridge number." },
	BIE01: { label: "Inspection Type", units: null, help: "Type of inspection or scour monitoring performed: 1 Initial, 2 Routine, 3 Underwater, 4 NSTM, 5 Damage, 6 In-Depth, 7 Special, 8 Service, 9 Scour Monitoring." },
	BIE02: { label: "Inspection Begin Date", units: null, help: "Date the inspection began (YYYYMMDD); for multi-day inspections, the first day field work started." },
	BIE03: { label: "Inspection Completion Date", units: null, help: "Date the inspection was completed (YYYYMMDD); for single-day inspections, the same as the begin date." },
	BIE04: { label: "Nationally Certified Bridge Inspector", units: null, help: "Unique agency-assigned code identifying the Nationally Certified Bridge Inspector (team leader) responsible for the inspection type performed." },
	BIE05: { label: "Inspection Interval", units: "months", help: "Planned number of months until the next scheduled inspection of this type; report 0 for damage, scour-monitoring, or special inspections with no defined interval." },
	BIE06: { label: "Inspection Due Date", units: null, help: "Inspection due date (YYYYMMDD), calculated by FHWA as the completion date plus the inspection interval; only for types that have an interval." },
	BIE07: { label: "Risk-Based Inspection Interval Method", units: null, help: "Risk-based method used to set the inspection interval: N Not applicable; 1 Method 1 (3 risk levels, up to 12/24/48 mo); 2 Method 2 (4 risk levels, up to 12/24/48/72 mo)." },
	BIE08: { label: "Inspection Quality Control Date", units: null, help: "Date an independent quality-control (QC) review of the inspection was completed (YYYYMMDD); left blank if no QC review was performed." },
	BIE09: { label: "Inspection Quality Assurance Date", units: null, help: "Date an independent quality-assurance (QA) review of the inspection was completed (YYYYMMDD); left blank if no QA review was performed." },
	BIE10: { label: "Inspection Data Update Date", units: null, help: "Date the completed NBI inspection data were entered or updated in the agency's bridge inventory (YYYYMMDD)." },
	BIE11: { label: "Inspection Note", units: null, help: "Brief free-text note describing the members or features inspected when only limited portions of the bridge were inspected (up to 300 characters)." },
	BIE12: { label: "Inspection Equipment", units: null, help: "One or more pipe-delimited codes for access (A01-A14/AX/AN) and inspection/NDE (I01-I15/IX/IN) equipment used beyond standard equipment for the inspection." },
	BIR01: { label: "NSTM Inspection Required", units: null, help: "Flag: does any part of the bridge require an NSTM (fracture-critical) inspection? N = not required; Y = required; I = not required, internally redundant; S = not required, system redundant." },
	BIR02: { label: "Fatigue Details", units: null, help: "Flag: does the bridge have AASHTO fatigue category E or E' details (details most prone to fatigue)? N = no E/E' details; Y = E/E' details present." },
	BIR03: { label: "Underwater Inspection Required", units: null, help: "Flag: is an underwater inspection required under normal flow (substructure not reachable to the mudline by wading or probing)? N = not required; Y = required." },
	BIR04: { label: "Complex Feature", units: null, help: "Flag: does the bridge have a complex feature as defined by the NBIS and agency policy? N = no complex feature; Y = has complex feature." },
	BL01: { label: "State Code", units: null, help: "FIPS numeric State code where the bridge is located (e.g., 1 = Alabama, 6 = California, 36 = New York, 48 = Texas)." },
	BL02: { label: "County Code", units: null, help: "FIPS numeric code for the county, parish, or borough in which the bridge is located." },
	BL03: { label: "Place Code", units: null, help: "FIPS place code for the city, town, township, village, or census-designated place where the bridge is located; report 0 if none." },
	BL04: { label: "Highway Agency District", units: null, help: "The State transportation department's district or region code where the bridge is located." },
	BL05: { label: "Latitude", units: "degrees", help: "Latitude of the bridge in decimal degrees (negative for the southern hemisphere), consistent with NAD 83 LRS data." },
	BL06: { label: "Longitude", units: "degrees", help: "Longitude of the bridge in decimal degrees (negative for the western hemisphere), consistent with NAD 83 LRS data." },
	BL07: { label: "Border Bridge Number", units: null, help: "The neighboring State's bridge number for a border bridge; report N if the bridge crosses no State/country border, or 0 if the bordering country has no number." },
	BL08: { label: "Border Bridge State or Country Code", units: null, help: "Neighboring State code (per B.L.01) for a border bridge, or CA for Canada / MX for Mexico; not reported when the bridge crosses no border." },
	BL09: { label: "Border Bridge Inspection Responsibility", units: null, help: "Border-bridge inspection responsibility: 0 = none, 1 = shared with bordering State/country, 2 = full; not reported when the bridge crosses no border." },
	BL10: { label: "Border Bridge Designated Lead State", units: null, help: "State code (per B.L.01) of the State designated by agreement to report the full record for a border bridge; not reported when the bridge crosses no border." },
	BL11: { label: "Bridge Location", units: null, help: "Narrative description of the bridge's location, preferably its distance from a distinguishable feature along the route the bridge carries." },
	BL12: { label: "Metropolitan Planning Organization", units: null, help: "Name(s) of the Metropolitan Planning Organization(s) the bridge is located in; report multiple separated by a pipe (|), or N if not in an MPO." },
	BLR01: { label: "Designed Load", units: null, help: "Coded live load the bridge was designed for: H10/H15/H20, HS15/HS20/HS20M/HS20Plus, HL93/HL93Plus, RR=railroad, U=unknown, X=other." },
	BLR02: { label: "Designed Method", units: null, help: "Method the bridge was designed by: ASD=allowable stress, LFD=load factor, LRFD=load & resistance factor, U=unknown, X=other." },
	BLR03: { label: "Load Rating Date", units: null, help: "Date (YYYYMMDD) of the most recent load rating calculation or reevaluation; not reported if no rating has been performed." },
	BLR04: { label: "Load Rating Method", units: null, help: "Method used to compute the load rating: LFR, ASR, LRFR, LT=load testing, AR=assigned, EJ=engineering judgment, N=no rating performed." },
	BLR05: { label: "Inventory Load Rating Factor", units: null, help: "Inventory-level load rating factor (dimensionless, to two decimals) for HS-20 or HL-93 loading; not reported if no rating performed." },
	BLR06: { label: "Operating Load Rating Factor", units: null, help: "Operating-level load rating factor (dimensionless, to two decimals) for HS-20 or HL-93 loading; not reported if no rating performed." },
	BLR07: { label: "Controlling Legal Load Rating Factor", units: null, help: "Lowest (controlling) rating factor for AASHTO and State legal loads (dimensionless, to two decimals); not reported if no rating performed." },
	BLR08: { label: "Routine Permit Loads", units: null, help: "Whether the bridge carries routine permit loads: A=all carried, B=some restricted, C=none carried/restricted, N=agency issues no routine permits." },
	BN01: { label: "Navigable Waterway", units: null, help: "Whether the waterway feature is navigable waters of the U.S. under Coast Guard jurisdiction: Y = navigable, N = not navigable, U = undetermined." },
	BN02: { label: "Navigation Minimum Vertical Clearance", units: "feet", help: "Minimum vertical clearance over the designated navigation channel, in feet (bridge in closed position for movable spans); reported only when the waterway is navigable." },
	BN03: { label: "Movable Bridge Maximum Navigation Vertical Clearance", units: "feet", help: "For movable bridges, the maximum vertical clearance over the navigation channel in the open position, in feet; report 999.9 for unlimited clearance." },
	BN04: { label: "Navigation Channel Width", units: "feet", help: "Width of the designated navigation channel, in feet (most restrictive if multiple channels exist)." },
	BN05: { label: "Navigation Channel Minimum Horizontal Clearance", units: "feet", help: "Minimum horizontal distance from the navigation channel edge to the nearest substructure, in feet; 0 = substructures bound the channel, 9999.9 = no substructure in the waterway." },
	BN06: { label: "Substructure Navigation Protection", units: null, help: "Presence and adequacy of vessel-collision protection: 0-1 = not required, 2 = system in place and functioning, 3 = system in place but impaired, 4-5 = reevaluation recommended." },
	BPS01: { label: "Load Posting Status", units: null, help: "2-letter posting status: prefix P/T/S = permanent/temporary/supported; N=new, O=open, A=needs action, P=weight posted, R=other restriction, D=needs reduction, M=signs missing, C=closed." },
	BPS02: { label: "Posting Status Change Date", units: null, help: "Date (YYYYMMDD) the bridge entered the load posting status reported in B.PS.01." },
	BRH01: { label: "Bridge Railings", units: null, help: "Crash-test rating code for the bridge's railings; roadside-hardware codes: N=not required, 0=required but absent, I=untested/substandard, MYY/3501-06/etc.=crash-tested by test level 1-6." },
	BRH02: { label: "Transitions", units: null, help: "Crash-test rating code for the approach-railing-to-bridge-railing transitions; codes: N=not required, 0=required but absent, I=untested/substandard, crash-test codes by test level 1-6." },
	BRR01: { label: "Railroad Service Type", units: null, help: "Rail service on the railroad feature: F = freight, FE = freight electrified, P = passenger, PE = passenger electrified, M = multiple (non-electrified), ME = multiple electrified, I = inactive." },
	BRR02: { label: "Railroad Minimum Vertical Clearance", units: "feet", help: "Minimum vertical clearance from top of rail to the lowest bridge restriction, in feet; report 99.9 when 100 feet or greater. Reported only for railroads below the bridge." },
	BRR03: { label: "Railroad Minimum Horizontal Offset", units: "feet", help: "Minimum horizontal distance from the railroad track centerline to the nearest substructure unit or steep (>1:3) slope toe, in feet." },
	BSB01: { label: "Substructure Configuration Designation", units: null, help: "Designates each unique substructure configuration: A## = abutment, P## = pier or bent, W## = widening (## = sequential number)." },
	BSB02: { label: "Number of Substructure Units", units: "units", help: "Number of substructure units of similar material, design, and foundation type reported in this configuration." },
	BSB03: { label: "Substructure Material", units: null, help: "Principal substructure material code: 0=none, A=aluminum, C=concrete, E=reinforced soil, F=FRP, I=iron, M=masonry, P=plastic, S=steel, T=timber, X=other." },
	BSB04: { label: "Substructure Type", units: null, help: "Substructure design-type code: 0=none, A##=abutment types, B##=bent types, P##=pier types, U=unknown, X=other." },
	BSB05: { label: "Substructure Protective System", units: null, help: "Substructure protective-system code: 0=none, A=admixture, C=coating, E=encasement, P=patina, S=sacrificial cathodic, T=treated timber, X=other." },
	BSB06: { label: "Foundation Type", units: null, help: "Foundation type code: E=reinforced soil, F=footing, P=pile, S=drilled shaft or caisson, U=unknown, X=other." },
	BSB07: { label: "Foundation Protective System", units: null, help: "Foundation protective-system code: 0=none, A=admixture, C=coating, E=encasement, P=patina, S=sacrificial cathodic, T=treated timber, U=unknown, X=other." },
	BSP01: { label: "Span Configuration Designation", units: null, help: "Designates each unique span configuration: M## = main, A## = approach, C## = culvert, V## = culvert extension, W## = widening (## = sequential number)." },
	BSP02: { label: "Number of Spans", units: "spans", help: "Number of spans in the designated span configuration (report the maximum if the number of barrels or spans varies)." },
	BSP03: { label: "Number of Beam Lines", units: "beam lines", help: "Number of principal beam lines (main longitudinal load-carrying members) in the span; report 1 for slab/frame types and 0 for pipe types." },
	BSP04: { label: "Span Material", units: null, help: "Principal span material code: A=aluminum, C=concrete, F=FRP composite, I=iron, M=masonry, P=plastic, S=steel, T=timber, X=other." },
	BSP05: { label: "Span Continuity", units: null, help: "Span continuity code 1-7: 1=simple/single span, 2=continuous, 3=continuous for live loads only, 4=cantilever, 5=cantilever with pin and hanger, 6=frame, 7=buried." },
	BSP06: { label: "Span Type", units: null, help: "Span type code: A=arch, B=box girder/beam, F=frame, G=girder/beam, L=cable, M=movable, P=pipe, S=slab, T=truss, X=other." },
	BSP07: { label: "Span Protective System", units: null, help: "Span protective-system code: 0=none, A=admixture, C=coating, E=encasement, M=membrane, P=weathering-steel patina, S=sacrificial cathodic, T=treated timber, U=unknown, X=other." },
	BSP08: { label: "Deck Interaction", units: null, help: "Deck-to-superstructure interaction code: CS=composite shored, CU=composite unshored, IM=integral or monolithic, NC=non-composite." },
	BSP09: { label: "Deck Material and Type", units: null, help: "Predominant deck material/type code: 0=none, A=aluminum, C=concrete, F=FRP composite, S=steel, T=timber, X=other." },
	BSP10: { label: "Wearing Surface", units: null, help: "Predominant deck wearing-surface code: 0=none, B=bituminous/asphalt, C=concrete, E=earth, P=polymer, S=steel, T=timber planks, X=other." },
	BSP11: { label: "Deck Protective System", units: null, help: "Deck protective-system code: 0=none, A=admixture, C=coating, M=membrane, P=weathering-steel patina, X=other." },
	BSP12: { label: "Deck Reinforcing Protective System", units: null, help: "Deck reinforcing protective-system code (concrete decks only): 0=none, C=coating, R=protected reinforcing type, S=sacrificial cathodic, X=other." },
	BSP13: { label: "Deck Stay-In-Place Forms", units: null, help: "Deck stay-in-place form code: 0=none, C01=reinforced concrete, C02=prestressed concrete, F01=FRP composite, M01=metal, T01=timber, X=other." },
	BW01: { label: "Year Built", units: null, help: "Calendar year original construction finished and the bridge could carry traffic (for phased construction, the year the first phase opened); best estimate if unknown." },
	BW02: { label: "Year Work Performed", units: null, help: "Calendar year work was completed on the bridge; part of the Work Data Set, reported for every year (many per bridge) whether or not work actually occurred." },
	BW03: { label: "Work Performed", units: null, help: "Codes for all work completed on the bridge that year - replacement, improvement, rehabilitation, or preservation - pipe-delimited; report 0 when no reportable work was done." },
	Elements: { label: "Elements", units: null, help: "AASHTO MBEI bridge elements with their quantities and condition-state distributions (BE / BCS codes)." },
	Features: { label: "Features Intersected", units: null, help: "The features the bridge intersects — highways, waterways, railroads and their routes (BF / BH / BN / BRR codes)." },
	Inspections: { label: "Inspection Events", units: null, help: "Inspection and scour-monitoring events recorded for the bridge (BIE codes)." },
	PostingEvaluations: { label: "Posting Evaluations", units: null, help: "Load-posting evaluations and the ratings that drive posting decisions (BEP codes)." },
	PostingStatuses: { label: "Posting Statuses", units: null, help: "Load-posting status of the bridge over time (BPS codes)." },
	Routes: { label: "Routes", units: null, help: "Routes Data Set (SNBI Subsection 4.2): the route items (designation, number, direction, type, service type) identifying each route carried on a highway feature of the bridge." },
	SpanSets: { label: "Span Sets", units: null, help: "Sets of spans grouped by shared configuration — material, design, protective systems (BSP codes)." },
	SubstructureSets: { label: "Substructure Sets", units: null, help: "Sets of substructure units grouped by shared configuration — material, design, protection (BSB codes)." },
	Works: { label: "Work History", units: null, help: "Planned or completed work on the bridge — projects, work types and dates (BW codes)." },
};

// Coded value -> human-readable meaning, per enumerated SNBI code. Numeric/text codes are absent (their value is shown as-is + units).
const VALUES = {
	BAP01: { "G": "Good (no speed reduction)", "F": "Fair (noticeable reduction)", "P": "Poor (substantial reduction)" },
	BAP02: { "0": "Never", "1": "Remote (100+ yr)", "2": "Very low (51-99 yr)", "3": "Low (26-50 yr)", "4": "Moderate (11-25 yr)", "5": "High (3-10 yr)", "6": "Very high (every 2 yr or more)" },
	BAP03: { "0": "Appraisal not completed", "A": "Stable for scour", "B": "Stable via countermeasures", "C": "Scour critical (temporary countermeasure)", "D": "Scour critical", "E": "Not completed (temporary countermeasure)", "U": "Unknown foundations" },
	BAP04: { "0": "Not required", "N": "Required, not implemented", "Y": "Required and implemented" },
	BAP05: { "0": "Not evaluated", "N": "Evaluation not required", "A": "Meets criteria (no retrofit)", "B": "Full retrofit in place", "C": "Partial retrofit in place", "D": "Retrofit not in place" },
	BC01: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no deck)" },
	BC02: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable" },
	BC03: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable" },
	BC04: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (not a culvert)" },
	BC05: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no railings)" },
	BC06: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no transitions)" },
	BC07: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no bearings)" },
	BC08: { "0": "Failed (safety hazard)", "1": "Imminent Failure (ineffective)", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no joints)" },
	BC09: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no water crossing)" },
	BC10: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable (no devices)" },
	BC11: { "0": "Failed (closed)", "1": "Imminent Failure (closed)", "2": "Critical scour", "3": "Serious scour", "4": "Major scour (affected)", "5": "Moderate scour", "6": "Minor to moderate scour", "7": "Minor scour", "8": "Insignificant scour", "9": "No scour", "N": "Not Applicable (no water crossing)" },
	BC12: { "G": "Good (ratings 7-9)", "F": "Fair (ratings 5-6)", "P": "Poor (ratings 0-4)" },
	BC13: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent" },
	BC14: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable" },
	BC15: { "0": "Failed", "1": "Imminent Failure", "2": "Critical", "3": "Serious", "4": "Poor", "5": "Fair", "6": "Satisfactory", "7": "Good", "8": "Very Good", "9": "Excellent", "N": "Not Applicable" },
	BCL01: { "S01": "State DOT", "S02": "State park/forest agency", "S03": "State toll authority", "SX": "Other state agency", "L01": "County highway agency", "L02": "Town/township agency", "L03": "City/municipal agency", "L04": "Local park/forest agency", "L05": "Local toll authority", "LX": "Other local agency", "F01": "Agriculture Research Service", "F02": "Dept. of Energy", "F03": "General Services Admin.", "F04": "NASA", "F05": "Smithsonian (National Zoo)", "F06": "Tennessee Valley Authority", "F07": "Veterans Affairs", "F08": "FEMA", "F09": "Int'l Boundary & Water Comm.", "FX": "Other federal agency", "FL01": "Bureau of Indian Affairs", "FL02": "Bureau of Land Management", "FL03": "Bureau of Reclamation", "FL04": "Fish & Wildlife Service", "FL05": "National Park Service", "FL06": "Army Corps of Engineers", "FL07": "U.S. Forest Service", "FL0X": "Other Federal Lands agency", "I": "Indian Tribal Government", "D01": "Air Force", "D02": "Army", "D03": "Navy/Marines", "D04": "Pentagon", "D05": "National Security Agency", "DX": "Other Dept. of Defense", "T": "Transit agency", "P": "Private", "R": "Railroad", "U": "Unknown", "X": "Other" },
	BCL02: { "S01": "State DOT", "S02": "State park/forest agency", "S03": "State toll authority", "SX": "Other state agency", "L01": "County highway agency", "L02": "Town/township agency", "L03": "City/municipal agency", "L04": "Local park/forest agency", "L05": "Local toll authority", "LX": "Other local agency", "F01": "Agriculture Research Service", "F02": "Dept. of Energy", "F03": "General Services Admin.", "F04": "NASA", "F05": "Smithsonian (National Zoo)", "F06": "Tennessee Valley Authority", "F07": "Veterans Affairs", "F08": "FEMA", "F09": "Int'l Boundary & Water Comm.", "FX": "Other federal agency", "FL01": "Bureau of Indian Affairs", "FL02": "Bureau of Land Management", "FL03": "Bureau of Reclamation", "FL04": "Fish & Wildlife Service", "FL05": "National Park Service", "FL06": "Army Corps of Engineers", "FL07": "U.S. Forest Service", "FL0X": "Other Federal Lands agency", "I": "Indian Tribal Government", "D01": "Air Force", "D02": "Army", "D03": "Navy/Marines", "D04": "Pentagon", "D05": "National Security Agency", "DX": "Other Dept. of Defense", "T": "Transit agency", "P": "Private", "R": "Railroad", "U": "Unknown", "X": "Other" },
	BCL03: { "N": "Not applicable", "BIA": "Tribal Gov't / Bureau of Indian Affairs", "BLM": "Bureau of Land Management", "NPS": "National Park Service", "USACE": "Army Corps of Engineers", "USBR": "Bureau of Reclamation", "USFS": "U.S. Forest Service", "USFWS": "Fish & Wildlife Service", "X": "Other" },
	BCL04: { "1": "On National Register", "2": "Eligible for National Register", "3": "In historic district (contributing)", "4": "In historic district (non-contributing)", "5": "Potentially eligible (unevaluated)", "6": "State/local register only", "7": "Not determined", "N": "Not eligible" },
	BCL05: { "1": "Toll bridge (no FHWA agreement)", "2": "Toll bridge (FHWA agreement)", "3": "Carries toll road (no FHWA agreement)", "4": "Carries toll road (FHWA agreement)", "N": "Not tolled" },
	BCL06: { "Y": "Evacuation route", "N": "Not an evacuation route" },
	BEP01: { "3": "Type 3", "3S2": "Type 3S2", "3-3": "Type 3-3", "SU4": "SU4 truck", "SU5": "SU5 truck", "SU6": "SU6 truck", "SU7": "SU7 truck", "NRL": "Notional Rating Load", "EV2": "EV2 emergency vehicle", "EV3": "EV3 emergency vehicle" },
	BEP03: { "G": "Gross load", "A": "Single axle load", "D": "Tandem axle load", "T": "Truck load", "C": "No commercial vehicles", "S": "Speed reduction", "L": "Lanes restricted", "V": "Vehicles restricted", "X": "Other" },
	BF01: { "H": "Highway", "R": "Railroad", "P": "Pathway", "W": "Waterway", "F": "Flood relief for waterway", "B": "Urban feature", "D": "Dry terrain / side slope", "X": "Other" },
	BF02: { "C": "Carried on bridge", "A": "Above bridge", "B": "Below bridge", "T": "Top level", "L": "Lower level" },
	BG10: { "0": "No median", "1": "Open median", "2": "Closed median (mountable)", "3": "Closed median (non-mountable)" },
	BG12: { "CU": "Curved girder(s)", "CP": "Piecewise straight girders", "CK": "Kinked girder(s)", "N": "Not curved" },
	BG14: { "Y": "Sidehill bridge", "N": "Not a sidehill bridge" },
	BH01: { "1": "Interstate", "2": "Other Freeway/Expressway", "3": "Other Principal Arterial", "4": "Minor Arterial", "5": "Major Collector", "6": "Minor Collector", "7": "Local" },
	BH03: { "Y": "On the NHS", "N": "Non-NHS" },
	BH04: { "1": "Primary Highway Freight System", "2": "Interstate not on PHFS", "3": "Critical Rural Freight Corridor", "4": "Critical Urban Freight Corridor", "N": "Not on NHFN" },
	BH05: { "1": "STRAHNET route", "2": "STRAHNET Connector", "N": "Not a STRAHNET route" },
	BIE01: { "1": "Initial", "2": "Routine", "3": "Underwater", "4": "NSTM", "5": "Damage", "6": "In-Depth", "7": "Special", "8": "Service", "9": "Scour Monitoring" },
	BIE07: { "1": "Method 1 (3 risk levels)", "2": "Method 2 (4 risk levels)", "N": "Not applicable" },
	BIE12: { "AN": "No access equipment used", "A01": "Ladder", "A02": "Bucket lift vehicle", "A03": "Under-bridge inspection vehicle", "A04": "Rigging", "A05": "Waders", "A06": "Boat", "A07": "Snorkel", "A08": "SCUBA", "A09": "Surface supplied air", "A10": "Remotely operated vehicle (ROV)", "A11": "Video pole", "A12": "Borescope", "A13": "Unmanned aerial system (UAS)", "A14": "Service traveler", "AX": "Access - other", "IN": "No inspection equipment used", "I01": "Ultrasonic", "I02": "Ground-penetrating radar", "I03": "Infrared thermography", "I04": "Radiographic testing", "I05": "Impact echo", "I06": "Electromagnetic methods", "I07": "Rebound & penetration", "I08": "Acoustic emissions", "I09": "Dye penetrant", "I10": "Magnetic particle", "I11": "Eddy current", "I12": "Boring or drilling", "I13": "Underwater imaging", "I14": "Depth finder / fathometer", "I15": "Stress wave timer", "IX": "Inspection - other" },
	BIR01: { "N": "Not required", "Y": "Required", "I": "Not required (internal redundancy)", "S": "Not required (system redundancy)" },
	BIR02: { "N": "No E/E' details", "Y": "E/E' details present" },
	BIR03: { "N": "Not required", "Y": "Required" },
	BIR04: { "N": "No complex feature", "Y": "Has complex feature" },
	BL09: { "0": "No responsibility", "1": "Shared (with bordering State/country)", "2": "Full responsibility" },
	BLR01: { "H10": "H-10", "H15": "H-15", "H20": "H-20", "HS15": "HS-15", "HS20": "HS-20", "HS20M": "HS-20 and Military", "HS20Plus": "Greater than HS-20", "HL93": "HL-93", "HL93Plus": "Greater than HL-93", "RR": "Railroad", "U": "Unknown", "X": "Other" },
	BLR02: { "ASD": "Allowable Stress Design", "LFD": "Load Factor Design", "LRFD": "Load & Resistance Factor Design", "U": "Unknown", "X": "Other" },
	BLR04: { "LFR": "Load Factor Rating", "ASR": "Allowable Stress Rating", "LRFR": "Load & Resistance Factor Rating", "LT": "Load Testing", "AR": "Assigned Rating", "EJ": "Engineering Judgment", "N": "No Rating Performed" },
	BLR08: { "A": "All carried (none restricted)", "B": "Some restricted", "C": "None carried (all restricted)", "N": "None (agency issues no routine permits)" },
	BN01: { "Y": "Navigable waters", "N": "Not navigable waters", "U": "Undetermined" },
	BN06: { "0": "Not required (adequate capacity)", "1": "Not required (low impact probability)", "2": "System in place, functioning", "3": "System in place, impaired", "4": "System in place, reevaluation suggested", "5": "No system, reevaluation recommended" },
	BPS01: { "N": "New - not yet open", "PO": "Open (permanent)", "PA": "Needs action (permanent)", "PP": "Weight posted (permanent)", "PR": "Other restriction (permanent)", "PD": "Needs reduction (permanent)", "PM": "Signs missing (permanent)", "TO": "Open (temporary bridge)", "TA": "Needs action (temporary)", "TP": "Weight posted (temporary)", "TR": "Other restriction (temporary)", "TD": "Needs reduction (temporary)", "TM": "Signs missing (temporary)", "SO": "Open (supported)", "SA": "Needs action (supported)", "SP": "Weight posted (supported)", "SR": "Other restriction (supported)", "SD": "Needs reduction (supported)", "SM": "Signs missing (supported)", "C": "Closed" },
	BRH01: { "0": "None (required but absent)", "891": "1989 AASHTO Guide Spec, TL-1", "892": "1989 AASHTO Guide Spec, TL-2", "893": "1989 AASHTO Guide Spec, TL-3", "2301": "NCHRP 230, TL-1", "2302": "NCHRP 230, TL-2", "2303": "NCHRP 230, TL-3", "2391": "NCHRP 239, TL-1", "2392": "NCHRP 239, TL-2", "2393": "NCHRP 239, TL-3", "3501": "NCHRP 350, TL-1", "3502": "NCHRP 350, TL-2", "3503": "NCHRP 350, TL-3", "3504": "NCHRP 350, TL-4", "3505": "NCHRP 350, TL-5", "3506": "NCHRP 350, TL-6", "N": "Not applicable (not required)", "MYY1": "MASH crash-tested, TL-1 (YY=year)", "MYY2": "MASH crash-tested, TL-2 (YY=year)", "MYY3": "MASH crash-tested, TL-3 (YY=year)", "MYY4": "MASH crash-tested, TL-4 (YY=year)", "MYY5": "MASH crash-tested, TL-5 (YY=year)", "MYY6": "MASH crash-tested, TL-6 (YY=year)", "X": "Crash-tested, other criteria", "AYY": "Untested; meets AASHTO Std Specs (YY=year)", "SYY": "Untested; meets agency standard (YY=year)", "I": "Untested, substandard" },
	BRH02: { "0": "None (required but absent)", "891": "1989 AASHTO Guide Spec, TL-1", "892": "1989 AASHTO Guide Spec, TL-2", "893": "1989 AASHTO Guide Spec, TL-3", "2301": "NCHRP 230, TL-1", "2302": "NCHRP 230, TL-2", "2303": "NCHRP 230, TL-3", "2391": "NCHRP 239, TL-1", "2392": "NCHRP 239, TL-2", "2393": "NCHRP 239, TL-3", "3501": "NCHRP 350, TL-1", "3502": "NCHRP 350, TL-2", "3503": "NCHRP 350, TL-3", "3504": "NCHRP 350, TL-4", "3505": "NCHRP 350, TL-5", "3506": "NCHRP 350, TL-6", "N": "Not applicable (not required)", "MYY1": "MASH crash-tested, TL-1 (YY=year)", "MYY2": "MASH crash-tested, TL-2 (YY=year)", "MYY3": "MASH crash-tested, TL-3 (YY=year)", "MYY4": "MASH crash-tested, TL-4 (YY=year)", "MYY5": "MASH crash-tested, TL-5 (YY=year)", "MYY6": "MASH crash-tested, TL-6 (YY=year)", "X": "Crash-tested, other criteria", "AYY": "Untested; meets AASHTO Std Specs (YY=year)", "SYY": "Untested; meets agency standard (YY=year)", "I": "Untested, substandard" },
	BRR01: { "F": "Freight", "FE": "Freight - electrified", "P": "Passenger", "PE": "Passenger - electrified", "M": "Multiple - not electrified", "ME": "Multiple - electrified", "I": "Inactive" },
	BSB01: { "A": "Abutment", "P": "Pier or bent", "W": "Widening" },
	BSB03: { "0": "None", "A01": "Aluminum", "C01": "Reinforced concrete, cast-in-place", "C02": "Reinforced concrete, precast", "C03": "Prestressed, pre-tensioned", "C04": "Prestressed, CIP post-tensioned", "C05": "Prestressed, precast post-tensioned", "CX": "Concrete - other", "E01": "Earth - reinforced soil", "F01": "FRP - aramid fiber", "F02": "FRP - carbon fiber", "F03": "FRP - glass fiber", "FX": "FRP - other", "I01": "Iron - wrought", "I02": "Iron - cast", "M01": "Masonry - block", "M02": "Masonry - stone", "P01": "Plastic - polyethylene", "PX": "Plastic - other", "S01": "Steel - rolled shapes", "S02": "Steel - welded shapes", "S03": "Steel - bolted shapes", "S04": "Steel - riveted shapes", "S05": "Steel - bolted & riveted", "S06": "Steel - pipe", "SX": "Steel - other", "T01": "Timber - glue laminated", "T02": "Timber - nail laminated", "T03": "Timber - solid sawn", "T04": "Timber - stress laminated", "TX": "Timber - other", "X": "Other" },
	BSB04: { "0": "None", "A01": "Abutment - cantilever/wall", "A02": "Abutment - stub", "A03": "Abutment - open/spill-through", "A04": "Abutment - integral", "A05": "Abutment - semi-integral", "A06": "Abutment - gravity", "A07": "Abutment - counterfort", "A08": "Abutment - pile bent w/ lagging", "A09": "Abutment - crib", "A10": "Abutment - cellular/vaulted", "A11": "Abutment - reinforced soil", "A12": "Abutment - footing only", "AX": "Abutment - other", "B01": "Bent - column or open", "B02": "Bent - column with web wall", "B03": "Bent - pile", "B04": "Bent - straddle or c-shaped", "BX": "Bent - other", "P01": "Pier - wall", "P02": "Pier - single column", "P03": "Pier - multiple column", "P04": "Pier - multi column w/ web wall", "P05": "Pier - straddle or c-shaped", "P06": "Pier - movable bridge", "P07": "Pier - tower", "P08": "Pier - footing only", "PX": "Pier - other", "U": "Unknown", "X": "Other" },
	BSB05: { "0": "None", "A01": "Admixture - internally sealed", "A02": "Admixture - low permeability", "A03": "Admixture - polymer impregnated", "A04": "Admixture - corrosion inhibitor", "A05": "Admixture - ASR inhibitor", "AX": "Admixture - other", "C01": "Coating - paint", "C02": "Coating - sealer", "C03": "Coating - galvanizing/metalizing", "CX": "Coating - other", "E01": "Encasement - concrete", "EX": "Encasement - other", "P01": "Patina - weathering steel", "S01": "Sacrificial cathodic - passive", "S02": "Sacrificial cathodic - active", "SX": "Sacrificial - other", "T01": "Treated - timber preservative", "X": "Other" },
	BSB06: { "E01": "Earth - reinforced soil", "F01": "Footing - not on rock", "F02": "Footing - on rock", "F03": "Footing - on reinforced soil", "P01": "Pile - steel H-shape", "P02": "Pile - steel pipe", "P03": "Pile - concrete, cast-in-place", "P04": "Pile - prestressed concrete", "P05": "Pile - timber", "P06": "Pile - auger cast", "P07": "Pile - micropile", "P08": "Pile - composite", "P09": "Pile - FRP composite", "PX": "Pile - other", "S01": "Drilled shaft - single", "S02": "Drilled shafts - multiple", "S03": "Caisson", "U": "Unknown", "X": "Other" },
	BSB07: { "0": "None", "A01": "Admixture - internally sealed", "A02": "Admixture - low permeability", "A03": "Admixture - polymer impregnated", "A04": "Admixture - corrosion inhibitor", "A05": "Admixture - ASR inhibitor", "AX": "Admixture - other", "C01": "Coating - paint", "C02": "Coating - sealer", "C03": "Coating - galvanizing/metalizing", "CX": "Coating - other", "E01": "Encasement - concrete", "EX": "Encasement - other", "P01": "Patina - weathering steel", "S01": "Sacrificial cathodic - passive", "S02": "Sacrificial cathodic - active", "SX": "Sacrificial - other", "T01": "Treated - timber preservative", "U": "Unknown", "X": "Other" },
	BSP01: { "M": "Main", "A": "Approach", "C": "Culvert", "V": "Culvert extension", "W": "Widening" },
	BSP04: { "A01": "Aluminum", "C01": "Reinforced concrete, cast-in-place", "C02": "Reinforced concrete, precast", "C03": "Prestressed, pre-tensioned", "C04": "Prestressed, CIP post-tensioned", "C05": "Prestressed, precast post-tensioned", "CX": "Concrete - other", "F01": "FRP - aramid fiber", "F02": "FRP - carbon fiber", "F03": "FRP - glass fiber", "FX": "FRP - other", "I01": "Iron - cast", "I02": "Iron - wrought", "M01": "Masonry - block", "M02": "Masonry - stone", "P01": "Plastic - polyethylene", "PX": "Plastic - other", "S01": "Steel - rolled shapes", "S02": "Steel - welded shapes", "S03": "Steel - bolted shapes", "S04": "Steel - riveted shapes", "S05": "Steel - bolted & riveted", "SX": "Steel - other", "T01": "Timber - glue laminated", "T02": "Timber - nail laminated", "T03": "Timber - solid sawn", "T04": "Timber - stress laminated", "TX": "Timber - other", "X": "Other" },
	BSP05: { "1": "Simple or single span", "2": "Continuous", "3": "Continuous (live load only)", "4": "Cantilever", "5": "Cantilever with pin & hanger", "6": "Frame", "7": "Buried" },
	BSP06: { "A01": "Arch - under fill, no spandrel", "A02": "Arch - open spandrel", "A03": "Arch - closed spandrel", "A04": "Arch - through", "A05": "Arch - tied", "B01": "Box girder - single", "B02": "Box girder - multiple adjacent", "B03": "Box girder - multiple spread", "B04": "Box girder - segmental", "F01": "Frame - three-sided", "F02": "Frame - four-sided", "F03": "Frame - K-shaped", "F04": "Frame - delta-shaped", "G01": "Girder - I-shaped adjacent", "G02": "Girder - I-shaped spread", "G03": "Girder - tee-beam", "G04": "Girder - inverted tee-beam", "G05": "Girder - double-tee adjacent", "G06": "Girder - double-tee spread", "G07": "Girder - channel adjacent", "G08": "Girder - channel spread", "G09": "Girder & floor beam", "G10": "Through girder", "GX": "Girder - other", "L01": "Cable - suspension", "L02": "Cable - cable-stayed", "L03": "Cable - extradosed", "LX": "Cable - other", "M01": "Movable - vertical lift", "M02": "Movable - bascule", "M03": "Movable - swing", "MX": "Movable - other", "P01": "Pipe - rigid", "P02": "Pipe - flexible", "S01": "Slab - solid", "S02": "Slab - voided", "T01": "Truss - deck", "T02": "Truss - through", "T03": "Truss - pony", "X01": "Other - railroad flat car", "X02": "Other - ferry transfer", "X03": "Other - floating", "X": "Other" },
	BSP07: { "0": "None", "A01": "Admixture - internally sealed", "A02": "Admixture - low permeability", "A03": "Admixture - polymer impregnated", "A04": "Admixture - corrosion inhibitor", "A05": "Admixture - ASR inhibitor", "AX": "Admixture - other", "C01": "Coating - paint", "C02": "Coating - sealer", "C03": "Coating - hot dip galvanizing", "C04": "Coating - metalizing/thermal spray", "CX": "Coating - other", "E01": "Encasement - concrete", "EX": "Encasement - other", "M01": "Membrane - built-up", "M02": "Membrane - sheet", "M03": "Membrane - liquid applied", "MU": "Membrane - unknown", "MX": "Membrane - other", "P01": "Patina - weathering steel", "S01": "Sacrificial cathodic - passive", "S02": "Sacrificial cathodic - active", "SX": "Sacrificial - other", "T01": "Treated - timber preservative", "U": "Unknown", "X": "Other" },
	BSP08: { "CS": "Composite - shored", "CU": "Composite - unshored", "IM": "Integral or monolithic", "NC": "Non-composite" },
	BSP09: { "0": "None", "A01": "Aluminum", "C01": "Reinforced concrete, cast-in-place", "C02": "Reinforced concrete, precast", "C03": "Prestressed, pre-tensioned", "C04": "Prestressed, CIP post-tensioned", "C05": "Prestressed, precast post-tensioned", "CX": "Concrete - other", "F01": "FRP - aramid fiber", "F02": "FRP - carbon fiber", "F03": "FRP - glass fiber", "FX": "FRP - other", "S01": "Steel - open grid", "S02": "Steel - filled/partly filled grid", "S03": "Steel - plate", "S04": "Steel - orthotropic", "S05": "Steel - corrugated", "SX": "Steel - other", "T01": "Timber - glue laminated", "T02": "Timber - nail laminated", "T03": "Timber - solid sawn", "T04": "Timber - stress laminated", "TX": "Timber - other", "X": "Other" },
	BSP10: { "0": "None", "B01": "Bituminous (asphalt)", "C01": "Concrete - monolithic", "C02": "Concrete - unmodified", "C03": "Concrete - latex modified", "C04": "Concrete - low slump", "C05": "Concrete - fiber reinforced", "C06": "Concrete - microsilica", "C07": "Concrete - polyester", "CX": "Concrete - other", "CU": "Concrete - unknown", "E01": "Earth - gravel or soil", "P01": "Polymer - epoxy", "P02": "Polymer - polyester", "PX": "Polymer - other", "S01": "Steel", "T01": "Timber - running planks", "X": "Other" },
	BSP11: { "0": "None", "A01": "Admixture - internally sealed", "A02": "Admixture - low permeability", "A03": "Admixture - polymer impregnated", "A04": "Admixture - corrosion inhibitor", "A05": "Admixture - ASR inhibitor", "AX": "Admixture - other", "C01": "Coating - paint", "C02": "Coating - silane/siloxane", "C03": "Coating - methacrylate", "CX": "Coating - other", "M01": "Membrane - built up", "M02": "Membrane - sheet", "M03": "Membrane - liquid applied", "MU": "Membrane - unknown", "MX": "Membrane - other", "P01": "Patina - weathering steel", "X": "Other" },
	BSP12: { "0": "None", "C01": "Coating - epoxy coated", "C02": "Coating - galvanized", "C03": "Coating - metalized", "CX": "Coating - other", "R01": "Reinforcing - stainless, clad", "R02": "Reinforcing - stainless, solid", "R03": "Reinforcing - high chromium", "R04": "Reinforcing - FRP, aramid", "R05": "Reinforcing - FRP, carbon", "R06": "Reinforcing - FRP, glass", "R07": "Reinforcing - FRP, other", "RX": "Reinforcing - other", "S01": "Sacrificial cathodic - passive", "S02": "Sacrificial cathodic - active", "SX": "Sacrificial - other", "X": "Other" },
	BSP13: { "0": "None", "C01": "Concrete - reinforced", "C02": "Concrete - prestressed", "F01": "FRP composite", "M01": "Metal", "T01": "Timber", "X": "Other" },
	BW03: { "0": "No reportable work", "BR1": "Bridge replaced", "IP1": "Widened", "IP2": "Raised", "IP3": "Strengthened (retrofit)", "IP4": "Seismic retrofit", "DK1": "Deck replaced", "SP1": "Superstructure replaced", "SB1": "Substructure replaced", "DK2": "Deck major rehab", "SP2": "Superstructure major rehab", "SB2": "Substructure major rehab", "CU2": "Culvert major rehab", "DK3": "Deck minor rehab", "SP3": "Superstructure minor rehab", "SB3": "Substructure minor rehab", "CU3": "Culvert minor rehab", "DK4": "Deck overlaid", "CU4": "Culvert overlaid", "DK5": "Deck sealed", "SP5": "Superstructure sealed", "SB5": "Substructure sealed", "CU5": "Culvert sealed", "SP6": "Superstructure coated (new/replaced)", "SB6": "Substructure coated (new/replaced)", "CU6": "Culvert coated (new/replaced)", "SP7": "Superstructure coating preserved", "SB7": "Substructure coating preserved", "CU7": "Culvert coating preserved", "BG1": "Bearings installed/replaced", "JT1": "Deck joints installed/replaced", "RT1": "Railings/transitions installed/replaced", "SC1": "Scour countermeasures installed/replaced", "CP1": "Channel protection installed/replaced", "BG2": "Bearings repaired", "JT2": "Deck joints repaired", "RT2": "Railings/transitions repaired", "SC2": "Scour countermeasures repaired", "CP2": "Channel protection repaired", "CH1": "Channel improved" },
};

function label(pCode) { const e = SNBI[pCode]; return e && e.label ? e.label : pCode; }
function units(pCode) { const e = SNBI[pCode]; return e ? e.units : null; }
function help(pCode) { const e = SNBI[pCode]; return e ? e.help : ''; }
// The human meaning of a raw coded value, or null when the code is not enumerated (numeric/text) or the value is unknown.
function decodeValue(pCode, pRaw) { const m = VALUES[pCode]; if (!m || pRaw == null || pRaw === '') { return null; } const k = String(pRaw); return m[k] != null ? m[k] : null; }
// A display-ready string for a code+value: enum -> "raw · Meaning" (or just the meaning for letter codes); numeric -> "value units"; text -> value.
function readable(pCode, pRaw)
{
	if (pRaw == null || pRaw === '') { return ''; }
	const dec = decodeValue(pCode, pRaw);
	if (dec != null) { return /^[0-9]+$/.test(String(pRaw)) ? (String(pRaw) + ' · ' + dec) : dec; }
	const u = units(pCode);
	return u ? (String(pRaw) + ' ' + u) : String(pRaw);
}

module.exports = { SNBI, VALUES, label, units, help, decodeValue, readable };

},{}],1073:[function(require,module,exports){
module.exports={
  "Form": "Default-ChangeOrder",
  "Descriptors": {
    "Header.GI.ChangeOrderDate": {
      "Hash": "HeaderGIChangeOrderDate",
      "Name": "Change Order Date",
      "DataAddress": "Header.GI.ChangeOrderDate",
      "DataType": "Date",
      "PictForm": {
        "Row": "1",
        "Section": "Header",
        "Group": "General_Information",
        "InputExtra": ""
      },
      "Description": "The date associated with this change order"
    },
    "Header.ChangeOrderNumber_Raw": {
      "Hash": "HeaderChangeOrderNumber_Raw",
      "Name": "Change Order Sequence Number",
      "DataAddress": "Header.ChangeOrderNumber_Raw",
      "DataType": "Number",
      "PictForm": {
        "InputType": "Hidden",
        "Section": "Header",
        "Group": "General_Information"
      }
    },
    "Header.ChangeOrderNumber": {
      "Hash": "HeaderChangeOrderNumber",
      "Name": "Change Order Form #",
      "DataAddress": "Header.ChangeOrderNumber",
      "DataType": "String",
      "PictForm": {
        "Row": "1",
        "Section": "Header",
        "Group": "General_Information",
        "InputType": "ReadOnly",
        "InputExtra": ""
      },
      "Description": "The placement of this change order among all change orders"
    },
    "Header.GI.Notes": {
      "Hash": "HeaderGINotes",
      "Name": "Notes",
      "DataAddress": "Header.GI.Notes",
      "DataType": "String",
      "PictForm": {
        "InputType": "TextArea",
        "Row": "2",
        "Section": "Header",
        "Group": "General_Information",
        "Placeholder": "Enter a description, explanation, and estimated cost of proposed revision",
        "InputExtra": ""
      }
    },
    "Header.GI.DescriptionOfWork": {
      "Hash": "HeaderGIDescriptionOfWork",
      "Name": "Description of Work",
      "DataAddress": "Header.GI.DescriptionOfWork",
      "DataType": "String",
      "PictForm": {
        "InputType": "TextArea",
        "Row": "2",
        "Section": "Header",
        "Group": "General_Information",
        "Placeholder": "Enter a description of the work to be done",
        "InputExtra": ""
      }
    },
    "Summary.AdditionalDaysRequested": {
      "Hash": "SummaryAdditionalDaysRequested",
      "Name": "Additional Days",
      "DataAddress": "Summary.AdditionalDaysRequested",
      "DataType": "Number",
      "PictForm": {
        "Section": "Summary",
        "Group": "Days"
      }
    },
    "Summary.RevisionDate_ISODate": {
      "Hash": "SummaryRevisionDate_ISODate",
      "Name": "New Completion Date",
      "DataAddress": "Summary.RevisionDate_ISODate",
      "DataType": "Date",
      "PictForm": {
        "Section": "Summary",
        "Group": "Days"
      }
    },
    "Summary.CurrentTotalAmount": {
      "Hash": "SummaryCurrentTotalAmount",
      "Name": "Current Total Amount",
      "DataAddress": "Summary.CurrentTotalAmount",
      "DataType": "PreciseNumber",
      "PictForm": {
        "Section": "Summary",
        "Group": "Cost",
        "InputType": "ReadOnly",
        "Chips": {
          "Units": "$"
        },
        "UseInlineUnits": true,
        "Units": "$"
      }
    },
    "Summary.RevisionTotalAmount": {
      "Hash": "SummaryRevisionTotalAmount",
      "Name": "New Total Amount",
      "DataAddress": "Summary.RevisionTotalAmount",
      "DataType": "PreciseNumber",
      "PictForm": {
        "Section": "Summary",
        "Group": "Cost",
        "InputType": "ReadOnly",
        "Chips": {
          "Units": "$"
        },
        "UseInlineUnits": true,
        "Units": "$"
      }
    },
    "Summary.AdjustmentTotalAmount": {
      "Hash": "SummaryAdjustmentTotalAmount",
      "Name": "Adjustement Total Amount",
      "DataAddress": "Summary.AdjustmentTotalAmount",
      "DataType": "PreciseNumber",
      "PictForm": {
        "Section": "Summary",
        "Group": "Cost",
        "InputType": "ReadOnly",
        "Chips": {
          "Units": "$"
        },
        "UseInlineUnits": true,
        "Units": "$"
      }
    },
    "MediaDetailCards": {
      "Hash": "MediaMediaDetailCards",
      "Name": "Media",
      "DataAddress": "MediaDetailCards",
      "DataType": "String",
      "PictForm": {
        "InputType": "MediaDetailCards",
        "Section": "Media",
        "Group": "Observations",
        "InputExtra": "hideTitle: false, cardSize: flexible, sortOrder: desc, hideId: false, hideLabels: false"
      },
      "Description": ""
    },
    "MediaFileSelector": {
      "Hash": "RecordSetStandardFileSelector",
      "Name": "File Selector",
      "DataAddress": "MediaFileSelector",
      "DataType": "String",
      "PictForm": {
        "InputType": "FileSelector",
        "Section": "Media",
        "Group": "Files",
        "InputExtra": ""
      },
      "Description": "",
      "IsTabular": true
    }
  },
  "Sections": [
    {
      "Name": "Header",
      "Hash": "Header",
      "Solvers": [
        "HeaderChangeOrderNumber_Raw = getvalue(\"AppData.DocumentData.ReportData.SequenceNumber\")",
        "HeaderChangeOrderNumber = IF(HeaderChangeOrderNumber_Raw, \"<\", 10, CONCAT(\"CO-00\", HeaderChangeOrderNumber_Raw), IF(HeaderChangeOrderNumber_Raw, \"<\", 100, CONCAT(\"CO-0\", HeaderChangeOrderNumber_Raw), CONCAT(\"CO-\", HeaderChangeOrderNumber_Raw)))"
      ],
      "Groups": [
        {
          "Name": "General Information",
          "Hash": "General_Information",
          "Rows": [],
          "RecordSetSolvers": []
        }
      ]
    },
    {
      "Name": "New Items",
      "Hash": "NewItems",
      "Solvers": [],
      "Groups": [
        {
          "RecordSetSolvers": [
            "FormChangeOrderNumber = getGlobalFormData(\"HeaderChangeOrderNumber\")",
            "OneNewItemChangeOrderNumber = CONCAT(WHEN(FormChangeOrderNumber, FormChangeOrderNumber, \"CO-xxx\"), \"--\", OneNewItemNumber)",
            "OneNewFundingCategoryCode = WHEN(OneNewFundingCategoryCode, OneNewFundingCategoryCode, OneNewFundingCategoryRecordCode)",
            "OneNewAmount = ROUND(OneNewCostPerUnit * OneNewQuantity, 2)"
          ],
          "Layout": "RecordSet",
          "RecordSetAddress": "NewItem",
          "RecordManifest": "NewItemsManifest",
          "Rows": [],
          "Name": "Enter New Items",
          "Hash": "NewItemsTable"
        }
      ]
    },
    {
      "Name": "Existing Items",
      "Hash": "ExistingItems",
      "Solvers": [],
      "Groups": [
        {
          "RecordSetSolvers": [
            "OneExistingItemChangeOrderNumber = OneExistingLineItemRecordChangeOrderNumber",
            "OneUnits = WHEN(OneUnits, OneUnits, OneCurrentUnits)",
            "OneCurrentAmount = ROUND(OneCurrentCostPerUnit * OneCurrentQuantity, 2)",
            "OneNewCostPerUnit = IF(OneNewCostPerUnit, \"==\", 0, OneCurrentCostPerUnit, OneNewCostPerUnit)",
            "OneAdjustmentQuantity_LastSolve = IF(OneAdjustmentQuantity_LastSolve, \"==\", 0, OneAdjustmentQuantity, OneAdjustmentQuantity_LastSolve)",
            "OneNewQuantity_LastSolve = IF(OneNewQuantity_LastSolve, \"==\", 0, OneNewQuantity, OneNewQuantity_LastSolve)",
            "OneAdjustmentQuantity_Hidden = OneAdjustmentQuantity",
            "OneNewQuantity_Hidden = OneNewQuantity",
            "OneAdjustmentQuantity_Changed = 0",
            "OneNewQuantity_Changed = 0",
            "OneAdjustmentQuantity_Changed = IF(OneAdjustmentQuantity_Hidden, \"==\", OneAdjustmentQuantity_LastSolve, 0, 1)",
            "OneNewQuantity_Changed = IF(OneNewQuantity_Hidden, \"==\", OneNewQuantity_LastSolve, 0, 1)",
            "OneNewQuantity = IF(OneAdjustmentQuantity_Changed, \"==\", 1, OneCurrentQuantity + OneAdjustmentQuantity, OneNewQuantity)",
            "OneAdjustmentQuantity = IF(OneNewQuantity_Changed, \"==\", 1, OneNewQuantity - OneCurrentQuantity, OneAdjustmentQuantity)",
            "OneNewQuantity = IF(OneAdjustmentQuantity_Changed + OneNewQuantity_Changed, \"==\", 0, OneCurrentQuantity + OneAdjustmentQuantity, OneNewQuantity)",
            "OneAdjustmentQuantity_LastSolve = OneAdjustmentQuantity",
            "OneNewQuantity_LastSolve = OneNewQuantity",
            "OneNewAmount = ROUND(OneNewCostPerUnit * OneNewQuantity, 2)"
          ],
          "Layout": "RecordSet",
          "RecordSetAddress": "CurrentItem",
          "RecordManifest": "ExistingItemsManifest",
          "Rows": [],
          "Name": "Enter the Items to modify",
          "Hash": "ExistingItemsTable"
        }
      ]
    },
    {
      "Name": "Summary",
      "Hash": "Summary",
      "Solvers": [
        "SummaryCurrentTotalAmount = SUM(FLATTEN(CurrentItem[].CurrentAmount))",
        "SummaryRevisionTotalAmount = SUM(FLATTEN(NewItem[].NewAmount)) + SUM(FLATTEN(CurrentItem[].NewAmount))",
        "SummaryAdjustmentTotalAmount = SummaryRevisionTotalAmount - SummaryCurrentTotalAmount"
      ],
      "Groups": [
        {
          "Name": "Days",
          "Hash": "Days",
          "Rows": [],
          "RecordSetSolvers": []
        },
        {
          "Name": "Cost",
          "Hash": "Cost",
          "Rows": [],
          "RecordSetSolvers": []
        }
      ]
    },
    {
      "Name": "Media",
      "Hash": "Media",
      "Solvers": [],
      "Groups": [
        {
          "Name": "Observations",
          "Hash": "Observations",
          "Rows": [],
          "RecordSetSolvers": [],
          "ShowTitle": false
        },
        {
          "Name": "Files",
          "Hash": "Files",
          "Rows": [],
          "RecordSetSolvers": [],
          "ShowTitle": false
        }
      ]
    }
  ],
  "ReferenceManifests": {
    "ExistingItemsManifest": {
      "Scope": "ExistingItemsManifest",
      "Descriptors": {
        "LineItem_IDLineItem": {
          "Hash": "OneExistingItem",
          "DataAddress": "LineItem_IDLineItem",
          "Name": "Item",
          "DataType": "Number",
          "PictForm": {
            "Row": "1",
            "InputType": "EntitySelector",
            "Entity": "LineItem",
            "EntityTag": "ItemNumber",
            "InputExtra": "",
            "Placeholder": "select an item to modify...",
            "Providers": [
              "Pict-Input-Select",
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAllInputs": true,
              "PostSolvers": [
                "runSolvers()",
                "refreshtabularsection(\"ExistingItems\",\"ExistingItemsTable\")"
              ],
              "EntitiesBundle": [
                {
                  "Entity": "LineItem",
                  "Filter": "FBV~IDLineItem~EQ~{~D:Record.Value~}",
                  "Destination": "SelectedLineItem",
                  "SingleRecord": true
                }
              ]
            }
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record": {
          "Hash": "OneExistingLineItemRecord",
          "DataAddress": "LineItem_IDLineItem__Record",
          "Name": "LineItemRecord",
          "DataType": "Object",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.Name": {
          "Hash": "OneExistingLineItemRecordName",
          "DataAddress": "LineItem_IDLineItem__Record.Name",
          "Name": "LineItemRecordName",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.Units": {
          "Hash": "OneExistingLineItemRecordUnits",
          "DataAddress": "LineItem_IDLineItem__Record.Units",
          "Name": "LineItemRecordUnit",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.ExpectedQuantity": {
          "Hash": "OneExistingLineItemRecordExpectedQuantity",
          "DataAddress": "LineItem_IDLineItem__Record.ExpectedQuantity",
          "Name": "LineItemRecordExpectedQuantity",
          "DataType": "PreciseNumber",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.CostPerUnit": {
          "Hash": "OneExistingLineItemRecordCostPerUnit",
          "DataAddress": "LineItem_IDLineItem__Record.CostPerUnit",
          "Name": "LineItemRecordCostPerUnit",
          "DataType": "PreciseNumber",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_IDLineItem__Record.ChangeOrderNumber": {
          "Hash": "OneExistingLineItemRecordChangeOrderNumber",
          "DataAddress": "LineItem_IDLineItem__Record.ChangeOrderNumber",
          "Name": "LineItemRecordChangeOrderNumber",
          "DataType": "PreciseNumber",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "LineItem_Name": {
          "Hash": "OneExistingItemName",
          "DataAddress": "LineItem_Name",
          "Name": "Name",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.Name",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "ChangeOrderNumber": {
          "Hash": "OneExistingItemChangeOrderNumber",
          "DataAddress": "ChangeOrderNumber",
          "Name": "Change Order #",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.ChangeOrderNumber",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentQuantity": {
          "Hash": "OneCurrentQuantity",
          "DataAddress": "CurrentQuantity",
          "Name": "Current Quantity",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.ExpectedQuantity",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentUnits": {
          "Hash": "OneCurrentUnits",
          "DataAddress": "CurrentUnits",
          "Name": "Current Units",
          "DataType": "String",
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.Units",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentCostPerUnit": {
          "Hash": "OneCurrentCostPerUnit",
          "DataAddress": "CurrentCostPerUnit",
          "Name": "Current Cost Per Unit",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.CostPerUnit",
              "PostSolvers": [
                "runSolvers()",
                "refreshtabularsection(\"ExistingItems\",\"ExistingItemsTable\")"
              ],
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "CurrentAmount": {
          "Hash": "OneCurrentAmount",
          "DataAddress": "CurrentAmount",
          "Name": "Current Amount",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "2",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        },
        "AdjustmentQuantity": {
          "Hash": "OneAdjustmentQuantity",
          "DataAddress": "AdjustmentQuantity",
          "Name": "Adjustment Quantity",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "3",
            "Width": "3"
          },
          "Description": "Enter a value to add to or subtract from the current quantity. New Quantity will update automatically.",
          "IsTabular": true
        },
        "AdjustmentQuantity_LastSolve": {
          "Hash": "OneAdjustmentQuantity_LastSolve",
          "DataAddress": "AdjustmentQuantity_LastSolve",
          "Name": "Adjustment Quantity Last Solve",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "AdjustmentQuantity_Hidden": {
          "Hash": "OneAdjustmentQuantity_Hidden",
          "DataAddress": "AdjustmentQuantity_Hidden",
          "Name": "Adjustment Quantity Hidden",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "AdjustmentQuantity_Changed": {
          "Hash": "OneAdjustmentQuantity_Changed",
          "DataAddress": "AdjustmentQuantity_Changed",
          "Name": "Adjustment Quantity Changed",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "NewQuantity": {
          "Hash": "OneNewQuantity",
          "DataAddress": "NewQuantity",
          "Name": "New Quantity",
          "DataType": "PreciseNumber",
          "Default": 0,
          "PictForm": {
            "Row": "4"
          },
          "Description": "Enter the final quantity directly. Adjustment Quantity will update automatically.",
          "IsTabular": true
        },
        "NewQuantity_LastSolve": {
          "Hash": "OneNewQuantity_LastSolve",
          "DataAddress": "NewQuantity_LastSolve",
          "Name": "New Quantity Last Solve",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "NewQuantity_Hidden": {
          "Hash": "OneNewQuantity_Hidden",
          "DataAddress": "NewQuantity_Hidden",
          "Name": "New Quantity Hidden",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "NewQuantity_Changed": {
          "Hash": "OneNewQuantity_Changed",
          "DataAddress": "NewQuantity_Changed",
          "Name": "New Quantity Changed",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "Units": {
          "Hash": "OneUnits",
          "DataAddress": "Units",
          "Name": "New Units",
          "DataType": "String",
          "PictForm": {
            "Row": "4",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.Units",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "NewCostPerUnit": {
          "Hash": "OneNewCostPerUnit",
          "DataAddress": "NewCostPerUnit",
          "Name": "New Cost Per Unit",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "4",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneExistingItemRowTrigger",
              "TriggerAddress": "SelectedLineItem.CostPerUnit",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        },
        "NewAmount": {
          "Hash": "OneNewAmount",
          "DataAddress": "NewAmount",
          "Name": "New Amount",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "4",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        }
      }
    },
    "NewItemsManifest": {
      "Scope": "NewItemsManifest",
      "Descriptors": {
        "LineItem_IDLineItem": {
          "Hash": "OneNewItem",
          "DataAddress": "LineItem_IDLineItem",
          "Name": "Item",
          "DataType": "Number",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "ChangeOrderNumber": {
          "Hash": "OneNewItemChangeOrderNumber",
          "DataAddress": "ChangeOrderNumber",
          "Name": "Change Order #",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden"
          },
          "IsTabular": true
        },
        "PayItem_IDPayItem": {
          "Hash": "OneNewPayItem",
          "DataAddress": "PayItem_IDPayItem",
          "Name": "Pay Item",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "Row": "1",
            "Width": "5",
            "InputType": "EntitySelector",
            "Entity": "PayItem",
            "EntityTag": "ItemCode",
            "InputExtra": "",
            "Placeholder": "link a master pay item...",
            "Providers": [
              "Pict-Input-Select"
            ]
          },
          "IsTabular": true
        },
        "ItemNumber": {
          "Hash": "OneNewItemNumber",
          "DataAddress": "ItemNumber",
          "Name": "Item Number",
          "DataType": "String",
          "PictForm": {
            "Row": "2",
            "Width": "2"
          },
          "IsTabular": true
        },
        "LineItem_Name": {
          "Hash": "OneNewItemName",
          "DataAddress": "LineItem_Name",
          "Name": "Item Name",
          "DataType": "String",
          "PictForm": {
            "Row": "2",
            "Width": "5"
          },
          "IsTabular": true
        },
        "NewQuantity": {
          "Hash": "OneNewQuantity",
          "DataAddress": "NewQuantity",
          "Name": "New Quantity",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "3"
          },
          "IsTabular": true
        },
        "Units": {
          "Hash": "OneUnits",
          "DataAddress": "Units",
          "Name": "Units",
          "DataType": "String",
          "PictForm": {
            "Row": "3"
          },
          "IsTabular": true
        },
        "NewCostPerUnit": {
          "Hash": "OneNewCostPerUnit",
          "DataAddress": "NewCostPerUnit",
          "Name": "New Cost Per Unit",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "3",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        },
        "NewAmount": {
          "Hash": "OneNewAmount",
          "DataAddress": "NewAmount",
          "Name": "New Amount",
          "DataType": "PreciseNumber",
          "PictForm": {
            "Row": "3",
            "InputType": "ReadOnly",
            "Chips": {
              "Units": "$"
            },
            "UseInlineUnits": true,
            "Units": "$"
          },
          "IsTabular": true
        },
        "FundingCategory_IDFundingCategory": {
          "Hash": "OneNewFundingCategory",
          "DataAddress": "FundingCategory_IDFundingCategory",
          "Name": "Funding Category",
          "DataType": "Number",
          "Default": 0,
          "PictForm": {
            "Row": "2",
            "Width": "5",
            "InputType": "EntitySelector",
            "Entity": "FundingCategory",
            "EntityTag": "Code",
            "InputExtra": "",
            "Placeholder": "select a funding category...",
            "Providers": [
              "Pict-Input-Select",
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneNewFundingCategoryTrigger",
              "TriggerAllInputs": true,
              "EntitiesBundle": [
                {
                  "Entity": "FundingCategory",
                  "Filter": "FBV~IDFundingCategory~EQ~{~D:Record.Value~}",
                  "Destination": "SelectedFundingCategory",
                  "SingleRecord": true
                }
              ]
            }
          },
          "IsTabular": true
        },
        "FundingCategory_Code": {
          "Hash": "OneNewFundingCategoryCode",
          "DataAddress": "FundingCategory_Code",
          "Name": "Category Code",
          "DataType": "String",
          "PictForm": {
            "InputType": "Hidden",
            "Providers": [
              "Pict-Input-TabularTriggerGroup"
            ],
            "TabularTriggerGroup": {
              "TriggerGroupHash": "OneNewFundingCategoryTrigger",
              "TriggerAddress": "SelectedFundingCategory.Code",
              "MarshalEmptyValues": true
            }
          },
          "IsTabular": true
        }
      }
    }
  },
  "FormName": "Default Change Order"
}

},{}],1074:[function(require,module,exports){
'use strict';

/**
 * Shared change-order gating — mirrors contract_admin's ProjectChangeOrderGating service.
 *
 * A project requires a Change Order for line-item / bid-item MODIFICATIONS when its current Status is in the
 * ProjectType's `RequiresChangeOrder` status list (`GET ProjectType/{id}/Statuses` → `.RequiresChangeOrder`).
 * This is a UX rule only (the API still writes regardless); the config app disables the direct line-item edit
 * affordances (Funding line-item category assignment, line/bid-item bulk delete) and points the user at the
 * Change Orders tab instead.
 *
 * @param {Function} pGetJSON - a promise-returning GET, `(url) => Promise<any>`.
 * @param {number} pIDProject
 * @param {object} [pProject] - an already-loaded Project record (with Status + IDProjectType) to skip the extra fetch.
 * @returns {Promise<{ requires: boolean, status: string, idProjectType: number }>}
 */
async function fetchProjectChangeOrderGating(pGetJSON, pIDProject, pProject)
{
	let tmpStatus = '';
	let tmpIDProjectType = 0;
	try
	{
		const tmpProject = (pProject && typeof pProject === 'object') ? pProject : await pGetJSON(`Project/${pIDProject}`);
		tmpStatus = (tmpProject && tmpProject.Status) ? String(tmpProject.Status) : '';
		tmpIDProjectType = (tmpProject && tmpProject.IDProjectType) ? Number(tmpProject.IDProjectType) : 0;
		if (tmpIDProjectType)
		{
			const tmpStatuses = await pGetJSON(`ProjectType/${tmpIDProjectType}/Statuses`).catch(() => null);
			const tmpList = (tmpStatuses && Array.isArray(tmpStatuses.RequiresChangeOrder)) ? tmpStatuses.RequiresChangeOrder : [];
			return { requires: tmpStatus ? (tmpList.indexOf(tmpStatus) > -1) : false, status: tmpStatus, idProjectType: tmpIDProjectType };
		}
	}
	catch (pError) { /* best-effort — default to direct (not required) */ }
	return { requires: false, status: tmpStatus, idProjectType: tmpIDProjectType };
}

module.exports = { fetchProjectChangeOrderGating };

},{}],1075:[function(require,module,exports){
'use strict';
/**
 * Config-Clone — pure (no Pict / no rest) helpers for cloning configuration across contexts.
 *
 * A clone reads a namespace's effective config at a SOURCE scope/context (one merged object per
 * NamespaceValue) and writes the selected values at a TARGET scope/context. The Configuration service
 * diffs each Put against the target's parent, so cloning Customer-A -> Customer-B stores only what
 * differs from B's Global default. These helpers build + summarize the plan; the provider performs the
 * reads/writes.
 */

/**
 * Build a clone plan: one Put per selected NamespaceValue, carrying the source's effective config.
 * Selected values with no source config are skipped.
 * @param {Object<string, object>} pSourceConfigByValue map NamespaceValue -> merged config (from a Get-all-values at the source scope)
 * @param {Array<string>} pSelectedValues the NamespaceValues to clone
 * @return {Array<{ NamespaceValue: string, Config: object }>}
 */
function planClone(pSourceConfigByValue, pSelectedValues)
{
	const tmpSource = pSourceConfigByValue || {};
	return (pSelectedValues || [])
		.filter((pValue) => Object.prototype.hasOwnProperty.call(tmpSource, pValue))
		.map((pValue) => ({ NamespaceValue: pValue, Config: tmpSource[pValue] }));
}

/**
 * Summarize a plan for the confirm dialog / preview.
 * @param {Array<{ NamespaceValue: string }>} pPlan
 * @return {{ Count: number, Values: Array<string> }}
 */
function summarizeClonePlan(pPlan)
{
	const tmpPlan = pPlan || [];
	return { Count: tmpPlan.length, Values: tmpPlan.map((pEntry) => pEntry.NamespaceValue) };
}

module.exports = { planClone, summarizeClonePlan };

},{}],1076:[function(require,module,exports){
'use strict';
/**
 * Config-Dictionary — curated, human descriptions for configuration namespaces and individual keys
 * (the "what it means" overlay). Keyed by NamespaceKey, then by ConfigEntry Address (slash form) so
 * lookups are independent of how the object-editor renders the path. Missing entries simply mean "no
 * help text" — the dictionary is an optional overlay that can grow over time.
 *
 * The viewer translates a focused node's editor path -> Address (Config-Provenance.editorPathToAddress
 * after editorPathToLeafPath) to find the matching Keys entry.
 *
 * (v2 idea: promote this to its own editable config namespace so descriptions are authored in-app.)
 */

const CONFIG_DICTIONARY =
{
	MasterListCatalog:
	{
		Description: 'Per-entity reference/catalog list configuration. Each NamespaceValue is one entity (Material, PayItem, …); its object configures how that list is read and displayed.',
		Keys:
		{
			'/Filter': 'A FoxHound filter (FBV~…) applied when reading this list — restricts which records appear.',
			'/Columns': 'The columns shown for this list, in order.',
			'/HiddenColumns': 'Columns hidden by default in the list view.',
			'/Connections': 'Related-entity connections surfaced alongside this list.',
			'/DisplayName': 'The human label shown for this list in the UI.',
			'/Category': 'The grouping/category this list is filed under in navigation.',
		},
	},
	ModuleAccess:
	{
		Description: 'Which optional product modules are enabled. Each NamespaceValue is a module (e.g. Contracts); `enabled` turns it on for the scope.',
		Keys:
		{
			'/enabled': 'Whether this module is enabled at the current scope.',
		},
	},
	Permissions:
	{
		Description: 'Role/permission toggles applied across the cascade.',
		Keys:
		{
			'/enabled': 'Whether this permission is granted at the current scope.',
		},
	},
	ApprovalsService:
	{
		Description: 'Approval-workflow configuration: routing, thresholds, and notifications.',
		Keys: {},
	},
	ApplicationSettings:
	{
		Description: 'General application behaviour and feature toggles.',
		Keys: {},
	},
	FinanceService:
	{
		Description: 'Finance service configuration. Each NamespaceValue is one area of the service — PaymentFulfillment, Forms, Digest, Accounting, … — and its object holds that area\'s settings.',
		Keys:
		{
			'/enableFormDataIngest': 'Whether saving a payment form makes the finance service read its FormData and write the accounting rows. A bridge for forms that have not yet adopted the payment entries endpoint; off means a form logs its own entries instead.',
			'/useMockFinancialReader': 'Forms: whether the default payment form falls back to its mock financial reader, which re-reads every earlier payment\'s FormData in the browser, instead of reading the accounting model. Off by default; an opt-out kept while the accounting flow soaks.',
		},
	},
};

/**
 * Namespace-level description, or '' when unknown.
 * @param {string} pNamespaceKey
 * @return {string}
 */
function describeNamespace(pNamespaceKey)
{
	const tmpEntry = CONFIG_DICTIONARY[pNamespaceKey];
	return (tmpEntry && tmpEntry.Description) || '';
}

/**
 * Per-key (Address) description, or '' when unknown.
 * @param {string} pNamespaceKey
 * @param {string} pAddress slash-form Address (e.g. '/Filter')
 * @return {string}
 */
function describeKey(pNamespaceKey, pAddress)
{
	const tmpEntry = CONFIG_DICTIONARY[pNamespaceKey];
	return (tmpEntry && tmpEntry.Keys && tmpEntry.Keys[pAddress]) || '';
}

module.exports = {
	CONFIG_DICTIONARY,
	describeNamespace,
	describeKey,
};

},{}],1077:[function(require,module,exports){
'use strict';
/**
 * Config-Namespace-Catalog — a curated registry of the cascading-configuration NAMESPACE KEYS the
 * platform authors, with human labels + a value-mode hint. This drives the viewer's left rail.
 *
 * The Configuration service has no "list all namespaces" endpoint, so this seed names the known keys;
 * the viewer ALSO discovers live NamespaceValues per key by calling /Configuration/Get without a
 * NamespaceValue (the response is keyed by NamespaceValue). The catalog is therefore a labelling +
 * grouping aid, not an exhaustive source of truth — unknown keys still work, they just render with a
 * derived label.
 *
 * NamespaceValueMode:
 *   'multi'  — many NamespaceValues under the key (e.g. MasterListCatalog has one per entity); enumerate live.
 *   'single' — effectively one well-known value; KnownValues names it.
 *
 * Keys verified in use across the Headlight app/services (MasterList-Registry-Provider,
 * ContractAdminConfig-Provider, and api/services config call sites).
 */

const CONFIG_NAMESPACE_CATALOG =
[
	{
		NamespaceKey: 'MasterListCatalog',
		Label: 'Master Lists',
		Group: 'Reference Data',
		NamespaceValueMode: 'multi',
		Description: 'Per-entity reference/catalog list configuration (one NamespaceValue per entity, e.g. Material, PayItem).',
	},
	{
		NamespaceKey: 'ModuleAccess',
		Label: 'Module Access',
		Group: 'Access & Permissions',
		NamespaceValueMode: 'multi',
		Description: 'Which optional product modules are enabled (one NamespaceValue per module, e.g. Contracts).',
	},
	{
		NamespaceKey: 'Permissions',
		Label: 'Permissions',
		Group: 'Access & Permissions',
		NamespaceValueMode: 'multi',
		Description: 'Role/permission toggles applied across the cascade (e.g. ContractAdmin).',
	},
	{
		NamespaceKey: 'PermissionsEnforcement',
		Label: 'Permissions Enforcement',
		Group: 'Access & Permissions',
		NamespaceValueMode: 'multi',
		Description: 'How permission rules are enforced at each scope.',
	},
	{
		NamespaceKey: 'EntityDestinations',
		Label: 'Where Records Open',
		Group: 'Platform',
		NamespaceValueMode: 'multi',
		Description: 'Destination rules per entity (NamespaceValue Sample, Location, Document): ordered rules keyed by name, each with an Audience, When conditions and a Target. Used by the links app for scanned labels and emailed links.',
	},
	{
		NamespaceKey: 'DashboardAccess',
		Label: 'Dashboard Access',
		Group: 'Platform',
		NamespaceValueMode: 'multi',
		Description: 'NamespaceValue Rules: ordered rules keyed by name, each giving an Audience of roles a set of Dashboards, an optional Landing dashboard, and optional DataFilters per dashboard. Resolved by platform data operations (PlatformDashboard/Available) for every app that shows dashboards.',
	},
	{
		NamespaceKey: 'QRCodes',
		Label: 'QR Codes',
		Group: 'Platform',
		NamespaceValueMode: 'multi',
		Description: 'Sample QR code profile (NamespaceValue Profile): code format, label envelope and SiteManager options, edited on the Sample QR Codes screen. Receiving (NamespaceValue Receive, edited on the Sample Scanning screen): optional StatusByLocation map of location QR code or GUID to the sample status a Receive scan sets, e.g. { "StatusByLocation": { "Disposed": "VOID" } }.',
	},
	{
		NamespaceKey: 'ApprovalsService',
		Label: 'Approvals',
		Group: 'Workflow',
		NamespaceValueMode: 'multi',
		Description: 'Approval-workflow configuration (routing, thresholds, notifications).',
	},
	{
		NamespaceKey: 'ApplicationSettings',
		Label: 'Application Settings',
		Group: 'Platform',
		NamespaceValueMode: 'multi',
		Description: 'General application behaviour and feature toggles.',
	},
	{
		NamespaceKey: 'FinanceService',
		Label: 'Finance',
		Group: 'Workflow',
		NamespaceValueMode: 'multi',
		Description: 'Finance/billing service configuration.',
	},
	{
		NamespaceKey: 'ObservationType',
		Label: 'Observation Types',
		Group: 'Field Data',
		NamespaceValueMode: 'multi',
		Description: 'Per-observation-type configuration overrides.',
	},
	{
		NamespaceKey: 'ObservationManifest',
		Label: 'Observation Manifests',
		Group: 'Field Data',
		NamespaceValueMode: 'multi',
		Description: 'Per-manifest configuration overrides.',
	},
	{
		NamespaceKey: 'Dashboards',
		Label: 'Dashboards',
		Group: 'Platform',
		NamespaceValueMode: 'multi',
		Description: 'Classic dashboards Fieldbook offers on a project (one NamespaceValue per dashboard), edited on the Fieldbook Dashboards screen.',
	},
	{
		NamespaceKey: 'EntityOwnershipAssignment',
		Label: 'Who Can Open New Forms',
		Group: 'Access & Permissions',
		NamespaceValueMode: 'multi',
		Description: 'NamespaceValue Document: { Enabled, ByType: { <form type>: { Roles: [ <role permission level> ] } } }. The API grants each new document to those roles. Edited on the Who Can Open New Forms screen.',
	},
	{
		NamespaceKey: 'FieldbookiOS',
		Label: 'Fieldbook iOS',
		Group: 'Platform',
		NamespaceValueMode: 'multi',
		Description: 'Read by the iPad app on sync. NamespaceValue Features: { QRScanner } (edited on the Sample Scanning screen); NamespaceValue SyncSettings: minimal-sync options.',
	},
];

/**
 * Find a catalog entry by namespace key (case-sensitive).
 * @param {string} pNamespaceKey
 * @return {object|null}
 */
function findNamespace(pNamespaceKey)
{
	return CONFIG_NAMESPACE_CATALOG.find((pEntry) => pEntry.NamespaceKey === pNamespaceKey) || null;
}

/**
 * Human label for a namespace key — the catalog label if known, else the raw key.
 * @param {string} pNamespaceKey
 * @return {string}
 */
function labelForNamespace(pNamespaceKey)
{
	const tmpEntry = findNamespace(pNamespaceKey);
	return (tmpEntry && tmpEntry.Label) || pNamespaceKey || '';
}

module.exports = {
	CONFIG_NAMESPACE_CATALOG,
	findNamespace,
	labelForNamespace,
};

},{}],1078:[function(require,module,exports){
'use strict';
/**
 * Config-Provenance — pure (no Pict / no DOM) helpers for the cascading-configuration viewer.
 *
 * The Configuration service stores config as flat ConfigEntry rows: ONE ROW PER LEAF, each carrying
 * its own LevelContext (scope) + Address. The server's /Configuration/Get cascades + merges across
 * scopes but returns ONLY the effective object — no per-leaf provenance. These helpers reconstruct,
 * for every leaf of the merged object, WHICH SCOPE set it, by matching the merged object's leaves to
 * the raw rows' Addresses.
 *
 * Address grammar (authoritative — mirrors api/config/.../Configuration-{Get,Put}-ByNamespace.js):
 *   - leading '/', object keys joined by '/', a literal '/' inside a key escaped as '\/'.
 *   - ARRAYS AND PRIMITIVES ARE ATOMIC LEAVES. The writer (_getAllLeafAddresses / _flattenConfig)
 *     never recurses into arrays, so Addresses NEVER contain array indices — an array's elements all
 *     share the array's single Address (and therefore its single scope).
 *
 * Object-editor path grammar (mirrors pict-section-objecteditor _walkObject / _walkArray):
 *   - object keys joined by '.', array elements suffixed '[n]'. Because config leaves are atomic, a
 *     config leaf's editor path is a pure dot-path; any '[n]' in a node path means "at/inside an
 *     atomic array", so it inherits that array's provenance (reduce by truncating at the first '[').
 */

// Cascade order — lowest (most general) to highest (most specific). A higher scope wins the merge.
const SCOPE_ORDER = [ 'Global', 'Customer', 'Contract', 'Project', 'User' ];
const MISSING_VALUE = '__MISSING__';
const SLASH_PLACEHOLDER = ' '; // private sentinel standing in for an escaped '\/' during split

/**
 * Rank of a scope in the cascade (higher = more specific = wins). Unknown scopes rank -1.
 * @param {string} pScope
 * @return {number}
 */
function scopeRank(pScope)
{
	return SCOPE_ORDER.indexOf(pScope);
}

/**
 * Translate a ConfigEntry Address (slash form) into an object-editor dot-path.
 * @param {string} pAddress e.g. '/Foo/Bar' or '/Weird\/Key/Leaf'
 * @return {string} e.g. 'Foo.Bar' or 'Weird/Key.Leaf'
 */
function addressToEditorPath(pAddress)
{
	if (!pAddress)
	{
		return '';
	}
	// Protect escaped slashes, split on the real separators, then restore the literal slashes.
	return String(pAddress).replace(/\\\//g, SLASH_PLACEHOLDER)
		.split('/')
		.filter((pSegment) => pSegment.length > 0)
		.map((pSegment) => pSegment.split(SLASH_PLACEHOLDER).join('/'))
		.join('.');
}

/**
 * Translate an object-editor dot-path (object keys only — a config leaf) into a ConfigEntry Address.
 * Inverse of addressToEditorPath for atomic-leaf paths. Bracketed (array-element) node paths must be
 * reduced via editorPathToLeafPath first.
 * @param {string} pPath e.g. 'Foo.Bar'
 * @return {string} e.g. '/Foo/Bar'
 */
function editorPathToAddress(pPath)
{
	if (!pPath)
	{
		return '';
	}
	return String(pPath).split('.')
		.filter((pSegment) => pSegment.length > 0)
		.map((pSegment) => '/' + pSegment.replace(/\//g, '\\/'))
		.join('');
}

/**
 * Reduce an object-editor node path to the path of the config LEAF that owns it. Config arrays are
 * atomic, so anything at or inside an array (a '[n]' segment) collapses to the array's own path.
 * @param {string} pPath e.g. 'Foo.Bar[2].Baz' -> 'Foo.Bar'; 'Foo.Baz' -> 'Foo.Baz'
 * @return {string}
 */
function editorPathToLeafPath(pPath)
{
	if (!pPath)
	{
		return '';
	}
	const tmpBracket = String(pPath).indexOf('[');
	return (tmpBracket >= 0) ? String(pPath).slice(0, tmpBracket) : String(pPath);
}

/**
 * Is this value an atomic config leaf? Primitives, null, and ARRAYS are leaves; plain objects recurse.
 * @param {*} pValue
 * @return {boolean}
 */
function isLeafValue(pValue)
{
	return (pValue === null) || (typeof pValue !== 'object') || Array.isArray(pValue);
}

/**
 * Enumerate every atomic-leaf path of a merged config object, as object-editor dot-paths.
 * @param {object} pObject the merged config
 * @return {Array<string>}
 */
function enumerateLeafPaths(pObject)
{
	const tmpPaths = [];
	const fWalk = (pValue, pBasePath) =>
	{
		if (isLeafValue(pValue))
		{
			if (pBasePath)
			{
				tmpPaths.push(pBasePath);
			}
			return;
		}
		Object.keys(pValue).forEach((pKey) =>
		{
			const tmpChildPath = pBasePath ? (pBasePath + '.' + pKey) : pKey;
			fWalk(pValue[pKey], tmpChildPath);
		});
	};
	fWalk(pObject || {}, '');
	return tmpPaths;
}

/**
 * Resolve the value at an object-key dot-path (no bracket support — config leaves are atomic).
 * @param {object} pObject
 * @param {string} pLeafPath
 * @return {*} the value, or undefined if any segment is missing
 */
function valueAtLeafPath(pObject, pLeafPath)
{
	if (!pLeafPath)
	{
		return pObject;
	}
	let tmpCurrent = pObject;
	const tmpSegments = String(pLeafPath).split('.');
	for (let i = 0; i < tmpSegments.length; i++)
	{
		if (tmpCurrent === null || typeof tmpCurrent !== 'object')
		{
			return undefined;
		}
		tmpCurrent = tmpCurrent[tmpSegments[i]];
	}
	return tmpCurrent;
}

/**
 * Compare two atomic leaf values (primitive or array) for equality.
 * @param {*} pA
 * @param {*} pB
 * @return {boolean}
 */
function leafValuesEqual(pA, pB)
{
	if (pA === pB)
	{
		return true;
	}
	try
	{
		return JSON.stringify(pA) === JSON.stringify(pB);
	}
	catch (pError)
	{
		return false;
	}
}

/**
 * Build a provenance map { [editorPath]: { Scope, ScopeID } } for a merged config, from the raw
 * ConfigEntry rows. Each leaf is attributed to the HIGHEST-ranked scope that has a (non-__MISSING__)
 * row at its Address; any leaf with no matching row is attributed to Global — the one scope a
 * non-super-user cannot read raw rows for, so "no row found" means "inherited from Global".
 *
 * @param {Array<object>} pRows raw ConfigEntry rows ({ Address, LevelContext, LevelContextID, ConfigValue })
 * @param {object} pMergedConfig the effective object from /Configuration/Get
 * @return {object} { [editorPath]: { Scope, ScopeID } }
 */
function buildProvenanceMapFromRows(pRows, pMergedConfig)
{
	// Index the highest-ranked real (non-hide) row per Address.
	const tmpByAddress = {};
	(pRows || []).forEach((pRow) =>
	{
		if (!pRow || typeof pRow.Address !== 'string' || pRow.ConfigValue === MISSING_VALUE)
		{
			return;
		}
		const tmpExisting = tmpByAddress[pRow.Address];
		if (!tmpExisting || scopeRank(pRow.LevelContext) > scopeRank(tmpExisting.Scope))
		{
			tmpByAddress[pRow.Address] = { Scope: pRow.LevelContext, ScopeID: pRow.LevelContextID };
		}
	});
	// Attribute every merged leaf to a scope (Global by elimination).
	const tmpMap = {};
	enumerateLeafPaths(pMergedConfig).forEach((pLeafPath) =>
	{
		const tmpAddress = editorPathToAddress(pLeafPath);
		tmpMap[pLeafPath] = tmpByAddress[tmpAddress] || { Scope: 'Global', ScopeID: 0 };
	});
	return tmpMap;
}

/**
 * Oracle / fallback: compute provenance by diffing the merged config at each successive scope.
 * pMergesByLevel is ordered general -> specific; each entry's Config is the merge UP TO AND INCLUDING
 * that scope (i.e. what /Configuration/Get returns with LevelContext set to that scope). A leaf is
 * attributed to the LAST level at which its value changed from the prior level (= the highest scope
 * that set the effective value).
 *
 * @param {Array<{Scope:string, ScopeID:(number|string), Config:object}>} pMergesByLevel
 * @return {object} { [editorPath]: { Scope, ScopeID } }
 */
function computeProvenanceByDiff(pMergesByLevel)
{
	const tmpLevels = pMergesByLevel || [];
	const tmpDeepest = tmpLevels.length ? tmpLevels[tmpLevels.length - 1].Config : {};
	const tmpMap = {};
	enumerateLeafPaths(tmpDeepest).forEach((pLeafPath) =>
	{
		let tmpPrior;
		let tmpResolved = null;
		for (let i = 0; i < tmpLevels.length; i++)
		{
			const tmpValue = valueAtLeafPath(tmpLevels[i].Config, pLeafPath);
			if (i === 0)
			{
				if (tmpValue !== undefined)
				{
					tmpResolved = { Scope: tmpLevels[i].Scope, ScopeID: tmpLevels[i].ScopeID };
				}
			}
			else if (!leafValuesEqual(tmpValue, tmpPrior))
			{
				tmpResolved = { Scope: tmpLevels[i].Scope, ScopeID: tmpLevels[i].ScopeID };
			}
			tmpPrior = tmpValue;
		}
		tmpMap[pLeafPath] = tmpResolved || { Scope: 'Global', ScopeID: 0 };
	});
	return tmpMap;
}

/**
 * Look up the provenance for an object-editor node by its Path (handles atomic-array descendants by
 * reducing to the owning leaf path). Returns null when the node is a container (no own leaf row).
 * @param {object} pProvenanceMap
 * @param {string} pNodePath
 * @return {{Scope:string, ScopeID:(number|string)}|null}
 */
function lookupProvenance(pProvenanceMap, pNodePath)
{
	if (!pProvenanceMap)
	{
		return null;
	}
	const tmpLeafPath = editorPathToLeafPath(pNodePath);
	return pProvenanceMap[tmpLeafPath] || null;
}

module.exports = {
	SCOPE_ORDER,
	MISSING_VALUE,
	scopeRank,
	addressToEditorPath,
	editorPathToAddress,
	editorPathToLeafPath,
	isLeafValue,
	enumerateLeafPaths,
	valueAtLeafPath,
	leafValuesEqual,
	buildProvenanceMapFromRows,
	computeProvenanceByDiff,
	lookupProvenance,
};

},{}],1079:[function(require,module,exports){
'use strict';
/**
 * ProvenanceNodeRenderers — thin subclasses of pict-section-objecteditor's per-type node renderers
 * that STAMP provenance fields onto the node descriptor before the standard render runs. Because
 * compileMacros() (PictView-ObjectEditor-Node.js) parses the view's MacroTemplates against the node,
 * and ProvenanceObjectEditor's macros reference {~D:Record.ProvenanceBadgeHTML~} / ProvenanceRowClass,
 * stamping those fields here is all that's needed — no template overrides, and it regenerates on every
 * renderTree() so it survives the editor's frequent re-renders.
 */

const libNodeString = require('pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeString.js');
const libNodeNumber = require('pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeNumber.js');
const libNodeBoolean = require('pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeBoolean.js');
const libNodeNull = require('pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeNull.js');
const libNodeObject = require('pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeObject.js');
const libNodeArray = require('pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeArray.js');

const libProvenance = require('../Config-Provenance.js');

// Short pill text + full tooltip per scope.
const SCOPE_SHORT = { Global: 'Default', Customer: 'Customer', Contract: 'Contract', Project: 'Project', User: 'You' };
const SCOPE_FULL = { Global: 'Platform Default', Customer: 'Customer', Contract: 'Contract', Project: 'Project', User: 'My Settings' };

/**
 * Resolve a dot-address (e.g. 'AppData.ConfigViewer.ProvenanceMap') from the fable/pict root.
 * @param {object} pFable
 * @param {string} pAddress
 * @return {*}
 */
function resolveAddress(pFable, pAddress)
{
	if (!pAddress)
	{
		return null;
	}
	let tmpCurrent = pFable;
	const tmpParts = String(pAddress).split('.');
	for (let i = 0; i < tmpParts.length; i++)
	{
		if (tmpCurrent === null || tmpCurrent === undefined)
		{
			return null;
		}
		tmpCurrent = tmpCurrent[tmpParts[i]];
	}
	return tmpCurrent;
}

/**
 * Escape for an HTML attribute (the title).
 * @param {string} pString
 * @return {string}
 */
function escapeAttribute(pString)
{
	return String(pString).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * Stamp pNode.ProvenanceRowClass + pNode.ProvenanceBadgeHTML from the provenance map at the view's
 * ProvenanceDataAddress. Container nodes (and the CustomProperties flat-blob mode, where the map is
 * empty) get no badge.
 * @param {object} pView the ProvenanceObjectEditor view
 * @param {object} pNode the node descriptor
 */
function applyProvenanceToNode(pView, pNode)
{
	const tmpAddress = (pView.options && pView.options.ProvenanceDataAddress) || 'AppData.ConfigViewer.ProvenanceMap';
	const tmpMap = resolveAddress(pView.fable, tmpAddress) || {};
	const tmpProv = libProvenance.lookupProvenance(tmpMap, pNode.Path);
	if (!tmpProv)
	{
		pNode.ProvenanceRowClass = '';
		pNode.ProvenanceBadgeHTML = '';
		return;
	}
	const tmpScope = tmpProv.Scope;
	const tmpClass = 'cfg-prov-' + String(tmpScope).toLowerCase();
	pNode.ProvenanceRowClass = tmpClass;
	pNode.ProvenanceBadgeHTML = '<span class="cfg-prov-badge ' + tmpClass + '" title="Set at '
		+ escapeAttribute(SCOPE_FULL[tmpScope] || tmpScope) + '">' + escapeAttribute(SCOPE_SHORT[tmpScope] || tmpScope) + '</span>';
}

/**
 * Build a provenance-aware subclass of a base node renderer.
 * @param {Function} pBaseClass
 * @return {Function}
 */
function makeProvenanceRenderer(pBaseClass)
{
	return class extends pBaseClass
	{
		renderNodeHTML(pNode, pValue, pOptions)
		{
			applyProvenanceToNode(this._ObjectEditorView, pNode);
			return super.renderNodeHTML(pNode, pValue, pOptions);
		}
	};
}

module.exports =
{
	applyProvenanceToNode,
	// Service-type name -> subclass, plus the node-type key it serves.
	Renderers:
	[
		{ TypeKey: 'string', ServiceType: 'PictViewProvNodeString', Class: makeProvenanceRenderer(libNodeString) },
		{ TypeKey: 'number', ServiceType: 'PictViewProvNodeNumber', Class: makeProvenanceRenderer(libNodeNumber) },
		{ TypeKey: 'boolean', ServiceType: 'PictViewProvNodeBoolean', Class: makeProvenanceRenderer(libNodeBoolean) },
		{ TypeKey: 'null', ServiceType: 'PictViewProvNodeNull', Class: makeProvenanceRenderer(libNodeNull) },
		{ TypeKey: 'object', ServiceType: 'PictViewProvNodeObject', Class: makeProvenanceRenderer(libNodeObject) },
		{ TypeKey: 'array', ServiceType: 'PictViewProvNodeArray', Class: makeProvenanceRenderer(libNodeArray) },
	],
};

},{"../Config-Provenance.js":1078,"pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeArray.js":959,"pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeBoolean.js":960,"pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeNull.js":961,"pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeNumber.js":962,"pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeObject.js":963,"pict-section-objecteditor/source/views/PictView-ObjectEditor-NodeString.js":964}],1080:[function(require,module,exports){
'use strict';
/**
 * ProvenanceObjectEditor — pict-section-objecteditor specialized to show, per value, WHICH SCOPE set
 * it (a colored left border on the row + a small scope badge after the value). It does this WITHOUT
 * overriding any template hash (which would risk clobbering other ObjectEditor instances): it appends
 * {~D:Record.ProvenanceBadgeHTML~} to the value/summary macros and a {~D:Record.ProvenanceRowClass~}
 * to RowOpen — macros are read from THIS view's own options, so the change is fully isolated. The
 * per-node fields are stamped by the swapped-in provenance node renderers (ProvenanceNodeRenderers).
 *
 * Options of note (set per-instance by the host, like ProjectWorkspace embeds the base editor):
 *   ObjectDataAddress      — the object to edit (e.g. 'AppData.ConfigViewer.EditingConfig')
 *   ProvenanceDataAddress  — the provenance map (e.g. 'AppData.ConfigViewer.ProvenanceMap'); empty map => no badges
 *   Editable               — read-only vs editable
 */

const libBaseObjectEditor = require('pict-section-objecteditor');
const libProvRenderers = require('./ProvenanceNodeRenderers.js');

const _BaseConfig = libBaseObjectEditor.default_configuration;
const _BaseMacros = _BaseConfig.MacroTemplates.Node;
const _Badge = '{~D:Record.ProvenanceBadgeHTML~}';

// Override only the macros that render a value/summary (append the badge) and RowOpen (scope class).
// Everything else is inherited unchanged. Templates are NOT touched.
const _ProvenanceMacros = Object.assign({}, _BaseMacros,
	{
		RowOpen: '<div class="pict-oe-row {~D:Record.ProvenanceRowClass~}" style="padding-left:{~D:Record.PaddingLeft~}px" data-path="{~D:Record.EscapedPath~}">',
		ValueStringEditable: _BaseMacros.ValueStringEditable + _Badge,
		ValueStringReadOnly: _BaseMacros.ValueStringReadOnly + _Badge,
		ValueNumberEditable: _BaseMacros.ValueNumberEditable + _Badge,
		ValueNumberReadOnly: _BaseMacros.ValueNumberReadOnly + _Badge,
		ValueBooleanEditable: _BaseMacros.ValueBooleanEditable + _Badge,
		ValueBooleanReadOnly: _BaseMacros.ValueBooleanReadOnly + _Badge,
		ValueNull: _BaseMacros.ValueNull + _Badge,
		// Summary renders for arrays (atomic leaf -> badged) AND objects (container -> empty badge).
		Summary: _BaseMacros.Summary + _Badge,
	});

const _ProvenanceCSS = /*css*/`
.cfg-prov-badge { display:inline-block; margin-left:.5rem; padding:0 .42rem; border-radius:9px; font-size:.62rem; font-weight:600; line-height:1.55; vertical-align:middle; letter-spacing:.02em; }
.pict-oe-row.cfg-prov-global { border-left:3px solid var(--theme-color-border-default,#dcdcdc); }
.cfg-prov-badge.cfg-prov-global { background:var(--theme-color-background-tertiary,#ececec); color:var(--theme-color-text-muted,#777); }
.pict-oe-row.cfg-prov-customer { border-left:3px solid var(--theme-color-brand-primary,#2e7d74); }
.cfg-prov-badge.cfg-prov-customer { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; }
.pict-oe-row.cfg-prov-contract { border-left:3px solid var(--theme-color-info,#3098c8); }
.cfg-prov-badge.cfg-prov-contract { background:var(--theme-color-info,#3098c8); color:#fff; }
.pict-oe-row.cfg-prov-project { border-left:3px solid var(--theme-color-success,#3aa76d); }
.cfg-prov-badge.cfg-prov-project { background:var(--theme-color-success,#3aa76d); color:#fff; }
.pict-oe-row.cfg-prov-user { border-left:3px solid var(--theme-color-warning,#e0a800); }
.cfg-prov-badge.cfg-prov-user { background:var(--theme-color-warning,#e0a800); color:#fff; }
`;

class ProvenanceObjectEditor extends libBaseObjectEditor
{
	/**
	 * Build the default renderers, then swap in the provenance-aware subclasses (registered as service
	 * types and instantiated exactly like the base does).
	 */
	onBeforeInitialize()
	{
		const tmpResult = super.onBeforeInitialize();
		libProvRenderers.Renderers.forEach((pEntry) =>
		{
			if (!this.fable.servicesMap.hasOwnProperty(pEntry.ServiceType))
			{
				this.fable.addServiceType(pEntry.ServiceType, pEntry.Class);
			}
			const tmpRenderer = this.fable.instantiateServiceProviderWithoutRegistration(pEntry.ServiceType);
			tmpRenderer._ObjectEditorView = this;
			this._NodeRenderers[pEntry.TypeKey] = tmpRenderer;
		});
		return tmpResult;
	}
}

module.exports = ProvenanceObjectEditor;
module.exports.default_configuration = Object.assign({}, _BaseConfig,
	{
		ViewIdentifier: 'ProvenanceObjectEditor',
		ProvenanceDataAddress: 'AppData.ConfigViewer.ProvenanceMap',
		MacroTemplates: { Node: _ProvenanceMacros },
		CSS: (_BaseConfig.CSS || '') + _ProvenanceCSS,
	});

},{"./ProvenanceNodeRenderers.js":1079,"pict-section-objecteditor":957}],1081:[function(require,module,exports){
'use strict';

const { buildCustomerConfigScreenView } = require('./CustomerConfigScreen-View.js');

/**
 * The customer configuration screens built on CustomerConfigScreen: each one's provider, view, route and title.
 * The application registers them all from here. The router names each Route explicitly, as it does every route
 * (web/lims's manifest test reads them from its source).
 *
 * @type {Array<{ Route: string, Provider: any, ViewIdentifier: string, View: any, ViewConfiguration: Record<string, any> }>}
 */
const SCREENS =
[
	{
		Route: '/SampleScanningConfig',
		Provider: require('./SampleScanningConfig-Provider.js'),
		ViewIdentifier: 'SampleScanningConfig-View',
		MountID: 'SSC-Detail',
		Title: 'Sample Scanning',
		Subtitle: 'What scanning a sample label does: whether Fieldbook on iPad offers its scanner, and the status a sample takes when it is scanned into a location.',
	},
	{
		Route: '/FormAccess',
		Provider: require('./FormAccessConfig-Provider.js'),
		ViewIdentifier: 'FormAccessConfig-View',
		MountID: 'FAC-Detail',
		Title: 'Who Can Open New Forms',
		Subtitle: 'For each type of form, the roles that can open and edit a new one as soon as it is created, on any project.',
	},
	{
		Route: '/FieldbookDashboards',
		Provider: require('./FieldbookDashboardsConfig-Provider.js'),
		ViewIdentifier: 'FieldbookDashboardsConfig-View',
		MountID: 'FDC-Detail',
		Title: 'Fieldbook Dashboards',
		Subtitle: 'The classic dashboards this customer’s projects offer in Fieldbook, on the web and on iPad.',
	},
].map((pScreen) =>
{
	const tmpBuilt = buildCustomerConfigScreenView(
		{
			ViewIdentifier: pScreen.ViewIdentifier,
			ProviderHash: pScreen.Provider.SCREEN.Hash,
			MountID: pScreen.MountID,
			Title: pScreen.Title,
			Subtitle: pScreen.Subtitle,
		});
	if (`#${pScreen.MountID}` !== pScreen.Provider.SCREEN.Mount)
	{
		throw new Error(`${pScreen.Provider.SCREEN.Hash}: its mount ${pScreen.Provider.SCREEN.Mount} is not the view's #${pScreen.MountID}`);
	}
	return { Route: pScreen.Route, Provider: pScreen.Provider, ViewIdentifier: pScreen.ViewIdentifier, View: tmpBuilt.View, ViewConfiguration: tmpBuilt.default_configuration };
});

/**
 * Register every screen's provider and view.
 *
 * @param {any} pPict
 */
function registerConfigScreens(pPict)
{
	SCREENS.forEach((pScreen) =>
	{
		pPict.addProvider(pScreen.Provider.SCREEN.Hash, pScreen.Provider.default_configuration, pScreen.Provider);
		pPict.addView(pScreen.ViewIdentifier, pScreen.ViewConfiguration, pScreen.View);
	});
}

module.exports = { SCREENS, registerConfigScreens };

},{"./CustomerConfigScreen-View.js":1083,"./FieldbookDashboardsConfig-Provider.js":1084,"./FormAccessConfig-Provider.js":1085,"./SampleScanningConfig-Provider.js":1086}],1082:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

/**
 * @typedef {{ IDCustomer: number, Name: string }} CustomerChoice
 *
 * @typedef {Object} CustomerConfigScreenState
 * @property {boolean} Loaded
 * @property {boolean} Loading
 * @property {boolean} Saving
 * @property {boolean} Dirty
 * @property {string} Error
 * @property {string} Message
 * @property {number} TargetCustomerID
 * @property {string} TargetCustomerName
 * @property {Array<CustomerChoice>} Customers
 * @property {Record<string, string>} Snapshots - `<NamespaceKey>/<NamespaceValue>` → the JSON read at load, for the stale-write check
 *
 * @typedef {Object} ScreenIdentity
 * @property {string} Hash - the provider's registered hash
 * @property {string} StateKey - the AppData key holding the screen's state
 * @property {string} Mount - the CSS selector the screen renders into
 * @property {{ Entity: string, Action: string, Label: string }} Entitlement - the capability that opens the screen, and its task label
 */

/**
 * The shared plumbing of a configuration screen that edits one customer's settings: who may use it, which customer
 * it edits (a super user picks one, everyone else edits their own), reading and writing customer-level configuration,
 * and refusing to save over a value someone else changed after the screen loaded it.
 *
 * A subclass declares a static SCREEN (ScreenIdentity), then implements `loadCustomerAsync`, `saveAsync`,
 * `bodyHTML`, and `initialState`. Saving needs a customer administrator on the configuration service; the entitlement
 * only decides who sees the screen.
 */
class CustomerConfigScreenProvider extends libPictProvider
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	/** @return {ScreenIdentity} who this screen is: set by each subclass as its static SCREEN */
	get screen()
	{
		return /** @type {any} */ (this.constructor).SCREEN;
	}

	/** @return {string} the provider hash the screen's inline handlers call */
	get providerHash()
	{
		return this.screen.Hash;
	}

	/** @return {string} the AppData key this screen keeps its state under */
	get stateKey()
	{
		return this.screen.StateKey;
	}

	/** @return {string} the CSS selector of the screen's detail mount */
	get mount()
	{
		return this.screen.Mount;
	}

	/** @return {{ Entity: string, Action: string, Label: string }} the entitlement that opens the screen */
	get entitlement()
	{
		return this.screen.Entitlement;
	}

	/** @return {any} the Headlight REST client */
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	/** @return {CustomerConfigScreenState & Record<string, any>} */
	get state()
	{
		if (!this.pict.AppData[this.stateKey])
		{
			this.pict.AppData[this.stateKey] = Object.assign(
				{
					Loaded: false, Loading: false, Saving: false, Dirty: false, Error: '', Message: '',
					TargetCustomerID: 0, TargetCustomerName: '', Customers: [], Snapshots: {},
				}, this.initialState());
		}
		return this.pict.AppData[this.stateKey];
	}

	/** @return {Record<string, any>} the subclass's own state fields */
	initialState()
	{
		return {};
	}

	/** @return {Record<string, any>} the signed-in user's session */
	get currentUser()
	{
		return this.pict.AppData.CurrentUser || {};
	}

	/** @return {number} */
	callerCustomer()
	{
		return Number(this.currentUser.CustomerID) || 0;
	}

	/** @return {boolean} */
	isSuperUser()
	{
		return (Number(this.currentUser.UserRoleIndex) === 5) && (Number(this.currentUser.CustomerID) === 1);
	}

	/** @return {boolean} whether the signed-in user holds the screen's entitlement */
	can()
	{
		const tmpService = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpService || (typeof tmpService.can !== 'function'))
		{
			return true;
		}
		return tmpService.can(this.entitlement.Entity, this.entitlement.Action);
	}

	/**
	 * @param {string} pURL
	 * @return {Promise<any>} the body, or null on error
	 */
	_getJSON(pURL)
	{
		const tmpClient = this.restClient;
		if (!tmpClient)
		{
			return Promise.resolve(null);
		}
		return new Promise((fResolve) => tmpClient.getJSON(pURL, (pError, pBody) => fResolve(pError ? null : pBody)));
	}

	/**
	 * @param {string} pURL
	 * @param {Object} pBody
	 * @return {Promise<{ error: any, result: any }>}
	 */
	_postJSON(pURL, pBody)
	{
		const tmpClient = this.restClient;
		if (!tmpClient)
		{
			return Promise.resolve({ error: 'no client', result: null });
		}
		return new Promise((fResolve) => tmpClient.postJSON(pURL, pBody, (pError, pResult) => fResolve({ error: pError, result: pResult })));
	}

	/**
	 * @param {any} pValue
	 * @return {string}
	 */
	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[pChar]));
	}

	/**
	 * @param {any} pValue
	 * @return {string} a single-quoted JS string literal, HTML-escaped, for an inline onclick argument
	 */
	_arg(pValue)
	{
		return this._esc(JSON.stringify(String(pValue == null ? '' : pValue)).replace(/'/g, '\\u0027'));
	}

	/**
	 * Read one customer-level configuration value. A failed read throws, so a screen never offers to save over a
	 * value it could not see.
	 *
	 * @param {string} pNamespaceKey
	 * @param {string} pNamespaceValue
	 * @param {number} pIDCustomer
	 * @return {Promise<Record<string, any>>} the value, or {} when none is set
	 */
	async readCustomerConfigAsync(pNamespaceKey, pNamespaceValue, pIDCustomer)
	{
		const tmpMap = await this._getJSON(`Configuration/For/${pNamespaceKey}/In/Customer/${Number(pIDCustomer)}`);
		if (tmpMap === null)
		{
			throw new Error(`the saved ${pNamespaceKey} settings could not be read`);
		}
		const tmpValue = (tmpMap && tmpMap[pNamespaceValue] && (typeof tmpMap[pNamespaceValue] === 'object') && !Array.isArray(tmpMap[pNamespaceValue])) ? tmpMap[pNamespaceValue] : {};
		return JSON.parse(JSON.stringify(tmpValue));
	}

	/**
	 * Remember the value as read, so a save can tell whether someone else changed it in the meantime.
	 *
	 * @param {string} pNamespaceKey
	 * @param {string} pNamespaceValue
	 * @param {any} pValue
	 */
	rememberSnapshot(pNamespaceKey, pNamespaceValue, pValue)
	{
		this.state.Snapshots[`${pNamespaceKey}/${pNamespaceValue}`] = JSON.stringify(pValue || {});
	}

	/**
	 * Write one customer-level configuration value, replacing the whole value at that level, but only if the live
	 * value still equals what this screen loaded.
	 *
	 * @param {string} pNamespaceKey
	 * @param {string} pNamespaceValue
	 * @param {Record<string, any>} pValue
	 * @return {Promise<void>} rejects when the value changed since load or the write fails
	 */
	async writeCustomerConfigAsync(pNamespaceKey, pNamespaceValue, pValue)
	{
		const tmpIDCustomer = Number(this.state.TargetCustomerID);
		const tmpLive = await this.readCustomerConfigAsync(pNamespaceKey, pNamespaceValue, tmpIDCustomer);
		const tmpKey = `${pNamespaceKey}/${pNamespaceValue}`;
		if ((this.state.Snapshots[tmpKey] !== undefined) && (JSON.stringify(tmpLive) !== this.state.Snapshots[tmpKey]))
		{
			throw new Error('someone else changed these settings after you opened them. Reload the page to see their changes, then make yours again');
		}
		const tmpResult = await this._postJSON(`Configuration/Put/${pNamespaceKey}/${pNamespaceValue}/Customer/${tmpIDCustomer}`, { Config: pValue });
		if (tmpResult.error || (tmpResult.result && tmpResult.result.Error))
		{
			const tmpReason = (tmpResult.error && tmpResult.error.message) || (tmpResult.result && tmpResult.result.Error) || String(tmpResult.error);
			throw new Error(/40[13]/.test(tmpReason) ? 'saving these settings needs a customer administrator' : tmpReason);
		}
		this.rememberSnapshot(pNamespaceKey, pNamespaceValue, pValue);
	}

	/**
	 * Load the screen for the signed-in user's customer, or the customer a super user picked.
	 *
	 * @return {Promise<void>}
	 */
	async loadAsync()
	{
		const tmpState = this.state;
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			if (this.isSuperUser() && (tmpState.Customers.length < 1))
			{
				const tmpCustomers = await this._getJSON('Customers/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/2000');
				tmpState.Customers = Array.isArray(tmpCustomers) ? tmpCustomers.map((pCustomer) => ({ IDCustomer: Number(pCustomer.IDCustomer), Name: pCustomer.Name })) : [];
			}
			if (!tmpState.TargetCustomerID)
			{
				tmpState.TargetCustomerID = this.callerCustomer();
			}
			const tmpCustomer = await this._getJSON(`Customer/${Number(tmpState.TargetCustomerID)}`);
			tmpState.TargetCustomerName = (tmpCustomer && tmpCustomer.Name) || '';
			tmpState.Snapshots = {};
			await this.loadCustomerAsync(Number(tmpState.TargetCustomerID));
			tmpState.Dirty = false;
			tmpState.Loaded = true;
		}
		catch (pError)
		{
			tmpState.Loaded = false;
			tmpState.Error = `Could not load these settings: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	/**
	 * Read everything the screen edits for one customer into state.
	 *
	 * @param {number} pIDCustomer
	 * @return {Promise<void>}
	 */
	async loadCustomerAsync(pIDCustomer)
	{
		this.state.TargetCustomerID = Number(pIDCustomer) || 0;
	}

	/**
	 * @param {number|string} pIDCustomer
	 * @return {Promise<void>}
	 */
	async selectCustomer(pIDCustomer)
	{
		if (this.state.Dirty && (typeof window !== 'undefined') && (typeof window.confirm === 'function') && !window.confirm('You have unsaved changes. Switch customer and lose them?'))
		{
			this.render();
			return;
		}
		this.state.TargetCustomerID = Number(pIDCustomer) || 0;
		await this.loadAsync();
	}

	/** Note an unsaved edit and clear the last save's message. */
	markDirty()
	{
		this.state.Dirty = true;
		this.state.Message = '';
	}

	/**
	 * Save every value the screen edits. Subclasses write with writeCustomerConfigAsync.
	 *
	 * @return {Promise<void>}
	 */
	async saveAsync()
	{
		return Promise.resolve();
	}

	/** @return {string} the success message after a save */
	savedMessage()
	{
		return 'Saved.';
	}

	/** @return {Promise<void>} */
	async save()
	{
		const tmpState = this.state;
		if (tmpState.Saving || !tmpState.Dirty || !tmpState.Loaded)
		{
			return;
		}
		tmpState.Saving = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			await this.saveAsync();
			tmpState.Dirty = false;
			tmpState.Message = this.savedMessage();
		}
		catch (pError)
		{
			tmpState.Error = `Not saved: ${(pError && pError.message) || pError}.`;
		}
		finally
		{
			tmpState.Saving = false;
			this.render();
		}
	}

	/** @return {string} the customer the screen edits, as a picker for a super user */
	customerHTML()
	{
		const tmpState = this.state;
		if (this.isSuperUser() && tmpState.Customers.length)
		{
			const tmpOptions = tmpState.Customers.map((pCustomer) => `<option value="${Number(pCustomer.IDCustomer)}" ${Number(pCustomer.IDCustomer) === Number(tmpState.TargetCustomerID) ? 'selected' : ''}>${this._esc(pCustomer.Name)}</option>`).join('');
			return `<div class="ccs-field"><label class="ccs-label">Customer</label><select class="ccs-select" onchange="_Pict.providers.${this.providerHash}.selectCustomer(this.value)">${tmpOptions}</select></div>`;
		}
		return `<div class="ccs-field"><label class="ccs-label">Customer</label><span class="ccs-customer">${this._esc(tmpState.TargetCustomerName)}</span></div>`;
	}

	// --- Search pickers (lists of hundreds are searched, not listed) ----------------------------------------------

	/**
	 * The choices a picker offers for some typed text. Subclasses answer for each picker they draw.
	 *
	 * @param {string} pPicker - the picker's name
	 * @param {string} pText - what was typed
	 * @return {Array<{ Value: string, Label: string, Sub?: string }>}
	 */
	pickerChoices(pPicker, pText)
	{
		return [];
	}

	/**
	 * A choice was picked. Subclasses act on it.
	 *
	 * @param {string} pPicker
	 * @param {string} pValue
	 * @return {void}
	 */
	pickerChose(pPicker, pValue)
	{
		this.markDirty();
	}

	/**
	 * @param {string} pPicker
	 * @return {string} the element id of the picker's suggestion list
	 */
	_pickerID(pPicker)
	{
		return `CCS-${this.providerHash}-${String(pPicker).replace(/[^A-Za-z0-9_-]/g, '_')}`;
	}

	/**
	 * @param {string} pPicker
	 * @param {string} pPlaceholder
	 * @return {string} a search box whose matches list under it
	 */
	pickerHTML(pPicker, pPlaceholder)
	{
		const tmpID = this._pickerID(pPicker);
		return `<div class="ccs-picker">
			<input id="${tmpID}-Input" class="ccs-input" type="search" autocomplete="off" placeholder="${this._esc(pPlaceholder)}"
				oninput="_Pict.providers.${this.providerHash}.searchPicker(${this._arg(pPicker)}, this.value)"
				onfocus="_Pict.providers.${this.providerHash}.searchPicker(${this._arg(pPicker)}, this.value)">
			<div id="${tmpID}-Suggest" class="ccs-suggest"></div>
		</div>`;
	}

	/**
	 * Show a picker's matches without redrawing the box being typed in.
	 *
	 * @param {string} pPicker
	 * @param {string} pText
	 */
	searchPicker(pPicker, pText)
	{
		const tmpSelector = `#${this._pickerID(pPicker)}-Suggest`;
		if ((typeof document === 'undefined') || !document.querySelector(tmpSelector))
		{
			return;
		}
		this.pict.ContentAssignment.assignContent(tmpSelector, this.pickerSuggestionsHTML(pPicker, pText));
	}

	/**
	 * @param {string} pPicker
	 * @param {string} pText
	 * @return {string} up to 12 matches, and how many more there are
	 */
	pickerSuggestionsHTML(pPicker, pText)
	{
		const tmpLimit = 12;
		const tmpChoices = this.pickerChoices(pPicker, pText);
		const tmpRows = tmpChoices.slice(0, tmpLimit).map((pChoice) =>
			`<button type="button" class="ccs-suggestion" onclick="_Pict.providers.${this.providerHash}.choosePicker(${this._arg(pPicker)}, ${this._arg(pChoice.Value)})">${this._esc(pChoice.Label)}${pChoice.Sub ? ` <span class="ccs-sub">${this._esc(pChoice.Sub)}</span>` : ''}</button>`).join('');
		const tmpMore = (tmpChoices.length > tmpLimit) ? `<div class="ccs-more">${tmpChoices.length - tmpLimit} more. Keep typing to narrow the list.</div>` : '';
		if (!tmpRows)
		{
			return String(pText || '').trim() ? '<div class="ccs-more">Nothing matches.</div>' : '';
		}
		return `${tmpRows}${tmpMore}`;
	}

	/**
	 * @param {string} pPicker
	 * @param {string} pValue
	 */
	choosePicker(pPicker, pValue)
	{
		this.pickerChose(pPicker, pValue);
		this.render();
		const tmpInput = (typeof document !== 'undefined') ? document.getElementById(`${this._pickerID(pPicker)}-Input`) : null;
		if (tmpInput)
		{
			tmpInput.focus();
		}
	}

	/**
	 * @param {Array<{ Value: string, Label: string, Sub?: string }>} pChoices
	 * @param {string} pText
	 * @return {Array<{ Value: string, Label: string, Sub?: string }>} the choices whose label or detail holds every typed word
	 */
	static filterChoices(pChoices, pText)
	{
		const tmpWords = String(pText || '').toLowerCase().split(/\s+/).filter(Boolean);
		return (pChoices || []).filter((pChoice) =>
		{
			const tmpHaystack = `${pChoice.Label} ${pChoice.Sub || ''} ${pChoice.Value}`.toLowerCase();
			return tmpWords.every((pWord) => tmpHaystack.includes(pWord));
		});
	}

	/** @return {string} the save button, its unsaved-changes hint and the outcome of the last save */
	saveBarHTML()
	{
		const tmpState = this.state;
		return `<div class="ccs-savebar">
			<button class="ccs-save" ${(tmpState.Saving || !tmpState.Dirty) ? 'disabled' : ''} onclick="_Pict.providers.${this.providerHash}.save()">${tmpState.Saving ? 'Saving…' : 'Save'}</button>
			${tmpState.Dirty ? '<span class="ccs-unsaved">Unsaved changes</span>' : ''}
		</div>`;
	}

	/** @return {string} the screen's own content */
	bodyHTML()
	{
		return '';
	}

	/** @return {string} */
	renderHTML()
	{
		const tmpState = this.state;
		if (!this.can())
		{
			return `<div class="ccs-empty">You don’t have the “${this._esc(this.entitlement.Label)}” entitlement.</div>`;
		}
		if (tmpState.Loading)
		{
			return '<div class="ccs-empty"><i class="fas fa-spinner fa-spin"></i> Loading…</div>';
		}
		const tmpMessages = `${tmpState.Message ? `<div class="ccs-msg">${this._esc(tmpState.Message)}</div>` : ''}${tmpState.Error ? `<div class="ccs-error">${this._esc(tmpState.Error)}</div>` : ''}`;
		if (!tmpState.Loaded)
		{
			return `${this.customerHTML()}${tmpMessages}`;
		}
		return `${this.customerHTML()}${tmpMessages}${this.bodyHTML()}${this.saveBarHTML()}`;
	}

	/** @return {boolean} whether the screen's mount was on the page to paint */
	render()
	{
		if ((typeof document === 'undefined') || !document.querySelector(this.mount))
		{
			return false;
		}
		this.pict.ContentAssignment.assignContent(this.mount, this.renderHTML());
		return true;
	}
}

module.exports = CustomerConfigScreenProvider;

},{"pict-provider":845}],1083:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

const CSS_HASH = 'CustomerConfigScreen';

const CSS = /*css*/`
	.ccs-wrap { padding: 1.25rem 1.5rem 2rem; }
	.ccs-head { margin: 0 0 1rem; }
	.ccs-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; max-width:52rem; }
	.ccs-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:18rem; max-width:58rem; }
	.ccs-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:12rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
	.ccs-field { margin:0 0 0.9rem; }
	.ccs-label { display:block; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.35rem; }
	.ccs-customer { font-size:0.98rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-select, .ccs-input { font-size:0.88rem; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); box-sizing:border-box; max-width:100%; }
	.ccs-select { min-width:16rem; }
	.ccs-input { width:100%; max-width:28rem; }
	.ccs-section { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:1rem; margin-top:1rem; }
	.ccs-section:first-of-type { border-top:none; padding-top:0; margin-top:0; }
	.ccs-section-title { font-size:1.05rem; font-weight:700; margin:0 0 0.3rem; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-help { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.8rem; }
	.ccs-note { font-size:0.84rem; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; margin:0 0 1rem; }
	.ccs-warn { color:var(--theme-color-status-warning,#b7791f); }
	.ccs-check { display:flex; gap:0.5rem; align-items:flex-start; font-size:0.9rem; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.5rem; cursor:pointer; }
	.ccs-check input { margin-top:0.2rem; }
	.ccs-checks { display:flex; flex-wrap:wrap; gap:0.3rem 1.1rem; margin:0 0 0.8rem; }
	.ccs-checks .ccs-check { margin:0; }
	.ccs-table { width:100%; border-collapse:collapse; font-size:0.88rem; margin:0 0 0.8rem; }
	.ccs-table th { text-align:left; font-size:0.7rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); padding:0.35rem 0.5rem; border-bottom:1px solid var(--theme-color-border-default,#d7dce3); }
	.ccs-table td { padding:0.45rem 0.5rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); vertical-align:top; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-table tr.is-selected td { background:var(--theme-color-background-selected,#f5f5fe); }
	.ccs-sub { display:block; font-size:0.74rem; color:var(--theme-color-text-muted,#6b7686); }
	.ccs-chips { display:flex; flex-wrap:wrap; gap:0.3rem; align-items:center; }
	.ccs-chip { display:inline-flex; align-items:center; gap:0.25rem; font-size:0.8rem; color:var(--theme-color-text-primary,#1f2733); }
	.ccs-chip { background:var(--theme-color-background-selected,#eef0fe); border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:999px; padding:0.08rem 0.2rem 0.08rem 0.6rem; }
	.ccs-chip.is-unknown { border-style:dashed; color:var(--theme-color-status-warning,#b7791f); }
	.ccs-chip-x { border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.95rem; line-height:1; padding:0 0.3rem; }
	.ccs-btn { font-size:0.82rem; font-weight:600; padding:0.32rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; white-space:nowrap; }
	.ccs-btn[disabled] { opacity:0.5; cursor:default; }
	.ccs-btn.is-danger:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
	.ccs-row { display:flex; gap:0.5rem; align-items:center; flex-wrap:wrap; margin:0 0 0.8rem; }
	.ccs-picker { position:relative; display:inline-flex; flex-direction:column; min-width:16rem; max-width:28rem; }
	.ccs-suggest { display:flex; flex-direction:column; }
	.ccs-suggest:empty { display:none; }
	.ccs-suggestion { text-align:left; font-size:0.85rem; padding:0.35rem 0.6rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-top:none; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
	.ccs-suggestion:hover, .ccs-suggestion:focus { background:var(--theme-color-background-selected,#f5f5fe); }
	.ccs-more { font-size:0.78rem; color:var(--theme-color-text-muted,#6b7686); padding:0.3rem 0.6rem; }
	.ccs-savebar { margin:1.1rem 0 0.2rem; display:flex; gap:0.8rem; align-items:center; }
	.ccs-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
	.ccs-save[disabled] { opacity:0.6; cursor:default; }
	.ccs-unsaved { font-size:0.82rem; color:var(--theme-color-status-warning,#b7791f); }
	.ccs-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
	.ccs-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
	@media (max-width: 640px)
	{
		.ccs-wrap { padding: 1rem; }
		.ccs-select, .ccs-picker { min-width:0; width:100%; }
		.ccs-table th:nth-child(3), .ccs-table td:nth-child(3) { display:none; }
	}
`;

/**
 * @typedef {Object} CustomerConfigScreenViewOptions
 * @property {string} ViewIdentifier - the view's hash, which the router renders
 * @property {string} ProviderHash - the screen's provider
 * @property {string} MountID - the id of the element the provider renders into
 * @property {string} Title
 * @property {string} Subtitle
 */

/**
 * Build the thin view shell of a customer configuration screen: a header and one mount the screen's provider fills.
 * Every such screen shares one stylesheet.
 *
 * @param {CustomerConfigScreenViewOptions} pOptions
 * @return {{ View: typeof libPictView, default_configuration: Record<string, any> }}
 */
function buildCustomerConfigScreenView(pOptions)
{
	/** The screen's view: a header and one mount its provider fills. */
	class CustomerConfigScreenView extends libPictView
	{
		/** @return {any} the screen's provider */
		get provider()
		{
			return this.pict.providers[pOptions.ProviderHash];
		}

		/**
		 * @param {any} pRenderable
		 * @return {any}
		 */
		onAfterRender(pRenderable)
		{
			this.pict.CSSMap.injectCSS();
			const tmpProvider = this.provider;
			if (tmpProvider)
			{
				tmpProvider.render();
				if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading)
				{
					tmpProvider.loadAsync();
				}
			}
			return super.onAfterRender(pRenderable);
		}
	}

	const tmpTemplateHash = `${pOptions.ViewIdentifier}-Wrap`;
	const tmpEsc = (pValue) => String(pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[pChar]));
	return {
		View: CustomerConfigScreenView,
		default_configuration:
		{
			ViewIdentifier: pOptions.ViewIdentifier,
			DefaultRenderable: tmpTemplateHash,
			DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
			AutoRender: false,
			CSSHash: CSS_HASH,
			CSS: CSS,
			Templates:
			[
				{
					Hash: tmpTemplateHash,
					Template: /*html*/`
						<div class="ccs-wrap">
							<div class="ccs-head">
								<h1 class="ccs-title">${tmpEsc(pOptions.Title)}</h1>
								<p class="ccs-subtitle">${tmpEsc(pOptions.Subtitle)}</p>
							</div>
							<div id="${pOptions.MountID}" class="ccs-main"></div>
						</div>`,
				},
			],
			Renderables:
			[
				{
					RenderableHash: tmpTemplateHash,
					TemplateHash: tmpTemplateHash,
					DestinationAddress: '#PlatformConfiguration-Application-Container',
					RenderMethod: 'replace',
				},
			],
		},
	};
}

module.exports = { buildCustomerConfigScreenView, CSS_HASH };

},{"pict-view":1053}],1084:[function(require,module,exports){
'use strict';

const libCustomerConfigScreen = require('./CustomerConfigScreen-Provider.js');

// Fieldbook web reads `Configuration/For/Dashboards` on a project (web/fieldbook/app/scripts/app.routes.js); platform
// data operations lists the same entries to Fieldbook iOS as `Kind: Legacy`. Shape and rules:
// tools/scripts/dashboards_config/README.md.
const NAMESPACE = 'Dashboards';

/**
 * The classic dashboards built to run inside Fieldbook (injected into the page, not framed). Adding one here is an
 * engineering change: a dashboard has to be built for the embed, and only its own files may be listed, never the
 * standalone page's assets shim.
 *
 * @type {Array<{ Key: string, DashboardHash: string, DisplayName: string, Description: string, EntryPoint: string, Config: Record<string, any>, AddSample: boolean }>}
 */
const EMBEDDABLE_DASHBOARDS =
[
	{
		Key: 'MaterialLineItemSamples', DashboardHash: 'materials_samples', DisplayName: 'Sample Plan',
		Description: 'A project’s sample plan, its samples and its failing samples.',
		EntryPoint: 'dashboard.js', Config: { ObservationType: '', ShowAddSample: false }, AddSample: true,
	},
];

/**
 * @typedef {Object} FieldbookDashboardEntry
 * @property {string} Key - the entry's name in the Dashboards configuration
 * @property {Record<string, any>} Value - the entry as it will be saved
 * @property {boolean} Platform - set for every customer at Global level
 * @property {boolean} Removed
 * @property {boolean} Dirty
 */

/**
 * The entry to save. Fieldbook reads `Config.ObservationType` without a guard, and the configuration service stores an
 * empty object as nothing at all, so `Config` always keeps at least one key.
 *
 * @param {Record<string, any>} pEntry
 * @return {Record<string, any>}
 */
function normalizeEntry(pEntry)
{
	const tmpEntry = JSON.parse(JSON.stringify(pEntry || {}));
	if (!tmpEntry.Config || (typeof tmpEntry.Config !== 'object') || Array.isArray(tmpEntry.Config))
	{
		tmpEntry.Config = {};
	}
	if (!Object.prototype.hasOwnProperty.call(tmpEntry.Config, 'ObservationType'))
	{
		tmpEntry.Config.ObservationType = '';
	}
	return tmpEntry;
}

/**
 * FieldbookDashboardsConfig: the #/FieldbookDashboards screen ("Fieldbook Dashboards"). The classic dashboards a
 * customer's projects offer in Fieldbook on the web and on iPad, and whether the Sample Plan dashboard shows its New
 * Sample buttons. Who sees each one is set on Dashboard Access, so the same entitlement opens both screens.
 */
class FieldbookDashboardsConfigProvider extends libCustomerConfigScreen
{
	/** @return {Record<string, any>} */
	initialState()
	{
		return { Entries: [] };
	}

	/**
	 * @param {number} pIDCustomer
	 * @return {Promise<void>}
	 */
	async loadCustomerAsync(pIDCustomer)
	{
		const tmpState = this.state;
		const tmpMerged = await this._getJSON(`Configuration/For/${NAMESPACE}/In/Customer/${Number(pIDCustomer)}`);
		const tmpPlatform = await this._getJSON(`Configuration/For/${NAMESPACE}/In/Global/0`);
		if ((tmpMerged === null) || (tmpPlatform === null))
		{
			throw new Error('the saved dashboards could not be read');
		}
		tmpState.Entries = Object.keys(tmpMerged || {})
			.filter((pKey) => tmpMerged[pKey] && (typeof tmpMerged[pKey] === 'object') && !Array.isArray(tmpMerged[pKey]))
			.sort()
			.map((pKey) =>
			{
				this.rememberSnapshot(NAMESPACE, pKey, tmpMerged[pKey]);
				return { Key: pKey, Value: JSON.parse(JSON.stringify(tmpMerged[pKey])), Platform: !!(tmpPlatform && tmpPlatform[pKey]), Removed: false, Dirty: false };
			});
	}

	/** @return {Promise<void>} */
	async saveAsync()
	{
		const tmpState = this.state;
		for (const tmpEntry of tmpState.Entries.filter((pEntry) => pEntry.Dirty))
		{
			await this.writeCustomerConfigAsync(NAMESPACE, tmpEntry.Key, tmpEntry.Removed ? {} : normalizeEntry(tmpEntry.Value));
			tmpEntry.Dirty = false;
		}
		tmpState.Entries = tmpState.Entries.filter((pEntry) => !pEntry.Removed);
	}

	/** @return {string} */
	savedMessage()
	{
		return 'Saved. Fieldbook shows the change the next time a project is opened, within about 15 minutes.';
	}

	// --- Edits ----------------------------------------------------------------------------------------------------

	/**
	 * @param {string} pKey
	 * @return {FieldbookDashboardEntry|undefined}
	 */
	_entry(pKey)
	{
		return this.state.Entries.find((pEntry) => pEntry.Key === pKey);
	}

	/**
	 * @param {string} pKey
	 * @param {'DisplayName'|'Description'} pField
	 * @param {string} pValue
	 */
	setText(pKey, pField, pValue)
	{
		const tmpEntry = this._entry(pKey);
		if (!tmpEntry || ![ 'DisplayName', 'Description' ].includes(pField))
		{
			return;
		}
		tmpEntry.Value[pField] = String(pValue || '').trim();
		tmpEntry.Dirty = true;
		this.markDirty();
		this.render();
	}

	/**
	 * @param {string} pKey
	 * @param {boolean} pOn
	 */
	setShowAddSample(pKey, pOn)
	{
		const tmpEntry = this._entry(pKey);
		if (!tmpEntry)
		{
			return;
		}
		tmpEntry.Value = normalizeEntry(tmpEntry.Value);
		tmpEntry.Value.Config.ShowAddSample = !!pOn;
		tmpEntry.Dirty = true;
		this.markDirty();
		this.render();
	}

	/** @param {string} pKey */
	toggleRemoved(pKey)
	{
		const tmpEntry = this._entry(pKey);
		if (!tmpEntry || tmpEntry.Platform)
		{
			return;
		}
		tmpEntry.Removed = !tmpEntry.Removed;
		tmpEntry.Dirty = true;
		this.markDirty();
		this.render();
	}

	/** @param {string} pKey - an EMBEDDABLE_DASHBOARDS key */
	addDashboard(pKey)
	{
		const tmpTemplate = EMBEDDABLE_DASHBOARDS.find((pDashboard) => pDashboard.Key === pKey);
		if (!tmpTemplate)
		{
			return;
		}
		const tmpExisting = this._entry(pKey);
		if (tmpExisting)
		{
			tmpExisting.Removed = false;
		}
		else
		{
			const tmpValue = normalizeEntry({ DashboardHash: tmpTemplate.DashboardHash, DisplayName: tmpTemplate.DisplayName, Description: '', EntryPoint: tmpTemplate.EntryPoint, Config: tmpTemplate.Config });
			this.state.Entries.push({ Key: pKey, Value: tmpValue, Platform: false, Removed: false, Dirty: true });
		}
		this.markDirty();
		this.render();
	}

	// --- Rendering ------------------------------------------------------------------------------------------------

	/**
	 * @param {FieldbookDashboardEntry} pEntry
	 * @return {string}
	 */
	_entryHTML(pEntry)
	{
		const tmpKey = this._arg(pEntry.Key);
		const tmpValue = pEntry.Value || {};
		const tmpTemplate = EMBEDDABLE_DASHBOARDS.find((pDashboard) => pDashboard.DashboardHash === tmpValue.DashboardHash);
		const tmpAddSample = (tmpTemplate && tmpTemplate.AddSample) ?
			`<label class="ccs-check"><input type="checkbox" ${(tmpValue.Config && tmpValue.Config.ShowAddSample) ? 'checked' : ''} onchange="_Pict.providers.${this.providerHash}.setShowAddSample(${tmpKey}, this.checked)">
				Show the New Sample buttons. They appear only on projects that have a form type that starts a sample.</label>` :
			'';
		const tmpRemove = pEntry.Platform ?
			'<span class="ccs-sub">Set for every customer</span>' :
			`<button class="ccs-btn ${pEntry.Removed ? '' : 'is-danger'}" onclick="_Pict.providers.${this.providerHash}.toggleRemoved(${tmpKey})">${pEntry.Removed ? 'Keep' : 'Remove'}</button>`;
		if (pEntry.Removed)
		{
			return `<tr><td colspan="2"><s>${this._esc(tmpValue.DisplayName || pEntry.Key)}</s> <span class="ccs-sub ccs-warn">Removed when you save</span></td><td>${tmpRemove}</td></tr>`;
		}
		return `<tr>
			<td>
				<input class="ccs-input" type="text" value="${this._esc(tmpValue.DisplayName || '')}" aria-label="Name" onchange="_Pict.providers.${this.providerHash}.setText(${tmpKey}, 'DisplayName', this.value)">
				<span class="ccs-sub">${this._esc(tmpTemplate ? tmpTemplate.Description : (tmpValue.DashboardHash || pEntry.Key))}</span>
			</td>
			<td>${tmpAddSample}</td>
			<td>${tmpRemove}</td>
		</tr>`;
	}

	/** @return {string} the dashboards and the ones that can be added */
	bodyHTML()
	{
		const tmpState = this.state;
		const tmpRows = tmpState.Entries.map((pEntry) => this._entryHTML(pEntry)).join('');
		const tmpTable = tmpRows ?
			`<table class="ccs-table"><thead><tr><th>Name shown in Fieldbook</th><th>Options</th><th></th></tr></thead><tbody>${tmpRows}</tbody></table>` :
			'<div class="ccs-note">No dashboards, so Fieldbook doesn’t show a Dashboards menu on this customer’s projects.</div>';
		const tmpAddable = EMBEDDABLE_DASHBOARDS.filter((pDashboard) =>
		{
			const tmpEntry = this._entry(pDashboard.Key);
			return !tmpEntry || tmpEntry.Removed;
		});
		const tmpAdd = tmpAddable.map((pDashboard) => `<button class="ccs-btn" onclick="_Pict.providers.${this.providerHash}.addDashboard(${this._arg(pDashboard.Key)})"><i class="fas fa-plus"></i> ${this._esc(pDashboard.DisplayName)}</button>`).join(' ');
		return `<div class="ccs-section">
			<p class="ccs-help">These dashboards appear under Dashboards on every project in Fieldbook, on the web and on iPad. Who sees each one is set on <a href="#/DashboardAccess">Dashboard Access</a>.</p>
			${tmpTable}
			${tmpAdd ? `<div class="ccs-row"><span>Add:</span>${tmpAdd}</div>` : ''}
		</div>`;
	}
}

FieldbookDashboardsConfigProvider.SCREEN =
{
	Hash: 'FieldbookDashboardsConfig',
	StateKey: 'FieldbookDashboardsConfig',
	Mount: '#FDC-Detail',
	Entitlement: { Entity: 'DashboardAccess', Action: 'Configure', Label: 'Configure dashboard access' },
};

module.exports = FieldbookDashboardsConfigProvider;
module.exports.default_configuration = { ProviderIdentifier: 'FieldbookDashboardsConfig', AutoInitialize: true, AutoInitializeOrdinal: 0 };
module.exports.EMBEDDABLE_DASHBOARDS = EMBEDDABLE_DASHBOARDS;
module.exports.normalizeEntry = normalizeEntry;

},{"./CustomerConfigScreen-Provider.js":1082}],1085:[function(require,module,exports){
'use strict';

const libCustomerConfigScreen = require('./CustomerConfigScreen-Provider.js');

// Read by the API on every document create (api/headlight/ts_source/bundles/contentmanagement/DocumentAccess.ts
// assignmentByType): `{ Enabled, ByType: { <form type hash>: { Roles: [ <Role.PermissionLevel>, … ] } } }`.
const NAMESPACE = 'EntityOwnershipAssignment';
const NAMESPACE_VALUE = 'Document';
// PermissionLevel values that mark an administrative tier rather than name a role.
const TIER_LEVELS = [ 'CustomerAdmin', 'RoleManager', 'SuperAdmin' ];

/**
 * @typedef {{ Code: string, Names: Array<string> }} FormAccessRole - roles sharing one permission level
 * @typedef {{ Hash: string, Name: string, Standard: boolean }} FormAccessType
 */

/**
 * The role codes listed for each form type, from a loaded configuration. A type whose entry isn't an object grants
 * nothing on the server, so it is read as having no roles.
 *
 * @param {Record<string, any>} pConfig
 * @return {Record<string, Array<string>>}
 */
function rolesByType(pConfig)
{
	const tmpByType = (pConfig && pConfig.ByType && (typeof pConfig.ByType === 'object')) ? pConfig.ByType : {};
	/** @type {Record<string, Array<string>>} */
	const tmpResult = {};
	Object.keys(tmpByType).forEach((pHash) =>
	{
		const tmpEntry = tmpByType[pHash];
		const tmpRoles = (tmpEntry && (typeof tmpEntry === 'object') && Array.isArray(tmpEntry.Roles)) ? tmpEntry.Roles : [];
		tmpResult[pHash] = tmpRoles.filter((pCode) => (typeof pCode === 'string') && pCode.length > 0);
	});
	return tmpResult;
}

/**
 * The configuration to save. Keys the screen has no control for, on the whole value and on each type's entry, are
 * kept. A type left with no roles and nothing else is dropped, since it grants nothing.
 *
 * @param {Record<string, any>} pLoaded - the value as read
 * @param {boolean} pEnabled
 * @param {Record<string, Array<string>>} pRolesByType
 * @return {Record<string, any>}
 */
function buildAssignmentConfig(pLoaded, pEnabled, pRolesByType)
{
	const tmpLoaded = pLoaded || {};
	const tmpLoadedByType = (tmpLoaded.ByType && (typeof tmpLoaded.ByType === 'object')) ? tmpLoaded.ByType : {};
	const tmpByType = {};
	Object.keys(pRolesByType || {}).sort().forEach((pHash) =>
	{
		const tmpLoadedEntry = tmpLoadedByType[pHash];
		const tmpEntry = (tmpLoadedEntry && (typeof tmpLoadedEntry === 'object') && !Array.isArray(tmpLoadedEntry)) ? Object.assign({}, tmpLoadedEntry) : {};
		const tmpRoles = Array.from(new Set(pRolesByType[pHash] || []));
		if (tmpRoles.length > 0)
		{
			tmpEntry.Roles = tmpRoles;
		}
		else
		{
			delete tmpEntry.Roles;
		}
		if (Object.keys(tmpEntry).length > 0)
		{
			tmpByType[pHash] = tmpEntry;
		}
	});
	return Object.assign({}, tmpLoaded, { Enabled: !!pEnabled, ByType: tmpByType });
}

/**
 * FormAccessConfig: the #/FormAccess screen ("Who Can Open New Forms"). For each form type, the roles that are given
 * a new form of that type the moment it is created, so the people holding them can open and edit it without being
 * members of its project. Saved as the customer's `EntityOwnershipAssignment` / `Document` configuration. Opened by
 * the Configure who can open new forms entitlement.
 */
class FormAccessConfigProvider extends libCustomerConfigScreen
{
	/** @return {Record<string, any>} */
	initialState()
	{
		return { Loaded_Config: {}, Enabled: true, RolesByType: {}, Roles: [], FormTypes: [], Selected: {} };
	}

	/**
	 * @param {number} pIDCustomer
	 * @return {Promise<void>}
	 */
	async loadCustomerAsync(pIDCustomer)
	{
		const tmpState = this.state;
		tmpState.Loaded_Config = await this.readCustomerConfigAsync(NAMESPACE, NAMESPACE_VALUE, pIDCustomer);
		this.rememberSnapshot(NAMESPACE, NAMESPACE_VALUE, tmpState.Loaded_Config);
		tmpState.Enabled = (tmpState.Loaded_Config.Enabled !== false);
		tmpState.RolesByType = rolesByType(tmpState.Loaded_Config);
		tmpState.Selected = {};

		const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${Number(pIDCustomer)}~FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/3000`);
		const tmpByCode = new Map();
		(Array.isArray(tmpRoles) ? tmpRoles : [])
			.filter((pRole) => pRole && pRole.PermissionLevel && (pRole.Type !== 'PermissionGroup') && !TIER_LEVELS.includes(pRole.PermissionLevel))
			.forEach((pRole) =>
			{
				if (!tmpByCode.has(pRole.PermissionLevel))
				{
					tmpByCode.set(pRole.PermissionLevel, { Code: pRole.PermissionLevel, Names: [] });
				}
				tmpByCode.get(pRole.PermissionLevel).Names.push(pRole.Name || pRole.PermissionLevel);
			});
		tmpState.Roles = Array.from(tmpByCode.values()).sort((pA, pB) => pA.Names[0].localeCompare(pB.Names[0]));

		const tmpTypes = await this._getJSON(`ReportNamedInstances/LiteExtended/Hash,Name,IDCustomer/FilteredTo/FBL~IDCustomer~INN~0,${Number(pIDCustomer)}~FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/5000`);
		const tmpByHash = new Map();
		(Array.isArray(tmpTypes) ? tmpTypes : []).filter((pType) => pType && pType.Hash).forEach((pType) =>
		{
			const tmpStandard = !(Number(pType.IDCustomer) > 0);
			if (!tmpByHash.has(pType.Hash) || !tmpStandard)
			{
				tmpByHash.set(pType.Hash, { Hash: pType.Hash, Name: pType.Name || pType.Hash, Standard: tmpStandard });
			}
		});
		tmpState.FormTypes = Array.from(tmpByHash.values());
	}

	/** @return {Promise<void>} */
	async saveAsync()
	{
		const tmpState = this.state;
		const tmpConfig = buildAssignmentConfig(tmpState.Loaded_Config, tmpState.Enabled, tmpState.RolesByType);
		await this.writeCustomerConfigAsync(NAMESPACE, NAMESPACE_VALUE, tmpConfig);
		tmpState.Loaded_Config = tmpConfig;
		tmpState.RolesByType = rolesByType(tmpConfig);
		Object.keys(tmpState.Selected).forEach((pHash) =>
		{
			if (!tmpState.RolesByType[pHash])
			{
				delete tmpState.Selected[pHash];
			}
		});
	}

	/** @return {string} */
	savedMessage()
	{
		return 'Saved. Forms created from about 15 minutes from now follow these settings. Forms that already exist keep the access they have.';
	}

	// --- Edits ----------------------------------------------------------------------------------------------------

	/** @param {boolean} pOn */
	setEnabled(pOn)
	{
		this.state.Enabled = !!pOn;
		this.markDirty();
		this.render();
	}

	/**
	 * @param {string} pHash
	 * @param {boolean} pOn
	 */
	selectType(pHash, pOn)
	{
		if (pOn)
		{
			this.state.Selected[pHash] = true;
		}
		else
		{
			delete this.state.Selected[pHash];
		}
		this.render();
	}

	/** @param {boolean} pOn */
	selectAll(pOn)
	{
		this.state.Selected = {};
		if (pOn)
		{
			Object.keys(this.state.RolesByType).forEach((pHash) =>
			{
				this.state.Selected[pHash] = true;
			});
		}
		this.render();
	}

	/** @return {Array<string>} the form types the toolbar acts on */
	selectedTypes()
	{
		return Object.keys(this.state.Selected).filter((pHash) => this.state.RolesByType[pHash]);
	}

	/**
	 * @param {string} pHash
	 * @param {string} pCode
	 */
	removeRole(pHash, pCode)
	{
		const tmpRoles = this.state.RolesByType[pHash] || [];
		this.state.RolesByType[pHash] = tmpRoles.filter((pRole) => pRole !== pCode);
		this.markDirty();
		this.render();
	}

	/** @param {string} pCode - take this role off every selected form type */
	removeRoleFromSelected(pCode)
	{
		if (!pCode)
		{
			return;
		}
		this.selectedTypes().forEach((pHash) =>
		{
			this.state.RolesByType[pHash] = (this.state.RolesByType[pHash] || []).filter((pRole) => pRole !== pCode);
		});
		this.markDirty();
		this.render();
	}

	/** @param {string} pHash - stop granting this form type on create */
	removeType(pHash)
	{
		delete this.state.RolesByType[pHash];
		delete this.state.Selected[pHash];
		this.markDirty();
		this.render();
	}

	/**
	 * @param {string} pPicker - 'FormType' or 'Role'
	 * @param {string} pText
	 * @return {Array<{ Value: string, Label: string, Sub?: string }>} form types not yet listed, or roles some selected type lacks
	 */
	pickerChoices(pPicker, pText)
	{
		const tmpState = this.state;
		if (pPicker === 'FormType')
		{
			const tmpChoices = tmpState.FormTypes
				.filter((pType) => !tmpState.RolesByType[pType.Hash])
				.map((pType) => ({ Value: pType.Hash, Label: pType.Name, Sub: pType.Standard ? 'standard form' : '' }));
			return libCustomerConfigScreen.filterChoices(tmpChoices, pText);
		}
		const tmpSelected = this.selectedTypes();
		const tmpChoices = tmpState.Roles
			.filter((pRole) => tmpSelected.some((pHash) => !(tmpState.RolesByType[pHash] || []).includes(pRole.Code)))
			.map((pRole) => ({ Value: pRole.Code, Label: pRole.Names.join(', '), Sub: pRole.Code }));
		return libCustomerConfigScreen.filterChoices(tmpChoices, pText);
	}

	/**
	 * List a form type (selected, so the next role added reaches it), or add a role to every selected form type.
	 *
	 * @param {string} pPicker - 'FormType' or 'Role'
	 * @param {string} pValue
	 */
	pickerChose(pPicker, pValue)
	{
		const tmpState = this.state;
		if (pPicker === 'FormType')
		{
			if (!tmpState.RolesByType[pValue])
			{
				tmpState.RolesByType[pValue] = [];
			}
			tmpState.Selected[pValue] = true;
			this.markDirty();
			return;
		}
		this.selectedTypes().forEach((pHash) =>
		{
			const tmpRoles = tmpState.RolesByType[pHash] || [];
			if (!tmpRoles.includes(pValue))
			{
				tmpRoles.push(pValue);
			}
			tmpState.RolesByType[pHash] = tmpRoles;
		});
		this.markDirty();
	}

	// --- Rendering ------------------------------------------------------------------------------------------------

	/**
	 * @param {string} pCode
	 * @return {FormAccessRole|null}
	 */
	_role(pCode)
	{
		return this.state.Roles.find((pRole) => pRole.Code === pCode) || null;
	}

	/**
	 * @param {string} pHash
	 * @param {string} pCode
	 * @return {string}
	 */
	_chipHTML(pHash, pCode)
	{
		const tmpRole = this._role(pCode);
		const tmpLabel = tmpRole ? tmpRole.Names.join(', ') : pCode;
		const tmpTitle = tmpRole ? pCode : 'No role has this permission level, so it gives nobody access';
		return `<span class="ccs-chip ${tmpRole ? '' : 'is-unknown'}" title="${this._esc(tmpTitle)}">${this._esc(tmpLabel)}<button class="ccs-chip-x" title="Remove" onclick="_Pict.providers.${this.providerHash}.removeRole(${this._arg(pHash)}, ${this._arg(pCode)})">×</button></span>`;
	}

	/** @return {string} one row per listed form type */
	_tableHTML()
	{
		const tmpState = this.state;
		const tmpTypes = new Map(tmpState.FormTypes.map((pType) => [ pType.Hash, pType ]));
		const tmpHashes = Object.keys(tmpState.RolesByType).sort((pA, pB) => ((tmpTypes.get(pA) || { Name: pA }).Name).localeCompare((tmpTypes.get(pB) || { Name: pB }).Name));
		if (tmpHashes.length < 1)
		{
			return '<div class="ccs-note">No form types are listed, so a new form is open only to its project’s members and the people its approval steps name.</div>';
		}
		const tmpAllSelected = tmpHashes.every((pHash) => tmpState.Selected[pHash]);
		const tmpRows = tmpHashes.map((pHash) =>
		{
			const tmpType = tmpTypes.get(pHash);
			const tmpName = tmpType ?
				`${this._esc(tmpType.Name)}<span class="ccs-sub">${this._esc(pHash)}</span>` :
				`${this._esc(pHash)}<span class="ccs-sub ccs-warn">No form type has this code</span>`;
			const tmpChips = (tmpState.RolesByType[pHash] || []).map((pCode) => this._chipHTML(pHash, pCode)).join('');
			return `<tr class="${tmpState.Selected[pHash] ? 'is-selected' : ''}">
				<td><input type="checkbox" aria-label="Select" ${tmpState.Selected[pHash] ? 'checked' : ''} onchange="_Pict.providers.${this.providerHash}.selectType(${this._arg(pHash)}, this.checked)"></td>
				<td>${tmpName}</td>
				<td><div class="ccs-chips">${tmpChips || '<span class="ccs-sub ccs-warn">No roles yet. Select it and add one, or it is dropped when you save.</span>'}</div></td>
				<td><button class="ccs-btn is-danger" onclick="_Pict.providers.${this.providerHash}.removeType(${this._arg(pHash)})">Remove</button></td>
			</tr>`;
		}).join('');
		return `<table class="ccs-table">
			<thead><tr>
				<th><input type="checkbox" aria-label="Select all" ${tmpAllSelected ? 'checked' : ''} onchange="_Pict.providers.${this.providerHash}.selectAll(this.checked)"></th>
				<th>Form type</th><th>Roles that can open a new one</th><th></th>
			</tr></thead>
			<tbody>${tmpRows}</tbody>
		</table>`;
	}

	/** @return {string} the actions on the selected form types */
	_toolbarHTML()
	{
		const tmpState = this.state;
		const tmpSelected = this.selectedTypes();
		if (tmpSelected.length < 1)
		{
			return '<p class="ccs-help">Select form types to add a role to all of them at once, or to take one off.</p>';
		}
		const tmpPresent = Array.from(new Set([].concat(...tmpSelected.map((pHash) => tmpState.RolesByType[pHash] || []))));
		const tmpRemoveOptions = tmpPresent.map((pCode) =>
		{
			const tmpRole = this._role(pCode);
			return `<option value="${this._esc(pCode)}">${this._esc(tmpRole ? tmpRole.Names.join(', ') : pCode)}</option>`;
		}).join('');
		return `<div class="ccs-row">
			<span><b>${tmpSelected.length}</b> selected. Add a role:</span>
			${this.pickerHTML('Role', 'Search roles')}
		</div>
		${tmpPresent.length ? `<div class="ccs-row"><span>Take a role off the selected forms:</span>
			<select class="ccs-select" onchange="_Pict.providers.${this.providerHash}.removeRoleFromSelected(this.value)"><option value="">Choose a role…</option>${tmpRemoveOptions}</select></div>` : ''}`;
	}

	/** @return {string} */
	bodyHTML()
	{
		const tmpState = this.state;
		const tmpOff = tmpState.Enabled ? '' : '<div class="ccs-note ccs-warn">Turned off: new forms get none of the access below until this is turned back on.</div>';
		const tmpNoRoles = tmpState.Roles.length ? '' : '<div class="ccs-note ccs-warn">None of this customer’s roles has a permission level, so there is nothing to choose yet. Give a role one in Access &amp; Permissions.</div>';
		return `<div class="ccs-section">
			<label class="ccs-check"><input type="checkbox" ${tmpState.Enabled ? 'checked' : ''} onchange="_Pict.providers.${this.providerHash}.setEnabled(this.checked)"> Give new forms to the roles listed below</label>
			${tmpOff}
			<div class="ccs-note">
				Everyone holding a listed role can open and edit a new form of that type, on any project, without being a project member.
				Changes reach forms created from now on. Forms that already exist keep the access they have.
				Roles are matched by their permission level, set on the role in Access &amp; Permissions.
				Lab test forms are also given to the teams that staff the test’s lab (Teams), whatever is listed here.
			</div>
			${tmpNoRoles}
			${this._toolbarHTML()}
			${this._tableHTML()}
			<div class="ccs-row"><span>Add a form type:</span>${this.pickerHTML('FormType', 'Search form types')}</div>
		</div>`;
	}
}

FormAccessConfigProvider.SCREEN =
{
	Hash: 'FormAccessConfig',
	StateKey: 'FormAccessConfig',
	Mount: '#FAC-Detail',
	Entitlement: { Entity: 'FormAccess', Action: 'Configure', Label: 'Configure who can open new forms' },
};

module.exports = FormAccessConfigProvider;
module.exports.default_configuration = { ProviderIdentifier: 'FormAccessConfig', AutoInitialize: true, AutoInitializeOrdinal: 0 };
module.exports.rolesByType = rolesByType;
module.exports.buildAssignmentConfig = buildAssignmentConfig;

},{"./CustomerConfigScreen-Provider.js":1082}],1086:[function(require,module,exports){
'use strict';

const libCustomerConfigScreen = require('./CustomerConfigScreen-Provider.js');
const libScanStatus = require('headlight-sample-scanning/source/Sample-Scan-Status.js');
const { DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS } = require('headlight-dynamic-inputs-bundle/source/providers/_VocabularySelectorMap.js');

// Fieldbook iOS reads `Features.QRScanner` from FieldbookiOS (mpi_ios ManifestsSyncOperation.m, QR_SCANNER_CONFIG_KEY).
const IOS_NAMESPACE = 'FieldbookiOS';
const IOS_FEATURES = 'Features';
const IOS_SCANNER_KEY = 'QRScanner';
// Read by headlight-sample-scanning Sample-Scan-Status.js when a sample is moved into a location.
const RECEIVE_NAMESPACE = 'QRCodes';
const RECEIVE_VALUE = 'Receive';
const NO_STATUS = '';

/**
 * @typedef {{ Key: string, Name: string, QRCode: string, Type: string, IsTop: boolean }} ScanLocation
 * @typedef {{ Hash: string, Name: string }} ScanStatus
 */

/**
 * The location key a Receive rule is stored under: its QR code, or its GUID when it has none. The scanner matches
 * either (Sample-Scan-Status.js getConfiguredStatus).
 *
 * @param {{ QRCode?: string, GUIDLocation?: string }} pLocation
 * @return {string}
 */
function locationKey(pLocation)
{
	return String((pLocation && (pLocation.QRCode || pLocation.GUIDLocation)) || '');
}

/**
 * The Receive value to save: the edited rules and, when it was set or changed, the statuses they may replace. Keys
 * the screen has no control for are kept.
 *
 * @param {Record<string, any>} pLoaded - the value as read
 * @param {Record<string, string>} pStatusByLocation
 * @param {Array<string>|null} pOnlySetFrom - null leaves the reader's default (only samples with no status)
 * @return {Record<string, any>}
 */
function buildReceiveConfig(pLoaded, pStatusByLocation, pOnlySetFrom)
{
	const tmpConfig = Object.assign({}, pLoaded || {});
	tmpConfig.StatusByLocation = Object.assign({}, pStatusByLocation || {});
	if (Array.isArray(pOnlySetFrom))
	{
		tmpConfig.OnlySetFrom = pOnlySetFrom.slice();
	}
	else
	{
		delete tmpConfig.OnlySetFrom;
	}
	return tmpConfig;
}

/**
 * The FieldbookiOS Features value to save. The iPad keeps its last value when the key is missing, so off is
 * written as false, never by removing the key.
 *
 * @param {Record<string, any>} pLoaded
 * @param {boolean} pScanner
 * @return {Record<string, any>}
 */
function buildFeaturesConfig(pLoaded, pScanner)
{
	return Object.assign({}, pLoaded || {}, { [IOS_SCANNER_KEY]: !!pScanner });
}

/**
 * SampleScanningConfig: the #/SampleScanningConfig screen ("Sample Scanning"). Two customer settings that decide what
 * scanning does: whether Fieldbook on iPad shows its QR scanner, and the status a sample takes when it is scanned
 * into a location (`QRCodes` / `Receive`). Opened by the Configure sample QR codes entitlement.
 */
class SampleScanningConfigProvider extends libCustomerConfigScreen
{
	/** @return {Record<string, any>} */
	initialState()
	{
		return {
			Features: {}, Scanner: null, ScannerDirty: false,
			Receive: {}, StatusByLocation: {}, OnlySetFrom: null, ReceiveDirty: false,
			Locations: [], Statuses: [], NewStatus: '',
		};
	}

	/**
	 * @param {number} pIDCustomer
	 * @return {Promise<void>}
	 */
	async loadCustomerAsync(pIDCustomer)
	{
		const tmpState = this.state;
		tmpState.Features = await this.readCustomerConfigAsync(IOS_NAMESPACE, IOS_FEATURES, pIDCustomer);
		this.rememberSnapshot(IOS_NAMESPACE, IOS_FEATURES, tmpState.Features);
		tmpState.Scanner = (typeof tmpState.Features[IOS_SCANNER_KEY] === 'boolean') ? tmpState.Features[IOS_SCANNER_KEY] : null;
		tmpState.ScannerDirty = false;

		tmpState.Receive = await this.readCustomerConfigAsync(RECEIVE_NAMESPACE, RECEIVE_VALUE, pIDCustomer);
		this.rememberSnapshot(RECEIVE_NAMESPACE, RECEIVE_VALUE, tmpState.Receive);
		tmpState.StatusByLocation = (tmpState.Receive.StatusByLocation && typeof tmpState.Receive.StatusByLocation === 'object') ? Object.assign({}, tmpState.Receive.StatusByLocation) : {};
		tmpState.OnlySetFrom = Array.isArray(tmpState.Receive.OnlySetFrom) ? tmpState.Receive.OnlySetFrom.map(String) : null;
		tmpState.ReceiveDirty = false;

		const tmpLocations = await this._getJSON(`Locations/FilteredTo/FBV~IDCustomer~EQ~${Number(pIDCustomer)}~FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/5000`);
		tmpState.Locations = (Array.isArray(tmpLocations) ? tmpLocations : [])
			.filter((pLocation) => locationKey(pLocation))
			.map((pLocation) => ({ Key: locationKey(pLocation), Name: pLocation.Name || locationKey(pLocation), QRCode: pLocation.QRCode || '', Type: pLocation.Type || '', IsTop: !(Number(pLocation.ParentIDLocation) > 0) }));

		const tmpStatuses = await this._getJSON('SampleStatuss/FilteredTo/FBV~Deleted~EQ~0~FSF~Ordinal~ASC~0/0/500');
		tmpState.Statuses = (Array.isArray(tmpStatuses) && tmpStatuses.length) ?
			tmpStatuses.filter((pStatus) => pStatus && pStatus.Hash).map((pStatus) => ({ Hash: String(pStatus.Hash), Name: pStatus.Name || pStatus.Hash })) :
			DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS.map((pOption) => ({ Hash: pOption.id, Name: pOption.text }));
		const tmpUsed = Object.values(tmpState.StatusByLocation)[0];
		tmpState.NewStatus = tmpUsed || ((tmpState.Statuses.find((pStatus) => pStatus.Hash === 'RECV') || tmpState.Statuses[0] || { Hash: '' }).Hash);
	}

	/** @return {Promise<void>} */
	async saveAsync()
	{
		const tmpState = this.state;
		if (tmpState.ScannerDirty)
		{
			await this.writeCustomerConfigAsync(IOS_NAMESPACE, IOS_FEATURES, buildFeaturesConfig(tmpState.Features, tmpState.Scanner));
			tmpState.Features = buildFeaturesConfig(tmpState.Features, tmpState.Scanner);
			tmpState.ScannerDirty = false;
		}
		if (tmpState.ReceiveDirty)
		{
			tmpState.Receive = buildReceiveConfig(tmpState.Receive, tmpState.StatusByLocation, tmpState.OnlySetFrom);
			await this.writeCustomerConfigAsync(RECEIVE_NAMESPACE, RECEIVE_VALUE, tmpState.Receive);
			tmpState.ReceiveDirty = false;
		}
	}

	/** @return {string} */
	savedMessage()
	{
		return 'Saved. Scans into a location follow these rules within about 15 minutes; iPads pick up the scanner setting the next time they sync.';
	}

	// --- Edits ----------------------------------------------------------------------------------------------------

	/** @param {boolean} pOn */
	setScanner(pOn)
	{
		this.state.Scanner = !!pOn;
		this.state.ScannerDirty = true;
		this.markDirty();
		this.render();
	}

	/** Note an unsaved change to the receiving rules. */
	_receiveEdited()
	{
		this.state.ReceiveDirty = true;
		this.markDirty();
	}

	/**
	 * @param {string} pKey - a location key
	 * @param {string} pStatus
	 */
	setLocationStatus(pKey, pStatus)
	{
		if (!pStatus)
		{
			return;
		}
		this.state.StatusByLocation[pKey] = String(pStatus);
		this._receiveEdited();
		this.render();
	}

	/** @param {string} pKey */
	removeLocation(pKey)
	{
		delete this.state.StatusByLocation[pKey];
		this._receiveEdited();
		this.render();
	}

	/** @param {string} pStatus - the status rows added from now on set */
	setNewStatus(pStatus)
	{
		this.state.NewStatus = String(pStatus || '');
	}

	/** Give every top-level location that has no rule yet the chosen status. */
	addTopLevelLocations()
	{
		const tmpState = this.state;
		if (!tmpState.NewStatus)
		{
			return;
		}
		tmpState.Locations.filter((pLocation) => pLocation.IsTop && !tmpState.StatusByLocation[pLocation.Key]).forEach((pLocation) =>
		{
			tmpState.StatusByLocation[pLocation.Key] = tmpState.NewStatus;
		});
		this._receiveEdited();
		this.render();
	}

	/**
	 * @param {string} pStatus - a status hash, or '' for a sample with no status yet
	 * @param {boolean} pOn
	 */
	toggleOnlySetFrom(pStatus, pOn)
	{
		const tmpState = this.state;
		const tmpList = Array.isArray(tmpState.OnlySetFrom) ? tmpState.OnlySetFrom.slice() : libScanStatus.DEFAULT_ONLY_SET_FROM.slice();
		const tmpIndex = tmpList.indexOf(pStatus);
		if (pOn && (tmpIndex < 0))
		{
			tmpList.push(pStatus);
		}
		else if (!pOn && (tmpIndex >= 0))
		{
			tmpList.splice(tmpIndex, 1);
		}
		tmpState.OnlySetFrom = tmpList;
		this._receiveEdited();
		this.render();
	}

	/**
	 * @param {string} pPicker
	 * @param {string} pText
	 * @return {Array<{ Value: string, Label: string, Sub?: string }>} locations that don't set a status yet
	 */
	pickerChoices(pPicker, pText)
	{
		const tmpState = this.state;
		const tmpChoices = tmpState.Locations
			.filter((pLocation) => !tmpState.StatusByLocation[pLocation.Key])
			.map((pLocation) => ({ Value: pLocation.Key, Label: pLocation.Name, Sub: [ pLocation.Type, pLocation.QRCode ].filter(Boolean).join(' · ') }));
		return libCustomerConfigScreen.filterChoices(tmpChoices, pText);
	}

	/**
	 * Give the picked location the status chosen for new rows.
	 *
	 * @param {string} pPicker
	 * @param {string} pValue - a location key
	 */
	pickerChose(pPicker, pValue)
	{
		if (this.state.NewStatus && !this.state.StatusByLocation[pValue])
		{
			this.state.StatusByLocation[pValue] = this.state.NewStatus;
			this._receiveEdited();
		}
	}

	// --- Rendering ------------------------------------------------------------------------------------------------

	/**
	 * @param {string} pHash
	 * @return {string}
	 */
	_statusName(pHash)
	{
		if (pHash === NO_STATUS)
		{
			return 'No status yet';
		}
		const tmpStatus = this.state.Statuses.find((pStatus) => pStatus.Hash === pHash);
		return tmpStatus ? tmpStatus.Name : pHash;
	}

	/**
	 * @param {string} pSelected
	 * @param {string} pOnChange - the inline handler, taking this.value
	 * @return {string}
	 */
	_statusSelectHTML(pSelected, pOnChange)
	{
		const tmpKnown = this.state.Statuses.some((pStatus) => pStatus.Hash === pSelected);
		const tmpOptions = this.state.Statuses.map((pStatus) => `<option value="${this._esc(pStatus.Hash)}" ${pStatus.Hash === pSelected ? 'selected' : ''}>${this._esc(pStatus.Name)}</option>`).join('');
		const tmpUnknown = (pSelected && !tmpKnown) ? `<option value="${this._esc(pSelected)}" selected>${this._esc(pSelected)} (not a status this customer has)</option>` : '';
		return `<select class="ccs-select" onchange="${pOnChange}">${tmpUnknown}${tmpOptions}</select>`;
	}

	/** @return {string} */
	_scannerHTML()
	{
		const tmpState = this.state;
		const tmpUnset = (tmpState.Scanner === null) ?
			'<div class="ccs-note">Not set for this customer yet. iPads keep whatever they had before, and a new install doesn’t show the button.</div>' :
			'';
		return `<div class="ccs-section">
			<h2 class="ccs-section-title">Scanning in Fieldbook on iPad</h2>
			<p class="ccs-help">The Scan QR Code button opens a sample by scanning its label. iPads pick up a change the next time they sync.</p>
			${tmpUnset}
			<label class="ccs-check"><input type="checkbox" ${tmpState.Scanner === true ? 'checked' : ''} onchange="_Pict.providers.${this.providerHash}.setScanner(this.checked)"> Show the Scan QR Code button</label>
		</div>`;
	}

	/** @return {string} */
	_receiveHTML()
	{
		const tmpState = this.state;
		const tmpByKey = new Map(tmpState.Locations.map((pLocation) => [ pLocation.Key, pLocation ]));
		const tmpRows = Object.keys(tmpState.StatusByLocation)
			.map((pKey) => ({ Key: pKey, Location: tmpByKey.get(pKey) || null }))
			.sort((pA, pB) => (pA.Location ? pA.Location.Name : pA.Key).localeCompare(pB.Location ? pB.Location.Name : pB.Key))
			.map((pRow) =>
			{
				const tmpName = pRow.Location ?
					`${this._esc(pRow.Location.Name)}<span class="ccs-sub">${this._esc([ pRow.Location.Type, pRow.Location.QRCode ].filter(Boolean).join(' · '))}</span>` :
					`${this._esc(pRow.Key)}<span class="ccs-sub ccs-warn">No location has this code, so this rule does nothing.</span>`;
				return `<tr>
					<td>${tmpName}</td>
					<td>${this._statusSelectHTML(tmpState.StatusByLocation[pRow.Key], `_Pict.providers.${this.providerHash}.setLocationStatus(${this._arg(pRow.Key)}, this.value)`)}</td>
					<td><button class="ccs-btn is-danger" onclick="_Pict.providers.${this.providerHash}.removeLocation(${this._arg(pRow.Key)})">Remove</button></td>
				</tr>`;
			}).join('');
		const tmpTable = tmpRows ?
			`<table class="ccs-table"><thead><tr><th>Location</th><th>Sets the sample’s status to</th><th></th></tr></thead><tbody>${tmpRows}</tbody></table>` :
			'<div class="ccs-note">No locations set a status, so scanning a sample into a location only records where it is.</div>';
		const tmpTopLeft = tmpState.Locations.filter((pLocation) => pLocation.IsTop && !tmpState.StatusByLocation[pLocation.Key]).length;
		const tmpAllowed = Array.isArray(tmpState.OnlySetFrom) ? tmpState.OnlySetFrom : libScanStatus.DEFAULT_ONLY_SET_FROM;
		const tmpFrom = [ NO_STATUS ].concat(tmpState.Statuses.map((pStatus) => pStatus.Hash)).map((pHash) =>
			`<label class="ccs-check"><input type="checkbox" ${tmpAllowed.includes(pHash) ? 'checked' : ''} onchange="_Pict.providers.${this.providerHash}.toggleOnlySetFrom(${this._arg(pHash)}, this.checked)"> ${this._esc(this._statusName(pHash))}</label>`).join('');
		return `<div class="ccs-section">
			<h2 class="ccs-section-title">Receiving samples by scanning them into a location</h2>
			<p class="ccs-help">When a sample is scanned into one of these locations, it takes the status shown, for example Received at a lab’s reception. Locations not listed don’t change a sample’s status.</p>
			${tmpTable}
			<div class="ccs-row">
				<span>Add a location that sets</span>
				${this._statusSelectHTML(tmpState.NewStatus, `_Pict.providers.${this.providerHash}.setNewStatus(this.value)`)}
				${this.pickerHTML('Location', 'Search locations by name or code')}
			</div>
			<div class="ccs-row">
				<button class="ccs-btn" ${tmpTopLeft ? '' : 'disabled'} onclick="_Pict.providers.${this.providerHash}.addTopLevelLocations()">Add every top-level location (${tmpTopLeft})</button>
				<span class="ccs-sub">Top-level locations are the ones not inside another, such as each lab.</span>
			</div>
			<label class="ccs-label">Only change samples whose status is</label>
			<p class="ccs-help">So that scanning a sample that is already being tested can’t send it back to an earlier status.${Array.isArray(tmpState.OnlySetFrom) ? '' : ' Not set yet, so only samples with no status are changed.'}</p>
			<div class="ccs-checks">${tmpFrom}</div>
		</div>`;
	}

	/** @return {string} */
	bodyHTML()
	{
		return `${this._scannerHTML()}${this._receiveHTML()}`;
	}
}

SampleScanningConfigProvider.SCREEN =
{
	Hash: 'SampleScanningConfig',
	StateKey: 'SampleScanningConfig',
	Mount: '#SSC-Detail',
	Entitlement: { Entity: 'SampleQRCode', Action: 'Configure', Label: 'Configure sample QR codes, labels and scanning' },
};

module.exports = SampleScanningConfigProvider;
module.exports.default_configuration = { ProviderIdentifier: 'SampleScanningConfig', AutoInitialize: true, AutoInitializeOrdinal: 0 };
module.exports.buildReceiveConfig = buildReceiveConfig;
module.exports.buildFeaturesConfig = buildFeaturesConfig;
module.exports.locationKey = locationKey;

},{"./CustomerConfigScreen-Provider.js":1082,"headlight-dynamic-inputs-bundle/source/providers/_VocabularySelectorMap.js":171,"headlight-sample-scanning/source/Sample-Scan-Status.js":298}],1087:[function(require,module,exports){
'use strict';

/**
 * ContractAdmin-Template — the canonical, HNTB-free definition of the "Contract Administration" starter
 * template: the two report forms (Payment, Change Order), the two default approval workflows, and the
 * bindings that tie each form to its workflow.
 *
 * This is the version-controlled SOURCE the Generate action materializes onto the HeadLight customer
 * (IDCustomer 1); the HeadLight copy is then the runtime single source of truth that the per-customer
 * "Set up Contract Administration" action clones into other customers. Everything here is a plain data
 * factory (no pict/REST), so it is reusable by the generate + clone provider and unit-testable.
 *
 * Identifier scheme — per-customer so each tenant owns its own rows/blobs and nothing collides globally:
 *   - Payment RNI:      Hash `HeadLight-Payment-Transitional-<id>`, GUID `HL-CA-RNI-PAYMENT-<id>`
 *   - Change Order RNI: Hash `Default-ChangeOrder-<id>`,            GUID `HL-CA-RNI-CHANGEORDER-<id>`
 *   - Workflows:        Configuration ns ApprovalWorkflow, hashes 'Default Payment Approval' /
 *                       'Default Change Order Approval' (names are the Config NamespaceValue).
 *   - Bindings:         ApprovalWorkflowBindings 'Document' map { <formHash>: <workflowName> }.
 *
 * The TidingsData.Type on the payment form points at the GLOBAL server-side Tidings report template
 * 'HeadLight-Payment-Transitional' (NOT suffixed) — that is a shared renderer, not a per-customer row.
 */

const libChangeOrderManifest = require('../change-orders/Default-ChangeOrder-Manifest.json');
const libApprovalModel = require('../approval-workflow/ApprovalWorkflow-Model.js');

const HEADLIGHT_IDCUSTOMER = 1;

// The platform module-catalog row for Contract Administration. ModuleHash is a readable identifier (like the
// other catalog rows: HEADLIGHT_FIELDBOOK, HEADLIGHT_TRACKER, …); enablement for a customer is a CustomerModuleJoin
// keyed by this hash. Distinct from the vendor-specific 'Contracts' (IDOT_CONTRACT_MGMT) row.
const MODULE_HASH = 'HEADLIGHT_CONTRACTADMIN';
const MODULE_NAME = 'Contract Administration';
const MODULE_ORDINAL = 500;

// The RolePermission capability that actually gates the Contract-Admin screens (canModule('ContractAdmin')).
const MODULE_ACCESS_CAPABILITY = 'Module-ContractAdmin-Access';

const PAYMENT_WORKFLOW = 'Default Payment Approval';
const CHANGEORDER_WORKFLOW = 'Default Change Order Approval';

const paymentHash = (pIDCustomer) => `HeadLight-Payment-Transitional-${pIDCustomer}`;
const changeOrderHash = (pIDCustomer) => `Default-ChangeOrder-${pIDCustomer}`;
const paymentGUID = (pIDCustomer) => `HL-CA-RNI-PAYMENT-${pIDCustomer}`;
const changeOrderGUID = (pIDCustomer) => `HL-CA-RNI-CHANGEORDER-${pIDCustomer}`;

/** The Payment report form (ReportNamedInstance) — a thin pointer to the global 'HeadLight-Payment-Transitional' Tidings template. */
function paymentFormRNI(pIDCustomer)
{
	const tmpID = Number(pIDCustomer);
	return {
		GUIDReportNamedInstance: paymentGUID(tmpID),
		IDCustomer: tmpID,
		Name: 'HeadLight Payment',
		Hash: paymentHash(tmpID),
		OptionsJSON: JSON.stringify({
			DefaultEmailFormat: 'pdf',
			TidingsData: { Type: 'HeadLight-Payment-Transitional', Renderer: 'html' },
			FormOnly: true,
			Meta: { reportTitle: '', hideDuplicateButton: true, hideCloningFeature: false },
			Body: { displayOrder: [] },
		}),
		IDReportArchetype: 2,
		DefaultReport: 1,
		Ordinal: 0,
	};
}

/** The Change Order report form (ReportNamedInstance) — an inline HeadlightDynamicForm using the canonical manifest. */
function changeOrderFormRNI(pIDCustomer)
{
	const tmpID = Number(pIDCustomer);
	return {
		GUIDReportNamedInstance: changeOrderGUID(tmpID),
		IDCustomer: tmpID,
		Name: 'Change Order',
		Hash: changeOrderHash(tmpID),
		OptionsJSON: JSON.stringify({
			DefaultEmailFormat: 'pdf',
			TidingsData: { Type: 'headlight-dynamic-form', Renderer: 'html' },
			FormOnly: true,
			Meta: { reportTitle: '' },
			FormDefinition: { Product: 'HeadlightDynamicForm', DefaultFormManifest: libChangeOrderManifest },
		}),
		IDReportArchetype: 0,
		DefaultReport: 1,
		Ordinal: 0,
	};
}

/** A fresh deep copy of the platform-default approval workflow (generic Draft→Submitted→{Approved,Rejected} with one IsApproval edge, keyword 'Admin' actor so it clones verbatim into any customer). */
function defaultWorkflowBlob()
{
	return JSON.parse(JSON.stringify(libApprovalModel.NEW_DEFAULT_WORKFLOW_CONFIG));
}

/**
 * Build the full template artifact set for a customer.
 * @param {number} pIDCustomer
 * @returns {{ IDCustomer:number, ReportForms:Array<Object>, Workflows:Array<{Hash:string,Blob:Object}>, Bindings:Object }}
 */
function buildTemplate(pIDCustomer)
{
	const tmpID = Number(pIDCustomer);
	return {
		IDCustomer: tmpID,
		ReportForms: [ paymentFormRNI(tmpID), changeOrderFormRNI(tmpID) ],
		Workflows:
		[
			{ Hash: PAYMENT_WORKFLOW, Blob: defaultWorkflowBlob() },
			{ Hash: CHANGEORDER_WORKFLOW, Blob: defaultWorkflowBlob() },
		],
		Bindings:
		{
			[paymentHash(tmpID)]: PAYMENT_WORKFLOW,
			[changeOrderHash(tmpID)]: CHANGEORDER_WORKFLOW,
		},
	};
}

module.exports = {
	buildTemplate,
	HEADLIGHT_IDCUSTOMER,
	MODULE_HASH,
	MODULE_NAME,
	MODULE_ORDINAL,
	MODULE_ACCESS_CAPABILITY,
	PAYMENT_WORKFLOW,
	CHANGEORDER_WORKFLOW,
	paymentHash,
	changeOrderHash,
	paymentGUID,
	changeOrderGUID,
};

},{"../approval-workflow/ApprovalWorkflow-Model.js":1068,"../change-orders/Default-ChangeOrder-Manifest.json":1073}],1088:[function(require,module,exports){
/**
 * GENERATED FILE — do not edit by hand.
 *
 * The operational Data Explorer config graph (pict-dataexplorer). Relationships are derived from the live
 * schema (lib/headlight_model/json/Headlight.json); scope + presentation come from Explorer-Curation.js.
 * Regenerate:  node source/data-explorer/build-explorer-config.js
 */

module.exports = {
	"URLPrefix": "/1.0/",
	"PageSize": 25,
	"MaxDepth": 8,
	"Roots": [
		{
			"Label": "Projects",
			"Entity": "Project"
		},
		{
			"Label": "Contracts",
			"Entity": "Contract"
		},
		{
			"Label": "Users",
			"Entity": "User"
		},
		{
			"Label": "Organizations",
			"Entity": "Organization"
		},
		{
			"Label": "Materials",
			"Entity": "Material"
		},
		{
			"Label": "Pay Items",
			"Entity": "PayItem"
		},
		{
			"Label": "Specification Sets",
			"Entity": "TestSpecificationSet"
		},
		{
			"Label": "Tests",
			"Entity": "Test"
		},
		{
			"Label": "Labs",
			"Entity": "Lab"
		},
		{
			"Label": "Products",
			"Entity": "Product"
		},
		{
			"Label": "Mix Designs",
			"Entity": "MixDesign"
		}
	],
	"Entities": {
		"Project": {
			"Lite": [
				"Name",
				"Status",
				"IDProjectType",
				"IDContract",
				"IDOrganization",
				"GUIDProject"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Status~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Project Type",
					"Entity": "ProjectType",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDProjectType"
					}
				},
				{
					"Label": "Contract",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Primary Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Users",
					"Entity": "User",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectUserJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDUser"
					}
				},
				{
					"Label": "Organizations",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectOrganizationJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDOrganization"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ObservationTagProjectJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDObservationTag"
					}
				},
				{
					"Label": "Report Instances",
					"Entity": "ReportNamedInstance",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ReportNamedInstanceProjectJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDReportNamedInstance"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectLabJoin",
						"ParentKey": "IDProject",
						"ChildKey": "IDLab"
					}
				},
				{
					"Label": "Observation Types",
					"Entity": "ProjectObservationManifestJoin",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Sample Plan",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "LineItem",
						"ParentKey": "IDProject",
						"ChildKey": "IDPayItem"
					}
				}
			]
		},
		"Contract": {
			"Lite": [
				"Name",
				"Status",
				"IDOrganization",
				"IDContractType",
				"GUIDContract"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Status~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Contract Type",
					"Entity": "ContractType",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContractType"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContract"
					}
				}
			]
		},
		"User": {
			"Lite": [
				"NameFirst",
				"NameLast",
				"LoginID",
				"Email",
				"Role",
				"Title",
				"IDRole",
				"IDProjectOffice",
				"GUIDUser"
			],
			"Display": {
				"Title": "{~D:Record.NameFirst~} {~D:Record.NameLast~}",
				"Subtitle": "{~D:Record.LoginID~}"
			},
			"Sort": "Title",
			"Children": [
				{
					"Label": "Role",
					"Entity": "Role",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDRole"
					}
				},
				{
					"Label": "Roles",
					"Entity": "Role",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "UserRoleJoin",
						"ParentKey": "IDUser",
						"ChildKey": "IDRole"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectUserJoin",
						"ParentKey": "IDUser",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"Organization": {
			"Lite": [
				"Name",
				"Type",
				"GUIDOrganization"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Type~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectOrganizationJoin",
						"ParentKey": "IDOrganization",
						"ChildKey": "IDProject"
					}
				},
				{
					"Label": "Contracts",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Mix Designs",
					"Entity": "MixDesign",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Products",
					"Entity": "Product",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "OrganizationMaterialJoin",
						"ParentKey": "IDOrganization",
						"ChildKey": "IDMaterial"
					}
				}
			]
		},
		"Role": {
			"Lite": [
				"Name",
				"Type",
				"GUIDRole"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Type~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Users",
					"Entity": "User",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDRole"
					}
				},
				{
					"Label": "Users",
					"Entity": "User",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "UserRoleJoin",
						"ParentKey": "IDRole",
						"ChildKey": "IDUser"
					}
				}
			]
		},
		"Material": {
			"Lite": [
				"Name",
				"ItemCode",
				"GUIDMaterial"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.ItemCode~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "LabMaterialAssignment",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDLab"
					}
				},
				{
					"Label": "Mix Designs",
					"Entity": "MixDesign",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Pay Items",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "MaterialPayItemJoin",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDPayItem"
					}
				},
				{
					"Label": "Products",
					"Entity": "Product",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Organizations",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "OrganizationMaterialJoin",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDOrganization"
					}
				},
				{
					"Label": "Test Specifications",
					"Entity": "TestSpecification",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationMaterialJoin",
						"ParentKey": "IDMaterial",
						"ChildKey": "IDTestSpecification"
					}
				},
				{
					"Label": "Tests",
					"Entity": "ProjectLineItemMaterialTest",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDMaterial",
						"ContextKeys": [
							"IDLineItem"
						],
						"RequireContext": [
							"IDLineItem"
						]
					}
				}
			]
		},
		"Product": {
			"Lite": [
				"Name",
				"ProductCategory",
				"IDMaterial",
				"IDOrganization",
				"GUIDProduct"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.ProductCategory~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Material",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				}
			]
		},
		"MixDesign": {
			"Lite": [
				"Name",
				"MaterialCode",
				"IDMaterial",
				"IDOrganization",
				"IDMixType",
				"GUIDMixDesign"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.MaterialCode~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Material",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDMaterial"
					}
				},
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				}
			]
		},
		"PayItem": {
			"Lite": [
				"Description",
				"ItemCode",
				"Section",
				"FunctionalClass",
				"Name",
				"IDTestSpecificationSet",
				"GUIDPayItem"
			],
			"Display": {
				"Title": "Description",
				"Subtitle": "{~D:Record.ItemCode~}"
			},
			"Sort": "ItemCode",
			"Children": [
				{
					"Label": "Specification Set",
					"Entity": "TestSpecificationSet",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Bid Items",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDPayItem"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "MaterialPayItemJoin",
						"ParentKey": "IDPayItem",
						"ChildKey": "IDMaterial"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDPayItem",
						"ContextKeys": [
							"IDProject"
						],
						"RequireContext": [
							"IDProject"
						]
					}
				}
			],
			"Filter": "FBV~Description~NE~",
			"ColumnBlacklist": [
				"ExtendedJSON"
			]
		},
		"TestSpecificationSet": {
			"Lite": [
				"Name",
				"Year",
				"GUIDTestSpecificationSet"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Year~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Pay Items",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Tests",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationSetTestJoin",
						"ParentKey": "IDTestSpecificationSet",
						"ChildKey": "IDTest"
					}
				},
				{
					"Label": "Test Specifications",
					"Entity": "TestSpecification",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTestSpecificationSet"
					}
				}
			]
		},
		"TestSpecification": {
			"Lite": [
				"Name",
				"Description",
				"IDTestSpecificationSet",
				"GUIDTestSpecification"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Specification Set",
					"Entity": "TestSpecificationSet",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Requirements",
					"Entity": "TestSpecificationRequirement",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTestSpecification"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationMaterialJoin",
						"ParentKey": "IDTestSpecification",
						"ChildKey": "IDMaterial"
					}
				}
			]
		},
		"TestSpecificationRequirement": {
			"Lite": [
				"Name",
				"IDTestSpecification",
				"IDTest",
				"GUIDTestSpecificationRequirement"
			],
			"Display": {
				"Title": "Name"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Test Specification",
					"Entity": "TestSpecification",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTestSpecification"
					}
				},
				{
					"Label": "Test",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTest"
					}
				}
			]
		},
		"Test": {
			"Lite": [
				"Name",
				"Description",
				"GUIDTest"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Labs",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestLabJoin",
						"ParentKey": "IDTest",
						"ChildKey": "IDLab"
					}
				},
				{
					"Label": "Specification Sets",
					"Entity": "TestSpecificationSet",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestSpecificationSetTestJoin",
						"ParentKey": "IDTest",
						"ChildKey": "IDTestSpecificationSet"
					}
				},
				{
					"Label": "Requirements",
					"Entity": "TestSpecificationRequirement",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDTest"
					}
				}
			]
		},
		"Lab": {
			"Lite": [
				"Name",
				"IDOrganization",
				"IDOrganizationAddress",
				"GUIDLab"
			],
			"Display": {
				"Title": "Name"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Tests",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "TestLabJoin",
						"ParentKey": "IDLab",
						"ChildKey": "IDTest"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "LabMaterialAssignment",
						"ParentKey": "IDLab",
						"ChildKey": "IDMaterial"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectLabJoin",
						"ParentKey": "IDLab",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"LineItem": {
			"Lite": [
				"Name",
				"ItemCode",
				"IDFundingCategory",
				"IDPayItem",
				"IDBidItem",
				"IDContract",
				"IDProject",
				"Status",
				"GUIDLineItem"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.ItemNumber~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Pay Item",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDPayItem"
					}
				},
				{
					"Label": "Bid Item",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDBidItem"
					}
				},
				{
					"Label": "Contract",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Project",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDLineItem"
					}
				},
				{
					"Label": "Materials",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ProjectLineItemMaterialTest",
						"ParentKey": "IDLineItem",
						"ChildKey": "IDMaterial"
					}
				}
			]
		},
		"BidItem": {
			"Lite": [
				"Name",
				"Units",
				"IDContract",
				"IDProject",
				"IDPayItem",
				"IDOrganization",
				"GUIDBidItem"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Units~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Contract",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDContract"
					}
				},
				{
					"Label": "Project",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDProject"
					}
				},
				{
					"Label": "Pay Item",
					"Entity": "PayItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDPayItem"
					}
				},
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Observation Tags",
					"Entity": "ObservationTag",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDBidItem"
					}
				},
				{
					"Label": "Line Items",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDBidItem"
					}
				}
			]
		},
		"ObservationManifest": {
			"Lite": [
				"Name",
				"Category",
				"GUIDObservationManifest"
			],
			"Display": {
				"Title": "DisplayName",
				"Subtitle": "{~D:Record.Category~}"
			},
			"Sort": "Name",
			"Children": []
		},
		"ProjectType": {
			"Lite": [
				"Name",
				"Description",
				"IDProgram",
				"GUIDProjectType"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDProjectType"
					}
				}
			]
		},
		"ContractType": {
			"Lite": [
				"Name",
				"Description",
				"GUIDContractType"
			],
			"Display": {
				"Title": "Name",
				"Subtitle": "{~D:Record.Description~}"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Contracts",
					"Entity": "Contract",
					"Resolve": "count",
					"Relationship": {
						"Type": "Filter",
						"Key": "IDContractType"
					}
				}
			]
		},
		"ObservationTag": {
			"Lite": [
				"Description",
				"IDOrganization",
				"IDBidItem",
				"IDLineItem",
				"GUIDObservationTag"
			],
			"Display": {
				"Title": "Description"
			},
			"Sort": "Description",
			"Children": [
				{
					"Label": "Organization",
					"Entity": "Organization",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDOrganization"
					}
				},
				{
					"Label": "Bid Item",
					"Entity": "BidItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDBidItem"
					}
				},
				{
					"Label": "Line Item",
					"Entity": "LineItem",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDLineItem"
					}
				},
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ObservationTagProjectJoin",
						"ParentKey": "IDObservationTag",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"ReportNamedInstance": {
			"Lite": [
				"Name",
				"IDReportArchetype",
				"GUIDReportNamedInstance"
			],
			"Display": {
				"Title": "Name"
			},
			"Sort": "Name",
			"Children": [
				{
					"Label": "Projects",
					"Entity": "Project",
					"Resolve": "count",
					"Relationship": {
						"Type": "Join",
						"JoinEntity": "ReportNamedInstanceProjectJoin",
						"ParentKey": "IDReportNamedInstance",
						"ChildKey": "IDProject"
					}
				}
			]
		},
		"ProjectObservationManifestJoin": {
			"IDField": "IDProjectObservationManifestJoin",
			"Lite": [
				"ObservationManifestName",
				"IDProject"
			],
			"Display": {
				"Title": "ObservationManifestName"
			}
		},
		"ProjectLineItemMaterialTest": {
			"IDField": "IDProjectLineItemMaterialTest",
			"Lite": [
				"TestDescription",
				"SampleType",
				"Intent",
				"Frequency",
				"Units",
				"SampleSize",
				"IDTest",
				"IDLab",
				"IDMaterial",
				"GUIDProjectLineItemMaterialTest"
			],
			"Display": {
				"Title": "TestDescription",
				"Subtitle": "{~D:Record.SampleType~}"
			},
			"Sort": "SampleType",
			"Children": [
				{
					"Label": "Test",
					"Entity": "Test",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDTest"
					}
				},
				{
					"Label": "Lab",
					"Entity": "Lab",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDLab"
					}
				},
				{
					"Label": "Material",
					"Entity": "Material",
					"Resolve": "count",
					"Relationship": {
						"Type": "Reference",
						"Key": "IDMaterial"
					}
				}
			]
		}
	}
};

},{}],1089:[function(require,module,exports){
/**
 * Contract Package Import — human-readable field layouts for the map step.
 *
 * The bespoke Project / Contract workspaces render their Overview as labeled sections (Identity, Schedule,
 * Financials, …) with friendly field labels instead of raw column names. The importer's map step should
 * read the same way, so this mirrors those section+label layouts (Project/Contract transcribed from
 * ProjectWorkspace-Provider / ContractWorkspace-Provider; Bid Item / Line Item authored here since they
 * have no bespoke workspace). Any settable field not named in a layout falls into an "Additional fields"
 * section with a humanized label — so nothing is lost, it's just deprioritized.
 *
 * Pure data + helpers — no pict / REST. Each layout is an ordered list of { Section, Fields:[{Key,Label}] }.
 * (Audit + the GUID/PK/strategy-owned FK columns are intentionally omitted — they aren't mapped from data.)
 */

'use strict';

const LAYOUTS =
{
	Contract:
	[
		{ Section: 'Identity', Fields: [ { Key: 'Name', Label: 'Contract Name' }, { Key: 'Status', Label: 'Status' }, { Key: 'ExternalContractID', Label: 'External Contract ID' } ] },
		{ Section: 'Project Numbers', Fields: [ { Key: 'PrimaryProjectNumber', Label: 'Primary' }, { Key: 'CountyProjectNumber', Label: 'County' }, { Key: 'StateProjectNumber', Label: 'State' }, { Key: 'FederalProjectNumber', Label: 'Federal' } ] },
		{ Section: 'Route & Limits', Fields: [ { Key: 'RouteNumber', Label: 'Route #' }, { Key: 'HighwayNumber', Label: 'Highway #' }, { Key: 'PavingMaterial', Label: 'Paving Material' }, { Key: 'StationBegin', Label: 'Station Begin' }, { Key: 'TerminusBegin', Label: 'Terminus Begin' }, { Key: 'StationEnd', Label: 'Station End' }, { Key: 'TerminusEnd', Label: 'Terminus End' } ] },
		{ Section: 'Financials', Fields: [ { Key: 'TotalBidAmount', Label: 'Total Bid Amount' }, { Key: 'NetChangeOrderAmount', Label: 'Net Change Orders' }, { Key: 'VendorAccountCode', Label: 'Vendor Account Code' } ] },
		{ Section: 'Specifications', Fields: [ { Key: 'ItemSpecificationYear', Label: 'Item Spec Year' }, { Key: 'MaterialsSpecificationYear', Label: 'Materials Spec Year' }, { Key: 'ItemIDTestSpecificationSet', Label: 'Item Test Spec Set' }, { Key: 'MaterialIDTestSpecificationSet', Label: 'Material Test Spec Set' }, { Key: 'DBEStructure', Label: 'DBE Structure' } ] },
		{ Section: 'Relationships & Schedule', Fields: [ { Key: 'IDOrganization', Label: 'Prime Contractor' }, { Key: 'IDContractType', Label: 'Contract Type' }, { Key: 'IDCustomer', Label: 'Customer' }, { Key: 'EstimatedCompletionDate', Label: 'Estimated Completion' } ] },
	],
	Project:
	[
		{ Section: 'Identity', Fields: [ { Key: 'Name', Label: 'Project Name' }, { Key: 'ExternalProjectID', Label: 'External Project ID' }, { Key: 'Status', Label: 'Status' }, { Key: 'ImprovementTypeCode', Label: 'Improvement Type' } ] },
		{ Section: 'Schedule', Fields: [ { Key: 'OriginalContractedDays', Label: 'Original Contracted Days' }, { Key: 'ContractedDays', Label: 'Contracted Days' }, { Key: 'CompletedDays', Label: 'Completed Days' }, { Key: 'PaidDays', Label: 'Paid Days' }, { Key: 'PercentComplete', Label: 'Percent Complete' }, { Key: 'PercentCompleteByDays', Label: 'Percent Complete (by days)' }, { Key: 'Timezone', Label: 'Timezone' } ] },
		{ Section: 'Financials', Fields: [ { Key: 'CostPerDay', Label: 'Cost / Day' }, { Key: 'InitialContractAmount', Label: 'Initial Contract' }, { Key: 'CurrentTotalContractAmount', Label: 'Current Total Contract' }, { Key: 'CurrentTotalContractPaid', Label: 'Total Paid' }, { Key: 'PurchaseOrderNumber', Label: 'Purchase Order #' } ] },
		{ Section: 'Relationships', Fields: [ { Key: 'IDOrganization', Label: 'Prime Contractor' }, { Key: 'IDProjectType', Label: 'Project Type' }, { Key: 'IDCustomer', Label: 'Customer' } ] },
	],
	BidItem:
	[
		{ Section: 'Identity', Fields: [ { Key: 'Name', Label: 'Name' }, { Key: 'Description', Label: 'Description' } ] },
		{ Section: 'Quantities', Fields: [ { Key: 'Quantity', Label: 'Quantity' }, { Key: 'Units', Label: 'Units' }, { Key: 'CostPerUnit', Label: 'Cost / Unit' } ] },
		{ Section: 'Relationships', Fields: [ { Key: 'IDPayItem', Label: 'Pay Item' }, { Key: 'IDOrganization', Label: 'Prime Contractor' }, { Key: 'IDCustomer', Label: 'Customer' } ] },
	],
	LineItem:
	[
		{ Section: 'Identity', Fields: [ { Key: 'Name', Label: 'Name' }, { Key: 'Description', Label: 'Description' }, { Key: 'ItemCode', Label: 'Item Code' }, { Key: 'ItemNumber', Label: 'Item Number' }, { Key: 'Status', Label: 'Status' }, { Key: 'ImprovementType', Label: 'Improvement Type' }, { Key: 'CategoryNumber', Label: 'Category #' }, { Key: 'ProposalIdentifier', Label: 'Proposal ID' }, { Key: 'ChangeOrderNumber', Label: 'Change Order #' } ] },
		{ Section: 'Quantities', Fields: [ { Key: 'Units', Label: 'Units' }, { Key: 'ExpectedQuantity', Label: 'Expected Qty' }, { Key: 'ContractQuantity', Label: 'Contract Qty' }, { Key: 'ActualQuantity', Label: 'Actual Qty' }, { Key: 'InstalledQuantity', Label: 'Installed Qty' }, { Key: 'ContractorReportedQuantity', Label: 'Contractor Reported Qty' }, { Key: 'ChangeOrderQuantity', Label: 'Change Order Qty' }, { Key: 'ChangeOrderQuantityPending', Label: 'CO Qty (pending)' } ] },
		{ Section: 'Financials', Fields: [ { Key: 'CostPerUnit', Label: 'Cost / Unit' }, { Key: 'Tax', Label: 'Tax' }, { Key: 'Retainage', Label: 'Retainage' }, { Key: 'PercentComplete', Label: 'Percent Complete' }, { Key: 'FHWAEligible', Label: 'FHWA Eligible' } ] },
		{ Section: 'Schedule & Specs', Fields: [ { Key: 'DeliveryDate', Label: 'Delivery Date' }, { Key: 'SpecificationYear', Label: 'Spec Year' } ] },
		{ Section: 'Relationships', Fields: [ { Key: 'IDPayItem', Label: 'Pay Item' }, { Key: 'IDFundingCategory', Label: 'Funding Category' }, { Key: 'FundingCategory', Label: 'Funding Category (text)' }, { Key: 'IDCustomer', Label: 'Customer' } ] },
	],
};

/**
 * Humanize a raw column name for the fallback "Additional fields" section:
 * strip a leading `ID`, split camelCase, tidy runs of capitals. e.g. `PurchaseOrderNumber` -> `Purchase
 * Order Number`, `IDPayItem` -> `Pay Item`, `FHWAEligible` -> `FHWA Eligible`.
 * @param {string} pName @returns {string}
 */
function humanize(pName)
{
	let tmpName = String(pName || '');
	if (/^ID[A-Z]/.test(tmpName)) { tmpName = tmpName.slice(2); }
	return tmpName
		.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
		.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
		.trim();
}

/**
 * Group a set of settable field names into ordered { Section, Fields:[{Key,Label}] } per the entity layout;
 * anything not named in the layout lands in a trailing "Additional fields" section with a humanized label.
 * @param {string} pEntity @param {Array<string>} pFieldNames
 * @returns {Array<{Section:string, Fields:Array<{Key:string, Label:string}>}>}
 */
function groupFields(pEntity, pFieldNames)
{
	const tmpAvailable = {};
	(pFieldNames || []).forEach((pName) => { tmpAvailable[pName] = true; });
	const tmpUsed = {};
	const tmpGroups = [];

	(LAYOUTS[pEntity] || []).forEach((pSection) =>
	{
		const tmpFields = pSection.Fields
			.filter((pField) => tmpAvailable[pField.Key])
			.map((pField) => { tmpUsed[pField.Key] = true; return { Key: pField.Key, Label: pField.Label }; });
		if (tmpFields.length > 0) { tmpGroups.push({ Section: pSection.Section, Fields: tmpFields }); }
	});

	const tmpExtra = (pFieldNames || [])
		.filter((pName) => !tmpUsed[pName])
		.map((pName) => ({ Key: pName, Label: humanize(pName) }));
	if (tmpExtra.length > 0) { tmpGroups.push({ Section: 'Additional fields', Fields: tmpExtra }); }

	return tmpGroups;
}

/**
 * Resolve a source-column header to a field key for an entity — by exact/normalized field key OR by the
 * friendly Label. Lets a template's human headers ("Cost / Unit", "Purchase Order #") auto-map to the
 * schema fields (CostPerUnit, PurchaseOrderNumber). Returns '' when nothing matches.
 * @param {string} pEntity @param {string} pHeader @returns {string}
 */
function keyForHeader(pEntity, pHeader)
{
	const tmpNorm = (pStr) => String(pStr || '').toLowerCase().replace(/[^a-z0-9]/g, '');
	const tmpTarget = tmpNorm(pHeader);
	if (!tmpTarget) { return ''; }
	let tmpKey = '';
	(LAYOUTS[pEntity] || []).some((pSection) => pSection.Fields.some((pField) =>
	{
		if ((tmpNorm(pField.Label) === tmpTarget) || (tmpNorm(pField.Key) === tmpTarget)) { tmpKey = pField.Key; return true; }
		return false;
	}));
	return tmpKey;
}

module.exports = { LAYOUTS, humanize, groupFields, keyForHeader };

},{}],1090:[function(require,module,exports){
/**
 * Contract Package Import — the pre-wired Contract -> Project -> BidItem -> LineItem entity graph and the
 * pure builders that turn the bespoke view's entity-aware choices (which source column keys each level,
 * which levels are picked-constants vs created-from-data) into the exact config the shared engine consumes:
 *
 *   - a meadow-integration GUID *strategy config*  (compileGUIDStrategy / DataImport-GuidStrategyApply)
 *   - a dataimport *mapping*  (Order + Entities{} with per-entity Mappings + GUIDName + attached strategy)
 *   - a push *context*  (Order, per-entity GUID column sizes, marshal prefixes)
 *
 * This is the ONE Headlight-specific piece of the bespoke importer — the composer, strategy compiler,
 * comprehension builder and ordered multi-entity push all live in the modules (meadow-integration +
 * pict-section-dataimport) and are reused verbatim. Pure data + functions; no pict / REST / DOM here.
 *
 * The FK graph (verified against lib/headlight_model/json/Headlight.json — every level carries a DIRECT
 * foreign key to each ancestor, which is exactly what the context-aware GUID composer wants):
 *
 *     Contract (IDContract / GUIDContract)                     — root
 *        └─ Project   (IDContract)                             — Project.IDContract -> Contract
 *              └─ BidItem  (IDContract, IDProject)             — direct to both ancestors
 *                    └─ LineItem (IDContract, IDProject, IDBidItem)   — direct to all three
 *
 * How a child's foreign key to an ancestor is landed, chosen per-level by the scope step:
 *   - CREATED ancestor -> a same-upload GUID *join* (`GUID<Ancestor>`): the child carries the ancestor's
 *     COMPOSED GUID and the ordered push resolves it to the real id after the ancestor is created. The
 *     join recomputes the ancestor's FULL GUID (its own ancestors included) so it matches byte-for-byte.
 *   - PICKED ancestor -> a *constant* foreign key (`ID<Ancestor>` = the picked row id) stamped on every
 *     child as a literal mapping; the ancestor is NOT created. Its natural key still rides a synthetic
 *     constant column into each descendant GUID as a context segment, so re-imports stay idempotent.
 */

'use strict';

// The GUID marshal prefix for the whole package. The strategy composes the entire GUID (e.g.
// `UI_C10_P01278_LI8675309`), so this is the composer's prefix, not an adapter marshal prefix.
const PACKAGE_GUID_PREFIX = 'UI';

/**
 * The ordered Contract-package levels, root-first (this IS the push Order). Each declares:
 *   - Abbrev:      the STABLE GUID segment abbreviation (load-bearing — same data must yield same GUID).
 *   - GUIDName:    the entity's GUID column.
 *   - Parents:     ancestors this level carries a direct FK to (root-first).
 *   - ForeignKey:  ID<Parent> column name per parent (all direct here).
 *   - DefaultKeyColumns: sensible default natural-key columns the view pre-selects (user can change).
 *   - GUIDSize:    fallback GUID column width (the live schema width wins at runtime).
 */
const PACKAGE_ENTITIES =
[
	{
		Entity: 'Contract', Abbrev: 'C', GUIDName: 'GUIDContract',
		Label: 'Contract', Icon: 'fas fa-file-signature',
		Parents: [],
		ForeignKey: {},
		DefaultKeyColumns: [ 'PrimaryProjectNumber', 'Name' ],
		// Normalized (lowercased, alphanumeric-only) substrings the auto-seed prefers, in order, when
		// picking the key column from realistic headers ("Contract Number", "Contract No", …).
		KeyHints: [ 'contractnumber', 'contractno', 'primaryprojectnumber', 'contractid', 'contract' ],
		GUIDSize: 64,
	},
	{
		Entity: 'Project', Abbrev: 'P', GUIDName: 'GUIDProject',
		Label: 'Project', Icon: 'fas fa-diagram-project',
		Parents: [ 'Contract' ],
		ForeignKey: { Contract: 'IDContract' },
		DefaultKeyColumns: [ 'Name' ],
		KeyHints: [ 'projectnumber', 'projectname', 'projectcode', 'projectid', 'project' ],
		GUIDSize: 64,
	},
	{
		Entity: 'BidItem', Abbrev: 'BI', GUIDName: 'GUIDBidItem',
		Label: 'Bid Item', Icon: 'fas fa-list-ol',
		Parents: [ 'Contract', 'Project' ],
		ForeignKey: { Contract: 'IDContract', Project: 'IDProject' },
		DefaultKeyColumns: [ 'Name' ],
		KeyHints: [ 'biditemnumber', 'biditemname', 'biditem', 'bidgroup', 'sectionname' ],
		GUIDSize: 64,
	},
	{
		Entity: 'LineItem', Abbrev: 'LI', GUIDName: 'GUIDLineItem',
		Label: 'Line Item', Icon: 'fas fa-list-check',
		Parents: [ 'Contract', 'Project', 'BidItem' ],
		ForeignKey: { Contract: 'IDContract', Project: 'IDProject', BidItem: 'IDBidItem' },
		DefaultKeyColumns: [ 'ItemNumber', 'Name' ],
		KeyHints: [ 'itemnumber', 'lineitemnumber', 'linenumber', 'itemno', 'itemcode' ],
		GUIDSize: 64,
	},
];

const ENTITY_ORDER = PACKAGE_ENTITIES.map((pEntity) => pEntity.Entity);

/** Look up a package level by entity name. @param {string} pEntity @returns {object|null} */
function findLevel(pEntity)
{
	return PACKAGE_ENTITIES.find((pLevel) => pLevel.Entity === pEntity) || null;
}

/** The synthetic per-row column that carries a PICKED ancestor's natural key into descendant GUIDs. */
function syntheticKeyColumn(pParentEntity)
{
	return `__PKG_${pParentEntity}Key`;
}

/**
 * The context catalog (Abbrev / GUIDSize per entity) the GUID strategy compiler consumes. Built from the
 * package graph so the abbreviations always agree with PACKAGE_ENTITIES.
 * @returns {Record<string,{Abbrev:string, KeyField:string, GUIDSize:number}>}
 */
function contextCatalog()
{
	const tmpCatalog = {};
	PACKAGE_ENTITIES.forEach((pLevel) =>
	{
		tmpCatalog[pLevel.Entity] = { Abbrev: pLevel.Abbrev, KeyField: pLevel.DefaultKeyColumns[0], GUIDSize: pLevel.GUIDSize };
	});
	return tmpCatalog;
}

/**
 * Normalize the per-level scope + key selections the view collected into a canonical plan the builders
 * consume. Defensive about missing pieces so a partially-filled UI never throws mid-build.
 *
 * @param {object} pScope
 * @param {Record<string,'create'|'pick'>} pScope.Modes            per-entity: 'create' | 'pick'
 * @param {Record<string,number>}          [pScope.PickedIDs]      picked row id per 'pick' entity (constant FK)
 * @param {Record<string,string>}          [pScope.PickedKeys]     picked parent natural key per 'pick' entity
 *                                                                 (a constant GUID context segment)
 * @param {Record<string,string[]>}        [pScope.KeyColumns]     per created entity: source column(s) that key it
 *                                                                 (v1 uses the first — a single key keeps joins matched)
 * @param {Record<string,string>}          [pScope.ParentKeyColumns] "<Child>.<Parent>" -> the source column in the
 *                                                                 child's rows that identifies that created ancestor
 * @returns {{Levels: Array<object>, Order: string[]}}
 */
function normalizePlan(pScope)
{
	const tmpScope = pScope || {};
	const tmpModes = tmpScope.Modes || {};
	const tmpPickedIDs = tmpScope.PickedIDs || {};
	const tmpPickedKeys = tmpScope.PickedKeys || {};
	const tmpKeyColumns = tmpScope.KeyColumns || {};
	const tmpParentKeyColumns = tmpScope.ParentKeyColumns || {};
	const tmpReferenceKeyColumns = tmpScope.ReferenceKeyColumns || {};

	const tmpLevels = PACKAGE_ENTITIES.map((pLevel) =>
	{
		const tmpMode = (tmpModes[pLevel.Entity] === 'pick') ? 'pick'
			: (tmpModes[pLevel.Entity] === 'reference') ? 'reference' : 'create';
		const tmpKeys = Array.isArray(tmpKeyColumns[pLevel.Entity])
			? tmpKeyColumns[pLevel.Entity].filter((pColumn) => !!pColumn)
			: [];
		return Object.assign({}, pLevel,
			{
				Mode: tmpMode,
				KeyColumns: (tmpKeys.length > 0) ? tmpKeys : pLevel.DefaultKeyColumns.slice(0, 1),
				PickedID: tmpPickedIDs[pLevel.Entity],
				PickedKey: tmpPickedKeys[pLevel.Entity],
				// The source column in THIS level's rows that identifies each created ancestor (giant sheet:
				// usually the ancestor's own key column; the view can override per Child.Parent pair).
				ParentKeyColumn: pLevel.Parents.reduce((pMap, pParent) =>
				{
					pMap[pParent] = tmpParentKeyColumns[`${pLevel.Entity}.${pParent}`] || '';
					return pMap;
				}, {}),
			});
	});

	// Only levels the user chose to create are pushed. A picked level drops out of creation (it already
	// exists) — its identity flows to descendants as a constant FK + constant GUID context segment.
	const tmpOrder = tmpLevels.filter((pLevel) => pLevel.Mode === 'create').map((pLevel) => pLevel.Entity);

	return { Levels: tmpLevels, Order: tmpOrder, ReferenceKeyColumns: tmpReferenceKeyColumns };
}

/** The per-row column carrying a referenced parent's resolved ID (many-project items import). */
function resolvedIDColumn(pParentEntity)
{
	return `__PKG_ID${pParentEntity}`;
}

/** The mode ('create' | 'pick') of a level within a plan. */
function _levelMode(pPlan, pEntity)
{
	const tmpLevel = pPlan.Levels.find((pLevel) => pLevel.Entity === pEntity);
	return tmpLevel ? tmpLevel.Mode : 'create';
}

/**
 * The source column in a CHILD level's rows that identifies an ANCESTOR — the single knob every context
 * segment + join key reuses, so the child's recomputed ancestor GUID matches the ancestor's own GUID:
 *   - picked ancestor  -> its synthetic constant column (carries the picked natural key on every row)
 *   - created ancestor -> the child's explicit Child.Parent override, else the ancestor's own key column
 *     (in a giant denormalized sheet these are the same physical column)
 */
function _childColumnForAncestor(pChildLevel, pAncestor, pPlan)
{
	if (_levelMode(pPlan, pAncestor) === 'pick')
	{
		return syntheticKeyColumn(pAncestor);
	}
	if (_levelMode(pPlan, pAncestor) === 'reference')
	{
		// An existing parent matched per-row by a real key column in the data (many-project items import).
		return (pPlan.ReferenceKeyColumns || {})[pAncestor] || '';
	}
	// The ancestor's own key column comes from the NORMALIZED plan level (KeyColumns), not the raw catalog
	// entry (which only carries DefaultKeyColumns).
	const tmpAncestorLevel = pPlan.Levels.find((pLevel) => pLevel.Entity === pAncestor);
	return pChildLevel.ParentKeyColumn[pAncestor] || (tmpAncestorLevel ? tmpAncestorLevel.KeyColumns[0] : '');
}

/**
 * Build the meadow-integration GUID strategy config for a normalized plan. Each created level composes its
 * GUID from every ancestor's key segment (context) + its own single key, and carries a same-upload GUID
 * join for every CREATED ancestor — the join carrying the ancestor's own grandparent context so the
 * recomputed `GUID<Ancestor>` matches the ancestor's own GUID byte-for-byte. PICKED ancestors are context
 * segments only (via their synthetic constant column); their FK is landed as a constant ID by buildMapping.
 *
 * @param {{Levels:Array<object>, Order:string[]}} pPlan
 * @returns {{Prefix:string, Entities:Record<string,object>}}
 */
function buildStrategyConfig(pPlan)
{
	const tmpPlan = pPlan || normalizePlan({});
	const tmpEntities = {};

	tmpPlan.Levels.forEach((pLevel) =>
	{
		if (pLevel.Mode !== 'create')
		{
			return; // picked levels aren't composed / created
		}

		// EVERY ancestor (created or picked) contributes a context segment, keyed by the child's column
		// for that ancestor (a real column, or the picked ancestor's synthetic constant column).
		const tmpContextEntities = pLevel.Parents.slice(); // already root-first
		const tmpContextKeyColumns = {};
		tmpContextEntities.forEach((pParent) =>
		{
			tmpContextKeyColumns[pParent] = _childColumnForAncestor(pLevel, pParent, tmpPlan);
		});

		// Joins (FK GUID fields) only for CREATED ancestors. Each join recomputes the ancestor's full GUID,
		// so it carries the ancestor's OWN ancestors as grandparent context (keyed by the child's columns).
		const tmpJoins = pLevel.Parents
			.filter((pParent) => _levelMode(tmpPlan, pParent) === 'create')
			.map((pParent) =>
			{
				const tmpParentLevel = findLevel(pParent);
				const tmpGrandContext = (tmpParentLevel ? tmpParentLevel.Parents : []).slice();
				const tmpGrandKeyColumns = {};
				tmpGrandContext.forEach((pGrand) =>
				{
					tmpGrandKeyColumns[pGrand] = _childColumnForAncestor(pLevel, pGrand, tmpPlan);
				});
				return {
					ParentEntity: pParent,
					Mode: 'prefixed',
					KeyColumn: _childColumnForAncestor(pLevel, pParent, tmpPlan),
					ContextEntities: tmpGrandContext,
					ContextKeyColumns: tmpGrandKeyColumns,
					CrossSession: false, // same upload — resolved from the ordered push batch's GUIDMap
				};
			});

		tmpEntities[pLevel.Entity] =
		{
			Mode: 'prefixed',
			OwnKeyColumn: pLevel.KeyColumns[0], // single key column — keeps the join recompute matched
			ContextEntities: tmpContextEntities,
			ContextKeyColumns: tmpContextKeyColumns,
			Joins: tmpJoins,
		};
	});

	return { Prefix: PACKAGE_GUID_PREFIX, Entities: tmpEntities };
}

/**
 * Build the dataimport mapping (Order + Entities{}) for a normalized plan + the per-entity column->field
 * assignments the map step produced. Constant foreign keys (picked ancestors) are injected as literal
 * mapping values; created-ancestor FKs are left to the GUID join (attached later by applyStrategy).
 *
 * @param {{Levels:Array<object>, Order:string[]}} pPlan
 * @param {Record<string, Record<string,string>>} pFieldAssignments  entity -> { targetField: sourceColumn }
 * @returns {{Order:string[], Entities:Record<string,object>}}
 */
function buildMapping(pPlan, pFieldAssignments)
{
	const tmpPlan = pPlan || normalizePlan({});
	const tmpAssignments = pFieldAssignments || {};
	const tmpEntities = {};

	tmpPlan.Levels.forEach((pLevel) =>
	{
		if (pLevel.Mode !== 'create')
		{
			return;
		}

		const tmpAssigned = tmpAssignments[pLevel.Entity] || {};
		const tmpMappings = {};

		// Real data columns the user mapped: value is a pict template pulling the source column.
		Object.keys(tmpAssigned).forEach((pTargetField) =>
		{
			const tmpSourceColumn = tmpAssigned[pTargetField];
			if (tmpSourceColumn)
			{
				tmpMappings[pTargetField] = `{~D:Record.${tmpSourceColumn}~}`;
			}
		});

		// Foreign keys for non-created ancestors:
		//   pick      -> a literal constant id (the picked parent), passed through verbatim.
		//   reference -> `{~D:Record.__PKG_ID<Parent>~}`, the per-row id the provider resolved by natural key.
		// (created ancestors carry no ID<Parent> mapping — their FK is the strategy's GUID join.)
		pLevel.Parents.forEach((pParent) =>
		{
			const tmpFKColumn = pLevel.ForeignKey[pParent];
			if (!tmpFKColumn) { return; }
			const tmpParentMode = _levelMode(tmpPlan, pParent);
			if (tmpParentMode === 'pick')
			{
				const tmpParentLevel = tmpPlan.Levels.find((pOther) => pOther.Entity === pParent);
				if (tmpParentLevel && (tmpParentLevel.PickedID != null)) { tmpMappings[tmpFKColumn] = String(tmpParentLevel.PickedID); }
			}
			else if (tmpParentMode === 'reference')
			{
				tmpMappings[tmpFKColumn] = `{~D:Record.${resolvedIDColumn(pParent)}~}`;
			}
		});

		tmpEntities[pLevel.Entity] = { Entity: pLevel.Entity, GUIDName: pLevel.GUIDName, Mappings: tmpMappings };
	});

	return { Order: tmpPlan.Order.slice(), Entities: tmpEntities };
}

/**
 * Add the synthetic constant columns a plan's PICKED ancestors need (their natural key on every row) so
 * the GUID composer can fold them into descendant GUIDs. Returns a new row array (originals untouched);
 * a no-op (same array) when nothing is picked.
 * @param {Array<Record<string,any>>} pRows @param {{Levels:Array<object>}} pPlan
 * @returns {Array<Record<string,any>>}
 */
function injectConstantColumns(pRows, pPlan)
{
	const tmpPlan = pPlan || normalizePlan({});
	const tmpPicked = tmpPlan.Levels.filter((pLevel) => (pLevel.Mode === 'pick') && (pLevel.PickedKey != null) && (String(pLevel.PickedKey) !== ''));
	if (tmpPicked.length === 0)
	{
		return Array.isArray(pRows) ? pRows : [];
	}
	return (Array.isArray(pRows) ? pRows : []).map((pRow) =>
	{
		const tmpRow = Object.assign({}, pRow);
		tmpPicked.forEach((pLevel) => { tmpRow[syntheticKeyColumn(pLevel.Entity)] = String(pLevel.PickedKey); });
		return tmpRow;
	});
}

/**
 * The push context the shared _pushViaHeadlight seam consumes: ordered created entities, per-entity GUID
 * column widths (so a composed GUID isn't re-truncated), and the explicitly-empty marshal prefixes that
 * tell the adapter to store the strategy-composed GUID verbatim.
 * @param {{Order:string[]}} pPlan
 * @param {Record<string,number>} [pGUIDSizes]  entity -> GUID column width (from the resolved schema)
 * @returns {{Order:string[], GUIDPrefix:string, EntityGUIDPrefix:string, AllowGUIDTruncation:boolean, GUIDColumnSizes:Record<string,number>}}
 */
function buildPushContext(pPlan, pGUIDSizes)
{
	const tmpPlan = pPlan || normalizePlan({});
	const tmpSizes = pGUIDSizes || {};
	const tmpColumnSizes = {};
	tmpPlan.Order.forEach((pEntity) =>
	{
		const tmpLevel = findLevel(pEntity);
		tmpColumnSizes[pEntity] = tmpSizes[pEntity] || (tmpLevel ? tmpLevel.GUIDSize : 64);
	});
	return {
		Order: tmpPlan.Order.slice(),
		// Empty marshal prefixes: the GUID strategy already composed the full `UI_...` GUID; the adapter
		// must store it verbatim (a non-empty prefix would double-marshal + break cross-level FK matching).
		GUIDPrefix: '',
		EntityGUIDPrefix: '',
		AllowGUIDTruncation: true,
		GUIDColumnSizes: tmpColumnSizes,
	};
}

module.exports =
{
	PACKAGE_GUID_PREFIX,
	PACKAGE_ENTITIES,
	ENTITY_ORDER,
	findLevel,
	syntheticKeyColumn,
	resolvedIDColumn,
	contextCatalog,
	normalizePlan,
	buildStrategyConfig,
	buildMapping,
	injectConstantColumns,
	buildPushContext,
};

},{}],1091:[function(require,module,exports){
// GENERATED FILE — do not edit by hand (run examples/contract-package-import/embed-template.js).
// Base64-embedded copy of assets/Headlight-Contract-Package-Template.xlsx. The Contract Package importer
// downloads these bytes via a Blob, so the "Download the Excel template" link ships inside the JS bundle
// and can never 404 / show as "unavailable" regardless of how the app's static assets are served.
module.exports =
{
	FileName: 'Headlight-Contract-Package-Template.xlsx',
	MimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	ByteLength: 13872,
	Base64: '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',
};

},{}],1092:[function(require,module,exports){
/**
 * Data Import — pure mapping from a Headlight `/1.0/<Entity>/Schema` body to the target-schema shape
 * pict-section-dataimport's mapping step consumes:
 *   { Entities: [ { Entity, GUIDName, Fields: [ { Name, Type, Size, Required, IsGUID, ForeignKeyEntity } ] } ], Order }
 *
 * Headlight's schema endpoint returns JSON-schema (`{ properties: { Col: { type, size } } }`); meadow's
 * native shape (`{ Columns: [...] }`) is also accepted. System / audit / auto-PK columns are dropped so
 * the column-mapping UI only shows real, settable fields. No pict / REST dependency — unit-testable.
 *
 * This is the browser-clean equivalent of pict-section-dataimport's own Meadow schema adapter, which we
 * cannot use directly because it hard-requires `pict.EntityProvider` (the Headlight config app drives
 * everything through HeadlightRestClient instead). v1 is single-entity, so there is no foreign-key
 * inference and the Order is just `[ entity ]`.
 */

// Audit / lifecycle columns Meadow stamps on every entity — noise in a column-mapping UI.
const SYSTEM_COLUMNS =
{
	CreateDate: 1, CreatingIDUser: 1, UpdateDate: 1, UpdatingIDUser: 1,
	Deleted: 1, DeleteDate: 1, DeletingIDUser: 1,
};

/**
 * Pull a normalized column list out of a schema body (JSON-schema `properties`, meadow `Columns`, or a
 * bare `Schema` array).
 * @param {Record<string, any>} pSchemaBody
 * @returns {Array<Record<string, any>>}
 */
function extractColumns(pSchemaBody)
{
	const tmpBody = pSchemaBody || {};
	if (Array.isArray(tmpBody.Columns))
	{
		return tmpBody.Columns;
	}
	if (Array.isArray(tmpBody.Schema))
	{
		return tmpBody.Schema;
	}
	if (tmpBody.properties && (typeof tmpBody.properties === 'object'))
	{
		return Object.keys(tmpBody.properties).map((pKey) => Object.assign({ Column: pKey }, tmpBody.properties[pKey]));
	}
	return [];
}

/**
 * Map one entity's schema body to the dataimport target-schema descriptor.
 * @param {string} pEntityName
 * @param {Record<string, any>} pSchemaBody
 * @returns {{Entities:Array<any>, Order:Array<string>}}
 */
function mapEntitySchema(pEntityName, pSchemaBody)
{
	const tmpGUIDName = `GUID${pEntityName}`;
	const tmpColumns = extractColumns(pSchemaBody);
	const tmpFields = tmpColumns.map((pColumn) =>
	{
		const tmpName = pColumn.Column || pColumn.Name || pColumn.column;
		return {
			Name: tmpName,
			Type: pColumn.DataType || pColumn.Type || pColumn.type || 'string',
			Size: Number(pColumn.Size || pColumn.size || 0) || 0,
			Required: !!(pColumn.Required || pColumn.NonNull),
			IsGUID: (tmpName === tmpGUIDName),
			ForeignKeyEntity: '',
		};
	}).filter((pField) => !!pField.Name
		&& (pField.Name !== `ID${pEntityName}`)      // the auto-increment primary key
		&& !SYSTEM_COLUMNS[pField.Name]);            // audit / lifecycle columns

	return {
		Entities: [ { Entity: pEntityName, GUIDName: tmpGUIDName, Fields: tmpFields } ],
		Order: [ pEntityName ],
	};
}

module.exports =
{
	SYSTEM_COLUMNS,
	extractColumns,
	mapEntitySchema,
};

},{}],1093:[function(require,module,exports){
/**
 * DataImport-Xlsx-Parser — a host-side Excel parser for the pict-section-dataimport wizard.
 *
 * Why this exists: the Headlight build EXCLUDES `xlsx` from browserify (`.gulpfile-quackage-config.json`
 * BrowserifyIgnore) and loads SheetJS as a global (`window.XLSX`, `html/index.html`) — bundling the Node-only
 * paths of xlsx@0.18.5 breaks module evaluation. The stock module parser only does `require('xlsx')`, which
 * under `--ignore` returns an EMPTY STUB `{}` (it does not throw), so `XLSX.read(...)` blows up with
 * "read is not a function" inside the detect promise → the wizard silently renders an empty step and Excel
 * "fails outright". This subclass fixes it exactly the way the app's legacy importer does
 * (ContractProjectTypesImportProvider `_getXlsx`): prefer `window.XLSX`, fall back to `require`, and fail
 * with a clear message when neither is a real SheetJS. Registered via the wizard's `Parsers` seam
 * (DataImport-Provider), so no module edit / republish is needed.
 */

const libPictSectionDataImport = require('pict-section-dataimport');

class DataImportXlsxParser extends libPictSectionDataImport.ParserXlsx
{
	/**
	 * Resolve SheetJS: the browser global first (how Headlight ships it), then the optional npm dep, and
	 * throw a clear error if what we got isn't a real SheetJS (guards the browserify-ignore stub `{}`).
	 * @return {any}
	 */
	_xlsx()
	{
		if (this._xlsxLib) { return this._xlsxLib; }
		if ((typeof window !== 'undefined') && window.XLSX) { this._xlsxLib = window.XLSX; }
		else { try { this._xlsxLib = require('xlsx'); } catch (pError) { this._xlsxLib = null; } }
		if (!this._xlsxLib || (typeof this._xlsxLib.read !== 'function'))
		{
			throw new Error('DataImport: the xlsx (SheetJS) library is not available — it should load as window.XLSX (js/xlsx.full.min.js).');
		}
		return this._xlsxLib;
	}

	/**
	 * Read the chosen worksheet as an array-of-arrays. Overridden to (a) resolve xlsx + read the buffer
	 * INSIDE the promise so any failure rejects (rather than throwing synchronously out of detect()/parse()
	 * and bypassing the wizard's .catch), and (b) wrap the buffer as a Uint8Array so SheetJS's
	 * `instanceof ArrayBuffer` check holds across bundle/iframe realms.
	 * @param {Record<string, any>} pFileHandle
	 * @param {Record<string, any>} pParseConfig
	 * @return {Promise<Array<Array<any>>>}
	 */
	_readSheetMatrix(pFileHandle, pParseConfig)
	{
		return this._readArrayBuffer(pFileHandle).then((pBuffer) =>
		{
			const tmpXLSX = this._xlsx();
			const tmpWorkbook = tmpXLSX.read(new Uint8Array(pBuffer), { type: 'array' });
			const tmpSheetName = (pParseConfig && pParseConfig.Xlsx && pParseConfig.Xlsx.SheetName) || tmpWorkbook.SheetNames[0];
			const tmpSheet = tmpWorkbook.Sheets[tmpSheetName];
			if (!tmpSheet) { return []; }
			return tmpXLSX.utils.sheet_to_json(tmpSheet, { header: 1, defval: '', blankrows: false });
		});
	}

	/**
	 * The worksheet/tab names in an uploaded workbook — used by the bespoke Contract-package import to treat
	 * a multi-tab workbook as one dataset per entity.
	 * @param {Record<string, any>} pFileHandle
	 * @return {Promise<Array<string>>}
	 */
	listSheetNames(pFileHandle)
	{
		return this._readArrayBuffer(pFileHandle).then((pBuffer) =>
		{
			const tmpXLSX = this._xlsx();
			const tmpWorkbook = tmpXLSX.read(new Uint8Array(pBuffer), { type: 'array' });
			return tmpWorkbook.SheetNames || [];
		});
	}
}

module.exports = DataImportXlsxParser;

},{"pict-section-dataimport":566,"xlsx":363}],1094:[function(require,module,exports){
/**
 * Headlight context-entity catalog for the data-import GUID strategy.
 *
 * The five "context" entities whose identity can be baked into a child record's GUID so the GUID is
 * globally unique without a true UUID (e.g. a Line Item on Contract 10 / Project 01278 composes to
 * `UI_C10_P01278_LI8675309`). Each entity has a STABLE abbreviation — load-bearing for cross-import
 * matching, since the same source data must always yield the same GUID — plus its natural-key field
 * (informational; the uploader maps the actual source column in the GUID-strategy panel).
 *
 * This is the ONE host-specific piece of the GUID work; the composer + strategy compiler live in
 * meadow-integration and the configuration UI lives in pict-section-dataimport. Passed into the wizard
 * via DataImport-Provider as `ContextEntityCatalog`.
 */
module.exports =
{
	Project: { Abbrev: 'P', KeyField: 'Name', GUIDSize: 64 },
	Contract: { Abbrev: 'C', KeyField: 'Name', GUIDSize: 64 },
	Sample: { Abbrev: 'S', KeyField: 'Name', GUIDSize: 64 },
	PhysicalAsset: { Abbrev: 'PA', KeyField: 'Name', GUIDSize: 128 },
	Inspection: { Abbrev: 'I', KeyField: 'Name', GUIDSize: 36 },
};

},{}],1095:[function(require,module,exports){
/**
 * Data Import — the catalog of Meadow reference entities an administrator can bulk-import from a file
 * (CSV / TSV / Excel) via the pict-section-dataimport wizard.
 *
 * The list is derived from the platform Master List seed (the same Entity / Label / Icon the rest of
 * the app uses) — EVERY master list is an import target, minus a small exclude set of entities that are
 * not backed by a normal importable table. Because the wizard is schema-driven (it fetches
 * `/1.0/<Entity>/Schema` and lets the admin map spreadsheet columns to fields), any real Meadow entity
 * works; the only thing that would break is a catalog name with no `/Schema` endpoint (see the exclude
 * set below). Some master lists are "context-dependent" — a Sample, Line Item, Bid Item, Lot, Core,
 * Test Instance, Mix Design, Test Specification / Requirement belongs to a parent (Project, Contract,
 * Material, …), so a standalone import is only meaningful when the source file carries the parent FK
 * id column(s); they are still offered (the admin maps those columns), but flat catalogs (Materials,
 * Pay Items, Test Specification Sets, …) import with no parent. Pure data + helpers — no pict / REST.
 */

const libMasterLists = require('../master-lists/Headlight-MasterLists.js');

// Reserved: master-list entries to keep OUT of the import targets — for any list not backed by a real
// importable Meadow table (no live `/1.0/<Entity>/Schema` + create endpoint, so the wizard would have
// nothing to map). Currently EMPTY — every master list, SampleStatus included, resolves a live schema
// endpoint and imports through the same schema-driven wizard. Add a future synthesized / non-table
// master list here if one is ever added to the catalog.
const IMPORT_EXCLUDE = new Set();

/**
 * Build the import targets from EVERY master list (in catalog order), minus IMPORT_EXCLUDE, as
 * { Entity, Label, Icon, Description }. New master lists flow through automatically.
 * @returns {Array<{Entity:string, Label:string, Icon:string, Description:string}>}
 */
function buildImportEntities()
{
	return (Array.isArray(libMasterLists) ? libMasterLists : [])
		.filter((pEntry) => pEntry && pEntry.Entity && !IMPORT_EXCLUDE.has(pEntry.Entity))
		.map((pEntry) =>
			({
				Entity: pEntry.Entity,
				Label: pEntry.Label || pEntry.Entity,
				Icon: pEntry.Icon || 'fas fa-table',
				Description: pEntry.Description || '',
			}));
}

// The context entities (Project, Contract, ...) are also importable — both so an admin can bulk-load
// them and so they're available as the PARENTS of interconnected child imports (the GUID-strategy panel
// references them). Stable abbreviations + sizes live in Import-Context-Catalog.js.
const CONTEXT_IMPORT_ENTITIES =
[
	{ Entity: 'Project', Label: 'Projects', Icon: 'fas fa-diagram-project', Description: 'Projects — a context parent for interconnected imports (Line Items, Samples, …).' },
	{ Entity: 'Contract', Label: 'Contracts', Icon: 'fas fa-file-signature', Description: 'Contracts — a context parent for interconnected imports.' },
	{ Entity: 'Sample', Label: 'Samples', Icon: 'fas fa-vial', Description: 'Field / material samples.' },
	{ Entity: 'PhysicalAsset', Label: 'Physical Assets', Icon: 'fas fa-cubes', Description: 'Physical assets / infrastructure inventory.' },
	{ Entity: 'Inspection', Label: 'Inspections', Icon: 'fas fa-clipboard-check', Description: 'Inspections.' },
];

const IMPORT_ENTITIES = (() =>
{
	const tmpList = buildImportEntities();
	const tmpSeen = {};
	tmpList.forEach((pEntity) => { tmpSeen[pEntity.Entity] = true; });
	CONTEXT_IMPORT_ENTITIES.forEach((pEntity) => { if (!tmpSeen[pEntity.Entity]) { tmpList.push(pEntity); } });
	return tmpList;
})();

/**
 * Look up a curated import entity by name.
 * @param {string} pEntityName
 * @returns {{Entity:string, Label:string, Icon:string, Description:string}|null}
 */
function findEntity(pEntityName)
{
	return IMPORT_ENTITIES.find((pEntity) => pEntity.Entity === pEntityName) || null;
}

module.exports =
{
	IMPORT_EXCLUDE,
	IMPORT_ENTITIES,
	buildImportEntities,
	findEntity,
};

},{"../master-lists/Headlight-MasterLists.js":1290}],1096:[function(require,module,exports){
/**
 * Pure builder + validator for the "create a materialized projection" wizard.
 *
 * No pict / DOM / network dependencies — just deterministic transforms of plain state, so the create
 * flow's body construction + validation can be unit-tested in isolation. Mirrors the server contract in
 * services/platform_data_operations/source/endpoints/Projection-Endpoints.js (Name regex, Target customer
 * silo prefix, OperationType allow-list, required OperationConfiguration) so the user never round-trips to
 * a 400. The wizard supports the Extraction operation (pick a source entity → project columns); the other
 * operation types are listed for completeness / later tiers.
 */

const NAME_REGEX = /^[A-Za-z][A-Za-z0-9_]*$/;

const OPERATION_TYPES =
[
	'Extraction', 'Unnest', 'Aggregation', 'Histogram', 'Intersection', 'PassthroughClone', 'SQLAggregate', 'SQLJoin',
];

/**
 * Map a JSON-Schema scalar type (from a meadow /Schema response) to a meadow DDL column Type for the lake
 * TargetSchema. Unsized strings become Text (a sized String silently drops longer values on every run and
 * can't be widened without dropping the table — the projection-agent-guide "learned the hard way" trap).
 * @param {string} pJsonType
 * @param {string} [pSize]
 * @returns {string}
 */
function jsonTypeToMeadow(pJsonType, pSize)
{
	switch (pJsonType)
	{
		case 'integer': return 'Integer';
		case 'number': return 'Numeric';
		case 'boolean': return 'Boolean';
		case 'string':
		default:
			return (!pSize || pSize === 'Default') ? 'Text' : 'String';
	}
}

/**
 * Normalize a raw database column type (from /mapper/introspect of an imported lake clone — Postgres/MSSQL
 * types like bigint/varchar/numeric) to a JSON-Schema scalar type, so imported-clone columns flow through
 * the same field-builder + jsonTypeToMeadow as projection (/PrivateDataLake/Schema) and entity (/Schema)
 * columns. Unknown / exotic types default to string (safe — never silently mis-sizes a numeric column).
 * @param {string} pDbType
 * @returns {string}
 */
function dbTypeToJsonType(pDbType)
{
	const tmpType = String(pDbType || '').toLowerCase().trim();
	if (tmpType.startsWith('interval')) { return 'string'; }
	if (/serial/.test(tmpType) || /^(big|small|tiny)?int/.test(tmpType)) { return 'integer'; }
	if (/^(numeric|decimal|dec|real|double|float|money)/.test(tmpType)) { return 'number'; }
	if (/^bool/.test(tmpType)) { return 'boolean'; }
	if (/json/.test(tmpType)) { return 'object'; }
	return 'string';
}

/**
 * Derive the source address for an Extraction from a Headlight entity.
 * @param {{ SourceConnectionPrefix?: string, Entity: string, Filter?: string }} pState
 * @returns {string}
 */
function buildSourceAddress(pState)
{
	const tmpFilter = (pState.Filter || '').trim();
	if (pState.SourceType === 'lake' && pState.LakeSource)
	{
		// Lake source: an existing computed projection or imported clone, already addressed as lake/<physical>.
		return tmpFilter ? `${pState.LakeSource}/FilteredTo/${tmpFilter}` : pState.LakeSource;
	}
	const tmpPrefix = pState.SourceConnectionPrefix || 'headlight_api';
	const tmpEntity = pState.Entity;
	return tmpFilter ? `${tmpPrefix}/${tmpEntity}/FilteredTo/${tmpFilter}` : `${tmpPrefix}/${tmpEntity}`;
}

/**
 * Build the POST /1.0/Projection body for an Extraction from the wizard state.
 * @param {object} pState - { IDCustomer, Name, Entity, SourceConnectionPrefix?, Filter?, GUIDTemplate, Description?, fields:[{ SourceField, OutCol?, JsonType, Size?, Include? }] }
 * @returns {object} the POST body
 */
function buildExtractionBody(pState)
{
	const tmpDataset = `C${pState.IDCustomer}_${pState.Name}`;
	const tmpProjection = {};
	const tmpColumns = [];
	const tmpFields = (pState.fields || []).filter((pField) => pField && pField.Include !== false);
	for (const tmpField of tmpFields)
	{
		const tmpOutCol = tmpField.OutCol || tmpField.SourceField;
		tmpProjection[tmpOutCol] = `{~D:Record.${tmpField.SourceField}~}`;
		const tmpColumn = { Column: tmpOutCol, Type: jsonTypeToMeadow(tmpField.JsonType, tmpField.Size) };
		if (tmpField.Size && tmpField.Size !== 'Default' && tmpColumn.Type === 'String')
		{
			tmpColumn.Size = tmpField.Size;
		}
		tmpColumns.push(tmpColumn);
	}

	const tmpBody =
	{
		IDCustomer: parseInt(pState.IDCustomer, 10),
		Name: pState.Name,
		OperationType: 'Extraction',
		Source: buildSourceAddress(pState),
		Target: `lake/${tmpDataset}`,
		OperationConfiguration:
		{
			Entity: tmpDataset,
			GUIDTemplate: pState.GUIDTemplate,
			Projection: tmpProjection,
		},
	};
	if (tmpColumns.length > 0)
	{
		tmpBody.TargetSchema = { Columns: tmpColumns };
	}
	if (pState.Description)
	{
		tmpBody.Description = pState.Description;
	}
	return tmpBody;
}

/**
 * Validate the wizard state for an Extraction, mirroring the server's checks.
 * @param {object} pState
 * @returns {{ Valid: boolean, Errors: Array<string> }}
 */
function validateExtractionState(pState)
{
	const tmpErrors = [];
	const tmpID = parseInt(pState && pState.IDCustomer, 10);
	if (!(tmpID > 0))
	{
		tmpErrors.push('A customer is required.');
	}
	if (!pState || !pState.Name || !NAME_REGEX.test(pState.Name))
	{
		tmpErrors.push('Name must start with a letter and contain only letters, numbers, and underscores.');
	}
	const tmpIsLake = !!(pState && pState.SourceType === 'lake');
	if (!pState || (tmpIsLake ? !pState.LakeSource : !pState.Entity))
	{
		tmpErrors.push(tmpIsLake ? 'A source data-lake table is required.' : 'A source entity is required.');
	}
	else if (tmpIsLake && tmpID > 0 && pState.Name && pState.LakeSource === `lake/C${tmpID}_${pState.Name}`)
	{
		tmpErrors.push('The new projection name must differ from the source lake table.');
	}
	const tmpFields = (pState && Array.isArray(pState.fields) ? pState.fields : []).filter((pField) => pField && pField.Include !== false);
	if (tmpFields.length < 1)
	{
		tmpErrors.push('Select at least one column to project.');
	}
	if (!pState || !pState.GUIDTemplate || pState.GUIDTemplate.indexOf('{~D:Record.') < 0)
	{
		tmpErrors.push('The GUID template must reference a record field, e.g. {~D:Record.IDProject~}.');
	}
	// Target customer-silo check (mirrors Projection-Endpoints: the 2nd path segment must start with C<id>_).
	if (tmpID > 0 && pState && pState.Name)
	{
		const tmpTarget = `lake/C${tmpID}_${pState.Name}`;
		const tmpSegment = tmpTarget.replace(/^\/+/, '').split('/')[1] || '';
		if (!tmpSegment.startsWith(`C${tmpID}_`))
		{
			tmpErrors.push('The target must live in this customer\'s lake silo.');
		}
	}
	return { Valid: tmpErrors.length === 0, Errors: tmpErrors };
}

/**
 * Build the POST /1.0/Projection body for a PassthroughClone — a 1:1 copy of a lake table into a new,
 * registered (queryable) lake table. Used to "projectionize" a raw imported clone table so its rows become
 * browsable over the API. No column picking (the operation copies all columns + infers the schema).
 * @param {{ IDCustomer, Name, LakeSource:string, Description? }} pState
 * @returns {object}
 */
function buildPassthroughCloneBody(pState)
{
	const tmpDataset = `C${pState.IDCustomer}_${pState.Name}`;
	const tmpBody =
	{
		IDCustomer: parseInt(pState.IDCustomer, 10),
		Name: pState.Name,
		OperationType: 'PassthroughClone',
		Source: pState.LakeSource,
		Target: `lake/${tmpDataset}`,
		OperationConfiguration: { Entity: tmpDataset, GUIDTemplate: pState.GUIDTemplate, Source: pState.LakeSource },
	};
	if (pState.Description)
	{
		tmpBody.Description = pState.Description;
	}
	return tmpBody;
}

/**
 * Validate a PassthroughClone (projectionize) state.
 * @param {object} pState
 * @returns {{ Valid: boolean, Errors: Array<string> }}
 */
function validateCloneState(pState)
{
	const tmpErrors = [];
	const tmpID = parseInt(pState && pState.IDCustomer, 10);
	if (!(tmpID > 0))
	{
		tmpErrors.push('A customer is required.');
	}
	if (!pState || !pState.Name || !NAME_REGEX.test(pState.Name))
	{
		tmpErrors.push('Name must start with a letter and contain only letters, numbers, and underscores.');
	}
	if (!pState || !pState.LakeSource)
	{
		tmpErrors.push('A source lake table is required.');
	}
	else if (pState.LakeSource === `lake/C${tmpID}_${pState.Name}`)
	{
		tmpErrors.push('The new projection name must differ from the source table.');
	}
	if (!pState || !pState.GUIDTemplate || pState.GUIDTemplate.indexOf('{~D:Record.') < 0)
	{
		tmpErrors.push('A row key (GUID template) referencing a source column is required.');
	}
	return { Valid: tmpErrors.length === 0, Errors: tmpErrors };
}

module.exports =
{
	NAME_REGEX,
	OPERATION_TYPES,
	jsonTypeToMeadow,
	dbTypeToJsonType,
	buildSourceAddress,
	buildExtractionBody,
	validateExtractionState,
	buildPassthroughCloneBody,
	validateCloneState,
};

},{}],1097:[function(require,module,exports){
/**
 * Curated source entities for the create-projection wizard.
 *
 * The full Headlight meadow set is ~300 entities, mostly join/audit/system tables that are noise as a
 * projection source. This curated list surfaces the main operational + document entities a user would
 * project from, each pre-stamped with its DefaultIdentifier (for the GUID-template default). Field lists
 * are fetched live per entity from /1.0/<Entity>/Schema — only the entity choices are curated here.
 *
 * `FormData: true` marks the entity whose rows carry dynamic, manifest-driven form fields (Document) — the
 * Tier-2 flow projects FormData.<key> paths sourced from the chosen DocumentType's ArtifactType schema,
 * rather than the meadow columns.
 */

const DATALAKE_SOURCE_ENTITIES =
[
	{ Entity: 'Document', Label: 'Documents (field data)', DefaultIdentifier: 'IDDocument', FormData: true },
	{ Entity: 'Project', Label: 'Projects', DefaultIdentifier: 'IDProject' },
	{ Entity: 'Contract', Label: 'Contracts', DefaultIdentifier: 'IDContract' },
	{ Entity: 'Organization', Label: 'Organizations', DefaultIdentifier: 'IDOrganization' },
	{ Entity: 'User', Label: 'Users', DefaultIdentifier: 'IDUser' },
	{ Entity: 'Observation', Label: 'Observations', DefaultIdentifier: 'IDObservation' },
	{ Entity: 'ObservationManifest', Label: 'Observation Types', DefaultIdentifier: 'IDObservationManifest' },
	{ Entity: 'Sample', Label: 'Samples', DefaultIdentifier: 'IDSample' },
	{ Entity: 'TestInstance', Label: 'Test Instances', DefaultIdentifier: 'IDTestInstance' },
	{ Entity: 'Material', Label: 'Materials', DefaultIdentifier: 'IDMaterial' },
	{ Entity: 'PayItem', Label: 'Pay Items', DefaultIdentifier: 'IDPayItem' },
	{ Entity: 'ReportNamedInstance', Label: 'Document Types', DefaultIdentifier: 'IDReportNamedInstance' },
];

module.exports = { DATALAKE_SOURCE_ENTITIES };

},{}],1098:[function(require,module,exports){
module.exports={
	"Form": "AccountCreateManifest",
	"Scope": "Account-Create",
	"Descriptors":
	{
		"AccountDetails.Name":
		{
			"Name": "Name",
			"Hash": "Account-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Account-Create-Identity",
				"Group": "Account-Create-Identity"
			}
		},
		"AccountDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Account-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.Description":
		{
			"Name": "Description",
			"Hash": "Account-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.IDAccountType":
		{
			"Name": "Account Type",
			"Hash": "Account-Create-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details",
				"Entity": "AccountType",
				"SearchFields":
				[
					"Name",
					"EntityName",
					"Description"
				]
			}
		},
		"AccountDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "Account-Create-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.IDEntity":
		{
			"Name": "IDEntity",
			"Hash": "Account-Create-IDEntity",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Account-Create-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.Pending":
		{
			"Name": "Pending",
			"Hash": "Account-Create-Pending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Account-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Account-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Account-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Account-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1099:[function(require,module,exports){
module.exports={
	"Form": "AccountEditManifest",
	"Scope": "Account-Edit",
	"Descriptors":
	{
		"AccountDetails.Name":
		{
			"Name": "Name",
			"Hash": "Account-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Account-Edit-Identity",
				"Group": "Account-Edit-Identity"
			}
		},
		"AccountDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Account-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.Description":
		{
			"Name": "Description",
			"Hash": "Account-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.IDAccountType":
		{
			"Name": "Account Type",
			"Hash": "Account-Edit-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details",
				"Entity": "AccountType",
				"SearchFields":
				[
					"Name",
					"EntityName",
					"Description"
				]
			}
		},
		"AccountDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "Account-Edit-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.IDEntity":
		{
			"Name": "IDEntity",
			"Hash": "Account-Edit-IDEntity",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Account-Edit-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.Pending":
		{
			"Name": "Pending",
			"Hash": "Account-Edit-Pending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.IDAccount":
		{
			"Name": "IDAccount",
			"Hash": "Account-Edit-IDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.GUIDAccount":
		{
			"Name": "GUIDAccount",
			"Hash": "Account-Edit-GUIDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Account-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Account-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Account-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Account-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Account-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Account-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Account-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Account-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Account-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Account-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1100:[function(require,module,exports){
module.exports={
	"Form": "AccountViewManifest",
	"Scope": "Account-View",
	"Descriptors":
	{
		"AccountDetails.Name":
		{
			"Name": "Name",
			"Hash": "Account-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Account-View-Identity",
				"Group": "Account-View-Identity"
			}
		},
		"AccountDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Account-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.Description":
		{
			"Name": "Description",
			"Hash": "Account-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.IDAccountType":
		{
			"Name": "Account Type",
			"Hash": "Account-View-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details",
				"Entity": "AccountType",
				"SearchFields":
				[
					"Name",
					"EntityName",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"AccountDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "Account-View-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.IDEntity":
		{
			"Name": "IDEntity",
			"Hash": "Account-View-IDEntity",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Account-View-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.Pending":
		{
			"Name": "Pending",
			"Hash": "Account-View-Pending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-View-Details",
				"Group": "Account-View-Details"
			}
		},
		"AccountDetails.IDAccount":
		{
			"Name": "IDAccount",
			"Hash": "Account-View-IDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.GUIDAccount":
		{
			"Name": "GUIDAccount",
			"Hash": "Account-View-GUIDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Account-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Account-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Account-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		},
		"AccountDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Account-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-View-DataAudit",
				"Group": "Account-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Account-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Account-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Account-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Account-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Account-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Account-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1101:[function(require,module,exports){
module.exports={
	"Form": "AccountTypeCreateManifest",
	"Scope": "AccountType-Create",
	"Descriptors":
	{
		"AccountTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AccountType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AccountType-Create-Identity",
				"Group": "AccountType-Create-Identity"
			}
		},
		"AccountTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "AccountType-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Create-Details",
				"Group": "AccountType-Create-Details"
			}
		},
		"AccountTypeDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "AccountType-Create-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Create-Details",
				"Group": "AccountType-Create-Details"
			}
		},
		"AccountTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AccountType-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "AccountType-Create-Details",
				"Group": "AccountType-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AccountType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AccountType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AccountType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AccountType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1102:[function(require,module,exports){
module.exports={
	"Form": "AccountTypeEditManifest",
	"Scope": "AccountType-Edit",
	"Descriptors":
	{
		"AccountTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AccountType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AccountType-Edit-Identity",
				"Group": "AccountType-Edit-Identity"
			}
		},
		"AccountTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "AccountType-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Edit-Details",
				"Group": "AccountType-Edit-Details"
			}
		},
		"AccountTypeDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "AccountType-Edit-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Edit-Details",
				"Group": "AccountType-Edit-Details"
			}
		},
		"AccountTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AccountType-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "AccountType-Edit-Details",
				"Group": "AccountType-Edit-Details"
			}
		},
		"AccountTypeDetails.IDAccountType":
		{
			"Name": "IDAccount Type",
			"Hash": "AccountType-Edit-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.GUIDAccountType":
		{
			"Name": "GUIDAccount Type",
			"Hash": "AccountType-Edit-GUIDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AccountType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AccountType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AccountType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AccountType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AccountType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AccountType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AccountType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AccountType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AccountType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AccountType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1103:[function(require,module,exports){
module.exports={
	"Form": "AccountTypeViewManifest",
	"Scope": "AccountType-View",
	"Descriptors":
	{
		"AccountTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AccountType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "AccountType-View-Identity",
				"Group": "AccountType-View-Identity"
			}
		},
		"AccountTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "AccountType-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-View-Details",
				"Group": "AccountType-View-Details"
			}
		},
		"AccountTypeDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "AccountType-View-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-View-Details",
				"Group": "AccountType-View-Details"
			}
		},
		"AccountTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AccountType-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "AccountType-View-Details",
				"Group": "AccountType-View-Details"
			}
		},
		"AccountTypeDetails.IDAccountType":
		{
			"Name": "IDAccount Type",
			"Hash": "AccountType-View-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.GUIDAccountType":
		{
			"Name": "GUIDAccount Type",
			"Hash": "AccountType-View-GUIDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AccountType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AccountType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AccountType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AccountType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AccountType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AccountType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AccountType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AccountType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AccountType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AccountType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1104:[function(require,module,exports){
module.exports={
	"Form": "ArtifactTypeEditManifest",
	"Scope": "ArtifactType-Edit",
	"Descriptors":
	{
		"ArtifactTypeDetails.IDArtifactType":
		{
			"Name": "ID",
			"Hash": "ArtifactTypeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ArtifactTypeEditIdentity",
				"Group": "ArtifactTypeEditIdentity"
			}
		},
		"ArtifactTypeDetails.GUIDArtifactType":
		{
			"Name": "GUID",
			"Hash": "ArtifactTypeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ArtifactTypeEditIdentity",
				"Group": "ArtifactTypeEditIdentity"
			}
		},
		"ArtifactTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ArtifactTypeEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ArtifactTypeEditIdentity",
				"Group": "ArtifactTypeEditIdentity"
			}
		},
		"ArtifactTypeDetails.Schemata":
		{
			"Name": "Schema Definition (JSON)",
			"Hash": "ArtifactTypeEdit-Schemata",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "ArtifactTypeEditSchema",
				"Group": "ArtifactTypeEditSchema"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ArtifactTypeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ArtifactTypeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Schema",
			"Hash": "ArtifactTypeEditSchema",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Schema",
					"Hash": "ArtifactTypeEditSchema",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1105:[function(require,module,exports){
module.exports={
	"Scope": "ArtifactType-List",
	"CoreEntity": "ArtifactType",
	"TitleTemplate": "Artifact Types",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ArtifactTypeListName",
			"PictDashboard": {}
		}
	}
}

},{}],1106:[function(require,module,exports){
module.exports={
	"Form": "ArtifactTypeViewManifest",
	"Scope": "ArtifactType-View",
	"Descriptors":
	{
		"ArtifactTypeDetails.IDArtifactType":
		{
			"Name": "ID",
			"Hash": "ArtifactTypeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ArtifactTypeIdentity",
				"Group": "ArtifactTypeIdentity"
			}
		},
		"ArtifactTypeDetails.GUIDArtifactType":
		{
			"Name": "GUID",
			"Hash": "ArtifactTypeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ArtifactTypeIdentity",
				"Group": "ArtifactTypeIdentity"
			}
		},
		"ArtifactTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ArtifactTypeView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ArtifactTypeIdentity",
				"Group": "ArtifactTypeIdentity"
			}
		},
		"ArtifactTypeDetails.Schemata":
		{
			"Name": "Schema Definition (JSON)",
			"Hash": "ArtifactTypeView-Schemata",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "ArtifactTypeSchema",
				"Group": "ArtifactTypeSchema"
			}
		},
		"ArtifactTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ArtifactTypeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		},
		"ArtifactTypeDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ArtifactTypeView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		},
		"ArtifactTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ArtifactTypeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		},
		"ArtifactTypeDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ArtifactTypeView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ArtifactTypeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ArtifactTypeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Schema",
			"Hash": "ArtifactTypeSchema",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Schema",
					"Hash": "ArtifactTypeSchema",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ArtifactTypeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ArtifactTypeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1107:[function(require,module,exports){
module.exports={
	"Form": "AssetClassificationCreateManifest",
	"Scope": "AssetClassification-Create",
	"Descriptors":
	{
		"AssetClassificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetClassification-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetClassification-Create-Identity",
				"Group": "AssetClassification-Create-Identity"
			}
		},
		"AssetClassificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetClassification-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetClassification-Create-Details",
				"Group": "AssetClassification-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetClassification-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetClassification-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetClassification-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetClassification-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1108:[function(require,module,exports){
module.exports={
	"Form": "AssetClassificationEditManifest",
	"Scope": "AssetClassification-Edit",
	"Descriptors":
	{
		"AssetClassificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetClassification-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetClassification-Edit-Identity",
				"Group": "AssetClassification-Edit-Identity"
			}
		},
		"AssetClassificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetClassification-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetClassification-Edit-Details",
				"Group": "AssetClassification-Edit-Details"
			}
		},
		"AssetClassificationDetails.IDAssetClassification":
		{
			"Name": "IDAsset Classification",
			"Hash": "AssetClassification-Edit-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.GUIDAssetClassification":
		{
			"Name": "GUIDAsset Classification",
			"Hash": "AssetClassification-Edit-GUIDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetClassification-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetClassification-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetClassification-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetClassification-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetClassification-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetClassification-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetClassification-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetClassification-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetClassification-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetClassification-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1109:[function(require,module,exports){
module.exports={
	"Form": "AssetClassificationViewManifest",
	"Scope": "AssetClassification-View",
	"Descriptors":
	{
		"AssetClassificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetClassification-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "AssetClassification-View-Identity",
				"Group": "AssetClassification-View-Identity"
			}
		},
		"AssetClassificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetClassification-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "AssetClassification-View-Details",
				"Group": "AssetClassification-View-Details"
			}
		},
		"AssetClassificationDetails.IDAssetClassification":
		{
			"Name": "IDAsset Classification",
			"Hash": "AssetClassification-View-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.GUIDAssetClassification":
		{
			"Name": "GUIDAsset Classification",
			"Hash": "AssetClassification-View-GUIDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetClassification-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetClassification-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetClassification-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetClassification-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetClassification-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetClassification-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetClassification-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetClassification-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetClassification-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetClassification-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1110:[function(require,module,exports){
module.exports={
	"Form": "AssetTypeCreateManifest",
	"Scope": "AssetType-Create",
	"Descriptors":
	{
		"AssetTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetType-Create-Identity",
				"Group": "AssetType-Create-Identity"
			}
		},
		"AssetTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetType-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetType-Create-Details",
				"Group": "AssetType-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1111:[function(require,module,exports){
module.exports={
	"Form": "AssetTypeEditManifest",
	"Scope": "AssetType-Edit",
	"Descriptors":
	{
		"AssetTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetType-Edit-Identity",
				"Group": "AssetType-Edit-Identity"
			}
		},
		"AssetTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetType-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetType-Edit-Details",
				"Group": "AssetType-Edit-Details"
			}
		},
		"AssetTypeDetails.IDAssetType":
		{
			"Name": "IDAsset Type",
			"Hash": "AssetType-Edit-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.GUIDAssetType":
		{
			"Name": "GUIDAsset Type",
			"Hash": "AssetType-Edit-GUIDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		},
		"AssetTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-Edit-DataAudit",
				"Group": "AssetType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1112:[function(require,module,exports){
module.exports={
	"Form": "AssetTypeViewManifest",
	"Scope": "AssetType-View",
	"Descriptors":
	{
		"AssetTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "AssetType-View-Identity",
				"Group": "AssetType-View-Identity"
			}
		},
		"AssetTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetType-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "AssetType-View-Details",
				"Group": "AssetType-View-Details"
			}
		},
		"AssetTypeDetails.IDAssetType":
		{
			"Name": "IDAsset Type",
			"Hash": "AssetType-View-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.GUIDAssetType":
		{
			"Name": "GUIDAsset Type",
			"Hash": "AssetType-View-GUIDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1113:[function(require,module,exports){
module.exports={
	"Form": "BidItemCreateManifest",
	"Scope": "BidItem-Create",
	"Descriptors":
	{
		"BidItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "BidItem-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "BidItem-Create-Identity",
				"Group": "BidItem-Create-Identity"
			}
		},
		"BidItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "BidItem-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.Quantity":
		{
			"Name": "Quantity",
			"Hash": "BidItem-Create-Quantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "BidItem-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "BidItem-Create-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "BidItem-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"BidItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "BidItem-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"BidItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "BidItem-Create-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"BidItemDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "BidItem-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "BidItem-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "BidItem-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "BidItem-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "BidItem-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1114:[function(require,module,exports){
module.exports={
	"Form": "BidItemEditManifest",
	"Scope": "BidItem-Edit",
	"Descriptors":
	{
		"BidItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "BidItem-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "BidItem-Edit-Identity",
				"Group": "BidItem-Edit-Identity"
			}
		},
		"BidItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "BidItem-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.Quantity":
		{
			"Name": "Quantity",
			"Hash": "BidItem-Edit-Quantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "BidItem-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "BidItem-Edit-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "BidItem-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"BidItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "BidItem-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"BidItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "BidItem-Edit-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"BidItemDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "BidItem-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"BidItemDetails.IDBidItem":
		{
			"Name": "IDBid Item",
			"Hash": "BidItem-Edit-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.GUIDBidItem":
		{
			"Name": "GUIDBid Item",
			"Hash": "BidItem-Edit-GUIDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "BidItem-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "BidItem-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "BidItem-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "BidItem-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "BidItem-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "BidItem-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "BidItem-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "BidItem-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "BidItem-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "BidItem-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1115:[function(require,module,exports){
module.exports={
	"Form": "BidItemViewManifest",
	"Scope": "BidItem-View",
	"Descriptors":
	{
		"BidItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "BidItem-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "BidItem-View-Identity",
				"Group": "BidItem-View-Identity"
			}
		},
		"BidItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "BidItem-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.Quantity":
		{
			"Name": "Quantity",
			"Hash": "BidItem-View-Quantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "BidItem-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "BidItem-View-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details"
			}
		},
		"BidItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "BidItem-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "BidItem-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "BidItem-View-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "BidItem-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "BidItem-View-Details",
				"Group": "BidItem-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"BidItemDetails.IDBidItem":
		{
			"Name": "IDBid Item",
			"Hash": "BidItem-View-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.GUIDBidItem":
		{
			"Name": "GUIDBid Item",
			"Hash": "BidItem-View-GUIDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "BidItem-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "BidItem-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "BidItem-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		},
		"BidItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "BidItem-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-View-DataAudit",
				"Group": "BidItem-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "BidItem-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "BidItem-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "BidItem-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "BidItem-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "BidItem-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "BidItem-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1116:[function(require,module,exports){
module.exports={
	"Form": "CertificationTypeCreateManifest",
	"Scope": "CertificationType-Create",
	"Descriptors":
	{
		"CertificationTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "CertificationType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "CertificationType-Create-Identity",
				"Group": "CertificationType-Create-Identity"
			}
		},
		"CertificationTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "CertificationType-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Create-Details",
				"Group": "CertificationType-Create-Details"
			}
		},
		"CertificationTypeDetails.Verb":
		{
			"Name": "Verb",
			"Hash": "CertificationType-Create-Verb",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Create-Details",
				"Group": "CertificationType-Create-Details"
			}
		},
		"CertificationTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "CertificationType-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "CertificationType-Create-Details",
				"Group": "CertificationType-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CertificationType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CertificationType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "CertificationType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "CertificationType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1117:[function(require,module,exports){
module.exports={
	"Form": "CertificationTypeEditManifest",
	"Scope": "CertificationType-Edit",
	"Descriptors":
	{
		"CertificationTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "CertificationType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "CertificationType-Edit-Identity",
				"Group": "CertificationType-Edit-Identity"
			}
		},
		"CertificationTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "CertificationType-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Edit-Details",
				"Group": "CertificationType-Edit-Details"
			}
		},
		"CertificationTypeDetails.Verb":
		{
			"Name": "Verb",
			"Hash": "CertificationType-Edit-Verb",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Edit-Details",
				"Group": "CertificationType-Edit-Details"
			}
		},
		"CertificationTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "CertificationType-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "CertificationType-Edit-Details",
				"Group": "CertificationType-Edit-Details"
			}
		},
		"CertificationTypeDetails.IDCertificationType":
		{
			"Name": "IDCertification Type",
			"Hash": "CertificationType-Edit-IDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.GUIDCertificationType":
		{
			"Name": "GUIDCertification Type",
			"Hash": "CertificationType-Edit-GUIDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "CertificationType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "CertificationType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "CertificationType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "CertificationType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-Edit-DataAudit",
				"Group": "CertificationType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CertificationType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CertificationType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "CertificationType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "CertificationType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "CertificationType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "CertificationType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1118:[function(require,module,exports){
module.exports={
	"Form": "CertificationTypeViewManifest",
	"Scope": "CertificationType-View",
	"Descriptors":
	{
		"CertificationTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "CertificationType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "CertificationType-View-Identity",
				"Group": "CertificationType-View-Identity"
			}
		},
		"CertificationTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "CertificationType-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-View-Details",
				"Group": "CertificationType-View-Details"
			}
		},
		"CertificationTypeDetails.Verb":
		{
			"Name": "Verb",
			"Hash": "CertificationType-View-Verb",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-View-Details",
				"Group": "CertificationType-View-Details"
			}
		},
		"CertificationTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "CertificationType-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "CertificationType-View-Details",
				"Group": "CertificationType-View-Details"
			}
		},
		"CertificationTypeDetails.IDCertificationType":
		{
			"Name": "IDCertification Type",
			"Hash": "CertificationType-View-IDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.GUIDCertificationType":
		{
			"Name": "GUIDCertification Type",
			"Hash": "CertificationType-View-GUIDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "CertificationType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "CertificationType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "CertificationType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "CertificationType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CertificationType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CertificationType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "CertificationType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "CertificationType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "CertificationType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "CertificationType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1119:[function(require,module,exports){
module.exports={
	"Form": "ContactCreateManifest",
	"Scope": "Contact-Create",
	"Descriptors":
	{
		"ContactDetails.Title":
		{
			"Name": "Title",
			"Hash": "Contact-Create-Title",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Contact-Create-Identity",
				"Group": "Contact-Create-Identity"
			}
		},
		"ContactDetails.NameFirst":
		{
			"Name": "Name First",
			"Hash": "Contact-Create-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details"
			}
		},
		"ContactDetails.NameLast":
		{
			"Name": "Name Last",
			"Hash": "Contact-Create-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details"
			}
		},
		"ContactDetails.NameFull":
		{
			"Name": "Name Full",
			"Hash": "Contact-Create-NameFull",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details"
			}
		},
		"ContactDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Contact-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ContactDetails.Email":
		{
			"Name": "Email",
			"Hash": "Contact-Create-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "Contact-Create-Contact",
				"Group": "Contact-Create-Contact"
			}
		},
		"ContactDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Contact-Create-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Contact-Create-Contact",
				"Group": "Contact-Create-Contact"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Contact-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Contact-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Contact-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Contact-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Contact-Create-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Contact-Create-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1120:[function(require,module,exports){
module.exports={
	"Form": "ContactEditManifest",
	"Scope": "Contact-Edit",
	"Descriptors":
	{
		"ContactDetails.Title":
		{
			"Name": "Title",
			"Hash": "Contact-Edit-Title",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Contact-Edit-Identity",
				"Group": "Contact-Edit-Identity"
			}
		},
		"ContactDetails.NameFirst":
		{
			"Name": "Name First",
			"Hash": "Contact-Edit-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details"
			}
		},
		"ContactDetails.NameLast":
		{
			"Name": "Name Last",
			"Hash": "Contact-Edit-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details"
			}
		},
		"ContactDetails.NameFull":
		{
			"Name": "Name Full",
			"Hash": "Contact-Edit-NameFull",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details"
			}
		},
		"ContactDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Contact-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Contact-Edit-Details",
				"Group": "Contact-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ContactDetails.Email":
		{
			"Name": "Email",
			"Hash": "Contact-Edit-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "Contact-Edit-Contact",
				"Group": "Contact-Edit-Contact"
			}
		},
		"ContactDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Contact-Edit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Contact-Edit-Contact",
				"Group": "Contact-Edit-Contact"
			}
		},
		"ContactDetails.IDContact":
		{
			"Name": "IDContact",
			"Hash": "Contact-Edit-IDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.GUIDContact":
		{
			"Name": "GUIDContact",
			"Hash": "Contact-Edit-GUIDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Contact-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Contact-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Contact-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		},
		"ContactDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Contact-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-Edit-DataAudit",
				"Group": "Contact-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Contact-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Contact-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Contact-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Contact-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Contact-Edit-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Contact-Edit-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Contact-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Contact-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1121:[function(require,module,exports){
module.exports={
	"Form": "ContactViewManifest",
	"Scope": "Contact-View",
	"Descriptors":
	{
		"ContactDetails.Title":
		{
			"Name": "Title",
			"Hash": "Contact-View-Title",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Contact-View-Identity",
				"Group": "Contact-View-Identity"
			}
		},
		"ContactDetails.NameFirst":
		{
			"Name": "Name First",
			"Hash": "Contact-View-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details"
			}
		},
		"ContactDetails.NameLast":
		{
			"Name": "Name Last",
			"Hash": "Contact-View-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details"
			}
		},
		"ContactDetails.NameFull":
		{
			"Name": "Name Full",
			"Hash": "Contact-View-NameFull",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details"
			}
		},
		"ContactDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Contact-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"ContactDetails.Email":
		{
			"Name": "Email",
			"Hash": "Contact-View-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "Contact-View-Contact",
				"Group": "Contact-View-Contact"
			}
		},
		"ContactDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Contact-View-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Contact-View-Contact",
				"Group": "Contact-View-Contact"
			}
		},
		"ContactDetails.IDContact":
		{
			"Name": "IDContact",
			"Hash": "Contact-View-IDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.GUIDContact":
		{
			"Name": "GUIDContact",
			"Hash": "Contact-View-GUIDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Contact-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Contact-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Contact-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Contact-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Contact-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Contact-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Contact-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Contact-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Contact-View-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Contact-View-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Contact-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Contact-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1122:[function(require,module,exports){
module.exports={
	"Scope": "Contract-List",
	"CoreEntity": "Contract",
	"TitleTemplate": "Contracts",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ContractListName",
			"PictDashboard": {}
		},
		"PrimaryProjectNumber":
		{
			"Name": "Primary Project #",
			"Hash": "ContractListPrimary",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Status",
			"Hash": "ContractListStatus",
			"PictDashboard":
			{
				"ValueTemplate": "<span class=\"tag has-text-weight-bold {~TIfAbs:PSRS-StatusTag-Success:Record:Record.Payload.Status^==^Construction~}{~TIfAbs:PSRS-StatusTag-Info:Record:Record.Payload.Status^==^Pending~}{~TIfAbs:PSRS-StatusTag-Danger:Record:Record.Payload.Status^==^Closed~}\">{~D:Record.Payload.Status~}</span>"
			}
		}
	}
}

},{}],1123:[function(require,module,exports){
module.exports={
	"Form": "ContractTypeEditManifest",
	"Scope": "ContractType-Edit",
	"Descriptors":
	{
		"ContractTypeDetails.IDContractType":
		{
			"Name": "ID",
			"Hash": "ContractTypeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.GUIDContractType":
		{
			"Name": "GUID",
			"Hash": "ContractTypeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ContractTypeEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ContractTypeEdit-Hash",
			"DataType": "String",
			"Description": "Stable short code used for imports and external references. Keep case-sensitive and avoid spaces.",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ContractTypeEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 8,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ContractTypeEdit-AvailableStatusList",
			"DataType": "String",
			"Description": "Lifecycle statuses a contract of this type can occupy, in display order. Type a status name and press Enter to add it.",
			"PictForm":
			{
				"InputType": "Select2Multiple",
				"AllowCustomValues": true,
				"Row": "2",
				"Width": 6,
				"Section": "ContractTypeEditSettings",
				"Group": "ContractTypeEditSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.AllowedProjectTypeIDs":
		{
			"Name": "Allowed Project Types",
			"Hash": "ContractTypeEdit-AllowedProjectTypeIDs",
			"DataType": "String",
			"Description": "Project types allowed under a contract of this type. Leave blank to allow any project type. Manage the available project types from the Project Types card on the dashboard.",
			"PictForm":
			{
				"InputType": "Picker",
				"Multiple": true,
				"Entity": "ProjectType",
				"ValueField": "IDProjectType",
				"TextField": "Name",
				"Row": "3",
				"Width": 6,
				"Section": "ContractTypeEditSettings",
				"Group": "ContractTypeEditSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.DefaultDates":
		{
			"Name": "Default Contract Dates",
			"Hash": "ContractTypeEdit-DefaultDates",
			"DataType": "Array"
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ContractTypeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ContractTypeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ContractTypeEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ContractTypeEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Default Contract Dates",
			"Hash": "ContractTypeEditDefaultDates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Default Contract Dates",
					"Hash": "ContractTypeEditDefaultDatesGrid",
					"Layout": "Tabular",
					"RecordSetSolvers": [],
					"RecordSetAddress": "ContractTypeDetails._DisplaySettings.DefaultDates",
					"RecordManifest": "ContractTypeDefaultDateRow",
					"ShowTitle": false
				}
			]
		}
	],
	"ReferenceManifests":
	{
		"ContractTypeDefaultDateRow":
		{
			"Scope": "ContractTypeDefaultDateRow",
			"Descriptors":
			{
				"Hash":
				{
					"Name": "Hash",
					"Hash": "ContractTypeDefaultDateRowHash",
					"DataType": "String",
					"Description": "Stable short code for the date milestone (e.g. NTP, SUBCMP).",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ContractTypeEditDefaultDates",
						"Group": "ContractTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				},
				"Name":
				{
					"Name": "Display Name",
					"Hash": "ContractTypeDefaultDateRowName",
					"DataType": "String",
					"Description": "Human-readable label shown to users (e.g. 'Notice to Proceed').",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ContractTypeEditDefaultDates",
						"Group": "ContractTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				}
			}
		}
	}
}

},{}],1124:[function(require,module,exports){
module.exports={
	"Scope": "ContractType-List",
	"CoreEntity": "ContractType",
	"TitleTemplate": "Contract Types",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ContractTypeListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "ContractTypeListHash",
			"PictDashboard": {}
		},
		"Description":
		{
			"Name": "Description",
			"Hash": "ContractTypeListDescription",
			"PictDashboard": {}
		}
	}
}

},{}],1125:[function(require,module,exports){
module.exports={
	"Form": "ContractTypeViewManifest",
	"Scope": "ContractType-View",
	"Descriptors":
	{
		"ContractTypeDetails.IDContractType":
		{
			"Name": "ID",
			"Hash": "ContractTypeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.GUIDContractType":
		{
			"Name": "GUID",
			"Hash": "ContractTypeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ContractTypeView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ContractTypeView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ContractTypeView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 8,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ContractTypeView-AvailableStatusList",
			"DataType": "String",
			"Description": "Lifecycle statuses a contract of this type can occupy.",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ContractTypeSettings",
				"Group": "ContractTypeSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.AllowedProjectTypeNamesText":
		{
			"Name": "Allowed Project Types",
			"Hash": "ContractTypeView-AllowedProjectTypeNames",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "ContractTypeSettings",
				"Group": "ContractTypeSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.DefaultDatesText":
		{
			"Name": "Default Contract Dates",
			"Hash": "ContractTypeView-DefaultDates",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "ContractTypeSettings",
				"Group": "ContractTypeSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.PrototypeContractName":
		{
			"Name": "Prototype Contract",
			"Hash": "ContractTypeView-PrototypeContractName",
			"DataType": "String",
			"Description": "The canonical prototype contract an admin configures for this contract type; cloned onto real contracts of this type.",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ContractTypePrototype",
				"Group": "ContractTypePrototype"
			}
		},
		"ContractTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ContractTypeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		},
		"ContractTypeDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ContractTypeView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		},
		"ContractTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ContractTypeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		},
		"ContractTypeDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ContractTypeView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ContractTypeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ContractTypeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ContractTypeSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ContractTypeSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Prototype Contract",
			"Hash": "ContractTypePrototype",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Prototype Contract",
					"Hash": "ContractTypePrototype",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ContractTypeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ContractTypeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1126:[function(require,module,exports){
module.exports={
	"Form": "CoreCreateManifest",
	"Scope": "Core-Create",
	"Descriptors":
	{
		"CoreDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Core-Create-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Core-Create-Identity",
				"Group": "Core-Create-Identity"
			}
		},
		"CoreDetails.IDLot":
		{
			"Name": "Lot",
			"Hash": "Core-Create-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details",
				"Entity": "Lot",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"CoreDetails.IDSublot":
		{
			"Name": "IDSublot",
			"Hash": "Core-Create-IDSublot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		},
		"CoreDetails.IDSample":
		{
			"Name": "Sample",
			"Hash": "Core-Create-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"CoreDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Core-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"CoreDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Core-Create-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		},
		"CoreDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Core-Create-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		},
		"CoreDetails.SublotName":
		{
			"Name": "Sublot Name",
			"Hash": "Core-Create-SublotName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Core-Create-Details",
				"Group": "Core-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Core-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Core-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Core-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Core-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1127:[function(require,module,exports){
module.exports={
	"Form": "CoreEditManifest",
	"Scope": "Core-Edit",
	"Descriptors":
	{
		"CoreDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Core-Edit-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Core-Edit-Identity",
				"Group": "Core-Edit-Identity"
			}
		},
		"CoreDetails.IDLot":
		{
			"Name": "Lot",
			"Hash": "Core-Edit-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details",
				"Entity": "Lot",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"CoreDetails.IDSublot":
		{
			"Name": "IDSublot",
			"Hash": "Core-Edit-IDSublot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.IDSample":
		{
			"Name": "Sample",
			"Hash": "Core-Edit-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"CoreDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Core-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"CoreDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Core-Edit-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Core-Edit-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.SublotName":
		{
			"Name": "Sublot Name",
			"Hash": "Core-Edit-SublotName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.IDCore":
		{
			"Name": "IDCore",
			"Hash": "Core-Edit-IDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.GUIDCore":
		{
			"Name": "GUIDCore",
			"Hash": "Core-Edit-GUIDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Core-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Core-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Core-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Core-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Core-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Core-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Core-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Core-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Core-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Core-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1128:[function(require,module,exports){
module.exports={
	"Form": "CoreViewManifest",
	"Scope": "Core-View",
	"Descriptors":
	{
		"CoreDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Core-View-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Core-View-Identity",
				"Group": "Core-View-Identity"
			}
		},
		"CoreDetails.IDLot":
		{
			"Name": "Lot",
			"Hash": "Core-View-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details",
				"Entity": "Lot",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"CoreDetails.IDSublot":
		{
			"Name": "IDSublot",
			"Hash": "Core-View-IDSublot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.IDSample":
		{
			"Name": "Sample",
			"Hash": "Core-View-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				],
				"ReadOnly": true
			}
		},
		"CoreDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Core-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"CoreDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Core-View-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Core-View-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.SublotName":
		{
			"Name": "Sublot Name",
			"Hash": "Core-View-SublotName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.IDCore":
		{
			"Name": "IDCore",
			"Hash": "Core-View-IDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.GUIDCore":
		{
			"Name": "GUIDCore",
			"Hash": "Core-View-GUIDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Core-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Core-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Core-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Core-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Core-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Core-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Core-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Core-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Core-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Core-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1129:[function(require,module,exports){
module.exports={
	"Form": "CustomerEditManifest",
	"Scope": "Customer-Edit",
	"Descriptors":
	{
		"CustomerDetails.GUIDCustomer":
		{
			"Name": "GUID",
			"Hash": "Customer-Edit-GUIDCustomer",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "CustomerEditIdentity",
				"Group": "CustomerEditIdentity"
			}
		},
		"CustomerDetails.Name":
		{
			"Name": "Customer Name",
			"Hash": "Customer-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "CustomerEditIdentity",
				"Group": "CustomerEditIdentity"
			}
		},
		"CustomerDetails.Code":
		{
			"Name": "Customer Code",
			"Hash": "Customer-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerEditSettings",
				"Group": "CustomerEditSettings"
			}
		},
		"CustomerDetails.Timezone":
		{
			"Name": "Timezone",
			"Hash": "Customer-Edit-Timezone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerEditSettings",
				"Group": "CustomerEditSettings"
			}
		},
		"CustomerDetails.Enabled":
		{
			"Name": "Enabled",
			"Hash": "Customer-Edit-Enabled",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "CustomerEditSettings",
				"Group": "CustomerEditSettings"
			}
		},
		"CustomerDetails.CustomProperties":
		{
			"Name": "Custom Properties (JSON)",
			"Hash": "Customer-Edit-CustomProperties",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "CustomerEditCustomProperties",
				"Group": "CustomerEditCustomProperties"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CustomerEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CustomerEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "CustomerEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "CustomerEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "CustomerEditCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "CustomerEditCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1130:[function(require,module,exports){
module.exports={
	"Scope": "Customer-List",
	"CoreEntity": "Customer",
	"TitleTemplate": "Customers",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Customer Name",
			"Hash": "CustomerListName",
			"PictDashboard": {}
		},
		"Timezone":
		{
			"Name": "Timezone",
			"Hash": "CustomerListTimezone",
			"PictDashboard": {}
		}
	}
}

},{}],1131:[function(require,module,exports){
module.exports={
	"Form": "CustomerViewManifest",
	"Scope": "Customer-View",
	"Descriptors":
	{
		"CustomerDetails.GUIDCustomer":
		{
			"Name": "GUID",
			"Hash": "Customer-GUIDCustomer",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "CustomerIdentity",
				"Group": "CustomerIdentity"
			}
		},
		"CustomerDetails.Name":
		{
			"Name": "Customer Name",
			"Hash": "Customer-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "CustomerIdentity",
				"Group": "CustomerIdentity"
			}
		},
		"CustomerDetails.Code":
		{
			"Name": "Customer Code",
			"Hash": "Customer-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerSettings",
				"Group": "CustomerSettings"
			}
		},
		"CustomerDetails.Timezone":
		{
			"Name": "Timezone",
			"Hash": "Customer-Timezone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerSettings",
				"Group": "CustomerSettings"
			}
		},
		"CustomerDetails.Enabled":
		{
			"Name": "Enabled",
			"Hash": "Customer-Enabled",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "CustomerSettings",
				"Group": "CustomerSettings"
			}
		},
		"CustomerDetails.CustomProperties":
		{
			"Name": "Custom Properties (JSON)",
			"Hash": "Customer-CustomProperties",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "CustomerCustomProperties",
				"Group": "CustomerCustomProperties"
			}
		},
		"CustomerDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "Customer-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		},
		"CustomerDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "Customer-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		},
		"CustomerDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "Customer-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		},
		"CustomerDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "Customer-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CustomerIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CustomerIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "CustomerSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "CustomerSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "CustomerCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "CustomerCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "CustomerAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "CustomerAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1132:[function(require,module,exports){
module.exports={
	"Form": "DocumentApprovalStateEditManifest",
	"Scope": "DocumentApprovalState-Edit",
	"Descriptors":
	{
		"DocumentApprovalStateDetails.IDDocumentApprovalState":
		{
			"Name": "ID",
			"Hash": "DocStateEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		},
		"DocumentApprovalStateDetails.GUIDDocumentApprovalState":
		{
			"Name": "GUID",
			"Hash": "DocStateEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		},
		"DocumentApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "DocStateEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		},
		"DocumentApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "DocStateEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateEditIdentity",
				"Group": "DocStateEditIdentity"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStateEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStateEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1133:[function(require,module,exports){
module.exports={
	"Scope": "DocumentApprovalState-List",
	"CoreEntity": "DocumentApprovalState",
	"TitleTemplate": "Document Approval States",
	"Descriptors":
	{
		"Name":
		{
			"Name": "State Name",
			"Hash": "DocStateListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "DocStateListHash",
			"PictDashboard": {}
		}
	}
}

},{}],1134:[function(require,module,exports){
module.exports={
	"Form": "DocumentApprovalStateViewManifest",
	"Scope": "DocumentApprovalState-View",
	"Descriptors":
	{
		"DocumentApprovalStateDetails.IDDocumentApprovalState":
		{
			"Name": "ID",
			"Hash": "DocStateView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.GUIDDocumentApprovalState":
		{
			"Name": "GUID",
			"Hash": "DocStateView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "DocStateView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "DocStateView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "DocStateView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		},
		"DocumentApprovalStateDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "DocStateView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		},
		"DocumentApprovalStateDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "DocStateView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		},
		"DocumentApprovalStateDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "DocStateView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStateIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStateIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "DocStateAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "DocStateAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1135:[function(require,module,exports){
module.exports={
	"Form": "DocumentApprovalStepEditManifest",
	"Scope": "DocumentApprovalStep-Edit",
	"Descriptors":
	{
		"DocumentApprovalStepDetails.IDDocumentApprovalStep":
		{
			"Name": "ID",
			"Hash": "DocStepEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStepEditIdentity",
				"Group": "DocStepEditIdentity"
			}
		},
		"DocumentApprovalStepDetails.GUIDDocumentApprovalStep":
		{
			"Name": "GUID",
			"Hash": "DocStepEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStepEditIdentity",
				"Group": "DocStepEditIdentity"
			}
		},
		"DocumentApprovalStepDetails.IDDocumentApprovalState":
		{
			"Name": "State ID",
			"Hash": "DocStepEdit-IDState",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "DocStepEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "DocStepEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "DocStepEdit-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "DocStepEdit-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStepEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStepEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "DocStepEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "DocStepEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1136:[function(require,module,exports){
module.exports={
	"Scope": "DocumentApprovalStep-List",
	"CoreEntity": "DocumentApprovalStep",
	"TitleTemplate": "Document Approval Steps",
	"Descriptors":
	{
		"IDDocumentApprovalState":
		{
			"Name": "State ID",
			"Hash": "DocStepListIDState",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "DocStepListOrdinal",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "DocStepListIDRole",
			"PictDashboard": {}
		},
		"IncludeHigherRoles":
		{
			"Name": "Higher Roles",
			"Hash": "DocStepListHigherRoles",
			"PictDashboard": {}
		},
		"PerformLock":
		{
			"Name": "Lock",
			"Hash": "DocStepListLock",
			"PictDashboard": {}
		}
	}
}

},{}],1137:[function(require,module,exports){
module.exports={
	"Form": "DocumentApprovalStepViewManifest",
	"Scope": "DocumentApprovalStep-View",
	"Descriptors":
	{
		"DocumentApprovalStepDetails.IDDocumentApprovalStep":
		{
			"Name": "ID",
			"Hash": "DocStepView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStepIdentity",
				"Group": "DocStepIdentity"
			}
		},
		"DocumentApprovalStepDetails.GUIDDocumentApprovalStep":
		{
			"Name": "GUID",
			"Hash": "DocStepView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStepIdentity",
				"Group": "DocStepIdentity"
			}
		},
		"DocumentApprovalStepDetails.IDDocumentApprovalState":
		{
			"Name": "State ID",
			"Hash": "DocStepView-IDState",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "DocStepView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "DocStepView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "DocStepView-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "DocStepView-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "DocStepView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		},
		"DocumentApprovalStepDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "DocStepView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		},
		"DocumentApprovalStepDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "DocStepView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		},
		"DocumentApprovalStepDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "DocStepView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStepIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStepIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "DocStepConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "DocStepConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "DocStepAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "DocStepAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1138:[function(require,module,exports){
module.exports={
	"Form": "DocumentApprovalWorkflowEditManifest",
	"Scope": "DocumentApprovalWorkflow-Edit",
	"Descriptors":
	{
		"DocumentApprovalWorkflowDetails.IDDocumentApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "DocWfEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocWfEditIdentity",
				"Group": "DocWfEditIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "DocWfEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "DocWfEditIdentity",
				"Group": "DocWfEditIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.FromStatus":
		{
			"Name": "From Status",
			"Hash": "DocWfEdit-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfEditConfig",
				"Group": "DocWfEditConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.ToStatus":
		{
			"Name": "To Status",
			"Hash": "DocWfEdit-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfEditConfig",
				"Group": "DocWfEditConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "DocWfEdit-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfEditConfig",
				"Group": "DocWfEditConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "DocWfEdit-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "DocWfEditEdgeOptions",
				"Group": "DocWfEditEdgeOptions"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocWfEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocWfEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "DocWfEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "DocWfEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "DocWfEditEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "DocWfEditEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1139:[function(require,module,exports){
module.exports={
	"Scope": "DocumentApprovalWorkflow-List",
	"CoreEntity": "DocumentApprovalWorkflow",
	"TitleTemplate": "Document Approval Workflows",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Transition Name",
			"Hash": "DocWfListName",
			"PictDashboard": {}
		},
		"FromStatus":
		{
			"Name": "From Status",
			"Hash": "DocWfListFromStatus",
			"PictDashboard": {}
		},
		"ToStatus":
		{
			"Name": "To Status",
			"Hash": "DocWfListToStatus",
			"PictDashboard": {}
		},
		"IDProject":
		{
			"Name": "Project ID",
			"Hash": "DocWfListIDProject",
			"PictDashboard": {}
		}
	}
}

},{}],1140:[function(require,module,exports){
module.exports={
	"Form": "DocumentApprovalWorkflowViewManifest",
	"Scope": "DocumentApprovalWorkflow-View",
	"Descriptors":
	{
		"DocumentApprovalWorkflowDetails.IDDocumentApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "DocWfView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocWfIdentity",
				"Group": "DocWfIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "DocWfView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 10,
				"Section": "DocWfIdentity",
				"Group": "DocWfIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.FromStatus":
		{
			"Name": "From Status",
			"Hash": "DocWfView-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfConfig",
				"Group": "DocWfConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.ToStatus":
		{
			"Name": "To Status",
			"Hash": "DocWfView-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfConfig",
				"Group": "DocWfConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "DocWfView-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfConfig",
				"Group": "DocWfConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "DocWfView-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "DocWfEdgeOptions",
				"Group": "DocWfEdgeOptions"
			}
		},
		"DocumentApprovalWorkflowDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "DocWfView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		},
		"DocumentApprovalWorkflowDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "DocWfView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		},
		"DocumentApprovalWorkflowDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "DocWfView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		},
		"DocumentApprovalWorkflowDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "DocWfView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocWfIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocWfIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "DocWfConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "DocWfConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "DocWfEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "DocWfEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "DocWfAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "DocWfAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1141:[function(require,module,exports){
module.exports={
	"Form": "EquipmentCreateManifest",
	"Scope": "Equipment-Create",
	"Descriptors":
	{
		"EquipmentDetails.Name":
		{
			"Name": "Name",
			"Hash": "Equipment-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Equipment-Create-Identity",
				"Group": "Equipment-Create-Identity"
			}
		},
		"EquipmentDetails.Code":
		{
			"Name": "Code",
			"Hash": "Equipment-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Equipment-Create-Identity",
				"Group": "Equipment-Create-Identity"
			}
		},
		"EquipmentDetails.Description":
		{
			"Name": "Description",
			"Hash": "Equipment-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Equipment-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "Equipment-Create-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.Status":
		{
			"Name": "Status",
			"Hash": "Equipment-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.ExternalEquipmentID":
		{
			"Name": "External Equipment ID",
			"Hash": "Equipment-Create-ExternalEquipmentID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Equipment-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Equipment-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Equipment-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Equipment-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1142:[function(require,module,exports){
module.exports={
	"Form": "EquipmentEditManifest",
	"Scope": "Equipment-Edit",
	"Descriptors":
	{
		"EquipmentDetails.Name":
		{
			"Name": "Name",
			"Hash": "Equipment-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Equipment-Edit-Identity",
				"Group": "Equipment-Edit-Identity"
			}
		},
		"EquipmentDetails.Code":
		{
			"Name": "Code",
			"Hash": "Equipment-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Equipment-Edit-Identity",
				"Group": "Equipment-Edit-Identity"
			}
		},
		"EquipmentDetails.Description":
		{
			"Name": "Description",
			"Hash": "Equipment-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Equipment-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "Equipment-Edit-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.Status":
		{
			"Name": "Status",
			"Hash": "Equipment-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.ExternalEquipmentID":
		{
			"Name": "External Equipment ID",
			"Hash": "Equipment-Edit-ExternalEquipmentID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Edit-Details",
				"Group": "Equipment-Edit-Details"
			}
		},
		"EquipmentDetails.IDEquipment":
		{
			"Name": "IDEquipment",
			"Hash": "Equipment-Edit-IDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.GUIDEquipment":
		{
			"Name": "GUIDEquipment",
			"Hash": "Equipment-Edit-GUIDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Equipment-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Equipment-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Equipment-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		},
		"EquipmentDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Equipment-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-Edit-DataAudit",
				"Group": "Equipment-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Equipment-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Equipment-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Equipment-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Equipment-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Equipment-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Equipment-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1143:[function(require,module,exports){
module.exports={
	"Form": "EquipmentViewManifest",
	"Scope": "Equipment-View",
	"Descriptors":
	{
		"EquipmentDetails.Name":
		{
			"Name": "Name",
			"Hash": "Equipment-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Equipment-View-Identity",
				"Group": "Equipment-View-Identity"
			}
		},
		"EquipmentDetails.Code":
		{
			"Name": "Code",
			"Hash": "Equipment-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Equipment-View-Identity",
				"Group": "Equipment-View-Identity"
			}
		},
		"EquipmentDetails.Description":
		{
			"Name": "Description",
			"Hash": "Equipment-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Equipment-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "Equipment-View-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.Status":
		{
			"Name": "Status",
			"Hash": "Equipment-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.ExternalEquipmentID":
		{
			"Name": "External Equipment ID",
			"Hash": "Equipment-View-ExternalEquipmentID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-View-Details",
				"Group": "Equipment-View-Details"
			}
		},
		"EquipmentDetails.IDEquipment":
		{
			"Name": "IDEquipment",
			"Hash": "Equipment-View-IDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.GUIDEquipment":
		{
			"Name": "GUIDEquipment",
			"Hash": "Equipment-View-GUIDEquipment",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Equipment-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Equipment-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Equipment-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		},
		"EquipmentDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Equipment-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Equipment-View-DataAudit",
				"Group": "Equipment-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Equipment-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Equipment-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Equipment-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Equipment-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Equipment-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Equipment-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1144:[function(require,module,exports){
module.exports={
	"Form": "FundCreateManifest",
	"Scope": "Fund-Create",
	"Descriptors":
	{
		"FundDetails.Name":
		{
			"Name": "Name",
			"Hash": "Fund-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Fund-Create-Identity",
				"Group": "Fund-Create-Identity"
			}
		},
		"FundDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Fund-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.Description":
		{
			"Name": "Description",
			"Hash": "Fund-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.OriginalBalance":
		{
			"Name": "Original Balance",
			"Hash": "Fund-Create-OriginalBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.TotalCommitted":
		{
			"Name": "Total Committed",
			"Hash": "Fund-Create-TotalCommitted",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.CommittedBalance":
		{
			"Name": "Committed Balance",
			"Hash": "Fund-Create-CommittedBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Fund-Create-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.TotalPendingCharge":
		{
			"Name": "Total Pending Charge",
			"Hash": "Fund-Create-TotalPendingCharge",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.ExternalAccountID":
		{
			"Name": "External Account ID",
			"Hash": "Fund-Create-ExternalAccountID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.CostCenter":
		{
			"Name": "Cost Center",
			"Hash": "Fund-Create-CostCenter",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		},
		"FundDetails.Active":
		{
			"Name": "Active",
			"Hash": "Fund-Create-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Fund-Create-Details",
				"Group": "Fund-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Fund-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Fund-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Fund-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Fund-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1145:[function(require,module,exports){
module.exports={
	"Form": "FundEditManifest",
	"Scope": "Fund-Edit",
	"Descriptors":
	{
		"FundDetails.Name":
		{
			"Name": "Name",
			"Hash": "Fund-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Fund-Edit-Identity",
				"Group": "Fund-Edit-Identity"
			}
		},
		"FundDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Fund-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.Description":
		{
			"Name": "Description",
			"Hash": "Fund-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.OriginalBalance":
		{
			"Name": "Original Balance",
			"Hash": "Fund-Edit-OriginalBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.TotalCommitted":
		{
			"Name": "Total Committed",
			"Hash": "Fund-Edit-TotalCommitted",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.CommittedBalance":
		{
			"Name": "Committed Balance",
			"Hash": "Fund-Edit-CommittedBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Fund-Edit-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.TotalPendingCharge":
		{
			"Name": "Total Pending Charge",
			"Hash": "Fund-Edit-TotalPendingCharge",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.ExternalAccountID":
		{
			"Name": "External Account ID",
			"Hash": "Fund-Edit-ExternalAccountID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.CostCenter":
		{
			"Name": "Cost Center",
			"Hash": "Fund-Edit-CostCenter",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.Active":
		{
			"Name": "Active",
			"Hash": "Fund-Edit-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.IDFund":
		{
			"Name": "IDFund",
			"Hash": "Fund-Edit-IDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.GUIDFund":
		{
			"Name": "GUIDFund",
			"Hash": "Fund-Edit-GUIDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Fund-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Fund-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Fund-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Fund-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Fund-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Fund-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Fund-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Fund-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Fund-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Fund-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1146:[function(require,module,exports){
module.exports={
	"Form": "FundViewManifest",
	"Scope": "Fund-View",
	"Descriptors":
	{
		"FundDetails.Name":
		{
			"Name": "Name",
			"Hash": "Fund-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Fund-View-Identity",
				"Group": "Fund-View-Identity"
			}
		},
		"FundDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Fund-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.Description":
		{
			"Name": "Description",
			"Hash": "Fund-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.OriginalBalance":
		{
			"Name": "Original Balance",
			"Hash": "Fund-View-OriginalBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.TotalCommitted":
		{
			"Name": "Total Committed",
			"Hash": "Fund-View-TotalCommitted",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.CommittedBalance":
		{
			"Name": "Committed Balance",
			"Hash": "Fund-View-CommittedBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Fund-View-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.TotalPendingCharge":
		{
			"Name": "Total Pending Charge",
			"Hash": "Fund-View-TotalPendingCharge",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.ExternalAccountID":
		{
			"Name": "External Account ID",
			"Hash": "Fund-View-ExternalAccountID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.CostCenter":
		{
			"Name": "Cost Center",
			"Hash": "Fund-View-CostCenter",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.Active":
		{
			"Name": "Active",
			"Hash": "Fund-View-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.IDFund":
		{
			"Name": "IDFund",
			"Hash": "Fund-View-IDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.GUIDFund":
		{
			"Name": "GUIDFund",
			"Hash": "Fund-View-GUIDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Fund-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Fund-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Fund-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Fund-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Fund-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Fund-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Fund-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Fund-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Fund-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Fund-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1147:[function(require,module,exports){
module.exports={
	"Form": "FundingCategoryCreateManifest",
	"Scope": "FundingCategory-Create",
	"Descriptors":
	{
		"FundingCategoryDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingCategory-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingCategory-Create-Identity",
				"Group": "FundingCategory-Create-Identity"
			}
		},
		"FundingCategoryDetails.Code":
		{
			"Name": "Code",
			"Hash": "FundingCategory-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingCategory-Create-Identity",
				"Group": "FundingCategory-Create-Identity"
			}
		},
		"FundingCategoryDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingCategory-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "2",
				"Width": 4,
				"Section": "FundingCategory-Create-Details",
				"Group": "FundingCategory-Create-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		},
		"FundingCategoryDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingCategory-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingCategory-Create-Details",
				"Group": "FundingCategory-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingCategory-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingCategory-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingCategory-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingCategory-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1148:[function(require,module,exports){
module.exports={
	"Form": "FundingCategoryEditManifest",
	"Scope": "FundingCategory-Edit",
	"Descriptors":
	{
		"FundingCategoryDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingCategory-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingCategory-Edit-Identity",
				"Group": "FundingCategory-Edit-Identity"
			}
		},
		"FundingCategoryDetails.Code":
		{
			"Name": "Code",
			"Hash": "FundingCategory-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingCategory-Edit-Identity",
				"Group": "FundingCategory-Edit-Identity"
			}
		},
		"FundingCategoryDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingCategory-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "2",
				"Width": 4,
				"Section": "FundingCategory-Edit-Details",
				"Group": "FundingCategory-Edit-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		},
		"FundingCategoryDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingCategory-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingCategory-Edit-Details",
				"Group": "FundingCategory-Edit-Details"
			}
		},
		"FundingCategoryDetails.IDFundingCategory":
		{
			"Name": "IDFunding Category",
			"Hash": "FundingCategory-Edit-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.GUIDFundingCategory":
		{
			"Name": "GUIDFunding Category",
			"Hash": "FundingCategory-Edit-GUIDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingCategory-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingCategory-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingCategory-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingCategory-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingCategory-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingCategory-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingCategory-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingCategory-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingCategory-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingCategory-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1149:[function(require,module,exports){
module.exports={
	"Form": "FundingCategoryViewManifest",
	"Scope": "FundingCategory-View",
	"Descriptors":
	{
		"FundingCategoryDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingCategory-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "FundingCategory-View-Identity",
				"Group": "FundingCategory-View-Identity"
			}
		},
		"FundingCategoryDetails.Code":
		{
			"Name": "Code",
			"Hash": "FundingCategory-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "FundingCategory-View-Identity",
				"Group": "FundingCategory-View-Identity"
			}
		},
		"FundingCategoryDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingCategory-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "FundingCategory-View-Details",
				"Group": "FundingCategory-View-Details"
			}
		},
		"FundingCategoryDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingCategory-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "FundingCategory-View-Details",
				"Group": "FundingCategory-View-Details"
			}
		},
		"FundingCategoryDetails.IDFundingCategory":
		{
			"Name": "IDFunding Category",
			"Hash": "FundingCategory-View-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.GUIDFundingCategory":
		{
			"Name": "GUIDFunding Category",
			"Hash": "FundingCategory-View-GUIDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingCategory-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingCategory-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingCategory-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingCategory-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-View-DataAudit",
				"Group": "FundingCategory-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingCategory-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingCategory-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingCategory-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingCategory-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingCategory-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingCategory-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1150:[function(require,module,exports){
module.exports={
	"Form": "FundingSourceCreateManifest",
	"Scope": "FundingSource-Create",
	"Descriptors":
	{
		"FundingSourceDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingSource-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingSource-Create-Identity",
				"Group": "FundingSource-Create-Identity"
			}
		},
		"FundingSourceDetails.FundingSourceAccountCode":
		{
			"Name": "Funding Source Account Code",
			"Hash": "FundingSource-Create-FundingSourceAccountCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingSource-Create-Identity",
				"Group": "FundingSource-Create-Identity"
			}
		},
		"FundingSourceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "FundingSource-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details"
			}
		},
		"FundingSourceDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingSource-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details"
			}
		},
		"FundingSourceDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "FundingSource-Create-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details"
			}
		},
		"FundingSourceDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingSource-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Create-Details",
				"Group": "FundingSource-Create-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingSource-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingSource-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingSource-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingSource-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1151:[function(require,module,exports){
module.exports={
	"Form": "FundingSourceEditManifest",
	"Scope": "FundingSource-Edit",
	"Descriptors":
	{
		"FundingSourceDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingSource-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingSource-Edit-Identity",
				"Group": "FundingSource-Edit-Identity"
			}
		},
		"FundingSourceDetails.FundingSourceAccountCode":
		{
			"Name": "Funding Source Account Code",
			"Hash": "FundingSource-Edit-FundingSourceAccountCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingSource-Edit-Identity",
				"Group": "FundingSource-Edit-Identity"
			}
		},
		"FundingSourceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "FundingSource-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details"
			}
		},
		"FundingSourceDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingSource-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details"
			}
		},
		"FundingSourceDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "FundingSource-Edit-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details"
			}
		},
		"FundingSourceDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingSource-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-Edit-Details",
				"Group": "FundingSource-Edit-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		},
		"FundingSourceDetails.IDFundingSource":
		{
			"Name": "IDFunding Source",
			"Hash": "FundingSource-Edit-IDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.GUIDFundingSource":
		{
			"Name": "GUIDFunding Source",
			"Hash": "FundingSource-Edit-GUIDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingSource-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingSource-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingSource-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		},
		"FundingSourceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingSource-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-Edit-DataAudit",
				"Group": "FundingSource-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingSource-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingSource-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingSource-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingSource-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingSource-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingSource-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1152:[function(require,module,exports){
module.exports={
	"Form": "FundingSourceViewManifest",
	"Scope": "FundingSource-View",
	"Descriptors":
	{
		"FundingSourceDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingSource-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "FundingSource-View-Identity",
				"Group": "FundingSource-View-Identity"
			}
		},
		"FundingSourceDetails.FundingSourceAccountCode":
		{
			"Name": "Funding Source Account Code",
			"Hash": "FundingSource-View-FundingSourceAccountCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "FundingSource-View-Identity",
				"Group": "FundingSource-View-Identity"
			}
		},
		"FundingSourceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "FundingSource-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingSource-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "FundingSource-View-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingSource-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.IDFundingSource":
		{
			"Name": "IDFunding Source",
			"Hash": "FundingSource-View-IDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.GUIDFundingSource":
		{
			"Name": "GUIDFunding Source",
			"Hash": "FundingSource-View-GUIDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingSource-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingSource-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingSource-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingSource-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingSource-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingSource-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingSource-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingSource-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingSource-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingSource-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1153:[function(require,module,exports){
module.exports={
	"Form": "LabCreateManifest",
	"Scope": "Lab-Create",
	"Descriptors":
	{
		"LabDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lab-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lab-Create-Identity",
				"Group": "Lab-Create-Identity"
			}
		},
		"LabDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Lab-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"LabDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "Lab-Create-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"LabDetails.ExternalOrganization":
		{
			"Name": "External Organization",
			"Hash": "Lab-Create-ExternalOrganization",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 3,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Lab-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.IDLabParent":
		{
			"Name": "Parent Lab",
			"Hash": "Lab-Create-IDLabParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"LabDetails.ExternalLabID":
		{
			"Name": "External Lab ID",
			"Hash": "Lab-Create-ExternalLabID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.BypassReceived":
		{
			"Name": "Bypass Received",
			"Hash": "Lab-Create-BypassReceived",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.AggregateTo":
		{
			"Name": "Aggregate To",
			"Hash": "Lab-Create-AggregateTo",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lab-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lab-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lab-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lab-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1154:[function(require,module,exports){
module.exports={
	"Form": "LabEditManifest",
	"Scope": "Lab-Edit",
	"Descriptors":
	{
		"LabDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lab-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lab-Edit-Identity",
				"Group": "Lab-Edit-Identity"
			}
		},
		"LabDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Lab-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"LabDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "Lab-Edit-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"LabDetails.ExternalOrganization":
		{
			"Name": "External Organization",
			"Hash": "Lab-Edit-ExternalOrganization",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 3,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Lab-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.IDLabParent":
		{
			"Name": "Parent Lab",
			"Hash": "Lab-Edit-IDLabParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"LabDetails.ExternalLabID":
		{
			"Name": "External Lab ID",
			"Hash": "Lab-Edit-ExternalLabID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.BypassReceived":
		{
			"Name": "Bypass Received",
			"Hash": "Lab-Edit-BypassReceived",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.AggregateTo":
		{
			"Name": "Aggregate To",
			"Hash": "Lab-Edit-AggregateTo",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.IDLab":
		{
			"Name": "IDLab",
			"Hash": "Lab-Edit-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.GUIDLab":
		{
			"Name": "GUIDLab",
			"Hash": "Lab-Edit-GUIDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lab-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lab-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lab-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lab-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lab-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lab-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lab-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lab-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lab-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lab-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1155:[function(require,module,exports){
module.exports={
	"Form": "LabViewManifest",
	"Scope": "Lab-View",
	"Descriptors":
	{
		"LabDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lab-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Lab-View-Identity",
				"Group": "Lab-View-Identity"
			}
		},
		"LabDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Lab-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"LabDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "Lab-View-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				],
				"ReadOnly": true
			}
		},
		"LabDetails.ExternalOrganization":
		{
			"Name": "External Organization",
			"Hash": "Lab-View-ExternalOrganization",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 3,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Lab-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.IDLabParent":
		{
			"Name": "Parent Lab",
			"Hash": "Lab-View-IDLabParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"LabDetails.ExternalLabID":
		{
			"Name": "External Lab ID",
			"Hash": "Lab-View-ExternalLabID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.BypassReceived":
		{
			"Name": "Bypass Received",
			"Hash": "Lab-View-BypassReceived",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.AggregateTo":
		{
			"Name": "Aggregate To",
			"Hash": "Lab-View-AggregateTo",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Lab-View-Details",
				"Group": "Lab-View-Details"
			}
		},
		"LabDetails.IDLab":
		{
			"Name": "IDLab",
			"Hash": "Lab-View-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.GUIDLab":
		{
			"Name": "GUIDLab",
			"Hash": "Lab-View-GUIDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lab-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lab-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lab-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		},
		"LabDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lab-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-View-DataAudit",
				"Group": "Lab-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lab-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lab-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lab-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lab-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lab-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lab-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1156:[function(require,module,exports){
module.exports={
	"Form": "LineItemCreateManifest",
	"Scope": "LineItem-Create",
	"Descriptors":
	{
		"LineItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "LineItem-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "LineItem-Create-Identity",
				"Group": "LineItem-Create-Identity"
			}
		},
		"LineItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "LineItem-Create-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "LineItem-Create-Identity",
				"Group": "LineItem-Create-Identity"
			}
		},
		"LineItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "LineItem-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "LineItem-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "LineItem-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "LineItem-Create-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ItemNumber":
		{
			"Name": "Item Number",
			"Hash": "LineItem-Create-ItemNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "LineItem-Create-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ExpectedQuantity":
		{
			"Name": "Expected Quantity",
			"Hash": "LineItem-Create-ExpectedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ContractorReportedQuantity":
		{
			"Name": "Contractor Reported Quantity",
			"Hash": "LineItem-Create-ContractorReportedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ActualQuantity":
		{
			"Name": "Actual Quantity",
			"Hash": "LineItem-Create-ActualQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ContractQuantity":
		{
			"Name": "Contract Quantity",
			"Hash": "LineItem-Create-ContractQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.InstalledQuantity":
		{
			"Name": "Installed Quantity",
			"Hash": "LineItem-Create-InstalledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantity":
		{
			"Name": "Change Order Quantity",
			"Hash": "LineItem-Create-ChangeOrderQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantityPending":
		{
			"Name": "Change Order Quantity Pending",
			"Hash": "LineItem-Create-ChangeOrderQuantityPending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Tax":
		{
			"Name": "Tax",
			"Hash": "LineItem-Create-Tax",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ChangeOrderNumber":
		{
			"Name": "Change Order Number",
			"Hash": "LineItem-Create-ChangeOrderNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.FundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Create-FundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.IDFundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Create-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "FundingCategory",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		},
		"LineItemDetails.Status":
		{
			"Name": "Status",
			"Hash": "LineItem-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ProposalIdentifier":
		{
			"Name": "Proposal Identifier",
			"Hash": "LineItem-Create-ProposalIdentifier",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.PercentComplete":
		{
			"Name": "Percent Complete",
			"Hash": "LineItem-Create-PercentComplete",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.CategoryNumber":
		{
			"Name": "Category Number",
			"Hash": "LineItem-Create-CategoryNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.Retainage":
		{
			"Name": "Retainage",
			"Hash": "LineItem-Create-Retainage",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ImprovementType":
		{
			"Name": "Improvement Type",
			"Hash": "LineItem-Create-ImprovementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.DeliveryDate":
		{
			"Name": "Delivery Date",
			"Hash": "LineItem-Create-DeliveryDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		},
		"LineItemDetails.ParentIDLineItem":
		{
			"Name": "Parent Line Item",
			"Hash": "LineItem-Create-ParentIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"LineItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "LineItem-Create-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"LineItemDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "LineItem-Create-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"LineItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "LineItem-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LineItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "LineItem-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"LineItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "LineItem-Create-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "13",
				"Width": 3,
				"Section": "LineItem-Create-Details",
				"Group": "LineItem-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "LineItem-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "LineItem-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "LineItem-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "LineItem-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1157:[function(require,module,exports){
module.exports={
	"Form": "LineItemEditManifest",
	"Scope": "LineItem-Edit",
	"Descriptors":
	{
		"LineItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "LineItem-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "LineItem-Edit-Identity",
				"Group": "LineItem-Edit-Identity"
			}
		},
		"LineItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "LineItem-Edit-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "LineItem-Edit-Identity",
				"Group": "LineItem-Edit-Identity"
			}
		},
		"LineItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "LineItem-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "LineItem-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "LineItem-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "LineItem-Edit-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ItemNumber":
		{
			"Name": "Item Number",
			"Hash": "LineItem-Edit-ItemNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "LineItem-Edit-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ExpectedQuantity":
		{
			"Name": "Expected Quantity",
			"Hash": "LineItem-Edit-ExpectedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ContractorReportedQuantity":
		{
			"Name": "Contractor Reported Quantity",
			"Hash": "LineItem-Edit-ContractorReportedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ActualQuantity":
		{
			"Name": "Actual Quantity",
			"Hash": "LineItem-Edit-ActualQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ContractQuantity":
		{
			"Name": "Contract Quantity",
			"Hash": "LineItem-Edit-ContractQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.InstalledQuantity":
		{
			"Name": "Installed Quantity",
			"Hash": "LineItem-Edit-InstalledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantity":
		{
			"Name": "Change Order Quantity",
			"Hash": "LineItem-Edit-ChangeOrderQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantityPending":
		{
			"Name": "Change Order Quantity Pending",
			"Hash": "LineItem-Edit-ChangeOrderQuantityPending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Tax":
		{
			"Name": "Tax",
			"Hash": "LineItem-Edit-Tax",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ChangeOrderNumber":
		{
			"Name": "Change Order Number",
			"Hash": "LineItem-Edit-ChangeOrderNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.FundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Edit-FundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.IDFundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-Edit-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "FundingCategory",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		},
		"LineItemDetails.Status":
		{
			"Name": "Status",
			"Hash": "LineItem-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ProposalIdentifier":
		{
			"Name": "Proposal Identifier",
			"Hash": "LineItem-Edit-ProposalIdentifier",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.PercentComplete":
		{
			"Name": "Percent Complete",
			"Hash": "LineItem-Edit-PercentComplete",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.CategoryNumber":
		{
			"Name": "Category Number",
			"Hash": "LineItem-Edit-CategoryNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.Retainage":
		{
			"Name": "Retainage",
			"Hash": "LineItem-Edit-Retainage",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ImprovementType":
		{
			"Name": "Improvement Type",
			"Hash": "LineItem-Edit-ImprovementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.DeliveryDate":
		{
			"Name": "Delivery Date",
			"Hash": "LineItem-Edit-DeliveryDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.ParentIDLineItem":
		{
			"Name": "Parent Line Item",
			"Hash": "LineItem-Edit-ParentIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"LineItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "LineItem-Edit-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"LineItemDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "LineItem-Edit-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"LineItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "LineItem-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LineItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "LineItem-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"LineItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "LineItem-Edit-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "13",
				"Width": 3,
				"Section": "LineItem-Edit-Details",
				"Group": "LineItem-Edit-Details"
			}
		},
		"LineItemDetails.IDLineItem":
		{
			"Name": "IDLine Item",
			"Hash": "LineItem-Edit-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.GUIDLineItem":
		{
			"Name": "GUIDLine Item",
			"Hash": "LineItem-Edit-GUIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "LineItem-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "LineItem-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "LineItem-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		},
		"LineItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "LineItem-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-Edit-DataAudit",
				"Group": "LineItem-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "LineItem-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "LineItem-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "LineItem-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "LineItem-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "LineItem-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "LineItem-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1158:[function(require,module,exports){
module.exports={
	"Form": "LineItemViewManifest",
	"Scope": "LineItem-View",
	"Descriptors":
	{
		"LineItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "LineItem-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "LineItem-View-Identity",
				"Group": "LineItem-View-Identity"
			}
		},
		"LineItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "LineItem-View-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "LineItem-View-Identity",
				"Group": "LineItem-View-Identity"
			}
		},
		"LineItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "LineItem-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "LineItem-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "LineItem-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "LineItem-View-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ItemNumber":
		{
			"Name": "Item Number",
			"Hash": "LineItem-View-ItemNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "LineItem-View-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ExpectedQuantity":
		{
			"Name": "Expected Quantity",
			"Hash": "LineItem-View-ExpectedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ContractorReportedQuantity":
		{
			"Name": "Contractor Reported Quantity",
			"Hash": "LineItem-View-ContractorReportedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ActualQuantity":
		{
			"Name": "Actual Quantity",
			"Hash": "LineItem-View-ActualQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ContractQuantity":
		{
			"Name": "Contract Quantity",
			"Hash": "LineItem-View-ContractQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.InstalledQuantity":
		{
			"Name": "Installed Quantity",
			"Hash": "LineItem-View-InstalledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantity":
		{
			"Name": "Change Order Quantity",
			"Hash": "LineItem-View-ChangeOrderQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantityPending":
		{
			"Name": "Change Order Quantity Pending",
			"Hash": "LineItem-View-ChangeOrderQuantityPending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Tax":
		{
			"Name": "Tax",
			"Hash": "LineItem-View-Tax",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ChangeOrderNumber":
		{
			"Name": "Change Order Number",
			"Hash": "LineItem-View-ChangeOrderNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.FundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-View-FundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.IDFundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-View-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "FundingCategory",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.Status":
		{
			"Name": "Status",
			"Hash": "LineItem-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ProposalIdentifier":
		{
			"Name": "Proposal Identifier",
			"Hash": "LineItem-View-ProposalIdentifier",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.PercentComplete":
		{
			"Name": "Percent Complete",
			"Hash": "LineItem-View-PercentComplete",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.CategoryNumber":
		{
			"Name": "Category Number",
			"Hash": "LineItem-View-CategoryNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Retainage":
		{
			"Name": "Retainage",
			"Hash": "LineItem-View-Retainage",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ImprovementType":
		{
			"Name": "Improvement Type",
			"Hash": "LineItem-View-ImprovementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.DeliveryDate":
		{
			"Name": "Delivery Date",
			"Hash": "LineItem-View-DeliveryDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ParentIDLineItem":
		{
			"Name": "Parent Line Item",
			"Hash": "LineItem-View-ParentIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "LineItem-View-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "LineItem-View-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "LineItem-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "LineItem-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "LineItem-View-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "13",
				"Width": 3,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.IDLineItem":
		{
			"Name": "IDLine Item",
			"Hash": "LineItem-View-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.GUIDLineItem":
		{
			"Name": "GUIDLine Item",
			"Hash": "LineItem-View-GUIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "LineItem-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "LineItem-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "LineItem-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "LineItem-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "LineItem-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "LineItem-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "LineItem-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "LineItem-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "LineItem-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "LineItem-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1159:[function(require,module,exports){
module.exports={
	"Form": "LocationCreateManifest",
	"Scope": "Location-Create",
	"Descriptors":
	{
		"LocationDetails.Name":
		{
			"Name": "Name",
			"Hash": "Location-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Location-Create-Identity",
				"Group": "Location-Create-Identity"
			}
		},
		"LocationDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Location-Create-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Location-Create-Identity",
				"Group": "Location-Create-Identity"
			}
		},
		"LocationDetails.Type":
		{
			"Name": "Type",
			"Hash": "Location-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details"
			}
		},
		"LocationDetails.Description":
		{
			"Name": "Description",
			"Hash": "Location-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details"
			}
		},
		"LocationDetails.ExternalLocationID":
		{
			"Name": "External Location ID",
			"Hash": "Location-Create-ExternalLocationID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details"
			}
		},
		"LocationDetails.ParentIDLocation":
		{
			"Name": "Parent Location",
			"Hash": "Location-Create-ParentIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details",
				"Entity": "Location",
				"SearchFields":
				[
					"Name",
					"Description",
					"QRCode"
				]
			}
		},
		"LocationDetails.IDObservation":
		{
			"Name": "Photo",
			"Hash": "Location-Create-IDObservation",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ObservationPhoto",
				"Row": "5",
				"Width": 12,
				"Section": "Location-Create-Photo",
				"Group": "Location-Create-Photo",
				"PhotoEntity": "Location"
			}
		},
		"LocationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Location-Create-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Location-Create-Contact",
				"Group": "Location-Create-Contact"
			}
		},
		"LocationDetails.Address":
		{
			"Name": "Address",
			"Hash": "Location-Create-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 12,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.City":
		{
			"Name": "City",
			"Hash": "Location-Create-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.State":
		{
			"Name": "State",
			"Hash": "Location-Create-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "Location-Create-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.Latitude":
		{
			"Name": "Location",
			"Hash": "Location-Create-Latitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "GeolocationSelectorWithMap",
				"Row": "9",
				"Width": 12,
				"Section": "Location-Create-Map",
				"Group": "Location-Create-Map",
				"LatitudeAddress": "LocationDetails.Latitude",
				"LongitudeAddress": "LocationDetails.Longitude"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Location-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Location-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Location-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Location-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Photo",
			"Hash": "Location-Create-Photo",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Photo",
					"Hash": "Location-Create-Photo",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Location-Create-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Location-Create-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "Location-Create-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "Location-Create-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Map Location",
			"Hash": "Location-Create-Map",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Map Location",
					"Hash": "Location-Create-Map",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1160:[function(require,module,exports){
module.exports={
	"Form": "LocationEditManifest",
	"Scope": "Location-Edit",
	"Descriptors":
	{
		"LocationDetails.Name":
		{
			"Name": "Name",
			"Hash": "Location-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Location-Edit-Identity",
				"Group": "Location-Edit-Identity"
			}
		},
		"LocationDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Location-Edit-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Location-Edit-Identity",
				"Group": "Location-Edit-Identity"
			}
		},
		"LocationDetails.Type":
		{
			"Name": "Type",
			"Hash": "Location-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details"
			}
		},
		"LocationDetails.Description":
		{
			"Name": "Description",
			"Hash": "Location-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details"
			}
		},
		"LocationDetails.ExternalLocationID":
		{
			"Name": "External Location ID",
			"Hash": "Location-Edit-ExternalLocationID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details"
			}
		},
		"LocationDetails.ParentIDLocation":
		{
			"Name": "Parent Location",
			"Hash": "Location-Edit-ParentIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details",
				"Entity": "Location",
				"SearchFields":
				[
					"Name",
					"Description",
					"QRCode"
				]
			}
		},
		"LocationDetails.IDObservation":
		{
			"Name": "Photo",
			"Hash": "Location-Edit-IDObservation",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ObservationPhoto",
				"Row": "5",
				"Width": 12,
				"Section": "Location-Edit-Photo",
				"Group": "Location-Edit-Photo",
				"PhotoEntity": "Location"
			}
		},
		"LocationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Location-Edit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Location-Edit-Contact",
				"Group": "Location-Edit-Contact"
			}
		},
		"LocationDetails.Address":
		{
			"Name": "Address",
			"Hash": "Location-Edit-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 12,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.City":
		{
			"Name": "City",
			"Hash": "Location-Edit-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.State":
		{
			"Name": "State",
			"Hash": "Location-Edit-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "Location-Edit-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.Latitude":
		{
			"Name": "Location",
			"Hash": "Location-Edit-Latitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "GeolocationSelectorWithMap",
				"Row": "9",
				"Width": 12,
				"Section": "Location-Edit-Map",
				"Group": "Location-Edit-Map",
				"LatitudeAddress": "LocationDetails.Latitude",
				"LongitudeAddress": "LocationDetails.Longitude"
			}
		},
		"LocationDetails.IDLocation":
		{
			"Name": "IDLocation",
			"Hash": "Location-Edit-IDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.GUIDLocation":
		{
			"Name": "GUIDLocation",
			"Hash": "Location-Edit-GUIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Location-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Location-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Location-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Location-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Location-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Location-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Location-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Location-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Photo",
			"Hash": "Location-Edit-Photo",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Photo",
					"Hash": "Location-Edit-Photo",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Location-Edit-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Location-Edit-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "Location-Edit-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "Location-Edit-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Map Location",
			"Hash": "Location-Edit-Map",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Map Location",
					"Hash": "Location-Edit-Map",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Location-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Location-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1161:[function(require,module,exports){
module.exports={
	"Form": "LocationViewManifest",
	"Scope": "Location-View",
	"Descriptors":
	{
		"LocationDetails.Name":
		{
			"Name": "Name",
			"Hash": "Location-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Location-View-Identity",
				"Group": "Location-View-Identity"
			}
		},
		"LocationDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Location-View-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Location-View-Identity",
				"Group": "Location-View-Identity"
			}
		},
		"LocationDetails.Type":
		{
			"Name": "Type",
			"Hash": "Location-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details"
			}
		},
		"LocationDetails.Description":
		{
			"Name": "Description",
			"Hash": "Location-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details"
			}
		},
		"LocationDetails.ExternalLocationID":
		{
			"Name": "External Location ID",
			"Hash": "Location-View-ExternalLocationID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details"
			}
		},
		"LocationDetails.ParentIDLocation":
		{
			"Name": "Parent Location",
			"Hash": "Location-View-ParentIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Location-View-Details",
				"Group": "Location-View-Details",
				"Entity": "Location",
				"SearchFields":
				[
					"Name",
					"Description",
					"QRCode"
				],
				"ReadOnly": true
			}
		},
		"LocationDetails.IDObservation":
		{
			"Name": "Photo",
			"Hash": "Location-View-IDObservation",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ObservationPhoto",
				"Row": "5",
				"Width": 12,
				"Section": "Location-View-Photo",
				"Group": "Location-View-Photo",
				"PhotoEntity": "Location",
				"ReadOnly": true
			}
		},
		"LocationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Location-View-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Location-View-Contact",
				"Group": "Location-View-Contact"
			}
		},
		"LocationDetails.Address":
		{
			"Name": "Address",
			"Hash": "Location-View-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 12,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.City":
		{
			"Name": "City",
			"Hash": "Location-View-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.State":
		{
			"Name": "State",
			"Hash": "Location-View-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "Location-View-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Location-View-Address",
				"Group": "Location-View-Address"
			}
		},
		"LocationDetails.Latitude":
		{
			"Name": "Location",
			"Hash": "Location-View-Latitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "GeolocationSelectorWithMap",
				"Row": "9",
				"Width": 12,
				"Section": "Location-View-Map",
				"Group": "Location-View-Map",
				"LatitudeAddress": "LocationDetails.Latitude",
				"LongitudeAddress": "LocationDetails.Longitude",
				"ReadOnly": true
			}
		},
		"LocationDetails.IDLocation":
		{
			"Name": "IDLocation",
			"Hash": "Location-View-IDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.GUIDLocation":
		{
			"Name": "GUIDLocation",
			"Hash": "Location-View-GUIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Location-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Location-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Location-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		},
		"LocationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Location-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-View-DataAudit",
				"Group": "Location-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Location-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Location-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Location-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Location-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Photo",
			"Hash": "Location-View-Photo",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Photo",
					"Hash": "Location-View-Photo",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Location-View-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Location-View-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "Location-View-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "Location-View-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Map Location",
			"Hash": "Location-View-Map",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Map Location",
					"Hash": "Location-View-Map",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Location-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Location-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1162:[function(require,module,exports){
module.exports={
	"Form": "LotCreateManifest",
	"Scope": "Lot-Create",
	"Descriptors":
	{
		"LotDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lot-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lot-Create-Identity",
				"Group": "Lot-Create-Identity"
			}
		},
		"LotDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "Lot-Create-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.FormData":
		{
			"Name": "Form Data",
			"Hash": "Lot-Create-FormData",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Lot-Create-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"LotDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Lot-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LotDetails.ValidationSequence":
		{
			"Name": "Validation Sequence",
			"Hash": "Lot-Create-ValidationSequence",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Lot-Create-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Lot-Create-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lot-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lot-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lot-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lot-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1163:[function(require,module,exports){
module.exports={
	"Form": "LotEditManifest",
	"Scope": "Lot-Edit",
	"Descriptors":
	{
		"LotDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lot-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lot-Edit-Identity",
				"Group": "Lot-Edit-Identity"
			}
		},
		"LotDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "Lot-Edit-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.FormData":
		{
			"Name": "Form Data",
			"Hash": "Lot-Edit-FormData",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Lot-Edit-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"LotDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Lot-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LotDetails.ValidationSequence":
		{
			"Name": "Validation Sequence",
			"Hash": "Lot-Edit-ValidationSequence",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Lot-Edit-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Lot-Edit-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lot-Edit-Details",
				"Group": "Lot-Edit-Details"
			}
		},
		"LotDetails.IDLot":
		{
			"Name": "IDLot",
			"Hash": "Lot-Edit-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.GUIDLot":
		{
			"Name": "GUIDLot",
			"Hash": "Lot-Edit-GUIDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lot-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lot-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lot-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		},
		"LotDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lot-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-Edit-DataAudit",
				"Group": "Lot-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lot-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lot-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lot-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lot-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lot-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lot-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1164:[function(require,module,exports){
module.exports={
	"Form": "LotViewManifest",
	"Scope": "Lot-View",
	"Descriptors":
	{
		"LotDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lot-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Lot-View-Identity",
				"Group": "Lot-View-Identity"
			}
		},
		"LotDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "Lot-View-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.FormData":
		{
			"Name": "Form Data",
			"Hash": "Lot-View-FormData",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Lot-View-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"LotDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Lot-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"LotDetails.ValidationSequence":
		{
			"Name": "Validation Sequence",
			"Hash": "Lot-View-ValidationSequence",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Lot-View-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Lot-View-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.IDLot":
		{
			"Name": "IDLot",
			"Hash": "Lot-View-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.GUIDLot":
		{
			"Name": "GUIDLot",
			"Hash": "Lot-View-GUIDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lot-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lot-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lot-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lot-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lot-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lot-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lot-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lot-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lot-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lot-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1165:[function(require,module,exports){
module.exports={
	"Form": "MaterialCreateManifest",
	"Scope": "Material-Create",
	"Descriptors":
	{
		"MaterialDetails.Name":
		{
			"Name": "Name",
			"Hash": "Material-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.NameAbbreviated":
		{
			"Name": "Name Abbreviated",
			"Hash": "Material-Create-NameAbbreviated",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Material-Create-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "Material-Create-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "Material-Create-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.Type":
		{
			"Name": "Type",
			"Hash": "Material-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "Material-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.UnitsMetric":
		{
			"Name": "Units Metric",
			"Hash": "Material-Create-UnitsMetric",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.UnitsImperial":
		{
			"Name": "Units Imperial",
			"Hash": "Material-Create-UnitsImperial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.Active":
		{
			"Name": "Active",
			"Hash": "Material-Create-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.BrandNameRequired":
		{
			"Name": "Brand Name Required",
			"Hash": "Material-Create-BrandNameRequired",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.IDMaterialParent":
		{
			"Name": "Parent Material",
			"Hash": "Material-Create-IDMaterialParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MaterialDetails.Category":
		{
			"Name": "Category",
			"Hash": "Material-Create-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.CategoryName":
		{
			"Name": "Category Name",
			"Hash": "Material-Create-CategoryName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.ItemSection":
		{
			"Name": "Item Section",
			"Hash": "Material-Create-ItemSection",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Material-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Material-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Material-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Material-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1166:[function(require,module,exports){
module.exports={
	"Form": "MaterialEditManifest",
	"Scope": "Material-Edit",
	"Descriptors":
	{
		"MaterialDetails.Name":
		{
			"Name": "Name",
			"Hash": "Material-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.NameAbbreviated":
		{
			"Name": "Name Abbreviated",
			"Hash": "Material-Edit-NameAbbreviated",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Material-Edit-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "Material-Edit-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "Material-Edit-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.Type":
		{
			"Name": "Type",
			"Hash": "Material-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "Material-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.UnitsMetric":
		{
			"Name": "Units Metric",
			"Hash": "Material-Edit-UnitsMetric",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.UnitsImperial":
		{
			"Name": "Units Imperial",
			"Hash": "Material-Edit-UnitsImperial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.Active":
		{
			"Name": "Active",
			"Hash": "Material-Edit-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.BrandNameRequired":
		{
			"Name": "Brand Name Required",
			"Hash": "Material-Edit-BrandNameRequired",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.IDMaterialParent":
		{
			"Name": "Parent Material",
			"Hash": "Material-Edit-IDMaterialParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MaterialDetails.Category":
		{
			"Name": "Category",
			"Hash": "Material-Edit-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.CategoryName":
		{
			"Name": "Category Name",
			"Hash": "Material-Edit-CategoryName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.ItemSection":
		{
			"Name": "Item Section",
			"Hash": "Material-Edit-ItemSection",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.IDMaterial":
		{
			"Name": "IDMaterial",
			"Hash": "Material-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.GUIDMaterial":
		{
			"Name": "GUIDMaterial",
			"Hash": "Material-Edit-GUIDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Material-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Material-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Material-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Material-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Material-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Material-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Material-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Material-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Material-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Material-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1167:[function(require,module,exports){
module.exports={
	"Form": "MaterialViewManifest",
	"Scope": "Material-View",
	"Descriptors":
	{
		"MaterialDetails.Name":
		{
			"Name": "Name",
			"Hash": "Material-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.NameAbbreviated":
		{
			"Name": "Name Abbreviated",
			"Hash": "Material-View-NameAbbreviated",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Material-View-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "Material-View-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "Material-View-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Material-View-Identity",
				"Group": "Material-View-Identity"
			}
		},
		"MaterialDetails.Type":
		{
			"Name": "Type",
			"Hash": "Material-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "Material-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.UnitsMetric":
		{
			"Name": "Units Metric",
			"Hash": "Material-View-UnitsMetric",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.UnitsImperial":
		{
			"Name": "Units Imperial",
			"Hash": "Material-View-UnitsImperial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.Active":
		{
			"Name": "Active",
			"Hash": "Material-View-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.BrandNameRequired":
		{
			"Name": "Brand Name Required",
			"Hash": "Material-View-BrandNameRequired",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.IDMaterialParent":
		{
			"Name": "Parent Material",
			"Hash": "Material-View-IDMaterialParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"MaterialDetails.Category":
		{
			"Name": "Category",
			"Hash": "Material-View-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.CategoryName":
		{
			"Name": "Category Name",
			"Hash": "Material-View-CategoryName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.ItemSection":
		{
			"Name": "Item Section",
			"Hash": "Material-View-ItemSection",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Material-View-Details",
				"Group": "Material-View-Details"
			}
		},
		"MaterialDetails.IDMaterial":
		{
			"Name": "IDMaterial",
			"Hash": "Material-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.GUIDMaterial":
		{
			"Name": "GUIDMaterial",
			"Hash": "Material-View-GUIDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Material-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Material-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Material-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		},
		"MaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Material-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-View-DataAudit",
				"Group": "Material-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Material-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Material-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Material-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Material-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Material-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Material-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1168:[function(require,module,exports){
module.exports={
	"Form": "MixDesignCreateManifest",
	"Scope": "MixDesign-Create",
	"Descriptors":
	{
		"MixDesignDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "MixDesign-Create-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixDesign-Create-Identity",
				"Group": "MixDesign-Create-Identity"
			}
		},
		"MixDesignDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixDesign-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixDesign-Create-Identity",
				"Group": "MixDesign-Create-Identity"
			}
		},
		"MixDesignDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "MixDesign-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MixDesignDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "MixDesign-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"MixDesignDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "MixDesign-Create-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "MixDesign-Create-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.MixID":
		{
			"Name": "Mix ID",
			"Hash": "MixDesign-Create-MixID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixDesign-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.IDMixType":
		{
			"Name": "Mix Type",
			"Hash": "MixDesign-Create-IDMixType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details",
				"Entity": "MixType",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixDesign-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixDesign-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixDesign-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixDesign-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1169:[function(require,module,exports){
module.exports={
	"Form": "MixDesignEditManifest",
	"Scope": "MixDesign-Edit",
	"Descriptors":
	{
		"MixDesignDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "MixDesign-Edit-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixDesign-Edit-Identity",
				"Group": "MixDesign-Edit-Identity"
			}
		},
		"MixDesignDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixDesign-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixDesign-Edit-Identity",
				"Group": "MixDesign-Edit-Identity"
			}
		},
		"MixDesignDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "MixDesign-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MixDesignDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "MixDesign-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"MixDesignDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "MixDesign-Edit-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "MixDesign-Edit-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.MixID":
		{
			"Name": "Mix ID",
			"Hash": "MixDesign-Edit-MixID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixDesign-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.IDMixType":
		{
			"Name": "Mix Type",
			"Hash": "MixDesign-Edit-IDMixType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details",
				"Entity": "MixType",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		},
		"MixDesignDetails.IDMixDesign":
		{
			"Name": "IDMix Design",
			"Hash": "MixDesign-Edit-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.GUIDMixDesign":
		{
			"Name": "GUIDMix Design",
			"Hash": "MixDesign-Edit-GUIDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixDesign-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixDesign-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixDesign-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixDesign-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixDesign-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixDesign-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixDesign-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixDesign-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixDesign-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixDesign-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1170:[function(require,module,exports){
module.exports={
	"Form": "MixDesignViewManifest",
	"Scope": "MixDesign-View",
	"Descriptors":
	{
		"MixDesignDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "MixDesign-View-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "MixDesign-View-Identity",
				"Group": "MixDesign-View-Identity"
			}
		},
		"MixDesignDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixDesign-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "MixDesign-View-Identity",
				"Group": "MixDesign-View-Identity"
			}
		},
		"MixDesignDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "MixDesign-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"MixDesignDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "MixDesign-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"MixDesignDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "MixDesign-View-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "MixDesign-View-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.MixID":
		{
			"Name": "Mix ID",
			"Hash": "MixDesign-View-MixID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixDesign-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.IDMixType":
		{
			"Name": "Mix Type",
			"Hash": "MixDesign-View-IDMixType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details",
				"Entity": "MixType",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"MixDesignDetails.IDMixDesign":
		{
			"Name": "IDMix Design",
			"Hash": "MixDesign-View-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.GUIDMixDesign":
		{
			"Name": "GUIDMix Design",
			"Hash": "MixDesign-View-GUIDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixDesign-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixDesign-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixDesign-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixDesign-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixDesign-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixDesign-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixDesign-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixDesign-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixDesign-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixDesign-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1171:[function(require,module,exports){
module.exports={
	"Form": "MixSpecificationCreateManifest",
	"Scope": "MixSpecification-Create",
	"Descriptors":
	{
		"MixSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixSpecification-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixSpecification-Create-Identity",
				"Group": "MixSpecification-Create-Identity"
			}
		},
		"MixSpecificationDetails.Code":
		{
			"Name": "Code",
			"Hash": "MixSpecification-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixSpecification-Create-Identity",
				"Group": "MixSpecification-Create-Identity"
			}
		},
		"MixSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixSpecification-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "MixSpecification-Create-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "MixSpecification-Create-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "MixSpecification-Create-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.ApprovalDate":
		{
			"Name": "Approval Date",
			"Hash": "MixSpecification-Create-ApprovalDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.ApprovingIDUser":
		{
			"Name": "Approving IDUser",
			"Hash": "MixSpecification-Create-ApprovingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixSpecification-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixSpecification-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixSpecification-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixSpecification-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1172:[function(require,module,exports){
module.exports={
	"Form": "MixSpecificationEditManifest",
	"Scope": "MixSpecification-Edit",
	"Descriptors":
	{
		"MixSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixSpecification-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixSpecification-Edit-Identity",
				"Group": "MixSpecification-Edit-Identity"
			}
		},
		"MixSpecificationDetails.Code":
		{
			"Name": "Code",
			"Hash": "MixSpecification-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixSpecification-Edit-Identity",
				"Group": "MixSpecification-Edit-Identity"
			}
		},
		"MixSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixSpecification-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "MixSpecification-Edit-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "MixSpecification-Edit-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "MixSpecification-Edit-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.ApprovalDate":
		{
			"Name": "Approval Date",
			"Hash": "MixSpecification-Edit-ApprovalDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.ApprovingIDUser":
		{
			"Name": "Approving IDUser",
			"Hash": "MixSpecification-Edit-ApprovingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.IDMixSpecification":
		{
			"Name": "IDMix Specification",
			"Hash": "MixSpecification-Edit-IDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.GUIDMixSpecification":
		{
			"Name": "GUIDMix Specification",
			"Hash": "MixSpecification-Edit-GUIDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixSpecification-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixSpecification-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixSpecification-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixSpecification-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixSpecification-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixSpecification-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixSpecification-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixSpecification-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixSpecification-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixSpecification-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1173:[function(require,module,exports){
module.exports={
	"Form": "MixSpecificationViewManifest",
	"Scope": "MixSpecification-View",
	"Descriptors":
	{
		"MixSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixSpecification-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "MixSpecification-View-Identity",
				"Group": "MixSpecification-View-Identity"
			}
		},
		"MixSpecificationDetails.Code":
		{
			"Name": "Code",
			"Hash": "MixSpecification-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "MixSpecification-View-Identity",
				"Group": "MixSpecification-View-Identity"
			}
		},
		"MixSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixSpecification-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "MixSpecification-View-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "MixSpecification-View-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "MixSpecification-View-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.ApprovalDate":
		{
			"Name": "Approval Date",
			"Hash": "MixSpecification-View-ApprovalDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.ApprovingIDUser":
		{
			"Name": "Approving IDUser",
			"Hash": "MixSpecification-View-ApprovingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.IDMixSpecification":
		{
			"Name": "IDMix Specification",
			"Hash": "MixSpecification-View-IDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.GUIDMixSpecification":
		{
			"Name": "GUIDMix Specification",
			"Hash": "MixSpecification-View-GUIDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixSpecification-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixSpecification-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixSpecification-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixSpecification-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixSpecification-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixSpecification-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixSpecification-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixSpecification-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixSpecification-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixSpecification-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1174:[function(require,module,exports){
module.exports={
	"Form": "ObservationApprovalStateEditManifest",
	"Scope": "ObservationApprovalState-Edit",
	"Descriptors":
	{
		"ObservationApprovalStateDetails.IDObservationApprovalState":
		{
			"Name": "ID",
			"Hash": "ObsStateEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		},
		"ObservationApprovalStateDetails.GUIDObservationApprovalState":
		{
			"Name": "GUID",
			"Hash": "ObsStateEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		},
		"ObservationApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "ObsStateEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		},
		"ObservationApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ObsStateEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStateEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStateEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1175:[function(require,module,exports){
module.exports={
	"Scope": "ObservationApprovalState-List",
	"CoreEntity": "ObservationApprovalState",
	"TitleTemplate": "Observation Approval States",
	"Descriptors":
	{
		"Name":
		{
			"Name": "State Name",
			"Hash": "ObsStateListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "ObsStateListHash",
			"PictDashboard": {}
		}
	}
}

},{}],1176:[function(require,module,exports){
module.exports={
	"Form": "ObservationApprovalStateViewManifest",
	"Scope": "ObservationApprovalState-View",
	"Descriptors":
	{
		"ObservationApprovalStateDetails.IDObservationApprovalState":
		{
			"Name": "ID",
			"Hash": "ObsStateView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.GUIDObservationApprovalState":
		{
			"Name": "GUID",
			"Hash": "ObsStateView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "ObsStateView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ObsStateView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsStateView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		},
		"ObservationApprovalStateDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsStateView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		},
		"ObservationApprovalStateDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsStateView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		},
		"ObservationApprovalStateDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsStateView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStateIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStateIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsStateAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsStateAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1177:[function(require,module,exports){
module.exports={
	"Form": "ObservationApprovalStepEditManifest",
	"Scope": "ObservationApprovalStep-Edit",
	"Descriptors":
	{
		"ObservationApprovalStepDetails.IDObservationApprovalStep":
		{
			"Name": "ID",
			"Hash": "ObsStepEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStepEditIdentity",
				"Group": "ObsStepEditIdentity"
			}
		},
		"ObservationApprovalStepDetails.GUIDObservationApprovalStep":
		{
			"Name": "GUID",
			"Hash": "ObsStepEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStepEditIdentity",
				"Group": "ObsStepEditIdentity"
			}
		},
		"ObservationApprovalStepDetails.IDObservationApprovalState":
		{
			"Name": "State ID",
			"Hash": "ObsStepEdit-StateID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "ObsStepEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 2,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.ObservationType":
		{
			"Name": "Observation Type",
			"Hash": "ObsStepEdit-ObsType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "ObsStepEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "ObsStepEdit-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "ObsStepEdit-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStepEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStepEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "ObsStepEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "ObsStepEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1178:[function(require,module,exports){
module.exports={
	"Scope": "ObservationApprovalStep-List",
	"CoreEntity": "ObservationApprovalStep",
	"TitleTemplate": "Observation Approval Steps",
	"Descriptors":
	{
		"IDObservationApprovalState":
		{
			"Name": "State ID",
			"Hash": "ObsStepListStateID",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "ObsStepListOrdinal",
			"PictDashboard": {}
		},
		"ObservationType":
		{
			"Name": "Obs Type",
			"Hash": "ObsStepListObsType",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "ObsStepListIDRole",
			"PictDashboard": {}
		},
		"IncludeHigherRoles":
		{
			"Name": "Higher Roles",
			"Hash": "ObsStepListHigherRoles",
			"PictDashboard": {}
		},
		"PerformLock":
		{
			"Name": "Lock",
			"Hash": "ObsStepListLock",
			"PictDashboard": {}
		}
	}
}

},{}],1179:[function(require,module,exports){
module.exports={
	"Form": "ObservationApprovalStepViewManifest",
	"Scope": "ObservationApprovalStep-View",
	"Descriptors":
	{
		"ObservationApprovalStepDetails.IDObservationApprovalStep":
		{
			"Name": "ID",
			"Hash": "ObsStepView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStepIdentity",
				"Group": "ObsStepIdentity"
			}
		},
		"ObservationApprovalStepDetails.GUIDObservationApprovalStep":
		{
			"Name": "GUID",
			"Hash": "ObsStepView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStepIdentity",
				"Group": "ObsStepIdentity"
			}
		},
		"ObservationApprovalStepDetails.IDObservationApprovalState":
		{
			"Name": "State ID",
			"Hash": "ObsStepView-StateID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "ObsStepView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 2,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.ObservationType":
		{
			"Name": "Observation Type",
			"Hash": "ObsStepView-ObsType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "ObsStepView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "ObsStepView-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "ObsStepView-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsStepView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		},
		"ObservationApprovalStepDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsStepView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		},
		"ObservationApprovalStepDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsStepView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		},
		"ObservationApprovalStepDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsStepView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStepIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStepIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "ObsStepConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "ObsStepConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsStepAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsStepAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1180:[function(require,module,exports){
module.exports={
	"Form": "ObservationApprovalWorkflowEditManifest",
	"Scope": "ObservationApprovalWorkflow-Edit",
	"Descriptors":
	{
		"ObservationApprovalWorkflowDetails.IDObservationApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "ObsWfEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsWfEditIdentity",
				"Group": "ObsWfEditIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "ObsWfEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsWfEditIdentity",
				"Group": "ObsWfEditIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.FromStatus":
		{
			"Name": "FromStatus",
			"Hash": "ObsWfEdit-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfEditConfig",
				"Group": "ObsWfEditConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.ToStatus":
		{
			"Name": "ToStatus",
			"Hash": "ObsWfEdit-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfEditConfig",
				"Group": "ObsWfEditConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ObsWfEdit-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfEditConfig",
				"Group": "ObsWfEditConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "ObsWfEdit-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ObsWfEditEdgeOptions",
				"Group": "ObsWfEditEdgeOptions"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsWfEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsWfEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "ObsWfEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "ObsWfEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "ObsWfEditEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "ObsWfEditEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1181:[function(require,module,exports){
module.exports={
	"Scope": "ObservationApprovalWorkflow-List",
	"CoreEntity": "ObservationApprovalWorkflow",
	"TitleTemplate": "Observation Approval Workflows",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Transition Name",
			"Hash": "ObsWfListName",
			"PictDashboard": {}
		},
		"FromStatus":
		{
			"Name": "FromStatus",
			"Hash": "ObsWfListFromStatus",
			"PictDashboard": {}
		},
		"ToStatus":
		{
			"Name": "ToStatus",
			"Hash": "ObsWfListToStatus",
			"PictDashboard": {}
		},
		"IDProject":
		{
			"Name": "Project ID",
			"Hash": "ObsWfListIDProject",
			"PictDashboard": {}
		}
	}
}

},{}],1182:[function(require,module,exports){
module.exports={
	"Form": "ObservationApprovalWorkflowViewManifest",
	"Scope": "ObservationApprovalWorkflow-View",
	"Descriptors":
	{
		"ObservationApprovalWorkflowDetails.IDObservationApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "ObsWfView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsWfIdentity",
				"Group": "ObsWfIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "ObsWfView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsWfIdentity",
				"Group": "ObsWfIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.FromStatus":
		{
			"Name": "FromStatus",
			"Hash": "ObsWfView-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfConfig",
				"Group": "ObsWfConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.ToStatus":
		{
			"Name": "ToStatus",
			"Hash": "ObsWfView-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfConfig",
				"Group": "ObsWfConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ObsWfView-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfConfig",
				"Group": "ObsWfConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "ObsWfView-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ObsWfEdgeOptions",
				"Group": "ObsWfEdgeOptions"
			}
		},
		"ObservationApprovalWorkflowDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsWfView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		},
		"ObservationApprovalWorkflowDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsWfView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		},
		"ObservationApprovalWorkflowDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsWfView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		},
		"ObservationApprovalWorkflowDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsWfView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsWfIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsWfIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "ObsWfConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "ObsWfConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "ObsWfEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "ObsWfEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsWfAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsWfAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1183:[function(require,module,exports){
module.exports={
	"Form": "ObservationManifestEditManifest",
	"Scope": "ObservationManifest-Edit",
	"Descriptors":
	{
		"ObservationManifestDetails.IDObservationManifest":
		{
			"Name": "ID",
			"Hash": "ObsManifestEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsManifestEditIdentity",
				"Group": "ObsManifestEditIdentity"
			}
		},
		"ObservationManifestDetails.GUIDObservationManifest":
		{
			"Name": "GUID",
			"Hash": "ObsManifestEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsManifestEditIdentity",
				"Group": "ObsManifestEditIdentity"
			}
		},
		"ObservationManifestDetails.Name":
		{
			"Name": "Name",
			"Hash": "ObsManifestEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsManifestEditIdentity",
				"Group": "ObsManifestEditIdentity"
			}
		},
		"ObservationManifestDetails.DisplayName":
		{
			"Name": "Display Name",
			"Hash": "ObsManifestEdit-DisplayName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestEditConfig",
				"Group": "ObsManifestEditConfig"
			}
		},
		"ObservationManifestDetails.Category":
		{
			"Name": "Category",
			"Hash": "ObsManifestEdit-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestEditConfig",
				"Group": "ObsManifestEditConfig"
			}
		},
		"ObservationManifestDetails.SettingsJSON":
		{
			"Name": "Settings (JSON)",
			"Hash": "ObsManifestEdit-Settings",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ObsManifestEditSettings",
				"Group": "ObsManifestEditSettings"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsManifestEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsManifestEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsManifestEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsManifestEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ObsManifestEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ObsManifestEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1184:[function(require,module,exports){
module.exports={
	"Scope": "ObservationManifest-List",
	"CoreEntity": "ObservationManifest",
	"TitleTemplate": "Observation Manifests",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ObsManifestListName",
			"PictDashboard": {}
		},
		"DisplayName":
		{
			"Name": "Display Name",
			"Hash": "ObsManifestListDisplayName",
			"PictDashboard": {}
		},
		"Category":
		{
			"Name": "Category",
			"Hash": "ObsManifestListCategory",
			"PictDashboard": {}
		}
	}
}

},{}],1185:[function(require,module,exports){
module.exports={
	"Form": "ObservationManifestViewManifest",
	"Scope": "ObservationManifest-View",
	"Descriptors":
	{
		"ObservationManifestDetails.IDObservationManifest":
		{
			"Name": "ID",
			"Hash": "ObsManifestView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsManifestIdentity",
				"Group": "ObsManifestIdentity"
			}
		},
		"ObservationManifestDetails.GUIDObservationManifest":
		{
			"Name": "GUID",
			"Hash": "ObsManifestView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsManifestIdentity",
				"Group": "ObsManifestIdentity"
			}
		},
		"ObservationManifestDetails.Name":
		{
			"Name": "Name",
			"Hash": "ObsManifestView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsManifestIdentity",
				"Group": "ObsManifestIdentity"
			}
		},
		"ObservationManifestDetails.DisplayName":
		{
			"Name": "Display Name",
			"Hash": "ObsManifestView-DisplayName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestConfig",
				"Group": "ObsManifestConfig"
			}
		},
		"ObservationManifestDetails.Category":
		{
			"Name": "Category",
			"Hash": "ObsManifestView-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestConfig",
				"Group": "ObsManifestConfig"
			}
		},
		"ObservationManifestDetails.SettingsJSON":
		{
			"Name": "Settings (JSON)",
			"Hash": "ObsManifestView-Settings",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ObsManifestSettings",
				"Group": "ObsManifestSettings"
			}
		},
		"ObservationManifestDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsManifestView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		},
		"ObservationManifestDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsManifestView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		},
		"ObservationManifestDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsManifestView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		},
		"ObservationManifestDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsManifestView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsManifestIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsManifestIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsManifestConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsManifestConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ObsManifestSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ObsManifestSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsManifestAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsManifestAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1186:[function(require,module,exports){
module.exports={
	"Form": "ObservationTagEditManifest",
	"Scope": "ObservationTag-Edit",
	"Descriptors":
	{
		"ObservationTagDetails.IDObservationTag":
		{
			"Name": "ID",
			"Hash": "ObsTagEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsTagEditIdentity",
				"Group": "ObsTagEditIdentity"
			}
		},
		"ObservationTagDetails.GUIDObservationTag":
		{
			"Name": "GUID",
			"Hash": "ObsTagEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsTagEditIdentity",
				"Group": "ObsTagEditIdentity"
			}
		},
		"ObservationTagDetails.Tag":
		{
			"Name": "Tag",
			"Hash": "ObsTagEdit-Tag",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsTagEditIdentity",
				"Group": "ObsTagEditIdentity"
			}
		},
		"ObservationTagDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "ObsTagEdit-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ObsTagEditConfig",
				"Group": "ObsTagEditConfig"
			}
		},
		"ObservationTagDetails.Description":
		{
			"Name": "Description",
			"Hash": "ObsTagEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 6,
				"Section": "ObsTagEditConfig",
				"Group": "ObsTagEditConfig"
			}
		},
		"ObservationTagDetails.Global":
		{
			"Name": "Global",
			"Hash": "ObsTagEdit-Global",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "ObsTagEditConfig",
				"Group": "ObsTagEditConfig"
			}
		},
		"ObservationTagDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "ObsTagEdit-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagEditAssociations",
				"Group": "ObsTagEditAssociations"
			}
		},
		"ObservationTagDetails.IDBidItem":
		{
			"Name": "Bid Item ID",
			"Hash": "ObsTagEdit-IDBidItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagEditAssociations",
				"Group": "ObsTagEditAssociations"
			}
		},
		"ObservationTagDetails.IDLineItem":
		{
			"Name": "Line Item ID",
			"Hash": "ObsTagEdit-IDLineItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagEditAssociations",
				"Group": "ObsTagEditAssociations"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsTagEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsTagEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsTagEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsTagEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Associations",
			"Hash": "ObsTagEditAssociations",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Associations",
					"Hash": "ObsTagEditAssociations",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1187:[function(require,module,exports){
module.exports={
	"Scope": "ObservationTag-List",
	"CoreEntity": "ObservationTag",
	"TitleTemplate": "Observation Tags",
	"Descriptors":
	{
		"Tag":
		{
			"Name": "Tag",
			"Hash": "ObsTagListTag",
			"PictDashboard": {}
		},
		"TagType":
		{
			"Name": "Tag Type",
			"Hash": "ObsTagListTagType",
			"PictDashboard": {}
		},
		"Global":
		{
			"Name": "Global",
			"Hash": "ObsTagListGlobal",
			"PictDashboard":
			{
				"ValueTemplate": "<div class=\"has-text-centered\">{~HCS:Record.Payload.Global~}<span class=\"icon has-text-success\"><i class=\"fas fa-circle-check\"></i></span>{~HCE:Record.Payload.Global~}{~HCS:Record.Payload.Global:true~}<span class=\"icon has-text-grey\"><i class=\"fas fa-circle-xmark\"></i></span>{~HCE:Record.Payload.Global:true~}</div>"
			}
		}
	}
}

},{}],1188:[function(require,module,exports){
module.exports={
	"Form": "ObservationTagViewManifest",
	"Scope": "ObservationTag-View",
	"Descriptors":
	{
		"ObservationTagDetails.IDObservationTag":
		{
			"Name": "ID",
			"Hash": "ObsTagView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsTagIdentity",
				"Group": "ObsTagIdentity"
			}
		},
		"ObservationTagDetails.GUIDObservationTag":
		{
			"Name": "GUID",
			"Hash": "ObsTagView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsTagIdentity",
				"Group": "ObsTagIdentity"
			}
		},
		"ObservationTagDetails.Tag":
		{
			"Name": "Tag",
			"Hash": "ObsTagView-Tag",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsTagIdentity",
				"Group": "ObsTagIdentity"
			}
		},
		"ObservationTagDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "ObsTagView-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsTagConfig",
				"Group": "ObsTagConfig"
			}
		},
		"ObservationTagDetails.Description":
		{
			"Name": "Description",
			"Hash": "ObsTagView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsTagConfig",
				"Group": "ObsTagConfig"
			}
		},
		"ObservationTagDetails.Global":
		{
			"Name": "Global",
			"Hash": "ObsTagView-Global",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "ObsTagConfig",
				"Group": "ObsTagConfig"
			}
		},
		"ObservationTagDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "ObsTagView-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagAssociations",
				"Group": "ObsTagAssociations"
			}
		},
		"ObservationTagDetails.IDBidItem":
		{
			"Name": "Bid Item ID",
			"Hash": "ObsTagView-IDBidItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagAssociations",
				"Group": "ObsTagAssociations"
			}
		},
		"ObservationTagDetails.IDLineItem":
		{
			"Name": "Line Item ID",
			"Hash": "ObsTagView-IDLineItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagAssociations",
				"Group": "ObsTagAssociations"
			}
		},
		"ObservationTagDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsTagView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		},
		"ObservationTagDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsTagView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		},
		"ObservationTagDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsTagView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		},
		"ObservationTagDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsTagView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsTagIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsTagIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsTagConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsTagConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Associations",
			"Hash": "ObsTagAssociations",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Associations",
					"Hash": "ObsTagAssociations",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsTagAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsTagAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1189:[function(require,module,exports){
module.exports={
	"Form": "OrganizationCreateManifest",
	"Scope": "Organization-Create",
	"Descriptors":
	{
		"OrganizationDetails.Name":
		{
			"Name": "Organization Name",
			"Hash": "OrgCreate-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 12,
				"Section": "OrgCreateIdentity",
				"Group": "OrgCreateIdentity"
			}
		},
		"OrganizationDetails.Type":
		{
			"Name": "Type",
			"Hash": "OrgCreate-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.VendorCode":
		{
			"Name": "Vendor Code",
			"Hash": "OrgCreate-VendorCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.ExternalOrganizationID":
		{
			"Name": "External Organization ID",
			"Hash": "OrgCreate-ExternalOrgID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.Approved":
		{
			"Name": "Approved",
			"Hash": "OrgCreate-Approved",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.DisadvantagedBusiness":
		{
			"Name": "Disadvantaged Business",
			"Hash": "OrgCreate-DisadvantagedBusiness",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.Email":
		{
			"Name": "Email",
			"Hash": "OrgCreate-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgCreateContact",
				"Group": "OrgCreateContact"
			}
		},
		"OrganizationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "OrgCreate-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgCreateContact",
				"Group": "OrgCreateContact"
			}
		},
		"OrganizationDetails.Address":
		{
			"Name": "Address",
			"Hash": "OrgCreate-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 12,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		},
		"OrganizationDetails.City":
		{
			"Name": "City",
			"Hash": "OrgCreate-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		},
		"OrganizationDetails.State":
		{
			"Name": "State",
			"Hash": "OrgCreate-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		},
		"OrganizationDetails.Zip":
		{
			"Name": "ZIP Code",
			"Hash": "OrgCreate-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "OrgCreateIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "OrgCreateIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "OrgCreateDetails",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "OrgCreateDetails",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "OrgCreateContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "OrgCreateContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "OrgCreateAddress",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "OrgCreateAddress",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1190:[function(require,module,exports){
module.exports={
	"Form": "OrganizationEditManifest",
	"Scope": "Organization-Edit",
	"Descriptors":
	{
		"OrganizationDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "OrgEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "OrgEditIdentity",
				"Group": "OrgEditIdentity"
			}
		},
		"OrganizationDetails.GUIDOrganization":
		{
			"Name": "GUID",
			"Hash": "OrgEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "OrgEditIdentity",
				"Group": "OrgEditIdentity"
			}
		},
		"OrganizationDetails.Name":
		{
			"Name": "Organization Name",
			"Hash": "OrgEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "OrgEditIdentity",
				"Group": "OrgEditIdentity"
			}
		},
		"OrganizationDetails.Type":
		{
			"Name": "Type",
			"Hash": "OrgEdit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.VendorCode":
		{
			"Name": "Vendor Code",
			"Hash": "OrgEdit-VendorCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.ExternalOrganizationID":
		{
			"Name": "External Organization ID",
			"Hash": "OrgEdit-ExternalOrgID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.Approved":
		{
			"Name": "Approved",
			"Hash": "OrgEdit-Approved",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.DisadvantagedBusiness":
		{
			"Name": "Disadvantaged Business",
			"Hash": "OrgEdit-DisadvantagedBusiness",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 4,
				"Section": "OrgEditDetails",
				"Group": "OrgEditDetails"
			}
		},
		"OrganizationDetails.Email":
		{
			"Name": "Email",
			"Hash": "OrgEdit-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgEditContact",
				"Group": "OrgEditContact"
			}
		},
		"OrganizationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "OrgEdit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgEditContact",
				"Group": "OrgEditContact"
			}
		},
		"OrganizationDetails.Address":
		{
			"Name": "Address",
			"Hash": "OrgEdit-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 12,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		},
		"OrganizationDetails.City":
		{
			"Name": "City",
			"Hash": "OrgEdit-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		},
		"OrganizationDetails.State":
		{
			"Name": "State",
			"Hash": "OrgEdit-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		},
		"OrganizationDetails.Zip":
		{
			"Name": "ZIP Code",
			"Hash": "OrgEdit-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgEditAddress",
				"Group": "OrgEditAddress"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "OrgEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "OrgEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "OrgEditDetails",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "OrgEditDetails",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "OrgEditContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "OrgEditContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "OrgEditAddress",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "OrgEditAddress",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1191:[function(require,module,exports){
module.exports={
	"Scope": "Organization-List",
	"CoreEntity": "Organization",
	"TitleTemplate": "Organizations",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "OrgListName",
			"PictDashboard": {}
		},
		"Type":
		{
			"Name": "Type",
			"Hash": "OrgListType",
			"PictDashboard": {}
		},
		"City":
		{
			"Name": "City",
			"Hash": "OrgListCity",
			"PictDashboard": {}
		},
		"State":
		{
			"Name": "State",
			"Hash": "OrgListState",
			"PictDashboard": {}
		},
		"Approved":
		{
			"Name": "Approved",
			"Hash": "OrgListApproved",
			"PictDashboard":
			{
				"ValueTemplate": "<div class=\"has-text-centered\">{~HCS:Record.Payload.Approved~}<span class=\"icon has-text-success\"><i class=\"fas fa-circle-check\"></i></span>{~HCE:Record.Payload.Approved~}{~HCS:Record.Payload.Approved:true~}<span class=\"icon has-text-grey\"><i class=\"fas fa-circle-xmark\"></i></span>{~HCE:Record.Payload.Approved:true~}</div>"
			}
		}
	}
}

},{}],1192:[function(require,module,exports){
module.exports={
	"Form": "OrganizationViewManifest",
	"Scope": "Organization-View",
	"Descriptors":
	{
		"OrganizationDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "OrgView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "OrgIdentity",
				"Group": "OrgIdentity"
			}
		},
		"OrganizationDetails.GUIDOrganization":
		{
			"Name": "GUID",
			"Hash": "OrgView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "OrgIdentity",
				"Group": "OrgIdentity"
			}
		},
		"OrganizationDetails.Name":
		{
			"Name": "Organization Name",
			"Hash": "OrgView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "OrgIdentity",
				"Group": "OrgIdentity"
			}
		},
		"OrganizationDetails.Type":
		{
			"Name": "Type",
			"Hash": "OrgView-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.VendorCode":
		{
			"Name": "Vendor Code",
			"Hash": "OrgView-VendorCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.ExternalOrganizationID":
		{
			"Name": "External Organization ID",
			"Hash": "OrgView-ExternalOrgID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.Approved":
		{
			"Name": "Approved",
			"Hash": "OrgView-Approved",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.DisadvantagedBusiness":
		{
			"Name": "Disadvantaged Business",
			"Hash": "OrgView-DisadvantagedBusiness",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.Email":
		{
			"Name": "Email",
			"Hash": "OrgView-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "OrgContact",
				"Group": "OrgContact"
			}
		},
		"OrganizationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "OrgView-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "OrgContact",
				"Group": "OrgContact"
			}
		},
		"OrganizationDetails.Address":
		{
			"Name": "Address",
			"Hash": "OrgView-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 12,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.City":
		{
			"Name": "City",
			"Hash": "OrgView-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.State":
		{
			"Name": "State",
			"Hash": "OrgView-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.Zip":
		{
			"Name": "ZIP Code",
			"Hash": "OrgView-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "OrgView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		},
		"OrganizationDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "OrgView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		},
		"OrganizationDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "OrgView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		},
		"OrganizationDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "OrgView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "OrgIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "OrgIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "OrgDetails",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "OrgDetails",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "OrgContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "OrgContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "OrgAddress",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "OrgAddress",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "OrgAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "OrgAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1193:[function(require,module,exports){
module.exports={
	"Form": "PayItemCreateManifest",
	"Scope": "PayItem-Create",
	"Descriptors":
	{
		"PayItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "PayItem-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PayItem-Create-Identity",
				"Group": "PayItem-Create-Identity"
			}
		},
		"PayItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "PayItem-Create-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PayItem-Create-Identity",
				"Group": "PayItem-Create-Identity"
			}
		},
		"PayItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "PayItem-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.FunctionalClass":
		{
			"Name": "Functional Class",
			"Hash": "PayItem-Create-FunctionalClass",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "PayItem-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.Amount":
		{
			"Name": "Amount",
			"Hash": "PayItem-Create-Amount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "PayItem-Create-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "PayItem-Create-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"PayItemDetails.Section":
		{
			"Name": "Section",
			"Hash": "PayItem-Create-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.ExternalPayItemID":
		{
			"Name": "External Pay Item ID",
			"Hash": "PayItem-Create-ExternalPayItemID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		},
		"PayItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "PayItem-Create-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "PayItem-Create-Details",
				"Group": "PayItem-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PayItem-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PayItem-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PayItem-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PayItem-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1194:[function(require,module,exports){
module.exports={
	"Form": "PayItemEditManifest",
	"Scope": "PayItem-Edit",
	"Descriptors":
	{
		"PayItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "PayItem-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PayItem-Edit-Identity",
				"Group": "PayItem-Edit-Identity"
			}
		},
		"PayItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "PayItem-Edit-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PayItem-Edit-Identity",
				"Group": "PayItem-Edit-Identity"
			}
		},
		"PayItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "PayItem-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.FunctionalClass":
		{
			"Name": "Functional Class",
			"Hash": "PayItem-Edit-FunctionalClass",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "PayItem-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.Amount":
		{
			"Name": "Amount",
			"Hash": "PayItem-Edit-Amount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "PayItem-Edit-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "PayItem-Edit-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"PayItemDetails.Section":
		{
			"Name": "Section",
			"Hash": "PayItem-Edit-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.ExternalPayItemID":
		{
			"Name": "External Pay Item ID",
			"Hash": "PayItem-Edit-ExternalPayItemID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "PayItem-Edit-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "PayItem-Edit-Details",
				"Group": "PayItem-Edit-Details"
			}
		},
		"PayItemDetails.IDPayItem":
		{
			"Name": "IDPay Item",
			"Hash": "PayItem-Edit-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.GUIDPayItem":
		{
			"Name": "GUIDPay Item",
			"Hash": "PayItem-Edit-GUIDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PayItem-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PayItem-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PayItem-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		},
		"PayItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PayItem-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-Edit-DataAudit",
				"Group": "PayItem-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PayItem-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PayItem-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PayItem-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PayItem-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PayItem-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PayItem-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1195:[function(require,module,exports){
module.exports={
	"Form": "PayItemViewManifest",
	"Scope": "PayItem-View",
	"Descriptors":
	{
		"PayItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "PayItem-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "PayItem-View-Identity",
				"Group": "PayItem-View-Identity"
			}
		},
		"PayItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "PayItem-View-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PayItem-View-Identity",
				"Group": "PayItem-View-Identity"
			}
		},
		"PayItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "PayItem-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.FunctionalClass":
		{
			"Name": "Functional Class",
			"Hash": "PayItem-View-FunctionalClass",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "PayItem-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.Amount":
		{
			"Name": "Amount",
			"Hash": "PayItem-View-Amount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "PayItem-View-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "PayItem-View-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"PayItemDetails.Section":
		{
			"Name": "Section",
			"Hash": "PayItem-View-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.ExternalPayItemID":
		{
			"Name": "External Pay Item ID",
			"Hash": "PayItem-View-ExternalPayItemID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "PayItem-View-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.IDPayItem":
		{
			"Name": "IDPay Item",
			"Hash": "PayItem-View-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.GUIDPayItem":
		{
			"Name": "GUIDPay Item",
			"Hash": "PayItem-View-GUIDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PayItem-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PayItem-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PayItem-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PayItem-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PayItem-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PayItem-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PayItem-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PayItem-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PayItem-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PayItem-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1196:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetCreateManifest",
	"Scope": "PhysicalAsset-Create",
	"Descriptors":
	{
		"PhysicalAssetDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAsset-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAsset-Create-Identity",
				"Group": "PhysicalAsset-Create-Identity"
			}
		},
		"PhysicalAssetDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAsset-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.OriginLatitude":
		{
			"Name": "Origin Latitude",
			"Hash": "PhysicalAsset-Create-OriginLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.OriginLongitude":
		{
			"Name": "Origin Longitude",
			"Hash": "PhysicalAsset-Create-OriginLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLatitude":
		{
			"Name": "Bounding Min Latitude",
			"Hash": "PhysicalAsset-Create-BoundingMinLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLatitude":
		{
			"Name": "Bounding Max Latitude",
			"Hash": "PhysicalAsset-Create-BoundingMaxLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLongitude":
		{
			"Name": "Bounding Min Longitude",
			"Hash": "PhysicalAsset-Create-BoundingMinLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLongitude":
		{
			"Name": "Bounding Max Longitude",
			"Hash": "PhysicalAsset-Create-BoundingMaxLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.IDAssetClassification":
		{
			"Name": "Asset Classification",
			"Hash": "PhysicalAsset-Create-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "AssetClassification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.IDAssetType":
		{
			"Name": "Asset Type",
			"Hash": "PhysicalAsset-Create-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "AssetType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.ParentIDPhysicalAsset":
		{
			"Name": "Parent Physical Asset",
			"Hash": "PhysicalAsset-Create-ParentIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "PhysicalAsset",
				"SearchFields":
				[
					"Name",
					"Description",
					"AssetNumber"
				]
			}
		},
		"PhysicalAssetDetails.ManifestVersion":
		{
			"Name": "Manifest Version",
			"Hash": "PhysicalAsset-Create-ManifestVersion",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.AssetNumber":
		{
			"Name": "Asset Number",
			"Hash": "PhysicalAsset-Create-AssetNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.YearBuilt":
		{
			"Name": "Year Built",
			"Hash": "PhysicalAsset-Create-YearBuilt",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details"
			}
		},
		"PhysicalAssetDetails.IDFIPSState":
		{
			"Name": "FIPSState",
			"Hash": "PhysicalAsset-Create-IDFIPSState",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "FIPSState",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		},
		"PhysicalAssetDetails.IDFIPSCounty":
		{
			"Name": "FIPSCounty",
			"Hash": "PhysicalAsset-Create-IDFIPSCounty",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Create-Details",
				"Group": "PhysicalAsset-Create-Details",
				"Entity": "FIPSCounty",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAsset-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAsset-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAsset-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAsset-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1197:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetEditManifest",
	"Scope": "PhysicalAsset-Edit",
	"Descriptors":
	{
		"PhysicalAssetDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAsset-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAsset-Edit-Identity",
				"Group": "PhysicalAsset-Edit-Identity"
			}
		},
		"PhysicalAssetDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAsset-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.OriginLatitude":
		{
			"Name": "Origin Latitude",
			"Hash": "PhysicalAsset-Edit-OriginLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.OriginLongitude":
		{
			"Name": "Origin Longitude",
			"Hash": "PhysicalAsset-Edit-OriginLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLatitude":
		{
			"Name": "Bounding Min Latitude",
			"Hash": "PhysicalAsset-Edit-BoundingMinLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLatitude":
		{
			"Name": "Bounding Max Latitude",
			"Hash": "PhysicalAsset-Edit-BoundingMaxLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLongitude":
		{
			"Name": "Bounding Min Longitude",
			"Hash": "PhysicalAsset-Edit-BoundingMinLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLongitude":
		{
			"Name": "Bounding Max Longitude",
			"Hash": "PhysicalAsset-Edit-BoundingMaxLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.IDAssetClassification":
		{
			"Name": "Asset Classification",
			"Hash": "PhysicalAsset-Edit-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "AssetClassification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.IDAssetType":
		{
			"Name": "Asset Type",
			"Hash": "PhysicalAsset-Edit-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "AssetType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"PhysicalAssetDetails.ParentIDPhysicalAsset":
		{
			"Name": "Parent Physical Asset",
			"Hash": "PhysicalAsset-Edit-ParentIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "PhysicalAsset",
				"SearchFields":
				[
					"Name",
					"Description",
					"AssetNumber"
				]
			}
		},
		"PhysicalAssetDetails.ManifestVersion":
		{
			"Name": "Manifest Version",
			"Hash": "PhysicalAsset-Edit-ManifestVersion",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.AssetNumber":
		{
			"Name": "Asset Number",
			"Hash": "PhysicalAsset-Edit-AssetNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.YearBuilt":
		{
			"Name": "Year Built",
			"Hash": "PhysicalAsset-Edit-YearBuilt",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details"
			}
		},
		"PhysicalAssetDetails.IDFIPSState":
		{
			"Name": "FIPSState",
			"Hash": "PhysicalAsset-Edit-IDFIPSState",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "FIPSState",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		},
		"PhysicalAssetDetails.IDFIPSCounty":
		{
			"Name": "FIPSCounty",
			"Hash": "PhysicalAsset-Edit-IDFIPSCounty",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-Details",
				"Group": "PhysicalAsset-Edit-Details",
				"Entity": "FIPSCounty",
				"SearchFields":
				[
					"Code",
					"Name"
				]
			}
		},
		"PhysicalAssetDetails.IDPhysicalAsset":
		{
			"Name": "IDPhysical Asset",
			"Hash": "PhysicalAsset-Edit-IDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.GUIDPhysicalAsset":
		{
			"Name": "GUIDPhysical Asset",
			"Hash": "PhysicalAsset-Edit-GUIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAsset-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAsset-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAsset-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAsset-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-Edit-DataAudit",
				"Group": "PhysicalAsset-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAsset-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAsset-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAsset-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAsset-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAsset-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAsset-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1198:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetViewManifest",
	"Scope": "PhysicalAsset-View",
	"Descriptors":
	{
		"PhysicalAssetDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAsset-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAsset-View-Identity",
				"Group": "PhysicalAsset-View-Identity"
			}
		},
		"PhysicalAssetDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAsset-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.OriginLatitude":
		{
			"Name": "Origin Latitude",
			"Hash": "PhysicalAsset-View-OriginLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.OriginLongitude":
		{
			"Name": "Origin Longitude",
			"Hash": "PhysicalAsset-View-OriginLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLatitude":
		{
			"Name": "Bounding Min Latitude",
			"Hash": "PhysicalAsset-View-BoundingMinLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLatitude":
		{
			"Name": "Bounding Max Latitude",
			"Hash": "PhysicalAsset-View-BoundingMaxLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLongitude":
		{
			"Name": "Bounding Min Longitude",
			"Hash": "PhysicalAsset-View-BoundingMinLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLongitude":
		{
			"Name": "Bounding Max Longitude",
			"Hash": "PhysicalAsset-View-BoundingMaxLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.IDAssetClassification":
		{
			"Name": "Asset Classification",
			"Hash": "PhysicalAsset-View-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "AssetClassification",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.IDAssetType":
		{
			"Name": "Asset Type",
			"Hash": "PhysicalAsset-View-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "AssetType",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.ParentIDPhysicalAsset":
		{
			"Name": "Parent Physical Asset",
			"Hash": "PhysicalAsset-View-ParentIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "PhysicalAsset",
				"SearchFields":
				[
					"Name",
					"Description",
					"AssetNumber"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.ManifestVersion":
		{
			"Name": "Manifest Version",
			"Hash": "PhysicalAsset-View-ManifestVersion",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.AssetNumber":
		{
			"Name": "Asset Number",
			"Hash": "PhysicalAsset-View-AssetNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.YearBuilt":
		{
			"Name": "Year Built",
			"Hash": "PhysicalAsset-View-YearBuilt",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.IDFIPSState":
		{
			"Name": "FIPSState",
			"Hash": "PhysicalAsset-View-IDFIPSState",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "FIPSState",
				"SearchFields":
				[
					"Code",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.IDFIPSCounty":
		{
			"Name": "FIPSCounty",
			"Hash": "PhysicalAsset-View-IDFIPSCounty",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "FIPSCounty",
				"SearchFields":
				[
					"Code",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.IDPhysicalAsset":
		{
			"Name": "IDPhysical Asset",
			"Hash": "PhysicalAsset-View-IDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.GUIDPhysicalAsset":
		{
			"Name": "GUIDPhysical Asset",
			"Hash": "PhysicalAsset-View-GUIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAsset-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAsset-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAsset-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAsset-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAsset-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAsset-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAsset-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAsset-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAsset-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAsset-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1199:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetDefectCreateManifest",
	"Scope": "PhysicalAssetDefect-Create",
	"Descriptors":
	{
		"PhysicalAssetDefectDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetDefect-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Create-Identity",
				"Group": "PhysicalAssetDefect-Create-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetDefect-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-Identity",
				"Group": "PhysicalAssetDefect-Create-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetDefect-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Create-Details",
				"Group": "PhysicalAssetDefect-Create-Details"
			}
		},
		"PhysicalAssetDefectDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "PhysicalAssetDefect-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Create-Details",
				"Group": "PhysicalAssetDefect-Create-Details"
			}
		},
		"PhysicalAssetDefectDetails.PrimaryDocumentationURL":
		{
			"Name": "Primary Documentation URL",
			"Hash": "PhysicalAssetDefect-Create-PrimaryDocumentationURL",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Create-Details",
				"Group": "PhysicalAssetDefect-Create-Details"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS1":
		{
			"Name": "Good (CS1)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS1",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS2":
		{
			"Name": "Fair (CS2)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS2",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS3":
		{
			"Name": "Poor (CS3)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS3",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS4":
		{
			"Name": "Severe (CS4)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS4",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetDefect-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetDefect-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetDefect-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetDefect-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Condition State Descriptions",
			"Hash": "PhysicalAssetDefect-Create-ConditionStates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Condition State Descriptions",
					"Hash": "PhysicalAssetDefect-Create-ConditionStates",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1200:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetDefectEditManifest",
	"Scope": "PhysicalAssetDefect-Edit",
	"Descriptors":
	{
		"PhysicalAssetDefectDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetDefect-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-Identity",
				"Group": "PhysicalAssetDefect-Edit-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetDefect-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-Identity",
				"Group": "PhysicalAssetDefect-Edit-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetDefect-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Edit-Details",
				"Group": "PhysicalAssetDefect-Edit-Details"
			}
		},
		"PhysicalAssetDefectDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "PhysicalAssetDefect-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Edit-Details",
				"Group": "PhysicalAssetDefect-Edit-Details"
			}
		},
		"PhysicalAssetDefectDetails.PrimaryDocumentationURL":
		{
			"Name": "Primary Documentation URL",
			"Hash": "PhysicalAssetDefect-Edit-PrimaryDocumentationURL",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-Details",
				"Group": "PhysicalAssetDefect-Edit-Details"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS1":
		{
			"Name": "Good (CS1)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS1",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS2":
		{
			"Name": "Fair (CS2)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS2",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS3":
		{
			"Name": "Poor (CS3)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS3",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS4":
		{
			"Name": "Severe (CS4)",
			"Hash": "PhysicalAssetDefect-Edit-StateDescriptionCS4",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Edit-ConditionStates",
				"Group": "PhysicalAssetDefect-Edit-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.IDPhysicalAssetDefect":
		{
			"Name": "IDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-Edit-IDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.GUIDPhysicalAssetDefect":
		{
			"Name": "GUIDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-Edit-GUIDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetDefect-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetDefect-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetDefect-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetDefect-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Edit-DataAudit",
				"Group": "PhysicalAssetDefect-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetDefect-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetDefect-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetDefect-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetDefect-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Condition State Descriptions",
			"Hash": "PhysicalAssetDefect-Edit-ConditionStates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Condition State Descriptions",
					"Hash": "PhysicalAssetDefect-Edit-ConditionStates",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetDefect-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetDefect-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1201:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetDefectViewManifest",
	"Scope": "PhysicalAssetDefect-View",
	"Descriptors":
	{
		"PhysicalAssetDefectDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetDefect-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-Identity",
				"Group": "PhysicalAssetDefect-View-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetDefect-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-Identity",
				"Group": "PhysicalAssetDefect-View-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetDefect-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAssetDefect-View-Details",
				"Group": "PhysicalAssetDefect-View-Details"
			}
		},
		"PhysicalAssetDefectDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "PhysicalAssetDefect-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetDefect-View-Details",
				"Group": "PhysicalAssetDefect-View-Details"
			}
		},
		"PhysicalAssetDefectDetails.PrimaryDocumentationURL":
		{
			"Name": "Primary Documentation URL",
			"Hash": "PhysicalAssetDefect-View-PrimaryDocumentationURL",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-Details",
				"Group": "PhysicalAssetDefect-View-Details"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS1":
		{
			"Name": "Good (CS1)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS1",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS2":
		{
			"Name": "Fair (CS2)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS2",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS3":
		{
			"Name": "Poor (CS3)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS3",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS4":
		{
			"Name": "Severe (CS4)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS4",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.IDPhysicalAssetDefect":
		{
			"Name": "IDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-View-IDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.GUIDPhysicalAssetDefect":
		{
			"Name": "GUIDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-View-GUIDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetDefect-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetDefect-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetDefect-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetDefect-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetDefect-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetDefect-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetDefect-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetDefect-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Condition State Descriptions",
			"Hash": "PhysicalAssetDefect-View-ConditionStates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Condition State Descriptions",
					"Hash": "PhysicalAssetDefect-View-ConditionStates",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetDefect-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetDefect-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1202:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetElementTypeCreateManifest",
	"Scope": "PhysicalAssetElementType-Create",
	"Descriptors":
	{
		"PhysicalAssetElementTypeDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetElementType-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Identity",
				"Group": "PhysicalAssetElementType-Create-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.SectionCode":
		{
			"Name": "Section Code",
			"Hash": "PhysicalAssetElementType-Create-SectionCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Identity",
				"Group": "PhysicalAssetElementType-Create-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetElementType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "PhysicalAssetElementType-Create-Identity",
				"Group": "PhysicalAssetElementType-Create-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Section":
		{
			"Name": "Section",
			"Hash": "PhysicalAssetElementType-Create-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Unit":
		{
			"Name": "Unit",
			"Hash": "PhysicalAssetElementType-Create-Unit",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Clarification":
		{
			"Name": "Clarification",
			"Hash": "PhysicalAssetElementType-Create-Clarification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetMaterial":
		{
			"Name": "Physical Asset Material",
			"Hash": "PhysicalAssetElementType-Create-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Create-Details",
				"Group": "PhysicalAssetElementType-Create-Details",
				"Entity": "PhysicalAssetMaterial",
				"SearchFields":
				[
					"Code",
					"Description"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetElementType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetElementType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetElementType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetElementType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1203:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetElementTypeEditManifest",
	"Scope": "PhysicalAssetElementType-Edit",
	"Descriptors":
	{
		"PhysicalAssetElementTypeDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetElementType-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Identity",
				"Group": "PhysicalAssetElementType-Edit-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.SectionCode":
		{
			"Name": "Section Code",
			"Hash": "PhysicalAssetElementType-Edit-SectionCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Identity",
				"Group": "PhysicalAssetElementType-Edit-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetElementType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "PhysicalAssetElementType-Edit-Identity",
				"Group": "PhysicalAssetElementType-Edit-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Section":
		{
			"Name": "Section",
			"Hash": "PhysicalAssetElementType-Edit-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Unit":
		{
			"Name": "Unit",
			"Hash": "PhysicalAssetElementType-Edit-Unit",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Clarification":
		{
			"Name": "Clarification",
			"Hash": "PhysicalAssetElementType-Edit-Clarification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetMaterial":
		{
			"Name": "Physical Asset Material",
			"Hash": "PhysicalAssetElementType-Edit-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details",
				"Entity": "PhysicalAssetMaterial",
				"SearchFields":
				[
					"Code",
					"Description"
				]
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetElementType":
		{
			"Name": "IDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-Edit-IDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.GUIDPhysicalAssetElementType":
		{
			"Name": "GUIDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-Edit-GUIDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetElementType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetElementType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetElementType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetElementType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetElementType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetElementType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetElementType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetElementType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetElementType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetElementType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1204:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetElementTypeViewManifest",
	"Scope": "PhysicalAssetElementType-View",
	"Descriptors":
	{
		"PhysicalAssetElementTypeDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetElementType-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Identity",
				"Group": "PhysicalAssetElementType-View-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.SectionCode":
		{
			"Name": "Section Code",
			"Hash": "PhysicalAssetElementType-View-SectionCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Identity",
				"Group": "PhysicalAssetElementType-View-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetElementType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "PhysicalAssetElementType-View-Identity",
				"Group": "PhysicalAssetElementType-View-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Section":
		{
			"Name": "Section",
			"Hash": "PhysicalAssetElementType-View-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Unit":
		{
			"Name": "Unit",
			"Hash": "PhysicalAssetElementType-View-Unit",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Clarification":
		{
			"Name": "Clarification",
			"Hash": "PhysicalAssetElementType-View-Clarification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetMaterial":
		{
			"Name": "Physical Asset Material",
			"Hash": "PhysicalAssetElementType-View-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details",
				"Entity": "PhysicalAssetMaterial",
				"SearchFields":
				[
					"Code",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetElementType":
		{
			"Name": "IDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-View-IDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.GUIDPhysicalAssetElementType":
		{
			"Name": "GUIDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-View-GUIDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetElementType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetElementType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetElementType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetElementType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetElementType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetElementType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetElementType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetElementType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetElementType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetElementType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1205:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetMaterialCreateManifest",
	"Scope": "PhysicalAssetMaterial-Create",
	"Descriptors":
	{
		"PhysicalAssetMaterialDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetMaterial-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Create-Identity",
				"Group": "PhysicalAssetMaterial-Create-Identity"
			}
		},
		"PhysicalAssetMaterialDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Create-Details",
				"Group": "PhysicalAssetMaterial-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"PhysicalAssetMaterialDetails.Material":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Create-Material",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Create-Details",
				"Group": "PhysicalAssetMaterial-Create-Details"
			}
		},
		"PhysicalAssetMaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetMaterial-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetMaterial-Create-Details",
				"Group": "PhysicalAssetMaterial-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetMaterial-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetMaterial-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetMaterial-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetMaterial-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1206:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetMaterialEditManifest",
	"Scope": "PhysicalAssetMaterial-Edit",
	"Descriptors":
	{
		"PhysicalAssetMaterialDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetMaterial-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-Identity",
				"Group": "PhysicalAssetMaterial-Edit-Identity"
			}
		},
		"PhysicalAssetMaterialDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-Details",
				"Group": "PhysicalAssetMaterial-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"PhysicalAssetMaterialDetails.Material":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Edit-Material",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-Details",
				"Group": "PhysicalAssetMaterial-Edit-Details"
			}
		},
		"PhysicalAssetMaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetMaterial-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetMaterial-Edit-Details",
				"Group": "PhysicalAssetMaterial-Edit-Details"
			}
		},
		"PhysicalAssetMaterialDetails.IDPhysicalAssetMaterial":
		{
			"Name": "IDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-Edit-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.GUIDPhysicalAssetMaterial":
		{
			"Name": "GUIDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-Edit-GUIDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetMaterial-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetMaterial-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetMaterial-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetMaterial-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Edit-DataAudit",
				"Group": "PhysicalAssetMaterial-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetMaterial-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetMaterial-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetMaterial-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetMaterial-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetMaterial-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetMaterial-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1207:[function(require,module,exports){
module.exports={
	"Form": "PhysicalAssetMaterialViewManifest",
	"Scope": "PhysicalAssetMaterial-View",
	"Descriptors":
	{
		"PhysicalAssetMaterialDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetMaterial-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-Identity",
				"Group": "PhysicalAssetMaterial-View-Identity"
			}
		},
		"PhysicalAssetMaterialDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-Details",
				"Group": "PhysicalAssetMaterial-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetMaterialDetails.Material":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-View-Material",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-Details",
				"Group": "PhysicalAssetMaterial-View-Details"
			}
		},
		"PhysicalAssetMaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetMaterial-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetMaterial-View-Details",
				"Group": "PhysicalAssetMaterial-View-Details"
			}
		},
		"PhysicalAssetMaterialDetails.IDPhysicalAssetMaterial":
		{
			"Name": "IDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-View-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.GUIDPhysicalAssetMaterial":
		{
			"Name": "GUIDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-View-GUIDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetMaterial-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetMaterial-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetMaterial-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetMaterial-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetMaterial-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetMaterial-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetMaterial-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetMaterial-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetMaterial-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetMaterial-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1208:[function(require,module,exports){
module.exports={
	"Form": "ProductCreateManifest",
	"Scope": "Product-Create",
	"Descriptors":
	{
		"ProductDetails.Name":
		{
			"Name": "Name",
			"Hash": "Product-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Product-Create-Identity",
				"Group": "Product-Create-Identity"
			}
		},
		"ProductDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Product-Create-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Product-Create-Identity",
				"Group": "Product-Create-Identity"
			}
		},
		"ProductDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Product-Create-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Product-Create-Identity",
				"Group": "Product-Create-Identity"
			}
		},
		"ProductDetails.AcceptanceMethod":
		{
			"Name": "Acceptance Method",
			"Hash": "Product-Create-AcceptanceMethod",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.ProductCategory":
		{
			"Name": "Product Category",
			"Hash": "Product-Create-ProductCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "Product-Create-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "Product-Create-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.Comments":
		{
			"Name": "Comments",
			"Hash": "Product-Create-Comments",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 12,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Product-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"ProductDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Product-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Product-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Product-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Product-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Product-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1209:[function(require,module,exports){
module.exports={
	"Form": "ProductEditManifest",
	"Scope": "Product-Edit",
	"Descriptors":
	{
		"ProductDetails.Name":
		{
			"Name": "Name",
			"Hash": "Product-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Product-Edit-Identity",
				"Group": "Product-Edit-Identity"
			}
		},
		"ProductDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Product-Edit-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Product-Edit-Identity",
				"Group": "Product-Edit-Identity"
			}
		},
		"ProductDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Product-Edit-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Product-Edit-Identity",
				"Group": "Product-Edit-Identity"
			}
		},
		"ProductDetails.AcceptanceMethod":
		{
			"Name": "Acceptance Method",
			"Hash": "Product-Edit-AcceptanceMethod",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.ProductCategory":
		{
			"Name": "Product Category",
			"Hash": "Product-Edit-ProductCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "Product-Edit-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "Product-Edit-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.Comments":
		{
			"Name": "Comments",
			"Hash": "Product-Edit-Comments",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 12,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Product-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"ProductDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Product-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ProductDetails.IDProduct":
		{
			"Name": "IDProduct",
			"Hash": "Product-Edit-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.GUIDProduct":
		{
			"Name": "GUIDProduct",
			"Hash": "Product-Edit-GUIDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Product-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Product-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Product-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Product-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Product-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Product-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Product-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Product-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Product-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Product-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1210:[function(require,module,exports){
module.exports={
	"Form": "ProductViewManifest",
	"Scope": "Product-View",
	"Descriptors":
	{
		"ProductDetails.Name":
		{
			"Name": "Name",
			"Hash": "Product-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Product-View-Identity",
				"Group": "Product-View-Identity"
			}
		},
		"ProductDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Product-View-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Product-View-Identity",
				"Group": "Product-View-Identity"
			}
		},
		"ProductDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Product-View-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Product-View-Identity",
				"Group": "Product-View-Identity"
			}
		},
		"ProductDetails.AcceptanceMethod":
		{
			"Name": "Acceptance Method",
			"Hash": "Product-View-AcceptanceMethod",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.ProductCategory":
		{
			"Name": "Product Category",
			"Hash": "Product-View-ProductCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "Product-View-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "Product-View-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.Comments":
		{
			"Name": "Comments",
			"Hash": "Product-View-Comments",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 12,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details"
			}
		},
		"ProductDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Product-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"ProductDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Product-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-View-Details",
				"Group": "Product-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"ProductDetails.IDProduct":
		{
			"Name": "IDProduct",
			"Hash": "Product-View-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.GUIDProduct":
		{
			"Name": "GUIDProduct",
			"Hash": "Product-View-GUIDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Product-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Product-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Product-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		},
		"ProductDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Product-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-View-DataAudit",
				"Group": "Product-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Product-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Product-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Product-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Product-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Product-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Product-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1211:[function(require,module,exports){
module.exports={
	"Form": "ProductionPlantCreateManifest",
	"Scope": "ProductionPlant-Create",
	"Descriptors":
	{
		"ProductionPlantDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProductionPlant-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProductionPlant-Create-Identity",
				"Group": "ProductionPlant-Create-Identity"
			}
		},
		"ProductionPlantDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "ProductionPlant-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ProductionPlantDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "ProductionPlant-Create-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"ProductionPlantDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "ProductionPlant-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details"
			}
		},
		"ProductionPlantDetails.ExternalProductionPlantID":
		{
			"Name": "External Production Plant ID",
			"Hash": "ProductionPlant-Create-ExternalProductionPlantID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProductionPlant-Create-Details",
				"Group": "ProductionPlant-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProductionPlant-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProductionPlant-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "ProductionPlant-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "ProductionPlant-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1212:[function(require,module,exports){
module.exports={
	"Form": "ProductionPlantEditManifest",
	"Scope": "ProductionPlant-Edit",
	"Descriptors":
	{
		"ProductionPlantDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProductionPlant-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProductionPlant-Edit-Identity",
				"Group": "ProductionPlant-Edit-Identity"
			}
		},
		"ProductionPlantDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "ProductionPlant-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ProductionPlantDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "ProductionPlant-Edit-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"ProductionPlantDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "ProductionPlant-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details"
			}
		},
		"ProductionPlantDetails.ExternalProductionPlantID":
		{
			"Name": "External Production Plant ID",
			"Hash": "ProductionPlant-Edit-ExternalProductionPlantID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details"
			}
		},
		"ProductionPlantDetails.IDProductionPlant":
		{
			"Name": "IDProduction Plant",
			"Hash": "ProductionPlant-Edit-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.GUIDProductionPlant":
		{
			"Name": "GUIDProduction Plant",
			"Hash": "ProductionPlant-Edit-GUIDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProductionPlant-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProductionPlant-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProductionPlant-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProductionPlant-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProductionPlant-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProductionPlant-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "ProductionPlant-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "ProductionPlant-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProductionPlant-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProductionPlant-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1213:[function(require,module,exports){
module.exports={
	"Form": "ProductionPlantViewManifest",
	"Scope": "ProductionPlant-View",
	"Descriptors":
	{
		"ProductionPlantDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProductionPlant-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProductionPlant-View-Identity",
				"Group": "ProductionPlant-View-Identity"
			}
		},
		"ProductionPlantDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "ProductionPlant-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"ProductionPlantDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "ProductionPlant-View-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				],
				"ReadOnly": true
			}
		},
		"ProductionPlantDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "ProductionPlant-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details"
			}
		},
		"ProductionPlantDetails.ExternalProductionPlantID":
		{
			"Name": "External Production Plant ID",
			"Hash": "ProductionPlant-View-ExternalProductionPlantID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details"
			}
		},
		"ProductionPlantDetails.IDProductionPlant":
		{
			"Name": "IDProduction Plant",
			"Hash": "ProductionPlant-View-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.GUIDProductionPlant":
		{
			"Name": "GUIDProduction Plant",
			"Hash": "ProductionPlant-View-GUIDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProductionPlant-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProductionPlant-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProductionPlant-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProductionPlant-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProductionPlant-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProductionPlant-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "ProductionPlant-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "ProductionPlant-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProductionPlant-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProductionPlant-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1214:[function(require,module,exports){
module.exports={
	"Form": "ProjectEditManifest",
	"Scope": "Project-Edit",
	"Descriptors":
	{
		"ProjectDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ProjectEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectEditIdentity",
				"Group": "ProjectEditIdentity"
			}
		},
		"ProjectDetails.GUIDProject":
		{
			"Name": "GUID",
			"Hash": "ProjectEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectEditIdentity",
				"Group": "ProjectEditIdentity"
			}
		},
		"ProjectDetails.Name":
		{
			"Name": "Project Name",
			"Hash": "ProjectEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectEditIdentity",
				"Group": "ProjectEditIdentity"
			}
		},
		"ProjectDetails.Status":
		{
			"Name": "Status",
			"Hash": "ProjectEdit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.ExternalProjectID":
		{
			"Name": "External Project ID",
			"Hash": "ProjectEdit-ExternalID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.IDOrganization":
		{
			"Name": "Prime Contractor",
			"Hash": "ProjectEdit-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Picker",
				"Entity": "Organization",
				"SearchFields": [ "Name", "Type", "City", "State", "VendorCode" ],
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "ProjectEdit-IDContract",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Picker",
				"Entity": "Contract",
				"SearchFields": [ "Name", "Description", "Status", "PrimaryProjectNumber", "ExternalContractID" ],
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.InitialContractAmount":
		{
			"Name": "Initial Contract Amount",
			"Hash": "ProjectEdit-InitialContractAmount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.CostPerDay":
		{
			"Name": "Cost / Day",
			"Hash": "ProjectEdit-CostPerDay",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.OriginalContractedDays":
		{
			"Name": "Original Contracted Days",
			"Hash": "ProjectEdit-OriginalContractedDays",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.ContractedDays":
		{
			"Name": "Contracted Days",
			"Hash": "ProjectEdit-ContractedDays",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectEditDescription",
				"Group": "ProjectEditDescription"
			}
		},
		"ProjectDetails.CustomProperties":
		{
			"Name": "Custom Properties",
			"Hash": "ProjectEdit-CustomProperties",
			"DataType": "Object",
			"PictForm":
			{
				"InputType": "ObjectEditor",
				"Row": "4",
				"Width": 12,
				"Section": "ProjectEditCustomProperties",
				"Group": "ProjectEditCustomProperties"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ProjectEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ProjectEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Schedule & Financials",
			"Hash": "ProjectEditFinancials",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Schedule & Financials",
					"Hash": "ProjectEditFinancials",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Description",
			"Hash": "ProjectEditDescription",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Description",
					"Hash": "ProjectEditDescription",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "ProjectEditCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "ProjectEditCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1215:[function(require,module,exports){
module.exports={
	"Scope": "Project-List",
	"CoreEntity": "Project",
	"TitleTemplate": "Projects",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ProjectListName",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Status",
			"Hash": "ProjectListStatus",
			"PictDashboard":
			{
				"ValueTemplate": "<span class=\"tag has-text-weight-bold {~TIfAbs:PSRS-StatusTag-Success:Record:Record.Payload.Status^==^Active~}{~TIfAbs:PSRS-StatusTag-Info:Record:Record.Payload.Status^==^Pending~}{~TIfAbs:PSRS-StatusTag-Danger:Record:Record.Payload.Status^==^Closed~}\">{~D:Record.Payload.Status~}</span>"
			}
		}
	}
}

},{}],1216:[function(require,module,exports){
module.exports={
	"Form": "ProjectViewManifest",
	"Scope": "Project-View",
	"Descriptors":
	{
		"ProjectDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ProjectView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectIdentity",
				"Group": "ProjectIdentity"
			}
		},
		"ProjectDetails.GUIDProject":
		{
			"Name": "GUID",
			"Hash": "ProjectView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectIdentity",
				"Group": "ProjectIdentity"
			}
		},
		"ProjectDetails.Name":
		{
			"Name": "Project Name",
			"Hash": "ProjectView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectIdentity",
				"Group": "ProjectIdentity"
			}
		},
		"ProjectDetails.Status":
		{
			"Name": "Status",
			"Hash": "ProjectView-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.ExternalProjectID":
		{
			"Name": "External Project ID",
			"Hash": "ProjectView-ExternalID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "ProjectView-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.IDContract":
		{
			"Name": "Contract ID",
			"Hash": "ProjectView-IDContract",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectConfig",
				"Group": "ProjectConfig"
			}
		},
		"ProjectDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectDescription",
				"Group": "ProjectDescription"
			}
		},
		"ProjectDetails.CustomProperties":
		{
			"Name": "Custom Properties (JSON)",
			"Hash": "ProjectView-CustomProperties",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "ProjectCustomProperties",
				"Group": "ProjectCustomProperties"
			}
		},
		"ProjectDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ProjectView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		},
		"ProjectDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ProjectView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		},
		"ProjectDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ProjectView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		},
		"ProjectDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ProjectView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 3,
				"Section": "ProjectAudit",
				"Group": "ProjectAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ProjectConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ProjectConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Description",
			"Hash": "ProjectDescription",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Description",
					"Hash": "ProjectDescription",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "ProjectCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "ProjectCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ProjectAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ProjectAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1217:[function(require,module,exports){
module.exports={
	"Form": "ProjectOfficeCreateManifest",
	"Scope": "ProjectOffice-Create",
	"Descriptors":
	{
		"ProjectOfficeDetails.OfficeCode":
		{
			"Name": "Office Code",
			"Hash": "ProjectOffice-Create-OfficeCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectOffice-Create-Identity",
				"Group": "ProjectOffice-Create-Identity"
			}
		},
		"ProjectOfficeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectOffice-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectOffice-Create-Identity",
				"Group": "ProjectOffice-Create-Identity"
			}
		},
		"ProjectOfficeDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "ProjectOffice-Create-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectOffice-Create-Contact",
				"Group": "ProjectOffice-Create-Contact"
			}
		},
		"ProjectOfficeDetails.Address":
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Create-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		},
		"ProjectOfficeDetails.City":
		{
			"Name": "City",
			"Hash": "ProjectOffice-Create-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		},
		"ProjectOfficeDetails.State":
		{
			"Name": "State",
			"Hash": "ProjectOffice-Create-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		},
		"ProjectOfficeDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "ProjectOffice-Create-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectOffice-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectOffice-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "ProjectOffice-Create-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "ProjectOffice-Create-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Create-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "ProjectOffice-Create-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1218:[function(require,module,exports){
module.exports={
	"Form": "ProjectOfficeEditManifest",
	"Scope": "ProjectOffice-Edit",
	"Descriptors":
	{
		"ProjectOfficeDetails.OfficeCode":
		{
			"Name": "Office Code",
			"Hash": "ProjectOffice-Edit-OfficeCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Identity",
				"Group": "ProjectOffice-Edit-Identity"
			}
		},
		"ProjectOfficeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectOffice-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectOffice-Edit-Identity",
				"Group": "ProjectOffice-Edit-Identity"
			}
		},
		"ProjectOfficeDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "ProjectOffice-Edit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Contact",
				"Group": "ProjectOffice-Edit-Contact"
			}
		},
		"ProjectOfficeDetails.Address":
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Edit-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.City":
		{
			"Name": "City",
			"Hash": "ProjectOffice-Edit-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.State":
		{
			"Name": "State",
			"Hash": "ProjectOffice-Edit-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "ProjectOffice-Edit-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.IDProjectOffice":
		{
			"Name": "IDProject Office",
			"Hash": "ProjectOffice-Edit-IDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.GUIDProjectOffice":
		{
			"Name": "GUIDProject Office",
			"Hash": "ProjectOffice-Edit-GUIDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProjectOffice-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProjectOffice-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProjectOffice-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProjectOffice-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectOffice-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectOffice-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "ProjectOffice-Edit-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "ProjectOffice-Edit-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Edit-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "ProjectOffice-Edit-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProjectOffice-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProjectOffice-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1219:[function(require,module,exports){
module.exports={
	"Form": "ProjectOfficeViewManifest",
	"Scope": "ProjectOffice-View",
	"Descriptors":
	{
		"ProjectOfficeDetails.OfficeCode":
		{
			"Name": "Office Code",
			"Hash": "ProjectOffice-View-OfficeCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectOffice-View-Identity",
				"Group": "ProjectOffice-View-Identity"
			}
		},
		"ProjectOfficeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectOffice-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectOffice-View-Identity",
				"Group": "ProjectOffice-View-Identity"
			}
		},
		"ProjectOfficeDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "ProjectOffice-View-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectOffice-View-Contact",
				"Group": "ProjectOffice-View-Contact"
			}
		},
		"ProjectOfficeDetails.Address":
		{
			"Name": "Address",
			"Hash": "ProjectOffice-View-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.City":
		{
			"Name": "City",
			"Hash": "ProjectOffice-View-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.State":
		{
			"Name": "State",
			"Hash": "ProjectOffice-View-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "ProjectOffice-View-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-View-Address",
				"Group": "ProjectOffice-View-Address"
			}
		},
		"ProjectOfficeDetails.IDProjectOffice":
		{
			"Name": "IDProject Office",
			"Hash": "ProjectOffice-View-IDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.GUIDProjectOffice":
		{
			"Name": "GUIDProject Office",
			"Hash": "ProjectOffice-View-GUIDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProjectOffice-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProjectOffice-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProjectOffice-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProjectOffice-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-View-DataAudit",
				"Group": "ProjectOffice-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectOffice-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectOffice-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "ProjectOffice-View-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "ProjectOffice-View-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "ProjectOffice-View-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "ProjectOffice-View-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProjectOffice-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProjectOffice-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1220:[function(require,module,exports){
module.exports={
	"Form": "ProjectTagTypeEditManifest",
	"Scope": "ProjectTagType-Edit",
	"Descriptors":
	{
		"ProjectTagTypeDetails.IDProjectTagType":
		{
			"Name": "ID",
			"Hash": "PTTEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.GUIDProjectTagType":
		{
			"Name": "GUID",
			"Hash": "PTTEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "PTTEdit-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.Name":
		{
			"Name": "Display Name",
			"Hash": "PTTEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "PTTEditIdentity",
				"Group": "PTTEditIdentity"
			}
		},
		"ProjectTagTypeDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "PTTEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "PTTEditConfig",
				"Group": "PTTEditConfig"
			}
		},
		"ProjectTagTypeDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "PTTEdit-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "PTTEditConfig",
				"Group": "PTTEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PTTEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PTTEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "PTTEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "PTTEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1221:[function(require,module,exports){
module.exports={
	"Scope": "ProjectTagType-List",
	"CoreEntity": "ProjectTagType",
	"TitleTemplate": "Project Tag Types",
	"Descriptors":
	{
		"TagType":
		{
			"Name": "Tag Type",
			"Hash": "PTTListTagType",
			"PictDashboard": {}
		},
		"Name":
		{
			"Name": "Display Name",
			"Hash": "PTTListName",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "PTTListOrdinal",
			"PictDashboard": {}
		},
		"IDProject":
		{
			"Name": "Project ID",
			"Hash": "PTTListIDProject",
			"PictDashboard": {}
		}
	}
}

},{}],1222:[function(require,module,exports){
module.exports={
	"Form": "ProjectTagTypeViewManifest",
	"Scope": "ProjectTagType-View",
	"Descriptors":
	{
		"ProjectTagTypeDetails.IDProjectTagType":
		{
			"Name": "ID",
			"Hash": "PTTView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.GUIDProjectTagType":
		{
			"Name": "GUID",
			"Hash": "PTTView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "PTTView-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.Name":
		{
			"Name": "Display Name",
			"Hash": "PTTView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "PTTView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "PTTConfig",
				"Group": "PTTConfig"
			}
		},
		"ProjectTagTypeDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "PTTView-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "PTTConfig",
				"Group": "PTTConfig"
			}
		},
		"ProjectTagTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "PTTView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "PTTAudit",
				"Group": "PTTAudit"
			}
		},
		"ProjectTagTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "PTTView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "PTTAudit",
				"Group": "PTTAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PTTIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PTTIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "PTTConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "PTTConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "PTTAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "PTTAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1223:[function(require,module,exports){
module.exports={
	"Form": "ProjectTypeEditManifest",
	"Scope": "ProjectType-Edit",
	"Descriptors":
	{
		"ProjectTypeDetails.IDProjectType":
		{
			"Name": "ID",
			"Hash": "ProjectTypeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.GUIDProjectType":
		{
			"Name": "GUID",
			"Hash": "ProjectTypeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectTypeEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ProjectTypeEdit-Hash",
			"DataType": "String",
			"Description": "Stable short code. Referenced by a contract type's allowed-project-types list (via the ContractType AllowedProjectTypes endpoint) and CSV imports.",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectTypeEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Ordinal":
		{
			"Name": "Order",
			"Hash": "ProjectTypeEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 2,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ProjectTypeEdit-AvailableStatusList",
			"DataType": "String",
			"Description": "Lifecycle statuses a project of this type can occupy, in display order. Type a status name and press Enter to add it. The Project Transition form uses this list as the destination-status picker.",
			"PictForm":
			{
				"InputType": "Select2Multiple",
				"AllowCustomValues": true,
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeEditSettings",
				"Group": "ProjectTypeEditSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.StatusesRequiringChangeOrder":
		{
			"Name": "Statuses Requiring Change Order",
			"Hash": "ProjectTypeEdit-StatusesRequiringChangeOrder",
			"DataType": "String",
			"Description": "When a project is in one of these statuses, line-item edits must go through the Change Order flow in Contract Admin. Type a status name and press Enter to add it.",
			"PictForm":
			{
				"InputType": "Select2Multiple",
				"AllowCustomValues": true,
				"Row": "3",
				"Width": 6,
				"Section": "ProjectTypeEditSettings",
				"Group": "ProjectTypeEditSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.DefaultDates":
		{
			"Name": "Default Project Dates",
			"Hash": "ProjectTypeEdit-DefaultDates",
			"DataType": "Array"
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectTypeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectTypeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ProjectTypeEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ProjectTypeEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Default Project Dates",
			"Hash": "ProjectTypeEditDefaultDates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Default Project Dates",
					"Hash": "ProjectTypeEditDefaultDatesGrid",
					"Layout": "Tabular",
					"RecordSetSolvers": [],
					"RecordSetAddress": "ProjectTypeDetails._DisplaySettings.DefaultDates",
					"RecordManifest": "ProjectTypeDefaultDateRow",
					"ShowTitle": false
				}
			]
		}
	],
	"ReferenceManifests":
	{
		"ProjectTypeDefaultDateRow":
		{
			"Scope": "ProjectTypeDefaultDateRow",
			"Descriptors":
			{
				"Hash":
				{
					"Name": "Hash",
					"Hash": "ProjectTypeDefaultDateRowHash",
					"DataType": "String",
					"Description": "Stable short code for the date milestone (e.g. NTP, SUBCMP).",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ProjectTypeEditDefaultDates",
						"Group": "ProjectTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				},
				"Name":
				{
					"Name": "Display Name",
					"Hash": "ProjectTypeDefaultDateRowName",
					"DataType": "String",
					"Description": "Human-readable label shown to users (e.g. 'Notice to Proceed').",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ProjectTypeEditDefaultDates",
						"Group": "ProjectTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				}
			}
		}
	}
}

},{}],1224:[function(require,module,exports){
module.exports={
	"Scope": "ProjectType-List",
	"CoreEntity": "ProjectType",
	"TitleTemplate": "Project Types",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ProjectTypeListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "ProjectTypeListHash",
			"PictDashboard": {}
		},
		"Description":
		{
			"Name": "Description",
			"Hash": "ProjectTypeListDescription",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Order",
			"Hash": "ProjectTypeListOrdinal",
			"PictDashboard": {}
		}
	}
}

},{}],1225:[function(require,module,exports){
module.exports={
	"Form": "ProjectTypeViewManifest",
	"Scope": "ProjectType-View",
	"Descriptors":
	{
		"ProjectTypeDetails.IDProjectType":
		{
			"Name": "ID",
			"Hash": "ProjectTypeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.GUIDProjectType":
		{
			"Name": "GUID",
			"Hash": "ProjectTypeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectTypeView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ProjectTypeView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectTypeView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Ordinal":
		{
			"Name": "Order",
			"Hash": "ProjectTypeView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 2,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ProjectTypeView-AvailableStatusList",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeSettings",
				"Group": "ProjectTypeSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.StatusesRequiringChangeOrder":
		{
			"Name": "Statuses Requiring Change Order",
			"Hash": "ProjectTypeView-StatusesRequiringChangeOrder",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "ProjectTypeSettings",
				"Group": "ProjectTypeSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.DefaultDatesText":
		{
			"Name": "Default Project Dates",
			"Hash": "ProjectTypeView-DefaultDates",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "ProjectTypeSettings",
				"Group": "ProjectTypeSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.PrototypeProjectName":
		{
			"Name": "Prototype Project",
			"Hash": "ProjectTypeView-PrototypeProjectName",
			"DataType": "String",
			"Description": "The canonical prototype project an admin configures for this project type; cloned onto real projects of this type.",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectTypePrototype",
				"Group": "ProjectTypePrototype"
			}
		},
		"ProjectTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ProjectTypeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		},
		"ProjectTypeDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ProjectTypeView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		},
		"ProjectTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ProjectTypeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		},
		"ProjectTypeDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ProjectTypeView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectTypeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectTypeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ProjectTypeSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ProjectTypeSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Prototype Project",
			"Hash": "ProjectTypePrototype",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Prototype Project",
					"Hash": "ProjectTypePrototype",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ProjectTypeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ProjectTypeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1226:[function(require,module,exports){
module.exports={
	"Form": "ReportNamedInstanceEditManifest",
	"Scope": "ReportNamedInstance-Edit",
	"Descriptors":
	{
		"ReportNamedInstanceDetails.IDReportNamedInstance":
		{
			"Name": "ID",
			"Hash": "RNIEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RNIEditIdentity",
				"Group": "RNIEditIdentity"
			}
		},
		"ReportNamedInstanceDetails.GUIDReportNamedInstance":
		{
			"Name": "GUID",
			"Hash": "RNIEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RNIEditIdentity",
				"Group": "RNIEditIdentity"
			}
		},
		"ReportNamedInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "RNIEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "RNIEditIdentity",
				"Group": "RNIEditIdentity"
			}
		},
		"ReportNamedInstanceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "RNIEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "RNIEditConfig",
				"Group": "RNIEditConfig"
			}
		},
		"ReportNamedInstanceDetails.DefaultReport":
		{
			"Name": "Default Report",
			"Hash": "RNIEdit-DefaultReport",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RNIEditConfig",
				"Group": "RNIEditConfig"
			}
		},
		"ReportNamedInstanceDetails.OptionsJSON":
		{
			"Name": "Options (JSON)",
			"Hash": "RNIEdit-Options",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "RNIEditOptions",
				"Group": "RNIEditOptions"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RNIEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RNIEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RNIEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RNIEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Options",
			"Hash": "RNIEditOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Options",
					"Hash": "RNIEditOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1227:[function(require,module,exports){
module.exports={
	"Scope": "ReportNamedInstance-List",
	"CoreEntity": "ReportNamedInstance",
	"TitleTemplate": "Report Named Instances",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "RNIListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "RNIListHash",
			"PictDashboard": {}
		},
		"DefaultReport":
		{
			"Name": "Default",
			"Hash": "RNIListDefault",
			"PictDashboard":
			{
				"ValueTemplate": "<div class=\"has-text-centered\">{~HCS:Record.Payload.DefaultReport~}<span class=\"icon has-text-success\"><i class=\"fas fa-circle-check\"></i></span>{~HCE:Record.Payload.DefaultReport~}{~HCS:Record.Payload.DefaultReport:true~}<span class=\"icon has-text-grey\"><i class=\"fas fa-circle-xmark\"></i></span>{~HCE:Record.Payload.DefaultReport:true~}</div>"
			}
		}
	}
}

},{}],1228:[function(require,module,exports){
module.exports={
	"Form": "ReportNamedInstanceViewManifest",
	"Scope": "ReportNamedInstance-View",
	"Descriptors":
	{
		"ReportNamedInstanceDetails.IDReportNamedInstance":
		{
			"Name": "ID",
			"Hash": "RNIView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RNIIdentity",
				"Group": "RNIIdentity"
			}
		},
		"ReportNamedInstanceDetails.GUIDReportNamedInstance":
		{
			"Name": "GUID",
			"Hash": "RNIView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RNIIdentity",
				"Group": "RNIIdentity"
			}
		},
		"ReportNamedInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "RNIView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "RNIIdentity",
				"Group": "RNIIdentity"
			}
		},
		"ReportNamedInstanceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "RNIView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "RNIConfig",
				"Group": "RNIConfig"
			}
		},
		"ReportNamedInstanceDetails.DefaultReport":
		{
			"Name": "Default Report",
			"Hash": "RNIView-DefaultReport",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RNIConfig",
				"Group": "RNIConfig"
			}
		},
		"ReportNamedInstanceDetails.OptionsJSON":
		{
			"Name": "Options (JSON)",
			"Hash": "RNIView-Options",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "RNIOptions",
				"Group": "RNIOptions"
			}
		},
		"ReportNamedInstanceDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RNIView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		},
		"ReportNamedInstanceDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "RNIView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		},
		"ReportNamedInstanceDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RNIView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		},
		"ReportNamedInstanceDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "RNIView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RNIAudit",
				"Group": "RNIAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RNIIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RNIIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RNIConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RNIConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Options",
			"Hash": "RNIOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Options",
					"Hash": "RNIOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RNIAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RNIAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1229:[function(require,module,exports){
module.exports={
	"Form": "RoleEditManifest",
	"Scope": "Role-Edit",
	"Descriptors":
	{
		"RoleDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RoleEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleEditIdentity",
				"Group": "RoleEditIdentity"
			}
		},
		"RoleDetails.GUIDRole":
		{
			"Name": "GUID",
			"Hash": "RoleEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleEditIdentity",
				"Group": "RoleEditIdentity"
			}
		},
		"RoleDetails.Name":
		{
			"Name": "Role Name",
			"Hash": "RoleEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "RoleEditIdentity",
				"Group": "RoleEditIdentity"
			}
		},
		"RoleDetails.Description":
		{
			"Name": "Description",
			"Hash": "RoleEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		},
		"RoleDetails.PermissionLevel":
		{
			"Name": "Permission Level",
			"Hash": "RoleEdit-PermissionLevel",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		},
		"RoleDetails.Type":
		{
			"Name": "Role Type",
			"Hash": "RoleEdit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 3,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		},
		"RoleDetails.LinkedIDUser":
		{
			"Name": "Linked User ID",
			"Hash": "RoleEdit-LinkedIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RoleEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RoleEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RoleEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RoleEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1230:[function(require,module,exports){
module.exports={
	"Scope": "Role-List",
	"CoreEntity": "Role",
	"TitleTemplate": "Roles",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "RoleListName",
			"PictDashboard": {}
		},
		"PermissionLevel":
		{
			"Name": "Permission Level",
			"Hash": "RoleListPermissionLevel",
			"PictDashboard": {}
		},
		"Type":
		{
			"Name": "Type",
			"Hash": "RoleListType",
			"PictDashboard": {}
		}
	}
}

},{}],1231:[function(require,module,exports){
module.exports={
	"Form": "RoleViewManifest",
	"Scope": "Role-View",
	"Descriptors":
	{
		"RoleDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RoleView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleIdentity",
				"Group": "RoleIdentity"
			}
		},
		"RoleDetails.GUIDRole":
		{
			"Name": "GUID",
			"Hash": "RoleView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleIdentity",
				"Group": "RoleIdentity"
			}
		},
		"RoleDetails.Name":
		{
			"Name": "Role Name",
			"Hash": "RoleView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "RoleIdentity",
				"Group": "RoleIdentity"
			}
		},
		"RoleDetails.Description":
		{
			"Name": "Description",
			"Hash": "RoleView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.PermissionLevel":
		{
			"Name": "Permission Level",
			"Hash": "RoleView-PermissionLevel",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.Type":
		{
			"Name": "Role Type",
			"Hash": "RoleView-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.LinkedIDUser":
		{
			"Name": "Linked User ID",
			"Hash": "RoleView-LinkedIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RoleView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		},
		"RoleDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "RoleView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		},
		"RoleDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RoleView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		},
		"RoleDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "RoleView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RoleIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RoleIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RoleConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RoleConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RoleAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RoleAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1232:[function(require,module,exports){
module.exports={
	"Form": "RoleEdgeEditManifest",
	"Scope": "RoleEdge-Edit",
	"Descriptors":
	{
		"RoleEdgeDetails.IDRoleEdge":
		{
			"Name": "ID",
			"Hash": "RoleEdgeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		},
		"RoleEdgeDetails.GUIDRoleEdge":
		{
			"Name": "GUID",
			"Hash": "RoleEdgeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		},
		"RoleEdgeDetails.ParentIDRole":
		{
			"Name": "Parent Role ID",
			"Hash": "RoleEdgeEdit-ParentIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		},
		"RoleEdgeDetails.ChildIDRole":
		{
			"Name": "Child Role ID",
			"Hash": "RoleEdgeEdit-ChildIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Role Hierarchy",
			"Hash": "RoleEdgeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Role Hierarchy",
					"Hash": "RoleEdgeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1233:[function(require,module,exports){
module.exports={
	"Scope": "RoleEdge-List",
	"CoreEntity": "RoleEdge",
	"TitleTemplate": "Role Edges",
	"Descriptors":
	{
		"ParentIDRole":
		{
			"Name": "Parent Role ID",
			"Hash": "RoleEdgeListParent",
			"PictDashboard": {}
		},
		"ChildIDRole":
		{
			"Name": "Child Role ID",
			"Hash": "RoleEdgeListChild",
			"PictDashboard": {}
		}
	}
}

},{}],1234:[function(require,module,exports){
module.exports={
	"Form": "RoleEdgeViewManifest",
	"Scope": "RoleEdge-View",
	"Descriptors":
	{
		"RoleEdgeDetails.IDRoleEdge":
		{
			"Name": "ID",
			"Hash": "RoleEdgeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.GUIDRoleEdge":
		{
			"Name": "GUID",
			"Hash": "RoleEdgeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.ParentIDRole":
		{
			"Name": "Parent Role ID",
			"Hash": "RoleEdgeView-ParentIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.ChildIDRole":
		{
			"Name": "Child Role ID",
			"Hash": "RoleEdgeView-ChildIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RoleEdgeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "RoleEdgeAudit",
				"Group": "RoleEdgeAudit"
			}
		},
		"RoleEdgeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RoleEdgeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "RoleEdgeAudit",
				"Group": "RoleEdgeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Role Hierarchy",
			"Hash": "RoleEdgeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Role Hierarchy",
					"Hash": "RoleEdgeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RoleEdgeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RoleEdgeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1235:[function(require,module,exports){
module.exports={
	"Form": "RolePermissionEditManifest",
	"Scope": "RolePermission-Edit",
	"Descriptors":
	{
		"RolePermissionDetails.IDRolePermission":
		{
			"Name": "ID",
			"Hash": "RolePermEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RolePermEditIdentity",
				"Group": "RolePermEditIdentity"
			}
		},
		"RolePermissionDetails.GUIDRolePermission":
		{
			"Name": "GUID",
			"Hash": "RolePermEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RolePermEditIdentity",
				"Group": "RolePermEditIdentity"
			}
		},
		"RolePermissionDetails.Hash":
		{
			"Name": "Permission Hash",
			"Hash": "RolePermEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "RolePermEditIdentity",
				"Group": "RolePermEditIdentity"
			}
		},
		"RolePermissionDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RolePermEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		},
		"RolePermissionDetails.Allowed":
		{
			"Name": "Allowed",
			"Hash": "RolePermEdit-Allowed",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		},
		"RolePermissionDetails.Context":
		{
			"Name": "Context",
			"Hash": "RolePermEdit-Context",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		},
		"RolePermissionDetails.IDContext":
		{
			"Name": "Context ID",
			"Hash": "RolePermEdit-IDContext",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermEditConfig",
				"Group": "RolePermEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RolePermEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RolePermEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Permission Configuration",
			"Hash": "RolePermEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Permission Configuration",
					"Hash": "RolePermEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1236:[function(require,module,exports){
module.exports={
	"Scope": "RolePermission-List",
	"CoreEntity": "RolePermission",
	"TitleTemplate": "Role Permissions",
	"Descriptors":
	{
		"Hash":
		{
			"Name": "Permission Hash",
			"Hash": "RolePermListHash",
			"PictDashboard": {}
		},
		"Allowed":
		{
			"Name": "Allowed",
			"Hash": "RolePermListAllowed",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "RolePermListIDRole",
			"PictDashboard": {}
		},
		"Context":
		{
			"Name": "Context",
			"Hash": "RolePermListContext",
			"PictDashboard": {}
		}
	}
}

},{}],1237:[function(require,module,exports){
module.exports={
	"Form": "RolePermissionViewManifest",
	"Scope": "RolePermission-View",
	"Descriptors":
	{
		"RolePermissionDetails.IDRolePermission":
		{
			"Name": "ID",
			"Hash": "RolePermView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RolePermIdentity",
				"Group": "RolePermIdentity"
			}
		},
		"RolePermissionDetails.GUIDRolePermission":
		{
			"Name": "GUID",
			"Hash": "RolePermView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RolePermIdentity",
				"Group": "RolePermIdentity"
			}
		},
		"RolePermissionDetails.Hash":
		{
			"Name": "Permission Hash",
			"Hash": "RolePermView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "RolePermIdentity",
				"Group": "RolePermIdentity"
			}
		},
		"RolePermissionDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RolePermView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.Allowed":
		{
			"Name": "Allowed",
			"Hash": "RolePermView-Allowed",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.Context":
		{
			"Name": "Context",
			"Hash": "RolePermView-Context",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.IDContext":
		{
			"Name": "Context ID",
			"Hash": "RolePermView-IDContext",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RolePermView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "RolePermAudit",
				"Group": "RolePermAudit"
			}
		},
		"RolePermissionDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RolePermView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "RolePermAudit",
				"Group": "RolePermAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RolePermIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RolePermIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Permission Configuration",
			"Hash": "RolePermConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Permission Configuration",
					"Hash": "RolePermConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RolePermAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RolePermAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1238:[function(require,module,exports){
module.exports={
	"Form": "SampleCreateManifest",
	"Scope": "Sample-Create",
	"Descriptors":
	{
		"SampleDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Sample-Create-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Sample-Create-Identity",
				"Group": "Sample-Create-Identity"
			}
		},
		"SampleDetails.Name":
		{
			"Name": "Name",
			"Hash": "Sample-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Sample-Create-Identity",
				"Group": "Sample-Create-Identity"
			}
		},
		"SampleDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Sample-Create-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Sample-Create-Identity",
				"Group": "Sample-Create-Identity"
			}
		},
		"SampleDetails.DesignatedTime":
		{
			"Name": "Designated Time",
			"Hash": "Sample-Create-DesignatedTime",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.CaptureLatitude":
		{
			"Name": "Capture Latitude",
			"Hash": "Sample-Create-CaptureLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.CaptureLongitude":
		{
			"Name": "Capture Longitude",
			"Hash": "Sample-Create-CaptureLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "Sample-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"SampleDetails.ParentIDSample":
		{
			"Name": "Parent Sample",
			"Hash": "Sample-Create-ParentIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"SampleDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Sample-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"SampleDetails.IDProductionPlant":
		{
			"Name": "Production Plant",
			"Hash": "Sample-Create-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "ProductionPlant",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"SampleDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "Sample-Create-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"SampleDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Sample-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 12,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Status":
		{
			"Name": "Status",
			"Hash": "Sample-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.LabControlNumber":
		{
			"Name": "Lab Control Number",
			"Hash": "Sample-Create-LabControlNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.LabReferenceNumber":
		{
			"Name": "Lab Reference Number",
			"Hash": "Sample-Create-LabReferenceNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.ProductName":
		{
			"Name": "Product Name",
			"Hash": "Sample-Create-ProductName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "Sample-Create-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Sample-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"SampleDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Sample-Create-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IntendedUse":
		{
			"Name": "Intended Use",
			"Hash": "Sample-Create-IntendedUse",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.BuyUSA":
		{
			"Name": "Buy USA",
			"Hash": "Sample-Create-BuyUSA",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "9",
				"Width": 3,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.ReceivedFrom":
		{
			"Name": "Received From",
			"Hash": "Sample-Create-ReceivedFrom",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.GeographicalArea":
		{
			"Name": "Geographical Area",
			"Hash": "Sample-Create-GeographicalArea",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Station":
		{
			"Name": "Station",
			"Hash": "Sample-Create-Station",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Offset":
		{
			"Name": "Offset",
			"Hash": "Sample-Create-Offset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.RepresentedQuantity":
		{
			"Name": "Represented Quantity",
			"Hash": "Sample-Create-RepresentedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.SampledQuantity":
		{
			"Name": "Sampled Quantity",
			"Hash": "Sample-Create-SampledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.SampledQuantityUnits":
		{
			"Name": "Sampled Quantity Units",
			"Hash": "Sample-Create-SampledQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.RepresentedQuantityUnits":
		{
			"Name": "Represented Quantity Units",
			"Hash": "Sample-Create-RepresentedQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Units":
		{
			"Name": "Units",
			"Hash": "Sample-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.RequestedBy":
		{
			"Name": "Requested By",
			"Hash": "Sample-Create-RequestedBy",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.IDSampleType":
		{
			"Name": "Sample Type",
			"Hash": "Sample-Create-IDSampleType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "SampleType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IDProduct":
		{
			"Name": "Product",
			"Hash": "Sample-Create-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details",
				"Entity": "Product",
				"SearchFields":
				[
					"Name",
					"ManufacturerCode",
					"CatalogCode"
				]
			}
		},
		"SampleDetails.SampledByIDUser":
		{
			"Name": "Sampled By IDUser",
			"Hash": "Sample-Create-SampledByIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.WitnessIDUser":
		{
			"Name": "Witness IDUser",
			"Hash": "Sample-Create-WitnessIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.AuthorizedIDUser":
		{
			"Name": "Authorized IDUser",
			"Hash": "Sample-Create-AuthorizedIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.CMSIDUser":
		{
			"Name": "CMSIDUser",
			"Hash": "Sample-Create-CMSIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Datum":
		{
			"Name": "Datum",
			"Hash": "Sample-Create-Datum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Locked":
		{
			"Name": "Locked",
			"Hash": "Sample-Create-Locked",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "15",
				"Width": 3,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		},
		"SampleDetails.Sequenced":
		{
			"Name": "Sequenced",
			"Hash": "Sample-Create-Sequenced",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "16",
				"Width": 3,
				"Section": "Sample-Create-Details",
				"Group": "Sample-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Sample-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Sample-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Sample-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Sample-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1239:[function(require,module,exports){
module.exports={
	"Form": "SampleEditManifest",
	"Scope": "Sample-Edit",
	"Descriptors":
	{
		"SampleDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Sample-Edit-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Sample-Edit-Identity",
				"Group": "Sample-Edit-Identity"
			}
		},
		"SampleDetails.Name":
		{
			"Name": "Name",
			"Hash": "Sample-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Sample-Edit-Identity",
				"Group": "Sample-Edit-Identity"
			}
		},
		"SampleDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Sample-Edit-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Sample-Edit-Identity",
				"Group": "Sample-Edit-Identity"
			}
		},
		"SampleDetails.DesignatedTime":
		{
			"Name": "Designated Time",
			"Hash": "Sample-Edit-DesignatedTime",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.CaptureLatitude":
		{
			"Name": "Capture Latitude",
			"Hash": "Sample-Edit-CaptureLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.CaptureLongitude":
		{
			"Name": "Capture Longitude",
			"Hash": "Sample-Edit-CaptureLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "Sample-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"SampleDetails.ParentIDSample":
		{
			"Name": "Parent Sample",
			"Hash": "Sample-Edit-ParentIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"SampleDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Sample-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"SampleDetails.IDProductionPlant":
		{
			"Name": "Production Plant",
			"Hash": "Sample-Edit-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "ProductionPlant",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"SampleDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "Sample-Edit-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"SampleDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Sample-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 12,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Status":
		{
			"Name": "Status",
			"Hash": "Sample-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.LabControlNumber":
		{
			"Name": "Lab Control Number",
			"Hash": "Sample-Edit-LabControlNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.LabReferenceNumber":
		{
			"Name": "Lab Reference Number",
			"Hash": "Sample-Edit-LabReferenceNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.ProductName":
		{
			"Name": "Product Name",
			"Hash": "Sample-Edit-ProductName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "Sample-Edit-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Sample-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"SampleDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Sample-Edit-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IntendedUse":
		{
			"Name": "Intended Use",
			"Hash": "Sample-Edit-IntendedUse",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.BuyUSA":
		{
			"Name": "Buy USA",
			"Hash": "Sample-Edit-BuyUSA",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "9",
				"Width": 3,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.ReceivedFrom":
		{
			"Name": "Received From",
			"Hash": "Sample-Edit-ReceivedFrom",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.GeographicalArea":
		{
			"Name": "Geographical Area",
			"Hash": "Sample-Edit-GeographicalArea",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Station":
		{
			"Name": "Station",
			"Hash": "Sample-Edit-Station",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Offset":
		{
			"Name": "Offset",
			"Hash": "Sample-Edit-Offset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.RepresentedQuantity":
		{
			"Name": "Represented Quantity",
			"Hash": "Sample-Edit-RepresentedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.SampledQuantity":
		{
			"Name": "Sampled Quantity",
			"Hash": "Sample-Edit-SampledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.SampledQuantityUnits":
		{
			"Name": "Sampled Quantity Units",
			"Hash": "Sample-Edit-SampledQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.RepresentedQuantityUnits":
		{
			"Name": "Represented Quantity Units",
			"Hash": "Sample-Edit-RepresentedQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Units":
		{
			"Name": "Units",
			"Hash": "Sample-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.RequestedBy":
		{
			"Name": "Requested By",
			"Hash": "Sample-Edit-RequestedBy",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDSampleType":
		{
			"Name": "Sample Type",
			"Hash": "Sample-Edit-IDSampleType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "SampleType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IDProduct":
		{
			"Name": "Product",
			"Hash": "Sample-Edit-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Product",
				"SearchFields":
				[
					"Name",
					"ManufacturerCode",
					"CatalogCode"
				]
			}
		},
		"SampleDetails.SampledByIDUser":
		{
			"Name": "Sampled By IDUser",
			"Hash": "Sample-Edit-SampledByIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.WitnessIDUser":
		{
			"Name": "Witness IDUser",
			"Hash": "Sample-Edit-WitnessIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.AuthorizedIDUser":
		{
			"Name": "Authorized IDUser",
			"Hash": "Sample-Edit-AuthorizedIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.CMSIDUser":
		{
			"Name": "CMSIDUser",
			"Hash": "Sample-Edit-CMSIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Datum":
		{
			"Name": "Datum",
			"Hash": "Sample-Edit-Datum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Locked":
		{
			"Name": "Locked",
			"Hash": "Sample-Edit-Locked",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "15",
				"Width": 3,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Sequenced":
		{
			"Name": "Sequenced",
			"Hash": "Sample-Edit-Sequenced",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "16",
				"Width": 3,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDSample":
		{
			"Name": "IDSample",
			"Hash": "Sample-Edit-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.GUIDSample":
		{
			"Name": "GUIDSample",
			"Hash": "Sample-Edit-GUIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Sample-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Sample-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Sample-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Sample-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Sample-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Sample-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Sample-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Sample-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Sample-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Sample-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1240:[function(require,module,exports){
module.exports={
	"Form": "SampleViewManifest",
	"Scope": "Sample-View",
	"Descriptors":
	{
		"SampleDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Sample-View-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Sample-View-Identity",
				"Group": "Sample-View-Identity"
			}
		},
		"SampleDetails.Name":
		{
			"Name": "Name",
			"Hash": "Sample-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Sample-View-Identity",
				"Group": "Sample-View-Identity"
			}
		},
		"SampleDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Sample-View-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Sample-View-Identity",
				"Group": "Sample-View-Identity"
			}
		},
		"SampleDetails.DesignatedTime":
		{
			"Name": "Designated Time",
			"Hash": "Sample-View-DesignatedTime",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.CaptureLatitude":
		{
			"Name": "Capture Latitude",
			"Hash": "Sample-View-CaptureLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.CaptureLongitude":
		{
			"Name": "Capture Longitude",
			"Hash": "Sample-View-CaptureLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "Sample-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.ParentIDSample":
		{
			"Name": "Parent Sample",
			"Hash": "Sample-View-ParentIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Sample-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDProductionPlant":
		{
			"Name": "Production Plant",
			"Hash": "Sample-View-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "ProductionPlant",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "Sample-View-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Sample-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 12,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Status":
		{
			"Name": "Status",
			"Hash": "Sample-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.LabControlNumber":
		{
			"Name": "Lab Control Number",
			"Hash": "Sample-View-LabControlNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.LabReferenceNumber":
		{
			"Name": "Lab Reference Number",
			"Hash": "Sample-View-LabReferenceNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.ProductName":
		{
			"Name": "Product Name",
			"Hash": "Sample-View-ProductName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "Sample-View-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Sample-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Sample-View-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IntendedUse":
		{
			"Name": "Intended Use",
			"Hash": "Sample-View-IntendedUse",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.BuyUSA":
		{
			"Name": "Buy USA",
			"Hash": "Sample-View-BuyUSA",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "9",
				"Width": 3,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.ReceivedFrom":
		{
			"Name": "Received From",
			"Hash": "Sample-View-ReceivedFrom",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.GeographicalArea":
		{
			"Name": "Geographical Area",
			"Hash": "Sample-View-GeographicalArea",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Station":
		{
			"Name": "Station",
			"Hash": "Sample-View-Station",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Offset":
		{
			"Name": "Offset",
			"Hash": "Sample-View-Offset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.RepresentedQuantity":
		{
			"Name": "Represented Quantity",
			"Hash": "Sample-View-RepresentedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.SampledQuantity":
		{
			"Name": "Sampled Quantity",
			"Hash": "Sample-View-SampledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.SampledQuantityUnits":
		{
			"Name": "Sampled Quantity Units",
			"Hash": "Sample-View-SampledQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.RepresentedQuantityUnits":
		{
			"Name": "Represented Quantity Units",
			"Hash": "Sample-View-RepresentedQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Units":
		{
			"Name": "Units",
			"Hash": "Sample-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.RequestedBy":
		{
			"Name": "Requested By",
			"Hash": "Sample-View-RequestedBy",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDSampleType":
		{
			"Name": "Sample Type",
			"Hash": "Sample-View-IDSampleType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "SampleType",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.IDProduct":
		{
			"Name": "Product",
			"Hash": "Sample-View-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details",
				"Entity": "Product",
				"SearchFields":
				[
					"Name",
					"ManufacturerCode",
					"CatalogCode"
				],
				"ReadOnly": true
			}
		},
		"SampleDetails.SampledByIDUser":
		{
			"Name": "Sampled By IDUser",
			"Hash": "Sample-View-SampledByIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.WitnessIDUser":
		{
			"Name": "Witness IDUser",
			"Hash": "Sample-View-WitnessIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.AuthorizedIDUser":
		{
			"Name": "Authorized IDUser",
			"Hash": "Sample-View-AuthorizedIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.CMSIDUser":
		{
			"Name": "CMSIDUser",
			"Hash": "Sample-View-CMSIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Datum":
		{
			"Name": "Datum",
			"Hash": "Sample-View-Datum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Locked":
		{
			"Name": "Locked",
			"Hash": "Sample-View-Locked",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "15",
				"Width": 3,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.Sequenced":
		{
			"Name": "Sequenced",
			"Hash": "Sample-View-Sequenced",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "16",
				"Width": 3,
				"Section": "Sample-View-Details",
				"Group": "Sample-View-Details"
			}
		},
		"SampleDetails.IDSample":
		{
			"Name": "IDSample",
			"Hash": "Sample-View-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.GUIDSample":
		{
			"Name": "GUIDSample",
			"Hash": "Sample-View-GUIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Sample-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Sample-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Sample-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		},
		"SampleDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Sample-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-View-DataAudit",
				"Group": "Sample-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Sample-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Sample-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Sample-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Sample-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Sample-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Sample-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1241:[function(require,module,exports){
module.exports={
	"Form": "SampleStatusCreateManifest",
	"Scope": "SampleStatus-Create",
	"Descriptors":
	{
		"SampleStatusDetails.Name":
		{
			"Name": "Name",
			"Hash": "SampleStatus-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "SampleStatus-Create-Identity",
				"Group": "SampleStatus-Create-Identity"
			}
		},
		"SampleStatusDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "SampleStatus-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		},
		"SampleStatusDetails.Description":
		{
			"Name": "Description",
			"Hash": "SampleStatus-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		},
		"SampleStatusDetails.Category":
		{
			"Name": "Category",
			"Hash": "SampleStatus-Create-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		},
		"SampleStatusDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "SampleStatus-Create-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "SampleStatus-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "SampleStatus-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "SampleStatus-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "SampleStatus-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1242:[function(require,module,exports){
module.exports={
	"Form": "SampleStatusEditManifest",
	"Scope": "SampleStatus-Edit",
	"Descriptors":
	{
		"SampleStatusDetails.Name":
		{
			"Name": "Name",
			"Hash": "SampleStatus-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "SampleStatus-Edit-Identity",
				"Group": "SampleStatus-Edit-Identity"
			}
		},
		"SampleStatusDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "SampleStatus-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.Description":
		{
			"Name": "Description",
			"Hash": "SampleStatus-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.Category":
		{
			"Name": "Category",
			"Hash": "SampleStatus-Edit-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "SampleStatus-Edit-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.IDSampleStatus":
		{
			"Name": "IDSample Status",
			"Hash": "SampleStatus-Edit-IDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.GUIDSampleStatus":
		{
			"Name": "GUIDSample Status",
			"Hash": "SampleStatus-Edit-GUIDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "SampleStatus-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "SampleStatus-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "SampleStatus-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "SampleStatus-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "SampleStatus-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "SampleStatus-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "SampleStatus-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "SampleStatus-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "SampleStatus-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "SampleStatus-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1243:[function(require,module,exports){
module.exports={
	"Form": "SampleStatusViewManifest",
	"Scope": "SampleStatus-View",
	"Descriptors":
	{
		"SampleStatusDetails.Name":
		{
			"Name": "Name",
			"Hash": "SampleStatus-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "SampleStatus-View-Identity",
				"Group": "SampleStatus-View-Identity"
			}
		},
		"SampleStatusDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "SampleStatus-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.Description":
		{
			"Name": "Description",
			"Hash": "SampleStatus-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.Category":
		{
			"Name": "Category",
			"Hash": "SampleStatus-View-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "SampleStatus-View-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-View-Details",
				"Group": "SampleStatus-View-Details"
			}
		},
		"SampleStatusDetails.IDSampleStatus":
		{
			"Name": "IDSample Status",
			"Hash": "SampleStatus-View-IDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.GUIDSampleStatus":
		{
			"Name": "GUIDSample Status",
			"Hash": "SampleStatus-View-GUIDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "SampleStatus-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "SampleStatus-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "SampleStatus-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		},
		"SampleStatusDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "SampleStatus-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-View-DataAudit",
				"Group": "SampleStatus-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "SampleStatus-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "SampleStatus-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "SampleStatus-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "SampleStatus-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "SampleStatus-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "SampleStatus-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1244:[function(require,module,exports){
module.exports={
	"Form": "TeamCreateManifest",
	"Scope": "Team-Create",
	"Descriptors":
	{
		"TeamDetails.Name":
		{
			"Name": "Name",
			"Hash": "Team-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Team-Create-Identity",
				"Group": "Team-Create-Identity"
			}
		},
		"TeamDetails.Description":
		{
			"Name": "Description",
			"Hash": "Team-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Team-Create-Details",
				"Group": "Team-Create-Details"
			}
		},
		"TeamDetails.ParentIDTeam":
		{
			"Name": "Parent Team",
			"Hash": "Team-Create-ParentIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Team-Create-Details",
				"Group": "Team-Create-Details",
				"Entity": "Team",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Team-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Team-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Team-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Team-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1245:[function(require,module,exports){
module.exports={
	"Form": "TeamEditManifest",
	"Scope": "Team-Edit",
	"Descriptors":
	{
		"TeamDetails.Name":
		{
			"Name": "Name",
			"Hash": "Team-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Team-Edit-Identity",
				"Group": "Team-Edit-Identity"
			}
		},
		"TeamDetails.Description":
		{
			"Name": "Description",
			"Hash": "Team-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Team-Edit-Details",
				"Group": "Team-Edit-Details"
			}
		},
		"TeamDetails.ParentIDTeam":
		{
			"Name": "Parent Team",
			"Hash": "Team-Edit-ParentIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Team-Edit-Details",
				"Group": "Team-Edit-Details",
				"Entity": "Team",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TeamDetails.IDTeam":
		{
			"Name": "IDTeam",
			"Hash": "Team-Edit-IDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.GUIDTeam":
		{
			"Name": "GUIDTeam",
			"Hash": "Team-Edit-GUIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Team-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Team-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Team-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Team-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Team-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Team-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Team-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Team-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Team-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Team-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1246:[function(require,module,exports){
module.exports={
	"Form": "TeamViewManifest",
	"Scope": "Team-View",
	"Descriptors":
	{
		"TeamDetails.Name":
		{
			"Name": "Name",
			"Hash": "Team-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Team-View-Identity",
				"Group": "Team-View-Identity"
			}
		},
		"TeamDetails.Description":
		{
			"Name": "Description",
			"Hash": "Team-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "Team-View-Details",
				"Group": "Team-View-Details"
			}
		},
		"TeamDetails.ParentIDTeam":
		{
			"Name": "Parent Team",
			"Hash": "Team-View-ParentIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Team-View-Details",
				"Group": "Team-View-Details",
				"Entity": "Team",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TeamDetails.IDTeam":
		{
			"Name": "IDTeam",
			"Hash": "Team-View-IDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.GUIDTeam":
		{
			"Name": "GUIDTeam",
			"Hash": "Team-View-GUIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Team-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Team-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Team-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		},
		"TeamDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Team-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-View-DataAudit",
				"Group": "Team-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Team-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Team-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Team-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Team-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Team-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Team-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1247:[function(require,module,exports){
module.exports={
	"Form": "TestCreateManifest",
	"Scope": "Test-Create",
	"Descriptors":
	{
		"TestDetails.Name":
		{
			"Name": "Name",
			"Hash": "Test-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Test-Create-Identity",
				"Group": "Test-Create-Identity"
			}
		},
		"TestDetails.Description":
		{
			"Name": "Description",
			"Hash": "Test-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Test-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Test-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Active":
		{
			"Name": "Active",
			"Hash": "Test-Create-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Standalone":
		{
			"Name": "Standalone",
			"Hash": "Test-Create-Standalone",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Injectable":
		{
			"Name": "Injectable",
			"Hash": "Test-Create-Injectable",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.Collection":
		{
			"Name": "Collection",
			"Hash": "Test-Create-Collection",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		},
		"TestDetails.SmallQuantityExempt":
		{
			"Name": "Small Quantity Exempt",
			"Hash": "Test-Create-SmallQuantityExempt",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Test-Create-Details",
				"Group": "Test-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Test-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Test-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Test-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Test-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1248:[function(require,module,exports){
module.exports={
	"Form": "TestEditManifest",
	"Scope": "Test-Edit",
	"Descriptors":
	{
		"TestDetails.Name":
		{
			"Name": "Name",
			"Hash": "Test-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Test-Edit-Identity",
				"Group": "Test-Edit-Identity"
			}
		},
		"TestDetails.Description":
		{
			"Name": "Description",
			"Hash": "Test-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Test-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Test-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Active":
		{
			"Name": "Active",
			"Hash": "Test-Edit-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Standalone":
		{
			"Name": "Standalone",
			"Hash": "Test-Edit-Standalone",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Injectable":
		{
			"Name": "Injectable",
			"Hash": "Test-Edit-Injectable",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.Collection":
		{
			"Name": "Collection",
			"Hash": "Test-Edit-Collection",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.SmallQuantityExempt":
		{
			"Name": "Small Quantity Exempt",
			"Hash": "Test-Edit-SmallQuantityExempt",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Test-Edit-Details",
				"Group": "Test-Edit-Details"
			}
		},
		"TestDetails.IDTest":
		{
			"Name": "IDTest",
			"Hash": "Test-Edit-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.GUIDTest":
		{
			"Name": "GUIDTest",
			"Hash": "Test-Edit-GUIDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Test-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Test-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Test-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		},
		"TestDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Test-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-Edit-DataAudit",
				"Group": "Test-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Test-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Test-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Test-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Test-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Test-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Test-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1249:[function(require,module,exports){
module.exports={
	"Form": "TestViewManifest",
	"Scope": "Test-View",
	"Descriptors":
	{
		"TestDetails.Name":
		{
			"Name": "Name",
			"Hash": "Test-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Test-View-Identity",
				"Group": "Test-View-Identity"
			}
		},
		"TestDetails.Description":
		{
			"Name": "Description",
			"Hash": "Test-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Test-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Test-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Active":
		{
			"Name": "Active",
			"Hash": "Test-View-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Standalone":
		{
			"Name": "Standalone",
			"Hash": "Test-View-Standalone",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Injectable":
		{
			"Name": "Injectable",
			"Hash": "Test-View-Injectable",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.Collection":
		{
			"Name": "Collection",
			"Hash": "Test-View-Collection",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.SmallQuantityExempt":
		{
			"Name": "Small Quantity Exempt",
			"Hash": "Test-View-SmallQuantityExempt",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Test-View-Details",
				"Group": "Test-View-Details"
			}
		},
		"TestDetails.IDTest":
		{
			"Name": "IDTest",
			"Hash": "Test-View-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.GUIDTest":
		{
			"Name": "GUIDTest",
			"Hash": "Test-View-GUIDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Test-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Test-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Test-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		},
		"TestDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Test-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Test-View-DataAudit",
				"Group": "Test-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Test-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Test-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Test-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Test-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Test-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Test-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1250:[function(require,module,exports){
module.exports={
	"Form": "TestInstanceCreateManifest",
	"Scope": "TestInstance-Create",
	"Descriptors":
	{
		"TestInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestInstance-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestInstance-Create-Identity",
				"Group": "TestInstance-Create-Identity"
			}
		},
		"TestInstanceDetails.IDTestPlan":
		{
			"Name": "Test Plan",
			"Hash": "TestInstance-Create-IDTestPlan",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "TestPlan",
				"SearchFields":
				[
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestInstance-Create-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLab":
		{
			"Name": "Lab",
			"Hash": "TestInstance-Create-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestInstanceDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "TestInstance-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"TestInstanceDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "TestInstance-Create-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "TestInstance-Create-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"TestInstanceDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "TestInstance-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "TestInstance-Create-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.EstimatedCompletionDate":
		{
			"Name": "Estimated Completion Date",
			"Hash": "TestInstance-Create-EstimatedCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.ActualCompletionDate":
		{
			"Name": "Actual Completion Date",
			"Hash": "TestInstance-Create-ActualCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.Status":
		{
			"Name": "Status",
			"Hash": "TestInstance-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.StatusMessage":
		{
			"Name": "Status Message",
			"Hash": "TestInstance-Create-StatusMessage",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.SampleTestNumber":
		{
			"Name": "Sample Test Number",
			"Hash": "TestInstance-Create-SampleTestNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		},
		"TestInstanceDetails.TestResult":
		{
			"Name": "Test Result",
			"Hash": "TestInstance-Create-TestResult",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "TestInstance-Create-Details",
				"Group": "TestInstance-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestInstance-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestInstance-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestInstance-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestInstance-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1251:[function(require,module,exports){
module.exports={
	"Form": "TestInstanceEditManifest",
	"Scope": "TestInstance-Edit",
	"Descriptors":
	{
		"TestInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestInstance-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestInstance-Edit-Identity",
				"Group": "TestInstance-Edit-Identity"
			}
		},
		"TestInstanceDetails.IDTestPlan":
		{
			"Name": "Test Plan",
			"Hash": "TestInstance-Edit-IDTestPlan",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "TestPlan",
				"SearchFields":
				[
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestInstance-Edit-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLab":
		{
			"Name": "Lab",
			"Hash": "TestInstance-Edit-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestInstanceDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "TestInstance-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"TestInstanceDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "TestInstance-Edit-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "TestInstance-Edit-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"TestInstanceDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "TestInstance-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "TestInstance-Edit-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.EstimatedCompletionDate":
		{
			"Name": "Estimated Completion Date",
			"Hash": "TestInstance-Edit-EstimatedCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.ActualCompletionDate":
		{
			"Name": "Actual Completion Date",
			"Hash": "TestInstance-Edit-ActualCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.Status":
		{
			"Name": "Status",
			"Hash": "TestInstance-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.StatusMessage":
		{
			"Name": "Status Message",
			"Hash": "TestInstance-Edit-StatusMessage",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.SampleTestNumber":
		{
			"Name": "Sample Test Number",
			"Hash": "TestInstance-Edit-SampleTestNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.TestResult":
		{
			"Name": "Test Result",
			"Hash": "TestInstance-Edit-TestResult",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.IDTestInstance":
		{
			"Name": "IDTest Instance",
			"Hash": "TestInstance-Edit-IDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.GUIDTestInstance":
		{
			"Name": "GUIDTest Instance",
			"Hash": "TestInstance-Edit-GUIDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestInstance-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestInstance-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestInstance-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestInstance-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestInstance-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestInstance-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestInstance-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestInstance-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestInstance-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestInstance-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1252:[function(require,module,exports){
module.exports={
	"Form": "TestInstanceViewManifest",
	"Scope": "TestInstance-View",
	"Descriptors":
	{
		"TestInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestInstance-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestInstance-View-Identity",
				"Group": "TestInstance-View-Identity"
			}
		},
		"TestInstanceDetails.IDTestPlan":
		{
			"Name": "Test Plan",
			"Hash": "TestInstance-View-IDTestPlan",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "TestPlan",
				"SearchFields":
				[
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestInstance-View-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDLab":
		{
			"Name": "Lab",
			"Hash": "TestInstance-View-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "TestInstance-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "TestInstance-View-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "TestInstance-View-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "TestInstance-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "TestInstance-View-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.EstimatedCompletionDate":
		{
			"Name": "Estimated Completion Date",
			"Hash": "TestInstance-View-EstimatedCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.ActualCompletionDate":
		{
			"Name": "Actual Completion Date",
			"Hash": "TestInstance-View-ActualCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.Status":
		{
			"Name": "Status",
			"Hash": "TestInstance-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.StatusMessage":
		{
			"Name": "Status Message",
			"Hash": "TestInstance-View-StatusMessage",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.SampleTestNumber":
		{
			"Name": "Sample Test Number",
			"Hash": "TestInstance-View-SampleTestNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.TestResult":
		{
			"Name": "Test Result",
			"Hash": "TestInstance-View-TestResult",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.IDTestInstance":
		{
			"Name": "IDTest Instance",
			"Hash": "TestInstance-View-IDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.GUIDTestInstance":
		{
			"Name": "GUIDTest Instance",
			"Hash": "TestInstance-View-GUIDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestInstance-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestInstance-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestInstance-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestInstance-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestInstance-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestInstance-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestInstance-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestInstance-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestInstance-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestInstance-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1253:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationCreateManifest",
	"Scope": "TestSpecification-Create",
	"Descriptors":
	{
		"TestSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecification-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecification-Create-Identity",
				"Group": "TestSpecification-Create-Identity"
			}
		},
		"TestSpecificationDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "TestSpecification-Create-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecification-Create-Details",
				"Group": "TestSpecification-Create-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "TestSpecification-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "TestSpecification-Create-Details",
				"Group": "TestSpecification-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecification-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecification-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecification-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecification-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1254:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationEditManifest",
	"Scope": "TestSpecification-Edit",
	"Descriptors":
	{
		"TestSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecification-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecification-Edit-Identity",
				"Group": "TestSpecification-Edit-Identity"
			}
		},
		"TestSpecificationDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "TestSpecification-Edit-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecification-Edit-Details",
				"Group": "TestSpecification-Edit-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "TestSpecification-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "TestSpecification-Edit-Details",
				"Group": "TestSpecification-Edit-Details"
			}
		},
		"TestSpecificationDetails.IDTestSpecification":
		{
			"Name": "IDTest Specification",
			"Hash": "TestSpecification-Edit-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.GUIDTestSpecification":
		{
			"Name": "GUIDTest Specification",
			"Hash": "TestSpecification-Edit-GUIDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecification-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecification-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecification-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecification-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecification-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecification-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecification-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecification-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecification-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecification-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1255:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationViewManifest",
	"Scope": "TestSpecification-View",
	"Descriptors":
	{
		"TestSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecification-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecification-View-Identity",
				"Group": "TestSpecification-View-Identity"
			}
		},
		"TestSpecificationDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "TestSpecification-View-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecification-View-Details",
				"Group": "TestSpecification-View-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"TestSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "TestSpecification-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "TestSpecification-View-Details",
				"Group": "TestSpecification-View-Details"
			}
		},
		"TestSpecificationDetails.IDTestSpecification":
		{
			"Name": "IDTest Specification",
			"Hash": "TestSpecification-View-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.GUIDTestSpecification":
		{
			"Name": "GUIDTest Specification",
			"Hash": "TestSpecification-View-GUIDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecification-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecification-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecification-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecification-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecification-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecification-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecification-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecification-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecification-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecification-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1256:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationRequirementCreateManifest",
	"Scope": "TestSpecificationRequirement-Create",
	"Descriptors":
	{
		"TestSpecificationRequirementDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationRequirement-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationRequirement-Create-Identity",
				"Group": "TestSpecificationRequirement-Create-Identity"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecification":
		{
			"Name": "Test Specification",
			"Hash": "TestSpecificationRequirement-Create-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details",
				"Entity": "TestSpecification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestSpecificationRequirement-Create-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "TestSpecificationRequirement-Create-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.OperationType":
		{
			"Name": "Operation Type",
			"Hash": "TestSpecificationRequirement-Create-OperationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMinimum":
		{
			"Name": "Value Minimum",
			"Hash": "TestSpecificationRequirement-Create-ValueMinimum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMaximum":
		{
			"Name": "Value Maximum",
			"Hash": "TestSpecificationRequirement-Create-ValueMaximum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationTemplate":
		{
			"Name": "Computation Template",
			"Hash": "TestSpecificationRequirement-Create-ComputationTemplate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeType":
		{
			"Name": "Outcome Type",
			"Hash": "TestSpecificationRequirement-Create-OutcomeType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeTargets":
		{
			"Name": "Outcome Targets",
			"Hash": "TestSpecificationRequirement-Create-OutcomeTargets",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationSuccessOutcome":
		{
			"Name": "Computation Success Outcome",
			"Hash": "TestSpecificationRequirement-Create-ComputationSuccessOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationFailureOutcome":
		{
			"Name": "Computation Failure Outcome",
			"Hash": "TestSpecificationRequirement-Create-ComputationFailureOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.PrecompiledSolver":
		{
			"Name": "Precompiled Solver",
			"Hash": "TestSpecificationRequirement-Create-PrecompiledSolver",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationRequirement-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationRequirement-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationRequirement-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationRequirement-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1257:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationRequirementEditManifest",
	"Scope": "TestSpecificationRequirement-Edit",
	"Descriptors":
	{
		"TestSpecificationRequirementDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationRequirement-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationRequirement-Edit-Identity",
				"Group": "TestSpecificationRequirement-Edit-Identity"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecification":
		{
			"Name": "Test Specification",
			"Hash": "TestSpecificationRequirement-Edit-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details",
				"Entity": "TestSpecification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestSpecificationRequirement-Edit-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "TestSpecificationRequirement-Edit-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.OperationType":
		{
			"Name": "Operation Type",
			"Hash": "TestSpecificationRequirement-Edit-OperationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMinimum":
		{
			"Name": "Value Minimum",
			"Hash": "TestSpecificationRequirement-Edit-ValueMinimum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMaximum":
		{
			"Name": "Value Maximum",
			"Hash": "TestSpecificationRequirement-Edit-ValueMaximum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationTemplate":
		{
			"Name": "Computation Template",
			"Hash": "TestSpecificationRequirement-Edit-ComputationTemplate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeType":
		{
			"Name": "Outcome Type",
			"Hash": "TestSpecificationRequirement-Edit-OutcomeType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeTargets":
		{
			"Name": "Outcome Targets",
			"Hash": "TestSpecificationRequirement-Edit-OutcomeTargets",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationSuccessOutcome":
		{
			"Name": "Computation Success Outcome",
			"Hash": "TestSpecificationRequirement-Edit-ComputationSuccessOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationFailureOutcome":
		{
			"Name": "Computation Failure Outcome",
			"Hash": "TestSpecificationRequirement-Edit-ComputationFailureOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.PrecompiledSolver":
		{
			"Name": "Precompiled Solver",
			"Hash": "TestSpecificationRequirement-Edit-PrecompiledSolver",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecificationRequirement":
		{
			"Name": "IDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-Edit-IDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.GUIDTestSpecificationRequirement":
		{
			"Name": "GUIDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-Edit-GUIDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationRequirement-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationRequirement-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationRequirement-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationRequirement-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationRequirement-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationRequirement-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationRequirement-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationRequirement-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationRequirement-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationRequirement-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1258:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationRequirementViewManifest",
	"Scope": "TestSpecificationRequirement-View",
	"Descriptors":
	{
		"TestSpecificationRequirementDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationRequirement-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationRequirement-View-Identity",
				"Group": "TestSpecificationRequirement-View-Identity"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecification":
		{
			"Name": "Test Specification",
			"Hash": "TestSpecificationRequirement-View-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details",
				"Entity": "TestSpecification",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestSpecificationRequirementDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestSpecificationRequirement-View-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestSpecificationRequirementDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "TestSpecificationRequirement-View-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.OperationType":
		{
			"Name": "Operation Type",
			"Hash": "TestSpecificationRequirement-View-OperationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMinimum":
		{
			"Name": "Value Minimum",
			"Hash": "TestSpecificationRequirement-View-ValueMinimum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMaximum":
		{
			"Name": "Value Maximum",
			"Hash": "TestSpecificationRequirement-View-ValueMaximum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationTemplate":
		{
			"Name": "Computation Template",
			"Hash": "TestSpecificationRequirement-View-ComputationTemplate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeType":
		{
			"Name": "Outcome Type",
			"Hash": "TestSpecificationRequirement-View-OutcomeType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeTargets":
		{
			"Name": "Outcome Targets",
			"Hash": "TestSpecificationRequirement-View-OutcomeTargets",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationSuccessOutcome":
		{
			"Name": "Computation Success Outcome",
			"Hash": "TestSpecificationRequirement-View-ComputationSuccessOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationFailureOutcome":
		{
			"Name": "Computation Failure Outcome",
			"Hash": "TestSpecificationRequirement-View-ComputationFailureOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.PrecompiledSolver":
		{
			"Name": "Precompiled Solver",
			"Hash": "TestSpecificationRequirement-View-PrecompiledSolver",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-Details",
				"Group": "TestSpecificationRequirement-View-Details"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecificationRequirement":
		{
			"Name": "IDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-View-IDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.GUIDTestSpecificationRequirement":
		{
			"Name": "GUIDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-View-GUIDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationRequirement-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationRequirement-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationRequirement-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationRequirement-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-View-DataAudit",
				"Group": "TestSpecificationRequirement-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationRequirement-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationRequirement-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationRequirement-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationRequirement-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationRequirement-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationRequirement-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1259:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationSetCreateManifest",
	"Scope": "TestSpecificationSet-Create",
	"Descriptors":
	{
		"TestSpecificationSetDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationSet-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationSet-Create-Identity",
				"Group": "TestSpecificationSet-Create-Identity"
			}
		},
		"TestSpecificationSetDetails.Year":
		{
			"Name": "Year",
			"Hash": "TestSpecificationSet-Create-Year",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationSet-Create-Details",
				"Group": "TestSpecificationSet-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationSet-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationSet-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationSet-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationSet-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1260:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationSetEditManifest",
	"Scope": "TestSpecificationSet-Edit",
	"Descriptors":
	{
		"TestSpecificationSetDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationSet-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationSet-Edit-Identity",
				"Group": "TestSpecificationSet-Edit-Identity"
			}
		},
		"TestSpecificationSetDetails.Year":
		{
			"Name": "Year",
			"Hash": "TestSpecificationSet-Edit-Year",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-Details",
				"Group": "TestSpecificationSet-Edit-Details"
			}
		},
		"TestSpecificationSetDetails.IDTestSpecificationSet":
		{
			"Name": "IDTest Specification Set",
			"Hash": "TestSpecificationSet-Edit-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.GUIDTestSpecificationSet":
		{
			"Name": "GUIDTest Specification Set",
			"Hash": "TestSpecificationSet-Edit-GUIDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationSet-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationSet-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationSet-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationSet-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationSet-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationSet-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationSet-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationSet-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationSet-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationSet-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1261:[function(require,module,exports){
module.exports={
	"Form": "TestSpecificationSetViewManifest",
	"Scope": "TestSpecificationSet-View",
	"Descriptors":
	{
		"TestSpecificationSetDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationSet-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationSet-View-Identity",
				"Group": "TestSpecificationSet-View-Identity"
			}
		},
		"TestSpecificationSetDetails.Year":
		{
			"Name": "Year",
			"Hash": "TestSpecificationSet-View-Year",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationSet-View-Details",
				"Group": "TestSpecificationSet-View-Details"
			}
		},
		"TestSpecificationSetDetails.IDTestSpecificationSet":
		{
			"Name": "IDTest Specification Set",
			"Hash": "TestSpecificationSet-View-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.GUIDTestSpecificationSet":
		{
			"Name": "GUIDTest Specification Set",
			"Hash": "TestSpecificationSet-View-GUIDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationSet-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationSet-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationSet-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationSet-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationSet-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationSet-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationSet-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationSet-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationSet-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationSet-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1262:[function(require,module,exports){
module.exports={
	"Form": "UserEditManifest",
	"Scope": "User-Edit",
	"Descriptors":
	{
		"UserDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "UserEdit-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.GUIDUser":
		{
			"Name": "GUID",
			"Hash": "UserEdit-GUIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.NameFirst":
		{
			"Name": "First Name",
			"Hash": "UserEdit-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.NameLast":
		{
			"Name": "Last Name",
			"Hash": "UserEdit-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 3,
				"Section": "UserEditIdentity",
				"Group": "UserEditIdentity"
			}
		},
		"UserDetails.Email":
		{
			"Name": "Email Address",
			"Hash": "UserEdit-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Placeholder": "user@example.com",
				"Row": "2",
				"Width": 6,
				"Section": "UserEditContact",
				"Group": "UserEditContact"
			}
		},
		"UserDetails.LoginID":
		{
			"Name": "Login ID",
			"Hash": "UserEdit-LoginID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "UserEditContact",
				"Group": "UserEditContact"
			}
		},
		"UserDetails.Role":
		{
			"Name": "Role",
			"Hash": "UserEdit-Role",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "UserEditContact",
				"Group": "UserEditContact"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "UserEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "UserEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact & Access",
			"Hash": "UserEditContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact & Access",
					"Hash": "UserEditContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1263:[function(require,module,exports){
module.exports={
	"Scope": "User-List",
	"CoreEntity": "User",
	"TitleTemplate": "Users",
	"Descriptors":
	{
		"NameFirst":
		{
			"Name": "First Name",
			"Hash": "UserListFirstName",
			"PictDashboard": {}
		},
		"NameLast":
		{
			"Name": "Last Name",
			"Hash": "UserListLastName",
			"PictDashboard": {}
		},
		"Email":
		{
			"Name": "Email",
			"Hash": "UserListEmail",
			"PictDashboard": {}
		},
		"LoginID":
		{
			"Name": "Login ID",
			"Hash": "UserListLoginID",
			"PictDashboard": {}
		},
		"Title":
		{
			"Name": "Title",
			"Hash": "UserListTitle",
			"PictDashboard": {}
		}
	}
}

},{}],1264:[function(require,module,exports){
module.exports={
	"Form": "UserViewManifest",
	"Scope": "User-View",
	"Descriptors":
	{
		"UserDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "UserView-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.GUIDUser":
		{
			"Name": "GUID",
			"Hash": "UserView-GUIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.NameFirst":
		{
			"Name": "First Name",
			"Hash": "UserView-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.NameLast":
		{
			"Name": "Last Name",
			"Hash": "UserView-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "UserIdentity",
				"Group": "UserIdentity"
			}
		},
		"UserDetails.Email":
		{
			"Name": "Email Address",
			"Hash": "UserView-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "UserContact",
				"Group": "UserContact"
			}
		},
		"UserDetails.LoginID":
		{
			"Name": "Login ID",
			"Hash": "UserView-LoginID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "UserContact",
				"Group": "UserContact"
			}
		},
		"UserDetails.Role":
		{
			"Name": "Role",
			"Hash": "UserView-Role",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "UserContact",
				"Group": "UserContact"
			}
		},
		"UserDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "UserView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		},
		"UserDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "UserView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		},
		"UserDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "UserView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		},
		"UserDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "UserView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "UserAudit",
				"Group": "UserAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "UserIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "UserIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact & Access",
			"Hash": "UserContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact & Access",
					"Hash": "UserContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "UserAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "UserAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1265:[function(require,module,exports){
module.exports={
	"Form": "UserRoleJoinEditManifest",
	"Scope": "UserRoleJoin-Edit",
	"Descriptors":
	{
		"UserRoleJoinDetails.IDUserRoleJoin":
		{
			"Name": "ID",
			"Hash": "URJEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.GUIDUserRoleJoin":
		{
			"Name": "GUID",
			"Hash": "URJEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "URJEdit-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "URJEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.ProxyIDRole":
		{
			"Name": "Proxy Role ID",
			"Hash": "URJEdit-ProxyIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "URJEditConfig",
				"Group": "URJEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Assignment",
			"Hash": "URJEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Assignment",
					"Hash": "URJEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Proxy Configuration",
			"Hash": "URJEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Proxy Configuration",
					"Hash": "URJEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1266:[function(require,module,exports){
module.exports={
	"Scope": "UserRoleJoin-List",
	"CoreEntity": "UserRoleJoin",
	"TitleTemplate": "User Role Assignments",
	"Descriptors":
	{
		"IDUser":
		{
			"Name": "User ID",
			"Hash": "URJListIDUser",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "URJListIDRole",
			"PictDashboard": {}
		},
		"ProxyIDRole":
		{
			"Name": "Proxy Role ID",
			"Hash": "URJListProxyIDRole",
			"PictDashboard": {}
		}
	}
}

},{}],1267:[function(require,module,exports){
module.exports={
	"Form": "UserRoleJoinViewManifest",
	"Scope": "UserRoleJoin-View",
	"Descriptors":
	{
		"UserRoleJoinDetails.IDUserRoleJoin":
		{
			"Name": "ID",
			"Hash": "URJView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.GUIDUserRoleJoin":
		{
			"Name": "GUID",
			"Hash": "URJView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "URJView-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "URJView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "URJIdentity",
				"Group": "URJIdentity"
			}
		},
		"UserRoleJoinDetails.ProxyIDRole":
		{
			"Name": "Proxy Role ID",
			"Hash": "URJView-ProxyIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "URJConfig",
				"Group": "URJConfig"
			}
		},
		"UserRoleJoinDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "URJView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "URJAudit",
				"Group": "URJAudit"
			}
		},
		"UserRoleJoinDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "URJView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "URJAudit",
				"Group": "URJAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Assignment",
			"Hash": "URJIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Assignment",
					"Hash": "URJIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Proxy Configuration",
			"Hash": "URJConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Proxy Configuration",
					"Hash": "URJConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "URJAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "URJAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1268:[function(require,module,exports){
/**
 * GENERATED — do not edit by hand. Run: node source/default_manifests/build-catalog-manifests.js
 *
 * Registry of the generated catalog master-list manifests + per-entity wiring metadata.
 * PlatformConfiguration-Application-Web.js spreads MANIFESTS into its manifest map and applies
 * ENTITIES to the built catalog recordset configurations (read/create manifest routing).
 */

const manifestMaterialView = require('./Material-View.json');
const manifestMaterialEdit = require('./Material-Edit.json');
const manifestMaterialCreate = require('./Material-Create.json');
const manifestProductView = require('./Product-View.json');
const manifestProductEdit = require('./Product-Edit.json');
const manifestProductCreate = require('./Product-Create.json');
const manifestProductionPlantView = require('./ProductionPlant-View.json');
const manifestProductionPlantEdit = require('./ProductionPlant-Edit.json');
const manifestProductionPlantCreate = require('./ProductionPlant-Create.json');
const manifestPayItemView = require('./PayItem-View.json');
const manifestPayItemEdit = require('./PayItem-Edit.json');
const manifestPayItemCreate = require('./PayItem-Create.json');
const manifestLabView = require('./Lab-View.json');
const manifestLabEdit = require('./Lab-Edit.json');
const manifestLabCreate = require('./Lab-Create.json');
const manifestTestSpecificationView = require('./TestSpecification-View.json');
const manifestTestSpecificationEdit = require('./TestSpecification-Edit.json');
const manifestTestSpecificationCreate = require('./TestSpecification-Create.json');
const manifestEquipmentView = require('./Equipment-View.json');
const manifestEquipmentEdit = require('./Equipment-Edit.json');
const manifestEquipmentCreate = require('./Equipment-Create.json');
const manifestLocationView = require('./Location-View.json');
const manifestLocationEdit = require('./Location-Edit.json');
const manifestLocationCreate = require('./Location-Create.json');
const manifestTeamView = require('./Team-View.json');
const manifestTeamEdit = require('./Team-Edit.json');
const manifestTeamCreate = require('./Team-Create.json');
const manifestContactView = require('./Contact-View.json');
const manifestContactEdit = require('./Contact-Edit.json');
const manifestContactCreate = require('./Contact-Create.json');
const manifestCertificationTypeView = require('./CertificationType-View.json');
const manifestCertificationTypeEdit = require('./CertificationType-Edit.json');
const manifestCertificationTypeCreate = require('./CertificationType-Create.json');
const manifestAccountView = require('./Account-View.json');
const manifestAccountEdit = require('./Account-Edit.json');
const manifestAccountCreate = require('./Account-Create.json');
const manifestFundingSourceView = require('./FundingSource-View.json');
const manifestFundingSourceEdit = require('./FundingSource-Edit.json');
const manifestFundingSourceCreate = require('./FundingSource-Create.json');
const manifestFundView = require('./Fund-View.json');
const manifestFundEdit = require('./Fund-Edit.json');
const manifestFundCreate = require('./Fund-Create.json');
const manifestFundingCategoryView = require('./FundingCategory-View.json');
const manifestFundingCategoryEdit = require('./FundingCategory-Edit.json');
const manifestFundingCategoryCreate = require('./FundingCategory-Create.json');
const manifestAccountTypeView = require('./AccountType-View.json');
const manifestAccountTypeEdit = require('./AccountType-Edit.json');
const manifestAccountTypeCreate = require('./AccountType-Create.json');
const manifestMixDesignView = require('./MixDesign-View.json');
const manifestMixDesignEdit = require('./MixDesign-Edit.json');
const manifestMixDesignCreate = require('./MixDesign-Create.json');
const manifestMixSpecificationView = require('./MixSpecification-View.json');
const manifestMixSpecificationEdit = require('./MixSpecification-Edit.json');
const manifestMixSpecificationCreate = require('./MixSpecification-Create.json');
const manifestLotView = require('./Lot-View.json');
const manifestLotEdit = require('./Lot-Edit.json');
const manifestLotCreate = require('./Lot-Create.json');
const manifestProjectOfficeView = require('./ProjectOffice-View.json');
const manifestProjectOfficeEdit = require('./ProjectOffice-Edit.json');
const manifestProjectOfficeCreate = require('./ProjectOffice-Create.json');
const manifestTestSpecificationSetView = require('./TestSpecificationSet-View.json');
const manifestTestSpecificationSetEdit = require('./TestSpecificationSet-Edit.json');
const manifestTestSpecificationSetCreate = require('./TestSpecificationSet-Create.json');
const manifestTestView = require('./Test-View.json');
const manifestTestEdit = require('./Test-Edit.json');
const manifestTestCreate = require('./Test-Create.json');
const manifestTestInstanceView = require('./TestInstance-View.json');
const manifestTestInstanceEdit = require('./TestInstance-Edit.json');
const manifestTestInstanceCreate = require('./TestInstance-Create.json');
const manifestSampleView = require('./Sample-View.json');
const manifestSampleEdit = require('./Sample-Edit.json');
const manifestSampleCreate = require('./Sample-Create.json');
const manifestSampleStatusView = require('./SampleStatus-View.json');
const manifestSampleStatusEdit = require('./SampleStatus-Edit.json');
const manifestSampleStatusCreate = require('./SampleStatus-Create.json');
const manifestCoreView = require('./Core-View.json');
const manifestCoreEdit = require('./Core-Edit.json');
const manifestCoreCreate = require('./Core-Create.json');
const manifestLineItemView = require('./LineItem-View.json');
const manifestLineItemEdit = require('./LineItem-Edit.json');
const manifestLineItemCreate = require('./LineItem-Create.json');
const manifestBidItemView = require('./BidItem-View.json');
const manifestBidItemEdit = require('./BidItem-Edit.json');
const manifestBidItemCreate = require('./BidItem-Create.json');
const manifestTestSpecificationRequirementView = require('./TestSpecificationRequirement-View.json');
const manifestTestSpecificationRequirementEdit = require('./TestSpecificationRequirement-Edit.json');
const manifestTestSpecificationRequirementCreate = require('./TestSpecificationRequirement-Create.json');
const manifestAssetTypeView = require('./AssetType-View.json');
const manifestAssetTypeEdit = require('./AssetType-Edit.json');
const manifestAssetTypeCreate = require('./AssetType-Create.json');
const manifestAssetClassificationView = require('./AssetClassification-View.json');
const manifestAssetClassificationEdit = require('./AssetClassification-Edit.json');
const manifestAssetClassificationCreate = require('./AssetClassification-Create.json');
const manifestPhysicalAssetElementTypeView = require('./PhysicalAssetElementType-View.json');
const manifestPhysicalAssetElementTypeEdit = require('./PhysicalAssetElementType-Edit.json');
const manifestPhysicalAssetElementTypeCreate = require('./PhysicalAssetElementType-Create.json');
const manifestPhysicalAssetMaterialView = require('./PhysicalAssetMaterial-View.json');
const manifestPhysicalAssetMaterialEdit = require('./PhysicalAssetMaterial-Edit.json');
const manifestPhysicalAssetMaterialCreate = require('./PhysicalAssetMaterial-Create.json');
const manifestPhysicalAssetDefectView = require('./PhysicalAssetDefect-View.json');
const manifestPhysicalAssetDefectEdit = require('./PhysicalAssetDefect-Edit.json');
const manifestPhysicalAssetDefectCreate = require('./PhysicalAssetDefect-Create.json');
const manifestPhysicalAssetView = require('./PhysicalAsset-View.json');
const manifestPhysicalAssetEdit = require('./PhysicalAsset-Edit.json');
const manifestPhysicalAssetCreate = require('./PhysicalAsset-Create.json');

const MANIFESTS =
{
	'Material-View': manifestMaterialView,
	'Material-Edit': manifestMaterialEdit,
	'Material-Create': manifestMaterialCreate,
	'Product-View': manifestProductView,
	'Product-Edit': manifestProductEdit,
	'Product-Create': manifestProductCreate,
	'ProductionPlant-View': manifestProductionPlantView,
	'ProductionPlant-Edit': manifestProductionPlantEdit,
	'ProductionPlant-Create': manifestProductionPlantCreate,
	'PayItem-View': manifestPayItemView,
	'PayItem-Edit': manifestPayItemEdit,
	'PayItem-Create': manifestPayItemCreate,
	'Lab-View': manifestLabView,
	'Lab-Edit': manifestLabEdit,
	'Lab-Create': manifestLabCreate,
	'TestSpecification-View': manifestTestSpecificationView,
	'TestSpecification-Edit': manifestTestSpecificationEdit,
	'TestSpecification-Create': manifestTestSpecificationCreate,
	'Equipment-View': manifestEquipmentView,
	'Equipment-Edit': manifestEquipmentEdit,
	'Equipment-Create': manifestEquipmentCreate,
	'Location-View': manifestLocationView,
	'Location-Edit': manifestLocationEdit,
	'Location-Create': manifestLocationCreate,
	'Team-View': manifestTeamView,
	'Team-Edit': manifestTeamEdit,
	'Team-Create': manifestTeamCreate,
	'Contact-View': manifestContactView,
	'Contact-Edit': manifestContactEdit,
	'Contact-Create': manifestContactCreate,
	'CertificationType-View': manifestCertificationTypeView,
	'CertificationType-Edit': manifestCertificationTypeEdit,
	'CertificationType-Create': manifestCertificationTypeCreate,
	'Account-View': manifestAccountView,
	'Account-Edit': manifestAccountEdit,
	'Account-Create': manifestAccountCreate,
	'FundingSource-View': manifestFundingSourceView,
	'FundingSource-Edit': manifestFundingSourceEdit,
	'FundingSource-Create': manifestFundingSourceCreate,
	'Fund-View': manifestFundView,
	'Fund-Edit': manifestFundEdit,
	'Fund-Create': manifestFundCreate,
	'FundingCategory-View': manifestFundingCategoryView,
	'FundingCategory-Edit': manifestFundingCategoryEdit,
	'FundingCategory-Create': manifestFundingCategoryCreate,
	'AccountType-View': manifestAccountTypeView,
	'AccountType-Edit': manifestAccountTypeEdit,
	'AccountType-Create': manifestAccountTypeCreate,
	'MixDesign-View': manifestMixDesignView,
	'MixDesign-Edit': manifestMixDesignEdit,
	'MixDesign-Create': manifestMixDesignCreate,
	'MixSpecification-View': manifestMixSpecificationView,
	'MixSpecification-Edit': manifestMixSpecificationEdit,
	'MixSpecification-Create': manifestMixSpecificationCreate,
	'Lot-View': manifestLotView,
	'Lot-Edit': manifestLotEdit,
	'Lot-Create': manifestLotCreate,
	'ProjectOffice-View': manifestProjectOfficeView,
	'ProjectOffice-Edit': manifestProjectOfficeEdit,
	'ProjectOffice-Create': manifestProjectOfficeCreate,
	'TestSpecificationSet-View': manifestTestSpecificationSetView,
	'TestSpecificationSet-Edit': manifestTestSpecificationSetEdit,
	'TestSpecificationSet-Create': manifestTestSpecificationSetCreate,
	'Test-View': manifestTestView,
	'Test-Edit': manifestTestEdit,
	'Test-Create': manifestTestCreate,
	'TestInstance-View': manifestTestInstanceView,
	'TestInstance-Edit': manifestTestInstanceEdit,
	'TestInstance-Create': manifestTestInstanceCreate,
	'Sample-View': manifestSampleView,
	'Sample-Edit': manifestSampleEdit,
	'Sample-Create': manifestSampleCreate,
	'SampleStatus-View': manifestSampleStatusView,
	'SampleStatus-Edit': manifestSampleStatusEdit,
	'SampleStatus-Create': manifestSampleStatusCreate,
	'Core-View': manifestCoreView,
	'Core-Edit': manifestCoreEdit,
	'Core-Create': manifestCoreCreate,
	'LineItem-View': manifestLineItemView,
	'LineItem-Edit': manifestLineItemEdit,
	'LineItem-Create': manifestLineItemCreate,
	'BidItem-View': manifestBidItemView,
	'BidItem-Edit': manifestBidItemEdit,
	'BidItem-Create': manifestBidItemCreate,
	'TestSpecificationRequirement-View': manifestTestSpecificationRequirementView,
	'TestSpecificationRequirement-Edit': manifestTestSpecificationRequirementEdit,
	'TestSpecificationRequirement-Create': manifestTestSpecificationRequirementCreate,
	'AssetType-View': manifestAssetTypeView,
	'AssetType-Edit': manifestAssetTypeEdit,
	'AssetType-Create': manifestAssetTypeCreate,
	'AssetClassification-View': manifestAssetClassificationView,
	'AssetClassification-Edit': manifestAssetClassificationEdit,
	'AssetClassification-Create': manifestAssetClassificationCreate,
	'PhysicalAssetElementType-View': manifestPhysicalAssetElementTypeView,
	'PhysicalAssetElementType-Edit': manifestPhysicalAssetElementTypeEdit,
	'PhysicalAssetElementType-Create': manifestPhysicalAssetElementTypeCreate,
	'PhysicalAssetMaterial-View': manifestPhysicalAssetMaterialView,
	'PhysicalAssetMaterial-Edit': manifestPhysicalAssetMaterialEdit,
	'PhysicalAssetMaterial-Create': manifestPhysicalAssetMaterialCreate,
	'PhysicalAssetDefect-View': manifestPhysicalAssetDefectView,
	'PhysicalAssetDefect-Edit': manifestPhysicalAssetDefectEdit,
	'PhysicalAssetDefect-Create': manifestPhysicalAssetDefectCreate,
	'PhysicalAsset-View': manifestPhysicalAssetView,
	'PhysicalAsset-Edit': manifestPhysicalAssetEdit,
	'PhysicalAsset-Create': manifestPhysicalAssetCreate,
};

const ENTITIES = [{"Entity":"Material","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"NameAbbreviated","DisplayName":"Name Abbreviated"},{"Key":"Type","DisplayName":"Type"},{"Key":"Description","DisplayName":"Description"},{"Key":"CatalogCode","DisplayName":"Catalog Code"},{"Key":"MaterialCode","DisplayName":"Material Code"}]},{"Entity":"Product","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"ManufacturerCode","DisplayName":"Manufacturer Code"},{"Key":"CatalogCode","DisplayName":"Catalog Code"}]},{"Entity":"ProductionPlant","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"}]},{"Entity":"PayItem","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"ItemCode","DisplayName":"Item Code"}]},{"Entity":"Lab","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"}]},{"Entity":"TestSpecification","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"Equipment","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"Code","DisplayName":"Code"},{"Key":"Status","DisplayName":"Status"}]},{"Entity":"Location","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Type","DisplayName":"Type"},{"Key":"Description","DisplayName":"Description"},{"Key":"QRCode","DisplayName":"QRCode"},{"Key":"City","DisplayName":"City"},{"Key":"State","DisplayName":"State"}]},{"Entity":"Team","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"Contact","OverrideReadOnly":false,"ListColumns":[{"Key":"Title","DisplayName":"Title"}]},{"Entity":"CertificationType","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"Account","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"FundingSource","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"FundingSourceAccountCode","DisplayName":"Funding Source Account Code"},{"Key":"Type","DisplayName":"Type"}]},{"Entity":"Fund","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"FundingCategory","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Code","DisplayName":"Code"},{"Key":"Type","DisplayName":"Type"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"AccountType","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"MixDesign","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"MaterialCode","DisplayName":"Material Code"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"MixSpecification","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"Code","DisplayName":"Code"}]},{"Entity":"Lot","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"}]},{"Entity":"ProjectOffice","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"OfficeCode","DisplayName":"Office Code"},{"Key":"City","DisplayName":"City"},{"Key":"State","DisplayName":"State"}]},{"Entity":"TestSpecificationSet","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"}]},{"Entity":"Test","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"TestInstance","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Status","DisplayName":"Status"},{"Key":"SampleTestNumber","DisplayName":"Sample Test Number"}]},{"Entity":"Sample","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"QRCode","DisplayName":"QRCode"},{"Key":"Status","DisplayName":"Status"},{"Key":"LabControlNumber","DisplayName":"Lab Control Number"},{"Key":"LabReferenceNumber","DisplayName":"Lab Reference Number"},{"Key":"ManufacturerCode","DisplayName":"Manufacturer Code"}]},{"Entity":"SampleStatus","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"Category","DisplayName":"Category"}]},{"Entity":"Core","OverrideReadOnly":false,"ListColumns":[{"Key":"QRCode","DisplayName":"QRCode"}]},{"Entity":"LineItem","OverrideReadOnly":true,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"ItemCode","DisplayName":"Item Code"},{"Key":"ItemNumber","DisplayName":"Item Number"},{"Key":"ChangeOrderNumber","DisplayName":"Change Order Number"},{"Key":"Status","DisplayName":"Status"}]},{"Entity":"BidItem","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"TestSpecificationRequirement","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"}]},{"Entity":"AssetType","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"AssetClassification","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"PhysicalAssetElementType","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Code","DisplayName":"Code"},{"Key":"SectionCode","DisplayName":"Section Code"}]},{"Entity":"PhysicalAssetMaterial","OverrideReadOnly":false,"ListColumns":[{"Key":"Code","DisplayName":"Code"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"PhysicalAssetDefect","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Code","DisplayName":"Code"},{"Key":"Description","DisplayName":"Description"}]},{"Entity":"PhysicalAsset","OverrideReadOnly":false,"ListColumns":[{"Key":"Name","DisplayName":"Name"},{"Key":"Description","DisplayName":"Description"},{"Key":"AssetNumber","DisplayName":"Asset Number"}]}];

const PICKER_TARGETS = [{"Entity":"Contract","SearchFields":["Name","Description","PrimaryProjectNumber","CountyProjectNumber"]},{"Entity":"FIPSCounty","SearchFields":["Code","Name"]},{"Entity":"FIPSState","SearchFields":["Code","Name"]},{"Entity":"MixType","SearchFields":["Name","Code","Description"]},{"Entity":"Organization","SearchFields":["Name","VendorCode","FederalTaxCode"]},{"Entity":"OrganizationAddress","SearchFields":["LocationName"]},{"Entity":"Project","SearchFields":["Name","Description","PurchaseOrderNumber","ImprovementTypeCode"]},{"Entity":"SampleType","SearchFields":["Name","Description"]},{"Entity":"TestPlan","SearchFields":["Description"]}];

module.exports = { MANIFESTS, ENTITIES, PICKER_TARGETS };

},{"./Account-Create.json":1098,"./Account-Edit.json":1099,"./Account-View.json":1100,"./AccountType-Create.json":1101,"./AccountType-Edit.json":1102,"./AccountType-View.json":1103,"./AssetClassification-Create.json":1107,"./AssetClassification-Edit.json":1108,"./AssetClassification-View.json":1109,"./AssetType-Create.json":1110,"./AssetType-Edit.json":1111,"./AssetType-View.json":1112,"./BidItem-Create.json":1113,"./BidItem-Edit.json":1114,"./BidItem-View.json":1115,"./CertificationType-Create.json":1116,"./CertificationType-Edit.json":1117,"./CertificationType-View.json":1118,"./Contact-Create.json":1119,"./Contact-Edit.json":1120,"./Contact-View.json":1121,"./Core-Create.json":1126,"./Core-Edit.json":1127,"./Core-View.json":1128,"./Equipment-Create.json":1141,"./Equipment-Edit.json":1142,"./Equipment-View.json":1143,"./Fund-Create.json":1144,"./Fund-Edit.json":1145,"./Fund-View.json":1146,"./FundingCategory-Create.json":1147,"./FundingCategory-Edit.json":1148,"./FundingCategory-View.json":1149,"./FundingSource-Create.json":1150,"./FundingSource-Edit.json":1151,"./FundingSource-View.json":1152,"./Lab-Create.json":1153,"./Lab-Edit.json":1154,"./Lab-View.json":1155,"./LineItem-Create.json":1156,"./LineItem-Edit.json":1157,"./LineItem-View.json":1158,"./Location-Create.json":1159,"./Location-Edit.json":1160,"./Location-View.json":1161,"./Lot-Create.json":1162,"./Lot-Edit.json":1163,"./Lot-View.json":1164,"./Material-Create.json":1165,"./Material-Edit.json":1166,"./Material-View.json":1167,"./MixDesign-Create.json":1168,"./MixDesign-Edit.json":1169,"./MixDesign-View.json":1170,"./MixSpecification-Create.json":1171,"./MixSpecification-Edit.json":1172,"./MixSpecification-View.json":1173,"./PayItem-Create.json":1193,"./PayItem-Edit.json":1194,"./PayItem-View.json":1195,"./PhysicalAsset-Create.json":1196,"./PhysicalAsset-Edit.json":1197,"./PhysicalAsset-View.json":1198,"./PhysicalAssetDefect-Create.json":1199,"./PhysicalAssetDefect-Edit.json":1200,"./PhysicalAssetDefect-View.json":1201,"./PhysicalAssetElementType-Create.json":1202,"./PhysicalAssetElementType-Edit.json":1203,"./PhysicalAssetElementType-View.json":1204,"./PhysicalAssetMaterial-Create.json":1205,"./PhysicalAssetMaterial-Edit.json":1206,"./PhysicalAssetMaterial-View.json":1207,"./Product-Create.json":1208,"./Product-Edit.json":1209,"./Product-View.json":1210,"./ProductionPlant-Create.json":1211,"./ProductionPlant-Edit.json":1212,"./ProductionPlant-View.json":1213,"./ProjectOffice-Create.json":1217,"./ProjectOffice-Edit.json":1218,"./ProjectOffice-View.json":1219,"./Sample-Create.json":1238,"./Sample-Edit.json":1239,"./Sample-View.json":1240,"./SampleStatus-Create.json":1241,"./SampleStatus-Edit.json":1242,"./SampleStatus-View.json":1243,"./Team-Create.json":1244,"./Team-Edit.json":1245,"./Team-View.json":1246,"./Test-Create.json":1247,"./Test-Edit.json":1248,"./Test-View.json":1249,"./TestInstance-Create.json":1250,"./TestInstance-Edit.json":1251,"./TestInstance-View.json":1252,"./TestSpecification-Create.json":1253,"./TestSpecification-Edit.json":1254,"./TestSpecification-View.json":1255,"./TestSpecificationRequirement-Create.json":1256,"./TestSpecificationRequirement-Edit.json":1257,"./TestSpecificationRequirement-View.json":1258,"./TestSpecificationSet-Create.json":1259,"./TestSpecificationSet-Edit.json":1260,"./TestSpecificationSet-View.json":1261}],1269:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */
/**
 * Document lookup for pickers: find one document to act on (grant it to a team, attach it to an inspection) without
 * scanning the customer's Document table.
 *
 * A document is found either by its number (IDDocument, a primary-key read) or by name within one project (the
 * `IDProject, Deleted` index), never by an unanchored name LIKE across the whole customer: on LADOTD QA that read had
 * not answered after 150 s. Rows come from `Documents/LiteExtended/Name,DocumentType`, so FormData (megabytes per
 * record) never crosses the wire; Name and DocumentType were checked against the full record for document 4903130.
 *
 * Form type hashes (DocumentType, e.g. `LADOTD-ATM`) are shown by their form name (ReportNamedInstance.Name).
 */

const libPictSectionPicker = require('pict-section-picker');

const DEFAULT_PAGE_SIZE = 25;
const MAX_PAGE_SIZE = 250;

/** The projection every lookup reads: the Lite columns plus the two a picker and a grant need. */
const DOCUMENT_COLUMNS = 'Name,DocumentType';

/**
 * @typedef {Object} DocumentLookupScope
 * @property {number} IDCustomer - The customer whose documents are searched.
 * @property {number} [IDProject] - The project a name search runs in; without one only a document number finds anything.
 * @property {number} [Start] - Record offset (default 0).
 * @property {number} [PageSize] - Records per request (default 25, never above 250).
 */

/**
 * @typedef {Object} DocumentPickerOption
 * @property {number} Value - IDDocument.
 * @property {string} Text - The document's name.
 * @property {string} Tag - The document number, shown as a badge.
 * @property {Record<string, any>} Record - The LiteExtended row (IDDocument, IDProject, Name, DocumentType, …).
 */

/**
 * @param {any} pValue
 * @returns {number} A positive integer, or 0.
 */
function positiveInteger(pValue)
{
	const tmpNumber = Number(pValue);
	return (Number.isInteger(tmpNumber) && (tmpNumber > 0)) ? tmpNumber : 0;
}

/**
 * @param {DocumentLookupScope} pScope
 * @returns {number} The requested page size, clamped to 1..250.
 */
function pageSize(pScope)
{
	const tmpSize = Math.floor(Number(pScope && pScope.PageSize) || DEFAULT_PAGE_SIZE);
	return Math.min(Math.max(tmpSize, 1), MAX_PAGE_SIZE);
}

/**
 * Tidy a search term: `~` is FoxHound's separator, and whitespace collapses.
 *
 * @param {any} pTerm - The raw search text.
 * @returns {string} The cleaned term ('' when nothing is left).
 */
function cleanTerm(pTerm)
{
	return String(pTerm == null ? '' : pTerm).replace(/~/g, ' ').replace(/\s+/g, ' ').trim();
}

/**
 * The document number in a search term, when the term is one: `4903130`, `#4903130` or `No. 4903130`.
 *
 * @param {any} pTerm - The raw search text.
 * @returns {number} The IDDocument, or 0 when the term is not a document number.
 */
function parseDocumentNumber(pTerm)
{
	const tmpMatch = /^(?:no\.?\s*|#\s*)?(\d+)$/i.exec(cleanTerm(pTerm));
	return tmpMatch ? positiveInteger(tmpMatch[1]) : 0;
}

/**
 * The `Documents/LiteExtended` URL for a search, or '' when the search cannot be answered cheaply (no project and the
 * term is not a document number), in which case nothing should be requested.
 *
 * @param {any} pTerm - The raw search text.
 * @param {DocumentLookupScope} pScope
 * @returns {string} A URL relative to the API root, or ''.
 */
function buildDocumentSearchURL(pTerm, pScope)
{
	const tmpScope = pScope || { IDCustomer: 0 };
	const tmpIDCustomer = positiveInteger(tmpScope.IDCustomer);
	const tmpCustomerFilter = tmpIDCustomer ? `~FBV~IDCustomer~EQ~${tmpIDCustomer}` : '';
	const tmpBase = `Documents/LiteExtended/${DOCUMENT_COLUMNS}/FilteredTo`;
	const tmpNumber = parseDocumentNumber(pTerm);
	if (tmpNumber)
	{
		return `${tmpBase}/FBV~IDDocument~EQ~${tmpNumber}${tmpCustomerFilter}~FBV~Deleted~EQ~0/0/1`;
	}
	const tmpIDProject = positiveInteger(tmpScope.IDProject);
	if (!tmpIDProject)
	{
		return '';
	}
	const tmpNameFilter = libPictSectionPicker.prototype.buildSearchFilter.call(null, [ 'Name' ], cleanTerm(pTerm));
	const tmpFilter = [ `FBV~IDProject~EQ~${tmpIDProject}`, tmpNameFilter ].filter(Boolean).join('~');
	const tmpStart = Math.max(Math.floor(Number(tmpScope.Start) || 0), 0);
	return `${tmpBase}/${tmpFilter}${tmpCustomerFilter}~FBV~Deleted~EQ~0~FSF~IDDocument~DESC~0/${tmpStart}/${pageSize(tmpScope)}`;
}

/**
 * What an empty document list says, so the admin knows how to find a document.
 *
 * @param {any} pTerm - The raw search text.
 * @param {number} [pIDProject] - The selected project, if any.
 * @returns {string} The empty-list text.
 */
function documentSearchEmptyLabel(pTerm, pIDProject)
{
	if (parseDocumentNumber(pTerm))
	{
		return 'No document with that number';
	}
	if (!positiveInteger(pIDProject))
	{
		return 'Pick a project first, or type a document number';
	}
	return cleanTerm(pTerm) ? 'No document in this project matches that name' : 'This project has no documents';
}

/**
 * @param {Record<string, any>} pRow - A Document (or LiteExtended) row.
 * @returns {DocumentPickerOption} The picker option.
 */
function documentOption(pRow)
{
	const tmpID = positiveInteger(pRow && pRow.IDDocument);
	return { Value: tmpID, Text: (pRow && pRow.Name) || `Document #${tmpID}`, Tag: `#${tmpID}`, Record: pRow };
}

/**
 * A pict-section-picker DataProvider over the document lookup: `(term, page) => { results, hasMore }`. The scope is
 * read at call time, so a project picked after the picker mounted applies to the next search.
 *
 * @param {(pURL: string) => Promise<any>} fGetJSON - The caller's API GET (relative URL → parsed body).
 * @param {() => DocumentLookupScope} fScope - The current customer and project.
 * @returns {(pTerm: any, pPage: number) => Promise<{ results: Array<DocumentPickerOption>, hasMore: boolean }>}
 */
function documentPickerDataProvider(fGetJSON, fScope)
{
	return (pTerm, pPage) =>
	{
		const tmpScope = Object.assign({}, fScope());
		const tmpPageSize = pageSize(tmpScope);
		tmpScope.Start = (Number(pPage) || 0) * tmpPageSize;
		const tmpURL = buildDocumentSearchURL(pTerm, tmpScope);
		if (!tmpURL)
		{
			return Promise.resolve({ results: [], hasMore: false });
		}
		return Promise.resolve(fGetJSON(tmpURL))
			.then((pRows) =>
			{
				const tmpRows = Array.isArray(pRows) ? pRows.filter((pRow) => positiveInteger(pRow && pRow.IDDocument)) : [];
				return { results: tmpRows.map(documentOption), hasMore: (tmpRows.length >= tmpPageSize) && !parseDocumentNumber(pTerm) };
			})
			.catch(() => ({ results: [], hasMore: false }));
	};
}

/**
 * A pict-section-picker DataProvider over the customer's projects by name (Lite rows: the name is `Value`), in name
 * order. The API scopes Projects to the caller's customer.
 *
 * @param {(pURL: string) => Promise<any>} fGetJSON - The caller's API GET.
 * @returns {(pTerm: any, pPage: number) => Promise<{ results: Array<{ Value: number, Text: string, Record: Record<string, any> }>, hasMore: boolean }>}
 */
function projectPickerDataProvider(fGetJSON)
{
	return (pTerm, pPage) =>
	{
		const tmpNameFilter = libPictSectionPicker.prototype.buildSearchFilter.call(null, [ 'Name' ], cleanTerm(pTerm));
		const tmpFilter = [ tmpNameFilter, 'FBV~Deleted~EQ~0~FSF~Name~ASC~0' ].filter(Boolean).join('~');
		const tmpStart = (Number(pPage) || 0) * DEFAULT_PAGE_SIZE;
		return Promise.resolve(fGetJSON(`Projects/Lite/FilteredTo/${tmpFilter}/${tmpStart}/${DEFAULT_PAGE_SIZE}`))
			.then((pRows) =>
			{
				const tmpRows = Array.isArray(pRows) ? pRows.filter((pRow) => positiveInteger(pRow && pRow.IDProject)) : [];
				return {
					results: tmpRows.map((pRow) => ({ Value: Number(pRow.IDProject), Text: pRow.Value || pRow.Name || `Project #${pRow.IDProject}`, Record: pRow })),
					hasMore: (tmpRows.length >= DEFAULT_PAGE_SIZE),
				};
			})
			.catch(() => ({ results: [], hasMore: false }));
	};
}

/**
 * The URL resolving document type hashes to form names (the customer's own form types, then the shared ones).
 *
 * @param {Array<string>} pTypeHashes - DocumentType values.
 * @param {number} pIDCustomer - The customer.
 * @returns {string} A URL relative to the API root, or '' when there is nothing to resolve.
 */
function buildFormTypeNamesURL(pTypeHashes, pIDCustomer)
{
	const tmpHashes = Array.from(new Set((Array.isArray(pTypeHashes) ? pTypeHashes : []).map((pHash) => cleanTerm(pHash)).filter((pHash) => pHash && (pHash.indexOf(',') < 0))));
	if (!tmpHashes.length)
	{
		return '';
	}
	const tmpCustomers = [ positiveInteger(pIDCustomer), 0 ].filter((pID, pIndex, pAll) => pAll.indexOf(pID) === pIndex).join(',');
	return `ReportNamedInstances/LiteExtended/Hash,Name/FilteredTo/FBL~Hash~INN~${tmpHashes.map(encodeURIComponent).join(',')}~FBL~IDCustomer~INN~${tmpCustomers}~FBV~Deleted~EQ~0/0/${Math.min(tmpHashes.length * 4, MAX_PAGE_SIZE)}`;
}

/**
 * Form names by type hash. A customer's own form type wins over a shared one with the same hash.
 *
 * @param {Array<Record<string, any>>} pRows - ReportNamedInstance rows (Hash, Name, IDCustomer).
 * @param {number} pIDCustomer - The customer.
 * @returns {Record<string, string>} Hash → form name.
 */
function formTypeNamesByHash(pRows, pIDCustomer)
{
	/** @type {Record<string, string>} */
	const tmpNames = {};
	/** @type {Record<string, boolean>} */
	const tmpOwn = {};
	(Array.isArray(pRows) ? pRows : []).forEach((pRow) =>
	{
		const tmpName = pRow && (pRow.Name || pRow.Value);
		if (!pRow || !pRow.Hash || !tmpName)
		{
			return;
		}
		const tmpIsOwn = (positiveInteger(pRow.IDCustomer) === positiveInteger(pIDCustomer));
		if (!tmpNames[pRow.Hash] || (tmpIsOwn && !tmpOwn[pRow.Hash]))
		{
			tmpNames[pRow.Hash] = String(tmpName).trim();
			tmpOwn[pRow.Hash] = tmpIsOwn;
		}
	});
	return tmpNames;
}

module.exports =
{
	MAX_PAGE_SIZE,
	parseDocumentNumber,
	buildDocumentSearchURL,
	documentSearchEmptyLabel,
	documentOption,
	documentPickerDataProvider,
	projectPickerDataProvider,
	buildFormTypeNamesURL,
	formTypeNamesByHash,
};

},{"pict-section-picker":711}],1270:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libDocumentFrame = require('headlight-configurable-application/source/providers/DocumentFrameProvider.js');

const CHANNEL = libDocumentFrame.CHANNEL;
const FRAME_PARAMETER = libDocumentFrame.FRAME_PARAMETER;

// Frames past this are closed least-recently-viewed first, but only when they are loaded and hold nothing unsaved.
const MAX_LIVE_FRAMES = 6;
const REQUEST_TIMEOUT_MS = 120000;
const LAYER_ID = 'DocFrames-Layer';
// Media kind -> [ singular, plural, Font Awesome icon ].
const MEDIA_LABELS =
{
	image: [ 'image', 'images', 'fa-image' ],
	video: [ 'video', 'videos', 'fa-video' ],
	audio: [ 'audio clip', 'audio clips', 'fa-microphone' ],
	file: [ 'file', 'files', 'fa-paperclip' ],
};

/**
 * @typedef {Object} SwitcherDocument
 * @property {number} IDDocument
 * @property {String} [Name]
 * @property {String} [DocumentType]
 * @property {String} [Status]
 * @property {String} [CreateDate]
 * @property {String} [FormName] - The form the document was made from, shown in its tooltip and, when it has no tests, on its second line.
 * @property {Array<SwitcherTest>} [Tests] - The tests the document covers; replaces the type on the rail.
 * @property {Record<String, number>} [Media] - Media observations by kind: image, video, audio, file.
 */

/**
 * @typedef {Object} SwitcherTest
 * @property {String} Code
 * @property {String} [Name]
 * @property {boolean} [Assigned] - The record asked for this test on this document.
 * @property {String} [Result] - The test's result as text, e.g. `Passed`.
 * @property {String} [ResultTone] - 'success' | 'danger' | 'warning' | 'info' | 'muted'.
 */

/**
 * @typedef {Object} FrameEntry
 * @property {number} IDDocument
 * @property {String} FrameID
 * @property {String} Phase - 'rendering' | 'loading' | 'ready' | 'error'
 * @property {String} Kind - 'pending' | 'form' (reports its state) | 'untracked' (a form that does not) | 'classic' (a legacy report page)
 * @property {String} Error
 * @property {?HTMLIFrameElement} IFrame
 * @property {?import('headlight-configurable-application/source/providers/DocumentFrameProvider.js').DocumentFrameState} State
 * @property {boolean} Touched - The user typed in a frame that cannot report its own unsaved state.
 * @property {number} LastActiveAt
 * @property {{ ClickedAt: number, RenderMS: ?number, LoadMS: ?number, ReadyMS: ?number, FormLoad: any }} Timing
 */

/**
 * DocumentFrameSwitcher — opens a record's documents side by side with a quick-switch rail, each in its own iframe running
 * the same form page the longhand editor opens (Report/Render → Report/{GUID}/index.html). Every document keeps its own
 * pict, so editing, saving, approval actions and access control are exactly the longhand path's, and a document that is
 * not on screen shares nothing with the one that is.
 *
 * Frames live in one layer appended to <body>, laid over an anchor element the caller paints, because a workspace repaint
 * replaces its markup and an iframe that leaves the DOM reloads (losing unsaved work). Switching only changes which frame
 * is visible. Configurable forms report ready / unsaved / approval state over the DocumentFrame protocol
 * (headlight-configurable-application DocumentFrameProvider); classic report pages are hosted the same way without it.
 */
class DocumentFrameSwitcherProvider extends libPictProvider
{
	/**
	 * @param {any} pFable - The Fable instance.
	 * @param {Object} [pOptions] - The provider options.
	 * @param {String} [pServiceHash] - The fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;

		/** @type {?String} */
		this.OwnerKey = null;
		/** @type {(pHash: String) => boolean} */
		this._ownerMatch = () => false;
		/** @type {String} */
		this._anchorID = '';
		/** @type {Array<SwitcherDocument>} */
		this.Documents = [];
		/** @type {String} Plain text shown at the foot of the rail, e.g. how many documents the user cannot see. */
		this.RailNote = '';
		/** @type {Record<number, FrameEntry>} */
		this.Frames = {};
		/** @type {Record<String, FrameEntry>} */
		this._framesByFrameID = {};
		/** @type {number} */
		this.ActiveID = 0;
		/** @type {boolean} */
		this.Fullscreen = false;
		/** @type {Record<String, String>} - DocumentType -> Kind, learned from frames opened this session. */
		this._kindByType = {};
		/** @type {Record<String, { resolve: Function, timer: any }>} */
		this._pendingRequests = {};
		this._requestSerial = 0;
		this._frameSerial = 0;
		/** @type {Array<any>} */
		this.Timings = [];
		this._layer = null;
		/** @type {?String} The rail markup last painted, so an unchanged rail keeps its elements and an open tooltip. */
		this._railMarkup = null;
		/** @type {Array<{ destroy: Function }>} */
		this._railTooltips = [];
		this._rafHandle = null;
		this._lastHash = (typeof window !== 'undefined') ? window.location.hash : '';
		this._restoringHash = false;

		if (typeof window !== 'undefined')
		{
			this._onMessage = this._onMessage.bind(this);
			this._onHashChange = this._onHashChange.bind(this);
			this._onBeforeUnload = this._onBeforeUnload.bind(this);
			this._onKeydown = this._onKeydown.bind(this);
			window.addEventListener('message', this._onMessage);
			window.addEventListener('hashchange', this._onHashChange);
			window.addEventListener('beforeunload', this._onBeforeUnload);
			document.addEventListener('keydown', this._onKeydown);
		}
		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('DocumentFrameSwitcher-CSS', _CSS, 525);
		}
	}

	/** @return {any} The HeadlightDocumentRender service. */
	get render()
	{
		return this.pict.HeadlightDocumentRender;
	}

	// --- owner lifecycle ---------------------------------------------------------------------------------------------

	/**
	 * Bind the switcher to a record and the anchor it should cover. Frames already open for the same owner are kept;
	 * a different owner starts clean.
	 *
	 * @param {Object} pOptions
	 * @param {String} pOptions.OwnerKey - Identifies the record, e.g. `Sample:<GUID>`.
	 * @param {(pHash: String) => boolean} pOptions.OwnerMatch - Whether a location hash still belongs to the record.
	 * @param {String} pOptions.AnchorID - The id of the element the switcher is laid over.
	 * @param {Array<SwitcherDocument>} pOptions.Documents
	 * @param {String} [pOptions.RailNote] - Plain text shown at the foot of the document list.
	 * @return {void}
	 */
	attach(pOptions)
	{
		if (this.OwnerKey && (this.OwnerKey !== pOptions.OwnerKey))
		{
			this.teardown();
		}
		this.OwnerKey = pOptions.OwnerKey;
		this._ownerMatch = (typeof pOptions.OwnerMatch === 'function') ? pOptions.OwnerMatch : (() => true);
		this._anchorID = pOptions.AnchorID;
		this._ensureLayer();
		this.RailNote = String(pOptions.RailNote || '');
		this.setDocuments(pOptions.Documents || []);
		this._startPositionSync();
		try
		{
			this.pict.CSSMap.injectCSS();
		}
		catch (pError)
		{
			this.pict.log.warn(`[DocFrames] could not inject styles: ${pError.message || pError}`);
		}
	}

	/**
	 * @param {Array<SwitcherDocument>} pDocuments
	 * @return {void}
	 */
	setDocuments(pDocuments)
	{
		this.Documents = (Array.isArray(pDocuments) ? pDocuments : []).filter((pDocument) => pDocument && (Number(pDocument.IDDocument) > 0));
		this._renderChrome();
	}

	/** Close every frame and release the record. Unsaved work in them is gone; callers guard with hasUnsavedWork(). */
	teardown()
	{
		for (const tmpEntry of Object.values(this.Frames))
		{
			this._removeFrame(tmpEntry);
		}
		this.Frames = {};
		this._framesByFrameID = {};
		this.ActiveID = 0;
		this.Fullscreen = false;
		this.OwnerKey = null;
		this.Documents = [];
		this.RailNote = '';
		this._destroyRailTooltips();
		this._railMarkup = null;
		this._stopPositionSync();
		if (this._layer)
		{
			this._layer.style.display = 'none';
			this._layer.classList.remove('dfs-is-fs');
		}
		this._renderChrome();
	}

	// --- opening and switching ---------------------------------------------------------------------------------------

	/**
	 * Show a document, rendering it into a new frame the first time.
	 *
	 * @param {number|String} pIDDocument
	 * @return {void}
	 */
	open(pIDDocument)
	{
		const tmpID = Number(pIDDocument) || 0;
		if (!tmpID)
		{
			return;
		}
		const tmpExisting = this.Frames[tmpID];
		if (tmpExisting && (tmpExisting.Phase !== 'error'))
		{
			this._activate(tmpExisting);
			return;
		}
		if (tmpExisting)
		{
			this._removeFrame(tmpExisting);
		}
		const tmpEntry = this._createEntry(tmpID);
		this._activate(tmpEntry);
		this._closeIdleFrames();
		this._renderIntoFrame(tmpEntry);
	}

	/**
	 * @param {number} pIDDocument
	 * @return {FrameEntry}
	 */
	_createEntry(pIDDocument)
	{
		this._frameSerial++;
		/** @type {FrameEntry} */
		const tmpEntry =
		{
			IDDocument: pIDDocument,
			FrameID: `doc-${pIDDocument}-${this._frameSerial}`,
			Phase: 'rendering',
			Kind: 'pending',
			Error: '',
			IFrame: null,
			State: null,
			Touched: false,
			LastActiveAt: Date.now(),
			Timing: { ClickedAt: this._now(), RenderMS: null, LoadMS: null, ReadyMS: null, FormLoad: null },
		};
		this.Frames[pIDDocument] = tmpEntry;
		this._framesByFrameID[tmpEntry.FrameID] = tmpEntry;
		return tmpEntry;
	}

	/**
	 * Render the document on the server and point a new iframe at the result. The session token lets the page use the
	 * document data the render put in it instead of fetching it again.
	 *
	 * @param {FrameEntry} pEntry
	 * @return {Promise<void>}
	 */
	async _renderIntoFrame(pEntry)
	{
		const tmpRender = this.render;
		if (!tmpRender)
		{
			this._failEntry(pEntry, 'The document viewer is not available.');
			return;
		}
		let tmpResult;
		let tmpToken = null;
		try
		{
			[ tmpResult, tmpToken ] = await Promise.all(
				[
					new Promise((fResolve, fReject) =>
					{
						tmpRender.renderDocument(pEntry.IDDocument, 'default', (pError, pResult) =>
						{
							if (pError)
							{
								fReject(pError);
								return;
							}
							fResolve(pResult);
						});
					}),
					new Promise((fResolve) =>
					{
						tmpRender.getCheckoutSessionToken((pError, pToken) =>
						{
							fResolve((!pError && pToken && pToken.Token) ? pToken.Token : null);
						});
					}),
				]);
		}
		catch (pError)
		{
			this._failEntry(pEntry, `Could not open the document: ${(pError && pError.message) ? pError.message : pError}`);
			return;
		}
		if (this.Frames[pEntry.IDDocument] !== pEntry)
		{
			// Closed (or replaced) while the render was in flight.
			return;
		}
		pEntry.Timing.RenderMS = Math.round(this._now() - pEntry.Timing.ClickedAt);
		const tmpParameters = new URLSearchParams();
		if (tmpToken)
		{
			tmpParameters.set('SessionToken', tmpToken);
		}
		tmpParameters.set(FRAME_PARAMETER, pEntry.FrameID);
		const tmpURL = `${tmpResult.IndexURL}${(tmpResult.IndexURL.indexOf('?') > -1) ? '&' : '?'}${tmpParameters.toString()}`;

		const tmpIFrame = document.createElement('iframe');
		tmpIFrame.className = 'dfs-frame';
		tmpIFrame.title = this._documentLabel(pEntry.IDDocument);
		tmpIFrame.setAttribute('data-id-document', String(pEntry.IDDocument));
		// Forms scan QR codes with the camera and stamp locations, as they do when opened on their own.
		tmpIFrame.setAttribute('allow', 'camera; geolocation; clipboard-read; clipboard-write; fullscreen');
		tmpIFrame.addEventListener('load', () =>
		{
			this._onFrameLoad(pEntry);
		});
		tmpIFrame.src = tmpURL;
		pEntry.IFrame = tmpIFrame;
		pEntry.Phase = 'loading';
		this._ensureLayer();
		const tmpFrames = this._layer.querySelector('.dfs-frames');
		tmpFrames.appendChild(tmpIFrame);
		this._syncFrameVisibility();
		this._renderChrome();
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_onFrameLoad(pEntry)
	{
		if (pEntry.Timing.LoadMS === null)
		{
			pEntry.Timing.LoadMS = Math.round(this._now() - pEntry.Timing.ClickedAt);
		}
		let tmpWindow = null;
		try
		{
			tmpWindow = pEntry.IFrame.contentWindow;
			// A frame that cannot report whether it holds unsaved work is guarded by whether anyone typed in it.
			tmpWindow.document.addEventListener('input', () =>
			{
				this._noteTouched(pEntry);
			}, true);
			tmpWindow.document.addEventListener('change', () =>
			{
				this._noteTouched(pEntry);
			}, true);
		}
		catch (pError)
		{
			tmpWindow = null;
		}
		const tmpPict = tmpWindow && tmpWindow._Pict;
		if (tmpPict && tmpPict.providers && tmpPict.providers.DocumentFrame && tmpPict.providers.DocumentFrame.Enabled)
		{
			pEntry.Kind = 'form';
			if (pEntry.State && pEntry.State.Ready && !pEntry.State.ReloadPending)
			{
				pEntry.Phase = 'ready';
			}
		}
		else
		{
			pEntry.Kind = tmpPict ? 'untracked' : 'classic';
			pEntry.Phase = 'ready';
			pEntry.State = null;
			this._recordTiming(pEntry);
		}
		this._rememberKind(pEntry);
		this._renderChrome();
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_noteTouched(pEntry)
	{
		if (pEntry.Kind === 'form')
		{
			return;
		}
		if (!pEntry.Touched)
		{
			pEntry.Touched = true;
			this._renderChrome();
		}
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @param {String} pMessage
	 * @return {void}
	 */
	_failEntry(pEntry, pMessage)
	{
		pEntry.Phase = 'error';
		pEntry.Error = pMessage;
		this.pict.log.error(`[DocFrames] document ${pEntry.IDDocument}: ${pMessage}`);
		this._renderChrome();
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_activate(pEntry)
	{
		this.ActiveID = pEntry.IDDocument;
		pEntry.LastActiveAt = Date.now();
		this._syncFrameVisibility();
		this._renderChrome();
	}

	/** Close the least recently viewed frames past MAX_LIVE_FRAMES that are safe to close. */
	_closeIdleFrames()
	{
		const tmpEntries = Object.values(this.Frames);
		if (tmpEntries.length <= MAX_LIVE_FRAMES)
		{
			return;
		}
		const tmpClosable = tmpEntries
			.filter((pEntry) => (pEntry.IDDocument !== this.ActiveID) && this._isSafeToClose(pEntry))
			.sort((pA, pB) => pA.LastActiveAt - pB.LastActiveAt);
		let tmpExcess = tmpEntries.length - MAX_LIVE_FRAMES;
		for (const tmpEntry of tmpClosable)
		{
			if (tmpExcess <= 0)
			{
				break;
			}
			this.pict.log.info(`[DocFrames] closing idle document ${tmpEntry.IDDocument} (more than ${MAX_LIVE_FRAMES} open).`);
			this._removeFrame(tmpEntry);
			delete this.Frames[tmpEntry.IDDocument];
			tmpExcess--;
		}
		if (tmpExcess > 0)
		{
			this.pict.log.warn(`[DocFrames] ${tmpEntries.length} documents open; the rest hold unsaved work or are still loading, so they stay open.`);
		}
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @return {boolean}
	 */
	_isSafeToClose(pEntry)
	{
		if (pEntry.Phase === 'error')
		{
			return true;
		}
		if (pEntry.Phase !== 'ready')
		{
			return false;
		}
		return !this._unsavedReason(pEntry);
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_removeFrame(pEntry)
	{
		if (pEntry.IFrame && pEntry.IFrame.parentNode)
		{
			pEntry.IFrame.parentNode.removeChild(pEntry.IFrame);
		}
		pEntry.IFrame = null;
		delete this._framesByFrameID[pEntry.FrameID];
		if (this.ActiveID === pEntry.IDDocument)
		{
			this.ActiveID = 0;
		}
	}

	// --- actions from the chrome -------------------------------------------------------------------------------------

	/** Reload the active document from the server. Asks first when it holds unsaved work. */
	reloadActive()
	{
		const tmpEntry = this.Frames[this.ActiveID];
		if (!tmpEntry)
		{
			return;
		}
		if (this._unsavedReason(tmpEntry) && !window.confirm(`Reload "${this._documentLabel(tmpEntry.IDDocument)}"? Your unsaved changes in it will be lost.`))
		{
			return;
		}
		const tmpID = tmpEntry.IDDocument;
		this._removeFrame(tmpEntry);
		delete this.Frames[tmpID];
		this.open(tmpID);
	}

	/** Open the active document in its own browser tab, the longhand way. */
	openActiveInNewTab()
	{
		const tmpID = this.ActiveID;
		if (!tmpID || !this.render || (typeof this.render.openDocument !== 'function'))
		{
			return;
		}
		this.render.openDocument(tmpID, { target: '_blank', variation: 'default' }, (pError) =>
		{
			if (pError)
			{
				this.pict.log.error(`[DocFrames] opening document ${tmpID} in a new tab failed: ${pError.message || pError}`);
			}
		});
	}

	/** Toggle the switcher between its place in the page and the whole browser view. */
	toggleFullscreen()
	{
		this.Fullscreen = !this.Fullscreen;
		if (this._layer)
		{
			this._layer.classList.toggle('dfs-is-fs', this.Fullscreen);
		}
		this._syncLayerPosition();
		this._renderChrome();
	}

	/**
	 * Save every open form that reports unsaved changes, through its own Save.
	 *
	 * @return {Promise<Array<{ IDDocument: number, Error: ?String }>>}
	 */
	async saveAllUnsaved()
	{
		const tmpTargets = Object.values(this.Frames).filter((pEntry) => (pEntry.Kind === 'form') && pEntry.State && pEntry.State.HasUnsavedChanges);
		const tmpResults = await Promise.all(tmpTargets.map(async (pEntry) =>
		{
			const tmpReply = await this._request(pEntry, 'save');
			if (tmpReply && tmpReply.state)
			{
				pEntry.State = tmpReply.state;
			}
			return { IDDocument: pEntry.IDDocument, Error: tmpReply ? tmpReply.error : 'The form did not answer.' };
		}));
		this._renderChrome();
		return tmpResults;
	}

	/**
	 * The bar's Save button: save every open form with unsaved changes and say how it went.
	 * @return {Promise<void>}
	 */
	async saveAllFromChrome()
	{
		const tmpResults = await this.saveAllUnsaved();
		const tmpFailed = tmpResults.filter((pResult) => pResult.Error);
		if (tmpFailed.length)
		{
			this._toast(`Could not save ${tmpFailed.map((pResult) => `"${this._documentLabel(pResult.IDDocument)}"`).join(', ')}.`, 'error');
		}
		else if (tmpResults.length)
		{
			this._toast(tmpResults.length === 1 ? 'Document saved.' : `${tmpResults.length} documents saved.`, 'success');
		}
	}

	// --- unsaved-work guard ------------------------------------------------------------------------------------------

	/**
	 * Why a frame may hold unsaved work, or '' when it does not.
	 *
	 * @param {FrameEntry} pEntry
	 * @return {String}
	 */
	_unsavedReason(pEntry)
	{
		if (!pEntry.IFrame)
		{
			return '';
		}
		if (pEntry.Kind === 'form')
		{
			if (pEntry.State && (pEntry.State.Saving || pEntry.State.ApprovalBusy))
			{
				return 'saving';
			}
			return (pEntry.State && pEntry.State.HasUnsavedChanges) ? 'unsaved' : '';
		}
		return pEntry.Touched ? 'maybe' : '';
	}

	/** @return {Array<FrameEntry>} The frames that hold, or may hold, unsaved work. */
	framesWithUnsavedWork()
	{
		return Object.values(this.Frames).filter((pEntry) => !!this._unsavedReason(pEntry));
	}

	/** @return {boolean} */
	hasUnsavedWork()
	{
		return this.framesWithUnsavedWork().length > 0;
	}

	/**
	 * Ask before discarding open documents with unsaved work.
	 *
	 * @return {boolean} True when it is fine to close them.
	 */
	confirmDiscard()
	{
		const tmpFrames = this.framesWithUnsavedWork();
		if (!tmpFrames.length)
		{
			return true;
		}
		const tmpNames = tmpFrames.map((pEntry) => `• ${this._documentLabel(pEntry.IDDocument)}${(this._unsavedReason(pEntry) === 'maybe') ? ' (may have changes)' : ''}`).join('\n');
		return window.confirm(`These open documents have changes that are not saved:\n\n${tmpNames}\n\nLeave and lose them?`);
	}

	/** @param {BeforeUnloadEvent} pEvent */
	_onBeforeUnload(pEvent)
	{
		if (!this.hasUnsavedWork())
		{
			return;
		}
		pEvent.preventDefault();
		pEvent.returnValue = '';
	}

	/** Leaving the record (a hash it does not match) closes its frames, after asking when they hold unsaved work. */
	_onHashChange()
	{
		const tmpNewHash = window.location.hash;
		const tmpOldHash = this._lastHash;
		this._lastHash = tmpNewHash;
		if (this._restoringHash)
		{
			this._restoringHash = false;
			return;
		}
		if (!this.OwnerKey || this._ownerMatch(tmpNewHash))
		{
			return;
		}
		if (this.hasUnsavedWork() && !this.confirmDiscard())
		{
			this._restoringHash = true;
			this._lastHash = tmpOldHash;
			window.location.hash = tmpOldHash;
			return;
		}
		this.teardown();
	}

	/** @param {KeyboardEvent} pEvent */
	_onKeydown(pEvent)
	{
		if ((pEvent.key === 'Escape') && this.Fullscreen)
		{
			this.toggleFullscreen();
		}
	}

	// --- messages from the frames ------------------------------------------------------------------------------------

	/**
	 * A DocumentFrame message, trusted only from the frame it names and from this origin.
	 * @param {MessageEvent} pEvent
	 */
	_onMessage(pEvent)
	{
		const tmpData = pEvent.data;
		if (!tmpData || (tmpData.channel !== CHANNEL) || (pEvent.origin !== window.location.origin))
		{
			return;
		}
		const tmpEntry = this._framesByFrameID[tmpData.frameId];
		if (!tmpEntry || !tmpEntry.IFrame || (pEvent.source !== tmpEntry.IFrame.contentWindow))
		{
			return;
		}
		if (tmpData.requestId && this._pendingRequests[tmpData.requestId])
		{
			const tmpPending = this._pendingRequests[tmpData.requestId];
			delete this._pendingRequests[tmpData.requestId];
			clearTimeout(tmpPending.timer);
			tmpPending.resolve(tmpData);
		}
		if (tmpData.state)
		{
			tmpEntry.State = tmpData.state;
			// An approval action can change the status without the form reloading, so any state message may carry it.
			this._syncDocumentStatus(tmpEntry);
		}
		tmpEntry.Kind = 'form';
		if (tmpData.type === 'ready')
		{
			tmpEntry.Phase = 'ready';
			tmpEntry.Timing.FormLoad = tmpData.timing || null;
			this._recordTiming(tmpEntry);
			this._rememberKind(tmpEntry);
		}
		else if (tmpEntry.State && tmpEntry.State.ReloadPending)
		{
			// An approval action landed and the form is reloading itself; the next ready brings the new status.
			tmpEntry.Phase = 'loading';
		}
		this._renderChrome();
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @param {String} pType
	 * @return {Promise<any>} The reply, or null if the frame did not answer in time.
	 */
	_request(pEntry, pType)
	{
		return new Promise((fResolve) =>
		{
			if (!pEntry.IFrame || !pEntry.IFrame.contentWindow)
			{
				fResolve(null);
				return;
			}
			this._requestSerial++;
			const tmpRequestID = `${pEntry.FrameID}-r${this._requestSerial}`;
			const tmpTimer = setTimeout(() =>
			{
				delete this._pendingRequests[tmpRequestID];
				fResolve(null);
			}, REQUEST_TIMEOUT_MS);
			this._pendingRequests[tmpRequestID] = { resolve: fResolve, timer: tmpTimer };
			pEntry.IFrame.contentWindow.postMessage({ channel: CHANNEL, frameId: pEntry.FrameID, type: pType, requestId: tmpRequestID }, window.location.origin);
		});
	}

	/**
	 * Carry the status a frame reports back onto the list row, so the rail stays right after an approval action.
	 *
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_syncDocumentStatus(pEntry)
	{
		if (!pEntry.State || !pEntry.State.Status)
		{
			return;
		}
		const tmpDocument = this.Documents.find((pDocument) => Number(pDocument.IDDocument) === pEntry.IDDocument);
		if (tmpDocument)
		{
			tmpDocument.Status = pEntry.State.Status;
		}
	}

	/**
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_rememberKind(pEntry)
	{
		const tmpDocument = this.Documents.find((pDocument) => Number(pDocument.IDDocument) === pEntry.IDDocument);
		if (tmpDocument && tmpDocument.DocumentType && (pEntry.Kind !== 'pending'))
		{
			this._kindByType[tmpDocument.DocumentType] = pEntry.Kind;
		}
	}

	/**
	 * One `[DocFrames]` line per open: click to server render, to the page's load event, to the form drawn — plus the
	 * form's own `[FormLoad]` phases when it reports them. Kept on `Timings` for a harness to read.
	 *
	 * @param {FrameEntry} pEntry
	 * @return {void}
	 */
	_recordTiming(pEntry)
	{
		if (pEntry.Timing.ReadyMS !== null)
		{
			return;
		}
		pEntry.Timing.ReadyMS = Math.round(this._now() - pEntry.Timing.ClickedAt);
		const tmpDocument = this.Documents.find((pDocument) => Number(pDocument.IDDocument) === pEntry.IDDocument) || {};
		const tmpRecord =
		{
			IDDocument: pEntry.IDDocument,
			DocumentType: tmpDocument.DocumentType || '',
			Kind: pEntry.Kind,
			RenderMS: pEntry.Timing.RenderMS,
			LoadMS: pEntry.Timing.LoadMS,
			ReadyMS: pEntry.Timing.ReadyMS,
			FormLoad: pEntry.Timing.FormLoad,
		};
		this.Timings.push(tmpRecord);
		const tmpFormLoad = (tmpRecord.FormLoad && tmpRecord.FormLoad.TotalMS !== undefined) ? `, form ${tmpRecord.FormLoad.TotalMS}ms from frame navigation` : '';
		this.pict.log.info(`[DocFrames] document ${tmpRecord.IDDocument} (${tmpRecord.DocumentType || 'unknown type'}, ${tmpRecord.Kind}): render ${tmpRecord.RenderMS}ms, page load ${tmpRecord.LoadMS}ms, ready ${tmpRecord.ReadyMS}ms after click${tmpFormLoad}`);
	}

	// --- layer, positioning and chrome -------------------------------------------------------------------------------

	/** Create the layer the frames live in, once, outside any markup a repaint replaces. */
	_ensureLayer()
	{
		if (this._layer && document.body.contains(this._layer))
		{
			return;
		}
		const tmpLayer = document.createElement('div');
		tmpLayer.id = LAYER_ID;
		tmpLayer.className = 'dfs';
		tmpLayer.style.display = 'none';
		tmpLayer.innerHTML = '<div class="dfs-stage"><div class="dfs-bar"></div><div class="dfs-frames"><div class="dfs-placeholder"></div></div></div><aside class="dfs-rail"></aside>';
		document.body.appendChild(tmpLayer);
		this._layer = tmpLayer;
		this._railMarkup = null;
	}

	/** Track the anchor every animation frame while a record is attached. */
	_startPositionSync()
	{
		if (this._rafHandle || (typeof window.requestAnimationFrame !== 'function'))
		{
			return;
		}
		const fTick = () =>
		{
			this._syncLayerPosition();
			this._rafHandle = window.requestAnimationFrame(fTick);
		};
		this._rafHandle = window.requestAnimationFrame(fTick);
	}

	/** Stop tracking the anchor. */
	_stopPositionSync()
	{
		if (this._rafHandle)
		{
			window.cancelAnimationFrame(this._rafHandle);
			this._rafHandle = null;
		}
	}

	/**
	 * The lowest point of the window a frame can use: the window's bottom edge, or the top of the app's Bulma fixed bottom
	 * navbar when one is showing.
	 *
	 * @return {number} - The visible bottom edge, in viewport pixels.
	 */
	_visibleBottom()
	{
		const tmpNavbar = document.querySelector('.navbar.is-fixed-bottom');
		if (tmpNavbar && (tmpNavbar.offsetHeight > 0))
		{
			return Math.min(window.innerHeight, tmpNavbar.getBoundingClientRect().top);
		}
		return window.innerHeight;
	}

	/**
	 * Lay the layer over the anchor while it is on screen; hide it (frames stay alive) while it is not. The layer stops at
	 * the visible bottom of the window, so a form's bottom bar is never below the fold or under the app's footer.
	 */
	_syncLayerPosition()
	{
		if (!this._layer)
		{
			return;
		}
		const tmpAnchor = this._anchorID ? document.getElementById(this._anchorID) : null;
		const tmpVisible = !!(tmpAnchor && tmpAnchor.offsetParent);
		if (!tmpVisible)
		{
			if (this._layer.style.display !== 'none')
			{
				this._layer.style.display = 'none';
			}
			if (this.Fullscreen)
			{
				this.Fullscreen = false;
				this._layer.classList.remove('dfs-is-fs');
			}
			return;
		}
		if (this._layer.style.display === 'none')
		{
			this._layer.style.display = '';
		}
		if (this.Fullscreen)
		{
			return;
		}
		const tmpRect = tmpAnchor.getBoundingClientRect();
		const tmpStyle = this._layer.style;
		const tmpTop = `${Math.round(tmpRect.top)}px`;
		const tmpLeft = `${Math.round(tmpRect.left)}px`;
		const tmpWidth = `${Math.round(tmpRect.width)}px`;
		const tmpHeight = `${Math.max(0, Math.round(Math.min(tmpRect.bottom, this._visibleBottom()) - tmpRect.top))}px`;
		if ((tmpStyle.top !== tmpTop) || (tmpStyle.left !== tmpLeft) || (tmpStyle.width !== tmpWidth) || (tmpStyle.height !== tmpHeight))
		{
			tmpStyle.top = tmpTop;
			tmpStyle.left = tmpLeft;
			tmpStyle.width = tmpWidth;
			tmpStyle.height = tmpHeight;
		}
	}

	/** Show the active frame; the others stay loaded but hidden. */
	_syncFrameVisibility()
	{
		for (const tmpEntry of Object.values(this.Frames))
		{
			if (tmpEntry.IFrame)
			{
				tmpEntry.IFrame.classList.toggle('dfs-frame-active', tmpEntry.IDDocument === this.ActiveID);
			}
		}
	}

	/** Repaint the rail, the bar and the placeholder. Never touches the frames. */
	_renderChrome()
	{
		if (!this._layer)
		{
			return;
		}
		const tmpRail = this._layer.querySelector('.dfs-rail');
		const tmpBar = this._layer.querySelector('.dfs-bar');
		const tmpPlaceholder = this._layer.querySelector('.dfs-placeholder');
		// The hover cards are part of what the rail shows, so a change to one alone repaints too.
		const tmpRailMarkup = [ this._railHTML() ].concat(this.Documents.map((pDocument) => (this._hasDetails(pDocument) ? this._tooltipHTML(pDocument) : ''))).join('\u0000');
		if (tmpRailMarkup !== this._railMarkup)
		{
			this._destroyRailTooltips();
			tmpRail.innerHTML = this._railHTML();
			this._railMarkup = tmpRailMarkup;
			this._attachRailTooltips(tmpRail);
		}
		tmpBar.innerHTML = this._barHTML();
		const tmpActive = this.Frames[this.ActiveID];
		if (!tmpActive)
		{
			tmpPlaceholder.style.display = '';
			tmpPlaceholder.innerHTML = this.Documents.length ?
				'<i class="fas fa-hand-pointer"></i><p>Choose a document on the right to open it here.</p>' :
				'<i class="fas fa-inbox"></i><p>No documents are attached to this sample.</p>';
		}
		else if (tmpActive.Phase === 'error')
		{
			tmpPlaceholder.style.display = '';
			tmpPlaceholder.innerHTML = `<i class="fas fa-triangle-exclamation"></i><p>${this._esc(tmpActive.Error)}</p><button class="button is-small is-light" onclick="_Pict.providers.DocumentFrameSwitcher.reloadActive()">Try again</button>`;
		}
		else if (!tmpActive.IFrame || (tmpActive.Phase !== 'ready'))
		{
			// The frame paints its own loading splash once it has a page; until then say what is happening.
			tmpPlaceholder.style.display = tmpActive.IFrame ? 'none' : '';
			tmpPlaceholder.innerHTML = '<span class="dfs-spinner"></span><p>Opening the document…</p>';
		}
		else
		{
			tmpPlaceholder.style.display = 'none';
		}
	}

	/** @return {String} The bar above the active document. */
	_barHTML()
	{
		const tmpEntry = this.Frames[this.ActiveID];
		const tmpUnsavedCount = Object.values(this.Frames).filter((pFrame) => (pFrame.Kind === 'form') && pFrame.State && pFrame.State.HasUnsavedChanges).length;
		const tmpSaveLabel = (tmpUnsavedCount === 1) ? '1 unsaved document' : `${tmpUnsavedCount} unsaved documents`;
		const tmpSaveAll = tmpUnsavedCount ?
			`<button class="dfs-btn dfs-btn-primary" onclick="_Pict.providers.DocumentFrameSwitcher.saveAllFromChrome()" title="Save every open document with unsaved changes"><i class="fas fa-floppy-disk"></i> Save ${tmpSaveLabel}</button>` :
			'';
		const tmpTitle = tmpEntry ? `<span class="dfs-bar-title">${this._esc(this._documentLabel(tmpEntry.IDDocument))}</span>${(tmpEntry.Kind === 'classic') ? '<span class="dfs-badge">Classic form</span>' : ''}` : '<span class="dfs-bar-title dfs-muted">Documents</span>';
		const tmpDocActions = tmpEntry ?
			`<button class="dfs-btn" onclick="_Pict.providers.DocumentFrameSwitcher.reloadActive()" title="Reload this document from the server"><i class="fas fa-rotate"></i></button>
				<button class="dfs-btn" onclick="_Pict.providers.DocumentFrameSwitcher.openActiveInNewTab()" title="Open in a new tab"><i class="fas fa-up-right-from-square"></i></button>` :
			'';
		const tmpFullscreen = `<button class="dfs-btn" onclick="_Pict.providers.DocumentFrameSwitcher.toggleFullscreen()" title="${this.Fullscreen ? 'Exit full screen (Esc)' : 'Full screen'}"><i class="fas ${this.Fullscreen ? 'fa-compress' : 'fa-expand'}"></i></button>`;
		return `<div class="dfs-bar-left">${tmpTitle}</div><div class="dfs-bar-right">${tmpSaveAll}${tmpDocActions}${tmpFullscreen}</div>`;
	}

	/** @return {String} The quick-switch list of the record's documents. */
	_railHTML()
	{
		const tmpNote = this.RailNote ? `<div class="dfs-rail-note"><i class="fas fa-lock"></i><span>${this._esc(this.RailNote)}</span></div>` : '';
		if (!this.Documents.length)
		{
			return `<div class="dfs-rail-empty">No documents</div>${tmpNote}`;
		}
		const tmpItems = this.Documents.map((pDocument) =>
		{
			const tmpID = Number(pDocument.IDDocument);
			const tmpEntry = this.Frames[tmpID];
			const tmpKind = tmpEntry && (tmpEntry.Kind !== 'pending') ? tmpEntry.Kind : (this._kindByType[pDocument.DocumentType] || '');
			const tmpStatus = (tmpEntry && tmpEntry.State && tmpEntry.State.Status) || pDocument.Status || '';
			const tmpClasses = [ 'dfs-item' ];
			if (tmpID === this.ActiveID)
			{
				tmpClasses.push('is-active');
			}
			if (tmpKind === 'classic')
			{
				tmpClasses.push('is-classic');
			}
			const tmpTitle = this._hasDetails(pDocument) ? '' : ` title="${this._esc(this._documentLabel(tmpID))}"`;
			return `<button class="${tmpClasses.join(' ')}" data-dfs-id="${tmpID}" onclick="_Pict.providers.DocumentFrameSwitcher.open(${tmpID})"${tmpTitle}>
				<span class="dfs-item-main">
					<span class="dfs-item-name">${this._esc(pDocument.Name || `Document #${tmpID}`)}</span>
					<span class="dfs-item-meta">${this._testsHTML(pDocument)}${(tmpKind === 'classic') ? ' · Classic' : ''}</span>
				</span>
				<span class="dfs-item-side">
					${tmpStatus ? `<span class="dfs-chip">${this._esc(tmpStatus)}</span>` : ''}
					${this._indicatorHTML(tmpEntry)}
				</span>
			</button>`;
		}).join('');
		return `<div class="dfs-rail-head">Documents <span class="dfs-muted">${this.Documents.length}</span></div><div class="dfs-rail-list">${tmpItems}</div>${tmpNote}`;
	}

	/**
	 * @param {?FrameEntry} pEntry
	 * @return {String}
	 */
	_indicatorHTML(pEntry)
	{
		if (!pEntry)
		{
			return '';
		}
		if (pEntry.Phase === 'error')
		{
			return '<i class="fas fa-triangle-exclamation dfs-ind dfs-ind-error" title="Could not open"></i>';
		}
		if ((pEntry.Phase === 'rendering') || (pEntry.Phase === 'loading'))
		{
			return '<span class="dfs-spinner dfs-ind" title="Opening"></span>';
		}
		const tmpReason = this._unsavedReason(pEntry);
		if (tmpReason === 'saving')
		{
			return '<span class="dfs-spinner dfs-ind" title="Saving"></span>';
		}
		if (tmpReason === 'unsaved')
		{
			return '<span class="dfs-dot dfs-dot-unsaved" title="Unsaved changes"></span>';
		}
		if (tmpReason === 'maybe')
		{
			return '<span class="dfs-dot dfs-dot-maybe" title="Edited here; this form saves on its own terms"></span>';
		}
		if (pEntry.State && (pEntry.State.Locked || !pEntry.State.CanEdit))
		{
			return `<i class="fas ${pEntry.State.Locked ? 'fa-lock' : 'fa-eye'} dfs-ind" title="${pEntry.State.Locked ? 'Locked' : 'Read only'}"></i>`;
		}
		return '<span class="dfs-dot dfs-dot-open" title="Open"></span>';
	}

	/**
	 * The rail's second line: the document's test codes, or its form's name when it names none and the document's own
	 * name doesn't already say it. Never the form's hash. When some tests are the record's own, the others are muted.
	 * @param {SwitcherDocument} pDocument
	 * @return {String}
	 */
	_testsHTML(pDocument)
	{
		const tmpTests = Array.isArray(pDocument.Tests) ? pDocument.Tests : [];
		if (!tmpTests.length)
		{
			const tmpFormName = String(pDocument.FormName || '').trim();
			return (tmpFormName && (tmpFormName.toLowerCase() !== String(pDocument.Name || '').trim().toLowerCase())) ? this._esc(tmpFormName) : '';
		}
		const tmpAnyAssigned = tmpTests.some((pTest) => pTest.Assigned);
		return tmpTests.map((pTest) => `<span class="dfs-test${(tmpAnyAssigned && !pTest.Assigned) ? ' is-other' : ''}">${this._esc(pTest.Code)}</span>`).join('<span class="dfs-test-sep"> · </span>');
	}

	/**
	 * @param {SwitcherDocument} pDocument
	 * @return {boolean} Whether the document has tests or media to show in a tooltip.
	 */
	_hasDetails(pDocument)
	{
		return !!(this._modal() && ((Array.isArray(pDocument.Tests) && pDocument.Tests.length) || this._mediaEntries(pDocument).length));
	}

	/** @return {any} pict-section-modal, when the app has it. */
	_modal()
	{
		const tmpModal = this.pict.views && this.pict.views['Pict-Section-Modal'];
		return (tmpModal && (typeof tmpModal.richTooltip === 'function')) ? tmpModal : null;
	}

	/**
	 * @param {SwitcherDocument} pDocument
	 * @return {Array<{ Kind: String, Count: number }>} The document's media, by kind, in display order.
	 */
	_mediaEntries(pDocument)
	{
		const tmpMedia = pDocument.Media || {};
		return [ 'image', 'video', 'audio', 'file' ].map((pKind) => ({ Kind: pKind, Count: Number(tmpMedia[pKind]) || 0 })).filter((pEntry) => pEntry.Count > 0);
	}

	/**
	 * The hover card for a document: its form, its tests (the record's own marked, with their results) and its media counts.
	 * @param {SwitcherDocument} pDocument
	 * @return {String}
	 */
	_tooltipHTML(pDocument)
	{
		const tmpTests = Array.isArray(pDocument.Tests) ? pDocument.Tests : [];
		const tmpAnyAssigned = tmpTests.some((pTest) => pTest.Assigned);
		const tmpRows = tmpTests.map((pTest) =>
			`<tr class="${(tmpAnyAssigned && !pTest.Assigned) ? 'is-other' : ''}">
				<td class="dfs-tip-plan">${pTest.Assigned ? '<i class="fas fa-link" aria-label="Linked to this sample"></i>' : ''}</td>
				<td class="dfs-tip-code">${this._esc(pTest.Code)}</td>
				<td>${this._esc(pTest.Name || '')}</td>
				<td class="dfs-tip-result">${pTest.Result ? `<span class="dfs-result is-${this._esc(pTest.ResultTone || 'info')}">${this._esc(pTest.Result)}</span>` : ''}</td>
			</tr>`).join('');
		const tmpMedia = this._mediaEntries(pDocument).map((pEntry) =>
		{
			const tmpLabel = `${pEntry.Count} ${MEDIA_LABELS[pEntry.Kind][(pEntry.Count === 1) ? 0 : 1]}`;
			return `<span class="dfs-tip-media-item"><i class="fas ${MEDIA_LABELS[pEntry.Kind][2]}"></i> ${this._esc(tmpLabel)}</span>`;
		}).join('');
		return [
			`<div class="dfs-tip-title">${this._esc(pDocument.FormName || pDocument.Name || '')}</div>`,
			tmpRows ? `<table class="dfs-tip-tests">${tmpRows}</table>` : '',
			tmpMedia ? `<div class="dfs-tip-media">${tmpMedia}</div>` : '',
		].join('');
	}

	/**
	 * Attach a hover card to each rail item that has tests or media.
	 * @param {HTMLElement} pRail
	 */
	_attachRailTooltips(pRail)
	{
		const tmpModal = this._modal();
		if (!tmpModal)
		{
			return;
		}
		for (const tmpDocument of this.Documents)
		{
			const tmpItem = pRail.querySelector(`.dfs-item[data-dfs-id="${Number(tmpDocument.IDDocument)}"]`);
			if (tmpItem && this._hasDetails(tmpDocument))
			{
				this._railTooltips.push(tmpModal.richTooltip(tmpItem, this._tooltipHTML(tmpDocument), { position: 'left', maxWidth: '360px', className: 'dfs-tip' }));
			}
		}
	}

	/** Remove the rail's hover cards, open or not. */
	_destroyRailTooltips()
	{
		for (const tmpTooltip of this._railTooltips)
		{
			if (tmpTooltip && (typeof tmpTooltip.destroy === 'function'))
			{
				tmpTooltip.destroy();
			}
		}
		this._railTooltips = [];
	}

	// --- helpers -----------------------------------------------------------------------------------------------------

	/**
	 * @param {number} pIDDocument
	 * @return {String}
	 */
	_documentLabel(pIDDocument)
	{
		const tmpDocument = this.Documents.find((pDocument) => Number(pDocument.IDDocument) === Number(pIDDocument));
		return (tmpDocument && tmpDocument.Name) ? tmpDocument.Name : `Document #${pIDDocument}`;
	}

	/** @return {number} Milliseconds, high resolution where available. */
	_now()
	{
		return ((typeof performance !== 'undefined') && (typeof performance.now === 'function')) ? performance.now() : Date.now();
	}

	/**
	 * @param {String} pMessage
	 * @param {String} pType - 'success' or 'error'.
	 */
	_toast(pMessage, pType)
	{
		try
		{
			const tmpPanels = this.pict.views.HeadlightPanels;
			if (tmpPanels && (typeof tmpPanels.toast === 'function'))
			{
				tmpPanels.toast({ type: (pType === 'error') ? 'is-danger' : 'is-success', message: pMessage });
				return;
			}
		}
		catch (pError)
		{
			// Fall through to the log.
		}
		this.pict.log.info(`[DocFrames] ${pMessage}`);
	}

	/**
	 * @param {any} pValue
	 * @return {String} The value, escaped for HTML text and attributes.
	 */
	_esc(pValue)
	{
		return String((pValue === undefined || pValue === null) ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

const _CSS = /*css*/`
	.dfs { position: fixed; z-index: 25; display: flex; gap: 0.6rem; box-sizing: border-box; }
	.dfs.dfs-is-fs { inset: 0 !important; width: auto !important; height: auto !important; z-index: 1100; padding: 0.6rem; background: var(--theme-color-background-tertiary, #f3f4f6); transform: translateZ(0); }
	.dfs-stage { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-primary, #fff); }
	.dfs-bar { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.4rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-secondary, #f7f9fb); }
	.dfs-bar-left { display: flex; align-items: center; gap: 0.5rem; min-width: 0; }
	.dfs-bar-right { display: flex; align-items: center; gap: 0.35rem; }
	.dfs-bar-title { font-weight: 600; font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.dfs-muted { color: var(--theme-color-text-muted, #8a94a3); font-weight: 500; }
	.dfs-badge { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; padding: 0.1rem 0.45rem; }
	.dfs-badge { border-radius: 999px; background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-muted, #6b7686); border: 1px dashed var(--theme-color-border-medium, #d5dbe3); }
	.dfs-btn { display: inline-flex; align-items: center; gap: 0.35rem; font: inherit; font-size: 0.78rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
	.dfs-btn { background: var(--theme-color-background-primary, #fff); border: 1px solid var(--theme-color-border-medium, #d5dbe3); border-radius: 7px; padding: 0.28rem 0.55rem; cursor: pointer; white-space: nowrap; }
	.dfs-btn:hover { border-color: var(--theme-color-brand-primary, #5650e6); color: var(--theme-color-brand-primary, #5650e6); }
	.dfs-btn-primary { color: #fff; background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); }
	.dfs-btn-primary:hover { color: #fff; filter: brightness(1.08); }
	.dfs-frames { position: relative; flex: 1 1 auto; min-height: 0; }
	.dfs-frame { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; visibility: hidden; pointer-events: none; background: #fff; }
	.dfs-frame.dfs-frame-active { visibility: visible; pointer-events: auto; }
	.dfs-placeholder { position: absolute; inset: 0; z-index: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; }
	.dfs-placeholder { gap: 0.5rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.9rem; background: var(--theme-color-background-primary, #fff); text-align: center; padding: 1rem; }
	.dfs-placeholder .fas { font-size: 1.6rem; opacity: 0.5; }
	.dfs-rail { flex: 0 0 17rem; display: flex; flex-direction: column; min-height: 0; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; background: var(--theme-color-background-primary, #fff); overflow: hidden; }
	.dfs-rail-head { padding: 0.55rem 0.75rem; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.dfs-rail-list { flex: 1 1 auto; overflow-y: auto; padding: 0.3rem; display: flex; flex-direction: column; gap: 0.2rem; }
	.dfs-rail-empty { padding: 1rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.85rem; }
	.dfs-rail-note { flex: 0 0 auto; display: flex; gap: 0.45rem; align-items: baseline; padding: 0.6rem 0.75rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); font-size: 0.78rem; line-height: 1.35; color: var(--theme-color-text-muted, #6b7686); }
	.dfs-rail-note .fas { font-size: 0.72rem; opacity: 0.7; }
	.dfs-item { display: flex; align-items: center; justify-content: space-between; gap: 0.4rem; width: 100%; text-align: left; font: inherit; }
	.dfs-item { padding: 0.45rem 0.55rem; border: 1px solid transparent; border-radius: 8px; background: transparent; cursor: pointer; color: var(--theme-color-text-primary, #1f2733); }
	.dfs-item:hover { background: var(--theme-color-background-secondary, #f7f9fb); }
	.dfs-item.is-active { background: var(--theme-color-background-selected, #eef1f8); border-color: var(--theme-color-brand-primary, #5650e6); }
	.dfs-item.is-classic .dfs-item-name { font-style: italic; }
	.dfs-item-main { display: flex; flex-direction: column; min-width: 0; }
	.dfs-item-name { font-size: 0.84rem; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.dfs-item-meta { font-size: 0.7rem; color: var(--theme-color-text-muted, #8a94a3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.dfs-test { color: var(--theme-color-text-secondary, #45505f); font-weight: 600; }
	.dfs-test.is-other { color: var(--theme-color-text-muted, #8a94a3); font-weight: 500; }
	.pict-modal-tooltip.dfs-tip { z-index: 1120; font-size: 0.78rem; }
	.dfs-tip-title { font-weight: 700; margin-bottom: 0.3rem; }
	.dfs-tip-tests { border-collapse: collapse; }
	.dfs-tip-tests td { padding: 0.08rem 0.35rem 0.08rem 0; vertical-align: top; color: inherit; }
	.dfs-tip-tests tr.is-other { opacity: 0.6; }
	.dfs-tip-tests td.dfs-tip-plan { width: 1rem; color: var(--theme-color-brand-primary, #5650e6); }
	.dfs-tip-tests td.dfs-tip-result { white-space: nowrap; text-align: right; padding-left: 0.5rem; }
	.dfs-result { display: inline-block; font-size: 0.66rem; font-weight: 700; padding: 0.05rem 0.4rem; border-radius: 999px; --dfs-tone: var(--theme-color-status-info, #3e7bd6); }
	.dfs-result { color: var(--dfs-tone); background: color-mix(in srgb, var(--dfs-tone) 16%, transparent); border: 1px solid color-mix(in srgb, var(--dfs-tone) 40%, transparent); }
	.dfs-result.is-success { --dfs-tone: var(--theme-color-status-success, #2f8f5b); }
	.dfs-result.is-danger { --dfs-tone: var(--theme-color-status-danger, var(--theme-color-status-error, #c0392b)); }
	.dfs-result.is-warning { --dfs-tone: var(--theme-color-status-warning, #c98a12); }
	.dfs-result.is-muted { --dfs-tone: var(--theme-color-text-muted, #8a94a3); }
	.dfs-tip-code { font-weight: 700; white-space: nowrap; }
	.dfs-tip-media { display: flex; flex-wrap: wrap; gap: 0.3rem 0.75rem; margin-top: 0.4rem; padding-top: 0.35rem; border-top: 1px solid var(--theme-color-border-light, rgba(127,127,127,0.25)); }
	.dfs-tip-media-item { white-space: nowrap; }
	.dfs-tip-media-item .fas { opacity: 0.8; margin-right: 0.15rem; }
	.dfs-item-side { display: flex; align-items: center; gap: 0.35rem; flex: 0 0 auto; }
	.dfs-chip { font-size: 0.64rem; font-weight: 700; padding: 0.08rem 0.42rem; border-radius: 999px; background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-secondary, #45505f); }
	.dfs-dot { width: 0.55rem; height: 0.55rem; border-radius: 50%; display: inline-block; }
	.dfs-dot-open { background: var(--theme-color-border-medium, #c5ccd6); }
	.dfs-dot-unsaved { background: #d8a13b; box-shadow: 0 0 0 2px rgba(216,161,59,0.25); }
	.dfs-dot-maybe { background: transparent; border: 2px solid #d8a13b; }
	.dfs-ind { font-size: 0.72rem; color: var(--theme-color-text-muted, #8a94a3); }
	.dfs-ind-error { color: #b23b3b; }
	.dfs-spinner { width: 0.8rem; height: 0.8rem; border-radius: 50%; border: 2px solid var(--theme-color-border-medium, #d5dbe3); border-top-color: var(--theme-color-brand-primary, #5650e6); display: inline-block; animation: dfs-spin 0.8s linear infinite; }
	.dfs-placeholder .dfs-spinner { width: 1.4rem; height: 1.4rem; }
	@keyframes dfs-spin { to { transform: rotate(360deg); } }
	@media (max-width: 900px) { .dfs { flex-direction: column-reverse; } .dfs-rail { flex: 0 0 auto; max-height: max(30%, 6.5rem); } .dfs-rail-list { min-height: 3.5rem; } }
`;

module.exports = DocumentFrameSwitcherProvider;
module.exports.default_configuration = { ProviderIdentifier: 'DocumentFrameSwitcher' };
module.exports.MAX_LIVE_FRAMES = MAX_LIVE_FRAMES;

},{"headlight-configurable-application/source/providers/DocumentFrameProvider.js":34,"pict-provider":845}],1271:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

const libCustomerRecordManifests = require('../providers/CustomerRecordManifests-Merge.js');

/**
 * DocumentList — a net-new, filterable Documents (Reports + Forms) browse screen for the config app, built as the
 * document cognate of the Observation screen (one filter bar; List + Charts view switcher; embeddable + project-locked
 * in the Project workspace). Documents have NO Solr/search index (unlike observations) — the only document Solr code in
 * the API is dead/commented — so this is backed by Meadow: `GET /1.0/Documents/FilteredTo/<FBV~…~FBL~…>/<begin>/<cap>`
 * plus `/Documents/Count/FilteredTo/…` (the `Document` table is indexed on exactly the facet columns, so filtered
 * queries are fast; the risky case is an unscoped customer-wide scan). Reference impl: `web/document_search/`.
 *
 * A document's "reporting status" analog is its own approval `Status` (Draft → Submitted → Pending → Rejected →
 * Approved). `DocumentType` is a ReportNamedInstance hash (not a table) resolved to a display name where possible.
 *
 * Charts view computes its distributions with parallel `Count/FilteredTo` queries per facet value (status, type) —
 * the contract-safe fallback for "faceting" without a Solr index.
 *
 * NOT YET WIRED (needs a logged-in pass to validate the DocumentApproval state-machine contracts + test safely, since
 * transitions mutate real approval state): the approval ACTIONS (approve / reject / submit) and actionable-users. The
 * per-row/detail Status is shown read-only for now.
 */

// The document approval status vocabulary (from the API state machine: Draft → Submitted → Pending → Rejected → Approved).
const _STATUSES = [ 'Draft', 'Submitted', 'Pending', 'Rejected', 'Approved' ];
const _STATUS_COLOR = { Draft: '#8b98a3', Submitted: '#3a86a8', Pending: '#c98a2e', Rejected: '#bd6631', Approved: '#4f9d69' };
const _CAT = [ '#2e7d74', '#3a86a8', '#6a6fae', '#9a6fb0', '#b5734e', '#4f9d69', '#c2708f', '#7f8b3d', '#c98a2e', '#5a8bce' ];

class DocumentListProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#DocumentList-Host';
		this._filter = { SearchText: '', Types: [], Statuses: [], States: [], Authors: [], AuthorNames: {}, From: '', To: '', IDProject: 0, ProjectName: '', Form: '' };
		this._layout = libCustomerRecordManifests.documentBrowseLayout(null, null);
		this._projectNames = {};
		this._stateDropdownOpen = false;
		this._page = 0;
		this._cap = 25;
		this._total = 0;
		this._rows = [];
		this._authorNames = {};
		this._typeOptions = null;      // [{ Hash, Label }] resolved from ReportNamedInstance where possible
		this._typeGrouped = false;     // true once type display names resolved (else retry next load)
		this._loading = false;
		this._error = '';
		this._loaded = false;

		this._viewMode = 'list';       // 'list' | 'charts'
		this._embeddedProjectID = 0;   // when >0, embedded in a Project workspace tab: locked to project, no Project filter
		this._fullscreen = false;      // standalone "full screen" — overlay the whole browser view (see toggleFullscreen)
		this._typeDropdownOpen = false;
		this._statusDropdownOpen = false;

		// charts state
		this._baseline = 0;
		this._chartStatus = {};        // status -> count under current (minus-status) filter
		this._chartTypes = [];         // [{ hash, label, count }] under current (minus-type) filter
		this._chartLatencyMs = 0;
		this._chartsLoaded = false;
		this._prevKPI = null;
		this._chartsCache = {};        // filter signature -> computed charts (instant re-view)
		this._loadGen = 0;             // bumped each charts load; in-flight type streaming checks it to cancel stale work
		this._typeProgress = { done: 0, total: 0 };
		this._lastTypePaint = 0;

		if (typeof document !== 'undefined')
		{
			this._onDocClick = (pEvent) =>
			{
				if (!this._typeDropdownOpen && !this._statusDropdownOpen && !this._stateDropdownOpen)
				{
					return;
				}
				try
				{
					const inType = document.querySelector('.dol-dd-type'); const inStatus = document.querySelector('.dol-dd-status');
					let changed = false;
					if (this._typeDropdownOpen && inType && !inType.contains(pEvent.target)) { this._typeDropdownOpen = false; changed = true; }
					if (this._statusDropdownOpen && inStatus && !inStatus.contains(pEvent.target)) { this._statusDropdownOpen = false; changed = true; }
					const tmpInState = document.querySelector('.dol-dd-state');
					if (this._stateDropdownOpen && tmpInState && !tmpInState.contains(pEvent.target))
					{
						this._stateDropdownOpen = false;
						changed = true;
					}
					if (changed) { this.render(); }
				}
				catch (pError) { /* */ }
			};
			document.addEventListener('click', this._onDocClick, true);
			// Esc leaves full screen (routed through toggleFullscreen).
			this._onKeydown = (pEvent) => { if (pEvent.key === 'Escape' && this._fullscreen) { this.toggleFullscreen(); } };
			document.addEventListener('keydown', this._onKeydown);
		}

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('DocumentList-CSS', _CSS, 520);
		}
	}

	get cfg() { return this.options || {}; }
	get providerName() { return this.cfg.ProviderIdentifier || 'DocumentList'; }
	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get customerID() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }

	_get(pURL) { return new Promise((resolve) => this.restClient.getJSON(pURL, (e, b) => resolve(e ? null : b))); }
	_esc(pV) { return String(pV == null ? '' : pV).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
	_mediaUrl(pPath) { const rc = this.restClient; if (rc && (typeof rc.formatUrl === 'function')) { try { return rc.formatUrl(pPath); } catch (e) { /* */ } } return `/1.0/${pPath}`; }
	_fmt(pN) { return Math.round(Number(pN) || 0).toLocaleString(); }
	_compact(pN) { const n = Number(pN) || 0; if (n >= 1e6) { return `${(n / 1e6).toFixed(1)}M`; } if (n >= 1e3) { return `${Math.round(n / 1e3)}K`; } return String(n); }
	_fmtDate(pV) { if (!pV) { return ''; } try { const d = new Date(pV); if (!Number.isNaN(d.getTime())) { return d.toLocaleDateString(); } } catch (e) { /* */ } return String(pV).slice(0, 10); }
	_escFilter(pV) { return String(pV == null ? '' : pV).replace(/~/g, ''); }

	// --- Meadow filter stanzas (dates use GE/LT per the Meadow convention — never GTE/LTE) ---
	_buildFilter(pExclude)
	{
		const f = this._filter; const parts = [ `FBV~IDCustomer~EQ~${this.customerID}`, 'FBV~Deleted~EQ~0' ];
		if (f.IDProject) { parts.push(`FBV~IDProject~EQ~${Number(f.IDProject)}`); }
		if (f.SearchText && f.SearchText.trim()) { parts.push(`FBV~Name~LK~${encodeURIComponent(`%${this._escFilter(f.SearchText.trim())}%`)}`); }
		if (f.Types && f.Types.length && pExclude !== 'type') { parts.push(`FBL~DocumentType~INN~${f.Types.map((t) => this._escFilter(t)).join(',')}`); }
		if (f.Statuses && f.Statuses.length && pExclude !== 'status')
		{
			parts.push(`FBL~Status~INN~${f.Statuses.map((s) => encodeURIComponent(this._escFilter(s))).join(',')}`);
		}
		if (f.States && f.States.length)
		{
			parts.push(`FBL~StateName~INN~${f.States.map((pState) => encodeURIComponent(this._escFilter(pState))).join(',')}`);
		}
		if (f.Authors && f.Authors.length) { parts.push(`FBL~CreatingIDUser~INN~${f.Authors.map(Number).join(',')}`); }
		if (f.From) { parts.push(`FBV~DocumentDate~GE~${new Date(f.From).toISOString()}`); }
		if (f.To) { parts.push(`FBV~DocumentDate~LT~${new Date(`${f.To}T23:59:59`).toISOString()}`); }
		if (f.Form === '0' || f.Form === '1') { parts.push(`FBV~Form~EQ~${f.Form}`); }
		return parts.join('~');
	}

	async loadAsync()
	{
		this._loading = true; this._error = ''; this._loaded = true;
		this.render();
		try
		{
			await Promise.all([ this._ensureTypeOptions(), this._loadLayoutAsync() ]);
			if (this._viewMode === 'charts') { await this._loadChartsAsync(); }
			else { await this._loadListAsync(); }
		}
		catch (pError) { this._error = (pError && pError.message) || String(pError); this._rows = []; this._total = 0; }
		this._loading = false;
		this.render();
	}

	async _loadListAsync()
	{
		const flt = this._buildFilter();
		const [ tmpRows, tmpCount ] = await Promise.all([
			this._get(`Documents/FilteredTo/${flt}~FSF~DocumentDate~DESC~0/${this._page * this._cap}/${this._cap}`),
			this._get(`Documents/Count/FilteredTo/${flt}`),
		]);
		if (!tmpRows) { throw new Error('The document search did not respond (are you signed in?).'); }
		this._rows = Array.isArray(tmpRows) ? tmpRows : [];
		this._total = (tmpCount && typeof tmpCount.Count === 'number') ? tmpCount.Count : this._rows.length;
		await Promise.all([ this._resolveAuthors(), this._resolveProjects() ]);
	}

	/**
	 * The signed-in customer's Document List / Filter manifests decide the columns and the Status / State pick lists.
	 * @return {Promise<void>}
	 */
	async _loadLayoutAsync()
	{
		const tmpManifests = this.pict.providers.CustomerRecordManifests;
		if (!tmpManifests)
		{
			return;
		}
		try
		{
			this._layout = await tmpManifests.getDocumentBrowseLayoutAsync();
		}
		catch (pError)
		{
			this.pict.log.warn(`DocumentList: customer document manifests not applied: ${(pError && pError.message) || pError}`);
		}
	}

	/** @return {Array<{ Key: string, Label: string }>} the columns to draw */
	_columns()
	{
		return this._layout.Columns.filter((pColumn) => !(this._embeddedProjectID && (pColumn.Key === 'IDProject')));
	}

	/**
	 * Project names for the Project column, when it shows.
	 * @return {Promise<void>}
	 */
	async _resolveProjects()
	{
		if (!this._columns().some((pColumn) => pColumn.Key === 'IDProject'))
		{
			return;
		}
		const tmpIDs = [ ...new Set(this._rows.map((pDoc) => Number(pDoc.IDProject)).filter((pID) => pID && !this._projectNames[pID])) ];
		if (!tmpIDs.length)
		{
			return;
		}
		const tmpProjects = await this._get(`Projects/Lite/FilteredTo/FBL~IDProject~INN~${tmpIDs.join(',')}/0/${tmpIDs.length}`);
		(Array.isArray(tmpProjects) ? tmpProjects : []).forEach((pProject) =>
		{
			this._projectNames[pProject.IDProject] = pProject.Value || pProject.Name || `#${pProject.IDProject}`;
		});
	}

	// Charts — no document index, so counts are per-value Meadow Count/FilteredTo (DocumentType/Status are indexed, so
	// each individual count is fast; it's the QUANTITY of round-trips that hurts). To stay responsive we: (1) load KPIs +
	// the approval-status funnel FIRST (total + one count per status ~1s), (2) STREAM the type breakdown in progressively
	// (bounded concurrency, patched into the panel as counts land), and (3) cache the whole result per filter signature so
	// re-viewing is instant. A newer load bumps _loadGen, which cancels any in-flight streaming.
	_countFor(pFilter) { return this._get(`Documents/Count/FilteredTo/${pFilter}`).then((r) => (r && typeof r.Count === 'number') ? r.Count : 0); }
	_filterSig() { return JSON.stringify(this._filter); }

	async _loadChartsAsync()
	{
		const tmpGen = ++this._loadGen;
		const tmpSig = this._filterSig();

		const tmpCached = this._chartsCache[tmpSig];
		if (tmpCached)
		{
			this._total = tmpCached.total; this._chartStatus = tmpCached.status; this._chartTypes = tmpCached.types;
			this._chartLatencyMs = tmpCached.ms; this._typeProgress = { done: tmpCached.types.length, total: tmpCached.types.length };
			this._chartsLoaded = true;
			return;
		}

		// Phase A — KPIs + approval-status funnel (fast).
		const tmpT0 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
		const tmpStatusBase = this._buildFilter('status');
		const [ tmpTotal, tmpStatusCounts ] = await Promise.all([
			this._countFor(this._buildFilter()),
			Promise.all(_STATUSES.map((s) => this._countFor(`${tmpStatusBase}~FBV~Status~EQ~${this._escFilter(s)}`))),
		]);
		if (tmpGen !== this._loadGen) { return; }   // superseded by a newer load
		this._total = tmpTotal;
		this._chartStatus = {}; _STATUSES.forEach((s, i) => { this._chartStatus[s] = tmpStatusCounts[i] || 0; });
		this._chartLatencyMs = Math.max(1, Math.round(((typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now()) - tmpT0));
		this._chartTypes = [];
		this._typeProgress = { done: 0, total: (this._typeOptions || []).length };
		this._chartsLoaded = true;

		// Phase B — stream the type breakdown (NOT awaited; loadAsync renders Phase A immediately, then this patches in).
		this._streamTypeBreakdown(tmpGen, tmpSig);
	}

	async _streamTypeBreakdown(pGen, pSig)
	{
		const tmpTypeBase = this._buildFilter('type');
		let tmpOpts = null;
		// Bounded scope (a project/date/etc. narrowed the set) → a distinct read returns ONLY the types actually present,
		// so we count a handful instead of every configured type. Distinct scans the result set, so we only try it when
		// the set is small enough (a customer-wide distinct over ~800k rows times out), and race it with a timeout.
		if (this._total > 0 && this._total <= 100000)
		{
			const tmpDistinct = await Promise.race([
				this._get(`Documents/Distinct/DocumentType/FilteredTo/${tmpTypeBase}`),
				new Promise((pResolve) => setTimeout(() => pResolve('__timeout__'), 5000)),
			]);
			if (pGen !== this._loadGen) { return; }
			if (Array.isArray(tmpDistinct))
			{
				const tmpPresent = tmpDistinct.map((r) => (r && (r.DocumentType != null)) ? r.DocumentType : r).filter((h) => (h != null && h !== ''));
				tmpOpts = tmpPresent.map((h) => { const o = (this._typeOptions || []).find((x) => x.Hash === h); return { Hash: h, Label: o ? o.Label : String(h) }; });
			}
		}
		if (!tmpOpts) { tmpOpts = (this._typeOptions || []).slice(); }
		this._typeProgress = { done: 0, total: tmpOpts.length };
		this._patchTypePanel(pGen, false);
		const tmpResults = [];
		let tmpIdx = 0;
		const fWorker = async () =>
		{
			while (tmpIdx < tmpOpts.length)
			{
				const o = tmpOpts[tmpIdx++];
				const c = await this._countFor(`${tmpTypeBase}~FBV~DocumentType~EQ~${this._escFilter(o.Hash)}`);
				if (pGen !== this._loadGen) { return; }   // a newer load superseded this stream
				tmpResults.push({ hash: o.Hash, label: o.Label, count: c });
				this._chartTypes = tmpResults.slice().sort((a, b) => (b.count - a.count));
				this._typeProgress = { done: tmpResults.length, total: tmpOpts.length };
				this._patchTypePanel(pGen, false);
			}
		};
		await Promise.all(Array.from({ length: Math.min(6, tmpOpts.length || 1) }, fWorker));
		if (pGen !== this._loadGen) { return; }
		this._typeProgress = { done: tmpOpts.length, total: tmpOpts.length };
		this._chartsCache[pSig] = { total: this._total, status: this._chartStatus, types: this._chartTypes, ms: this._chartLatencyMs };
		this._patchTypePanel(pGen, true);
	}

	// Patch ONLY the type panel + the "types" KPI in place (throttled) so streaming counts don't re-render / re-tween the rest.
	_patchTypePanel(pGen, pFinal)
	{
		if (pGen !== this._loadGen || this._viewMode !== 'charts') { return; }
		const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
		if (!pFinal && (now - (this._lastTypePaint || 0)) < 280) { return; }
		this._lastTypePaint = now;
		const tmpCA = this.pict.ContentAssignment; if (!tmpCA) { return; }
		const tmpPanel = tmpCA.getElement(`${this._mount} #dol-typepanel`);
		if (tmpPanel && tmpPanel.length) { tmpPanel[0].innerHTML = this._typeChartInnerHTML(); }
		const tmpKpi = tmpCA.getElement(`${this._mount} .dxp-v[data-kpi="types"]`);
		if (tmpKpi && tmpKpi.length) { tmpKpi[0].textContent = this._fmt(this._chartTypes.filter((t) => t.count > 0).length); }
	}

	// Resolve DocumentType hashes → display names via ReportNamedInstance (per-project when scoped, else customer-wide).
	async _ensureTypeOptions()
	{
		if (this._typeOptions && this._typeGrouped) { return; }
		let tmpRows = null;
		if (this._filter.IDProject) { tmpRows = await this._get(`ReportNamedInstancesByProject/${Number(this._filter.IDProject)}/0/500`); }
		if (!Array.isArray(tmpRows) || !tmpRows.length) { tmpRows = await this._get(`ReportNamedInstances/FilteredTo/FBV~IDCustomer~EQ~${this.customerID}~FBV~Deleted~EQ~0/0/500`); }
		const tmpByHash = {};
		(Array.isArray(tmpRows) ? tmpRows : []).forEach((r) =>
		{
			const tmpHash = r.Hash || r.DocumentType || r.ReportTypeName; if (!tmpHash) { return; }
			const tmpLabel = r.Name || r.DisplayName || r.Title || tmpHash;
			if (!tmpByHash[tmpHash]) { tmpByHash[tmpHash] = { Hash: tmpHash, Label: String(tmpLabel).trim() }; }
		});
		const tmpOpts = Object.keys(tmpByHash).map((k) => tmpByHash[k]).sort((a, b) => a.Label.localeCompare(b.Label));
		this._typeOptions = tmpOpts;
		this._typeGrouped = tmpOpts.length > 0;   // retry next load if it didn't resolve
	}

	async _resolveAuthors()
	{
		const tmpIDs = [ ...new Set(this._rows.map((d) => d.CreatingIDUser).filter((x) => x && !this._authorNames[x])) ];
		if (!tmpIDs.length) { return; }
		const tmpUsers = await this._get(`Users/FilteredTo/FBL~IDUser~INN~${tmpIDs.join(',')}/0/${tmpIDs.length}`);
		(Array.isArray(tmpUsers) ? tmpUsers : []).forEach((u) =>
		{
			// filter(Boolean) keeps a literal "-" placeholder some imported users carry in an empty name part, leaving a
			// dangling "Ciolino, David -". Trim each part and drop punctuation-only placeholders before joining.
			const tmpParts = [ u.NameFirst, u.NameLast ]
				.map((pPart) => String(pPart == null ? '' : pPart).trim())
				.filter((pPart) => pPart && !/^[-–—]+$/.test(pPart));
			this._authorNames[u.IDUser] = tmpParts.join(' ') || u.LoginID || `#${u.IDUser}`;
		});
	}

	_typeLabel(pHash) { const o = (this._typeOptions || []).find((t) => t.Hash === pHash); return o ? o.Label : (pHash || ''); }

	// --- interactions ---
	setSearch(pV) { this._filter.SearchText = String(pV == null ? '' : pV); }
	setDateFrom(pV) { this._filter.From = pV || ''; }
	setDateTo(pV) { this._filter.To = pV || ''; }
	setForm(pV) { this._filter.Form = pV || ''; this.applyFilters(); }
	toggleTypeDropdown() { this._typeDropdownOpen = !this._typeDropdownOpen; this._statusDropdownOpen = false; this.render(); }
	toggleStatusDropdown() { this._statusDropdownOpen = !this._statusDropdownOpen; this._typeDropdownOpen = false; this.render(); }
	/** Open or close the State pick list. */
	toggleStateDropdown()
	{
		this._stateDropdownOpen = !this._stateDropdownOpen;
		this._typeDropdownOpen = false;
		this._statusDropdownOpen = false;
		this.render();
	}
	/**
	 * Add or remove a state name from the filter.
	 * @param {string} pState
	 */
	toggleState(pState)
	{
		const tmpState = String(pState);
		const tmpIndex = this._filter.States.indexOf(tmpState);
		if (tmpIndex >= 0)
		{
			this._filter.States.splice(tmpIndex, 1);
		}
		else
		{
			this._filter.States.push(tmpState);
		}
		this.applyFilters();
	}
	toggleType(pHash)
	{
		const h = String(pHash); const i = this._filter.Types.indexOf(h);
		if (i >= 0) { this._filter.Types.splice(i, 1); } else { this._filter.Types.push(h); }
		this.applyFilters();
	}
	clearTypes() { if (!this._filter.Types.length) { return; } this._filter.Types = []; this.applyFilters(); }
	toggleStatus(pStatus)
	{
		const s = String(pStatus); const i = this._filter.Statuses.indexOf(s);
		if (i >= 0) { this._filter.Statuses.splice(i, 1); } else { this._filter.Statuses.push(s); }
		this.applyFilters();
	}
	setStatusOnly(pStatus) { this._filter.Statuses = pStatus ? [ String(pStatus) ] : []; this.applyFilters(); }
	removeAuthor(pID) { const id = Number(pID); this._filter.Authors = this._filter.Authors.filter((x) => Number(x) !== id); this.applyFilters(); }
	addAuthor(pID, pName) { const id = Number(pID); if (!id) { return; } if (this._filter.Authors.map(Number).indexOf(id) < 0) { this._filter.Authors.push(id); if (pName) { this._authorNames[id] = pName; } } this.applyFilters(); }
	selectProject(pID, pName)
	{
		this._filter.IDProject = Number(pID) || 0; this._filter.ProjectName = pName || '';
		this._typeOptions = null; this._typeGrouped = false;   // types are project-scoped — re-resolve
		this.applyFilters();
	}
	clearFilters()
	{
		const tmpProj = this._embeddedProjectID || 0;
		this._filter = { SearchText: '', Types: [], Statuses: [], States: [], Authors: [], AuthorNames: {}, From: '', To: '', IDProject: tmpProj, ProjectName: this._filter.ProjectName || '', Form: '' };
		if (!tmpProj) { this._typeOptions = null; this._typeGrouped = false; }
		this.applyFilters();
	}
	applyFilters() { this._page = 0; this.loadAsync(); }
	setPage(pPage) { const tmpMax = Math.max(0, Math.ceil(this._total / this._cap) - 1); this._page = Math.min(Math.max(0, pPage), tmpMax); this.loadAsync(); }
	setViewMode(pMode) { if ((pMode !== 'list' && pMode !== 'charts') || this._viewMode === pMode) { return; } this._viewMode = pMode; this.loadAsync(); }
	// Full screen: overlay the dashboard across the whole browser view (above the app nav). State is a provider field so it
	// survives the shell rebuild; `.dol-fs` composites on its own layer (CSS transform) so it paints immediately. Navigating
	// away replaces the host, tearing the fixed overlay down with it (no leak). Esc exits.
	toggleFullscreen() { if (this._embeddedProjectID) { return; } this._fullscreen = !this._fullscreen; this.render(); }
	get _docRender() { return this.pict.HeadlightDocumentRender; }
	// Open the document as same-origin HTML via the render service (Report/{GUID}/index.html) — NEVER Fieldbook.
	// pReadOnly=false loads the editable form viewer/editor (editable when the doc isn't Locked); pReadOnly=true loads
	// the read-only HTML render. Falls back to the PDF only if the service is somehow unavailable.
	openHTML(pID, pReadOnly)
	{
		const id = Number(pID) || 0; if (!id) { return; }
		const svc = this._docRender;
		if (!svc || (typeof svc.openDocument !== 'function'))
		{
			try { window.open(this._mediaUrl(`Document/${id}/DCR.pdf`), '_blank', 'noopener'); } catch (e) { /* */ }
			return;
		}
		svc.openDocument(id, { target: '_blank', variation: pReadOnly ? 'html' : 'default' }, (pError) =>
		{
			if (pError) { try { this.pict.log.error(`Open document ${id} failed: ${pError.message || pError}`); } catch (e) { /* */ } }
		});
	}
	downloadPDF(pID)
	{
		const id = Number(pID) || 0; if (!id) { return; }
		const svc = this._docRender;
		if (svc && (typeof svc.downloadPDFLink === 'function')) { svc.downloadPDFLink(id); return; }
		try { window.open(this._mediaUrl(`Document/${id}/DCR.pdf`), '_blank', 'noopener'); } catch (e) { /* */ }
	}

	/**
	 * Fails closed: the Delete button stays hidden until the capability map is ready. A document grant can allow
	 * delete without the role permission, and the API only reports `CanDelete` on a single-document read, so the
	 * button shows on every unlocked row and `documentAllowsDelete` decides on click.
	 * @return {boolean}
	 */
	canDeleteDocument()
	{
		const tmpPermissions = this.pict.fable && this.pict.fable.EffectivePermissionsService;
		return !!(tmpPermissions && tmpPermissions.currentUserReady && tmpPermissions.currentUserReady());
	}

	/**
	 * Whether this user may delete this document: the role permission, or the document's own `CanDelete`.
	 * @param {number} pID - IDDocument
	 * @return {Promise<boolean>}
	 */
	async documentAllowsDelete(pID)
	{
		if (this.pict.fable.EffectivePermissionsService.canHash('Document-Delete'))
		{
			return true;
		}
		const tmpRecord = await this._get(`Document/${pID}`);
		return !!(tmpRecord && tmpRecord.CanDelete);
	}

	/**
	 * Delete a document from the list, after the user confirms. Locked documents can't be deleted here.
	 * @param {number} pID - IDDocument
	 * @return {Promise<void>}
	 */
	async deleteDocument(pID)
	{
		const tmpID = Number(pID) || 0;
		const tmpDoc = (this._rows || []).find((pRow) => Number(pRow.IDDocument) === tmpID);
		if (!tmpID || !this.canDeleteDocument() || (tmpDoc && tmpDoc.Locked))
		{
			return;
		}
		if (!(await this.documentAllowsDelete(tmpID)))
		{
			const tmpRefusalPanels = this.pict.views.HeadlightPanels;
			if (tmpRefusalPanels && (typeof tmpRefusalPanels.toast === 'function'))
			{
				tmpRefusalPanels.toast({ type: 'is-warning', message: 'You do not have permission to delete this document.' });
			}
			return;
		}
		const tmpLabel = (tmpDoc && tmpDoc.Name) ? `"${tmpDoc.Name}"` : 'this document';
		if ((typeof window !== 'undefined') && (typeof window.confirm === 'function') && !window.confirm(`Delete ${tmpLabel}?`))
		{
			return;
		}
		const tmpError = await new Promise((resolve) => this.restClient.deleteEntity('Document', tmpID, (pError) => resolve(pError)));
		const tmpPanels = this.pict.views.HeadlightPanels;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast(tmpError ? { type: 'is-danger', message: `Could not delete the document: ${(tmpError && tmpError.message) || tmpError}` } : { type: 'is-success', message: 'Document deleted.' });
		}
		await this.loadAsync();
	}

	// --- embed API (Project workspace Forms tab): lock to project, hide the Project filter, paint into the tab host ---
	openInto(pIDProject, pHostSelector)
	{
		const tmpID = Number(pIDProject) || 0;
		const tmpHost = pHostSelector || this._mount;
		const tmpChanged = (this._embeddedProjectID !== tmpID) || (this._mount !== tmpHost);
		this._embeddedProjectID = tmpID;
		this._mount = tmpHost;
		if (this._filter.IDProject !== tmpID) { this._filter.IDProject = tmpID; this._filter.ProjectName = ''; this._typeOptions = null; this._typeGrouped = false; }
		if (tmpChanged || !this._loaded)
		{
			try { if (this.pict.CSSMap && (typeof this.pict.CSSMap.injectCSS === 'function')) { this.pict.CSSMap.injectCSS(); } } catch (pError) { /* */ }
			this._page = 0; this.loadAsync();
		}
		else { this.render(); }
	}
	exitEmbed()
	{
		if (!this._embeddedProjectID && this._mount === '#DocumentList-Host') { return; }
		this._embeddedProjectID = 0; this._mount = '#DocumentList-Host';
		this._filter.IDProject = 0; this._filter.ProjectName = ''; this._typeOptions = null; this._typeGrouped = false;
	}

	// --- render ---
	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement(this._mount).length === 0) { return; }
		tmpCA.assignContent(this._mount, this._shellHTML());
		this._mountPickers();
		if (this._viewMode === 'charts') { this._tweenChartKPIs(); }
	}

	_shellHTML()
	{
		return /*html*/`
			<div class="dol${this._embeddedProjectID ? ' dol-embedded' : ''}${this._fullscreen ? ' dol-fs' : ''}">
				${this._embeddedProjectID ? '' : `<div class="dol-head"><div class="dol-title"><i class="fas fa-file-lines"></i> Documents</div></div>`}
				${this._filterBarHTML()}
				${this._viewTabsHTML()}
				<div id="dol-results">${this._bodyHTML()}</div>
			</div>`;
	}

	_viewTabsHTML()
	{
		const P = this.providerName;
		const tab = (pMode, pIcon, pLabel) => `<button class="dol-vtab${this._viewMode === pMode ? ' dol-vtab-on' : ''}" onclick="_Pict.providers.${P}.setViewMode('${pMode}')"><i class="fas ${pIcon}"></i> ${pLabel}</button>`;
		const tmpCount = this._loaded ? `<span class="dol-vtabcount">${this._total.toLocaleString()} document${this._total === 1 ? '' : 's'}</span>` : '';
		// Full-screen toggle — standalone only (in an embedded Project tab there's no app chrome to escape).
		const tmpFsBtn = this._embeddedProjectID ? '' : `<button class="dol-fsbtn${this._fullscreen ? ' dol-fsbtn-on' : ''}" onclick="_Pict.providers.${P}.toggleFullscreen()" title="${this._fullscreen ? 'Exit full screen (Esc)' : 'Full screen'}"><i class="fas ${this._fullscreen ? 'fa-compress' : 'fa-expand'}"></i> ${this._fullscreen ? 'Exit full screen' : 'Full screen'}</button>`;
		return `<div class="dol-viewtabs-row"><div class="dol-viewtabs">${tab('list', 'fa-list-ul', 'List')}${tab('charts', 'fa-chart-simple', 'Charts')}</div><div class="dol-vtabs-right">${tmpCount}${tmpFsBtn}</div></div>`;
	}

	_bodyHTML() { return (this._viewMode === 'charts') ? this._chartsHTML() : this._resultsHTML(); }

	_filterBarHTML()
	{
		const f = this._filter; const P = this.providerName;
		const tmpAuthorChips = f.Authors.map((id) => `<span class="dol-tag">${this._esc(this._authorNames[id] || ('#' + id))}<button class="dol-tag-x" onclick="_Pict.providers.${P}.removeAuthor(${Number(id)})">&times;</button></span>`).join('');
		return /*html*/`
			<div class="dol-filters">
				<div class="dol-row">
					<span class="dol-search"><i class="fas fa-search dol-search-ic"></i><input class="dol-search-in" type="search" placeholder="Search documents…" value="${this._esc(f.SearchText)}" oninput="_Pict.providers.${P}.setSearch(this.value)" onkeydown="if(event.key==='Enter'){_Pict.providers.${P}.applyFilters();}" /></span>
					<div class="dol-f"><span class="dol-f-l">Type</span>${this._typeDropdownHTML()}</div>
					<div class="dol-f"><span class="dol-f-l">Status</span>${this._statusDropdownHTML()}</div>
					${this._layout.StateOptions ? `<div class="dol-f"><span class="dol-f-l">State</span>${this._stateDropdownHTML()}</div>` : ''}
					<div class="dol-f"><span class="dol-f-l">Kind</span><div id="DocumentList-KindPicker" class="dol-picker dol-enumpicker"></div></div>
					<label class="dol-f"><span class="dol-f-l">From</span><input type="date" value="${this._esc(f.From)}" onchange="_Pict.providers.${P}.setDateFrom(this.value)" /></label>
					<label class="dol-f"><span class="dol-f-l">To</span><input type="date" value="${this._esc(f.To)}" onchange="_Pict.providers.${P}.setDateTo(this.value)" /></label>
					<button class="dol-apply" onclick="_Pict.providers.${P}.applyFilters()">Apply</button>
					<button class="dol-clear" onclick="_Pict.providers.${P}.clearFilters()">Clear</button>
				</div>
				<div class="dol-row dol-row-pickers">
					${this._embeddedProjectID ? '' : `<div class="dol-pick"><span class="dol-f-l">Project</span><div id="DocumentList-ProjectPicker" class="dol-picker"></div></div>`}
					<div class="dol-pick"><span class="dol-f-l">Author</span><div id="DocumentList-AuthorPicker" class="dol-picker"></div>${tmpAuthorChips ? `<div class="dol-tags">${tmpAuthorChips}</div>` : ''}</div>
				</div>
			</div>`;
	}

	_typeDropdownHTML()
	{
		const P = this.providerName; const opts = this._typeOptions || [];
		const sel = this._filter.Types.length;
		const btn = `<button type="button" class="dol-ddbtn${this._typeDropdownOpen ? ' dol-ddbtn-open' : ''}" onclick="_Pict.providers.${P}.toggleTypeDropdown()"><span class="dol-ddbtn-l">${sel ? `${sel} selected` : 'Any type'}</span>${sel ? `<span class="dol-ddbadge">${sel}</span>` : ''}<i class="fas fa-chevron-${this._typeDropdownOpen ? 'up' : 'down'} dol-ddcaret"></i></button>`;
		if (!this._typeDropdownOpen) { return `<div class="dol-typedd dol-dd-type">${btn}</div>`; }
		const items = opts.map((o) =>
		{
			const on = this._filter.Types.indexOf(o.Hash) >= 0;
			return `<label class="dol-dditem${on ? ' dol-dditem-on' : ''}"><input type="checkbox" ${on ? 'checked' : ''} onclick="_Pict.providers.${P}.toggleType('${this._esc(o.Hash)}')" /><span class="dol-ddname" title="${this._esc(o.Label)}">${this._esc(o.Label)}</span></label>`;
		}).join('');
		return `<div class="dol-typedd dol-dd-type">${btn}<div class="dol-ddpanel"><div class="dol-ddpanel-head"><span>${opts.length} type${opts.length === 1 ? '' : 's'}</span>${sel ? `<button type="button" class="dol-ddclearbtn" onclick="_Pict.providers.${P}.clearTypes()">Clear</button>` : ''}</div><div class="dol-ddlist">${items || '<div class="dol-ddempty">No types resolved</div>'}</div></div></div>`;
	}

	_statusDropdownHTML()
	{
		const P = this.providerName; const sel = this._filter.Statuses.length;
		const btn = `<button type="button" class="dol-ddbtn${this._statusDropdownOpen ? ' dol-ddbtn-open' : ''}" onclick="_Pict.providers.${P}.toggleStatusDropdown()"><span class="dol-ddbtn-l">${sel ? `${sel} selected` : 'Any status'}</span>${sel ? `<span class="dol-ddbadge">${sel}</span>` : ''}<i class="fas fa-chevron-${this._statusDropdownOpen ? 'up' : 'down'} dol-ddcaret"></i></button>`;
		if (!this._statusDropdownOpen) { return `<div class="dol-typedd dol-dd-status">${btn}</div>`; }
		const tmpOptions = this._layout.StatusOptions || _STATUSES.map((pStatus) => ({ id: pStatus, text: pStatus }));
		const items = tmpOptions.map((pOption) =>
		{
			const on = this._filter.Statuses.indexOf(pOption.id) >= 0;
			const tmpInput = `<input type="checkbox" ${on ? 'checked' : ''} onclick="_Pict.providers.${P}.toggleStatus(${this._esc(JSON.stringify(pOption.id))})" />`;
			return `<label class="dol-dditem${on ? ' dol-dditem-on' : ''}">${tmpInput}<span class="dol-statusdot" style="background:${_STATUS_COLOR[pOption.id] || '#8b98a3'}"></span><span class="dol-ddname">${this._esc(pOption.text)}</span></label>`;
		}).join('');
		return `<div class="dol-typedd dol-dd-status">${btn}<div class="dol-ddpanel"><div class="dol-ddlist">${items}</div></div></div>`;
	}

	/** @return {string} the State pick list (only when the customer's Document Filter manifest lists states) */
	_stateDropdownHTML()
	{
		const P = this.providerName;
		const tmpSelected = this._filter.States.length;
		const tmpLabel = `<span class="dol-ddbtn-l">${tmpSelected ? `${tmpSelected} selected` : 'Any state'}</span>${tmpSelected ? `<span class="dol-ddbadge">${tmpSelected}</span>` : ''}`;
		const tmpButton = `<button type="button" class="dol-ddbtn${this._stateDropdownOpen ? ' dol-ddbtn-open' : ''}" onclick="_Pict.providers.${P}.toggleStateDropdown()">${tmpLabel}<i class="fas fa-chevron-${this._stateDropdownOpen ? 'up' : 'down'} dol-ddcaret"></i></button>`;
		if (!this._stateDropdownOpen)
		{
			return `<div class="dol-typedd dol-dd-state">${tmpButton}</div>`;
		}
		const tmpItems = (this._layout.StateOptions || []).map((pOption) =>
		{
			const tmpOn = this._filter.States.indexOf(pOption.id) >= 0;
			return `<label class="dol-dditem${tmpOn ? ' dol-dditem-on' : ''}"><input type="checkbox" ${tmpOn ? 'checked' : ''} onclick="_Pict.providers.${P}.toggleState(${this._esc(JSON.stringify(pOption.id))})" /><span class="dol-ddname">${this._esc(pOption.text)}</span></label>`;
		}).join('');
		return `<div class="dol-typedd dol-dd-state">${tmpButton}<div class="dol-ddpanel"><div class="dol-ddlist">${tmpItems}</div></div></div>`;
	}

	_resultsHTML()
	{
		if (this._loading && !this._rows.length) { return `<div class="dol-empty"><span class="dol-spin"></span> Searching…</div>`; }
		if (this._error) { return `<div class="dol-empty dol-error">${this._esc(this._error)}</div>`; }
		if (!this._rows.length) { return `<div class="dol-empty">No documents match these filters.</div>`; }
		const tmpRows = this._rows.map((d) => this._rowHTML(d)).join('');
		return `<div class="dol-listwrap"><table class="dol-list"><thead><tr><th></th>${this._columns().map((pColumn) => `<th>${this._esc(pColumn.Label)}</th>`).join('')}<th></th></tr></thead><tbody>${tmpRows}</tbody></table></div>${this._paginationHTML()}`;
	}

	_rowHTML(pDoc)
	{
		const id = pDoc.IDDocument;
		const tmpType = this._typeLabel(pDoc.DocumentType);
		const tmpRawName = String(pDoc.Name == null ? '' : pDoc.Name).trim();
		// An untitled document often carries its type name as Name (e.g. "LADOTD (HDR)"), which would just duplicate the
		// Type column. Show a muted "Untitled" instead (the SequenceNumber sub-line below still identifies the row) rather
		// than echoing the Type or exposing the raw IDDocument. Form instances keep their meaningful "Form #<sequence>" label.
		const tmpHasDistinctName = tmpRawName && (tmpRawName.toLowerCase() !== String(tmpType || '').trim().toLowerCase());
		const tmpName = tmpHasDistinctName ? tmpRawName : (pDoc.Form ? `Form #${pDoc.SequenceNumber || id}` : '');
		const tmpAuthor = this._authorNames[pDoc.CreatingIDUser] || (pDoc.CreatingIDUser ? `#${pDoc.CreatingIDUser}` : '');
		const tmpStatus = pDoc.Status || 'Draft';
		const tmpColor = _STATUS_COLOR[tmpStatus] || '#8b98a3';
		const tmpKindIcon = pDoc.Form ? 'fa-file-pen' : 'fa-file-lines';
		const P = this.providerName;
		const tmpLocked = !!pDoc.Locked;
		const tmpLock = tmpLocked ? ` <i class="fas fa-lock dol-lock" title="Locked (read-only)"></i>` : '';
		// Clicking the row (or Edit) loads the document as HTML via the render service — editable when not Locked.
		return `<tr class="dol-r" onclick="_Pict.providers.${P}.openHTML(${id}, false)">
			<td class="dol-icon-cell"><span class="dol-kicon"><i class="fas ${tmpKindIcon}"></i></span></td>
			${this._cellsHTML(pDoc, { Type: tmpType, Name: tmpName, Author: tmpAuthor, Status: tmpStatus, Color: tmpColor, Lock: tmpLock })}
			<td class="dol-actions dol-nowrap" onclick="event.stopPropagation()">
				${tmpLocked ? '' : `<button type="button" class="dol-act dol-act-primary" title="Open in HTML (editable — not locked)" onclick="_Pict.providers.${P}.openHTML(${id}, false)"><i class="fas fa-pen-to-square"></i> Edit</button>`}
				<button type="button" class="dol-act" title="View read-only in HTML" onclick="_Pict.providers.${P}.openHTML(${id}, true)"><i class="fas fa-eye"></i> View</button>
				<button type="button" class="dol-act dol-act-icon" title="Download PDF" onclick="_Pict.providers.${P}.downloadPDF(${id})"><i class="fas fa-file-pdf"></i></button>
				${(!tmpLocked && this.canDeleteDocument()) ? `<button type="button" class="dol-act dol-act-icon dol-act-danger" title="Delete" onclick="_Pict.providers.${P}.deleteDocument(${id})"><i class="fas fa-trash"></i></button>` : ''}
			</td>
		</tr>`;
	}

	/**
	 * One row's cells for the current columns. The lock icon follows the first status column, else the name.
	 * @param {Record<string, any>} pDoc
	 * @param {{ Type: string, Name: string, Author: string, Status: string, Color: string, Lock: string }} pValues
	 * @return {string}
	 */
	_cellsHTML(pDoc, pValues)
	{
		const tmpColumns = this._columns();
		const tmpStatusColumn = tmpColumns.find((pColumn) => (pColumn.Key === 'StateName') || (pColumn.Key === 'Status'));
		const tmpLockKey = tmpStatusColumn ? tmpStatusColumn.Key : 'Name';
		const fBadge = (pText, pColor) => `<span class="dol-badge" style="color:${pColor};background:${pColor}1a;border-color:${pColor}55">${this._esc(pText)}</span>`;
		return tmpColumns.map((pColumn) =>
		{
			const tmpLock = (pColumn.Key === tmpLockKey) ? pValues.Lock : '';
			switch (pColumn.Key)
			{
			case 'DocumentType':
				return `<td><span class="dol-type">${this._esc(pValues.Type)}</span></td>`;
			case 'Name':
				return `<td class="dol-namecell"><span class="dol-name${pValues.Name ? '' : ' dol-name-untitled'}">${pValues.Name ? this._esc(pValues.Name) : 'Untitled'}</span>${pDoc.SequenceNumber ? `<span class="dol-seq">#${this._esc(pDoc.SequenceNumber)}</span>` : ''}${tmpLock}</td>`;
			case 'DocumentDate':
				return `<td class="dol-nowrap">${this._esc(this._fmtDate(pDoc.DocumentDate))}</td>`;
			case 'CreatingIDUser':
				return `<td>${this._esc(pValues.Author)}</td>`;
			case 'Status':
				return `<td>${fBadge(pValues.Status, pValues.Color)}${tmpLock}</td>`;
			case 'StateName':
				return `<td>${fBadge(pDoc.StateName || pValues.Status, pValues.Color)}${tmpLock}</td>`;
			case 'IDProject':
				return `<td>${this._esc(this._projectNames[pDoc.IDProject] || (pDoc.IDProject ? `#${pDoc.IDProject}` : ''))}</td>`;
			default:
				return '<td></td>';
			}
		}).join('');
	}

	_paginationHTML()
	{
		const tmpPages = Math.max(1, Math.ceil(this._total / this._cap));
		if (tmpPages <= 1) { return ''; }
		const P = this.providerName;
		const tmpStart = this._page * this._cap + 1; const tmpEnd = Math.min(this._total, (this._page + 1) * this._cap);
		return `<div class="dol-pager">
			<button class="dol-pg" ${this._page <= 0 ? 'disabled' : ''} onclick="_Pict.providers.${P}.setPage(${this._page - 1})"><i class="fas fa-chevron-left"></i> Prev</button>
			<span class="dol-pg-info">${tmpStart.toLocaleString()}–${tmpEnd.toLocaleString()} of ${this._total.toLocaleString()}</span>
			<button class="dol-pg" ${this._page >= (tmpPages - 1) ? 'disabled' : ''} onclick="_Pict.providers.${P}.setPage(${this._page + 1})">Next <i class="fas fa-chevron-right"></i></button>
		</div>`;
	}

	// --- charts (KPIs + approval-status funnel + type distribution) ---
	_chartsHTML()
	{
		if (this._error) { return `<div class="dol-empty dol-error">${this._esc(this._error)}</div>`; }
		if (this._loading && !this._chartsLoaded) { return `<div class="dol-empty"><span class="dol-spin"></span> Counting…</div>`; }
		const approved = this._chartStatus.Approved || 0;
		const pending = (this._chartStatus.Submitted || 0) + (this._chartStatus.Pending || 0);
		const approvedPct = this._total ? Math.round((approved / this._total) * 100) : 0;
		return /*html*/`
			<div class="dxp">
				<div class="dxp-badge-row"><span class="dxp-badge"><span class="dxp-pulse${this._loading ? ' dxp-pulse-busy' : ''}"></span> counted in <b id="dxp-badge-ms">${this._loading ? '…' : this._chartLatencyMs}</b> ms · Meadow (no index)</span></div>
				<div class="dxp-kpis">
					${this._kpi('Metric', 'total', this._total, 'Documents in view')}
					${this._kpi('Metric', 'types', this._chartTypes.filter((t) => t.count > 0).length, 'Document types')}
					${this._kpi('Metric', 'approved', approvedPct, 'Approved', '', '%')}
					${this._kpi('Attention', 'pending', pending, 'Awaiting approval', ' dxp-kpi-warn')}
				</div>
				<div class="dxp-grid">
					${this._statusChartHTML()}
					${this._typeChartHTML()}
				</div>
				<div class="dxp-foot"><i class="fas fa-bolt"></i> Documents have no search index, so each bar is a live <b>Count/FilteredTo</b> query (parallel) — clicking one sets the same filter the List shares. Approval actions (approve/reject/submit) are the next step.</div>
			</div>`;
	}
	_kpi(pEyebrow, pId, pVal, pLabel, pCls, pSuffix)
	{
		const prev = this._prevKPI ? (this._prevKPI[pId] != null ? this._prevKPI[pId] : pVal) : 0;
		return `<div class="dxp-kpi${pCls || ''}"><div class="dxp-eyebrow">${pEyebrow}</div><div class="dxp-v" data-kpi="${pId}" data-to="${pVal}" data-suffix="${pSuffix || ''}">${this._fmt(prev)}${pSuffix || ''}</div><div class="dxp-l">${pLabel}</div></div>`;
	}
	_statusChartHTML()
	{
		const P = this.providerName;
		const segs = _STATUSES.map((s) => ({ s, count: this._chartStatus[s] || 0, color: _STATUS_COLOR[s] }));
		const sum = segs.reduce((a, x) => a + x.count, 0) || 1;
		const sel = this._filter.Statuses;
		const stack = segs.map((x) => `<div class="dxp-seg${sel.length && sel.indexOf(x.s) < 0 ? ' dxp-seg-dim' : ''}" style="width:${(x.count / sum) * 100}%;background:${x.color}" title="${x.s} · ${this._fmt(x.count)}" onclick="_Pict.providers.${P}.toggleStatus('${x.s}')"></div>`).join('');
		const legend = segs.map((x) => `<div class="dxp-fl${sel.indexOf(x.s) >= 0 ? ' dxp-fl-on' : ''}" onclick="_Pict.providers.${P}.toggleStatus('${x.s}')"><span class="dxp-sw" style="background:${x.color}"></span><span class="dxp-fname">${x.s}</span><span class="dxp-fpct">${((x.count / sum) * 100).toFixed(1)}%</span><span class="dxp-fcnt">${this._fmt(x.count)}</span></div>`).join('');
		return `<div class="dxp-panel"><div class="dxp-ph"><h3><i class="fas fa-clipboard-check"></i> Approval status</h3><span class="dxp-hint">Document.Status</span></div><div class="dxp-stack">${stack}</div><div class="dxp-flegend">${legend}</div></div>`;
	}
	_typeChartHTML() { return `<div class="dxp-panel" id="dol-typepanel">${this._typeChartInnerHTML()}</div>`; }
	_typeChartInnerHTML()
	{
		const P = this.providerName; const rows = this._chartTypes;
		const prog = this._typeProgress || { done: 0, total: 0 };
		const loading = (prog.total > 0) && (prog.done < prog.total);
		const max = rows.reduce((a, r) => Math.max(a, r.count), 1);
		const body = rows.map((r, i) =>
		{
			const on = this._filter.Types.indexOf(r.hash) >= 0;
			const w = Math.max(1.5, (r.count / max) * 100); const color = _CAT[i % _CAT.length];
			return `<div class="dxp-row${on ? ' dxp-row-on' : ''}" onclick="_Pict.providers.${P}.toggleType('${this._esc(r.hash)}')">
				<div class="dxp-row-bg" style="width:${w}%;background:linear-gradient(90deg,${color}22,transparent)"></div>
				<div class="dxp-lab"><span class="dxp-dot" style="background:${color}"></span><span class="dxp-name" title="${this._esc(r.label)}">${this._esc(r.label)}</span></div>
				<span class="dxp-cnt">${this._fmt(r.count)}</span>
				<div class="dxp-track"><div class="dxp-fill" style="width:${w}%;background:${color}"></div></div>
			</div>`;
		}).join('');
		const hint = loading
			? `<span class="dxp-hint"><span class="dol-spin"></span> counting types… ${prog.done}/${prog.total}</span>`
			: `<span class="dxp-hint">DocumentType — click to filter</span>`;
		return `<div class="dxp-ph"><h3><i class="fas fa-file-lines"></i> Document type</h3>${hint}</div><div class="dxp-rows">${body || (loading ? '' : '<div class="dol-empty">No types in view.</div>')}</div>`;
	}
	_tweenChartKPIs()
	{
		const tmpCA = this.pict.ContentAssignment; if (!tmpCA) { return; }
		const els = tmpCA.getElement(`${this._mount} .dxp-v`);
		const reduced = (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
		const next = {};
		for (let i = 0; els && i < els.length; i++)
		{
			const el = els[i]; const key = el.getAttribute('data-kpi'); const to = Number(el.getAttribute('data-to')) || 0; const sfx = el.getAttribute('data-suffix') || '';
			const from = this._prevKPI && this._prevKPI[key] != null ? this._prevKPI[key] : 0; next[key] = to;
			if (reduced || from === to) { el.textContent = this._fmt(to) + sfx; continue; }
			this._animateKPI(el, from, to, sfx);
		}
		this._prevKPI = next;
	}
	_animateKPI(el, from, to, sfx)
	{
		const dur = 460; let t0 = null;
		const step = (ts) => { if (t0 === null) { t0 = ts; } const p = Math.min(1, (ts - t0) / dur); const e = 1 - Math.pow(1 - p, 3); el.textContent = this._fmt(from + (to - from) * e) + sfx; if (p < 1) { requestAnimationFrame(step); } };
		requestAnimationFrame(step);
	}

	// --- pickers (project + author, searchable, via pict-section-picker) ---
	_mountPickers()
	{
		const tmpPicker = this.pict.providers && this.pict.providers['Pict-Section-Picker'];
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		if (tmpCA.getElement('#DocumentList-ProjectPicker').length > 0)
		{
			const v = tmpPicker.createPicker(`${this.providerName}-ProjectPicker`, {
				DestinationAddress: '#DocumentList-ProjectPicker', ValueAddress: `AppData.${this.providerName}.PickerProject`,
				Searchable: true, AllowClear: true, ClearLabel: '— any project —', Placeholder: 'Any project…',
				DataProvider: this._projectDataProvider(), ResolveValue: this._projectResolveValue(),
				OnChange: (val, pRecord) => this.selectProject(val, pRecord && (pRecord.Text || pRecord.Name)),
			});
			if (v && (typeof v.render === 'function')) { v.render(); }
			if (v && (typeof v.setValue === 'function')) { v.setValue(this._filter.IDProject || ''); }
		}
		if (tmpCA.getElement('#DocumentList-AuthorPicker').length > 0)
		{
			const v = tmpPicker.createPicker(`${this.providerName}-AuthorPicker`, {
				DestinationAddress: '#DocumentList-AuthorPicker', ValueAddress: `AppData.${this.providerName}.PickerAuthor`,
				Searchable: true, AllowClear: true, ClearLabel: '— add author —', Placeholder: 'Add an author…',
				DataProvider: this._authorDataProvider(), ResolveValue: () => Promise.resolve(null),
				OnChange: (val, pRecord) => { if (val) { this.addAuthor(val, pRecord && (pRecord.Text || pRecord.Name)); } },
			});
			if (v && (typeof v.render === 'function')) { v.render(); }
		}
		if (tmpCA.getElement('#DocumentList-KindPicker').length > 0)
		{
			const v = tmpPicker.createPicker(`${this.providerName}-KindPicker`, {
				DestinationAddress: '#DocumentList-KindPicker', ValueAddress: `AppData.${this.providerName}.PickerKind`,
				Searchable: true, AllowClear: true, ClearLabel: 'All', Placeholder: 'All',
				DataProvider: this._kindDataProvider(), ResolveValue: (val) => Promise.resolve(this._kindOption(val)),
				OnChange: (val) => this.setForm(val == null ? '' : String(val)),
			});
			if (v && (typeof v.render === 'function')) { v.render(); }
			if (v && (typeof v.setValue === 'function')) { v.setValue(this._filter.Form || ''); }
		}
	}
	_projectDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'Projects/Lite', IDField: 'IDProject',
				ToOption: (r) => ({ Value: Number(r.IDProject), Text: r.Value || r.Name || `Project ${r.IDProject}`, Record: r }),
			});
	}
	_projectResolveValue() { return (v) => { const id = Number(v); if (!id) { return Promise.resolve(null); } return this._get(`Project/${id}`).then((r) => ((r && r.IDProject) ? { Value: id, Text: r.Name || `#${id}` } : { Value: id, Text: `#${id}` })).catch(() => ({ Value: id, Text: `#${id}` })); }; }
	_authorDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._get(pURL), { Scope: 'FBV~Deleted~EQ~0', PageSize: 25 });
	}
	_KIND_OPTIONS() { return [ { Value: '0', Text: 'Reports' }, { Value: '1', Text: 'Forms' } ]; }
	_kindOption(pValue) { const v = String(pValue == null ? '' : pValue); return this._KIND_OPTIONS().find((o) => o.Value === v) || null; }
	_kindDataProvider()
	{
		return (pTerm) =>
		{
			const t = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
			const rows = this._KIND_OPTIONS().filter((o) => !t || o.Text.toLowerCase().indexOf(t) >= 0);
			return Promise.resolve({ results: rows, hasMore: false });
		};
	}
}

module.exports = DocumentListProvider;
module.exports.default_configuration = { ProviderIdentifier: 'DocumentList' };

const _CSS = /*css*/`
	/* Consistent horizontal gutter for the whole dashboard chrome (this screen runs full-bleed in Dashboard Mode, so the
	   page has no side padding). Standalone only — embedded in a Project tab the tab host supplies its own padding. The wide
	   results table full-bleeds back out to the edge (below) so it still uses the whole browser width. */
	.dol { width: 100%; --dol-gutter: clamp(1rem, 2.2vw, 2rem); }
	.dol:not(.dol-embedded) { padding-left: var(--dol-gutter); padding-right: var(--dol-gutter); }
	.dol.dol-embedded { --dol-gutter: 0px; }
	.dol-head { margin: 0 0 0.8rem; } .dol-title { font-size: 1.1rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); display: inline-flex; align-items: center; gap: 0.5rem; } .dol-title i { color: var(--theme-color-brand-primary,#2e7d74); }
	.dol-filters { background: var(--theme-color-background-secondary,#f4f6f9); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 10px; padding: 0.75rem 0.85rem; margin: 0 0 1rem; }
	.dol-row { display: flex; align-items: flex-end; gap: 0.6rem 0.8rem; flex-wrap: wrap; } .dol-row-pickers { margin-top: 0.6rem; }
	.dol-search { position: relative; flex: 1 1 16rem; min-width: 12rem; }
	.dol-search-ic { position: absolute; left: 0.6rem; top: 50%; transform: translateY(-50%); color: var(--theme-color-text-muted,#9aa3af); font-size: 0.8rem; }
	.dol-search-in { width: 100%; font-size: 0.88rem; padding: 0.42rem 0.6rem 0.42rem 1.9rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); }
	.dol-f { display: flex; flex-direction: column; gap: 0.15rem; font-size: 0.82rem; }
	.dol-f-l { font-size: 0.64rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary,#45505f); }
	.dol-f input, .dol-f select { font-size: 0.85rem; padding: 0.38rem 0.5rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); }
	.dol-apply { font-size: 0.84rem; font-weight: 600; color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border: none; border-radius: 7px; padding: 0.42rem 0.85rem; cursor: pointer; }
	.dol-clear { font-size: 0.84rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: transparent; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; padding: 0.42rem 0.75rem; cursor: pointer; }
	.dol-pick { display: flex; flex-direction: column; gap: 0.15rem; flex: 1 1 16rem; min-width: 13rem; } .dol-picker { min-width: 12rem; }
	.dol-tags { display: flex; gap: 0.3rem; flex-wrap: wrap; margin-top: 0.3rem; }
	.dol-tag { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.76rem; font-weight: 600; color: var(--theme-color-text-primary,#1f2733); background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 999px; padding: 0.08rem 0.2rem 0.08rem 0.5rem; }
	.dol-tag-x { border: none; background: transparent; color: var(--theme-color-text-muted,#98a2b3); cursor: pointer; font-size: 0.95rem; line-height: 1; }

	.dol-typedd { position: relative; display: inline-block; }
	.dol-ddbtn { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.85rem; padding: 0.38rem 0.6rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); color: var(--theme-color-text-primary,#1f2733); cursor: pointer; white-space: nowrap; min-width: 8rem; justify-content: space-between; }
	.dol-ddbtn:hover, .dol-ddbtn-open { border-color: var(--theme-color-brand-primary,#2e7d74); }
	.dol-ddbtn-open { box-shadow: 0 0 0 2px color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 18%, transparent); }
	.dol-ddcaret { font-size: 0.7rem; color: var(--theme-color-text-muted,#8894a4); }
	.dol-ddbadge { background: var(--theme-color-brand-primary,#2e7d74); color: #fff; font-size: 0.66rem; font-weight: 700; border-radius: 999px; padding: 0.02rem 0.4rem; }
	.dol-ddpanel { position: absolute; top: calc(100% + 0.35rem); left: 0; z-index: 40; width: 17rem; max-width: 82vw; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 9px; box-shadow: 0 12px 30px -12px rgba(20,40,50,0.3); overflow: hidden; }
	.dol-ddpanel-head { display: flex; align-items: center; justify-content: space-between; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light,#eef2f4); font-size: 0.66rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#8b98a3); }
	.dol-ddclearbtn { border: none; background: transparent; color: var(--theme-color-brand-primary,#2e7d74); font: inherit; font-size: 0.7rem; font-weight: 700; cursor: pointer; }
	.dol-ddlist { max-height: 16rem; overflow-y: auto; padding: 0.3rem; }
	.dol-dditem { display: flex; align-items: center; gap: 0.55rem; padding: 0.35rem 0.5rem; border-radius: 6px; cursor: pointer; font-size: 0.85rem; }
	.dol-dditem:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.dol-dditem input { accent-color: var(--theme-color-brand-primary,#2e7d74); width: 0.95rem; height: 0.95rem; cursor: pointer; flex: none; }
	.dol-ddname { flex: 1; color: var(--theme-color-text-primary,#1f2733); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.dol-dditem-on .dol-ddname { font-weight: 600; }
	.dol-statusdot { width: 0.6rem; height: 0.6rem; border-radius: 50%; flex: none; }
	.dol-ddempty { padding: 0.6rem; color: var(--theme-color-text-muted,#9aa3af); font-size: 0.82rem; text-align: center; }

	.dol-viewtabs-row { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
	.dol-viewtabs { display: inline-flex; gap: 0.15rem; padding: 0.2rem; background: var(--theme-color-background-secondary,#eef1f6); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 10px; }
	.dol-vtab { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-secondary,#54636e); background: transparent; border: none; border-radius: 7px; padding: 0.38rem 0.85rem; cursor: pointer; }
	.dol-vtab-on { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); }
	.dol-vtabcount { font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-muted,#6b7686); font-variant-numeric: tabular-nums; }
	.dol-vtabs-right { display: flex; align-items: center; gap: 0.55rem 0.9rem; flex-wrap: wrap; }
	.dol-embedded .dol-filters { margin-top: 0; }

	/* --- full-screen toggle + overlay --- */
	.dol-fsbtn { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.8rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 8px; padding: 0.36rem 0.7rem; cursor: pointer; white-space: nowrap; }
	.dol-fsbtn:hover { border-color: var(--theme-color-brand-primary,#2e7d74); color: var(--theme-color-brand-primary,#2e7d74); }
	.dol-fsbtn i { font-size: 0.78rem; opacity: 0.85; }
	.dol-fsbtn-on { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-color: var(--theme-color-brand-primary,#2e7d74); }
	.dol-fsbtn-on:hover { color: #fff; filter: brightness(1.05); }
	.dol-fsbtn-on i { opacity: 1; }
	/* Overlay fills the whole browser view, above the app nav (top navbar z-index 30, bottom bar 1050). 'transform' composites
	   the layer from creation so it paints immediately (avoids the "position:fixed blank until scroll" quirk). */
	.dol.dol-fs { position: fixed; inset: 0; z-index: 1100; overflow: auto; background: var(--theme-color-background-tertiary,#f3f4f6); padding-top: 1.1rem; padding-bottom: 1.6rem; transform: translateZ(0); }

	.dol-listwrap { width: auto; overflow-x: auto; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 10px; }
	/* Wide tabular data uses the WHOLE browser width + scrolls: cancel the chrome gutter so the table band reaches the edges. */
	.dol:not(.dol-embedded) .dol-listwrap { margin-left: calc(-1 * var(--dol-gutter)); margin-right: calc(-1 * var(--dol-gutter)); border-left: none; border-right: none; border-radius: 0; }
	.dol-list { width: 100%; border-collapse: collapse; font-size: 0.86rem; }
	.dol-list th { text-align: left; font-size: 0.64rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#6b7686); background: var(--theme-color-background-tertiary,#f4f6f9); padding: 0.5rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light,#e8ebf0); white-space: nowrap; }
	.dol-list td { padding: 0.5rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light,#f1f4f8); vertical-align: middle; }
	.dol-r { cursor: pointer; } .dol-r:hover td { background: var(--theme-color-background-secondary,#f6f8fb); }
	.dol-icon-cell { width: 2.4rem; } .dol-kicon { display: inline-flex; align-items: center; justify-content: center; width: 1.9rem; height: 1.9rem; border-radius: 6px; background: var(--theme-color-background-secondary,#eef1f6); color: var(--theme-color-brand-primary,#2e7d74); }
	.dol-type { font-size: 0.72rem; font-weight: 700; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border-radius: 5px; padding: 0.08rem 0.4rem; white-space: nowrap; }
	.dol-namecell { min-width: 16rem; } .dol-name { display: block; color: var(--theme-color-text-primary,#1f2733); } .dol-name-untitled { font-style: italic; color: var(--theme-color-text-muted,#9aa3af); } .dol-seq { display: block; font-size: 0.72rem; color: var(--theme-color-text-muted,#9aa3af); }
	.dol-nowrap { white-space: nowrap; }
	.dol-badge { font-size: 0.72rem; font-weight: 700; border: 1px solid; border-radius: 999px; padding: 0.1rem 0.55rem; white-space: nowrap; }
	.dol-actions { text-align: right; } .dol-actions .dol-act { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.76rem; font-weight: 600; border: 1px solid var(--theme-color-border-medium,#d5dbe3); background: var(--theme-color-background-primary,#fff); color: var(--theme-color-text-secondary,#45505f); border-radius: 6px; padding: 0.25rem 0.55rem; cursor: pointer; margin-left: 0.3rem; }
	.dol-act:hover { border-color: var(--theme-color-brand-primary,#2e7d74); color: var(--theme-color-brand-primary,#2e7d74); }
	.dol-act-danger:hover { border-color: var(--theme-color-danger,#c0392b); color: var(--theme-color-danger,#c0392b); }
	.dol-act-primary { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-color: var(--theme-color-brand-primary,#2e7d74); } .dol-act-primary:hover { color: #fff; filter: brightness(1.05); }
	.dol-act-icon { padding: 0.25rem 0.45rem; } .dol-lock { color: var(--theme-color-text-muted,#9aa3af); font-size: 0.72rem; margin-left: 0.35rem; }
	.dol-empty { padding: 2.4rem 1rem; text-align: center; color: var(--theme-color-text-muted,#8a94a3); font-size: 0.9rem; } .dol-empty.dol-error { color: #c0392b; }
	.dol-spin { display: inline-block; width: 1rem; height: 1rem; border: 2px solid var(--theme-color-border-medium,#d5dbe3); border-top-color: var(--theme-color-brand-primary,#2e7d74); border-radius: 50%; animation: dol-sp 0.7s linear infinite; vertical-align: -2px; }
	@keyframes dol-sp { to { transform: rotate(360deg); } }
	.dol-pager { display: flex; align-items: center; justify-content: center; gap: 1rem; padding: 0.9rem; }
	.dol-pg { font-size: 0.84rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; padding: 0.35rem 0.7rem; cursor: pointer; } .dol-pg[disabled] { opacity: 0.45; cursor: default; }
	.dol-pg-info { font-size: 0.82rem; color: var(--theme-color-text-muted,#6b7686); font-variant-numeric: tabular-nums; }

	/* charts */
	.dxp { width: 100%; } .dxp-badge-row { display: flex; justify-content: flex-end; margin: 0 0 0.7rem; }
	.dxp-badge { display: inline-flex; align-items: center; gap: 0.5rem; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 999px; padding: 0.35rem 0.8rem; font-size: 0.76rem; color: var(--theme-color-text-muted,#6b7686); }
	.dxp-badge b { color: var(--theme-color-brand-primary,#2e7d74); font-variant-numeric: tabular-nums; }
	.dxp-pulse { width: 0.5rem; height: 0.5rem; border-radius: 50%; background: #2f8f5b; } .dxp-pulse-busy { background: var(--theme-color-brand-primary,#2e7d74); animation: dol-blink 0.7s linear infinite; } @keyframes dol-blink { 50% { opacity: 0.25; } }
	.dxp-kpis { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.85rem; margin: 0 0 0.9rem; }
	.dxp-kpi { background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 13px; padding: 0.9rem 1rem; position: relative; overflow: hidden; }
	.dxp-eyebrow { font-size: 0.62rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; color: var(--theme-color-text-muted,#8b98a3); }
	.dxp-v { font-size: 1.85rem; font-weight: 800; line-height: 1; margin: 0.5rem 0 0.3rem; letter-spacing: -0.02em; color: var(--theme-color-text-primary,#1f2733); font-variant-numeric: tabular-nums; }
	.dxp-l { font-size: 0.76rem; color: var(--theme-color-text-muted,#6b7686); }
	.dxp-kpi-warn .dxp-v { color: #bd6631; } .dxp-kpi-warn::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 3px; background: #bd6631; }
	.dxp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.85rem; align-items: start; }
	.dxp-panel { background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 13px; padding: 0.9rem 1rem 1rem; min-width: 0; }
	.dxp-ph { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; margin: 0 0 0.8rem; }
	.dxp-ph h3 { font-size: 0.92rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); display: flex; align-items: center; gap: 0.45rem; margin: 0; } .dxp-ph h3 i { color: var(--theme-color-brand-primary,#2e7d74); font-size: 0.85rem; }
	.dxp-hint { font-size: 0.68rem; color: var(--theme-color-text-muted,#9aa3af); }
	.dxp-stack { display: flex; height: 2.4rem; border-radius: 9px; overflow: hidden; border: 1px solid var(--theme-color-border-light,#e2e8ec); margin: 0 0 0.7rem; }
	.dxp-seg { height: 100%; cursor: pointer; transition: width 0.5s cubic-bezier(.22,1,.36,1), opacity 0.15s; min-width: 2px; } .dxp-seg:hover { filter: brightness(1.07); } .dxp-seg-dim { opacity: 0.3; }
	.dxp-flegend { display: flex; flex-direction: column; gap: 0.25rem; }
	.dxp-fl { display: grid; grid-template-columns: auto 1fr auto auto; align-items: center; gap: 0.6rem; padding: 0.3rem 0.5rem; border-radius: 8px; cursor: pointer; font-size: 0.82rem; border: 1px solid transparent; } .dxp-fl:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.dxp-fl-on { background: var(--theme-color-brand-primary-subtle,#e3f1ee); border-color: color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 30%, transparent); }
	.dxp-sw { width: 0.7rem; height: 0.7rem; border-radius: 50%; } .dxp-fname { color: var(--theme-color-text-primary,#1f2733); } .dxp-fpct { color: var(--theme-color-text-muted,#9aa3af); font-variant-numeric: tabular-nums; } .dxp-fcnt { font-weight: 600; font-variant-numeric: tabular-nums; color: var(--theme-color-text-secondary,#54636e); }
	.dxp-rows { display: flex; flex-direction: column; gap: 0.15rem; }
	.dxp-row { display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 0.6rem; padding: 0.32rem 0.5rem; border-radius: 8px; cursor: pointer; position: relative; border: 1px solid transparent; } .dxp-row:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.dxp-row-on { background: var(--theme-color-brand-primary-subtle,#e3f1ee); border-color: color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 32%, transparent); }
	.dxp-row-bg { position: absolute; left: 0.5rem; right: 0.5rem; top: 0.2rem; bottom: 0.2rem; border-radius: 6px; z-index: 0; transition: width 0.5s cubic-bezier(.22,1,.36,1); }
	.dxp-lab { display: flex; align-items: center; gap: 0.55rem; min-width: 0; z-index: 1; } .dxp-dot { width: 0.6rem; height: 0.6rem; border-radius: 3px; flex: none; }
	.dxp-name { font-size: 0.82rem; color: var(--theme-color-text-primary,#1f2733); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } .dxp-row-on .dxp-name { font-weight: 600; color: var(--theme-color-brand-primary,#2e7d74); }
	.dxp-cnt { font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-secondary,#54636e); font-variant-numeric: tabular-nums; z-index: 1; } .dxp-row-on .dxp-cnt { color: var(--theme-color-brand-primary,#2e7d74); }
	.dxp-track { position: absolute; left: 0.5rem; right: 0.5rem; bottom: 0.15rem; height: 2px; border-radius: 2px; background: var(--theme-color-border-light,#eef2f4); overflow: hidden; z-index: 0; } .dxp-fill { position: absolute; left: 0; top: 0; bottom: 0; border-radius: 2px; transition: width 0.5s cubic-bezier(.22,1,.36,1); }
	.dxp-foot { margin-top: 1rem; font-size: 0.72rem; color: var(--theme-color-text-muted,#9aa3af); line-height: 1.6; } .dxp-foot i { color: #2f8f5b; } .dxp-foot b { color: var(--theme-color-text-secondary,#54636e); }

	@media (max-width: 900px) { .dxp-kpis { grid-template-columns: repeat(2, 1fr); } .dxp-grid { grid-template-columns: 1fr; } }
	@media (prefers-reduced-motion: reduce) { .dxp-seg, .dxp-row-bg, .dxp-fill { transition: none; } .dxp-pulse-busy { animation: none; } }
`;

},{"../access/User-Search.js":1064,"../providers/CustomerRecordManifests-Merge.js":1325,"../services/Entity-Picker-Search.js":1398,"pict-provider":845}],1272:[function(require,module,exports){
'use strict';

// Per-document-type configuration for the reusable [[DocumentThroughput-Provider.js]] dashboard. Each entry declares the
// DocumentType to scope to and the breakdown dimensions the agency cares about for that type. Adding a new document type
// to the throughput dashboard is a config entry here — no code change.
//
// Dimension shape: { Key, Label, ItemLabel, logField|docField, resolve }
//   • logField  — group by a field on the DocumentApprovalLog transition (e.g. CreatingIDUser = who submitted/approved).
//   • docField  — group by a field on the (lite) Document (e.g. IDProject).
//   • resolve   — 'user' | 'project' to turn the id into a display name (batched). Omit for a literal key.
//
// NOTE on DocumentType: it is a ReportNamedInstance identifier. 'Inspection-Dossier' is stored as a literal string here
// (verified against the Meadow filter), but other report types may be a hash — put the exact value the Document rows carry.

const CONFIGS =
{
	'Inspection-Dossier':
	{
		DocumentType: 'Inspection-Dossier',
		Title: 'Inspection submissions & approvals',
		Subtitle: 'Dossier submission and approval throughput across the inspection program — the inspection\'s real status is driven by this approval workflow.',
		Icon: 'fas fa-clipboard-check',
		Dimensions:
		[
			{ Key: 'submitter', Label: 'By submitter', ItemLabel: 'User', logField: 'CreatingIDUser', resolve: 'user' },
			{ Key: 'project', Label: 'By structure (project)', ItemLabel: 'Project', docField: 'IDProject', resolve: 'project' },
		],
	},

	// ---- Future: Structural Concrete reports, broken down by Producer and Project (the agency's ask). ----
	// Wire when the concrete report type + its Producer source are confirmed. Producer likely isn't on the lite Document,
	// so its dimension will need a `docField` once the producer id is exposed there (or a small resolver extension).
	// '<StructuralConcreteReportType>':
	// {
	//     DocumentType: '<literal-or-hash>',
	//     Title: 'Structural concrete reports',
	//     Subtitle: 'Concrete report submission and approval throughput.',
	//     Icon: 'fas fa-cubes',
	//     Dimensions:
	//     [
	//         { Key: 'producer', Label: 'By producer', ItemLabel: 'Producer', docField: 'IDProducer', resolve: 'organization' },
	//         { Key: 'project', Label: 'By project', ItemLabel: 'Project', docField: 'IDProject', resolve: 'project' },
	//     ],
	// },
};

// A generic config for any document type not explicitly registered (submitter + project breakdowns).
function genericConfig(pType)
{
	return {
		DocumentType: pType,
		Title: `${pType} throughput`,
		Subtitle: 'Submission and approval throughput driven by the document approval workflow.',
		Icon: 'fas fa-file-signature',
		Dimensions:
		[
			{ Key: 'submitter', Label: 'By submitter', ItemLabel: 'User', logField: 'CreatingIDUser', resolve: 'user' },
			{ Key: 'project', Label: 'By project', ItemLabel: 'Project', docField: 'IDProject', resolve: 'project' },
		],
	};
}

function resolveConfig(pType)
{
	if (!pType) { return CONFIGS['Inspection-Dossier']; }
	return CONFIGS[pType] || genericConfig(pType);
}

module.exports = { CONFIGS, resolveConfig };

},{}],1273:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

/**
 * DocumentThroughput — a REUSABLE document-approval throughput dashboard. The metric it visualizes is universal across the
 * platform: how many documents of a given type are submitted and approved over time (plus how long approval takes), broken
 * down by configurable dimensions. Inspection dossiers, structural-concrete reports, anything with an approval workflow.
 *
 * It is driven by a per-type config (see [[DocumentThroughput-Configs.js]]): `{ DocumentType, Title, Dimensions:[…] }`.
 * The Inspection Schedule points it at 'Inspection-Dossier'; a future Structural-Concrete screen points it at that report
 * type with Dimensions of Producer + Project — no code change, just a config entry.
 *
 * Data (plain Meadow, no server work, and — crucially — no slow full-Document scans):
 *   1. `Documents/Lite/FilteredTo/…DocumentType~EQ~<type>…` — fast, FormData-free; yields IDDocument + IDProject + Name.
 *   2. `DocumentApprovalLogs/FilteredTo/FBL~IDDocument~INN~<chunk>~FBV~CreateDate~GE~<windowStart>…` — the dated approval
 *      transitions (Action 'Submit' → submitted, IsApproval=1 → approved); log queries are well-indexed and ~80ms.
 * Everything else is aggregated client-side. The inspection's real status lives in this approval workflow, NOT the
 * Inspection.StatusDisplay shell.
 */

const _SUB = '#2f6f9f';   // submitted
const _APP = '#3f9e6a';   // approved
const _MON = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
const _DOC_CAP = 4000;

class DocumentThroughputProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#DocumentThroughput-Host';
		this._config = null;            // the active per-type config
		this._trailing = 12;
		this._docMeta = {};             // IDDocument -> { IDProject, Name }
		this._docType = '';             // type the current _docMeta was loaded for
		this._names = { user: {}, project: {} };
		this._agg = null;               // computed aggregation
		this._loading = false;
		this._error = '';
		this._loadGen = 0;
	}

	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get idCustomer() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }
	get providerName() { return 'DocumentThroughput'; }
	_get(pURL) { return new Promise((resolve) => this.restClient.getJSON(pURL, (e, b) => resolve(e ? null : b))); }
	_esc(pV) { return String(pV == null ? '' : pV).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

	// Configure for a document type. `pConfig` is a DocumentThroughput config object.
	configure(pConfig, pMount) { this._config = pConfig || null; if (pMount) { this._mount = pMount; } return this; }

	// --- date helpers ---
	_monthKeys()
	{
		const out = []; const d = new Date(); d.setDate(1); d.setHours(0, 0, 0, 0);
		for (let i = this._trailing - 1; i >= 0; i--) { const m = new Date(d.getFullYear(), d.getMonth() - i, 1); out.push({ key: `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, '0')}`, y: m.getFullYear(), m: m.getMonth() }); }
		return out;
	}
	_windowStartYMD() { const d = new Date(); const s = new Date(d.getFullYear(), d.getMonth() - (this._trailing - 1), 1); return `${s.getFullYear()}-${String(s.getMonth() + 1).padStart(2, '0')}-01`; }

	async loadAsync()
	{
		if (!this._config) { return; }
		const gen = ++this._loadGen;
		this._loading = true; this._error = ''; this._paint();
		try
		{
			await this._loadLiteDocs(gen);
			if (gen !== this._loadGen) { return; }
			const logs = await this._loadLogs(gen);
			if (gen !== this._loadGen) { return; }
			await this._aggregate(logs, gen);
		}
		catch (e) { this._error = (e && e.message) || String(e); }
		finally { if (gen === this._loadGen) { this._loading = false; this._paint(); } }
	}

	async _loadLiteDocs(pGen)
	{
		const type = this._config.DocumentType;
		if (this._docType === type && Object.keys(this._docMeta).length) { return; } // cached per type
		// Newest-first (FSF DESC): a trailing-window metric must keep the most RECENT documents when the type exceeds the cap.
		const rows = await this._get(`Documents/Lite/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}~FBV~DocumentType~EQ~${encodeURIComponent(type)}~FBV~Deleted~EQ~0~FSF~IDDocument~DESC~0/0/${_DOC_CAP}`);
		if (pGen !== this._loadGen) { return; }
		const meta = {};
		(Array.isArray(rows) ? rows : []).forEach((d) => { meta[d.IDDocument] = { IDProject: d.IDProject || 0, Name: d.Value || `Document ${d.IDDocument}` }; });
		this._docMeta = meta; this._docType = type;
		this._docTruncated = Array.isArray(rows) && rows.length >= _DOC_CAP;
	}

	async _loadLogs(pGen)
	{
		const ids = Object.keys(this._docMeta).map(Number).filter(Boolean);
		if (!ids.length) { return []; }
		const start = this._windowStartYMD();
		const out = [];
		this._logsTruncated = false;
		for (let i = 0; i < ids.length; i += 100)
		{
			const chunk = ids.slice(i, i + 100);
			// Newest-first so a >cap chunk keeps recent months (a trailing-window chart needs the newest, not the oldest).
			const rows = await this._get(`DocumentApprovalLogs/FilteredTo/FBL~IDDocument~INN~${chunk.join(',')}~FBV~CreateDate~GE~${start}~FBV~Deleted~EQ~0~FSF~CreateDate~DESC~0/0/8000`);
			if (pGen !== this._loadGen) { return out; }
			if (Array.isArray(rows)) { out.push(...rows); if (rows.length >= 8000) { this._logsTruncated = true; } }
		}
		return out;
	}

	async _aggregate(pLogs, pGen)
	{
		const months = this._monthKeys(); const idx = {}; months.forEach((mo, i) => { idx[mo.key] = i; });
		// Roll the raw transition log up to ONE record PER DOCUMENT first — a multi-step approval (Engineer→Contractor)
		// writes several IsApproval rows, so counting events would double-count and push the approval rate over 100%.
		const perDoc = {}; // IDDocument -> { firstSubmit, firstApprove, submitter }
		pLogs.forEach((log) =>
		{
			const isSubmit = (log.Action === 'Submit') || (log.AfterStatus === 'Submitted');
			const isApprove = (Number(log.IsApproval) === 1);
			if (!isSubmit && !isApprove) { return; }
			const pd = perDoc[log.IDDocument] || (perDoc[log.IDDocument] = { firstSubmit: null, firstApprove: null, submitter: null });
			if (isSubmit && (!pd.firstSubmit || log.CreateDate < pd.firstSubmit)) { pd.firstSubmit = log.CreateDate; pd.submitter = log.CreatingIDUser; }
			if (isApprove && (!pd.firstApprove || log.CreateDate < pd.firstApprove)) { pd.firstApprove = log.CreateDate; }
		});
		const submitted = new Array(months.length).fill(0); const approved = new Array(months.length).fill(0);
		const dims = (this._config.Dimensions || []).map((d) => ({ def: d, groups: {} }));
		const cycles = [];
		Object.keys(perDoc).forEach((docId) =>
		{
			const pd = perDoc[docId]; const meta = this._docMeta[docId] || {};
			if (pd.firstSubmit) { const mi = idx[pd.firstSubmit.slice(0, 7)]; if (mi != null) { submitted[mi]++; } }
			if (pd.firstApprove) { const mi = idx[pd.firstApprove.slice(0, 7)]; if (mi != null) { approved[mi]++; } }
			if (pd.firstSubmit && pd.firstApprove && pd.firstApprove >= pd.firstSubmit) { cycles.push((new Date(pd.firstApprove) - new Date(pd.firstSubmit)) / 86400000); }
			// dimension tallies — PER DOCUMENT. For a submitter (logField) dimension the key is the doc's SUBMITTER, so its
			// approved column counts that submitter's docs that got approved (not the approver, who is a different person).
			dims.forEach((dim) =>
			{
				const key = dim.def.docField ? meta[dim.def.docField] : (dim.def.logField === 'CreatingIDUser' ? pd.submitter : (dim.def.logField ? pd[dim.def.logField] : null));
				if (key == null || key === 0 || key === '') { return; }
				const g = dim.groups[key] || (dim.groups[key] = { submitted: 0, approved: 0 });
				if (pd.firstSubmit) { g.submitted++; }
				if (pd.firstApprove) { g.approved++; }
			});
		});
		cycles.sort((a, b) => a - b);
		const median = cycles.length ? (cycles.length % 2 ? cycles[(cycles.length - 1) / 2] : (cycles[cycles.length / 2 - 1] + cycles[cycles.length / 2]) / 2) : null;
		await this._resolveDimensionNames(dims, pGen);
		this._agg = {
			months, submitted, approved,
			totalDocs: Object.keys(this._docMeta).length,
			totalSubmitted: submitted.reduce((a, b) => a + b, 0),
			totalApproved: approved.reduce((a, b) => a + b, 0),
			medianCycleDays: median,
			dims,
		};
	}

	async _resolveDimensionNames(pDims, pGen)
	{
		const userIDs = []; const projIDs = [];
		pDims.forEach((dim) => { if (dim.def.resolve === 'user') { Object.keys(dim.groups).forEach((k) => userIDs.push(Number(k))); } else if (dim.def.resolve === 'project') { Object.keys(dim.groups).forEach((k) => projIDs.push(Number(k))); } });
		if (userIDs.length)
		{
			const need = [ ...new Set(userIDs.filter((x) => x && !this._names.user[x])) ];
			for (let i = 0; i < need.length; i += 100)
			{
				const chunk = need.slice(i, i + 100);
				const rows = await this._get(`Users/FilteredTo/FBL~IDUser~INN~${chunk.join(',')}/0/${chunk.length}`);
				if (pGen !== this._loadGen) { return; }
				(Array.isArray(rows) ? rows : []).forEach((u) => { this._names.user[u.IDUser] = [ u.NameFirst, u.NameLast ].filter(Boolean).join(' ') || u.LoginID || `User ${u.IDUser}`; });
			}
		}
		if (projIDs.length)
		{
			const need = [ ...new Set(projIDs.filter((x) => x && !this._names.project[x])) ];
			for (let i = 0; i < need.length; i += 100)
			{
				const chunk = need.slice(i, i + 100);
				const rows = await this._get(`Projects/Lite/FilteredTo/FBL~IDProject~INN~${chunk.join(',')}/0/${chunk.length}`);
				if (pGen !== this._loadGen) { return; }
				(Array.isArray(rows) ? rows : []).forEach((p) => { this._names.project[p.IDProject] = p.Value || p.Name || `Project ${p.IDProject}`; });
			}
		}
	}
	_dimLabel(pDim, pKey)
	{
		if (pDim.def.resolve === 'user') { return this._names.user[pKey] || `User ${pKey}`; }
		if (pDim.def.resolve === 'project') { return this._names.project[pKey] || `Project ${pKey}`; }
		return String(pKey);
	}

	// =========================================================== paint ===========================================================
	renderInto(pMount, pConfig) { this.configure(pConfig, pMount); this.loadAsync(); }
	_paint() { const ca = this.pict.ContentAssignment; if (!ca) { return; } ca.assignContent(this._mount, this._html()); }
	_html()
	{
		if (!this._config) { return ''; }
		if (this._error) { return `${_TP_STYLE}<div class="tp"><div class="tp-empty tp-err"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._error)}</div></div>`; }
		if (this._loading && !this._agg) { return `${_TP_STYLE}<div class="tp"><div class="tp-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading approval throughput…</div></div>`; }
		const a = this._agg || { months: this._monthKeys(), submitted: [], approved: [], totalDocs: 0, totalSubmitted: 0, totalApproved: 0, medianCycleDays: null, dims: [] };
		const rate = a.totalSubmitted ? Math.min(100, Math.round(100 * a.totalApproved / a.totalSubmitted)) : 0;
		const stats = `<div class="tp-stats">
			${this._stat(a.totalDocs, 'Documents of type', '')}
			${this._stat(a.totalSubmitted, `Submitted · ${this._trailing} mo`, _SUB)}
			${this._stat(a.totalApproved, `Approved · ${this._trailing} mo`, _APP)}
			${this._stat(a.medianCycleDays == null ? '—' : Math.round(a.medianCycleDays) + 'd', 'Median submit → approve', '')}
			${this._stat(rate + '%', 'Approval rate', '')}
		</div>`;
		// Compact embed (e.g. inside the Inspection Schedule Overview): stats + chart only, no dimension tables.
		if (this._config.Compact)
		{
			return `${_TP_STYLE}<div class="tp tp-compact">${stats}
				<div class="tp-card"><div class="tp-card-h">Submitted vs approved per month <span class="tp-legend"><span class="tp-dot" style="background:${_SUB}"></span>submitted <span class="tp-dot" style="background:${_APP}"></span>approved</span></div>${this._chartHTML(a)}</div></div>`;
		}
		return `${_TP_STYLE}<div class="tp">${stats}
			<div class="tp-card"><div class="tp-card-h">Throughput — submitted vs approved per month <span class="tp-legend"><span class="tp-dot" style="background:${_SUB}"></span>submitted <span class="tp-dot" style="background:${_APP}"></span>approved</span></div>${this._chartHTML(a)}</div>
			${(a.dims || []).map((dim) => `<div class="tp-card"><div class="tp-card-h">${this._esc(dim.def.Label || 'Breakdown')}</div>${this._dimHTML(dim)}</div>`).join('')}
			${this._docTruncated ? `<div class="tp-note"><i class="fas fa-circle-info"></i> Showing the first ${_DOC_CAP.toLocaleString()} documents of this type (capped).</div>` : ''}</div>`;
	}
	_stat(v, label, color) { return `<div class="tp-stat"><div class="tp-stat-v"${color ? ` style="color:${color}"` : ''}>${typeof v === 'number' ? v.toLocaleString() : this._esc(v)}</div><div class="tp-stat-l">${this._esc(label)}</div></div>`; }
	_chartHTML(a)
	{
		let max = 1; a.months.forEach((mo, i) => { max = Math.max(max, a.submitted[i] || 0, a.approved[i] || 0); });
		if (!a.totalSubmitted && !a.totalApproved) { return `<div class="tp-empty-sm">No submissions or approvals for this document type in the last ${this._trailing} months.</div>`; }
		const bars = a.months.map((mo, i) =>
		{
			const s = a.submitted[i] || 0; const ap = a.approved[i] || 0;
			return `<div class="tp-bar" title="${_MON[mo.m]} ${mo.y}: ${s} submitted, ${ap} approved">
				<div class="tp-bar-pair">
					<span class="tp-bar-c" style="height:${Math.round(100 * s / max)}%;background:${_SUB}"><span class="tp-bar-n">${s || ''}</span></span>
					<span class="tp-bar-c" style="height:${Math.round(100 * ap / max)}%;background:${_APP}"><span class="tp-bar-n">${ap || ''}</span></span>
				</div>
				<span class="tp-bar-x">${_MON[mo.m]}${mo.m === 0 ? " '" + String(mo.y).slice(2) : ''}</span>
			</div>`;
		}).join('');
		return `<div class="tp-chart">${bars}</div>`;
	}
	_dimHTML(dim)
	{
		const rows = Object.keys(dim.groups).map((k) => ({ key: k, ...dim.groups[k] })).sort((a, b) => b.submitted - a.submitted).slice(0, 12);
		if (!rows.length) { return `<div class="tp-empty-sm">No data.</div>`; }
		const max = Math.max(1, ...rows.map((r) => r.submitted));
		const body = rows.map((r) => `<tr>
			<td class="tp-dim-n">${this._esc(this._dimLabel(dim, r.key))}</td>
			<td class="tp-dim-bar"><div class="tp-dimbar"><span style="width:${Math.round(100 * r.submitted / max)}%;background:${_SUB}"></span></div></td>
			<td class="tp-dim-v">${r.submitted}</td>
			<td class="tp-dim-v" style="color:${_APP}">${r.approved}</td>
		</tr>`).join('');
		return `<table class="tp-dimtable"><thead><tr><th>${this._esc(dim.def.ItemLabel || 'Group')}</th><th></th><th>Subm.</th><th>Appr.</th></tr></thead><tbody>${body}</tbody></table>`;
	}
}

const _TP_STYLE = /*html*/`<style>
	.tp { --b:var(--theme-color-border-light,#e4e9ef); --mut:var(--theme-color-text-muted,#8894a4); --ink:var(--theme-color-text-primary,#1f2733); --sec:var(--theme-color-text-secondary,#45505f); --card:var(--theme-color-background-primary,#fff); --bg2:var(--theme-color-background-secondary,#f4f6f9); font-size:14px; color:var(--ink); }
	.tp-stats { display:grid; grid-template-columns:repeat(auto-fit,minmax(9rem,1fr)); gap:0.7rem; margin:0 0 0.9rem; }
	.tp-stat { background:var(--card); border:1px solid var(--b); border-radius:11px; padding:0.7rem 0.9rem; } .tp-stat-v { font-size:1.5rem; font-weight:800; line-height:1; } .tp-stat-l { font-size:0.68rem; color:var(--mut); margin-top:0.3rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:700; }
	.tp-card { background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.9rem 1rem; margin:0 0 0.9rem; } .tp-card-h { font-size:0.8rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--sec); margin:0 0 0.75rem; display:flex; align-items:center; gap:0.5rem; } .tp-legend { margin-left:auto; font-weight:600; text-transform:none; letter-spacing:0; color:var(--mut); display:inline-flex; align-items:center; gap:0.3rem; } .tp-dot { width:0.6rem; height:0.6rem; border-radius:50%; display:inline-block; margin-left:0.5rem; }
	.tp-chart { display:flex; align-items:flex-end; gap:0.5rem; height:11rem; }
	.tp-bar { flex:1; display:flex; flex-direction:column; align-items:center; justify-content:flex-end; gap:0.3rem; height:100%; } .tp-bar-pair { display:flex; align-items:flex-end; gap:2px; height:100%; width:100%; justify-content:center; }
	.tp-bar-c { width:38%; max-width:1.1rem; min-height:2px; border-radius:3px 3px 0 0; position:relative; display:flex; justify-content:center; } .tp-bar-n { position:absolute; top:-1rem; font-size:0.6rem; font-weight:800; color:var(--sec); } .tp-bar-x { font-size:0.62rem; color:var(--mut); font-weight:700; }
	.tp-dimtable { width:100%; border-collapse:collapse; font-size:0.85rem; } .tp-dimtable th { text-align:left; font-size:0.62rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--mut); font-weight:800; padding:0 0.4rem 0.4rem; } .tp-dimtable td { padding:0.35rem 0.4rem; border-top:1px solid var(--b); } .tp-dim-n { font-weight:600; } .tp-dim-bar { width:45%; } .tp-dimbar { height:0.55rem; background:var(--bg2); border-radius:4px; overflow:hidden; } .tp-dimbar span { display:block; height:100%; } .tp-dim-v { text-align:right; font-weight:700; }
	.tp-empty { padding:2.5rem; text-align:center; color:var(--mut); border:1px dashed var(--b); border-radius:12px; } .tp-err { color:#b23b32; } .tp-empty-sm { color:var(--mut); font-size:0.85rem; padding:1.4rem; text-align:center; } .tp-note { font-size:0.8rem; color:var(--mut); }
</style>`;

module.exports = DocumentThroughputProvider;
module.exports.default_configuration = { ProviderIdentifier: 'DocumentThroughput' };

},{"pict-provider":845}],1274:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libObjectEditor = require('pict-section-objecteditor');

// The Headlight dynamic-input themes (registered by HeadlightDynamicInputsBundle): the SAME manifest renders
// read-only or editable by swapping the section views' template prefix — no separate view/edit manifests. VIEW mode
// uses the Print theme (static text, no input boxes) so the read-only metadata blends into the record's other
// label/value groups instead of showing locked input boxes.
const THEME_VIEW = 'PictProvider-Theme-Print';
const THEME_EDIT = 'PictProvider-Theme-Edit';

const BODY_SELECTOR = '#EMF-Body';

/**
 * EntityMetadataForm — a REUSABLE provider that renders an entity's per-customer "custom metadata" (its
 * CustomProperties JSON blob) as an embedded pict-section-form, whose SHAPE is a ManifestSchema (Type
 * 'EntityMetadata', SubType = the entity name), composed client-side from its partials. Shows read-only in view
 * mode / editable in edit mode (one manifest, theme-prefix swap), with an entitlement-gated "Advanced" toggle that
 * swaps the guided form for the raw-JSON object editor over the SAME bound object (so keys the manifest doesn't
 * describe are preserved, and the host's single serialize point persists everything).
 *
 * Public API: openInto({ entityType, idCustomer, dataAddress, host, mode }).
 *   - entityType : e.g. 'Project' (→ ManifestSchema SubType)
 *   - idCustomer : the record's customer (prefer that customer's manifest, else the global/first)
 *   - dataAddress: the AppData path of the live CustomProperties object the form binds to (and the host serializes)
 *   - host       : CSS selector of the mount the caller painted (e.g. '#PW-CustomPropsHost')
 *   - mode       : 'view' | 'edit'
 *
 * See [[config-app-entity-metadata]].
 */
class EntityMetadataFormProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._manifestCache = {};   // key `${entity}:${customer}` → { Loading } | { Manifest, IDManifestSchema } | { Empty } | { Error }
		this._current = null;       // the active open() descriptor
		this._advanced = false;
		this._advancedKey = '';
		this._formKey = '';
		this._ws = null;            // workspace inline-editor state (openWorkspaceMetadata), or null for the embed (openInto) path
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get formHost() { return this.pict.providers.EntityMetaFormHost; }
	get packaging() { return this.pict.services.ManifestPackagingService; }
	get app() { return this.pict.PictApplication; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); } }

	/** True when the session may edit this entity's records (fail-open until the capability map loads). */
	_canEdit(pEntity)
	{
		const tmpSvc = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return true; }
		return !!tmpSvc.can(pEntity, 'Update');
	}

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }

	/** True when the session may use the Advanced (raw JSON) view — fail-open until the capability map loads. */
	_canAdvanced()
	{
		const tmpSvc = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return false; }
		return !!tmpSvc.can('CustomMetadata', 'Advanced');
	}

	// ── Public entry ─────────────────────────────────────────────────────────────
	async openInto(pOptions)
	{
		const tmpOpt = pOptions || {};
		const tmpCur =
		{
			entityType: tmpOpt.entityType, idCustomer: Number(tmpOpt.idCustomer) || 0,
			dataAddress: tmpOpt.dataAddress, host: tmpOpt.host, mode: (tmpOpt.mode === 'edit') ? 'edit' : 'view',
		};
		if (!tmpCur.entityType || !tmpCur.dataAddress || !tmpCur.host) { return; }
		this._ws = null;            // embed path (caller owns the record/save) — no inline edit controls
		this._current = tmpCur;
		// Reset the advanced toggle only when the record/host changes (so a repaint keeps the user's toggle).
		const tmpAdvKey = `${tmpCur.entityType}:${tmpCur.idCustomer}:${tmpCur.dataAddress}:${tmpCur.host}`;
		if (this._advancedKey !== tmpAdvKey) { this._advanced = false; this._advancedKey = tmpAdvKey; }
		this._renderPanel();                                        // paint shell (may show Loading)
		await this._ensureManifestAsync(tmpCur.entityType, tmpCur.idCustomer);
		if (this._current === tmpCur) { this._renderPanel(); }      // repaint with the resolved manifest
	}

	// ── Public entry: self-contained inline metadata editor for a workspace tab ───────────────────────────────
	// Reads an entity record's blob COLUMN (e.g. MixDesign.MixMetadata), shows the guided form read-only with an
	// Edit → Save flow that serializes back to that column and PUTs the entity. Reusable across entities/workspaces.
	async openWorkspaceMetadata(pOptions)
	{
		const tmpOpt = pOptions || {};
		const tmpEntity = tmpOpt.entityType;
		const tmpHost = tmpOpt.host;
		const tmpRecord = tmpOpt.record;
		if (!tmpEntity || !tmpHost || !tmpRecord) { return; }
		const tmpBlobColumn = tmpOpt.blobColumn || 'CustomProperties';
		const tmpIDField = tmpOpt.idField || `ID${tmpEntity}`;
		// Already showing this exact record (e.g. a tab repaint recreated the host) — just re-attach into the new
		// host and re-render; do NOT re-parse the blob, so an in-progress edit is preserved.
		if (this._ws && (this._ws.entityType === tmpEntity) && (Number(this._ws.id) === (Number(tmpRecord[tmpIDField]) || 0)) && this._current)
		{
			this._current.host = tmpHost;
			this._renderPanel();
			return;
		}
		// The entity's Meadow field may hand us the blob as an already-parsed object (JSON-typed field) or as a raw
		// JSON string (plain text field). We write back in whichever shape we read, so Meadow stores it correctly —
		// an explicit MetadataBlob.encoding ('object' | 'string') wins when the record's blob is empty (first save).
		const tmpRaw = tmpRecord[tmpBlobColumn];
		this._ws =
		{
			entityType: tmpEntity, blobColumn: tmpBlobColumn, idField: tmpIDField, id: Number(tmpRecord[tmpIDField]) || 0,
			record: tmpRecord, canEdit: this._canEdit(tmpEntity), editing: false, saving: false, error: '',
			encoding: tmpOpt.encoding || '', blobIsObject: (tmpRaw != null) && (typeof tmpRaw === 'object'),
		};
		this.pict.AppData.EntityMetaWS = this._parseBlob(tmpRaw);
		this._advanced = false; this._advancedKey = ''; this._formKey = '';
		this._current = { entityType: tmpEntity, idCustomer: Number(tmpOpt.idCustomer) || Number(tmpRecord.IDCustomer) || 0, dataAddress: 'AppData.EntityMetaWS', host: tmpHost, mode: 'view' };
		this._renderPanel();
		await this._ensureManifestAsync(this._current.entityType, this._current.idCustomer);
		if (this._current && (this._current.host === tmpHost)) { this._renderPanel(); }
	}

	_parseBlob(pRaw)
	{
		// Always hand back an INDEPENDENT working copy. For an already-parsed object (JSON-typed Meadow field) a deep
		// clone is essential — otherwise the form would marshal straight into the record's own object, clobbering the
		// original in-memory and leaving Cancel nothing to revert to.
		if (pRaw && (typeof pRaw === 'object')) { try { return JSON.parse(JSON.stringify(pRaw)); } catch (pE) { return {}; } }
		try { const tmpO = JSON.parse(pRaw || '{}'); return (tmpO && (typeof tmpO === 'object')) ? tmpO : {}; } catch (pE) { return {}; }
	}

	/** Shape the metadata object for the entity's blob field — mirror the read shape (or the config's encoding). */
	_serializeBlob(pObj)
	{
		const tmpObj = pObj || {};
		const tmpWantsObject = (this._ws && this._ws.encoding) ? (this._ws.encoding === 'object') : !!(this._ws && this._ws.blobIsObject);
		return tmpWantsObject ? tmpObj : JSON.stringify(tmpObj);
	}

	/** Enter inline edit mode (workspace tab). */
	wsEdit()
	{
		if (!this._ws || !this._ws.canEdit || this._ws.saving) { return; }
		this._ws.editing = true; this._ws.error = ''; this._advanced = false; this._formKey = '';
		this._current.mode = 'edit';
		this._renderPanel();
	}

	/** Discard edits + return to read-only. */
	wsCancel()
	{
		if (!this._ws || this._ws.saving) { return; }
		this.pict.AppData.EntityMetaWS = this._parseBlob(this._ws.record[this._ws.blobColumn]);   // revert to the loaded blob
		this._ws.editing = false; this._ws.error = ''; this._advanced = false; this._formKey = '';
		this._current.mode = 'view';
		this._renderPanel();
	}

	/** Serialize the metadata back to the entity's blob column and PUT the entity. */
	async wsSave()
	{
		if (!this._ws || !this._ws.editing || this._ws.saving) { return; }
		this.flush();   // marshal form → AppData.EntityMetaWS + restore the manifest's declared types
		this._ws.saving = true; this._ws.error = '';
		this._renderPanel();
		const tmpObj = this.pict.AppData.EntityMetaWS || {};
		const tmpSerialized = this._serializeBlob(tmpObj);
		const tmpBody = {};
		tmpBody[this._ws.idField] = this._ws.id;
		tmpBody[this._ws.blobColumn] = tmpSerialized;
		const tmpRes = await new Promise((resolve) => this.restClient.putJSON(this._ws.entityType, tmpBody, (pErr, pBody) => resolve({ error: pErr, result: pBody })));
		this._ws.saving = false;
		if (tmpRes.error || (tmpRes.result && tmpRes.result.ErrorCode))
		{
			this._ws.error = 'Could not save the metadata (you may not have permission).';
			this._renderPanel();
			this._toast(this._ws.error, 'error');
			return;
		}
		this._ws.record[this._ws.blobColumn] = tmpSerialized;   // keep the in-memory record in sync (same shape we sent)
		this._ws.editing = false; this._formKey = '';
		this._current.mode = 'view';
		this._renderPanel();
		this._toast('Metadata saved.', 'success');
	}

	// ── Manifest load + compose (client-side; the service's pure merge helper works in-browser) ──────────────
	async _ensureManifestAsync(pEntity, pCustomer)
	{
		const tmpKey = `${pEntity}:${pCustomer}`;
		const tmpExisting = this._manifestCache[tmpKey];
		if (tmpExisting && !tmpExisting.Loading) { return tmpExisting; }
		if (tmpExisting && tmpExisting.Loading) { return tmpExisting; }
		this._manifestCache[tmpKey] = { Loading: true };
		try
		{
			const tmpRows = await this._getJSON(`ManifestSchemas/FilteredTo/FBV~Type~EQ~EntityMetadata~FBV~SubType~EQ~${encodeURIComponent(pEntity)}~FBV~Deleted~EQ~0~FSF~Version~DESC~0/0/50`);
			const tmpList = Array.isArray(tmpRows) ? tmpRows : [];
			// Prefer this customer's manifest; else a Global (IDCustomer 0) default; else the newest row.
			const tmpRow = tmpList.find((pR) => Number(pR.IDCustomer) === pCustomer)
				|| tmpList.find((pR) => Number(pR.IDCustomer) === 0) || tmpList[0] || null;
			if (!tmpRow) { this._manifestCache[tmpKey] = { Empty: true }; return this._manifestCache[tmpKey]; }
			const tmpRoot = (typeof tmpRow.Manifest === 'string') ? JSON.parse(tmpRow.Manifest || '{}') : (tmpRow.Manifest || {});
			// Fetch + order the partials (Ordinal lives on the join row).
			let tmpPartials = [];
			const tmpJoins = await this._getJSON(`ManifestSchemaManifestSchemaPartialJoins/FilteredTo/FBV~IDManifestSchema~EQ~${tmpRow.IDManifestSchema}`);
			const tmpJoinList = Array.isArray(tmpJoins) ? tmpJoins : [];
			if (tmpJoinList.length)
			{
				const tmpOrd = {};
				tmpJoinList.forEach((pJ) => { tmpOrd[Number(pJ.IDManifestSchemaPartial)] = Number(pJ.Ordinal) || 0; });
				const tmpIDs = tmpJoinList.map((pJ) => Number(pJ.IDManifestSchemaPartial)).filter(Boolean);
				const tmpPRows = await this._getJSON(`ManifestSchemaPartials/FilteredTo/FBL~IDManifestSchemaPartial~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0/0/500`);
				tmpPartials = (Array.isArray(tmpPRows) ? tmpPRows : [])
					.map((pP) => ({ ManifestPartial: (typeof pP.ManifestPartial === 'string') ? JSON.parse(pP.ManifestPartial || '{}') : (pP.ManifestPartial || {}), __id: Number(pP.IDManifestSchemaPartial) }))
					.sort((pA, pB) => (tmpOrd[pA.__id] || 0) - (tmpOrd[pB.__id] || 0));
			}
			// Compose. _mergeManifests MUTATES its root in place, so clone first.
			let tmpManifest = tmpRoot;
			if (this.packaging && (typeof this.packaging._mergeManifests === 'function'))
			{
				const tmpPacked = this.packaging._mergeManifests({ Manifest: JSON.parse(JSON.stringify(tmpRoot)) }, tmpPartials);
				tmpManifest = (tmpPacked && tmpPacked.DefaultFormManifest) || tmpRoot;
			}
			this._manifestCache[tmpKey] = { Manifest: tmpManifest, IDManifestSchema: tmpRow.IDManifestSchema };
		}
		catch (pError)
		{
			this._manifestCache[tmpKey] = { Error: (pError && pError.message) ? pError.message : String(pError) };
		}
		return this._manifestCache[tmpKey];
	}

	// ── Render ───────────────────────────────────────────────────────────────────
	_renderPanel()
	{
		this._ensureStyles();
		const tmpCur = this._current;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCur || !tmpCA.getElement(tmpCur.host).length) { return; }
		const tmpEntry = this._manifestCache[`${tmpCur.entityType}:${tmpCur.idCustomer}`] || {};
		const tmpCanAdv = this._canAdvanced();
		const tmpToggle = tmpCanAdv
			? `<button type="button" class="emf-toggle" onclick="_Pict.providers.EntityMetadataForm.toggleAdvanced()">${this._advanced ? '<i class="fas fa-list-check"></i> Guided view' : '<i class="fas fa-code"></i> Advanced (JSON)'}</button>`
			: '';
		// Workspace inline-edit controls (openWorkspaceMetadata path only; the embed path's caller owns edit/save).
		let tmpWsBtns = '';
		if (this._ws)
		{
			if (this._ws.editing)
			{
				tmpWsBtns = `<button type="button" class="emf-btn emf-btn-primary"${this._ws.saving ? ' disabled' : ''} onclick="_Pict.providers.EntityMetadataForm.wsSave()">${this._ws.saving ? 'Saving…' : 'Save'}</button>`
					+ `<button type="button" class="emf-btn"${this._ws.saving ? ' disabled' : ''} onclick="_Pict.providers.EntityMetadataForm.wsCancel()">Cancel</button>`;
			}
			else if (this._ws.canEdit)
			{
				tmpWsBtns = `<button type="button" class="emf-btn" onclick="_Pict.providers.EntityMetadataForm.wsEdit()"><i class="fas fa-pen"></i> Edit</button>`;
			}
		}
		const tmpErr = (this._ws && this._ws.error) ? `<div class="emf-note emf-error">${this._esc(this._ws.error)}</div>` : '';
		// No title — the caller's panel already heads this section; we add only the edit controls + advanced toggle.
		const tmpHead = (tmpWsBtns || tmpToggle) ? `<div class="emf-head">${tmpWsBtns}${tmpToggle}</div>` : '';
		tmpCA.assignContent(tmpCur.host, `<div class="emf-panel">${tmpHead}${tmpErr}<div id="EMF-Body" class="emf-body"></div></div>`);
		// Neutralize the host's leftover object-editor box (border / grey bg / fixed-height overflow:auto) so the
		// form just flows and grows vertically like the record's other groups — no scroll box.
		const tmpHostEl = tmpCA.getElement(tmpCur.host);
		if (tmpHostEl && tmpHostEl[0] && tmpHostEl[0].style)
		{
			const tmpEl = tmpHostEl[0];
			tmpEl.style.overflow = 'visible'; tmpEl.style.maxHeight = 'none'; tmpEl.style.minHeight = '0';
			tmpEl.style.border = 'none'; tmpEl.style.background = 'transparent'; tmpEl.style.padding = '0';
		}
		if (tmpEntry.Loading) { tmpCA.assignContent(BODY_SELECTOR, '<div class="emf-note"><i class="fas fa-spinner fa-spin"></i> Loading…</div>'); return; }
		// Advanced (entitled) → raw object editor. Also the fallback when there is no manifest for this entity/customer.
		if ((this._advanced && tmpCanAdv) || tmpEntry.Empty || tmpEntry.Error || !tmpEntry.Manifest)
		{
			if (tmpEntry.Error) { /* fall through to the raw editor so the data is still shown + editable */ }
			this._mountRaw();
			return;
		}
		this._mountForm(tmpEntry.Manifest);
	}

	_mountForm(pManifest)
	{
		const tmpCur = this._current;
		const tmpHost = this.formHost;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpHost || (typeof tmpHost.loadForm !== 'function')) { tmpCA.assignContent(BODY_SELECTOR, '<div class="emf-note">The form runner is not available.</div>'); return; }
		const tmpKey = `${tmpCur.entityType}:${tmpCur.idCustomer}:${tmpCur.dataAddress}:${tmpCur.mode}`;
		try
		{
			if ((this._formKey === tmpKey) && (typeof tmpHost.isLoaded === 'function') && tmpHost.isLoaded())
			{
				// Same form; the host div was just recreated by a repaint — re-render into it + keep the theme.
				tmpHost.options.DestinationAddress = BODY_SELECTOR;
				this._applyTheme(tmpHost, tmpCur.mode);
				tmpHost.render();
			}
			else
			{
				tmpHost.loadForm(pManifest, { DestinationAddress: BODY_SELECTOR, DataAddress: tmpCur.dataAddress });
				this._formKey = tmpKey;
				this._applyTheme(tmpHost, tmpCur.mode);
				tmpHost.render();
				// Section views can be built a tick after loadForm (async inputs); re-apply the theme once more.
				setTimeout(() => { try { if (this._formKey === tmpKey) { this._applyTheme(tmpHost, tmpCur.mode); tmpHost.render(); } } catch (pE) { /* */ } }, 0);
			}
		}
		catch (pError) { tmpCA.assignContent(BODY_SELECTOR, `<div class="emf-note emf-error">Could not render the form: ${this._esc((pError && pError.message) || pError)}</div>`); }
	}

	/** Swap the section views' template prefix so one manifest renders read-only (view) or editable (edit). */
	_applyTheme(pHost, pMode)
	{
		const tmpPrefix = (pMode === 'edit') ? THEME_EDIT : THEME_VIEW;
		try
		{
			const tmpViews = (typeof pHost.getSectionViews === 'function') ? (pHost.getSectionViews() || []) : [];
			tmpViews.forEach((pView) => { if (pView) { pView.customDefaultTemplatePrefix = tmpPrefix; } });
		}
		catch (pError) { /* best-effort; falls back to the global theme */ }
	}

	// ── Raw JSON (object editor) — advanced, and the no-manifest fallback ─────────────────────────────────────
	_mountRaw()
	{
		const tmpCur = this._current;
		const tmpView = this._ensureRawView(tmpCur.dataAddress, tmpCur.mode === 'edit');
		if (!tmpView) { this.pict.ContentAssignment.assignContent(BODY_SELECTOR, '<div class="emf-note">The raw editor is not available.</div>'); return; }
		tmpView.options.DefaultDestinationAddress = BODY_SELECTOR;
		try { tmpView.render(); } catch (pError) { this.pict.ContentAssignment.assignContent(BODY_SELECTOR, `<div class="emf-note emf-error">Could not render the raw editor: ${this._esc((pError && pError.message) || pError)}</div>`); }
	}

	_ensureRawView(pDataAddress, pEditable)
	{
		const tmpHash = `EMF-Raw-${String(pDataAddress).replace(/[^A-Za-z0-9]/g, '_')}-${pEditable ? 'edit' : 'view'}`;
		if (this.pict.views[tmpHash]) { return this.pict.views[tmpHash]; }
		this.pict.addView(tmpHash, Object.assign({}, libObjectEditor.default_configuration,
			{
				ViewIdentifier: tmpHash, AutoRender: false, Editable: !!pEditable, InitialExpandDepth: 2,
				ObjectDataAddress: pDataAddress,
				Renderables: [ { RenderableHash: 'ObjectEditor-Container', TemplateHash: 'ObjectEditor-Container-Template', DestinationAddress: BODY_SELECTOR, RenderMethod: 'replace' } ],
			}), libObjectEditor);
		const tmpView = this.pict.views[tmpHash];
		if (tmpView && (typeof tmpView.initialize === 'function')) { tmpView.initialize(); }
		return tmpView;
	}

	/**
	 * Flush any pending guided-form edit into the bound object — call before the host serializes CustomProperties, so
	 * a value typed but not yet blurred is captured. No-op in advanced mode (the object editor mutates in place) or
	 * when no form is loaded. The form already auto-marshals on change; this just closes the unblurred-field gap.
	 */
	flush()
	{
		const tmpHost = this.formHost;
		if (!this._advanced && tmpHost && (typeof tmpHost.save === 'function') && (typeof tmpHost.isLoaded === 'function') && tmpHost.isLoaded())
		{
			try { tmpHost.save(); } catch (pError) { /* best-effort marshal */ }
			this._coerceTypes();
		}
	}

	/** The form marshals every input as a string; restore the manifest's declared types (Number/Boolean) on the bound
	 *  object so a numeric metadata value doesn't silently become a string on save. Date/Time stay strings. */
	_coerceTypes()
	{
		const tmpCur = this._current;
		if (!tmpCur) { return; }
		const tmpEntry = this._manifestCache[`${tmpCur.entityType}:${tmpCur.idCustomer}`];
		const tmpManifest = tmpEntry && tmpEntry.Manifest;
		const tmpDescriptors = tmpManifest && tmpManifest.Descriptors;
		const tmpObj = this._resolveAddress(tmpCur.dataAddress);
		if (!tmpDescriptors || !tmpObj || (typeof tmpObj !== 'object')) { return; }
		Object.keys(tmpDescriptors).forEach((pKey) =>
		{
			const tmpD = tmpDescriptors[pKey] || {};
			const tmpAddr = tmpD.DataAddress || pKey;
			if (tmpAddr.indexOf('.') > -1) { return; }                 // only top-level metadata keys (P1)
			if (!Object.prototype.hasOwnProperty.call(tmpObj, tmpAddr)) { return; }
			const tmpVal = tmpObj[tmpAddr];
			const tmpType = tmpD.DataType;
			if ((tmpType === 'Number') || (tmpType === 'PreciseNumber'))
			{
				if ((tmpVal === '') || (tmpVal == null)) { tmpObj[tmpAddr] = null; }
				else if ((typeof tmpVal === 'string') && (tmpVal.trim() !== '') && !isNaN(Number(tmpVal))) { tmpObj[tmpAddr] = Number(tmpVal); }
			}
			else if (tmpType === 'Boolean')
			{
				if (typeof tmpVal === 'string') { tmpObj[tmpAddr] = (tmpVal === 'true') || (tmpVal === '1') || (tmpVal === 'on'); }
			}
		});
	}

	/** Walk a Pict address (e.g. 'AppData.ProjectEditWorkspace.CustomPropsData') from the pict root to the live object. */
	_resolveAddress(pAddress)
	{
		const tmpParts = String(pAddress || '').split('.');
		let tmpNode = this.pict;
		for (let i = 0; i < tmpParts.length; i++) { if (tmpNode == null) { return null; } tmpNode = tmpNode[tmpParts[i]]; }
		return tmpNode;
	}

	toggleAdvanced()
	{
		if (!this._canAdvanced()) { return; }
		this._advanced = !this._advanced;
		// Force the guided form to re-mount when toggling back (the host div is replaced by the panel repaint).
		this._formKey = '';
		this._renderPanel();
	}

	_ensureStyles()
	{
		if ((typeof document === 'undefined') || document.getElementById('emf-styles')) { return; }
		const tmpStyle = document.createElement('style');
		tmpStyle.id = 'emf-styles';
		tmpStyle.textContent = /*css*/`
			.emf-panel { margin-top: 0.4rem; }
			.emf-head { display:flex; align-items:center; justify-content:flex-end; gap:0.75rem; margin:0 0 0.4rem; }
			.emf-toggle { font-size:0.74rem; font-weight:600; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; padding:0.25rem 0.6rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); }
			.emf-toggle:hover { border-color:var(--theme-color-primary,#2f6fed); color:var(--theme-color-primary,#2f6fed); }
			.emf-btn { font-size:0.78rem; font-weight:600; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; padding:0.28rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); }
			.emf-btn:hover:not([disabled]) { border-color:var(--theme-color-primary,#2f6fed); color:var(--theme-color-primary,#2f6fed); }
			.emf-btn[disabled] { opacity:0.6; cursor:default; }
			.emf-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
			.emf-btn-primary:hover:not([disabled]) { color:#fff; opacity:0.92; }
			.emf-note { font-size:0.85rem; color:var(--theme-color-text-muted,#6b7686); padding:0.5rem 0; }
			.emf-error { color:var(--theme-color-status-danger,#c0392b); }
		`;
		try { document.head.appendChild(tmpStyle); } catch (pError) { /* */ }
	}
}

EntityMetadataFormProvider.default_configuration = { ProviderIdentifier: 'EntityMetadataForm' };

module.exports = EntityMetadataFormProvider;
module.exports.default_configuration = EntityMetadataFormProvider.default_configuration;

},{"pict-provider":845,"pict-section-objecteditor":957}],1275:[function(require,module,exports){
/**
 * FormConcierge-Api — the browser client for the Form Concierge façade (`/formconcierge/1.0/*`, same origin as the app).
 *
 * The façade holds the plansheet token and enforces tenancy; this client only speaks JSON to it. Every call carries the
 * `X-Form-Concierge: 1` CSRF header (a custom header cannot be sent cross-origin without a preflight the façade never
 * allows), same-origin credentials and `cache: 'no-store'`. Uploads go through XHR (fetch has no upload progress) as a
 * raw-body PUT to `Upload`.
 *
 * `fetch` and `XMLHttpRequest` are injectable for tests; otherwise they are read from `window` at CALL time, never at
 * load time (the module is required by tests and by the bundle before any window exists).
 */

const DEFAULT_BASE_URL = '/formconcierge/1.0/';
const MAX_ID = 9999999999;

/**
 * Does nothing (the abort of an upload that never started).
 */
const noop = () =>
{
	// nothing to do
};

/**
 * An error answered by (or on the way to) the façade.
 * `.Status` is the HTTP status (0 = no response), `.Code` is the body's `Error` (or a client code such as
 * 'NetworkError', 'BadResponse', 'Aborted', 'BadRequest'), `.Detail` the body's `Detail`, `.Body` the parsed body or null.
 */
class FormConciergeApiError extends Error
{
	/**
	 * @param {string} pMessage - Human-readable message.
	 * @param {{ Status?: number, Code?: string, Detail?: string, Body?: any }} [pInfo] - What the façade answered.
	 */
	constructor(pMessage, pInfo)
	{
		super(pMessage);
		const tmpInfo = pInfo || {};
		this.name = 'FormConciergeApiError';
		/** @type {number} */
		this.Status = Number(tmpInfo.Status) || 0;
		/** @type {string} */
		this.Code = (typeof tmpInfo.Code === 'string') ? tmpInfo.Code : '';
		/** @type {string} */
		this.Detail = (typeof tmpInfo.Detail === 'string') ? tmpInfo.Detail : '';
		/** @type {any} */
		this.Body = (tmpInfo.Body === undefined) ? null : tmpInfo.Body;
	}
}

/**
 * Build the error for a non-2xx answer from its status and (maybe) parsed body.
 * @param {number} pStatus - HTTP status.
 * @param {any} pBody - Parsed JSON body, or null when it was not JSON.
 * @return {FormConciergeApiError}
 */
const errorFromResponse = (pStatus, pBody) =>
{
	const tmpBody = (pBody && (typeof pBody === 'object')) ? pBody : null;
	const tmpCode = (tmpBody && (typeof tmpBody.Error === 'string')) ? tmpBody.Error : '';
	const tmpDetail = (tmpBody && (typeof tmpBody.Detail === 'string')) ? tmpBody.Detail : '';
	let tmpMessage = tmpCode || `HTTP ${pStatus}`;
	if (tmpDetail)
	{
		tmpMessage += `: ${tmpDetail}`;
	}
	return new FormConciergeApiError(tmpMessage, { Status: pStatus, Code: tmpCode || `HTTP${pStatus}`, Detail: tmpDetail, Body: tmpBody });
};

/**
 * Parse a response text as JSON; '' → {} (a 2xx with no body), anything unparseable → undefined.
 * @param {string} pText - The raw response text.
 * @return {any}
 */
const parseJSONText = (pText) =>
{
	if ((typeof pText !== 'string') || (pText.trim().length < 1))
	{
		return {};
	}
	try
	{
		return JSON.parse(pText);
	}
	catch (pError)
	{
		return undefined;
	}
};

/**
 * A positive integer id for a path segment, or throw (keeps anything but digits out of the URL).
 * @param {any} pValue - The id as given.
 * @param {string} pName - Its name, for the error.
 * @return {number}
 */
const requireID = (pValue, pName) =>
{
	const tmpID = Number(pValue);
	if (!isFinite(tmpID) || (Math.floor(tmpID) !== tmpID) || (tmpID < 1) || (tmpID > MAX_ID))
	{
		throw new FormConciergeApiError(`BadRequest: ${pName} must be a positive integer`, { Status: 0, Code: 'BadRequest', Detail: pName });
	}
	return tmpID;
};

/**
 * Same-origin client for the Form Concierge façade (E2). Every method returns a promise of the façade's JSON or
 * rejects with a FormConciergeApiError; uploadFile returns `{ promise, abort }`.
 */
class FormConciergeApi
{
	/**
	 * @param {{ BaseURL?: string, fetch?: Function, XMLHttpRequest?: any }} [pOptions] - BaseURL defaults to
	 *   '/formconcierge/1.0/'; fetch / XMLHttpRequest default to window's at call time.
	 */
	constructor(pOptions)
	{
		const tmpOptions = pOptions || {};
		let tmpBaseURL = (typeof tmpOptions.BaseURL === 'string' && tmpOptions.BaseURL.length > 0) ? tmpOptions.BaseURL : DEFAULT_BASE_URL;
		if (tmpBaseURL.charAt(tmpBaseURL.length - 1) !== '/')
		{
			tmpBaseURL += '/';
		}
		/** @type {string} */
		this.BaseURL = tmpBaseURL;
		/** @type {Function|null} */
		this._fetch = (typeof tmpOptions.fetch === 'function') ? tmpOptions.fetch : null;
		/** @type {any} */
		this._XMLHttpRequest = (typeof tmpOptions.XMLHttpRequest === 'function') ? tmpOptions.XMLHttpRequest : null;
	}

	/**
	 * The fetch to use: the injected one, else window.fetch (resolved now, not at load).
	 * @return {Function|null}
	 */
	_resolveFetch()
	{
		if (this._fetch)
		{
			return this._fetch;
		}
		const tmpWindow = (typeof window !== 'undefined') ? /** @type {any} */ (window) : null;
		if (tmpWindow && (typeof tmpWindow.fetch === 'function'))
		{
			return tmpWindow.fetch.bind(tmpWindow);
		}
		return null;
	}

	/**
	 * The XMLHttpRequest constructor to use: the injected one, else window's.
	 * @return {any}
	 */
	_resolveXHR()
	{
		if (this._XMLHttpRequest)
		{
			return this._XMLHttpRequest;
		}
		const tmpWindow = (typeof window !== 'undefined') ? /** @type {any} */ (window) : null;
		if (tmpWindow && (typeof tmpWindow.XMLHttpRequest === 'function'))
		{
			return tmpWindow.XMLHttpRequest;
		}
		return null;
	}

	/**
	 * Send one request and answer `{ Status, Body, Empty }`: Body is the parsed JSON ({} for an empty body, undefined
	 * when the response was not JSON). Rejects only on a network-level failure (FormConciergeApiError 'NetworkError').
	 * @param {string} pMethod - GET / POST / PUT.
	 * @param {string} pPath - Path under BaseURL (may carry a query string).
	 * @param {any} [pBody] - Object to send as JSON; undefined sends no body.
	 * @return {Promise<{ Status: number, Body: any, Empty: boolean }>}
	 */
	async _send(pMethod, pPath, pBody)
	{
		const tmpFetch = this._resolveFetch();
		if (!tmpFetch)
		{
			throw new FormConciergeApiError('NetworkError: fetch is not available', { Status: 0, Code: 'NetworkError', Detail: 'fetch is not available' });
		}
		/** @type {Record<string, string>} */
		const tmpHeaders = { 'X-Form-Concierge': '1', 'Accept': 'application/json' };
		/** @type {Record<string, any>} */
		const tmpInit = { method: pMethod, credentials: 'same-origin', cache: 'no-store', headers: tmpHeaders };
		if (pBody !== undefined)
		{
			tmpHeaders['Content-Type'] = 'application/json';
			tmpInit.body = JSON.stringify(pBody);
		}
		let tmpResponse;
		let tmpText;
		try
		{
			tmpResponse = await tmpFetch(this.BaseURL + pPath, tmpInit);
			tmpText = await tmpResponse.text();
		}
		catch (pError)
		{
			const tmpDetail = (pError && pError.message) ? String(pError.message) : String(pError);
			throw new FormConciergeApiError(`NetworkError: ${tmpDetail}`, { Status: 0, Code: 'NetworkError', Detail: tmpDetail });
		}
		const tmpEmpty = (typeof tmpText !== 'string') || (tmpText.trim().length < 1);
		return { Status: Number(tmpResponse && tmpResponse.status) || 0, Body: parseJSONText(tmpText), Empty: tmpEmpty };
	}

	/**
	 * A JSON call: 2xx with a JSON object/array → the body; anything else → FormConciergeApiError.
	 * @param {string} pMethod - GET / POST / PUT.
	 * @param {string} pPath - Path under BaseURL.
	 * @param {any} [pBody] - JSON body (POST/PUT).
	 * @return {Promise<any>}
	 */
	async _json(pMethod, pPath, pBody)
	{
		const tmpResult = await this._send(pMethod, pPath, pBody);
		const tmpOK = (tmpResult.Status >= 200) && (tmpResult.Status < 300);
		if (!tmpOK)
		{
			throw errorFromResponse(tmpResult.Status, (tmpResult.Body === undefined) ? null : tmpResult.Body);
		}
		if ((tmpResult.Body === undefined) || (tmpResult.Body === null) || (typeof tmpResult.Body !== 'object'))
		{
			throw new FormConciergeApiError('BadResponse: the Form Concierge service did not answer JSON', { Status: tmpResult.Status, Code: 'BadResponse', Detail: 'not JSON' });
		}
		return tmpResult.Body;
	}

	/**
	 * GET Status. A missing façade (404), a non-JSON answer (e.g. the static server's HTML) or a network error
	 * degrades to `{ Configured:false, Allowed:false, Unreachable:true }` instead of throwing; other JSON errors throw.
	 * @return {Promise<any>}
	 */
	async getStatus()
	{
		const tmpUnreachable = { Configured: false, Allowed: false, Unreachable: true };
		let tmpResult;
		try
		{
			tmpResult = await this._send('GET', 'Status');
		}
		catch (pError)
		{
			return tmpUnreachable;
		}
		if (tmpResult.Status === 404)
		{
			return tmpUnreachable;
		}
		const tmpBody = tmpResult.Body;
		if (tmpResult.Empty || (tmpBody === undefined) || (tmpBody === null) || (typeof tmpBody !== 'object') || Array.isArray(tmpBody))
		{
			return tmpUnreachable;
		}
		if ((tmpResult.Status < 200) || (tmpResult.Status >= 300))
		{
			throw errorFromResponse(tmpResult.Status, tmpBody);
		}
		return tmpBody;
	}

	/**
	 * POST Workspace — find-or-create the customer's library and index anchors.
	 * @return {Promise<{ Workspace: any }>}
	 */
	ensureWorkspace()
	{
		return this._json('POST', 'Workspace', {});
	}

	/**
	 * GET Forms — the customer's indexed forms plus adoptable plansheet form projects.
	 * @return {Promise<{ Forms: Array<any>, Unindexed: Array<any> }>}
	 */
	getForms()
	{
		return this._json('GET', 'Forms');
	}

	/**
	 * POST Form — create a form project and index it.
	 * @param {{ Name: string, Summary?: string }} pBody - The new form.
	 * @return {Promise<{ Form: any }>}
	 */
	createForm(pBody)
	{
		return this._json('POST', 'Form', pBody || {});
	}

	/**
	 * POST Form/:IDProject/Adopt — index an existing plansheet form project for this customer.
	 * @param {number} pIDProject - The plansheet project.
	 * @return {Promise<{ Form: any }>}
	 */
	async adoptForm(pIDProject)
	{
		const tmpID = requireID(pIDProject, 'IDProject');
		return this._json('POST', `Form/${tmpID}/Adopt`, {});
	}

	/**
	 * Upload one file's original bytes to the customer's library (XHR PUT with byte progress).
	 * @param {any} pFile - A File/Blob (`name`, `type`, `size`).
	 * @param {{ onProgress?: (pFraction: number) => void }} [pOptions] - onProgress gets 0..1.
	 * @return {{ promise: Promise<{ IDMedia: number, IDProjectSource: number, Name: string, MimeType: string, FileSizeBytes: number }>, abort: () => void }}
	 */
	uploadFile(pFile, pOptions)
	{
		const tmpOptions = pOptions || {};
		const XHRClass = this._resolveXHR();
		if (!pFile)
		{
			return { promise: Promise.reject(new FormConciergeApiError('BadRequest: no file', { Status: 0, Code: 'BadRequest', Detail: 'file' })), abort: noop };
		}
		if (!XHRClass)
		{
			return { promise: Promise.reject(new FormConciergeApiError('NetworkError: XMLHttpRequest is not available', { Status: 0, Code: 'NetworkError', Detail: 'XMLHttpRequest is not available' })), abort: noop };
		}
		const tmpName = (typeof pFile.name === 'string' && pFile.name.length > 0) ? pFile.name : 'upload';
		const tmpType = (typeof pFile.type === 'string' && pFile.type.length > 0) ? pFile.type : 'application/octet-stream';
		const tmpSize = Number(pFile.size) || 0;
		const tmpURL = `${this.BaseURL}Upload?Name=${encodeURIComponent(tmpName)}&MimeType=${encodeURIComponent(tmpType)}`;
		const tmpXHR = new XHRClass();
		let tmpDone = false;
		let tmpLastFraction = -1;

		/** @param {number} pFraction */
		const fReport = (pFraction) =>
		{
			if (typeof tmpOptions.onProgress !== 'function')
			{
				return;
			}
			const tmpFraction = Math.max(0, Math.min(1, Number(pFraction) || 0));
			if (tmpFraction === tmpLastFraction)
			{
				return;
			}
			tmpLastFraction = tmpFraction;
			try
			{
				tmpOptions.onProgress(tmpFraction);
			}
			catch (pError)
			{
				// a progress painter must never break the upload
			}
		};

		/** @type {(pError: Error|null, pResult?: any) => void} */
		let fFinish = noop;
		const tmpPromise = new Promise((fResolve, fReject) =>
		{
			fFinish = (pError, pResult) =>
			{
				if (tmpDone)
				{
					return;
				}
				tmpDone = true;
				if (pError)
				{
					return fReject(pError);
				}
				return fResolve(pResult);
			};

			tmpXHR.open('PUT', tmpURL, true);
			tmpXHR.setRequestHeader('X-Form-Concierge', '1');
			tmpXHR.setRequestHeader('Accept', 'application/json');
			tmpXHR.setRequestHeader('Content-Type', tmpType);
			if (tmpXHR.upload)
			{
				tmpXHR.upload.onprogress = (pEvent) =>
				{
					if (!pEvent)
					{
						return;
					}
					const tmpTotal = (pEvent.lengthComputable && Number(pEvent.total) > 0) ? Number(pEvent.total) : tmpSize;
					if (tmpTotal > 0)
					{
						fReport(Number(pEvent.loaded) / tmpTotal);
					}
				};
			}
			tmpXHR.onload = () =>
			{
				const tmpStatus = Number(tmpXHR.status) || 0;
				const tmpBody = parseJSONText(tmpXHR.responseText);
				if ((tmpStatus >= 200) && (tmpStatus < 300))
				{
					if ((tmpBody === undefined) || (tmpBody === null) || (typeof tmpBody !== 'object'))
					{
						return fFinish(new FormConciergeApiError('BadResponse: the upload did not answer JSON', { Status: tmpStatus, Code: 'BadResponse', Detail: 'not JSON' }));
					}
					fReport(1);
					return fFinish(null, tmpBody);
				}
				if (tmpStatus === 0)
				{
					return fFinish(new FormConciergeApiError('NetworkError: the upload did not complete', { Status: 0, Code: 'NetworkError', Detail: 'no response' }));
				}
				return fFinish(errorFromResponse(tmpStatus, (tmpBody === undefined) ? null : tmpBody));
			};
			tmpXHR.onerror = () =>
			{
				fFinish(new FormConciergeApiError('NetworkError: the upload failed', { Status: 0, Code: 'NetworkError', Detail: 'upload failed' }));
			};
			tmpXHR.ontimeout = () =>
			{
				fFinish(new FormConciergeApiError('Timeout: the upload timed out', { Status: 0, Code: 'Timeout', Detail: 'upload timed out' }));
			};
			tmpXHR.onabort = () =>
			{
				fFinish(new FormConciergeApiError('Aborted: the upload was cancelled', { Status: 0, Code: 'Aborted', Detail: 'cancelled' }));
			};
			try
			{
				tmpXHR.send(pFile);
			}
			catch (pError)
			{
				const tmpDetail = (pError && pError.message) ? String(pError.message) : String(pError);
				fFinish(new FormConciergeApiError(`NetworkError: ${tmpDetail}`, { Status: 0, Code: 'NetworkError', Detail: tmpDetail }));
			}
		});

		return {
			promise: tmpPromise,
			abort: () =>
			{
				if (tmpDone)
				{
					return;
				}
				try
				{
					tmpXHR.abort();
				}
				catch (pError)
				{
					// already finished
				}
				// Not every XHR fires onabort synchronously (or at all); settle here so the caller never hangs.
				fFinish(new FormConciergeApiError('Aborted: the upload was cancelled', { Status: 0, Code: 'Aborted', Detail: 'cancelled' }));
			},
		};
	}

	/**
	 * POST Form/:IDProject/Sources — link library media and inline text into a form's corpus.
	 * @param {number} pIDProject - The form project.
	 * @param {Array<any>} pSources - `{Kind:'media', IDMedia, Name, Role?, Description?}` | `{Kind:'text', Name, Title?, Body, Role?}`.
	 * @return {Promise<{ Sources: Array<any> }>}
	 */
	async addSources(pIDProject, pSources)
	{
		const tmpID = requireID(pIDProject, 'IDProject');
		return this._json('POST', `Form/${tmpID}/Sources`, { Sources: Array.isArray(pSources) ? pSources : [] });
	}

	/**
	 * GET Form/:IDProject/Sources — the form's corpus (names/roles only, never bodies).
	 * @param {number} pIDProject - The form project.
	 * @return {Promise<{ Sources: Array<any> }>}
	 */
	async getSources(pIDProject)
	{
		const tmpID = requireID(pIDProject, 'IDProject');
		return this._json('GET', `Form/${tmpID}/Sources`);
	}

	/**
	 * POST Session — start a create / update / build run, or an examples follow-up.
	 * @param {{ Flow: string, IDProject: number, Text?: string, DeliverTo?: string, ValidateOnly?: boolean, Force?: boolean, NewSources?: Array<string> }} pBody
	 * @return {Promise<{ IDRequest: number, IDRun?: number, Status?: string, Mode?: string, Warnings?: Array<string> }>}
	 */
	startSession(pBody)
	{
		return this._json('POST', 'Session', pBody || {});
	}

	/**
	 * GET Sessions — recent sessions across the customer's forms, or one form's.
	 * @param {number} [pIDProject] - Limit to one form project.
	 * @return {Promise<{ Sessions: Array<any> }>}
	 */
	async getSessions(pIDProject)
	{
		if (!pIDProject)
		{
			return this._json('GET', 'Sessions');
		}
		const tmpID = requireID(pIDProject, 'IDProject');
		return this._json('GET', `Sessions?IDProject=${tmpID}`);
	}

	/**
	 * GET Session/:IDRequest — the session, its turns, the active run and the form.
	 * @param {number} pIDRequest - The plansheet request.
	 * @return {Promise<any>}
	 */
	async getSession(pIDRequest)
	{
		const tmpID = requireID(pIDRequest, 'IDRequest');
		return this._json('GET', `Session/${tmpID}`);
	}

	/**
	 * POST Session/:IDRequest/Message — send a follow-up turn.
	 * @param {number} pIDRequest - The plansheet request.
	 * @param {{ Text: string, NewSources?: Array<string> }} pBody - The turn.
	 * @return {Promise<{ IDRequest: number }>}
	 */
	async sendMessage(pIDRequest, pBody)
	{
		const tmpID = requireID(pIDRequest, 'IDRequest');
		return this._json('POST', `Session/${tmpID}/Message`, pBody || {});
	}

	/**
	 * POST Session/:IDRequest/Cancel — best-effort cancel of the active run.
	 * @param {number} pIDRequest - The plansheet request.
	 * @return {Promise<{ CancelRequested: boolean, Claimed: boolean }>}
	 */
	async cancelSession(pIDRequest)
	{
		const tmpID = requireID(pIDRequest, 'IDRequest');
		return this._json('POST', `Session/${tmpID}/Cancel`, {});
	}
}

module.exports = { FormConciergeApi, FormConciergeApiError };

},{}],1276:[function(require,module,exports){
/**
 * FormConcierge-FileText — turns a dropped file into markdown for the form corpus (contract §7 + C8 + D15).
 *
 * `convertFileToMarkdown(file)` never rejects: anything it cannot read comes back as `{ Markdown: null }`
 * with a note, and the original still uploads. Input parsed is capped at 25 MB (and 200 MB once a zip-based
 * Office file is inflated), output at 400 000 characters.
 *
 * - .md .markdown .txt → the text; .csv .tsv → a markdown table up to 2 000 rows, else fenced text;
 *   .json → fenced json (pretty when valid); .xml .html .htm → fenced text (never rendered).
 * - .xlsx .xlsm .xls .ods → SheetJS: one `## Sheet: <name>` table per visible sheet (≤ 2 000 rows, ≤ 50 cols).
 * - .docx / .pptx → SheetJS's zip reader (XLSX.CFB) + DOMParser, best-effort headings, lists and tables.
 * - .pdf → pdf.js loaded on first use from js/pdfjs-dist; a near-textless PDF "looks scanned" → null.
 *
 * SheetJS is the page global `window.XLSX`: the build browserify-ignores `xlsx`, so `require('xlsx')` is an
 * empty stub there (same guard as data-import/DataImport-Xlsx-Parser.js). XLSX, DOMParser and the pdf.js
 * loader are injectable for tests; defaults are resolved at call time. No window / document access at load.
 */

/** Largest file parsed. */
const INPUT_CAP_BYTES = 25 * 1024 * 1024;
/** Largest total an Office zip may inflate to before it is refused (zip-bomb guard). */
const INFLATED_CAP_BYTES = 200 * 1024 * 1024;
/** Longest markdown returned. */
const OUTPUT_CAP_CHARS = 400000;
/** Rows per table (header included). */
const TABLE_ROW_CAP = 2000;
/** Columns per table. */
const TABLE_COLUMN_CAP = 50;
/** Below this many non-space characters per page a PDF is treated as scanned. */
const SCANNED_CHARS_PER_PAGE = 20;
/** Pages read from one PDF. */
const PDF_PAGE_CAP = 1000;
/** pdf.js module and worker, served beside index.html (app package.json copyFiles). */
const PDFJS_SCRIPT_SRC = 'js/pdfjs-dist/build/pdf.mjs';
const PDFJS_WORKER_SRC = 'js/pdfjs-dist/build/pdf.worker.mjs';
/** How long the pdf.js script may take to load, and one PDF to convert. */
const PDFJS_LOAD_TIMEOUT_MS = 30000;
const PDF_CONVERT_TIMEOUT_MS = 120000;

const NS_WORD = [ 'http://schemas.openxmlformats.org/wordprocessingml/2006/main', 'http://purl.oclc.org/ooxml/wordprocessingml/main' ];
const NS_DRAWING = [ 'http://schemas.openxmlformats.org/drawingml/2006/main', 'http://purl.oclc.org/ooxml/drawingml/main' ];
const NS_PRESENTATION = [ 'http://schemas.openxmlformats.org/presentationml/2006/main', 'http://purl.oclc.org/ooxml/presentationml/main' ];
const NS_MARKUP_COMPATIBILITY = [ 'http://schemas.openxmlformats.org/markup-compatibility/2006' ];

/** @type {Record<string, string>} */
const _KindByExtension =
	{
		md: 'text', markdown: 'text', txt: 'text',
		csv: 'csv', tsv: 'csv',
		json: 'json',
		xml: 'markup', html: 'markup', htm: 'markup',
		xlsx: 'spreadsheet', xlsm: 'spreadsheet', xls: 'spreadsheet', ods: 'spreadsheet',
		docx: 'docx',
		pptx: 'pptx',
		pdf: 'pdf',
	};

/** @type {Record<string, string>} */
const _KindByType =
	{
		'text/markdown': 'text',
		'text/plain': 'text',
		'text/csv': 'csv',
		'text/tab-separated-values': 'csv',
		'application/json': 'json',
		'text/xml': 'markup',
		'application/xml': 'markup',
		'text/html': 'markup',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'spreadsheet',
		'application/vnd.ms-excel.sheet.macroenabled.12': 'spreadsheet',
		'application/vnd.ms-excel': 'spreadsheet',
		'application/vnd.oasis.opendocument.spreadsheet': 'spreadsheet',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
		'application/pdf': 'pdf',
	};

const _TextNativeExtensions = [ 'md', 'markdown', 'txt', 'csv', 'tsv', 'json' ];
/** Kinds whose bytes are never text, whatever MIME type the browser guessed. */
const _BinaryKinds = [ 'spreadsheet', 'docx', 'pptx', 'pdf', 'binary' ];

/** @type {any} Cached pdf.js load. */
let _PdfJsPromise = null;

/**
 * The global object, typed loosely (pdf.js and SheetJS hang off it).
 *
 * @return {any} globalThis / window / self, or an empty object.
 */
function _global()
{
	if (typeof globalThis !== 'undefined')
	{
		return /** @type {any} */ (globalThis);
	}
	if (typeof window !== 'undefined')
	{
		return /** @type {any} */ (window);
	}
	return {};
}

/**
 * Lower-cased extension of a file name, without the dot.
 *
 * @param {any} pName - the file name.
 *
 * @return {string} 'xlsx', or '' when there is none.
 */
function _extensionOf(pName)
{
	const tmpName = (typeof pName === 'string') ? pName.trim() : '';
	const tmpDot = tmpName.lastIndexOf('.');
	return ((tmpDot >= 0) && (tmpDot < tmpName.length - 1)) ? tmpName.slice(tmpDot + 1).toLowerCase() : '';
}

/**
 * What kind of file this is, by extension first and MIME type second.
 *
 * TextNative (C8 upload rule): text/*, application/json, or a .md/.markdown/.txt/.csv/.tsv/.json name —
 * except that a name saying spreadsheet / Word / PowerPoint / PDF is never text, whatever the MIME type.
 *
 * @param {any} pName - file name.
 * @param {any} pType - MIME type ('' when the browser did not know).
 *
 * @return {{ Kind: string, TextNative: boolean }} the classification.
 */
function classifyFile(pName, pType)
{
	const tmpExtension = _extensionOf(pName);
	const tmpType = ((typeof pType === 'string') ? pType : '').split(';')[0].trim().toLowerCase();
	let tmpKind = _KindByExtension[tmpExtension] || _KindByType[tmpType] || '';
	if (!tmpKind)
	{
		tmpKind = (tmpType.indexOf('text/') === 0) ? 'text' : 'binary';
	}
	const tmpNativeSignal = (tmpType.indexOf('text/') === 0) || (tmpType === 'application/json') || (_TextNativeExtensions.indexOf(tmpExtension) >= 0);
	return { Kind: tmpKind, TextNative: tmpNativeSignal && (_BinaryKinds.indexOf(tmpKind) < 0) };
}

/**
 * A failed conversion.
 *
 * @param {string} pKind - the file kind.
 * @param {string} pNote - why.
 *
 * @return {{ Markdown: null, Kind: string, Notes: Array<string> }} the result.
 */
function _noText(pKind, pNote)
{
	return { Markdown: null, Kind: pKind, Notes: [ pNote ] };
}

/**
 * A short, single-line error message for a note.
 *
 * @param {any} pError - the error.
 *
 * @return {string} the message.
 */
function _errorText(pError)
{
	const tmpMessage = (pError && pError.message) ? String(pError.message) : String(pError);
	return tmpMessage.replace(/[\x00-\x1f\x7f]+/g, ' ').trim().slice(0, 160);
}

/**
 * Resolves SheetJS: the injected one, else the page global, else `require('xlsx')`; null unless it is a real
 * SheetJS (the browserify-ignore stub is `{}`).
 *
 * @param {any} pDeps - injected dependencies.
 *
 * @return {any} SheetJS or null.
 */
function _resolveXLSX(pDeps)
{
	/** @type {any} */
	let tmpXLSX = pDeps ? pDeps.XLSX : null;
	if (!tmpXLSX && (typeof window !== 'undefined'))
	{
		tmpXLSX = /** @type {any} */ (window).XLSX;
	}
	if (!tmpXLSX)
	{
		try
		{
			tmpXLSX = require('xlsx');
		}
		catch (pError)
		{
			tmpXLSX = null;
		}
	}
	return (tmpXLSX && (typeof tmpXLSX.read === 'function')) ? tmpXLSX : null;
}

/**
 * Resolves a DOMParser constructor: the injected one, else the page's.
 *
 * @param {any} pDeps - injected dependencies.
 *
 * @return {any} the constructor or null.
 */
function _resolveDOMParser(pDeps)
{
	if (pDeps && (typeof pDeps.DOMParser === 'function'))
	{
		return pDeps.DOMParser;
	}
	const tmpGlobal = _global();
	return (typeof tmpGlobal.DOMParser === 'function') ? tmpGlobal.DOMParser : null;
}

/**
 * Reads a file's bytes (File.arrayBuffer, else FileReader).
 *
 * @param {any} pFile - a File-like object.
 *
 * @return {Promise<Uint8Array|null>} the bytes, or null when the object cannot give them.
 */
function _readBytes(pFile)
{
	if (typeof pFile.arrayBuffer === 'function')
	{
		return Promise.resolve(pFile.arrayBuffer()).then((pBuffer) => _toBytes(pBuffer));
	}
	const tmpGlobal = _global();
	if ((typeof tmpGlobal.FileReader === 'function') && (typeof tmpGlobal.Blob === 'function') && (pFile instanceof tmpGlobal.Blob))
	{
		return new Promise((fResolve, fReject) =>
		{
			const tmpReader = new tmpGlobal.FileReader();
			tmpReader.onload = () => fResolve(_toBytes(tmpReader.result));
			tmpReader.onerror = () => fReject(tmpReader.error || new Error('The file could not be read'));
			tmpReader.readAsArrayBuffer(pFile);
		});
	}
	return Promise.resolve(null);
}

/**
 * A Uint8Array view of whatever a reader returned.
 *
 * @param {any} pValue - ArrayBuffer, typed array or Buffer.
 *
 * @return {Uint8Array|null} the bytes.
 */
function _toBytes(pValue)
{
	if (!pValue)
	{
		return null;
	}
	if (pValue instanceof Uint8Array)
	{
		return pValue;
	}
	if ((typeof ArrayBuffer !== 'undefined') && ArrayBuffer.isView && ArrayBuffer.isView(pValue))
	{
		return new Uint8Array(pValue.buffer, pValue.byteOffset, pValue.byteLength);
	}
	if ((typeof pValue.byteLength === 'number') && (typeof pValue.slice === 'function'))
	{
		return new Uint8Array(pValue);
	}
	return null;
}

/**
 * Decodes text bytes: UTF-16 when a byte-order mark says so, else UTF-8; a leading BOM is dropped.
 *
 * @param {Uint8Array} pBytes - the bytes.
 *
 * @return {string} the text.
 */
function _decodeText(pBytes)
{
	let tmpEncoding = 'utf-8';
	if ((pBytes.length >= 2) && (pBytes[0] === 0xFF) && (pBytes[1] === 0xFE))
	{
		tmpEncoding = 'utf-16le';
	}
	else if ((pBytes.length >= 2) && (pBytes[0] === 0xFE) && (pBytes[1] === 0xFF))
	{
		tmpEncoding = 'utf-16be';
	}
	let tmpText = '';
	if (typeof TextDecoder === 'function')
	{
		tmpText = new TextDecoder(tmpEncoding).decode(pBytes);
	}
	else
	{
		// Latin-1 is better than nothing on a browser without TextDecoder.
		for (let i = 0; i < pBytes.length; i += 8192)
		{
			tmpText += String.fromCharCode.apply(null, Array.prototype.slice.call(pBytes, i, i + 8192));
		}
	}
	return (tmpText.charCodeAt(0) === 0xFEFF) ? tmpText.slice(1) : tmpText;
}

/**
 * Whether a character code is whitespace for trimming (space, tab, CR, LF, FF, VT, NBSP).
 *
 * @param {number} pCode - a char code.
 *
 * @return {boolean} true for whitespace.
 */
function _isSpaceCode(pCode)
{
	return (pCode === 32) || ((pCode >= 9) && (pCode <= 13)) || (pCode === 160);
}

/**
 * Drops trailing whitespace in linear time (`/\s+$/` is quadratic on long whitespace runs).
 *
 * @param {string} pText - the text.
 *
 * @return {string} the text without trailing whitespace.
 */
function _trimEnd(pText)
{
	let tmpEnd = pText.length;
	while ((tmpEnd > 0) && _isSpaceCode(pText.charCodeAt(tmpEnd - 1)))
	{
		tmpEnd--;
	}
	return pText.slice(0, tmpEnd);
}

/**
 * Drops trailing spaces and tabs from every line (linear; `/[ \t]+\n/` is quadratic).
 *
 * @param {string} pText - the text.
 *
 * @return {string} the text.
 */
function _trimLineEnds(pText)
{
	return pText.split('\n').map((pLine) =>
	{
		let tmpEnd = pLine.length;
		while ((tmpEnd > 0) && ((pLine.charCodeAt(tmpEnd - 1) === 32) || (pLine.charCodeAt(tmpEnd - 1) === 9)))
		{
			tmpEnd--;
		}
		return pLine.slice(0, tmpEnd);
	}).join('\n');
}

/**
 * Joins the lines of a text into one line (headings, slide bullets).
 *
 * @param {string} pText - the text.
 *
 * @return {string} one trimmed line.
 */
function _joinLines(pText)
{
	return pText.split('\n').map((pLine) => pLine.trim()).filter((pLine) => pLine).join(' ');
}

/**
 * Cuts markdown to the output cap, noting it.
 *
 * @param {string} pMarkdown - the markdown.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string} the capped markdown.
 */
function _capOutput(pMarkdown, pNotes)
{
	if (pMarkdown.length <= OUTPUT_CAP_CHARS)
	{
		return pMarkdown;
	}
	const tmpSuffix = '\n\n… (truncated)\n';
	pNotes.push('Truncated to 400,000 characters');
	return pMarkdown.slice(0, OUTPUT_CAP_CHARS - tmpSuffix.length) + tmpSuffix;
}

/**
 * A fenced code block whose fence is longer than any backtick run in the text, capped to fit the output.
 *
 * @param {string} pText - block content.
 * @param {string} pLanguage - info string ('' for none).
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string} the fenced block.
 */
function _fence(pText, pLanguage, pNotes)
{
	let tmpLongest = 0;
	const tmpRuns = pText.match(/`+/g) || [];
	tmpRuns.forEach((pRun) =>
	{
		tmpLongest = Math.max(tmpLongest, pRun.length);
	});
	const tmpFence = new Array(Math.max(3, tmpLongest + 1) + 1).join('`');
	const tmpBudget = OUTPUT_CAP_CHARS - (2 * tmpFence.length) - pLanguage.length - 32;
	let tmpText = _trimEnd(pText);
	if (tmpText.length > tmpBudget)
	{
		tmpText = `${ tmpText.slice(0, tmpBudget) }\n… (truncated)`;
		pNotes.push('Truncated to 400,000 characters');
	}
	return `${ tmpFence }${ pLanguage }\n${ tmpText }\n${ tmpFence }\n`;
}

/**
 * One markdown table cell: pipes escaped (and any backslashes right before them), line breaks as <br>,
 * control characters dropped.
 *
 * @param {any} pValue - the cell value.
 *
 * @return {string} cell text.
 */
function _tableCell(pValue)
{
	const tmpText = ((pValue === null) || (typeof pValue === 'undefined')) ? '' : String(pValue);
	// One linear pass: a backslash run right before a pipe is doubled so the pipe stays escaped.
	let tmpOut = '';
	let tmpSlashes = 0;
	for (let i = 0; i < tmpText.length; i++)
	{
		const tmpChar = tmpText.charAt(i);
		const tmpCode = tmpText.charCodeAt(i);
		if (((tmpCode < 32) && (tmpCode !== 9) && (tmpCode !== 10) && (tmpCode !== 13)) || (tmpCode === 127))
		{
			// Control characters are dropped (they come from binary junk); a backslash run carries on across them.
			continue;
		}
		if (tmpChar === '\\')
		{
			tmpSlashes++;
			tmpOut += tmpChar;
			continue;
		}
		if (tmpChar === '|')
		{
			tmpOut += `${ new Array(tmpSlashes + 1).join('\\') }\\|`;
		}
		else if ((tmpChar === '\r') || (tmpChar === '\n'))
		{
			if (!((tmpChar === '\n') && (tmpText.charAt(i - 1) === '\r')))
			{
				tmpOut += '<br>';
			}
		}
		else
		{
			tmpOut += tmpChar;
		}
		tmpSlashes = 0;
	}
	return tmpOut.trim();
}

/**
 * Whether any cell of any row has text once cleaned.
 *
 * @param {Array<Array<any>>} pRows - rows.
 *
 * @return {boolean} true when there is something to show.
 */
function _rowsHaveText(pRows)
{
	return pRows.some((pRow) => pRow.some((pCell) => _tableCell(pCell) !== ''));
}

/**
 * A GFM table from rows of cells, first row as the header, columns capped.
 *
 * @param {Array<Array<any>>} pRows - rows (at least one).
 * @param {Array<string>} pNotes - notes to add to.
 * @param {string} pWhere - 'sheet 2' / 'table 1' for notes.
 *
 * @return {string} the table markdown.
 */
function _markdownTable(pRows, pNotes, pWhere)
{
	let tmpColumns = 0;
	pRows.forEach((pRow) =>
	{
		tmpColumns = Math.max(tmpColumns, pRow.length);
	});
	if (tmpColumns > TABLE_COLUMN_CAP)
	{
		pNotes.push(`${ pWhere }: first ${ TABLE_COLUMN_CAP } of ${ tmpColumns } columns`);
		tmpColumns = TABLE_COLUMN_CAP;
	}
	tmpColumns = Math.max(tmpColumns, 1);
	/**
	 * One table line.
	 * @param {Array<any>} pRow - cells.
	 * @return {string} the line.
	 */
	const fLine = (pRow) =>
	{
		const tmpCells = [];
		for (let i = 0; i < tmpColumns; i++)
		{
			tmpCells.push(_tableCell(pRow[i]));
		}
		return `| ${ tmpCells.join(' | ') } |`;
	};
	const tmpSeparator = [];
	for (let i = 0; i < tmpColumns; i++)
	{
		tmpSeparator.push('---');
	}
	const tmpLines = [ fLine(pRows[0]), `| ${ tmpSeparator.join(' | ') } |` ];
	for (let i = 1; i < pRows.length; i++)
	{
		tmpLines.push(fLine(pRows[i]));
	}
	return `${ tmpLines.join('\n') }\n`;
}

/**
 * Parses delimited text (quoted fields with "" escapes, CR/LF/CRLF rows), stopping after pMaxRows.
 *
 * @param {string} pText - the text.
 * @param {string} pDelimiter - ',' or '\t'.
 * @param {number} pMaxRows - rows to collect.
 *
 * @return {{ Rows: Array<Array<string>>, More: boolean }} rows, and whether more remained.
 */
function _parseDelimited(pText, pDelimiter, pMaxRows)
{
	const tmpRows = [];
	let tmpRow = [];
	let tmpField = '';
	let tmpQuoted = false;
	let tmpFieldStart = true;
	let i = 0;
	/** Ends the current row (blank lines are skipped). */
	const fEndRow = () =>
	{
		tmpRow.push(tmpField);
		if ((tmpRow.length > 1) || (tmpRow[0] !== ''))
		{
			tmpRows.push(tmpRow);
		}
		tmpRow = [];
		tmpField = '';
		tmpFieldStart = true;
	};
	while (i < pText.length)
	{
		const tmpChar = pText.charAt(i);
		if (tmpQuoted)
		{
			if (tmpChar === '"')
			{
				if (pText.charAt(i + 1) === '"')
				{
					tmpField += '"';
					i += 2;
					continue;
				}
				tmpQuoted = false;
			}
			else
			{
				tmpField += tmpChar;
			}
			i++;
			continue;
		}
		if ((tmpChar === '"') && tmpFieldStart)
		{
			tmpQuoted = true;
			tmpFieldStart = false;
		}
		else if (tmpChar === pDelimiter)
		{
			tmpRow.push(tmpField);
			tmpField = '';
			tmpFieldStart = true;
		}
		else if ((tmpChar === '\n') || (tmpChar === '\r'))
		{
			fEndRow();
			if ((tmpChar === '\r') && (pText.charAt(i + 1) === '\n'))
			{
				i++;
			}
			if (tmpRows.length > pMaxRows)
			{
				return { Rows: tmpRows.slice(0, pMaxRows), More: true };
			}
		}
		else
		{
			tmpField += tmpChar;
			tmpFieldStart = false;
		}
		i++;
	}
	if ((tmpField !== '') || (tmpRow.length > 0))
	{
		fEndRow();
	}
	return { Rows: tmpRows.slice(0, pMaxRows), More: tmpRows.length > pMaxRows };
}

/**
 * The delimiter of a .csv: an Excel `sep=X` first line wins, else whichever of , ; or tab the first line
 * uses most outside quotes (European Excel exports use ;).
 *
 * @param {string} pText - the text.
 *
 * @return {{ Delimiter: string, Text: string }} the delimiter, and the text without a sep= line.
 */
function _sniffDelimiter(pText)
{
	const tmpSep = /^sep=(.)\r?\n/i.exec(pText.slice(0, 16));
	if (tmpSep)
	{
		return { Delimiter: tmpSep[1], Text: pText.slice(tmpSep[0].length) };
	}
	/** @type {Record<string, number>} */
	const tmpCounts = { ',': 0, ';': 0, '\t': 0 };
	let tmpQuoted = false;
	for (let i = 0; (i < pText.length) && (i < 65536); i++)
	{
		const tmpChar = pText.charAt(i);
		if (tmpChar === '"')
		{
			tmpQuoted = !tmpQuoted;
		}
		else if (!tmpQuoted && ((tmpChar === '\n') || (tmpChar === '\r')))
		{
			break;
		}
		else if (!tmpQuoted && Object.prototype.hasOwnProperty.call(tmpCounts, tmpChar))
		{
			tmpCounts[tmpChar]++;
		}
	}
	let tmpDelimiter = ',';
	[ ';', '\t' ].forEach((pCandidate) =>
	{
		if (tmpCounts[pCandidate] > tmpCounts[tmpDelimiter])
		{
			tmpDelimiter = pCandidate;
		}
	});
	return { Delimiter: tmpDelimiter, Text: pText };
}

/**
 * CSV / TSV → a table, or fenced text when it has too many rows.
 *
 * Parsed here rather than with SheetJS's string reader: that reader sniffs formats (a CSV whose first line
 * is "TABLE" reads as DIF and comes back empty) and counts blank lines against its row limit.
 *
 * @param {string} pText - the text.
 * @param {boolean} pTabs - tab-separated.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string|null} markdown.
 */
function _delimitedMarkdown(pText, pTabs, pNotes)
{
	if (!pText.trim())
	{
		return null;
	}
	const tmpSniffed = pTabs ? { Delimiter: '\t', Text: pText } : _sniffDelimiter(pText);
	const tmpParsed = _parseDelimited(tmpSniffed.Text, tmpSniffed.Delimiter, TABLE_ROW_CAP);
	if (tmpParsed.More)
	{
		pNotes.push(`More than ${ TABLE_ROW_CAP.toLocaleString('en-US') } rows: kept as ${ pTabs ? 'TSV' : 'CSV' } text, not a table`);
		return _fence(pText, pTabs ? 'tsv' : 'csv', pNotes);
	}
	if (!tmpParsed.Rows.length || !_rowsHaveText(tmpParsed.Rows))
	{
		return null;
	}
	pNotes.push(`Table: ${ tmpParsed.Rows.length.toLocaleString('en-US') } rows`);
	return _markdownTable(tmpParsed.Rows, pNotes, 'table');
}

/**
 * JSON → a fenced json block, pretty-printed when it parses.
 *
 * @param {string} pText - the text.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string|null} markdown.
 */
function _jsonMarkdown(pText, pNotes)
{
	if (!pText.trim())
	{
		return null;
	}
	let tmpText = pText;
	try
	{
		tmpText = JSON.stringify(JSON.parse(pText), null, 2);
	}
	catch (pError)
	{
		pNotes.push('Not valid JSON: included as text');
	}
	return _fence(tmpText, 'json', pNotes);
}

/**
 * Sum of the uncompressed sizes a zip's central directory declares (zip-bomb guard), or -1 when the bytes
 * are not a readable zip (e.g. a legacy .xls compound file).
 *
 * @param {Uint8Array} pBytes - the file.
 *
 * @return {number} total bytes, or -1.
 */
function _zipInflatedSize(pBytes)
{
	const tmpLength = pBytes.length;
	/**
	 * @param {number} pAt - offset.
	 * @return {number} little-endian uint16.
	 */
	const fU16 = (pAt) => pBytes[pAt] | (pBytes[pAt + 1] << 8);
	/**
	 * @param {number} pAt - offset.
	 * @return {number} little-endian uint32.
	 */
	const fU32 = (pAt) => (pBytes[pAt] | (pBytes[pAt + 1] << 8) | (pBytes[pAt + 2] << 16) | (pBytes[pAt + 3] << 24)) >>> 0;
	if ((tmpLength < 22) || (pBytes[0] !== 0x50) || (pBytes[1] !== 0x4B))
	{
		return -1;
	}
	let tmpEnd = -1;
	for (let i = tmpLength - 22; i >= Math.max(0, tmpLength - 65557); i--)
	{
		if (fU32(i) === 0x06054B50)
		{
			tmpEnd = i;
			break;
		}
	}
	if (tmpEnd < 0)
	{
		return -1;
	}
	const tmpCount = fU16(tmpEnd + 10);
	let tmpAt = fU32(tmpEnd + 16);
	let tmpTotal = 0;
	for (let n = 0; n < tmpCount; n++)
	{
		if ((tmpAt + 46 > tmpLength) || (fU32(tmpAt) !== 0x02014B50))
		{
			return -1;
		}
		tmpTotal += fU32(tmpAt + 24);
		tmpAt += 46 + fU16(tmpAt + 28) + fU16(tmpAt + 30) + fU16(tmpAt + 32);
	}
	return tmpTotal;
}

/**
 * Throws when a zip declares more than the inflated cap.
 *
 * @param {Uint8Array} pBytes - the file.
 */
function _guardZip(pBytes)
{
	if (_zipInflatedSize(pBytes) > INFLATED_CAP_BYTES)
	{
		throw new Error('Expands to more than 200 MB');
	}
}

/**
 * Workbook → one table per visible sheet.
 *
 * @param {Uint8Array} pBytes - the file.
 * @param {any} pDeps - injected dependencies.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string|null} markdown.
 */
function _spreadsheetMarkdown(pBytes, pDeps, pNotes)
{
	const tmpXLSX = _resolveXLSX(pDeps);
	if (!tmpXLSX || !tmpXLSX.utils)
	{
		pNotes.push('The spreadsheet reader (SheetJS) is not available');
		return null;
	}
	_guardZip(pBytes);
	const tmpBook = tmpXLSX.read(pBytes, { type: 'array', cellDates: true, cellFormula: false, cellHTML: false, cellStyles: false, bookVBA: false });
	const tmpSheetInfo = (tmpBook.Workbook && Array.isArray(tmpBook.Workbook.Sheets)) ? tmpBook.Workbook.Sheets : [];
	const tmpParts = [];
	let tmpHidden = 0;
	let tmpRowTotal = 0;
	(tmpBook.SheetNames || []).forEach((pName, pIndex) =>
	{
		if (tmpSheetInfo[pIndex] && tmpSheetInfo[pIndex].Hidden)
		{
			tmpHidden++;
			return;
		}
		const tmpWhere = `sheet ${ pIndex + 1 }`;
		const tmpHeading = `## Sheet: ${ String(pName).replace(/[\r\n]+/g, ' ') }\n\n`;
		const tmpSheet = tmpBook.Sheets[pName];
		if (!tmpSheet || !tmpSheet['!ref'])
		{
			tmpParts.push(`${ tmpHeading }_(empty)_\n`);
			return;
		}
		// Clamp the range first so a sheet claiming A1:XFD1048576 is never walked in full.
		const tmpRange = tmpXLSX.utils.decode_range(tmpSheet['!ref']);
		const tmpRowsInRange = tmpRange.e.r - tmpRange.s.r + 1;
		const tmpColumnsInRange = tmpRange.e.c - tmpRange.s.c + 1;
		if (tmpRowsInRange > TABLE_ROW_CAP)
		{
			tmpRange.e.r = tmpRange.s.r + TABLE_ROW_CAP - 1;
			pNotes.push(`${ tmpWhere }: first ${ TABLE_ROW_CAP.toLocaleString('en-US') } of ${ tmpRowsInRange.toLocaleString('en-US') } rows`);
		}
		if (tmpColumnsInRange > TABLE_COLUMN_CAP)
		{
			tmpRange.e.c = tmpRange.s.c + TABLE_COLUMN_CAP - 1;
			pNotes.push(`${ tmpWhere }: first ${ TABLE_COLUMN_CAP } of ${ tmpColumnsInRange } columns`);
		}
		const tmpRows = tmpXLSX.utils.sheet_to_json(tmpSheet, { header: 1, defval: '', raw: false, blankrows: false, range: tmpRange });
		if (!tmpRows.length || !_rowsHaveText(tmpRows))
		{
			tmpParts.push(`${ tmpHeading }_(empty)_\n`);
			return;
		}
		tmpRowTotal += tmpRows.length;
		tmpParts.push(tmpHeading + _markdownTable(tmpRows, pNotes, tmpWhere));
	});
	if (tmpHidden)
	{
		pNotes.push(`${ tmpHidden } hidden sheet${ (tmpHidden === 1) ? '' : 's' } skipped`);
	}
	if (!tmpParts.length)
	{
		return null;
	}
	if (!tmpRowTotal)
	{
		return null;
	}
	pNotes.unshift(`${ tmpParts.length } sheet${ (tmpParts.length === 1) ? '' : 's' }, ${ tmpRowTotal.toLocaleString('en-US') } rows`);
	return tmpParts.join('\n');
}

/**
 * Whether a node is the element namespace:localName.
 *
 * @param {any} pNode - a DOM node.
 * @param {Array<string>} pNamespaces - accepted namespace URIs.
 * @param {string} pLocalName - local name.
 *
 * @return {boolean} true when it is.
 */
function _isElement(pNode, pNamespaces, pLocalName)
{
	return !!pNode && (pNode.nodeType === 1) && (pNode.localName === pLocalName) && (pNamespaces.indexOf(pNode.namespaceURI) >= 0);
}

/**
 * Element children of a node.
 *
 * @param {any} pNode - a DOM node.
 *
 * @return {Array<any>} the child elements.
 */
function _children(pNode)
{
	const tmpChildren = [];
	for (let tmpChild = pNode ? pNode.firstChild : null; tmpChild; tmpChild = tmpChild.nextSibling)
	{
		if (tmpChild.nodeType === 1)
		{
			tmpChildren.push(tmpChild);
		}
	}
	return tmpChildren;
}

/**
 * The first child element namespace:localName.
 *
 * @param {any} pNode - a DOM node.
 * @param {Array<string>} pNamespaces - accepted namespace URIs.
 * @param {string} pLocalName - local name.
 *
 * @return {any} the element or null.
 */
function _child(pNode, pNamespaces, pLocalName)
{
	const tmpChildren = _children(pNode);
	for (let i = 0; i < tmpChildren.length; i++)
	{
		if (_isElement(tmpChildren[i], pNamespaces, pLocalName))
		{
			return tmpChildren[i];
		}
	}
	return null;
}

/**
 * A namespaced attribute (w:val, …), with a prefixed-name fallback.
 *
 * @param {any} pElement - the element.
 * @param {Array<string>} pNamespaces - accepted namespace URIs.
 * @param {string} pPrefix - the conventional prefix.
 * @param {string} pName - local attribute name.
 *
 * @return {string} the value, or ''.
 */
function _attribute(pElement, pNamespaces, pPrefix, pName)
{
	if (!pElement)
	{
		return '';
	}
	for (let i = 0; i < pNamespaces.length; i++)
	{
		const tmpValue = pElement.getAttributeNS(pNamespaces[i], pName);
		if (tmpValue)
		{
			return tmpValue;
		}
	}
	return pElement.getAttribute(`${ pPrefix }:${ pName }`) || pElement.getAttribute(pName) || '';
}

/**
 * Parses XML, throwing when the parser reports an error.
 *
 * @param {any} pDOMParser - DOMParser constructor.
 * @param {string} pXML - the XML text.
 *
 * @return {any} the document.
 */
function _parseXML(pDOMParser, pXML)
{
	const tmpDocument = new pDOMParser().parseFromString(pXML, 'application/xml');
	if (!tmpDocument || !tmpDocument.documentElement || (tmpDocument.getElementsByTagName('parsererror').length > 0))
	{
		throw new Error('The document XML could not be parsed');
	}
	return tmpDocument;
}

/**
 * Text of a zip entry, or null when it is missing.
 *
 * @param {any} pCFB - XLSX.CFB.
 * @param {any} pContainer - the read zip.
 * @param {string} pPath - '/word/document.xml'.
 *
 * @return {string|null} the text.
 */
function _zipEntryText(pCFB, pContainer, pPath)
{
	const tmpEntry = pCFB.find(pContainer, pPath);
	if (!tmpEntry || !tmpEntry.content)
	{
		return null;
	}
	const tmpBytes = _toBytes(tmpEntry.content) || new Uint8Array(tmpEntry.content);
	return _decodeText(tmpBytes);
}

/** @type {Record<string, string>} Word run elements that stand for fixed text. */
const _WordFixedText = { tab: '\t', br: '\n', cr: '\n', noBreakHyphen: '-', softHyphen: '' };
/** Word elements whose text is not document text: deletions, moved-away text, field codes, properties. */
const _WordSkipped = [ 'del', 'moveFrom', 'delText', 'instrText', 'pPr', 'rPr' ];

/**
 * Plain text of a Word paragraph's runs (tabs, breaks; deleted text, field codes and fallback copies skipped).
 *
 * @param {any} pNode - a w:p or a node inside one.
 *
 * @return {string} the text.
 */
function _wordText(pNode)
{
	let tmpText = '';
	_children(pNode).forEach((pChild) =>
	{
		if (pChild.namespaceURI && (NS_MARKUP_COMPATIBILITY.indexOf(pChild.namespaceURI) >= 0) && (pChild.localName === 'Fallback'))
		{
			return;
		}
		if (NS_WORD.indexOf(pChild.namespaceURI) < 0)
		{
			tmpText += _wordText(pChild);
			return;
		}
		const tmpName = pChild.localName;
		if (Object.prototype.hasOwnProperty.call(_WordFixedText, tmpName))
		{
			tmpText += _WordFixedText[tmpName];
		}
		else if (tmpName === 't')
		{
			tmpText += pChild.textContent || '';
		}
		else if (tmpName === 'p')
		{
			// A paragraph inside a text box.
			tmpText += `\n${ _wordText(pChild) }\n`;
		}
		else if (_WordSkipped.indexOf(tmpName) < 0)
		{
			tmpText += _wordText(pChild);
		}
	});
	return tmpText;
}

/**
 * Text of a Word table cell (its paragraphs, nested tables flattened), lines joined with <br>.
 *
 * @param {any} pCell - a w:tc.
 *
 * @return {string} the cell text.
 */
function _wordCellText(pCell)
{
	const tmpParts = [];
	_children(pCell).forEach((pChild) =>
	{
		if (_isElement(pChild, NS_WORD, 'p'))
		{
			tmpParts.push(_wordText(pChild).trim());
		}
		else if (_isElement(pChild, NS_WORD, 'tbl'))
		{
			_children(pChild).forEach((pRow) =>
			{
				if (_isElement(pRow, NS_WORD, 'tr'))
				{
					tmpParts.push(_children(pRow).map((pInner) => _wordCellText(pInner)).filter((pText) => pText).join(' '));
				}
			});
		}
		else if (_isElement(pChild, NS_WORD, 'sdt'))
		{
			tmpParts.push(_wordCellText(_child(pChild, NS_WORD, 'sdtContent')));
		}
	});
	return tmpParts.filter((pText) => pText).join('\n');
}

/**
 * A Word paragraph as markdown: Heading N / Title → '#', numbered or List-styled → '- ', else text.
 *
 * @param {any} pParagraph - a w:p.
 *
 * @return {string} the line, or '' when empty.
 */
function _wordParagraph(pParagraph)
{
	const tmpText = _trimLineEnds(_wordText(pParagraph)).trim();
	if (!tmpText)
	{
		return '';
	}
	const tmpProperties = _child(pParagraph, NS_WORD, 'pPr');
	const tmpStyle = _attribute(_child(tmpProperties, NS_WORD, 'pStyle'), NS_WORD, 'w', 'val');
	let tmpLevel = 0;
	const tmpHeading = /^heading\s*([1-9])$/i.exec(tmpStyle);
	if (tmpHeading)
	{
		tmpLevel = Number(tmpHeading[1]);
	}
	else if (/^title$/i.test(tmpStyle))
	{
		tmpLevel = 1;
	}
	else
	{
		const tmpOutline = _attribute(_child(tmpProperties, NS_WORD, 'outlineLvl'), NS_WORD, 'w', 'val');
		if (/^[0-8]$/.test(tmpOutline))
		{
			tmpLevel = Number(tmpOutline) + 1;
		}
	}
	if (tmpLevel)
	{
		return `${ new Array(Math.min(tmpLevel, 6) + 1).join('#') } ${ _joinLines(tmpText) }`;
	}
	const tmpNumbering = _child(tmpProperties, NS_WORD, 'numPr');
	if (tmpNumbering || /^list/i.test(tmpStyle))
	{
		const tmpDepth = Number(_attribute(_child(tmpNumbering, NS_WORD, 'ilvl'), NS_WORD, 'w', 'val')) || 0;
		return `${ new Array(Math.min(tmpDepth, 8) + 1).join('  ') }- ${ tmpText.replace(/\n/g, ' ') }`;
	}
	return tmpText;
}

/**
 * Word body blocks (paragraphs, tables, content controls) as markdown blocks.
 *
 * @param {any} pParent - w:body or a container.
 * @param {Array<string>} pBlocks - blocks to add to.
 * @param {Array<string>} pNotes - notes to add to.
 * @param {{ Tables: number }} pCounts - running counts.
 */
function _wordBlocks(pParent, pBlocks, pNotes, pCounts)
{
	_children(pParent).forEach((pChild) =>
	{
		if (_isElement(pChild, NS_WORD, 'p'))
		{
			const tmpLine = _wordParagraph(pChild);
			if (tmpLine)
			{
				pBlocks.push(tmpLine);
			}
		}
		else if (_isElement(pChild, NS_WORD, 'tbl'))
		{
			const tmpRows = [];
			_children(pChild).forEach((pRow) =>
			{
				if (_isElement(pRow, NS_WORD, 'tr') && (tmpRows.length < TABLE_ROW_CAP))
				{
					tmpRows.push(_children(pRow).filter((pCell) => _isElement(pCell, NS_WORD, 'tc')).map((pCell) => _wordCellText(pCell)));
				}
			});
			if (tmpRows.length)
			{
				pCounts.Tables++;
				pBlocks.push(_markdownTable(tmpRows, pNotes, `table ${ pCounts.Tables }`));
			}
		}
		else if (_isElement(pChild, NS_WORD, 'sdt'))
		{
			_wordBlocks(_child(pChild, NS_WORD, 'sdtContent'), pBlocks, pNotes, pCounts);
		}
		else if (_isElement(pChild, NS_WORD, 'customXml'))
		{
			_wordBlocks(pChild, pBlocks, pNotes, pCounts);
		}
	});
}

/**
 * Opens an Office zip with XLSX.CFB.
 *
 * @param {Uint8Array} pBytes - the file.
 * @param {any} pDeps - injected dependencies.
 *
 * @return {{ CFB: any, Container: any, DOMParser: any }} the reader parts.
 */
function _openOfficeZip(pBytes, pDeps)
{
	const tmpXLSX = _resolveXLSX(pDeps);
	const tmpCFB = tmpXLSX ? tmpXLSX.CFB : null;
	if (!tmpCFB || (typeof tmpCFB.read !== 'function') || (typeof tmpCFB.find !== 'function'))
	{
		throw new Error('The zip reader (SheetJS CFB) is not available');
	}
	const tmpDOMParser = _resolveDOMParser(pDeps);
	if (!tmpDOMParser)
	{
		throw new Error('The XML reader (DOMParser) is not available');
	}
	_guardZip(pBytes);
	return { CFB: tmpCFB, Container: tmpCFB.read(pBytes, { type: 'array' }), DOMParser: tmpDOMParser };
}

/**
 * Word document → markdown.
 *
 * @param {Uint8Array} pBytes - the file.
 * @param {any} pDeps - injected dependencies.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string|null} markdown.
 */
function _docxMarkdown(pBytes, pDeps, pNotes)
{
	const tmpZip = _openOfficeZip(pBytes, pDeps);
	let tmpXML = _zipEntryText(tmpZip.CFB, tmpZip.Container, '/word/document.xml');
	if (tmpXML === null)
	{
		// Some writers name the main part differently; the package relationships say where it is.
		const tmpRelationships = _zipEntryText(tmpZip.CFB, tmpZip.Container, '/_rels/.rels');
		if (tmpRelationships !== null)
		{
			const tmpRelDocument = _parseXML(tmpZip.DOMParser, tmpRelationships);
			const tmpList = tmpRelDocument.getElementsByTagName('Relationship');
			for (let i = 0; (i < tmpList.length) && (tmpXML === null); i++)
			{
				const tmpTarget = tmpList[i].getAttribute('Target') || '';
				if (/\/officeDocument$/.test(tmpList[i].getAttribute('Type') || '') && /^[\w./-]+$/.test(tmpTarget))
				{
					tmpXML = _zipEntryText(tmpZip.CFB, tmpZip.Container, `/${ tmpTarget.replace(/^\/+/, '') }`);
				}
			}
		}
	}
	if (tmpXML === null)
	{
		pNotes.push('No document body found');
		return null;
	}
	const tmpDocument = _parseXML(tmpZip.DOMParser, tmpXML);
	const tmpBodies = NS_WORD.map((pNamespace) => tmpDocument.getElementsByTagNameNS(pNamespace, 'body')[0]).filter((pBody) => !!pBody);
	if (!tmpBodies.length)
	{
		pNotes.push('No document body found');
		return null;
	}
	const tmpBlocks = [];
	const tmpCounts = { Tables: 0 };
	_wordBlocks(tmpBodies[0], tmpBlocks, pNotes, tmpCounts);
	if (!tmpBlocks.length)
	{
		return null;
	}
	pNotes.unshift(`${ tmpBlocks.length.toLocaleString('en-US') } block${ (tmpBlocks.length === 1) ? '' : 's' }${ tmpCounts.Tables ? `, ${ tmpCounts.Tables } table${ (tmpCounts.Tables === 1) ? '' : 's' }` : '' }`);
	return `${ tmpBlocks.join('\n\n') }\n`;
}

/**
 * Whether a slide element sits in a title placeholder.
 *
 * @param {any} pNode - a node inside a slide.
 *
 * @return {boolean} true for title text.
 */
function _inSlideTitle(pNode)
{
	for (let tmpNode = pNode; tmpNode; tmpNode = tmpNode.parentNode)
	{
		if (_isElement(tmpNode, NS_PRESENTATION, 'sp'))
		{
			const tmpPlaceholder = _child(_child(_child(tmpNode, NS_PRESENTATION, 'nvSpPr'), NS_PRESENTATION, 'nvPr'), NS_PRESENTATION, 'ph');
			const tmpType = tmpPlaceholder ? (tmpPlaceholder.getAttribute('type') || '') : '';
			return (tmpType === 'title') || (tmpType === 'ctrTitle');
		}
	}
	return false;
}

/**
 * Text of a DrawingML paragraph (a:t runs and fields, a:br breaks).
 *
 * @param {any} pNode - an a:p or a node inside one.
 *
 * @return {string} the text.
 */
function _drawingText(pNode)
{
	let tmpText = '';
	_children(pNode).forEach((pChild) =>
	{
		if (_isElement(pChild, NS_DRAWING, 't'))
		{
			tmpText += pChild.textContent || '';
		}
		else if (_isElement(pChild, NS_DRAWING, 'br'))
		{
			tmpText += '\n';
		}
		else if (!_isElement(pChild, NS_DRAWING, 'pPr') && !_isElement(pChild, NS_DRAWING, 'rPr'))
		{
			tmpText += _drawingText(pChild);
		}
	});
	return tmpText;
}

/**
 * The paragraphs of a slide in document order (fallback copies skipped).
 *
 * @param {any} pNode - the slide root or a node in it.
 * @param {Array<any>} pParagraphs - list to add to.
 */
function _slideParagraphs(pNode, pParagraphs)
{
	_children(pNode).forEach((pChild) =>
	{
		if (_isElement(pChild, NS_DRAWING, 'p'))
		{
			pParagraphs.push(pChild);
		}
		else if (!_isElement(pChild, NS_MARKUP_COMPATIBILITY, 'Fallback'))
		{
			_slideParagraphs(pChild, pParagraphs);
		}
	});
}

/**
 * PowerPoint deck → '## Slide N' sections (slides in file-number order).
 *
 * @param {Uint8Array} pBytes - the file.
 * @param {any} pDeps - injected dependencies.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string|null} markdown.
 */
function _pptxMarkdown(pBytes, pDeps, pNotes)
{
	const tmpZip = _openOfficeZip(pBytes, pDeps);
	const tmpSlides = [];
	const tmpPaths = tmpZip.Container.FullPaths || [];
	for (let i = 0; i < tmpPaths.length; i++)
	{
		const tmpMatch = /\/ppt\/slides\/slide(\d+)\.xml$/i.exec(tmpPaths[i]);
		if (tmpMatch && tmpZip.Container.FileIndex[i] && tmpZip.Container.FileIndex[i].content)
		{
			tmpSlides.push({ Number: Number(tmpMatch[1]), Entry: tmpZip.Container.FileIndex[i] });
		}
	}
	tmpSlides.sort((pLeft, pRight) => pLeft.Number - pRight.Number);
	if (!tmpSlides.length)
	{
		pNotes.push('No slides found');
		return null;
	}
	let tmpWithText = 0;
	const tmpParts = tmpSlides.map((pSlide, pIndex) =>
	{
		const tmpDocument = _parseXML(tmpZip.DOMParser, _decodeText(_toBytes(pSlide.Entry.content) || new Uint8Array(pSlide.Entry.content)));
		const tmpParagraphs = [];
		_slideParagraphs(tmpDocument.documentElement, tmpParagraphs);
		const tmpLines = [];
		tmpParagraphs.forEach((pParagraph) =>
		{
			const tmpText = _joinLines(_drawingText(pParagraph));
			if (!tmpText)
			{
				return;
			}
			if (_inSlideTitle(pParagraph))
			{
				tmpLines.push(`### ${ tmpText }`);
				return;
			}
			const tmpProperties = _child(pParagraph, NS_DRAWING, 'pPr');
			const tmpDepth = Number(tmpProperties ? tmpProperties.getAttribute('lvl') : 0) || 0;
			tmpLines.push(`${ new Array(Math.min(tmpDepth, 8) + 1).join('  ') }- ${ tmpText }`);
		});
		if (tmpLines.length)
		{
			tmpWithText++;
		}
		return `## Slide ${ pIndex + 1 }\n\n${ tmpLines.length ? tmpLines.join('\n') : '_(no text)_' }\n`;
	});
	if (!tmpWithText)
	{
		pNotes.push('No slide text found');
		return null;
	}
	pNotes.unshift(`${ tmpSlides.length } slide${ (tmpSlides.length === 1) ? '' : 's' }`);
	return tmpParts.join('\n');
}

/**
 * Rejects a promise that takes too long.
 *
 * @param {Promise<any>} pPromise - the work.
 * @param {number} pMilliseconds - the limit.
 * @param {string} pMessage - the timeout error message.
 *
 * @return {Promise<any>} the work, or a timeout rejection.
 */
function _withTimeout(pPromise, pMilliseconds, pMessage)
{
	return new Promise((fResolve, fReject) =>
	{
		const tmpTimer = setTimeout(() => fReject(new Error(pMessage)), pMilliseconds);
		pPromise.then(
			(pValue) =>
			{
				clearTimeout(tmpTimer);
				fResolve(pValue);
			},
			(pError) =>
			{
				clearTimeout(tmpTimer);
				fReject(pError);
			});
	});
}

/**
 * Loads pdf.js on first use: a `<script type="module">` for js/pdfjs-dist/build/pdf.mjs (which sets
 * `globalThis.pdfjsLib`), then points its worker at pdf.worker.mjs. Cached; a failed load can be retried.
 *
 * @return {Promise<any>} pdfjsLib.
 */
function defaultLoadPdfJs()
{
	if (_PdfJsPromise)
	{
		return _PdfJsPromise;
	}
	const tmpLoad = new Promise((fResolve, fReject) =>
	{
		const tmpGlobal = _global();
		if (tmpGlobal.pdfjsLib && (typeof tmpGlobal.pdfjsLib.getDocument === 'function'))
		{
			fResolve(tmpGlobal.pdfjsLib);
			return;
		}
		if ((typeof document === 'undefined') || !document.createElement || !document.head)
		{
			fReject(new Error('pdf.js needs a browser page'));
			return;
		}
		const tmpScript = document.createElement('script');
		tmpScript.type = 'module';
		tmpScript.src = PDFJS_SCRIPT_SRC;
		tmpScript.onload = () =>
		{
			// A module has run by its load event; poll briefly in case the global lands a tick later.
			let tmpTries = 0;
			const fCheck = () =>
			{
				const tmpLib = _global().pdfjsLib;
				if (tmpLib && (typeof tmpLib.getDocument === 'function'))
				{
					fResolve(tmpLib);
				}
				else if (++tmpTries > 40)
				{
					fReject(new Error('pdf.js did not initialise'));
				}
				else
				{
					setTimeout(fCheck, 50);
				}
			};
			fCheck();
		};
		tmpScript.onerror = () => fReject(new Error('pdf.js failed to load'));
		document.head.appendChild(tmpScript);
	});
	_PdfJsPromise = _withTimeout(tmpLoad, PDFJS_LOAD_TIMEOUT_MS, 'pdf.js took too long to load').then((pLib) =>
	{
		if (pLib.GlobalWorkerOptions)
		{
			pLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;
		}
		return pLib;
	});
	_PdfJsPromise.catch(() =>
	{
		_PdfJsPromise = null;
	});
	return _PdfJsPromise;
}

/**
 * Text of one pdf.js getTextContent() result.
 *
 * @param {any} pContent - { items: [{ str, hasEOL }] }.
 *
 * @return {string} the page text.
 */
function _pdfPageText(pContent)
{
	let tmpText = '';
	((pContent && pContent.items) || []).forEach((pItem) =>
	{
		if (pItem && (typeof pItem.str === 'string'))
		{
			tmpText += pItem.str;
			if (pItem.hasEOL)
			{
				tmpText += '\n';
			}
		}
	});
	return _trimLineEnds(tmpText).replace(/\n{3,}/g, '\n\n').trim();
}

/**
 * PDF → '## Page N' sections; null with "looks scanned" when there is too little text.
 *
 * @param {Uint8Array} pBytes - the file.
 * @param {any} pDeps - injected dependencies.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {Promise<string|null>} markdown.
 */
function _pdfMarkdown(pBytes, pDeps, pNotes)
{
	const fLoad = (pDeps && (typeof pDeps.loadPdfJs === 'function')) ? pDeps.loadPdfJs : defaultLoadPdfJs;
	/** @type {any} */
	let tmpTask = null;
	const tmpWork = Promise.resolve()
		.then(() => fLoad())
		.then((pLib) =>
		{
			if (!pLib || (typeof pLib.getDocument !== 'function'))
			{
				throw new Error('pdf.js is not available');
			}
			// pdf.js hands the buffer to its worker, so give it a copy; never evaluate font programs.
			tmpTask = pLib.getDocument({ data: pBytes.slice(0), isEvalSupported: false, disableFontFace: true });
			return tmpTask.promise;
		})
		.then((pDocument) =>
		{
			const tmpPageCount = Number(pDocument.numPages) || 0;
			const tmpPages = [];
			let tmpLength = 0;
			let tmpCharacters = 0;
			let tmpPage = 1;
			/**
			 * Reads pages one at a time until the last page, the page cap or the output cap.
			 * @return {Promise<void>} done.
			 */
			const fNext = () =>
			{
				if ((tmpPage > tmpPageCount) || (tmpPage > PDF_PAGE_CAP) || (tmpLength > OUTPUT_CAP_CHARS))
				{
					return Promise.resolve();
				}
				return Promise.resolve(pDocument.getPage(tmpPage))
					.then((pPage) => Promise.resolve(pPage.getTextContent()).then((pContent) =>
					{
						const tmpText = _pdfPageText(pContent);
						const tmpSection = `## Page ${ tmpPage }\n\n${ tmpText }\n`;
						tmpPages.push(tmpSection);
						tmpLength += tmpSection.length;
						tmpCharacters += tmpText.replace(/\s+/g, '').length;
						if (typeof pPage.cleanup === 'function')
						{
							pPage.cleanup();
						}
						tmpPage++;
						return fNext();
					}));
			};
			return fNext().then(() =>
			{
				const tmpRead = tmpPages.length;
				if (!tmpRead || ((tmpCharacters / tmpRead) < SCANNED_CHARS_PER_PAGE))
				{
					pNotes.push('PDF looks scanned (little or no text): no text extracted');
					return null;
				}
				if (tmpRead < tmpPageCount)
				{
					pNotes.push(`First ${ tmpRead.toLocaleString('en-US') } of ${ tmpPageCount.toLocaleString('en-US') } pages`);
				}
				pNotes.unshift(`${ tmpPageCount.toLocaleString('en-US') } page${ (tmpPageCount === 1) ? '' : 's' }`);
				return tmpPages.join('\n');
			});
		});
	/** Frees the pdf.js document and worker; failures here never matter. */
	const fRelease = () =>
	{
		try
		{
			if (tmpTask && (typeof tmpTask.destroy === 'function'))
			{
				Promise.resolve(tmpTask.destroy()).catch(() => null);
			}
		}
		catch (pError)
		{
			// Ignored.
		}
	};
	return _withTimeout(tmpWork, PDF_CONVERT_TIMEOUT_MS, 'The PDF took too long to read').then(
		(pMarkdown) =>
		{
			fRelease();
			return pMarkdown;
		},
		(pError) =>
		{
			fRelease();
			throw pError;
		});
}

/**
 * The conversion proper (may reject; convertFileToMarkdown catches).
 *
 * @param {any} pFile - a File-like object.
 * @param {{ Kind: string, TextNative: boolean }} pClass - its classification.
 * @param {any} pDeps - injected dependencies.
 *
 * @return {Promise<{ Markdown: string|null, Kind: string, Notes: Array<string> }>} the result.
 */
function _convert(pFile, pClass, pDeps)
{
	const tmpKind = pClass.Kind;
	if (tmpKind === 'binary')
	{
		return Promise.resolve(_noText(tmpKind, 'No text conversion for this file type'));
	}
	if ((typeof pFile.size === 'number') && (pFile.size > INPUT_CAP_BYTES))
	{
		return Promise.resolve(_noText(tmpKind, 'Too large to convert (over 25 MB)'));
	}
	/** @type {Array<string>} */
	const tmpNotes = [];
	return _readBytes(pFile)
		.then((pBytes) =>
		{
			if (!pBytes && (typeof pFile.text === 'function') && (_BinaryKinds.indexOf(tmpKind) < 0))
			{
				// A File-like object that only offers text().
				return Promise.resolve(pFile.text()).then((pText) => ({ Bytes: null, Text: String(pText) }));
			}
			return { Bytes: pBytes, Text: null };
		})
		.then((pRead) =>
		{
			if (!pRead.Bytes && (pRead.Text === null))
			{
				return _noText(tmpKind, 'The file could not be read');
			}
			const tmpSize = pRead.Bytes ? pRead.Bytes.length : pRead.Text.length;
			if (tmpSize > INPUT_CAP_BYTES)
			{
				return _noText(tmpKind, 'Too large to convert (over 25 MB)');
			}
			if (_BinaryKinds.indexOf(tmpKind) >= 0)
			{
				return Promise.resolve(_binaryMarkdown(tmpKind, pRead.Bytes, pDeps, tmpNotes)).then((pMarkdown) => _result(pMarkdown, tmpKind, tmpNotes));
			}
			const tmpText = (pRead.Text !== null) ? pRead.Text.replace(/^\uFEFF/, '') : _decodeText(pRead.Bytes);
			if (tmpText.slice(0, 8192).indexOf('\u0000') >= 0)
			{
				return _noText(tmpKind, 'Looks like binary data, not text');
			}
			const tmpExtension = _extensionOf(pFile.name);
			const tmpType = ((typeof pFile.type === 'string') ? pFile.type : '').toLowerCase();
			let tmpMarkdown = tmpText;
			if (tmpKind === 'csv')
			{
				tmpMarkdown = _delimitedMarkdown(tmpText, (tmpExtension === 'tsv') || (tmpType.indexOf('text/tab-separated-values') === 0), tmpNotes);
			}
			else if (tmpKind === 'json')
			{
				tmpMarkdown = _jsonMarkdown(tmpText, tmpNotes);
			}
			else if (tmpKind === 'markup')
			{
				tmpMarkdown = tmpText.trim() ? _fence(tmpText, ((tmpExtension === 'xml') || (tmpType.indexOf('xml') >= 0)) ? 'xml' : 'html', tmpNotes) : null;
			}
			return _result(tmpMarkdown, tmpKind, tmpNotes);
		});
}

/**
 * Dispatches the binary kinds.
 *
 * @param {string} pKind - spreadsheet / docx / pptx / pdf.
 * @param {Uint8Array} pBytes - the file.
 * @param {any} pDeps - injected dependencies.
 * @param {Array<string>} pNotes - notes to add to.
 *
 * @return {string|null|Promise<string|null>} markdown.
 */
function _binaryMarkdown(pKind, pBytes, pDeps, pNotes)
{
	if (pKind === 'spreadsheet')
	{
		return _spreadsheetMarkdown(pBytes, pDeps, pNotes);
	}
	if (pKind === 'docx')
	{
		return _docxMarkdown(pBytes, pDeps, pNotes);
	}
	if (pKind === 'pptx')
	{
		return _pptxMarkdown(pBytes, pDeps, pNotes);
	}
	if (pKind === 'pdf')
	{
		return _pdfMarkdown(pBytes, pDeps, pNotes);
	}
	pNotes.push('No text conversion for this file type');
	return null;
}

/**
 * The final result: empty text counts as no text; long text is capped.
 *
 * @param {string|null} pMarkdown - converted markdown.
 * @param {string} pKind - the file kind.
 * @param {Array<string>} pNotes - notes so far.
 *
 * @return {{ Markdown: string|null, Kind: string, Notes: Array<string> }} the result.
 */
function _result(pMarkdown, pKind, pNotes)
{
	if ((typeof pMarkdown !== 'string') || !pMarkdown.trim())
	{
		if (!pNotes.length)
		{
			pNotes.push('No text found');
		}
		return { Markdown: null, Kind: pKind, Notes: pNotes };
	}
	return { Markdown: _capOutput(pMarkdown, pNotes), Kind: pKind, Notes: pNotes };
}

/**
 * Converts a dropped file to markdown for the corpus. Never rejects.
 *
 * @param {any} pFile - a File (or { name, type, size, arrayBuffer?(), text?() }).
 * @param {{ XLSX?: any, DOMParser?: any, loadPdfJs?: function(): Promise<any> }} [pDeps] - injected dependencies.
 *
 * @return {Promise<{ Markdown: string|null, Kind: string, Notes: Array<string> }>} the result.
 */
function convertFileToMarkdown(pFile, pDeps)
{
	let tmpKind = 'binary';
	return new Promise((fResolve) =>
	{
		try
		{
			if (!pFile || (typeof pFile !== 'object'))
			{
				fResolve(_noText(tmpKind, 'No file'));
				return;
			}
			const tmpClass = classifyFile(pFile.name, pFile.type);
			tmpKind = tmpClass.Kind;
			_convert(pFile, tmpClass, pDeps || {}).then(
				fResolve,
				(pError) => fResolve(_noText(tmpKind, `Could not convert: ${ _errorText(pError) }`)));
		}
		catch (pError)
		{
			fResolve(_noText(tmpKind, `Could not convert: ${ _errorText(pError) }`));
		}
	});
}

module.exports =
{
	convertFileToMarkdown: convertFileToMarkdown,
	classifyFile: classifyFile,
	defaultLoadPdfJs: defaultLoadPdfJs,
};

},{"xlsx":363}],1277:[function(require,module,exports){
/**
 * FormConcierge-Markdown — the strict renderer for everything the plansheet pipeline sends back.
 *
 * Every upstream string is untrusted (contract §6 + D4): assistant AND user turns, standing instructions,
 * metadata, form / request / file names. A prompt injected through an uploaded file can steer a reply, so
 * this renderer is stricter than `_UserMarkdown.js`:
 *
 * - raw HTML is shown as escaped text, block and inline, including inside table cells and link text;
 * - no `<img>` is ever emitted (an https image becomes a link labelled with its alt text, others its alt text);
 * - links are made only for absolute https URLs that are not Headlight, the current host, localhost or an IP
 *   (a `/1.0/Report/<guid>/index.html` render URL on a Headlight API host other than the current host is the
 *   one exception), and every link shows its destination host beside it;
 * - a delivery command is offered for copy only when it has the exact shape `cd <dir> && npx hldi load …`.
 *
 * marked: a require from this folder resolves pict-section-form's marked 4.3, which has no `Marked` class
 * and positional renderer arguments, so the root copy (14.x, also at /working/node_modules in Docker) is
 * loaded by path and used only through a private instance (never `marked.use()` / `setOptions()`).
 *
 * No window / document access at load time.
 */

const libUserMarkdown = require('../../../../lib/web/headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js');

/** @type {any} */
let libMarked = null;
try
{
	libMarked = require('../../../../node_modules/marked');
}
catch (pError)
{
	// Reported at first render, where the fallback to escaped text already handles it.
	libMarked = null;
}

/** Façade-added steering starts here; everything from it on is not the user's text (contract C1). */
const STEERING_MARKER = '\n\n---\nForm Concierge steering:\n';
/** Leading paragraph the façade puts on an examples turn. */
const EXAMPLES_PREFIX = '[examples] ';
/** Leading paragraph the façade puts on an update (revision) turn. */
const REVISION_PREFIX = '[revision] ';

/** Example-document render URLs, the one Headlight path a reply may link to (D2). */
const REPORT_PATH_PATTERN = /^\/1\.0\/Report\/[0-9A-Za-z-]+\/index\.html$/;
/** The Headlight hosts a render URL may point at: the API hosts only (api.headlight.com, api.qa.headlight.com, …). */
const REPORT_HOST_PATTERN = /^api(\.[a-z0-9-]+)*\.headlight\.com$/;
/** Characters that never belong in a copyable command (D3). */
const COMMAND_FORBIDDEN_PATTERN = /[;|$`<>()]/;
/** The fixed head of a copyable command; the cd path cannot contain a space, so this match is linear. */
const COMMAND_HEAD_PATTERN = /^cd [\w./~-]+ && npx hldi load /;
/** Longest command considered for copy. */
const COMMAND_MAX_LENGTH = 2000;
/** Longest JSON shown in a metadata Details block. */
const DETAILS_MAX_LENGTH = 20000;

/** @type {Record<string, string>} */
const _TextEntityMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' };
/** Unescaped specials, leaving existing entity references alone (so applying it twice is harmless). */
const _TextEscapePattern = /[<>"']|&(?!(?:#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g;

/** @type {any} Built on first render. */
let _RemoteMarked = null;
/** Options of the render in progress (marked parses synchronously, so one slot is enough). */
let _ActiveOptions = {};
/** How many links the render is inside, so an image in link text renders as its alt only. */
let _LinkDepth = 0;

/**
 * Escapes a value for HTML text or an attribute (the shared `_UserMarkdown.js` rules).
 *
 * @param {any} pValue - the value to escape.
 *
 * @return {string} the escaped value; '' for null/undefined.
 */
function escapeHTML(pValue)
{
	return libUserMarkdown.escapeHTML(pValue);
}

/**
 * Escapes the specials in text that may already be escaped, without double-escaping entities.
 *
 * @param {any} pText - text from a marked token.
 *
 * @return {string} safe HTML text.
 */
function _escapeTextIdempotent(pText)
{
	return String((pText === null) || (typeof pText === 'undefined') ? '' : pText)
		.replace(_TextEscapePattern, (pCharacter) => _TextEntityMap[pCharacter]);
}

/**
 * Lower-cases a host name and drops a trailing dot and any port, so 'Config.Headlight.com.:443' compares as
 * 'config.headlight.com'.
 *
 * @param {any} pHost - a host or hostname.
 *
 * @return {string} the normalized hostname, or ''.
 */
function _normalizeHost(pHost)
{
	let tmpHost = (typeof pHost === 'string') ? pHost.trim().toLowerCase() : '';
	if (!tmpHost)
	{
		return '';
	}
	if (tmpHost.charAt(0) !== '[')
	{
		const tmpColon = tmpHost.indexOf(':');
		if (tmpColon >= 0)
		{
			tmpHost = tmpHost.slice(0, tmpColon);
		}
	}
	// A loop, not /\.+$/ (quadratic on a long run of dots).
	let tmpEnd = tmpHost.length;
	while ((tmpEnd > 0) && (tmpHost.charAt(tmpEnd - 1) === '.'))
	{
		tmpEnd--;
	}
	return tmpHost.slice(0, tmpEnd);
}

/**
 * The host the page is served from: the option when given, else `location.hostname` (read at call time).
 *
 * @param {any} pOptions - render options.
 *
 * @return {string} the normalized current host, or ''.
 */
function _currentHost(pOptions)
{
	if (pOptions && (typeof pOptions.currentHost === 'string'))
	{
		return _normalizeHost(pOptions.currentHost);
	}
	try
	{
		if ((typeof location !== 'undefined') && location && location.hostname)
		{
			return _normalizeHost(location.hostname);
		}
	}
	catch (pError)
	{
		return '';
	}
	return '';
}

/**
 * Whether a parsed hostname is an IP literal. The URL parser has already turned every IPv4 spelling
 * (hex, octal, a bare number) into a dotted quad, and a host whose last label is all digits is never a name.
 *
 * @param {string} pHostname - a normalized hostname.
 *
 * @return {boolean} true for IPv4 / IPv6 literals.
 */
function _isIPLiteral(pHostname)
{
	if (pHostname.charAt(0) === '[')
	{
		return true;
	}
	const tmpLabels = pHostname.split('.');
	return /^(?:0x[0-9a-f]*|\d+)$/i.test(tmpLabels[tmpLabels.length - 1]);
}

/**
 * Whether a hostname is Headlight's (headlight.com or any subdomain), where `/1.0/*` reaches the API with the
 * viewer's session cookie.
 *
 * @param {string} pHostname - a normalized hostname.
 *
 * @return {boolean} true for Headlight hosts.
 */
function _isHeadlightHost(pHostname)
{
	return (pHostname === 'headlight.com') || /\.headlight\.com$/.test(pHostname);
}

/**
 * The link policy (D2): returns the parsed URL when it may be linked, else null.
 *
 * Only absolute https URLs without credentials, and never Headlight, the current host, localhost or an IP
 * literal. The current host is checked first, so no exception reaches it. With `allowReport`, a Headlight
 * API host (`api[.<env>].headlight.com`) is allowed for exactly `/1.0/Report/<guid>/index.html` with no
 * query or fragment.
 *
 * @param {any} pHref - the candidate href.
 * @param {{ currentHost?: string, allowReport?: boolean }} [pOptions] - policy options.
 *
 * @return {URL|null} the URL to link to (emit its `href`), or null to render text.
 */
function safeLink(pHref, pOptions)
{
	const tmpOptions = pOptions || {};
	if ((typeof pHref !== 'string') || (typeof URL !== 'function'))
	{
		return null;
	}
	const tmpHref = pHref.trim();
	if (!tmpHref)
	{
		return null;
	}
	let tmpURL;
	try
	{
		// No base: relative, protocol-relative and /1.0/... hrefs throw here.
		tmpURL = new URL(tmpHref);
	}
	catch (pError)
	{
		return null;
	}
	if ((tmpURL.protocol !== 'https:') || tmpURL.username || tmpURL.password)
	{
		return null;
	}
	const tmpHostname = _normalizeHost(tmpURL.hostname);
	if (!tmpHostname || _isIPLiteral(tmpHostname))
	{
		return null;
	}
	if ((tmpHostname === 'localhost') || /\.localhost$/.test(tmpHostname))
	{
		return null;
	}
	// The page's own origin first, before any exception: a link there runs with the viewer's session on
	// the façade's origin (Kong serves /1.0 on every host), so it is never made.
	const tmpCurrentHost = _currentHost(tmpOptions);
	if (tmpCurrentHost && (tmpHostname === tmpCurrentHost))
	{
		return null;
	}
	if (_isHeadlightHost(tmpHostname))
	{
		// The render-URL exception, for the API hosts only; tmpURL.pathname is already dot-segment normalized.
		if (tmpOptions.allowReport && REPORT_HOST_PATTERN.test(tmpHostname) && REPORT_PATH_PATTERN.test(tmpURL.pathname) && !tmpURL.search && !tmpURL.hash && (tmpHref.indexOf('?') < 0) && (tmpHref.indexOf('#') < 0))
		{
			return tmpURL;
		}
		return null;
	}
	return tmpURL;
}

/**
 * A link that opens in a new tab and shows its destination host, or just the label when the href fails the
 * link policy.
 *
 * @param {any} pHref - the candidate href.
 * @param {string} pLabelHTML - the link text, ALREADY safe HTML (escaped by the caller or rendered by marked).
 * @param {{ currentHost?: string, allowReport?: boolean }} [pOptions] - policy options.
 *
 * @return {string} '<a …>label</a><span class="fcg-linkhost">(host)</span>' or the label alone.
 */
function linkHTML(pHref, pLabelHTML, pOptions)
{
	const tmpLabel = (typeof pLabelHTML === 'string') ? pLabelHTML : '';
	const tmpURL = safeLink(pHref, pOptions);
	if (!tmpURL)
	{
		return tmpLabel;
	}
	const tmpShown = tmpLabel.trim() ? tmpLabel : escapeHTML(tmpURL.href);
	return `<a href="${ escapeHTML(tmpURL.href) }" target="_blank" rel="noopener noreferrer nofollow">${ tmpShown }</a><span class="fcg-linkhost">(${ escapeHTML(tmpURL.host) })</span>`;
}

/**
 * The private marked instance (marked >= 13 object-argument renderers).
 *
 * @return {any} the Marked instance.
 */
function _getRemoteMarked()
{
	if (_RemoteMarked)
	{
		return _RemoteMarked;
	}
	if (!libMarked || (typeof libMarked.Marked !== 'function'))
	{
		throw new Error('FormConcierge needs marked >= 13');
	}
	_RemoteMarked = new libMarked.Marked(
		{
			gfm: true,
			breaks: true,
			async: false,
			// Inline text after an inline <pre>/<code>/<kbd>/<script> tag reaches the renderer unescaped
			// (marked's "raw block" state), so `<kbd><img/src=x onerror=…>` would otherwise run. Escape every
			// leaf text token; already-escaped text is left as it is.
			walkTokens: function(pToken)
			{
				if (pToken && (pToken.type === 'text') && !pToken.tokens && (typeof pToken.text === 'string'))
				{
					pToken.text = _escapeTextIdempotent(pToken.text);
				}
			},
			renderer:
			{
				// Function expressions: `this` is marked's renderer, which carries `this.parser`.
				html: function(pToken)
				{
					const tmpText = escapeHTML(pToken.text);
					return pToken.block ? `<pre class="fcg-md-raw">${ tmpText }</pre>\n` : tmpText;
				},
				link: function(pToken)
				{
					let tmpLabel = '';
					_LinkDepth++;
					try
					{
						tmpLabel = this.parser.parseInline(pToken.tokens);
					}
					finally
					{
						_LinkDepth--;
					}
					let tmpHref = pToken.href;
					// A <https://…> autolink carries an HTML-escaped href; its raw text is the real one.
					if ((typeof pToken.raw === 'string') && /^<[^<>]*>$/.test(pToken.raw))
					{
						tmpHref = pToken.raw.slice(1, -1);
					}
					return linkHTML(tmpHref, tmpLabel, _ActiveOptions);
				},
				image: function(pToken)
				{
					// The alt text arrives escaped.
					const tmpAlt = (typeof pToken.text === 'string') ? pToken.text : '';
					if (_LinkDepth > 0)
					{
						return tmpAlt;
					}
					const tmpURL = safeLink(pToken.href, _ActiveOptions);
					if (!tmpURL)
					{
						return tmpAlt;
					}
					return linkHTML(tmpURL.href, tmpAlt.trim() ? tmpAlt : 'image', _ActiveOptions);
				},
			},
		});
	return _RemoteMarked;
}

/**
 * Renders untrusted remote markdown to display HTML (contract §6, D1, D2, D4). Falls back to the escaped
 * source in a `<pre>` when marked is unusable or throws.
 *
 * @param {any} pMarkdown - the markdown.
 * @param {{ currentHost?: string, allowReport?: boolean }} [pOptions] - link policy; allowReport defaults to true.
 *
 * @return {string} HTML.
 */
function renderRemoteMarkdown(pMarkdown, pOptions)
{
	if ((pMarkdown === null) || (typeof pMarkdown === 'undefined') || (pMarkdown === ''))
	{
		return '';
	}
	const tmpMarkdown = (typeof pMarkdown === 'string') ? pMarkdown : String(pMarkdown);
	const tmpSource = pOptions || {};
	const tmpOptions =
		{
			currentHost: _currentHost(tmpSource),
			allowReport: (typeof tmpSource.allowReport === 'boolean') ? tmpSource.allowReport : true,
		};
	try
	{
		_ActiveOptions = tmpOptions;
		_LinkDepth = 0;
		return String(_getRemoteMarked().parse(tmpMarkdown));
	}
	catch (pError)
	{
		return `<pre class="fcg-md-fallback">${ escapeHTML(tmpMarkdown) }</pre>`;
	}
	finally
	{
		_ActiveOptions = {};
		_LinkDepth = 0;
	}
}

/**
 * Whether the text after `… hldi load ` matches `[\w./ -]+( --[\w-]+( [\w.,/-]+)?)*$` — computed in linear
 * time, because that regex backtracks exponentially on crafted input (~20 s for under 200 characters) and the
 * command is attacker-steerable.
 *
 * A comma can only sit in an option value, so a tail without one only has to fit `[\w./ -]+`. Otherwise the
 * token holding the first comma is a value whose option is the token just before it; from that option on the
 * tail is single-space separated tokens of `[\w.,/-]+`, where every token that is not an option (`--[\w-]+`)
 * directly follows one that is.
 *
 * @param {string} pTail - the text after the fixed head.
 *
 * @return {boolean} true when the tail fits.
 */
function _commandTailMatches(pTail)
{
	if (!pTail || /[^\w./ ,-]/.test(pTail))
	{
		return false;
	}
	const tmpFirstComma = pTail.indexOf(',');
	if (tmpFirstComma < 0)
	{
		return true;
	}
	const tmpValueStart = pTail.lastIndexOf(' ', tmpFirstComma) + 1;
	if (tmpValueStart < 2)
	{
		return false;
	}
	const tmpOptionStart = pTail.lastIndexOf(' ', tmpValueStart - 2) + 1;
	// The option must be preceded by a space that is not the tail's first character (the head part is non-empty).
	if (tmpOptionStart < 2)
	{
		return false;
	}
	const tmpTokens = pTail.slice(tmpOptionStart).split(' ');
	const tmpIsOption = (pToken) => /^--[\w-]+$/.test(pToken);
	if (!tmpIsOption(tmpTokens[0]))
	{
		return false;
	}
	for (let i = 0; i < tmpTokens.length; i++)
	{
		if (!/^[\w.,/-]+$/.test(tmpTokens[i]))
		{
			return false;
		}
		if ((i > 0) && !tmpIsOption(tmpTokens[i]) && !tmpIsOption(tmpTokens[i - 1]))
		{
			return false;
		}
	}
	return true;
}

/**
 * Whether a delivery command may be offered for copy (D3): exactly
 * `^cd [\w./~-]+ && npx hldi load [\w./ -]+( --[\w-]+( [\w.,/-]+)?)*$`, none of `;|$\`<>()`, and no `&`
 * besides the single `&&`.
 *
 * @param {any} pCommand - the command from reply metadata.
 *
 * @return {boolean} true when it is safe to offer.
 */
function isCopyableCommand(pCommand)
{
	if ((typeof pCommand !== 'string') || !pCommand || (pCommand.length > COMMAND_MAX_LENGTH))
	{
		return false;
	}
	if (COMMAND_FORBIDDEN_PATTERN.test(pCommand) || (pCommand.split('&').length !== 3) || (pCommand.indexOf('&&') < 0))
	{
		return false;
	}
	const tmpHead = COMMAND_HEAD_PATTERN.exec(pCommand);
	if (!tmpHead)
	{
		return false;
	}
	return _commandTailMatches(pCommand.slice(tmpHead[0].length));
}

/**
 * The user's own words from a composed turn (C6): drops everything from STEERING_MARKER on, then a leading
 * EXAMPLES_PREFIX / REVISION_PREFIX paragraph (up to the first blank line). Must match the façade's copy.
 *
 * @param {any} pText - a composed input value or turn Content.
 *
 * @return {string} the stripped text.
 */
function stripSteering(pText)
{
	// Non-strings are '' (as in the façade's copy).
	let tmpText = (typeof pText === 'string') ? pText : '';
	const tmpMarker = tmpText.indexOf(STEERING_MARKER);
	if (tmpMarker >= 0)
	{
		tmpText = tmpText.slice(0, tmpMarker);
	}
	if ((tmpText.indexOf(EXAMPLES_PREFIX) === 0) || (tmpText.indexOf(REVISION_PREFIX) === 0))
	{
		const tmpBlank = tmpText.indexOf('\n\n');
		tmpText = (tmpBlank >= 0) ? tmpText.slice(tmpBlank + 2) : '';
	}
	return tmpText;
}

/**
 * A metadata value as chip text.
 *
 * @param {any} pValue - the value.
 *
 * @return {string} plain (unescaped) text; '' when there is nothing to show.
 */
function _chipText(pValue)
{
	if ((pValue === null) || (typeof pValue === 'undefined'))
	{
		return '';
	}
	if (typeof pValue === 'boolean')
	{
		return pValue ? 'yes' : 'no';
	}
	if ((typeof pValue === 'string') || (typeof pValue === 'number'))
	{
		return String(pValue);
	}
	try
	{
		return String(JSON.stringify(pValue)).slice(0, 300);
	}
	catch (pError)
	{
		return '';
	}
}

/**
 * One escaped label/value chip.
 *
 * @param {string} pLabel - fixed label text.
 * @param {any} pValue - the untrusted value.
 * @param {string} [pModifier] - optional fixed modifier class.
 *
 * @return {string} HTML, or '' for an empty value.
 */
function _chip(pLabel, pValue, pModifier)
{
	const tmpText = _chipText(pValue);
	if (!tmpText)
	{
		return '';
	}
	const tmpClass = pModifier ? `fcg-chip ${ pModifier }` : 'fcg-chip';
	return `<span class="${ tmpClass }"><span class="fcg-chip-label">${ escapeHTML(pLabel) }</span> <span class="fcg-chip-value">${ escapeHTML(tmpText) }</span></span> `;
}

/**
 * A count for fields that may arrive as a number, an array or an object.
 *
 * @param {any} pValue - the field value.
 *
 * @return {any} a number for arrays/objects, else the value.
 */
function _countOf(pValue)
{
	if (Array.isArray(pValue))
	{
		return pValue.length;
	}
	if (pValue && (typeof pValue === 'object'))
	{
		return Object.keys(pValue).length;
	}
	return pValue;
}

/**
 * Copies the keys of an object that a group did not render, so the Details block shows them.
 *
 * @param {Record<string, any>} pObject - the group object.
 * @param {Array<string>} pKnown - keys the group rendered.
 *
 * @return {Record<string, any>|null} the leftovers, or null when none.
 */
function _leftoverKeys(pObject, pKnown)
{
	/** @type {Record<string, any>} */
	const tmpLeftover = {};
	let tmpAny = false;
	Object.keys(pObject).forEach((pKey) =>
	{
		if (pKnown.indexOf(pKey) < 0)
		{
			tmpLeftover[pKey] = pObject[pKey];
			tmpAny = true;
		}
	});
	return tmpAny ? tmpLeftover : null;
}

/**
 * Whether a value is a plain (non-array) object.
 *
 * @param {any} pValue - the value.
 *
 * @return {boolean} true for objects.
 */
function _isObject(pValue)
{
	return !!pValue && (typeof pValue === 'object') && !Array.isArray(pValue);
}

/**
 * The parsed plansheet.io share URL, or null when the value is not one (D2 + §6: only https://plansheet.io/).
 *
 * @param {any} pShareURL - Blueprint.ShareURL.
 *
 * @return {URL|null} the URL.
 */
function _plansheetShareURL(pShareURL)
{
	if ((typeof pShareURL !== 'string') || (pShareURL.trim().indexOf('https://plansheet.io/') !== 0) || (typeof URL !== 'function'))
	{
		return null;
	}
	try
	{
		const tmpURL = new URL(pShareURL.trim());
		if ((tmpURL.protocol === 'https:') && (tmpURL.hostname === 'plansheet.io') && !tmpURL.port && !tmpURL.username && !tmpURL.password)
		{
			return tmpURL;
		}
	}
	catch (pError)
	{
		return null;
	}
	return null;
}

/**
 * Chips for reply metadata (§6 + D2/D3). Every value is escaped; links follow the link policy; a Copy
 * button appears only for a command that passes isCopyableCommand, as
 * `<button type="button" class="fcg-copy" data-fcg-copy="<index into Copyables>">` (no inline handlers).
 *
 * @param {any} pMeta - parsed MetadataJSON (a JSON string is parsed too), or null.
 * @param {{ currentHost?: string }} [pOptions] - link policy options.
 *
 * @return {{ HTML: string, Copyables: Array<string> }} the chips and the copyable strings.
 */
function renderReplyMetadata(pMeta, pOptions)
{
	/** @type {Array<string>} */
	const tmpCopyables = [];
	let tmpMeta = pMeta;
	if (typeof tmpMeta === 'string')
	{
		try
		{
			tmpMeta = tmpMeta.trim() ? JSON.parse(tmpMeta) : null;
		}
		catch (pError)
		{
			tmpMeta = { Unparsed: pMeta };
		}
	}
	if ((tmpMeta === null) || (typeof tmpMeta === 'undefined'))
	{
		return { HTML: '', Copyables: tmpCopyables };
	}
	if (!_isObject(tmpMeta))
	{
		tmpMeta = { Value: tmpMeta };
	}
	const tmpHostOptions = { currentHost: _currentHost(pOptions || {}) };
	/** @type {Record<string, any>} */
	const tmpLeftover = {};
	let tmpHasLeftover = false;
	const tmpGroups = [];
	const tmpHandled = [ 'Blueprint', 'HeadlightForm', 'Config', 'Session', 'Examples', 'Documents' ];

	/**
	 * Records a group's unrendered keys.
	 * @param {string} pKey - group key.
	 * @param {any} pValue - leftovers or null.
	 */
	const fKeep = (pKey, pValue) =>
	{
		if (pValue !== null)
		{
			tmpLeftover[pKey] = pValue;
			tmpHasLeftover = true;
		}
	};

	Object.keys(tmpMeta).forEach((pKey) =>
	{
		const tmpValue = tmpMeta[pKey];
		const tmpKnownShape = (pKey === 'Examples' || pKey === 'Documents') ? Array.isArray(tmpValue) : _isObject(tmpValue);
		if ((tmpHandled.indexOf(pKey) < 0) || !tmpKnownShape)
		{
			fKeep(pKey, tmpValue);
		}
	});

	const tmpBlueprint = tmpMeta.Blueprint;
	if (_isObject(tmpBlueprint))
	{
		let tmpHTML = '';
		if ((tmpBlueprint.BlueprintNumber !== null) && (typeof tmpBlueprint.BlueprintNumber !== 'undefined') && (tmpBlueprint.BlueprintNumber !== ''))
		{
			tmpHTML += _chip('Blueprint', `#${ _chipText(tmpBlueprint.BlueprintNumber) }`);
			tmpHTML += _chip('ID', tmpBlueprint.IDBlueprint);
		}
		else
		{
			tmpHTML += _chip('Blueprint', tmpBlueprint.IDBlueprint);
		}
		if ((typeof tmpBlueprint.ShareURL !== 'undefined') && (tmpBlueprint.ShareURL !== null) && (tmpBlueprint.ShareURL !== ''))
		{
			const tmpShareURL = _plansheetShareURL(tmpBlueprint.ShareURL);
			const tmpLink = tmpShareURL ? linkHTML(tmpShareURL.href, 'Open blueprint', tmpHostOptions) : '';
			tmpHTML += tmpLink ? `<span class="fcg-meta-link">${ tmpLink }</span>` : '<span class="fcg-meta-muted">Share link not shown (not a plansheet.io address)</span>';
		}
		tmpGroups.push(`<div class="fcg-meta-group fcg-meta-blueprint"><span class="fcg-meta-title">Blueprint</span> ${ tmpHTML }</div>`);
		fKeep('Blueprint', _leftoverKeys(tmpBlueprint, [ 'IDBlueprint', 'BlueprintNumber', 'ShareURL' ]));
	}

	const tmpForm = tmpMeta.HeadlightForm;
	if (_isObject(tmpForm))
	{
		let tmpHTML = '';
		tmpHTML += _chip('Hash', tmpForm.Hash);
		tmpHTML += _chip('Environment', tmpForm.Environment);
		if (tmpForm.Pushed === true)
		{
			tmpHTML += _chip('Pushed', 'yes', 'fcg-chip-ok');
		}
		else if (tmpForm.Pushed === false)
		{
			tmpHTML += _chip('Pushed', 'no', 'fcg-chip-warn');
		}
		else
		{
			tmpHTML += _chip('Pushed', tmpForm.Pushed);
		}
		tmpHTML += _chip('Customer', tmpForm.Customer);
		tmpHTML += _chip('Default report', tmpForm.DefaultReport);
		const tmpCommand = tmpForm.Command;
		if ((tmpCommand !== null) && (typeof tmpCommand !== 'undefined') && (tmpCommand !== ''))
		{
			if (isCopyableCommand(tmpCommand))
			{
				const tmpIndex = tmpCopyables.length;
				tmpCopyables.push(tmpCommand);
				tmpHTML += `<div class="fcg-command"><pre class="fcg-command-text">${ escapeHTML(tmpCommand) }</pre><button type="button" class="fcg-copy" data-fcg-copy="${ tmpIndex }">Copy</button></div>`;
			}
			else
			{
				tmpHTML += `<div class="fcg-command fcg-command-unrecognized"><div class="fcg-meta-muted">Unrecognized command — not offered for copy</div><pre class="fcg-command-text">${ escapeHTML(_chipText(tmpCommand)) }</pre></div>`;
			}
		}
		tmpGroups.push(`<div class="fcg-meta-group fcg-meta-headlightform"><span class="fcg-meta-title">Headlight form</span> ${ tmpHTML }</div>`);
		fKeep('HeadlightForm', _leftoverKeys(tmpForm, [ 'Hash', 'Environment', 'Pushed', 'Customer', 'DefaultReport', 'Command' ]));
	}

	const tmpConfig = tmpMeta.Config;
	if (_isObject(tmpConfig))
	{
		let tmpHTML = '';
		tmpHTML += _chip('Form hash', tmpConfig.FormHash);
		tmpHTML += _chip('Sections', _countOf(tmpConfig.Sections));
		tmpHTML += _chip('Descriptors', _countOf(tmpConfig.Descriptors));
		tmpHTML += _chip('Exact match', tmpConfig.ValidationExactRate);
		const tmpNotes = _chipText(tmpConfig.Notes);
		if (tmpNotes)
		{
			tmpHTML += `<div class="fcg-meta-notes">${ escapeHTML(tmpNotes).replace(/\r?\n/g, '<br>') }</div>`;
		}
		tmpGroups.push(`<div class="fcg-meta-group fcg-meta-config"><span class="fcg-meta-title">Configuration</span> ${ tmpHTML }</div>`);
		fKeep('Config', _leftoverKeys(tmpConfig, [ 'FormHash', 'Sections', 'Descriptors', 'ValidationExactRate', 'Notes' ]));
	}

	const tmpSession = tmpMeta.Session;
	if (_isObject(tmpSession))
	{
		tmpGroups.push(`<div class="fcg-meta-group fcg-meta-session"><span class="fcg-meta-title">Session</span> ${ _chip('Session file', tmpSession.IDSessionFile) }</div>`);
		fKeep('Session', _leftoverKeys(tmpSession, [ 'IDSessionFile' ]));
	}

	[ 'Examples', 'Documents' ].forEach((pKey) =>
	{
		const tmpList = tmpMeta[pKey];
		if (!Array.isArray(tmpList))
		{
			return;
		}
		let tmpRows = '';
		/** @type {Array<any>} */
		const tmpOther = [];
		tmpList.forEach((pRow) =>
		{
			if (!_isObject(pRow))
			{
				tmpOther.push(pRow);
				return;
			}
			const tmpName = _chipText(pRow.Name) || 'Document';
			const tmpReportOptions = { currentHost: tmpHostOptions.currentHost, allowReport: true };
			const tmpRenderURL = safeLink(pRow.RenderURL, tmpReportOptions);
			let tmpLink = '';
			if (tmpRenderURL)
			{
				tmpLink = `<span class="fcg-meta-link">${ linkHTML(tmpRenderURL.href, 'Open', tmpReportOptions) }</span>`;
			}
			else if ((pRow.RenderURL !== null) && (typeof pRow.RenderURL !== 'undefined') && (pRow.RenderURL !== ''))
			{
				tmpLink = '<span class="fcg-meta-muted">(render link not shown)</span>';
			}
			tmpRows += `<li><span class="fcg-meta-docname">${ escapeHTML(tmpName) }</span> ${ _chip('ID', pRow.IDDocument) }${ tmpLink }</li>`;
			// Rows with extra keys or a refused link go to Details too, so nothing is hidden.
			if (_leftoverKeys(pRow, [ 'Name', 'IDDocument', 'RenderURL' ]) || (tmpLink && !tmpRenderURL))
			{
				tmpOther.push(pRow);
			}
		});
		tmpGroups.push(`<div class="fcg-meta-group fcg-meta-documents"><span class="fcg-meta-title">${ (pKey === 'Examples') ? 'Examples' : 'Documents' }</span><ul class="fcg-meta-doclist">${ tmpRows }</ul></div>`);
		if (tmpOther.length)
		{
			fKeep(pKey, tmpOther);
		}
	});

	if (tmpHasLeftover)
	{
		let tmpJSON = '';
		try
		{
			tmpJSON = String(JSON.stringify(tmpLeftover, null, 2));
		}
		catch (pError)
		{
			tmpJSON = '(not displayable)';
		}
		if (tmpJSON.length > DETAILS_MAX_LENGTH)
		{
			tmpJSON = `${ tmpJSON.slice(0, DETAILS_MAX_LENGTH) }\n… (truncated)`;
		}
		tmpGroups.push(`<details class="fcg-meta-details"><summary>Details</summary><pre>${ escapeHTML(tmpJSON) }</pre></details>`);
	}

	return { HTML: tmpGroups.length ? `<div class="fcg-meta">${ tmpGroups.join('') }</div>` : '', Copyables: tmpCopyables };
}

module.exports =
{
	renderRemoteMarkdown: renderRemoteMarkdown,
	safeLink: safeLink,
	linkHTML: linkHTML,
	escapeHTML: escapeHTML,
	renderReplyMetadata: renderReplyMetadata,
	isCopyableCommand: isCopyableCommand,
	stripSteering: stripSteering,
	STEERING_MARKER: STEERING_MARKER,
	EXAMPLES_PREFIX: EXAMPLES_PREFIX,
	REVISION_PREFIX: REVISION_PREFIX,
};

},{"../../../../lib/web/headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js":170,"../../../../node_modules/marked":506}],1278:[function(require,module,exports){
/**
 * FormConcierge-Mirror — mirrors each Form Concierge session (a plansheet Request + its turns) into Headlight as one
 * Document of the `FormConcierge-Session` form type, so sessions are durable and browsable on the Headlight side too.
 *
 * Layout (all in the session customer, which for v1 is always customer 1 — super-users only):
 *   - form type: the RNI Hash `FormConcierge-Session` (seeded by seed-form-concierge-config.js); missing → mirror OFF.
 *   - project:   `GUIDProject = FormConcierge-<IDCustomer>-Sessions`, joined to the RNI (ReportNamedInstanceProjectJoin)
 *                so its documents render with this form rather than the project's first one.
 *   - document:  `GUIDDocument = FormConcierge-Session-<GUIDRequest>`, FormData as an OBJECT (never a string).
 *
 * Every deterministic-GUID find-or-create walks the suffixes '', '-2', '-3': a live hit is used; a GUID held only by a
 * soft-deleted row is skipped (Meadow's create sees deleted rows and refuses the GUID forever); a free GUID is created
 * and then read back, because some Meadow writes answer 200 `{}` when they were refused.
 *
 * Everything here is fire-and-forget for the screen: no public method rejects; failures come back as
 * `{ Skipped:true, Reason }` for a quiet inline warning. All plansheet-sourced strings are stored as data only (the
 * form's descriptors are String/TextArea/Number/DateTime, D12) and never interpolated into a Meadow filter unchecked.
 *
 * No window/document access anywhere; the REST client is injected (HeadlightRestClient-like, URLs WITHOUT /1.0/).
 */

const RNI_HASH = 'FormConcierge-Session';
const DOCUMENT_TYPE = 'FormConcierge-Session';
const DOCUMENT_GUID_PREFIX = 'FormConcierge-Session-';
const PROJECT_NAME = 'Form Concierge — Sessions';
const PROJECT_STATUS = 'FormConcierge';
const PROJECT_DESCRIPTION = 'Headlight mirror of Form Concierge sessions (the plansheet form pipeline): one Document per session. Maintained by the Platform Configuration app.';
const GUID_SUFFIXES = [ '', '-2', '-3' ];
// Plansheet GUIDs are UUIDs; anything else is refused before it can reach a Meadow filter expression.
const GUID_PATTERN = /^[0-9A-Za-z-]{1,200}$/;
const NOT_INSTALLED_REASON = 'Not mirrored to Headlight: the FormConcierge-Session form type isn\'t installed in this environment';
const READY_RETRY_MS = 60000;
const RECONCILE_PROBE_CAP = 100;
const RECONCILE_SYNC_CAP = 5;
const DOCUMENT_NAME_MAX = 128;
const TURN_CONTENT_MAX = 200000;
const TRANSCRIPT_MAX = 600000;
const EXAMPLES_MAX = 25;
const FLOW_LABELS = { create: 'Create', update: 'Update', build: 'Build', examples: 'Examples' };

// Steering sentinels (C1). The façade already strips them into Display.UserText; these only back the fallback below.
const STEERING_MARKER = '\n\n---\nForm Concierge steering:\n';
const EXAMPLES_PREFIX = '[examples] ';
const REVISION_PREFIX = '[revision] ';
const STANDING_HEADING = '## Standing instructions';

/**
 * C6 stripping: drop a leading [examples]/[revision] paragraph and everything from the steering marker on.
 * @param {any} pText - Raw turn text.
 * @return {string}
 */
const stripSteering = (pText) =>
{
	let tmpText = (typeof pText === 'string') ? pText : '';
	const tmpMarker = tmpText.indexOf(STEERING_MARKER);
	if (tmpMarker >= 0)
	{
		tmpText = tmpText.slice(0, tmpMarker);
	}
	tmpText = tmpText.replace(/^\s+/, '');
	if ((tmpText.indexOf(EXAMPLES_PREFIX) === 0) || (tmpText.indexOf(REVISION_PREFIX) === 0))
	{
		const tmpBreak = tmpText.indexOf('\n\n');
		tmpText = (tmpBreak >= 0) ? tmpText.slice(tmpBreak + 2) : '';
	}
	return tmpText.trim();
};

/**
 * The user's own segment of an assembled first turn ('## Standing instructions … ## <Input> …'); '' when there is
 * none, so the standing instructions never land in the mirror.
 * @param {string} pContent - The first user turn's Content.
 * @return {string}
 */
const userSegmentOfAssembledTurn = (pContent) =>
{
	if (pContent.indexOf(STANDING_HEADING) !== 0)
	{
		return pContent;
	}
	const tmpHeading = /\n## [^\n]*\n/g;
	tmpHeading.lastIndex = STANDING_HEADING.length;
	const tmpMatch = tmpHeading.exec(pContent);
	return tmpMatch ? pContent.slice(tmpMatch.index + tmpMatch[0].length).replace(/^\n+/, '') : '';
};

/**
 * A single-line, control-free string cut to a width (names, hashes, roles).
 * @param {any} pValue - Anything.
 * @param {number} pMax - Maximum length.
 * @return {string}
 */
const cleanLine = (pValue, pMax) =>
{
	if ((pValue === undefined) || (pValue === null))
	{
		return '';
	}
	// eslint-disable-next-line no-control-regex
	return String(pValue).replace(/[\x00-\x1f\x7f]+/g, ' ').trim().slice(0, pMax);
};

/**
 * Multi-line text cut to a width, with a visible marker when cut.
 * @param {any} pValue - Anything.
 * @param {number} pMax - Maximum length.
 * @return {string}
 */
const cleanText = (pValue, pMax) =>
{
	if (typeof pValue !== 'string')
	{
		return '';
	}
	// eslint-disable-next-line no-control-regex
	const tmpText = pValue.replace(/\x00/g, '');
	return (tmpText.length > pMax) ? `${tmpText.slice(0, pMax)}\n\n…[truncated]` : tmpText;
};

/**
 * @param {any} pValue
 * @return {boolean}
 */
const isPlainObject = (pValue) => !!pValue && (typeof pValue === 'object') && !Array.isArray(pValue);

/**
 * Deep copy with every '<' in every string replaced by a look-alike (U+2039). The mirror form's PDF/Print render
 * writes String and TextArea values with innerHTML, so nothing we store may be able to become markup there.
 * @param {any} pValue - Anything JSON-shaped.
 * @return {any}
 */
const neutralizeMarkup = (pValue) =>
{
	if (typeof pValue === 'string')
	{
		return pValue.replace(/</g, '\u2039');
	}
	if (Array.isArray(pValue))
	{
		return pValue.map(neutralizeMarkup);
	}
	if (isPlainObject(pValue))
	{
		const tmpOut = {};
		Object.keys(pValue).forEach((pKey) =>
		{
			tmpOut[pKey] = neutralizeMarkup(pValue[pKey]);
		});
		return tmpOut;
	}
	return pValue;
};

/**
 * Message metadata as an object (the façade parses it; a string is tolerated and parsed here). Never a string.
 * @param {any} pValue - Metadata / MetadataJSON.
 * @return {Record<string, any>|null}
 */
const parseMetadata = (pValue) =>
{
	let tmpValue = pValue;
	if (typeof tmpValue === 'string')
	{
		if (tmpValue.trim().length < 1)
		{
			return null;
		}
		try
		{
			tmpValue = JSON.parse(tmpValue);
		}
		catch (pError)
		{
			return null;
		}
	}
	if (!isPlainObject(tmpValue))
	{
		return null;
	}
	try
	{
		return JSON.parse(JSON.stringify(tmpValue));
	}
	catch (pError)
	{
		return null;
	}
};

/**
 * Milliseconds for a date-ish value, or 0. Accepts ISO strings and MySQL-style 'YYYY-MM-DD HH:mm:ss' (read as UTC).
 * @param {any} pValue
 * @return {number}
 */
const toMillis = (pValue) =>
{
	if (!pValue)
	{
		return 0;
	}
	let tmpParsed = Date.parse(String(pValue));
	if (!isFinite(tmpParsed) && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(String(pValue)))
	{
		tmpParsed = Date.parse(`${String(pValue).replace(' ', 'T')}Z`);
	}
	return isFinite(tmpParsed) ? tmpParsed : 0;
};

/**
 * 'YYYY-MM-DD HH:mm UTC' for the transcript, or the raw value when it doesn't parse.
 * @param {any} pValue
 * @return {string}
 */
const transcriptDate = (pValue) =>
{
	const tmpMillis = toMillis(pValue);
	if (!tmpMillis)
	{
		return pValue ? cleanLine(pValue, 40) : '-';
	}
	return `${new Date(tmpMillis).toISOString().slice(0, 16).replace('T', ' ')} UTC`;
};

/**
 * The session's messages, sorted by Sequence (the façade sends them ascending; this does not rely on it).
 * @param {any} pPayload - GET Session payload.
 * @return {Array<any>}
 */
const sortedMessages = (pPayload) =>
{
	const tmpMessages = (pPayload && Array.isArray(pPayload.Messages)) ? pPayload.Messages.filter(isPlainObject) : [];
	return tmpMessages.slice().sort((pA, pB) => (Number(pA.Sequence) || 0) - (Number(pB.Sequence) || 0));
};

/**
 * The status to mirror: Request.Status, except an active run the façade flagged as a zombie reads as the Sessions
 * list shows it (B14) — 'NotPickedUp', or 'Cancelled' when a cancel was requested.
 * @param {any} pPayload - GET Session payload.
 * @return {string}
 */
const effectiveStatus = (pPayload) =>
{
	const tmpSession = (pPayload && isPlainObject(pPayload.Session)) ? pPayload.Session : {};
	const tmpStatus = cleanLine(tmpSession.Status, 32);
	const tmpRun = (pPayload && isPlainObject(pPayload.Run)) ? pPayload.Run : null;
	if (((tmpStatus === 'Pending') || (tmpStatus === 'Running')) && tmpRun && (tmpRun.Zombie === true))
	{
		return (tmpRun.CancelRequested === true) ? 'Cancelled' : 'NotPickedUp';
	}
	return tmpStatus;
};

/**
 * An example-document render URL (D2 exception): https, no credentials, `/1.0/Report/<guid>/index.html`, no query/hash.
 * @param {any} pValue
 * @return {string} The normalized URL, or ''.
 */
const reportURL = (pValue) =>
{
	if ((typeof pValue !== 'string') || (pValue.length > 600))
	{
		return '';
	}
	let tmpURL;
	try
	{
		tmpURL = new URL(pValue);
	}
	catch (pError)
	{
		return '';
	}
	if ((tmpURL.protocol !== 'https:') || tmpURL.username || tmpURL.password || tmpURL.search || tmpURL.hash)
	{
		return '';
	}
	return /^\/1\.0\/Report\/[0-9A-Za-z-]+\/index\.html$/.test(tmpURL.pathname) ? tmpURL.href : '';
};

// Document-id cues near a render URL, most specific first.
const EXAMPLE_ID_PATTERNS = [
	/\bIDDocument\D{0,4}?(\d{1,10})\b/i,
	/\bdoc(?:ument)?\s*(?:id\s*)?[#:]?\s*(\d{3,10})\b/i,
	/(?:^|[^\w$.,/:-])(\d{5,10})(?!\d|[.,]\d)/,
];

/**
 * Find a document id (and the label that follows it) in a line of text.
 * @param {string} pText - The text before the URL on its line (or the line above).
 * @return {{ IDDocument: number, Name: string }|null}
 */
const exampleCue = (pText) =>
{
	for (let i = 0; i < EXAMPLE_ID_PATTERNS.length; i++)
	{
		const tmpMatch = EXAMPLE_ID_PATTERNS[i].exec(pText);
		if (!tmpMatch)
		{
			continue;
		}
		const tmpEnd = tmpMatch.index + tmpMatch[0].length;
		let tmpName = pText.slice(tmpEnd).replace(/^[\s,:;*()[\]–—-]+/, '');
		const tmpStops = [ ':', '**', 'http', '(', ')', ' - ', ' — ', ' – ', '. ' ];
		tmpStops.forEach((pStop) =>
		{
			const tmpAt = tmpName.indexOf(pStop);
			if (tmpAt >= 0)
			{
				tmpName = tmpName.slice(0, tmpAt);
			}
		});
		return { IDDocument: Number(tmpMatch[1]) || 0, Name: cleanLine(tmpName.replace(/[\s*,;]+$/, ''), 80) };
	}
	return null;
};

/**
 * Best-effort example documents in assistant text: every render URL, with the document id and label written
 * nearest before it (the node replies like '**4913644, Single Award:** … View: https://…/1.0/Report/<guid>/index.html').
 * @param {string} pContent - Assistant Content.
 * @return {Array<{ IDDocument: number, Name: string, RenderURL: string }>}
 */
const examplesFromContent = (pContent) =>
{
	/** @type {Array<{ IDDocument: number, Name: string, RenderURL: string }>} */
	const tmpFound = [];
	if (typeof pContent !== 'string')
	{
		return tmpFound;
	}
	const tmpURLPattern = /https:\/\/[^\s<>()"'[\]*`]+/g;
	let tmpMatch = tmpURLPattern.exec(pContent);
	while (tmpMatch && (tmpFound.length < EXAMPLES_MAX))
	{
		const tmpURL = reportURL(tmpMatch[0].replace(/[.,;:!?]+$/, ''));
		if (tmpURL)
		{
			const tmpLineStart = pContent.lastIndexOf('\n', tmpMatch.index) + 1;
			let tmpCue = exampleCue(pContent.slice(tmpLineStart, tmpMatch.index));
			if (!tmpCue && (tmpLineStart > 1))
			{
				const tmpAbove = pContent.slice(0, tmpLineStart - 1);
				const tmpAboveLine = tmpAbove.slice(tmpAbove.lastIndexOf('\n') + 1);
				tmpCue = exampleCue(tmpAboveLine);
			}
			tmpFound.push({ IDDocument: tmpCue ? tmpCue.IDDocument : 0, Name: tmpCue ? tmpCue.Name : '', RenderURL: tmpURL });
		}
		tmpMatch = tmpURLPattern.exec(pContent);
	}
	return tmpFound;
};

/**
 * Normalize a Files list for FormData.
 * @param {any} pFiles
 * @return {Array<{ Name: string, MimeType: string, Size: number, IDMedia: number, Converted: any, Role: string }>}
 */
const normalizeFiles = (pFiles) =>
{
	if (!Array.isArray(pFiles))
	{
		return [];
	}
	return pFiles.filter(isPlainObject).slice(0, 200).map((pFile) =>
	{
		return {
			Name: cleanLine(pFile.Name, 256),
			MimeType: cleanLine(pFile.MimeType, 96),
			Size: Number(pFile.Size) || 0,
			IDMedia: Number(pFile.IDMedia) || 0,
			Converted: (typeof pFile.Converted === 'string') ? cleanLine(pFile.Converted, 32) : !!pFile.Converted,
			Role: cleanLine(pFile.Role, 32),
		};
	});
};

/**
 * @param {{ IDMedia: number, Name: string }} pFile
 * @return {string}
 */
const fileKey = (pFile) => ((pFile.IDMedia > 0) ? `m${pFile.IDMedia}` : `n${pFile.Name}`);

/**
 * Union of two file lists (by IDMedia, else Name); entries in pNewer win.
 * @param {Array<any>} pOlder
 * @param {Array<any>} pNewer
 * @return {Array<any>}
 */
const mergeFiles = (pOlder, pNewer) =>
{
	/** @type {Array<any>} */
	const tmpMerged = [];
	/** @type {Record<string, number>} */
	const tmpIndex = {};
	(pOlder || []).concat(pNewer || []).forEach((pFile) =>
	{
		const tmpKey = fileKey(pFile);
		if (tmpIndex[tmpKey] === undefined)
		{
			tmpIndex[tmpKey] = tmpMerged.length;
			tmpMerged.push(pFile);
		}
		else
		{
			tmpMerged[tmpIndex[tmpKey]] = pFile;
		}
	});
	return tmpMerged.slice(0, 200);
};

/**
 * A Document read's FormData as an object ({} when absent or unparseable).
 * @param {any} pDocument
 * @return {Record<string, any>}
 */
const documentFormData = (pDocument) =>
{
	if (!pDocument)
	{
		return {};
	}
	let tmpFormData = (pDocument.FormData !== undefined) ? pDocument.FormData : pDocument.FormDataJSON;
	if (typeof tmpFormData === 'string')
	{
		try
		{
			tmpFormData = JSON.parse(tmpFormData);
		}
		catch (pError)
		{
			tmpFormData = {};
		}
	}
	return isPlainObject(tmpFormData) ? tmpFormData : {};
};

/**
 * The mirrored status recorded in a mirror Document's Description (written by this module), or ''.
 * @param {any} pDescription
 * @return {string}
 */
const recordedStatus = (pDescription) =>
{
	const tmpMatch = (typeof pDescription === 'string') ? /Status: ([A-Za-z]{1,32})\s*$/.exec(pDescription) : null;
	return tmpMatch ? tmpMatch[1] : '';
};

/**
 * @param {any} pError
 * @return {string}
 */
const errorMessage = (pError) => cleanLine((pError && pError.message) ? pError.message : pError, 300);

/**
 * Meadow's create refusal for a GUID already held (live or soft-deleted).
 * @param {any} pError
 * @return {boolean}
 */
const isDuplicateGUIDError = (pError) => /already exists/i.test(errorMessage(pError));

/**
 * The Headlight-side mirror of Form Concierge sessions (one instance per screen; it caches the form type, the
 * sessions project and each session's resolved Document).
 */
class FormConciergeMirror
{
	/**
	 * @param {{ rest: any, IDCustomer: number, Environment?: string, log?: any, now?: () => number }} pOptions -
	 *   rest = HeadlightRestClient-like (getJSON/postJSON/putJSON with (err, body) callbacks, URLs without /1.0/);
	 *   now = clock for tests.
	 */
	constructor(pOptions)
	{
		/** @type {Record<string, any>} */
		const tmpOptions = pOptions || {};
		/** @type {any} */
		this.rest = tmpOptions.rest || null;
		/** @type {number} */
		this.IDCustomer = Number(tmpOptions.IDCustomer) || 0;
		/** @type {string} */
		this.Environment = cleanLine(tmpOptions.Environment, 16);
		/** @type {any} */
		this.log = tmpOptions.log || null;
		/** @type {() => number} */
		this._now = (typeof tmpOptions.now === 'function') ? tmpOptions.now : () => Date.now();
		/** @type {{ Result: any, Transient: boolean, At: number }|null} */
		this._ready = null;
		/** @type {Promise<any>|null} */
		this._readyPromise = null;
		/** @type {{ IDProject: number, GUIDProject: string }|null} */
		this._project = null;
		/** @type {Promise<any>|null} */
		this._projectPromise = null;
		/** @type {string} */
		this._formLinkKey = '';
		// Per-session mirror state (provider-lifetime cache): GUIDRequest → { IDDocument, GUIDDocument, IDProject, Key, Status, Files, FilesLoaded }.
		/** @type {Record<string, any>} */
		this._docs = {};
		/** @type {Record<string, Promise<any>>} */
		this._locks = {};
		/** @type {Promise<any>|null} */
		this._reconcilePromise = null;
		/** @type {number} */
		this._lastStamp = 0;
	}

	/**
	 * 'FormConcierge-Session-' + GUIDRequest.
	 * @param {string} pGUIDRequest - The plansheet Request GUID.
	 * @return {string}
	 */
	static documentGUID(pGUIDRequest)
	{
		return DOCUMENT_GUID_PREFIX + String(pGUIDRequest || '');
	}

	/**
	 * The change signature of a session: (Request.Status, Messages.length, last message Status, last message
	 * IDRequestMessage), plus the zombie status when the façade flagged the active run as never picked up.
	 * @param {any} pPayload - GET Session payload.
	 * @return {string}
	 */
	static signature(pPayload)
	{
		const tmpSession = (pPayload && isPlainObject(pPayload.Session)) ? pPayload.Session : {};
		const tmpMessages = sortedMessages(pPayload);
		const tmpLast = tmpMessages.length ? tmpMessages[tmpMessages.length - 1] : null;
		const tmpStatus = cleanLine(tmpSession.Status, 32);
		const tmpParts = [ tmpStatus, String(tmpMessages.length), tmpLast ? cleanLine(tmpLast.Status, 32) : '', String(tmpLast ? (Number(tmpLast.IDRequestMessage) || 0) : 0) ];
		const tmpEffective = effectiveStatus(pPayload);
		if (tmpEffective !== tmpStatus)
		{
			tmpParts.push(tmpEffective);
		}
		return tmpParts.join('|');
	}

	/**
	 * The mirror Document's FormData (§5 shape). User turns carry only what the user typed (the façade's
	 * Display.UserText — never the assembled prompt or steering); Metadata is always an object or null.
	 * @param {any} pPayload - GET Session payload.
	 * @param {{ Files?: Array<any>, Environment?: string, MirroredAt?: string, TaskName?: string }} [pExtras]
	 * @return {Record<string, any>}
	 */
	static buildFormData(pPayload, pExtras)
	{
		return neutralizeMarkup(FormConciergeMirror._buildFormDataRaw(pPayload, pExtras));
	}

	/**
	 * buildFormData before markup neutralization.
	 * @param {any} pPayload - GET Session payload.
	 * @param {{ Files?: Array<any>, Environment?: string, MirroredAt?: string, TaskName?: string }} [pExtras]
	 * @return {Record<string, any>}
	 */
	static _buildFormDataRaw(pPayload, pExtras)
	{
		const tmpExtras = pExtras || {};
		const tmpSession = (pPayload && isPlainObject(pPayload.Session)) ? pPayload.Session : {};
		const tmpForm = (pPayload && isPlainObject(pPayload.Form)) ? pPayload.Form : {};
		const tmpMessages = sortedMessages(pPayload);
		const tmpFlow = cleanLine(tmpSession.Flow, 32).toLowerCase();
		const tmpIDRequest = Number(tmpSession.IDRequest) || 0;
		const tmpFormName = cleanLine(tmpSession.FormName || tmpForm.Name, 200);
		let tmpTitle = cleanLine(tmpSession.Name, 200);
		if (!tmpTitle)
		{
			tmpTitle = FLOW_LABELS[tmpFlow] ? `${FLOW_LABELS[tmpFlow]}: ${tmpFormName || 'form'}` : (tmpFormName || `Session ${tmpIDRequest}`);
		}

		let tmpSeenUser = false;
		const tmpTurns = tmpMessages.map((pMessage) =>
		{
			const tmpRole = (cleanLine(pMessage.Role, 16).toLowerCase() === 'assistant') ? 'assistant' : 'user';
			let tmpContent = '';
			if (tmpRole === 'assistant')
			{
				tmpContent = (typeof pMessage.Content === 'string') ? pMessage.Content : '';
			}
			else if (isPlainObject(pMessage.Display) && (typeof pMessage.Display.UserText === 'string'))
			{
				tmpContent = pMessage.Display.UserText;
			}
			else
			{
				// No Display from the façade: never mirror the raw prompt — cut the standing instructions and steering.
				const tmpRaw = (typeof pMessage.Content === 'string') ? pMessage.Content : '';
				tmpContent = stripSteering(tmpSeenUser ? tmpRaw : userSegmentOfAssembledTurn(tmpRaw));
			}
			if (tmpRole === 'user')
			{
				tmpSeenUser = true;
			}
			return {
				Sequence: Number(pMessage.Sequence) || 0,
				Role: tmpRole,
				Status: cleanLine(pMessage.Status, 32),
				At: cleanLine((tmpRole === 'assistant') ? (pMessage.AnsweredDate || pMessage.CreateDate) : pMessage.CreateDate, 40),
				Content: cleanText(tmpContent, TURN_CONTENT_MAX),
				IDRun: Number(pMessage.IDRun) || 0,
				IDRequestMessage: Number(pMessage.IDRequestMessage) || 0,
				Metadata: parseMetadata((pMessage.Metadata !== undefined) ? pMessage.Metadata : pMessage.MetadataJSON),
			};
		});

		const tmpFirstUser = tmpTurns.filter((pTurn) => pTurn.Role === 'user')[0];
		const tmpTranscript = tmpTurns.map((pTurn) =>
		{
			const tmpRoleLabel = (pTurn.Role === 'assistant') ? 'Assistant' : 'User';
			return `### ${tmpRoleLabel} · ${transcriptDate(pTurn.At)} · ${pTurn.Status || '-'}\n\n${pTurn.Content || '(no text)'}`;
		}).join('\n\n');

		return {
			Session:
			{
				Title: tmpTitle,
				Flow: tmpFlow,
				Status: effectiveStatus(pPayload),
				FormName: tmpFormName,
				Environment: cleanLine(tmpExtras.Environment, 16),
				IDRequest: tmpIDRequest,
				GUIDRequest: cleanLine(tmpSession.GUIDRequest, 64),
				RequestNumber: Number(tmpSession.RequestNumber) || 0,
				PlansheetIDProject: Number(tmpSession.IDProject || tmpForm.IDProject) || 0,
				PlansheetGUIDProject: cleanLine(tmpSession.GUIDProject || tmpForm.GUIDProject, 64),
				IDTask: Number(tmpSession.IDTask) || 0,
				TaskName: cleanLine(tmpSession.TaskName || tmpExtras.TaskName, 200),
				CreatedAt: cleanLine(tmpSession.CreateDate, 40),
				AnsweredAt: cleanLine(tmpSession.AnsweredDate, 40),
				MirroredAt: (typeof tmpExtras.MirroredAt === 'string' && tmpExtras.MirroredAt) ? tmpExtras.MirroredAt : new Date().toISOString(),
				Signature: FormConciergeMirror.signature(pPayload),
			},
			Request: { Text: tmpFirstUser ? tmpFirstUser.Content : '' },
			Transcript: cleanText(tmpTranscript, TRANSCRIPT_MAX),
			Turns: tmpTurns,
			Files: normalizeFiles(tmpExtras.Files),
			Outputs: FormConciergeMirror._outputs(tmpTurns),
		};
	}

	/**
	 * Outputs from the latest assistant metadata carrying each key (Blueprint, HeadlightForm, Config), plus
	 * example documents from metadata arrays and render URLs in assistant Content (newest first, de-duplicated).
	 * @param {Array<any>} pTurns - FormData Turns.
	 * @return {Record<string, any>}
	 */
	static _outputs(pTurns)
	{
		let tmpBlueprint = null;
		let tmpHeadlightForm = null;
		let tmpConfig = null;
		/** @type {Array<{ IDDocument: number, Name: string, RenderURL: string }>} */
		const tmpExamples = [];
		/** @type {Record<string, boolean>} */
		const tmpSeen = {};
		/** @param {{ IDDocument: number, Name: string, RenderURL: string }} pExample */
		const fAdd = (pExample) =>
		{
			if (!pExample.RenderURL || tmpSeen[pExample.RenderURL] || (tmpExamples.length >= EXAMPLES_MAX))
			{
				return;
			}
			tmpSeen[pExample.RenderURL] = true;
			tmpExamples.push(pExample);
		};

		for (let i = pTurns.length - 1; i >= 0; i--)
		{
			const tmpTurn = pTurns[i];
			if (tmpTurn.Role !== 'assistant')
			{
				continue;
			}
			const tmpMeta = tmpTurn.Metadata;
			if (tmpMeta)
			{
				if (!tmpBlueprint && isPlainObject(tmpMeta.Blueprint))
				{
					tmpBlueprint = tmpMeta.Blueprint;
				}
				if (!tmpHeadlightForm && isPlainObject(tmpMeta.HeadlightForm))
				{
					tmpHeadlightForm = tmpMeta.HeadlightForm;
				}
				if (!tmpConfig && isPlainObject(tmpMeta.Config))
				{
					tmpConfig = tmpMeta.Config;
				}
				[ tmpMeta.Examples, tmpMeta.Documents ].forEach((pList) =>
				{
					if (!Array.isArray(pList))
					{
						return;
					}
					pList.filter(isPlainObject).forEach((pItem) =>
					{
						fAdd({ IDDocument: Number(pItem.IDDocument) || 0, Name: cleanLine(pItem.Name, 80), RenderURL: reportURL(pItem.RenderURL) });
					});
				});
			}
			examplesFromContent(tmpTurn.Content).forEach(fAdd);
		}

		const tmpShareURL = (tmpBlueprint && (typeof tmpBlueprint.ShareURL === 'string') && (tmpBlueprint.ShareURL.indexOf('https://plansheet.io/') === 0)) ? cleanLine(tmpBlueprint.ShareURL, 500) : '';
		return {
			IDBlueprint: Number(tmpBlueprint && tmpBlueprint.IDBlueprint) || 0,
			BlueprintShareURL: tmpShareURL,
			FormHash: cleanLine((tmpConfig && tmpConfig.FormHash) || (tmpHeadlightForm && tmpHeadlightForm.Hash), 128),
			Pushed: !!(tmpHeadlightForm && (tmpHeadlightForm.Pushed === true)),
			DeliveryEnvironment: cleanLine(tmpHeadlightForm && tmpHeadlightForm.Environment, 100),
			DeliveryCustomer: cleanLine(tmpHeadlightForm && tmpHeadlightForm.Customer, 300),
			Command: cleanLine(tmpHeadlightForm && tmpHeadlightForm.Command, 2000),
			Examples: tmpExamples,
		};
	}

	// ── REST plumbing ───────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Promise wrapper over the injected rest client. A body carrying Error/ErrorCode is a failure too.
	 * @param {string} pMethod - 'getJSON' | 'postJSON' | 'putJSON'.
	 * @param {string} pURL - Without the /1.0/ prefix.
	 * @param {any} [pBody] - JSON body (post/put).
	 * @return {Promise<any>}
	 */
	_call(pMethod, pURL, pBody)
	{
		return new Promise((fResolve, fReject) =>
		{
			if (!this.rest || (typeof this.rest[pMethod] !== 'function'))
			{
				return fReject(new Error('no Headlight REST client'));
			}
			/**
			 * @param {any} pError
			 * @param {any} pResult
			 */
			const fDone = (pError, pResult) =>
			{
				if (pError)
				{
					return fReject(pError);
				}
				if (pResult && (typeof pResult === 'object') && !Array.isArray(pResult) && (pResult.Error || pResult.ErrorCode))
				{
					return fReject(new Error(String(pResult.Error || `ErrorCode ${pResult.ErrorCode}`)));
				}
				return fResolve(pResult);
			};
			try
			{
				if (pMethod === 'getJSON')
				{
					this.rest.getJSON(pURL, fDone);
				}
				else
				{
					this.rest[pMethod](pURL, pBody, fDone);
				}
			}
			catch (pError)
			{
				fReject(pError);
			}
		});
	}

	/**
	 * @param {string} pURL
	 * @return {Promise<any>}
	 */
	_get(pURL)
	{
		return this._call('getJSON', pURL);
	}

	/**
	 * @param {string} pURL
	 * @param {any} pBody
	 * @return {Promise<any>}
	 */
	_post(pURL, pBody)
	{
		return this._call('postJSON', pURL, pBody);
	}

	/**
	 * @param {string} pURL
	 * @param {any} pBody
	 * @return {Promise<any>}
	 */
	_put(pURL, pBody)
	{
		return this._call('putJSON', pURL, pBody);
	}

	/**
	 * @param {string} pMessage
	 */
	_warn(pMessage)
	{
		if (this.log && (typeof this.log.warn === 'function'))
		{
			try
			{
				this.log.warn(`FormConcierge mirror: ${pMessage}`);
			}
			catch (pError)
			{
				// logging is best-effort
			}
		}
	}

	/**
	 * Run pWork after any earlier work on the same key (one sync per session at a time).
	 * @param {string} pKey
	 * @param {() => Promise<any>} pWork
	 * @return {Promise<any>}
	 */
	_withLock(pKey, pWork)
	{
		const tmpPrevious = this._locks[pKey] || Promise.resolve();
		const tmpRun = tmpPrevious.then(pWork, pWork);
		const tmpTail = tmpRun.then(() => null, () => null);
		this._locks[pKey] = tmpTail;
		tmpTail.then(() =>
		{
			if (this._locks[pKey] === tmpTail)
			{
				delete this._locks[pKey];
			}
		});
		return tmpRun;
	}

	/**
	 * A strictly increasing ISO stamp (two writes in one millisecond still verify distinctly).
	 * @return {string}
	 */
	_stamp()
	{
		let tmpNow = Number(this._now()) || Date.now();
		if (tmpNow <= this._lastStamp)
		{
			tmpNow = this._lastStamp + 1;
		}
		this._lastStamp = tmpNow;
		return new Date(tmpNow).toISOString();
	}

	// ── Readiness (form type) ───────────────────────────────────────────────────────────────────────────────

	/**
	 * Is the FormConcierge-Session form type installed for this customer (or globally)? Cached: a found or missing
	 * form type for the life of this mirror, a failed lookup for a minute.
	 * @return {Promise<{ Ready: boolean, IDReportNamedInstance?: number, Reason?: string }>}
	 */
	async checkReady()
	{
		try
		{
			const tmpCached = this._ready;
			if (tmpCached && (!tmpCached.Transient || ((this._now() - tmpCached.At) < READY_RETRY_MS)))
			{
				return Object.assign({}, tmpCached.Result);
			}
			if (!this._readyPromise)
			{
				this._readyPromise = this._lookupFormType().then((pReady) =>
				{
					this._ready = pReady;
					this._readyPromise = null;
					return pReady;
				}, (pError) =>
				{
					this._readyPromise = null;
					throw pError;
				});
			}
			const tmpReady = await this._readyPromise;
			return Object.assign({}, tmpReady.Result);
		}
		catch (pError)
		{
			return { Ready: false, Reason: `Not mirrored to Headlight: ${errorMessage(pError)}` };
		}
	}

	/**
	 * One lean RNI read (§5). The customer's own RNI wins over a global (customer 0) one.
	 * @return {Promise<{ Result: any, Transient: boolean, At: number }>}
	 */
	async _lookupFormType()
	{
		const tmpAt = this._now();
		const tmpCustomer = this.IDCustomer;
		if (!(tmpCustomer > 0) || (Math.floor(tmpCustomer) !== tmpCustomer))
		{
			return { Result: { Ready: false, Reason: 'Not mirrored to Headlight: there is no session customer.' }, Transient: true, At: tmpAt };
		}
		let tmpRows;
		try
		{
			tmpRows = await this._get(`ReportNamedInstances/LiteExtended/Hash,Name/FilteredTo/FBV~Hash~EQ~${RNI_HASH}~FBL~IDCustomer~INN~${tmpCustomer},0~FBV~Deleted~EQ~0/0/2`);
		}
		catch (pError)
		{
			return { Result: { Ready: false, Reason: `Not mirrored to Headlight: could not check the FormConcierge-Session form type (${errorMessage(pError)}).` }, Transient: true, At: tmpAt };
		}
		if (!Array.isArray(tmpRows))
		{
			return { Result: { Ready: false, Reason: 'Not mirrored to Headlight: the form type lookup answered unexpectedly.' }, Transient: true, At: tmpAt };
		}
		const tmpCandidates = tmpRows.filter((pRow) => isPlainObject(pRow) && (Number(pRow.IDReportNamedInstance) > 0) && (!pRow.Hash || (pRow.Hash === RNI_HASH)));
		const tmpRNI = tmpCandidates.filter((pRow) => Number(pRow.IDCustomer) === tmpCustomer)[0] || tmpCandidates.filter((pRow) => Number(pRow.IDCustomer) === 0)[0] || null;
		if (!tmpRNI)
		{
			return { Result: { Ready: false, Reason: NOT_INSTALLED_REASON }, Transient: false, At: tmpAt };
		}
		return { Result: { Ready: true, IDReportNamedInstance: Number(tmpRNI.IDReportNamedInstance) }, Transient: false, At: tmpAt };
	}

	// ── Deterministic-GUID location ─────────────────────────────────────────────────────────────────────────

	/**
	 * Walk the GUID suffixes from pFromIndex: a live row → use it; a GUID held only by a deleted row → next suffix;
	 * otherwise this GUID is free. A live-probe failure throws (never guess and risk a duplicate).
	 * @param {string} pBase - The deterministic GUID.
	 * @param {number} pFromIndex - First suffix index to try.
	 * @param {(pGUID: string) => Promise<any>} fProbeLive
	 * @param {(pGUID: string) => Promise<any>} fProbeAny - Includes soft-deleted rows.
	 * @return {Promise<{ Index: number, GUID: string, Row: any }|null>} null when every suffix is held by a deleted row.
	 */
	async _locateGUID(pBase, pFromIndex, fProbeLive, fProbeAny)
	{
		for (let i = pFromIndex; i < GUID_SUFFIXES.length; i++)
		{
			const tmpGUID = pBase + GUID_SUFFIXES[i];
			const tmpLive = await fProbeLive(tmpGUID);
			if (tmpLive)
			{
				return { Index: i, GUID: tmpGUID, Row: tmpLive };
			}
			let tmpHeld = false;
			try
			{
				tmpHeld = !!(await fProbeAny(tmpGUID));
			}
			catch (pError)
			{
				// best-effort: the create's duplicate-GUID refusal is the backstop
				tmpHeld = false;
			}
			if (!tmpHeld)
			{
				return { Index: i, GUID: tmpGUID, Row: null };
			}
		}
		return null;
	}

	/**
	 * Probe Projects by GUID.
	 * @param {string} pGUID
	 * @param {boolean} pIncludeDeleted
	 * @return {Promise<any>} The matching row or null.
	 */
	async _probeProject(pGUID, pIncludeDeleted)
	{
		const tmpRows = await this._get(`Projects/FilteredTo/FBV~GUIDProject~EQ~${encodeURIComponent(pGUID)}/0/2${pIncludeDeleted ? '?includeDeleted=true' : ''}`);
		if (!Array.isArray(tmpRows))
		{
			throw new Error('the project lookup answered unexpectedly');
		}
		return tmpRows.filter((pRow) => isPlainObject(pRow) && (Number(pRow.IDProject) > 0) &&
			((pRow.GUIDProject === undefined) || (pRow.GUIDProject === pGUID)) &&
			(pIncludeDeleted || (Number(pRow.Deleted) !== 1)))[0] || null;
	}

	/**
	 * Probe Documents by GUID (lean LiteExtended read; never pulls FormData).
	 * @param {string} pGUID
	 * @param {boolean} pIncludeDeleted
	 * @return {Promise<any>} The matching row or null.
	 */
	async _probeDocument(pGUID, pIncludeDeleted)
	{
		const tmpRows = await this._get(`Documents/LiteExtended/Name,DocumentType/FilteredTo/FBV~GUIDDocument~EQ~${encodeURIComponent(pGUID)}/0/1${pIncludeDeleted ? '?includeDeleted=true' : ''}`);
		if (!Array.isArray(tmpRows))
		{
			throw new Error('the document lookup answered unexpectedly');
		}
		return tmpRows.filter((pRow) => isPlainObject(pRow) && (Number(pRow.IDDocument) > 0) &&
			((pRow.GUIDDocument === undefined) || (pRow.GUIDDocument === pGUID)) &&
			(pIncludeDeleted || (Number(pRow.Deleted) !== 1)))[0] || null;
	}

	// ── Project + form link ─────────────────────────────────────────────────────────────────────────────────

	/**
	 * The sessions project (find-or-create, cached; concurrent callers share one attempt).
	 * @return {Promise<{ IDProject: number, GUIDProject: string }>}
	 */
	_ensureProject()
	{
		if (this._project)
		{
			return Promise.resolve(this._project);
		}
		if (!this._projectPromise)
		{
			this._projectPromise = this._findOrCreateProject().then((pProject) =>
			{
				this._project = pProject;
				this._projectPromise = null;
				return pProject;
			}, (pError) =>
			{
				this._projectPromise = null;
				throw pError;
			});
		}
		return this._projectPromise;
	}

	/**
	 * D12 find-or-create for `FormConcierge-<IDCustomer>-Sessions`.
	 * @return {Promise<{ IDProject: number, GUIDProject: string }>}
	 */
	async _findOrCreateProject()
	{
		const tmpBase = `FormConcierge-${this.IDCustomer}-Sessions`;
		const fLive = (/** @type {string} */ pGUID) => this._probeProject(pGUID, false);
		const fAny = (/** @type {string} */ pGUID) => this._probeProject(pGUID, true);
		let tmpFrom = 0;
		while (tmpFrom < GUID_SUFFIXES.length)
		{
			const tmpSpot = await this._locateGUID(tmpBase, tmpFrom, fLive, fAny);
			if (!tmpSpot)
			{
				break;
			}
			if (tmpSpot.Row)
			{
				return { IDProject: Number(tmpSpot.Row.IDProject), GUIDProject: tmpSpot.GUID };
			}
			let tmpCreated = null;
			let tmpError = null;
			try
			{
				tmpCreated = await this._post('Project', { GUIDProject: tmpSpot.GUID, Name: PROJECT_NAME, Status: PROJECT_STATUS, Description: PROJECT_DESCRIPTION });
			}
			catch (pError)
			{
				tmpError = pError;
			}
			// Read back: a refused write can still answer 200.
			const tmpBack = await fLive(tmpSpot.GUID);
			if (tmpBack)
			{
				return { IDProject: Number(tmpBack.IDProject), GUIDProject: tmpSpot.GUID };
			}
			if (isDuplicateGUIDError(tmpError))
			{
				tmpFrom = tmpSpot.Index + 1;
				continue;
			}
			throw new Error(`Headlight refused to create the Form Concierge sessions project${tmpError ? `: ${errorMessage(tmpError)}` : (tmpCreated ? ' (the write did not stick)' : '')}`);
		}
		throw new Error('every Form Concierge sessions project GUID (base, -2, -3) is held by a deleted project');
	}

	/**
	 * Ensure the RNI ↔ project join (no Deleted column on this table, so no Deleted filter). Cached once verified.
	 * @param {number} pIDProject
	 * @param {number} pIDReportNamedInstance
	 * @return {Promise<boolean>}
	 */
	async _ensureFormLink(pIDProject, pIDReportNamedInstance)
	{
		const tmpKey = `${pIDProject}:${pIDReportNamedInstance}`;
		if (this._formLinkKey === tmpKey)
		{
			return true;
		}
		const tmpURL = `ReportNamedInstanceProjectJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}~FBV~IDReportNamedInstance~EQ~${pIDReportNamedInstance}/0/1`;
		const fProbe = async () =>
		{
			const tmpRows = await this._get(tmpURL);
			if (!Array.isArray(tmpRows))
			{
				throw new Error('the form link lookup answered unexpectedly');
			}
			return tmpRows.filter((pRow) => isPlainObject(pRow) &&
				((pRow.IDProject === undefined) || (Number(pRow.IDProject) === pIDProject)) &&
				((pRow.IDReportNamedInstance === undefined) || (Number(pRow.IDReportNamedInstance) === pIDReportNamedInstance))).length > 0;
		};
		if (await fProbe())
		{
			this._formLinkKey = tmpKey;
			return true;
		}
		let tmpError = null;
		try
		{
			await this._post('ReportNamedInstanceProjectJoin', { IDReportNamedInstance: pIDReportNamedInstance, IDProject: pIDProject });
		}
		catch (pError)
		{
			tmpError = pError;
		}
		if (await fProbe())
		{
			this._formLinkKey = tmpKey;
			return true;
		}
		throw new Error(`could not join the FormConcierge-Session form to the sessions project${tmpError ? `: ${errorMessage(tmpError)}` : ''}`);
	}

	// ── Session sync ────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Mirror one session (the GET Session payload) into its Headlight Document. Never rejects.
	 * @param {any} pPayload - GET Session response.
	 * @param {{ Files?: Array<{ Name: string, MimeType: string, Size: number, IDMedia: number, Converted: any, Role: string }>, TaskName?: string }} [pExtras]
	 * @return {Promise<{ IDDocument: number, Created: boolean, Skipped: boolean, Reason?: string, Unchanged?: boolean, Warnings?: Array<string> }>}
	 */
	async syncSession(pPayload, pExtras)
	{
		let tmpGUIDRequest = '';
		try
		{
			const tmpSession = (pPayload && isPlainObject(pPayload.Session)) ? pPayload.Session : null;
			if (!tmpSession)
			{
				return { IDDocument: 0, Created: false, Skipped: true, Reason: 'Not mirrored to Headlight: the session could not be read.' };
			}
			tmpGUIDRequest = String(tmpSession.GUIDRequest || '');
			if (!GUID_PATTERN.test(tmpGUIDRequest))
			{
				return { IDDocument: 0, Created: false, Skipped: true, Reason: 'Not mirrored to Headlight: the session has no usable GUIDRequest.' };
			}
			return await this._withLock(tmpGUIDRequest, () => this._syncLocked(pPayload, pExtras || {}, tmpGUIDRequest));
		}
		catch (pError)
		{
			const tmpRecord = tmpGUIDRequest ? this._docs[tmpGUIDRequest] : null;
			this._warn(errorMessage(pError));
			return { IDDocument: (tmpRecord && tmpRecord.IDDocument) || 0, Created: false, Skipped: true, Reason: `Not mirrored to Headlight: ${errorMessage(pError)}` };
		}
	}

	/**
	 * The sync body, serialized per session by syncSession.
	 * @param {any} pPayload
	 * @param {Record<string, any>} pExtras
	 * @param {string} pGUIDRequest
	 * @return {Promise<{ IDDocument: number, Created: boolean, Skipped: boolean, Reason?: string, Unchanged?: boolean, Warnings?: Array<string> }>}
	 */
	async _syncLocked(pPayload, pExtras, pGUIDRequest)
	{
		const tmpRecord = this._docs[pGUIDRequest] || (this._docs[pGUIDRequest] = { IDDocument: 0, GUIDDocument: '', IDProject: 0, Key: '', Status: '', Files: [], FilesLoaded: false });
		if (Array.isArray(pExtras.Files))
		{
			tmpRecord.Files = mergeFiles(tmpRecord.Files, normalizeFiles(pExtras.Files));
		}
		const tmpKey = `${FormConciergeMirror.signature(pPayload)}#${JSON.stringify(tmpRecord.Files)}`;
		if (tmpRecord.IDDocument && (tmpRecord.Key === tmpKey))
		{
			return { IDDocument: tmpRecord.IDDocument, Created: false, Skipped: false, Unchanged: true };
		}

		const tmpReady = await this.checkReady();
		if (!tmpReady.Ready)
		{
			return { IDDocument: tmpRecord.IDDocument || 0, Created: false, Skipped: true, Reason: tmpReady.Reason || NOT_INSTALLED_REASON };
		}
		const tmpProject = await this._ensureProject();
		/** @type {Array<string>} */
		const tmpWarnings = [];
		try
		{
			await this._ensureFormLink(tmpProject.IDProject, Number(tmpReady.IDReportNamedInstance));
		}
		catch (pError)
		{
			// The data still mirrors; it only renders with the project's first form until the join exists (retried next sync).
			tmpWarnings.push('FormLinkMissing');
			this._warn(errorMessage(pError));
		}

		const tmpWritten = await this._writeDocument(pPayload, pExtras, pGUIDRequest, tmpRecord, tmpProject);
		tmpRecord.Key = tmpKey;
		tmpRecord.Status = tmpWritten.Status;
		/** @type {{ IDDocument: number, Created: boolean, Skipped: boolean, Warnings?: Array<string> }} */
		const tmpResult = { IDDocument: tmpRecord.IDDocument, Created: tmpWritten.Created, Skipped: false };
		if (tmpWarnings.length)
		{
			tmpResult.Warnings = tmpWarnings;
		}
		return tmpResult;
	}

	/**
	 * Locate (or create) the session's Document and write FormData, verifying every write by reading it back.
	 * A cached document that vanished (deleted under us) is re-located once.
	 * @param {any} pPayload
	 * @param {Record<string, any>} pExtras
	 * @param {string} pGUIDRequest
	 * @param {Record<string, any>} pRecord - The per-session cache entry (updated in place).
	 * @param {{ IDProject: number }} pProject
	 * @return {Promise<{ Created: boolean, Status: string }>}
	 */
	async _writeDocument(pPayload, pExtras, pGUIDRequest, pRecord, pProject)
	{
		const tmpBase = FormConciergeMirror.documentGUID(pGUIDRequest);
		const fLive = (/** @type {string} */ pGUID) => this._probeDocument(pGUID, false);
		const fAny = (/** @type {string} */ pGUID) => this._probeDocument(pGUID, true);
		/** @param {string} pStamp */
		const fBuild = (pStamp) => FormConciergeMirror.buildFormData(pPayload, { Files: pRecord.Files, Environment: this.Environment, MirroredAt: pStamp, TaskName: pExtras.TaskName });

		for (let tmpPass = 0; tmpPass < 2; tmpPass++)
		{
			let tmpCreated = false;
			if (!pRecord.IDDocument)
			{
				let tmpFrom = 0;
				while (!pRecord.IDDocument)
				{
					const tmpSpot = await this._locateGUID(tmpBase, tmpFrom, fLive, fAny);
					if (!tmpSpot)
					{
						throw new Error('every mirror document GUID (base, -2, -3) is held by a deleted document');
					}
					if (tmpSpot.Row)
					{
						pRecord.IDDocument = Number(tmpSpot.Row.IDDocument);
						pRecord.GUIDDocument = tmpSpot.GUID;
						pRecord.IDProject = Number(tmpSpot.Row.IDProject) || pProject.IDProject;
						pRecord.FilesLoaded = false;
						break;
					}
					const tmpFormData = fBuild(this._stamp());
					let tmpCreateError = null;
					try
					{
						await this._post('Document', this._documentRecord(tmpFormData, { GUIDDocument: tmpSpot.GUID, IDProject: pProject.IDProject, DocumentDate: this._documentDate(pPayload) }));
					}
					catch (pError)
					{
						tmpCreateError = pError;
					}
					const tmpBack = await fLive(tmpSpot.GUID);
					if (tmpBack)
					{
						pRecord.IDDocument = Number(tmpBack.IDDocument);
						pRecord.GUIDDocument = tmpSpot.GUID;
						pRecord.IDProject = pProject.IDProject;
						pRecord.FilesLoaded = true;
						tmpCreated = true;
						const tmpCheck = await this._verifyDocument(pRecord.IDDocument, tmpSpot.GUID, tmpFormData.Session.MirroredAt);
						if (tmpCheck.OK)
						{
							return { Created: true, Status: tmpFormData.Session.Status };
						}
						// Created, but the FormData didn't stick: fall through to the update path below.
						break;
					}
					if (isDuplicateGUIDError(tmpCreateError))
					{
						tmpFrom = tmpSpot.Index + 1;
						continue;
					}
					throw new Error(`Headlight refused to create the mirror document${tmpCreateError ? `: ${errorMessage(tmpCreateError)}` : ' (the write did not stick)'}`);
				}
			}

			if (!pRecord.FilesLoaded)
			{
				// First write to an existing document in this session: keep the Files it already lists.
				try
				{
					const tmpExisting = await this._get(`Document/${pRecord.IDDocument}`);
					pRecord.Files = mergeFiles(normalizeFiles(documentFormData(tmpExisting).Files), pRecord.Files);
					pRecord.FilesLoaded = true;
				}
				catch (pError)
				{
					// verification below decides whether the document is still there
				}
			}
			const tmpFormData = fBuild(this._stamp());
			let tmpPutError = null;
			try
			{
				await this._put('Document', this._documentRecord(tmpFormData, { IDDocument: pRecord.IDDocument, IDProject: pRecord.IDProject || pProject.IDProject }));
			}
			catch (pError)
			{
				tmpPutError = pError;
			}
			const tmpCheck = await this._verifyDocument(pRecord.IDDocument, pRecord.GUIDDocument, tmpFormData.Session.MirroredAt);
			if (tmpCheck.OK)
			{
				return { Created: tmpCreated, Status: tmpFormData.Session.Status };
			}
			if (tmpCheck.Gone && (tmpPass === 0) && !tmpCreated)
			{
				pRecord.IDDocument = 0;
				pRecord.GUIDDocument = '';
				pRecord.FilesLoaded = false;
				continue;
			}
			throw new Error(tmpPutError ? `Headlight refused the mirror update: ${errorMessage(tmpPutError)}` : 'Headlight did not keep the mirror update (the read-back did not match)');
		}
		throw new Error('the mirror document could not be written');
	}

	/**
	 * The Document body for a POST/PUT. FormData goes as an OBJECT; Description records the mirrored status so
	 * reconcile can spot a stale mirror from a lean list read.
	 * @param {Record<string, any>} pFormData
	 * @param {Record<string, any>} pFields - GUIDDocument/IDProject/DocumentDate (create) or IDDocument/IDProject (update).
	 * @return {Record<string, any>}
	 */
	_documentRecord(pFormData, pFields)
	{
		const tmpSession = pFormData.Session;
		const tmpNumber = tmpSession.RequestNumber || tmpSession.IDRequest;
		let tmpName = tmpSession.Title;
		const tmpSuffix = tmpNumber ? ` (#${tmpNumber})` : '';
		if ((tmpName.length + tmpSuffix.length) > DOCUMENT_NAME_MAX)
		{
			tmpName = tmpName.slice(0, Math.max(0, DOCUMENT_NAME_MAX - tmpSuffix.length - 1)).trim() + '…';
		}
		return Object.assign({}, pFields,
			{
				Name: (tmpName + tmpSuffix).slice(0, DOCUMENT_NAME_MAX),
				DocumentType: DOCUMENT_TYPE,
				Form: 1,
				FormData: pFormData,
				Description: `Form Concierge session mirror: plansheet request ${tmpSession.IDRequest}. Status: ${tmpSession.Status || 'Unknown'}`,
			});
	}

	/**
	 * DocumentDate = the Request's CreateDate when it parses, else now.
	 * @param {any} pPayload
	 * @return {string}
	 */
	_documentDate(pPayload)
	{
		const tmpMillis = toMillis(pPayload && pPayload.Session && pPayload.Session.CreateDate);
		return new Date(tmpMillis || this._now()).toISOString();
	}

	/**
	 * Read the Document back and check it holds THIS write (GUID + FormData.Session.MirroredAt).
	 * @param {number} pIDDocument
	 * @param {string} pGUID
	 * @param {string} pStamp
	 * @return {Promise<{ OK: boolean, Gone: boolean }>}
	 */
	async _verifyDocument(pIDDocument, pGUID, pStamp)
	{
		let tmpDocument;
		try
		{
			tmpDocument = await this._get(`Document/${Number(pIDDocument)}`);
		}
		catch (pError)
		{
			return { OK: false, Gone: true };
		}
		if (!isPlainObject(tmpDocument) || (Number(tmpDocument.IDDocument) !== Number(pIDDocument)) || (Number(tmpDocument.Deleted) === 1) ||
			(pGUID && tmpDocument.GUIDDocument && (tmpDocument.GUIDDocument !== pGUID)))
		{
			return { OK: false, Gone: true };
		}
		const tmpSession = documentFormData(tmpDocument).Session;
		return { OK: !!(tmpSession && (tmpSession.MirroredAt === pStamp)), Gone: false };
	}

	// ── Reconcile ───────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Catch up mirrors for sessions that finished while nobody had them open (D12): ONE lean Documents read for the
	 * listed sessions, then at most 5 sequential fetch+sync for sessions whose document is missing or stale.
	 * Never rejects; a call while one is running shares it.
	 * @param {Array<any>} pSessions - GET Sessions rows.
	 * @param {(pIDRequest: number) => Promise<any>} pFetchSession - Resolves a GET Session payload.
	 * @return {Promise<{ Synced: number, Errors: number, Checked: number, Failures: Array<{ IDRequest: number, Reason: string }>, Reason?: string }>}
	 */
	reconcile(pSessions, pFetchSession)
	{
		if (this._reconcilePromise)
		{
			return this._reconcilePromise;
		}
		const tmpRun = this._reconcile(pSessions, pFetchSession).then((pResult) => pResult, (pError) =>
		{
			this._warn(errorMessage(pError));
			return { Synced: 0, Errors: 1, Checked: 0, Failures: [ { IDRequest: 0, Reason: errorMessage(pError) } ] };
		});
		this._reconcilePromise = tmpRun.then((pResult) =>
		{
			this._reconcilePromise = null;
			return pResult;
		});
		return this._reconcilePromise;
	}

	/**
	 * @param {Array<any>} pSessions
	 * @param {(pIDRequest: number) => Promise<any>} pFetchSession
	 * @return {Promise<{ Synced: number, Errors: number, Checked: number, Failures: Array<{ IDRequest: number, Reason: string }>, Reason?: string }>}
	 */
	async _reconcile(pSessions, pFetchSession)
	{
		/** @type {{ Synced: number, Errors: number, Checked: number, Failures: Array<{ IDRequest: number, Reason: string }>, Reason?: string }} */
		const tmpResult = { Synced: 0, Errors: 0, Checked: 0, Failures: [] };
		const tmpRows = (Array.isArray(pSessions) ? pSessions : [])
			.filter((pRow) => isPlainObject(pRow) && (Number(pRow.IDRequest) > 0) && GUID_PATTERN.test(String(pRow.GUIDRequest || '')))
			.slice(0, RECONCILE_PROBE_CAP);
		if (tmpRows.length < 1)
		{
			return tmpResult;
		}
		if (typeof pFetchSession !== 'function')
		{
			tmpResult.Reason = 'no session fetcher';
			return tmpResult;
		}
		const tmpReady = await this.checkReady();
		if (!tmpReady.Ready)
		{
			tmpResult.Reason = tmpReady.Reason;
			return tmpResult;
		}

		/** @param {any} pRow */
		const fGUIDFor = (pRow) =>
		{
			const tmpRecord = this._docs[String(pRow.GUIDRequest)];
			return (tmpRecord && tmpRecord.GUIDDocument) ? tmpRecord.GUIDDocument : FormConciergeMirror.documentGUID(pRow.GUIDRequest);
		};
		/** @type {Array<string>} */
		const tmpGUIDs = [];
		tmpRows.forEach((pRow) =>
		{
			const tmpGUID = fGUIDFor(pRow);
			if (tmpGUIDs.indexOf(tmpGUID) < 0)
			{
				tmpGUIDs.push(tmpGUID);
			}
		});
		let tmpDocuments;
		try
		{
			tmpDocuments = await this._get(`Documents/LiteExtended/Name,DocumentType,Description/FilteredTo/FBL~GUIDDocument~INN~${tmpGUIDs.map((pGUID) => encodeURIComponent(pGUID)).join(',')}~FBV~Deleted~EQ~0/0/${RECONCILE_PROBE_CAP}`);
		}
		catch (pError)
		{
			tmpResult.Errors = 1;
			tmpResult.Failures.push({ IDRequest: 0, Reason: errorMessage(pError) });
			return tmpResult;
		}
		if (!Array.isArray(tmpDocuments))
		{
			tmpResult.Errors = 1;
			tmpResult.Failures.push({ IDRequest: 0, Reason: 'the mirror lookup answered unexpectedly' });
			return tmpResult;
		}
		/** @type {Record<string, any>} */
		const tmpByGUID = {};
		tmpDocuments.forEach((pDocument) =>
		{
			if (isPlainObject(pDocument) && (typeof pDocument.GUIDDocument === 'string') && (Number(pDocument.IDDocument) > 0))
			{
				tmpByGUID[pDocument.GUIDDocument] = pDocument;
			}
		});

		tmpResult.Checked = tmpRows.length;
		/** @type {Array<any>} */
		const tmpStale = [];
		tmpRows.forEach((pRow) =>
		{
			if (tmpStale.length >= RECONCILE_SYNC_CAP)
			{
				return;
			}
			const tmpGUIDRequest = String(pRow.GUIDRequest);
			const tmpGUID = fGUIDFor(pRow);
			const tmpDocument = tmpByGUID[tmpGUID];
			const tmpRecord = this._docs[tmpGUIDRequest];
			const tmpStatus = cleanLine(pRow.Status, 32);
			if (!tmpDocument)
			{
				if (tmpRecord)
				{
					// The cached document is gone (deleted) — forget it so the sync re-locates.
					tmpRecord.IDDocument = 0;
					tmpRecord.GUIDDocument = '';
					tmpRecord.Key = '';
					tmpRecord.FilesLoaded = false;
				}
				tmpStale.push(pRow);
				return;
			}
			if (!tmpRecord)
			{
				// Seed the cache so the sync skips the GUID probes.
				this._docs[tmpGUIDRequest] = { IDDocument: Number(tmpDocument.IDDocument), GUIDDocument: tmpGUID, IDProject: Number(tmpDocument.IDProject) || 0, Key: '', Status: '', Files: [], FilesLoaded: false };
			}
			else if (tmpRecord.Key && (tmpRecord.Status === tmpStatus))
			{
				// Already mirrored at this status by this screen.
				return;
			}
			const tmpRecorded = recordedStatus(tmpDocument.Description);
			if (tmpRecorded && (tmpRecorded !== tmpStatus))
			{
				tmpStale.push(pRow);
				return;
			}
			const tmpAnswered = toMillis(pRow.AnsweredDate);
			const tmpUpdated = toMillis(tmpDocument.UpdateDate);
			if (tmpAnswered && tmpUpdated && (tmpAnswered > tmpUpdated))
			{
				tmpStale.push(pRow);
			}
		});

		for (let i = 0; i < tmpStale.length; i++)
		{
			const tmpIDRequest = Number(tmpStale[i].IDRequest);
			let tmpPayload;
			try
			{
				tmpPayload = await pFetchSession(tmpIDRequest);
			}
			catch (pError)
			{
				tmpResult.Errors++;
				tmpResult.Failures.push({ IDRequest: tmpIDRequest, Reason: errorMessage(pError) });
				continue;
			}
			const tmpSync = await this.syncSession(tmpPayload);
			if (tmpSync.Skipped)
			{
				tmpResult.Errors++;
				tmpResult.Failures.push({ IDRequest: tmpIDRequest, Reason: tmpSync.Reason || 'skipped' });
			}
			else
			{
				tmpResult.Synced++;
			}
		}
		return tmpResult;
	}
}

module.exports = { FormConciergeMirror };

},{}],1279:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
// The app's segmented CodeMirror markdown editor (same component the Support composer uses). Subclassed below so the
// concierge's boxes never inline a dropped/pasted file as text or a base64 data: URI, and never preview an <img>.
const libMarkdownEditor = require('pict-section-markdowneditor');

const FLOWS = [ 'create', 'update', 'examples', 'build' ];

// Composer chrome per flow. Every string here is ours (safe to put in HTML and in the picker's pict templates).
const FLOW_META =
{
	create:   { Label: 'Create a form',     Icon: 'fa-file-circle-plus', Go: 'Create the form',   EditorLabel: 'Describe the form you need' },
	update:   { Label: 'Update a form',     Icon: 'fa-pen-to-square',    Go: 'Send the update',   EditorLabel: 'What should change?' },
	examples: { Label: 'Generate examples', Icon: 'fa-vials',            Go: 'Generate examples', EditorLabel: 'Anything specific about the examples? (optional)' },
	build:    { Label: 'Build & deliver',   Icon: 'fa-truck-ramp-box',   Go: 'Build & deliver',   EditorLabel: 'Notes for the build (optional)' },
};

// Session.Flow (the façade's label) → chip text. Unknown values are escaped and shown as-is.
const FLOW_CHIP = { create: 'Create', author: 'Create', update: 'Update', modify: 'Update', build: 'Build & deliver', config: 'Build & deliver', examples: 'Examples' };

// Run phase (see runPhase) → chip/status chrome.
const PHASE_META =
{
	answered:              { Chip: 'Answered',          Cls: 'fcg-st-ok',   Icon: 'fa-circle-check' },
	failed:                { Chip: 'Failed',            Cls: 'fcg-st-err',  Icon: 'fa-circle-exclamation' },
	cancelled:             { Chip: 'Cancelled',         Cls: 'fcg-st-off',  Icon: 'fa-ban' },
	'cancelled-unstarted': { Chip: 'Cancelled',         Cls: 'fcg-st-off',  Icon: 'fa-ban' },
	notpickedup:           { Chip: 'Not picked up',     Cls: 'fcg-st-warn', Icon: 'fa-plug-circle-exclamation' },
	cancelling:            { Chip: 'Cancelling',        Cls: 'fcg-st-warn', Icon: 'fa-hourglass-half' },
	stalled:               { Chip: 'Stalled?',          Cls: 'fcg-st-warn', Icon: 'fa-triangle-exclamation' },
	working:               { Chip: 'Working',           Cls: 'fcg-st-run',  Icon: 'fa-gears' },
	starting:              { Chip: 'Starting',          Cls: 'fcg-st-run',  Icon: 'fa-circle-notch' },
	waiting:               { Chip: 'Waiting',           Cls: 'fcg-st-run',  Icon: 'fa-hourglass-start' },
};

// Sessions-list Status (plansheet Request.Status, plus the façade's NotPickedUp) → chip chrome.
const SESSION_STATUS_META =
{
	Pending:     { Chip: 'Pending',       Cls: 'fcg-st-run' },
	Running:     { Chip: 'Running',       Cls: 'fcg-st-run' },
	Answered:    { Chip: 'Answered',      Cls: 'fcg-st-ok' },
	Failed:      { Chip: 'Failed',        Cls: 'fcg-st-err' },
	Cancelled:   { Chip: 'Cancelled',     Cls: 'fcg-st-off' },
	NotPickedUp: { Chip: 'Not picked up', Cls: 'fcg-st-warn' },
};

// Friendly text for the façade's error codes (§3 + amendment B/C). Everything else falls back to the error message.
const ERROR_TEXT =
{
	NodeBusy: 'The plansheet node is busy with another request. Try again when it finishes.',
	RunInProgress: 'This session still has a run in progress.',
	NotDelivered: 'This form has not been delivered (pushed) to Headlight yet. Build & deliver it first.',
	NoConfigSession: 'This form has no answered Build & deliver session yet, so there is nothing to seed examples from.',
	TextRequired: 'Describe the change you want first.',
	DeliveryTargetRequired: 'Say where to deliver the form, or tick Validate only.',
	NoBlueprint: 'This form has no agreed blueprint yet.',
	CorpusTooLarge: 'This form\'s sources are over the 1.5 MB text budget. Remove or trim some sources first.',
	ShapeUnavailable: 'Plansheet\'s prompt shape for this task could not be read, so nothing was started.',
	InputDropped: 'Plansheet dropped the request text, so the run was cancelled. Nothing else was changed.',
	PlansheetAuthFailed: 'Plansheet rejected the concierge\'s credentials (a server configuration problem).',
	PlansheetUnavailable: 'Plansheet is not answering right now. Try again in a minute.',
	PlansheetUserMismatch: 'This session belongs to a different plansheet user than this environment\'s token.',
	NotConfigured: 'Form Concierge is not configured on this server.',
	NotLoggedIn: 'Your Headlight session has expired. Sign in again.',
	NotAllowed: 'Form Concierge is for platform super-users only.',
	BadOrigin: 'The request was refused (cross-origin check).',
	AlreadyClaimed: 'That plansheet project is already claimed by Form Concierge (here or in another environment).',
	NotFound: 'Not found, or not one of this customer\'s Concierge forms.',
	NetworkError: 'The network request failed. Check your connection and try again.',
	Aborted: 'The upload was cancelled.',
};

// Error codes after which a session poll gives up (nothing a retry can fix).
const POLL_FATAL_CODES = [ 'NotFound', 'NotAllowed', 'NotLoggedIn', 'NotConfigured', 'PlansheetUserMismatch', 'BadOrigin' ];

const MB = 1024 * 1024;
const MAX_UPLOAD_BYTES = 25 * MB;         // façade upload cap (B6)
const REFERENCE_MAX_BYTES = 5 * MB;       // a binary with no extracted text is linked as a Reference only up to this (C8)
const MAX_CONCURRENT_UPLOADS = 2;         // D5 / B6
const MAX_SOURCES_PER_CALL = 25;          // façade Sources cap (B5)

const POLL_FAST_MS = 5000;
const POLL_MID_MS = 15000;
const POLL_SLOW_MS = 30000;
const POLL_FAST_UNTIL_MS = 2 * 60 * 1000;
const POLL_MID_UNTIL_MS = 10 * 60 * 1000;
const POLL_CAP_MS = 60 * 60 * 1000;       // D11: from the last explicit user action
const TICK_MS = 1000;

const STARTING_MS = 90 * 1000;            // unclaimed and younger than this → "Starting…"
const STALL_MS = 10 * 60 * 1000;          // claimed, no heartbeat for this long → "Stalled?"

const USER_WAIT_TRIES = 40;               // Support's CurrentUser wait: 150 ms × 40, then fail closed
const USER_WAIT_MS = 150;

const SESSION_LIST_SHOW = 30;
const PICKER_PAGE = 60;
const PICKER_HASH = 'FormConcierge-FormPicker';

const GROUP_INDEXED = 'Concierge forms';
const GROUP_UNINDEXED = 'Plansheet, not yet in Concierge';

// The two markdown boxes (D6): unique view ids, mounts and data addresses.
const EDITORS =
{
	composer: { ViewID: 'FormConcierge-Composer-Editor', Mount: '#FCG-Editor-Mount', Address: 'AppData.FormConcierge.ComposerSegments', Key: 'ComposerSegments', Draft: '_draft' },
	followup: { ViewID: 'FormConcierge-FollowUp-Editor', Mount: '#FCG-FU-Editor-Mount', Address: 'AppData.FormConcierge.FollowUpSegments', Key: 'FollowUpSegments', Draft: '_followDraft' },
};

// File regions per staging context.
const FILE_REGIONS = { composer: '#FCG-Files', followup: '#FCG-FU-Files' };

// Fallbacks for the shared steering constants (C1) when the Markdown module does not supply them.
const DEFAULT_EXAMPLES_PREFIX = '[examples] ';
const DEFAULT_STEERING_MARKER = '\n\n---\nForm Concierge steering:\n';
const DEFAULT_REVISION_PREFIX = '[revision] ';

/**
 * The sibling Form Concierge modules, loaded on first use (tests inject fakes through provider._deps instead).
 * @return {{ Api: any, Markdown: any, FileText: any, Mirror: any }}
 */
function loadDefaultDeps()
{
	return {
		Api: require('./FormConcierge-Api.js'),
		Markdown: require('./FormConcierge-Markdown.js'),
		FileText: require('./FormConcierge-FileText.js'),
		Mirror: require('./FormConcierge-Mirror.js'),
	};
}

/**
 * The concierge's markdown box: pict-section-markdowneditor with every file path (image paste, file drop, the image
 * picker) handed to the screen's drop zone, which uploads it like any other source file.
 */
class FormConciergeMarkdownEditor extends libMarkdownEditor
{
	/**
	 * A pasted or dropped image goes to the drop zone; the editor never inlines it as a data: URI.
	 * @param {File} pFile - The image file.
	 * @param {number} pSegmentIndex - Segment index (unused; there is one segment).
	 * @param {function} fCallback - Editor callback (never called: no image markdown is inserted).
	 * @returns {boolean} Always true (handled).
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		const tmpSelf = /** @type {any} */ (this);
		const tmpHost = tmpSelf.pict && tmpSelf.pict.providers && tmpSelf.pict.providers.FormConcierge;
		if (pFile && tmpHost && (typeof tmpHost.addFiles === 'function'))
		{
			tmpHost.addFiles([ pFile ], tmpSelf.options.FCGContext);
		}
		return true;
	}

	/**
	 * Put a file-drop handler FIRST in the CodeMirror handler chain, so a dropped file (any type, any count) reaches
	 * the drop zone instead of CodeMirror's default read-as-text insert or the editor's own first-image-only handler.
	 * Text drags (no files) fall through to the normal behaviour.
	 * @param {Array} pExtensions - The extensions array to modify.
	 * @param {number} pSegmentIndex - The segment index.
	 * @returns {Array} The modified extensions array.
	 */
	customConfigureExtensions(pExtensions, pSegmentIndex)
	{
		const tmpSelf = /** @type {any} */ (this);
		const tmpCM = tmpSelf._codeMirrorModules;
		if (!Array.isArray(pExtensions) || !tmpCM || !tmpCM.EditorView || (typeof tmpCM.EditorView.domEventHandlers !== 'function'))
		{
			return pExtensions;
		}
		pExtensions.unshift(tmpCM.EditorView.domEventHandlers(
			{
				drop: (pEvent) =>
				{
					const tmpFiles = pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files;
					if (!tmpFiles || !tmpFiles.length)
					{
						return false;
					}
					pEvent.preventDefault();
					// The editor's container-level listener would otherwise forward the first image a second time.
					pEvent.stopPropagation();
					const tmpHost = tmpSelf.pict && tmpSelf.pict.providers && tmpSelf.pict.providers.FormConcierge;
					if (tmpHost && (typeof tmpHost.addFiles === 'function'))
					{
						tmpHost.addFiles(tmpFiles, tmpSelf.options.FCGContext);
					}
					return true;
				},
			}));
		return pExtensions;
	}
}

/**
 * FormConciergeProvider — the #/FormConcierge screen (super-users only). Drop files, type one markdown request, press
 * Go, and hold a conversation with the plansheet form pipeline through the same-origin façade (/formconcierge/1.0/).
 * Flows: create (Author task on a new form project), update (Author task on an existing one), build (Config task:
 * build & deliver), examples (a follow-up on the form's delivered config session). Sessions are plansheet Requests,
 * mirrored into Headlight as FormConcierge-Session Documents.
 *
 * Painting is region-based (contract D7): the host skeleton is painted once per mode, and each region repaints only
 * itself — the mounted editor, picker and file list never get torn down by a status change. Every upstream string
 * (assistant AND user turns, names, metadata, guidance, errors) is untrusted: it goes through
 * FormConcierge-Markdown or _esc()/textContent, never a pict template. Inline handlers carry only Number()-coerced
 * ids or fixed literals; copy buttons resolve through an index into provider state.
 */
class FormConciergeProvider extends libPictProvider
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {any} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		/** @type {any} */
		this._deps = null;
		this._initState();
	}

	/**
	 * Reset every piece of instance state (the constructor calls this; prototype-built test instances call it too).
	 */
	_initState()
	{
		this._mount = '#FormConcierge-Host';
		/** @type {any} */
		this._api = null;
		this._loadGen = 0;
		this._userWait = 0;
		/** @type {any} */
		this._pendingApply = null;
		/** @type {any} the last route applied (a Retry after a failed load re-applies it, not Home) */
		this._lastApply = null;
		this._locked = false;
		this._statusLoaded = false;
		/** @type {any} */
		this._status = null;
		/** @type {any} */
		this._nodeBusy = null;
		this._workspaceReady = false;
		/** @type {any} */
		this._forms = null;
		this._formsError = '';
		/** @type {any} */
		this._sessions = null;
		this._sessionsError = '';
		this._sessionsLoading = false;
		this._showAllSessions = false;
		/** @type {any} */
		this._mirror = null;
		/** @type {any} */
		this._mirrorReady = null;
		/** @type {any} */
		this._mirrorReadyPromise = null;
		/** @type {Record<string, any>} */
		this._mirrorState = {};
		/** @type {Record<string, string>} */
		this._mirroredSig = {};
		/** @type {Record<string, Array<any>>} */
		this._sessionFiles = {};
		this._paintedMode = '';
		this._draft = '';
		this._followDraft = '';
		this._followFor = 0;
		this._formName = '';
		this._deliverTo = '';
		this._validateOnly = false;
		/** @type {{ composer: Array<any>, followup: Array<any> }} */
		this._stage = { composer: [], followup: [] };
		this._fileSeq = 0;
		/** @type {any} */
		this._session = null;
		this._threadSig = '';
		this._runKey = '';
		this._headKey = '';
		/** @type {any} */
		this._phase = null;
		/** @type {Record<string, boolean>} */
		this._openDetails = {};
		/** @type {Array<string>} */
		this._copyables = [];
		this._pollGen = 0;
		/** @type {any} */
		this._pollTimer = null;
		/** @type {any} */
		this._tickTimer = null;
		this._pollToken = -1;
		this._pollCapStart = 0;
		this._pollCapped = false;
		this._pollError = '';
		/** @type {any} */
		this._visHandler = null;
		this._skew = 0;
		/** @type {any} */
		this._hostListenerEl = null;
	}

	// ── Collaborators ──────────────────────────────────────────────────────────────────────────────────────────

	/** @return {any} the injected (tests) or real sibling modules */
	get deps()
	{
		if (!this._deps)
		{
			this._deps = loadDefaultDeps();
		}
		return this._deps;
	}

	/** @return {any} the façade client (one per provider) */
	get api()
	{
		if (!this._api)
		{
			const tmpApiModule = this.deps.Api;
			const tmpClass = (tmpApiModule && tmpApiModule.FormConciergeApi) || tmpApiModule;
			this._api = new tmpClass({});
		}
		return this._api;
	}

	/** @return {any} the strict remote-markdown module */
	get md() { return this.deps.Markdown || {}; }

	/** @return {any} */
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	/** @return {any} */
	get modal() { return this.pict.views && this.pict.views['Pict-Section-Modal']; }

	/** @return {any} */
	get pickerProvider() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }

	/** @return {number} the session customer */
	get idCustomer() { return Number((this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0); }

	/** @return {any} the screen state (AppData.FormConcierge; also holds the editors' segment arrays) */
	get state()
	{
		if (!this.pict.AppData.FormConcierge)
		{
			this.pict.AppData.FormConcierge =
			{
				Mode: 'home', Flow: 'create', IDProject: 0, IDRequest: 0,
				Loading: false, Error: '', Busy: false, BusyText: '', SendBusy: false,
				ComposerSegments: [ { Content: '' } ], FollowUpSegments: [ { Content: '' } ], PickedForm: '',
			};
		}
		return this.pict.AppData.FormConcierge;
	}

	// ── Small helpers ──────────────────────────────────────────────────────────────────────────────────────────

	/** @return {number} wall-clock ms (injectable for tests) */
	_now()
	{
		const tmpDeps = this._deps || {};
		return (typeof tmpDeps.now === 'function') ? tmpDeps.now() : Date.now();
	}

	/**
	 * setTimeout through the injectable clock.
	 * @param {Function} fCallback
	 * @param {number} pMs
	 * @return {any} handle
	 */
	_setTimer(fCallback, pMs)
	{
		const tmpDeps = this._deps || {};
		return (typeof tmpDeps.setTimeout === 'function') ? tmpDeps.setTimeout(fCallback, pMs) : setTimeout(fCallback, pMs);
	}

	/**
	 * clearTimeout through the injectable clock.
	 * @param {any} pHandle
	 */
	_clearTimer(pHandle)
	{
		if (!pHandle)
		{
			return;
		}
		const tmpDeps = this._deps || {};
		if (typeof tmpDeps.clearTimeout === 'function')
		{
			tmpDeps.clearTimeout(pHandle);
		}
		else
		{
			clearTimeout(pHandle);
		}
	}

	/** @return {number} the server's clock, estimated from the last GET Session ServerNow */
	_serverNow() { return this._now() + (this._skew || 0); }

	/** @return {any} document, or null outside a browser */
	_doc() { return (typeof document !== 'undefined') ? document : null; }

	/** @return {any} window, or null outside a browser */
	_win() { return (typeof window !== 'undefined') ? window : null; }

	/**
	 * @param {string} pID - element id (no '#')
	 * @return {any} the element or null
	 */
	_el(pID)
	{
		const tmpDoc = this._doc();
		return tmpDoc ? tmpDoc.getElementById(pID) : null;
	}

	/**
	 * @param {string} pSelector
	 * @return {boolean} whether the selector is in the DOM
	 */
	_has(pSelector)
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || (typeof tmpCA.getElement !== 'function'))
		{
			return false;
		}
		try
		{
			const tmpSet = tmpCA.getElement(pSelector);
			return !!(tmpSet && tmpSet.length > 0);
		}
		catch (pError)
		{
			return false;
		}
	}

	/**
	 * Replace one region's HTML (no-op when the region is not painted).
	 * @param {string} pSelector
	 * @param {string} pHTML
	 * @return {boolean} painted
	 */
	_assign(pSelector, pHTML)
	{
		if (!this._has(pSelector))
		{
			return false;
		}
		this.pict.ContentAssignment.assignContent(pSelector, pHTML);
		return true;
	}

	/**
	 * HTML-escape (the Markdown module's escapeHTML when present; same entity set otherwise).
	 * @param {any} pValue
	 * @return {string}
	 */
	_esc(pValue)
	{
		const tmpMd = this._deps && this._deps.Markdown;
		if (tmpMd && (typeof tmpMd.escapeHTML === 'function'))
		{
			return String(tmpMd.escapeHTML(pValue == null ? '' : pValue));
		}
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[pChar]));
	}

	/**
	 * Untrusted markdown → safe HTML (strict renderer; escaped <pre> if it throws).
	 * @param {any} pText
	 * @return {string}
	 */
	_md(pText)
	{
		const tmpText = String(pText == null ? '' : pText);
		try
		{
			return String(this.md.renderRemoteMarkdown(tmpText));
		}
		catch (pError)
		{
			return `<pre class="fcg-pre">${this._esc(tmpText)}</pre>`;
		}
	}

	/**
	 * Strip the façade's steering (C6) from a turn's text.
	 * @param {any} pText
	 * @return {string}
	 */
	_stripSteering(pText)
	{
		const tmpText = String(pText == null ? '' : pText);
		if (typeof this.md.stripSteering === 'function')
		{
			try
			{
				return String(this.md.stripSteering(tmpText));
			}
			catch (pError)
			{
				// fall through to the local rule
			}
		}
		let tmpOut = tmpText;
		const tmpMarker = tmpOut.indexOf(this.md.STEERING_MARKER || DEFAULT_STEERING_MARKER);
		if (tmpMarker >= 0)
		{
			tmpOut = tmpOut.slice(0, tmpMarker);
		}
		const tmpPrefixes = [ this.md.EXAMPLES_PREFIX || DEFAULT_EXAMPLES_PREFIX, this.md.REVISION_PREFIX || DEFAULT_REVISION_PREFIX ];
		if (tmpPrefixes.some((pPrefix) => tmpOut.indexOf(pPrefix) === 0))
		{
			const tmpBreak = tmpOut.indexOf('\n\n');
			tmpOut = (tmpBreak >= 0) ? tmpOut.slice(tmpBreak + 2) : '';
		}
		return tmpOut;
	}

	/**
	 * A strict positive id (^[1-9]\d{0,9}$) → Number, anything else → 0.
	 * @param {any} pValue
	 * @return {number}
	 */
	_validID(pValue)
	{
		const tmpString = String(pValue == null ? '' : pValue).trim();
		return /^[1-9]\d{0,9}$/.test(tmpString) ? Number(tmpString) : 0;
	}

	/**
	 * A name as the façade stores it: control chars and slashes stripped, trimmed, cut (B5).
	 * @param {any} pName
	 * @param {number} pMax
	 * @return {string}
	 */
	_cleanName(pName, pMax)
	{
		return String(pName == null ? '' : pName).replace(/[\x00-\x1f\x7f/\\]/g, '').trim().slice(0, pMax);
	}

	/**
	 * @param {any} pValue
	 * @return {number} ms since epoch, or 0
	 */
	_ms(pValue)
	{
		if (!pValue)
		{
			return 0;
		}
		const tmpMs = Date.parse(String(pValue));
		return isNaN(tmpMs) ? 0 : tmpMs;
	}

	/**
	 * @param {number} pMs
	 * @return {string} m:ss or h:mm:ss
	 */
	_fmtElapsed(pMs)
	{
		const tmpSeconds = Math.max(0, Math.floor((Number(pMs) || 0) / 1000));
		const tmpH = Math.floor(tmpSeconds / 3600);
		const tmpM = Math.floor((tmpSeconds % 3600) / 60);
		const tmpS = tmpSeconds % 60;
		const fPad = (pN) => ((pN < 10) ? '0' : '') + pN;
		return tmpH ? `${tmpH}:${fPad(tmpM)}:${fPad(tmpS)}` : `${tmpM}:${fPad(tmpS)}`;
	}

	/**
	 * @param {any} pValue - ISO date
	 * @return {string} "5 min ago" style, or ''
	 */
	_relTime(pValue)
	{
		const tmpMs = this._ms(pValue);
		if (!tmpMs)
		{
			return '';
		}
		const tmpAgo = this._serverNow() - tmpMs;
		if (tmpAgo < 60000)
		{
			return 'just now';
		}
		if (tmpAgo < 3600000)
		{
			return `${Math.round(tmpAgo / 60000)} min ago`;
		}
		if (tmpAgo < 86400000)
		{
			return `${Math.round(tmpAgo / 3600000)} h ago`;
		}
		if (tmpAgo < 7 * 86400000)
		{
			return `${Math.round(tmpAgo / 86400000)} d ago`;
		}
		return new Date(tmpMs).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
	}

	/**
	 * @param {any} pValue - ISO date
	 * @return {string} short local date + time, or ''
	 */
	_dateTime(pValue)
	{
		const tmpMs = this._ms(pValue);
		return tmpMs ? new Date(tmpMs).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
	}

	/**
	 * @param {number} pBytes
	 * @return {string}
	 */
	_fmtSize(pBytes)
	{
		const tmpBytes = Number(pBytes) || 0;
		if (tmpBytes >= MB)
		{
			return `${(tmpBytes / MB).toFixed(1)} MB`;
		}
		if (tmpBytes >= 1024)
		{
			return `${Math.round(tmpBytes / 1024)} KB`;
		}
		return `${tmpBytes} B`;
	}

	/**
	 * Toast through pict-section-modal (escapes the message; duration only when given, never undefined).
	 * @param {string} pMessage
	 * @param {string} [pType]
	 * @param {number} [pDuration]
	 */
	_toast(pMessage, pType, pDuration)
	{
		const tmpModal = this.modal;
		if (!tmpModal || (typeof tmpModal.toast !== 'function'))
		{
			return;
		}
		/** @type {any} */
		const tmpOptions = { type: pType || 'info' };
		if (Number(pDuration) > 0)
		{
			tmpOptions.duration = Number(pDuration);
		}
		else if ((pType === 'error') || (pType === 'warning'))
		{
			tmpOptions.duration = 7000;
		}
		tmpModal.toast(String(pMessage == null ? '' : pMessage), tmpOptions);
	}

	/**
	 * A user-facing sentence for a thrown error (façade codes mapped; everything shown is escaped by the caller).
	 * @param {any} pError
	 * @return {string}
	 */
	_errorText(pError)
	{
		const tmpCode = pError && (typeof pError.Code === 'string') ? pError.Code : '';
		if (tmpCode && ERROR_TEXT[tmpCode])
		{
			return ERROR_TEXT[tmpCode];
		}
		if ((tmpCode === 'BadRequest') && pError.Detail)
		{
			return `The request was rejected: ${String(pError.Detail).slice(0, 200)}`;
		}
		const tmpMessage = (pError && pError.message) ? pError.message : String(pError || 'Something went wrong.');
		return String(tmpMessage).slice(0, 300);
	}

	/** @return {number} the router's navigation token (latest-wins) */
	_routeToken()
	{
		const tmpRouter = this.pict.providers && this.pict.providers.PlatformConfigurationRouter;
		return tmpRouter ? (Number(tmpRouter._routeToken) || 0) : 0;
	}

	/**
	 * Write the URL hash (the router applies it). Tests replace this method.
	 * @param {string} pHash - e.g. '#/FormConcierge/Session/12'
	 */
	_navigate(pHash)
	{
		const tmpWindow = this._win();
		if (tmpWindow && tmpWindow.location)
		{
			tmpWindow.location.hash = pHash;
		}
	}

	/** @return {any} the app's navigo instance (pict-router keeps it at PictRouter.router), or null */
	_navigo()
	{
		const tmpPictRouter = this.pict.providers && this.pict.providers.PictRouter;
		const tmpNavigo = tmpPictRouter && tmpPictRouter.router;
		return (tmpNavigo && (typeof tmpNavigo.navigate === 'function')) ? tmpNavigo : null;
	}

	/**
	 * Rewrite the URL without routing (D9: a created form's id survives a reload).
	 *
	 * navigo is told about the new route too, without running its handler or hooks: a bare history.replaceState
	 * leaves navigo's lastResolved on the old route, so a later link to that old route resolves as "already
	 * there" and does nothing. navigo writes no URL itself here (updateBrowserURL:false): its own write freezes
	 * its popstate listener for ~1 ms, which can swallow the popstate of the _navigate() that Go fires right after.
	 * @param {string} pHash - e.g. '#/FormConcierge/create/77'
	 */
	_replaceHash(pHash)
	{
		const tmpHash = String(pHash || '');
		const tmpNavigo = this._navigo();
		if (tmpNavigo)
		{
			try
			{
				tmpNavigo.navigate(tmpHash.replace(/^#?\/?/, ''), { callHandler: false, callHooks: false, updateBrowserURL: false });
			}
			catch (pError)
			{
				// best-effort: the URL write below still happens
			}
		}
		const tmpWindow = this._win();
		try
		{
			if (tmpWindow && tmpWindow.history && (typeof tmpWindow.history.replaceState === 'function'))
			{
				tmpWindow.history.replaceState(null, '', tmpHash);
			}
		}
		catch (pError)
		{
			// best-effort: the id is still kept in state
		}
	}

	// ── Gate ───────────────────────────────────────────────────────────────────────────────────────────────────

	/** @return {boolean} platform super-user (customer 1, role 5); fail-closed */
	_isSuperUser()
	{
		const tmpApp = this.pict.PictApplication;
		if (tmpApp && (typeof tmpApp._isSuperUser === 'function'))
		{
			try
			{
				return !!tmpApp._isSuperUser();
			}
			catch (pError)
			{
				return false;
			}
		}
		const tmpUser = this.pict.AppData && this.pict.AppData.CurrentUser;
		return !!(tmpUser && (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1));
	}

	/** @return {boolean} CurrentUser has arrived */
	_currentUserReady()
	{
		const tmpUser = this.pict.AppData && this.pict.AppData.CurrentUser;
		return !!(tmpUser && (tmpUser.UserID || tmpUser.LoginID || (tmpUser.UserRoleIndex !== undefined)));
	}

	/** @return {boolean} the façade answered Configured + Allowed */
	_isReady()
	{
		const tmpStatus = this._status;
		return !!(tmpStatus && tmpStatus.Configured && tmpStatus.Allowed && !tmpStatus.Unreachable);
	}

	/** @return {boolean} the screen can paint a working surface (not locked / loading / not configured) */
	_canRender() { return !this._locked && this._statusLoaded && !this.state.Loading && this._isReady(); }

	/**
	 * The plansheet task a flow needs (create/update → Author; build/examples → Config), or null.
	 * @param {string} pFlow
	 * @return {any}
	 */
	_taskFor(pFlow)
	{
		const tmpTasks = (this._status && this._status.Tasks) || {};
		return ((pFlow === 'build') || (pFlow === 'examples')) ? (tmpTasks.Config || null) : (tmpTasks.Author || null);
	}

	// ── Load ───────────────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Screen entry (the view calls this on every mount): wait for the user (fail closed), GET Status, then Forms +
	 * Sessions once, check the mirror once, and apply the pending route.
	 * @return {Promise<void>}
	 */
	async loadAsync()
	{
		const tmpGen = ++this._loadGen;
		const tmpState = this.state;
		// The editors write every keystroke into the segment arrays; take the drafts from there before anything
		// paints (a mount re-seeds the box from the draft), so text typed before leaving the screen comes back.
		this._refreshDrafts();
		this._stopPolling();
		this._paintedMode = '';
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Busy = false;
		tmpState.SendBusy = false;
		if (!this._currentUserReady())
		{
			this._paintNotice('loading');
			this._userWait = (this._userWait || 0) + 1;
			if (this._userWait <= USER_WAIT_TRIES)
			{
				this._setTimer(() =>
				{
					if (tmpGen === this._loadGen)
					{
						this.loadAsync();
					}
				}, USER_WAIT_MS);
				return;
			}
		}
		this._userWait = 0;
		if (!this._isSuperUser())
		{
			this._locked = true;
			this._statusLoaded = false;
			tmpState.Loading = false;
			this._pendingApply = null;
			this._paintNotice('locked');
			return;
		}
		this._locked = false;
		this._paintNotice('loading');
		try
		{
			const tmpStatus = await this.api.getStatus();
			if (tmpGen !== this._loadGen)
			{
				return;
			}
			this._status = tmpStatus || { Configured: false, Allowed: false, Unreachable: true };
			this._nodeBusy = this._status.NodeBusy || null;
			const tmpWorkspace = this._status.Workspace || {};
			this._workspaceReady = !!(tmpWorkspace.WorkflowData && tmpWorkspace.Forms);
			this._statusLoaded = true;
			if (this._isReady())
			{
				this._initMirror();
				await Promise.all([ this._loadFormsAsync(), this._loadSessionsAsync() ]);
				if (tmpGen !== this._loadGen)
				{
					return;
				}
				this._reconcileMirror();
			}
		}
		catch (pError)
		{
			if (tmpGen !== this._loadGen)
			{
				return;
			}
			this._statusLoaded = false;
			tmpState.Error = this._errorText(pError);
		}
		finally
		{
			if (tmpGen === this._loadGen)
			{
				tmpState.Loading = false;
				this._paintedMode = '';
				// A Retry (no pending apply) re-applies the last route, so a deep link survives a failed first load.
				const tmpApply = this._pendingApply || this._lastApply || ((pProvider) => pProvider.routeApplyHome());
				this._pendingApply = null;
				this._lastApply = tmpApply;
				try
				{
					tmpApply(this);
				}
				catch (pError)
				{
					if (this.pict.log && (typeof this.pict.log.error === 'function'))
					{
						this.pict.log.error(`FormConcierge route apply failed: ${pError && pError.message}`);
					}
					this._render();
				}
			}
		}
	}

	/**
	 * GET Forms into this._forms ({Forms, Unindexed}); an error is kept for the picker's empty label.
	 * @return {Promise<void>}
	 */
	async _loadFormsAsync()
	{
		try
		{
			const tmpResult = await this.api.getForms();
			this._forms =
			{
				Forms: Array.isArray(tmpResult && tmpResult.Forms) ? tmpResult.Forms : [],
				Unindexed: Array.isArray(tmpResult && tmpResult.Unindexed) ? tmpResult.Unindexed : [],
			};
			this._formsError = '';
		}
		catch (pError)
		{
			this._forms = this._forms || { Forms: [], Unindexed: [] };
			this._formsError = this._errorText(pError);
		}
	}

	/**
	 * GET Sessions into this._sessions.
	 * @return {Promise<void>}
	 */
	async _loadSessionsAsync()
	{
		this._sessionsLoading = true;
		try
		{
			const tmpResult = await this.api.getSessions();
			this._sessions = Array.isArray(tmpResult && tmpResult.Sessions) ? tmpResult.Sessions : [];
			this._sessionsError = '';
		}
		catch (pError)
		{
			this._sessions = this._sessions || [];
			this._sessionsError = this._errorText(pError);
		}
		this._sessionsLoading = false;
	}

	/**
	 * A Home load after a session visit: refetch Forms + Sessions (never polled), repaint their regions, reconcile.
	 * @return {Promise<void>}
	 */
	async _refreshHomeDataAsync()
	{
		this._sessionsLoading = true;
		this._paintSessions();
		await Promise.all([ this._loadFormsAsync(), this._loadSessionsAsync() ]);
		if (this.state.Mode !== 'home')
		{
			return;
		}
		this._paintSessions();
		this._paintTargetInfo();
		this._setPickerValue(this.state.IDProject);
		this._paintGo();
		this._reconcileMirror();
	}

	// ── Mirror (D12) ───────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Build the Headlight mirror and check its form type once for this screen entry.
	 */
	_initMirror()
	{
		this._mirror = null;
		this._mirrorReady = null;
		this._mirrorReadyPromise = null;
		try
		{
			const tmpModule = this.deps.Mirror;
			const tmpClass = (tmpModule && tmpModule.FormConciergeMirror) || tmpModule;
			if ((typeof tmpClass !== 'function') || !this.restClient)
			{
				this._mirrorReady = { Ready: false, Reason: 'The Headlight mirror is not available in this build.' };
				return;
			}
			this._mirror = new tmpClass({ rest: this.restClient, IDCustomer: this.idCustomer, Environment: (this._status && this._status.Environment) || '', log: this.pict.log });
			this._mirrorReadyPromise = Promise.resolve(this._mirror.checkReady()).then(
				(pReady) =>
				{
					this._mirrorReady = pReady || { Ready: false };
					this._paintSessionHeader(true);
					return this._mirrorReady;
				},
				(pError) =>
				{
					this._mirrorReady = { Ready: false, Reason: this._errorText(pError) };
					this._paintSessionHeader(true);
					return this._mirrorReady;
				});
		}
		catch (pError)
		{
			this._mirror = null;
			this._mirrorReady = { Ready: false, Reason: this._errorText(pError) };
		}
	}

	/**
	 * @param {any} pPayload - GET Session payload
	 * @return {string} the mirror signature (the Mirror module's when it has one)
	 */
	_mirrorSignature(pPayload)
	{
		const tmpModule = this.deps.Mirror;
		const tmpClass = (tmpModule && tmpModule.FormConciergeMirror) || tmpModule;
		if (tmpClass && (typeof tmpClass.signature === 'function'))
		{
			try
			{
				return String(tmpClass.signature(pPayload));
			}
			catch (pError)
			{
				// fall back to the thread signature
			}
		}
		return this._threadSignature(pPayload);
	}

	/**
	 * Fire-and-forget mirror sync when this session's signature changed since its last sync.
	 * @param {any} pPayload
	 */
	_maybeMirror(pPayload)
	{
		if (!this._mirror || this._pollCapped || !pPayload || !pPayload.Session)
		{
			return;
		}
		const tmpID = Number(pPayload.Session.IDRequest) || 0;
		if (!tmpID)
		{
			return;
		}
		const tmpSig = this._mirrorSignature(pPayload);
		if (this._mirroredSig[tmpID] === tmpSig)
		{
			return;
		}
		this._mirroredSig[tmpID] = tmpSig;
		const tmpMirror = this._mirror;
		Promise.resolve(this._mirrorReadyPromise)
			.then((pReady) =>
			{
				if (!pReady || !pReady.Ready)
				{
					return null;
				}
				const tmpFiles = this._sessionFiles[tmpID];
				return tmpMirror.syncSession(pPayload, tmpFiles ? { Files: tmpFiles } : {});
			})
			.then((pResult) =>
			{
				if (pResult)
				{
					this._mirrorState[tmpID] = pResult;
					this._paintSessionHeader(true);
				}
			})
			.catch((pError) =>
			{
				this._mirrorState[tmpID] = { Skipped: true, Reason: this._errorText(pError) };
				this._paintSessionHeader(true);
			});
	}

	/**
	 * Reconcile the mirror against the loaded Sessions list (fire-and-forget; the Mirror module bounds the work).
	 */
	_reconcileMirror()
	{
		const tmpMirror = this._mirror;
		const tmpSessions = this._sessions;
		if (!tmpMirror || !Array.isArray(tmpSessions) || !tmpSessions.length || (typeof tmpMirror.reconcile !== 'function'))
		{
			return;
		}
		Promise.resolve(this._mirrorReadyPromise)
			.then((pReady) =>
			{
				if (!pReady || !pReady.Ready)
				{
					return null;
				}
				return tmpMirror.reconcile(tmpSessions, (pIDRequest) => this.api.getSession(pIDRequest));
			})
			.catch(() =>
			{
				// best-effort; the next Home load tries again
			});
	}

	/**
	 * "Open in Headlight" for a mirrored session (index lookup by IDRequest; the handler passes only a Number).
	 * @param {number} pIDRequest
	 */
	openMirrorDocument(pIDRequest)
	{
		const tmpEntry = this._mirrorState[Number(pIDRequest) || 0];
		const tmpIDDocument = Number(tmpEntry && tmpEntry.IDDocument) || 0;
		const tmpRender = this.pict.HeadlightDocumentRender;
		if (!tmpIDDocument || !tmpRender || (typeof tmpRender.openDocument !== 'function'))
		{
			this._toast('The Headlight copy of this session is not available yet.', 'warning');
			return;
		}
		tmpRender.openDocument(tmpIDDocument, { target: '_blank', variation: 'html' }, (pError) =>
		{
			if (!pError)
			{
				return;
			}
			const tmpMessage = String((pError && pError.message) || pError);
			if (this.pict.log && (typeof this.pict.log.error === 'function'))
			{
				this.pict.log.error(`FormConcierge: opening mirror document ${tmpIDDocument} failed: ${tmpMessage}`);
			}
			this._toast(/blocked/i.test(tmpMessage)
				? 'Your browser blocked the new tab — allow pop-ups for this site and try again.'
				: `The Headlight copy of this session could not be opened: ${tmpMessage.slice(0, 200)}`, 'error');
		});
	}

	// ── Routes (D8) ────────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Router entry: #/FormConcierge → a fresh Create composer.
	 */
	routeApplyHome()
	{
		this.routeApplyFlow('create', 0);
	}

	/**
	 * Router entry: #/FormConcierge/:Flow[/:IDProject]. Same flow + new form → picker.setValue only; flow change →
	 * repaint Target + Guidance (draft and staged files carry over); entering Home → paint the home skeleton.
	 * @param {string} pFlow - create | update | examples | build
	 * @param {number} [pIDProject]
	 */
	routeApplyFlow(pFlow, pIDProject)
	{
		const tmpLower = String(pFlow == null ? '' : pFlow).toLowerCase();
		const tmpFlow = (FLOWS.indexOf(tmpLower) >= 0) ? tmpLower : 'create';
		const tmpID = this._validID(pIDProject);
		this._lastApply = (pProvider) => pProvider.routeApplyFlow(tmpFlow, tmpID);
		const tmpState = this.state;
		const tmpPrevMode = this._paintedMode;
		const tmpPrevFlow = tmpState.Flow;
		const tmpPrevID = Number(tmpState.IDProject) || 0;
		if (tmpState.Mode === 'session')
		{
			this._captureEditor('followup');
		}
		this._stopPolling();
		tmpState.Mode = 'home';
		tmpState.Flow = tmpFlow;
		tmpState.IDProject = tmpID;
		tmpState.IDRequest = 0;
		if (!this._canRender())
		{
			this._render();
			return;
		}
		if ((tmpPrevMode !== 'home') || !this._has('#FCG-Composer'))
		{
			this._paintHome();
			if (tmpPrevMode === 'session')
			{
				this._refreshHomeDataAsync();
			}
			return;
		}
		if (tmpPrevFlow !== tmpFlow)
		{
			this._captureEditor('composer');
			this._paintFlowTabs();
			this._paintTarget();
			this._paintGuidance();
			this._paintDropVisibility();
			this._paintGo();
			return;
		}
		if (tmpPrevID !== tmpID)
		{
			if (this._has('#FCG-FormPicker'))
			{
				this._setPickerValue(tmpID);
				this._paintTargetInfo();
			}
			else
			{
				// create (name input ↔ resumed form) and a fixed build target hold no widget: safe to repaint
				this._paintTarget();
			}
			this._paintGo();
		}
	}

	/**
	 * Router entry: #/FormConcierge/Session/:IDRequest — paint the session view, fetch, and poll (an explicit open).
	 * @param {number} pIDRequest
	 * @return {Promise<void>|void}
	 */
	routeApplySession(pIDRequest)
	{
		const tmpID = this._validID(pIDRequest);
		const tmpState = this.state;
		if (!tmpID)
		{
			this._navigate('#/FormConcierge');
			return;
		}
		this._lastApply = (pProvider) => pProvider.routeApplySession(tmpID);
		if (tmpState.Mode === 'home')
		{
			this._captureEditor('composer');
		}
		const tmpSame = (tmpState.Mode === 'session') && (Number(tmpState.IDRequest) === tmpID) && (this._paintedMode === 'session') && this._has('#FCG-Thread');
		if (Number(tmpState.IDRequest) !== tmpID)
		{
			this._session = null;
			this._threadSig = '';
			this._runKey = '';
			this._headKey = '';
			this._phase = null;
			this._openDetails = {};
			this._copyables = [];
		}
		// A follow-up draft (and its files) belongs to one session: keep it across a Home round-trip, drop it on a switch.
		if (this._followFor !== tmpID)
		{
			this._followFor = tmpID;
			this._followDraft = '';
			tmpState.FollowUpSegments = [ { Content: '' } ];
			this._clearStage('followup');
		}
		tmpState.Mode = 'session';
		tmpState.IDRequest = tmpID;
		if (!this._canRender())
		{
			this._render();
			return;
		}
		if (!tmpSame)
		{
			this._paintSession();
		}
		return this._openSession(true);
	}

	// ── Polling (D11) ──────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Fetch the open session now and keep polling. An explicit open restarts the 60-minute cap.
	 * @param {boolean} pExplicit - a user action (Go, Send, Cancel, Refresh, open by click/deep link)
	 * @return {Promise<void>}
	 */
	_openSession(pExplicit)
	{
		const tmpGen = this._beginPoll(pExplicit);
		return this._pollTick(tmpGen);
	}

	/**
	 * Start a new poll generation (kills any older chain) bound to the current route token.
	 * @param {boolean} pExplicit
	 * @return {number} the generation
	 */
	_beginPoll(pExplicit)
	{
		this._stopTimers();
		this._pollGen = (this._pollGen || 0) + 1;
		this._pollToken = this._routeToken();
		if (pExplicit || !this._pollCapStart)
		{
			this._pollCapStart = this._now();
		}
		this._pollCapped = false;
		this._pollError = '';
		return this._pollGen;
	}

	/** Stop every poll chain (bumps the generation). */
	_stopPolling()
	{
		this._pollGen = (this._pollGen || 0) + 1;
		this._stopTimers();
	}

	/** Clear the poll + ticker timers and the visibility wait. */
	_stopTimers()
	{
		this._clearTimer(this._pollTimer);
		this._pollTimer = null;
		this._clearTimer(this._tickTimer);
		this._tickTimer = null;
		const tmpDoc = this._doc();
		if (this._visHandler && tmpDoc)
		{
			tmpDoc.removeEventListener('visibilitychange', this._visHandler);
		}
		this._visHandler = null;
	}

	/**
	 * @param {number} pGen
	 * @return {boolean} this chain may still run (same generation, same route, thread still mounted)
	 */
	_pollAlive(pGen)
	{
		return (pGen === this._pollGen)
			&& (this._routeToken() === this._pollToken)
			&& (this.state.Mode === 'session')
			&& this._has('#FCG-Thread');
	}

	/** @return {boolean} the cap (60 min since the last explicit action) has passed */
	_capReached() { return (this._now() - (this._pollCapStart || 0)) >= POLL_CAP_MS; }

	/**
	 * One poll: guards, cap, hidden-tab wait, GET Session, apply, then schedule the next (unless terminal).
	 * @param {number} pGen
	 * @return {Promise<void>}
	 */
	async _pollTick(pGen)
	{
		if (!this._pollAlive(pGen))
		{
			return;
		}
		if (this._capReached())
		{
			this._hitCap();
			return;
		}
		const tmpDoc = this._doc();
		if (tmpDoc && tmpDoc.hidden)
		{
			this._waitVisible(pGen);
			return;
		}
		const tmpID = Number(this.state.IDRequest) || 0;
		let tmpPayload = null;
		try
		{
			tmpPayload = await this.api.getSession(tmpID);
		}
		catch (pError)
		{
			if (!this._pollAlive(pGen) || (Number(this.state.IDRequest) !== tmpID))
			{
				return;
			}
			this._pollError = this._errorText(pError);
			this._paintRunStatus(true);
			if (!this._session)
			{
				this._assign('#FCG-Thread', `<div class="fcg-note fcg-note-error"><i class="fas fa-circle-exclamation"></i> ${this._esc(this._pollError)}</div>`);
			}
			if (POLL_FATAL_CODES.indexOf(pError && pError.Code) >= 0)
			{
				this._stopTimers();
				return;
			}
			this._scheduleNext(pGen);
			return;
		}
		if (!this._pollAlive(pGen) || (Number(this.state.IDRequest) !== tmpID))
		{
			return;
		}
		this._pollError = '';
		try
		{
			this._applySessionPayload(tmpPayload);
		}
		catch (pError)
		{
			if (this.pict.log && (typeof this.pict.log.error === 'function'))
			{
				this.pict.log.error(`FormConcierge could not paint session ${tmpID}: ${pError && pError.message}`);
			}
		}
		if (this._phase && this._phase.Terminal)
		{
			this._stopTimers();
			return;
		}
		this._startTicker(pGen);
		this._scheduleNext(pGen);
	}

	/**
	 * Schedule the next poll on the 5 s → 15 s → 30 s ladder (measured from the last explicit action).
	 * @param {number} pGen
	 */
	_scheduleNext(pGen)
	{
		if (!this._pollAlive(pGen))
		{
			return;
		}
		const tmpElapsed = this._now() - (this._pollCapStart || 0);
		if (tmpElapsed >= POLL_CAP_MS)
		{
			this._hitCap();
			return;
		}
		let tmpDelay = POLL_SLOW_MS;
		if (tmpElapsed < POLL_FAST_UNTIL_MS)
		{
			tmpDelay = POLL_FAST_MS;
		}
		else if (tmpElapsed < POLL_MID_UNTIL_MS)
		{
			tmpDelay = POLL_MID_MS;
		}
		tmpDelay = Math.max(250, Math.min(tmpDelay, POLL_CAP_MS - tmpElapsed));
		this._clearTimer(this._pollTimer);
		this._pollTimer = this._setTimer(() =>
		{
			this._pollTimer = null;
			this._pollTick(pGen);
		}, tmpDelay);
	}

	/** At the cap: no more requests (poll, ticker, mirror) until Refresh. */
	_hitCap()
	{
		this._pollCapped = true;
		this._stopTimers();
		this._paintRunStatus(true);
	}

	/**
	 * Paused while the tab is hidden; resume on visibilitychange without touching the cap (hidden time counts).
	 * @param {number} pGen
	 */
	_waitVisible(pGen)
	{
		const tmpDoc = this._doc();
		if (!tmpDoc)
		{
			return;
		}
		if (this._visHandler)
		{
			tmpDoc.removeEventListener('visibilitychange', this._visHandler);
		}
		this._visHandler = () =>
		{
			if (tmpDoc.hidden)
			{
				return;
			}
			tmpDoc.removeEventListener('visibilitychange', this._visHandler);
			this._visHandler = null;
			this._pollTick(pGen);
		};
		tmpDoc.addEventListener('visibilitychange', this._visHandler);
	}

	/**
	 * The 1 s elapsed ticker: writes only #FCG-Elapsed textContent; dies with the poll guards, the cap, or terminal.
	 * @param {number} pGen
	 */
	_startTicker(pGen)
	{
		if (this._tickTimer)
		{
			return;
		}
		const fTick = () =>
		{
			this._tickTimer = null;
			if (!this._pollAlive(pGen) || this._pollCapped || !this._phase || this._phase.Terminal)
			{
				return;
			}
			if (this._capReached())
			{
				this._hitCap();
				return;
			}
			this._writeElapsed();
			this._tickTimer = this._setTimer(fTick, TICK_MS);
		};
		this._tickTimer = this._setTimer(fTick, TICK_MS);
	}

	/** Write the elapsed time into #FCG-Elapsed (textContent only). */
	_writeElapsed()
	{
		const tmpEl = this._el('FCG-Elapsed');
		if (tmpEl && this._phase && this._phase.ElapsedFrom)
		{
			tmpEl.textContent = this._fmtElapsed(this._serverNow() - this._phase.ElapsedFrom);
		}
	}

	/**
	 * Explicit Refresh (also the way out of the cap): fetch now and restart polling.
	 * @return {Promise<void>}
	 */
	refreshSession()
	{
		if (this.state.Mode !== 'session')
		{
			return Promise.resolve();
		}
		return this._openSession(true);
	}

	// ── Session payload → regions ──────────────────────────────────────────────────────────────────────────────

	/**
	 * @param {any} pPayload
	 * @return {Array<any>} messages in Sequence order
	 */
	_messages(pPayload)
	{
		const tmpList = (pPayload && Array.isArray(pPayload.Messages)) ? pPayload.Messages.slice() : [];
		tmpList.sort((pA, pB) => (Number(pA && pA.Sequence) || 0) - (Number(pB && pB.Sequence) || 0));
		return tmpList;
	}

	/**
	 * @param {any} pMessage
	 * @return {boolean}
	 */
	_isAssistant(pMessage) { return String((pMessage && pMessage.Role) || '').toLowerCase() === 'assistant'; }

	/**
	 * The thread signature (§5): Request.Status, message count, last message Status + id.
	 * @param {any} pPayload
	 * @return {string}
	 */
	_threadSignature(pPayload)
	{
		const tmpMessages = this._messages(pPayload);
		const tmpLast = tmpMessages[tmpMessages.length - 1] || {};
		const tmpSession = (pPayload && pPayload.Session) || {};
		return [ tmpSession.Status || '', tmpMessages.length, tmpLast.Status || '', tmpLast.IDRequestMessage || '' ].join('|');
	}

	/**
	 * Map a GET Session payload to the client run phase (contract D10), against the server clock.
	 * @param {any} pPayload
	 * @param {number} [pNowMs] - server-clock now (defaults to the skew-corrected clock)
	 * @return {{ Key: string, Label: string, Detail: string, Terminal: boolean, Active: boolean, Cancel: boolean, SubmitAgain: boolean, TryAgain: boolean, ElapsedFrom: number, StageLabel: string }}
	 */
	runPhase(pPayload, pNowMs)
	{
		const tmpPayload = pPayload || {};
		const tmpSession = tmpPayload.Session || {};
		const tmpRun = tmpPayload.Run || null;
		const tmpNow = (Number(pNowMs) > 0) ? Number(pNowMs) : (this._ms(tmpPayload.ServerNow) || this._serverNow());
		const tmpMessages = this._messages(tmpPayload);
		const tmpLast = tmpMessages[tmpMessages.length - 1] || null;
		/** @type {any} */
		let tmpLastUser = null;
		tmpMessages.forEach((pMessage) =>
		{
			if (!this._isAssistant(pMessage))
			{
				tmpLastUser = pMessage;
			}
		});
		let tmpStatus = String(tmpSession.Status || '');
		if (tmpLast && this._isAssistant(tmpLast) && tmpLast.Status)
		{
			tmpStatus = String(tmpLast.Status);
		}
		else if (tmpLast && !this._isAssistant(tmpLast) && (tmpMessages.length > 1))
		{
			// a follow-up was posted and its assistant turn is not there yet
			tmpStatus = 'Pending';
		}
		const tmpTurnStart = this._ms(tmpLastUser && tmpLastUser.CreateDate) || this._ms(tmpSession.CreateDate);
		const tmpStage = tmpRun && tmpRun.StageLabel ? String(tmpRun.StageLabel) : '';
		/**
		 * @param {string} pKey
		 * @param {string} pLabel
		 * @param {any} [pExtra]
		 * @return {any}
		 */
		const fPhase = (pKey, pLabel, pExtra) => Object.assign(
			{ Key: pKey, Label: pLabel, Detail: '', Terminal: false, Active: false, Cancel: false, SubmitAgain: false, TryAgain: false, ElapsedFrom: 0, StageLabel: '' },
			pExtra || {});
		if (tmpStatus === 'Answered')
		{
			return fPhase('answered', 'Answered', { Terminal: true });
		}
		if (tmpStatus === 'Failed')
		{
			return fPhase('failed', 'This run failed.', { Terminal: true, TryAgain: true });
		}
		if (tmpStatus === 'Cancelled')
		{
			return fPhase('cancelled', 'Cancelled.', { Terminal: true });
		}
		if (tmpRun && tmpRun.CancelRequested && !tmpRun.Claimed)
		{
			return fPhase('cancelled-unstarted', 'Cancelled (never started).', { Terminal: true, SubmitAgain: true });
		}
		if (tmpRun && tmpRun.Zombie)
		{
			return fPhase('notpickedup', 'Not picked up — the node was busy or offline.',
				{ Terminal: true, SubmitAgain: true, Detail: 'Plansheet runs one request at a time and never picks a run up later. Submit it again once the node is free.' });
		}
		const tmpClaimedAt = (tmpRun && this._ms(tmpRun.ClaimedAt)) || tmpTurnStart;
		if (tmpRun && tmpRun.CancelRequested && tmpRun.Claimed)
		{
			return fPhase('cancelling', 'Cancelling… it may still finish.',
				{ Active: true, ElapsedFrom: tmpClaimedAt, StageLabel: tmpStage, Detail: 'The node stops at its next heartbeat; a run that is nearly done can still complete.' });
		}
		if (tmpRun && tmpRun.Claimed)
		{
			const tmpBeat = this._ms(tmpRun.HeartbeatDate) || tmpClaimedAt;
			if (tmpBeat && ((tmpNow - tmpBeat) >= STALL_MS))
			{
				return fPhase('stalled', 'Stalled?',
					{ Active: true, Cancel: true, ElapsedFrom: tmpClaimedAt, StageLabel: tmpStage, Detail: `No heartbeat from the node for ${Math.floor((tmpNow - tmpBeat) / 60000)} min.` });
			}
			return fPhase('working', 'Working…', { Active: true, Cancel: true, ElapsedFrom: tmpClaimedAt, StageLabel: tmpStage });
		}
		const tmpAge = tmpTurnStart ? (tmpNow - tmpTurnStart) : 0;
		if (tmpAge < STARTING_MS)
		{
			return fPhase('starting', 'Starting…', { Active: true, ElapsedFrom: tmpTurnStart });
		}
		return fPhase('waiting', 'Waiting for a worker…', { Active: true, Cancel: true, ElapsedFrom: tmpTurnStart, Detail: 'No plansheet node has picked this up yet.' });
	}

	/**
	 * Apply a fetched session: thread/next steps only on a signature change, run status only when its state changed,
	 * the follow-up only by toggling Send, then the mirror.
	 * @param {any} pPayload
	 */
	_applySessionPayload(pPayload)
	{
		const tmpPayload = pPayload || {};
		this._session = tmpPayload;
		const tmpServerNow = this._ms(tmpPayload.ServerNow);
		if (tmpServerNow)
		{
			this._skew = tmpServerNow - this._now();
		}
		this._phase = this.runPhase(tmpPayload);
		const tmpSig = this._threadSignature(tmpPayload);
		if (tmpSig !== this._threadSig)
		{
			this._threadSig = tmpSig;
			this._paintThread();
			this._paintNextSteps();
		}
		// The node was busy with THIS request and it has finished: the stale NodeBusy no longer applies.
		const tmpIDRequest = Number(tmpPayload.Session && tmpPayload.Session.IDRequest) || 0;
		if (this._phase.Terminal && this._nodeBusy && (Number(this._nodeBusy.IDRequest) === tmpIDRequest))
		{
			this._nodeBusy = null;
		}
		this._paintSessionHeader();
		this._paintRunStatus();
		this._syncFollowUpLock();
		this._maybeMirror(tmpPayload);
	}

	/**
	 * The text a user turn shows (C6: Display.UserText from the façade; stripped Content otherwise).
	 * @param {any} pMessage
	 * @return {string}
	 */
	_userText(pMessage)
	{
		if (pMessage && pMessage.Display && (typeof pMessage.Display.UserText === 'string'))
		{
			return pMessage.Display.UserText;
		}
		return this._stripSteering(pMessage && pMessage.Content);
	}

	/**
	 * @param {any} pMessage
	 * @return {any} the reply metadata object, or null
	 */
	_meta(pMessage)
	{
		let tmpMeta = pMessage ? pMessage.Metadata : null;
		if (typeof tmpMeta === 'string')
		{
			try
			{
				tmpMeta = tmpMeta.trim() ? JSON.parse(tmpMeta) : null;
			}
			catch (pError)
			{
				tmpMeta = null;
			}
		}
		return (tmpMeta && (typeof tmpMeta === 'object')) ? tmpMeta : null;
	}

	/** Remember which <details> are open so a thread repaint restores them (keyed by turn index). */
	_captureDetails()
	{
		const tmpThread = this._el('FCG-Thread');
		if (!tmpThread || (typeof tmpThread.querySelectorAll !== 'function'))
		{
			return;
		}
		Array.prototype.forEach.call(tmpThread.querySelectorAll('details[data-fcg-det]'), (pDetails) =>
		{
			this._openDetails[pDetails.getAttribute('data-fcg-det')] = !!pDetails.open;
		});
	}

	/** Repaint #FCG-Thread (restores open <details>). */
	_paintThread()
	{
		if (!this._has('#FCG-Thread'))
		{
			return;
		}
		this._captureDetails();
		this._assign('#FCG-Thread', this._threadHTML());
	}

	/** @return {string} the thread (turns in Sequence order); rebuilds the copy index */
	_threadHTML()
	{
		this._copyables = [];
		const tmpPayload = this._session;
		if (!tmpPayload)
		{
			return `<div class="fcg-note"><i class="fas fa-circle-notch fa-spin"></i> Loading the session…</div>`;
		}
		const tmpMessages = this._messages(tmpPayload);
		if (!tmpMessages.length)
		{
			return `<div class="fcg-note"><i class="fas fa-paper-plane"></i> The request was submitted; its first turn is not in plansheet yet.</div>`;
		}
		let tmpSeenUser = false;
		return tmpMessages.map((pMessage, pIndex) =>
		{
			const tmpFirstUser = !this._isAssistant(pMessage) && !tmpSeenUser;
			if (!this._isAssistant(pMessage))
			{
				tmpSeenUser = true;
			}
			return this._turnHTML(pMessage, pIndex, tmpFirstUser);
		}).join('');
	}

	/**
	 * One turn. User turns render Display.UserText (the full prompt only in an escaped, collapsed <pre>); assistant
	 * turns render their Content strictly plus the metadata chips (copy indexes offset into this._copyables).
	 * @param {any} pMessage
	 * @param {number} pIndex
	 * @param {boolean} pFirstUser
	 * @return {string}
	 */
	_turnHTML(pMessage, pIndex, pFirstUser)
	{
		const tmpIndex = Number(pIndex) || 0;
		const tmpWhen = this._dateTime(pMessage.CreateDate);
		const fOpen = (pKind) => (this._openDetails[`${tmpIndex}-${pKind}`] ? ' open' : '');
		if (!this._isAssistant(pMessage))
		{
			const tmpText = this._userText(pMessage);
			const tmpBody = String(tmpText).trim()
				? this._md(tmpText)
				: `<div class="fcg-muted">No request text (files only).</div>`;
			const tmpFull = String(pMessage.Content == null ? '' : pMessage.Content);
			const tmpDetails = (tmpFull && (tmpFull.trim() !== String(tmpText).trim()))
				? `<details class="fcg-det" data-fcg-det="${tmpIndex}-prompt"${fOpen('prompt')}><summary>Full prompt sent</summary><pre class="fcg-pre">${this._esc(tmpFull)}</pre></details>`
				: '';
			return `<article class="fcg-turn fcg-turn-user" data-fcg-turn="${tmpIndex}">`
				+ `<header class="fcg-turn-h"><span class="fcg-turn-who"><i class="fas fa-user"></i> ${pFirstUser ? 'Request' : 'Follow-up'}</span><span class="fcg-turn-when">${this._esc(tmpWhen)}</span></header>`
				+ `<div class="fcg-turn-body fcg-md">${tmpBody}</div>${this._attachmentsHTML(pMessage)}${tmpDetails}</article>`;
		}
		const tmpStatus = String(pMessage.Status || '');
		const tmpStatusMeta = SESSION_STATUS_META[tmpStatus] || { Chip: tmpStatus || 'Pending', Cls: 'fcg-st-run' };
		let tmpBody = '';
		if (tmpStatus === 'Answered')
		{
			tmpBody = String(pMessage.Content || '').trim() ? this._md(pMessage.Content) : `<div class="fcg-muted">(empty reply)</div>`;
		}
		else if (tmpStatus === 'Failed')
		{
			tmpBody = `<div class="fcg-muted">This turn failed.</div>${String(pMessage.Content || '').trim() ? this._md(pMessage.Content) : ''}`;
		}
		else if (tmpStatus === 'Cancelled')
		{
			tmpBody = `<div class="fcg-muted">Cancelled.</div>`;
		}
		else
		{
			tmpBody = `<div class="fcg-muted"><i class="fas fa-circle-notch fa-spin"></i> Working on it…</div>`;
		}
		return `<article class="fcg-turn fcg-turn-assistant" data-fcg-turn="${tmpIndex}">`
			+ `<header class="fcg-turn-h"><span class="fcg-turn-who"><i class="fas fa-wand-sparkles"></i> Plansheet</span>`
			+ `<span class="fcg-chip ${tmpStatusMeta.Cls}">${this._esc(tmpStatusMeta.Chip)}</span><span class="fcg-turn-when">${this._esc(tmpWhen)}</span></header>`
			+ `<div class="fcg-turn-body fcg-md">${tmpBody}</div>${this._metaHTML(pMessage)}${this._attachmentsHTML(pMessage)}</article>`;
	}

	/**
	 * Reply metadata chips via the Markdown module; its data-fcg-copy indexes are offset into this._copyables.
	 * @param {any} pMessage
	 * @return {string}
	 */
	_metaHTML(pMessage)
	{
		const tmpMeta = this._meta(pMessage);
		if (!tmpMeta || (typeof this.md.renderReplyMetadata !== 'function'))
		{
			return '';
		}
		let tmpResult = null;
		try
		{
			tmpResult = this.md.renderReplyMetadata(tmpMeta);
		}
		catch (pError)
		{
			return `<details class="fcg-det"><summary>Details</summary><pre class="fcg-pre">${this._esc(JSON.stringify(tmpMeta, null, 2))}</pre></details>`;
		}
		const tmpBase = this._copyables.length;
		const tmpHTML = String((tmpResult && tmpResult.HTML) || '').replace(/data-fcg-copy="(\d+)"/g, (pMatch, pIdx) => `data-fcg-copy="${tmpBase + Number(pIdx)}"`);
		const tmpCopyables = (tmpResult && Array.isArray(tmpResult.Copyables)) ? tmpResult.Copyables : [];
		tmpCopyables.forEach((pText) => this._copyables.push(String(pText)));
		return tmpHTML ? `<div class="fcg-meta">${tmpHTML}</div>` : '';
	}

	/**
	 * @param {any} pMessage
	 * @return {string} escaped attachment chips
	 */
	_attachmentsHTML(pMessage)
	{
		const tmpList = (pMessage && Array.isArray(pMessage.Attachments)) ? pMessage.Attachments : [];
		if (!tmpList.length)
		{
			return '';
		}
		return `<div class="fcg-attach">${tmpList.map((pItem) =>
		{
			const tmpName = (pItem && (typeof pItem === 'object')) ? (pItem.Name || pItem.FileName || pItem.Title || 'attachment') : String(pItem);
			return `<span class="fcg-chip"><i class="fas fa-paperclip"></i> ${this._esc(tmpName)}</span>`;
		}).join('')}</div>`;
	}

	/**
	 * Repaint #FCG-SessionHeader when its inputs changed (or always, when forced by a mirror update).
	 * @param {boolean} [pForce]
	 */
	_paintSessionHeader(pForce)
	{
		if ((this.state.Mode !== 'session') || !this._has('#FCG-SessionHeader'))
		{
			return;
		}
		const tmpKey = `${this._threadSig}|${this._phase ? this._phase.Key : ''}`;
		if (!pForce && (tmpKey === this._headKey))
		{
			return;
		}
		this._headKey = tmpKey;
		this._assign('#FCG-SessionHeader', this._sessionHeaderHTML());
	}

	/** @return {string} the session header (form, flow, status, started, mirror, blueprint) */
	_sessionHeaderHTML()
	{
		const tmpBack = `<a class="fcg-back" href="#/FormConcierge"><i class="fas fa-arrow-left"></i> Form Concierge</a>`;
		const tmpPayload = this._session;
		if (!tmpPayload)
		{
			return `${tmpBack}<h2 class="fcg-shead-t">Session #${Number(this.state.IDRequest) || 0}</h2>`;
		}
		const tmpSession = tmpPayload.Session || {};
		const tmpForm = tmpPayload.Form || {};
		const tmpFlow = String(tmpSession.Flow || '').toLowerCase();
		const tmpFlowChip = `<span class="fcg-chip fcg-chip-flow">${this._esc(FLOW_CHIP[tmpFlow] || tmpSession.Flow || 'Session')}</span>`;
		const tmpPhaseMeta = (this._phase && PHASE_META[this._phase.Key]) || { Chip: tmpSession.Status || '', Cls: 'fcg-st-run' };
		const tmpStatusChip = tmpPhaseMeta.Chip ? `<span class="fcg-chip ${tmpPhaseMeta.Cls}">${this._esc(tmpPhaseMeta.Chip)}</span>` : '';
		const tmpNumber = Number(tmpSession.RequestNumber) || 0;
		const tmpStarted = this._relTime(tmpSession.CreateDate);
		const tmpFacts = [ tmpNumber ? `Request #${tmpNumber}` : '', tmpStarted ? `started ${this._esc(tmpStarted)}` : '' ].filter(Boolean).join(' · ');
		return `${tmpBack}`
			+ `<div class="fcg-shead-row"><h2 class="fcg-shead-t">${this._esc(tmpSession.FormName || tmpForm.Name || 'Form')}</h2>${tmpFlowChip}${tmpStatusChip}</div>`
			+ `<div class="fcg-shead-sub">${tmpFacts}${this._blueprintLinkHTML()}</div>`
			+ `<div class="fcg-shead-mirror">${this._mirrorHTML(Number(tmpSession.IDRequest) || 0)}</div>`;
	}

	/** @return {string} the latest blueprint share link (https://plansheet.io/ only), or '' */
	_blueprintLinkHTML()
	{
		let tmpURL = '';
		this._messages(this._session).forEach((pMessage) =>
		{
			const tmpMeta = this._isAssistant(pMessage) ? this._meta(pMessage) : null;
			if (tmpMeta && tmpMeta.Blueprint && (typeof tmpMeta.Blueprint.ShareURL === 'string'))
			{
				tmpURL = tmpMeta.Blueprint.ShareURL;
			}
		});
		if (!tmpURL || (tmpURL.indexOf('https://plansheet.io/') !== 0) || (typeof this.md.linkHTML !== 'function'))
		{
			return '';
		}
		try
		{
			return ` · <span class="fcg-shead-link"><i class="fas fa-compass-drafting"></i> ${this.md.linkHTML(tmpURL, 'Open blueprint')}</span>`;
		}
		catch (pError)
		{
			return '';
		}
	}

	/**
	 * @param {number} pIDRequest
	 * @return {string} mirror state for the session header
	 */
	_mirrorHTML(pIDRequest)
	{
		const tmpReady = this._mirrorReady;
		if (!tmpReady)
		{
			return `<span class="fcg-mirror"><i class="fas fa-circle-notch fa-spin"></i> Checking the Headlight mirror…</span>`;
		}
		if (!tmpReady.Ready || !this._mirror)
		{
			const tmpReason = String(tmpReady.Reason || '').trim();
			// The Mirror module's reason may already be the whole sentence.
			const tmpText = /^not mirrored/i.test(tmpReason)
				? tmpReason
				: `Not mirrored to Headlight: ${tmpReason || 'the FormConcierge-Session form type isn\'t installed in this environment'}`;
			return `<span class="fcg-mirror fcg-mirror-off"><i class="fas fa-circle-info"></i> ${this._esc(tmpText)}</span>`;
		}
		const tmpEntry = this._mirrorState[pIDRequest];
		if (tmpEntry && (Number(tmpEntry.IDDocument) > 0))
		{
			return `<span class="fcg-mirror fcg-mirror-on"><i class="fas fa-link"></i> Mirrored to Headlight · `
				+ `<a href="#" onclick="_Pict.providers.FormConcierge.openMirrorDocument(${Number(pIDRequest) || 0}); return false;">Open in Headlight</a></span>`;
		}
		if (tmpEntry && tmpEntry.Skipped && tmpEntry.Reason)
		{
			return `<span class="fcg-mirror fcg-mirror-warn"><i class="fas fa-triangle-exclamation"></i> The Headlight mirror did not update: ${this._esc(tmpEntry.Reason)}</span>`;
		}
		return `<span class="fcg-mirror"><i class="fas fa-circle-notch fa-spin"></i> Mirroring to Headlight…</span>`;
	}

	/**
	 * Repaint #FCG-RunStatus when the phase/stage/cap/error changed (or forced).
	 * @param {boolean} [pForce]
	 */
	_paintRunStatus(pForce)
	{
		if (!this._has('#FCG-RunStatus'))
		{
			return;
		}
		const tmpPhase = this._phase;
		const tmpKey = [ tmpPhase ? tmpPhase.Key : '', tmpPhase ? tmpPhase.StageLabel : '', tmpPhase ? tmpPhase.Detail : '', this._pollCapped, this._pollError ].join('|');
		if (!pForce && (tmpKey === this._runKey))
		{
			return;
		}
		this._runKey = tmpKey;
		this._assign('#FCG-RunStatus', this._runStatusHTML());
	}

	/** @return {string} the run status line + its actions */
	_runStatusHTML()
	{
		const tmpPhase = this._phase;
		const tmpError = this._pollError ? `<div class="fcg-run-err"><i class="fas fa-rotate"></i> Couldn't refresh: ${this._esc(this._pollError)}</div>` : '';
		if (!tmpPhase)
		{
			return tmpError;
		}
		const tmpMeta = PHASE_META[tmpPhase.Key] || PHASE_META.working;
		const tmpButtons = [];
		if (this._pollCapped && !tmpPhase.Terminal)
		{
			return `<div class="fcg-run fcg-st-warn"><i class="fas fa-pause"></i> <b>Still running.</b> Auto-refresh stopped after an hour.`
				+ ` <button type="button" class="fcg-btn fcg-btn-sm" onclick="_Pict.providers.FormConcierge.refreshSession(); return false;"><i class="fas fa-rotate"></i> Refresh</button></div>${tmpError}`;
		}
		if (tmpPhase.Cancel)
		{
			tmpButtons.push(`<button type="button" class="fcg-btn fcg-btn-sm" onclick="_Pict.providers.FormConcierge.cancelRun(); return false;"><i class="fas fa-ban"></i> Cancel</button>`);
		}
		if (tmpPhase.SubmitAgain)
		{
			tmpButtons.push(`<button type="button" class="fcg-btn fcg-btn-sm fcg-btn-primary" onclick="_Pict.providers.FormConcierge.resubmit(); return false;"><i class="fas fa-paper-plane"></i> Submit again</button>`);
		}
		if (tmpPhase.TryAgain)
		{
			tmpButtons.push(`<button type="button" class="fcg-btn fcg-btn-sm fcg-btn-primary" onclick="_Pict.providers.FormConcierge.resubmit(); return false;"><i class="fas fa-rotate-right"></i> Try again</button>`);
		}
		const tmpSpin = tmpPhase.Active && (tmpPhase.Key !== 'stalled');
		const tmpIcon = tmpSpin ? 'fa-circle-notch fa-spin' : tmpMeta.Icon;
		const tmpElapsed = (tmpPhase.Active && tmpPhase.ElapsedFrom)
			? ` <span id="FCG-Elapsed" class="fcg-elapsed">${this._fmtElapsed(this._serverNow() - tmpPhase.ElapsedFrom)}</span>`
			: '';
		const tmpStage = tmpPhase.StageLabel ? ` <span class="fcg-stage">${this._esc(tmpPhase.StageLabel)}</span>` : '';
		const tmpDetail = tmpPhase.Detail ? `<div class="fcg-run-sub">${this._esc(tmpPhase.Detail)}</div>` : '';
		return `<div class="fcg-run ${tmpMeta.Cls}"><div class="fcg-run-main"><i class="fas ${tmpIcon}"></i> <b>${this._esc(tmpPhase.Label)}</b>${tmpElapsed}${tmpStage}`
			+ `${tmpButtons.length ? `<span class="fcg-run-actions">${tmpButtons.join('')}</span>` : ''}</div>${tmpDetail}</div>${tmpError}`;
	}

	/** Repaint #FCG-NextSteps. */
	_paintNextSteps() { this._assign('#FCG-NextSteps', this._nextStepsHTML()); }

	/** @return {string} Build & deliver after a blueprint answer; Generate examples once the form is delivered */
	_nextStepsHTML()
	{
		const tmpPayload = this._session;
		if (!tmpPayload || !tmpPayload.Session)
		{
			return '';
		}
		const tmpFlow = String(tmpPayload.Session.Flow || '').toLowerCase();
		const tmpForm = tmpPayload.Form || {};
		const tmpIDProject = Number(tmpForm.IDProject || tmpPayload.Session.IDProject) || 0;
		if (!tmpIDProject)
		{
			return '';
		}
		const tmpAnswered = this._messages(tmpPayload).filter((pMessage) => this._isAssistant(pMessage) && (pMessage.Status === 'Answered'));
		const tmpBlueprint = tmpAnswered.some((pMessage) =>
		{
			const tmpMeta = this._meta(pMessage);
			return !!(tmpMeta && tmpMeta.Blueprint);
		});
		const tmpPushed = this._isDelivered(tmpForm) || tmpAnswered.some((pMessage) =>
		{
			const tmpMeta = this._meta(pMessage);
			return !!(tmpMeta && tmpMeta.HeadlightForm && (tmpMeta.HeadlightForm.Pushed === true));
		});
		const tmpSteps = [];
		if ([ 'create', 'update', 'author', 'modify' ].indexOf(tmpFlow) >= 0 && tmpBlueprint)
		{
			tmpSteps.push(`<a class="fcg-btn fcg-btn-primary" href="#/FormConcierge/build/${tmpIDProject}"><i class="fas fa-truck-ramp-box"></i> Build & deliver the form</a>`);
		}
		if (tmpPushed)
		{
			tmpSteps.push(`<a class="fcg-btn" href="#/FormConcierge/examples/${tmpIDProject}"><i class="fas fa-vials"></i> Generate examples</a>`);
		}
		if (!tmpSteps.length)
		{
			return '';
		}
		return `<div class="fcg-next"><div class="fcg-next-h">Next steps</div><div class="fcg-next-actions">${tmpSteps.join('')}</div></div>`;
	}

	// ── Painting: shells ───────────────────────────────────────────────────────────────────────────────────────

	/** Paint whatever the current state calls for (notice, home, or session). */
	_render()
	{
		if (this._locked)
		{
			this._paintNotice('locked');
			return;
		}
		if (this.state.Loading)
		{
			this._paintNotice('loading');
			return;
		}
		if (!this._statusLoaded)
		{
			this._paintNotice(this.state.Error ? 'error' : 'loading');
			return;
		}
		if (!this._isReady())
		{
			this._paintNotice(this._status && this._status.Unreachable ? 'unreachable' : (this._status && this._status.Configured === false ? 'notconfigured' : 'notallowed'));
			return;
		}
		if (this.state.Mode === 'session')
		{
			this._paintSession();
			return;
		}
		this._paintHome();
	}

	/** Attach the one delegated click listener (copy buttons) to the current host element. */
	_attachHostListener()
	{
		const tmpDoc = this._doc();
		const tmpHost = tmpDoc ? tmpDoc.querySelector(this._mount) : null;
		if (!tmpHost || (tmpHost === this._hostListenerEl))
		{
			return;
		}
		this._hostListenerEl = tmpHost;
		tmpHost.addEventListener('click', (pEvent) => this._onHostClick(pEvent));
	}

	/**
	 * Delegated click: a [data-fcg-copy="<index>"] button copies this._copyables[index] (never markup-carried text).
	 * @param {any} pEvent
	 */
	_onHostClick(pEvent)
	{
		const tmpTarget = /** @type {any} */ (pEvent && pEvent.target);
		const tmpButton = (tmpTarget && (typeof tmpTarget.closest === 'function')) ? tmpTarget.closest('[data-fcg-copy]') : null;
		if (!tmpButton)
		{
			return;
		}
		if (typeof pEvent.preventDefault === 'function')
		{
			pEvent.preventDefault();
		}
		const tmpRaw = String(tmpButton.getAttribute('data-fcg-copy') || '');
		const tmpIndex = /^\d{1,6}$/.test(tmpRaw) ? Number(tmpRaw) : -1;
		const tmpText = (tmpIndex >= 0) ? this._copyables[tmpIndex] : undefined;
		if (typeof tmpText === 'string')
		{
			this._copyText(tmpText);
		}
	}

	/**
	 * Copy text to the clipboard (async API, else a hidden-textarea fallback).
	 * @param {string} pText
	 */
	_copyText(pText)
	{
		const tmpWindow = /** @type {any} */ (this._win());
		const tmpClipboard = tmpWindow && tmpWindow.navigator && tmpWindow.navigator.clipboard;
		if (tmpClipboard && (typeof tmpClipboard.writeText === 'function'))
		{
			tmpClipboard.writeText(pText).then(() => this._toast('Copied to the clipboard.', 'success'), () => this._copyFallback(pText));
			return;
		}
		this._copyFallback(pText);
	}

	/**
	 * @param {string} pText
	 */
	_copyFallback(pText)
	{
		const tmpDoc = this._doc();
		if (!tmpDoc)
		{
			return;
		}
		const tmpArea = tmpDoc.createElement('textarea');
		tmpArea.value = pText;
		tmpArea.setAttribute('readonly', '');
		tmpArea.style.position = 'fixed';
		tmpArea.style.left = '-9999px';
		tmpDoc.body.appendChild(tmpArea);
		tmpArea.select();
		let tmpOK = false;
		try
		{
			tmpOK = tmpDoc.execCommand('copy');
		}
		catch (pError)
		{
			tmpOK = false;
		}
		tmpDoc.body.removeChild(tmpArea);
		this._toast(tmpOK ? 'Copied to the clipboard.' : 'Copy failed; select the text and copy it by hand.', tmpOK ? 'success' : 'warning');
	}

	/**
	 * Paint the host with the header + one notice (loading / locked / error / not configured / unreachable).
	 * @param {string} pKind
	 */
	_paintNotice(pKind)
	{
		if (!this._has(this._mount))
		{
			return;
		}
		this._assign(this._mount, `<div class="fcg" data-fcg-mode="notice"><div id="FCG-Header">${this._headerHTML()}</div>${this._noticeHTML(pKind)}</div>`);
		this._paintedMode = `notice:${pKind}`;
		this._attachHostListener();
	}

	/**
	 * @param {string} pKind
	 * @return {string}
	 */
	_noticeHTML(pKind)
	{
		const tmpRetry = `<button type="button" class="fcg-btn fcg-btn-sm" onclick="_Pict.providers.FormConcierge.loadAsync(); return false;"><i class="fas fa-rotate"></i> Retry</button>`;
		switch (pKind)
		{
			case 'locked':
				return `<div class="fcg-note fcg-note-locked"><i class="fas fa-lock"></i> <div><b>Form Concierge is for platform super-users only.</b><br>It drives the plansheet form pipeline on Headlight's behalf.</div></div>`;
			case 'notallowed':
				return `<div class="fcg-note fcg-note-locked"><i class="fas fa-lock"></i> <div><b>The server did not allow this session.</b><br>Form Concierge accepts only signed-in platform super-users.</div></div>`;
			case 'notconfigured':
				return `<div class="fcg-note fcg-note-warn"><i class="fas fa-plug-circle-xmark"></i> <div><b>Form Concierge isn't configured on this server.</b><br>`
					+ `Production needs FORM_CONCIERGE_PLANSHEET_TOKEN and FORM_CONCIERGE_ENVIRONMENT; local dev needs Plansheet.Enabled, Token and Environment in .headlight.config.json. Restart after setting them.</div></div>`;
			case 'unreachable':
				return `<div class="fcg-note fcg-note-warn"><i class="fas fa-plug-circle-exclamation"></i> <div><b>The Form Concierge service didn't answer.</b><br>`
					+ `It runs only in the deployed config-app image and under services/proxy_server serve. ${tmpRetry}</div></div>`;
			case 'error':
				return `<div class="fcg-note fcg-note-error"><i class="fas fa-circle-exclamation"></i> <div><b>Form Concierge couldn't load.</b><br>${this._esc(this.state.Error)} ${tmpRetry}</div></div>`;
			default:
				return `<div class="fcg-note"><i class="fas fa-circle-notch fa-spin"></i> Loading Form Concierge…</div>`;
		}
	}

	/** @return {string} the title row with the façade status pill */
	_headerHTML()
	{
		const tmpStatus = this._status;
		let tmpPill = `<span class="fcg-pill">Checking…</span>`;
		if (this._locked)
		{
			tmpPill = `<span class="fcg-pill fcg-st-off">Locked</span>`;
		}
		else if (this._statusLoaded && tmpStatus)
		{
			if (tmpStatus.Unreachable)
			{
				tmpPill = `<span class="fcg-pill fcg-st-err">Unreachable</span>`;
			}
			else if (!tmpStatus.Configured)
			{
				tmpPill = `<span class="fcg-pill fcg-st-warn">Not configured</span>`;
			}
			else if (!tmpStatus.Allowed)
			{
				tmpPill = `<span class="fcg-pill fcg-st-off">Not allowed</span>`;
			}
			else if (!this._taskFor('create') || !this._taskFor('build'))
			{
				tmpPill = `<span class="fcg-pill fcg-st-warn">Tasks missing</span>`;
			}
			else
			{
				tmpPill = `<span class="fcg-pill fcg-st-ok">Ready</span>`;
			}
		}
		const tmpEnv = (tmpStatus && tmpStatus.Environment && this._isReady()) ? `<span class="fcg-pill fcg-pill-env">${this._esc(tmpStatus.Environment)}</span>` : '';
		const tmpBusy = (this._nodeBusy && this._isReady()) ? `<span class="fcg-pill fcg-st-warn" title="The plansheet node is working on another request">Node busy</span>` : '';
		return `<div class="fcg-head"><div class="fcg-head-l"><h1 class="fcg-title"><i class="fas fa-wand-sparkles"></i> Form Concierge</h1>`
			+ `<p class="fcg-sub">Drop files, describe a form, and have the plansheet form pipeline create it, update it, build and deliver it, or seed examples for it.</p></div>`
			+ `<div class="fcg-head-r">${tmpPill}${tmpEnv}${tmpBusy}</div></div>`;
	}

	/** Repaint #FCG-Header. */
	_paintHeader() { this._assign('#FCG-Header', this._headerHTML()); }

	/** Paint the Home skeleton (header, flow tabs, composer regions, sessions) and mount the picker + editor. */
	_paintHome()
	{
		if (!this._has(this._mount))
		{
			return;
		}
		const tmpFlow = this.state.Flow;
		const tmpDropHandlers = `ondragover="_Pict.providers.FormConcierge.onDragOver(event,'composer')" ondragleave="_Pict.providers.FormConcierge.onDragLeave(event,'composer')" ondrop="_Pict.providers.FormConcierge.onDrop(event,'composer')"`;
		const tmpTasksNote = (!this._taskFor('create') || !this._taskFor('build'))
			? `<div class="fcg-note fcg-note-warn"><i class="fas fa-triangle-exclamation"></i> Plansheet's form-administration tasks weren't all found${this._taskFor('create') ? '' : ' (Author is missing)'}${this._taskFor('build') ? '' : ' (Config is missing)'}. Flows that need them stay off.</div>`
			: '';
		const tmpHTML = `<div class="fcg" data-fcg-mode="home">`
			+ `<div id="FCG-Header">${this._headerHTML()}</div>${tmpTasksNote}`
			+ `<nav id="FCG-Flow" class="fcg-flow">${this._flowTabsHTML()}</nav>`
			+ `<section id="FCG-Composer" class="fcg-card">`
			+ `<div id="FCG-Target" class="fcg-target">${this._targetHTML()}</div>`
			+ `<div id="FCG-DropWrap" class="fcg-dropwrap${tmpFlow === 'build' ? ' fcg-hidden' : ''}">`
			+ `<div id="FCG-Drop" class="fcg-drop" ${tmpDropHandlers}>${this._dropInnerHTML('composer')}</div>`
			+ `<div id="FCG-Files" class="fcg-files">${this._filesHTML('composer')}</div></div>`
			+ `<div id="FCG-EditorLabel" class="fcg-label"></div>`
			+ `<div id="FCG-Editor" class="fcg-editor" ondragover="_Pict.providers.FormConcierge.onEditorDragOver(event)" ondrop="_Pict.providers.FormConcierge.onDrop(event,'composer')"><div id="FCG-Editor-Mount"></div></div>`
			+ `<div id="FCG-Guidance" class="fcg-guidance"></div>`
			+ `<div id="FCG-Go" class="fcg-go">${this._goHTML()}</div>`
			+ `</section>`
			+ `<section id="FCG-Sessions" class="fcg-sessions">${this._sessionsHTML()}</section>`
			+ `</div>`;
		this._assign(this._mount, tmpHTML);
		this._paintedMode = 'home';
		this._attachHostListener();
		this._mountPicker();
		this._mountEditor('composer');
		this._paintGuidance();
	}

	/** Paint the Session skeleton and mount the follow-up editor. */
	_paintSession()
	{
		if (!this._has(this._mount))
		{
			return;
		}
		const tmpDropHandlers = `ondragover="_Pict.providers.FormConcierge.onDragOver(event,'followup')" ondragleave="_Pict.providers.FormConcierge.onDragLeave(event,'followup')" ondrop="_Pict.providers.FormConcierge.onDrop(event,'followup')"`;
		this._runKey = '';
		this._headKey = '';
		this._threadSig = this._session ? this._threadSignature(this._session) : '';
		const tmpHTML = `<div class="fcg" data-fcg-mode="session">`
			+ `<div id="FCG-Header">${this._headerHTML()}</div>`
			+ `<section id="FCG-SessionHeader" class="fcg-shead">${this._sessionHeaderHTML()}</section>`
			+ `<section id="FCG-Thread" class="fcg-thread">${this._threadHTML()}</section>`
			+ `<section id="FCG-RunStatus" class="fcg-runwrap">${this._runStatusHTML()}</section>`
			+ `<section id="FCG-FollowUp" class="fcg-card fcg-fu">`
			+ `<div class="fcg-label">Follow up</div>`
			+ `<div id="FCG-FU-Editor" class="fcg-editor" ondragover="_Pict.providers.FormConcierge.onEditorDragOver(event)" ondrop="_Pict.providers.FormConcierge.onDrop(event,'followup')"><div id="FCG-FU-Editor-Mount"></div></div>`
			+ `<div id="FCG-FU-Drop" class="fcg-drop fcg-drop-sm" ${tmpDropHandlers}>${this._dropInnerHTML('followup')}</div>`
			+ `<div id="FCG-FU-Files" class="fcg-files">${this._filesHTML('followup')}</div>`
			+ `<div class="fcg-fu-actions"><button id="FCG-SendBtn" type="button" class="fcg-btn fcg-btn-primary" onclick="_Pict.providers.FormConcierge.sendFollowUp(); return false;"><i class="fas fa-paper-plane"></i> Send</button>`
			+ `<button id="FCG-RecheckBtn" type="button" class="fcg-linkbtn fcg-hidden" onclick="_Pict.providers.FormConcierge.recheckNode(); return false;">Check the node again</button>`
			+ `<span id="FCG-SendNote" class="fcg-go-note"></span></div>`
			+ `</section>`
			+ `<section id="FCG-NextSteps">${this._nextStepsHTML()}</section>`
			+ `</div>`;
		this._assign(this._mount, tmpHTML);
		this._paintedMode = 'session';
		this._attachHostListener();
		this._mountEditor('followup');
		this._syncFollowUpLock();
	}

	// ── Painting: home regions ─────────────────────────────────────────────────────────────────────────────────

	/** @return {string} the segmented flow links (hash routes, never JS tab state) */
	_flowTabsHTML()
	{
		const tmpFlow = this.state.Flow;
		return FLOWS.map((pFlow) =>
		{
			const tmpMeta = FLOW_META[pFlow];
			return `<a class="fcg-seg${pFlow === tmpFlow ? ' fcg-seg-on' : ''}" href="#/FormConcierge/${pFlow}"><i class="fas ${tmpMeta.Icon}"></i> ${tmpMeta.Label}</a>`;
		}).join('');
	}

	/** Repaint #FCG-Flow (links only). */
	_paintFlowTabs() { this._assign('#FCG-Flow', this._flowTabsHTML()); }

	/** @return {string} the Target region for the current flow (name input / form picker / deliver-to) */
	_targetHTML()
	{
		const tmpState = this.state;
		const tmpFlow = tmpState.Flow;
		const tmpID = Number(tmpState.IDProject) || 0;
		if (tmpFlow === 'create')
		{
			if (tmpID)
			{
				return `<div class="fcg-label">Form</div><div class="fcg-fixed"><i class="fas fa-file-lines"></i> <b>${this._esc(this._formLabel(tmpID))}</b>`
					+ ` <span class="fcg-muted">(created; finish starting it here)</span> <a class="fcg-linkbtn" href="#/FormConcierge">Start a different form</a></div>`;
			}
			return `<label class="fcg-label" for="FCG-Name">Form name <span class="fcg-muted">(optional; defaults to your first heading)</span></label>`
				+ `<input id="FCG-Name" class="fcg-input" type="text" maxlength="200" autocomplete="off" value="${this._esc(this._formName)}" placeholder="e.g. Concrete cylinder break log" oninput="_Pict.providers.FormConcierge.setFormName(this.value)">`;
		}
		const tmpPicker = `<div class="fcg-label">Form</div><div id="FCG-FormPicker" class="fcg-picker"></div><div id="FCG-TargetInfo" class="fcg-targetinfo">${this._targetInfoHTML()}</div>`;
		if (tmpFlow === 'build')
		{
			const tmpForm = tmpID
				? `<div class="fcg-label">Form</div><div class="fcg-fixed"><i class="fas fa-file-lines"></i> <b>${this._esc(this._formLabel(tmpID))}</b> <a class="fcg-linkbtn" href="#/FormConcierge/build">Pick another</a></div><div id="FCG-TargetInfo" class="fcg-targetinfo">${this._targetInfoHTML()}</div>`
				: tmpPicker;
			return `${tmpForm}<div class="fcg-deliver">`
				+ `<label class="fcg-label" for="FCG-DeliverTo">Deliver to</label>`
				+ `<input id="FCG-DeliverTo" class="fcg-input" type="text" maxlength="200" autocomplete="off" value="${this._esc(this._deliverTo)}" placeholder="Headlight environment and customer, e.g. Headlight QA, customer 10"${this._validateOnly ? ' disabled' : ''} oninput="_Pict.providers.FormConcierge.setDeliverTo(this.value)">`
				+ `<label class="fcg-check"><input id="FCG-ValidateOnly" type="checkbox"${this._validateOnly ? ' checked' : ''} onchange="_Pict.providers.FormConcierge.setValidateOnly(this.checked)"> Validate only (don't push)</label></div>`;
		}
		return tmpPicker;
	}

	/** Repaint #FCG-Target and re-mount the picker into it. */
	_paintTarget()
	{
		if (this._assign('#FCG-Target', this._targetHTML()))
		{
			this._mountPicker();
		}
	}

	/** @return {string} chips describing the selected form (status, blueprint, delivery) */
	_targetInfoHTML()
	{
		const tmpID = Number(this.state.IDProject) || 0;
		if (!tmpID)
		{
			return this._formsError ? `<div class="fcg-muted">Couldn't load the form list: ${this._esc(this._formsError)}</div>` : '';
		}
		const tmpFound = this._findForm(tmpID);
		if (!tmpFound)
		{
			return `<div class="fcg-muted">Form #${tmpID} isn't in this customer's Concierge forms.</div>`;
		}
		const tmpForm = tmpFound.Form;
		const tmpChips = [];
		if (tmpForm.Status)
		{
			tmpChips.push(`<span class="fcg-chip">${this._esc(tmpForm.Status)}</span>`);
		}
		tmpChips.push(Number(tmpForm.IDBlueprint) > 0 ? `<span class="fcg-chip fcg-st-ok">Blueprint</span>` : `<span class="fcg-chip fcg-st-off">No blueprint yet</span>`);
		const tmpHash = (tmpForm.Delivery && tmpForm.Delivery.Hash) || (tmpForm.HeadlightForm && tmpForm.HeadlightForm.Hash) || '';
		tmpChips.push(this._isDelivered(tmpForm)
			? `<span class="fcg-chip fcg-st-ok">Delivered${tmpHash ? ` · ${this._esc(tmpHash)}` : ''}</span>`
			: `<span class="fcg-chip fcg-st-off">Not delivered</span>`);
		if (!tmpFound.Indexed)
		{
			tmpChips.push(`<span class="fcg-chip fcg-st-warn">Not yet in Concierge</span>`);
		}
		return `<div class="fcg-chips">${tmpChips.join('')}</div>`;
	}

	/** Repaint #FCG-TargetInfo (holds no widget). */
	_paintTargetInfo() { this._assign('#FCG-TargetInfo', this._targetInfoHTML()); }

	/** Guidance + editor label (textContent only: the guidance may come from plansheet's PromptShape). */
	_paintGuidance()
	{
		const tmpGuidance = this._el('FCG-Guidance');
		if (tmpGuidance)
		{
			tmpGuidance.textContent = this._guidanceText();
		}
		const tmpLabel = this._el('FCG-EditorLabel');
		if (tmpLabel)
		{
			tmpLabel.textContent = (FLOW_META[this.state.Flow] || FLOW_META.create).EditorLabel;
		}
	}

	/** @return {string} the guidance line for the current flow (plain text) */
	_guidanceText()
	{
		const tmpFlow = this.state.Flow;
		const tmpTask = this._taskFor(tmpFlow);
		const tmpShape = (tmpTask && (typeof tmpTask.InputGuidance === 'string')) ? tmpTask.InputGuidance.trim() : '';
		if (tmpFlow === 'update')
		{
			return 'Describe exactly what should change. Everything you do not mention stays as it is.';
		}
		if (tmpFlow === 'examples')
		{
			return 'Optional: say how many examples you want and which scenarios. The delivered form is not rebuilt.';
		}
		if (tmpFlow === 'build')
		{
			return tmpShape || 'Builds the form configuration from the agreed blueprint, validates it, and delivers it where you say.';
		}
		return tmpShape || 'Describe the form: what it records, who fills it in, and any rules. Dropped files become the form\'s sources.';
	}

	/** Show/hide the drop zone (Build & deliver takes no files). */
	_paintDropVisibility()
	{
		const tmpWrap = this._el('FCG-DropWrap');
		if (tmpWrap && tmpWrap.classList)
		{
			tmpWrap.classList.toggle('fcg-hidden', this.state.Flow === 'build');
		}
	}

	/** Repaint #FCG-Go (the only region Busy repaints). */
	_paintGo() { this._assign('#FCG-Go', this._goHTML()); }

	/** @return {string} the Go button + busy text or the reason it is off */
	_goHTML()
	{
		const tmpState = this.state;
		const tmpMeta = FLOW_META[tmpState.Flow] || FLOW_META.create;
		if (tmpState.Busy)
		{
			return `<button type="button" class="fcg-btn fcg-btn-primary" disabled><i class="fas fa-circle-notch fa-spin"></i> ${this._esc(tmpState.BusyText || 'Working…')}</button>`;
		}
		const tmpBlock = this._goBlock();
		return `<button id="FCG-GoBtn" type="button" class="fcg-btn fcg-btn-primary"${tmpBlock.Disabled ? ' disabled' : ''} onclick="_Pict.providers.FormConcierge.go(); return false;"><i class="fas ${tmpMeta.Icon}"></i> ${tmpMeta.Go}</button>`
			+ (tmpBlock.NoteHTML ? `<span class="fcg-go-note">${tmpBlock.NoteHTML}</span>` : '');
	}

	/** @return {string} the NodeBusy explanation + Check again (and a link to that session) */
	_nodeBusyHTML()
	{
		const tmpBusy = this._nodeBusy || {};
		const tmpID = Number(tmpBusy.IDRequest) || 0;
		const tmpStage = tmpBusy.StageLabel ? ` (${this._esc(tmpBusy.StageLabel)})` : '';
		return `<i class="fas fa-hourglass-half"></i> The plansheet node is busy${tmpID ? ` with request <a href="#/FormConcierge/Session/${tmpID}">#${tmpID}</a>` : ''}${tmpStage}. `
			+ `It runs one request at a time and never picks one up later, so this stays off until it finishes. `
			+ `<button type="button" class="fcg-linkbtn" onclick="_Pict.providers.FormConcierge.recheckNode(); return false;">Check again</button>`;
	}

	/**
	 * Why Go is off right now (non-text reasons; empty text is checked on click).
	 * @return {{ Disabled: boolean, NoteHTML: string }}
	 */
	_goBlock()
	{
		const tmpState = this.state;
		const tmpFlow = tmpState.Flow;
		const tmpID = Number(tmpState.IDProject) || 0;
		const fBlock = (pHTML) => ({ Disabled: true, NoteHTML: pHTML });
		if (!this._isReady())
		{
			return fBlock('Form Concierge is not ready.');
		}
		if (!this._taskFor(tmpFlow))
		{
			return fBlock(`Plansheet's ${(tmpFlow === 'build') || (tmpFlow === 'examples') ? 'form configuration' : 'form authoring'} task is not available.`);
		}
		if (this._nodeBusy)
		{
			return fBlock(this._nodeBusyHTML());
		}
		if ((tmpFlow !== 'create') && !tmpID)
		{
			return fBlock(tmpFlow === 'examples' ? 'Pick a delivered form.' : 'Pick a form.');
		}
		if (tmpFlow === 'examples')
		{
			const tmpFound = this._findForm(tmpID);
			if (tmpFound && !this._isDelivered(tmpFound.Form))
			{
				return fBlock('This form has not been delivered yet. Build & deliver it first.');
			}
		}
		if (tmpFlow === 'build')
		{
			if (!String(this._deliverTo || '').trim() && !this._validateOnly)
			{
				return fBlock('Say where to deliver it, or tick Validate only.');
			}
			if (this._stage.composer.length)
			{
				return { Disabled: false, NoteHTML: 'Staged files are not used by Build & deliver; they stay staged for the other flows.' };
			}
			return { Disabled: false, NoteHTML: '' };
		}
		const tmpBusyFiles = this._stage.composer.filter((pFile) => (pFile.Status === 'uploading') || (pFile.Status === 'converting')).length;
		if (tmpBusyFiles)
		{
			return fBlock(`Waiting for ${tmpBusyFiles} file${tmpBusyFiles === 1 ? '' : 's'} to finish uploading.`);
		}
		if (this._stage.composer.some((pFile) => pFile.Status === 'error'))
		{
			return fBlock('Remove or retry the file that failed.');
		}
		return { Disabled: false, NoteHTML: '' };
	}

	/** @return {string} the Recent sessions list */
	_sessionsHTML()
	{
		const tmpList = Array.isArray(this._sessions) ? this._sessions : [];
		const tmpHead = `<div class="fcg-sess-h"><h2 class="fcg-h2">Recent sessions</h2>${tmpList.length ? `<span class="fcg-muted">${tmpList.length}</span>` : ''}</div>`;
		if (this._sessionsLoading && !tmpList.length)
		{
			return `${tmpHead}<div class="fcg-note"><i class="fas fa-circle-notch fa-spin"></i> Loading sessions…</div>`;
		}
		if (this._sessionsError && !tmpList.length)
		{
			return `${tmpHead}<div class="fcg-note fcg-note-error"><i class="fas fa-circle-exclamation"></i> ${this._esc(this._sessionsError)}</div>`;
		}
		if (!tmpList.length)
		{
			return `${tmpHead}<div class="fcg-note">No sessions yet. Your first Go starts one.</div>`;
		}
		const tmpShown = this._showAllSessions ? tmpList : tmpList.slice(0, SESSION_LIST_SHOW);
		const tmpRows = tmpShown.map((pRow) =>
		{
			const tmpID = Number(pRow && pRow.IDRequest) || 0;
			if (!tmpID)
			{
				return '';
			}
			const tmpFlow = String(pRow.Flow || '').toLowerCase();
			const tmpStatus = SESSION_STATUS_META[pRow.Status] || { Chip: pRow.Status || '', Cls: 'fcg-st-off' };
			return `<a class="fcg-srow" href="#/FormConcierge/Session/${tmpID}">`
				+ `<span class="fcg-srow-main"><span class="fcg-srow-name">${this._esc(pRow.FormName || pRow.Name || `Request ${tmpID}`)}</span>`
				+ `<span class="fcg-srow-req">${this._esc(pRow.Name || '')}</span></span>`
				+ `<span class="fcg-chip fcg-chip-flow">${this._esc(FLOW_CHIP[tmpFlow] || pRow.Flow || '')}</span>`
				+ `${tmpStatus.Chip ? `<span class="fcg-chip ${tmpStatus.Cls}">${this._esc(tmpStatus.Chip)}</span>` : ''}`
				+ `<span class="fcg-srow-when">${this._esc(this._relTime(pRow.CreateDate))}</span></a>`;
		}).join('');
		const tmpMore = (tmpList.length > SESSION_LIST_SHOW)
			? `<button type="button" class="fcg-linkbtn" onclick="_Pict.providers.FormConcierge.toggleAllSessions(); return false;">${this._showAllSessions ? 'Show fewer' : `Show all ${tmpList.length}`}</button>`
			: '';
		return `${tmpHead}<div class="fcg-slist">${tmpRows}</div>${tmpMore}`;
	}

	/** Repaint #FCG-Sessions. */
	_paintSessions() { this._assign('#FCG-Sessions', this._sessionsHTML()); }

	/** Show all / fewer sessions. */
	toggleAllSessions()
	{
		this._showAllSessions = !this._showAllSessions;
		this._paintSessions();
	}

	// ── Inputs ─────────────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * @param {any} pValue - the Form name input
	 */
	setFormName(pValue) { this._formName = String(pValue == null ? '' : pValue).slice(0, 200); }

	/**
	 * @param {any} pValue - the Deliver to input
	 */
	setDeliverTo(pValue)
	{
		this._deliverTo = String(pValue == null ? '' : pValue).slice(0, 200);
		this._paintGo();
	}

	/**
	 * @param {any} pChecked - Validate only (don't push)
	 */
	setValidateOnly(pChecked)
	{
		this._validateOnly = !!pChecked;
		const tmpInput = this._el('FCG-DeliverTo');
		if (tmpInput)
		{
			tmpInput.disabled = this._validateOnly;
		}
		this._paintGo();
	}

	/**
	 * Re-fetch Status (the explicit way to clear NodeBusy) and repaint what depends on it.
	 * @return {Promise<void>}
	 */
	async recheckNode()
	{
		await this._refreshStatus();
		this._paintHeader();
		if (this.state.Mode === 'home')
		{
			this._paintGo();
		}
		else
		{
			this._syncFollowUpLock();
		}
		this._toast(this._nodeBusy ? 'The plansheet node is still busy.' : 'The plansheet node is free.', 'info');
	}

	/**
	 * GET Status again (before Go/Send) to refresh NodeBusy. Errors leave the previous status in place.
	 * @return {Promise<any>} the NodeBusy record or null
	 */
	async _refreshStatus()
	{
		try
		{
			const tmpStatus = await this.api.getStatus();
			if (tmpStatus && !tmpStatus.Unreachable)
			{
				this._status = tmpStatus;
				this._nodeBusy = tmpStatus.NodeBusy || null;
			}
		}
		catch (pError)
		{
			// keep the last known status; the façade's own single-flight check (409 NodeBusy) still applies
		}
		return this._nodeBusy;
	}

	// ── Forms + picker ─────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * @param {number} pIDProject
	 * @return {{ Form: any, Indexed: boolean }|null}
	 */
	_findForm(pIDProject)
	{
		const tmpID = Number(pIDProject) || 0;
		const tmpForms = this._forms || { Forms: [], Unindexed: [] };
		const tmpIndexed = (tmpForms.Forms || []).find((pForm) => Number(pForm && pForm.IDProject) === tmpID);
		if (tmpIndexed)
		{
			return { Form: tmpIndexed, Indexed: true };
		}
		const tmpLoose = (tmpForms.Unindexed || []).find((pForm) => Number(pForm && pForm.IDProject) === tmpID);
		return tmpLoose ? { Form: tmpLoose, Indexed: false } : null;
	}

	/**
	 * @param {number} pIDProject
	 * @return {string} a display name (plain text; callers escape)
	 */
	_formLabel(pIDProject)
	{
		const tmpFound = this._findForm(pIDProject);
		return (tmpFound && tmpFound.Form.Name) ? String(tmpFound.Form.Name) : `Form #${Number(pIDProject) || 0}`;
	}

	/**
	 * @param {any} pForm
	 * @return {boolean} delivered (a Delivery record, or HeadlightForm.Pushed === true)
	 */
	_isDelivered(pForm)
	{
		return !!(pForm && ((pForm.Delivery && pForm.Delivery.Hash) || (pForm.HeadlightForm && (pForm.HeadlightForm.Pushed === true))));
	}

	/**
	 * Picker rows for the current flow: indexed forms first, then unindexed (examples → delivered only).
	 * @param {any} pTerm
	 * @return {Array<{ Value: number, Text: string, Group: string }>}
	 */
	_formRows(pTerm)
	{
		const tmpFlow = this.state.Flow;
		const tmpTerm = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
		const tmpForms = this._forms || { Forms: [], Unindexed: [] };
		// Straight quotes only: option text renders through a pict template.
		const fText = (pForm) => String(pForm.Name || `Form #${Number(pForm.IDProject) || 0}`).replace(/[‘’]/g, '\'').replace(/[“”]/g, '"');
		const fKeep = (pForm) => !!pForm && (Number(pForm.IDProject) > 0)
			&& ((tmpFlow !== 'examples') || this._isDelivered(pForm))
			&& (!tmpTerm || (fText(pForm).toLowerCase().indexOf(tmpTerm) >= 0) || (String(pForm.IDProject) === tmpTerm));
		/** @type {Array<{ Value: number, Text: string, Group: string }>} */
		const tmpRows = [];
		(tmpForms.Forms || []).filter(fKeep).forEach((pForm) => tmpRows.push({ Value: Number(pForm.IDProject), Text: fText(pForm), Group: GROUP_INDEXED }));
		(tmpForms.Unindexed || []).filter(fKeep).forEach((pForm) => tmpRows.push({ Value: Number(pForm.IDProject), Text: fText(pForm), Group: GROUP_UNINDEXED }));
		return tmpRows;
	}

	/** Mount the searchable form picker into #FCG-FormPicker (no-op when that span isn't painted). */
	_mountPicker()
	{
		if (!this._has('#FCG-FormPicker'))
		{
			return;
		}
		const tmpPicker = this.pickerProvider;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function'))
		{
			this._assign('#FCG-FormPicker', `<div class="fcg-muted">The form picker isn't available.</div>`);
			return;
		}
		const tmpInstance = tmpPicker.createPicker(PICKER_HASH,
			{
				DestinationAddress: '#FCG-FormPicker',
				ValueAddress: 'AppData.FormConcierge.PickedForm',
				Searchable: true,
				AllowClear: false,
				Placeholder: 'Search forms',
				EmptyLabel: 'No matching forms',
				DataProvider: (pTerm) =>
				{
					const tmpRows = this._formRows(pTerm);
					return Promise.resolve({ results: tmpRows.slice(0, PICKER_PAGE), hasMore: tmpRows.length > PICKER_PAGE });
				},
				ResolveValue: (pValue) =>
				{
					const tmpID = this._validID(pValue);
					return Promise.resolve(tmpID ? { Value: tmpID, Text: this._formLabel(tmpID).replace(/[‘’]/g, '\'').replace(/[“”]/g, '"') } : null);
				},
				OnChange: (pValue) =>
				{
					this._onPickForm(pValue);
				},
			});
		if (tmpInstance && (typeof tmpInstance.render === 'function'))
		{
			tmpInstance.render();
		}
		this._setPickerValue(this.state.IDProject);
	}

	/**
	 * Set the picker's value in place (no paint).
	 * @param {number} pIDProject
	 */
	_setPickerValue(pIDProject)
	{
		const tmpView = this.pict.views && this.pict.views[PICKER_HASH];
		if (tmpView && this._has('#FCG-FormPicker') && (typeof tmpView.setValue === 'function'))
		{
			tmpView.setValue(Number(pIDProject) || '');
		}
	}

	/**
	 * A form was picked: adopt it first when it isn't in Concierge yet (confirm), then write the route.
	 * @param {any} pValue
	 * @return {Promise<void>}
	 */
	async _onPickForm(pValue)
	{
		const tmpFlow = this.state.Flow;
		const tmpID = this._validID(pValue);
		if (!tmpID)
		{
			this._navigate(`#/FormConcierge/${tmpFlow}`);
			return;
		}
		const tmpFound = this._findForm(tmpID);
		if (tmpFound && !tmpFound.Indexed)
		{
			const tmpName = String(tmpFound.Form.Name || `Form #${tmpID}`);
			const tmpEnvironment = this._cleanName(this._status && this._status.Environment, 60);
			const tmpWhere = tmpEnvironment ? `the ${tmpEnvironment} environment` : 'this environment';
			const tmpModal = this.modal;
			// The modal escapes the message; adopting claims the plansheet project for this environment only.
			const tmpOK = (tmpModal && (typeof tmpModal.confirm === 'function'))
				? await tmpModal.confirm(`Adopt "${tmpName}" into Form Concierge? It becomes one of this customer's Concierge forms in ${tmpWhere}, and no other environment can adopt it afterwards.`, { title: 'Adopt plansheet form', confirmLabel: 'Adopt', cancelLabel: 'Cancel' })
				: false;
			if (!tmpOK)
			{
				this._setPickerValue(this.state.IDProject);
				return;
			}
			try
			{
				await this.api.adoptForm(tmpID);
				await this._loadFormsAsync();
				this._toast('Adopted into Form Concierge.', 'success');
			}
			catch (pError)
			{
				this._toast(this._errorText(pError), 'error');
				this._setPickerValue(this.state.IDProject);
				return;
			}
		}
		this._navigate(`#/FormConcierge/${tmpFlow}/${tmpID}`);
	}

	// ── Markdown editors (D6) ──────────────────────────────────────────────────────────────────────────────────

	/** @return {Array<any>} the default top-right buttons minus the image picker */
	_editorButtonsTR()
	{
		const tmpDefaults = /** @type {any} */ (libMarkdownEditor).default_configuration;
		const tmpButtons = (tmpDefaults && Array.isArray(tmpDefaults.ButtonsTR)) ? tmpDefaults.ButtonsTR : [];
		return tmpButtons.filter((pButton) => pButton && (pButton.Action !== 'openImagePicker'));
	}

	/**
	 * Mount (or re-render) a markdown box, seeded only with the user's own draft (never upstream text).
	 * @param {string} pContext - composer | followup
	 */
	_mountEditor(pContext)
	{
		const tmpEditor = EDITORS[pContext];
		if (!tmpEditor || !this._has(tmpEditor.Mount))
		{
			return;
		}
		this.state[tmpEditor.Key] = [ { Content: String(this[tmpEditor.Draft] || '') } ];
		if (!this.pict.views[tmpEditor.ViewID])
		{
			this.pict.addView(tmpEditor.ViewID,
				{
					ViewIdentifier: tmpEditor.ViewID,
					TargetElementAddress: tmpEditor.Mount,
					ContentDataAddress: tmpEditor.Address,
					AutoRender: false,
					EnableRichPreview: false,
					ReadOnly: false,
					ButtonsTL: [],
					ButtonsBL: [],
					ButtonsTR: this._editorButtonsTR(),
					FCGContext: pContext,
				}, FormConciergeMarkdownEditor);
		}
		const tmpView = this.pict.views[tmpEditor.ViewID];
		if (!tmpView)
		{
			return;
		}
		// The image preview builds <img src> for every ![](url) in the text, which would fire same-origin GETs.
		tmpView._updateImagePreviews = function () {};
		try
		{
			tmpView.render();
		}
		catch (pError)
		{
			// the box falls back to an empty mount if the CodeMirror bundle hiccups
		}
	}

	/**
	 * Pull a box's text back into its draft (before any repaint of an ancestor, a flow switch, or a submit).
	 * Guarded by DOM presence so a persisted editor never surfaces stale text.
	 * @param {string} pContext
	 */
	_captureEditor(pContext)
	{
		const tmpEditor = EDITORS[pContext];
		if (!tmpEditor || !this._has(tmpEditor.Mount))
		{
			return;
		}
		const tmpView = this.pict.views && this.pict.views[tmpEditor.ViewID];
		if (tmpView && (typeof tmpView.marshalFromView === 'function'))
		{
			try
			{
				tmpView.marshalFromView();
			}
			catch (pError)
			{
				// editor already gone
			}
		}
		const tmpSegments = Array.isArray(this.state[tmpEditor.Key]) ? this.state[tmpEditor.Key] : [];
		this[tmpEditor.Draft] = tmpSegments.map((pSegment) => (pSegment && pSegment.Content) || '').join('\n\n');
	}

	/**
	 * Take both drafts from the live segment arrays (the editor writes them on every keystroke), whether or not the
	 * box is still mounted. A successful Go / Send and a session switch reset the arrays, so nothing submitted or
	 * belonging to another session comes back.
	 */
	_refreshDrafts()
	{
		Object.keys(EDITORS).forEach((pContext) =>
		{
			const tmpEditor = EDITORS[pContext];
			if (this._has(tmpEditor.Mount))
			{
				this._captureEditor(pContext);
				return;
			}
			const tmpSegments = this.state[tmpEditor.Key];
			if (Array.isArray(tmpSegments))
			{
				this[tmpEditor.Draft] = tmpSegments.map((pSegment) => (pSegment && pSegment.Content) || '').join('\n\n');
			}
		});
	}

	/**
	 * Empty a box after its text was submitted: the draft, the segment array, and the editor when it is mounted.
	 * @param {string} pContext - composer | followup
	 */
	_resetEditor(pContext)
	{
		const tmpEditor = EDITORS[pContext];
		if (!tmpEditor)
		{
			return;
		}
		this[tmpEditor.Draft] = '';
		this.state[tmpEditor.Key] = [ { Content: '' } ];
		this._mountEditor(pContext);
	}

	// ── Drop zone + staged files (D5) ──────────────────────────────────────────────────────────────────────────

	/**
	 * @param {string} pContext
	 * @return {string} the drop zone's inner markup
	 */
	_dropInnerHTML(pContext)
	{
		const tmpLiteral = (pContext === 'followup') ? 'followup' : 'composer';
		return `<i class="fas fa-cloud-arrow-up fcg-drop-ic"></i> <span>Drop files here or </span>`
			+ `<button type="button" class="fcg-linkbtn" onclick="_Pict.providers.FormConcierge.chooseFiles('${tmpLiteral}'); return false;">browse</button>`
			+ `<div class="fcg-drop-sub">Specs, spreadsheets, Word, PDF, sample data. Each file uploads as soon as you add it.</div>`;
	}

	/**
	 * @param {string} pContext
	 * @return {string} the escaped staged-file list
	 */
	_filesHTML(pContext)
	{
		const tmpList = this._stage[pContext] || [];
		if (!tmpList.length)
		{
			return '';
		}
		return `<ul class="fcg-filelist">${tmpList.map((pFile) => this._fileRowHTML(pFile)).join('')}</ul>`;
	}

	/**
	 * One staged file (name, size, upload state, conversion chip, remove/retry). The name is untrusted: escaped.
	 * @param {any} pFile
	 * @return {string}
	 */
	_fileRowHTML(pFile)
	{
		const tmpKey = Number(pFile.Key) || 0;
		const tmpPct = Math.round(Math.max(0, Math.min(1, Number(pFile.Progress) || 0)) * 100);
		let tmpState = '';
		if (pFile.UploadStatus === 'error')
		{
			tmpState = `<span class="fcg-chip fcg-st-err">Failed</span>`;
		}
		else if (pFile.UploadStatus === 'queued')
		{
			tmpState = `<span class="fcg-chip">Queued</span>`;
		}
		else if (pFile.UploadStatus === 'uploading')
		{
			tmpState = `<span class="fcg-chip fcg-st-run" id="FCG-FilePct-${tmpKey}">Uploading ${tmpPct}%</span>`;
		}
		else
		{
			tmpState = `<span class="fcg-chip fcg-st-ok">Uploaded</span>`;
		}
		const tmpBar = (pFile.UploadStatus === 'uploading')
			? `<div class="fcg-bar"><div class="fcg-bar-fill" id="FCG-FileBar-${tmpKey}" style="width:${tmpPct}%"></div></div>`
			: '';
		const tmpActions = [];
		if ((pFile.UploadStatus === 'error') && !pFile.NoRetry)
		{
			tmpActions.push(`<button type="button" class="fcg-linkbtn" onclick="_Pict.providers.FormConcierge.retryFile(${tmpKey}); return false;">Retry</button>`);
		}
		tmpActions.push(`<button type="button" class="fcg-iconbtn" title="Remove" onclick="_Pict.providers.FormConcierge.removeFile(${tmpKey}); return false;"><i class="fas fa-xmark"></i></button>`);
		const tmpError = pFile.Error ? `<div class="fcg-file-err">${this._esc(pFile.Error)}</div>` : '';
		return `<li class="fcg-file fcg-file-${this._esc(pFile.Status)}" id="FCG-File-${tmpKey}">`
			+ `<div class="fcg-file-row"><i class="fas ${pFile.TextNative ? 'fa-file-lines' : 'fa-file'}"></i>`
			+ `<span class="fcg-file-name" title="${this._esc(pFile.Name)}">${this._esc(pFile.Name)}</span>`
			+ `<span class="fcg-file-size">${this._esc(this._fmtSize(pFile.Size))}</span>${tmpState}${this._convChipHTML(pFile)}`
			+ `<span class="fcg-file-actions">${tmpActions.join('')}</span></div>${tmpBar}${tmpError}</li>`;
	}

	/**
	 * What the file will contribute to the form's corpus (C8), as an escaped chip.
	 * @param {any} pFile
	 * @return {string}
	 */
	_convChipHTML(pFile)
	{
		if (pFile.TextNative)
		{
			return `<span class="fcg-chip fcg-chip-conv" title="Linked as a text file source">text</span>`;
		}
		if (pFile.ConvertStatus === 'converting')
		{
			return `<span class="fcg-chip fcg-chip-conv"><i class="fas fa-circle-notch fa-spin"></i> extracting text</span>`;
		}
		const tmpNotes = (Array.isArray(pFile.Notes) && pFile.Notes.length) ? ` title="${this._esc(pFile.Notes.join(' · '))}"` : '';
		if (pFile.Markdown)
		{
			return `<span class="fcg-chip fcg-chip-conv fcg-st-ok"${tmpNotes}>to text · ${this._esc(Math.round(pFile.Markdown.length / 100) / 10)}k chars</span>`
				+ ((Array.isArray(pFile.Notes) && pFile.Notes.length) ? `<span class="fcg-file-note">${this._esc(pFile.Notes.join(' · '))}</span>` : '');
		}
		if ((Number(pFile.Size) || 0) <= REFERENCE_MAX_BYTES)
		{
			return `<span class="fcg-chip fcg-chip-conv fcg-st-warn"${tmpNotes}>no text · attached as a reference</span>`;
		}
		return `<span class="fcg-chip fcg-chip-conv fcg-st-err"${tmpNotes}>no text · over 5 MB, won't be linked</span>`;
	}

	/**
	 * Repaint one staging context's file list, then whatever depends on file state.
	 * @param {string} pContext
	 */
	_paintFiles(pContext)
	{
		this._assign(FILE_REGIONS[pContext] || FILE_REGIONS.composer, this._filesHTML(pContext));
		if (pContext === 'followup')
		{
			this._syncFollowUpLock();
		}
		else if (this.state.Mode === 'home')
		{
			this._paintGo();
		}
	}

	/**
	 * Per-file progress without repainting the list.
	 * @param {any} pFile
	 */
	_paintFileProgress(pFile)
	{
		const tmpKey = Number(pFile.Key) || 0;
		const tmpPct = Math.round(Math.max(0, Math.min(1, Number(pFile.Progress) || 0)) * 100);
		const tmpBar = this._el(`FCG-FileBar-${tmpKey}`);
		if (tmpBar && tmpBar.style)
		{
			tmpBar.style.width = `${tmpPct}%`;
		}
		const tmpLabel = this._el(`FCG-FilePct-${tmpKey}`);
		if (tmpLabel)
		{
			tmpLabel.textContent = `Uploading ${tmpPct}%`;
		}
	}

	/**
	 * Open the OS file picker (a hidden <input type=file multiple> appended to body).
	 * @param {string} pContext
	 */
	chooseFiles(pContext)
	{
		const tmpDoc = this._doc();
		if (!tmpDoc)
		{
			return;
		}
		let tmpInput = tmpDoc.getElementById('FCG-FileInput');
		if (!tmpInput)
		{
			tmpInput = tmpDoc.createElement('input');
			tmpInput.type = 'file';
			tmpInput.id = 'FCG-FileInput';
			tmpInput.multiple = true;
			tmpInput.style.display = 'none';
			tmpDoc.body.appendChild(tmpInput);
		}
		tmpInput.value = '';
		tmpInput.onchange = () =>
		{
			const tmpFiles = tmpInput.files;
			tmpInput.onchange = null;
			if (tmpFiles && tmpFiles.length)
			{
				this.addFiles(tmpFiles, pContext);
			}
		};
		tmpInput.click();
	}

	/**
	 * @param {any} pEvent
	 * @param {string} pContext
	 */
	onDragOver(pEvent, pContext)
	{
		if (pEvent && (typeof pEvent.preventDefault === 'function'))
		{
			pEvent.preventDefault();
			if (pEvent.dataTransfer)
			{
				pEvent.dataTransfer.dropEffect = 'copy';
			}
		}
		const tmpZone = this._el(pContext === 'followup' ? 'FCG-FU-Drop' : 'FCG-Drop');
		if (tmpZone && tmpZone.classList)
		{
			tmpZone.classList.add('fcg-dragover');
		}
	}

	/**
	 * @param {any} pEvent
	 * @param {string} pContext
	 */
	onDragLeave(pEvent, pContext)
	{
		const tmpZone = this._el(pContext === 'followup' ? 'FCG-FU-Drop' : 'FCG-Drop');
		if (tmpZone && tmpZone.classList)
		{
			tmpZone.classList.remove('fcg-dragover');
		}
	}

	/**
	 * A file dragged over the editor wrapper (outside CodeMirror) must not open in the browser.
	 * @param {any} pEvent
	 */
	onEditorDragOver(pEvent)
	{
		const tmpTypes = pEvent && pEvent.dataTransfer && pEvent.dataTransfer.types;
		if (tmpTypes && (Array.prototype.indexOf.call(tmpTypes, 'Files') >= 0) && (typeof pEvent.preventDefault === 'function'))
		{
			pEvent.preventDefault();
		}
	}

	/**
	 * Files dropped on a zone (or the editor wrapper) are staged and uploaded.
	 * @param {any} pEvent
	 * @param {string} pContext
	 */
	onDrop(pEvent, pContext)
	{
		this.onDragLeave(pEvent, pContext);
		const tmpFiles = pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files;
		if (!tmpFiles || !tmpFiles.length)
		{
			return;
		}
		if (typeof pEvent.preventDefault === 'function')
		{
			pEvent.preventDefault();
		}
		if (typeof pEvent.stopPropagation === 'function')
		{
			pEvent.stopPropagation();
		}
		this.addFiles(tmpFiles, pContext);
	}

	/**
	 * @param {string} pName
	 * @param {string} pType
	 * @return {{ Kind: string, TextNative: boolean }}
	 */
	_classify(pName, pType)
	{
		const tmpFileText = this.deps.FileText;
		if (tmpFileText && (typeof tmpFileText.classifyFile === 'function'))
		{
			try
			{
				const tmpResult = tmpFileText.classifyFile(pName, pType);
				if (tmpResult)
				{
					return { Kind: String(tmpResult.Kind || 'binary'), TextNative: !!tmpResult.TextNative };
				}
			}
			catch (pError)
			{
				// local rule below
			}
		}
		const tmpTextNative = /\.(md|markdown|txt|csv|tsv|json)$/i.test(pName) || /^text\//i.test(pType) || /^application\/json$/i.test(pType);
		return { Kind: tmpTextNative ? 'text' : 'binary', TextNative: tmpTextNative };
	}

	/**
	 * Stage files and start their uploads (≤ 2 at a time) and conversions (binary only) right away.
	 * @param {any} pFiles - FileList or array of File
	 * @param {string} [pContext] - composer | followup
	 * @return {number} files added
	 */
	addFiles(pFiles, pContext)
	{
		const tmpContext = (pContext === 'followup') ? 'followup' : 'composer';
		const tmpFiles = Array.prototype.slice.call(pFiles || []);
		if (!tmpFiles.length)
		{
			return 0;
		}
		if ((tmpContext === 'composer') && (this.state.Flow === 'build'))
		{
			this._toast('Build & deliver does not take files. Add them from Create or Update.', 'info');
			return 0;
		}
		let tmpAdded = 0;
		tmpFiles.forEach((pFile) =>
		{
			if (!pFile)
			{
				return;
			}
			const tmpName = String(pFile.name || 'file');
			const tmpType = String(pFile.type || '');
			const tmpClass = this._classify(tmpName, tmpType);
			const tmpEntry =
			{
				Key: ++this._fileSeq, Context: tmpContext, Name: tmpName, Size: Number(pFile.size) || 0, Type: tmpType,
				Kind: tmpClass.Kind, TextNative: tmpClass.TextNative, Status: 'uploading', UploadStatus: 'queued',
				ConvertStatus: tmpClass.TextNative ? 'skipped' : 'converting', Progress: 0, IDMedia: 0, MimeType: tmpType,
				Markdown: null, Notes: [], Error: '', NoRetry: false, Removed: false,
				// IDProject → true once this entry's source is linked there (a retry never links it twice).
				LinkedTo: {},
			};
			Object.defineProperty(tmpEntry, '_file', { value: pFile, enumerable: false, writable: true });
			Object.defineProperty(tmpEntry, '_abort', { value: null, enumerable: false, writable: true });
			if (tmpEntry.Size > MAX_UPLOAD_BYTES)
			{
				tmpEntry.UploadStatus = 'error';
				tmpEntry.ConvertStatus = 'skipped';
				tmpEntry.Error = 'Too large to upload (the limit is 25 MB).';
				tmpEntry.NoRetry = true;
			}
			else if (!tmpClass.TextNative)
			{
				this._convert(tmpEntry);
			}
			this._syncFileStatus(tmpEntry);
			this._stage[tmpContext].push(tmpEntry);
			tmpAdded++;
		});
		this._paintFiles(tmpContext);
		this._pumpUploads();
		return tmpAdded;
	}

	/**
	 * Extract text from a binary file (never rejects; a failure just means no text twin).
	 * @param {any} pEntry
	 */
	_convert(pEntry)
	{
		const tmpFileText = this.deps.FileText;
		Promise.resolve()
			.then(() => tmpFileText.convertFileToMarkdown(pEntry._file))
			.then((pResult) =>
			{
				pEntry.Markdown = (pResult && (typeof pResult.Markdown === 'string') && pResult.Markdown) ? pResult.Markdown : null;
				pEntry.Notes = (pResult && Array.isArray(pResult.Notes)) ? pResult.Notes.map(String) : [];
			}, () =>
			{
				pEntry.Markdown = null;
				pEntry.Notes = [ 'Text extraction failed.' ];
			})
			.then(() =>
			{
				pEntry.ConvertStatus = 'done';
				if (!pEntry.Removed)
				{
					this._syncFileStatus(pEntry);
					this._paintFiles(pEntry.Context);
				}
			});
	}

	/**
	 * Status from the upload + conversion sub-states (D5: converting | uploading | ready | error).
	 * @param {any} pEntry
	 */
	_syncFileStatus(pEntry)
	{
		if (pEntry.UploadStatus === 'error')
		{
			pEntry.Status = 'error';
		}
		else if (pEntry.UploadStatus !== 'done')
		{
			pEntry.Status = 'uploading';
		}
		else if (pEntry.ConvertStatus === 'converting')
		{
			pEntry.Status = 'converting';
		}
		else
		{
			pEntry.Status = 'ready';
		}
	}

	/** Start queued uploads up to the concurrency limit (across both staging contexts). */
	_pumpUploads()
	{
		const tmpAll = this._stage.composer.concat(this._stage.followup);
		let tmpActive = tmpAll.filter((pEntry) => pEntry.UploadStatus === 'uploading').length;
		tmpAll.forEach((pEntry) =>
		{
			if ((tmpActive < MAX_CONCURRENT_UPLOADS) && (pEntry.UploadStatus === 'queued') && !pEntry.Removed)
			{
				tmpActive++;
				this._startUpload(pEntry);
			}
		});
	}

	/**
	 * Upload one original to the library anchor (XHR PUT with byte progress through the Api module).
	 * @param {any} pEntry
	 */
	_startUpload(pEntry)
	{
		pEntry.UploadStatus = 'uploading';
		pEntry.Progress = 0;
		pEntry.Error = '';
		this._syncFileStatus(pEntry);
		let tmpHandle = null;
		try
		{
			tmpHandle = this.api.uploadFile(pEntry._file, { onProgress: (pFraction) =>
			{
				pEntry.Progress = Number(pFraction) || 0;
				this._paintFileProgress(pEntry);
			} });
		}
		catch (pError)
		{
			tmpHandle = { promise: Promise.reject(pError), abort: null };
		}
		pEntry._abort = (tmpHandle && (typeof tmpHandle.abort === 'function')) ? tmpHandle.abort : null;
		Promise.resolve(tmpHandle && tmpHandle.promise)
			.then((pResult) =>
			{
				const tmpIDMedia = Number(pResult && pResult.IDMedia) || 0;
				if (!tmpIDMedia)
				{
					throw new Error('The upload did not return a media id.');
				}
				pEntry.IDMedia = tmpIDMedia;
				pEntry.MimeType = String((pResult && pResult.MimeType) || pEntry.Type || '');
				pEntry.UploadStatus = 'done';
				pEntry.Progress = 1;
			})
			.catch((pError) =>
			{
				pEntry.UploadStatus = 'error';
				pEntry.Error = this._errorText(pError);
			})
			.then(() =>
			{
				pEntry._abort = null;
				if (!pEntry.Removed)
				{
					this._syncFileStatus(pEntry);
					this._paintFiles(pEntry.Context);
				}
				this._pumpUploads();
			});
	}

	/**
	 * @param {number} pKey
	 * @return {any} the staged entry or null
	 */
	_findFile(pKey)
	{
		const tmpKey = Number(pKey) || 0;
		return this._stage.composer.concat(this._stage.followup).find((pEntry) => pEntry.Key === tmpKey) || null;
	}

	/**
	 * Drop a staged file (its Media stays in the library by design); aborts an upload in flight.
	 * @param {number} pKey
	 */
	removeFile(pKey)
	{
		const tmpEntry = this._findFile(pKey);
		if (!tmpEntry)
		{
			return;
		}
		tmpEntry.Removed = true;
		if (typeof tmpEntry._abort === 'function')
		{
			try
			{
				tmpEntry._abort();
			}
			catch (pError)
			{
				// already settled
			}
		}
		const tmpList = this._stage[tmpEntry.Context];
		const tmpIndex = tmpList.indexOf(tmpEntry);
		if (tmpIndex >= 0)
		{
			tmpList.splice(tmpIndex, 1);
		}
		this._paintFiles(tmpEntry.Context);
		this._pumpUploads();
	}

	/**
	 * Re-queue a failed upload.
	 * @param {number} pKey
	 */
	retryFile(pKey)
	{
		const tmpEntry = this._findFile(pKey);
		if (!tmpEntry || (tmpEntry.UploadStatus !== 'error') || tmpEntry.NoRetry)
		{
			return;
		}
		tmpEntry.UploadStatus = 'queued';
		tmpEntry.Error = '';
		this._syncFileStatus(tmpEntry);
		this._paintFiles(tmpEntry.Context);
		this._pumpUploads();
	}

	/**
	 * Forget a staging context (after a successful submit, or a session switch).
	 * @param {string} pContext
	 */
	_clearStage(pContext)
	{
		(this._stage[pContext] || []).forEach((pEntry) =>
		{
			pEntry.Removed = true;
			if (typeof pEntry._abort === 'function')
			{
				try
				{
					pEntry._abort();
				}
				catch (pError)
				{
					// already settled
				}
			}
		});
		this._stage[pContext] = [];
	}

	/**
	 * Take just the submitted entries out of a staging context; files added while the submit ran stay staged.
	 * @param {string} pContext
	 * @param {Array<any>} pEntries - the entries the submit used
	 */
	_unstage(pContext, pEntries)
	{
		const tmpSubmitted = pEntries || [];
		tmpSubmitted.forEach((pEntry) =>
		{
			pEntry.Removed = true;
		});
		this._stage[pContext] = (this._stage[pContext] || []).filter((pEntry) => tmpSubmitted.indexOf(pEntry) < 0);
	}

	/**
	 * The C8 corpus plan for staged files: text-native originals → one FILE source; binaries → their extracted text
	 * as a DATA source; a binary with no text → a Reference FILE when ≤ 5 MB, else skipped.
	 * @param {Array<any>} pFiles
	 * @param {string} pFlow
	 * @return {{ Sources: Array<any>, Entries: Array<any>, Skipped: Array<string>, Names: Array<string>, Extras: Array<any> }}
	 *   Entries[i] is the staged entry Sources[i] came from.
	 */
	_planSources(pFiles, pFlow)
	{
		const tmpRole = (pFlow === 'examples') ? 'Example' : 'Spec';
		/** @type {Array<any>} */
		const tmpSources = [];
		/** @type {Array<any>} */
		const tmpEntries = [];
		/** @type {Array<string>} */
		const tmpSkipped = [];
		/** @type {Array<any>} */
		const tmpExtras = [];
		(pFiles || []).forEach((pEntry) =>
		{
			if (!pEntry || (pEntry.Status !== 'ready') || !(Number(pEntry.IDMedia) > 0))
			{
				return;
			}
			const tmpName = this._cleanName(pEntry.Name, 200) || 'file';
			if (pEntry.TextNative)
			{
				tmpSources.push({ Kind: 'media', IDMedia: Number(pEntry.IDMedia), Name: tmpName, Role: tmpRole });
				tmpExtras.push({ Name: pEntry.Name, MimeType: pEntry.MimeType, Size: pEntry.Size, IDMedia: Number(pEntry.IDMedia), Converted: false, Role: tmpRole });
			}
			else if (pEntry.Markdown)
			{
				tmpSources.push({ Kind: 'text', Name: this._cleanName(`${pEntry.Name} (text)`, 200), Title: tmpName, Body: pEntry.Markdown, Role: tmpRole });
				tmpExtras.push({ Name: pEntry.Name, MimeType: pEntry.MimeType, Size: pEntry.Size, IDMedia: Number(pEntry.IDMedia), Converted: true, Role: tmpRole });
			}
			else if ((Number(pEntry.Size) || 0) <= REFERENCE_MAX_BYTES)
			{
				tmpSources.push({ Kind: 'media', IDMedia: Number(pEntry.IDMedia), Name: tmpName, Role: 'Reference' });
				tmpExtras.push({ Name: pEntry.Name, MimeType: pEntry.MimeType, Size: pEntry.Size, IDMedia: Number(pEntry.IDMedia), Converted: false, Role: 'Reference' });
			}
			else
			{
				tmpSkipped.push(pEntry.Name);
				return;
			}
			tmpEntries.push(pEntry);
		});
		return { Sources: tmpSources, Entries: tmpEntries, Skipped: tmpSkipped, Names: tmpSources.map((pSource) => pSource.Name), Extras: tmpExtras };
	}

	/**
	 * Link planned sources to a form so a retry never duplicates one, while a revised file is always linked.
	 *
	 * Dedupe is per staged entry: an entry links into a project once (entry.LinkedTo[IDProject]), so the retry of a
	 * Go / Send that failed after linking skips it. A form's older source with the same name is NOT a reason to
	 * skip: a revised Spec.docx arrives as another 'Spec.docx (text)' (text sources carry IDMedia 0), and dropping
	 * it would run the turn on the old text. The one server-side check left is D9's Name + IDMedia for media sources,
	 * where IDMedia is the exact upload (an earlier add whose answer was lost).
	 * @param {number} pIDProject
	 * @param {{ Sources: Array<any>, Entries: Array<any> }} pPlan - from _planSources
	 * @param {boolean} pFresh - the project was created by this same Go (nothing can be linked yet)
	 * @return {Promise<Array<any>>} the planned sources now on the form for this submit, in plan order: added by this
	 *   call or by an earlier failed attempt of the same submit (its entries are still staged, so the node has not
	 *   been told about them). NewSources is built from these.
	 */
	async _linkSources(pIDProject, pPlan, pFresh)
	{
		const tmpSources = (pPlan && Array.isArray(pPlan.Sources)) ? pPlan.Sources : [];
		const tmpEntries = (pPlan && Array.isArray(pPlan.Entries)) ? pPlan.Entries : [];
		const tmpKey = String(Number(pIDProject) || 0);
		/** @param {number} pIndex @return {boolean} */
		const fLinked = (pIndex) => !!(tmpEntries[pIndex] && tmpEntries[pIndex].LinkedTo && tmpEntries[pIndex].LinkedTo[tmpKey]);
		/** @param {number} pIndex */
		const fMark = (pIndex) =>
		{
			const tmpEntry = tmpEntries[pIndex];
			if (tmpEntry)
			{
				tmpEntry.LinkedTo = tmpEntry.LinkedTo || {};
				tmpEntry.LinkedTo[tmpKey] = true;
			}
		};
		let tmpPending = tmpSources.map((pSource, pIndex) => pIndex).filter((pIndex) => !fLinked(pIndex));
		if (!pFresh && tmpPending.some((pIndex) => Number(tmpSources[pIndex].IDMedia) > 0))
		{
			const tmpExisting = await this.api.getSources(pIDProject);
			/** @type {Record<string, boolean>} */
			const tmpMediaKeys = {};
			((tmpExisting && tmpExisting.Sources) || []).forEach((pRow) =>
			{
				const tmpIDMedia = Number(pRow && pRow.IDMedia) || 0;
				if (tmpIDMedia > 0)
				{
					tmpMediaKeys[`${String(pRow.Name)}|${tmpIDMedia}`] = true;
				}
			});
			tmpPending = tmpPending.filter((pIndex) =>
			{
				const tmpSource = tmpSources[pIndex];
				const tmpIDMedia = Number(tmpSource.IDMedia) || 0;
				if ((tmpIDMedia > 0) && tmpMediaKeys[`${tmpSource.Name}|${tmpIDMedia}`])
				{
					fMark(pIndex);
					return false;
				}
				return true;
			});
		}
		for (let i = 0; i < tmpPending.length; i += MAX_SOURCES_PER_CALL)
		{
			const tmpChunk = tmpPending.slice(i, i + MAX_SOURCES_PER_CALL);
			await this.api.addSources(pIDProject, tmpChunk.map((pIndex) => tmpSources[pIndex]));
			tmpChunk.forEach(fMark);
		}
		return tmpSources.filter((pSource, pIndex) => fLinked(pIndex));
	}

	// ── Go (D9 + C2–C5, C8) ────────────────────────────────────────────────────────────────────────────────────

	/**
	 * The default form name: the name input, else the request's first heading/line (≤ 80), else the first file's name,
	 * else "Untitled form <YYYY-MM-DD HH:mm>".
	 * @return {string}
	 */
	_defaultFormName()
	{
		const tmpTyped = String(this._formName || '').replace(/[\x00-\x1f\x7f]/g, '').trim();
		if (tmpTyped)
		{
			return tmpTyped.slice(0, 200);
		}
		const tmpText = String(this._draft || '');
		const tmpHeading = /^\s{0,3}#{1,6}\s+(.+?)\s*#*\s*$/m.exec(tmpText);
		let tmpLine = tmpHeading ? tmpHeading[1] : (tmpText.split(/\r?\n/).map((pLine) => pLine.trim()).find((pLine) => !!pLine) || '');
		tmpLine = tmpLine.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/^[-*+>\s]+/, '').replace(/[*_`#]/g, '').replace(/[\x00-\x1f\x7f]/g, '').trim();
		if (tmpLine)
		{
			return tmpLine.slice(0, 80).trim();
		}
		const tmpFirst = this._stage.composer.find((pEntry) => pEntry && pEntry.Name);
		if (tmpFirst)
		{
			const tmpBase = String(tmpFirst.Name).replace(/\.[A-Za-z0-9]{1,8}$/, '').replace(/[\x00-\x1f\x7f]/g, '').trim();
			if (tmpBase)
			{
				return tmpBase.slice(0, 80);
			}
		}
		const tmpNow = new Date(this._now());
		const fPad = (pN) => ((pN < 10) ? '0' : '') + pN;
		return `Untitled form ${tmpNow.getFullYear()}-${fPad(tmpNow.getMonth() + 1)}-${fPad(tmpNow.getDate())} ${fPad(tmpNow.getHours())}:${fPad(tmpNow.getMinutes())}`;
	}

	/**
	 * Busy text on #FCG-Go (the only region Busy repaints).
	 * @param {string} pText
	 */
	_setBusy(pText)
	{
		this.state.Busy = true;
		this.state.BusyText = pText;
		this._paintGo();
	}

	/** Clear Busy and repaint Go. */
	_clearBusy()
	{
		this.state.Busy = false;
		this.state.BusyText = '';
		this._paintGo();
	}

	/**
	 * Go: Status (NodeBusy) → workspace → form (create; kept for retries) → sources (deduped) → session → open it.
	 * Idempotent after a failure: the created form id is kept (and in the URL), and linked sources are skipped.
	 * @return {Promise<void>}
	 */
	async go()
	{
		const tmpState = this.state;
		if (tmpState.Busy || (tmpState.Mode !== 'home'))
		{
			return;
		}
		this._captureEditor('composer');
		const tmpFlow = tmpState.Flow;
		const tmpText = String(this._draft || '').trim();
		const tmpBlock = this._goBlock();
		if (tmpBlock.Disabled)
		{
			this._paintGo();
			return;
		}
		const tmpReady = (tmpFlow === 'build') ? [] : this._stage.composer.filter((pEntry) => pEntry.Status === 'ready');
		if ((tmpFlow === 'create') && !tmpText && !tmpReady.length)
		{
			this._toast('Describe the form, or add at least one file.', 'info');
			return;
		}
		if ((tmpFlow === 'update') && !tmpText)
		{
			this._toast('Describe the change you want.', 'info');
			return;
		}
		const tmpToken = this._routeToken();
		this._setBusy('Checking the plansheet node…');
		try
		{
			await this._refreshStatus();
			if (this._nodeBusy)
			{
				this._clearBusy();
				this._paintHeader();
				return;
			}
			if (!this._workspaceReady)
			{
				this._setBusy('Preparing the workspace…');
				await this.api.ensureWorkspace();
				this._workspaceReady = true;
			}
			let tmpIDProject = Number(tmpState.IDProject) || 0;
			let tmpFresh = false;
			if ((tmpFlow === 'create') && !tmpIDProject)
			{
				this._setBusy('Creating the form project…');
				const tmpCreated = await this.api.createForm({ Name: this._defaultFormName() });
				const tmpForm = (tmpCreated && tmpCreated.Form) || {};
				tmpIDProject = this._validID(tmpForm.IDProject);
				if (!tmpIDProject)
				{
					throw new Error('Plansheet did not return the new form project.');
				}
				tmpFresh = true;
				tmpState.IDProject = tmpIDProject;
				if (this._forms && Array.isArray(this._forms.Forms) && !this._findForm(tmpIDProject))
				{
					this._forms.Forms.unshift(tmpForm);
				}
				// Only while the user is still on this Go's route: never rewrite the URL of a screen they moved to.
				if (this._routeToken() === tmpToken)
				{
					this._replaceHash(`#/FormConcierge/create/${tmpIDProject}`);
					// The screen now matches the URL it wrote, so a Retry after a failed reload resumes this form.
					this._lastApply = (pProvider) => pProvider.routeApplyFlow('create', tmpIDProject);
				}
				this._paintTarget();
			}
			const tmpPlan = this._planSources(tmpReady, tmpFlow);
			/** @type {Array<any>} */
			let tmpLinked = [];
			if (tmpPlan.Sources.length)
			{
				this._setBusy(`Linking ${tmpPlan.Sources.length} source${tmpPlan.Sources.length === 1 ? '' : 's'} to the form…`);
				tmpLinked = await this._linkSources(tmpIDProject, tmpPlan, tmpFresh);
			}
			if (tmpPlan.Skipped.length)
			{
				this._toast(`Not linked (no text could be extracted and over 5 MB): ${tmpPlan.Skipped.join(', ')}`, 'warning');
			}
			this._setBusy('Starting the run…');
			/** @type {any} */
			const tmpBody = { Flow: tmpFlow, IDProject: tmpIDProject, Text: tmpText };
			if (tmpFlow === 'build')
			{
				if (this._validateOnly)
				{
					tmpBody.ValidateOnly = true;
				}
				else
				{
					tmpBody.DeliverTo = String(this._deliverTo || '').trim().slice(0, 200);
				}
			}
			// Announce only what is on the form for this turn, never a planned name that did not get linked.
			if ((tmpFlow === 'examples') && tmpLinked.length)
			{
				tmpBody.NewSources = tmpLinked.map((pSource) => pSource.Name);
			}
			let tmpResult = null;
			try
			{
				tmpResult = await this.api.startSession(tmpBody);
			}
			catch (pError)
			{
				if ((tmpFlow !== 'build') || !pError || (pError.Code !== 'NoBlueprint'))
				{
					throw pError;
				}
				const tmpModal = this.modal;
				const tmpForce = (tmpModal && (typeof tmpModal.confirm === 'function'))
					? await tmpModal.confirm('This form has no agreed blueprint yet. Build it anyway from its sources?', { title: 'No blueprint', confirmLabel: 'Build anyway', cancelLabel: 'Cancel' })
					: false;
				if (!tmpForce)
				{
					this._clearBusy();
					return;
				}
				tmpBody.Force = true;
				tmpResult = await this.api.startSession(tmpBody);
			}
			const tmpIDRequest = this._validID(tmpResult && tmpResult.IDRequest);
			if (!tmpIDRequest)
			{
				throw new Error('Plansheet did not return a session id.');
			}
			if (tmpResult && Array.isArray(tmpResult.Warnings) && (tmpResult.Warnings.indexOf('DeliveryIdentityUnrecognized') >= 0))
			{
				this._toast('The recorded delivery identity was not recognized, so the in-place guardrail was left out. Check the reply before pushing.', 'warning');
			}
			if (tmpPlan.Extras.length)
			{
				this._sessionFiles[tmpIDRequest] = (this._sessionFiles[tmpIDRequest] || []).concat(tmpPlan.Extras);
			}
			// Success (D7): clear the draft — the segment array and the mounted box too, or the route to the session
			// would capture the submitted text back into the draft — and take out only the files this Go submitted
			// (Build used none; files dropped while it ran stay staged). Then reset Create.
			this._resetEditor('composer');
			this._unstage('composer', tmpReady);
			if (tmpFlow === 'create')
			{
				this._formName = '';
				tmpState.IDProject = 0;
			}
			if (tmpFlow === 'build')
			{
				this._deliverTo = '';
				this._validateOnly = false;
			}
			tmpState.Busy = false;
			tmpState.BusyText = '';
			if (this._routeToken() === tmpToken)
			{
				this._paintFiles('composer');
				if (tmpFlow === 'create')
				{
					// The started form must not stay in history as "finish starting it": Back from the session lands Home.
					this._replaceHash('#/FormConcierge');
				}
				this._navigate(`#/FormConcierge/Session/${tmpIDRequest}`);
			}
			else
			{
				this._toast(`Session #${tmpIDRequest} started. It is in Recent sessions.`, 'success');
				if (this.state.Mode === 'home')
				{
					this._paintFiles('composer');
				}
			}
		}
		catch (pError)
		{
			this._onSubmitError(pError);
			this._clearBusy();
		}
	}

	/**
	 * A Go/Send/resubmit failure: NodeBusy disables the buttons (until Check again); everything else toasts.
	 * @param {any} pError
	 */
	_onSubmitError(pError)
	{
		if (pError && (pError.Code === 'NodeBusy'))
		{
			const tmpBody = pError.Body || {};
			this._nodeBusy = { IDRequest: Number(tmpBody.IDRequest) || 0, StageLabel: '' };
			this._paintHeader();
		}
		this._toast(this._errorText(pError), (pError && (pError.Code === 'NodeBusy')) ? 'warning' : 'error');
	}

	// ── Follow-up, cancel, resubmit ────────────────────────────────────────────────────────────────────────────

	/** @return {string} why Send is off ('' = on) */
	_sendBlockReason()
	{
		const tmpPayload = this._session;
		if (!tmpPayload)
		{
			return 'Loading the session…';
		}
		if (this._phase && this._phase.Active)
		{
			return 'A run is in progress. Keep typing; Send unlocks when it finishes.';
		}
		const tmpIDRequest = Number(tmpPayload.Session && tmpPayload.Session.IDRequest) || 0;
		if (this._nodeBusy && (Number(this._nodeBusy.IDRequest) !== tmpIDRequest))
		{
			return `The plansheet node is busy${Number(this._nodeBusy.IDRequest) ? ` with request #${Number(this._nodeBusy.IDRequest)}` : ''}. Send stays off until it finishes.`;
		}
		const tmpBusy = this._stage.followup.filter((pEntry) => (pEntry.Status === 'uploading') || (pEntry.Status === 'converting')).length;
		if (tmpBusy)
		{
			return `Waiting for ${tmpBusy} file${tmpBusy === 1 ? '' : 's'} to finish uploading.`;
		}
		if (this._stage.followup.some((pEntry) => pEntry.Status === 'error'))
		{
			return 'Remove or retry the file that failed.';
		}
		return '';
	}

	/** Toggle Send (disabled + note) and the follow-up wrapper class — never a repaint. */
	_syncFollowUpLock()
	{
		const tmpReason = this._sendBlockReason();
		const tmpButton = this._el('FCG-SendBtn');
		if (tmpButton)
		{
			tmpButton.disabled = !!tmpReason || !!this.state.SendBusy;
			tmpButton.innerHTML = this.state.SendBusy ? '<i class="fas fa-circle-notch fa-spin"></i> Sending…' : '<i class="fas fa-paper-plane"></i> Send';
		}
		const tmpWrap = this._el('FCG-FollowUp');
		if (tmpWrap && tmpWrap.classList)
		{
			tmpWrap.classList.toggle('fcg-fu-locked', !!(this._phase && this._phase.Active));
		}
		const tmpNote = this._el('FCG-SendNote');
		if (tmpNote)
		{
			tmpNote.textContent = tmpReason;
		}
		const tmpRecheck = this._el('FCG-RecheckBtn');
		if (tmpRecheck && tmpRecheck.classList)
		{
			const tmpIDRequest = Number(this._session && this._session.Session && this._session.Session.IDRequest) || 0;
			tmpRecheck.classList.toggle('fcg-hidden', !(this._nodeBusy && (Number(this._nodeBusy.IDRequest) !== tmpIDRequest)));
		}
	}

	/**
	 * Send a follow-up: Status (NodeBusy) → new files become sources first (C7) → POST Message → poll.
	 * @return {Promise<void>}
	 */
	async sendFollowUp()
	{
		const tmpState = this.state;
		if (tmpState.SendBusy || (tmpState.Mode !== 'session') || !this._session)
		{
			return;
		}
		this._captureEditor('followup');
		const tmpText = String(this._followDraft || '').trim();
		const tmpReason = this._sendBlockReason();
		if (tmpReason)
		{
			this._toast(tmpReason, 'info');
			this._syncFollowUpLock();
			return;
		}
		if (!tmpText)
		{
			this._toast('Write the follow-up first.', 'info');
			return;
		}
		const tmpPayload = this._session;
		const tmpIDRequest = Number(tmpState.IDRequest) || 0;
		const tmpIDProject = Number((tmpPayload.Form && tmpPayload.Form.IDProject) || (tmpPayload.Session && tmpPayload.Session.IDProject)) || 0;
		const tmpFlow = String((tmpPayload.Session && tmpPayload.Session.Flow) || '').toLowerCase();
		tmpState.SendBusy = true;
		this._syncFollowUpLock();
		try
		{
			await this._refreshStatus();
			if (this._nodeBusy && (Number(this._nodeBusy.IDRequest) !== tmpIDRequest))
			{
				tmpState.SendBusy = false;
				this._syncFollowUpLock();
				this._toast(this._sendBlockReason() || ERROR_TEXT.NodeBusy, 'warning');
				return;
			}
			const tmpReady = this._stage.followup.filter((pEntry) => pEntry.Status === 'ready');
			const tmpPlan = this._planSources(tmpReady, tmpFlow === 'examples' ? 'examples' : 'other');
			/** @type {Array<any>} */
			let tmpLinked = [];
			if (tmpPlan.Sources.length && tmpIDProject)
			{
				tmpLinked = await this._linkSources(tmpIDProject, tmpPlan, false);
			}
			if (tmpPlan.Skipped.length)
			{
				this._toast(`Not linked (no text could be extracted and over 5 MB): ${tmpPlan.Skipped.join(', ')}`, 'warning');
			}
			/** @type {any} */
			const tmpBody = { Text: tmpText };
			if (tmpLinked.length)
			{
				tmpBody.NewSources = tmpLinked.map((pSource) => pSource.Name);
			}
			await this.api.sendMessage(tmpIDRequest, tmpBody);
			if (tmpPlan.Extras.length)
			{
				this._sessionFiles[tmpIDRequest] = (this._sessionFiles[tmpIDRequest] || []).concat(tmpPlan.Extras);
			}
			// Only the submitted files leave staging (files dropped during the send stay). The box is emptied only
			// while it still belongs to this session: a switch mid-send gave it, and its staging, to another one.
			this._unstage('followup', tmpReady);
			tmpState.SendBusy = false;
			if (this._followFor === tmpIDRequest)
			{
				this._resetEditor('followup');
			}
			this._paintFiles('followup');
			if (Number(tmpState.IDRequest) === tmpIDRequest)
			{
				await this._openSession(true);
			}
		}
		catch (pError)
		{
			tmpState.SendBusy = false;
			this._onSubmitError(pError);
			this._syncFollowUpLock();
		}
	}

	/**
	 * Cancel the active run (best-effort upstream; a claimed run may still finish), then refresh.
	 * @return {Promise<void>}
	 */
	async cancelRun()
	{
		const tmpIDRequest = Number(this.state.IDRequest) || 0;
		if (!tmpIDRequest || (this.state.Mode !== 'session'))
		{
			return;
		}
		const tmpModal = this.modal;
		const tmpOK = (tmpModal && (typeof tmpModal.confirm === 'function'))
			? await tmpModal.confirm('Ask the plansheet node to cancel this run? A run that has already started may still finish.', { title: 'Cancel run', confirmLabel: 'Cancel the run', cancelLabel: 'Keep it running', dangerous: true })
			: false;
		if (!tmpOK)
		{
			return;
		}
		try
		{
			const tmpResult = await this.api.cancelSession(tmpIDRequest);
			this._toast((tmpResult && tmpResult.Claimed)
				? 'Cancel requested. The node stops at its next heartbeat and may still finish.'
				: 'Cancelled. The run had not started.', 'info');
		}
		catch (pError)
		{
			this._toast(this._errorText(pError), 'error');
		}
		if ((this.state.Mode === 'session') && (Number(this.state.IDRequest) === tmpIDRequest))
		{
			await this._openSession(true);
		}
	}

	/**
	 * Submit again (not picked up / cancelled before starting) or Try again (failed), always from the STRIPPED user
	 * text, never raw Content: an examples turn re-runs the examples flow; a never-started first turn becomes a new
	 * session of the same flow (Build goes back to its composer for the delivery target); anything else is re-sent as
	 * a follow-up.
	 * @return {Promise<void>}
	 */
	async resubmit()
	{
		const tmpState = this.state;
		const tmpPayload = this._session;
		const tmpPhase = this._phase;
		if (!tmpPayload || !tmpPhase || !tmpPhase.Terminal || tmpState.SendBusy || (tmpState.Mode !== 'session'))
		{
			return;
		}
		const tmpMessages = this._messages(tmpPayload);
		const tmpUserTurns = tmpMessages.filter((pMessage) => !this._isAssistant(pMessage));
		const tmpLastUser = tmpUserTurns[tmpUserTurns.length - 1] || null;
		const tmpText = String(this._userText(tmpLastUser)).trim();
		const tmpSession = tmpPayload.Session || {};
		const tmpFlow = String(tmpSession.Flow || '').toLowerCase();
		const tmpIDProject = Number((tmpPayload.Form && tmpPayload.Form.IDProject) || tmpSession.IDProject) || 0;
		const tmpIDRequest = Number(tmpSession.IDRequest || tmpState.IDRequest) || 0;
		const tmpExamplesPrefix = this.md.EXAMPLES_PREFIX || DEFAULT_EXAMPLES_PREFIX;
		const tmpIsExamples = !!tmpLastUser && (String(tmpLastUser.Content || '').indexOf(tmpExamplesPrefix) === 0);
		const tmpNewSession = tmpPhase.SubmitAgain && (tmpUserTurns.length <= 1);
		if (tmpNewSession && ([ 'build', 'config' ].indexOf(tmpFlow) >= 0) && !tmpIsExamples)
		{
			this._toast('Enter the delivery target again, then Build & deliver.', 'info');
			this._navigate(`#/FormConcierge/build/${tmpIDProject}`);
			return;
		}
		if (!tmpText && !(tmpNewSession || tmpIsExamples))
		{
			this._toast('There is no request text to send again.', 'info');
			return;
		}
		tmpState.SendBusy = true;
		this._syncFollowUpLock();
		try
		{
			await this._refreshStatus();
			if (this._nodeBusy && (Number(this._nodeBusy.IDRequest) !== tmpIDRequest))
			{
				tmpState.SendBusy = false;
				this._syncFollowUpLock();
				this._toast(this._sendBlockReason() || ERROR_TEXT.NodeBusy, 'warning');
				return;
			}
			if (tmpIsExamples || tmpNewSession)
			{
				const tmpNewFlow = tmpIsExamples ? 'examples' : (([ 'update', 'modify' ].indexOf(tmpFlow) >= 0) ? 'update' : 'create');
				const tmpResult = await this.api.startSession({ Flow: tmpNewFlow, IDProject: tmpIDProject, Text: tmpText });
				const tmpNewID = this._validID(tmpResult && tmpResult.IDRequest);
				tmpState.SendBusy = false;
				if (!tmpNewID)
				{
					throw new Error('Plansheet did not return a session id.');
				}
				if (tmpNewID === Number(tmpState.IDRequest))
				{
					await this._openSession(true);
				}
				else
				{
					this._navigate(`#/FormConcierge/Session/${tmpNewID}`);
				}
				return;
			}
			await this.api.sendMessage(tmpIDRequest, { Text: tmpText });
			tmpState.SendBusy = false;
			await this._openSession(true);
		}
		catch (pError)
		{
			tmpState.SendBusy = false;
			this._onSubmitError(pError);
			this._syncFollowUpLock();
		}
	}
}

module.exports = FormConciergeProvider;
module.exports.default_configuration = { ProviderIdentifier: 'FormConcierge' };
module.exports.FormConciergeMarkdownEditor = FormConciergeMarkdownEditor;

},{"./FormConcierge-Api.js":1275,"./FormConcierge-FileText.js":1276,"./FormConcierge-Markdown.js":1277,"./FormConcierge-Mirror.js":1278,"pict-provider":845,"pict-section-markdowneditor":955}],1280:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

// Drives the Headlight Academy full-page view. Owns no doc content of its own — it reuses the inline-doc
// provider (`Pict-InlineDocumentation`): `AppData.InlineDocumentation.SidebarGroups` for the TOC and
// `_fetchDocument(DocsBaseURL + path)` for a rendered (AcademyContent-layered) article, so the Academy, the
// help panel, and the doc editor always agree. Navigation between articles is client-side (no view re-render);
// the route only mounts the shell.

class AcademyProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._current = null;      // path of the article shown (e.g. 'organizations.md')
		this._targetPath = null;   // path the pending mount should open
		this._filter = '';         // lowercased TOC filter text
		this._clickBound = false;
	}

	get docProvider() { return this.pict.providers['Pict-InlineDocumentation'] || null; }
	get docState() { return (this.pict.AppData && this.pict.AppData.InlineDocumentation) || {}; }
	/** The host application's documentationProfile. Read from the application itself rather than only
	 *  from AppData, because this screen can render BEFORE the help panel publishes it there — and a
	 *  half-initialized read would paint the host app's name over a micro app's Academy. */
	get docProfile()
	{
		const tmpPublished = this.pict.AppData && this.pict.AppData.DocumentationProfile;
		if (tmpPublished) { return tmpPublished; }
		const tmpApplication = this.pict.PictApplication;
		return (tmpApplication && tmpApplication.documentationProfile) || {};
	}
	get docsBase() { return this.docState.DocsBaseURL || this.docProfile.DocsBaseURL || 'docs/'; }
	get landingArticle() { return this.docProfile.LandingArticle || 'overview.md'; }
	get groups() { return this.docState.SidebarGroups || []; }

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	/** Normalize a route topic ('organizations', 'organizations.md', '#/page/foo.md') to a doc path ('foo.md'). */
	_resolvePath(pTopic)
	{
		if (!pTopic) { return this.landingArticle; }
		let tmpPath = String(pTopic).replace(/^#?\/?(page\/)?/, '').replace(/^\.\//, '').replace(/^\//, '').replace(/#.*$/, '');
		if (!tmpPath) { return this.landingArticle; }
		if (!/\.md$/i.test(tmpPath)) { tmpPath += '.md'; }
		return tmpPath;
	}

	/** Set the article a pending route should open. The router calls this BEFORE (re-)rendering the shell, so the
	 *  view's onAfterRender → onViewRendered opens the right doc (not the overview default). */
	prepare(pTopic)
	{
		this._targetPath = this._resolvePath(pTopic);
	}

	/** When the shell is already mounted (route change without a re-render), swap the target article in place. */
	showTargetIfMounted()
	{
		if (this._targetPath && this._targetPath !== this._current) { this.openArticle(this._targetPath, false); }
	}

	/** Called by the view once its shell DOM exists. Ensure the TOC data is loaded, paint it, wire clicks, open. */
	onViewRendered()
	{
		// The shell ships neutral copy; the app names itself here so a micro app does not present its
		// inspectors with "Guides and reference for configuring your platform."
		this._paintHeading();
		this._ensureSidebar(() =>
		{
			this._paintHeading();
			this._bindClicks();
			this.renderTOC();
			this.openArticle(this._targetPath || this._current || this.landingArticle, false);
		});
	}

	/**
	 * The Academy can be the first screen to ask for documentation, before the help panel has ever been
	 * opened. Until the app initializes the inline-doc provider it has no docs root, so a sidebar load
	 * fetches nothing and the table of contents paints empty and never recovers. Kick the initialization
	 * first, then load.
	 */
	/** The shell ships the host app's copy; the running app names itself here, so a micro app does not
	 *  greet its inspectors with "Guides and reference for configuring your platform." */
	_paintHeading()
	{
		const tmpProfile = this.docProfile;
		if (!tmpProfile.Title) { return; }
		this.pict.ContentAssignment.assignContent('#Academy-Title', this._esc(tmpProfile.Title));
		this.pict.ContentAssignment.assignContent('#Academy-Subtitle', this._esc(tmpProfile.Subtitle || ''));
	}

	_ensureSidebar(fCallback)
	{
		if (this.groups.length) { return fCallback(); }
		const tmpApplication = this.pict.PictApplication;
		if (tmpApplication && !tmpApplication._helpInitialized && (typeof tmpApplication._initializeHelpDocumentation === 'function'))
		{
			tmpApplication._initializeHelpDocumentation();
		}
		const tmpDoc = this.docProvider;
		if (tmpDoc && typeof tmpDoc._loadSidebar === 'function') { return tmpDoc._loadSidebar(() => fCallback()); }
		return fCallback();
	}

	_matchesFilter(pItem)
	{
		if (!this._filter) { return true; }
		return String(pItem.Name || '').toLowerCase().indexOf(this._filter) !== -1;
	}

	renderTOC()
	{
		const tmpHTML = this.groups.map((pGroup) =>
		{
			const tmpItems = (pGroup.Items || []).filter((pItem) => this._matchesFilter(pItem)).map((pItem) =>
			{
				const tmpActive = (pItem.Path === this._current) ? ' ha-active' : '';
				const tmpIndent = pItem.Level ? ` style="padding-left:${10 + (pItem.Level * 14)}px"` : '';
				return `<a class="ha-toc-item${tmpActive}" data-ha-path="${this._esc(pItem.Path)}"${tmpIndent}>${this._esc(pItem.Name)}</a>`;
			}).join('');
			if (!tmpItems) { return ''; }
			return `<div class="ha-toc-group"><div class="ha-toc-group-title">${this._esc(pGroup.Name)}</div>${tmpItems}</div>`;
		}).join('');
		this.pict.ContentAssignment.assignContent('#Academy-TOC', tmpHTML || '<div class="ha-toc-empty">No articles match your filter.</div>');
	}

	onFilterInput(pText)
	{
		this._filter = String(pText || '').toLowerCase().trim();
		this.renderTOC();
	}

	/** Fetch + render an article into the article pane (reusing the inline-doc pipeline), update TOC highlight and
	 *  the hash route. pUpdateRoute=false when the load was itself driven by a route change. */
	openArticle(pPath, pUpdateRoute)
	{
		const tmpPath = this._resolvePath(pPath);
		this._current = tmpPath;
		this.renderTOC();
		this.pict.ContentAssignment.assignContent('#Academy-Article', '<div class="ha-loading"><span class="ha-spinner"></span> Loading…</div>');

		const tmpDoc = this.docProvider;
		if (!tmpDoc || typeof tmpDoc._fetchDocument !== 'function')
		{
			this.pict.ContentAssignment.assignContent('#Academy-Article', '<div class="ha-empty"><i class="fas fa-triangle-exclamation"></i><p>Documentation is unavailable.</p></div>');
			return;
		}
		tmpDoc._fetchDocument(this.docsBase + tmpPath, (pError, pHTML) =>
		{
			if (this._current !== tmpPath) { return; }   // a newer article was requested; drop this paint
			if (pError || !pHTML)
			{
				this.pict.ContentAssignment.assignContent('#Academy-Article', `<div class="ha-empty"><i class="fas fa-triangle-exclamation"></i><p>Could not load &ldquo;${this._esc(tmpPath)}&rdquo;.</p></div>`);
				return;
			}
			this.pict.ContentAssignment.assignContent('#Academy-Article', `<article class="ha-doc">${pHTML}</article>`);
			const tmpEl = this.pict.ContentAssignment.getElement('#Academy-Article');
			if (tmpEl && tmpEl[0]) { tmpEl[0].scrollTop = 0; }
		});

		if (pUpdateRoute !== false && typeof window !== 'undefined' && window.location)
		{
			const tmpWant = `/Academy/${tmpPath.replace(/\.md$/i, '')}`;
			if (window.location.hash.replace(/^#/, '') !== tmpWant) { window.location.hash = tmpWant; }
		}
	}

	/** One delegated click handler (survives shell re-renders) for TOC items (data-ha-path) and in-doc cross-links
	 *  (the inline-doc link resolver marks them rel="pict-inline-doc-link:<path>"). */
	_bindClicks()
	{
		if (this._clickBound || typeof document === 'undefined') { return; }
		this._clickBound = true;
		document.addEventListener('click', (pEvent) =>
		{
			const tmpTarget = pEvent.target && pEvent.target.closest ? pEvent.target.closest('[data-ha-path], a[rel^="pict-inline-doc-link:"]') : null;
			if (!tmpTarget || !tmpTarget.closest('#Academy-Container')) { return; }
			pEvent.preventDefault();
			let tmpPath = tmpTarget.getAttribute('data-ha-path');
			if (!tmpPath)
			{
				const tmpRel = tmpTarget.getAttribute('rel') || '';
				tmpPath = tmpRel.replace(/^pict-inline-doc-link:/, '');
			}
			if (tmpPath) { this.openArticle(tmpPath, true); }
		});
	}
}

AcademyProvider.default_configuration =
{
	ProviderIdentifier: 'Academy',
	AutoInitialize: true,
	AutoInitializeOrdinal: 260,
};

module.exports = AcademyProvider;

},{"pict-provider":845}],1281:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

// Full-page documentation browser ("Headlight Academy"). A reading-first companion to the compact inline help
// panel: it reuses the SAME doc pipeline (pict-section-inlinedocumentation → AcademyContent-layered markdown), so
// the TOC and every article match the panel + the doc editor, with customer overrides applied. The view renders a
// static shell; the Academy provider paints the TOC + article into it (see Academy-Provider.js).

const HELP_CENTER_CSS = /*css*/`
#Academy-Container.ha-wrap { display:flex; flex-direction:column; min-height: calc(100vh - 110px); background: var(--theme-color-surface, #fff); border-radius: 10px; box-shadow: 0 1px 3px rgba(15,23,42,.08); overflow:hidden; }
.ha-header { display:flex; justify-content:space-between; align-items:center; gap:16px; flex-wrap:wrap; padding: 20px 26px; border-bottom:1px solid var(--theme-color-border, #e2e8f0); }
.ha-header-main { display:flex; align-items:center; gap:14px; min-width:0; }
.ha-header-icon { font-size:24px; color: var(--theme-color-brand-primary, #5650e6); }
.ha-title { margin:0; font-size:21px; font-weight:700; color: var(--theme-color-text, #0f172a); letter-spacing:-.01em; }
.ha-subtitle { margin:2px 0 0; font-size:13px; color: var(--theme-color-text-muted, #64748b); }
.ha-search { position:relative; flex:0 0 auto; }
.ha-search input { width:240px; max-width:52vw; padding:8px 12px 8px 32px; border:1px solid var(--theme-color-border, #e2e8f0); border-radius:8px; font-size:13px; background: var(--theme-color-surface-muted, #f8fafc); color: var(--theme-color-text, #0f172a); }
.ha-search input:focus { outline:none; border-color: var(--theme-color-brand-primary, #5650e6); box-shadow:0 0 0 3px rgba(86,80,230,.12); background:#fff; }
.ha-search i { position:absolute; left:11px; top:50%; transform:translateY(-50%); color:#94a3b8; font-size:12px; }
.ha-body { display:flex; align-items:flex-start; flex:1; min-height:0; }
.ha-toc { flex:0 0 272px; width:272px; align-self:stretch; position:sticky; top:0; max-height: calc(100vh - 110px); overflow-y:auto; padding:16px 10px 24px; border-right:1px solid var(--theme-color-border, #e2e8f0); background: var(--theme-color-surface-muted, #f8fafc); }
.ha-toc-group { margin-bottom:14px; }
.ha-toc-group-title { font-size:11px; text-transform:uppercase; letter-spacing:.06em; color:#94a3b8; font-weight:700; padding:4px 10px 6px; }
.ha-toc-item { display:block; padding:6px 10px; border-radius:6px; color: var(--theme-color-text, #334155); text-decoration:none; font-size:13.5px; line-height:1.35; cursor:pointer; }
.ha-toc-item:hover { background: rgba(86,80,230,.08); color: var(--theme-color-brand-primary, #5650e6); }
.ha-toc-item.ha-active { background: var(--theme-color-brand-primary, #5650e6); color:#fff; font-weight:600; }
.ha-toc-empty { padding:12px; color:#94a3b8; font-size:13px; font-style:italic; }
.ha-article { flex:1; min-width:0; overflow-y:auto; padding: 26px 40px 60px; }
.ha-loading, .ha-empty { color:#64748b; font-size:14px; padding:24px 0; display:flex; align-items:center; gap:10px; }
.ha-empty { flex-direction:column; align-items:flex-start; gap:6px; }
.ha-empty i { color:#cf5b5b; font-size:20px; }
.ha-spinner { width:16px; height:16px; border:2px solid #cbd5e1; border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius:50%; display:inline-block; animation: ha-spin .7s linear infinite; }
@keyframes ha-spin { to { transform: rotate(360deg); } }

/* Article typography (rendered markdown) */
.ha-doc { max-width: 780px; color: var(--theme-color-text, #1e293b); font-size:15px; line-height:1.65; }
.ha-doc > :first-child { margin-top:0; }
.ha-doc h1 { font-size:26px; font-weight:700; letter-spacing:-.02em; margin:0 0 8px; color: var(--theme-color-text, #0f172a); }
.ha-doc h2 { font-size:19px; font-weight:700; margin:28px 0 8px; padding-bottom:5px; border-bottom:1px solid var(--theme-color-border, #eef2f6); color: var(--theme-color-text, #0f172a); }
.ha-doc h3 { font-size:16px; font-weight:700; margin:22px 0 6px; }
.ha-doc p { margin:0 0 12px; }
.ha-doc ul, .ha-doc ol { margin:0 0 12px; padding-left:22px; }
.ha-doc li { margin:4px 0; }
.ha-doc a { color: var(--theme-color-brand-primary, #5650e6); text-decoration:none; }
.ha-doc a:hover { text-decoration:underline; }
.ha-doc code { background: var(--theme-color-surface-muted, #f1f5f9); padding:1.5px 5px; border-radius:4px; font-size:.88em; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
.ha-doc pre { background: #0f172a; color:#e2e8f0; padding:14px 16px; border-radius:8px; overflow-x:auto; margin:0 0 14px; }
.ha-doc pre code { background:none; padding:0; color:inherit; font-size:13px; }
.ha-doc blockquote { margin:0 0 14px; padding:6px 14px; border-left:3px solid var(--theme-color-brand-primary, #5650e6); background: rgba(86,80,230,.05); color:#475569; }
.ha-doc table { border-collapse:collapse; width:100%; margin:0 0 16px; font-size:14px; }
.ha-doc th, .ha-doc td { border:1px solid var(--theme-color-border, #e2e8f0); padding:7px 10px; text-align:left; }
.ha-doc th { background: var(--theme-color-surface-muted, #f8fafc); font-weight:600; }
.ha-doc img { max-width:100%; border-radius:6px; }
.ha-doc hr { border:none; border-top:1px solid var(--theme-color-border, #e2e8f0); margin:22px 0; }
@media (max-width: 820px) {
	.ha-body { flex-direction:column; }
	.ha-toc { position:static; width:auto; flex-basis:auto; max-height:none; border-right:none; border-bottom:1px solid var(--theme-color-border, #e2e8f0); }
	.ha-article { padding:20px; }
}
`;

const HELP_CENTER_TEMPLATES =
[
	{
		Hash: 'Academy-Shell',
		Template: /*html*/`
			<div id="Academy-Container" class="ha-wrap">
				<header class="ha-header">
					<div class="ha-header-main">
						<i class="fas fa-graduation-cap ha-header-icon"></i>
						<div>
							<h1 id="Academy-Title" class="ha-title">Headlight Academy</h1>
							<p id="Academy-Subtitle" class="ha-subtitle">Guides and reference for configuring your platform.</p>
						</div>
					</div>
					<div class="ha-search">
						<i class="fas fa-magnifying-glass"></i>
						<input id="Academy-Filter" type="text" placeholder="Filter articles…" autocomplete="off"
							oninput="_Pict.providers.Academy.onFilterInput(this.value)" />
					</div>
				</header>
				<div class="ha-body">
					<nav id="Academy-TOC" class="ha-toc"></nav>
					<main id="Academy-Article" class="ha-article"></main>
				</div>
			</div>`,
	},
];

class AcademyView extends libPictView
{
	onAfterRender()
	{
		const tmpProvider = this.pict.providers.Academy;
		if (tmpProvider && typeof tmpProvider.onViewRendered === 'function') { tmpProvider.onViewRendered(); }
		return super.onAfterRender();
	}
}

AcademyView.default_configuration =
{
	ViewIdentifier: 'Academy',
	DefaultRenderable: 'Academy-Shell',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: HELP_CENTER_CSS,
	Templates: HELP_CENTER_TEMPLATES,
	Renderables: [ { RenderableHash: 'Academy-Shell', TemplateHash: 'Academy-Shell', DestinationAddress: '#PlatformConfiguration-Application-Container', RenderMethod: 'replace' } ],
};

module.exports = AcademyView;

},{"pict-view":1053}],1282:[function(require,module,exports){
/**
 * Platform documentation registry — the single source of truth for the config app's F1 / `?` help.
 *
 * Every help topic is authored as markdown under ./ (this help/ folder), MANAGED in the AcademyContent table
 * (seeded via PlatformDocs-Seed.js), and served cross-tenant by the API's `GET /1.0/PlatformDocument/:Hash`
 * (canonical customer-1 copy + per-customer override). The app fetches by Hash and injects into the shared
 * inline-documentation panel (the Sample Plan displayContent bridge); pressing F1 on a route resolves the doc
 * via ROUTE_DOC, and a per-area nav bar lets the reader move between sibling topics in the same feature.
 *
 * Pure data + helpers (no pict / REST / fs), so this is safe in the browser bundle AND in the Node seed
 * generator. Markdown content lives in the .md files, never here — it stays out of the browser bundle.
 *
 * Hashes are `Doc-<Area>-<Topic>` — one `Doc-` namespace, so the API allowlist stays a single entry. To add a
 * topic: add an entry below + a matching .md file under help/<area>/, then reseed (see PlatformDocs-Seed.js).
 * Each doc: { Topic, Title, Nav, File, Routes } — Routes are the F1 targets (empty = reachable only via the nav).
 */

'use strict';

const AREAS =
[
	{
		Area: 'Import',
		Docs:
		[
			{ Topic: 'Overview',        Title: 'Importing Contracts, Projects & Items', Nav: 'Overview',            File: 'import/overview.md',         Routes: [] },
			{ Topic: 'ContractPackage', Title: 'Import Contract Package',                Nav: 'Contract Package',    File: 'import/contract-package.md', Routes: [ '/ContractImport' ] },
			{ Topic: 'LineItems',       Title: 'Import Line Items',                      Nav: 'Line Items',          File: 'import/line-items.md',       Routes: [ '/ItemImport' ] },
			{ Topic: 'Example',         Title: 'Example: importing a contract',          Nav: 'Example',             File: 'import/example.md',          Routes: [] },
			{ Topic: 'Cleanup',         Title: 'Fixing a bad import',                    Nav: 'Fixing a bad import', File: 'import/cleanup.md',          Routes: [] },
		],
	},
	{
		Area: 'Access',
		Docs:
		[
			{ Topic: 'Overview',  Title: 'Access & Permissions',              Nav: 'Overview',       File: 'access/overview.md',  Routes: [ '/Access' ] },
			{ Topic: 'Matrix',    Title: 'The Permission Matrix',             Nav: 'Matrix',         File: 'access/matrix.md',    Routes: [] },
			{ Topic: 'Roles',     Title: 'Roles, Groups & Composition',       Nav: 'Roles & Groups', File: 'access/roles.md',     Routes: [] },
			{ Topic: 'Effective', Title: 'Assignment & Effective Permissions', Nav: 'Effective',      File: 'access/effective.md', Routes: [] },
		],
	},
	{
		Area: 'ApprovalWorkflow',
		Docs:
		[
			{ Topic: 'Overview', Title: 'Approval Workflows',           Nav: 'Overview', File: 'approval-workflow/overview.md', Routes: [ '/ApprovalWorkflows', '/ApprovalWorkflow' ] },
			{ Topic: 'Editor',   Title: 'Editing an approval workflow', Nav: 'Editor',   File: 'approval-workflow/editor.md',   Routes: [] },
			{ Topic: 'Bindings', Title: 'Binding types to workflows',   Nav: 'Bindings', File: 'approval-workflow/bindings.md', Routes: [] },
		],
	},
	{
		Area: 'ObservationType',
		Docs:
		[
			{ Topic: 'Overview',     Title: 'Observation Types',             Nav: 'Overview',     File: 'observation-type/overview.md',     Routes: [ '/ObservationType' ] },
			{ Topic: 'Requirements', Title: 'Requirements & Artifact Types', Nav: 'Requirements', File: 'observation-type/requirements.md', Routes: [] },
			{ Topic: 'Building',     Title: 'Building & cloning a type',     Nav: 'Building',     File: 'observation-type/building.md',     Routes: [] },
		],
	},
	{
		Area: 'Config',
		Docs:
		[
			{ Topic: 'Overview', Title: 'Configuration Explorer',   Nav: 'Overview', File: 'config/overview.md', Routes: [ '/ConfigViewer' ] },
			{ Topic: 'Editing',  Title: 'Editing at a scope',       Nav: 'Editing',  File: 'config/editing.md',  Routes: [] },
			{ Topic: 'Cloning',  Title: 'Cloning between contexts', Nav: 'Cloning',  File: 'config/cloning.md',  Routes: [ '/ConfigClone' ] },
		],
	},
	{
		Area: 'DataImport',
		Docs:
		[
			{ Topic: 'Overview', Title: 'Import Data',    Nav: 'Overview', File: 'dataimport/overview.md', Routes: [ '/DataImport' ] },
			{ Topic: 'Mapping',  Title: 'Mapping & keys', Nav: 'Mapping',  File: 'dataimport/mapping.md',  Routes: [] },
		],
	},
	{
		Area: 'Datalake',
		Docs:
		[
			{ Topic: 'Overview',   Title: 'The Data Lake Catalog',      Nav: 'Overview',   File: 'datalake/overview.md',   Routes: [ '/Datalake' ] },
			{ Topic: 'Projection', Title: 'Creating a projection',      Nav: 'Projection', File: 'datalake/projection.md', Routes: [ '/Datalake/New' ] },
			{ Topic: 'Datasets',   Title: 'Browsing & managing datasets', Nav: 'Datasets',   File: 'datalake/datasets.md',   Routes: [ '/Datalake/Dataset', '/Datalake/Table' ] },
		],
	},
	{
		Area: 'Entitlements',
		Docs:
		[
			{ Topic: 'Overview', Title: 'Entitlements',            Nav: 'Overview',       File: 'entitlements/overview.md', Routes: [ '/Entitlements' ] },
			{ Topic: 'Tasks',    Title: 'How tasks map to access', Nav: 'Tasks & access', File: 'entitlements/tasks.md',    Routes: [] },
		],
	},
];

/** Hash for an (area, topic): the single `Doc-` namespace the API allowlist gates on. */
function hashFor(pArea, pTopic)
{
	return `Doc-${pArea}-${pTopic}`;
}

// Flatten to the lookups the app + seed use: DOCS (one per topic, with computed Hash) + ROUTE_DOC (route→Hash).
const DOCS = [];
const ROUTE_DOC = [];
AREAS.forEach((pArea) =>
{
	pArea.Docs.forEach((pDoc) =>
	{
		const tmpHash = hashFor(pArea.Area, pDoc.Topic);
		DOCS.push({ Hash: tmpHash, Area: pArea.Area, Title: pDoc.Title, Nav: pDoc.Nav, File: pDoc.File });
		(pDoc.Routes || []).forEach((pRoute) => ROUTE_DOC.push({ Route: pRoute, Hash: tmpHash }));
	});
});

/**
 * Resolve a route to the Hash of the help doc F1 should open, or '' when the route has no platform doc (so the
 * caller falls back to the file-based route help). Longest-matching route prefix wins.
 * @param {string} pRoute @returns {string}
 */
function hashForRoute(pRoute)
{
	const tmpRoute = String(pRoute || '');
	let tmpHash = '';
	let tmpBestLength = -1;
	ROUTE_DOC.forEach((pEntry) =>
	{
		if ((tmpRoute === pEntry.Route || tmpRoute.indexOf(pEntry.Route + '/') === 0) && (pEntry.Route.length > tmpBestLength))
		{
			tmpHash = pEntry.Hash;
			tmpBestLength = pEntry.Route.length;
		}
	});
	return tmpHash;
}

/** The doc registry entry for a Hash, or null. @param {string} pHash */
function docByHash(pHash)
{
	return DOCS.find((pDoc) => pDoc.Hash === pHash) || null;
}

/** The Area a Hash belongs to (''), for grouping the in-panel nav. @param {string} pHash */
function areaForHash(pHash)
{
	const tmpDoc = docByHash(pHash);
	return tmpDoc ? tmpDoc.Area : '';
}

/**
 * Parse the Area straight out of a `Doc-<Area>-<Topic>` hash — works for topics that aren't in the static
 * registry (customer-authored / newly-created ones), where docByHash/areaForHash would return ''. @param {string} pHash
 */
function areaFromHash(pHash)
{
	const tmpParts = String(pHash || '').split('-');
	return ((tmpParts.length >= 3) && (tmpParts[0] === 'Doc')) ? tmpParts[1] : '';
}

/** All docs in an Area, in registry order — the sibling topics shown in the in-panel nav. @param {string} pArea */
function docsInArea(pArea)
{
	return DOCS.filter((pDoc) => pDoc.Area === pArea);
}

module.exports = { AREAS, DOCS, ROUTE_DOC, hashFor, hashForRoute, docByHash, areaForHash, areaFromHash, docsInArea };

},{}],1283:[function(require,module,exports){
'use strict';

/**
 * Important Project Files — data/logic provider (navigator + download + entitlement-gated management).
 *
 * The feature already exists server-side: two Meadow entities, ProjectFileFolder (nested via
 * ParentIDProjectFileFolder, project-scoped) and ProjectFile (a pointer into a folder at a FileType, carrying
 * IDObservation + IDArtifact + ArtifactVersion). This provider loads a whole project's folders + files in two
 * flat reads and assembles the nested tree in memory — the same shape the reference client
 * (web/providers/ProjectFileProvider.getProjectFilesDataStructure) builds, ported off pict.EntityProvider onto
 * this app's HeadlightRestClient. Standalone project-scoped screen, mirroring the Sample Plan front door.
 *
 * Read paths (everyone with Project-Read): load + tree + front door + per-file download of the current version.
 * Management (entitlement 'manage-important-files' → ProjectFile/ProjectFileFolder CRUD, gated by canManage()):
 * create/rename/move/delete folders, and rename/move/remove files — all generic Meadow CRUD (the bespoke
 * ImportantProjectFile endpoints are GET-only), full-record PUTs, soft-deletes, non-empty folders blocked (no
 * server cascade); plus upload (new file → Observation of the MIME's type + its Artifact binary → ProjectFile
 * pointer); plus a versions view (list + download any version — every version 1..Artifact.Version has bytes at
 * Artifact/Media/{id}/{v}; a new version is an upload to version N+1). Size visualization arrives in a later phase.
 */

const libPictProvider = require('pict-provider');

// Stored FileType carries a legacy prefix for everything but plain files ('Legacy Image' / 'Legacy Video' /
// 'Legacy Audio'); normalize to the clean taxonomy the UI shows + icons off.
const FILE_TYPES = [ 'File', 'Image', 'Video', 'Audio' ];

// getBinaryBlob returns an UNTYPED Blob, and stored names sometimes lack an extension; map the observation's
// FileMimeType (or, failing that, the FileType tier) to a sensible download extension.
const MIME_EXTENSIONS = {
	'application/pdf': 'pdf',
	'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/png': 'png', 'image/gif': 'gif', 'image/heic': 'heic', 'image/webp': 'webp', 'image/tiff': 'tiff', 'image/bmp': 'bmp',
	'video/mp4': 'mp4', 'video/quicktime': 'mov', 'video/x-msvideo': 'avi', 'video/webm': 'webm', 'video/mpeg': 'mpeg',
	'audio/mpeg': 'mp3', 'audio/mp3': 'mp3', 'audio/wav': 'wav', 'audio/x-wav': 'wav', 'audio/mp4': 'm4a', 'audio/aac': 'aac', 'audio/ogg': 'ogg',
	'text/plain': 'txt', 'text/csv': 'csv', 'application/json': 'json', 'application/zip': 'zip',
	'application/msword': 'doc', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	'application/vnd.ms-excel': 'xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
};
const DEFAULT_TYPE_EXTENSIONS = { Image: 'jpg', Video: 'mp4', Audio: 'mp3', File: '' };

// The artifact-type name inside an observation's Details differs from the datum key for plain files: a 'File'
// observation carries a 'Data_File' artifact (the server's Data_File manifest supplies AllowedMimeTypes /
// DisallowedExtensions and validates it — sending the datum key 'File' instead leaves the artifact Invalid=1).
// The legacy media types use their datum name as the artifact type as-is (verified against real observations).
const ARTIFACT_TYPE_FOR_DATUM = { File: 'Data_File', Image: 'Image', Video: 'Video', Audio: 'Audio' };

class ImportantFilesProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._idProject = 0;
		this._tree = [];
		this._rawFolders = {};   // IDProjectFileFolder -> raw record (full-record PUTs need every column)
		this._rawFiles = {};     // IDProjectFile -> raw record
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	/** The screen's AppData-backed state; slots + title are derived from it in the view's onBeforeRender. */
	get workspaceState()
	{
		if (!this.pict.AppData.ImportantFiles)
		{
			this.pict.AppData.ImportantFiles = { Loading: false, Message: '', HasModel: false, ProjectName: '', IDProject: 0, FileCount: 0, FolderCount: 0 };
		}
		return this.pict.AppData.ImportantFiles;
	}

	get tree() { return this._tree; }
	get idProject() { return this._idProject; }

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)));
		});
	}

	_render()
	{
		if (this.pict.views['ImportantFiles']) { this.pict.views['ImportantFiles'].render(); }
	}

	/** 'Legacy Image' -> 'Image'; '' -> 'File'; anything unknown falls back to 'File'. */
	_normalizeFileType(pFileType)
	{
		const tmpType = String(pFileType || '').replace(/^Legacy\s+/i, '').trim();
		return FILE_TYPES.indexOf(tmpType) >= 0 ? tmpType : 'File';
	}

	// --- Management entitlement (Phase 3) -----------------------------------------------------------

	get permissions() { return this.pict.fable.EffectivePermissionsService; }

	/**
	 * Server-authoritative capability check, fail-CLOSED for management (unlike the nav-visibility gate, which
	 * fails open): no permissions service or an unloaded capability map → false, so management affordances never
	 * flash before we know the user's grants. Super-users pass (the service bypasses for them). The server stays
	 * the real authority — this only decides what to show.
	 */
	can(pEntity, pAction)
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.can !== 'function') || !tmpPermissions.currentUserReady()) { return false; }
		return tmpPermissions.can(pEntity, pAction);
	}

	/**
	 * May the current user MANAGE important files (create/rename/move folders, add/remove files)? The
	 * 'manage-important-files' entitlement (Task-Catalog) grants the ProjectFile + ProjectFileFolder CRUD bundle
	 * together, so any one of them signals management; individual affordances in later phases still check their
	 * own specific capability. Viewers without the entitlement stay in the read-only navigator.
	 * @returns {Boolean}
	 */
	canManage()
	{
		return this.can('ProjectFile', 'Create')
			|| this.can('ProjectFile', 'Update')
			|| this.can('ProjectFile', 'Delete')
			|| this.can('ProjectFileFolder', 'Create')
			|| this.can('ProjectFileFolder', 'Update')
			|| this.can('ProjectFileFolder', 'Delete');
	}

	// --- Front door ---------------------------------------------------------------------------------

	/**
	 * Search the customer's projects by name for the front-door picker (mirrors the Sample Plan front door).
	 * @param {String} pTerm
	 * @returns {Promise<Array<{IDProject:Number, Name:String}>>}
	 */
	async searchProjectsAsync(pTerm)
	{
		const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
		let tmpFilter = 'FBV~Deleted~EQ~0';
		if (tmpTerm) { tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`; }
		const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}/0/100`).catch(() => []);
		// The Lite projection returns the display name under `Value` (the filter still runs on the real Name column).
		return (Array.isArray(tmpRows) ? tmpRows : [])
			.map((pRow) => ({ IDProject: pRow.IDProject, Name: pRow.Value || pRow.Name || pRow.Description || `Project ${pRow.IDProject}` }))
			.sort((pA, pB) => (pA.Name.toLowerCase() < pB.Name.toLowerCase() ? -1 : (pA.Name.toLowerCase() > pB.Name.toLowerCase() ? 1 : 0)));
	}

	/** Reset to the front-door project picker (the no-ID route + the "Choose another project" button). State only;
	 *  the route's _renderRouteView does the paint. */
	resetToPicker()
	{
		const tmpState = this.workspaceState;
		tmpState.Loading = false;
		tmpState.Message = '';
		tmpState.HasModel = false;
		tmpState.ProjectName = '';
		tmpState.IDProject = 0;
		this._idProject = 0;
		this._tree = [];
	}

	// --- Loading ------------------------------------------------------------------------------------

	/**
	 * Load a project's important files: two flat Meadow reads (folders + files) -> in-memory nested tree, then
	 * re-render. Mirrors the Sample Plan loadAsync lifecycle (Loading -> HasModel).
	 * @param {Number} pIDProject
	 */
	async loadAsync(pIDProject)
	{
		const tmpState = this.workspaceState;
		this._idProject = pIDProject;
		this._tree = [];
		tmpState.Loading = true;
		tmpState.Message = '';
		tmpState.HasModel = false;
		tmpState.IDProject = pIDProject;
		this._render();

		try
		{
			const tmpFolderFilter = `FBV~IDProject~EQ~${pIDProject}~FBV~Deleted~EQ~0`;
			const tmpFileFilter = `FBV~IDProject~EQ~${pIDProject}~FBV~Deleted~EQ~0`;
			const [ tmpFolders, tmpFiles, tmpProject ] = await Promise.all(
				[
					this._getJSON(`ProjectFileFolders/FilteredTo/${tmpFolderFilter}/0/5000`).catch(() => []),
					this._getJSON(`ProjectFiles/FilteredTo/${tmpFileFilter}/0/10000`).catch(() => []),
					this._getJSON(`Project/${pIDProject}`).catch(() => null),
				]);

			this._tree = this._buildTree(Array.isArray(tmpFolders) ? tmpFolders : [], Array.isArray(tmpFiles) ? tmpFiles : []);
			tmpState.FolderCount = (Array.isArray(tmpFolders) ? tmpFolders.length : 0);
			tmpState.FileCount = (Array.isArray(tmpFiles) ? tmpFiles.length : 0);
			tmpState.ProjectName = (tmpProject && (tmpProject.Name || tmpProject.Description)) || `Project ${pIDProject}`;
			tmpState.HasModel = true;
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			this.pict.log.error(`ImportantFiles: failed to load project ${pIDProject}: ${pError && pError.message ? pError.message : pError}`, pError);
			tmpState.Loading = false;
			tmpState.HasModel = false;
			tmpState.Message = 'Could not load this project’s files.';
			this._render();
		}
	}

	/**
	 * Merge the flat folder + file rows into a nested tree (folders wired by ParentIDProjectFileFolder; files
	 * dropped into their folder; folder-0 files collected into a synthetic read-only "Customer Files" root).
	 * Node shape: { Name, IsFolder, ID, RowID, Date, Children?, IsCustomer?, ParentID? } for folders and
	 * { Name, IsFolder:false, ID, RowID, Date, FileType, IDObservation, IDArtifact, ArtifactVersion } for files.
	 * @returns {Array<Object>} root nodes, sorted (folders first, then files, each by name).
	 */
	_buildTree(pFolders, pFiles)
	{
		const tmpMap = {};
		const tmpRoots = [];
		// Keep the raw records around, keyed by id — full-record PUTs (rename/move) need every column.
		this._rawFolders = {};
		this._rawFiles = {};

		for (let i = 0; i < pFolders.length; i++)
		{
			const tmpFolder = pFolders[i];
			this._rawFolders[tmpFolder.IDProjectFileFolder] = tmpFolder;
			tmpMap[tmpFolder.IDProjectFileFolder] = (
				{
					Name: tmpFolder.Name, IsFolder: true, IsCustomer: false,
					ID: tmpFolder.IDProjectFileFolder, ParentID: tmpFolder.ParentIDProjectFileFolder,
					Date: tmpFolder.UpdateDate, Children: [],
					RowID: `Folder_${tmpFolder.IDProjectFileFolder}`,
				});
		}
		// Wire each folder under its parent; a folder whose parent is 0 (or missing) is a root.
		Object.keys(tmpMap).forEach((pKey) =>
		{
			const tmpNode = tmpMap[pKey];
			if (tmpNode.ParentID > 0 && tmpMap[tmpNode.ParentID]) { tmpMap[tmpNode.ParentID].Children.push(tmpNode); }
			else { tmpRoots.push(tmpNode); }
		});

		let tmpCustomerFolder = null;
		for (let i = 0; i < pFiles.length; i++)
		{
			const tmpFile = pFiles[i];
			this._rawFiles[tmpFile.IDProjectFile] = tmpFile;
			const tmpFileNode = (
				{
					Name: tmpFile.Name, IsFolder: false,
					ID: tmpFile.IDProjectFile, IDObservation: tmpFile.IDObservation,
					IDArtifact: tmpFile.IDArtifact, ArtifactVersion: tmpFile.ArtifactVersion,
					FileType: this._normalizeFileType(tmpFile.FileType), Date: tmpFile.UpdateDate,
					RowID: `File_${tmpFile.IDProjectFile}`,
				});
			if (tmpMap[tmpFile.IDProjectFileFolder])
			{
				tmpMap[tmpFile.IDProjectFileFolder].Children.push(tmpFileNode);
			}
			else if (Number(tmpFile.IDProjectFileFolder) === 0)
			{
				// Files with no folder live in a synthetic read-only "Customer Files" root bucket (reference behavior).
				if (!tmpCustomerFolder)
				{
					tmpCustomerFolder = { Name: 'Customer Files', IsFolder: true, IsCustomer: true, ID: 0, ParentID: 0, Date: tmpFile.UpdateDate, Children: [], RowID: 'Folder_0' };
					tmpRoots.push(tmpCustomerFolder);
				}
				tmpCustomerFolder.Children.push(tmpFileNode);
			}
			else
			{
				this.pict.log.warn(`ImportantFiles: file ${tmpFile.IDProjectFile} references missing folder ${tmpFile.IDProjectFileFolder}; skipped.`);
			}
		}

		this._sortNodes(tmpRoots);
		return tmpRoots;
	}

	/** Recursively order a sibling list: folders before files, each alphabetically (case-insensitive). Phase-1 default sort. */
	_sortNodes(pNodes)
	{
		pNodes.sort((pA, pB) =>
		{
			if (pA.IsFolder !== pB.IsFolder) { return pA.IsFolder ? -1 : 1; }
			const tmpA = String(pA.Name || '').toLowerCase();
			const tmpB = String(pB.Name || '').toLowerCase();
			return tmpA < tmpB ? -1 : (tmpA > tmpB ? 1 : 0);
		});
		pNodes.forEach((pNode) => { if (pNode.Children && pNode.Children.length) { this._sortNodes(pNode.Children); } });
	}
	// --- Download (Phase 2) -------------------------------------------------------------------------

	/** Find a tree node (folder or file) by its RowID. */
	findNode(pRowID)
	{
		let tmpFound = null;
		const fWalk = (pNodes) =>
		{
			for (let i = 0; i < pNodes.length; i++)
			{
				if (tmpFound) { return; }
				if (pNodes[i].RowID === pRowID) { tmpFound = pNodes[i]; return; }
				if (pNodes[i].Children && pNodes[i].Children.length) { fWalk(pNodes[i].Children); }
			}
		};
		fWalk(this._tree || []);
		return tmpFound;
	}

	_getBlob(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getBinaryBlob(pURL, (pError, pBlob) => (pError ? reject(pError) : resolve(pBlob)));
		});
	}

	/** True when the filename already carries a plausible extension (so we don't need the observation to name it). */
	_hasExtension(pName) { return /\.[A-Za-z0-9]{1,8}$/.test(String(pName == null ? '' : pName).trim()); }

	/** A ProjectFile's own concrete artifact-version pin (>= 0), or null when unset/negative. The server treats a
	 *  negative ArtifactVersion as "track the artifact's current version" and everything >= 0 (including 0) as a
	 *  real pin, so 0 must be preserved — never coerced to 1. */
	_pinnedVersion(pNode)
	{
		const tmpVersion = pNode ? pNode.ArtifactVersion : undefined;
		if (tmpVersion === undefined || tmpVersion === null || tmpVersion === '') { return null; }
		const tmpNumber = Number(tmpVersion);
		return (Number.isFinite(tmpNumber) && tmpNumber >= 0) ? tmpNumber : null;
	}

	/**
	 * Fast path: a same-origin media URL the browser streams straight to disk via <a download> (ambient session
	 * cookie), with no round-trip and no in-memory blob — used whenever the node already pins a concrete artifact
	 * + version and its name carries an extension. Returns null when we must resolve via the observation (legacy
	 * rows with IDArtifact 0 / unpinned version / no extension) or when the API base is cross-origin (a download
	 * anchor + cookie aren't honored there — fall back to the authenticated blob fetch).
	 * @returns {{ url: String, filename: String } | null}
	 */
	directDownloadURL(pNode)
	{
		if (!pNode || pNode.IsFolder) { return null; }
		const tmpID = Number(pNode.IDArtifact);
		const tmpVersion = this._pinnedVersion(pNode);
		if (!(tmpID > 0) || (tmpVersion === null) || !this._hasExtension(pNode.Name)) { return null; }
		const tmpURL = this.restClient.formatUrl(`Artifact/Media/${tmpID}/${tmpVersion}`);
		// Only a same-origin URL streams via a plain download anchor with the ambient session cookie.
		const tmpSameOrigin = (tmpURL.charAt(0) === '/') || ((typeof window !== 'undefined') && (tmpURL.indexOf(window.location.origin) === 0));
		return tmpSameOrigin ? { url: tmpURL, filename: pNode.Name } : null;
	}

	/**
	 * Robust path: resolve a file node to a downloadable Blob + filename + mime, fetching the bytes through the
	 * authenticated rest client. The ProjectFile row's own IDArtifact + ArtifactVersion are authoritative (matching
	 * the server: a pinned version >= 0 wins; the observation artifact is only the fallback); the live Observation's
	 * Details.File[0] fills in a missing artifact/version and the real filename + mime. `getBinaryBlob` returns an
	 * untyped Blob, so we re-wrap it with the resolved mime. Used for legacy rows and the cross-origin case.
	 * @param {Object} pNode a file node from the tree
	 * @returns {Promise<{ blob: Blob, filename: String, mimetype: String }>}
	 */
	async resolveDownloadAsync(pNode)
	{
		if (!pNode || pNode.IsFolder) { throw new Error('Not a downloadable file.'); }

		let tmpIDArtifact = (Number(pNode.IDArtifact) > 0) ? Number(pNode.IDArtifact) : null;
		let tmpVersion = this._pinnedVersion(pNode);
		let tmpFileName = pNode.Name;
		let tmpMime = '';

		// Fetch the observation only when we still need something from it: the artifact id, the version, or a
		// filename with an extension. A pinned node with an extension-bearing name needs no round-trip.
		if (pNode.IDObservation && ((tmpIDArtifact === null) || (tmpVersion === null) || !this._hasExtension(tmpFileName)))
		{
			const tmpObservation = await this._getJSON(`Observation/${pNode.IDObservation}`).catch(() => null);
			const tmpFile = tmpObservation && tmpObservation.Details && tmpObservation.Details.File && tmpObservation.Details.File[0];
			if (tmpFile)
			{
				if ((tmpIDArtifact === null) && tmpFile.IDArtifact) { tmpIDArtifact = tmpFile.IDArtifact; }
				if ((tmpVersion === null) && (tmpFile.Version !== undefined) && (tmpFile.Version !== null)) { tmpVersion = tmpFile.Version; }
				if (tmpFile.Datum && tmpFile.Datum.FileName && !this._hasExtension(tmpFileName)) { tmpFileName = tmpFile.Datum.FileName; }
				if (tmpFile.Datum && tmpFile.Datum.FileMimeType) { tmpMime = tmpFile.Datum.FileMimeType; }
			}
		}

		if (!tmpIDArtifact) { throw new Error('This file has no downloadable artifact.'); }
		if (tmpVersion === null) { tmpVersion = 1; }   // last resort only — a real 0 pin is preserved above

		const tmpBlob = await this._getBlob(`Artifact/Media/${tmpIDArtifact}/${tmpVersion}`);
		const tmpTyped = (tmpMime && (typeof Blob !== 'undefined')) ? new Blob([ tmpBlob ], { type: tmpMime }) : tmpBlob;
		return { blob: tmpTyped, filename: this._ensureExtension(tmpFileName, tmpMime, pNode.FileType, tmpIDArtifact), mimetype: tmpMime };
	}

	/** Give the download a sensible filename + extension when the stored name lacks one. */
	_ensureExtension(pName, pMime, pFileType, pIDArtifact)
	{
		const tmpName = String(pName == null ? '' : pName).trim() || `file-${pIDArtifact || ''}`.replace(/-$/, '') || 'download';
		if (/\.[A-Za-z0-9]{1,8}$/.test(tmpName)) { return tmpName; }
		const tmpExt = MIME_EXTENSIONS[String(pMime || '').toLowerCase()] || DEFAULT_TYPE_EXTENSIONS[pFileType] || '';
		return tmpExt ? `${tmpName}.${tmpExt}` : tmpName;
	}

	// --- Mutations (Phase 4: folder + file management) ----------------------------------------------

	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_deleteEntity(pEntity, pID) { return new Promise((resolve, reject) => this.restClient.deleteEntity(pEntity, pID, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }

	/**
	 * Re-fetch the project's folders + files and rebuild the tree WITHOUT the full-screen loading flash (unlike
	 * loadAsync). Used after a mutation so the tree updates in place while the header + collapse state stay put.
	 */
	async _reloadTreeAsync()
	{
		const tmpState = this.workspaceState;
		const tmpFilter = `FBV~IDProject~EQ~${this._idProject}~FBV~Deleted~EQ~0`;
		const [ tmpFolders, tmpFiles ] = await Promise.all(
			[
				this._getJSON(`ProjectFileFolders/FilteredTo/${tmpFilter}/0/5000`).catch(() => []),
				this._getJSON(`ProjectFiles/FilteredTo/${tmpFilter}/0/10000`).catch(() => []),
			]);
		this._tree = this._buildTree(Array.isArray(tmpFolders) ? tmpFolders : [], Array.isArray(tmpFiles) ? tmpFiles : []);
		tmpState.FolderCount = (Array.isArray(tmpFolders) ? tmpFolders.length : 0);
		tmpState.FileCount = (Array.isArray(tmpFiles) ? tmpFiles.length : 0);
		this._render();
	}

	/** Guard: every write must clear the management gate (the server is the real authority, but fail fast + friendly). */
	_assertCanManage()
	{
		if (!this.canManage()) { throw new Error('You don’t have permission to manage this project’s important files.'); }
	}

	/** Real (non-synthetic) folders as a flat list for a move-target picker, each with an indented path label.
	 *  Optionally excludes a folder + its whole subtree (so a folder can't be moved into itself/a descendant). */
	folderChoices(pExcludeID)
	{
		const tmpExclude = this._descendantIDs(pExcludeID);
		if (pExcludeID) { tmpExclude[pExcludeID] = true; }
		const tmpList = [];
		const fWalk = (pNodes, pDepth) =>
		{
			pNodes.forEach((pNode) =>
			{
				if (!pNode.IsFolder || pNode.IsCustomer) { return; }   // the synthetic 'Customer Files' bucket isn't a real folder
				if (tmpExclude[pNode.ID]) { return; }
				tmpList.push({ ID: pNode.ID, Name: pNode.Name, Depth: pDepth });
				fWalk(pNode.Children || [], pDepth + 1);
			});
		};
		fWalk(this._tree || [], 0);
		return tmpList;
	}

	/** Map of a folder's descendant folder IDs (for move cycle-prevention). */
	_descendantIDs(pFolderID)
	{
		const tmpResult = {};
		const tmpNode = pFolderID ? this.findNode(`Folder_${pFolderID}`) : null;
		if (!tmpNode) { return tmpResult; }
		const fWalk = (pNodes) => pNodes.forEach((pChild) =>
		{
			if (pChild.IsFolder) { tmpResult[pChild.ID] = true; fWalk(pChild.Children || []); }
		});
		fWalk(tmpNode.Children || []);
		return tmpResult;
	}

	/** Create a folder (POST). ParentID 0 = a root folder. Server stamps IDCustomer/GUID/audit; IDProject drives
	 *  the membership check. */
	async createFolderAsync(pName, pParentID)
	{
		this._assertCanManage();
		const tmpName = String(pName == null ? '' : pName).trim();
		if (!tmpName) { throw new Error('A folder name is required.'); }
		await this._postJSON('ProjectFileFolder', { Name: tmpName, Description: '', ParentIDProjectFileFolder: Number(pParentID) || 0, IDProject: this._idProject });
		await this._reloadTreeAsync();
	}

	async renameFolderAsync(pNode, pNewName)
	{
		this._assertCanManage();
		const tmpName = String(pNewName == null ? '' : pNewName).trim();
		if (!tmpName) { throw new Error('A folder name is required.'); }
		const tmpRaw = this._rawFolders[pNode.ID];
		if (!tmpRaw) { throw new Error('Folder not found — refresh and try again.'); }
		if (tmpName === tmpRaw.Name) { return; }
		await this._putJSON('ProjectFileFolder', Object.assign({}, tmpRaw, { Name: tmpName }));
		await this._reloadTreeAsync();
	}

	async moveFolderAsync(pNode, pNewParentID)
	{
		this._assertCanManage();
		const tmpRaw = this._rawFolders[pNode.ID];
		if (!tmpRaw) { throw new Error('Folder not found — refresh and try again.'); }
		const tmpNewParent = Number(pNewParentID) || 0;
		if (tmpNewParent === pNode.ID) { throw new Error('A folder can’t be moved into itself.'); }
		if (this._descendantIDs(pNode.ID)[tmpNewParent]) { throw new Error('A folder can’t be moved into one of its own subfolders.'); }
		if (tmpNewParent === (tmpRaw.ParentIDProjectFileFolder || 0)) { return; }
		await this._putJSON('ProjectFileFolder', Object.assign({}, tmpRaw, { ParentIDProjectFileFolder: tmpNewParent }));
		await this._reloadTreeAsync();
	}

	/** Delete a folder (soft-delete). Blocks a non-empty folder — the server has no cascade, so its contents would
	 *  be orphaned; the caller must empty it first. */
	async deleteFolderAsync(pNode)
	{
		this._assertCanManage();
		if (pNode.Children && pNode.Children.length) { throw new Error('This folder isn’t empty. Move or remove everything inside it first.'); }
		await this._deleteEntity('ProjectFileFolder', pNode.ID);
		await this._reloadTreeAsync();
	}

	async renameFileAsync(pNode, pNewName)
	{
		this._assertCanManage();
		const tmpName = String(pNewName == null ? '' : pNewName).trim();
		if (!tmpName) { throw new Error('A file name is required.'); }
		const tmpRaw = this._rawFiles[pNode.ID];
		if (!tmpRaw) { throw new Error('File not found — refresh and try again.'); }
		if (tmpName === tmpRaw.Name) { return; }
		await this._putJSON('ProjectFile', Object.assign({}, tmpRaw, { Name: tmpName }));
		await this._reloadTreeAsync();
	}

	/** Move a file to another folder (ID 0 = top level / out of any folder). */
	async moveFileAsync(pNode, pNewFolderID)
	{
		this._assertCanManage();
		const tmpRaw = this._rawFiles[pNode.ID];
		if (!tmpRaw) { throw new Error('File not found — refresh and try again.'); }
		const tmpNewFolder = Number(pNewFolderID) || 0;
		if (tmpNewFolder === (tmpRaw.IDProjectFileFolder || 0)) { return; }
		await this._putJSON('ProjectFile', Object.assign({}, tmpRaw, { IDProjectFileFolder: tmpNewFolder }));
		await this._reloadTreeAsync();
	}

	/** Remove a file from the project's important files (soft-delete the ProjectFile pointer). The underlying
	 *  Observation + its artifact are untouched — this only unlists it here. */
	async removeFileAsync(pNode)
	{
		this._assertCanManage();
		await this._deleteEntity('ProjectFile', pNode.ID);
		await this._reloadTreeAsync();
	}

	// --- Upload (Phase 5: new file -> Observation + Artifact -> ProjectFile) -------------------------

	_postBinary(pURL, pFile, pOnProgress)
	{
		return new Promise((resolve, reject) => this.restClient.postBinary(pURL, pFile, pFile.type || 'application/octet-stream', (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)), pOnProgress));
	}

	/** Browser File MIME -> Headlight ObservationType (media carry the 'Legacy' prefix; everything else is a plain
	 *  'File'). The datum key is that type without the prefix ('Image'/'Video'/'Audio'/'File'). */
	_observationTypeForMime(pMime)
	{
		const tmpMime = String(pMime || '').toLowerCase();
		if (tmpMime.indexOf('image/') === 0) { return 'Legacy Image'; }
		if (tmpMime.indexOf('video/') === 0) { return 'Legacy Video'; }
		if (tmpMime.indexOf('audio/') === 0) { return 'Legacy Audio'; }
		return 'File';
	}

	/**
	 * Upload a new file into the important files: (1) create an Observation of the right type — the server
	 * provisions its Artifact and returns the id + version; (2) POST the raw bytes to that artifact; (3) create the
	 * ProjectFile pointer into the target folder. Mirrors the reference ObservationProvider pipeline, ported onto
	 * the rest client (no ObservationProvider/UploadTracking/Geo here; EXIF + geo enrichment are skipped). Does NOT
	 * reload the tree — the caller reloads once after a batch.
	 * @param {File} pFile a browser File (from an <input type=file>)
	 * @param {Number} pFolderID destination folder (0 = top level / not in a folder)
	 * @param {Function} [pOnProgress] postBinary progress callback
	 * @returns {Promise<{ IDObservation:Number, IDProjectFile:Number, Name:String }>}
	 */
	async uploadFileAsync(pFile, pFolderID, pOnProgress)
	{
		this._assertCanManage();
		if (!pFile) { throw new Error('No file selected.'); }
		const tmpObservationType = this._observationTypeForMime(pFile.type);
		const tmpDatumType = tmpObservationType.replace(/^Legacy\s+/, '');
		const tmpArtifactType = ARTIFACT_TYPE_FOR_DATUM[tmpDatumType] || tmpDatumType;
		const tmpFileName = pFile.name || `New ${tmpDatumType}`;

		const tmpObservation = {
			Name: tmpFileName, Description: '', Tags: [], ObservationType: tmpObservationType,
			Details: { [tmpDatumType]: [ { ArtifactType: tmpArtifactType, IDArtifact: 0, Datum: { FileName: tmpFileName, FileMimeType: pFile.type || '' } } ] },
			IDObservation: 0, IDProject: this._idProject,
			CaptureLatitude: '0.00000000', CaptureLongitude: '0.00000000',
			UserLatitude: '0.00000000', UserLongitude: '0.00000000',
			AlignmentStation: 0, AlignmentOffset: 0,
		};
		const tmpNewObs = await this._postJSON('Observation', tmpObservation);
		const tmpArtifact = tmpNewObs && tmpNewObs.Details && tmpNewObs.Details[tmpDatumType] && tmpNewObs.Details[tmpDatumType][0];
		if (!tmpNewObs || !tmpNewObs.IDObservation || !tmpArtifact || !tmpArtifact.IDArtifact)
		{
			throw new Error('Could not create the observation for this file.');
		}
		await this._postBinary(`Artifact/Media/${tmpArtifact.IDArtifact}/${tmpArtifact.Version}`, pFile, pOnProgress);
		const tmpProjectFile = await this._postJSON('ProjectFile',
			{
				Name: tmpFileName, Description: '', IDProject: this._idProject, IDProjectFileFolder: Number(pFolderID) || 0,
				IDObservation: tmpNewObs.IDObservation, IDArtifact: tmpArtifact.IDArtifact, ArtifactVersion: tmpArtifact.Version,
				FileType: tmpObservationType,
			});
		return { IDObservation: tmpNewObs.IDObservation, IDProjectFile: (tmpProjectFile && (tmpProjectFile.IDProjectFile || tmpProjectFile.ID)) || 0, Name: tmpFileName };
	}

	// --- Add EXISTING observation (create a ProjectFile pointer; no new Observation/Artifact) --------

	/** Map of IDObservation already referenced by a ProjectFile in this project — excluded from the add-picker so
	 *  a file isn't listed twice. */
	_usedObservationIDs()
	{
		const tmpUsed = {};
		Object.keys(this._rawFiles || {}).forEach((pKey) =>
		{
			const tmpFile = this._rawFiles[pKey];
			if (tmpFile && tmpFile.IDObservation) { tmpUsed[tmpFile.IDObservation] = true; }
		});
		return tmpUsed;
	}

	get importableCap() { return 500; }

	/**
	 * Load (and cache) the project's file/photo observations that can be added to the important files. One read of
	 * the most-recent observations (the collection read carries `Details`, so we resolve each artifact + keep only
	 * file-bearing rows), excluding observations already listed here. Filename search is client-side — the file's
	 * real name lives in the artifact `Datum.FileName`, not a server-filterable column (the observation `Name` is
	 * often a generic "New File"), so a server LIKE on Name would miss what the user actually sees. Call once when
	 * the picker opens; then `filterImportableObservations` narrows the cache per keystroke.
	 * @returns {Promise<{ total:Number, truncated:Boolean }>}
	 */
	async loadImportableObservationsAsync()
	{
		this._importableObservations = [];
		this._importableTruncated = false;
		if (!this._idProject) { return { total: 0, truncated: false }; }
		const tmpCap = this.importableCap;
		const tmpFilter = `FBV~IDProject~EQ~${this._idProject}~FBV~Deleted~EQ~0`;
		// Newest first; some deployments reject the sort token on this entity, so fall back unsorted.
		let tmpRows = await this._getJSON(`Observations/FilteredTo/${tmpFilter}~FSF~CreateDate~DESC~0/0/${tmpCap}`).catch(() => null);
		if (!Array.isArray(tmpRows)) { tmpRows = await this._getJSON(`Observations/FilteredTo/${tmpFilter}/0/${tmpCap}`).catch(() => []); }
		// We only fetched the most-recent page; there may be older file observations we didn't pull.
		this._importableTruncated = Array.isArray(tmpRows) && (tmpRows.length >= tmpCap);
		const tmpUsed = this._usedObservationIDs();
		const tmpResults = [];
		(Array.isArray(tmpRows) ? tmpRows : []).forEach((pObs) =>
		{
			if (!pObs || !pObs.IDObservation || tmpUsed[pObs.IDObservation]) { return; }
			const tmpSlot = this._firstFileArtifact(pObs.Details);
			if (!tmpSlot || !tmpSlot.IDArtifact) { return; }   // no file/photo artifact — can't be added
			const tmpName = (tmpSlot.Datum && tmpSlot.Datum.FileName) || pObs.Name || `Observation ${pObs.IDObservation}`;
			tmpResults.push(
				{
					IDObservation: pObs.IDObservation,
					Name: tmpName,
					ObservationType: pObs.ObservationType || '',
					FileType: this._normalizeFileType(pObs.ObservationType),
					Date: pObs.CreateDate || pObs.UpdateDate || null,
					IDArtifact: tmpSlot.IDArtifact,
					ArtifactVersion: ((tmpSlot.Version !== undefined) && (tmpSlot.Version !== null)) ? tmpSlot.Version : null,
					Mime: (tmpSlot.Datum && tmpSlot.Datum.FileMimeType) || '',
					// Precomputed lowercase haystack for the client-side name filter.
					Search: String(tmpName).toLowerCase(),
				});
		});
		this._importableObservations = tmpResults;
		return { total: tmpResults.length, truncated: this._importableTruncated };
	}

	/**
	 * Narrow the cached importable-observation rows by a filename substring (client-side; see
	 * loadImportableObservationsAsync). Capped so a huge project doesn't render thousands of rows at once.
	 * @param {String} pTerm
	 * @param {Number} [pLimit]
	 * @returns {{ rows:Array<Object>, total:Number, shown:Number, truncated:Boolean }}
	 */
	filterImportableObservations(pTerm, pLimit)
	{
		const tmpAll = this._importableObservations || [];
		const tmpTerm = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
		const tmpMatched = tmpTerm ? tmpAll.filter((pRow) => pRow.Search.indexOf(tmpTerm) >= 0) : tmpAll;
		const tmpLimit = pLimit || 150;
		return { rows: tmpMatched.slice(0, tmpLimit), total: tmpMatched.length, shown: Math.min(tmpMatched.length, tmpLimit), truncated: !!this._importableTruncated };
	}

	/**
	 * Add an EXISTING observation's file to the important files: create a ProjectFile pointer into pFolderID (0 =
	 * top level) referencing the observation's current file/media artifact. Unlike uploadFileAsync this creates NO
	 * new Observation/Artifact — it just lists a file that already exists. Uses the picker's hint when it carried
	 * the artifact (Details-bearing list); otherwise resolves from the live Observation. Reloads the tree unless
	 * pSkipReload (the picker adds many, then reloads once on close).
	 * @param {Number} pIDObservation
	 * @param {Number} pFolderID destination folder (0 = top level)
	 * @param {Object} [pHint] optional picker row { Name, ObservationType, IDArtifact, ArtifactVersion }
	 * @param {Boolean} [pSkipReload]
	 * @returns {Promise<{ IDProjectFile:Number, Name:String }>}
	 */
	async addExistingObservationAsync(pIDObservation, pFolderID, pHint, pSkipReload)
	{
		this._assertCanManage();
		const tmpID = Number(pIDObservation);
		if (!(tmpID > 0)) { throw new Error('No observation selected.'); }

		let tmpIDArtifact = (pHint && (Number(pHint.IDArtifact) > 0)) ? Number(pHint.IDArtifact) : 0;
		let tmpVersion = (pHint && (pHint.ArtifactVersion !== undefined) && (pHint.ArtifactVersion !== null) && (pHint.ArtifactVersion !== '')) ? Number(pHint.ArtifactVersion) : null;
		let tmpName = (pHint && pHint.Name) || '';
		let tmpObservationType = (pHint && pHint.ObservationType) || '';

		// Resolve from the live observation whenever the picker didn't already carry everything (Details-less list).
		if (!(tmpIDArtifact > 0) || (tmpVersion === null) || !tmpName || !tmpObservationType)
		{
			const tmpObservation = await this._getJSON(`Observation/${tmpID}`).catch(() => null);
			if (!tmpObservation) { throw new Error('Could not load that observation.'); }
			if (!tmpObservationType) { tmpObservationType = tmpObservation.ObservationType || 'File'; }
			const tmpSlot = this._firstFileArtifact(tmpObservation.Details);
			if (tmpSlot)
			{
				if (!(tmpIDArtifact > 0) && tmpSlot.IDArtifact) { tmpIDArtifact = tmpSlot.IDArtifact; }
				if ((tmpVersion === null) && (tmpSlot.Version !== undefined) && (tmpSlot.Version !== null)) { tmpVersion = Number(tmpSlot.Version); }
				if (!tmpName && tmpSlot.Datum && tmpSlot.Datum.FileName) { tmpName = tmpSlot.Datum.FileName; }
			}
			if (!tmpName) { tmpName = tmpObservation.Name || `Observation ${tmpID}`; }
		}

		if (!(tmpIDArtifact > 0)) { throw new Error('That observation has no file or photo to add.'); }
		if (tmpVersion === null) { tmpVersion = 1; }
		if (!tmpName) { tmpName = `Observation ${tmpID}`; }

		// Store FileType as the observation type (the same convention uploadFileAsync uses); the view normalizes it.
		const tmpProjectFile = await this._postJSON('ProjectFile',
			{
				Name: tmpName, Description: '', IDProject: this._idProject, IDProjectFileFolder: Number(pFolderID) || 0,
				IDObservation: tmpID, IDArtifact: tmpIDArtifact, ArtifactVersion: tmpVersion,
				FileType: tmpObservationType || 'File',
			});
		if (!pSkipReload) { await this._reloadTreeAsync(); }
		return { IDProjectFile: (tmpProjectFile && (tmpProjectFile.IDProjectFile || tmpProjectFile.ID)) || 0, Name: tmpName };
	}

	// --- Versions (Phase 6: download older versions) ------------------------------------------------

	/** The file/media artifact slot inside an observation's Details (File/Image/Video/Audio, else the first array). */
	_firstFileArtifact(pDetails)
	{
		if (!pDetails) { return null; }
		const tmpKeys = [ 'File', 'Image', 'Video', 'Audio' ];
		for (let i = 0; i < tmpKeys.length; i++) { if (pDetails[tmpKeys[i]] && pDetails[tmpKeys[i]][0]) { return pDetails[tmpKeys[i]][0]; } }
		const tmpAll = Object.keys(pDetails);
		for (let i = 0; i < tmpAll.length; i++) { if (Array.isArray(pDetails[tmpAll[i]]) && pDetails[tmpAll[i]][0]) { return pDetails[tmpAll[i]][0]; } }
		return null;
	}

	/**
	 * Resolve a file node's artifact reference: its IDArtifact, the CURRENT version (the live Observation's artifact
	 * slot is the source of truth; the node's own fields are the fallback), plus the real filename + mime + the
	 * current version's date. Every version 1..currentVersion has bytes at Artifact/Media/{id}/{v}.
	 * @returns {Promise<{ idArtifact:Number, currentVersion:Number, fileName:String, mime:String, currentDate:(String|null) }>}
	 */
	async _resolveArtifactRef(pNode)
	{
		if (!pNode || pNode.IsFolder) { throw new Error('Not a file.'); }
		let tmpIDArtifact = (Number(pNode.IDArtifact) > 0) ? Number(pNode.IDArtifact) : null;
		let tmpVersion = null;
		let tmpFileName = pNode.Name;
		let tmpMime = '';
		let tmpDate = pNode.Date || null;
		if (pNode.IDObservation)
		{
			const tmpObservation = await this._getJSON(`Observation/${pNode.IDObservation}`).catch(() => null);
			const tmpSlot = tmpObservation && this._firstFileArtifact(tmpObservation.Details);
			if (tmpSlot)
			{
				if (tmpSlot.IDArtifact) { tmpIDArtifact = tmpSlot.IDArtifact; }
				if ((tmpSlot.Version !== undefined) && (tmpSlot.Version !== null)) { tmpVersion = Number(tmpSlot.Version); }
				if (tmpSlot.UpdateDate) { tmpDate = tmpSlot.UpdateDate; }
				if (tmpSlot.Datum && tmpSlot.Datum.FileName) { tmpFileName = tmpSlot.Datum.FileName; }
				if (tmpSlot.Datum && tmpSlot.Datum.FileMimeType) { tmpMime = tmpSlot.Datum.FileMimeType; }
			}
		}
		if (tmpVersion === null) { tmpVersion = this._pinnedVersion(pNode); }
		if (!tmpIDArtifact) { throw new Error('This file has no downloadable artifact.'); }
		if ((tmpVersion === null) || (tmpVersion < 1)) { tmpVersion = 1; }
		return { idArtifact: tmpIDArtifact, currentVersion: tmpVersion, fileName: tmpFileName, mime: tmpMime, currentDate: tmpDate };
	}

	/**
	 * List a file's versions, newest first. Each version 1..current is a downloadable blob; only the current
	 * version carries a reliable date (older per-version metadata isn't recorded — an extension point).
	 * @returns {Promise<{ idArtifact:Number, currentVersion:Number, fileName:String, mime:String, versions:Array }>}
	 */
	async listVersionsAsync(pNode)
	{
		const tmpRef = await this._resolveArtifactRef(pNode);
		const tmpVersions = [];
		for (let v = tmpRef.currentVersion; v >= 1; v--)
		{
			const tmpIsCurrent = (v === tmpRef.currentVersion);
			tmpVersions.push({ version: v, isCurrent: tmpIsCurrent, date: tmpIsCurrent ? tmpRef.currentDate : null });
		}
		return { idArtifact: tmpRef.idArtifact, currentVersion: tmpRef.currentVersion, fileName: tmpRef.fileName, mime: tmpRef.mime, versions: tmpVersions };
	}

	/** Download one specific version's bytes. Pass the cached ref (from listVersionsAsync) to skip a re-resolve.
	 *  Older versions get a ' (vN)' filename suffix so they don't collide with the current download on disk. */
	async downloadVersionAsync(pNode, pVersion, pRef)
	{
		const tmpRef = pRef || await this._resolveArtifactRef(pNode);
		const tmpBlob = await this._getBlob(`Artifact/Media/${tmpRef.idArtifact}/${pVersion}`);
		const tmpTyped = (tmpRef.mime && (typeof Blob !== 'undefined')) ? new Blob([ tmpBlob ], { type: tmpRef.mime }) : tmpBlob;
		const tmpBase = this._ensureExtension(tmpRef.fileName, tmpRef.mime, pNode.FileType, tmpRef.idArtifact);
		const tmpFilename = (Number(pVersion) === tmpRef.currentVersion) ? tmpBase : this._versionedFilename(tmpBase, pVersion);
		return { blob: tmpTyped, filename: tmpFilename };
	}

	/** 'report.pdf' + v2 -> 'report (v2).pdf'. */
	_versionedFilename(pName, pVersion)
	{
		const tmpMatch = String(pName || 'download').match(/^(.*?)(\.[A-Za-z0-9]{1,8})?$/);
		const tmpStem = (tmpMatch && tmpMatch[1]) || String(pName || 'download');
		const tmpExt = (tmpMatch && tmpMatch[2]) || '';
		return `${tmpStem} (v${pVersion})${tmpExt}`;
	}

}

module.exports = ImportantFilesProvider;
module.exports.default_configuration = { ProviderIdentifier: 'ImportantFiles' };

},{"pict-provider":845}],1284:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libThroughputConfigs = require('../documents/DocumentThroughput-Configs.js');

/**
 * InspectionSchedule — the state inspection PROGRAM oversight instrument (not a personal calendar). Built for a program
 * manager whose job is compliance + throughput + allocation across a whole asset portfolio. It answers four questions:
 *   • What's coming?   → Overview: a compliance-demand wave (deadline-month workload), due-soon KPIs, a status pipeline.
 *   • Schedule manually → a reschedule action (PUT Inspection.ScheduledStartDate) reachable from the needs-attention
 *                          queue, the List, and the Calendar; plus a dedicated Unscheduled queue to work through.
 *   • What's in flight? → In-progress KPI + pipeline + a List/Calendar filter.
 *   • What's done?      → Completed KPI + throughput.
 * Modes: Overview (default program dashboard) · Calendar (Year/Month/Week lens) · List (sortable, filterable worklist).
 *
 * Standalone DashboardMode screen (#/InspectionSchedule[/:View]); the thin view [[InspectionSchedule.js]] paints this
 * provider into #InspectionSchedule-Host. Backed by plain Meadow — no server work: Overview/List load the full active set
 * once (Deleted=0, capped, ordered by DeadlineDate) and aggregate client-side; Calendar loads only the visible window
 * (FBV~ScheduledStartDate~GE~YYYY-MM-DD~…~LT~…). Urgency is deadline-driven (the compliance signal); TypeDisplay is empty
 * so type is resolved from IDInspectionType. Day keys use the ISO date's first 10 chars (UTC-midnight calendar day) to
 * stay timezone-stable.
 */

// Urgency / lifecycle ramp — one severity system used everywhere (tiles, bars, chips, dots).
const _U =
{
	overdue: { c: '#c0392b', bg: '#fbe9e7', label: 'Overdue' },
	due30: { c: '#d9772b', bg: '#fdf0e3', label: 'Due ≤30 days' },
	due90: { c: '#bf9b26', bg: '#faf5dc', label: 'Due 31–90 days' },
	future: { c: '#3a7ca5', bg: '#e9f2f8', label: 'Scheduled ahead' },
	unscheduled: { c: '#6a7480', bg: '#eceff2', label: 'Unscheduled' },
	inprogress: { c: '#6b62b0', bg: '#eeecf9', label: 'In progress' },
	completed: { c: '#3f9e6a', bg: '#e6f4ec', label: 'Completed' },
};
const _WEEKDAYS = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];
const _MONTHS = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
const _MON = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
const _ALL_CAP = 4000;

class InspectionScheduleProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#InspectionSchedule-Host';
		this._mode = 'overview';        // 'overview' | 'calendar' | 'list'
		this._calView = 'month';        // 'year' | 'month' | 'week'
		this._anchor = this._startOfDay(new Date());
		this._axis = 'scheduled';       // calendar axis: 'scheduled' | 'deadline'
		this._filterType = 0;
		this._filterStatus = '';
		this._filterUrgency = '';       // '', 'overdue','due30','due90','future','unscheduled','inprogress','completed'
		this._listSort = { key: 'deadline', dir: 'asc' };
		this._typeOptions = [];
		this._typeNames = {};
		this._statusOptions = [];
		this._all = [];                 // full active set (overview/list)
		this._allSig = '';              // filter signature the full set was loaded under
		this._allTruncated = false;
		this._rows = [];                // calendar window rows
		this._teamNames = {};           // IDTeam -> name (timeline lanes)
		this._inspTeam = {};            // IDInspection -> IDTeam (derived via the packet's DocumentAccessJoin grants)
		this._kpis = null;
		this._scheduleTarget = null;    // { IDInspection, Name, ScheduledStartDate, DeadlineDate }
		this._detailTarget = 0;         // IDInspection whose detail popover is open
		this._detail = null;            // { loading, id, inspectors:[], assets:[], createdBy }
		this._loading = false;
		this._error = '';
		this._loadGen = 0;
	}

	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get idCustomer() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }
	get providerName() { return 'InspectionSchedule'; }
	_get(pURL) { return new Promise((resolve) => this.restClient.getJSON(pURL, (e, b) => resolve(e ? null : b))); }
	_put(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (e, b) => e ? reject(e) : resolve(b))); }
	_esc(pV) { return String(pV == null ? '' : pV).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

	// --- date helpers ---
	_startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
	_addDays(d, n) { const x = new Date(d); x.setDate(x.getDate() + n); return x; }
	_addMonths(d, n) { const x = new Date(d); x.setDate(1); x.setMonth(x.getMonth() + n); return x; }
	_startOfMonth(d) { const x = new Date(d); x.setDate(1); x.setHours(0, 0, 0, 0); return x; }
	_startOfWeek(d) { const x = this._startOfDay(d); x.setDate(x.getDate() - x.getDay()); return x; }
	_ymd(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; }
	_todayYMD() { return this._ymd(new Date()); }
	_fmtDate(pV) { if (!pV) { return ''; } try { const d = new Date(pV); if (!Number.isNaN(d.getTime())) { return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); } } catch (e) { /* */ } return String(pV).slice(0, 10); }
	_axisField() { return this._axis === 'deadline' ? 'DeadlineDate' : 'ScheduledStartDate'; }
	_daysBetween(pFromYMD, pToYMD) { const a = new Date(pFromYMD + 'T00:00:00'); const b = new Date(pToYMD + 'T00:00:00'); return Math.round((b - a) / 86400000); }

	// --- classification (the compliance model) ---
	_isCompleted(r) { const s = String(r.StatusDisplay || '').toLowerCase(); return s.indexOf('complete') >= 0 || s.indexOf('closed') >= 0 || !!r.EndDate; }
	_isInProgress(r) { const s = String(r.StatusDisplay || '').toLowerCase(); return !this._isCompleted(r) && (!!r.StartDate || s.indexOf('progress') >= 0 || s.indexOf('active') >= 0 || s.indexOf('field') >= 0); }
	_isScheduled(r) { return !!r.ScheduledStartDate; }
	_isActive(r) { return !this._isCompleted(r); }
	_urg(r)
	{
		if (this._isCompleted(r)) { return 'completed'; }
		if (this._isInProgress(r)) { return 'inprogress'; }
		const dl = r.DeadlineDate ? String(r.DeadlineDate).slice(0, 10) : '';
		if (dl)
		{
			const t = this._todayYMD();
			if (dl < t) { return 'overdue'; }
			if (dl <= this._ymd(this._addDays(new Date(), 30))) { return 'due30'; }
			if (dl <= this._ymd(this._addDays(new Date(), 90))) { return 'due90'; }
			return 'future';
		}
		return r.ScheduledStartDate ? 'future' : 'unscheduled';
	}
	_typeName(pID) { return this._typeNames[pID] || (pID ? `Type ${pID}` : '—'); }
	_statusClass(pStatus) { const s = String(pStatus || '').toLowerCase(); if (s.indexOf('complete') >= 0 || s.indexOf('closed') >= 0 || s.indexOf('approv') >= 0) { return 'is-complete'; } if (s.indexOf('progress') >= 0 || s.indexOf('active') >= 0 || s.indexOf('field') >= 0) { return 'is-progress'; } if (s.indexOf('schedul') >= 0 || s.indexOf('pending') >= 0 || s === '') { return 'is-scheduled'; } return 'is-other'; }

	// =========================================================== load ===========================================================
	/** The session's inspection scope, or null when the service is not registered. */
	get _scopeService() { return this.pict.providers.InspectionScope || null; }

	_filterClauses()
	{
		let flt = '';
		if (this._filterType) { flt += `~FBV~IDInspectionType~EQ~${Number(this._filterType)}`; }
		if (this._filterStatus) { flt += `~FBV~StatusDisplay~EQ~${encodeURIComponent(this._filterStatus)}`; }
		// Narrow to the signed-in user's own work unless they hold the program view. Empty for an
		// administrator; an impossible clause (never an omitted one) for a scoped user with no
		// inspections — see [[InspectionScope-Service.js]].
		const scope = this._scopeService;
		if (scope) { flt += scope.inspectionClause('IDInspection'); }
		return flt;
	}
	async loadAsync()
	{
		const gen = ++this._loadGen;
		this._loading = true; this._error = ''; this._paint();
		try
		{
			if (!this._typeOptions.length) { await this._loadTypes(); }
			if (this._mode === 'calendar') { await this._loadWindow(gen); }
			else { await this._loadAll(gen); }
		}
		catch (e) { this._error = (e && e.message) || String(e); }
		finally { if (gen === this._loadGen) { this._loading = false; this._paint(); } }
	}
	async _loadTypes()
	{
		const rows = await this._get('InspectionTypes/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/200');
		this._typeOptions = (Array.isArray(rows) ? rows : []).map((t) => ({ IDInspectionType: t.IDInspectionType, Name: t.Name || `Type ${t.IDInspectionType}` }));
		this._typeOptions.forEach((t) => { this._typeNames[t.IDInspectionType] = t.Name; });
	}
	async _loadAll(pGen)
	{
		// The signature includes the scope clause (via _filterClauses), so switching users cannot serve
		// the previous user's rows from cache.
		const sig = this._filterClauses();
		if (this._allSig === sig && this._all.length) { return; } // cached under same filters + scope
		const base = `FBV~Deleted~EQ~0${sig}`;
		const rows = await this._get(`Inspections/FilteredTo/${base}~FSF~DeadlineDate~ASC~0/0/${_ALL_CAP}`);
		if (pGen !== this._loadGen) { return; }
		this._all = Array.isArray(rows) ? rows : [];
		this._allTruncated = this._all.length >= _ALL_CAP;
		this._allSig = sig;
		const seen = new Set(this._statusOptions); this._all.forEach((r) => { if (r.StatusDisplay) { seen.add(r.StatusDisplay); } });
		this._statusOptions = [ ...seen ].sort();
		this._kpis = this._computeKPIs();
	}
	async _loadWindow(pGen)
	{
		// The timeline keys bars on the scheduled window (start → deadline), so it always loads by ScheduledStartDate.
		const af = (this._calView === 'timeline') ? 'ScheduledStartDate' : this._axisField(); const win = this._calWindow();
		const base = `FBV~Deleted~EQ~0${this._filterClauses()}`;
		const rangeFlt = `${base}~FBV~${af}~GE~${this._ymd(win.start)}~FBV~${af}~LT~${this._ymd(win.end)}`;
		const WCAP = 6000;
		const rows = await this._get(`Inspections/FilteredTo/${rangeFlt}~FSF~${af}~ASC~0/0/${WCAP}`);
		if (pGen !== this._loadGen) { return; }
		this._rows = Array.isArray(rows) ? rows : [];
		this._windowTruncated = this._rows.length >= WCAP;
		const seen = new Set(this._statusOptions); this._rows.forEach((r) => { if (r.StatusDisplay) { seen.add(r.StatusDisplay); } });
		this._statusOptions = [ ...seen ].sort();
		if (this._calView === 'timeline') { await this._resolveWindowTeams(pGen); }
	}
	// Chunked INN fetch (Meadow filter-length safety) — 100 ids per chunk, PAGED to exhaustion so a rich join set
	// (many docs per inspection, or many grants per doc) is never silently truncated (which would drop a crewed
	// inspection into the Unassigned lane).
	async _innFetch(pEntity, pField, pIDs, pExtra)
	{
		const ids = [ ...new Set(pIDs.map(Number).filter(Boolean)) ]; const out = []; const PAGE = 2000;
		for (let i = 0; i < ids.length; i += 100)
		{
			const chunk = ids.slice(i, i + 100); let off = 0;
			for (;;)
			{
				const rows = await this._get(`${pEntity}/FilteredTo/FBL~${pField}~INN~${chunk.join(',')}${pExtra || ''}/${off}/${PAGE}`);
				const arr = Array.isArray(rows) ? rows : [];
				out.push(...arr);
				if (arr.length < PAGE) { break; }
				off += PAGE;
			}
		}
		return out;
	}
	// Derive each visible inspection's assigned team (Phase-3: a team is granted the inspection's document packet via
	// DocumentAccessJoin). Bounded + batched for the window: inspections → packet docs → team grants. No N+1.
	async _resolveWindowTeams(pGen)
	{
		this._inspTeam = {};
		const inspIDs = this._rows.map((r) => r.IDInspection);
		if (!inspIDs.length) { return; }
		const idj = await this._innFetch('InspectionDocumentJoins', 'IDInspection', inspIDs, '~FBV~Deleted~EQ~0');
		if (pGen !== this._loadGen) { return; }
		const docsByInsp = {}; const allDocIDs = new Set();
		idj.forEach((r) => { (docsByInsp[r.IDInspection] = docsByInsp[r.IDInspection] || []).push(r.IDDocument); allDocIDs.add(r.IDDocument); });
		if (!allDocIDs.size) { return; }
		const grants = await this._innFetch('DocumentAccessJoins', 'IDDocument', [ ...allDocIDs ], '~FBV~Deleted~EQ~0');
		if (pGen !== this._loadGen) { return; }
		const teamByDoc = {}; grants.forEach((g) => { if (Number(g.IDTeam) > 0) { teamByDoc[g.IDDocument] = Number(g.IDTeam); } });
		const teamIDs = new Set();
		inspIDs.forEach((id) => { const docs = docsByInsp[id] || []; const t = docs.map((d) => teamByDoc[d]).find(Boolean); if (t) { this._inspTeam[id] = t; teamIDs.add(t); } });
		if (teamIDs.size)
		{
			const rows = await this._get(`Teams/FilteredTo/FBL~IDTeam~INN~${[ ...teamIDs ].join(',')}/0/${teamIDs.size}`);
			if (pGen !== this._loadGen) { return; }
			(Array.isArray(rows) ? rows : []).forEach((t) => { this._teamNames[t.IDTeam] = t.Name || `Team ${t.IDTeam}`; });
		}
	}

	_computeKPIs()
	{
		const k = { total: 0, active: 0, overdue: 0, due30: 0, due90: 0, future: 0, unscheduled: 0, inprogress: 0, completed: 0 };
		this._all.forEach((r) =>
		{
			k.total++;
			const u = this._urg(r);
			k[u] = (k[u] || 0) + 1;
			if (this._isActive(r)) { k.active++; if (!this._isScheduled(r) && !this._isInProgress(r)) { /* unscheduled counted via _urg only when no deadline; recount below */ } }
		});
		// "unscheduled" as a scheduling state (active & no ScheduledStartDate) — independent of the deadline-urgency bucket
		k.unscheduled = this._all.filter((r) => this._isActive(r) && !this._isScheduled(r)).length;
		return k;
	}

	// =========================================================== interactions ===========================================================
	setMode(pMode) { if ([ 'overview', 'calendar', 'list' ].indexOf(pMode) < 0 || this._mode === pMode) { return; } this._mode = pMode; this._syncHash(); this.loadAsync(); }
	setCalView(pView) { if ([ 'year', 'month', 'week', 'timeline' ].indexOf(pView) < 0) { return; } this._calView = pView; if (this._mode !== 'calendar') { this._mode = 'calendar'; } this._syncHash(); this.loadAsync(); }
	setAxis(pAxis) { const a = (pAxis === 'deadline') ? 'deadline' : 'scheduled'; if (this._axis === a) { return; } this._axis = a; this.loadAsync(); }
	setType(pID) { this._filterType = Number(pID) || 0; this._allSig = '~force'; this.loadAsync(); }
	setStatus(pStatus) { this._filterStatus = pStatus || ''; this._allSig = '~force'; this.loadAsync(); }
	setUrgency(pU) { this._filterUrgency = pU || ''; this._paint(); }
	setSort(pKey) { if (this._listSort.key === pKey) { this._listSort.dir = this._listSort.dir === 'asc' ? 'desc' : 'asc'; } else { this._listSort = { key: pKey, dir: pKey === 'deadline' || pKey === 'scheduled' || pKey === 'name' ? 'asc' : 'asc' }; } this._paint(); }
	drill(pUrgency) { this._filterUrgency = pUrgency || ''; this._mode = 'list'; this._syncHash(); if (this._all.length) { this._paint(); } else { this.loadAsync(); } }
	today() { this._anchor = this._startOfDay(new Date()); this.loadAsync(); }
	go(pDir)
	{
		const d = Number(pDir) || 0;
		if (this._calView === 'year') { this._anchor = new Date(this._anchor.getFullYear() + d, this._anchor.getMonth(), 1); }
		else if (this._calView === 'week') { this._anchor = this._addDays(this._anchor, 7 * d); }
		else { this._anchor = this._addMonths(this._anchor, d); }
		this.loadAsync();
	}
	openMonth(pYear, pMonth) { this._anchor = new Date(Number(pYear), Number(pMonth), 1); this._calView = 'month'; this._mode = 'calendar'; this._syncHash(); this.loadAsync(); }
	openInspection(pID) { const id = Number(pID) || 0; if (id) { try { window.location.hash = `#/Inspection/Workspace/${id}`; } catch (e) { /* */ } } }
	setMonth(pVal) { const m = /^(\d{4})-(\d{2})$/.exec(String(pVal || '')); if (!m) { return; } this._anchor = new Date(Number(m[1]), Number(m[2]) - 1, 1); this.loadAsync(); }
	// --- inspection detail popover (a calendar item click opens THIS, not the reschedule editor) ---
	showDetail(pID)
	{
		const id = Number(pID) || 0; if (!id) { return; }
		this._detailTarget = id; this._detail = { loading: true, id };
		this._paint(); this._loadDetail(id);
	}
	closeDetail() { this._detailTarget = 0; this._detail = null; this._paint(); }
	async _loadDetail(pID)
	{
		const id = Number(pID) || 0; const r = this._findRow(id) || {};
		try
		{
			const [ users, assets ] = await Promise.all([
				this._get(`InspectionUserJoins/FilteredTo/FBV~IDInspection~EQ~${id}~FBV~Deleted~EQ~0/0/50`),
				this._get(`InspectionPhysicalAssetJoins/FilteredTo/FBV~IDInspection~EQ~${id}~FBV~Deleted~EQ~0/0/50`),
			]);
			const uIDs = [ ...new Set((Array.isArray(users) ? users : []).map((u) => u.IDUser).filter(Boolean)) ];
			const createIDs = r.CreatingIDUser ? [ r.CreatingIDUser ] : [];
			const allUserIDs = [ ...new Set([ ...uIDs, ...createIDs ]) ];
			const nameByID = {};
			if (allUserIDs.length) { const rows = await this._get(`Users/FilteredTo/FBL~IDUser~INN~${allUserIDs.join(',')}/0/${allUserIDs.length}`); (Array.isArray(rows) ? rows : []).forEach((u) => { nameByID[u.IDUser] = [ u.NameFirst, u.NameLast ].filter(Boolean).join(' ') || u.LoginID || `#${u.IDUser}`; }); }
			const aIDs = [ ...new Set((Array.isArray(assets) ? assets : []).map((a) => a.IDPhysicalAsset).filter(Boolean)) ];
			let assetList = [];
			if (aIDs.length) { const rows = await this._get(`PhysicalAssets/FilteredTo/FBL~IDPhysicalAsset~INN~${aIDs.join(',')}/0/${aIDs.length}`); assetList = (Array.isArray(rows) ? rows : []).map((a) => ({ id: a.IDPhysicalAsset, name: a.Name || `Asset ${a.IDPhysicalAsset}`, structure: a.ExternalSyncGUID || '' })); }
			if (this._detailTarget !== id) { return; }
			this._detail = { loading: false, id, inspectors: uIDs.map((u) => nameByID[u] || `#${u}`), assets: assetList, createdBy: r.CreatingIDUser ? (nameByID[r.CreatingIDUser] || `#${r.CreatingIDUser}`) : '' };
		}
		catch (e) { if (this._detailTarget === id) { this._detail = { loading: false, id, inspectors: [], assets: [], createdBy: '', error: (e && e.message) || String(e) }; } }
		this._paint();
	}
	rescheduleFromDetail(pID) { this._detailTarget = 0; this._detail = null; this.beginSchedule(pID); }
	// --- manual scheduling ---
	beginSchedule(pID)
	{
		const id = Number(pID) || 0; const r = this._findRow(id); if (!r) { return; }
		this._detailTarget = 0;
		this._scheduleTarget = { IDInspection: id, Name: r.Name || `Inspection ${id}`, ScheduledStartDate: r.ScheduledStartDate ? String(r.ScheduledStartDate).slice(0, 10) : '', DeadlineDate: r.DeadlineDate ? String(r.DeadlineDate).slice(0, 10) : '' };
		this._paint();
	}
	cancelSchedule() { this._scheduleTarget = null; this._paint(); }
	async saveSchedule()
	{
		const t = this._scheduleTarget; if (!t) { return; }
		const el = this.pict.ContentAssignment.getElement('#isc-sched-date'); const val = (el && el.length) ? el[0].value : '';
		await this._commitSchedule(t.IDInspection, val || null);
	}
	async clearScheduleDate() { const t = this._scheduleTarget; if (!t) { return; } await this._commitSchedule(t.IDInspection, null); }
	async _commitSchedule(pID, pDateOrNull)
	{
		try { await this._put('Inspection', { IDInspection: Number(pID), ScheduledStartDate: pDateOrNull }); this._patchRow(pID, { ScheduledStartDate: pDateOrNull }); }
		catch (e) { this.pict.log.error(`Reschedule failed: ${e.message || e}`); }
		this._scheduleTarget = null;
		this._kpis = this._all.length ? this._computeKPIs() : this._kpis;
		if (this._mode === 'calendar') { this.loadAsync(); } else { this._paint(); }
	}
	_findRow(pID) { const id = Number(pID); return this._all.find((r) => r.IDInspection === id) || this._rows.find((r) => r.IDInspection === id) || null; }
	_patchRow(pID, pPatch) { const id = Number(pID); [ this._all, this._rows ].forEach((arr) => { const r = arr.find((x) => x.IDInspection === id); if (r) { Object.assign(r, pPatch); } }); }
	_syncHash() { try { const seg = this._mode === 'calendar' ? this._calView : this._mode; const h = `#/InspectionSchedule/${seg}`; if (window.location.hash !== h) { window.history.replaceState(null, '', h); } } catch (e) { /* */ } }
	applyViewFromRoute(pView)
	{
		if (!pView) { return; }
		if ([ 'year', 'month', 'week', 'timeline' ].indexOf(pView) >= 0) { this._mode = 'calendar'; this._calView = pView; }
		else if ([ 'overview', 'list', 'calendar' ].indexOf(pView) >= 0) { this._mode = pView; }
	}

	// =========================================================== paint ===========================================================
	_paint() { const ca = this.pict.ContentAssignment; if (!ca) { return; } ca.assignContent(this._mount, this._shellHTML()); if (this._mode === 'overview') { try { setTimeout(() => this._mountThroughput(), 0); } catch (e) { /* */ } } }
	// Embed the reusable DocumentThroughput dashboard (Inspection-Dossier, compact) into the Overview. The Overview repaints
	// wipe the host, so re-mount after each paint; reuse the cached aggregation when it is already loaded for this type.
	_mountThroughput()
	{
		const tp = this.pict.providers && this.pict.providers['DocumentThroughput'];
		const ca = this.pict.ContentAssignment;
		if (!tp || !ca || ca.getElement('#InspectionSchedule-ThroughputHost').length === 0) { return; }
		const cfg = Object.assign({}, libThroughputConfigs.resolveConfig('Inspection-Dossier'), { Compact: true });
		tp._mount = '#InspectionSchedule-ThroughputHost';
		if (tp._docType === 'Inspection-Dossier' && tp._agg) { tp._config = cfg; tp._paint(); return; }
		// A load is already in flight for this type — don't restart it on every Overview repaint (that would thrash the
		// Documents/Lite + approval-log fetches); just repaint the loading state.
		if (tp._loading && tp._config && tp._config.DocumentType === 'Inspection-Dossier') { tp._paint(); return; }
		tp._config = cfg; tp.loadAsync();
	}
	_shellHTML() { return `${_STYLE}<div class="isc">${this._toolbarHTML()}<div class="isc-body">${this._bodyHTML()}</div>${this._scheduleModalHTML()}${this._detailModalHTML()}</div>`; }
	_toolbarHTML()
	{
		const P = this.providerName;
		const mbtn = (m, label, icon) => `<button class="isc-vbtn${this._mode === m ? ' on' : ''}" onclick="_Pict.providers.${P}.setMode('${m}')"><i class="${icon}"></i> ${label}</button>`;
		const typeOpts = `<option value="0"${!this._filterType ? ' selected' : ''}>All types</option>` + this._typeOptions.map((o) => `<option value="${o.IDInspectionType}"${this._filterType === o.IDInspectionType ? ' selected' : ''}>${this._esc(o.Name)}</option>`).join('');
		const statusOpts = `<option value=""${!this._filterStatus ? ' selected' : ''}>All statuses</option>` + this._statusOptions.map((s) => `<option value="${this._esc(s)}"${this._filterStatus === s ? ' selected' : ''}>${this._esc(s)}</option>`).join('');
		let ctx = '';
		if (this._mode === 'calendar')
		{
			const cv = (v, label) => `<button class="${this._calView === v ? 'on' : ''}" onclick="_Pict.providers.${P}.setCalView('${v}')">${label}</button>`;
			ctx = `<div class="isc-nav">
				<div class="isc-calviews">${cv('year', 'Year')}${cv('month', 'Month')}${cv('week', 'Week')}${cv('timeline', 'Timeline')}</div>
				<button class="isc-navbtn" title="Previous" onclick="_Pict.providers.${P}.go(-1)"><i class="fas fa-chevron-left"></i></button>
				<button class="isc-today" onclick="_Pict.providers.${P}.today()">Today</button>
				<button class="isc-navbtn" title="Next" onclick="_Pict.providers.${P}.go(1)"><i class="fas fa-chevron-right"></i></button>
				<span class="isc-period">${this._esc(this._calPeriodLabel())}</span>
				${this._calView === 'year' ? '' : `<input type="month" class="isc-monthpick" title="Jump to any month — e.g. last year" value="${this._anchor.getFullYear()}-${String(this._anchor.getMonth() + 1).padStart(2, '0')}" onchange="_Pict.providers.${P}.setMonth(this.value)">`}
				${this._calView === 'timeline' ? '' : `<div class="isc-axis"><button class="${this._axis === 'scheduled' ? 'on' : ''}" onclick="_Pict.providers.${P}.setAxis('scheduled')">Scheduled</button><button class="${this._axis === 'deadline' ? 'on' : ''}" onclick="_Pict.providers.${P}.setAxis('deadline')">Deadline</button></div>`}
			</div>`;
		}
		return `<div class="isc-toolbar">
			<div class="isc-views">${mbtn('overview', 'Overview', 'fas fa-gauge-high')}${mbtn('calendar', 'Calendar', 'fas fa-calendar-days')}${mbtn('list', 'Worklist', 'fas fa-list-check')}</div>
			${ctx}
			<div class="isc-filters">
				${this._loading ? '<i class="fas fa-circle-notch fa-spin isc-spin"></i>' : ''}
				<select class="isc-sel" onchange="_Pict.providers.${P}.setType(this.value)">${typeOpts}</select>
				<select class="isc-sel" onchange="_Pict.providers.${P}.setStatus(this.value)">${statusOpts}</select>
				<a class="isc-newbtn" href="#/PSRS/Inspection/Create"><i class="fas fa-plus"></i> New inspection</a>
			</div>
		</div>`;
	}
	_bodyHTML()
	{
		if (this._error) { return `<div class="isc-empty isc-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._error)}</div>`; }
		if (this._loading && !this._all.length && !this._rows.length) { return `<div class="isc-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading the program…</div>`; }
		if (this._mode === 'overview') { return this._overviewHTML(); }
		if (this._mode === 'list') { return this._listHTML(); }
		return this._calendarHTML();
	}

	// =========================================================== OVERVIEW ===========================================================
	_overviewHTML()
	{
		const k = this._kpis || this._computeKPIs(); const P = this.providerName;
		const tile = (val, label, urg, drill) => `<button class="isc-kpi${urg ? ' u-' + urg : ''}" onclick="_Pict.providers.${P}.drill('${drill || ''}')"><div class="isc-kpi-v">${(val || 0).toLocaleString()}</div><div class="isc-kpi-l">${label}</div></button>`;
		const kpis = `<div class="isc-kpis">
			${tile(k.active, 'Active inspections', '', '')}
			${tile(k.overdue, 'Overdue', 'overdue', 'overdue')}
			${tile(k.due30, 'Due ≤30 days', 'due30', 'due30')}
			${tile(k.due90, 'Due 31–90 days', 'due90', 'due90')}
			${tile(k.unscheduled, 'Unscheduled', 'unscheduled', 'unscheduled')}
			${tile(k.inprogress, 'In progress', 'inprogress', 'inprogress')}
			${tile(k.completed, 'Completed', 'completed', 'completed')}
		</div>`;
		const compliance = (() =>
		{
			const denom = k.active || 0; const atRisk = (k.overdue || 0) + (k.due30 || 0);
			const pct = denom ? Math.round(100 * (denom - (k.overdue || 0)) / denom) : 100;
			return `<div class="isc-compliance">
				<div class="isc-comp-h">Program compliance <span class="isc-comp-pct${k.overdue ? ' bad' : ''}">${pct}%</span></div>
				<div class="isc-comp-bar"><span style="width:${pct}%"></span></div>
				<div class="isc-comp-sub">${(k.overdue || 0).toLocaleString()} overdue · ${atRisk.toLocaleString()} overdue or due within 30 days · ${(k.unscheduled || 0).toLocaleString()} still unscheduled</div>
			</div>`;
		})();
		return `${kpis}${compliance}
			<div class="isc-cols">
				<div class="isc-card"><div class="isc-card-h"><i class="fas fa-wave-square"></i> Compliance demand — next 12 months</div>${this._workloadHTML()}</div>
				<div class="isc-card"><div class="isc-card-h"><i class="fas fa-diagram-project"></i> Pipeline</div>${this._pipelineHTML()}</div>
			</div>
			<div class="isc-card"><div class="isc-card-h"><i class="fas fa-gauge-simple-high"></i> Submission throughput <span class="isc-cardsub">dossier approvals — the real completion signal</span><a class="isc-cardlink" href="#/DocumentThroughput/Inspection-Dossier">full dashboard</a></div><div id="InspectionSchedule-ThroughputHost"></div></div>
			<div class="isc-cols">
				<div class="isc-card"><div class="isc-card-h"><i class="fas fa-layer-group"></i> By inspection type</div>${this._typeBreakdownHTML()}</div>
				<div class="isc-card"><div class="isc-card-h"><i class="fas fa-triangle-exclamation"></i> Needs attention <button class="isc-cardlink" onclick="_Pict.providers.${P}.drill('overdue')">open worklist</button></div>${this._needsAttentionHTML()}</div>
			</div>
			${this._allTruncated ? `<div class="isc-note"><i class="fas fa-circle-info"></i> Showing the first ${_ALL_CAP.toLocaleString()} inspections (capped). Filter by type to narrow the program view.</div>` : ''}
			${this._legendHTML()}`;
	}
	_workloadHTML()
	{
		// Bars by DEADLINE month for the next 12 months (the compliance demand wave), colored by urgency; the overdue
		// backlog and unscheduled pool are called out beside the chart since they sit outside the forward window.
		const months = []; const start = this._startOfMonth(new Date());
		for (let i = 0; i < 12; i++) { const d = this._addMonths(start, i); months.push({ key: this._ymd(d).slice(0, 7), y: d.getFullYear(), m: d.getMonth() }); }
		const idx = {}; months.forEach((mo, i) => { idx[mo.key] = i; });
		const stacks = months.map(() => ({ overdue: 0, due30: 0, due90: 0, future: 0 }));
		let max = 0;
		this._all.forEach((r) =>
		{
			if (!this._isActive(r) || !r.DeadlineDate) { return; }
			const key = String(r.DeadlineDate).slice(0, 7); const i = idx[key]; if (i == null) { return; }
			const u = this._urg(r); if (stacks[i][u] == null) { stacks[i].future++; } else { stacks[i][u]++; }
		});
		months.forEach((mo, i) => { const tot = stacks[i].overdue + stacks[i].due30 + stacks[i].due90 + stacks[i].future; if (tot > max) { max = tot; } });
		const P = this.providerName;
		const bars = months.map((mo, i) =>
		{
			const s = stacks[i]; const tot = s.overdue + s.due30 + s.due90 + s.future; const h = max ? Math.round(100 * tot / max) : 0;
			const seg = (u) => s[u] ? `<span class="isc-seg" style="flex:${s[u]};background:${_U[u].c}" title="${_U[u].label}: ${s[u]}"></span>` : '';
			return `<button class="isc-bar" onclick="_Pict.providers.${P}.openMonth(${mo.y}, ${mo.m})" title="${_MON[mo.m]} ${mo.y}: ${tot}">
				<span class="isc-bar-n">${tot || ''}</span>
				<span class="isc-bar-col" style="height:${Math.max(h, tot ? 6 : 0)}%">${seg('overdue')}${seg('due30')}${seg('due90')}${seg('future')}</span>
				<span class="isc-bar-x">${_MON[mo.m]}${mo.m === 0 ? " '" + String(mo.y).slice(2) : ''}</span>
			</button>`;
		}).join('');
		const k = this._kpis || {};
		return `<div class="isc-workload">
			<div class="isc-chart">${bars || '<div class="isc-empty-sm">No dated inspections in the next 12 months.</div>'}</div>
			<div class="isc-backlog">
				<button class="isc-back u-overdue" onclick="_Pict.providers.${this.providerName}.drill('overdue')"><div class="isc-back-v">${(k.overdue || 0).toLocaleString()}</div><div class="isc-back-l">Overdue backlog</div></button>
				<button class="isc-back u-unscheduled" onclick="_Pict.providers.${this.providerName}.drill('unscheduled')"><div class="isc-back-v">${(k.unscheduled || 0).toLocaleString()}</div><div class="isc-back-l">Unscheduled — place these</div></button>
			</div>
		</div>`;
	}
	_pipelineHTML()
	{
		const k = this._kpis || {};
		const steps = [
			{ u: 'unscheduled', v: k.unscheduled || 0 },
			{ u: 'future', v: k.future || 0 },
			{ u: 'due90', v: (k.due90 || 0) + (k.due30 || 0) },
			{ u: 'overdue', v: k.overdue || 0 },
			{ u: 'inprogress', v: k.inprogress || 0 },
			{ u: 'completed', v: k.completed || 0 },
		];
		const max = Math.max(1, ...steps.map((s) => s.v));
		const P = this.providerName;
		const rows = steps.map((s) => `<button class="isc-pipe" onclick="_Pict.providers.${P}.drill('${s.u === 'due90' ? 'due90' : s.u}')">
			<span class="isc-pipe-l"><span class="isc-dot" style="background:${_U[s.u].c}"></span>${s.u === 'due90' ? 'Due ≤90 days' : _U[s.u].label}</span>
			<span class="isc-pipe-track"><span class="isc-pipe-fill" style="width:${Math.round(100 * s.v / max)}%;background:${_U[s.u].c}"></span></span>
			<span class="isc-pipe-v">${s.v.toLocaleString()}</span>
		</button>`).join('');
		return `<div class="isc-pipeline">${rows}</div>`;
	}
	_typeBreakdownHTML()
	{
		const by = {};
		this._all.forEach((r) => { const id = r.IDInspectionType || 0; if (!by[id]) { by[id] = { id, total: 0, overdue: 0, duesoon: 0, inprogress: 0, completed: 0 }; } const b = by[id]; b.total++; const u = this._urg(r); if (u === 'overdue') { b.overdue++; } else if (u === 'due30' || u === 'due90') { b.duesoon++; } else if (u === 'inprogress') { b.inprogress++; } else if (u === 'completed') { b.completed++; } });
		const rows = Object.values(by).sort((a, b) => b.total - a.total);
		if (!rows.length) { return '<div class="isc-empty-sm">No inspections.</div>'; }
		const P = this.providerName;
		const body = rows.map((b) =>
		{
			const seg = (n, u) => n ? `<span style="flex:${n};background:${_U[u].c}" title="${_U[u].label}: ${n}"></span>` : '';
			const other = b.total - b.overdue - b.duesoon - b.inprogress - b.completed;
			return `<tr onclick="_Pict.providers.${P}.setType(${b.id})">
				<td class="isc-tb-name">${this._esc(this._typeName(b.id))}</td>
				<td class="isc-tb-bar"><div class="isc-tbbar">${seg(b.overdue, 'overdue')}${seg(b.duesoon, 'due90')}${seg(b.inprogress, 'inprogress')}${seg(b.completed, 'completed')}${other ? `<span style="flex:${other};background:${_U.future.c}"></span>` : ''}</div></td>
				<td class="isc-tb-n">${b.total}</td>
				<td class="isc-tb-o${b.overdue ? ' bad' : ''}">${b.overdue || '—'}</td>
			</tr>`;
		}).join('');
		return `<table class="isc-tbtable"><thead><tr><th>Type</th><th></th><th>Total</th><th>Overdue</th></tr></thead><tbody>${body}</tbody></table>`;
	}
	_needsAttentionHTML()
	{
		const P = this.providerName;
		const rank = (r) => { const u = this._urg(r); const uns = this._isActive(r) && !this._isScheduled(r); if (u === 'overdue') { return 0; } if (uns) { return 1; } if (u === 'due30') { return 2; } if (u === 'due90') { return 3; } return 9; };
		const items = this._all.filter((r) => this._isActive(r) && (this._urg(r) === 'overdue' || this._urg(r) === 'due30' || this._urg(r) === 'due90' || !this._isScheduled(r)))
			.sort((a, b) => { const ra = rank(a); const rb = rank(b); if (ra !== rb) { return ra - rb; } const da = a.DeadlineDate ? String(a.DeadlineDate).slice(0, 10) : '9999'; const db = b.DeadlineDate ? String(b.DeadlineDate).slice(0, 10) : '9999'; return da < db ? -1 : da > db ? 1 : 0; })
			.slice(0, 12);
		if (!items.length) { return '<div class="isc-empty-sm"><i class="fas fa-circle-check"></i> Nothing overdue, due soon, or unscheduled. The program is on track.</div>'; }
		const rows = items.map((r) =>
		{
			const u = this._urg(r); const col = _U[u]; const dl = r.DeadlineDate ? String(r.DeadlineDate).slice(0, 10) : '';
			const uns = this._isActive(r) && !this._isScheduled(r);
			const due = dl ? (u === 'overdue' ? `${Math.abs(this._daysBetween(this._todayYMD(), dl))}d overdue` : `due in ${this._daysBetween(this._todayYMD(), dl)}d`) : 'no deadline';
			return `<div class="isc-na">
				<span class="isc-dot" style="background:${col.c}"></span>
				<span class="isc-na-main"><span class="isc-na-name" onclick="_Pict.providers.${P}.showDetail(${r.IDInspection})">${this._esc(r.Name || ('Inspection ' + r.IDInspection))}</span><span class="isc-na-meta">${this._esc(this._typeName(r.IDInspectionType))} · <span style="color:${col.c};font-weight:700">${due}</span>${uns ? ' · <span class="isc-unsched">unscheduled</span>' : ''}</span></span>
				<button class="isc-na-btn" onclick="_Pict.providers.${P}.beginSchedule(${r.IDInspection})"><i class="fas fa-calendar-plus"></i> ${uns ? 'Schedule' : 'Reschedule'}</button>
			</div>`;
		}).join('');
		return `<div class="isc-nalist">${rows}</div>`;
	}
	_legendHTML()
	{
		return `<div class="isc-legend">${[ 'overdue', 'due30', 'due90', 'future', 'unscheduled', 'inprogress', 'completed' ].map((u) => `<span class="isc-leg"><span class="isc-dot" style="background:${_U[u].c}"></span>${_U[u].label}</span>`).join('')}</div>`;
	}

	// =========================================================== LIST (worklist) ===========================================================
	_listHTML()
	{
		const P = this.providerName;
		let rows = this._all.slice();
		const uf = this._filterUrgency;
		if (uf === 'unscheduled') { rows = rows.filter((r) => this._isActive(r) && !this._isScheduled(r)); }
		else if (uf) { rows = rows.filter((r) => this._urg(r) === uf); }
		const s = this._listSort; const val = (r) => { if (s.key === 'name') { return String(r.Name || '').toLowerCase(); } if (s.key === 'type') { return this._typeName(r.IDInspectionType).toLowerCase(); } if (s.key === 'scheduled') { return r.ScheduledStartDate ? String(r.ScheduledStartDate).slice(0, 10) : '9999'; } if (s.key === 'status') { return String(r.StatusDisplay || '').toLowerCase(); } return r.DeadlineDate ? String(r.DeadlineDate).slice(0, 10) : '9999'; };
		rows.sort((a, b) => { const va = val(a); const vb = val(b); const c = va < vb ? -1 : va > vb ? 1 : 0; return s.dir === 'asc' ? c : -c; });
		const total = rows.length; const shown = rows.slice(0, 300);
		const urgChips = [ [ '', 'All' ], [ 'overdue', 'Overdue' ], [ 'due30', 'Due ≤30' ], [ 'due90', 'Due ≤90' ], [ 'unscheduled', 'Unscheduled' ], [ 'inprogress', 'In progress' ], [ 'completed', 'Completed' ] ]
			.map(([ v, label ]) => `<button class="isc-chipf${this._filterUrgency === v ? ' on' : ''}${v ? ' u-' + v : ''}" onclick="_Pict.providers.${P}.setUrgency('${v}')">${label}</button>`).join('');
		const sortIc = (key) => s.key === key ? `<i class="fas fa-caret-${s.dir === 'asc' ? 'up' : 'down'}"></i>` : '';
		const th = (key, label) => `<th class="isc-sortable" onclick="_Pict.providers.${P}.setSort('${key}')">${label} ${sortIc(key)}</th>`;
		const body = shown.map((r) =>
		{
			const u = this._urg(r); const col = _U[u]; const dl = r.DeadlineDate ? String(r.DeadlineDate).slice(0, 10) : '';
			const uns = this._isActive(r) && !this._isScheduled(r);
			const days = dl ? this._daysBetween(this._todayYMD(), dl) : null;
			const daysCell = dl ? (days < 0 ? `<span class="isc-days over">${Math.abs(days)}d over</span>` : `<span class="isc-days">${days}d</span>`) : '<span class="isc-mut">—</span>';
			return `<tr>
				<td><span class="isc-dot" style="background:${col.c}"></span></td>
				<td class="isc-l-name" onclick="_Pict.providers.${P}.showDetail(${r.IDInspection})">${this._esc(r.Name || ('Inspection ' + r.IDInspection))}${uns ? ' <span class="isc-unsched">unscheduled</span>' : ''}</td>
				<td><span class="isc-atype">${this._esc(this._typeName(r.IDInspectionType))}</span></td>
				<td class="isc-nowrap">${r.ScheduledStartDate ? this._esc(String(r.ScheduledStartDate).slice(0, 10)) : '<span class="isc-mut">—</span>'}</td>
				<td class="isc-nowrap">${dl ? this._esc(dl) : '<span class="isc-mut">—</span>'}</td>
				<td class="isc-nowrap">${daysCell}</td>
				<td><span class="isc-astatus" style="--c:${col.c};--bg:${col.bg}">${this._esc(r.StatusDisplay || col.label)}</span></td>
				<td class="isc-l-act"><button class="isc-act" title="Schedule / reschedule" onclick="_Pict.providers.${P}.beginSchedule(${r.IDInspection})"><i class="fas fa-calendar-plus"></i></button><button class="isc-act" title="Open workspace" onclick="_Pict.providers.${P}.openInspection(${r.IDInspection})"><i class="fas fa-arrow-right"></i></button></td>
			</tr>`;
		}).join('');
		return `<div class="isc-listwrap">
			<div class="isc-chipbar">${urgChips}<span class="isc-count">${total.toLocaleString()} inspection${total === 1 ? '' : 's'}${total > 300 ? ' · showing first 300' : ''}</span></div>
			<table class="isc-ltable"><thead><tr><th></th>${th('name', 'Inspection')}${th('type', 'Type')}${th('scheduled', 'Scheduled')}${th('deadline', 'Deadline')}${th('deadline', 'Due in')}<th>Status</th><th></th></tr></thead><tbody>${body || '<tr><td colspan="8" class="isc-empty-sm">No inspections match.</td></tr>'}</tbody></table>
		</div>`;
	}

	// =========================================================== CALENDAR ===========================================================
	_calWindow()
	{
		const a = this._anchor;
		if (this._calView === 'year') { return { start: new Date(a.getFullYear(), 0, 1), end: new Date(a.getFullYear() + 1, 0, 1) }; }
		if (this._calView === 'week') { const s = this._startOfWeek(a); return { start: s, end: this._addDays(s, 7) }; }
		if (this._calView === 'timeline') { const s = this._startOfMonth(a); return { start: s, end: this._addMonths(s, 1) }; }
		const gs = this._startOfWeek(this._startOfMonth(a)); return { start: gs, end: this._addDays(gs, 42) };
	}
	_calPeriodLabel()
	{
		const a = this._anchor;
		if (this._calView === 'year') { return String(a.getFullYear()); }
		if (this._calView === 'week') { const s = this._startOfWeek(a); const e = this._addDays(s, 6); const sm = s.getMonth() === e.getMonth(); return `${_MON[s.getMonth()]} ${s.getDate()} – ${sm ? '' : _MON[e.getMonth()] + ' '}${e.getDate()}, ${e.getFullYear()}`; }
		return `${_MONTHS[a.getMonth()]} ${a.getFullYear()}`;
	}
	_calDayKey(r) { const v = r[this._axisField()]; return v ? String(v).slice(0, 10) : ''; }
	_byDay() { const m = {}; this._rows.forEach((r) => { const k = this._calDayKey(r); if (k) { (m[k] = m[k] || []).push(r); } }); return m; }
	_calendarHTML() { const t = this._windowTruncated ? `<div class="isc-note"><i class="fas fa-circle-info"></i> This period has more inspections than the view loads — counts may be partial. Filter by type or narrow the range.</div>` : ''; if (this._calView === 'year') { return t + this._yearHTML(); } if (this._calView === 'week') { return t + this._weekHTML(); } if (this._calView === 'timeline') { return t + this._timelineHTML(); } return t + this._monthHTML(); }
	_calChip(r)
	{
		const P = this.providerName; const u = this._urg(r); const col = _U[u];
		return `<button class="isc-chip" style="--c:${col.c};--bg:${col.bg}" title="${this._esc(r.Name || '')} · ${this._esc(this._typeName(r.IDInspectionType))} · ${col.label}" onclick="event.stopPropagation();_Pict.providers.${P}.showDetail(${r.IDInspection})"><span class="isc-chip-dot" style="background:${col.c}"></span><span class="isc-chip-t">${this._esc(r.Name || ('Inspection ' + r.IDInspection))}</span></button>`;
	}
	_yearHTML()
	{
		const P = this.providerName; const y = this._anchor.getFullYear();
		const counts = new Array(12).fill(0); const buckets = Array.from({ length: 12 }, () => ({ overdue: 0, due30: 0, due90: 0, future: 0, inprogress: 0, completed: 0, unscheduled: 0 }));
		this._rows.forEach((r) => { const k = this._calDayKey(r); if (!k) { return; } const m = Number(k.slice(5, 7)) - 1; if (m >= 0 && m < 12) { counts[m]++; buckets[m][this._urg(r)]++; } });
		const cells = _MONTHS.map((name, m) =>
		{
			const bd = buckets[m]; const total = counts[m];
			const bar = total ? `<div class="isc-ybar">${[ 'overdue', 'due30', 'due90', 'inprogress', 'future', 'completed', 'unscheduled' ].map((u) => bd[u] ? `<span style="flex:${bd[u]};background:${_U[u].c}" title="${_U[u].label}: ${bd[u]}"></span>` : '').join('')}</div>` : '<div class="isc-ybar isc-ybar-empty"></div>';
			return `<button class="isc-ycell" onclick="_Pict.providers.${P}.openMonth(${y}, ${m})"><div class="isc-ycell-h"><span class="isc-ycell-m">${name}</span><span class="isc-ycell-n">${total || ''}</span></div>${bar}</button>`;
		}).join('');
		return `<div class="isc-year">${cells}</div>${this._legendHTML()}`;
	}
	_monthHTML()
	{
		const P = this.providerName; const byDay = this._byDay(); const today = this._todayYMD();
		const gs = this._startOfWeek(this._startOfMonth(this._anchor)); const am = this._anchor.getMonth();
		const head = `<div class="isc-mhead">${_WEEKDAYS.map((d) => `<div>${d}</div>`).join('')}</div>`;
		let cells = '';
		for (let i = 0; i < 42; i++)
		{
			const d = this._addDays(gs, i); const k = this._ymd(d); const inMonth = d.getMonth() === am; const isToday = k === today; const items = byDay[k] || [];
			const shown = items.slice(0, 4).map((r) => this._calChip(r)).join('');
			const more = items.length > 4 ? `<span class="isc-more">+${items.length - 4} more</span>` : '';
			cells += `<div class="isc-cell${inMonth ? '' : ' isc-out'}${isToday ? ' isc-today-c' : ''}"><div class="isc-cell-d">${d.getDate()}${isToday ? '<span class="isc-todaydot"></span>' : ''}</div><div class="isc-cell-items">${shown}${more}</div></div>`;
		}
		return `<div class="isc-month">${head}<div class="isc-grid">${cells}</div></div>${this._legendHTML()}`;
	}
	_weekHTML()
	{
		const byDay = this._byDay(); const today = this._todayYMD(); const ws = this._startOfWeek(this._anchor);
		let cols = '';
		for (let i = 0; i < 7; i++)
		{
			const d = this._addDays(ws, i); const k = this._ymd(d); const isToday = k === today; const items = byDay[k] || [];
			cols += `<div class="isc-wcol${isToday ? ' isc-today-c' : ''}"><div class="isc-wcol-h"><span class="isc-wcol-wd">${_WEEKDAYS[d.getDay()]}</span><span class="isc-wcol-n${isToday ? ' on' : ''}">${d.getDate()}</span></div><div class="isc-wcol-items">${items.length ? items.map((r) => this._calChip(r)).join('') : '<div class="isc-wcol-empty">—</div>'}</div></div>`;
		}
		return `<div class="isc-week">${cols}</div>${this._legendHTML()}`;
	}

	// =========================================================== schedule modal ===========================================================
	_scheduleModalHTML()
	{
		const t = this._scheduleTarget; if (!t) { return ''; }
		const P = this.providerName;
		return `<div class="isc-modalbg" onclick="_Pict.providers.${P}.cancelSchedule()"><div class="isc-modal" onclick="event.stopPropagation()">
			<div class="isc-modal-h"><i class="fas fa-calendar-plus"></i> Schedule inspection</div>
			<div class="isc-modal-name">${this._esc(t.Name)}</div>
			<label class="isc-modal-f">Scheduled start date<input id="isc-sched-date" type="date" value="${this._esc(t.ScheduledStartDate)}"></label>
			<div class="isc-modal-dl">${t.DeadlineDate ? `Compliance deadline: <b>${this._esc(t.DeadlineDate)}</b>` : 'No deadline set.'}<a class="isc-modal-open" href="#/Inspection/Workspace/${t.IDInspection}">Open inspection <i class="fas fa-arrow-up-right-from-square"></i></a></div>
			<div class="isc-modal-act">
				<button class="isc-btn ghost" onclick="_Pict.providers.${P}.cancelSchedule()">Cancel</button>
				${t.ScheduledStartDate ? `<button class="isc-btn ghost" onclick="_Pict.providers.${P}.clearScheduleDate()">Clear date</button>` : ''}
				<button class="isc-btn" onclick="_Pict.providers.${P}.saveSchedule()"><i class="fas fa-check"></i> Save</button>
			</div>
		</div></div>`;
	}

	_detailModalHTML()
	{
		const id = this._detailTarget; if (!id) { return ''; }
		const r = this._findRow(id) || {}; const P = this.providerName; const d = this._detail || {};
		const status = r.StatusDisplay || '—'; const col = _U[this._urg(r)];
		const typeName = this._typeName(r.IDInspectionType);
		const team = this._inspTeam[id] ? (this._teamNames[this._inspTeam[id]] || `Team ${this._inspTeam[id]}`) : null;
		const field = (label, value) => `<div class="isc-dt-f"><div class="isc-dt-l">${label}</div><div class="isc-dt-v">${value}</div></div>`;
		const dt = (v) => v ? this._esc(this._fmtDate(v)) : '<span class="isc-mut">—</span>';
		const who = d.loading ? '<span class="isc-mut"><i class="fas fa-circle-notch fa-spin"></i> loading…</span>'
			: ((d.inspectors && d.inspectors.length) ? d.inspectors.map((n) => `<span class="isc-dt-chip">${this._esc(n)}</span>`).join(' ')
				: `<span class="isc-mut">No inspector assigned${team ? '' : ' · no crew'}</span>`);
		const assets = d.loading ? '' : ((d.assets && d.assets.length) ? d.assets.map((a) => `<a class="isc-link" href="#/Asset/Workspace/${a.id}">${this._esc(a.name)}${a.structure ? ` · ${this._esc(a.structure)}` : ''}</a>`).join('<br>') : '<span class="isc-mut">—</span>');
		return `<div class="isc-modalbg" onclick="_Pict.providers.${P}.closeDetail()"><div class="isc-modal isc-dt" onclick="event.stopPropagation()">
			<div class="isc-dt-head"><span class="isc-status ${this._statusClass(status)}">${this._esc(status)}</span>${typeName ? `<span class="isc-typepill">${this._esc(typeName)}</span>` : ''}${team ? `<span class="isc-dt-crew"><i class="fas fa-users"></i> ${this._esc(team)}</span>` : '<span class="isc-dt-crew isc-mut"><i class="fas fa-user-slash"></i> Unassigned</span>'}<button class="isc-dt-x" title="Close" onclick="_Pict.providers.${P}.closeDetail()"><i class="fas fa-xmark"></i></button></div>
			<div class="isc-dt-name">${this._esc(r.Name || ('Inspection ' + id))}</div>
			<div class="isc-dt-grid">
				${field('Inspector(s)', who)}
				${field('Asset', assets)}
				${field('Scheduled start', dt(r.ScheduledStartDate))}
				${field('Deadline', dt(r.DeadlineDate))}
				${field('Started', dt(r.StartDate))}
				${field('Completed', dt(r.EndDate))}
				${field('Project', r.IDProject ? `<a class="isc-link" href="#/Project/Workspace/${r.IDProject}">Project ${r.IDProject}</a>` : '<span class="isc-mut">—</span>')}
				${field('Created by', d.loading ? '…' : (d.createdBy ? this._esc(d.createdBy) : '<span class="isc-mut">—</span>'))}
			</div>
			<div class="isc-modal-act">
				<button class="isc-btn ghost" onclick="_Pict.providers.${P}.closeDetail()">Close</button>
				<button class="isc-btn ghost" onclick="_Pict.providers.${P}.rescheduleFromDetail(${id})"><i class="fas fa-calendar-plus"></i> Reschedule</button>
				<a class="isc-btn" href="#/Inspection/Workspace/${id}"><i class="fas fa-arrow-up-right-from-square"></i> Open inspection</a>
			</div>
		</div></div>`;
	}

	// =========================================================== TIMELINE (team swimlanes) ===========================================================
	_timelineHTML()
	{
		const P = this.providerName;
		const monthStart = this._startOfMonth(this._anchor); const daysInMonth = this._addDays(this._addMonths(monthStart, 1), -1).getDate();
		const monthStartYMD = this._ymd(monthStart); const todayYMD = this._todayYMD();
		const scheduled = this._rows.filter((r) => r.ScheduledStartDate);
		if (!scheduled.length) { return `<div class="isc-empty">Nothing scheduled in ${this._esc(this._calPeriodLabel())}. Place unscheduled inspections from the Worklist, then assign crews from an inspection's Teams tab.</div>${this._legendHTML()}`; }
		// group into lanes by assigned team (+ Unassigned)
		const lanes = {};
		scheduled.forEach((r) => { const t = this._inspTeam[r.IDInspection] || 0; const k = t ? `t${t}` : 'unassigned'; if (!lanes[k]) { lanes[k] = { label: t ? (this._teamNames[t] || `Team ${t}`) : 'Unassigned', idTeam: t, items: [] }; } lanes[k].items.push(r); });
		const laneKeys = Object.keys(lanes).sort((a, b) => (a === 'unassigned' ? 1 : b === 'unassigned' ? -1 : lanes[a].label.localeCompare(lanes[b].label)));
		const clamp = (v) => Math.max(0, Math.min(100, v));
		// weekly day-axis ticks
		const ticks = []; for (let d = 1; d <= daysInMonth; d++) { if (d === 1 || (d % 7) === 1) { ticks.push(d); } }
		const axis = `<div class="isc-tl-axis"><div class="isc-tl-axis-l"></div><div class="isc-tl-axis-t">${ticks.map((d) => `<span class="isc-tl-tick" style="left:${((d - 1) / daysInMonth) * 100}%">${_MON[monthStart.getMonth()]} ${d}</span>`).join('')}</div></div>`;
		const todayLeft = (todayYMD.slice(0, 7) === monthStartYMD.slice(0, 7)) ? clamp((this._daysBetween(monthStartYMD, todayYMD) / daysInMonth) * 100) : -1;
		const bar = (r) =>
		{
			const s = String(r.ScheduledStartDate).slice(0, 10); const dl = r.DeadlineDate ? String(r.DeadlineDate).slice(0, 10) : '';
			const startOff = this._daysBetween(monthStartYMD, s); const endOff = dl ? this._daysBetween(monthStartYMD, dl) : startOff;
			const left = clamp((startOff / daysInMonth) * 100); const right = clamp(((endOff + 1) / daysInMonth) * 100); const width = Math.max(right - left, 2.5);
			const u = this._urg(r); const col = _U[u];
			const dlIn = dl && dl.slice(0, 7) === monthStartYMD.slice(0, 7);
			const dlLeft = dlIn ? clamp(((this._daysBetween(monthStartYMD, dl) + 0.5) / daysInMonth) * 100) : -1;
			return `<div class="isc-tl-row">
				<button class="isc-tl-bar" style="left:${left}%;width:${width}%;background:${col.bg};border-color:${col.c};color:${col.c}" title="${this._esc(r.Name || '')} · ${col.label} · ${s}${dl ? ' → due ' + dl : ''}" onclick="_Pict.providers.${P}.showDetail(${r.IDInspection})"><span class="isc-tl-bar-t">${this._esc(r.Name || ('Inspection ' + r.IDInspection))}</span></button>
				${dlLeft >= 0 ? `<span class="isc-tl-dl" style="left:${dlLeft}%;color:${col.c}" title="Deadline ${this._esc(dl)}"><i class="fas fa-flag"></i></span>` : ''}
			</div>`;
		};
		const lanesHTML = laneKeys.map((k) =>
		{
			const lane = lanes[k];
			return `<div class="isc-tl-lane">
				<div class="isc-tl-lanelabel"><i class="fas fa-${lane.idTeam ? 'users' : 'user-slash'} isc-tl-laneicon"></i><span class="isc-tl-lanename">${this._esc(lane.label)}</span><span class="isc-tl-lanen">${lane.items.length}</span>${lane.idTeam ? `<a class="isc-tl-laneopen" href="#/Team/Workspace/${lane.idTeam}/inspections" title="Open crew"><i class="fas fa-arrow-up-right-from-square"></i></a>` : ''}</div>
				<div class="isc-tl-track">${todayLeft >= 0 ? `<span class="isc-tl-today" style="left:${todayLeft}%"></span>` : ''}${lane.items.map((r) => bar(r)).join('')}</div>
			</div>`;
		}).join('');
		const unassigned = (lanes['unassigned'] || { items: [] }).items.length;
		return `<div class="isc-note"><i class="fas fa-users" style="color:var(--brand)"></i> Crews as lanes; each inspection a bar from scheduled start to its deadline (flag). Click a bar to reschedule or open.${unassigned ? ` <b>${unassigned}</b> of ${scheduled.length} scheduled ${unassigned === 1 ? 'inspection is' : 'inspections are'} not yet crewed — assign a team from an inspection's Teams tab.` : ''}</div>
			<div class="isc-tl">${axis}${lanesHTML}</div>${this._legendHTML()}`;
	}
}

const _STYLE = /*html*/`<style>
	.isc { --b:var(--theme-color-border-light,#e4e9ef); --b2:var(--theme-color-border-medium,#d5dbe3); --mut:var(--theme-color-text-muted,#8894a4); --ink:var(--theme-color-text-primary,#1f2733); --sec:var(--theme-color-text-secondary,#45505f); --brand:var(--theme-color-brand-primary,#2e7d74); --bg2:var(--theme-color-background-secondary,#f4f6f9); --card:var(--theme-color-background-primary,#fff); font-size:14px; color:var(--ink); }
	.isc-toolbar { display:flex; flex-wrap:wrap; align-items:center; gap:0.7rem 1rem; padding:0.1rem 0 0.9rem; }
	.isc-views, .isc-calviews, .isc-axis { display:inline-flex; border:1px solid var(--b2); border-radius:9px; overflow:hidden; }
	.isc-vbtn { border:none; background:var(--card); color:var(--sec); font-size:0.82rem; font-weight:700; padding:0.45rem 0.85rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.4rem; border-right:1px solid var(--b); }
	.isc-vbtn:last-child { border-right:none; } .isc-vbtn:hover { background:var(--bg2); } .isc-vbtn.on { background:var(--brand); color:#fff; }
	.isc-nav { display:inline-flex; align-items:center; gap:0.45rem; flex-wrap:wrap; }
	.isc-calviews button, .isc-axis button { border:none; background:var(--card); color:var(--sec); font-size:0.78rem; font-weight:700; padding:0.42rem 0.7rem; cursor:pointer; border-right:1px solid var(--b); } .isc-calviews button:last-child { border-right:none; } .isc-calviews button.on, .isc-axis button.on { background:var(--brand); color:#fff; }
	.isc-navbtn { border:1px solid var(--b2); background:var(--card); color:var(--sec); width:2rem; height:2rem; border-radius:8px; cursor:pointer; } .isc-navbtn:hover { background:var(--bg2); color:var(--brand); }
	.isc-today { border:1px solid var(--b2); background:var(--card); color:var(--sec); font-size:0.8rem; font-weight:700; padding:0 0.7rem; height:2rem; border-radius:8px; cursor:pointer; } .isc-today:hover { background:var(--bg2); color:var(--brand); }
	.isc-period { font-size:0.98rem; font-weight:800; margin:0 0.2rem; } .isc-spin { color:var(--brand); }
	.isc-filters { display:inline-flex; align-items:center; gap:0.5rem; margin-left:auto; }
	.isc-sel { font-size:0.82rem; padding:0.42rem 0.5rem; border:1px solid var(--b2); border-radius:8px; background:var(--theme-color-background-input,#fff); color:var(--ink); }
	.isc-newbtn { font-size:0.82rem; font-weight:600; padding:0.42rem 0.7rem; border-radius:8px; text-decoration:none; white-space:nowrap; color:#fff; background:var(--theme-color-brand-primary,#2e7d74); border:1px solid var(--theme-color-brand-primary,#2e7d74); }
	.isc-newbtn:hover { filter:brightness(1.07); color:#fff; }
	.isc-newbtn i { font-size:0.75rem; margin-right:0.25rem; }
	.isc-empty { padding:2.5rem; text-align:center; color:var(--mut); font-size:0.9rem; border:1px dashed var(--b2); border-radius:12px; } .isc-error { color:#b23b32; border-color:#e7b3ad; background:#fdf1f0; } .isc-empty-sm { color:var(--mut); font-size:0.85rem; padding:1rem; text-align:center; }
	.isc-note { font-size:0.8rem; color:var(--mut); margin:0.8rem 0 0; display:flex; align-items:center; gap:0.4rem; }
	/* KPI tiles */
	.isc-kpis { display:grid; grid-template-columns:repeat(auto-fit,minmax(8.5rem,1fr)); gap:0.7rem; margin:0 0 0.9rem; }
	.isc-kpi { text-align:left; background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.75rem 0.9rem; cursor:pointer; border-top:3px solid var(--b2); transition:box-shadow .12s; } .isc-kpi:hover { box-shadow:0 2px 12px rgba(0,0,0,0.08); }
	.isc-kpi-v { font-size:1.55rem; font-weight:800; line-height:1; } .isc-kpi-l { font-size:0.68rem; color:var(--mut); margin-top:0.35rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:700; }
	.isc-kpi.u-overdue { border-top-color:#c0392b; } .isc-kpi.u-overdue .isc-kpi-v { color:#c0392b; }
	.isc-kpi.u-due30 { border-top-color:#d9772b; } .isc-kpi.u-due30 .isc-kpi-v { color:#d9772b; }
	.isc-kpi.u-due90 { border-top-color:#bf9b26; } .isc-kpi.u-unscheduled { border-top-color:#6a7480; }
	.isc-kpi.u-inprogress { border-top-color:#6b62b0; } .isc-kpi.u-completed { border-top-color:#3f9e6a; }
	/* compliance */
	.isc-compliance { background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.85rem 1rem; margin:0 0 0.9rem; }
	.isc-comp-h { font-size:0.9rem; font-weight:800; display:flex; align-items:center; gap:0.6rem; } .isc-comp-pct { font-size:1.4rem; color:#3f9e6a; } .isc-comp-pct.bad { color:#c0392b; }
	.isc-comp-bar { height:9px; background:var(--bg2); border-radius:5px; overflow:hidden; margin:0.5rem 0 0.4rem; } .isc-comp-bar span { display:block; height:100%; background:linear-gradient(90deg,#3f9e6a,#57ad7d); border-radius:5px; }
	.isc-comp-sub { font-size:0.8rem; color:var(--mut); }
	/* cards + columns */
	.isc-cols { display:grid; grid-template-columns:1.4fr 1fr; gap:0.9rem; margin:0 0 0.9rem; } @media (max-width:960px){ .isc-cols { grid-template-columns:1fr; } }
	.isc-card { background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.9rem 1rem; } .isc-card-h { font-size:0.8rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--sec); margin:0 0 0.75rem; display:flex; align-items:center; gap:0.45rem; } .isc-card-h i { color:var(--brand); } .isc-cardlink { margin-left:auto; font-size:0.72rem; font-weight:700; color:var(--brand); background:none; border:none; cursor:pointer; text-transform:none; letter-spacing:0; text-decoration:none; } .isc-cardlink:hover { text-decoration:underline; } .isc-cardsub { font-size:0.7rem; font-weight:600; color:var(--mut); text-transform:none; letter-spacing:0; }
	/* workload chart */
	.isc-workload { display:flex; gap:1rem; align-items:stretch; } @media (max-width:600px){ .isc-workload { flex-direction:column; } }
	.isc-chart { flex:1; display:flex; align-items:flex-end; gap:0.35rem; height:11rem; padding-top:0.5rem; }
	.isc-bar { flex:1; display:flex; flex-direction:column; align-items:center; justify-content:flex-end; gap:0.25rem; height:100%; border:none; background:none; cursor:pointer; } .isc-bar:hover .isc-bar-col { filter:brightness(1.06); outline:1px solid var(--b2); }
	.isc-bar-n { font-size:0.66rem; font-weight:800; color:var(--sec); height:0.9rem; } .isc-bar-col { width:100%; max-width:2.2rem; min-height:2px; border-radius:4px 4px 0 0; overflow:hidden; display:flex; flex-direction:column-reverse; } .isc-seg { display:block; } .isc-bar-x { font-size:0.62rem; color:var(--mut); font-weight:700; }
	.isc-backlog { display:flex; flex-direction:column; gap:0.6rem; justify-content:center; min-width:8.5rem; }
	.isc-back { text-align:left; border:1px solid var(--b); border-left:4px solid var(--b2); border-radius:9px; padding:0.5rem 0.7rem; cursor:pointer; background:var(--card); } .isc-back:hover { background:var(--bg2); }
	.isc-back.u-overdue { border-left-color:#c0392b; } .isc-back.u-overdue .isc-back-v { color:#c0392b; } .isc-back.u-unscheduled { border-left-color:#6a7480; }
	.isc-back-v { font-size:1.4rem; font-weight:800; line-height:1; } .isc-back-l { font-size:0.66rem; color:var(--mut); font-weight:700; text-transform:uppercase; letter-spacing:0.02em; margin-top:0.2rem; }
	/* pipeline */
	.isc-pipeline { display:flex; flex-direction:column; gap:0.5rem; }
	.isc-pipe { display:flex; align-items:center; gap:0.6rem; border:none; background:none; cursor:pointer; padding:0.1rem 0; width:100%; } .isc-pipe:hover .isc-pipe-l { color:var(--ink); }
	.isc-pipe-l { font-size:0.78rem; color:var(--sec); font-weight:600; width:8.5rem; flex:0 0 auto; display:flex; align-items:center; gap:0.4rem; text-align:left; } .isc-pipe-track { flex:1; height:0.7rem; background:var(--bg2); border-radius:5px; overflow:hidden; } .isc-pipe-fill { display:block; height:100%; border-radius:5px; } .isc-pipe-v { font-size:0.82rem; font-weight:800; width:2.8rem; text-align:right; }
	.isc-dot { width:0.6rem; height:0.6rem; border-radius:50%; display:inline-block; flex:0 0 auto; }
	/* type breakdown */
	.isc-tbtable { width:100%; border-collapse:collapse; font-size:0.85rem; } .isc-tbtable th { text-align:left; font-size:0.64rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--mut); font-weight:800; padding:0 0.4rem 0.4rem; } .isc-tbtable td { padding:0.4rem; border-top:1px solid var(--b); cursor:pointer; } .isc-tbtable tr:hover td { background:var(--bg2); }
	.isc-tb-name { font-weight:600; } .isc-tb-bar { width:45%; } .isc-tbbar { display:flex; height:0.6rem; border-radius:4px; overflow:hidden; background:var(--bg2); } .isc-tbbar span { display:block; } .isc-tb-n { text-align:right; font-weight:700; } .isc-tb-o { text-align:right; color:var(--mut); } .isc-tb-o.bad { color:#c0392b; font-weight:800; }
	/* needs attention */
	.isc-nalist { display:flex; flex-direction:column; }
	.isc-na { display:flex; align-items:center; gap:0.55rem; padding:0.5rem 0.1rem; border-top:1px solid var(--b); } .isc-na:first-child { border-top:none; }
	.isc-na-main { flex:1; min-width:0; } .isc-na-name { font-weight:600; font-size:0.86rem; cursor:pointer; display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; } .isc-na-name:hover { color:var(--brand); } .isc-na-meta { font-size:0.74rem; color:var(--mut); } .isc-unsched { color:#6a7480; font-weight:700; background:#eceff2; border-radius:4px; padding:0 0.3rem; font-size:0.68rem; }
	.isc-na-btn { border:1px solid var(--b2); background:var(--card); color:var(--brand); font-size:0.74rem; font-weight:700; border-radius:7px; padding:0.3rem 0.6rem; cursor:pointer; white-space:nowrap; } .isc-na-btn:hover { background:var(--brand); color:#fff; }
	/* legend */
	.isc-legend { display:flex; flex-wrap:wrap; gap:0.4rem 1rem; margin-top:0.6rem; padding-top:0.6rem; } .isc-leg { font-size:0.72rem; color:var(--sec); display:inline-flex; align-items:center; gap:0.35rem; }
	/* worklist */
	.isc-chipbar { display:flex; flex-wrap:wrap; align-items:center; gap:0.4rem; margin:0 0 0.7rem; } .isc-chipf { border:1px solid var(--b2); background:var(--card); color:var(--sec); font-size:0.76rem; font-weight:700; border-radius:999px; padding:0.28rem 0.7rem; cursor:pointer; } .isc-chipf:hover { background:var(--bg2); } .isc-chipf.on { background:var(--brand); color:#fff; border-color:var(--brand); } .isc-chipf.on.u-overdue { background:#c0392b; border-color:#c0392b; } .isc-chipf.on.u-due30 { background:#d9772b; border-color:#d9772b; } .isc-count { margin-left:auto; font-size:0.76rem; color:var(--mut); }
	.isc-ltable { width:100%; border-collapse:collapse; font-size:0.86rem; } .isc-ltable th { text-align:left; font-size:0.64rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--sec); font-weight:800; border-bottom:1px solid var(--b); padding:0.45rem 0.5rem; white-space:nowrap; } .isc-sortable { cursor:pointer; } .isc-sortable:hover { color:var(--brand); }
	.isc-ltable td { padding:0.5rem; border-bottom:1px solid var(--b); vertical-align:middle; } .isc-ltable tr:hover td { background:var(--bg2); }
	.isc-l-name { font-weight:600; cursor:pointer; } .isc-l-name:hover { color:var(--brand); } .isc-atype { font-size:0.72rem; font-weight:600; color:var(--sec); background:var(--bg2); border-radius:5px; padding:0.08rem 0.45rem; } .isc-nowrap { white-space:nowrap; color:var(--sec); } .isc-mut { color:var(--mut); } .isc-days { font-weight:700; color:var(--sec); } .isc-days.over { color:#c0392b; }
	.isc-astatus { font-size:0.7rem; font-weight:700; color:var(--c); background:var(--bg); border-radius:999px; padding:0.12rem 0.55rem; white-space:nowrap; } .isc-l-act { white-space:nowrap; text-align:right; } .isc-act { border:none; background:transparent; color:var(--mut); cursor:pointer; padding:0.25rem 0.4rem; border-radius:6px; } .isc-act:hover { color:var(--brand); background:var(--bg2); }
	/* calendar (reused) */
	.isc-year { display:grid; grid-template-columns:repeat(4,1fr); gap:0.8rem; } @media (max-width:900px){ .isc-year { grid-template-columns:repeat(2,1fr);} }
	.isc-ycell { text-align:left; background:var(--card); border:1px solid var(--b); border-radius:12px; padding:0.85rem 0.95rem; cursor:pointer; } .isc-ycell:hover { border-color:var(--brand); box-shadow:0 2px 10px rgba(46,125,116,0.12); }
	.isc-ycell-h { display:flex; align-items:baseline; justify-content:space-between; } .isc-ycell-m { font-size:0.95rem; font-weight:800; } .isc-ycell-n { font-size:1.35rem; font-weight:800; color:var(--brand); }
	.isc-ybar { display:flex; height:8px; border-radius:5px; overflow:hidden; margin-top:0.7rem; gap:2px; } .isc-ybar-empty { background:var(--bg2); } .isc-ybar span { display:block; border-radius:3px; }
	.isc-mhead { display:grid; grid-template-columns:repeat(7,1fr); gap:1px; padding:0 0 0.4rem; } .isc-mhead div { font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--sec); padding-left:0.2rem; }
	.isc-grid { display:grid; grid-template-columns:repeat(7,1fr); grid-auto-rows:minmax(6.2rem,auto); gap:1px; background:var(--b); border:1px solid var(--b); border-radius:10px; overflow:hidden; }
	.isc-cell { background:var(--card); padding:0.3rem 0.35rem; min-height:6.2rem; display:flex; flex-direction:column; gap:0.2rem; } .isc-out { background:var(--bg2); } .isc-out .isc-cell-d { color:var(--mut); }
	.isc-cell-d { font-size:0.78rem; font-weight:700; color:var(--sec); display:flex; align-items:center; gap:0.25rem; } .isc-today-c { outline:2px solid var(--brand); outline-offset:-2px; } .isc-todaydot { width:0.4rem; height:0.4rem; border-radius:50%; background:var(--brand); display:inline-block; } .isc-cell-items { display:flex; flex-direction:column; gap:2px; }
	.isc-chip { display:flex; align-items:center; gap:0.3rem; width:100%; text-align:left; border:none; background:var(--bg); color:var(--c); border-left:3px solid var(--c); border-radius:4px; padding:0.12rem 0.35rem; font-size:0.72rem; font-weight:600; cursor:pointer; overflow:hidden; } .isc-chip:hover { filter:brightness(0.97); } .isc-chip-dot { width:0.42rem; height:0.42rem; border-radius:50%; flex:0 0 auto; } .isc-chip-t { white-space:nowrap; overflow:hidden; text-overflow:ellipsis; } .isc-more { color:var(--mut); font-size:0.7rem; font-weight:700; padding:0.05rem 0.35rem; }
	.isc-week { display:grid; grid-template-columns:repeat(7,1fr); gap:1px; background:var(--b); border:1px solid var(--b); border-radius:10px; overflow:hidden; } .isc-wcol { background:var(--card); min-height:20rem; display:flex; flex-direction:column; } .isc-wcol-h { padding:0.5rem 0.6rem; border-bottom:1px solid var(--b); display:flex; align-items:center; justify-content:space-between; } .isc-wcol-wd { font-size:0.66rem; font-weight:800; text-transform:uppercase; color:var(--sec); } .isc-wcol-n { font-size:0.95rem; font-weight:800; } .isc-wcol-n.on { color:#fff; background:var(--brand); border-radius:50%; width:1.6rem; height:1.6rem; display:inline-flex; align-items:center; justify-content:center; } .isc-wcol-items { padding:0.4rem; display:flex; flex-direction:column; gap:0.3rem; } .isc-wcol-empty { color:var(--mut); text-align:center; padding:0.6rem 0; }
	/* timeline (team swimlanes) */
	.isc-tl { border:1px solid var(--b); border-radius:10px; overflow:hidden; }
	.isc-tl-axis { display:grid; grid-template-columns:11rem 1fr; border-bottom:1px solid var(--b); background:var(--bg2); } .isc-tl-axis-l { border-right:1px solid var(--b); } .isc-tl-axis-t { position:relative; height:1.5rem; } .isc-tl-tick { position:absolute; top:0.35rem; font-size:0.62rem; color:var(--mut); font-weight:700; padding-left:3px; white-space:nowrap; border-left:1px solid var(--b); height:1.15rem; }
	.isc-tl-lane { display:grid; grid-template-columns:11rem 1fr; border-top:1px solid var(--b); } .isc-tl-lane:first-of-type { border-top:none; }
	.isc-tl-lanelabel { display:flex; align-items:center; gap:0.4rem; padding:0.5rem 0.6rem; border-right:1px solid var(--b); background:var(--bg2); font-size:0.8rem; font-weight:700; color:var(--sec); } .isc-tl-laneicon { color:var(--mut); } .isc-tl-lanename { flex:1; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; } .isc-tl-lanen { font-size:0.7rem; color:var(--mut); background:var(--card); border:1px solid var(--b); border-radius:999px; padding:0 0.4rem; } .isc-tl-laneopen { color:var(--brand); }
	.isc-tl-track { position:relative; padding:0.35rem 0; min-height:2.4rem; } .isc-tl-row { position:relative; height:1.5rem; margin:0.15rem 0; }
	.isc-tl-bar { position:absolute; top:0; height:1.5rem; border:1px solid; border-left-width:3px; border-radius:5px; padding:0 0.4rem; font-size:0.72rem; font-weight:700; display:flex; align-items:center; cursor:pointer; overflow:hidden; box-sizing:border-box; } .isc-tl-bar:hover { filter:brightness(0.96); } .isc-tl-bar-t { white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
	.isc-tl-dl { position:absolute; top:0.05rem; font-size:0.72rem; transform:translateX(-50%); pointer-events:none; } .isc-tl-today { position:absolute; top:0; bottom:0; width:2px; background:var(--brand); opacity:0.5; pointer-events:none; }
	/* modal */
	.isc-modal-open { margin-left:0.6rem; color:var(--brand); font-weight:700; text-decoration:none; } .isc-modal-open:hover { text-decoration:underline; }
	.isc-modalbg { position:fixed; inset:0; background:rgba(20,28,38,0.42); display:flex; align-items:center; justify-content:center; z-index:9000; } .isc-modal { background:var(--card); border-radius:14px; padding:1.2rem 1.3rem; width:min(24rem,92vw); box-shadow:0 12px 40px rgba(0,0,0,0.25); }
	.isc-modal-h { font-size:1rem; font-weight:800; display:flex; align-items:center; gap:0.5rem; } .isc-modal-h i { color:var(--brand); } .isc-modal-name { font-size:0.86rem; color:var(--sec); margin:0.4rem 0 0.9rem; } .isc-modal-f { display:flex; flex-direction:column; gap:0.3rem; font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--sec); } .isc-modal-f input { font-size:0.95rem; padding:0.5rem; border:1px solid var(--b2); border-radius:8px; } .isc-modal-dl { font-size:0.8rem; color:var(--mut); margin:0.6rem 0 1rem; } .isc-modal-act { display:flex; justify-content:flex-end; gap:0.5rem; }
	.isc-btn { border:none; background:var(--brand); color:#fff; font-size:0.84rem; font-weight:700; border-radius:8px; padding:0.5rem 0.95rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; text-decoration:none; } .isc-btn:hover { filter:brightness(1.05); } .isc-btn.ghost { background:transparent; color:var(--sec); border:1px solid var(--b2); }
	.isc-monthpick { font-size:0.8rem; padding:0.32rem 0.4rem; border:1px solid var(--b2); border-radius:8px; background:var(--theme-color-background-input,#fff); color:var(--ink); }
	/* detail popover */
	.isc-dt { width:min(30rem,94vw); } .isc-dt-head { display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap; } .isc-dt-crew { font-size:0.74rem; font-weight:700; color:var(--brand); display:inline-flex; align-items:center; gap:0.3rem; } .isc-dt-crew.isc-mut { color:var(--mut); } .isc-dt-x { margin-left:auto; border:none; background:transparent; color:var(--mut); cursor:pointer; font-size:1rem; border-radius:6px; padding:0.2rem 0.4rem; } .isc-dt-x:hover { color:var(--ink); background:var(--bg2); }
	.isc-dt-name { font-size:1.05rem; font-weight:800; margin:0.5rem 0 0.9rem; }
	.isc-dt-grid { display:grid; grid-template-columns:1fr 1fr; gap:0.7rem 1rem; margin:0 0 1rem; } .isc-dt-f { min-width:0; } .isc-dt-l { font-size:0.62rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--sec); margin-bottom:0.15rem; } .isc-dt-v { font-size:0.88rem; color:var(--ink); } .isc-dt-chip { font-size:0.76rem; font-weight:600; color:var(--sec); background:var(--bg2); border-radius:5px; padding:0.08rem 0.45rem; display:inline-block; margin:0.1rem 0.1rem 0 0; }
	.isc-status { font-size:0.72rem; font-weight:800; letter-spacing:0.02em; border-radius:999px; padding:0.15rem 0.6rem; text-transform:uppercase; } .isc-status.is-scheduled { color:#1e5fa8; background:#e4f0fb; } .isc-status.is-progress { color:#8a5a00; background:#fdf0d8; } .isc-status.is-complete { color:#1f7a44; background:#e2f5ea; } .isc-status.is-other { color:#45505f; background:#eef1f6; } .isc-typepill { font-size:0.72rem; font-weight:700; color:var(--sec); background:var(--bg2); border-radius:999px; padding:0.15rem 0.6rem; }
</style>`;

module.exports = InspectionScheduleProvider;
module.exports.default_configuration = { ProviderIdentifier: 'InspectionSchedule' };

},{"../documents/DocumentThroughput-Configs.js":1272,"pict-provider":845}],1285:[function(require,module,exports){
// Service/application version inventory + version-fetch engine — ported from the standalone `web/internals`
// app so its two screens (Service Versions, Versions Across Environments) can live as Headlight-only views in
// this config app. Only adaptation from the original: `currentEnvironmentKey` reads the browser host (this
// app's REST client base is relative). Fetches the public `/Version` + `/1.0/ServiceVersion/<hash>` endpoints
// cross-subdomain via `fetch` — a version that a CORS/host denies simply shows as unknown ('???').
const libPictProvider = require('pict-provider');

const MONOREPO_URL = 'https://github.com/paviasystems/headlight';
const SERVICE_VERSION_ROUTE_PREFIX = '/1.0/ServiceVersion';
// Reported by a service whose version file could not be read; never a real version.
const UNKNOWN_VERSION = '--';
// A hung host would otherwise hold the whole versions view until the gateway's 60s connect timeout.
const VERSION_FETCH_TIMEOUT_MS = 5000;

// -------------------------------------------------------------------------------------------------
// TEMPORARY: paths these services answered on before the ServiceVersion namespace existed, for
// environments not yet deployed with it. Applications need no equivalent — they serve /Version at the
// same URL in both paradigms.
//
// To remove once staging and production are cut over: delete this map, `fetchLegacyVersion`, and the
// one call to it in `fetchVersionForService`.
// -------------------------------------------------------------------------------------------------
const LEGACY_VERSION_PATHS =
{
	FinancialService: '/1.0/Finance/Version',
	MaterialsService: '/1.0/LIMS/Version',
	PermissionService: '/1.0/Permissions/Version',
	PDFRasterizationService: '/1.0/Rasterize/Version',
	UserManagementService: '/1.0/UM/Version',
};

/**
 * How a version is fetched: back-end services answer on a shared path, applications on their own subdomain.
 *
 * @typedef {'Application' | 'Micro-Service'} ServiceType
 */

/**
 * How an entry is grouped for display, mirroring the Rancher stacks plus the legacy application set.
 *
 * @typedef {'Service' | 'Application' | 'Legacy' | 'MissionControl' | 'Ultravisor'} ServiceGroupKey
 */

/**
 * @typedef {Object} ServiceCatalogEntry
 * @property {string} Name - what we call the service or application.
 * @property {ServiceType} Type
 * @property {ServiceGroupKey} Group
 * @property {string} [ServiceHash] - Micro-Service only; the hash the service publishes its version under, matching its fable `Product`.
 * @property {string} [ApplicationSubdomain] - Application only; the subdomain the application is served from.
 * @property {string} [VersionHost] - Micro-Service only; the subdomain that answers its ServiceVersion route, when not `api`.
 * @property {string} [RepoBaseURL] - defaults to the monorepo.
 */

/**
 * @typedef {Object} EnvironmentInfo
 * @property {string} Key - subdomain segment used to build URLs; empty for production.
 * @property {string} Label
 */

/**
 * @typedef {Object} ServiceGroupInfo
 * @property {ServiceGroupKey} Key
 * @property {string} Label
 */

/**
 * The single inventory of what the internals application reports versions for.
 *
 * Back-end services publish under `/1.0/ServiceVersion/<ServiceHash>` on the shared API host (the
 * Ultravisor stack on its own hub host, which answers for every connected beacon), since
 * they have no DNS of their own; applications serve `/Version` from their own subdomain.
 */
class ServiceCatalog extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../Application-Web.js').INTERNALSPict} */
		this.pict;

		/** @type {EnvironmentInfo[]} */
		this.environments =
		[
			{ Key: 'qa', Label: 'QA' },
			{ Key: 'stg', Label: 'STG' },
			{ Key: '', Label: 'PROD' },
		];

		/** @type {ServiceGroupInfo[]} */
		this.groups =
		[
			{ Key: 'Service', Label: 'Back-End Services' },
			{ Key: 'Application', Label: 'Applications' },
			{ Key: 'Legacy', Label: 'Legacy Applications' },
			{ Key: 'MissionControl', Label: 'Mission Control' },
			{ Key: 'Ultravisor', Label: 'Ultravisor Stack' },
		];

		/** @type {ServiceCatalogEntry[]} */
		this.services =
		[
			{ Name: 'API Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'HLServer' },
			{ Name: 'Approvals Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'ApprovalsService' },
			{ Name: 'Asset Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'AssetService' },
			{ Name: 'Authentication Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'HLAuth' },
			{ Name: 'Config Sync Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'ConfigSyncService' },
			{ Name: 'Configuration Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'ConfigService' },
			{ Name: 'Distilling Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'DistillingService' },
			{ Name: 'Document Packaging Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'FormPackaging' },
			{ Name: 'Email Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'EmailService' },
			{ Name: 'Entity Bundles Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'EntityBundlesService' },
			{ Name: 'Finance Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'FinancialService' },
			{ Name: 'Forms Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'FormsService' },
			{ Name: 'Materials Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'MaterialsService' },
			{ Name: 'Membership Sync Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'MembershipSync' },
			{ Name: 'Permissions Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'PermissionService' },
			{ Name: 'Platform Data Ops Service / Data App', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'PlatformDataOperations' },
			{ Name: 'Public Data Lake Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'PublicDataLakeAPI' },
			{ Name: 'Rasterization Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'PDFRasterizationService' },
			{ Name: 'Report Definitions', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'ReportDefinitions', RepoBaseURL: 'https://github.com/paviasystems/report_definitions' },
			{ Name: 'Report Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'ReportService' },
			{ Name: 'Sync Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'SyncService' },
			{ Name: 'User Mgmt Service', Group: 'Service', Type: 'Micro-Service', ServiceHash: 'UserManagementService' },

			{ Name: 'Data Service', Group: 'MissionControl', Type: 'Micro-Service', ServiceHash: 'MissionControlDataService' },
			{ Name: 'Image Metadata Parser', Group: 'MissionControl', Type: 'Micro-Service', ServiceHash: 'HeadLight-MissionControl-ImageMetadataParser' },
			{ Name: 'Job Pusher', Group: 'MissionControl', Type: 'Micro-Service', ServiceHash: 'HeadLight-MissionControl-JobPusher' },
			{ Name: 'Librarian', Group: 'MissionControl', Type: 'Micro-Service', ServiceHash: 'HeadLight-MissionControl-Librarian' },

			// ServiceHash is each image's `product-name` in .github/workflows/services_headlight-*.yaml.
			{ Name: 'Ultravisor Hub', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'UltravisorAuthBeacon' },
			{ Name: 'Comprehension Loader Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'ComprehensionLoaderBeacon' },
			{ Name: 'MCP Data Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'MCPDataBeacon' },
			{ Name: 'Meadow (API) Data Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'MeadowDatabeacon' },
			{ Name: 'MySQL Data Beacons', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'MySQLDatabeacon' },
			{ Name: 'Notification Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'NotificationBeacon' },
			{ Name: 'Postgres (Private Lake) Data Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'PostgresDatabeacon' },
			{ Name: 'Private Lake Ingest Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'PrivateLakeIngestBeacon' },
			{ Name: 'Projection Refresh Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'ProjectionRefreshBeacon' },
			{ Name: 'Type Seeding Beacon', Group: 'Ultravisor', Type: 'Micro-Service', VersionHost: 'ultravisor', ServiceHash: 'TypeSeedingBeacon' },

			{ Name: 'Asset Management (v2)', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'assets2' },
			{ Name: 'Assets', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'assets' },
			{ Name: 'Bridge Inspection', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'bridge' },
			{ Name: 'Bundles Explorer', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'bundles' },
			{ Name: 'Contract Admin', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'contractadmin' },
			{ Name: 'Dashboards', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'dashboards' },
			{ Name: 'Documentation', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'docs' },
			{ Name: 'Form Editor', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'forms' },
			{ Name: 'Home', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'home' },
			{ Name: 'Internals', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'internals' },
			{ Name: 'LIMS', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'lims' },
			{ Name: 'Links', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'links' },
			{ Name: 'Materials Sample Tracking', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'materials', RepoBaseURL: 'https://github.com/paviasystems/materials-sampletracking' },
			{ Name: 'Payment Data', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'paymentdata' },
			{ Name: 'Platform Configuration', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'config' },
			{ Name: 'Profile', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'profile' },
			{ Name: 'Sample Plan', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'sampleplan' },
			{ Name: 'Smart Forms', Group: 'Application', Type: 'Application', ApplicationSubdomain: 'smartforms' },

			{ Name: 'Contracts', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'contracts' },
			{ Name: 'Customers', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'customers' },
			{ Name: 'Dashboard', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'dashboard' },
			{ Name: 'Fieldbook', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'fieldbook' },
			{ Name: 'Portal', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'portal' },
			{ Name: 'Projects', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'projects' },
			{ Name: 'Tracker', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'tracker' },
			{ Name: 'Vault', Group: 'Legacy', Type: 'Application', ApplicationSubdomain: 'vault' },
		];
	}

	/**
	 * The environment the application is currently pointed at.
	 *
	 * @return {string} The environment subdomain segment; empty string for production.
	 */
	get currentEnvironmentKey()
	{
		// The config app's REST client base is RELATIVE ('/1.0/') — unlike the standalone internals app whose
		// client points at the absolute API host — so it carries no environment segment. Detect the environment
		// from the browser host instead: config.<env>.headlight.com (prod = config.headlight.com; local → qa).
		const tmpSegments = String((typeof window !== 'undefined' && window.location && window.location.hostname) || '').split('.');
		switch (tmpSegments[1])
		{
			case 'headlight':
			case 'paviasystems':
				return '';
			case 'qa':
			case 'stg':
			case 'demo':
				return tmpSegments[1];
			default:
				return 'qa';
		}
	}

	/**
	 * The entries belonging to a display group, in catalog order.
	 *
	 * @param {ServiceGroupKey} pGroupKey - The group to select.
	 *
	 * @return {ServiceCatalogEntry[]} The matching entries.
	 */
	servicesInGroup(pGroupKey)
	{
		return this.services.filter((pService) => pService.Group === pGroupKey);
	}

	/**
	 * Build the absolute URL a service or application reports its version at.
	 *
	 * @param {ServiceCatalogEntry} pService - The catalog entry.
	 * @param {string} pEnvironmentKey - The environment subdomain segment; empty string for production.
	 *
	 * @return {string} The absolute URL, or an empty string when the entry is not fetchable.
	 */
	buildVersionURL(pService, pEnvironmentKey)
	{
		if (pService.Type === 'Application')
		{
			if (!pService.ApplicationSubdomain)
			{
				return '';
			}
			return `https://${pService.ApplicationSubdomain}.${pEnvironmentKey}.headlight.com/Version`.replace('..', '.');
		}
		if (!pService.ServiceHash)
		{
			return '';
		}
		return `https://${pService.VersionHost || 'api'}.${pEnvironmentKey}.headlight.com${SERVICE_VERSION_ROUTE_PREFIX}/${pService.ServiceHash}`.replace('..', '.');
	}

	/**
	 * Build the repository link for a version.
	 *
	 * @param {ServiceCatalogEntry} pService - The catalog entry.
	 * @param {string} pHashOrTag - The reported version.
	 *
	 * @return {string} The commit URL, or an empty string when there is nothing to link to.
	 */
	buildHeadCommitURL(pService, pHashOrTag)
	{
		if (!pService || !pHashOrTag || pHashOrTag === UNKNOWN_VERSION)
		{
			return '';
		}
		return `${pService.RepoBaseURL || MONOREPO_URL}/commits/${pHashOrTag}`;
	}

	/**
	 * Fetch a reported version.
	 *
	 * @param {string} pURL - The absolute version URL.
	 *
	 * @return {Promise<{version:string, packageVersion:string?}?>} The reported info, or null when unreadable.
	 */
	async fetchVersion(pURL)
	{
		if (!pURL)
		{
			return null;
		}
		try
		{
			const tmpResponse = await fetch(pURL, { signal: AbortSignal.timeout(VERSION_FETCH_TIMEOUT_MS) });
			if (!tmpResponse.ok)
			{
				this.pict.log.warn(`${tmpResponse.status} failed to fetch version from ${pURL}`);
				return null;
			}
			const tmpData = await tmpResponse.json();
			if (tmpData.version == null) { return null; }
			// Services report { version, packageVersion, serviceHash }; apps report just { version }. Keep the
			// deployed `version` (displayed + linked to the commit) plus `packageVersion` (the entry's own
			// package.json semver — services only; null for apps or a service reporting the '--' sentinel).
			return { version: tmpData.version, packageVersion: (tmpData.packageVersion != null) ? tmpData.packageVersion : null };
		}
		catch (pError)
		{
			this.pict.log.warn(`failed to fetch version from ${pURL}: ${pError.message}`, pError);
			return null;
		}
	}

	/**
	 * Whether a reported value is an actual version, as opposed to a service answering without one.
	 *
	 * @param {string?} pVersion - The reported version.
	 *
	 * @return {boolean} true if the value is a real version.
	 */
	isRealVersion(pVersion)
	{
		return !!pVersion && pVersion !== UNKNOWN_VERSION;
	}

	/**
	 * Fetch the version a service or application reports.
	 *
	 * @param {ServiceCatalogEntry} pService - The catalog entry.
	 * @param {string} pEnvironmentKey - The environment subdomain segment; empty string for production.
	 *
	 * @return {Promise<string?>} The reported version, or null when it could not be read.
	 */
	/**
	 * Fetch the full version info a service/app reports: { version, packageVersion }. `version` = deployed
	 * monorepo/release version; `packageVersion` = the entry's own package.json semver (services only).
	 * @param {ServiceCatalogEntry} pService @param {string} pEnvironmentKey
	 * @return {Promise<{version:string, packageVersion:string?}?>} The info, or null when nothing was read.
	 */
	async fetchVersionInfoForService(pService, pEnvironmentKey)
	{
		const tmpInfo = await this.fetchVersion(this.buildVersionURL(pService, pEnvironmentKey));
		if (tmpInfo !== null)
		{
			return tmpInfo;
		}
		return this.fetchLegacyVersion(pService, pEnvironmentKey);
	}

	async fetchVersionForService(pService, pEnvironmentKey)
	{
		const tmpInfo = await this.fetchVersionInfoForService(pService, pEnvironmentKey);
		return tmpInfo ? tmpInfo.version : null;
	}

	/**
	 * Fetch a version from the path a service answered on before the ServiceVersion namespace existed.
	 *
	 * Remove alongside `LEGACY_VERSION_PATHS`.
	 *
	 * @param {ServiceCatalogEntry} pService - The catalog entry.
	 * @param {string} pEnvironmentKey - The environment subdomain segment; empty string for production.
	 *
	 * @return {Promise<string?>} The reported version, or null when there is no legacy path or it could not be read.
	 */
	async fetchLegacyVersion(pService, pEnvironmentKey)
	{
		const tmpLegacyPath = (pService.Type === 'Micro-Service') ? LEGACY_VERSION_PATHS[pService.ServiceHash] : null;
		if (!tmpLegacyPath)
		{
			return null;
		}
		return this.fetchVersion(`https://api.${pEnvironmentKey}.headlight.com${tmpLegacyPath}`.replace('..', '.'));
	}
}

module.exports = ServiceCatalog;

module.exports.default_configuration = (
	{
		Name: 'InternalsServiceCatalog',
	});

},{"pict-provider":845}],1286:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * @typedef {import('../providers/ServiceCatalog.js').ServiceType} ServiceType
 */

/**
 * @typedef {Object} ServiceDisplayInfo
 * @property {string} Name - what we call the service or application
 * @property {string} PlatformVersion
 * @property {string} RepoLink
 * @property {ServiceType} Type
 */

class VersionsView extends libPictView
{
    constructor(pFable, pOptions, pServiceHash)
    {
        super(pFable, pOptions, pServiceHash);

        /** @type {import('../Application-Web').INTERNALSPict} */
        this.pict;

        this.reset();
    }

    /**
     * @return {import('../providers/ServiceCatalog.js')} The shared service inventory.
     */
    get serviceCatalog()
    {
        return this.pict.providers.InternalsServiceCatalog;
    }

    /**
     * @spec clears any data generated by this view. Useful for initialization and re-rendering
     */
    reset()
    {
        if (!this.AppData.Display)
        {
            this.AppData.Display = {};
        }
        this.AppData.Display.VersionGroups = [];
    }

    async buildModel()
    {
        const tmpEnvironmentKey = this.serviceCatalog.currentEnvironmentKey;
        const tmpInfos = await Promise.all(this.serviceCatalog.services.map(
            (pService) => this.serviceCatalog.fetchVersionInfoForService(pService, tmpEnvironmentKey)));
        const tmpInfoByService = new Map(this.serviceCatalog.services.map((pService, pIndex) => [ pService, tmpInfos[pIndex] ]));
        this.AppData.Display.VersionGroups = this.serviceCatalog.groups.map((pGroup) => (
            {
                Label: pGroup.Label,
                Services: this.serviceCatalog.servicesInGroup(pGroup.Key).map((pService) =>
                {
                    const tmpInfo = tmpInfoByService.get(pService);
                    const tmpVersion = (tmpInfo && tmpInfo.version) || '???';
                    // packageVersion is a services-only extra: apps omit it and a service that can't read its file
                    // reports '--' — show a badge only when there's a real, distinct package version.
                    const tmpPackageVersion = (tmpInfo && tmpInfo.packageVersion && tmpInfo.packageVersion !== '--') ? tmpInfo.packageVersion : '';
                    return {
                        Name: pService.Name,
                        Type: pService.Type,
                        PlatformVersion: tmpVersion,
                        PackageVersion: tmpPackageVersion,
                        RepoLink: this.serviceCatalog.buildHeadCommitURL(pService, tmpVersion),
                    };
                }),
            }));
    }

    async onBeforeRenderAsync(pCallback, pRenderable)
    {
        this.reset();
        await this.buildModel();
        super.onBeforeRenderAsync(pCallback, pRenderable);
    }
}

module.exports = VersionsView;
module.exports.default_configuration = (
    {
        ViewIdentifier: "ServiceVersions",
        DefaultRenderable: "ServiceVersions",
        DefaultDestinationAddress: "#PlatformConfiguration-Application-Container",

        AutoRender: true,

        CSS: /*css*/`
        .has-border-top-light {
            border-top: 1px dotted var(--bulma-border);
        }
        `,

        Templates: [
            {
                Hash: "VersionsView-Wrapper",
                Template: /*html*/`
                <section class="section">
                    <h1 class="title is-3 mb-1">Service Versions</h1>
                    <p class="subtitle is-6 has-text-text-50">The version each Headlight service and application currently reports in this environment. Click the branch icon to open the matching commit.</p>
                    <div class="columns is-multiline">
                        {~TS:VersionsView-Group:AppData.Display.VersionGroups~}
                    </div>
                </section>
                `
            },
            {
                Hash: "VersionsView-Group",
                Template: /*html*/`
                <div class="column is-6">
                    <section class="column card p-5">
                        <h2 class="title is-4 pb-4 mb-0 has-text-text-50">{~D:Record.Label~}</h2>
                        <div class="columns is-multiline">
                            {~TS:VersionsView-Service:Record.Services~}
                        </div>
                    </section>
                </div>
                `
            },
            {
                Hash: "VersionsView-Service",
                Template: /*html*/`
                <section class="column is-12 has-border-top-light">
                    <h2 class="title is-6">
                        {~D:Record.Name~}
                        <span class="pl-1 tag">{~D:Record.PlatformVersion~}</span>
                        {~TIfAbs:VersionsView-Service-PkgBadge:Record:Record.PackageVersion^>^0~}
                        {~TIfAbs:VersionsView-Service-RepoLink:Record:Record.RepoLink^>^0~}
                    </h2>
                </section>
                `
            },
            {
                Hash: "VersionsView-Service-PkgBadge",
                Template: /*html*/`
                <span class="pl-1 tag is-light" title="Service package version (package.json)">pkg {~D:Record.PackageVersion~}</span>
                `
            },
            {
                Hash: "VersionsView-Service-RepoLink",
                Template: /*html*/`
                <a href="{~D:Record.RepoLink~}" target="_blank" title="Click to see the code of this version">
                    <i class="fa-regular fa-code-branch"></i>
                </a>
                `
            },
        ],
        Renderables: [
            {
                RenderableHash: "ServiceVersions",
                TemplateHash: "VersionsView-Wrapper",
                RenderMethod: 'replace'
            }]
    });

},{"pict-view":1053}],1287:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * @typedef {import('../providers/ServiceCatalog.js').ServiceType} ServiceType
 */

/**
 * @typedef {Object} CellDisplayInfo
 * @property {string} EnvLabel
 * @property {string} EnvKey
 * @property {string} Version
 * @property {string} RepoLink
 * @property {boolean} HasVersion
 */

/**
 * @typedef {Object} RowDisplayInfo
 * @property {string} Name
 * @property {ServiceType} Type
 * @property {CellDisplayInfo[]} Cells
 * @property {boolean} HasDrift
 * @property {string} DriftMarker
 */

class MultiEnvVersionsView extends libPictView
{
    constructor(pFable, pOptions, pServiceHash)
    {
        super(pFable, pOptions, pServiceHash);

        /** @type {import('../Application-Web').INTERNALSPict} */
        this.pict;

        this.reset();
    }

    /**
     * @return {import('../providers/ServiceCatalog.js')} The shared service inventory.
     */
    get serviceCatalog()
    {
        return this.pict.providers.InternalsServiceCatalog;
    }

    reset()
    {
        if (!this.AppData.Display)
        {
            this.AppData.Display = {};
        }
        /** @type {RowDisplayInfo[]} */
        this.AppData.Display.MultiEnvGroups = [];
        this.AppData.Display.MultiEnvHeaders = this.serviceCatalog.environments.map((pEnvironment) => ({ Label: pEnvironment.Label, Key: pEnvironment.Key }));
        this.AppData.Display.MultiEnvColumnSpan = this.serviceCatalog.environments.length + 1;
    }

    /**
     * Fetch every environment for one catalog entry and shape it into a display row.
     *
     * @param {any} pService - The catalog entry.
     *
     * @return {Promise<RowDisplayInfo>} The row.
     */
    async buildRow(pService)
    {
        const tmpEnvironments = this.serviceCatalog.environments;
        const tmpVersions = await Promise.all(tmpEnvironments.map(
            (pEnvironment) => this.serviceCatalog.fetchVersionForService(pService, pEnvironment.Key)));
        const tmpCells = tmpEnvironments.map((pEnvironment, pIndex) => (
            {
                EnvLabel: pEnvironment.Label,
                EnvKey: pEnvironment.Key,
                Version: tmpVersions[pIndex] || '???',
                RepoLink: this.serviceCatalog.buildHeadCommitURL(pService, tmpVersions[pIndex]),
                HasVersion: this.serviceCatalog.isRealVersion(tmpVersions[pIndex]),
            }));
        const tmpHasDrift = new Set(tmpVersions.filter((pVersion) => this.serviceCatalog.isRealVersion(pVersion))).size > 1;
        return (
            {
                Name: pService.Name,
                Type: pService.Type,
                Cells: tmpCells,
                HasDrift: tmpHasDrift,
                DriftMarker: tmpHasDrift ? 'drift' : '',
            });
    }

    async buildModel()
    {
        const tmpRows = await Promise.all(this.serviceCatalog.services.map((pService) => this.buildRow(pService)));
        const tmpRowByService = new Map(this.serviceCatalog.services.map((pService, pIndex) => [ pService, tmpRows[pIndex] ]));
        this.AppData.Display.MultiEnvGroups = this.serviceCatalog.groups.map((pGroup) => (
            {
                Label: pGroup.Label,
                ColumnSpan: this.AppData.Display.MultiEnvColumnSpan,
                Rows: this.serviceCatalog.servicesInGroup(pGroup.Key).map((pService) => tmpRowByService.get(pService)),
            }));
    }

    async onBeforeRenderAsync(pCallback, pRenderable)
    {
        this.reset();
        await this.buildModel();
        super.onBeforeRenderAsync(pCallback, pRenderable);
    }
}

module.exports = MultiEnvVersionsView;
module.exports.default_configuration = (
    {
        ViewIdentifier: "ServiceVersionsMultiEnv",
        DefaultRenderable: "ServiceVersionsMultiEnv",
        DefaultDestinationAddress: "#PlatformConfiguration-Application-Container",

        AutoRender: true,

        CSS: /*css*/`
        .multi-env-versions-table {
            width: 100%;
            border-collapse: collapse;
        }
        .multi-env-versions-table th,
        .multi-env-versions-table td {
            padding: 0.5rem 0.75rem;
            border-bottom: 1px dotted var(--bulma-border);
            vertical-align: middle;
        }
        .multi-env-versions-table th {
            text-align: left;
            background-color: var(--bulma-background);
        }
        .multi-env-versions-table tr.has-version-drift {
            background-color: var(--bulma-warning-soft, rgba(255, 224, 138, 0.35));
        }
        .multi-env-versions-table tr.has-version-drift td:first-child {
            border-left: 3px solid var(--bulma-warning, #ffd57d);
        }
        .multi-env-versions-table .product-name {
            font-weight: 600;
        }
        .multi-env-versions-table tr.group-heading th {
            padding-top: 1.25rem;
            font-size: 0.8rem;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            color: var(--bulma-text-50);
            background-color: transparent;
        }
        .multi-env-versions-table .env-label {
            text-transform: uppercase;
            font-size: 0.85rem;
            letter-spacing: 0.04em;
        }
        `,

        Templates: [
            {
                Hash: "MultiEnvVersionsView-Wrapper",
                Template: /*html*/`
                <section id="MultiEnvVersionsView" class="card p-5">
                    <h2 class="title is-4 pb-4 mb-0 has-text-text-50">Versions Across Environments</h2>
                    <p class="pb-3">Highlighted rows have version drift across environments.</p>
                    <table class="multi-env-versions-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                {~TS:MultiEnvVersionsView-Header:AppData.Display.MultiEnvHeaders~}
                            </tr>
                        </thead>
                        {~TS:MultiEnvVersionsView-Group:AppData.Display.MultiEnvGroups~}
                    </table>
                </section>
                `
            },
            {
                Hash: "MultiEnvVersionsView-Group",
                Template: /*html*/`
                <tbody>
                    <tr class="group-heading">
                        <th colspan="{~D:Record.ColumnSpan~}">{~D:Record.Label~}</th>
                    </tr>
                    {~TS:MultiEnvVersionsView-Row:Record.Rows~}
                </tbody>
                `
            },
            {
                Hash: "MultiEnvVersionsView-Header",
                Template: /*html*/`
                <th class="env-label">{~D:Record.Label~}</th>
                `
            },
            {
                Hash: "MultiEnvVersionsView-Row",
                Template: /*html*/`
                <tr class="{~TIfAbs:MultiEnvVersionsView-DriftClass:Record:Record.DriftMarker^>^0~}">
                    <td class="product-name">{~D:Record.Name~}</td>
                    {~TS:MultiEnvVersionsView-Cell:Record.Cells~}
                </tr>
                `
            },
            {
                Hash: "MultiEnvVersionsView-DriftClass",
                Template: /*html*/`has-version-drift`
            },
            {
                Hash: "MultiEnvVersionsView-Cell",
                Template: /*html*/`
                <td>
                    <span class="tag">{~D:Record.Version~}</span>
                    {~TIfAbs:MultiEnvVersionsView-Cell-RepoLink:Record:Record.RepoLink^>^0~}
                </td>
                `
            },
            {
                Hash: "MultiEnvVersionsView-Cell-RepoLink",
                Template: /*html*/`
                <a href="{~D:Record.RepoLink~}" target="_blank" title="Click to see the code of this version" class="ml-1">
                    <i class="fa-regular fa-code-branch"></i>
                </a>
                `
            },
        ],
        Renderables: [
            {
                RenderableHash: "ServiceVersionsMultiEnv",
                TemplateHash: "MultiEnvVersionsView-Wrapper",
                RenderMethod: 'replace'
            }]
    });

},{"pict-view":1053}],1288:[function(require,module,exports){
'use strict';

/**
 * Association chip decoration — two coordinated behaviours for the association UIs (the inline
 * RecordSet-AssociationEditor tabs on read views + their add-pickers), so an admin can tell
 * similarly-named records apart by a short identifier code next to the name.
 *
 *  (A) DEFAULT identifier chip per entity. Every association side shows its natural human-facing code
 *      beside the Name (Material → Material Code, Pay Item → Item Code, …). Applied by setting each
 *      side's `ChipFields`, which drives BOTH surfaces at once — the inline current-associations list
 *      (RecordSet-AssociationManager.composeChips) AND the add-picker (EntityTags) — but only where the
 *      side has no curated ChipFields already, so hand-tuned associations are left alone.
 *
 *  (B) USER-SELECTABLE decoration on the current-associations LIST. The add-picker already lets a user
 *      pin extra columns as chips (pict-section-picker's field-decoration ⚙, persisted per entity in
 *      localStorage). We extend that SAME choice to the editor's current-associations rows by wrapping
 *      the manager's `listAssociatedRecords`: it builds each row carrying the full `OtherRecord`, and we
 *      append a chip for each user-pinned field. So one ⚙ choice decorates both the picker and the list.
 *
 * App-local integration — no node_module edits. Applied once, after the associations are registered.
 */

// Per-entity default identifier chip: the natural short, human-facing code that differentiates same-named
// records (chosen from each entity's Meadow schema). Entities with no suitable identifier — BidItem, Lot,
// Test, TestSpecification — are intentionally absent (they get no default chip).
const ENTITY_CHIP_FIELDS =
{
	Material: { Field: 'MaterialCode', Label: 'Code' },
	PayItem: { Field: 'ItemCode', Label: 'Item' },
	LineItem: { Field: 'ItemNumber', Label: 'Item' },
	Equipment: { Field: 'Code', Label: 'Code' },
	MixSpecification: { Field: 'Code', Label: 'Code' },
	Organization: { Field: 'VendorCode', Label: 'Vendor' },
	Contact: { Field: 'Email', Label: 'Email' },
	FundingSource: { Field: 'FundingSourceAccountCode', Label: 'Acct' },
	Lab: { Field: 'ExternalLabID', Label: 'Lab ID' },
	Project: { Field: 'ExternalProjectID', Label: 'Proj ID' },
	ReportNamedInstance: { Field: 'Hash', Label: 'Hash' },
	Sample: { Field: 'LabControlNumber', Label: 'Ctrl #' },
	TestInstance: { Field: 'SampleTestNumber', Label: 'Test #' },
	TestSpecificationSet: { Field: 'Year', Label: 'Year' },
};

// Mirrors pict-section-picker's field-decoration storage (client-only, keyed per entity).
const DECORATION_KEY_PREFIX = 'PictSectionPicker.Decoration.';

function _chipFieldName(pSpec) { return (typeof pSpec === 'string') ? pSpec : ((pSpec && pSpec.Field) || ''); }

/**
 * (A) Give each association side a default identifier ChipFields entry where it has none. Drives both the
 * inline list chips and the add-picker's EntityTags. Preserves any side that already has curated chips.
 * @param {any} pManager - the RecordSetAssociationManager provider.
 */
function applyDefaultAssociationChips(pManager)
{
	if (!pManager || !pManager.associations) { return; }
	Object.keys(pManager.associations).forEach((pHash) =>
	{
		const tmpAssoc = pManager.associations[pHash];
		[ 'SideA', 'SideB' ].forEach((pSideKey) =>
		{
			const tmpSide = tmpAssoc && tmpAssoc[pSideKey];
			if (!tmpSide || !tmpSide.Entity) { return; }
			if (Array.isArray(tmpSide.ChipFields) && (tmpSide.ChipFields.length > 0)) { return; }   // keep curated chips
			const tmpChip = ENTITY_CHIP_FIELDS[tmpSide.Entity];
			if (tmpChip) { tmpSide.ChipFields = [ { Field: tmpChip.Field, Label: tmpChip.Label } ]; }
		});
	});
}

/** Read the user's picker-pinned decoration field list for an entity (client-only localStorage; safe). */
function _readDecorationFields(pEntity)
{
	if (!pEntity || (typeof window !== 'object') || !window || (typeof window.localStorage !== 'object') || !window.localStorage) { return []; }
	try
	{
		const tmpRaw = window.localStorage.getItem(`${DECORATION_KEY_PREFIX}${pEntity}`);
		const tmpParsed = tmpRaw ? JSON.parse(tmpRaw) : [];
		return Array.isArray(tmpParsed) ? tmpParsed.filter((pField) => ((typeof pField === 'string') && pField)) : [];
	}
	catch (pError) { return []; }
}

/**
 * (B) Wrap listAssociatedRecords so the current-associations rows also show the user's ⚙-pinned columns
 * (the same per-entity field-decoration choice the add-picker uses). Idempotent; best-effort.
 * @param {any} pManager - the RecordSetAssociationManager provider.
 */
function patchAssociationListDecoration(pManager)
{
	if (!pManager || pManager.__assocListDecorationPatched) { return; }
	if (typeof pManager.listAssociatedRecords !== 'function') { return; }
	pManager.__assocListDecorationPatched = true;
	const fOriginal = pManager.listAssociatedRecords.bind(pManager);
	pManager.listAssociatedRecords = function (pAssociationHash, pThisRecordSetName, pThisID)
	{
		return Promise.resolve(fOriginal(pAssociationHash, pThisRecordSetName, pThisID)).then((pRows) =>
		{
			try
			{
				if (!Array.isArray(pRows) || (pRows.length === 0)) { return pRows; }
				const tmpSides = this.resolveSides(pAssociationHash, pThisRecordSetName);
				const tmpEntity = tmpSides && tmpSides.otherSide && tmpSides.otherSide.Entity;
				const tmpDecoFields = _readDecorationFields(tmpEntity);
				if (!tmpEntity || (tmpDecoFields.length === 0)) { return pRows; }
				// Don't repeat a field already shown as the default / curated chip.
				const tmpExisting = new Set(((tmpSides.otherSide.ChipFields) || []).map(_chipFieldName).filter(Boolean));
				pRows.forEach((pRow) =>
				{
					const tmpRecord = pRow && pRow.OtherRecord;
					if (!tmpRecord) { return; }
					tmpDecoFields.forEach((pField) =>
					{
						if (tmpExisting.has(pField)) { return; }
						const tmpValue = tmpRecord[pField];
						if ((tmpValue === undefined) || (tmpValue === null) || (tmpValue === '')) { return; }
						pRow.Chips = (Array.isArray(pRow.Chips) ? pRow.Chips : []).concat([ { Text: `${pField}: ${tmpValue}` } ]);
					});
				});
			}
			catch (pError) { /* decoration is best-effort — never break the associations list */ }
			return pRows;
		});
	};
}

module.exports = { ENTITY_CHIP_FIELDS, applyDefaultAssociationChips, patchAssociationListDecoration };

},{}],1289:[function(require,module,exports){
/**
 * GENERATED FILE — do not edit by hand.
 *
 * The Master List connection registry. Relationships are derived from the live schema
 * (lib/headlight_model/json/Headlight.json); scope + presentation come from Connection-Curation.js.
 * Regenerate:  node source/master-lists/build-connections.js
 */

module.exports = {
	"ASSOCIATIONS": {
		"OrganizationProject": {
			"JoinEntity": "ProjectOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"ContactProject": {
			"JoinEntity": "ProjectContactJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Contact",
				"IDField": "IDContact",
				"DisplayField": "Title",
				"SearchFields": [
					"Title"
				],
				"TableColumns": [
					{
						"Key": "Title",
						"DisplayName": "Title"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"FundingSourceProject": {
			"JoinEntity": "FundingSourceProjectJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "FundingSource",
				"IDField": "IDFundingSource",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"ProjectReportNamedInstance": {
			"JoinEntity": "ReportNamedInstanceProjectJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			},
			"SideB": {
				"RecordSet": "ReportNamedInstance",
				"IDField": "IDReportNamedInstance",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDReportArchetype",
						"DisplayName": "IDReport Archetype"
					}
				]
			}
		},
		"LabProject": {
			"JoinEntity": "ProjectLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"ContactOrganization": {
			"JoinEntity": "ContactOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Contact",
				"IDField": "IDContact",
				"DisplayField": "Title",
				"SearchFields": [
					"Title"
				],
				"TableColumns": [
					{
						"Key": "Title",
						"DisplayName": "Title"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"EquipmentOrganization": {
			"JoinEntity": "EquipmentOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Equipment",
				"IDField": "IDEquipment",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Code",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Code",
						"DisplayName": "Code"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"BidItemOrganization": {
			"JoinEntity": "BidItemOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "BidItem",
				"IDField": "IDBidItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Units"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Units",
						"DisplayName": "Units"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDPayItem",
						"DisplayName": "IDPay Item"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"LineItemOrganization": {
			"JoinEntity": "LineItemOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"MaterialOrganization": {
			"JoinEntity": "OrganizationMaterialJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"MaterialPayItem": {
			"JoinEntity": "MaterialPayItemJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "PayItem",
				"IDField": "IDPayItem",
				"DisplayField": "Description",
				"SearchFields": [
					"Description",
					"ItemCode",
					"Name"
				],
				"TableColumns": [
					{
						"Key": "ItemCode",
						"DisplayName": "Item Code"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					},
					{
						"Key": "FunctionalClass",
						"DisplayName": "Functional Class"
					},
					{
						"Key": "Units",
						"DisplayName": "Units"
					},
					{
						"Key": "Amount",
						"DisplayName": "Amount"
					}
				]
			}
		},
		"MaterialMixSpecification": {
			"JoinEntity": "MixSpecificationMaterialJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "MixSpecification",
				"IDField": "IDMixSpecification",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Code"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Code",
						"DisplayName": "Code"
					}
				]
			}
		},
		"LineItemMaterial": {
			"JoinEntity": "MaterialLineItemJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			}
		},
		"MaterialTestSpecification": {
			"JoinEntity": "TestSpecificationMaterialJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecification",
				"IDField": "IDTestSpecification",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Description"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					}
				]
			}
		},
		"PayItemTestSpecificationSet": {
			"JoinEntity": "PayItemTestSpecificationSetJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "PayItem",
				"IDField": "IDPayItem",
				"DisplayField": "Description",
				"SearchFields": [
					"Description",
					"ItemCode",
					"Name"
				],
				"TableColumns": [
					{
						"Key": "ItemCode",
						"DisplayName": "Item Code"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					},
					{
						"Key": "FunctionalClass",
						"DisplayName": "Functional Class"
					},
					{
						"Key": "Units",
						"DisplayName": "Units"
					},
					{
						"Key": "Amount",
						"DisplayName": "Amount"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecificationSet",
				"IDField": "IDTestSpecificationSet",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Year"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Year",
						"DisplayName": "Year"
					}
				]
			}
		},
		"LabTestSpecificationSet": {
			"JoinEntity": "LabTestSpecificationSetJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecificationSet",
				"IDField": "IDTestSpecificationSet",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Year"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Year",
						"DisplayName": "Year"
					}
				]
			}
		},
		"TestTestSpecificationSet": {
			"JoinEntity": "TestSpecificationSetTestJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Test",
				"IDField": "IDTest",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Description"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecificationSet",
				"IDField": "IDTestSpecificationSet",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Year"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Year",
						"DisplayName": "Year"
					}
				]
			}
		},
		"LabTest": {
			"JoinEntity": "TestLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "Test",
				"IDField": "IDTest",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Description"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					}
				]
			}
		},
		"LabSample": {
			"JoinEntity": "SampleLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "Sample",
				"IDField": "IDSample",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDMaterial",
						"DisplayName": "IDMaterial"
					},
					{
						"Key": "IDProductionPlant",
						"DisplayName": "IDProduction Plant"
					}
				]
			}
		},
		"LabTestInstance": {
			"JoinEntity": "TestInstanceLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestInstance",
				"IDField": "IDTestInstance",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDTestPlan",
						"DisplayName": "IDTest Plan"
					},
					{
						"Key": "IDTest",
						"DisplayName": "IDTest"
					},
					{
						"Key": "IDLab",
						"DisplayName": "IDLab"
					}
				]
			}
		},
		"LineItemLot": {
			"JoinEntity": "LineItemLotJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Lot",
				"IDField": "IDLot",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDMixDesign",
						"DisplayName": "IDMix Design"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					}
				]
			}
		},
		"LineItemSample": {
			"JoinEntity": "SampleLineItemJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Sample",
				"IDField": "IDSample",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDMaterial",
						"DisplayName": "IDMaterial"
					},
					{
						"Key": "IDProductionPlant",
						"DisplayName": "IDProduction Plant"
					}
				]
			}
		},
		"SampleTestInstance": {
			"JoinEntity": "TestInstanceSampleJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Sample",
				"IDField": "IDSample",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDMaterial",
						"DisplayName": "IDMaterial"
					},
					{
						"Key": "IDProductionPlant",
						"DisplayName": "IDProduction Plant"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestInstance",
				"IDField": "IDTestInstance",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDTestPlan",
						"DisplayName": "IDTest Plan"
					},
					{
						"Key": "IDTest",
						"DisplayName": "IDTest"
					},
					{
						"Key": "IDLab",
						"DisplayName": "IDLab"
					}
				]
			}
		}
	},
	"EntityConnections": {
		"Project": {
			"ReadTabs": [
				{
					"Association": "OrganizationProject",
					"Title": "Organizations"
				},
				{
					"Association": "ContactProject",
					"Title": "Contacts"
				},
				{
					"Association": "FundingSourceProject",
					"Title": "Funding Sources"
				},
				{
					"Association": "ProjectReportNamedInstance",
					"Title": "Report Instances"
				},
				{
					"Association": "LabProject",
					"Title": "Labs"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "BidItem",
					"FilterField": "IDProject",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDProject",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDProject",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						},
						{
							"Field": "IDProductionPlant",
							"Entity": "ProductionPlant",
							"DisplayField": "Name",
							"Label": "Production Plant"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDProject",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						},
						{
							"Field": "IDLab",
							"Entity": "Lab",
							"DisplayField": "Name",
							"Label": "Lab"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Contract": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Project",
					"FilterField": "IDContract",
					"Title": "Projects",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProjectType",
							"DisplayName": "IDProject Type"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProjectType",
							"Entity": "ProjectType",
							"DisplayField": "Name",
							"Label": "Project Type"
						},
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				},
				{
					"RecordSet": "BidItem",
					"FilterField": "IDContract",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDContract",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "Lot",
					"FilterField": "IDContract",
					"Title": "Lots",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDMixDesign",
							"DisplayName": "IDMix Design"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMixDesign",
							"Entity": "MixDesign",
							"DisplayField": "Name",
							"Label": "Mix Design"
						}
					]
				},
				{
					"RecordSet": "Core",
					"FilterField": "IDContract",
					"Title": "Cores",
					"DisplayField": "IDCore",
					"Columns": [
						{
							"Key": "IDLot",
							"DisplayName": "IDLot"
						},
						{
							"Key": "IDSample",
							"DisplayName": "IDSample"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDLot",
							"Entity": "Lot",
							"DisplayField": "Name",
							"Label": "Lot"
						},
						{
							"Field": "IDSample",
							"Entity": "Sample",
							"DisplayField": "Name",
							"Label": "Sample"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"User": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Organization": {
			"ReadTabs": [
				{
					"Association": "OrganizationProject",
					"Title": "Projects"
				},
				{
					"Association": "ContactOrganization",
					"Title": "Contacts"
				},
				{
					"Association": "EquipmentOrganization",
					"Title": "Equipments"
				},
				{
					"Association": "BidItemOrganization",
					"Title": "Bid Items"
				},
				{
					"Association": "LineItemOrganization",
					"Title": "Line Items"
				},
				{
					"Association": "MaterialOrganization",
					"Title": "Materials"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "Project",
					"FilterField": "IDOrganization",
					"Title": "Projects",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProjectType",
							"DisplayName": "IDProject Type"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProjectType",
							"Entity": "ProjectType",
							"DisplayField": "Name",
							"Label": "Project Type"
						}
					]
				},
				{
					"RecordSet": "Contract",
					"FilterField": "IDOrganization",
					"Title": "Contracts",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDContractType",
							"DisplayName": "IDContract Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContractType",
							"Entity": "ContractType",
							"DisplayField": "Name",
							"Label": "Contract Type"
						}
					]
				},
				{
					"RecordSet": "Contact",
					"FilterField": "IDOrganization",
					"Title": "Contacts",
					"DisplayField": "Title",
					"Columns": [
						{
							"Key": "Title",
							"DisplayName": "Title"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "ObservationTag",
					"FilterField": "IDOrganization",
					"Title": "Observation Tags",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDBidItem",
							"DisplayName": "IDBid Item"
						},
						{
							"Key": "IDLineItem",
							"DisplayName": "IDLine Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDBidItem",
							"Entity": "BidItem",
							"DisplayField": "Name",
							"Label": "Bid Item"
						},
						{
							"Field": "IDLineItem",
							"Entity": "LineItem",
							"DisplayField": "Name",
							"Label": "Line Item"
						}
					]
				},
				{
					"RecordSet": "BidItem",
					"FilterField": "IDOrganization",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				},
				{
					"RecordSet": "Lab",
					"FilterField": "IDOrganization",
					"Title": "Labs",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDOrganizationAddress",
							"DisplayName": "IDOrganization Address"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "MixDesign",
					"FilterField": "IDOrganization",
					"Title": "Mix Designs",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "MaterialCode",
							"DisplayName": "Material Code"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDMixType",
							"DisplayName": "IDMix Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				},
				{
					"RecordSet": "Product",
					"FilterField": "IDOrganization",
					"Title": "Products",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "ProductCategory",
							"DisplayName": "Product Category"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				},
				{
					"RecordSet": "ProductionPlant",
					"FilterField": "IDOrganization",
					"Title": "Production Plants",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDOrganizationAddress",
							"DisplayName": "IDOrganization Address"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDOrganization",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Role": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "User",
					"FilterField": "IDRole",
					"Title": "Users",
					"DisplayField": "NameLast",
					"Columns": [
						{
							"Key": "NameLast",
							"Keys": [
								"NameFirst",
								"NameLast"
							],
							"DisplayName": "Name"
						},
						{
							"Key": "Title",
							"DisplayName": "Title"
						},
						{
							"Key": "Email",
							"DisplayName": "Email"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProjectOffice",
							"Entity": "ProjectOffice",
							"DisplayField": "Name",
							"Label": "Project Office"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Material": {
			"ReadTabs": [
				{
					"Association": "MaterialPayItem",
					"Title": "Pay Items"
				},
				{
					"Association": "MaterialMixSpecification",
					"Title": "Mix Specifications"
				},
				{
					"Association": "LineItemMaterial",
					"Title": "Line Items"
				},
				{
					"Association": "MaterialOrganization",
					"Title": "Organizations"
				},
				{
					"Association": "MaterialTestSpecification",
					"Title": "Test Specifications"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "MixDesign",
					"FilterField": "IDMaterial",
					"Title": "Mix Designs",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "MaterialCode",
							"DisplayName": "Material Code"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDMixType",
							"DisplayName": "IDMix Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				},
				{
					"RecordSet": "Product",
					"FilterField": "IDMaterial",
					"Title": "Products",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "ProductCategory",
							"DisplayName": "Product Category"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDMaterial",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDProductionPlant",
							"Entity": "ProductionPlant",
							"DisplayField": "Name",
							"Label": "Production Plant"
						}
					]
				}
			],
			"MatrixAssociations": [
				{
					"Association": "MaterialPayItem",
					"Title": "Pay Items grid"
				}
			],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Product": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Sample",
					"FilterField": "IDProduct",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"MixDesign": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Lot",
					"FilterField": "IDMixDesign",
					"Title": "Lots",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDMixDesign",
							"DisplayName": "IDMix Design"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDMixDesign",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"PayItem": {
			"ReadTabs": [
				{
					"Association": "PayItemTestSpecificationSet",
					"Title": "Specification Sets"
				},
				{
					"Association": "MaterialPayItem",
					"Title": "Materials"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "BidItem",
					"FilterField": "IDPayItem",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDPayItem",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				}
			],
			"MatrixAssociations": [
				{
					"Association": "MaterialPayItem",
					"Title": "Materials grid"
				}
			],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestSpecificationSet": {
			"ReadTabs": [
				{
					"Association": "PayItemTestSpecificationSet",
					"Title": "Pay Items"
				},
				{
					"Association": "LabTestSpecificationSet",
					"Title": "Labs"
				},
				{
					"Association": "TestTestSpecificationSet",
					"Title": "Tests"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "PayItem",
					"FilterField": "IDTestSpecificationSet",
					"Title": "Pay Items",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "ItemCode",
							"DisplayName": "Item Code"
						},
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "FunctionalClass",
							"DisplayName": "Functional Class"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "Amount",
							"DisplayName": "Amount"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "TestSpecification",
					"FilterField": "IDTestSpecificationSet",
					"Title": "Test Specifications",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Description",
							"DisplayName": "Description"
						}
					],
					"ChipFields": []
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestSpecification": {
			"ReadTabs": [
				{
					"Association": "MaterialTestSpecification",
					"Title": "Materials"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "TestSpecificationRequirement",
					"FilterField": "IDTestSpecification",
					"Title": "Requirements",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDTestSpecification",
							"DisplayName": "IDTest Specification"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						}
					],
					"ChipFields": [
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestSpecificationRequirement": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Test": {
			"ReadTabs": [
				{
					"Association": "LabTest",
					"Title": "Labs"
				},
				{
					"Association": "TestTestSpecificationSet",
					"Title": "Specification Sets"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "TestSpecificationRequirement",
					"FilterField": "IDTest",
					"Title": "Requirements",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDTestSpecification",
							"DisplayName": "IDTest Specification"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						}
					],
					"ChipFields": [
						{
							"Field": "IDTestSpecification",
							"Entity": "TestSpecification",
							"DisplayField": "Name",
							"Label": "Test Specification"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDTest",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDLab",
							"Entity": "Lab",
							"DisplayField": "Name",
							"Label": "Lab"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Lab": {
			"ReadTabs": [
				{
					"Association": "LabTest",
					"Title": "Tests"
				},
				{
					"Association": "LabTestSpecificationSet",
					"Title": "Specification Sets"
				},
				{
					"Association": "LabProject",
					"Title": "Projects"
				},
				{
					"Association": "LabSample",
					"Title": "Samples"
				},
				{
					"Association": "LabTestInstance",
					"Title": "Test Instances"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDLab",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"LineItem": {
			"ReadTabs": [
				{
					"Association": "LineItemOrganization",
					"Title": "Organizations"
				},
				{
					"Association": "LineItemLot",
					"Title": "Lots"
				},
				{
					"Association": "LineItemMaterial",
					"Title": "Materials"
				},
				{
					"Association": "LineItemSample",
					"Title": "Samples"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "ObservationTag",
					"FilterField": "IDLineItem",
					"Title": "Observation Tags",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDBidItem",
							"DisplayName": "IDBid Item"
						},
						{
							"Key": "IDLineItem",
							"DisplayName": "IDLine Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						},
						{
							"Field": "IDBidItem",
							"Entity": "BidItem",
							"DisplayField": "Name",
							"Label": "Bid Item"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDLineItem",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDLineItem",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"BidItem": {
			"ReadTabs": [
				{
					"Association": "BidItemOrganization",
					"Title": "Organizations"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "ObservationTag",
					"FilterField": "IDBidItem",
					"Title": "Observation Tags",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDBidItem",
							"DisplayName": "IDBid Item"
						},
						{
							"Key": "IDLineItem",
							"DisplayName": "IDLine Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						},
						{
							"Field": "IDLineItem",
							"Entity": "LineItem",
							"DisplayField": "Name",
							"Label": "Line Item"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDBidItem",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDBidItem",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ObservationManifest": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ProjectType": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Project",
					"FilterField": "IDProjectType",
					"Title": "Projects",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProjectType",
							"DisplayName": "IDProject Type"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ContractType": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Contract",
					"FilterField": "IDContractType",
					"Title": "Contracts",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDContractType",
							"DisplayName": "IDContract Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ObservationTag": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ReportNamedInstance": {
			"ReadTabs": [
				{
					"Association": "ProjectReportNamedInstance",
					"Title": "Projects"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ProductionPlant": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Sample",
					"FilterField": "IDProductionPlant",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Equipment": {
			"ReadTabs": [
				{
					"Association": "EquipmentOrganization",
					"Title": "Organizations"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Contact": {
			"ReadTabs": [
				{
					"Association": "ContactProject",
					"Title": "Projects"
				},
				{
					"Association": "ContactOrganization",
					"Title": "Organizations"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"CertificationType": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Account": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"FundingSource": {
			"ReadTabs": [
				{
					"Association": "FundingSourceProject",
					"Title": "Projects"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"MixSpecification": {
			"ReadTabs": [
				{
					"Association": "MaterialMixSpecification",
					"Title": "Materials"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Lot": {
			"ReadTabs": [
				{
					"Association": "LineItemLot",
					"Title": "Line Items"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "Core",
					"FilterField": "IDLot",
					"Title": "Cores",
					"DisplayField": "IDCore",
					"Columns": [
						{
							"Key": "IDLot",
							"DisplayName": "IDLot"
						},
						{
							"Key": "IDSample",
							"DisplayName": "IDSample"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDSample",
							"Entity": "Sample",
							"DisplayField": "Name",
							"Label": "Sample"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ProjectOffice": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "User",
					"FilterField": "IDProjectOffice",
					"Title": "Users",
					"DisplayField": "NameLast",
					"Columns": [
						{
							"Key": "NameLast",
							"Keys": [
								"NameFirst",
								"NameLast"
							],
							"DisplayName": "Name"
						},
						{
							"Key": "Title",
							"DisplayName": "Title"
						},
						{
							"Key": "Email",
							"DisplayName": "Email"
						}
					],
					"ChipFields": []
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestInstance": {
			"ReadTabs": [
				{
					"Association": "SampleTestInstance",
					"Title": "Samples"
				},
				{
					"Association": "LabTestInstance",
					"Title": "Labs"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Sample": {
			"ReadTabs": [
				{
					"Association": "LineItemSample",
					"Title": "Line Items"
				},
				{
					"Association": "LabSample",
					"Title": "Labs"
				},
				{
					"Association": "SampleTestInstance",
					"Title": "Test Instances"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "Core",
					"FilterField": "IDSample",
					"Title": "Cores",
					"DisplayField": "IDCore",
					"Columns": [
						{
							"Key": "IDLot",
							"DisplayName": "IDLot"
						},
						{
							"Key": "IDSample",
							"DisplayName": "IDSample"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDLot",
							"Entity": "Lot",
							"DisplayField": "Name",
							"Label": "Lot"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Core": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		}
	}
};

},{}],1290:[function(require,module,exports){
/**
 * Headlight Platform Configuration — Master List seed catalog.
 *
 * The reference / catalog "master lists" an administrator curates. Each entry is a
 * thin, data-driven description of a Meadow entity to expose as a managed list; the
 * MasterList-Builder turns each into a pict-section-recordset configuration plus a
 * navigation entry. Columns and the create / edit / view forms are auto-generated from
 * the entity's /1.0/<Entity>/Schema endpoint — no hand-written manifest required.
 *
 * This static seed is the always-present baseline. The MasterListRegistry provider layers
 * the cascading Configuration service on top of it (namespace 'MasterListCatalog', one value
 * per entity, merged Global -> Customer -> Project -> User) and a GUI tool edits it, so product
 * managers can add and tune lists — and choose each list's association views — without a
 * developer. Entries here are the platform-default fallback when no config layer overrides them.
 *
 * Per entry:
 *   Entity       (required) — the Meadow entity / record set name (e.g. 'Material').
 *   Label        — human navigation label (defaults to Entity).
 *   Domain       — grouping bucket for the future nav retool (informational for now).
 *   Icon         — Font Awesome class for the nav entry.
 *   Keywords     — search terms for the navigation palette.
 *   Description  — one-line nav description.
 *   SearchFields — optional list-search fields (defaults to [ 'Name' ]).
 *   Columns      — optional curated columns; omit to auto-generate from the schema.
 *   DefaultFilter — optional FoxHound filter string (e.g. a 'FSF~CreateDate~DESC~0' sort) for a bare
 *                  /PSRS/<Entity>/List route, the one workspace Back links and redirects land on.
 *   Sortable     — optional; true makes the list's column headers sort it (pict-section-recordset
 *                  RecordSetListSortable). A column can opt out with Sortable: false.
 *   QuickFilters — optional quick-filter bar fields (pict-section-recordset QuickFilters: a field name
 *                  or { Field, Label }). Quick filters are opt-in here, so a list without this has no bar.
 *   Filters      — optional per-field filter tweaks merged onto an auto-generated clause (e.g. a
 *                  foreign-key picker's ExternalFilterByColumns), passed through to the recordset provider.
 *   FieldFilterClauses — optional per-field REPLACEMENT clause arrays; the module drops its
 *                  auto-generated clauses for that field and uses these instead (e.g. a status pick list).
 *
 * Connection surfaces (ReadTabs / ChildLists / Matrix / Bulk / Unlink) are NOT hand-written here — they
 * are merged in per entity from Connections.generated.js (derived from the schema graph by
 * build-connections.js), unless an entry hand-specifies that array. Regenerate the connection registry
 * with:  node source/master-lists/build-connections.js
 */

const { EntityConnections } = require('./Connections.generated.js');

/**
 * Merge an entity's generated connection defaults (ReadTabs / ChildLists / Matrix / Bulk / Unlink) into
 * its catalog entry, unless the entry already hand-specifies that array (a hand array is an intentional
 * override — including an empty one meaning "show none").
 * @param {Object} pEntry - a master-list catalog entry.
 * @return {Object} the entry with connection defaults applied.
 */
function applyConnectionDefaults(pEntry)
{
	const tmpConnections = EntityConnections[pEntry.Entity];
	if (!tmpConnections) { return pEntry; }
	const tmpResult = Object.assign({}, pEntry);
	[ 'ReadTabs', 'ChildLists', 'MatrixAssociations', 'BulkAssociations', 'UnlinkAssociations' ].forEach((pKey) =>
	{
		if (!Array.isArray(tmpResult[pKey]) && Array.isArray(tmpConnections[pKey]) && (tmpConnections[pKey].length > 0))
		{
			tmpResult[pKey] = tmpConnections[pKey].slice();
		}
	});
	return tmpResult;
}

const CATALOG =
[
	{
		Entity: 'Material',
		Label: 'Materials',
		Domain: 'Materials & Mixes',
		Icon: 'fas fa-cube',
		Keywords: 'material catalog aggregate concrete asphalt base source',
		Description: 'Base material catalog — aggregates, mixes, and source materials.',
		Sortable: true,
		// Search the code columns too, not just Name — users routinely look a material up by its
		// code (Material Code / Catalog Code / Item Code), which the default [ 'Name' ] never matched.
		SearchFields: [ 'Name', 'NameAbbreviated', 'MaterialCode', 'CatalogCode', 'ItemCode' ],
		// Bespoke read tab: the specification sets reachable transitively through this material's specs —
		// the reciprocal of TestSpecificationSet's SpecSetMaterials tab (B5).
		ViewTabs: [ { View: 'MaterialSpecSets', Title: 'Test Specification Sets' } ]
	},
	{
		Entity: 'Product',
		Label: 'Products',
		Domain: 'Products & Production',
		Icon: 'fas fa-box',
		Keywords: 'product manufactured producer finished goods',
		Description: 'Manufactured products linked to base materials and producers.'
	},
	{
		Entity: 'ProductionPlant',
		Label: 'Production Plants',
		Domain: 'Products & Production',
		Icon: 'fas fa-industry',
		Keywords: 'plant producer facility manufacturing site',
		Description: 'Producer manufacturing facilities and their addresses.'
	},
	{
		Entity: 'PayItem',
		Label: 'Pay Items',
		Domain: 'Pay & Funding',
		Icon: 'fas fa-dollar-sign',
		Keywords: 'pay item bid payment specification billing',
		Description: 'Bid / payment items and their linked test specification sets.'
	},
	{
		Entity: 'Lab',
		Label: 'Labs',
		Domain: 'Labs & Equipment',
		Icon: 'fas fa-flask',
		Keywords: 'lab laboratory testing facility',
		Description: 'Testing laboratories — facilities, addresses, and hierarchy.',
		Sortable: true
	},
	{
		Entity: 'TestSpecification',
		Label: 'Test Specifications',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-vial',
		Keywords: 'test specification AASHTO ASTM requirement threshold',
		Description: 'Individual test specifications within specification sets.'
	},

	// --- The rest of the home app's (app_headlight) Master Lists section ---
	// Source of truth: lib/bootstraps/mixins/modules.js (CustomerConfig.MasterLists + Entities,
	// minus Role / Contract / User) with labels from lib/bootstraps/mixins/entities.js EntityConfig.
	{
		Entity: 'Equipment',
		Label: 'Equipment',
		Domain: 'Labs & Equipment',
		Icon: 'fas fa-screwdriver-wrench',
		Keywords: 'equipment machinery field plant',
		Description: 'Field equipment and machinery.',
		Sortable: true
	},
	{
		Entity: 'Location',
		Label: 'Locations',
		Domain: 'Labs & Equipment',
		Icon: 'fas fa-location-dot',
		Keywords: 'location storage room shelf freezer building sample receive scan qr',
		Description: 'Places samples are kept — buildings, rooms, shelves — and which is inside which.',
		Sortable: true,
		SearchFields: [ 'Name', 'QRCode', 'Type', 'Description' ],
		QuickFilters: [ 'Name', { Field: 'CreateDate', Label: 'Added' } ],
		Columns:
		[
			{ Key: 'Name', DisplayName: 'Name' },
			{ Key: 'Type', DisplayName: 'Type' },
			{ Key: 'QRCode', DisplayName: 'QR Code' },
			{ Key: 'Description', DisplayName: 'Description' }
		]
	},
	{
		Entity: 'Team',
		Label: 'Teams',
		Domain: 'Organizations & People',
		Icon: 'fas fa-users',
		Keywords: 'team crew squad members roles enrollment shared ownership collaboration people manager document access',
		Description: 'Groups of people, each in a role, that can be granted documents together. Members reach a granted document, and its project, without being added to the project.'
	},
	{
		Entity: 'Contact',
		Label: 'Personnel',
		Domain: 'Organizations & People',
		Icon: 'fas fa-address-card',
		Keywords: 'contact personnel people person staff',
		Description: 'Personnel and contacts linked to organizations.'
	},
	{
		Entity: 'CertificationType',
		Label: 'Certifications',
		Domain: 'Organizations & People',
		Icon: 'fas fa-stamp',
		Keywords: 'certification type credential DBE qualification',
		Description: 'Certification types and credentials.'
	},
	{
		Entity: 'Account',
		Label: 'Accounts',
		Domain: 'Pay & Funding',
		Icon: 'fas fa-money-check-dollar',
		Keywords: 'account financial ledger budget',
		Description: 'Financial accounts.'
	},
	{
		Entity: 'FundingSource',
		Label: 'Funding Sources',
		Domain: 'Pay & Funding',
		Icon: 'fas fa-building-columns',
		Keywords: 'funding source federal state grant loan',
		Description: 'Funding sources for projects and contracts.'
	},
	{
		Entity: 'Fund',
		Label: 'Funds',
		Domain: 'Pay & Funding',
		Icon: 'fas fa-piggy-bank',
		Keywords: 'fund balance cost center appropriation money pool',
		Description: 'Funds a funding source draws from (each carries a balance).'
	},
	{
		Entity: 'FundingCategory',
		Label: 'Funding Categories',
		Domain: 'Pay & Funding',
		Icon: 'fas fa-folder-tree',
		Keywords: 'funding category bucket classification participating non-participating',
		Description: 'Categories that classify how funding applies to line items.'
	},
	{
		Entity: 'AccountType',
		Label: 'Account Types',
		Domain: 'Pay & Funding',
		Icon: 'fas fa-list-ul',
		Keywords: 'account type kind ledger classification',
		Description: 'The kinds of financial account (drives what each account applies to).'
	},
	{
		Entity: 'MixDesign',
		Label: 'Mix Designs',
		Domain: 'Materials & Mixes',
		Icon: 'fas fa-flask-vial',
		Keywords: 'mix design formulation plant concrete asphalt',
		Description: 'Mix design formulations.'
	},
	{
		Entity: 'MixType',
		Label: 'Mix Types',
		Domain: 'Materials & Mixes',
		Icon: 'fas fa-layer-group',
		Keywords: 'mix type category classification asphalt concrete nominal aggregate traffic',
		Description: 'Mix type categories and their per-customer metadata.'
	},
	{
		Entity: 'MixSpecification',
		Label: 'Mix Specifications',
		Domain: 'Materials & Mixes',
		Icon: 'fas fa-file-lines',
		Keywords: 'mix specification requirement template',
		Description: 'Mix specification templates.'
	},
	{
		Entity: 'Lot',
		Label: 'Lots',
		Domain: 'Materials & Mixes',
		Icon: 'fas fa-boxes-stacked',
		Keywords: 'lot batch material placement',
		Description: 'Material lots and batches.'
	},
	{
		Entity: 'ProjectOffice',
		Label: 'Project Offices',
		Domain: 'Projects & Contracts',
		Icon: 'fas fa-building',
		Keywords: 'project office district region',
		Description: 'Regional and district project offices.'
	},
	{
		Entity: 'TestSpecificationSet',
		Label: 'Test Specification Sets',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-vials',
		Keywords: 'test specification set group AASHTO ASTM',
		Description: 'Grouped sets of test specifications.',
		// Bespoke read tab: the materials reachable transitively through this set's specs (B5).
		ViewTabs: [ { View: 'SpecSetMaterials', Title: 'Materials' } ]
	},
	{
		Entity: 'Test',
		Label: 'Material Sample Tests',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-flask',
		Keywords: 'test material sample method procedure',
		Description: 'Material sample test definitions.',
		Sortable: true
	},
	{
		Entity: 'TestInstance',
		Label: 'Test Instances',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-microscope',
		Keywords: 'test instance result run reading',
		Description: 'Recorded test instances and results.'
	},
	{
		Entity: 'Sample',
		Label: 'Samples',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-vial',
		Keywords: 'sample field material specimen',
		Description: 'Field and material samples.',
		// The identifiers people search by: Description, PSID, sample ID (QR Code) and Lab Reference #.
		SearchFields: [ 'Name', 'LabControlNumber', 'QRCode', 'LabReferenceNumber' ],
		// Newest first, matching the Samples menu route (navigation-graph.js and web/lims LIMS-Navigation-Graph.js).
		DefaultFilter: 'FSF~CreateDate~DESC~0',
		Sortable: true,
		// Status stays in the drawer's labelled pick list: the quick bar can show it only as raw codes (PASS, LOGD) or a free-text box.
		QuickFilters: [ { Field: 'Name', Label: 'Description' }, 'IDProject', 'IDMaterial', { Field: 'CreateDate', Label: 'Logged' }, { Field: 'CreatingIDUser', Label: 'Logged by' } ],
		// Find samples by their sampled Material's CODE, not just its name. A Sample carries only
		// IDMaterial (no code column of its own), so reach through the foreign-key picker: widen the
		// material picker's search columns to the same code fields the Materials list search uses
		// (Material Code / Catalog Code / Item Code). Mirrors the Materials list search fix.
		Filters:
		{
			IDMaterial: { ExternalFilterByColumns: [ 'Name', 'NameAbbreviated', 'MaterialCode', 'CatalogCode', 'ItemCode' ] }
		},
		// Curated list columns, matching the LIMS Samples list operators know: LabControlNumber shows as "PSID",
		// Name as "Description", ReceivedFrom as "Source", and the Status CODE is resolved to its friendly label via
		// the {~SampleStatusName:~} MetaTemplate (registered in PlatformConfiguration-Application-Web). Setting Columns
		// here wins over the generated catalog ListColumns (the catalog only fills RecordSetListColumns when unset).
		Columns:
		[
			{ Key: 'LabControlNumber', DisplayName: 'PSID' },
			{ Key: 'Name', DisplayName: 'Description' },
			{ Key: 'Status', DisplayName: 'Status', PictDashboard: { ValueTemplate: '{~SampleStatusName:Record.Payload.Status~}' } },
			{ Key: 'ReceivedFrom', DisplayName: 'Source' },
			// stopPropagation keeps a row click (where a list has one) from also firing, so a cmd-click opens one new tab.
			{ Key: 'QRCode', DisplayName: 'QR Code', PictDashboard: { ValueTemplate: '<a href="#/PSRS/Sample/View/{~D:Record.Payload.GUIDSample~}" onclick="event.stopPropagation()">{~D:Record.Payload.QRCode~}</a>' } },
			{ Key: 'LabReferenceNumber', DisplayName: 'Lab Reference #' },
			{ Key: 'ManufacturerCode', DisplayName: 'Manufacturer Code' },
		],
		// Status is a fixed vocabulary, not free text — offer the sample statuses as a labelled pick
		// list instead of the auto-generated free-entry Exact / Partial / Range inputs, so a filter
		// can't miss on a typo or wrong case. This mirrors the LIMS "Sample Status" filter exactly
		// (web/lims/config/LADOTD/sample-filter-manifest.json): a StringMatch (exact) clause rendered
		// as a Select2 whose { id, text } options show a friendly label while filtering on the stored
		// code. This is the HISTORICAL set, deliberately wider than what a sample form now offers: the
		// selectable vocabulary moved to the customer-managed SampleStatus table, but a filter still has
		// to reach samples stamped with a code since retired from that list.
		FieldFilterClauses:
		{
			Status:
			[
				{
					FilterKey: 'Status',
					ClauseKey: 'Status_Select_List',
					// Label heads the clause once added to the drawer; DisplayName is the button under the
					// "Status" field group in the Add-Filter popover (sibling to "Exact Match" on other fields).
					Label: 'Status',
					DisplayName: 'Is',
					Type: 'StringMatch',
					FilterByColumn: 'Status',
					ExactMatch: true,
					DataType: 'String',
					Ordinal: 1,
					PictForm:
					{
						InputType: 'Select2',
						SelectOptions:
						[
							{ id: 'N/A',  text: 'N/A' },
							{ id: 'LOGD', text: 'Logged' },
							{ id: 'RECV', text: 'Received' },
							{ id: 'INFO', text: 'Info' },
							{ id: 'PREA', text: 'Preauthorized' },
							{ id: 'PEND', text: 'Pending' },
							{ id: 'TEST', text: 'In Testing' },
							{ id: 'TSTR', text: 'Test Run' },
							{ id: 'FAIL', text: 'Failed' },
							{ id: 'FAIC', text: 'Failed with Comments' },
							{ id: 'PASS', text: 'Passed' },
							{ id: 'PASC', text: 'Passed with Comments' },
							{ id: 'VOID', text: 'Voided' }
						]
					}
				}
			]
		}
	},
	{
		Entity: 'SampleStatus',
		Label: 'Sample Statuses',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-clipboard-list',
		Keywords: 'sample status code state workflow logged received pending testing passed failed voided',
		Description: 'The sample statuses this customer can set on a sample.',
		// Admins look a status up by its code as often as by its label - the code is what shows on
		// exports and what the form field persists into Sample.Status.
		SearchFields: [ 'Name', 'Hash' ]
	},
	{
		Entity: 'Core',
		Label: 'Cores',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-circle-dot',
		Keywords: 'core sample drilled pavement',
		Description: 'Core samples.'
	},

	// --- Added so they register as recordsets and can anchor / target generated connections ---
	{
		Entity: 'LineItem',
		Label: 'Line Items',
		Domain: 'Projects & Contracts',
		Icon: 'fas fa-list-ol',
		Keywords: 'line item contract bid pay quantity contractor',
		Description: 'Contract line items — quantities, pay items, materials, and contractor links.',
		// Surface the operational scope (Contract / Project) and the mapped Bid Item as named columns.
		// IDContract / IDProject / IDBidItem render as their entity names via PSRS_FOREIGN_KEY_ENTITIES
		// (App-Web), which also makes them first-class entity-picker filters in the filter drawer.
		Columns:
		[
			{ Key: 'Name', DisplayName: 'Name' },
			{ Key: 'ItemNumber', DisplayName: 'Item Number' },
			{ Key: 'IDBidItem', DisplayName: 'Bid Item' },
			{ Key: 'IDContract', DisplayName: 'Contract' },
			{ Key: 'IDProject', DisplayName: 'Project' },
			{ Key: 'Status', DisplayName: 'Status' }
		]
	},
	{
		Entity: 'BidItem',
		Label: 'Bid Items',
		Domain: 'Projects & Contracts',
		Icon: 'fas fa-gavel',
		Keywords: 'bid item contract proposal award organization',
		Description: 'Contract bid items and their bidding organizations.',
		// Contract / Project (+ bidding Organization) render as entity names + first-class picker filters
		// via PSRS_FOREIGN_KEY_ENTITIES (App-Web).
		Columns:
		[
			{ Key: 'Name', DisplayName: 'Name' },
			{ Key: 'Description', DisplayName: 'Description' },
			{ Key: 'IDContract', DisplayName: 'Contract' },
			{ Key: 'IDProject', DisplayName: 'Project' },
			{ Key: 'Quantity', DisplayName: 'Quantity' },
			{ Key: 'IDOrganization', DisplayName: 'Organization' }
		]
	},
	{
		Entity: 'TestSpecificationRequirement',
		Label: 'Spec Requirements',
		Domain: 'Tests & Specifications',
		Icon: 'fas fa-clipboard-check',
		Keywords: 'test specification requirement threshold limit method',
		Description: 'Individual requirements within a test specification.'
	},
	{
		Entity: 'AssetType',
		Label: 'Asset Types',
		Domain: 'Physical Assets',
		Icon: 'fas fa-shapes',
		Keywords: 'asset type catalog bridge culvert sign physical infrastructure',
		Description: 'Types of physical asset (bridge, culvert, sign, …).'
	},
	{
		Entity: 'AssetClassification',
		Label: 'Asset Classifications',
		Domain: 'Physical Assets',
		Icon: 'fas fa-sitemap',
		Keywords: 'asset classification category physical infrastructure',
		Description: 'Classification buckets for physical assets.'
	},
	{
		Entity: 'PhysicalAssetElementType',
		Label: 'Asset Element Types',
		Domain: 'Physical Assets',
		Icon: 'fas fa-diagram-project',
		Keywords: 'element type aashto nbe section code unit bridge deck girder railing joint',
		Description: 'AASHTO element-type catalog (the element library) for asset inspection.',
		SearchFields: [ 'Name', 'Code', 'Section', 'SectionCode' ],
		// Which AASHTO defects apply to this element type (populated by the catalog Sync).
		ReadTabs: [ { Association: 'PhysicalAssetElementTypeDefect', Title: 'Defects' } ]
	},
	{
		Entity: 'PhysicalAssetMaterial',
		Label: 'Asset Materials',
		Domain: 'Physical Assets',
		Icon: 'fas fa-layer-group',
		Keywords: 'asset material element concrete steel prestressed reinforced timber masonry',
		Description: 'Materials an asset element is made of (AASHTO material classes).',
		// The friendly Material text column is skipped by the generator's list/picker heuristics — curate it.
		Columns:
		[
			{ Key: 'Code', DisplayName: 'Code' },
			{ Key: 'Material', DisplayName: 'Material' },
			{ Key: 'Description', DisplayName: 'Description' }
		],
		SearchFields: [ 'Code', 'Material', 'Description' ]
	},
	{
		Entity: 'PhysicalAssetDefect',
		Label: 'Asset Defects',
		Domain: 'Physical Assets',
		Icon: 'fas fa-triangle-exclamation',
		Keywords: 'defect aashto condition state corrosion cracking connection damage distortion',
		Description: 'AASHTO defect catalog with per-condition-state descriptions.',
		SearchFields: [ 'Name', 'Code' ],
		// The element types this defect applies to (reciprocal of the element-type Defects tab).
		ReadTabs: [ { Association: 'PhysicalAssetElementTypeDefect', Title: 'Element Types' } ]
	},
	{
		Entity: 'PhysicalAsset',
		Label: 'Physical Assets',
		Domain: 'Physical Assets',
		Icon: 'fas fa-cube',
		Keywords: 'physical asset bridge culvert instance inventory structure',
		Description: 'The physical asset inventory (bridges, culverts, …). Open one for its workspace.',
		Columns:
		[
			{ Key: 'Name', DisplayName: 'Name' },
			{ Key: 'AssetNumber', DisplayName: 'Asset #' },
			{ Key: 'ExternalSyncGUID', DisplayName: 'Structure' },
			{ Key: 'YearBuilt', DisplayName: 'Year Built' }
		],
		SearchFields: [ 'Name', 'AssetNumber', 'ExternalSyncGUID' ],
		// Externally synced — not hand-authored here. Hides the list "+ New"; the router sends the generic
		// Edit route to the (view-only) workspace and Create back to the list.
		NoCreate: true
	},
	{
		Entity: 'Inspection',
		Label: 'Inspections',
		Domain: 'Physical Assets',
		Icon: 'fas fa-clipboard-check',
		Keywords: 'inspection bridge culvert routine NSTM underwater scour scheduled dossier condition survey field asset',
		Description: 'Scheduled and dynamic asset inspections — open one for its workspace (assets, document dossier, inspectors, timeline).',
		Columns:
		[
			{ Key: 'Name', DisplayName: 'Name' },
			{ Key: 'StatusDisplay', DisplayName: 'Status' },
			{ Key: 'ScheduledStartDate', DisplayName: 'Scheduled' },
			{ Key: 'DeadlineDate', DisplayName: 'Deadline' }
		],
		SearchFields: [ 'Name', 'Description' ]
		// "+ New" opens the bespoke schedule screen: the router bridges /PSRS/Inspection/Create to
		// InspectionCreateWorkspace, which creates the asset join, the project scope and the document packet
		// through BridgeDocumentManager.createInspection(). (NoCreate was set here while only the generic
		// raw-schema form existed — that form produced inspections with no asset, project or documents.)
	}
];

// Duplicate read-tab resolution. The schema-graph generator (Connections.generated.js) emits BOTH a
// direct-FK child list AND a join-table association for an entity pair that has both, so three read views
// showed two tabs with the SAME title (audited 2026-09-05, verified against live data). Resolve each per
// the data + the product decision:
//   • LineItem "Samples": the FK Sample.IDLineItem is effectively unpopulated (1 row app-wide) so the child
//     list is always empty — drop it; the LineItemSample join association (SampleLineItemJoin) holds the data.
//   • TestSpecificationSet "Pay Items": the FK child list and the join association return the IDENTICAL set
//     (redundant) — drop the child list; keep the PayItemTestSpecificationSet association.
//   • Lab "Test Instances": the FK child list (TestInstance.IDLab — the instance's primary lab, ~838k) and
//     the join association (TestInstanceLabJoin, ~380k) are DIFFERENT and both real — keep BOTH, and rename
//     the join tab to "Linked Test Instances" so the two are distinguishable.
const READ_TAB_OVERRIDES =
{
	LineItem:             { DropChildLists: [ { RecordSet: 'Sample',  FilterField: 'IDLineItem' } ] },
	TestSpecificationSet: { DropChildLists: [ { RecordSet: 'PayItem', FilterField: 'IDTestSpecificationSet' } ] },
	Lab:                  { RenameReadTabs: [ { Association: 'LabTestInstance', Title: 'Linked Test Instances' } ] },
};

/**
 * Resolve the duplicate read tabs described by READ_TAB_OVERRIDES: drop the named child lists and/or rename
 * the named association tabs. Clones only the arrays/entries it changes, so the shared generated connection
 * objects (EntityConnections) are never mutated.
 * @param {Object} pEntry - a catalog entry (post applyConnectionDefaults).
 * @return {Object} the entry with duplicate tabs resolved.
 */
function applyReadTabOverrides(pEntry)
{
	const tmpOverride = READ_TAB_OVERRIDES[pEntry.Entity];
	if (!tmpOverride) { return pEntry; }
	const tmpResult = Object.assign({}, pEntry);
	if (Array.isArray(tmpOverride.DropChildLists) && Array.isArray(tmpResult.ChildLists))
	{
		tmpResult.ChildLists = tmpResult.ChildLists.filter((pChild) =>
			!tmpOverride.DropChildLists.some((pDrop) => (pDrop.RecordSet === pChild.RecordSet) && (pDrop.FilterField === pChild.FilterField)));
	}
	if (Array.isArray(tmpOverride.RenameReadTabs) && Array.isArray(tmpResult.ReadTabs))
	{
		tmpResult.ReadTabs = tmpResult.ReadTabs.map((pTab) =>
		{
			const tmpRename = tmpOverride.RenameReadTabs.find((pRename) => pRename.Association === pTab.Association);
			return tmpRename ? Object.assign({}, pTab, { Title: tmpRename.Title }) : pTab;
		});
	}
	return tmpResult;
}

module.exports = CATALOG.map(applyConnectionDefaults).map(applyReadTabOverrides);

},{"./Connections.generated.js":1289}],1291:[function(require,module,exports){
/**
 * Headlight Platform Configuration — Master List association registry.
 *
 * The many-to-many joins between managed entities, GENERATED from the live schema graph
 * (lib/headlight_model/json/Headlight.json) by build-connections.js — see Connections.generated.js.
 * pict-section-recordset reads these (registered into its RecordSetAssociationManager) and a record's
 * read view shows an embedded Association editor tab for any recordset that opts in via `ReadTabs`
 * (defaulted per entity from the same generated file; see Headlight-MasterLists.js).
 *
 * Regenerate after a schema change or a Connection-Curation.js edit:
 *   node source/master-lists/build-connections.js
 *
 * The richer, runtime-context associations (Project↔ObservationManifest name-keyed synthesis + defaults,
 * Project↔User role scope) stay registered INLINE in PlatformConfiguration-Application-Web.js — they close
 * over the app's REST client, so they can't live in a static file. They are excluded from generation
 * (Connection-Curation.ExcludeJoins) so nothing collides.
 */

const { ASSOCIATIONS } = require('./Connections.generated.js');

module.exports = { ASSOCIATIONS };

},{"./Connections.generated.js":1289}],1292:[function(require,module,exports){
/**
 * Headlight Platform Configuration — Master List builder.
 *
 * Turns the data-driven master-list catalog (Headlight-MasterLists.js, or any array of
 * the same shape loaded later from a ConfigFragment) into the two artifacts the app
 * needs: pict-section-recordset configurations and a navigation section.
 *
 * Lists run "manifest-less": with no RecordSetListManifestOnly flag and no manifest,
 * pict-section-recordset pulls the column set and the create / edit / view forms from
 * the entity's /1.0/<Entity>/Schema endpoint. A curated Columns array (optional, per
 * entry) overrides the auto-generated columns.
 */

const DEFAULT_URL_PREFIX = '/1.0/';

/**
 * Is this a usable catalog entry (has a non-empty Entity name)?
 * @param {Object} pEntry - a master-list catalog entry.
 * @return {Boolean}
 */
function isValidEntry(pEntry)
{
	return !!(pEntry && typeof pEntry.Entity === 'string' && pEntry.Entity.length > 0);
}

/**
 * Does this column key name another record's ID (IDMaterial, CreatingIDUser, SampleDetails.IDProject)? The record's own
 * primary key (IDSample on Sample) does not count.
 * @param {String} pKey - a list column's Key.
 * @param {String} pEntity - the list's entity.
 * @return {Boolean}
 */
function isForeignKeyColumn(pKey, pEntity)
{
	const tmpField = String(pKey || '').split('.').pop();
	return /^([A-Z][a-z]+)?ID[A-Z]/.test(tmpField) && (tmpField !== `ID${ pEntity }`);
}

/**
 * The list columns for a sortable entry, with every foreign-key column left plain: it shows the linked record's name
 * but would sort by the hidden ID. A column that sets Sortable itself keeps it. Other entries' columns pass through.
 * @param {Array<Object|String>} pColumns - an entry's Columns (objects, or bare keys).
 * @param {Object} pEntry - the master-list catalog entry.
 * @return {Array<Object|String>} a new array; columns that change are copies.
 */
function markForeignKeyColumnsUnsortable(pColumns, pEntry)
{
	if (!pEntry || (pEntry.Sortable !== true))
	{
		return pColumns.slice();
	}
	return pColumns.map((pColumn) =>
	{
		const tmpKey = (typeof pColumn === 'string') ? pColumn : (pColumn && pColumn.Key);
		if (!isForeignKeyColumn(tmpKey, pEntry.Entity) || ((typeof pColumn === 'object') && (typeof pColumn.Sortable === 'boolean')))
		{
			return pColumn;
		}
		const tmpColumn = (typeof pColumn === 'string') ? { Key: pColumn, DisplayName: pColumn } : Object.assign({}, pColumn);
		tmpColumn.Sortable = false;
		return tmpColumn;
	});
}

/**
 * The registered pict-view identifier for a (parent, child) FK child-list tab. The builder points a
 * { Type: 'View' } read tab at it; PlatformConfiguration-Application-Web.js registers one ChildListTab
 * instance under the same id. Keyed by FilterField too, so a parent with two FK children on the same
 * entity (different foreign keys) gets distinct instances.
 * @param {String} pParentEntity - the entity whose read view hosts the tab.
 * @param {Object} pChildSpec - a ChildLists entry { RecordSet, FilterField, ... }.
 * @return {String}
 */
function childListViewId(pParentEntity, pChildSpec)
{
	return `RSP-ChildList-${ pParentEntity }-${ pChildSpec.RecordSet }-${ pChildSpec.FilterField }`;
}

/**
 * Build an entry's combined read-tab list: an Association editor tab per join (ReadTabs) followed by a
 * filtered child-list tab per FK child (ChildLists → a { Type: 'View' } tab at a ChildListTab instance).
 * @param {Object} pEntry - a master-list catalog entry.
 * @return {Array} RecordSetReadTabs entries.
 */
function buildReadTabs(pEntry)
{
	const tmpTabs = [];
	(Array.isArray(pEntry.ReadTabs) ? pEntry.ReadTabs : []).forEach((pTab) =>
	{
		tmpTabs.push({ Type: 'Association', Association: pTab.Association, Title: pTab.Title });
	});
	(Array.isArray(pEntry.ChildLists) ? pEntry.ChildLists : []).forEach((pChild) =>
	{
		tmpTabs.push({ Type: 'View', View: childListViewId(pEntry.Entity, pChild), Title: pChild.Title });
	});
	// Bespoke view tabs — a { View, Title } pointing at a hand-registered view (e.g. SpecSetMaterials).
	(Array.isArray(pEntry.ViewTabs) ? pEntry.ViewTabs : []).forEach((pViewTab) =>
	{
		if (pViewTab && pViewTab.View) { tmpTabs.push({ Type: 'View', View: pViewTab.View, Title: pViewTab.Title || pViewTab.View }); }
	});
	return tmpTabs;
}

/**
 * Build a pict-section-recordset configuration for a single master-list entry.
 * @param {Object} pEntry - a master-list catalog entry (see Headlight-MasterLists.js).
 * @return {Object} a recordset configuration for loadRecordSetConfigurationArray.
 */
function buildRecordSetConfiguration(pEntry)
{
	const tmpConfiguration =
	{
		'RecordSet': pEntry.Entity,

		'RecordSetType': 'MeadowEndpoint',
		'RecordSetMeadowEntity': pEntry.Entity,

		'RecordSetURLPrefix': pEntry.URLPrefix || DEFAULT_URL_PREFIX,
		'Title': pEntry.Label || pEntry.Entity,
		'SearchFields': Array.isArray(pEntry.SearchFields) ? pEntry.SearchFields : [ 'Name' ]
	};

	// pict-section-recordset applies RecordSetDefaultFilter only when the list route names no /FilteredTo/ of its own.
	if ((typeof pEntry.DefaultFilter === 'string') && (pEntry.DefaultFilter.length > 0))
	{
		tmpConfiguration.RecordSetDefaultFilter = pEntry.DefaultFilter;
	}

	// Clickable column headers; the sort rides the list route's FSF stanza, so it runs server-side across every page.
	if (pEntry.Sortable === true)
	{
		tmpConfiguration.RecordSetListSortable = true;
	}

	// Quick filters are opt-in in this app (ComplexFilterProvider), so a list shows the bar only when its entry names them.
	if (Array.isArray(pEntry.QuickFilters) && (pEntry.QuickFilters.length > 0))
	{
		tmpConfiguration.QuickFilters = pEntry.QuickFilters.slice();
	}

	// A curated column list is optional — omitting it lets pict-section-recordset
	// generate columns from the Meadow schema (the "auto for everything" default).
	if (Array.isArray(pEntry.Columns) && (pEntry.Columns.length > 0))
	{
		tmpConfiguration.RecordSetListColumns = markForeignKeyColumnsUnsortable(pEntry.Columns, pEntry);
	}

	// Optional advanced-filter overrides, passed straight through to the recordset provider
	// (RecordSet-RecordProvider-MeadowEndpoints reads both off its options):
	//   Filters            — per-field customization MERGED onto an auto-generated clause; for a
	//                        foreign key this is the picker, so widening ExternalFilterByColumns lets
	//                        the picker be found by more than Name (e.g. a material's code columns).
	//   FieldFilterClauses — a per-field REPLACEMENT clause array; when present the module skips its
	//                        auto-generated clauses for that field entirely (e.g. swap a free-entry
	//                        Exact/Partial/Range set for a single pick-list clause).
	if (pEntry.Filters && (typeof pEntry.Filters === 'object'))
	{
		tmpConfiguration.Filters = pEntry.Filters;
	}
	if (pEntry.FieldFilterClauses && (typeof pEntry.FieldFilterClauses === 'object'))
	{
		tmpConfiguration.FieldFilterClauses = pEntry.FieldFilterClauses;
	}

	// Read tabs — an Association editor per join (ReadTabs) + a filtered child list per FK child
	// (ChildLists). ReadLayout defaults to 'Split': the record is the page, its connection tabs sit as a
	// right-justified strip on top; opening one reveals its editor beside the record (the app hides the
	// module's "Full Record" collapse toggle so only connection tabs show). Override with 'Tab' or 'Basic'.
	const tmpReadTabs = buildReadTabs(pEntry);
	if (tmpReadTabs.length > 0)
	{
		tmpConfiguration.ReadLayout = pEntry.ReadLayout || 'Split';
		tmpConfiguration.RecordSetReadTabs = tmpReadTabs;
	}
	else if (pEntry.ReadLayout)
	{
		tmpConfiguration.ReadLayout = pEntry.ReadLayout;
	}

	// Bulk association screens — a dedicated "Assign …" screen per listed association, reached at
	// #/PSRS/<Entity>/Associate/<Association>. Use this (instead of, or alongside, ReadTabs) when an
	// association is better managed in bulk than inline on each record. The builder also emits a
	// navigation entry for each (see buildCategorizedSections).
	if (Array.isArray(pEntry.BulkAssociations) && (pEntry.BulkAssociations.length > 0))
	{
		tmpConfiguration.RecordSetBulkAssociations = pEntry.BulkAssociations.map((pBulk) =>
			({ Association: pBulk.Association, Title: pBulk.Title }));
	}

	return tmpConfiguration;
}

/**
 * Build the recordset configuration array for a catalog of master-list entries.
 * @param {Array} pCatalog - array of master-list catalog entries.
 * @return {Array} recordset configurations.
 */
function buildRecordSetConfigurations(pCatalog)
{
	if (!Array.isArray(pCatalog))
	{
		return [];
	}
	return pCatalog.filter(isValidEntry).map(buildRecordSetConfiguration);
}

/**
 * Apply an entry's association-view choices to an already-built / live recordset configuration.
 *
 * The read-tab and bulk-screen surfaces are now cascading config (not code), but the live
 * recordset configs are built from the static seed at construction time — so when the merged
 * config arrives (or a save re-applies), these fields must be pushed onto the live config. This
 * sets RecordSetReadTabs + ReadLayout + RecordSetBulkAssociations, clearing them when the
 * corresponding array is empty (an emptied view list is a real "show none" intent — arrays
 * replace wholesale). Matrix / unlink screens are navigation-only (no recordset field) and are
 * handled by rebuilding the nav.
 * @param {Object} pLiveConfig - the live recordset configuration to mutate.
 * @param {Object} pEntry - a master-list catalog entry.
 * @return {Object} the mutated live configuration.
 */
function applyAssociationViewsToConfig(pLiveConfig, pEntry)
{
	if (!pLiveConfig || !pEntry)
	{
		return pLiveConfig;
	}

	const tmpReadTabs = buildReadTabs(pEntry);
	pLiveConfig.RecordSetReadTabs = tmpReadTabs;
	pLiveConfig.ReadLayout = pEntry.ReadLayout || ((tmpReadTabs.length > 0) ? 'Split' : 'Basic');

	const tmpBulk = Array.isArray(pEntry.BulkAssociations) ? pEntry.BulkAssociations : [];
	pLiveConfig.RecordSetBulkAssociations = tmpBulk.map((pBulk) =>
		({ Association: pBulk.Association, Title: pBulk.Title }));

	return pLiveConfig;
}

/**
 * Build a navigation child node for a single master-list entry.
 * @param {Object} pEntry - a master-list catalog entry.
 * @return {Object} a pict-section-navigation child node.
 */
function buildNavigationChild(pEntry)
{
	return (
	{
		Name: pEntry.Label || pEntry.Entity,
		Icon: pEntry.Icon || 'fas fa-list',
		Route: `#/PSRS/${pEntry.Entity}/List`,
		Keywords: pEntry.Keywords || '',
		Description: pEntry.Description || ''
	});
}

/**
 * Build the "Reference Data" navigation section holding every master list. A single,
 * non-disruptive section for now; the per-domain retool (using each entry's Domain)
 * is a deliberate later step.
 * @param {Array} pCatalog - array of master-list catalog entries.
 * @return {Object} a pict-section-navigation section node.
 */
function buildNavigationSection(pCatalog)
{
	const tmpChildren = (Array.isArray(pCatalog) ? pCatalog : []).filter(isValidEntry).map(buildNavigationChild);

	return (
	{
		Name: 'Reference Data',
		Icon: 'fas fa-database',
		Accent: 'var(--theme-color-brand-primary)',
		Blurb: 'Catalog and lookup lists the platform draws from.',
		Children:
		[
			{
				Name: 'Manage Lists',
				Icon: 'fas fa-sliders',
				Route: '#/MasterLists',
				Keywords: 'configure columns search master list settings curate',
				Description: 'Choose which columns and search fields each reference list shows.'
			}
		].concat(tmpChildren)
	});
}

/**
 * Build the Master Lists navigation section: a "Manage Lists" entry followed by every
 * list as its own discrete, directly-navigable entry (flat, alphabetical — like the home
 * app). The category is an organizing attribute used by the Manage Lists tool's rail, not
 * a navigation node, so the nav has no non-clickable "combined" group links. Marked
 * MasterListCategory so the registry can swap it at runtime. (`pCategories` is unused now
 * but kept for call-site compatibility.)
 * @param {Array} pEntries - master-list catalog entries (enabled).
 * @param {Array} [pCategories] - category metadata (unused; flat nav).
 * @return {Array} a one-section array for the navigation graph.
 */
function buildCategorizedSections(pEntries, pCategories)
{
	const tmpValidEntries = (Array.isArray(pEntries) ? pEntries : []).filter(isValidEntry);

	const tmpListChildren = tmpValidEntries
		.slice()
		.sort((pA, pB) => (pA.Label || pA.Entity).localeCompare(pB.Label || pB.Entity))
		.map(buildNavigationChild);

	// A flat nav entry for each opted-in standalone association SCREEN. A list opts a connection
	// into a screen by listing it under one of these fields; the route differs per screen type
	// (bulk is recordset-centric; matrix / unlink are association-centric, anchored to this list).
	const tmpScreenSpecifications =
	[
		{ Field: 'BulkAssociations',   Icon: 'fas fa-arrow-right-arrow-left', route: (pEntity, pAssociation) => `#/PSRS/${pEntity}/Associate/${pAssociation}` },
		{ Field: 'MatrixAssociations', Icon: 'fas fa-table-cells',            route: (pEntity, pAssociation) => `#/PSRS/AssociateMatrix/${pAssociation}/${pEntity}` },
		{ Field: 'UnlinkAssociations', Icon: 'fas fa-link-slash',             route: (pEntity, pAssociation) => `#/PSRS/AssociateUnlink/${pAssociation}/${pEntity}` }
	];
	const tmpScreenChildren = [];
	tmpValidEntries.forEach((pEntry) =>
	{
		tmpScreenSpecifications.forEach((pSpecification) =>
		{
			(Array.isArray(pEntry[pSpecification.Field]) ? pEntry[pSpecification.Field] : []).forEach((pScreen) =>
			{
				tmpScreenChildren.push(
				{
					Name: pScreen.Title || `${pEntry.Label || pEntry.Entity} associations`,
					Icon: pScreen.Icon || pSpecification.Icon,
					Route: pSpecification.route(pEntry.Entity, pScreen.Association),
					Keywords: `associate ${pEntry.Entity} ${pScreen.Association}`,
					Description: pScreen.Description || `Manage associations for ${pEntry.Label || pEntry.Entity}.`
				});
			});
		});
	});

	const tmpManageEntry =
	{
		Name: 'Manage Lists',
		Icon: 'fas fa-sliders',
		Route: '#/MasterLists',
		Keywords: 'configure columns search master list settings curate add remove category',
		Description: 'Add, remove, categorize and curate the reference lists.'
	};

	return (
	[
		{
			Name: 'Master Lists',
			Icon: 'fas fa-database',
			Accent: 'var(--theme-color-brand-primary)',
			Blurb: 'Catalog and lookup lists the platform draws from.',
			MasterListCategory: true,
			Children: [ tmpManageEntry ].concat(tmpListChildren).concat(tmpScreenChildren)
		}
	]);
}

module.exports =
{
	buildRecordSetConfiguration,
	buildRecordSetConfigurations,
	applyAssociationViewsToConfig,
	buildNavigationChild,
	buildNavigationSection,
	buildCategorizedSections,
	childListViewId,
	buildReadTabs,
	markForeignKeyColumnsUnsortable
};

},{}],1293:[function(require,module,exports){
/**
 * Headlight Platform Configuration — Master List categories + addable candidates.
 *
 * CATEGORIES: the domains a reference list can be filed under. They drive the grouping
 * in the Manage Lists tool and the Reference Data navigation tree (one node per
 * non-empty category).
 *
 * CANDIDATES: reference/catalog entities an admin can turn into a managed list from the
 * tool. These are entities NOT already managed by the app's built-in recordsets — a
 * curated, categorized starting set. (Any entity name can still be added by hand via
 * the tool's free-text field; this list is just the friendly menu.)
 */

const CATEGORIES =
[
	{ Name: 'Materials & Mixes', Icon: 'fas fa-cube' },
	{ Name: 'Products & Production', Icon: 'fas fa-industry' },
	{ Name: 'Organizations & People', Icon: 'fas fa-building' },
	{ Name: 'Projects & Contracts', Icon: 'fas fa-file-contract' },
	{ Name: 'Pay & Funding', Icon: 'fas fa-dollar-sign' },
	{ Name: 'Labs & Equipment', Icon: 'fas fa-flask' },
	{ Name: 'Tests & Specifications', Icon: 'fas fa-vial' },
	{ Name: 'Data & Assets', Icon: 'fas fa-layer-group' },
	{ Name: 'Physical Assets', Icon: 'fas fa-cubes' },
	{ Name: 'Reports & Dashboards', Icon: 'fas fa-chart-line' },
	{ Name: 'Academy', Icon: 'fas fa-graduation-cap' },
	{ Name: 'Lookups & Types', Icon: 'fas fa-tags' },
	{ Name: 'Uncategorized', Icon: 'fas fa-folder' }
];

const CANDIDATES =
[
	{ Entity: 'MixDesign', Label: 'Mix Designs', Domain: 'Materials & Mixes', Icon: 'fas fa-flask-vial' },
	{ Entity: 'MixSpecification', Label: 'Mix Specifications', Domain: 'Materials & Mixes', Icon: 'fas fa-clipboard-list' },
	{ Entity: 'Stockpile', Label: 'Stockpiles', Domain: 'Materials & Mixes', Icon: 'fas fa-mountain' },

	{ Entity: 'Contact', Label: 'Contacts', Domain: 'Organizations & People', Icon: 'fas fa-address-card' },

	{ Entity: 'ProjectOffice', Label: 'Project Offices', Domain: 'Projects & Contracts', Icon: 'fas fa-location-dot' },

	{ Entity: 'BidItem', Label: 'Bid Items', Domain: 'Pay & Funding', Icon: 'fas fa-gavel' },
	{ Entity: 'FundingSource', Label: 'Funding Sources', Domain: 'Pay & Funding', Icon: 'fas fa-hand-holding-dollar' },
	{ Entity: 'Fund', Label: 'Funds', Domain: 'Pay & Funding', Icon: 'fas fa-piggy-bank' },
	{ Entity: 'FundingCategory', Label: 'Funding Categories', Domain: 'Pay & Funding', Icon: 'fas fa-folder-tree' },
	{ Entity: 'Account', Label: 'Accounts', Domain: 'Pay & Funding', Icon: 'fas fa-book' },
	{ Entity: 'AccountType', Label: 'Account Types', Domain: 'Pay & Funding', Icon: 'fas fa-list-ul' },

	{ Entity: 'Equipment', Label: 'Equipment', Domain: 'Labs & Equipment', Icon: 'fas fa-screwdriver-wrench' },
	{ Entity: 'Device', Label: 'Devices', Domain: 'Labs & Equipment', Icon: 'fas fa-tablet-screen-button' },

	{ Entity: 'TestSpecificationSet', Label: 'Test Specification Sets', Domain: 'Tests & Specifications', Icon: 'fas fa-vials' },
	{ Entity: 'TestPlan', Label: 'Test Plans', Domain: 'Tests & Specifications', Icon: 'fas fa-list-check' },

	{ Entity: 'Module', Label: 'Modules', Domain: 'Data & Assets', Icon: 'fas fa-puzzle-piece' },
	{ Entity: 'Layer', Label: 'Layers', Domain: 'Data & Assets', Icon: 'fas fa-layer-group' },
	{ Entity: 'LayerSet', Label: 'Layer Sets', Domain: 'Data & Assets', Icon: 'fas fa-clone' },
	{ Entity: 'DataSet', Label: 'Data Sets', Domain: 'Data & Assets', Icon: 'fas fa-database' },

	{ Entity: 'ReportArchetype', Label: 'Report Archetypes', Domain: 'Reports & Dashboards', Icon: 'fas fa-file-lines' },
	{ Entity: 'Dashboard', Label: 'Dashboards', Domain: 'Reports & Dashboards', Icon: 'fas fa-gauge-high' },

	{ Entity: 'AcademyLearningProgression', Label: 'Learning Progressions', Domain: 'Academy', Icon: 'fas fa-road' },
	{ Entity: 'AcademyObjective', Label: 'Learning Objectives', Domain: 'Academy', Icon: 'fas fa-bullseye' },
	{ Entity: 'AcademyLesson', Label: 'Lessons', Domain: 'Academy', Icon: 'fas fa-chalkboard' },
	{ Entity: 'AcademyContent', Label: 'Lesson Content', Domain: 'Academy', Icon: 'fas fa-photo-film' },
	{ Entity: 'AcademyTips', Label: 'Tips', Domain: 'Academy', Icon: 'fas fa-lightbulb' },

	{ Entity: 'JobType', Label: 'Job Types', Domain: 'Lookups & Types', Icon: 'fas fa-tag' },
	{ Entity: 'ListDefault', Label: 'List Defaults', Domain: 'Lookups & Types', Icon: 'fas fa-list' },
	{ Entity: 'IntegrationAdapter', Label: 'Integration Adapters', Domain: 'Lookups & Types', Icon: 'fas fa-plug' }
];

module.exports = { CATEGORIES, CANDIDATES };

},{}],1294:[function(require,module,exports){
/**
 * Headlight Platform Configuration — navigation graph for pict-section-navigation.
 *
 * The category browser (the body nav). Every section carries an explicit, stable `Hash` so the header
 * topic pages (navigation-topics.js Scope arrays) bind to identity, not display name. Accents are pict
 * theme tokens, icons are Font Awesome classes, Routes are the app's hash routes. `Advanced` items are
 * hidden until "Show advanced" or a search; `Headlight: true` items are gated to the Headlight session.
 * `Module: '<Hash>'` / `Capability: '<Entity>-<Action>'` gate an entry by the current user's permissions
 * (the expression layer — PlatformConfiguration-Application-Web._navItemPermitted). PSRS `#/PSRS/<Entity>/List`
 * routes auto-derive `<Entity>-Read`, so only NON-PSRS entries need an explicit Module/Capability.
 *
 * Master lists are now placed EXPLICITLY here (static) rather than auto-injected: every reference/catalog
 * list the master-list catalog registers (recordsets + column config + the Manage Lists tool, unchanged)
 * is nav'd from one of the sections below. `composeGraph` therefore returns the static sections as-is —
 * the dynamic Reference-Data injection is retired (curating a list in Manage Lists no longer moves its nav
 * entry; it still governs that list's columns).
 */

const BASE_SECTIONS =
[
	{
		Name: 'Activity', Hash: 'activity', Icon: 'fas fa-chart-column', Accent: 'var(--theme-color-status-info)', Blurb: 'See what users are doing and get an overview of your data over time.',
		Children:
		[
			{ Name: 'Dashboards', Icon: 'fas fa-gauge-high', Route: '#/Dashboards/All', Keywords: 'dashboard dashboards kpi chart overview my samples lab queue waiting approvals role home landing', Description: 'The dashboards your roles give you — open one to see its charts and lists.' },
			{ Name: 'User Activity', Icon: 'fas fa-user-clock', Route: '#/UserActivity', Capability: 'User-Read', AlsoSuperUser: true, Keywords: 'user activity observation document comment approval create pressure temporal per day week month who what productivity engagement', Description: 'One user’s record-creation pressure over time — Observations, Documents, Comments and Document Approval actions by day, week or month.' },
			{ Name: 'User Logins', Icon: 'fas fa-right-to-bracket', Route: '#/UserLoginOverview', Capability: 'User-Read', AlsoSuperUser: true, Keywords: 'user login last sign in recency active idle dormant never roster who logged in adoption engagement', Description: 'Every user and when they last signed in, with an active / idle / dormant / never breakdown.' },
			{ Name: 'Project Activity', Icon: 'fas fa-folder-open', Route: '#/ProjectActivity', Capability: 'Project-Read', AlsoSuperUser: true, Keywords: 'project activity document observation line item create update stream temporal per day week month data overview recent', Description: 'A project’s Documents, Observations and Line Items created or updated over time, plus a recent-activity stream.' }
		]
	},
	{
		Name: 'People & Access', Hash: 'people-access', Icon: 'fas fa-user-shield', Accent: 'var(--theme-color-brand-primary)', Blurb: 'Who can sign in and what they can do.',
		Children:
		[
			{ Name: 'Users', Icon: 'fas fa-users', Route: '#/PSRS/User/List', Keywords: 'people accounts login email password impersonate', Description: 'User accounts, login credentials, email addresses, and names.' },
			{ Name: 'Teams', Icon: 'fas fa-users', Route: '#/PSRS/Team/List', Keywords: 'team crew lab group members roles enrollment shared ownership grant document access co-own people manager project access', Description: 'Groups of people, each in a role, that can be granted documents together. Members reach a granted document, and its project, without being added to the project.' },
			{ Name: 'Certifications', Icon: 'fas fa-award', Route: '#/Certifications', Capability: 'Certification-Read', Keywords: 'certification credential certify qualify sampler tester technician license expire start end date valid material lab equipment test bulk holder', Description: 'Certify holders (users, labs, materials, equipment, tests) in bulk for a certification type (with optional start/end dates), see + search + remove holders, and set what each type certifies-for.' },
			{ Name: 'Certification Types', Icon: 'fas fa-stamp', Route: '#/CertificationTypes', Capability: 'CertificationType-Read', Keywords: 'certification type credential setup configure manage catalog holder kind certifies for default validity entitlement definition verb hash', Description: 'Create and edit certification types and configure what each one certifies (holders) and certifies-for — driving a simplified certifying screen.' },
			{ Name: 'Access & Permissions', Icon: 'fas fa-user-shield', Route: '#/Access', Capability: 'Role-Read', Keywords: 'roles permission groups matrix assign grant deny effective visualizer rbac security capability context', Description: 'Manage roles, permission groups, the permission matrix, who has what, and per-user role assignment — all in one workspace.' },
				{ Name: 'Dashboard Access', Icon: 'fas fa-gauge', Route: '#/DashboardAccess', Capability: 'DashboardAccess-Configure', AlsoSuperUser: true, Keywords: 'dashboard access role roles see visible landing home page open first data filter limit restrict scope lims fieldbook ipad', Description: 'Choose which dashboards each role sees, the one they open first, and what data each dashboard shows them — in every app.' },
				{ Name: 'Who Can Open New Forms', Icon: 'fas fa-file-shield', Route: '#/FormAccess', Capability: 'FormAccess-Configure', AlsoSuperUser: true, Keywords: 'form document access grant new create role open edit owner ownership lab test assignment', Description: 'For each type of form, the roles that can open and edit a new one as soon as it is created, on any project.' },
				{ Name: 'Fieldbook Dashboards', Icon: 'fas fa-table-cells-large', Route: '#/FieldbookDashboards', Capability: 'DashboardAccess-Configure', AlsoSuperUser: true, Advanced: true, Keywords: 'dashboard fieldbook ipad classic sample plan new sample add project menu', Description: 'The classic dashboards this customer’s projects offer in Fieldbook, and whether the Sample Plan dashboard offers New Sample buttons.' },
				{ Name: 'Entitlements', Icon: 'fas fa-toggle-on', Route: '#/Entitlements', Capability: 'Role-Read', Keywords: 'entitlement feature task grant enable disable turn on off role group user setup simple lock down capability', Description: 'Turn config-app features on or off for a role, permission group, or user as plain tasks — no need to understand the permission matrix.' },
				{ Name: 'Clone Role', Icon: 'fas fa-clone', Route: '#/RoleClone', Capability: 'Role-Create', Keywords: 'clone copy duplicate role permission group grants edges variant railroad scope rbac make new from existing', Description: 'Duplicate an existing role or permission group — its permission grants and included roles carry over — then rename it as a new, independent role.' },
				{ Name: 'Customers', Icon: 'fas fa-city', Route: '#/Customers', Capability: 'Customer-Impersonate', AlsoSuperUser: true, Headlight: true, Keywords: 'manage customers impersonate configuration admin tenant super user support staff platform usage data view team assign employee modules customer team workspace dashboard', Description: 'The customers you can administer. Open one for its overview, users, modules, and team; Manage Configuration signs you in as its configuration admin. For level-5 super-admins and support staff with the impersonation entitlement.' },
				{ Name: 'Grants', Icon: 'fas fa-user-lock', Route: '#/GrantAccess', SuperUser: true, Keywords: 'grant access bootstrap permission grant super user platform level 5 seed first grantor chicken egg give user permission', Description: 'Platform super-users only: search any user across every customer and grant them Permission-Grant to bootstrap access administration.' },
				{ Name: 'Permission Groups', Icon: 'fas fa-layer-group', Route: '#/Access', Capability: 'Role-Read', Keywords: 'permission group bundle capability compose role rbac', Description: 'Reusable bundles of permissions composed into roles.' },
				{ Name: 'Roles (raw records)', Icon: 'fas fa-table-list', Route: '#/PSRS/Role/List', Keywords: 'security permission level table advanced', Advanced: true, Description: 'The underlying Role records as a raw table (advanced — the workspace is the managed view).' },
			{ Name: 'Role Permissions', Icon: 'fas fa-key', Route: '#/PSRS/RolePermission/List', Keywords: 'grant deny capability context', Advanced: true, Description: 'Granular permission hashes, allowed/denied flags, and context scoping per role.' },
			{ Name: 'Role Hierarchy', Icon: 'fas fa-sitemap', Route: '#/PSRS/RoleEdge/List', Keywords: 'edges inheritance parent child', Advanced: true, Description: 'Parent–child role relationships that build permission inheritance.' },
			{ Name: 'User Role Assignments', Icon: 'fas fa-user-tag', Route: '#/PSRS/UserRoleJoin/List', Keywords: 'assign proxy delegation', Advanced: true, Description: 'Assign roles to users and configure proxy role delegation.' }
		]
	},
	{
		Name: 'Support', Hash: 'customer-support', Icon: 'fas fa-headset', Accent: 'var(--theme-color-brand-primary)', Blurb: 'Log, triage, and resolve customer support calls.',
		Children:
		[
			{ Name: 'Support Console', Icon: 'fas fa-headset', Route: '#/Support', Capability: 'Support-Agent', AlsoSuperUser: true, Keywords: 'support console help desk ticket call case customer service triage resolve screenshot attachment agent issue bug password reset', Description: 'Log, triage, and work customer support calls. Each call is a document with its own approval workflow; screenshots and files attach as observations. For support staff with the Support-Agent entitlement (and platform super-users).' },
			{ Name: 'Support Runbooks', Icon: 'fas fa-book', Route: '#/Support/docs', Capability: 'Document-Update', AlsoSuperUser: true, Keywords: 'runbook runbooks support documentation knowledge base article markdown upload download bulk drag drop playbook platform customer edit author', Description: 'Create, edit, download, and bulk-upload support runbook / knowledge-base articles (markdown), to the platform or a customer scope. For users with the Document edit entitlement — opens the runbook manager only, not the triage console.' },
			{ Name: 'My Support Cases', Icon: 'fas fa-clipboard-list', Route: '#/SupportPortal', Capability: 'Support-View', AlsoSuperUser: true, Keywords: 'support cases my open tickets status updates portal customer view read-only self service track case help', Description: 'A read-only dashboard of your organization’s open support cases and the updates from the support team. For customer stakeholders with the Support-View entitlement.' },
		]
	},
	{
		Name: 'Projects', Hash: 'projects', Icon: 'fas fa-folder-open', Accent: 'var(--theme-color-status-success)', Blurb: 'Projects, their templates, and the contracts that group them.',
		Children:
		[
			{ Name: 'Projects', Icon: 'fas fa-folder-open', Route: '#/PSRS/Project/List', Keywords: 'job site inspection program status', Description: 'Projects, their status, external IDs, and associated configuration.' },
			{ Name: 'Project Types', Icon: 'fas fa-diagram-project', Route: '#/ProjectTypes', Capability: 'ProjectType-Read', Keywords: 'template lifecycle status default date change order prototype observation label setup', Description: 'Project lifecycle types — statuses, default dates, and each type’s prototype template (observation types, labels, forms) that new projects are cloned from.' },
			{ Name: 'Project Types (raw records)', Icon: 'fas fa-table-list', Route: '#/PSRS/ProjectType/List', Keywords: 'raw table advanced project type', Advanced: true, Description: 'The underlying ProjectType records as a raw table (advanced — the managed editor is the primary view).' },
			{ Name: 'Project Tag Types', Icon: 'fas fa-layer-group', Route: '#/PSRS/ProjectTagType/List', Keywords: 'tag category label', Advanced: true, Description: 'Which tag-type categories are available per project.' },
			{ Name: 'Contracts', Icon: 'fas fa-file-signature', Route: '#/PSRS/Contract/List', Keywords: 'contract bid project number award construction route', Description: 'Construction contracts — their project numbers, bid amounts, route limits, and the projects under each.' },
			{ Name: 'Contract Types', Icon: 'fas fa-file-contract', Route: '#/ContractTypes', Capability: 'ContractType-Read', Keywords: 'template lifecycle default date allowed project funding prototype setup', Description: 'Contract lifecycle types — statuses, default dates, allowed project types, default funding, and each type’s prototype template that new contracts are cloned from.' },
			{ Name: 'Contract Types (raw records)', Icon: 'fas fa-table-list', Route: '#/PSRS/ContractType/List', Keywords: 'raw table advanced contract type', Advanced: true, Description: 'The underlying ContractType records as a raw table (advanced — the managed editor is the primary view).' },
			{ Name: 'Project Clone', Icon: 'fas fa-clone', Route: '#/ProjectClone', Capability: 'Project-Create', Keywords: 'copy duplicate configuration', Advanced: true, Description: 'Copy a project’s configuration, links, and structure into a new project.' }
		]
	},
	{
		Name: 'Observations', Hash: 'observations', Icon: 'fas fa-clipboard-check', Accent: 'var(--theme-color-status-error)', Blurb: 'What gets collected in the field, and how it is approved.',
		Children:
		[
			{ Name: 'Observation Explorer', Icon: 'fas fa-magnifying-glass-chart', Route: '#/ObservationExplorer', Keywords: 'facet dashboard browse cross-filter type reporting document count distribution analytics fast solr search index', Description: 'A fast, faceted dashboard — cross-filter every observation by type and reporting status, with live counts over the whole search index.' },
			{ Name: 'Observation Types', Icon: 'fas fa-clipboard-check', Route: '#/PSRS/ObservationManifest/List', Keywords: 'manifest display category', Description: 'Observation manifests with display names, categories, and settings.' },
			{ Name: 'New Observation Type', Icon: 'fas fa-plus', Route: '#/ObservationType/New', Capability: 'ObservationManifest-Create', Keywords: 'create build manifest requirement clone', Description: 'Build a new observation type — its requirements and artifact types.' },
			{ Name: 'Observation Tags', Icon: 'fas fa-tags', Route: '#/PSRS/ObservationTag/List', Keywords: 'label classify', Description: 'Tag values classified by type, used for labeling observations.' },
			{ Name: 'Artifact Types', Icon: 'fas fa-puzzle-piece', Route: '#/PSRS/ArtifactType/List', Keywords: 'schemata data collection', Description: 'Artifact schemata used by observation types for data collection.' },
			{ Name: 'New Artifact Type', Icon: 'fas fa-plus', Route: '#/ArtifactType/New', Capability: 'ArtifactType-Create', Keywords: 'create build artifact schema field column', Description: 'Define a new artifact type — the fields/columns an observation collects.' },
			{ Name: 'Approval Workflow Editor', Icon: 'fas fa-diagram-project', Route: '#/ApprovalWorkflows', Keywords: 'visual graph state transition editor approval configuration', Description: 'Edit approval workflows visually as a state-transition graph (the configuration that drives observation approvals).' },
			{ Name: 'Approval Bindings', Icon: 'fas fa-link', Route: '#/ApprovalWorkflows/Bindings/Observation', Keywords: 'bind observation type workflow approval govern', Description: 'Bind each observation type to the approval workflow that governs it.' },
			{ Name: 'Approval Workflow', Icon: 'fas fa-diagram-project', Route: '#/PSRS/ObservationApprovalWorkflow/List', Keywords: 'transition state', Advanced: true, Description: 'State transitions for how observations move between approval statuses.' },
			{ Name: 'Approval States', Icon: 'fas fa-circle-nodes', Route: '#/PSRS/ObservationApprovalState/List', Keywords: 'draft submitted approved', Advanced: true, Description: 'Named approval states (Draft, Submitted, Approved…) for observations.' },
			{ Name: 'Approval Steps', Icon: 'fas fa-list-ol', Route: '#/PSRS/ObservationApprovalStep/List', Keywords: 'sequence role lock', Advanced: true, Description: 'Sequential approval steps scoped by observation type, with role requirements.' }
		]
	},
	{
		Name: 'Forms & Documents', Hash: 'documents', Icon: 'fas fa-file-lines', Accent: 'var(--theme-color-status-warning)', Blurb: 'Report and form templates, and how they are reviewed.',
		Children:
		[
			{ Name: 'Browse Documents', Icon: 'fas fa-folder-open', Route: '#/Documents/Browse', Keywords: 'browse list search filter report form document instance status approval project author date charts', Description: 'Browse, filter, and review every report and form — by type, status, project, author, and date, with a charts view.' },
			{ Name: 'Approval Throughput', Icon: 'fas fa-gauge-simple-high', Route: '#/DocumentThroughput', Capability: 'Document-Read', Keywords: 'approval throughput submitted approved turnaround velocity per month document type producer project submitter cycle time workflow reusable dashboard', Description: 'Submission and approval throughput over time for any document type — from the approval workflow history; break down by submitter, project, and more.' },
			{ Name: 'Document Types', Icon: 'fas fa-file-lines', Route: '#/PSRS/ReportNamedInstance/List', Keywords: 'report template default form definition named instance', Description: 'Report and form templates, default report settings, and hash identifiers.' },
			{ Name: 'Project Forms', Icon: 'fas fa-diagram-project', Route: '#/ReportProjectAssignment', Capability: 'ReportNamedInstance-Read', Keywords: 'report named instance project assignment link forms which documents', Description: 'Assign report/form definitions to projects and manage which forms each project uses.' },
			{ Name: 'Approval Workflow Editor', Icon: 'fas fa-diagram-project', Route: '#/ApprovalWorkflows', Keywords: 'visual graph state transition editor approval configuration', Description: 'Edit approval workflows visually as a state-transition graph (the configuration that drives document approvals).' },
			{ Name: 'Approval Bindings', Icon: 'fas fa-link', Route: '#/ApprovalWorkflows/Bindings', Keywords: 'bind document type workflow approval govern', Description: 'Bind each document type to the approval workflow that governs it.' },
			{ Name: 'Approval Workflow', Icon: 'fas fa-diagram-project', Route: '#/PSRS/DocumentApprovalWorkflow/List', Keywords: 'transition state', Advanced: true, Description: 'State transitions for how documents move between approval statuses.' },
			{ Name: 'Approval States', Icon: 'fas fa-circle-nodes', Route: '#/PSRS/DocumentApprovalState/List', Keywords: 'draft submitted approved', Advanced: true, Description: 'Named approval states (Draft, Submitted, Approved…) for documents.' },
			{ Name: 'Approval Steps', Icon: 'fas fa-list-ol', Route: '#/PSRS/DocumentApprovalStep/List', Keywords: 'sequence role lock hierarchy', Advanced: true, Description: 'Sequential approval steps with role requirements, locking, and hierarchy options.' },
			{ Name: 'Email Notifications', Icon: 'fas fa-envelope', Route: '#/EmailNotifications', Keywords: 'email rule notification notify alert schedule recipient status change handler', Description: 'Rules that send automated emails when documents change status or on a schedule.' },
			{ Name: 'Form Concierge', Icon: 'fas fa-wand-sparkles', Route: '#/FormConcierge', SuperUser: true, Keywords: 'form concierge plansheet author modify generate examples blueprint ai request', Description: 'Platform super-users only: drop files, describe a form, and have the plansheet pipeline create, update, or seed examples for it.' }
		]
	},
	{
		Name: 'Data Explorer', Hash: 'data-explorer', Icon: 'fas fa-sitemap', Accent: 'var(--theme-color-brand-primary)', Blurb: 'Browse the operational database as an expandable graph of records and their related collections.',
		Children:
		[
			{ Name: 'Operational Database', Icon: 'fas fa-diagram-project', Route: '#/DataExplorer', Keywords: 'explore tree graph drill records relationships browse customer project contract user organization observation', Description: 'Browse Customers, Projects, Contracts, Users and Organizations as an expandable tree of records and their related collections, each with a preview card.' }
		]
	},
	{
		Name: 'Configuration', Hash: 'configuration', Icon: 'fas fa-sliders', Accent: 'var(--theme-color-brand-primary)', Blurb: 'See where each configuration value comes from across scopes, edit it, and clone it between contexts.',
		Children:
		[
			{ Name: 'Configuration Explorer', Icon: 'fas fa-sliders', Route: '#/ConfigViewer', Keywords: 'config configuration cascade scope provenance global customer project user namespace override customproperties settings clone', Description: 'Browse cascading configuration with a per-value badge showing which scope set it (Global / Customer / Project / User); edit at a chosen scope and clone between contexts.' },
			{ Name: 'Clone Configuration', Icon: 'fas fa-copy', Route: '#/ConfigClone', Keywords: 'clone copy configuration namespace scope context customer project user migrate seed', Description: 'Copy a namespace’s configuration from one context (customer / project / user) to another.' },
			{ Name: 'Documentation', Icon: 'fas fa-book', Route: '#/Documentation', Keywords: 'documentation help docs manage edit content academy topic override platform default customer authoring', Description: 'Manage the in-app help — edit the platform-default topics (Headlight admins) or customize your customer’s own copy (customer admins), and author new topics.' }
		]
	},
	{
		Name: 'Master Lists', Hash: 'master-lists', Icon: 'fas fa-database', Accent: 'var(--theme-color-brand-primary)', Blurb: 'Core reference and catalog lists the platform draws from.',
		Children:
		[
			{ Name: 'External Organizations & Contractors', Icon: 'fas fa-building', Route: '#/PSRS/Organization/List', Keywords: 'contractor vendor agency organization external company', Description: 'Contractors and organizations with addresses, vendor codes, and approval status.' },
			{ Name: 'Certifications', Icon: 'fas fa-stamp', Route: '#/PSRS/CertificationType/List', Keywords: 'certification type credential DBE qualification', Description: 'Certification types and credentials.' },
			{ Name: 'Equipment', Icon: 'fas fa-screwdriver-wrench', Route: '#/PSRS/Equipment/List', Keywords: 'equipment machinery field plant', Description: 'Field equipment and machinery.' },
			{ Name: 'Materials', Icon: 'fas fa-cube', Route: '#/PSRS/Material/List', Keywords: 'material catalog aggregate concrete asphalt base source', Description: 'Base material catalog — aggregates, mixes, and source materials.' },
			{ Name: 'Pay Items', Icon: 'fas fa-dollar-sign', Route: '#/PSRS/PayItem/List', Keywords: 'pay item bid payment specification billing', Description: 'Bid / payment items and their linked test specification sets.' },
			{ Name: 'Personnel', Icon: 'fas fa-address-card', Route: '#/PSRS/Contact/List', Keywords: 'contact personnel people person staff', Description: 'Personnel and contacts linked to organizations.' },
			{ Name: 'Project Offices', Icon: 'fas fa-building', Route: '#/PSRS/ProjectOffice/List', Keywords: 'project office district region', Description: 'Regional and district project offices.' },
			{ Name: 'Import Data', Icon: 'fas fa-file-import', Route: '#/DataImport', Keywords: 'import upload csv excel tsv bulk material pay item equipment contact load file', Description: 'Bulk-import reference records (Materials, Pay Items, Equipment, …) from a CSV or Excel file.' }
		]
	},
	{
		Name: 'Contracts and Payments', Hash: 'contracts-payments', Icon: 'fas fa-dollar-sign', Accent: 'var(--theme-color-brand-secondary)', Blurb: 'Funding and financial reference data.',
		Children:
		[
			{ Name: 'Project Funding', Icon: 'fas fa-scale-balanced', Route: '#/Project/Funding', Capability: 'Project-Read', AlsoSuperUser: true, Keywords: 'project funding setup fund funding source category allocate line item accounting bucket configuration finance', Description: 'Configure a project’s funding — map funding sources, funds, and categories, allocate to line items, and see the accounting overview. Viewers read-only; configuring needs the funding entitlement.' },
			{ Name: 'Funding Sources', Icon: 'fas fa-building-columns', Route: '#/PSRS/FundingSource/List', Keywords: 'funding source federal state grant loan', Description: 'Funding sources for projects and contracts.' },
			{ Name: 'Accounts', Icon: 'fas fa-money-check-dollar', Route: '#/PSRS/Account/List', Keywords: 'account financial ledger budget', Description: 'Financial accounts.' },
			{ Name: 'Funds', Icon: 'fas fa-piggy-bank', Route: '#/PSRS/Fund/List', Keywords: 'fund balance cost center appropriation money pool', Description: 'Funds a funding source draws from (each carries a balance).' },
			{ Name: 'Funding Categories', Icon: 'fas fa-folder-tree', Route: '#/PSRS/FundingCategory/List', Keywords: 'funding category bucket classification participating non-participating', Description: 'Categories that classify how funding applies to line items.' },
			{ Name: 'Account Types', Icon: 'fas fa-list-ul', Route: '#/PSRS/AccountType/List', Keywords: 'account type kind ledger classification', Description: 'The kinds of financial account.' },
			{ Name: 'Import Contract Package', Icon: 'fas fa-folder-tree', Route: '#/ContractImport', Keywords: 'import contract project bid item line item package bulk upload csv excel workbook multi entity graph load file', Description: 'Bulk-import a whole Contract → Project → Bid Item → Line Item package from one sheet, a workbook, or a file per level — records interlink automatically and re-imports update in place.' },
			{ Name: 'Import Line Items', Icon: 'fas fa-list-check', Route: '#/ItemImport', Keywords: 'import bid item line item bulk upload csv excel add existing project contract many projects per row resolve match', Description: 'Add Bid Items and Line Items to existing Projects — each row matched to its Contract and Project by a column, so one file can span many projects.' }
		]
	},
	{
		Name: 'Materials Program', Hash: 'materials-program', Icon: 'fas fa-flask', Accent: 'var(--theme-color-status-info)', Blurb: 'Samples, tests, mixes, plants — the materials testing domain.',
		Children:
		[
			{ Name: 'Sample Plan', Icon: 'fas fa-clipboard-check', Route: '#/SamplePlan', Keywords: 'sample plan plimt material test rate frequency line item pay item section satisfaction certificate spec book', Description: 'Plan and review a project’s material sampling and testing across its line items — grouped by pay-item section or by line item, with satisfaction rollups and spec-book documentation.' },
			{ Name: 'Sample Plan Dashboard', Icon: 'fas fa-table-list', Route: '#/SamplePlanDashboard', Keywords: 'sample plan dashboard material line item samples rate frequency planned required bid installed quantity type units', Description: 'A read-only dashboard of a project’s planned material samples — each pay line item’s materials × sample types with their rate, frequency, quantities, and planned/required sample counts.' },
			{ Name: 'ATM Dashboard Config', Icon: 'fas fa-sliders', Route: '#/ATMDashboardConfig', Capability: 'MaterialsAudit-Configure', Advanced: true, Keywords: 'atm audit testing materials sample plan checklist dashboard configuration validation conformance columns pass fail cert unit', Description: 'Configure the Audit of Testing & Materials (Sample Plan Checklist) dashboard — its validation rules and which columns it shows, as a customer default or per-project override.' },
			{ Name: 'Samples', Icon: 'fas fa-vial', Route: '#/PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0', Keywords: 'sample field material specimen lims lab', Description: 'Field and material samples — newest first. Open one for the full sample workspace (details, line items, tests, documents, logs).' },
			{ Name: 'Samples List Columns', Icon: 'fas fa-table-columns', Route: '#/SampleListColumnsConfig', Capability: 'SampleListColumns-Configure', AlsoSuperUser: true, Advanced: true, Keywords: 'sample samples list columns configure display show hide label header rename reorder searchable customize grid table', Description: 'Choose which columns the Samples list shows and rename their headers — as a platform default, a customer-wide default, or your own preference.' },
			{ Name: 'Sample QR Codes', Icon: 'fas fa-qrcode', Route: '#/SampleQRCodeConfig', Capability: 'SampleQRCode-Configure', AlsoSuperUser: true, Advanced: true, Keywords: 'qr code sample configure format standard sitemanager legacy scan generate encode barcode label print', Description: 'Configure how new sample QR codes are generated for a customer — the standard format or the SiteManager/legacy format.' },
			{ Name: 'Sample Scanning', Icon: 'fas fa-barcode', Route: '#/SampleScanningConfig', Capability: 'SampleQRCode-Configure', AlsoSuperUser: true, Advanced: true, Keywords: 'scan scanner qr ipad fieldbook receive reception received location status lab check in', Description: 'Whether Fieldbook on iPad offers its QR scanner, and the status a sample takes when it is scanned into a location.' },
			{ Name: 'Where Records Open', Icon: 'fas fa-signs-post', Route: '#/EntityDestinations', Capability: 'EntityDestinations-Configure', AlsoSuperUser: true, Advanced: true, Keywords: 'qr code scan link destination route open landing lims role where records open', Description: 'Choose where a scanned QR label or an emailed link takes each person, by role and record state.' },
			{ Name: 'Test Instances', Icon: 'fas fa-microscope', Route: '#/PSRS/TestInstance/List', Keywords: 'test instance result run reading', Description: 'Recorded test instances and results.' },
			{ Name: 'Test Specifications', Icon: 'fas fa-vial', Route: '#/PSRS/TestSpecification/List', Keywords: 'test specification AASHTO ASTM requirement threshold', Advanced: true, Description: 'Individual test specifications within specification sets.' },
			{ Name: 'Test Specification Sets', Icon: 'fas fa-vials', Route: '#/PSRS/TestSpecificationSet/List', Keywords: 'test specification set group AASHTO ASTM', Advanced: true, Description: 'Grouped sets of test specifications.' },
			{ Name: 'Products', Icon: 'fas fa-box', Route: '#/PSRS/Product/List', Keywords: 'product manufactured producer finished goods', Description: 'Manufactured products linked to base materials and producers.' },
			{ Name: 'Production Plants', Icon: 'fas fa-industry', Route: '#/PSRS/ProductionPlant/List', Keywords: 'plant producer facility manufacturing site', Description: 'Producer manufacturing facilities and their addresses.' },
			{ Name: 'Mix Designs', Icon: 'fas fa-flask-vial', Route: '#/PSRS/MixDesign/List', Keywords: 'mix design formulation plant concrete asphalt', Description: 'Mix design formulations.' },
			{ Name: 'Mix Specifications', Icon: 'fas fa-file-lines', Route: '#/PSRS/MixSpecification/List', Keywords: 'mix specification requirement template', Description: 'Mix specification templates.' },
			{ Name: 'Assign Materials to Pay Items', Icon: 'fas fa-arrow-right-arrow-left', Route: '#/PSRS/PayItem/Associate/MaterialPayItem', Keywords: 'associate material pay item bulk assign', Advanced: true, Description: 'Bulk-assign materials to pay items.' },
			{ Name: 'Unlink Materials from Pay Items', Icon: 'fas fa-link-slash', Route: '#/PSRS/AssociateUnlink/MaterialPayItem/PayItem', Keywords: 'associate unlink material pay item remove', Advanced: true, Description: 'Bulk-remove material ↔ pay-item links.' },
			{ Name: 'Materials ⇄ Pay Items grid', Icon: 'fas fa-table-cells', Route: '#/PSRS/AssociateMatrix/MaterialPayItem/Material', Keywords: 'associate material pay item matrix grid cross link', Advanced: true, Description: 'Cross-link materials and pay items in a grid.' },
			{ Name: 'Labs', Icon: 'fas fa-flask', Route: '#/PSRS/Lab/List', Keywords: 'lab laboratory testing facility', Description: 'Testing laboratories — facilities, addresses, and hierarchy.' },
			{ Name: 'Locations', Icon: 'fas fa-location-dot', Route: '#/PSRS/Location/List', Keywords: 'location storage room shelf freezer building sample receive scan qr inside', Description: 'Places samples are kept — buildings, rooms, shelves. Open one to see what is inside it and which samples are there.' },
			{ Name: 'Lots', Icon: 'fas fa-boxes-stacked', Route: '#/PSRS/Lot/List', Keywords: 'lot batch material placement', Description: 'Material lots and batches.' },
			{ Name: 'Material Sample Tests', Icon: 'fas fa-flask', Route: '#/PSRS/Test/List', Keywords: 'test material sample method procedure', Description: 'Material sample test definitions.' },
		]
	},
	{
		Name: 'Physical Assets', Hash: 'physical-assets', Icon: 'fas fa-cubes', Accent: 'var(--theme-color-status-info)', Blurb: 'Bridges and other physical assets — the AASHTO catalog that describes them (element types, materials, defects) and the asset types.',
		Children:
		[
			{ Name: 'Inspection Schedule', Icon: 'fas fa-calendar-check', Route: '#/InspectionSchedule', Capability: 'Inspection-Read', Keywords: 'inspection schedule calendar program year month week agenda upcoming due deadline scheduled overdue routine nstm underwater bridge run plan tempo', Description: 'The program-level asset inspection schedule — every scheduled and dynamic inspection by year, month, week, or agenda; run the whole program from here.' },
			{ Name: 'Inspections', Icon: 'fas fa-clipboard-check', Route: '#/PSRS/Inspection/List', Capability: 'Inspection-Read', Keywords: 'inspection list browse bridge routine nstm underwater scour asset record dossier packet', Description: 'Browse every asset inspection; open one for its workspace (assets, document dossier, inspectors, teams, timeline).' },
			{ Name: 'Inspection Throughput', Icon: 'fas fa-gauge-simple-high', Route: '#/DocumentThroughput/Inspection-Dossier', Capability: 'Document-Read', Keywords: 'inspection throughput submitted approved dossier approval workflow turnaround velocity completed submissions per month compliance productivity submitter', Description: 'Dossier submission and approval throughput over time — the inspection program’s real completion rate, from the approval workflow.' },
			{ Name: 'Bridge Dashboard', Icon: 'fas fa-map-location-dot', Route: '#/AssetDashboard', Capability: 'PhysicalAsset-Read', Keywords: 'bridge asset dashboard map browse condition load rating geometry snbi visualize mapping inventory structure fhwa nbi explore', Description: 'Map, browse, and analyze the physical-asset (bridge) inventory by its SNBI data — condition, load rating, geometry, and more.' },
			{ Name: 'Sync AASHTO Catalog', Icon: 'fas fa-cloud-arrow-down', Route: '#/AssetCatalogSync', Capability: 'PhysicalAssetElementType-Create', AlsoSuperUser: true, Keywords: 'sync seed import aashto catalog public data lake element defect material baseline', Description: 'Seed this customer’s asset catalog from the shared public data lake (AASHTO standard).' },
			{ Name: 'Asset Types', Icon: 'fas fa-shapes', Route: '#/PSRS/AssetType/List', AlsoSuperUser: true, Keywords: 'asset type catalog bridge culvert sign workspace metadata shape custom properties edit', Description: 'Types of physical asset (bridge, culvert, sign, …).' },
			{ Name: 'Asset Classifications', Icon: 'fas fa-sitemap', Route: '#/PSRS/AssetClassification/List', AlsoSuperUser: true, Keywords: 'asset classification category', Description: 'Classification buckets for physical assets.' },
			{ Name: 'Element Types', Icon: 'fas fa-diagram-project', Route: '#/PSRS/PhysicalAssetElementType/List', AlsoSuperUser: true, Keywords: 'element type aashto nbe section code unit deck girder railing joint', Description: 'AASHTO element-type catalog (the element library).' },
			{ Name: 'Asset Materials', Icon: 'fas fa-layer-group', Route: '#/PSRS/PhysicalAssetMaterial/List', AlsoSuperUser: true, Keywords: 'asset material concrete steel prestressed reinforced timber masonry', Description: 'Materials an asset element is made of.' },
			{ Name: 'Defects', Icon: 'fas fa-triangle-exclamation', Route: '#/PSRS/PhysicalAssetDefect/List', AlsoSuperUser: true, Keywords: 'defect aashto condition state corrosion cracking connection', Description: 'AASHTO defect catalog with per-condition-state descriptions.' },
			{ Name: 'Asset Inventory', Icon: 'fas fa-cube', Route: '#/PSRS/PhysicalAsset/List', Capability: 'PhysicalAsset-Read', AlsoSuperUser: true, Keywords: 'asset inventory bridge instance browse element condition migrate', Description: 'Browse asset instances and their migrated element data; migrate a single asset.' }
		]
	},
	{
		Name: 'Data Lake', Hash: 'asset-management', Icon: 'fas fa-water', Accent: 'var(--theme-color-brand-secondary)', Secondary: true, Blurb: 'Imported clones and computed projections in your private data lake.',
		Children:
		[
			{ Name: 'Data Lake Catalog', Icon: 'fas fa-water', Route: '#/Datalake', Keywords: 'lake projection materialized dataset imported clone lastrada pipeline browse', Description: 'Browse imported clones and computed projections in your data lake.' },
			{ Name: 'New Projection', Icon: 'fas fa-plus', Route: '#/Datalake/New', Keywords: 'create projection extraction dataset lake materialize new', Description: 'Create a materialized projection from the Headlight data model.' },
			{ Name: 'Data Mapper', Icon: 'fas fa-diagram-project', Route: '#/DataMapper', Keywords: 'map mapper mapping operation transform source target column field beacon projection compile', Description: 'Visually define source→target field mappings — the operations that compile materialized projections.' },
			// Gated by the CustomerModuleJoin enablement (NOT the role-permission Module gate): `CustomerModule` is
			// evaluated by _customerHasModule() in the app's nav filter. Also shown to platform super-users.
			{ Name: 'Data Downloader', Icon: 'fas fa-cloud-arrow-down', Route: '#/Datalake/DataDownloader', CustomerModule: 'DOWNLOAD_DATA_DOWNLOADER', AlsoSuperUser: true, Keywords: 'download downloader desktop app installer offline bulk export data observations documents media dmg exe msi deb', Description: 'Download the Headlight Data Downloader desktop app for your platform.' }
		]
	},
	{
		Name: 'System', Hash: 'system', Icon: 'fas fa-gear', Accent: 'var(--theme-color-status-info)', Secondary: true, Blurb: 'Branding, customers, diagnostics, and platform administration.',
		Children:
		[
			{ Name: 'Branding & Labels', Icon: 'fas fa-image', Route: '#/MyHeadlight', Keywords: 'logo brand customer image upload appearance my headlight organization default project labels tag types', Description: 'Your organization’s logo, the branding shown across Headlight, and the default project labels new projects start with.' },
			{ Name: 'Web Error Log', Icon: 'fas fa-triangle-exclamation', Route: '#/ErrorLog', Keywords: 'error log diagnostics exception crash javascript fieldbook portal debug health', Advanced: true, Headlight: true, Description: 'Recent client-side errors reported by the Headlight web apps, charted per day with full stack traces.' },
			{ Name: 'Manage Lists', Icon: 'fas fa-sliders', Route: '#/MasterLists', Keywords: 'configure columns search master list settings curate add remove category', Advanced: true, Description: 'Add, remove, categorize and curate the reference lists and their columns.' },
			{ Name: 'Customer Provisioning', Icon: 'fas fa-wand-magic-sparkles', Route: '#/CustomerProvisioning', Keywords: 'new customer seed personas roles specs', Headlight: true, Description: 'Stand up a new customer environment in guided phases.' },
			{ Name: 'Service Versions', Icon: 'fas fa-code-branch', Route: '#/ServiceVersions', Keywords: 'version service application deploy release commit build platform internals diagnostics environment which version running', Headlight: true, AlsoSuperUser: true, Description: 'The version every Headlight service and application reports in this environment, grouped by kind, each linking to its commit.' },
			{ Name: 'Versions by Environment', Icon: 'fas fa-layer-group', Route: '#/ServiceVersionsMultiEnv', Keywords: 'version environment qa stg prod drift compare across mismatch service application deploy release internals diagnostics side by side', Headlight: true, AlsoSuperUser: true, Description: 'Every service and application version across QA, STG and PROD side by side, highlighting drift between environments.' }
		]
	}
];

/**
 * Compose the full navigation graph. Master lists are placed statically in BASE_SECTIONS now, so this is
 * an identity pass over the static sections — the `pReferenceSections` argument (still passed by the
 * MasterListRegistry's rebuildNav) is intentionally ignored. Kept as a function for call-site stability.
 * @param {Array} [pReferenceSections] - ignored (master-list nav is no longer dynamically injected).
 * @return {Array} the full navigation graph.
 */
function composeGraph(pReferenceSections)
{
	return BASE_SECTIONS.slice();
}

const tmpInitialGraph = composeGraph();
tmpInitialGraph.BaseSections = BASE_SECTIONS;
tmpInitialGraph.composeGraph = composeGraph;

module.exports = tmpInitialGraph;

},{}],1295:[function(require,module,exports){
/**
 * Headlight Platform Configuration — top-level header topics + KPI metadata.
 *
 * The header is a set of INDEPENDENT destinations. Each is a page with KPIs proximal to its function and
 * the category browser pre-filtered (Scope) to the relevant sections. `Settings` is the catch-all — the
 * full browser (no Scope, all KPIs, the navigation-style chooser) and the app's landing. KPI values come
 * from AppData.DashboardStats.*Count (see the app's loadDashboardStatsAsync). Anything flagged
 * `Headlight: true` is gated to the Headlight customer session (CustomerID === 1).
 */

// Each Dashboard count → display metadata. Keys match AppData.DashboardStats.*.
const KPI_META =
{
	CustomerCount:            { Label: 'Customers',         Icon: 'fas fa-city',              Accent: 'var(--theme-color-brand-primary, #156dd1)',  Headlight: true },
	UserCount:                { Label: 'Users',             Icon: 'fas fa-users',             Accent: 'var(--theme-color-status-info, #2b8aa7)' },
	RoleCount:                { Label: 'Roles',             Icon: 'fas fa-user-shield',       Accent: 'var(--theme-color-brand-primary, #156dd1)' },
	ProjectCount:             { Label: 'Projects',          Icon: 'fas fa-folder-open',       Accent: 'var(--theme-color-status-success, #3a9b5c)' },
	ProjectTypeCount:         { Label: 'Project Types',     Icon: 'fas fa-diagram-project',   Accent: 'var(--theme-color-status-info, #2b8aa7)' },
	ObservationManifestCount: { Label: 'Observation Types', Icon: 'fas fa-clipboard-check',   Accent: 'var(--theme-color-status-error, #cf5b5b)' },
	OrganizationCount:        { Label: 'Organizations',     Icon: 'fas fa-building',          Accent: 'var(--theme-color-status-warning, #d08a2c)' },
	DocumentTypeCount:        { Label: 'Document Types',    Icon: 'fas fa-file-lines',        Accent: 'var(--theme-color-status-warning, #d08a2c)' },
	ContractTypeCount:        { Label: 'Contract Types',    Icon: 'fas fa-file-contract',     Accent: 'var(--theme-color-brand-primary, #156dd1)' },
	MaterialCount:            { Label: 'Materials',         Icon: 'fas fa-cube',              Accent: 'var(--theme-color-status-info, #2b8aa7)' },
	PayItemCount:             { Label: 'Pay Items',         Icon: 'fas fa-dollar-sign',       Accent: 'var(--theme-color-status-success, #3a9b5c)' },
	SampleCount:              { Label: 'Samples',           Icon: 'fas fa-vial',              Accent: 'var(--theme-color-status-error, #cf5b5b)' },
	FundingSourceCount:       { Label: 'Funding Sources',   Icon: 'fas fa-building-columns',  Accent: 'var(--theme-color-brand-primary, #156dd1)' },
	AccountCount:             { Label: 'Accounts',          Icon: 'fas fa-money-check-dollar', Accent: 'var(--theme-color-status-warning, #d08a2c)' },
};

// The "<Entity-plural>/Count" endpoints fetched at login. A failed count degrades to '--'.
const KPI_ENDPOINTS =
[
	{ Key: 'CustomerCount', Endpoint: 'Customers/Count' },
	{ Key: 'UserCount', Endpoint: 'Users/Count' },
	{ Key: 'ProjectCount', Endpoint: 'Projects/Count' },
	{ Key: 'RoleCount', Endpoint: 'Roles/Count' },
	{ Key: 'ObservationManifestCount', Endpoint: 'ObservationManifests/Count' },
	{ Key: 'OrganizationCount', Endpoint: 'Organizations/Count' },
	{ Key: 'DocumentTypeCount', Endpoint: 'ReportNamedInstances/Count' },
	{ Key: 'ContractTypeCount', Endpoint: 'ContractTypes/Count' },
	{ Key: 'ProjectTypeCount', Endpoint: 'ProjectTypes/Count' },
	{ Key: 'MaterialCount', Endpoint: 'Materials/Count' },
	{ Key: 'PayItemCount', Endpoint: 'PayItems/Count' },
	{ Key: 'SampleCount', Endpoint: 'Samples/Count' },
	{ Key: 'FundingSourceCount', Endpoint: 'FundingSources/Count' },
	{ Key: 'AccountCount', Endpoint: 'Accounts/Count' },
];

// The headline platform counts shown on the Settings (full-browser) jumbotron.
const ALL_KPI_KEYS =
[
	'CustomerCount', 'UserCount', 'RoleCount', 'OrganizationCount',
	'ProjectCount', 'ProjectTypeCount',
	'ObservationManifestCount',
	'DocumentTypeCount', 'ContractTypeCount',
];

// Header topics. Scope = navigation-graph category hashes (the nav is pre-filtered to these). The
// 'Settings' topic is the catch-all (no Scope → everything) + the navigation-style chooser + the landing.
const TOPIC_CONFIGS =
{
	Settings:      { Key: 'Settings', Title: 'Settings', Icon: 'fas fa-gear', Blurb: 'Everything you can configure — search, or pick an area below.', Route: '#/Settings', Scope: null, KpiKeys: ALL_KPI_KEYS, ShowChooser: true },
	Users:         { Key: 'Users', Title: 'Users & Access', Icon: 'fas fa-user-shield', Blurb: 'Who can sign in and what they can do.', Route: '#/Users', Scope: [ 'people-access' ], KpiKeys: [ 'UserCount', 'RoleCount' ] },
	Projects:      { Key: 'Projects', Title: 'Projects & Contracts', Icon: 'fas fa-folder-open', Blurb: 'Units of work, their templates, and the contracts that group them.', Route: '#/Projects', Scope: [ 'projects' ], KpiKeys: [ 'ProjectCount', 'ProjectTypeCount', 'ContractTypeCount' ] },
	Observations:  { Key: 'Observations', Title: 'Observations', Icon: 'fas fa-clipboard-check', Blurb: 'What gets collected in the field, and how it is approved.', Route: '#/Observations', Scope: [ 'observations' ], KpiKeys: [ 'ObservationManifestCount' ] },
	Documents:     { Key: 'Documents', Title: 'Forms & Documents', Icon: 'fas fa-file-lines', Blurb: 'Report and form templates, and how they are reviewed.', Route: '#/Documents', Scope: [ 'documents' ], KpiKeys: [ 'DocumentTypeCount' ] },
	Database:      { Key: 'Database', Title: 'Database', Icon: 'fas fa-database', Blurb: 'Explore the operational data graph, plus the reference, materials, and financial data the platform draws from.', Route: '#/Database', Scope: [ 'data-explorer', 'configuration', 'master-lists', 'materials-program', 'contracts-payments', 'physical-assets' ], KpiKeys: [ 'MaterialCount', 'PayItemCount', 'SampleCount', 'FundingSourceCount', 'AccountCount' ] },
	Lake:          { Key: 'Lake', Title: 'Data Lake', Icon: 'fas fa-water', Blurb: 'Browse imported clones and computed projections, and create new projections from your Headlight data.', Route: '#/Datalake', Scope: [ 'asset-management' ], KpiKeys: [] },
};

// The top navbar order. (The navbar markup lives in html/index.html; this is the canonical order + targets.)
const TOP_NAV =
[
	{ Label: 'Settings', Icon: 'fas fa-gear', Route: '#/Settings' },
	{ Label: 'Users', Icon: 'fas fa-user-shield', Route: '#/Users' },
	{ Label: 'Projects', Icon: 'fas fa-folder-open', Route: '#/Projects' },
	{ Label: 'Observations', Icon: 'fas fa-clipboard-check', Route: '#/Observations' },
	{ Label: 'Documents', Icon: 'fas fa-file-lines', Route: '#/Documents' },
	{ Label: 'Database', Icon: 'fas fa-database', Route: '#/Database' },
	{ Label: 'Data Lake', Icon: 'fas fa-water', Route: '#/Datalake' },
];

/** Format a raw count for display (numbers get thousands separators; placeholders pass through). */
function formatCount(pValue)
{
	if (pValue == null) { return '—'; }
	if (pValue === '...') { return '…'; }
	const tmpNumber = Number(pValue);
	return Number.isNaN(tmpNumber) ? String(pValue) : tmpNumber.toLocaleString('en-US');
}

/**
 * Build KPI display records (data, not HTML) for a set of stat keys, dropping Headlight-gated KPIs for
 * non-Headlight sessions. Feeds the {~TS:Nav-Kpi-Card:~} strip.
 * @param {Object} pStats - AppData.DashboardStats
 * @param {Array<string>} pKeys
 * @param {boolean} pIsHeadlight
 * @returns {Array<{Key:string, Label:string, Icon:string, Accent:string, Value:string}>}
 */
function buildKpiRecords(pStats, pKeys, pIsHeadlight)
{
	const tmpStats = pStats || {};
	return (pKeys || [])
		.filter((pKey) => KPI_META[pKey] && (!KPI_META[pKey].Headlight || pIsHeadlight))
		.map((pKey) =>
		{
			const tmpMeta = KPI_META[pKey];
			return { Key: pKey, Label: tmpMeta.Label, Icon: tmpMeta.Icon, Accent: tmpMeta.Accent, Value: formatCount(tmpStats[pKey]) };
		});
}

// Shared KPI-card template (one small wide rectangle; no navigation).
const KPI_CARD_TEMPLATE =
{
	Hash: 'Nav-Kpi-Card',
	Template: /*html*/`<div class="nav-kpi-rect"><span class="nav-kpi-ic" style="color:{~D:Record.Accent~}"><i class="{~D:Record.Icon~}"></i></span><span class="nav-kpi-text"><span class="nav-kpi-val">{~D:Record.Value~}</span><span class="nav-kpi-lbl">{~D:Record.Label~}</span></span></div>`,
};

module.exports = { KPI_META, KPI_ENDPOINTS, ALL_KPI_KEYS, TOPIC_CONFIGS, TOP_NAV, formatCount, buildKpiRecords, KPI_CARD_TEMPLATE };

},{}],1296:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

/**
 * ObservationList — a net-new, Solr-backed, filterable observation list for the config app. Replaces the generic
 * pict-section-recordset list at #/PSRS/Observation/List (which HANGS scanning the ~21k-row Observations table) with
 * the fast `POST /1.0/ObservationsFilter/Index/{begin}/{cap}` search index Fieldbook uses (~70ms; the response's
 * {numFound, docs} carries type/date/author/project/artifact/doc-count so no per-row fetch is needed). Rows link to the
 * bespoke Observation workspace. Filters mirror the Fieldbook observation-list filter bar (v1): free-text, observation
 * types, authors, date range, in-reports (document count), project scope. Labels/tags (grouped by tag-type) are a
 * follow-up. This provider owns the fetch + the host-div paint; a thin ObservationList view supplies the host chrome.
 */
class ObservationListProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#ObservationList-Host';
		this._filter = { SearchText: '', Types: [], Authors: [], AuthorNames: {}, From: '', To: '', Inclusion: '', IDProject: 0, ProjectName: '', Labels: {}, MatchAllLabels: false };
		this._projectTagTypes = null;   // the selected project's tag-type vocabulary (Labels filter is project-scoped)
		this._activeTagType = '';       // which tag type the label-value picker searches
		this._page = 0;
		this._cap = 25;
		this._total = 0;
		this._rows = [];
		this._authorNames = {};
		this._typeOptions = null;    // [{Label, Names, Count}] — cached once grouped (see _typeGrouped)
		this._typeGrouped = false;   // true once the catalog mapped types to DisplayNames (else retry next load)
		this._loading = false;
		this._error = '';
		this._loaded = false;

		// --- view mode (one filter bar, three bodies): 'list' (paginated) | 'charts' (facet panels) | 'map' (next) ---
		this._viewMode = 'list';
		this._baseline = 0;                       // unfiltered customer total (KPI context; captured in _ensureTypeOptions)
		this._chartTypeCounts = {};               // RecordSubType -> count under the current (minus-type) filter
		this._rep = { b0: 0, b1: 0, b2plus: 0 };  // DocumentCount buckets under the current (minus-reporting) filter
		this._chartLatencyMs = 0;
		this._typeChartOrder = null;              // stable chart-bar order (fixed on first charts load, count desc)
		this._chartsLoaded = false;
		this._prevKPI = null;                     // previous KPI values for number tweening

		// --- map view (Leaflet + docked responsive sidebar; the same pattern as the bridge dashboard). The map plots
		// the most-recent _MAP_FETCH matches of the SHARED filter that carry a capture/user coordinate; clicking a point
		// shows that observation's detail in the docked side panel IN PLACE (no shell repaint) so the map never resets. ---
		this._map = null;                         // Leaflet map instance (window.L)
		this._mapMarkers = [];                    // [{ r, m, base }] — r = { doc, id, pt }, m = circleMarker, base = color
		this._mapRows = [];                       // fetched docs decorated with { doc, id, pt }
		this._mapMappable = [];                   // the subset of _mapRows that have a plottable coordinate
		this._mapFetched = 0;                     // how many docs we actually fetched (<= _MAP_FETCH)
		this._mapLoaded = false;                  // true once a map fetch has completed at least once
		this._mapDetail = 0;                      // IDRecord shown in the docked side panel (0 = legend/hint)
		this._mapDetailObs = null;                // the full hydrated Observation (with .Details) for _mapDetail, once fetched
		this._mapDetailObsID = 0;                 // which id _mapDetailObs holds (guards stale async loads)
		this._mapDetailSpec = null;               // its resolved ObservationSpecification (for schema-driven columns)
		this._mapDetailLoading = false;           // true while fetching the full observation for the side panel
		this._mapView = null;                     // { center, zoom } preserved across benign remounts (dropdown close, etc.)
		this._mapFitPending = false;              // true after a data load → the next mount fits the bounds; a benign repaint keeps the view
		this._typeColorByRST = null; this._typeColorForOptions = null;  // cached RecordSubType -> chart-palette color

		// --- embed mode: when >0, this screen is embedded in a Project workspace tab, locked to that project (the
		// Project filter is hidden and IDProject is forced) — see openInto()/exitEmbed(). ---
		this._embeddedProjectID = 0;
		this._typeDropdownOpen = false;           // Observation Types dropdown-checklist open/closed
		this._fullscreen = false;                 // standalone "full screen" — overlay the whole browser view (see toggleFullscreen)

		// Close the type dropdown on an outside click (capture phase so it runs before the button's own handler).
		if (typeof document !== 'undefined')
		{
			this._onDocClick = (pEvent) =>
			{
				if (!this._typeDropdownOpen) { return; }
				try { const dd = document.querySelector('.obl-typedd'); if (dd && !dd.contains(pEvent.target)) { this._typeDropdownOpen = false; this.render(); } } catch (pError) { /* */ }
			};
			document.addEventListener('click', this._onDocClick, true);
			// Esc leaves full screen (routed through toggleFullscreen so it gets the same repaint/map handling).
			this._onKeydown = (pEvent) => { if (pEvent.key === 'Escape' && this._fullscreen) { this.toggleFullscreen(); } };
			document.addEventListener('keydown', this._onKeydown);
		}

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('ObservationList-CSS', _CSS, 520);
		}
	}

	get cfg() { return this.options || {}; }
	get providerName() { return this.cfg.ProviderIdentifier || 'ObservationList'; }
	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get customerID() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }
	get L() { return (typeof window !== 'undefined' && window.L) ? window.L : null; }  // Leaflet — loaded globally in index.html

	_get(pURL) { return new Promise((resolve) => this.restClient.getJSON(pURL, (e, b) => resolve(e ? null : b))); }
	_post(pURL, pBody) { return new Promise((resolve) => this.restClient.postJSON(pURL, pBody, (e, b) => resolve(e ? null : b))); }
	_esc(pV) { return String(pV == null ? '' : pV).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
	_mediaUrl(pPath) { const rc = this.restClient; if (rc && (typeof rc.formatUrl === 'function')) { try { return rc.formatUrl(pPath); } catch (e) { /* */ } } return `/1.0/${pPath}`; }
	_fmtDate(pV) { if (!pV) { return ''; } try { const d = new Date(pV); if (!Number.isNaN(d.getTime())) { return d.toLocaleDateString(); } } catch (e) { /* */ } return String(pV).slice(0, 10); }
	_idOf(pDoc) { return pDoc.IDRecord || (pDoc.id ? Number(String(pDoc.id).replace(/^Observation_/, '')) : 0); }

	_fmt(pN) { return Math.round(Number(pN) || 0).toLocaleString(); }
	// Readable fallback label when the catalog DisplayName isn't available (e.g. slow ObservationManifests): split
	// CamelCase / acronyms into words — "LADOTDPersonnel" → "LADOTD Personnel", "SiteManagerWeather" → "Site Manager Weather".
	_prettyType(pS) { return String(pS || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2').replace(/_/g, ' ').replace(/\s+/g, ' ').trim(); }
	_compact(pN) { const n = Number(pN) || 0; if (n >= 1e6) { return `${(n / 1e6).toFixed(1)}M`; } if (n >= 1e3) { return `${Math.round(n / 1e3)}K`; } return String(n); }
	_facetPairs(pRes, pField) { const ff = pRes && pRes.facet_counts && pRes.facet_counts.facet_fields && pRes.facet_counts.facet_fields[pField]; const out = []; if (Array.isArray(ff)) { for (let i = 0; i < ff.length - 1; i += 2) { out.push([ ff[i], Number(ff[i + 1]) || 0 ]); } } return out; }

	// --- data ---
	// pExclude omits one dimension so a facet panel still shows the other values you could switch to (drill-down faceting).
	_buildBody(pExclude)
	{
		const f = this._filter; const b = {};
		if (f.IDProject) { b.IDProject = Number(f.IDProject); }
		if (f.SearchText && f.SearchText.trim()) { b.SearchText = f.SearchText.trim(); }
		if (f.Types && f.Types.length && pExclude !== 'type') { b.ObservationType = f.Types.slice(); }
		if (f.Authors && f.Authors.length) { b.IDAuthor = f.Authors.map(Number); }
		if (f.From && f.To) { b.DesignatedTime = { From: new Date(f.From).toISOString(), To: new Date(`${f.To}T23:59:59`).toISOString() }; }
		if (pExclude !== 'reporting')
		{
			if (f.Inclusion === '0') { b.DocumentCount = { Compare: '=', Value: 0 }; }
			else if (f.Inclusion === '1') { b.DocumentCount = { Compare: '=', Value: 1 }; }
			else if (f.Inclusion === '2') { b.DocumentCount = { Compare: '>=', Value: 2 }; }
		}
		// Labels — { TagType: [values] } → Solr <TagType>_Labelss:("v"). Only include non-empty types.
		const tmpLabels = {};
		Object.keys(f.Labels || {}).forEach((pType) => { const arr = (f.Labels[pType] || []).filter(Boolean); if (arr.length) { tmpLabels[pType] = arr; } });
		if (Object.keys(tmpLabels).length) { b.Labels = tmpLabels; if (f.MatchAllLabels) { b.MatchAllTags = true; } }
		return b;
	}

	async loadAsync()
	{
		this._loading = true; this._error = ''; this._loaded = true;
		this.render();
		try
		{
			await this._ensureTypeOptions();
			if (this._viewMode === 'charts') { await this._loadChartsAsync(); }
			else if (this._viewMode === 'map') { await this._loadMapAsync(); }
			else { await this._loadListAsync(); }
		}
		catch (pError) { this._error = (pError && pError.message) || String(pError); this._rows = []; this._total = 0; }
		this._loading = false;
		this.render();
	}

	async _loadListAsync()
	{
		const tmpBody = this._buildBody();
		const tmpResult = await this._post(`ObservationsFilter/Index/${this._page * this._cap}/${this._cap}`, tmpBody);
		if (!tmpResult) { throw new Error('The observation search did not respond.'); }
		this._rows = Array.isArray(tmpResult.docs) ? tmpResult.docs : [];
		this._total = (typeof tmpResult.numFound === 'number') ? tmpResult.numFound : this._rows.length;
		await this._resolveAuthors();
	}

	// Charts view — REAL server-side drill-down faceting: one facet POST per panel (excluding its own dimension so it
	// still offers the other values you could switch to) + one for the filtered total, all in parallel; the badge shows
	// the true round-trip. Clicking a bar sets the SAME shared filter the list and map use.
	async _loadChartsAsync()
	{
		const tmpT0 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
		const [ tmpTypeRes, tmpRepRes, tmpTotalRes ] = await Promise.all([
			this._post('ObservationsFilter/Index/0/0', Object.assign(this._buildBody('type'), { Facets: [ 'RecordSubType' ] })),
			this._post('ObservationsFilter/Index/0/0', Object.assign(this._buildBody('reporting'), { Facets: [ 'DocumentCount' ] })),
			this._post('ObservationsFilter/Index/0/0', this._buildBody()),
		]);
		const tmpT1 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
		this._chartLatencyMs = Math.max(1, Math.round(tmpT1 - tmpT0));

		this._chartTypeCounts = {};
		this._facetPairs(tmpTypeRes, 'RecordSubType').forEach(([ rst, cnt ]) => { if (rst) { this._chartTypeCounts[rst] = cnt; } });

		const tmpRep = { b0: 0, b1: 0, b2plus: 0 };
		this._facetPairs(tmpRepRes, 'DocumentCount').forEach(([ v, cnt ]) => { const n = Number(v); if (n <= 0) { tmpRep.b0 += cnt; } else if (n === 1) { tmpRep.b1 += cnt; } else { tmpRep.b2plus += cnt; } });
		this._rep = tmpRep;

		this._total = (tmpTotalRes && typeof tmpTotalRes.numFound === 'number') ? tmpTotalRes.numFound : 0;

		if (!this._typeChartOrder && this._typeOptions)
		{
			this._typeChartOrder = this._typeOptions
				.map((g) => ({ label: g.Label, c: g.Names.reduce((a, n) => a + (this._chartTypeCounts[n] || 0), 0) }))
				.sort((a, b) => (b.c - a.c)).map((x) => x.label);
		}
		this._chartsLoaded = true;
	}

	// Map view — the SAME search index the list/charts use (the docs carry Capture/User lat/long directly, so no per-row
	// hydration is needed). We fetch the most-recent _MAP_FETCH matches of the shared filter and plot those with a real
	// coordinate; DateOfRecord-desc means "the most recent N" when the match set is larger than the cap.
	async _loadMapAsync()
	{
		const tmpBody = this._buildBody();
		const tmpResult = await this._post(`ObservationsFilter/Index/0/${_MAP_FETCH}`, tmpBody);
		if (!tmpResult) { throw new Error('The observation search did not respond.'); }
		const tmpDocs = Array.isArray(tmpResult.docs) ? tmpResult.docs : [];
		this._total = (typeof tmpResult.numFound === 'number') ? tmpResult.numFound : tmpDocs.length;
		this._rows = tmpDocs;   // reuse the list plumbing (author resolution) — not rendered as a table in map mode
		this._mapFetched = tmpDocs.length;
		this._mapRows = tmpDocs.map((d) => ({ doc: d, id: this._idOf(d), pt: this._pointOf(d) }));
		this._mapMappable = this._mapRows.filter((r) => r.pt);
		await this._resolveAuthors();
		// If the open detail is no longer in the filtered/mapped set, close it (its marker is gone).
		if (this._mapDetail && !this._mapMappable.some((r) => r.id === this._mapDetail)) { this._mapDetail = 0; }
		this._mapLoaded = true;
		this._mapFitPending = true;   // a fresh data set → the next mount should fit the map to it
	}

	// Capture (device / EXIF) coordinate, falling back to the user coordinate; 0/near-0 is the "no location" sentinel.
	_pointOf(pDoc)
	{
		const f = (pLat, pLng) =>
		{
			const lat = parseFloat(pLat); const lng = parseFloat(pLng);
			if (!Number.isFinite(lat) || !Number.isFinite(lng)) { return null; }
			if ((Math.abs(lat) < 0.0000001) && (Math.abs(lng) < 0.0000001)) { return null; }
			if ((Math.abs(lat) > 90) || (Math.abs(lng) > 180)) { return null; }
			return { lat: lat, lng: lng };
		};
		return f(pDoc.CaptureLatitude, pDoc.CaptureLongitude) || f(pDoc.UserLatitude, pDoc.UserLongitude);
	}

	// A stable color per observation-type group, matching the Charts palette (position in _typeOptions → _CAT), so the
	// map, the type dropdown counts, and the charts all read the same. Rebuilt whenever _typeOptions is re-derived.
	_typeColorMap()
	{
		if (this._typeColorByRST && this._typeColorForOptions === this._typeOptions) { return this._typeColorByRST; }
		const tmpMap = {};
		(this._typeOptions || []).forEach((g, i) => { const c = _CAT[i % _CAT.length]; g.Names.forEach((n) => { tmpMap[n] = c; }); });
		this._typeColorByRST = tmpMap; this._typeColorForOptions = this._typeOptions;
		return tmpMap;
	}
	_typeColorFor(pRST) { return this._typeColorMap()[pRST] || '#8894a4'; }
	_typeGroupLabelFor(pRST) { const g = (this._typeOptions || []).find((x) => x.Names.indexOf(pRST) >= 0); return g ? g.Label : this._prettyType(pRST); }

	async _ensureTypeOptions()
	{
		// Cache only once the catalog actually grouped the types to their DisplayNames. If the ObservationManifests
		// catalog is slow or fails, we fall back to raw RecordSubType names for THIS load but retry on the next one
		// (so a transient catalog hiccup never sticks the session on ugly names like "LADOTDPersonnel").
		if (this._typeOptions && this._typeGrouped) { return; }
		this._typeChartOrder = null;  // rebuilding the options → recompute the stable chart order
		// PREFERRED: the opt-in Solr `RecordSubType` facet returns the observation types actually PRESENT in the customer's
		// indexed data, with counts (scoped server-side to IDCustomer + Deleted:0). It needs the `Facets` pass-through on
		// ObservationsFilter/Index; on an API without it the facet call returns no facet_counts and we fall back to the
		// customer's configured manifest types (ProjectObservationManifestJoin). Either way one chip = one catalog
		// DisplayName (so "Weather" covers "Legacy Weather" + "SiteManagerWeather"). The underlying values sent as the
		// ObservationType filter are RecordSubTypes (facet path) or manifest Names (fallback) — the server strips a leading
		// "Legacy " on both, so both match the indexed RecordSubType identically.
		// No server sort (FSF) — it scans/sorts the manifest table and is the slow/flaky part; we sort by DisplayName client-side.
		const tmpCatalogP = this._get('ObservationManifests/FilteredTo/FBV~Deleted~EQ~0/0/300');
		const tmpFacet = await this._post('ObservationsFilter/Index/0/0', { Facets: [ 'RecordSubType' ] });
		const tmpPairs = tmpFacet && tmpFacet.facet_counts && tmpFacet.facet_counts.facet_fields && tmpFacet.facet_counts.facet_fields.RecordSubType;
		if (tmpFacet && typeof tmpFacet.numFound === 'number') { this._baseline = tmpFacet.numFound; }  // unfiltered total (KPI context)
		const tmpCatalog = await tmpCatalogP;
		const tmpCatalogOk = Array.isArray(tmpCatalog) && tmpCatalog.length > 0;

		if (Array.isArray(tmpPairs) && tmpPairs.length)
		{
			// RecordSubType == manifest Name minus a leading "Legacy " — map each to its catalog DisplayName for the chip.
			const tmpDisplayByRST = {};
			(Array.isArray(tmpCatalog) ? tmpCatalog : []).forEach((m) => { if (m.Name) { const rst = String(m.Name).replace(/^Legacy /, ''); if (!tmpDisplayByRST[rst]) { tmpDisplayByRST[rst] = m.DisplayName || m.Name; } } });
			// facet_fields is a flat [ value, count, value, count, ... ] array.
			const tmpByLabel = {};
			for (let i = 0; i < tmpPairs.length - 1; i += 2)
			{
				const tmpVal = tmpPairs[i]; const tmpCount = Number(tmpPairs[i + 1]) || 0;
				if (!tmpVal) { continue; }
				const tmpLabel = tmpDisplayByRST[tmpVal] ? String(tmpDisplayByRST[tmpVal]).trim() : this._prettyType(tmpVal);
				const tmpGroup = (tmpByLabel[tmpLabel] = tmpByLabel[tmpLabel] || { Label: tmpLabel, Names: [], Count: 0 });
				if (tmpGroup.Names.indexOf(tmpVal) < 0) { tmpGroup.Names.push(tmpVal); }
				tmpGroup.Count += tmpCount;
			}
			this._typeOptions = Object.keys(tmpByLabel).sort((a, b) => a.localeCompare(b)).map((k) => tmpByLabel[k]);
			if (this._typeOptions.length) { this._typeGrouped = tmpCatalogOk; return; }
		}

		// FALLBACK (API without the `Facets` pass-through): the customer's configured manifest types, grouped by DisplayName.
		const tmpJoins = await this._get(`ProjectObservationManifestJoins/FilteredTo/FBV~IDCustomer~EQ~${this.customerID}/0/5000`);
		const tmpDisplayByName = {};
		(Array.isArray(tmpCatalog) ? tmpCatalog : []).forEach((m) => { if (m.Name) { tmpDisplayByName[m.Name] = m.DisplayName || m.Name; } });
		const tmpUsedNames = [ ...new Set((Array.isArray(tmpJoins) ? tmpJoins : []).map((r) => r.ObservationManifestName).filter(Boolean)) ];
		const fGroup = (pNames) =>
		{
			const tmpByLabel = {};
			pNames.forEach((n) => { const tmpLabel = String(tmpDisplayByName[n] || n).trim(); (tmpByLabel[tmpLabel] = tmpByLabel[tmpLabel] || []).push(n); });
			return Object.keys(tmpByLabel).sort((a, b) => a.localeCompare(b)).map((pLabel) => ({ Label: pLabel, Names: [ ...new Set(tmpByLabel[pLabel]) ] }));
		};
		// Fall back to the full catalog only if the customer has no configured manifests (better than an empty type filter).
		this._typeOptions = tmpUsedNames.length ? fGroup(tmpUsedNames) : fGroup(Object.keys(tmpDisplayByName));
		this._typeGrouped = tmpCatalogOk;  // retry next load if the catalog wasn't available
	}

	async _resolveAuthors()
	{
		const tmpIDs = [ ...new Set(this._rows.map((d) => d.IDAuthor).filter((x) => x && !this._authorNames[x])) ];
		if (!tmpIDs.length) { return; }
		const tmpUsers = await this._get(`Users/FilteredTo/FBL~IDUser~INN~${tmpIDs.join(',')}/0/${tmpIDs.length}`);
		(Array.isArray(tmpUsers) ? tmpUsers : []).forEach((u) => { this._authorNames[u.IDUser] = [ u.NameFirst, u.NameLast ].filter(Boolean).join(' ') || u.LoginID || `#${u.IDUser}`; });
	}

	// --- interactions ---
	setSearch(pV) { this._filter.SearchText = String(pV == null ? '' : pV); }
	setDateFrom(pV) { this._filter.From = pV || ''; }
	setDateTo(pV) { this._filter.To = pV || ''; }
	setInclusion(pV) { this._filter.Inclusion = pV || ''; this.applyFilters(); }
	toggleType(pIndex)
	{
		const tmpOpt = (this._typeOptions || [])[Number(pIndex)];
		if (!tmpOpt) { return; }
		const tmpOn = tmpOpt.Names.every((n) => this._filter.Types.indexOf(n) >= 0);
		if (tmpOn) { this._filter.Types = this._filter.Types.filter((n) => tmpOpt.Names.indexOf(n) < 0); }
		else { tmpOpt.Names.forEach((n) => { if (this._filter.Types.indexOf(n) < 0) { this._filter.Types.push(n); } }); }
		this.applyFilters();
	}
	toggleTypeDropdown() { this._typeDropdownOpen = !this._typeDropdownOpen; this.render(); }
	clearTypes() { if (!this._filter.Types.length) { return; } this._filter.Types = []; this.applyFilters(); }
	removeAuthor(pID)
	{
		const tmpID = Number(pID);
		this._filter.Authors = this._filter.Authors.filter((x) => Number(x) !== tmpID);
		this.applyFilters();
	}
	addAuthor(pID, pName)
	{
		const tmpID = Number(pID); if (!tmpID) { return; }
		if (this._filter.Authors.map(Number).indexOf(tmpID) < 0) { this._filter.Authors.push(tmpID); if (pName) { this._authorNames[tmpID] = pName; } }
		this.applyFilters();
	}
	selectProject(pID, pName)
	{
		this._filter.IDProject = Number(pID) || 0; this._filter.ProjectName = pName || '';
		this._filter.Labels = {}; this._activeTagType = ''; this._projectTagTypes = null;
		if (this._filter.IDProject) { this._loadProjectTagTypes(this._filter.IDProject); }
		this.applyFilters();
	}
	clearFilters()
	{
		// In an embed the project is locked, so Clear keeps it (and its labels vocabulary) and only resets the rest.
		const tmpProj = this._embeddedProjectID || 0;
		this._filter = { SearchText: '', Types: [], Authors: [], AuthorNames: {}, From: '', To: '', Inclusion: '', IDProject: tmpProj, ProjectName: this._filter.ProjectName || '', Labels: {}, MatchAllLabels: false };
		if (!tmpProj) { this._projectTagTypes = null; this._activeTagType = ''; }
		this.applyFilters();
	}

	// --- embed API (called by the Project workspace Observations tab): lock to a project, hide the Project filter,
	// paint into the tab host. Idempotent (the workspace re-mounts on every tab paint). ---
	openInto(pIDProject, pHostSelector)
	{
		const tmpID = Number(pIDProject) || 0;
		const tmpHost = pHostSelector || this._mount;
		const tmpChanged = (this._embeddedProjectID !== tmpID) || (this._mount !== tmpHost);
		this._embeddedProjectID = tmpID;
		this._mount = tmpHost;
		if (this._filter.IDProject !== tmpID)
		{
			this._filter.IDProject = tmpID; this._filter.ProjectName = '';
			this._filter.Labels = {}; this._activeTagType = ''; this._projectTagTypes = null;
			if (tmpID) { this._loadProjectTagTypes(tmpID); }
		}
		if (tmpChanged || !this._loaded)
		{
			try { if (this.pict.CSSMap && (typeof this.pict.CSSMap.injectCSS === 'function')) { this.pict.CSSMap.injectCSS(); } } catch (pError) { /* */ }
			this._page = 0; this.loadAsync();
		}
		else { this.render(); }  // plain repaint (the host div was re-created) — no refetch
	}
	// Return to the standalone screen: unlock the project and paint back into the standalone host.
	exitEmbed()
	{
		if (!this._embeddedProjectID && this._mount === '#ObservationList-Host') { return; }
		this._embeddedProjectID = 0;
		this._mount = '#ObservationList-Host';
		this._filter.IDProject = 0; this._filter.ProjectName = '';
		this._filter.Labels = {}; this._activeTagType = ''; this._projectTagTypes = null;
	}

	/** Load the selected project's tag-type vocabulary (project types, falling back to customer, then platform defaults). */
	async _loadProjectTagTypes(pID)
	{
		const fTypes = (rows) => [ ...new Set((Array.isArray(rows) ? rows : []).map((r) => r.TagType).filter(Boolean)) ];
		let tmpList = fTypes(await this._get(`ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~${pID}~FBV~IDCustomer~EQ~${this.customerID}~FSF~TagType~ASC~0/0/1000`));
		if (!tmpList.length) { tmpList = fTypes(await this._get(`ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~${this.customerID}~FSF~TagType~ASC~0/0/1000`)); }
		if (!tmpList.length) { tmpList = fTypes(await this._get('ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~0~FSF~TagType~ASC~0/0/1000')); }
		this._projectTagTypes = tmpList.sort((a, b) => a.localeCompare(b));
		this._activeTagType = this._projectTagTypes[0] || '';
		this.render();
	}

	setActiveTagType(pType) { this._activeTagType = pType || ''; }
	addLabel(pType, pValue) { const t = pType || this._activeTagType; if (!t || !pValue) { return; } this._filter.Labels[t] = this._filter.Labels[t] || []; if (this._filter.Labels[t].indexOf(pValue) < 0) { this._filter.Labels[t].push(pValue); } this.applyFilters(); }
	removeLabel(pType, pValue) { if (this._filter.Labels[pType]) { this._filter.Labels[pType] = this._filter.Labels[pType].filter((v) => v !== pValue); if (!this._filter.Labels[pType].length) { delete this._filter.Labels[pType]; } } this.applyFilters(); }
	toggleMatchAllLabels() { this._filter.MatchAllLabels = !this._filter.MatchAllLabels; if (Object.keys(this._filter.Labels).length) { this.applyFilters(); } else { this.render(); } }
	applyFilters() { this._page = 0; this.loadAsync(); }
	setPage(pPage) { const tmpMax = Math.max(0, Math.ceil(this._total / this._cap) - 1); this._page = Math.min(Math.max(0, pPage), tmpMax); this.loadAsync(); }
	openObservation(pID) { const tmpID = Number(pID) || 0; if (tmpID) { try { window.location.hash = `#/Observation/Workspace/${tmpID}`; } catch (e) { /* */ } } }

	// --- view mode + charts view ---
	setViewMode(pMode)
	{
		if (pMode !== 'list' && pMode !== 'charts' && pMode !== 'map') { return; }
		if (this._viewMode === pMode) { return; }
		this._viewMode = pMode;
		this.loadAsync();
	}
	// Full screen: overlay the dashboard across the whole browser view (above the app nav). State is a provider field so it
	// survives the shell rebuild; render() re-applies the `.obl-fs` class. Navigating away replaces the host, so the fixed
	// overlay is torn down with it (no leak).
	toggleFullscreen()
	{
		if (this._embeddedProjectID) { return; }
		this._fullscreen = !this._fullscreen;
		this.render();
		// The overlay composites on its own layer (CSS `transform` on .obl-fs) so it paints immediately without the classic
		// "position:fixed stays blank until you scroll" quirk. On the map, re-fit Leaflet to the new size next frame.
		if (this._viewMode === 'map' && typeof requestAnimationFrame === 'function')
		{
			requestAnimationFrame(() => { if (this._map) { try { this._map.invalidateSize(); } catch (pError) { /* */ } } });
		}
	}
	// Reporting bucket -> the shared "In reports" (Inclusion) filter, so it drives the list and map too.
	setReportingBucket(pBucket)
	{
		const tmpInc = { b0: '0', b1: '1', b2plus: '2' }[pBucket] || '';
		this._filter.Inclusion = (this._filter.Inclusion === tmpInc) ? '' : tmpInc;
		this.applyFilters();
	}

	_chartGroups()
	{
		const tmpOrder = this._typeChartOrder || (this._typeOptions || []).map((g) => g.Label);
		const tmpByLabel = {};
		(this._typeOptions || []).forEach((g, i) => { tmpByLabel[g.Label] = { label: g.Label, names: g.Names, idx: i, count: g.Names.reduce((a, n) => a + (this._chartTypeCounts[n] || 0), 0) }; });
		return tmpOrder.map((l) => tmpByLabel[l]).filter(Boolean);
	}
	_chartKPIs()
	{
		const tmpRepTotal = this._rep.b0 + this._rep.b1 + this._rep.b2plus;
		const inc = this._filter.Inclusion;
		let awaiting; let inPct;
		if (inc === '0') { awaiting = this._total; inPct = 0; }
		else if (inc === '1' || inc === '2') { awaiting = 0; inPct = 100; }
		else { awaiting = this._rep.b0; inPct = tmpRepTotal ? Math.round(((this._rep.b1 + this._rep.b2plus) / tmpRepTotal) * 100) : 0; }
		return { total: this._total, types: this._chartGroups().filter((g) => g.count > 0).length, inPct: inPct, awaiting: awaiting };
	}

	_chartsHTML()
	{
		if (this._error) { return `<div class="obl-empty obl-error">${this._esc(this._error)}</div>`; }
		if (this._loading && !this._chartsLoaded) { return `<div class="obl-empty"><span class="obl-spin"></span> Faceting…</div>`; }
		const k = this._chartKPIs();
		return /*html*/`
			<div class="oxp">
				<div class="oxp-badge-row"><span class="oxp-badge"><span class="oxp-pulse${this._loading ? ' oxp-pulse-busy' : ''}"></span> re-faceted in <b id="oxp-badge-ms">${this._loading ? '…' : this._chartLatencyMs}</b> ms over <b>${this._compact(this._baseline)}</b> rows</span></div>
				${this._kpisChartHTML(k)}
				<div class="oxp-grid">${this._typeChartPanelHTML()}${this._reportChartPanelHTML()}</div>
				<div class="oxp-foot"><i class="fas fa-bolt"></i> Live — faceted on the search index per selection; clicking a bar sets the same filter the List and Map share. Project · author · label facets and a time trend are next.</div>
			</div>`;
	}
	_kpisChartHTML(k)
	{
		const tmpShare = this._baseline ? Math.round((k.total / this._baseline) * 100) : 100;
		const cell = (pEyebrow, pId, pVal, pLabel, pCls, pSub) => `<div class="oxp-kpi${pCls || ''}"><div class="oxp-eyebrow">${pEyebrow}</div><div class="oxp-v" data-kpi="${pId}" data-to="${pVal}">${this._prevKPI ? this._fmt(this._prevKPI[pId] != null ? this._prevKPI[pId] : pVal) : '0'}</div><div class="oxp-l">${pLabel}${pSub ? ` <span class="oxp-l-sub">${pSub}</span>` : ''}</div></div>`;
		return `<div class="oxp-kpis">${cell('Metric', 'total', k.total, 'Observations in view', '', `· ${tmpShare}% of ${this._compact(this._baseline)}`)}${cell('Metric', 'types', k.types, 'Observation types', '')}${cell('Metric', 'inPct', k.inPct, 'In a report', '', '%')}${cell('Attention', 'awaiting', k.awaiting, 'Awaiting a report', ' oxp-kpi-warn')}</div>`;
	}
	_typeChartPanelHTML()
	{
		const P = this.providerName; const tmpGroups = this._chartGroups();
		const tmpMax = tmpGroups.reduce((a, g) => Math.max(a, g.count), 1);
		const tmpRows = tmpGroups.map((g) =>
		{
			const on = g.names.length && g.names.every((n) => this._filter.Types.indexOf(n) >= 0);
			const w = Math.max(1.5, (g.count / tmpMax) * 100);
			const color = _CAT[g.idx % _CAT.length];
			return `<div class="oxp-row${on ? ' oxp-row-on' : ''}" onclick="_Pict.providers.${P}.toggleType(${g.idx})">
				<div class="oxp-row-bg" style="width:${w}%;background:linear-gradient(90deg,${color}22,transparent)"></div>
				<div class="oxp-lab"><span class="oxp-dot" style="background:${color}"></span><span class="oxp-name" title="${this._esc(g.label)}">${this._esc(g.label)}</span></div>
				<span class="oxp-cnt">${this._fmt(g.count)}</span>
				<div class="oxp-track"><div class="oxp-fill" style="width:${w}%;background:${color}"></div></div>
			</div>`;
		}).join('');
		return `<div class="oxp-panel"><div class="oxp-ph"><h3><i class="fas fa-chart-simple"></i> Observation type</h3><span class="oxp-hint">facet · RecordSubType — click to filter</span></div><div class="oxp-rows">${tmpRows || '<div class="oxp-empty">No types in view.</div>'}</div></div>`;
	}
	_reportChartPanelHTML()
	{
		const P = this.providerName; const sel = this._filter.Inclusion;
		const segs = [
			{ key: 'b0', inc: '0', name: 'Not in a report', count: this._rep.b0, color: _WARN },
			{ key: 'b1', inc: '1', name: 'In one report', count: this._rep.b1, color: _CAT[0] },
			{ key: 'b2plus', inc: '2', name: 'In two or more', count: this._rep.b2plus, color: _CAT[1] },
		];
		const sum = segs.reduce((a, s) => a + s.count, 0) || 1;
		const stack = segs.map((s) => `<div class="oxp-seg${sel && sel !== s.inc ? ' oxp-seg-dim' : ''}" style="width:${(s.count / sum) * 100}%;background:${s.color}" title="${this._esc(s.name)} · ${this._fmt(s.count)}" onclick="_Pict.providers.${P}.setReportingBucket('${s.key}')"></div>`).join('');
		const legend = segs.map((s) => `<div class="oxp-fl${sel === s.inc ? ' oxp-fl-on' : ''}" onclick="_Pict.providers.${P}.setReportingBucket('${s.key}')"><span class="oxp-sw" style="background:${s.color}"></span><span class="oxp-fname">${this._esc(s.name)}</span><span class="oxp-fpct">${((s.count / sum) * 100).toFixed(1)}%</span><span class="oxp-fcnt">${this._fmt(s.count)}</span></div>`).join('');
		const awaitPct = sum ? ((this._rep.b0 / sum) * 100) : 0;
		return `<div class="oxp-panel"><div class="oxp-ph"><h3><i class="fas fa-clipboard-check"></i> Reporting status</h3><span class="oxp-hint">facet · DocumentCount</span></div><div class="oxp-stack">${stack}</div><div class="oxp-flegend">${legend}</div>${this._rep.b0 > 0 ? `<div class="oxp-callout"><i class="fas fa-triangle-exclamation"></i><p><b>${this._fmt(this._rep.b0)}</b> — ${awaitPct.toFixed(1)}% of the current view — aren't in any report yet. <a href="#" onclick="_Pict.providers.${P}.setReportingBucket('b0');return false;">Isolate them &rarr;</a></p></div>` : ''}</div>`;
	}
	// =========================================================== MAP ===========================================================
	_mapHTML()
	{
		if (this._error) { return `<div class="obl-empty obl-error">${this._esc(this._error)}</div>`; }
		if (this._loading && !this._mapLoaded) { return `<div class="obl-empty"><span class="obl-spin"></span> Mapping observations…</div>`; }
		if (!this.L) { return `<div class="obl-empty">The map library didn't load — reload the page to see the map.</div>`; }
		return `<div class="obl-maprow"><div id="obl-map" class="obl-map"></div><div id="obl-map-side" class="obl-side">${this._mapSideInnerHTML()}</div></div>`;
	}
	// (Re)build the Leaflet map into #obl-map. render() replaces the shell's innerHTML on every paint, so the map DOM is
	// always fresh here — we preserve the user's current center/zoom across BENIGN repaints (e.g. closing the type dropdown)
	// and only re-fit the bounds when the plotted dataset actually changes (a filter change). Marker clicks NEVER repaint.
	_mountObservationMap()
	{
		const L = this.L; const ca = this.pict.ContentAssignment;
		if (!L || !ca) { return; }
		const tmpHostList = ca.getElement('#obl-map');
		if (!tmpHostList || !tmpHostList.length)
		{
			if (this._map) { try { this._map.remove(); } catch (pError) { /* */ } this._map = null; }   // left map view — drop the instance
			return;
		}
		const tmpHost = tmpHostList[0];
		const tmpPrevView = this._map ? { center: this._map.getCenter(), zoom: this._map.getZoom() } : this._mapView;
		if (this._map) { try { this._map.remove(); } catch (pError) { /* */ } this._map = null; }
		this._map = L.map(tmpHost, { scrollWheelZoom: true }).setView([ 39.5, -98.35 ], 4);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(this._map);
		this._mapMarkers = [];
		this._mapMappable.forEach((r) =>
		{
			const tmpBase = this._typeColorFor(r.doc.RecordSubType);
			const m = L.circleMarker([ r.pt.lat, r.pt.lng ], { radius: 5, weight: 1, color: '#ffffff', fillColor: tmpBase, fillOpacity: 0.9 });
			m.bindTooltip(`${this._esc(this._typeGroupLabelFor(r.doc.RecordSubType))} · ${this._esc(this._fmtDate(r.doc.DateOfRecord))}`);
			m.on('click', () => { try { this.showObservationDetail(r.id); } catch (pError) { /* */ } });
			m.addTo(this._map); this._mapMarkers.push({ r: r, m: m, base: tmpBase });
		});
		this._restyleMapMarkers();
		const tmpPts = this._mapMarkers.map((x) => [ x.r.pt.lat, x.r.pt.lng ]);
		// Fit the bounds only when a data load is pending (entered the map, or the filter changed); a benign repaint
		// (e.g. closing the type dropdown) keeps the user's current center/zoom so the map never jumps under them.
		if (!this._mapFitPending && tmpPrevView) { try { this._map.setView(tmpPrevView.center, tmpPrevView.zoom); } catch (pError) { /* */ } }
		else if (tmpPts.length) { try { this._map.fitBounds(tmpPts, { padding: [ 28, 28 ], maxZoom: 15 }); } catch (pError) { /* */ } }
		this._mapFitPending = false;
		this._map.on('moveend zoomend', () => { if (this._map) { try { this._mapView = { center: this._map.getCenter(), zoom: this._map.getZoom() }; } catch (pError) { /* */ } } });
		setTimeout(() => { if (this._map) { try { this._map.invalidateSize(); } catch (pError) { /* */ } } }, 60);
	}
	// Emphasize the open observation's marker (amber ring, brought to front) so it's obvious which point the panel shows.
	_restyleMapMarkers()
	{
		if (!this._mapMarkers) { return; }
		const sel = this._mapDetail;
		this._mapMarkers.forEach((x) =>
		{
			if (sel && x.r.id === sel) { x.m.setStyle({ color: '#f59e0b', weight: 3, fillColor: x.base, fillOpacity: 1 }); x.m.setRadius(8); try { x.m.bringToFront(); } catch (pError) { /* */ } }
			else { x.m.setStyle({ color: '#ffffff', weight: 1, fillColor: x.base, fillOpacity: 0.9 }); x.m.setRadius(5); }
		});
	}
	// Marker click → show the observation in the docked side panel IN PLACE (update only #obl-map-side; no shell repaint,
	// so the map keeps its exact position and zoom as you click between points).
	showObservationDetail(pID) { const id = Number(pID) || 0; if (!id) { return; } this._mapDetail = id; this._restyleMapMarkers(); this._renderMapSide(); this._ensureMapDetailObsAsync(id); }
	closeObservationDetail() { this._mapDetail = 0; this._restyleMapMarkers(); this._renderMapSide(); }

	/** The centralized observation renderer (registered in PlatformConfiguration-Application-Web). */
	get _obsRender() { return this.pict && this.pict.HeadlightObservationRender; }

	/**
	 * Fetch the full observation (with its assembled .Details) + resolved schema for the docked side panel, so it can
	 * show the observation's CAPTURED DATA below the Solr metadata (a data-laden panel, via the centralized renderer).
	 * The list/map feed is Solr docs (metadata only), so the data is a lazy per-click fetch; guarded against stale loads.
	 */
	async _ensureMapDetailObsAsync(pID)
	{
		const id = Number(pID) || 0;
		if (!id || !this._obsRender) { return; }
		if (this._mapDetailObsID === id && this._mapDetailObs) { return; }
		this._mapDetailLoading = true;
		this._mapDetailObs = null; this._mapDetailObsID = id; this._mapDetailSpec = null;
		this._renderMapSide();
		const tmpObs = await this._get(`Observation/${id}`);
		if (this._mapDetail !== id) { return; }   // the user moved on — drop this result
		if (tmpObs && !tmpObs.Error && (typeof this._obsRender.loadSpecification === 'function') && tmpObs.ObservationType)
		{
			await new Promise((resolve) => this._obsRender.loadSpecification(tmpObs.ObservationType, tmpObs.IDProject,
				(pError, pSpec) => { if (this._mapDetail === id) { this._mapDetailSpec = pError ? null : pSpec; } resolve(); }));
		}
		if (this._mapDetail !== id) { return; }
		this._mapDetailObs = (tmpObs && !tmpObs.Error) ? tmpObs : null;
		this._mapDetailLoading = false;
		this._renderMapSide();
	}

	/** The captured-data block appended to the side detail panel (spinner while loading; the renderer's data view once ready). */
	_mapSideDataHTML()
	{
		if (this._mapDetailLoading) { return `<div class="obl-side-data"><div class="obl-side-data-h">Captured data</div><div class="obl-note"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div></div>`; }
		const tmpRender = this._obsRender;
		if (!tmpRender || !this._mapDetailObs || (this._mapDetailObsID !== this._mapDetail)) { return ''; }
		const tmpHTML = tmpRender.renderObservationHTML(this._mapDetailObs, { format: 'data', specification: this._mapDetailSpec || null });
		return `<div class="obl-side-data"><div class="obl-side-data-h">Captured data</div>${tmpHTML}</div>`;
	}
	_renderMapSide() { const ca = this.pict.ContentAssignment; if (!ca) { return; } const el = ca.getElement('#obl-map-side'); if (el && el.length) { el[0].innerHTML = this._mapSideInnerHTML(); } }
	_mapSideInnerHTML()
	{
		const tmpInfo = `<div class="obl-side-sum-wrap">${this._mapSummaryHTML()}</div>`;
		if (this._mapDetail) { return tmpInfo + this._mapSideDetailHTML(); }
		return tmpInfo + this._mapLegendHTML() + `<div class="obl-side-hint"><i class="fas fa-hand-pointer"></i> Click any point to read its observation here.</div>`;
	}
	_mapSummaryHTML()
	{
		const tmpMapped = this._mapMappable.length;
		const tmpNoLoc = this._mapFetched - tmpMapped;
		const tmpCapped = this._total > this._mapFetched;
		let tmpNote = '';
		if (tmpCapped) { tmpNote = ` <span class="obl-mut">· most recent ${this._mapFetched.toLocaleString()} of ${this._total.toLocaleString()} matches — refine filters to map the rest</span>`; }
		else if (tmpNoLoc > 0) { tmpNote = ` <span class="obl-mut">· ${tmpNoLoc.toLocaleString()} without a location</span>`; }
		return `<div class="obl-side-sum"><b>${tmpMapped.toLocaleString()}</b> observation${tmpMapped === 1 ? '' : 's'} mapped${tmpNote}</div>`;
	}
	// A legend of the observation-type groups present in the mapped set — colored to match the markers and clickable to
	// toggle that type in the SHARED filter (so the legend doubles as a quick type filter, like the charts panel).
	_mapLegendHTML()
	{
		const P = this.providerName;
		const tmpCounts = {};
		this._mapMappable.forEach((r) => { const lbl = this._typeGroupLabelFor(r.doc.RecordSubType); tmpCounts[lbl] = (tmpCounts[lbl] || 0) + 1; });
		const tmpRows = (this._typeOptions || [])
			.map((g, i) => ({ label: g.Label, idx: i, color: _CAT[i % _CAT.length], count: tmpCounts[g.Label] || 0, on: g.Names.length && g.Names.every((n) => this._filter.Types.indexOf(n) >= 0) }))
			.filter((x) => x.count > 0 || x.on)
			.sort((a, b) => (b.count - a.count));
		if (!tmpRows.length) { return ''; }
		const tmpItems = tmpRows.map((x) => `<div class="obl-legend-i${x.on ? ' obl-legend-on' : ''}" onclick="_Pict.providers.${P}.toggleType(${x.idx})" title="${this._esc(x.label)}"><span class="obl-legend-dot" style="background:${x.color}"></span><span class="obl-legend-v">${this._esc(x.label)}</span><span class="obl-legend-c">${x.count.toLocaleString()}</span></div>`).join('');
		return `<div class="obl-legend"><div class="obl-legend-h">Observation type <span class="obl-mut">click to filter</span></div><div class="obl-legend-list">${tmpItems}</div></div>`;
	}
	_mapSideDetailHTML()
	{
		const P = this.providerName; const id = this._mapDetail;
		const r = this._mapMappable.find((x) => x.id === id) || this._mapRows.find((x) => x.id === id);
		const d = r ? r.doc : null;
		if (!d) { return ''; }
		const tmpTitle = this._docTitle(d);
		const tmpAuthor = this._authorNames[d.IDAuthor] || (d.IDAuthor ? `#${d.IDAuthor}` : '');
		const tmpTypeLabel = this._typeGroupLabelFor(d.RecordSubType);
		const tmpColor = this._typeColorFor(d.RecordSubType);
		const tmpPt = (r && r.pt) ? r.pt : this._pointOf(d);
		// A small, crisp thumbnail beside the title (the /Image/Thumbnail size is the reliably-generated one; the larger
		// sizes return a placeholder until the transcoder builds them). Non-photo observation types show a typed glyph.
		const tmpThumb = d.IDArtifact
			? `<img class="obl-side-thumb" src="${this._esc(this._mediaUrl(`Observation/${id}/Image/Thumbnail`))}" alt="" loading="lazy" referrerpolicy="no-referrer" onerror="this.classList.add('obl-side-thumb-broken')">`
			: `<span class="obl-side-thumb obl-side-thumb-none" style="color:${tmpColor}"><i class="fas fa-clipboard"></i></span>`;
		const tmpProps = [
			this._sideProp('Type', `<span class="obl-prop-type"><span class="obl-legend-dot" style="background:${tmpColor}"></span>${this._esc(tmpTypeLabel)}</span>`),
			this._sideProp('Date', this._esc(this._fmtDate(d.DateOfRecord)) || '—'),
			this._sideProp('Author', this._esc(tmpAuthor) || '—'),
			this._sideProp('Project', this._esc(d.Project || '') || '—'),
			this._sideProp('In reports', this._reportBadge(d.DocumentCount)),
			tmpPt ? (this._sideProp('Latitude', tmpPt.lat.toFixed(5)) + this._sideProp('Longitude', tmpPt.lng.toFixed(5))) : '',
		].join('');
		return `<div class="obl-side-detail">
			<div class="obl-side-top">
				<button class="obl-side-x" onclick="_Pict.providers.${P}.closeObservationDetail()" title="Close"><i class="fas fa-xmark"></i></button>
				<div class="obl-side-idrow">
					${tmpThumb}
					<div class="obl-side-idtext">
						<span class="obl-side-name">${this._esc(tmpTitle)}</span>
						<div class="obl-side-sub"><span class="obl-type">${this._esc(d.RecordSubType || '')}</span><span class="obl-mut">#${id}</span></div>
					</div>
				</div>
			</div>
			<div class="obl-side-scroll"><div class="obl-props">${tmpProps}</div>${this._mapSideDataHTML()}</div>
			<div class="obl-side-foot"><a class="obl-side-btn" href="#/Observation/Workspace/${id}"><i class="fas fa-arrow-up-right-from-square"></i> Open observation</a></div>
		</div>`;
	}
	_sideProp(pLabel, pValueHtml) { return `<div class="obl-prop"><div class="obl-prop-l">${this._esc(pLabel)}</div><div class="obl-prop-v">${pValueHtml}</div></div>`; }
	_reportBadge(pCount) { const n = Number(pCount) || 0; if (n <= 0) { return '<span class="obl-rep obl-rep-0">Not in a report</span>'; } return `<span class="obl-rep obl-rep-1">In ${n} report${n === 1 ? '' : 's'}</span>`; }

	_bodyHTML()
	{
		if (this._viewMode === 'charts') { return this._chartsHTML(); }
		if (this._viewMode === 'map') { return this._mapHTML(); }
		return this._resultsHTML();
	}
	_viewTabsHTML()
	{
		const P = this.providerName;
		const tab = (pMode, pIcon, pLabel) => `<button class="obl-vtab${this._viewMode === pMode ? ' obl-vtab-on' : ''}" onclick="_Pict.providers.${P}.setViewMode('${pMode}')"><i class="fas ${pIcon}"></i> ${pLabel}</button>`;
		const tmpCount = this._loaded ? `<span class="obl-vtabcount">${this._total.toLocaleString()} match${this._total === 1 ? '' : 'es'}</span>` : '';
		// Full-screen toggle — standalone only (in an embedded Project tab there's no app chrome to escape).
		const tmpFsBtn = this._embeddedProjectID ? '' : `<button class="obl-fsbtn${this._fullscreen ? ' obl-fsbtn-on' : ''}" onclick="_Pict.providers.${P}.toggleFullscreen()" title="${this._fullscreen ? 'Exit full screen (Esc)' : 'Full screen'}"><i class="fas ${this._fullscreen ? 'fa-compress' : 'fa-expand'}"></i> ${this._fullscreen ? 'Exit full screen' : 'Full screen'}</button>`;
		return `<div class="obl-viewtabs-row"><div class="obl-viewtabs">${tab('list', 'fa-list-ul', 'List')}${tab('charts', 'fa-chart-simple', 'Charts')}${tab('map', 'fa-location-dot', 'Map')}</div><div class="obl-vtabs-right">${tmpCount}${tmpFsBtn}</div></div>`;
	}
	_tweenChartKPIs()
	{
		const tmpCA = this.pict.ContentAssignment; if (!tmpCA) { return; }
		const els = tmpCA.getElement(`${this._mount} .oxp-v`);
		const reduced = (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
		const next = {};
		for (let i = 0; els && i < els.length; i++)
		{
			const el = els[i]; const key = el.getAttribute('data-kpi'); const to = Number(el.getAttribute('data-to')) || 0;
			const isPct = (key === 'inPct'); const from = this._prevKPI && this._prevKPI[key] != null ? this._prevKPI[key] : 0;
			next[key] = to;
			if (reduced || from === to) { el.textContent = isPct ? `${Math.round(to)}%` : this._fmt(to); continue; }
			this._animateKPI(el, from, to, isPct);
		}
		this._prevKPI = next;
	}
	_animateKPI(el, from, to, isPct)
	{
		const dur = 460; let t0 = null;
		const step = (ts) => { if (t0 === null) { t0 = ts; } const p = Math.min(1, (ts - t0) / dur); const e = 1 - Math.pow(1 - p, 3); const v = from + (to - from) * e; el.textContent = isPct ? `${Math.round(v)}%` : this._fmt(v); if (p < 1) { requestAnimationFrame(step); } };
		requestAnimationFrame(step);
	}

	// --- render (host-div paint) ---
	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement(this._mount).length === 0) { return; }
		tmpCA.assignContent(this._mount, this._shellHTML());
		this._mountPickers();
		if (this._viewMode === 'charts') { this._tweenChartKPIs(); }
		if (this._viewMode === 'map') { this._mountObservationMap(); }
		else if (this._map) { try { this._map.remove(); } catch (pError) { /* */ } this._map = null; }   // left map view — tear down Leaflet
	}

	_shellHTML()
	{
		// Embedded in a Project workspace tab: the tab already says "Observations", so drop the redundant page title.
		return /*html*/`
			<div class="obl${this._embeddedProjectID ? ' obl-embedded' : ''}${this._fullscreen ? ' obl-fs' : ''}">
				${this._embeddedProjectID ? '' : `<div class="obl-head"><div class="obl-title"><i class="fas fa-clipboard-list"></i> Observations</div></div>`}
				${this._filterBarHTML()}
				${this._viewTabsHTML()}
				<div id="obl-results">${this._bodyHTML()}</div>
			</div>`;
	}

	_filterBarHTML()
	{
		const f = this._filter;
		const tmpAuthorChips = f.Authors.map((id) => `<span class="obl-tag">${this._esc(this._authorNames[id] || ('#' + id))}<button class="obl-tag-x" onclick="_Pict.providers.${this.providerName}.removeAuthor(${Number(id)})">&times;</button></span>`).join('');
		const P = this.providerName;
		return /*html*/`
			<div class="obl-filters">
				<div class="obl-row">
					<span class="obl-search"><i class="fas fa-search obl-search-ic"></i><input class="obl-search-in" type="search" placeholder="Search observations…" value="${this._esc(f.SearchText)}" oninput="_Pict.providers.${P}.setSearch(this.value)" onkeydown="if(event.key==='Enter'){_Pict.providers.${P}.applyFilters();}" /></span>
					<div class="obl-f"><span class="obl-f-l">Types</span>${this._typeDropdownHTML()}</div>
					<label class="obl-f"><span class="obl-f-l">From</span><input type="date" value="${this._esc(f.From)}" onchange="_Pict.providers.${P}.setDateFrom(this.value)" /></label>
					<label class="obl-f"><span class="obl-f-l">To</span><input type="date" value="${this._esc(f.To)}" onchange="_Pict.providers.${P}.setDateTo(this.value)" /></label>
					<div class="obl-f"><span class="obl-f-l">In reports</span><div id="ObservationList-InclusionPicker" class="obl-picker obl-enumpicker"></div></div>
					<button class="obl-apply" onclick="_Pict.providers.${P}.applyFilters()">Apply</button>
					<button class="obl-clear" onclick="_Pict.providers.${P}.clearFilters()">Clear</button>
				</div>
				<div class="obl-row obl-row-pickers">
					${this._embeddedProjectID ? '' : `<div class="obl-pick"><span class="obl-f-l">Project</span><div id="ObservationList-ProjectPicker" class="obl-picker"></div></div>`}
					<div class="obl-pick"><span class="obl-f-l">Author</span><div id="ObservationList-AuthorPicker" class="obl-picker"></div>${tmpAuthorChips ? `<div class="obl-tags">${tmpAuthorChips}</div>` : ''}</div>
				</div>
				${this._labelsFilterHTML()}
			</div>`;
	}

	/** Observation Types — a dropdown button + checklist panel (replaces the chip cluster). Multi-select; the panel
	 *  stays open across selections (open state is provider-held) and closes on an outside click or the button. */
	_typeDropdownHTML()
	{
		const P = this.providerName; const opts = this._typeOptions || [];
		const tmpSel = opts.filter((o) => o.Names.length && o.Names.every((n) => this._filter.Types.indexOf(n) >= 0)).length;
		const tmpBtn = `<button type="button" class="obl-ddbtn${this._typeDropdownOpen ? ' obl-ddbtn-open' : ''}" onclick="_Pict.providers.${P}.toggleTypeDropdown()"><span class="obl-ddbtn-l">${tmpSel ? `${tmpSel} selected` : 'Any type'}</span>${tmpSel ? `<span class="obl-ddbadge">${tmpSel}</span>` : ''}<i class="fas fa-chevron-${this._typeDropdownOpen ? 'up' : 'down'} obl-ddcaret"></i></button>`;
		if (!this._typeDropdownOpen) { return `<div class="obl-typedd">${tmpBtn}</div>`; }
		const tmpItems = opts.map((o, i) =>
		{
			const on = o.Names.length && o.Names.every((n) => this._filter.Types.indexOf(n) >= 0);
			const cnt = (o.Count != null) ? `<span class="obl-ddcount">${Number(o.Count).toLocaleString()}</span>` : '';
			return `<label class="obl-dditem${on ? ' obl-dditem-on' : ''}"><input type="checkbox" ${on ? 'checked' : ''} onclick="_Pict.providers.${P}.toggleType(${i})" /><span class="obl-ddname" title="${this._esc(o.Label)}">${this._esc(o.Label)}</span>${cnt}</label>`;
		}).join('');
		return `<div class="obl-typedd">${tmpBtn}<div class="obl-ddpanel"><div class="obl-ddpanel-head"><span>${opts.length} type${opts.length === 1 ? '' : 's'} in your data</span>${tmpSel ? `<button type="button" class="obl-ddclearbtn" onclick="_Pict.providers.${P}.clearTypes()">Clear</button>` : ''}</div><div class="obl-ddlist">${tmpItems || '<div class="obl-ddempty">No types</div>'}</div></div></div>`;
	}

	/** The project-scoped Labels filter: a tag-type selector + a searchable value picker, and the selected values as
	 *  removable chips grouped by type. Only shown once a project is selected (labels are a per-project vocabulary). */
	_labelsFilterHTML()
	{
		if (!this._filter.IDProject) { return `<div class="obl-labelhint"><i class="fas fa-tags"></i> Pick a project above to filter by its labels.</div>`; }
		if (!this._projectTagTypes) { return `<div class="obl-labelhint"><span class="obl-spin"></span> Loading labels…</div>`; }
		if (!this._projectTagTypes.length) { return ''; }
		const P = this.providerName;
		const tmpTypeSelect = `<select class="obl-labeltype" onchange="_Pict.providers.${P}.setActiveTagType(this.value)">${this._projectTagTypes.map((t) => `<option value="${this._esc(t)}"${t === this._activeTagType ? ' selected' : ''}>${this._esc(t)}</option>`).join('')}</select>`;
		const tmpChosen = Object.keys(this._filter.Labels).map((pType) =>
		{
			const vals = this._filter.Labels[pType] || []; if (!vals.length) { return ''; }
			return `<span class="obl-label-grp"><span class="obl-label-gt">${this._esc(pType)}</span>${vals.map((v) => `<span class="obl-tag">${this._esc(v)}<button class="obl-tag-x" onclick="_Pict.providers.${P}.removeLabel('${this._esc(pType)}','${this._esc(v)}')">&times;</button></span>`).join('')}</span>`;
		}).join('');
		const tmpHasLabels = Object.keys(this._filter.Labels).length > 0;
		return `<div class="obl-labels-filter">
			<span class="obl-f-l">Labels</span>
			${tmpTypeSelect}
			<div id="ObservationList-LabelPicker" class="obl-picker obl-labelpicker"></div>
			${tmpHasLabels ? `<label class="obl-matchall"><input type="checkbox"${this._filter.MatchAllLabels ? ' checked' : ''} onchange="_Pict.providers.${P}.toggleMatchAllLabels()" /> Match all</label>` : ''}
			${tmpChosen ? `<div class="obl-label-chips">${tmpChosen}</div>` : ''}
		</div>`;
	}

	_resultsHTML()
	{
		if (this._loading) { return `<div class="obl-empty"><span class="obl-spin"></span> Searching…</div>`; }
		if (this._error) { return `<div class="obl-empty obl-error">${this._esc(this._error)}</div>`; }
		if (!this._rows.length) { return `<div class="obl-empty">No observations match these filters.</div>`; }
		const tmpRows = this._rows.map((d) => this._rowHTML(d)).join('');
		return `<div class="obl-listwrap"><table class="obl-list"><thead><tr><th></th><th>Type</th><th>Observation</th><th>Date</th><th>Author</th><th>Project</th><th class="obl-num">Docs</th></tr></thead><tbody>${tmpRows}</tbody></table></div>${this._paginationHTML()}`;
	}

	_rowHTML(pDoc)
	{
		const tmpID = this._idOf(pDoc);
		const tmpThumb = pDoc.IDArtifact ? `<img class="obl-thumb" src="${this._mediaUrl(`Observation/${tmpID}/Image/Thumbnail`)}" loading="lazy" onerror="this.classList.add('obl-thumb-broken')"/>` : '<span class="obl-thumb obl-thumb-none"><i class="fas fa-clipboard"></i></span>';
		const tmpTitle = this._docTitle(pDoc);
		const tmpAuthor = this._authorNames[pDoc.IDAuthor] || (pDoc.IDAuthor ? `#${pDoc.IDAuthor}` : '');
		return `<tr class="obl-r" onclick="_Pict.providers.${this.providerName}.openObservation(${tmpID})">
			<td class="obl-thumb-cell">${tmpThumb}</td>
			<td><span class="obl-type">${this._esc(pDoc.RecordSubType || '')}</span></td>
			<td class="obl-obscell"><span class="obl-obsname">${this._esc(tmpTitle)}</span><span class="obl-obsid">#${tmpID}</span></td>
			<td class="obl-nowrap">${this._esc(this._fmtDate(pDoc.DateOfRecord))}</td>
			<td>${this._esc(tmpAuthor)}</td>
			<td class="obl-proj">${this._esc(pDoc.Project || '')}</td>
			<td class="obl-num">${pDoc.DocumentCount != null ? this._esc(pDoc.DocumentCount) : ''}</td>
		</tr>`;
	}

	/** A readable row title from the Solr doc — the search text is a concatenation; trim to a sensible label. */
	_docTitle(pDoc)
	{
		const tmpText = String(pDoc.SearchText || '').trim().replace(/\s+/g, ' ');
		if (tmpText) { return tmpText.length > 90 ? `${tmpText.slice(0, 90)}…` : tmpText; }
		return pDoc.RecordSubType || `Observation ${this._idOf(pDoc)}`;
	}

	_paginationHTML()
	{
		const tmpPages = Math.max(1, Math.ceil(this._total / this._cap));
		if (tmpPages <= 1) { return ''; }
		const P = this.providerName;
		const tmpStart = this._page * this._cap + 1;
		const tmpEnd = Math.min(this._total, (this._page + 1) * this._cap);
		return `<div class="obl-pager">
			<button class="obl-pg" ${this._page <= 0 ? 'disabled' : ''} onclick="_Pict.providers.${P}.setPage(${this._page - 1})"><i class="fas fa-chevron-left"></i> Prev</button>
			<span class="obl-pg-info">${tmpStart.toLocaleString()}–${tmpEnd.toLocaleString()} of ${this._total.toLocaleString()}</span>
			<button class="obl-pg" ${this._page >= (tmpPages - 1) ? 'disabled' : ''} onclick="_Pict.providers.${P}.setPage(${this._page + 1})">Next <i class="fas fa-chevron-right"></i></button>
		</div>`;
	}

	// --- pickers (project + author, searchable, via pict-section-picker) ---
	_mountPickers()
	{
		const tmpPicker = this.pict.providers && this.pict.providers['Pict-Section-Picker'];
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		if (tmpCA.getElement('#ObservationList-ProjectPicker').length > 0)
		{
			const tmpV = tmpPicker.createPicker(`${this.providerName}-ProjectPicker`,
				{
					DestinationAddress: '#ObservationList-ProjectPicker', ValueAddress: `AppData.${this.providerName}.PickerProject`,
					Searchable: true, AllowClear: true, ClearLabel: '— any project —', Placeholder: 'Any project…',
					DataProvider: this._projectDataProvider(), ResolveValue: this._projectResolveValue(),
					OnChange: (v, pRecord) => this.selectProject(v, pRecord && (pRecord.Text || pRecord.Name)),
				});
			if (tmpV && (typeof tmpV.render === 'function')) { tmpV.render(); }
			if (tmpV && (typeof tmpV.setValue === 'function')) { tmpV.setValue(this._filter.IDProject || ''); }
		}
		if (tmpCA.getElement('#ObservationList-LabelPicker').length > 0)
		{
			const tmpV = tmpPicker.createPicker(`${this.providerName}-LabelPicker`,
				{
					DestinationAddress: '#ObservationList-LabelPicker', ValueAddress: `AppData.${this.providerName}.PickerLabel`,
					Searchable: true, AllowClear: true, ClearLabel: '— add a label value —', Placeholder: 'Add a label value…',
					DataProvider: this._labelValueDataProvider(), ResolveValue: () => Promise.resolve(null),
					OnChange: (v) => { if (v) { this.addLabel(this._activeTagType, v); } },
				});
			if (tmpV && (typeof tmpV.render === 'function')) { tmpV.render(); }
		}
		if (tmpCA.getElement('#ObservationList-AuthorPicker').length > 0)
		{
			const tmpV = tmpPicker.createPicker(`${this.providerName}-AuthorPicker`,
				{
					DestinationAddress: '#ObservationList-AuthorPicker', ValueAddress: `AppData.${this.providerName}.PickerAuthor`,
					Searchable: true, AllowClear: true, ClearLabel: '— add author —', Placeholder: 'Add an author…',
					DataProvider: this._authorDataProvider(), ResolveValue: () => Promise.resolve(null),
					OnChange: (v, pRecord) => { if (v) { this.addAuthor(v, pRecord && (pRecord.Text || pRecord.Name)); } },
				});
			if (tmpV && (typeof tmpV.render === 'function')) { tmpV.render(); }
		}
		if (tmpCA.getElement('#ObservationList-InclusionPicker').length > 0)
		{
			const tmpV = tmpPicker.createPicker(`${this.providerName}-InclusionPicker`,
				{
					DestinationAddress: '#ObservationList-InclusionPicker', ValueAddress: `AppData.${this.providerName}.PickerInclusion`,
					Searchable: true, AllowClear: true, ClearLabel: 'Any', Placeholder: 'Any',
					DataProvider: this._inclusionDataProvider(), ResolveValue: (v) => Promise.resolve(this._inclusionOption(v)),
					OnChange: (v) => this.setInclusion(v == null ? '' : String(v)),
				});
			if (tmpV && (typeof tmpV.render === 'function')) { tmpV.render(); }
			if (tmpV && (typeof tmpV.setValue === 'function')) { tmpV.setValue(this._filter.Inclusion || ''); }
		}
	}

	_projectDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'Projects/Lite', IDField: 'IDProject',
				ToOption: (r) => ({ Value: Number(r.IDProject), Text: r.Value || r.Name || `Project ${r.IDProject}`, Record: r }),
			});
	}
	_projectResolveValue() { return (v) => { const id = Number(v); if (!id) { return Promise.resolve(null); } return this._get(`Project/${id}`).then((r) => ((r && r.IDProject) ? { Value: id, Text: r.Name || `#${id}` } : { Value: id, Text: `#${id}` })).catch(() => ({ Value: id, Text: `#${id}` })); }; }

	/** Distinct label VALUES for the currently-selected project + active tag type (freeform Tag strings). */
	_labelValueDataProvider()
	{
		return (pTerm) =>
		{
			const tmpProj = this._filter.IDProject; const tmpType = this._activeTagType;
			if (!tmpProj || !tmpType) { return Promise.resolve({ results: [], hasMore: false }); }
			const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
			let flt = `FBV~IDProject~EQ~${tmpProj}~FBV~TagType~EQ~${encodeURIComponent(tmpType)}`;
			if (tmpTerm) { flt += `~FBV~Tag~LK~${encodeURIComponent(`%${tmpTerm}%`)}`; }
			return this._get(`ObservationTagProjectJoins/FilteredTo/${flt}~FSF~Tag~ASC~0/0/50`).then((rows) =>
			{
				const tmpSeen = {}; const tmpOut = [];
				(Array.isArray(rows) ? rows : []).forEach((r) => { const t = r.Tag; if (t && !tmpSeen[t]) { tmpSeen[t] = true; tmpOut.push({ Value: t, Text: t, Record: r }); } });
				return { results: tmpOut, hasMore: false };
			}).catch(() => ({ results: [], hasMore: false }));
		};
	}

	_authorDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._get(pURL), { Scope: 'FBV~Deleted~EQ~0', PageSize: 25 });
	}

	/** The fixed "In reports" (DocumentCount inclusion) vocabulary, served to a picker instead of a native <select>. */
	_INCLUSION_OPTIONS() { return [ { Value: '0', Text: 'Not in any report' }, { Value: '1', Text: 'In exactly one' }, { Value: '2', Text: 'In more than one' } ]; }
	_inclusionOption(pValue) { const v = String(pValue == null ? '' : pValue); return this._INCLUSION_OPTIONS().find((o) => o.Value === v) || null; }
	_inclusionDataProvider()
	{
		return (pTerm) =>
		{
			const t = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
			const rows = this._INCLUSION_OPTIONS().filter((o) => !t || o.Text.toLowerCase().indexOf(t) >= 0);
			return Promise.resolve({ results: rows, hasMore: false });
		};
	}
}

module.exports = ObservationListProvider;

module.exports.default_configuration = { ProviderIdentifier: 'ObservationList' };

// Categorical palette for the Charts view (curated mid-tones that read on the app's light theme).
const _CAT = [ '#2e7d74', '#3a86a8', '#6a6fae', '#9a6fb0', '#b5734e', '#4f9d69', '#c2708f', '#7f8b3d', '#c98a2e', '#5a8bce' ];
const _WARN = '#bd6631';
// Map view: how many of the most-recent filtered matches to fetch + plot. The match set can be in the millions, so we
// cap the plotted set (DateOfRecord-desc = "most recent N") and tell the user to refine the filter to see the rest.
const _MAP_FETCH = 2000;

const _CSS = /*css*/`
	/* Consistent horizontal gutter for the whole dashboard chrome (this screen runs full-bleed in Dashboard Mode, so the
	   page itself has no side padding). Standalone only — embedded in a Project tab the tab host supplies its own padding.
	   The wide results table full-bleeds back out to the edge (below) so it can still use the whole browser width. */
	.obl { width: 100%; --obl-gutter: clamp(1rem, 2.2vw, 2rem); }
	.obl:not(.obl-embedded) { padding-left: var(--obl-gutter); padding-right: var(--obl-gutter); }
	.obl.obl-embedded { --obl-gutter: 0px; }
	.obl-head { display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; margin: 0 0 0.8rem; }
	.obl-title { font-size: 1.1rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); display: inline-flex; align-items: center; gap: 0.5rem; }
	.obl-title i { color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-count { font-size: 0.85rem; font-weight: 600; color: var(--theme-color-text-muted,#6b7686); }
	.obl-filters { background: var(--theme-color-background-secondary,#f4f6f9); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 10px; padding: 0.75rem 0.85rem; margin: 0 0 1rem; }
	.obl-row { display: flex; align-items: flex-end; gap: 0.6rem 0.8rem; flex-wrap: wrap; }
	.obl-row-pickers { margin-top: 0.6rem; }
	.obl-search { position: relative; flex: 1 1 18rem; min-width: 14rem; }
	.obl-search-ic { position: absolute; left: 0.6rem; top: 50%; transform: translateY(-50%); color: var(--theme-color-text-muted,#9aa3af); font-size: 0.8rem; }
	.obl-search-in { width: 100%; font-size: 0.88rem; padding: 0.42rem 0.6rem 0.42rem 1.9rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); }
	.obl-f { display: flex; flex-direction: column; gap: 0.15rem; font-size: 0.82rem; }
	.obl-f-l { font-size: 0.64rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary,#45505f); }
	.obl-f input, .obl-f select { font-size: 0.85rem; padding: 0.38rem 0.5rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); }
	.obl-apply { font-size: 0.84rem; font-weight: 600; color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border: none; border-radius: 7px; padding: 0.42rem 0.85rem; cursor: pointer; }
	.obl-clear { font-size: 0.84rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: transparent; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; padding: 0.42rem 0.75rem; cursor: pointer; }
	.obl-pick { display: flex; flex-direction: column; gap: 0.15rem; flex: 1 1 16rem; min-width: 13rem; }
	.obl-picker { min-width: 12rem; }
	.obl-tags { display: flex; gap: 0.3rem; flex-wrap: wrap; margin-top: 0.3rem; }
	.obl-tag { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.76rem; font-weight: 600; color: var(--theme-color-text-primary,#1f2733); background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 999px; padding: 0.08rem 0.2rem 0.08rem 0.5rem; }
	.obl-tag-x { border: none; background: transparent; color: var(--theme-color-text-muted,#98a2b3); cursor: pointer; font-size: 0.95rem; line-height: 1; }
	.obl-labelhint { margin-top: 0.6rem; font-size: 0.8rem; color: var(--theme-color-text-muted,#8894a4); display: flex; align-items: center; gap: 0.4rem; }
	.obl-labels-filter { margin-top: 0.6rem; display: flex; align-items: center; gap: 0.5rem 0.7rem; flex-wrap: wrap; }
	.obl-labeltype { font-size: 0.85rem; padding: 0.36rem 0.5rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); }
	.obl-labelpicker { min-width: 14rem; }
	.obl-matchall { font-size: 0.8rem; color: var(--theme-color-text-secondary,#45505f); display: inline-flex; align-items: center; gap: 0.3rem; cursor: pointer; }
	.obl-label-chips { display: flex; gap: 0.5rem; flex-wrap: wrap; flex-basis: 100%; }
	.obl-label-grp { display: inline-flex; align-items: center; gap: 0.3rem; flex-wrap: wrap; }
	.obl-label-gt { font-size: 0.66rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted,#7a8794); }
	.obl-types { margin-top: 0.6rem; display: flex; align-items: baseline; gap: 0.6rem; }
	.obl-chips { display: flex; gap: 0.3rem; flex-wrap: wrap; }
	.obl-chip { font-size: 0.76rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 999px; padding: 0.15rem 0.6rem; cursor: pointer; }
	.obl-chip-on { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-chip-n { font-size: 0.68rem; font-weight: 800; opacity: 0.6; font-variant-numeric: tabular-nums; }
	.obl-chip-on .obl-chip-n { opacity: 0.85; }
	.obl-empty { padding: 2.4rem 1rem; text-align: center; color: var(--theme-color-text-muted,#8a94a3); font-size: 0.9rem; }
	.obl-empty.obl-error { color: var(--theme-color-status-danger,#c0392b); }
	.obl-spin { display: inline-block; width: 1rem; height: 1rem; border: 2px solid var(--theme-color-border-medium,#d5dbe3); border-top-color: var(--theme-color-brand-primary,#2e7d74); border-radius: 50%; animation: obl-sp 0.7s linear infinite; vertical-align: -2px; }
	@keyframes obl-sp { to { transform: rotate(360deg); } }
	.obl-listwrap { width: auto; overflow-x: auto; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 10px; }
	/* Wide tabular data uses the WHOLE browser width + scrolls: cancel the chrome gutter so the table band reaches the edges. */
	.obl:not(.obl-embedded) .obl-listwrap { margin-left: calc(-1 * var(--obl-gutter)); margin-right: calc(-1 * var(--obl-gutter)); border-left: none; border-right: none; border-radius: 0; }
	.obl-list { width: 100%; border-collapse: collapse; font-size: 0.86rem; }
	.obl-list th { text-align: left; font-size: 0.64rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#6b7686); background: var(--theme-color-background-tertiary,#f4f6f9); padding: 0.5rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light,#e8ebf0); white-space: nowrap; }
	.obl-list td { padding: 0.45rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light,#f1f4f8); vertical-align: middle; }
	.obl-r { cursor: pointer; }
	.obl-r:hover td { background: var(--theme-color-background-secondary,#f6f8fb); }
	.obl-thumb-cell { width: 3.4rem; }
	.obl-thumb { width: 3rem; height: 3rem; object-fit: cover; border-radius: 6px; border: 1px solid var(--theme-color-border-light,#e8ebf0); display: block; }
	.obl-thumb-broken, .obl-thumb-none { display: inline-flex; align-items: center; justify-content: center; color: var(--theme-color-text-muted,#c2c9d3); background: var(--theme-color-background-secondary,#eef1f6); font-size: 1rem; }
	.obl-thumb-broken { }
	.obl-type { font-size: 0.72rem; font-weight: 700; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border-radius: 5px; padding: 0.08rem 0.4rem; white-space: nowrap; }
	.obl-obscell { min-width: 16rem; } .obl-obsname { display: block; color: var(--theme-color-text-primary,#1f2733); } .obl-obsid { display: block; font-size: 0.72rem; color: var(--theme-color-text-muted,#9aa3af); }
	.obl-proj { color: var(--theme-color-text-secondary,#45505f); }
	.obl-nowrap { white-space: nowrap; }
	.obl-num { text-align: right; font-variant-numeric: tabular-nums; }
	.obl-pager { display: flex; align-items: center; justify-content: center; gap: 1rem; padding: 0.9rem; }
	.obl-pg { font-size: 0.84rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; padding: 0.35rem 0.7rem; cursor: pointer; }
	.obl-pg[disabled] { opacity: 0.45; cursor: default; }
	.obl-pg-info { font-size: 0.82rem; color: var(--theme-color-text-muted,#6b7686); font-variant-numeric: tabular-nums; }

	/* --- view switcher (List / Charts / Map) --- */
	.obl-viewtabs { display: inline-flex; gap: 0.15rem; padding: 0.2rem; background: var(--theme-color-background-secondary,#eef1f6); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 10px; margin: 0 0 1rem; }
	.obl-vtab { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-secondary,#54636e); background: transparent; border: none; border-radius: 7px; padding: 0.38rem 0.85rem; cursor: pointer; }
	.obl-vtab i { font-size: 0.78rem; opacity: 0.8; }
	.obl-vtab:hover { color: var(--theme-color-text-primary,#1f2733); }
	.obl-vtab-on { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); box-shadow: 0 1px 2px rgba(20,40,50,0.12); }
	.obl-vtab-on i { opacity: 1; }

	/* --- charts view (facet panels) --- */
	.oxp { width: 100%; }
	.oxp-badge-row { display: flex; justify-content: flex-end; margin: 0 0 0.7rem; }
	.oxp-badge { display: inline-flex; align-items: center; gap: 0.5rem; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 999px; padding: 0.35rem 0.8rem; font-size: 0.76rem; color: var(--theme-color-text-muted,#6b7686); white-space: nowrap; }
	.oxp-badge b { color: var(--theme-color-brand-primary,#2e7d74); font-variant-numeric: tabular-nums; }
	.oxp-pulse { width: 0.5rem; height: 0.5rem; border-radius: 50%; background: #2f8f5b; }
	.oxp-pulse-busy { background: var(--theme-color-brand-primary,#2e7d74); animation: oxp-blink 0.7s linear infinite; }
	@keyframes oxp-blink { 50% { opacity: 0.25; } }
	.oxp-kpis { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.85rem; margin: 0 0 0.9rem; }
	.oxp-kpi { background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 13px; padding: 0.9rem 1rem; position: relative; overflow: hidden; }
	.oxp-eyebrow { font-size: 0.62rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; color: var(--theme-color-text-muted,#8b98a3); }
	.oxp-v { font-size: 1.85rem; font-weight: 800; line-height: 1; margin: 0.5rem 0 0.3rem; letter-spacing: -0.02em; color: var(--theme-color-text-primary,#1f2733); font-variant-numeric: tabular-nums; }
	.oxp-l { font-size: 0.76rem; color: var(--theme-color-text-muted,#6b7686); } .oxp-l-sub { color: var(--theme-color-text-muted,#9aa3af); font-variant-numeric: tabular-nums; }
	.oxp-kpi-warn .oxp-v { color: #bd6631; } .oxp-kpi-warn::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 3px; background: #bd6631; }
	.oxp-grid { display: grid; grid-template-columns: 1.15fr 0.85fr; gap: 0.85rem; align-items: start; }
	.oxp-panel { background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e2e8ec); border-radius: 13px; padding: 0.9rem 1rem 1rem; min-width: 0; }
	.oxp-ph { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; margin: 0 0 0.8rem; }
	.oxp-ph h3 { font-size: 0.92rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); display: flex; align-items: center; gap: 0.45rem; margin: 0; }
	.oxp-ph h3 i { color: var(--theme-color-brand-primary,#2e7d74); font-size: 0.85rem; }
	.oxp-hint { font-size: 0.68rem; color: var(--theme-color-text-muted,#9aa3af); }
	.oxp-rows { display: flex; flex-direction: column; gap: 0.15rem; }
	.oxp-row { display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 0.6rem; padding: 0.32rem 0.5rem; border-radius: 8px; cursor: pointer; position: relative; border: 1px solid transparent; }
	.oxp-row:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.oxp-row-on { background: var(--theme-color-brand-primary-subtle,#e3f1ee); border-color: color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 32%, transparent); }
	.oxp-row-bg { position: absolute; left: 0.5rem; right: 0.5rem; top: 0.2rem; bottom: 0.2rem; border-radius: 6px; z-index: 0; transition: width 0.5s cubic-bezier(.22,1,.36,1); }
	.oxp-lab { display: flex; align-items: center; gap: 0.55rem; min-width: 0; z-index: 1; }
	.oxp-dot { width: 0.6rem; height: 0.6rem; border-radius: 3px; flex: none; }
	.oxp-name { font-size: 0.82rem; color: var(--theme-color-text-primary,#1f2733); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.oxp-row-on .oxp-name { font-weight: 600; color: var(--theme-color-brand-primary,#2e7d74); }
	.oxp-cnt { font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-secondary,#54636e); font-variant-numeric: tabular-nums; z-index: 1; }
	.oxp-row-on .oxp-cnt { color: var(--theme-color-brand-primary,#2e7d74); }
	.oxp-track { position: absolute; left: 0.5rem; right: 0.5rem; bottom: 0.15rem; height: 2px; border-radius: 2px; background: var(--theme-color-border-light,#eef2f4); overflow: hidden; z-index: 0; }
	.oxp-fill { position: absolute; left: 0; top: 0; bottom: 0; border-radius: 2px; transition: width 0.5s cubic-bezier(.22,1,.36,1); }
	.oxp-stack { display: flex; height: 2.4rem; border-radius: 9px; overflow: hidden; border: 1px solid var(--theme-color-border-light,#e2e8ec); margin: 0 0 0.7rem; }
	.oxp-seg { height: 100%; cursor: pointer; transition: width 0.5s cubic-bezier(.22,1,.36,1), opacity 0.15s; min-width: 2px; }
	.oxp-seg:hover { filter: brightness(1.07); } .oxp-seg-dim { opacity: 0.3; }
	.oxp-flegend { display: flex; flex-direction: column; gap: 0.25rem; }
	.oxp-fl { display: grid; grid-template-columns: auto 1fr auto auto; align-items: center; gap: 0.6rem; padding: 0.3rem 0.5rem; border-radius: 8px; cursor: pointer; font-size: 0.82rem; border: 1px solid transparent; }
	.oxp-fl:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.oxp-fl-on { background: var(--theme-color-brand-primary-subtle,#e3f1ee); border-color: color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 30%, transparent); }
	.oxp-sw { width: 0.7rem; height: 0.7rem; border-radius: 3px; } .oxp-fname { color: var(--theme-color-text-primary,#1f2733); }
	.oxp-fpct { color: var(--theme-color-text-muted,#9aa3af); font-variant-numeric: tabular-nums; } .oxp-fcnt { font-weight: 600; font-variant-numeric: tabular-nums; color: var(--theme-color-text-secondary,#54636e); }
	.oxp-callout { margin-top: 0.75rem; display: flex; gap: 0.6rem; align-items: flex-start; background: #f5e7db; border: 1px solid color-mix(in srgb, #bd6631 26%, transparent); border-radius: 10px; padding: 0.6rem 0.75rem; }
	.oxp-callout i { color: #bd6631; margin-top: 0.1rem; } .oxp-callout p { margin: 0; font-size: 0.76rem; color: var(--theme-color-text-primary,#1f2733); } .oxp-callout b { color: #bd6631; }
	.oxp-callout a { color: var(--theme-color-brand-primary,#2e7d74); font-weight: 600; text-decoration: none; white-space: nowrap; }
	.oxp-foot { margin-top: 1rem; font-size: 0.72rem; color: var(--theme-color-text-muted,#9aa3af); line-height: 1.6; } .oxp-foot i { color: #2f8f5b; } .oxp-foot b { color: var(--theme-color-text-secondary,#54636e); }

	/* --- map view (Leaflet + docked responsive sidebar) --- */
	.obl-maprow { display: grid; grid-template-columns: 1fr 22rem; gap: 0.9rem; align-items: start; }
	.obl-map { height: 70vh; min-height: 30rem; border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 12px; overflow: hidden; position: relative; z-index: 0; }
	.obl-side { align-self: start; min-width: 0; }
	.obl-mut { color: var(--theme-color-text-muted,#9aa3af); }
	.obl-side-sum-wrap:empty { display: none; }
	.obl-side-sum { font-size: 0.8rem; line-height: 1.4; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#f4f6f9); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 9px; padding: 0.5rem 0.6rem; margin: 0 0 0.65rem; }
	.obl-side-sum b { color: var(--theme-color-brand-primary,#2e7d74); font-variant-numeric: tabular-nums; }
	.obl-side-hint { font-size: 0.76rem; color: var(--theme-color-text-muted,#8a94a3); padding: 0.55rem 0.2rem 0; display: flex; align-items: center; gap: 0.4rem; }
	.obl-side-hint i { color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-legend { background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 12px; padding: 0.75rem 0.85rem; }
	.obl-legend-h { display: flex; align-items: baseline; justify-content: space-between; gap: 0.5rem; font-size: 0.66rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#8b98a3); margin: 0 0 0.5rem; }
	.obl-legend-h .obl-mut { text-transform: none; letter-spacing: 0; font-weight: 600; font-size: 0.68rem; }
	.obl-legend-list { display: flex; flex-direction: column; gap: 0.15rem; max-height: 52vh; overflow: auto; }
	.obl-legend-i { display: flex; align-items: center; gap: 0.5rem; font-size: 0.82rem; padding: 0.28rem 0.4rem; border-radius: 7px; cursor: pointer; border: 1px solid transparent; }
	.obl-legend-i:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.obl-legend-on { background: var(--theme-color-brand-primary-subtle,#e3f1ee); border-color: color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 30%, transparent); }
	.obl-legend-dot { width: 0.7rem; height: 0.7rem; border-radius: 3px; flex: none; }
	.obl-legend-v { flex: 1; min-width: 0; color: var(--theme-color-text-primary,#1f2733); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.obl-legend-on .obl-legend-v { font-weight: 600; color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-legend-c { font-size: 0.78rem; font-weight: 700; color: var(--theme-color-text-secondary,#54636e); font-variant-numeric: tabular-nums; }
	/* docked detail panel */
	.obl-side-detail { background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 12px; display: flex; flex-direction: column; overflow: hidden; max-height: 74vh; }
	.obl-side-top { position: relative; padding: 0.7rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light,#e8ebf0); flex: 0 0 auto; }
	.obl-side-idrow { display: flex; align-items: flex-start; gap: 0.6rem; padding-right: 1.4rem; }
	.obl-side-thumb { width: 3.2rem; height: 3.2rem; flex: 0 0 auto; object-fit: cover; border-radius: 8px; border: 1px solid var(--theme-color-border-light,#e8ebf0); display: block; }
	.obl-side-thumb-none, .obl-side-thumb-broken { display: inline-flex; align-items: center; justify-content: center; background: var(--theme-color-background-secondary,#eef1f6); color: var(--theme-color-text-muted,#c2c9d3); font-size: 1.1rem; }
	.obl-side-idtext { min-width: 0; flex: 1; }
	.obl-side-name { display: block; font-size: 0.9rem; font-weight: 800; line-height: 1.28; color: var(--theme-color-text-primary,#1f2733); word-break: break-word; }
	.obl-side-x { position: absolute; top: 0.55rem; right: 0.55rem; border: none; background: transparent; color: var(--theme-color-text-muted,#98a2b3); cursor: pointer; font-size: 1rem; line-height: 1; padding: 0.1rem 0.2rem; }
	.obl-side-x:hover { color: var(--theme-color-text-primary,#1f2733); }
	.obl-side-sub { display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem 0.5rem; margin-top: 0.35rem; font-size: 0.74rem; }
	.obl-side-scroll { padding: 0.75rem 0.8rem; overflow: auto; flex: 1 1 auto; }
	.obl-props { display: grid; grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr)); gap: 0.55rem 0.7rem; }
	.obl-side-data { margin-top: 0.9rem; border-top: 1px solid var(--theme-color-border-light, #eef1f5); padding-top: 0.6rem; }
	.obl-side-data-h { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.4rem; }
	.obl-side-data .hor-slots { grid-template-columns: 1fr; }
	.obl-note { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.8rem; }
	.obl-prop-type { display: inline-flex; align-items: center; gap: 0.4rem; }
	.obl-prop { min-width: 0; }
	.obl-prop-l { font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted,#8b98a3); line-height: 1.2; }
	.obl-prop-v { font-size: 0.86rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); word-break: break-word; margin-top: 0.1rem; }
	.obl-prop-u { font-size: 0.7rem; font-weight: 600; color: var(--theme-color-text-muted,#9aa3af); }
	.obl-rep { display: inline-block; font-size: 0.74rem; font-weight: 700; border-radius: 5px; padding: 0.05rem 0.4rem; }
	.obl-rep-0 { color: #bd6631; background: #f5e7db; }
	.obl-rep-1 { color: var(--theme-color-brand-primary,#2e7d74); background: var(--theme-color-brand-primary-subtle,#e3f1ee); }
	.obl-side-foot { padding: 0.6rem 0.8rem; border-top: 1px solid var(--theme-color-border-light,#e8ebf0); flex: 0 0 auto; }
	.obl-side-btn { display: flex; align-items: center; justify-content: center; gap: 0.4rem; width: 100%; font-size: 0.82rem; font-weight: 600; color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-radius: 7px; padding: 0.45rem 0.75rem; text-decoration: none; }
	.obl-side-btn:hover { filter: brightness(1.05); }
	@media (max-width: 900px) { .obl-maprow { grid-template-columns: 1fr; } .obl-side-detail { max-height: none; } .obl-map { height: 55vh; min-height: 22rem; } }

	/* --- view-tabs row (tabs left, live count right) --- */
	.obl-viewtabs-row { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
	.obl-viewtabs { margin: 0; }
	.obl-vtabcount { font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-muted,#6b7686); font-variant-numeric: tabular-nums; }
	.obl-vtabs-right { display: flex; align-items: center; gap: 0.55rem 0.9rem; flex-wrap: wrap; }
	.obl-embedded .obl-filters { margin-top: 0; }

	/* --- full-screen toggle + overlay --- */
	.obl-fsbtn { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.8rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 8px; padding: 0.36rem 0.7rem; cursor: pointer; white-space: nowrap; }
	.obl-fsbtn:hover { border-color: var(--theme-color-brand-primary,#2e7d74); color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-fsbtn i { font-size: 0.78rem; opacity: 0.85; }
	.obl-fsbtn-on { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-fsbtn-on:hover { color: #fff; filter: brightness(1.05); }
	.obl-fsbtn-on i { opacity: 1; }
	/* The overlay fills the whole browser view, above the app nav (Bulma navbar z-index is 30). No ancestor sets a
	   transform/filter/contain, so position:fixed anchors to the viewport. It keeps the same side gutter as normal. */
	.obl.obl-fs { position: fixed; inset: 0; z-index: 1100; overflow: auto; background: var(--theme-color-background-tertiary,#f3f4f6); padding-top: 1.1rem; padding-bottom: 1.6rem; transform: translateZ(0); }

	/* --- Observation Types dropdown-checklist --- */
	.obl-typedd { position: relative; display: inline-block; }
	.obl-ddbtn { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.85rem; padding: 0.38rem 0.6rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); color: var(--theme-color-text-primary,#1f2733); cursor: pointer; white-space: nowrap; min-width: 8.5rem; justify-content: space-between; }
	.obl-ddbtn:hover { border-color: var(--theme-color-brand-primary,#2e7d74); }
	.obl-ddbtn-open { border-color: var(--theme-color-brand-primary,#2e7d74); box-shadow: 0 0 0 2px color-mix(in srgb, var(--theme-color-brand-primary,#2e7d74) 18%, transparent); }
	.obl-ddbtn-l { overflow: hidden; text-overflow: ellipsis; }
	.obl-ddcaret { font-size: 0.7rem; color: var(--theme-color-text-muted,#8894a4); }
	.obl-ddbadge { background: var(--theme-color-brand-primary,#2e7d74); color: #fff; font-size: 0.66rem; font-weight: 700; border-radius: 999px; padding: 0.02rem 0.4rem; font-variant-numeric: tabular-nums; }
	.obl-ddpanel { position: absolute; top: calc(100% + 0.35rem); left: 0; z-index: 40; width: 19rem; max-width: 82vw; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 9px; box-shadow: 0 12px 30px -12px rgba(20,40,50,0.3); overflow: hidden; }
	.obl-ddpanel-head { display: flex; align-items: center; justify-content: space-between; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light,#eef2f4); font-size: 0.66rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#8b98a3); }
	.obl-ddclearbtn { border: none; background: transparent; color: var(--theme-color-brand-primary,#2e7d74); font: inherit; font-size: 0.7rem; font-weight: 700; cursor: pointer; text-transform: none; letter-spacing: 0; }
	.obl-ddclearbtn:hover { text-decoration: underline; }
	.obl-ddlist { max-height: 17rem; overflow-y: auto; padding: 0.3rem; }
	.obl-dditem { display: flex; align-items: center; gap: 0.55rem; padding: 0.35rem 0.5rem; border-radius: 6px; cursor: pointer; font-size: 0.85rem; }
	.obl-dditem:hover { background: var(--theme-color-background-secondary,#f5f8f9); }
	.obl-dditem input { accent-color: var(--theme-color-brand-primary,#2e7d74); width: 0.95rem; height: 0.95rem; cursor: pointer; flex: none; }
	.obl-ddname { flex: 1; color: var(--theme-color-text-primary,#1f2733); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.obl-dditem-on .obl-ddname { font-weight: 600; }
	.obl-ddcount { font-size: 0.74rem; color: var(--theme-color-text-muted,#9aa3af); font-variant-numeric: tabular-nums; }
	.obl-ddempty { padding: 0.6rem; color: var(--theme-color-text-muted,#9aa3af); font-size: 0.82rem; text-align: center; }

	@media (max-width: 900px) { .oxp-kpis { grid-template-columns: repeat(2, 1fr); } .oxp-grid { grid-template-columns: 1fr; } }
	@media (prefers-reduced-motion: reduce) { .oxp-fill, .oxp-seg, .oxp-row-bg { transition: none; } .oxp-pulse-busy { animation: none; } }
`;

},{"../access/User-Search.js":1064,"../services/Entity-Picker-Search.js":1398,"pict-provider":845}],1297:[function(require,module,exports){
'use strict';

/**
 * Project Funding — data/logic provider (slice 1: primary load + funding-config setup + accounting overview).
 *
 * A port of the Vue project-funding screen (web/contract_admin/src/app/funding/projectFunding) onto this pict app.
 * It does NOT touch raw Meadow entities; it rides the bespoke `Finance/*` API (served at /1.0/Finance/… through
 * the same gateway), whose shapes were confirmed against the live API:
 *
 *   GET  Finance/Bundle/Digest/Project/{id}      → { Bundle:{ Digest, FundingConfiguration, ProjectFundingSolution,
 *                                                    MasterLists, FeatureToggles }, Key }   (primary load)
 *   GET  Finance/FundingConfiguration/For/Project/{id}  → { Config:[…], LineItems, Indications }
 *   PUT  …/Category   { Key, Name, Code }                        add a funding category
 *   PUT  …/Source     { Key, Name, Hash, …, Category:{Key} }     add a funding source under a category bucket
 *   PUT  …/Funds      [ { Key, Sequence, Weight, …, FundingSource:{Key} } ]  add fund(s) under a source bucket
 *   PUT  …/Buckets    [ { BucketKey, Changes:{…} } ]             edit staged bucket fields
 *   POST …/Buckets/Delete  [ bucketKey, … ]                      remove a bucket (+ its subtree)
 *   GET  Finance/FundingSolution/For/Project/{id}  → { Solution:{ …outcomes, Violations[] }, TransactionLog }
 *   GET  Finance/Profile/Customer/{id}   → { profile:{ Funds, FundingSources, FundingCategories } }  (add-dialog masters)
 *
 * The config is a nested tree of pipe-keyed "buckets": Config[] = category buckets → FundingSourceBuckets[] →
 * FundBuckets[]. Every edit/delete addresses a bucket by its `Key`. Every edit commits immediately.
 *
 * Later slices: per-line-item funding, funding simulation, purchase-order export.
 */

const libPictProvider = require('pict-provider');
const libProjectChangeOrderGating = require('../change-orders/ProjectChangeOrderGating.js');

class ProjectFundingProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._idProject = 0;
		this._idCustomer = 0;
		this._profile = null;          // { Funds, FundingSources, FundingCategories } — lazy, for add-dialog pickers
		this._profilePromise = null;   // in-flight profile fetch, so concurrent add-dialog opens share one load
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get workspaceState()
	{
		if (!this.pict.AppData.ProjectFunding)
		{
			this.pict.AppData.ProjectFunding =
			{
				Loading: false, Message: '', HasModel: false, ProjectName: '', IDProject: 0,
				Config: [], LineItems: [], ProjectCategories: [], FeatureToggles: {}, Digest: {}, Solution: {}, CanManage: false,
			};
		}
		return this.pict.AppData.ProjectFunding;
	}

	get idProject() { return this._idProject; }
	get config() { return this.workspaceState.Config || []; }
	get profile() { return this._profile; }
	get featureToggles() { return this.workspaceState.FeatureToggles || {}; }
	canExportPurchaseOrder() { return !!this.featureToggles.EnablePurchaseOrderExport; }

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }

	_render() { if (this.pict.views['ProjectFunding']) { this.pict.views['ProjectFunding'].render(); } }

	// --- Permissions --------------------------------------------------------------------------------

	get permissions() { return this.pict.fable.EffectivePermissionsService; }

	/** Fail-closed manage gate: the funding config wires funding sources to a project, so the representative grant is
	 *  FundingSource-Project-Associate (part of the 'associate-funding' entitlement). Super-users pass; the Finance
	 *  API is the real authority. */
	canManage()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return false; }
		return tmpPermissions.canHash('FundingSource-Project-Associate') || tmpPermissions.canHash('FundingSource-Project-Disassociate');
	}

	// --- Front door ---------------------------------------------------------------------------------

	/** Search the customer's projects by name (front-door picker; mirrors ImportantFiles / Sample Plan). */
	async searchProjectsAsync(pTerm)
	{
		const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
		let tmpFilter = 'FBV~Deleted~EQ~0';
		if (tmpTerm) { tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`; }
		const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}/0/100`).catch(() => []);
		return (Array.isArray(tmpRows) ? tmpRows : [])
			.map((pRow) => ({ IDProject: pRow.IDProject, Name: pRow.Value || pRow.Name || `Project ${pRow.IDProject}` }))
			.sort((pA, pB) => (pA.Name.toLowerCase() < pB.Name.toLowerCase() ? -1 : (pA.Name.toLowerCase() > pB.Name.toLowerCase() ? 1 : 0)));
	}

	resetToPicker()
	{
		const tmpState = this.workspaceState;
		tmpState.Loading = false; tmpState.Message = ''; tmpState.HasModel = false; tmpState.ProjectName = ''; tmpState.IDProject = 0;
		tmpState.Config = []; tmpState.LineItems = []; tmpState.ProjectCategories = []; tmpState.Digest = {}; tmpState.Solution = {}; tmpState.FeatureToggles = {};
		this._idProject = 0;
	}

	// --- Loading ------------------------------------------------------------------------------------

	/** Primary load: the digest bundle (config + solution + digest + toggles) + the project name. */
	async loadAsync(pIDProject)
	{
		const tmpState = this.workspaceState;
		this._idProject = pIDProject;
		// The finance profile + funding are customer-scoped; take the customer from the live session so a failed
		// Project/{id} fetch can't leave it 0 (which would fetch Finance/Profile/Customer/0 → empty add-pickers).
		this._idCustomer = (this.permissions && this.permissions._currentUserCap && this.permissions._currentUserCap.IDContext) || this._idCustomer || 0;
		tmpState.Loading = true; tmpState.Message = ''; tmpState.HasModel = false; tmpState.IDProject = pIDProject;
		this._render();
		try
		{
			const [ tmpBundleResp, tmpProject ] = await Promise.all(
				[
					this._getJSON(`Finance/Bundle/Digest/Project/${pIDProject}`),
					this._getJSON(`Project/${pIDProject}`).catch(() => null),
				]);
			const tmpBundle = (tmpBundleResp && (tmpBundleResp.Bundle || tmpBundleResp)) || {};
			this._applyBundle(tmpBundle);
			this._idCustomer = this._idCustomer || (tmpProject && (tmpProject.IDCustomer || tmpProject.CustomerID)) || 0;
			tmpState.ProjectName = (tmpProject && (tmpProject.Name || tmpProject.Description)) || `Project ${pIDProject}`;
			tmpState.CanManage = this.canManage();
			// Change-order gating: when the project's status requires a Change Order, direct line-item edits (here,
			// funding-category assignment, which writes LineItem.IDFundingCategory) are locked (see the reference's
			// ProjectChangeOrderGating). Best-effort; a failure leaves funding directly editable.
			try
			{
				const tmpGating = await libProjectChangeOrderGating.fetchProjectChangeOrderGating((pURL) => this._getJSON(pURL), pIDProject, tmpProject);
				tmpState.RequiresChangeOrder = !!tmpGating.requires;
				tmpState.ProjectStatus = tmpGating.status || '';
			}
			catch (pError) { tmpState.RequiresChangeOrder = false; }
			tmpState.HasModel = true;
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			this.pict.log.error(`ProjectFunding: failed to load project ${pIDProject}: ${pError && pError.message ? pError.message : pError}`, pError);
			tmpState.Loading = false; tmpState.HasModel = false;
			tmpState.Message = 'Could not load this project’s funding.';
			this._render();
		}
	}

	/** Fold the digest-bundle payload into state. */
	_applyBundle(pBundle)
	{
		const tmpState = this.workspaceState;
		const tmpConfig = pBundle.FundingConfiguration || {};
		this._applyConfigShape(tmpConfig);
		tmpState.Digest = pBundle.Digest || {};
		tmpState.Solution = (pBundle.ProjectFundingSolution && (pBundle.ProjectFundingSolution.Solution || pBundle.ProjectFundingSolution)) || {};
		tmpState.FeatureToggles = pBundle.FeatureToggles || {};
	}

	/** Apply a FundingConfiguration payload (Config tree + line items + the project's category list) to state. */
	_applyConfigShape(pConfig)
	{
		const tmpState = this.workspaceState;
		if (!pConfig) { return; }
		if (Array.isArray(pConfig.Config)) { tmpState.Config = pConfig.Config; }
		if (Array.isArray(pConfig.LineItems)) { tmpState.LineItems = pConfig.LineItems; }
		if (Array.isArray(pConfig.FundingCategories)) { tmpState.ProjectCategories = pConfig.FundingCategories; }
	}

	/** Fold a funding-config mutation response into state (its body IS the updated config). Returns the
	 *  RefreshFundingSolution indication so the caller knows whether to re-pull the solution. */
	_applyConfigResponse(pResponse)
	{
		this._applyConfigShape(pResponse);
		return pResponse && pResponse.Indications && pResponse.Indications.RefreshFundingSolution;
	}

	/** Authoritative config re-pull (GET) — used after mutations whose response may not carry the full shape
	 *  (line-item funding, category add/remove), so the tree + line items + category list all stay in sync. */
	async refreshConfigAsync()
	{
		try
		{
			const tmpResp = await this._getJSON(this._base());
			this._applyConfigShape(tmpResp && (tmpResp.FundingConfiguration || tmpResp));
		}
		catch (pError) { this.pict.log.warn(`ProjectFunding: config refresh failed: ${pError && pError.message ? pError.message : pError}`); }
	}

	async refreshSolutionAsync()
	{
		try
		{
			const tmpSol = await this._getJSON(`Finance/FundingSolution/For/Project/${this._idProject}`);
			this.workspaceState.Solution = (tmpSol && (tmpSol.Solution || tmpSol)) || {};
		}
		catch (pError) { this.pict.log.warn(`ProjectFunding: solution refresh failed: ${pError && pError.message ? pError.message : pError}`); }
	}

	async refreshDigestAsync()
	{
		try
		{
			const tmpDigest = await this._getJSON(`Finance/Digest/Project/${this._idProject}`);
			this.workspaceState.Digest = (tmpDigest && (tmpDigest.Digest || tmpDigest)) || this.workspaceState.Digest;
		}
		catch (pError) { this.pict.log.warn(`ProjectFunding: digest refresh failed: ${pError && pError.message ? pError.message : pError}`); }
	}

	/** After a mutation: apply the returned config, then refresh digest + (if signalled) the solution, then paint.
	 *  pQuiet (a field edit — no structural bucket change) asks the view to update the accounting + computed cells
	 *  in place instead of rebuilding the whole grid, so the user's focus + in-progress edits in other cells survive. */
	async _afterMutationAsync(pResponse, pQuiet)
	{
		const tmpRefreshSolution = this._applyConfigResponse(pResponse);
		// Structural changes (add/remove category/source/fund) can change the line-item + category lists too, and
		// the mutation response doesn't always carry them — re-pull the full config authoritatively. A field edit
		// (quiet) only touches bucket fields, so the response's Config is enough (and a re-pull would reorder).
		if (!pQuiet) { await this.refreshConfigAsync(); }
		await Promise.all([ this.refreshDigestAsync(), tmpRefreshSolution ? this.refreshSolutionAsync() : Promise.resolve() ]);
		this.workspaceState.CanManage = this.canManage();
		const tmpView = this.pict.views['ProjectFunding'];
		if (pQuiet && tmpView && (typeof tmpView.afterFieldSave === 'function')) { tmpView.afterFieldSave(); }
		else { this._render(); }
	}

	// --- Add-dialog master lists (lazy) -------------------------------------------------------------

	/** Load the customer's funds / funding sources / categories for the add pickers. Cached; the lists are large
	 *  (10k+), so this is deferred until an add-dialog opens rather than carried on the primary load. */
	loadProfileAsync()
	{
		if (this._profile) { return Promise.resolve(this._profile); }
		if (this._profilePromise) { return this._profilePromise; }   // coalesce concurrent opens onto one fetch
		const tmpCustomer = this._idCustomer || (this.permissions && this.permissions._currentUserCap && this.permissions._currentUserCap.IDContext) || 0;
		this._profilePromise = (async () =>
		{
			try
			{
				if (!tmpCustomer) { throw new Error('No customer in scope for the finance profile.'); }
				const tmpResp = await this._getJSON(`Finance/Profile/Customer/${tmpCustomer}`);
				this._profile = (tmpResp && tmpResp.profile) || { Funds: [], FundingSources: [], FundingCategories: [] };
			}
			catch (pError)
			{
				this.pict.log.error(`ProjectFunding: could not load the finance profile: ${pError && pError.message ? pError.message : pError}`, pError);
				// Leave _profile null so a later open retries; return an empty shell to the current caller.
				return { Funds: [], FundingSources: [], FundingCategories: [] };
			}
			finally { this._profilePromise = null; }
			return this._profile;
		})();
		return this._profilePromise;
	}

	// --- Config lookups -----------------------------------------------------------------------------

	/** Find any bucket (category / source / fund) in the config tree by its pipe Key. Returns { node, type, parent }. */
	findBucket(pKey)
	{
		const tmpConfig = this.config;
		for (let c = 0; c < tmpConfig.length; c++)
		{
			const tmpCat = tmpConfig[c];
			if (tmpCat.Key === pKey) { return { node: tmpCat, type: 'category', parent: null }; }
			const tmpSources = tmpCat.FundingSourceBuckets || [];
			for (let s = 0; s < tmpSources.length; s++)
			{
				const tmpSrc = tmpSources[s];
				if (tmpSrc.Key === pKey) { return { node: tmpSrc, type: 'source', parent: tmpCat }; }
				const tmpFunds = tmpSrc.FundBuckets || [];
				for (let f = 0; f < tmpFunds.length; f++)
				{
					if (tmpFunds[f].Key === pKey) { return { node: tmpFunds[f], type: 'fund', parent: tmpSrc }; }
				}
			}
		}
		return null;
	}

	// --- Mutations ----------------------------------------------------------------------------------

	_assertCanManage() { if (!this.canManage()) { throw new Error('You don’t have permission to configure funding for this project.'); } }

	_base() { return `Finance/FundingConfiguration/For/Project/${this._idProject}`; }

	/** Add a funding category to the project (pCategory = a profile FundingCategory { Key, Name, Code }). */
	async addCategoryAsync(pCategory)
	{
		this._assertCanManage();
		if (!pCategory || !pCategory.Key) { throw new Error('Pick a funding category.'); }
		const tmpResp = await this._putJSON(`${this._base()}/Category`, { Key: pCategory.Key, Name: pCategory.Name || '', Code: pCategory.Code || '' });
		await this._afterMutationAsync(tmpResp);
	}

	/** Add a funding source under a category bucket (pSource = a profile FundingSource; pCategoryBucketKey = the
	 *  category bucket's pipe Key). Seeds the default editable fields the source dialog uses. */
	async addSourceAsync(pSource, pCategoryBucketKey)
	{
		this._assertCanManage();
		if (!pSource || !pSource.Key) { throw new Error('Pick a funding source.'); }
		if (!pCategoryBucketKey) { throw new Error('Choose the category to add it under.'); }
		const tmpBody =
		{
			Key: pSource.Key, Name: pSource.Name || '', Hash: pSource.Hash || '', AccountCode: pSource.AccountCode || '',
			Priority: '1', PriorityWeight: '1', FundCap: '0', ProjectFundCap: '0', PurchaseOrderItem: '',
			Category: { Key: pCategoryBucketKey },
		};
		const tmpResp = await this._putJSON(`${this._base()}/Source`, tmpBody);
		await this._afterMutationAsync(tmpResp);
	}

	/** Add one or more funds under a source bucket (pFunds = profile Fund[]; pSourceBucketKey = source bucket key). */
	async addFundsAsync(pFunds, pSourceBucketKey)
	{
		this._assertCanManage();
		const tmpFunds = (Array.isArray(pFunds) ? pFunds : [ pFunds ]).filter((pFund) => pFund && pFund.Key);
		if (!tmpFunds.length) { throw new Error('Pick at least one fund.'); }
		if (!pSourceBucketKey) { throw new Error('Choose the funding source to add it under.'); }
		// Unlike /Source (which parses the pipe bucket key), the /Funds endpoint keys the join by the RAW
		// IDFundingSource — it does `Number(FundingSource.Key)`, so a pipe bucket key here becomes NaN and the
		// write "succeeds" while persisting NO FundingSourceFundJoin. Segment [2] of the source bucket key is the
		// IDFundingSource (finance toBucketKey: [FundingCategory, FundingCategoryProjectJoin, FundingSource, …]);
		// send that, matching what the Vue funding screen sends.
		const tmpSourceID = this._sourceIDFromBucketKey(pSourceBucketKey);
		if (!tmpSourceID) { throw new Error('Could not resolve the funding source to add the fund under.'); }
		const tmpBody = tmpFunds.map((pFund) => ({ Key: pFund.Key, Sequence: '1', Weight: '1', PurchaseOrderItem: '', FundingSource: { Key: tmpSourceID } }));
		const tmpResp = await this._putJSON(`${this._base()}/Funds`, tmpBody);
		await this._afterMutationAsync(tmpResp);
	}

	/** The raw IDFundingSource from a source bucket pipe key (`IDCat|inst|IDSrc|inst|…`), or '' when unresolvable. */
	_sourceIDFromBucketKey(pKey)
	{
		const tmpKey = String(pKey == null ? '' : pKey);
		const tmpID = (tmpKey.indexOf('|') >= 0) ? tmpKey.split('|')[2] : tmpKey;
		return (tmpID && (tmpID !== 'null') && !Number.isNaN(Number(tmpID))) ? tmpID : '';
	}

	/** Save edited fields on one bucket: PUT …/Buckets [{ BucketKey, Changes }]. */
	async saveBucketAsync(pBucketKey, pChanges)
	{
		this._assertCanManage();
		if (!pBucketKey || !pChanges || !Object.keys(pChanges).length) { return; }
		const tmpResp = await this._putJSON(`${this._base()}/Buckets`, [ { BucketKey: pBucketKey, Changes: pChanges } ]);
		await this._afterMutationAsync(tmpResp, true);   // quiet: a field edit, keep the user's focus
	}

	/** Remove buckets (a category / source / fund and its subtree): POST …/Buckets/Delete [ keys ]. */
	async deleteBucketsAsync(pKeys)
	{
		this._assertCanManage();
		const tmpKeys = (Array.isArray(pKeys) ? pKeys : [ pKeys ]).filter(Boolean);
		if (!tmpKeys.length) { return; }
		const tmpResp = await this._postJSON(`${this._base()}/Buckets/Delete`, tmpKeys);
		await this._afterMutationAsync(tmpResp);
	}

	// --- Purchase-order export (gated on FeatureToggles.EnablePurchaseOrderExport) -------------------
	// GET Finance/Export/PurchaseOrder/For/Project/{id} returns a DocumentArtifact envelope
	// { GUIDDocumentArtifact, Type, Version, Datum } where Datum = { File (plaintext), Files:[{Types,Content}],
	// FileName, Violations, DepletionHistory, TransactionLog, IDProject }. NOTE: the server ALSO persists the
	// generated artifact on every call (by design — the same as the Vue export). It fails 422 ("… missing a funding
	// category" / project has no Contract) BEFORE generating, so an incomplete project persists nothing.

	async exportPurchaseOrderAsync()
	{
		try
		{
			const tmpResp = await this._getJSON(`Finance/Export/PurchaseOrder/For/Project/${this._idProject}`);
			const tmpDatum = (tmpResp && tmpResp.Datum) || {};
			const tmpFiles = Array.isArray(tmpDatum.Files) && tmpDatum.Files.length
				? tmpDatum.Files
				: ((tmpDatum.File != null) ? [ { Types: [ 'PlainText' ], Content: String(tmpDatum.File) } ] : []);
			return {
				GUID: (tmpResp && tmpResp.GUIDDocumentArtifact) || '',
				FileName: tmpDatum.FileName || `${(tmpResp && tmpResp.GUIDDocumentArtifact) || 'PurchaseOrder'}.dat`,
				Files: tmpFiles,
				PrimaryContent: (tmpDatum.File != null) ? String(tmpDatum.File) : (tmpFiles.length ? String(tmpFiles[0].Content || '') : ''),
				Violations: Array.isArray(tmpDatum.Violations) ? tmpDatum.Violations : [],
			};
		}
		catch (pError)
		{
			throw new Error(this._humanizeError(pError, 'Could not generate the purchase order.'));
		}
	}

	/** Pull a human message out of a rest-client error whose .message is a stringified JSON error body
	 *  ({ code, message }) — the shape Headlight-Rest-Client wraps a 4xx response in. */
	_humanizeError(pError, pFallback)
	{
		const tmpRaw = (pError && pError.message) ? String(pError.message) : '';
		if (tmpRaw)
		{
			try { const tmpParsed = JSON.parse(tmpRaw); if (tmpParsed && tmpParsed.message) { return String(tmpParsed.message); } } catch (pIgnore) { /* not a JSON body */ }
			if (tmpRaw.charAt(0) !== '{') { return tmpRaw; }
		}
		return pFallback;
	}

	// --- Funding simulation (what-if; read-only, no persistence) -------------------------------------
	// POST Finance/Scenario/Simulate/For/Project/{id}/v2 with { LineItemsToFund:[{ LineItem:{Key}, Category:{Key},
	// Amount }] } computes a what-if funding solution for paying the given amounts against those line items, WITHOUT
	// touching any live data (ScenarioController is read-only — the non-v2 route is deprecated and reads a different
	// body key, LineItemsToPay). Returns { Scenario:{ LogEntry[], TransactionLog[], … }, Solution:{ FinalPaymentAmount,
	// ActualPaymentAmount, FundingTypeOutcomes[], FundOutcomes[], Violations[], … (amounts are strings) }, LookupData }.

	async simulateAsync(pLineItemsToFund)
	{
		const tmpLineItems = (Array.isArray(pLineItemsToFund) ? pLineItemsToFund : []).filter((pRow) => pRow && pRow.LineItem && pRow.LineItem.Key);
		if (!tmpLineItems.length) { throw new Error('Pick at least one line item to simulate.'); }
		try
		{
			return await this._postJSON(`Finance/Scenario/Simulate/For/Project/${this._idProject}/v2`, { LineItemsToFund: tmpLineItems });
		}
		catch (pError)
		{
			throw new Error(this._humanizeError(pError, 'Could not run the funding simulation.'));
		}
	}

	// --- Line-item funding (slice 2) ----------------------------------------------------------------

	get lineItems() { return this.workspaceState.LineItems || []; }
	get projectCategories() { return this.workspaceState.ProjectCategories || []; }

	/** The line items with their resolved funding-category name, for the grid. Uncategorized is represented by the
	 *  server as Category.Key === '0' (a sentinel), NOT an empty/absent key — treat that as uncategorized. */
	lineItemRows()
	{
		const tmpByKey = {};
		this.projectCategories.forEach((pCat) => { tmpByKey[String(pCat.Key)] = pCat.Name; });
		return this.lineItems.map((pItem) =>
		{
			const tmpRaw = (pItem.Category && (pItem.Category.Key != null)) ? String(pItem.Category.Key) : '';
			const tmpUncategorized = (!tmpRaw || (tmpRaw === '0'));
			return {
				Key: pItem.Key,
				ItemCode: pItem.Code || pItem.ItemCode || '',
				Name: pItem.Name || '',
				CategoryKey: tmpUncategorized ? '' : tmpRaw,
				CategoryName: tmpUncategorized ? '' : (tmpByKey[tmpRaw] || (pItem.Category && pItem.Category.Name) || ''),
				IsUncategorized: tmpUncategorized,
			};
		});
	}

	/** Assign a funding category to a line item. There is NO un-assign — the Finance API resolves the category by
	 *  key and rejects a '0'/empty key ("Record not found"), matching the Vue (which only ever reassigns). So a
	 *  falsy/'0' key is a no-op here. Ripples into the config + digest + solution. */
	async saveLineItemCategoryAsync(pLineItemKey, pCategoryKey)
	{
		this._assertCanManage();
		// When the project's status requires a Change Order, line-item modifications (this writes LineItem) are locked.
		if (this.workspaceState.RequiresChangeOrder) { throw new Error(`This project’s status (${this.workspaceState.ProjectStatus || ''}) requires a Change Order to modify line items.`); }
		if (!pLineItemKey || !pCategoryKey || (String(pCategoryKey) === '0')) { return; }
		await this._putJSON('Finance/LineItem', { Key: pLineItemKey, Category: { Key: pCategoryKey } });
		await this.refreshConfigAsync();
		await Promise.all([ this.refreshDigestAsync(), this.refreshSolutionAsync() ]);
		this._render();
	}
}

module.exports = ProjectFundingProvider;
module.exports.default_configuration = { ProviderIdentifier: 'ProjectFunding' };

},{"../change-orders/ProjectChangeOrderGating.js":1074,"pict-provider":845}],1298:[function(require,module,exports){
'use strict';

/**
 * ATM / Sample Plan Checklist dashboard — configuration catalog.
 *
 * Data-driven description of every value the bespoke #/ATMDashboardConfig screen edits, split across the two
 * surfaces the dashboard actually reads (see documents spec "ATM + Sample Plan Checklist — Configuration Reference"):
 *
 *   1. VALIDATION — the audit logic, Configuration namespace `MaterialsAudit`. The API endpoint reads it as
 *      `Object.assign(defaults, Configuration/For/MaterialsAudit/In/Project/<id>)`, so each TOP-LEVEL key is its
 *      own Configuration NamespaceValue (ContractorReportedQuantityValidation, StatusOptions, …).
 *   2. DISPLAY — which SamplePlan columns show, Configuration namespace `AppDashboards`, under
 *      `<bucket>.SamplePlanChecklist.Config.SamplePlan`. The dashboard (sampleplan.* / dashboards.* iframe) reads
 *      the `SamplePlan` bucket; `hidden:true` hides a column.
 */

// ── Validation (MaterialsAudit) ──────────────────────────────────────────────

// Simple on/off checks — one NamespaceValue each, config shape { Enabled }.
const VALIDATION_CHECKS =
[
	{ Key: 'ContractorReportedQuantityValidation', Label: 'Contractor-reported quantity check', Default: true,
		Description: 'Flag a line item when the installed quantity is short of what the contractor reported (Installed Qty < Item Slip Total).' },
	{ Key: 'PaidQuantityValidation', Label: 'Paid (expected) quantity check', Default: false,
		Description: 'Flag a line item when the installed quantity is short of the expected/paid quantity (Installed Qty < Expected Qty).' },
	{ Key: 'RequiredAcceptedValidation', Label: 'Required samples-accepted check', Default: false,
		Description: 'Flag a line item when fewer samples were accepted than the sample plan requires (a count check).' },
];

// AcceptedQuantityValidation is special — { Enabled, ValidationField }.
const ACCEPTED_QTY_KEY = 'AcceptedQuantityValidation';
const ACCEPTED_QTY_DEFAULT = { Enabled: true, ValidationField: 'ContractorReportedQuantity' };
const ACCEPTED_QTY_FIELDS =
[
	{ Value: 'ContractorReportedQuantity', Label: 'Item Slip Total (contractor reported)' },
	{ Value: 'InstalledQty', Label: 'Installed quantity' },
	{ Value: 'ExpectedQty', Label: 'Expected (paid) quantity' },
	{ Value: 'BidQty', Label: 'Bid quantity' },
];

// StatusOptions — the pass/fail vocabulary. NamespaceValue `StatusOptions`, shape { Passing:[], Failing:[] }.
const STATUS_OPTIONS_KEY = 'StatusOptions';
const STATUS_OPTIONS_DEFAULT = { Passing: [ 'PASS' ], Failing: [ 'FAIL' ] };

// CertUnitTypes — PLIMT unit strings that mean "certification-style" testing. NamespaceValue `CertUnitTypes`
// (its config IS the array).
const CERT_UNIT_TYPES_KEY = 'CertUnitTypes';
const CERT_UNIT_TYPES_DEFAULT =
[
	'per lot per plant per month',
	'per lot per plant per mix design',
	'per source per lot of mineral admixture',
	'project',
];

const MATERIALS_AUDIT_NAMESPACE = 'MaterialsAudit';

// ── Display (AppDashboards → SamplePlan) ─────────────────────────────────────

const APPDASHBOARDS_NAMESPACE = 'AppDashboards';
// The Sample Plan Checklist dashboard reads this bucket (sampleplan.* and the dashboards.* iframe host).
const DISPLAY_BUCKET = 'SamplePlan';

// Canonical SamplePlan-bucket shape (spec §6.3), used to SEED the bucket when a customer/project has no
// AppDashboards config yet — otherwise there is nothing to preserve DashboardHash/EntryPoints against and columns
// can never be configured. Saving with this seed registers the Sample Plan Checklist dashboard for that scope.
const DISPLAY_BUCKET_TEMPLATE =
{
	DashboardHash: 'sampleplan_checklist_new',
	DisplayName: 'Sample Plan Checklist',
	Description: 'Sample plan checklist dashboard.',
	EntryPoints: { css: [ 'index.css' ], js: [ 'index.js' ] },
	Config: { Parent: 'Project', SamplePlan: {} },
};

// Section-level options (live directly under SamplePlan).
const DISPLAY_SECTION_OPTIONS =
[
	{ Key: 'Title', Type: 'text', Label: 'Section title', Default: 'Original Sampling Plan' },
	{ Key: 'Subtitle', Type: 'text', Label: 'Sub-heading (optional)', Default: '' },
	{ Key: 'EmptyMessage', Type: 'text', Label: 'Empty-state message', Default: 'No sample plan found for this Project!' },
	{ Key: 'NonConformingValidation', Type: 'bool', Label: 'Show the green/red conformance indicator column', Default: true },
];

// Column groups. Each column: { Key, Label (default header), Hidden (default) }. The editor shows a "Show" checkbox
// (= !hidden) and an editable label. Labels may contain HTML (the defaults use <br/> to wrap) — shown as raw text
// in the input and written verbatim.
const DISPLAY_COLUMN_GROUPS =
[
	{
		Group: 'Line-item header row',
		Columns:
		[
			{ Key: 'LineItemNumber', Label: 'Line Item', Hidden: false },
			{ Key: 'LineItemCode', Label: 'Item Code', Hidden: false },
			{ Key: 'LineItemDescription', Label: 'Description', Hidden: false },
			{ Key: 'LineItemUnits', Label: 'Units', Hidden: false },
			{ Key: 'ContractQuantity', Label: 'Contract Qty.', Hidden: false },
			{ Key: 'ExpectedQuantity', Label: 'Expected Qty.', Hidden: false },
			{ Key: 'InstalledQuantity', Label: 'Installed Qty.', Hidden: false },
			{ Key: 'ContractorReportedQuantity', Label: 'Item Slip Total', Hidden: true },
			{ Key: 'SmallQtyTotal', Label: 'Small Quantity Total', Hidden: false },
		],
	},
	{
		Group: 'Material / sample-type rows',
		Columns:
		[
			{ Key: 'MaterialCategory', Label: 'Material Category', Hidden: false },
			{ Key: 'SampleUnit', Label: 'Sample <br/>Unit', Hidden: false },
			{ Key: 'SampleType', Label: 'Sample <br/>Type', Hidden: false },
			{ Key: 'SampleRate', Label: 'Rate', Hidden: false },
			{ Key: 'SampleFrequency', Label: 'Frequency', Hidden: false },
			{ Key: 'ConversionFactor', Label: 'Conversion <br/>Factor', Hidden: false },
			{ Key: 'SamplesPlanned', Label: 'Samples <br/>Planned', Hidden: false },
			{ Key: 'SamplesRequired', Label: 'Samples <br/>Required', Hidden: false },
			{ Key: 'SamplesTaken', Label: 'Samples <br/>Taken', Hidden: false },
			{ Key: 'SamplesPassing', Label: 'Samples <br/>Passing', Hidden: false },
			{ Key: 'PartialExceptionTotal', Label: 'Partial <br/>Exception <br/>Quantity', Hidden: false },
			{ Key: 'SamplesAccepted', Label: 'Samples <br/>Accepted', Hidden: true },
			{ Key: 'AcceptedQuantity', Label: 'Accepted Qty.', Hidden: true },
		],
	},
	{
		Group: 'Detail rows (full-width, under each sample type)',
		Columns:
		[
			{ Key: 'SampleDescription', Label: 'Sample Description', Hidden: false },
			{ Key: 'SamplingInstructions', Label: 'Sampling Instructions', Hidden: false },
			{ Key: 'Remarks', Label: 'Remarks', Hidden: false },
			{ Key: 'ErrorOmissionDetail', Label: 'Errors and Omissions', Hidden: false },
		],
	},
];

// The dashboard's built-in fallback profile (spec §4.2) — what the checklist shows when NO SamplePlan config
// exists yet. Supplying a config REPLACES this profile entirely, so when there's no stored config the editor is
// seeded from this (overlaid on the §3.3 column defaults) rather than the bare defaults, and the full state is
// written on save — otherwise saving would silently drop these hidden/relabeled columns. Keys not listed here fall
// back to their §3.3 defaults. (`ErrorsAndOmissionsSummary` is a cover-page/form thing — inert in the dashboard.)
const DISPLAY_FALLBACK_PROFILE =
{
	ContractorReportedQuantity: { label: 'Item Slip Total', hidden: false },
	ConversionFactor: { hidden: true },
	SamplesAccepted: { label: 'Samples <br/>Accepted', hidden: false },
	SamplesPassing: { hidden: true },
	AcceptedQuantity: { label: 'Quantity <br />Accepted', hidden: false },
	SamplingInstructions: { hidden: true },
	Remarks: { hidden: true },
};

// Flat column list + default lookups (built once).
const DISPLAY_COLUMNS = DISPLAY_COLUMN_GROUPS.reduce((pAll, pGroup) => pAll.concat(pGroup.Columns), []);
const DISPLAY_COLUMN_DEFAULTS = {};
DISPLAY_COLUMNS.forEach((pCol) => { DISPLAY_COLUMN_DEFAULTS[pCol.Key] = pCol; });

module.exports =
{
	MATERIALS_AUDIT_NAMESPACE,
	VALIDATION_CHECKS,
	ACCEPTED_QTY_KEY, ACCEPTED_QTY_DEFAULT, ACCEPTED_QTY_FIELDS,
	STATUS_OPTIONS_KEY, STATUS_OPTIONS_DEFAULT,
	CERT_UNIT_TYPES_KEY, CERT_UNIT_TYPES_DEFAULT,
	APPDASHBOARDS_NAMESPACE, DISPLAY_BUCKET, DISPLAY_BUCKET_TEMPLATE,
	DISPLAY_SECTION_OPTIONS, DISPLAY_COLUMN_GROUPS, DISPLAY_COLUMNS, DISPLAY_COLUMN_DEFAULTS, DISPLAY_FALLBACK_PROFILE,
};

},{}],1299:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libCatalog = require('./ATMDashboardConfig-Catalog.js');

const DETAIL_MOUNT = '#ATM-Detail';
const PROJECT_RESULTS_MOUNT = '#ATM-Project-Results';

const NS_AUDIT = libCatalog.MATERIALS_AUDIT_NAMESPACE;      // 'MaterialsAudit'
const NS_DASH = libCatalog.APPDASHBOARDS_NAMESPACE;         // 'AppDashboards'

/**
 * ATMDashboardConfig — the bespoke #/ATMDashboardConfig screen. Edits the Audit of Testing & Materials /
 * Sample Plan Checklist dashboard configuration across its two real config surfaces, at Customer default or
 * per-Project override scope, gated by the `MaterialsAudit-Configure` entitlement.
 *
 *   Validation (namespace MaterialsAudit, one NamespaceValue per top-level key) — the audit checks + pass/fail
 *     vocabulary; read by the API as Object.assign(defaults, Configuration/For/MaterialsAudit/In/Project/<id>).
 *   Display   (namespace AppDashboards, bucket `SamplePlan` → SamplePlanChecklist.Config.SamplePlan) — which
 *     checklist columns show + their labels; the bucket value is preserved and only its SamplePlan slice rewritten.
 *
 * Writes go through the same Configuration/Put path the ConfigViewer / ApprovalWorkflow tools use; the server gate
 * on Configuration/Put stays authoritative.
 */
class ATMDashboardConfigProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._searchTimer = null;
		this._searchToken = 0;
		this._displayBucketName = libCatalog.DISPLAY_BUCKET;
		this._displayBucketCfg = null;   // the full effective bucket object, preserved for save
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get state()
	{
		if (!this.pict.AppData.ATMDashboardConfig)
		{
			this.pict.AppData.ATMDashboardConfig =
			{
				Loaded: false, Loading: false, Saving: false, Error: '', Message: '',
				ScopeMode: 'Customer', IDProject: 0, ProjectLabel: '', ProjectSearch: '', ProjectResults: [], ProjectSearching: false,
				ActiveTab: 'validation',
				ValChecks: {}, ValAccepted: {}, ValStatusPassing: '', ValStatusFailing: '', ValCert: '',
				DispSection: {}, DispColumns: {}, DisplayAvailable: true,
			};
		}
		return this.pict.AppData.ATMDashboardConfig;
	}

	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID) : 0; }

	/** The entitlement gate — `MaterialsAudit-Configure`. Same capability the nav entry checks; server stays authoritative. */
	can()
	{
		const tmpSvc = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return true; }   // fail-open until the cap map loads
		return tmpSvc.can('MaterialsAudit', 'Configure');
	}

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	// ── Config I/O (centralized so the storage shape lives in ONE place) ─────────

	_scope() { return (this.state.ScopeMode === 'Project') ? { Scope: 'Project', ID: Number(this.state.IDProject) } : { Scope: 'Customer', ID: this.callerCustomer() }; }

	/** Read a namespace's merged {NamespaceValue: config} map at a scope. */
	_readMap(pNamespace, pScope, pID) { return this._getJSON(`Configuration/For/${pNamespace}/In/${pScope}/${pID}`).then((pBody) => (pBody && typeof pBody === 'object' && !Array.isArray(pBody)) ? pBody : {}); }

	/** Write one NamespaceValue's config at a scope (server dedups a value equal to its parent). */
	_putValue(pNamespace, pValue, pScope, pID, pConfig) { return this._postJSON(`Configuration/Put/${pNamespace}/${pValue}/${pScope}/${pID}`, { Config: pConfig }); }

	// ── Load ─────────────────────────────────────────────────────────────────────

	loadAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return; }
		if ((tmpState.ScopeMode === 'Project') && !tmpState.IDProject) { tmpState.Loaded = true; this.render(); return; }
		tmpState.Loading = true;
		tmpState.Error = '';
		this.render();
		const tmpScope = this._scope();
		Promise.all([ this._loadValidation(tmpScope), this._loadDisplay(tmpScope) ]).then(() =>
		{
			tmpState.Loaded = true;
			tmpState.Loading = false;
			this.render();
		});
	}

	_loadValidation(pScope)
	{
		const tmpState = this.state;
		return this._readMap(NS_AUDIT, pScope.Scope, pScope.ID).then((pMap) =>
		{
			tmpState.ValChecks = {};
			libCatalog.VALIDATION_CHECKS.forEach((pCheck) =>
			{
				const tmpVal = pMap[pCheck.Key];
				tmpState.ValChecks[pCheck.Key] = (tmpVal && (tmpVal.Enabled != null)) ? !!tmpVal.Enabled : pCheck.Default;
			});
			const tmpAccepted = pMap[libCatalog.ACCEPTED_QTY_KEY] || {};
			tmpState.ValAccepted =
			{
				Enabled: (tmpAccepted.Enabled != null) ? !!tmpAccepted.Enabled : libCatalog.ACCEPTED_QTY_DEFAULT.Enabled,
				ValidationField: tmpAccepted.ValidationField || libCatalog.ACCEPTED_QTY_DEFAULT.ValidationField,
			};
			const tmpStatus = pMap[libCatalog.STATUS_OPTIONS_KEY] || {};
			tmpState.ValStatusPassing = this._listToText(Array.isArray(tmpStatus.Passing) ? tmpStatus.Passing : libCatalog.STATUS_OPTIONS_DEFAULT.Passing);
			tmpState.ValStatusFailing = this._listToText(Array.isArray(tmpStatus.Failing) ? tmpStatus.Failing : libCatalog.STATUS_OPTIONS_DEFAULT.Failing);
			const tmpCert = pMap[libCatalog.CERT_UNIT_TYPES_KEY];
			tmpState.ValCert = this._linesToText(Array.isArray(tmpCert) ? tmpCert : libCatalog.CERT_UNIT_TYPES_DEFAULT);
		});
	}

	_loadDisplay(pScope)
	{
		const tmpState = this.state;
		return this._readMap(NS_DASH, pScope.Scope, pScope.ID).then((pMap) =>
		{
			// Pick the bucket the Sample Plan Checklist reads: SamplePlan, else HeadLight, else the first bucket that
			// carries a SamplePlanChecklist config. Preserve the whole bucket object so save only rewrites its slice.
			const tmpBucketName = pMap[libCatalog.DISPLAY_BUCKET] ? libCatalog.DISPLAY_BUCKET
				: (pMap.HeadLight && pMap.HeadLight.SamplePlanChecklist) ? 'HeadLight'
					: Object.keys(pMap).find((pKey) => pMap[pKey] && pMap[pKey].SamplePlanChecklist) || libCatalog.DISPLAY_BUCKET;
			const tmpBucket = (pMap[tmpBucketName] && pMap[tmpBucketName].SamplePlanChecklist) ? pMap[tmpBucketName] : null;
			// No SamplePlan bucket at this scope (a customer that hasn't configured the dashboard) — seed the canonical
			// one so columns are still configurable; saving then registers the dashboard for this scope.
			this._displayBucketName = libCatalog.DISPLAY_BUCKET;
			this._displayBucketIsNew = !tmpBucket;
			this._displayBucketCfg = tmpBucket ? JSON.parse(JSON.stringify(tmpBucket)) : JSON.parse(JSON.stringify(libCatalog.DISPLAY_BUCKET_TEMPLATE));
			tmpState.DisplayAvailable = true;
			tmpState.DisplayIsNew = !tmpBucket;
			const tmpSP = (this._displayBucketCfg.SamplePlanChecklist && this._displayBucketCfg.SamplePlanChecklist.Config && this._displayBucketCfg.SamplePlanChecklist.Config.SamplePlan) || null;
			// Overlay precedence: an existing SamplePlan config REPLACES the built-in fallback (spec §4.2); with no
			// config, seed from the fallback so the editor mirrors what the dashboard currently renders.
			const tmpOverlay = tmpSP || libCatalog.DISPLAY_FALLBACK_PROFILE;
			tmpState.DispSection = {};
			libCatalog.DISPLAY_SECTION_OPTIONS.forEach((pOpt) =>
			{
				tmpState.DispSection[pOpt.Key] = (tmpOverlay[pOpt.Key] != null) ? tmpOverlay[pOpt.Key] : pOpt.Default;
			});
			tmpState.DispColumns = {};
			libCatalog.DISPLAY_COLUMNS.forEach((pCol) =>
			{
				const tmpEntry = tmpOverlay[pCol.Key] || {};
				const tmpHidden = (tmpEntry.hidden != null) ? !!tmpEntry.hidden : !!pCol.Hidden;
				tmpState.DispColumns[pCol.Key] = { show: !tmpHidden, label: (tmpEntry.label != null) ? String(tmpEntry.label) : '' };
			});
		});
	}

	_listToText(pArr) { return (Array.isArray(pArr) ? pArr : []).join(', '); }
	_linesToText(pArr) { return (Array.isArray(pArr) ? pArr : []).join('\n'); }
	_parseList(pText) { return String(pText || '').split(',').map((pV) => pV.trim()).filter((pV) => pV.length > 0); }
	_parseLines(pText) { return String(pText || '').split(/\r?\n/).map((pV) => pV.trim()).filter((pV) => pV.length > 0); }

	// ── Scope ────────────────────────────────────────────────────────────────────

	setScopeMode(pMode)
	{
		const tmpState = this.state;
		const tmpMode = (pMode === 'Project') ? 'Project' : 'Customer';
		if (tmpState.ScopeMode === tmpMode) { return; }
		tmpState.ScopeMode = tmpMode;
		tmpState.Error = ''; tmpState.Message = '';
		tmpState.Loaded = false;
		if (tmpMode === 'Customer') { this.loadAsync(); }
		else if (tmpState.IDProject) { this.loadAsync(); }
		else { this.render(); }   // Project mode with no project chosen yet → prompt to pick one
	}

	setProjectSearch(pValue)
	{
		const tmpState = this.state;
		tmpState.ProjectSearch = String(pValue == null ? '' : pValue);
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(() => { this._searchTimer = null; this._searchProjects(); }, 250);
	}

	_searchProjects()
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.ProjectSearch || '').trim();
		if (tmpQuery.length < 2) { tmpState.ProjectSearching = false; tmpState.ProjectResults = []; this._renderProjectResults(); return; }
		const tmpToken = ++this._searchToken;
		tmpState.ProjectSearching = true;
		this._renderProjectResults();
		const tmpLike = encodeURIComponent(`%${tmpQuery}%`);
		const tmpCustomer = this.callerCustomer();
		// Project search, scoped to this customer, matched on name / PO number (the Project columns the picker uses).
		const tmpGroup = `FOP~0~(~0~FBV~Name~LK~${tmpLike}~FBVOR~PurchaseOrderNumber~LK~${tmpLike}~FCP~0~)~0`;
		this._getJSON(`Projects/FilteredTo/FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0~${tmpGroup}~FSF~Name~ASC~0/0/25`).then((pRows) =>
		{
			if (tmpToken !== this._searchToken) { return; }
			tmpState.ProjectResults = Array.isArray(pRows) ? pRows : [];
			tmpState.ProjectSearching = false;
			this._renderProjectResults();
		});
	}

	selectProject(pID, pLabel)
	{
		const tmpState = this.state;
		tmpState.IDProject = Number(pID);
		tmpState.ProjectLabel = String(pLabel || `Project #${pID}`);
		tmpState.ProjectResults = [];
		tmpState.ProjectSearch = '';
		tmpState.Error = ''; tmpState.Message = '';
		tmpState.Loaded = false;
		this.loadAsync();
	}

	// ── Edits (validation) ───────────────────────────────────────────────────────

	toggleCheck(pKey) { const tmpState = this.state; tmpState.ValChecks[pKey] = !tmpState.ValChecks[pKey]; tmpState.Message = ''; this.render(); }
	toggleAcceptedEnabled() { const tmpState = this.state; tmpState.ValAccepted.Enabled = !tmpState.ValAccepted.Enabled; tmpState.Message = ''; this.render(); }
	setAcceptedField(pValue) { this.state.ValAccepted.ValidationField = String(pValue || 'ContractorReportedQuantity'); this.state.Message = ''; }
	setStatusPassing(pValue) { this.state.ValStatusPassing = String(pValue == null ? '' : pValue); this.state.Message = ''; }
	setStatusFailing(pValue) { this.state.ValStatusFailing = String(pValue == null ? '' : pValue); this.state.Message = ''; }
	setCert(pValue) { this.state.ValCert = String(pValue == null ? '' : pValue); this.state.Message = ''; }

	// ── Edits (display) ──────────────────────────────────────────────────────────

	toggleColumn(pKey) { const tmpState = this.state; const tmpCol = tmpState.DispColumns[pKey]; if (tmpCol) { tmpCol.show = !tmpCol.show; tmpState.Message = ''; this.render(); } }
	setColumnLabel(pKey, pValue) { const tmpCol = this.state.DispColumns[pKey]; if (tmpCol) { tmpCol.label = String(pValue == null ? '' : pValue); this.state.Message = ''; } }
	setSectionText(pKey, pValue) { this.state.DispSection[pKey] = String(pValue == null ? '' : pValue); this.state.Message = ''; }
	toggleSectionBool(pKey) { const tmpState = this.state; tmpState.DispSection[pKey] = !tmpState.DispSection[pKey]; tmpState.Message = ''; this.render(); }

	/** Switch tabs via a stable route (#/ATMDashboardConfig/<Tab>) so the active tab lives in the URL. (The
	 *  orthogonal Customer/Project ScopeMode stays in-place JS — it's a scope filter, not page navigation.) */
	navigateTab(pTab) { if ((typeof window !== 'undefined') && window.location) { window.location.hash = `#/ATMDashboardConfig/${ (pTab === 'display') ? 'display' : 'validation' }`; } else { this.setTab(pTab); } }

	setTab(pTab) { const tmpTab = (pTab === 'display') ? 'display' : 'validation'; if (this.state.ActiveTab === tmpTab) { return; } this.state.ActiveTab = tmpTab; this.state.Error = ''; this.render(); }

	// ── Save ─────────────────────────────────────────────────────────────────────

	async saveValidationAsync()
	{
		const tmpState = this.state;
		if (!this.can() || tmpState.Saving) { return; }
		if ((tmpState.ScopeMode === 'Project') && !tmpState.IDProject) { return; }
		tmpState.Saving = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		const tmpScope = this._scope();
		const tmpWrites = [];
		libCatalog.VALIDATION_CHECKS.forEach((pCheck) => tmpWrites.push(this._putValue(NS_AUDIT, pCheck.Key, tmpScope.Scope, tmpScope.ID, { Enabled: !!tmpState.ValChecks[pCheck.Key] })));
		tmpWrites.push(this._putValue(NS_AUDIT, libCatalog.ACCEPTED_QTY_KEY, tmpScope.Scope, tmpScope.ID, { Enabled: !!tmpState.ValAccepted.Enabled, ValidationField: tmpState.ValAccepted.ValidationField }));
		tmpWrites.push(this._putValue(NS_AUDIT, libCatalog.STATUS_OPTIONS_KEY, tmpScope.Scope, tmpScope.ID, { Passing: this._parseList(tmpState.ValStatusPassing), Failing: this._parseList(tmpState.ValStatusFailing) }));
		tmpWrites.push(this._putValue(NS_AUDIT, libCatalog.CERT_UNIT_TYPES_KEY, tmpScope.Scope, tmpScope.ID, this._parseLines(tmpState.ValCert)));
		const tmpResults = await Promise.all(tmpWrites);
		tmpState.Saving = false;
		const tmpFailed = tmpResults.filter((pR) => pR && pR.error).length;
		if (tmpFailed) { tmpState.Error = `Saved with ${tmpFailed} error(s) — the server may have rejected a write (you may lack config-admin rights in this scope).`; }
		else { tmpState.Message = `Validation rules saved to the ${this._scopeLabel()}.`; }
		this.render();
	}

	async saveDisplayAsync()
	{
		const tmpState = this.state;
		if (!this.can() || tmpState.Saving) { return; }
		if ((tmpState.ScopeMode === 'Project') && !tmpState.IDProject) { return; }
		if (!tmpState.DisplayAvailable || !this._displayBucketCfg) { tmpState.Error = 'No Sample Plan Checklist dashboard is configured to edit its columns against.'; this.render(); return; }
		tmpState.Saving = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		// Build the full SamplePlan slice from the editor (explicit + lossless: an override replaces the fallback).
		const tmpSP = {};
		libCatalog.DISPLAY_SECTION_OPTIONS.forEach((pOpt) => { tmpSP[pOpt.Key] = tmpState.DispSection[pOpt.Key]; });
		libCatalog.DISPLAY_COLUMNS.forEach((pCol) =>
		{
			const tmpCol = tmpState.DispColumns[pCol.Key] || { show: !pCol.Hidden, label: '' };
			const tmpEntry = { hidden: !tmpCol.show };
			if (tmpCol.label && tmpCol.label.length) { tmpEntry.label = tmpCol.label; }
			tmpSP[pCol.Key] = tmpEntry;
		});
		// Splice into a clone of the preserved bucket so DashboardHash / EntryPoints / other keys survive.
		const tmpBucket = JSON.parse(JSON.stringify(this._displayBucketCfg));
		if (!tmpBucket.SamplePlanChecklist) { tmpBucket.SamplePlanChecklist = {}; }
		if (!tmpBucket.SamplePlanChecklist.Config) { tmpBucket.SamplePlanChecklist.Config = {}; }
		tmpBucket.SamplePlanChecklist.Config.SamplePlan = tmpSP;
		const tmpScope = this._scope();
		const tmpRes = await this._putValue(NS_DASH, this._displayBucketName, tmpScope.Scope, tmpScope.ID, tmpBucket);
		tmpState.Saving = false;
		if (tmpRes && tmpRes.error) { tmpState.Error = 'The server rejected the display config write (you may lack config-admin rights in this scope). Nothing was changed.'; }
		else { tmpState.Message = `Display columns saved to the ${this._scopeLabel()}.`; this._displayBucketCfg = tmpBucket; }
		this.render();
	}

	_scopeLabel() { return (this.state.ScopeMode === 'Project') ? `project “${this.state.ProjectLabel}”` : 'customer default'; }

	// ── Render ─────────────────────────────────────────────────────────────────

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || (tmpCA.getElement(DETAIL_MOUNT).length === 0)) { return; }
		tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML());
	}

	_renderProjectResults()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(PROJECT_RESULTS_MOUNT).length > 0) { tmpCA.assignContent(PROJECT_RESULTS_MOUNT, this._projectResultsHTML()); }
		else { this.render(); }
	}

	_detailHTML()
	{
		const tmpState = this.state;
		if (!this.can()) { return '<div class="atm-empty">You don’t have the “Configure the Audit of Testing and Materials dashboard” entitlement.</div>'; }
		const tmpScopeBar = this._scopeBarHTML();
		if ((tmpState.ScopeMode === 'Project') && !tmpState.IDProject)
		{
			return tmpScopeBar + '<div class="atm-empty">Search for and pick a project above to configure its override.</div>';
		}
		if (tmpState.Loading || !tmpState.Loaded) { return tmpScopeBar + '<div class="atm-empty">Loading configuration…</div>'; }
		const tmpMsg = tmpState.Message ? `<div class="atm-msg">${this._esc(tmpState.Message)}</div>` : '';
		const tmpErr = tmpState.Error ? `<div class="atm-error">${this._esc(tmpState.Error)}</div>` : '';
		const tmpBody = (tmpState.ActiveTab === 'display') ? this._displayHTML() : this._validationHTML();
		return tmpScopeBar + this._tabBarHTML() + tmpErr + tmpMsg + tmpBody;
	}

	_scopeBarHTML()
	{
		const tmpState = this.state;
		const tmpIsProject = (tmpState.ScopeMode === 'Project');
		const tmpProjectPicker = tmpIsProject
			? `<div class="atm-project"><input class="atm-project-input" type="text" autocomplete="off" spellcheck="false" placeholder="Search projects by name or number…" value="${this._esc(tmpState.ProjectSearch || '')}" oninput="_Pict.providers.ATMDashboardConfig.setProjectSearch(this.value)" />`
				+ (tmpState.IDProject ? `<span class="atm-project-current">Editing: <strong>${this._esc(tmpState.ProjectLabel)}</strong></span>` : '')
				+ `<div id="ATM-Project-Results" class="atm-project-results">${this._projectResultsHTML()}</div></div>`
			: '';
		return `<div class="atm-scopebar">
				<span class="atm-scope-label">Scope</span>
				<button type="button" class="atm-scope-btn${tmpIsProject ? '' : ' is-active'}" onclick="_Pict.providers.ATMDashboardConfig.setScopeMode('Customer'); return false;">Customer default</button>
				<button type="button" class="atm-scope-btn${tmpIsProject ? ' is-active' : ''}" onclick="_Pict.providers.ATMDashboardConfig.setScopeMode('Project'); return false;">Project override</button>
			</div>${tmpProjectPicker}`;
	}

	_projectResultsHTML()
	{
		const tmpState = this.state;
		if (tmpState.ProjectSearching) { return '<div class="atm-project-empty">Searching…</div>'; }
		const tmpQuery = String(tmpState.ProjectSearch || '').trim();
		if (tmpQuery.length < 2) { return ''; }
		if (!(tmpState.ProjectResults || []).length) { return `<div class="atm-project-empty">No projects match “${this._esc(tmpQuery)}”.</div>`; }
		return (tmpState.ProjectResults || []).map((pRow) =>
		{
			const tmpLabel = pRow.Name || `Project #${pRow.IDProject}`;
			const tmpSub = pRow.PurchaseOrderNumber || pRow.ImprovementTypeCode || '';
			return `<div class="atm-project-item" onclick="_Pict.providers.ATMDashboardConfig.selectProject(${Number(pRow.IDProject)}, '${this._esc(String(tmpLabel).replace(/'/g, ''))}'); return false;">${this._esc(tmpLabel)}${tmpSub ? `<span class="atm-project-sub">${this._esc(tmpSub)}</span>` : ''}</div>`;
		}).join('');
	}

	_tabBarHTML()
	{
		const tmpTab = this.state.ActiveTab || 'validation';
		return `<div class="atm-tabs">
				<button type="button" class="atm-tab${tmpTab === 'validation' ? ' is-active' : ''}" onclick="_Pict.providers.ATMDashboardConfig.navigateTab('validation'); return false;">Validation rules</button>
				<button type="button" class="atm-tab${tmpTab === 'display' ? ' is-active' : ''}" onclick="_Pict.providers.ATMDashboardConfig.navigateTab('display'); return false;">Display columns</button>
			</div>`;
	}

	_switch(pOn, pOnClick, pDisabled) { return `<button type="button" class="atm-switch${pOn ? ' is-on' : ''}"${pDisabled ? ' disabled' : ''} onclick="${pOnClick}; return false;"><span class="atm-switch-dot"></span></button>`; }

	_validationHTML()
	{
		const tmpState = this.state;
		const tmpDisabled = tmpState.Saving;
		const tmpChecks = libCatalog.VALIDATION_CHECKS.map((pCheck) =>
			`<div class="atm-row"><div class="atm-row-main"><div class="atm-row-label">${this._esc(pCheck.Label)}</div><div class="atm-row-desc">${this._esc(pCheck.Description)}</div></div>${this._switch(!!tmpState.ValChecks[pCheck.Key], `_Pict.providers.ATMDashboardConfig.toggleCheck('${pCheck.Key}')`, tmpDisabled)}</div>`).join('');
		const tmpAcceptedOn = !!tmpState.ValAccepted.Enabled;
		const tmpFieldOpts = libCatalog.ACCEPTED_QTY_FIELDS.map((pF) => `<option value="${pF.Value}"${tmpState.ValAccepted.ValidationField === pF.Value ? ' selected' : ''}>${this._esc(pF.Label)}</option>`).join('');
		const tmpAccepted = `<div class="atm-row"><div class="atm-row-main"><div class="atm-row-label">Accepted-quantity check</div>`
			+ `<div class="atm-row-desc">Flag a line item when the accepted quantity falls short of the quantity that needed coverage.</div>`
			+ `<div class="atm-subfield"><label class="atm-sublabel">Measured against</label> <select class="atm-select"${tmpAcceptedOn ? '' : ' disabled'} onchange="_Pict.providers.ATMDashboardConfig.setAcceptedField(this.value)">${tmpFieldOpts}</select></div></div>`
			+ this._switch(tmpAcceptedOn, `_Pict.providers.ATMDashboardConfig.toggleAcceptedEnabled()`, tmpDisabled) + `</div>`;
		const tmpStatus = `<div class="atm-area"><div class="atm-area-head">Pass / fail vocabulary</div>`
			+ `<div class="atm-field"><label class="atm-field-label">Statuses that count as <strong>passing</strong> (comma-separated)</label>`
			+ `<input class="atm-input" type="text" value="${this._esc(tmpState.ValStatusPassing)}" oninput="_Pict.providers.ATMDashboardConfig.setStatusPassing(this.value)" /></div>`
			+ `<div class="atm-field"><label class="atm-field-label">Statuses that count as <strong>failing</strong> (comma-separated)</label>`
			+ `<input class="atm-input" type="text" value="${this._esc(tmpState.ValStatusFailing)}" oninput="_Pict.providers.ATMDashboardConfig.setStatusFailing(this.value)" /></div></div>`;
		const tmpCert = `<div class="atm-area"><div class="atm-area-head">Certification-style unit types</div>`
			+ `<div class="atm-field"><label class="atm-field-label">PLIMT unit strings treated as certification testing (one per line)</label>`
			+ `<textarea class="atm-textarea" rows="4" oninput="_Pict.providers.ATMDashboardConfig.setCert(this.value)">${this._esc(tmpState.ValCert)}</textarea></div></div>`;
		return `<div class="atm-body">
				<div class="atm-area"><div class="atm-area-head">Conformance checks</div>${tmpChecks}${tmpAccepted}</div>
				${tmpStatus}${tmpCert}
				${this._saveBarHTML('saveValidationAsync', 'Save validation rules')}
			</div>`;
	}

	_displayHTML()
	{
		const tmpState = this.state;
		const tmpNewNote = tmpState.DisplayIsNew
			? `<div class="atm-note atm-note-warn">No Sample Plan Checklist dashboard config exists at the ${this._esc(this._scopeLabel())} yet — saving here will create it (registering the dashboard for this scope) with the columns below.</div>`
			: '';
		const tmpDisabled = tmpState.Saving;
		const tmpSection = libCatalog.DISPLAY_SECTION_OPTIONS.map((pOpt) =>
		{
			if (pOpt.Type === 'bool')
			{
				return `<div class="atm-row"><div class="atm-row-main"><div class="atm-row-label">${this._esc(pOpt.Label)}</div></div>${this._switch(!!tmpState.DispSection[pOpt.Key], `_Pict.providers.ATMDashboardConfig.toggleSectionBool('${pOpt.Key}')`, tmpDisabled)}</div>`;
			}
			return `<div class="atm-field"><label class="atm-field-label">${this._esc(pOpt.Label)}</label><input class="atm-input" type="text" value="${this._esc(tmpState.DispSection[pOpt.Key] || '')}" oninput="_Pict.providers.ATMDashboardConfig.setSectionText('${pOpt.Key}', this.value)" /></div>`;
		}).join('');
		const tmpGroups = libCatalog.DISPLAY_COLUMN_GROUPS.map((pGroup) =>
		{
			const tmpRows = pGroup.Columns.map((pCol) =>
			{
				const tmpCol = tmpState.DispColumns[pCol.Key] || { show: !pCol.Hidden, label: '' };
				const tmpToggle = this._switch(!!tmpCol.show, `_Pict.providers.ATMDashboardConfig.toggleColumn('${pCol.Key}')`, tmpDisabled);
				const tmpDefaultLabel = String(pCol.Label).replace(/<br\s*\/?>/gi, ' ');
				return `<div class="atm-col"><div class="atm-col-main"><span class="atm-col-name">${this._esc(tmpDefaultLabel)}</span>`
					+ `<input class="atm-col-label" type="text" placeholder="${this._esc(tmpDefaultLabel)}" value="${this._esc(tmpCol.label)}" oninput="_Pict.providers.ATMDashboardConfig.setColumnLabel('${pCol.Key}', this.value)" /></div>`
					+ `<span class="atm-col-show">Show ${tmpToggle}</span></div>`;
			}).join('');
			return `<div class="atm-area"><div class="atm-area-head">${this._esc(pGroup.Group)}</div>${tmpRows}</div>`;
		}).join('');
		return `<div class="atm-body">
				${tmpNewNote}
				<div class="atm-note">Uncheck a column to hide it on the checklist; type a label to rename its header (blank = default). Editing scope: <strong>${this._esc(this._scopeLabel())}</strong>.</div>
				<div class="atm-area"><div class="atm-area-head">Section</div>${tmpSection}</div>
				${tmpGroups}
				${this._saveBarHTML('saveDisplayAsync', 'Save display columns')}
			</div>`;
	}

	_saveBarHTML(pMethod, pLabel)
	{
		const tmpState = this.state;
		const tmpDisabled = tmpState.Saving ? ' disabled' : '';
		return `<div class="atm-savebar"><button type="button" class="atm-save"${tmpDisabled} onclick="_Pict.providers.ATMDashboardConfig.${pMethod}(); return false;">${tmpState.Saving ? 'Saving…' : this._esc(pLabel)}</button></div>`;
	}
}

module.exports = ATMDashboardConfigProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ATMDashboardConfig',
	AutoInitialize: true,
	AutoInitializeOrdinal: 45,
};

},{"./ATMDashboardConfig-Catalog.js":1298,"pict-provider":845}],1300:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');
const libTabBar = require('../views/TabBar.js');

/**
 * AccessWorkspace — the orchestrator behind the cohesive "Access & Permissions" workspace.
 *
 * One screen replaces the raw Role / RolePermission / RoleEdge / UserRoleJoin recordset lists: a rail of
 * subjects (Roles, Permission Groups, Users) + a workspace-global context bar + a tabbed editor. This
 * provider owns the ONLY copy of the selected subject + context ({ SubjectKind, SubjectID, Context,
 * IDContext }); the sibling providers (PermissionMatrix, PermissionVisualizer, RoleAssignment) read it and
 * never duplicate it. All render state lives in pict.AppData.AccessWorkspace and the AccessWorkspace view
 * derives + repaints declaratively (the MasterListManager / ConfigViewer idiom).
 *
 * A Permission Group is a Role row with Type='PermissionGroup'; a Role Group is a Role with any other Type.
 * This rich layer is separate from the simple User.IDRole (0-5) base level, which stays in user management.
 */

// Tabs per subject kind. 'details' is the only one wired in phase 0; the rest are filled by later phases
// (Permissions=matrix, Effective=visualizer, Composition/Members=groups, assignment/overrides=user).
const TABS_ROLE =
[
	{ Key: 'details', Label: 'Details', Icon: 'fas fa-id-card' },
	{ Key: 'permissions', Label: 'Permissions', Icon: 'fas fa-table-cells' },
	{ Key: 'effective', Label: 'Effective', Icon: 'fas fa-eye' },
	{ Key: 'composition', Label: 'Composition', Icon: 'fas fa-sitemap' },
	{ Key: 'members', Label: 'Members', Icon: 'fas fa-users' },
];

// Shown only for a User Group (Role.Type==='UserGroup'): the effective set of projects/labs a user is added to
// when placed in the group (UserGroupGrants provider). Appended to TABS_ROLE in _deriveSubject for that kind.
const TAB_PROJECTS_GRANTED = { Key: 'projectsgranted', Label: 'Projects Granted', Icon: 'fas fa-folder-tree' };

const TABS_USER =
[
	{ Key: 'details', Label: 'Details', Icon: 'fas fa-id-card' },
	{ Key: 'assignment', Label: 'Roles & Groups', Icon: 'fas fa-user-tag' },
	{ Key: 'effective', Label: 'Effective', Icon: 'fas fa-eye' },
	{ Key: 'overrides', Label: 'Overrides', Icon: 'fas fa-user-shield' },
];

// Context scopes a permission can be authored/resolved in. Customer is the common case; the others take a
// context entity ID (a contract / project / lab record).
const CONTEXT_OPTIONS =
[
	{ Key: 'Customer', Label: 'Customer' },
	{ Key: 'Contract', Label: 'Contract' },
	{ Key: 'Project', Label: 'Project' },
	{ Key: 'Lab', Label: 'Lab' },
];

// Tabs that actually render content today; everything else shows a "coming with phase N" placeholder so the
// shell is shippable + verifiable on its own. Later phases move keys out of this set as they land.
const READY_TABS = { details: true, permissions: true, effective: true, composition: true, members: true, assignment: true, overrides: true, projectsgranted: true };

class AccessWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// Raw subject lists (loaded once per session, refreshed on demand). Roles/Groups are fully loaded (they feed
		// name lookups + the composition/assignment pickers); Users are server-side search results (a customer can have
		// thousands, so they are never preloaded — see _searchUsersAsync).
		this._roles = [];
		this._permissionGroups = [];
		this._users = [];
		this._railLoaded = false;
		this._userSearchTimer = null;
		this._userSearchToken = 0;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	// --- Session context + role gating (mirrors MasterListRegistry + PermissionService) ---

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	get idUser()
	{
		return this.currentUser.UserID;
	}

	/**
	 * Customer-1 / role-5 super-user (the server's EndpointBase._isSuperUser).
	 * @return {Boolean}
	 */
	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		if ((Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1))
		{
			return true;
		}
		// The home app (PermissionService.isSuperUser) also treats the SuperAdminAccessRole as a super-user.
		const tmpRoles = tmpUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && pRole.Hash === 'SuperAdminAccessRole');
	}

	/**
	 * Holds a role with PermissionLevel 'RoleManager' (or is a super-user) — the home app's gate for
	 * editing roles/permissions (PermissionService.isRoleManager). UI hint only; the server is authoritative.
	 * @return {Boolean}
	 */
	get isRoleManager()
	{
		if (this.isSuperUser)
		{
			return true;
		}
		// Mirror PermissionService.isRoleManager (RoleManager level), plus the SuperAdminUser permission level.
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'RoleManager' || pRole.PermissionLevel === 'SuperAdminUser'));
	}

	/**
	 * All roles + permission groups currently loaded in the rail (for name lookups + the composition picker).
	 * @return {Array}
	 */
	get rolesAndGroups()
	{
		return this._roles.concat(this._permissionGroups);
	}

	/**
	 * Is the current subject a User Group (Role.Type==='UserGroup')? Only User Groups grant context memberships
	 * (RoleContextMembership) that member_sync materializes into user projects/labs — so only they get the
	 * "Projects Granted" tab.
	 * @return {Boolean}
	 */
	get isUserGroup()
	{
		return ((this.state.SubjectRecord || {}).Type === 'UserGroup');
	}

	// --- REST helpers (promise wrappers over the Headlight rest client) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			// The rest client exposes deleteEntity(entity, id) (there is no raw deleteJSON). Entity/<id> paths
			// go through it; custom DELETE paths (e.g. Permissions/Role/.../For/User/...) go direct.
			const tmpMatch = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (tmpMatch)
			{
				this.restClient.deleteEntity(tmpMatch[1], tmpMatch[2], (pError, pBody) => pError ? reject(pError) : resolve(pBody));
				return;
			}
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((pResponse) =>
				{
					if (!pResponse.ok) { reject(new Error(`HTTP ${pResponse.status}`)); return; }
					pResponse.text().then((pText) => resolve(pText ? JSON.parse(pText) : {})).catch(() => resolve({}));
				})
				.catch(reject);
		});
	}

	/**
	 * Read an entire filtered set (Count then a single page sized to the count). Meadow's FilteredTo needs an
	 * explicit page size, so we size it from the Count rather than guessing.
	 * @param {String} pEntitySet - plural meadow set (e.g. 'Roles', 'Users')
	 * @param {String} pFilter - a FoxHound FilteredTo expression
	 * @param {Number} [pCap] - hard cap on rows fetched (default 1000)
	 * @return {Promise<Array>}
	 */
	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 1000;
		let tmpTotal = tmpCap;
		try
		{
			const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`);
			tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap);
		}
		catch (pError)
		{
			tmpTotal = tmpCap;
		}
		if (!tmpTotal)
		{
			return [];
		}
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	// --- Workspace state (drives the AccessWorkspace view via AppData) ---

	get state()
	{
		if (!this.pict.AppData.AccessWorkspace)
		{
			this.pict.AppData.AccessWorkspace =
			{
				SubjectKind: '', SubjectID: 0, SubjectLabel: '', SubjectRecord: null,
				Context: 'Customer', IDContext: 0, ContextIDInput: '',
				ActiveTab: 'details',
				Search: '', RailLoading: false,
				Message: '', MessageClass: '', Saving: false, DeleteConfirm: false,
				// Details-tab "add members": a multi-select user picker writes ids here. For an existing role they're
				// assigned on the Add button; for a NEW role they're staged and assigned right after Save creates it.
				DetailsAddUserIDs: [], DetailsAddSaving: false, DetailsAddError: '', DetailsAddNotice: '',
				// derived slots
				RailGroups: [], RailLoadingSlot: [], MessageSlot: [], NewButtonsSlot: [],
				SubjectSlot: [], EmptySlot: [ {} ],
				Tabs: [], ContextOptions: [], ContextIDSlot: [],
				SubjectTitle: '', SubjectIcon: '', SubjectKindLabel: '',
				DetailsActiveSlot: [], DetailsFields: [],
				PlaceholderActiveSlot: [], PlaceholderText: '',
			};
		}
		return this.pict.AppData.AccessWorkspace;
	}

	// --- Boot / rail load ---

	/**
	 * Load (once) the rail subjects and paint. Called by the /Access route.
	 * @param {Boolean} [pForce] - reload even if already loaded
	 */
	async loadAsync(pForce)
	{
		if (this._railLoaded && !pForce)
		{
			this._render();
			return;
		}
		const tmpState = this.state;
		tmpState.RailLoading = true;
		if (!tmpState.IDContext)
		{
			tmpState.IDContext = this.idCustomer;
		}
		this._render();
		try
		{
			await this._loadRailAsync();
			this._railLoaded = true;
		}
		catch (pError)
		{
			this._message(`Could not load roles and users: ${pError && pError.message ? pError.message : pError}`, 'is-danger');
		}
		tmpState.RailLoading = false;
		this._render();
	}

	async _loadRailAsync()
	{
		const tmpCustomer = this.idCustomer;
		// Roles (+ Permission Groups) — global (IDCustomer 0) + this customer, not deleted. Load the FULL set
		// (_getFilteredAll = Count-then-page): the rolesAndGroups getter feeds name lookups AND the composition /
		// assignment pickers, so this set must never be truncated. Roles are admin-authored (bounded; ~1.5k on a large
		// customer). The high cap is only a pathological backstop, not the old silent 1000-row cutoff.
		const tmpRoleFilter = `FBL~IDCustomer~INN~0,${tmpCustomer}~FBV~Deleted~EQ~0`;
		const tmpRoles = await this._getFilteredAll('Roles', tmpRoleFilter, 10000);
		this._roles = tmpRoles.filter((pRole) => (pRole.Type !== 'PermissionGroup'));
		this._permissionGroups = tmpRoles.filter((pRole) => (pRole.Type === 'PermissionGroup'));
		// Users are NOT preloaded — a customer can have thousands (9,495 seen), so the old `Users/…/0/100` cap silently
		// hid everyone past the first 100 and the client-side search could never reach them. The rail's Users group is
		// server-side search now (setSearch → _searchUsersAsync); it starts empty until the admin types.
		this._users = [];
	}

	// --- Subject selection ---

	async selectRoleAsync(pID)
	{
		return this._selectRoleRecordAsync(pID, 'role');
	}

	async selectGroupAsync(pID)
	{
		return this._selectRoleRecordAsync(pID, 'group');
	}

	async _selectRoleRecordAsync(pID, pKind)
	{
		const tmpState = this.state;
		const tmpID = parseInt(pID, 10);
		tmpState.SubjectKind = pKind;
		tmpState.SubjectID = tmpID;
		// Land a role/group on its Permissions matrix — the primary thing managed here.
		tmpState.ActiveTab = 'permissions';
		tmpState.Message = '';
		this._render();
		try
		{
			const tmpRole = await this._getJSON(`Role/${tmpID}`);
			tmpState.SubjectRecord = tmpRole || null;
			tmpState.SubjectLabel = (tmpRole && tmpRole.Name) || `Role ${tmpID}`;
		}
		catch (pError)
		{
			tmpState.SubjectRecord = null;
			this._message(`Could not load that ${pKind}.`, 'is-danger');
		}
		this._render();
		this._loadActiveTabData();
	}

	async selectUserAsync(pID)
	{
		const tmpState = this.state;
		const tmpID = parseInt(pID, 10);
		tmpState.SubjectKind = 'user';
		tmpState.SubjectID = tmpID;
		tmpState.ActiveTab = 'details';
		tmpState.Message = '';
		this._render();
		try
		{
			const tmpUser = await this._getJSON(`User/${tmpID}`);
			tmpState.SubjectRecord = tmpUser || null;
			tmpState.SubjectLabel = tmpUser ? libUserSearch.userLabel(tmpUser) : `User ${tmpID}`;
		}
		catch (pError)
		{
			tmpState.SubjectRecord = null;
			this._message('Could not load that user.', 'is-danger');
		}
		this._render();
	}

	/**
	 * Open a role/group by its GUID — the PSRS read-route bridge from the raw Role list.
	 * @param {String} pGUID
	 */
	async openRoleByGUIDAsync(pGUID)
	{
		this.loadAsync();
		try
		{
			const tmpRows = await this._getFilteredAll('Roles', `FBV~GUIDRole~EQ~${pGUID}`, 1);
			if (tmpRows.length)
			{
				const tmpRole = tmpRows[0];
				this.selectSubject((tmpRole.Type === 'PermissionGroup') ? 'group' : 'role', tmpRole.IDRole);
			}
		}
		catch (pError)
		{
			this._message('Could not open that role.', 'is-danger');
			this._render();
		}
	}

	/**
	 * Dispatch a rail click to the right subject loader.
	 * @param {String} pKind - 'role' | 'group' | 'user'
	 * @param {Number} pID
	 */
	selectSubject(pKind, pID)
	{
		// A different subject → drop any users staged in the Details add-members picker (don't carry them across roles).
		this._resetDetailsAdd();
		if (pKind === 'user')
		{
			return this.selectUserAsync(pID);
		}
		if (pKind === 'group')
		{
			return this.selectGroupAsync(pID);
		}
		return this.selectRoleAsync(pID);
	}

	/** Clear the Details add-members picker state (on subject change / new). */
	_resetDetailsAdd()
	{
		const tmpState = this.state;
		tmpState.DetailsAddUserIDs = [];
		tmpState.DetailsAddSaving = false;
		tmpState.DetailsAddError = '';
		tmpState.DetailsAddNotice = '';
	}

	// --- Role / Group CRUD ---

	newRole()
	{
		this._startNew('role', 'Role');
	}

	newGroup()
	{
		this._startNew('group', 'PermissionGroup');
	}

	_startNew(pKind, pType)
	{
		const tmpState = this.state;
		tmpState.SubjectKind = pKind;
		tmpState.SubjectID = 0;
		tmpState.SubjectRecord = { IDRole: 0, Name: '', Type: pType, PermissionLevel: '', Description: '', IDCustomer: this.idCustomer };
		tmpState.SubjectLabel = (pKind === 'group') ? 'New permission group' : 'New role';
		tmpState.ActiveTab = 'details';
		tmpState.DeleteConfirm = false;
		tmpState.Message = '';
		this._resetDetailsAdd();
		this._render();
	}

	/**
	 * Update a field of the in-edit role/group record. Text fields don't repaint (so the input keeps focus);
	 * the Type select repaints to refresh the subject icon/label.
	 * @param {String} pField
	 * @param {String} pValue
	 */
	setDetailField(pField, pValue)
	{
		if (!this.state.SubjectRecord)
		{
			return;
		}
		this.state.SubjectRecord[pField] = pValue;
		if (pField === 'Type')
		{
			this.state.SubjectKind = (pValue === 'PermissionGroup') ? 'group' : 'role';
			this._render();
		}
	}

	/**
	 * Create (IDRole 0) or update the selected role/group, then refresh the rail + keep it selected.
	 */
	async saveDetailsAsync()
	{
		const tmpState = this.state;
		if (tmpState.Saving)
		{
			return;
		}
		const tmpRecord = tmpState.SubjectRecord || {};
		if (!tmpRecord.Name || !String(tmpRecord.Name).trim())
		{
			this._message('A name is required.', 'is-warning');
			this._render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Message = '';
		this._render();
		const tmpType = tmpRecord.Type || 'Role';
		const tmpPayload =
		{
			Name: String(tmpRecord.Name).trim(),
			Type: tmpType,
			PermissionLevel: tmpRecord.PermissionLevel || '',
			Description: tmpRecord.Description || '',
			IDCustomer: tmpRecord.IDCustomer || this.idCustomer,
		};
		const tmpWasNew = !(Number(tmpState.SubjectID) > 0);
		try
		{
			let tmpSaved;
			if (!tmpWasNew)
			{
				tmpPayload.IDRole = Number(tmpState.SubjectID);
				tmpSaved = await this._putJSON('Role', tmpPayload);
			}
			else
			{
				tmpSaved = await this._postJSON('Role', tmpPayload);
			}
			const tmpNewID = (tmpSaved && tmpSaved.IDRole) || Number(tmpState.SubjectID);
			await this._loadRailAsync();
			this._railLoaded = true;
			tmpState.SubjectID = tmpNewID;
			tmpState.SubjectKind = (tmpType === 'PermissionGroup') ? 'group' : 'role';
			tmpState.SubjectRecord = tmpSaved || Object.assign({ IDRole: tmpNewID }, tmpPayload);
			tmpState.SubjectLabel = tmpPayload.Name;
			tmpState.Saving = false;
			// Create Role screen: assign any members staged on the form now that the role has an id.
			if (tmpWasNew && (tmpNewID > 0) && (tmpState.DetailsAddUserIDs || []).length)
			{
				const tmpStaged = tmpState.DetailsAddUserIDs.slice();
				tmpState.DetailsAddUserIDs = [];
				this._message('Saved. Adding members…', 'is-success is-light');
				this._render();
				const tmpAssign = await this._assignUsersToRoleAsync(tmpNewID, tmpStaged);
				tmpState.DetailsAddNotice = tmpAssign.fail
					? `Added ${tmpAssign.ok} member${tmpAssign.ok === 1 ? '' : 's'}; ${tmpAssign.fail} could not be added (you may lack permission).`
					: `Added ${tmpAssign.ok} member${tmpAssign.ok === 1 ? '' : 's'} to this role.`;
			}
			this._message('Saved.', 'is-success is-light');
			this._render();
		}
		catch (pError)
		{
			tmpState.Saving = false;
			this._message(`Could not save: ${pError && pError.message ? pError.message : pError}`, 'is-danger');
			this._render();
		}
	}

	requestDelete()
	{
		this.state.DeleteConfirm = true;
		this._render();
	}

	cancelDelete()
	{
		this.state.DeleteConfirm = false;
		this._render();
	}

	/**
	 * Delete the selected role/group, then refresh the rail + clear the selection.
	 */
	async confirmDeleteAsync()
	{
		const tmpState = this.state;
		if (Number(tmpState.SubjectID) <= 0 || tmpState.Saving)
		{
			return;
		}
		tmpState.Saving = true;
		this._render();
		try
		{
			await this._deleteJSON(`Role/${tmpState.SubjectID}`);
			await this._loadRailAsync();
			this._railLoaded = true;
			tmpState.SubjectKind = '';
			tmpState.SubjectID = 0;
			tmpState.SubjectRecord = null;
			tmpState.DeleteConfirm = false;
			tmpState.Saving = false;
			this._message('Deleted.', 'is-success is-light');
			this._render();
		}
		catch (pError)
		{
			tmpState.Saving = false;
			this._message(`Could not delete: ${pError && pError.message ? pError.message : pError}`, 'is-danger');
			this._render();
		}
	}

	// --- Tab + context controls ---

	/** Switch tabs via a stable route (#/Access/<Kind>/<ID>/<tab>) so the subject AND its active tab both live in
	 *  the URL — deep-linkable, bookmarkable, back/forward. The tab buttons call this; the subject-route handler
	 *  applies the tab (and only re-selects/re-fetches the subject when it actually changed). */
	navigateTab(pTab)
	{
		const tmpState = this.state;
		const tmpKindPath = { role: 'Role', group: 'Group', user: 'User' }[tmpState.SubjectKind];
		if (tmpKindPath && tmpState.SubjectID && (typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/Access/${ tmpKindPath }/${ tmpState.SubjectID }/${ pTab }`;
		}
		else
		{
			this.setActiveTab(pTab);
		}
	}

	setActiveTab(pKey)
	{
		this.state.ActiveTab = pKey;
		this._render();
		this._loadActiveTabData();
	}

	setContext(pContext)
	{
		const tmpState = this.state;
		tmpState.Context = pContext;
		if (pContext === 'Customer')
		{
			tmpState.IDContext = this.idCustomer;
			tmpState.ContextIDInput = '';
		}
		else
		{
			// Other scopes take an explicit context entity ID typed below.
			tmpState.IDContext = parseInt(tmpState.ContextIDInput, 10) || 0;
		}
		this._onContextChanged();
	}

	setContextID(pValue)
	{
		const tmpState = this.state;
		tmpState.ContextIDInput = pValue;
		tmpState.IDContext = parseInt(pValue, 10) || 0;
		this._onContextChanged();
	}

	/**
	 * Hook for the data tabs to refresh when the context changes. Phase 0 just repaints; later phases
	 * override-extend this to re-read the matrix / visualizer for the new Context+IDContext.
	 */
	_onContextChanged()
	{
		this._render();
		this._loadActiveTabData();
	}

	setSearch(pValue)
	{
		this.state.Search = pValue || '';
		// Roles/Groups are fully loaded → filter them client-side immediately (snappy). Users are server-side search:
		// debounce 250ms then query (mirrors SuperUserGrant / Entitlements), with a stale-token guard on the response.
		this._render();
		if (this._userSearchTimer) { clearTimeout(this._userSearchTimer); }
		this._userSearchTimer = setTimeout(() => { this._userSearchTimer = null; this._searchUsersAsync(); }, 250);
	}

	/**
	 * Server-side user search for the rail's Users group (the shared user search: name, login ID or email, every word
	 * must match), scoped to this customer + not deleted, in name order, capped at 50. Below 2 characters the group
	 * clears — browsing thousands of users is exactly the failure mode we're removing. Guarded by a token so a slow
	 * response from an earlier keystroke can't overwrite a newer one.
	 */
	async _searchUsersAsync()
	{
		const tmpQuery = String(this.state.Search || '').trim();
		if (tmpQuery.length < 2)
		{
			this._users = [];
			this._render();
			return;
		}
		const tmpToken = ++this._userSearchToken;
		let tmpUsers = [];
		try
		{
			tmpUsers = await libUserSearch.searchUsersAsync((pURL) => this._getJSON(pURL), tmpQuery, { Scope: `FBV~IDCustomer~EQ~${this.idCustomer}~FBV~Deleted~EQ~0`, PageSize: 50 });
		}
		catch (pError)
		{
			tmpUsers = [];
		}
		if (tmpToken !== this._userSearchToken)
		{
			return;
		}
		this._users = tmpUsers;
		this._render();
	}

	/**
	 * Trigger the owning provider's data load for the active tab (on subject select, tab switch, or context
	 * change). Each data tab is backed by its own provider but reads subject + context from here.
	 */
	_loadActiveTabData()
	{
		const tmpState = this.state;
		if (!tmpState.SubjectRecord)
		{
			return;
		}
		if (tmpState.ActiveTab === 'permissions' && tmpState.SubjectKind !== 'user' && this.pict.providers.PermissionMatrix)
		{
			this.pict.providers.PermissionMatrix.loadAsync();
		}
		if (tmpState.ActiveTab === 'effective' && this.pict.providers.PermissionVisualizer)
		{
			this.pict.providers.PermissionVisualizer.loadAsync();
		}
		if (tmpState.ActiveTab === 'composition' && tmpState.SubjectKind !== 'user' && this.pict.providers.GroupComposition)
		{
			this.pict.providers.GroupComposition.loadAsync();
		}
		if (tmpState.ActiveTab === 'members' && tmpState.SubjectKind !== 'user' && this.pict.providers.GroupComposition)
		{
			this.pict.providers.GroupComposition.loadMembersAsync();
		}
		if (tmpState.ActiveTab === 'projectsgranted' && this.isUserGroup && this.pict.providers.UserGroupGrants)
		{
			this.pict.providers.UserGroupGrants.loadGrantsAsync();
		}
		if ((tmpState.ActiveTab === 'assignment' || tmpState.ActiveTab === 'overrides') && tmpState.SubjectKind === 'user' && this.pict.providers.RoleAssignment)
		{
			this.pict.providers.RoleAssignment.loadAsync();
		}
	}

	// --- Helpers ---


	_message(pMessage, pClass)
	{
		const tmpState = this.state;
		tmpState.Message = pMessage;
		tmpState.MessageClass = pClass || 'is-info';
	}

	_matchesSearch(pLabel)
	{
		const tmpSearch = (this.state.Search || '').toLowerCase().trim();
		if (!tmpSearch)
		{
			return true;
		}
		return String(pLabel || '').toLowerCase().indexOf(tmpSearch) > -1;
	}

	// --- Render ---

	_render()
	{
		this.deriveRenderState();
		if (this.pict.views.AccessWorkspace)
		{
			this.pict.views.AccessWorkspace.render();
		}
	}

	/**
	 * Recompute the AppData the AccessWorkspace view renders.
	 */
	deriveRenderState()
	{
		const tmpState = this.state;

		tmpState.RailLoadingSlot = tmpState.RailLoading ? [ {} ] : [];
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message, MessageClass: tmpState.MessageClass || 'is-info' } ] : [];
		tmpState.NewButtonsSlot = this.isRoleManager ? [ {} ] : [];

		// Rail groups. Roles/Groups are fully loaded → client-filtered by the search box. Users are server-side search
		// results (already filtered) → shown as-is, with a hint prompting a search when the group is empty.
		const tmpQuery = String(tmpState.Search || '').trim();
		const tmpUsersGroup = this._railGroup('users', 'Users', 'fas fa-users', this._users, 'user', true);
		tmpUsersGroup.HintSlot = tmpUsersGroup.Rows.length
			? []
			: [ { Hint: (tmpQuery.length < 2) ? 'Type at least 2 characters to find a user.' : `No users match “${tmpQuery}”.` } ];
		tmpState.RailGroups =
		[
			this._railGroup('roles', 'Roles', 'fas fa-user-shield', this._roles, 'role', false),
			this._railGroup('groups', 'Permission Groups', 'fas fa-layer-group', this._permissionGroups, 'group', false),
			tmpUsersGroup,
			// Roles/Groups collapse when empty under a search; the Users group always shows (it carries the search hint).
		].filter((pGroup) => (pGroup.Key === 'users') || pGroup.Rows.length > 0 || !tmpState.Search);

		// Context bar.
		tmpState.ContextOptions = CONTEXT_OPTIONS.map((pOption) =>
			({ Key: pOption.Key, Label: pOption.Label, SelectedAttr: (pOption.Key === tmpState.Context) ? 'selected' : '' }));
		tmpState.ContextIDSlot = (tmpState.Context === 'Customer') ? [] : [ { ContextIDInput: tmpState.ContextIDInput, Context: tmpState.Context } ];

		// Subject + tabs.
		if (tmpState.SubjectKind && tmpState.SubjectRecord)
		{
			this._deriveSubject(tmpState);
			tmpState.SubjectSlot = [ tmpState ];
			tmpState.EmptySlot = [];
		}
		else if (tmpState.SubjectKind && !tmpState.SubjectRecord)
		{
			// selected but still loading (or failed) — keep the empty pane minimal
			tmpState.SubjectSlot = [];
			tmpState.EmptySlot = [ {} ];
		}
		else
		{
			tmpState.SubjectSlot = [];
			tmpState.EmptySlot = [ {} ];
		}
	}

	_railGroup(pKey, pLabel, pIcon, pRecords, pKind, pServerFiltered)
	{
		const tmpActiveKind = this.state.SubjectKind;
		const tmpActiveID = this.state.SubjectID;
		const tmpRows = (pRecords || []).map((pRecord) =>
		{
			if (pKind === 'user')
			{
				return {
					ID: pRecord.IDUser,
					Label: libUserSearch.userLabel(pRecord),
					Sub: pRecord.LoginID || pRecord.Email || '',
				};
			}
			return {
				ID: pRecord.IDRole,
				Label: pRecord.Name || `Role ${pRecord.IDRole}`,
				Sub: (Number(pRecord.IDCustomer) === 0) ? 'Global' : (pRecord.PermissionLevel || ''),
			};
		})
			// Users are already server-filtered (pServerFiltered) — don't re-filter them client-side, or a hit on a
			// field not shown in the row label (e.g. email) would be dropped. Roles/Groups filter on the search box.
			.filter((pRow) => pServerFiltered || this._matchesSearch(pRow.Label) || this._matchesSearch(pRow.Sub))
			.map((pRow) => Object.assign(pRow, {
				Kind: pKind,
				RowClass: (tmpActiveKind === pKind && Number(tmpActiveID) === Number(pRow.ID)) ? 'is-active' : '',
			}));
		return { Key: pKey, Label: pLabel, Icon: pIcon, Rows: tmpRows, Count: tmpRows.length, HintSlot: [] };
	}

	_deriveSubject(pState)
	{
		const tmpIsUser = (pState.SubjectKind === 'user');
		// User Groups (Role.Type==='UserGroup') get an extra "Projects Granted" tab; other roles/groups don't.
		const tmpTabs = tmpIsUser ? TABS_USER : (this.isUserGroup ? TABS_ROLE.concat([ TAB_PROJECTS_GRANTED ]) : TABS_ROLE);

		pState.SubjectTitle = pState.SubjectLabel;
		pState.SubjectIcon = tmpIsUser ? 'fas fa-user' : (pState.SubjectKind === 'group' ? 'fas fa-layer-group' : 'fas fa-user-shield');
		pState.SubjectKindLabel = tmpIsUser ? 'User' : (this.isUserGroup ? 'User Group' : (pState.SubjectKind === 'group' ? 'Permission Group' : 'Role'));

		pState.Tabs = libTabBar.buildTabs(tmpTabs, pState.ActiveTab, (pTab) => `_Pict.providers.AccessWorkspace.navigateTab('${ pTab.Key }')`);

		// Per-tab body: phase 0 renders Details for real; not-yet-ready tabs show a placeholder. Later phases
		// move their tab key into READY_TABS + add a sibling active-slot as they mount real content.
		const tmpActive = pState.ActiveTab;
		const tmpRoleEditable = (!tmpIsUser && !!this.isRoleManager);
		pState.DetailsReadSlot = (tmpActive === 'details' && !tmpRoleEditable) ? [ { Fields: this._detailsFields(pState) } ] : [];
		pState.DetailsEditSlot = (tmpActive === 'details' && tmpRoleEditable) ? [ this._detailsForm(pState) ] : [];
		pState.MatrixActiveSlot = (!tmpIsUser && tmpActive === 'permissions') ? [ {} ] : [];
		pState.EffectiveActiveSlot = (tmpActive === 'effective') ? [ {} ] : [];
		pState.CompositionActiveSlot = (!tmpIsUser && tmpActive === 'composition') ? [ {} ] : [];
		pState.MembersActiveSlot = (!tmpIsUser && tmpActive === 'members') ? [ {} ] : [];
		pState.ProjectsGrantedActiveSlot = (!tmpIsUser && this.isUserGroup && tmpActive === 'projectsgranted') ? [ {} ] : [];
		pState.AssignmentActiveSlot = (tmpIsUser && tmpActive === 'assignment') ? [ {} ] : [];
		pState.OverridesActiveSlot = (tmpIsUser && tmpActive === 'overrides') ? [ {} ] : [];
		pState.PlaceholderActiveSlot = (!READY_TABS[tmpActive]) ? [ { Text: this._placeholderText(tmpActive) } ] : [];

		// Let the active tab's provider recompute its slots within this render pass (pure; no network).
		if (pState.MatrixActiveSlot.length && this.pict.providers.PermissionMatrix)
		{
			this.pict.providers.PermissionMatrix.deriveMatrix();
		}
		if (pState.EffectiveActiveSlot.length && this.pict.providers.PermissionVisualizer)
		{
			this.pict.providers.PermissionVisualizer.deriveVisualizer();
		}
		if (pState.CompositionActiveSlot.length && this.pict.providers.GroupComposition)
		{
			this.pict.providers.GroupComposition.deriveComposition();
		}
		if (pState.MembersActiveSlot.length && this.pict.providers.GroupComposition)
		{
			this.pict.providers.GroupComposition.deriveMembership();
		}
		if ((pState.AssignmentActiveSlot.length || pState.OverridesActiveSlot.length) && this.pict.providers.RoleAssignment)
		{
			this.pict.providers.RoleAssignment.deriveAssignment();
		}
	}

	_detailsFields(pState)
	{
		const tmpRecord = pState.SubjectRecord || {};
		if (pState.SubjectKind === 'user')
		{
			return [
				{ Label: 'Name', Value: libUserSearch.userLabel(tmpRecord) },
				{ Label: 'Login', Value: tmpRecord.LoginID || '' },
				{ Label: 'Email', Value: tmpRecord.Email || '' },
				{ Label: 'Base role level', Value: String(tmpRecord.UserRole || tmpRecord.IDRole || '') },
				{ Label: 'Customer', Value: String(tmpRecord.IDCustomer || '') },
			].filter((pField) => pField.Value !== '');
		}
		return [
			{ Label: 'Name', Value: tmpRecord.Name || '' },
			{ Label: 'Type', Value: tmpRecord.Type || 'Role' },
			{ Label: 'Permission level', Value: tmpRecord.PermissionLevel || '' },
			{ Label: 'Level ordinal', Value: (tmpRecord.LevelOrdinal !== undefined && tmpRecord.LevelOrdinal !== null) ? String(tmpRecord.LevelOrdinal) : '' },
			{ Label: 'Scope', Value: (Number(tmpRecord.IDCustomer) === 0) ? 'Global (all customers)' : `Customer ${tmpRecord.IDCustomer}` },
			{ Label: 'Description', Value: tmpRecord.Description || '' },
		].filter((pField) => pField.Value !== '');
	}

	/**
	 * Build the editable Details form model for a role/group (role-manager view).
	 * @param {Object} pState
	 * @return {Object}
	 */
	_detailsForm(pState)
	{
		const tmpRecord = pState.SubjectRecord || {};
		const tmpType = tmpRecord.Type || 'Role';
		const tmpIsNew = (Number(pState.SubjectID) <= 0);
		return {
			IDRole: pState.SubjectID,
			IsNew: tmpIsNew,
			Name: tmpRecord.Name || '',
			Description: tmpRecord.Description || '',
			PermissionLevel: tmpRecord.PermissionLevel || '',
			TypeOptions:
			[
				{ Value: 'Role', Label: 'Role', SelectedAttr: (tmpType !== 'PermissionGroup' && tmpType !== 'UserGroup') ? 'selected' : '' },
				{ Value: 'PermissionGroup', Label: 'Permission Group', SelectedAttr: (tmpType === 'PermissionGroup') ? 'selected' : '' },
				{ Value: 'UserGroup', Label: 'User Group', SelectedAttr: (tmpType === 'UserGroup') ? 'selected' : '' },
			],
			Scope: (Number(tmpRecord.IDCustomer) === 0) ? 'Global (all customers)' : `Customer ${tmpRecord.IDCustomer || this.idCustomer}`,
			SaveDisabledAttr: pState.Saving ? 'disabled' : '',
			DuplicateButtonSlot: (!tmpIsNew) ? [ { IDRole: pState.SubjectID } ] : [],
			DeleteButtonSlot: (!tmpIsNew && !pState.DeleteConfirm) ? [ {} ] : [],
			DeleteConfirmSlot: (!tmpIsNew && pState.DeleteConfirm) ? [ {} ] : [],
			// "Add members" panel on the Details (View/Create Role) screen. Existing role → Add button (assigns now);
			// new role → staged, assigned on Save. This form only renders for Role Managers, so no extra gate needed.
			AddMembersSlot:
			[
				{
					AddButtonSlot: (!tmpIsNew) ? [ {} ] : [],
					NewHintSlot: tmpIsNew ? [ {} ] : [],
					SavingSlot: pState.DetailsAddSaving ? [ {} ] : [],
					NoticeSlot: pState.DetailsAddNotice ? [ { Notice: pState.DetailsAddNotice } ] : [],
					ErrorSlot: pState.DetailsAddError ? [ { Error: pState.DetailsAddError } ] : [],
				},
			],
		};
	}

	// --- Add members from the Details (View / Create Role) screen ---

	/** (Re)mount the multi-select user picker into #acw-details-add-members-picker (Details edit form). Called from
	 * the view's onAfterRender; no-ops unless the mount is present (Details tab, Role Manager). */
	mountDetailsAddMembersPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#acw-details-add-members-picker').length === 0) { return; }
		const tmpView = tmpPicker.createPicker('AccessWorkspace-DetailsAddMembers',
			{
				DestinationAddress: '#acw-details-add-members-picker',
				ValueAddress: 'AppData.AccessWorkspace.DetailsAddUserIDs',
				Mode: 'multi',
				Searchable: true,
				Placeholder: 'Search users by name, login ID or email…',
				DataProvider: this._userPickerDataProvider(),
				ResolveValue: this._userPickerResolveValue(),
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	/** Server-side user search (customer-scoped) for the add-members picker. Empty term → browse the customer's users. */
	_userPickerDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._getJSON(pURL), { Scope: () => `FBV~IDCustomer~EQ~${this.idCustomer}~FBV~Deleted~EQ~0`, PageSize: 25 });
	}

	/** Resolve a selected user id → {Value,Text} so its chip shows a name. */
	_userPickerResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`User/${tmpID}`)
				.then((pUser) => ((pUser && pUser.IDUser) ? libUserSearch.userPickerOption(pUser) : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/** Assign users to a role at the customer scope (UserRoleJoin) in bounded-concurrency batches → { ok, fail }. */
	async _assignUsersToRoleAsync(pIDRole, pUserIDs)
	{
		const tmpIDs = (pUserIDs || []).map(Number).filter((pID) => pID > 0);
		let tmpOK = 0;
		let tmpFail = 0;
		const tmpConcurrency = 6;
		for (let tmpStart = 0; tmpStart < tmpIDs.length; tmpStart += tmpConcurrency)
		{
			const tmpBatch = tmpIDs.slice(tmpStart, tmpStart + tmpConcurrency);
			/* eslint-disable no-await-in-loop */
			await Promise.all(tmpBatch.map((pIDUser) =>
				this._putJSON('Permissions/Role/For/User', { IDRole: Number(pIDRole), IDUser: pIDUser, Context: 'Customer', IDContext: this.idCustomer })
					.then(() => { tmpOK++; }, () => { tmpFail++; })));
			/* eslint-enable no-await-in-loop */
		}
		return { ok: tmpOK, fail: tmpFail };
	}

	/** Existing role: assign the picked users immediately (the Details "Add users" button). A brand-new role has no
	 * id yet, so its picks are staged and assigned by saveDetailsAsync instead. */
	async addDetailsMembersAsync()
	{
		const tmpState = this.state;
		const tmpIDRole = Number(tmpState.SubjectID);
		if (!(tmpIDRole > 0) || tmpState.DetailsAddSaving) { return; }
		const tmpUserIDs = (tmpState.DetailsAddUserIDs || []).map(Number).filter((pID) => pID > 0);
		if (!tmpUserIDs.length)
		{
			tmpState.DetailsAddError = 'Search for and pick one or more users to add first.';
			tmpState.DetailsAddNotice = '';
			this._render();
			return;
		}
		tmpState.DetailsAddSaving = true;
		tmpState.DetailsAddError = '';
		tmpState.DetailsAddNotice = '';
		this._render();
		const tmpResult = await this._assignUsersToRoleAsync(tmpIDRole, tmpUserIDs);
		tmpState.DetailsAddSaving = false;
		tmpState.DetailsAddUserIDs = [];
		tmpState.DetailsAddNotice = tmpResult.fail
			? `Added ${tmpResult.ok} member${tmpResult.ok === 1 ? '' : 's'}; ${tmpResult.fail} could not be added (you may lack permission).`
			: `Added ${tmpResult.ok} member${tmpResult.ok === 1 ? '' : 's'} to this ${(tmpState.SubjectKind === 'group') ? 'group' : 'role'}.`;
		this._render();
		// Refresh the Members tab's data so it reflects the new members next time it's viewed.
		if (this.pict.providers.GroupComposition) { this.pict.providers.GroupComposition.loadMembersAsync(true); }
	}

	_placeholderText(pTab)
	{
		switch (pTab)
		{
		case 'permissions': return 'The permission matrix lands in the next phase.';
		case 'effective': return 'The effective-permissions visualizer lands in a later phase.';
		case 'composition': return 'Group composition (the role inheritance tree) lands in a later phase.';
		case 'members': return 'The members view lands in a later phase.';
		case 'assignment': return 'Role assignment lands in a later phase.';
		case 'overrides': return 'User permission overrides land in a later phase.';
		default: return 'Coming soon.';
		}
	}
}

module.exports = AccessWorkspaceProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'AccessWorkspace',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

},{"../access/User-Search.js":1064,"../views/TabBar.js":1479,"pict-provider":845}],1301:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');

/**
 * ActivityObservabilityProvider — the shared data+render engine behind the three bespoke observability views
 * (User Activity, User Logins, Project Activity). One provider so the temporal-count engine, the date bucketizer,
 * the REST helpers and the (theme-aware) chart plumbing live in one place; each thin view (SuperUserGrant-style)
 * delegates its render into a mount div here.
 *
 * SCALE: never pull entity rows to count them. Every temporal series is built from server-side
 * `{Entity}s/Count/FilteredTo/<filter>` calls (SQL COUNT(*), zero row transfer, no page cap) — one per
 * (entity, time bucket), run under bounded concurrency. Validated against LADOTD (11.4M observations). The only
 * row reads are bounded lists: the login roster (paged/searched) and the project recent-activity stream (a small
 * capped tail read per entity).
 *
 * TENANCY: customer-scoped via callerCustomer() (the session's CustomerID); the server stays authoritative. The
 * views work for customer admins directly and for a super-user who has impersonated a customer. Cross-customer
 * widening without impersonation is intentionally not attempted here (server RLS scopes to the session customer).
 */
class ActivityObservabilityProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;

		// Per-view state kept apart so the three surfaces don't stomp each other.
		this.userActivity =
		{
			IDUser: null, User: null, Window: '90d', Granularity: 'auto', Metric: 'create',
			Loading: false, Error: '', Buckets: [], Series: [], Totals: {},
			Progress: { active: false, done: 0, total: 0, perEntity: [] },
			PickerOpen: false, PickerSearch: '', PickerResults: [], PickerSearching: false, Token: 0,
		};
		this.logins =
		{
			Loading: false, Error: '', Users: [], Filter: '', Total: 0,
			Recency: { active: 0, idle: 0, dormant: 0, never: 0 },
			Searching: false, SearchResults: null, SearchTerm: '', Token: 0,
		};
		this.projectActivity =
		{
			IDProject: null, Project: null, Window: '90d', Granularity: 'auto', Metric: 'create',
			Loading: false, Error: '', Buckets: [], Series: [], Totals: {}, Stream: [], StreamLoading: false,
			Progress: { active: false, done: 0, total: 0, perEntity: [] }, PickerOpen: false,
			PickerSearch: '', PickerResults: [], PickerSearching: false, Token: 0, PickerPage: 0, PickerHasMore: false,
		};

		this._userNameCache = {};
		this._pickerTimer = null;
	}

	// ---- shared plumbing -----------------------------------------------------------------------------

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get app() { return this.pict.PictApplication; }
	get chartProvider() { return this.pict.providers.PlatformDashboardData; }

	/** Fable's built-in progress/time-estimation service (ProgressTrackerSet) — lazily instantiated once. */
	get trackerSet()
	{
		if (this._trackerSet === undefined)
		{
			try { this._trackerSet = this.pict.fable.instantiateServiceProviderIfNotExists('ProgressTrackerSet'); }
			catch (pError) { this._trackerSet = null; }
		}
		return this._trackerSet;
	}

	/** Trim Fable's formatTimeDuration ("3s 421ms") to its coarse head ("3s") once a second-or-larger unit is present. */
	_coarseDuration(pText)
	{
		const tmpText = String(pText == null ? '' : pText);
		const tmpStripped = tmpText.replace(/\s*\d+ms$/, '').trim();
		return tmpStripped.length ? tmpStripped : tmpText;
	}

	/** The session customer; all queries scope to it (server stays authoritative). */
	callerCustomer() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || null; }
	sessionUserID() { return (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.UserID) || null; }
	isSuperUser() { return !!(this.app && typeof this.app._isSuperUser === 'function' && this.app._isSuperUser()); }

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody)));
	}

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	_assign(pSelector, pHTML)
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(pSelector).length) { tmpCA.assignContent(pSelector, pHTML); }
	}

	/** Inject the shared .ao-* stylesheet once. */
	_ensureStyles()
	{
		if (document.getElementById('ao-observability-styles')) { return; }
		const tmpStyle = document.createElement('style');
		tmpStyle.id = 'ao-observability-styles';
		tmpStyle.textContent = ActivityObservabilityProvider.SHARED_CSS;
		document.head.appendChild(tmpStyle);
	}

	// ---- concurrency + counting ---------------------------------------------------------------------

	/** Run fWorker over items with at most pLimit in flight; results keep item order. */
	async _mapLimit(pItems, pLimit, fWorker)
	{
		const tmpResults = new Array(pItems.length);
		let tmpNext = 0;
		const fRunner = async () =>
		{
			while (tmpNext < pItems.length)
			{
				const tmpIndex = tmpNext++;
				tmpResults[tmpIndex] = await fWorker(pItems[tmpIndex], tmpIndex);
			}
		};
		const tmpRunners = [];
		for (let i = 0; i < Math.min(pLimit, pItems.length); i++) { tmpRunners.push(fRunner()); }
		await Promise.all(tmpRunners);
		return tmpResults;
	}

	/** One server-side COUNT(*); returns a number (0 on any error, so a slow/failed entity degrades gracefully). */
	async _countAsync(pEntityPlural, pFilter)
	{
		try
		{
			const tmpBody = await this._getJSON(`${pEntityPlural}/Count/FilteredTo/${pFilter}`);
			if (tmpBody && tmpBody.Count != null) { return Number(tmpBody.Count) || 0; }
			if (typeof tmpBody === 'number') { return tmpBody; }
			return 0;
		}
		catch (pError) { return 0; }
	}

	/**
	 * Count several entities' temporal series through ONE bounded pool (so total concurrency is fixed and the
	 * progress is reportable): one COUNT call per (entity, bucket), ANDing the entity base filter with the
	 * bucket's [start,end) date range. Mutates pProgress ({ active, done, total, perEntity }) and calls
	 * fOnProgress (throttled) as counts land, so the view can show a live "what it's doing / how far" panel.
	 *
	 * @param {Array<{plural:string,label:string,color:string}>} pEntities
	 * @return {Promise<Array<{label:string,color:string,counts:number[],total:number}>>}
	 */
	async _countAllSeriesAsync(pEntities, pBaseStanzas, pDateField, pBuckets, pProgress, fOnProgress)
	{
		pProgress.active = true;
		pProgress.total = pEntities.length * pBuckets.length;
		pProgress.done = 0;
		pProgress.etaText = null;
		pProgress.elapsedText = null;
		pProgress.perEntity = pEntities.map((pEntity) => ({ label: pEntity.label, color: pEntity.color, done: 0, total: pBuckets.length }));
		const tmpResults = pEntities.map(() => new Array(pBuckets.length).fill(0));
		const tmpTasks = [];
		pEntities.forEach((pEntity, pEI) => pBuckets.forEach((pBucket, pBI) => tmpTasks.push({ ei: pEI, bi: pBI, plural: pEntity.plural })));
		// Fable's built-in time estimator: a fresh, uniquely-hashed tracker per run (so a superseded run can't
		// corrupt a newer one's timing), started now and incremented as each count lands.
		const tmpSet = this.trackerSet;
		this._trackerSeq = (this._trackerSeq || 0) + 1;
		const tmpTrackerHash = `ActivityObservability-Counts-${this._trackerSeq}`;
		if (tmpSet) { tmpSet.createProgressTracker(tmpTrackerHash, pProgress.total); tmpSet.startProgressTracker(tmpTrackerHash); }
		if (fOnProgress) { fOnProgress(); }
		await this._mapLimit(tmpTasks, 8, async (pTask) =>
		{
			const tmpBucket = pBuckets[pTask.bi];
			const tmpFilter = `${pBaseStanzas}~FBV~${pDateField}~GE~${tmpBucket.s}~FBV~${pDateField}~LT~${tmpBucket.e}`;
			tmpResults[pTask.ei][pTask.bi] = await this._countAsync(pTask.plural, tmpFilter);
			pProgress.done++;
			pProgress.perEntity[pTask.ei].done++;
			if (tmpSet)
			{
				const tmpStatus = tmpSet.incrementProgressTracker(tmpTrackerHash, 1);
				if (tmpStatus)
				{
					pProgress.etaText = (tmpStatus.EstimatedCompletionTime >= 0) ? this._coarseDuration(tmpSet.progressTimes.formatTimeDuration(tmpStatus.EstimatedCompletionTime)) : null;
					pProgress.elapsedText = (tmpStatus.ElapsedTime >= 0) ? this._coarseDuration(tmpSet.progressTimes.formatTimeDuration(tmpStatus.ElapsedTime)) : null;
				}
			}
			// Update on every completed request — there are only tens of counts, so a per-count repaint of the
			// small progress panel is cheap and gives the user a live, moving indicator.
			if (fOnProgress) { fOnProgress(); }
		});
		if (tmpSet) { tmpSet.endProgressTracker(tmpTrackerHash); }
		pProgress.active = false;
		return pEntities.map((pEntity, pEI) => ({ label: pEntity.label, color: pEntity.color, counts: tmpResults[pEI], total: tmpResults[pEI].reduce((pA, pB) => pA + pB, 0) }));
	}

	/** Centered progress panel: overall bar + a per-record-type row, so a long count shows WHAT it is doing and HOW FAR. */
	_progressHTML(pProgress, pTitle)
	{
		const tmpPct = pProgress.total ? Math.round((100 * pProgress.done) / pProgress.total) : 0;
		const tmpEta = pProgress.etaText
			? ` &middot; ~${this._esc(pProgress.etaText)} left`
			: ((pProgress.done > 0 && pProgress.done < pProgress.total) ? ' &middot; estimating…' : '');
		let tmpHTML = '<div class="ao-progress">';
		tmpHTML += '<div class="ao-progress-spin"><i class="fas fa-circle-notch fa-spin"></i></div>';
		tmpHTML += `<div class="ao-progress-title">${this._esc(pTitle)}</div>`;
		tmpHTML += `<div class="ao-progress-sub">${this._num(pProgress.done)} of ${this._num(pProgress.total)} time-slices counted &middot; ${tmpPct}%${tmpEta}</div>`;
		tmpHTML += `<div class="ao-progress-bar"><div class="ao-progress-fill" style="width:${tmpPct}%"></div></div>`;
		tmpHTML += '<div class="ao-progress-entities">';
		(pProgress.perEntity || []).forEach((pEntity) =>
		{
			const tmpDone = pEntity.done >= pEntity.total;
			const tmpEPct = pEntity.total ? Math.round((100 * pEntity.done) / pEntity.total) : 0;
			tmpHTML += '<div class="ao-progress-entity">'
				+ `<span class="ao-progress-dot" style="background:${pEntity.color}"></span>`
				+ `<span class="ao-progress-elabel">${this._esc(pEntity.label)}</span>`
				+ `<span class="ao-progress-etrack"><span class="ao-progress-efill" style="width:${tmpEPct}%;background:${pEntity.color}"></span></span>`
				+ `<span class="ao-progress-ecount">${tmpDone ? '<i class="fas fa-check"></i>' : `${pEntity.done}/${pEntity.total}`}</span>`
				+ '</div>';
		});
		tmpHTML += '</div></div>';
		return tmpHTML;
	}

	// ---- date bucketizing (UTC, to match stored UTC CreateDate) --------------------------------------

	_iso(pDate) { return pDate.toISOString().slice(0, 19); }

	_utcDay(pDate) { return new Date(Date.UTC(pDate.getUTCFullYear(), pDate.getUTCMonth(), pDate.getUTCDate())); }

	/** Window preset -> {days}; used to compute the start date (end = now). */
	_windowDays(pKey)
	{
		return ({ '7d': 7, '30d': 30, '90d': 90, '12mo': 365 })[pKey] || 90;
	}

	/** Pick a bucket size for a window length when Granularity==='auto'; also the coarsen ladder. */
	_effectiveGranularity(pWindowKey, pGranularity)
	{
		if (pGranularity && pGranularity !== 'auto') { return pGranularity; }
		const tmpDays = this._windowDays(pWindowKey);
		if (tmpDays <= 14) { return 'day'; }
		if (tmpDays <= 120) { return 'week'; }
		return 'month';
	}

	/**
	 * Produce [{ label, s, e }] buckets over the last window, in UTC, capped at ~60 buckets (auto-coarsening
	 * day->week->month) so the count fan-out stays bounded.
	 */
	_buildBuckets(pWindowKey, pGranularity)
	{
		const tmpDays = this._windowDays(pWindowKey);
		let tmpGran = this._effectiveGranularity(pWindowKey, pGranularity);
		const tmpLadder = [ 'day', 'week', 'month' ];
		const tmpNow = new Date();
		const tmpEnd = this._utcDay(tmpNow);
		tmpEnd.setUTCDate(tmpEnd.getUTCDate() + 1); // include today (exclusive upper bound = tomorrow 00:00Z)

		const fBuild = (pGran) =>
		{
			const tmpStart = this._utcDay(new Date(tmpNow.getTime() - (tmpDays * 86400000)));
			const tmpBuckets = [];
			if (pGran === 'month')
			{
				let tmpCursor = new Date(Date.UTC(tmpStart.getUTCFullYear(), tmpStart.getUTCMonth(), 1));
				while (tmpCursor < tmpEnd)
				{
					const tmpNextMonth = new Date(Date.UTC(tmpCursor.getUTCFullYear(), tmpCursor.getUTCMonth() + 1, 1));
					tmpBuckets.push({ label: tmpCursor.toLocaleDateString(undefined, { month: 'short', year: '2-digit', timeZone: 'UTC' }), s: this._iso(tmpCursor), e: this._iso(tmpNextMonth) });
					tmpCursor = tmpNextMonth;
				}
			}
			else
			{
				const tmpStep = (pGran === 'week') ? 7 : 1;
				let tmpCursor = new Date(tmpStart.getTime());
				while (tmpCursor < tmpEnd)
				{
					const tmpNextDate = new Date(tmpCursor.getTime() + (tmpStep * 86400000));
					const tmpLabel = (pGran === 'week')
						? tmpCursor.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric', timeZone: 'UTC' })
						: tmpCursor.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric', timeZone: 'UTC' });
					tmpBuckets.push({ label: tmpLabel, s: this._iso(tmpCursor), e: this._iso(tmpNextDate) });
					tmpCursor = tmpNextDate;
				}
			}
			return tmpBuckets;
		};

		let tmpResult = fBuild(tmpGran);
		// Auto-coarsen if a fine granularity blew past the cap.
		let tmpLadderIndex = tmpLadder.indexOf(tmpGran);
		while (tmpResult.length > 60 && tmpLadderIndex < tmpLadder.length - 1)
		{
			tmpLadderIndex++;
			tmpGran = tmpLadder[tmpLadderIndex];
			tmpResult = fBuild(tmpGran);
		}
		this._activeGranularity = tmpGran;
		return tmpResult;
	}

	// ---- theme-aware chart helpers ------------------------------------------------------------------

	_themeColors()
	{
		let tmpText = '#1f2733';
		let tmpGrid = 'rgba(120,130,145,0.18)';
		try
		{
			const tmpCS = getComputedStyle(document.documentElement);
			tmpText = (tmpCS.getPropertyValue('--theme-color-text-primary') || '').trim() || tmpText;
			const tmpBorder = (tmpCS.getPropertyValue('--theme-color-border-light') || '').trim();
			if (tmpBorder) { tmpGrid = tmpBorder; }
		}
		catch (pError) { /* getComputedStyle unavailable -> defaults */ }
		return { text: tmpText, grid: tmpGrid };
	}

	get palette()
	{
		return { Observation: '#ef4444', Document: '#3b82f6', Comment: '#22c55e', Approval: '#f59e0b', LineItem: '#8b5cf6', Update: '#94a3b8' };
	}

	_stackedBarOptions()
	{
		const tmpTheme = this._themeColors();
		return {
			plugins: { legend: { position: 'bottom', labels: { color: tmpTheme.text, usePointStyle: true, boxWidth: 10 } }, tooltip: { mode: 'index', intersect: false } },
			scales:
			{
				x: { stacked: true, ticks: { color: tmpTheme.text, maxRotation: 0, autoSkip: true }, grid: { color: 'transparent' } },
				y: { stacked: true, beginAtZero: true, ticks: { color: tmpTheme.text, precision: 0 }, grid: { color: tmpTheme.grid } },
			},
		};
	}

	_createChart(pID, pType, pData, pOptions)
	{
		const tmpProvider = this.chartProvider;
		if (tmpProvider && typeof tmpProvider.createChart === 'function') { return tmpProvider.createChart(pID, pType, pData, pOptions); }
		return null;
	}

	_destroyChart(pID)
	{
		const tmpProvider = this.chartProvider;
		if (tmpProvider && typeof tmpProvider.destroyChart === 'function') { tmpProvider.destroyChart(pID); }
	}

	// ---- small formatters ---------------------------------------------------------------------------

	_num(pNum) { return (pNum == null || isNaN(pNum)) ? '0' : Number(pNum).toLocaleString(); }


	_relative(pDateStr)
	{
		if (!pDateStr) { return 'never'; }
		const tmpThen = new Date(pDateStr).getTime();
		if (isNaN(tmpThen)) { return '—'; }
		const tmpDiff = Date.now() - tmpThen;
		const tmpDay = 86400000;
		if (tmpDiff < 0) { return 'just now'; }
		if (tmpDiff < 3600000) { return `${Math.max(1, Math.round(tmpDiff / 60000))} min ago`; }
		if (tmpDiff < tmpDay) { return `${Math.round(tmpDiff / 3600000)} hr ago`; }
		if (tmpDiff < 30 * tmpDay) { return `${Math.round(tmpDiff / tmpDay)} days ago`; }
		if (tmpDiff < 365 * tmpDay) { return `${Math.round(tmpDiff / (30 * tmpDay))} mo ago`; }
		return `${Math.round(tmpDiff / (365 * tmpDay))} yr ago`;
	}

	async _resolveUserNamesAsync(pIDs)
	{
		const tmpMissing = pIDs.filter((pID) => pID && !this._userNameCache[pID]);
		if (!tmpMissing.length) { return; }
		const tmpUnique = Array.from(new Set(tmpMissing)).slice(0, 200);
		try
		{
			const tmpRows = await this._getJSON(`Users/FilteredTo/FBL~IDUser~INN~${tmpUnique.join(',')}/0/${tmpUnique.length}`);
			(Array.isArray(tmpRows) ? tmpRows : []).forEach((pUser) => { this._userNameCache[pUser.IDUser] = libUserSearch.userLabel(pUser); });
		}
		catch (pError) { /* leave ids unresolved -> shown as User #id */ }
	}

	_kpiTile(pLabel, pValue, pAccent)
	{
		return `<div class="ao-kpi"${pAccent ? ` style="border-top-color:${pAccent}"` : ''}><div class="ao-kpi-value">${this._esc(pValue)}</div><div class="ao-kpi-label">${this._esc(pLabel)}</div></div>`;
	}

	_windowBarHTML(pProviderMethod, pState, pWithMetric)
	{
		const fBtn = (pGroup, pVal, pLabel, pCurrent) => `<button type="button" class="ao-seg${(pCurrent === pVal) ? ' is-active' : ''}" onclick="_Pict.providers.ActivityObservability.${pProviderMethod}('${pGroup}','${pVal}')">${pLabel}</button>`;
		let tmpHTML = '<div class="ao-controls">';
		tmpHTML += '<span class="ao-control-label">Window</span><div class="ao-seggroup">'
			+ fBtn('window', '7d', '7d', pState.Window) + fBtn('window', '30d', '30d', pState.Window) + fBtn('window', '90d', '90d', pState.Window) + fBtn('window', '12mo', '12mo', pState.Window) + '</div>';
		tmpHTML += '<span class="ao-control-label">Bucket</span><div class="ao-seggroup">'
			+ fBtn('gran', 'auto', 'Auto', pState.Granularity) + fBtn('gran', 'day', 'Day', pState.Granularity) + fBtn('gran', 'week', 'Week', pState.Granularity) + fBtn('gran', 'month', 'Month', pState.Granularity) + '</div>';
		if (pWithMetric)
		{
			tmpHTML += '<span class="ao-control-label">Metric</span><div class="ao-seggroup">'
				+ fBtn('metric', 'create', 'Created', pState.Metric) + fBtn('metric', 'update', 'Updated', pState.Metric) + '</div>';
		}
		tmpHTML += '</div>';
		return tmpHTML;
	}

	// =================================================================================================
	// VIEW 1 — USER ACTIVITY
	// =================================================================================================

	static get USER_ENTITIES()
	{
		return [
			{ plural: 'Observations', label: 'Observations', color: '#ef4444' },
			{ plural: 'Documents', label: 'Documents', color: '#3b82f6' },
			{ plural: 'Comments', label: 'Comments', color: '#22c55e' },
			{ plural: 'DocumentApprovalLogs', label: 'Approvals', color: '#f59e0b' },
		];
	}

	/** Entry point from the route: load activity for a user (defaults to the signed-in user). */
	async loadUserActivityAsync(pIDUser)
	{
		this._ensureStyles();
		const tmpID = pIDUser ? Number(pIDUser) : this.sessionUserID();
		this.userActivity.IDUser = tmpID;
		// Resolve the user's display record (best-effort).
		if (tmpID)
		{
			try { const tmpRows = await this._getJSON(`Users/FilteredTo/FBV~IDUser~EQ~${tmpID}/0/1`); this.userActivity.User = (Array.isArray(tmpRows) && tmpRows[0]) || null; }
			catch (pError) { this.userActivity.User = null; }
		}
		await this._refreshUserActivityAsync();
	}

	setUserActivityOption(pGroup, pValue)
	{
		const tmpState = this.userActivity;
		if (pGroup === 'window') { tmpState.Window = pValue; }
		else if (pGroup === 'gran') { tmpState.Granularity = pValue; }
		else if (pGroup === 'metric') { tmpState.Metric = pValue; }
		this._refreshUserActivityAsync();
	}

	async _refreshUserActivityAsync()
	{
		const tmpState = this.userActivity;
		if (!tmpState.IDUser) { this.renderUserActivity(); return; }
		const tmpToken = ++tmpState.Token;
		const tmpBuckets = this._buildBuckets(tmpState.Window, tmpState.Granularity);
		const tmpEntities = ActivityObservabilityProvider.USER_ENTITIES;
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Buckets = tmpBuckets;
		// Pre-seed progress so the very first paint already shows the per-record-type checklist.
		tmpState.Progress = { active: true, done: 0, total: tmpEntities.length * tmpBuckets.length,
			perEntity: tmpEntities.map((pEntity) => ({ label: pEntity.label, color: pEntity.color, done: 0, total: tmpBuckets.length })) };
		this.renderUserActivity();
		try
		{
			const tmpDateField = (tmpState.Metric === 'update') ? 'UpdateDate' : 'CreateDate';
			const tmpActorField = (tmpState.Metric === 'update') ? 'UpdatingIDUser' : 'CreatingIDUser';
			const tmpBase = `FBV~${tmpActorField}~EQ~${tmpState.IDUser}`;
			const tmpTitle = `Counting ${libUserSearch.userLabel(tmpState.User) || 'this user'}’s activity…`;
			const fTick = () => { if (tmpToken === tmpState.Token) { this._assign('#AO-UserActivity-Progress', this._progressHTML(tmpState.Progress, tmpTitle)); } };
			const tmpSeries = await this._countAllSeriesAsync(tmpEntities, tmpBase, tmpDateField, tmpBuckets, tmpState.Progress, fTick);
			if (tmpToken !== tmpState.Token) { return; } // superseded
			tmpState.Series = tmpSeries;
			tmpState.Totals = {};
			tmpSeries.forEach((pSeries) => { tmpState.Totals[pSeries.label] = pSeries.total; });
			tmpState.Loading = false;
			this.renderUserActivity();
			this._drawUserActivityChart();
		}
		catch (pError)
		{
			if (tmpToken !== tmpState.Token) { return; }
			tmpState.Loading = false;
			tmpState.Error = `Could not load activity: ${(pError && pError.message) ? pError.message : pError}`;
			this.renderUserActivity();
		}
	}

	renderUserActivity()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#AO-UserActivity-Body').length === 0) { return; }
		this._assign('#AO-UserActivity-Body', this._userActivityHTML());
	}

	_userActivityHTML()
	{
		const tmpState = this.userActivity;
		let tmpHTML = '';
		// user picker header
		tmpHTML += '<div class="ao-pickrow">';
		tmpHTML += `<div class="ao-pick-current"><span class="ao-pick-icon"><i class="fas fa-user"></i></span><span class="ao-pick-name">${this._esc(libUserSearch.userLabel(tmpState.User) || 'Select a user')}</span>`;
		if (tmpState.User && tmpState.User.LoginID) { tmpHTML += `<span class="ao-pick-sub">${this._esc(tmpState.User.LoginID)}</span>`; }
		tmpHTML += `</div><button type="button" class="ao-pick-btn" onclick="_Pict.providers.ActivityObservability.toggleUserPicker()"><i class="fas fa-user-group"></i> Change user</button></div>`;
		if (tmpState.PickerOpen) { tmpHTML += this._userPickerHTML(); }

		tmpHTML += this._windowBarHTML('setUserActivityOption', tmpState, true);

		if (!tmpState.IDUser) { return tmpHTML + '<div class="ao-note">Pick a user to see their activity.</div>'; }
		if (tmpState.Error) { return tmpHTML + `<div class="ao-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Error)}</div>`; }

		// KPI tiles
		tmpHTML += '<div class="ao-kpis">';
		ActivityObservabilityProvider.USER_ENTITIES.forEach((pEntity) =>
		{
			tmpHTML += this._kpiTile(pEntity.label, tmpState.Loading ? '…' : this._num(tmpState.Totals[pEntity.label] || 0), pEntity.color);
		});
		tmpHTML += '</div>';

		if (tmpState.Loading)
		{
			const tmpTitle = `Counting ${libUserSearch.userLabel(tmpState.User) || 'this user'}’s activity…`;
			return tmpHTML + `<div id="AO-UserActivity-Progress">${this._progressHTML(tmpState.Progress, tmpTitle)}</div>`;
		}
		const tmpMetricWord = (tmpState.Metric === 'update') ? 'updated' : 'created';
		tmpHTML += `<div class="ao-chart-head"><span>Records ${tmpMetricWord} per ${this._activeGranularity || 'bucket'}</span></div>`;
		tmpHTML += '<div class="ao-chart-wrap"><canvas id="AO-UserActivity-Chart"></canvas></div>';
		return tmpHTML;
	}

	_userPickerHTML()
	{
		const tmpState = this.userActivity;
		let tmpHTML = '<div class="ao-picker">';
		tmpHTML += `<input class="ao-filter" type="text" autocomplete="off" placeholder="Search users by name, login ID or email…" value="${this._esc(tmpState.PickerSearch)}" oninput="_Pict.providers.ActivityObservability.onUserPickerSearch(this.value)" />`;
		tmpHTML += `<div class="ao-picker-list" id="AO-User-Picker-List">${this._userPickerListHTML()}</div>`;
		tmpHTML += '</div>';
		return tmpHTML;
	}

	/** Inner content of the user-picker results list. Assigned on its own (#AO-User-Picker-List) so the
	 *  sibling search <input> is never re-rendered and keeps focus/caret while typing. */
	_userPickerListHTML()
	{
		const tmpState = this.userActivity;
		let tmpHTML = '';
		if (tmpState.PickerSearching) { tmpHTML += '<div class="ao-note"><i class="fas fa-spinner fa-spin"></i> Searching…</div>'; }
		else if ((tmpState.PickerSearch || '').trim().length < 2) { tmpHTML += '<div class="ao-note">Type at least 2 characters, or pick from recent below.</div>'; }
		else if (!tmpState.PickerResults.length) { tmpHTML += '<div class="ao-note">No users match.</div>'; }
		tmpState.PickerResults.forEach((pUser) =>
		{
			tmpHTML += `<div class="ao-picker-row" onclick="_Pict.providers.ActivityObservability.selectUser(${Number(pUser.IDUser)})"><span>${this._esc(libUserSearch.userLabel(pUser))}</span><span class="ao-picker-sub">${this._esc(pUser.LoginID || pUser.Email || '')}</span></div>`;
		});
		return tmpHTML;
	}

	toggleUserPicker()
	{
		this.userActivity.PickerOpen = !this.userActivity.PickerOpen;
		this.renderUserActivity();
	}

	onUserPickerSearch(pValue)
	{
		this.userActivity.PickerSearch = pValue;
		if (this._pickerTimer) { clearTimeout(this._pickerTimer); }
		this._pickerTimer = setTimeout(() => { this._pickerTimer = null; this._userPickerSearchAsync(); }, 250);
	}

	async _userPickerSearchAsync()
	{
		const tmpState = this.userActivity;
		const tmpTerm = String(tmpState.PickerSearch || '').trim();
		const tmpToken = ++tmpState.Token;
		if (tmpTerm.length < 2)
		{
			tmpState.PickerResults = [];
			tmpState.PickerSearching = false;
			this._assignUserPicker();
			return;
		}
		tmpState.PickerSearching = true;
		this._assignUserPicker();
		let tmpUsers = [];
		try
		{
			tmpUsers = await libUserSearch.searchUsersAsync((pURL) => this._getJSON(pURL), tmpTerm, { Scope: `FBV~IDCustomer~EQ~${this.callerCustomer()}~FBV~Deleted~EQ~0`, PageSize: 40 });
		}
		catch (pError)
		{
			tmpUsers = [];
		}
		if (tmpToken !== tmpState.Token)
		{
			return;
		}
		tmpState.PickerResults = tmpUsers;
		tmpState.PickerSearching = false;
		this._assignUserPicker();
	}

	_assignUserPicker()
	{
		// Repaint ONLY the results list, never the <input> sibling — a full body re-render would destroy
		// the focused search box and drop the caret after each keystroke (mirrors the project picker fix).
		this._assign('#AO-User-Picker-List', this._userPickerListHTML());
	}

	async selectUser(pIDUser)
	{
		this.userActivity.PickerOpen = false;
		this.userActivity.PickerSearch = '';
		this.userActivity.PickerResults = [];
		if (window && window.location) { window.location.hash = `#/UserActivity/${Number(pIDUser)}`; }
		await this.loadUserActivityAsync(pIDUser);
	}

	_drawUserActivityChart()
	{
		const tmpState = this.userActivity;
		if (!tmpState.Series.length) { this._destroyChart('AO-UserActivity-Chart'); return; }
		const tmpData =
		{
			labels: tmpState.Buckets.map((pBucket) => pBucket.label),
			datasets: tmpState.Series.map((pSeries) => ({ label: pSeries.label, data: pSeries.counts, backgroundColor: pSeries.color, borderWidth: 0, borderRadius: 2 })),
		};
		this._createChart('AO-UserActivity-Chart', 'bar', tmpData, this._stackedBarOptions());
	}

	// =================================================================================================
	// VIEW 2 — USER LOGINS
	// =================================================================================================

	async loadLoginsAsync()
	{
		this._ensureStyles();
		const tmpState = this.logins;
		const tmpToken = ++tmpState.Token;
		tmpState.Loading = true;
		tmpState.Error = '';
		this.renderLogins();
		const tmpCustomer = this.callerCustomer();
		const tmpNow = Date.now();
		const tmpISO = (pMsAgo) => new Date(tmpNow - pMsAgo).toISOString().slice(0, 19);
		const tmp7 = tmpISO(7 * 86400000);
		const tmp30 = tmpISO(30 * 86400000);
		const tmpBase = `FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0`;
		try
		{
			const tmpResults = await Promise.all([
				this._getJSON(`Users/FilteredTo/${tmpBase}~FSF~LastLoginTime~DESC~0/0/300`),
				this._countAsync('Users', tmpBase),
				this._countAsync('Users', `${tmpBase}~FBV~LastLoginTime~GE~${tmp7}`),
				this._countAsync('Users', `${tmpBase}~FBV~LastLoginTime~GE~${tmp30}~FBV~LastLoginTime~LT~${tmp7}`),
				this._countAsync('Users', `${tmpBase}~FBV~LastLoginTime~LT~${tmp30}`),
				this._countAsync('Users', `${tmpBase}~FBV~LastLoginTime~IN~`),
			]);
			if (tmpToken !== tmpState.Token) { return; }
			tmpState.Users = Array.isArray(tmpResults[0]) ? tmpResults[0] : [];
			tmpState.Total = tmpResults[1];
			tmpState.Recency = { active: tmpResults[2], idle: tmpResults[3], dormant: tmpResults[4], never: tmpResults[5] };
			tmpState.Loading = false;
			this.renderLogins();
			this._drawLoginDoughnut();
		}
		catch (pError)
		{
			if (tmpToken !== tmpState.Token) { return; }
			tmpState.Loading = false;
			tmpState.Error = `Could not load users: ${(pError && pError.message) ? pError.message : pError}`;
			this.renderLogins();
		}
	}

	_recencyOf(pUser)
	{
		if (!pUser.LastLoginTime) { return { key: 'never', label: 'Never', cls: 'ao-badge-never' }; }
		const tmpDays = (Date.now() - new Date(pUser.LastLoginTime).getTime()) / 86400000;
		if (tmpDays < 7) { return { key: 'active', label: 'Active', cls: 'ao-badge-active' }; }
		if (tmpDays < 30) { return { key: 'idle', label: 'Idle', cls: 'ao-badge-idle' }; }
		return { key: 'dormant', label: 'Dormant', cls: 'ao-badge-dormant' };
	}

	renderLogins()
	{
		if (this.pict.ContentAssignment.getElement('#AO-Logins-Body').length === 0) { return; }
		this._assign('#AO-Logins-Body', this._loginsHTML());
	}

	_loginsHTML()
	{
		const tmpState = this.logins;
		if (tmpState.Loading && !tmpState.Users.length) { return '<div class="ao-note"><i class="fas fa-spinner fa-spin"></i> Loading users…</div>'; }
		if (tmpState.Error) { return `<div class="ao-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Error)}</div>`; }
		const tmpRec = tmpState.Recency;
		let tmpHTML = '';
		tmpHTML += '<div class="ao-kpis">';
		tmpHTML += this._kpiTile('Total users', this._num(tmpState.Total), '#64748b');
		tmpHTML += this._kpiTile('Active (7d)', this._num(tmpRec.active), '#22c55e');
		tmpHTML += this._kpiTile('Dormant (30d+)', this._num(tmpRec.dormant), '#f59e0b');
		tmpHTML += this._kpiTile('Never logged in', this._num(tmpRec.never), '#ef4444');
		tmpHTML += '</div>';

		tmpHTML += '<div class="ao-split">';
		tmpHTML += '<div class="ao-split-chart"><div class="ao-chart-head"><span>Login recency</span></div><div class="ao-chart-wrap ao-chart-sm"><canvas id="AO-Logins-Doughnut"></canvas></div></div>';
		tmpHTML += '<div class="ao-split-table">';
		tmpHTML += `<input id="AO-Logins-Filter" class="ao-filter" type="text" autocomplete="off" placeholder="Filter the ${this._num(tmpState.Users.length)} most-recent by name or login…" oninput="_Pict.providers.ActivityObservability.onLoginFilter(this.value)" />`;
		tmpHTML += `<div id="AO-Logins-List" class="ao-tablewrap">${this._loginRowsHTML()}</div>`;
		if (tmpState.Total > tmpState.Users.length) { tmpHTML += `<div class="ao-note ao-note-sm">Showing the ${this._num(tmpState.Users.length)} most-recently-active of ${this._num(tmpState.Total)} users. The recency tiles &amp; chart above count all users.</div>`; }
		tmpHTML += '</div></div>';
		return tmpHTML;
	}

	_loginRowsHTML()
	{
		const tmpState = this.logins;
		const tmpTerm = String(tmpState.Filter || '').trim().toLowerCase();
		const tmpRows = tmpState.Users.filter((pUser) => !tmpTerm
			|| libUserSearch.userLabel(pUser).toLowerCase().indexOf(tmpTerm) > -1
			|| String(pUser.LoginID || '').toLowerCase().indexOf(tmpTerm) > -1);
		if (!tmpRows.length) { return '<div class="ao-note">No users match your filter.</div>'; }
		let tmpHTML = '<table class="ao-table"><thead><tr><th>User</th><th>Login</th><th>Last login</th><th>Status</th></tr></thead><tbody>';
		tmpRows.forEach((pUser) =>
		{
			const tmpRec = this._recencyOf(pUser);
			tmpHTML += `<tr class="ao-trow" onclick="_Pict.providers.ActivityObservability.openUserActivity(${Number(pUser.IDUser)})">`
				+ `<td>${this._esc(libUserSearch.userLabel(pUser))}</td>`
				+ `<td class="ao-mono">${this._esc(pUser.LoginID || '')}</td>`
				+ `<td>${pUser.LastLoginTime ? this._esc(this._relative(pUser.LastLoginTime)) : '<span class="ao-muted">never</span>'}</td>`
				+ `<td><span class="ao-badge ${tmpRec.cls}">${tmpRec.label}</span></td></tr>`;
		});
		tmpHTML += '</tbody></table>';
		return tmpHTML;
	}

	onLoginFilter(pValue)
	{
		this.logins.Filter = pValue;
		this._assign('#AO-Logins-List', this._loginRowsHTML());
	}

	openUserActivity(pIDUser)
	{
		if (window && window.location) { window.location.hash = `#/UserActivity/${Number(pIDUser)}`; }
	}

	_drawLoginDoughnut()
	{
		const tmpRec = this.logins.Recency;
		const tmpTheme = this._themeColors();
		const tmpData =
		{
			labels: [ 'Active (<7d)', 'Idle (7–30d)', 'Dormant (30d+)', 'Never' ],
			datasets: [ { data: [ tmpRec.active, tmpRec.idle, tmpRec.dormant, tmpRec.never ], backgroundColor: [ '#22c55e', '#3b82f6', '#f59e0b', '#ef4444' ], borderWidth: 0 } ],
		};
		this._createChart('AO-Logins-Doughnut', 'doughnut', tmpData, { cutout: '62%', plugins: { legend: { position: 'bottom', labels: { color: tmpTheme.text, usePointStyle: true, boxWidth: 10 } } } });
	}

	// =================================================================================================
	// VIEW 3 — PROJECT ACTIVITY
	// =================================================================================================

	static get PROJECT_ENTITIES()
	{
		return [
			{ plural: 'Documents', label: 'Documents', color: '#3b82f6' },
			{ plural: 'Observations', label: 'Observations', color: '#ef4444' },
			{ plural: 'LineItems', label: 'Line Items', color: '#8b5cf6' },
		];
	}

	async loadProjectActivityAsync(pIDProject)
	{
		this._ensureStyles();
		const tmpState = this.projectActivity;
		if (pIDProject) { tmpState.IDProject = Number(pIDProject); }
		if (tmpState.IDProject)
		{
			try { const tmpRows = await this._getJSON(`Projects/FilteredTo/FBV~IDProject~EQ~${tmpState.IDProject}/0/1`); tmpState.Project = (Array.isArray(tmpRows) && tmpRows[0]) || null; }
			catch (pError) { tmpState.Project = null; }
		}
		await this._refreshProjectActivityAsync();
	}

	setProjectActivityOption(pGroup, pValue)
	{
		const tmpState = this.projectActivity;
		if (pGroup === 'window') { tmpState.Window = pValue; }
		else if (pGroup === 'gran') { tmpState.Granularity = pValue; }
		else if (pGroup === 'metric') { tmpState.Metric = pValue; }
		this._refreshProjectActivityAsync();
	}

	async _refreshProjectActivityAsync()
	{
		const tmpState = this.projectActivity;
		if (!tmpState.IDProject) { this.renderProjectActivity(); return; }
		const tmpToken = ++tmpState.Token;
		const tmpBuckets = this._buildBuckets(tmpState.Window, tmpState.Granularity);
		const tmpEntities = ActivityObservabilityProvider.PROJECT_ENTITIES;
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Buckets = tmpBuckets;
		tmpState.Progress = { active: true, done: 0, total: tmpEntities.length * tmpBuckets.length,
			perEntity: tmpEntities.map((pEntity) => ({ label: pEntity.label, color: pEntity.color, done: 0, total: tmpBuckets.length })) };
		this.renderProjectActivity();
		try
		{
			const tmpDateField = (tmpState.Metric === 'update') ? 'UpdateDate' : 'CreateDate';
			const tmpBase = `FBV~IDProject~EQ~${tmpState.IDProject}`;
			const tmpTitle = `Counting activity for ${(tmpState.Project && tmpState.Project.Name) || 'this project'}…`;
			const fTick = () => { if (tmpToken === tmpState.Token) { this._assign('#AO-Project-Progress', this._progressHTML(tmpState.Progress, tmpTitle)); } };
			const tmpSeries = await this._countAllSeriesAsync(tmpEntities, tmpBase, tmpDateField, tmpBuckets, tmpState.Progress, fTick);
			if (tmpToken !== tmpState.Token) { return; }
			tmpState.Series = tmpSeries;
			tmpState.Totals = {};
			tmpSeries.forEach((pSeries) => { tmpState.Totals[pSeries.label] = pSeries.total; });
			tmpState.Loading = false;
			this.renderProjectActivity();
			this._drawProjectChart();
			this._loadProjectStreamAsync(tmpToken);
		}
		catch (pError)
		{
			if (tmpToken !== tmpState.Token) { return; }
			tmpState.Loading = false;
			tmpState.Error = `Could not load activity: ${(pError && pError.message) ? pError.message : pError}`;
			this.renderProjectActivity();
		}
	}

	/** Bounded tail read per entity -> a merged, most-recent-first activity stream (live rows only). */
	async _loadProjectStreamAsync(pToken)
	{
		const tmpState = this.projectActivity;
		tmpState.StreamLoading = true;
		this._assign('#AO-Project-Stream', '<div class="ao-note"><i class="fas fa-spinner fa-spin"></i> Loading recent activity…</div>');
		try
		{
			const tmpPer = await Promise.all(ActivityObservabilityProvider.PROJECT_ENTITIES.map(async (pEntity) =>
			{
				const tmpRows = await this._getJSON(`${pEntity.plural}/FilteredTo/FBV~IDProject~EQ~${tmpState.IDProject}~FBV~Deleted~EQ~0~FSF~UpdateDate~DESC~0/0/15`).catch(() => []);
				return (Array.isArray(tmpRows) ? tmpRows : []).map((pRow) => ({
					type: pEntity.label, color: pEntity.color,
					name: pRow.Name || pRow.Description || `#${pRow.IDDocument || pRow.IDObservation || pRow.IDLineItem || ''}`,
					created: pRow.CreateDate, updated: pRow.UpdateDate,
					actor: pRow.UpdatingIDUser || pRow.CreatingIDUser,
					isNew: (pRow.CreateDate === pRow.UpdateDate),
				}));
			}));
			if (pToken !== tmpState.Token) { return; }
			const tmpMerged = [].concat.apply([], tmpPer)
				.sort((pA, pB) => new Date(pB.updated || pB.created).getTime() - new Date(pA.updated || pA.created).getTime())
				.slice(0, 40);
			await this._resolveUserNamesAsync(tmpMerged.map((pItem) => pItem.actor));
			if (pToken !== tmpState.Token) { return; }
			tmpState.Stream = tmpMerged;
			tmpState.StreamLoading = false;
			this._assign('#AO-Project-Stream', this._streamHTML());
		}
		catch (pError)
		{
			if (pToken !== tmpState.Token) { return; }
			tmpState.StreamLoading = false;
			this._assign('#AO-Project-Stream', `<div class="ao-error">${this._esc((pError && pError.message) || pError)}</div>`);
		}
	}

	renderProjectActivity()
	{
		if (this.pict.ContentAssignment.getElement('#AO-Project-Body').length === 0) { return; }
		this._assign('#AO-Project-Body', this._projectActivityHTML());
	}

	_projectActivityHTML()
	{
		const tmpState = this.projectActivity;
		let tmpHTML = '';
		tmpHTML += '<div class="ao-pickrow">';
		tmpHTML += `<div class="ao-pick-current"><span class="ao-pick-icon"><i class="fas fa-folder-open"></i></span><span class="ao-pick-name">${this._esc((tmpState.Project && tmpState.Project.Name) || 'Select a project')}</span></div>`;
		tmpHTML += `<button type="button" class="ao-pick-btn" onclick="_Pict.providers.ActivityObservability.toggleProjectPicker()"><i class="fas fa-folder-tree"></i> Change project</button></div>`;
		if (tmpState.PickerOpen) { tmpHTML += this._projectPickerHTML(); }

		tmpHTML += this._windowBarHTML('setProjectActivityOption', tmpState, true);

		if (!tmpState.IDProject) { return tmpHTML + '<div class="ao-note">Pick a project to see its activity.</div>'; }
		if (tmpState.Error) { return tmpHTML + `<div class="ao-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Error)}</div>`; }

		tmpHTML += '<div class="ao-kpis">';
		ActivityObservabilityProvider.PROJECT_ENTITIES.forEach((pEntity) =>
		{
			tmpHTML += this._kpiTile(pEntity.label, tmpState.Loading ? '…' : this._num(tmpState.Totals[pEntity.label] || 0), pEntity.color);
		});
		tmpHTML += '</div>';

		if (tmpState.Loading)
		{
			const tmpTitle = `Counting activity for ${(tmpState.Project && tmpState.Project.Name) || 'this project'}…`;
			return tmpHTML + `<div id="AO-Project-Progress">${this._progressHTML(tmpState.Progress, tmpTitle)}</div>`;
		}
		const tmpMetricWord = (tmpState.Metric === 'update') ? 'updated' : 'created';
		tmpHTML += `<div class="ao-chart-head"><span>Records ${tmpMetricWord} per ${this._activeGranularity || 'bucket'}</span></div>`;
		tmpHTML += '<div class="ao-chart-wrap"><canvas id="AO-Project-Chart"></canvas></div>';
		tmpHTML += '<div class="ao-chart-head"><span>Recent activity</span></div>';
		tmpHTML += `<div id="AO-Project-Stream">${this._streamHTML()}</div>`;
		return tmpHTML;
	}

	_streamHTML()
	{
		const tmpState = this.projectActivity;
		if (tmpState.StreamLoading) { return '<div class="ao-note"><i class="fas fa-spinner fa-spin"></i> Loading recent activity…</div>'; }
		if (!tmpState.Stream.length) { return '<div class="ao-note">No recent records.</div>'; }
		let tmpHTML = '<ul class="ao-stream">';
		tmpState.Stream.forEach((pItem) =>
		{
			const tmpWhen = pItem.updated || pItem.created;
			const tmpActor = this._userNameCache[pItem.actor] || (pItem.actor ? `User #${pItem.actor}` : 'unknown');
			tmpHTML += `<li class="ao-stream-item"><span class="ao-stream-dot" style="background:${pItem.color}"></span>`
				+ `<span class="ao-stream-type">${this._esc(pItem.type)}</span>`
				+ `<span class="ao-stream-name">${this._esc(pItem.name)}</span>`
				+ `<span class="ao-stream-meta">${pItem.isNew ? 'created' : 'updated'} by ${this._esc(tmpActor)} · ${this._esc(this._relative(tmpWhen))}</span></li>`;
		});
		tmpHTML += '</ul>';
		return tmpHTML;
	}

	toggleProjectPicker()
	{
		const tmpState = this.projectActivity;
		tmpState.PickerOpen = !tmpState.PickerOpen;
		this.renderProjectActivity();
		// Browse-on-open: show the first page of the caller's projects immediately instead of an empty
		// "type to search" box. The server scopes Project reads to what this user can actually reach
		// (member + soft-membership for regular users; the whole customer for admins), name-ordered — so
		// this lists the projects they have access to, and paging (below) reaches all of them, not just 40.
		if (tmpState.PickerOpen) { tmpState.PickerPage = 0; this._projectPickerSearchAsync(false); }
	}

	onProjectPickerSearch(pValue)
	{
		this.projectActivity.PickerSearch = pValue;
		this.projectActivity.PickerPage = 0;
		if (this._pickerTimer) { clearTimeout(this._pickerTimer); }
		this._pickerTimer = setTimeout(() => { this._pickerTimer = null; this._projectPickerSearchAsync(false); }, 250);
	}

	/** Append the next page of picker results (the "Load more projects…" row). */
	loadMoreProjects()
	{
		this.projectActivity.PickerPage = (this.projectActivity.PickerPage || 0) + 1;
		this._projectPickerSearchAsync(true);
	}

	async _projectPickerSearchAsync(pAppend)
	{
		const tmpState = this.projectActivity;
		const tmpTerm = String(tmpState.PickerSearch || '').replace(/~/g, '').trim();
		const tmpToken = ++tmpState.Token;
		const tmpPageSize = 100;
		if (!pAppend) { tmpState.PickerPage = 0; tmpState.PickerResults = []; }
		tmpState.PickerSearching = true;
		// Repaint ONLY the results list, never the <input> sibling: re-rendering the whole body would
		// destroy the focused search box and drop the caret after every keystroke.
		this._assignProjectPickerList();
		// Keep the IDCustomer scope (safe — the server also scopes Project reads to what this user can
		// reach). Fall back to the server scope alone when the session carries no customer id, since a
		// bare `IDCustomer~EQ~` (empty) matches nothing.
		const tmpCustomer = this.callerCustomer();
		let tmpFilter = tmpCustomer ? `FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0` : 'FBV~Deleted~EQ~0';
		if (tmpTerm.length >= 2) { tmpFilter += `~FBV~Name~LK~${encodeURIComponent('%' + tmpTerm.replace(/\*/g, '%') + '%')}`; }
		const tmpStart = (tmpState.PickerPage || 0) * tmpPageSize;
		try
		{
			const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}~FSF~Name~ASC~0/${tmpStart}/${tmpPageSize}`);
			if (tmpToken !== tmpState.Token) { return; }
			const tmpMapped = (Array.isArray(tmpRows) ? tmpRows : []).map((pRow) => ({ IDProject: pRow.ID || pRow.IDProject, Name: pRow.Value || pRow.Name || `Project #${pRow.ID || pRow.IDProject}` }));
			tmpState.PickerResults = pAppend ? tmpState.PickerResults.concat(tmpMapped) : tmpMapped;
			tmpState.PickerHasMore = (Array.isArray(tmpRows) && tmpRows.length >= tmpPageSize);
			tmpState.PickerSearching = false;
			this._assignProjectPickerList();
		}
		catch (pError)
		{
			if (tmpToken !== tmpState.Token) { return; }
			tmpState.PickerSearching = false; if (!pAppend) { tmpState.PickerResults = []; }
			this._assignProjectPickerList();
		}
	}

	_projectPickerHTML()
	{
		const tmpState = this.projectActivity;
		let tmpHTML = '<div class="ao-picker">';
		tmpHTML += `<input class="ao-filter" type="text" autocomplete="off" placeholder="Search projects by name…" value="${this._esc(tmpState.PickerSearch)}" oninput="_Pict.providers.ActivityObservability.onProjectPickerSearch(this.value)" />`;
		tmpHTML += `<div class="ao-picker-list" id="AO-Project-Picker-List">${this._projectPickerListHTML()}</div>`;
		tmpHTML += '</div>';
		return tmpHTML;
	}

	/** Inner content of the picker results list (spinner / empty / rows / load-more). Assigned on its own
	 *  (#AO-Project-Picker-List) so the sibling search <input> is never re-rendered and keeps focus/caret. */
	_projectPickerListHTML()
	{
		const tmpState = this.projectActivity;
		let tmpHTML = '';
		if (tmpState.PickerSearching && !tmpState.PickerResults.length) { tmpHTML += '<div class="ao-note"><i class="fas fa-spinner fa-spin"></i> Searching…</div>'; }
		else if (!tmpState.PickerResults.length) { tmpHTML += '<div class="ao-note">No projects found.</div>'; }
		tmpState.PickerResults.forEach((pProject) =>
		{
			tmpHTML += `<div class="ao-picker-row" onclick="_Pict.providers.ActivityObservability.selectProject(${Number(pProject.IDProject)})"><span>${this._esc(pProject.Name)}</span><span class="ao-picker-sub">#${Number(pProject.IDProject)}</span></div>`;
		});
		if (tmpState.PickerHasMore) { tmpHTML += `<div class="ao-picker-row ao-picker-more" onclick="_Pict.providers.ActivityObservability.loadMoreProjects()"><i class="fas fa-angle-down"></i>&nbsp;Load more projects…</div>`; }
		return tmpHTML;
	}

	_assignProjectPickerList()
	{
		this._assign('#AO-Project-Picker-List', this._projectPickerListHTML());
	}

	async selectProject(pIDProject)
	{
		this.projectActivity.PickerOpen = false;
		this.projectActivity.PickerSearch = '';
		this.projectActivity.PickerResults = [];
		if (window && window.location) { window.location.hash = `#/ProjectActivity/${Number(pIDProject)}`; }
		await this.loadProjectActivityAsync(pIDProject);
	}

	_drawProjectChart()
	{
		const tmpState = this.projectActivity;
		if (!tmpState.Series.length) { this._destroyChart('AO-Project-Chart'); return; }
		const tmpData =
		{
			labels: tmpState.Buckets.map((pBucket) => pBucket.label),
			datasets: tmpState.Series.map((pSeries) => ({ label: pSeries.label, data: pSeries.counts, backgroundColor: pSeries.color, borderWidth: 0, borderRadius: 2 })),
		};
		this._createChart('AO-Project-Chart', 'bar', tmpData, this._stackedBarOptions());
	}
}

ActivityObservabilityProvider.SHARED_CSS = /*css*/`
	.ao-wrap { padding: 1.25rem 1.5rem 2.5rem; }
	.ao-head { margin: 0 0 1rem; }
	.ao-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0; color: var(--theme-color-text-primary,#1f2733); }
	.ao-subtitle { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0.2rem 0 0; max-width: 62rem; }
	.ao-note { padding: 0.9rem; font-size: 0.9rem; color: var(--theme-color-text-muted,#8894a4); }
	.ao-note-sm { padding: 0.5rem 0.2rem; font-size: 0.8rem; }
	.ao-error { padding: 0.9rem; font-size: 0.88rem; color: var(--theme-color-status-danger,#c0392b); }
	.ao-muted { color: var(--theme-color-text-muted,#9aa4b2); font-style: italic; }
	.ao-mono { font-family: ui-monospace,SFMono-Regular,Menlo,monospace; font-size: 0.82rem; color: var(--theme-color-text-muted,#8a94a3); }
	.ao-pickrow { display: flex; align-items: center; justify-content: space-between; gap: 1rem; background: var(--theme-color-background-secondary,#f4f6f9); border: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 10px; padding: 0.7rem 0.95rem; margin: 0 0 0.9rem; }
	.ao-pick-current { display: flex; align-items: baseline; gap: 0.6rem; min-width: 0; }
	.ao-pick-icon { color: var(--theme-color-brand-primary,#156dd1); }
	.ao-pick-name { font-weight: 700; font-size: 1.05rem; color: var(--theme-color-text-primary,#1f2733); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.ao-pick-sub { font-size: 0.82rem; color: var(--theme-color-text-muted,#8a94a3); }
	.ao-pick-btn, .ao-seg { cursor: pointer; font-size: 0.82rem; font-weight: 600; border-radius: 7px; border: 1px solid var(--theme-color-border-medium,#d5dbe3); background: var(--theme-color-background-input,#fff); color: var(--theme-color-text-primary,#1f2733); padding: 0.4rem 0.75rem; }
	.ao-pick-btn:hover { border-color: var(--theme-color-brand-primary,#156dd1); }
	.ao-picker { border: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 10px; padding: 0.7rem; margin: 0 0 0.9rem; background: var(--theme-color-background-primary,#fff); }
	.ao-picker-list { max-height: 16rem; overflow-y: auto; margin-top: 0.5rem; }
	.ao-picker-row { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; padding: 0.45rem 0.6rem; border-radius: 6px; cursor: pointer; font-size: 0.9rem; }
	.ao-picker-row:hover { background: var(--theme-color-background-secondary,#f4f6f9); }
	.ao-picker-sub { color: var(--theme-color-text-muted,#8a94a3); font-size: 0.8rem; }
	.ao-picker-more { justify-content: center; color: var(--theme-color-primary,#2b6cb0); font-size: 0.82rem; border-top: 1px solid var(--theme-color-border-light,#eef1f5); margin-top: 0.25rem; }
	.ao-filter { width: 100%; box-sizing: border-box; font-size: 0.92rem; padding: 0.5rem 0.7rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 8px; background: var(--theme-color-background-input,#fff); color: var(--theme-color-text-primary,#1f2733); }
	.ao-filter:focus { outline: none; border-color: var(--theme-color-brand-primary,#2f6fed); box-shadow: 0 0 0 2px rgba(47,111,237,0.15); }
	.ao-controls { display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem 0.75rem; margin: 0 0 1rem; }
	.ao-control-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted,#8a94a3); }
	.ao-seggroup { display: inline-flex; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 8px; overflow: hidden; }
	.ao-seggroup .ao-seg { border: none; border-right: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 0; background: var(--theme-color-background-input,#fff); }
	.ao-seggroup .ao-seg:last-child { border-right: none; }
	.ao-seg.is-active { background: var(--theme-color-brand-primary,#156dd1); color: #fff; }
	.ao-kpis { display: grid; grid-template-columns: repeat(auto-fit,minmax(9rem,1fr)); gap: 0.75rem; margin: 0 0 1.1rem; }
	.ao-kpi { border: 1px solid var(--theme-color-border-light,#eef1f5); border-top: 3px solid var(--theme-color-brand-primary,#156dd1); border-radius: 10px; padding: 0.8rem 0.9rem; background: var(--theme-color-background-primary,#fff); }
	.ao-kpi-value { font-size: 1.6rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary,#1f2733); }
	.ao-kpi-label { font-size: 0.78rem; color: var(--theme-color-text-muted,#8a94a3); margin-top: 0.2rem; }
	.ao-chart-head { display: flex; align-items: center; justify-content: space-between; font-size: 0.9rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); margin: 0.6rem 0 0.5rem; }
	.ao-spin { font-size: 0.8rem; font-weight: 500; color: var(--theme-color-text-muted,#8a94a3); }
	.ao-chart-wrap { position: relative; height: 20rem; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 10px; padding: 0.75rem; }
	.ao-chart-sm { height: 15rem; }
	.ao-split { display: grid; grid-template-columns: minmax(14rem,20rem) 1fr; gap: 1.1rem; align-items: start; }
	@media (max-width: 820px) { .ao-split { grid-template-columns: 1fr; } }
	.ao-tablewrap { margin-top: 0.6rem; border: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 10px; }
	.ao-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
	.ao-table thead th { position: sticky; top: 0; background: var(--theme-color-background-secondary,#f4f6f9); text-align: left; font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#8a94a3); padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--theme-color-border-light,#eef1f5); }
	.ao-table td { padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--theme-color-border-light,#eef1f5); color: var(--theme-color-text-primary,#1f2733); }
	.ao-trow { cursor: pointer; }
	.ao-trow:hover td { background: var(--theme-color-background-secondary,#f4f6f9); }
	.ao-badge { font-size: 0.68rem; font-weight: 700; padding: 0.1rem 0.5rem; border-radius: 9px; color: #fff; }
	.ao-badge-active { background: #22c55e; }
	.ao-badge-idle { background: #3b82f6; }
	.ao-badge-dormant { background: #f59e0b; }
	.ao-badge-never { background: #94a3b8; }
	.ao-stream { list-style: none; margin: 0.3rem 0 0; padding: 0; border: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 10px; overflow: hidden; }
	.ao-stream-item { display: flex; align-items: center; gap: 0.6rem; padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light,#eef1f5); font-size: 0.9rem; }
	.ao-stream-item:last-child { border-bottom: none; }
	.ao-stream-dot { flex: 0 0 auto; width: 0.55rem; height: 0.55rem; border-radius: 50%; }
	.ao-stream-type { flex: 0 0 6rem; font-weight: 700; font-size: 0.78rem; color: var(--theme-color-text-secondary,#45505f); }
	.ao-stream-name { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary,#1f2733); }
	.ao-stream-meta { flex: 0 0 auto; font-size: 0.78rem; color: var(--theme-color-text-muted,#8a94a3); }
	.ao-progress { display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 0.55rem; min-height: 20rem; padding: 2rem 1rem; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#eef1f5); border-radius: 10px; }
	.ao-progress-spin { font-size: 1.7rem; color: var(--theme-color-brand-primary,#156dd1); }
	.ao-progress-title { font-size: 1.05rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); max-width: 34rem; }
	.ao-progress-sub { font-size: 0.85rem; color: var(--theme-color-text-muted,#8a94a3); font-variant-numeric: tabular-nums; }
	.ao-progress-bar { width: min(28rem,90%); height: 0.5rem; background: var(--theme-color-background-tertiary,#eef1f6); border-radius: 99px; overflow: hidden; margin-top: 0.15rem; }
	.ao-progress-fill { height: 100%; background: var(--theme-color-brand-primary,#156dd1); border-radius: 99px; transition: width 0.15s linear; }
	.ao-progress-entities { width: min(28rem,90%); margin-top: 0.6rem; display: flex; flex-direction: column; gap: 0.45rem; }
	.ao-progress-entity { display: flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; }
	.ao-progress-dot { flex: 0 0 auto; width: 0.55rem; height: 0.55rem; border-radius: 50%; }
	.ao-progress-elabel { flex: 0 0 7rem; text-align: left; color: var(--theme-color-text-secondary,#45505f); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.ao-progress-etrack { flex: 1 1 auto; height: 0.35rem; background: var(--theme-color-background-tertiary,#eef1f6); border-radius: 99px; overflow: hidden; }
	.ao-progress-efill { display: block; height: 100%; border-radius: 99px; transition: width 0.15s linear; }
	.ao-progress-ecount { flex: 0 0 2.6rem; text-align: right; color: var(--theme-color-text-muted,#8a94a3); font-variant-numeric: tabular-nums; }
	.ao-progress-ecount .fa-check { color: var(--theme-color-status-success,#22c55e); }
`;

ActivityObservabilityProvider.default_configuration = { ProviderIdentifier: 'ActivityObservability' };

module.exports = ActivityObservabilityProvider;
module.exports.default_configuration = ActivityObservabilityProvider.default_configuration;

},{"../access/User-Search.js":1064,"pict-provider":845}],1302:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');

const libModel = require('../approval-workflow/ApprovalWorkflow-Model.js');

/**
 * Bindings families. Approval workflows are a SHARED pool (one 'ApprovalWorkflow' Configuration namespace);
 * documents and observations differ ONLY in the bindings layer — a distinct Configuration NamespaceValue on
 * 'ApprovalWorkflowBindings', a different target entity to bind, and how each target row yields its key/label.
 *   - Document:    targets = ReportNamedInstance (key = .Hash, label = .Name).
 *   - Observation: targets = ObservationManifest (key = .Name — matches Observation.ObservationType — label
 *                  = .DisplayName || .Name; there is no .Hash column).
 * NOTE: the approvals microservice currently only ENFORCES 'Document' (it early-returns null for other entity
 * types and `WorkflowsEnabledForType` lists only Document), so observation bindings written here are inert
 * until the server drops those guards. The storage + editor are already generic.
 */
// Project-scope binding-dropdown sentinels (distinct from any real workflow hash): "use the customer default"
// and "no workflow (opt out of the default)". The provider maps these to the effective-map edits the config
// service expects on save (see setBinding).
const BINDING_INHERIT = '__INHERIT__';
const BINDING_NONE = '__NONE__';

const BINDING_FAMILIES =
{
	Document:
	{
		EntityType: 'Document',
		Title: 'Document Bindings',
		TargetNoun: 'document type',
		TargetNounPlural: 'document types',
		ServerPending: false,
		targetsURL: (pIDCustomer) => `ReportNamedInstances/By/IDCustomer/${pIDCustomer}/0/2000`,
		targetKey: (pRow) => pRow && pRow.Hash,
		targetLabel: (pRow) => (pRow && (pRow.Name || pRow.Hash)) || '',
	},
	Observation:
	{
		EntityType: 'Observation',
		Title: 'Observation Bindings',
		TargetNoun: 'observation type',
		TargetNounPlural: 'observation types',
		ServerPending: true,
		// SECURITY: scope to this customer (+ global IDCustomer 0). ObservationManifest carries a per-customer
		// IDCustomer, and its server-side Read authz is `Allow` (NOT MyCustomer-scoped), so a bare `ObservationManifests`
		// fetch returns every tenant's observation-type config to anyone who opens this route. Mirror the Document
		// family's per-customer scoping + cap. (Defense-in-depth: the schema Read authz should also move to MyCustomer.)
		targetsURL: (pIDCustomer) => `ObservationManifests/FilteredTo/FBL~IDCustomer~INN~0,${pIDCustomer}~FBV~Deleted~EQ~0/0/2000`,
		targetKey: (pRow) => pRow && pRow.Name,
		targetLabel: (pRow) => (pRow && (pRow.DisplayName || pRow.Name)) || '',
	},
};

/**
 * ApprovalWorkflowProvider — the data layer behind the config-app approval-workflow editor.
 *
 * The editor edits the Configuration BLOB (NamespaceKey 'ApprovalWorkflow'), NOT the DB-table approval
 * engine. Because storage is the shared Config blob, this config-app editor is a drop-in for Home's — same
 * read/write endpoints, same blob shape, same generated sentences.
 *
 * Responsibilities:
 *   - List every workflow for the customer (Configuration/For/ApprovalWorkflow/In/Customer/:id → { hash: blob }).
 *   - Load one workflow and pre-resolve the role/user display names its sentences need.
 *   - Save one workflow (Configuration/Put/ApprovalWorkflow/:hash/Customer/:id), unchanged apart from the user's edits.
 *   - Gate create/edit/save to a customer admin (super-user OR a UserRole with PermissionLevel 'CustomerAdmin').
 *
 * State lives in pict.AppData.ApprovalWorkflowEditor; the views derive a clean render-state from it.
 */
class ApprovalWorkflowProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	// --- Session context + write-permission (mirrors ConfigViewer / the server's gate) ---

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	get hasCustomerAdmin()
	{
		// A customer super-admin ('CustomerAdmin' or 'SuperAdminUser' — the latter is how the Access workspace
		// recognises a customer-level admin) may edit. UI gate only; the Configuration/Put server gate is
		// authoritative, so being slightly permissive here just means a rejected save surfaces as an error.
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin' || pRole.PermissionLevel === 'SuperAdminUser'));
	}

	/** Can the current user create / edit / save workflows? UI gate only — the server is authoritative. */
	get canEdit()
	{
		return this.isSuperUser || this.hasCustomerAdmin;
	}

	/** The shared editor state slice (lazily created). */
	get state()
	{
		if (!this.pict.AppData.ApprovalWorkflowEditor)
		{
			this.pict.AppData.ApprovalWorkflowEditor =
			{
				// List page.
				List: [], ListLoading: false, ListError: '',
				// Editor page.
				Editor:
				{
					Hash: '', Workflow: null, Names: { RoleNameByLevel: {}, UserNameByID: {} },
					Findings: [], DocumentCounts: null, Loading: false, Error: '', Editable: false, IsNew: false,
				},
			};
		}
		return this.pict.AppData.ApprovalWorkflowEditor;
	}

	// --- REST helpers ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/**
	 * Configuration/Get returns EITHER { Config, LevelControlRecords } OR the raw config object depending on
	 * the namespace (mirrors ConfigViewer / PermissionMatrix). Normalize to the config object.
	 * @return {Object}
	 */
	_unwrapConfig(pResult)
	{
		if (pResult && pResult.Config !== undefined)
		{
			return pResult.Config || {};
		}
		return pResult || {};
	}

	// --- List ---

	/**
	 * Load every ApprovalWorkflow the customer has, as a list of { Hash, StateCount, TransitionCount }.
	 */
	async loadListAsync()
	{
		const tmpState = this.state;
		tmpState.ListLoading = true;
		tmpState.ListError = '';
		tmpState.List = [];
		tmpState.ProjectOnlyList = [];
		this._repaintList();
		try
		{
			const tmpMap = await this._getJSON(`Configuration/For/ApprovalWorkflow/In/Customer/${this.idCustomer}`) || {};
			const tmpList = Object.keys(tmpMap).map((pHash) =>
			{
				const tmpBlob = tmpMap[pHash] || {};
				const tmpStates = Array.isArray(tmpBlob.States) ? tmpBlob.States : [];
				let tmpTransitionCount = 0;
				tmpStates.forEach((pState) => { tmpTransitionCount += (Array.isArray(pState.Transitions) ? pState.Transitions.length : 0); });
				return { Hash: pHash, StateCount: tmpStates.length, TransitionCount: tmpTransitionCount };
			});
			tmpList.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)));
			tmpState.List = tmpList;
			const tmpLevels = await this._readWorkflowLevelsAsync();
			if (tmpLevels)
			{
				tmpList.forEach((pRow) => { pRow.LevelText = this._listLevelText(tmpLevels.filter((pLevel) => pLevel.NamespaceValue === pRow.Hash)); });
				const tmpListed = new Set(tmpList.map((pRow) => pRow.Hash));
				tmpState.ProjectOnlyList = tmpLevels.filter((pLevel) => (pLevel.LevelContext === 'Project') && !pLevel.Hidden && !tmpListed.has(pLevel.NamespaceValue))
					.map((pLevel) => ({ Hash: pLevel.NamespaceValue, IDProject: pLevel.LevelContextID, ProjectName: pLevel.ProjectName }))
					.sort((pA, pB) => String(pA.Hash).localeCompare(String(pB.Hash)) || (pA.IDProject - pB.IDProject));
			}
		}
		catch (pError)
		{
			tmpState.ListError = `Could not load approval workflows: ${pError && pError.message ? pError.message : pError}`;
			this.pict.log.warn(`ApprovalWorkflow list load failed`, { error: String(pError) });
		}
		tmpState.ListLoading = false;
		this._repaintList();
	}

	/**
	 * Where each of the customer's workflows is set. Best-effort: where it can't be read, nothing is labelled.
	 * @return {Promise<Array<Object>|null>}
	 */
	async _readWorkflowLevelsAsync(pHash)
	{
		try
		{
			const tmpName = pHash ? `/${encodeURIComponent(pHash)}` : '';
			const tmpResult = await this._getJSON(`Configuration/Levels/ApprovalWorkflow${tmpName}/In/Customer/${this.idCustomer}`);
			return (tmpResult && Array.isArray(tmpResult.Levels)) ? tmpResult.Levels : null;
		}
		catch (pError)
		{
			this.pict.log.warn(`ApprovalWorkflow levels read failed`, { error: String(pError) });
			return null;
		}
	}

	/**
	 * @param {Array<Object>} pLevels - Where one workflow is set.
	 * @return {String} What the list should say about that.
	 */
	_listLevelText(pLevels)
	{
		const tmpParts = [];
		const tmpCustomer = pLevels.some((pLevel) => (pLevel.LevelContext === 'Customer') && !pLevel.Hidden);
		if (pLevels.some((pLevel) => pLevel.LevelContext === 'Global'))
		{
			tmpParts.push(tmpCustomer ? 'Customized from the global default' : 'Global default');
		}
		const tmpProjects = pLevels.filter((pLevel) => (pLevel.LevelContext === 'Project') && !pLevel.Hidden).length;
		if (tmpProjects)
		{
			tmpParts.push(`${tmpProjects} project cop${(tmpProjects === 1) ? 'y' : 'ies'}`);
		}
		return tmpParts.join(' · ');
	}

	_repaintList()
	{
		const tmpView = this.pict.views.ApprovalWorkflowList;
		if (tmpView && tmpView.pict)
		{
			tmpView.render();
		}
	}

	// --- Editor load ---

	/**
	 * Load a single workflow blob and resolve the display names its sentences need.
	 * @param {String} pHash  the workflow's Configuration NamespaceValue (a document-type hash, or 'Default')
	 * @param {Number} [pIDProject]  open the copy on this project rather than the customer's
	 */
	async loadWorkflowAsync(pHash, pIDProject)
	{
		const tmpEditor = this.state.Editor;
		const tmpLoadToken = this._beginEditorLoad();
		tmpEditor.Hash = pHash;
		tmpEditor.IsNew = false;
		tmpEditor.IDProject = pIDProject || 0;
		this._repaintEditor();
		try
		{
			const tmpBlob = await this._readWorkflowBlobAsync(pHash);
			if (tmpLoadToken !== this._editorLoadToken)
			{
				return;
			}
			if (!Array.isArray(tmpBlob.States) || !tmpBlob.States.length)
			{
				throw new Error('no workflow is stored under that name for this customer');
			}
			await this._applyWorkflowBlob(tmpBlob);
			if (tmpLoadToken !== this._editorLoadToken)
			{
				return;
			}
			tmpEditor.Editable = this.canEdit;
			this._loadLevelInfoAsync(tmpLoadToken);
		}
		catch (pError)
		{
			if (tmpLoadToken !== this._editorLoadToken)
			{
				return;
			}
			tmpEditor.Workflow = null;
			tmpEditor.Pristine = null;
			tmpEditor.Error = `Could not load workflow "${pHash}", so editing is disabled: ${pError && pError.message ? pError.message : pError}`;
			this.pict.log.warn(`ApprovalWorkflow load failed`, { hash: pHash, error: String(pError) });
		}
		tmpEditor.Loading = false;
		this._repaintEditor();
	}

	/**
	 * Reset the editor for a new load. The token makes a slower earlier load give way, so its blob can't land under a
	 * later workflow's hash, where the next save would overwrite that workflow with it.
	 * @return {Number} this load's token
	 */
	_beginEditorLoad()
	{
		const tmpEditor = this.state.Editor;
		this._editorLoadToken = (this._editorLoadToken || 0) + 1;
		tmpEditor.Loading = true;
		tmpEditor.Error = '';
		tmpEditor.Workflow = null;
		tmpEditor.Pristine = null;
		tmpEditor.Findings = [];
		tmpEditor.DocumentCounts = null;
		tmpEditor.LevelInfo = null;
		tmpEditor.Dirty = false;
		tmpEditor.Editable = false;
		const tmpView = this.pict.views && this.pict.views.ApprovalWorkflowEditor;
		if (tmpView && (typeof tmpView.onWorkflowLoadStarted === 'function'))
		{
			tmpView.onWorkflowLoadStarted();
		}
		return this._editorLoadToken;
	}

	/**
	 * @param {String} pHash
	 * @param {Number} [pIDProject] - Read through this project; defaults to the one being edited.
	 * @return {Promise<Object>} the workflow's blob at that level; {} when none is stored. Rejects if the read fails.
	 */
	async _readWorkflowBlobAsync(pHash, pIDProject)
	{
		const tmpIDProject = (pIDProject === undefined) ? this.state.Editor.IDProject : pIDProject;
		return this._unwrapConfig(await this._postJSON('Configuration/Get',
			{ LevelContext: tmpIDProject ? 'Project' : 'Customer', LevelContextID: tmpIDProject || this.idCustomer, NamespaceKey: 'ApprovalWorkflow', NamespaceValue: pHash }));
	}

	/** The Configuration/Put path for the level being edited. */
	_workflowPutPath(pHash)
	{
		const tmpIDProject = this.state.Editor.IDProject;
		return `Configuration/Put/ApprovalWorkflow/${encodeURIComponent(pHash)}/${tmpIDProject ? `Project/${tmpIDProject}` : `Customer/${this.idCustomer}`}`;
	}

	/**
	 * Work out where the open workflow is set, for the banner. Best-effort: nothing changes if it can't be read.
	 * @param {Number} pLoadToken
	 */
	async _loadLevelInfoAsync(pLoadToken)
	{
		const tmpEditor = this.state.Editor;
		const tmpLevels = await this._readWorkflowLevelsAsync(tmpEditor.Hash);
		if (!tmpLevels || (pLoadToken !== this._editorLoadToken))
		{
			return;
		}
		const tmpVisible = tmpLevels.filter((pLevel) => !pLevel.Hidden);
		const tmpThisProject = tmpVisible.find((pLevel) => (pLevel.LevelContext === 'Project') && (pLevel.LevelContextID === tmpEditor.IDProject));
		tmpEditor.LevelInfo =
		{
			OnGlobal: tmpVisible.some((pLevel) => pLevel.LevelContext === 'Global'),
			OnCustomer: tmpVisible.some((pLevel) => pLevel.LevelContext === 'Customer'),
			Projects: tmpVisible.filter((pLevel) => pLevel.LevelContext === 'Project').map((pLevel) => ({ IDProject: pLevel.LevelContextID, ProjectName: pLevel.ProjectName })),
			ProjectName: tmpThisProject ? tmpThisProject.ProjectName : '',
			OnThisProject: !!tmpThisProject,
		};
		const tmpView = this.pict.views && this.pict.views.ApprovalWorkflowEditor;
		if (tmpView && (typeof tmpView.onLevelInfoLoaded === 'function'))
		{
			tmpView.onLevelInfoLoaded();
		}
	}

	/**
	 * Stop overriding what's inherited: the customer's copy of a global workflow, or a project's copy of anything.
	 * Writing the parent's exact value makes the config service remove this level's row, and writing nothing when there's
	 * no parent removes the row too (api/config Configuration-Put-ByNamespace.js _flattenConfig).
	 * @return {Promise<void>}
	 */
	async revertToInheritedAsync()
	{
		if (!this.canEdit)
		{
			throw new Error('You do not have permission to edit approval workflows.');
		}
		const tmpEditor = this.state.Editor;
		const tmpParent = tmpEditor.IDProject
			? await this._readWorkflowBlobAsync(tmpEditor.Hash, 0)
			: this._unwrapConfig(await this._postJSON('Configuration/Get', { LevelContext: 'Global', NamespaceKey: 'ApprovalWorkflow', NamespaceValue: tmpEditor.Hash }));
		await this._postJSON(this._workflowPutPath(tmpEditor.Hash), { Config: tmpParent });
		tmpEditor.Dirty = false;
	}

	/**
	 * Delete the customer's workflow. Refused while anything still uses it, or while that can't be confirmed, because a
	 * binding left pointing at it stops its documents having a workflow.
	 * @return {Promise<{ Blockers: Array<String>, Deleted: Boolean }>}
	 */
	async deleteWorkflowAsync()
	{
		if (!this.canEdit)
		{
			throw new Error('You do not have permission to edit approval workflows.');
		}
		const tmpEditor = this.state.Editor;
		const tmpBlockers = await this.workflowDeleteBlockersAsync(tmpEditor.Hash);
		if (tmpBlockers.length)
		{
			return { Blockers: tmpBlockers, Deleted: false };
		}
		await this._postJSON(this._workflowPutPath(tmpEditor.Hash), { Config: {} });
		tmpEditor.Dirty = false;
		return { Blockers: [], Deleted: true };
	}

	/**
	 * Everything that stops a workflow being deleted.
	 * @param {String} pHash
	 * @return {Promise<Array<String>>}
	 */
	async workflowDeleteBlockersAsync(pHash)
	{
		const tmpLevels = await this._readWorkflowLevelsAsync(pHash);
		if (!tmpLevels)
		{
			return [ 'Couldn\'t check where this workflow is used.' ];
		}
		const tmpBlockers = [];
		if (tmpLevels.some((pLevel) => pLevel.LevelContext === 'Global'))
		{
			tmpBlockers.push('It comes from the global default. Use revert instead.');
		}
		tmpLevels.filter((pLevel) => (pLevel.LevelContext === 'Project') && !pLevel.Hidden).forEach((pLevel) =>
		{
			tmpBlockers.push(`${pLevel.ProjectName} has its own copy.`);
		});
		try
		{
			const fBoundTypes = (pBindings) =>
			{
				const tmpMap = (pBindings && pBindings.Document) || {};
				return Object.keys(tmpMap).filter((pType) => tmpMap[pType] === pHash);
			};
			fBoundTypes(await this._getJSON(`Configuration/For/ApprovalWorkflowBindings/In/Customer/${this.idCustomer}`)).forEach((pType) =>
			{
				tmpBlockers.push(`${pType} is bound to it.`);
			});
			const tmpBindingLevels = await this._getJSON(`Configuration/Levels/ApprovalWorkflowBindings/Document/In/Customer/${this.idCustomer}`);
			const tmpProjects = ((tmpBindingLevels && tmpBindingLevels.Levels) || []).filter((pLevel) => pLevel.LevelContext === 'Project');
			const tmpQueue = tmpProjects.slice();
			const fWorker = async () =>
			{
				while (tmpQueue.length)
				{
					const tmpProject = tmpQueue.shift();
					const tmpBound = fBoundTypes(await this._getJSON(`Configuration/For/ApprovalWorkflowBindings/In/Project/${tmpProject.LevelContextID}`));
					tmpBound.forEach((pType) =>
					{
						const tmpLine = `${pType} is bound to it on ${tmpProject.ProjectName}.`;
						if (!tmpBlockers.includes(tmpLine) && !tmpBlockers.includes(`${pType} is bound to it.`))
						{
							tmpBlockers.push(tmpLine);
						}
					});
				}
			};
			await Promise.all([ fWorker(), fWorker(), fWorker(), fWorker() ]);
		}
		catch (pError)
		{
			return [ `Couldn't check what's bound to this workflow: ${pError && pError.message ? pError.message : pError}` ];
		}
		return tmpBlockers;
	}

	/**
	 * Seed a brand-new workflow in the editor (unsaved). Its hash is chosen when it is first saved.
	 */
	async newWorkflowAsync()
	{
		const tmpEditor = this.state.Editor;
		this._beginEditorLoad();
		tmpEditor.Hash = '';
		tmpEditor.IDProject = 0;
		tmpEditor.IsNew = true;
		this._repaintEditor();
		await this._applyWorkflowBlob(libModel.NEW_DEFAULT_WORKFLOW_CONFIG);
		tmpEditor.Editable = this.canEdit;
		tmpEditor.Loading = false;
		this._repaintEditor();
	}

	/**
	 * Normalize a blob into the working model, resolve its actor names, and stash it all in the editor state.
	 * @param {Object} pBlob
	 */
	async _applyWorkflowBlob(pBlob)
	{
		const tmpEditor = this.state.Editor;
		const tmpWorkflow = libModel.normalizeLoadedBlob(pBlob);
		tmpEditor.Workflow = tmpWorkflow;
		// Snapshot the just-loaded state so Discard can revert locally (no network round-trip, works even
		// when the last save is the baseline). Refreshed on every successful save.
		tmpEditor.Pristine = JSON.parse(JSON.stringify(tmpWorkflow));
		tmpEditor.Names = await this._resolveActorNamesAsync(tmpWorkflow);
		this._refreshFindings();
	}

	/**
	 * Resolve every role PermissionLevel → Role Name and every referenced IDUser → "First Last" in one pass,
	 * so the (synchronous) transition-node bodies can render their sentences. Best-effort: an unresolved
	 * reference just renders as its raw hash fragment.
	 * @param {Object} pWorkflow
	 * @return {Promise<{ RoleNameByLevel: Object, UserNameByID: Object }>}
	 */
	async _resolveActorNamesAsync(pWorkflow)
	{
		const tmpNames = { RoleNameByLevel: {}, UserNameByID: {}, KnownRoleCodes: null, Users: null };
		const tmpRefs = libModel.collectActorReferences(pWorkflow);
		if (tmpRefs.RoleLevels.length)
		{
			try
			{
				const tmpRoles = await this._getJSON(
					`Roles/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}~FBL~PermissionLevel~INN~${tmpRefs.RoleLevels.join(',')}`);
				(Array.isArray(tmpRoles) ? tmpRoles : []).forEach((pRole) =>
				{
					if (pRole && pRole.PermissionLevel != null)
					{
						tmpNames.RoleNameByLevel[String(pRole.PermissionLevel)] = pRole.Name;
					}
				});
				tmpNames.KnownRoleCodes = new Set(Object.keys(tmpNames.RoleNameByLevel));
			}
			catch (pError)
			{
				this.pict.log.warn(`ApprovalWorkflow role-name resolution failed`, { error: String(pError) });
			}
		}
		if (tmpRefs.UserIDs.length)
		{
			try
			{
				const tmpUsers = await this._getJSON(`Users/FilteredTo/FBL~IDUser~INN~${tmpRefs.UserIDs.join(',')}`);
				(Array.isArray(tmpUsers) ? tmpUsers : []).forEach((pUser) =>
				{
					if (pUser && pUser.IDUser != null)
					{
						tmpNames.UserNameByID[String(pUser.IDUser)] = libUserSearch.userLabel(pUser);
						tmpNames.Users = tmpNames.Users || {};
						tmpNames.Users[String(pUser.IDUser)] = { Disabled: pUser.Disabled, IDCustomer: pUser.IDCustomer };
					}
				});
				tmpNames.Users = tmpNames.Users || {};
			}
			catch (pError)
			{
				this.pict.log.warn(`ApprovalWorkflow user-name resolution failed`, { error: String(pError) });
			}
		}
		return tmpNames;
	}

	/**
	 * Bring what's derived from the working model up to date after an edit: names for anything newly referenced, and
	 * the findings.
	 */
	async _afterEditAsync()
	{
		const tmpEditor = this.state.Editor;
		if (!tmpEditor.Workflow)
		{
			return;
		}
		tmpEditor.Names = await this._resolveActorNamesAsync(tmpEditor.Workflow);
		this._refreshFindings();
	}

	/** Re-check the working model. A role or user list that couldn't be read skips its rule rather than reporting everyone. */
	_refreshFindings()
	{
		const tmpEditor = this.state.Editor;
		const tmpNames = tmpEditor.Names || {};
		tmpEditor.Findings = libModel.checkWorkflow(tmpEditor.Workflow,
			{
				KnownRoleCodes: tmpNames.KnownRoleCodes || undefined,
				Users: tmpNames.Users || undefined,
				IDCustomer: this.idCustomer,
				Baseline: tmpEditor.IsNew ? undefined : tmpEditor.Pristine,
			});
	}

	/** What Save would change, by state and action name. */
	pendingChanges()
	{
		const tmpEditor = this.state.Editor;
		return libModel.workflowChanges(tmpEditor.Pristine || {}, tmpEditor.Workflow || {});
	}

	/**
	 * Replace the working model with edited JSON. Refused, leaving the model alone, if it doesn't parse or can't be saved.
	 * @param {String} pText
	 * @return {Promise<{ Error?: String, Changed?: Boolean }>}
	 */
	async applyWorkflowJSONAsync(pText)
	{
		let tmpParsed;
		try
		{
			tmpParsed = JSON.parse(pText);
		}
		catch (pError)
		{
			return { Error: `That isn't valid JSON: ${pError.message}` };
		}
		if (!tmpParsed || (typeof tmpParsed !== 'object') || Array.isArray(tmpParsed))
		{
			return { Error: 'A workflow must be a JSON object with a States list.' };
		}
		const tmpProblems = libModel.findSaveProblems(tmpParsed);
		if (tmpProblems.length)
		{
			return { Error: tmpProblems.join(' ') };
		}
		if (libModel.workflowsEqual(tmpParsed, this.workflow))
		{
			return { Changed: false };
		}
		this.state.Editor.Workflow = libModel.normalizeLoadedBlob(tmpParsed);
		this._markDirty();
		await this._afterEditAsync();
		return { Changed: true };
	}

	/**
	 * Count documents per state, for warning before a rename or delete strands them. On a project's copy this covers that
	 * project. On a customer's workflow it covers document types bound at customer level, so a project-level binding makes
	 * the true number higher. Best-effort: a failed count is left out and blocks nothing.
	 */
	async loadDocumentCountsAsync()
	{
		const tmpEditor = this.state.Editor;
		const tmpToken = this._editorLoadToken;
		if (tmpEditor.DocumentCounts || tmpEditor.IsNew || !tmpEditor.Workflow)
		{
			return;
		}
		tmpEditor.DocumentCounts = {};
		let tmpTypes = [];
		try
		{
			const tmpScope = tmpEditor.IDProject ? `Project/${tmpEditor.IDProject}` : `Customer/${this.idCustomer}`;
			const tmpBindings = await this._getJSON(`Configuration/For/ApprovalWorkflowBindings/In/${tmpScope}`);
			const tmpMap = (tmpBindings && tmpBindings.Document) || {};
			tmpTypes = Object.keys(tmpMap).filter((pType) => (pType !== 'Default') && (tmpMap[pType] === tmpEditor.Hash));
		}
		catch (pError)
		{
			this.pict.log.warn(`ApprovalWorkflow document count: bindings read failed`, { error: String(pError) });
			return;
		}
		if (!tmpTypes.length)
		{
			return;
		}
		const tmpTypeFilter = tmpTypes.map(encodeURIComponent).join(',');
		const tmpScopeFilter = tmpEditor.IDProject ? `FBV~IDProject~EQ~${tmpEditor.IDProject}` : `FBV~IDCustomer~EQ~${this.idCustomer}`;
		const tmpQueue = (tmpEditor.Workflow.States || []).map((pState) => pState.Status);
		const fWorker = async () =>
		{
			while (tmpQueue.length && (tmpToken === this._editorLoadToken))
			{
				const tmpStatus = tmpQueue.shift();
				try
				{
					const tmpResult = await this._getJSON(`Documents/Count/FilteredTo/FBL~DocumentType~INN~${tmpTypeFilter}~${tmpScopeFilter}~FBV~Status~EQ~${encodeURIComponent(tmpStatus)}`);
					if ((tmpToken === this._editorLoadToken) && tmpResult && (typeof tmpResult.Count === 'number'))
					{
						tmpEditor.DocumentCounts[tmpStatus] = tmpResult.Count;
					}
				}
				catch (pError)
				{
					this.pict.log.warn(`ApprovalWorkflow document count failed`, { status: tmpStatus, error: String(pError) });
				}
			}
		};
		await Promise.all([ fWorker(), fWorker(), fWorker(), fWorker() ]);
	}

	/**
	 * @param {String} pStatus
	 * @return {Number} Documents known to be in that state; 0 when none are known.
	 */
	documentCountFor(pStatus)
	{
		const tmpCounts = this.state.Editor.DocumentCounts;
		return (tmpCounts && tmpCounts[pStatus]) || 0;
	}

	/**
	 * Whether a panel's values differ from the transition they edit.
	 * @param {String} pSourceStatus
	 * @param {Number} pTransitionIndex
	 * @param {Object} pPatch
	 * @return {Boolean}
	 */
	transitionPatchChanges(pSourceStatus, pTransitionIndex, pPatch)
	{
		const tmpFound = this._findState(pSourceStatus);
		const tmpTransition = tmpFound && (tmpFound.State.Transitions || [])[pTransitionIndex];
		return !!tmpTransition && libModel.applyTransitionPatch(JSON.parse(JSON.stringify(tmpTransition)), pPatch);
	}

	/**
	 * Whether a panel's values differ from the state they edit.
	 * @param {String} pStatus
	 * @param {{ StateName: String, Status: String }} pPatch
	 * @return {Boolean}
	 */
	statePatchChanges(pStatus, pPatch)
	{
		const tmpFound = this._findState(pStatus);
		return !!tmpFound && ((String(pPatch.Status || '').trim() !== pStatus) || ((tmpFound.State.StateName || '') !== pPatch.StateName));
	}

	// --- Save (P2 uses this; wired now so the data layer is complete) ---

	/**
	 * Persist a working model to the given hash (Customer scope). Refuses anything findSaveProblems rejects, including a
	 * missing or empty model, which would wipe the stored workflow. Returns the advisory findings on success.
	 * @param {String} pHash
	 * @param {Object} [pWorkflow]  the working model (defaults to the editor's current one)
	 * @return {Promise<{ Unreachable: Array<String>, Dangling: Array<String> }>}
	 */
	async saveWorkflowAsync(pHash, pWorkflow)
	{
		if (!this.canEdit)
		{
			throw new Error('You do not have permission to edit approval workflows.');
		}
		const tmpWorkflow = pWorkflow || this.state.Editor.Workflow;
		const tmpProblems = libModel.findSaveProblems(tmpWorkflow);
		if (tmpProblems.length)
		{
			throw new Error(tmpProblems.join(' '));
		}
		const tmpSaveable = libModel.prepareBlobForSave(tmpWorkflow);
		await this._postJSON(this._workflowPutPath(pHash), { Config: tmpSaveable });
		return { Unreachable: libModel.findUnreachableStates(tmpSaveable), Dangling: libModel.findDanglingTargets(tmpSaveable) };
	}

	// --- Clone ---

	/**
	 * @param {String} pName
	 * @return {String} Why that can't be a workflow's name; empty when it can.
	 */
	nameProblem(pName)
	{
		return libModel.workflowNameProblem(pName);
	}

	/** True if the customer already has a workflow stored under pHash (exact match, per the loaded list). */
	workflowHashExists(pHash)
	{
		const tmpHash = String(pHash || '').trim();
		return (this.state.List || []).some((pRow) => String(pRow.Hash) === tmpHash);
	}

	/**
	 * Clone an existing workflow to a new hash (Customer scope). The source's stored blob is copied verbatim:
	 * every intra-workflow reference is a Status string that lives inside the blob, so a deep copy keeps all
	 * wiring valid and there is nothing to remap. Actor references (role PermissionLevels / IDUsers) stay valid
	 * within the same customer. Bindings are untouched — the clone is inert until a document/observation type is
	 * pointed at it on the Bindings screen.
	 *
	 * NOTE: the hash is the Configuration map key, so a Put to an existing hash OVERWRITES it. Callers must
	 * reject a collision first (see workflowHashExists); this method assumes pNewHash is free.
	 * @param {String} pSourceHash  the workflow to copy from
	 * @param {String} pNewHash     the hash/name to store the copy under
	 * @return {Promise<void>}
	 */
	async cloneWorkflowAsync(pSourceHash, pNewHash)
	{
		if (!this.canEdit)
		{
			throw new Error('You do not have permission to clone approval workflows.');
		}
		const tmpResult = await this._postJSON('Configuration/Get',
			{ LevelContext: 'Customer', LevelContextID: this.idCustomer, NamespaceKey: 'ApprovalWorkflow', NamespaceValue: pSourceHash });
		const tmpSourceBlob = this._unwrapConfig(tmpResult);
		if (!tmpSourceBlob || !Array.isArray(tmpSourceBlob.States))
		{
			throw new Error(`Source workflow "${pSourceHash}" could not be read.`);
		}
		// Deep-copy so the persisted clone shares no references with the source, then store it verbatim under the
		// new hash (same direct-blob Put shape as saveWorkflowAsync).
		const tmpClone = JSON.parse(JSON.stringify(tmpSourceBlob));
		await this._postJSON(`Configuration/Put/ApprovalWorkflow/${encodeURIComponent(pNewHash)}/Customer/${this.idCustomer}`, { Config: tmpClone });
	}

	// --- P2 editing: mutate the working blob directly (single source of truth) ---
	//
	// All edits happen on this.state.Editor.Workflow (the normalized blob). The canvas stays read-only; the editor view
	// drives these from its panels and toolbar, then redraws the graph. Branches are read-only for now.

	get workflow()
	{
		return this.state.Editor.Workflow;
	}

	/** The states, as { Status, StateName } — for the target-state pickers. */
	stateOptions()
	{
		return ((this.workflow && this.workflow.States) || []).map((pState) => ({ Status: pState.Status, StateName: pState.StateName }));
	}

	_findState(pStatus)
	{
		const tmpStates = (this.workflow && this.workflow.States) || [];
		const tmpIndex = tmpStates.findIndex((pState) => pState.Status === pStatus);
		return (tmpIndex < 0) ? null : { State: tmpStates[tmpIndex], Index: tmpIndex };
	}

	_markDirty()
	{
		this.state.Editor.Dirty = true;
	}

	/**
	 * Apply an edit to a primary transition. pPatch may set Action, ToStatus, and the four flags; only values that
	 * differ are written, and only a real change marks the editor dirty.
	 * @return {Promise<Boolean>} true if anything changed
	 */
	async applyTransitionEditAsync(pSourceStatus, pTransitionIndex, pPatch)
	{
		const tmpFound = this._findState(pSourceStatus);
		if (!tmpFound)
		{
			return false;
		}
		const tmpTransition = (tmpFound.State.Transitions || [])[pTransitionIndex];
		if (!tmpTransition)
		{
			return false;
		}
		if (!libModel.applyTransitionPatch(tmpTransition, pPatch))
		{
			return false;
		}
		this._markDirty();
		await this._afterEditAsync();
		return true;
	}

	/**
	 * Add a new transition to a state (default action, targeting the first other state). Returns its index.
	 */
	async addTransitionAsync(pSourceStatus)
	{
		const tmpFound = this._findState(pSourceStatus);
		if (!tmpFound) { return -1; }
		if (!Array.isArray(tmpFound.State.Transitions)) { tmpFound.State.Transitions = []; }
		const tmpStates = this.workflow.States;
		const tmpDefaultTarget = (tmpStates.find((pState) => pState.Status !== pSourceStatus) || tmpStates[0]).Status;
		tmpFound.State.Transitions.push({ Action: 'New Action', ToStatus: tmpDefaultTarget, Actors: [] });
		this._markDirty();
		await this._afterEditAsync();
		return tmpFound.State.Transitions.length - 1;
	}

	/** Remove a transition from a state. */
	async removeTransitionAsync(pSourceStatus, pTransitionIndex)
	{
		const tmpFound = this._findState(pSourceStatus);
		if (!tmpFound || !Array.isArray(tmpFound.State.Transitions)) { return; }
		tmpFound.State.Transitions.splice(pTransitionIndex, 1);
		this._markDirty();
		await this._afterEditAsync();
	}

	/**
	 * Edit a state's display name and/or its Status identity. Renaming the Status cascades to every
	 * reference to it. Only a real change marks the editor dirty. Returns the (possibly new) Status plus whether anything
	 * changed, or an { Error }.
	 */
	async applyStateEditAsync(pStatus, pPatch)
	{
		const tmpFound = this._findState(pStatus);
		if (!tmpFound) { return { Error: 'State not found.' }; }
		let tmpChanged = false;
		let tmpNewStatus = pStatus;
		if (pPatch.hasOwnProperty('Status') && (pPatch.Status !== pStatus))
		{
			const tmpProposed = String(pPatch.Status || '').trim();
			if (!tmpProposed) { return { Error: 'State hash cannot be empty.' }; }
			if ((tmpProposed !== pStatus) && this.workflow.States.some((pState) => pState.Status === tmpProposed))
			{
				return { Error: `Another state already uses the hash "${tmpProposed}".` };
			}
			if (tmpProposed !== pStatus)
			{
				libModel.renameStatusCascade(this.workflow, pStatus, tmpProposed);
				tmpFound.State.Status = tmpProposed;
				tmpNewStatus = tmpProposed;
				tmpChanged = true;
			}
		}
		if (pPatch.hasOwnProperty('StateName') && ((tmpFound.State.StateName || '') !== pPatch.StateName))
		{
			tmpFound.State.StateName = pPatch.StateName;
			tmpChanged = true;
		}
		if (tmpChanged)
		{
			this._markDirty();
			await this._afterEditAsync();
		}
		return { Status: tmpNewStatus, Changed: tmpChanged };
	}

	/** Add a new state (unique Status). Returns its Status. */
	async addStateAsync()
	{
		if (!this.workflow.States) { this.workflow.States = []; }
		let tmpN = this.workflow.States.length + 1;
		let tmpStatus = `NewState${tmpN}`;
		while (this.workflow.States.some((pState) => pState.Status === tmpStatus)) { tmpN++; tmpStatus = `NewState${tmpN}`; }
		this.workflow.States.push({ Status: tmpStatus, StateName: 'New State', Transitions: [] });
		this._markDirty();
		await this._afterEditAsync();
		return tmpStatus;
	}

	/** Remove a state and every transition that referenced it (as owner or target). */
	async removeStateAsync(pStatus)
	{
		if (!this.workflow.States) { return; }
		libModel.removeStateCascade(this.workflow, pStatus);
		this._markDirty();
		await this._afterEditAsync();
	}

	// --- P3 actor editing ("who can perform this action") ---
	//
	// Actors stay in their stored form. The editor addresses them through libModel.actorRows, which shows one row per
	// role or user. New role/user actors are objects { Type, Hashes, Tags:[] }; new keyword and level actors are strings
	// ("Admin", "MinimumUserLevelInProject:3").

	/** The customer's roles (cached) for the role pickers: [{ PermissionLevel, Name }] sorted by Name. */
	async loadCustomerRolesAsync()
	{
		if (this._customerRoles)
		{
			return this._customerRoles;
		}
		try
		{
			const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}`);
			this._customerRoles = (Array.isArray(tmpRoles) ? tmpRoles : [])
				.filter((pRole) => pRole && pRole.PermissionLevel != null)
				.map((pRole) => ({ PermissionLevel: String(pRole.PermissionLevel), Name: pRole.Name || String(pRole.PermissionLevel) }))
				.sort((pA, pB) => pA.Name.localeCompare(pB.Name));
		}
		catch (pError)
		{
			this.pict.log.warn(`ApprovalWorkflow customer-role load failed`, { error: String(pError) });
			this._customerRoles = [];
		}
		return this._customerRoles;
	}

	get customerRoles()
	{
		return this._customerRoles || [];
	}

	/** Best-effort user search for the Users actor picker (the shared user search: name, login ID or email, every
	 *  word must match; the server scopes it to the caller's customer): [{ IDUser, Name }] in name order. */
	async searchUsersAsync(pQuery)
	{
		const tmpQuery = String(pQuery || '').trim();
		if (tmpQuery.length < 2)
		{
			return [];
		}
		try
		{
			const tmpUsers = await libUserSearch.searchUsersAsync((pURL) => this._getJSON(pURL), tmpQuery, { PageSize: 25 });
			return tmpUsers.map((pUser) => ({ IDUser: pUser.IDUser, Name: libUserSearch.userLabel(pUser) }));
		}
		catch (pError)
		{
			this.pict.log.warn(`ApprovalWorkflow user search failed`, { error: String(pError) });
			return [];
		}
	}

	/**
	 * The read-mode detail for a clicked edge (graphviz renderer → { SourceStatus, TransitionIndex, ... }):
	 * the source/target names + the full generated sentence. Sentences resolve role/user names from the
	 * already-loaded Editor.Names.
	 */
	edgeDetail(pInfo)
	{
		const tmpWorkflow = this.workflow;
		if (!tmpWorkflow || !pInfo) { return null; }
		const tmpStateMap = libModel.buildStateMap(tmpWorkflow);
		const tmpState = (tmpWorkflow.States || []).find((pState) => pState.Status === pInfo.SourceStatus);
		if (!tmpState) { return null; }
		const tmpTransition = (tmpState.Transitions || [])[pInfo.TransitionIndex];
		if (!tmpTransition) { return null; }
		return {
			SourceStateName: tmpState.StateName || pInfo.SourceStatus,
			ToStateName: tmpStateMap[pInfo.ToStatus] || pInfo.ToStatus,
			SentenceText: libModel.transitionSentence(tmpTransition, tmpStateMap, this.state.Editor.Names || {}),
			IsBranch: !!pInfo.IsBranch,
		};
	}

	/** Readable rows for a transition's actors (for the editor list): [{ ActorIndex, SettingIndex, Label }]. */
	actorLabels(pSourceStatus, pTransitionIndex)
	{
		const tmpFound = this._findState(pSourceStatus);
		if (!tmpFound) { return []; }
		const tmpTransition = (tmpFound.State.Transitions || [])[pTransitionIndex];
		if (!tmpTransition) { return []; }
		return libModel.actorRows(tmpTransition.Actors, this.state.Editor.Names || { RoleNameByLevel: {}, UserNameByID: {} });
	}

	/** Add an actor (object for role/user, string for keyword/level) to a transition. */
	async addActorAsync(pSourceStatus, pTransitionIndex, pActor)
	{
		const tmpFound = this._findState(pSourceStatus);
		if (!tmpFound) { return; }
		const tmpTransition = (tmpFound.State.Transitions || [])[pTransitionIndex];
		if (!tmpTransition) { return; }
		if (!Array.isArray(tmpTransition.Actors)) { tmpTransition.Actors = []; }
		libModel.addActorSpec(tmpTransition.Actors, pActor);
		this._markDirty();
		await this._afterEditAsync();
	}

	/** Remove one actor row (see libModel.actorRows) from a transition. */
	async removeActorAsync(pSourceStatus, pTransitionIndex, pActorIndex, pSettingIndex)
	{
		const tmpFound = this._findState(pSourceStatus);
		if (!tmpFound) { return; }
		const tmpTransition = (tmpFound.State.Transitions || [])[pTransitionIndex];
		if (!tmpTransition || !Array.isArray(tmpTransition.Actors)) { return; }
		libModel.removeActorRow(tmpTransition.Actors, pActorIndex, pSettingIndex);
		this._markDirty();
		await this._afterEditAsync();
	}

	/** Set the tags on one actor row (see libModel.actorRows) of a transition. */
	async setActorTagsAsync(pSourceStatus, pTransitionIndex, pActorIndex, pSettingIndex, pTags)
	{
		const tmpFound = this._findState(pSourceStatus);
		const tmpTransition = tmpFound && (tmpFound.State.Transitions || [])[pTransitionIndex];
		if (!tmpTransition || !Array.isArray(tmpTransition.Actors))
		{
			return;
		}
		if (libModel.setActorRowTags(tmpTransition.Actors, pActorIndex, pSettingIndex, pTags))
		{
			this._markDirty();
			await this._afterEditAsync();
		}
	}

	/** True while the editor holds edits that have not been saved. */
	hasUnsavedEdits()
	{
		const tmpEditor = this.state.Editor;
		return !!(tmpEditor.Dirty && tmpEditor.Workflow);
	}

	/**
	 * Persist the current working model. Re-reads the stored workflow first and writes nothing if that read fails. A new
	 * workflow may not take a name already in use. An existing one that changed since it was loaded comes back as
	 * { Conflict: true }, unwritten, unless pOptions.Force says to overwrite.
	 * @param {{ Hash?: String, Force?: Boolean }} [pOptions] - Hash names a new workflow.
	 * @return {Promise<{ Conflict?: Boolean, Changes?: Array<String>, Unreachable?: Array<String>, Dangling?: Array<String> }>}
	 */
	async saveAsync(pOptions)
	{
		const tmpOptions = pOptions || {};
		const tmpEditor = this.state.Editor;
		const tmpHash = tmpOptions.Hash || tmpEditor.Hash;
		const tmpNameProblem = libModel.workflowNameProblem(tmpHash);
		if (tmpNameProblem)
		{
			throw new Error(tmpNameProblem);
		}
		const tmpProblems = libModel.findSaveProblems(tmpEditor.Workflow);
		if (tmpProblems.length)
		{
			throw new Error(tmpProblems.join(' '));
		}
		let tmpLive;
		try
		{
			tmpLive = await this._readWorkflowBlobAsync(tmpHash);
		}
		catch (pError)
		{
			throw new Error(`Nothing was saved: the stored workflow could not be checked (${pError && pError.message ? pError.message : pError}).`);
		}
		if (tmpEditor.IsNew)
		{
			if (Object.keys(tmpLive).length)
			{
				throw new Error(`A workflow named "${tmpHash}" already exists. Choose a different name.`);
			}
		}
		else if (!tmpOptions.Force && !libModel.workflowsEqual(libModel.normalizeLoadedBlob(tmpLive), tmpEditor.Pristine))
		{
			return { Conflict: true, Changes: libModel.workflowChanges(tmpEditor.Pristine || {}, libModel.normalizeLoadedBlob(tmpLive)) };
		}
		const tmpResult = await this.saveWorkflowAsync(tmpHash, tmpEditor.Workflow);
		tmpEditor.Hash = tmpHash;
		tmpEditor.IsNew = false;
		tmpEditor.Dirty = false;
		// The saved state is the new baseline for Discard and for the next save's check.
		tmpEditor.Pristine = JSON.parse(JSON.stringify(tmpEditor.Workflow));
		this._refreshFindings();
		return tmpResult;
	}

	// --- P4 bindings: which approval workflow governs each document type ---------------------------------
	//
	// Stored at Configuration namespace 'ApprovalWorkflowBindings', NamespaceValue 'Document', as a flat map
	// { "<documentTypeHash>": "<workflowHash>" }. Document types are ReportNamedInstance rows; a synthetic
	// "Default" row is the fallback for any document without its own binding.
	//
	// SCOPE. Bindings cascade Global -> Customer -> Project (deeper wins, PER KEY — see the config service).
	// This screen edits two of those levels, mirroring Home:
	//   - Customer scope: the customer-wide default set (what every project inherits).
	//   - Project scope:  one project's overrides. A project's EFFECTIVE map (what the approvals engine reads)
	//     is the customer map with the project's own keys layered on top; the read endpoint already returns
	//     that merge, so tmpState.Map is always the effective map for the active scope and tmpState.CustomerMap
	//     is the default reference used to tell inherited rows from overrides. On save we write the whole
	//     effective map back to the scope; the server keeps only genuine overrides (a value equal to the parent
	//     is dropped -> inherit; a parent key omitted is hidden -> opt-out), so project bindings can diverge
	//     from the customer default without duplicating the whole set.

	// Project-scope dropdown sentinels (not real workflow hashes): "use the customer default" and "no workflow".
	get BINDING_INHERIT() { return BINDING_INHERIT; }
	get BINDING_NONE() { return BINDING_NONE; }

	get bindingsState()
	{
		if (!this.state.Bindings)
		{
			this.state.Bindings = { Loading: false, Error: '', Rows: [], WorkflowHashes: [], Map: {}, Dirty: false, Editable: false,
				EntityType: 'Document', Title: BINDING_FAMILIES.Document.Title, TargetNoun: BINDING_FAMILIES.Document.TargetNoun, TargetNounPlural: BINDING_FAMILIES.Document.TargetNounPlural, ServerPending: false,
				// Scope: 'Customer' (the default set) or 'Project' (one project's overrides).
				Scope: 'Customer', IDProject: 0, ProjectName: '', ScopeLoading: false,
				CustomerMap: {}, CustomerMapLoaded: false, LoadedScopeKey: '', Targets: [], Projects: [], ProjectsLoaded: false };
		}
		return this.state.Bindings;
	}

	/** The (Scope, ScopeID) the bindings map is read from / written to right now. */
	_bindingScope()
	{
		const tmpState = this.bindingsState;
		return (tmpState.Scope === 'Project' && tmpState.IDProject > 0)
			? { Scope: 'Project', ScopeID: tmpState.IDProject }
			: { Scope: 'Customer', ScopeID: this.idCustomer };
	}

	/**
	 * Fetch the effective bindings map ({ typeHash: workflowHash }) for the entity type at a scope. Rejects when the
	 * read fails: the map is written back whole on save, so treating a failed read as an empty map would wipe the
	 * scope's bindings (or opt a project out of every customer binding) on the next save.
	 */
	async _fetchBindingsMap(pScope, pScopeID, pEntityType)
	{
		const tmpBindings = await this._getJSON(`Configuration/For/ApprovalWorkflowBindings/In/${pScope}/${pScopeID}`);
		return Object.assign({}, (tmpBindings && tmpBindings[pEntityType]) || {});
	}

	/** Key of the scope whose map is in hand, e.g. 'Customer:10' or 'Project:34876'. */
	_bindingScopeKey(pScope)
	{
		return `${pScope.Scope}:${pScope.ScopeID}`;
	}

	/**
	 * Why the active scope's bindings can't be saved right now ('' when they can). Saving is refused unless the map
	 * on screen came from a successful read of the scope being written.
	 * @return {String}
	 */
	bindingsSaveBlockedReason()
	{
		const tmpState = this.bindingsState;
		if (tmpState.Loading || tmpState.ScopeLoading)
		{
			return 'The bindings are still loading.';
		}
		if (tmpState.LoadedScopeKey !== this._bindingScopeKey(this._bindingScope()))
		{
			return 'The current bindings could not be read, so saving is disabled: a save would overwrite them. Reload the page and try again.';
		}
		return '';
	}

	/**
	 * Load the target types (documents or observations) + workflow hashes + the current bindings map into the
	 * bindings state, for the given family. Workflows are the SHARED pool; only the target entity and the
	 * bindings NamespaceValue differ. Always resets to Customer scope. @param {String} [pEntityType] 'Document'
	 * (default) or 'Observation'.
	 */
	async loadBindingsAsync(pEntityType)
	{
		const tmpFamily = BINDING_FAMILIES[pEntityType] || BINDING_FAMILIES.Document;
		const tmpState = this.bindingsState;
		tmpState.EntityType = tmpFamily.EntityType;
		tmpState.Title = tmpFamily.Title;
		tmpState.TargetNoun = tmpFamily.TargetNoun;
		tmpState.TargetNounPlural = tmpFamily.TargetNounPlural;
		tmpState.ServerPending = tmpFamily.ServerPending;
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Dirty = false;
		tmpState.Editable = this.canEdit;
		// A fresh page load always starts on the customer default set.
		tmpState.Scope = 'Customer';
		tmpState.IDProject = 0;
		tmpState.ProjectName = '';
		tmpState.CustomerMapLoaded = false;
		tmpState.LoadedScopeKey = '';
		this._repaintBindings();
		try
		{
			// No fallback to {}: without the workflow list every row's dropdown would be empty (see _fetchBindingsMap).
			const tmpWorkflowMap = await this._getJSON(`Configuration/For/ApprovalWorkflow/In/Customer/${this.idCustomer}`);
			const tmpTargets = await this._getJSON(tmpFamily.targetsURL(this.idCustomer)).catch(() => []);

			tmpState.CustomerWorkflowHashes = Object.keys(tmpWorkflowMap || {}).sort((pA, pB) => String(pA).localeCompare(String(pB)));
			tmpState.WorkflowHashes = tmpState.CustomerWorkflowHashes;
			tmpState.Targets = (Array.isArray(tmpTargets) ? tmpTargets : [])
				.map((pRow) => ({ Key: tmpFamily.targetKey(pRow), Label: tmpFamily.targetLabel(pRow) }))
				.filter((pRow) => pRow.Key);
			// The customer map is both the customer-scope working map and the default reference for project scope.
			tmpState.CustomerMap = await this._fetchBindingsMap('Customer', this.idCustomer, tmpFamily.EntityType);
			tmpState.CustomerMapLoaded = true;
			tmpState.LoadedScopeKey = this._bindingScopeKey(this._bindingScope());
			tmpState.Map = Object.assign({}, tmpState.CustomerMap);
			this._rebuildBindingRows();
		}
		catch (pError)
		{
			tmpState.Rows = [];
			tmpState.Map = {};
			tmpState.Error = `Could not load bindings, so editing is disabled: ${pError && pError.message ? pError.message : pError}`;
			this.pict.log.warn(`ApprovalWorkflow bindings load failed`, { error: String(pError), entityType: tmpFamily.EntityType });
		}
		tmpState.Loading = false;
		this._repaintBindings();
		// The project scope picker is server-side search now (mountBindingProjectPicker) — no capped bulk preload
		// (the old `Projects/Lite/…/0/1000` made projects past 1000 permanently unselectable for an override).
	}

	/**
	 * (Re)mount the searchable project-scope picker into #ApprovalWorkflowBindings-ProjectPicker. Server-side search
	 * over the customer's projects (replaces the capped `Projects/Lite/…/0/1000` <select>). Called from the bindings
	 * view's onAfterRender, so it re-creates into the fresh mount each repaint; the selection is preserved via the
	 * ValueAddress binding on Bindings.IDProject + ResolveValue. Mirrors the RoleClone / ProjectEditWorkspace pattern.
	 */
	mountBindingProjectPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#ApprovalWorkflowBindings-ProjectPicker').length === 0) { return; }
		const tmpView = tmpPicker.createPicker('ApprovalWorkflowBindings-ProjectPicker',
			{
				DestinationAddress: '#ApprovalWorkflowBindings-ProjectPicker',
				ValueAddress: 'AppData.ApprovalWorkflowEditor.Bindings.IDProject',
				Searchable: true, AllowClear: false,
				// The bound value is Bindings.IDProject, whose "no project chosen" state is 0. Tell the picker to
				// paint 0 as the placeholder instead of a literal "0" selection (it still stores/returns 0).
				EmptyValues: [ 0 ],
				Placeholder: 'Select a project…',
				DataProvider: (pTerm, pPage) =>
				{
					const tmpStart = (Number(pPage) || 0) * 25;
					let tmpFilter = `FBV~IDCustomer~EQ~${this.idCustomer}~FBV~Deleted~EQ~0`;
					const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
					if (tmpTerm) { tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`; }
					return this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}/${tmpStart}/25`)
						// The Lite projection returns the project NAME under `Value` (not `Name`), so read that first —
						// otherwise the browse list shows "Project <id>" for every row.
						.then((pRows) => ({ results: (Array.isArray(pRows) ? pRows : []).map((pP) => ({ Value: Number(pP.IDProject), Text: pP.Value || pP.Name || `Project ${pP.IDProject}`, Record: pP })), hasMore: (Array.isArray(pRows) && (pRows.length >= 25)) }))
						.catch(() => ({ results: [], hasMore: false }));
				},
				ResolveValue: (pValue) =>
				{
					const tmpID = Number(pValue);
					if (!tmpID) { return Promise.resolve(null); }
					return this._getJSON(`Project/${tmpID}`)
						.then((pP) => ((pP && pP.IDProject) ? { Value: Number(pP.IDProject), Text: pP.Name || `Project ${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` }))
						.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
				},
				OnChange: (pValue) => { const tmpBindingsView = this.pict.views.ApprovalWorkflowBindings; if (tmpBindingsView) { tmpBindingsView.onProjectChange(pValue || 0); } },
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	/**
	 * Switch the bindings screen between the customer default set and one project's overrides. Loads the target
	 * scope's effective map (customer map is already cached). @param {String} pScope 'Customer'|'Project'.
	 */
	async switchBindingScopeAsync(pScope, pIDProject)
	{
		const tmpState = this.bindingsState;
		const tmpScope = (pScope === 'Project') ? 'Project' : 'Customer';
		const tmpIDProject = parseInt(pIDProject, 10) || 0;
		tmpState.Scope = tmpScope;
		tmpState.Dirty = false;
		tmpState.Error = '';
		if (tmpScope === 'Project' && tmpIDProject > 0)
		{
			const tmpProject = (tmpState.Projects || []).find((pProject) => Number(pProject.IDProject) === tmpIDProject);
			tmpState.IDProject = tmpIDProject;
			// The picker isn't a preloaded list, so the chosen project may not be cached — resolve its name by id.
			if (tmpProject) { tmpState.ProjectName = tmpProject.Name; }
			else { const tmpFetched = await this._getJSON(`Project/${tmpIDProject}`).catch(() => null); tmpState.ProjectName = (tmpFetched && tmpFetched.Name) || `Project ${tmpIDProject}`; }
			tmpState.ScopeLoading = true;
			tmpState.LoadedScopeKey = '';
			this._repaintBindings();
			try
			{
				tmpState.Map = await this._fetchBindingsMap('Project', tmpIDProject, tmpState.EntityType);
				// A project can bind to a workflow set only on itself, which the customer's list doesn't include.
				const tmpProjectWorkflows = await this._getJSON(`Configuration/For/ApprovalWorkflow/In/Project/${tmpIDProject}`);
				tmpState.WorkflowHashes = Array.from(new Set((tmpState.CustomerWorkflowHashes || []).concat(Object.keys(tmpProjectWorkflows || {})))).sort((pA, pB) => String(pA).localeCompare(String(pB)));
				tmpState.LoadedScopeKey = this._bindingScopeKey(this._bindingScope());
				this._rebuildBindingRows();
			}
			catch (pError)
			{
				tmpState.Map = {};
				tmpState.Rows = [];
				tmpState.Error = `Could not load ${tmpState.ProjectName}'s bindings, so editing is disabled: ${pError && pError.message ? pError.message : pError}`;
			}
			tmpState.ScopeLoading = false;
		}
		else if (tmpScope === 'Project')
		{
			// Project scope selected but no project chosen yet — show the prompt, wait for a pick.
			tmpState.IDProject = 0;
			tmpState.ProjectName = '';
			tmpState.Map = {};
			tmpState.Rows = [];
			tmpState.LoadedScopeKey = '';
		}
		else
		{
			tmpState.IDProject = 0;
			tmpState.ProjectName = '';
			tmpState.WorkflowHashes = tmpState.CustomerWorkflowHashes || [];
			tmpState.Map = Object.assign({}, tmpState.CustomerMap);
			tmpState.LoadedScopeKey = tmpState.CustomerMapLoaded ? this._bindingScopeKey(this._bindingScope()) : '';
			if (!tmpState.CustomerMapLoaded)
			{
				tmpState.Error = 'The customer default bindings could not be read, so editing is disabled. Reload the page and try again.';
			}
			this._rebuildBindingRows();
		}
		this._repaintBindings();
	}

	/** Rebuild the target-row list (synthetic Default + every target type + any bound key not in the list). */
	_rebuildBindingRows()
	{
		const tmpState = this.bindingsState;
		const tmpRows = [ { DocHash: 'Default', DocName: 'Default', Synthetic: true } ];
		const tmpSeen = { Default: true };
		(tmpState.Targets || []).forEach((pTarget) =>
		{
			if (pTarget.Key && !tmpSeen[pTarget.Key])
			{
				tmpSeen[pTarget.Key] = true;
				tmpRows.push({ DocHash: pTarget.Key, DocName: pTarget.Label || pTarget.Key });
			}
		});
		// Orphans = bound keys (in this scope's map OR the customer default) with no matching target type.
		Object.keys(tmpState.Map || {}).concat(Object.keys(tmpState.CustomerMap || {})).forEach((pKey) =>
		{
			if (!tmpSeen[pKey]) { tmpSeen[pKey] = true; tmpRows.push({ DocHash: pKey, DocName: pKey, Orphan: true }); }
		});
		tmpState.Rows = tmpRows;
	}

	/**
	 * Set the binding for a type in the active scope. In project scope the value may be a sentinel: BINDING_INHERIT
	 * copies the customer default (server dedupes it back to "inherit"); BINDING_NONE / '' clears it (in project
	 * scope an omitted parent key is hidden -> the project opts out of the default). Marks dirty.
	 */
	setBinding(pDocHash, pValue)
	{
		const tmpState = this.bindingsState;
		if (pValue === BINDING_INHERIT)
		{
			const tmpDefault = tmpState.CustomerMap[pDocHash];
			if (tmpDefault) { tmpState.Map[pDocHash] = tmpDefault; }
			else { delete tmpState.Map[pDocHash]; }
		}
		else if (pValue && pValue !== BINDING_NONE)
		{
			tmpState.Map[pDocHash] = pValue;
		}
		else
		{
			delete tmpState.Map[pDocHash];
		}
		tmpState.Dirty = true;
	}

	/**
	 * Persist the active scope's bindings map. Writes the whole effective map to Customer or Project scope; the
	 * server keeps only genuine overrides. Returns { Count, Scope, OverrideCount }. On a project save the map is
	 * re-fetched so the inherited/override badges reflect what was actually stored.
	 */
	async saveBindingsAsync()
	{
		if (!this.canEdit)
		{
			throw new Error('You do not have permission to edit approval-workflow bindings.');
		}
		const tmpBlockedReason = this.bindingsSaveBlockedReason();
		if (tmpBlockedReason)
		{
			throw new Error(tmpBlockedReason);
		}
		const tmpState = this.bindingsState;
		const tmpEntityType = tmpState.EntityType || 'Document';
		const tmpScope = this._bindingScope();
		const tmpMap = {};
		Object.keys(tmpState.Map).forEach((pHash) => { if (tmpState.Map[pHash]) { tmpMap[pHash] = tmpState.Map[pHash]; } });
		await this._postJSON(`Configuration/Put/ApprovalWorkflowBindings/${tmpEntityType}/${tmpScope.Scope}/${tmpScope.ScopeID}`, tmpMap);
		tmpState.Dirty = false;
		const tmpOverrideCount = this.bindingOverrideCount();
		if (tmpScope.Scope === 'Project')
		{
			// Reflect the server's dedup/hide: re-read the effective map so inherited vs override reads true. The save
			// itself succeeded; if the re-read fails, block further edits until a reload rather than show a stale map.
			try
			{
				tmpState.Map = await this._fetchBindingsMap('Project', tmpScope.ScopeID, tmpEntityType);
			}
			catch (pError)
			{
				tmpState.LoadedScopeKey = '';
				tmpState.Rows = [];
				tmpState.Error = `Saved, but the bindings could not be read back, so editing is disabled. Reload the page before editing again: ${pError && pError.message ? pError.message : pError}`;
			}
			if (!tmpState.Error)
			{
				this._rebuildBindingRows();
			}
			this._repaintBindings();
		}
		else
		{
			// Keep the default reference fresh so project scope compares against what was just saved.
			tmpState.CustomerMap = Object.assign({}, tmpMap);
		}
		return { Count: Object.keys(tmpMap).length, Scope: tmpScope.Scope, OverrideCount: tmpOverrideCount };
	}

	/** How many types in the active (project) scope diverge from the customer default. 0 for customer scope. */
	bindingOverrideCount()
	{
		const tmpState = this.bindingsState;
		if (tmpState.Scope !== 'Project') { return 0; }
		const tmpKeys = {};
		Object.keys(tmpState.Map || {}).concat(Object.keys(tmpState.CustomerMap || {})).forEach((pKey) => { tmpKeys[pKey] = true; });
		let tmpCount = 0;
		Object.keys(tmpKeys).forEach((pKey) =>
		{
			if ((tmpState.Map[pKey] || '') !== (tmpState.CustomerMap[pKey] || '')) { tmpCount++; }
		});
		return tmpCount;
	}

	_repaintBindings()
	{
		const tmpView = this.pict.views.ApprovalWorkflowBindings;
		if (tmpView && tmpView.pict)
		{
			tmpView.render();
		}
	}

	/** Revert edits to the last-loaded/saved state. Restores the in-memory snapshot (no network); falls back
	 * to a server reload / default re-seed only if no snapshot exists. */
	async discardAsync()
	{
		const tmpEditor = this.state.Editor;
		if (tmpEditor.Pristine)
		{
			tmpEditor.Workflow = JSON.parse(JSON.stringify(tmpEditor.Pristine));
			tmpEditor.Dirty = false;
			this._refreshFindings();
			tmpEditor.Error = '';
			this._repaintEditor();
			return;
		}
		if (tmpEditor.IsNew)
		{
			await this.newWorkflowAsync();
		}
		else
		{
			await this.loadWorkflowAsync(tmpEditor.Hash, tmpEditor.IDProject);
		}
		tmpEditor.Dirty = false;
	}

	_repaintEditor()
	{
		const tmpView = this.pict.views.ApprovalWorkflowEditor;
		if (tmpView && tmpView.pict)
		{
			tmpView.render();
		}
	}
}

module.exports = ApprovalWorkflowProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ApprovalWorkflow',
	AutoInitialize: true,
	AutoInitializeOrdinal: 30,
};

},{"../access/User-Search.js":1064,"../approval-workflow/ApprovalWorkflow-Model.js":1068,"pict-provider":845}],1303:[function(require,module,exports){

const libPictProvider = require('pict-provider');

// An ArtifactType is a reusable data-shape: a Name + a JSON-Schema `Schemata` whose `properties`
// define the columns/fields an observation requirement collects (a single value like Data_String,
// or a multi-column "row" like LegacyPersonnel). This editor lets you define those properties.
// ArtifactType is writable on the API (User: Create=Allow / Update=Mine, Administrator: Update=Allow),
// so creating is open to any user; editing an existing one needs ownership or admin.

const PROPERTY_TYPES = [ 'string', 'number', 'integer', 'boolean' ];

/**
 * ArtifactTypeEditor — the data layer behind the bespoke ArtifactType builder. Loads an artifact's
 * Schemata into an ordered property model the view edits, and persists it back as JSON Schema.
 */
class ArtifactTypeEditorProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		this._allArtifacts = null;
		this._editor = null;
		this._rowKeySeed = 1;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser() { return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {}; }
	get idUser() { return this.currentUser.UserID; }
	get isAdmin() { return Number(this.currentUser.UserRoleIndex) === 5; }

	/** Editable when creating new, when an admin, or when the current user created this artifact (Update=Mine). */
	_canEdit(pArtifact, pMode)
	{
		if (pMode === 'new') { return true; }
		if (this.isAdmin) { return true; }
		return Number(pArtifact && pArtifact.CreatingIDUser) === Number(this.idUser);
	}

	// --- REST helpers ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) => { this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody)); });
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) => { this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody)); });
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) => { this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody)); });
	}

	async _ensureAllArtifactsAsync()
	{
		if (this._allArtifacts) { return this._allArtifacts; }
		let tmpRows = [];
		try { tmpRows = await this._getJSON('ArtifactTypes'); }
		catch (pError) { this.log.warn(`ArtifactTypeEditor: could not load the artifact catalog: ${pError.message || pError}`); }
		this._allArtifacts = Array.isArray(tmpRows) ? tmpRows : [];
		return this._allArtifacts;
	}

	_nameInUse(pName, pExcludeID)
	{
		const tmpName = (pName || '').trim().toLowerCase();
		return (this._allArtifacts || []).some((pArtifact) =>
			pArtifact && (pArtifact.Deleted !== 1) && ((pArtifact.Name || '').trim().toLowerCase() === tmpName)
			&& (Number(pArtifact.IDArtifactType) !== Number(pExcludeID)));
	}

	// --- Schemata <-> property-model ---

	/**
	 * Parse an artifact's Schemata JSON Schema into ordered, editable property rows. Keeps the raw
	 * property object on each row so unknown attributes survive a round-trip.
	 * @param {Object} pArtifact
	 * @return {Array<Object>}
	 */
	_propertiesFromSchemata(pArtifact)
	{
		let tmpSchema = pArtifact && pArtifact.Schemata;
		if (typeof tmpSchema === 'string') { try { tmpSchema = JSON.parse(tmpSchema); } catch (pError) { tmpSchema = {}; } }
		const tmpProperties = (tmpSchema && tmpSchema.properties) || {};
		const tmpRequired = Array.isArray(tmpSchema && tmpSchema.required) ? tmpSchema.required : [];
		return Object.keys(tmpProperties)
			.map((pKey) => Object.assign({ Key: pKey }, tmpProperties[pKey]))
			.sort((pA, pB) => ((pA.ordinal == null ? 999 : pA.ordinal) - (pB.ordinal == null ? 999 : pB.ordinal)))
			.map((pProperty) =>
				(
					{
						_key: this._rowKeySeed++,
						_original: pProperty,
						Key: pProperty.Key,
						DisplayName: pProperty.displayName || '',
						Type: (PROPERTY_TYPES.indexOf((`${pProperty.type || 'string'}`).toLowerCase()) >= 0) ? (`${pProperty.type}`).toLowerCase() : 'string',
						EnumOptions: Array.isArray(pProperty.enumOptions) ? pProperty.enumOptions.join(', ') : '',
						Required: (tmpRequired.indexOf(pProperty.Key) >= 0),
						Hidden: (pProperty.visible === false) || (pProperty.Hidden === true)
					}));
	}

	/**
	 * Serialize the working property model back into a JSON Schema, preserving unknown attributes.
	 * @param {String} pTitle
	 * @return {Object}
	 */
	_buildSchemata(pTitle)
	{
		const tmpProperties = {};
		const tmpRequired = [];
		this._editor.properties.forEach((pRow, pIndex) =>
		{
			const tmpKey = (pRow.Key || '').trim();
			if (!tmpKey) { return; }
			const tmpProperty = Object.assign({}, pRow._original || {});
			tmpProperty.type = pRow.Type;
			tmpProperty.ordinal = pIndex;
			if ((pRow.DisplayName || '').trim()) { tmpProperty.displayName = pRow.DisplayName.trim(); }
			else { delete tmpProperty.displayName; }
			const tmpEnum = (pRow.EnumOptions || '').split(',').map((pOption) => pOption.trim()).filter((pOption) => pOption.length > 0);
			if (tmpEnum.length > 0) { tmpProperty.enumOptions = tmpEnum; }
			else { delete tmpProperty.enumOptions; }
			if (pRow.Hidden) { tmpProperty.visible = false; }
			else { delete tmpProperty.visible; delete tmpProperty.Hidden; }
			delete tmpProperty.Key;
			tmpProperties[tmpKey] = tmpProperty;
			if (pRow.Required) { tmpRequired.push(tmpKey); }
		});
		return { title: pTitle, type: 'object', properties: tmpProperties, required: tmpRequired };
	}

	_blankProperty()
	{
		return { _key: this._rowKeySeed++, _original: {}, Key: '', DisplayName: '', Type: 'string', EnumOptions: '', Required: false, Hidden: false };
	}

	// --- Load / new / save ---

	async loadAsync(pIDArtifact)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		tmpState.Message = '';
		this._render();
		try
		{
			await this._ensureAllArtifactsAsync();
			const tmpArtifact = await this._getJSON(`ArtifactType/${pIDArtifact}`);
			if (!tmpArtifact || !tmpArtifact.IDArtifactType) { throw new Error(`Artifact type ${pIDArtifact} not found.`); }
			this._editor =
			{
				mode: this._canEdit(tmpArtifact, 'edit') ? 'edit' : 'view',
				artifact: tmpArtifact,
				properties: this._propertiesFromSchemata(tmpArtifact)
			};
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the artifact type: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	async newType()
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		this._render();
		await this._ensureAllArtifactsAsync();
		this._editor = { mode: 'new', artifact: { Name: '' }, properties: [ this._blankProperty() ] };
		tmpState.Loading = false;
		this._render();
	}

	async openByGUIDAsync(pGUID)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true; tmpState.Message = '';
		this._render();
		try
		{
			const tmpRows = await this._getJSON(`ArtifactTypes/FilteredTo/FBV~GUIDArtifactType~EQ~${pGUID}`);
			const tmpRecord = (Array.isArray(tmpRows) && tmpRows.length > 0) ? tmpRows[0] : null;
			if (!tmpRecord) { throw new Error(`No artifact type found for GUID ${pGUID}.`); }
			await this.loadAsync(tmpRecord.IDArtifactType);
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not open the artifact type: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	async saveAsync()
	{
		if (!this._editor) { return; }
		const tmpState = this.editorState;
		const tmpName = (this._editor.artifact.Name || '').trim();
		if (!tmpName)
		{
			tmpState.Message = 'A Name is required.'; tmpState.MessageClass = 'is-warning'; this._render(); return;
		}
		if (this._nameInUse(tmpName, this._editor.artifact.IDArtifactType))
		{
			tmpState.Message = `The name “${tmpName}” is already used by another artifact type.`; tmpState.MessageClass = 'is-warning'; this._render(); return;
		}
		const tmpKeys = this._editor.properties.map((pRow) => (pRow.Key || '').trim()).filter((pKey) => pKey.length > 0);
		if (tmpKeys.length === 0)
		{
			tmpState.Message = 'Add at least one field (a property with a key).'; tmpState.MessageClass = 'is-warning'; this._render(); return;
		}
		if ((new Set(tmpKeys)).size !== tmpKeys.length)
		{
			tmpState.Message = 'Field keys must be unique.'; tmpState.MessageClass = 'is-warning'; this._render(); return;
		}

		tmpState.Saving = true; tmpState.Message = '';
		this._render();
		try
		{
			const tmpRecord = Object.assign({}, this._editor.artifact, { Name: tmpName, Schemata: JSON.stringify(this._buildSchemata(tmpName)) });
			let tmpSaved;
			if (tmpRecord.IDArtifactType) { tmpSaved = await this._putJSON('ArtifactType', tmpRecord); }
			else { tmpSaved = await this._postJSON('ArtifactType', tmpRecord); }
			const tmpID = (tmpSaved && tmpSaved.IDArtifactType) || tmpRecord.IDArtifactType;
			this._allArtifacts = null;
			tmpState.Saving = false;
			await this.loadAsync(tmpID);
			this.editorState.Message = `Saved “${tmpName}”.`;
			this.editorState.MessageClass = 'is-success';
			this._render();
			if (typeof window !== 'undefined' && window.location) { window.location.hash = `#/ArtifactType/${tmpID}`; }
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Save failed: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	// --- Property-model mutations ---

	_row(pKey) { return this._editor ? this._editor.properties.find((pRow) => pRow._key === Number(pKey)) : null; }

	setArtifactName(pValue) { if (this._editor) { this._editor.artifact.Name = pValue; } }

	addProperty()
	{
		if (!this._editor) { return; }
		this._editor.properties.push(this._blankProperty());
		this._render();
	}

	removeProperty(pKey)
	{
		if (!this._editor) { return; }
		this._editor.properties = this._editor.properties.filter((pRow) => pRow._key !== Number(pKey));
		this._render();
	}

	setPropertyField(pKey, pField, pValue)
	{
		const tmpRow = this._row(pKey);
		if (!tmpRow) { return; }
		if ((pField === 'Required') || (pField === 'Hidden')) { tmpRow[pField] = !!pValue; }
		else { tmpRow[pField] = pValue; }
		if (pField === 'Type') { this._render(); }
	}

	_move(pKey, pDelta)
	{
		if (!this._editor) { return; }
		const tmpProperties = this._editor.properties;
		const tmpIndex = tmpProperties.findIndex((pRow) => pRow._key === Number(pKey));
		const tmpTarget = tmpIndex + pDelta;
		if (tmpIndex < 0 || tmpTarget < 0 || tmpTarget >= tmpProperties.length) { return; }
		const tmpMoved = tmpProperties.splice(tmpIndex, 1)[0];
		tmpProperties.splice(tmpTarget, 0, tmpMoved);
		this._render();
	}

	moveUp(pKey) { this._move(pKey, -1); }
	moveDown(pKey) { this._move(pKey, 1); }

	backToList()
	{
		if (typeof window !== 'undefined' && window.location) { window.location.hash = '#/PSRS/ArtifactType/List'; }
	}

	// --- Render-state ---

	get editorState()
	{
		if (!this.pict.AppData.ArtifactTypeEditor)
		{
			this.pict.AppData.ArtifactTypeEditor =
			{
				Loading: false, Saving: false, Message: '', MessageClass: '',
				LoadingSlot: [], EditorSlot: [], EmptySlot: [ {} ], MessageSlot: [], ReadOnlyNoticeSlot: [],
				Mode: '', CanEdit: false, Name: '', TitleText: 'Artifact Type',
				Properties: [], PropertyCount: 0, TypeOptions: PROPERTY_TYPES.slice(),
				SaveDisabledAttr: '', ReadOnlyAttr: ''
			};
		}
		return this.pict.AppData.ArtifactTypeEditor;
	}

	deriveRenderState()
	{
		const tmpState = this.editorState;
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message, MessageClass: tmpState.MessageClass || 'is-info' } ] : [];

		if (tmpState.Loading) { tmpState.LoadingSlot = [ {} ]; tmpState.EditorSlot = []; tmpState.EmptySlot = []; return; }
		if (!this._editor) { tmpState.LoadingSlot = []; tmpState.EditorSlot = []; tmpState.EmptySlot = [ {} ]; return; }

		const tmpCanEdit = (this._editor.mode === 'new') || (this._editor.mode === 'edit');
		tmpState.Mode = this._editor.mode;
		tmpState.CanEdit = tmpCanEdit;
		tmpState.ReadOnlyAttr = tmpCanEdit ? '' : 'disabled';
		tmpState.Name = this._editor.artifact.Name || '';
		tmpState.TitleText = (this._editor.mode === 'new') ? 'New Artifact Type' : (this._editor.artifact.Name || 'Artifact Type');
		tmpState.ReadOnlyNoticeSlot = tmpCanEdit ? [] : [ {} ];

		tmpState.Properties = this._editor.properties.map((pRow) =>
		{
			const tmpIsString = (pRow.Type === 'string');
			return (
				{
					Key: pRow._key,
					KeyName: pRow.Key || '',
					DisplayName: pRow.DisplayName || '',
					EnumOptions: pRow.EnumOptions || '',
					RequiredAttr: pRow.Required ? 'checked' : '',
					HiddenAttr: pRow.Hidden ? 'checked' : '',
					ReadOnlyAttr: tmpCanEdit ? '' : 'disabled',
					EnumDisabledAttr: (tmpCanEdit && tmpIsString) ? '' : 'disabled',
					TypeOptions: PROPERTY_TYPES.map((pType) => ({ Value: pType, SelectedAttr: (pType === pRow.Type) ? 'selected' : '' }))
				});
		});
		tmpState.PropertyCount = this._editor.properties.length;
		tmpState.EmptyPropertiesSlot = (this._editor.properties.length > 0) ? [] : [ {} ];
		tmpState.SaveDisabledAttr = (tmpState.Saving || !tmpCanEdit) ? 'disabled' : '';
		tmpState.ShowSave = tmpCanEdit;
		tmpState.LoadingSlot = []; tmpState.EmptySlot = [];
		tmpState.EditorSlot = [ tmpState ];
	}

	_render()
	{
		this.deriveRenderState();
		if (this.pict.views.ArtifactTypeEditor) { this.pict.views.ArtifactTypeEditor.render(); }
	}
}

module.exports = ArtifactTypeEditorProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ArtifactTypeEditor',
	AutoInitialize: true,
	AutoInitializeOrdinal: 211
};

},{"pict-provider":845}],1304:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

/**
 * AssetCatalogSyncProvider — the engine behind the #/AssetCatalogSync screen.
 *
 * Seeds THIS customer's PhysicalAsset* catalog from the shared public data lake (the AASHTO/NBE national
 * standard, reachable through the main /1.0/ proxy). The public lake is the shared master; each customer gets
 * its own copy so they can adjust it with local nuance — so this sync is ADDITIVE (create-missing only): it
 * NEVER overwrites a row the customer already has, matching on the natural key (Code within the customer).
 * Re-running is therefore idempotent and safe to run against a catalog an admin has already tuned.
 *
 * Mapping (lake -> per-customer catalog):
 *   AssetMaterial                        -> PhysicalAssetMaterial       (Code, Material, Description)
 *   Element                              -> PhysicalAssetElementType    (Code, Section, SectionCode, Name, Unit,
 *                                           Clarification, IDPhysicalAssetMaterial resolved via the material Code)
 *   BridgeElementConditionDefect         -> PhysicalAssetDefect         (Code, Name, Description, Notes,
 *                                           PrimaryDocumentationURL; CS1-CS4 packed into StateDescriptionsJSON)
 *   BridgeElementConditionDefectElementJoin -> PhysicalAssetElementTypePhysicalAssetDefectJoin
 *                                           (which defects apply to which element type)
 *
 * IDCustomer is server-stamped from the session — never sent. Row GUIDs auto-generate (we do NOT carry the
 * lake BRM-* GUID across, to avoid the soft-deleted-GUID-uniqueness trap on re-sync; the Code is the key).
 *
 * State lives in pict.AppData.AssetCatalogSync; the (large) lake payloads are held on the instance.
 */

const PAGE = 500;            // read page size for the /1.0/{Set}/{start}/{cap} paging
const WRITE_BATCH = 200;     // bulk-create chunk size (POST /1.0/{Set} with an array)

// Lake reference sets and the customer catalog sets they seed.
const LAKE = { Material: 'AssetMaterials', Element: 'Elements', Defect: 'BridgeElementConditionDefects', Join: 'BridgeElementConditionDefectElementJoins' };
const CAT  = { Material: 'PhysicalAssetMaterials', Element: 'PhysicalAssetElementTypes', Defect: 'PhysicalAssetDefects', Join: 'PhysicalAssetElementTypePhysicalAssetDefectJoins' };

class AssetCatalogSyncProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// Held off-state (they are large): the lake reference payloads + the last computed plan.
		this._lake = null;
		this._plan = null;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get currentUser() { return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {}; }
	get idCustomer() { return this.currentUser.CustomerID; }
	get customerName() { return this.currentUser.CustomerName || this.currentUser.Customer || ('Customer ' + this.idCustomer); }

	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	get hasCustomerAdmin()
	{
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin' || pRole.PermissionLevel === 'SuperAdminUser'));
	}

	/** Who may run the sync (writes to the catalog). UI gate only — the Meadow role auth is authoritative. */
	get canEdit() { return this.isSuperUser || this.hasCustomerAdmin; }

	get state()
	{
		if (!this.pict.AppData.AssetCatalogSync)
		{
			this.pict.AppData.AssetCatalogSync =
			{
				Loading: false, Loaded: false, Error: '',
				Plan: null,                 // { Material:{lake,existing,toCreate}, Element:{…}, Defect:{…}, Join:{lake} }
				Confirming: false,
				Applying: false, Progress: '', Result: null,
			};
		}
		return this.pict.AppData.AssetCatalogSync;
	}

	// --- REST helpers (promisified over the shared HeadlightRestClient) ---

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_postJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }

	/** Page through a Meadow set (returns every row). */
	async _readAll(pSet)
	{
		let tmpOut = [];
		let tmpStart = 0;
		for (;;)
		{
			const tmpRows = await this._getJSON(`${pSet}/${tmpStart}/${PAGE}`);
			if (!Array.isArray(tmpRows) || tmpRows.length === 0) { break; }
			tmpOut = tmpOut.concat(tmpRows);
			if (tmpRows.length < PAGE) { break; }
			tmpStart += PAGE;
			if (tmpStart > 100000) { break; } // safety
		}
		return tmpOut;
	}

	/** Bulk-create rows into a set (chunked). Returns the count actually POSTed. */
	async _bulkCreate(pSet, pRows)
	{
		let tmpCount = 0;
		for (let i = 0; i < pRows.length; i += WRITE_BATCH)
		{
			const tmpChunk = pRows.slice(i, i + WRITE_BATCH);
			const tmpResult = await this._postJSON(pSet, tmpChunk);
			// Meadow bulk create surfaces an in-body error object on failure — treat that as fatal for this stage.
			if (tmpResult && tmpResult.Error) { throw new Error(`${pSet}: ${tmpResult.Error}`); }
			tmpCount += tmpChunk.length;
			this._progress(`Created ${tmpCount} / ${pRows.length} into ${pSet}…`);
		}
		return tmpCount;
	}

	static _index(pRows, pKey)
	{
		const tmpMap = {};
		(pRows || []).forEach((pRow) => { if (pRow && (pRow[pKey] !== undefined) && (pRow[pKey] !== null)) { tmpMap[String(pRow[pKey])] = pRow; } });
		return tmpMap;
	}

	// --- Plan (dry-run preview; NO writes) ---

	/**
	 * Read the lake reference catalog + this customer's existing catalog, and compute what an additive sync
	 * would create. Leaves the lake payloads on the instance for a subsequent apply.
	 */
	async loadPlanAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return; }
		tmpState.Loading = true; tmpState.Error = ''; tmpState.Result = null; tmpState.Confirming = false;
		this.render();
		try
		{
			// Shared lake reference (the AASHTO master).
			const [ tmpLakeMat, tmpLakeElem, tmpLakeDef, tmpLakeJoin ] = await Promise.all(
			[
				this._readAll(LAKE.Material), this._readAll(LAKE.Element), this._readAll(LAKE.Defect), this._readAll(LAKE.Join),
			]);
			// This customer's existing catalog (live rows only).
			const [ tmpCurMat, tmpCurElem, tmpCurDef ] = await Promise.all(
			[
				this._readAll(`${CAT.Material}/FilteredTo/FBV~Deleted~EQ~0`),
				this._readAll(`${CAT.Element}/FilteredTo/FBV~Deleted~EQ~0`),
				this._readAll(`${CAT.Defect}/FilteredTo/FBV~Deleted~EQ~0`),
			]);

			this._lake = { Material: tmpLakeMat, Element: tmpLakeElem, Defect: tmpLakeDef, Join: tmpLakeJoin };

			const tmpMatByCode = AssetCatalogSyncProvider._index(tmpCurMat, 'Code');
			const tmpElemByCode = AssetCatalogSyncProvider._index(tmpCurElem, 'Code');
			const tmpDefByCode = AssetCatalogSyncProvider._index(tmpCurDef, 'Code');

			const tmpMatToCreate = tmpLakeMat.filter((pRow) => !tmpMatByCode[String(pRow.Code)]);
			const tmpElemToCreate = tmpLakeElem.filter((pRow) => !tmpElemByCode[String(pRow.Code)]);
			const tmpDefToCreate = tmpLakeDef.filter((pRow) => !tmpDefByCode[String(pRow.Code)]);

			this._plan =
			{
				Material: { lake: tmpLakeMat.length, existing: tmpCurMat.length, toCreate: tmpMatToCreate },
				Element:  { lake: tmpLakeElem.length, existing: tmpCurElem.length, toCreate: tmpElemToCreate },
				Defect:   { lake: tmpLakeDef.length, existing: tmpCurDef.length, toCreate: tmpDefToCreate },
				Join:     { lake: tmpLakeJoin.length }, // per-row create resolved at apply (needs new element/defect IDs)
			};
			tmpState.Plan =
			{
				Material: { lake: tmpLakeMat.length, existing: tmpCurMat.length, toCreate: tmpMatToCreate.length },
				Element:  { lake: tmpLakeElem.length, existing: tmpCurElem.length, toCreate: tmpElemToCreate.length },
				Defect:   { lake: tmpLakeDef.length, existing: tmpCurDef.length, toCreate: tmpDefToCreate.length },
				Join:     { lake: tmpLakeJoin.length },
			};
			tmpState.Loaded = true;
		}
		catch (pError)
		{
			tmpState.Error = (pError && pError.message) || String(pError);
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	// --- Apply (writes; additive create-missing) ---

	askApply() { this.state.Confirming = true; this.render(); }
	cancelApply() { this.state.Confirming = false; this.render(); }

	_progress(pMessage) { this.state.Progress = pMessage; this.render(); }

	/**
	 * Execute the additive sync. Dependency order: materials -> element types (need material ids) ->
	 * defects -> element-type/defect joins (need both new- side ids). After each create stage we RE-READ the
	 * customer set to resolve Code -> new id (robust regardless of the bulk-create response shape).
	 */
	async applyAsync()
	{
		const tmpState = this.state;
		if (tmpState.Applying) { return; }
		if (!this.canEdit) { tmpState.Error = 'You do not have permission to write the asset catalog.'; this.render(); return; }
		if (!this._plan) { await this.loadPlanAsync(); if (this.state.Error) { return; } }

		tmpState.Applying = true; tmpState.Confirming = false; tmpState.Error = ''; tmpState.Result = null;
		const tmpResult = { Material: 0, Element: 0, Defect: 0, Join: 0 };
		this._progress('Starting…');
		try
		{
			// 1) Materials.
			if (this._plan.Material.toCreate.length)
			{
				const tmpRows = this._plan.Material.toCreate.map((pRow) => ({ Code: pRow.Code, Material: pRow.Material, Description: pRow.Description || '' }));
				tmpResult.Material = await this._bulkCreate(CAT.Material, tmpRows);
			}
			// Resolve material maps (existing + just-created).
			const tmpCurMat = await this._readAll(`${CAT.Material}/FilteredTo/FBV~Deleted~EQ~0`);
			const tmpMatByCode = AssetCatalogSyncProvider._index(tmpCurMat, 'Code');
			const tmpLakeMatById = AssetCatalogSyncProvider._index(this._lake.Material, 'IDAssetMaterial');

			// 2) Element types (resolve IDPhysicalAssetMaterial via the lake material Code).
			if (this._plan.Element.toCreate.length)
			{
				const tmpRows = this._plan.Element.toCreate.map((pRow) =>
				{
					const tmpLakeMat = tmpLakeMatById[String(pRow.IDAssetMaterial)];
					const tmpCustMat = tmpLakeMat ? tmpMatByCode[String(tmpLakeMat.Code)] : null;
					return {
						Code: pRow.Code, Section: pRow.Section, SectionCode: pRow.SectionCode, Name: pRow.Name,
						Unit: pRow.Unit, Clarification: pRow.Clarification || '',
						IDPhysicalAssetMaterial: tmpCustMat ? tmpCustMat.IDPhysicalAssetMaterial : 0,
					};
				});
				tmpResult.Element = await this._bulkCreate(CAT.Element, tmpRows);
			}

			// 3) Defects (pack the four condition-state descriptions into StateDescriptionsJSON).
			if (this._plan.Defect.toCreate.length)
			{
				const tmpRows = this._plan.Defect.toCreate.map((pRow) => (
				{
					Code: pRow.Code, Name: pRow.Name, Description: pRow.Description || '', Notes: pRow.Notes || '',
					PrimaryDocumentationURL: pRow.PrimaryDocumentationURL || '',
					StateDescriptionsJSON: JSON.stringify({ CS1: pRow.CS1Description || '', CS2: pRow.CS2Description || '', CS3: pRow.CS3Description || '', CS4: pRow.CS4Description || '' }),
				}));
				tmpResult.Defect = await this._bulkCreate(CAT.Defect, tmpRows);
			}

			// 4) Element-type <-> defect joins. Re-read both sides to map Code -> new id, and existing joins to skip.
			this._progress('Linking defects to element types…');
			const [ tmpCurElem2, tmpCurDef2, tmpCurJoin ] = await Promise.all(
			[
				this._readAll(`${CAT.Element}/FilteredTo/FBV~Deleted~EQ~0`),
				this._readAll(`${CAT.Defect}/FilteredTo/FBV~Deleted~EQ~0`),
				this._readAll(`${CAT.Join}/FilteredTo/FBV~Deleted~EQ~0`),
			]);
			const tmpElemByCode = AssetCatalogSyncProvider._index(tmpCurElem2, 'Code');
			const tmpDefByCode = AssetCatalogSyncProvider._index(tmpCurDef2, 'Code');
			const tmpLakeElemById = AssetCatalogSyncProvider._index(this._lake.Element, 'IDElement');
			const tmpLakeDefById = AssetCatalogSyncProvider._index(this._lake.Defect, 'IDBridgeElementConditionDefect');
			const tmpJoinSig = {};
			tmpCurJoin.forEach((pRow) => { tmpJoinSig[`${pRow.IDPhysicalAssetElementType}|${pRow.IDPhysicalAssetDefect}`] = true; });

			const tmpJoinRows = [];
			this._lake.Join.forEach((pRow) =>
			{
				const tmpLakeElem = tmpLakeElemById[String(pRow.IDElement)];
				const tmpLakeDef = tmpLakeDefById[String(pRow.IDBridgeElementConditionDefect)];
				if (!tmpLakeElem || !tmpLakeDef) { return; }
				const tmpElem = tmpElemByCode[String(tmpLakeElem.Code)];
				const tmpDef = tmpDefByCode[String(tmpLakeDef.Code)];
				if (!tmpElem || !tmpDef) { return; }
				const tmpSig = `${tmpElem.IDPhysicalAssetElementType}|${tmpDef.IDPhysicalAssetDefect}`;
				if (tmpJoinSig[tmpSig]) { return; }
				tmpJoinSig[tmpSig] = true; // guard against dupes within this batch
				tmpJoinRows.push({ IDPhysicalAssetElementType: tmpElem.IDPhysicalAssetElementType, IDPhysicalAssetDefect: tmpDef.IDPhysicalAssetDefect });
			});
			if (tmpJoinRows.length) { tmpResult.Join = await this._bulkCreate(CAT.Join, tmpJoinRows); }

			tmpState.Result = tmpResult;
			tmpState.Progress = '';
			// Refresh the plan so the table now shows everything present (toCreate -> 0).
			await this.loadPlanAsync();
			this.state.Result = tmpResult;
		}
		catch (pError)
		{
			tmpState.Error = (pError && pError.message) || String(pError);
		}
		finally
		{
			this.state.Applying = false;
			this.render();
		}
	}

	// --- Render (assigns the body HTML into the view's mount) ---

	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
	_n(pValue) { const tmpN = Number(pValue); return Number.isNaN(tmpN) ? '—' : tmpN.toLocaleString('en-US'); }

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement('#AssetCatalogSync-Body').length === 0) { return; }
		tmpCA.assignContent('#AssetCatalogSync-Body', this._bodyHTML());
	}

	_planRowHTML(pLabel, pIcon, pRow)
	{
		if (!pRow) { return ''; }
		const tmpToCreate = (pRow.toCreate === undefined) ? null : pRow.toCreate;
		const tmpBadge = (tmpToCreate === null)
			? `<span class="acs-badge acs-badge-info">${this._n(pRow.lake)} available</span>`
			: (tmpToCreate > 0 ? `<span class="acs-badge acs-badge-new">+${this._n(tmpToCreate)} new</span>` : `<span class="acs-badge acs-badge-ok">up to date</span>`);
		const tmpExisting = (pRow.existing === undefined) ? '—' : this._n(pRow.existing);
		return `<tr>
			<td class="acs-cell-label"><i class="${pIcon}"></i> ${this._esc(pLabel)}</td>
			<td class="acs-num">${this._n(pRow.lake)}</td>
			<td class="acs-num">${tmpExisting}</td>
			<td class="acs-num">${tmpToCreate === null ? '—' : this._n(tmpToCreate)}</td>
			<td>${tmpBadge}</td>
		</tr>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (tmpState.Loading && !tmpState.Plan) { return `<div class="acs-note"><i class="fas fa-circle-notch fa-spin"></i> Reading the public lake and your catalog…</div>`; }
		if (tmpState.Error) { return `<div class="acs-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Error)}</div>${this._actionsHTML()}`; }
		if (!tmpState.Plan) { return `<div class="acs-note">Preparing…</div>`; }

		const tmpPlan = tmpState.Plan;
		const tmpTotalNew = tmpPlan.Material.toCreate + tmpPlan.Element.toCreate + tmpPlan.Defect.toCreate;

		const tmpTable = `<table class="acs-table">
			<thead><tr><th>Catalog</th><th class="acs-num">In lake</th><th class="acs-num">You have</th><th class="acs-num">New</th><th></th></tr></thead>
			<tbody>
				${this._planRowHTML('Asset Materials', 'fas fa-layer-group', tmpPlan.Material)}
				${this._planRowHTML('Element Types', 'fas fa-diagram-project', tmpPlan.Element)}
				${this._planRowHTML('Defects', 'fas fa-triangle-exclamation', tmpPlan.Defect)}
				${this._planRowHTML('Element ⇄ Defect links', 'fas fa-link', tmpPlan.Join)}
			</tbody>
		</table>`;

		let tmpResultHTML = '';
		if (tmpState.Result)
		{
			const tmpR = tmpState.Result;
			tmpResultHTML = `<div class="acs-result"><i class="fas fa-circle-check"></i> Sync complete — created
				<b>${this._n(tmpR.Material)}</b> materials, <b>${this._n(tmpR.Element)}</b> element types,
				<b>${this._n(tmpR.Defect)}</b> defects, <b>${this._n(tmpR.Join)}</b> links.</div>`;
		}

		const tmpSummary = tmpTotalNew > 0
			? `<p class="acs-summary">This will <b>add ${this._n(tmpTotalNew)}</b> catalog rows to <b>${this._esc(this.customerName)}</b> (plus element⇄defect links). Existing rows you have already tuned are left untouched.</p>`
			: `<p class="acs-summary acs-summary-ok">${this._esc(this.customerName)}’s catalog already matches the lake baseline. Nothing new to add.</p>`;

		return tmpSummary + tmpTable + tmpResultHTML + this._actionsHTML();
	}

	_actionsHTML()
	{
		const tmpState = this.state;
		if (tmpState.Applying) { return `<div class="acs-actions"><span class="acs-progress"><i class="fas fa-circle-notch fa-spin"></i> ${this._esc(tmpState.Progress || 'Working…')}</span></div>`; }

		const tmpReload = `<button class="acs-btn acs-btn-ghost" onclick="_Pict.providers.AssetCatalogSync.loadPlanAsync()"${tmpState.Loading ? ' disabled' : ''}><i class="fas fa-rotate"></i> Reload plan</button>`;

		if (!this.canEdit)
		{
			return `<div class="acs-actions">${tmpReload}<span class="acs-note-inline">Running the sync needs a super-user or customer-admin.</span></div>`;
		}

		const tmpHasWork = tmpState.Plan && (tmpState.Plan.Material.toCreate + tmpState.Plan.Element.toCreate + tmpState.Plan.Defect.toCreate) > 0;
		if (tmpState.Confirming)
		{
			return `<div class="acs-actions acs-confirm">
				<span class="acs-confirm-q">Add the missing AASHTO catalog rows to ${this._esc(this.customerName)}?</span>
				<button class="acs-btn acs-btn-primary" onclick="_Pict.providers.AssetCatalogSync.applyAsync()"><i class="fas fa-cloud-arrow-down"></i> Yes, sync now</button>
				<button class="acs-btn acs-btn-ghost" onclick="_Pict.providers.AssetCatalogSync.cancelApply()">Cancel</button>
			</div>`;
		}
		const tmpApply = tmpHasWork
			? `<button class="acs-btn acs-btn-primary" onclick="_Pict.providers.AssetCatalogSync.askApply()"><i class="fas fa-cloud-arrow-down"></i> Sync from public lake</button>`
			: `<button class="acs-btn acs-btn-primary" disabled><i class="fas fa-check"></i> Up to date</button>`;
		return `<div class="acs-actions">${tmpApply}${tmpReload}</div>`;
	}
}

module.exports = AssetCatalogSyncProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'AssetCatalogSync',
	AutoInitialize: true,
	AutoInitializeOrdinal: 30,
};

},{"pict-provider":845}],1305:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libAssetDescriptor = require('../assets/AssetDescriptor.js');

const DETAIL_MOUNT = '#ATD-Detail';
const BODY_MOUNT = '#ATD-Body';
const STATUS_MOUNT = '#ATD-Status';

// ManifestJSON is MEDIUMTEXT once migrate-once/WidenAssetTypeManifestJSON.sql has run, and plain TEXT
// before that. A non-strict MySQL TRUNCATES an oversized value rather than refusing it, which leaves
// unparseable JSON that normalizeDescriptor swallows into {} — a blank screen with no error anywhere.
// So the editor refuses first, and warns well before the older limit in case the migration is behind.
const MEDIUMTEXT_BYTES = 16777215;
const TEXT_BYTES = 65535;

/**
 * AssetTypeDescriptor — the bespoke #/AssetTypeDescriptor screen: the metadata SHAPE editor for an
 * asset type. It owns the v2 descriptor inside AssetTypeManifest.ManifestJSON — which fields the
 * asset detail panel shows, what they are called, their units and help, which are map metrics, and
 * the order they read in.
 *
 * Three rules this screen exists to respect, each of which has already bitten someone:
 *
 *  1. ManifestJSON is a SHARED blob. The legacy flat `Properties` array (#/AssetTypeManifests) lives
 *     in the same column, and normalizeDescriptor does not round-trip it. So the raw parsed blob is
 *     kept on state and the edited descriptor is overlaid onto it — never the other way round.
 *  2. `Status` is the on switch and its absence is off. A descriptor without Status:'published' is
 *     skipped by the resolver, and the caller silently gets the compiled-in SNBI (bridge) vocabulary
 *     instead — so a culvert would render as a bridge. Every write here stamps Status explicitly.
 *  3. Field `Code` and metadata-set `Key` are PRIMARY KEYS for stored data: PhysicalAssetMetadata
 *     rows bind by (MetadataSetGUID = set key, Address = field code). Renaming either orphans every
 *     stored value with no error and no migration. They are read-only here; you rename the Label.
 *
 * Saving never mutates a published row in place. A published row is serving every asset of the type
 * right now, so an edit to one becomes a NEW version; only a draft row is written over.
 */
class AssetTypeDescriptorProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// Monotonic counter behind the provisional identifiers authored nodes carry until their first save.
		this._newSequence = 0;
		// Embed mode (hosted inside the AssetType workspace's Metadata Shape tab): lock to one type, hide its picker.
		this._fixedIDAssetType = 0;
		this._embedHost = '';
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get state()
	{
		if (!this.pict.AppData.AssetTypeDescriptor)
		{
			this.pict.AppData.AssetTypeDescriptor =
			{
				Loaded: false, Loading: false, Saving: false, Error: '', Message: '',
				Types: [], IDAssetType: 0,
				// The raw parsed blob exactly as stored. Everything this screen does not understand
				// rides along in here and is written back untouched.
				Raw: null,
				Descriptor: null,
				Row: null, Versions: [],
				SetKey: '', Filter: '', Expanded: {}, Dirty: false,
			};
		}
		return this.pict.AppData.AssetTypeDescriptor;
	}

	/** UI-only hint; the server stays authoritative. Fails open like the rest of the app. */
	canEdit()
	{
		const tmpService = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpService || (typeof tmpService.can !== 'function')) { return true; }
		return tmpService.can('AssetTypeManifest', 'Update') || tmpService.can('AssetTypeManifest', 'Create');
	}

	// --- embed API (the AssetType workspace's Metadata Shape tab) ---
	// Lock the editor to one IDAssetType, hide the type picker, and paint into the tab host. Idempotent:
	// the workspace re-creates the host div and calls this on every paint of the active embed tab.
	openInto(pIDAssetType, pHostSelector)
	{
		const tmpID = Number(pIDAssetType) || 0;
		this._embedHost = pHostSelector || '';
		const tmpChanged = (Number(this._fixedIDAssetType) !== tmpID);
		this._fixedIDAssetType = tmpID;
		try { if (this.pict.CSSMap && (typeof this.pict.CSSMap.injectCSS === 'function')) { this.pict.CSSMap.injectCSS(); } } catch (pError) { /* best-effort */ }
		// Re-paint the detail scaffold into the (re-created) host so render()'s #ATD-Detail mount exists here.
		if (pHostSelector) { this.pict.ContentAssignment.assignContent(pHostSelector, '<div class="atd-embed"><div id="ATD-Detail" class="atd-main"></div></div>'); }
		const tmpState = this.state;
		tmpState.IDAssetType = tmpID; // so loadAsync's remembered-type logic selects THIS type
		if (tmpChanged || !tmpState.Loaded) { this.loadAsync(); }
		else { this.render(); }
	}
	exitEmbed() { this._fixedIDAssetType = 0; this._embedHost = ''; }

	_get(pURI) { return new Promise((resolve, reject) => this.restClient.getJSON(pURI, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)))); }
	_post(pURI, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURI, pBody, (pError, pResult) => (pError ? reject(pError) : resolve(pResult)))); }
	_put(pURI, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURI, pBody, (pError, pResult) => (pError ? reject(pError) : resolve(pResult)))); }

	async _getAllPages(pURI, pPage)
	{
		const tmpPage = pPage || 250;
		const tmpOut = [];
		let tmpOffset = 0;
		for (;;)
		{
			const tmpRows = await this._get(`${ pURI }/${ tmpOffset }/${ tmpPage }`);
			if (!Array.isArray(tmpRows) || (tmpRows.length === 0)) { break; }
			tmpOut.push(...tmpRows);
			if (tmpRows.length < tmpPage) { break; }
			tmpOffset += tmpPage;
			if (tmpOffset > 100000) { break; }
		}
		return tmpOut;
	}

	_esc(pString) { return String(pString == null ? '' : pString).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	/** Escape for an inline handler's single-quoted JS string argument inside a DOUBLE-quoted HTML attribute:
	 * JS-escape backslash + single quote, and HTML-escape & and " so a typed identifier cannot break out of
	 * the attribute (field codes / set keys / value codes are free-text here). & first so later entities survive. */
	_js(pString) { return String(pString == null ? '' : pString).replace(/&/g, '&amp;').replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;'); }

	// A recognizable, unique placeholder identifier for a node the user just created. It is a non-empty
	// string (so normalizeDescriptor will not silently drop the node) that the save guard refuses to
	// store, forcing the author to give the node a real key before it can be written.
	_provisional(pKind) { this._newSequence += 1; return `__new_${ pKind }_${ this._newSequence }`; }
	_isProvisional(pString) { return /^__new_(set|group|field|value)_\d+$/.test(String(pString == null ? '' : pString)); }
	// A node's Label defaults to its Code/Key, so a brand-new node's label mirrors its provisional id; show
	// blank (placeholder) instead until the author types a real one.
	_cleanLabel(pNode) { return (pNode && pNode._New && this._isProvisional(pNode.Label)) ? '' : ((pNode && pNode.Label) || ''); }

	/** Object-or-string, and never throw: a truncated blob must not take the screen down. */
	_parseManifest(pRaw)
	{
		if (pRaw && (typeof pRaw === 'string')) { try { return JSON.parse(pRaw) || {}; } catch (pError) { return {}; } }
		if (pRaw && (typeof pRaw === 'object')) { return pRaw; }
		return {};
	}

	// ============================================================ load ============================================================

	async loadAsync()
	{
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		try
		{
			tmpState.Types = await this._getAllPages('AssetTypes/FilteredTo/FBV~Deleted~EQ~0');
			tmpState.Loaded = true;
			if (tmpState.Types.length)
			{
				const tmpRemembered = tmpState.Types.find((pType) => (Number(pType.IDAssetType) === Number(tmpState.IDAssetType)));
				await this.selectTypeAsync((tmpRemembered || tmpState.Types[0]).IDAssetType);
			}
		}
		catch (pError)
		{
			tmpState.Error = `Could not load the asset types: ${ (pError && pError.message) || pError }`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	/**
	 * Load the newest manifest row for a type — newest overall, not newest published, so a draft in
	 * progress is what you come back to.
	 *
	 * @param {Number|String} pIDAssetType
	 */
	async selectTypeAsync(pIDAssetType)
	{
		const tmpState = this.state;
		const tmpID = Number(pIDAssetType) || 0;
		if (!tmpID) { return; }
		tmpState.IDAssetType = tmpID;
		tmpState.Error = ''; tmpState.Message = '';
		tmpState.Raw = null; tmpState.Descriptor = null; tmpState.Row = null; tmpState.Versions = [];
		tmpState.SetKey = ''; tmpState.Expanded = {}; tmpState.Dirty = false; tmpState.Filter = '';
		tmpState.Loading = true;
		this.render();
		try
		{
			tmpState.Versions = await this._getAllPages(`AssetTypeManifests/FilteredTo/FBV~IDAssetType~EQ~${ tmpID }~FBV~Deleted~EQ~0`);
			const tmpNewest = tmpState.Versions.reduce((pBest, pRow) => ((!pBest || (Number(pRow.Version) > Number(pBest.Version))) ? pRow : pBest), null);
			if (tmpNewest)
			{
				// Re-read the single row: the Reads route does not always carry the blob, and this is
				// also the freshest copy immediately before an edit.
				const tmpRow = await this._get(`AssetTypeManifest/${ Number(tmpNewest.IDAssetTypeManifest) }`);
				const tmpBlob = (tmpRow && (tmpRow.Manifest != null)) ? tmpRow.Manifest : (tmpRow ? tmpRow.ManifestJSON : null);
				tmpState.Row = { IDAssetTypeManifest: Number(tmpNewest.IDAssetTypeManifest), Version: Number(tmpNewest.Version) };
				tmpState.Raw = this._parseManifest(tmpBlob);
			}
			else
			{
				tmpState.Row = null;
				tmpState.Raw = {};
			}
			tmpState.Descriptor = libAssetDescriptor.normalizeDescriptor(tmpState.Raw);
			tmpState.SetKey = tmpState.Descriptor.Dashboard.DefaultSet
				|| (tmpState.Descriptor.MetadataSets.length ? tmpState.Descriptor.MetadataSets[0].Key : '');
		}
		catch (pError)
		{
			tmpState.Error = `Could not load the metadata shape: ${ (pError && pError.message) || pError }`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	// ======================================================== editing ========================================================

	get accessor()
	{
		return new libAssetDescriptor.AssetDescriptorAccessor(this.state.Descriptor, { SetKey: this.state.SetKey });
	}

	get set()
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor) { return null; }
		return tmpState.Descriptor.MetadataSets.find((pSet) => (pSet.Key === tmpState.SetKey)) || null;
	}

	_field(pCode)
	{
		const tmpSet = this.set;
		return tmpSet ? (tmpSet.Fields.find((pField) => (pField.Code === pCode)) || null) : null;
	}

	_touch() { this.state.Dirty = true; this.state.Message = ''; }

	setSetKey(pKey) { this.state.SetKey = pKey; this.state.Expanded = {}; this.render(); }
	setSetLabel(pKey, pValue) { const tmpD = this.state.Descriptor; if (!tmpD) { return; } const tmpSet = tmpD.MetadataSets.find((pSet) => (pSet.Key === pKey)); if (tmpSet) { tmpSet.Label = String(pValue || ''); this._touch(); this._syncStatus(); } }
	setFilter(pValue) { this.state.Filter = String(pValue || ''); this._repaintBody(); }
	toggleExpand(pCode) { const tmpState = this.state; tmpState.Expanded[pCode] = !tmpState.Expanded[pCode]; this._repaintBody(); }

	toggleVisible(pCode)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		tmpField.Visible = !tmpField.Visible;
		this._touch(); this._repaintBody();
	}

	toggleMetric(pCode)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		tmpField.Metric = !tmpField.Metric;
		// Filterable has always defaulted to Metric; keep the pair consistent so the stored descriptor
		// does not develop a contradiction the editor never showed anyone.
		tmpField.Filterable = tmpField.Metric;
		// A hidden field cannot be a metric — metrics() excludes it, so leaving the flag on would be a
		// switch that visibly does nothing.
		if (tmpField.Metric) { tmpField.Visible = true; }
		this._touch(); this._repaintBody();
	}

	// Text setters do NOT repaint: the caret is in the input the user is typing into.
	setLabel(pCode, pValue) { const tmpField = this._field(pCode); if (tmpField) { tmpField.Label = String(pValue || ''); this._touch(); this._syncStatus(); } }
	setUnits(pCode, pValue) { const tmpField = this._field(pCode); if (tmpField) { tmpField.Units = String(pValue || '').trim() || null; this._touch(); this._syncStatus(); } }
	setHelp(pCode, pValue) { const tmpField = this._field(pCode); if (tmpField) { tmpField.Help = String(pValue || ''); this._touch(); this._syncStatus(); } }
	setGroupLabel(pKey, pValue)
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpGroup = tmpSet.Groups.find((pGroup) => (pGroup.Key === pKey));
		if (tmpGroup) { tmpGroup.Label = String(pValue || ''); this._touch(); this._syncStatus(); }
	}
	setAssetLabel(pWhich, pValue)
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor) { return; }
		tmpState.Descriptor.AssetType.Label[pWhich] = String(pValue || '');
		this._touch(); this._syncStatus();
	}
	setValueLabel(pCode, pValue, pLabel)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		const tmpEntry = tmpField.Values.find((pItem) => (pItem.Value === pValue));
		if (tmpEntry) { tmpEntry.Label = String(pLabel || ''); this._touch(); this._syncStatus(); }
	}

	setValueDisplay(pCode, pValue) { const tmpField = this._field(pCode); if (tmpField) { tmpField.Format.ValueDisplay = pValue; this._touch(); this._repaintBody(); } }
	setDecimals(pCode, pValue)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		const tmpNumber = (String(pValue).trim() === '') ? null : Number(pValue);
		tmpField.Format.Decimals = Number.isFinite(tmpNumber) ? tmpNumber : null;
		this._touch(); this._syncStatus();
	}

	setDefaultMetric(pCode)
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor) { return; }
		tmpState.Descriptor.Dashboard.DefaultMetric = pCode || null;
		this._touch(); this._syncStatus();
	}

	/** Show or hide every field in one group at once — the common case on a 149-field descriptor. */
	setGroupVisible(pKey, pVisible)
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpVisible = !!pVisible;
		tmpSet.Fields.forEach((pField) => { if ((pField.Group || '') === pKey) { pField.Visible = tmpVisible; if (!tmpVisible) { pField.Metric = false; pField.Filterable = false; } } });
		this._touch(); this._repaintBody();
	}

	/**
	 * Move a field within its group. Ordinals are renumbered densely afterwards so the stored order is
	 * unambiguous rather than depending on the array order that produced it.
	 *
	 * @param {String} pCode
	 * @param {Number} pDelta - -1 up, +1 down
	 */
	moveField(pCode, pDelta)
	{
		const tmpSet = this.set;
		const tmpField = this._field(pCode);
		if (!tmpSet || !tmpField) { return; }
		const tmpGroupKey = tmpField.Group || '';
		const tmpPeers = tmpSet.Fields.filter((pPeer) => ((pPeer.Group || '') === tmpGroupKey)).sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal));
		const tmpIndex = tmpPeers.indexOf(tmpField);
		const tmpTarget = tmpIndex + Number(pDelta);
		if ((tmpIndex < 0) || (tmpTarget < 0) || (tmpTarget >= tmpPeers.length)) { return; }
		tmpPeers.splice(tmpIndex, 1);
		tmpPeers.splice(tmpTarget, 0, tmpField);
		tmpPeers.forEach((pPeer, pIndex) => { pPeer.Ordinal = pIndex; });
		this._touch(); this._repaintBody();
	}

	/** Move a whole group up or down, renumbering group ordinals densely. */
	moveGroup(pKey, pDelta)
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpGroups = tmpSet.Groups.slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal));
		const tmpGroup = tmpGroups.find((pItem) => (pItem.Key === pKey));
		const tmpIndex = tmpGroups.indexOf(tmpGroup);
		const tmpTarget = tmpIndex + Number(pDelta);
		if (!tmpGroup || (tmpTarget < 0) || (tmpTarget >= tmpGroups.length)) { return; }
		tmpGroups.splice(tmpIndex, 1);
		tmpGroups.splice(tmpTarget, 0, tmpGroup);
		tmpGroups.forEach((pItem, pIndex) => { pItem.Ordinal = pIndex * 10; });
		this._touch(); this._repaintBody();
	}

	// =================================================== structural authoring ===================================================
	// Add/remove/reorder of metadata sets, sections, fields and coded values. Everything mutates
	// state.Descriptor in place and rides the existing _touch/_mergedManifest/validate/save/publish
	// pipeline, so draft/publish/versioning/byte-guard are inherited. A node authored in-session carries
	// a transient `_New` flag — never serialized (normalize* rebuilds a fixed key set) and dropped when
	// selectTypeAsync reloads after save — so its Code/Key stays editable only until the first save.

	addMetadataSet()
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor) { return; }
		const tmpKey = this._provisional('set');
		const tmpSet = libAssetDescriptor.normalizeSet({ Key: tmpKey, Label: '' }, tmpState.Descriptor.MetadataSets.length);
		tmpSet._New = true;
		// Seed one empty section so the author lands one click from adding a field.
		const tmpGroup = libAssetDescriptor.normalizeGroup({ Key: this._provisional('group'), Label: '' }, 0);
		tmpGroup._New = true;
		tmpSet.Groups.push(tmpGroup);
		tmpState.Descriptor.MetadataSets.push(tmpSet);
		tmpState.SetKey = tmpKey; tmpState.Expanded = {};
		this._touch(); this.render();
	}

	removeMetadataSet(pKey)
	{
		const tmpState = this.state;
		const tmpD = tmpState.Descriptor;
		if (!tmpD) { return; }
		const tmpSet = tmpD.MetadataSets.find((pSet) => (pSet.Key === pKey));
		if (!tmpSet) { return; }
		if (!tmpSet._New && (typeof window !== 'undefined') && !window.confirm(`Remove the "${ tmpSet.Label || tmpSet.Key }" metadata set and everything in it? Stored values are kept but will no longer be shown or decoded for any asset of this type.`)) { return; }
		tmpD.MetadataSets = tmpD.MetadataSets.filter((pSet) => (pSet.Key !== pKey));
		if (tmpState.SetKey === pKey) { tmpState.SetKey = tmpD.MetadataSets.length ? tmpD.MetadataSets[0].Key : ''; }
		if (tmpD.Dashboard.DefaultSet === pKey) { tmpD.Dashboard.DefaultSet = null; }
		tmpState.Expanded = {};
		this._touch(); this.render();
	}

	addGroup()
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpGroup = libAssetDescriptor.normalizeGroup({ Key: this._provisional('group'), Label: '' }, tmpSet.Groups.length);
		tmpGroup._New = true;
		tmpGroup.Ordinal = tmpSet.Groups.reduce((pMax, pItem) => Math.max(pMax, pItem.Ordinal), -10) + 10;
		tmpSet.Groups.push(tmpGroup);
		this._touch(); this._repaintBody();
	}

	removeGroup(pKey)
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpGroup = tmpSet.Groups.find((pItem) => (pItem.Key === pKey));
		if (!tmpGroup) { return; }
		// Removing a non-empty section would drop its fields into the synthesized "Other" bucket.
		if (tmpSet.Fields.some((pField) => ((pField.Group || '') === pKey)))
		{
			this.state.Error = 'Move or remove this section’s fields before removing the section.';
			this.render();
			return;
		}
		if (!tmpGroup._New && (typeof window !== 'undefined') && !window.confirm(`Remove the "${ tmpGroup.Label || pKey }" section?`)) { return; }
		tmpSet.Groups = tmpSet.Groups.filter((pItem) => (pItem.Key !== pKey));
		tmpSet.Groups.slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal)).forEach((pItem, pIndex) => { pItem.Ordinal = pIndex * 10; });
		this._touch(); this._repaintBody();
	}

	addField(pGroupKey)
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpCode = this._provisional('field');
		const tmpField = libAssetDescriptor.normalizeField({ Code: tmpCode, Label: '', Group: pGroupKey, DataType: 'string' }, tmpSet.Fields.length);
		tmpField._New = true;
		tmpField.Ordinal = tmpSet.Fields.filter((pField) => ((pField.Group || '') === pGroupKey)).reduce((pMax, pField) => Math.max(pMax, pField.Ordinal), -1) + 1;
		tmpSet.Fields.push(tmpField);
		this.state.Expanded[tmpCode] = true;
		this._touch(); this._repaintBody();
	}

	removeField(pCode)
	{
		const tmpSet = this.set;
		const tmpField = this._field(pCode);
		if (!tmpSet || !tmpField) { return; }
		if (!tmpField._New && (typeof window !== 'undefined') && !window.confirm(`Remove "${ tmpField.Label || pCode }"? This stops showing it on every asset of this type. Stored values are kept and reappear if you re-add the field with the same code.`)) { return; }
		const tmpGroupKey = tmpField.Group || '';
		tmpSet.Fields = tmpSet.Fields.filter((pField) => (pField !== tmpField));
		tmpSet.Fields.filter((pField) => ((pField.Group || '') === tmpGroupKey)).sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal)).forEach((pField, pIndex) => { pField.Ordinal = pIndex; });
		delete this.state.Expanded[pCode];
		if (this.state.Descriptor.Dashboard.DefaultMetric === pCode) { this.state.Descriptor.Dashboard.DefaultMetric = null; }
		this._touch(); this._repaintBody();
	}

	addValue(pCode)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		const tmpValue = libAssetDescriptor.normalizeValue({ Value: this._provisional('value'), Label: '' }, tmpField.Values.length);
		tmpValue._New = true;
		tmpValue.Ordinal = tmpField.Values.reduce((pMax, pItem) => Math.max(pMax, pItem.Ordinal), -1) + 1;
		tmpField.Values.push(tmpValue);
		// A value list IS the enum claim — keep the declared type honest.
		if (tmpField.DataType !== 'enum') { tmpField.DataType = 'enum'; }
		this._touch(); this._repaintBody();
	}

	removeValue(pCode, pValue)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		tmpField.Values = tmpField.Values.filter((pItem) => (pItem.Value !== pValue));
		tmpField.Values.slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal)).forEach((pItem, pIndex) => { pItem.Ordinal = pIndex; });
		this._touch(); this._repaintBody();
	}

	moveValue(pCode, pValue, pDelta)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		const tmpOrdered = tmpField.Values.slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal));
		const tmpIndex = tmpOrdered.findIndex((pItem) => (pItem.Value === pValue));
		const tmpTarget = tmpIndex + Number(pDelta);
		if ((tmpIndex < 0) || (tmpTarget < 0) || (tmpTarget >= tmpOrdered.length)) { return; }
		const tmpMoved = tmpOrdered.splice(tmpIndex, 1)[0];
		tmpOrdered.splice(tmpTarget, 0, tmpMoved);
		tmpOrdered.forEach((pItem, pIndex) => { pItem.Ordinal = pIndex; });
		this._touch(); this._repaintBody();
	}

	// --- identifier setters (effective only while the node is _New; onchange → repaint so handlers rebind) ---
	setNewSetKey(pOldKey, pValue)
	{
		const tmpState = this.state;
		const tmpD = tmpState.Descriptor;
		if (!tmpD) { return; }
		const tmpSet = tmpD.MetadataSets.find((pSet) => (pSet.Key === pOldKey));
		if (!tmpSet || !tmpSet._New) { return; }
		const tmpNew = String(pValue == null ? '' : pValue).trim();
		tmpSet.Key = tmpNew;
		if (tmpState.SetKey === pOldKey) { tmpState.SetKey = tmpNew; }
		if (tmpD.Dashboard.DefaultSet === pOldKey) { tmpD.Dashboard.DefaultSet = tmpNew; }
		this._touch(); this.render();
	}

	setNewGroupKey(pOldKey, pValue)
	{
		const tmpSet = this.set;
		if (!tmpSet) { return; }
		const tmpGroup = tmpSet.Groups.find((pItem) => (pItem.Key === pOldKey));
		if (!tmpGroup || !tmpGroup._New) { return; }
		const tmpNew = String(pValue == null ? '' : pValue).trim();
		// Re-home any fields already placed under the provisional key.
		tmpSet.Fields.forEach((pField) => { if ((pField.Group || '') === pOldKey) { pField.Group = tmpNew; } });
		tmpGroup.Key = tmpNew;
		this._touch(); this._repaintBody();
	}

	setNewCode(pOldCode, pValue)
	{
		const tmpField = this._field(pOldCode);
		if (!tmpField || !tmpField._New) { return; }
		const tmpNew = String(pValue == null ? '' : pValue).trim();
		if (this.state.Expanded[pOldCode]) { delete this.state.Expanded[pOldCode]; if (tmpNew) { this.state.Expanded[tmpNew] = true; } }
		if (!tmpField.ExternalID || (tmpField.ExternalID === pOldCode) || this._isProvisional(tmpField.ExternalID)) { tmpField.ExternalID = tmpNew; }
		tmpField.Code = tmpNew;
		this._touch(); this._repaintBody();
	}

	setNewValueCode(pCode, pOldValue, pNewValue)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		const tmpEntry = tmpField.Values.find((pItem) => (pItem.Value === pOldValue));
		if (!tmpEntry || !tmpEntry._New) { return; }
		tmpEntry.Value = String(pNewValue == null ? '' : pNewValue).trim();
		this._touch(); this._repaintBody();
	}

	setDataType(pCode, pValue)
	{
		const tmpField = this._field(pCode);
		if (!tmpField || !tmpField._New) { return; } // changing a saved field's type would reinterpret stored values
		if (tmpField.Values.length) { return; }       // a value list forces enum; clear values to change type
		if (libAssetDescriptor.DATA_TYPES.indexOf(String(pValue)) > -1) { tmpField.DataType = String(pValue); }
		this._touch(); this._repaintBody();
	}

	setConstraint(pCode, pWhich, pValue)
	{
		const tmpField = this._field(pCode);
		if (!tmpField) { return; }
		if (pWhich === 'Required') { tmpField.Constraints.Required = !!pValue; this._touch(); this._repaintBody(); return; }
		if ([ 'Min', 'Max', 'MaxLength' ].indexOf(pWhich) < 0) { return; }
		const tmpNumber = (String(pValue).trim() === '') ? null : Number(pValue);
		tmpField.Constraints[pWhich] = Number.isFinite(tmpNumber) ? tmpNumber : null;
		this._touch(); this._syncStatus();
	}

	/**
	 * Blocking problems with in-session authored nodes: a blank or still-provisional identifier, or a
	 * duplicate key/code/value. Runs BEFORE _mergedManifest, because normalize turns a provisional code
	 * into a literal stored key that _problems would then wave through. Returns '' when clean.
	 *
	 * @return {String}
	 */
	_structuralProblems()
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor) { return ''; }
		const tmpBad = (pValue) => (!String(pValue == null ? '' : pValue).trim() || this._isProvisional(pValue));
		const tmpProblems = [];
		const tmpSetKeys = {};
		(tmpState.Descriptor.MetadataSets || []).forEach((pSet) =>
		{
			const tmpSetName = pSet.Label || pSet.Key || 'a set';
			if (pSet._New && tmpBad(pSet.Key)) { tmpProblems.push('A new metadata set still needs a key.'); }
			if (pSet.Key && tmpSetKeys[pSet.Key]) { tmpProblems.push(`Two metadata sets share the key "${ pSet.Key }".`); }
			tmpSetKeys[pSet.Key] = true;
			const tmpGroupKeys = {};
			(pSet.Groups || []).forEach((pGroup) =>
			{
				if (pGroup._New && tmpBad(pGroup.Key)) { tmpProblems.push(`A new section in "${ tmpSetName }" still needs a key.`); }
				if (pGroup.Key && tmpGroupKeys[pGroup.Key]) { tmpProblems.push(`Two sections in "${ tmpSetName }" share the key "${ pGroup.Key }".`); }
				tmpGroupKeys[pGroup.Key] = true;
			});
			const tmpFieldCodes = {};
			(pSet.Fields || []).forEach((pField) =>
			{
				const tmpFieldName = pField.Label || pField.Code || 'a field';
				if (pField._New && tmpBad(pField.Code)) { tmpProblems.push(`A new field in "${ tmpSetName }" still needs a code.`); }
				if (pField.Code && tmpFieldCodes[pField.Code]) { tmpProblems.push(`Two fields in "${ tmpSetName }" share the code "${ pField.Code }".`); }
				tmpFieldCodes[pField.Code] = true;
				const tmpValueCodes = {};
				(pField.Values || []).forEach((pValue) =>
				{
					if (pValue._New && tmpBad(pValue.Value)) { tmpProblems.push(`A new coded value on "${ tmpFieldName }" still needs a code.`); }
					if (pValue.Value && tmpValueCodes[pValue.Value]) { tmpProblems.push(`Two coded values on "${ tmpFieldName }" share "${ pValue.Value }".`); }
					tmpValueCodes[pValue.Value] = true;
				});
			});
		});
		if (!tmpProblems.length) { return ''; }
		const tmpUnique = tmpProblems.filter((pItem, pIndex) => (tmpProblems.indexOf(pItem) === pIndex));
		return `Finish the new items before saving:\n  • ${ tmpUnique.join('\n  • ') }`;
	}

	// ========================================================= saving =========================================================

	/**
	 * The blob to store: everything that was there, with this screen's keys written over it.
	 *
	 * The overlay direction is the whole point. normalizeDescriptor returns only the six descriptor
	 * keys, so serializing IT would drop the legacy `Properties` array and anything else sharing the
	 * column. Raw first, descriptor second.
	 *
	 * @param {String} pStatus - 'draft' or 'published', always written explicitly
	 * @return {Object}
	 */
	_mergedManifest(pStatus)
	{
		const tmpState = this.state;
		const tmpDescriptor = libAssetDescriptor.normalizeDescriptor(tmpState.Descriptor);
		tmpDescriptor.Status = pStatus;
		return Object.assign({}, (tmpState.Raw && (typeof tmpState.Raw === 'object')) ? tmpState.Raw : {}, tmpDescriptor);
	}

	/**
	 * Refuse a write that cannot survive the round trip, using the guards the module already ships.
	 *
	 * @param {Object} pManifest
	 * @return {String} an empty string when it is safe to write
	 */
	_problems(pManifest)
	{
		const tmpBytes = libAssetDescriptor.serializedByteLength(pManifest);
		if (tmpBytes > MEDIUMTEXT_BYTES)
		{
			return `This shape is ${ tmpBytes.toLocaleString() } bytes and the column holds ${ MEDIUMTEXT_BYTES.toLocaleString() }. It would be truncated into unreadable JSON rather than refused, so it has not been saved.`;
		}
		// validateDescriptor returns a FLAT array of { Severity, Path, Message }. Errors block the write;
		// warnings are shown beside the save buttons instead, because they describe a descriptor that is
		// storable but will not do what its author expects.
		const tmpProblems = libAssetDescriptor.validateDescriptor(pManifest) || [];
		const tmpErrors = tmpProblems.filter((pProblem) => (pProblem.Severity === 'error'));
		if (tmpErrors.length)
		{
			return `This shape is not valid:\n  • ${ tmpErrors.map((pProblem) => `${ pProblem.Path }: ${ pProblem.Message }`).join('\n  • ') }`;
		}
		return '';
	}

	/**
	 * Non-blocking complaints about the shape as it currently stands.
	 *
	 * @return {Array<String>}
	 */
	_warnings()
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor || !tmpState.Descriptor.MetadataSets.length) { return []; }
		const tmpProblems = libAssetDescriptor.validateDescriptor(this._mergedManifest(this._storedStatus())) || [];
		return tmpProblems.filter((pProblem) => (pProblem.Severity !== 'error')).map((pProblem) => `${ pProblem.Path }: ${ pProblem.Message }`);
	}

	saveDraftAsync() { return this._writeAsync('draft'); }
	publishAsync() { return this._writeAsync('published'); }

	/**
	 * Write the descriptor.
	 *
	 * A DRAFT row is written over: nothing renders it, so there is nothing to disturb. A PUBLISHED row
	 * is never mutated — it is serving every asset of this type at this moment — so an edit to one
	 * becomes a new version instead.
	 *
	 * @param {String} pStatus
	 */
	async _writeAsync(pStatus)
	{
		const tmpState = this.state;
		if (tmpState.Saving || !tmpState.Descriptor || !tmpState.IDAssetType) { return; }
		if (!tmpState.Descriptor.MetadataSets.length)
		{
			tmpState.Error = 'There is no metadata shape to save yet. Add a metadata set (or pull one in from the library on the Asset Types screen) first.';
			this.render();
			return;
		}

		const tmpStructural = this._structuralProblems();
		if (tmpStructural) { tmpState.Error = tmpStructural; tmpState.Message = ''; this.render(); return; }

		const tmpManifest = this._mergedManifest(pStatus);
		const tmpProblem = this._problems(tmpManifest);
		if (tmpProblem) { tmpState.Error = tmpProblem; tmpState.Message = ''; this.render(); return; }

		tmpState.Saving = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		try
		{
			const tmpJSON = JSON.stringify(tmpManifest);
			// NO IDCustomer in this payload, ever. The server stamps it from the session and rejects a
			// value that disagrees with it.
			const tmpExistingStatus = this._storedStatus();
			let tmpVerb = '';
			if (tmpState.Row && (tmpExistingStatus !== 'published'))
			{
				const tmpResult = await this._put('AssetTypeManifest', { IDAssetTypeManifest: tmpState.Row.IDAssetTypeManifest, ManifestJSON: tmpJSON });
				if (tmpResult && tmpResult.Error) { throw new Error(tmpResult.Error); }
				tmpVerb = `version ${ tmpState.Row.Version } updated`;
			}
			else
			{
				const tmpVersion = tmpState.Versions.length ? (Math.max(...tmpState.Versions.map((pRow) => Number(pRow.Version) || 0)) + 1) : 1;
				const tmpResult = await this._post('AssetTypeManifest', { IDAssetType: tmpState.IDAssetType, Version: tmpVersion, ManifestJSON: tmpJSON });
				if (tmpResult && tmpResult.Error) { throw new Error(tmpResult.Error); }
				tmpVerb = `saved as version ${ tmpVersion }`;
			}

			// The dashboard caches the manifest fetch AND the normalized descriptor per (type, version).
			// Without this the rest of the session renders the shape that was there before this save.
			const tmpDescriptorProvider = this.pict.providers.AssetDescriptor;
			if (tmpDescriptorProvider && (typeof tmpDescriptorProvider.invalidate === 'function')) { tmpDescriptorProvider.invalidate(tmpState.IDAssetType); }

			await this.selectTypeAsync(tmpState.IDAssetType);
			tmpState.Message = (pStatus === 'published')
				? `Published — ${ tmpVerb }. Every ${ this.accessor.singularLabel.toLowerCase() } of this type now reads this shape.`
				: `Draft ${ tmpVerb }. Nothing on the dashboard changes until you publish it.`;
		}
		catch (pError)
		{
			tmpState.Error = `Save failed: ${ (pError && pError.message) || pError }`;
		}
		finally
		{
			// try/FINALLY. The sibling screen resets this only on the failure path, so its buttons never
			// come back after the first successful save.
			tmpState.Saving = false;
			this.render();
		}
	}

	/** The Status of the row as it is STORED, not as it has been edited on screen. */
	_storedStatus()
	{
		const tmpRaw = this.state.Raw;
		const tmpStatus = (tmpRaw && tmpRaw.Status) ? String(tmpRaw.Status) : '';
		return (tmpStatus === 'published') ? 'published' : 'draft';
	}

	openDashboard() { window.location.hash = '#/AssetDashboard'; }

	// ========================================================= render =========================================================

	render()
	{
		if (!this.pict.views.AssetTypeDescriptor) { return; }
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA.getElement(DETAIL_MOUNT).length) { return; }
		const tmpState = this.state;

		if (tmpState.Loading && !tmpState.Loaded) { tmpCA.assignContent(DETAIL_MOUNT, '<div class="atd-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>'); return; }
		if (tmpState.Loaded && !tmpState.Types.length)
		{
			tmpCA.assignContent(DETAIL_MOUNT, '<div class="atd-empty">There are no asset types yet. Add one from the library on the Asset Types screen first.</div>');
			return;
		}

		const tmpTypeOptions = tmpState.Types.map((pType) =>
			`<option value="${ Number(pType.IDAssetType) }"${ (Number(pType.IDAssetType) === Number(tmpState.IDAssetType)) ? ' selected' : '' }>${ this._esc(pType.Name || `Type ${ pType.IDAssetType }`) }</option>`).join('');

		const tmpSets = (tmpState.Descriptor && tmpState.Descriptor.MetadataSets) ? tmpState.Descriptor.MetadataSets : [];
		const tmpSetPicker = (tmpSets.length > 1)
			? `<span class="atd-bar-label">Set</span><select class="atd-select" onchange="_Pict.providers.AssetTypeDescriptor.setSetKey(this.value)">${
				tmpSets.map((pSet) => `<option value="${ this._esc(pSet.Key) }"${ (pSet.Key === tmpState.SetKey) ? ' selected' : '' }>${ this._esc(pSet.Label || pSet.Key) }</option>`).join('') }</select>`
			: '';

		const tmpHTML = `
			${ tmpState.Error ? `<div class="atd-error">${ this._esc(tmpState.Error) }</div>` : '' }
			${ tmpState.Message ? `<div class="atd-msg">${ this._esc(tmpState.Message) }</div>` : '' }
			<div class="atd-bar">
				${ this._fixedIDAssetType ? '' : '<span class="atd-bar-label">Asset type</span>' }
				${ this._fixedIDAssetType ? '' : `<select class="atd-select" onchange="_Pict.providers.AssetTypeDescriptor.selectTypeAsync(this.value)">${ tmpTypeOptions }</select>` }
				${ tmpSetPicker }${ this.canEdit() ? '<button class="atd-add" title="Add a metadata set" onclick="_Pict.providers.AssetTypeDescriptor.addMetadataSet()"><i class="fas fa-plus"></i> Set</button>' : '' }
				<span class="atd-spacer"></span>
				<span id="ATD-Status">${ this._statusHTML() }</span>
			</div>
			${ this._identityHTML() }
			<div class="atd-area-head">Fields <span class="atd-hint">— the eye shows a value on the asset detail panel; the chart makes it a map metric. Field codes are fixed: stored values bind to them.</span></div>
			<div class="atd-bar" style="border:0;padding:0;margin:0 0 0.5rem;">
				<input class="atd-input atd-input--md" placeholder="Filter by name or code…" value="${ this._esc(tmpState.Filter) }" oninput="_Pict.providers.AssetTypeDescriptor.setFilter(this.value)">
				${ this._defaultMetricHTML() }
			</div>
			<div id="ATD-Body" class="atd-body">${ this._bodyHTML() }</div>
			${ this._saveBarHTML() }`;
		tmpCA.assignContent(DETAIL_MOUNT, tmpHTML);
	}

	/** Repaint only the field list, keeping the scroll position — the list runs to 149 rows. */
	_repaintBody()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpMount = tmpCA.getElement(BODY_MOUNT);
		if (!tmpMount || !tmpMount.length) { this.render(); return; }
		let tmpScroll = 0;
		try { tmpScroll = tmpMount[0].scrollTop || 0; } catch (pError) { /* not a live DOM node */ }
		tmpCA.assignContent(BODY_MOUNT, this._bodyHTML());
		try { const tmpAfter = tmpCA.getElement(BODY_MOUNT); if (tmpAfter && tmpAfter.length) { tmpAfter[0].scrollTop = tmpScroll; } } catch (pError) { /* ditto */ }
		this._syncStatus();
	}

	/** Repaint the status pills alone — safe to call from a text input's oninput. */
	_syncStatus()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA.getElement(STATUS_MOUNT).length) { return; }
		tmpCA.assignContent(STATUS_MOUNT, this._statusHTML());
	}

	_statusHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Row && !tmpState.Descriptor) { return ''; }
		const tmpStored = this._storedStatus();
		const tmpParts = [];
		tmpParts.push(`<span class="atd-pill atd-pill--${ tmpStored }">${ tmpStored }</span>`);
		if (tmpState.Row) { tmpParts.push(`<span class="atd-pill">v${ tmpState.Row.Version }</span>`); }
		if (tmpState.Dirty) { tmpParts.push('<span class="atd-pill atd-pill--dirty">unsaved</span>'); }
		return tmpParts.join(' ');
	}

	_identityHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor) { return ''; }
		const tmpLabel = tmpState.Descriptor.AssetType.Label;
		return `<div class="atd-ident">
			<label class="atd-fieldwrap"><span class="atd-fieldwrap-label">One is called</span><input class="atd-input atd-input--md" value="${ this._esc(tmpLabel.Singular) }" oninput="_Pict.providers.AssetTypeDescriptor.setAssetLabel('Singular', this.value)"></label>
			<label class="atd-fieldwrap"><span class="atd-fieldwrap-label">Many are called</span><input class="atd-input atd-input--md" value="${ this._esc(tmpLabel.Plural) }" oninput="_Pict.providers.AssetTypeDescriptor.setAssetLabel('Plural', this.value)"></label>
		</div>`;
	}

	_defaultMetricHTML()
	{
		const tmpAccessor = this.accessor;
		const tmpGroups = tmpAccessor.metrics();
		if (!tmpGroups.length) { return '<span class="atd-hint">No map metrics chosen yet — turn on a chart icon to offer one.</span>'; }
		const tmpCurrent = this.state.Descriptor.Dashboard.DefaultMetric || '';
		const tmpOptions = tmpGroups.map((pGroup) => `<optgroup label="${ this._esc(pGroup.Group) }">${
			pGroup.Fields.map((pField) => `<option value="${ this._esc(pField.Code) }"${ (pField.Code === tmpCurrent) ? ' selected' : '' }>${ this._esc(pField.Label) }</option>`).join('') }</optgroup>`).join('');
		return `<span class="atd-bar-label">Map opens on</span><select class="atd-select" onchange="_Pict.providers.AssetTypeDescriptor.setDefaultMetric(this.value)"><option value="">Nothing</option>${ tmpOptions }</select>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return '<div class="atd-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>'; }
		const tmpCanEdit = this.canEdit();
		if (!tmpState.Descriptor || !tmpState.Descriptor.MetadataSets.length)
		{
			const tmpAddSet = tmpCanEdit ? `<div class="atd-body-actions"><button class="atd-add" onclick="_Pict.providers.AssetTypeDescriptor.addMetadataSet()"><i class="fas fa-plus"></i> Add a metadata set</button></div>` : '';
			return `<div class="atd-empty">This asset type has no metadata shape yet.<br>Add one from scratch, or pull one in from the library on the Asset Types screen.</div>${ tmpAddSet }`;
		}
		const tmpGroups = this.accessor.groups();
		// accessor.groups() drops zero-field groups, so union in the set's declared-but-empty sections
		// (a freshly added section has no fields yet) so they can still be edited.
		const tmpSet = this.set;
		if (tmpSet)
		{
			tmpSet.Groups.slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal)).forEach((pGroup) =>
			{
				if (!tmpGroups.some((pItem) => (pItem.Key === pGroup.Key))) { tmpGroups.push(Object.assign({}, pGroup, { Fields: [] })); }
			});
			tmpGroups.sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal));
		}
		const tmpAddSection = tmpCanEdit ? `<div class="atd-body-actions"><button class="atd-add" onclick="_Pict.providers.AssetTypeDescriptor.addGroup()"><i class="fas fa-plus"></i> Add section</button></div>` : '';
		// A brand-new, in-session set needs a KEY before it can be saved (its provisional key is blocked by the
		// save guard). Offer the key + optional label + remove here; it disappears once saved (reload strips _New).
		const tmpSetEditor = (tmpCanEdit && tmpSet && tmpSet._New) ? this._newSetEditorHTML(tmpSet) : '';
		if (!tmpGroups.length) { return tmpSetEditor + `<div class="atd-empty">This metadata set has no sections yet.</div>${ tmpAddSection }`; }
		const tmpHTML = tmpGroups.map((pGroup, pIndex) => this._groupHTML(pGroup, pIndex, tmpGroups.length)).join('');
		return tmpSetEditor + (tmpHTML || '<div class="atd-empty">Nothing matches that filter.</div>') + tmpAddSection;
	}

	/** Inline key/label/remove editor shown for a freshly-added (unsaved) metadata set. */
	_newSetEditorHTML(pSet)
	{
		const tmpKey = this._js(pSet.Key);
		const tmpLabelVal = (pSet.Label && !this._isProvisional(pSet.Label)) ? pSet.Label : '';
		return `<div class="atd-newset">
			<span class="atd-newset-l">New set — give it a key before saving</span>
			<input class="atd-input atd-input--md atd-code--edit" placeholder="set key (e.g. CulvertInspection)" value="${ this._esc(this._isProvisional(pSet.Key) ? '' : pSet.Key) }" onchange="_Pict.providers.AssetTypeDescriptor.setNewSetKey('${ tmpKey }', this.value)">
			<input class="atd-input atd-input--md" placeholder="label (optional)" value="${ this._esc(tmpLabelVal) }" oninput="_Pict.providers.AssetTypeDescriptor.setSetLabel('${ tmpKey }', this.value)">
			<button class="atd-del" title="Remove this set" onclick="_Pict.providers.AssetTypeDescriptor.removeMetadataSet('${ tmpKey }')"><i class="fas fa-trash"></i></button>
		</div>`;
	}

	_matches(pField)
	{
		const tmpFilter = String(this.state.Filter || '').trim().toLowerCase();
		if (!tmpFilter) { return true; }
		return ((String(pField.Label || '').toLowerCase().indexOf(tmpFilter) > -1) || (String(pField.Code || '').toLowerCase().indexOf(tmpFilter) > -1));
	}

	/** <option> list for the field DataType select, from the module's single source of truth. */
	_dataTypeOptions(pCurrent)
	{
		const tmpLabels = { enum: 'Coded list', string: 'Short text', text: 'Long text', number: 'Number', integer: 'Whole number', date: 'Date', boolean: 'Yes / No' };
		return libAssetDescriptor.DATA_TYPES.map((pType) => `<option value="${ pType }"${ (pType === pCurrent) ? ' selected' : '' }>${ tmpLabels[pType] || pType }</option>`).join('');
	}

	_groupHTML(pGroup, pIndex, pCount)
	{
		const tmpFields = pGroup.Fields.filter((pField) => this._matches(pField));
		const tmpFiltering = (String(this.state.Filter || '').trim().length > 0);
		// Hide a section with no matches WHILE filtering; otherwise keep empty sections so they can be edited.
		if (!tmpFields.length && tmpFiltering) { return ''; }
		const tmpKey = this._js(pGroup.Key);
		const tmpShown = pGroup.Fields.filter((pField) => pField.Visible).length;
		const tmpSet = this.set;
		const tmpGroupObj = tmpSet ? tmpSet.Groups.find((pItem) => (pItem.Key === pGroup.Key)) : null;
		const tmpIsNew = !!(tmpGroupObj && tmpGroupObj._New);
		const tmpCanEdit = this.canEdit();
		const tmpKeyCell = tmpIsNew
			? `<input class="atd-grp-key atd-grp-key--edit" placeholder="section key" value="${ this._esc(pGroup.Key) }" onchange="_Pict.providers.AssetTypeDescriptor.setNewGroupKey('${ tmpKey }', this.value)">`
			: `<span class="atd-grp-key" title="Section key — fixed">${ this._esc(pGroup.Key || '—') }</span>`;
		// Field add / section remove only for real declared sections (not the synthesized "Other" bucket).
		const tmpAddRemove = (tmpCanEdit && tmpGroupObj)
			? `<button class="atd-add atd-add--sm" title="Add a field to this section" onclick="_Pict.providers.AssetTypeDescriptor.addField('${ tmpKey }')"><i class="fas fa-plus"></i> Field</button><button class="atd-del" title="Remove this section" onclick="_Pict.providers.AssetTypeDescriptor.removeGroup('${ tmpKey }')"><i class="fas fa-trash"></i></button>`
			: '';
		// The synthesized "Other"/ungrouped bucket is not a declared group: its label can't be renamed and it
		// can't be reordered (both setters key off declared Groups), so render those controls inert-free.
		const tmpLabelCell = tmpGroupObj
			? `<input class="atd-grp-label" value="${ this._esc(this._cleanLabel(tmpGroupObj)) }" title="Rename this section" oninput="_Pict.providers.AssetTypeDescriptor.setGroupLabel('${ tmpKey }', this.value)">`
			: `<span class="atd-grp-label atd-grp-label--ro" title="Fields with no section">${ this._esc(pGroup.Label || 'Other') }</span>`;
		const tmpMoveCells = tmpGroupObj
			? `<button class="atd-mv" title="Move section up" ${ (pIndex === 0) ? 'disabled' : '' } onclick="_Pict.providers.AssetTypeDescriptor.moveGroup('${ tmpKey }', -1)"><i class="fas fa-chevron-up"></i></button><button class="atd-mv" title="Move section down" ${ (pIndex >= (pCount - 1)) ? 'disabled' : '' } onclick="_Pict.providers.AssetTypeDescriptor.moveGroup('${ tmpKey }', 1)"><i class="fas fa-chevron-down"></i></button>`
			: '';
		return `<div class="atd-grp">
			<div class="atd-grp-head">
				${ tmpKeyCell }
				${ tmpLabelCell }
				<span class="atd-grp-count">${ tmpShown } of ${ pGroup.Fields.length } shown</span>
				<button class="atd-grp-bulk" onclick="_Pict.providers.AssetTypeDescriptor.setGroupVisible('${ tmpKey }', true)">Show all</button>
				<button class="atd-grp-bulk" onclick="_Pict.providers.AssetTypeDescriptor.setGroupVisible('${ tmpKey }', false)">Hide all</button>
				${ tmpMoveCells }
				${ tmpAddRemove }
			</div>
			${ tmpFields.map((pField) => this._rowHTML(pField)).join('') }
		</div>`;
	}

	_rowHTML(pField)
	{
		const tmpCode = this._js(pField.Code);
		const tmpExpanded = !!this.state.Expanded[pField.Code];
		const tmpIsNew = !!pField._New;
		const tmpCanEdit = this.canEdit();
		const tmpCodeCell = tmpIsNew
			? `<input class="atd-code atd-code--edit" placeholder="field code" value="${ this._esc(pField.Code) }" onchange="_Pict.providers.AssetTypeDescriptor.setNewCode('${ tmpCode }', this.value)">`
			: `<span class="atd-code" title="Field code ${ this._esc(pField.Code) } — fixed, because stored values bind to it">${ this._esc(pField.Code) }</span>`;
		const tmpTypeCell = tmpIsNew
			? `<select class="atd-type-edit"${ pField.Values.length ? ' disabled title="Clear the coded values to change the type"' : '' } onchange="_Pict.providers.AssetTypeDescriptor.setDataType('${ tmpCode }', this.value)">${ this._dataTypeOptions(pField.DataType) }</select>`
			: `<span class="atd-type">${ this._esc(pField.DataType) }</span>`;
		const tmpRemove = tmpCanEdit ? `<button class="atd-del" title="Remove this field" onclick="_Pict.providers.AssetTypeDescriptor.removeField('${ tmpCode }')"><i class="fas fa-trash"></i></button>` : '';
		return `<div class="atd-row${ pField.Visible ? '' : ' is-hidden' }">
			<span class="atd-toggles">
				<button class="atd-tg${ pField.Visible ? ' is-on-eye' : '' }" title="${ pField.Visible ? 'Shown on the detail panel — click to hide' : 'Hidden — click to show' }" onclick="_Pict.providers.AssetTypeDescriptor.toggleVisible('${ tmpCode }')"><i class="fas fa-${ pField.Visible ? 'eye' : 'eye-slash' }"></i></button>
				<button class="atd-tg${ pField.Metric ? ' is-on' : '' }" title="${ pField.Metric ? 'The map can colour by this — click to stop' : 'Make this a map metric' }" onclick="_Pict.providers.AssetTypeDescriptor.toggleMetric('${ tmpCode }')"><i class="fas fa-chart-simple"></i></button>
			</span>
			${ tmpCodeCell }
			<input class="atd-label" value="${ this._esc(this._cleanLabel(pField)) }" oninput="_Pict.providers.AssetTypeDescriptor.setLabel('${ tmpCode }', this.value)">
			<input class="atd-units" placeholder="units" value="${ this._esc(pField.Units || '') }" oninput="_Pict.providers.AssetTypeDescriptor.setUnits('${ tmpCode }', this.value)">
			${ tmpTypeCell }
			<span class="atd-rowacts">
				<button class="atd-mv" title="Move up" onclick="_Pict.providers.AssetTypeDescriptor.moveField('${ tmpCode }', -1)"><i class="fas fa-chevron-up"></i></button>
				<button class="atd-mv" title="Move down" onclick="_Pict.providers.AssetTypeDescriptor.moveField('${ tmpCode }', 1)"><i class="fas fa-chevron-down"></i></button>
				<button class="atd-tg${ tmpExpanded ? ' is-on' : '' }" title="Help text, formatting and value names" onclick="_Pict.providers.AssetTypeDescriptor.toggleExpand('${ tmpCode }')"><i class="fas fa-gear"></i></button>
				${ tmpRemove }
			</span>
		</div>${ tmpExpanded ? this._advancedHTML(pField) : '' }`;
	}

	_advancedHTML(pField)
	{
		const tmpCode = this._js(pField.Code);
		const tmpNumeric = ((pField.DataType === 'number') || (pField.DataType === 'integer'));
		const tmpString = ((pField.DataType === 'string') || (pField.DataType === 'text'));
		const tmpCanEdit = this.canEdit();
		const tmpDisplayOptions = libAssetDescriptor.VALUE_DISPLAYS.map((pDisplay) =>
			`<option value="${ pDisplay }"${ (pField.Format.ValueDisplay === pDisplay) ? ' selected' : '' }>${ ({ 'label-only': 'Meaning only', 'code-and-label': 'Code and meaning', 'raw': 'Raw value' })[pDisplay] || pDisplay }</option>`).join('');
		// Show the values editor whenever the field is (or is becoming) an enum, so a new enum can get its first value.
		const tmpShowValues = ((pField.DataType === 'enum') || (pField.Values.length > 0));
		const tmpOrdered = pField.Values.slice().sort((pLeft, pRight) => (pLeft.Ordinal - pRight.Ordinal));
		const tmpValueRows = tmpOrdered.map((pValue, pValueIndex) =>
		{
			const tmpValueJS = this._js(pValue.Value);
			const tmpValueCode = (tmpCanEdit && pValue._New)
				? `<input class="atd-val-code atd-val-code--edit" placeholder="code" value="${ this._esc(pValue.Value) }" onchange="_Pict.providers.AssetTypeDescriptor.setNewValueCode('${ tmpCode }', '${ tmpValueJS }', this.value)">`
				: `<span class="atd-val-code">${ this._esc(pValue.Value) }</span>`;
			const tmpValueActs = tmpCanEdit
				? `<button class="atd-val-mv" title="Move up" ${ (pValueIndex === 0) ? 'disabled' : '' } onclick="_Pict.providers.AssetTypeDescriptor.moveValue('${ tmpCode }', '${ tmpValueJS }', -1)"><i class="fas fa-chevron-up"></i></button><button class="atd-val-mv" title="Move down" ${ (pValueIndex >= (tmpOrdered.length - 1)) ? 'disabled' : '' } onclick="_Pict.providers.AssetTypeDescriptor.moveValue('${ tmpCode }', '${ tmpValueJS }', 1)"><i class="fas fa-chevron-down"></i></button><button class="atd-val-del" title="Remove this value" onclick="_Pict.providers.AssetTypeDescriptor.removeValue('${ tmpCode }', '${ tmpValueJS }')"><i class="fas fa-xmark"></i></button>`
				: '';
			return `<div class="atd-val">${ tmpValueCode }<input class="atd-val-label" value="${ this._esc(this._cleanLabel(pValue)) }" oninput="_Pict.providers.AssetTypeDescriptor.setValueLabel('${ tmpCode }', '${ tmpValueJS }', this.value)">${ tmpValueActs }</div>`;
		}).join('');
		const tmpValues = tmpShowValues
			? `<div class="atd-vals"><div class="atd-vals-h">What each code means</div>${ tmpValueRows }${ tmpCanEdit ? `<button class="atd-val-add" onclick="_Pict.providers.AssetTypeDescriptor.addValue('${ tmpCode }')"><i class="fas fa-plus"></i> Add value</button>` : '' }</div>`
			: '';
		const tmpRequired = `<label class="atd-fieldwrap atd-fieldwrap--chk"><span class="atd-fieldwrap-label">Required</span><input type="checkbox" ${ pField.Constraints.Required ? 'checked' : '' } onchange="_Pict.providers.AssetTypeDescriptor.setConstraint('${ tmpCode }', 'Required', this.checked)"></label>`;
		const tmpMaxLength = tmpString ? `<label class="atd-fieldwrap"><span class="atd-fieldwrap-label">Max length</span><input class="atd-input atd-input--sm" type="number" min="0" value="${ (pField.Constraints.MaxLength == null) ? '' : pField.Constraints.MaxLength }" onchange="_Pict.providers.AssetTypeDescriptor.setConstraint('${ tmpCode }', 'MaxLength', this.value)"></label>` : '';
		const tmpMinMax = tmpNumeric ? `<label class="atd-fieldwrap"><span class="atd-fieldwrap-label">Min</span><input class="atd-input atd-input--sm" type="number" value="${ (pField.Constraints.Min == null) ? '' : pField.Constraints.Min }" onchange="_Pict.providers.AssetTypeDescriptor.setConstraint('${ tmpCode }', 'Min', this.value)"></label><label class="atd-fieldwrap"><span class="atd-fieldwrap-label">Max</span><input class="atd-input atd-input--sm" type="number" value="${ (pField.Constraints.Max == null) ? '' : pField.Constraints.Max }" onchange="_Pict.providers.AssetTypeDescriptor.setConstraint('${ tmpCode }', 'Max', this.value)"></label>` : '';
		return `<div class="atd-adv">
			<div class="atd-adv-grid">
				${ pField.Values.length ? `<label class="atd-fieldwrap"><span class="atd-fieldwrap-label">Show coded values as</span><select class="atd-select" onchange="_Pict.providers.AssetTypeDescriptor.setValueDisplay('${ tmpCode }', this.value)">${ tmpDisplayOptions }</select></label>` : '' }
				${ tmpNumeric ? `<label class="atd-fieldwrap"><span class="atd-fieldwrap-label">Decimal places</span><input class="atd-input atd-input--sm" type="number" min="0" max="8" value="${ (pField.Format.Decimals == null) ? '' : pField.Format.Decimals }" oninput="_Pict.providers.AssetTypeDescriptor.setDecimals('${ tmpCode }', this.value)"></label>` : '' }
				${ tmpRequired }
				${ tmpMaxLength }
				${ tmpMinMax }
			</div>
			<textarea class="atd-help" placeholder="Help text — shown as the tooltip wherever this value appears." oninput="_Pict.providers.AssetTypeDescriptor.setHelp('${ tmpCode }', this.value)">${ this._esc(pField.Help) }</textarea>
			${ tmpValues }
		</div>`;
	}

	_saveBarHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Descriptor || !tmpState.Descriptor.MetadataSets.length) { return ''; }
		const tmpBytes = libAssetDescriptor.serializedByteLength(this._mergedManifest(this._storedStatus()));
		const tmpOver = (tmpBytes > TEXT_BYTES);
		const tmpSizeNote = tmpOver
			? `${ tmpBytes.toLocaleString() } bytes — over the old TEXT limit, so this column must already be MEDIUMTEXT`
			: `${ tmpBytes.toLocaleString() } bytes`;
		const tmpDisabled = tmpState.Saving ? 'disabled' : '';
		const tmpCanEdit = this.canEdit();
		if (!tmpCanEdit) { return '<div class="atd-warn">You do not have permission to change asset metadata shapes.</div>'; }
		const tmpWarnings = this._warnings();
		return `<div class="atd-savebar">
			<button class="atd-save atd-save--primary" ${ tmpDisabled } onclick="_Pict.providers.AssetTypeDescriptor.publishAsync()">${ tmpState.Saving ? 'Saving…' : 'Publish' }</button>
			<button class="atd-save" ${ tmpDisabled } onclick="_Pict.providers.AssetTypeDescriptor.saveDraftAsync()">Save as draft</button>
			<button class="atd-save" onclick="_Pict.providers.AssetTypeDescriptor.openDashboard()">Open the dashboard</button>
			<span class="atd-size${ tmpOver ? ' is-over' : '' }">${ this._esc(tmpSizeNote) }</span>
		</div>
		${ (this._storedStatus() === 'published') ? '<div class="atd-warn">This version is published and is what every asset of this type reads right now. Publishing again writes a new version rather than changing it underneath them.</div>' : '' }
		${ tmpWarnings.length ? `<div class="atd-warn">${ tmpWarnings.map((pWarning) => this._esc(pWarning)).join('<br>') }</div>` : '' }`;
	}
}

module.exports = AssetTypeDescriptorProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'AssetTypeDescriptor',
	AutoInitialize: true,
	AutoInitializeOrdinal: 232,
};

},{"../assets/AssetDescriptor.js":1070,"pict-provider":845}],1306:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');

/**
 * AssetTypeWorkspaceProvider — the engine behind the unified AssetType workspace
 * (#/AssetType/Workspace/:ID[/:Tab]), bridged over /PSRS/AssetType/View/:GUID. It folds the asset type's
 * three former screens into one page:
 *   • Overview       — inline edit of Name / Description (the master-list columns).
 *   • Metadata Shape — embeds the existing AssetTypeDescriptor editor (authoring + display tailoring),
 *                      scoped to this type via openInto(IDAssetType). See [[AssetTypeDescriptor-Provider.js]].
 *
 * The legacy flat #/AssetTypeManifests editor is retired; everything an admin needs for a type now lives
 * here. Config in [[AssetType.config.js]]; modeled on [[AssetWorkspace-Provider.js]].
 */
class AssetTypeWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._ovMsg = ''; this._ovErr = ''; this._ovSaving = false;
	}

	_val(pSel) { const CA = this.pict.ContentAssignment; const el = CA && CA.getElement(pSel); return (el && el.length) ? el[0].value : ''; }
	get _canEdit() { return this.can('AssetType', 'Update') || this.can('AssetType', 'Create'); }

	_overviewHTML()
	{
		const a = this._record || {};
		const ro = !this._canEdit;
		const tmpMsg = this._ovMsg ? `<div class="atw-msg">${ this._esc(this._ovMsg) }</div>` : '';
		const tmpErr = this._ovErr ? `<div class="atw-err">${ this._esc(this._ovErr) }</div>` : '';
		return `${ tmpErr }${ tmpMsg }<div class="atw-form">
			<div class="atw-field"><span class="atw-label">Name</span><input id="ATW-Name" class="atw-in" ${ ro ? 'disabled' : '' } value="${ this._esc(a.Name || '') }"></div>
			<div class="atw-field"><span class="atw-label">Description</span><textarea id="ATW-Desc" class="atw-in atw-ta" ${ ro ? 'disabled' : '' }>${ this._esc(a.Description || '') }</textarea></div>
			${ ro ? '<div class="atw-hint">Read-only — editing an asset type needs a super-user or customer-admin.</div>' : `<div class="atw-actions"><button class="atw-btn" ${ this._ovSaving ? 'disabled' : '' } onclick="_Pict.providers.AssetTypeWorkspace.saveOverviewAsync()">${ this._ovSaving ? 'Saving…' : 'Save' }</button></div>` }
		</div>
		<div class="atw-note"><i class="fas fa-circle-info"></i> Define this type's custom properties and how they display on the <b>Metadata Shape</b> tab.</div>`;
	}

	async saveOverviewAsync()
	{
		if (this._ovSaving || !this._canEdit || !this.idRecord) { return; }
		// Read the inputs BEFORE repainting — repaintBody rebuilds the fields from _record and would discard the edits.
		const tmpName = String(this._val('#ATW-Name') || '').trim();
		const tmpDesc = String(this._val('#ATW-Desc') || '');
		this._ovSaving = true; this._ovErr = ''; this._ovMsg = ''; this.repaintBody();
		// NO IDCustomer in the payload — the server stamps it from the session.
		const r = await this._putJSON('AssetType', { IDAssetType: this.idRecord, Name: tmpName, Description: tmpDesc });
		this._ovSaving = false;
		if (r && r.error) { this._ovErr = `Save failed: ${ (r.error && r.error.message) || r.error }`; this.repaintBody(); return; }
		this._record.Name = tmpName; this._record.Description = tmpDesc; this._ovMsg = 'Saved.';
		this.renderWorkspace();
	}
}

module.exports = AssetTypeWorkspaceProvider;
module.exports.default_configuration = { ProviderIdentifier: 'AssetTypeWorkspace', AutoInitialize: true, AutoInitializeOrdinal: 231 };

},{"pict-section-workspace":1049}],1307:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

/**
 * AssetWorkspaceProvider — the engine behind the unified Asset view (#/Asset/Workspace/:ID[/:Tab]), a subclass
 * of the pict-section-workspace base. The base owns the shell (header, tab bar, routing, load); this subclass
 * keeps Asset's bespoke tab bodies (all `render` kind): Overview · Location (interactive Leaflet map, reusing
 * ProjectCenterMap) · Elements · Defects · Observations · Documents · Migrate (single-asset legacy→modern
 * element migration). Config in [[Asset.config.js]].
 *
 * ELEMENT MANAGEMENT (AASHTO element-level inspection). The Elements tab is a master→detail editor for a
 * super-user / customer-admin:
 *   • master — the asset's PhysicalAssetElement instances (add from the element-type catalog / soft-remove),
 *     each row showing its latest condition's CS1–4 distribution.
 *   • detail — one element's full record: inline Quantity edit; the per-year CONDITION history
 *     (PhysicalAssetElementCondition, CS1–4 + total per Year, add/edit/remove); and the DEFECTS recorded
 *     against the element (PhysicalAssetElementPhysicalAssetDefectJoin), each with its own per-year CS1–4
 *     breakdown (add from the element-type's defect catalog / edit / soft-remove).
 * The condition breakdown lives in PhysicalAssetElementCondition.QuantitiesJSON; the per-defect breakdown lives
 * in the element↔defect join's QuantitiesJSON/TotalQuantity/Year (columns added to that join — a bare link
 * before — so a defect carries the AASHTO condition-state quantities it accounts for). See the schema change in
 * web/contract_admin/schema/MeadowSchema-PhysicalAssetElementPhysicalAssetDefectJoin.json.
 *
 * The map reuses the app's ProjectCenterMap via a third instance (AssetLocationMap, ProviderName='AssetWorkspace',
 * MapHostID='AW-MapHost'); this provider therefore implements the map contract (center / hasCenter / setCenter)
 * exactly like ProjectWorkspace, and setCenter does a LIGHT readout update (never a full body re-render) so a
 * marker drag never tears the live map down. The map is (re)mounted from the Location tab's OnEnter hook.
 */
class AssetWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._asset = null;
		this._typeName = '';
		this._classificationName = '';
		this._center = { Latitude: null, Longitude: null };
		this._centerDirty = false;
		this._locError = '';
		this._tabs = {};      // per-tab loaded data cache
		this._migrate = { Plan: null, Applying: false, Result: null, Confirming: false, Error: '' };
		this._elementDetail = null;   // the open element (master→detail) or null
		this._condEdit = null;        // { ID } — the condition being added (ID 0) / edited, or null
		this._defEdit = null;         // { ID, IDDefect, Label } — the defect-on-element being added (ID 0) / edited, or null
		this._confirm = null;         // { kind:'element'|'condition'|'defect', id } — inline delete confirm
		this._elemError = '';         // last element/condition/defect write error (shown in the Elements tab)
		this._customProps = null;     // { Loaded, HasShape, Accessor, Values:{setKey:{addr:val}}, RowIDs, Error, FromFallback } — Overview custom-property render
		this._cpEdit = null;          // { On, Draft:{code:val}, Saving, Error } — per-asset custom-property VALUE edit mode
	}

	get currentUser() { return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {}; }
	get customerName() { return this.currentUser.CustomerName || ('Customer ' + this.currentUser.CustomerID); }
	get idCustomer() { return Number(this.currentUser.CustomerID) || (this._asset && this._asset.IDCustomer) || 0; }
	get isSuperUser() { const u = this.currentUser; return (Number(u.UserRoleIndex) === 5) && (Number(u.CustomerID) === 1); }
	get hasCustomerAdmin() { const r = this.currentUser.UserRoles; return Array.isArray(r) && r.some((x) => x && (x.PermissionLevel === 'CustomerAdmin' || x.PermissionLevel === 'SuperAdminUser')); }
	get canEdit() { return this.isSuperUser || this.hasCustomerAdmin; }
	get idAsset() { return this._asset ? this._asset.IDPhysicalAsset : null; }
	get providerName() { return this.identifier || 'AssetWorkspace'; }

	// Map contract (consumed by the AssetLocationMap ProjectCenterMap instance).
	get center() { return this._center; }
	get hasCenter() { return (this._center.Latitude != null) && (this._center.Longitude != null) && !((Number(this._center.Latitude) === 0) && (Number(this._center.Longitude) === 0)); }

	// --- REST helpers (reject-on-error variants the Asset loaders were written against) ---
	_get(pURI) { return new Promise((res, rej) => this.restClient.getJSON(pURI, (e, b) => e ? rej(e) : res(b))); }
	_post(pURI, pBody) { return new Promise((res, rej) => this.restClient.postJSON(pURI, pBody, (e, b) => e ? rej(e) : res(b))); }
	_put(pURI, pBody) { return new Promise((res, rej) => this.restClient.putJSON(pURI, pBody, (e, b) => e ? rej(e) : res(b))); }
	// DELETE a single entity row (soft-delete where the schema has a Deleted column). Mirrors the Inspection
	// workspace: prefer the rest client's deleteEntity, fall back to a raw DELETE.
	_del(pURI)
	{
		return new Promise((res, rej) =>
		{
			const m = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURI));
			if (m && this.restClient && (typeof this.restClient.deleteEntity === 'function')) { this.restClient.deleteEntity(m[1], m[2], (e, b) => e ? rej(e) : res(b)); return; }
			const tmpBase = (this.restClient && this.restClient.serverURL) || '/1.0/';
			fetch(`${tmpBase}${pURI}`, { method: 'DELETE', credentials: 'include' })
				.then((r) => { if (!r.ok) { rej(new Error(`HTTP ${r.status}`)); return; } r.text().then((t) => res(t ? JSON.parse(t) : {})).catch(() => res({})); })
				.catch(rej);
		});
	}
	async _getAllPages(pURI, pPage = 250)
	{
		const tmpOut = []; let o = 0;
		for (;;) { const rows = await this._get(`${pURI}/${o}/${pPage}`); if (!Array.isArray(rows) || rows.length === 0) { break; } tmpOut.push(...rows); if (rows.length < pPage) { break; } o += pPage; if (o > 200000) { break; } }
		return tmpOut;
	}
	static _index(pRows, pKey) { const m = {}; (pRows || []).forEach((r) => { if (r && r[pKey] != null) { m[String(r[pKey])] = r; } }); return m; }
	_n(v) { const n = Number(v); return Number.isNaN(n) ? '—' : n.toLocaleString('en-US'); }
	_num0(v) { const n = Number(v); return Number.isNaN(n) ? 0 : n; }
	_val(pSel) { const CA = this.pict.ContentAssignment; const el = CA && CA.getElement(pSel); return (el && el.length) ? el[0].value : ''; }
	// Escape for a single-quoted JS string arg inside a double-quoted HTML attribute (field codes are authored).
	_js(pStr) { return String(pStr == null ? '' : pStr).replace(/&/g, '&amp;').replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;'); }
	// Meadow serves a `<col>JSON` column read as the parsed object under the un-suffixed name (Quantities),
	// while accepting writes under either name. Read Quantities; fall back to parsing the raw string.
	_normalizeCS(pRow)
	{
		if (!pRow) { return null; }
		if (pRow.Quantities && typeof pRow.Quantities === 'object') { return pRow.Quantities; }
		const raw = pRow.Quantities || pRow.QuantitiesJSON; if (!raw) { return null; }
		try { return JSON.parse(raw); } catch (e) { return null; }
	}

	// --- hydrate (runs inside the base load, after the PhysicalAsset record arrives) ---
	async hydrateAsync(pRecord)
	{
		this._asset = pRecord;
		this._tabs = {};
		this._migrate = { Plan: null, Applying: false, Result: null, Confirming: false, Error: '' };
		this._elementDetail = null; this._condEdit = null; this._defEdit = null; this._confirm = null; this._elemError = '';
		this._center = { Latitude: pRecord.OriginLatitude != null ? Number(pRecord.OriginLatitude) : null, Longitude: pRecord.OriginLongitude != null ? Number(pRecord.OriginLongitude) : null };
		this._centerDirty = false;
		if (this.pict && this.pict.AppData) { this.pict.AppData.AssetWorkspace = this.pict.AppData.AssetWorkspace || {}; }
		// FK name lookups (may be owned by a shared/platform customer → not readable → fall back to the id).
		this._typeName = await this._lookupName('AssetType', pRecord.IDAssetType, 'Name');
		this._classificationName = await this._lookupName('AssetClassification', pRecord.IDAssetClassification, 'Name');
		// Stash the resolved names on the record so the base header Subtitle(rec) can read them.
		pRecord.__typeName = this._typeName;
		pRecord.__classificationName = this._classificationName;
		// Resolve the type's published metadata shape + this asset's stored values for the Overview panel.
		await this._loadCustomPropsAsync();
	}

	// Load this asset type's published descriptor (if any) + this asset's PhysicalAssetMetadata values, for a
	// read-only custom-property panel on the Overview. Non-fatal: a failure leaves the rest of the workspace intact.
	async _loadCustomPropsAsync()
	{
		this._cpEdit = null;
		this._customProps = { Loaded: false, HasShape: false, Accessor: null, Values: {}, RowIDs: {}, Error: '', FromFallback: false };
		try
		{
			const tmpProv = this.pict.providers && this.pict.providers.AssetDescriptor;
			if (!tmpProv || (typeof tmpProv.accessorForTypeAsync !== 'function')) { this._customProps.Loaded = true; return; }
			const tmpIDType = this._asset.IDAssetType;
			const tmpVersion = this._asset.ManifestVersion;
			const tmpRows = await this._getAllPages(`PhysicalAssetMetadatas/FilteredTo/FBV~IDPhysicalAsset~EQ~${this.idAsset}~FBV~Deleted~EQ~0`);
			const tmpBySet = {}; const tmpRowIDs = {};
			tmpRows.forEach((r) => { const s = r.MetadataSetGUID || ''; const a = r.Address; if (a == null) { return; } (tmpBySet[s] = tmpBySet[s] || {})[a] = (r.Value != null && r.Value !== '') ? r.Value : r.MetadataValue; (tmpRowIDs[s] = tmpRowIDs[s] || {})[a] = r.IDPhysicalAssetMetadata; });
			const tmpDescriptor = await tmpProv.descriptorForTypeAsync(tmpIDType, tmpVersion);
			// Render when the type has an authored (published) shape, OR when the asset simply has stored values —
			// bridges carry SNBI data the compiled-in fallback vocabulary decodes. Otherwise there is nothing to show.
			if (!tmpDescriptor && !tmpRows.length) { this._customProps.Loaded = true; return; }
			const tmpAccessor = await tmpProv.accessorForTypeAsync(tmpIDType, { ManifestVersion: tmpVersion });
			this._customProps = { Loaded: true, HasShape: true, Accessor: tmpAccessor, Values: tmpBySet, RowIDs: tmpRowIDs, Error: '', FromFallback: !tmpDescriptor };
		}
		catch (e) { this._customProps = { Loaded: true, HasShape: false, Accessor: null, Values: {}, Error: (e && e.message) || String(e), FromFallback: false }; }
	}

	// The Overview's custom-property panel: the type's visible fields (primary set) with this asset's values,
	// read-only (editing the SHAPE is on the AssetType workspace; per-asset value editing is a later piece).
	_customPropsHTML()
	{
		const cp = this._customProps;
		if (!cp || !cp.Loaded) { return `<div class="aw-cp-note"><i class="fas fa-circle-notch fa-spin"></i> Loading custom properties…</div>`; }
		if (cp.Error) { return `<div class="aw-cp-note">Custom properties could not be loaded — ${this._esc(cp.Error)}</div>`; }
		const tmpIDType = this._asset && this._asset.IDAssetType;
		if (!cp.HasShape || !cp.Accessor)
		{
			const tmpLink = tmpIDType ? ` <a class="aw-link" href="#/AssetType/Workspace/${tmpIDType}/metadata">Define it</a>` : '';
			return `<div class="aw-cp-note"><i class="fas fa-circle-info"></i> No custom-property shape published for this asset type, and no values recorded for this asset yet.${tmpLink}</div>`;
		}
		const acc = cp.Accessor;
		const tmpVals = (cp.Values && cp.Values[acc.setKey]) || {};
		const tmpGroups = acc.visibleGroups();
		// With an authored shape, show every declared visible field (blank → "—"). With only the fallback
		// vocabulary (e.g. a bridge's SNBI data, no custom shape), show only the fields the asset has values for,
		// so the panel is the asset's data — not a 150-row dump of the whole standard dictionary.
		const tmpEditing = !!(this._cpEdit && this._cpEdit.On);
		// Value editing is offered only for an AUTHORED shape (the SNBI fallback is inspection/ingested data).
		const tmpCanEditValues = this.canEdit && !cp.FromFallback;
		const tmpOnlyPopulated = !!cp.FromFallback && !tmpEditing;
		const tmpBlocks = tmpGroups.map((g) =>
		{
			let tmpFields = g.Fields;
			if (tmpOnlyPopulated) { tmpFields = tmpFields.filter((f) => { const raw = tmpVals[f.Code]; return (raw != null && raw !== ''); }); }
			if (!tmpFields.length) { return ''; }
			const tmpRows = tmpFields.map((f) =>
			{
				if (tmpEditing)
				{
					return `<div class="aw-field"><div class="aw-field-label">${this._esc(f.Label)}${f.Units ? ` <span class="aw-muted">(${this._esc(f.Units)})</span>` : ''}${(f.Constraints && f.Constraints.Required) ? ' <span class="aw-req" title="Required">*</span>' : ''}</div><div class="aw-field-value">${this._cpFieldEditHTML(f)}</div></div>`;
				}
				const raw = tmpVals[f.Code];
				const shown = (raw == null || raw === '') ? '<span class="aw-muted">—</span>' : this._esc(acc.readable(f.Code, raw));
				return `<div class="aw-field"><div class="aw-field-label">${this._esc(f.Label)}${f.Units ? ` <span class="aw-muted">(${this._esc(f.Units)})</span>` : ''}</div><div class="aw-field-value">${shown}</div></div>`;
			}).join('');
			return `<div class="aw-cp-group"><div class="aw-cp-group-h">${this._esc(g.Label)}</div><div class="aw-fields">${tmpRows}</div></div>`;
		}).filter(Boolean).join('');
		if (!tmpBlocks && !tmpEditing) { return `<div class="aw-cp-note"><i class="fas fa-circle-info"></i> No custom-property values recorded for this asset yet.${tmpCanEditValues ? ' <a class="aw-link" onclick="_Pict.providers.AssetWorkspace.startCPEdit()">Add values</a>' : ''}${tmpIDType ? ` · <a class="aw-link" href="#/AssetType/Workspace/${tmpIDType}/metadata">Define its shape</a>` : ''}</div>`; }
		const tmpErr = (tmpEditing && this._cpEdit.Error) ? `<div class="aw-error" style="margin:0.5rem 0 0">${this._esc(this._cpEdit.Error)}</div>` : '';
		const tmpActions = tmpEditing
			? `<span class="aw-cp-actions"><button class="aw-btn aw-btn-primary aw-btn-sm" ${this._cpEdit.Saving ? 'disabled' : ''} onclick="_Pict.providers.AssetWorkspace.saveCPValuesAsync()">${this._cpEdit.Saving ? 'Saving…' : 'Save values'}</button><button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.cancelCPEdit()">Cancel</button></span>`
			: `<span class="aw-cp-actions">${tmpCanEditValues ? `<button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.startCPEdit()"><i class="fas fa-pen"></i> Edit values</button>` : ''}${tmpIDType ? ` <a class="aw-link aw-cp-edit" href="#/AssetType/Workspace/${tmpIDType}/metadata">Edit shape</a>` : ''}</span>`;
		return `<div class="aw-cp-head">Custom properties<span class="aw-muted"> · ${this._esc(acc.setLabel)}</span>${tmpActions}</div>${tmpErr}${tmpBlocks}`;
	}

	// --- per-asset custom-property VALUE editing (authored shapes only; upserts PhysicalAssetMetadata) ---
	_repaintOverview() { this.repaintBody(); this._scheduleCPMount(); }
	_scheduleCPMount() { try { setTimeout(() => this._mountCPPickers(), 0); } catch (e) { /* */ } }

	/** The input widget for one field in edit mode. Enums mount a picker (house rule); others are typed inputs. */
	_cpFieldEditHTML(pField)
	{
		const tmpCode = this._js(pField.Code);
		const tmpDraft = (this._cpEdit && this._cpEdit.Draft) || {};
		const tmpVal = (tmpDraft[pField.Code] != null) ? tmpDraft[pField.Code] : '';
		const dt = pField.DataType;
		if (dt === 'enum') { return `<div id="AW-CP-${this._esc(pField.Code)}" class="aw-cp-pick"></div>`; }
		if (dt === 'boolean')
		{
			const on = (tmpVal === true || String(tmpVal) === 'true' || String(tmpVal) === '1');
			return `<label class="aw-cp-chk"><input type="checkbox" ${on ? 'checked' : ''} onchange="_Pict.providers.AssetWorkspace.setCPValue('${tmpCode}', this.checked ? 'true' : 'false')"></label>`;
		}
		if (dt === 'text') { return `<textarea class="aw-in aw-cp-in aw-cp-ta" oninput="_Pict.providers.AssetWorkspace.setCPValue('${tmpCode}', this.value)">${this._esc(tmpVal)}</textarea>`; }
		const tmpInputType = (dt === 'number' || dt === 'integer') ? 'number' : (dt === 'date' ? 'date' : 'text');
		const tmpStep = (dt === 'integer') ? ' step="1"' : (dt === 'number' ? ' step="any"' : '');
		const tmpShownVal = (dt === 'date') ? String(tmpVal).slice(0, 10) : tmpVal;
		return `<input class="aw-in aw-cp-in" type="${tmpInputType}"${tmpStep} value="${this._esc(tmpShownVal)}" oninput="_Pict.providers.AssetWorkspace.setCPValue('${tmpCode}', this.value)">`;
	}

	startCPEdit()
	{
		const cp = this._customProps;
		if (!this.canEdit || !cp || !cp.HasShape || cp.FromFallback || !cp.Accessor) { return; }
		if (this.pict && this.pict.AppData) { this.pict.AppData.AssetWorkspace = this.pict.AppData.AssetWorkspace || {}; this.pict.AppData.AssetWorkspace.CPPick = {}; }
		const tmpVals = (cp.Values && cp.Values[cp.Accessor.setKey]) || {};
		this._cpEdit = { On: true, Draft: Object.assign({}, tmpVals), Saving: false, Error: '' };
		this._repaintOverview();
	}
	cancelCPEdit() { this._cpEdit = null; this._repaintOverview(); }
	setCPValue(pCode, pValue) { if (this._cpEdit && this._cpEdit.Draft) { this._cpEdit.Draft[pCode] = pValue; } }

	async saveCPValuesAsync()
	{
		const cp = this._customProps; const ed = this._cpEdit;
		if (!ed || ed.Saving || !this.canEdit || !cp || !cp.Accessor) { return; }
		const acc = cp.Accessor; const tmpSetKey = acc.setKey;
		const tmpOrig = (cp.Values && cp.Values[tmpSetKey]) || {};
		const tmpRowIDs = (cp.RowIDs && cp.RowIDs[tmpSetKey]) || {};
		const tmpVisible = [];
		acc.visibleGroups().forEach((g) => g.Fields.forEach((f) => tmpVisible.push(f)));
		const tmpMissing = tmpVisible.filter((f) => f.Constraints && f.Constraints.Required && (ed.Draft[f.Code] == null || String(ed.Draft[f.Code]).trim() === ''));
		if (tmpMissing.length) { ed.Error = `These are required: ${tmpMissing.map((f) => f.Label || f.Code).join(', ')}.`; this._repaintOverview(); return; }
		const tmpChanges = tmpVisible.filter((f) => String(ed.Draft[f.Code] == null ? '' : ed.Draft[f.Code]) !== String(tmpOrig[f.Code] == null ? '' : tmpOrig[f.Code]));
		if (!tmpChanges.length) { this._cpEdit = null; this._repaintOverview(); return; }
		ed.Saving = true; ed.Error = ''; this._repaintOverview();
		try
		{
			for (const f of tmpChanges)
			{
				const v = (ed.Draft[f.Code] == null) ? '' : String(ed.Draft[f.Code]);
				const tmpExistingID = tmpRowIDs[f.Code];
				if (tmpExistingID) { const r = await this._put('PhysicalAssetMetadata', { IDPhysicalAssetMetadata: tmpExistingID, Value: v, MetadataValue: v }); if (r && r.Error) { throw new Error(r.Error); } }
				else if (v !== '') { const r = await this._post('PhysicalAssetMetadatas', { IDPhysicalAsset: this.idAsset, MetadataSetGUID: tmpSetKey, Address: f.Code, Value: v, MetadataValue: v, Units: f.Units || '' }); if (r && r.Error) { throw new Error(r.Error); } }
			}
			await this._loadCustomPropsAsync(); // reloads values + clears edit mode
		}
		catch (e) { ed.Saving = false; ed.Error = `Save failed — ${(e && e.message) || String(e)}`; }
		this._repaintOverview();
	}

	_mountCPPickers()
	{
		if (!this._cpEdit || !this._cpEdit.On) { return; }
		const cp = this._customProps; if (!cp || !cp.Accessor) { return; }
		const tmpPicker = this._picker(); const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const self = this;
		cp.Accessor.visibleGroups().forEach((g) => g.Fields.forEach((f) =>
		{
			if (f.DataType !== 'enum') { return; }
			if (tmpCA.getElement(`#AW-CP-${f.Code}`).length === 0) { return; }
			const v = tmpPicker.createPicker(`AssetWorkspace-CP-${f.Code}`, {
				DestinationAddress: `#AW-CP-${f.Code}`, ValueAddress: `AppData.AssetWorkspace.CPPick.${f.Code}`,
				Searchable: true, AllowClear: true, ClearLabel: '— none —', Placeholder: 'choose…',
				DataProvider: self._cpValueDataProvider(f),
				ResolveValue: () => Promise.resolve((self._cpEdit && self._cpEdit.Draft) ? self._cpEdit.Draft[f.Code] : null),
				OnChange: (val) => { self.setCPValue(f.Code, (val == null ? '' : String(val))); },
			});
			if (v && (typeof v.render === 'function')) { v.render(); }
		}));
	}
	_cpValueDataProvider(pField)
	{
		const tmpValues = (pField.Values || []).slice().sort((a, b) => (a.Ordinal - b.Ordinal)).map((v) => ({ Value: v.Value, Text: `${v.Value} · ${v.Label || v.Value}`, Record: v }));
		return (pTerm) => { const t = String(pTerm == null ? '' : pTerm).toLowerCase().trim(); const res = t ? tmpValues.filter((x) => (String(x.Text).toLowerCase().indexOf(t) > -1)) : tmpValues; return Promise.resolve({ results: res, hasMore: false }); };
	}

	async _lookupName(pEntity, pID, pField)
	{
		if (!pID) { return ''; }
		try { const r = await this._get(`${pEntity}/${Number(pID)}`); return (r && !r.Error && r[pField]) ? r[pField] : `#${pID}`; }
		catch (e) { return `#${pID}`; }
	}

	// --- Tab data (async tabs load on enter, then repaint the body) ---
	async _ensureTabDataAsync(pTab, pForce)
	{
		if (!this._asset) { return; }
		if (!pForce && this._tabs[pTab] && this._tabs[pTab].Loaded) { if (pTab === 'elements') { this._scheduleElementsMount(); } return; }
		this._tabs[pTab] = { Loading: true, Loaded: false };
		this.repaintBody();
		try
		{
			if (pTab === 'elements') { this._tabs[pTab].Rows = await this._loadElements(); }
			else if (pTab === 'defects') { this._tabs[pTab].Rows = await this._loadDefects(); }
			else if (pTab === 'observations') { const r = await this._loadObservations(); this._tabs[pTab].Rows = r.rows; this._tabs[pTab].IDProject = r.idProject; }
			else if (pTab === 'documents') { this._tabs[pTab].Rows = await this._loadDocuments(); }
			this._tabs[pTab].Loaded = true;
		}
		catch (e) { this._tabs[pTab].Error = (e && e.message) || String(e); this._tabs[pTab].Loaded = true; }
		finally { this._tabs[pTab].Loading = false; this.repaintBody(); if (pTab === 'elements') { this._scheduleElementsMount(); } }
	}

	/** Location tab OnEnter: (re)mount the reused Leaflet map into the freshly-painted #AW-MapHost. showForProject
	 *  tears down any prior map first, so this is safe on every entry; marker drags go through setCenter (a targeted
	 *  readout update, NOT a body repaint) so the live map is never torn down. */
	_mountMap()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA && tmpCA.getElement('#AW-MapHost').length > 0)
		{
			const tmpMap = this.pict.views.AssetLocationMap;
			if (tmpMap && (typeof tmpMap.showForProject === 'function')) { tmpMap.showForProject(); }
		}
	}

	async _loadElements()
	{
		const tmpElements = await this._getAllPages(`PhysicalAssetElements/FilteredTo/FBV~IDPhysicalAsset~EQ~${this.idAsset}~FBV~Deleted~EQ~0`);
		const tmpConditions = await this._getAllPages(`PhysicalAssetElementConditions/FilteredTo/FBV~IDPhysicalAsset~EQ~${this.idAsset}~FBV~Deleted~EQ~0`);
		const tmpByElement = {};
		tmpConditions.forEach((c) => { const k = String(c.IDPhysicalAssetElement); (tmpByElement[k] = tmpByElement[k] || []).push(c); });
		return tmpElements.map((e) =>
		{
			const conds = (tmpByElement[String(e.IDPhysicalAssetElement)] || [])
				.map((c) => ({ ID: c.IDPhysicalAssetElementCondition, Year: c.Year || '', Total: c.TotalQuantity, CS: this._normalizeCS(c) }))
				.sort((a, b) => String(b.Year).localeCompare(String(a.Year)));
			return {
				ID: e.IDPhysicalAssetElement,
				IDType: e.IDPhysicalAssetElementType,
				IDMaterial: e.IDPhysicalAssetMaterial,
				Name: e.Name, Units: e.Units, Quantity: e.Quantity,
				Conditions: conds,
				Latest: conds.length ? conds[0] : null,
			};
		});
	}

	async _loadDefects()
	{
		const tmpJoins = await this._getAllPages(`PhysicalAssetPhysicalAssetDefectJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${this.idAsset}`);
		const tmpIDs = [ ...new Set(tmpJoins.map((j) => j.IDPhysicalAssetDefect).filter(Boolean)) ];
		if (!tmpIDs.length) { return []; }
		const tmpDefects = await this._getAllPages(`PhysicalAssetDefects/FilteredTo/FBL~IDPhysicalAssetDefect~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0`);
		return tmpDefects.map((d) => ({ Code: d.Code, Name: d.Name, Description: d.Description }));
	}

	// Defects recorded against ONE element (the AASHTO per-element defect list, each with its own CS breakdown).
	async _loadElementDefects(pIDElement)
	{
		const tmpJoins = await this._getAllPages(`PhysicalAssetElementPhysicalAssetDefectJoins/FilteredTo/FBV~IDPhysicalAssetElement~EQ~${pIDElement}~FBV~Deleted~EQ~0`);
		if (!tmpJoins.length) { return []; }
		const tmpIDs = [ ...new Set(tmpJoins.map((j) => j.IDPhysicalAssetDefect).filter(Boolean)) ];
		const tmpDefects = tmpIDs.length ? await this._getAllPages(`PhysicalAssetDefects/FilteredTo/FBL~IDPhysicalAssetDefect~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0`) : [];
		const tmpByID = AssetWorkspaceProvider._index(tmpDefects, 'IDPhysicalAssetDefect');
		return tmpJoins.map((j) =>
		{
			const d = tmpByID[String(j.IDPhysicalAssetDefect)] || {};
			return { ID: j.IDPhysicalAssetElementPhysicalAssetDefectJoin, IDDefect: j.IDPhysicalAssetDefect, Code: d.Code || '', Name: d.Name || `#${j.IDPhysicalAssetDefect}`, Year: j.Year || '', Total: j.TotalQuantity, CS: this._normalizeCS(j) };
		}).sort((a, b) => String(a.Code).localeCompare(String(b.Code)));
	}

	// The defects the element's TYPE allows (AASHTO catalog) — used to scope the add-defect picker.
	async _loadValidDefectIDs(pIDElementType)
	{
		if (!pIDElementType) { return []; }
		try { const joins = await this._getAllPages(`PhysicalAssetElementTypePhysicalAssetDefectJoins/FilteredTo/FBV~IDPhysicalAssetElementType~EQ~${pIDElementType}~FBV~Deleted~EQ~0`); return [ ...new Set(joins.map((j) => j.IDPhysicalAssetDefect).filter(Boolean)) ]; }
		catch (e) { return []; }
	}

	/**
	 * Header action: schedule an inspection of this asset. Hands the asset to the bespoke create screen, which
	 * resolves the project, previews the document packet, and creates all of it in one call.
	 */
	scheduleInspection()
	{
		if ((typeof window !== 'undefined') && window.location && this.idAsset)
		{
			window.location.hash = `#/PSRS/Inspection/Create/ForAsset/${ this.idAsset }`;
		}
	}

	async _resolveProjectID()
	{
		const tmpPJ = await this._getAllPages(`PhysicalAssetPolyJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${this.idAsset}~FBV~RemoteType~EQ~Project`);
		return tmpPJ.length ? tmpPJ[0].IDRemote : null;
	}

	async _loadObservations()
	{
		const tmpIDProject = await this._resolveProjectID();
		if (!tmpIDProject) { return { rows: [], idProject: null }; }
		const tmpRows = await this._get(`Observations/FilteredTo/FBV~IDProject~EQ~${tmpIDProject}~FBV~Deleted~EQ~0~FSF~CreateDate~DESC~0/0/50`);
		return { rows: Array.isArray(tmpRows) ? tmpRows.map((o) => ({ Type: o.ObservationType || o.Type || '', Date: o.CreateDate, Note: o.Note || o.Description || o.Name || '' })) : [], idProject: tmpIDProject };
	}

	async _loadDocuments()
	{
		const tmpJoins = await this._getAllPages(`PhysicalAssetArtifactJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${this.idAsset}`);
		const tmpIDs = [ ...new Set(tmpJoins.map((j) => j.IDArtifact).filter(Boolean)) ];
		if (!tmpIDs.length) { return []; }
		const tmpArtifacts = await this._getAllPages(`Artifacts/FilteredTo/FBL~IDArtifact~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0`);
		return tmpArtifacts.map((a) => ({ Name: a.Name || a.FileName || `#${a.IDArtifact}`, Type: a.Type || a.ArtifactType || '', Date: a.CreateDate }));
	}

	// --- Map contract (light-update, never a full body render → live map is preserved) ---
	setCenter(pLat, pLng, pSyncMap)
	{
		this._center = { Latitude: Number(pLat), Longitude: Number(pLng) };
		this._centerDirty = true; this._locError = '';
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA && tmpCA.getElement('#AW-LocReadout').length > 0) { tmpCA.assignContent('#AW-LocReadout', this._locReadoutHTML()); }
		if (pSyncMap) { const m = this.pict.views.AssetLocationMap; if (m && typeof m.moveMarkerTo === 'function') { m.moveMarkerTo(this._center.Latitude, this._center.Longitude); } }
	}
	setCenterFromText(pLat, pLng)
	{
		const tmpLat = Number(pLat); const tmpLng = Number(pLng);
		if (Number.isNaN(tmpLat) || Number.isNaN(tmpLng) || tmpLat < -90 || tmpLat > 90 || tmpLng < -180 || tmpLng > 180)
		{ this._locError = 'Enter a valid latitude (−90..90) and longitude (−180..180).'; const tmpCA = this.pict.ContentAssignment; if (tmpCA && tmpCA.getElement('#AW-LocReadout').length > 0) { tmpCA.assignContent('#AW-LocReadout', this._locReadoutHTML()); } return; }
		this.setCenter(tmpLat, tmpLng, true);
	}
	async saveLocationAsync()
	{
		if (!this.canEdit || !this._asset) { return; }
		this._locError = ''; this._locSaving = true;
		const tmpCA = this.pict.ContentAssignment; if (tmpCA && tmpCA.getElement('#AW-LocReadout').length > 0) { tmpCA.assignContent('#AW-LocReadout', this._locReadoutHTML()); }
		try
		{
			await this._put('PhysicalAsset', { IDPhysicalAsset: this.idAsset, OriginLatitude: this._center.Latitude, OriginLongitude: this._center.Longitude });
			this._asset.OriginLatitude = this._center.Latitude; this._asset.OriginLongitude = this._center.Longitude;
			this._centerDirty = false;
		}
		catch (e) { this._locError = (e && e.message) || String(e); }
		finally { this._locSaving = false; if (tmpCA && tmpCA.getElement('#AW-LocReadout').length > 0) { tmpCA.assignContent('#AW-LocReadout', this._locReadoutHTML()); } }
	}

	// --- Tab bodies (all `render` kind; the base assigns the returned string into the tab body) ---
	_field(pLabel, pValue) { return `<div class="aw-field"><div class="aw-field-label">${this._esc(pLabel)}</div><div class="aw-field-value">${pValue == null || pValue === '' ? '<span class="aw-muted">—</span>' : this._esc(pValue)}</div></div>`; }

	_overviewHTML()
	{
		const a = this._asset || {};
		return `<div class="aw-fields">
			${this._field('Name', a.Name)}
			${this._field('Asset Number', a.AssetNumber)}
			${this._field('Structure (external)', a.ExternalSyncGUID)}
			${this._field('Asset Type', this._typeName)}
			${this._field('Classification', this._classificationName)}
			${this._field('Year Built', a.YearBuilt)}
			${this._field('Latitude', a.OriginLatitude)}
			${this._field('Longitude', a.OriginLongitude)}
		</div>
		${ this._customPropsHTML() }`;
	}

	_locReadoutHTML()
	{
		const c = this._center;
		const tmpCoords = this.hasCenter ? `${Number(c.Latitude).toFixed(6)}, ${Number(c.Longitude).toFixed(6)}` : 'Not set';
		const tmpSave = (this.canEdit && this._centerDirty) ? `<button class="aw-btn aw-btn-primary" ${this._locSaving ? 'disabled' : ''} onclick="_Pict.providers.AssetWorkspace.saveLocationAsync()">${this._locSaving ? 'Saving…' : 'Save location'}</button>` : '';
		const tmpErr = this._locError ? `<span class="aw-error-inline">${this._esc(this._locError)}</span>` : '';
		return `<div class="aw-loc-coords"><b>${tmpCoords}</b>${this._centerDirty ? ' <span class="aw-muted">(unsaved)</span>' : ''}</div>${tmpSave}${tmpErr}`;
	}

	_locationHTML()
	{
		const a = this._asset || {};
		const tmpBounds = (a.BoundingMinLatitude || a.BoundingMaxLatitude || a.BoundingMinLongitude || a.BoundingMaxLongitude)
			? `<div class="aw-field-label" style="margin-top:0.8rem">Bounding box</div><div class="aw-mono">${this._n(a.BoundingMinLatitude)}, ${this._n(a.BoundingMinLongitude)} → ${this._n(a.BoundingMaxLatitude)}, ${this._n(a.BoundingMaxLongitude)}</div>`
			: '';
		return `<div class="aw-loc">
			<div class="aw-loc-top"><div id="AW-LocReadout">${this._locReadoutHTML()}</div></div>
			<div id="AW-MapHost" class="aw-map"></div>
			${this.canEdit ? '<div class="aw-hint">Drag the marker to reposition the asset, then Save.</div>' : '<div class="aw-hint">Read-only — repositioning needs a super-user or customer-admin.</div>'}
			${tmpBounds}
		</div>`;
	}

	_csBar(pCS, pTotal)
	{
		if (!pCS) { return '<span class="aw-muted">—</span>'; }
		const parts = [ [ 'cs1', pCS.CS1 ], [ 'cs2', pCS.CS2 ], [ 'cs3', pCS.CS3 ], [ 'cs4', pCS.CS4 ] ];
		const total = Number(pTotal) || parts.reduce((a, [ , v ]) => a + (Number(v) || 0), 0) || 1;
		return `<span class="aw-csbar">${parts.map(([ cls, v ]) => { const w = Math.max(0, (Number(v) || 0) / total * 100); return w > 0 ? `<span class="aw-cs aw-${cls}" style="width:${w.toFixed(1)}%" title="${cls.toUpperCase()}: ${this._n(v)}"></span>` : ''; }).join('')}</span>`;
	}

	_tabState(pTab) { return this._tabs[pTab] || {}; }
	_loadingOrEmpty(pTab, pEmptyMsg)
	{
		const t = this._tabState(pTab);
		// Not yet loaded (and not errored) → show the spinner rather than a premature empty state (the base paints
		// the body once BEFORE the OnEnter load kicks in).
		if (t.Loading || (!t.Loaded && !t.Error)) { return `<div class="aw-note"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>`; }
		if (t.Error) { return `<div class="aw-error">${this._esc(t.Error)}</div>`; }
		if (!t.Rows || !t.Rows.length) { return `<div class="aw-note">${this._esc(pEmptyMsg)}</div>`; }
		return null;
	}

	// ========================================================= Elements (master → detail) =========================================================
	_elementsHTML()
	{
		if (this._elementDetail) { return this._elementDetailHTML(); }
		const t = this._tabState('elements');
		if (t.Loading || (!t.Loaded && !t.Error)) { return `<div class="aw-note"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>`; }
		if (t.Error) { return `<div class="aw-error">${this._esc(t.Error)}</div>`; }
		const rows = t.Rows || [];
		const err = this._elemError ? `<div class="aw-error">${this._esc(this._elemError)}</div>` : '';
		const add = this.canEdit
			? `<div class="aw-addbar"><span class="aw-addbar-l">Add an element</span><div id="AW-ElementTypePicker" class="aw-pick"></div></div>`
			: '';
		if (!rows.length)
		{
			return err + add + `<div class="aw-note">No elements on this asset yet${this.canEdit ? ' — add one above' : ''}, or use the <b>Migrate</b> tab to import legacy bridge element conditions.</div>`;
		}
		const fVal = (pCS, pKey) => (pCS && pCS[pKey] != null) ? this._n(pCS[pKey]) : '<span class="aw-muted">—</span>';
		const body = rows.map((e) =>
		{
			const c = e.Latest;
			const confirming = this._confirm && this._confirm.kind === 'element' && this._confirm.id === e.ID;
			const act = this.canEdit
				? (confirming
					? `<span class="aw-confirm-q">Remove?</span> <button class="aw-x aw-x-yes" title="Confirm remove" onclick="_Pict.providers.AssetWorkspace.confirmRemove()"><i class="fas fa-check"></i></button> <button class="aw-x" title="Cancel" onclick="_Pict.providers.AssetWorkspace.cancelRemove()"><i class="fas fa-xmark"></i></button>`
					: `<button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.openElement(${e.ID})"><i class="fas fa-sliders"></i> Manage</button> <button class="aw-x" title="Remove element" onclick="_Pict.providers.AssetWorkspace.askRemove('element',${e.ID})"><i class="fas fa-trash-can"></i></button>`)
				: `<button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.openElement(${e.ID})"><i class="fas fa-eye"></i> View</button>`;
			return `<tr>`
				+ `<td><a class="aw-link" onclick="_Pict.providers.AssetWorkspace.openElement(${e.ID})">${this._esc(e.Name)}</a>${e.Conditions.length ? ` <span class="aw-chip" title="Condition years on record">${e.Conditions.length} yr</span>` : ''}</td>`
				+ `<td class="aw-num">${this._n(e.Quantity)} ${this._esc(e.Units || '')}</td>`
				+ `<td>${c && c.Year ? this._esc(c.Year) : '<span class="aw-muted">—</span>'}</td>`
				+ `<td class="aw-num aw-cs1-t">${fVal(c && c.CS, 'CS1')}</td>`
				+ `<td class="aw-num aw-cs2-t">${fVal(c && c.CS, 'CS2')}</td>`
				+ `<td class="aw-num aw-cs3-t">${fVal(c && c.CS, 'CS3')}</td>`
				+ `<td class="aw-num aw-cs4-t">${fVal(c && c.CS, 'CS4')}</td>`
				+ `<td class="aw-csbar-cell">${this._csBar(c && c.CS, c && c.Total)}</td>`
				+ `<td class="aw-row-act">${act}</td>`
				+ `</tr>`;
		}).join('');
		return err + add + `<table class="aw-table"><thead><tr>`
			+ `<th>Element</th><th class="aw-num">Quantity</th><th>Latest</th>`
			+ `<th class="aw-num aw-cs1-h" title="Good">CS1</th><th class="aw-num aw-cs2-h" title="Fair">CS2</th><th class="aw-num aw-cs3-h" title="Poor">CS3</th><th class="aw-num aw-cs4-h" title="Severe">CS4</th>`
			+ `<th>Condition</th><th></th>`
			+ `</tr></thead><tbody>${body}</tbody></table>`;
	}

	_elementDetailHTML()
	{
		const d = this._elementDetail;
		const err = this._elemError ? `<div class="aw-error">${this._esc(this._elemError)}</div>` : '';
		const head = `<div class="aw-detail-head">
			<button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.closeElement()"><i class="fas fa-arrow-left"></i> Elements</button>
			<div class="aw-detail-title">${this._esc(d.Name)}</div>
			${d.Busy ? '<span class="aw-muted"><i class="fas fa-circle-notch fa-spin"></i></span>' : ''}
		</div>`;
		// Element basics (quantity is inline-editable)
		const basics = this.canEdit
			? `<div class="aw-basics"><label class="aw-inl">Quantity <input id="AW-Elem-Quantity" class="aw-in aw-in-num" type="number" step="any" value="${d.Quantity == null ? '' : this._esc(d.Quantity)}"></label><span class="aw-units">${this._esc(d.Units || '')}</span><button class="aw-btn aw-btn-primary aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.saveElementBasics()"><i class="fas fa-check"></i> Save</button></div>`
			: `<div class="aw-basics"><span class="aw-field-label">Quantity</span> <b>${this._n(d.Quantity)}</b> <span class="aw-units">${this._esc(d.Units || '')}</span></div>`;
		return err + head + basics + this._conditionsHTML() + this._elementDefectsHTML();
	}

	// A CS1–4 (+ Year) input row shared by the condition and defect editors.
	_csEditorHTML(pPrefix, pSeed)
	{
		const s = pSeed || {}; const cs = s.CS || {};
		const inp = (k) => `<input id="AW-${pPrefix}-${k}" class="aw-in aw-in-num" type="number" step="any" min="0" value="${cs[k] == null ? '' : this._esc(cs[k])}" placeholder="0">`;
		return `<span class="aw-csedit">`
			+ `<label class="aw-inl aw-inl-yr">Year <input id="AW-${pPrefix}-Year" class="aw-in aw-in-yr" type="text" maxlength="24" value="${this._esc(s.Year || '')}" placeholder="2025"></label>`
			+ `<label class="aw-inl">CS1 ${inp('CS1')}</label>`
			+ `<label class="aw-inl">CS2 ${inp('CS2')}</label>`
			+ `<label class="aw-inl">CS3 ${inp('CS3')}</label>`
			+ `<label class="aw-inl">CS4 ${inp('CS4')}</label>`
			+ `</span>`;
	}
	_readCS(pPrefix)
	{
		const cs = { CS1: this._num0(this._val(`#AW-${pPrefix}-CS1`)), CS2: this._num0(this._val(`#AW-${pPrefix}-CS2`)), CS3: this._num0(this._val(`#AW-${pPrefix}-CS3`)), CS4: this._num0(this._val(`#AW-${pPrefix}-CS4`)) };
		return { CS: cs, Total: cs.CS1 + cs.CS2 + cs.CS3 + cs.CS4, Year: String(this._val(`#AW-${pPrefix}-Year`) || '').trim() };
	}

	_conditionsHTML()
	{
		const d = this._elementDetail; const conds = d.Conditions || [];
		const fVal = (pCS, pKey) => (pCS && pCS[pKey] != null) ? this._n(pCS[pKey]) : '<span class="aw-muted">—</span>';
		const editing = this._condEdit;
		const rowFor = (c) =>
		{
			if (editing && editing.ID === c.ID)
			{
				return `<tr class="aw-editing"><td colspan="7">${this._csEditorHTML('Cond', c)}<span class="aw-editbar"><button class="aw-btn aw-btn-primary aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.saveCondition()"><i class="fas fa-check"></i> Save</button><button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.cancelEdit()">Cancel</button></span></td></tr>`;
			}
			const confirming = this._confirm && this._confirm.kind === 'condition' && this._confirm.id === c.ID;
			const act = this.canEdit
				? (confirming
					? `<span class="aw-confirm-q">Remove?</span> <button class="aw-x aw-x-yes" onclick="_Pict.providers.AssetWorkspace.confirmRemove()"><i class="fas fa-check"></i></button> <button class="aw-x" onclick="_Pict.providers.AssetWorkspace.cancelRemove()"><i class="fas fa-xmark"></i></button>`
					: `<button class="aw-x" title="Edit" onclick="_Pict.providers.AssetWorkspace.editCondition(${c.ID})"><i class="fas fa-pen"></i></button> <button class="aw-x" title="Remove" onclick="_Pict.providers.AssetWorkspace.askRemove('condition',${c.ID})"><i class="fas fa-trash-can"></i></button>`)
				: '';
			return `<tr>`
				+ `<td>${c.Year ? this._esc(c.Year) : '<span class="aw-muted">—</span>'}</td>`
				+ `<td class="aw-num aw-cs1-t">${fVal(c.CS, 'CS1')}</td>`
				+ `<td class="aw-num aw-cs2-t">${fVal(c.CS, 'CS2')}</td>`
				+ `<td class="aw-num aw-cs3-t">${fVal(c.CS, 'CS3')}</td>`
				+ `<td class="aw-num aw-cs4-t">${fVal(c.CS, 'CS4')}</td>`
				+ `<td class="aw-num">${this._n(c.Total)}</td>`
				+ `<td class="aw-row-act">${act}</td>`
				+ `</tr>`;
		};
		const body = conds.map(rowFor).join('');
		const addNew = (editing && editing.ID === 0)
			? `<tr class="aw-editing"><td colspan="7">${this._csEditorHTML('Cond', null)}<span class="aw-editbar"><button class="aw-btn aw-btn-primary aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.saveCondition()"><i class="fas fa-check"></i> Add</button><button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.cancelEdit()">Cancel</button></span></td></tr>`
			: '';
		const addBtn = (this.canEdit && !editing) ? `<button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.addCondition()"><i class="fas fa-plus"></i> Add condition year</button>` : '';
		const empty = (!conds.length && !addNew) ? `<tr><td colspan="7"><span class="aw-muted">No condition years recorded${this.canEdit ? ' — add one.' : '.'}</span></td></tr>` : '';
		return `<div class="aw-sec"><div class="aw-sec-h"><span><i class="fas fa-chart-column"></i> Condition states by year</span>${addBtn}</div>`
			+ `<table class="aw-table aw-subtable"><thead><tr><th>Year</th><th class="aw-num aw-cs1-h">CS1</th><th class="aw-num aw-cs2-h">CS2</th><th class="aw-num aw-cs3-h">CS3</th><th class="aw-num aw-cs4-h">CS4</th><th class="aw-num">Total</th><th></th></tr></thead>`
			+ `<tbody>${body}${addNew}${empty}</tbody></table></div>`;
	}

	_elementDefectsHTML()
	{
		const d = this._elementDetail;
		if (d.DefectsError)
		{
			return `<div class="aw-sec"><div class="aw-sec-h"><span><i class="fas fa-triangle-exclamation"></i> Defects</span></div><div class="aw-note">${this._esc(d.DefectsError)}</div></div>`;
		}
		const defs = d.Defects || [];
		const fVal = (pCS, pKey) => (pCS && pCS[pKey] != null) ? this._n(pCS[pKey]) : '<span class="aw-muted">—</span>';
		const editing = this._defEdit;
		const rowFor = (x) =>
		{
			if (editing && editing.ID === x.ID)
			{
				return `<tr class="aw-editing"><td colspan="8"><div class="aw-defedit-name">${this._esc(x.Code ? x.Code + ' · ' : '')}${this._esc(x.Name)}</div>${this._csEditorHTML('Def', x)}<span class="aw-editbar"><button class="aw-btn aw-btn-primary aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.saveDefect()"><i class="fas fa-check"></i> Save</button><button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.cancelEdit()">Cancel</button></span></td></tr>`;
			}
			const confirming = this._confirm && this._confirm.kind === 'defect' && this._confirm.id === x.ID;
			const act = this.canEdit
				? (confirming
					? `<span class="aw-confirm-q">Remove?</span> <button class="aw-x aw-x-yes" onclick="_Pict.providers.AssetWorkspace.confirmRemove()"><i class="fas fa-check"></i></button> <button class="aw-x" onclick="_Pict.providers.AssetWorkspace.cancelRemove()"><i class="fas fa-xmark"></i></button>`
					: `<button class="aw-x" title="Edit" onclick="_Pict.providers.AssetWorkspace.editDefect(${x.ID})"><i class="fas fa-pen"></i></button> <button class="aw-x" title="Remove" onclick="_Pict.providers.AssetWorkspace.askRemove('defect',${x.ID})"><i class="fas fa-trash-can"></i></button>`)
				: '';
			return `<tr>`
				+ `<td class="aw-mono">${this._esc(x.Code || '')}</td>`
				+ `<td>${this._esc(x.Name)}</td>`
				+ `<td>${x.Year ? this._esc(x.Year) : '<span class="aw-muted">—</span>'}</td>`
				+ `<td class="aw-num aw-cs1-t">${fVal(x.CS, 'CS1')}</td>`
				+ `<td class="aw-num aw-cs2-t">${fVal(x.CS, 'CS2')}</td>`
				+ `<td class="aw-num aw-cs3-t">${fVal(x.CS, 'CS3')}</td>`
				+ `<td class="aw-num aw-cs4-t">${fVal(x.CS, 'CS4')}</td>`
				+ `<td class="aw-row-act">${act}</td>`
				+ `</tr>`;
		};
		const body = defs.map(rowFor).join('');
		const addNew = (editing && editing.ID === 0)
			? `<tr class="aw-editing"><td colspan="8"><div class="aw-defadd"><span class="aw-addbar-l">Defect</span><div id="AW-DefectPicker" class="aw-pick"></div></div>${this._csEditorHTML('Def', null)}<span class="aw-editbar"><button class="aw-btn aw-btn-primary aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.saveDefect()"><i class="fas fa-check"></i> Add</button><button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.cancelEdit()">Cancel</button></span></td></tr>`
			: '';
		const addBtn = (this.canEdit && !editing) ? `<button class="aw-btn aw-btn-ghost aw-btn-sm" onclick="_Pict.providers.AssetWorkspace.addDefect()"><i class="fas fa-plus"></i> Add defect</button>` : '';
		const empty = (!defs.length && !addNew) ? `<tr><td colspan="8"><span class="aw-muted">No defects recorded against this element${this.canEdit ? ' — add one.' : '.'}</span></td></tr>` : '';
		return `<div class="aw-sec"><div class="aw-sec-h"><span><i class="fas fa-triangle-exclamation"></i> Defects on this element</span>${addBtn}</div>`
			+ `<table class="aw-table aw-subtable"><thead><tr><th>Code</th><th>Defect</th><th>Year</th><th class="aw-num aw-cs1-h">CS1</th><th class="aw-num aw-cs2-h">CS2</th><th class="aw-num aw-cs3-h">CS3</th><th class="aw-num aw-cs4-h">CS4</th><th></th></tr></thead>`
			+ `<tbody>${body}${addNew}${empty}</tbody></table></div>`;
	}

	// --- Element interactions ---
	_repaintElements() { this.repaintBody(); this._scheduleElementsMount(); }

	async openElement(pID)
	{
		const id = Number(pID) || 0; if (!id) { return; }
		this._elemError = ''; this._condEdit = null; this._defEdit = null; this._confirm = null;
		const row = (this._tabState('elements').Rows || []).find((r) => r.ID === id);
		if (!row) { this._reload('elements'); return; }
		this._elementDetail = Object.assign({}, row, { Busy: true, Defects: [], DefectsError: '', ValidDefectIDs: [] });
		this._repaintElements();
		try
		{
			this._elementDetail.ValidDefectIDs = await this._loadValidDefectIDs(row.IDType);
			this._elementDetail.Defects = await this._loadElementDefects(id);
		}
		catch (e) { this._elementDetail.DefectsError = `Defects could not be loaded — ${((e && e.message) || String(e))}. (The element↔defect join columns may not be deployed yet.)`; }
		finally { if (this._elementDetail) { this._elementDetail.Busy = false; } this._repaintElements(); }
	}
	closeElement() { this._elementDetail = null; this._condEdit = null; this._defEdit = null; this._confirm = null; this._elemError = ''; this._repaintElements(); }
	_reload(pTab) { if (this._tabs[pTab]) { this._tabs[pTab].Loaded = false; } this._ensureTabDataAsync(pTab, true); }

	// Re-fetch the open element's conditions + defects without the full-list spinner flash.
	async _refreshDetail()
	{
		const id = this._elementDetail && this._elementDetail.ID; if (!id) { return; }
		this._elementDetail.Busy = true; this._repaintElements();
		try
		{
			const rows = await this._loadElements();
			this._tabs.elements = { Loaded: true, Rows: rows };
			const row = rows.find((r) => r.ID === id);
			const defects = await this._loadElementDefects(id).catch((e) => { this._elementDetail.DefectsError = `Defects could not be loaded — ${((e && e.message) || String(e))}.`; return this._elementDetail.Defects || []; });
			if (row) { this._elementDetail = Object.assign({}, row, { Busy: false, Defects: defects, DefectsError: this._elementDetail.DefectsError || '', ValidDefectIDs: this._elementDetail.ValidDefectIDs || [] }); }
			else { this._elementDetail = null; }
		}
		catch (e) { this._elemError = (e && e.message) || String(e); if (this._elementDetail) { this._elementDetail.Busy = false; } }
		finally { this._repaintElements(); }
	}

	async addElement(pIDType)
	{
		const id = Number(pIDType) || 0; if (!id || !this.canEdit) { return; }
		this._elemError = '';
		try
		{
			const et = await this._get(`PhysicalAssetElementType/${id}`);
			const payload = {
				Name: (et && (et.Name || et.Code)) || `Element ${id}`,
				Units: (et && et.Unit) || '',
				Quantity: 0,
				IDPhysicalAsset: this.idAsset,
				IDAssetType: (this._asset && this._asset.IDAssetType) || 0,
				IDPhysicalAssetElementType: id,
				IDPhysicalAssetMaterial: (et && et.IDPhysicalAssetMaterial) || 0,
			};
			const r = await this._post('PhysicalAssetElements', payload);
			if (r && r.Error) { throw new Error(r.Error); }
		}
		catch (e) { this._elemError = `Add element failed — ${(e && e.message) || String(e)}`; }
		if (this.pict && this.pict.AppData && this.pict.AppData.AssetWorkspace) { this.pict.AppData.AssetWorkspace.ElementTypePicker = null; }
		this._reload('elements');
	}

	async saveElementBasics()
	{
		const d = this._elementDetail; if (!d || !this.canEdit) { return; }
		this._elemError = '';
		const qty = this._num0(this._val('#AW-Elem-Quantity'));
		try { const r = await this._put('PhysicalAssetElement', { IDPhysicalAssetElement: d.ID, Quantity: qty }); if (r && r.Error) { throw new Error(r.Error); } d.Quantity = qty; }
		catch (e) { this._elemError = `Save failed — ${(e && e.message) || String(e)}`; }
		this._repaintElements();
	}

	// --- condition editing ---
	addCondition() { if (!this.canEdit) { return; } this._condEdit = { ID: 0 }; this._confirm = null; this._repaintElements(); }
	editCondition(pID) { if (!this.canEdit) { return; } this._condEdit = { ID: Number(pID) || 0 }; this._confirm = null; this._repaintElements(); }
	cancelEdit() { this._condEdit = null; this._defEdit = null; this._repaintElements(); }
	async saveCondition()
	{
		const d = this._elementDetail; if (!d || !this.canEdit || !this._condEdit) { return; }
		this._elemError = '';
		const r = this._readCS('Cond');
		const payload = {
			IDPhysicalAssetElement: d.ID, IDPhysicalAsset: this.idAsset,
			Year: r.Year, TotalQuantity: r.Total, QuantitiesJSON: JSON.stringify(r.CS),
			Source: 'Manual', EffectiveDate: /^\d{4}$/.test(r.Year) ? `${r.Year}-01-01T00:00:00Z` : null,
		};
		try
		{
			if (this._condEdit.ID) { payload.IDPhysicalAssetElementCondition = this._condEdit.ID; const x = await this._put('PhysicalAssetElementCondition', payload); if (x && x.Error) { throw new Error(x.Error); } }
			else { const x = await this._post('PhysicalAssetElementConditions', payload); if (x && x.Error) { throw new Error(x.Error); } }
			this._condEdit = null;
		}
		catch (e) { this._elemError = `Save condition failed — ${(e && e.message) || String(e)}`; }
		await this._refreshDetail();
	}

	// --- defect editing ---
	addDefect() { if (!this.canEdit) { return; } this._defEdit = { ID: 0, IDDefect: 0 }; this._confirm = null; if (this.pict && this.pict.AppData && this.pict.AppData.AssetWorkspace) { this.pict.AppData.AssetWorkspace.DefectPicker = null; } this._repaintElements(); }
	editDefect(pID)
	{
		if (!this.canEdit) { return; }
		const x = (this._elementDetail.Defects || []).find((y) => y.ID === (Number(pID) || 0));
		this._defEdit = x ? { ID: x.ID, IDDefect: x.IDDefect, Code: x.Code, Name: x.Name } : null;
		this._confirm = null; this._repaintElements();
	}
	async saveDefect()
	{
		const d = this._elementDetail; if (!d || !this.canEdit || !this._defEdit) { return; }
		this._elemError = '';
		const r = this._readCS('Def');
		let idDefect = this._defEdit.IDDefect;
		if (!this._defEdit.ID) { idDefect = Number(this._defEdit.PickedID) || Number((this.pict.AppData.AssetWorkspace || {}).DefectPicker) || 0; if (!idDefect) { this._elemError = 'Pick a defect to add.'; this._repaintElements(); return; } }
		const payload = {
			IDPhysicalAssetElement: d.ID, IDPhysicalAssetDefect: idDefect,
			Year: r.Year, TotalQuantity: r.Total, QuantitiesJSON: JSON.stringify(r.CS),
		};
		try
		{
			if (this._defEdit.ID) { payload.IDPhysicalAssetElementPhysicalAssetDefectJoin = this._defEdit.ID; const x = await this._put('PhysicalAssetElementPhysicalAssetDefectJoin', payload); if (x && x.Error) { throw new Error(x.Error); } }
			else { const x = await this._post('PhysicalAssetElementPhysicalAssetDefectJoins', payload); if (x && x.Error) { throw new Error(x.Error); } }
			this._defEdit = null;
		}
		catch (e) { this._elemError = `Save defect failed — ${(e && e.message) || String(e)}. (The element↔defect join columns may not be deployed yet.)`; }
		await this._refreshDetail();
	}

	// --- shared inline delete confirm ---
	askRemove(pKind, pID) { if (!this.canEdit) { return; } this._confirm = { kind: pKind, id: Number(pID) || 0 }; this._condEdit = null; this._defEdit = null; this._repaintElements(); }
	cancelRemove() { this._confirm = null; this._repaintElements(); }
	async confirmRemove()
	{
		const c = this._confirm; if (!c || !this.canEdit) { return; }
		this._confirm = null; this._elemError = '';
		try
		{
			if (c.kind === 'element') { const x = await this._del(`PhysicalAssetElement/${c.id}`); if (x && x.Error) { throw new Error(x.Error); } this._elementDetail = null; this._reload('elements'); return; }
			if (c.kind === 'condition') { const x = await this._del(`PhysicalAssetElementCondition/${c.id}`); if (x && x.Error) { throw new Error(x.Error); } await this._refreshDetail(); return; }
			if (c.kind === 'defect') { const x = await this._del(`PhysicalAssetElementPhysicalAssetDefectJoin/${c.id}`); if (x && x.Error) { throw new Error(x.Error); } await this._refreshDetail(); return; }
		}
		catch (e) { this._elemError = `Remove failed — ${(e && e.message) || String(e)}`; this._repaintElements(); }
	}

	// --- pickers (element-type on the list add-bar, defect inside the element detail add form) ---
	_scheduleElementsMount() { try { setTimeout(() => this._mountElementsPickers(), 0); } catch (e) { /* */ } }
	_picker() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }
	_mountElementsPickers()
	{
		const tmpPicker = this._picker(); const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const mount = (pHostID, pName, pDataProvider, pOnChange, pPlaceholder) =>
		{
			if (tmpCA.getElement(`#${pHostID}`).length === 0) { return; }
			const v = tmpPicker.createPicker(`${this.providerName}-${pName}`, {
				DestinationAddress: `#${pHostID}`, ValueAddress: `AppData.AssetWorkspace.${pName}`,
				Searchable: true, AllowClear: true, ClearLabel: `— ${pPlaceholder} —`, Placeholder: `${pPlaceholder}…`,
				DataProvider: pDataProvider, ResolveValue: () => Promise.resolve(null), OnChange: pOnChange,
			});
			if (v && (typeof v.render === 'function')) { v.render(); }
		};
		if (this._elementDetail && this._defEdit && this._defEdit.ID === 0)
		{
			mount('AW-DefectPicker', 'DefectPicker', this._defectDataProvider(), (val) => { if (this._defEdit) { this._defEdit.PickedID = Number(val) || 0; } }, 'search defects');
		}
		else if (!this._elementDetail && this.canEdit)
		{
			mount('AW-ElementTypePicker', 'ElementTypePicker', this._elementTypeDataProvider(), (val) => { if (val) { this.addElement(val); } }, 'search element types');
		}
	}
	_elementTypeDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'PhysicalAssetElementTypes', IDField: 'IDPhysicalAssetElementType', SortField: 'Code',
				ToOption: (r) => ({ Value: Number(r.IDPhysicalAssetElementType), Text: (r.Code ? `${r.Code} · ` : '') + (r.Name || `Type ${r.IDPhysicalAssetElementType}`), Record: r }),
			});
	}
	_defectDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'PhysicalAssetDefects', IDField: 'IDPhysicalAssetDefect', SortField: 'Code',
				Scope: () =>
				{
					const ids = (this._elementDetail && this._elementDetail.ValidDefectIDs) || [];
					return ids.length ? `FBL~IDPhysicalAssetDefect~INN~${ids.join(',')}~FBV~Deleted~EQ~0` : 'FBV~Deleted~EQ~0';
				},
				ToOption: (r) => ({ Value: Number(r.IDPhysicalAssetDefect), Text: (r.Code ? `${r.Code} · ` : '') + (r.Name || `Defect ${r.IDPhysicalAssetDefect}`), Record: r }),
			});
	}

	_defectsHTML()
	{
		const tmpBusy = this._loadingOrEmpty('defects', 'No defects recorded against this asset.');
		if (tmpBusy) { return tmpBusy; }
		const rows = this._tabState('defects').Rows.map((d) => `<tr><td class="aw-mono">${this._esc(d.Code)}</td><td>${this._esc(d.Name)}</td><td>${this._esc(d.Description || '')}</td></tr>`).join('');
		return `<div class="aw-hint">Asset-level defect roll-up. Defects recorded against a specific element — with their condition-state breakdown — live in that element's <b>Manage</b> view on the Elements tab.</div><table class="aw-table"><thead><tr><th>Code</th><th>Name</th><th>Description</th></tr></thead><tbody>${rows}</tbody></table>`;
	}

	_observationsHTML()
	{
		const tmpBusy = this._loadingOrEmpty('observations', 'No observations found for this asset’s project (or the asset isn’t linked to a project yet).');
		if (tmpBusy) { return tmpBusy; }
		const rows = this._tabState('observations').Rows.map((o) => `<tr><td>${this._esc(o.Type)}</td><td>${o.Date ? this._esc(String(o.Date).slice(0, 10)) : ''}</td><td>${this._esc(String(o.Note || '').slice(0, 120))}</td></tr>`).join('');
		return `<div class="aw-hint">Observations from this asset’s linked project (newest first).</div><table class="aw-table"><thead><tr><th>Type</th><th>Date</th><th>Note</th></tr></thead><tbody>${rows}</tbody></table>`;
	}

	_documentsHTML()
	{
		const tmpBusy = this._loadingOrEmpty('documents', 'No documents linked to this asset yet.');
		if (tmpBusy) { return tmpBusy; }
		const rows = this._tabState('documents').Rows.map((d) => `<tr><td>${this._esc(d.Name)}</td><td>${this._esc(d.Type || '')}</td><td>${d.Date ? this._esc(String(d.Date).slice(0, 10)) : ''}</td></tr>`).join('');
		return `<table class="aw-table"><thead><tr><th>Name</th><th>Type</th><th>Added</th></tr></thead><tbody>${rows}</tbody></table>`;
	}

	// --- Migrate (single asset; mirrors the CLI + AssetBrowser) ---
	askMigrate() { this._migrate.Confirming = true; this.repaintBody(); }
	cancelMigrate() { this._migrate.Confirming = false; this.repaintBody(); }
	async loadMigratePlanAsync() { await this._runMigration(true); }
	async migrateAsync() { await this._runMigration(false); }

	async _runMigration(pDryRun)
	{
		const m = this._migrate;
		if (m.Applying || !this._asset) { return; }
		if (!pDryRun && !this.canEdit) { m.Error = 'Migrating needs a super-user or customer-admin.'; this.repaintBody(); return; }
		m.Applying = true; m.Error = ''; m.Confirming = false; if (!pDryRun) { m.Result = null; } this.repaintBody();
		const tmpAssetID = this.idAsset;
		try
		{
			const tmpETypes = await this._getAllPages('PhysicalAssetElementTypes/FilteredTo/FBV~Deleted~EQ~0');
			if (!tmpETypes.length) { throw new Error('No element-type catalog for this customer — run the AASHTO catalog Sync first (#/AssetCatalogSync).'); }
			const tmpETByCode = AssetWorkspaceProvider._index(tmpETypes, 'Code');
			const tmpLakeElemById = AssetWorkspaceProvider._index(await this._getAllPages('Elements'), 'IDElement');
			const tmpPJ = await this._getAllPages(`PhysicalAssetPolyJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${tmpAssetID}~FBV~RemoteType~EQ~Bridge`);
			const tmpIDBridge = tmpPJ.length ? tmpPJ[0].IDRemote : null;
			if (!tmpIDBridge) { throw new Error('This asset is not linked to a bridge (no element source).'); }
			const tmpConditions = await this._getAllPages(`BridgeElementConditions/FilteredTo/FBV~IDBridge~EQ~${tmpIDBridge}`);

			const tmpByElement = {}; tmpConditions.forEach((r) => { const k = String(r.IDElement); (tmpByElement[k] = tmpByElement[k] || []).push(r); });
			const tmpExisting = await this._getAllPages(`PhysicalAssetElements/FilteredTo/FBV~IDPhysicalAsset~EQ~${tmpAssetID}~FBV~Deleted~EQ~0`);
			const tmpElemByType = AssetWorkspaceProvider._index(tmpExisting, 'IDPhysicalAssetElementType');
			const tmpExistingCond = await this._getAllPages(`PhysicalAssetElementConditions/FilteredTo/FBV~IDPhysicalAsset~EQ~${tmpAssetID}~FBV~Deleted~EQ~0`);
			const tmpCondSig = {}; tmpExistingCond.forEach((c) => { tmpCondSig[`${c.IDPhysicalAssetElement}|${c.Year}`] = true; });

			const tmpElementsToCreate = []; const tmpTypeByLakeElem = {}; let tmpUnknown = 0;
			Object.keys(tmpByElement).forEach((k) =>
			{
				const le = tmpLakeElemById[k]; const et = le ? tmpETByCode[String(le.Code)] : null;
				if (!et) { tmpUnknown++; return; }
				tmpTypeByLakeElem[k] = et;
				let latest = null; tmpByElement[k].forEach((r) => { if (!latest || String(r.Year) > String(latest.Year)) { latest = r; } });
				if (tmpElemByType[String(et.IDPhysicalAssetElementType)]) { return; }
				tmpElementsToCreate.push({ Name: et.Name || `Element ${et.Code}`, Units: et.Unit || '', Quantity: latest ? latest.TotalQuantity : 0, IDPhysicalAsset: tmpAssetID, IDAssetType: this._asset.IDAssetType || 0, IDPhysicalAssetElementType: et.IDPhysicalAssetElementType, IDPhysicalAssetMaterial: et.IDPhysicalAssetMaterial || 0 });
			});
			let tmpCondPlan = 0;
			Object.keys(tmpByElement).forEach((k) => { const et = tmpTypeByLakeElem[k]; if (!et) { return; } const ex = tmpElemByType[String(et.IDPhysicalAssetElementType)]; tmpByElement[k].forEach((r) => { if (ex && tmpCondSig[`${ex.IDPhysicalAssetElement}|${r.Year}`]) { return; } tmpCondPlan++; }); });

			if (pDryRun) { m.Plan = { bridge: tmpIDBridge, elementsToCreate: tmpElementsToCreate.length, conditionsToCreate: tmpCondPlan, unknown: tmpUnknown }; return; }

			let tmpElemCreated = 0;
			if (tmpElementsToCreate.length) { const r = await this._post('PhysicalAssetElements', tmpElementsToCreate); if (r && r.Error) { throw new Error(r.Error); } tmpElemCreated = tmpElementsToCreate.length; }
			const tmpRefreshed = await this._getAllPages(`PhysicalAssetElements/FilteredTo/FBV~IDPhysicalAsset~EQ~${tmpAssetID}~FBV~Deleted~EQ~0`);
			const tmpElemByTypeNow = AssetWorkspaceProvider._index(tmpRefreshed, 'IDPhysicalAssetElementType');
			const tmpCondsToCreate = [];
			Object.keys(tmpByElement).forEach((k) =>
			{
				const et = tmpTypeByLakeElem[k]; if (!et) { return; } const elemRow = tmpElemByTypeNow[String(et.IDPhysicalAssetElementType)]; if (!elemRow) { return; }
				tmpByElement[k].forEach((r) => { const sig = `${elemRow.IDPhysicalAssetElement}|${r.Year}`; if (tmpCondSig[sig]) { return; } tmpCondSig[sig] = true; const y = String(r.Year || ''); tmpCondsToCreate.push({ IDPhysicalAssetElement: elemRow.IDPhysicalAssetElement, IDPhysicalAsset: tmpAssetID, Year: y, EffectiveDate: /^\d{4}$/.test(y) ? `${y}-01-01T00:00:00Z` : null, Source: r.Source || '', TotalQuantity: r.TotalQuantity, QuantitiesJSON: JSON.stringify({ CS1: r.CS1, CS2: r.CS2, CS3: r.CS3, CS4: r.CS4 }) }); });
			});
			let tmpCondCreated = 0;
			if (tmpCondsToCreate.length) { const r = await this._post('PhysicalAssetElementConditions', tmpCondsToCreate); if (r && r.Error) { throw new Error(r.Error); } tmpCondCreated = tmpCondsToCreate.length; }
			m.Result = { elementsCreated: tmpElemCreated, conditionsCreated: tmpCondCreated, unknown: tmpUnknown }; m.Plan = null;
			this._tabs.elements = { Loaded: false }; // force refresh of the Elements tab
		}
		catch (e) { m.Error = (e && e.message) || String(e); }
		finally { m.Applying = false; this.repaintBody(); }
	}

	_migrateHTML()
	{
		const m = this._migrate;
		let h = `<div class="aw-hint">Bring this asset’s legacy bridge element-condition data into the modern model. Additive &amp; safe to re-run. (For bulk, use the migration CLI.)</div>`;
		if (m.Applying) { return h + `<div class="aw-note"><i class="fas fa-circle-notch fa-spin"></i> Working…</div>`; }
		if (m.Error) { h += `<div class="aw-error">${this._esc(m.Error)}</div>`; }
		if (m.Result) { h += `<div class="aw-result"><i class="fas fa-circle-check"></i> Migrated — ${this._n(m.Result.elementsCreated)} elements, ${this._n(m.Result.conditionsCreated)} conditions${m.Result.unknown ? ` (${this._n(m.Result.unknown)} unknown skipped)` : ''}.</div>`; }
		if (m.Plan)
		{
			h += `<div class="aw-plan">Plan: <b>${this._n(m.Plan.elementsToCreate)}</b> elements + <b>${this._n(m.Plan.conditionsToCreate)}</b> conditions from lake bridge ${this._n(m.Plan.bridge)}${m.Plan.unknown ? ` · ${this._n(m.Plan.unknown)} unknown skipped` : ''}.</div>`;
			const tmpWork = (m.Plan.elementsToCreate + m.Plan.conditionsToCreate) > 0;
			if (this.canEdit && tmpWork)
			{
				h += m.Confirming
					? `<div class="aw-actions"><span class="aw-confirm-q">Migrate this asset?</span><button class="aw-btn aw-btn-primary" onclick="_Pict.providers.AssetWorkspace.migrateAsync()">Yes, migrate</button><button class="aw-btn aw-btn-ghost" onclick="_Pict.providers.AssetWorkspace.cancelMigrate()">Cancel</button></div>`
					: `<div class="aw-actions"><button class="aw-btn aw-btn-primary" onclick="_Pict.providers.AssetWorkspace.askMigrate()"><i class="fas fa-cloud-arrow-down"></i> Migrate this asset</button></div>`;
			}
			else if (!tmpWork) { h += `<div class="aw-note">Nothing to migrate — already up to date.</div>`; }
			else { h += `<div class="aw-note">Migrating needs a super-user or customer-admin.</div>`; }
		}
		else { h += `<div class="aw-actions"><button class="aw-btn aw-btn-ghost" onclick="_Pict.providers.AssetWorkspace.loadMigratePlanAsync()"><i class="fas fa-list-check"></i> Check migration (dry run)</button></div>`; }
		return h;
	}
}

module.exports = AssetWorkspaceProvider;

},{"../services/Entity-Picker-Search.js":1398,"pict-section-workspace":1049}],1308:[function(require,module,exports){
'use strict';

/**
 * Bulk File Upload — data/logic provider (ProjectWorkspace ▸ Data ▸ Bulk upload files).
 *
 * Stages many browser Files and creates ONE Observation per file (image/* → an Image observation, video/* → Video,
 * audio/* → Audio, everything else → a File observation), reusing the same server pipeline the Important Files
 * single-upload proved out (create the Observation → the server provisions its Artifact → POST the raw bytes) but
 * WITHOUT the ProjectFile pointer step (these are plain project observations, not important-file listings).
 *
 * The user edits each row's Name + Designated Date (Observation.DesignatedTime) in a grid before uploading (the
 * values are baked into the POST), and may keep editing after — a post-upload edit does a full-record PUT so it
 * persists. Uploads run through a small concurrency pool with a per-row progress callback + a byte-weighted
 * overall bar. All state lives on the provider (rows) + AppData.BulkUpload (view flags); the view paints the grid
 * and pokes per-row/overall progress into the DOM (no full re-render mid-upload, so inputs keep focus).
 */

const libPictProvider = require('pict-provider');

// MIME → Headlight ObservationType. Media carry the legacy prefix; everything else is a plain 'File'. The datum
// key is the type without the prefix ('Image'/'Video'/'Audio'/'File'). Mirrors ImportantFiles-Provider.
const OBSERVATION_TYPE_FOR_MIME = (pMime) =>
{
	const tmpMime = String(pMime || '').toLowerCase();
	if (tmpMime.indexOf('image/') === 0) { return 'Legacy Image'; }
	if (tmpMime.indexOf('video/') === 0) { return 'Legacy Video'; }
	if (tmpMime.indexOf('audio/') === 0) { return 'Legacy Audio'; }
	return 'File';
};

// The artifact-type name inside the observation's Details differs from the datum key for plain files: a 'File'
// observation's artifact MUST be 'Data_File' (the server's Data_File manifest validates it — sending 'File'
// leaves the artifact Invalid=1). Media types use their datum name as-is. (Verified against real observations.)
const ARTIFACT_TYPE_FOR_DATUM = { File: 'Data_File', Image: 'Image', Video: 'Video', Audio: 'Audio' };

class BulkUploadProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._idProject = 0;
		this._rows = [];
		this._rowSeq = 0;
		this._uploading = false;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get view() { return this.pict.views['BulkUpload']; }
	get rows() { return this._rows; }
	get idProject() { return this._idProject; }
	get isUploading() { return this._uploading; }

	/** The screen's AppData-backed flags (the view derives its slots from these). */
	get state()
	{
		if (!this.pict.AppData.BulkUpload)
		{
			this.pict.AppData.BulkUpload = { IDProject: 0, HasRows: false, Uploading: false };
		}
		return this.pict.AppData.BulkUpload;
	}

	_render() { if (this.view) { this.view.render(); } }

	// --- Capability gate (Observation/Artifact creation) --------------------------------------------

	get permissions() { return this.pict.fable.EffectivePermissionsService; }

	/** Server-authoritative capability check, fail-CLOSED (no service / unloaded map → false) so the upload
	 *  affordance never flashes before we know the user's grants. Super-users pass (the service bypasses). */
	can(pEntity, pAction)
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.can !== 'function') || !tmpPermissions.currentUserReady()) { return false; }
		return tmpPermissions.can(pEntity, pAction);
	}

	/** May the current user bulk-create observations? Needs Observation-Create (the artifact rides along on the
	 *  observation POST, which the server authorizes together). */
	canUpload() { return this.can('Observation', 'Create'); }

	// --- Lifecycle / embed --------------------------------------------------------------------------

	/** Point the tool at a project. Switching projects clears any staged rows (they belong to the old project). */
	setProject(pIDProject)
	{
		const tmpID = Number(pIDProject) || 0;
		if (tmpID !== this._idProject)
		{
			this._idProject = tmpID;
			this._rows = [];
			this._uploading = false;
		}
		this.state.IDProject = this._idProject;
		this.state.HasRows = (this._rows.length > 0);
		this.state.Uploading = this._uploading;
	}

	// --- Row staging --------------------------------------------------------------------------------

	/** 'report.pdf' → 'report'; leaves extension-less names alone. Used as the default observation Name. */
	_stripExtension(pName)
	{
		const tmpName = String(pName == null ? '' : pName).trim();
		return tmpName.replace(/\.[A-Za-z0-9]{1,8}$/, '') || tmpName || 'Untitled';
	}

	/** A file's own last-modified day as YYYY-MM-DD (a sensible default Designated Date for old scanned docs);
	 *  falls back to today. UTC date parts so it round-trips with how we serialize DesignatedTime. */
	_defaultDateISO(pFile)
	{
		let tmpDate = null;
		if (pFile && pFile.lastModified) { tmpDate = new Date(pFile.lastModified); }
		if (!tmpDate || Number.isNaN(tmpDate.getTime())) { tmpDate = new Date(); }
		return tmpDate.toISOString().slice(0, 10);
	}

	/** Add browser Files as staged rows. Returns the number added. */
	addFiles(pFiles)
	{
		const tmpFiles = Array.prototype.slice.call(pFiles || []);
		let tmpAdded = 0;
		tmpFiles.forEach((pFile) =>
		{
			if (!pFile) { return; }
			const tmpObsType = OBSERVATION_TYPE_FOR_MIME(pFile.type);
			this._rows.push(
				{
					UID: `blk_${++this._rowSeq}`,
					File: pFile,
					Name: this._stripExtension(pFile.name || ''),
					FileName: pFile.name || 'file',
					DateISO: this._defaultDateISO(pFile),
					Mime: pFile.type || '',
					ObservationType: tmpObsType,
					Type: tmpObsType.replace(/^Legacy\s+/, ''),   // Image / Video / Audio / File
					Size: pFile.size || 0,
					Status: 'staged',
					Progress: 0,
					UploadedBytes: 0,
					IDObservation: 0,
					Message: '',
				});
			tmpAdded++;
		});
		if (tmpAdded) { this.state.HasRows = (this._rows.length > 0); this._render(); }
		return tmpAdded;
	}

	_findRow(pUID) { return this._rows.find((pRow) => pRow.UID === pUID) || null; }

	/** Remove one row (only when not mid-upload). */
	removeRow(pUID)
	{
		const tmpRow = this._findRow(pUID);
		if (!tmpRow || tmpRow.Status === 'uploading') { return; }
		this._rows = this._rows.filter((pRow) => pRow.UID !== pUID);
		this.state.HasRows = (this._rows.length > 0);
		this._render();
	}

	/** Clear every row (blocked while uploading). */
	clearAll()
	{
		if (this._uploading) { return; }
		this._rows = [];
		this.state.HasRows = false;
		this._render();
	}

	/** Edit a staged row's Name; a done row's edit is persisted with a full-record PUT. */
	async setRowName(pUID, pName)
	{
		const tmpRow = this._findRow(pUID);
		if (!tmpRow) { return; }
		tmpRow.Name = String(pName == null ? '' : pName);
		if (tmpRow.Status === 'done' && tmpRow.IDObservation) { await this._persistRowEditAsync(tmpRow); }
	}

	/** Edit a row's Designated Date (YYYY-MM-DD); a done row's edit is persisted with a full-record PUT. */
	async setRowDate(pUID, pDateISO)
	{
		const tmpRow = this._findRow(pUID);
		if (!tmpRow) { return; }
		tmpRow.DateISO = String(pDateISO == null ? '' : pDateISO);
		if (tmpRow.Status === 'done' && tmpRow.IDObservation) { await this._persistRowEditAsync(tmpRow); }
	}

	// --- Upload pipeline ----------------------------------------------------------------------------

	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_postBinary(pURL, pFile, pOnProgress) { return new Promise((resolve, reject) => this.restClient.postBinary(pURL, pFile, pFile.type || 'application/octet-stream', (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)), pOnProgress)); }

	/**
	 * Upload raw bytes with LIVE progress. The rest client's postBinary buffers the whole File (arrayBuffer) and
	 * fires its progress callback only ONCE at completion, so a real per-file bar needs `XMLHttpRequest.upload.
	 * onprogress`. We POST straight to the same-origin media route with `withCredentials` — the config-app rest
	 * client authenticates purely by the ambient session cookie (it sets no SessionToken/Bearer header), so the
	 * cookie rides along and the request is identical to postBinary's, just observable. Falls back to postBinary
	 * when XHR upload progress isn't available (non-browser / no upload object).
	 * @param {String} pURL rest path (e.g. 'Artifact/Media/123/1')
	 * @param {File} pFile
	 * @param {Function} pOnProgress receives a ProgressEvent (lengthComputable/loaded/total)
	 */
	_uploadBytesAsync(pURL, pFile, pOnProgress)
	{
		if ((typeof XMLHttpRequest === 'undefined') || !this.restClient || (typeof this.restClient.formatUrl !== 'function'))
		{
			return this._postBinary(pURL, pFile, pOnProgress);
		}
		return new Promise((resolve, reject) =>
		{
			let tmpXHR = null;
			try { tmpXHR = new XMLHttpRequest(); } catch (pErr) { tmpXHR = null; }
			if (!tmpXHR || !tmpXHR.upload) { this._postBinary(pURL, pFile, pOnProgress).then(resolve, reject); return; }
			tmpXHR.open('POST', this.restClient.formatUrl(pURL), true);
			tmpXHR.withCredentials = true;   // send the ambient UserSession cookie (same-origin /1.0/)
			try { tmpXHR.setRequestHeader('Content-Type', pFile.type || 'application/octet-stream'); } catch (pErr) { /* header already fixed by the agent in rare states */ }
			tmpXHR.upload.onprogress = (pEvent) => { if (typeof pOnProgress === 'function') { pOnProgress(pEvent); } };
			tmpXHR.onload = () =>
			{
				if (tmpXHR.status >= 200 && tmpXHR.status < 300) { resolve(tmpXHR.responseText); }
				else { reject(new Error(`Upload failed (HTTP ${tmpXHR.status || 0}).`)); }
			};
			tmpXHR.onerror = () => reject(new Error('Upload failed — network error.'));
			tmpXHR.onabort = () => reject(new Error('Upload cancelled.'));
			try { tmpXHR.send(pFile); } catch (pErr) { reject(pErr); }
		});
	}

	/** A row's Designated Date as a DesignatedTime datetime. Noon UTC so the calendar day doesn't shift under a
	 *  timezone when it round-trips (we read the day back off the ISO date part). Falls back to now. */
	_designatedTimeFromRow(pRow)
	{
		const tmpISO = String(pRow.DateISO || '').trim();
		if (/^\d{4}-\d{2}-\d{2}$/.test(tmpISO)) { return `${tmpISO}T12:00:00.000Z`; }
		return new Date().toISOString();
	}

	/** Percent (0-100) out of whatever postBinary hands the progress callback, or null when not computable. */
	_progressPercent(pEvent)
	{
		if (pEvent == null) { return null; }
		if (typeof pEvent === 'number') { return (pEvent <= 1) ? Math.round(pEvent * 100) : Math.round(pEvent); }
		if (pEvent.lengthComputable && pEvent.total) { return Math.round((pEvent.loaded / pEvent.total) * 100); }
		if (typeof pEvent.percent === 'number') { return Math.round(pEvent.percent); }
		if ((typeof pEvent.loaded === 'number') && (typeof pEvent.total === 'number') && pEvent.total) { return Math.round((pEvent.loaded / pEvent.total) * 100); }
		return null;
	}

	/** Create the Observation for a row (server provisions its Artifact). Returns { IDObservation, IDArtifact, Version, datumType }. */
	async _createObservationAsync(pRow)
	{
		const tmpDatumType = pRow.ObservationType.replace(/^Legacy\s+/, '');
		const tmpArtifactType = ARTIFACT_TYPE_FOR_DATUM[tmpDatumType] || tmpDatumType;
		const tmpName = String(pRow.Name || '').trim() || this._stripExtension(pRow.FileName) || `New ${tmpDatumType}`;
		const tmpObservation = {
			Name: tmpName, Description: '', Tags: [], ObservationType: pRow.ObservationType,
			DesignatedTime: this._designatedTimeFromRow(pRow),
			Details: { [tmpDatumType]: [ { ArtifactType: tmpArtifactType, IDArtifact: 0, Datum: { FileName: pRow.FileName, FileMimeType: pRow.Mime || '' } } ] },
			IDObservation: 0, IDProject: this._idProject,
			CaptureLatitude: '0.00000000', CaptureLongitude: '0.00000000',
			UserLatitude: '0.00000000', UserLongitude: '0.00000000',
			AlignmentStation: 0, AlignmentOffset: 0,
		};
		const tmpNewObs = await this._postJSON('Observation', tmpObservation);
		const tmpArtifact = tmpNewObs && tmpNewObs.Details && tmpNewObs.Details[tmpDatumType] && tmpNewObs.Details[tmpDatumType][0];
		if (!tmpNewObs || !tmpNewObs.IDObservation || !tmpArtifact || !tmpArtifact.IDArtifact)
		{
			throw new Error('Could not create the observation for this file.');
		}
		return { IDObservation: tmpNewObs.IDObservation, IDArtifact: tmpArtifact.IDArtifact, Version: tmpArtifact.Version, datumType: tmpDatumType };
	}

	/** Upload one staged (or previously-errored) row: create observation → POST bytes, driving row + overall
	 *  progress through pOnTick(). Marks the row done or error; never throws (errors land on the row). */
	async _uploadRowAsync(pRow, pOnTick)
	{
		if (!pRow || !pRow.File) { return; }
		pRow.Status = 'uploading';
		pRow.Progress = 0;
		pRow.UploadedBytes = 0;
		pRow.Message = '';
		if (this.view) { this.view.paintRow(pRow.UID); }
		try
		{
			const tmpArt = await this._createObservationAsync(pRow);
			pRow.IDObservation = tmpArt.IDObservation;
			// The observation POST is a small slice of the work; the bytes are the rest. Start the bar at 3%.
			pRow.Progress = 3;
			pRow.UploadedBytes = Math.round(pRow.Size * 0.03);
			if (this.view) { this.view.paintRow(pRow.UID); }
			if (typeof pOnTick === 'function') { pOnTick(); }

			await this._uploadBytesAsync(`Artifact/Media/${tmpArt.IDArtifact}/${tmpArt.Version}`, pRow.File, (pEvent) =>
			{
				const tmpPct = this._progressPercent(pEvent);
				if (tmpPct !== null)
				{
					pRow.Progress = Math.max(3, Math.min(99, 3 + Math.round(tmpPct * 0.97)));
					pRow.UploadedBytes = Math.round(pRow.Size * (pRow.Progress / 100));
					if (this.view) { this.view.paintRow(pRow.UID); }
					if (typeof pOnTick === 'function') { pOnTick(); }
				}
			});

			pRow.Status = 'done';
			pRow.Progress = 100;
			pRow.UploadedBytes = pRow.Size;
			pRow.File = null;   // free the bytes; metadata + IDObservation remain for post-edit
		}
		catch (pError)
		{
			pRow.Status = 'error';
			pRow.Message = (pError && pError.message) ? pError.message : 'Upload failed.';
			this.pict.log.error(`BulkUpload: row ${pRow.UID} failed: ${pRow.Message}`, pError);
		}
		if (this.view) { this.view.paintRow(pRow.UID); }
		if (typeof pOnTick === 'function') { pOnTick(); }
	}

	/**
	 * Upload every staged/errored row through a small concurrency pool (retries errored rows too). Per-row progress
	 * lands via the view's paintRow; overall progress via paintOverall. Returns a { done, failed, total } summary.
	 */
	async uploadAllAsync()
	{
		if (this._uploading) { return null; }
		if (!this.canUpload())
		{
			const tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal && tmpModal.toast) { tmpModal.toast('You don’t have permission to create observations on this project.', { type: 'error', duration: 6000 }); }
			return null;
		}
		const tmpPending = this._rows.filter((pRow) => (pRow.Status === 'staged') || (pRow.Status === 'error'));
		if (!tmpPending.length) { return null; }

		this._uploading = true;
		this.state.Uploading = true;
		if (this.view) { this.view.paintToolbar(); }
		const fTick = () => { if (this.view) { this.view.paintOverall(); } };
		fTick();

		const tmpConcurrency = Math.min(3, tmpPending.length);
		let tmpIndex = 0;
		const fWorker = async () =>
		{
			while (tmpIndex < tmpPending.length)
			{
				const tmpRow = tmpPending[tmpIndex++];
				await this._uploadRowAsync(tmpRow, fTick);
			}
		};
		await Promise.all(Array.from({ length: tmpConcurrency }, fWorker));

		this._uploading = false;
		this.state.Uploading = false;
		const tmpDone = this._rows.filter((pRow) => pRow.Status === 'done').length;
		const tmpFailed = this._rows.filter((pRow) => pRow.Status === 'error').length;
		this._render();   // full repaint: final states + re-enabled toolbar + summary
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && tmpModal.toast)
		{
			if (!tmpFailed) { tmpModal.toast(`Uploaded ${tmpDone} observation${tmpDone === 1 ? '' : 's'}.`, { type: 'success' }); }
			else if (tmpDone) { tmpModal.toast(`Uploaded ${tmpDone}; ${tmpFailed} failed — fix and retry.`, { type: 'warning', duration: 7000 }); }
			else { tmpModal.toast(`All ${tmpFailed} uploads failed.`, { type: 'error', duration: 7000 }); }
		}
		return { done: tmpDone, failed: tmpFailed, total: this._rows.length };
	}

	/** Persist a post-upload Name/DesignatedTime edit to an already-created observation (full-record PUT). */
	async _persistRowEditAsync(pRow)
	{
		try
		{
			const tmpObs = await this._getJSON(`Observation/${pRow.IDObservation}`);
			if (!tmpObs || !tmpObs.IDObservation) { throw new Error('Observation not found.'); }
			const tmpName = String(pRow.Name || '').trim() || tmpObs.Name;
			await this._putJSON('Observation', Object.assign({}, tmpObs, { Name: tmpName, DesignatedTime: this._designatedTimeFromRow(pRow) }));
		}
		catch (pError)
		{
			this.pict.log.error(`BulkUpload: could not update observation ${pRow.IDObservation}: ${pError && pError.message ? pError.message : pError}`, pError);
			const tmpModal = this.pict.views['Pict-Section-Modal'];
			if (tmpModal && tmpModal.toast) { tmpModal.toast('Could not save that change — try again.', { type: 'error', duration: 5000 }); }
		}
	}

	// --- Overall progress accounting (byte-weighted) ------------------------------------------------

	/** { totalBytes, uploadedBytes, percent, done, failed, uploading, total } for the overall bar + counts. */
	overallStats()
	{
		let tmpTotal = 0;
		let tmpUploaded = 0;
		let tmpDone = 0;
		let tmpFailed = 0;
		let tmpUploading = 0;
		this._rows.forEach((pRow) =>
		{
			const tmpSize = Math.max(pRow.Size || 0, 1);   // guard zero-byte files so they still weigh in
			tmpTotal += tmpSize;
			if (pRow.Status === 'done') { tmpUploaded += tmpSize; tmpDone++; }
			else if (pRow.Status === 'error') { tmpFailed++; }
			else if (pRow.Status === 'uploading') { tmpUploaded += Math.min(tmpSize, pRow.UploadedBytes || 0); tmpUploading++; }
		});
		const tmpPercent = tmpTotal > 0 ? Math.round((tmpUploaded / tmpTotal) * 100) : 0;
		return { totalBytes: tmpTotal, uploadedBytes: tmpUploaded, percent: tmpPercent, done: tmpDone, failed: tmpFailed, uploading: tmpUploading, total: this._rows.length };
	}
}

module.exports = BulkUploadProvider;
module.exports.default_configuration = { ProviderIdentifier: 'BulkUpload' };

},{"pict-provider":845}],1309:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libCertConfig = require('../Certification-Config.js');

// Mount points (the CertificationTypes view lays these out; this provider fills them with hand-built HTML).
const RAIL_MOUNT = '#CertTypes-Rail';
const RAIL_LIST_MOUNT = '#CertTypes-Rail-List';
const DETAIL_MOUNT = '#CertTypes-Detail';

const HOLDER_CHOICES = libCertConfig.HOLDER_CERTIFIABLE_LIST;   // User/Material/Lab/Equipment/Test
const APPLIES_CHOICES = libCertConfig.APPLIES_TO_KIND_LIST;     // Material/Lab/Test/Equipment
const STARTER_TYPES = libCertConfig.STARTER_TYPES;             // suggested starter catalog for empty tenants
const KIND_LABEL = (pKind) => (libCertConfig.HOLDER_KIND_BY_TYPE[pKind] ? libCertConfig.HOLDER_KIND_BY_TYPE[pKind].Label : pKind);

/**
 * CertificationTypes — the #/CertificationTypes management screen. Create/edit the certification-type CATALOG
 * (Name / Hash / Verb / Description) AND each type's per-type CONFIG (which entity kinds it certifies — holders — and
 * certifies-for, plus a default validity), stored in the cascading Configuration service (namespace
 * CertificationTypeConfig, one NamespaceValue per type). That config drives the "simplified interface" on the
 * #/Certifications workspace (pre-scoped / collapsed kind pickers).
 *
 * Gated by the CertificationType capabilities (Read to see, Update/Create/Delete to edit) — server stays
 * authoritative. Config writes go to Customer scope; the client never sends IDCustomer.
 */
class CertificationTypesProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._typeSearchTimer = null;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID) : 0; }

	// ── Capability gates (server authoritative; fail-open before the map loads) ───
	_can(pEntity, pAction)
	{
		const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
		if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function')) { return tmpApp.EffectivePermissionsService.can(pEntity, pAction); }
		return true;
	}
	canCreate() { return this._can('CertificationType', 'Create'); }
	canEditDef() { return this._can('CertificationType', 'Update'); }
	canDelete() { return this._can('CertificationType', 'Delete'); }

	get state()
	{
		if (!this.pict.AppData.CertificationTypes)
		{
			this.pict.AppData.CertificationTypes =
			{
				Loaded: false, Loading: false,
				Types: [], TypeSearch: '',
				SelectedTypeID: 0, SelectedType: null,
				// definition editor
				Editing: { Name: '', Hash: '', Verb: '', Description: '' }, DefSaving: false, DefError: '', DefNotice: '',
				// per-type config editor (normalized blob or null while loading)
				Config: null, ConfigSaving: false, ConfigError: '', ConfigNotice: '',
				// create / delete
				ShowNew: false, NewFields: { Name: '', Hash: '', Verb: '', Description: '' }, NewSaving: false, NewError: '',
				DeleteConfirm: false, Deleting: false,
				// starter suggestions (shown while the catalog started empty)
				StarterMode: false, AdoptBusy: -1, StarterNotice: '',
			};
		}
		return this.pict.AppData.CertificationTypes;
	}

	// ── REST helpers ─────────────────────────────────────────────────────────────
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_deleteEntity(pEntity, pID) { const tmpRC = this.restClient; return (tmpRC && (typeof tmpRC.deleteEntity === 'function')) ? new Promise((resolve) => tmpRC.deleteEntity(pEntity, pID, (pErr) => resolve(!pErr))) : Promise.resolve(false); }

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_typeLabel(pType) { if (!pType) { return ''; } return String(pType.Name || pType.Hash || `Type ${pType.IDCertificationType}`); }
	_typeSub(pType) { if (!pType) { return ''; } return [ pType.Verb, (pType.Name ? pType.Hash : '') ].filter((pBit) => pBit).join(' · '); }

	// ── Load ─────────────────────────────────────────────────────────────────────
	loadAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return; }
		tmpState.Loading = true;
		this.render();
		this._getJSON(`CertificationTypes/FilteredTo/FBV~Deleted~EQ~0~FSF~Hash~ASC~0/0/2000`).then((pRows) =>
		{
			tmpState.Types = (Array.isArray(pRows) ? pRows : []).slice();
			// An empty catalog gets the "get started" suggestions; stays on for this session so several can be adopted.
			if (!tmpState.Types.length) { tmpState.StarterMode = true; }
			tmpState.Loaded = true;
			tmpState.Loading = false;
			this.render();
		});
	}

	// ── Starter suggestions (empty-tenant onboarding) ────────────────────────────
	_unadoptedStarters()
	{
		const tmpState = this.state;
		const tmpHave = {};
		(tmpState.Types || []).forEach((pT) => { if (pT.Hash) { tmpHave[String(pT.Hash).toLowerCase()] = true; } if (pT.Name) { tmpHave[String(pT.Name).toLowerCase()] = true; } });
		return STARTER_TYPES.map((pStarter, pIndex) => ({ Starter: pStarter, Index: pIndex }))
			.filter((pRow) => !tmpHave[String(pRow.Starter.Hash).toLowerCase()] && !tmpHave[String(pRow.Starter.Name).toLowerCase()]);
	}

	/** Return to the suggestions panel (deselect any type). */
	showSuggestions() { const tmpState = this.state; tmpState.SelectedTypeID = 0; tmpState.SelectedType = null; tmpState.ShowNew = false; tmpState.StarterNotice = ''; this.render(); }

	/** Adopt a suggested type: create the CertificationType, then best-effort save its bundled config. Stays on the
	 * suggestions panel so several can be adopted in a row. */
	async adoptStarterAsync(pIndex)
	{
		const tmpState = this.state;
		if (!this.canCreate() || (tmpState.AdoptBusy > -1)) { return; }
		const tmpStarter = STARTER_TYPES[Number(pIndex)];
		if (!tmpStarter) { return; }
		tmpState.AdoptBusy = Number(pIndex); tmpState.StarterNotice = '';
		this.render();
		const tmpRes = await this._postJSON('CertificationType', { IDCertificationType: 0, Name: tmpStarter.Name, Hash: tmpStarter.Hash, Verb: tmpStarter.Verb, Description: tmpStarter.Description });
		const tmpType = tmpRes && tmpRes.result;
		if (tmpRes.error || !tmpType || !tmpType.IDCertificationType)
		{
			tmpState.AdoptBusy = -1; tmpState.StarterNotice = `Could not add “${tmpStarter.Name}” (you may lack permission).`;
			this.render();
			return;
		}
		tmpState.Types.push(tmpType);
		tmpState.Types.sort((pA, pB) => String(pA.Hash || pA.Name || '').localeCompare(String(pB.Hash || pB.Name || '')));
		// best-effort: apply the starter's bundled config so the adopted type is ready + simplified (Customer scope may 403)
		const tmpBlob = { HolderKinds: tmpStarter.HolderKinds.slice(), AppliesToKinds: tmpStarter.AppliesToKinds.slice(), DefaultValidityYears: Number(tmpStarter.DefaultValidityYears) || 0 };
		await this._postJSON(`Configuration/Put/${libCertConfig.CERT_CONFIG_NAMESPACE}/${libCertConfig.configNamespaceValue(tmpType.IDCertificationType)}/Customer/${this.callerCustomer()}`, { Config: tmpBlob });
		tmpState.AdoptBusy = -1; tmpState.StarterNotice = `Added “${tmpStarter.Name}”.`;
		this.render();
	}

	setTypeSearch(pValue)
	{
		this.state.TypeSearch = String(pValue == null ? '' : pValue);
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length > 0) { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		else { this.render(); }
	}

	selectType(pIDCertificationType)
	{
		const tmpState = this.state;
		const tmpID = Number(pIDCertificationType);
		tmpState.SelectedTypeID = tmpID;
		tmpState.SelectedType = (tmpState.Types || []).find((pType) => Number(pType.IDCertificationType) === tmpID) || null;
		tmpState.ShowNew = false;
		tmpState.DeleteConfirm = false;
		tmpState.DefError = ''; tmpState.DefNotice = ''; tmpState.ConfigError = ''; tmpState.ConfigNotice = '';
		tmpState.Config = null;
		const tmpType = tmpState.SelectedType;
		tmpState.Editing = tmpType
			? { Name: String(tmpType.Name || ''), Hash: String(tmpType.Hash || ''), Verb: String(tmpType.Verb || ''), Description: String(tmpType.Description || '') }
			: { Name: '', Hash: '', Verb: '', Description: '' };
		this.render();
		if (tmpID > 0) { this._loadConfigAsync(tmpID, tmpType); }
	}

	_loadConfigAsync(pTypeID, pType)
	{
		const tmpState = this.state;
		this._postJSON('Configuration/Get', { LevelContext: 'Customer', LevelContextID: this.callerCustomer(), NamespaceKey: libCertConfig.CERT_CONFIG_NAMESPACE, NamespaceValue: libCertConfig.configNamespaceValue(pTypeID) }).then((pRes) =>
		{
			if (Number(tmpState.SelectedTypeID) !== Number(pTypeID)) { return; }
			const tmpBody = (pRes && (pRes.result !== undefined)) ? pRes.result : pRes;
			const tmpRaw = (tmpBody && (tmpBody.Config !== undefined)) ? tmpBody.Config : ((tmpBody && tmpBody.Document) || tmpBody);
			tmpState.Config = libCertConfig.normalizeConfig(tmpRaw, pType);
			this.render();
		});
	}

	// ── Definition (Name / Hash / Verb / Description) ────────────────────────────
	setEditField(pField, pValue) { const tmpState = this.state; if (Object.prototype.hasOwnProperty.call(tmpState.Editing, pField)) { tmpState.Editing[pField] = String(pValue == null ? '' : pValue); } }

	async saveDefAsync()
	{
		const tmpState = this.state;
		if (!this.canEditDef() || tmpState.DefSaving) { return; }
		const tmpType = tmpState.SelectedType;
		if (!tmpType) { return; }
		const tmpName = String(tmpState.Editing.Name || '').trim();
		const tmpHash = String(tmpState.Editing.Hash || '').trim();
		if (!tmpName && !tmpHash) { tmpState.DefError = 'Give the certification a name (or a hash/code).'; tmpState.DefNotice = ''; this.render(); return; }
		tmpState.DefSaving = true; tmpState.DefError = ''; tmpState.DefNotice = '';
		this.render();
		const tmpBody = Object.assign({}, tmpType, { Name: tmpName, Hash: tmpHash, Verb: String(tmpState.Editing.Verb || '').trim(), Description: String(tmpState.Editing.Description || '') });
		const tmpRes = await this._putJSON(`CertificationType/${Number(tmpType.IDCertificationType)}`, tmpBody);
		tmpState.DefSaving = false;
		if (tmpRes.error) { tmpState.DefError = 'The server rejected the change (you may lack permission).'; this.render(); return; }
		const tmpSaved = (tmpRes.result && tmpRes.result.IDCertificationType) ? tmpRes.result : tmpBody;
		const tmpIdx = tmpState.Types.findIndex((pT) => Number(pT.IDCertificationType) === Number(tmpType.IDCertificationType));
		if (tmpIdx > -1) { tmpState.Types[tmpIdx] = tmpSaved; }
		tmpState.SelectedType = tmpSaved;
		tmpState.Types.sort((pA, pB) => String(pA.Hash || pA.Name || '').localeCompare(String(pB.Hash || pB.Name || '')));
		tmpState.DefNotice = 'Saved.';
		this.render();
	}

	// ── Per-type config (holders / certifies-for / validity) ─────────────────────
	toggleConfigKind(pList, pKind, pChecked)
	{
		const tmpState = this.state;
		if (!tmpState.Config) { return; }
		const tmpKey = (pList === 'Holder') ? 'HolderKinds' : 'AppliesToKinds';
		const tmpAllowed = (pList === 'Holder') ? HOLDER_CHOICES : APPLIES_CHOICES;
		if (tmpAllowed.indexOf(pKind) === -1) { return; }
		const tmpSet = tmpState.Config[tmpKey].filter((pK) => pK !== pKind);
		if (pChecked) { tmpSet.push(pKind); }
		// preserve canonical order
		tmpState.Config[tmpKey] = tmpAllowed.filter((pK) => tmpSet.indexOf(pK) > -1);
		tmpState.ConfigNotice = ''; tmpState.ConfigError = '';
	}

	setConfigValidity(pValue)
	{
		const tmpState = this.state;
		if (!tmpState.Config) { return; }
		const tmpN = Number(pValue);
		tmpState.Config.DefaultValidityYears = (tmpN >= 0 && Number.isFinite(tmpN)) ? tmpN : 0;
		tmpState.ConfigNotice = ''; tmpState.ConfigError = '';
	}

	async saveConfigAsync()
	{
		const tmpState = this.state;
		if (!this.canEditDef() || tmpState.ConfigSaving || !tmpState.Config || !tmpState.SelectedType) { return; }
		if (!tmpState.Config.HolderKinds.length) { tmpState.ConfigError = 'Pick at least one kind this certification certifies.'; this.render(); return; }
		tmpState.ConfigSaving = true; tmpState.ConfigError = ''; tmpState.ConfigNotice = '';
		this.render();
		const tmpBlob = { HolderKinds: tmpState.Config.HolderKinds.slice(), AppliesToKinds: tmpState.Config.AppliesToKinds.slice(), DefaultValidityYears: Number(tmpState.Config.DefaultValidityYears) || 0 };
		const tmpNSV = libCertConfig.configNamespaceValue(tmpState.SelectedTypeID);
		const tmpRes = await this._postJSON(`Configuration/Put/${libCertConfig.CERT_CONFIG_NAMESPACE}/${tmpNSV}/Customer/${this.callerCustomer()}`, { Config: tmpBlob });
		tmpState.ConfigSaving = false;
		if (tmpRes.error) { tmpState.ConfigError = 'The server rejected the configuration (Customer-level config may need an administrator).'; this.render(); return; }
		tmpState.ConfigNotice = 'Configuration saved.';
		// re-read so the view reflects the server's cascade/diff
		this._loadConfigAsync(Number(tmpState.SelectedTypeID), tmpState.SelectedType);
	}

	// ── New type ─────────────────────────────────────────────────────────────────
	showNew() { const tmpState = this.state; tmpState.ShowNew = true; tmpState.SelectedTypeID = 0; tmpState.SelectedType = null; tmpState.NewFields = { Name: '', Hash: '', Verb: '', Description: '' }; tmpState.NewError = ''; this.render(); }
	setNewField(pField, pValue) { const tmpState = this.state; if (Object.prototype.hasOwnProperty.call(tmpState.NewFields, pField)) { tmpState.NewFields[pField] = String(pValue == null ? '' : pValue); } }
	cancelNew() { this.state.ShowNew = false; this.render(); }

	async createTypeAsync()
	{
		const tmpState = this.state;
		if (!this.canCreate() || tmpState.NewSaving) { return; }
		const tmpName = String(tmpState.NewFields.Name || '').trim();
		const tmpHash = String(tmpState.NewFields.Hash || '').trim();
		if (!tmpName && !tmpHash) { tmpState.NewError = 'Give the certification a name (or a hash/code).'; this.render(); return; }
		tmpState.NewSaving = true; tmpState.NewError = '';
		this.render();
		const tmpRes = await this._postJSON('CertificationType', { IDCertificationType: 0, Name: tmpName, Hash: tmpHash, Verb: String(tmpState.NewFields.Verb || '').trim(), Description: String(tmpState.NewFields.Description || '') });
		tmpState.NewSaving = false;
		const tmpType = tmpRes && tmpRes.result;
		if (tmpRes.error || !tmpType || !tmpType.IDCertificationType) { tmpState.NewError = 'The server rejected the new certification type.'; this.render(); return; }
		tmpState.Types.push(tmpType);
		tmpState.Types.sort((pA, pB) => String(pA.Hash || pA.Name || '').localeCompare(String(pB.Hash || pB.Name || '')));
		tmpState.ShowNew = false;
		this.selectType(Number(tmpType.IDCertificationType));
	}

	// ── Delete ───────────────────────────────────────────────────────────────────
	askDelete() { this.state.DeleteConfirm = true; this.render(); }
	cancelDelete() { this.state.DeleteConfirm = false; this.render(); }
	async deleteTypeAsync()
	{
		const tmpState = this.state;
		if (!this.canDelete() || tmpState.Deleting || !tmpState.SelectedType) { return; }
		tmpState.Deleting = true;
		this.render();
		const tmpID = Number(tmpState.SelectedTypeID);
		const tmpOK = await this._deleteEntity('CertificationType', tmpID);
		tmpState.Deleting = false;
		tmpState.DeleteConfirm = false;
		if (!tmpOK) { tmpState.DefError = 'The server refused to delete this certification type (you may lack permission, or it is in use).'; this.render(); return; }
		tmpState.Types = tmpState.Types.filter((pT) => Number(pT.IDCertificationType) !== tmpID);
		tmpState.SelectedTypeID = 0; tmpState.SelectedType = null; tmpState.Config = null;
		this.render();
	}

	/** Jump to the #/Certifications workspace to certify holders of the selected type (hash router). */
	goCertify() { window.location.hash = '#/Certifications'; }

	// ── Render ───────────────────────────────────────────────────────────────────
	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_MOUNT).length === 0) { return; }
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length === 0) { tmpCA.assignContent(RAIL_MOUNT, this._railHTML()); }
		else { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML());
	}

	_railHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Loaded) { return '<div class="ctp-empty">Loading…</div>'; }
		const tmpNew = this.canCreate() ? `<button class="ctp-newtype-btn" onclick="_Pict.providers.CertificationTypes.showNew()"><i class="fas fa-plus"></i> New certification type</button>` : '';
		// While bootstrapping an empty tenant, offer a way back to the suggestions once a type is selected / being created.
		const tmpSuggest = (tmpState.StarterMode && this._unadoptedStarters().length && (tmpState.SelectedTypeID || tmpState.ShowNew)) ? `<button class="ctp-newtype-btn ctp-suggest-btn" onclick="_Pict.providers.CertificationTypes.showSuggestions()"><i class="fas fa-wand-magic-sparkles"></i> Suggested types</button>` : '';
		return `<input class="ctp-rail-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search certification types…" value="${this._esc(tmpState.TypeSearch || '')}" oninput="_Pict.providers.CertificationTypes.setTypeSearch(this.value)" />`
			+ tmpNew + tmpSuggest
			+ `<div id="CertTypes-Rail-List" class="ctp-rail-list">${this._railListHTML()}</div>`;
	}

	_railListHTML()
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.TypeSearch || '').trim().toLowerCase();
		const tmpTypes = (tmpState.Types || []).filter((pType) => !tmpQuery
			|| String(this._typeLabel(pType)).toLowerCase().indexOf(tmpQuery) > -1
			|| String(pType.Verb || '').toLowerCase().indexOf(tmpQuery) > -1
			|| String(pType.Description || '').toLowerCase().indexOf(tmpQuery) > -1);
		if (!tmpTypes.length) { return `<div class="ctp-empty">${tmpQuery ? 'No certification types match.' : 'No certification types yet.'}</div>`; }
		return tmpTypes.map((pType) =>
		{
			const tmpActive = (Number(tmpState.SelectedTypeID) === Number(pType.IDCertificationType)) ? ' is-active' : '';
			const tmpSub = this._typeSub(pType);
			return `<div class="ctp-rail-item${tmpActive}" onclick="_Pict.providers.CertificationTypes.selectType(${Number(pType.IDCertificationType)})"><div class="ctp-rail-name">${this._esc(this._typeLabel(pType))}</div>${tmpSub ? `<div class="ctp-rail-sub">${this._esc(tmpSub)}</div>` : ''}</div>`;
		}).join('');
	}

	_detailHTML()
	{
		const tmpState = this.state;
		if (tmpState.ShowNew) { return this._newTypeHTML(); }
		if (!tmpState.SelectedTypeID || !tmpState.SelectedType)
		{
			if (tmpState.StarterMode) { return this._suggestionsHTML(); }
			return '<div class="ctp-detail-empty">Pick a certification type on the left to edit it and configure what it certifies — or create a new type.</div>';
		}
		const tmpType = tmpState.SelectedType;
		return `<div class="ctp-detail-head"><div class="ctp-detail-title">${this._esc(this._typeLabel(tmpType))}</div>`
			+ `<div class="ctp-detail-sub">${this._esc(this._typeSub(tmpType))}</div>`
			+ `<button class="ctp-btn ctp-btn-ghost ctp-go" onclick="_Pict.providers.CertificationTypes.goCertify()"><i class="fas fa-award"></i> Certify holders →</button></div>`
			+ this._defHTML()
			+ this._configHTML()
			+ this._dangerHTML();
	}

	_suggestionsHTML()
	{
		const tmpState = this.state;
		const tmpUnadopted = this._unadoptedStarters();
		const tmpNotice = tmpState.StarterNotice ? `<div class="ctp-notice">${this._esc(tmpState.StarterNotice)}</div>` : '';
		const tmpCanCreate = this.canCreate();
		if (!tmpUnadopted.length)
		{
			return `<div class="ctp-detail-head"><div class="ctp-detail-title">You're all set</div><div class="ctp-detail-sub">Every suggested certification type has been added.</div></div>`
				+ tmpNotice
				+ `<div class="ctp-section"><p class="ctp-note">Pick a certification type on the left to configure what it certifies — or add your own with <b>+ New certification type</b>.</p></div>`;
		}
		const tmpCards = tmpUnadopted.map((pRow) =>
		{
			const tmpStarter = pRow.Starter;
			const tmpHolders = tmpStarter.HolderKinds.map((pK) => KIND_LABEL(pK)).join(', ');
			const tmpApplies = tmpStarter.AppliesToKinds.map((pK) => KIND_LABEL(pK)).join(', ');
			const tmpValidity = (tmpStarter.DefaultValidityYears > 0) ? ` · ${tmpStarter.DefaultValidityYears}-yr validity` : '';
			const tmpBusy = (tmpState.AdoptBusy === pRow.Index);
			const tmpBtn = tmpCanCreate ? `<button class="ctp-btn ctp-btn-primary ctp-adopt"${tmpBusy ? ' disabled' : ''} onclick="_Pict.providers.CertificationTypes.adoptStarterAsync(${pRow.Index})">${tmpBusy ? 'Adding…' : 'Adopt'}</button>` : '';
			return `<div class="ctp-suggest"><div class="ctp-suggest-main">`
				+ `<div class="ctp-suggest-name">${this._esc(tmpStarter.Name)}</div>`
				+ `<div class="ctp-suggest-desc">${this._esc(tmpStarter.Description)}</div>`
				+ `<div class="ctp-suggest-meta">Certifies ${this._esc(tmpHolders)} · for ${this._esc(tmpApplies)}${this._esc(tmpValidity)}</div>`
				+ `</div>${tmpBtn}</div>`;
		}).join('');
		return `<div class="ctp-detail-head"><div class="ctp-detail-title">Get started</div><div class="ctp-detail-sub">No certification types yet — adopt a common one to create it (pre-configured), then tweak as needed.</div></div>`
			+ tmpNotice
			+ `<div class="ctp-suggest-list">${tmpCards}</div>`
			+ (tmpCanCreate ? `<p class="ctp-note">…or use <b>+ New certification type</b> on the left to build your own.</p>` : '');
	}

	_defHTML()
	{
		const tmpState = this.state;
		const tmpEditable = this.canEditDef();
		const tmpE = tmpState.Editing;
		const tmpDis = tmpEditable ? '' : ' disabled';
		const tmpNotice = tmpState.DefNotice ? `<div class="ctp-notice">${this._esc(tmpState.DefNotice)}</div>` : '';
		const tmpError = tmpState.DefError ? `<div class="ctp-error">${this._esc(tmpState.DefError)}</div>` : '';
		const tmpBusy = tmpState.DefSaving ? '<span class="ctp-busy">saving…</span>' : '';
		const tmpSave = tmpEditable ? `<div class="ctp-add-row"><button class="ctp-btn ctp-btn-primary" onclick="_Pict.providers.CertificationTypes.saveDefAsync()">Save definition</button>${tmpBusy}</div>` : '<p class="ctp-note">Editing certification types needs the Update-certification-type permission.</p>';
		return `<div class="ctp-section"><div class="ctp-section-head">Definition</div>`
			+ `<label class="ctp-field"><span>Name</span><input type="text"${tmpDis} value="${this._esc(tmpE.Name)}" oninput="_Pict.providers.CertificationTypes.setEditField('Name', this.value)"></label>`
			+ `<label class="ctp-field"><span>Verb</span><input type="text"${tmpDis} value="${this._esc(tmpE.Verb)}" placeholder="e.g. Collect Sample" oninput="_Pict.providers.CertificationTypes.setEditField('Verb', this.value)"></label>`
			+ `<label class="ctp-field"><span>Hash / code</span><input type="text"${tmpDis} value="${this._esc(tmpE.Hash)}" placeholder="(short code)" oninput="_Pict.providers.CertificationTypes.setEditField('Hash', this.value)"></label>`
			+ `<label class="ctp-field"><span>Description</span><textarea rows="2"${tmpDis} oninput="_Pict.providers.CertificationTypes.setEditField('Description', this.value)">${this._esc(tmpE.Description)}</textarea></label>`
			+ tmpSave + tmpNotice + tmpError + `</div>`;
	}

	_kindCheckboxes(pList, pChoices, pSelected)
	{
		const tmpEditable = this.canEditDef();
		return pChoices.map((pKind) =>
		{
			const tmpChecked = (pSelected.indexOf(pKind) > -1) ? ' checked' : '';
			const tmpDis = tmpEditable ? '' : ' disabled';
			return `<label class="ctp-check"><input type="checkbox"${tmpChecked}${tmpDis} onchange="_Pict.providers.CertificationTypes.toggleConfigKind('${pList}', '${pKind}', this.checked)"> ${this._esc(KIND_LABEL(pKind))}</label>`;
		}).join('');
	}

	_configHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Config) { return `<div class="ctp-section"><div class="ctp-section-head">What this certifies</div><p class="ctp-note">Loading…</p></div>`; }
		const tmpCfg = tmpState.Config;
		const tmpEditable = this.canEditDef();
		const tmpDefaultsNote = tmpCfg.Configured ? '' : `<div class="ctp-hint"><i class="fas fa-circle-info"></i> Using built-in defaults — not yet saved for this type. Adjust and save to lock them in.</div>`;
		const tmpNotice = tmpState.ConfigNotice ? `<div class="ctp-notice">${this._esc(tmpState.ConfigNotice)}</div>` : '';
		const tmpError = tmpState.ConfigError ? `<div class="ctp-error">${this._esc(tmpState.ConfigError)}</div>` : '';
		const tmpBusy = tmpState.ConfigSaving ? '<span class="ctp-busy">saving…</span>' : '';
		const tmpValidity = `<label class="ctp-field ctp-field-inline"><span>Default validity (years)</span><input type="number" min="0" step="1"${tmpEditable ? '' : ' disabled'} value="${Number(tmpCfg.DefaultValidityYears) || 0}" onchange="_Pict.providers.CertificationTypes.setConfigValidity(this.value)"><span class="ctp-hint-inline">0 = no default expiry</span></label>`;
		const tmpSave = tmpEditable ? `<div class="ctp-add-row"><button class="ctp-btn ctp-btn-primary" onclick="_Pict.providers.CertificationTypes.saveConfigAsync()">Save configuration</button>${tmpBusy}</div>` : '';
		return `<div class="ctp-section"><div class="ctp-section-head">What this certifies</div>`
			+ `<p class="ctp-note">Controls the #/Certifications screen: a type with a single holder kind hides the picker (a User-only cert just says “certify users”).</p>`
			+ tmpDefaultsNote
			+ `<div class="ctp-cfg-group"><div class="ctp-cfg-head">Certifies (holders)</div><div class="ctp-checks">${this._kindCheckboxes('Holder', HOLDER_CHOICES, tmpCfg.HolderKinds)}</div></div>`
			+ `<div class="ctp-cfg-group"><div class="ctp-cfg-head">Certifies for</div><div class="ctp-checks">${this._kindCheckboxes('Applies', APPLIES_CHOICES, tmpCfg.AppliesToKinds)}</div></div>`
			+ tmpValidity
			+ tmpSave + tmpNotice + tmpError + `</div>`;
	}

	_dangerHTML()
	{
		const tmpState = this.state;
		if (!this.canDelete()) { return ''; }
		if (tmpState.DeleteConfirm)
		{
			const tmpBusy = tmpState.Deleting ? '<span class="ctp-busy">deleting…</span>' : '';
			return `<div class="ctp-section ctp-danger"><div class="ctp-section-head">Delete</div>`
				+ `<p class="ctp-note">Delete “${this._esc(this._typeLabel(tmpState.SelectedType))}”? Existing certifications that reference it are not removed.</p>`
				+ `<div class="ctp-add-row"><button class="ctp-btn ctp-btn-danger" onclick="_Pict.providers.CertificationTypes.deleteTypeAsync()">Delete certification type</button><button class="ctp-btn ctp-btn-ghost" onclick="_Pict.providers.CertificationTypes.cancelDelete()">Cancel</button>${tmpBusy}</div></div>`;
		}
		return `<div class="ctp-section ctp-danger"><button class="ctp-btn ctp-btn-ghost ctp-btn-danger-link" onclick="_Pict.providers.CertificationTypes.askDelete()"><i class="fas fa-trash-can"></i> Delete this type</button></div>`;
	}

	_newTypeHTML()
	{
		const tmpState = this.state;
		const tmpF = tmpState.NewFields;
		const tmpError = tmpState.NewError ? `<div class="ctp-error">${this._esc(tmpState.NewError)}</div>` : '';
		const tmpBusy = tmpState.NewSaving ? '<span class="ctp-busy">saving…</span>' : '';
		return `<div class="ctp-detail-head"><div class="ctp-detail-title">New certification type</div><div class="ctp-detail-sub">Create the type, then configure what it certifies.</div></div>`
			+ `<div class="ctp-section">`
			+ `<label class="ctp-field"><span>Name</span><input type="text" value="${this._esc(tmpF.Name)}" placeholder="e.g. Asphalt Sampling" oninput="_Pict.providers.CertificationTypes.setNewField('Name', this.value)"></label>`
			+ `<label class="ctp-field"><span>Verb</span><input type="text" value="${this._esc(tmpF.Verb)}" placeholder="e.g. Collect Sample" oninput="_Pict.providers.CertificationTypes.setNewField('Verb', this.value)"></label>`
			+ `<label class="ctp-field"><span>Hash / code</span><input type="text" value="${this._esc(tmpF.Hash)}" placeholder="(optional short code)" oninput="_Pict.providers.CertificationTypes.setNewField('Hash', this.value)"></label>`
			+ `<label class="ctp-field"><span>Description</span><textarea rows="2" oninput="_Pict.providers.CertificationTypes.setNewField('Description', this.value)">${this._esc(tmpF.Description)}</textarea></label>`
			+ `<div class="ctp-add-row"><button class="ctp-btn ctp-btn-primary" onclick="_Pict.providers.CertificationTypes.createTypeAsync()">Create type</button><button class="ctp-btn ctp-btn-ghost" onclick="_Pict.providers.CertificationTypes.cancelNew()">Cancel</button>${tmpBusy}</div>`
			+ tmpError + `</div>`;
	}
}

module.exports = CertificationTypesProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'CertificationTypes',
	AutoInitialize: true,
	AutoInitializeOrdinal: 41,
};

},{"../Certification-Config.js":1054,"pict-provider":845}],1310:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');

// Shared kind registry + per-type config model (single source of truth with the #/CertificationTypes screen).
const libCertConfig = require('../Certification-Config.js');
const HOLDER_KINDS = libCertConfig.HOLDER_KINDS;
const HOLDER_KIND_BY_TYPE = libCertConfig.HOLDER_KIND_BY_TYPE;
const APPLIES_TO_KIND_LIST = libCertConfig.APPLIES_TO_KIND_LIST;

// Mount points (the Certifications view lays these out; this provider fills them with hand-built HTML — the
// Entitlements/SuperUserGrant idiom).
const RAIL_MOUNT = '#Cert-Rail';
const RAIL_LIST_MOUNT = '#Cert-Rail-List';
const DETAIL_MOUNT = '#Cert-Detail';
// Picker mounts (Pict-Section-Picker). The certify (holder) picker is multi; the applies-to picker is single.
const HOLDER_PICKER_MOUNT = '#Cert-HolderPicker';
const APPLIES_PICKER_MOUNT = '#Cert-AppliesPicker';

/**
 * Certifications — the #/Certifications workspace. Pick (or create) a CertificationType on the left, then on the
 * right: BULK-CERTIFY holders — pick a holder KIND (User, Material, Lab, Equipment, Test, …), set the dates once,
 * multi-pick entities → one Certification + CertificationEntityPolyJoin per entity; see + search + remove current
 * holders (any kind); and manage what the type "certifies for" (Material/Lab applicability, via
 * CertificationTypeCertifiedEntityPolyJoin).
 *
 * Faithful to the Home app's model: a Certification is ONE row per holder (never shared) carrying the optional
 * CertifiedOn / CertifiedStartDate / CertifiedEndDate; the holder link is a polymorphic CertificationEntityPolyJoin
 * {EntityType, IDEntity} (User/Material/Lab/Equipment/Test/MixDesign/…). The client never sends IDCustomer (the
 * server stamps it from the session).
 */
class CertificationsProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._typeSearchTimer = null;
		this._typeSearchToken = 0;
		this._holderSearchTimer = null;
		this._holderSearchToken = 0;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID) : 0; }

	/** UI gate — creating certifications needs Certification-Create (server stays authoritative). */
	canEdit()
	{
		const tmpApp = this.pict.PictApplication;
		if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function'))
		{
			return tmpApp.EffectivePermissionsService.can('Certification', 'Create');
		}
		return true;   // before the permission map loads, don't hide the UI (server enforces)
	}

	get state()
	{
		if (!this.pict.AppData.Certifications)
		{
			this.pict.AppData.Certifications =
			{
				Loaded: false, Loading: false,
				Types: [], TypeSearch: '',
				SelectedTypeID: 0, SelectedType: null,
				// per-type config (from the Configuration service) — which kinds this type certifies + certifies-for + defaults
				TypeConfig: null,
				// certify form — CertifyKind picks the holder entity kind; AddEntityIDs are the picked entity ids of that kind
				CertifyKind: 'User', AddEntityIDs: [], CertOn: '', CertStart: '', CertEnd: '', Notes: '', CertifySaving: false, CertifyNotice: '', CertifyError: '',
				// holders — server-side paginated (browse), or cross-entity name search
				Holders: [], HoldersLoading: false, HolderNames: {},
				HolderPage: 0, HolderPageSize: 50, HolderTotalCount: 0, HolderSearch: '',
				// certifies-for (polymorphic: Material/Lab/Test/Equipment/…)
				AppliesTo: [], AppliesToLoading: false, AppliesToNames: {}, AppliesToBusy: false, AppliesToError: '',
				AppliesKind: 'Material', AppliesPickValue: '',
				// new-type
				ShowNewType: false, NewTypeName: '', NewTypeVerb: '', NewTypeHash: '', NewTypeDescription: '', NewTypeSaving: false, NewTypeError: '',
			};
		}
		return this.pict.AppData.Certifications;
	}

	// ── REST helpers ─────────────────────────────────────────────────────────────
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_deleteEntity(pEntity, pID) { const tmpRC = this.restClient; return (tmpRC && (typeof tmpRC.deleteEntity === 'function')) ? new Promise((resolve) => tmpRC.deleteEntity(pEntity, pID, (pErr) => resolve(!pErr))) : Promise.resolve(false); }

	// ── Load ─────────────────────────────────────────────────────────────────────
	loadAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return; }
		tmpState.Loading = true;
		this.render();
		// Certification types are a bounded per-customer catalog (dozens); load them all, sorted, for the rail.
		this._getJSON(`CertificationTypes/FilteredTo/FBV~Deleted~EQ~0~FSF~Hash~ASC~0/0/2000`).then((pRows) =>
		{
			tmpState.Types = (Array.isArray(pRows) ? pRows : []).slice();
			tmpState.Loaded = true;
			tmpState.Loading = false;
			this.render();
		});
	}

	_typeLabel(pType) { if (!pType) { return ''; } return String(pType.Name || pType.Hash || `Type ${pType.IDCertificationType}`); }
	_typeSub(pType) { if (!pType) { return ''; } const tmpBits = [ pType.Verb, (pType.Name ? pType.Hash : '') ].filter((pBit) => pBit); return tmpBits.join(' · '); }

	setTypeSearch(pValue)
	{
		this.state.TypeSearch = String(pValue == null ? '' : pValue);
		// Types are fully loaded → filter client-side; just repaint the list (keeps the search box focused).
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length > 0) { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		else { this.render(); }
	}

	selectType(pIDCertificationType)
	{
		const tmpState = this.state;
		const tmpID = Number(pIDCertificationType);
		tmpState.SelectedTypeID = tmpID;
		tmpState.SelectedType = (tmpState.Types || []).find((pType) => Number(pType.IDCertificationType) === tmpID) || null;
		tmpState.ShowNewType = false;
		// reset the certify form + sections (keep the chosen holder kind so it sticks while browsing types)
		tmpState.TypeConfig = null;
		tmpState.AddEntityIDs = []; tmpState.CertOn = ''; tmpState.CertStart = ''; tmpState.CertEnd = ''; tmpState.Notes = '';
		tmpState.CertifyNotice = ''; tmpState.CertifyError = '';
		tmpState.Holders = []; tmpState.HolderNames = {}; tmpState.HolderPage = 0; tmpState.HolderTotalCount = 0; tmpState.HolderSearch = '';
		tmpState.AppliesTo = []; tmpState.AppliesToNames = {}; tmpState.AppliesToError = ''; tmpState.AppliesPickValue = '';
		this.render();
		if (tmpID > 0) { this._loadTypeConfigAsync(tmpID, tmpState.SelectedType); this._loadHoldersAsync(tmpID); this._loadAppliesToAsync(tmpID); }
	}

	/** Load the type's per-type config (cascaded read), normalize over defaults, and pre-scope the kind dropdowns. */
	_loadTypeConfigAsync(pTypeID, pType)
	{
		const tmpState = this.state;
		this._postJSON('Configuration/Get', { LevelContext: 'Customer', LevelContextID: this.callerCustomer(), NamespaceKey: libCertConfig.CERT_CONFIG_NAMESPACE, NamespaceValue: libCertConfig.configNamespaceValue(pTypeID) }).then((pRes) =>
		{
			if (Number(tmpState.SelectedTypeID) !== Number(pTypeID)) { return; }
			const tmpBody = (pRes && (pRes.result !== undefined)) ? pRes.result : pRes;
			const tmpRaw = (tmpBody && (tmpBody.Config !== undefined)) ? tmpBody.Config : ((tmpBody && tmpBody.Document) || tmpBody);
			const tmpConfig = libCertConfig.normalizeConfig(tmpRaw, pType);
			tmpState.TypeConfig = tmpConfig;
			// pre-scope only when an admin has EXPLICITLY configured this type — otherwise stay fully flexible (nothing
			// hidden). If the current kind isn't offered by the saved config, snap to the first configured kind.
			if (tmpConfig.Configured)
			{
				if (tmpConfig.HolderKinds.indexOf(tmpState.CertifyKind) === -1) { tmpState.CertifyKind = tmpConfig.HolderKinds[0]; }
				if (tmpConfig.AppliesToKinds.indexOf(tmpState.AppliesKind) === -1) { tmpState.AppliesKind = tmpConfig.AppliesToKinds[0]; }
			}
			this.render();
		});
	}

	/** Holder kinds offered for the selected type — the saved config if the type is CONFIGURED, else every certifiable kind. */
	_certifyKindChoices() { const tmpCfg = this.state.TypeConfig; return (tmpCfg && tmpCfg.Configured && tmpCfg.HolderKinds.length) ? tmpCfg.HolderKinds : libCertConfig.HOLDER_CERTIFIABLE_LIST; }
	/** Certifies-for kinds offered for the selected type — the saved config if CONFIGURED, else the full list. */
	_appliesKindChoices() { const tmpCfg = this.state.TypeConfig; return (tmpCfg && tmpCfg.Configured && tmpCfg.AppliesToKinds.length) ? tmpCfg.AppliesToKinds : APPLIES_TO_KIND_LIST; }

	// ── Certify users (bulk) ─────────────────────────────────────────────────────

	setNotes(pValue) { this.state.Notes = String(pValue == null ? '' : pValue); }
	setCertDate(pField, pValue)
	{
		const tmpState = this.state;
		if (pField === 'On') { tmpState.CertOn = pValue || ''; }
		else if (pField === 'Start') { tmpState.CertStart = pValue || ''; }
		else if (pField === 'End') { tmpState.CertEnd = pValue || ''; }
	}

	/** Preset: set the end date to N years after the start (or CertifiedOn, or today) — mirrors the Home app helper. */
	applyDatePreset(pYears)
	{
		const tmpState = this.state;
		const tmpBase = tmpState.CertStart || tmpState.CertOn;
		if (!tmpBase) { tmpState.CertifyError = 'Set a start date first, then apply a preset.'; this.render(); return; }
		const tmpParts = String(tmpBase).split('-').map((pPart) => Number(pPart));
		if (tmpParts.length !== 3) { return; }
		const tmpEndYear = tmpParts[0] + Number(pYears);
		tmpState.CertEnd = `${tmpEndYear}-${String(tmpParts[1]).padStart(2, '0')}-${String(tmpParts[2]).padStart(2, '0')}`;
		tmpState.CertifyError = '';
		this.render();
	}

	/** YYYY-MM-DD (from a date input) → an ISO DateTime the API stores; '' → null. */
	_dateToISO(pYMD) { const tmpV = String(pYMD || '').trim(); return tmpV ? `${tmpV}T00:00:00.000Z` : null; }
	/** ISO DateTime → YYYY-MM-DD for a date input / display. */
	_isoToYMD(pISO) { const tmpV = String(pISO || ''); return (tmpV.length >= 10) ? tmpV.slice(0, 10) : ''; }

	/** Change the holder kind being certified (User / Material / Lab / …) — clears the picked entities + re-mounts. */
	setCertifyKind(pValue)
	{
		const tmpState = this.state;
		const tmpKind = HOLDER_KIND_BY_TYPE[pValue] ? String(pValue) : 'User';
		if (tmpState.CertifyKind === tmpKind) { return; }
		tmpState.CertifyKind = tmpKind;
		tmpState.AddEntityIDs = [];   // ids are kind-specific — drop the previous kind's selection
		tmpState.CertifyError = '';
		this.mountCertifyPicker();     // re-create the picker (fresh chips + kind-specific placeholder + data provider)
	}

	/**
	 * Bulk-certify: for each picked entity of the chosen kind, create a Certification (this type + the shared dates +
	 * notes) then attach it via a CertificationEntityPolyJoin{EntityType:<kind>, IDEntity:<id>}. One Certification per
	 * holder (never shared), so each holder's dates can be renewed independently. IDCustomer is server-derived.
	 */
	async certifySelectedAsync()
	{
		const tmpState = this.state;
		if (!this.canEdit() || tmpState.CertifySaving) { return; }
		const tmpTypeID = Number(tmpState.SelectedTypeID);
		const tmpKindDef = HOLDER_KIND_BY_TYPE[tmpState.CertifyKind] || HOLDER_KIND_BY_TYPE['User'];
		const tmpIDs = (tmpState.AddEntityIDs || []).map(Number).filter((pID) => pID > 0);
		if (!(tmpTypeID > 0)) { return; }
		if (!tmpIDs.length)
		{
			tmpState.CertifyError = `Search for and pick one or more ${tmpKindDef.Ph.replace(/ by .*$/, '')} to certify first.`;
			tmpState.CertifyNotice = '';
			this.render();
			return;
		}
		if (tmpState.CertStart && tmpState.CertEnd && (tmpState.CertStart > tmpState.CertEnd)) { tmpState.CertifyError = 'The end date is before the start date.'; tmpState.CertifyNotice = ''; this.render(); return; }
		tmpState.CertifySaving = true; tmpState.CertifyError = ''; tmpState.CertifyNotice = '';
		this.render();
		// Only send dates that are actually set (omit empties rather than sending null, which the server may reject).
		const tmpCertBody = { IDCertification: 0, IDCertificationType: tmpTypeID, Notes: String(tmpState.Notes || '') };
		const tmpOn = this._dateToISO(tmpState.CertOn); if (tmpOn) { tmpCertBody.CertifiedOn = tmpOn; }
		const tmpStartISO = this._dateToISO(tmpState.CertStart); if (tmpStartISO) { tmpCertBody.CertifiedStartDate = tmpStartISO; }
		const tmpEndISO = this._dateToISO(tmpState.CertEnd); if (tmpEndISO) { tmpCertBody.CertifiedEndDate = tmpEndISO; }
		let tmpOK = 0;
		let tmpFail = 0;
		const tmpConcurrency = 5;
		for (let tmpStart = 0; tmpStart < tmpIDs.length; tmpStart += tmpConcurrency)
		{
			const tmpBatch = tmpIDs.slice(tmpStart, tmpStart + tmpConcurrency);
			/* eslint-disable no-await-in-loop */
			await Promise.all(tmpBatch.map((pID) => this._certifyOne(tmpCertBody, tmpKindDef.Kind, pID).then((pOk) => { if (pOk) { tmpOK++; } else { tmpFail++; } })));
			/* eslint-enable no-await-in-loop */
		}
		const tmpNoun = tmpOK === 1 ? 'holder' : 'holders';
		tmpState.CertifySaving = false;
		tmpState.AddEntityIDs = [];
		tmpState.CertifyNotice = tmpFail
			? `Certified ${tmpOK} ${tmpNoun}; ${tmpFail} failed (you may lack permission).`
			: `Certified ${tmpOK} ${tmpNoun}.`;
		// Repaint the certify panel FIRST so the "certifying…" busy indicator clears and the notice shows —
		// `_reloadHolders` only repaints the holders list body (`_renderHoldersBody`), not this panel, so on its
		// own it would leave the CertifySaving span stuck next to the button even though CertifySaving is false.
		this.render();
		this._reloadHolders();   // then reload + repaint the holders list to include the new certifications
	}

	/** One holder: POST Certification then POST its poly-join {EntityType, IDEntity}. Resolves true on success. */
	_certifyOne(pCertBody, pEntityType, pIDEntity)
	{
		return this._postJSON('Certification', Object.assign({}, pCertBody)).then((pRes) =>
		{
			const tmpCert = pRes && pRes.result;
			if (pRes.error || !tmpCert || !tmpCert.IDCertification) { return false; }
			return this._postJSON('CertificationEntityPolyJoin', { IDCertificationEntityPolyJoin: 0, IDCertification: Number(tmpCert.IDCertification), EntityType: String(pEntityType), IDEntity: Number(pIDEntity) })
				.then((pJoinRes) => !pJoinRes.error);
		});
	}

	// ── Holders (users who hold this type) ───────────────────────────────────────

	// Holders of a type = the User poly-joins of this type's Certifications. BROWSE mode pages the type's
	// Certifications server-side (begin/count) → their User poly-joins → holders. A name query switches to SEARCH mode
	// (find users by name, login ID or email, keep those holding this type). The `?Joins=` inline param is not honored by the
	// server, so every mode reads certs + poly-joins separately and joins them client-side. The holders body repaints
	// on its own mount (#Cert-Holders-Body) so the search box keeps focus and the certify/applies-to pickers don't
	// re-mount on a keystroke or a page turn.

	setHolderSearch(pValue)
	{
		this.state.HolderSearch = String(pValue == null ? '' : pValue);
		if (this._holderSearchTimer) { clearTimeout(this._holderSearchTimer); }
		this._holderSearchTimer = setTimeout(() => { this._holderSearchTimer = null; this._runHolderQuery(); }, 250);
	}

	/** New search-box value → name search (≥2 chars) or browse page 0. */
	_runHolderQuery()
	{
		const tmpState = this.state;
		const tmpTypeID = Number(tmpState.SelectedTypeID);
		if (!(tmpTypeID > 0)) { return; }
		const tmpTerm = String(tmpState.HolderSearch || '').trim();
		if (tmpTerm.length >= 2) { this._searchHoldersAsync(tmpTypeID, tmpTerm); }
		else { this._loadHoldersAsync(tmpTypeID, 0); }
	}

	/** Reload the current holders view (after certify / remove) — same page, or re-run the active search. */
	_reloadHolders()
	{
		const tmpState = this.state;
		const tmpTypeID = Number(tmpState.SelectedTypeID);
		if (!(tmpTypeID > 0)) { return; }
		const tmpTerm = String(tmpState.HolderSearch || '').trim();
		if (tmpTerm.length >= 2) { this._searchHoldersAsync(tmpTypeID, tmpTerm); }
		else { this._loadHoldersAsync(tmpTypeID, tmpState.HolderPage); }
	}

	holderPrevPage() { const tmpState = this.state; if (tmpState.HolderPage > 0) { this._loadHoldersAsync(Number(tmpState.SelectedTypeID), tmpState.HolderPage - 1); } }
	holderNextPage() { const tmpState = this.state; const tmpPages = Math.max(1, Math.ceil(tmpState.HolderTotalCount / tmpState.HolderPageSize)); if (tmpState.HolderPage < (tmpPages - 1)) { this._loadHoldersAsync(Number(tmpState.SelectedTypeID), tmpState.HolderPage + 1); } }

	/** BROWSE: page the type's Certifications (begin/count, stable sort), then their User poly-joins → holders. */
	_loadHoldersAsync(pTypeID, pPage)
	{
		const tmpState = this.state;
		const tmpPage = Math.max(0, Number(pPage) || 0);
		tmpState.HolderPage = tmpPage;
		tmpState.HoldersLoading = true;
		this._renderHoldersBody();
		const tmpScope = `FBV~IDCertificationType~EQ~${pTypeID}~FBV~Deleted~EQ~0`;
		const tmpStart = tmpPage * tmpState.HolderPageSize;
		Promise.all(
			[
				this._getJSON(`Certifications/FilteredTo/${tmpScope}~FSF~IDCertification~ASC~0/${tmpStart}/${tmpState.HolderPageSize}`),
				(tmpPage === 0) ? this._getJSON(`Certifications/Count/FilteredTo/${tmpScope}`) : Promise.resolve(null),
			]).then((pResults) =>
		{
			if (Number(tmpState.SelectedTypeID) !== Number(pTypeID)) { return; }
			if (pResults[1] && (pResults[1].Count != null)) { tmpState.HolderTotalCount = Number(pResults[1].Count); }
			this._buildHoldersFromCerts(pTypeID, Array.isArray(pResults[0]) ? pResults[0] : []);
		});
	}

	/** Resolve a page of Certifications → holders (their User poly-joins), then repaint + resolve names. */
	_buildHoldersFromCerts(pTypeID, pCerts)
	{
		const tmpState = this.state;
		const tmpCertByID = {};
		pCerts.forEach((pCert) => { tmpCertByID[Number(pCert.IDCertification)] = pCert; });
		const tmpIDs = Object.keys(tmpCertByID);
		if (!tmpIDs.length) { tmpState.Holders = []; tmpState.HoldersLoading = false; this._renderHoldersBody(); return; }
		// Any holder kind (User/Material/Lab/…) — one poly-join per Certification; join client-side.
		this._getJSON(`CertificationEntityPolyJoins/FilteredTo/FBL~IDCertification~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0/0/${tmpIDs.length + 10}`).then((pJoins) =>
		{
			if (Number(tmpState.SelectedTypeID) !== Number(pTypeID)) { return; }
			tmpState.Holders = (Array.isArray(pJoins) ? pJoins : []).map((pJoin) => this._holderFrom(pJoin, tmpCertByID[Number(pJoin.IDCertification)])).filter((pRow) => pRow);
			tmpState.HoldersLoading = false;
			this._renderHoldersBody();
			this._resolveHolderNames();
		});
	}

	_holderFrom(pJoin, pCert)
	{
		if (!pJoin || !pCert) { return null; }
		return { IDCertification: Number(pJoin.IDCertification), IDJoin: Number(pJoin.IDCertificationEntityPolyJoin), EntityType: String(pJoin.EntityType || ''), IDEntity: Number(pJoin.IDEntity), On: this._isoToYMD(pCert.CertifiedOn), Start: this._isoToYMD(pCert.CertifiedStartDate), End: this._isoToYMD(pCert.CertifiedEndDate) };
	}

	/**
	 * SEARCH (polymorphic): match the term against every holder kind's entity set in parallel (one request per kind,
	 * see _kindFilter), collect matching entities per kind, find their poly-joins per kind, then keep only the
	 * ones whose Certification is of this type.
	 */
	_searchHoldersAsync(pTypeID, pTerm)
	{
		const tmpState = this.state;
		tmpState.HoldersLoading = true;
		this._renderHoldersBody();
		const tmpToken = ++this._holderSearchToken;
		const fStale = () => (tmpToken !== this._holderSearchToken) || (Number(tmpState.SelectedTypeID) !== Number(pTypeID));
		// 1) matching entities of every holder kind (User is customer-scoped; the rest are session-scoped by the server)
		Promise.all(HOLDER_KINDS.map((pKind) =>
		{
			const tmpScope = (pKind.Kind === 'User') ? `~FBV~IDCustomer~EQ~${this.callerCustomer()}` : '';
			return this._getJSON(`${pKind.Plural}/FilteredTo/${this._kindFilter(pKind, pTerm)}${tmpScope}/0/25`)
				.then((pRows) =>
				{
					const tmpByID = {};
					(Array.isArray(pRows) ? pRows : []).forEach((pRec) =>
					{
						const tmpID = Number(pRec && pRec[pKind.IDField]);
						if (tmpID > 0)
						{
							tmpByID[tmpID] = pRec;
						}
					});
					return { Kind: pKind, Records: tmpByID };
				});
		})).then((pKindResults) =>
		{
			if (fStale()) { return; }
			// stash labels + collect (kind → matched ids)
			const tmpKindIDs = [];
			pKindResults.forEach((pKR) =>
			{
				const tmpIDs = Object.keys(pKR.Records).map(Number);
				if (!tmpIDs.length) { return; }
				tmpIDs.forEach((pID) => { tmpState.HolderNames[`${pKR.Kind.Kind}:${pID}`] = this._entityLabel(pKR.Kind, pKR.Records[pID]); });
				tmpKindIDs.push({ Kind: pKR.Kind, IDs: tmpIDs });
			});
			if (!tmpKindIDs.length) { tmpState.Holders = []; tmpState.HoldersLoading = false; this._renderHoldersBody(); return; }
			// 2) poly-joins for those entities (per kind, parallel)
			Promise.all(tmpKindIDs.map((pKI) => this._getJSON(`CertificationEntityPolyJoins/FilteredTo/FBV~EntityType~EQ~${pKI.Kind.Kind}~FBL~IDEntity~INN~${pKI.IDs.join(',')}~FBV~Deleted~EQ~0/0/1000`))).then((pJoinArrays) =>
			{
				if (fStale()) { return; }
				const tmpJoinRows = [];
				pJoinArrays.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pJoin) => tmpJoinRows.push(pJoin)));
				const tmpCertIDs = Array.from(new Set(tmpJoinRows.map((pJoin) => Number(pJoin.IDCertification)).filter((pID) => pID > 0)));
				if (!tmpCertIDs.length) { tmpState.Holders = []; tmpState.HoldersLoading = false; this._renderHoldersBody(); return; }
				// 3) keep only poly-joins whose Certification is of THIS type
				this._getJSON(`Certifications/FilteredTo/FBL~IDCertification~INN~${tmpCertIDs.join(',')}~FBV~IDCertificationType~EQ~${pTypeID}~FBV~Deleted~EQ~0/0/${tmpCertIDs.length + 10}`).then((pCerts) =>
				{
					if (fStale()) { return; }
					const tmpCertByID = {};
					(Array.isArray(pCerts) ? pCerts : []).forEach((pCert) => { tmpCertByID[Number(pCert.IDCertification)] = pCert; });
					tmpState.Holders = tmpJoinRows.map((pJoin) => this._holderFrom(pJoin, tmpCertByID[Number(pJoin.IDCertification)])).filter((pRow) => pRow);
					tmpState.HoldersLoading = false;
					this._renderHoldersBody();
				});
			});
		});
	}

	/** Resolve holder entity ids → display names, grouped by EntityType (batched INN per kind), then repaint. */
	_resolveHolderNames()
	{
		const tmpState = this.state;
		const tmpByType = {};
		(tmpState.Holders || []).forEach((pHolder) =>
		{
			if (!(pHolder.IDEntity > 0)) { return; }
			if (tmpState.HolderNames[`${pHolder.EntityType}:${pHolder.IDEntity}`]) { return; }
			(tmpByType[pHolder.EntityType] = tmpByType[pHolder.EntityType] || []).push(pHolder.IDEntity);
		});
		const tmpTypes = Object.keys(tmpByType);
		if (!tmpTypes.length) { return; }
		tmpTypes.forEach((pType) =>
		{
			const tmpKindDef = HOLDER_KIND_BY_TYPE[pType];
			const tmpIDs = Array.from(new Set(tmpByType[pType])).slice(0, 500);
			if (!tmpKindDef)   // unknown holder kind — label generically so the row still renders
			{
				tmpIDs.forEach((pID) => { tmpState.HolderNames[`${pType}:${pID}`] = `${pType} #${pID}`; });
				this._renderHoldersBody();
				return;
			}
			this._getJSON(`${tmpKindDef.Plural}/FilteredTo/FBL~${tmpKindDef.IDField}~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0/0/${tmpIDs.length}`).then((pRows) =>
			{
				(Array.isArray(pRows) ? pRows : []).forEach((pRec) => { const tmpID = Number(pRec[tmpKindDef.IDField]); tmpState.HolderNames[`${pType}:${tmpID}`] = this._entityLabel(tmpKindDef, pRec); });
				this._renderHoldersBody();
			});
		});
	}

	/** Display label for any holder-kind record (User → the shared user label; others → Name, with a typed fallback). */
	_entityLabel(pKindDef, pRecord)
	{
		if (!pRecord) { return ''; }
		if (pKindDef && pKindDef.Kind === 'User')
		{
			return libUserSearch.userLabel(pRecord);
		}
		const tmpID = pKindDef ? pRecord[pKindDef.IDField] : '';
		return String(pRecord.Name || pRecord.Title || `${pKindDef ? pKindDef.Kind : 'Entity'} #${tmpID}`);
	}

	/** Remove a holder: delete the poly-join then the Certification (mirrors the Home app). */
	async removeHolderAsync(pIDCertification, pIDJoin)
	{
		if (!this.canEdit()) { return; }
		await this._deleteEntity('CertificationEntityPolyJoin', Number(pIDJoin));
		await this._deleteEntity('Certification', Number(pIDCertification));
		this._reloadHolders();
	}

	// ── Certifies-for (polymorphic entity applicability) ─────────────────────────

	_loadAppliesToAsync(pTypeID)
	{
		const tmpState = this.state;
		tmpState.AppliesToLoading = true;
		this._getJSON(`CertificationTypeCertifiedEntityPolyJoins/FilteredTo/FBV~IDCertificationType~EQ~${pTypeID}~FBV~Deleted~EQ~0/0/2000`).then((pRows) =>
		{
			if (Number(tmpState.SelectedTypeID) !== Number(pTypeID)) { return; }
			// Keep every kind (Material/Lab/Test/Equipment/Customer/…) — display resolves what it can, generic otherwise.
			tmpState.AppliesTo = (Array.isArray(pRows) ? pRows : []).filter((pRow) => pRow && pRow.EntityType && (pRow.IDEntity != null));
			tmpState.AppliesToLoading = false;
			this.render();
			this._resolveAppliesToNames();
		});
	}

	/** Resolve certifies-for entity ids → names, grouped by EntityType (batched INN per kind), then repaint. */
	_resolveAppliesToNames()
	{
		const tmpState = this.state;
		const tmpByType = {};
		(tmpState.AppliesTo || []).forEach((pRow) =>
		{
			const tmpID = Number(pRow.IDEntity);
			if (!(tmpID > 0) || tmpState.AppliesToNames[`${pRow.EntityType}:${tmpID}`]) { return; }
			(tmpByType[pRow.EntityType] = tmpByType[pRow.EntityType] || []).push(tmpID);
		});
		Object.keys(tmpByType).forEach((pType) =>
		{
			const tmpKindDef = HOLDER_KIND_BY_TYPE[pType];
			const tmpIDs = Array.from(new Set(tmpByType[pType])).slice(0, 500);
			if (!tmpKindDef)   // unknown certifies-for kind (Customer, CertificationType, …) — generic label
			{
				tmpIDs.forEach((pID) => { tmpState.AppliesToNames[`${pType}:${pID}`] = `${pType} #${pID}`; });
				this.render();
				return;
			}
			this._getJSON(`${tmpKindDef.Plural}/FilteredTo/FBL~${tmpKindDef.IDField}~INN~${tmpIDs.join(',')}~FBV~Deleted~EQ~0/0/${tmpIDs.length}`).then((pRows) =>
			{
				(Array.isArray(pRows) ? pRows : []).forEach((pRec) => { tmpState.AppliesToNames[`${pType}:${Number(pRec[tmpKindDef.IDField])}`] = this._entityLabel(tmpKindDef, pRec); });
				this.render();
			});
		});
	}

	/** Change the certifies-for kind — clears the pick + re-mounts the applies picker (mirrors setCertifyKind). */
	setAppliesKind(pValue)
	{
		const tmpState = this.state;
		const tmpKind = (HOLDER_KIND_BY_TYPE[pValue] && (APPLIES_TO_KIND_LIST.indexOf(pValue) > -1)) ? String(pValue) : 'Material';
		if (tmpState.AppliesKind === tmpKind) { return; }
		tmpState.AppliesKind = tmpKind;
		tmpState.AppliesPickValue = '';
		tmpState.AppliesToError = '';
		this.mountAppliesPicker();
	}

	setAppliesPick(pValue) { this.state.AppliesPickValue = Number(pValue) || 0; }

	async addAppliesToAsync()
	{
		const tmpState = this.state;
		if (!this.canEdit() || tmpState.AppliesToBusy) { return; }
		const tmpTypeID = Number(tmpState.SelectedTypeID);
		const tmpKindDef = HOLDER_KIND_BY_TYPE[tmpState.AppliesKind] || HOLDER_KIND_BY_TYPE['Material'];
		const tmpKind = tmpKindDef.Kind;
		const tmpIDEntity = Number(tmpState.AppliesPickValue);
		if (!(tmpTypeID > 0) || !(tmpIDEntity > 0)) { tmpState.AppliesToError = `Pick a ${tmpKindDef.Label.toLowerCase()} to add.`; this.render(); return; }
		if ((tmpState.AppliesTo || []).some((pRow) => (pRow.EntityType === tmpKind) && (Number(pRow.IDEntity) === tmpIDEntity))) { tmpState.AppliesToError = `That ${tmpKindDef.Label.toLowerCase()} is already listed.`; this.render(); return; }
		tmpState.AppliesToBusy = true; tmpState.AppliesToError = '';
		this.render();
		const tmpRes = await this._postJSON('CertificationTypeCertifiedEntityPolyJoin', { IDCertificationTypeCertifiedEntityPolyJoin: 0, IDCertificationType: tmpTypeID, EntityType: tmpKind, IDEntity: tmpIDEntity, Note: '' });
		tmpState.AppliesToBusy = false;
		if (tmpRes.error) { tmpState.AppliesToError = 'The server rejected the change.'; this.render(); return; }
		tmpState.AppliesPickValue = '';
		this._loadAppliesToAsync(tmpTypeID);
	}

	async removeAppliesToAsync(pIDJoin)
	{
		const tmpState = this.state;
		if (!this.canEdit()) { return; }
		await this._deleteEntity('CertificationTypeCertifiedEntityPolyJoin', Number(pIDJoin));
		this._loadAppliesToAsync(Number(tmpState.SelectedTypeID));
	}

	// ── New CertificationType ────────────────────────────────────────────────────

	showNewType() { const tmpState = this.state; tmpState.ShowNewType = true; tmpState.SelectedTypeID = 0; tmpState.SelectedType = null; tmpState.NewTypeName = ''; tmpState.NewTypeVerb = ''; tmpState.NewTypeHash = ''; tmpState.NewTypeDescription = ''; tmpState.NewTypeError = ''; this.render(); }
	setNewTypeField(pField, pValue) { const tmpState = this.state; const tmpKey = 'NewType' + pField; if (Object.prototype.hasOwnProperty.call(tmpState, tmpKey)) { tmpState[tmpKey] = String(pValue == null ? '' : pValue); } }

	async createTypeAsync()
	{
		const tmpState = this.state;
		if (!this.canEdit() || tmpState.NewTypeSaving) { return; }
		const tmpName = String(tmpState.NewTypeName || '').trim();
		const tmpHash = String(tmpState.NewTypeHash || '').trim();
		if (!tmpName && !tmpHash) { tmpState.NewTypeError = 'Give the certification a name (or a hash/code).'; this.render(); return; }
		tmpState.NewTypeSaving = true; tmpState.NewTypeError = '';
		this.render();
		const tmpRes = await this._postJSON('CertificationType', { IDCertificationType: 0, Name: tmpName, Hash: tmpHash, Verb: String(tmpState.NewTypeVerb || '').trim(), Description: String(tmpState.NewTypeDescription || '') });
		tmpState.NewTypeSaving = false;
		const tmpType = tmpRes && tmpRes.result;
		if (tmpRes.error || !tmpType || !tmpType.IDCertificationType) { tmpState.NewTypeError = 'The server rejected the new certification type.'; this.render(); return; }
		tmpState.Types.push(tmpType);
		tmpState.Types.sort((pA, pB) => String(pA.Hash || pA.Name || '').localeCompare(String(pB.Hash || pB.Name || '')));
		tmpState.ShowNewType = false;
		this.selectType(Number(tmpType.IDCertificationType));
	}

	// ── Pickers (mounted per render) ─────────────────────────────────────────────

	_pickerProvider() { return this.pict.providers['Pict-Section-Picker']; }

	_certifyKindDef() { return HOLDER_KIND_BY_TYPE[this.state.CertifyKind] || HOLDER_KIND_BY_TYPE['User']; }
	_appliesKindDef() { return HOLDER_KIND_BY_TYPE[this.state.AppliesKind] || HOLDER_KIND_BY_TYPE['Material']; }

	/**
	 * The filter for a holder-kind search: people by name, login ID or email (the shared user search), everything
	 * else by its `Search` columns, every word of the term matching; not deleted. An empty term browses.
	 *
	 * @param {{ Kind: string, Search: ?Array<string> }} pKind - A HOLDER_KINDS entry.
	 * @param {any} pTerm - The search text.
	 * @returns {string} FoxHound filter stanzas.
	 */
	_kindFilter(pKind, pTerm)
	{
		const tmpSearch = (pKind.Kind === 'User') ? libUserSearch.buildUserSearchFilter(pTerm) : libUserSearch.buildSearchFilter(pKind.Search, pTerm);
		return [ tmpSearch, 'FBV~Deleted~EQ~0' ].filter(Boolean).join('~');
	}

	/** Entity-set search bound to a kind (resolved via pGetKindDef at call-time, so re-mounting re-targets it), one
	 * request per page. Users are customer-scoped; other kinds are session-scoped by the server. */
	_kindDataProvider(pGetKindDef)
	{
		const tmpPageSize = 25;
		return (pTerm, pPage) =>
		{
			const tmpKindDef = pGetKindDef() || HOLDER_KIND_BY_TYPE['User'];
			const tmpScope = (tmpKindDef.Kind === 'User') ? `~FBV~IDCustomer~EQ~${this.callerCustomer()}` : '';
			const fMap = (pRows) => (Array.isArray(pRows) ? pRows : []).map((pRec) => ({ Value: Number(pRec[tmpKindDef.IDField]), Text: this._entityLabel(tmpKindDef, pRec), Record: pRec }));
			const tmpStart = (Number(pPage) || 0) * tmpPageSize;
			return this._getJSON(`${tmpKindDef.Plural}/FilteredTo/${this._kindFilter(tmpKindDef, pTerm)}${tmpScope}/${tmpStart}/${tmpPageSize}`)
				.then((pRows) => ({ results: fMap(pRows), hasMore: (Array.isArray(pRows) && (pRows.length >= tmpPageSize)) }));
		};
	}
	_kindResolveValue(pGetKindDef)
	{
		return (pValue) =>
		{
			const tmpKindDef = pGetKindDef() || HOLDER_KIND_BY_TYPE['User'];
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`${tmpKindDef.One}/${tmpID}`).then((pRec) => ((pRec && pRec[tmpKindDef.IDField]) ? { Value: tmpID, Text: this._entityLabel(tmpKindDef, pRec) } : { Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/** (Re)mount just the certify (holder) multi-picker, bound to the current CertifyKind. */
	mountCertifyPicker()
	{
		const tmpPicker = this._pickerProvider();
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement(HOLDER_PICKER_MOUNT).length === 0) { return; }
		const tmpKindDef = this._certifyKindDef();
		const tmpP = tmpPicker.createPicker('Cert-HolderPicker', { DestinationAddress: HOLDER_PICKER_MOUNT, ValueAddress: 'AppData.Certifications.AddEntityIDs', Mode: 'multi', Searchable: true, Placeholder: `Search ${tmpKindDef.Ph}…`, DataProvider: this._kindDataProvider(() => this._certifyKindDef()), ResolveValue: this._kindResolveValue(() => this._certifyKindDef()) });
		if (tmpP && (typeof tmpP.render === 'function')) { tmpP.render(); }
	}

	/** (Re)mount just the certifies-for single-picker, bound to the current AppliesKind. */
	mountAppliesPicker()
	{
		const tmpPicker = this._pickerProvider();
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement(APPLIES_PICKER_MOUNT).length === 0) { return; }
		const tmpKindDef = this._appliesKindDef();
		const tmpP = tmpPicker.createPicker('Cert-AppliesPicker',
			{
				DestinationAddress: APPLIES_PICKER_MOUNT, ValueAddress: 'AppData.Certifications.AppliesPickValue', Searchable: true, AllowClear: true,
				ClearLabel: `— pick a ${tmpKindDef.Label.toLowerCase()} —`, Placeholder: `Search ${tmpKindDef.Ph}…`,
				DataProvider: this._kindDataProvider(() => this._appliesKindDef()), ResolveValue: this._kindResolveValue(() => this._appliesKindDef()),
				OnChange: (pValue) => this.setAppliesPick(pValue),
			});
		if (tmpP && (typeof tmpP.render === 'function')) { tmpP.render(); }
	}

	/** (Re)mount the detail pickers present in the DOM (certify holder multi + certifies-for single). */
	mountPickers()
	{
		const tmpPicker = this._pickerProvider();
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		this.mountCertifyPicker();
		this.mountAppliesPicker();
	}

	// ── Render (hand-built HTML into the mounts) ─────────────────────────────────

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_MOUNT).length === 0) { return; }
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length === 0) { tmpCA.assignContent(RAIL_MOUNT, this._railHTML()); }
		else { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML());
		// The detail HTML was just repainted (fresh, empty picker mounts) — (re)mount the pickers into it. render()
		// is targeted ContentAssignment, so the view's onAfterRender (which also mounts) does NOT fire here.
		this.mountPickers();
	}

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	_railHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Loaded) { return '<div class="cert-empty">Loading…</div>'; }
		const tmpNew = this.canEdit() ? `<button class="cert-newtype-btn" onclick="_Pict.providers.Certifications.showNewType()"><i class="fas fa-plus"></i> New certification type</button>` : '';
		return `<input class="cert-rail-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search certification types…" value="${this._esc(tmpState.TypeSearch || '')}" oninput="_Pict.providers.Certifications.setTypeSearch(this.value)" />`
			+ tmpNew
			+ `<div id="Cert-Rail-List" class="cert-rail-list">${this._railListHTML()}</div>`;
	}

	_railListHTML()
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.TypeSearch || '').trim().toLowerCase();
		const tmpTypes = (tmpState.Types || []).filter((pType) => !tmpQuery
			|| String(this._typeLabel(pType)).toLowerCase().indexOf(tmpQuery) > -1
			|| String(pType.Verb || '').toLowerCase().indexOf(tmpQuery) > -1
			|| String(pType.Description || '').toLowerCase().indexOf(tmpQuery) > -1);
		if (!tmpTypes.length) { return `<div class="cert-empty">${tmpQuery ? 'No certification types match.' : 'No certification types yet.'}</div>`; }
		return tmpTypes.map((pType) =>
		{
			const tmpActive = (Number(tmpState.SelectedTypeID) === Number(pType.IDCertificationType)) ? ' is-active' : '';
			const tmpSub = this._typeSub(pType);
			return `<div class="cert-rail-item${tmpActive}" onclick="_Pict.providers.Certifications.selectType(${Number(pType.IDCertificationType)})"><div class="cert-rail-name">${this._esc(this._typeLabel(pType))}</div>${tmpSub ? `<div class="cert-rail-sub">${this._esc(tmpSub)}</div>` : ''}</div>`;
		}).join('');
	}

	_detailHTML()
	{
		const tmpState = this.state;
		if (tmpState.ShowNewType) { return this._newTypeHTML(); }
		if (!tmpState.SelectedTypeID || !tmpState.SelectedType) { return '<div class="cert-detail-empty">Pick a certification type on the left to certify people or things and set what it applies to — or create a new type.</div>'; }
		const tmpEditable = this.canEdit();
		const tmpType = tmpState.SelectedType;
		return `<div class="cert-detail-head"><div class="cert-detail-title">${this._esc(this._typeLabel(tmpType))}</div>`
			+ `<div class="cert-detail-sub">${this._esc([ tmpType.Verb, tmpType.Hash ].filter((pBit) => pBit).join(' · '))}</div>`
			+ (tmpType.Description ? `<p class="cert-detail-desc">${this._esc(tmpType.Description)}</p>` : '') + `</div>`
			+ this._certifyHTML(tmpEditable)
			+ this._holdersHTML(tmpEditable)
			+ this._appliesToHTML(tmpEditable);
	}

	_kindPlural(pKind) { const tmpDef = HOLDER_KIND_BY_TYPE[pKind]; if (!tmpDef) { return pKind || 'entities'; } return (pKind === 'Equipment') ? 'Equipment' : `${tmpDef.Label}s`; }

	_certifyKindOptions()
	{
		const tmpKind = this.state.CertifyKind;
		return this._certifyKindChoices().map((pK) => { const tmpDef = HOLDER_KIND_BY_TYPE[pK]; const tmpLabel = tmpDef ? tmpDef.Label : pK; return `<option value="${pK}"${tmpKind === pK ? ' selected' : ''}>${this._esc(tmpLabel)}</option>`; }).join('');
	}

	_certifyHTML(pEditable)
	{
		const tmpState = this.state;
		if (!pEditable) { return '<div class="cert-section"><div class="cert-section-head">Certify</div><p class="cert-note">You can view certifications here, but adding them needs the Create-certification permission.</p></div>'; }
		const tmpNotice = tmpState.CertifyNotice ? `<div class="cert-notice">${this._esc(tmpState.CertifyNotice)}</div>` : '';
		const tmpError = tmpState.CertifyError ? `<div class="cert-error">${this._esc(tmpState.CertifyError)}</div>` : '';
		const tmpBusy = tmpState.CertifySaving ? '<span class="cert-busy">certifying…</span>' : '';
		// A type configured for a single holder kind hides the dropdown (the "simplified interface"); many kinds → dropdown.
		const tmpChoices = this._certifyKindChoices();
		const tmpKindRow = (tmpChoices.length <= 1)
			? `<div class="cert-kind"><span>Certifying</span><span class="cert-kind-fixed">${this._esc(this._kindPlural(tmpChoices[0]))}</span></div>`
			: `<label class="cert-kind"><span>Certify</span><select class="cert-kind-select" onchange="_Pict.providers.Certifications.setCertifyKind(this.value)">${this._certifyKindOptions()}</select></label>`;
		const tmpCfg = tmpState.TypeConfig;
		const tmpDefPreset = (tmpCfg && (tmpCfg.DefaultValidityYears > 0)) ? `<button class="cert-preset cert-preset-default" onclick="_Pict.providers.Certifications.applyDatePreset(${tmpCfg.DefaultValidityYears})">+${tmpCfg.DefaultValidityYears} yr (default)</button>` : '';
		return `<div class="cert-section"><div class="cert-section-head">Certify</div>`
			+ `<p class="cert-note">Choose what you're certifying, set the dates once (optional), pick one or more, and certify them all at once — each gets its own certification record.</p>`
			+ tmpKindRow
			+ `<div class="cert-dates">`
			+ `<label class="cert-date"><span>Certified on</span><input type="date" value="${this._esc(tmpState.CertOn)}" onchange="_Pict.providers.Certifications.setCertDate('On', this.value)"></label>`
			+ `<label class="cert-date"><span>Start</span><input type="date" value="${this._esc(tmpState.CertStart)}" onchange="_Pict.providers.Certifications.setCertDate('Start', this.value)"></label>`
			+ `<label class="cert-date"><span>End</span><input type="date" value="${this._esc(tmpState.CertEnd)}" onchange="_Pict.providers.Certifications.setCertDate('End', this.value)"></label>`
			+ `<span class="cert-presets">${tmpDefPreset}<button class="cert-preset" onclick="_Pict.providers.Certifications.applyDatePreset(1)">+1 yr</button><button class="cert-preset" onclick="_Pict.providers.Certifications.applyDatePreset(5)">+5 yr</button></span>`
			+ `</div>`
			+ `<label class="cert-notes"><span>Notes</span><input type="text" value="${this._esc(tmpState.Notes)}" placeholder="(optional)" onchange="_Pict.providers.Certifications.setNotes(this.value)"></label>`
			+ `<div class="cert-add-row"><div id="Cert-HolderPicker" class="cert-userpicker"></div><button class="cert-btn cert-btn-primary" onclick="_Pict.providers.Certifications.certifySelectedAsync()">Certify selected</button>${tmpBusy}</div>`
			+ tmpNotice + tmpError + `</div>`;
	}

	_holdersHTML(pEditable)
	{
		const tmpState = this.state;
		this._holdersEditable = pEditable;   // remembered so a body-only repaint keeps the remove buttons in the right mode
		return `<div class="cert-section"><div class="cert-section-head">Current holders</div>`
			+ `<input class="cert-holder-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search holders by name…" value="${this._esc(tmpState.HolderSearch || '')}" oninput="_Pict.providers.Certifications.setHolderSearch(this.value)" />`
			+ `<div id="Cert-Holders-Body" class="cert-holders-body">${this._holdersBodyHTML(pEditable)}</div></div>`;
	}

	/** Repaint just the holders body (count + pager + rows) so the search box keeps focus + the pickers don't remount. */
	_renderHoldersBody()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#Cert-Holders-Body').length > 0) { tmpCA.assignContent('#Cert-Holders-Body', this._holdersBodyHTML(this._holdersEditable)); }
		else { this.render(); }
	}

	_holdersBodyHTML(pEditable)
	{
		const tmpState = this.state;
		if (tmpState.HoldersLoading) { return '<p class="cert-note">Loading…</p>'; }
		const tmpSearching = (String(tmpState.HolderSearch || '').trim().length >= 2);
		const tmpRows = (tmpState.Holders || []).map((pHolder) => this._holderRowHTML(pHolder, pEditable)).join('');
		if (!tmpRows) { return `<p class="cert-note">${tmpSearching ? 'No holders match your search.' : 'No one holds this certification yet.'}</p>`; }
		let tmpMeta;
		if (tmpSearching)
		{
			tmpMeta = `<div class="cert-holders-meta"><span class="cert-count">${tmpState.Holders.length} matching holder${tmpState.Holders.length === 1 ? '' : 's'}</span></div>`;
		}
		else
		{
			const tmpTotal = tmpState.HolderTotalCount;
			const tmpPages = Math.max(1, Math.ceil(tmpTotal / tmpState.HolderPageSize));
			const tmpPage = tmpState.HolderPage;
			const tmpFrom = (tmpState.Holders.length ? (tmpPage * tmpState.HolderPageSize + 1) : 0);
			const tmpTo = tmpPage * tmpState.HolderPageSize + tmpState.Holders.length;
			const tmpPager = (tmpPages > 1)
				? `<span class="cert-pager"><button class="cert-page-btn"${tmpPage <= 0 ? ' disabled' : ''} onclick="_Pict.providers.Certifications.holderPrevPage()">‹ Prev</button><span class="cert-page-ind">Page ${tmpPage + 1} of ${tmpPages}</span><button class="cert-page-btn"${tmpPage >= (tmpPages - 1) ? ' disabled' : ''} onclick="_Pict.providers.Certifications.holderNextPage()">Next ›</button></span>`
				: '';
			tmpMeta = `<div class="cert-holders-meta"><span class="cert-count">${tmpTotal} holder${tmpTotal === 1 ? '' : 's'}${(tmpPages > 1) ? ` · showing ${tmpFrom}–${tmpTo}` : ''}</span>${tmpPager}</div>`;
		}
		return tmpMeta + tmpRows;
	}

	_holderKindLabel(pType) { const tmpDef = HOLDER_KIND_BY_TYPE[pType]; return tmpDef ? tmpDef.Label : (pType || 'Entity'); }

	_holderRowHTML(pHolder, pEditable)
	{
		const tmpState = this.state;
		const tmpName = tmpState.HolderNames[`${pHolder.EntityType}:${pHolder.IDEntity}`] || (`${pHolder.EntityType || 'Entity'} #${pHolder.IDEntity}`);
		const tmpKindBadge = (pHolder.EntityType && (pHolder.EntityType !== 'User')) ? `<span class="cert-kind-badge">${this._esc(this._holderKindLabel(pHolder.EntityType))}</span>` : '';
		const tmpRange = (pHolder.Start || pHolder.End) ? `${pHolder.Start || '—'} → ${pHolder.End || '—'}` : 'no dates';
		const tmpRemove = pEditable ? `<button class="cert-x" title="Remove" onclick="_Pict.providers.Certifications.removeHolderAsync(${pHolder.IDCertification}, ${pHolder.IDJoin})"><i class="fas fa-xmark"></i></button>` : '';
		return `<div class="cert-holder"><div class="cert-holder-main"><span class="cert-holder-name">${this._esc(tmpName)}</span>${tmpKindBadge}${this._holderStatusBadge(pHolder)}</div><div class="cert-holder-dates">${this._esc(tmpRange)}</div>${tmpRemove}</div>`;
	}

	_holderStatusBadge(pHolder)
	{
		if (!pHolder.End && !pHolder.Start) { return ''; }
		const tmpToday = new Date().toISOString().slice(0, 10);
		if (pHolder.End && (pHolder.End < tmpToday)) { return '<span class="cert-badge cert-badge-exp">expired</span>'; }
		if (pHolder.Start && (pHolder.Start > tmpToday)) { return '<span class="cert-badge cert-badge-future">not yet active</span>'; }
		return '<span class="cert-badge cert-badge-active">active</span>';
	}

	_appliesKindOptions()
	{
		const tmpKind = this.state.AppliesKind;
		return this._appliesKindChoices().map((pK) => { const tmpDef = HOLDER_KIND_BY_TYPE[pK]; const tmpLabel = tmpDef ? tmpDef.Label : pK; return `<option value="${pK}"${tmpKind === pK ? ' selected' : ''}>${this._esc(tmpLabel)}</option>`; }).join('');
	}

	_appliesToHTML(pEditable)
	{
		const tmpState = this.state;
		// distinct kinds present, ordered: dropdown kinds first, then any extras (e.g. Customer) so nothing is hidden
		const tmpPresent = [];
		(tmpState.AppliesTo || []).forEach((pRow) => { if (tmpPresent.indexOf(pRow.EntityType) === -1) { tmpPresent.push(pRow.EntityType); } });
		const tmpOrdered = APPLIES_TO_KIND_LIST.filter((pK) => tmpPresent.indexOf(pK) > -1).concat(tmpPresent.filter((pK) => APPLIES_TO_KIND_LIST.indexOf(pK) === -1));
		const tmpGroups = tmpOrdered.map((pType) =>
		{
			const tmpLabel = HOLDER_KIND_BY_TYPE[pType] ? HOLDER_KIND_BY_TYPE[pType].Label : pType;
			const tmpChips = (tmpState.AppliesTo || []).filter((pRow) => pRow.EntityType === pType).map((pRow) =>
			{
				const tmpName = tmpState.AppliesToNames[`${pType}:${Number(pRow.IDEntity)}`] || `${pType} #${pRow.IDEntity}`;
				const tmpRemove = pEditable ? `<button class="cert-x" title="Remove" onclick="_Pict.providers.Certifications.removeAppliesToAsync(${Number(pRow.IDCertificationTypeCertifiedEntityPolyJoin)})"><i class="fas fa-xmark"></i></button>` : '';
				return `<div class="cert-chip">${this._esc(tmpName)}${tmpRemove}</div>`;
			}).join('');
			return `<div class="cert-applies-group"><div class="cert-applies-head">${this._esc(tmpLabel)}</div><div class="cert-chips">${tmpChips || '<span class="cert-note">None</span>'}</div></div>`;
		}).join('');
		const tmpApChoices = this._appliesKindChoices();
		const tmpApKindControl = (tmpApChoices.length <= 1)
			? `<span class="cert-applies-fixed">${this._esc((HOLDER_KIND_BY_TYPE[tmpApChoices[0]] || { Label: tmpApChoices[0] }).Label)}</span>`
			: `<select class="cert-applies-select" onchange="_Pict.providers.Certifications.setAppliesKind(this.value)">${this._appliesKindOptions()}</select>`;
		const tmpAdd = pEditable
			? `<div class="cert-applies-add"><span class="cert-applies-lbl">Kind</span>${tmpApKindControl}<div id="Cert-AppliesPicker" class="cert-entpicker"></div><button class="cert-btn" onclick="_Pict.providers.Certifications.addAppliesToAsync()">Add</button></div>`
			: '';
		const tmpError = tmpState.AppliesToError ? `<div class="cert-error">${this._esc(tmpState.AppliesToError)}</div>` : '';
		return `<div class="cert-section"><div class="cert-section-head">Certifies for</div>`
			+ `<p class="cert-note">Which entities this certification type applies to — materials, labs, tests, equipment…</p>${tmpAdd}${tmpGroups}${tmpError}</div>`;
	}

	_newTypeHTML()
	{
		const tmpState = this.state;
		const tmpError = tmpState.NewTypeError ? `<div class="cert-error">${this._esc(tmpState.NewTypeError)}</div>` : '';
		const tmpBusy = tmpState.NewTypeSaving ? '<span class="cert-busy">saving…</span>' : '';
		return `<div class="cert-detail-head"><div class="cert-detail-title">New certification type</div></div>`
			+ `<div class="cert-section">`
			+ `<label class="cert-field"><span>Name</span><input type="text" value="${this._esc(tmpState.NewTypeName)}" placeholder="e.g. Asphalt Sampling" oninput="_Pict.providers.Certifications.setNewTypeField('Name', this.value)"></label>`
			+ `<label class="cert-field"><span>Verb</span><input type="text" value="${this._esc(tmpState.NewTypeVerb)}" placeholder="e.g. Collect Sample" oninput="_Pict.providers.Certifications.setNewTypeField('Verb', this.value)"></label>`
			+ `<label class="cert-field"><span>Hash / code</span><input type="text" value="${this._esc(tmpState.NewTypeHash)}" placeholder="(optional short code)" oninput="_Pict.providers.Certifications.setNewTypeField('Hash', this.value)"></label>`
			+ `<label class="cert-field"><span>Description</span><textarea rows="2" oninput="_Pict.providers.Certifications.setNewTypeField('Description', this.value)">${this._esc(tmpState.NewTypeDescription)}</textarea></label>`
			+ `<div class="cert-add-row"><button class="cert-btn cert-btn-primary" onclick="_Pict.providers.Certifications.createTypeAsync()">Create type</button><button class="cert-btn cert-btn-ghost" onclick="_Pict.providers.Certifications.selectType(0)">Cancel</button>${tmpBusy}</div>`
			+ tmpError + `</div>`;
	}
}

module.exports = CertificationsProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'Certifications',
	AutoInitialize: true,
	AutoInitializeOrdinal: 40,
};

},{"../Certification-Config.js":1054,"../access/User-Search.js":1064,"pict-provider":845}],1311:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

// The Default-ChangeOrder HeadlightDynamicForm manifest (extracted from ContractAdminConfig getChangeOrderFormRNI).
// Rendered by the ChangeOrderFormHost (pict-section-form-host) for create/edit.
const CHANGE_ORDER_MANIFEST = require('../change-orders/Default-ChangeOrder-Manifest.json');
const libProjectChangeOrderGating = require('../change-orders/ProjectChangeOrderGating.js');

const BODY_MOUNT = '#CO-Body';

// Coarse ChangeOrder header statuses (the approval lifecycle) → a color class for the status pill.
const STATUS_CLASS =
{
	'Draft': 'co-st-draft',
	'Pending PE': 'co-st-pending', 'Pending CE': 'co-st-pending', 'Pending CA': 'co-st-pending',
	'Submitted': 'co-st-submitted',
	'Approved': 'co-st-approved',
	'Rejected': 'co-st-rejected',
};

/**
 * ChangeOrdersProvider — data + render for the ProjectWorkspace Contract ▸ Change Orders tab. Phase 1: list /
 * browse the project's ChangeOrder headers and view one (its header + LineItemChangeOrder lines + linked form).
 *
 * A change order is a GROUP: one ChangeOrder header (ChangeNumber, Amount, Status, dates, FormIDDocument) groups
 * many LineItemChangeOrder rows via IDChangeOrder. Both are plain Meadow entities, read customer/project-scoped.
 * The surface honors the same `enableNewChangeOrders` config the contract_admin app reads
 * (Configuration/For/ApplicationSettings → ContractAdmin, with a per-project override). Create/edit (the Tidings
 * change-order form via pict-section-form-host) + the project-status line-item gating arrive in Phase 2.
 */
class ChangeOrdersProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._idProject = 0;
		this.hasModel = false;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get permissions() { return this.pict.fable.EffectivePermissionsService; }
	get idProject() { return this._idProject; }

	get state()
	{
		if (!this.pict.AppData.ChangeOrders)
		{
			this.pict.AppData.ChangeOrders =
			{
				Mode: 'list', Loading: false, Message: '', ProjectName: '', IDProject: 0,
				EnableNewChangeOrders: true, Rows: [], Filter: '', ActiveCO: null, Lines: [],
			};
		}
		return this.pict.AppData.ChangeOrders;
	}

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }

	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'info' }); } }

	/** Read-only gate (Phase 1 lists + views); fail-closed until the capability map is ready. */
	canRead()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return true; }
		return tmpPermissions.canHash('ChangeOrder-Read');
	}

	/** Create gate — ChangeOrder-Create; fail-closed once the capability map is ready. */
	canCreate()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return true; }
		return tmpPermissions.canHash('ChangeOrder-Create');
	}

	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	_money(pValue)
	{
		const tmpN = Number(pValue);
		if (!Number.isFinite(tmpN)) { return '—'; }
		try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(tmpN); }
		catch (pError) { return '$' + tmpN.toFixed(2); }
	}

	_date(pValue)
	{
		const tmpString = String(pValue == null ? '' : pValue);
		if (!tmpString || tmpString.indexOf('0000-00-00') === 0) { return '—'; }
		const tmpDate = new Date(tmpString);
		return Number.isNaN(tmpDate.getTime()) ? tmpString : tmpDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
	}

	// --- Rendering seam: the view repaints the template into its (embedded) host, then paints the body here. ---

	_render() { if (this.pict.views['ChangeOrders']) { this.pict.views['ChangeOrders'].render(); } }

	renderBody()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
		// In form mode a re-paint recreates an empty #CO-FormHost; if the form host already has a manifest loaded
		// (e.g. a workspace repaint fired), re-render it into the fresh host so the form isn't wiped.
		if ((this.state.Mode === 'form') && this.formHost && (typeof this.formHost.isLoaded === 'function') && this.formHost.isLoaded()
			&& (this.pict.ContentAssignment.getElement('#CO-FormHost').length > 0))
		{
			try { this.formHost.render(); } catch (pError) { /* best-effort re-mount */ }
		}
	}

	// --- Config: the same enableNewChangeOrders the contract_admin app reads (customer + per-project override) ---

	async _loadEnableNewChangeOrdersAsync()
	{
		try
		{
			const tmpConfig = await this._getJSON(`Configuration/For/ApplicationSettings/ContractAdmin/IDProject/${this._idProject}`);
			// The scoped endpoint returns the ContractAdmin block directly (project override folded over customer).
			if (tmpConfig && (typeof tmpConfig.enableNewChangeOrders !== 'undefined')) { return !!tmpConfig.enableNewChangeOrders; }
			// Fallback shape: the full ApplicationSettings document with a ContractAdmin sub-object.
			if (tmpConfig && tmpConfig.ContractAdmin && (typeof tmpConfig.ContractAdmin.enableNewChangeOrders !== 'undefined')) { return !!tmpConfig.ContractAdmin.enableNewChangeOrders; }
		}
		catch (pError) { /* config unavailable — default on (the reference treats a missing flag as the new flow off, but here the tab is already gated by presence; default to showing the list) */ }
		return true;
	}

	/**
	 * The two-mode gating (same as contract_admin's ProjectChangeOrderGating): the project requires a change order
	 * for line-item edits when its Status is in the ProjectType's RequiresChangeOrder list. Also discover the
	 * project's change-order form RNI (the Document DocumentType used on create/edit).
	 */
	async _loadGatingAsync()
	{
		this._coRNIHash = '';
		const tmpGating = await libProjectChangeOrderGating.fetchProjectChangeOrderGating((pURL) => this._getJSON(pURL), this._idProject);
		try
		{
			const tmpRNIs = await this._getJSON(`ReportNamedInstancesByProject/${this._idProject}/0/250`);
			const tmpCO = (Array.isArray(tmpRNIs) ? tmpRNIs : []).filter((pRNI) =>
			{
				try { const tmpOpt = (typeof pRNI.Options === 'string') ? JSON.parse(pRNI.Options) : (pRNI.Options || {}); return tmpOpt.FormOnly && tmpOpt.TidingsData && (String(tmpOpt.TidingsData.Type || '').toLowerCase().indexOf('changeorder') > -1); }
				catch (pInner) { return false; }
			});
			// Prefer an active (non-archived) change-order form.
			const tmpActive = tmpCO.find((pRNI) => !/DO NOT USE|ARCHIV/i.test(pRNI.Name || '')) || tmpCO[0];
			this._coRNIHash = tmpActive ? tmpActive.Hash : '';
		}
		catch (pError) { /* no RNI discoverable — create/edit will surface a clear message */ }
		this.state.RequiresChangeOrder = !!tmpGating.requires;
		this.state.ProjectStatus = tmpGating.status || '';
	}

	// --- Load ---

	async loadAsync(pIDProject)
	{
		this._idProject = Number(pIDProject) || 0;
		const tmpState = this.state;
		tmpState.IDProject = this._idProject;
		tmpState.Mode = 'list';
		tmpState.Loading = true;
		tmpState.Message = '';
		this.hasModel = false;
		this._render();
		try
		{
			const tmpResults = await Promise.all(
			[
				this._loadEnableNewChangeOrdersAsync(),
				this._loadGatingAsync().then(() => true).catch(() => true),
				this._getJSON(`ChangeOrders/FilteredTo/FBV~IDProject~EQ~${this._idProject}~FBV~Deleted~EQ~0~FSF~DateOfChange~DESC~0/0/500`),
			]);
			tmpState.EnableNewChangeOrders = tmpResults[0];
			const tmpRows = tmpResults[2];
			tmpState.Rows = (Array.isArray(tmpRows) ? tmpRows : []);
			this.hasModel = true;
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load change orders: ${(pError && pError.message) ? pError.message : pError}`;
			this._render();
		}
	}

	/** Open one change order's detail (its header + its LineItemChangeOrder line rows). */
	async openCO(pIDChangeOrder)
	{
		const tmpState = this.state;
		const tmpID = Number(pIDChangeOrder) || 0;
		tmpState.ActiveCO = (tmpState.Rows || []).find((pRow) => Number(pRow.IDChangeOrder) === tmpID) || null;
		tmpState.Mode = 'detail';
		tmpState.Loading = true;
		this._render();
		try
		{
			if (!tmpState.ActiveCO) { tmpState.ActiveCO = await this._getJSON(`ChangeOrder/${tmpID}`); }
			const tmpLines = await this._getJSON(`LineItemChangeOrders/FilteredTo/FBV~IDChangeOrder~EQ~${tmpID}~FBV~Deleted~EQ~0~FSF~ChangeNumber~ASC~0/0/500`);
			tmpState.Lines = (Array.isArray(tmpLines) ? tmpLines : []);
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the change order: ${(pError && pError.message) ? pError.message : pError}`;
			this._render();
		}
	}

	backToList()
	{
		const tmpState = this.state;
		tmpState.Mode = 'list';
		tmpState.Message = '';
		tmpState.ActiveCO = null;
		tmpState.Lines = [];
		this._render();
	}

	// --- Create / edit via the change-order dynamic form (pict-section-form-host) ---

	get formHost() { return this.pict.providers.ChangeOrderFormHost; }

	/** Open a blank change-order form (create). Paints the form panel, then mounts the form into #CO-FormHost. */
	startCreate()
	{
		const tmpState = this.state;
		tmpState.Mode = 'form';
		tmpState.FormMode = 'create';
		tmpState.FormTitle = 'New Change Order';
		tmpState.Message = '';
		this._editingIDDocument = 0;
		this.pict.AppData.ChangeOrderForm = {};
		this._render();
		this._mountForm({});
	}

	/** Mount (or remount) the change-order form manifest into the freshly-painted #CO-FormHost. */
	_mountForm(pData)
	{
		const tmpHost = this.formHost;
		if (!tmpHost || (typeof tmpHost.loadForm !== 'function'))
		{
			this.state.Message = 'The change-order form runner is not available.';
			this.renderBody();
			return;
		}
		try
		{
			this.pict.AppData.ChangeOrderForm = pData || {};
			tmpHost.loadForm(CHANGE_ORDER_MANIFEST, { DestinationAddress: '#CO-FormHost', DataAddress: 'AppData.ChangeOrderForm' });
		}
		catch (pError)
		{
			this.state.Message = `Could not open the change-order form: ${(pError && pError.message) ? pError.message : pError}`;
			this.renderBody();
		}
	}

	get modal() { return this.pict.views['Pict-Section-Modal']; }

	/**
	 * Save the change-order form as a Draft Document (the same shape contract_admin's FormCreate posts: DocumentType
	 * = the project's change-order form RNI, Form:1, FormData = the marshaled form). The server's DocumentApproval
	 * workflow materializes the ChangeOrder/LineItemChangeOrder rows on approval; a Draft just persists the form.
	 */
	async saveForm()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		const tmpHost = this.formHost;
		if (!tmpHost) { this._toast('The change-order form runner is not available.', 'error'); return; }
		if (!this._coRNIHash) { this._toast('No change-order form is configured for this project.', 'error'); return; }
		if (typeof tmpHost.save === 'function') { try { tmpHost.save(); } catch (pError) { /* marshal best-effort */ } }
		const tmpFormData = Object.assign({ Meta: { DocumentCreatorApp: 'Platform Configuration' } },
			(typeof tmpHost.getFormData === 'function') ? (tmpHost.getFormData() || {}) : (this.pict.AppData.ChangeOrderForm || {}));
		tmpState.Saving = true;
		try
		{
			const tmpNow = (new Date()).toISOString();
			let tmpSaved;
			if (this._editingIDDocument)
			{
				tmpSaved = await this._putJSON('Document', { IDDocument: Number(this._editingIDDocument), IDProject: this._idProject, DocumentType: this._coRNIHash, Form: 1, FormData: tmpFormData });
			}
			else
			{
				tmpSaved = await this._postJSON('Document',
					{ Name: `Change Order — ${tmpNow.slice(0, 10)}`, DocumentDate: tmpNow, IDProject: this._idProject, DocumentType: this._coRNIHash, Form: 1, FormData: tmpFormData, Status: 'Draft', Observations: [] });
			}
			if (!tmpSaved || tmpSaved.ErrorCode || tmpSaved.Error)
			{
				throw new Error((tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode)) ? String(tmpSaved.Error || tmpSaved.ErrorCode) : 'the server rejected the change order.');
			}
			tmpState.Saving = false;
			this._editingIDDocument = 0;
			this._toast('Change order draft saved.', 'success');
			this.loadAsync(this._idProject);   // back to the list, refreshed
		}
		catch (pError)
		{
			tmpState.Saving = false;
			this._toast(`Could not save the change order: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
	}

	/** Edit an existing change order — reopen its form Document (FormIDDocument) in the runner. */
	async editCO(pIDChangeOrder)
	{
		const tmpState = this.state;
		const tmpCO = (tmpState.ActiveCO && Number(tmpState.ActiveCO.IDChangeOrder) === Number(pIDChangeOrder))
			? tmpState.ActiveCO
			: (tmpState.Rows || []).find((pRow) => Number(pRow.IDChangeOrder) === Number(pIDChangeOrder));
		if (!tmpCO || !tmpCO.FormIDDocument) { this._toast('This change order has no editable form.', 'info'); return; }
		tmpState.Mode = 'form';
		tmpState.FormMode = 'edit';
		tmpState.FormTitle = `Edit ${tmpCO.ChangeNumber || 'Change Order'}`;
		tmpState.Message = '';
		tmpState.Loading = true;
		this._render();
		try
		{
			const tmpDoc = await this._getJSON(`Document/${Number(tmpCO.FormIDDocument)}`);
			this._editingIDDocument = Number(tmpCO.FormIDDocument);
			tmpState.Loading = false;
			this._render();
			this._mountForm((tmpDoc && tmpDoc.FormData) ? tmpDoc.FormData : {});
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the change-order form: ${(pError && pError.message) ? pError.message : pError}`;
			this._render();
		}
	}

	cancelForm()
	{
		const tmpHost = this.formHost;
		if (tmpHost && (typeof tmpHost.destroy === 'function')) { try { tmpHost.destroy(); } catch (pError) { /* best-effort */ } }
		this._editingIDDocument = 0;
		this.state.Mode = 'list';
		this.state.Message = '';
		this._render();
	}

	/** In-place list filter (keeps the filter input focused — only the list body repaints). */
	onFilter(pValue)
	{
		this.state.Filter = pValue;
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#CO-List').length) { tmpCA.assignContent('#CO-List', this._listRowsHTML()); }
	}

	// --- HTML ---

	_bodyHTML()
	{
		const tmpState = this.state;
		if (!this.canRead()) { return `<div class="co-note co-note-locked"><i class="fas fa-lock"></i> You don’t have permission to view change orders.</div>`; }
		if (tmpState.Loading) { return `<div class="co-note"><i class="fas fa-spinner fa-spin"></i> Loading…</div>`; }
		if (tmpState.Message && tmpState.Mode !== 'form') { return `<div class="co-note co-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Message)}</div>`; }
		if (tmpState.Mode === 'form') { return this._formHTML(); }
		return (tmpState.Mode === 'detail') ? this._detailHTML() : this._listHTML();
	}

	_formHTML()
	{
		const tmpState = this.state;
		const tmpError = tmpState.Message ? `<div class="co-note co-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Message)}</div>` : '';
		return `<div class="co-head"><div><div class="co-eyebrow"><a class="co-back" onclick="_Pict.providers.ChangeOrders.cancelForm()"><i class="fas fa-arrow-left"></i> Change Orders</a></div>`
			+ `<h2 class="co-title">${this._esc(tmpState.FormTitle || 'Change Order')}</h2></div>`
			+ `<div class="co-head-actions"><button class="co-btn co-btn-primary" onclick="_Pict.providers.ChangeOrders.saveForm(); return false;">Save draft</button>`
			+ `<button class="co-btn" onclick="_Pict.providers.ChangeOrders.cancelForm(); return false;">Cancel</button></div></div>`
			+ tmpError
			+ `<div id="CO-FormHost" class="co-form-host"></div>`;
	}

	_listHTML()
	{
		const tmpState = this.state;
		const tmpGatedNote = tmpState.EnableNewChangeOrders ? ''
			: `<div class="co-note co-note-info"><i class="fas fa-circle-info"></i> The new Change Orders flow is not enabled for this project — showing existing change orders read-only.</div>`;
		// The two-mode indicator (projectRequiresChangeOrder): the project's status decides whether line-item edits go
		// direct or must be made through a change order.
		const tmpModeBanner = tmpState.RequiresChangeOrder
			? `<div class="co-mode co-mode-required"><i class="fas fa-lock"></i> This project’s status <strong>${this._esc(tmpState.ProjectStatus || '')}</strong> requires a <strong>Change Order</strong> to modify line items or bid items.</div>`
			: (tmpState.ProjectStatus ? `<div class="co-mode co-mode-direct"><i class="fas fa-pen-to-square"></i> Line items on this project (status <strong>${this._esc(tmpState.ProjectStatus)}</strong>) are directly editable; change orders are optional.</div>` : '');
		const tmpNewBtn = (tmpState.EnableNewChangeOrders && this.canCreate())
			? `<button class="co-btn co-btn-primary" onclick="_Pict.providers.ChangeOrders.startCreate(); return false;"><i class="fas fa-plus"></i> New Change Order</button>`
			: '';
		return `<div class="co-head"><div><div class="co-eyebrow">Contract</div><h2 class="co-title">Change Orders</h2></div>`
			+ `<div class="co-head-actions">${tmpNewBtn}<input class="co-filter" type="text" autocomplete="off" placeholder="Filter by number, status, description…" oninput="_Pict.providers.ChangeOrders.onFilter(this.value)" /></div></div>`
			+ tmpModeBanner
			+ tmpGatedNote
			+ `<div id="CO-List" class="co-list">${this._listRowsHTML()}</div>`;
	}

	_listRowsHTML()
	{
		const tmpState = this.state;
		const tmpTerm = String(tmpState.Filter || '').trim().toLowerCase();
		const tmpRows = (tmpState.Rows || []).filter((pRow) => !tmpTerm
			|| (String(pRow.ChangeNumber || '').toLowerCase().indexOf(tmpTerm) > -1)
			|| (String(pRow.Status || '').toLowerCase().indexOf(tmpTerm) > -1)
			|| (String(pRow.Description || '').toLowerCase().indexOf(tmpTerm) > -1));
		if (!tmpRows.length) { return `<div class="co-note">${tmpTerm ? 'No change orders match your filter.' : 'This project has no change orders yet.'}</div>`; }
		const tmpHeader = `<div class="co-row co-row-head"><span class="co-c-num">Change #</span><span class="co-c-desc">Description</span><span class="co-c-amt">Amount</span><span class="co-c-status">Status</span><span class="co-c-date">Date</span><span class="co-c-chev"></span></div>`;
		return tmpHeader + tmpRows.map((pRow) =>
		{
			const tmpStatus = String(pRow.Status || '');
			const tmpPill = tmpStatus ? `<span class="co-pill ${STATUS_CLASS[tmpStatus] || 'co-st-draft'}">${this._esc(tmpStatus)}</span>` : '—';
			return `<div class="co-row co-row-click" onclick="_Pict.providers.ChangeOrders.openCO(${Number(pRow.IDChangeOrder)})">`
				+ `<span class="co-c-num">${this._esc(pRow.ChangeNumber || `#${pRow.IDChangeOrder}`)}</span>`
				+ `<span class="co-c-desc">${this._esc(String(pRow.Description || '').slice(0, 120))}</span>`
				+ `<span class="co-c-amt">${this._money(pRow.Amount)}</span>`
				+ `<span class="co-c-status">${tmpPill}</span>`
				+ `<span class="co-c-date">${this._date(pRow.DateOfChange)}</span>`
				+ `<span class="co-c-chev"><i class="fas fa-chevron-right"></i></span>`
				+ `</div>`;
		}).join('');
	}

	_detailHTML()
	{
		const tmpState = this.state;
		const tmpCO = tmpState.ActiveCO || {};
		const tmpStatus = String(tmpCO.Status || '');
		const tmpPill = tmpStatus ? `<span class="co-pill ${STATUS_CLASS[tmpStatus] || 'co-st-draft'}">${this._esc(tmpStatus)}</span>` : '';
		const fField = (pLabel, pValue) => `<div class="co-field"><span class="co-field-label">${this._esc(pLabel)}</span><span class="co-field-value">${pValue}</span></div>`;
		const tmpFormLink = tmpCO.FormIDDocument
			? `<a class="co-form-link" href="#/PSRS/Document/View/${Number(tmpCO.FormIDDocument)}"><i class="fas fa-file-lines"></i> Change Order Form #${Number(tmpCO.FormIDDocument)}</a>`
			: '<span class="co-field-value">—</span>';
		const tmpEditBtn = (tmpState.EnableNewChangeOrders && this.canCreate() && tmpCO.FormIDDocument)
			? `<button class="co-btn co-btn-primary" onclick="_Pict.providers.ChangeOrders.editCO(${Number(tmpCO.IDChangeOrder)}); return false;"><i class="fas fa-pen"></i> Edit form</button>`
			: '';
		return `<div class="co-head"><div><div class="co-eyebrow"><a class="co-back" onclick="_Pict.providers.ChangeOrders.backToList()"><i class="fas fa-arrow-left"></i> Change Orders</a></div>`
			+ `<h2 class="co-title">${this._esc(tmpCO.ChangeNumber || `Change Order #${tmpCO.IDChangeOrder}`)} ${tmpPill}</h2></div>`
			+ `<div class="co-head-actions">${tmpEditBtn}</div></div>`
			+ `<div class="co-detail-grid">`
			+ fField('Amount', this._money(tmpCO.Amount))
			+ fField('Reason Code', this._esc(tmpCO.ReasonCode || '—'))
			+ fField('Additional Days', this._esc((tmpCO.AdditionalDays != null && tmpCO.AdditionalDays !== '') ? tmpCO.AdditionalDays : '—'))
			+ fField('Date of Change', this._date(tmpCO.DateOfChange))
			+ fField('Approved', this._date(tmpCO.ApprovedByDate))
			+ fField('Form', tmpFormLink)
			+ `</div>`
			+ (tmpCO.Description ? `<div class="co-block"><div class="co-block-label">Description</div><div class="co-block-body">${this._esc(tmpCO.Description)}</div></div>` : '')
			+ (tmpCO.Remarks ? `<div class="co-block"><div class="co-block-label">Remarks</div><div class="co-block-body">${this._esc(tmpCO.Remarks)}</div></div>` : '')
			+ `<div class="co-block-label co-lines-label">Line Items <span class="co-lines-count">${(tmpState.Lines || []).length}</span></div>`
			+ this._linesHTML();
	}

	_linesHTML()
	{
		const tmpLines = this.state.Lines || [];
		if (!tmpLines.length) { return `<div class="co-note">This change order has no line-item changes.</div>`; }
		const tmpHeader = `<div class="co-lrow co-lrow-head"><span class="co-l-num">#</span><span class="co-l-name">Item</span><span class="co-l-qty">Change Qty</span><span class="co-l-cpu">Cost / Unit</span><span class="co-l-amt">Amount</span><span class="co-l-status">Status</span></div>`;
		return `<div class="co-lines">` + tmpHeader + tmpLines.map((pLine) =>
			`<div class="co-lrow">`
			+ `<span class="co-l-num">${this._esc(pLine.ChangeNumber || '')}</span>`
			+ `<span class="co-l-name">${this._esc(pLine.Name || pLine.ItemNumber || `Item ${pLine.IDLineItem || ''}`)}</span>`
			+ `<span class="co-l-qty">${this._esc((pLine.ChangeQuantity != null && pLine.ChangeQuantity !== '') ? pLine.ChangeQuantity : '—')}</span>`
			+ `<span class="co-l-cpu">${this._money(pLine.CostPerUnit)}</span>`
			+ `<span class="co-l-amt">${this._money(pLine.Amount)}</span>`
			+ `<span class="co-l-status">${this._esc(pLine.CommitmentChangeStatus || '—')}</span>`
			+ `</div>`).join('') + `</div>`;
	}
}

module.exports = ChangeOrdersProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ChangeOrders',
	AutoInitialize: true,
	AutoInitializeOrdinal: 228,
};

},{"../change-orders/Default-ChangeOrder-Manifest.json":1073,"../change-orders/ProjectChangeOrderGating.js":1074,"pict-provider":845}],1312:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const libCatalog = require('../config-editor/Config-Namespace-Catalog.js');
const libClone = require('../config-editor/Config-Clone.js');

// Scopes the clone exposes for source (all readable) and target (gated by canWriteScope).
const SCOPES = [ 'Global', 'Customer', 'Project', 'User' ];

/**
 * ConfigCloneProvider — the data layer for cloning a namespace's configuration from one context to
 * another. Reads the source's effective config per NamespaceValue, then writes the selected values at
 * the target scope/context (the Configuration service diffs each Put vs the target's parent). Delegates
 * REST + permission + scope-labelling to the ConfigViewer provider to avoid duplication.
 */
class ConfigCloneProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	onAfterInitialize()
	{
		this._ensureState();
		return super.onAfterInitialize();
	}

	get cv()
	{
		return this.pict.providers.ConfigViewer;
	}

	_ensureState()
	{
		if (!this.pict.AppData.ConfigClone)
		{
			this.pict.AppData.ConfigClone =
			{
				NamespaceKey: (libCatalog.CONFIG_NAMESPACE_CATALOG[0] || {}).NamespaceKey || 'MasterListCatalog',
				SourceScope: 'Customer',
				SourceID: 0,
				TargetScope: 'User',
				TargetID: 0,
				Values: [],                 // [{ Value, Checked }]
				SourceConfigByValue: {},
				Loaded: false,
				Result: null,               // { Succeeded, Failed, Details:[{Value, OK, Error?}] }
				Loading: false,
				Message: '',
			};
		}
		return this.pict.AppData.ConfigClone;
	}

	get state()
	{
		return this._ensureState();
	}

	/** Default the source/target ids from the live session once it's known (init runs before login). */
	_ensureSessionDefaults()
	{
		const tmpState = this.state;
		if (!(parseInt(tmpState.SourceID, 10) > 0))
		{
			tmpState.SourceID = (tmpState.SourceScope === 'User') ? this.cv.idUser : this.cv.idCustomer;
		}
		if (!(parseInt(tmpState.TargetID, 10) > 0))
		{
			tmpState.TargetID = (tmpState.TargetScope === 'User') ? this.cv.idUser : this.cv.idCustomer;
		}
	}

	/** Resolve a level id, falling back to the session when 0/blank (Global is always 0). */
	_idOrSession(pScope, pID)
	{
		if (pScope === 'Global') { return 0; }
		const tmpID = parseInt(pID, 10);
		if (tmpID > 0) { return tmpID; }
		return (pScope === 'User') ? this.cv.idUser : this.cv.idCustomer;
	}

	// --- field setters (from the view) ---

	setField(pField, pValue)
	{
		this.state[pField] = pValue;
		// Changing a scope invalidates a defaulted id so the new scope's session id can fill in.
		if (pField === 'SourceScope') { this.state.SourceID = 0; }
		if (pField === 'TargetScope') { this.state.TargetID = 0; }
	}

	toggleValue(pValue)
	{
		const tmpRow = this.state.Values.find((pRow) => pRow.Value === pValue);
		if (tmpRow) { tmpRow.Checked = !tmpRow.Checked; }
	}

	setAllChecked(pChecked)
	{
		this.state.Values.forEach((pRow) => { pRow.Checked = !!pChecked; });
	}

	selectedValues()
	{
		return this.state.Values.filter((pRow) => pRow.Checked).map((pRow) => pRow.Value);
	}

	buildPlan()
	{
		return libClone.planClone(this.state.SourceConfigByValue, this.selectedValues());
	}

	// --- load + apply ---

	/** Read the source namespace's effective config (all values) at the chosen source scope/context. */
	async loadSourceValuesAsync()
	{
		const tmpState = this.state;
		this._ensureSessionDefaults();
		tmpState.Loading = true;
		tmpState.Message = '';
		tmpState.Result = null;
		try
		{
			const tmpBody = await this.cv._postJSON('Configuration/Get',
				{
					LevelContext: tmpState.SourceScope,
					LevelContextID: this._idOrSession(tmpState.SourceScope, tmpState.SourceID),
					NamespaceKey: tmpState.NamespaceKey,
				});
			const tmpMap = (tmpBody && tmpBody.Document) || tmpBody || {};
			tmpState.SourceConfigByValue = {};
			Object.keys(tmpMap)
				.filter((pKey) => pKey !== 'Config' && pKey !== 'LevelControlRecords')
				.forEach((pKey) => { tmpState.SourceConfigByValue[pKey] = tmpMap[pKey]; });
			tmpState.Values = Object.keys(tmpState.SourceConfigByValue).map((pValue) => ({ Value: pValue, Checked: true }));
			tmpState.Loaded = true;
			if (!tmpState.Values.length)
			{
				tmpState.Message = 'No values found for this namespace at the source context.';
			}
		}
		catch (pError)
		{
			tmpState.Message = `Could not load source: ${pError.message}`;
		}
		tmpState.Loading = false;
	}

	/**
	 * Apply the plan: Put each selected value at the target scope/context. Aggregates per-value results.
	 * @return {Promise<object|null>} the result summary
	 */
	async applyAsync()
	{
		const tmpState = this.state;
		const tmpPlan = this.buildPlan();
		if (!tmpPlan.length)
		{
			tmpState.Message = 'Nothing selected to clone.';
			return null;
		}
		if (!this.cv.canWriteScope(tmpState.TargetScope))
		{
			tmpState.Message = `You don't have permission to write the ${this.cv._scopeLabel(tmpState.TargetScope)} scope.`;
			return null;
		}
		tmpState.Loading = true;
		tmpState.Message = '';
		const tmpTargetID = this._idOrSession(tmpState.TargetScope, tmpState.TargetID);
		const tmpDetails = [];
		for (let i = 0; i < tmpPlan.length; i++)
		{
			const tmpItem = tmpPlan[i];
			const tmpURL = `Configuration/Put/${tmpState.NamespaceKey}/${tmpItem.NamespaceValue}/${tmpState.TargetScope}/${tmpTargetID}`;
			try
			{
				/* eslint-disable no-await-in-loop */
				await this.cv._postJSON(tmpURL, { Config: tmpItem.Config });
				/* eslint-enable no-await-in-loop */
				tmpDetails.push({ Value: tmpItem.NamespaceValue, OK: true });
			}
			catch (pError)
			{
				tmpDetails.push({ Value: tmpItem.NamespaceValue, OK: false, Error: pError.message });
			}
		}
		tmpState.Result =
		{
			Succeeded: tmpDetails.filter((pDetail) => pDetail.OK).length,
			Failed: tmpDetails.filter((pDetail) => !pDetail.OK).length,
			Details: tmpDetails,
		};
		tmpState.Loading = false;
		return tmpState.Result;
	}

	// --- derive view state ---

	deriveRenderState()
	{
		const tmpState = this.state;
		this._ensureSessionDefaults();

		tmpState.NamespaceOptions = libCatalog.CONFIG_NAMESPACE_CATALOG.map((pEntry) => (
			{
				Value: pEntry.NamespaceKey,
				Label: pEntry.Label,
				SelectedAttr: (pEntry.NamespaceKey === tmpState.NamespaceKey) ? 'selected' : '',
			}));

		tmpState.SourceScopeOptions = SCOPES.map((pScope) => (
			{
				Value: pScope,
				Label: this.cv._scopeLabel(pScope),
				SelectedAttr: (pScope === tmpState.SourceScope) ? 'selected' : '',
				DisabledAttr: '',
			}));
		tmpState.TargetScopeOptions = SCOPES.map((pScope) => (
			{
				Value: pScope,
				Label: this.cv._scopeLabel(pScope),
				SelectedAttr: (pScope === tmpState.TargetScope) ? 'selected' : '',
				DisabledAttr: this.cv.canWriteScope(pScope) ? '' : 'disabled',
			}));

		tmpState.ValueRows = (tmpState.Values || []).map((pRow) => (
			{ Value: pRow.Value, CheckedAttr: pRow.Checked ? 'checked' : '' }));

		const tmpSelectedCount = this.selectedValues().length;
		const tmpCanWriteTarget = this.cv.canWriteScope(tmpState.TargetScope);
		tmpState.SelectedCount = tmpSelectedCount;
		tmpState.CanApply = tmpSelectedCount > 0 && tmpCanWriteTarget;
		tmpState.ApplyDisabledAttr = tmpState.CanApply ? '' : 'disabled';

		// conditional slots
		tmpState.LoadingSlot = tmpState.Loading ? [ {} ] : [];
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message } ] : [];
		tmpState.ValuesSlot = (tmpState.Loaded && (tmpState.Values || []).length) ? [ {} ] : [];
		tmpState.NoTargetPermSlot = (!tmpCanWriteTarget) ? [ { Scope: this.cv._scopeLabel(tmpState.TargetScope) } ] : [];
		tmpState.ResultSlot = tmpState.Result ? [ tmpState.Result ] : [];
		tmpState.ResultRows = tmpState.Result ? tmpState.Result.Details.map((pDetail) => (
			{
				Value: pDetail.Value,
				StatusClass: pDetail.OK ? 'has-text-success' : 'has-text-danger',
				StatusText: pDetail.OK ? 'cloned' : ('failed: ' + (pDetail.Error || 'error')),
			})) : [];

		return tmpState;
	}
}

module.exports = ConfigCloneProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ConfigCloneProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 41,
};

},{"../config-editor/Config-Clone.js":1075,"../config-editor/Config-Namespace-Catalog.js":1077,"pict-provider":845}],1313:[function(require,module,exports){

// ConfigSync — a debounced trigger for the platform's Configuration Sync job.
//
// Configuration Sync is the step that PUBLISHES a project's/customer's configuration (label types + label
// values, observation types, …) out to Fieldbook and the field apps. Without it, a newly-created label exists
// in the API and shows in the config/Projects app, but never reaches Fieldbook on observations — which is
// exactly the reported gap ("we used to run a config sync on a project for the labels to show"). This wires
// that sync to run automatically after a label change.
//
// It mirrors the legacy app's manual "Config Sync" page (web/app_headlight/src/pages/ConfigurationSync.vue):
//   GET /1.0/ConfigurationSync/Sync/{Context}/{ContextID}   → queues an async job (Context ∈ Customer|Project).
//
// The endpoint is SUPER-USER-ONLY (server EndpointBase._isSuperUser: role index 5 AND customer 1). For anyone
// else it 403s; we surface that as a gentle, actionable notice rather than an error (the label change itself
// still saved — a super-user just needs to run the sync). Rapid edits are coalesced into ONE job per
// (Context, ID) by a short debounce so, e.g., seeding a default set + adding a type triggers a single sync.

const DEBOUNCE_MS = 2000;

/** @type {Record<string, any>} - pending debounce timers keyed by `${Context}:${ContextID}`. */
const _timers = {};

function _restClient(pPict)
{
	return (pPict && pPict.fable && pPict.fable.HeadlightRestClient) || (pPict && pPict.HeadlightRestClient) || null;
}

function _toast(pPict, pMessage, pType)
{
	const tmpModal = pPict && pPict.views && pPict.views['Pict-Section-Modal'];
	if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast(pMessage, { type: pType || 'info' }); }
}

function _fire(pPict, pContext, pContextID)
{
	const tmpRestClient = _restClient(pPict);
	if (!tmpRestClient) { return; }
	tmpRestClient.getJSON(`ConfigurationSync/Sync/${pContext}/${pContextID}`, (pError) =>
	{
		if (pError)
		{
			const tmpMessage = String((pError && pError.message) || pError || '');
			if (/forbidden|permission/i.test(tmpMessage))
			{
				// Not a super-user: the save succeeded, but the sync needs one. Inform, don't alarm.
				_toast(pPict, 'Saved — but a super-user Configuration Sync is needed to push this to the field apps.', 'info');
			}
			else
			{
				if (pPict && pPict.log) { pPict.log.warn(`ConfigSync: sync ${pContext}/${pContextID} failed: ${tmpMessage}`); }
				_toast(pPict, 'Couldn’t start the configuration sync automatically — a super-user can run it from Config Sync.', 'error');
			}
			return;
		}
		_toast(pPict, `Configuration sync started — the ${pContext === 'Project' ? 'project’s' : 'customer’s'} labels will reach the field apps shortly.`, 'info');
	});
}

/**
 * Request a (debounced) Configuration Sync for a context. Coalesces rapid changes into one job per (Context, ID).
 * @param {any} pPict - the pict instance (for the REST client + toasts).
 * @param {'Project'|'Customer'} pContext
 * @param {Number} pContextID
 */
function requestSync(pPict, pContext, pContextID)
{
	if (!pPict || ((pContext !== 'Project') && (pContext !== 'Customer')) || !(Number(pContextID) > 0)) { return; }
	const tmpKey = `${pContext}:${pContextID}`;
	if (_timers[tmpKey]) { clearTimeout(_timers[tmpKey]); }
	_timers[tmpKey] = setTimeout(() =>
	{
		delete _timers[tmpKey];
		_fire(pPict, pContext, pContextID);
	}, DEBOUNCE_MS);
}

// ── Scoped sync (the new, side-by-side endpoint) ─────────────────────────────────
//
// requestScopedSync targets the SCOPE-AWARE reimplementation:
//   GET /1.0/ConfigurationSync/SyncScoped/{Context}/{ContextID}[?Manifest=<Name>]   (Context ∈ Customer|Project|Global)
// It rebuilds only the requested level(s) — not the whole platform — and, with a Manifest name, only that one
// ObservationType's per-type config. Unlike the legacy /Sync route this endpoint also admits a customer's own
// config-admin (tenancy + Module-PlatformConfiguration-Access checked server-side), so a 403 here means "not
// permitted for this context", NOT "super-user required". Global is super-user-only (enforced server-side).

function _fireScoped(pPict, pContext, pContextID, pManifest)
{
	const tmpRestClient = _restClient(pPict);
	if (!tmpRestClient) { return; }
	let tmpURI = `ConfigurationSync/SyncScoped/${pContext}/${pContextID}`;
	if (pManifest) { tmpURI += `?Manifest=${encodeURIComponent(pManifest)}`; }
	tmpRestClient.getJSON(tmpURI, (pError) =>
	{
		if (pError)
		{
			const tmpMessage = String((pError && pError.message) || pError || '');
			if (/forbidden|permission/i.test(tmpMessage))
			{
				_toast(pPict, 'You don’t have permission to run a configuration sync for this context.', 'info');
			}
			else
			{
				if (pPict && pPict.log) { pPict.log.warn(`ConfigSync: scoped sync ${pContext}/${pContextID} failed: ${tmpMessage}`); }
				_toast(pPict, 'Couldn’t start the configuration sync — please try again or contact a Headlight admin.', 'error');
			}
			return;
		}
		const tmpWhat = (pContext === 'Project') ? 'project’s' : (pContext === 'Global' ? 'platform' : 'customer’s');
		_toast(pPict, `Configuration sync started — the ${tmpWhat} configuration will reach the field apps shortly.`, 'info');
	});
}

/**
 * Request a scoped Configuration Sync via the new endpoint. Coalesces rapid changes into one job per
 * (Context, ID, Manifest) unless pOptions.immediate is set (used by the manual dashboard buttons).
 * @param {Object} pPict - the pict instance (for the REST client + toasts).
 * @param {String} pContext - 'Customer', 'Project' or 'Global'.
 * @param {Number} pContextID - the customer/project id (ignored for Global).
 * @param {Object} [pOptions] - { manifest?: String (limit to one ObservationType), immediate?: Boolean (skip debounce) }.
 * @return {void}
 */
function requestScopedSync(pPict, pContext, pContextID, pOptions)
{
	const tmpOptions = pOptions || {};
	if (!pPict || ((pContext !== 'Customer') && (pContext !== 'Project') && (pContext !== 'Global'))) { return; }
	if ((pContext !== 'Global') && !(Number(pContextID) > 0)) { return; }
	const tmpID = (pContext === 'Global') ? 0 : Number(pContextID);
	const tmpManifest = tmpOptions.manifest || null;
	if (tmpOptions.immediate)
	{
		_fireScoped(pPict, pContext, tmpID, tmpManifest);
		return;
	}
	const tmpKey = `scoped:${pContext}:${tmpID}:${tmpManifest || ''}`;
	if (_timers[tmpKey]) { clearTimeout(_timers[tmpKey]); }
	_timers[tmpKey] = setTimeout(() =>
	{
		delete _timers[tmpKey];
		_fireScoped(pPict, pContext, tmpID, tmpManifest);
	}, DEBOUNCE_MS);
}

module.exports = { requestSync, requestScopedSync };

},{}],1314:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const libProvenance = require('../config-editor/Config-Provenance.js');
const libCatalog = require('../config-editor/Config-Namespace-Catalog.js');
const libDictionary = require('../config-editor/Config-Dictionary.js');

// Scopes this tool authors, general -> specific. Contract/Project are included in the cascade only
// when a context id is supplied (otherwise they don't apply to the viewer's own session).
const WRITE_SCOPES = [ 'Global', 'Customer', 'Project', 'User' ];
const SCOPE_LABELS =
{
	Global: 'Platform Default',
	Customer: 'Customer',
	Contract: 'Contract',
	Project: 'Project',
	User: 'My Settings',
};

/**
 * ConfigViewerProvider — the data layer behind the provenance-aware configuration viewer.
 *
 * Reads the cascading Configuration service (api/config) for a chosen NamespaceKey/NamespaceValue at a
 * chosen context, computes per-leaf PROVENANCE (which scope set each value) by diffing the merge at
 * each successive scope (Config-Provenance.computeProvenanceByDiff — robust, server-scoped; the raw
 * ConfigEntry table has no IDCustomer column so a direct row read can't be customer-scoped reliably),
 * writes edits to a chosen scope (the service diffs vs the parent), and also surfaces a record's
 * CustomProperties JSON blob as a flat (un-cascaded) editable object. Mirrors the permission + REST
 * patterns of MasterList-Registry-Provider.
 */
class ConfigViewerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	// --- lifecycle ---

	onAfterInitialize()
	{
		this._ensureState();
		return super.onAfterInitialize();
	}

	_ensureState()
	{
		if (!this.pict.AppData.ConfigViewer)
		{
			this.pict.AppData.ConfigViewer =
			{
				Context: { IDCustomer: this.idCustomer, IDProject: 0, IDUser: this.idUser },
				WriteScope: this.defaultScope,
				Selected: null,        // { Mode, NamespaceKey, NamespaceValue, Entity, RecordID, Label }
				ValueList: [],         // NamespaceValues for the selected key
				EditingConfig: {},     // bound to the ObjectEditor
				ProvenanceMap: {},     // editorPath -> { Scope, ScopeID }
				Loading: false,
				Message: '',
				// view-derived slots (filled by deriveRenderState)
				RailGroups: [],
				ScopeOptions: [],
				HelpNamespace: '',
				HelpKey: '',
			};
		}
		return this.pict.AppData.ConfigViewer;
	}

	get state()
	{
		return this._ensureState();
	}

	// --- session context + permissions (mirror the server config gate) ---

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	get idUser()
	{
		return this.currentUser.UserID;
	}

	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	get hasCustomerAdmin()
	{
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin'));
	}

	/**
	 * Can the current user WRITE config at this scope? UI gate only — the server is authoritative.
	 * @param {String} pLevel
	 * @return {Boolean}
	 */
	canWriteScope(pLevel)
	{
		switch (pLevel)
		{
			case 'Global': return this.isSuperUser;
			case 'Customer':
			case 'Contract':
			case 'Project': return this.isSuperUser || this.hasCustomerAdmin;
			case 'User': return true;
			default: return false;
		}
	}

	get defaultScope()
	{
		if (this.isSuperUser) { return 'Global'; }
		if (this.hasCustomerAdmin) { return 'Customer'; }
		return 'User';
	}

	_scopeLabel(pLevel)
	{
		return SCOPE_LABELS[pLevel] || pLevel;
	}

	/**
	 * The LevelContextID for a scope, from the active context.
	 * @param {String} pLevel
	 * @return {Number}
	 */
	_levelIdFor(pLevel)
	{
		const tmpContext = this.state.Context;
		switch (pLevel)
		{
			case 'Global': return 0;
			case 'Customer': return tmpContext.IDCustomer;
			case 'Contract': return tmpContext.IDContract || 0;
			case 'Project': return tmpContext.IDProject || 0;
			case 'User': return tmpContext.IDUser;
			default: return 0;
		}
	}

	/**
	 * Fill the active context's customer/user from the live session when not already set. The provider
	 * initializes before login, so the session ids aren't known at construction — this self-heals the
	 * context on first use after CurrentUser is populated (super-user customer overrides are preserved).
	 */
	_ensureSessionContext()
	{
		const tmpContext = this.state.Context;
		if (!tmpContext.IDCustomer) { tmpContext.IDCustomer = this.idCustomer; }
		if (!tmpContext.IDUser) { tmpContext.IDUser = this.idUser; }
	}

	/**
	 * The ordered scope chain (general -> specific) for the active context. Contract/Project are
	 * included only when their context id is set. The deepest entry is the full effective merge.
	 * @return {Array<{Scope:String, ScopeID:Number}>}
	 */
	_activeScopeChain()
	{
		this._ensureSessionContext();
		const tmpContext = this.state.Context;
		const tmpChain = [ { Scope: 'Global', ScopeID: 0 }, { Scope: 'Customer', ScopeID: tmpContext.IDCustomer } ];
		if (tmpContext.IDContract) { tmpChain.push({ Scope: 'Contract', ScopeID: tmpContext.IDContract }); }
		if (tmpContext.IDProject) { tmpChain.push({ Scope: 'Project', ScopeID: tmpContext.IDProject }); }
		tmpChain.push({ Scope: 'User', ScopeID: tmpContext.IDUser });
		return tmpChain;
	}

	// --- REST helpers (promise wrappers over the Headlight rest client) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_deepClone(pValue)
	{
		return pValue ? JSON.parse(JSON.stringify(pValue)) : pValue;
	}

	// --- Configuration service: read one NamespaceValue's merged config at a scope ---

	/**
	 * Merged config for a NamespaceValue up to and including a scope. /Configuration/Get with a
	 * NamespaceValue returns { Config, LevelControlRecords }.
	 * @return {Promise<Object>}
	 */
	async _getConfigAt(pScope, pScopeID, pNamespaceKey, pNamespaceValue)
	{
		const tmpPayload =
		{
			LevelContext: pScope,
			LevelContextID: pScopeID,
			NamespaceKey: pNamespaceKey,
			NamespaceValue: pNamespaceValue,
		};
		const tmpResult = await this._postJSON('Configuration/Get', tmpPayload);
		if (tmpResult && tmpResult.Config !== undefined) { return tmpResult.Config || {}; }
		return (tmpResult && tmpResult.Document) || tmpResult || {};
	}

	/**
	 * List the live NamespaceValues for a key at the active deepest context (Get without a
	 * NamespaceValue returns an object keyed by NamespaceValue).
	 * @param {String} pNamespaceKey
	 * @return {Promise<Array<String>>}
	 */
	async loadNamespaceValuesAsync(pNamespaceKey)
	{
		const tmpDeepest = this._activeScopeChain().slice(-1)[0];
		const tmpResult = await this._postJSON('Configuration/Get',
			{ LevelContext: tmpDeepest.Scope, LevelContextID: tmpDeepest.ScopeID, NamespaceKey: pNamespaceKey });
		const tmpMap = (tmpResult && tmpResult.Document) || tmpResult || {};
		return Object.keys(tmpMap).filter((pKey) => pKey !== 'Config' && pKey !== 'LevelControlRecords');
	}

	/**
	 * Load a NamespaceValue's effective config + provenance map into AppData. Provenance is computed by
	 * diffing the merge at each successive scope (the deepest is the effective config to edit).
	 * @param {String} pNamespaceKey
	 * @param {String} pNamespaceValue
	 * @return {Promise<void>}
	 */
	async loadConfigAsync(pNamespaceKey, pNamespaceValue)
	{
		const tmpChain = this._activeScopeChain();
		const tmpMerges = [];
		for (let i = 0; i < tmpChain.length; i++)
		{
			/* eslint-disable no-await-in-loop */
			const tmpConfig = await this._getConfigAt(tmpChain[i].Scope, tmpChain[i].ScopeID, pNamespaceKey, pNamespaceValue);
			/* eslint-enable no-await-in-loop */
			tmpMerges.push({ Scope: tmpChain[i].Scope, ScopeID: tmpChain[i].ScopeID, Config: tmpConfig });
		}
		const tmpEffective = tmpMerges.length ? tmpMerges[tmpMerges.length - 1].Config : {};
		this.state.EditingConfig = this._deepClone(tmpEffective) || {};
		this.state.ProvenanceMap = libProvenance.computeProvenanceByDiff(tmpMerges);
	}

	/**
	 * Persist the (whole) edited config object at a scope. The service diffs vs the parent level:
	 * a value equal to the parent is dropped (no override); a key removed vs the parent becomes a
	 * hide-record (except at User scope). After writing we re-load so the badges reflect the truth.
	 * @param {String} pWriteScope
	 * @return {Promise<Object>} the server result
	 */
	async saveConfigAsync(pWriteScope)
	{
		const tmpSelected = this.state.Selected;
		if (!tmpSelected || tmpSelected.Mode !== 'config')
		{
			throw new Error('No configuration namespace selected.');
		}
		const tmpLevelID = this._levelIdFor(pWriteScope);
		const tmpURL = `Configuration/Put/${tmpSelected.NamespaceKey}/${tmpSelected.NamespaceValue}/${pWriteScope}/${tmpLevelID}`;
		const tmpResult = await this._postJSON(tmpURL, { Config: this.state.EditingConfig });
		await this.loadConfigAsync(tmpSelected.NamespaceKey, tmpSelected.NamespaceValue);
		return tmpResult;
	}

	// --- CustomProperties (flat per-record JSON; no cascade) ---

	/**
	 * Load a record's CustomProperties blob into the editor (badges disabled in the view).
	 * @param {String} pEntity 'Customer' | 'Project'
	 * @param {Number} pRecordID
	 * @return {Promise<void>}
	 */
	async loadCustomPropertiesAsync(pEntity, pRecordID)
	{
		const tmpRecord = await this._getJSON(`${pEntity}/${pRecordID}`);
		let tmpProps = {};
		const tmpRaw = tmpRecord && tmpRecord.CustomProperties;
		if (tmpRaw && typeof tmpRaw === 'string')
		{
			try { tmpProps = JSON.parse(tmpRaw); }
			catch (pError) { tmpProps = {}; }
		}
		else if (tmpRaw && typeof tmpRaw === 'object')
		{
			tmpProps = tmpRaw;
		}
		this.state.EditingConfig = tmpProps || {};
		this.state.ProvenanceMap = {}; // flat blob — no provenance
	}

	/**
	 * Persist the edited CustomProperties blob back to the record.
	 * @param {String} pEntity
	 * @param {Number} pRecordID
	 * @return {Promise<Object>}
	 */
	async saveCustomPropertiesAsync(pEntity, pRecordID)
	{
		const tmpPayload = { CustomProperties: JSON.stringify(this.state.EditingConfig || {}) };
		tmpPayload[`ID${pEntity}`] = pRecordID;
		return this._putJSON(`${pEntity}`, tmpPayload);
	}

	// --- selection + context (called from the view) ---

	async selectNamespaceAsync(pNamespaceKey, pNamespaceValue)
	{
		this.state.Loading = true;
		this.state.Message = '';
		try
		{
			let tmpValue = pNamespaceValue;
			if (!tmpValue)
			{
				const tmpValues = await this.loadNamespaceValuesAsync(pNamespaceKey);
				this.state.ValueList = tmpValues;
				tmpValue = tmpValues.length ? tmpValues[0] : '';
			}
			this.state.Selected =
			{
				Mode: 'config',
				NamespaceKey: pNamespaceKey,
				NamespaceValue: tmpValue,
				Label: `${libCatalog.labelForNamespace(pNamespaceKey)}${tmpValue ? ' › ' + tmpValue : ''}`,
			};
			if (tmpValue)
			{
				await this.loadConfigAsync(pNamespaceKey, tmpValue);
			}
			else
			{
				this.state.EditingConfig = {};
				this.state.ProvenanceMap = {};
				this.state.Message = 'No values configured for this namespace at the current context.';
			}
		}
		catch (pError)
		{
			this.state.Message = `Could not load configuration: ${pError.message}`;
		}
		this.state.Loading = false;
	}

	async selectCustomPropertiesAsync(pEntity, pRecordID, pLabel)
	{
		this.state.Loading = true;
		this.state.Message = '';
		try
		{
			this.state.Selected = { Mode: 'customprops', Entity: pEntity, RecordID: pRecordID, Label: pLabel };
			await this.loadCustomPropertiesAsync(pEntity, pRecordID);
		}
		catch (pError)
		{
			this.state.Message = `Could not load CustomProperties: ${pError.message}`;
		}
		this.state.Loading = false;
	}

	setWriteScope(pScope)
	{
		if (this.canWriteScope(pScope))
		{
			this.state.WriteScope = pScope;
		}
	}

	/**
	 * Whether the editor should be editable for the current selection + write scope.
	 * @return {Boolean}
	 */
	get isEditable()
	{
		const tmpSelected = this.state.Selected;
		if (!tmpSelected) { return false; }
		if (tmpSelected.Mode === 'customprops')
		{
			// meadow Update is Mine/MyCustomer — gate on customer-admin or super-user for now.
			return this.isSuperUser || this.hasCustomerAdmin;
		}
		return this.canWriteScope(this.state.WriteScope);
	}

	// --- help (dictionary) ---

	/**
	 * Dictionary text for a focused node path within the selected namespace.
	 * @param {String} pNodePath editor path
	 * @return {String}
	 */
	helpForNodePath(pNodePath)
	{
		const tmpSelected = this.state.Selected;
		if (!tmpSelected || tmpSelected.Mode !== 'config') { return ''; }
		const tmpAddress = libProvenance.editorPathToAddress(libProvenance.editorPathToLeafPath(pNodePath));
		return libDictionary.describeKey(tmpSelected.NamespaceKey, tmpAddress);
	}

	// --- derive view state ---

	deriveRenderState()
	{
		const tmpState = this.state;

		// Namespace rail — catalog grouped by Group, plus the CustomProperties pseudo-entries.
		const tmpGroups = {};
		libCatalog.CONFIG_NAMESPACE_CATALOG.forEach((pEntry) =>
		{
			const tmpGroupName = pEntry.Group || 'Other';
			if (!tmpGroups[tmpGroupName]) { tmpGroups[tmpGroupName] = { Group: tmpGroupName, Items: [] }; }
			tmpGroups[tmpGroupName].Items.push(
				{
					Kind: 'config',
					NamespaceKey: pEntry.NamespaceKey,
					Label: pEntry.Label,
					IsActive: !!(tmpState.Selected && tmpState.Selected.Mode === 'config'
						&& tmpState.Selected.NamespaceKey === pEntry.NamespaceKey),
					ActiveClass: (tmpState.Selected && tmpState.Selected.Mode === 'config'
						&& tmpState.Selected.NamespaceKey === pEntry.NamespaceKey) ? 'is-active' : '',
				});
		});
		const tmpRailGroups = Object.keys(tmpGroups).map((pKey) => tmpGroups[pKey]);
		// CustomProperties group (current customer; super-user can extend later).
		tmpRailGroups.push(
			{
				Group: 'Record Properties',
				Items:
				[
					{
						Kind: 'customprops',
						Entity: 'Customer',
						RecordID: this.idCustomer,
						Label: 'Customer CustomProperties',
						IsActive: !!(tmpState.Selected && tmpState.Selected.Mode === 'customprops'),
						ActiveClass: (tmpState.Selected && tmpState.Selected.Mode === 'customprops') ? 'is-active' : '',
					},
				],
			});
		tmpState.RailGroups = tmpRailGroups;

		// Write-scope options (gated).
		tmpState.ScopeOptions = WRITE_SCOPES
			.filter((pScope) => pScope !== 'Project' || tmpState.Context.IDProject)
			.map((pScope) => (
				{
					Value: pScope,
					Label: this._scopeLabel(pScope),
					SelectedAttr: (pScope === tmpState.WriteScope) ? 'selected' : '',
					DisabledAttr: this.canWriteScope(pScope) ? '' : 'disabled',
				}));

		// Value list for the selected namespace.
		tmpState.ValueOptions = (tmpState.ValueList || []).map((pValue) => (
			{
				Value: pValue,
				SelectedAttr: (tmpState.Selected && tmpState.Selected.NamespaceValue === pValue) ? 'selected' : '',
			}));

		// Editor mode flags + help.
		const tmpIsConfig = !!(tmpState.Selected && tmpState.Selected.Mode === 'config');
		const tmpEditable = this.isEditable;
		tmpState.IsConfigMode = tmpIsConfig;
		tmpState.IsCustomPropsMode = !!(tmpState.Selected && tmpState.Selected.Mode === 'customprops');
		tmpState.Editable = tmpEditable;
		tmpState.HelpNamespace = tmpIsConfig ? libDictionary.describeNamespace(tmpState.Selected.NamespaceKey) : '';
		tmpState.SaveLabel = tmpIsConfig ? `Save to ${this._scopeLabel(tmpState.WriteScope)}` : 'Save';

		// Dictionary key list for the help panel (the "what it means" overlay).
		tmpState.HelpKeyList = [];
		if (tmpIsConfig)
		{
			const tmpDict = libDictionary.CONFIG_DICTIONARY[tmpState.Selected.NamespaceKey];
			const tmpKeys = (tmpDict && tmpDict.Keys) || {};
			tmpState.HelpKeyList = Object.keys(tmpKeys).map((pAddress) => ({ Address: pAddress, Text: tmpKeys[pAddress] }));
		}

		// Scope legend (the colour key for the badges), one per scope in the active chain.
		tmpState.Legend = this._activeScopeChain().map((pLevel) => (
			{
				Label: this._scopeLabel(pLevel.Scope),
				BadgeClass: 'cfg-prov-' + String(pLevel.Scope).toLowerCase(),
			}));

		// conditional slots (single-element-array trick)
		const tmpHasValue = !!(tmpState.Selected && tmpState.Selected.NamespaceValue);
		const tmpHasEditable = (tmpIsConfig && tmpHasValue) || tmpState.IsCustomPropsMode;
		tmpState.LoadingSlot = tmpState.Loading ? [ {} ] : [];
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message } ] : [];
		tmpState.SelectedSlot = tmpState.Selected ? [ tmpState.Selected ] : [];
		tmpState.EmptySlot = tmpState.Selected ? [] : [ {} ];
		tmpState.ScopePickerSlot = (tmpIsConfig && tmpHasValue) ? [ {} ] : [];
		tmpState.EditorBodySlot = tmpHasEditable ? [ {} ] : [];
		tmpState.NoValuesSlot = (tmpIsConfig && !tmpHasValue) ? [ {} ] : [];
		tmpState.ValuePickerSlot = (tmpIsConfig && (tmpState.ValueList || []).length > 1) ? [ {} ] : [];
		tmpState.SaveEnabledSlot = (tmpEditable && tmpHasEditable) ? [ { SaveLabel: tmpState.SaveLabel } ] : [];
		tmpState.ReadOnlySlot = (tmpHasEditable && !tmpEditable) ? [ {} ] : [];
		tmpState.HelpSlot = (tmpState.HelpNamespace || tmpState.HelpKeyList.length) ? [ {} ] : [];

		return tmpState;
	}
}

module.exports = ConfigViewerProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ConfigViewer',
	AutoInitialize: true,
	AutoInitializeOrdinal: 40,
};

},{"../config-editor/Config-Dictionary.js":1076,"../config-editor/Config-Namespace-Catalog.js":1077,"../config-editor/Config-Provenance.js":1078,"pict-provider":845}],1315:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libTemplate = require('../contract-admin/ContractAdmin-Template.js');

/**
 * ContractAdminProvisioning — GENERATES the canonical Contract Administration template on the HeadLight
 * customer (IDCustomer 1), and CLONES it — non-destructively + idempotently — into a chosen target customer.
 *
 * Replaces the retired, destructive #/ContractAdmin screen (which did full-replace Configuration/Put writes
 * against the operator's OWN customer). Every write here is safe and explicit-customer:
 *   - Report forms → PUT ReportNamedInstance/Upsert (upsert-by-GUID — idempotent, never duplicates).
 *   - Workflows    → create-if-absent (Configuration/Put/ApprovalWorkflow/<name>/Customer/<id>); never
 *                    overwrites a customer's existing/edited workflow.
 *   - Bindings     → read-merge-write the ApprovalWorkflowBindings 'Document' map (Configuration/Put is a
 *                    full-document REPLACE, so we merge our keys into the existing map and write it back).
 *
 * Runs as a HeadLight super-user (L5 / customer 1), who may write across customers with an explicit
 * IDCustomer — so no impersonation is needed.
 */
class ContractAdminProvisioningProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pBody) => pErr ? reject(pErr) : resolve(pBody))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pBody2) => pErr ? reject(pErr) : resolve(pBody2))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pBody2) => pErr ? reject(pErr) : resolve(pBody2))); }
	_unwrapConfig(pResult) { return (pResult && pResult.Config !== undefined) ? (pResult.Config || {}) : (pResult || {}); }
	_errText(pError) { return (pError && pError.message) ? pError.message : String(pError); }

	// ── Primitives (each targets an EXPLICIT IDCustomer) ─────────────────────────

	/** Upsert one ReportNamedInstance by its GUID — updates if the GUID exists, creates otherwise. */
	async _upsertFormAsync(pForm)
	{
		await this._putJSON('ReportNamedInstance/Upsert', pForm);
	}

	/**
	 * The customer's existing ApprovalWorkflow hashes, so workflows are created only when absent. Rejects when the read
	 * fails: an empty set here would make create-if-absent overwrite the customer's existing workflows.
	 */
	async _existingWorkflowHashesAsync(pIDCustomer)
	{
		const tmpMap = await this._getJSON(`Configuration/For/ApprovalWorkflow/In/Customer/${pIDCustomer}`);
		return new Set(Object.keys(tmpMap || {}));
	}

	/** Create an ApprovalWorkflow blob only if the customer does not already have one under that name (never overwrite edits). */
	async _putWorkflowIfAbsentAsync(pIDCustomer, pHash, pBlob, pExistingSet)
	{
		if (pExistingSet && pExistingSet.has(pHash)) { return 'skipped'; }
		await this._postJSON(`Configuration/Put/ApprovalWorkflow/${encodeURIComponent(pHash)}/Customer/${pIDCustomer}`, pBlob);
		return 'created';
	}

	/**
	 * Merge {formHash: workflowName} pairs into the customer's ApprovalWorkflowBindings 'Document' map (read-merge-write; never
	 * full-replace). Returns the number of keys added/changed. Rejects when the read fails: merging into an empty map would
	 * write back only the template's keys and drop every other binding the customer has.
	 */
	async _mergeBindingsAsync(pIDCustomer, pBindings)
	{
		const tmpAll = await this._getJSON(`Configuration/For/ApprovalWorkflowBindings/In/Customer/${pIDCustomer}`);
		const tmpDocMap = Object.assign({}, (tmpAll && tmpAll.Document) || {});
		let tmpAdded = 0;
		Object.keys(pBindings || {}).forEach((pFormHash) =>
		{
			if (tmpDocMap[pFormHash] !== pBindings[pFormHash]) { tmpDocMap[pFormHash] = pBindings[pFormHash]; tmpAdded++; }
		});
		if (tmpAdded > 0) { await this._postJSON(`Configuration/Put/ApprovalWorkflowBindings/Document/Customer/${pIDCustomer}`, tmpDocMap); }
		return tmpAdded;
	}

	// ── Materialize / Generate ───────────────────────────────────────────────────

	/**
	 * Materialize a template artifact set into a customer — idempotent + non-destructive.
	 * @param {number} pIDCustomer
	 * @param {Object} pTemplate  from ContractAdmin-Template.buildTemplate (or a clone source, re-stamped)
	 * @returns {Promise<Object>} per-item result summary
	 */
	async materializeTemplateAsync(pIDCustomer, pTemplate)
	{
		const tmpID = Number(pIDCustomer);
		const tmpResult = { IDCustomer: tmpID, Forms: [], Workflows: [], BindingsAdded: 0, Errors: [] };

		// 1) Forms — upsert-by-GUID.
		for (const tmpForm of (pTemplate.ReportForms || []))
		{
			try { await this._upsertFormAsync(tmpForm); tmpResult.Forms.push({ Hash: tmpForm.Hash, Status: 'upserted' }); }
			catch (pError) { tmpResult.Errors.push(`form ${tmpForm.Hash}: ${this._errText(pError)}`); tmpResult.Forms.push({ Hash: tmpForm.Hash, Status: 'error' }); }
		}

		// 2) Workflows — create-if-absent (preserve existing/edited workflows). Without the existing set we can't tell
		//    absent from present, so skip the step rather than overwrite.
		let tmpExisting = null;
		try
		{
			tmpExisting = await this._existingWorkflowHashesAsync(tmpID);
		}
		catch (pError)
		{
			tmpResult.Errors.push(`workflows: could not read the customer's existing workflows, so none were written: ${this._errText(pError)}`);
			(pTemplate.Workflows || []).forEach((pWF) => tmpResult.Workflows.push({ Hash: pWF.Hash, Status: 'skipped' }));
		}
		for (const tmpWF of (tmpExisting ? (pTemplate.Workflows || []) : []))
		{
			try { const tmpStatus = await this._putWorkflowIfAbsentAsync(tmpID, tmpWF.Hash, tmpWF.Blob, tmpExisting); tmpResult.Workflows.push({ Hash: tmpWF.Hash, Status: tmpStatus }); }
			catch (pError) { tmpResult.Errors.push(`workflow ${tmpWF.Hash}: ${this._errText(pError)}`); tmpResult.Workflows.push({ Hash: tmpWF.Hash, Status: 'error' }); }
		}

		// 3) Bindings — read-merge-write.
		try { tmpResult.BindingsAdded = await this._mergeBindingsAsync(tmpID, pTemplate.Bindings || {}); }
		catch (pError) { tmpResult.Errors.push(`bindings: ${this._errText(pError)}`); }

		return tmpResult;
	}

	/** Generate / refresh the canonical Contract-Admin template on the HeadLight customer (IDCustomer 1). */
	async generateHeadLightTemplateAsync()
	{
		const tmpTemplate = libTemplate.buildTemplate(libTemplate.HEADLIGHT_IDCUSTOMER);
		const tmpResult = await this.materializeTemplateAsync(libTemplate.HEADLIGHT_IDCUSTOMER, tmpTemplate);
		// (The module-catalog row is a client-side entry merged by the Customer workspace Modules tab — creating a
		// server Module row is a restricted op; config-app modules enable via a real CustomerModuleJoin by ModuleHash.)
		this.pict.log.info('ContractAdmin: generated HeadLight template', tmpResult);
		return tmpResult;
	}

	// ── Clone the HeadLight (cust 1) template into a target customer ──────────────

	/** Read the LIVE default-workflow blobs from HeadLight (cust 1) so admin tuning propagates; fall back to the canonical default. */
	async _readHeadLightWorkflowsAsync()
	{
		const tmpNames = [ libTemplate.PAYMENT_WORKFLOW, libTemplate.CHANGEORDER_WORKFLOW ];
		const tmpCanon = libTemplate.buildTemplate(libTemplate.HEADLIGHT_IDCUSTOMER).Workflows;
		const tmpResult = [];
		for (const tmpName of tmpNames)
		{
			let tmpBlob = null;
			try
			{
				const tmpRes = await this._postJSON('Configuration/Get', { LevelContext: 'Customer', LevelContextID: libTemplate.HEADLIGHT_IDCUSTOMER, NamespaceKey: 'ApprovalWorkflow', NamespaceValue: tmpName });
				const tmpUnwrapped = this._unwrapConfig(tmpRes);
				if (tmpUnwrapped && Array.isArray(tmpUnwrapped.States)) { tmpBlob = tmpUnwrapped; }
			}
			catch (pError) { /* fall back to the canonical default below */ }
			if (!tmpBlob) { const tmpFallback = tmpCanon.find((pW) => pW.Hash === tmpName); tmpBlob = tmpFallback ? tmpFallback.Blob : {}; }
			tmpResult.push({ Hash: tmpName, Blob: JSON.parse(JSON.stringify(tmpBlob)) });
		}
		return tmpResult;
	}

	/**
	 * Clone the HeadLight (cust 1) Contract-Admin template into a target customer — non-destructive + idempotent.
	 * Forms + bindings come from the canonical template (re-stamped for the target); workflows come from the LIVE
	 * cust-1 blobs (so HeadLight's own tuning of the defaults propagates). Returns the materialize result summary.
	 * @param {number} pIDCustomer
	 */
	async cloneToCustomerAsync(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		const tmpTemplate = libTemplate.buildTemplate(tmpID);
		tmpTemplate.Workflows = await this._readHeadLightWorkflowsAsync();
		return this.materializeTemplateAsync(tmpID, tmpTemplate);
	}

	// ── Capability grant (the real gate for the Contract-Admin screens) ──────────

	/** Find-or-create the customer's 'Customer Config Admin' permission group (PermissionLevel CustomerAdmin). */
	async _ensureConfigAdminGroupAsync(pIDCustomer)
	{
		const tmpName = 'Customer Config Admin';
		const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${Number(pIDCustomer)}~FBV~Name~EQ~${encodeURIComponent(tmpName)}~FBV~Deleted~EQ~0/0/1`).catch(() => null);
		const tmpExisting = (Array.isArray(tmpRoles) ? tmpRoles : []).find((pRole) => pRole && pRole.IDRole);
		if (tmpExisting) { return tmpExisting; }
		return this._postJSON('Role', { Name: tmpName, Type: 'PermissionGroup', PermissionLevel: 'CustomerAdmin', Description: 'Configuration-admin rights for this customer. Managed by the customer module tooling.', IDCustomer: Number(pIDCustomer) });
	}

	/** Grant the Module-ContractAdmin-Access capability to the customer's config-admin group, so the Contract-Admin screens become visible/usable for that customer. Returns the IDRole granted. */
	async grantCapabilityAsync(pIDCustomer)
	{
		const tmpGroup = await this._ensureConfigAdminGroupAsync(pIDCustomer);
		if (!tmpGroup || !tmpGroup.IDRole) { throw new Error('could not resolve the customer config-admin group'); }
		await this._getJSON(`Permissions/Grant/${encodeURIComponent(libTemplate.MODULE_ACCESS_CAPABILITY)}/To/Role/${Number(tmpGroup.IDRole)}/For/Customer/${Number(pIDCustomer)}`);
		return Number(tmpGroup.IDRole);
	}
}

module.exports = ContractAdminProvisioningProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ContractAdminProvisioning',
	AutoInitialize: true,
	AutoInitializeOrdinal: 45,
};

},{"../contract-admin/ContractAdmin-Template.js":1087,"pict-provider":845}],1316:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const BODY_MOUNT = '#CCW-Body';
const MESSAGE_MOUNT = '#CCW-Message';

// The editable Contract fields offered at CREATE, grouped for the form (curated from the ContractWorkspace
// Overview column list). Name is required; the rest are optional and default on the server. IDCustomer is NEVER
// sent (the server stamps it from the session). Audit/GUID/PK columns are omitted.
const FIELD_GROUPS =
[
	{ Name: 'Identity', Fields:
		[
			{ Key: 'Name', Label: 'Contract Name', Type: 'text', Wide: true, Required: true },
			{ Key: 'Status', Label: 'Status', Type: 'text' },
			{ Key: 'ExternalContractID', Label: 'External Contract ID', Type: 'text' },
		] },
	{ Name: 'Relationships', Fields:
		[
			{ Key: 'IDOrganization', Label: 'Prime Contractor', Type: 'entity', Entity: 'Organization', Wide: true },
			{ Key: 'IDContractType', Label: 'Contract Type', Type: 'entity', Entity: 'ContractType', Wide: true },
		] },
	{ Name: 'Project Numbers', Fields:
		[
			{ Key: 'PrimaryProjectNumber', Label: 'Primary', Type: 'text' },
			{ Key: 'CountyProjectNumber', Label: 'County', Type: 'text' },
			{ Key: 'StateProjectNumber', Label: 'State', Type: 'text' },
			{ Key: 'FederalProjectNumber', Label: 'Federal', Type: 'text' },
		] },
	{ Name: 'Route & Limits', Fields:
		[
			{ Key: 'RouteNumber', Label: 'Route #', Type: 'text' },
			{ Key: 'HighwayNumber', Label: 'Highway #', Type: 'text' },
			{ Key: 'PavingMaterial', Label: 'Paving Material', Type: 'text' },
			{ Key: 'StationBegin', Label: 'Station Begin', Type: 'text' },
			{ Key: 'TerminusBegin', Label: 'Terminus Begin', Type: 'text' },
			{ Key: 'StationEnd', Label: 'Station End', Type: 'text' },
			{ Key: 'TerminusEnd', Label: 'Terminus End', Type: 'text' },
		] },
	{ Name: 'Financials', Fields:
		[
			{ Key: 'TotalBidAmount', Label: 'Total Bid Amount', Type: 'number' },
			{ Key: 'NetChangeOrderAmount', Label: 'Net Change Orders', Type: 'number' },
			{ Key: 'VendorAccountCode', Label: 'Vendor Account Code', Type: 'text' },
		] },
	{ Name: 'Specifications & Schedule', Fields:
		[
			{ Key: 'ItemSpecificationYear', Label: 'Item Spec Year', Type: 'text' },
			{ Key: 'MaterialsSpecificationYear', Label: 'Materials Spec Year', Type: 'text' },
			{ Key: 'ItemIDTestSpecificationSet', Label: 'Item Test Spec Set', Type: 'entity', Entity: 'TestSpecificationSet' },
			{ Key: 'MaterialIDTestSpecificationSet', Label: 'Material Test Spec Set', Type: 'entity', Entity: 'TestSpecificationSet' },
			{ Key: 'DBEStructure', Label: 'DBE Structure', Type: 'text' },
			{ Key: 'EstimatedCompletionDate', Label: 'Estimated Completion', Type: 'date' },
		] },
	{ Name: 'Description', Fields:
		[
			{ Key: 'Description', Label: 'Description', Type: 'textarea', Wide: true },
		] },
];

// Server-side entity-picker config per relationship field (this app has no pict.EntityProvider). Organization is
// customer-scoped (has an IDCustomer column, mirroring ProjectCreateWorkspace); ContractType and
// TestSpecificationSet are filtered by Deleted only (the server scopes reads to the session's customer, so no
// explicit IDCustomer clause — avoids filtering on a column those entities may not carry).
const PICKER_PAGE_SIZE = 25;
const ENTITY_CONFIG =
{
	IDOrganization: { Set: 'Organizations', One: 'Organization', IDField: 'IDOrganization', Noun: 'prime contractor', CustomerScoped: true, SearchFields: [ 'Name', 'City', 'State', 'VendorCode', 'Type' ], IgnoreFields: [ 'IDCustomer', 'GUIDOrganization' ] },
	IDContractType: { Set: 'ContractTypes', One: 'ContractType', IDField: 'IDContractType', Noun: 'contract type', CustomerScoped: false, SearchFields: [ 'Name', 'Description' ], IgnoreFields: [ 'IDCustomer', 'GUIDContractType' ] },
	ItemIDTestSpecificationSet: { Set: 'TestSpecificationSets', One: 'TestSpecificationSet', IDField: 'IDTestSpecificationSet', Noun: 'test spec set', CustomerScoped: false, SearchFields: [ 'Name', 'Year' ], IgnoreFields: [ 'IDCustomer', 'GUIDTestSpecificationSet' ] },
	MaterialIDTestSpecificationSet: { Set: 'TestSpecificationSets', One: 'TestSpecificationSet', IDField: 'IDTestSpecificationSet', Noun: 'test spec set', CustomerScoped: false, SearchFields: [ 'Name', 'Year' ], IgnoreFields: [ 'IDCustomer', 'GUIDTestSpecificationSet' ] },
};

/**
 * ContractCreateWorkspace — the data layer behind the bespoke Contract CREATE screen. Reached by the app-router
 * Create bridge (#/PSRS/Contract/Create) that shadows the generic recordset create form, so "+ New" opens a
 * curated, grouped experience instead of the plain manifest form. ContractWorkspace itself is a read-only detail
 * view, so this is the first editable Contract surface.
 *
 * It starts from a blank working copy, POSTs a new Contract (IDCustomer stamped by the server — never sent), and
 * on success navigates to #/PSRS/Contract/View/<newGUID>, which the View bridge opens as ContractWorkspace.
 */
class ContractCreateWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get state()
	{
		if (!this.pict.AppData.ContractCreateWorkspace)
		{
			this.pict.AppData.ContractCreateWorkspace =
			{
				Ready: false, Message: '', MessageClass: '', Saving: false,
				IDCustomer: 0, Fields: {}, Errors: {},
			};
		}
		return this.pict.AppData.ContractCreateWorkspace;
	}

	// --- REST helpers ---

	_create(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.createEntity('Contract', pRecord, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	_toNumberOrNull(pValue)
	{
		if (pValue == null || String(pValue).trim() === '') { return null; }
		const tmpNumber = Number(pValue);
		return Number.isFinite(tmpNumber) ? tmpNumber : null;
	}

	// --- Start a new contract ---

	startNew()
	{
		const tmpState = this.state;
		tmpState.Message = '';
		tmpState.MessageClass = '';
		tmpState.Saving = false;
		tmpState.Errors = {};
		tmpState.IDCustomer = Number(this.currentUser.CustomerID) || 0;
		const tmpFields = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			tmpFields[pField.Key] = '';
		}));
		tmpState.Fields = tmpFields;
		tmpState.Ready = true;
		this.render();
	}

	// --- Editing ---

	setField(pKey, pValue)
	{
		this.state.Fields[pKey] = pValue;
		if (this.state.Errors[pKey]) { delete this.state.Errors[pKey]; }
	}

	_validate()
	{
		const tmpState = this.state;
		const tmpErrors = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			const tmpValue = tmpState.Fields[pField.Key];
			const tmpHasValue = (tmpValue != null && String(tmpValue).trim() !== '');
			if (pField.Required && !tmpHasValue) { tmpErrors[pField.Key] = `${pField.Label} is required.`; return; }
			if (pField.Type === 'number' && tmpHasValue)
			{
				const tmpNumber = Number(tmpValue);
				if (!Number.isFinite(tmpNumber)) { tmpErrors[pField.Key] = `${pField.Label} must be a number.`; }
				else if (tmpNumber < 0) { tmpErrors[pField.Key] = `${pField.Label} can’t be negative.`; }
			}
		}));
		tmpState.Errors = tmpErrors;
		return Object.keys(tmpErrors).length === 0;
	}

	// --- Save / navigation ---

	async saveAsync()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		if (!this._validate())
		{
			tmpState.Message = 'Please fix the highlighted fields.';
			tmpState.MessageClass = 'is-danger';
			this.render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Message = 'Creating…';
		tmpState.MessageClass = 'is-info';
		this._renderMessage();
		try
		{
			// Build the create payload — omit empty optionals so the server applies its own defaults. IDCustomer
			// is never included (stamped from the session).
			const tmpPayload = {};
			FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
			{
				const tmpValue = tmpState.Fields[pField.Key];
				if ((pField.Type === 'number') || (pField.Type === 'entity'))
				{
					const tmpNumber = this._toNumberOrNull(tmpValue);
					if (tmpNumber != null) { tmpPayload[pField.Key] = tmpNumber; }
				}
				else if (tmpValue != null && String(tmpValue).trim() !== '')
				{
					tmpPayload[pField.Key] = tmpValue;
				}
			}));
			const tmpSaved = await this._create(tmpPayload);
			if (!tmpSaved || tmpSaved.ErrorCode || !tmpSaved.IDContract)
			{
				throw new Error((tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode))
					? String(tmpSaved.Error || tmpSaved.ErrorCode)
					: 'the server rejected the new contract (you may not have permission to create contracts).');
			}
			tmpState.Saving = false;
			this._navigateToView(tmpSaved);
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Could not create the contract: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	cancel()
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = '#/PSRS/Contract/List';
		}
	}

	/** Land on the bespoke read workspace for the just-created contract (via the View bridge). */
	_navigateToView(pSaved)
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = pSaved.GUIDContract ? `#/PSRS/Contract/View/${pSaved.GUIDContract}` : '#/PSRS/Contract/List';
		}
	}

	// --- Render (hand-built HTML into the shell's mount; mirrors ProjectCreateWorkspace-Provider) ---

	render()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
		if (this.state.Ready) { this._mountPickers(); }
	}

	_mountPickers()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			if (pField.Type === 'entity') { this._mountPicker(pField.Key); }
		}));
	}

	_mountPicker(pKey)
	{
		const tmpMount = `#CCW-Picker-${pKey}`;
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; }
		const tmpConfig = ENTITY_CONFIG[pKey];
		if (!tmpConfig) { return; }
		const tmpPicker = this.pict.providers['Pict-Section-Picker'].createPicker(`CCW-Picker-${pKey}`,
			{
				DestinationAddress: tmpMount,
				ValueAddress: `AppData.ContractCreateWorkspace.Fields.${pKey}`,
				Searchable: true,
				AllowClear: true,
				ClearLabel: '(none)',
				Placeholder: `Search a ${tmpConfig.Noun}…`,
				DataProvider: this._entityDataProvider(tmpConfig),
				ResolveValue: this._entityResolveValue(tmpConfig),
				Entity: tmpConfig.One,
				AllowFieldDecoration: true,
				DecorationIgnoreFields: tmpConfig.IgnoreFields,
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
	}

	_entityDataProvider(pConfig)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		return (pSearchTerm, pPage) =>
		{
			const tmpStart = (Number(pPage) || 0) * PICKER_PAGE_SIZE;
			let tmpFilter = (pConfig.CustomerScoped === false)
				? `FBV~Deleted~EQ~0`
				: `FBV~IDCustomer~EQ~${this.state.IDCustomer}~FBV~Deleted~EQ~0`;
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).trim();
			if (tmpTerm && tmpPickerProvider && (typeof tmpPickerProvider.buildSearchFilter === 'function'))
			{
				tmpFilter += `~${tmpPickerProvider.buildSearchFilter(pConfig.SearchFields, tmpTerm)}`;
			}
			return this._getJSON(`${pConfig.Set}/FilteredTo/${tmpFilter}/${tmpStart}/${PICKER_PAGE_SIZE}`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					return { results: tmpList.map((pRow) => ({ Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${pRow[pConfig.IDField]}`, Record: pRow })), hasMore: (tmpList.length >= PICKER_PAGE_SIZE) };
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	_entityResolveValue(pConfig)
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`${pConfig.One}/${tmpID}`)
				.then((pRow) => ((pRow && pRow[pConfig.IDField]) ? { Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	_renderMessage()
	{
		if (this.pict.ContentAssignment.getElement(MESSAGE_MOUNT).length === 0) { this.render(); return; }
		this.pict.ContentAssignment.assignContent(MESSAGE_MOUNT, this._messageHTML());
	}

	_messageHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Message) { return ''; }
		return `<div class="notification ${this._esc(tmpState.MessageClass || 'is-info')} is-soft py-2 px-3 mb-3">${this._esc(tmpState.Message)}</div>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Ready)
		{
			return `<div class="pew-empty box has-text-grey has-text-centered"><span class="pew-spinner"></span><p class="mt-3">Loading…</p></div>`;
		}
		return `<div class="pew-head">`
			+ `<div><div class="pew-eyebrow">New Contract</div><h1 class="pew-title">Create a contract</h1></div>`
			+ `<div class="pew-head-actions">`
			+ `<button class="button is-link"${tmpState.Saving ? ' disabled' : ''} onclick="_Pict.providers.ContractCreateWorkspace.saveAsync(); return false;"><span>Create contract</span></button>`
			+ `<button class="button is-light" onclick="_Pict.providers.ContractCreateWorkspace.cancel(); return false;"><span>Cancel</span></button>`
			+ `</div></div>`
			+ `<div id="CCW-Message">${this._messageHTML()}</div>`
			+ `<div class="pew-form">${FIELD_GROUPS.map((pGroup) => this._groupHTML(pGroup)).join('')}</div>`;
	}

	_groupHTML(pGroup)
	{
		const tmpRows = pGroup.Fields.map((pField) => this._fieldHTML(pField)).join('');
		return `<div class="pew-group"><div class="pew-group-head">${this._esc(pGroup.Name)}</div><div class="pew-grid">${tmpRows}</div></div>`;
	}

	_fieldHTML(pField)
	{
		const tmpState = this.state;
		const tmpValue = tmpState.Fields[pField.Key];
		const tmpError = tmpState.Errors[pField.Key] ? `<div class="pew-field-error">${this._esc(tmpState.Errors[pField.Key])}</div>` : '';
		const tmpWide = pField.Wide ? ' pew-field-wide' : '';
		const tmpRequired = pField.Required ? ' <span class="ccw-req">*</span>' : '';
		return `<div class="pew-field${tmpWide}"><label class="pew-field-label">${this._esc(pField.Label)}${tmpRequired}</label>${this._controlHTML(pField, tmpValue)}${tmpError}</div>`;
	}

	_controlHTML(pField, pValue)
	{
		const tmpOnChange = `onchange="_Pict.providers.ContractCreateWorkspace.setField('${pField.Key}', this.value)"`;
		if (pField.Type === 'textarea')
		{
			return `<textarea class="textarea pew-input" ${tmpOnChange}>${this._esc(pValue)}</textarea>`;
		}
		if (pField.Type === 'entity')
		{
			return `<div id="CCW-Picker-${pField.Key}" class="pew-input pew-picker-host"></div>`;
		}
		if (pField.Type === 'date')
		{
			return `<input class="input pew-input" type="date" value="${this._esc(pValue)}" ${tmpOnChange} />`;
		}
		const tmpStep = (pField.Type === 'number') ? ' step="any"' : '';
		return `<input class="input pew-input" type="${(pField.Type === 'number') ? 'number' : 'text'}"${tmpStep} value="${this._esc(pValue)}" ${tmpOnChange} />`;
	}
}

module.exports = ContractCreateWorkspaceProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ContractCreateWorkspace',
	AutoInitialize: true,
	AutoInitializeOrdinal: 226,
};

},{"pict-provider":845}],1317:[function(require,module,exports){
(function (Buffer){(function (){
'use strict';

const libPictProvider = require('pict-provider');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

const libModel = require('../data-import/ContractPackage-Model.js');
const libSchema = require('../data-import/DataImport-Schema.js');
const libLayouts = require('../data-import/ContractPackage-FieldLayouts.js');
const libTemplateData = require('../data-import/ContractPackage-Template-Data.js');
const libStrategyApply = require('pict-section-dataimport/source/services/DataImport-GuidStrategyApply.js');
const libComprehensionBuilder = require('pict-section-dataimport/source/services/DataImport-ComprehensionBuilder.js');
const libDelimitedParser = require('pict-section-dataimport/source/seams/DataImport-Parser-Delimited.js');
const libPictSectionUpload = require('pict-section-upload');
const libPictSectionAccordion = require('pict-section-accordion');

// The three source shapes the bespoke importer accepts.
const SOURCE_SHAPES =
{
	SHEET: 'sheet',   // "One file" — a giant denormalized sheet OR an Excel workbook (auto-detected on load)
	FILES: 'files',   // "Multiple files" — one file per level
};

const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'ContractPackageImportManager',
	AutoInitialize: true,
	AutoInitializeOrdinal: 91,
};

/**
 * ContractPackageImportManager — the orchestrator behind the bespoke "Import Contract Package" screen.
 *
 * Where the generic DataImportManager imports ONE flat entity, this imports the interconnected
 * Contract -> Project -> BidItem -> LineItem graph in one pass. It is a thin config-author over the SAME
 * engine + push the generic importer uses: it fetches the four live schemas, parses the chosen source
 * (reusing the wizard's parsers, Excel host-override included), turns the entity-aware UI choices into a
 * meadow-integration GUID strategy + multi-entity mapping via ContractPackage-Model, runs the shared
 * ComprehensionBuilder, then pushes the ordered comprehension through DataImportManager._pushViaHeadlight
 * (which already lands referenced-entities-first with GUID cross-linking). All render state lives at
 * AppData.ContractImportUI.
 */
class ContractPackageImportManagerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._csvParser = null;
		this._schemaCache = null;      // { <entity>: mappedSchema }
		this._comprehension = null;    // last built comprehension (for the push step)
		this._pushContext = null;
		this._uploaders = {};          // slot -> created (pict-section-upload drop zone hash)
		this._uploaderInit = {};       // slot -> initialized once
		this._accHash = 'CPI-MapAccordion';   // the mapping accordion view hash
	}

	/** The shared Headlight rest client (schema reads + record upsert). */
	get restClient()
	{
		return (this.fable && this.fable.HeadlightRestClient)
			|| (this.pict && this.pict.fable && this.pict.fable.HeadlightRestClient)
			|| (this.pict && this.pict.HeadlightRestClient)
			|| null;
	}

	/** The generic import manager — we reuse its ordered multi-entity push + Excel parser. */
	get dataImportManager()
	{
		return this.pict.providers['DataImportManager'];
	}

	/** The app's shared modal (success / error toasts). */
	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	// ── Parsers (reused) ────────────────────────────────────────────────────────
	_xlsxParser()
	{
		// Reuse the generic manager's window.XLSX-aware host parser (has listSheetNames for the workbook shape).
		return this.dataImportManager ? this.dataImportManager._xlsxParser() : null;
	}

	_delimitedParser()
	{
		if (!this._csvParser) { this._csvParser = new libDelimitedParser(this.pict, { Kind: 'csv' }); }
		return this._csvParser;
	}

	/** Pick a parser for an uploaded file handle by extension (handle.Name from pict-section-upload). */
	_parserForFile(pHandle)
	{
		if (this._isExcel(pHandle)) { return this._xlsxParser(); }
		return this._delimitedParser(); // csv / tsv / txt
	}

	/** Is this handle an Excel file (by name)? */
	_isExcel(pHandle)
	{
		const tmpName = (pHandle && (pHandle.Name || pHandle.name)) ? String(pHandle.Name || pHandle.name).toLowerCase() : '';
		return /\.xlsx?$/.test(tmpName) || /\.xlsm$/.test(tmpName);
	}

	// ── Upload drop zones (pict-section-upload) ──────────────────────────────────
	// The generic import wizard embeds pict-section-upload to turn a browser File into a parser-ready
	// handle (getText/getArrayBuffer via FileReader). The bespoke view does the same, one drop zone per
	// upload slot ('sheet' for the giant/workbook shapes; one per created level for the file-per-level shape).

	/** Ensure the pict-section-upload provider is registered (the wizard registers it lazily too). */
	_ensureUploadProvider()
	{
		if (!this.pict.providers['Pict-Section-Upload'])
		{
			this.pict.addProvider('Pict-Section-Upload', libPictSectionUpload.default_configuration, libPictSectionUpload);
		}
		return this.pict.providers['Pict-Section-Upload'];
	}

	/** (Re)mount the drop zones for the current source shape into their view mounts (from onAfterRender). */
	mountUploaders()
	{
		const tmpState = this._ensureState();
		this._ensureUploadProvider();
		if (tmpState.IsSheet)
		{
			this._mountUploader('sheet', 'Drop your data file here, or');
		}
		if (tmpState.IsFiles)
		{
			(tmpState.CreatedLevels || []).forEach((pLevel) => this._mountUploader(pLevel.Entity, `Drop the ${pLevel.Label} file here, or`));
		}
	}

	/** Create (once) + render a drop zone for a slot, routing its handle to onFileReady. */
	_mountUploader(pSlot, pDropLabel)
	{
		const tmpMount = `#CPI-Upload-${pSlot}`;
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; } // mount not painted yet
		const tmpHash = `CPI-Upload-${pSlot}`;
		if (!this._uploaders[tmpHash])
		{
			this._ensureUploadProvider().createUploader(tmpHash,
				{
					DestinationAddress: tmpMount,
					Accept: '.csv,.tsv,.txt,.xlsx,.xls',
					DropLabel: pDropLabel,
					OnComplete: (pHandle) => this.onFileReady(pHandle, pSlot),
					OnRemove: () => this.onFileRemoved(pSlot),
				});
			this._uploaders[tmpHash] = true;
		}
		const tmpView = this.pict.views[tmpHash];
		if (tmpView)
		{
			if (!this._uploaderInit[tmpHash] && (typeof tmpView.initialize === 'function')) { tmpView.initialize(); this._uploaderInit[tmpHash] = true; }
			tmpView.render();
		}
	}

	// ── Mapping accordion (pict-section-accordion) ───────────────────────────────
	// Each created level is a collapsible panel (header = level + row count + key; body = the field grid),
	// so the map step shows one level's fields at a time instead of every box at once. Mirrors the wizard's
	// createAccordion + per-body-render + rebuild-on-wipe lifecycle.

	_ensureAccordionProvider()
	{
		if (!this.pict.providers['Pict-Section-Accordion'])
		{
			this.pict.addProvider('Pict-Section-Accordion', libPictSectionAccordion.default_configuration, libPictSectionAccordion);
		}
		return this.pict.providers['Pict-Section-Accordion'];
	}

	/** (Re)build the mapping accordion + render each level's field grid into its panel body (onAfterRender). */
	mountMappingAccordion()
	{
		const tmpState = this._ensureState();
		const tmpLevels = tmpState.CreatedLevels || [];
		const tmpMount = '#CPI-Map-Accordion';
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; } // mount not painted yet
		if (tmpLevels.length === 0) { return; }

		const tmpSteps = tmpLevels.map((pLevel) => (
			{
				Hash: pLevel.Entity,
				Title: pLevel.Label,
				Subtitle: `${pLevel.RowCount} row${pLevel.RowCount === 1 ? '' : 's'}${pLevel.KeyColumn ? ` · key: ${pLevel.KeyColumn}` : ''}`,
			}));

		this._ensureAccordionProvider().createAccordion(this._accHash,
			{
				DestinationAddress: tmpMount,
				RenderMode: 'accordion',
				AllowMultipleOpen: true,
				LinearGating: false,     // levels are independent — every panel is openable
				Steps: tmpSteps,
			});
		this.pict.views[this._accHash].render();

		// Render each level's body (Sheet picker + key + field grid) into its panel body container.
		tmpLevels.forEach((pLevel) =>
		{
			const tmpHTML = this.pict.parseTemplateByHash('CPI-Level-Body-Template', pLevel);
			this.pict.ContentAssignment.assignContent(`#PSA_Body_${this._accHash}_${pLevel.Entity}`, tmpHTML);
		});
	}

	// ── Pre-import Review tree ───────────────────────────────────────────────────
	// Renders the built comprehension as a browsable Contract→Project→BidItem→LineItem tree (items flow:
	// BidItem→LineItem) so the user can validate the actual records before pushing. Built as recursive HTML
	// into a mount (native <details> for expand/collapse), refreshed in onAfterRender like the accordion.

	mountReviewTree()
	{
		const tmpMount = '#CPI-Review-Tree';
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; }
		if (!this._comprehension) { return; }
		this.pict.ContentAssignment.assignContent(tmpMount, this._reviewTreeHTML());
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"]/g, (pCh) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pCh]));
	}

	/** Build the review tree HTML, rooted at the first created level in the push order. */
	_reviewTreeHTML()
	{
		const tmpComprehension = this._comprehension || {};
		const tmpOrder = (this._pushContext && this._pushContext.Order) || Object.keys(tmpComprehension);
		if (!tmpOrder.length) { return '<div class="cpi-tree-empty">Nothing to preview.</div>'; }
		const tmpRootGUIDs = Object.keys(tmpComprehension[tmpOrder[0]] || {});
		if (!tmpRootGUIDs.length) { return '<div class="cpi-tree-empty">No records were produced — check the key columns.</div>'; }
		return this._reviewNodeHTML(tmpOrder, 0, tmpRootGUIDs);
	}

	_reviewNodeHTML(pOrder, pLevelIdx, pGUIDs)
	{
		const tmpComprehension = this._comprehension || {};
		const tmpLevel = pOrder[pLevelIdx];
		const tmpRecords = tmpComprehension[tmpLevel] || {};
		const tmpMeta = libModel.findLevel(tmpLevel) || { Label: tmpLevel, Icon: 'fas fa-circle' };
		const tmpHasChild = (pLevelIdx + 1) < pOrder.length;
		const tmpChildLevel = tmpHasChild ? pOrder[pLevelIdx + 1] : null;
		const tmpChildRecords = tmpHasChild ? (tmpComprehension[tmpChildLevel] || {}) : {};
		const tmpChildMeta = tmpHasChild ? (libModel.findLevel(tmpChildLevel) || { Label: tmpChildLevel }) : null;

		return pGUIDs.map((pGUID) =>
		{
			const tmpRec = tmpRecords[pGUID] || {};
			const tmpTitle = this._esc(this._nodeTitle(tmpRec, pGUID));
			const tmpFields = this._nodeFieldsHTML(tmpRec);
			if (!tmpHasChild)
			{
				return `<div class="cpi-tree-leaf"><span class="cpi-tree-badge">${this._esc(tmpMeta.Label)}</span><span class="cpi-tree-title">${tmpTitle}</span>${tmpFields}</div>`;
			}
			const tmpChildGUIDs = Object.keys(tmpChildRecords).filter((pChild) => tmpChildRecords[pChild][`GUID${tmpLevel}`] === pGUID);
			const tmpSub = `${tmpChildGUIDs.length} ${tmpChildMeta.Label}${tmpChildGUIDs.length === 1 ? '' : 's'}`;
			const tmpOpen = (pLevelIdx < 1) ? ' open' : '';
			return `<details class="cpi-tree-node"${tmpOpen}><summary class="cpi-tree-head">`
				+ `<span class="cpi-tree-badge">${this._esc(tmpMeta.Label)}</span><span class="cpi-tree-title">${tmpTitle}</span>`
				+ `<span class="cpi-tree-sub">${this._esc(tmpSub)}</span></summary>${tmpFields}`
				+ `<div class="cpi-tree-children">${this._reviewNodeHTML(pOrder, pLevelIdx + 1, tmpChildGUIDs)}</div></details>`;
		}).join('');
	}

	/** A human title for a review node — the record's Name / number. */
	_nodeTitle(pRec, pGUID)
	{
		return pRec.Name || pRec.ItemNumber || pRec.ItemCode || pRec.Description || pGUID;
	}

	/** Up to six field chips (humanized label + value) for a node — mapped, non-internal fields only. */
	_nodeFieldsHTML(pRec)
	{
		const tmpChips = [];
		Object.keys(pRec).forEach((pKey) =>
		{
			if (tmpChips.length >= 6) { return; }
			if (/^GUID/.test(pKey) || /^_/.test(pKey) || (/^ID[A-Z]/.test(pKey)) || pKey === 'Name') { return; }
			const tmpValue = pRec[pKey];
			if (tmpValue == null || String(tmpValue) === '') { return; }
			tmpChips.push(`<span class="cpi-tree-chip"><span class="cpi-tree-chip-k">${this._esc(libLayouts.humanize(pKey))}</span> ${this._esc(tmpValue)}</span>`);
		});
		return tmpChips.length ? `<div class="cpi-tree-fields">${tmpChips.join('')}</div>` : '';
	}

	// ── State ───────────────────────────────────────────────────────────────────
	_ensureState()
	{
		if (!this.pict.AppData.ContractImportUI)
		{
			this.pict.AppData.ContractImportUI =
			{
				Mode: 'new',                 // 'new' (create all) | 'existing' (attach to a picked parent)
				SourceShape: SOURCE_SHAPES.SHEET,
				// Per-level scope: 'create' | 'pick'. 'new' mode forces all-create; 'existing' lets the user
				// pick a Contract (and optionally a Project) that become constant parents.
				Modes: { Contract: 'create', Project: 'create', BidItem: 'create', LineItem: 'create' },
				PickedIDs: {},
				PickedKeys: {},
				PickedLabels: {},
				// Detected columns for the loaded source (giant sheet: shared; per-entity: per level).
				Columns: [],
				SampleRows: [],
				PerEntityColumns: {},        // entity -> [columns] (workbook / files shapes)
				PerEntityRows: {},           // entity -> parsed rows (workbook / files shapes)
				RowsLoaded: 0,
				WorkbookTabs: [],            // a multi-tab workbook's sheet names (drives the per-level Sheet picker)
				TabAssignments: {},          // entity -> which workbook tab feeds it (best-guess, user-overridable)
				// Map step: entity -> { targetField: sourceColumn }, and entity -> keyColumn.
				FieldAssignments: {},
				KeyColumns: {},
				// Contract / Project pickers (add-to-existing).
				ContractOptions: [],
				ProjectOptions: [],
				// Items flow ('items') vs the full package flow ('package'): which columns match each row's
				// existing Contract + Project (per-row, many-project resolution).
				Flow: 'package',
				ContractKeyColumn: '',
				ProjectKeyColumn: '',
				// Derived render slots (rebuilt each prepare()).
				Preview: null,
				Warnings: [],
				LastResult: null,
				LastError: '',
				Busy: false,
			};
		}
		return this.pict.AppData.ContractImportUI;
	}

	/** Recompute derived render slots from core state. Called by the view's onBeforeRender. */
	prepare()
	{
		const tmpState = this._ensureState();

		// The levels that will be CREATED, in order, with their resolved key + column choices for the UI.
		const tmpPlan = this._plan();
		tmpState.CreatedLevels = tmpPlan.Levels
			.filter((pLevel) => pLevel.Mode === 'create')
			.map((pLevel) => (
				{
					Entity: pLevel.Entity,
					Label: pLevel.Label,
					Icon: pLevel.Icon,
					KeyColumn: (tmpState.KeyColumns[pLevel.Entity] || pLevel.KeyColumns[0] || ''),
					// The columns available to map/key this level (giant sheet shares one set).
					ColumnItems: this._columnsFor(pLevel.Entity).map((pColumn) => (
						{ Name: pColumn, Label: pColumn, Selected: ((tmpState.KeyColumns[pLevel.Entity] || pLevel.KeyColumns[0]) === pColumn) })),
					Groups: this._fieldGroupsFor(pLevel.Entity, tmpState),
					RowCount: (tmpState.PerEntityRows.__sheet)
						? tmpState.PerEntityRows.__sheet.length
						: (tmpState.PerEntityRows[pLevel.Entity] || []).length,
					// Files shape: each level gets its own file input inside its card.
					FileSlot: (tmpState.SourceShape === SOURCE_SHAPES.FILES) ? [ { Entity: pLevel.Entity, Label: pLevel.Label } ] : [],
					// Multi-tab workbook: a Sheet picker (all tabs + none), best-guess selected, user-overridable.
					TabSlot: (tmpState.WorkbookTabs && tmpState.WorkbookTabs.length)
						? [ { Entity: pLevel.Entity, TabItems: [ { Name: '', Label: '— none —', Selected: !tmpState.TabAssignments[pLevel.Entity] } ].concat(
							tmpState.WorkbookTabs.map((pTab) => ({ Name: pTab, Label: pTab, Selected: (tmpState.TabAssignments[pLevel.Entity] === pTab) }))) } ]
						: [],
				}));

		tmpState.IsItems = (tmpState.Flow === 'items');
		tmpState.IsPackage = !tmpState.IsItems;
		tmpState.Title = tmpState.IsItems ? 'Import Line Items' : 'Import Contract Package';
		tmpState.Subtitle = tmpState.IsItems
			? 'Add Bid Items and Line Items to existing Projects — each row matched to its Contract and Project by a column you choose, so one file can span many projects. Re-imports update in place.'
			: 'Load a Contract with its Projects, Bid Items and Line Items in one pass — from one file (a single sheet or an Excel workbook), or a file per level. Records interlink automatically, and re-importing the same data updates in place instead of duplicating.';
		tmpState.HeadIcon = tmpState.IsItems ? 'fas fa-list-check' : 'fas fa-folder-tree';
		tmpState.IsExisting = (tmpState.Mode === 'existing');
		tmpState.IsSheet = (tmpState.SourceShape !== SOURCE_SHAPES.FILES);   // "One file" — a sheet OR a workbook (auto-detected)
		tmpState.IsFiles = (tmpState.SourceShape === SOURCE_SHAPES.FILES);
		tmpState.HasColumns = (tmpState.Columns.length > 0) || (Object.keys(tmpState.PerEntityColumns).length > 0);

		// Segmented-control active classes + the top upload slot (the "One file" shape uploads once).
		tmpState.ModeNewClass = (tmpState.Mode === 'new') ? ' cpi-seg-on' : '';
		tmpState.ModeExistingClass = (tmpState.Mode === 'existing') ? ' cpi-seg-on' : '';
		tmpState.ShapeSheetClass = tmpState.IsSheet ? ' cpi-seg-on' : '';
		tmpState.ShapeFilesClass = tmpState.IsFiles ? ' cpi-seg-on' : '';
		tmpState.TopUploadSlot = tmpState.IsSheet
			? [ { Hint: 'CSV or Excel — a single sheet, or an Excel workbook with a tab per level' } ]
			: [];
		tmpState.MapSlot = (tmpState.HasColumns && tmpState.CreatedLevels.length > 0) ? [ {} ] : [];
		tmpState.CanImport = !!tmpState.Preview && !tmpState.Busy;
		tmpState.ReviewSlot = this._comprehension ? [ {} ] : [];   // the browsable record tree, after Preview

		tmpState.PreviewSlot = tmpState.Preview ? [ tmpState.Preview ] : [];
		tmpState.WarningSlot = (tmpState.Warnings || []).map((pWarning) => ({ Message: pWarning }));
		tmpState.ResultSlot = tmpState.LastResult ? [ tmpState.LastResult ] : [];
		tmpState.ErrorSlot = tmpState.LastError ? [ { Message: tmpState.LastError } ] : [];
		tmpState.PickerSlot = (tmpState.IsPackage && tmpState.IsExisting) ? [ {} ] : [];
		tmpState.ProjectPickerSlot = (tmpState.IsPackage && tmpState.IsExisting && tmpState.PickedIDs.Contract) ? [ {} ] : [];
		tmpState.NoteSlot = tmpState.SourceNote ? [ { Message: tmpState.SourceNote } ] : [];

		// Package flow shows the new/existing scope; items flow shows a "link to existing" intro + (once the
		// file is loaded) the Contract / Project column pickers used for per-row parent resolution.
		tmpState.PackageScopeSlot = tmpState.IsPackage ? [ {} ] : [];
		tmpState.ItemsIntroSlot = tmpState.IsItems ? [ {} ] : [];
		const tmpSheetColumns = (tmpState.Columns || []).map((pColumn) => (typeof pColumn === 'string') ? pColumn : (pColumn.SourceName || pColumn.Name));
		const fLinkItems = (pSelected) => [ { Name: '', Label: '— choose a column —', Selected: !pSelected } ].concat(
			tmpSheetColumns.map((pColumn) => ({ Name: pColumn, Label: pColumn, Selected: (pSelected === pColumn) })));
		tmpState.LinkSlot = (tmpState.IsItems && tmpState.HasColumns)
			? [ { ContractItems: fLinkItems(tmpState.ContractKeyColumn), ProjectItems: fLinkItems(tmpState.ProjectKeyColumn) } ]
			: [];

		return tmpState;
	}

	/** The normalized model plan for the current UI state. */
	_plan()
	{
		const tmpState = this._ensureState();
		const tmpModes = {};
		const tmpKeyColumns = {};
		Object.keys(tmpState.KeyColumns).forEach((pEntity) => { tmpKeyColumns[pEntity] = [ tmpState.KeyColumns[pEntity] ]; });

		if (tmpState.Flow === 'items')
		{
			// Import Bid Items + Line Items into EXISTING work: Contract + Project are referenced per-row by
			// the key column the user chose; only Bid Item + Line Item are created.
			libModel.PACKAGE_ENTITIES.forEach((pLevel) =>
			{
				tmpModes[pLevel.Entity] = (pLevel.Entity === 'Contract' || pLevel.Entity === 'Project') ? 'reference' : 'create';
			});
			return libModel.normalizePlan(
				{
					Modes: tmpModes,
					KeyColumns: tmpKeyColumns,
					ReferenceKeyColumns: { Contract: tmpState.ContractKeyColumn, Project: tmpState.ProjectKeyColumn },
				});
		}

		libModel.PACKAGE_ENTITIES.forEach((pLevel) =>
		{
			tmpModes[pLevel.Entity] = (tmpState.Mode === 'existing') ? (tmpState.Modes[pLevel.Entity] || 'create') : 'create';
		});
		return libModel.normalizePlan(
			{
				Modes: tmpModes,
				PickedIDs: tmpState.PickedIDs,
				PickedKeys: tmpState.PickedKeys,
				KeyColumns: tmpKeyColumns,
			});
	}

	/** The available source columns for a level (per-entity dataset if present, else the shared sheet). */
	_columnsFor(pEntity)
	{
		const tmpState = this._ensureState();
		if (tmpState.PerEntityColumns[pEntity] && tmpState.PerEntityColumns[pEntity].length)
		{
			return tmpState.PerEntityColumns[pEntity];
		}
		return (tmpState.Columns || []).map((pColumn) => (typeof pColumn === 'string') ? pColumn : pColumn.SourceName || pColumn.Name);
	}

	/** The mappable fields for a level (from the fetched schema), with the current assignment. */
	/**
	 * The mappable fields for a level, grouped + friendly-labeled like the record edit screen (Identity /
	 * Schedule / Financials / …), via ContractPackage-FieldLayouts. Each group's fields carry the source
	 * column dropdown. Ungrouped settable fields fall into an "Additional fields" section.
	 * @returns {Array<{Section:string, Fields:Array<object>}>}
	 */
	_fieldGroupsFor(pEntity, pState)
	{
		const tmpSchemaEntity = this._schemaEntity(pEntity);
		if (!tmpSchemaEntity) { return []; }
		const tmpAssigned = (pState.FieldAssignments[pEntity] || {});
		const tmpColumns = this._columnsFor(pEntity);
		const tmpLevel = libModel.findLevel(pEntity);
		// Foreign-key columns owned by the GUID strategy / constant-FK path are hidden from the data mapper.
		const tmpHiddenFK = {};
		(tmpLevel ? tmpLevel.Parents : []).forEach((pParent) => { tmpHiddenFK[(tmpLevel.ForeignKey[pParent] || '')] = true; });

		const tmpRequired = {};
		const tmpSettable = (tmpSchemaEntity.Fields || [])
			.filter((pField) => pField.Name !== tmpSchemaEntity.GUIDName && !tmpHiddenFK[pField.Name])
			.map((pField) => { tmpRequired[pField.Name] = !!pField.Required; return pField.Name; });

		const fColumnItems = (pFieldName) => [ { Name: '', Label: '— none —', Selected: !tmpAssigned[pFieldName] } ].concat(
			tmpColumns.map((pColumn) => ({ Name: pColumn, Label: pColumn, Selected: (tmpAssigned[pFieldName] === pColumn) })));

		return libLayouts.groupFields(pEntity, tmpSettable).map((pGroup) => (
			{
				Section: pGroup.Section,
				Fields: pGroup.Fields.map((pField) => (
					{
						Entity: pEntity,
						Name: pField.Key,
						Label: pField.Label,
						Required: !!tmpRequired[pField.Key],
						ColumnItems: fColumnItems(pField.Key),
					})),
			}));
	}

	_schemaEntity(pEntity)
	{
		return (this._schemaCache && this._schemaCache[pEntity]) || null;
	}

	// ── Wiring from the view ──────────────────────────────────────────────────────
	/** Switch flow: 'package' (create the whole Contract graph) vs 'items' (add Bid/Line Items to existing work). */
	setFlow(pFlow)
	{
		this.setFlowQuiet(pFlow);
		this._render();
	}

	/** Set the flow without rendering — for the router to call before it renders the view. */
	setFlowQuiet(pFlow)
	{
		const tmpState = this._ensureState();
		tmpState.Flow = (pFlow === 'items') ? 'items' : 'package';
		this._resetBuild();
		return this;
	}

	/** Items flow: which source column identifies each row's existing Contract / Project. */
	setContractKeyColumn(pColumn) { const tmpState = this._ensureState(); tmpState.ContractKeyColumn = pColumn || ''; this._resetBuild(); this._render(); }
	setProjectKeyColumn(pColumn) { const tmpState = this._ensureState(); tmpState.ProjectKeyColumn = pColumn || ''; this._resetBuild(); this._render(); }

	setMode(pMode)
	{
		const tmpState = this._ensureState();
		tmpState.Mode = (pMode === 'existing') ? 'existing' : 'new';
		if (tmpState.Mode === 'new')
		{
			tmpState.Modes = { Contract: 'create', Project: 'create', BidItem: 'create', LineItem: 'create' };
		}
		this._resetBuild();
		if (tmpState.Mode === 'existing' && tmpState.ContractOptions.length === 0)
		{
			this._loadContracts();
		}
		this._render();
	}

	setSourceShape(pShape)
	{
		const tmpState = this._ensureState();
		tmpState.SourceShape = pShape || SOURCE_SHAPES.SHEET;
		tmpState.Columns = []; tmpState.SampleRows = []; tmpState.PerEntityColumns = {}; tmpState.PerEntityRows = {}; tmpState.RowsLoaded = 0;
		tmpState.WorkbookTabs = []; tmpState.TabAssignments = {};
		tmpState.SourceNote = '';
		this._resetBuild();
		this._render();
	}

	/** The user picked an existing Contract to attach to → Contract becomes a constant parent. */
	pickContract(pIDContract, pLabel, pKey)
	{
		const tmpState = this._ensureState();
		const tmpID = parseInt(pIDContract, 10);
		// Picking (or clearing) a Contract resets any Project pick beneath it.
		this._clearProjectPick();
		tmpState.ProjectOptions = [];
		if (!tmpID)
		{
			delete tmpState.PickedIDs.Contract; delete tmpState.PickedKeys.Contract; delete tmpState.PickedLabels.Contract;
			tmpState.Modes.Contract = 'create';
		}
		else
		{
			tmpState.Modes.Contract = 'pick';
			tmpState.PickedIDs.Contract = tmpID;
			tmpState.PickedKeys.Contract = (pKey != null) ? String(pKey) : String(tmpID);
			tmpState.PickedLabels.Contract = pLabel || `Contract ${tmpID}`;
			// The optional "attach to a Project" picker self-loads (server-side search scoped to this contract) when
			// it mounts — no need to preload a capped ProjectOptions list here.
		}
		this._resetBuild();
		this._render();
	}

	/** The user picked an existing Project under the chosen Contract → import only Bid Items + Line Items. */
	pickProject(pIDProject, pLabel, pKey)
	{
		const tmpState = this._ensureState();
		const tmpID = parseInt(pIDProject, 10);
		if (!tmpID)
		{
			this._clearProjectPick();
		}
		else
		{
			tmpState.Modes.Project = 'pick';
			tmpState.PickedIDs.Project = tmpID;
			tmpState.PickedKeys.Project = (pKey != null) ? String(pKey) : String(tmpID);
			tmpState.PickedLabels.Project = pLabel || `Project ${tmpID}`;
		}
		this._resetBuild();
		this._render();
	}

	_clearProjectPick()
	{
		const tmpState = this._ensureState();
		delete tmpState.PickedIDs.Project; delete tmpState.PickedKeys.Project; delete tmpState.PickedLabels.Project;
		tmpState.Modes.Project = 'create';
	}

	// --- Searchable Contract / Project pickers (server-side search; replace the capped `/0/200` <select>s that made
	//     any contract/project past the cap unreachable for "attach to existing"). Follows the RoleClone pattern. ---

	_getJSONPromise(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_contractLabel(pC) { return `${(pC && pC.Name) || 'Contract'} (${(pC && (pC.PrimaryProjectNumber || pC.IDContract)) || ''})`; }
	_contractKey(pC) { return (pC && (pC.PrimaryProjectNumber || pC.Name)) || String((pC && pC.IDContract) || ''); }
	_projectLabel(pP) { return (pP && pP.Name) || `Project ${(pP && pP.IDProject) || ''}`; }
	_projectKey(pP) { return (pP && pP.Name) || String((pP && pP.IDProject) || ''); }

	/**
	 * Server-side entity search for a picker → { results:[{Value,Text,Record}], hasMore }. Parallel single-field LIKE
	 * queries merged + de-duped by id — NOT the picker's buildSearchFilter, whose parenthesized OR group is not honored
	 * by the Meadow server here (returns empty). Empty term → the requested page of the scope.
	 */
	_pickerSearch(pEntitySet, pScope, pSearchFields, pTerm, pIDField, pLabelFn, pPage)
	{
		const tmpPageSize = 25;
		const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
		const fToOption = (pRow) => ({ Value: Number(pRow[pIDField]), Text: pLabelFn(pRow), Record: pRow });
		const fMap = (pRows) => (Array.isArray(pRows) ? pRows : []).map(fToOption);
		if (!tmpTerm)
		{
			return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSONPromise(pURL),
				{ Set: pEntitySet, IDField: pIDField, Scope: pScope, SortField: pSearchFields[0], PageSize: tmpPageSize, ToOption: fToOption })('', pPage);
		}
		const tmpLike = encodeURIComponent(`%${tmpTerm}%`);
		return Promise.all(pSearchFields.map((pField) => this._getJSONPromise(`${pEntitySet}/FilteredTo/FBV~${pField}~LK~${tmpLike}~${pScope}/0/${tmpPageSize}`)))
			.then((pResults) =>
			{
				const tmpByID = {};
				pResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pRow) => { const tmpID = Number(pRow && pRow[pIDField]); if ((tmpID > 0) && !tmpByID[tmpID]) { tmpByID[tmpID] = pRow; } }));
				return { results: fMap(Object.keys(tmpByID).map((pKey) => tmpByID[pKey])).slice(0, 50), hasMore: false };
			});
	}

	/** (Re)mount the searchable Contract picker into #CPI-ContractPicker. Called from the view's onAfterRender. */
	mountContractPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#CPI-ContractPicker').length === 0) { return; }
		const tmpView = tmpPicker.createPicker('CPI-ContractPicker',
			{
				DestinationAddress: '#CPI-ContractPicker',
				ValueAddress: 'AppData.ContractImportUI.PickedIDs.Contract',
				Searchable: true, AllowClear: true, ClearLabel: '— choose a contract —',
				Placeholder: 'Search a contract by name or project number…',
				DataProvider: (pTerm, pPage) => this._pickerSearch('Contracts', 'FBV~Deleted~EQ~0', [ 'Name', 'PrimaryProjectNumber' ], pTerm, 'IDContract', (pC) => this._contractLabel(pC), pPage),
				ResolveValue: (pValue) =>
				{
					const tmpID = Number(pValue);
					if (!tmpID) { return Promise.resolve(null); }
					return this._getJSONPromise(`Contract/${tmpID}`).then((pC) => ((pC && pC.IDContract) ? { Value: Number(pC.IDContract), Text: this._contractLabel(pC) } : { Value: tmpID, Text: `#${tmpID}` }));
				},
				OnChange: (pValue, pOption) => { const tmpR = pOption && pOption.Record; this.pickContract(pValue || 0, tmpR ? this._contractLabel(tmpR) : '', tmpR ? this._contractKey(tmpR) : ''); },
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	/** (Re)mount the optional Project picker (scoped to the picked Contract) into #CPI-ProjectPicker. */
	mountProjectPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#CPI-ProjectPicker').length === 0) { return; }
		const tmpIDContract = this._ensureState().PickedIDs.Contract;
		if (!tmpIDContract) { return; }
		const tmpView = tmpPicker.createPicker('CPI-ProjectPicker',
			{
				DestinationAddress: '#CPI-ProjectPicker',
				ValueAddress: 'AppData.ContractImportUI.PickedIDs.Project',
				Searchable: true, AllowClear: true, ClearLabel: '— none (create Projects from the file) —',
				Placeholder: 'Search a project…',
				DataProvider: (pTerm, pPage) => this._pickerSearch('Projects', `FBV~IDContract~EQ~${tmpIDContract}`, [ 'Name' ], pTerm, 'IDProject', (pP) => this._projectLabel(pP), pPage),
				ResolveValue: (pValue) =>
				{
					const tmpID = Number(pValue);
					if (!tmpID) { return Promise.resolve(null); }
					return this._getJSONPromise(`Project/${tmpID}`).then((pP) => ((pP && pP.IDProject) ? { Value: Number(pP.IDProject), Text: this._projectLabel(pP) } : { Value: tmpID, Text: `#${tmpID}` }));
				},
				OnChange: (pValue, pOption) => { const tmpR = pOption && pOption.Record; this.pickProject(pValue || 0, tmpR ? this._projectLabel(tmpR) : '', tmpR ? this._projectKey(tmpR) : ''); },
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	/** The map step: assign a source column to a target field (or clear it with ''). */
	assignField(pEntity, pField, pColumn)
	{
		const tmpState = this._ensureState();
		if (!tmpState.FieldAssignments[pEntity]) { tmpState.FieldAssignments[pEntity] = {}; }
		if (pColumn) { tmpState.FieldAssignments[pEntity][pField] = pColumn; }
		else { delete tmpState.FieldAssignments[pEntity][pField]; }
		this._resetBuild();
	}

	/** The map step: choose the natural-key column that composes a level's GUID (idempotency anchor). */
	setKeyColumn(pEntity, pColumn)
	{
		const tmpState = this._ensureState();
		tmpState.KeyColumns[pEntity] = pColumn;
		this._resetBuild();
		this._render();
	}

	_resetBuild()
	{
		const tmpState = this._ensureState();
		tmpState.Preview = null; tmpState.LastResult = null; tmpState.LastError = ''; this._comprehension = null; this._pushContext = null;
	}

	// ── Schema + source loading ───────────────────────────────────────────────────
	/** Fetch the four live schemas once (parallel), map to the dataimport shape, cache. */
	ensureSchemas()
	{
		if (this._schemaCache) { return Promise.resolve(this._schemaCache); }
		const tmpRestClient = this.restClient;
		if (!tmpRestClient) { return Promise.reject(new Error('HeadlightRestClient is not available for the schema read.')); }
		return Promise.all(libModel.ENTITY_ORDER.map((pEntity) => new Promise((resolve, reject) =>
		{
			tmpRestClient.getJSON(`${pEntity}/Schema`, (pError, pBody) =>
			{
				if (pError) { return reject(pError); }
				const tmpMapped = libSchema.mapEntitySchema(pEntity, pBody);
				resolve(tmpMapped.Entities[0]);
			});
		}))).then((pEntities) =>
		{
			this._schemaCache = {};
			pEntities.forEach((pEntity) => { this._schemaCache[pEntity.Entity] = pEntity; });
			return this._schemaCache;
		});
	}

	/** Load the Contract picker options (active contracts) for the add-to-existing mode. */
	_loadContracts()
	{
		const tmpRestClient = this.restClient;
		if (!tmpRestClient) { return; }
		// Lite list of active contracts; Name + PrimaryProjectNumber label the option, GUID/key anchors the GUID.
		tmpRestClient.getJSON('Contracts/FilteredTo/FBV~Deleted~EQ~0/0/200', (pError, pBody) =>
		{
			const tmpState = this._ensureState();
			if (pError || !Array.isArray(pBody)) { tmpState.ContractOptions = []; this._render(); return; }
			tmpState.ContractOptions = pBody.map((pContract) => (
				{
					IDContract: pContract.IDContract,
					Key: pContract.PrimaryProjectNumber || pContract.Name || String(pContract.IDContract),
					Label: `${pContract.Name || 'Contract'} (${pContract.PrimaryProjectNumber || pContract.IDContract})`,
				}));
			this._render();
		}, 0, 200);
	}

	/** Load the Project picker options for the chosen Contract (optional — pick to import only below Project). */
	_loadProjects(pIDContract)
	{
		const tmpRestClient = this.restClient;
		const tmpState = this._ensureState();
		if (!tmpRestClient || !pIDContract) { tmpState.ProjectOptions = []; return; }
		tmpRestClient.getJSON(`Projects/FilteredTo/FBV~IDContract~EQ~${pIDContract}/0/200`, (pError, pBody) =>
		{
			if (pError || !Array.isArray(pBody)) { tmpState.ProjectOptions = []; this._render(); return; }
			tmpState.ProjectOptions = pBody.map((pProject) => (
				{
					IDProject: pProject.IDProject,
					Key: pProject.Name || String(pProject.IDProject),
					Label: pProject.Name || `Project ${pProject.IDProject}`,
				}));
			this._render();
		}, 0, 200);
	}

	/**
	 * A parser-ready file handle arrived from a pict-section-upload drop zone (getText/getArrayBuffer). Parse
	 * it into the right slot for the current source shape. Slot is 'sheet' (giant / workbook) or an entity.
	 * @param {Record<string,any>} pHandle @param {string} pSlot
	 */
	onFileReady(pHandle, pSlot)
	{
		if (!pHandle) { return; }
		const tmpState = this._ensureState();
		tmpState.LastError = '';

		this.ensureSchemas().then(() =>
		{
			if (tmpState.SourceShape === SOURCE_SHAPES.FILES) { return this._loadEntityFile(pSlot, pHandle); }
			// sheet / workbook: adapt to the file — any Excel auto-detects single-sheet vs a tab-per-level.
			if (this._isExcel(pHandle)) { return this._loadWorkbook(pHandle); }
			return this._loadSheet(pHandle); // a CSV in the single-file shapes is one giant sheet
		}).then(() => { this._render(); }).catch((pError) => this._onError(pError));
	}

	/** A file was removed from a drop zone — drop that slot's parsed data. */
	onFileRemoved(pSlot)
	{
		const tmpState = this._ensureState();
		if (pSlot === 'sheet') { tmpState.Columns = []; tmpState.SampleRows = []; delete tmpState.PerEntityRows.__sheet; }
		else { delete tmpState.PerEntityColumns[pSlot]; delete tmpState.PerEntityRows[pSlot]; }
		tmpState.RowsLoaded = Object.keys(tmpState.PerEntityRows).reduce((pSum, pKey) => pSum + (tmpState.PerEntityRows[pKey] || []).length, 0);
		this._resetBuild();
		this._render();
	}

	/** Giant sheet: parse one file into a shared rows + columns set that feeds all four levels. */
	_loadSheet(pFile)
	{
		const tmpParser = this._parserForFile(pFile);
		const tmpState = this._ensureState();
		return Promise.all([ tmpParser.detect(pFile, {}), tmpParser.parse(pFile, {}) ]).then((pResults) =>
		{
			tmpState.PerEntityColumns = {};   // a giant sheet shares ONE column set across all levels
			tmpState.WorkbookTabs = []; tmpState.TabAssignments = {};   // not a per-tab workbook
			tmpState.Columns = (pResults[0].Columns || []).map((pColumn) => pColumn.SourceName || pColumn.Name || pColumn);
			tmpState.SampleRows = pResults[0].SampleRows || [];
			tmpState.PerEntityRows = { __sheet: pResults[1] || [] };
			tmpState.RowsLoaded = (pResults[1] || []).length;
			tmpState.SourceNote = `Loaded a single sheet — ${(pResults[1] || []).length} rows feed all four levels.`;
			this._seedDefaults();
		});
	}

	/**
	 * Excel: adapt to the file. A single-sheet workbook is a giant denormalized sheet (→ _loadSheet). A
	 * multi-tab workbook is per-level: best-guess each level's tab by name, parse the guessed tabs, and keep
	 * the tab list + handle so the user can reassign any level's tab in the map step (re-parsing on change).
	 */
	_loadWorkbook(pFile)
	{
		const tmpXlsx = this._xlsxParser();
		const tmpState = this._ensureState();
		if (!tmpXlsx || (typeof tmpXlsx.listSheetNames !== 'function')) { return this._loadSheet(pFile); }
		return tmpXlsx.listSheetNames(pFile).then((pSheetNames) =>
		{
			const tmpTabs = (pSheetNames || []).filter((pTab) => !!pTab);
			if (tmpTabs.length <= 1) { return this._loadSheet(pFile); }   // a single sheet is a giant sheet

			// Multi-tab: per-level. Keep the handle + tabs so the user can reassign; best-guess each level.
			this._workbookHandle = pFile;
			tmpState.WorkbookTabs = tmpTabs;
			tmpState.Columns = []; tmpState.SampleRows = []; delete tmpState.PerEntityRows.__sheet;
			tmpState.PerEntityColumns = {}; tmpState.PerEntityRows = {}; tmpState.TabAssignments = {};
			libModel.ENTITY_ORDER.forEach((pEntity) => { tmpState.TabAssignments[pEntity] = this._matchTab(pEntity, tmpTabs); });

			return Promise.all(libModel.ENTITY_ORDER
				.filter((pEntity) => tmpState.TabAssignments[pEntity])
				.map((pEntity) => this._parseTabInto(pEntity, tmpState.TabAssignments[pEntity])))
				.then(() =>
				{
					tmpState.RowsLoaded = Object.keys(tmpState.PerEntityRows).reduce((pSum, pKey) => pSum + (tmpState.PerEntityRows[pKey] || []).length, 0);
					const tmpMatched = libModel.ENTITY_ORDER.filter((pE) => tmpState.TabAssignments[pE]).length;
					tmpState.SourceNote = `Multi-tab workbook — ${tmpTabs.length} tabs, ${tmpMatched} auto-matched to levels. Set each level's sheet below.`;
					this._seedDefaults();
				});
		});
	}

	/** Parse a specific workbook tab into a level's dataset (on load + when the user reassigns a tab). */
	_parseTabInto(pEntity, pTab)
	{
		const tmpXlsx = this._xlsxParser();
		const tmpState = this._ensureState();
		return Promise.all([ tmpXlsx.detect(this._workbookHandle, { Xlsx: { SheetName: pTab } }), tmpXlsx.parse(this._workbookHandle, { Xlsx: { SheetName: pTab } }) ]).then((pResults) =>
		{
			tmpState.PerEntityColumns[pEntity] = (pResults[0].Columns || []).map((pColumn) => pColumn.SourceName || pColumn.Name || pColumn);
			tmpState.PerEntityRows[pEntity] = pResults[1] || [];
		});
	}

	/** Reassign which workbook tab feeds a level (multi-tab workbook), re-parsing that tab. */
	setTab(pEntity, pTab)
	{
		const tmpState = this._ensureState();
		if (!tmpState.WorkbookTabs || !this._workbookHandle) { return; }
		tmpState.TabAssignments[pEntity] = pTab || '';
		// The tab's columns change, so this level's seeded key + field mappings are stale — reseed them.
		delete tmpState.KeyColumns[pEntity];
		delete tmpState.FieldAssignments[pEntity];
		this._resetBuild();
		const fDone = () =>
		{
			tmpState.RowsLoaded = Object.keys(tmpState.PerEntityRows).reduce((pSum, pKey) => pSum + (tmpState.PerEntityRows[pKey] || []).length, 0);
			this._seedDefaults();
			this._render();
		};
		if (pTab) { this._parseTabInto(pEntity, pTab).then(fDone).catch((pError) => this._onError(pError)); }
		else { delete tmpState.PerEntityColumns[pEntity]; delete tmpState.PerEntityRows[pEntity]; fDone(); }
	}

	/** Files shape: parse one file into a single level's dataset. */
	_loadEntityFile(pEntity, pFile)
	{
		const tmpParser = this._parserForFile(pFile);
		const tmpState = this._ensureState();
		return Promise.all([ tmpParser.detect(pFile, {}), tmpParser.parse(pFile, {}) ]).then((pResults) =>
		{
			tmpState.PerEntityColumns[pEntity] = (pResults[0].Columns || []).map((pColumn) => pColumn.SourceName || pColumn.Name || pColumn);
			tmpState.PerEntityRows[pEntity] = pResults[1] || [];
			tmpState.RowsLoaded = Object.keys(tmpState.PerEntityRows).reduce((pSum, pKey) => pSum + (tmpState.PerEntityRows[pKey] || []).length, 0);
			this._seedDefaults();
		});
	}

	/** Fuzzy-match a workbook tab name to an entity (Contract/Project/BidItem/LineItem). */
	_matchTab(pEntity, pTabs)
	{
		const tmpLower = String(pEntity).toLowerCase();
		const tmpAlt = tmpLower.replace('item', ' item');
		return (pTabs || []).find((pTab) =>
		{
			const tmpTab = String(pTab).toLowerCase().replace(/[^a-z]/g, '');
			return (tmpTab.indexOf(tmpLower) > -1) || (tmpTab.indexOf(tmpAlt.replace(/\s/g, '')) > -1);
		}) || '';
	}

	/** After a source loads, seed key columns + obvious field mappings by name match (user can override). */
	_seedDefaults()
	{
		const tmpState = this._ensureState();
		libModel.PACKAGE_ENTITIES.forEach((pLevel) =>
		{
			const tmpColumns = this._columnsFor(pLevel.Entity);
			if (!tmpState.KeyColumns[pLevel.Entity])
			{
				// Default key column: an exact DefaultKeyColumns match, else a fuzzy KeyHints match against
				// realistic headers ("Contract Number", "Project Name", …), else the first column.
				const tmpNorm = (pName) => String(pName).toLowerCase().replace(/[^a-z0-9]/g, '');
				let tmpKey = pLevel.DefaultKeyColumns.find((pColumn) => tmpColumns.indexOf(pColumn) > -1);
				if (!tmpKey)
				{
					(pLevel.KeyHints || []).some((pHint) =>
					{
						const tmpMatch = tmpColumns.find((pColumn) => tmpNorm(pColumn).indexOf(pHint) > -1);
						if (tmpMatch) { tmpKey = tmpMatch; return true; }
						return false;
					});
				}
				tmpKey = tmpKey || tmpColumns[0] || '';
				if (tmpKey) { tmpState.KeyColumns[pLevel.Entity] = tmpKey; }
			}
			// Auto-map source columns to fields: exact schema name, OR the friendly label ("Cost / Unit" ->
			// CostPerUnit) so a template's human headers land pre-mapped.
			const tmpSchemaEntity = this._schemaEntity(pLevel.Entity);
			if (tmpSchemaEntity)
			{
				if (!tmpState.FieldAssignments[pLevel.Entity]) { tmpState.FieldAssignments[pLevel.Entity] = {}; }
				const tmpFieldNames = {};
				(tmpSchemaEntity.Fields || []).forEach((pField) => { tmpFieldNames[pField.Name] = true; });
				tmpColumns.forEach((pColumn) =>
				{
					const tmpFieldKey = tmpFieldNames[pColumn] ? pColumn : libLayouts.keyForHeader(pLevel.Entity, pColumn);
					if (tmpFieldKey && tmpFieldNames[tmpFieldKey] && !tmpState.FieldAssignments[pLevel.Entity][tmpFieldKey])
					{
						tmpState.FieldAssignments[pLevel.Entity][tmpFieldKey] = pColumn;
					}
				});
			}
		});

		// Items flow: best-guess which column identifies each row's existing Contract / Project.
		if (tmpState.Flow === 'items')
		{
			const tmpColumns = this._columnsFor('BidItem');
			const tmpNorm = (pName) => String(pName).toLowerCase().replace(/[^a-z0-9]/g, '');
			const fSeed = (pCurrent, pHints) =>
			{
				if (pCurrent) { return pCurrent; }
				let tmpMatch = '';
				pHints.some((pHint) => { const tmpCol = tmpColumns.find((pColumn) => tmpNorm(pColumn).indexOf(pHint) > -1); if (tmpCol) { tmpMatch = tmpCol; return true; } return false; });
				return tmpMatch;
			};
			tmpState.ContractKeyColumn = fSeed(tmpState.ContractKeyColumn, [ 'contractnumber', 'contractno', 'contractid', 'contract' ]);
			tmpState.ProjectKeyColumn = fSeed(tmpState.ProjectKeyColumn, [ 'projectname', 'projectnumber', 'projectid', 'project' ]);
		}
	}

	// ── Build + push ──────────────────────────────────────────────────────────────
	/** Build the comprehension from the current plan + source, computing per-level counts + validation. */
	buildPreview()
	{
		const tmpState = this._ensureState();
		if (tmpState.Flow === 'items') { return this._buildItemsPreview(); }
		try { this._composeAndPreview(this._plan(), null); }
		catch (pError) { tmpState.Preview = null; tmpState.LastError = (pError && pError.message) ? pError.message : String(pError); this._render(); }
	}

	/** Items flow: resolve each row's existing Contract + Project by key column, then build from resolved rows. */
	_buildItemsPreview()
	{
		const tmpState = this._ensureState();
		if (!tmpState.ContractKeyColumn || !tmpState.ProjectKeyColumn)
		{
			tmpState.Preview = null; tmpState.LastError = 'Choose which columns identify the Contract and Project first.'; this._render(); return;
		}
		const tmpRows = tmpState.PerEntityRows.__sheet || [];
		if (tmpRows.length === 0) { tmpState.Preview = null; tmpState.LastError = 'Upload a file with Bid Item / Line Item rows first.'; this._render(); return; }
		tmpState.Busy = true; tmpState.LastError = ''; this._render();
		this._resolveParents(tmpRows).then((pResolution) =>
		{
			tmpState.Busy = false;
			try
			{
				this._composeAndPreview(this._plan(), pResolution.ResolvedRows);
				if (pResolution.UnresolvedCount > 0)
				{
					tmpState.Warnings = (tmpState.Warnings || []).concat(
						`${pResolution.UnresolvedCount} row(s) skipped — no matching Contract/Project${pResolution.Samples.length ? ` (e.g. ${pResolution.Samples.join('; ')})` : ''}.`);
					this._render();
				}
			}
			catch (pError) { tmpState.Preview = null; tmpState.LastError = (pError && pError.message) ? pError.message : String(pError); this._render(); }
		}).catch((pError) => { tmpState.Busy = false; this._onError(pError); });
	}

	/** Compose strategy + mapping + comprehension for a plan; optionally from explicit sheet rows (items flow). */
	_composeAndPreview(pPlan, pSheetRowsOverride)
	{
		const tmpState = this._ensureState();
		if (pPlan.Order.length === 0) { throw new Error('No levels selected to create.'); }

		const tmpStrategyConfig = libModel.buildStrategyConfig(pPlan);
		const tmpMapping = libModel.buildMapping(pPlan, tmpState.FieldAssignments);
		const tmpSchema = { Order: libModel.ENTITY_ORDER, Entities: libModel.ENTITY_ORDER.map((pEntity) => this._schemaEntity(pEntity)).filter(Boolean) };
		libStrategyApply.applyStrategy(tmpMapping, tmpStrategyConfig, libModel.contextCatalog(), tmpSchema);

		const tmpBuilder = new libComprehensionBuilder(this.pict);
		const tmpComprehension = {};
		const tmpReport = { EntityCounts: {}, BadRecords: [] };

		// One shared dataset (giant / single-sheet workbook / items-flow resolved rows) vs per-entity datasets.
		if (pSheetRowsOverride || tmpState.PerEntityRows.__sheet)
		{
			const tmpRows = libModel.injectConstantColumns(pSheetRowsOverride || tmpState.PerEntityRows.__sheet || [], pPlan);
			const tmpResult = tmpBuilder.build(tmpMapping, tmpRows);
			Object.assign(tmpComprehension, tmpResult.Comprehension);
			Object.assign(tmpReport.EntityCounts, tmpResult.Report.EntityCounts);
			tmpReport.BadRecords = tmpResult.Report.BadRecords;
		}
		else
		{
			pPlan.Order.forEach((pEntity) =>
			{
				const tmpEntityRows = libModel.injectConstantColumns(tmpState.PerEntityRows[pEntity] || [], pPlan);
				const tmpMini = { Order: [ pEntity ], Entities: {} };
				tmpMini.Entities[pEntity] = tmpMapping.Entities[pEntity];
				const tmpResult = tmpBuilder.build(tmpMini, tmpEntityRows);
				tmpComprehension[pEntity] = tmpResult.Comprehension[pEntity] || {};
				tmpReport.EntityCounts[pEntity] = Object.keys(tmpComprehension[pEntity]).length;
				tmpReport.BadRecords = tmpReport.BadRecords.concat(tmpResult.Report.BadRecords || []);
			});
		}

		const tmpSizes = {};
		libModel.ENTITY_ORDER.forEach((pEntity) =>
		{
			const tmpGUIDField = (this._schemaEntity(pEntity) && (this._schemaEntity(pEntity).Fields || []).find((pField) => pField.IsGUID));
			if (tmpGUIDField && tmpGUIDField.Size) { tmpSizes[pEntity] = tmpGUIDField.Size; }
		});
		this._comprehension = tmpComprehension;
		this._pushContext = libModel.buildPushContext(pPlan, tmpSizes);

		tmpState.Warnings = this._collectWarnings(pPlan, tmpMapping, tmpReport);
		tmpState.Preview =
		{
			Counts: pPlan.Order.map((pEntity) => (
				{ Entity: pEntity, Label: libModel.findLevel(pEntity).Label, Count: (tmpReport.EntityCounts[pEntity] || 0) })),
			BadCount: (tmpReport.BadRecords || []).length,
			Summary: pPlan.Order.map((pEntity) => `${tmpReport.EntityCounts[pEntity] || 0} ${libModel.findLevel(pEntity).Label}${(tmpReport.EntityCounts[pEntity] === 1) ? '' : 's'}`).join(' · '),
		};
		tmpState.LastError = '';
		this._render();
	}

	/**
	 * Resolve each row's existing Contract + Project by the chosen key columns, injecting `__PKG_IDContract`
	 * / `__PKG_IDProject`. Rows whose Contract or Project don't match are dropped (and counted).
	 * @param {Array<Record<string,any>>} pRows
	 * @returns {Promise<{ResolvedRows:Array<object>, UnresolvedCount:number, Samples:Array<string>}>}
	 */
	_resolveParents(pRows)
	{
		const tmpState = this._ensureState();
		const tmpContractCol = tmpState.ContractKeyColumn;
		const tmpProjectCol = tmpState.ProjectKeyColumn;
		const tmpKey = (pVal) => String(pVal == null ? '' : pVal).trim().toLowerCase();

		return this._fetchContractsMap().then((pContractMap) =>
		{
			// Which contracts are actually referenced → fetch just those contracts' projects.
			const tmpNeeded = {};
			pRows.forEach((pRow) => { const tmpID = pContractMap[tmpKey(pRow[tmpContractCol])]; if (tmpID) { tmpNeeded[tmpID] = true; } });
			return this._fetchProjectsMap(Object.keys(tmpNeeded)).then((pProjectMap) =>
			{
				let tmpUnresolved = 0;
				const tmpSamples = [];
				const tmpResolved = [];
				pRows.forEach((pRow) =>
				{
					const tmpIDContract = pContractMap[tmpKey(pRow[tmpContractCol])];
					const tmpIDProject = tmpIDContract ? pProjectMap[`${tmpIDContract}|${tmpKey(pRow[tmpProjectCol])}`] : undefined;
					if (!tmpIDContract || !tmpIDProject)
					{
						tmpUnresolved++;
						if (tmpSamples.length < 4) { tmpSamples.push(`${pRow[tmpContractCol] || '?'} / ${pRow[tmpProjectCol] || '?'}`); }
						return;
					}
					const tmpRow = Object.assign({}, pRow);
					tmpRow[libModel.resolvedIDColumn('Contract')] = String(tmpIDContract);
					tmpRow[libModel.resolvedIDColumn('Project')] = String(tmpIDProject);
					tmpResolved.push(tmpRow);
				});
				return { ResolvedRows: tmpResolved, UnresolvedCount: tmpUnresolved, Samples: tmpSamples };
			});
		});
	}

	/**
	 * Read an ENTIRE filtered set by paging to exhaustion (begin/count until a short page). Row-resolution maps must be
	 * complete or import rows silently vanish — the old single `/0/2000` (contracts) and `/0/500` (projects) fetches
	 * dropped every row that referenced a parent past the cap. A one-time import can afford the extra pages.
	 */
	_fetchAllRows(pEntitySet, pFilter)
	{
		const tmpRestClient = this.restClient;
		const tmpPageSize = 2000;
		return new Promise((resolve) =>
		{
			if (!tmpRestClient) { return resolve([]); }
			const tmpAll = [];
			const fPage = (pBegin) =>
			{
				tmpRestClient.getJSON(`${pEntitySet}/FilteredTo/${pFilter}/${pBegin}/${tmpPageSize}`, (pError, pBody) =>
				{
					if (pError || !Array.isArray(pBody) || (pBody.length === 0)) { return resolve(tmpAll); }
					tmpAll.push(...pBody);
					if (pBody.length < tmpPageSize) { return resolve(tmpAll); }   // last (short) page
					fPage(pBegin + tmpPageSize);
				}, pBegin, tmpPageSize);
			};
			fPage(0);
		});
	}

	/** Fetch active contracts → { <natural key lowercased>: IDContract } (matched on any project number or name). */
	_fetchContractsMap()
	{
		return this._fetchAllRows('Contracts', 'FBV~Deleted~EQ~0').then((pRows) =>
		{
			const tmpMap = {};
			pRows.forEach((pContract) =>
			{
				[ pContract.PrimaryProjectNumber, pContract.CountyProjectNumber, pContract.StateProjectNumber, pContract.FederalProjectNumber, pContract.ExternalContractID, pContract.Name ]
					.forEach((pK) => { if (pK != null && String(pK).trim() !== '') { tmpMap[String(pK).trim().toLowerCase()] = pContract.IDContract; } });
			});
			return tmpMap;
		});
	}

	/** Fetch projects for the given contracts → { `<IDContract>|<name lowercased>`: IDProject }. */
	_fetchProjectsMap(pContractIDs)
	{
		const tmpMap = {};
		if (!this.restClient || !pContractIDs.length) { return Promise.resolve(tmpMap); }
		return pContractIDs.reduce((pPromise, pIDContract) => pPromise.then(() => this._fetchAllRows('Projects', `FBV~IDContract~EQ~${pIDContract}`).then((pRows) =>
		{
			pRows.forEach((pProject) =>
			{
				[ pProject.Name, pProject.ExternalProjectID, pProject.PurchaseOrderNumber ]
					.forEach((pK) => { if (pK != null && String(pK).trim() !== '') { tmpMap[`${pIDContract}|${String(pK).trim().toLowerCase()}`] = pProject.IDProject; } });
			});
		})), Promise.resolve()).then(() => tmpMap);
	}

	/** Gather human-readable warnings (missing keys, empty levels, unmapped required fields). */
	_collectWarnings(pPlan, pMapping, pReport)
	{
		const tmpState = this._ensureState();
		const tmpWarnings = [];
		pPlan.Order.forEach((pEntity) =>
		{
			if (!tmpState.KeyColumns[pEntity]) { tmpWarnings.push(`${libModel.findLevel(pEntity).Label} has no key column — re-imports may duplicate.`); }
			if ((pReport.EntityCounts[pEntity] || 0) === 0) { tmpWarnings.push(`No ${libModel.findLevel(pEntity).Label} records were produced — check the source column that keys it.`); }
		});
		if ((pReport.BadRecords || []).length > 0) { tmpWarnings.push(`${pReport.BadRecords.length} row(s) produced no valid GUID and were skipped.`); }
		return tmpWarnings;
	}

	/** Push the built comprehension via the shared ordered multi-entity push. */
	runImport()
	{
		const tmpState = this._ensureState();
		if (!this._comprehension || !this._pushContext)
		{
			this.buildPreview();
			// The items-flow preview is async (parent resolution), so it isn't ready yet — the user reviews
			// the resolved counts + skipped rows, then clicks Import again.
			if (tmpState.Flow === 'items' || !this._comprehension) { return; }
		}
		if (!this._comprehension || tmpState.LastError) { return; }
		const tmpManager = this.dataImportManager;
		if (!tmpManager || (typeof tmpManager._pushViaHeadlight !== 'function'))
		{
			return this._onError(new Error('The import push seam is unavailable.'));
		}
		tmpState.Busy = true; tmpState.LastResult = null; tmpState.LastError = ''; this._render();

		tmpManager._pushViaHeadlight(this._comprehension, this._pushContext).then((pResult) =>
		{
			tmpState.Busy = false;
			const tmpIsItems = (tmpState.Flow === 'items');
			const tmpMessage = (pResult && pResult.Message) ? pResult.Message : (tmpIsItems ? 'Line items imported.' : 'Contract package imported.');
			tmpState.LastResult = tmpIsItems
				? { Message: tmpMessage, ViewRoute: '#/PSRS/LineItem/List', ViewLabel: 'View line items' }
				: { Message: tmpMessage, ViewRoute: '#/PSRS/Contract/List', ViewLabel: 'View contracts' };
			if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(tmpMessage, { type: 'success' }); }
			this._render();
		}).catch((pError) => { tmpState.Busy = false; this._onError(pError); });
	}

	_onError(pError)
	{
		const tmpState = this._ensureState();
		const tmpMessage = (pError && pError.message) ? pError.message : String(pError || 'Import failed.');
		tmpState.LastError = tmpMessage;
		if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(tmpMessage, { type: 'error', duration: 6000 }); }
		this._render();
	}

	_render()
	{
		if (this.pict.views['ContractPackageImport']) { this.pict.views['ContractPackageImport'].render(); }
	}

	/**
	 * Download the styled Contract Package Excel template (Read Me + a tab per level). The bytes are
	 * embedded in the bundle (data-import/ContractPackage-Template-Data.js) and handed to the browser via a
	 * Blob, so the template ships INSIDE the app and downloads with zero dependency on the server serving
	 * /assets/ — which is why the old `<a href="assets/…">` link was showing as "unavailable". Invoked from
	 * the step-1 scope card link. Uses the standard client-side Blob-download idiom.
	 */
	downloadTemplate()
	{
		if ((typeof document === 'undefined') || (typeof Blob === 'undefined') || (typeof URL === 'undefined'))
		{
			return;
		}
		try
		{
			// base64 → bytes (atob in the browser; Buffer only as a non-browser safety net for tests).
			const tmpBinary = (typeof atob === 'function')
				? atob(libTemplateData.Base64)
				: Buffer.from(libTemplateData.Base64, 'base64').toString('binary');
			const tmpBytes = new Uint8Array(tmpBinary.length);
			for (let i = 0; i < tmpBinary.length; i++) { tmpBytes[i] = tmpBinary.charCodeAt(i); }

			const tmpBlob = new Blob([ tmpBytes ], { type: libTemplateData.MimeType });
			const tmpURL = URL.createObjectURL(tmpBlob);
			const tmpLink = document.createElement('a');
			tmpLink.href = tmpURL;
			tmpLink.download = libTemplateData.FileName;
			document.body.appendChild(tmpLink);
			tmpLink.click();
			document.body.removeChild(tmpLink);
			URL.revokeObjectURL(tmpURL);
		}
		catch (pError)
		{
			if (this.pict && this.pict.log) { this.pict.log.error(`Contract Package template download failed: ${pError.message || pError}`); }
			if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast('Could not open the Excel template.', { type: 'error' }); }
		}
	}
}

module.exports = ContractPackageImportManagerProvider;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;
module.exports.SOURCE_SHAPES = SOURCE_SHAPES;

}).call(this)}).call(this,require("buffer").Buffer)

},{"../data-import/ContractPackage-FieldLayouts.js":1089,"../data-import/ContractPackage-Model.js":1090,"../data-import/ContractPackage-Template-Data.js":1091,"../data-import/DataImport-Schema.js":1092,"../services/Entity-Picker-Search.js":1398,"buffer":364,"pict-provider":845,"pict-section-accordion":553,"pict-section-dataimport/source/seams/DataImport-Parser-Delimited.js":569,"pict-section-dataimport/source/services/DataImport-ComprehensionBuilder.js":576,"pict-section-dataimport/source/services/DataImport-GuidStrategyApply.js":577,"pict-section-upload":721}],1318:[function(require,module,exports){
/**
 * ContractProjectTypesImportProvider
 *
 * Parses a spreadsheet upload (CSV / TSV / XLSX) describing ContractType or
 * ProjectType rows and routes each through the shared TypeComprehensionSaveProvider
 * — the exact same canonical type-save the editor uses — so an imported type gets
 * its prototype, default-date definitions, and ListDefault statuses just like one
 * created in the editor. The companion UI button in the Configuration App calls
 * `importSpreadsheetFile` with the picked File, or `importCsvText` /
 * `importMappedRows` directly when the caller already has parsed content.
 *
 * Recognized platform fields (header names — case-sensitive):
 *   Name, Hash, Description, Ordinal,
 *   AvailableStatusList, StatusesRequiringChangeOrder,
 *   AllowedProjectTypeIDs, DefaultDates
 *
 * List-shaped columns (AvailableStatusList,
 * StatusesRequiringChangeOrder, AllowedProjectTypeIDs) accept
 * pipe-delimited values: "Draft|Active|Closed". AllowedProjectTypeIDs accepts
 * readable ProjectType Hashes ("ROADWAY|BRIDGE") or numeric IDs; the save
 * provider resolves either to the ProjectType id it stores. DefaultDates accepts
 * pipe-delimited "Hash:Name" pairs: "NTP:Notice to Proceed|SUBCMP:Substantial Completion".
 *
 * CSV escaping follows the RFC 4180 subset commonly seen in agency
 * spreadsheets: commas allowed inside double-quoted fields, doubled quotes
 * escape a literal quote inside a quoted field.
 *
 * XLSX support uses the bundled `xlsx` (SheetJS) library. Note: the npm
 * package is unmaintained (CVE-2024-22363 — prototype pollution in parsing);
 * the maintained release is on https://cdn.sheetjs.com/. For our Configuration
 * App admin-only upload flow the risk surface is the same user's own data,
 * but it's worth tracking the CDN migration as a follow-up.
 */

const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
 * Resolve the xlsx (SheetJS) module at use-time. In the browser the library is
 * loaded via a separate `<script src="js/xlsx.full.min.js">` tag (see
 * `html/index.html`) so it lives on `window.XLSX`. In Node (unit tests) we
 * fall through to a plain `require('xlsx')`. Browserify is configured to
 * ignore the bare `require('xlsx')` call (see `.gulpfile-quackage-config.json`
 * `BrowserifyIgnore`), so the main app bundle stays small and free of the
 * Node-only paths inside the npm xlsx@0.18.5 package that previously broke
 * the top-level module evaluation.
 *
 * @returns {any | null} the xlsx module, or null when neither path is available
 */
function _getXlsx()
{
	if (typeof window !== 'undefined' && window.XLSX)
	{
		return window.XLSX;
	}
	try
	{
		// eslint-disable-next-line global-require
		return require('xlsx');
	}
	catch (pError)
	{
		return null;
	}
}

// List columns become text on `_DisplaySettings` (the editor's display shape) so the
// imported record runs through the exact same type-save path as the editor. Status
// lists are newline-joined (TextArea form); AllowedProjectTypeIDs is comma-joined
// (multi-select form). The save provider's fromDisplay() then normalizes them.
const STATUS_LIST_KEYS = new Set([
	'AvailableStatusList',
	'StatusesRequiringChangeOrder',
]);
const CSV_LIST_KEYS = new Set([
	'AllowedProjectTypeIDs',
]);
const TOP_LEVEL_KEYS = new Set([ 'Name', 'Hash', 'Description', 'Ordinal' ]);

/**
 * Split a single CSV/TSV line into fields, honoring double-quoted
 * sub-strings (with "" → " escape).
 *
 * @param {string} pLine
 * @param {string} pDelimiter
 * @returns {Array<string>}
 */
function splitLine(pLine, pDelimiter)
{
	const tmpFields = [];
	let tmpBuffer = '';
	let tmpInQuotes = false;
	for (let i = 0; i < pLine.length; i++)
	{
		const tmpChar = pLine.charAt(i);
		if (tmpInQuotes)
		{
			if (tmpChar === '"')
			{
				if (i + 1 < pLine.length && pLine.charAt(i + 1) === '"')
				{
					tmpBuffer += '"';
					i += 1;
				}
				else
				{
					tmpInQuotes = false;
				}
			}
			else
			{
				tmpBuffer += tmpChar;
			}
		}
		else if (tmpChar === '"')
		{
			tmpInQuotes = true;
		}
		else if (tmpChar === pDelimiter)
		{
			tmpFields.push(tmpBuffer);
			tmpBuffer = '';
		}
		else
		{
			tmpBuffer += tmpChar;
		}
	}
	tmpFields.push(tmpBuffer);
	return tmpFields;
}

/**
 * Parse a pipe-delimited DefaultDates cell into structured records.
 *
 * @param {string} pCell - e.g. "NTP:Notice to Proceed|SUBCMP:Substantial Completion"
 * @returns {Array<{Hash: string, Name: string}>}
 */
function parseDefaultDatesCell(pCell)
{
	if (!pCell || typeof pCell !== 'string')
	{
		return [];
	}
	return pCell.split('|').reduce((pAccum, pEntry) =>
	{
		const tmpTrimmed = pEntry.trim();
		if (!tmpTrimmed)
		{
			return pAccum;
		}
		const tmpColonIdx = tmpTrimmed.indexOf(':');
		if (tmpColonIdx === -1)
		{
			pAccum.push({ Hash: tmpTrimmed, Name: tmpTrimmed });
		}
		else
		{
			pAccum.push({
				Hash: tmpTrimmed.substring(0, tmpColonIdx).trim(),
				Name: tmpTrimmed.substring(tmpColonIdx + 1).trim(),
			});
		}
		return pAccum;
	}, []);
}

/**
 * Parse a CSV/TSV text blob into a `{ headers, rows }` shape where each row
 * is a plain string array aligned to the headers. This is the format the
 * column-mapping UI consumes — no platform-field interpretation happens here.
 *
 * @param {string} pText - Raw file content.
 * @param {{ Delimiter?: string }} [pOptions]
 * @returns {{ headers: Array<string>, rows: Array<Array<string>> }}
 */
function parseCsvTextToRows(pText, pOptions)
{
	if (typeof pText !== 'string' || pText.length === 0)
	{
		return { headers: [], rows: [] };
	}
	const tmpDelimiter = (pOptions && pOptions.Delimiter) || (pText.indexOf('\t') !== -1 && pText.indexOf(',') === -1 ? '\t' : ',');
	const tmpLines = pText.split(/\r?\n/).filter((pLine) => pLine.length > 0);
	if (tmpLines.length < 1)
	{
		return { headers: [], rows: [] };
	}
	const tmpHeaders = splitLine(tmpLines[0], tmpDelimiter).map((pHeader) => pHeader.trim());
	const tmpRows = [];
	for (let i = 1; i < tmpLines.length; i++)
	{
		const tmpFields = splitLine(tmpLines[i], tmpDelimiter);
		const tmpRow = [];
		for (let j = 0; j < tmpHeaders.length; j++)
		{
			tmpRow.push((tmpFields[j] || '').trim());
		}
		tmpRows.push(tmpRow);
	}
	return { headers: tmpHeaders, rows: tmpRows };
}

/**
 * Parse an XLSX ArrayBuffer (first sheet only) into the same `{ headers, rows }`
 * shape `parseCsvTextToRows` returns. Returns an empty result when the xlsx
 * library is not present at runtime (e.g. in a Node-only mocha run that hasn't
 * loaded the bundled module).
 *
 * @param {ArrayBuffer | Uint8Array} pArrayBuffer
 * @returns {{ headers: Array<string>, rows: Array<Array<string>> }}
 */
function parseXlsxBufferToRows(pArrayBuffer)
{
	const tmpXLSX = _getXlsx();
	if (!tmpXLSX || !pArrayBuffer)
	{
		return { headers: [], rows: [] };
	}
	const tmpWorkbook = tmpXLSX.read(pArrayBuffer, { type: 'array' });
	const tmpSheetName = tmpWorkbook.SheetNames[0];
	if (!tmpSheetName)
	{
		return { headers: [], rows: [] };
	}
	const tmpSheet = tmpWorkbook.Sheets[tmpSheetName];
	// `header: 1` gives us arrays-of-arrays — same shape as parseCsvTextToRows.
	// `raw: false` returns strings (numbers come back formatted, dates ISO-ish).
	// `defval: ''` keeps short rows aligned with header length.
	const tmpMatrix = tmpXLSX.utils.sheet_to_json(tmpSheet, { header: 1, raw: false, defval: '' });
	if (!Array.isArray(tmpMatrix) || tmpMatrix.length === 0)
	{
		return { headers: [], rows: [] };
	}
	const tmpHeaders = (tmpMatrix[0] || []).map((pHeader) => String(pHeader == null ? '' : pHeader).trim());
	const tmpRows = [];
	for (let i = 1; i < tmpMatrix.length; i++)
	{
		const tmpRow = [];
		for (let j = 0; j < tmpHeaders.length; j++)
		{
			const tmpCell = tmpMatrix[i] && tmpMatrix[i][j];
			tmpRow.push(String(tmpCell == null ? '' : tmpCell).trim());
		}
		// Skip rows that are entirely blank (Excel often emits trailing empties).
		if (tmpRow.some((pCell) => pCell.length > 0))
		{
			tmpRows.push(tmpRow);
		}
	}
	return { headers: tmpHeaders, rows: tmpRows };
}

/**
 * Marshal one `{ headers, rows }` snapshot through a column-mapping into
 * editor display-shaped records (`{ Name, Hash, Description, Ordinal,
 * _DisplaySettings: {...} }`) — the shape TypeComprehensionSaveProvider consumes.
 * The mapping maps **source header → platform field name**. Source columns mapped
 * to the empty string or to a value not in the recognized platform-field set are
 * skipped, so callers can pass a partial mapping.
 *
 * @param {{ headers: Array<string>, rows: Array<Array<string>> }} pSheet
 * @param {Object<string, string>} [pColumnMapping] - source-header → platform-field. Defaults to identity.
 * @returns {Array<Object>}
 */
function applyMappingToRecords(pSheet, pColumnMapping)
{
	if (!pSheet || !Array.isArray(pSheet.headers) || !Array.isArray(pSheet.rows))
	{
		return [];
	}
	const tmpMapping = pColumnMapping || {};
	const tmpResolvedFields = pSheet.headers.map((pSource) =>
	{
		// Empty / explicitly-null mapping value → skip this column.
		// Missing mapping entry → identity (source header is the platform field).
		const tmpExplicit = Object.prototype.hasOwnProperty.call(tmpMapping, pSource) ? tmpMapping[pSource] : pSource;
		if (typeof tmpExplicit !== 'string' || tmpExplicit.length === 0)
		{
			return null;
		}
		return tmpExplicit;
	});
	const tmpRecords = [];
	for (const tmpRow of pSheet.rows)
	{
		const tmpRecord = {};
		const tmpDisplay = {};
		let tmpHasDisplay = false;
		for (let j = 0; j < tmpResolvedFields.length; j++)
		{
			const tmpField = tmpResolvedFields[j];
			if (!tmpField)
			{
				continue;
			}
			const tmpRaw = (tmpRow[j] == null ? '' : String(tmpRow[j])).trim();
			if (tmpRaw === '')
			{
				continue;
			}
			if (TOP_LEVEL_KEYS.has(tmpField))
			{
				tmpRecord[tmpField] = tmpField === 'Ordinal' ? Number(tmpRaw) : tmpRaw;
			}
			else if (STATUS_LIST_KEYS.has(tmpField))
			{
				// Status lists are comma-joined: the editor's status fields are Select2Multiple
				// (CSV) and the save path's statusDisplayToPayload() splits them with csvToList()
				// on commas. Joining with anything else (e.g. newlines) leaves the whole list as
				// one lumped status on the /Statuses endpoint.
				tmpDisplay[tmpField] = tmpRaw.split('|').map((pPart) => pPart.trim()).filter((pPart) => pPart.length > 0).join(',');
				tmpHasDisplay = true;
			}
			else if (CSV_LIST_KEYS.has(tmpField))
			{
				// Comma-separated text for the multi-select display form.
				tmpDisplay[tmpField] = tmpRaw.split('|').map((pPart) => pPart.trim()).filter((pPart) => pPart.length > 0).join(',');
				tmpHasDisplay = true;
			}
			else if (tmpField === 'DefaultDates')
			{
				tmpDisplay.DefaultDates = parseDefaultDatesCell(tmpRaw);
				tmpHasDisplay = true;
			}
		}
		if (tmpHasDisplay)
		{
			tmpRecord._DisplaySettings = tmpDisplay;
		}
		if (tmpRecord.Name || tmpRecord.Hash)
		{
			tmpRecords.push(tmpRecord);
		}
	}
	return tmpRecords;
}

/**
 * The set of platform field names the import knows how to interpret. The
 * column-mapping UI uses this as its target-field dropdown.
 */
const PLATFORM_FIELD_NAMES = Object.freeze([
	'Name',
	'Hash',
	'Description',
	'Ordinal',
	'AvailableStatusList',
	'StatusesRequiringChangeOrder',
	'AllowedProjectTypeIDs',
	'DefaultDates',
]);

/**
 * The ordered columns for a blank import template, per entity. Each list is the
 * subset of PLATFORM_FIELD_NAMES the corresponding save path actually consumes:
 *   - ProjectType (saveProjectType): no AllowedProjectTypeIDs.
 *   - ContractType (saveContractType): no Ordinal.
 * Both carry DefaultDates. Downloading these as headers gives a user a spreadsheet
 * whose columns the importer recognizes one-for-one (see suggestColumnMapping).
 */
const TEMPLATE_COLUMNS = Object.freeze({
	ProjectType: Object.freeze([
		'Name', 'Hash', 'Description', 'Ordinal',
		'AvailableStatusList', 'StatusesRequiringChangeOrder', 'DefaultDates',
	]),
	ContractType: Object.freeze([
		'Name', 'Hash', 'Description',
		'AvailableStatusList', 'StatusesRequiringChangeOrder', 'AllowedProjectTypeIDs', 'DefaultDates',
	]),
});

/**
 * The ordered template columns for an entity. Unknown entities default to the
 * ProjectType shape.
 *
 * @param {'ContractType' | 'ProjectType'} pEntity
 * @returns {Array<string>}
 */
function templateColumnsForEntity(pEntity)
{
	return (pEntity === 'ContractType') ? TEMPLATE_COLUMNS.ContractType.slice() : TEMPLATE_COLUMNS.ProjectType.slice();
}

/**
 * Per-column guidance shown on the Instructions sheet. Keyed by platform field; the
 * Instructions table is generated from the entity's actual column list so it can never
 * drift from what the importer accepts.
 */
const COLUMN_DOC = Object.freeze({
	Name: { required: 'Required', format: 'Plain text — the display name', example: 'Roadway' },
	Hash: { required: 'Required', format: 'Short stable code; unique within your customer', example: 'ROADWAY' },
	Description: { required: 'Optional', format: 'Plain text', example: 'Road construction projects' },
	Ordinal: { required: 'Optional', format: 'Whole number (sort order)', example: '1' },
	AvailableStatusList: { required: 'Optional', format: 'Status names separated by a pipe "|"', example: 'Draft|Active|Closed' },
	StatusesRequiringChangeOrder: { required: 'Optional', format: 'Subset of Available Statuses, separated by "|"', example: 'Active|Closed' },
	AllowedProjectTypeIDs: { required: 'Optional', format: 'Project Type Hashes (readable codes) or IDs, separated by "|"', example: 'ROADWAY|BRIDGE' },
	DefaultDates: { required: 'Optional', format: '"Code:Label" pairs separated by "|"', example: 'NTP:Notice to Proceed|SUBCMP:Substantial Completion' },
});

/**
 * Build the rows (array-of-arrays) for the Instructions sheet: a short how-to, a
 * per-column reference generated from the entity's columns, and a few notes. Pure —
 * no xlsx dependency — so it is unit-testable on its own.
 *
 * @param {'ContractType' | 'ProjectType'} pEntity
 * @returns {Array<Array<string>>}
 */
function buildTemplateInstructions(pEntity)
{
	const tmpIsContract = (pEntity === 'ContractType');
	const tmpLabel = tmpIsContract ? 'Contract' : 'Project';
	const tmpDataSheet = tmpIsContract ? 'ContractTypes' : 'ProjectTypes';
	const tmpRows = [
		[ `${tmpLabel} Type bulk import — instructions` ],
		[ '' ],
		[ 'How to use' ],
		[ `1. Enter your ${tmpLabel.toLowerCase()} types on the "${tmpDataSheet}" tab — one per row, starting in row 2 (under the headers).` ],
		[ '2. Do not rename, reorder, or delete the column headers in row 1 of that tab.' ],
		[ '3. Leave this Instructions tab as-is — the importer only reads the first tab.' ],
		[ '4. In list columns, separate multiple values with a pipe "|" (not commas).' ],
		[ `5. Save the file, then on the dashboard use the ${tmpLabel} Types card → "Import from Spreadsheet".` ],
		[ '' ],
		[ 'Columns', 'Required', 'Format', 'Example' ],
	];
	for (const tmpColumn of templateColumnsForEntity(pEntity))
	{
		const tmpDoc = COLUMN_DOC[tmpColumn] || { required: 'Optional', format: '', example: '' };
		tmpRows.push([ tmpColumn, tmpDoc.required, tmpDoc.format, tmpDoc.example ]);
	}
	tmpRows.push(
		[ '' ],
		[ 'Notes' ],
		[ '- Hash identifies the type; keep it short, stable, and unique within your customer.' ],
		[ '- "Statuses Requiring Change Order" should use names that also appear in "Available Statuses".' ],
		[ '- Default Dates use "Code:Label" pairs; a value with no colon is used as both the code and the label.' ],
		[ '- Empty optional cells are simply skipped.' ],
		[ '- On upload you get a column-mapping preview, so you can confirm before anything is saved.' ],
	);
	return tmpRows;
}

/**
 * Build the entity's import-template XLSX workbook as bytes ready for a Blob
 * download, or null when the xlsx library is unavailable at runtime (caller should
 * fall back to CSV).
 *
 * The workbook has TWO sheets:
 *   - sheet 0: the data sheet (header row only) — the sheet the user fills and the
 *     importer reads (the importer only ever reads the first sheet), and
 *   - sheet 1: an "Instructions" sheet the importer ignores.
 * The data sheet is kept pristine (just headers) so its integrity as the upload
 * target is never affected by the guidance.
 *
 * @param {'ContractType' | 'ProjectType'} pEntity
 * @returns {Uint8Array | null}
 */
function buildTemplateWorkbookBytes(pEntity)
{
	const tmpXLSX = _getXlsx();
	if (!tmpXLSX)
	{
		return null;
	}
	const tmpColumns = templateColumnsForEntity(pEntity);
	const tmpDataSheetName = (pEntity === 'ContractType') ? 'ContractTypes' : 'ProjectTypes';

	// Sheet 0: the upload target — header row only, with readable column widths.
	const tmpDataSheet = tmpXLSX.utils.aoa_to_sheet([ tmpColumns ]);
	tmpDataSheet['!cols'] = tmpColumns.map((pColumn) => ({ wch: Math.max(16, pColumn.length + 2) }));

	// Sheet 1: instructions (ignored by the importer, which only reads the first sheet).
	const tmpInstructionsSheet = tmpXLSX.utils.aoa_to_sheet(buildTemplateInstructions(pEntity));
	tmpInstructionsSheet['!cols'] = [ { wch: 30 }, { wch: 12 }, { wch: 52 }, { wch: 46 } ];

	const tmpBook = tmpXLSX.utils.book_new();
	// Data sheet is appended first so it is sheet 0 — the workbook opens on it (the sheet
	// to fill) and, critically, the importer only ever reads the first sheet. The
	// Instructions tab sits beside it for reference and is ignored on import.
	tmpXLSX.utils.book_append_sheet(tmpBook, tmpDataSheet, tmpDataSheetName);
	tmpXLSX.utils.book_append_sheet(tmpBook, tmpInstructionsSheet, 'Instructions');

	return tmpXLSX.write(tmpBook, { bookType: 'xlsx', type: 'array' });
}

/**
 * Build an empty (header-row-only) CSV string for the entity's import template.
 * Fallback for when the xlsx runtime is not present.
 *
 * @param {'ContractType' | 'ProjectType'} pEntity
 * @returns {string}
 */
function buildTemplateCsv(pEntity)
{
	return templateColumnsForEntity(pEntity).join(',') + '\r\n';
}

/**
 * Describe the downloadable blank template for an entity: filename, MIME type,
 * and content. Prefers XLSX; falls back to CSV when xlsx is unavailable.
 *
 * @param {'ContractType' | 'ProjectType'} pEntity
 * @returns {{ filename: string, mimeType: string, content: (Uint8Array|string) }}
 */
function buildTemplateDescriptor(pEntity)
{
	const tmpLabel = (pEntity === 'ContractType') ? 'ContractType' : 'ProjectType';
	const tmpBytes = buildTemplateWorkbookBytes(pEntity);
	if (tmpBytes)
	{
		return {
			filename: `${tmpLabel}-Import-Template.xlsx`,
			mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			content: tmpBytes,
		};
	}
	return {
		filename: `${tmpLabel}-Import-Template.csv`,
		mimeType: 'text/csv',
		content: buildTemplateCsv(pEntity),
	};
}

/**
 * Build a default column-mapping by matching source headers against platform
 * field names case-insensitively. Unknown headers map to the empty string
 * (= skip). Drives the auto-population of the mapping UI.
 *
 * @param {Array<string>} pHeaders
 * @returns {Object<string, string>}
 */
function suggestColumnMapping(pHeaders)
{
	const tmpResult = {};
	if (!Array.isArray(pHeaders))
	{
		return tmpResult;
	}
	const tmpLowerCaseMap = {};
	for (const tmpField of PLATFORM_FIELD_NAMES)
	{
		tmpLowerCaseMap[tmpField.toLowerCase()] = tmpField;
	}
	for (const tmpHeader of pHeaders)
	{
		if (typeof tmpHeader !== 'string' || tmpHeader.length === 0)
		{
			continue;
		}
		tmpResult[tmpHeader] = tmpLowerCaseMap[tmpHeader.toLowerCase()] || '';
	}
	return tmpResult;
}

/**
 * Back-compat wrapper. Parse CSV/TSV text into Meadow-shaped records
 * directly — equivalent to `parseCsvTextToRows` + `applyMappingToRecords`
 * with an identity mapping.
 *
 * @param {string} pText
 * @param {{ Delimiter?: string }} [pOptions]
 * @returns {Array<Object>}
 */
function parseCsvText(pText, pOptions)
{
	return applyMappingToRecords(parseCsvTextToRows(pText, pOptions), null);
}

/**
 * Provider class. The static parsers above are exposed for unit tests
 * and don't require a Fable instance.
 */
class ContractProjectTypesImportProvider extends libFableServiceProviderBase
{
	/**
	 * @param {*} pFable - The fable instance.
	 * @param {*} [pOptions] - Provider options.
	 * @param {string} [pServiceHash] - Fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict = this.fable;
		this.serviceType = 'ContractProjectTypesImportProvider';
	}

	/**
	 * @returns {*} the shared TypeComprehensionSaveProvider fable service, or null.
	 */
	get _typeSaveProvider()
	{
		return (this.fable && this.fable.TypeComprehensionSaveProvider)
			|| (this.fable && this.fable.serviceManager && this.fable.serviceManager.instantiateServiceProvider('TypeComprehensionSaveProvider', {}))
			|| null;
	}

	/**
	 * @returns {number} the logged-in user's customer id (stamped onto imported types
	 * so the comprehension's child rows inherit the right customer), or 0 if unknown.
	 */
	get _currentIDCustomer()
	{
		const tmpUser = this.fable && this.fable.AppData && this.fable.AppData.CurrentUser;
		return (tmpUser && (Number(tmpUser.IDCustomer) || Number(tmpUser.CustomerID))) || 0;
	}

	/**
	 * Describe the downloadable blank import template for an entity (filename,
	 * MIME type, content). The dashboard view wraps `content` in a Blob and
	 * triggers the browser download.
	 *
	 * @param {'ContractType' | 'ProjectType'} pEntity
	 * @returns {{ filename: string, mimeType: string, content: (Uint8Array|string) }}
	 */
	buildTemplateDescriptor(pEntity)
	{
		return buildTemplateDescriptor(pEntity);
	}

	/**
	 * Parse CSV/TSV text into records and save them via the canonical type-save.
	 * Kept for back-compat — newer callers should drive the parse/mapping/import via
	 * the staged methods (parseSpreadsheetFile → applyMappingToRecords → import).
	 *
	 * @param {string} pCsvText - The raw upload content.
	 * @param {'ContractType' | 'ProjectType'} pEntity - The target type entity.
	 * @param {(error: Error | null, summary: { Count: number, Records: Array<Object> }) => void} fCallback
	 */
	importCsvText(pCsvText, pEntity, fCallback)
	{
		try
		{
			const tmpRecords = parseCsvText(pCsvText);
			return this._saveRecords(tmpRecords, pEntity, fCallback);
		}
		catch (pError)
		{
			return fCallback(pError, { Count: 0, Records: [] });
		}
	}

	/**
	 * Parse a picked File (CSV / TSV / XLSX) into the `{ headers, rows }`
	 * shape the column-mapping UI consumes. Dispatches on the file extension
	 * — `.xlsx` reads as ArrayBuffer + SheetJS; everything else reads as text
	 * and goes through the CSV parser (which auto-detects tab-delimited).
	 *
	 * @param {File} pFile
	 * @param {(error: Error | null, sheet: { headers: Array<string>, rows: Array<Array<string>> }) => void} fCallback
	 */
	parseSpreadsheetFile(pFile, fCallback)
	{
		if (!pFile || typeof pFile.name !== 'string')
		{
			return fCallback(new Error('No file provided to parseSpreadsheetFile.'), { headers: [], rows: [] });
		}
		const tmpIsXlsx = /\.xlsx$/i.test(pFile.name) ||
			pFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
		const tmpReader = new FileReader();
		tmpReader.onload = (pEvent) =>
		{
			try
			{
				if (tmpIsXlsx)
				{
					const tmpBuffer = pEvent?.target?.result;
					const tmpSheet = parseXlsxBufferToRows(tmpBuffer);
					if (tmpSheet.headers.length === 0)
					{
						return fCallback(new Error('Could not read the workbook. The xlsx parser is unavailable or the file is empty.'), tmpSheet);
					}
					return fCallback(null, tmpSheet);
				}
				const tmpText = String(pEvent?.target?.result || '');
				return fCallback(null, parseCsvTextToRows(tmpText));
			}
			catch (pError)
			{
				return fCallback(pError, { headers: [], rows: [] });
			}
		};
		tmpReader.onerror = () => fCallback(new Error('Failed to read the selected file.'), { headers: [], rows: [] });
		if (tmpIsXlsx)
		{
			tmpReader.readAsArrayBuffer(pFile);
		}
		else
		{
			tmpReader.readAsText(pFile);
		}
	}

	/**
	 * Apply a column mapping to a previously-parsed `{ headers, rows }` and
	 * POST the resulting records. Used by the column-mapping UI after the
	 * user confirms.
	 *
	 * @param {{ headers: Array<string>, rows: Array<Array<string>> }} pSheet
	 * @param {Object<string, string>} pColumnMapping
	 * @param {'ContractType' | 'ProjectType'} pEntity
	 * @param {(error: Error | null, summary: { Count: number, Records: Array<Object> }) => void} fCallback
	 * @param {(done: number, total: number) => void} [fProgress] - called before the first save
	 *   and after each record so the UI can show import progress.
	 */
	importMappedRows(pSheet, pColumnMapping, pEntity, fCallback, fProgress)
	{
		try
		{
			const tmpRecords = applyMappingToRecords(pSheet, pColumnMapping);
			return this._saveRecords(tmpRecords, pEntity, fCallback, fProgress);
		}
		catch (pError)
		{
			return fCallback(pError, { Count: 0, Records: [] });
		}
	}

	/**
	 * Shared save loop. Routes each parsed record through the canonical
	 * TypeComprehensionSaveProvider (build comprehension -> push -> prototype pointer
	 * -> statuses), so imported types are identical to editor-created ones — prototype,
	 * default-date definitions, and ListDefault statuses included. Runs sequentially
	 * (each save is a multi-step comprehension push) and is first-error-wins: a failed
	 * record is recorded but the remaining records still import.
	 *
	 * @private
	 * @param {Array<Object>} pRecords - editor display-shaped records.
	 * @param {'ContractType' | 'ProjectType'} pEntity
	 * @param {(error: Error | null, summary: { Count: number, Records: Array<Object> }) => void} fCallback
	 * @param {(done: number, total: number) => void} [fProgress] - reported before the first save
	 *   (0/total) and after each record, so the UI can show a live progress indicator. Because the
	 *   loop awaits between records, these updates render between saves.
	 * @returns {Promise<void>}
	 */
	async _saveRecords(pRecords, pEntity, fCallback, fProgress)
	{
		const tmpReportProgress = (pDone, pTotal) =>
		{
			if (typeof fProgress === 'function')
			{
				fProgress(pDone, pTotal);
			}
		};
		if (!Array.isArray(pRecords) || pRecords.length === 0)
		{
			return fCallback(null, { Count: 0, Records: [] });
		}
		const tmpProvider = this._typeSaveProvider;
		if (!tmpProvider)
		{
			return fCallback(new Error('TypeComprehensionSaveProvider is not available — cannot import types.'), { Count: 0, Records: pRecords });
		}
		const tmpTotal = pRecords.length;
		const tmpIDCustomer = this._currentIDCustomer;
		let tmpFirstError = null;
		let tmpDone = 0;
		tmpReportProgress(0, tmpTotal);
		for (const tmpRecord of pRecords)
		{
			// Stamp the current customer so the comprehension's child rows inherit it.
			if (tmpIDCustomer && !tmpRecord.IDCustomer)
			{
				tmpRecord.IDCustomer = tmpIDCustomer;
			}
			try
			{
				// Import is always create/upsert semantics (no prune on re-import); the
				// deterministic Hash-derived GUIDs make a re-import idempotent.
				if (pEntity === 'ContractType')
				{
					await tmpProvider.saveContractType(tmpRecord, true);
				}
				else
				{
					await tmpProvider.saveProjectType(tmpRecord, true);
				}
			}
			catch (pError)
			{
				if (!tmpFirstError)
				{
					tmpFirstError = pError;
				}
				this.pict.log.error(`Import: failed to save ${pEntity} "${tmpRecord.Name || tmpRecord.Hash}".`, { Error: pError && pError.message });
			}
			tmpDone += 1;
			tmpReportProgress(tmpDone, tmpTotal);
		}
		return fCallback(tmpFirstError, { Count: pRecords.length, Records: pRecords });
	}
}

ContractProjectTypesImportProvider.default_configuration = {
	Name: 'ContractProjectTypesImportProvider',
	ProviderType: 'ContractProjectTypesImportProvider',
};

module.exports = ContractProjectTypesImportProvider;
module.exports.parseCsvText = parseCsvText;
module.exports.parseCsvTextToRows = parseCsvTextToRows;
module.exports.parseXlsxBufferToRows = parseXlsxBufferToRows;
module.exports.applyMappingToRecords = applyMappingToRecords;
module.exports.suggestColumnMapping = suggestColumnMapping;
module.exports.parseDefaultDatesCell = parseDefaultDatesCell;
module.exports.splitLine = splitLine;
module.exports.PLATFORM_FIELD_NAMES = PLATFORM_FIELD_NAMES;
module.exports.TEMPLATE_COLUMNS = TEMPLATE_COLUMNS;
module.exports.templateColumnsForEntity = templateColumnsForEntity;
module.exports.buildTemplateInstructions = buildTemplateInstructions;
module.exports.buildTemplateWorkbookBytes = buildTemplateWorkbookBytes;
module.exports.buildTemplateCsv = buildTemplateCsv;
module.exports.buildTemplateDescriptor = buildTemplateDescriptor;

},{"fable-serviceproviderbase":838,"xlsx":363}],1319:[function(require,module,exports){
/**
 * ContractProjectTypesSettingsAdapter
 *
 * Pure utility — translates the Settings blob on a ContractType / ProjectType
 * record between two representations:
 *
 *   - **Storage form** (what the API sends/accepts): native JS types inside
 *     `record.Settings` — arrays of strings for the list fields and plain
 *     strings for scalars.
 *
 *   - **Display form** (what the Settings editor binds to): the same scalar /
 *     boolean values, plus newline-joined text for the list fields. Stored on
 *     `record._DisplaySettings` so the edit form's descriptors can bind to those
 *     addresses without polluting the actual Settings blob the API stores.
 *
 * Two single-purpose functions:
 *
 *   - `toDisplay(record)` — populates `record._DisplaySettings.*` from
 *     `record.Settings.*`. Idempotent. Safe on records that have no Settings.
 *   - `fromDisplay(record)` — overwrites `record.Settings.*` with parsed values
 *     from `record._DisplaySettings.*`, then deletes `_DisplaySettings` so the
 *     adapter's shadow never reaches the API.
 *
 * Designed so the PSRS MeadowEndpoints provider can be lightly wrapped in
 * `PlatformConfiguration-Application-Web.js`: call `toDisplay` after fetch,
 * `fromDisplay` before create/update. The adapter has no Fable / pict
 * dependencies and is unit-tested in isolation.
 */

/**
 * Keys whose Settings value is an array of strings and whose display form is
 * newline-joined text (driven by a TextArea descriptor in the edit manifest).
 *
 * NOTE: the status lists used to live here. They are now stored canonically as
 * ListDefault rows (see STATUS_LIST_KEYS below), so this list is currently
 * empty — kept as the extension point for any future newline-text Settings list.
 */
const LIST_KEYS = [];

/**
 * Status list display keys. These are NOT round-tripped through the Settings
 * blob — statuses are stored canonically as ListDefault rows and synced via the
 * `/1.0/{ProjectType|ContractType}/:id/Statuses` endpoints. They surface in the
 * editor as a comma-joined value bound to `_DisplaySettings.*` — the wire format of
 * the status `Select2Multiple` (free-text chip) inputs; the PSRS wiring in
 * PlatformConfiguration-Application-Web.js fills them from the /Statuses endpoint
 * on load and writes them back on save. `toDisplay` initializes them to '' so the
 * manifest has stable binding targets, and `fromDisplay` strips any legacy values
 * from Settings so they never persist there again.
 */
const STATUS_LIST_KEYS = [
	'AvailableStatusList',
	'StatusesRequiringChangeOrder',
];

/**
 * Map each `_DisplaySettings` status key to the purpose used by the /Statuses
 * endpoint payload ({ Available, RequiresChangeOrder }).
 */
const STATUS_DISPLAY_KEY_TO_PURPOSE = {
	AvailableStatusList: 'Available',
	StatusesRequiringChangeOrder: 'RequiresChangeOrder',
};

/**
 * Keys whose Settings value is an array of strings but whose display form is
 * comma-separated text — what the bundled `EntitySelectorMultiple` /
 * `Select2Multiple` inputs read and write as their bound value. These are the
 * fields rendered as a true multi-select chip control, not a free-typed text
 * area.
 */
const CSV_LIST_KEYS = [];

/**
 * Display keys backed by a dedicated non-CRUD endpoint (NOT the Settings blob),
 * rendered as a comma-separated multi-select value. Like STATUS_LIST_KEYS these are
 * display-only: `toDisplay` initializes them empty (the PSRS wiring fills them from
 * their endpoint on load), and `fromDisplay` strips them from Settings so they never
 * persist there. `AllowedProjectTypeIDs` is stored as ListDefault rows via the
 * `/ContractType/:id/AllowedProjectTypes` endpoint (same model as statuses).
 * `AllowedProjectTypeNamesText` is the read-only View mirror (resolved Names); it is
 * never saved.
 */
const ENDPOINT_CSV_KEYS = [
	'AllowedProjectTypeIDs',
	'AllowedProjectTypeNamesText',
];

/**
 * Convert a string-array Settings value into a newline-joined text string for
 * the display textarea.
 *
 * @param {Array<string> | null | undefined} pList
 * @returns {string}
 */
function listToText(pList)
{
	if (!Array.isArray(pList))
	{
		return '';
	}
	return pList
		.filter((p) => p !== null && p !== undefined && String(p).length > 0)
		.join('\n');
}

/**
 * Parse a newline-separated textarea value back into an array of trimmed
 * strings. Blank lines are dropped.
 *
 * @param {string | null | undefined} pText
 * @returns {Array<string>}
 */
function textToList(pText)
{
	if (typeof pText !== 'string' || pText.length === 0)
	{
		return [];
	}
	return pText
		.split(/\r?\n/)
		.map((pLine) => pLine.trim())
		.filter((pLine) => pLine.length > 0);
}

/**
 * Convert a string-array Settings value into a comma-separated string — the
 * wire format used by `Select2Multiple` / `EntitySelectorMultiple` bound values.
 *
 * @param {Array<string> | null | undefined} pList
 * @returns {string}
 */
function listToCsv(pList)
{
	if (!Array.isArray(pList))
	{
		return '';
	}
	return pList
		.filter((p) => p !== null && p !== undefined && String(p).length > 0)
		.map((p) => String(p).trim())
		.filter((p) => p.length > 0)
		.join(',');
}

/**
 * Parse a comma-separated multi-select value back into an array of trimmed
 * strings. Blank entries are dropped.
 *
 * @param {string | Array<string> | null | undefined} pValue
 * @returns {Array<string>}
 */
function csvToList(pValue)
{
	if (Array.isArray(pValue))
	{
		// Belt-and-suspenders: if the input is already shaped as an array
		// (e.g. the multi-select widget marshaled a real array through), accept
		// it as-is. Falls through cleanly when the value is just a CSV string.
		return pValue.map((p) => String(p).trim()).filter((p) => p.length > 0);
	}
	if (typeof pValue !== 'string' || pValue.length === 0)
	{
		return [];
	}
	return pValue
		.split(',')
		.map((pEntry) => pEntry.trim())
		.filter((pEntry) => pEntry.length > 0);
}

/**
 * Convert the structured `DefaultDates` array into a `HASH:Name` per-line text.
 *
 * @param {Array<{Hash?: string, Name?: string}> | null | undefined} pDates
 * @returns {string}
 */
function defaultDatesToText(pDates)
{
	if (!Array.isArray(pDates))
	{
		return '';
	}
	return pDates
		.filter((pEntry) => pEntry && (pEntry.Hash || pEntry.Name))
		.map((pEntry) =>
		{
			const tmpHash = (pEntry.Hash || '').toString().trim();
			const tmpName = (pEntry.Name || '').toString().trim();
			if (tmpHash && tmpName)
			{
				return `${tmpHash}:${tmpName}`;
			}
			return tmpHash || tmpName;
		})
		.join('\n');
}

/**
 * Parse `HASH:Name` per-line text into the structured DefaultDates array.
 * Lines without a colon are treated as Hash-only (Name copied from Hash).
 *
 * @param {string | null | undefined} pText
 * @returns {Array<{Hash: string, Name: string}>}
 */
function textToDefaultDates(pText)
{
	if (typeof pText !== 'string' || pText.length === 0)
	{
		return [];
	}
	return pText
		.split(/\r?\n/)
		.map((pLine) => pLine.trim())
		.filter((pLine) => pLine.length > 0)
		.map((pLine) =>
		{
			const tmpColonIdx = pLine.indexOf(':');
			if (tmpColonIdx === -1)
			{
				return { Hash: pLine, Name: pLine };
			}
			return {
				Hash: pLine.substring(0, tmpColonIdx).trim(),
				Name: pLine.substring(tmpColonIdx + 1).trim(),
			};
		});
}

/**
 * Populate `record._DisplaySettings.*` from `record.Settings.*`. Idempotent.
 *
 * @param {Object | null | undefined} pRecord - The ContractType/ProjectType record.
 * @returns {Object | null | undefined} The same record, mutated for chaining.
 */
function toDisplay(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object')
	{
		return pRecord;
	}
	const tmpSettings = (pRecord.Settings && typeof pRecord.Settings === 'object') ? pRecord.Settings : {};
	const tmpDisplay = {};
	for (const tmpKey of LIST_KEYS)
	{
		tmpDisplay[tmpKey] = listToText(tmpSettings[tmpKey]);
	}
	// Statuses live in ListDefault, not Settings — initialize the display targets
	// to empty strings (stable binding targets); the PSRS wiring fills them from
	// the /Statuses endpoint after this runs.
	for (const tmpKey of STATUS_LIST_KEYS)
	{
		tmpDisplay[tmpKey] = '';
	}
	for (const tmpKey of CSV_LIST_KEYS)
	{
		tmpDisplay[tmpKey] = listToCsv(tmpSettings[tmpKey]);
	}
	// Endpoint-backed multi-selects (e.g. AllowedProjectTypeIDs) initialize empty;
	// the PSRS wiring fills them from their endpoint (e.g. /AllowedProjectTypes) after this runs.
	for (const tmpKey of ENDPOINT_CSV_KEYS)
	{
		tmpDisplay[tmpKey] = '';
	}
	// DefaultDates live as ProjectTypeDefaultDate / ContractTypeDefaultDate rows
	// Initialize the display
	// target empty; the PSRS wiring fills it from the /DefaultDates endpoint after
	// this runs (the Tabular RecordSet group binds to _DisplaySettings.DefaultDates).
	tmpDisplay.DefaultDates = [];
	// Prototype project/contract name are display-only too: initialize empty binding
	// targets; the PSRS read wiring fills them after this runs.
	tmpDisplay.PrototypeProjectName = '';
	tmpDisplay.PrototypeContractName = '';
	pRecord._DisplaySettings = tmpDisplay;
	return pRecord;
}

/**
 * Overwrite `record.Settings.*` with parsed values from
 * `record._DisplaySettings.*`, then delete `_DisplaySettings`. Idempotent on
 * records that already have no `_DisplaySettings`.
 *
 * @param {Object | null | undefined} pRecord
 * @returns {Object | null | undefined} The same record, mutated for chaining.
 */
function fromDisplay(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object' || !pRecord._DisplaySettings)
	{
		return pRecord;
	}
	const tmpDisplay = pRecord._DisplaySettings;
	const tmpSettings = (pRecord.Settings && typeof pRecord.Settings === 'object') ? Object.assign({}, pRecord.Settings) : {};
	for (const tmpKey of LIST_KEYS)
	{
		tmpSettings[tmpKey] = textToList(tmpDisplay[tmpKey]);
		if (tmpSettings[tmpKey].length === 0)
		{
			delete tmpSettings[tmpKey];
		}
	}
	// Statuses are persisted as ListDefault rows via the /Statuses endpoint (the
	// PSRS wiring captures the display text before this runs and PUTs it after the
	// save). Strip any legacy status arrays so they never live in Settings again.
	for (const tmpKey of STATUS_LIST_KEYS)
	{
		delete tmpSettings[tmpKey];
	}
	for (const tmpKey of CSV_LIST_KEYS)
	{
		tmpSettings[tmpKey] = csvToList(tmpDisplay[tmpKey]);
		if (tmpSettings[tmpKey].length === 0)
		{
			delete tmpSettings[tmpKey];
		}
	}
	// Endpoint-backed multi-selects (e.g. AllowedProjectTypeIDs) are persisted via
	// their own endpoint (the PSRS wiring captures the display value before this runs and
	// PUTs it after the save). Strip any legacy values so they never live in Settings again.
	for (const tmpKey of ENDPOINT_CSV_KEYS)
	{
		delete tmpSettings[tmpKey];
	}
	// DefaultDates are persisted as *TypeDefaultDate rows via the /DefaultDates
	// endpoint (the PSRS wiring captures the display rows before this runs and PUTs
	// them after the save). Never persist them in Settings.
	delete tmpSettings.DefaultDates;
	pRecord.Settings = tmpSettings;
	delete pRecord._DisplaySettings;
	return pRecord;
}

/**
 * Translate a /Statuses endpoint payload ({ Available, RequiresChangeOrder })
 * into the editor's comma-joined `_DisplaySettings` value — the wire format the
 * status `Select2Multiple` (free-text chip) inputs bind to.
 *
 * @param {{Available?: Array<string>, RequiresChangeOrder?: Array<string>} | null | undefined} pPayload
 * @returns {{AvailableStatusList: string, StatusesRequiringChangeOrder: string}}
 */
function statusPayloadToDisplay(pPayload)
{
	const tmpPayload = (pPayload && typeof pPayload === 'object') ? pPayload : {};
	return {
		AvailableStatusList: listToCsv(tmpPayload.Available),
		StatusesRequiringChangeOrder: listToCsv(tmpPayload.RequiresChangeOrder),
	};
}

/**
 * Translate the editor's comma-joined `_DisplaySettings` status values back into a
 * /Statuses endpoint payload.
 *
 * @param {{AvailableStatusList?: string, StatusesRequiringChangeOrder?: string} | null | undefined} pDisplay
 * @returns {{Available: Array<string>, RequiresChangeOrder: Array<string>}}
 */
function statusDisplayToPayload(pDisplay)
{
	const tmpDisplay = (pDisplay && typeof pDisplay === 'object') ? pDisplay : {};
	return {
		Available: csvToList(tmpDisplay.AvailableStatusList),
		RequiresChangeOrder: csvToList(tmpDisplay.StatusesRequiringChangeOrder),
	};
}

/**
 * Build the editor's `_DisplaySettings` values for the allowed-project-type
 * list from a `/ContractType/:id/AllowedProjectTypes` response:
 *   - `AllowedProjectTypeIDs`       — comma-joined IDs; the Edit picker binds it.
 *   - `AllowedProjectTypeNamesText` — comma-joined Names; the read-only View binds it.
 *
 * @param {Array<string> | null | undefined} pIDs   - IDProjectType strings from the endpoint.
 * @param {Array<string> | null | undefined} pNames - resolved ProjectType Names (View only).
 * @returns {{AllowedProjectTypeIDs: string, AllowedProjectTypeNamesText: string}}
 */
function allowedProjectTypesPayloadToDisplay(pIDs, pNames)
{
	return {
		AllowedProjectTypeIDs: listToCsv(pIDs),
		AllowedProjectTypeNamesText: listToCsv(pNames),
	};
}

/**
 * Translate the editor's comma-joined `_DisplaySettings.AllowedProjectTypeIDs`
 * back into a flat array. The save provider passes this through
 * `_normalizeToProjectTypeIDs` and PUTs `{ IDs: [...] }` to `/AllowedProjectTypes`
 * (the endpoint's bodyParser rejects a bare top-level array under mapParams).
 *
 * @param {{AllowedProjectTypeIDs?: string} | null | undefined} pDisplay
 * @returns {Array<string>}
 */
function allowedProjectTypesDisplayToPayload(pDisplay)
{
	const tmpDisplay = (pDisplay && typeof pDisplay === 'object') ? pDisplay : {};
	return csvToList(tmpDisplay.AllowedProjectTypeIDs);
}

module.exports = {
	LIST_KEYS,
	STATUS_LIST_KEYS,
	STATUS_DISPLAY_KEY_TO_PURPOSE,
	CSV_LIST_KEYS,
	ENDPOINT_CSV_KEYS,
	listToText,
	textToList,
	listToCsv,
	csvToList,
	defaultDatesToText,
	textToDefaultDates,
	statusPayloadToDisplay,
	statusDisplayToPayload,
	allowedProjectTypesPayloadToDisplay,
	allowedProjectTypesDisplayToPayload,
	toDisplay,
	fromDisplay,
};

},{}],1320:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');

// ContractWorkspace — now a thin subclass of the pict-section-workspace base. The base owns the shell
// (header, tab bar, routing, load, overview FieldGroups, the RecordDates + BidItemMap embeds). This subclass
// keeps ONLY Contract's bespoke Projects tab: the FK-children list (Project.IDContract) plus the association
// management it carries — add an existing project (searchable picker → full-record PUT setting IDContract),
// remove one (IDContract → 0), and create a new project already linked to the contract. Config in
// [[Contract.config.js]]. Mirrors the migration of [[ProjectWorkspace]] onto the shared library.

class ContractWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._projects = [];
		this._bidItems = { Loaded: false, Loading: false, Rows: [] };
	}

	// --- hydrate (runs inside the base load, after the Contract record arrives) ---

	async hydrateAsync(pRecord)
	{
		this._projects = [];
		this._bidItems = { Loaded: false, Loading: false, Rows: [] };
		const tmpRows = await this._getJSON(`Projects/FilteredTo/FBV~IDContract~EQ~${pRecord.IDContract}/0/1000`);
		this._projects = Array.isArray(tmpRows) ? tmpRows : [];
	}

	get idContract() { return this.record.IDContract || this.idRecord; }

	// --- Projects tab (bespoke render) ---

	openProject(pIDProject)
	{
		if (typeof window !== 'undefined' && window.location) { window.location.hash = `#/Project/Workspace/${pIDProject}`; }
	}

	/** The Projects tab body: a management toolbar (gated) + the FK-children table (or an empty state). */
	renderProjects()
	{
		const tmpCanManage = this.canManageProjects();
		const tmpCanCreate = this.canCreateProjects();
		const tmpProjects = this._projects || [];
		const tmpCount = tmpProjects.length;
		const tmpToolbar = (tmpCanManage || tmpCanCreate)
			? `<div class="pw-toolbar">`
				+ `<span class="pw-muted">${tmpCount} ${tmpCount === 1 ? 'project' : 'projects'} under this contract.</span>`
				+ `<span style="flex:1"></span>`
				+ (tmpCanManage ? `<button class="pw-btn is-light" onclick="_Pict.providers.ContractWorkspace.promptAddProject()"><i class="fas fa-link"></i><span>Add existing project</span></button>` : '')
				+ (tmpCanCreate ? `<button class="pw-btn is-link" onclick="_Pict.providers.ContractWorkspace.createProjectUnderContract()"><i class="fas fa-plus"></i><span>New project</span></button>` : '')
				+ `</div>`
			: `<div class="pw-toolbar"><span class="pw-muted">${tmpCount} ${tmpCount === 1 ? 'project' : 'projects'} under this contract.</span></div>`;
		if (!tmpCount) { return `${tmpToolbar}<div class="pw-empty"><i class="fas fa-folder-open"></i><p>No projects are linked to this contract.</p></div>`; }
		const tmpRows = tmpProjects.map((pProject) =>
		{
			const tmpID = Number(pProject.IDProject);
			const tmpName = this._esc(pProject.Name || `Project ${tmpID}`);
			const tmpRemove = tmpCanManage
				? `<button class="pw-btn is-danger" title="Remove from this contract" onclick="event.stopPropagation(); _Pict.providers.ContractWorkspace.confirmRemoveProject(${tmpID}); return false;"><i class="fas fa-link-slash"></i></button>`
				: '';
			return `<tr onclick="_Pict.providers.ContractWorkspace.openProject(${tmpID})" style="cursor:pointer">`
				+ `<td class="pw-cell-strong">${tmpName}</td>`
				+ `<td>${this._esc(pProject.Status || '—')}</td>`
				+ `<td class="pw-muted">${this._esc(pProject.ExternalProjectID || '—')}</td>`
				+ `<td class="pw-row-actions">${tmpRemove}<span class="pw-muted" style="margin-left:.4rem">Open <i class="fas fa-chevron-right"></i></span></td>`
				+ `</tr>`;
		}).join('');
		return `${tmpToolbar}<div class="pw-tablewrap"><table class="pw-table">`
			+ `<thead><tr><th>Project</th><th>Status</th><th>External ID</th><th></th></tr></thead>`
			+ `<tbody>${tmpRows}</tbody></table></div>`;
	}

	// --- Bid Items tab (bespoke render): the contract's bid items, each showing its Project when set ---

	/** OnEnter for the Bid Items tab: lazily fetch the contract's bid items (a contract can carry many), then
	 *  repaint the body. Bid items are CONTRACT-scoped (BidItem.IDContract) and may carry an optional IDProject
	 *  (line-item ↔ bid-item mapping is a project-scoped concern and lives on the Project workspace, not here). */
	async loadBidItemsAsync()
	{
		if (this._bidItems.Loaded || this._bidItems.Loading) { return; }
		this._bidItems.Loading = true;
		this.repaintBody();
		const tmpRows = await this._getJSON(`BidItems/FilteredTo/FBV~IDContract~EQ~${this.idContract}~FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/2000`);
		this._bidItems = { Loaded: true, Loading: false, Rows: Array.isArray(tmpRows) ? tmpRows : [] };
		this.repaintBody();
	}

	/** Resolve a bid item's IDProject to its project name (from the contract's projects loaded in hydrate). */
	_projectName(pIDProject)
	{
		if (!pIDProject) { return ''; }
		const tmpProject = (this._projects || []).find((pP) => Number(pP.IDProject) === Number(pIDProject));
		return tmpProject ? (tmpProject.Name || `Project ${pIDProject}`) : `Project ${pIDProject}`;
	}

	/** The Bid Items tab body: the contract's bid items, with each item's Project shown when it is set. */
	renderBidItems()
	{
		const tmpState = this._bidItems;
		if (tmpState.Loading && !tmpState.Loaded)
		{
			return `<div class="pw-state"><span class="pw-spinner pw-spinner-inline"></span> Loading bid items…</div>`;
		}
		const tmpRows = tmpState.Rows || [];
		const tmpCount = tmpRows.length;
		const tmpToolbar = `<div class="pw-toolbar"><span class="pw-muted">${tmpCount} ${tmpCount === 1 ? 'bid item' : 'bid items'} on this contract.</span></div>`;
		if (!tmpCount)
		{
			return `${tmpToolbar}<div class="pw-empty"><i class="fas fa-gavel"></i><p>No bid items on this contract.</p></div>`;
		}
		const tmpBody = tmpRows.map((pRow) =>
		{
			const tmpProjectName = this._projectName(pRow.IDProject);
			const tmpProjectCell = tmpProjectName
				? `<a href="#/Project/Workspace/${Number(pRow.IDProject)}" onclick="event.stopPropagation()">${this._esc(tmpProjectName)}</a>`
				: `<span class="pw-muted">—</span>`;
			return `<tr>`
				+ `<td class="pw-cell-strong">${this._esc(pRow.Name || `Bid Item ${pRow.IDBidItem}`)}</td>`
				+ `<td>${this._esc(pRow.Description || '—')}</td>`
				+ `<td>${tmpProjectCell}</td>`
				+ `<td>${this._esc(pRow.Units || '—')}</td>`
				+ `<td class="pw-num">${this._formatValue(pRow.Quantity, 'number')}</td>`
				+ `<td class="pw-num">${this._formatValue(pRow.CostPerUnit, 'currency')}</td>`
				+ `</tr>`;
		}).join('');
		return `${tmpToolbar}<div class="pw-tablewrap"><table class="pw-table">`
			+ `<thead><tr><th>Name</th><th>Description</th><th>Project</th><th>Units</th><th class="pw-num">Quantity</th><th class="pw-num">Unit Cost</th></tr></thead>`
			+ `<tbody>${tmpBody}</tbody></table></div>`;
	}

	// --- Project association management (add existing / remove / create under contract) ---

	get modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType, pDuration) { if (this.modal && (typeof this.modal.toast === 'function')) { const tmpOptions = { type: pType || 'info' }; if (pDuration !== undefined) { tmpOptions.duration = pDuration; } this.modal.toast(pMessage, tmpOptions); } }

	/** Fail-CLOSED capability check for the mutating actions (no service / unloaded map → false). */
	_canFailClosed(pEntity, pAction)
	{
		const tmpSvc = this.permissions;
		if (!tmpSvc || (typeof tmpSvc.can !== 'function') || !tmpSvc.currentUserReady || !tmpSvc.currentUserReady()) { return false; }
		return !!tmpSvc.can(pEntity, pAction);
	}
	canManageProjects() { return this._canFailClosed('Project', 'Update'); }
	canCreateProjects() { return this._canFailClosed('Project', 'Create'); }

	/** Re-fetch just the projects under this contract + re-render the active (Projects) tab. */
	async _reloadProjectsAsync()
	{
		if (!this.record.IDContract) { return; }
		const tmpRows = await this._getJSON(`Projects/FilteredTo/FBV~IDContract~EQ~${this.record.IDContract}/0/1000`);
		this._projects = Array.isArray(tmpRows) ? tmpRows : this._projects;
		// Repaint the tab bar too (the Projects (N) count is a dynamic label) + the body.
		this.renderWorkspace();
	}

	/** Candidate projects to ADD: those NOT already on this contract, optionally name-filtered. */
	async searchAddableProjectsAsync(pTerm)
	{
		if (!this.record.IDContract) { return []; }
		const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
		let tmpFilter = `FBV~IDContract~NE~${this.record.IDContract}~FBV~Deleted~EQ~0`;
		if (tmpTerm) { tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`; }
		const tmpRows = await this._getJSON(`Projects/FilteredTo/${tmpFilter}/0/100`);
		return (Array.isArray(tmpRows) ? tmpRows : [])
			.map((pRow) => ({ IDProject: pRow.IDProject, Name: pRow.Name || `Project ${pRow.IDProject}`, Status: pRow.Status || '', IDContract: pRow.IDContract || 0 }))
			.sort((pA, pB) => (pA.Name.toLowerCase() < pB.Name.toLowerCase() ? -1 : (pA.Name.toLowerCase() > pB.Name.toLowerCase() ? 1 : 0)));
	}

	/** Link an existing project to this contract (full-record PUT setting Project.IDContract). */
	async addProjectToContractAsync(pIDProject)
	{
		if (!this.canManageProjects()) { throw new Error('You don’t have permission to change project assignments.'); }
		const tmpProject = await this._getJSON(`Project/${pIDProject}`);
		if (!tmpProject || !tmpProject.IDProject) { throw new Error('Project not found.'); }
		tmpProject.IDContract = this.record.IDContract;
		const tmpResult = await this._putJSON('Project', tmpProject);
		if (tmpResult && tmpResult.error) { throw new Error('Could not save the project assignment.'); }
		await this._reloadProjectsAsync();
	}

	/** Unlink a project from this contract (sets Project.IDContract back to 0 — the project itself is untouched). */
	async removeProjectFromContractAsync(pIDProject)
	{
		if (!this.canManageProjects()) { throw new Error('You don’t have permission to change project assignments.'); }
		const tmpProject = await this._getJSON(`Project/${pIDProject}`);
		if (!tmpProject || !tmpProject.IDProject) { throw new Error('Project not found.'); }
		tmpProject.IDContract = 0;
		const tmpResult = await this._putJSON('Project', tmpProject);
		if (tmpResult && tmpResult.error) { throw new Error('Could not save the project assignment.'); }
		await this._reloadProjectsAsync();
	}

	confirmRemoveProject(pIDProject)
	{
		const tmpProject = this._projects.find((pP) => Number(pP.IDProject) === Number(pIDProject));
		const tmpName = (tmpProject && tmpProject.Name) || `Project ${pIDProject}`;
		Promise.resolve(this.modal.confirm(`Remove “${tmpName}” from this contract? The project is kept — only its link to this contract is cleared.`, { title: 'Remove from contract', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true }))
			.then((pOk) =>
			{
				if (!pOk) { return; }
				return this.removeProjectFromContractAsync(pIDProject)
					.then(() => this._toast(`Removed “${tmpName}” from this contract.`, 'success'))
					.catch((pError) => this._toast((pError && pError.message) ? pError.message : 'Could not remove the project.', 'error', 6000));
			});
	}

	/** Create a brand-new project already linked to this contract: prefill + open the Create workspace. */
	createProjectUnderContract()
	{
		if (!this.canCreateProjects()) { this._toast('You don’t have permission to create projects.', 'error', 6000); return; }
		const tmpCreate = this.pict.providers.ProjectCreateWorkspace;
		if (tmpCreate && (typeof tmpCreate.prefillNew === 'function')) { tmpCreate.prefillNew({ IDContract: this.record.IDContract }); }
		if (typeof window !== 'undefined' && window.location) { window.location.hash = '#/PSRS/Project/Create'; }
	}

	// --- Add-existing picker (searchable modal) ---

	promptAddProject()
	{
		if (!this.canManageProjects()) { this._toast('You don’t have permission to change project assignments.', 'error', 6000); return; }
		if (!this.modal || (typeof this.modal.show !== 'function')) { return; }
		this._addProjectToken = 0;
		this.modal.show(
			{
				title: 'Add an existing project to this contract',
				content: '<p class="cw-modal-help">Pick a project to link to this contract. Projects already on another contract will be moved to this one.</p>'
					+ '<input id="CW-AddProjSearch" class="input" type="text" autocomplete="off" placeholder="Search projects by name…" oninput="_Pict.providers.ContractWorkspace.onAddProjectSearch(this.value)" />'
					+ '<div id="CW-AddProjResults" class="cw-addproj-list"><div class="cw-addproj-note">Loading projects…</div></div>',
				buttons: [ { Hash: 'close', Label: 'Close' } ],
				width: '520px',
			});
		setTimeout(() => this.onAddProjectSearch(''), 60);
	}

	onAddProjectSearch(pTerm)
	{
		if (this._addProjectTimer) { clearTimeout(this._addProjectTimer); }
		const tmpToken = (this._addProjectToken = (this._addProjectToken || 0) + 1);
		this._addProjectTimer = setTimeout(() =>
		{
			this.searchAddableProjectsAsync(pTerm).then((pRows) =>
			{
				if (tmpToken === this._addProjectToken) { this._renderAddProjectResults(pRows); }
			}).catch(() => { if (tmpToken === this._addProjectToken) { this._renderAddProjectResults(null); } });
		}, 200);
	}

	_renderAddProjectResults(pRows)
	{
		const tmpHost = document.getElementById('CW-AddProjResults');
		if (!tmpHost) { return; }
		if (pRows === null) { tmpHost.innerHTML = '<div class="cw-addproj-note cw-addproj-err">Could not load projects.</div>'; return; }
		if (!pRows.length) { tmpHost.innerHTML = '<div class="cw-addproj-note">No matching projects.</div>'; return; }
		tmpHost.innerHTML = pRows.slice(0, 100).map((pRow) =>
			`<button type="button" class="cw-addproj-row" onclick="_Pict.providers.ContractWorkspace.pickAddProject(${Number(pRow.IDProject)})">`
			+ `<span class="cw-addproj-name">${this._esc(pRow.Name)}</span>`
			+ (pRow.IDContract ? '<span class="cw-addproj-tag">on another contract</span>' : '')
			+ '</button>').join('');
	}

	pickAddProject(pIDProject)
	{
		if (this.modal && (typeof this.modal.dismissModals === 'function')) { this.modal.dismissModals(); }
		this.addProjectToContractAsync(pIDProject)
			.then(() => this._toast('Project added to this contract.', 'success'))
			.catch((pError) => this._toast((pError && pError.message) ? pError.message : 'Could not add the project.', 'error', 6000));
	}
}

module.exports = ContractWorkspaceProvider;

},{"pict-section-workspace":1049}],1321:[function(require,module,exports){
/**
 * CustomerProvisioning-PersonaCatalog.js
 *
 * Persona catalog for the Customer Provisioning tool.
 * Each entry maps a persona key to its category, display title,
 * default role, default character name, and classification.
 */

module.exports = [
  // ── Field ──────────────────────────────────────────────────
  {
    key: 'construction-inspector',
    category: 'Field',
    title: 'DOT Construction Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Marcus', last: 'Thompson' },
    classification: 'DOT',
  },
  {
    key: 'cei-field-inspector',
    category: 'Field',
    title: 'CEI Field Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Daniela', last: 'Reyes' },
    classification: 'CEI',
  },
  {
    key: 'materials-field-sampler',
    category: 'Field',
    title: 'Materials Field Sampler',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'James', last: 'Okafor' },
    classification: 'DOT',
  },
  {
    key: 'bridge-inspector',
    category: 'Field',
    title: 'Bridge Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Simon', last: 'Achebe' },
    classification: 'DOT',
  },
  {
    key: 'specialty-inspector-uas',
    category: 'Field',
    title: 'UAS Pilot / Specialty Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Alicia', last: 'Tran' },
    classification: 'DOT',
  },
  {
    key: 'contractor-field-representative',
    category: 'Field',
    title: 'Contractor Field Representative',
    role: 'UM-STD-R-CONTRACTOR',
    defaultName: { first: 'Ray', last: 'Dominguez' },
    classification: 'Contractor',
  },

  // ── Project Office ─────────────────────────────────────────
  {
    key: 'resident-engineer',
    category: 'Project Office',
    title: 'DOT Resident Engineer',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Sarah', last: 'Nakamura' },
    classification: 'DOT',
  },
  {
    key: 'cei-project-manager',
    category: 'Project Office',
    title: 'CEI Project Manager',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Kevin', last: 'Briggs' },
    classification: 'CEI',
  },
  {
    key: 'office-manager',
    category: 'Project Office',
    title: 'Field Office Manager',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Patricia', last: 'Goodwin' },
    classification: 'DOT',
  },
  {
    key: 'lab-technician',
    category: 'Project Office',
    title: 'Lab Technician',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Tyler', last: 'Marsh' },
    classification: 'DOT',
  },
  {
    key: 'project-engineer-eit',
    category: 'Project Office',
    title: 'Project Engineer / Engineer-in-Training',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Mei', last: 'Chen' },
    classification: 'DOT',
  },
  {
    key: 'local-agency-inspector',
    category: 'Project Office',
    title: 'Local Agency Inspector/PM',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Derek', last: 'Washington' },
    classification: 'Local Agency',
  },

  // ── Back Office ────────────────────────────────────────────
  {
    key: 'materials-lab-manager',
    category: 'Back Office',
    title: 'Materials Lab Manager',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Carol', last: 'Hensley' },
    classification: 'DOT',
  },
  {
    key: 'contract-administrator',
    category: 'Back Office',
    title: 'Contract Administrator',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Robert', last: 'Kimani' },
    classification: 'DOT',
  },
  {
    key: 'program-director',
    category: 'Back Office',
    title: 'Program Director',
    role: 'UM-STD-R-HL-ADMIN',
    defaultName: { first: 'Denise', last: 'Whitmore' },
    classification: 'DOT',
  },
  {
    key: 'it-system-administrator',
    category: 'Back Office',
    title: 'IT / System Administrator',
    role: 'UM-STD-R-HL-ADMIN',
    defaultName: { first: 'Raj', last: 'Patel' },
    classification: 'DOT',
  },
  {
    key: 'dbe-compliance-officer',
    category: 'Back Office',
    title: 'DBE / Civil Rights Compliance Officer',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Angela', last: 'Torres' },
    classification: 'DOT',
  },
  {
    key: 'cei-firm-executive',
    category: 'Back Office',
    title: 'CEI Firm Executive / Division Director',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Christine', last: 'Park' },
    classification: 'CEI',
  },
];

},{}],1322:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const SpecsCatalog = require('./CustomerProvisioning-SpecsCatalog.js');
const PersonaCatalog = require('./CustomerProvisioning-PersonaCatalog.js');
const RoleCatalog = require('./CustomerProvisioning-RoleCatalog.js');

class CustomerProvisioningProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	/**
	 * Trigger a declarative repaint of the view from current AppData.
	 */
	render()
	{
		this.pict.views.CustomerProvisioning.render();
	}

	generatePassword()
	{
		const tmpWords = [
			'anchor','asphalt','beacon','bridge','canyon','cement','cobalt','crane',
			'delta','diesel','ember','falcon','gauge','gravel','harbor','iron',
			'jetty','keystone','lantern','marble','nimbus','orbit','paving','quarry',
			'rebar','signal','timber','truss','upland','valley','welded','zenith',
			'alpine','barrel','conduit','dredge','flange','girder','hopper','joist',
			'kiln','ledger','mallet','nozzle','outlet','plinth','rivet','spanner',
			'toggle','umbra','vessel','wrench','axle','bolted','clamp','dowel'
		];
		let tmpWord1 = tmpWords[Math.floor(Math.random() * tmpWords.length)];
		let tmpWord2 = tmpWords[Math.floor(Math.random() * tmpWords.length)];
		// Capitalize first letter of each
		tmpWord1 = tmpWord1.charAt(0).toUpperCase() + tmpWord1.slice(1);
		tmpWord2 = tmpWord2.charAt(0).toUpperCase() + tmpWord2.slice(1);
		return `${tmpWord1}-${tmpWord2}`;
	}

	// --- State Initialization ---

	initializeState()
	{
		this.pict.AppData.CustomerProvisioning = {
			ActiveStep: 1,
			CompletedSteps: [],
			SelectedDataset: null,
			DatasetFilter: '',
			DatasetRows: [],
			DatasetSummarySlot: [],
			PersonaGroups: [],
			RoleRows: [],
			CustomerLabel: '',
			AdminLabel: '',
			PersonaSelectedCount: 0,
			DatasetLabel: 'None',
			SpecRecords: 0,
			RoleCount: 0,
			Customer: {
				Name: '',
				Code: '',
				Timezone: 'America/New_York',
				GUIDCustomer: '',
			},
			AdminUser: {
				NameFirst: '',
				NameLast: '',
				Email: '',
				LoginID: '',
				LoginPassword: '',
			},
			IntegrationUser: {
				NameFirst: 'Integration',
				NameLast: 'Service',
				Email: '',
				LoginID: '',
				LoginPassword: 'HeadLight2026!',
			},
			ExampleUsers: PersonaCatalog.map((pPersona) =>
			{
				return {
					selected: true,
					persona: pPersona,
					userData: {
						NameFirst: pPersona.defaultName.first,
						NameLast: pPersona.defaultName.last,
						Email: '',
						LoginID: '',
						Title: pPersona.title,
					},
				};
			}),
			Comprehension1: null,
			Comprehension2: null,
			PushState: {
				Phase: 'idle',
				Progress: 0,
				StatusText: '',
				PanelClass: 'is-hidden',
				TotalSteps: 0,
				CurrentEntity: '',
				Errors: [],
				Log: [],
			},
		};
	}

	// --- Derived Render State ---

	/**
	 * Compute the per-step accordion body visibility + status tag slots from
	 * ActiveStep / CompletedSteps. Uses Bulma is-hidden (not inline display).
	 */
	deriveStepState()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		for (let i = 1; i <= 5; i++)
		{
			tmpState['Step' + i + '_BodyClass'] = (tmpState.ActiveStep === i) ? '' : 'is-hidden';

			if (tmpState.CompletedSteps.includes(i))
			{
				tmpState['Step' + i + '_StatusLabel'] = '✓ Complete';
				tmpState['Step' + i + '_StatusClass'] = 'is-success';
			}
			else if (tmpState.ActiveStep === i)
			{
				tmpState['Step' + i + '_StatusLabel'] = 'Active';
				tmpState['Step' + i + '_StatusClass'] = 'is-info';
			}
			else
			{
				tmpState['Step' + i + '_StatusLabel'] = 'Pending';
				tmpState['Step' + i + '_StatusClass'] = '';
			}
		}
	}

	/**
	 * Build the dataset grid rows from the specs catalog, applying the active
	 * filter (is-hidden) and selected-row highlight.
	 */
	deriveDatasetRows()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		let tmpFilter = (tmpState.DatasetFilter || '').toLowerCase();
		let tmpSelectedCode = tmpState.SelectedDataset ? tmpState.SelectedDataset.code : null;
		let tmpRows = [];

		let tmpSortedCodes = Object.keys(SpecsCatalog).sort((a, b) => SpecsCatalog[a].name.localeCompare(SpecsCatalog[b].name));

		for (let tmpCode of tmpSortedCodes)
		{
			let tmpDataset = SpecsCatalog[tmpCode];
			if (!tmpDataset.comprehensionRecords)
			{
				continue;
			}

			let tmpNameLower = tmpDataset.name.toLowerCase();
			let tmpCodeLower = tmpCode.toLowerCase();
			let tmpVisible = (!tmpFilter || tmpCodeLower.includes(tmpFilter) || tmpNameLower.includes(tmpFilter));

			let tmpRowClass = tmpVisible ? '' : 'is-hidden';
			if (tmpSelectedCode && tmpDataset.code === tmpSelectedCode)
			{
				tmpRowClass = (tmpRowClass + ' has-background-info-light').trim();
			}

			tmpRows.push({
				Code: tmpDataset.code,
				Name: tmpDataset.name,
				Records: tmpDataset.comprehensionRecords.toLocaleString(),
				TestForms: tmpDataset.testForms || 0,
				TestProcedures: tmpDataset.testProcedures || 0,
				ExampleProjects: tmpDataset.exampleProjects || 0,
				BidTabs: tmpDataset.bidTabFiles || 0,
				NameLower: tmpNameLower,
				RowClass: tmpRowClass,
			});
		}

		tmpState.DatasetRows = tmpRows;
	}

	/**
	 * Build the persona checkbox groups (Field / Project Office / Back Office).
	 */
	derivePersonaGroups()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		let tmpCategories = ['Field', 'Project Office', 'Back Office'];
		let tmpGroups = [];

		for (let tmpCatIdx = 0; tmpCatIdx < tmpCategories.length; tmpCatIdx++)
		{
			let tmpCategory = tmpCategories[tmpCatIdx];
			let tmpUsers = [];

			for (let i = 0; i < tmpState.ExampleUsers.length; i++)
			{
				let tmpEU = tmpState.ExampleUsers[i];
				if (tmpEU.persona.category !== tmpCategory)
				{
					continue;
				}

				tmpUsers.push({
					Index: i,
					NameFirst: tmpEU.userData.NameFirst,
					NameLast: tmpEU.userData.NameLast,
					Title: tmpEU.persona.title,
					CheckedAttr: tmpEU.selected ? 'checked' : '',
				});
			}

			tmpGroups.push({ Category: tmpCategory, Users: tmpUsers });
		}

		tmpState.PersonaGroups = tmpGroups;
	}

	/**
	 * Build the role summary rows from the role catalog.
	 */
	deriveRoleRows()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		let tmpRows = [];

		for (let tmpKey in RoleCatalog)
		{
			let tmpRole = RoleCatalog[tmpKey];
			tmpRows.push({
				Name: tmpRole.Name || tmpKey,
				Code: tmpRole.Code || tmpKey,
				Type: tmpRole.Type || 'Role',
			});
		}

		tmpState.RoleRows = tmpRows;
	}

	/**
	 * Compute the scalar review-summary fields for Step 5.
	 */
	deriveReviewState()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		let tmpSelectedCount = tmpState.ExampleUsers.filter((pEU) => pEU.selected).length;

		tmpState.CustomerLabel = `${tmpState.Customer.Name} (${tmpState.Customer.Code})`;
		tmpState.AdminLabel = `${tmpState.AdminUser.NameFirst} ${tmpState.AdminUser.NameLast} <${tmpState.AdminUser.Email}>`;
		tmpState.PersonaSelectedCount = tmpSelectedCount;
		tmpState.DatasetLabel = tmpState.SelectedDataset ? tmpState.SelectedDataset.name : 'None';
		tmpState.SpecRecords = tmpState.SelectedDataset ? tmpState.SelectedDataset.comprehensionRecords : 0;
		tmpState.RoleCount = Object.keys(RoleCatalog).length;
	}

	/**
	 * Derive the push-progress panel visibility from PushState.Phase.
	 */
	derivePushState()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		tmpState.PushState.PanelClass = (tmpState.PushState.Phase !== 'idle') ? '' : 'is-hidden';
	}

	// --- Accordion Navigation ---

	goToStep(pStepNumber)
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		// Can only go to completed steps or the next uncompleted step
		if (pStepNumber > 1 && !tmpState.CompletedSteps.includes(pStepNumber - 1) && tmpState.ActiveStep !== pStepNumber)
		{
			return;
		}

		tmpState.ActiveStep = pStepNumber;
		this.render();
	}

	completeStep(pStepNumber)
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		if (!tmpState.CompletedSteps.includes(pStepNumber))
		{
			tmpState.CompletedSteps.push(pStepNumber);
		}

		this.goToStep(pStepNumber + 1);
	}

	// --- Step 1: Dataset Selection ---

	filterDatasetTable(pFilter)
	{
		this.pict.AppData.CustomerProvisioning.DatasetFilter = pFilter || '';
		this.deriveDatasetRows();
		// Repaint ONLY the table rows, not the whole view — a full render() would rebuild the filter
		// <input> (a sibling of #CP-Dataset-Rows) and drop focus/caret after each keystroke.
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement('#CP-Dataset-Rows').length === 0) { this.render(); return; }
		tmpCA.assignContent('#CP-Dataset-Rows', this.pict.parseTemplateSetByHash('CustomerProvisioning-DatasetRow', this.pict.AppData.CustomerProvisioning.DatasetRows));
	}

	selectDataset(pCode)
	{
		let tmpDataset = SpecsCatalog[pCode];
		if (!tmpDataset)
		{
			return;
		}

		let tmpState = this.pict.AppData.CustomerProvisioning;
		tmpState.SelectedDataset = tmpDataset;

		// Re-derive so the selected row highlights
		this.deriveDatasetRows();

		// Single-element array drives the summary notification template
		tmpState.DatasetSummarySlot = [{
			Name: tmpDataset.name,
			Code: tmpDataset.code,
			Records: tmpDataset.comprehensionRecords,
			ExampleProjects: tmpDataset.exampleProjects,
		}];

		this.render();
	}

	// --- Step 2: Customer Configuration ---

	saveCustomerConfig()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		tmpState.Customer.Name = (this.pict.ContentAssignment.readContent('#CP-CustomerName') || '').trim();
		tmpState.Customer.Code = (this.pict.ContentAssignment.readContent('#CP-CustomerCode') || '').trim();
		tmpState.Customer.Timezone = this.pict.ContentAssignment.readContent('#CP-Timezone') || 'America/New_York';

		if (!tmpState.Customer.Name || !tmpState.Customer.Code)
		{
			this.pict.views.HeadlightPanels?.toast({ message: 'Please fill in Customer Name and Code', type: 'is-warning' });
			return;
		}

		tmpState.Customer.GUIDCustomer = 'CUST-' + tmpState.Customer.Code;

		// Generate a shared password for all accounts
		let tmpPassword = this.generatePassword();
		tmpState._generatedPassword = tmpPassword;

		// Auto-populate admin user
		tmpState.AdminUser.NameFirst = tmpState.Customer.Code;
		tmpState.AdminUser.NameLast = 'Admin';
		tmpState.AdminUser.Email = `developer+${tmpState.Customer.Code}-Admin@headlight.com`;
		tmpState.AdminUser.LoginID = `${tmpState.Customer.Code}-admin`;
		tmpState.AdminUser.LoginPassword = tmpPassword;

		// Auto-generate integration user
		tmpState.IntegrationUser.LoginID = tmpState.Customer.Code + '-integration';
		tmpState.IntegrationUser.Email = `developer+${tmpState.Customer.Code}-Integration@headlight.com`;
		tmpState.IntegrationUser.LoginPassword = tmpPassword;

		// Generate example user emails and passwords based on customer code
		for (let tmpIdx = 0; tmpIdx < tmpState.ExampleUsers.length; tmpIdx++)
		{
			let tmpEU = tmpState.ExampleUsers[tmpIdx];
			tmpEU.userData.Email = `developer+${tmpState.Customer.Code}-${tmpEU.persona.defaultName.first}@headlight.com`;
			tmpEU.userData.LoginID = `${tmpEU.persona.defaultName.first.toLowerCase()}.${tmpEU.persona.defaultName.last.toLowerCase()}`;
			tmpEU.userData.LoginPassword = tmpPassword;
		}

		// Step-3 inputs are bound to AppData, so they show the auto-populated
		// values after the re-render triggered by completeStep().
		this.completeStep(2);
	}

	// --- Step 3: User Configuration ---

	saveUserConfig()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		tmpState.AdminUser.NameFirst = (this.pict.ContentAssignment.readContent('#CP-AdminFirst') || '').trim();
		tmpState.AdminUser.NameLast = (this.pict.ContentAssignment.readContent('#CP-AdminLast') || '').trim();
		tmpState.AdminUser.Email = (this.pict.ContentAssignment.readContent('#CP-AdminEmail') || '').trim();
		tmpState.AdminUser.LoginID = (this.pict.ContentAssignment.readContent('#CP-AdminLogin') || '').trim();
		tmpState.AdminUser.LoginPassword = this.pict.ContentAssignment.readContent('#CP-AdminPassword') || '';
		tmpState.IntegrationUser.LoginPassword = this.pict.ContentAssignment.readContent('#CP-IntegrationPassword') || 'HeadLight2026!';

		if (!tmpState.AdminUser.NameFirst || !tmpState.AdminUser.Email || !tmpState.AdminUser.LoginID || !tmpState.AdminUser.LoginPassword)
		{
			this.pict.views.HeadlightPanels?.toast({ message: 'Please fill in all admin user fields', type: 'is-warning' });
			return;
		}

		this.completeStep(3);
	}

	togglePersona(pIndex)
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		tmpState.ExampleUsers[pIndex].selected = !tmpState.ExampleUsers[pIndex].selected;
		this.derivePersonaGroups();
		this.render();
	}

	// --- Step 4: Security / Roles ---

	saveSecurityConfig()
	{
		this.completeStep(4);
	}

	// --- Comprehension Building ---

	buildComprehensions()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		// Every provisioned GUID is SCOPED to this customer's Code (there is only a GUID convention, no auto-scoping),
		// so approving a SECOND customer never collides with (or clobbers) the first's PROV-USER-admin / PROV-<role>
		// records. Child records carry GUIDCustomer so the server resolves them onto the NEW customer (CUST-<Code>,
		// created first). Permissions are FLATTENED directly onto each role (its child permission groups' hashes) via
		// RolePermission rather than role→permission-group RoleEdges — RoleEdge's parent/child FKs are not
		// GUID-resolvable in a comprehension, and a flattened role grants the same effective access.
		const tmpCode = String(tmpState.Customer.Code || '').trim();
		const tmpSfx = '-' + tmpCode;
		const tmpCustomerGUID = 'CUST-' + tmpCode;

		// --- Comprehension 1: Customer, Users, Roles, admin/integration UserRoleJoins ---
		let tmpComprehension1 = {};

		// Customer (created first — its GUID→ID mapping is what scopes the child records below)
		tmpComprehension1.Customer = {};
		tmpComprehension1.Customer[tmpCustomerGUID] = {
			GUIDCustomer: tmpCustomerGUID,
			Name: tmpState.Customer.Name,
			Code: tmpState.Customer.Code,
			Enabled: true,
			Timezone: tmpState.Customer.Timezone,
		};

		// Users (admin + integration) — GUIDs scoped by Code; GUIDCustomer ties them to the new customer
		tmpComprehension1.User = {};
		const tmpAdminGUID = 'PROV-USER-admin' + tmpSfx;
		const tmpIntegrationGUID = 'PROV-USER-integration' + tmpSfx;
		tmpComprehension1.User[tmpAdminGUID] = {
			GUIDUser: tmpAdminGUID,
			GUIDCustomer: tmpCustomerGUID,
			NameFirst: tmpState.AdminUser.NameFirst,
			NameLast: tmpState.AdminUser.NameLast,
			Email: tmpState.AdminUser.Email,
			LoginID: tmpState.AdminUser.LoginID,
			LoginPassword: tmpState.AdminUser.LoginPassword,
			Title: 'Administrator',
		};
		tmpComprehension1.User[tmpIntegrationGUID] = {
			GUIDUser: tmpIntegrationGUID,
			GUIDCustomer: tmpCustomerGUID,
			NameFirst: tmpState.IntegrationUser.NameFirst,
			NameLast: tmpState.IntegrationUser.NameLast,
			Email: tmpState.IntegrationUser.Email,
			LoginID: tmpState.IntegrationUser.LoginID,
			LoginPassword: tmpState.IntegrationUser.LoginPassword,
			Title: 'Integration Service',
		};

		// Roles — GUIDs scoped by Code; GUIDCustomer ties them to the new customer.
		tmpComprehension1.Role = {};
		let tmpAllRoleEntries = [].concat(RoleCatalog.roles || [], RoleCatalog.permissionGroups || []);
		for (let tmpRoleIdx = 0; tmpRoleIdx < tmpAllRoleEntries.length; tmpRoleIdx++)
		{
			let tmpRole = tmpAllRoleEntries[tmpRoleIdx];
			let tmpRoleGUID = 'PROV-' + tmpRole.Key + tmpSfx;
			tmpComprehension1.Role[tmpRoleGUID] = {
				GUIDRole: tmpRoleGUID,
				GUIDCustomer: tmpCustomerGUID,
				Name: tmpRole.Name,
				Type: tmpRole.Type || 'Role',
				PermissionLevel: tmpRole.PermissionLevel || '',
				Deleted: 0,
			};
		}

		// Permissions: flatten each ROLE's effective permission hashes directly onto it (union of its child permission
		// groups' PermissionHashes from the catalog), scoped by Code + GUIDCustomer. GUIDRole is a standard FK the
		// server resolves; this avoids RoleEdge (whose parent/child FKs are not GUID-resolvable) while granting the
		// same access. The permission-group entries created above stay as empty placeholder roles.
		tmpComprehension1.RolePermission = {};
		let tmpPGByKey = {};
		(RoleCatalog.permissionGroups || []).forEach((pPG) => { tmpPGByKey[pPG.Key] = pPG; });
		(RoleCatalog.roles || []).forEach((pRole) =>
		{
			let tmpRoleGUID = 'PROV-' + pRole.Key + tmpSfx;
			let tmpSeen = {};
			let tmpPermIdx = 0;
			(pRole.ChildRoles || []).forEach((pChildKey) =>
			{
				let tmpPG = tmpPGByKey[pChildKey];
				if (!tmpPG || !tmpPG.PermissionHashes) { return; }
				Object.keys(tmpPG.PermissionHashes).forEach((pContext) =>
				{
					(tmpPG.PermissionHashes[pContext] || []).forEach((pHash) =>
					{
						let tmpDedup = pContext + '|' + pHash;
						if (tmpSeen[tmpDedup]) { return; }
						tmpSeen[tmpDedup] = true;
						let tmpRPGUID = 'PROV-RP-' + pRole.Key + '-' + (tmpPermIdx++) + tmpSfx;
						tmpComprehension1.RolePermission[tmpRPGUID] = {
							GUIDRolePermission: tmpRPGUID,
							GUIDCustomer: tmpCustomerGUID,
							GUIDRole: tmpRoleGUID,
							Hash: pHash,
							Allowed: 1,
							Context: pContext,
						};
					});
				});
			});
		});

		// Membership: link the admin + integration users into the HeadLight-admin role (standard GUIDUser/GUIDRole FKs).
		tmpComprehension1.UserRoleJoin = {};
		const tmpAdminRoleGUID = 'PROV-UM-STD-R-HL-ADMIN' + tmpSfx;
		tmpComprehension1.UserRoleJoin['PROV-URJ-admin' + tmpSfx] = {
			GUIDUserRoleJoin: 'PROV-URJ-admin' + tmpSfx,
			GUIDCustomer: tmpCustomerGUID,
			GUIDUser: tmpAdminGUID,
			GUIDRole: tmpAdminRoleGUID,
		};
		tmpComprehension1.UserRoleJoin['PROV-URJ-integration' + tmpSfx] = {
			GUIDUserRoleJoin: 'PROV-URJ-integration' + tmpSfx,
			GUIDCustomer: tmpCustomerGUID,
			GUIDUser: tmpIntegrationGUID,
			GUIDRole: tmpAdminRoleGUID,
		};

		tmpState.Comprehension1 = tmpComprehension1;

		// --- Comprehension 2: Example Users (GUIDs scoped by Code; tied to the new customer) ---
		let tmpComprehension2 = {};
		tmpComprehension2.User = {};
		tmpComprehension2.UserRoleJoin = {};

		let tmpSelectedUsers = tmpState.ExampleUsers.filter((pEU) => pEU.selected);
		for (let tmpIdx = 0; tmpIdx < tmpSelectedUsers.length; tmpIdx++)
		{
			let tmpEU = tmpSelectedUsers[tmpIdx];
			let tmpUserGUID = 'PROV-USER-example-' + tmpIdx + tmpSfx;
			tmpComprehension2.User[tmpUserGUID] = {
				GUIDUser: tmpUserGUID,
				GUIDCustomer: tmpCustomerGUID,
				NameFirst: tmpEU.userData.NameFirst,
				NameLast: tmpEU.userData.NameLast,
				Email: tmpEU.userData.Email,
				LoginID: tmpEU.userData.LoginID,
				Title: tmpEU.userData.Title,
			};

			// Membership: link the persona's role, but only when it names one of the catalog roles above (so the
			// scoped GUIDRole actually resolves). Persona role key lives on `.role` (the old `.roleCode` was always
			// undefined, so no example memberships were ever created).
			const tmpPersonaRole = tmpEU.persona && (tmpEU.persona.role || tmpEU.persona.roleCode);
			const tmpPersonaRoleGUID = tmpPersonaRole ? ('PROV-' + tmpPersonaRole + tmpSfx) : '';
			if (tmpPersonaRoleGUID && tmpComprehension1.Role[tmpPersonaRoleGUID])
			{
				let tmpURJGUID = 'PROV-URJ-example-' + tmpIdx + tmpSfx;
				tmpComprehension2.UserRoleJoin[tmpURJGUID] = {
					GUIDUserRoleJoin: tmpURJGUID,
					GUIDCustomer: tmpCustomerGUID,
					GUIDUser: tmpUserGUID,
					GUIDRole: tmpPersonaRoleGUID,
				};
			}
		}

		tmpState.Comprehension2 = tmpComprehension2;
	}

	// --- Download ---

	downloadComprehension(pPhase)
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		if (!tmpState.Comprehension1)
		{
			this.buildComprehensions();
		}

		let tmpData = (pPhase === 1) ? tmpState.Comprehension1 : tmpState.Comprehension2;
		let tmpJSON = JSON.stringify(tmpData, null, 2);
		let tmpBlob = new Blob([tmpJSON], { type: 'application/json' });
		let tmpURL = URL.createObjectURL(tmpBlob);

		// Intentional exception: the anchor-download idiom (createElement('a') +
		// click) is the only browser way to trigger a file download; it has no
		// Pict/template equivalent. This is the sole permitted document.* usage here.
		let tmpLink = document.createElement('a');
		tmpLink.href = tmpURL;
		tmpLink.download = `${tmpState.Customer.Code}_phase${pPhase}_comprehension.json`;
		document.body.appendChild(tmpLink);
		tmpLink.click();
		document.body.removeChild(tmpLink);
		URL.revokeObjectURL(tmpURL);
	}

	// --- Submit as a New Customer request Document (provisions on approval) ---

	/**
	 * Merge the two GUID-keyed comprehension maps ({ Entity: { GUID: record } }) that buildComprehensions() produces
	 * into one, dropping empty buckets. This is exactly the shape the server's OnEnteringState comprehension applier
	 * (the IntegrationAdapter) consumes — so the request document's onApprove payload is the wizard's own output.
	 */
	_mergeComprehensions(pC1, pC2)
	{
		const tmpOut = {};
		[ pC1, pC2 ].forEach((pC) =>
		{
			if (!pC || (typeof pC !== 'object')) { return; }
			Object.keys(pC).forEach((pEntity) =>
			{
				const tmpBucket = pC[pEntity];
				if (!tmpBucket || (typeof tmpBucket !== 'object')) { return; }
				const tmpKeys = Object.keys(tmpBucket);
				if (!tmpKeys.length) { return; }
				if (!tmpOut[pEntity]) { tmpOut[pEntity] = {}; }
				tmpKeys.forEach((pGUID) => { tmpOut[pEntity][pGUID] = tmpBucket[pGUID]; });
			});
		});
		return tmpOut;
	}

	/** The request form snapshot stored on the Document (addresses match the HeadLight-NewCustomer RNI form). */
	_requestFormData(pState)
	{
		return {
			Customer: { Name: pState.Customer.Name, Code: pState.Customer.Code, Timezone: pState.Customer.Timezone },
			AdminUser: { NameFirst: pState.AdminUser.NameFirst, NameLast: pState.AdminUser.NameLast, Email: pState.AdminUser.Email, LoginID: pState.AdminUser.LoginID },
			DatasetLabel: pState.DatasetLabel || (pState.SelectedDataset && pState.SelectedDataset.name) || '',
		};
	}

	/** Find (or create) the HeadLight "New Customers" project that holds the request documents. Idempotent. */
	async _ensureNewCustomersProjectID()
	{
		if (this._newCustomersProjectID) { return this._newCustomersProjectID; }
		const tmpFound = await new Promise((pResolve) => this.restClient.getJSON('Projects/FilteredTo/FBV~Name~EQ~New Customers~FBN~IDCustomer~EQ~1~FBV~Deleted~EQ~0/0/1', (pErr, pBody) => pResolve(pErr ? null : pBody)));
		if (Array.isArray(tmpFound) && tmpFound[0] && tmpFound[0].IDProject) { this._newCustomersProjectID = tmpFound[0].IDProject; return this._newCustomersProjectID; }
		const tmpCreated = await this.upsertRecord('Project', { IDCustomer: 1, Name: 'New Customers', Description: 'Platform project holding New Customer provisioning requests (documents) and their observations.', Status: 'Active', Deleted: 0, InitialContractAmount: 0, GUIDProject: 'HL-NEWCUSTOMERS-PROJECT' });
		this._newCustomersProjectID = tmpCreated && tmpCreated.IDProject;
		return this._newCustomersProjectID;
	}

	/**
	 * Submit the wizard's input as a New Customer REQUEST: a Draft Document (type HeadLight-NewCustomer) in the New
	 * Customers project whose EntityData.OnEnteringState.Approved carries the provisioning comprehension. The customer
	 * (+ users, roles) is created when an approver approves the request — not here. Reuses buildComprehensions() as-is.
	 */
	async createRequestDocument()
	{
		const tmpState = this.pict.AppData.CustomerProvisioning;
		if (!tmpState || !tmpState.Customer || !tmpState.Customer.Name || !tmpState.Customer.Code)
		{
			this.pict.views.HeadlightPanels?.toast({ message: 'Please complete the customer name and code first.', type: 'is-warning' });
			return;
		}
		try
		{
			this.buildComprehensions();   // reuse the existing builder verbatim
			const tmpComprehension = this._mergeComprehensions(tmpState.Comprehension1, tmpState.Comprehension2);
			const tmpProjectID = await this._ensureNewCustomersProjectID();
			const tmpDoc = {
				IDCustomer: 1,
				IDProject: tmpProjectID,
				DocumentType: 'HeadLight-NewCustomer',
				Form: 1,
				Name: tmpState.Customer.Name,
				Description: 'New customer provisioning request — provisions the customer, users and roles on approval.',
				DocumentDate: (new Date()).toISOString(),
				FormDataJSON: JSON.stringify(this._requestFormData(tmpState)),
				EntityDataJSON: JSON.stringify({ OnEnteringState: { Approved: tmpComprehension } }),
				GUIDDocument: 'NEWCUST-REQ-' + tmpState.Customer.Code + '-' + Date.now(),
				Deleted: 0,
			};
			const tmpCreated = await this.upsertRecord('Document', tmpDoc);
			this.pict.views.HeadlightPanels?.toast({ message: `New customer request for "${tmpState.Customer.Name}" submitted for approval.`, type: 'is-success' });
			if ((typeof window !== 'undefined') && window.location) { window.location.hash = '#/Customers/New'; }
			return tmpCreated;
		}
		catch (pError)
		{
			this.pict.views.HeadlightPanels?.toast({ message: 'Could not submit the request: ' + (pError.message || pError), type: 'is-danger' });
		}
	}

	// --- Push to HeadLight ---

	async pushToHeadLight()
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;

		if (!tmpState.Comprehension1)
		{
			this.buildComprehensions();
		}

		tmpState.PushState.Phase = 'pushing-phase1';
		tmpState.PushState.Progress = 0;
		tmpState.PushState.Log = [];
		tmpState.PushState.Errors = [];
		this.render();

		try
		{
			// Phase 1: Push Customer, Users, Roles
			this.logProgress('Starting Phase 1: Customer setup...');

			// Push Customer
			this.logProgress('Creating Customer record...');
			let tmpCustomerRecord = Object.values(tmpState.Comprehension1.Customer)[0];
			await this.upsertRecord('Customer', tmpCustomerRecord);
			this.updateProgress(10);

			// Push Users (admin + integration)
			this.logProgress('Creating users...');
			let tmpUsers = Object.values(tmpState.Comprehension1.User);
			for (let tmpUserIdx = 0; tmpUserIdx < tmpUsers.length; tmpUserIdx++)
			{
				let tmpUser = tmpUsers[tmpUserIdx];
				let tmpResult = await this.upsertRecord('User', tmpUser);
				if (tmpUser.GUIDUser.includes('integration'))
				{
					tmpState.PushState._integrationUserID = tmpResult?.IDUser;
				}
				if (tmpUser.GUIDUser.includes('admin'))
				{
					tmpState.PushState._adminUserID = tmpResult?.IDUser;
				}
				this.logProgress('  Created user: ' + tmpUser.LoginID + ' (ID: ' + (tmpResult?.IDUser || '?') + ')');
			}
			this.updateProgress(20);

			// Push Roles and capture returned IDs
			this.logProgress('Creating roles...');
			let tmpRoles = Object.values(tmpState.Comprehension1.Role);
			let tmpRoleGUIDToID = {};
			for (let tmpRoleIdx = 0; tmpRoleIdx < tmpRoles.length; tmpRoleIdx++)
			{
				let tmpRoleResult = await this.upsertRecord('Role', tmpRoles[tmpRoleIdx]);
				if (tmpRoleResult && tmpRoleResult.IDRole)
				{
					tmpRoleGUIDToID[tmpRoles[tmpRoleIdx].GUIDRole] = tmpRoleResult.IDRole;
				}
				this.logProgress('  Role: ' + tmpRoles[tmpRoleIdx].Name + ' (ID: ' + (tmpRoleResult?.IDRole || '?') + ')');
			}
			this.updateProgress(40);

			// Role GUIDs are scoped per customer (see buildComprehensions), so resolve the server IDs by the SCOPED GUID.
			const tmpSfx = '-' + String(tmpState.Customer.Code || '').trim();
			let tmpAllEntries = [].concat(RoleCatalog.roles || [], RoleCatalog.permissionGroups || []);
			for (let tmpEntryIdx = 0; tmpEntryIdx < tmpAllEntries.length; tmpEntryIdx++)
			{
				let tmpEntry = tmpAllEntries[tmpEntryIdx];
				let tmpParentGUID = 'PROV-' + tmpEntry.Key + tmpSfx;
				let tmpParentID = tmpRoleGUIDToID[tmpParentGUID];
				if (!tmpParentID || !tmpEntry.ChildRoles) continue;

				for (let tmpChildIdx = 0; tmpChildIdx < tmpEntry.ChildRoles.length; tmpChildIdx++)
				{
					let tmpChildGUID = 'PROV-' + tmpEntry.ChildRoles[tmpChildIdx] + tmpSfx;
					let tmpChildID = tmpRoleGUIDToID[tmpChildGUID];
					if (!tmpChildID) continue;

					await this.upsertRecord('RoleEdge', {
						GUIDRoleEdge: 'RE-' + tmpParentID + '-' + tmpChildID,
						ParentIDRole: tmpParentID,
						ChildIDRole: tmpChildID,
					});
				}
			}
			this.updateProgress(50);

			// Build RolePermissions using server-assigned IDRole values
			this.logProgress('Creating role permissions...');
			for (let tmpPGIdx = 0; tmpPGIdx < (RoleCatalog.permissionGroups || []).length; tmpPGIdx++)
			{
				let tmpPG = RoleCatalog.permissionGroups[tmpPGIdx];
				let tmpPGGUID = 'PROV-' + tmpPG.Key + tmpSfx;
				let tmpPGID = tmpRoleGUIDToID[tmpPGGUID];
				if (!tmpPGID || !tmpPG.PermissionHashes) continue;

				let tmpPermBatch = [];
				for (let tmpScope in tmpPG.PermissionHashes)
				{
					let tmpHashes = tmpPG.PermissionHashes[tmpScope];
					for (let tmpHashIdx = 0; tmpHashIdx < tmpHashes.length; tmpHashIdx++)
					{
						tmpPermBatch.push({
							GUIDRolePermission: 'RP-' + tmpPGID + '-' + tmpHashIdx,
							IDRole: tmpPGID,
							Hash: tmpHashes[tmpHashIdx],
							Allowed: 1,
							Context: tmpScope,
						});
					}
				}
				if (tmpPermBatch.length > 0)
				{
					// Batch in groups of 50
					for (let i = 0; i < tmpPermBatch.length; i += 50)
					{
						await this.upsertRecords('RolePermission', tmpPermBatch.slice(i, i + 50));
					}
					this.logProgress('  ' + tmpPG.Name + ': ' + tmpPermBatch.length + ' permissions');
				}
			}
			this.updateProgress(60);

			// UserRoleJoins — assign admin and integration users to HL-ADMIN role
			this.logProgress('Assigning user roles...');
			let tmpAdminRoleID = tmpRoleGUIDToID['PROV-UM-STD-R-HL-ADMIN' + tmpSfx];
			if (tmpAdminRoleID && tmpState.PushState._adminUserID)
			{
				await this.upsertRecord('UserRoleJoin', {
					GUIDUserRoleJoin: 'PROV-URJ-admin' + tmpSfx,
					IDRole: tmpAdminRoleID,
					IDUser: tmpState.PushState._adminUserID,
				});
			}
			if (tmpAdminRoleID && tmpState.PushState._integrationUserID)
			{
				await this.upsertRecord('UserRoleJoin', {
					GUIDUserRoleJoin: 'PROV-URJ-integration' + tmpSfx,
					IDRole: tmpAdminRoleID,
					IDUser: tmpState.PushState._integrationUserID,
				});
			}
			this.updateProgress(65);

			// Phase 2: Impersonate and push spec data
			tmpState.PushState.Phase = 'impersonating';
			if (tmpState.PushState._integrationUserID)
			{
				this.logProgress('Impersonating integration user...');
				await new Promise((pResolve, pReject) =>
				{
					this.restClient.impersonate(tmpState.PushState._integrationUserID, (pError) =>
					{
						if (pError)
						{
							pReject(pError);
						}
						else
						{
							pResolve();
						}
					});
				});
				this.logProgress('Impersonation successful.');
			}

			tmpState.PushState.Phase = 'pushing-phase2';

			// Push Comprehension 2 entities in dependency order
			if (tmpState.Comprehension2)
			{
				let tmpEntityOrder = [
					'TestSpecificationSet', 'TestSpecification', 'PayItem', 'Organization', 'Lab', 'Test',
					'Material', 'MaterialPayItemJoin', 'ManifestSchema', 'ReportNamedInstance',
					'Project', 'LineItem', 'MaterialLineItemJoin', 'ProjectLineItemMaterialTest',
					'User', 'UserRoleJoin',
				];

				let tmpStep = 0;
				for (let tmpEntityIdx = 0; tmpEntityIdx < tmpEntityOrder.length; tmpEntityIdx++)
				{
					let tmpEntity = tmpEntityOrder[tmpEntityIdx];
					if (!tmpState.Comprehension2[tmpEntity])
					{
						continue;
					}

					let tmpRecords = Array.isArray(tmpState.Comprehension2[tmpEntity])
						? tmpState.Comprehension2[tmpEntity]
						: Object.values(tmpState.Comprehension2[tmpEntity]);

					if (tmpRecords.length === 0)
					{
						continue;
					}

					this.logProgress(`Pushing ${tmpRecords.length} ${tmpEntity} records...`);

					// Batch in groups of 100
					for (let i = 0; i < tmpRecords.length; i += 100)
					{
						let tmpBatch = tmpRecords.slice(i, i + 100);
						await this.upsertRecords(tmpEntity, tmpBatch);
					}

					tmpStep++;
					this.updateProgress(65 + Math.round((tmpStep / tmpEntityOrder.length) * 35));
				}
			}

			tmpState.PushState.Phase = 'complete';
			this.updateProgress(100);
			this.logProgress('Provisioning complete!');
			this.pict.views.HeadlightPanels?.toast({ message: 'Customer provisioned successfully!', type: 'is-success' });
		}
		catch (pError)
		{
			tmpState.PushState.Phase = 'error';
			tmpState.PushState.Errors.push(pError.message || String(pError));
			this.logProgress('Error: ' + (pError.message || String(pError)));
			this.pict.views.HeadlightPanels?.toast({ message: 'Error during provisioning: ' + (pError.message || pError), type: 'is-danger' });
		}
	}

	// --- Helper Methods ---

	upsertRecord(pEntityType, pRecord)
	{
		return new Promise((pResolve, pReject) =>
		{
			this.restClient.upsertEntity(pEntityType, pRecord, (pError, pResult) =>
			{
				if (pError)
				{
					pReject(pError);
				}
				else
				{
					pResolve(pResult);
				}
			});
		});
	}

	upsertRecords(pEntityType, pRecords)
	{
		return new Promise((pResolve, pReject) =>
		{
			this.restClient.upsertEntities(pEntityType, pRecords, (pError, pResult) =>
			{
				if (pError)
				{
					pReject(pError);
				}
				else
				{
					pResolve(pResult);
				}
			});
		});
	}

	logProgress(pMessage)
	{
		let tmpState = this.pict.AppData.CustomerProvisioning;
		let tmpTime = new Date();
		tmpState.PushState.Log.push({
			time: tmpTime.toISOString(),
			message: pMessage,
			Display: tmpTime.toLocaleTimeString() + ' — ' + pMessage,
		});
		tmpState.PushState.StatusText = pMessage;
		this.render();
	}

	updateProgress(pPercent)
	{
		this.pict.AppData.CustomerProvisioning.PushState.Progress = pPercent;
		this.render();
	}
}

module.exports = CustomerProvisioningProvider;

module.exports.default_configuration = {
	ProviderIdentifier: 'CustomerProvisioningProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

},{"./CustomerProvisioning-PersonaCatalog.js":1321,"./CustomerProvisioning-RoleCatalog.js":1323,"./CustomerProvisioning-SpecsCatalog.js":1324,"pict-provider":845}],1323:[function(require,module,exports){
/**
 * CustomerProvisioning-RoleCatalog.js
 *
 * Role and permission-group definitions for Customer Provisioning.
 * Data sourced from the JSONC files in:
 *   api/user_management/source/data/roles/global/
 */

module.exports = {
  roles: [
    {
      Key: 'UM-STD-R-HL-ADMIN',
      Name: 'HeadLight Administrator',
      Description: 'This is a standard role that grants administrative access to the HeadLight platform',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-HL-ADMIN', 'UM-STD-PG-ROLE-MANAGER'],
    },
    {
      Key: 'UM-STD-R-HL-USER',
      Name: 'HeadLight User',
      Description: 'This is a standard role that provides minimum acccess to the HeadLight platform via the Home app',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-HOME-ACCESS'],
    },
    {
      Key: 'UM-STD-R-CONTRACTOR',
      Name: 'Contractor',
      Description: 'This is a standard role that grants project staffing via the Home App',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-CONTRACTOR'],
    },
    {
      Key: 'UM-STD-R-PROJECT-MANAGER',
      Name: 'Project Manager',
      Description: 'This is a standard role that allows a user to manage data in the projects of which they are a member',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-PROJECT-MANAGER'],
    },
    {
      Key: 'UM-STD-R-REPORT-MANAGER',
      Name: 'Report Manager',
      Description: 'This is a standard role that that enables managing reports for a project',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-REPORT-MANAGER'],
    },
    {
      Key: 'UM-STD-R-ROLE-MANAGER',
      Name: 'Role Manager',
      Description: 'This is a standard role that grants project staffing via the Home App',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-ROLE-MANAGER'],
    },
  ],

  permissionGroups: [
    {
      Key: 'UM-STD-PG-HL-ADMIN',
      Name: 'HeadLight Administrator',
      Description: 'This is a standard permission group that provides minimum acccess to the HeadLight platform via the Home app',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Artifact-Create',
          'Artifact-Read',
          'Artifact-Update',
          'Artifact-Delete',
          'BidItem-Create',
          'BidItem-Read',
          'BidItem-Update',
          'BidItem-Delete',
          'Certification-Read',
          'ChangeOrder-Create',
          'ChangeOrder-Read',
          'ChangeOrder-Update',
          'ChangeOrder-Delete',
          'Comment-Create',
          'Comment-Read',
          'Comment-Update',
          'Comment-Delete',
          'ConfigEntry-Read',
          'Contact-Create',
          'Contact-Read',
          'Contact-Update',
          'Contact-Delete',
          'Contract-Create',
          'Contract-Read',
          'Contract-Update',
          'Contract-Delete',
          'Customer-Read',
          'Customer-Update',
          'Customer-Delete',
          'Document-Observation-Associate',
          'DocumentApprovalLog-Create',
          'DocumentApprovalLog-Read',
          'Equipment-Create',
          'Equipment-Read',
          'Equipment-Update',
          'Equipment-Delete',
          'Lab-User-Associate',
          'Lot-Create',
          'Lot-Read',
          'Lot-Update',
          'Lot-Delete',
          'SubLot-Create',
          'SubLot-Read',
          'SubLot-Update',
          'SubLot-Delete',
          'Lab-Create',
          'Lab-Read',
          'Lab-Update',
          'Lab-Delete',
          'LineItem-Create',
          'LineItem-Read',
          'LineItem-Update',
          'LineItem-Delete',
          'Material-Create',
          'Material-Read',
          'Material-Update',
          'Material-Delete',
          'Observation-Artifact-Associate',
          'Observation-Create',
          'Observation-Read',
          'Observation-Update',
          'Observation-Delete',
          'Organization-Create',
          'Organization-Read',
          'Organization-Update',
          'Organization-Delete',
          'PayItem-Create',
          'PayItem-Read',
          'PayItem-Update',
          'PayItem-Delete',
          'Permission-Grant',
          'Project-Create',
          'Project-Lab-Associate',
          'Project-Read',
          'Project-Update',
          'Project-User-Associate',
          'Project-Delete',
          'ReportNamedInstance-Create',
          'ReportNamedInstance-Read',
          'ReportNamedInstance-Update',
          'ReportNamedInstance-Delete',
          'ReportNamedInstance-Project-Associate',
          'Role-Create',
          'Role-Read',
          'Role-Update',
          'Role-Delete',
          'RoleEdge-Create',
          'RoleEdge-Read',
          'RoleEdge-Update',
          'RoleEdge-Delete',
          'User-Read',
          'User-Create',
          'User-Read',
          'User-Role-Associate',
          'User-Update',
          'User-Delete',
          'UserContextRole-Create',
          'UserContextRole-Read',
          'UserContextRole-Update',
          'UserContextRole-Delete',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
    {
      Key: 'UM-STD-PG-HL-USER',
      Name: 'HeadLight User',
      Description: 'This is a standard permission group that provides minimum acccess to the HeadLight platform via the Home app',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Artifact-Read',
          'BidItem-Read',
          'Certification-Read',
          'Comment-Create',
          'Comment-Read',
          'ConfigEntry-Read',
          'Contact-Read',
          'Customer-Read',
          'Document-Observation-Associate',
          'DocumentApprovalLog-Create',
          'DocumentApprovalLog-Read',
          'Material-Read',
          'Module-HeadLight-Access',
          'Observation-Read',
          'Observation-Artifact-Associate',
          'Organization-Read',
          'PayItem-Read',
          'ReportArchetype-Read',
          'ReportNamedInstance-Read',
          'Role-Read',
          'User-Read',
        ],
        ContractMembership: [
          'Contract-Read',
        ],
        ProjectMembership: [
          'Artifact-Create',
          'ChangeOrder-Read',
          'LineItem-Read',
          'Observation-Create',
          'Project-Read',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-HOME-ACCESS',
      Name: 'Home App Access',
      Description: 'This is a standard permission group that gives access to the Home App',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-HeadLight-Access',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
    {
      Key: 'UM-STD-PG-CONTRACTOR',
      Name: 'PG Contractor',
      Description: 'This is a standard permission group that defines what a contractor can do',
      PermissionLevel: 'Contractor',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-HeadLight-Access',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
      DenialHashes: {
        CustomerMembership: [
          'Module-Headlight_Fieldbook-Access',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-PROJECT-MANAGER',
      Name: 'Project Manager',
      Description: 'This is a standard permission group that enables project management',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Artifact-Read',
          'BidItem-Read',
          'Certification-Read',
          'Comment-Create',
          'Comment-Read',
          'ConfigEntry-Read',
          'Contact-Read',
          'Customer-Read',
          'Document-Observation-Associate',
          'DocumentApprovalLog-Create',
          'DocumentApprovalLog-Read',
          'Material-Read',
          'Observation-Read',
          'Observation-Artifact-Associate',
          'Organization-Read',
          'PayItem-Read',
          'Role-Create',
          'Role-Read',
          'Role-Update',
          'User-Read',
        ],
        ContractMembership: [
          'Contract-Read',
        ],
        ProjectMembership: [
          'Artifact-Create',
          'ChangeOrder-Create',
          'ChangeOrder-Read',
          'ChangeOrder-Update',
          'ChangeOrder-Delete',
          'LineItem-Create',
          'LineItem-Read',
          'LineItem-Update',
          'LineItem-Delete',
          'Observation-Create',
          'Project-Lab-Associate',
          'Project-Read',
          'Project-Update',
          'Project-User-Associate',
          'Project-Delete',
          'ReportNamedInstance-Project-Associate',
          'UserContextRole-Create',
          'UserContextRole-Read',
          'UserContextRole-Update',
          'UserContextRole-Delete',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-REPORT-MANAGER',
      Name: 'HeadLight Report Manager',
      Description: 'This is a standard permission group that enables managing reports for a project',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'ReportArchetype-Read',
          'ReportNamedInstance-Read',
        ],
        ContractMembership: [],
        ProjectMembership: [
          'ChangeOrder-Create',
          'ChangeOrder-Read',
          'ChangeOrder-Update',
          'ChangeOrder-Delete',
          'Project-Read',
          'ReportNamedInstance-Project-Associate',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-ROLE-MANAGER',
      Name: 'HeadLight Report Manager',
      Description: 'This is a standard permission group that enables project staffing via the Home App',
      PermissionLevel: 'RoleManager',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-HeadLight-Access',
          'Project-Read',
          'Project-User-Associate',
          'Role-Create',
          'Role-Read',
          'Role-Update',
          'Role-Delete',
          'RoleContextMembership-Read',
          'RoleContextMembership-Create',
          'RoleContextMembership-Update',
          'RoleContextMembership-Delete',
          'RoleEdge-Create',
          'RoleEdge-Read',
          'RoleEdge-Update',
          'RoleEdge-Delete',
          'User-Read',
          'User-Role-Associate',
          'UserContextRole-Create',
          'UserContextRole-Read',
          'UserContextRole-Update',
          'UserContextRole-Delete',
          'UserContextRole-Create',
          'RoleEdge-Read',
          'Lab-User-Associate',
          'UserContextRole-Delete',
          'UserContextRole-Read',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
    {
      Key: 'UM-STD-PG-CONTRACTADMIN-ACCESS',
      Name: 'Contract Administration Access',
      Description: 'This is a standard permission group that gives access to Contract Administration',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-ContractAdmin-Access',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
  ],
};

},{}],1324:[function(require,module,exports){
/**
 * CustomerProvisioning-SpecsCatalog.js
 *
 * State-level dataset catalog for the Customer Provisioning tool.
 * Each entry describes the available test forms, procedures,
 * comprehension records, example projects, bid-tab files, and
 * the comprehension-file name for a single state DOT.
 */

module.exports = {
  al: {
    code: 'AL',
    name: 'Alabama',
    testForms: 109,
    testProcedures: 123,
    comprehensionRecords: 2809,
    exampleProjects: 10,
    bidTabFiles: 53,
    comprehensionFile: 'aldot_2026_create.json',
  },
  ar: {
    code: 'AR',
    name: 'Arkansas',
    testForms: 19,
    testProcedures: 0,
    comprehensionRecords: 189,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'ardot_2026_create.json',
  },
  az: {
    code: 'AZ',
    name: 'Arizona',
    testForms: 10,
    testProcedures: 0,
    comprehensionRecords: 4225,
    exampleProjects: 10,
    bidTabFiles: 2,
    comprehensionFile: 'adot_2026_create.json',
  },
  ca: {
    code: 'CA',
    name: 'California',
    testForms: 21,
    testProcedures: 0,
    comprehensionRecords: 187,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'CALTRANS_2026_create.json',
  },
  co: {
    code: 'CO',
    name: 'Colorado',
    testForms: 6,
    testProcedures: 0,
    comprehensionRecords: 174,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'CDOT_2026_create.json',
  },
  ct: {
    code: 'CT',
    name: 'Connecticut',
    testForms: 16,
    testProcedures: 0,
    comprehensionRecords: 185,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'CTDOT_2026_create.json',
  },
  de: {
    code: 'DE',
    name: 'Delaware',
    testForms: 81,
    testProcedures: 0,
    comprehensionRecords: 271,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'DELDOT_2026_create.json',
  },
  fl: {
    code: 'FL',
    name: 'Florida',
    testForms: 138,
    testProcedures: 0,
    comprehensionRecords: 262,
    exampleProjects: 0,
    bidTabFiles: 3,
    comprehensionFile: 'FDOT_2026_create.json',
  },
  ga: {
    code: 'GA',
    name: 'Georgia',
    testForms: 7,
    testProcedures: 0,
    comprehensionRecords: 624,
    exampleProjects: 10,
    bidTabFiles: 4,
    comprehensionFile: 'gdot_2026_create.json',
  },
  hi: {
    code: 'HI',
    name: 'Hawaii',
    testForms: 5,
    testProcedures: 0,
    comprehensionRecords: 206,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'HDOT_2026_create.json',
  },
  ia: {
    code: 'IA',
    name: 'Iowa',
    testForms: 51,
    testProcedures: 0,
    comprehensionRecords: 238,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'IADOT_2026_create.json',
  },
  il: {
    code: 'IL',
    name: 'Illinois',
    testForms: 53,
    testProcedures: 0,
    comprehensionRecords: 311,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'IDOT_2026_create.json',
  },
  in: {
    code: 'IN',
    name: 'Indiana',
    testForms: 28,
    testProcedures: 119,
    comprehensionRecords: 4784,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'indot_2026_create.json',
  },
  ks: {
    code: 'KS',
    name: 'Kansas',
    testForms: 9,
    testProcedures: 0,
    comprehensionRecords: 289,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'KDOT_2026_create.json',
  },
  ky: {
    code: 'KY',
    name: 'Kentucky',
    testForms: 20,
    testProcedures: 0,
    comprehensionRecords: 211,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'kytc_2026_create.json',
  },
  la: {
    code: 'LA',
    name: 'Louisiana',
    testForms: 163,
    testProcedures: 89,
    comprehensionRecords: 0,
    exampleProjects: 0,
    bidTabFiles: 5,
    comprehensionFile: null,
  },
  ma: {
    code: 'MA',
    name: 'Massachusetts',
    testForms: 7,
    testProcedures: 0,
    comprehensionRecords: 188,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MASSDOT_2026_create.json',
  },
  md: {
    code: 'MD',
    name: 'Maryland',
    testForms: 12,
    testProcedures: 0,
    comprehensionRecords: 246,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'MDSHA_2026_create.json',
  },
  me: {
    code: 'ME',
    name: 'Maine',
    testForms: 29,
    testProcedures: 0,
    comprehensionRecords: 167,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MEDOT_2026_create.json',
  },
  mi: {
    code: 'MI',
    name: 'Michigan',
    testForms: 60,
    testProcedures: 0,
    comprehensionRecords: 264,
    exampleProjects: 10,
    bidTabFiles: 2,
    comprehensionFile: 'MIDOT_2026_create.json',
  },
  mn: {
    code: 'MN',
    name: 'Minnesota',
    testForms: 35,
    testProcedures: 0,
    comprehensionRecords: 212,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MNDOT_2026_create.json',
  },
  mo: {
    code: 'MO',
    name: 'Missouri',
    testForms: 60,
    testProcedures: 0,
    comprehensionRecords: 177,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'MODOT_2026_create.json',
  },
  ms: {
    code: 'MS',
    name: 'Mississippi',
    testForms: 11,
    testProcedures: 0,
    comprehensionRecords: 212,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'msdot_2026_create.json',
  },
  nc: {
    code: 'NC',
    name: 'North Carolina',
    testForms: 128,
    testProcedures: 0,
    comprehensionRecords: 220,
    exampleProjects: 0,
    bidTabFiles: 3,
    comprehensionFile: 'NCDOT_2026_create.json',
  },
  ne: {
    code: 'NE',
    name: 'Nebraska',
    testForms: 49,
    testProcedures: 0,
    comprehensionRecords: 255,
    exampleProjects: 10,
    bidTabFiles: 2,
    comprehensionFile: 'NDOR_2026_create.json',
  },
  nj: {
    code: 'NJ',
    name: 'New Jersey',
    testForms: 47,
    testProcedures: 0,
    comprehensionRecords: 213,
    exampleProjects: 0,
    bidTabFiles: 2,
    comprehensionFile: 'NJDOT_2026_create.json',
  },
  nm: {
    code: 'NM',
    name: 'New Mexico',
    testForms: 6,
    testProcedures: 0,
    comprehensionRecords: 208,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'NMDOT_2026_create.json',
  },
  nv: {
    code: 'NV',
    name: 'Nevada',
    testForms: 3,
    testProcedures: 0,
    comprehensionRecords: 172,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'NVDOT_2026_create.json',
  },
  ny: {
    code: 'NY',
    name: 'New York',
    testForms: 154,
    testProcedures: 0,
    comprehensionRecords: 233,
    exampleProjects: 0,
    bidTabFiles: 2,
    comprehensionFile: 'NYSDOT_2026_create.json',
  },
  oh: {
    code: 'OH',
    name: 'Ohio',
    testForms: 33,
    testProcedures: 0,
    comprehensionRecords: 259,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'OHDOT_2026_create.json',
  },
  or: {
    code: 'OR',
    name: 'Oregon',
    testForms: 9,
    testProcedures: 0,
    comprehensionRecords: 2241,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'odot_2026_create.json',
  },
  pa: {
    code: 'PA',
    name: 'Pennsylvania',
    testForms: 4,
    testProcedures: 0,
    comprehensionRecords: 277,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'PENNDOT_2026_create.json',
  },
  sc: {
    code: 'SC',
    name: 'South Carolina',
    testForms: 9,
    testProcedures: 0,
    comprehensionRecords: 5821,
    exampleProjects: 10,
    bidTabFiles: 4,
    comprehensionFile: 'scdot_2026_create.json',
  },
  sd: {
    code: 'SD',
    name: 'South Dakota',
    testForms: 10,
    testProcedures: 0,
    comprehensionRecords: 212,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'SDDOT_2026_create.json',
  },
  tn: {
    code: 'TN',
    name: 'Tennessee',
    testForms: 57,
    testProcedures: 0,
    comprehensionRecords: 358,
    exampleProjects: 10,
    bidTabFiles: 9,
    comprehensionFile: 'tdot_2026_create.json',
  },
  tx: {
    code: 'TX',
    name: 'Texas',
    testForms: 19,
    testProcedures: 0,
    comprehensionRecords: 10726,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'txdot_2026_create.json',
  },
  ut: {
    code: 'UT',
    name: 'Utah',
    testForms: 24,
    testProcedures: 0,
    comprehensionRecords: 141,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'UDOT_2026_create.json',
  },
  va: {
    code: 'VA',
    name: 'Virginia',
    testForms: 50,
    testProcedures: 0,
    comprehensionRecords: 235,
    exampleProjects: 0,
    bidTabFiles: 2,
    comprehensionFile: 'vdot_2026_create.json',
  },
  vt: {
    code: 'VT',
    name: 'Vermont',
    testForms: 22,
    testProcedures: 0,
    comprehensionRecords: 194,
    exampleProjects: 10,
    bidTabFiles: 0,
    comprehensionFile: 'VTRANS_2026_create.json',
  },
  wa: {
    code: 'WA',
    name: 'Washington',
    testForms: 23,
    testProcedures: 0,
    comprehensionRecords: 394,
    exampleProjects: 10,
    bidTabFiles: 3,
    comprehensionFile: 'wsdot_2026_create.json',
  },
  wv: {
    code: 'WV',
    name: 'West Virginia',
    testForms: 30,
    testProcedures: 0,
    comprehensionRecords: 226,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'wvdot_2026_create.json',
  },
  wy: {
    code: 'WY',
    name: 'Wyoming',
    testForms: 4,
    testProcedures: 0,
    comprehensionRecords: 197,
    exampleProjects: 10,
    bidTabFiles: 1,
    comprehensionFile: 'WYDOT_2026_create.json',
  },
};

},{}],1325:[function(require,module,exports){
'use strict';

/**
 * Pure rules for a customer's record-set manifests (ManifestSchema rows `LIMS-<RecordSet>-<Verb>`): how the List and
 * Filter verbs layer over the config app's own list columns and filter schema, and how the Document List / Filter
 * verbs map onto the Documents browser. No pict, no REST: CustomerRecordManifests-Provider.js feeds these.
 */

/**
 * @typedef {Object} ListColumn
 * @property {string} Key - the record field (or address) the column shows
 * @property {string} [DisplayName] - the header
 * @property {{ ValueTemplate?: string }} [PictDashboard] - how the cell renders
 * @property {boolean} [DefaultHidden]
 * @property {boolean} [Sortable] - set by the manifest; unset leaves it to the list
 */

/**
 * @typedef {Object} DocumentBrowseColumn
 * @property {string} Key - one of DOCUMENT_BROWSE_COLUMN_KEYS
 * @property {string} Label - the header
 */

/**
 * @typedef {Object} SelectOption
 * @property {string} id - the stored value
 * @property {string} text - the label
 */

/**
 * @typedef {Object} DocumentBrowseLayout
 * @property {Array<DocumentBrowseColumn>} Columns
 * @property {Array<SelectOption>|null} StatusOptions - null keeps the browser's own status list
 * @property {Array<SelectOption>|null} StateOptions - null means no State filter
 */

/**
 * The Documents browser's built-in columns, in its own order. `StateName` is the badge that shows the state name, or
 * the status when there is none.
 * @type {Array<DocumentBrowseColumn>}
 */
const DEFAULT_DOCUMENT_BROWSE_COLUMNS =
[
	{ Key: 'DocumentType', Label: 'Type' },
	{ Key: 'Name', Label: 'Document' },
	{ Key: 'DocumentDate', Label: 'Date' },
	{ Key: 'CreatingIDUser', Label: 'Author' },
	{ Key: 'StateName', Label: 'Status' },
];

/** The fields the Documents browser knows how to draw a cell for. */
const DOCUMENT_BROWSE_COLUMN_KEYS = [ 'DocumentType', 'Name', 'DocumentDate', 'CreatingIDUser', 'Status', 'StateName', 'IDProject' ];

/**
 * @param {any} pValue
 * @return {boolean}
 */
const isPlainObject = (pValue) => (pValue !== null) && (typeof pValue === 'object') && !Array.isArray(pValue);

/**
 * A manifest counts only when it has at least one descriptor. For List and Filter an empty row is treated as no row:
 * an empty list would show no columns and an empty filter set changes nothing. (For the form verbs an empty row turns
 * the verb off instead; that rule lives in SampleWorkspace-Provider.js loadFormAvailabilityAsync.)
 * @param {any} pManifest
 * @return {boolean}
 */
function hasDescriptors(pManifest)
{
	return isPlainObject(pManifest) && isPlainObject(pManifest.Descriptors) && (Object.keys(pManifest.Descriptors).length > 0);
}

/**
 * Turn a List manifest into list columns, the way pict-section-recordset's generateManifestTableCells does: one
 * column per descriptor that has a PictDashboard block, keyed by the descriptor's address, headed by its Name. A
 * column the manifest gives no ValueTemplate keeps the template the underlying column set has for the same Key, so
 * the manifest picks columns and headers while the platform keeps its cell renderers (e.g. the Status label).
 * @param {any} pManifest
 * @param {Array<ListColumn|string>} [pBaseColumns] - the columns beneath the manifest
 * @return {Array<ListColumn>} empty when the manifest has no usable descriptors
 */
function listManifestToColumns(pManifest, pBaseColumns)
{
	if (!hasDescriptors(pManifest))
	{
		return [];
	}
	const tmpBaseTemplates = {};
	for (const tmpBase of (Array.isArray(pBaseColumns) ? pBaseColumns : []))
	{
		if (isPlainObject(tmpBase) && tmpBase.Key && tmpBase.PictDashboard && tmpBase.PictDashboard.ValueTemplate)
		{
			tmpBaseTemplates[tmpBase.Key] = tmpBase.PictDashboard.ValueTemplate;
		}
	}
	const tmpColumns = [];
	for (const [ tmpKey, tmpDescriptor ] of Object.entries(pManifest.Descriptors))
	{
		if (!isPlainObject(tmpDescriptor) || !isPlainObject(tmpDescriptor.PictDashboard))
		{
			continue;
		}
		const tmpColumn = { Key: tmpKey, DisplayName: tmpDescriptor.Name || tmpKey };
		const tmpTemplate = tmpDescriptor.PictDashboard.ValueTemplate || tmpBaseTemplates[tmpKey];
		if (tmpTemplate)
		{
			tmpColumn.PictDashboard = Object.assign({}, tmpDescriptor.PictDashboard, { ValueTemplate: tmpTemplate });
		}
		if (tmpDescriptor.DefaultHidden === true)
		{
			tmpColumn.DefaultHidden = true;
		}
		if (typeof tmpDescriptor.Sortable === 'boolean')
		{
			tmpColumn.Sortable = tmpDescriptor.Sortable;
		}
		tmpColumns.push(tmpColumn);
	}
	return tmpColumns;
}

/**
 * Whether the cascaded configuration sets list columns at a level above Global (Customer, Project or User). The
 * cascade arrives merged, so this compares it with the Global level on its own: equal (or no columns at all) means
 * nothing above Global touched them.
 * @param {Array<any>|undefined} pCascadedColumns - Columns from the merged cascade, if any
 * @param {Array<any>|undefined} pGlobalColumns - Columns at the Global level alone, if any
 * @return {boolean}
 */
function hasColumnsAboveGlobal(pCascadedColumns, pGlobalColumns)
{
	if (!Array.isArray(pCascadedColumns))
	{
		return false;
	}
	if (!Array.isArray(pGlobalColumns))
	{
		return true;
	}
	return JSON.stringify(pCascadedColumns) !== JSON.stringify(pGlobalColumns);
}

/**
 * Decide a list's columns. Precedence, lowest first: code seed, Global configuration, the customer's List manifest,
 * then Customer / Project / User configuration.
 * @param {Object} pInput
 * @param {any} pInput.Manifest - the customer's List manifest (or null)
 * @param {Array<any>} [pInput.SeedColumns] - the code seed's columns
 * @param {Array<any>} [pInput.GlobalColumns] - the Global configuration's columns, if any
 * @param {Array<any>} [pInput.CascadedColumns] - the merged cascade's columns, if any
 * @return {{ Columns: Array<any>|undefined, Source: string }} Source is 'Configuration', 'Manifest', 'Global' or 'Seed'
 */
function resolveListColumns(pInput)
{
	const tmpInput = pInput || {};
	if (hasColumnsAboveGlobal(tmpInput.CascadedColumns, tmpInput.GlobalColumns))
	{
		return { Columns: tmpInput.CascadedColumns, Source: 'Configuration' };
	}
	const tmpBase = Array.isArray(tmpInput.GlobalColumns) ? tmpInput.GlobalColumns : tmpInput.SeedColumns;
	const tmpManifestColumns = listManifestToColumns(tmpInput.Manifest, tmpBase);
	if (tmpManifestColumns.length > 0)
	{
		return { Columns: tmpManifestColumns, Source: 'Manifest' };
	}
	if (Array.isArray(tmpInput.GlobalColumns))
	{
		return { Columns: tmpInput.GlobalColumns, Source: 'Global' };
	}
	return { Columns: tmpInput.SeedColumns, Source: 'Seed' };
}

/**
 * A customer filter that replaces the platform's still searches every column the platform's searched: a join clause
 * keeps its own columns first, then gains the platform clause's (same RemoteTable) that it lacks. LADOTD's Material
 * filter searches Name only; the platform's also searches the material codes.
 * @param {any} pBaseDescriptor - the platform's filter for this key
 * @param {any} pOverlayDescriptor - the customer's filter for the same key (modified in place)
 * @return {any} the overlay descriptor
 */
function keepBaseSearchColumns(pBaseDescriptor, pOverlayDescriptor)
{
	const tmpBaseClauses = (pBaseDescriptor && Array.isArray(pBaseDescriptor.AvailableClauses)) ? pBaseDescriptor.AvailableClauses : [];
	const tmpOverlayClauses = (pOverlayDescriptor && Array.isArray(pOverlayDescriptor.AvailableClauses)) ? pOverlayDescriptor.AvailableClauses : [];
	tmpOverlayClauses.forEach((pClause) =>
	{
		if (!pClause || !Array.isArray(pClause.ExternalFilterByColumns))
		{
			return;
		}
		const tmpBaseClause = tmpBaseClauses.find((pBase) => pBase && Array.isArray(pBase.ExternalFilterByColumns) && pBase.RemoteTable && (pBase.RemoteTable === pClause.RemoteTable));
		if (!tmpBaseClause)
		{
			return;
		}
		tmpBaseClause.ExternalFilterByColumns.forEach((pColumn) =>
		{
			if (!pClause.ExternalFilterByColumns.includes(pColumn))
			{
				pClause.ExternalFilterByColumns.push(pColumn);
			}
		});
	});
	return pOverlayDescriptor;
}

/**
 * Layer a Filter manifest over a record set's filter schema, as legacy LIMS did: each descriptor replaces the filter of
 * the same key (or adds one), and `ReplaceBaseFilters: true` drops every filter the manifest doesn't name. A replaced
 * filter keeps the platform's search columns (keepBaseSearchColumns).
 * @param {Record<string, any>} pBaseSchema - the record set's own filter schema (not modified)
 * @param {any} pManifest - the customer's Filter manifest (or null)
 * @return {Record<string, any>} a new schema; a copy of the base when the manifest has no descriptors
 */
function mergeFilterSchema(pBaseSchema, pManifest)
{
	const tmpBase = isPlainObject(pBaseSchema) ? pBaseSchema : {};
	if (!hasDescriptors(pManifest))
	{
		return Object.assign({}, tmpBase);
	}
	const tmpOverlay = JSON.parse(JSON.stringify(pManifest.Descriptors));
	Object.keys(tmpOverlay).forEach((pKey) =>
	{
		if (tmpBase[pKey])
		{
			keepBaseSearchColumns(tmpBase[pKey], tmpOverlay[pKey]);
		}
	});
	if (pManifest.ReplaceBaseFilters === true)
	{
		return tmpOverlay;
	}
	return Object.assign({}, tmpBase, tmpOverlay);
}

/**
 * The pick-list options a Filter manifest declares for one field: the first clause with `PictForm.SelectOptions`.
 * @param {any} pManifest
 * @param {string} pKey - descriptor key
 * @return {Array<SelectOption>|null}
 */
function filterSelectOptions(pManifest, pKey)
{
	if (!hasDescriptors(pManifest) || !isPlainObject(pManifest.Descriptors[pKey]))
	{
		return null;
	}
	const tmpClauses = Array.isArray(pManifest.Descriptors[pKey].AvailableClauses) ? pManifest.Descriptors[pKey].AvailableClauses : [];
	for (const tmpClause of tmpClauses)
	{
		const tmpOptions = tmpClause && tmpClause.PictForm && tmpClause.PictForm.SelectOptions;
		if (Array.isArray(tmpOptions) && (tmpOptions.length > 0))
		{
			return tmpOptions
				.filter((pOption) => pOption && (pOption.id !== undefined) && (pOption.id !== null) && (String(pOption.id) !== ''))
				.map((pOption) => ({ id: String(pOption.id), text: String((pOption.text === undefined) || (pOption.text === null) ? pOption.id : pOption.text) }));
		}
	}
	return null;
}

/**
 * Map a customer's Document List and Filter manifests onto the Documents browser. The browser draws its own cells, so
 * a List manifest chooses which of the known columns show, in what order, under what header; descriptors it can't
 * draw (and value templates) are ignored. A Filter manifest supplies the Status pick list and adds a State pick list;
 * the browser's Type and Project filters already cover those descriptors.
 * @param {any} pListManifest
 * @param {any} pFilterManifest
 * @return {DocumentBrowseLayout}
 */
function documentBrowseLayout(pListManifest, pFilterManifest)
{
	let tmpColumns = DEFAULT_DOCUMENT_BROWSE_COLUMNS.map((pColumn) => Object.assign({}, pColumn));
	if (hasDescriptors(pListManifest))
	{
		const tmpFromManifest = [];
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(pListManifest.Descriptors))
		{
			if ((DOCUMENT_BROWSE_COLUMN_KEYS.indexOf(tmpKey) < 0) || tmpFromManifest.some((pColumn) => pColumn.Key === tmpKey))
			{
				continue;
			}
			tmpFromManifest.push({ Key: tmpKey, Label: (isPlainObject(tmpDescriptor) && tmpDescriptor.Name) ? String(tmpDescriptor.Name) : tmpKey });
		}
		if (tmpFromManifest.length > 0)
		{
			tmpColumns = tmpFromManifest;
		}
	}
	return {
		Columns: tmpColumns,
		StatusOptions: filterSelectOptions(pFilterManifest, 'Status'),
		StateOptions: filterSelectOptions(pFilterManifest, 'StateName'),
	};
}

module.exports =
{
	DEFAULT_DOCUMENT_BROWSE_COLUMNS,
	DOCUMENT_BROWSE_COLUMN_KEYS,
	hasDescriptors,
	listManifestToColumns,
	hasColumnsAboveGlobal,
	resolveListColumns,
	mergeFilterSchema,
	filterSelectOptions,
	documentBrowseLayout,
};

},{}],1326:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const libMerge = require('./CustomerRecordManifests-Merge.js');

/** The product that owns these ManifestSchema rows (`LIMS-<RecordSet>-<Verb>`), whichever app reads them. */
const MANIFEST_PRODUCT = 'LIMS';

/** The record-set verbs read here. The form verbs (Create / Edit / View) are read by the Sample workspace. */
const RECORD_SET_VERBS =
[
	{ RecordSet: 'Sample', Verb: 'List' },
	{ RecordSet: 'Sample', Verb: 'Filter' },
	{ RecordSet: 'Document', Verb: 'List' },
	{ RecordSet: 'Document', Verb: 'Filter' },
];

const CATALOG_NAMESPACE = 'MasterListCatalog';

/**
 * CustomerRecordManifests — reads the signed-in customer's record-set manifests (ManifestSchema rows
 * `LIMS-<RecordSet>-<Verb>`, pushed with hlrm / hldi) once per customer and layers them into the app:
 *   - List: the master-list registry's columns for that record set (see CustomerRecordManifests-Merge resolveListColumns
 *     for the precedence), so the list, the Samples list columns editor and the cascade all agree;
 *   - Filter: the record set's pict-section-recordset filter schema;
 *   - Document List / Filter: the Documents browser's columns and pick lists (getDocumentBrowseLayout);
 *   - Printable: read by QRCodeProvider.ensurePrintableManifests; this provider only clears it when the customer changes.
 */
class CustomerRecordManifestsProvider extends libPictProvider
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		/** @type {Record<string, any>} manifests by `<RecordSet>-<Verb>`, null where the customer has none */
		this.manifests = {};
		this._loadedCustomerID = null;
		this._loadPromise = null;
		/** @type {WeakMap<any, Record<string, any>>} each record-set provider's own filter schema, before any overlay */
		this._filterBaseByProvider = new WeakMap();
		this._registerTemplateExpressions();
	}

	/** @return {any} the app's REST client */
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	/** @return {number} the signed-in user's customer, 0 when signed out */
	get customerID()
	{
		const tmpUser = (this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return Number(tmpUser.CustomerID) || 0;
	}

	/**
	 * The value templates customer List manifests written for legacy LIMS use.
	 */
	_registerTemplateExpressions()
	{
		const tmpMetaTemplate = this.pict.MetaTemplate;
		if (!tmpMetaTemplate || (typeof tmpMetaTemplate.addPattern !== 'function'))
		{
			return;
		}
		const fDate = (pHash, pData, fCallback, pFallBackToCreateDate) =>
		{
			const [ tmpAddress, tmpFormat ] = String(pHash).split('^');
			let tmpDate = this.pict.resolveStateFromAddress(tmpAddress, pData, fCallback);
			if (!tmpDate && pFallBackToCreateDate)
			{
				tmpDate = this.pict.resolveStateFromAddress(`${tmpAddress.split('.').slice(0, -1).join('.')}.CreateDate`, pData, fCallback);
			}
			if (!tmpDate)
			{
				return '';
			}
			const tmpDay = this.pict.fable.Dates.dayJS(tmpDate);
			return tmpDay.isValid() ? tmpDay.format(tmpFormat || 'MM/DD/YYYY') : '';
		};
		tmpMetaTemplate.addPattern('{~DateFormatLIMS:', '~}', (pHash, pData, fCallback) => fDate(pHash, pData, fCallback, true));
		tmpMetaTemplate.addPattern('{~DateFormatNoFallback:', '~}', (pHash, pData, fCallback) => fDate(pHash, pData, fCallback, false));
		tmpMetaTemplate.addPattern('{~ParseSourceLocation:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const tmpExtension = (tmpRecord && tmpRecord.Extension) || {};
			return formatSourceLocation(tmpExtension.SourceCity, tmpExtension.SourceState, tmpExtension.SourceCountry);
		});
	}

	/**
	 * Read the signed-in customer's manifests, once per customer. A different customer signing in (no reload) reads
	 * afresh and drops the previous customer's QR label layout.
	 * @return {Promise<Record<string, any>>}
	 */
	loadAsync()
	{
		const tmpCustomerID = this.customerID;
		if (this._loadPromise && (this._loadedCustomerID === tmpCustomerID))
		{
			return this._loadPromise;
		}
		if ((this._loadedCustomerID !== null) && (this._loadedCustomerID !== tmpCustomerID))
		{
			this._resetPrintableLayout();
		}
		this._loadedCustomerID = tmpCustomerID;
		this.manifests = {};
		this._loadPromise = tmpCustomerID ? this._fetchAllAsync() : Promise.resolve(this.manifests);
		return this._loadPromise;
	}

	/**
	 * @return {Promise<Record<string, any>>} every RECORD_SET_VERBS manifest, null where the customer has none
	 */
	async _fetchAllAsync()
	{
		const tmpService = this.pict.services.ManifestPackagingService || this.pict.ManifestPackagingService;
		const tmpManifests = {};
		await Promise.all(RECORD_SET_VERBS.map(async (pEntry) =>
		{
			const tmpKey = `${pEntry.RecordSet}-${pEntry.Verb}`;
			tmpManifests[tmpKey] = null;
			if (!tmpService || (typeof tmpService.loadRecordManifestSchema !== 'function'))
			{
				return;
			}
			try
			{
				tmpManifests[tmpKey] = (await tmpService.loadRecordManifestSchema(pEntry.RecordSet, pEntry.Verb, MANIFEST_PRODUCT)) || null;
			}
			catch (pError)
			{
				this.pict.log.error(`CustomerRecordManifests: could not read ${MANIFEST_PRODUCT}-${tmpKey}: ${(pError && pError.message) || pError}`);
			}
		}));
		this.manifests = tmpManifests;
		return tmpManifests;
	}

	/**
	 * @param {string} pRecordSet
	 * @param {string} pVerb
	 * @return {any} the manifest, or null
	 */
	getManifest(pRecordSet, pVerb)
	{
		return this.manifests[`${pRecordSet}-${pVerb}`] || null;
	}

	/**
	 * Drop the QR label layout so the next print reads the signed-in customer's LIMS-<Entity>-Printable rows.
	 */
	_resetPrintableLayout()
	{
		const tmpQR = this.pict.providers.QRCodeProvider;
		if (tmpQR)
		{
			tmpQR.typeConfig = {};
			tmpQR._PrintableManifestsEnsured = false;
		}
	}

	/**
	 * Read one master-list entity's configuration at the Global level alone.
	 * @param {string} pEntity
	 * @return {Promise<Record<string, any>|null>} null when the read fails
	 */
	_getGlobalCatalogEntryAsync(pEntity)
	{
		const tmpRC = this.restClient;
		if (!tmpRC)
		{
			return Promise.resolve(null);
		}
		return new Promise((fResolve) =>
		{
			tmpRC.postJSON('Configuration/Get', { LevelContext: 'Global', LevelContextID: 0, NamespaceKey: CATALOG_NAMESPACE, NamespaceValue: pEntity }, (pError, pBody) =>
			{
				if (pError)
				{
					return fResolve(null);
				}
				return fResolve((pBody && (pBody.Document || pBody)) || {});
			});
		});
	}

	/**
	 * Put each customer List manifest's columns into the master-list registry's entries, beneath any Customer / Project /
	 * User configuration. Called by MasterListRegistry after every cascade load.
	 * @param {Record<string, any>} pEntries - registry entries by entity (modified)
	 * @param {Record<string, any>} pCascadedCatalog - the merged MasterListCatalog namespace, by entity
	 * @param {Record<string, any>} pSeedByEntity - the code seed, by entity
	 * @return {Promise<void>}
	 */
	async overlayMasterListEntriesAsync(pEntries, pCascadedCatalog, pSeedByEntity)
	{
		await this.loadAsync();
		for (const tmpEntry of RECORD_SET_VERBS)
		{
			const tmpEntity = tmpEntry.RecordSet;
			const tmpManifest = (tmpEntry.Verb === 'List') ? this.getManifest(tmpEntity, 'List') : null;
			if (!pEntries[tmpEntity] || !libMerge.hasDescriptors(tmpManifest))
			{
				continue;
			}
			const tmpCascaded = (pCascadedCatalog && pCascadedCatalog[tmpEntity]) || {};
			let tmpGlobal = {};
			if (Array.isArray(tmpCascaded.Columns))
			{
				tmpGlobal = await this._getGlobalCatalogEntryAsync(tmpEntity);
				if (tmpGlobal === null)
				{
					this.pict.log.warn(`CustomerRecordManifests: the Global ${tmpEntity} list configuration could not be read; configured columns win over the customer manifest.`);
					continue;
				}
			}
			const tmpResolved = libMerge.resolveListColumns(
				{
					Manifest: tmpManifest,
					SeedColumns: (pSeedByEntity && pSeedByEntity[tmpEntity] && pSeedByEntity[tmpEntity].Columns) || undefined,
					GlobalColumns: Array.isArray(tmpGlobal.Columns) ? tmpGlobal.Columns : undefined,
					CascadedColumns: tmpCascaded.Columns,
				});
			if (tmpResolved.Source === 'Manifest')
			{
				pEntries[tmpEntity] = Object.assign({}, pEntries[tmpEntity], { Columns: tmpResolved.Columns });
			}
		}
	}

	/**
	 * Layer each customer Filter manifest over its record set's filter schema, restoring the record set's own schema
	 * first (so a customer without a Filter row after one with it gets the platform filters back).
	 * @return {Promise<void>}
	 */
	async applyFilterOverlaysAsync()
	{
		await this.loadAsync();
		for (const tmpEntry of RECORD_SET_VERBS)
		{
			if (tmpEntry.Verb !== 'Filter')
			{
				continue;
			}
			const tmpProvider = this.pict.providers[`RSP-Provider-${tmpEntry.RecordSet}`];
			const tmpManifest = this.getManifest(tmpEntry.RecordSet, 'Filter');
			if (!tmpProvider || ((tmpProvider._FilterSchema === null) || (typeof tmpProvider._FilterSchema !== 'object')))
			{
				continue;
			}
			let tmpBase = this._filterBaseByProvider.get(tmpProvider);
			if (!tmpBase)
			{
				if (!libMerge.hasDescriptors(tmpManifest))
				{
					continue;
				}
				// The schema-derived filters are appended once, when the entity schema first loads; take the base after that.
				try
				{
					if (typeof tmpProvider.getRecordSchema === 'function')
					{
						await tmpProvider.getRecordSchema();
					}
				}
				catch (pError)
				{
					this.pict.log.warn(`CustomerRecordManifests: ${tmpEntry.RecordSet} schema not loaded; its customer filters wait for the next sign-in: ${(pError && pError.message) || pError}`);
					continue;
				}
				if (!tmpProvider._Schema)
				{
					continue;
				}
				tmpBase = JSON.parse(JSON.stringify(tmpProvider._FilterSchema));
				this._filterBaseByProvider.set(tmpProvider, tmpBase);
			}
			const tmpMerged = libMerge.mergeFilterSchema(tmpBase, tmpManifest);
			for (const tmpKey of Object.keys(tmpProvider._FilterSchema))
			{
				delete tmpProvider._FilterSchema[tmpKey];
			}
			Object.assign(tmpProvider._FilterSchema, JSON.parse(JSON.stringify(tmpMerged)));
		}
	}

	/**
	 * The Documents browser's columns and pick lists for the signed-in customer.
	 * @return {Promise<import('./CustomerRecordManifests-Merge.js').DocumentBrowseLayout>}
	 */
	async getDocumentBrowseLayoutAsync()
	{
		await this.loadAsync();
		return libMerge.documentBrowseLayout(this.getManifest('Document', 'List'), this.getManifest('Document', 'Filter'));
	}
}

/**
 * "City, State", or every part with "---" for a missing one when there is a country; the legacy LIMS Source Location.
 * @param {string} [pCity]
 * @param {string} [pState]
 * @param {string} [pCountry]
 * @return {string}
 */
function formatSourceLocation(pCity, pState, pCountry)
{
	if (!pCity && !pState && !pCountry)
	{
		return '';
	}
	if (pCity && pState)
	{
		return `${pCity}, ${pState}`;
	}
	if ((pCity && pCountry) || (pState && pCountry))
	{
		return `${pCity || '---'}, ${pState || '---'}, ${pCountry || '---'}`;
	}
	return pCity || pState || pCountry;
}

module.exports = CustomerRecordManifestsProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'CustomerRecordManifests',
	AutoInitialize: false,
};
module.exports.MANIFEST_PRODUCT = MANIFEST_PRODUCT;
module.exports.RECORD_SET_VERBS = RECORD_SET_VERBS;
module.exports.formatSourceLocation = formatSourceLocation;

},{"./CustomerRecordManifests-Merge.js":1325,"pict-provider":845}],1327:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libUserSearch = require('../access/User-Search.js');
// The shared "per-customer metadata form underneath the Overview" behavior (same pattern as MixDesign/Product), so
// the Customer dashboard shows the customer's CustomProperties as a guided, read/edit form with the rest of the record.
const libEntityMetadataWorkspace = require('./EntityMetadataWorkspace-Provider.js');
// The app's own gated downloadable-app modules (Data Downloader + the future binary apps). Merged into the
// Modules-tab catalog so they can be enabled per customer even though the platform Module catalog has no row
// for them (creating a Module is a restricted op; the CustomerModuleJoin gate is keyed by ModuleHash, no FK).
const libDataDownloaderProvider = require('./DataDownloader-Provider.js');
// Contract Administration is a config-app-defined module (no server Module row — restricted op); it is merged into
// the Modules-tab catalog and gets a guided "Set up" action (enable + grant capability + clone the cust-1 template).
const libContractAdminTemplate = require('../contract-admin/ContractAdmin-Template.js');
const libConfigSync = require('./ConfigSync.js');

/**
 * CustomerWorkspace-Provider — the bespoke-methods subclass behind source/workspace-configs/Customer.config.js.
 *
 * It turns the per-customer #/Customer/Workspace/:ID surface into the "Customer dashboard": the Overview tab is the
 * declarative FieldGroups (handled by the base), while Modules and Customer Team are bespoke `render` tabs lifted
 * from the old #/ManageCustomers screen and re-bound to THIS record's customer (no customer picker — the workspace
 * record fixes the customer). The header "Manage Configuration" action impersonates the customer's configuration
 * admin through the single app seam (PlatformConfiguration-Application-Web.impersonateCustomerAdmin).
 *
 * Tenancy: a level-5 super-user's Meadow reads/writes are NOT customer-scoped, so every module read/write passes an
 * explicit IDCustomer and every write re-reads to confirm it took (the server can silently no-op an unauthorized
 * write). See [[config-app-customer-dashboard]], [[config-app-data-downloader-and-modules]],
 * [[manage-customers-impersonation]].
 */
class CustomerWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._customer = null;
		// Bespoke-tab UI state (kept off the base `state` getter, which is a read-only AppData bag).
		this._mc =
		{
			// Modules tab — enable/disable CustomerModuleJoin rows for THIS customer.
			ModulesCatalog: [], ModulesJoins: [], ModulesLoaded: false, ModulesLoading: false, ModulesError: '', ModulesFilter: '', ModulesBusyHash: '',
			// Customer Team tab — cross-customer search + platform-admin marker (who may impersonate).
			TeamSearch: '', TeamResults: [], TeamSearching: false, TeamError: '',
			// Grants tab — read-only view of this customer's users and the roles/groups they hold.
			GrantsUsers: [], GrantsLoaded: false, GrantsLoading: false, GrantsError: '', GrantsFilter: '', GrantsTruncated: false,
			// Header dashboard metrics — live counts loaded once per customer.
			Counts: {}, CountsLoaded: false, CountsLoading: false,
		};
		this._teamSearchTimer = null;
		this._teamSearchToken = 0;
	}

	// --- seams + helpers -------------------------------------------------------------------------------------
	get app() { return this.pict.PictApplication; }
	/** The shared pict-section-modal (confirm/toast); guarded — it may be absent. */
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); } }

	// Reject-on-error REST (the lifted module/team code relies on throw/catch for its error paths; the base's own
	// `_getJSON`/`_postJSON` resolve null/{error} instead, so keep these distinct and leave the base helpers alone).
	_get(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_put(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_post(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_del(pEntity, pID) { return new Promise((resolve, reject) => this.restClient.deleteEntity(pEntity, pID, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }

	// --- permission gates (delegate to the app's single gates) -----------------------------------------------
	get isSuperUser() { return !!(this.app && (typeof this.app._isSuperUser === 'function') && this.app._isSuperUser()); }

	/**
	 * Manually trigger a SCOPED Configuration Sync for this customer (header action; super-user only). Confirms,
	 * then fires immediately (no debounce) against the scoped endpoint, which rebuilds only this customer and its
	 * projects — not the whole platform.
	 * @return {Promise<void>}
	 */
	async syncConfiguration()
	{
		if (!this.idCustomer) { return; }
		const tmpName = (this._customer && this._customer.Name) || `Customer ${this.idCustomer}`;
		const tmpConfirmed = (this.modal && (typeof this.modal.confirm === 'function'))
			? await this.modal.confirm(`Run a configuration sync for ${tmpName}? This publishes the customer's observation-type configuration (and its projects') out to the field apps. It runs in the background and may take a little while.`,
				{ title: 'Run configuration sync?', confirmLabel: 'Run sync', cancelLabel: 'Cancel' })
			: true;
		if (!tmpConfirmed) { return; }
		libConfigSync.requestScopedSync(this.pict, 'Customer', Number(this.idCustomer), { immediate: true });
	}
	get canManageTeam() { return !!(this.app && (typeof this.app._canManageCustomerTeam === 'function') && this.app._canManageCustomerTeam()); }
	canImpersonate() { return !!(this.app && (typeof this.app.canImpersonate === 'function') && this.app.canImpersonate()); }

	/** The customer id this workspace is bound to (the loaded record's id). */
	get idCustomer() { return Number(this._id) || Number(this._customer && this._customer.IDCustomer) || 0; }

	/** Base calls this after the record loads — capture it + reset per-customer bespoke-tab state. */
	async hydrateAsync(pRecord)
	{
		this._customer = pRecord || {};
		// Reset the per-customer module joins + team search; the module CATALOG persists across records (it is global).
		this._mc.ModulesJoins = [];
		this._mc.ModulesLoaded = false;
		this._mc.ModulesLoading = false;
		this._mc.ModulesError = '';
		this._mc.ModulesFilter = '';
		this._mc.ModulesBusyHash = '';
		this._mc.TeamSearch = '';
		this._mc.TeamResults = [];
		this._mc.TeamSearching = false;
		this._mc.TeamError = '';
		this._mc.GrantsUsers = [];
		this._mc.GrantsLoaded = false;
		this._mc.GrantsLoading = false;
		this._mc.GrantsError = '';
		this._mc.GrantsFilter = '';
		this._mc.GrantsTruncated = false;
		this._mc.Counts = {};
		this._mc.CountsLoaded = false;
		this._mc.CountsLoading = false;
	}

	// --- header dashboard metrics -----------------------------------------------------------------------------
	// The live-counts strip under the title (Users / Projects / Modules / Config admins) that makes this a
	// dashboard. Rendered as the Header.Subtitle with placeholder slots, then filled by Header.AfterRender ->
	// _ensureCountsAsync (COUNT reads + the config-admin resolver), loaded once per customer.

	_fmtCount(pValue) { return (pValue === null || pValue === undefined) ? '—' : Number(pValue).toLocaleString(); }

	/** The header metrics strip; values are the loaded counts, or a placeholder until AfterRender fills them. */
	_headerMetricsHTML()
	{
		const tmpLoaded = this._mc.CountsLoaded;
		const tmpCounts = this._mc.Counts || {};
		const fMetric = (pLabel, pSlot, pKey) =>
			`<span class="cw-metric"><span class="cw-metric-label">${pLabel}</span>`
			+ `<span class="cw-metric-value" id="${pSlot}">${tmpLoaded ? this._esc(this._fmtCount(tmpCounts[pKey])) : '…'}</span></span>`;
		return `<div class="cw-metrics">`
			+ fMetric('Users', 'CW-M-Users', 'Users')
			+ fMetric('Projects', 'CW-M-Projects', 'Projects')
			+ fMetric('Modules', 'CW-M-Modules', 'Modules')
			+ fMetric('Config admins', 'CW-M-Admins', 'Admins')
			+ `</div>`;
	}

	_paintCounts()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpCounts = this._mc.Counts || {};
		const fSet = (pSel, pKey) => { if (tmpCA.getElement(pSel).length) { tmpCA.assignContent(pSel, this._esc(this._fmtCount(tmpCounts[pKey]))); } };
		fSet('#CW-M-Users', 'Users');
		fSet('#CW-M-Projects', 'Projects');
		fSet('#CW-M-Modules', 'Modules');
		fSet('#CW-M-Admins', 'Admins');
	}

	/** Header AfterRender — load the four at-a-glance counts once per customer, then fill the header slots. */
	async _ensureCountsAsync()
	{
		if (!this.idCustomer || this._mc.CountsLoading || this._mc.CountsLoaded) { return; }
		this._mc.CountsLoading = true;
		const tmpID = Number(this.idCustomer);
		const fCount = async (pURL) =>
		{
			try { const tmpRes = await this._get(pURL); return (tmpRes && typeof tmpRes.Count === 'number') ? tmpRes.Count : (Array.isArray(tmpRes) ? tmpRes.length : null); }
			catch (pError) { return null; }
		};
		const [ tmpUsers, tmpProjects, tmpModules ] = await Promise.all(
			[
				fCount(`Users/Count/FilteredTo/FBV~IDCustomer~EQ~${tmpID}~FBV~Deleted~EQ~0`),
				fCount(`Projects/Count/FilteredTo/FBV~IDCustomer~EQ~${tmpID}`),
				fCount(`CustomerModuleJoins/Count/FilteredTo/FBV~IDCustomer~EQ~${tmpID}`),
			]);
		let tmpAdmins = null;
		try { tmpAdmins = (await this._loadCustomerAdminAccounts(tmpID)).length; } catch (pError) { tmpAdmins = null; }
		this._mc.Counts = { Users: tmpUsers, Projects: tmpProjects, Modules: tmpModules, Admins: tmpAdmins };
		this._mc.CountsLoaded = true;
		this._mc.CountsLoading = false;
		this._paintCounts();
	}

	/** Overview = the base's declarative FieldGroups, then the per-customer metadata form appended underneath. */
	_renderOverview(pBodySel)
	{
		super._renderOverview(pBodySel);
		libEntityMetadataWorkspace.renderMetadataSection(this, pBodySel);
	}

	// --- header action: Manage Configuration -----------------------------------------------------------------
	/**
	 * Manage Configuration — load this customer's configuration-admin accounts and let you sign in as a SPECIFIC one
	 * (the roster + "Sign in as" picker, in a modal). Falls back to the server's auto-resolve seam when no modal is
	 * available. The per-account sign-in uses the app's `impersonateUser` seam (the proven per-user route).
	 */
	async manageConfiguration()
	{
		if (!this.idCustomer) { return; }
		if (!this.modal || (typeof this.modal.show !== 'function'))
		{
			if (this.app && (typeof this.app.impersonateCustomerAdmin === 'function')) { this.app.impersonateCustomerAdmin(this.idCustomer); }
			return;
		}
		let tmpAccounts;
		try { tmpAccounts = await this._loadCustomerAdminAccounts(this.idCustomer); }
		catch (pError) { this._toast(`Could not load configuration-admin accounts: ${(pError && pError.message) ? pError.message : pError}`, 'error'); return; }
		const tmpName = (this._customer && this._customer.Name) || `Customer ${this.idCustomer}`;
		if (!tmpAccounts.length)
		{
			this.modal.show({ title: 'Manage Configuration', closeable: true,
				content: `<p class="cw-modal-note">No configuration admin for <strong>${this._esc(tmpName)}</strong> yet — <a href="#/GrantAccess/${Number(this.idCustomer)}">grant one in Grants</a> first.</p>`,
				buttons: [ { Hash: 'close', Label: 'Close', Style: 'light' } ] });
			return;
		}
		const tmpContent = `<p class="cw-modal-note">Sign in as a configuration admin for <strong>${this._esc(tmpName)}</strong> to manage their configuration:</p>`
			+ `<div class="cw-modal-accounts">` + tmpAccounts.map((pAccount) =>
				`<button type="button" class="cw-account" onclick="_Pict.providers.CustomerWorkspace.impersonateAccount(${Number(pAccount.IDUser)})">`
				+ `<span class="cw-account-avatar"><i class="fas fa-user"></i></span>`
				+ `<span class="cw-account-id"><span class="cw-account-name">${this._esc(pAccount.Name)}</span><span class="cw-account-login">${this._esc(pAccount.LoginID || pAccount.Email || `#${pAccount.IDUser}`)}</span></span>`
				+ `<span class="cw-account-go">Sign in <i class="fas fa-arrow-right-to-bracket"></i></span>`
				+ `</button>`).join('') + `</div>`;
		this.modal.show({ title: 'Manage Configuration', content: tmpContent, closeable: true, buttons: [ { Hash: 'cancel', Label: 'Cancel', Style: 'light' } ] });
	}

	/** Sign in as a specific account via the app's per-user impersonation seam (reloads as them on success). */
	impersonateAccount(pIDUser)
	{
		if (this.app && (typeof this.app.impersonateUser === 'function')) { this.app.impersonateUser(Number(pIDUser)); }
	}

	/**
	 * Resolve a customer's impersonatable accounts — users holding a PermissionLevel-'CustomerAdmin' role in that
	 * customer (the config-app write gate). Mirrors the server's resolveCustomerAdminUser query, listing ALL of them.
	 */
	async _loadCustomerAdminAccounts(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		const tmpRoles = await this._get(`Roles/FilteredTo/FBV~IDCustomer~EQ~${tmpID}~FBV~PermissionLevel~EQ~CustomerAdmin~FBV~Deleted~EQ~0/0/200`);
		const tmpRoleIDs = (Array.isArray(tmpRoles) ? tmpRoles : []).map((pRole) => pRole.IDRole).filter(Boolean);
		if (!tmpRoleIDs.length) { return []; }
		const tmpJoins = await this._get(`UserRoleJoins/FilteredTo/FBL~IDRole~INN~${tmpRoleIDs.join(',')}/0/1000`);
		const tmpUserIDs = Array.from(new Set((Array.isArray(tmpJoins) ? tmpJoins : []).map((pJoin) => pJoin.IDUser).filter(Boolean)));
		if (!tmpUserIDs.length) { return []; }
		const tmpUsers = await this._get(`Users/FilteredTo/FBL~IDUser~INN~${tmpUserIDs.join(',')}~FBV~IDCustomer~EQ~${tmpID}~FBV~Deleted~EQ~0~FBV~Disabled~EQ~0/0/1000`);
		return (Array.isArray(tmpUsers) ? tmpUsers : [])
			.map((pUser) => ({ IDUser: pUser.IDUser, Name: libUserSearch.userLabel(pUser), LoginID: pUser.LoginID || '', Email: pUser.Email || '' }))
			.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
	}

	// --- Modules tab ----------------------------------------------------------------------------------------
	// A super-user's Meadow reads/writes are not customer-scoped, so this reads/writes THIS customer's rows by
	// passing an explicit IDCustomer. Enablement is a CustomerModuleJoin {IDCustomer, ModuleHash, Start/EndDate};
	// disable is a physical delete (no soft-delete column). The catalog is the global Module entity + the app's
	// gated downloadable-app modules (which have no catalog row — the join gate is keyed by ModuleHash).

	_modulesHTML()
	{
		if (!this.isSuperUser) { return `<div class="cw-note">Module licensing is available to platform super-users.</div>`; }
		return `<p class="cw-help">Enable or disable licensed <strong>Modules</strong> for this customer. A customer only sees a gated feature (e.g. the Data Downloader) once its module is enabled here. Changes take effect the next time that customer loads the app.</p>`
			+ `<div id="CW-ModuleResults" class="cw-module-results">${this._moduleResultsHTML()}</div>`;
	}

	_moduleResultsHTML()
	{
		if (this._mc.ModulesError) { return `<div class="cw-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._mc.ModulesError)}</div>`; }
		if (!this._mc.ModulesLoaded) { return '<div class="cw-note"><i class="fas fa-spinner fa-spin"></i> Loading modules…</div>'; }
		return `<input id="CW-ModuleFilter" class="cw-filter" type="text" autocomplete="off" placeholder="Filter modules by name…" value="${this._esc(this._mc.ModulesFilter)}" oninput="_Pict.providers.CustomerWorkspace.onModuleFilter(this.value)" />`
			+ `<div id="CW-ModuleList" class="cw-list">${this._moduleListHTML()}</div>`;
	}

	_moduleName(pModuleHash)
	{
		const tmpModule = (this._mc.ModulesCatalog || []).find((pModule) => pModule.ModuleHash === pModuleHash);
		return tmpModule ? tmpModule.Name : pModuleHash;
	}

	/** Is a module currently enabled for this customer (a join row whose [Start,End] window holds now)? */
	_isModuleEnabled(pModuleHash)
	{
		const tmpNow = (new Date()).toISOString();
		return (this._mc.ModulesJoins || []).some((pJoin) => (pJoin.ModuleHash === pModuleHash)
			&& (!pJoin.StartDate || String(pJoin.StartDate) <= tmpNow) && (!pJoin.EndDate || String(pJoin.EndDate) >= tmpNow));
	}

	_moduleListHTML()
	{
		const tmpTerm = String(this._mc.ModulesFilter || '').trim().toLowerCase();
		const tmpRows = (this._mc.ModulesCatalog || []).filter((pModule) =>
			!tmpTerm || (String(pModule.Name).toLowerCase().indexOf(tmpTerm) > -1) || (String(pModule.ModuleHash).toLowerCase().indexOf(tmpTerm) > -1));
		if (!tmpRows.length) { return `<div class="cw-note">${tmpTerm ? 'No modules match your filter.' : 'No modules in the catalog.'}</div>`; }
		return tmpRows.map((pModule) =>
		{
			const tmpOn = this._isModuleEnabled(pModule.ModuleHash);
			// On the HeadLight customer a guided module GENERATES its canonical template; elsewhere it clones it.
			const tmpGuidedIsHL = (Number(this.idCustomer) === libContractAdminTemplate.HEADLIGHT_IDCUSTOMER);
			const tmpAppTag = pModule.App ? ' <span class="cw-app-tag">Desktop app</span>' : '';
			const tmpBadge = tmpOn ? ' <span class="cw-badge">Enabled</span>' : '';
			const tmpBusy = (this._mc.ModulesBusyHash === pModule.ModuleHash);
			let tmpButton;
			if (tmpBusy) { tmpButton = '<button type="button" class="cw-btn" disabled><i class="fas fa-spinner fa-spin"></i></button>'; }
			else if (pModule.Guided && !tmpOn) { tmpButton = `<button type="button" class="cw-btn" onclick="_Pict.providers.CustomerWorkspace.setupContractAdmin()"><i class="fas fa-wand-magic-sparkles"></i> ${tmpGuidedIsHL ? 'Generate template' : 'Set up'}</button>`; }
				else if (pModule.Guided && tmpOn) { tmpButton = `<button type="button" class="cw-btn" title="${tmpGuidedIsHL ? 'Re-generate the template from the committed definition' : 'Re-clone the HeadLight template'} — non-destructive + idempotent" onclick="_Pict.providers.CustomerWorkspace.setupContractAdmin()"><i class="fas fa-rotate"></i> ${tmpGuidedIsHL ? 'Re-generate' : 'Re-sync'}</button> <button type="button" class="cw-btn cw-btn-remove" onclick="_Pict.providers.CustomerWorkspace.disableModule('${this._esc(pModule.ModuleHash)}')"><i class="fas fa-toggle-on"></i> Disable</button>`; }
			else if (tmpOn) { tmpButton = `<button type="button" class="cw-btn cw-btn-remove" onclick="_Pict.providers.CustomerWorkspace.disableModule('${this._esc(pModule.ModuleHash)}')"><i class="fas fa-toggle-on"></i> Disable</button>`; }
			else { tmpButton = `<button type="button" class="cw-btn" onclick="_Pict.providers.CustomerWorkspace.enableModule('${this._esc(pModule.ModuleHash)}')"><i class="fas fa-toggle-off"></i> Enable</button>`; }
			return `<div class="cw-row">`
				+ `<span class="cw-col-name">${this._esc(pModule.Name || pModule.ModuleHash)}${tmpAppTag}${tmpBadge}</span>`
				+ `<span class="cw-col-code">${this._esc(pModule.ModuleHash)}</span>`
				+ `<span class="cw-col-action">${tmpButton}</span>`
				+ `</div>`;
		}).join('');
	}

	onModuleFilter(pValue) { this._mc.ModulesFilter = pValue; this._renderModuleList(); }

	/** Tab OnEnter — load the catalog (once) + this customer's joins, then repaint the results region. */
	async _ensureModulesAsync()
	{
		if (!this.isSuperUser || this._mc.ModulesLoading) { return; }
		if (this._mc.ModulesLoaded) { return; }
		this._mc.ModulesLoading = true;
		this._mc.ModulesError = '';
		this._renderModuleResults();
		try
		{
			if (!this._mc.ModulesCatalog.length)
			{
				const tmpCatalog = await this._get('Modules/0/500');
				const tmpRows = (Array.isArray(tmpCatalog) ? tmpCatalog : [])
					.map((pModule) => ({ ModuleHash: pModule.ModuleHash, Name: pModule.Name || pModule.ModuleHash, Ordinal: Number(pModule.Ordinal) || 0, App: false }))
					.filter((pModule) => !!pModule.ModuleHash);
				const tmpHave = {};
				tmpRows.forEach((pModule) => { tmpHave[pModule.ModuleHash] = true; });
				(((libDataDownloaderProvider && libDataDownloaderProvider.DOWNLOAD_MODULES) || [])).forEach((pApp) =>
				{
					if (pApp && pApp.ModuleHash && !tmpHave[pApp.ModuleHash]) { tmpRows.push({ ModuleHash: pApp.ModuleHash, Name: pApp.Name || pApp.ModuleHash, Ordinal: 900, App: true }); }
				});
				// Contract Administration — config-app-defined module with a guided Set-up action (see _moduleListHTML).
				if (!tmpHave[libContractAdminTemplate.MODULE_HASH])
				{
					tmpRows.push({ ModuleHash: libContractAdminTemplate.MODULE_HASH, Name: libContractAdminTemplate.MODULE_NAME, Ordinal: libContractAdminTemplate.MODULE_ORDINAL, App: false, Guided: true });
				}
				this._mc.ModulesCatalog = tmpRows.sort((pA, pB) => (pA.Ordinal - pB.Ordinal) || String(pA.Name).localeCompare(String(pB.Name)));
			}
			await this._refreshJoins();
			this._mc.ModulesLoaded = true;
		}
		catch (pError)
		{
			this._mc.ModulesError = `Could not load modules: ${(pError && pError.message) ? pError.message : pError}`;
		}
		this._mc.ModulesLoading = false;
		this._renderModuleResults();
	}

	async _refreshJoins()
	{
		const tmpJoins = await this._get(`CustomerModuleJoins/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}/0/500`);
		this._mc.ModulesJoins = Array.isArray(tmpJoins) ? tmpJoins : [];
	}

	_renderModuleResults() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#CW-ModuleResults').length) { tmpCA.assignContent('#CW-ModuleResults', this._moduleResultsHTML()); } }
	_renderModuleList() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#CW-ModuleList').length) { tmpCA.assignContent('#CW-ModuleList', this._moduleListHTML()); } }

	async enableModule(pModuleHash)
	{
		if (!this.idCustomer || this._mc.ModulesBusyHash) { return; }
		this._mc.ModulesBusyHash = pModuleHash;
		this._renderModuleList();
		try
		{
			const tmpSaved = await this._post('CustomerModuleJoin',
				{ IDCustomer: Number(this.idCustomer), ModuleHash: pModuleHash, IDProgram: 0, StartDate: '2000-01-01T00:00:00.000Z', EndDate: '2050-01-01T00:00:00.000Z' });
			if (tmpSaved && tmpSaved.ErrorCode) { throw new Error('the server rejected the change'); }
			await this._refreshJoins();
			// The server may silently no-op an unauthorized write (empty body, no ErrorCode) — confirm it took.
			if (!this._isModuleEnabled(pModuleHash)) { throw new Error('the change did not take effect (you may not have permission).'); }
			this._toast(`Enabled ${this._moduleName(pModuleHash)} for this customer.`, 'success');
		}
		catch (pError)
		{
			this._toast(`Could not enable the module: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
		this._mc.ModulesBusyHash = '';
		this._renderModuleList();
	}

	disableModule(pModuleHash)
	{
		if (!this.idCustomer || this._mc.ModulesBusyHash) { return; }
		const tmpJoins = (this._mc.ModulesJoins || []).filter((pJoin) => pJoin.ModuleHash === pModuleHash);
		if (!tmpJoins.length) { return; }
		const fGo = async () =>
		{
			this._mc.ModulesBusyHash = pModuleHash;
			this._renderModuleList();
			try
			{
				for (const pJoin of tmpJoins) { await this._del('CustomerModuleJoin', Number(pJoin.IDCustomerModuleJoin)); }
				await this._refreshJoins();
				if (this._isModuleEnabled(pModuleHash)) { throw new Error('the change did not take effect (you may not have permission).'); }
				this._toast(`Disabled ${this._moduleName(pModuleHash)} for this customer.`, 'success');
			}
			catch (pError)
			{
				this._toast(`Could not disable the module: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			}
			this._mc.ModulesBusyHash = '';
			this._renderModuleList();
		};
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(`Disable ${this._moduleName(pModuleHash)} for this customer? This removes their access to the feature.`,
				{ title: 'Disable module', confirmLabel: 'Disable', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fGo(); } });
		}
		else { fGo(); }
	}

	/**
	 * Guided "Set up Contract Administration" for THIS customer — the non-destructive replacement for the retired
	 * #/ContractAdmin screen. Enables the module (CustomerModuleJoin), grants the Module-ContractAdmin-Access
	 * capability to the customer's config-admin group, and clones the HeadLight (cust 1) template: the Payment and
	 * Change Order forms, the two default approval workflows, and their bindings. Idempotent + safe to re-run.
	 */
	setupContractAdmin()
	{
		const tmpHash = libContractAdminTemplate.MODULE_HASH;
		if (!this.idCustomer || this._mc.ModulesBusyHash) { return; }
		const tmpName = (this._customer && this._customer.Name) || `Customer ${this.idCustomer}`;
		// On HeadLight (cust 1) this GENERATES the canonical template from the committed definition (the source of
		// truth); on every other customer it CLONES the HeadLight template.
		const tmpIsHeadLight = (Number(this.idCustomer) === libContractAdminTemplate.HEADLIGHT_IDCUSTOMER);
		const fGo = async () =>
		{
			this._mc.ModulesBusyHash = tmpHash;
			this._renderModuleList();
			const tmpProv = this.pict.providers.ContractAdminProvisioning;
			try
			{
				if (!tmpProv) { throw new Error('the Contract Administration provisioner is unavailable'); }
				// 1) Enable the module (CustomerModuleJoin) if it is not already on.
				if (!this._isModuleEnabled(tmpHash))
				{
					const tmpSaved = await this._post('CustomerModuleJoin',
						{ IDCustomer: Number(this.idCustomer), ModuleHash: tmpHash, IDProgram: 0, StartDate: '2000-01-01T00:00:00.000Z', EndDate: '2050-01-01T00:00:00.000Z' });
					if (tmpSaved && tmpSaved.ErrorCode) { throw new Error('the server rejected enabling the module'); }
					await this._refreshJoins();
					if (!this._isModuleEnabled(tmpHash)) { throw new Error('enabling the module did not take effect (you may not have permission).'); }
				}
				// 2) Grant the capability that actually gates the Contract-Admin screens.
				await tmpProv.grantCapabilityAsync(Number(this.idCustomer));
				// 3) Materialize the template — GENERATE from the committed definition on HeadLight, or CLONE from HeadLight elsewhere.
				const tmpTemplateResult = tmpIsHeadLight
					? await tmpProv.generateHeadLightTemplateAsync()
					: await tmpProv.cloneToCustomerAsync(Number(this.idCustomer));
				const tmpVerb = tmpIsHeadLight ? 'generated on HeadLight' : `set up for ${tmpName}`;
				if (tmpTemplateResult && Array.isArray(tmpTemplateResult.Errors) && tmpTemplateResult.Errors.length)
				{
					this._toast(`Contract Administration ${tmpVerb} with warnings: ${tmpTemplateResult.Errors.join('; ')}`, 'warning');
				}
				else
				{
					this._toast(`Contract Administration ${tmpVerb} — forms, approval workflows, and bindings are in place.`, 'success');
				}
			}
			catch (pError)
			{
				this._toast(`Could not set up Contract Administration: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			}
			this._mc.ModulesBusyHash = '';
			this._renderModuleList();
		};
		const tmpConfirmMsg = tmpIsHeadLight
			? `Generate / refresh the Contract Administration template on HeadLight? This creates (or updates) the Payment and Change Order forms, the two default approval workflows, and their bindings — the canonical template every other customer is cloned from. It is non-destructive and safe to re-run.`
			: `Set up Contract Administration for ${tmpName}? This enables the module and adds the Payment and Change Order forms, the default approval workflows, and their bindings — cloned from the HeadLight template. It is non-destructive and safe to re-run.`;
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(tmpConfirmMsg,
				{ title: tmpIsHeadLight ? 'Generate Contract-Admin template' : 'Set up Contract Administration', confirmLabel: tmpIsHeadLight ? 'Generate' : 'Set up', cancelLabel: 'Cancel' })
				.then((pOk) => { if (pOk) { fGo(); } });
		}
		else { fGo(); }
	}

	// --- Customer Team tab ----------------------------------------------------------------------------------
	// The non-level-5 HeadLight users who may impersonate a customer's configuration admin — the internal support
	// team. Marked by Classification='Headlight_Platform_Admin' + PersistentPassword. Cross-customer search rides
	// the super-user session (like Grant Access). This roster is platform-wide, shown on every customer dashboard.

	_isPlatformAdmin(pUser) { return (pUser.Classification === 'Headlight_Platform_Admin') && ((Number(pUser.PersistentPassword) === 1) || (pUser.PersistentPassword === true)); }

	_teamHTML()
	{
		if (!this.canManageTeam) { return `<div class="cw-note">Managing the Headlight platform team requires the “Manage Customer Team” entitlement.</div>`; }
		return `<p class="cw-help">The <strong>Headlight platform team</strong> — the internal users (not customer level-5 admins) who may impersonate a customer&#8217;s configuration admin. Search any user, across every customer, and add or remove them. This sets the user&#8217;s <code>Classification</code> and <code>PersistentPassword</code>, and applies platform-wide.</p>`
			+ `<input id="CW-TeamSearch" class="cw-filter" type="text" autocomplete="off" placeholder="Search users by name, login ID or email…" value="${this._esc(this._mc.TeamSearch)}" oninput="_Pict.providers.CustomerWorkspace.onTeamSearch(this.value)" />`
			+ `<div id="CW-TeamResults" class="cw-list">${this._teamResultsHTML()}</div>`;
	}

	_teamResultsHTML()
	{
		if (this._mc.TeamError) { return `<div class="cw-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._mc.TeamError)}</div>`; }
		if (this._mc.TeamSearching) { return '<div class="cw-note"><i class="fas fa-spinner fa-spin"></i> Searching…</div>'; }
		const tmpTerm = String(this._mc.TeamSearch || '').trim();
		if (tmpTerm.length < 2) { return '<div class="cw-note">Type at least 2 characters to search users.</div>'; }
		const tmpRows = this._mc.TeamResults;
		if (!tmpRows.length) { return '<div class="cw-note">No users match your search.</div>'; }
		return tmpRows.map((pUser) =>
		{
			const tmpIsAdmin = this._isPlatformAdmin(pUser);
			const tmpBadge = tmpIsAdmin ? ' <span class="cw-badge">Platform team</span>' : '';
			const tmpButton = tmpIsAdmin
				? `<button type="button" class="cw-btn cw-btn-remove" onclick="_Pict.providers.CustomerWorkspace.togglePlatformAdmin(${Number(pUser.IDUser)}, false)"><i class="fas fa-user-minus"></i> Remove from team</button>`
				: `<button type="button" class="cw-btn" onclick="_Pict.providers.CustomerWorkspace.togglePlatformAdmin(${Number(pUser.IDUser)}, true)"><i class="fas fa-user-plus"></i> Add to team</button>`;
			return `<div class="cw-row">`
				+ `<span class="cw-col-name">${this._esc(libUserSearch.userLabel(pUser))}${tmpBadge}</span>`
				+ `<span class="cw-col-code">${this._esc(pUser.Email || '')}</span>`
				+ `<span class="cw-col-action">${tmpButton}</span>`
				+ `</div>`;
		}).join('');
	}

	/** Debounced cross-customer user search; only the results re-render, so the search input keeps focus. */
	onTeamSearch(pValue)
	{
		this._mc.TeamSearch = pValue;
		if (this._teamSearchTimer) { clearTimeout(this._teamSearchTimer); }
		this._teamSearchTimer = setTimeout(() => { this._teamSearchTimer = null; this._teamSearchAsync(); }, 250);
	}

	async _teamSearchAsync()
	{
		const tmpTerm = String(this._mc.TeamSearch || '').trim();
		const tmpToken = ++this._teamSearchToken;
		if (tmpTerm.length < 2)
		{
			this._mc.TeamResults = [];
			this._mc.TeamSearching = false;
			this._mc.TeamError = '';
			this._renderTeamResults();
			return;
		}
		this._mc.TeamSearching = true;
		this._mc.TeamError = '';
		this._renderTeamResults();
		try
		{
			// Cross-customer (no customer clause) — the super-user session may search everyone (like Grant Access).
			const tmpUsers = await libUserSearch.searchUsersAsync((pURL) => this._get(pURL), tmpTerm, { PageSize: 50 });
			if (tmpToken !== this._teamSearchToken)
			{
				return;
			}
			this._mc.TeamResults = tmpUsers;
		}
		catch (pError)
		{
			if (tmpToken !== this._teamSearchToken)
			{
				return;
			}
			this._mc.TeamResults = [];
			this._mc.TeamError = 'Could not search users. Try again.';
		}
		this._mc.TeamSearching = false;
		this._renderTeamResults();
	}

	_renderTeamResults() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#CW-TeamResults').length) { tmpCA.assignContent('#CW-TeamResults', this._teamResultsHTML()); } }

	/** Add/remove a user from the platform team by setting Classification + PersistentPassword (no IDCustomer sent). */
	togglePlatformAdmin(pIDUser, pOn)
	{
		const tmpUser = (this._mc.TeamResults || []).find((pUser) => Number(pUser.IDUser) === Number(pIDUser));
		if (!tmpUser) { return; }
		const tmpPayload = { IDUser: Number(pIDUser), Classification: pOn ? 'Headlight_Platform_Admin' : '', PersistentPassword: pOn ? 1 : 0 };
		this._put('User', tmpPayload).then((pSaved) =>
		{
			if (!pSaved || pSaved.ErrorCode)
			{
				this._toast('Could not update the user (you may not have permission).', 'error');
				return;
			}
			tmpUser.Classification = tmpPayload.Classification;
			tmpUser.PersistentPassword = tmpPayload.PersistentPassword;
			this._toast(pOn ? `Added ${libUserSearch.userLabel(tmpUser)} to the platform team.` : `Removed ${libUserSearch.userLabel(tmpUser)} from the platform team.`, 'success');
			this._renderTeamResults();
		}).catch((pError) =>
		{
			this._toast(`Could not update the user: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		});
	}

	// --- Grants tab -----------------------------------------------------------------------------------------
	// A READ-ONLY grid of this customer's users and the roles/groups they hold (direct customer + global grants
	// + base permission level). Editing lives in the deep #/GrantAccess screen (the launch button) or via
	// impersonation. A super-user's Meadow reads are NOT customer-scoped, so every read passes an explicit
	// IDCustomer. We deliberately avoid a per-user permission fold (N+1): three list reads — users, roles, and
	// user-role-joins — are joined client-side. Group-inherited and project/lab grants show in the deep screen.

	/** The user's base-level (User.IDRole 0-5) name, mirroring the #/GrantAccess USER_LEVEL_NAMES. */
	_levelLabel(pLevel)
	{
		const tmpNames = { 0: 'Read Only', 1: 'Field Personnel', 2: 'Office Staff', 3: 'Office Manager', 4: 'Executive Manager', 5: 'Pavia Administrator' };
		const tmpKey = Number(pLevel);
		return Object.prototype.hasOwnProperty.call(tmpNames, tmpKey) ? tmpNames[tmpKey] : `Level ${pLevel}`;
	}

	_grantsHTML()
	{
		if (!this.isSuperUser) { return `<div class="cw-note">Access &amp; grants are available to platform super-users.</div>`; }
		return `<p class="cw-help">The users in this customer and the <strong>roles &amp; groups</strong> they hold — a read-only overview (direct customer grants + base permission level). Group-inherited and project/lab grants, and any changes, live in the full <strong>Grant Access</strong> screen.</p>`
			+ `<p class="cw-actions"><a class="cw-btn" href="#/GrantAccess/${Number(this.idCustomer)}"><i class="fas fa-user-lock"></i> Manage grants…</a></p>`
			+ `<div id="CW-GrantResults" class="cw-grant-results">${this._grantResultsHTML()}</div>`;
	}

	_grantResultsHTML()
	{
		if (this._mc.GrantsError) { return `<div class="cw-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._mc.GrantsError)}</div>`; }
		if (!this._mc.GrantsLoaded) { return '<div class="cw-note"><i class="fas fa-spinner fa-spin"></i> Loading grants…</div>'; }
		return `<input id="CW-GrantFilter" class="cw-filter" type="text" autocomplete="off" placeholder="Filter users by name, login or role…" value="${this._esc(this._mc.GrantsFilter)}" oninput="_Pict.providers.CustomerWorkspace.onGrantFilter(this.value)" />`
			+ `<div id="CW-GrantList" class="cw-list">${this._grantListHTML()}</div>`
			+ (this._mc.GrantsTruncated ? `<div class="cw-note">Showing the first 500 users — use <strong>Manage grants…</strong> to search the rest.</div>` : '');
	}

	_grantListHTML()
	{
		const tmpUsers = this._mc.GrantsUsers || [];
		if (!tmpUsers.length) { return `<div class="cw-note">This customer has no active users.</div>`; }
		const tmpTerm = String(this._mc.GrantsFilter || '').trim().toLowerCase();
		const tmpRows = tmpUsers.filter((pUser) =>
		{
			if (!tmpTerm) { return true; }
			const tmpRoleText = (pUser.Roles || []).map((pRole) => pRole.Name).join(' ').toLowerCase();
			return (String(pUser.Name).toLowerCase().indexOf(tmpTerm) > -1)
				|| (String(pUser.LoginID).toLowerCase().indexOf(tmpTerm) > -1)
				|| (tmpRoleText.indexOf(tmpTerm) > -1);
		});
		if (!tmpRows.length) { return `<div class="cw-note">No users match your filter.</div>`; }
		return tmpRows.map((pUser) =>
		{
			const tmpLevel = `<span class="cw-badge cw-badge-level">${this._esc(pUser.LevelLabel)}</span>`;
			const tmpRoleChips = (pUser.Roles || []).length
				? (pUser.Roles || []).map((pRole) => `<span class="cw-badge">${this._esc(pRole.Name)}</span>`).join('')
				: '<span class="cw-muted">no additional roles</span>';
			const tmpDisabled = pUser.Disabled ? ' <span class="cw-muted">(disabled)</span>' : '';
			return `<div class="cw-row cw-grant-row">`
				+ `<span class="cw-col-name">${this._esc(pUser.Name)}${tmpDisabled}</span>`
				+ `<span class="cw-col-code">${this._esc(pUser.LoginID)}</span>`
				+ `<span class="cw-col-grants">${tmpLevel}${tmpRoleChips}</span>`
				+ `</div>`;
		}).join('');
	}

	onGrantFilter(pValue) { this._mc.GrantsFilter = pValue; this._renderGrantList(); }

	_renderGrantResults() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#CW-GrantResults').length) { tmpCA.assignContent('#CW-GrantResults', this._grantResultsHTML()); } }
	_renderGrantList() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#CW-GrantList').length) { tmpCA.assignContent('#CW-GrantList', this._grantListHTML()); } }

	/** Tab OnEnter — load this customer's users + roles + role joins (3 batched reads, no per-user fan-out), then repaint. */
	async _ensureGrantsAsync()
	{
		if (!this.isSuperUser || this._mc.GrantsLoading) { return; }
		if (this._mc.GrantsLoaded) { return; }
		this._mc.GrantsLoading = true;
		this._mc.GrantsError = '';
		this._renderGrantResults();
		try
		{
			const tmpID = Number(this.idCustomer);
			// 1) This customer's active users (explicit IDCustomer — super-user reads are not tenancy-scoped).
			const tmpUsers = await this._get(`Users/FilteredTo/FBV~IDCustomer~EQ~${tmpID}~FBV~Deleted~EQ~0/0/500`);
			const tmpUserRows = (Array.isArray(tmpUsers) ? tmpUsers : []);
			this._mc.GrantsTruncated = (tmpUserRows.length >= 500);
			// 2) The roles/groups visible to this customer (its own + the seeded globals at IDCustomer 0).
			const tmpRoles = await this._get(`Roles/FilteredTo/FBL~IDCustomer~INN~0,${tmpID}~FBV~Deleted~EQ~0/0/500`).catch(() => []);
			const tmpRolesByID = {};
			(Array.isArray(tmpRoles) ? tmpRoles : []).forEach((pRole) => { if (pRole && pRole.IDRole) { tmpRolesByID[pRole.IDRole] = pRole; } });
			// 3) The direct role grants for THIS customer's users — batched by user id to keep URLs bounded.
			const tmpJoinsByUser = {};
			const tmpUserIDs = tmpUserRows.map((pUser) => pUser.IDUser).filter(Boolean);
			for (let i = 0; i < tmpUserIDs.length; i += 150)
			{
				const tmpBatch = tmpUserIDs.slice(i, i + 150);
				const tmpJoins = await this._get(`UserRoleJoins/FilteredTo/FBL~IDUser~INN~${tmpBatch.join(',')}/0/5000`).catch(() => []);
				(Array.isArray(tmpJoins) ? tmpJoins : []).forEach((pJoin) =>
				{
					if (!pJoin || !pJoin.IDUser || !pJoin.IDRole) { return; }
					(tmpJoinsByUser[pJoin.IDUser] = tmpJoinsByUser[pJoin.IDUser] || []).push(pJoin);
				});
			}
			// Fold into read-only display rows.
			this._mc.GrantsUsers = tmpUserRows.map((pUser) =>
			{
				const tmpSeen = {};
				const tmpRolesForUser = (tmpJoinsByUser[pUser.IDUser] || [])
					.map((pJoin) => ({ IDRole: pJoin.IDRole, Name: (tmpRolesByID[pJoin.IDRole] && tmpRolesByID[pJoin.IDRole].Name) || `Role #${pJoin.IDRole}` }))
					.filter((pRole) => { if (tmpSeen[pRole.IDRole]) { return false; } tmpSeen[pRole.IDRole] = true; return true; })
					.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
				return {
					IDUser: pUser.IDUser,
					Name: libUserSearch.userLabel(pUser),
					LoginID: pUser.LoginID || '',
					LevelLabel: this._levelLabel(pUser.IDRole),
					Disabled: (Number(pUser.Disabled) === 1) || (pUser.Disabled === true),
					Roles: tmpRolesForUser,
				};
			}).sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
			this._mc.GrantsLoaded = true;
		}
		catch (pError)
		{
			this._mc.GrantsError = `Could not load grants: ${(pError && pError.message) ? pError.message : pError}`;
		}
		this._mc.GrantsLoading = false;
		this._renderGrantResults();
	}
}

CustomerWorkspaceProvider.default_configuration = { ProviderIdentifier: 'CustomerWorkspace' };

module.exports = CustomerWorkspaceProvider;
module.exports.default_configuration = CustomerWorkspaceProvider.default_configuration;

},{"../access/User-Search.js":1064,"../contract-admin/ContractAdmin-Template.js":1087,"./ConfigSync.js":1313,"./DataDownloader-Provider.js":1330,"./EntityMetadataWorkspace-Provider.js":1339,"pict-section-workspace":1049}],1328:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');

// The New-Customer document type (ReportNamedInstance Hash) — stable across environments, so the New Customers tab
// filters on it rather than on an environment-specific project id. Provisioning requests are Documents of this type
// (back-filled existing customers carry a GUIDDocument of `NEWCUST-BF-<IDCustomer>`). See [[config-app-customer-dashboard]].
const NEW_CUSTOMER_DOCTYPE = 'HeadLight-NewCustomer';
const BACKFILL_GUID_PREFIX = 'NEWCUST-BF-';

/**
 * CustomersList-Provider — data + logic for the #/Customers screen. Two tabs share this provider + the Customers view:
 *  - "Customers" (the default): the customer roster (front door to the per-customer Customer workspace). Each row
 *    opens the workspace (#/Customer/Workspace/:IDCustomer) and — for a session that may impersonate — carries a
 *    "Manage Configuration" button that signs in as the customer's configuration admin.
 *  - "New Customers" (#/Customers/New): the provisioning-request Documents (type HeadLight-NewCustomer), each with a
 *    status badge; "+ New Customer" opens the provisioning wizard. Existing customers appear here as Provisioned.
 *
 * Replaces the old #/ManageCustomers list; the Modules + Customer Team tooling that used to sit beside it now lives
 * in the workspace (source/providers/CustomerWorkspace-Provider.js). See [[config-app-customer-dashboard]].
 */
class CustomersListProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this.state = { ViewMode: 'roster', Loaded: false, Loading: false, Error: '', Customers: [], Filter: '',
			// A customer row expands to list its configuration-admin accounts so you can sign in as a SPECIFIC one
			// (the roster + "Sign in as" picker the old #/ManageCustomers screen had — not a one-click auto-pick).
			ExpandedCustomerID: 0, AccountsByCustomer: {}, AccountsLoadingID: 0, AccountsError: '',
			// "New Customers" tab — the provisioning-request Documents.
			NewLoaded: false, NewLoading: false, NewError: '', NewDocs: [], NewFilter: '', NewStatusFilter: 'all', NewBusyID: 0 };
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get app() { return this.pict.PictApplication; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pError, pResult) => pError ? reject(pError) : resolve(pResult))); }
	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); } }

	/** UI gate for the Manage Configuration affordance (impersonation). The server stays authoritative. */
	canImpersonate() { return !!(this.app && (typeof this.app.canImpersonate === 'function') && this.app.canImpersonate()); }

	async loadAsync()
	{
		this.state.Loading = true;
		this.state.Error = '';
		this.render();
		try
		{
			// The server scopes the list to what this session may see (no client-side customer filter).
			const tmpRows = await this._getJSON('Customers/0/2000');
			this.state.Customers = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pCustomer) => ({ IDCustomer: pCustomer.IDCustomer, Name: pCustomer.Name || `Customer #${pCustomer.IDCustomer}`, Code: pCustomer.Code || '', Enabled: pCustomer.Enabled }))
				.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
			this.state.Loaded = true;
		}
		catch (pError)
		{
			this.state.Error = `Could not load customers: ${(pError && pError.message) ? pError.message : pError}`;
		}
		this.state.Loading = false;
		this.render();
	}

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#CL-Body').length === 0) { return; }
		tmpCA.assignContent('#CL-Body', this._bodyHTML());
	}

	/** Switch between the "Customers" roster and the "New Customers" request list (driven by the router per route). */
	setMode(pMode)
	{
		this.state.ViewMode = (pMode === 'new') ? 'new' : 'roster';
		if ((this.state.ViewMode === 'new') && !this.state.NewLoaded && !this.state.NewLoading) { this.loadNewCustomersAsync(); return; }
		this.render();
	}

	_bodyHTML()
	{
		return this._tabStripHTML() + ((this.state.ViewMode === 'new') ? this._newBodyHTML() : this._rosterBodyHTML());
	}

	_tabStripHTML()
	{
		const tmpNew = (this.state.ViewMode === 'new');
		return `<div class="cl-tabs">`
			+ `<a class="cl-tab${tmpNew ? '' : ' is-active'}" href="#/Customers"><i class="fas fa-city"></i> Customers</a>`
			+ `<a class="cl-tab${tmpNew ? ' is-active' : ''}" href="#/Customers/New"><i class="fas fa-wand-magic-sparkles"></i> New Customers</a>`
			+ `</div>`;
	}

	_rosterBodyHTML()
	{
		if (this.state.Loading && !this.state.Loaded) { return '<div class="cl-note"><i class="fas fa-spinner fa-spin"></i> Loading customers…</div>'; }
		if (this.state.Error) { return `<div class="cl-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.Error)}</div>`; }
		return `<input id="CL-Filter" class="cl-filter" type="text" autocomplete="off" placeholder="Filter customers by name or code…" value="${this._esc(this.state.Filter)}" oninput="_Pict.providers.CustomersList.onFilter(this.value)" />`
			+ `<div id="CL-List" class="cl-list">${this._listHTML()}</div>`;
	}

	/** Filter in place — only the list re-renders, so the filter input keeps focus. */
	onFilter(pValue) { this.state.Filter = pValue; this._renderList(); }

	_renderList()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpEl = tmpCA.getElement('#CL-List');
		if (!tmpEl || !tmpEl.length) { return; }
		const tmpTop = tmpEl[0].scrollTop;
		tmpCA.assignContent('#CL-List', this._listHTML());
		const tmpEl2 = tmpCA.getElement('#CL-List');
		if (tmpEl2 && tmpEl2.length) { tmpEl2[0].scrollTop = tmpTop; }
	}

	_listHTML()
	{
		const tmpTerm = String(this.state.Filter || '').trim().toLowerCase();
		const tmpRows = this.state.Customers.filter((pCustomer) =>
			!tmpTerm || (String(pCustomer.Name).toLowerCase().indexOf(tmpTerm) > -1) || (String(pCustomer.Code).toLowerCase().indexOf(tmpTerm) > -1));
		if (!tmpRows.length) { return `<div class="cl-note">${tmpTerm ? 'No customers match your filter.' : 'No customers available.'}</div>`; }
		const tmpCanImpersonate = this.canImpersonate();
		const tmpHeader = '<div class="cl-head-row"><span class="cl-col-name">Customer</span><span class="cl-col-code">Code</span><span class="cl-col-action"></span></div>';
		return tmpHeader + tmpRows.map((pCustomer) =>
		{
			const tmpID = Number(pCustomer.IDCustomer);
			const tmpExpanded = (Number(this.state.ExpandedCustomerID) === tmpID);
			const tmpManage = tmpCanImpersonate
				? `<button type="button" class="cl-btn cl-btn-ghost${tmpExpanded ? ' is-open' : ''}" title="Sign in as one of this customer's configuration-admin accounts" onclick="event.stopPropagation(); _Pict.providers.CustomersList.toggleAccounts(${tmpID})"><i class="fas fa-user-gear"></i> Manage Configuration <i class="fas fa-chevron-${tmpExpanded ? 'up' : 'down'} cl-btn-caret"></i></button>`
				: '';
			return `<div class="cl-item${tmpExpanded ? ' is-expanded' : ''}">`
				+ `<div class="cl-row" role="button" tabindex="0" title="Open this customer's workspace" onclick="_Pict.providers.CustomersList.openWorkspace(${tmpID})" onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();_Pict.providers.CustomersList.openWorkspace(${tmpID});}">`
				+ `<span class="cl-col-name">${this._esc(pCustomer.Name)}</span>`
				+ `<span class="cl-col-code">${pCustomer.Code ? this._esc(pCustomer.Code) : `#${this._esc(pCustomer.IDCustomer)}`}</span>`
				+ `<span class="cl-col-action">${tmpManage}<i class="fas fa-chevron-right cl-open-caret"></i></span>`
				+ `</div>`
				+ (tmpExpanded ? `<div class="cl-accounts">${this._accountsHTML(tmpID)}</div>` : '')
				+ `</div>`;
		}).join('');
	}


	/** Open a customer's workspace (Overview / Users / Modules / Customer Team). */
	openWorkspace(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		if (!tmpID) { return; }
		if ((typeof window !== 'undefined') && window.location) { window.location.hash = `#/Customer/Workspace/${tmpID}`; }
	}

	/** Expand (or collapse) a customer row to show its configuration-admin accounts. First expand loads them. No modal. */
	toggleAccounts(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		if (Number(this.state.ExpandedCustomerID) === tmpID) { this.state.ExpandedCustomerID = 0; this._renderList(); return; }
		this.state.ExpandedCustomerID = tmpID;
		this.state.AccountsError = '';
		if (!this.state.AccountsByCustomer[tmpID]) { this._loadAccountsAsync(tmpID); }
		this._renderList();
	}

	/**
	 * Load a customer's impersonatable accounts — the users who hold a PermissionLevel-'CustomerAdmin' role in that
	 * customer (the config-app write gate). Mirrors the server's resolveCustomerAdminUser query, but lists ALL of them.
	 * Cross-customer reads ride the super-user session (same pattern as SuperUserGrant / Entitlements).
	 */
	async _loadAccountsAsync(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		this.state.AccountsLoadingID = tmpID;
		this.state.AccountsError = '';
		this._renderList();
		try
		{
			const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${tmpID}~FBV~PermissionLevel~EQ~CustomerAdmin~FBV~Deleted~EQ~0/0/200`);
			const tmpRoleIDs = (Array.isArray(tmpRoles) ? tmpRoles : []).map((pRole) => pRole.IDRole).filter(Boolean);
			let tmpAccounts = [];
			if (tmpRoleIDs.length)
			{
				const tmpJoins = await this._getJSON(`UserRoleJoins/FilteredTo/FBL~IDRole~INN~${tmpRoleIDs.join(',')}/0/1000`);
				const tmpUserIDs = Array.from(new Set((Array.isArray(tmpJoins) ? tmpJoins : []).map((pJoin) => pJoin.IDUser).filter(Boolean)));
				if (tmpUserIDs.length)
				{
					// Only live, enabled users actually IN the target customer qualify (mirrors the server's gate).
					const tmpUsers = await this._getJSON(`Users/FilteredTo/FBL~IDUser~INN~${tmpUserIDs.join(',')}~FBV~IDCustomer~EQ~${tmpID}~FBV~Deleted~EQ~0~FBV~Disabled~EQ~0/0/1000`);
					tmpAccounts = (Array.isArray(tmpUsers) ? tmpUsers : [])
						.map((pUser) => ({ IDUser: pUser.IDUser, Name: libUserSearch.userLabel(pUser), LoginID: pUser.LoginID || '', Email: pUser.Email || '' }))
						.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
				}
			}
			if (Number(this.state.ExpandedCustomerID) === tmpID) { this.state.AccountsByCustomer[tmpID] = tmpAccounts; }
		}
		catch (pError)
		{
			if (Number(this.state.ExpandedCustomerID) === tmpID) { this.state.AccountsError = `Could not load accounts: ${(pError && pError.message) ? pError.message : pError}`; }
		}
		this.state.AccountsLoadingID = 0;
		this._renderList();
	}

	/** The impersonatable accounts for one customer: loading / error / empty / a list of "Sign in as" account buttons. */
	_accountsHTML(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		if (this.state.AccountsError) { return `<div class="cl-accounts-note cl-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.AccountsError)}</div>`; }
		const tmpAccounts = this.state.AccountsByCustomer[tmpID];
		if (!tmpAccounts) { return `<div class="cl-accounts-note cl-note"><i class="fas fa-spinner fa-spin"></i> Loading accounts…</div>`; }
		if (!tmpAccounts.length)
		{
			return `<div class="cl-accounts-note cl-note">No configuration admin for this customer yet — <a href="#/GrantAccess/${tmpID}">grant one in Grants</a> first.</div>`;
		}
		const tmpHead = '<div class="cl-accounts-head">Sign in as a configuration admin</div>';
		return tmpHead + tmpAccounts.map((pAccount) =>
			`<button type="button" class="cl-account" onclick="_Pict.providers.CustomersList.impersonateAccount(${Number(pAccount.IDUser)})">`
			+ `<span class="cl-account-avatar"><i class="fas fa-user"></i></span>`
			+ `<span class="cl-account-id"><span class="cl-account-name">${this._esc(pAccount.Name)}</span><span class="cl-account-login">${this._esc(pAccount.LoginID || pAccount.Email || `#${pAccount.IDUser}`)}</span></span>`
			+ `<span class="cl-account-go">Sign in <i class="fas fa-arrow-right-to-bracket"></i></span>`
			+ `</button>`).join('');
	}

	/** Sign in as a specific account (no modal) via the app's per-user impersonation seam. */
	impersonateAccount(pIDUser)
	{
		if (this.app && (typeof this.app.impersonateUser === 'function')) { this.app.impersonateUser(Number(pIDUser)); }
	}

	// ── New Customers tab ────────────────────────────────────────────────────────────────────────────────────

	/** Load the provisioning-request Documents (type HeadLight-NewCustomer). The session is HeadLight (customer 1). */
	async loadNewCustomersAsync()
	{
		this.state.NewLoading = true;
		this.state.NewError = '';
		this.render();
		try
		{
			const tmpRows = await this._getJSON(`Documents/FilteredTo/FBV~DocumentType~EQ~${NEW_CUSTOMER_DOCTYPE}~FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/2000`);
			this.state.NewDocs = (Array.isArray(tmpRows) ? tmpRows : []).map((pDoc) => (
			{
				IDDocument: pDoc.IDDocument,
				GUIDDocument: pDoc.GUIDDocument || '',
				Name: pDoc.Name || `Request #${pDoc.IDDocument}`,
				Status: pDoc.Status || 'Draft',
				StateName: pDoc.StateName || '',
				DocumentDate: pDoc.DocumentDate || '',
				Backfill: String(pDoc.GUIDDocument || '').indexOf(BACKFILL_GUID_PREFIX) === 0,
			})).sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
			this.state.NewLoaded = true;
		}
		catch (pError)
		{
			this.state.NewError = `Could not load new-customer requests: ${(pError && pError.message) ? pError.message : pError}`;
		}
		this.state.NewLoading = false;
		this.render();
	}

	/** A request is "Provisioned" when its customer exists — a back-fill (existing customer) or an Approved request. */
	_newStatus(pDoc)
	{
		const tmpState = String(pDoc.StateName || pDoc.Status || 'Draft');
		if (pDoc.Backfill || (tmpState === 'Approved')) { return { Label: 'Provisioned', Class: 'prov' }; }
		if (tmpState === 'Rejected') { return { Label: 'Rejected', Class: 'rej' }; }
		if ((tmpState === 'Submitted') || (tmpState === 'Pending')) { return { Label: 'Pending approval', Class: 'pend' }; }
		return { Label: 'Draft', Class: 'draft' };
	}

	_newBodyHTML()
	{
		if (this.state.NewLoading && !this.state.NewLoaded) { return '<div class="cl-note"><i class="fas fa-spinner fa-spin"></i> Loading new-customer requests…</div>'; }
		if (this.state.NewError) { return `<div class="cl-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.NewError)}</div>`; }
		const tmpTotal = this.state.NewDocs.length;
		const tmpProvisioned = this.state.NewDocs.filter((pDoc) => this._newStatus(pDoc).Class === 'prov').length;
		const tmpPending = tmpTotal - tmpProvisioned;
		const tmpSeg = (pKey, pLabel, pCount) =>
			`<button type="button" class="cl-seg${this.state.NewStatusFilter === pKey ? ' is-active' : ''}" onclick="_Pict.providers.CustomersList.onNewStatusFilter('${pKey}')">${pLabel} <span class="cl-seg-count">${pCount}</span></button>`;
		return `<div class="cl-newbar">`
			+ `<p class="cl-newsummary"><strong>${tmpTotal}</strong> new-customer request${tmpTotal === 1 ? '' : 's'} · ${tmpProvisioned} provisioned · ${tmpPending} in progress</p>`
			+ `<button type="button" class="cl-newbtn" onclick="_Pict.providers.CustomersList.startNewCustomer()"><i class="fas fa-plus"></i> New Customer</button>`
			+ `</div>`
			+ `<div class="cl-filterrow">`
			+ `<input id="CL-NewFilter" class="cl-filter cl-filter-inrow" type="text" autocomplete="off" placeholder="Filter requests by name…" value="${this._esc(this.state.NewFilter)}" oninput="_Pict.providers.CustomersList.onNewFilter(this.value)" />`
			+ `<div class="cl-segctl">${tmpSeg('all', 'All', tmpTotal)}${tmpSeg('provisioned', 'Provisioned', tmpProvisioned)}${tmpSeg('unprovisioned', 'Not provisioned', tmpPending)}</div>`
			+ `</div>`
			+ `<div id="CL-NewList" class="cl-list">${this._newListHTML()}</div>`;
	}

	_newListHTML()
	{
		const tmpTerm = String(this.state.NewFilter || '').trim().toLowerCase();
		const tmpStatusFilter = this.state.NewStatusFilter;
		const tmpRows = this.state.NewDocs.filter((pDoc) =>
		{
			if (tmpTerm && (String(pDoc.Name).toLowerCase().indexOf(tmpTerm) === -1)) { return false; }
			const tmpIsProv = (this._newStatus(pDoc).Class === 'prov');
			if ((tmpStatusFilter === 'provisioned') && !tmpIsProv) { return false; }
			if ((tmpStatusFilter === 'unprovisioned') && tmpIsProv) { return false; }
			return true;
		});
		if (!tmpRows.length) { return `<div class="cl-note">${(tmpTerm || (tmpStatusFilter !== 'all')) ? 'No requests match your filter.' : 'No new-customer requests yet.'}</div>`; }
		const tmpHeader = '<div class="cl-head-row"><span class="cl-col-name">Customer</span><span class="cl-col-status">Status</span><span class="cl-col-newactions"></span></div>';
		return tmpHeader + tmpRows.map((pDoc) =>
		{
			const tmpStatus = this._newStatus(pDoc);
			return `<div class="cl-item">`
				+ `<div class="cl-row cl-row-static">`
				+ `<span class="cl-col-name">${this._esc(pDoc.Name)}</span>`
				+ `<span class="cl-col-status"><span class="cl-badge cl-badge-${tmpStatus.Class}">${tmpStatus.Label}</span></span>`
				+ `<span class="cl-col-newactions">${this._newRowActions(pDoc, tmpStatus)}</span>`
				+ `</div>`
				+ `</div>`;
		}).join('');
	}

	/** Approval actions for an in-progress request: Draft → Submit; Submitted/Pending → Approve/Reject. */
	_newRowActions(pDoc, pStatus)
	{
		const tmpID = Number(pDoc.IDDocument);
		if (Number(this.state.NewBusyID) === tmpID) { return '<span class="cl-actbusy"><i class="fas fa-spinner fa-spin"></i></span>'; }
		if (pStatus.Class === 'draft')
		{
			return `<button type="button" class="cl-actbtn" onclick="_Pict.providers.CustomersList.transitionRequest(${tmpID},'Submit')"><i class="fas fa-paper-plane"></i> Submit</button>`;
		}
		if (pStatus.Class === 'pend')
		{
			return `<button type="button" class="cl-actbtn cl-actbtn-approve" onclick="_Pict.providers.CustomersList.transitionRequest(${tmpID},'Approve')"><i class="fas fa-check"></i> Approve</button>`
				+ `<button type="button" class="cl-actbtn cl-actbtn-reject" onclick="_Pict.providers.CustomersList.transitionRequest(${tmpID},'Reject')"><i class="fas fa-xmark"></i> Reject</button>`;
		}
		return '';
	}

	/**
	 * Drive an approval transition on a request Document (POST /1.0/DocumentApproval). Approve fires the document's
	 * OnEnteringState.Approved comprehension server-side, provisioning the customer. Reloads the list on success.
	 */
	transitionRequest(pIDDocument, pAction)
	{
		const tmpID = Number(pIDDocument);
		if (!tmpID || Number(this.state.NewBusyID)) { return; }
		const tmpDoc = this.state.NewDocs.find((pDoc) => Number(pDoc.IDDocument) === tmpID);
		const tmpName = tmpDoc ? tmpDoc.Name : `request #${tmpID}`;
		const fGo = async () =>
		{
			this.state.NewBusyID = tmpID;
			this._renderNewList();
			try
			{
				const tmpRes = await this._postJSON('DocumentApproval', { IDDocument: tmpID, Action: pAction });
				if (tmpRes && tmpRes.ErrorCode) { throw new Error(tmpRes.Error || 'the server rejected the transition'); }
				this.state.NewBusyID = 0;
				this.state.NewLoaded = false;
				await this.loadNewCustomersAsync();
				const tmpVerb = (pAction === 'Approve') ? 'Approved and provisioned' : (pAction === 'Reject') ? 'Rejected' : 'Submitted';
				this._toast(`${tmpVerb} "${tmpName}".`, 'success');
			}
			catch (pError)
			{
				this.state.NewBusyID = 0;
				this._toast(`Could not ${pAction.toLowerCase()} "${tmpName}": ${(pError && pError.message) ? pError.message : pError}`, 'error');
				this._renderNewList();
			}
		};
		// Approve (provisions) and Reject get a confirm; Submit is low-stakes.
		if (((pAction === 'Approve') || (pAction === 'Reject')) && this.modal && (typeof this.modal.confirm === 'function'))
		{
			const tmpMsg = (pAction === 'Approve')
				? `Approve "${tmpName}"? This provisions the customer, its admin and integration users, and roles.`
				: `Reject "${tmpName}"? The request stays in the list as Rejected.`;
			this.modal.confirm(tmpMsg, { title: `${pAction} request`, confirmLabel: pAction, cancelLabel: 'Cancel', dangerous: (pAction === 'Reject') }).then((pOk) => { if (pOk) { fGo(); } });
		}
		else { fGo(); }
	}

	onNewFilter(pValue) { this.state.NewFilter = pValue; this._renderNewList(); }

	/** Filter by provisioned status — re-render the body so the segmented control's active pill + the list both update. */
	onNewStatusFilter(pKey) { this.state.NewStatusFilter = ([ 'provisioned', 'unprovisioned' ].indexOf(pKey) > -1) ? pKey : 'all'; this.render(); }

	_renderNewList()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpEl = tmpCA.getElement('#CL-NewList');
		if (!tmpEl || !tmpEl.length) { return; }
		const tmpTop = tmpEl[0].scrollTop;
		tmpCA.assignContent('#CL-NewList', this._newListHTML());
		const tmpEl2 = tmpCA.getElement('#CL-NewList');
		if (tmpEl2 && tmpEl2.length) { tmpEl2[0].scrollTop = tmpTop; }
	}

	/** Start a new customer request — the provisioning wizard (which, once wired, saves a Draft request document). */
	startNewCustomer()
	{
		if ((typeof window !== 'undefined') && window.location) { window.location.hash = '#/CustomerProvisioning'; }
	}
}

CustomersListProvider.default_configuration = { ProviderIdentifier: 'CustomersList' };

module.exports = CustomersListProvider;
module.exports.default_configuration = CustomersListProvider.default_configuration;

},{"../access/User-Search.js":1064,"pict-provider":845}],1329:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libDashboardAccess = require('headlight-dashboard-access');

/**
 * @typedef {import('headlight-dashboard-access/source/Headlight-Dashboard-Access.js').AccessRule} AccessRule
 * @typedef {import('headlight-dashboard-access/source/Headlight-Dashboard-Access.js').FilterClause} FilterClause
 */

/** How many role matches the role search lists at once. */
const ROLE_SUGGESTION_LIMIT = 8;

/** The "typed value" choice in a filter row's value picker; every other choice is a token. */
const TYPED_VALUE = '';

/**
 * DashboardAccessConfig — the #/DashboardAccess screen. Edits the customer-level `DashboardAccess` configuration
 * (NamespaceValue `Rules`): which roles see which dashboards, the one each role opens first, and the data each dashboard
 * shows them. Platform data operations resolves the same rules (PlatformDashboard/Available) for every app that shows
 * dashboards; the preview here uses the same library, so it says exactly what a person will get.
 *
 * Same shape as Where Records Open (EntityDestinationsConfig-Provider.js): ordered rules, a searchable role picker, a
 * "who sees what" preview. Gated by the `DashboardAccess-Configure` entitlement; super-users may pick any customer.
 */
class DashboardAccessConfigProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get state()
	{
		if (!this.pict.AppData.DashboardAccessConfig)
		{
			this.pict.AppData.DashboardAccessConfig =
			{
				Loaded: false, Loading: false, Saving: false, Error: '', Message: '',
				TargetCustomerID: 0, TargetCustomerName: '', Customers: [],
				Rules: {}, Dirty: false,
				Roles: [], Dashboards: [], Fields: {},
				EditingKey: '', Draft: null,
				PreviewRoles: [],
				RoleSearch: { Draft: '', Preview: '' },
			};
		}
		return this.pict.AppData.DashboardAccessConfig;
	}

	get currentUser()
	{
		return this.pict.AppData.CurrentUser || {};
	}

	callerCustomer()
	{
		return Number(this.currentUser.CustomerID) || 0;
	}

	isSuperUser()
	{
		return (Number(this.currentUser.UserRoleIndex) === 5) && (Number(this.currentUser.CustomerID) === 1);
	}

	can()
	{
		const tmpService = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpService || (typeof tmpService.can !== 'function'))
		{
			return true;
		}
		return tmpService.can('DashboardAccess', 'Configure');
	}

	/**
	 * @param {string} pURL
	 * @return {Promise<any>} the body, or null on error
	 */
	_getJSON(pURL)
	{
		const tmpClient = this.restClient;
		if (!tmpClient)
		{
			return Promise.resolve(null);
		}
		return new Promise((fResolve) => tmpClient.getJSON(pURL, (pError, pBody) => fResolve(pError ? null : pBody)));
	}

	/**
	 * @param {string} pURL
	 * @param {Object} pBody
	 * @return {Promise<{ error: any, result: any }>}
	 */
	_postJSON(pURL, pBody)
	{
		const tmpClient = this.restClient;
		if (!tmpClient)
		{
			return Promise.resolve({ error: 'no client', result: null });
		}
		return new Promise((fResolve) => tmpClient.postJSON(pURL, pBody, (pError, pResult) => fResolve({ error: pError, result: pResult })));
	}

	/**
	 * @param {any} pValue
	 * @return {string}
	 */
	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/**
	 * @param {any} pValue
	 * @return {string} a JSON literal safe inside a single-quoted onclick attribute
	 */
	_arg(pValue)
	{
		return this._esc(JSON.stringify(pValue));
	}

	/** @return {Array<[string, AccessRule]>} rules in the order they are tried */
	orderedRules()
	{
		return Object.entries(this.state.Rules).sort(([ pKeyA, pA ], [ pKeyB, pB ]) => ((pA.Order ?? 100) - (pB.Order ?? 100)) || pKeyA.localeCompare(pKeyB));
	}

	/**
	 * @param {string} pHash
	 * @return {{ Hash: string, Title: string, Kind: string, ProjectBound: boolean, SchemaURL: string|null }}
	 */
	dashboard(pHash)
	{
		return this.state.Dashboards.find((pDashboard) => pDashboard.Hash === pHash) || { Hash: pHash, Title: `${pHash} (no longer exists)`, Kind: 'Missing', ProjectBound: false, SchemaURL: null };
	}

	/**
	 * @param {string} pHash
	 * @return {string}
	 */
	roleName(pHash)
	{
		return (this.state.Roles.find((pRole) => pRole.Hash === pHash) || { Name: pHash }).Name;
	}

	// --- Load -----------------------------------------------------------------------------------------------

	async loadAsync()
	{
		const tmpState = this.state;
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			if (this.isSuperUser())
			{
				const tmpCustomers = await this._getJSON('Customers/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/2000');
				tmpState.Customers = Array.isArray(tmpCustomers) ? tmpCustomers.map((pCustomer) => ({ IDCustomer: pCustomer.IDCustomer, Name: pCustomer.Name })) : [];
			}
			if (!tmpState.TargetCustomerID)
			{
				tmpState.TargetCustomerID = this.callerCustomer();
			}
			await this._loadCustomerAsync(tmpState.TargetCustomerID);
			tmpState.Loaded = true;
		}
		catch (pError)
		{
			tmpState.Error = `Could not load dashboard access: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	/**
	 * @param {number} pIDCustomer
	 */
	async _loadCustomerAsync(pIDCustomer)
	{
		const tmpState = this.state;
		const tmpCustomer = await this._getJSON(`Customer/${Number(pIDCustomer)}`);
		tmpState.TargetCustomerName = (tmpCustomer && tmpCustomer.Name) || '';
		const tmpConfig = await this._getJSON(`Configuration/For/${libDashboardAccess.NAMESPACE}/In/Customer/${Number(pIDCustomer)}`);
		if (tmpConfig === null)
		{
			throw new Error('the saved settings could not be read');
		}
		const tmpRules = tmpConfig[libDashboardAccess.NAMESPACE_VALUE];
		tmpState.Rules = (tmpRules && typeof tmpRules === 'object') ? JSON.parse(JSON.stringify(tmpRules)) : {};
		tmpState.Dirty = false;
		tmpState.EditingKey = '';
		tmpState.Draft = null;
		tmpState.Fields = {};

		const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBL~IDCustomer~INN~0,${Number(pIDCustomer)}~FSF~Name~ASC~0/0/1000`);
		const tmpRoleRows = (Array.isArray(tmpRoles) ? tmpRoles : []).filter((pRole) => pRole && pRole.GUIDRole && pRole.Name && !pRole.Deleted && pRole.Type !== 'PermissionGroup');
		const tmpNameCounts = tmpRoleRows.reduce((pCounts, pRole) => Object.assign(pCounts, { [pRole.Name]: (pCounts[pRole.Name] || 0) + 1 }), {});
		tmpState.Roles = tmpRoleRows.map((pRole) => ({ Hash: pRole.GUIDRole, Name: (tmpNameCounts[pRole.Name] > 1 && !Number(pRole.IDCustomer)) ? `${pRole.Name} (standard)` : pRole.Name, PermissionLevel: pRole.PermissionLevel || '' }));

		const tmpDashboards = await this._getJSON(`Dashboards/FilteredTo/FBV~IDCustomer~EQ~${Number(pIDCustomer)}~FSF~Ordinal~ASC~0/0/200`);
		tmpState.Dashboards = (Array.isArray(tmpDashboards) ? tmpDashboards : []).map((pRow) =>
		{
			let tmpDataSource = pRow.DataSource;
			if (!tmpDataSource || typeof tmpDataSource !== 'object')
			{
				try
				{
					tmpDataSource = JSON.parse(pRow.DataSourceJSON || '{}') || {};
				}
				catch (pError)
				{
					tmpDataSource = {};
				}
			}
			const tmpPrefix = String(tmpDataSource.URLPrefix || '/1.0/').replace(/^\/1\.0\//, '');
			return {
				Hash: pRow.Hash, Title: pRow.Name || pRow.Hash, Kind: 'Dynamic', ProjectBound: !!tmpDataSource.ProjectField,
				SchemaURL: tmpDataSource.Entity ? `${tmpPrefix}${tmpDataSource.Entity}/Schema` : null,
			};
		});
		// The legacy app_dashboards bundles (Fieldbook and the materials app show these today) can be granted too.
		const tmpLegacy = await this._getJSON(`Configuration/For/Dashboards/In/Customer/${Number(pIDCustomer)}`);
		for (const [ tmpKey, tmpEntry ] of Object.entries((tmpLegacy && typeof tmpLegacy === 'object') ? tmpLegacy : {}))
		{
			if (tmpEntry && typeof tmpEntry === 'object')
			{
				tmpState.Dashboards.push({ Hash: tmpEntry.DashboardHash || tmpKey, Title: tmpEntry.DisplayName || tmpKey, Kind: 'Legacy', ProjectBound: true, SchemaURL: null });
			}
		}
		tmpState.PreviewRoles = [];
		tmpState.RoleSearch = { Draft: '', Preview: '' };
	}

	async selectCustomer(pIDCustomer)
	{
		const tmpState = this.state;
		tmpState.TargetCustomerID = Number(pIDCustomer) || 0;
		tmpState.Message = '';
		tmpState.Error = '';
		tmpState.Loading = true;
		this.render();
		try
		{
			await this._loadCustomerAsync(tmpState.TargetCustomerID);
		}
		catch (pError)
		{
			tmpState.Error = `Could not load dashboard access: ${(pError && pError.message) || pError}`;
		}
		tmpState.Loading = false;
		this.render();
	}

	/**
	 * The columns a dashboard's data has, for the "limit the data" field picker. Fetched once per dashboard.
	 *
	 * @param {string} pHash
	 * @return {Promise<void>}
	 */
	async loadFieldsAsync(pHash)
	{
		const tmpState = this.state;
		if (tmpState.Fields[pHash])
		{
			return;
		}
		tmpState.Fields[pHash] = [];
		const tmpDashboard = this.dashboard(pHash);
		if (!tmpDashboard.SchemaURL)
		{
			return;
		}
		const tmpSchema = await this._getJSON(tmpDashboard.SchemaURL);
		const tmpProperties = (tmpSchema && (tmpSchema.properties || (tmpSchema.Schema && tmpSchema.Schema.properties))) || {};
		tmpState.Fields[pHash] = Object.keys(tmpProperties).filter((pField) => ![ 'CreateDate', 'UpdateDate', 'DeleteDate', 'Deleted', 'CreatingIDUser', 'UpdatingIDUser', 'DeletingIDUser' ].includes(pField)).sort();
		this.render();
	}

	// --- Rule list ------------------------------------------------------------------------------------------

	_markDirty()
	{
		this.state.Dirty = true;
		this.state.Message = '';
	}

	/**
	 * @param {Array<[string, AccessRule]>} pOrdered - The rules, in the order wanted.
	 */
	_renumber(pOrdered)
	{
		pOrdered.forEach(([ , pRule ], pIndex) =>
		{
			pRule.Order = (pIndex + 1) * 10;
		});
	}

	moveRule(pKey, pDelta)
	{
		const tmpOrdered = this.orderedRules();
		const tmpIndex = tmpOrdered.findIndex(([ pRuleKey ]) => pRuleKey === pKey);
		const tmpTarget = tmpIndex + Number(pDelta);
		if (tmpIndex < 0 || tmpTarget < 0 || tmpTarget >= tmpOrdered.length)
		{
			return;
		}
		const [ tmpMoved ] = tmpOrdered.splice(tmpIndex, 1);
		tmpOrdered.splice(tmpTarget, 0, tmpMoved);
		this._renumber(tmpOrdered);
		this._markDirty();
		this.render();
	}

	toggleRule(pKey)
	{
		const tmpRule = this.state.Rules[pKey];
		if (tmpRule)
		{
			tmpRule.Enabled = (tmpRule.Enabled === false);
			this._markDirty();
			this.render();
		}
	}

	removeRule(pKey)
	{
		delete this.state.Rules[pKey];
		if (this.state.EditingKey === pKey)
		{
			this.state.EditingKey = '';
			this.state.Draft = null;
		}
		this._renumber(this.orderedRules());
		this._markDirty();
		this.render();
	}

	// --- Rule editor ----------------------------------------------------------------------------------------

	editRule(pKey)
	{
		const tmpRule = this.state.Rules[pKey];
		if (!tmpRule)
		{
			return;
		}
		this.state.EditingKey = pKey;
		this.state.RoleSearch.Draft = '';
		this.state.Draft =
		{
			Label: tmpRule.Label || '',
			Roles: (tmpRule.Audience && Array.isArray(tmpRule.Audience.Roles)) ? tmpRule.Audience.Roles.slice() : [],
			Dashboards: Array.isArray(tmpRule.Dashboards) ? tmpRule.Dashboards.slice() : [],
			Landing: tmpRule.Landing || '',
			DataFilters: JSON.parse(JSON.stringify(tmpRule.DataFilters || {})),
			Extra: { Audience: Object.assign({}, tmpRule.Audience || {}) },
		};
		for (const tmpHash of Object.keys(this.state.Draft.DataFilters))
		{
			this.loadFieldsAsync(tmpHash);
		}
		this.render();
	}

	newRule()
	{
		this.state.EditingKey = '(new)';
		this.state.RoleSearch.Draft = '';
		this.state.Draft = { Label: '', Roles: [], Dashboards: [], Landing: '', DataFilters: {}, Extra: { Audience: {} } };
		this.render();
	}

	cancelEdit()
	{
		this.state.EditingKey = '';
		this.state.Draft = null;
		this.state.Error = '';
		this.render();
	}

	setDraft(pField, pValue)
	{
		if (this.state.Draft)
		{
			this.state.Draft[pField] = pValue;
		}
	}

	/**
	 * Tick or untick a dashboard in the rule being edited. Unticking drops its data limit and, if it was the
	 * "opens first" dashboard, that too.
	 *
	 * @param {string} pHash
	 */
	toggleDraftDashboard(pHash)
	{
		const tmpDraft = this.state.Draft;
		if (!tmpDraft)
		{
			return;
		}
		const tmpIndex = tmpDraft.Dashboards.indexOf(pHash);
		if (tmpIndex >= 0)
		{
			tmpDraft.Dashboards.splice(tmpIndex, 1);
			delete tmpDraft.DataFilters[pHash];
			if (tmpDraft.Landing === pHash)
			{
				tmpDraft.Landing = '';
			}
		}
		else
		{
			tmpDraft.Dashboards.push(pHash);
		}
		this.render();
	}

	/**
	 * @param {string} pHash
	 */
	setDraftLanding(pHash)
	{
		if (this.state.Draft)
		{
			this.state.Draft.Landing = (this.state.Draft.Landing === pHash) ? '' : pHash;
			this.render();
		}
	}

	/**
	 * @param {string} pHash
	 */
	addDraftFilter(pHash)
	{
		const tmpDraft = this.state.Draft;
		if (!tmpDraft)
		{
			return;
		}
		(tmpDraft.DataFilters[pHash] = tmpDraft.DataFilters[pHash] || []).push({ Field: '', Operator: 'EQ', Value: '' });
		this.loadFieldsAsync(pHash);
		this.render();
	}

	/**
	 * @param {string} pHash
	 * @param {number} pIndex
	 */
	removeDraftFilter(pHash, pIndex)
	{
		const tmpFilters = this.state.Draft && this.state.Draft.DataFilters[pHash];
		if (Array.isArray(tmpFilters))
		{
			tmpFilters.splice(Number(pIndex), 1);
			if (tmpFilters.length < 1)
			{
				delete this.state.Draft.DataFilters[pHash];
			}
			this.render();
		}
	}

	/**
	 * @param {string} pHash
	 * @param {number} pIndex
	 * @param {'Field'|'Operator'|'Value'|'ValueSource'} pPart
	 * @param {string} pValue
	 */
	setDraftFilter(pHash, pIndex, pPart, pValue)
	{
		const tmpClause = this.state.Draft && (this.state.Draft.DataFilters[pHash] || [])[Number(pIndex)];
		if (!tmpClause)
		{
			return;
		}
		if (pPart === 'ValueSource')
		{
			tmpClause.Value = (pValue === TYPED_VALUE) ? '' : `{~D:${pValue}~}`;
			this.render();
			return;
		}
		tmpClause[pPart] = pValue;
		if (pPart === 'Operator')
		{
			this.render();
		}
	}

	/**
	 * @param {Object} pDraft
	 * @return {{ Rule?: AccessRule, Error?: string }}
	 */
	buildRule(pDraft)
	{
		const tmpLabel = String(pDraft.Label || '').trim();
		if (!tmpLabel)
		{
			return { Error: 'Give the rule a name, e.g. “Lab technicians”.' };
		}
		if (!pDraft.Roles.length)
		{
			return { Error: 'Choose at least one role. A rule with no roles applies to nobody.' };
		}
		if (!pDraft.Dashboards.length)
		{
			return { Error: 'Tick at least one dashboard for these roles to see.' };
		}
		/** @type {Record<string, Array<FilterClause>>} */
		const tmpFilters = {};
		for (const [ tmpHash, tmpClauses ] of Object.entries(pDraft.DataFilters || {}))
		{
			const tmpComplete = [];
			for (const tmpClause of tmpClauses)
			{
				const tmpField = String(tmpClause.Field || '').trim();
				const tmpValue = (typeof tmpClause.Value === 'string') ? tmpClause.Value.trim() : tmpClause.Value;
				if (!tmpField && (tmpValue === '' || tmpValue === undefined))
				{
					continue;
				}
				if (!tmpField || tmpValue === '' || tmpValue === undefined)
				{
					return { Error: `Finish or remove the half-filled data limit on ${this.dashboard(tmpHash).Title}: it needs both a field and a value.` };
				}
				if (!/^[A-Za-z0-9_]+$/.test(tmpField))
				{
					return { Error: `“${tmpField}” isn’t a field name. Pick one from the list.` };
				}
				const tmpOperator = libDashboardAccess.OPERATORS[tmpClause.Operator] ? tmpClause.Operator : 'EQ';
				const tmpIsToken = (typeof tmpValue === 'string') && /^\{~D:[A-Za-z0-9_.]+~\}$/.test(tmpValue);
				tmpComplete.push({ Field: tmpField, Operator: tmpOperator, Value: (libDashboardAccess.OPERATORS[tmpOperator].List && !tmpIsToken) ? String(tmpValue).split(',').map((pItem) => pItem.trim()).filter(Boolean) : tmpValue });
			}
			if (tmpComplete.length > 0 && pDraft.Dashboards.includes(tmpHash))
			{
				tmpFilters[tmpHash] = tmpComplete;
			}
		}
		/** @type {AccessRule} */
		const tmpRule =
		{
			Label: tmpLabel,
			Audience: Object.assign({}, (pDraft.Extra && pDraft.Extra.Audience) || {}, { Roles: pDraft.Roles.slice() }),
			Dashboards: pDraft.Dashboards.slice(),
		};
		if (pDraft.Landing && pDraft.Dashboards.includes(pDraft.Landing))
		{
			tmpRule.Landing = pDraft.Landing;
		}
		if (Object.keys(tmpFilters).length > 0)
		{
			tmpRule.DataFilters = tmpFilters;
		}
		return { Rule: tmpRule };
	}

	applyDraft()
	{
		const tmpState = this.state;
		const tmpBuilt = this.buildRule(tmpState.Draft || {});
		if (tmpBuilt.Error)
		{
			tmpState.Error = tmpBuilt.Error;
			this.render();
			return;
		}
		let tmpKey = tmpState.EditingKey;
		if (tmpKey === '(new)' || !tmpState.Rules[tmpKey])
		{
			const tmpBase = tmpBuilt.Rule.Label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'rule';
			tmpKey = tmpBase;
			for (let i = 2; tmpState.Rules[tmpKey]; i++)
			{
				tmpKey = `${tmpBase}-${i}`;
			}
			tmpBuilt.Rule.Order = Number.MAX_SAFE_INTEGER;
		}
		else
		{
			tmpBuilt.Rule.Order = tmpState.Rules[tmpKey].Order;
			if (tmpState.Rules[tmpKey].Enabled === false)
			{
				tmpBuilt.Rule.Enabled = false;
			}
		}
		tmpState.Rules[tmpKey] = tmpBuilt.Rule;
		this._renumber(this.orderedRules());
		tmpState.Error = '';
		tmpState.EditingKey = '';
		tmpState.Draft = null;
		this._markDirty();
		this.render();
	}

	// --- Save -----------------------------------------------------------------------------------------------

	async save()
	{
		const tmpState = this.state;
		if (tmpState.Saving || !tmpState.Dirty)
		{
			return;
		}
		tmpState.Saving = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			const tmpResult = await this._postJSON(`Configuration/Put/${libDashboardAccess.NAMESPACE}/${libDashboardAccess.NAMESPACE_VALUE}/Customer/${Number(tmpState.TargetCustomerID)}`, { Config: tmpState.Rules });
			if (tmpResult.error || (tmpResult.result && tmpResult.result.Error))
			{
				throw new Error((tmpResult.error && tmpResult.error.message) || (tmpResult.result && tmpResult.result.Error) || String(tmpResult.error));
			}
			tmpState.Dirty = false;
			if (this.pict.providers.HeadlightDashboardHost)
			{
				this.pict.providers.HeadlightDashboardHost.invalidate();
			}
			tmpState.Message = libDashboardAccess.hasRules(tmpState.Rules)
				? `Saved. People at ${tmpState.TargetCustomerName || 'this customer'} see the dashboards these rules give them, in every app, the next time they open one.`
				: `Saved. With no rules turned on, everyone at ${tmpState.TargetCustomerName || 'this customer'} sees every dashboard.`;
		}
		catch (pError)
		{
			tmpState.Error = `Save failed: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Saving = false;
			this.render();
		}
	}

	// --- Role picker (a customer can have hundreds of roles, so they are searched, not listed) --------------

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @return {Array<string>}
	 */
	_chosenRoles(pContext)
	{
		if (pContext === 'Draft')
		{
			return (this.state.Draft && Array.isArray(this.state.Draft.Roles)) ? this.state.Draft.Roles : [];
		}
		return this.state.PreviewRoles;
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pText
	 * @return {{ Matches: Array<{ Hash: string, Name: string }>, More: number }}
	 */
	findRoles(pContext, pText)
	{
		const tmpChosen = this._chosenRoles(pContext);
		const tmpNeedle = String(pText || '').trim().toLowerCase();
		const tmpAll = this.state.Roles.filter((pRole) => !tmpChosen.includes(pRole.Hash) && (!tmpNeedle || pRole.Name.toLowerCase().includes(tmpNeedle) || pRole.PermissionLevel.toLowerCase().includes(tmpNeedle)));
		return { Matches: tmpAll.slice(0, ROLE_SUGGESTION_LIMIT), More: Math.max(tmpAll.length - ROLE_SUGGESTION_LIMIT, 0) };
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pText
	 */
	searchRoles(pContext, pText)
	{
		this.state.RoleSearch[pContext] = String(pText || '');
		if (typeof document !== 'undefined' && document.getElementById(`DAC-RoleSuggest-${pContext}`))
		{
			this.pict.ContentAssignment.assignContent(`#DAC-RoleSuggest-${pContext}`, this.renderRoleSuggestionsHTML(pContext));
		}
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pHash
	 */
	addRole(pContext, pHash)
	{
		const tmpChosen = this._chosenRoles(pContext);
		if (!tmpChosen.includes(pHash))
		{
			tmpChosen.push(pHash);
		}
		this.state.RoleSearch[pContext] = '';
		this.render();
		if (typeof document !== 'undefined' && document.getElementById(`DAC-RoleSearch-${pContext}`))
		{
			document.getElementById(`DAC-RoleSearch-${pContext}`).focus();
		}
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pHash
	 */
	dropRole(pContext, pHash)
	{
		const tmpChosen = this._chosenRoles(pContext);
		const tmpIndex = tmpChosen.indexOf(pHash);
		if (tmpIndex >= 0)
		{
			tmpChosen.splice(tmpIndex, 1);
		}
		this.render();
	}

	// --- Preview --------------------------------------------------------------------------------------------

	/**
	 * What a person with the preview roles gets from the current (unsaved) rules — the same resolver the platform runs.
	 * Values that come from the person (their labs, their projects) can't be known here, so they read as phrases.
	 *
	 * @return {ReturnType<typeof libDashboardAccess.resolveAccess>}
	 */
	preview()
	{
		const tmpState = this.state;
		const tmpRoles = tmpState.Roles.filter((pRole) => tmpState.PreviewRoles.includes(pRole.Hash));
		return libDashboardAccess.resolveAccess({ Rules: tmpState.Rules, Catalog: tmpState.Dashboards, CustomerRoles: tmpRoles, User: {} });
	}

	// --- Rendering ------------------------------------------------------------------------------------------

	/**
	 * @param {Array<FilterClause>} pClauses
	 * @return {string}
	 */
	describeFilters(pClauses)
	{
		return pClauses.map((pClause) => libDashboardAccess.describeClause(pClause)).join(' and ');
	}

	/**
	 * @param {AccessRule} pRule
	 * @return {string} the rule as a sentence: who sees what, opens what first, and any data limits
	 */
	describeRule(pRule)
	{
		const tmpWho = ((pRule.Audience && pRule.Audience.Roles) || []).map((pHash) => this.roleName(pHash)).join(', ') || 'Nobody (no roles chosen)';
		const tmpWhat = (pRule.Dashboards || []).map((pHash) => this.dashboard(pHash).Title).join(', ') || 'no dashboards';
		let tmpSentence = `${this._esc(tmpWho)} see <b>${this._esc(tmpWhat)}</b>`;
		if (pRule.Landing)
		{
			tmpSentence += ` · open <b>${this._esc(this.dashboard(pRule.Landing).Title)}</b> first`;
		}
		for (const [ tmpHash, tmpClauses ] of Object.entries(pRule.DataFilters || {}))
		{
			tmpSentence += `<br>${this._esc(this.dashboard(tmpHash).Title)} shows only rows where ${this._esc(this.describeFilters(tmpClauses))}`;
		}
		return tmpSentence;
	}

	render()
	{
		const tmpContainer = (typeof document !== 'undefined') ? document.getElementById('DAC-Detail') : null;
		const tmpHTML = this.renderHTML();
		if (tmpContainer)
		{
			this.pict.ContentAssignment.assignContent('#DAC-Detail', tmpHTML);
		}
		return tmpHTML;
	}

	/** @return {string} */
	renderHTML()
	{
		const tmpState = this.state;
		if (!this.can())
		{
			return '<div class="edc-empty">You don’t have the “Configure dashboard access” entitlement.</div>';
		}
		if (tmpState.Loading)
		{
			return '<div class="edc-empty"><i class="fas fa-spinner fa-spin"></i> Loading…</div>';
		}
		const tmpCustomer = (this.isSuperUser() && tmpState.Customers.length)
			? `<select class="edc-select" onchange="_Pict.providers.DashboardAccessConfig.selectCustomer(this.value)">${tmpState.Customers.map((pCustomer) => `<option value="${Number(pCustomer.IDCustomer)}" ${Number(pCustomer.IDCustomer) === Number(tmpState.TargetCustomerID) ? 'selected' : ''}>${this._esc(pCustomer.Name)}</option>`).join('')}</select>`
			: `<span class="edc-customer">${this._esc(tmpState.TargetCustomerName)}</span>`;
		const tmpOrdered = this.orderedRules();
		const tmpRows = tmpOrdered.map(([ pKey, pRule ], pIndex) =>
		{
			const tmpKeyArg = this._arg(pKey);
			return `<div class="edc-rule ${pRule.Enabled === false ? 'is-off' : ''}">
				<div class="edc-rule-order">
					<button class="edc-mv" title="Earlier" ${pIndex === 0 ? 'disabled' : ''} onclick='_Pict.providers.DashboardAccessConfig.moveRule(${tmpKeyArg}, -1)'><i class="fas fa-chevron-up"></i></button>
					<button class="edc-mv" title="Later" ${pIndex === tmpOrdered.length - 1 ? 'disabled' : ''} onclick='_Pict.providers.DashboardAccessConfig.moveRule(${tmpKeyArg}, 1)'><i class="fas fa-chevron-down"></i></button>
				</div>
				<div class="edc-rule-body">
					<div class="edc-rule-label">${this._esc(pRule.Label || pKey)}${pRule.Enabled === false ? ' <span class="edc-off">Off</span>' : ''}</div>
					<div class="edc-rule-sentence">${this.describeRule(pRule)}</div>
				</div>
				<div class="edc-rule-actions">
					<button class="edc-btn" onclick='_Pict.providers.DashboardAccessConfig.editRule(${tmpKeyArg})'>Edit</button>
					<button class="edc-btn" onclick='_Pict.providers.DashboardAccessConfig.toggleRule(${tmpKeyArg})'>${pRule.Enabled === false ? 'Turn on' : 'Turn off'}</button>
					<button class="edc-btn is-danger" onclick='_Pict.providers.DashboardAccessConfig.removeRule(${tmpKeyArg})'>Remove</button>
				</div>
			</div>`;
		}).join('');
		const tmpList = tmpRows || '<div class="edc-note">No rules yet, so everyone sees every dashboard. Add a rule to start choosing who sees what — once a rule is on, people see only the dashboards a rule gives one of their roles.</div>';
		return `
			<div class="edc-field"><label class="edc-field-label">Customer</label>${tmpCustomer}</div>
			${tmpState.Message ? `<div class="edc-msg">${this._esc(tmpState.Message)}</div>` : ''}
			${tmpState.Error ? `<div class="edc-error">${this._esc(tmpState.Error)}</div>` : ''}
			<p class="edc-help">Each rule gives a group of roles some dashboards. A person sees every dashboard any of their roles is given. Roles given on a single project count only for dashboards that show one project, and only on that project.</p>
			<div class="edc-rules">${tmpList}</div>
			${tmpState.Draft ? this.renderEditorHTML() : '<button class="edc-btn" onclick="_Pict.providers.DashboardAccessConfig.newRule()"><i class="fas fa-plus"></i> Add a rule</button>'}
			<div class="edc-savebar"><button class="edc-save" ${(!tmpState.Dirty || tmpState.Saving) ? 'disabled' : ''} onclick="_Pict.providers.DashboardAccessConfig.save()">${tmpState.Saving ? 'Saving…' : 'Save changes'}</button>${tmpState.Dirty ? '<span class="edc-unsaved">Unsaved changes</span>' : ''}</div>
			${this.renderPreviewHTML()}`;
	}

	/** @return {string} */
	renderEditorHTML()
	{
		const tmpState = this.state;
		const tmpDraft = tmpState.Draft;
		const tmpDashboards = tmpState.Dashboards.length
			? tmpState.Dashboards.map((pDashboard) => this.renderDraftDashboardHTML(pDashboard)).join('')
			: '<span class="edc-hint">This customer has no dashboards yet.</span>';
		return `<div class="edc-editor">
			<div class="edc-field"><label class="edc-field-label">Rule name</label><input class="edc-input" value="${this._esc(tmpDraft.Label)}" placeholder="Lab technicians" onchange="_Pict.providers.DashboardAccessConfig.setDraft('Label', this.value)"></div>
			<div class="edc-field"><label class="edc-field-label">Who</label>${this.renderRolePickerHTML('Draft', 'Choose one or more roles')}</div>
			<div class="edc-field"><label class="edc-field-label">Sees these dashboards</label>
				<p class="edc-hint">Tick what these roles should see. Mark one to open first — it becomes their home page in LIMS. “Limit the data” narrows what a dashboard shows them, for example only their own lab’s samples.</p>
				<div class="dac-dashboards">${tmpDashboards}</div>
			</div>
			<div class="edc-editor-actions"><button class="edc-save" onclick="_Pict.providers.DashboardAccessConfig.applyDraft()">Keep this rule</button> <button class="edc-btn" onclick="_Pict.providers.DashboardAccessConfig.cancelEdit()">Cancel</button></div>
		</div>`;
	}

	/**
	 * @param {{ Hash: string, Title: string, Kind: string, ProjectBound: boolean }} pDashboard
	 * @return {string}
	 */
	renderDraftDashboardHTML(pDashboard)
	{
		const tmpDraft = this.state.Draft;
		const tmpHashArg = this._arg(pDashboard.Hash);
		const tmpChecked = tmpDraft.Dashboards.includes(pDashboard.Hash);
		const tmpNotes = [ pDashboard.ProjectBound ? 'one project at a time' : '', pDashboard.Kind === 'Legacy' ? 'classic dashboard' : '' ].filter(Boolean).join(', ');
		let tmpHTML = `<div class="dac-dashboard ${tmpChecked ? 'is-on' : ''}">
			<label class="edc-chip"><input type="checkbox" ${tmpChecked ? 'checked' : ''} onchange='_Pict.providers.DashboardAccessConfig.toggleDraftDashboard(${tmpHashArg})'> <b>${this._esc(pDashboard.Title)}</b>${tmpNotes ? ` <span class="edc-hint">(${this._esc(tmpNotes)})</span>` : ''}</label>`;
		if (tmpChecked)
		{
			tmpHTML += ` <label class="edc-chip dac-landing"><input type="radio" name="dac-landing" ${tmpDraft.Landing === pDashboard.Hash ? 'checked' : ''} onclick='_Pict.providers.DashboardAccessConfig.setDraftLanding(${tmpHashArg})'> Open first</label>`;
			if (pDashboard.Kind !== 'Legacy')
			{
				const tmpClauses = tmpDraft.DataFilters[pDashboard.Hash] || [];
				tmpHTML += `<div class="dac-filters">${tmpClauses.map((pClause, pIndex) => this.renderDraftFilterHTML(pDashboard.Hash, pClause, pIndex)).join('')}
					<button class="edc-btn" onclick='_Pict.providers.DashboardAccessConfig.addDraftFilter(${tmpHashArg})'><i class="fas fa-filter"></i> ${tmpClauses.length ? 'Add another limit' : 'Limit the data'}</button></div>`;
			}
		}
		return `${tmpHTML}</div>`;
	}

	/**
	 * One "only rows where <field> <is> <value>" line.
	 *
	 * @param {string} pHash
	 * @param {FilterClause} pClause
	 * @param {number} pIndex
	 * @return {string}
	 */
	renderDraftFilterHTML(pHash, pClause, pIndex)
	{
		const tmpCall = (pPart) => `_Pict.providers.DashboardAccessConfig.setDraftFilter(${this._arg(pHash)}, ${pIndex}, '${pPart}', this.value)`;
		const tmpFields = this.state.Fields[pHash] || [];
		const tmpFieldInput = tmpFields.length
			? `<select class="edc-select edc-narrow" onchange="${this._esc(tmpCall('Field'))}"><option value="">Choose a field</option>${tmpFields.map((pField) => `<option ${pClause.Field === pField ? 'selected' : ''}>${this._esc(pField)}</option>`).join('')}</select>`
			: `<input class="edc-input dac-field" value="${this._esc(pClause.Field)}" placeholder="Field, e.g. IDLab" onchange="${this._esc(tmpCall('Field'))}">`;
		const tmpOperators = Object.entries(libDashboardAccess.OPERATORS).map(([ pKey, pOperator ]) => `<option value="${pKey}" ${pClause.Operator === pKey ? 'selected' : ''}>${this._esc(pOperator.Label)}</option>`).join('');
		const tmpTokenMatch = /^\{~D:([A-Za-z0-9_.]+)~\}$/.exec(String(pClause.Value || ''));
		const tmpSource = tmpTokenMatch ? tmpTokenMatch[1] : TYPED_VALUE;
		const tmpSources = [ `<option value="${TYPED_VALUE}" ${tmpSource === TYPED_VALUE ? 'selected' : ''}>a value I type</option>` ]
			.concat(Object.entries(libDashboardAccess.TOKENS).map(([ pToken, pDefinition ]) => `<option value="${pToken}" ${tmpSource === pToken ? 'selected' : ''}>${this._esc(pDefinition.Label)}</option>`)).join('');
		const tmpTyped = (tmpSource === TYPED_VALUE)
			? `<input class="edc-input dac-value" value="${this._esc(Array.isArray(pClause.Value) ? pClause.Value.join(', ') : pClause.Value)}" placeholder="${libDashboardAccess.OPERATORS[pClause.Operator] && libDashboardAccess.OPERATORS[pClause.Operator].List ? 'Values, separated by commas' : 'Value'}" onchange="${this._esc(tmpCall('Value'))}">`
			: '';
		return `<div class="dac-filter"><span class="edc-hint">Only rows where</span> ${tmpFieldInput}
			<select class="edc-select edc-narrow" onchange="${this._esc(tmpCall('Operator'))}">${tmpOperators}</select>
			<select class="edc-select edc-narrow" onchange="${this._esc(tmpCall('ValueSource'))}">${tmpSources}</select> ${tmpTyped}
			<button type="button" class="edc-tag-x" title="Remove this limit" onclick='_Pict.providers.DashboardAccessConfig.removeDraftFilter(${this._arg(pHash)}, ${pIndex})'>×</button></div>`;
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pNoneLabel
	 * @return {string}
	 */
	renderRolePickerHTML(pContext, pNoneLabel)
	{
		const tmpState = this.state;
		if (!tmpState.Roles.length)
		{
			return '<span class="edc-hint">No roles found for this customer.</span>';
		}
		const tmpTags = this._chosenRoles(pContext).map((pHash) => `<span class="edc-tag">${this._esc(this.roleName(pHash))}<button type="button" class="edc-tag-x" title="Remove" onclick='_Pict.providers.DashboardAccessConfig.dropRole("${pContext}", ${this._arg(pHash)})'>×</button></span>`).join('');
		return `<div class="edc-picker">
			<div class="edc-tags">${tmpTags || `<span class="edc-hint">${this._esc(pNoneLabel)}</span>`}</div>
			<input id="DAC-RoleSearch-${pContext}" class="edc-input" autocomplete="off" placeholder="Find a role to add (${tmpState.Roles.length} roles)" value="${this._esc(tmpState.RoleSearch[pContext])}" oninput="_Pict.providers.DashboardAccessConfig.searchRoles('${pContext}', this.value)" onfocus="_Pict.providers.DashboardAccessConfig.searchRoles('${pContext}', this.value)">
			<div id="DAC-RoleSuggest-${pContext}" class="edc-suggest">${tmpState.RoleSearch[pContext] ? this.renderRoleSuggestionsHTML(pContext) : ''}</div>
		</div>`;
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @return {string}
	 */
	renderRoleSuggestionsHTML(pContext)
	{
		const tmpFound = this.findRoles(pContext, this.state.RoleSearch[pContext]);
		if (!tmpFound.Matches.length)
		{
			return '<span class="edc-hint">No roles match.</span>';
		}
		const tmpButtons = tmpFound.Matches.map((pRole) => `<button type="button" class="edc-suggestion" onclick='_Pict.providers.DashboardAccessConfig.addRole("${pContext}", ${this._arg(pRole.Hash)})'>${this._esc(pRole.Name)}${pRole.PermissionLevel ? ` <span class="edc-hint">${this._esc(pRole.PermissionLevel)}</span>` : ''}</button>`).join('');
		return `${tmpButtons}${tmpFound.More ? `<span class="edc-hint">and ${tmpFound.More} more; keep typing to narrow it down.</span>` : ''}`;
	}

	/** @return {string} */
	renderPreviewHTML()
	{
		const tmpState = this.state;
		let tmpResultHTML = '';
		try
		{
			const tmpResult = this.preview();
			if (!tmpResult.Enforced)
			{
				tmpResultHTML = '<div>No rules are on, so <b>everyone sees every dashboard</b>.</div>';
			}
			else if (!tmpState.PreviewRoles.length)
			{
				tmpResultHTML = '<div>Choose some roles above to see what a person with them gets.</div>';
			}
			else if (!tmpResult.Dashboards.length)
			{
				tmpResultHTML = '<div><b>No dashboards.</b> None of these roles is in a rule that is turned on.</div>';
			}
			else
			{
				const tmpItems = tmpResult.Dashboards.map((pDashboard) =>
				{
					const tmpLimits = (pDashboard.DataFilter || []).concat(pDashboard.Unresolved || []);
					return `<li><b>${this._esc(pDashboard.Title)}</b>${tmpLimits.length ? ` — only rows where ${this._esc(this.describeFilters(tmpLimits))}` : ' — everything they can already reach'}</li>`;
				}).join('');
				tmpResultHTML = `<div><b>Sees:</b><ul class="dac-preview-list">${tmpItems}</ul></div>` +
					`<div><b>Opens first:</b> ${tmpResult.Landing ? this._esc(this.dashboard(tmpResult.Landing).Title) : 'the list of their dashboards'}</div>`;
			}
			tmpResultHTML += `<details class="edc-explain"><summary>Why</summary><ul>${tmpResult.Explain.map((pLine) => `<li>${this._esc(pLine)}</li>`).join('')}</ul>
				<p>When two rules give the same dashboard with different limits, the person gets the wider view: only the limits both rules share apply.</p></details>`;
		}
		catch (pError)
		{
			tmpResultHTML = `<div class="edc-error">Preview unavailable: ${this._esc((pError && pError.message) || pError)}</div>`;
		}
		return `<div class="edc-preview">
			<div class="edc-field-label">Try it: who sees what</div>
			<div class="edc-field"><label class="edc-field-label">A person with these roles</label>${this.renderRolePickerHTML('Preview', 'No roles')}</div>
			<div class="edc-preview-result">${tmpResultHTML}</div>
			<p class="edc-hint">Data limits narrow what a dashboard shows; they don’t widen anyone’s access. People never see records they couldn’t already open.</p>
		</div>`;
	}
}

module.exports = DashboardAccessConfigProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'DashboardAccessConfig',
	AutoInitialize: true,
	AutoInitializeOrdinal: 233,
};

},{"headlight-dashboard-access":6,"pict-provider":845}],1330:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

/**
 * The catalog of downloadable desktop apps we ship to customers, each gated by a Module (ModuleHash). This is the
 * first of three planned binary apps — add the next two as entries here (drop their installers in ./downloads/,
 * add a copyFiles rule, and a Module catalog row + a nav entry gated on the new ModuleHash).
 *
 * Files live in the committed ./downloads/ folder (copied to serve/…/downloads/ at build) and are linked as
 * plain static URLs. NOTE: gating here is PRESENTATIONAL — the static file URLs are public on the deployed
 * static webserver, so a customer without the module simply doesn't see the links; the bytes are not
 * access-controlled. (Byte-level enforcement would require serving through the authenticated /1.0/ API or a
 * session-checked download endpoint — a deliberate future step; UI-level gating was the chosen scope.)
 */
// One module definition per downloadable desktop app — each app is its OWN DOWNLOAD_<APP> module + constant
// (the ModuleHash carries the same DOWNLOAD_ prefix so downloadable-app modules are distinct from the platform
// service modules like HEADLIGHT_FIELDBOOK). The other two binary apps each get their own constant, added to
// DOWNLOAD_MODULES below.
// IMPORTANT: the CustomerModuleJoin.ModuleHash column is char(24) — a longer hash is SILENTLY TRUNCATED on write
// (which breaks the enable/gate match). Keep every ModuleHash here to 24 characters or fewer.
const DOWNLOAD_DATA_DOWNLOADER =
{
	Key: 'data-downloader',
	ModuleHash: 'DOWNLOAD_DATA_DOWNLOADER',
	Name: 'Headlight Data Downloader',
	Version: '0.9.3',
	Icon: 'fas fa-cloud-arrow-down',
	Blurb: 'A desktop app for bulk-downloading a project’s observations, documents, and media to your computer.',
	Builds:
	[
		{ OS: 'macOS', Note: 'Apple Silicon', OSIcon: 'fab fa-apple', File: 'Headlight_Downloader_0.9.3_aarch64.dmg', Kind: 'Disk image (.dmg)' },
		{ OS: 'Windows', Note: '64-bit', OSIcon: 'fab fa-windows', File: 'Headlight_Downloader_0.9.3_x64-setup.exe', Kind: 'Installer (.exe)' },
		{ OS: 'Windows', Note: '64-bit', OSIcon: 'fab fa-windows', File: 'Headlight_Downloader_0.9.3_x64_en-US.msi', Kind: 'MSI package (.msi)' },
		{ OS: 'Linux', Note: 'Debian / Ubuntu', OSIcon: 'fab fa-linux', File: 'Headlight_Downloader_0.9.3_amd64.deb', Kind: 'Package (.deb)' },
	],
};

// The registry the view + the ManageCustomers Modules tab iterate. Add each new app's DOWNLOAD_<APP> constant here.
const DOWNLOAD_MODULES = [ DOWNLOAD_DATA_DOWNLOADER ];

const BODY_MOUNT = '#DD-Body';

/**
 * DataDownloaderProvider — data + render for the #/Datalake/DataDownloader screen. Lists each downloadable app
 * the CURRENT customer has enabled (a CustomerModuleJoin for the session's customer, active date window). The nav
 * entry is already gated on the same module, so a customer without it never sees the link; this view re-checks so
 * a stale deep-link shows a clean "not enabled" notice instead of dead download buttons.
 */
class DataDownloaderProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get app() { return this.pict.PictApplication; }

	get state()
	{
		if (!this.pict.AppData.DataDownloader) { this.pict.AppData.DataDownloader = { Ready: false }; }
		return this.pict.AppData.DataDownloader;
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** Refresh the current customer's enabled modules (customer-scoped server-side) then paint. */
	async loadAsync()
	{
		if (this.app && (typeof this.app.loadCustomerModulesAsync === 'function'))
		{
			try { await this.app.loadCustomerModulesAsync(); } catch (pError) { /* fail-closed: render shows the gated notice */ }
		}
		this.state.Ready = true;
		this.render();
	}

	_hasModule(pHash)
	{
		return !!(this.app && (typeof this.app._customerHasModule === 'function') && this.app._customerHasModule(pHash));
	}

	render()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
	}

	_bodyHTML()
	{
		const tmpEnabledApps = DOWNLOAD_MODULES.filter((pApp) => this._hasModule(pApp.ModuleHash));
		const tmpHead = `<div class="dd-head"><div class="dd-eyebrow">Data Lake</div><h1 class="dd-title">Data Downloader</h1>`
			+ `<p class="dd-intro">Desktop tools for working with your Headlight data offline. Install one on your computer, sign in, and pull your project data down.</p></div>`;
		if (tmpEnabledApps.length === 0)
		{
			return tmpHead + this._gatedHTML();
		}
		return tmpHead + tmpEnabledApps.map((pApp) => this._appHTML(pApp)).join('');
	}

	_gatedHTML()
	{
		return `<div class="dd-gated">`
			+ `<div class="dd-gated-icon"><i class="fas fa-lock"></i></div>`
			+ `<div class="dd-gated-title">Not enabled for your organization</div>`
			+ `<div class="dd-gated-body">The Data Downloader is a licensed add-on. Ask your Headlight administrator to enable it for your organization.</div>`
			+ `</div>`;
	}

	_appHTML(pApp)
	{
		const tmpBuilds = pApp.Builds.map((pBuild) => this._buildHTML(pApp, pBuild)).join('');
		return `<div class="dd-app">`
			+ `<div class="dd-app-head"><span class="dd-app-icon"><i class="${this._esc(pApp.Icon)}"></i></span>`
			+ `<div><div class="dd-app-name">${this._esc(pApp.Name)}</div>`
			+ `<div class="dd-app-meta">Version ${this._esc(pApp.Version)}</div></div></div>`
			+ `<p class="dd-app-blurb">${this._esc(pApp.Blurb)}</p>`
			+ `<div class="dd-builds">${tmpBuilds}</div>`
			+ `</div>`;
	}

	_buildHTML(pApp, pBuild)
	{
		// Relative static path (served from serve/…/downloads/); the download attribute keeps the installer's name.
		const tmpHref = `downloads/${encodeURIComponent(pBuild.File)}`;
		return `<a class="dd-build" href="${this._esc(tmpHref)}" download="${this._esc(pBuild.File)}">`
			+ `<span class="dd-build-os"><i class="${this._esc(pBuild.OSIcon)}"></i></span>`
			+ `<span class="dd-build-text"><span class="dd-build-title">${this._esc(pBuild.OS)}</span>`
			+ `<span class="dd-build-sub">${this._esc(pBuild.Note)} · ${this._esc(pBuild.Kind)}</span></span>`
			+ `<span class="dd-build-dl"><i class="fas fa-download"></i></span>`
			+ `</a>`;
	}
}

module.exports = DataDownloaderProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'DataDownloaderProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 227,
};

module.exports.DOWNLOAD_MODULES = DOWNLOAD_MODULES;
module.exports.DOWNLOAD_DATA_DOWNLOADER = DOWNLOAD_DATA_DOWNLOADER;

},{"pict-provider":845}],1331:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const libCatalog = require('../data-import/Import-Entity-Catalog.js');
const libSchema = require('../data-import/DataImport-Schema.js');
const libContextCatalog = require('../data-import/Import-Context-Catalog.js');
const libXlsxParser = require('../data-import/DataImport-Xlsx-Parser.js');

// The wizard view's constant mount point (the host view's template provides this element) + a per-entity
// wizard view hash (each target entity gets its own wizard + upload/mapping session so switching targets
// never bleeds one entity's file/mapping into another).
const WIZARD_MOUNT = '#DataImport-Mount';
const WIZARD_HASH_PREFIX = 'HeadlightImport-';

// The GUID-marshal prefix the import stamps on every record. Combined with the natural key the user maps
// to the GUID template, this makes a re-import idempotent (same key -> same Meadow GUID -> upsert in place).
const IMPORT_GUID_PREFIX = 'HLIMPORT';

const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'DataImportManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 90,
};

/**
 * DataImportManager — the orchestrator behind the Import Data screen.
 *
 * It owns the curated target-entity list and the two host-supplied seams that let pict-section-dataimport
 * run entirely through the Headlight rest client (the config app has no `pict.EntityProvider`, which the
 * module's stock 'meadow' schema source / 'entityprovider' push both require):
 *   - SchemaSource: a function that fetches `/1.0/<Entity>/Schema` via HeadlightRestClient and maps it.
 *   - PushMode: a push target that runs meadow-integration's Integration Adapter against HeadlightRestClient
 *     (GUID marshaling + idempotent upsert), with PerformDeletes off.
 *
 * All host-view render state lives at `AppData.DataImportUI` (the wizard module owns `AppData.DataImport`).
 */
class DataImportManagerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _DEFAULT_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._meadowEngine = null;
		this._initializedWizards = {};
	}

	/** The shared Headlight rest client (drives every schema read + record upsert). */
	get restClient()
	{
		return (this.fable && this.fable.HeadlightRestClient)
			|| (this.pict && this.pict.fable && this.pict.fable.HeadlightRestClient)
			|| (this.pict && this.pict.HeadlightRestClient)
			|| null;
	}

	/** The embedded pict-section-dataimport provider (createImportWizard lives here). */
	get dataImportProvider()
	{
		return this.pict.providers['Pict-Section-DataImport'];
	}

	/** The app's shared modal (success / error toasts). */
	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	/** Lazily require the browser-safe meadow-integration engine (the Integration Adapter). */
	_engine()
	{
		if (!this._meadowEngine)
		{
			this._meadowEngine = require('meadow-integration/source/Meadow-Integration-Engine.js');
		}
		return this._meadowEngine;
	}

	/** Ensure the host-view state object exists at AppData.DataImportUI. */
	_ensureState()
	{
		if (!this.pict.AppData.DataImportUI)
		{
			this.pict.AppData.DataImportUI =
			{
				SelectedEntity: '',
				ActiveWizardHash: '',
				LastResult: null,
				LastError: '',
				// Derived each prepare():
				Entities: [],
				SelectedSlot: [],
				IntroSlot: [],
				ResultSlot: [],
				ErrorSlot: [],
				MissingSlot: [],
			};
		}
		return this.pict.AppData.DataImportUI;
	}

	/**
	 * Recompute the derived render slots from the core state. Called by the host view's onBeforeRender.
	 */
	prepare()
	{
		const tmpState = this._ensureState();
		const tmpSelected = tmpState.SelectedEntity;

		tmpState.Entities = libCatalog.IMPORT_ENTITIES.map((pEntity) => Object.assign({}, pEntity,
			{ Selected: (pEntity.Entity === tmpSelected) }));

		const tmpEntity = tmpSelected ? libCatalog.findEntity(tmpSelected) : null;
		tmpState.SelectedSlot = tmpEntity
			? [ { Label: tmpEntity.Label, Icon: tmpEntity.Icon, Description: tmpEntity.Description } ]
			: [];
		tmpState.IntroSlot = tmpEntity ? [] : [ {} ];

		tmpState.ResultSlot = tmpState.LastResult
			? [ {
				Message: tmpState.LastResult.Message,
				ViewRoute: `#/PSRS/${tmpState.LastResult.Entity}/List`,
				ViewLabel: 'View records',
			} ]
			: [];
		tmpState.ErrorSlot = tmpState.LastError ? [ { Message: tmpState.LastError } ] : [];

		tmpState.MissingSlot = this.dataImportProvider ? [] : [ {} ];
		return tmpState;
	}

	/**
	 * The user picked a target entity (or cleared the picker). (Re)build + mount that entity's wizard.
	 * @param {string} pEntityName
	 */
	selectEntity(pEntityName)
	{
		const tmpState = this._ensureState();
		const tmpEntity = pEntityName ? libCatalog.findEntity(pEntityName) : null;

		tmpState.SelectedEntity = tmpEntity ? tmpEntity.Entity : '';
		tmpState.LastResult = null;
		tmpState.LastError = '';

		if (tmpEntity)
		{
			this._buildWizard(tmpEntity.Entity);
		}
		else
		{
			tmpState.ActiveWizardHash = '';
		}
		this._render();
	}

	/** (Re)configure the per-entity import wizard with the Headlight schema + push seams. */
	/** The host xlsx parser (window.XLSX-aware), cached — shared by every wizard + the Contract-package import. */
	_xlsxParser()
	{
		if (!this._cachedXlsxParser) { this._cachedXlsxParser = new libXlsxParser(this.pict, {}); }
		return this._cachedXlsxParser;
	}

	_buildWizard(pEntityName)
	{
		const tmpProvider = this.dataImportProvider;
		if (!tmpProvider)
		{
			this.log.error('DataImport: the Pict-Section-DataImport provider is not registered.');
			return;
		}
		const tmpHash = `${WIZARD_HASH_PREFIX}${pEntityName}`;
		tmpProvider.createImportWizard(tmpHash,
			{
				DestinationAddress: WIZARD_MOUNT,
				RenderMode: 'wizard',
				URLPrefix: '/1.0/',
				GUIDPrefix: IMPORT_GUID_PREFIX,
				EntityGUIDPrefix: `E-${pEntityName}`,
				AllowGUIDTruncation: true,
				AllowedFileTypes: [ 'csv', 'tsv', 'xlsx', 'fixedwidth' ],
				AllowDownload: true,
				// Excel: the stock module parser require()s xlsx, which the Headlight build --ignores (SheetJS is
				// loaded as window.XLSX). Override with the host parser that prefers the global. See the parser.
				Parsers: { xlsx: this._xlsxParser() },
				// Context-aware GUID strategy: stable, length-safe, interconnected GUIDs (UI_<context>_<own>).
				// The composer + compiler live in meadow-integration; this app supplies only the catalog, and
				// the user tunes per-entity own-key + parent links (with a live preview) in the mapping step.
				GUIDStrategy: true,
				GUIDStrategyPrefix: 'UI',
				ContextEntityCatalog: libContextCatalog,
				// Host-supplied seams (no pict.EntityProvider in this app):
				SchemaSource: this._schemaSourceFor(pEntityName),
				MeadowEntities: [ pEntityName ],
				PushMode: this._buildPushTarget(),
				OnPushComplete: (pResult) => this._onPushComplete(pEntityName, pResult),
				OnError: (pError) => this._onError(pError),
			});
		this.pict.AppData.DataImportUI.ActiveWizardHash = tmpHash;
	}

	/** (Re)render the active wizard into the host page's mount div (called from the host view's onAfterRender). */
	mountWizard()
	{
		const tmpState = this._ensureState();
		const tmpHash = tmpState.ActiveWizardHash;
		if (!tmpHash)
		{
			return;
		}
		if (this.pict.ContentAssignment.getElement(WIZARD_MOUNT).length === 0)
		{
			return;
		}
		const tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return;
		}
		// A view added after the boot cycle isn't initialized automatically — initialize once before render.
		if (!this._initializedWizards[tmpHash] && (typeof tmpView.initialize === 'function'))
		{
			tmpView.initialize();
			this._initializedWizards[tmpHash] = true;
		}
		// pict-section-dataimport >= 1.0.1 rebuilds its accordion when a host re-render has wiped the mount,
		// so a plain render() is enough here — no need to reach into the wizard's internal `_wired` latch.
		tmpView.render();
	}

	/**
	 * A SchemaSource function: fetch `/1.0/<Entity>/Schema` via HeadlightRestClient, map it to the
	 * dataimport target-schema shape. (The stock 'meadow' source needs pict.EntityProvider.)
	 * @param {string} pEntityName
	 * @returns {(pContext:Record<string,any>) => Promise<{Entities:Array<any>, Order:Array<string>}>}
	 */
	_schemaSourceFor(pEntityName)
	{
		return () => new Promise((resolve, reject) =>
		{
			const tmpRestClient = this.restClient;
			if (!tmpRestClient)
			{
				return reject(new Error('HeadlightRestClient is not available for the schema read.'));
			}
			// getJSON prepends the /1.0/ base, so pass the entity-relative path.
			tmpRestClient.getJSON(`${pEntityName}/Schema`, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				return resolve(libSchema.mapEntitySchema(pEntityName, pBody));
			});
		});
	}

	/**
	 * A PushTarget: land the generated comprehension via meadow-integration's Integration Adapter running
	 * against HeadlightRestClient (the same engine the stock 'entityprovider' push uses, minus its
	 * dependency on pict.EntityProvider). One fresh adapter per entity, pushed in order.
	 * @returns {{push:(pComprehension:Record<string,any>, pContext:Record<string,any>) => Promise<any>}}
	 */
	_buildPushTarget()
	{
		return { push: (pComprehension, pContext) => this._pushViaHeadlight(pComprehension, pContext) };
	}

	/**
	 * @param {Record<string,any>} pComprehension @param {Record<string,any>} pContext
	 * @returns {Promise<{Success:boolean, EntitiesPushed:Array<string>, Message:string}>}
	 */
	_pushViaHeadlight(pComprehension, pContext)
	{
		const tmpRestClient = this.restClient;
		if (!tmpRestClient)
		{
			return Promise.reject(new Error('HeadlightRestClient is not available for the import push.'));
		}
		const tmpEngine = this._engine();
		const tmpContext = pContext || {};
		const tmpOrder = (Array.isArray(tmpContext.Order) && (tmpContext.Order.length > 0))
			? tmpContext.Order
			: Object.keys(pComprehension || {});

		const tmpPushed = [];
		let tmpTotal = 0;
		tmpOrder.forEach((pEntity) => { tmpTotal += Object.keys((pComprehension && pComprehension[pEntity]) || {}).length; });
		let tmpDone = 0;

		// Sequential reduce over the ordered entities (referenced entities first; v1 is single-entity).
		return tmpOrder.reduce((pPromise, pEntity) => pPromise.then(() =>
		{
			const tmpRecords = (pComprehension && pComprehension[pEntity]) || {};
			const tmpGUIDs = Object.keys(tmpRecords);
			if (tmpGUIDs.length === 0)
			{
				return null;
			}

			const tmpAdapterOptions = Object.assign({}, tmpEngine.MeadowIntegrationAdapter.default_configuration,
				{
					Entity: pEntity,
					// Honor an EXPLICITLY-EMPTY prefix: the GUID-strategy path composes the entire GUID itself
					// (e.g. `UI_P01278`) and sets both marshal prefixes to '' so the adapter stores it verbatim.
					// A plain `|| default` turns that '' back into the import default and double-marshals the GUID
					// (`HLIMPORT-E-Project-UI_P01278`), which breaks cross-session FK matching. Use the value when
					// it's a string (incl. '') and fall back only when it's truly unset.
					EntityGUIDMarshalPrefix: (typeof tmpContext.EntityGUIDPrefix === 'string') ? tmpContext.EntityGUIDPrefix : `E-${pEntity}`,
					AdapterSetGUIDMarshalPrefix: (typeof tmpContext.GUIDPrefix === 'string') ? tmpContext.GUIDPrefix : IMPORT_GUID_PREFIX,
					SimpleMarshal: true,
					ForceMarshal: true,
					PerformDeletes: false,
					AllowGUIDTruncation: !!tmpContext.AllowGUIDTruncation,
					// Real per-entity GUID column widths (from the wizard's resolved schema). The strategy
					// composer already sized each GUID to fit its column; without these the adapter's
					// auto-detect (which reads meadow `Columns`, not our JSON-schema `properties`) falls back to
					// a small default and re-truncates a composed GUID — clipping the entity's own segment.
					GUIDColumnSizes: tmpContext.GUIDColumnSizes || {},
				});
			const tmpAdapter = new tmpEngine.MeadowIntegrationAdapter(this.pict, tmpAdapterOptions, `DataImport-${pEntity}`);
			tmpAdapter.setRestClient(tmpRestClient);
			tmpGUIDs.forEach((pGUID) => tmpAdapter.addSourceRecord(tmpRecords[pGUID]));

			return new Promise((resolve, reject) =>
			{
				tmpAdapter.integrateRecords((pError) =>
				{
					if (pError)
					{
						return reject(pError);
					}
					tmpPushed.push(pEntity);
					tmpDone += tmpGUIDs.length;
					if (typeof tmpContext.onProgress === 'function')
					{
						tmpContext.onProgress(tmpDone, tmpTotal);
					}
					return resolve(null);
				});
			});
		}), Promise.resolve()).then(() =>
		{
			return {
				Success: true,
				EntitiesPushed: tmpPushed,
				Message: `Imported ${tmpDone} ${(tmpDone === 1) ? 'record' : 'records'} into ${tmpPushed.join(', ') || 'the selected entity'}.`,
			};
		});
	}

	/** @param {string} pEntityName @param {Record<string,any>} pResult */
	_onPushComplete(pEntityName, pResult)
	{
		const tmpState = this._ensureState();
		const tmpResult = pResult || {};
		tmpState.LastResult = { Message: tmpResult.Message || 'Import complete.', Entity: pEntityName };
		tmpState.LastError = '';
		if (this.modal && (typeof this.modal.toast === 'function'))
		{
			this.modal.toast(tmpResult.Message || 'Import complete.', { type: 'success' });
		}
		this._render();
	}

	/** @param {Error|string} pError */
	_onError(pError)
	{
		const tmpState = this._ensureState();
		const tmpMessage = (pError && pError.message) ? pError.message : String(pError || 'Import failed.');
		tmpState.LastError = tmpMessage;
		if (this.modal && (typeof this.modal.toast === 'function'))
		{
			this.modal.toast(tmpMessage, { type: 'error', duration: 6000 });
		}
		this._render();
	}

	/** Re-render the host view (re-derives slots + re-mounts the wizard via its onAfterRender). */
	_render()
	{
		if (this.pict.views['DataImport'])
		{
			this.pict.views['DataImport'].render();
		}
	}
}

module.exports = DataImportManagerProvider;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"../data-import/DataImport-Schema.js":1092,"../data-import/DataImport-Xlsx-Parser.js":1093,"../data-import/Import-Context-Catalog.js":1094,"../data-import/Import-Entity-Catalog.js":1095,"meadow-integration/source/Meadow-Integration-Engine.js":516,"pict-provider":845}],1332:[function(require,module,exports){

const libPictProvider = require('pict-provider');

/**
 * Data Lake catalog provider.
 *
 * The data lake IS the materialized-projections system: each customer's lake is a set of physical lake
 * tables, every one produced either by a one-time IMPORT (a clone of a legacy DB, e.g. walbec's Lastrada)
 * or by a COMPUTED projection (a transformation of Headlight operational data). The durable catalog of
 * those datasets is the `MaterializedProjection` meadow entity on the main /1.0/ API (reads auto-scope to
 * the session's customer); the actual dataset rows are read separately from the PDO service's
 * `/1.0/PrivateDataLake/...` surface (see DatalakeDataset-Provider).
 *
 * This provider loads the catalog, splits it into the two kinds the UI manages distinctly, groups each
 * (clones by source system, computed by pipeline / RefreshGroup), and derives a searchable two-tab rail.
 * All state lives in pict.AppData.DatalakeCatalog; the view repaints declaratively. Pure transforms are
 * module functions exported for unit tests.
 */

// --- Pure helpers (deterministic transforms of plain data; exported for tests) ---

/**
 * Classify a MaterializedProjection row as an imported clone or a computed projection.
 * Imported = a raw load of an external/legacy source (PassthroughClone / Beacon / file imports), durable
 * and never auto-refreshed. Computed = derived from the Headlight API or another lake table (typed ops).
 * @param {object} pRow
 * @returns {'imported'|'computed'}
 */
function classifyKind(pRow)
{
	if (!pRow || typeof(pRow) !== 'object')
	{
		return 'computed';
	}
	if (pRow.IsRaw)
	{
		return 'imported'; // a raw lake table with no projection definition
	}
	const tmpOp = String(pRow.OperationType || '');
	const tmpSourceType = String(pRow.SourceType || '');
	if (tmpOp === 'PassthroughClone' || tmpSourceType === 'Beacon' || tmpSourceType === 'CSV' || tmpSourceType === 'JSON' || tmpSourceType === 'XLSX')
	{
		return 'imported';
	}
	return 'computed';
}

/**
 * Split catalog rows into { imported, computed } arrays.
 * @param {Array<object>} pRows
 * @returns {{ imported: Array<object>, computed: Array<object> }}
 */
function splitByKind(pRows)
{
	const tmpResult = { imported: [], computed: [] };
	if (!Array.isArray(pRows))
	{
		return tmpResult;
	}
	for (const tmpRow of pRows)
	{
		tmpResult[classifyKind(tmpRow)].push(tmpRow);
	}
	return tmpResult;
}

/**
 * The source-system root of an address: the segment before the first '/'. e.g.
 * 'walbec_lastrada/AS_KP_MISCHGUT' -> 'walbec_lastrada'.
 * @param {string} pAddress
 * @returns {string}
 */
function sourceRoot(pAddress)
{
	const tmpAddress = String(pAddress || '');
	const tmpSlash = tmpAddress.indexOf('/');
	return (tmpSlash > 0) ? tmpAddress.slice(0, tmpSlash) : tmpAddress;
}

/**
 * Human-friendly label for a source-system root: 'walbec_lastrada' -> 'Walbec Lastrada'.
 * @param {string} pRoot
 * @returns {string}
 */
function humanizeSourceRoot(pRoot)
{
	const tmpRoot = String(pRoot || 'External source');
	if (!tmpRoot)
	{
		return 'External source';
	}
	return tmpRoot
		.split(/[_\s]+/)
		.filter(Boolean)
		.map((pWord) => pWord.charAt(0).toUpperCase() + pWord.slice(1))
		.join(' ');
}

/**
 * The logical lake-read name: the physical table name with the customer-silo prefix stripped.
 * 'C182_PD_MoistureDaily' -> 'PD_MoistureDaily'. The PDO read endpoints reject a leading C<n>_ and resolve
 * the remainder by ProjectionName / a LK 'C%_<suffix>' fallback, so the single-segment remainder is always
 * resolvable.
 * @param {string} pPhysicalTableName
 * @returns {string}
 */
function deriveLogicalReadName(pPhysicalTableName)
{
	return String(pPhysicalTableName || '').replace(/^C\d+_/, '');
}

/**
 * The at-a-glance status chip for a row.
 * @param {object} pRow
 * @returns {{ Label: string, Class: string, Icon: string }}
 */
function deriveStatusChip(pRow)
{
	const tmpKind = classifyKind(pRow);
	if (tmpKind === 'imported')
	{
		return { Label: 'Imported · read-only', Class: 'is-link is-light', Icon: 'fa-box-archive' };
	}
	const tmpStatus = String((pRow && pRow.LastRefreshStatus) || '');
	if (/^Failed/i.test(tmpStatus))
	{
		return { Label: 'Last run failed', Class: 'is-danger is-light', Icon: 'fa-circle-exclamation' };
	}
	if (/^Skipped/i.test(tmpStatus))
	{
		return { Label: 'No changes', Class: 'is-warning is-light', Icon: 'fa-circle-minus' };
	}
	if (/^Succeeded/i.test(tmpStatus))
	{
		return { Label: (pRow && pRow.RefreshEnabled) ? 'Scheduled · ✓' : '✓ Up to date', Class: 'is-success is-light', Icon: 'fa-circle-check' };
	}
	return (pRow && pRow.RefreshEnabled)
		? { Label: 'Scheduled', Class: 'is-info is-light', Icon: 'fa-clock' }
		: { Label: 'Paused', Class: '', Icon: 'fa-pause' };
}

/**
 * A human cadence label from the refresh schedule fields. Cron wins when set.
 * @param {object} pRow
 * @returns {string}
 */
function deriveCadenceLabel(pRow)
{
	if (!pRow || !pRow.RefreshEnabled)
	{
		return 'Manual';
	}
	if (pRow.RefreshCron)
	{
		return `cron: ${pRow.RefreshCron}`;
	}
	const tmpMinutes = parseInt(pRow.RefreshIntervalMinutes, 10);
	if (!isNaN(tmpMinutes) && tmpMinutes > 0)
	{
		if (tmpMinutes % 1440 === 0) { return `every ${tmpMinutes / 1440}d`; }
		if (tmpMinutes % 60 === 0) { return `every ${tmpMinutes / 60}h`; }
		return `every ${tmpMinutes}m`;
	}
	return 'Scheduled';
}

/**
 * Build the rail groups for the imported tab: one group per source-system root.
 * @param {Array<object>} pRows
 * @param {string} pSearch
 * @returns {Array<{ GroupKey: string, GroupLabel: string, Meta: string, Items: Array<object> }>}
 */
function groupClones(pRows, pSearch)
{
	const tmpGroups = {};
	const tmpOrder = [];
	for (const tmpRow of _filterRows(pRows, pSearch))
	{
		const tmpKey = sourceRoot(tmpRow.SourceAddress) || 'external';
		if (!tmpGroups[tmpKey])
		{
			tmpGroups[tmpKey] = { GroupKey: tmpKey, GroupLabel: humanizeSourceRoot(tmpKey), Items: [] };
			tmpOrder.push(tmpKey);
		}
		tmpGroups[tmpKey].Items.push(_railItem(tmpRow));
	}
	return tmpOrder.map((pKey) =>
	{
		const tmpGroup = tmpGroups[pKey];
		tmpGroup.Meta = `${tmpGroup.Items.length} table${tmpGroup.Items.length === 1 ? '' : 's'} · read-only`;
		return tmpGroup;
	});
}

/**
 * Build the rail groups for the computed tab: one group per RefreshGroup (pipeline), 'Ungrouped' last.
 * @param {Array<object>} pRows
 * @param {string} pSearch
 * @returns {Array<{ GroupKey: string, GroupLabel: string, Meta: string, Items: Array<object> }>}
 */
function groupComputed(pRows, pSearch)
{
	const tmpGroups = {};
	const tmpOrder = [];
	for (const tmpRow of _filterRows(pRows, pSearch))
	{
		const tmpKey = String(tmpRow.RefreshGroup || '') || '__ungrouped';
		if (!tmpGroups[tmpKey])
		{
			tmpGroups[tmpKey] = {
				GroupKey: tmpKey,
				GroupLabel: (tmpKey === '__ungrouped') ? 'Standalone projections' : tmpKey,
				Items: [],
			};
			tmpOrder.push(tmpKey);
		}
		tmpGroups[tmpKey].Items.push(_railItem(tmpRow));
	}
	// Ungrouped sorts last.
	tmpOrder.sort((a, b) => (a === '__ungrouped' ? 1 : 0) - (b === '__ungrouped' ? 1 : 0));
	return tmpOrder.map((pKey) =>
	{
		const tmpGroup = tmpGroups[pKey];
		const tmpPipeline = (pKey !== '__ungrouped');
		tmpGroup.Meta = tmpPipeline
			? `pipeline · ${tmpGroup.Items.length} stage${tmpGroup.Items.length === 1 ? '' : 's'}`
			: `${tmpGroup.Items.length} projection${tmpGroup.Items.length === 1 ? '' : 's'}`;
		return tmpGroup;
	});
}

/** Filter rows by a case-insensitive substring over name + physical table + description. */
function _filterRows(pRows, pSearch)
{
	const tmpRows = Array.isArray(pRows) ? pRows : [];
	const tmpSearch = String(pSearch || '').trim().toLowerCase();
	if (!tmpSearch)
	{
		return tmpRows;
	}
	return tmpRows.filter((pRow) =>
		`${pRow.ProjectionName || ''} ${pRow.PhysicalTableName || ''} ${pRow.Description || ''}`.toLowerCase().includes(tmpSearch));
}

/** A single rail row for a MaterializedProjection: the data-only fields the template renders. */
function _railItem(pRow)
{
	const tmpChip = deriveStatusChip(pRow);
	return {
		Name: pRow.ProjectionName || deriveLogicalReadName(pRow.PhysicalTableName) || `Projection ${pRow.IDMaterializedProjection}`,
		PhysicalTableName: pRow.PhysicalTableName || '',
		Description: pRow.Description || '',
		DescriptionSuffix: pRow.Description ? ` — ${pRow.Description}` : '',
		ChipLabel: tmpChip.Label,
		ChipClass: tmpChip.Class,
		ChipIcon: tmpChip.Icon,
		Cadence: deriveCadenceLabel(pRow),
		// How the dataset viewer opens this item: a registry row by GUID.
		OpenKind: 'guid',
		OpenArg: pRow.GUIDMaterializedProjection,
		GroupKey: sourceRoot(pRow.SourceAddress) || 'external',
		GroupLabel: humanizeImportedGroup(sourceRoot(pRow.SourceAddress) || 'external'),
	};
}

/** Friendly group label for an imported group key (the segment after the C<n>_ silo prefix, or a source root). */
function humanizeImportedGroup(pKey)
{
	const tmpKey = String(pKey || '');
	if (/^Lastrada/i.test(tmpKey)) { return 'Lastrada legacy DB'; }
	if (/lastrada/i.test(tmpKey)) { return 'Lastrada legacy DB'; }
	if (/^SiteManager/i.test(tmpKey) || /sitemanager/i.test(tmpKey)) { return 'SiteManager'; }
	return humanizeSourceRoot(tmpKey);
}

/** A rail row for a RAW lake table (an imported clone table that has no MaterializedProjection row). */
function _rawItem(pPhysicalTableName)
{
	const tmpLogical = deriveLogicalReadName(pPhysicalTableName);
	const tmpSegment = tmpLogical.split('_')[0];
	return {
		Name: tmpLogical,
		PhysicalTableName: pPhysicalTableName,
		Description: '',
		DescriptionSuffix: '',
		ChipLabel: 'Imported · read-only',
		ChipClass: 'is-link is-light',
		ChipIcon: 'fa-box-archive',
		Cadence: '',
		// Raw tables open by physical name (no registry row).
		OpenKind: 'table',
		OpenArg: pPhysicalTableName,
		GroupKey: tmpSegment,
		GroupLabel: humanizeImportedGroup(tmpSegment),
	};
}

/** Build imported-tab rail groups from MP "imported" rows + raw lake-table items, grouped + searched. */
function buildImportedGroups(pMPImportedRows, pRawItems, pSearch)
{
	const tmpItems = (pMPImportedRows || []).map((pRow) => _railItem(pRow)).concat(pRawItems || []);
	const tmpSearch = String(pSearch || '').trim().toLowerCase();
	const tmpFiltered = tmpSearch
		? tmpItems.filter((pItem) => `${pItem.Name} ${pItem.PhysicalTableName} ${pItem.Description || ''}`.toLowerCase().includes(tmpSearch))
		: tmpItems;
	const tmpGroups = {};
	const tmpOrder = [];
	for (const tmpItem of tmpFiltered)
	{
		const tmpKey = tmpItem.GroupKey || 'external';
		if (!tmpGroups[tmpKey])
		{
			tmpGroups[tmpKey] = { GroupKey: tmpKey, GroupLabel: tmpItem.GroupLabel || humanizeImportedGroup(tmpKey), Items: [] };
			tmpOrder.push(tmpKey);
		}
		tmpGroups[tmpKey].Items.push(tmpItem);
	}
	// Largest groups first (the Lastrada clone dominates).
	tmpOrder.sort((a, b) => tmpGroups[b].Items.length - tmpGroups[a].Items.length);
	return tmpOrder.map((pKey) =>
	{
		const tmpGroup = tmpGroups[pKey];
		tmpGroup.Meta = `${tmpGroup.Items.length} table${tmpGroup.Items.length === 1 ? '' : 's'} · read-only`;
		return tmpGroup;
	});
}

class DatalakeCatalogProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	/** @returns {*} The shared HeadlightRestClient registered on the fable. */
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	render()
	{
		if (this.pict.views.DatalakeCatalog)
		{
			this.pict.views.DatalakeCatalog.render();
		}
	}

	initializeState()
	{
		this.pict.AppData.DatalakeCatalog =
		{
			Loading: false,
			Rows: [],
			RawImported: [],  // raw lake tables (imported clones) not in the MaterializedProjection registry
			ActiveKind: 'computed', // 'imported' | 'computed'
			Search: '',
			Kpis: [],
			RailGroups: [],
			LoadingSlot: [],
			EmptySlot: [],
			ErrorSlot: [],
			// Tab button classes (data, not HTML).
			ImportedTabClass: '',
			ComputedTabClass: 'is-active',
			ImportedCount: 0,
			ComputedCount: 0,
		};
	}

	/**
	 * Load the customer's projection catalog. Reads auto-scope to MyCustomer; the IDCustomer filter is
	 * belt-and-suspenders and also scopes super-users (Administrator reads Allow = all customers).
	 */
	loadAsync()
	{
		if (!this.pict.AppData.DatalakeCatalog)
		{
			this.initializeState();
		}
		const tmpState = this.pict.AppData.DatalakeCatalog;
		tmpState.Loading = true;
		tmpState.ErrorSlot = [];
		this.deriveRenderState();
		this.render();

		const tmpCustomerID = parseInt((this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0, 10);
		const tmpFilter = 'FBV~Deleted~EQ~0' + (tmpCustomerID > 0 ? `~FBV~IDCustomer~EQ~${tmpCustomerID}` : '');
		// Page the MP registry to exhaustion rather than a single `/0/2000` (defensive — it's bounded to dozens per
		// customer today, but this drops the theoretical truncation). The imported-clones half (DataCatalog) is a
		// single un-paginatable inventory blob, so it stays one request.
		this._fetchAllMaterializedProjections(tmpFilter, (pError, pBody) =>
		{
			tmpState.Loading = false;
			if (pError)
			{
				tmpState.Rows = [];
				tmpState.ErrorSlot = [ { Message: `Could not load the data lake catalog: ${pError.message || pError}` } ];
				this.deriveRenderState();
				this.render();
				return;
			}
			tmpState.Rows = Array.isArray(pBody) ? pBody : [];
			// Land on the tab that actually has content (computed by default, else imported).
			const tmpSplit = splitByKind(tmpState.Rows);
			if (tmpSplit.computed.length === 0 && tmpSplit.imported.length > 0)
			{
				tmpState.ActiveKind = 'imported';
			}
			this.deriveRenderState();
			this.render();
			// The imported clones (raw lake tables) aren't in the MP registry — pull them from the DataCatalog.
			this._loadDataCatalog(tmpCustomerID);
		});
	}

	/** Page the MaterializedProjection registry to exhaustion (begin/count) → callback(error, allRows). */
	_fetchAllMaterializedProjections(pFilter, fDone)
	{
		const tmpPageSize = 2000;
		const tmpAll = [];
		const fPage = (pBegin) =>
		{
			this.restClient.getJSON(`MaterializedProjections/FilteredTo/${pFilter}/${pBegin}/${tmpPageSize}`, (pError, pBody) =>
			{
				if (pError) { return fDone(pError, tmpAll); }
				const tmpRows = Array.isArray(pBody) ? pBody : [];
				tmpRows.forEach((pRow) => tmpAll.push(pRow));
				if (tmpRows.length < tmpPageSize) { return fDone(null, tmpAll); }   // last (short) page
				fPage(pBegin + tmpPageSize);
			});
		};
		fPage(0);
	}

	/**
	 * Load the raw lake-table inventory from the DataCatalog and keep the C<id>_ tables that have no
	 * MaterializedProjection row — these are the imported clones (e.g. walbec's ~677 C182_LastradaDB_* tables).
	 */
	_loadDataCatalog(pCustomerID)
	{
		const tmpState = this.pict.AppData.DatalakeCatalog;
		if (!(pCustomerID > 0))
		{
			return;
		}
		this.restClient.getJSON('DataCatalog', (pError, pCatalog) =>
		{
			if (pError || !pCatalog || !pCatalog.Sources || !pCatalog.Sources.lake)
			{
				return; // best-effort; the computed catalog still works without it
			}
			const tmpLake = pCatalog.Sources.lake;
			const tmpDatasets = tmpLake.Datasets || tmpLake.datasets || [];
			const tmpNames = (Array.isArray(tmpDatasets) ? tmpDatasets : Object.keys(tmpDatasets))
				.map((pDataset) => (typeof pDataset === 'string') ? pDataset : (pDataset.Name || pDataset.Address || ''))
				.map((pString) => String(pString).replace(/^lake\//, ''));
			const tmpPrefix = `C${pCustomerID}_`;
			const tmpMPPhysical = {};
			tmpState.Rows.forEach((pRow) => { tmpMPPhysical[pRow.PhysicalTableName] = true; });
			tmpState.RawImported = tmpNames
				.filter((pName) => pName.startsWith(tmpPrefix) && !tmpMPPhysical[pName])
				.map((pName) => _rawItem(pName));
			this.deriveRenderState();
			this.render();
		});
	}

	deriveRenderState()
	{
		if (!this.pict.AppData.DatalakeCatalog)
		{
			this.initializeState();
		}
		const tmpState = this.pict.AppData.DatalakeCatalog;
		const tmpSplit = splitByKind(tmpState.Rows);
		const tmpRawImported = tmpState.RawImported || [];
		const tmpImportedTotal = tmpSplit.imported.length + tmpRawImported.length;
		tmpState.ImportedCount = tmpImportedTotal;
		tmpState.ComputedCount = tmpSplit.computed.length;

		// KPI strip (data only).
		const tmpPipelines = new Set(tmpSplit.computed.map((pRow) => pRow.RefreshGroup).filter(Boolean));
		const tmpFailed = tmpSplit.computed.filter((pRow) => /^Failed/i.test(String(pRow.LastRefreshStatus || ''))).length;
		tmpState.Kpis =
		[
			{ Label: 'Datasets', Value: String(tmpState.Rows.length + tmpRawImported.length), Icon: 'fas fa-database', Accent: 'var(--theme-color-brand-primary, #156dd1)' },
			{ Label: 'Imported', Value: String(tmpImportedTotal), Icon: 'fas fa-box-archive', Accent: 'var(--theme-color-status-info, #2b8aa7)' },
			{ Label: 'Projections', Value: String(tmpSplit.computed.length), Icon: 'fas fa-diagram-project', Accent: 'var(--theme-color-status-success, #3a9b5c)' },
			{ Label: 'Pipelines', Value: String(tmpPipelines.size), Icon: 'fas fa-timeline', Accent: 'var(--theme-color-status-warning, #d08a2c)' },
			{ Label: 'Failed runs', Value: String(tmpFailed), Icon: 'fas fa-circle-exclamation', Accent: 'var(--theme-color-status-error, #cf5b5b)' },
		];

		tmpState.ImportedTabClass = (tmpState.ActiveKind === 'imported') ? 'is-active' : '';
		tmpState.ComputedTabClass = (tmpState.ActiveKind === 'computed') ? 'is-active' : '';

		tmpState.RailGroups = (tmpState.ActiveKind === 'imported')
			? buildImportedGroups(tmpSplit.imported, tmpRawImported, tmpState.Search)
			: groupComputed(tmpSplit.computed, tmpState.Search);

		tmpState.LoadingSlot = tmpState.Loading ? [ {} ] : [];
		const tmpVisibleCount = tmpState.RailGroups.reduce((pSum, pGroup) => pSum + pGroup.Items.length, 0);
		const tmpKindLabel = (tmpState.ActiveKind === 'imported') ? 'imported' : 'computed';
		const tmpEmptyMessage = tmpState.Search
			? `No ${tmpKindLabel} datasets matching "${tmpState.Search}".`
			: (tmpState.ActiveKind === 'computed'
				? 'No computed projections yet. Projections you create from your Headlight data will appear here.'
				: 'No imported datasets. Cloned copies of source systems will appear here.');
		tmpState.EmptySlot = (!tmpState.Loading && tmpVisibleCount === 0) ? [ { Message: tmpEmptyMessage } ] : [];
	}

	// --- Interactions ---

	/** Switch the catalog kind via a stable route (#/Datalake/Kind/<kind>) so it lives in the URL. */
	navigateKind(pKind)
	{
		if ((typeof window !== 'undefined') && window.location) { window.location.hash = `#/Datalake/Kind/${ pKind }`; }
		else { this.setKind(pKind); }
	}

	setKind(pKind)
	{
		const tmpState = this.pict.AppData.DatalakeCatalog;
		tmpState.ActiveKind = (pKind === 'imported') ? 'imported' : 'computed';
		this.deriveRenderState();
		this.render();
	}

	setSearch(pValue)
	{
		const tmpState = this.pict.AppData.DatalakeCatalog;
		tmpState.Search = pValue || '';
		this.deriveRenderState();
		// Repaint ONLY the results box, not the whole view — a full render() would rebuild the search
		// <input> (a sibling in .dlc-toolbar) and drop focus/caret after each keystroke. Search affects
		// only RailGroups/EmptySlot/LoadingSlot (all inside #Datalake-Results); the KPIs and tab counts
		// are computed from the full set, so they don't change with the term.
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement('#Datalake-Results').length === 0) { this.render(); return; }
		tmpCA.assignContent('#Datalake-Results', this.pict.parseTemplateByHash('Datalake-Results', tmpState));
	}

	/** Open a dataset's detail view by GUID (the dataset route resolves it). */
	selectDataset(pGUID)
	{
		if (pGUID)
		{
			window.location.hash = `#/Datalake/Dataset/${pGUID}`;
		}
	}

	/** Open a catalog item: a registry projection by GUID, or a raw imported lake table by physical name. */
	openItem(pKind, pArg)
	{
		if (!pArg)
		{
			return;
		}
		window.location.hash = (pKind === 'table')
			? `#/Datalake/Table/${encodeURIComponent(pArg)}`
			: `#/Datalake/Dataset/${pArg}`;
	}

	/** Launch the create-projection wizard. */
	newProjection()
	{
		window.location.hash = '#/Datalake/New';
	}
}

module.exports = DatalakeCatalogProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'DatalakeCatalogProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

// Pure helpers exported for unit tests.
module.exports.classifyKind = classifyKind;
module.exports.splitByKind = splitByKind;
module.exports.sourceRoot = sourceRoot;
module.exports.humanizeSourceRoot = humanizeSourceRoot;
module.exports.deriveLogicalReadName = deriveLogicalReadName;
module.exports.deriveStatusChip = deriveStatusChip;
module.exports.deriveCadenceLabel = deriveCadenceLabel;
module.exports.groupClones = groupClones;
module.exports.groupComputed = groupComputed;

},{"pict-provider":845}],1333:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libCatalog = require('./DatalakeCatalog-Provider.js');

/**
 * Data Lake dataset provider — the per-dataset detail view (#/Datalake/Dataset/:GUID).
 *
 * Resolves the MaterializedProjection catalog row by GUID (main /1.0/ API), then reads the dataset's
 * column schema, a paginated page of rows, and its lineage from the PDO PrivateDataLake / DataCatalog
 * surface (same /1.0/ origin via Kong). Lake tables are flat (no relationships), so rows render as a
 * paginated table with columns derived from the JSON-Schema at runtime.
 *
 * Read-URL grammar (authoritative: PrivateLakeProvider._fetchProjectionBySegments): the logical name is
 * the PhysicalTableName with the customer-silo prefix stripped (C182_PD_MoistureDaily -> PD_MoistureDaily).
 * The resolver joins URL segments with '_' and matches ProjectionName EQ <suffix> OR PhysicalTableName LK
 * 'C%_<suffix>', so the single-segment logical always resolves. Schema/single-row use the singular name;
 * list/count pluralize it (append 's'). Lineage takes the PHYSICAL address: lake/<PhysicalTableName>.
 * Schema is loaded first so the lazy registration mounts routes off the singular segments.
 */

const PAGE_SIZE = 50;
const MAX_VISIBLE_COLUMNS = 16;

/** Stringify a lake cell value for the table (objects -> compact JSON, long values truncated). */
function cellText(pValue)
{
	if (pValue === null || pValue === undefined)
	{
		return '';
	}
	let tmpText;
	if (typeof(pValue) === 'object')
	{
		try { tmpText = JSON.stringify(pValue); }
		catch (pError) { tmpText = String(pValue); }
	}
	else
	{
		tmpText = String(pValue);
	}
	return (tmpText.length > 120) ? `${tmpText.slice(0, 117)}…` : tmpText;
}

/** Build the visible column descriptors from a JSON-Schema `properties` object. */
function columnsFromSchema(pProperties)
{
	const tmpProps = (pProperties && typeof(pProperties) === 'object') ? pProperties : {};
	const tmpKeys = Object.keys(tmpProps);
	return tmpKeys.slice(0, MAX_VISIBLE_COLUMNS).map((pKey) => ({ Key: pKey, Label: pKey, Type: (tmpProps[pKey] && tmpProps[pKey].type) || '' }));
}

class DatalakeDatasetProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	render()
	{
		if (this.pict.views.DatalakeDataset)
		{
			this.pict.views.DatalakeDataset.render();
		}
	}

	initializeState()
	{
		this.pict.AppData.DatalakeDataset =
		{
			Loading: false,
			ErrorSlot: [],
			Row: null,
			Kind: 'computed',
			IsImported: false,
			IsComputed: true,

			HeaderName: '',
			HeaderSub: '',
			ChipLabel: '',
			ChipClass: '',
			ChipIcon: '',
			MetaRows: [],

			SchemaRows: [],
			SchemaColumnCount: 0,

			Columns: [],
			Rows: [],
			RowCount: 0,
			Begin: 0,
			PageLabel: '',
			PrevDisabledAttr: 'disabled',
			NextDisabledAttr: 'disabled',
			ColumnsTruncatedNote: '',
			RowsLoadingSlot: [],
			RowsEmptySlot: [],

			LineageUpstream: [],
			LineageDownstream: [],
			LineageSlot: [],

			// Management (mutations): schedule edit + refresh + re-import.
			CanManageSchedule: false,
			CanReImport: false,
			ManageSlot: [],
			ComputedManageSlot: [],
			ImportedManageSlot: [],
			RawActionSlot: [],
			Schedule: { Enabled: false, Mode: 'interval', Cron: '', IntervalMinutes: 60, Group: '' },
			ScheduleEnabledAttr: '',
			ScheduleModeCronChecked: '',
			ScheduleModeIntervalChecked: 'checked',
			ScheduleCronClass: 'is-hidden',
			ScheduleIntervalClass: '',
			ActionBusy: false,
			ActionBusySlot: [],
			ActionResultSlot: [],
			RefreshDisabledAttr: '',

			LoadingSlot: [],
		};
	}

	/** The logical lake-read name (PhysicalTableName minus the C<n>_ silo prefix). */
	get logicalName()
	{
		const tmpRow = this.pict.AppData.DatalakeDataset.Row || {};
		return libCatalog.deriveLogicalReadName(tmpRow.PhysicalTableName);
	}

	/**
	 * Open a dataset by its MaterializedProjection GUID: resolve the catalog row, then load schema + rows +
	 * lineage. Re-reads the row (so a deep-link works without the catalog list being loaded).
	 * @param {string} pGUID
	 */
	openByGUIDAsync(pGUID)
	{
		// initializeState() REPLACES AppData.DatalakeDataset, so capture the reference AFTER it (else writes
		// land on an orphaned object while the view reads the fresh, empty one).
		this.initializeState();
		const tmpState = this.pict.AppData.DatalakeDataset;
		tmpState.Loading = true;
		tmpState.LoadingSlot = [ {} ];
		this.render();

		this.restClient.getJSON(`MaterializedProjections/FilteredTo/FBV~GUIDMaterializedProjection~EQ~${encodeURIComponent(pGUID)}/0/1`, (pError, pBody) =>
		{
			if (pError || !Array.isArray(pBody) || pBody.length < 1)
			{
				tmpState.Loading = false;
				tmpState.LoadingSlot = [];
				tmpState.ErrorSlot = [ { Message: pError ? `Could not load this dataset: ${pError.message || pError}` : 'Dataset not found.' } ];
				this.render();
				return;
			}
			tmpState.Row = pBody[0];
			tmpState.Kind = libCatalog.classifyKind(tmpState.Row);
			tmpState.IsImported = (tmpState.Kind === 'imported');
			tmpState.IsComputed = (tmpState.Kind === 'computed');
			tmpState.Begin = 0;
			this._deriveHeaderAndMeta();
			this._deriveActions();
			this.render();
			this._loadSchema();
			this._loadLineage();
		});
	}

	/**
	 * Open a RAW imported lake table by its physical name — a clone table (e.g. C182_LastradaDB_ASPHALT) that
	 * has no MaterializedProjection registry row. Synthesizes a read-only catalog row, then loads schema +
	 * rows + lineage the same way. No management actions (there is no projection definition to refresh).
	 * @param {string} pPhysicalTableName
	 */
	openByTableAsync(pPhysicalTableName)
	{
		this.initializeState();
		const tmpState = this.pict.AppData.DatalakeDataset;
		tmpState.Loading = true;
		tmpState.LoadingSlot = [ {} ];
		tmpState.Row =
		{
			PhysicalTableName: pPhysicalTableName,
			ProjectionName: libCatalog.deriveLogicalReadName(pPhysicalTableName),
			SourceType: 'PrivateLakeRaw',
			OperationType: '',
			SourceAddress: `lake/${pPhysicalTableName}`,
			TargetAddress: `lake/${pPhysicalTableName}`,
			RefreshEnabled: 0,
			Description: 'Imported raw lake table (no projection definition).',
			IsRaw: true,
		};
		tmpState.Kind = 'imported';
		tmpState.IsImported = true;
		tmpState.IsComputed = false;
		tmpState.Begin = 0;
		this._deriveHeaderAndMeta();
		this._deriveActions();
		this.render();
		this._loadSchema();
		this._loadLineage();
	}

	/** Load the dataset's column schema (singular name → triggers lazy registration), then count + rows. */
	_loadSchema()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpLogical = this.logicalName;
		this.restClient.getJSON(`PrivateDataLake/${tmpLogical}/Schema`, (pError, pBody) =>
		{
			if (pError)
			{
				tmpState.Loading = false;
				tmpState.LoadingSlot = [];
				const tmpIsRaw = tmpState.Row && tmpState.Row.IsRaw;
				tmpState.ErrorSlot = [ { Message: tmpIsRaw
					? 'This is a raw imported source table — catalogued in your data lake, but not directly queryable over the API (only materialized projections are). Create a projection from it to browse and use its data.'
					: `Could not read the dataset schema: ${pError.message || pError}` } ];
				this.render();
				return;
			}
			const tmpProperties = (pBody && pBody.properties) || {};
			const tmpKeys = Object.keys(tmpProperties);
			tmpState.SchemaRows = tmpKeys.map((pKey) => ({ Column: pKey, Type: (tmpProperties[pKey] && tmpProperties[pKey].type) || '', Size: (tmpProperties[pKey] && tmpProperties[pKey].size) || '' }));
			tmpState.SchemaColumnCount = tmpKeys.length;
			tmpState.Columns = columnsFromSchema(tmpProperties);
			tmpState.ColumnsTruncatedNote = (tmpKeys.length > MAX_VISIBLE_COLUMNS)
				? `Showing the first ${MAX_VISIBLE_COLUMNS} of ${tmpKeys.length} columns.`
				: '';
			this.render();
			this._loadCount();
			this._loadRowsPage();
		});
	}

	_loadCount()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		this.restClient.getJSON(`PrivateDataLake/${this.logicalName}s/Count`, (pError, pBody) =>
		{
			if (!pError && pBody)
			{
				tmpState.RowCount = (typeof(pBody.Count) === 'number') ? pBody.Count : (parseInt(pBody.Count, 10) || 0);
				this._derivePager();
				this.render();
			}
		});
	}

	_loadRowsPage()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		tmpState.RowsLoadingSlot = [ {} ];
		tmpState.RowsEmptySlot = [];
		this.render();
		this.restClient.getJSON(`PrivateDataLake/${this.logicalName}s/${tmpState.Begin}/${PAGE_SIZE}`, (pError, pBody) =>
		{
			tmpState.Loading = false;
			tmpState.LoadingSlot = [];
			tmpState.RowsLoadingSlot = [];
			if (pError)
			{
				tmpState.ErrorSlot = [ { Message: `Could not read dataset rows: ${pError.message || pError}` } ];
				this.render();
				return;
			}
			const tmpRecords = Array.isArray(pBody) ? pBody : [];
			tmpState.Rows = tmpRecords.map((pRecord) => ({
				Cells: tmpState.Columns.map((pColumn) => ({ Value: cellText(pRecord[pColumn.Key]) })),
			}));
			tmpState.RowsEmptySlot = (tmpRecords.length === 0) ? [ {} ] : [];
			this._derivePager();
			this.render();
		});
	}

	_derivePager()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpFrom = tmpState.RowCount === 0 ? 0 : tmpState.Begin + 1;
		const tmpTo = Math.min(tmpState.Begin + PAGE_SIZE, tmpState.RowCount || (tmpState.Begin + tmpState.Rows.length));
		tmpState.PageLabel = `${tmpFrom.toLocaleString('en-US')}–${tmpTo.toLocaleString('en-US')} of ${(tmpState.RowCount || 0).toLocaleString('en-US')}`;
		tmpState.PrevDisabledAttr = (tmpState.Begin <= 0) ? 'disabled' : '';
		tmpState.NextDisabledAttr = ((tmpState.Begin + PAGE_SIZE) >= tmpState.RowCount) ? 'disabled' : '';
	}

	_loadLineage()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpRow = tmpState.Row || {};
		const tmpAddress = tmpRow.TargetAddress || `lake/${tmpRow.PhysicalTableName}`;
		this.restClient.getJSON(`DataCatalog/Lineage?address=${encodeURIComponent(tmpAddress)}`, (pError, pBody) =>
		{
			if (pError || !pBody)
			{
				return; // lineage is best-effort; never block the viewer on it
			}
			const tmpUpstream = pBody.Upstream || pBody.upstream || [];
			const tmpDownstream = pBody.Downstream || pBody.downstream || [];
			tmpState.LineageUpstream = (Array.isArray(tmpUpstream) ? tmpUpstream : []).map((pItem) => ({ Address: (typeof(pItem) === 'string') ? pItem : (pItem.Address || pItem.address || JSON.stringify(pItem)) }));
			tmpState.LineageDownstream = (Array.isArray(tmpDownstream) ? tmpDownstream : []).map((pItem) => ({ Address: (typeof(pItem) === 'string') ? pItem : (pItem.Address || pItem.address || JSON.stringify(pItem)) }));
			tmpState.LineageSlot = (tmpState.LineageUpstream.length > 0 || tmpState.LineageDownstream.length > 0) ? [ {} ] : [];
			this.render();
		});
	}

	_deriveHeaderAndMeta()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpRow = tmpState.Row || {};
		const tmpChip = libCatalog.deriveStatusChip(tmpRow);
		tmpState.ChipLabel = tmpChip.Label;
		tmpState.ChipClass = tmpChip.Class;
		tmpState.ChipIcon = tmpChip.Icon;
		tmpState.HeaderName = tmpRow.ProjectionName || libCatalog.deriveLogicalReadName(tmpRow.PhysicalTableName);
		tmpState.HeaderSub = tmpRow.Description || '';

		const tmpMeta = [];
		tmpMeta.push({ Label: 'Physical table', Value: tmpRow.PhysicalTableName || '' });
		tmpMeta.push({ Label: 'Kind', Value: tmpState.IsImported ? 'Imported clone (read-only)' : 'Computed projection' });
		tmpMeta.push({ Label: 'Operation', Value: tmpRow.OperationType || '' });
		tmpMeta.push({ Label: 'Source', Value: tmpRow.SourceAddress || tmpRow.SourceDescriptor || '' });
		tmpMeta.push({ Label: 'Target', Value: tmpRow.TargetAddress || '' });
		if (tmpState.IsComputed)
		{
			tmpMeta.push({ Label: 'Refresh', Value: libCatalog.deriveCadenceLabel(tmpRow) });
			if (tmpRow.RefreshGroup) { tmpMeta.push({ Label: 'Pipeline', Value: tmpRow.RefreshGroup }); }
			tmpMeta.push({ Label: 'Last run', Value: this._formatRunStamp(tmpRow) });
		}
		else
		{
			tmpMeta.push({ Label: 'Imported', Value: this._formatDate(tmpRow.LastRefreshDate || tmpRow.CreateDate) });
		}
		tmpState.MetaRows = tmpMeta;
	}

	_formatRunStamp(pRow)
	{
		const tmpStatus = pRow.LastRefreshStatus || '—';
		const tmpDate = this._formatDate(pRow.LastRefreshDate);
		return tmpDate ? `${tmpStatus} · ${tmpDate}` : tmpStatus;
	}

	_formatDate(pValue)
	{
		if (!pValue)
		{
			return '';
		}
		const tmpString = String(pValue);
		// Render the date portion only (avoid a Date() parse that varies by tz); the API returns ISO-ish.
		const tmpMatch = tmpString.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/);
		return tmpMatch ? `${tmpMatch[1]} ${tmpMatch[2]}` : tmpString.slice(0, 19);
	}

	// --- Management (mutations) ---

	/** Decide which management affordances apply + seed the schedule editor from the row. */
	_deriveActions()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpRow = tmpState.Row || {};
		tmpState.CanManageSchedule = tmpState.IsComputed;
		tmpState.CanReImport = tmpState.IsImported && !tmpRow.IsRaw;
		tmpState.ManageSlot = (tmpState.CanManageSchedule || tmpState.CanReImport) ? [ {} ] : [];
		tmpState.ComputedManageSlot = tmpState.CanManageSchedule ? [ {} ] : [];
		tmpState.ImportedManageSlot = tmpState.CanReImport ? [ {} ] : [];
		// Raw imported table → offer to "projectionize" it into a queryable projection.
		tmpState.RawActionSlot = tmpRow.IsRaw ? [ {} ] : [];

		const tmpHasCron = !!(tmpRow.RefreshCron && String(tmpRow.RefreshCron).trim());
		tmpState.Schedule =
		{
			Enabled: !!tmpRow.RefreshEnabled,
			Mode: tmpHasCron ? 'cron' : 'interval',
			Cron: tmpRow.RefreshCron || '',
			IntervalMinutes: parseInt(tmpRow.RefreshIntervalMinutes, 10) || 60,
			Group: tmpRow.RefreshGroup || '',
		};
		this._deriveScheduleAttrs();
	}

	_deriveScheduleAttrs()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpSchedule = tmpState.Schedule;
		tmpState.ScheduleEnabledAttr = tmpSchedule.Enabled ? 'checked' : '';
		tmpState.ScheduleModeCronChecked = (tmpSchedule.Mode === 'cron') ? 'checked' : '';
		tmpState.ScheduleModeIntervalChecked = (tmpSchedule.Mode === 'interval') ? 'checked' : '';
		tmpState.ScheduleCronClass = (tmpSchedule.Enabled && tmpSchedule.Mode === 'cron') ? '' : 'is-hidden';
		tmpState.ScheduleIntervalClass = (tmpSchedule.Enabled && tmpSchedule.Mode === 'interval') ? '' : 'is-hidden';
	}

	setScheduleEnabledLocal(pChecked)
	{
		this.pict.AppData.DatalakeDataset.Schedule.Enabled = !!pChecked;
		this._deriveScheduleAttrs();
		this.render();
	}

	setScheduleMode(pMode)
	{
		this.pict.AppData.DatalakeDataset.Schedule.Mode = (pMode === 'cron') ? 'cron' : 'interval';
		this._deriveScheduleAttrs();
		this.render();
	}

	/** Update a schedule field WITHOUT re-rendering (so text/number input cursors aren't reset). */
	setScheduleField(pField, pValue)
	{
		const tmpSchedule = this.pict.AppData.DatalakeDataset.Schedule;
		if (pField === 'cron') { tmpSchedule.Cron = pValue || ''; }
		else if (pField === 'interval') { tmpSchedule.IntervalMinutes = parseInt(pValue, 10) || 0; }
		else if (pField === 'group') { tmpSchedule.Group = pValue || ''; }
	}

	/** PUT the full schedule triplet so switching modes clears the stale field (see 05-api-reference). */
	saveSchedule()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpRow = tmpState.Row || {};
		if (!tmpState.CanManageSchedule || tmpState.ActionBusy)
		{
			return;
		}
		const tmpSchedule = tmpState.Schedule;
		const tmpRecord =
		{
			IDMaterializedProjection: tmpRow.IDMaterializedProjection,
			RefreshEnabled: tmpSchedule.Enabled ? 1 : 0,
			RefreshCron: (tmpSchedule.Enabled && tmpSchedule.Mode === 'cron') ? String(tmpSchedule.Cron || '') : '',
			RefreshIntervalMinutes: (tmpSchedule.Enabled && tmpSchedule.Mode === 'interval') ? (parseInt(tmpSchedule.IntervalMinutes, 10) || 0) : 0,
			RefreshGroup: String(tmpSchedule.Group || ''),
		};
		this._setBusy(true);
		this.restClient.updateEntity('MaterializedProjection', tmpRecord, (pError) =>
		{
			this._setBusy(false);
			if (pError)
			{
				this._setActionResult('is-danger', 'fa-triangle-exclamation', `Could not update the schedule: ${pError.message || pError}`);
				return;
			}
			this._setActionResult('is-success', 'fa-circle-check', tmpSchedule.Enabled ? 'Schedule saved — automatic refreshes are enabled.' : 'Schedule paused.');
			this._reloadRowOnly();
		});
	}

	/** Re-run this projection now (POST /1.0/Projection rebuilt from the registry row). */
	refreshNow()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		if (!tmpState.CanManageSchedule || tmpState.ActionBusy)
		{
			return;
		}
		this._runRerun('Refresh', 'Refreshing — this can take a while for large sources…');
	}

	/** Re-pull an imported clone from its source (durable source, safe to re-run). */
	reImport()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		if (!tmpState.CanReImport || tmpState.ActionBusy)
		{
			return;
		}
		this._runRerun('Re-import', 'Re-importing from the source…');
	}

	_runRerun(pLabel, pBusyMessage)
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpBody = this._buildRerunBody(tmpState.Row);
		if (!tmpBody)
		{
			this._setActionResult('is-danger', 'fa-triangle-exclamation', `Could not reconstruct this dataset's definition to ${pLabel.toLowerCase()} it.`);
			return;
		}
		this._setBusy(true);
		this._setActionResult('is-info', 'fa-rotate', pBusyMessage);
		this.restClient.postJSON('Projection', tmpBody, (pError, pResponse) =>
		{
			this._setBusy(false);
			if (pError)
			{
				// Long runs can 504 at the gateway while continuing server-side — treat as indeterminate.
				this._setActionResult('is-warning', 'fa-clock', `${pLabel} was submitted but didn't confirm in time — it may still be running. Reloading status…`);
				this._reloadRowOnly();
				this._loadCount();
				return;
			}
			this._afterRunResult(pResponse, pLabel);
		});
	}

	/** Reconstruct the POST /1.0/Projection body from the stored registry row (OperationConfiguration from SourceConfigJSON). */
	_buildRerunBody(pRow)
	{
		if (!pRow || !pRow.OperationType || !pRow.SourceAddress || !pRow.TargetAddress)
		{
			return null;
		}
		const tmpBody =
		{
			IDCustomer: pRow.IDCustomer,
			Name: pRow.ProjectionName,
			OperationType: pRow.OperationType,
			Source: pRow.SourceAddress,
			Target: pRow.TargetAddress,
		};
		let tmpConfig = null;
		try { tmpConfig = pRow.SourceConfigJSON ? JSON.parse(pRow.SourceConfigJSON) : null; }
		catch (pError) { tmpConfig = null; }
		if (tmpConfig && tmpConfig.OperationConfiguration)
		{
			tmpBody.OperationConfiguration = tmpConfig.OperationConfiguration;
		}
		else if (tmpConfig && (tmpConfig.Projection || tmpConfig.Entity || tmpConfig.GroupBy || tmpConfig.ArrayPath))
		{
			tmpBody.OperationConfiguration = tmpConfig;
		}
		// POST /1.0/Projection requires OperationConfiguration; if we can't recover it, signal failure.
		return tmpBody.OperationConfiguration ? tmpBody : null;
	}

	_afterRunResult(pResponse, pLabel)
	{
		const tmpOK = pResponse && (pResponse.Success === true || /complete/i.test(String(pResponse.Status || '')));
		const tmpRead = (pResponse && pResponse.RowsRead != null) ? pResponse.RowsRead : '?';
		const tmpWritten = (pResponse && pResponse.RowsWritten != null) ? pResponse.RowsWritten : '?';
		if (tmpOK && tmpWritten === 0)
		{
			this._setActionResult('is-warning', 'fa-circle-exclamation', `${pLabel} completed but wrote 0 rows — check the source filter.`);
		}
		else if (tmpOK)
		{
			this._setActionResult('is-success', 'fa-circle-check', `${pLabel} complete — ${tmpRead} read, ${tmpWritten} written.`);
		}
		else
		{
			const tmpFailure = pResponse && pResponse.Failure;
			this._setActionResult('is-danger', 'fa-triangle-exclamation', `${pLabel} failed${(tmpFailure && tmpFailure.Reason) ? ': ' + tmpFailure.Reason : '.'}`);
		}
		const tmpState = this.pict.AppData.DatalakeDataset;
		tmpState.Begin = 0;
		this._reloadRowOnly();
		this._loadCount();
		this._loadRowsPage();
	}

	/** Re-read just the registry row + re-derive header/meta/actions (preserves the action-result banner). */
	_reloadRowOnly()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		const tmpGUID = (tmpState.Row || {}).GUIDMaterializedProjection;
		if (!tmpGUID)
		{
			return;
		}
		this.restClient.getJSON(`MaterializedProjections/FilteredTo/FBV~GUIDMaterializedProjection~EQ~${encodeURIComponent(tmpGUID)}/0/1`, (pError, pBody) =>
		{
			if (!pError && Array.isArray(pBody) && pBody.length > 0)
			{
				tmpState.Row = pBody[0];
				tmpState.Kind = libCatalog.classifyKind(tmpState.Row);
				tmpState.IsImported = (tmpState.Kind === 'imported');
				tmpState.IsComputed = (tmpState.Kind === 'computed');
				this._deriveHeaderAndMeta();
				this._deriveActions();
				this.render();
			}
		});
	}

	_setBusy(pBusy)
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		tmpState.ActionBusy = !!pBusy;
		tmpState.ActionBusySlot = pBusy ? [ {} ] : [];
		tmpState.RefreshDisabledAttr = pBusy ? 'disabled' : '';
		this.render();
	}

	_setActionResult(pClass, pIcon, pMessage)
	{
		this.pict.AppData.DatalakeDataset.ActionResultSlot = [ { Class: pClass, Icon: pIcon, Message: pMessage } ];
		this.render();
	}

	deriveRenderState()
	{
		if (!this.pict.AppData.DatalakeDataset)
		{
			this.initializeState();
		}
	}

	// --- pager interactions ---

	nextPage()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		if ((tmpState.Begin + PAGE_SIZE) >= tmpState.RowCount)
		{
			return;
		}
		tmpState.Begin += PAGE_SIZE;
		this._loadRowsPage();
	}

	prevPage()
	{
		const tmpState = this.pict.AppData.DatalakeDataset;
		if (tmpState.Begin <= 0)
		{
			return;
		}
		tmpState.Begin = Math.max(0, tmpState.Begin - PAGE_SIZE);
		this._loadRowsPage();
	}

	backToCatalog()
	{
		window.location.hash = '#/Datalake';
	}

	/** Projectionize a raw imported table: open the create wizard pre-filled to clone it into a queryable projection. */
	projectionizeThis()
	{
		const tmpRow = this.pict.AppData.DatalakeDataset.Row;
		if (tmpRow && tmpRow.PhysicalTableName && this.pict.providers.DatalakeProjectionEditorProvider)
		{
			this.pict.providers.DatalakeProjectionEditorProvider.newFromLakeTable(tmpRow.PhysicalTableName);
			window.location.hash = '#/Datalake/New';
		}
	}
}

module.exports = DatalakeDatasetProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'DatalakeDatasetProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

module.exports.cellText = cellText;
module.exports.columnsFromSchema = columnsFromSchema;
module.exports.PAGE_SIZE = PAGE_SIZE;

},{"./DatalakeCatalog-Provider.js":1332,"pict-provider":845}],1334:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libBuilder = require('../datalake/Datalake-Projection-Builder.js');
const libSourceEntities = require('../datalake/Datalake-Source-Entities.js');
const libCatalog = require('./DatalakeCatalog-Provider.js');

/**
 * Create-projection wizard provider.
 *
 * A 5-step flow that builds a materialized Extraction projection from the Headlight data model and submits
 * it to POST /1.0/Projection: (1) pick a source entity + optional FoxHound filter (+ a "test source" row
 * count); (2) pick the output columns from the entity's live /Schema + the GUID template; (3) name +
 * auto-derived silo Target + optional refresh schedule; (4) review the generated POST body; (5) submit +
 * show the run result, then apply the schedule via a follow-up PUT (POST /1.0/Projection takes no schedule
 * fields). All decisions go through the pure Datalake-Projection-Builder so they're unit-tested; AppData
 * holds data + slots only.
 *
 * Tier 1 (this provider) extracts structural meadow columns. Tier 2 (Document + a DocumentType → FormData
 * fields from the ArtifactType schema) layers onto the same flow via the FormData hooks.
 */

const AUDIT_FIELDS = { CreateDate: 1, CreatingIDUser: 1, UpdateDate: 1, UpdatingIDUser: 1, Deleted: 1, DeleteDate: 1, DeletingIDUser: 1 };

/** Audit-ish columns excluded from the default selection (the lake adds its own audit + GUID columns). */
function isAuditField(pName, pEntity)
{
	return !!AUDIT_FIELDS[pName] || (pName === `GUID${pEntity}`);
}

const STEP_COUNT = 5;

class DatalakeProjectionEditorProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._schemaCache = {};
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	render()
	{
		if (this.pict.views.DatalakeProjectionEditor)
		{
			this.pict.views.DatalakeProjectionEditor.render();
		}
	}

	get isSuperUser()
	{
		const tmpUser = this.pict.AppData.CurrentUser || {};
		return (parseInt(tmpUser.UserRoleIndex, 10) === 5) && (parseInt(tmpUser.CustomerID, 10) === 1);
	}

	initializeState()
	{
		const tmpCustomerID = parseInt((this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0, 10);
		this.pict.AppData.DatalakeProjectionEditor =
		{
			ActiveStep: 1,
			CompletedSteps: [],
			Mode: 'extraction', // 'extraction' | 'clone' (projectionize a raw imported lake table)
			LakeSource: '',
			LakeSourceTable: '',
			Step1_CardClass: '',
			Step2_CardClass: '',
			CloneBannerSlot: [],

			// Step 1 — Source
			SourceType: 'entity', // 'entity' (Headlight model) | 'lake' (existing projection / imported clone)
			Entity: '',
			EntityLabel: '',
			IsFormDataEntity: false,
			DocumentType: '',
			Filter: '',
			SourceConnectionPrefix: 'headlight_api',
			SourceEntityOptions: [],
			LakeKind: '',         // when SourceType==='lake': 'computed' | 'imported'
			LakeSourceLabel: '',
			LakeSourceValue: '',  // the picker's composite value: `${Kind}::${Physical}` (or '' for none)
			LakeSourceGroups: [], // [{ GroupLabel, Items:[{ Physical, Label, Kind, SelectedAttr }] }]
			LakeSourcesLoaded: false,
			LakeSourcesLoadingSlot: [],
			TestResultSlot: [],
			TestBusy: false,

			// Step 2 — Columns + GUID
			SchemaLoadingSlot: [],
			SchemaErrorSlot: [],
			ShowAll: false,
			Fields: [],          // working model: { SourceField, OutCol, JsonType, Size, Include, IsAudit }
			FieldRows: [],       // derived render rows
			FormDataFields: [],  // Tier 2: manually-added FormData.<key> columns ({ Key, OutCol })
			FormDataRows: [],    // derived render rows for FormData
			IncludedCount: 0,
			GUIDTemplate: '',

			// Step 3 — Name / Target / Schedule
			IDCustomer: tmpCustomerID,
			IDCustomerEditable: this.isSuperUser,
			Name: '',
			Description: '',
			TargetPreview: '',
			NameErrorSlot: [],
			ScheduleEnabled: false,
			ScheduleMode: 'interval',
			Cron: '',
			IntervalMinutes: 1440,
			Group: '',
			ScheduleEnabledAttr: '',
			ScheduleModeIntervalChecked: 'checked',
			ScheduleModeCronChecked: '',
			ScheduleFieldsClass: 'is-hidden',
			ScheduleIntervalClass: '',
			ScheduleCronClass: 'is-hidden',

			// Step 4 — Review
			ReviewJSON: '',
			ValidationSlot: [],

			// Step 5 — Submit + result
			Submitting: false,
			SubmitBusySlot: [],
			ResultSlot: [],
			NewDatasetGUID: '',
		};
	}

	/** Entry point from the route: reset + seed the source-entity picker. */
	newProjection()
	{
		this.initializeState();
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.SourceEntityOptions = libSourceEntities.DATALAKE_SOURCE_ENTITIES.map((pEntity) => ({
			Entity: pEntity.Entity,
			Label: pEntity.Label,
			SelectedAttr: '',
		}));
		this.render();
	}

	/**
	 * Open the wizard in "clone" mode pre-filled to projectionize a raw imported lake table: a 1:1
	 * PassthroughClone of the table into a new, registered (queryable) lake table. Source + columns are
	 * implicit, so it jumps to naming.
	 * @param {string} pPhysicalTableName
	 */
	newFromLakeTable(pPhysicalTableName)
	{
		this.newProjection();
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.Mode = 'clone';
		tmpState.LakeSourceTable = pPhysicalTableName;
		tmpState.LakeSource = `lake/${pPhysicalTableName}`;
		tmpState.CompletedSteps = [ 1, 2 ];
		tmpState.ActiveStep = 3;
		// Suggested name (must differ from the source table) — the logical name + a "_q" (queryable) suffix.
		const tmpLogical = pPhysicalTableName.replace(/^C\d+_/, '');
		tmpState.Name = `${tmpLogical}_q`.replace(/[^A-Za-z0-9_]/g, '_').slice(0, 110);
		// PassthroughClone needs a per-row key; imported lake tables carry a synthetic 'GUID' column
		// (private-lake-ingest's Schema-Inferrer always prepends an AutoIdentity 'ID' + AutoGUID 'GUID').
		tmpState.GUIDTemplate = '{~D:Record.GUID~}';
		this.deriveRenderState();
		this.render();
	}

	// --- derived render state ---

	deriveRenderState()
	{
		if (!this.pict.AppData.DatalakeProjectionEditor)
		{
			this.newProjection();
		}
		this.deriveStepState();
		this.deriveFieldState();
		this.deriveFormDataRows();
		this.deriveNameState();
		this.deriveScheduleAttrs();

		// Clone (projectionize) mode: hide the source + columns steps, show a "cloning X" banner.
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		const tmpClone = (tmpState.Mode === 'clone');
		tmpState.Step1_CardClass = tmpClone ? 'is-hidden' : '';
		tmpState.Step2_CardClass = tmpClone ? 'is-hidden' : '';
		tmpState.CloneBannerSlot = tmpClone ? [ { Source: tmpState.LakeSourceTable } ] : [];

		// Step-1 source-type tier: Headlight model (entity picker) vs data lake (projection/clone picker).
		const tmpLake = (tmpState.SourceType === 'lake');
		tmpState.SourceTypeEntityChecked = tmpLake ? '' : 'checked';
		tmpState.SourceTypeLakeChecked = tmpLake ? 'checked' : '';
		tmpState.EntityPickerSlot = tmpLake ? [] : [ {} ];
		tmpState.LakePickerSlot = tmpLake ? [ {} ] : [];
		tmpState.TestCountSlot = tmpLake ? [] : [ {} ]; // row-count test is entity-only for now
		(tmpState.LakeSourceGroups || []).forEach((pGroup) =>
		{
			pGroup.Items.forEach((pItem) => { pItem.SelectedAttr = (`lake/${pItem.Physical}` === tmpState.LakeSource) ? 'selected' : ''; });
		});
		tmpState.LakeSourcesEmptySlot = (tmpLake && tmpState.LakeSourcesLoaded
			&& (tmpState.LakeSourcesLoadingSlot || []).length === 0
			&& (tmpState.LakeSourceGroups || []).length === 0) ? [ {} ] : [];
	}

	deriveStepState()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		for (let i = 1; i <= STEP_COUNT; i++)
		{
			tmpState['Step' + i + '_BodyClass'] = (tmpState.ActiveStep === i) ? '' : 'is-hidden';
			if (tmpState.CompletedSteps.includes(i))
			{
				tmpState['Step' + i + '_StatusLabel'] = '✓';
				tmpState['Step' + i + '_StatusClass'] = 'is-success';
			}
			else if (tmpState.ActiveStep === i)
			{
				tmpState['Step' + i + '_StatusLabel'] = 'Active';
				tmpState['Step' + i + '_StatusClass'] = 'is-info';
			}
			else
			{
				tmpState['Step' + i + '_StatusLabel'] = '';
				tmpState['Step' + i + '_StatusClass'] = '';
			}
		}
	}

	deriveFieldState()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		const tmpRows = [];
		let tmpIncluded = 0;
		for (const tmpField of tmpState.Fields)
		{
			if (tmpField.Include) { tmpIncluded++; }
			if (tmpField.IsAudit && !tmpState.ShowAll && !tmpField.Include)
			{
				continue;
			}
			tmpRows.push({
				SourceField: tmpField.SourceField,
				OutCol: tmpField.OutCol,
				JsonType: tmpField.JsonType,
				MeadowType: libBuilder.jsonTypeToMeadow(tmpField.JsonType, tmpField.Size),
				IncludeAttr: tmpField.Include ? 'checked' : '',
				RowClass: tmpField.Include ? '' : 'has-text-grey',
			});
		}
		tmpState.FieldRows = tmpRows;
		const tmpFormDataCount = (tmpState.FormDataFields || []).filter((pField) => pField.Key && String(pField.Key).trim()).length;
		tmpState.IncludedCount = tmpIncluded + tmpFormDataCount;
		tmpState.ShowAllLabel = tmpState.ShowAll ? 'Hide audit columns' : 'Show all columns';
	}

	/** Tier 2: render rows for the manually-added FormData fields (Document source). */
	deriveFormDataRows()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.FormDataRows = (tmpState.FormDataFields || []).map((pField, pIndex) => ({
			Index: pIndex,
			Key: pField.Key,
			OutCol: pField.OutCol,
		}));
		tmpState.FormDataSlot = tmpState.IsFormDataEntity ? [ {} ] : [];
	}

	deriveNameState()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.TargetPreview = (tmpState.IDCustomer && tmpState.Name) ? `lake/C${tmpState.IDCustomer}_${tmpState.Name}` : '';
		tmpState.IDCustomerEditable = this.isSuperUser;
		if (tmpState.Name && !libBuilder.NAME_REGEX.test(tmpState.Name))
		{
			tmpState.NameErrorSlot = [ { Message: 'Letters, numbers and underscores only; must start with a letter.' } ];
		}
		else
		{
			tmpState.NameErrorSlot = [];
		}
	}

	deriveScheduleAttrs()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.ScheduleEnabledAttr = tmpState.ScheduleEnabled ? 'checked' : '';
		tmpState.ScheduleFieldsClass = tmpState.ScheduleEnabled ? '' : 'is-hidden';
		tmpState.ScheduleModeIntervalChecked = (tmpState.ScheduleMode === 'interval') ? 'checked' : '';
		tmpState.ScheduleModeCronChecked = (tmpState.ScheduleMode === 'cron') ? 'checked' : '';
		tmpState.ScheduleIntervalClass = (tmpState.ScheduleMode === 'interval') ? '' : 'is-hidden';
		tmpState.ScheduleCronClass = (tmpState.ScheduleMode === 'cron') ? '' : 'is-hidden';
	}

	// --- Step 1: Source ---

	setEntity(pEntity)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.Entity = pEntity || '';
		const tmpDef = libSourceEntities.DATALAKE_SOURCE_ENTITIES.find((pItem) => pItem.Entity === pEntity);
		tmpState.EntityLabel = tmpDef ? tmpDef.Label : pEntity;
		tmpState.IsFormDataEntity = !!(tmpDef && tmpDef.FormData);
		tmpState.DocumentType = '';
		tmpState.FormDataFields = [];
		tmpState.SourceEntityOptions = tmpState.SourceEntityOptions.map((pOption) => Object.assign({}, pOption, { SelectedAttr: (pOption.Entity === pEntity) ? 'selected' : '' }));
		tmpState.TestResultSlot = [];
		this.render();
	}

	/** Switch the Step-1 source between the Headlight model and the data lake; lazy-load lake sources. */
	setSourceType(pType)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.SourceType = (pType === 'lake') ? 'lake' : 'entity';
		// Switching source kinds invalidates the downstream column choice.
		tmpState.Fields = [];
		tmpState.GUIDTemplate = '';
		tmpState.TestResultSlot = [];
		if (tmpState.SourceType === 'lake' && !tmpState.LakeSourcesLoaded)
		{
			this._loadLakeSourcesAsync();
		}
		this.render();
	}

	/** Resolve a "<kind>::<physical>" option value (from the lake <select>) to a lake source. */
	onLakeSelect(pValue)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (!pValue)
		{
			this.setLakeSource('', '', '');
			return;
		}
		const tmpParts = String(pValue).split('::');
		const tmpKind = tmpParts[0];
		const tmpPhysical = tmpParts.slice(1).join('::');
		let tmpLabel = tmpPhysical;
		(tmpState.LakeSourceGroups || []).forEach((pGroup) => pGroup.Items.forEach((pItem) =>
		{
			if (pItem.Physical === tmpPhysical) { tmpLabel = pItem.Label; }
		}));
		this.setLakeSource(tmpPhysical, tmpKind, tmpLabel);
	}

	/** Pick a data-lake source (an existing projection or imported clone) as the extraction source. */
	setLakeSource(pPhysical, pKind, pLabel)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.LakeSource = pPhysical ? `lake/${pPhysical}` : '';
		tmpState.LakeSourceTable = pPhysical || '';
		tmpState.LakeKind = pKind || '';
		tmpState.LakeSourceLabel = pLabel || pPhysical || '';
		tmpState.LakeSourceValue = pPhysical ? `${pKind || ''}::${pPhysical}` : '';   // picker binding
		tmpState.Fields = [];        // new source → reload its schema in Step 2
		tmpState.GUIDTemplate = '';
		this.render();
	}

	/**
	 * (Re)mount the searchable lake-source picker into #DPE-LakeSourcePicker (replaces the unsearchable grouped
	 * <select>). The lake inventory is already loaded — MaterializedProjections is customer-scoped and DataCatalog is
	 * a single un-paginatable blob — so the DataProvider filters that in-memory merged list and returns GROUPED
	 * results (Computed projections / Imported clones). Called from the view's onAfterRender.
	 */
	mountLakeSourcePicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#DPE-LakeSourcePicker').length === 0) { return; }
		const tmpView = tmpPicker.createPicker('DPE-LakeSourcePicker',
			{
				DestinationAddress: '#DPE-LakeSourcePicker',
				ValueAddress: 'AppData.DatalakeProjectionEditor.LakeSourceValue',
				Searchable: true, AllowClear: true, ClearLabel: '— pick a projection or imported clone —',
				Placeholder: 'Search a projection or imported clone…',
				DataProvider: (pTerm) =>
				{
					const tmpTerm = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
					const tmpResults = [];
					(this.pict.AppData.DatalakeProjectionEditor.LakeSourceGroups || []).forEach((pGroup) =>
					{
						(pGroup.Items || []).forEach((pItem) =>
						{
							if (tmpTerm && (String(pItem.Label || '').toLowerCase().indexOf(tmpTerm) < 0) && (String(pItem.Physical || '').toLowerCase().indexOf(tmpTerm) < 0)) { return; }
							tmpResults.push({ Value: `${pItem.Kind}::${pItem.Physical}`, Text: pItem.Label, Group: pGroup.GroupLabel });
						});
					});
					return Promise.resolve({ results: tmpResults, hasMore: false });
				},
				ResolveValue: (pValue) =>
				{
					const tmpValue = String(pValue || '');
					if (!tmpValue) { return Promise.resolve(null); }
					const tmpPhysical = tmpValue.split('::').slice(1).join('::');
					let tmpLabel = tmpPhysical;
					(this.pict.AppData.DatalakeProjectionEditor.LakeSourceGroups || []).forEach((pGroup) => (pGroup.Items || []).forEach((pItem) => { if (pItem.Physical === tmpPhysical) { tmpLabel = pItem.Label; } }));
					return Promise.resolve({ Value: tmpValue, Text: tmpLabel });
				},
				OnChange: (pValue) => { this.onLakeSelect(pValue || ''); },
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	/** Enumerate the lake's existing computed projections + imported clones as selectable sources. */
	_loadLakeSourcesAsync()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		const tmpCustomerID = parseInt(tmpState.IDCustomer, 10) || 0;
		tmpState.LakeSourcesLoaded = true;
		tmpState.LakeSourcesLoadingSlot = [ {} ];
		this.render();
		const tmpComputed = [];
		const tmpImported = [];
		const tmpMPPhysical = {};

		const fFinish = () =>
		{
			tmpState.LakeSourcesLoadingSlot = [];
			const tmpGroups = [];
			if (tmpComputed.length) { tmpGroups.push({ GroupLabel: 'Computed projections', Items: tmpComputed }); }
			if (tmpImported.length) { tmpGroups.push({ GroupLabel: 'Imported clones', Items: tmpImported }); }
			tmpState.LakeSourceGroups = tmpGroups;
			this.render();
		};

		// 1) Computed projections — the MaterializedProjection registry (customer-scoped).
		const tmpMPURL = 'MaterializedProjections/FilteredTo/FBV~Deleted~EQ~0' + (tmpCustomerID > 0 ? `~FBV~IDCustomer~EQ~${tmpCustomerID}` : '');
		this.restClient.getJSON(tmpMPURL, (pError, pRows) =>
		{
			(Array.isArray(pRows) ? pRows : []).forEach((pRow) =>
			{
				tmpMPPhysical[pRow.PhysicalTableName] = true;
				if (libCatalog.classifyKind(pRow) === 'computed')
				{
					tmpComputed.push({ Physical: pRow.PhysicalTableName, Label: pRow.ProjectionName || libCatalog.deriveLogicalReadName(pRow.PhysicalTableName), Kind: 'computed' });
				}
			});
			// 2) Imported clones — the DataCatalog lake inventory minus the registered (MP) physical names.
			this.restClient.getJSON('DataCatalog', (pCatErr, pCatalog) =>
			{
				const tmpLake = (pCatalog && pCatalog.Sources && pCatalog.Sources.lake) || {};
				const tmpDatasets = tmpLake.Datasets || tmpLake.datasets || [];
				const tmpPrefix = `C${tmpCustomerID}_`;
				(Array.isArray(tmpDatasets) ? tmpDatasets : Object.keys(tmpDatasets))
					.map((pDataset) => (typeof pDataset === 'string') ? pDataset : (pDataset.Name || pDataset.Address || ''))
					.map((pString) => String(pString).replace(/^lake\//, ''))
					.filter((pName) => pName.startsWith(tmpPrefix) && !tmpMPPhysical[pName])
					.forEach((pName) => { tmpImported.push({ Physical: pName, Label: libCatalog.deriveLogicalReadName(pName), Kind: 'imported' }); });
				fFinish();
			});
		});
	}

	/** Tier 2: pick a DocumentType — auto-fills the filter to scope Documents to that type. */
	setDocumentType(pValue)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.DocumentType = pValue || '';
		tmpState.Filter = tmpState.DocumentType
			? `FBV~DocumentType~EQ~${tmpState.DocumentType}~FBV~Deleted~EQ~0`
			: '';
		this.render();
	}

	/** Tier 2: add an empty FormData.<key> column for the user to fill in. */
	addFormDataField()
	{
		this.pict.AppData.DatalakeProjectionEditor.FormDataFields.push({ Key: '', OutCol: '' });
		this.render();
	}

	setFormDataKey(pIndex, pValue)
	{
		const tmpField = this.pict.AppData.DatalakeProjectionEditor.FormDataFields[pIndex];
		if (tmpField) { tmpField.Key = pValue || ''; }
	}

	setFormDataOutCol(pIndex, pValue)
	{
		const tmpField = this.pict.AppData.DatalakeProjectionEditor.FormDataFields[pIndex];
		if (tmpField) { tmpField.OutCol = pValue || ''; }
	}

	removeFormDataField(pIndex)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.FormDataFields.splice(pIndex, 1);
		this.render();
	}

	setFilter(pValue)
	{
		this.pict.AppData.DatalakeProjectionEditor.Filter = pValue || '';
	}

	/** Count the source rows for the current entity + filter, so a zero-row source is caught up front. */
	testSource()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (!tmpState.Entity || tmpState.TestBusy)
		{
			return;
		}
		tmpState.TestBusy = true;
		tmpState.TestResultSlot = [ { Class: 'is-info', Message: 'Counting source rows…' } ];
		this.render();
		const tmpFilter = (tmpState.Filter || '').trim();
		const tmpURL = tmpFilter ? `${tmpState.Entity}s/Count/FilteredTo/${tmpFilter}` : `${tmpState.Entity}s/Count`;
		this.restClient.getJSON(tmpURL, (pError, pBody) =>
		{
			tmpState.TestBusy = false;
			if (pError)
			{
				tmpState.TestResultSlot = [ { Class: 'is-danger', Message: `Could not count the source: ${pError.message || pError}` } ];
			}
			else
			{
				const tmpCount = (pBody && (typeof(pBody.Count) === 'number')) ? pBody.Count : (parseInt(pBody && pBody.Count, 10) || 0);
				tmpState.TestResultSlot = (tmpCount > 0)
					? [ { Class: 'is-success', Message: `${tmpCount.toLocaleString('en-US')} source row(s) match.` } ]
					: [ { Class: 'is-warning', Message: 'No source rows match — the projection would be empty. Check the entity / filter.' } ];
			}
			this.render();
		});
	}

	/** Validate the source choice, load the source schema, advance to Step 2. */
	continueFromSource()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (tmpState.SourceType === 'lake')
		{
			if (!tmpState.LakeSource)
			{
				tmpState.TestResultSlot = [ { Class: 'is-danger', Message: 'Pick a data-lake source to continue.' } ];
				this.render();
				return;
			}
			this._loadLakeSchema(tmpState.LakeSourceTable, tmpState.LakeKind);
			return;
		}
		if (!tmpState.Entity)
		{
			tmpState.TestResultSlot = [ { Class: 'is-danger', Message: 'Pick a source entity to continue.' } ];
			this.render();
			return;
		}
		this._loadEntitySchema(tmpState.Entity);
	}

	_loadEntitySchema(pEntity)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.SchemaErrorSlot = [];
		tmpState.SchemaLoadingSlot = [ {} ];
		this._completeStep(1); // advance now; the field list fills in when the schema resolves

		const fApply = (pProperties) =>
		{
			const tmpDef = libSourceEntities.DATALAKE_SOURCE_ENTITIES.find((pItem) => pItem.Entity === pEntity);
			const tmpIDField = (tmpDef && tmpDef.DefaultIdentifier) || `ID${pEntity}`;
			this._applySchema(pProperties, `${pEntity}_{~D:Record.${tmpIDField}~}`, false);
		};

		if (this._schemaCache[pEntity])
		{
			fApply(this._schemaCache[pEntity]);
			return;
		}
		this.restClient.getJSON(`${pEntity}/Schema`, (pError, pBody) =>
		{
			if (pError || !pBody || !pBody.properties)
			{
				tmpState.SchemaLoadingSlot = [];
				tmpState.SchemaErrorSlot = [ { Message: `Could not load the ${pEntity} schema: ${pError ? (pError.message || pError) : 'no schema returned'}.` } ];
				this.render();
				return;
			}
			this._schemaCache[pEntity] = pBody.properties;
			fApply(pBody.properties);
		});
	}

	/**
	 * Build the Step-2 field model from a { properties: { col: { type, size } } } schema (entity or lake
	 * source). For lake sources only the standard audit columns are pre-excluded (no entity-named GUID).
	 * @param {object} pProperties
	 * @param {string} pGuidDefault
	 * @param {boolean} pIsLake
	 */
	_applySchema(pProperties, pGuidDefault, pIsLake)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.SchemaLoadingSlot = [];
		tmpState.Fields = Object.keys(pProperties).map((pKey) =>
		{
			const tmpAudit = pIsLake ? !!AUDIT_FIELDS[pKey] : isAuditField(pKey, tmpState.Entity);
			return {
				SourceField: pKey,
				OutCol: pKey,
				JsonType: (pProperties[pKey] && pProperties[pKey].type) || 'string',
				Size: (pProperties[pKey] && pProperties[pKey].size) || '',
				IsAudit: tmpAudit,
				Include: !tmpAudit,
			};
		});
		if (!tmpState.GUIDTemplate) { tmpState.GUIDTemplate = pGuidDefault; }
		this.render();
	}

	/**
	 * Load a lake source's columns + advance to Step 2: a computed projection via PrivateDataLake/Schema
	 * (REST-readable, works today), an imported clone via /mapper/introspect (deploy-gated — graceful
	 * message until the mapper service is live). Both flow through _applySchema like an entity source.
	 * @param {string} pPhysical the C<id>_<name> physical table
	 * @param {string} pKind 'computed' | 'imported'
	 */
	_loadLakeSchema(pPhysical, pKind)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.SchemaErrorSlot = [];
		tmpState.SchemaLoadingSlot = [ {} ];
		this._completeStep(1);
		const tmpLogical = String(pPhysical).replace(/^C\d+_/, '');
		const fGuidDefault = (pCols) => (pCols.indexOf('GUID') >= 0)
			? '{~D:Record.GUID~}'
			: `${tmpLogical}_{~D:Record.${pCols.find((pCol) => /^ID/i.test(pCol)) || pCols[0] || 'GUID'}~}`;

		if (pKind === 'imported')
		{
			// Raw clone columns are hidden from the meadow API — introspect via the mapper service.
			this.restClient.getJSON(`mapper/introspect?address=lake/${pPhysical}`, (pError, pBody) =>
			{
				if (pError || !pBody || !Array.isArray(pBody.Columns))
				{
					tmpState.SchemaLoadingSlot = [];
					tmpState.SchemaErrorSlot = [ { Message: 'Imported-clone schemas are read through the data-mapper service, which isn’t available here yet. Once it’s deployed the columns will load automatically — computed projections work today.' } ];
					this.render();
					return;
				}
				const tmpProps = {};
				pBody.Columns.forEach((pColumn) =>
				{
					const tmpName = pColumn.Name || pColumn.Column;
					if (tmpName) { tmpProps[tmpName] = { type: libBuilder.dbTypeToJsonType(pColumn.Type), size: pColumn.Size || '' }; }
				});
				this._applySchema(tmpProps, fGuidDefault(Object.keys(tmpProps)), true);
			});
			return;
		}
		// Computed projection — REST-readable JSON-Schema, same shape as an entity schema.
		this.restClient.getJSON(`PrivateDataLake/${tmpLogical}/Schema`, (pError, pBody) =>
		{
			if (pError || !pBody || !pBody.properties)
			{
				tmpState.SchemaLoadingSlot = [];
				tmpState.SchemaErrorSlot = [ { Message: `Could not load the source projection schema: ${pError ? (pError.message || pError) : 'no schema returned'}.` } ];
				this.render();
				return;
			}
			this._applySchema(pBody.properties, fGuidDefault(Object.keys(pBody.properties)), true);
		});
	}

	// --- Step 2: Columns + GUID ---

	toggleField(pSourceField)
	{
		const tmpField = this.pict.AppData.DatalakeProjectionEditor.Fields.find((pItem) => pItem.SourceField === pSourceField);
		if (tmpField) { tmpField.Include = !tmpField.Include; }
		this.render();
	}

	setOutCol(pSourceField, pValue)
	{
		const tmpField = this.pict.AppData.DatalakeProjectionEditor.Fields.find((pItem) => pItem.SourceField === pSourceField);
		if (tmpField) { tmpField.OutCol = (pValue || '').trim() || pSourceField; }
		// no render — avoid resetting the text cursor
	}

	toggleShowAll()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		tmpState.ShowAll = !tmpState.ShowAll;
		this.render();
	}

	setGUIDTemplate(pValue)
	{
		this.pict.AppData.DatalakeProjectionEditor.GUIDTemplate = pValue || '';
	}

	continueFromColumns()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		const tmpIncluded = this._buildState().fields.filter((pField) => pField.Include !== false);
		if (tmpIncluded.length < 1)
		{
			tmpState.SchemaErrorSlot = [ { Message: 'Select at least one column to project (or add a form field).' } ];
			this.render();
			return;
		}
		if (!tmpState.GUIDTemplate || tmpState.GUIDTemplate.indexOf('{~D:Record.') < 0)
		{
			tmpState.SchemaErrorSlot = [ { Message: 'The GUID template must reference a record field, e.g. {~D:Record.IDProject~}.' } ];
			this.render();
			return;
		}
		tmpState.SchemaErrorSlot = [];
		this._completeStep(2);
	}

	// --- Step 3: Name / Target / Schedule ---

	setName(pValue)
	{
		this.pict.AppData.DatalakeProjectionEditor.Name = (pValue || '').trim();
		this.deriveNameState();
		// Re-render to update the Target preview + name error (the name input keeps focus via onchange).
		this.render();
	}

	setDescription(pValue)
	{
		this.pict.AppData.DatalakeProjectionEditor.Description = pValue || '';
	}

	setCustomer(pValue)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (!this.isSuperUser) { return; }
		tmpState.IDCustomer = parseInt(pValue, 10) || 0;
		this.render();
	}

	setScheduleEnabled(pChecked)
	{
		this.pict.AppData.DatalakeProjectionEditor.ScheduleEnabled = !!pChecked;
		this.deriveScheduleAttrs();
		this.render();
	}

	setScheduleMode(pMode)
	{
		this.pict.AppData.DatalakeProjectionEditor.ScheduleMode = (pMode === 'cron') ? 'cron' : 'interval';
		this.deriveScheduleAttrs();
		this.render();
	}

	setScheduleField(pField, pValue)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (pField === 'cron') { tmpState.Cron = pValue || ''; }
		else if (pField === 'interval') { tmpState.IntervalMinutes = parseInt(pValue, 10) || 0; }
		else if (pField === 'group') { tmpState.Group = pValue || ''; }
	}

	continueFromName()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		const tmpBuildState = this._buildState();
		const tmpValidation = (tmpState.Mode === 'clone')
			? libBuilder.validateCloneState(tmpBuildState)
			: libBuilder.validateExtractionState(tmpBuildState);
		if (!tmpValidation.Valid)
		{
			tmpState.NameErrorSlot = [ { Message: tmpValidation.Errors[0] } ];
			this.render();
			return;
		}
		// Build the review body and advance.
		tmpState.ReviewJSON = JSON.stringify(
			(tmpState.Mode === 'clone') ? libBuilder.buildPassthroughCloneBody(tmpBuildState) : libBuilder.buildExtractionBody(tmpBuildState),
			null, 2);
		this._completeStep(3);
	}

	// --- Step 4: Review ---

	backToStep(pStep)
	{
		this.goToStep(pStep);
	}

	confirmReview()
	{
		this._completeStep(4);
	}

	// --- Step 5: Submit ---

	_buildState()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		// Tier 2: merge the manually-added FormData.<key> columns (all Text) into the field set.
		const tmpFormDataFields = (tmpState.FormDataFields || [])
			.filter((pField) => pField.Key && String(pField.Key).trim())
			.map((pField) =>
			{
				const tmpKey = String(pField.Key).trim();
				return {
					SourceField: `FormData.${tmpKey}`,
					OutCol: (pField.OutCol && pField.OutCol.trim()) || tmpKey.replace(/[^A-Za-z0-9_]/g, '_'),
					JsonType: 'string',
					Size: 'Default',
					Include: true,
				};
			});
		return {
			IDCustomer: tmpState.IDCustomer,
			Name: tmpState.Name,
			SourceType: tmpState.SourceType,
			Entity: tmpState.Entity,
			SourceConnectionPrefix: tmpState.SourceConnectionPrefix,
			Filter: tmpState.Filter,
			GUIDTemplate: tmpState.GUIDTemplate,
			Description: tmpState.Description,
			fields: tmpState.Fields.concat(tmpFormDataFields),
			Mode: tmpState.Mode,
			LakeSource: tmpState.LakeSource,
		};
	}

	submit()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (tmpState.Submitting)
		{
			return;
		}
		const tmpBuildState = this._buildState();
		const tmpValidation = (tmpState.Mode === 'clone')
			? libBuilder.validateCloneState(tmpBuildState)
			: libBuilder.validateExtractionState(tmpBuildState);
		if (!tmpValidation.Valid)
		{
			tmpState.ResultSlot = [ { Class: 'is-danger', Icon: 'fa-triangle-exclamation', Title: 'Cannot submit', Detail: tmpValidation.Errors.join(' ') } ];
			this.render();
			return;
		}
		const tmpBody = (tmpState.Mode === 'clone')
			? libBuilder.buildPassthroughCloneBody(tmpBuildState)
			: libBuilder.buildExtractionBody(tmpBuildState);
		tmpState.Submitting = true;
		tmpState.SubmitBusySlot = [ {} ];
		tmpState.ResultSlot = [ { Class: 'is-info', Icon: 'fa-rotate', Title: 'Creating projection…', Detail: 'Running the extraction — this can take a while for large sources.' } ];
		this.render();

		this.restClient.postJSON('Projection', tmpBody, (pError, pResponse) =>
		{
			tmpState.Submitting = false;
			tmpState.SubmitBusySlot = [];
			if (pError)
			{
				tmpState.ResultSlot = [ { Class: 'is-warning', Icon: 'fa-clock', Title: 'Submitted, not confirmed', Detail: `The projection was submitted but didn't confirm in time — it may still be running. Check the catalog shortly. (${pError.message || pError})` } ];
				this.render();
				return;
			}
			this._handleRunResult(pResponse);
		});
	}

	_handleRunResult(pResponse)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		const tmpOK = pResponse && (pResponse.Success === true || /complete/i.test(String(pResponse.Status || '')));
		const tmpRead = (pResponse && pResponse.RowsRead != null) ? pResponse.RowsRead : '?';
		const tmpWritten = (pResponse && pResponse.RowsWritten != null) ? pResponse.RowsWritten : '?';
		if (!tmpOK)
		{
			const tmpFailure = pResponse && pResponse.Failure;
			tmpState.ResultSlot = [ { Class: 'is-danger', Icon: 'fa-triangle-exclamation', Title: 'Projection failed', Detail: (tmpFailure && tmpFailure.Reason) ? tmpFailure.Reason : 'The extraction did not complete successfully.' } ];
			this.render();
			return;
		}
		const tmpDetail = (tmpWritten === 0)
			? `Completed, but wrote 0 rows — check the source filter. (${tmpRead} read)`
			: `${tmpRead} read · ${tmpWritten} written.`;
		tmpState.ResultSlot = [ { Class: (tmpWritten === 0) ? 'is-warning' : 'is-success', Icon: (tmpWritten === 0) ? 'fa-circle-exclamation' : 'fa-circle-check', Title: 'Projection created', Detail: tmpDetail } ];
		this._completeStep(5);
		this.render();
		// Apply the schedule via a follow-up PUT (POST /1.0/Projection takes no schedule fields).
		if (tmpState.ScheduleEnabled)
		{
			this._applySchedule();
		}
	}

	/** Resolve the new registry row by (IDCustomer, ProjectionName) and PUT the schedule triplet. */
	_applySchedule()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		this.restClient.getJSON(`MaterializedProjections/FilteredTo/FBV~IDCustomer~EQ~${tmpState.IDCustomer}~FBV~ProjectionName~EQ~${encodeURIComponent(tmpState.Name)}/0/1`, (pError, pBody) =>
		{
			if (pError || !Array.isArray(pBody) || pBody.length < 1)
			{
				return;
			}
			tmpState.NewDatasetGUID = pBody[0].GUIDMaterializedProjection;
			const tmpRecord =
			{
				IDMaterializedProjection: pBody[0].IDMaterializedProjection,
				RefreshEnabled: 1,
				RefreshCron: (tmpState.ScheduleMode === 'cron') ? String(tmpState.Cron || '') : '',
				RefreshIntervalMinutes: (tmpState.ScheduleMode === 'interval') ? (parseInt(tmpState.IntervalMinutes, 10) || 0) : 0,
				RefreshGroup: String(tmpState.Group || ''),
			};
			this.restClient.updateEntity('MaterializedProjection', tmpRecord, () => { /* best-effort; the result banner already shows success */ });
		});
	}

	viewInCatalog()
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (tmpState.NewDatasetGUID)
		{
			window.location.hash = `#/Datalake/Dataset/${tmpState.NewDatasetGUID}`;
		}
		else
		{
			window.location.hash = '#/Datalake';
		}
	}

	// --- step navigation ---

	goToStep(pStep)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (pStep !== tmpState.ActiveStep && !tmpState.CompletedSteps.includes(pStep) && pStep > tmpState.ActiveStep)
		{
			return;
		}
		tmpState.ActiveStep = pStep;
		this.render();
	}

	_completeStep(pStep)
	{
		const tmpState = this.pict.AppData.DatalakeProjectionEditor;
		if (!tmpState.CompletedSteps.includes(pStep))
		{
			tmpState.CompletedSteps.push(pStep);
		}
		tmpState.ActiveStep = Math.min(pStep + 1, STEP_COUNT);
		this.render();
	}
}

module.exports = DatalakeProjectionEditorProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'DatalakeProjectionEditorProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

module.exports.isAuditField = isAuditField;

},{"../datalake/Datalake-Projection-Builder.js":1096,"../datalake/Datalake-Source-Entities.js":1097,"./DatalakeCatalog-Provider.js":1332,"pict-provider":845}],1335:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libPlatformDocs = require('../help/PlatformDocs.js');
const libMarkdownEditor = require('pict-section-markdowneditor');

const RAIL_MOUNT = '#Doc-Rail';
const DETAIL_MOUNT = '#Doc-Detail';
const EDITOR_HOST_ID = 'Doc-Editor-Host';

/**
 * Documentation manager — the #/Documentation screen. Browses every platform help topic (the static registry
 * merged with topics discovered from PlatformDocumentIndex), shows each topic's status (platform default vs. this
 * customer's own copy vs. a customer-authored topic), and edits / creates / reverts them through the SAME
 * AcademyContent write path the F1 panel editor uses. Two modes, by session (reusing the app's gate): a customer-1
 * admin manages the canonical docs; a customer admin manages their own overrides + topics; everyone else reads.
 *
 * State lives in AppData.Documentation; the view renders a shell with #Doc-Rail + #Doc-Detail mounts and this
 * provider assigns hand-built HTML into them (SamplePlan pattern), mounting the markdown editor into the detail.
 */
class DocumentationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	get app() { return this.pict.PictApplication; }
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get state()
	{
		if (!this.pict.AppData.Documentation)
		{
			this.pict.AppData.Documentation =
			{
				Loaded: false, Loading: false, Areas: [],
				SelectedHash: '', SelectedTitle: '', SelectedStatus: '', SelectedIsRegistry: false,
				OwnRowID: 0, Markdown: '', Editing: false, Adding: '', ConfirmDelete: false, Error: '',
			};
		}
		return this.pict.AppData.Documentation;
	}

	/** The edit mode from the app's shared gate: 'canonical' | 'override' | null (read-only). */
	editMode() { return (this.app && (typeof this.app._platformDocsEditMode === 'function')) ? this.app._platformDocsEditMode() : null; }

	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID) : 0; }

	// ── Data ──────────────────────────────────────────────────────────────────

	/** Load every area's topic list (registry ∪ discovered) with per-topic status, then render. */
	loadAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return; }
		tmpState.Loading = true;
		this.render();
		const tmpAreaNames = libPlatformDocs.AREAS.map((pArea) => pArea.Area);
		const tmpCaller = this.callerCustomer();
		Promise.all(tmpAreaNames.map((pArea) => this._fetchIndex(pArea))).then((pResults) =>
		{
			tmpState.Areas = tmpAreaNames.map((pArea, pIndex) =>
			{
				const tmpDiscovered = pResults[pIndex] || [];
				const tmpByHash = {};
				tmpDiscovered.forEach((pDoc) => { if (pDoc && pDoc.Hash) { tmpByHash[pDoc.Hash] = pDoc; } });
				const tmpKnown = {};
				const tmpTopics = libPlatformDocs.docsInArea(pArea).map((pDoc) =>
				{
					tmpKnown[pDoc.Hash] = true;
					const tmpDisc = tmpByHash[pDoc.Hash];
					return this._topicEntry(pDoc.Hash, pDoc.Nav, (tmpDisc ? tmpDisc.IDCustomer : 1), true, tmpCaller);
				});
				tmpDiscovered
					.filter((pDoc) => pDoc && pDoc.Hash && !tmpKnown[pDoc.Hash])
					.forEach((pDoc) => tmpTopics.push(this._topicEntry(pDoc.Hash, pDoc.Title || pDoc.Hash, pDoc.IDCustomer, false, tmpCaller)));
				return { Area: pArea, Title: this._areaTitle(pArea), Topics: tmpTopics };
			});
			tmpState.Loaded = true;
			tmpState.Loading = false;
			this.render();
		});
	}

	/** A rail topic entry with a computed status. */
	_topicEntry(pHash, pLabel, pIDCustomer, pIsRegistry, pCaller)
	{
		let tmpStatus = 'default';
		if (pCaller === 1) { tmpStatus = 'canonical'; }
		else if (Number(pIDCustomer) === pCaller) { tmpStatus = pIsRegistry ? 'customized' : 'own'; }
		return { Hash: pHash, Label: pLabel, IsRegistry: pIsRegistry, Status: tmpStatus };
	}

	_fetchIndex(pArea)
	{
		const tmpRestClient = this.restClient;
		if (!tmpRestClient || !pArea) { return Promise.resolve([]); }
		return new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`PlatformDocumentIndex/${encodeURIComponent(pArea)}`, (pError, pBody) => resolve((!pError && Array.isArray(pBody)) ? pBody : []));
		});
	}

	/**
	 * The caller's OWN AcademyContent row for a hash (id + title + content), or null when they have not
	 * authored an override.
	 *
	 * Resolved from PlatformDocument, which reports the IDCustomer and row id of whichever copy it served,
	 * rather than from a Meadow read by Hash. That read fetches the canonical customer-1 row the caller does
	 * not own, and MyCustomer — a post-fetch per-record assertion — then refuses the whole request, so it
	 * resolved null for every tenant looking at a topic that has a platform default. That reads as "no
	 * override" whether or not one exists, which is what saveAsync and the revert action key off: a tenant
	 * with an override would have POSTed a duplicate instead of updating it, and revert would have gone dark.
	 */
	_fetchOwnRow(pHash)
	{
		const tmpRestClient = this.restClient;
		if (!tmpRestClient) { return Promise.resolve(null); }
		const tmpCallerCustomer = this.callerCustomer();
		return new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`PlatformDocument/${encodeURIComponent(pHash)}`, (pError, pBody) =>
			{
				if (pError || !pBody || Array.isArray(pBody) || !pBody.Hash) { return resolve(null); }
				// Only the caller's own copy counts as an "own row" — the canonical one is not theirs to edit
				// in place. An API that does not report IDCustomer cannot be trusted either way, so treat it
				// as no override and let the caller author one.
				const tmpServedCustomer = Number(pBody.IDCustomer || 0);
				if (!tmpServedCustomer || !tmpCallerCustomer || (tmpServedCustomer !== tmpCallerCustomer)) { return resolve(null); }
				return resolve({ IDAcademyContent: pBody.IDAcademyContent, Title: pBody.Title, Content: pBody.Content });
			});
		});
	}

	/** The resolved doc (own-or-canonical) for a hash — used to seed a first customer override. */
	_fetchResolved(pHash)
	{
		const tmpRestClient = this.restClient;
		if (!tmpRestClient) { return Promise.resolve(null); }
		return new Promise((resolve) =>
		{
			tmpRestClient.getJSON(`PlatformDocument/${encodeURIComponent(pHash)}`, (pError, pBody) => resolve((!pError && pBody && pBody.Content) ? pBody : null));
		});
	}

	// ── Interactions (reached from onclick as _Pict.providers.Documentation.X) ──

	/** Select a topic → load its own-row (id + content) or the canonical content, show it (read mode). */
	selectTopic(pHash)
	{
		const tmpState = this.state;
		tmpState.SelectedHash = pHash;
		tmpState.Editing = false;
		tmpState.Adding = '';
		tmpState.ConfirmDelete = false;
		tmpState.Error = '';
		const tmpRegistryDoc = libPlatformDocs.docByHash(pHash);
		tmpState.SelectedTitle = (tmpRegistryDoc && tmpRegistryDoc.Title) || pHash;
		tmpState.SelectedIsRegistry = !!tmpRegistryDoc;
		this.render();
		this._fetchOwnRow(pHash).then((pOwnRow) =>
		{
			if (tmpState.SelectedHash !== pHash) { return; }
			tmpState.OwnRowID = (pOwnRow && pOwnRow.IDAcademyContent) || 0;
			if (pOwnRow && (pOwnRow.Title)) { tmpState.SelectedTitle = pOwnRow.Title; }
			if (pOwnRow && (pOwnRow.Content != null)) { tmpState.Markdown = pOwnRow.Content; this.render(); return; }
			// No own row (a customer viewing a not-yet-overridden canonical topic): seed from the resolved doc.
			this._fetchResolved(pHash).then((pResolved) =>
			{
				if (tmpState.SelectedHash !== pHash) { return; }
				tmpState.Markdown = (pResolved && pResolved.Content) || '';
				this.render();
			});
		});
	}

	/** Enter edit mode for the selected topic. */
	startEdit()
	{
		if (!this.editMode() || !this.state.SelectedHash) { return; }
		this.state.Editing = true;
		this.state.Error = '';
		this.render();
	}

	/** Leave edit mode without saving. */
	cancelEdit() { this.state.Editing = false; this.state.ConfirmDelete = false; this.render(); }

	/** Save the editor's markdown: PUT an existing row, or POST a new override (server stamps the customer). */
	saveAsync()
	{
		const tmpState = this.state;
		const tmpRestClient = this.restClient;
		if (!tmpState.SelectedHash || !tmpRestClient) { return; }
		const tmpMarkdown = this._captureEditor();
		const tmpRecord = { Hash: tmpState.SelectedHash, Title: tmpState.SelectedTitle, Content: tmpMarkdown };
		const fDone = (pError) =>
		{
			if (pError)
			{
				tmpState.Error = 'Could not save — the server rejected the write (you may not have permission at this scope).';
				this.render();
				return;
			}
			tmpState.Markdown = tmpMarkdown;
			tmpState.Editing = false;
			this._invalidateCache();
			// Reload the row (its id + status may have changed — a first customer save just created the row).
			this.selectTopic(tmpState.SelectedHash);
			this.loadAsync();
		};
		if (tmpState.OwnRowID) { tmpRestClient.putJSON('AcademyContent', Object.assign({ IDAcademyContent: tmpState.OwnRowID }, tmpRecord), fDone); }
		else { tmpRestClient.postJSON('AcademyContent', tmpRecord, fDone); }
	}

	/** Whether the selected topic exposes a delete/revert action for this session. */
	canDeleteSelected()
	{
		const tmpState = this.state;
		if (!tmpState.OwnRowID) { return false; }
		const tmpMode = this.editMode();
		// Customer: delete their own row (override or their topic). Headlight: only a NON-registry canonical topic
		// (deleting a registry topic would orphan its static route/nav — that stays a code change).
		if (tmpMode === 'override') { return true; }
		if (tmpMode === 'canonical') { return !tmpState.SelectedIsRegistry; }
		return false;
	}

	armDelete() { if (this.canDeleteSelected()) { this.state.ConfirmDelete = true; this.render(); } }
	cancelDelete() { this.state.ConfirmDelete = false; this.render(); }

	/** Delete the selected topic's own row (revert to default, or remove a customer/new topic). */
	confirmDeleteAsync()
	{
		const tmpState = this.state;
		const tmpRestClient = this.restClient;
		if (!tmpState.OwnRowID || !tmpRestClient || (typeof tmpRestClient.deleteEntity !== 'function')) { return; }
		tmpRestClient.deleteEntity('AcademyContent', tmpState.OwnRowID, (pError) =>
		{
			if (pError)
			{
				tmpState.ConfirmDelete = false;
				tmpState.Error = 'Could not delete — the server rejected the request.';
				this.render();
				return;
			}
			tmpState.ConfirmDelete = false;
			tmpState.Editing = false;
			this._invalidateCache();
			// If it was a registry topic, it reverts to canonical (still selectable); otherwise it's gone.
			if (tmpState.SelectedIsRegistry) { this.selectTopic(tmpState.SelectedHash); }
			else { tmpState.SelectedHash = ''; this.render(); }
			this.loadAsync();
		});
	}

	// ── New topic ───────────────────────────────────────────────────────────────

	addTopic(pArea) { if (this.editMode() && pArea) { this.state.Adding = pArea; this.state.Error = ''; this.render(); this._focusNewTitle(); } }
	cancelAdd() { this.state.Adding = ''; this.render(); }

	createTopicAsync()
	{
		const tmpState = this.state;
		const tmpRestClient = this.restClient;
		if (!tmpState.Adding || !tmpRestClient) { return; }
		let tmpTitle = '';
		try { const tmpInput = document.getElementById('Doc-NewTopic-Title'); tmpTitle = tmpInput ? String(tmpInput.value || '').trim() : ''; }
		catch (pError) { tmpTitle = ''; }
		const tmpSlug = tmpTitle.replace(/[^A-Za-z0-9]+/g, ' ').trim().split(/\s+/).filter((pWord) => pWord.length > 0)
			.map((pWord) => pWord.charAt(0).toUpperCase() + pWord.slice(1)).join('');
		if (!tmpTitle || !tmpSlug) { tmpState.Error = 'Give the topic a title with at least one letter or number.'; this.render(); return; }
		const tmpExisting = {};
		libPlatformDocs.docsInArea(tmpState.Adding).forEach((pDoc) => { tmpExisting[pDoc.Hash] = true; });
		const tmpAreaState = tmpState.Areas.find((pArea) => pArea.Area === tmpState.Adding);
		if (tmpAreaState) { tmpAreaState.Topics.forEach((pTopic) => { tmpExisting[pTopic.Hash] = true; }); }
		let tmpFinalSlug = tmpSlug;
		let tmpCounter = 2;
		while (tmpExisting[`Doc-${tmpState.Adding}-${tmpFinalSlug}`]) { tmpFinalSlug = tmpSlug + tmpCounter; tmpCounter++; }
		const tmpHash = `Doc-${tmpState.Adding}-${tmpFinalSlug}`;
		tmpRestClient.postJSON('AcademyContent', { Hash: tmpHash, Title: tmpTitle, Content: `# ${tmpTitle}\n\n` }, (pError) =>
		{
			if (pError) { tmpState.Error = 'Could not create the topic — the server rejected the write (you may not have permission).'; this.render(); return; }
			tmpState.Adding = '';
			this._invalidateCache();
			this.selectTopic(tmpHash);
			this.state.Editing = true;
			this.loadAsync();
		});
	}

	// ── Render ─────────────────────────────────────────────────────────────────

	/** Assign the rail + detail HTML into their mounts, and (re)mount the editor when editing. */
	render()
	{
		if (this.pict.ContentAssignment.getElement(RAIL_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(RAIL_MOUNT, this._railHTML());
		this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
		if (this.state.Editing) { this._mountEditor(); }
		if (this.state.Adding) { this._focusNewTitle(); }
	}

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	_areaTitle(pArea) { return String(pArea || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2'); }

	_statusChip(pStatus)
	{
		const tmpMap =
		{
			canonical: [ 'Platform', 'doc-chip-canonical' ],
			default: [ 'Platform default', 'doc-chip-default' ],
			customized: [ 'Customized', 'doc-chip-custom' ],
			own: [ 'Your topic', 'doc-chip-custom' ],
		};
		const tmpEntry = tmpMap[pStatus] || tmpMap.default;
		return `<span class="doc-chip ${tmpEntry[1]}">${this._esc(tmpEntry[0])}</span>`;
	}

	_railHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Loaded) { return '<div class="doc-rail-loading">Loading topics…</div>'; }
		const tmpEditable = !!this.editMode();
		return tmpState.Areas.map((pArea) =>
		{
			const tmpItems = pArea.Topics.map((pTopic) =>
			{
				const tmpActive = (pTopic.Hash === tmpState.SelectedHash) ? ' is-active' : '';
				return `<div class="doc-rail-item${tmpActive}" onclick="_Pict.providers.Documentation.selectTopic('${this._esc(pTopic.Hash)}')">`
					+ `<span class="doc-rail-item-label">${this._esc(pTopic.Label)}</span>${this._statusChip(pTopic.Status)}</div>`;
			}).join('');
			const tmpAdd = tmpEditable
				? `<div class="doc-rail-add" onclick="_Pict.providers.Documentation.addTopic('${this._esc(pArea.Area)}')"><i class="fas fa-plus"></i> Add topic</div>`
				: '';
			return `<div class="doc-rail-group"><div class="doc-rail-head">${this._esc(pArea.Title)}</div>${tmpItems}${tmpAdd}</div>`;
		}).join('');
	}

	/** Which routes surface a topic in F1 (for the "appears on" hint). */
	_routesForHash(pHash)
	{
		return libPlatformDocs.ROUTE_DOC.filter((pEntry) => pEntry.Hash === pHash).map((pEntry) => pEntry.Route);
	}

	_detailHTML()
	{
		const tmpState = this.state;
		if (tmpState.Adding) { return this._newTopicHTML(); }
		if (!tmpState.SelectedHash) { return '<div class="doc-empty">Pick a topic on the left to view or edit it.</div>'; }
		const tmpError = tmpState.Error ? `<p class="doc-error">${this._esc(tmpState.Error)}</p>` : '';
		const tmpRoutes = this._routesForHash(tmpState.SelectedHash);
		const tmpWhere = tmpRoutes.length
			? `Opens with F1 on ${tmpRoutes.map((pRoute) => `<code>#${this._esc(pRoute)}</code>`).join(', ')}`
			: `A sibling topic in the ${this._esc(this._areaTitle(libPlatformDocs.areaFromHash(tmpState.SelectedHash)))} help`;
		const tmpHead = `<div class="doc-detail-head"><div><div class="doc-detail-title">${this._esc(tmpState.SelectedTitle)}</div>`
			+ `<div class="doc-detail-sub">${this._statusChip(this._selectedStatus())}<span class="doc-detail-where">${tmpWhere}</span></div></div>`
			+ this._detailActionsHTML() + '</div>';
		if (tmpState.Editing)
		{
			return tmpHead + tmpError + `<div id="${EDITOR_HOST_ID}" class="doc-editor-host"></div>` + this._deleteAreaHTML();
		}
		const tmpBody = this._parseMarkdown(tmpState.Markdown || '_Empty topic._');
		return tmpHead + tmpError + `<div class="doc-detail-body">${tmpBody}</div>`;
	}

	/** The read/edit action buttons in the detail header. */
	_detailActionsHTML()
	{
		const tmpState = this.state;
		const tmpMode = this.editMode();
		if (!tmpMode) { return ''; }
		if (tmpState.Editing)
		{
			return '<div class="doc-detail-actions">'
				+ '<button class="doc-btn doc-btn-primary" onclick="_Pict.providers.Documentation.saveAsync()">Save</button>'
				+ '<button class="doc-btn doc-btn-ghost" onclick="_Pict.providers.Documentation.cancelEdit()">Cancel</button></div>';
		}
		return `<div class="doc-detail-actions"><button class="doc-btn doc-btn-ghost" onclick="_Pict.providers.Documentation.startEdit()"><i class="fas fa-pen"></i> Edit</button></div>`;
	}

	/** The revert/delete row shown under the editor (customer overrides + non-registry topics). */
	_deleteAreaHTML()
	{
		const tmpState = this.state;
		if (!this.canDeleteSelected()) { return ''; }
		const tmpKnown = tmpState.SelectedIsRegistry;
		if (tmpState.ConfirmDelete)
		{
			const tmpQ = tmpKnown ? 'Delete this customer’s copy and revert to the platform default?' : 'Delete this topic?';
			return `<div class="doc-detail-actions doc-delrow"><span>${this._esc(tmpQ)}</span>`
				+ `<button class="doc-btn doc-btn-danger" onclick="_Pict.providers.Documentation.confirmDeleteAsync()">${tmpKnown ? 'Revert' : 'Delete'}</button>`
				+ '<button class="doc-btn doc-btn-ghost" onclick="_Pict.providers.Documentation.cancelDelete()">Keep it</button></div>';
		}
		return `<div class="doc-detail-actions doc-delrow"><button class="doc-btn doc-btn-danger" onclick="_Pict.providers.Documentation.armDelete()">${tmpKnown ? 'Revert to platform default' : 'Delete this topic'}</button></div>`;
	}

	_newTopicHTML()
	{
		const tmpState = this.state;
		const tmpNote = (this.editMode() === 'canonical')
			? 'New platform-default topic — visible to every customer once you save it.'
			: 'New topic for your customer only.';
		const tmpError = tmpState.Error ? `<p class="doc-error">${this._esc(tmpState.Error)}</p>` : '';
		return `<div class="doc-detail-head"><div class="doc-detail-title">Add a topic to ${this._esc(this._areaTitle(tmpState.Adding))}</div></div>`
			+ `<p class="doc-detail-note">${this._esc(tmpNote)}</p>${tmpError}`
			+ '<div class="doc-detail-actions"><input id="Doc-NewTopic-Title" type="text" class="doc-input" placeholder="Topic title" />'
			+ '<button class="doc-btn doc-btn-primary" onclick="_Pict.providers.Documentation.createTopicAsync()">Create</button>'
			+ '<button class="doc-btn doc-btn-ghost" onclick="_Pict.providers.Documentation.cancelAdd()">Cancel</button></div>';
	}

	_parseMarkdown(pMarkdown)
	{
		return (this.app && (typeof this.app._parseHelpMarkdown === 'function')) ? this.app._parseHelpMarkdown(pMarkdown) : this._esc(pMarkdown);
	}

	// ── Editor mount ─────────────────────────────────────────────────────────

	_mountEditor()
	{
		if (this.pict.ContentAssignment.getElement(`#${EDITOR_HOST_ID}`).length === 0) { return; }
		if (!this.pict.AppData.DocumentationEditor) { this.pict.AppData.DocumentationEditor = {}; }
		this.pict.AppData.DocumentationEditor.Segments = [ { Content: this.state.Markdown || '' } ];
		if (!this.pict.views['Documentation-Editor'])
		{
			this.pict.addView('Documentation-Editor',
				{
					ViewIdentifier: 'Documentation-Editor',
					TargetElementAddress: `#${EDITOR_HOST_ID}`,
					ContentDataAddress: 'AppData.DocumentationEditor.Segments',
					AutoRender: false, EnableRichPreview: true, ReadOnly: false,
				}, libMarkdownEditor);
		}
		try { this.pict.views['Documentation-Editor'].render(); }
		catch (pError) { this.pict.log.warn('Documentation editor failed to render', { error: String(pError) }); }
	}

	_captureEditor()
	{
		const tmpView = this.pict.views['Documentation-Editor'];
		if (tmpView && (typeof tmpView.marshalFromView === 'function')) { try { tmpView.marshalFromView(); } catch (pError) { /* editor gone */ } }
		const tmpSegments = (this.pict.AppData.DocumentationEditor && this.pict.AppData.DocumentationEditor.Segments) || [];
		return tmpSegments.map((pSeg) => (pSeg && pSeg.Content) || '').join('\n\n');
	}

	_focusNewTitle() { try { const tmpInput = document.getElementById('Doc-NewTopic-Title'); if (tmpInput) { tmpInput.focus(); } } catch (pError) { /* no-op */ } }

	_invalidateCache()
	{
		// Keep the F1 panel in sync: drop its per-hash + per-area caches for the edited topic.
		if (this.app)
		{
			if (this.app._academyHelpCache && this.state.SelectedHash) { this.app._academyHelpCache[this.state.SelectedHash] = undefined; }
			if (this.app._platformAreaIndexCache) { this.app._platformAreaIndexCache = {}; }
		}
	}

	/** Status of the currently-selected topic, from the loaded rail entry. */
	_selectedStatus()
	{
		const tmpState = this.state;
		let tmpStatus = 'default';
		(tmpState.Areas || []).some((pArea) => pArea.Topics.some((pTopic) =>
		{
			if (pTopic.Hash === tmpState.SelectedHash) { tmpStatus = pTopic.Status; return true; }
			return false;
		}));
		return tmpStatus;
	}
}

module.exports = DocumentationProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'Documentation',
	AutoInitialize: true,
	AutoInitializeOrdinal: 40,
};

},{"../help/PlatformDocs.js":1282,"pict-provider":845,"pict-section-markdowneditor":955}],1336:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libConfigFieldSchema = require('../views/EmailNotifications-ConfigFieldSchema.js');

/**
 * EmailNotificationsProvider — the data layer behind the config-app Email Notifications (Email Rules) editor.
 *
 * Migrated from the Home Vue app (pages/EmailRules.vue + components/EditEmailRule.vue). An "Email Rule" is a
 * Meadow entity (EmailRule table) — NOT a Configuration blob — that ties a set of documents (Projects +
 * DocumentType + Status filters) to a server-defined notification Handler, optionally on a schedule. The
 * per-rule email content (subject/body/recipients) lives in the Configuration service under
 * 'EmailRule-<Handler>' and is edited via a dynamic form built from the handler's defaultConfiguration.
 *
 * Handlers are SERVER-DRIVEN (GET Email/Handlers) — never hardcoded. Save is a multi-call sequence
 * (EmailRule/Upsert + Configuration/Put + EmailRule/SetSchedule); see the editor-phase methods.
 *
 * State lives in pict.AppData.EmailNotifications; the views derive a clean render-state from it.
 */
class EmailNotificationsProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	// --- Session context + write-permission (mirrors the ApprovalWorkflow provider / Home's gate) ---

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	get hasCustomerAdmin()
	{
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin' || pRole.PermissionLevel === 'SuperAdminUser'));
	}

	/** Capability check via the effective-permissions service (super-user bypass, fail-open before load — UI only). */
	_can(pEntity, pAction)
	{
		const tmpService = this.pict.fable.EffectivePermissionsService;
		return !!(tmpService && (typeof tmpService.can === 'function') && tmpService.can(pEntity, pAction));
	}

	/**
	 * Can the current user create/edit/delete rules? Additive gate — the coarse CustomerAdmin tier OR the
	 * fine-grained `EmailRule-Update` capability (so the Entitlements "Manage email notifications" task works).
	 * UI gate only; the server is authoritative (EmailRule is writable at Director/Executive = MyCustomer).
	 */
	get canEdit()
	{
		return this.isSuperUser || this.hasCustomerAdmin || this._can('EmailRule', 'Update');
	}

	/** Only a customer admin may write the per-rule custom Configuration blob (a config blob, so it stays coarse). */
	get canEditConfig()
	{
		return this.isSuperUser || this.hasCustomerAdmin;
	}

	/** The shared state slice (lazily created). */
	get state()
	{
		if (!this.pict.AppData.EmailNotifications)
		{
			this.pict.AppData.EmailNotifications =
			{
				List: [], ListLoading: false, ListError: '',
				Handlers: null,               // { <handlerName>: { description, docs, defaultConfiguration, scheduled, ... } }
				Lookups: { DocTypeMap: {}, Projects: [], Statuses: [] },
				Editor: null,                 // populated in the editor phase
			};
		}
		return this.pict.AppData.EmailNotifications;
	}

	// --- REST helpers ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/** EmailRule.Projects / .Status are JSON-array columns typed as string; parse defensively to an array. */
	_parseArray(pValue)
	{
		if (Array.isArray(pValue)) { return pValue; }
		if (typeof pValue === 'string' && pValue.trim())
		{
			try { const tmpParsed = JSON.parse(pValue); return Array.isArray(tmpParsed) ? tmpParsed : []; }
			catch (pErr) { return []; }
		}
		return [];
	}

	// --- Handlers (server-driven registry) ---

	/** Load the handler registry once (GET Email/Handlers). Cached on state.Handlers. */
	async loadHandlersAsync()
	{
		if (this.state.Handlers) { return this.state.Handlers; }
		const tmpHandlers = await this._getJSON('Email/Handlers').catch(() => ({}));
		this.state.Handlers = tmpHandlers || {};
		return this.state.Handlers;
	}

	// --- List ---

	/**
	 * Load every EmailRule for the customer (+ the handler registry + a doc-type name map), as a list of
	 * display rows.
	 */
	async loadListAsync()
	{
		const tmpState = this.state;
		tmpState.ListLoading = true;
		tmpState.ListError = '';
		tmpState.List = [];
		this._repaintList();
		try
		{
			await this.loadHandlersAsync();
			// Doc-type hash → Name, so the list can show a readable Document Type.
			const tmpRNIs = await this._getJSON(`ReportNamedInstances/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}`).catch(() => []);
			const tmpDocMap = {};
			(Array.isArray(tmpRNIs) ? tmpRNIs : []).forEach((pRNI) => { if (pRNI && pRNI.Hash) { tmpDocMap[pRNI.Hash] = pRNI.Name || pRNI.Hash; } });
			tmpState.Lookups.DocTypeMap = tmpDocMap;

			const tmpRules = await this._getJSON(`EmailRules/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}/0/2000`).catch(() => []);
			tmpState.List = (Array.isArray(tmpRules) ? tmpRules : []).map((pRule) => this.describeRule(pRule));
			tmpState.List.sort((pA, pB) => String(pA.HandlerLabel).localeCompare(String(pB.HandlerLabel)) || (pA.IDEmailRule - pB.IDEmailRule));
		}
		catch (pError)
		{
			tmpState.ListError = `Could not load email rules: ${pError && pError.message ? pError.message : pError}`;
			this.pict.log.warn(`EmailNotifications list load failed`, { error: String(pError) });
		}
		tmpState.ListLoading = false;
		this._repaintList();
	}

	/** Build a readable list row from a raw EmailRule record. */
	describeRule(pRule)
	{
		const tmpProjects = this._parseArray(pRule.Projects);
		const tmpStatus = this._parseArray(pRule.Status);
		const tmpHandlers = this.state.Handlers || {};
		const tmpHandlerMeta = tmpHandlers[pRule.Handler] || {};
		return {
			IDEmailRule: pRule.IDEmailRule,
			Enabled: !!pRule.Enabled,
			Handler: pRule.Handler || '',
			HandlerLabel: this.handlerLabel(pRule.Handler),
			Scheduled: !!tmpHandlerMeta.scheduled,
			DocumentType: pRule.DocumentType || '',
			DocumentTypeText: pRule.DocumentType ? (this.state.Lookups.DocTypeMap[pRule.DocumentType] || pRule.DocumentType) : 'Any document type',
			StatusText: tmpStatus.length ? (tmpStatus.length > 2 ? `${tmpStatus.slice(0, 2).join(', ')} +${tmpStatus.length - 2}` : tmpStatus.join(', ')) : 'Any status',
			ProjectsText: tmpProjects.length ? `${tmpProjects.length} project${tmpProjects.length === 1 ? '' : 's'}` : 'All projects',
			Config: pRule.Config || '',
			Raw: pRule,
		};
	}

	/** A human label for a handler name (spaced out CamelCase). */
	handlerLabel(pHandler)
	{
		if (!pHandler) { return '(no handler)'; }
		return String(pHandler).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
	}

	_repaintList()
	{
		const tmpView = this.pict.views.EmailNotificationsList;
		if (tmpView && tmpView.pict)
		{
			tmpView.render();
		}
	}

	// --- Editor (Phase 2): create / load / save / delete / clone -------------------------------------

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/** DELETE an Entity/<id> path through the rest client's deleteEntity (there is no raw deleteJSON). */
	_deleteEntity(pEntity, pID)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.deleteEntity(pEntity, pID, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/** Configuration/Get returns { Config, … } or the raw config; normalize to the config object. */
	_unwrapConfig(pResult)
	{
		if (pResult && pResult.Config !== undefined) { return pResult.Config || {}; }
		return pResult || {};
	}

	get editorState()
	{
		if (!this.state.Editor)
		{
			// HadConfig: the rule already had a stored custom-content blob when it loaded. Kept so that clearing
			// every override still writes an empty blob back, rather than leaving the old values in place.
			this.state.Editor = { Rule: null, Loading: false, Error: '', Editable: false, IsNew: false, Dirty: false, HadConfig: false };
		}
		return this.state.Editor;
	}

	_markRuleDirty() { this.editorState.Dirty = true; }

	/** A brand-new rule seeded with the same defaults Home uses (client-only Schedule/ConfigValue fields included). */
	_emptyRule()
	{
		const tmpHandlers = this.state.Handlers || {};
		const tmpDefaultHandler = tmpHandlers.StatusChangeNotification ? 'StatusChangeNotification' : (Object.keys(tmpHandlers)[0] || 'StatusChangeNotification');
		return {
			IDEmailRule: 0, Enabled: true, Projects: [], DocumentType: '', Status: [], Handler: tmpDefaultHandler,
			Config: '', ConfigValue: {}, ScheduleType: 'Weekly', ScheduleDays: [], ScheduleHour: 0,
		};
	}

	/** Load the selects' options (projects, document types, statuses) once. */
	async loadLookupsAsync()
	{
		if (this.state.Lookups.Loaded) { return; }
		await this.loadHandlersAsync();
		// Projects are NOT preloaded — a customer can have thousands (3,334 seen on QA), so the old 25-page (up to
		// 25k) sequential load blocked opening every rule. The projects dual-list is server-side search now (the
		// editor's Available pane queries per keystroke). This cache holds only the projects we've resolved (the
		// rule's selected ones + whatever a search surfaced) so their labels render in the Selected pane; it fills
		// lazily via searchProjectsAsync / resolveSelectedProjectLabelsAsync.
		if (!Array.isArray(this.state.Lookups.Projects)) { this.state.Lookups.Projects = []; }
		if (!this.state.Lookups.ProjectMap) { this.state.Lookups.ProjectMap = {}; }
		const tmpRNIs = await this._getJSON(`ReportNamedInstances/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}`).catch(() => []);
		const tmpDocMap = {}; const tmpDocList = [];
		(Array.isArray(tmpRNIs) ? tmpRNIs : []).forEach((pRNI) => { if (pRNI && pRNI.Hash) { tmpDocMap[pRNI.Hash] = pRNI.Name || pRNI.Hash; tmpDocList.push({ Hash: pRNI.Hash, Name: pRNI.Name || pRNI.Hash }); } });
		tmpDocList.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
		this.state.Lookups.DocTypeMap = tmpDocMap;
		this.state.Lookups.DocTypes = tmpDocList;
		// Statuses = the standard set + every Status found across the customer's approval workflows. The same
		// workflow blobs are the only place actor tags are authored, so harvest those in the same pass.
		const tmpWorkflows = await this._getJSON(`Configuration/For/ApprovalWorkflow/In/Customer/${this.idCustomer}`).catch(() => ({}));
		const tmpStatuses = new Set([ 'Draft', 'Submitted', 'Reviewed', 'Approved', 'Rejected' ]);
		const tmpActorTags = new Set();
		Object.keys(tmpWorkflows || {}).forEach((pKey) =>
		{
			const tmpBlob = tmpWorkflows[pKey];
			if (!tmpBlob || !Array.isArray(tmpBlob.States)) { return; }
			tmpBlob.States.forEach((pState) =>
			{
				if (!pState) { return; }
				if (pState.Status) { tmpStatuses.add(pState.Status); }
				(Array.isArray(pState.Transitions) ? pState.Transitions : []).forEach((pTransition) =>
				{
					// Object actors carry Tags; keyword/level actors are plain strings and have none.
					(Array.isArray(pTransition && pTransition.Actors) ? pTransition.Actors : []).forEach((pActor) =>
					{
						if (pActor && Array.isArray(pActor.Tags)) { pActor.Tags.forEach((pTag) => { if (pTag) { tmpActorTags.add(String(pTag)); } }); }
					});
				});
			});
		});
		this.state.Lookups.Statuses = Array.from(tmpStatuses);
		this.state.Lookups.ActorTags = Array.from(tmpActorTags).sort((pA, pB) => pA.localeCompare(pB));
		// Roles, for the UsersWithRole picker and the Recipients "Project role" rows.
		const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${this.idCustomer}`).catch(() => []);
		// A blank PermissionLevel cannot be targeted — `UsersWithRole` and `ProjectRole:` both match on the
		// level string, so an empty one would collapse every such role into a single meaningless choice.
		this.state.Lookups.Roles = (Array.isArray(tmpRoles) ? tmpRoles : [])
			.filter((pRole) => pRole && (pRole.PermissionLevel != null) && String(pRole.PermissionLevel).trim())
			.map((pRole) => ({ IDRole: pRole.IDRole, PermissionLevel: String(pRole.PermissionLevel), Name: pRole.Name || String(pRole.PermissionLevel) }))
			.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
		this.state.Lookups.Loaded = true;
	}

	/**
	 * The distinct PermissionLevels across the customer's roles, with a readable label. `UsersWithRole` and the
	 * `ProjectRole:` recipient token both match on PermissionLevel, and several roles can share one level.
	 * @return {Array<{ PermissionLevel: String, Label: String }>}
	 */
	get permissionLevelOptions()
	{
		const tmpRoles = (this.state.Lookups || {}).Roles || [];
		const tmpByLevel = {};
		tmpRoles.forEach((pRole) =>
		{
			if (!tmpByLevel[pRole.PermissionLevel]) { tmpByLevel[pRole.PermissionLevel] = []; }
			tmpByLevel[pRole.PermissionLevel].push(pRole.Name);
		});
		return Object.keys(tmpByLevel).sort((pA, pB) => pA.localeCompare(pB)).map((pLevel) =>
		{
			const tmpNames = tmpByLevel[pLevel];
			// One role on the level reads best as just its name; several become "Level (A, B)".
			const tmpLabel = (tmpNames.length === 1 && tmpNames[0] !== pLevel) ? `${tmpNames[0]} (${pLevel})` : `${pLevel}${tmpNames.length > 1 ? ` — ${tmpNames.length} roles` : ''}`;
			return { PermissionLevel: pLevel, Label: tmpLabel };
		});
	}

	/** A readable label for a stored UsersWithRole entry, which may be a PermissionLevel string or a numeric IDRole. */
	roleEntryLabel(pEntry)
	{
		const tmpRoles = (this.state.Lookups || {}).Roles || [];
		if (typeof pEntry === 'number' || /^\d+$/.test(String(pEntry)))
		{
			const tmpRole = tmpRoles.find((pRole) => Number(pRole.IDRole) === Number(pEntry));
			return tmpRole ? `${tmpRole.Name} (role ${pEntry})` : `Role ${pEntry}`;
		}
		const tmpLevel = this.permissionLevelOptions.find((pOption) => pOption.PermissionLevel === String(pEntry));
		return (tmpLevel && tmpLevel.Label) || String(pEntry);
	}

	/**
	 * Every project for the customer, paged out of Projects/Lite.
	 *
	 * A single 0/1000 call used to be enough; customers now run into the thousands (QA customer 10 has 3334),
	 * and a project missing from the picker was silently dropped from the rule on save — narrowing or, when
	 * the rule's only project was missing, WIDENING the rule to every project. Paging is what makes the
	 * picker's selected list authoritative.
	 */
	/** Merge resolved projects into the label cache — Lookups.Projects (dual-list Options()) + ProjectMap (labels). */
	_cacheProjects(pProjects)
	{
		const tmpLookups = this.state.Lookups;
		if (!Array.isArray(tmpLookups.Projects)) { tmpLookups.Projects = []; }
		if (!tmpLookups.ProjectMap) { tmpLookups.ProjectMap = {}; }
		(pProjects || []).forEach((pProject) =>
		{
			const tmpID = Number(pProject.IDProject);
			if (!(tmpID > 0) || Object.prototype.hasOwnProperty.call(tmpLookups.ProjectMap, tmpID)) { return; }
			const tmpName = pProject.Name || `Project ${tmpID}`;
			tmpLookups.ProjectMap[tmpID] = tmpName;
			tmpLookups.Projects.push({ IDProject: tmpID, Name: tmpName });
		});
	}

	/** Projects/Lite rows → [{IDProject, Name}]; the Lite shape carries the display name on `Value`. */
	_projectRowsToOptions(pRows)
	{
		return (Array.isArray(pRows) ? pRows : []).map((pRow) => ({ IDProject: pRow.IDProject, Name: pRow.Value || pRow.Name || `Project ${pRow.IDProject}` }));
	}

	/** Customer-scoped project filter, with an optional Name LIKE search term. */
	_projectsFilter(pTerm)
	{
		const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
		const tmpScope = `FBV~IDCustomer~EQ~${this.idCustomer}`;
		return tmpTerm ? `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpScope}` : tmpScope;
	}

	/** Server-side project search for the dual-list Available pane → [{Value:IDProject, Label:Name}] (first page). */
	async searchProjectsAsync(pTerm)
	{
		const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${this._projectsFilter(pTerm)}/0/50`).catch(() => []);
		const tmpProjects = this._projectRowsToOptions(tmpRows);
		this._cacheProjects(tmpProjects);
		return tmpProjects.map((pProject) => ({ Value: pProject.IDProject, Label: pProject.Name }));
	}

	/** "Add all matching the filter" — page the filtered set to exhaustion (bounded by the term) → options. */
	async searchAllProjectsAsync(pTerm)
	{
		const tmpFilter = this._projectsFilter(pTerm);
		const tmpPageSize = 1000;
		const tmpAll = [];
		for (let tmpBegin = 0; ; tmpBegin += tmpPageSize)
		{
			const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}/${tmpBegin}/${tmpPageSize}`).catch(() => []);
			const tmpRowsArr = Array.isArray(tmpRows) ? tmpRows : [];
			tmpRowsArr.forEach((pRow) => tmpAll.push(pRow));
			if (tmpRowsArr.length < tmpPageSize) { break; }
		}
		const tmpProjects = this._projectRowsToOptions(tmpAll);
		this._cacheProjects(tmpProjects);
		return tmpProjects.map((pProject) => ({ Value: pProject.IDProject, Label: pProject.Name }));
	}

	/** Resolve the rule's selected project ids → names into the cache (chunked INN), so the Selected pane reads names
	 * without preloading every project. */
	async resolveSelectedProjectLabelsAsync(pIDs)
	{
		const tmpIDs = (Array.isArray(pIDs) ? pIDs : []).map(Number).filter((pID) => pID > 0);
		if (!tmpIDs.length) { return; }
		const tmpChunkSize = 200;
		for (let tmpI = 0; tmpI < tmpIDs.length; tmpI += tmpChunkSize)
		{
			const tmpChunk = tmpIDs.slice(tmpI, tmpI + tmpChunkSize);
			const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/FBL~IDProject~INN~${tmpChunk.join(',')}~FBV~IDCustomer~EQ~${this.idCustomer}/0/${tmpChunkSize}`).catch(() => []);
			this._cacheProjects(this._projectRowsToOptions(tmpRows));
		}
	}

	/** A display label for a project id, falling back to the raw id when it is not in the resolved cache. */
	projectLabel(pIDProject)
	{
		return ((this.state.Lookups || {}).ProjectMap || {})[pIDProject] || `Project ${pIDProject}`;
	}

	async newRuleAsync()
	{
		const tmpEditor = this.editorState;
		tmpEditor.Loading = true; tmpEditor.Error = ''; tmpEditor.IsNew = true; tmpEditor.Dirty = false;
		tmpEditor.Editable = this.canEdit; tmpEditor.Rule = null; tmpEditor.HadConfig = false;
		this._repaintEditor();
		await this.loadLookupsAsync();
		tmpEditor.Rule = this._emptyRule();
		tmpEditor.Loading = false;
		this._repaintEditor();
	}

	async loadRuleAsync(pID)
	{
		const tmpEditor = this.editorState;
		tmpEditor.Loading = true; tmpEditor.Error = ''; tmpEditor.IsNew = false; tmpEditor.Dirty = false;
		tmpEditor.Editable = this.canEdit; tmpEditor.Rule = null;
		this._repaintEditor();
		try
		{
			await this.loadLookupsAsync();
			const tmpRows = await this._getJSON(`EmailRules/FilteredTo/FBV~IDEmailRule~EQ~${parseInt(pID, 10)}`).catch(() => []);
			const tmpRaw = (Array.isArray(tmpRows) ? tmpRows : [])[0];
			if (!tmpRaw) { tmpEditor.Error = `Email rule ${pID} was not found.`; tmpEditor.Loading = false; this._repaintEditor(); return; }
			const tmpRule = {
				IDEmailRule: tmpRaw.IDEmailRule, Enabled: !!tmpRaw.Enabled,
				Projects: this._parseArray(tmpRaw.Projects).map(Number), DocumentType: tmpRaw.DocumentType || '',
				Status: this._parseArray(tmpRaw.Status), Handler: tmpRaw.Handler || '', Config: tmpRaw.Config || '',
				ConfigValue: {}, ScheduleType: 'Weekly', ScheduleDays: [], ScheduleHour: 0,
			};
			// Load any existing custom email content so the config editor shows it (and a save round-trips it). A failed
			// read must fail the load: the save writes ConfigValue back whole, so starting from {} would drop the rule's
			// custom content.
			if (tmpRule.Config)
			{
				const tmpConfig = await this._postJSON('Configuration/Get',
					{ LevelContext: 'Customer', LevelContextID: this.idCustomer, NamespaceKey: `EmailRule-${tmpRule.Handler}`, NamespaceValue: tmpRule.Config || 'default' });
				tmpRule.ConfigValue = this._unwrapConfig(tmpConfig) || {};
			}
			tmpEditor.HadConfig = !!(tmpRule.Config && tmpRule.ConfigValue && Object.keys(tmpRule.ConfigValue).length);
			// Load the schedule rows (for scheduled handlers) into the client-only Schedule* fields.
			if ((this.state.Handlers[tmpRule.Handler] || {}).scheduled)
			{
				await this._loadScheduleInto(tmpRule);
			}
			tmpEditor.Rule = tmpRule;
			// Resolve the selected projects' names into the cache so the Selected pane reads names (not "Project <id>")
			// even though we no longer preload every project.
			await this.resolveSelectedProjectLabelsAsync(tmpRule.Projects);
		}
		catch (pError)
		{
			tmpEditor.Error = `Could not load email rule: ${pError && pError.message ? pError.message : pError}`;
			this.pict.log.warn(`EmailNotifications rule load failed`, { id: pID, error: String(pError) });
		}
		tmpEditor.Loading = false;
		this._repaintEditor();
	}

	/** Rebuild the client-only Schedule* fields from the rule's EmailRuleSchedule rows. */
	async _loadScheduleInto(pRule)
	{
		const tmpRows = await this._getJSON(`EmailRuleSchedules/FilteredTo/FBV~IDEmailRule~EQ~${pRule.IDEmailRule}`).catch(() => []);
		if (!Array.isArray(tmpRows) || !tmpRows.length) { return; }
		pRule.ScheduleHour = Number(tmpRows[0].HourOfDay) || 0;
		const tmpDaysOfWeek = tmpRows.filter((pRow) => Number(pRow.DayOfWeek) >= 0).map((pRow) => Number(pRow.DayOfWeek));
		const tmpDaysOfMonth = tmpRows.filter((pRow) => Number(pRow.DayOfMonth) >= 0).map((pRow) => Number(pRow.DayOfMonth));
		if (tmpDaysOfMonth.length) { pRule.ScheduleType = 'Monthly'; pRule.ScheduleDays = tmpDaysOfMonth; }
		else if (tmpDaysOfWeek.length >= 7) { pRule.ScheduleType = 'Daily'; pRule.ScheduleDays = []; }
		else { pRule.ScheduleType = 'Weekly'; pRule.ScheduleDays = tmpDaysOfWeek; }
	}

	/**
	 * The editable config fields for a handler, merging the handler's defaultConfiguration (the field set +
	 * defaults + docs) with the rule's stored ConfigValue.
	 *
	 * Overrides are PER KEY: ConfigValue holds only the keys the admin has chosen to customize, and every
	 * other key falls through to the handler's built-in default at send time. `Overridden` says which is
	 * which, `Value` is what the editor shows (the override when there is one, otherwise the default), and
	 * `Default` is kept alongside so the UI can show what "use the default" actually means.
	 *
	 * @return {Array<{ Key, Value, Default, Overridden, Editor, Doc, KnownField }>}
	 */
	configFieldDescriptors(pHandler, pConfigValue)
	{
		const tmpMeta = (this.state.Handlers || {})[pHandler] || {};
		const tmpDefaults = tmpMeta.defaultConfiguration || {};
		const tmpDocs = tmpMeta.configurationDocs || {};
		const tmpValue = pConfigValue || {};
		const tmpKeys = Object.keys(tmpDefaults);
		// Include any stored keys not in the defaults (forward-compat), preserving default order first.
		Object.keys(tmpValue).forEach((pKey) => { if (tmpKeys.indexOf(pKey) < 0) { tmpKeys.push(pKey); } });
		return tmpKeys.map((pKey) =>
		{
			const tmpOverridden = Object.prototype.hasOwnProperty.call(tmpValue, pKey);
			const tmpDefault = tmpDefaults[pKey];
			return {
				Key: pKey,
				Value: tmpOverridden ? tmpValue[pKey] : tmpDefault,
				Default: tmpDefault,
				Overridden: tmpOverridden,
				Editor: libConfigFieldSchema.resolveFieldEditor(pHandler, pKey, tmpDefault, tmpValue[pKey]),
				Doc: tmpDocs[pKey] || '',
				// A key the handler no longer declares — stored but unknown, so it only gets the JSON escape hatch.
				KnownField: Object.prototype.hasOwnProperty.call(tmpDefaults, pKey),
			};
		});
	}

	/**
	 * Turn a per-key override on (seeding an editable copy of the handler default) or off (dropping the key
	 * so the handler default applies again).
	 */
	setFieldOverride(pKey, pOn)
	{
		const tmpRule = this.editorState.Rule;
		if (!tmpRule) { return; }
		if (!tmpRule.ConfigValue) { tmpRule.ConfigValue = {}; }
		if (pOn)
		{
			const tmpMeta = (this.state.Handlers || {})[tmpRule.Handler] || {};
			const tmpDefault = (tmpMeta.defaultConfiguration || {})[pKey];
			tmpRule.ConfigValue[pKey] = (tmpDefault === undefined) ? '' : JSON.parse(JSON.stringify(tmpDefault));
		}
		else
		{
			delete tmpRule.ConfigValue[pKey];
		}
		this._markRuleDirty();
	}

	/**
	 * Persist the rule: EmailRule/Upsert (+ the new-rule-with-config double-save), then the custom-content
	 * Configuration/Put (customer-admin only, when custom config is in use), then EmailRule/SetSchedule (for
	 * scheduled handlers). Returns { IDEmailRule } or { Error }.
	 * NOTE: IDCustomer is intentionally omitted from the Upsert body — the server derives it from the session.
	 */
	async saveRuleAsync()
	{
		if (!this.canEdit) { throw new Error('You do not have permission to edit email rules.'); }
		const tmpEditor = this.editorState;
		const tmpRule = tmpEditor.Rule;
		if (!tmpRule) { return { Error: 'No rule to save.' }; }
		if (!tmpRule.Handler) { return { Error: 'Choose an email type.' }; }
		const tmpHandlerMeta = (this.state.Handlers || {})[tmpRule.Handler] || {};
		// Per-key overrides: ConfigValue holds only the keys the admin customized. Any override at all means the
		// rule needs its own Config pointer + blob; going back to zero overrides still needs a write (an empty
		// blob), otherwise the previously-stored values would keep applying.
		const tmpOverrideCount = (tmpRule.ConfigValue && typeof tmpRule.ConfigValue === 'object') ? Object.keys(tmpRule.ConfigValue).length : 0;
		const tmpUseConfig = tmpOverrideCount > 0;
		const tmpWriteConfig = tmpUseConfig || !!tmpEditor.HadConfig;

		const tmpBaseBody = () => ({
			Enabled: !!tmpRule.Enabled,
			DocumentType: tmpRule.DocumentType || '',
			Projects: (tmpRule.Projects || []).map(Number),
			Status: tmpRule.Status || [],
			Handler: tmpRule.Handler,
			Config: tmpRule.Config || '',
		});

		let tmpSaved = await this._putJSON('EmailRule/Upsert', Object.assign({ IDEmailRule: tmpRule.IDEmailRule || 0 }, tmpBaseBody()));
		let tmpNewID = (tmpSaved && (tmpSaved.IDEmailRule || (tmpSaved.Record && tmpSaved.Record.IDEmailRule))) || tmpRule.IDEmailRule;

		// Double-save: a brand-new rule with custom config needs its Config pointer set to IDEmailRule-<id>,
		// which is only known after the first Upsert.
		if (!tmpRule.Config && tmpUseConfig && tmpNewID)
		{
			tmpRule.Config = `IDEmailRule-${tmpNewID}`;
			tmpSaved = await this._putJSON('EmailRule/Upsert', Object.assign({ IDEmailRule: tmpNewID }, tmpBaseBody()));
		}
		tmpRule.IDEmailRule = tmpNewID;

		// Custom email content (customer-admin only). Skipped entirely for a rule that has never had overrides,
		// so a plain filter edit never creates a blob for a rule running on the handler defaults.
		// The client-side canEditConfig gate is coarser than the server's (QA showed a customer admin who is
		// refused Configuration writes), and by this point the EmailRule row is ALREADY saved. Letting the
		// rejection throw would surface a raw REST error and hide the fact that the rule now exists — so the
		// failure is captured and reported as a partial save instead.
		let tmpConfigWarning = '';
		if (tmpWriteConfig && this.canEditConfig && tmpRule.Config)
		{
			try
			{
				await this._postJSON(`Configuration/Put/EmailRule-${tmpRule.Handler}/${tmpRule.Config}/Customer/${this.idCustomer}`, tmpRule.ConfigValue || {});
				tmpEditor.HadConfig = tmpUseConfig;
			}
			catch (pError)
			{
				const tmpMessage = (pError && pError.message) ? pError.message : String(pError);
				tmpConfigWarning = /forbidden|permission/i.test(tmpMessage)
					? 'The rule was saved, but its customized email content was not — you do not have permission to write configuration for this customer.'
					: `The rule was saved, but its customized email content was not: ${tmpMessage}`;
				this.pict.log.warn(`EmailNotifications custom-content write failed`, { id: tmpNewID, error: tmpMessage });
			}
		}

		// Schedule (scheduled handlers only).
		if (tmpHandlerMeta.scheduled)
		{
			const tmpDays = tmpRule.ScheduleDays || [];
			await this._postJSON('EmailRule/SetSchedule',
				{
					IDEmailRule: tmpNewID,
					HourOfDay: Number(tmpRule.ScheduleHour) || 0,
					DaysOfMonth: (tmpRule.ScheduleType === 'Monthly') ? tmpDays : false,
					DaysOfWeek: (tmpRule.ScheduleType === 'Daily') ? [ 0, 1, 2, 3, 4, 5, 6 ] : ((tmpRule.ScheduleType === 'Weekly') ? tmpDays : false),
				});
		}

		tmpEditor.IsNew = false;
		tmpEditor.Dirty = false;
		this._repaintEditor();
		return { IDEmailRule: tmpNewID, Warning: tmpConfigWarning };
	}

	async deleteRuleAsync(pID)
	{
		if (!this.canEdit) { throw new Error('You do not have permission to delete email rules.'); }
		await this._deleteEntity('EmailRule', parseInt(pID, 10));
	}

	/**
	 * Clone a rule: a fresh EmailRule with the same targeting, IDClonedRule pointing at the source. The custom
	 * email content is NOT copied (a clone starts on the handler's default config, to avoid two rules sharing
	 * one config pointer); Phase 3's config editor can set it. Returns the new IDEmailRule.
	 */
	async cloneRuleAsync(pRaw)
	{
		if (!this.canEdit) { throw new Error('You do not have permission to clone email rules.'); }
		const tmpBody = {
			IDEmailRule: 0,
			IDClonedRule: pRaw.IDEmailRule,
			Enabled: !!pRaw.Enabled,
			DocumentType: pRaw.DocumentType || '',
			Projects: this._parseArray(pRaw.Projects).map(Number),
			Status: this._parseArray(pRaw.Status),
			Handler: pRaw.Handler,
			Config: '',
		};
		const tmpSaved = await this._putJSON('EmailRule/Upsert', tmpBody);
		return (tmpSaved && (tmpSaved.IDEmailRule || (tmpSaved.Record && tmpSaved.Record.IDEmailRule))) || 0;
	}

	_repaintEditor()
	{
		const tmpView = this.pict.views.EmailNotificationsEditor;
		if (tmpView && tmpView.pict)
		{
			tmpView.render();
		}
	}
}

module.exports = EmailNotificationsProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'EmailNotifications',
	AutoInitialize: true,
	AutoInitializeOrdinal: 40,
};

},{"../views/EmailNotifications-ConfigFieldSchema.js":1436,"pict-provider":845}],1337:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');
const libTaskCatalog = require('../access/Task-Catalog.js');
const libMasterListCatalog = require('../master-lists/Headlight-MasterLists.js');
const libTabBar = require('../views/TabBar.js');

const RAIL_MOUNT = '#Ent-Rail';
const RAIL_LIST_MOUNT = '#Ent-Rail-List';
const DETAIL_MOUNT = '#Ent-Detail';
const FORMS_LIST_MOUNT = '#Ent-Forms-List';
const MLIST_LIST_MOUNT = '#Ent-MList-List';
const TASKS_LIST_MOUNT = '#Ent-Tasks-List';   // the Features + Contract Administration tabs' scrollable task list
const STATUS_MOUNT = '#Ent-Status';           // the saving / error line (repainted in place so a toggle never rebuilds the detail)

// Managed permission-group name prefixes. Groups named with either prefix are lazily created + owned by this
// screen; they're hidden from the subject rail and indexed for state.
const TASK_PREFIX = 'Task-';         // Task-<Key>          — a feature task's capability bundle
const FORM_PREFIX = 'Form-';         // Form-<RNI.Hash>     — full access to one report/form (document type)
const MLIST_PREFIX = 'MList-';       // MList-<Entity>-<Action> — ONE capability (<Entity>-<Action>) on a master list

// Master-list access is granted per Meadow action. Read is the primary toggle (it's what un-hides the list in the
// navigation — the nav gate derives <Entity>-Read from the #/PSRS/<Entity>/List route); Create/Update/Delete sit
// behind an "Advanced" disclosure. One managed group per (entity, action), mirroring the Form-group model.
const MLIST_ACTIONS = [ 'Read', 'Create', 'Update', 'Delete' ];
const MLIST_ADV_ACTIONS = [ 'Create', 'Update', 'Delete' ];

// The dedicated Contract Administration tab renders exactly the tasks in this Area (the re-homed Pay & Funding
// list-management tasks + the funding association / module tasks); the Features tab excludes it.
const CONTRACT_ADMIN_AREA = 'Contract Administration';

// A report/form (ReportNamedInstance) capability hash is `DocumentType-<RNI.Hash>-<Action>` — mirrors the
// Access grid's reports/forms axis (Access-Matrix-Builder.reportCatalogSource). "Full access" is the four base
// report actions; finer control (individual actions, per-project scope, approval statuses) is the grid's job.
const REPORT_ENTITY_PREFIX = 'DocumentType-';
const FORM_ACTIONS = [ 'Create', 'View', 'Update', 'Delete' ];

// Elevating a USER (a person, not a role) to the CustomerAdmin config-admin tier. A broad task normally sets a
// Role/Group subject's own PermissionLevel; a user has none of their own, so we assign the shared, per-customer
// 'Customer Config Admin' group (PermissionLevel CustomerAdmin) — the SAME group the Grant Access screen
// manages, so the two screens stay in sync. Other broad tiers stay role/group-only.
const CONFIG_ADMIN_LEVEL = 'CustomerAdmin';
const CONFIG_ADMIN_GROUP_NAME = 'Customer Config Admin';

/**
 * Entitlements — the #/Entitlements screen. A task-based front end over the RBAC system: pick a subject (Role,
 * Permission Group, or User) and toggle human entitlements on/off; each toggle writes through the SAME grant path
 * the #/Access workspace uses — no matrix, no context theory. Two tabs: **Features** (the Task-Catalog.js task
 * bundles) and **Reports & Forms** (per-document-type full-access grants).
 *
 * Model:
 *   - A **feature task** is a lazily-created Permission Group named `Task-<Key>` carrying the task's capability
 *     bundle; a **form** is a lazily-created Permission Group named `Form-<RNI.Hash>` carrying full CRUD on that
 *     document type. Both are one-per-customer, shared across subjects, created on first use, never prospectively.
 *   - Turning one on:  Role/Group subject → compose the group in via **RoleEdge**;  User subject → assign it via
 *     **UserRoleJoin**. Off → remove that edge / assignment (the group stays for reuse).
 *   - **Broad tasks** (RequiresPermissionLevel, e.g. CustomerAdmin) set the subject's PermissionLevel directly for
 *     a Role/Group subject; they're offered only for Role/Group subjects (a person gets a tier by holding such a role).
 *
 * SECURITY / VERIFY: this writes real grants. The endpoint shapes below mirror the #/Access providers
 * (PermissionMatrix / GroupComposition / RoleAssignment) per the security map, but the round-trips MUST be
 * verified on QA against #/Access before this is trusted — I could not run it. Writing is gated to Role Managers
 * client-side; the server is authoritative.
 */
class EntitlementsProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._searchTimer = null;
		this._searchToken = 0;
	}

	get app() { return this.pict.PictApplication; }
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get state()
	{
		if (!this.pict.AppData.Entitlements)
		{
			this.pict.AppData.Entitlements =
			{
				Loaded: false, Loading: false, Roles: [], Groups: [], Users: [], TaskGroupsByKey: {}, FormGroupsByHash: {},
				SubjectKind: '', SubjectID: 0, SubjectLabel: '', SubjectRecord: null, SubjectPermissionLevel: '', HeldRoleIDs: {}, SubjectSearch: '', Searching: false, ConfigAdminGroup: null,
				ActiveTasks: {}, Busy: false, Error: '', ConfirmBroad: '',
				Tab: 'features', Forms: [], FormsLoaded: false, FormsLoading: false, ActiveForms: {}, FormSearch: '',
				MasterListGroupsByKey: {}, ActiveMasterLists: {}, MasterListSearch: '', MasterListExpanded: {},
			};
		}
		return this.pict.AppData.Entitlements;
	}

	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID) : 0; }

	/**
	 * Customer-1 / role-5 super-user — the server's EndpointBase._isSuperUser definition, and the ONLY subject that
	 * keeps the full cross-customer rail. Deliberately NARROWER than AccessWorkspace-Provider.isSuperUser, which also
	 * counts anyone holding a `SuperAdminAccessRole` role: customer admins (e.g. LADOTD) hold that role, so counting
	 * it here would hand them every customer's roles — the exact cross-customer leak this scoping fixes.
	 */
	isSuperUser()
	{
		const tmpUser = this.pict.AppData.CurrentUser;
		if (!tmpUser) { return false; }
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	/** UI gate — only a Role Manager (or super-user) may edit entitlements. Server stays authoritative. */
	canEdit()
	{
		const tmpUser = this.pict.AppData.CurrentUser;
		if (!tmpUser) { return false; }
		if ((Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1)) { return true; }
		const tmpRoles = tmpUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && ((pRole.PermissionLevel === 'RoleManager') || (pRole.PermissionLevel === 'SuperAdminUser')));
	}

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }

	// ── Load ───────────────────────────────────────────────────────────────────

	loadAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return; }
		tmpState.Loading = true;
		this.render();
		// The subject rail is server-side search (see setSubjectSearch/_searchSubjects) — with real data a customer
		// has thousands of users and roles, so we must NOT pre-load them and filter client-side (that only ever saw
		// the first page). Up front we load ONLY the managed permission groups — the Task-<Key> feature bundles and
		// Form-<RNI.Hash> full-access groups this screen lazily creates. That set is small and bounded (one row per
		// task/form per customer), and we need its full index so toggle-state reads true and _ensureTaskGroup /
		// _ensureFormGroup reuse an existing group instead of creating a duplicate. Managed groups live in the
		// caller's own customer (that's where _ensureTaskGroup creates them), so scope the lookup there.
		const tmpCustomer = this.callerCustomer();
		const tmpTaskURL = `Roles/FilteredTo/FBV~Name~LK~${encodeURIComponent(TASK_PREFIX + '%')}~FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0/0/500`;
		const tmpFormURL = `Roles/FilteredTo/FBV~Name~LK~${encodeURIComponent(FORM_PREFIX + '%')}~FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0/0/1000`;
		const tmpMListURL = `Roles/FilteredTo/FBV~Name~LK~${encodeURIComponent(MLIST_PREFIX + '%')}~FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0/0/1000`;
		Promise.all([ this._getJSON(tmpTaskURL), this._getJSON(tmpFormURL), this._getJSON(tmpMListURL) ]).then((pResults) =>
		{
			const tmpManaged = (Array.isArray(pResults[0]) ? pResults[0] : [])
				.concat(Array.isArray(pResults[1]) ? pResults[1] : [])
				.concat(Array.isArray(pResults[2]) ? pResults[2] : []);
			tmpState.TaskGroupsByKey = {};
			tmpState.FormGroupsByHash = {};
			tmpState.MasterListGroupsByKey = {};
			tmpManaged.forEach((pRole) =>
			{
				const tmpName = String((pRole && pRole.Name) || '');
				if (tmpName.indexOf(TASK_PREFIX) === 0) { tmpState.TaskGroupsByKey[tmpName.slice(TASK_PREFIX.length)] = pRole; }
				else if (tmpName.indexOf(MLIST_PREFIX) === 0) { tmpState.MasterListGroupsByKey[tmpName.slice(MLIST_PREFIX.length)] = pRole; }
				else if (tmpName.indexOf(FORM_PREFIX) === 0) { tmpState.FormGroupsByHash[tmpName.slice(FORM_PREFIX.length)] = pRole; }
			});
			// Subjects (Roles/Groups/Users) start empty; they're populated per-search from the server.
			tmpState.Roles = [];
			tmpState.Groups = [];
			tmpState.Users = [];
			tmpState.Loaded = true;
			tmpState.Loading = false;
			this.render();
		});
	}

	/** Select a subject and load which tasks are currently active on it. */
	selectSubject(pKind, pID)
	{
		const tmpState = this.state;
		tmpState.SubjectKind = pKind;
		tmpState.SubjectID = Number(pID);
		tmpState.Error = '';
		tmpState.ConfirmBroad = '';
		tmpState.ActiveTasks = {};
		tmpState.ActiveForms = {};
		tmpState.HeldRoleIDs = {};
		tmpState.SubjectPermissionLevel = '';
		const tmpSubject = this._subject(pKind, Number(pID));
		// Cache the selected record: the rail is live search, so the results list it came from can be replaced by
		// the next keystroke — _subject() falls back to this so writes + reloads still resolve the subject.
		tmpState.SubjectRecord = tmpSubject;
		tmpState.SubjectLabel = tmpSubject ? (tmpSubject.Name || libUserSearch.userLabel(tmpSubject) || ('#' + pID)) : ('#' + pID);
		if (pKind !== 'User') { tmpState.SubjectPermissionLevel = (tmpSubject && tmpSubject.PermissionLevel) || ''; }
		this.render();
		this._loadSubjectTasks(pKind, Number(pID));
	}

	_subject(pKind, pID)
	{
		const tmpState = this.state;
		const tmpList = (pKind === 'User') ? tmpState.Users : (pKind === 'Group') ? tmpState.Groups : tmpState.Roles;
		const tmpKey = (pKind === 'User') ? 'IDUser' : 'IDRole';
		const tmpFound = (tmpList || []).find((pItem) => Number(pItem[tmpKey]) === Number(pID));
		if (tmpFound) { return tmpFound; }
		// The search results may have moved on since selection; fall back to the record captured at select time.
		if (tmpState.SubjectRecord && (tmpState.SubjectKind === pKind) && (Number(tmpState.SubjectID) === Number(pID))) { return tmpState.SubjectRecord; }
		return null;
	}

	/**
	 * Which task groups the subject already holds. Role/Group → its RoleEdge children; User → its assigned roles.
	 * A task is "active" when the subject holds its Task-<Key> group (or, for a broad task, when a Role/Group
	 * subject's own PermissionLevel matches).
	 */
	_loadSubjectTasks(pKind, pID, pInPlace)
	{
		const tmpState = this.state;
		const tmpURL = (pKind === 'User')
			? `UserRoleJoins/FilteredTo/FBV~IDUser~EQ~${pID}`
			: `RoleEdges/FilteredTo/FBV~ParentIDRole~EQ~${pID}`;
		// For a User subject, also resolve the shared 'Customer Config Admin' group in THAT user's own customer,
		// so the broad config-admin task can reflect (and toggle) whether the person holds it.
		const tmpSubject = this._subject(pKind, pID);
		const tmpSubjectCustomer = tmpSubject ? Number(tmpSubject.IDCustomer) : this.callerCustomer();
		const tmpConfigGroupP = (pKind === 'User')
			? this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${tmpSubjectCustomer}~FBV~Name~EQ~${encodeURIComponent(CONFIG_ADMIN_GROUP_NAME)}~FBV~Deleted~EQ~0/0/1`)
			: Promise.resolve(null);
		Promise.all([ this._getJSON(tmpURL), tmpConfigGroupP ]).then((pResults) =>
		{
			if ((tmpState.SubjectKind !== pKind) || (tmpState.SubjectID !== pID)) { return; }
			const pRows = pResults[0];
			tmpState.ConfigAdminGroup = (Array.isArray(pResults[1]) ? pResults[1] : []).find((pRole) => pRole && pRole.IDRole) || null;
			const tmpHeldRoleIDs = {};
			(Array.isArray(pRows) ? pRows : []).forEach((pRow) => { const tmpChild = (pKind === 'User') ? pRow.IDRole : pRow.ChildIDRole; if (tmpChild) { tmpHeldRoleIDs[Number(tmpChild)] = pRow; } });
			tmpState.HeldRoleIDs = tmpHeldRoleIDs;   // shared by the feature tasks + the reports/forms tab
			const tmpConfigLink = tmpState.ConfigAdminGroup ? tmpHeldRoleIDs[Number(tmpState.ConfigAdminGroup.IDRole)] : null;
			const tmpActive = {};
			libTaskCatalog.getTasks().forEach((pTask) =>
			{
				if (pTask.RequiresPermissionLevel && (pKind !== 'User'))
				{
					// Role/Group subject: the tier is the subject's own PermissionLevel.
					tmpActive[pTask.Key] = { On: (tmpState.SubjectPermissionLevel === pTask.RequiresPermissionLevel), Link: null };
					return;
				}
				if (pTask.RequiresPermissionLevel && (pKind === 'User'))
				{
					// User subject: only the CustomerAdmin config-admin tier is grantable to a person (the shared
					// group); other tiers stay role/group-only, so they read Off.
					const tmpIsConfig = (pTask.RequiresPermissionLevel === CONFIG_ADMIN_LEVEL);
					tmpActive[pTask.Key] = { On: (tmpIsConfig && !!tmpConfigLink), Link: (tmpIsConfig ? (tmpConfigLink || null) : null) };
					return;
				}
				const tmpGroup = tmpState.TaskGroupsByKey[pTask.Key];
				const tmpLink = tmpGroup ? tmpHeldRoleIDs[Number(tmpGroup.IDRole)] : null;
				tmpActive[pTask.Key] = { On: !!tmpLink, Link: tmpLink || null };
			});
			tmpState.ActiveTasks = tmpActive;
			this._computeActiveForms();
			this._computeActiveMasterLists();
			// After a toggle we repaint only the active list (keeps tab + scroll); on a fresh subject load, full render.
			if (pInPlace) { this._repaintActiveList(); } else { this.render(); }
		});
	}

	// ── Toggle a task ────────────────────────────────────────────────────────────

	toggleTask(pKey)
	{
		const tmpState = this.state;
		if (!this.canEdit() || !tmpState.SubjectID || tmpState.Busy) { return; }
		const tmpTask = libTaskCatalog.getTask(pKey);
		if (!tmpTask || tmpTask.Pending) { return; }
		const tmpEntry = tmpState.ActiveTasks[pKey] || { On: false };
		// A broad (PermissionLevel) task turning ON gets a confirm step; otherwise apply immediately.
		if (tmpTask.Broad && !tmpEntry.On && (tmpState.ConfirmBroad !== pKey)) { tmpState.ConfirmBroad = pKey; this._repaintActiveList(); return; }
		tmpState.ConfirmBroad = '';
		tmpState.Busy = true;
		tmpState.Error = '';
		this._repaintActiveList();
		const fThen = (pOk) =>
		{
			tmpState.Busy = false;
			if (!pOk) { tmpState.Error = 'The server rejected the change (you may lack Permission-Grant in this context). Nothing was changed.'; this._repaintActiveList(); return; }
			// Reload the subject's state from the server so the toggles reflect the truth.
			if (tmpState.SubjectKind !== 'User') { const tmpSubject = this._subject(tmpState.SubjectKind, tmpState.SubjectID); tmpState.SubjectPermissionLevel = (tmpSubject && tmpSubject.PermissionLevel) || tmpState.SubjectPermissionLevel; }
			this._loadSubjectTasks(tmpState.SubjectKind, tmpState.SubjectID, true);
		};
		if (tmpTask.RequiresPermissionLevel && (tmpState.SubjectKind !== 'User')) { this._applyBroad(tmpTask, !tmpEntry.On).then(fThen); }
		else if (tmpTask.RequiresPermissionLevel && (tmpTask.RequiresPermissionLevel === CONFIG_ADMIN_LEVEL) && (tmpState.SubjectKind === 'User')) { this._applyConfigAdminForUser(!tmpEntry.On).then(fThen); }
		else if (tmpTask.RequiresPermissionLevel && (tmpState.SubjectKind === 'User')) { tmpState.Busy = false; this._repaintActiveList(); }   // other tiers are role/group-only (toggle is disabled)
		else { this._applyCapabilityTask(tmpTask, tmpEntry, !tmpEntry.On).then(fThen); }
	}

	/**
	 * User subject: grant/remove the shared 'Customer Config Admin' group (PermissionLevel CustomerAdmin) in the
	 * user's own customer — the same group #/GrantAccess manages, so a person elevated on either screen reads the
	 * same on both. @param {boolean} pOn
	 */
	_applyConfigAdminForUser(pOn)
	{
		const tmpState = this.state;
		const tmpSubject = this._subject('User', tmpState.SubjectID);
		if (!tmpSubject) { return Promise.resolve(false); }
		const tmpIDUser = Number(tmpSubject.IDUser);
		const tmpIDCustomer = Number(tmpSubject.IDCustomer);
		if (pOn)
		{
			return this._ensureConfigAdminGroup(tmpIDCustomer).then((tmpGroup) =>
			{
				if (!tmpGroup || !tmpGroup.IDRole) { return false; }
				return this._putJSON('Permissions/Role/For/User', { IDRole: Number(tmpGroup.IDRole), IDUser: tmpIDUser, Context: 'Customer', IDContext: tmpIDCustomer }).then((pRes) => !pRes.error);
			});
		}
		// Off — remove the user's assignment to the group (the group itself is left for reuse).
		const tmpLink = (tmpState.ConfigAdminGroup && tmpState.HeldRoleIDs) ? tmpState.HeldRoleIDs[Number(tmpState.ConfigAdminGroup.IDRole)] : null;
		if (!tmpLink) { return Promise.resolve(true); }
		return this._unlinkSubjectFromGroup(tmpLink);
	}

	/** Find (or create) the per-customer 'Customer Config Admin' Permission Group (PermissionLevel CustomerAdmin). */
	_ensureConfigAdminGroup(pIDCustomer)
	{
		return this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${pIDCustomer}~FBV~Name~EQ~${encodeURIComponent(CONFIG_ADMIN_GROUP_NAME)}~FBV~Deleted~EQ~0/0/1`).then((pRoles) =>
		{
			const tmpExisting = (Array.isArray(pRoles) ? pRoles : []).find((pRole) => pRole && pRole.IDRole);
			if (tmpExisting) { return tmpExisting; }
			return this._postJSON('Role',
				{
					Name: CONFIG_ADMIN_GROUP_NAME, Type: 'PermissionGroup', PermissionLevel: CONFIG_ADMIN_LEVEL,
					Description: 'Grants configuration-admin rights (PermissionLevel CustomerAdmin) for this customer. Managed by Grant Access / Entitlements.',
					IDCustomer: pIDCustomer,
				}).then((pRes) => (pRes && !pRes.error && pRes.result) ? pRes.result : null);
		});
	}

	/** Broad task: set (or clear) the subject role/group's PermissionLevel. */
	_applyBroad(pTask, pOn)
	{
		const tmpState = this.state;
		const tmpSubject = this._subject(tmpState.SubjectKind, tmpState.SubjectID);
		if (!tmpSubject) { return Promise.resolve(false); }
		const tmpBody = Object.assign({}, tmpSubject, { PermissionLevel: pOn ? pTask.RequiresPermissionLevel : '' });
		return this._putJSON('Role', tmpBody).then((pRes) =>
		{
			if (pRes.error) { return false; }
			tmpSubject.PermissionLevel = tmpBody.PermissionLevel;   // keep the cached subject in step
			return true;
		});
	}

	/** Capability task: ensure the Task-<Key> group exists + granted, then add/remove the subject's link to it. */
	_applyCapabilityTask(pTask, pEntry, pOn)
	{
		const tmpState = this.state;
		if (pOn)
		{
			return this._ensureTaskGroup(pTask).then((pGroup) =>
			{
				if (!pGroup) { return false; }
				return this._linkSubjectToGroup(pGroup.IDRole).then((pOk) => pOk);
			});
		}
		// Off — remove the link (leave the shared group for reuse).
		return this._unlinkSubjectFromGroup(pEntry.Link);
	}

	/** Find-or-create the Task-<Key> Permission Group for this customer, granting its capability bundle once. */
	_ensureTaskGroup(pTask)
	{
		const tmpState = this.state;
		const tmpExisting = tmpState.TaskGroupsByKey[pTask.Key];
		if (tmpExisting) { return Promise.resolve(tmpExisting); }
		const tmpCustomer = this.callerCustomer();
		const tmpBody = { Name: 'Task-' + pTask.Key, Type: 'PermissionGroup', Description: pTask.Label + ' (managed by Entitlements)', IDCustomer: tmpCustomer };
		return this._postJSON('Role', tmpBody).then((pRes) =>
		{
			const tmpGroup = pRes && pRes.result;
			if (pRes.error || !tmpGroup || !tmpGroup.IDRole) { return null; }
			tmpState.TaskGroupsByKey[pTask.Key] = tmpGroup;
			// Grant each capability to the new group at the customer scope (VERIFY scope vs #/Access _scope() on QA).
			const tmpGrants = libTaskCatalog.taskGrants(pTask);
			return Promise.all(tmpGrants.map((pGrant) => this._getJSON(`Permissions/Grant/${encodeURIComponent(pGrant.Hash)}/To/Role/${tmpGroup.IDRole}/For/Customer/${tmpCustomer}`)))
				.then(() => tmpGroup);
		});
	}

	/** Compose (Role/Group subject) or assign (User subject) the task group onto the subject. */
	_linkSubjectToGroup(pGroupID)
	{
		const tmpState = this.state;
		const tmpCustomer = this.callerCustomer();
		if (tmpState.SubjectKind === 'User')
		{
			return this._putJSON('Permissions/Role/For/User', { IDRole: pGroupID, IDUser: tmpState.SubjectID, Context: 'Customer', IDContext: tmpCustomer }).then((pRes) => !pRes.error);
		}
		return this._postJSON('RoleEdge', { ParentIDRole: tmpState.SubjectID, ChildIDRole: pGroupID, IDCustomer: tmpCustomer }).then((pRes) => !pRes.error);
	}

	/** Remove the subject's link to a task group (the RoleEdge row, or the UserRoleJoin). */
	_unlinkSubjectFromGroup(pLink)
	{
		const tmpState = this.state;
		const tmpRC = this.restClient;
		if (!pLink || !tmpRC || (typeof tmpRC.deleteEntity !== 'function')) { return Promise.resolve(false); }
		if (tmpState.SubjectKind === 'User')
		{
			return new Promise((resolve) => tmpRC.deleteEntity('UserRoleJoin', pLink.IDUserRoleJoin, (pErr) => resolve(!pErr)));
		}
		return new Promise((resolve) => tmpRC.deleteEntity('RoleEdge', pLink.IDRoleEdge, (pErr) => resolve(!pErr)));
	}

	// ── Reports & Forms tab ──────────────────────────────────────────────────────

	/** Switch the detail tab. Loads the customer's reports/forms on first visit to the Forms tab (Master Lists is
	 * catalog-driven + reads the subject's already-loaded held groups, so it needs no per-tab fetch). */
	/** Switch tabs via a stable route (#/Entitlements/<Kind>/<ID>/<tab>) so the selected subject AND its tab both
	 *  live in the URL. The tab buttons call this. */
	navigateTab(pTab)
	{
		const tmpState = this.state;
		if (tmpState.SubjectKind && tmpState.SubjectID && (typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/Entitlements/${ tmpState.SubjectKind }/${ tmpState.SubjectID }/${ pTab }`;
		}
		else { this.setTab(pTab); }
	}

	/** Select a subject via a stable route (keeps the current tab). The rail items call this. */
	navigateSubject(pKind, pID)
	{
		const tmpTab = this.state.Tab || 'features';
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/Entitlements/${ pKind }/${ Number(pID) }/${ tmpTab }`;
		}
		else { this.selectSubject(pKind, pID); }
	}

	setTab(pTab)
	{
		const tmpState = this.state;
		const tmpTab = ((pTab === 'forms') || (pTab === 'masterlists') || (pTab === 'contractadmin')) ? pTab : 'features';
		if (tmpState.Tab === tmpTab) { return; }
		tmpState.Tab = tmpTab;
		tmpState.Error = '';
		if ((tmpTab === 'forms') && !tmpState.FormsLoaded && !tmpState.FormsLoading) { this._loadFormsAsync(); return; }
		this.render();
	}

	/** Load the customer's document types (ReportNamedInstance) — the rows of the Forms tab. */
	_loadFormsAsync()
	{
		const tmpState = this.state;
		if (tmpState.FormsLoading) { return; }
		tmpState.FormsLoading = true;
		this.render();
		this._getJSON(`ReportNamedInstances/By/IDCustomer/${this.callerCustomer()}/0/1000`).then((pRows) =>
		{
			const tmpForms = (Array.isArray(pRows) ? pRows : []).filter((pRNI) => pRNI && pRNI.Hash);
			tmpForms.sort((pA, pB) => String(pA.Name || pA.Hash).localeCompare(String(pB.Name || pB.Hash)));
			tmpState.Forms = tmpForms;
			tmpState.FormsLoaded = true;
			tmpState.FormsLoading = false;
			this._computeActiveForms();
			this.render();
		});
	}

	/** Mark each form on/off for the current subject: on when the subject holds that form's Form-<Hash> group. */
	_computeActiveForms()
	{
		const tmpState = this.state;
		const tmpActive = {};
		(tmpState.Forms || []).forEach((pRNI) =>
		{
			const tmpGroup = tmpState.FormGroupsByHash[pRNI.Hash];
			const tmpLink = (tmpGroup && tmpState.HeldRoleIDs) ? tmpState.HeldRoleIDs[Number(tmpGroup.IDRole)] : null;
			tmpActive[pRNI.Hash] = { On: !!tmpLink, Link: tmpLink || null };
		});
		tmpState.ActiveForms = tmpActive;
	}

	setFormSearch(pValue)
	{
		const tmpState = this.state;
		tmpState.FormSearch = String(pValue == null ? '' : pValue);
		// Update just the list, so the search input keeps focus (a full render would rebuild the input).
		if (this.pict.ContentAssignment.getElement(FORMS_LIST_MOUNT).length > 0)
		{
			this.pict.ContentAssignment.assignContent(FORMS_LIST_MOUNT, this._formsListHTML(this.canEdit()));
		}
		else { this.render(); }
	}

	/** Toggle full access to a form for the subject — same group-compose path as a feature task. */
	toggleForm(pHash)
	{
		const tmpState = this.state;
		if (!this.canEdit() || !tmpState.SubjectID || tmpState.Busy) { return; }
		const tmpRNI = (tmpState.Forms || []).find((pRNI) => pRNI.Hash === pHash);
		if (!tmpRNI) { return; }
		const tmpEntry = tmpState.ActiveForms[pHash] || { On: false };
		tmpState.Busy = true;
		tmpState.Error = '';
		this._repaintActiveList();
		const fThen = (pOk) =>
		{
			tmpState.Busy = false;
			if (!pOk) { tmpState.Error = 'The server rejected the change (you may lack Permission-Grant in this context). Nothing was changed.'; this._repaintActiveList(); return; }
			this._loadSubjectTasks(tmpState.SubjectKind, tmpState.SubjectID, true);   // reloads held groups → recomputes both tabs
		};
		if (!tmpEntry.On)
		{
			this._ensureFormGroup(tmpRNI).then((pGroup) => (pGroup ? this._linkSubjectToGroup(pGroup.IDRole) : false)).then(fThen);
		}
		else
		{
			this._unlinkSubjectFromGroup(tmpEntry.Link).then(fThen);
		}
	}

	/** Find-or-create the Form-<Hash> Permission Group for this customer, granting full CRUD on the document type. */
	_ensureFormGroup(pRNI)
	{
		const tmpState = this.state;
		const tmpExisting = tmpState.FormGroupsByHash[pRNI.Hash];
		if (tmpExisting) { return Promise.resolve(tmpExisting); }
		const tmpCustomer = this.callerCustomer();
		const tmpBody = { Name: FORM_PREFIX + pRNI.Hash, Type: 'PermissionGroup', Description: `Form: ${pRNI.Name || pRNI.Hash} (managed by Entitlements)`, IDCustomer: tmpCustomer };
		return this._postJSON('Role', tmpBody).then((pRes) =>
		{
			const tmpGroup = pRes && pRes.result;
			if (pRes.error || !tmpGroup || !tmpGroup.IDRole) { return null; }
			tmpState.FormGroupsByHash[pRNI.Hash] = tmpGroup;
			// Full access = the four base report actions on this document type, at the customer scope (matching the
			// Task groups + the resolver's Customer/<customer> check). Per-action / per-context nuance → #/Access.
			return Promise.all(FORM_ACTIONS.map((pAction) => this._getJSON(`Permissions/Grant/${encodeURIComponent(REPORT_ENTITY_PREFIX + pRNI.Hash + '-' + pAction)}/To/Role/${tmpGroup.IDRole}/For/Customer/${tmpCustomer}`)))
				.then(() => tmpGroup);
		});
	}

	// ── Master Lists tab ─────────────────────────────────────────────────────────

	/** The master lists an admin can grant access to — the static seed catalog (Headlight-MasterLists.js). */
	_masterListCatalog()
	{
		return (Array.isArray(libMasterListCatalog) ? libMasterListCatalog : []).filter((pEntry) => pEntry && pEntry.Entity);
	}

	/** Group the catalog by Domain for display: [ { Domain, Lists:[entry…] } ], domains A→Z with "Other" last. */
	_masterListDomains()
	{
		const tmpByDomain = {};
		const tmpOrder = [];
		this._masterListCatalog().forEach((pEntry) =>
		{
			const tmpDomain = pEntry.Domain || 'Other';
			if (!tmpByDomain[tmpDomain]) { tmpByDomain[tmpDomain] = []; tmpOrder.push(tmpDomain); }
			tmpByDomain[tmpDomain].push(pEntry);
		});
		tmpOrder.sort((pA, pB) => (pA === 'Other') ? 1 : (pB === 'Other') ? -1 : pA.localeCompare(pB));
		return tmpOrder.map((pDomain) => ({ Domain: pDomain, Lists: tmpByDomain[pDomain].slice().sort((pA, pB) => String(pA.Label || pA.Entity).localeCompare(String(pB.Label || pB.Entity))) }));
	}

	/** Mark each (entity, action) on/off for the subject: on when it holds that MList-<Entity>-<Action> group. */
	_computeActiveMasterLists()
	{
		const tmpState = this.state;
		const tmpActive = {};
		this._masterListCatalog().forEach((pEntry) =>
		{
			MLIST_ACTIONS.forEach((pAction) =>
			{
				const tmpKey = `${pEntry.Entity}-${pAction}`;
				const tmpGroup = tmpState.MasterListGroupsByKey[tmpKey];
				const tmpLink = (tmpGroup && tmpState.HeldRoleIDs) ? tmpState.HeldRoleIDs[Number(tmpGroup.IDRole)] : null;
				tmpActive[tmpKey] = { On: !!tmpLink, Link: tmpLink || null };
			});
		});
		tmpState.ActiveMasterLists = tmpActive;
	}

	setMasterListSearch(pValue)
	{
		const tmpState = this.state;
		tmpState.MasterListSearch = String(pValue == null ? '' : pValue);
		// Repaint just the list so the search input keeps focus (mirrors setFormSearch).
		if (this.pict.ContentAssignment.getElement(MLIST_LIST_MOUNT).length > 0)
		{
			this.pict.ContentAssignment.assignContent(MLIST_LIST_MOUNT, this._masterListsListHTML(this.canEdit()));
		}
		else { this.render(); }
	}

	/** Show/hide the Create/Update/Delete disclosure for one master list (client-only UI state; repaint the list). */
	toggleMasterListAdvanced(pEntity)
	{
		const tmpState = this.state;
		if (tmpState.MasterListExpanded[pEntity]) { delete tmpState.MasterListExpanded[pEntity]; }
		else { tmpState.MasterListExpanded[pEntity] = true; }
		this._repaintActiveList();   // repaint the list in place, preserving its scroll position (no full re-render)
	}

	/** Toggle one <Entity>-<Action> capability for the subject — same group-compose path as a feature task / form. */
	toggleMasterList(pEntity, pAction)
	{
		const tmpState = this.state;
		if (!this.canEdit() || !tmpState.SubjectID || tmpState.Busy) { return; }
		if (MLIST_ACTIONS.indexOf(pAction) < 0) { return; }
		const tmpKey = `${pEntity}-${pAction}`;
		const tmpEntry = tmpState.ActiveMasterLists[tmpKey] || { On: false };
		tmpState.Busy = true;
		tmpState.Error = '';
		this._repaintActiveList();
		const fThen = (pOk) =>
		{
			tmpState.Busy = false;
			if (!pOk) { tmpState.Error = 'The server rejected the change (you may lack Permission-Grant in this context). Nothing was changed.'; this._repaintActiveList(); return; }
			this._loadSubjectTasks(tmpState.SubjectKind, tmpState.SubjectID, true);   // reloads held groups → recomputes every tab
		};
		if (!tmpEntry.On)
		{
			this._ensureMasterListGroup(pEntity, pAction).then((pGroup) => (pGroup ? this._linkSubjectToGroup(pGroup.IDRole) : false)).then(fThen);
		}
		else
		{
			this._unlinkSubjectFromGroup(tmpEntry.Link).then(fThen);
		}
	}

	/** Find-or-create the MList-<Entity>-<Action> Permission Group for this customer, granting that one capability. */
	_ensureMasterListGroup(pEntity, pAction)
	{
		const tmpState = this.state;
		const tmpKey = `${pEntity}-${pAction}`;
		const tmpExisting = tmpState.MasterListGroupsByKey[tmpKey];
		if (tmpExisting) { return Promise.resolve(tmpExisting); }
		const tmpCustomer = this.callerCustomer();
		const tmpBody = { Name: MLIST_PREFIX + tmpKey, Type: 'PermissionGroup', Description: `Master list: ${pAction} ${pEntity} (managed by Entitlements)`, IDCustomer: tmpCustomer };
		return this._postJSON('Role', tmpBody).then((pRes) =>
		{
			const tmpGroup = pRes && pRes.result;
			if (pRes.error || !tmpGroup || !tmpGroup.IDRole) { return null; }
			tmpState.MasterListGroupsByKey[tmpKey] = tmpGroup;
			// Grant the single <Entity>-<Action> capability to the new group at the customer scope (same shape as the
			// Task/Form groups + the resolver's Customer/<customer> check).
			return this._getJSON(`Permissions/Grant/${encodeURIComponent(tmpKey)}/To/Role/${tmpGroup.IDRole}/For/Customer/${tmpCustomer}`).then(() => tmpGroup);
		});
	}

	_masterListsHTML(pEditable)
	{
		const tmpState = this.state;
		return `<p class="ent-note">Grant this ${this._subjectKindNoun()} access to a reference / catalog list. <strong>Read</strong> lets them open the list and view its records (and surfaces it in their navigation); <strong>Advanced</strong> adds create, update, and delete. For finer control (per-project scope, other entities) use the Access &amp; Permissions grid.</p>`
			+ `<input class="ent-forms-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search master lists…" value="${this._esc(tmpState.MasterListSearch || '')}" oninput="_Pict.providers.Entitlements.setMasterListSearch(this.value)" />`
			+ `<div id="Ent-MList-List" class="ent-forms-list">${this._masterListsListHTML(pEditable)}</div>`;
	}

	_masterListsListHTML(pEditable)
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.MasterListSearch || '').trim().toLowerCase();
		const fMatch = (pEntry) => !tmpQuery
			|| (String(pEntry.Label || '').toLowerCase().indexOf(tmpQuery) > -1)
			|| (String(pEntry.Entity || '').toLowerCase().indexOf(tmpQuery) > -1)
			|| (String(pEntry.Domain || '').toLowerCase().indexOf(tmpQuery) > -1)
			|| (String(pEntry.Keywords || '').toLowerCase().indexOf(tmpQuery) > -1);
		const tmpDomains = this._masterListDomains()
			.map((pDomain) => ({ Domain: pDomain.Domain, Lists: pDomain.Lists.filter(fMatch) }))
			.filter((pDomain) => pDomain.Lists.length > 0);
		if (!tmpDomains.length) { return `<div class="ent-rail-empty">${tmpQuery ? 'No master lists match your search.' : 'No master lists found.'}</div>`; }
		const tmpDisabled = !pEditable || tmpState.Busy;
		return tmpDomains.map((pDomain) =>
		{
			const tmpRows = pDomain.Lists.map((pEntry) => this._masterListRowHTML(pEntry, tmpDisabled)).join('');
			return `<div class="ent-area"><div class="ent-area-head">${this._esc(pDomain.Domain)}</div>${tmpRows}</div>`;
		}).join('');
	}

	_masterListRowHTML(pEntry, pDisabled)
	{
		const tmpState = this.state;
		const tmpEntity = pEntry.Entity;
		const tmpReadEntry = tmpState.ActiveMasterLists[`${tmpEntity}-Read`] || { On: false };
		const tmpExpanded = !!tmpState.MasterListExpanded[tmpEntity];
		const tmpAdvOnCount = MLIST_ADV_ACTIONS.filter((pAction) => { const tmpE = tmpState.ActiveMasterLists[`${tmpEntity}-${pAction}`]; return tmpE && tmpE.On; }).length;
		const tmpIcon = pEntry.Icon ? `<i class="${this._esc(pEntry.Icon)} ent-mlist-icon"></i>` : '';
		const tmpReadToggle = `<button class="ent-switch${tmpReadEntry.On ? ' is-on' : ''}"${pDisabled ? ' disabled' : ''} title="Read — view this list and its records" onclick="_Pict.providers.Entitlements.toggleMasterList('${this._esc(tmpEntity)}','Read'); return false;"><span class="ent-switch-dot"></span></button>`;
		const tmpAdvBtn = `<button class="ent-mlist-adv-btn" onclick="_Pict.providers.Entitlements.toggleMasterListAdvanced('${this._esc(tmpEntity)}'); return false;">${tmpExpanded ? '▾' : '▸'} Advanced${tmpAdvOnCount ? ` <span class="ent-mlist-adv-count">${tmpAdvOnCount}</span>` : ''}</button>`;
		const tmpAdvRow = tmpExpanded
			? `<div class="ent-mlist-adv">${MLIST_ADV_ACTIONS.map((pAction) =>
			{
				const tmpEntry = tmpState.ActiveMasterLists[`${tmpEntity}-${pAction}`] || { On: false };
				return `<div class="ent-mlist-action"><span class="ent-mlist-action-lbl">${this._esc(pAction)}</span><button class="ent-switch${tmpEntry.On ? ' is-on' : ''}"${pDisabled ? ' disabled' : ''} onclick="_Pict.providers.Entitlements.toggleMasterList('${this._esc(tmpEntity)}','${pAction}'); return false;"><span class="ent-switch-dot"></span></button></div>`;
			}).join('')}</div>`
			: '';
		return `<div class="ent-task ent-mlist-row"><div class="ent-task-main"><div class="ent-task-label">${tmpIcon}${this._esc(pEntry.Label || tmpEntity)}</div>`
			+ `<div class="ent-task-desc">${this._esc(pEntry.Description || tmpEntity)}</div>${tmpAdvBtn}</div>`
			+ `<div class="ent-mlist-read"><span class="ent-read-lbl">Read</span>${tmpReadToggle}</div></div>${tmpAdvRow}`;
	}

	// ── Render (hand-built HTML into the shell's mounts) ─────────────────────────

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_MOUNT).length === 0) { return; }
		// Keep the rail search input alive across renders so it never loses focus mid-type (mirrors
		// SuperUserGrant-Provider): build the rail shell (search + list mount) only when it's absent, otherwise
		// repaint just the list. Keying off the list mount's presence also survives route re-navigation.
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length === 0) { tmpCA.assignContent(RAIL_MOUNT, this._railHTML()); }
		else { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML());
	}

	// ── In-place repaints (a toggle must NOT rebuild the whole detail — that resets the active tab's scroll, the search
	//    box, and the page position). Repaint ONLY the active tab's list + the status line, preserving the list's scroll. ──
	_activeListMount() { const tmpTab = this.state.Tab; return (tmpTab === 'masterlists') ? MLIST_LIST_MOUNT : (tmpTab === 'forms') ? FORMS_LIST_MOUNT : TASKS_LIST_MOUNT; }
	_activeListHTML() { const tmpEditable = this.canEdit(); const tmpTab = this.state.Tab; return (tmpTab === 'masterlists') ? this._masterListsListHTML(tmpEditable) : (tmpTab === 'forms') ? this._formsListHTML(tmpEditable) : this._tasksListHTML(tmpEditable); }
	/** Repaint just the active tab's entitlement list (keeps its internal scroll position) + the status line. */
	_repaintActiveList()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpMount = this._activeListMount();
		const tmpEl = tmpCA.getElement(tmpMount);
		if (!tmpEl || tmpEl.length === 0) { this.render(); return; }   // mount not in the DOM (e.g. Forms still loading) — fall back
		const tmpTop = tmpEl[0].scrollTop;
		tmpCA.assignContent(tmpMount, this._activeListHTML());
		const tmpEl2 = tmpCA.getElement(tmpMount);
		if (tmpEl2 && tmpEl2.length) { tmpEl2[0].scrollTop = tmpTop; }   // restore scroll (assignContent resets it)
		this._repaintStatus();
	}
	_repaintStatus() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement(STATUS_MOUNT).length > 0) { tmpCA.assignContent(STATUS_MOUNT, this._statusHTML()); } }
	_statusHTML() { const tmpState = this.state; return (tmpState.Busy ? '<p class="ent-note ent-busy">Saving…</p>' : '') + (tmpState.Error ? `<p class="ent-error">${this._esc(tmpState.Error)}</p>` : ''); }

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }


	/**
	 * Search the subject rail. SERVER-SIDE (mirrors SuperUserGrant-Provider): a customer has thousands of users +
	 * roles, so we can't load them and filter in the browser — that only ever saw the first page. Debounce 250ms,
	 * then query the server; a stale-token guard drops out-of-order responses. Repaints only the list mount so the
	 * search input keeps focus (see render()).
	 */
	setSubjectSearch(pValue)
	{
		const tmpState = this.state;
		tmpState.SubjectSearch = String(pValue == null ? '' : pValue);
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(() => { this._searchTimer = null; this._searchSubjects(); }, 250);
	}

	/** Repaint just the rail list (keeps the search input alive); full render if the list mount isn't in the DOM. */
	_renderRail()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length > 0) { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		else { this.render(); }
	}

	/**
	 * Run the subject search against the server: Roles/Groups matched on Name (global + this customer, or all for a
	 * super-user); Users via the shared user search (name, login ID or email; every word must match).
	 * Managed groups (Task-/Form-/config-admin) are filtered out.
	 */
	_searchSubjects()
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.SubjectSearch || '').trim();
		if (tmpQuery.length < 2)
		{
			tmpState.Searching = false;
			tmpState.Roles = []; tmpState.Groups = []; tmpState.Users = [];
			this._renderRail();
			return;
		}
		const tmpToken = ++this._searchToken;
		tmpState.Searching = true;
		this._renderRail();
		const tmpLike = encodeURIComponent(`%${tmpQuery}%`);
		const tmpCustomer = this.callerCustomer();
		// Roles/Groups: Name LIKE, scoped to global (IDCustomer 0) + this customer unless super-user (mirrors loadAsync's
		// old scope). Users: the shared user search (name, login ID or email), scoped to this customer unless super-user.
		const tmpRoleScope = this.isSuperUser() ? '' : `~FBL~IDCustomer~INN~0,${tmpCustomer}`;
		const tmpUserScope = this.isSuperUser() ? 'FBV~Deleted~EQ~0' : `FBV~IDCustomer~EQ~${tmpCustomer}~FBV~Deleted~EQ~0`;
		const tmpRolesURL = `Roles/FilteredTo/FBV~Name~LK~${tmpLike}${tmpRoleScope}~FBV~Deleted~EQ~0/0/50`;
		const fGetJSON = (pURL) => this._getJSON(pURL);
		Promise.all([ fGetJSON(tmpRolesURL), libUserSearch.searchUsersAsync(fGetJSON, tmpQuery, { Scope: tmpUserScope, PageSize: 50 }) ]).then((pResults) =>
		{
			if (tmpToken !== this._searchToken)
			{
				return;   // a newer search superseded this one
			}
			const fManaged = (pRole) => { const tmpName = String((pRole && pRole.Name) || ''); return (tmpName.indexOf(TASK_PREFIX) === 0) || (tmpName.indexOf(FORM_PREFIX) === 0) || (tmpName.indexOf(MLIST_PREFIX) === 0) || (tmpName === CONFIG_ADMIN_GROUP_NAME); };
			const tmpRoleRows = (Array.isArray(pResults[0]) ? pResults[0] : []).filter((pRole) => pRole && !fManaged(pRole));
			tmpState.Roles = tmpRoleRows.filter((pRole) => pRole.Type !== 'PermissionGroup');
			tmpState.Groups = tmpRoleRows.filter((pRole) => pRole.Type === 'PermissionGroup');
			tmpState.Users = pResults[1];
			tmpState.Searching = false;
			this._renderRail();
		});
	}

	_railGroup(pTitle, pIcon, pItems, pKind, pIDField, pLabelFn)
	{
		const tmpState = this.state;
		const tmpRows = (pItems || []).map((pItem) =>
		{
			const tmpID = pItem[pIDField];
			const tmpActive = ((tmpState.SubjectKind === pKind) && (Number(tmpState.SubjectID) === Number(tmpID))) ? ' is-active' : '';
			return `<div class="ent-rail-item${tmpActive}" onclick="_Pict.providers.Entitlements.navigateSubject('${pKind}', ${Number(tmpID)})">${this._esc(pLabelFn(pItem))}</div>`;
		}).join('');
		return `<div class="ent-rail-group"><div class="ent-rail-head"><i class="ent-rail-head-icon ${pIcon}"></i><span class="ent-rail-head-text">${this._esc(pTitle)}</span><span class="ent-rail-count">${(pItems || []).length}</span></div>${tmpRows || '<div class="ent-rail-empty">None</div>'}</div>`;
	}

	_railHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Loaded) { return '<div class="ent-rail-empty">Loading…</div>'; }
		return `<input class="ent-rail-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search roles, groups, users…" value="${this._esc(tmpState.SubjectSearch || '')}" oninput="_Pict.providers.Entitlements.setSubjectSearch(this.value)" />`
			+ `<div id="Ent-Rail-List" class="ent-rail-list">${this._railListHTML()}</div>`;
	}

	/** The subject rail: server search results (Roles / Permission Groups / Users), or a prompt/empty state. */
	_railListHTML()
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.SubjectSearch || '').trim();
		if (tmpState.Searching) { return '<div class="ent-rail-empty">Searching…</div>'; }
		if (tmpQuery.length < 2) { return '<div class="ent-rail-empty">Type at least 2 characters to find a role, permission group, or user.</div>'; }
		const fRoleLabel = (pItem) => pItem.Name || ('Role #' + pItem.IDRole);
		const fGroupLabel = (pItem) => pItem.Name || ('Group #' + pItem.IDRole);
		const fUserLabel = (pItem) => libUserSearch.userLabel(pItem);
		const tmpParts = [];
		// Only render a group that has hits — during search an empty "Roles — None" band is just noise.
		if ((tmpState.Roles || []).length) { tmpParts.push(this._railGroup('Roles', 'fas fa-user-shield', tmpState.Roles, 'Role', 'IDRole', fRoleLabel)); }
		if ((tmpState.Groups || []).length) { tmpParts.push(this._railGroup('Permission Groups', 'fas fa-layer-group', tmpState.Groups, 'Group', 'IDRole', fGroupLabel)); }
		if ((tmpState.Users || []).length) { tmpParts.push(this._railGroup('Users', 'fas fa-users', tmpState.Users, 'User', 'IDUser', fUserLabel)); }
		if (!tmpParts.length) { return `<div class="ent-rail-empty">No roles, permission groups, or users match “${this._esc(tmpQuery)}”.</div>`; }
		return tmpParts.join('');
	}

	_detailHTML()
	{
		const tmpState = this.state;
		if (!tmpState.SubjectID) { return '<div class="ent-empty">Pick a role, permission group, or user on the left to set up what they can do.</div>'; }
		const tmpEditable = this.canEdit();
		const tmpKindLabel = (tmpState.SubjectKind === 'User') ? 'User' : (tmpState.SubjectKind === 'Group') ? 'Permission Group' : 'Role';
		const tmpReadonly = tmpEditable ? '' : '<p class="ent-note">You can view entitlements here, but changing them needs a Role Manager role.</p>';
		const tmpBody = (tmpState.Tab === 'forms')
			? this._formsHTML(tmpEditable)
			: (tmpState.Tab === 'masterlists')
				? this._masterListsHTML(tmpEditable)
				: (tmpState.Tab === 'contractadmin')
					? this._contractAdminHTML(tmpEditable)
					: this._featuresHTML(tmpEditable);
		return `<div class="ent-detail-head"><div class="ent-detail-title">${this._esc(tmpState.SubjectLabel)}</div>`
			+ `<div class="ent-detail-sub">${this._esc(tmpKindLabel)}</div></div>`
			+ this._tabBarHTML()
			+ tmpReadonly
			+ `<div id="Ent-Status">${this._statusHTML()}</div>`
			+ tmpBody;
	}

	_tabBarHTML()
	{
		const tmpTab = this.state.Tab || 'features';
		return libTabBar.renderTabsHTML(
			[
				{ Key: 'features', Label: 'Features', Icon: 'fas fa-toggle-on' },
				{ Key: 'masterlists', Label: 'Master Lists', Icon: 'fas fa-database' },
				{ Key: 'contractadmin', Label: 'Contract Administration', Icon: 'fas fa-file-invoice-dollar' },
				{ Key: 'forms', Label: 'Reports & Forms', Icon: 'fas fa-file-lines' },
			],
			tmpTab,
			(pTab) => `_Pict.providers.Entitlements.navigateTab('${ pTab.Key }'); return false;`,
			{ overflow: 'wrap' });
	}

	_subjectKindNoun() { const tmpKind = this.state.SubjectKind; return (tmpKind === 'User') ? 'user' : (tmpKind === 'Group') ? 'permission group' : 'role'; }

	_formsHTML(pEditable)
	{
		const tmpState = this.state;
		if (tmpState.FormsLoading || !tmpState.FormsLoaded) { return '<p class="ent-note">Loading reports &amp; forms…</p>'; }
		return `<p class="ent-note">Turn a report or form on to give this ${this._subjectKindNoun()} full access to it — create, view, update, and delete. For finer control (individual actions, per-project scope, or approval statuses) use the Access &amp; Permissions grid.</p>`
			+ `<input class="ent-forms-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search reports &amp; forms…" value="${this._esc(tmpState.FormSearch || '')}" oninput="_Pict.providers.Entitlements.setFormSearch(this.value)" />`
			+ `<div id="Ent-Forms-List" class="ent-forms-list">${this._formsListHTML(pEditable)}</div>`;
	}

	_formsListHTML(pEditable)
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.FormSearch || '').trim().toLowerCase();
		const tmpForms = (tmpState.Forms || []).filter((pRNI) => !tmpQuery
			|| (String(pRNI.Name || '').toLowerCase().indexOf(tmpQuery) > -1)
			|| (String(pRNI.Hash || '').toLowerCase().indexOf(tmpQuery) > -1));
		if (!tmpForms.length) { return `<div class="ent-rail-empty">${tmpQuery ? 'No reports or forms match your search.' : 'No reports or forms found for this customer.'}</div>`; }
		return tmpForms.map((pRNI) =>
		{
			const tmpEntry = tmpState.ActiveForms[pRNI.Hash] || { On: false };
			const tmpDisabled = !pEditable || tmpState.Busy;
			const tmpToggle = `<button class="ent-switch${tmpEntry.On ? ' is-on' : ''}"${tmpDisabled ? ' disabled' : ''} onclick="_Pict.providers.Entitlements.toggleForm('${this._esc(pRNI.Hash)}'); return false;"><span class="ent-switch-dot"></span></button>`;
			return `<div class="ent-task"><div class="ent-task-main"><div class="ent-task-label">${this._esc(pRNI.Name || pRNI.Hash)}</div>`
				+ `<div class="ent-task-desc">${this._esc(pRNI.Hash)}</div></div>${tmpToggle}</div>`;
		}).join('');
	}

	_areaHTML(pArea, pEditable)
	{
		const tmpState = this.state;
		const tmpRows = pArea.Tasks.map((pTask) =>
		{
			const tmpEntry = tmpState.ActiveTasks[pTask.Key] || { On: false };
			// The CustomerAdmin config-admin tier CAN be granted to a person (via the shared group); other broad
			// tiers stay role/group-only, so only those are disabled for a User subject.
			const tmpUnsupportedBroadForUser = pTask.RequiresPermissionLevel && (pTask.RequiresPermissionLevel !== CONFIG_ADMIN_LEVEL) && (tmpState.SubjectKind === 'User');
			const tmpDisabled = !pEditable || tmpState.Busy || tmpUnsupportedBroadForUser || !!pTask.Pending;
			const tmpConfirm = (tmpState.ConfirmBroad === pTask.Key);
			const tmpToggle = tmpConfirm
				? `<span class="ent-confirm">Grant broad rights? <button class="ent-btn ent-btn-danger" onclick="_Pict.providers.Entitlements.toggleTask('${this._esc(pTask.Key)}')">Grant</button> <button class="ent-btn ent-btn-ghost" onclick="_Pict.providers.Entitlements.cancelBroad()">Cancel</button></span>`
				: `<button class="ent-switch${tmpEntry.On ? ' is-on' : ''}"${tmpDisabled ? ' disabled' : ''} onclick="_Pict.providers.Entitlements.toggleTask('${this._esc(pTask.Key)}'); return false;"><span class="ent-switch-dot"></span></button>`;
			const tmpFlags = (pTask.Broad ? '<span class="ent-flag">Broad</span>' : '')
				+ (pTask.Pending ? '<span class="ent-hint">Not yet available — platform update pending</span>' : '')
				+ (tmpUnsupportedBroadForUser ? '<span class="ent-hint">Set on a role, not a person</span>' : '');
			return `<div class="ent-task"><div class="ent-task-main"><div class="ent-task-label">${this._esc(pTask.Label)} ${tmpFlags}</div>`
				+ `<div class="ent-task-desc">${this._esc(pTask.Description || '')}</div></div>${tmpToggle}</div>`;
		}).join('');
		return `<div class="ent-area"><div class="ent-area-head">${this._esc(pArea.Area)}</div>${tmpRows}</div>`;
	}

	/** The Features tab: a filter box + the standard feature-task list (everything except the Contract Administration area). */
	_featuresHTML(pEditable)
	{
		const tmpState = this.state;
		return `<input class="ent-forms-search" type="text" autocomplete="off" spellcheck="false" placeholder="Filter entitlements…" value="${this._esc(tmpState.TaskSearch || '')}" oninput="_Pict.providers.Entitlements.setTaskSearch(this.value)" />`
			+ `<div id="Ent-Tasks-List" class="ent-forms-list ent-tasks">${this._tasksListHTML(pEditable)}</div>`;
	}

	/** The task rows for the active tasks-based tab (Features, or Contract Administration), filtered by the tab's filter box. */
	_tasksListHTML(pEditable)
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.TaskSearch || '').trim().toLowerCase();
		const tmpContract = (tmpState.Tab === 'contractadmin');
		const fMatch = (pTask) => !tmpQuery
			|| (String(pTask.Label || '').toLowerCase().indexOf(tmpQuery) > -1)
			|| (String(pTask.Description || '').toLowerCase().indexOf(tmpQuery) > -1)
			|| (String(pTask.Key || '').toLowerCase().indexOf(tmpQuery) > -1);
		const tmpAreas = libTaskCatalog.tasksByArea()
			.filter((pArea) => (tmpContract ? (pArea.Area === CONTRACT_ADMIN_AREA) : (pArea.Area !== CONTRACT_ADMIN_AREA)))
			.map((pArea) => ({ Area: pArea.Area, Tasks: pArea.Tasks.filter(fMatch) }))
			.filter((pArea) => pArea.Tasks.length > 0);
		if (!tmpAreas.length) { return `<div class="ent-rail-empty">${tmpQuery ? 'No entitlements match your filter.' : 'No entitlements are configured.'}</div>`; }
		return tmpAreas.map((pArea) => this._areaHTML(pArea, pEditable)).join('');
	}

	/** The dedicated Contract Administration tab: an intro + a filter box + only the Contract Administration Area tasks,
	 *  reusing the standard task toggles + list mount. */
	_contractAdminHTML(pEditable)
	{
		const tmpState = this.state;
		if (!libTaskCatalog.tasksByArea().some((pArea) => pArea.Area === CONTRACT_ADMIN_AREA)) { return '<div class="ent-empty">No Contract Administration entitlements are configured.</div>'; }
		const tmpIntro = '<p class="ent-note">Grants for the funding &amp; contract-administration arc: manage the financial reference lists (funds, funding sources, categories, accounts), wire funding to projects &amp; line items, and open the module. Per-action (Read/Create/Update/Delete) toggles for each list also live on the Master Lists tab.</p>';
		return tmpIntro
			+ `<input class="ent-forms-search" type="text" autocomplete="off" spellcheck="false" placeholder="Filter entitlements…" value="${this._esc(tmpState.TaskSearch || '')}" oninput="_Pict.providers.Entitlements.setTaskSearch(this.value)" />`
			+ `<div id="Ent-Tasks-List" class="ent-forms-list ent-tasks">${this._tasksListHTML(pEditable)}</div>`;
	}

	/** Filter the feature/contract task list in place (keeps the filter input focused during typing). */
	setTaskSearch(pValue)
	{
		const tmpState = this.state;
		tmpState.TaskSearch = String(pValue == null ? '' : pValue);
		if (this.pict.ContentAssignment.getElement(TASKS_LIST_MOUNT).length > 0)
		{
			this.pict.ContentAssignment.assignContent(TASKS_LIST_MOUNT, this._tasksListHTML(this.canEdit()));
		}
		else { this.render(); }
	}

	cancelBroad() { this.state.ConfirmBroad = ''; this._repaintActiveList(); }
}

module.exports = EntitlementsProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'Entitlements',
	AutoInitialize: true,
	AutoInitializeOrdinal: 40,
};

},{"../access/Task-Catalog.js":1063,"../access/User-Search.js":1064,"../master-lists/Headlight-MasterLists.js":1290,"../views/TabBar.js":1479,"pict-provider":845}],1338:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libNavigation = require('headlight-entity-navigation');
const libHosts = require('headlight-qrcode/source/Headlight-QRCode-Hosts.js');
const { DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS } = require('headlight-dynamic-inputs-bundle/source/providers/_VocabularySelectorMap.js');

/**
 * @typedef {import('headlight-entity-navigation/source/Headlight-Entity-Navigation.js').DestinationRule} DestinationRule
 */

/**
 * What each entity's rules can test and where they can send people. Route templates are fixed per
 * target so nobody types hosts or paths; `Custom` keeps an admin-written route on a known app.
 *
 * @type {Record<string, { Label: string, Conditions: Array<{ Address: string, Label: string, Values?: 'Statuses' }>, Targets: Array<{ Key: string, Label: string, Target: Object }>, Example: Object }>}
 */
const ENTITIES =
{
	Sample:
	{
		Label: 'Samples',
		Conditions: [ { Address: 'Record.Status', Label: 'Sample status', Values: 'Statuses' } ],
		Targets:
		[
			{ Key: 'lims', Label: 'The sample in LIMS', Target: { App: 'LIMS', Route: '#/Sample/Workspace/{~D:Record.IDSample~}' } },
			{ Key: 'workspace', Label: 'The sample workspace (configuration app)', Target: { App: 'Config', Route: '#/Sample/Workspace/{~D:Record.IDSample~}' } },
			{ Key: 'form-oldest', Label: 'The sample’s first form', Target: { Via: 'Document', Pick: 'Oldest' } },
			{ Key: 'form-newest', Label: 'The sample’s latest form', Target: { Via: 'Document', Pick: 'Newest' } },
			{ Key: 'landing', Label: 'A summary page with choices', Target: { Landing: true } },
		],
		Example: { GUIDSample: 'EXAMPLE-SAMPLE', IDSample: 1, Status: 'RECV' },
	},
	Location:
	{
		Label: 'Locations',
		Conditions: [ { Address: 'Record.Type', Label: 'Location type' } ],
		Targets:
		[
			{ Key: 'lims', Label: 'The location in LIMS', Target: { App: 'LIMS', Route: '#/Location/Workspace/{~D:Record.IDLocation~}' } },
			{ Key: 'landing', Label: 'A summary page with choices', Target: { Landing: true } },
		],
		Example: { GUIDLocation: 'EXAMPLE-LOCATION', IDLocation: 1, Type: '' },
	},
	Document:
	{
		Label: 'Forms',
		Conditions: [ { Address: 'Record.DocumentType', Label: 'Form type' } ],
		Targets:
		[
			{ Key: 'landing', Label: 'A summary page with choices', Target: { Landing: true } },
		],
		Example: { IDDocument: 1, GUIDDocument: 'EXAMPLE-FORM', DocumentType: '' },
	},
};

const CUSTOM_TARGET_KEY = 'custom';

/** How many role matches the role search lists at once. */
const ROLE_SUGGESTION_LIMIT = 8;

/**
 * EntityDestinationsConfig — the #/EntityDestinations screen ("Where Records Open"). Edits the customer-level
 * `EntityDestinations` configuration (NamespaceValue = entity) that the links app resolves scanned labels and
 * emailed links against, with a "who goes where" preview using the same resolver.
 *
 * Platform rules (Global level) apply to every customer. They are shown read-only, after the customer's own rules
 * (which are kept ordered ahead of them), and a customer can only turn one off. The configuration service stores
 * only what differs from the Global level, so saving the merged map keeps the platform rules inherited.
 * Gated by the `EntityDestinations-Configure` entitlement. Super-users may pick any customer.
 */
class EntityDestinationsConfigProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get state()
	{
		if (!this.pict.AppData.EntityDestinationsConfig)
		{
			this.pict.AppData.EntityDestinationsConfig =
			{
				Loaded: false, Loading: false, Saving: false, Error: '', Message: '',
				TargetCustomerID: 0, TargetCustomerName: '', Customers: [],
				Entity: 'Sample', Rules: {}, Platform: {}, Dirty: {},
				Roles: [], Statuses: [],
				EditingKey: '', Draft: null,
				PreviewRoles: [], PreviewValue: '',
				RoleSearch: { Draft: '', Preview: '' },
			};
		}
		return this.pict.AppData.EntityDestinationsConfig;
	}

	get currentUser()
	{
		return this.pict.AppData.CurrentUser || {};
	}

	callerCustomer()
	{
		return Number(this.currentUser.CustomerID) || 0;
	}

	isSuperUser()
	{
		return (Number(this.currentUser.UserRoleIndex) === 5) && (Number(this.currentUser.CustomerID) === 1);
	}

	can()
	{
		const tmpService = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpService || (typeof tmpService.can !== 'function'))
		{
			return true;
		}
		return tmpService.can('EntityDestinations', 'Configure');
	}

	/**
	 * @param {string} pURL
	 * @return {Promise<any>} the body, or null on error
	 */
	_getJSON(pURL)
	{
		const tmpClient = this.restClient;
		if (!tmpClient)
		{
			return Promise.resolve(null);
		}
		return new Promise((fResolve) => tmpClient.getJSON(pURL, (pError, pBody) => fResolve(pError ? null : pBody)));
	}

	/**
	 * @param {string} pURL
	 * @param {Object} pBody
	 * @return {Promise<{ error: any, result: any }>}
	 */
	_postJSON(pURL, pBody)
	{
		const tmpClient = this.restClient;
		if (!tmpClient)
		{
			return Promise.resolve({ error: 'no client', result: null });
		}
		return new Promise((fResolve) => tmpClient.postJSON(pURL, pBody, (pError, pResult) => fResolve({ error: pError, result: pResult })));
	}

	/**
	 * @param {any} pValue
	 * @return {string}
	 */
	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** @return {Record<string, DestinationRule>} the rules of the entity being edited */
	currentRules()
	{
		const tmpState = this.state;
		if (!tmpState.Rules[tmpState.Entity] || typeof tmpState.Rules[tmpState.Entity] !== 'object')
		{
			tmpState.Rules[tmpState.Entity] = {};
		}
		return tmpState.Rules[tmpState.Entity];
	}

	/** @return {Array<[string, DestinationRule]>} rules in the order they are tried */
	orderedRules()
	{
		return Object.entries(this.currentRules()).sort(([ pKeyA, pA ], [ pKeyB, pB ]) => ((pA.Order ?? 100) - (pB.Order ?? 100)) || pKeyA.localeCompare(pKeyB));
	}

	/**
	 * @param {string} pKey
	 * @return {boolean} true for a rule the platform (Global level) sets, which this customer inherits
	 */
	isPlatformRule(pKey)
	{
		const tmpPlatform = this.state.Platform[this.state.Entity];
		return !!(tmpPlatform && tmpPlatform[pKey]);
	}

	/** @return {Array<[string, DestinationRule]>} the customer's own rules, in the order they are tried */
	customerRules()
	{
		return this.orderedRules().filter(([ pKey ]) => !this.isPlatformRule(pKey));
	}

	async loadAsync()
	{
		const tmpState = this.state;
		tmpState.Loading = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			if (this.isSuperUser())
			{
				const tmpCustomers = await this._getJSON('Customers/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/2000');
				tmpState.Customers = Array.isArray(tmpCustomers) ? tmpCustomers.map((pCustomer) => ({ IDCustomer: pCustomer.IDCustomer, Name: pCustomer.Name })) : [];
			}
			if (!tmpState.TargetCustomerID)
			{
				tmpState.TargetCustomerID = this.callerCustomer();
			}
			await this._loadCustomerAsync(tmpState.TargetCustomerID);
			tmpState.Loaded = true;
		}
		catch (pError)
		{
			tmpState.Error = `Could not load where records open: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	/**
	 * @param {number} pIDCustomer
	 */
	async _loadCustomerAsync(pIDCustomer)
	{
		const tmpState = this.state;
		const tmpCustomer = await this._getJSON(`Customer/${Number(pIDCustomer)}`);
		tmpState.TargetCustomerName = (tmpCustomer && tmpCustomer.Name) || '';
		const tmpMap = await this._getJSON(`Configuration/For/EntityDestinations/In/Customer/${Number(pIDCustomer)}`);
		if (tmpMap === null)
		{
			throw new Error('the saved settings could not be read');
		}
		// Global level only: which of the merged rules come from the platform.
		const tmpPlatformMap = await this._getJSON('Configuration/For/EntityDestinations/In/Global/0');
		if (tmpPlatformMap === null)
		{
			throw new Error('the platform’s rules could not be read');
		}
		tmpState.Rules = {};
		tmpState.Platform = {};
		for (const tmpEntity of Object.keys(ENTITIES))
		{
			tmpState.Rules[tmpEntity] = (tmpMap && tmpMap[tmpEntity] && typeof tmpMap[tmpEntity] === 'object') ? JSON.parse(JSON.stringify(tmpMap[tmpEntity])) : {};
			tmpState.Platform[tmpEntity] = (tmpPlatformMap && tmpPlatformMap[tmpEntity] && typeof tmpPlatformMap[tmpEntity] === 'object') ? JSON.parse(JSON.stringify(tmpPlatformMap[tmpEntity])) : {};
		}
		tmpState.Dirty = {};
		tmpState.EditingKey = '';
		tmpState.Draft = null;
		const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBL~IDCustomer~INN~0,${Number(pIDCustomer)}~FSF~Name~ASC~0/0/1000`);
		const tmpRoleRows = (Array.isArray(tmpRoles) ? tmpRoles : []).filter((pRole) => pRole && pRole.GUIDRole && pRole.Name && !pRole.Deleted && pRole.Type !== 'PermissionGroup');
		const tmpNameCounts = tmpRoleRows.reduce((pCounts, pRole) => Object.assign(pCounts, { [pRole.Name]: (pCounts[pRole.Name] || 0) + 1 }), {});
		tmpState.Roles = tmpRoleRows.map((pRole) => ({ Hash: pRole.GUIDRole, Name: (tmpNameCounts[pRole.Name] > 1 && !Number(pRole.IDCustomer)) ? `${pRole.Name} (standard)` : pRole.Name, PermissionLevel: pRole.PermissionLevel || '' }));
		const tmpStatuses = await this._getJSON('SampleStatuss/FilteredTo/FSF~Ordinal~ASC~0/0/500');
		tmpState.Statuses = (Array.isArray(tmpStatuses) && tmpStatuses.length)
			? tmpStatuses.map((pStatus) => ({ Hash: pStatus.Hash, Name: pStatus.Name || pStatus.Hash }))
			: DEFAULT_SAMPLE_STATUS_SELECT_OPTIONS.map((pOption) => ({ Hash: pOption.id, Name: pOption.text }));
		tmpState.PreviewRoles = [];
		tmpState.PreviewValue = '';
		tmpState.RoleSearch = { Draft: '', Preview: '' };
	}

	async selectCustomer(pIDCustomer)
	{
		const tmpState = this.state;
		tmpState.TargetCustomerID = Number(pIDCustomer) || 0;
		tmpState.Message = '';
		tmpState.Error = '';
		tmpState.Loading = true;
		this.render();
		try
		{
			await this._loadCustomerAsync(tmpState.TargetCustomerID);
		}
		catch (pError)
		{
			tmpState.Error = `Could not load where records open: ${(pError && pError.message) || pError}`;
		}
		tmpState.Loading = false;
		this.render();
	}

	setEntity(pEntity)
	{
		if (ENTITIES[pEntity])
		{
			this.state.Entity = pEntity;
			this.state.EditingKey = '';
			this.state.Draft = null;
			this.state.PreviewValue = '';
			this.render();
		}
	}

	// --- Rule list ------------------------------------------------------------------------------------------

	_markDirty()
	{
		this.state.Dirty[this.state.Entity] = true;
		this.state.Message = '';
	}

	/**
	 * Number the customer's own rules 10, 20, … so they are tried in the order shown, and always ahead of the
	 * platform rules (the gap shrinks if a platform rule's Order is low). Platform rules keep their own Order.
	 * @param {Array<[string, DestinationRule]>} pOrdered - The customer's rules, in the order wanted.
	 */
	_renumber(pOrdered)
	{
		const tmpPlatformOrders = Object.values(this.state.Platform[this.state.Entity] || {}).filter((pRule) => pRule && typeof pRule === 'object').map((pRule) => pRule.Order ?? 100);
		const tmpCeiling = tmpPlatformOrders.length ? Math.min(...tmpPlatformOrders) : Infinity;
		const tmpStep = Number.isFinite(tmpCeiling) ? Math.max(Math.min(10, (tmpCeiling - 1) / (pOrdered.length || 1)), 0.001) : 10;
		pOrdered.forEach(([ , pRule ], pIndex) =>
		{
			pRule.Order = Math.round((pIndex + 1) * tmpStep * 1000) / 1000;
		});
	}

	moveRule(pKey, pDelta)
	{
		const tmpOrdered = this.customerRules();
		const tmpIndex = tmpOrdered.findIndex(([ pRuleKey ]) => pRuleKey === pKey);
		const tmpTarget = tmpIndex + Number(pDelta);
		if (tmpIndex < 0 || tmpTarget < 0 || tmpTarget >= tmpOrdered.length)
		{
			return;
		}
		const [ tmpMoved ] = tmpOrdered.splice(tmpIndex, 1);
		tmpOrdered.splice(tmpTarget, 0, tmpMoved);
		this._renumber(tmpOrdered);
		this._markDirty();
		this.render();
	}

	toggleRule(pKey)
	{
		const tmpRule = this.currentRules()[pKey];
		if (tmpRule)
		{
			tmpRule.Enabled = (tmpRule.Enabled === false);
			this._markDirty();
			this.render();
		}
	}

	removeRule(pKey)
	{
		if (this.isPlatformRule(pKey))
		{
			return;
		}
		delete this.currentRules()[pKey];
		if (this.state.EditingKey === pKey)
		{
			this.state.EditingKey = '';
			this.state.Draft = null;
		}
		this._renumber(this.customerRules());
		this._markDirty();
		this.render();
	}

	// --- Rule editor ----------------------------------------------------------------------------------------

	/**
	 * @param {DestinationRule['Target']} pTarget
	 * @return {string} the preset key matching a target, or 'custom'
	 */
	_targetKey(pTarget)
	{
		const tmpPreset = ENTITIES[this.state.Entity].Targets.find((pChoice) => JSON.stringify(pChoice.Target) === JSON.stringify(pTarget || {}));
		return tmpPreset ? tmpPreset.Key : CUSTOM_TARGET_KEY;
	}

	editRule(pKey)
	{
		const tmpRule = this.currentRules()[pKey];
		if (!tmpRule || this.isPlatformRule(pKey))
		{
			return;
		}
		const tmpCondition = ENTITIES[this.state.Entity].Conditions[0];
		const tmpValues = (tmpRule.When && tmpRule.When[tmpCondition.Address]) || [];
		this.state.EditingKey = pKey;
		this.state.RoleSearch.Draft = '';
		this.state.Draft =
		{
			Label: tmpRule.Label || '',
			Roles: (tmpRule.Audience && tmpRule.Audience.Roles) ? tmpRule.Audience.Roles.slice() : [],
			Values: Array.isArray(tmpValues) ? tmpValues.map(String) : [ String(tmpValues) ],
			TargetKey: this._targetKey(tmpRule.Target),
			CustomApp: (tmpRule.Target && tmpRule.Target.App) || 'LIMS',
			CustomRoute: (tmpRule.Target && tmpRule.Target.Route) || '',
			Extra: { Audience: Object.assign({}, tmpRule.Audience || {}), When: Object.assign({}, tmpRule.When || {}) },
		};
		this.render();
	}

	newRule()
	{
		this.state.EditingKey = '(new)';
		this.state.RoleSearch.Draft = '';
		this.state.Draft = { Label: '', Roles: [], Values: [], TargetKey: ENTITIES[this.state.Entity].Targets[0].Key, CustomApp: 'LIMS', CustomRoute: '', Extra: { Audience: {}, When: {} } };
		this.render();
	}

	cancelEdit()
	{
		this.state.EditingKey = '';
		this.state.Draft = null;
		this.render();
	}

	setDraft(pField, pValue)
	{
		const tmpDraft = this.state.Draft;
		if (!tmpDraft)
		{
			return;
		}
		tmpDraft[pField] = pValue;
		if (pField === 'TargetKey')
		{
			this.render();
		}
	}

	toggleDraftList(pField, pValue)
	{
		const tmpDraft = this.state.Draft;
		if (!tmpDraft || !Array.isArray(tmpDraft[pField]))
		{
			return;
		}
		const tmpIndex = tmpDraft[pField].indexOf(pValue);
		if (tmpIndex >= 0)
		{
			tmpDraft[pField].splice(tmpIndex, 1);
		}
		else
		{
			tmpDraft[pField].push(pValue);
		}
	}

	/**
	 * @param {Object} pDraft
	 * @return {{ Rule?: DestinationRule, Error?: string }}
	 */
	buildRule(pDraft)
	{
		const tmpEntity = ENTITIES[this.state.Entity];
		const tmpLabel = String(pDraft.Label || '').trim();
		if (!tmpLabel)
		{
			return { Error: 'Give the rule a button label, e.g. “Open in LIMS”.' };
		}
		let tmpTarget = null;
		if (pDraft.TargetKey === CUSTOM_TARGET_KEY)
		{
			const tmpRoute = String(pDraft.CustomRoute || '').trim();
			if (!libNavigation.APPS[pDraft.CustomApp])
			{
				return { Error: 'Choose which app the custom destination opens.' };
			}
			if (!tmpRoute.startsWith('#/'))
			{
				return { Error: 'A custom route starts with #/, e.g. #/Sample/{~D:Record.GUIDSample~}.' };
			}
			tmpTarget = { App: pDraft.CustomApp, Route: tmpRoute };
		}
		else
		{
			const tmpPreset = tmpEntity.Targets.find((pChoice) => pChoice.Key === pDraft.TargetKey);
			if (!tmpPreset)
			{
				return { Error: 'Choose where the rule sends people.' };
			}
			tmpTarget = JSON.parse(JSON.stringify(tmpPreset.Target));
		}
		const tmpAudience = Object.assign({}, (pDraft.Extra && pDraft.Extra.Audience) || {});
		if (pDraft.Roles.length)
		{
			tmpAudience.Roles = pDraft.Roles.slice();
		}
		else
		{
			delete tmpAudience.Roles;
		}
		const tmpWhen = Object.assign({}, (pDraft.Extra && pDraft.Extra.When) || {});
		const tmpAddress = tmpEntity.Conditions[0].Address;
		const tmpValues = (Array.isArray(pDraft.Values) ? pDraft.Values : String(pDraft.Values || '').split(',')).map((pValue) => String(pValue).trim()).filter(Boolean);
		if (tmpValues.length)
		{
			tmpWhen[tmpAddress] = tmpValues;
		}
		else
		{
			delete tmpWhen[tmpAddress];
		}
		/** @type {DestinationRule} */
		const tmpRule = { Label: tmpLabel, Target: tmpTarget };
		if (Object.keys(tmpAudience).length)
		{
			tmpRule.Audience = tmpAudience;
		}
		if (Object.keys(tmpWhen).length)
		{
			tmpRule.When = tmpWhen;
		}
		return { Rule: tmpRule };
	}

	applyDraft()
	{
		const tmpState = this.state;
		const tmpBuilt = this.buildRule(tmpState.Draft || {});
		if (tmpBuilt.Error)
		{
			tmpState.Error = tmpBuilt.Error;
			this.render();
			return;
		}
		const tmpRules = this.currentRules();
		let tmpKey = tmpState.EditingKey;
		if (tmpKey === '(new)' || !tmpRules[tmpKey])
		{
			const tmpBase = tmpBuilt.Rule.Label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'rule';
			tmpKey = tmpBase;
			for (let i = 2; tmpRules[tmpKey] || this.isPlatformRule(tmpKey); i++)
			{
				tmpKey = `${tmpBase}-${i}`;
			}
			tmpBuilt.Rule.Order = Number.MAX_SAFE_INTEGER;
		}
		else
		{
			tmpBuilt.Rule.Order = tmpRules[tmpKey].Order;
			if (tmpRules[tmpKey].Enabled === false)
			{
				tmpBuilt.Rule.Enabled = false;
			}
		}
		tmpRules[tmpKey] = tmpBuilt.Rule;
		this._renumber(this.customerRules());
		tmpState.Error = '';
		tmpState.EditingKey = '';
		tmpState.Draft = null;
		this._markDirty();
		this.render();
	}

	// --- Save -----------------------------------------------------------------------------------------------

	async save()
	{
		const tmpState = this.state;
		const tmpEntities = Object.keys(tmpState.Dirty).filter((pEntity) => tmpState.Dirty[pEntity]);
		if (tmpState.Saving || tmpEntities.length === 0)
		{
			return;
		}
		tmpState.Saving = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			for (const tmpEntity of tmpEntities)
			{
				const tmpResult = await this._postJSON(`Configuration/Put/EntityDestinations/${tmpEntity}/Customer/${Number(tmpState.TargetCustomerID)}`, { Config: tmpState.Rules[tmpEntity] || {} });
				if (tmpResult.error || (tmpResult.result && tmpResult.result.Error))
				{
					throw new Error((tmpResult.error && tmpResult.error.message) || (tmpResult.result && tmpResult.result.Error) || String(tmpResult.error));
				}
				tmpState.Dirty[tmpEntity] = false;
			}
			tmpState.Message = `Saved. Scanned labels and links for ${tmpState.TargetCustomerName || 'this customer'} follow these rules from now on.`;
		}
		catch (pError)
		{
			tmpState.Error = `Save failed: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Saving = false;
			this.render();
		}
	}

	// --- Preview --------------------------------------------------------------------------------------------

	// --- Role picker (a customer can have hundreds of roles, so they are searched, not listed) --------------

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @return {Array<string>} the chosen role hashes for the rule being edited, or for the preview
	 */
	_chosenRoles(pContext)
	{
		if (pContext === 'Draft')
		{
			return (this.state.Draft && Array.isArray(this.state.Draft.Roles)) ? this.state.Draft.Roles : [];
		}
		return this.state.PreviewRoles;
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pText
	 * @return {{ Matches: Array<{ Hash: string, Name: string }>, More: number }} roles not yet chosen whose name contains the text
	 */
	findRoles(pContext, pText)
	{
		const tmpChosen = this._chosenRoles(pContext);
		const tmpNeedle = String(pText || '').trim().toLowerCase();
		const tmpAll = this.state.Roles.filter((pRole) => !tmpChosen.includes(pRole.Hash) && (!tmpNeedle || pRole.Name.toLowerCase().includes(tmpNeedle)));
		return { Matches: tmpAll.slice(0, ROLE_SUGGESTION_LIMIT), More: Math.max(tmpAll.length - ROLE_SUGGESTION_LIMIT, 0) };
	}

	/**
	 * Show the matching roles under the search box, without redrawing the box being typed in.
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pText
	 */
	searchRoles(pContext, pText)
	{
		this.state.RoleSearch[pContext] = String(pText || '');
		if (typeof document !== 'undefined' && document.getElementById(`EDC-RoleSuggest-${pContext}`))
		{
			this.pict.ContentAssignment.assignContent(`#EDC-RoleSuggest-${pContext}`, this.renderRoleSuggestionsHTML(pContext));
		}
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pHash
	 */
	addRole(pContext, pHash)
	{
		const tmpChosen = this._chosenRoles(pContext);
		if (!tmpChosen.includes(pHash))
		{
			tmpChosen.push(pHash);
		}
		this.state.RoleSearch[pContext] = '';
		this.render();
		if (typeof document !== 'undefined' && document.getElementById(`EDC-RoleSearch-${pContext}`))
		{
			document.getElementById(`EDC-RoleSearch-${pContext}`).focus();
		}
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pHash
	 */
	dropRole(pContext, pHash)
	{
		const tmpChosen = this._chosenRoles(pContext);
		const tmpIndex = tmpChosen.indexOf(pHash);
		if (tmpIndex >= 0)
		{
			tmpChosen.splice(tmpIndex, 1);
		}
		this.render();
	}

	setPreviewValue(pValue)
	{
		this.state.PreviewValue = String(pValue || '');
		this.render();
	}

	/**
	 * Resolve the entity's current (unsaved) rules for an example record and the chosen roles.
	 * @return {ReturnType<typeof libNavigation.resolveDestinations>}
	 */
	preview()
	{
		const tmpState = this.state;
		const tmpEntity = ENTITIES[tmpState.Entity];
		const tmpRecord = Object.assign({}, tmpEntity.Example);
		const tmpAddress = tmpEntity.Conditions[0].Address.replace(/^Record\./, '');
		if (tmpState.PreviewValue)
		{
			tmpRecord[tmpAddress] = tmpState.PreviewValue;
		}
		const tmpRoles = tmpState.Roles.filter((pRole) => tmpState.PreviewRoles.includes(pRole.Hash));
		const tmpEnvironment = libHosts.getEnvironmentFromHostname((typeof window !== 'undefined' && window.location) ? window.location.hostname : '');
		return libNavigation.resolveDestinations({ Rules: this.currentRules(), Data: { Record: tmpRecord, Document: (tmpState.Entity === 'Document') ? tmpRecord : undefined, Session: { UserRoles: tmpRoles } }, From: 'links', Environment: tmpEnvironment });
	}

	// --- Rendering ------------------------------------------------------------------------------------------

	/**
	 * @param {DestinationRule} pRule
	 * @return {string} the rule as a sentence: who, when, where
	 */
	describeRule(pRule)
	{
		const tmpState = this.state;
		const tmpEntity = ENTITIES[tmpState.Entity];
		const tmpRoleNames = ((pRule.Audience && pRule.Audience.Roles) || []).map((pHash) => (tmpState.Roles.find((pRole) => pRole.Hash === pHash) || { Name: pHash }).Name);
		const tmpWho = tmpRoleNames.length ? tmpRoleNames.join(', ') : 'Everyone';
		const tmpConditions = Object.entries(pRule.When || {}).map(([ pAddress, pValues ]) =>
		{
			const tmpCondition = tmpEntity.Conditions.find((pCandidate) => pCandidate.Address === pAddress);
			const tmpNames = (Array.isArray(pValues) ? pValues : [ pValues ]).map((pValue) => ((tmpCondition && tmpCondition.Values === 'Statuses') ? ((tmpState.Statuses.find((pStatus) => pStatus.Hash === pValue) || { Name: pValue }).Name) : pValue));
			return `${(tmpCondition ? tmpCondition.Label : pAddress).toLowerCase()} is ${tmpNames.join(' or ')}`;
		});
		const tmpPreset = tmpEntity.Targets.find((pChoice) => JSON.stringify(pChoice.Target) === JSON.stringify(pRule.Target || {}));
		const tmpWhere = tmpPreset ? tmpPreset.Label : `${(pRule.Target && pRule.Target.App) || '?'} ${(pRule.Target && pRule.Target.Route) || ''}`;
		return `${this._esc(tmpWho)}${tmpConditions.length ? `, when ${this._esc(tmpConditions.join(' and '))}` : ''} → <b>${this._esc(tmpWhere)}</b>`;
	}

	render()
	{
		const tmpContainer = (typeof document !== 'undefined') ? document.getElementById('EDC-Detail') : null;
		const tmpHTML = this.renderHTML();
		if (tmpContainer)
		{
			this.pict.ContentAssignment.assignContent('#EDC-Detail', tmpHTML);
		}
		return tmpHTML;
	}

	/** @return {string} */
	renderHTML()
	{
		const tmpState = this.state;
		if (!this.can())
		{
			return '<div class="edc-empty">You don’t have the “Configure where records open” entitlement.</div>';
		}
		if (tmpState.Loading)
		{
			return '<div class="edc-empty"><i class="fas fa-spinner fa-spin"></i> Loading…</div>';
		}
		const tmpEntity = ENTITIES[tmpState.Entity];
		const tmpCustomer = (this.isSuperUser() && tmpState.Customers.length)
			? `<select class="edc-select" onchange="_Pict.providers.EntityDestinationsConfig.selectCustomer(this.value)">${tmpState.Customers.map((pCustomer) => `<option value="${Number(pCustomer.IDCustomer)}" ${Number(pCustomer.IDCustomer) === Number(tmpState.TargetCustomerID) ? 'selected' : ''}>${this._esc(pCustomer.Name)}</option>`).join('')}</select>`
			: `<span class="edc-customer">${this._esc(tmpState.TargetCustomerName)}</span>`;
		const tmpTabs = Object.entries(ENTITIES).map(([ pKey, pEntity ]) => `<button class="edc-tab ${pKey === tmpState.Entity ? 'is-active' : ''}" onclick="_Pict.providers.EntityDestinationsConfig.setEntity('${pKey}')">${this._esc(pEntity.Label)}${tmpState.Dirty[pKey] ? ' •' : ''}</button>`).join('');
		const tmpOrdered = this.orderedRules();
		const tmpOwnKeys = this.customerRules().map(([ pKey ]) => pKey);
		const tmpRows = tmpOrdered.map(([ pKey, pRule ]) =>
		{
			const tmpKeyArg = this._esc(JSON.stringify(pKey));
			if (this.isPlatformRule(pKey))
			{
				return `<div class="edc-rule is-platform ${pRule.Enabled === false ? 'is-off' : ''}">
					<div class="edc-rule-order"></div>
					<div class="edc-rule-body">
						<div class="edc-rule-label">${this._esc(pRule.Label)} <span class="edc-badge" title="Set for every customer; tried after this customer’s own rules">Platform default</span>${pRule.Enabled === false ? ' <span class="edc-off">Off for this customer</span>' : ''}</div>
						<div class="edc-rule-sentence">${this.describeRule(pRule)}</div>
					</div>
					<div class="edc-rule-actions">
						<button class="edc-btn" onclick='_Pict.providers.EntityDestinationsConfig.toggleRule(${tmpKeyArg})'>${pRule.Enabled === false ? 'Turn on for this customer' : 'Turn off for this customer'}</button>
					</div>
				</div>`;
			}
			const tmpIndex = tmpOwnKeys.indexOf(pKey);
			return `<div class="edc-rule ${pRule.Enabled === false ? 'is-off' : ''}">
				<div class="edc-rule-order">
					<button class="edc-mv" title="Try earlier" ${tmpIndex === 0 ? 'disabled' : ''} onclick='_Pict.providers.EntityDestinationsConfig.moveRule(${tmpKeyArg}, -1)'><i class="fas fa-chevron-up"></i></button>
					<button class="edc-mv" title="Try later" ${tmpIndex === tmpOwnKeys.length - 1 ? 'disabled' : ''} onclick='_Pict.providers.EntityDestinationsConfig.moveRule(${tmpKeyArg}, 1)'><i class="fas fa-chevron-down"></i></button>
				</div>
				<div class="edc-rule-body">
					<div class="edc-rule-label">${this._esc(pRule.Label)}${pRule.Enabled === false ? ' <span class="edc-off">Off</span>' : ''}</div>
					<div class="edc-rule-sentence">${this.describeRule(pRule)}</div>
				</div>
				<div class="edc-rule-actions">
					<button class="edc-btn" onclick='_Pict.providers.EntityDestinationsConfig.editRule(${tmpKeyArg})'>Edit</button>
					<button class="edc-btn" onclick='_Pict.providers.EntityDestinationsConfig.toggleRule(${tmpKeyArg})'>${pRule.Enabled === false ? 'Turn on' : 'Turn off'}</button>
					<button class="edc-btn is-danger" onclick='_Pict.providers.EntityDestinationsConfig.removeRule(${tmpKeyArg})'>Remove</button>
				</div>
			</div>`;
		}).join('');
		const tmpList = tmpRows || `<div class="edc-note">No rules for ${this._esc(tmpEntity.Label.toLowerCase())} yet, so scanned labels and links open where they always have.</div>`;
		const tmpDirty = Object.values(tmpState.Dirty).some(Boolean);
		return `
			<div class="edc-field"><label class="edc-field-label">Customer</label>${tmpCustomer}</div>
			${tmpState.Message ? `<div class="edc-msg">${this._esc(tmpState.Message)}</div>` : ''}
			${tmpState.Error ? `<div class="edc-error">${this._esc(tmpState.Error)}</div>` : ''}
			<div class="edc-tabs">${tmpTabs}</div>
			<p class="edc-help">Rules are tried from the top. The first one that fits the person and the record decides where a scanned label or emailed link opens; the others are offered as alternatives. Platform defaults apply to every customer and are tried after this customer’s own rules.</p>
			<div class="edc-rules">${tmpList}</div>
			${tmpState.Draft ? this.renderEditorHTML() : `<button class="edc-btn" onclick="_Pict.providers.EntityDestinationsConfig.newRule()"><i class="fas fa-plus"></i> Add a rule</button>`}
			<div class="edc-savebar"><button class="edc-save" ${(!tmpDirty || tmpState.Saving) ? 'disabled' : ''} onclick="_Pict.providers.EntityDestinationsConfig.save()">${tmpState.Saving ? 'Saving…' : 'Save changes'}</button>${tmpDirty ? '<span class="edc-unsaved">Unsaved changes</span>' : ''}</div>
			${this.renderPreviewHTML()}`;
	}

	/** @return {string} */
	renderEditorHTML()
	{
		const tmpState = this.state;
		const tmpDraft = tmpState.Draft;
		const tmpEntity = ENTITIES[tmpState.Entity];
		const tmpCondition = tmpEntity.Conditions[0];
		const tmpValues = (tmpCondition.Values === 'Statuses')
			? tmpState.Statuses.map((pStatus) => `<label class="edc-chip"><input type="checkbox" ${tmpDraft.Values.includes(pStatus.Hash) ? 'checked' : ''} onchange='_Pict.providers.EntityDestinationsConfig.toggleDraftList("Values", ${this._esc(JSON.stringify(pStatus.Hash))})'> ${this._esc(pStatus.Name)}</label>`).join('')
			: `<input class="edc-input" value="${this._esc(tmpDraft.Values.join(', '))}" placeholder="Any; or a comma-separated list" onchange="_Pict.providers.EntityDestinationsConfig.setDraft('Values', this.value.split(','))">`;
		const tmpTargets = tmpEntity.Targets.concat([ { Key: CUSTOM_TARGET_KEY, Label: 'Another page (advanced)' } ]).map((pChoice) => `<option value="${pChoice.Key}" ${tmpDraft.TargetKey === pChoice.Key ? 'selected' : ''}>${this._esc(pChoice.Label)}</option>`).join('');
		const tmpCustom = (tmpDraft.TargetKey === CUSTOM_TARGET_KEY)
			? `<div class="edc-field"><label class="edc-field-label">App and page</label>
				<select class="edc-select edc-narrow" onchange="_Pict.providers.EntityDestinationsConfig.setDraft('CustomApp', this.value)">${Object.keys(libNavigation.APPS).map((pApp) => `<option ${tmpDraft.CustomApp === pApp ? 'selected' : ''}>${pApp}</option>`).join('')}</select>
				<input class="edc-input edc-route" value="${this._esc(tmpDraft.CustomRoute)}" placeholder="#/Sample/{~D:Record.GUIDSample~}" onchange="_Pict.providers.EntityDestinationsConfig.setDraft('CustomRoute', this.value)">
				<div class="edc-hint">Use <code>{~D:Record.Field~}</code> for values from the scanned record.</div></div>`
			: '';
		return `<div class="edc-editor">
			<div class="edc-field"><label class="edc-field-label">Button label</label><input class="edc-input" value="${this._esc(tmpDraft.Label)}" placeholder="Open in LIMS" onchange="_Pict.providers.EntityDestinationsConfig.setDraft('Label', this.value)"></div>
			<div class="edc-field"><label class="edc-field-label">Who (leave empty for everyone)</label>${this.renderRolePickerHTML('Draft', 'Everyone')}</div>
			<div class="edc-field"><label class="edc-field-label">When ${this._esc(tmpCondition.Label.toLowerCase())} is (leave empty for any)</label><div class="edc-chips">${tmpValues}</div></div>
			<div class="edc-field"><label class="edc-field-label">Open</label><select class="edc-select" onchange="_Pict.providers.EntityDestinationsConfig.setDraft('TargetKey', this.value)">${tmpTargets}</select></div>
			${tmpCustom}
			<div class="edc-editor-actions"><button class="edc-save" onclick="_Pict.providers.EntityDestinationsConfig.applyDraft()">Keep this rule</button> <button class="edc-btn" onclick="_Pict.providers.EntityDestinationsConfig.cancelEdit()">Cancel</button></div>
		</div>`;
	}

	/**
	 * The chosen roles as removable tags, and a search box that lists matching roles to add.
	 * @param {'Draft'|'Preview'} pContext
	 * @param {string} pNoneLabel - Shown when no role is chosen.
	 * @return {string}
	 */
	renderRolePickerHTML(pContext, pNoneLabel)
	{
		const tmpState = this.state;
		if (!tmpState.Roles.length)
		{
			return '<span class="edc-hint">No roles found for this customer.</span>';
		}
		const tmpTags = this._chosenRoles(pContext).map((pHash) =>
		{
			const tmpName = (tmpState.Roles.find((pRole) => pRole.Hash === pHash) || { Name: pHash }).Name;
			return `<span class="edc-tag">${this._esc(tmpName)}<button type="button" class="edc-tag-x" title="Remove" onclick='_Pict.providers.EntityDestinationsConfig.dropRole("${pContext}", ${this._esc(JSON.stringify(pHash))})'>×</button></span>`;
		}).join('');
		return `<div class="edc-picker">
			<div class="edc-tags">${tmpTags || `<span class="edc-hint">${this._esc(pNoneLabel)}</span>`}</div>
			<input id="EDC-RoleSearch-${pContext}" class="edc-input" autocomplete="off" placeholder="Find a role to add (${tmpState.Roles.length} roles)" value="${this._esc(tmpState.RoleSearch[pContext])}" oninput="_Pict.providers.EntityDestinationsConfig.searchRoles('${pContext}', this.value)" onfocus="_Pict.providers.EntityDestinationsConfig.searchRoles('${pContext}', this.value)">
			<div id="EDC-RoleSuggest-${pContext}" class="edc-suggest">${tmpState.RoleSearch[pContext] ? this.renderRoleSuggestionsHTML(pContext) : ''}</div>
		</div>`;
	}

	/**
	 * @param {'Draft'|'Preview'} pContext
	 * @return {string}
	 */
	renderRoleSuggestionsHTML(pContext)
	{
		const tmpFound = this.findRoles(pContext, this.state.RoleSearch[pContext]);
		if (!tmpFound.Matches.length)
		{
			return '<span class="edc-hint">No roles match.</span>';
		}
		const tmpButtons = tmpFound.Matches.map((pRole) => `<button type="button" class="edc-suggestion" onclick='_Pict.providers.EntityDestinationsConfig.addRole("${pContext}", ${this._esc(JSON.stringify(pRole.Hash))})'>${this._esc(pRole.Name)}</button>`).join('');
		return `${tmpButtons}${tmpFound.More ? `<span class="edc-hint">and ${tmpFound.More} more; keep typing to narrow it down.</span>` : ''}`;
	}

	/** @return {string} */
	renderPreviewHTML()
	{
		const tmpState = this.state;
		const tmpEntity = ENTITIES[tmpState.Entity];
		const tmpCondition = tmpEntity.Conditions[0];
		const tmpValue = (tmpCondition.Values === 'Statuses')
			? `<select class="edc-select edc-narrow" onchange="_Pict.providers.EntityDestinationsConfig.setPreviewValue(this.value)"><option value="">Any</option>${tmpState.Statuses.map((pStatus) => `<option value="${this._esc(pStatus.Hash)}" ${tmpState.PreviewValue === pStatus.Hash ? 'selected' : ''}>${this._esc(pStatus.Name)}</option>`).join('')}</select>`
			: `<input class="edc-input edc-narrow" value="${this._esc(tmpState.PreviewValue)}" onchange="_Pict.providers.EntityDestinationsConfig.setPreviewValue(this.value)">`;
		let tmpResultHTML = '';
		try
		{
			const tmpResult = this.preview();
			const tmpDescribe = (pDestination) => this._esc(pDestination.Label) + (pDestination.URL ? ` <code>${this._esc(pDestination.URL)}</code>` : '');
			tmpResultHTML = tmpResult.Primary
				? `<div><b>Opens:</b> ${tmpDescribe(tmpResult.Primary)}</div>${tmpResult.Alternatives.length ? `<div><b>Also offered:</b> ${tmpResult.Alternatives.map(tmpDescribe).join('; ')}</div>` : ''}`
				: '<div><b>No rule fits</b>, so the label opens where it always has.</div>';
			tmpResultHTML += `<details class="edc-explain"><summary>Why</summary><ul>${tmpResult.Explain.map((pLine) => `<li>${this._esc(pLine)}</li>`).join('')}</ul></details>`;
		}
		catch (pError)
		{
			tmpResultHTML = `<div class="edc-error">Preview unavailable: ${this._esc((pError && pError.message) || pError)}</div>`;
		}
		return `<div class="edc-preview">
			<div class="edc-field-label">Try it: who goes where</div>
			<div class="edc-field"><label class="edc-field-label">A person with these roles</label>${this.renderRolePickerHTML('Preview', 'No roles')}</div>
			<div class="edc-field"><label class="edc-field-label">${this._esc(tmpCondition.Label)}</label>${tmpValue}</div>
			<div class="edc-preview-result">${tmpResultHTML}</div>
		</div>`;
	}
}

module.exports = EntityDestinationsConfigProvider;
module.exports.ENTITIES = ENTITIES;
module.exports.default_configuration =
{
	ProviderIdentifier: 'EntityDestinationsConfig',
	AutoInitialize: true,
	AutoInitializeOrdinal: 232,
};

},{"headlight-dynamic-inputs-bundle/source/providers/_VocabularySelectorMap.js":171,"headlight-entity-navigation":7,"headlight-qrcode/source/Headlight-QRCode-Hosts.js":16,"pict-provider":845}],1339:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');

/**
 * Entity-metadata section — the shared "append the per-customer metadata form UNDERNEATH the Overview's field groups"
 * behavior, factored out so ANY workspace provider can mix it in (not just the stock EntityMetadataWorkspaceProvider
 * below — e.g. CustomerWorkspace-Provider, which has its own bespoke tabs, calls renderMetadataSection() from its own
 * _renderOverview override).
 *
 * The values live on the entity's blob field; the field SHAPE comes from the per-customer EntityMetadata/<Entity>
 * ManifestSchema (SubType = Entity.Name), rendered read-only with an inline Edit/Save by the EntityMetadataForm
 * singleton provider. See [[config-app-entity-metadata]].
 *
 * A workspace opts in by setting, in its workspace-config:
 *   MetadataBlob: { column: '<blob field as the Meadow API names it>', label: '<section heading>', encoding?: 'object' | 'string' }
 * (`column` is the API field name — which can differ from the DB column; `encoding` is only needed when the field can
 * be empty on first save, since a populated record's shape is mirrored automatically.)
 */

const META_HOST_SELECTOR = '#EMW-MetaHost';

/** Append (once) the metadata group to the Overview body + (re)mount the form. Safe to call on every Overview paint. */
function renderMetadataSection(pProvider, pBodySel)
{
	const tmpBlob = pProvider.workspaceConfig && pProvider.workspaceConfig.MetadataBlob;
	const tmpCA = pProvider.pict.ContentAssignment;
	const tmpEl = tmpCA.getElement(pBodySel);
	if (!tmpBlob || !tmpBlob.column || !tmpEl || !tmpEl[0] || !pProvider._record || (typeof document === 'undefined')) { return; }
	// super._renderOverview replaced the body, so re-append our metadata group whenever it is missing.
	if (!tmpEl[0].querySelector(META_HOST_SELECTOR))
	{
		const tmpGroup = document.createElement('div');
		tmpGroup.className = 'pw-group';
		tmpGroup.innerHTML = `<div class="pw-group-head">${pProvider._esc(tmpBlob.label || 'Custom Properties')}</div><div id="EMW-MetaHost"></div>`;
		tmpEl[0].appendChild(tmpGroup);
	}
	_mountMetadata(pProvider, tmpBlob);
}

function _mountMetadata(pProvider, pBlob)
{
	const tmpEMF = pProvider.pict.providers.EntityMetadataForm;
	if (!pBlob || !tmpEMF || !pProvider._record || (typeof tmpEMF.openWorkspaceMetadata !== 'function')) { return; }
	if (!pProvider.pict.ContentAssignment.getElement(META_HOST_SELECTOR).length) { return; }   // host not on screen
	tmpEMF.openWorkspaceMetadata({ entityType: pProvider.entityName, blobColumn: pBlob.column, encoding: pBlob.encoding, record: pProvider._record, idField: pProvider.idField, idCustomer: pProvider._record.IDCustomer, host: META_HOST_SELECTOR });
}

/**
 * EntityMetadataWorkspace-Provider — a REUSABLE workspace ProviderClass whose ONLY customization is to render the
 * configured metadata blob underneath the Overview's field groups. Workspaces whose Overview needs nothing else opt
 * in simply with `ProviderClass: require('../providers/EntityMetadataWorkspace-Provider.js')` + a MetadataBlob.
 */
class EntityMetadataWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	/** Overview = the base's field groups, then the metadata section appended underneath (with the record). */
	_renderOverview(pBodySel)
	{
		super._renderOverview(pBodySel);
		renderMetadataSection(this, pBodySel);
	}
}

EntityMetadataWorkspaceProvider.default_configuration = { ProviderIdentifier: 'EntityMetadataWorkspace' };

module.exports = EntityMetadataWorkspaceProvider;
module.exports.default_configuration = EntityMetadataWorkspaceProvider.default_configuration;
module.exports.renderMetadataSection = renderMetadataSection;

},{"pict-section-workspace":1049}],1340:[function(require,module,exports){

const libPictProvider = require('pict-provider');

// Read-only diagnostics: the recent Headlight WEB error log. The field/portal apps POST client-side errors
// as `Artifact` rows of ArtifactType 'HLWebErrorLog' (the error JSON lives in the parsed `Datum` column:
// Datum.Error.{message,stack,cause} + Datum.Payload.{name,hash,IDProject,IDUser}). This page loads the last
// ~30 days, charts them per day, and lists them in a filterable table with an expandable JSON payload.
// Reads only — no writes. Mirrors the bespoke-page pattern (provider derives AppData, view paints).

const WINDOW_DAYS = 30;
const FETCH_CAP = 2000;
const TABLE_CAP = 200;

class ErrorLogViewerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._rows = [];
		this._loaded = false;
		this._appFilter = 'all';
		this._textFilter = '';
		this._expanded = {};
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	// --- Loading ---

	_sinceDate()
	{
		const tmpDate = new Date(Date.now() - (WINDOW_DAYS - 1) * 24 * 3600 * 1000);
		return tmpDate.toISOString().slice(0, 10);
	}

	async loadAsync()
	{
		const tmpState = this.viewState;
		tmpState.Loading = true;
		tmpState.Message = '';
		this._render();
		try
		{
			const tmpSince = this._sinceDate();
			const tmpRows = await this._getJSON(`Artifacts/FilteredTo/FBV~ArtifactType~EQ~HLWebErrorLog~FBV~CreateDate~GE~${tmpSince}/0/${FETCH_CAP}`);
			this._rows = (Array.isArray(tmpRows) ? tmpRows : []).map((pRow) => this._parseRow(pRow)).filter((pRow) => pRow);
			// Newest first.
			this._rows.sort((a, b) => b.Time - a.Time);
			this._loaded = true;
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			this._loaded = true;
			tmpState.Loading = false;
			tmpState.Message = `Could not load the error log: ${pError.message || pError}. You may not have permission to read diagnostic artifacts.`;
			tmpState.MessageClass = 'is-warning';
			this._render();
		}
	}

	reload()
	{
		this._expanded = {};
		this.loadAsync();
	}

	/** Normalize an Artifact row into a flat display record (Datum may be an object OR a JSON string). */
	_parseRow(pRow)
	{
		let tmpDatum = pRow.Datum;
		if (typeof tmpDatum === 'string')
		{
			try { tmpDatum = JSON.parse(tmpDatum); }
			catch (pError) { tmpDatum = null; }
		}
		const tmpError = (tmpDatum && tmpDatum.Error) || {};
		const tmpPayload = (tmpDatum && tmpDatum.Payload) || {};
		const tmpTime = new Date(pRow.CreateDate);
		return {
			ID: pRow.IDArtifact,
			Time: Number.isNaN(tmpTime.getTime()) ? 0 : tmpTime.getTime(),
			DateRaw: pRow.CreateDate,
			DayKey: this._localDayKey(tmpTime),
			App: String(tmpPayload.name || tmpPayload.hash || '(unknown)'),
			Message: String(tmpError.message || '(no message)'),
			Stack: tmpError.stack ? String(tmpError.stack) : '',
			Cause: (tmpError.cause != null) ? String(tmpError.cause) : '',
			IDProject: tmpPayload.IDProject != null ? tmpPayload.IDProject : null,
			IDUser: (tmpPayload.IDUser != null) ? tmpPayload.IDUser : pRow.CreatingIDUser,
			Datum: tmpDatum,
		};
	}

	_localDayKey(pDate)
	{
		if (!(pDate instanceof Date) || Number.isNaN(pDate.getTime())) { return ''; }
		const tmpYear = pDate.getFullYear();
		const tmpMonth = String(pDate.getMonth() + 1).padStart(2, '0');
		const tmpDay = String(pDate.getDate()).padStart(2, '0');
		return `${tmpYear}-${tmpMonth}-${tmpDay}`;
	}

	// --- Filtering ---

	get apps()
	{
		const tmpCounts = {};
		this._rows.forEach((pRow) => { tmpCounts[pRow.App] = (tmpCounts[pRow.App] || 0) + 1; });
		return Object.keys(tmpCounts).sort((a, b) => tmpCounts[b] - tmpCounts[a]);
	}

	/** Rows after the app filter only (drives the chart + summary). */
	_appFilteredRows()
	{
		if (this._appFilter === 'all') { return this._rows; }
		return this._rows.filter((pRow) => pRow.App === this._appFilter);
	}

	/** Rows after app + free-text filter (drives the table). */
	_filteredRows()
	{
		const tmpText = this._textFilter.trim().toLowerCase();
		return this._appFilteredRows().filter((pRow) =>
		{
			if (!tmpText) { return true; }
			return (pRow.Message.toLowerCase().indexOf(tmpText) >= 0)
				|| (pRow.App.toLowerCase().indexOf(tmpText) >= 0)
				|| (pRow.Stack.toLowerCase().indexOf(tmpText) >= 0);
		});
	}

	setAppFilter(pApp)
	{
		this._appFilter = pApp || 'all';
		this._render();
	}

	/** Free-text filter — repaint ONLY the table host so the input keeps focus + caret. */
	setTextFilter(pValue)
	{
		this._textFilter = pValue || '';
		this.deriveRenderState();
		const tmpView = this.pict.views.ErrorLogViewer;
		if (tmpView && (typeof tmpView.syncTable === 'function')) { tmpView.syncTable(); }
	}

	toggleRow(pID)
	{
		if (this._expanded[pID]) { delete this._expanded[pID]; }
		else { this._expanded[pID] = true; }
		this.deriveRenderState();
		const tmpView = this.pict.views.ErrorLogViewer;
		if (tmpView && (typeof tmpView.syncTable === 'function')) { tmpView.syncTable(); }
	}

	// --- Display formatting ---

	_formatTime(pRow)
	{
		if (!pRow.Time) { return '—'; }
		const tmpDate = new Date(pRow.Time);
		return tmpDate.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
	}

	_appClass(pApp)
	{
		switch (pApp)
		{
			case 'fieldbook': return 'elv-app-fieldbook';
			case 'portal': return 'elv-app-portal';
			case 'tracker': return 'elv-app-tracker';
			default: return 'elv-app-unknown';
		}
	}

	_shortDayLabel(pDayKey)
	{
		// pDayKey is 'YYYY-MM-DD'; render as 'Jun 3' from the parts (no tz shift).
		const tmpParts = String(pDayKey).split('-');
		if (tmpParts.length !== 3) { return pDayKey; }
		const tmpMonths = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
		return `${tmpMonths[Number(tmpParts[1]) - 1] || ''} ${Number(tmpParts[2])}`;
	}

	// --- Render-state ---

	get viewState()
	{
		if (!this.pict.AppData.ErrorLogViewer)
		{
			this.pict.AppData.ErrorLogViewer =
			{
				Loading: false, Message: '', MessageClass: '',
				LoadingSlot: [], MessageSlot: [], BodySlot: [],
				WindowLabel: `Last ${WINDOW_DAYS} days`,
				Total: 0, AppChips: [], FilterButtons: [], TextFilter: '',
				Bars: [], AxisLabels: [], ChartMaxLabel: '',
				Rows: [], TableEmptySlot: [], TableCountLabel: '',
			};
		}
		return this.pict.AppData.ErrorLogViewer;
	}

	deriveRenderState()
	{
		const tmpState = this.viewState;
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message, MessageClass: tmpState.MessageClass || 'is-info' } ] : [];
		tmpState.WindowLabel = `Last ${WINDOW_DAYS} days`;
		tmpState.TextFilter = this._textFilter;

		if (tmpState.Loading)
		{
			tmpState.LoadingSlot = [ {} ];
			tmpState.BodySlot = [];
			return;
		}
		tmpState.LoadingSlot = [];
		tmpState.BodySlot = [ {} ];

		const tmpAppRows = this._appFilteredRows();
		tmpState.Total = tmpAppRows.length;

		// App filter buttons (All + each app) with counts.
		const tmpAppCounts = {};
		this._rows.forEach((pRow) => { tmpAppCounts[pRow.App] = (tmpAppCounts[pRow.App] || 0) + 1; });
		tmpState.FilterButtons = [ { Key: 'all', Label: 'All', Count: this._rows.length, ActiveClass: (this._appFilter === 'all') ? 'is-active' : '' } ]
			.concat(this.apps.map((pApp) => ({ Key: this._attrJsString(pApp), Label: this._escape(pApp), Count: tmpAppCounts[pApp], ActiveClass: (this._appFilter === pApp) ? 'is-active' : '' })));
		tmpState.AppChips = this.apps.map((pApp) => ({ Label: this._escape(pApp), Count: tmpAppCounts[pApp], AppClass: this._appClass(pApp) }));

		// Per-day bars across the window (continuous axis so gaps are visible).
		const tmpDayCounts = {};
		tmpAppRows.forEach((pRow) => { if (pRow.DayKey) { tmpDayCounts[pRow.DayKey] = (tmpDayCounts[pRow.DayKey] || 0) + 1; } });
		const tmpDays = [];
		for (let i = WINDOW_DAYS - 1; i >= 0; i--)
		{
			tmpDays.push(this._localDayKey(new Date(Date.now() - i * 24 * 3600 * 1000)));
		}
		const tmpMax = Math.max(1, ...tmpDays.map((pDay) => tmpDayCounts[pDay] || 0));
		tmpState.Bars = tmpDays.map((pDay, pIndex) =>
		{
			const tmpCount = tmpDayCounts[pDay] || 0;
			return {
				DayKey: pDay,
				Count: tmpCount,
				HeightPct: Math.round((tmpCount / tmpMax) * 100),
				Tooltip: `${this._shortDayLabel(pDay)}: ${tmpCount} error${tmpCount === 1 ? '' : 's'}`,
				MaxClass: (tmpCount === tmpMax && tmpCount > 0) ? 'is-max' : '',
				// Sparse axis labels (~every 6 days + the last day).
				AxisLabel: ((pIndex % 6 === 0) || (pIndex === WINDOW_DAYS - 1)) ? this._shortDayLabel(pDay) : '',
			};
		});
		tmpState.ChartMaxLabel = `peak ${tmpMax}/day`;

		// Table (capped; newest first).
		const tmpFiltered = this._filteredRows();
		const tmpShown = tmpFiltered.slice(0, TABLE_CAP);
		tmpState.Rows = tmpShown.map((pRow) =>
		{
			const tmpExpanded = !!this._expanded[pRow.ID];
			return {
				ID: pRow.ID,
				Time: this._formatTime(pRow),
				AppDisplay: this._escape(pRow.App),
				AppClass: this._appClass(pRow.App),
				Message: this._escape(pRow.Message),
				Context: this._escape(this._rowContext(pRow)),
				Chevron: tmpExpanded ? 'fa-chevron-down' : 'fa-chevron-right',
				RowClass: tmpExpanded ? 'is-expanded' : '',
				DetailSlot: tmpExpanded ? [ {
					Stack: this._escape(pRow.Stack || '(no stack trace)'),
					CauseSlot: pRow.Cause ? [ { Cause: this._escape(pRow.Cause) } ] : [],
					JSON: this._escape(this._safeJSON(pRow.Datum)),
				} ] : [],
			};
		});
		tmpState.TableEmptySlot = (tmpShown.length === 0) ? [ {} ] : [];
		tmpState.TableCountLabel = (tmpFiltered.length > tmpShown.length)
			? `Showing the first ${tmpShown.length} of ${tmpFiltered.length} matching errors`
			: `${tmpFiltered.length} error${tmpFiltered.length === 1 ? '' : 's'}`;
	}

	_rowContext(pRow)
	{
		const tmpParts = [];
		if (pRow.IDProject != null && pRow.IDProject !== 0) { tmpParts.push(`Project ${pRow.IDProject}`); }
		if (pRow.IDUser != null && pRow.IDUser !== 0) { tmpParts.push(`User ${pRow.IDUser}`); }
		return tmpParts.join(' · ') || '—';
	}

	_safeJSON(pValue)
	{
		try { return JSON.stringify(pValue, null, 2); }
		catch (pError) { return String(pValue); }
	}

	// Error-log payloads are CLIENT-submitted and routinely contain raw HTML (e.g. a serialized <select> in
	// the error cause). The pict `{~D:~}` macro inserts values as-is, so every error-derived string MUST be
	// HTML-escaped here before it reaches a template — both so the markup renders as literal text and so a
	// hostile payload can't inject script into this admin page.
	_escape(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** Escape a value that lands inside a single-quoted JS string inside a double-quoted HTML attribute. */
	_attrJsString(pValue)
	{
		const tmpJs = String(pValue == null ? '' : pValue).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
		return tmpJs.replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pChar]));
	}

	_render()
	{
		this.deriveRenderState();
		if (this.pict.views.ErrorLogViewer)
		{
			this.pict.views.ErrorLogViewer.render();
		}
	}
}

module.exports = ErrorLogViewerProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ErrorLogViewer',
	AutoInitialize: true,
	AutoInitializeOrdinal: 223,
};

},{"pict-provider":845}],1341:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');

/**
 * GroupComposition — the Composition + Members tabs of the Access workspace.
 *
 * A Permission Group is a Role with Type='PermissionGroup'; a Role composes groups (and other roles) via a
 * RoleEdge (Parent=this role, Child=the included group). The resolver inherits a parent's children's
 * permissions (api/permissions includeChildRoles). This provider:
 *   - Composition tab: lists the selected role/group's direct children (what it INCLUDES) + an add-child
 *     picker; create/remove a child = POST/DELETE a RoleEdge (with client-side dedup — the schema has no
 *     unique constraint).
 *   - Members tab: lists the USERS who hold the selected role/group — read-only. It resolves membership the
 *     same way the Home app does, via the Permissions "Users With Role" endpoint
 *     (Permissions/Users/With/Role/<id>/At/<Context>/Level), which folds in parent roles (anyone who inherits
 *     this role through a role that composes it) and does NOT cascade contexts. We query it once at the
 *     Customer level and once at the Project level, then tag each member with whether they hold the role at
 *     the User (customer-wide, UserRoleJoin) level or the Project (ProjectUserJoin / UserContextRole) level.
 *
 * Subject + customer come from the AccessWorkspace provider; this owns AppData.AccessWorkspace.Composition
 * (RoleEdges for the Composition tab) and AppData.AccessWorkspace.Membership (users for the Members tab).
 */
class GroupCompositionProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get workspace()
	{
		return this.pict.providers.AccessWorkspace;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get composition()
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.Composition)
		{
			tmpWorkspaceState.Composition =
			{
				SubjectID: 0, Loading: false, Loaded: false, Error: '', Saving: false, AddPickerValue: '',
				Children: [], Candidates: [],
				LoadingSlot: [], ErrorSlot: [], ChildrenSlot: [], ChildEmptySlot: [],
				AddSlot: [], CandidateOptions: [],
			};
		}
		return tmpWorkspaceState.Composition;
	}

	get membership()
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.Membership)
		{
			tmpWorkspaceState.Membership =
			{
				SubjectID: 0, Loading: false, Loaded: false, Error: '',
				Members: [], CountLabel: '',
				LoadingSlot: [], ErrorSlot: [], MembersSlot: [], MemberEmptySlot: [],
				// Bulk "add users to this role": a multi-select user picker writes ids here, then addMembersAsync
				// PUTs each assignment at the workspace's current context.
				AddUserIDs: [], AddSaving: false, AddError: '', AddNotice: '',
				AddSlot: [], AddErrorSlot: [], AddNoticeSlot: [], AddSavingSlot: [],
			};
		}
		return tmpWorkspaceState.Membership;
	}

	// --- REST ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			// The rest client exposes deleteEntity(entity, id) (there is no raw deleteJSON).
			const tmpMatch = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (tmpMatch)
			{
				this.restClient.deleteEntity(tmpMatch[1], tmpMatch[2], (pError, pBody) => pError ? reject(pError) : resolve(pBody));
				return;
			}
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((pResponse) =>
				{
					if (!pResponse.ok) { reject(new Error(`HTTP ${pResponse.status}`)); return; }
					pResponse.text().then((pText) => resolve(pText ? JSON.parse(pText) : {})).catch(() => resolve({}));
				})
				.catch(reject);
		});
	}

	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 2000;
		let tmpTotal = tmpCap;
		try
		{
			const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`);
			tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap);
		}
		catch (pError)
		{
			tmpTotal = tmpCap;
		}
		if (!tmpTotal)
		{
			return [];
		}
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	// --- Load ---

	/**
	 * Load the child RoleEdges (what this role/group INCLUDES) for the workspace's current role/group. No-op
	 * for a user subject.
	 * @param {Boolean} [pForce]
	 */
	async loadAsync(pForce)
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.SubjectRecord || tmpWorkspaceState.SubjectKind === 'user')
		{
			return;
		}
		const tmpID = Number(tmpWorkspaceState.SubjectID);
		const tmpComposition = this.composition;
		if (tmpComposition.Loaded && !pForce && tmpComposition.SubjectID === tmpID)
		{
			this._render();
			return;
		}
		tmpComposition.SubjectID = tmpID;
		tmpComposition.Loaded = false;
		tmpComposition.Error = '';
		tmpComposition.Loading = true;
		this._render();
		try
		{
			const tmpChildEdges = await this._getFilteredAll('RoleEdges', `FBV~ParentIDRole~EQ~${tmpID}~FBV~Deleted~EQ~0`);
			const tmpNameByID = this._roleNameMap();
			tmpComposition.Children = tmpChildEdges.map((pEdge) => this._edgeRow(pEdge, pEdge.ChildIDRole, tmpNameByID));
			tmpComposition.Loaded = true;
		}
		catch (pError)
		{
			tmpComposition.Error = `Could not load composition: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpComposition.Loading = false;
		this._render();
	}

	/**
	 * Load the USERS who hold the workspace's current role/group (the Members tab). No-op for a user subject.
	 *
	 * Mirrors the Home app: the Permissions "Users With Role" endpoint resolves membership WITH parent roles
	 * folded in (so anyone who inherits this role through a composing role is included) but does NOT cascade
	 * contexts. We ask it twice — once at the Customer level (customer-wide UserRoleJoin members) and once at
	 * the Project level (ProjectUserJoin + UserContextRole members across every project) — and merge the two,
	 * tagging each member with the level(s) at which they hold the role.
	 * @param {Boolean} [pForce]
	 */
	async loadMembersAsync(pForce)
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.SubjectRecord || tmpWorkspaceState.SubjectKind === 'user')
		{
			return;
		}
		const tmpID = Number(tmpWorkspaceState.SubjectID);
		const tmpMembership = this.membership;
		if (tmpMembership.Loaded && !pForce && tmpMembership.SubjectID === tmpID)
		{
			this._render();
			return;
		}
		tmpMembership.SubjectID = tmpID;
		tmpMembership.Loaded = false;
		tmpMembership.Error = '';
		tmpMembership.Loading = true;
		this._render();
		try
		{
			const tmpResults = await Promise.all(
				[
					this._getJSON(`Permissions/Users/With/Role/${tmpID}/At/Customer/Level`),
					this._getJSON(`Permissions/Users/With/Role/${tmpID}/At/Project/Level`),
				]);
			tmpMembership.Members = this._buildMembers(tmpResults[0], tmpResults[1], tmpID);
			tmpMembership.Loaded = true;
		}
		catch (pError)
		{
			tmpMembership.Error = `Could not load members: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpMembership.Loading = false;
		this._render();
	}

	/**
	 * Merge the customer-level + project-level "users with role" responses into one de-duplicated member list.
	 * Each user is keyed by IDUser and tagged AtUserLevel / AtProjectLevel; the project-level entry carries the
	 * count of distinct projects (from the endpoint's per-user ContextRoles[]). A member reached only through a
	 * composing role (FromRoles that is not the subject role) is annotated so the inheritance is visible.
	 * @param {Array} pUserLevelRows - response from .../At/Customer/Level
	 * @param {Array} pProjectLevelRows - response from .../At/Project/Level
	 * @param {Number} pSubjectID - the role/group being viewed
	 * @return {Array}
	 */
	_buildMembers(pUserLevelRows, pProjectLevelRows, pSubjectID)
	{
		const tmpByID = {};
		const tmpOrder = [];
		const fEnsure = (pUser) =>
		{
			if (!tmpByID[pUser.IDUser])
			{
				tmpByID[pUser.IDUser] =
				{
					IDUser: pUser.IDUser,
					Label: libUserSearch.userLabel(pUser),
					Sub: pUser.LoginID || pUser.Email || '',
					AtUserLevel: false, AtProjectLevel: false, ProjectCount: 0,
					// Direct = holds a UserRoleJoin/UserContextRole of its own for THIS role (removable here);
					// vs inherited-only through a composing role (removed on the composing role, not here).
					DirectAtUser: false, DirectAtProject: false, ProjectContextIDs: [],
					ViaNames: {},
				};
				tmpOrder.push(pUser.IDUser);
			}
			return tmpByID[pUser.IDUser];
		};
		(Array.isArray(pUserLevelRows) ? pUserLevelRows : []).forEach((pUser) =>
		{
			if (!pUser || !pUser.IDUser)
			{
				return;
			}
			const tmpMember = fEnsure(pUser);
			tmpMember.AtUserLevel = true;
			if (this._isDirectHolder(pUser, pSubjectID)) { tmpMember.DirectAtUser = true; }
			this._collectVia(tmpMember, pUser, pSubjectID);
		});
		(Array.isArray(pProjectLevelRows) ? pProjectLevelRows : []).forEach((pUser) =>
		{
			if (!pUser || !pUser.IDUser)
			{
				return;
			}
			const tmpMember = fEnsure(pUser);
			tmpMember.AtProjectLevel = true;
			tmpMember.ProjectCount = Array.isArray(pUser.ContextRoles) ? pUser.ContextRoles.length : tmpMember.ProjectCount;
			// The per-project IDContexts (ContextRoles[]) — retained so a project-level membership can be
			// removed precisely (the customer-level path only needs idCustomer).
			if (this._isDirectHolder(pUser, pSubjectID))
			{
				tmpMember.DirectAtProject = true;
				tmpMember.ProjectContextIDs = (Array.isArray(pUser.ContextRoles) ? pUser.ContextRoles : []).map(Number).filter((pID) => pID > 0);
			}
			this._collectVia(tmpMember, pUser, pSubjectID);
		});
		return tmpOrder
			.map((pID) => tmpByID[pID])
			.map((pMember) => Object.assign(pMember, { ViaLabel: Object.keys(pMember.ViaNames).join(', ') }))
			.sort((pA, pB) => String(pA.Label).localeCompare(String(pB.Label)));
	}

	/**
	 * Record the names of any roles (other than the subject) that grant a user this membership — i.e. the
	 * composing roles they inherit it through, from the endpoint's per-user FromRoles[].
	 * @param {Object} pMember
	 * @param {Object} pUser
	 * @param {Number} pSubjectID
	 */
	_collectVia(pMember, pUser, pSubjectID)
	{
		(Array.isArray(pUser.FromRoles) ? pUser.FromRoles : []).forEach((pRole) =>
		{
			if (pRole && pRole.IDRole && Number(pRole.IDRole) !== Number(pSubjectID))
			{
				pMember.ViaNames[pRole.Name || `Role ${pRole.IDRole}`] = true;
			}
		});
	}

	/**
	 * Does this user hold the subject role DIRECTLY (a UserRoleJoin/UserContextRole of its own) rather than
	 * only inheriting it through a composing role? The endpoint's FromRoles[] lists the roles that grant the
	 * membership; a direct holder has the subject role itself in that list (or, defensively, no FromRoles info
	 * at all). Only a direct membership can be removed here — an inherited one lives on its composing role.
	 * @param {Object} pUser @param {Number} pSubjectID
	 * @return {Boolean}
	 */
	_isDirectHolder(pUser, pSubjectID)
	{
		const tmpFromRoles = Array.isArray(pUser.FromRoles) ? pUser.FromRoles : [];
		if (tmpFromRoles.length === 0) { return true; }
		return tmpFromRoles.some((pRole) => pRole && Number(pRole.IDRole) === Number(pSubjectID));
	}


	_projectCountLabel(pCount)
	{
		const tmpCount = Number(pCount) || 0;
		if (tmpCount <= 0)
		{
			return 'Project level';
		}
		return `Project level · ${tmpCount} project${tmpCount === 1 ? '' : 's'}`;
	}

	_roleNameMap()
	{
		const tmpMap = {};
		(this.workspace.rolesAndGroups || []).forEach((pRole) =>
		{
			tmpMap[pRole.IDRole] = pRole;
		});
		return tmpMap;
	}

	_edgeRow(pEdge, pOtherID, pNameByID)
	{
		const tmpRole = pNameByID[pOtherID] || {};
		return {
			IDRoleEdge: pEdge.IDRoleEdge,
			IDRole: pOtherID,
			Label: tmpRole.Name || `Role ${pOtherID}`,
			KindLabel: (tmpRole.Type === 'PermissionGroup') ? 'Permission Group' : 'Role',
			Icon: (tmpRole.Type === 'PermissionGroup') ? 'fas fa-layer-group' : 'fas fa-user-shield',
			Kind: (tmpRole.Type === 'PermissionGroup') ? 'group' : 'role',
		};
	}

	// --- Mutations ---

	setAddPicker(pValue)
	{
		this.composition.AddPickerValue = pValue || '';
	}

	/**
	 * Compose a child role/group into the selected role via a new RoleEdge (deduped against existing children).
	 * @param {Number} [pChildID] - defaults to the add-picker selection
	 */
	async addChildAsync(pChildID)
	{
		const tmpComposition = this.composition;
		const tmpChildID = Number(pChildID || tmpComposition.AddPickerValue);
		const tmpParentID = tmpComposition.SubjectID;
		if (!(tmpChildID > 0) || tmpComposition.Saving)
		{
			return;
		}
		if (tmpChildID === tmpParentID)
		{
			tmpComposition.Error = 'A role cannot include itself.';
			this._render();
			return;
		}
		if (tmpComposition.Children.some((pChild) => Number(pChild.IDRole) === tmpChildID))
		{
			tmpComposition.Error = 'That group is already included.';
			this._render();
			return;
		}
		tmpComposition.Saving = true;
		tmpComposition.Error = '';
		this._render();
		try
		{
			await this._postJSON('RoleEdge', { ParentIDRole: tmpParentID, ChildIDRole: tmpChildID, IDCustomer: this.workspace.idCustomer });
			tmpComposition.AddPickerValue = '';
			await this.loadAsync(true);
		}
		catch (pError)
		{
			tmpComposition.Error = `Could not add: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpComposition.Saving = false;
		this._render();
	}

	/**
	 * Remove a composed child by deleting its RoleEdge.
	 * @param {Number} pIDRoleEdge
	 */
	async removeChildAsync(pIDRoleEdge)
	{
		const tmpComposition = this.composition;
		if (tmpComposition.Saving)
		{
			return;
		}
		tmpComposition.Saving = true;
		tmpComposition.Error = '';
		this._render();
		try
		{
			await this._deleteJSON(`RoleEdge/${pIDRoleEdge}`);
			await this.loadAsync(true);
		}
		catch (pError)
		{
			tmpComposition.Error = `Could not remove: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpComposition.Saving = false;
		this._render();
	}

	selectRole(pID)
	{
		if (Number(pID) > 0)
		{
			this.workspace.selectSubject('role', pID);
		}
	}

	// --- Add members (bulk-assign users to the role/group) ---

	/**
	 * (Re)mount the multi-select user picker into #acw-add-members-picker (Members tab). Server-side user search,
	 * customer-scoped; the selected ids write to Membership.AddUserIDs, and addMembersAsync assigns them all. Called
	 * from the AccessWorkspace view's onAfterRender (no-ops unless the mount is present = editable Members tab).
	 */
	mountAddMembersPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#acw-add-members-picker').length === 0) { return; }
		const tmpView = tmpPicker.createPicker('AccessWorkspace-AddMembers',
			{
				DestinationAddress: '#acw-add-members-picker',
				ValueAddress: 'AppData.AccessWorkspace.Membership.AddUserIDs',
				Mode: 'multi',
				Searchable: true,
				Placeholder: 'Search users by name, login ID or email…',
				DataProvider: this._memberUserDataProvider(),
				ResolveValue: this._memberUserResolveValue(),
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	/** Server-side user search (customer-scoped) for the add-members picker. Empty term → browse the customer's users. */
	_memberUserDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._getJSON(pURL), { Scope: () => `FBV~IDCustomer~EQ~${this.workspace.idCustomer}~FBV~Deleted~EQ~0`, PageSize: 25 });
	}

	/** Resolve a selected user id → {Value,Text} so its chip shows a name. */
	_memberUserResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`User/${tmpID}`)
				.then((pUser) => ((pUser && pUser.IDUser) ? libUserSearch.userPickerOption(pUser) : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/**
	 * Assign every picked user to the selected role/group at the workspace's current context — the bulk path that
	 * replaces visiting each user's Roles & Groups tab. Same grant endpoint the User subject uses:
	 * PUT Permissions/Role/For/User (Customer → UserRoleJoin, Project/Lab → UserContextRole). Bounded concurrency.
	 */
	async addMembersAsync()
	{
		const tmpMembership = this.membership;
		const tmpWorkspaceState = this.workspace.state;
		const tmpIDRole = Number(tmpWorkspaceState.SubjectID);
		const tmpUserIDs = (tmpMembership.AddUserIDs || []).map(Number).filter((pID) => pID > 0);
		if (!(tmpIDRole > 0) || tmpMembership.AddSaving) { return; }
		if (!tmpUserIDs.length)
		{
			tmpMembership.AddError = 'Search for and pick one or more users to add first.';
			tmpMembership.AddNotice = '';
			this._render();
			return;
		}
		const tmpContext = tmpWorkspaceState.Context || 'Customer';
		const tmpIDContext = (tmpContext === 'Customer') ? this.workspace.idCustomer : Number(tmpWorkspaceState.IDContext);
		if (!(tmpIDContext > 0))
		{
			tmpMembership.AddError = `Enter a ${tmpContext} ID in the context bar first.`;
			tmpMembership.AddNotice = '';
			this._render();
			return;
		}
		tmpMembership.AddSaving = true;
		tmpMembership.AddError = '';
		tmpMembership.AddNotice = '';
		this._render();
		let tmpOK = 0;
		let tmpFail = 0;
		const tmpConcurrency = 6;
		for (let tmpStart = 0; tmpStart < tmpUserIDs.length; tmpStart += tmpConcurrency)
		{
			const tmpBatch = tmpUserIDs.slice(tmpStart, tmpStart + tmpConcurrency);
			/* eslint-disable no-await-in-loop */
			await Promise.all(tmpBatch.map((pIDUser) =>
				this._putJSON('Permissions/Role/For/User', { IDRole: tmpIDRole, IDUser: pIDUser, Context: tmpContext, IDContext: tmpIDContext })
					.then(() => { tmpOK++; }, () => { tmpFail++; })));
			/* eslint-enable no-await-in-loop */
		}
		tmpMembership.AddSaving = false;
		tmpMembership.AddUserIDs = [];   // clear the picker selection (re-mount reads this empty)
		tmpMembership.AddNotice = tmpFail
			? `Added ${tmpOK} user${tmpOK === 1 ? '' : 's'}; ${tmpFail} could not be added (you may lack permission in this context).`
			: `Added ${tmpOK} user${tmpOK === 1 ? '' : 's'} to this ${(tmpWorkspaceState.SubjectKind === 'group') ? 'group' : 'role'}.`;
		await this.loadMembersAsync(true);   // reload the members list (re-renders)
	}

	/**
	 * Remove a user's DIRECT membership of the selected role/group — the inverse of addMembersAsync, so the
	 * Members tab both grants and revokes (previously you could only remove from the User subject's tab). Deletes
	 * the customer-wide UserRoleJoin and/or each project UserContextRole the user directly holds for this role,
	 * via the same endpoint the User subject uses: DELETE Permissions/Role/{IDRole}/For/User/{IDUser}/In/{Context}/{IDContext}.
	 * Inherited-only (via a composing role) members are never offered a remove here, so there is nothing dangling to delete.
	 * @param {Number} pIDUser
	 */
	async removeMemberAsync(pIDUser)
	{
		const tmpMembership = this.membership;
		const tmpWorkspaceState = this.workspace.state;
		const tmpIDRole = Number(tmpWorkspaceState.SubjectID);
		if (!this.workspace.isRoleManager || !(tmpIDRole > 0) || tmpMembership.RemovingID) { return; }
		const tmpMember = (tmpMembership.Members || []).find((pMember) => Number(pMember.IDUser) === Number(pIDUser));
		if (!tmpMember) { return; }
		// The direct memberships to delete: the customer-wide grant and/or each directly-held project.
		const tmpTargets = [];
		if (tmpMember.DirectAtUser && Number(this.workspace.idCustomer) > 0)
		{
			tmpTargets.push({ Context: 'Customer', IDContext: Number(this.workspace.idCustomer) });
		}
		if (tmpMember.DirectAtProject)
		{
			(tmpMember.ProjectContextIDs || []).forEach((pID) => { if (Number(pID) > 0) { tmpTargets.push({ Context: 'Project', IDContext: Number(pID) }); } });
		}
		if (!tmpTargets.length)
		{
			tmpMembership.Error = `${tmpMember.Label} inherits this role through another role — remove it from that composing role instead.`;
			this._render();
			return;
		}
		tmpMembership.RemovingID = Number(pIDUser);
		tmpMembership.Error = '';
		this._render();
		let tmpFail = 0;
		for (let i = 0; i < tmpTargets.length; i++)
		{
			const tmpTarget = tmpTargets[i];
			try
			{
				/* eslint-disable-next-line no-await-in-loop */
				await this._deleteJSON(`Permissions/Role/${tmpIDRole}/For/User/${pIDUser}/In/${tmpTarget.Context}/${tmpTarget.IDContext}`);
			}
			catch (pError)
			{
				tmpFail++;
			}
		}
		tmpMembership.RemovingID = 0;
		if (tmpFail)
		{
			tmpMembership.Error = `${tmpFail} membership${tmpFail === 1 ? '' : 's'} could not be removed (you may lack permission in this context).`;
		}
		await this.loadMembersAsync(true);   // reload the members list (re-renders)
	}

	// --- Derive ---

	deriveComposition()
	{
		const tmpComposition = this.composition;
		const tmpEditable = !!this.workspace.isRoleManager;
		tmpComposition.LoadingSlot = tmpComposition.Loading ? [ {} ] : [];
		tmpComposition.ErrorSlot = tmpComposition.Error ? [ { Error: tmpComposition.Error } ] : [];
		tmpComposition.ChildrenSlot = tmpComposition.Children.length ? [ {} ] : [];
		tmpComposition.ChildEmptySlot = (!tmpComposition.Loading && !tmpComposition.Children.length) ? [ {} ] : [];

		// Add-child picker: every role/group except self + already-included children, sorted.
		if (tmpEditable)
		{
			const tmpExclude = new Set([ tmpComposition.SubjectID ]);
			tmpComposition.Children.forEach((pChild) => tmpExclude.add(Number(pChild.IDRole)));
			const tmpCandidates = (this.workspace.rolesAndGroups || [])
				.filter((pRole) => !tmpExclude.has(Number(pRole.IDRole)))
				.map((pRole) => ({ IDRole: pRole.IDRole, Label: `${pRole.Name || `Role ${pRole.IDRole}`}${pRole.Type === 'PermissionGroup' ? ' (group)' : ''}` }))
				.sort((pA, pB) => String(pA.Label).localeCompare(String(pB.Label)));
			tmpComposition.CandidateOptions = [ { IDRole: '', Label: 'Add a role or group…' } ].concat(tmpCandidates);
			tmpComposition.AddSlot = [ {} ];
		}
		else
		{
			tmpComposition.CandidateOptions = [];
			tmpComposition.AddSlot = [];
		}

		// Per-row remove affordance is gated on editability.
		tmpComposition.Children = tmpComposition.Children.map((pChild) =>
			Object.assign({}, pChild, { RemoveSlot: tmpEditable ? [ { IDRoleEdge: pChild.IDRoleEdge } ] : [] }));
	}

	deriveMembership()
	{
		const tmpMembership = this.membership;
		tmpMembership.LoadingSlot = tmpMembership.Loading ? [ {} ] : [];
		tmpMembership.ErrorSlot = tmpMembership.Error ? [ { Error: tmpMembership.Error } ] : [];

		// Cap the RENDERED members. `Permissions/Users/With/Role` is unbounded (a broadly-held base role returns every
		// user — thousands), and the member list renders through a recursive {~TS:~} template that stack-overflows past
		// ~1k rows. Render the first RENDER_CAP into a SEPARATE slot (never mutate the raw Members — deriveMembership runs
		// on every paint), and label the true total honestly. NOTE: the fetch itself is still unbounded; server-side
		// pagination/search on Users/With/Role is the complete fix.
		const tmpAllMembers = Array.isArray(tmpMembership.Members) ? tmpMembership.Members : [];
		const tmpTotal = tmpAllMembers.length;
		const tmpRenderCap = 200;
		tmpMembership.MembersRender = tmpAllMembers.slice(0, tmpRenderCap).map((pMember) =>
		{
			// A remove (×) is offered only to role managers, and only for members who hold the role DIRECTLY
			// at a resolvable context (a customer-wide UserRoleJoin, or one/more project UserContextRoles) —
			// never for a member who only inherits it through a composing role (that has nothing to delete here).
			const tmpRemovable = this.workspace.isRoleManager
				&& (pMember.DirectAtUser || (pMember.DirectAtProject && (pMember.ProjectContextIDs || []).length > 0));
			return Object.assign({}, pMember,
				{
					UserLevelSlot: pMember.AtUserLevel ? [ {} ] : [],
					ProjectLevelSlot: pMember.AtProjectLevel ? [ { CountLabel: this._projectCountLabel(pMember.ProjectCount) } ] : [],
					ViaSlot: pMember.ViaLabel ? [ { ViaLabel: pMember.ViaLabel } ] : [],
					RemoveSlot: tmpRemovable ? [ { IDUser: pMember.IDUser } ] : [],
				});
		});
		tmpMembership.MembersSlot = tmpTotal ? [ {} ] : [];
		tmpMembership.MemberEmptySlot = (!tmpMembership.Loading && !tmpTotal) ? [ {} ] : [];
		tmpMembership.CountLabel = tmpTotal
			? ((tmpTotal > tmpRenderCap) ? `Showing the first ${tmpRenderCap} of ${tmpTotal} members` : `${tmpTotal} member${tmpTotal === 1 ? '' : 's'}`)
			: '';

		// "Add users to this role" panel — shown only to editors (server stays authoritative); its saving/notice/error
		// slots drive the button + messages.
		tmpMembership.AddSlot = this.workspace.isRoleManager ? [ {} ] : [];
		tmpMembership.AddSavingSlot = tmpMembership.AddSaving ? [ {} ] : [];
		tmpMembership.AddErrorSlot = tmpMembership.AddError ? [ { Error: tmpMembership.AddError } ] : [];
		tmpMembership.AddNoticeSlot = tmpMembership.AddNotice ? [ { Notice: tmpMembership.AddNotice } ] : [];
	}

	_render()
	{
		if (this.pict.views.AccessWorkspace)
		{
			this.pict.views.AccessWorkspace.render();
		}
	}
}

module.exports = GroupCompositionProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'GroupComposition',
	AutoInitialize: true,
	AutoInitializeOrdinal: 3,
};

},{"../access/User-Search.js":1064,"pict-provider":845}],1342:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const BODY_MOUNT = '#ICW-Body';
const MESSAGE_MOUNT = '#ICW-Message';
const ASSET_PICKER_MOUNT = '#ICW-Picker-IDPhysicalAsset';
const PICKER_PAGE_SIZE = 25;

/**
 * InspectionCreateWorkspace — the bespoke Inspection CREATE screen.
 *
 * Creating an inspection is not a plain row insert: an inspection is only useful once it is joined to the asset
 * being inspected, scoped to that asset's project, and carrying the document packet its inspection type calls
 * for. `BridgeDocumentManager.createInspection()` does all four (POST Inspection → POST
 * InspectionPhysicalAssetJoin → generate one Document per InspectionTypeReportNamedInstanceJoin → wire the
 * dossier's DocumentPolyJoins), and that service is already instantiated app-wide by the HeadlightPanels view.
 * So this screen is a form over that one call.
 *
 * The router bridges #/PSRS/Inspection/Create here so this shadows the generic record-set create form. That
 * matters beyond polish: the generic form renders the raw schema (a bare number box for IDInspectionType, plain
 * text boxes for the dates) and POSTs a lone Inspection row — no asset, no project, no packet. Every inspection
 * created that way is an orphan that no screen in the platform can show properly.
 */
class InspectionCreateWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get documentManager()
	{
		return this.pict.BridgeDocumentManager || (this.pict.fable && this.pict.fable.BridgeDocumentManager);
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return Number(this.currentUser.CustomerID) || 0;
	}

	get state()
	{
		if (!this.pict.AppData.InspectionCreateWorkspace)
		{
			this.pict.AppData.InspectionCreateWorkspace =
			{
				Ready: false, Message: '', MessageClass: '', Saving: false,
				Fields: { IDPhysicalAsset: '', IDInspectionType: '', Name: '', Description: '', ScheduledStartDate: '', DeadlineDate: '' },
				Errors: {},
				// Resolved from the chosen asset — shown read-only, and required before save.
				AssetLabel: '', ProjectID: 0, ProjectName: '', ProjectState: 'idle',
				// Packet preview: how many documents this inspection type will generate.
				PacketCount: null,
				// Once the user edits the name by hand we stop regenerating it under them.
				NameTouched: false,
				TypeOptions: [],
			};
		}
		return this.pict.AppData.InspectionCreateWorkspace;
	}

	// --- REST helpers ---

	_get(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	// --- Start ---

	/**
	 * Begin a new inspection. An optional asset pre-selects and locks the subject, which is how the Asset
	 * workspace's "Schedule inspection" action arrives here.
	 *
	 * @param {Number|String} [pIDPhysicalAsset] - pre-select this asset
	 */
	async startNewAsync(pIDPhysicalAsset)
	{
		const tmpState = this.state;
		tmpState.Message = '';
		tmpState.MessageClass = '';
		tmpState.Saving = false;
		tmpState.Errors = {};
		tmpState.Fields = { IDPhysicalAsset: '', IDInspectionType: '', Name: '', Description: '', ScheduledStartDate: '', DeadlineDate: '' };
		tmpState.AssetLabel = '';
		tmpState.ProjectID = 0;
		tmpState.ProjectName = '';
		tmpState.ProjectState = 'idle';
		tmpState.PacketCount = null;
		tmpState.NameTouched = false;
		tmpState.Ready = true;

		try
		{
			const tmpTypes = await this._get('InspectionTypes/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/200');
			tmpState.TypeOptions = (Array.isArray(tmpTypes) ? tmpTypes : [])
				.map((pType) => ({ IDInspectionType: pType.IDInspectionType, Name: pType.Name || `Type ${ pType.IDInspectionType }` }));
		}
		catch (pError)
		{
			tmpState.TypeOptions = [];
			tmpState.Message = `Could not load inspection types: ${ pError.message || pError }`;
			tmpState.MessageClass = 'is-warning';
		}

		// Seed a pre-selected asset BEFORE the first paint: the picker resolves its label from the bound value
		// when it mounts, so setting this afterwards would leave the control showing its placeholder even though
		// an asset is chosen.
		const tmpID = Number(pIDPhysicalAsset);
		if (tmpID > 0) { tmpState.Fields.IDPhysicalAsset = tmpID; }

		this.render();

		if (tmpID > 0)
		{
			await this.setAssetAsync(tmpID);
		}
	}

	// --- Editing ---

	setField(pKey, pValue)
	{
		this.state.Fields[pKey] = pValue;
		if (this.state.Errors[pKey]) { delete this.state.Errors[pKey]; }
		if (pKey === 'Name') { this.state.NameTouched = (String(pValue).trim() !== ''); }
		if ((pKey === 'ScheduledStartDate') && !this.state.NameTouched) { this._regenerateName(); this._patchDerived(); }
	}

	/**
	 * Choose the inspection type: refresh the generated name and preview how many documents the packet will
	 * contain, so an unseeded type is visible BEFORE the inspection is created rather than after.
	 *
	 * @param {Number|String} pIDInspectionType
	 */
	async setTypeAsync(pIDInspectionType)
	{
		const tmpState = this.state;
		tmpState.Fields.IDInspectionType = pIDInspectionType;
		delete tmpState.Errors.IDInspectionType;
		tmpState.PacketCount = null;
		if (!tmpState.NameTouched) { this._regenerateName(); }
		this._patchDerived();

		const tmpID = Number(pIDInspectionType);
		if (!tmpID) { return; }
		try
		{
			const tmpJoins = await this._get(`InspectionTypeReportNamedInstanceJoins/FilteredTo/FBV~IDInspectionType~EQ~${ tmpID }`);
			tmpState.PacketCount = Array.isArray(tmpJoins) ? tmpJoins.length : 0;
		}
		catch (pError)
		{
			tmpState.PacketCount = null;
		}
		this._patchDerived();
	}

	/**
	 * Choose the asset being inspected, then resolve its project. The project is not cosmetic: the packet
	 * generator throws without one, and that throw is swallowed by the service's own error handling — so
	 * without this resolution a user gets a successful-looking inspection with an empty packet. Save is blocked
	 * until it resolves.
	 *
	 * @param {Number|String} pIDPhysicalAsset
	 */
	async setAssetAsync(pIDPhysicalAsset)
	{
		const tmpState = this.state;
		tmpState.Fields.IDPhysicalAsset = pIDPhysicalAsset;
		delete tmpState.Errors.IDPhysicalAsset;
		tmpState.ProjectID = 0;
		tmpState.ProjectName = '';
		tmpState.AssetLabel = '';

		const tmpID = Number(pIDPhysicalAsset);
		if (!tmpID)
		{
			tmpState.ProjectState = 'idle';
			this._patchDerived();
			return;
		}

		tmpState.ProjectState = 'loading';
		this._patchDerived();

		try
		{
			const tmpAsset = await this._get(`PhysicalAsset/${ tmpID }`);
			tmpState.AssetLabel = (tmpAsset && (tmpAsset.Name || tmpAsset.ExternalSyncGUID)) ? (tmpAsset.Name || tmpAsset.ExternalSyncGUID) : `Asset ${ tmpID }`;

			const tmpJoins = await this._get(`PhysicalAssetPolyJoins/FilteredTo/FBV~IDPhysicalAsset~EQ~${ tmpID }~FBV~RemoteType~EQ~Project`);
			const tmpIDProject = (Array.isArray(tmpJoins) && tmpJoins.length) ? Number(tmpJoins[0].IDRemote) : 0;
			if (!tmpIDProject)
			{
				tmpState.ProjectState = 'missing';
			}
			else
			{
				tmpState.ProjectID = tmpIDProject;
				tmpState.ProjectState = 'ready';
				try
				{
					const tmpProject = await this._get(`Project/${ tmpIDProject }`);
					tmpState.ProjectName = (tmpProject && tmpProject.Name) ? tmpProject.Name : `Project ${ tmpIDProject }`;
				}
				catch (pError) { tmpState.ProjectName = `Project ${ tmpIDProject }`; }
			}
		}
		catch (pError)
		{
			tmpState.ProjectState = 'error';
			tmpState.ProjectName = pError.message || String(pError);
		}

		if (!tmpState.NameTouched) { this._regenerateName(); }
		this._patchDerived();
	}

	/**
	 * Compose the conventional inspection name: "<asset> <type> Inspection - <scheduled date>", matching what
	 * the bridge apps have always generated so existing lists and reports stay legible.
	 */
	_regenerateName()
	{
		const tmpState = this.state;
		const tmpType = tmpState.TypeOptions.find((pType) => (Number(pType.IDInspectionType) === Number(tmpState.Fields.IDInspectionType)));
		const tmpParts = [ tmpState.AssetLabel, tmpType ? tmpType.Name : '', 'Inspection' ].filter(Boolean);
		if (tmpParts.length < 2) { return; }
		const tmpDate = String(tmpState.Fields.ScheduledStartDate || '').trim();
		tmpState.Fields.Name = tmpDate ? `${ tmpParts.join(' ') } - ${ tmpDate }` : tmpParts.join(' ');
	}

	_validate()
	{
		const tmpState = this.state;
		const tmpErrors = {};
		if (!Number(tmpState.Fields.IDPhysicalAsset)) { tmpErrors.IDPhysicalAsset = 'Choose the asset being inspected.'; }
		if (!Number(tmpState.Fields.IDInspectionType)) { tmpErrors.IDInspectionType = 'Choose an inspection type.'; }
		if (!String(tmpState.Fields.Name || '').trim()) { tmpErrors.Name = 'Name is required.'; }
		if (Number(tmpState.Fields.IDPhysicalAsset) && (tmpState.ProjectState !== 'ready'))
		{
			tmpErrors.IDPhysicalAsset = 'This asset is not linked to a project, so its inspection documents cannot be created.';
		}
		tmpState.Errors = tmpErrors;
		return Object.keys(tmpErrors).length === 0;
	}

	// --- Save ---

	async saveAsync()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		if (!this._validate())
		{
			tmpState.Message = 'Please fix the highlighted fields.';
			tmpState.MessageClass = 'is-danger';
			this.render();
			return;
		}
		const tmpDocumentManager = this.documentManager;
		if (!tmpDocumentManager || (typeof tmpDocumentManager.createInspection !== 'function'))
		{
			tmpState.Message = 'The inspection document service is not available in this application.';
			tmpState.MessageClass = 'is-danger';
			this.render();
			return;
		}

		tmpState.Saving = true;
		tmpState.Message = 'Creating the inspection and its documents…';
		tmpState.MessageClass = 'is-info';
		this._renderMessage();

		const tmpIDAsset = Number(tmpState.Fields.IDPhysicalAsset);
		// StatusDisplay is the denormalized label the lists read; real status is driven by the dossier's
		// approval workflow once the packet exists.
		const tmpPayload =
		{
			Name: String(tmpState.Fields.Name).trim(),
			Description: String(tmpState.Fields.Description || '').trim(),
			StatusDisplay: 'Scheduled',
			IDInspectionType: Number(tmpState.Fields.IDInspectionType),
			IDProject: tmpState.ProjectID,
		};
		if (String(tmpState.Fields.ScheduledStartDate || '').trim()) { tmpPayload.ScheduledStartDate = tmpState.Fields.ScheduledStartDate; }
		if (String(tmpState.Fields.DeadlineDate || '').trim()) { tmpPayload.DeadlineDate = tmpState.Fields.DeadlineDate; }

		try
		{
			const tmpInspection = await tmpDocumentManager.createInspection(tmpIDAsset, tmpPayload);
			if (!tmpInspection || !tmpInspection.IDInspection)
			{
				throw new Error('the server rejected the new inspection (you may not have permission to create inspections).');
			}

			// The packet is generated inside a `finally` whose errors the service logs and swallows, so a failure
			// there would otherwise look like success. Read the joins back and report what actually landed.
			const tmpPacket = await this._countPacketAsync(tmpInspection.IDInspection);
			tmpState.Saving = false;
			if (tmpPacket === 0)
			{
				tmpState.Message = 'The inspection was created, but none of its documents were — opening it so you can retry the packet.';
				tmpState.MessageClass = 'is-warning';
				this._renderMessage();
			}
			this._navigateToWorkspace(tmpInspection.IDInspection);
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Could not create the inspection: ${ pError.message || pError }`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	/**
	 * How many documents the new inspection actually ended up with.
	 *
	 * @param {Number} pIDInspection
	 * @return {Promise<Number|null>} the count, or null when it could not be read
	 */
	async _countPacketAsync(pIDInspection)
	{
		try
		{
			const tmpJoins = await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${ pIDInspection }~FBV~Deleted~EQ~0`);
			return Array.isArray(tmpJoins) ? tmpJoins.length : null;
		}
		catch (pError) { return null; }
	}

	cancel()
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = '#/PSRS/Inspection/List';
		}
	}

	_navigateToWorkspace(pIDInspection)
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/Inspection/Workspace/${ pIDInspection }`;
		}
	}

	// --- Render ---

	render()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
		if (this.state.Ready) { this._mountAssetPicker(); }
	}

	/**
	 * Patch just the parts that react to a selection — the resolved-project line, the packet preview and the
	 * generated name. A full repaint would tear the asset picker out of the DOM and rebuild it underneath the
	 * user, closing its dropdown and re-resolving its label on every keystroke.
	 */
	_patchDerived()
	{
		const tmpState = this.state;
		if (this.pict.ContentAssignment.getElement('#ICW-ProjectNote').length > 0)
		{
			this.pict.ContentAssignment.assignContent('#ICW-ProjectNote', this._projectHTML());
		}
		if (this.pict.ContentAssignment.getElement('#ICW-PacketNote').length > 0)
		{
			this.pict.ContentAssignment.assignContent('#ICW-PacketNote', this._packetHTML());
		}
		if (typeof document !== 'undefined')
		{
			const tmpNameInput = document.getElementById('ICW-Name');
			if (tmpNameInput && !tmpState.NameTouched) { tmpNameInput.value = tmpState.Fields.Name || ''; }
		}
	}

	_mountAssetPicker()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement(ASSET_PICKER_MOUNT).length === 0) { return; }
		const tmpPicker = tmpPickerProvider.createPicker('ICW-Picker-IDPhysicalAsset',
			{
				DestinationAddress: ASSET_PICKER_MOUNT,
				ValueAddress: 'AppData.InspectionCreateWorkspace.Fields.IDPhysicalAsset',
				Searchable: true,
				AllowClear: true,
				ClearLabel: '(none)',
				Placeholder: 'Search a bridge or asset…',
				DataProvider: this._assetDataProvider(),
				ResolveValue: this._assetResolveValue(),
				Entity: 'PhysicalAsset',
				OnChange: (pValue) => { this.setAssetAsync(pValue); },
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
	}

	_assetDataProvider()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		return (pSearchTerm, pPage) =>
		{
			const tmpStart = (Number(pPage) || 0) * PICKER_PAGE_SIZE;
			let tmpFilter = `FBV~IDCustomer~EQ~${ this.idCustomer }~FBV~Deleted~EQ~0`;
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).replace(/~/g, '').trim();
			if (tmpTerm && tmpPickerProvider && (typeof tmpPickerProvider.buildSearchFilter === 'function'))
			{
				tmpFilter += `~${ tmpPickerProvider.buildSearchFilter([ 'Name', 'ExternalSyncGUID', 'AssetNumber' ], tmpTerm) }`;
			}
			return this._get(`PhysicalAssets/FilteredTo/${ tmpFilter }~FSF~Name~ASC~0/${ tmpStart }/${ PICKER_PAGE_SIZE }`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					return {
						results: tmpList.map((pRow) => ({ Value: Number(pRow.IDPhysicalAsset), Text: pRow.Name || pRow.ExternalSyncGUID || `Asset ${ pRow.IDPhysicalAsset }`, Record: pRow })),
						hasMore: (tmpList.length >= PICKER_PAGE_SIZE)
					};
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	_assetResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._get(`PhysicalAsset/${ tmpID }`)
				.then((pRow) => ((pRow && pRow.IDPhysicalAsset)
					? { Value: Number(pRow.IDPhysicalAsset), Text: pRow.Name || pRow.ExternalSyncGUID || `Asset ${ tmpID }` }
					: { Value: tmpID, Text: `Asset ${ tmpID }` }))
				.catch(() => ({ Value: tmpID, Text: `Asset ${ tmpID }` }));
		};
	}

	_renderMessage()
	{
		if (this.pict.ContentAssignment.getElement(MESSAGE_MOUNT).length === 0) { this.render(); return; }
		this.pict.ContentAssignment.assignContent(MESSAGE_MOUNT, this._messageHTML());
	}

	_messageHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Message) { return ''; }
		return `<div class="notification ${ this._esc(tmpState.MessageClass || 'is-info') } is-soft py-2 px-3 mb-3">${ this._esc(tmpState.Message) }</div>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Ready)
		{
			return `<div class="pew-empty box has-text-grey has-text-centered"><span class="pew-spinner"></span><p class="mt-3">Loading…</p></div>`;
		}
		return `<div class="pew-head">`
			+ `<div><div class="pew-eyebrow">New Inspection</div><h1 class="pew-title">Schedule an inspection</h1></div>`
			+ `<div class="pew-head-actions">`
			+ `<button class="button is-link"${ tmpState.Saving ? ' disabled' : '' } onclick="_Pict.providers.InspectionCreateWorkspace.saveAsync(); return false;"><span>Create inspection</span></button>`
			+ `<button class="button is-light" onclick="_Pict.providers.InspectionCreateWorkspace.cancel(); return false;"><span>Cancel</span></button>`
			+ `</div></div>`
			+ `<div id="ICW-Message">${ this._messageHTML() }</div>`
			+ `<div class="pew-form">`
			+ this._subjectGroupHTML()
			+ this._scheduleGroupHTML()
			+ `</div>`;
	}

	_subjectGroupHTML()
	{
		const tmpState = this.state;
		const tmpAssetError = tmpState.Errors.IDPhysicalAsset ? `<div class="pew-field-error">${ this._esc(tmpState.Errors.IDPhysicalAsset) }</div>` : '';
		const tmpTypeError = tmpState.Errors.IDInspectionType ? `<div class="pew-field-error">${ this._esc(tmpState.Errors.IDInspectionType) }</div>` : '';
		const tmpOptions = [ `<option value="">Choose a type…</option>` ].concat(tmpState.TypeOptions.map((pType) =>
			`<option value="${ pType.IDInspectionType }"${ (Number(pType.IDInspectionType) === Number(tmpState.Fields.IDInspectionType)) ? ' selected' : '' }>${ this._esc(pType.Name) }</option>`)).join('');
		return `<div class="pew-group"><div class="pew-group-head">Subject</div><div class="pew-grid">`
			+ `<div class="pew-field pew-field-wide"><label class="pew-field-label">Asset <span class="icw-req">*</span></label>`
			+ `<div id="ICW-Picker-IDPhysicalAsset" class="pew-input pew-picker-host"></div>${ tmpAssetError }`
			+ `<div id="ICW-ProjectNote" class="icw-project">${ this._projectHTML() }</div></div>`
			+ `<div class="pew-field pew-field-wide"><label class="pew-field-label">Inspection type <span class="icw-req">*</span></label>`
			+ `<div class="select is-fullwidth pew-input"><select onchange="_Pict.providers.InspectionCreateWorkspace.setTypeAsync(this.value)">${ tmpOptions }</select></div>`
			+ `${ tmpTypeError }<div id="ICW-PacketNote">${ this._packetHTML() }</div></div>`
			+ `</div></div>`;
	}

	/**
	 * The resolved project, shown because the user cannot pick it and needs to know it was found — an asset with
	 * no project is the one case that silently produces an inspection with no documents.
	 */
	_projectHTML()
	{
		const tmpState = this.state;
		if (tmpState.ProjectState === 'loading') { return `<span class="icw-note">Resolving the asset’s project…</span>`; }
		if (tmpState.ProjectState === 'ready') { return `<span class="icw-note icw-note-ok">Project: ${ this._esc(tmpState.ProjectName) }</span>`; }
		if (tmpState.ProjectState === 'missing') { return `<span class="icw-note icw-note-bad">This asset is not linked to a project. Link it on the asset’s workspace before scheduling an inspection — the inspection’s documents are created under the project.</span>`; }
		if (tmpState.ProjectState === 'error') { return `<span class="icw-note icw-note-bad">Could not resolve the asset’s project: ${ this._esc(tmpState.ProjectName) }</span>`; }
		return '';
	}

	/** Preview the packet size so an inspection type with no report templates is visible before, not after. */
	_packetHTML()
	{
		const tmpCount = this.state.PacketCount;
		if (tmpCount == null) { return ''; }
		if (tmpCount === 0)
		{
			return `<span class="icw-note icw-note-bad">This inspection type has no report documents configured, so the inspection will be created empty.</span>`;
		}
		return `<span class="icw-note icw-note-ok">Creates ${ tmpCount } document${ (tmpCount === 1) ? '' : 's' } for this inspection.</span>`;
	}

	_scheduleGroupHTML()
	{
		const tmpState = this.state;
		const tmpNameError = tmpState.Errors.Name ? `<div class="pew-field-error">${ this._esc(tmpState.Errors.Name) }</div>` : '';
		return `<div class="pew-group"><div class="pew-group-head">Schedule</div><div class="pew-grid">`
			+ `<div class="pew-field"><label class="pew-field-label">Scheduled start</label>`
			+ `<input class="input pew-input" type="date" value="${ this._esc(tmpState.Fields.ScheduledStartDate) }" onchange="_Pict.providers.InspectionCreateWorkspace.setField('ScheduledStartDate', this.value)" /></div>`
			+ `<div class="pew-field"><label class="pew-field-label">Deadline</label>`
			+ `<input class="input pew-input" type="date" value="${ this._esc(tmpState.Fields.DeadlineDate) }" onchange="_Pict.providers.InspectionCreateWorkspace.setField('DeadlineDate', this.value)" /></div>`
			+ `<div class="pew-field pew-field-wide"><label class="pew-field-label">Name <span class="icw-req">*</span></label>`
			+ `<input id="ICW-Name" class="input pew-input" type="text" value="${ this._esc(tmpState.Fields.Name) }" onchange="_Pict.providers.InspectionCreateWorkspace.setField('Name', this.value)" />`
			+ `${ tmpNameError }<span class="icw-note">Generated from the asset, type and date — edit it and it stays as you typed it.</span></div>`
			+ `<div class="pew-field pew-field-wide"><label class="pew-field-label">Description</label>`
			+ `<textarea class="textarea pew-input" onchange="_Pict.providers.InspectionCreateWorkspace.setField('Description', this.value)">${ this._esc(tmpState.Fields.Description) }</textarea></div>`
			+ `</div></div>`;
	}
}

module.exports = InspectionCreateWorkspaceProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'InspectionCreateWorkspace',
	AutoInitialize: true,
	AutoInitializeOrdinal: 227,
};

},{"pict-provider":845}],1343:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libDocumentLookup = require('../documents/Document-Lookup.js');
const libUserSearch = require('../access/User-Search.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

/**
 * InspectionWorkspaceProvider — the engine behind the Inspection workspace (#/Inspection/Workspace/:ID[/:Tab], bridged
 * over /PSRS/Inspection/View/:GUID). One tabbed workspace for a scheduled/dynamic asset inspection, on plain Meadow CRUD
 * (server InspectionsBundle — no bespoke endpoints, no server work):
 *   • Overview   — StatusDisplay (denormalized string; the InspectionStatus table has no live read route) + type (resolved
 *                  from IDInspectionType — TypeDisplay comes back empty) + the four dates + project link; inline edit of
 *                  the schedulable fields (Name/Description/ScheduledStartDate/DeadlineDate/Type).
 *   • Assets     — InspectionPhysicalAssetJoin {IDInspection,IDPhysicalAsset}; add via a searchable asset picker / remove.
 *   • Documents  — InspectionDocumentJoin {…,IncludeOnDossier,Ordinal}: the dossier flag + ordering, Open/View (same-origin
 *                  HTML via HeadlightDocumentRender — NEVER Fieldbook) + PDF; add / remove / reorder / toggle-dossier.
 *   • Inspectors — InspectionUserJoin {IDInspection,IDUser}; add / remove. (Phase-3 Team assignment plugs in here.)
 *   • Timeline   — InspectionEventLog {Event,IDUser,Datum} — read-only audit trail.
 * Config in [[Inspection.config.js]]. Modeled on [[TeamWorkspace-Provider.js]].
 */
class InspectionWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._inspection = null;
		this._tabs = {};            // per-tab {Loading, Loaded, Error, Rows, ...}
		this._names = { user: {}, project: {}, asset: {}, type: {}, team: {} };  // id -> display name/meta caches
		this._typeOptions = [];     // [{IDInspectionType, Name}] — small (per-customer, ~11), safe to load whole
		this._editing = false;      // Overview "Edit details" open?
		this._docMeta = {};         // IDDocument -> {Name, Locked, DocumentType}
		this._packetDocIDs = [];    // the inspection's document-packet IDDocuments (for team grants across the packet)
	}

	get idInspection() { return this._inspection ? this._inspection.IDInspection : null; }
	get idCustomer() { return (this._inspection && this._inspection.IDCustomer) || (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }
	get providerName() { return (this.options && this.options.ProviderIdentifier) || 'InspectionWorkspace'; }
	get _docRender() { return this.pict.HeadlightDocumentRender; }

	// --- REST helpers (mirror the Team workspace) ---
	_get(pURL) { return this._getJSON(pURL); }
	_postJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pPayload, (e, b) => e ? reject(e) : resolve(b))); }
	_putJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pPayload, (e, b) => e ? reject(e) : resolve(b))); }
	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			const m = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (m) { this.restClient.deleteEntity(m[1], m[2], (e, b) => e ? reject(e) : resolve(b)); return; }
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((r) => { if (!r.ok) { reject(new Error(`HTTP ${r.status}`)); return; } r.text().then((t) => resolve(t ? JSON.parse(t) : {})).catch(() => resolve({})); })
				.catch(reject);
		});
	}
	_fmtDate(pV) { if (!pV) { return ''; } try { const d = new Date(pV); if (!Number.isNaN(d.getTime())) { return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); } } catch (e) { /* */ } return String(pV).slice(0, 10); }
	_dateInput(pV) { if (!pV) { return ''; } return String(pV).slice(0, 10); }

	// --- hydrate: base loaded the scalar Inspection; refresh it, resolve project + type vocab ---
	async hydrateAsync(pRecord)
	{
		this._tabs = {}; this._editing = false;
		const tmpFull = await this._get(`Inspection/${pRecord.IDInspection}`);
		if (tmpFull && tmpFull.IDInspection) { Object.assign(pRecord, tmpFull); }
		this._inspection = pRecord;
		// Inspection types are a small per-customer vocabulary — load them all once (TypeDisplay is not denormalized).
		try
		{
			const types = await this._get('InspectionTypes/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/200');
			this._typeOptions = (Array.isArray(types) ? types : []).map((t) => ({ IDInspectionType: t.IDInspectionType, Name: t.Name || `Type ${t.IDInspectionType}` }));
			this._typeOptions.forEach((t) => { this._names.type[t.IDInspectionType] = t.Name; });
		}
		catch (e) { this._typeOptions = []; }
		pRecord.TypeDisplay = this._names.type[pRecord.IDInspectionType] || pRecord.TypeDisplay || '';
		if (pRecord.IDProject)
		{
			try { const pr = await this._get(`Projects/Lite/FilteredTo/FBV~IDProject~EQ~${Number(pRecord.IDProject)}/0/1`); const row = Array.isArray(pr) ? pr[0] : null; if (row) { this._names.project[pRecord.IDProject] = row.Value || row.Name || `Project ${pRecord.IDProject}`; } }
			catch (e) { /* */ }
		}
	}

	// --- per-tab load + repaint ---
	async _ensureTabDataAsync(pTab, pForce)
	{
		if (!this._inspection) { return; }
		if (!pForce && this._tabs[pTab] && this._tabs[pTab].Loaded) { this._scheduleMount(pTab); return; }
		this._tabs[pTab] = { Loading: true, Loaded: false };
		this.repaintBody();
		try
		{
			if (pTab === 'overview') { await this._loadOverview(); }
			else if (pTab === 'assets') { this._tabs[pTab].Rows = await this._loadAssets(); }
			else if (pTab === 'documents') { this._tabs[pTab].Rows = await this._loadDocuments(); }
			else if (pTab === 'inspectors') { this._tabs[pTab].Rows = await this._loadInspectors(); }
			else if (pTab === 'teams') { this._tabs[pTab].Rows = await this._loadTeams(); }
			else if (pTab === 'timeline') { this._tabs[pTab].Rows = await this._loadTimeline(); }
			this._tabs[pTab].Loaded = true;
		}
		catch (e) { this._tabs[pTab].Error = (e && e.message) || String(e); this._tabs[pTab].Loaded = true; }
		finally { this._tabs[pTab].Loading = false; this.repaintBody(); this._scheduleMount(pTab); }
	}
	_reload(pTab) { if (this._tabs[pTab]) { this._tabs[pTab].Loaded = false; } this._ensureTabDataAsync(pTab, true); }
	_state(pTab) { return this._tabs[pTab] || {}; }
	_loadingOrError(pTab)
	{
		const t = this._state(pTab);
		if (t.Loading || (!t.Loaded && !t.Error)) { return `<div class="iw-note"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>`; }
		if (t.Error) { return `<div class="iw-error">${this._esc(t.Error)}</div>`; }
		return null;
	}

	async _resolveNames(pKind, pIDs, pURL, pLabel)
	{
		const tmpMissing = [ ...new Set(pIDs.map(Number).filter((x) => x && !this._names[pKind][x])) ];
		if (!tmpMissing.length) { return; }
		const rows = await this._get(pURL(tmpMissing));
		(Array.isArray(rows) ? rows : []).forEach((r) => { const id = pLabel.id(r); if (id) { this._names[pKind][id] = pLabel.name(r); } });
	}

	// --- data loaders ---
	async _loadOverview()
	{
		const [ assets, docs, users ] = await Promise.all([
			this._get(`InspectionPhysicalAssetJoins/Count/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0`),
			this._get(`InspectionDocumentJoins/Count/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0`),
			this._get(`InspectionUserJoins/Count/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0`),
		]);
		this._tabs.overview = Object.assign(this._tabs.overview || {}, {
			Assets: (assets && assets.Count) || 0,
			Documents: (docs && docs.Count) || 0,
			Inspectors: (users && users.Count) || 0,
		});
	}
	async _loadAssets()
	{
		const rows = await this._get(`InspectionPhysicalAssetJoins/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0/0/200`);
		const list = Array.isArray(rows) ? rows : [];
		await this._resolveNames('asset', list.map((r) => r.IDPhysicalAsset),
			(ids) => `PhysicalAssets/FilteredTo/FBL~IDPhysicalAsset~INN~${ids.join(',')}/0/${ids.length}`,
			{ id: (a) => a.IDPhysicalAsset, name: (a) => JSON.stringify({ Name: a.Name || `Asset ${a.IDPhysicalAsset}`, AssetNumber: a.AssetNumber || '', Structure: a.ExternalSyncGUID || '', GUID: a.GUIDPhysicalAsset || '' }) });
		return list;
	}
	async _loadDocuments()
	{
		const rows = await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0~FSF~Ordinal~ASC~0/0/300`);
		const list = Array.isArray(rows) ? rows : [];
		const tmpDocIDs = [ ...new Set(list.map((r) => r.IDDocument).filter(Boolean)) ];
		this._docMeta = this._docMeta || {};
		if (tmpDocIDs.length)
		{
			const docs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${tmpDocIDs.join(',')}/0/${tmpDocIDs.length}`);
			(Array.isArray(docs) ? docs : []).forEach((d) => { this._docMeta[d.IDDocument] = { Name: d.Name || `Document ${d.IDDocument}`, Locked: !!(d.Locked || d.IsLocked), DocumentType: d.DocumentType }; });
		}
		return list;
	}
	async _loadInspectors()
	{
		const rows = await this._get(`InspectionUserJoins/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0/0/200`);
		const list = Array.isArray(rows) ? rows : [];
		await this._resolveNames('user', list.map((r) => r.IDUser), (ids) => `Users/FilteredTo/FBL~IDUser~INN~${ids.join(',')}/0/${ids.length}`, { id: (u) => u.IDUser, name: (u) => [ u.NameFirst, u.NameLast ].filter(Boolean).join(' ') || u.LoginID || `#${u.IDUser}` });
		return list;
	}
	// Teams are assigned by granting them the inspection's whole document packet (DocumentAccessJoin per doc) — the same
	// "derived via document grants" mechanism as Team→Project; the access engine projects it to members and their project
	// reach. No InspectionTeamJoin. This loader derives the assigned teams by grouping packet-doc grants by IDTeam.
	async _loadPacket()
	{
		const idj = await this._get(`InspectionDocumentJoins/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0/0/300`);
		const docIDs = [ ...new Set((Array.isArray(idj) ? idj : []).map((r) => r.IDDocument).filter(Boolean)) ];
		this._packetDocIDs = docIDs;
		this._docMeta = this._docMeta || {};
		const missing = docIDs.filter((id) => !this._docMeta[id]);
		if (missing.length)
		{
			const docs = await this._get(`Documents/FilteredTo/FBL~IDDocument~INN~${missing.join(',')}/0/${missing.length}`);
			(Array.isArray(docs) ? docs : []).forEach((d) => { this._docMeta[d.IDDocument] = { Name: d.Name || `Document ${d.IDDocument}`, Locked: !!(d.Locked || d.IsLocked), DocumentType: d.DocumentType }; });
		}
		return docIDs;
	}
	async _loadTeams()
	{
		const docIDs = await this._loadPacket();
		if (!docIDs.length) { return []; }
		const rows = await this._get(`DocumentAccessJoins/FilteredTo/FBL~IDDocument~INN~${docIDs.join(',')}~FBV~Deleted~EQ~0/0/500`);
		const byTeam = {};
		(Array.isArray(rows) ? rows : []).forEach((g) => { const t = Number(g.IDTeam) || 0; if (!t) { return; } if (!byTeam[t]) { byTeam[t] = new Set(); } byTeam[t].add(g.IDDocument); });
		const teamIDs = Object.keys(byTeam).map(Number);
		await this._resolveNames('team', teamIDs, (ids) => `Teams/FilteredTo/FBL~IDTeam~INN~${ids.join(',')}/0/${ids.length}`, { id: (t) => t.IDTeam, name: (t) => t.Name || `Team ${t.IDTeam}` });
		return teamIDs.map((t) => ({ IDTeam: t, Covered: byTeam[t].size, Total: docIDs.length })).sort((a, b) => b.Covered - a.Covered);
	}
	async _loadTimeline()
	{
		const rows = await this._get(`InspectionEventLogs/FilteredTo/FBV~IDInspection~EQ~${this.idInspection}~FBV~Deleted~EQ~0~FSF~IDInspectionEventLog~DESC~0/0/200`);
		const list = Array.isArray(rows) ? rows : [];
		await this._resolveNames('user', list.map((r) => r.IDUser), (ids) => `Users/FilteredTo/FBL~IDUser~INN~${ids.join(',')}/0/${ids.length}`, { id: (u) => u.IDUser, name: (u) => [ u.NameFirst, u.NameLast ].filter(Boolean).join(' ') || u.LoginID || `#${u.IDUser}` });
		return list;
	}

	_assetMeta(pID) { const raw = this._names.asset[pID]; if (!raw) { return { Name: `Asset ${pID}` }; } try { return JSON.parse(raw); } catch (e) { return { Name: raw }; } }
	_statusClass(pStatus)
	{
		const s = String(pStatus || '').toLowerCase();
		if (s.indexOf('complete') >= 0 || s.indexOf('closed') >= 0) { return 'is-complete'; }
		if (s.indexOf('progress') >= 0 || s.indexOf('active') >= 0 || s.indexOf('field') >= 0) { return 'is-progress'; }
		if (s.indexOf('schedul') >= 0 || s.indexOf('pending') >= 0 || s === '') { return 'is-scheduled'; }
		return 'is-other';
	}

	// =========================================================== interactions ===========================================================
	toggleEdit() { this._editing = !this._editing; this.repaintBody(); this._scheduleMount('overview'); }
	async saveDetails()
	{
		const CA = this.pict.ContentAssignment; const g = (sel) => { const el = CA.getElement(sel); return (el && el.length) ? el[0].value : undefined; };
		const payload = { IDInspection: this.idInspection };
		const name = g('#InspectionWorkspace-Name'); if (name !== undefined) { payload.Name = name; }
		const desc = g('#InspectionWorkspace-Description'); if (desc !== undefined) { payload.Description = desc; }
		const sched = g('#InspectionWorkspace-Scheduled'); if (sched !== undefined) { payload.ScheduledStartDate = sched || null; }
		const dead = g('#InspectionWorkspace-Deadline'); if (dead !== undefined) { payload.DeadlineDate = dead || null; }
		const type = g('#InspectionWorkspace-Type'); if (type !== undefined) { payload.IDInspectionType = Number(type) || 0; }
		try
		{
			await this._putJSON('Inspection', payload);
			// reflect the edits on the in-memory record (incl. resolved type display for the header/overview)
			Object.assign(this._inspection, payload);
			this._inspection.TypeDisplay = this._names.type[this._inspection.IDInspectionType] || this._inspection.TypeDisplay || '';
		}
		catch (e) { this.pict.log.error(`Save inspection failed: ${e.message || e}`); }
		this._editing = false;
		this.repaintBody(); this._scheduleMount('overview');
	}
	async addAsset(pIDAsset)
	{
		const id = Number(pIDAsset) || 0; if (!id) { return; }
		try { await this._postJSON('InspectionPhysicalAssetJoin', { IDInspection: this.idInspection, IDPhysicalAsset: id, IDCustomer: this.idCustomer }); }
		catch (e) { this.pict.log.error(`Add asset failed: ${e.message || e}`); }
		this._reload('assets');
	}
	async removeAsset(pIDJoin) { const id = Number(pIDJoin) || 0; if (!id) { return; } try { await this._deleteJSON(`InspectionPhysicalAssetJoin/${id}`); } catch (e) { this.pict.log.error(`Remove asset failed: ${e.message || e}`); } this._reload('assets'); }
	async addDocument(pIDDocument)
	{
		const id = Number(pIDDocument) || 0; if (!id) { return; }
		const rows = this._state('documents').Rows || [];
		const nextOrdinal = rows.reduce((m, r) => Math.max(m, Number(r.Ordinal) || 0), -1) + 1;
		try { await this._postJSON('InspectionDocumentJoin', { IDInspection: this.idInspection, IDDocument: id, IncludeOnDossier: true, Ordinal: nextOrdinal, IDCustomer: this.idCustomer }); }
		catch (e) { this.pict.log.error(`Add document failed: ${e.message || e}`); }
		this._reload('documents');
	}
	async removeDocument(pIDJoin) { const id = Number(pIDJoin) || 0; if (!id) { return; } try { await this._deleteJSON(`InspectionDocumentJoin/${id}`); } catch (e) { this.pict.log.error(`Remove document failed: ${e.message || e}`); } this._reload('documents'); }
	async toggleDossier(pIDJoin)
	{
		const id = Number(pIDJoin) || 0; if (!id) { return; }
		const row = (this._state('documents').Rows || []).find((r) => r.IDInspectionDocumentJoin === id); if (!row) { return; }
		try { await this._putJSON('InspectionDocumentJoin', { IDInspectionDocumentJoin: id, IncludeOnDossier: !(row.IncludeOnDossier) }); }
		catch (e) { this.pict.log.error(`Toggle dossier failed: ${e.message || e}`); }
		this._reload('documents');
	}
	async moveDocument(pIDJoin, pDir)
	{
		const rows = (this._state('documents').Rows || []).slice(); const i = rows.findIndex((r) => r.IDInspectionDocumentJoin === Number(pIDJoin));
		const j = i + (pDir < 0 ? -1 : 1); if (i < 0 || j < 0 || j >= rows.length) { return; }
		const a = rows[i]; const b = rows[j]; const ao = Number(a.Ordinal) || 0; const bo = Number(b.Ordinal) || 0;
		try { await Promise.all([ this._putJSON('InspectionDocumentJoin', { IDInspectionDocumentJoin: a.IDInspectionDocumentJoin, Ordinal: bo }), this._putJSON('InspectionDocumentJoin', { IDInspectionDocumentJoin: b.IDInspectionDocumentJoin, Ordinal: ao }) ]); }
		catch (e) { this.pict.log.error(`Reorder failed: ${e.message || e}`); }
		this._reload('documents');
	}
	async addInspector(pIDUser)
	{
		if (!this.canStaff) { this.pict.log.warn('Only a team leader can change who is on an inspection.'); return; }
		const id = Number(pIDUser) || 0; if (!id) { return; }
		try { await this._postJSON('InspectionUserJoin', { IDInspection: this.idInspection, IDUser: id, IDCustomer: this.idCustomer }); }
		catch (e) { this.pict.log.error(`Add inspector failed: ${e.message || e}`); }
		this._reload('inspectors');
	}
	async removeInspector(pIDJoin) { if (!this.canStaff) { this.pict.log.warn('Only a team leader can change who is on an inspection.'); return; } const id = Number(pIDJoin) || 0; if (!id) { return; } try { await this._deleteJSON(`InspectionUserJoin/${id}`); } catch (e) { this.pict.log.error(`Remove inspector failed: ${e.message || e}`); } this._reload('inspectors'); }
	// Assign a team = grant it EVERY document in the inspection's packet (Steven's decision: grant the whole packet, since a
	// grant on the dossier doc does not propagate to its poly-children). Idempotent: skips docs the team already holds.
	async assignTeam(pIDTeam)
	{
		const idTeam = Number(pIDTeam) || 0; if (!idTeam) { return; }
		const docIDs = (this._packetDocIDs && this._packetDocIDs.length) ? this._packetDocIDs : await this._loadPacket();
		if (!docIDs.length) { this.pict.log.warn('This inspection has no documents to grant — attach its packet first.'); return; }
		const existing = new Set();
		try { const rows = await this._get(`DocumentAccessJoins/FilteredTo/FBV~IDTeam~EQ~${idTeam}~FBL~IDDocument~INN~${docIDs.join(',')}~FBV~Deleted~EQ~0/0/500`); (Array.isArray(rows) ? rows : []).forEach((g) => existing.add(g.IDDocument)); }
		catch (e) { /* treat as none owned */ }
		const toGrant = docIDs.filter((id) => !existing.has(id));
		try
		{
			await Promise.all(toGrant.map((id) => { const meta = (this._docMeta || {})[id] || {}; return this._postJSON('DocumentAccessJoin', { IDTeam: idTeam, IDDocument: id, DocumentType: meta.DocumentType || '', IDRole: 0, AccessKind: 'Owner', GrantRule: 'Config', IDCustomer: this.idCustomer }); }));
		}
		catch (e) { this.pict.log.error(`Assign team failed: ${e.message || e}`); }
		this._reload('teams');
	}
	async unassignTeam(pIDTeam)
	{
		const idTeam = Number(pIDTeam) || 0; if (!idTeam) { return; }
		const docIDs = (this._packetDocIDs && this._packetDocIDs.length) ? this._packetDocIDs : await this._loadPacket();
		if (!docIDs.length) { this._reload('teams'); return; }
		try
		{
			const rows = await this._get(`DocumentAccessJoins/FilteredTo/FBV~IDTeam~EQ~${idTeam}~FBL~IDDocument~INN~${docIDs.join(',')}~FBV~Deleted~EQ~0/0/500`);
			const joins = (Array.isArray(rows) ? rows : []).map((g) => g.IDDocumentAccessJoin).filter(Boolean);
			await Promise.all(joins.map((j) => this._deleteJSON(`DocumentAccessJoin/${j}`)));
		}
		catch (e) { this.pict.log.error(`Unassign team failed: ${e.message || e}`); }
		this._reload('teams');
	}
	// Same-origin HTML render (viewer/editor) — NEVER Fieldbook; falls back to PDF if the service is missing.
	openHTML(pIDDocument, pReadOnly)
	{
		const id = Number(pIDDocument) || 0; if (!id) { return; }
		const svc = this._docRender;
		if (!svc || (typeof svc.openDocument !== 'function')) { this.downloadPDF(id); return; }
		svc.openDocument(id, { target: '_blank', variation: pReadOnly ? 'html' : 'default' }, (pError) => { if (pError) { try { this.pict.log.error(`Open document ${id} failed: ${pError.message || pError}`); } catch (e) { /* */ } } });
	}
	downloadPDF(pIDDocument) { const id = Number(pIDDocument) || 0; if (!id) { return; } const svc = this._docRender; if (svc && (typeof svc.downloadPDFLink === 'function')) { svc.downloadPDFLink(id); return; } try { window.open(`${this.restClient.serverURL || '/1.0/'}Document/${id}/DCR.pdf`, '_blank', 'noopener'); } catch (e) { /* */ } }
	openAsset(pIDAsset) { const id = Number(pIDAsset) || 0; if (id) { try { window.location.hash = `#/Asset/Workspace/${id}`; } catch (e) { /* */ } } }
	openProject() { const id = Number(this._inspection && this._inspection.IDProject) || 0; if (id) { try { window.location.hash = `#/Project/Workspace/${id}`; } catch (e) { /* */ } } }

	// =========================================================== tab bodies ===========================================================
	_overviewHTML()
	{
		const t = this._inspection || {}; const s = this._state('overview'); const P = this.providerName;
		const loading = this._loadingOrError('overview');
		const status = t.StatusDisplay || 'Scheduled';
		const typeName = this._names.type[t.IDInspectionType] || t.TypeDisplay || '';
		const now = new Date();
		const overdue = t.DeadlineDate && !(/complete|closed/i.test(status)) && (new Date(t.DeadlineDate).getTime() < now.getTime());
		if (this._editing)
		{
			const opts = this._typeOptions.map((o) => `<option value="${o.IDInspectionType}"${o.IDInspectionType === t.IDInspectionType ? ' selected' : ''}>${this._esc(o.Name)}</option>`).join('');
			return `<div class="iw-editgrid">
				<label>Name<input id="InspectionWorkspace-Name" type="text" value="${this._esc(t.Name || '')}"></label>
				<label>Type<select id="InspectionWorkspace-Type">${opts}</select></label>
				<label>Scheduled start<input id="InspectionWorkspace-Scheduled" type="date" value="${this._dateInput(t.ScheduledStartDate)}"></label>
				<label>Deadline<input id="InspectionWorkspace-Deadline" type="date" value="${this._dateInput(t.DeadlineDate)}"></label>
				<label>Description<textarea id="InspectionWorkspace-Description">${this._esc(t.Description || '')}</textarea></label>
			</div>
			<div class="iw-editbar"><button class="iw-btn iw-ghost" onclick="_Pict.providers.${P}.toggleEdit()">Cancel</button><button class="iw-btn" onclick="_Pict.providers.${P}.saveDetails()"><i class="fas fa-check"></i> Save details</button></div>`;
		}
		const stats = loading ? '' : `<div class="iw-stats">
			<div class="iw-stat"><div class="iw-stat-v">${(s.Assets || 0).toLocaleString()}</div><div class="iw-stat-l">Assets</div></div>
			<div class="iw-stat"><div class="iw-stat-v">${(s.Documents || 0).toLocaleString()}</div><div class="iw-stat-l">Documents</div></div>
			<div class="iw-stat"><div class="iw-stat-v">${(s.Inspectors || 0).toLocaleString()}</div><div class="iw-stat-l">Inspectors</div></div>
		</div>`;
		return `<div class="iw-pillrow">
				<span class="iw-status ${this._statusClass(status)}">${this._esc(status)}</span>
				${typeName ? `<span class="iw-typepill">${this._esc(typeName)}</span>` : ''}
				<span style="flex:1"></span>
				<button class="iw-btn iw-ghost" onclick="_Pict.providers.${P}.toggleEdit()"><i class="fas fa-pen"></i> Edit details</button>
			</div>
			${stats}
			<div class="iw-fields">
				<div><div class="iw-field-label">Scheduled start</div><div class="iw-field-value">${t.ScheduledStartDate ? this._esc(this._fmtDate(t.ScheduledStartDate)) : '<span class="iw-muted">— not set —</span>'}</div></div>
				<div><div class="iw-field-label">Deadline</div><div class="iw-field-value ${overdue ? 'iw-overdue' : ''}">${t.DeadlineDate ? this._esc(this._fmtDate(t.DeadlineDate)) + (overdue ? ' · overdue' : '') : '<span class="iw-muted">— not set —</span>'}</div></div>
				<div><div class="iw-field-label">Started</div><div class="iw-field-value">${t.StartDate ? this._esc(this._fmtDate(t.StartDate)) : '<span class="iw-muted">—</span>'}</div></div>
				<div><div class="iw-field-label">Ended</div><div class="iw-field-value">${t.EndDate ? this._esc(this._fmtDate(t.EndDate)) : '<span class="iw-muted">—</span>'}</div></div>
				<div><div class="iw-field-label">Project</div><div class="iw-field-value">${t.IDProject ? `<a class="iw-link" href="#/Project/Workspace/${t.IDProject}">${this._esc(this._names.project[t.IDProject] || ('Project ' + t.IDProject))} <i class="fas fa-arrow-up-right-from-square" style="font-size:0.7em"></i></a>` : '<span class="iw-muted">—</span>'}</div></div>
			</div>
			${t.Description ? `<div class="iw-sec-h">Description</div><div class="iw-field-value">${this._esc(t.Description)}</div>` : ''}
			<div class="iw-hint"><i class="fas fa-circle-info"></i> Status is set by the inspection's forms and the access engine; edit the schedulable fields (name, type, dates) here.</div>`;
	}

	_assetsHTML()
	{
		const loading = this._loadingOrError('assets'); if (loading) { return loading; }
		const P = this.providerName; const rows = this._state('assets').Rows || [];
		const add = `<div class="iw-addbar"><div class="iw-f"><span class="iw-f-l">Add an asset under inspection</span><div id="InspectionWorkspace-AssetPicker" class="iw-pick"></div></div></div>`;
		const body = rows.length ? `<table class="iw-table"><thead><tr><th>Asset</th><th>Asset #</th><th>Structure</th><th></th></tr></thead><tbody>${rows.map((r) => { const m = this._assetMeta(r.IDPhysicalAsset); return `<tr>
			<td><a class="iw-link" href="#/Asset/Workspace/${r.IDPhysicalAsset}">${this._esc(m.Name || ('Asset ' + r.IDPhysicalAsset))}</a></td>
			<td>${m.AssetNumber ? `<span class="iw-chip">${this._esc(m.AssetNumber)}</span>` : '<span class="iw-muted">—</span>'}</td>
			<td>${m.Structure ? `<span class="iw-chip">${this._esc(m.Structure)}</span>` : '<span class="iw-muted">—</span>'}</td>
			<td style="text-align:right"><button class="iw-x" title="Remove from inspection" onclick="_Pict.providers.${P}.removeAsset(${r.IDInspectionPhysicalAssetJoin})"><i class="fas fa-xmark"></i></button></td>
		</tr>`; }).join('')}</tbody></table>` : `<div class="iw-empty">No assets on this inspection yet — add the structure(s) being inspected above.</div>`;
		return add + body;
	}

	_documentsHTML()
	{
		const loading = this._loadingOrError('documents'); if (loading) { return loading; }
		const P = this.providerName; const rows = this._state('documents').Rows || [];
		const add = `<div class="iw-addbar"><div class="iw-f"><span class="iw-f-l">Attach a document to this inspection</span><div id="InspectionWorkspace-DocPicker" class="iw-pick"></div></div></div>`;
		const hint = `<div class="iw-hint"><i class="fas fa-folder-open"></i> The document packet, in dossier order. Toggle the star to include a document in the compiled dossier; open a form as read-only HTML or (when unlocked) editable — never Fieldbook.</div>`;
		const body = rows.length ? `<table class="iw-table"><thead><tr><th style="width:2.5rem">Dossier</th><th>Document</th><th>Type</th><th style="width:4.5rem">Order</th><th></th></tr></thead><tbody>${rows.map((r, i) => { const m = (this._docMeta || {})[r.IDDocument] || {}; const on = !!r.IncludeOnDossier; const locked = !!m.Locked; return `<tr>
			<td style="text-align:center"><i class="fas fa-star iw-dossier ${on ? 'on' : 'off'}" title="${on ? 'On the dossier — click to exclude' : 'Not on the dossier — click to include'}" onclick="_Pict.providers.${P}.toggleDossier(${r.IDInspectionDocumentJoin})"></i></td>
			<td><span class="iw-name">${this._esc(m.Name || ('Document ' + r.IDDocument))}</span>${locked ? ' <i class="fas fa-lock iw-muted" title="Locked — read-only" style="font-size:0.75em"></i>' : ''}</td>
			<td><span class="iw-chip">${this._esc(r.DocumentType || m.DocumentType || '—')}</span></td>
			<td style="white-space:nowrap"><button class="iw-ord" title="Move up"${i === 0 ? ' disabled' : ''} onclick="_Pict.providers.${P}.moveDocument(${r.IDInspectionDocumentJoin}, -1)"><i class="fas fa-arrow-up"></i></button><button class="iw-ord" title="Move down"${i === rows.length - 1 ? ' disabled' : ''} onclick="_Pict.providers.${P}.moveDocument(${r.IDInspectionDocumentJoin}, 1)"><i class="fas fa-arrow-down"></i></button></td>
			<td style="text-align:right; white-space:nowrap">
				${locked ? '' : `<button class="iw-act" title="Open editable HTML" onclick="_Pict.providers.${P}.openHTML(${r.IDDocument}, false)"><i class="fas fa-pen-to-square"></i> Edit</button> `}
				<button class="iw-act" title="View read-only HTML" onclick="_Pict.providers.${P}.openHTML(${r.IDDocument}, true)"><i class="fas fa-eye"></i> View</button>
				<button class="iw-act iw-act-icon" title="Download PDF" onclick="_Pict.providers.${P}.downloadPDF(${r.IDDocument})"><i class="fas fa-file-pdf"></i></button>
				<button class="iw-x" title="Remove from inspection" onclick="_Pict.providers.${P}.removeDocument(${r.IDInspectionDocumentJoin})"><i class="fas fa-xmark"></i></button>
			</td>
		</tr>`; }).join('')}</tbody></table>` : `<div class="iw-empty">No documents attached yet. A scheduled inspection's forms are generated from its type — attach them here to build the dossier.</div>`;
		return add + hint + body;
	}

	/**
	 * May this session staff an inspection — add or unassign inspectors?
	 *
	 * Whoever leads a team can. Leadership is a role held on the TEAM (TeamUserJoin.IDRole), not on the
	 * inspection: an inspection records only who worked it. So a lead staffs crews wherever they are
	 * pulled in, which is how the work actually runs — leads hold different specialisms and bring each
	 * other in as ordinary inspectors depending on the structure.
	 *
	 * Program-tier users (administrators) can always staff. This is a UI affordance, not enforcement —
	 * the server does not gate InspectionUserJoin writes.
	 *
	 * @return {Boolean}
	 */
	get canStaff()
	{
		const tmpScope = this.pict.providers.InspectionScope;
		if (!tmpScope || !tmpScope.scope) { return true; }
		if (tmpScope.scope.Tier === 'program') { return true; }
		return (tmpScope.scope.LedTeamIDs || []).length > 0;
	}

	_inspectorsHTML()
	{
		const loading = this._loadingOrError('inspectors'); if (loading) { return loading; }
		const P = this.providerName; const rows = this._state('inspectors').Rows || [];
		const canStaff = this.canStaff;
		const add = canStaff
			? `<div class="iw-addbar"><div class="iw-f"><span class="iw-f-l">Assign an inspector</span><div id="InspectionWorkspace-UserPicker" class="iw-pick"></div></div></div>`
			: '';
		const hint = canStaff
			? `<div class="iw-hint"><i class="fas fa-circle-info"></i> Individual assignments. Team-based assignment (auto-granting access through the engine) arrives in the Teams phase.</div>`
			: `<div class="iw-hint"><i class="fas fa-circle-info"></i> Only a team leader can change who is on an inspection.</div>`;
		const body = rows.length ? `<table class="iw-table"><thead><tr><th>Inspector</th>${canStaff ? '<th></th>' : ''}</tr></thead><tbody>${rows.map((r) => `<tr>
			<td><span class="iw-name">${this._esc(this._names.user[r.IDUser] || ('#' + r.IDUser))}</span></td>
			${canStaff ? `<td style="text-align:right"><button class="iw-x" title="Unassign" onclick="_Pict.providers.${P}.removeInspector(${r.IDInspectionUserJoin})"><i class="fas fa-user-minus"></i></button></td>` : ''}
		</tr>`).join('')}</tbody></table>` : `<div class="iw-empty">No inspectors assigned yet.</div>`;
		return add + hint + body;
	}

	_teamsHTML()
	{
		const loading = this._loadingOrError('teams'); if (loading) { return loading; }
		const P = this.providerName; const rows = this._state('teams').Rows || [];
		const add = `<div class="iw-addbar"><div class="iw-f"><span class="iw-f-l">Assign a team to this inspection</span><div id="InspectionWorkspace-TeamPicker" class="iw-pick"></div></div></div>`;
		const hint = `<div class="iw-hint"><i class="fas fa-users"></i> Assigning a team grants it every document in this inspection's packet. Its members can open and edit them, and reach the inspection's project, without being added to the project.</div>`;
		const body = rows.length ? `<table class="iw-table"><thead><tr><th>Team</th><th>Packet coverage</th><th></th></tr></thead><tbody>${rows.map((r) => `<tr>
			<td><a class="iw-link" href="#/Team/Workspace/${r.IDTeam}">${this._esc(this._names.team[r.IDTeam] || ('Team ' + r.IDTeam))}</a></td>
			<td><span class="iw-chip">${r.Covered} of ${r.Total} docs</span>${r.Covered < r.Total ? ' <span class="iw-muted" title="Some packet documents are not shared with this team">partial</span>' : ''}</td>
			<td style="text-align:right"><button class="iw-x" title="Unassign team (revoke the whole packet)" onclick="_Pict.providers.${P}.unassignTeam(${r.IDTeam})"><i class="fas fa-users-slash"></i></button></td>
		</tr>`).join('')}</tbody></table>` : `<div class="iw-empty">No teams assigned yet — assign one above to grant its members the whole packet.</div>`;
		return add + hint + body;
	}

	_timelineHTML()
	{
		const loading = this._loadingOrError('timeline'); if (loading) { return loading; }
		const rows = this._state('timeline').Rows || [];
		const body = rows.length ? `<table class="iw-table"><thead><tr><th>When</th><th>Event</th><th>By</th><th>Detail</th></tr></thead><tbody>${rows.map((r) => `<tr>
			<td style="white-space:nowrap">${this._esc(this._fmtDate(r.CreateDate))}</td>
			<td><span class="iw-name">${this._esc(r.Event || '—')}</span></td>
			<td>${r.IDUser ? this._esc(this._names.user[r.IDUser] || ('#' + r.IDUser)) : '<span class="iw-muted">system</span>'}</td>
			<td>${r.Datum ? this._esc(String(r.Datum).slice(0, 200)) : '<span class="iw-muted">—</span>'}</td>
		</tr>`).join('')}</tbody></table>` : `<div class="iw-empty">No events logged for this inspection yet.</div>`;
		return `<div class="iw-hint"><i class="fas fa-clock-rotate-left"></i> Read-only audit trail (most recent first).</div>${body}`;
	}

	// =========================================================== pickers ===========================================================
	_scheduleMount(pTab) { try { setTimeout(() => this._mountPickers(pTab), 0); } catch (e) { /* */ } }
	_picker() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }
	_mountPickers(pTab)
	{
		const tmpPicker = this._picker(); const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const mount = (pHostID, pName, pDataProvider, pOnChange, pPlaceholder, pExtra) =>
		{
			if (tmpCA.getElement(`#${pHostID}`).length === 0) { return; }
			const v = tmpPicker.createPicker(`${this.providerName}-${pName}`, Object.assign({
				DestinationAddress: `#${pHostID}`, ValueAddress: `AppData.${this.providerName}.${pName}`,
				Searchable: true, AllowClear: true, ClearLabel: `— ${pPlaceholder} —`, Placeholder: `${pPlaceholder}…`,
				DataProvider: pDataProvider, ResolveValue: () => Promise.resolve(null), OnChange: pOnChange,
			}, pExtra || {}));
			if (v && (typeof v.render === 'function')) { v.render(); }
		};
		if (pTab === 'assets') { mount('InspectionWorkspace-AssetPicker', 'AssetPicker', this._assetDataProvider(), (val) => { if (val) { this.addAsset(val); } }, 'search assets'); }
		else if (pTab === 'documents')
		{
			mount('InspectionWorkspace-DocPicker', 'DocPicker', this._docDataProvider(), (val) => { if (val) { this.addDocument(val); } }, 'name or number in this project',
				{ EmptyLabel: (pTerm) => libDocumentLookup.documentSearchEmptyLabel(pTerm, this._inspectionProject) });
		}
		else if (pTab === 'inspectors') { if (this.canStaff) { mount('InspectionWorkspace-UserPicker', 'UserPicker', this._userDataProvider(), (val) => { if (val) { this.addInspector(val); } }, 'search people'); } }
		else if (pTab === 'teams') { mount('InspectionWorkspace-TeamPicker', 'TeamPicker', this._teamDataProvider(), (val) => { if (val) { this.assignTeam(val); } }, 'search teams'); }
	}
	_teamDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'Teams', IDField: 'IDTeam', Scope: () => `FBV~IDCustomer~EQ~${this.idCustomer}~FBV~Deleted~EQ~0`,
				ToOption: (r) => ({ Value: Number(r.IDTeam), Text: r.Name || `Team ${r.IDTeam}`, Record: r }),
			});
	}
	_assetDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'PhysicalAssets', IDField: 'IDPhysicalAsset', Scope: () => `FBV~IDCustomer~EQ~${this.idCustomer}~FBV~Deleted~EQ~0`,
				ToOption: (r) => ({ Value: Number(r.IDPhysicalAsset), Text: (r.Name || `Asset ${r.IDPhysicalAsset}`) + (r.ExternalSyncGUID ? ` · ${r.ExternalSyncGUID}` : ''), Record: r }),
			});
	}
	get _inspectionProject()
	{
		return Number(this._inspection && this._inspection.IDProject) || 0;
	}
	// Documents are found by number, or by name within the inspection's project (never a customer-wide name scan).
	_docDataProvider()
	{
		return libDocumentLookup.documentPickerDataProvider((pURL) => this._get(pURL), () => ({ IDCustomer: this.idCustomer, IDProject: this._inspectionProject }));
	}
	_userDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._get(pURL), { Scope: 'FBV~Deleted~EQ~0', PageSize: 25 });
	}
}

module.exports = InspectionWorkspaceProvider;
module.exports.default_configuration = { ProviderIdentifier: 'InspectionWorkspace' };

},{"../access/User-Search.js":1064,"../documents/Document-Lookup.js":1269,"../services/Entity-Picker-Search.js":1398,"pict-section-workspace":1049}],1344:[function(require,module,exports){

// Shared controller for editing per-observation-type LABEL BEHAVIORS (Free Entry / Max Count / Hidden, plus
// the per-type Auto-Filter/distilling switch). Mirrors the LabelManagerController pattern: a plain class (NOT a
// pict provider) driven by a host provider, exporting a shared template set (LABELBEHAVIOR_TEMPLATES) + CSS
// (LABELBEHAVIOR_CSS). Template handlers call back into the host by name via Record.ProviderName, so one
// template serves both hosts (the Project workspace and My Headlight).
//
// WHERE THESE LIVE (see memory observation-label-behaviors-storage): unlike the label VOCABULARY (ProjectTagType,
// edited by LabelManagerController), a label's BEHAVIOR is keyed per (ObservationType x TagType) inside the
// ObservationType "Configuration" cascade blob at PropertyInfo/<TagType>/<Flag>. The Auto-Filter switch is a
// per-observation-type flag in a SEPARATE blob (NamespaceKey 'DistillingService', NamespaceValue 'Library').
// Both are read/written with the standard Configuration/Get + Configuration/Put/<Namespace>/<Value>/<Scope>/<ID>
// endpoints the config app already uses (ConfigClone, PermissionMatrix). Reads return the merged-EFFECTIVE config
// at the scope; Put diffs the submitted config against the parent scope and stores only the overrides, so we
// READ-MERGE-WRITE the whole namespace-value config (never a partial — a key omitted from the submission is
// treated as "revert to inherited" and its override is deleted).
//
// Two scopes, same blobs:
//   - customer DEFAULT (My Headlight):  LevelContext 'Customer', ContextID <customer>   (IDProject 0)
//   - per-PROJECT (Project workspace):  LevelContext 'Project',  ContextID <project>
// The server (Configuration-Put-ByNamespace) authorizes Customer/Contract/Project writes for a CustomerAdmin
// role (or a Headlight super-user); Global is super-only. We gate the UI on the host's canManageLabels and
// surface any server refusal as a toast.

const libConfigSync = require('./ConfigSync.js');

const OBS_NAMESPACE = 'ObservationType';
const DISTILL_NAMESPACE = 'DistillingService';
const DISTILL_VALUE = 'Library';
// Config document keys that are not observation types (skip them when enumerating types).
const NON_TYPE_KEYS = new Set(['Config', 'LevelControlRecords', 'LevelControlRecord']);

class LabelBehaviorController
{
	/**
	 * @param {any} pPict
	 * @param {String} pProviderName - the host provider's identifier (the template calls it back by name).
	 */
	constructor(pPict, pProviderName)
	{
		this.pict = pPict;
		this.providerName = pProviderName;

		this.scope = { IDProject: 0, IDCustomer: 0 };
		this.canManage = false;
		this._onChange = () => {};

		// The full ObservationType config document at this scope, keyed by observation-type name; each value is
		// { ObservationType, PropertyInfo: { <TagType>: { EntityType, FreeEntry, MaxCount, Hidden, ... } }, ... }.
		this._doc = {};
		// The DistillingService 'Library' config: { DistillingEnabled: <scope default>, ByType: { <type>: { DistillingEnabled } } }.
		this._distill = { DistillingEnabled: false, ByType: {} };
		this.types = [];        // [{ Type, DisplayName, LabelCount }] — only types that carry >=1 label
		this.selectedType = '';
		this.loading = false;
		this.busy = false;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	_toast(pMessage, pType)
	{
		if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); }
	}

	/**
	 * After a behavior change, (debounced) publish this scope's config to the field apps (Fieldbook) — a Project
	 * sync for a project scope, a Customer sync for the customer-default scope. Same seam LabelManagerController
	 * uses; without it, a toggled flag is saved but never reaches Fieldbook. Debounced + permission-gated inside
	 * ConfigSync (a non-super-user without Module-PlatformConfiguration-Access gets a gentle notice instead).
	 */
	_requestConfigSync()
	{
		if (Number(this.scope.IDProject) > 0)
		{
			libConfigSync.requestSync(this.pict, 'Project', this.scope.IDProject);
		}
		else if (Number(this.scope.IDCustomer) > 0)
		{
			libConfigSync.requestSync(this.pict, 'Customer', this.scope.IDCustomer);
		}
	}

	// --- REST (promisified) ---

	_postJSON(pURL, pBody)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pBody, (pError, pBody2) => pError ? reject(pError) : resolve(pBody2));
		});
	}

	/** The Configuration cascade level for this scope: Project when a project is set, else Customer default. */
	_level()
	{
		return (Number(this.scope.IDProject) > 0)
			? { Context: 'Project', ContextID: Number(this.scope.IDProject) }
			: { Context: 'Customer', ContextID: Number(this.scope.IDCustomer) };
	}

	/** Read the merged-effective config for a namespace at this scope. Returns the document (unwrapped). */
	async _getConfig(pNamespaceKey)
	{
		const tmpLevel = this._level();
		const tmpBody = await this._postJSON('Configuration/Get',
			{ LevelContext: tmpLevel.Context, LevelContextID: tmpLevel.ContextID, NamespaceKey: pNamespaceKey });
		return (tmpBody && (tmpBody.Document || tmpBody)) || {};
	}

	/**
	 * Read-merge-write the WHOLE config for one namespace value at this scope. The server diffs against the
	 * parent scope and stores only the overrides, so we always submit the full (merged) document.
	 * @param {String} pNamespaceKey
	 * @param {String} pNamespaceValue
	 * @param {Object} pConfig - the complete config object for that value
	 */
	async _putConfig(pNamespaceKey, pNamespaceValue, pConfig)
	{
		const tmpLevel = this._level();
		const tmpURL = `Configuration/Put/${pNamespaceKey}/${encodeURIComponent(pNamespaceValue)}/${tmpLevel.Context}/${tmpLevel.ContextID}`;
		return this._postJSON(tmpURL, { Config: pConfig });
	}

	/**
	 * Point the controller at a scope + permission and register the host's re-render.
	 * @param {{IDProject:Number, IDCustomer:Number}} pScope
	 * @param {Boolean} pCanManage
	 * @param {Function} pOnChange
	 */
	setContext(pScope, pCanManage, pOnChange)
	{
		this.scope = pScope || { IDProject: 0, IDCustomer: 0 };
		this.canManage = !!pCanManage;
		this._onChange = (typeof pOnChange === 'function') ? pOnChange : () => {};
		this._doc = {};
		this._distill = { DistillingEnabled: false, ByType: {} };
		this.types = [];
		this.selectedType = '';
	}

	/** The label (EntityType==='Label') PropertyInfo entries of one observation type, as [ [TagType, entry], ... ]. */
	_labelEntries(pType)
	{
		const tmpTypeConfig = this._doc[pType];
		const tmpPropertyInfo = tmpTypeConfig && tmpTypeConfig.PropertyInfo;
		if (!tmpPropertyInfo || (typeof tmpPropertyInfo !== 'object')) { return []; }
		return Object.keys(tmpPropertyInfo)
			.map((pTagType) => [ pTagType, tmpPropertyInfo[pTagType] ])
			.filter((pPair) => pPair[1] && (pPair[1].EntityType === 'Label'));
	}

	/** Recompute the type list (only observation types that carry at least one label) from the loaded doc. */
	_rebuildTypes()
	{
		this.types = Object.keys(this._doc)
			.filter((pKey) => !NON_TYPE_KEYS.has(pKey))
			.map((pType) =>
			{
				const tmpLabels = this._labelEntries(pType);
				const tmpConfig = this._doc[pType] || {};
				const tmpDisplay = tmpConfig.ObservationDisplayName || tmpConfig.DisplayName || pType;
				return { Type: pType, DisplayName: tmpDisplay, LabelCount: tmpLabels.length };
			})
			.filter((pEntry) => pEntry.LabelCount > 0)
			.sort((a, b) => String(a.DisplayName || '').localeCompare(String(b.DisplayName || '')));
		// Keep a valid selection.
		if (!this.types.some((pEntry) => pEntry.Type === this.selectedType))
		{
			this.selectedType = this.types.length ? this.types[0].Type : '';
		}
	}

	// --- Data ops ---

	async load()
	{
		this.loading = true;
		this._onChange();
		try
		{
			const tmpDoc = await this._getConfig(OBS_NAMESPACE);
			this._doc = (tmpDoc && typeof tmpDoc === 'object') ? tmpDoc : {};
			// The distilling switches live in their own namespace; best-effort (absent = all off).
			try
			{
				const tmpDistillDoc = await this._getConfig(DISTILL_NAMESPACE);
				const tmpLibrary = (tmpDistillDoc && (tmpDistillDoc.Library || (tmpDistillDoc.Config && tmpDistillDoc.Config.Library))) || {};
				this._distill = { DistillingEnabled: !!tmpLibrary.DistillingEnabled, ByType: (tmpLibrary.ByType && typeof tmpLibrary.ByType === 'object') ? tmpLibrary.ByType : {} };
			}
			catch (pError) { this._distill = { DistillingEnabled: false, ByType: {} }; }
			this._rebuildTypes();
		}
		catch (pError)
		{
			this._doc = {};
			this.types = [];
			this._toast(`Could not load label behaviors: ${pError.message || pError}`, 'error');
		}
		this.loading = false;
		this._onChange();
	}

	/** Switch the active observation type (client-side; the config for every type is already loaded). */
	selectType(pType)
	{
		if (this._doc[pType]) { this.selectedType = pType; this._onChange(); }
	}

	/** Whether Auto-Filter (distilling) is on for the selected type (per-type override, else the scope default). */
	_distillingEnabledFor(pType)
	{
		const tmpByType = this._distill.ByType || {};
		if (tmpByType[pType] && (typeof tmpByType[pType].DistillingEnabled === 'boolean')) { return tmpByType[pType].DistillingEnabled; }
		return !!this._distill.DistillingEnabled;
	}

	/** Guard + fetch the PropertyInfo entry for a (type, tagType); returns null when not editable/found. */
	_entry(pType, pTagType)
	{
		if (!this.canManage) { return null; }
		const tmpTypeConfig = this._doc[pType];
		const tmpEntry = tmpTypeConfig && tmpTypeConfig.PropertyInfo && tmpTypeConfig.PropertyInfo[pTagType];
		return (tmpEntry && (tmpEntry.EntityType === 'Label')) ? tmpEntry : null;
	}

	/** Persist the selected observation type's config (read-merge-write of the whole value) after a mutation. */
	async _saveType(pType, pDescription)
	{
		this.busy = true;
		this._onChange();
		try
		{
			await this._putConfig(OBS_NAMESPACE, pType, this._doc[pType]);
			this._toast(pDescription || 'Label behavior saved.');
			this._requestConfigSync();
		}
		catch (pError)
		{
			this._toast(`Could not save: ${pError.message || pError}. Reloading.`, 'error');
			await this.load();
		}
		this.busy = false;
		this._onChange();
	}

	/** Deny (or allow) free entry for a label type on the selected observation type. deny=true → FreeEntry:false. */
	async setFreeEntry(pTagType, pDeny)
	{
		const tmpEntry = this._entry(this.selectedType, pTagType);
		if (!tmpEntry) { return; }
		tmpEntry.FreeEntry = !pDeny;
		await this._saveType(this.selectedType, pDeny ? `Free entry denied for “${pTagType}”.` : `Free entry allowed for “${pTagType}”.`);
	}

	/** Set the per-observation max count for a label type. 0 / blank = unlimited (stored explicitly as 0). */
	async setMaxCount(pTagType, pValue)
	{
		const tmpEntry = this._entry(this.selectedType, pTagType);
		if (!tmpEntry) { return; }
		let tmpN = parseInt(pValue, 10);
		if (!Number.isFinite(tmpN) || tmpN < 0) { tmpN = 0; }
		tmpEntry.MaxCount = tmpN;
		await this._saveType(this.selectedType, (tmpN > 0) ? `Max ${tmpN} “${pTagType}” per observation.` : `“${pTagType}” set to unlimited.`);
	}

	/** Hide (or show) a label type from the entry UI on the selected observation type. */
	async setHidden(pTagType, pHidden)
	{
		const tmpEntry = this._entry(this.selectedType, pTagType);
		if (!tmpEntry) { return; }
		tmpEntry.Hidden = !!pHidden;
		await this._saveType(this.selectedType, pHidden ? `“${pTagType}” hidden from entry.` : `“${pTagType}” shown in entry.`);
	}

	/** Toggle Auto-Filter (distilling) for the whole selected observation type (its own namespace/blob). */
	async setDistilling(pEnabled)
	{
		if (!this.canManage || !this.selectedType) { return; }
		const tmpByType = this._distill.ByType || (this._distill.ByType = {});
		tmpByType[this.selectedType] = Object.assign({}, tmpByType[this.selectedType], { DistillingEnabled: !!pEnabled });
		this.busy = true;
		this._onChange();
		try
		{
			await this._putConfig(DISTILL_NAMESPACE, DISTILL_VALUE, { DistillingEnabled: !!this._distill.DistillingEnabled, ByType: tmpByType });
			this._toast(pEnabled ? `Auto-Filter on for “${this.selectedType}”.` : `Auto-Filter off for “${this.selectedType}”.`);
			this._requestConfigSync();
		}
		catch (pError)
		{
			this._toast(`Could not save Auto-Filter: ${pError.message || pError}. Reloading.`, 'error');
			await this.load();
		}
		this.busy = false;
		this._onChange();
	}

	// --- Display ---

	_escape(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** Escape a value for use inside a single-quoted JS string literal in an inline handler attribute. */
	_jsString(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[pChar]));
	}

	/** Build the render record the shared Headlight-LabelBehavior template consumes. */
	buildState()
	{
		const tmpHasTypes = this.types.length > 0;
		const tmpType = this.selectedType;
		const tmpRows = (!this.loading && tmpHasTypes)
			? this._labelEntries(tmpType).map((pPair) =>
			{
				const tmpTagType = pPair[0];
				const tmpEntry = pPair[1];
				const tmpMax = Number(tmpEntry.MaxCount) || 0;
				const tmpNameText = (tmpEntry.DisplayName != null && String(tmpEntry.DisplayName).trim() !== '') ? tmpEntry.DisplayName : tmpTagType;
				return {
					ProviderName: this.providerName,
					TagTypeJS: this._jsString(tmpTagType),
					TagType: this._escape(tmpTagType),
					DisplayName: this._escape(tmpNameText),
					DenyChecked: (tmpEntry.FreeEntry === false) ? 'checked' : '',
					MaxValue: (tmpMax > 0) ? String(tmpMax) : '',
					HiddenChecked: (tmpEntry.Hidden === true) ? 'checked' : '',
					Disabled: (this.canManage && !this.busy) ? '' : 'disabled',
				};
			})
			: [];
		const tmpTypeOptions = this.types.map((pEntry) => ({
			Value: this._escape(pEntry.Type),
			Label: `${this._escape(pEntry.DisplayName)}${(pEntry.DisplayName !== pEntry.Type) ? ` (${this._escape(pEntry.Type)})` : ''}`,
			Selected: (pEntry.Type === tmpType) ? 'selected' : '',
		}));
		return {
			ProviderName: this.providerName,
			LoadingSlot: this.loading ? [ {} ] : [],
			ReadOnlySlot: (!this.canManage && !this.loading) ? [ {} ] : [],
			NoTypesSlot: (!this.loading && !tmpHasTypes) ? [ {} ] : [],
			PickerSlot: (!this.loading && tmpHasTypes) ? [ { ProviderName: this.providerName, Options: tmpTypeOptions, Disabled: this.busy ? 'disabled' : '' } ] : [],
			DistillingSlot: (!this.loading && tmpHasTypes) ? [ {
				ProviderName: this.providerName,
				DistillChecked: this._distillingEnabledFor(tmpType) ? 'checked' : '',
				Disabled: (this.canManage && !this.busy) ? '' : 'disabled',
			} ] : [],
			TableSlot: (!this.loading && tmpHasTypes && tmpRows.length > 0) ? [ { Rows: tmpRows } ] : [],
			EmptyTypeSlot: (!this.loading && tmpHasTypes && tmpRows.length === 0) ? [ {} ] : [],
		};
	}
}

module.exports = LabelBehaviorController;

module.exports.LABELBEHAVIOR_CSS = /*css*/`
	.lbh-mgr { font-size: 0.92rem; }
	.lbh-toolbar { display: flex; align-items: center; flex-wrap: wrap; gap: 0.9rem; margin: 0 0 0.9rem; }
	.lbh-field { display: flex; align-items: center; gap: 0.4rem; }
	.lbh-field label { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
	.lbh-select { min-width: 15rem; }
	.lbh-distill { margin-left: auto; display: flex; align-items: center; gap: 0.45rem; background: var(--theme-color-background-tertiary, #f4f6f9);
		border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.35rem 0.7rem; }
	.lbh-distill .lbh-distill-label { font-weight: 650; color: var(--theme-color-text-secondary, #45505f); }
	.lbh-distill .lbh-distill-hint { color: var(--theme-color-text-muted, #6b7686); font-size: 0.8rem; }
	.lbh-table { width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
	.lbh-table th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686);
		background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.45rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.lbh-th-type { width: 34%; }
	.lbh-th-center { text-align: center; width: 14%; }
	.lbh-th-max { width: 16%; }
	.lbh-table td { padding: 0.4rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; }
	.lbh-table tbody tr:last-child td { border-bottom: none; }
	.lbh-type { font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.lbh-td-center { text-align: center; }
	.lbh-maxinput { max-width: 6rem; }
	.lbh-note { font-size: 0.84rem; color: var(--theme-color-text-muted, #6b7686); font-style: italic; margin-top: 0.6rem; }
	.lbh-loading { color: var(--theme-color-text-muted, #6b7686); padding: 0.8rem 0.2rem; }
	.lbh-spin { display: inline-block; width: 1rem; height: 1rem; border: 2px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: lbh-spin 0.7s linear infinite; vertical-align: -0.15rem; margin-right: 0.4rem; }
	@keyframes lbh-spin { to { transform: rotate(360deg); } }
`;

module.exports.LABELBEHAVIOR_TEMPLATES =
[
	{
		Hash: 'Headlight-LabelBehavior',
		Template: /*html*/`
			<div class="lbh-mgr">
				{~TS:Headlight-LabelBehaviorLoading:Record.LoadingSlot~}
				{~TS:Headlight-LabelBehaviorNoTypes:Record.NoTypesSlot~}
				<div class="lbh-toolbar">
					{~TS:Headlight-LabelBehaviorPicker:Record.PickerSlot~}
					{~TS:Headlight-LabelBehaviorDistilling:Record.DistillingSlot~}
				</div>
				{~TS:Headlight-LabelBehaviorTable:Record.TableSlot~}
				{~TS:Headlight-LabelBehaviorEmptyType:Record.EmptyTypeSlot~}
				{~TS:Headlight-LabelBehaviorReadOnly:Record.ReadOnlySlot~}
			</div>`
	},
	{
		Hash: 'Headlight-LabelBehaviorPicker',
		Template: /*html*/`
			<div class="lbh-field">
				<label>Observation type</label>
				<div class="select is-small">
					<select class="lbh-select" {~D:Record.Disabled~} onchange="_Pict.providers['{~D:Record.ProviderName~}'].labelBehaviorSelectType(this.value)">
						{~TS:Headlight-LabelBehaviorPickerOption:Record.Options~}
					</select>
				</div>
			</div>`
	},
	{
		Hash: 'Headlight-LabelBehaviorPickerOption',
		Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.Selected~}>{~D:Record.Label~}</option>`
	},
	{
		Hash: 'Headlight-LabelBehaviorDistilling',
		Template: /*html*/`
			<div class="lbh-distill" title="Auto-Filter cascades each label's pick list by the other labels already chosen on the observation.">
				<label class="checkbox lbh-distill-label"><input type="checkbox" {~D:Record.DistillChecked~} {~D:Record.Disabled~} onchange="_Pict.providers['{~D:Record.ProviderName~}'].labelBehaviorSetDistilling(this.checked)" /> Auto-Filter</label>
				<span class="lbh-distill-hint">(distilling for this type)</span>
			</div>`
	},
	{
		Hash: 'Headlight-LabelBehaviorTable',
		Template: /*html*/`
			<table class="lbh-table">
				<thead><tr>
					<th class="lbh-th-type">Label type</th>
					<th class="lbh-th-center">Deny free entry</th>
					<th class="lbh-th-max">Max / observation</th>
					<th class="lbh-th-center">Hidden</th>
				</tr></thead>
				<tbody>{~TS:Headlight-LabelBehaviorRow:Record.Rows~}</tbody>
			</table>`
	},
	{
		Hash: 'Headlight-LabelBehaviorRow',
		Template: /*html*/`
			<tr class="lbh-row">
				<td class="lbh-type">{~D:Record.DisplayName~}</td>
				<td class="lbh-td-center"><input type="checkbox" {~D:Record.DenyChecked~} {~D:Record.Disabled~} onchange="_Pict.providers['{~D:Record.ProviderName~}'].labelBehaviorSetFreeEntry('{~D:Record.TagTypeJS~}', this.checked)" /></td>
				<td><input class="input is-small lbh-maxinput" type="number" min="0" step="1" placeholder="∞" value="{~D:Record.MaxValue~}" {~D:Record.Disabled~} onchange="_Pict.providers['{~D:Record.ProviderName~}'].labelBehaviorSetMaxCount('{~D:Record.TagTypeJS~}', this.value)" /></td>
				<td class="lbh-td-center"><input type="checkbox" {~D:Record.HiddenChecked~} {~D:Record.Disabled~} onchange="_Pict.providers['{~D:Record.ProviderName~}'].labelBehaviorSetHidden('{~D:Record.TagTypeJS~}', this.checked)" /></td>
			</tr>`
	},
	{
		Hash: 'Headlight-LabelBehaviorEmptyType',
		Template: /*html*/`<p class="lbh-note">This observation type has no labels to configure.</p>`
	},
	{
		Hash: 'Headlight-LabelBehaviorNoTypes',
		Template: /*html*/`<p class="lbh-note">No observation types with labels are available at this scope yet.</p>`
	},
	{
		Hash: 'Headlight-LabelBehaviorReadOnly',
		Template: /*html*/`<p class="lbh-note">You don’t have permission to change label behaviors.</p>`
	},
	{
		Hash: 'Headlight-LabelBehaviorLoading',
		Template: /*html*/`<div class="lbh-loading"><span class="lbh-spin"></span>Loading label behaviors…</div>`
	}
];

},{"./ConfigSync.js":1313}],1345:[function(require,module,exports){

// Shared controller for managing project "labels" (ProjectTagType rows) at a single scope. Mirrors the
// LogoSlotController pattern: a plain class (NOT a pict provider) driven by a host provider, exporting the
// shared list template (LABEL_TEMPLATES) + CSS (LABEL_CSS). Template handlers call back into the host by
// name via Record.ProviderName, so one template serves both hosts.
//
// Two scopes, same entity:
//   - customer DEFAULT labels: IDProject = 0,  IDCustomer = <customer>   (seed new projects; My Headlight)
//   - per-PROJECT labels:      IDProject = <p>, IDCustomer = <customer>  (Project workspace "Labels" tab)
// ProjectTagType is standard Meadow REST; `Name` is the display name (falls back to `TagType` when blank).

const libConfigSync = require('./ConfigSync.js');

class LabelManagerController
{
	/**
	 * @param {any} pPict
	 * @param {String} pProviderName - the host provider's identifier (the list template calls it back).
	 */
	constructor(pPict, pProviderName)
	{
		this.pict = pPict;
		this.providerName = pProviderName;

		this.scope = { IDProject: 0, IDCustomer: 0 };
		this.canManage = false;
		// The project "Labels" tab offers a one-click "copy customer defaults"; My Headlight (which IS the
		// defaults) does not.
		this.showCopyDefaults = false;
		this._onChange = () => {};

		this.labels = [];
		this.loading = false;
		this.busy = false;
		// Add-row input state (stashed on every keystroke WITHOUT a re-render so the inputs keep focus).
		this.newTagType = '';
		this.newName = '';
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	_toast(pMessage, pType)
	{
		if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); }
	}

	/**
	 * After a label-type change, (debounced) publish this scope's config to the field apps (Fieldbook) — a
	 * Project sync for a project scope, a Customer sync for the customer-default scope (My Headlight). Without
	 * this, a new/renamed/removed type shows here but never reaches Fieldbook. Debounced + permission-gated in
	 * ConfigSync (a non-super-user without Module-PlatformConfiguration-Access gets a gentle notice instead).
	 */
	_requestConfigSync()
	{
		if (Number(this.scope.IDProject) > 0)
		{
			libConfigSync.requestSync(this.pict, 'Project', this.scope.IDProject);
		}
		else if (Number(this.scope.IDCustomer) > 0)
		{
			libConfigSync.requestSync(this.pict, 'Customer', this.scope.IDCustomer);
		}
	}

	// --- REST (promisified) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_create(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.createEntity('ProjectTagType', pRecord, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_update(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.updateEntity('ProjectTagType', pRecord, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_delete(pID)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.deleteEntity('ProjectTagType', pID, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/**
	 * Point the controller at a scope + permission and register the host's re-render.
	 * @param {{IDProject:Number, IDCustomer:Number}} pScope
	 * @param {Boolean} pCanManage
	 * @param {Function} pOnChange
	 * @param {Boolean} [pShowCopyDefaults]
	 */
	setContext(pScope, pCanManage, pOnChange, pShowCopyDefaults)
	{
		this.scope = pScope || { IDProject: 0, IDCustomer: 0 };
		this.canManage = !!pCanManage;
		this.showCopyDefaults = !!pShowCopyDefaults;
		this._onChange = (typeof pOnChange === 'function') ? pOnChange : () => {};
		this.labels = [];
		this.newTagType = '';
		this.newName = '';
	}

	_sort()
	{
		this.labels.sort((a, b) => (Number(a.Ordinal || 0) - Number(b.Ordinal || 0)) || String(a.TagType || '').localeCompare(String(b.TagType || '')));
	}

	_sortRows(pRows)
	{
		return (Array.isArray(pRows) ? pRows.slice() : []).sort((a, b) => (Number(a.Ordinal || 0) - Number(b.Ordinal || 0)) || String(a.TagType || '').localeCompare(String(b.TagType || '')));
	}

	/**
	 * Resolve the effective DEFAULT label-type set for a customer: the customer's own defaults
	 * (IDProject=0, IDCustomer=c) when present, else Headlight's platform defaults (IDProject=0,
	 * IDCustomer=0). Mirrors the ProjectObservationManifestJoin cascade already shipping in
	 * ProjectWorkspace-Provider and the legacy Projects app (project → customer → platform).
	 * @param {Number} pIDCustomer
	 * @return {Promise<{Rows: Array<Object>, Source: ('customer'|'platform'|'none')}>}
	 */
	async _resolveEffectiveDefaults(pIDCustomer)
	{
		if (Number(pIDCustomer) !== 0)
		{
			const tmpCustomer = this._sortRows(await this._getJSON(`ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~${pIDCustomer}/0/1000`));
			if (tmpCustomer.length > 0) { return { Rows: tmpCustomer, Source: 'customer' }; }
		}
		const tmpPlatform = this._sortRows(await this._getJSON('ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~0/0/1000'));
		return { Rows: tmpPlatform, Source: tmpPlatform.length > 0 ? 'platform' : 'none' };
	}

	/**
	 * Materialize the given default rows as scoped copies at the current scope (skipping any TagType
	 * already present), pushing the created rows onto `this.labels`. Shared by copyDefaults() and the
	 * seed-on-first-customization in add().
	 * @param {Array<Object>} pRows
	 * @return {Promise<Number>} the number of rows created.
	 */
	async _seedRows(pRows)
	{
		const tmpExisting = new Set(this.labels.map((pLabel) => String(pLabel.TagType || '').toLowerCase()));
		let tmpAdded = 0;
		for (let i = 0; i < (Array.isArray(pRows) ? pRows.length : 0); i++)
		{
			const tmpRow = pRows[i];
			const tmpKey = String(tmpRow.TagType || '').toLowerCase();
			if (!tmpKey || tmpExisting.has(tmpKey)) { continue; }
			try
			{
				const tmpSaved = await this._create({ TagType: tmpRow.TagType, Name: tmpRow.Name || tmpRow.TagType, Ordinal: tmpRow.Ordinal || 0, IDProject: this.scope.IDProject, IDCustomer: this.scope.IDCustomer });
				if (tmpSaved && tmpSaved.IDProjectTagType) { this.labels.push(tmpSaved); tmpExisting.add(tmpKey); tmpAdded++; }
			}
			catch (pError) { /* keep going; the caller reports the total */ }
		}
		this._sort();
		return tmpAdded;
	}

	// --- Data ops ---

	async load()
	{
		this.loading = true;
		this._onChange();
		try
		{
			const tmpRows = await this._getJSON(`ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~${this.scope.IDProject}~FBV~IDCustomer~EQ~${this.scope.IDCustomer}/0/1000`);
			this.labels = Array.isArray(tmpRows) ? tmpRows.slice() : [];
			this._sort();
			// No own rows → fall back to the effective default set (customer defaults, else Headlight's
			// platform defaults), shown read-only, so the tab reflects what the project (or, in My Headlight,
			// the customer) actually inherits until it is customized. Mirrors the manifest cascade + the legacy
			// Projects app: project → customer(0,c) → platform(0,0).
			this._showingDefaults = false;
			this._defaults = [];
			this._defaultsSource = '';
			if (this.labels.length === 0)
			{
				const tmpEffective = await this._resolveEffectiveDefaults(this.scope.IDCustomer);
				this._defaults = tmpEffective.Rows;
				this._defaultsSource = tmpEffective.Source;
				this._showingDefaults = this._defaults.length > 0;
			}
		}
		catch (pError)
		{
			this.labels = [];
			this._defaults = [];
			this._showingDefaults = false;
			this._toast(`Could not load labels: ${pError.message || pError}`, 'error');
		}
		this.loading = false;
		this._onChange();
	}

	/** Stash an add-row field WITHOUT a re-render (keeps the input focused while typing). */
	setNew(pField, pValue)
	{
		if (pField === 'TagType') { this.newTagType = pValue; }
		else { this.newName = pValue; }
	}

	async add()
	{
		if (!this.canManage) { return; }
		const tmpTagType = String(this.newTagType || '').trim();
		if (!tmpTagType) { this._toast('Enter a label type.', 'error'); return; }
		// While inheriting, the visible set is the read-only defaults (this.labels is still empty), so
		// dedupe the new type against those too.
		const tmpInheriting = this._showingDefaults === true;
		const tmpVisible = tmpInheriting ? (this._defaults || []) : this.labels;
		if (tmpVisible.some((pLabel) => String(pLabel.TagType || '').toLowerCase() === tmpTagType.toLowerCase()))
		{
			this._toast('That label type already exists in this set.', 'error');
			return;
		}
		const tmpName = String(this.newName || '').trim() || tmpTagType;
		this.busy = true;
		this._onChange();
		try
		{
			// First customization of an inheriting project: materialize the whole inherited default set as
			// scoped rows FIRST, so adding one custom type doesn't drop the rest (the reported bug — mirrors
			// the legacy Projects app's seed-on-first-edit).
			if (tmpInheriting)
			{
				await this._seedRows(this._defaults);
				this._showingDefaults = false;
				this._defaults = [];
			}
			const tmpNextOrdinal = this.labels.reduce((pMax, pLabel) => Math.max(pMax, Number(pLabel.Ordinal) || 0), 0) + 1;
			const tmpSaved = await this._create({ TagType: tmpTagType, Name: tmpName, Ordinal: tmpNextOrdinal, IDProject: this.scope.IDProject, IDCustomer: this.scope.IDCustomer });
			if (!tmpSaved || !tmpSaved.IDProjectTagType) { throw new Error((tmpSaved && tmpSaved.Error) || 'the server returned an unexpected response.'); }
			this.labels.push(tmpSaved);
			this._sort();
			this.newTagType = '';
			this.newName = '';
			this._toast(`Added the “${tmpTagType}” label type.`);
			this._requestConfigSync();
		}
		catch (pError)
		{
			this._toast(`Could not add the label type: ${pError.message || pError}`, 'error');
		}
		this.busy = false;
		this._onChange();
	}

	async updateName(pID, pValue)
	{
		if (!this.canManage) { return; }
		const tmpLabel = this.labels.find((pLabel) => pLabel.IDProjectTagType === pID);
		if (!tmpLabel) { return; }
		const tmpValue = String(pValue || '').trim() || tmpLabel.TagType;
		if (tmpValue === tmpLabel.Name) { return; }
		try
		{
			const tmpSaved = await this._update({ IDProjectTagType: pID, Name: tmpValue });
			if (tmpSaved && tmpSaved.ErrorCode) { throw new Error(tmpSaved.Error || 'the server rejected the update.'); }
			tmpLabel.Name = tmpValue;
			this._toast('Label name saved.');
			this._requestConfigSync();
		}
		catch (pError)
		{
			this._toast(`Could not save the label name: ${pError.message || pError}`, 'error');
		}
		this._onChange();
	}

	async remove(pID)
	{
		if (!this.canManage) { return; }
		const tmpLabel = this.labels.find((pLabel) => pLabel.IDProjectTagType === pID);
		if (!tmpLabel) { return; }
		const fApply = async () =>
		{
			try
			{
				await this._delete(pID);
				this.labels = this.labels.filter((pLabel) => pLabel.IDProjectTagType !== pID);
				this._toast(`Removed the “${tmpLabel.TagType}” label type.`);
				this._requestConfigSync();
			}
			catch (pError)
			{
				this._toast(`Could not remove the label type: ${pError.message || pError}`, 'error');
			}
			this._onChange();
		};
		// Warn when the type is IN USE — i.e. labels (values) of this type exist. Removing the type is a
		// hard delete that does NOT remove those labels; they are left without a defined type. (Per the ask:
		// warn for in-use TYPES; there is no such warning when removing an individual label value.)
		const tmpInUse = await this._countTypeUsage(tmpLabel.TagType);
		const tmpTypeName = (tmpLabel.Name != null && String(tmpLabel.Name).trim() !== '') ? tmpLabel.Name : tmpLabel.TagType;
		const tmpScopeText = (Number(this.scope.IDProject) !== 0) ? 'on this project' : 'across your projects';
		const tmpMessage = (tmpInUse > 0)
			? `The “${tmpTypeName}” label type is in use by ${tmpInUse} label${tmpInUse === 1 ? '' : 's'} ${tmpScopeText}. Removing the type won’t delete those labels, but they’ll be left without a defined type. Remove it anyway?`
			: `Remove the “${tmpTypeName}” label type?`;
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(tmpMessage,
				{ title: 'Remove label type', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fApply(); } });
		}
		else { fApply(); }
	}

	/**
	 * Count the label VALUES (ObservationTagProjectJoin rows) that use a given TagType in this scope — the
	 * "in use" signal for a type removal. Project scope counts the project's labels of that type; the
	 * customer-default scope (My Headlight, IDProject=0) counts labels of that type across the customer's
	 * real projects (IDProject>0). Returns 0 if the count can't be fetched (never blocks the removal).
	 * @param {String} pTagType
	 * @return {Promise<Number>}
	 */
	async _countTypeUsage(pTagType)
	{
		try
		{
			const tmpType = encodeURIComponent(pTagType);
			const tmpFilter = (Number(this.scope.IDProject) !== 0)
				? `FBV~IDProject~EQ~${this.scope.IDProject}~FBV~TagType~EQ~${tmpType}`
				: `FBV~IDCustomer~EQ~${this.scope.IDCustomer}~FBV~TagType~EQ~${tmpType}~FBV~IDProject~GT~0`;
			const tmpCount = await this._getJSON(`ObservationTagProjectJoins/Count/FilteredTo/${tmpFilter}`);
			const tmpValue = (tmpCount && (tmpCount.Count != null)) ? tmpCount.Count : tmpCount;
			return Number(tmpValue) || 0;
		}
		catch (pError)
		{
			return 0;
		}
	}

	/** Project scope only: create scoped copies of the effective default label types (customer → platform). */
	async copyDefaults()
	{
		if (!this.canManage) { return; }
		try
		{
			const tmpEffective = await this._resolveEffectiveDefaults(this.scope.IDCustomer);
			const tmpExisting = new Set(this.labels.map((pLabel) => String(pLabel.TagType || '').toLowerCase()));
			const tmpToCreate = tmpEffective.Rows.filter((pDefault) => !tmpExisting.has(String(pDefault.TagType || '').toLowerCase()));
			if (tmpToCreate.length === 0) { this._toast('All default label types are already present.'); return; }
			this.busy = true;
			this._onChange();
			const tmpAdded = await this._seedRows(tmpToCreate);
			// Copying while inheriting materializes the set — drop the read-only defaults view.
			if (this._showingDefaults) { this._showingDefaults = false; this._defaults = []; }
			this._toast(`Added ${tmpAdded} label type${tmpAdded === 1 ? '' : 's'} from the defaults.`);
			if (tmpAdded > 0) { this._requestConfigSync(); }
		}
		catch (pError)
		{
			this._toast(`Could not copy the default label types: ${pError.message || pError}`, 'error');
		}
		this.busy = false;
		this._onChange();
	}

	// --- Display ---

	_escape(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** The inherited-defaults banner text, worded for the source tier (customer vs Headlight platform). */
	_defaultsBannerText()
	{
		const tmpProjectScope = Number(this.scope.IDProject) !== 0;
		const tmpAction = 'Add a label type or use “Copy default labels” to give it a custom set.';
		if (this._defaultsSource === 'platform')
		{
			return tmpProjectScope
				? `Showing Headlight’s platform default label types — neither this project nor your organization has set its own yet. ${ tmpAction }`
				: 'Showing Headlight’s platform default label types — your organization hasn’t set its own yet. Add a label type or copy these to give your organization a custom set.';
		}
		return tmpProjectScope
			? `Showing your organization’s default label types — this project hasn’t set its own yet. ${ tmpAction }`
			: 'Showing your organization’s default label types.';
	}

	/** Build the render record the shared Headlight-LabelManager template consumes. */
	buildState()
	{
		// When the project has no labels of its own, show the customer defaults read-only (the fallback set
		// the project actually uses). Rows are never editable/removable in this mode — the user customizes
		// by adding a label or copying the defaults, which makes a project-scoped set on the next load.
		const tmpUsingDefaults = (this._showingDefaults === true) && Array.isArray(this._defaults) && (this._defaults.length > 0);
		const tmpSource = tmpUsingDefaults ? this._defaults : this.labels;
		const tmpRows = tmpSource.map((pLabel) =>
		{
			const tmpNameText = (pLabel.Name != null && String(pLabel.Name).trim() !== '') ? pLabel.Name : pLabel.TagType;
			const tmpRowEditable = this.canManage && !tmpUsingDefaults;
			return {
				ProviderName: this.providerName,
				ID: pLabel.IDProjectTagType,
				// Lower-cased "type + display name" for the client-side type search (matched by the filter input's
				// inline handler against this data attribute — no re-render, so the input keeps focus).
				FilterText: this._escape(`${pLabel.TagType || ''} ${tmpNameText || ''}`.toLowerCase()),
				TagType: this._escape(pLabel.TagType),
				EditSlot: tmpRowEditable ? [ { ProviderName: this.providerName, ID: pLabel.IDProjectTagType, Name: this._escape(pLabel.Name != null ? pLabel.Name : '') } ] : [],
				ROSlot: !tmpRowEditable ? [ { NameText: this._escape(tmpNameText) } ] : [],
				RemoveSlot: (tmpRowEditable && !this.busy) ? [ { ProviderName: this.providerName, ID: pLabel.IDProjectTagType } ] : [],
			};
		});
		const tmpHasTable = (tmpRows.length > 0) || this.canManage;
		return {
			ProviderName: this.providerName,
			LoadingSlot: this.loading ? [ {} ] : [],
			DefaultsBanner: tmpUsingDefaults ? [ { BannerText: this._defaultsBannerText() } ] : [],
			// A client-side type search — shown once there are enough rows to be worth filtering. It hides/shows
			// the already-loaded rows in place (no server round-trip, no re-render), so it keeps focus while typing.
			FilterSlot: (!this.loading && tmpRows.length > 5) ? [ {} ] : [],
			TableSlot: (!this.loading && tmpHasTable) ? [ {
				Labels: tmpRows,
				AddSlot: (this.canManage && !this.busy) ? [ { ProviderName: this.providerName, NewTagType: this._escape(this.newTagType), NewName: this._escape(this.newName) } ] : [],
				BusySlot: this.busy ? [ {} ] : [],
			} ] : [],
			EmptySlot: (!this.loading && tmpRows.length === 0 && !this.canManage) ? [ {} ] : [],
			CopyDefaultsSlot: (this.showCopyDefaults && this.canManage && !this.loading && !this.busy) ? [ { ProviderName: this.providerName } ] : [],
			ReadOnlySlot: (!this.canManage && !this.loading) ? [ {} ] : [],
		};
	}
}

module.exports = LabelManagerController;

module.exports.LABEL_CSS = /*css*/`
	.lbl-mgr { font-size: 0.92rem; }
	.lbl-table { width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
	.lbl-table th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686);
		background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.45rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.lbl-filter { display: flex; align-items: center; gap: 0.35rem; margin: 0 0 0.7rem; }
	.lbl-filter-icon { color: var(--theme-color-text-muted, #6b7686); }
	.lbl-filter-input { flex: 1 1 auto; max-width: 22rem; }
	.lbl-th-type { width: 32%; }
	.lbl-th-act { width: 1%; }
	.lbl-table td { padding: 0.45rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; }
	.lbl-table tbody tr:last-child td { border-bottom: none; }
	.lbl-type { font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.lbl-name-ro { color: var(--theme-color-text-secondary, #45505f); }
	.lbl-input { max-width: 22rem; }
	.lbl-act { text-align: right; white-space: nowrap; }
	.lbl-add td { background: var(--theme-color-background-tertiary, #fafbfc); }
	.lbl-empty { color: var(--theme-color-text-muted, #6b7686); padding: 0.6rem 0.2rem; }
	.lbl-ro-note { font-size: 0.84rem; color: var(--theme-color-text-muted, #6b7686); font-style: italic; margin-top: 0.6rem; }
	.lbl-copy { margin-top: 0.8rem; }
	.lbl-defaults-banner { display: flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; color: var(--theme-color-text-secondary, #45505f);
		background: var(--theme-color-background-selected, #eef1f8); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.6rem 0.85rem; margin: 0 0 0.85rem; line-height: 1.5; }
	.lbl-defaults-banner .icon { color: var(--theme-color-brand-primary, #5650e6); flex: 0 0 auto; }
	.lbl-loading { color: var(--theme-color-text-muted, #6b7686); padding: 0.8rem 0.2rem; }
	.lbl-spin { display: inline-block; width: 1rem; height: 1rem; border: 2px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: lbl-spin 0.7s linear infinite; vertical-align: -0.15rem; margin-right: 0.4rem; }
	@keyframes lbl-spin { to { transform: rotate(360deg); } }
`;

module.exports.LABEL_TEMPLATES =
[
	{
		Hash: 'Headlight-LabelManager',
		Template: /*html*/`
			<div class="lbl-mgr">
				{~TS:Headlight-LabelLoading:Record.LoadingSlot~}
				{~TS:Headlight-LabelDefaultsBanner:Record.DefaultsBanner~}
				{~TS:Headlight-LabelFilter:Record.FilterSlot~}
				{~TS:Headlight-LabelTable:Record.TableSlot~}
				<p class="lbl-empty lbl-filter-none" style="display:none">No label types match your search.</p>
				{~TS:Headlight-LabelEmpty:Record.EmptySlot~}
				{~TS:Headlight-LabelCopyDefaults:Record.CopyDefaultsSlot~}
				{~TS:Headlight-LabelReadOnly:Record.ReadOnlySlot~}
			</div>`
	},
	{
		Hash: 'Headlight-LabelFilter',
		// A pure client-side filter over the already-loaded rows: it toggles row visibility by the row's
		// data-lbl attribute, keeping input focus (no re-render). Self-contained so it needs no host delegate
		// and works identically in every host that renders this template.
		Template: /*html*/`
			<div class="lbl-filter">
				<span class="icon lbl-filter-icon"><i class="fas fa-magnifying-glass"></i></span>
				<input class="input is-small lbl-filter-input" type="text" placeholder="Search label types…" oninput="(function(pInput){var tmpQuery=pInput.value.trim().toLowerCase();var tmpBox=pInput.closest('.lbl-mgr');if(!tmpBox){return;}var tmpShown=0,tmpTotal=0;tmpBox.querySelectorAll('tr.lbl-row').forEach(function(pRow){tmpTotal++;var tmpHay=pRow.getAttribute('data-lbl')||pRow.textContent.toLowerCase();var tmpHit=(!tmpQuery)||(tmpHay.indexOf(tmpQuery)>=0);pRow.style.display=tmpHit?'':'none';if(tmpHit){tmpShown++;}});var tmpNone=tmpBox.querySelector('.lbl-filter-none');if(tmpNone){tmpNone.style.display=(tmpQuery&&tmpShown===0&&tmpTotal>0)?'':'none';}})(this)" />
			</div>`
	},
	{
		Hash: 'Headlight-LabelDefaultsBanner',
		Template: /*html*/`<div class="lbl-defaults-banner"><span class="icon"><i class="fas fa-circle-info"></i></span><span>{~D:Record.BannerText~}</span></div>`
	},
	{
		Hash: 'Headlight-LabelTable',
		Template: /*html*/`
			<table class="lbl-table">
				<thead><tr><th class="lbl-th-type">Type</th><th>Display name</th><th class="lbl-th-act"></th></tr></thead>
				<tbody>
					{~TS:Headlight-LabelRow:Record.Labels~}
					{~TS:Headlight-LabelAdd:Record.AddSlot~}
				</tbody>
			</table>`
	},
	{
		Hash: 'Headlight-LabelRow',
		Template: /*html*/`
			<tr class="lbl-row" data-lbl="{~D:Record.FilterText~}">
				<td class="lbl-type">{~D:Record.TagType~}</td>
				<td>{~TS:Headlight-LabelNameEdit:Record.EditSlot~}{~TS:Headlight-LabelNameRO:Record.ROSlot~}</td>
				<td class="lbl-act">{~TS:Headlight-LabelRemove:Record.RemoveSlot~}</td>
			</tr>`
	},
	{
		Hash: 'Headlight-LabelNameEdit',
		Template: /*html*/`<input class="input lbl-input" type="text" value="{~D:Record.Name~}" onchange="_Pict.providers['{~D:Record.ProviderName~}'].labelUpdateName({~D:Record.ID~}, this.value)" />`
	},
	{
		Hash: 'Headlight-LabelNameRO',
		Template: /*html*/`<span class="lbl-name-ro">{~D:Record.NameText~}</span>`
	},
	{
		Hash: 'Headlight-LabelRemove',
		Template: /*html*/`<button class="button is-light is-small" title="Remove label" onclick="_Pict.providers['{~D:Record.ProviderName~}'].labelRemove({~D:Record.ID~})"><span class="icon"><i class="fas fa-trash"></i></span></button>`
	},
	{
		Hash: 'Headlight-LabelAdd',
		Template: /*html*/`
			<tr class="lbl-add">
				<td><input class="input is-small lbl-input" type="text" placeholder="New type (e.g. Phase)" value="{~D:Record.NewTagType~}" oninput="_Pict.providers['{~D:Record.ProviderName~}'].labelSetNew('TagType', this.value)" /></td>
				<td><input class="input is-small lbl-input" type="text" placeholder="Display name (optional)" value="{~D:Record.NewName~}" oninput="_Pict.providers['{~D:Record.ProviderName~}'].labelSetNew('Name', this.value)" /></td>
				<td class="lbl-act"><button class="button is-link is-small" onclick="_Pict.providers['{~D:Record.ProviderName~}'].labelAdd()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add</span></button></td>
			</tr>`
	},
	{
		Hash: 'Headlight-LabelCopyDefaults',
		Template: /*html*/`<button class="button is-light is-small lbl-copy" onclick="_Pict.providers['{~D:Record.ProviderName~}'].labelCopyDefaults()"><span class="icon"><i class="fas fa-copy"></i></span><span>Copy default labels</span></button>`
	},
	{
		Hash: 'Headlight-LabelEmpty',
		Template: /*html*/`<p class="lbl-empty">No labels have been defined yet.</p>`
	},
	{
		Hash: 'Headlight-LabelReadOnly',
		Template: /*html*/`<p class="lbl-ro-note">You don’t have permission to change these labels.</p>`
	},
	{
		Hash: 'Headlight-LabelLoading',
		Template: /*html*/`<div class="lbl-loading"><span class="lbl-spin"></span>Loading labels…</div>`
	}
];

},{"./ConfigSync.js":1313}],1346:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

// A project can carry a lot of line items; cap the loaded grid and warn at the ceiling
// (the per-record BidItem picker on the Line Items list handles the long tail).
const MAX_ROWS = 1500;
// Above this many rows we fall back from per-row Pict-Section-Pickers to native <select>s — creating
// several hundred picker views at once is heavy; native dropdowns keep a huge project responsive.
const PICKER_CAP = 400;

/**
 * LineItemBidItemMap — the "Bid Item Mapping" tab body on the Project workspace. Given a project, it
 * loads the project's Line Items and Bid Items, renders one row per line item with a **searchable
 * Bid Item picker (Pict-Section-Picker)** scoped to that project's bid items, and bulk-saves the changed
 * `LineItem.IDBidItem` FKs. Line items are project-scoped, so this mapping lives on the Project workspace
 * (it was previously on the Contract workspace, contract-anchored across the contract's projects).
 *
 * Renders into a host element owned by ProjectWorkspace (mirrors how the Leaflet map + association editors
 * mount from the workspace's OnEnter hook). No view of its own — HTML is hand-assigned into the mount, then
 * a Pict-Section-Picker is mounted per row (each fed a static, in-memory Options list + an OnChange hook).
 */
class LineItemBidItemMapProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;

		this._IDProject = 0;
		this._Mount = '';
		this._loading = false;
		this._loaded = false;
		this._saving = false;
		this._truncated = false;
		this._usePickers = true;
		this._message = '';
		this._messageClass = '';

		this._lineItems = [];
		this._bidItemsByProject = {};   // IDProject(string) -> [ bidItem, … ]
		this._bidItemLabelByID = {};    // IDBidItem(string) -> label
		this._pending = {};             // IDLineItem(string) -> new IDBidItem (number)

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('LineItemBidItemMap-CSS', _CSS, 520);
		}
	}

	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get effectivePermissions() { return this.pict.EffectivePermissionsService; }
	get pickerProvider() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }

	_canEdit()
	{
		try { return this.effectivePermissions ? this.effectivePermissions.can('LineItem', 'Update') : true; }
		catch (pError) { return true; }
	}

	/**
	 * Render (and, on a project change, load) the mapping grid into a host element.
	 * Safe to call on every ProjectWorkspace render — reloads only when the project changes.
	 * @param {number|string} pIDProject
	 * @param {string} pMountSelector
	 */
	async openInto(pIDProject, pMountSelector)
	{
		const tmpID = parseInt(pIDProject, 10);
		this._Mount = pMountSelector;
		if (!tmpID) { return; }
		// AppData store the per-row pickers read/write their value through (one address per line item).
		this.pict.AppData.LineItemBidItemMap = this.pict.AppData.LineItemBidItemMap || {};
		this.pict.AppData.LineItemBidItemMap.RowValues = this.pict.AppData.LineItemBidItemMap.RowValues || {};

		if (tmpID === this._IDProject && (this._loaded || this._loading))
		{
			// Same project, host was just re-created by a workspace re-render — repaint from cache.
			this._render();
			return;
		}
		this._IDProject = tmpID;
		this._pending = {};
		this._loaded = false;
		this._loading = true;
		this._message = '';
		this._render();
		try { await this._loadAsync(tmpID); }
		catch (pError) { this.pict.log.warn(`LineItemBidItemMap load failed: ${pError && pError.message ? pError.message : pError}`); }
		this._loading = false;
		this._loaded = true;
		this._render();
	}

	async _loadAsync(pIDProject)
	{
		const tmpLineItems = await this._getJSON(`LineItems/FilteredTo/FBV~IDProject~EQ~${pIDProject}~FBV~Deleted~EQ~0~FSF~ItemNumber~ASC~0/0/${MAX_ROWS}`);
		const tmpBidItems = await this._getJSON(`BidItems/FilteredTo/FBV~IDProject~EQ~${pIDProject}~FBV~Deleted~EQ~0/0/${MAX_ROWS}`);

		this._lineItems = Array.isArray(tmpLineItems) ? tmpLineItems : [];
		this._truncated = (this._lineItems.length >= MAX_ROWS);
		// Searchable pickers for the common case; native dropdowns keep a very large project responsive.
		this._usePickers = this._canEdit() && (this._lineItems.length <= PICKER_CAP);

		this._bidItemsByProject = {};
		this._bidItemLabelByID = {};
		(Array.isArray(tmpBidItems) ? tmpBidItems : []).forEach((pBidItem) =>
		{
			const tmpProjectKey = String(pBidItem.IDProject || 0);
			if (!this._bidItemsByProject[tmpProjectKey]) { this._bidItemsByProject[tmpProjectKey] = []; }
			this._bidItemsByProject[tmpProjectKey].push(pBidItem);
			this._bidItemLabelByID[String(pBidItem.IDBidItem)] = this._bidItemLabel(pBidItem);
		});
	}

	_bidItemLabel(pBidItem)
	{
		const tmpNumber = pBidItem.ItemNumber || pBidItem.ItemCode || '';
		const tmpName = pBidItem.Name || `Bid Item ${pBidItem.IDBidItem}`;
		return (tmpNumber ? `${tmpNumber} — ` : '') + tmpName;
	}

	/** The current value to display for a row — a pending pick if there is one, else the stored FK. */
	_currentValue(pLineItem)
	{
		const tmpPending = this._pending[String(pLineItem.IDLineItem)];
		return (tmpPending !== undefined) ? tmpPending : (parseInt(pLineItem.IDBidItem, 10) || 0);
	}

	/** `[{ Value, Text }]` option list for a row: none + the row's project bid items (+ its current FK if off-project). */
	_pickerOptions(pLineItem)
	{
		const tmpProjectKey = String(pLineItem.IDProject || 0);
		const tmpCurrent = parseInt(pLineItem.IDBidItem, 10) || 0;
		const tmpOptions = [ { Value: 0, Text: '— none —' } ];
		let tmpHasCurrent = (tmpCurrent === 0);
		(this._bidItemsByProject[tmpProjectKey] || []).forEach((pBidItem) =>
		{
			const tmpID = parseInt(pBidItem.IDBidItem, 10);
			if (tmpID === tmpCurrent) { tmpHasCurrent = true; }
			tmpOptions.push({ Value: tmpID, Text: this._bidItemLabel(pBidItem) });
		});
		// Never silently drop an existing mapping that points at a bid item from another project.
		if (!tmpHasCurrent && tmpCurrent > 0)
		{
			tmpOptions.push({ Value: tmpCurrent, Text: `${this._bidItemLabelByID[String(tmpCurrent)] || `Bid Item ${tmpCurrent}`} (other project)` });
		}
		return tmpOptions;
	}

	/** Selection handler — used by both the per-row picker (OnChange) and the native fallback (onchange). */
	onPick(pIDLineItem, pValue)
	{
		const tmpIDLineItem = parseInt(pIDLineItem, 10);
		const tmpValue = parseInt(pValue, 10) || 0;
		const tmpLineItem = this._lineItems.find((pRow) => pRow.IDLineItem === tmpIDLineItem);
		const tmpOriginal = tmpLineItem ? (parseInt(tmpLineItem.IDBidItem, 10) || 0) : 0;
		if (tmpValue === tmpOriginal) { delete this._pending[String(tmpIDLineItem)]; }
		else { this._pending[String(tmpIDLineItem)] = tmpValue; }
		this._syncSaveBar();
		this._highlightRow(tmpIDLineItem);
	}

	_highlightRow(pIDLineItem)
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !this._Mount) { return; }
		const tmpEl = tmpCA.getElement(`${this._Mount} tr[data-li="${pIDLineItem}"]`);
		const tmpRow = (tmpEl && tmpEl.length) ? tmpEl[0] : null;
		if (tmpRow && tmpRow.classList) { tmpRow.classList.toggle('libim-changed', this._pending[String(pIDLineItem)] !== undefined); }
	}

	pendingCount() { return Object.keys(this._pending).length; }

	async saveAsync()
	{
		if (!this._canEdit()) { this._flash('You do not have permission to edit line items.', 'is-danger'); return; }
		const tmpKeys = Object.keys(this._pending);
		if (tmpKeys.length === 0 || this._saving) { return; }

		this._saving = true;
		this._syncSaveBar();

		let tmpOK = 0;
		let tmpFail = 0;
		for (let i = 0; i < tmpKeys.length; i++)
		{
			const tmpIDLineItem = parseInt(tmpKeys[i], 10);
			const tmpIDBidItem = this._pending[tmpKeys[i]] || 0;
			// Field-wise Meadow update — send only the id + the changed FK (never IDCustomer; the server owns it).
			const tmpRes = await this._putJSON('LineItem', { IDLineItem: tmpIDLineItem, IDBidItem: tmpIDBidItem });
			if (tmpRes && !tmpRes.error)
			{
				tmpOK++;
				const tmpLineItem = this._lineItems.find((pRow) => pRow.IDLineItem === tmpIDLineItem);
				if (tmpLineItem) { tmpLineItem.IDBidItem = tmpIDBidItem; }
				delete this._pending[tmpKeys[i]];
			}
			else { tmpFail++; }
		}

		this._saving = false;
		this._flash(`Saved ${tmpOK} mapping${tmpOK === 1 ? '' : 's'}${tmpFail ? `, ${tmpFail} failed` : ''}.`, tmpFail ? 'is-warning' : 'is-success');
		this._render();
	}

	_flash(pMessage, pClass)
	{
		this._message = pMessage;
		this._messageClass = pClass || 'is-info';
	}

	// Cheap partial repaint of just the save bar (avoids repainting the whole grid on every pick).
	_syncSaveBar()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !this._Mount) { return; }
		if (tmpCA.getElement(`${this._Mount} .libim-savebar`).length === 0) { return; }
		tmpCA.assignContent(`${this._Mount} .libim-savebar`, this._saveBarHTML());
	}

	_saveBarHTML()
	{
		const tmpCount = this.pendingCount();
		const tmpDisabled = (tmpCount === 0 || this._saving || !this._canEdit()) ? 'disabled' : '';
		const tmpLabel = this._saving ? 'Saving…' : (tmpCount > 0 ? `Save ${tmpCount} change${tmpCount === 1 ? '' : 's'}` : 'No changes');
		return /*html*/`
			<span class="libim-pending">${tmpCount > 0 ? `${tmpCount} unsaved change${tmpCount === 1 ? '' : 's'}` : 'All mappings saved'}</span>
			<button class="libim-btn libim-btn-primary" ${tmpDisabled} onclick="_Pict.providers.LineItemBidItemMap.saveAsync()">${tmpLabel}</button>`;
	}

	_nativeOptionsHTML(pLineItem)
	{
		const tmpSelected = this._currentValue(pLineItem);
		return this._pickerOptions(pLineItem)
			.map((pOption) => `<option value="${pOption.Value}"${pOption.Value === tmpSelected ? ' selected' : ''}>${_escape(pOption.Text)}</option>`)
			.join('');
	}

	_render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !this._Mount) { return; }
		if (tmpCA.getElement(this._Mount).length === 0) { return; }

		if (this._loading)
		{
			tmpCA.assignContent(this._Mount, /*html*/`<div class="libim-empty">Loading line items…</div>`);
			return;
		}
		if (this._lineItems.length === 0)
		{
			tmpCA.assignContent(this._Mount, /*html*/`<div class="libim-empty">This project has no line items.</div>`);
			return;
		}

		const tmpReadOnly = !this._canEdit();
		const tmpMessage = this._message ? `<div class="libim-msg ${this._messageClass}">${_escape(this._message)}</div>` : '';
		const tmpTrunc = this._truncated ? `<div class="libim-msg is-warning">Showing the first ${MAX_ROWS} line items — narrow the set on the Line Items list for the rest.</div>` : '';
		const tmpReadNote = tmpReadOnly ? `<div class="libim-msg is-warning">You can view these mappings but not change them (needs the line-item edit permission).</div>` : '';
		const tmpBigNote = (!tmpReadOnly && !this._usePickers) ? `<div class="libim-msg is-info">This project has a lot of line items — using quick dropdowns instead of the searchable picker to stay responsive.</div>` : '';

		let tmpRows = '';
		for (let i = 0; i < this._lineItems.length; i++)
		{
			const tmpLI = this._lineItems[i];
			const tmpName = _escape(tmpLI.Name || tmpLI.ItemCode || `Line Item ${tmpLI.IDLineItem}`);
			const tmpNum = _escape(tmpLI.ItemNumber || '');
			const tmpChanged = (this._pending[String(tmpLI.IDLineItem)] !== undefined) ? ' libim-changed' : '';
			const tmpControl = this._usePickers
				? `<div id="LIBIM-pick-${tmpLI.IDLineItem}" class="libim-pickmount"></div>`
				: `<select class="libim-select" ${tmpReadOnly ? 'disabled' : ''} onchange="_Pict.providers.LineItemBidItemMap.onPick(${tmpLI.IDLineItem}, this.value)">${this._nativeOptionsHTML(tmpLI)}</select>`;
			tmpRows += /*html*/`
				<tr class="libim-row${tmpChanged}" data-li="${tmpLI.IDLineItem}">
					<td class="libim-num">${tmpNum}</td>
					<td class="libim-name">${tmpName}</td>
					<td class="libim-pick">${tmpControl}</td>
				</tr>`;
		}

		tmpCA.assignContent(this._Mount, /*html*/`
			<div class="libim">
				${tmpReadNote}${tmpBigNote}${tmpTrunc}${tmpMessage}
				<div class="libim-toolbar">
					<div class="libim-count">${this._lineItems.length} line item${this._lineItems.length === 1 ? '' : 's'}</div>
					<div class="libim-savebar">${this._saveBarHTML()}</div>
				</div>
				<div class="libim-tablewrap">
					<table class="libim-table">
						<thead><tr><th>Item #</th><th>Line Item</th><th>Bid Item (this line item's project)</th></tr></thead>
						<tbody>${tmpRows}</tbody>
					</table>
				</div>
			</div>`);

		if (this._usePickers && !tmpReadOnly) { this._mountRowPickers(); }
	}

	_mountRowPickers()
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const tmpStore = this.pict.AppData.LineItemBidItemMap.RowValues;

		for (let i = 0; i < this._lineItems.length; i++)
		{
			const tmpLI = this._lineItems[i];
			const tmpID = tmpLI.IDLineItem;
			const tmpDest = `#LIBIM-pick-${tmpID}`;
			if (tmpCA.getElement(tmpDest).length === 0) { continue; }

			const tmpValue = this._currentValue(tmpLI);
			tmpStore[tmpID] = tmpValue;

			const tmpInstance = tmpPicker.createPicker(`LIBIM-Pick-${tmpID}`,
				{
					DestinationAddress: tmpDest,
					ValueAddress: `AppData.LineItemBidItemMap.RowValues.${tmpID}`,
					Searchable: true,
					Placeholder: 'Search bid items…',
					Options: this._pickerOptions(tmpLI),
					OnChange: ((pRowID) => (pNewValue) => this.onPick(pRowID, pNewValue))(tmpID),
				});
			if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
			if (tmpInstance && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(tmpValue); }
		}
	}
}

function _escape(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const _CSS = /*css*/`
	.libim { font-size: 0.9rem; }
	.libim-empty { padding: 1.2rem; color: var(--theme-color-text-muted,#6b7686); text-align:center; }
	.libim-toolbar { display:flex; align-items:center; justify-content:space-between; gap:1rem; margin:0 0 0.7rem; flex-wrap:wrap; }
	.libim-count { font-size:0.85rem; color:var(--theme-color-text-muted,#6b7686); }
	.libim-savebar { display:flex; align-items:center; gap:0.7rem; }
	.libim-pending { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); }
	.libim-btn { font-size:0.85rem; font-weight:600; padding:0.42rem 0.95rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
	.libim-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
	.libim-btn[disabled] { opacity:0.5; cursor:default; }
	.libim-msg { font-size:0.84rem; border-radius:6px; padding:0.45rem 0.65rem; margin:0 0 0.6rem; }
	.libim-msg.is-info { color:#1f5673; background:var(--theme-color-status-info-bg,#e5f2f8); }
	.libim-msg.is-success { color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); }
	.libim-msg.is-warning { color:#8a6d1b; background:var(--theme-color-status-warning-bg,#fbf3d9); }
	.libim-msg.is-danger { color:#a12d22; background:var(--theme-color-status-danger-bg,#fbe6e3); }
	.libim-tablewrap { overflow-x:auto; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; }
	.libim-table { width:100%; border-collapse:separate; border-spacing:0; }
	.libim-table th { text-align:left; font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#f4f6f9); padding:0.5rem 0.85rem; border-bottom:1px solid var(--theme-color-border-light,#e8ebf0); }
	.libim-table td { padding:0.45rem 0.85rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); vertical-align:top; }
	.libim-table tbody tr:last-child td { border-bottom:none; }
	.libim-row.libim-changed td { background:var(--theme-color-status-warning-bg,#fbf3d9); }
	.libim-num { white-space:nowrap; color:var(--theme-color-text-muted,#6b7686); font-variant-numeric:tabular-nums; padding-top:0.65rem; }
	.libim-name { color:var(--theme-color-text-primary,#1f2733); padding-top:0.6rem; }
	.libim-pick { min-width:18rem; }
	.libim-pickmount { min-width:16rem; max-width:34rem; }
	.libim-select { font-size:0.86rem; padding:0.32rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); min-width:16rem; max-width:34rem; }
	.libim-select[disabled] { opacity:0.7; }
`;

module.exports = LineItemBidItemMapProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'LineItemBidItemMap',
	AutoInitialize: true,
	AutoInitializeOrdinal: 222,
};

},{"pict-provider":845}],1347:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libLocationTree = require('headlight-sample-scanning').LocationTree;
const libSampleLocationCartSession = require('../samples/SampleLocationCart-Session.js');

// The Location page's own cart for adding samples here: separate from the Sample page's and the panels' carts.
const SAMPLE_CART_NAME = 'LocationSampleCart';
const SAMPLE_CART_HOST_ID = 'LocationWorkspace-SampleCart';

/**
 * @typedef {Object} LocationRecord
 * @property {number} IDLocation
 * @property {string} [GUIDLocation]
 * @property {number} [ParentIDLocation]
 * @property {string} [Name]
 * @property {string} [Type]
 * @property {string} [QRCode]
 * @property {number|string} [Latitude]
 * @property {number|string} [Longitude]
 * @property {number} [IDObservation] - the location's photo (an image observation), 0 when it has none
 */

/**
 * @typedef {Object} LocationSamplesState
 * @property {boolean} Loaded
 * @property {boolean} Loading
 * @property {string} Error
 * @property {Array<Record<string, any>>} Samples
 * @property {Array<number>} LocationIDs
 * @property {boolean} Truncated
 */

/**
 * The bespoke methods behind workspace-configs/Location.config.js: where the location sits in the location tree,
 * its photo and where it is on a map, the samples kept here or in any location inside it, printing its label and
 * deleting it.
 */
class LocationWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		/** @type {Array<LocationRecord>} */
		this._locations = [];
		/** @type {LocationSamplesState} */
		this._samples = this._emptySamplesState();
	}

	/**
	 * @return {LocationSamplesState}
	 */
	_emptySamplesState()
	{
		return { Loaded: false, Loading: false, Error: '', Samples: [], LocationIDs: [], Truncated: false };
	}

	/**
	 * @return {any} the confirmation modal, when the app has one
	 */
	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	/**
	 * @return {boolean}
	 */
	canUpdate()
	{
		return this.can('Location', 'Update');
	}

	/**
	 * @return {boolean}
	 */
	canDelete()
	{
		return this.can('Location', 'Delete');
	}

	/**
	 * Called by the base after the location record loads: reset the samples tab and read the customer's locations
	 * for the breadcrumb and the locations inside this one.
	 *
	 * @return {Promise<void>}
	 */
	async hydrateAsync()
	{
		this.sampleCart.close();
		this._addingSamples = false;
		this._samples = this._emptySamplesState();
		const tmpLocationProvider = this.pict.providers.LocationProvider;
		if (!tmpLocationProvider || (typeof tmpLocationProvider.getAllLocations !== 'function'))
		{
			this._locations = [];
			return;
		}
		try
		{
			this._locations = await tmpLocationProvider.getAllLocations();
		}
		catch (pError)
		{
			this.pict.log.warn(`LocationWorkspace: could not read the location list: ${(pError && pError.message) || pError}`);
			this._locations = [];
		}
	}

	/**
	 * @param {string} pSize - Thumbnail, Standard, Preview or Enhanced
	 * @return {string} the URL of the location's photo at that size, through GET Location/:IDLocation/Photo/:Size
	 */
	photoURL(pSize)
	{
		const tmpPath = `Location/${Number(this.record.IDLocation)}/Photo/${pSize}`;
		const tmpRestClient = this.restClient;
		if (tmpRestClient && (typeof tmpRestClient.formatUrl === 'function'))
		{
			try
			{
				return tmpRestClient.formatUrl(tmpPath);
			}
			catch (pError)
			{
				// fall through to the relative URL
			}
		}
		return `/1.0/${tmpPath}`;
	}

	/**
	 * The Details tab's Photo field: the location's photo (opening full size in a new tab), or "No photo."
	 *
	 * @return {string}
	 */
	photoHTML()
	{
		if (!(Number(this.record.IDObservation) > 0))
		{
			return 'No photo.';
		}
		const tmpName = this.record.Name || `Location ${this.record.IDLocation}`;
		// A just-uploaded photo can take a moment to process; say so instead of showing a broken image.
		return `<a class="locw-photo-link" href="${this._esc(this.photoURL('Standard'))}" target="_blank" rel="noopener">` +
			`<img class="locw-photo" src="${this._esc(this.photoURL('Preview'))}" alt="Photo of ${this._esc(tmpName)}" ` +
			`onerror="this.parentNode.classList.add('is-hidden'); this.parentNode.nextElementSibling.classList.remove('is-hidden');" /></a>` +
			`<span class="pw-muted is-hidden">The photo is still being processed. It will show here shortly.</span>`;
	}

	/**
	 * @return {{ lat: number, lng: number }|null} the location's coordinates, when it has real ones (not blank, not
	 *     0,0, within range)
	 */
	coordinates()
	{
		const tmpRecord = this.record;
		if ((tmpRecord.Latitude === null) || (tmpRecord.Latitude === undefined) || (tmpRecord.Latitude === '') ||
			(tmpRecord.Longitude === null) || (tmpRecord.Longitude === undefined) || (tmpRecord.Longitude === ''))
		{
			return null;
		}
		const tmpLat = Number(tmpRecord.Latitude);
		const tmpLng = Number(tmpRecord.Longitude);
		if (!Number.isFinite(tmpLat) || !Number.isFinite(tmpLng) || (Math.abs(tmpLat) > 90) || (Math.abs(tmpLng) > 180) || ((tmpLat === 0) && (tmpLng === 0)))
		{
			return null;
		}
		return { lat: tmpLat, lng: tmpLng };
	}

	/**
	 * What the LocationViewMap plots: one read-only marker at the location.
	 * @return {{ capture?: { lat: number, lng: number, label: string } }}
	 */
	mapPoints()
	{
		const tmpPoint = this.coordinates();
		return tmpPoint ? { capture: Object.assign({ label: this.record.Name || 'Location' }, tmpPoint) } : {};
	}

	/**
	 * The Details tab's Map field: the coordinates over a read-only map, or that none are set.
	 *
	 * @return {string}
	 */
	mapHTML()
	{
		const tmpPoint = this.coordinates();
		if (!tmpPoint)
		{
			return 'No location set.';
		}
		return `<div class="locw-coords"><i class="fas fa-location-dot"></i> ${tmpPoint.lat.toFixed(6)}, ${tmpPoint.lng.toFixed(6)}</div>` +
			'<div id="LW-MapHost" class="locw-map"></div>';
	}

	/**
	 * Draw the Details tab, then mount the map into it. The overview is drawn again when its Inside card resolves,
	 * which replaces the map's host, so the map is mounted after every draw.
	 *
	 * @param {string} pBodySel
	 */
	_renderOverview(pBodySel)
	{
		super._renderOverview(pBodySel);
		this.mountMap();
	}

	/** Mount the read-only map into the Details tab's map host, when it is on the page. */
	mountMap()
	{
		if ((typeof document === 'undefined') || !document.getElementById('LW-MapHost'))
		{
			return;
		}
		const tmpMap = this.pict.views.LocationViewMap;
		if (tmpMap && (typeof tmpMap.showForProject === 'function'))
		{
			tmpMap.showForProject();
		}
	}

	// --- header QR thumbnail ---------------------------------------------------------------------------------------

	/** @return {string} the header corner's QR thumbnail host, when viewing a location that has a QR code */
	headerExtra()
	{
		return ((this.mode === 'view') && this.record.QRCode) ? '<div class="locw-qr-thumb" id="LocationWorkspace-QR"></div>' : '';
	}

	/** Draw the location's QR code into the header thumbnail, the way the Sample page draws a sample's. */
	headerAfterRender()
	{
		const tmpQR = this.pict.providers.HeadlightQR;
		if ((this.mode !== 'view') || !this.record.QRCode || !tmpQR || (typeof document === 'undefined'))
		{
			return;
		}
		try
		{
			const tmpContainer = document.querySelector('#LocationWorkspace-QR');
			if (tmpContainer)
			{
				tmpContainer.innerHTML = tmpQR.renderSVG(tmpQR.encode('Location', String(this.record.QRCode)), { SizePX: 128, Title: `QR ${this.record.QRCode}` });
			}
		}
		catch (pError)
		{
			// The thumbnail is decorative.
		}
	}

	// --- Samples tab: adding samples with this page's cart ----------------------------------------------------------

	/** @return {any} the Samples tab's cart session (this page's own cart, fixed to this location) */
	get sampleCart()
	{
		if (!this._sampleCart)
		{
			this._sampleCart = new libSampleLocationCartSession(
				{
					Pict: () => this.pict,
					CartName: SAMPLE_CART_NAME,
					HostID: SAMPLE_CART_HOST_ID,
					OwnHash: () => `#/Location/Workspace/${Number(this.record.IDLocation)}/samples`,
					Toast: (pMessage, pType) => this._toast(pMessage, pType),
					OnMoved: (pMove) => this._onSamplesMoved(pMove),
					OnLeave: () =>
					{
						this._addingSamples = false;
						this.refreshSamples();
					},
				});
		}
		return this._sampleCart;
	}

	/** @return {boolean} whether the user may move samples into this location */
	canAddSamples()
	{
		return (this.mode === 'view') && this.can('Sample', 'Update');
	}

	/** Add samples: swap the samples list for the cart, fixed to this location and empty. */
	addSamples()
	{
		if (!this.canAddSamples())
		{
			return;
		}
		this._addingSamples = true;
		this.repaintBody();
	}

	/** Close the cart and show the samples list again, read afresh. */
	closeSampleCart()
	{
		this.sampleCart.close();
		this._addingSamples = false;
		this.refreshSamples();
	}

	/**
	 * The cart moved samples here. Move all finishes adding: close the cart and show the list again. A scan saved
	 * right away keeps the cart open; the list is read again when it closes.
	 * @param {{ Moved: Array<Record<string, any>>, Via: string }} pMove
	 */
	_onSamplesMoved(pMove)
	{
		if (this._addingSamples && pMove && (pMove.Via === 'move-all') && Array.isArray(pMove.Moved) && pMove.Moved.length)
		{
			this.closeSampleCart();
		}
	}

	/** Forget the samples list and read it again, redrawing the tab. */
	refreshSamples()
	{
		this._samples = this._emptySamplesState();
		if (this._activeTab === 'samples')
		{
			this.repaintBody();
		}
		return this.ensureSamplesAsync();
	}

	/** @return {string} the Samples tab's toolbar: Add samples, when the user may */
	_samplesToolbarHTML()
	{
		if (!this.canAddSamples())
		{
			return '';
		}
		return '<div class="locw-toolbar"><button class="button is-small is-link" onclick="_Pict.providers.LocationWorkspace.addSamples()">' +
			'<span class="icon"><i class="fas fa-plus"></i></span><span>Add samples</span></button></div>';
	}

	/**
	 * @param {LocationRecord} pLocation
	 * @return {string} a link to that location's workspace
	 */
	_locationLinkHTML(pLocation)
	{
		const tmpName = pLocation.Name || `Location ${pLocation.IDLocation}`;
		return `<a href="#/Location/Workspace/${Number(pLocation.IDLocation)}">${this._esc(tmpName)}</a>`;
	}

	/**
	 * The header line under the name: the location's type and the locations it sits inside, outermost first.
	 *
	 * @return {string}
	 */
	headerSubtitle()
	{
		const tmpRecord = this.record;
		const tmpParts = [];
		if (tmpRecord.Type)
		{
			tmpParts.push(`<span class="locw-type">${this._esc(tmpRecord.Type)}</span>`);
		}
		const tmpAncestors = libLocationTree.getAncestors(tmpRecord.IDLocation, this._locations);
		if (tmpAncestors.length > 0)
		{
			tmpParts.push(`<span class="locw-crumbs">Inside ${tmpAncestors.map((pLocation) => this._locationLinkHTML(pLocation)).join(' <span class="locw-sep">›</span> ')}</span>`);
		}
		if (tmpRecord.QRCode)
		{
			tmpParts.push(`<span class="locw-qr"><i class="fas fa-qrcode"></i> ${this._esc(tmpRecord.QRCode)}</span>`);
		}
		return tmpParts.length ? `<div class="locw-subline">${tmpParts.join('')}</div>` : '';
	}

	/**
	 * Samples tab body.
	 *
	 * @return {string}
	 */
	renderSamples(pProvider, pBodySelector)
	{
		if (this._addingSamples)
		{
			// The cart draws into the tab itself, so the body is assigned here rather than returned.
			const tmpName = this.record.Name || `Location ${this.record.IDLocation}`;
			this.pict.ContentAssignment.assignContent(pBodySelector || this.bodySelector,
				`<div class="locw-toolbar locw-cart-bar"><span class="pw-muted">Scan or collect samples to move into ${this._esc(tmpName)}, then Move all.</span>` +
				'<button class="button is-small is-light" onclick="_Pict.providers.LocationWorkspace.closeSampleCart()"><span class="icon"><i class="fas fa-xmark"></i></span><span>Close</span></button></div>' +
				`<div id="${SAMPLE_CART_HOST_ID}" class="locw-cart"></div>`);
			this.sampleCart.mount({ FixedLocation: this.record });
			return undefined;
		}
		const tmpChildren = libLocationTree.getChildren(this.record.IDLocation, this._locations);
		const tmpChildHTML = this._samplesToolbarHTML() + (tmpChildren.length ?
			`<p class="locw-inside"><strong>Inside this location:</strong> ${tmpChildren.map((pChild) => this._locationLinkHTML(pChild)).join(', ')}</p>` :
			'');
		const tmpSamples = this._samples;
		if (tmpSamples.Error)
		{
			return `${tmpChildHTML}<div class="locw-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpSamples.Error)}</div>`;
		}
		if (!tmpSamples.Loaded)
		{
			return `${tmpChildHTML}<div class="pw-state"><span class="pw-spinner pw-spinner-inline"></span> Looking up samples…</div>`;
		}
		const tmpCount = tmpSamples.Samples.length;
		const tmpWhere = (tmpSamples.LocationIDs.length > 1) ? ' here or inside' : ' here';
		const tmpSummary = `${tmpCount}${tmpSamples.Truncated ? '+' : ''} sample${(tmpCount === 1) ? '' : 's'}${tmpWhere}.${tmpSamples.Truncated ? ' Showing the first 500.' : ''}`;
		if (tmpCount === 0)
		{
			return `${tmpChildHTML}<div class="pw-empty"><i class="fas fa-inbox"></i><p>No samples are kept${tmpWhere}.</p></div>`;
		}
		const tmpNames = new Map(this._locations.map((pLocation) => [ Number(pLocation.IDLocation), pLocation.Name ]));
		const tmpHere = Number(this.record.IDLocation);
		const tmpRows = tmpSamples.Samples.map((pSample) =>
		{
			const tmpCurrent = Number(pSample.CurrentIDLocation);
			const tmpWhereCell = (tmpCurrent === tmpHere) ?
				'Here' :
				`<a href="#/Location/Workspace/${tmpCurrent}">${this._esc(tmpNames.get(tmpCurrent) || `Location ${tmpCurrent}`)}</a>`;
			return `<tr>` +
				`<td class="pw-cell-strong"><a href="#/Sample/Workspace/${Number(pSample.IDSample)}">${this._esc(pSample.Name || `Sample ${pSample.IDSample}`)}</a></td>` +
				`<td class="pw-muted">${this._esc(pSample.QRCode || '')}</td>` +
				`<td>${this._esc(this._sampleStatusName(pSample.Status))}</td>` +
				`<td>${tmpWhereCell}</td>` +
				`</tr>`;
		}).join('');
		return `${tmpChildHTML}<p class="locw-count">${this._esc(tmpSummary)}</p>` +
			`<div class="pw-tablewrap"><table class="pw-table"><thead><tr><th>Sample</th><th>QR Code</th><th>Status</th><th>Where</th></tr></thead><tbody>${tmpRows}</tbody></table></div>`;
	}

	/**
	 * @param {string} pCode - a stored sample status code
	 * @return {string} its label when the Sample workspace has read the customer's statuses, else the code
	 */
	_sampleStatusName(pCode)
	{
		const tmpSampleWorkspace = this.pict.providers.SampleWorkspace;
		if (pCode && tmpSampleWorkspace && (typeof tmpSampleWorkspace.resolveSampleStatusName === 'function'))
		{
			return tmpSampleWorkspace.resolveSampleStatusName(pCode);
		}
		return pCode || '';
	}

	/**
	 * @return {Promise<void>} resolves once the Sample workspace has read the customer's status names
	 */
	_loadSampleStatusNamesAsync()
	{
		const tmpSampleWorkspace = this.pict.providers.SampleWorkspace;
		if (tmpSampleWorkspace && (typeof tmpSampleWorkspace.ensureStatusVocabularyAsync === 'function'))
		{
			return tmpSampleWorkspace.ensureStatusVocabularyAsync();
		}
		return Promise.resolve();
	}

	/**
	 * Samples tab OnEnter: look the samples up once per opened location, then repaint the tab.
	 *
	 * @return {Promise<void>}
	 */
	async ensureSamplesAsync()
	{
		const tmpSamples = this._samples;
		if (tmpSamples.Loaded || tmpSamples.Loading)
		{
			return;
		}
		const tmpLocationProvider = this.pict.providers.LocationProvider;
		if (!tmpLocationProvider || (typeof tmpLocationProvider.getSamplesAtLocation !== 'function'))
		{
			tmpSamples.Error = 'Samples by location are not available here.';
			this.repaintBody();
			return;
		}
		const tmpIDLocation = Number(this.record.IDLocation);
		tmpSamples.Loading = true;
		try
		{
			const [ tmpResult ] = await Promise.all([ tmpLocationProvider.getSamplesAtLocation(tmpIDLocation, this._locations), this._loadSampleStatusNamesAsync() ]);
			if ((this._samples !== tmpSamples) || (Number(this.record.IDLocation) !== tmpIDLocation))
			{
				return;
			}
			tmpSamples.Samples = tmpResult.Samples;
			tmpSamples.LocationIDs = tmpResult.LocationIDs;
			tmpSamples.Truncated = tmpResult.Truncated;
			tmpSamples.Loaded = true;
		}
		catch (pError)
		{
			this.pict.log.error(`LocationWorkspace: could not read the samples at location ${tmpIDLocation}: ${(pError && pError.message) || pError}`);
			tmpSamples.Error = 'Could not look up the samples at this location. Try again in a moment.';
		}
		finally
		{
			tmpSamples.Loading = false;
		}
		if (this._activeTab === 'samples')
		{
			this.repaintBody();
		}
	}

	/**
	 * @param {string} pMessage
	 * @param {string} pType - 'success' | 'error' | 'info'
	 */
	_toast(pMessage, pType)
	{
		const tmpPanels = this.pict.views.HeadlightPanels;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast({ type: (pType === 'error') ? 'is-danger' : ((pType === 'success') ? 'is-success' : 'is-info'), message: pMessage });
			return;
		}
		this.pict.log.info(`LocationWorkspace: ${pMessage}`);
	}

	/**
	 * Print the location's QR label, the same label legacy LIMS prints.
	 *
	 * @param {boolean} [pShowOptions] - open Print options (label stock and preview) instead of printing right away
	 * @return {Promise<void>}
	 */
	async printLabel(pShowOptions)
	{
		const tmpRecord = this.record;
		const tmpQR = this.pict.providers.QRCodeProvider;
		if (!tmpQR || !tmpRecord.QRCode)
		{
			this._toast('This location has no QR code to print.', 'error');
			return;
		}
		await tmpQR.ensurePrintableManifests();
		if (await tmpQR.printDecoratedEntity('Location', tmpRecord.QRCode, undefined, undefined, tmpRecord, { ShowOptions: !!pShowOptions }) === null)
		{
			this._toast('The label could not be printed. Check your connection and try again.', 'error');
		}
	}

	/**
	 * Ask, then delete this location and go back to the list.
	 *
	 * @return {Promise<void>}
	 */
	async deleteLocation()
	{
		const tmpRecord = this.record;
		if (!tmpRecord.IDLocation)
		{
			return;
		}
		if (!this.canDelete())
		{
			this._toast('You do not have permission to delete locations.', 'error');
			return;
		}
		const tmpName = tmpRecord.Name || `Location ${tmpRecord.IDLocation}`;
		const tmpInside = libLocationTree.getChildren(tmpRecord.IDLocation, this._locations).length;
		const tmpMessage = `Delete “${tmpName}”?${(tmpInside > 0) ? ` ${tmpInside} location${(tmpInside === 1) ? ' is' : 's are'} inside it and will no longer be inside anything.` : ''} This can't be undone.`;
		let tmpConfirmed;
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			tmpConfirmed = await this.modal.confirm(tmpMessage, { title: 'Delete this location?', confirmLabel: 'Delete', cancelLabel: 'Cancel' });
		}
		else
		{
			tmpConfirmed = (typeof window !== 'undefined') && window.confirm(tmpMessage);
		}
		if (!tmpConfirmed)
		{
			return;
		}
		const tmpError = await new Promise((fResolve) =>
		{
			this.restClient.deleteEntity('Location', tmpRecord.IDLocation, (pError) => fResolve(pError || null));
		});
		if (tmpError)
		{
			this._toast(`The location could not be deleted: ${(tmpError && tmpError.message) || tmpError}`, 'error');
			return;
		}
		this._toast('Location deleted.', 'success');
		this.backToList();
	}
}

module.exports = LocationWorkspaceProvider;

},{"../samples/SampleLocationCart-Session.js":1394,"headlight-sample-scanning":294,"pict-section-workspace":1049}],1348:[function(require,module,exports){

// Shared logic for the Headlight logo endpoints (bespoke, NOT Meadow auto-REST). One controller drives
// a set of logo "slots" for a single owner id (a customer id, or a project id):
//   POST   <prefix><Base>/<id>          raw PNG bytes, Content-Type: image/png   -> {Success:true}
//   GET    <prefix><Base>/<id>          streams the PNG (200), transparent/none otherwise
//   GET    <prefix><Base>/Remove/<id>
// where <Base> is e.g. 'Customer/Logo', 'Customer/SecondaryLogo', 'Project/PrimaryLogo',
// 'Project/SecondaryLogo'. Both My Headlight (customer logos) and the Project workspace (project logos)
// use this so all four logos behave identically. Permission is owner-specific and computed by the host
// (role >= 5, or role 4 editing their own customer / a project in their customer); the host passes it in.

class LogoSlotController
{
	/**
	 * @param {any} pPict
	 * @param {String} pProviderName - the host provider's identifier (the slot template calls it back).
	 * @param {Array<{Key:String, Label:String, Help:String, Base:String}>} pSlotDefs
	 */
	constructor(pPict, pProviderName, pSlotDefs)
	{
		this.pict = pPict;
		this.providerName = pProviderName;
		this.slotDefs = pSlotDefs;

		this.ownerID = null;
		this.canManage = false;
		this._onChange = () => {};

		// Per-slot UI state.
		this.state = {};
		this.slotDefs.forEach((pDef) => { this.state[pDef.Key] = { hasLogo: false, cacheBust: 1, uploading: false }; });
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get _prefix()
	{
		return (this.restClient && this.restClient.options && this.restClient.options.ServerURL) || '/1.0/';
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	_toast(pMessage, pType)
	{
		if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); }
	}

	_def(pKey)
	{
		return this.slotDefs.find((pDef) => pDef.Key === pKey);
	}

	_url(pDef, pState)
	{
		return `${this._prefix}${pDef.Base}/${this.ownerID}?cb=${pState.cacheBust}`;
	}

	/**
	 * Point the controller at an owner (customer/project id) + permission, and register the host's
	 * re-render. Resets slot state so a fresh owner re-probes.
	 * @param {Number|String} pOwnerID
	 * @param {Boolean} pCanManage
	 * @param {Function} pOnChange
	 */
	setContext(pOwnerID, pCanManage, pOnChange)
	{
		this.ownerID = pOwnerID;
		this.canManage = !!pCanManage;
		this._onChange = (typeof pOnChange === 'function') ? pOnChange : () => {};
		this.slotDefs.forEach((pDef) => { this.state[pDef.Key] = { hasLogo: false, cacheBust: 1, uploading: false }; });
	}

	/** Probe every slot's logo existence (200 + a non-trivial body; a placeholder is tiny / 202). */
	async probeAll()
	{
		if (this.ownerID == null) { return; }
		await Promise.all(this.slotDefs.map((pDef) => this._probe(pDef)));
	}

	async _probe(pDef)
	{
		const tmpState = this.state[pDef.Key];
		try
		{
			const tmpResponse = await fetch(this._url(pDef, tmpState), { credentials: 'include' });
			if (tmpResponse.status !== 200) { tmpState.hasLogo = false; return; }
			const tmpLength = Number(tmpResponse.headers.get('Content-Length') || 0);
			if (tmpLength > 0) { tmpState.hasLogo = tmpLength > 1000; return; }
			const tmpBlob = await tmpResponse.blob();
			tmpState.hasLogo = tmpBlob.size > 1000;
		}
		catch (pError)
		{
			tmpState.hasLogo = false;
		}
	}

	/**
	 * Upload the chosen file (raw PNG POST) for one slot.
	 * @param {String} pKey
	 * @param {HTMLInputElement} pInput
	 */
	async upload(pKey, pInput)
	{
		const tmpDef = this._def(pKey);
		const tmpState = this.state[pKey];
		const tmpFile = (pInput && pInput.files && pInput.files[0]) ? pInput.files[0] : null;
		if (!tmpDef || !tmpFile) { return; }
		if (tmpFile.type !== 'image/png')
		{
			this._toast('Logos must be PNG files.', 'error');
			pInput.value = '';
			return;
		}
		tmpState.uploading = true;
		this._onChange();
		try
		{
			const tmpResponse = await fetch(`${this._prefix}${tmpDef.Base}/${this.ownerID}`,
				{ method: 'POST', credentials: 'include', headers: { 'Content-Type': 'image/png' }, body: tmpFile });
			if (!tmpResponse.ok) { throw new Error(`server returned ${tmpResponse.status}`); }
			tmpState.hasLogo = true;
			tmpState.cacheBust = tmpState.cacheBust + 1;
			tmpState.uploading = false;
			this._toast(`${tmpDef.Label} updated.`, 'success');
			this._onChange();
		}
		catch (pError)
		{
			tmpState.uploading = false;
			this._toast(`Could not upload ${tmpDef.Label.toLowerCase()}: ${pError.message || pError}`, 'error');
			this._onChange();
		}
		pInput.value = '';
	}

	/** Remove one slot's logo (confirm first). */
	remove(pKey)
	{
		const tmpDef = this._def(pKey);
		const tmpState = this.state[pKey];
		if (!tmpDef || !tmpState.hasLogo) { return; }
		const fApply = async () =>
		{
			try
			{
				const tmpResponse = await fetch(`${this._prefix}${tmpDef.Base}/Remove/${this.ownerID}`, { credentials: 'include' });
				if (!tmpResponse.ok) { throw new Error(`server returned ${tmpResponse.status}`); }
				tmpState.hasLogo = false;
				tmpState.cacheBust = tmpState.cacheBust + 1;
				this._toast(`${tmpDef.Label} removed.`, 'success');
				this._onChange();
			}
			catch (pError)
			{
				this._toast(`Could not remove ${tmpDef.Label.toLowerCase()}: ${pError.message || pError}`, 'error');
			}
		};
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(`Remove the ${tmpDef.Label.toLowerCase()}? Headlight will fall back to the default until a new one is uploaded.`,
				{ title: `Remove ${tmpDef.Label.toLowerCase()}`, confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fApply(); } });
		}
		else { fApply(); }
	}

	/** Build the per-slot render records the shared Headlight-LogoSlot template iterates. */
	buildRecords()
	{
		return this.slotDefs.map((pDef) =>
		{
			const tmpState = this.state[pDef.Key];
			return (
				{
					ProviderName: this.providerName,
					Key: pDef.Key,
					Label: pDef.Label,
					Help: pDef.Help,
					LogoSlot: tmpState.hasLogo ? [ { LogoURL: this._url(pDef, tmpState) } ] : [],
					EmptySlot: tmpState.hasLogo ? [] : [ {} ],
					UploadSlot: (this.canManage && !tmpState.uploading) ? [ { UploadLabel: tmpState.hasLogo ? 'Replace' : 'Upload', ProviderName: this.providerName, Key: pDef.Key } ] : [],
					UploadingSlot: tmpState.uploading ? [ {} ] : [],
					RemoveSlot: (tmpState.hasLogo && this.canManage && !tmpState.uploading) ? [ { ProviderName: this.providerName, Key: pDef.Key } ] : [],
					ReadOnlySlot: this.canManage ? [] : [ {} ],
				});
		});
	}
}

module.exports = LogoSlotController;

// The shared CSS for a logo slot (a transparency-checkerboard frame + actions). Hosts add this to their
// view CSS.
module.exports.LOGO_SLOT_CSS = /*css*/`
	.logo-slot { display: flex; gap: 1.5rem; align-items: flex-start; flex-wrap: wrap; padding: 0.4rem 0; }
	.logo-slot + .logo-slot { border-top: 1px solid var(--theme-color-border-light, #e8ebf0); margin-top: 0.6rem; padding-top: 1.1rem; }
	.logo-frame { flex: 0 0 auto; width: 15rem; height: 8.25rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px;
		background:
			linear-gradient(45deg, var(--theme-color-background-tertiary, #f1f3f6) 25%, transparent 25%),
			linear-gradient(-45deg, var(--theme-color-background-tertiary, #f1f3f6) 25%, transparent 25%),
			linear-gradient(45deg, transparent 75%, var(--theme-color-background-tertiary, #f1f3f6) 75%),
			linear-gradient(-45deg, transparent 75%, var(--theme-color-background-tertiary, #f1f3f6) 75%);
		background-size: 16px 16px; background-position: 0 0, 0 8px, 8px -8px, -8px 0;
		display: flex; align-items: center; justify-content: center; overflow: hidden; }
	.logo-frame img { max-width: 100%; max-height: 100%; object-fit: contain; }
	.logo-empty { color: var(--theme-color-text-muted, #6b7686); font-size: 0.85rem; text-align: center; padding: 0 1rem; }
	.logo-empty .icon { font-size: 1.5rem; display: block; margin: 0 auto 0.3rem; }
	.logo-slot-body { flex: 1 1 16rem; min-width: 14rem; }
	.logo-slot-label { font-size: 0.95rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); margin: 0 0 0.2rem; }
	.logo-slot-help { font-size: 0.84rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.9rem; line-height: 1.5; }
	.logo-slot-actions { display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap; }
	.logo-upload-label { display: inline-flex; align-items: center; gap: 0.4rem; cursor: pointer; }
	.logo-upload-label input { display: none; }
	.logo-readonly { font-size: 0.84rem; color: var(--theme-color-text-muted, #6b7686); font-style: italic; }
	.logo-spin { display: inline-block; width: 1.1rem; height: 1.1rem; border: 2px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: logo-spin 0.7s linear infinite; vertical-align: -0.15rem; margin-right: 0.4rem; }
	@keyframes logo-spin { to { transform: rotate(360deg); } }
`;

// The shared templates a host iterates with {~TS:Headlight-LogoSlot:<...Slots address>~}. Handlers call
// back into the host provider by name (Record.ProviderName) so one template serves every logo.
module.exports.LOGO_SLOT_TEMPLATES =
[
	{
		Hash: 'Headlight-LogoSlot',
		Template: /*html*/`
			<div class="logo-slot">
				<div class="logo-frame">
					{~TS:Headlight-LogoSlot-Img:Record.LogoSlot~}
					{~TS:Headlight-LogoSlot-Empty:Record.EmptySlot~}
				</div>
				<div class="logo-slot-body">
					<p class="logo-slot-label">{~D:Record.Label~}</p>
					<p class="logo-slot-help">{~D:Record.Help~}</p>
					<div class="logo-slot-actions">
						{~TS:Headlight-LogoSlot-Upload:Record.UploadSlot~}
						{~TS:Headlight-LogoSlot-Uploading:Record.UploadingSlot~}
						{~TS:Headlight-LogoSlot-Remove:Record.RemoveSlot~}
						{~TS:Headlight-LogoSlot-ReadOnly:Record.ReadOnlySlot~}
					</div>
				</div>
			</div>`
	},
	{
		Hash: 'Headlight-LogoSlot-Img',
		Template: /*html*/`<img src="{~D:Record.LogoURL~}" alt="Logo" />`
	},
	{
		Hash: 'Headlight-LogoSlot-Empty',
		Template: /*html*/`<div class="logo-empty"><span class="icon">{~I:Image~}</span>None uploaded yet</div>`
	},
	{
		Hash: 'Headlight-LogoSlot-Upload',
		Template: /*html*/`<label class="button is-link logo-upload-label"><span class="icon">{~I:Upload~}</span><span>{~D:Record.UploadLabel~}</span><input type="file" accept="image/png" onchange="_Pict.providers['{~D:Record.ProviderName~}'].uploadSlot('{~D:Record.Key~}', this)" /></label>`
	},
	{
		Hash: 'Headlight-LogoSlot-Uploading',
		Template: /*html*/`<span class="logo-readonly"><span class="logo-spin"></span>Uploading…</span>`
	},
	{
		Hash: 'Headlight-LogoSlot-Remove',
		Template: /*html*/`<button class="button is-light" onclick="_Pict.providers['{~D:Record.ProviderName~}'].removeSlot('{~D:Record.Key~}')"><span class="icon">{~I:Trash~}</span><span>Remove</span></button>`
	},
	{
		Hash: 'Headlight-LogoSlot-ReadOnly',
		Template: /*html*/`<span class="logo-readonly">You don’t have permission to change this logo.</span>`
	}
];

},{}],1349:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');

/**
 * LotWorkspace-Provider — the bespoke-methods subclass behind source/workspace-configs/Lot.config.js.
 *
 * The Lot's own Overview stays the declarative FieldGroups (the base handles it). Its extra surface is the "Sub Lots"
 * tab: SubLot is a child of Lot (SubLot.IDLot), and each SubLot carries its OWN per-customer metadata blob
 * (SubLotMetadata). Rather than give SubLot a standalone workspace, we NEST it here — the tab lists the lot's sub lots
 * and expands one at a time into the shared EntityMetadataForm (read-only + inline Edit/Save), reusing the same
 * guided-metadata pattern as MixDesign/Product/MixType. See [[config-app-entity-metadata]] +
 * source/providers/EntityMetadataForm-Provider.js (the EntityMetadataForm singleton hosts one record at a time, which
 * is why sub lots expand singly).
 */
class LotWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._subLots = [];
		this._subLotsLoaded = false;
		this._subLotsLoading = false;
		this._subLotsError = '';
		this._openSubLotID = 0;
	}

	get app() { return this.pict.PictApplication; }
	// Resolve-null REST (best-effort read; the tab shows its own empty/error state).
	_get(pURL) { return new Promise((resolve) => this.restClient.getJSON(pURL, (pError, pBody) => resolve(pError ? null : pBody))); }

	/** Base calls this after the record loads — reset the per-lot sub-lot state. */
	async hydrateAsync()
	{
		this._subLots = [];
		this._subLotsLoaded = false;
		this._subLotsLoading = false;
		this._subLotsError = '';
		this._openSubLotID = 0;
	}

	// --- Sub Lots tab ---------------------------------------------------------------------------------------
	_subLotsHTML()
	{
		return `<p class="lw-help">The <strong>sub lots</strong> sampled under this lot, each with its own per-customer metadata. Expand one to view or edit its metadata.</p>`
			+ `<div id="LW-SubLots" class="lw-sublots">${this._subLotsListHTML()}</div>`;
	}

	_subLotsListHTML()
	{
		if (this._subLotsError) { return `<div class="lw-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._subLotsError)}</div>`; }
		if (!this._subLotsLoaded) { return '<div class="lw-note"><i class="fas fa-spinner fa-spin"></i> Loading sub lots…</div>'; }
		if (!this._subLots.length) { return '<div class="lw-note">No sub lots under this lot.</div>'; }
		return this._subLots.map((pSubLot) => this._subLotRowHTML(pSubLot)).join('');
	}

	_subLotRowHTML(pSubLot)
	{
		const tmpID = Number(pSubLot.IDSubLot);
		const tmpOpen = (this._openSubLotID === tmpID);
		const tmpSummary = this._subLotSummary(pSubLot);
		return `<div class="lw-sublot${tmpOpen ? ' is-open' : ''}">`
			+ `<button type="button" class="lw-sublot-head" onclick="_Pict.providers.LotWorkspace.toggleSubLot(${tmpID})">`
			+ `<span class="lw-sublot-name"><i class="fas fa-chevron-${tmpOpen ? 'down' : 'right'}"></i> ${this._esc(pSubLot.Name || ('Sub Lot ' + tmpID))}</span>`
			+ `<span class="lw-sublot-summary">${tmpSummary}</span>`
			+ `</button>`
			+ `<div class="lw-sublot-body" id="LW-SubLotHost-${tmpID}"${tmpOpen ? '' : ' hidden'}></div>`
			+ `</div>`;
	}

	/** A couple of metadata values for the collapsed header, so the list is scannable. */
	_subLotSummary(pSubLot)
	{
		let tmpMeta = pSubLot.SubLotMetadata;
		if (tmpMeta && (typeof tmpMeta === 'string')) { try { tmpMeta = JSON.parse(tmpMeta); } catch (pE) { tmpMeta = {}; } }
		tmpMeta = tmpMeta || {};
		const tmpBits = [];
		if (tmpMeta.Plant_Tons != null) { tmpBits.push(`Plant ${tmpMeta.Plant_Tons} t`); }
		if (tmpMeta.Mainline_Tons != null) { tmpBits.push(`Mainline ${tmpMeta.Mainline_Tons} t`); }
		if (tmpMeta.Gmm != null) { tmpBits.push(`Gmm ${tmpMeta.Gmm}`); }
		return tmpBits.length ? `<span class="lw-sublot-chips">${this._esc(tmpBits.join('  ·  '))}</span>` : '';
	}

	/** Tab OnEnter — load the lot's sub lots once, then repaint the list. */
	async _ensureSubLotsAsync()
	{
		if (this._subLotsLoaded) { this._renderSubLotsList(); return; }
		if (this._subLotsLoading) { return; }
		this._subLotsLoading = true;
		this._subLotsError = '';
		this._renderSubLotsList();
		const tmpID = Number(this._id) || Number(this._record && this._record.IDLot) || 0;
		const tmpRows = await this._get(`SubLots/FilteredTo/FBV~IDLot~EQ~${tmpID}/0/500`);
		if (tmpRows === null) { this._subLotsError = 'Could not load the sub lots for this lot.'; }
		this._subLots = (Array.isArray(tmpRows) ? tmpRows : []).sort((pA, pB) =>
		{
			const tmpNA = Number(pA.Name); const tmpNB = Number(pB.Name);
			if (!isNaN(tmpNA) && !isNaN(tmpNB)) { return tmpNA - tmpNB; }
			return String(pA.Name || '').localeCompare(String(pB.Name || ''), undefined, { numeric: true });
		});
		this._subLotsLoaded = true;
		this._subLotsLoading = false;
		this._renderSubLotsList();
	}

	_renderSubLotsList() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#LW-SubLots').length) { tmpCA.assignContent('#LW-SubLots', this._subLotsListHTML()); } }

	/** Expand/collapse one sub lot; expanding opens its metadata in the shared editor (one open at a time). */
	toggleSubLot(pID)
	{
		const tmpID = Number(pID);
		this._openSubLotID = (this._openSubLotID === tmpID) ? 0 : tmpID;
		this._renderSubLotsList();
		if (this._openSubLotID !== tmpID) { return; }
		const tmpSubLot = this._subLots.find((pSubLot) => Number(pSubLot.IDSubLot) === tmpID);
		const tmpEMF = this.pict.providers.EntityMetadataForm;
		if (!tmpSubLot || !tmpEMF || (typeof tmpEMF.openWorkspaceMetadata !== 'function')) { return; }
		tmpEMF.openWorkspaceMetadata({ entityType: 'SubLot', blobColumn: 'SubLotMetadata', record: tmpSubLot, idField: 'IDSubLot', idCustomer: tmpSubLot.IDCustomer, host: `#LW-SubLotHost-${tmpID}` });
	}
}

LotWorkspaceProvider.default_configuration = { ProviderIdentifier: 'LotWorkspace' };

module.exports = LotWorkspaceProvider;
module.exports.default_configuration = LotWorkspaceProvider.default_configuration;

},{"pict-section-workspace":1049}],1350:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');
// The app's own gated downloadable-app modules (Data Downloader + the future binary apps). Merged into the
// Modules-tab catalog so they can be enabled per customer even though the platform Module catalog has no row
// for them (creating a Module is a restricted op; the CustomerModuleJoin gate is keyed by ModuleHash, no FK).
const libDataDownloaderProvider = require('./DataDownloader-Provider.js');

/**
 * ManageCustomersProvider — data + logic for the #/ManageCustomers screen (platform super-users only).
 *
 * Loads the customer list and renders a filterable table into #MC-Body; each row's "Manage Configuration" button
 * kicks off impersonation of that customer's configuration admin through the SINGLE app client method
 * PlatformConfiguration-Application-Web.impersonateCustomerAdmin(IDCustomer) (the forward-compatible seam — the
 * future level-4 cross-customer flow reuses it). The level gate is the app's _isSuperUser().
 *
 * Server-managed tenancy: the client never sends IDCustomer in a body; the customer list comes back scoped by the
 * super-user session, and the impersonate call takes IDCustomer only as a route parameter.
 */
class ManageCustomersProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this.state = { Loaded: false, Loading: false, Error: '', Customers: [], Filter: '', Mode: 'customers', TeamSearch: '', TeamResults: [], TeamSearching: false, TeamError: '',
			// Customers tab: which customer row is expanded to pick a configuration-admin account to impersonate, the
			// per-customer account cache, and the load status. Picking one signs in as that specific account (no modal).
			ExpandedCustomerID: 0, AccountsByCustomer: {}, AccountsLoadingID: 0, AccountsError: '',
			// Modules tab: enable/disable Modules (CustomerModuleJoin) for a selected customer.
			ModulesCatalog: [], ModulesCustomerID: 0, ModulesJoins: [], ModulesLoading: false, ModulesError: '', ModulesFilter: '', ModulesBusyHash: '' };
		this._teamSearchTimer = null;
		this._teamSearchToken = 0;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get app() { return this.pict.PictApplication; }
	/** The shared pict-section-modal (confirm/toast); guarded — it may be absent. */
	get modal() { return this.pict.views['Pict-Section-Modal']; }

	_toast(pMessage, pType)
	{
		if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); }
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody)));
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody)));
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody)));
	}

	_deleteEntity(pEntity, pID)
	{
		return new Promise((resolve, reject) => this.restClient.deleteEntity(pEntity, pID, (pError, pBody) => pError ? reject(pError) : resolve(pBody)));
	}

	/** True when this super-user also holds the "Manage Customer Team" entitlement (delegates to the app's one gate). */
	_canManageTeam() { return !!(this.app && (typeof this.app._canManageCustomerTeam === 'function') && this.app._canManageCustomerTeam()); }

	/** UI gate — a level-5 super-admin OR a customer-1 support user with the Customer-Impersonate capability. The server
	 *  (Authentication.authorizeImpersonation) stays authoritative for the customer list + impersonation. */
	isAuthorized() { return !!(this.app && (typeof this.app.canImpersonate === 'function') && this.app.canImpersonate()); }
	/** The Modules + Customer Team tabs stay level-5 super-admin only (support staff impersonate, but don't license modules). */
	_isSuperUser() { return !!(this.app && (typeof this.app._isSuperUser === 'function') && this.app._isSuperUser()); }

	async loadAsync()
	{
		if (!this.isAuthorized()) { return; }
		this.state.Loading = true;
		this.state.Error = '';
		this.render();
		try
		{
			// The server scopes the list to what this super-user session may see (no client-side customer filter).
			const tmpRows = await this._getJSON('Customers/0/2000');
			this.state.Customers = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pCustomer) => ({ IDCustomer: pCustomer.IDCustomer, Name: pCustomer.Name || `Customer #${pCustomer.IDCustomer}`, Code: pCustomer.Code || '', Enabled: pCustomer.Enabled }))
				.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
			this.state.Loaded = true;
		}
		catch (pError)
		{
			this.state.Error = `Could not load customers: ${(pError && pError.message) ? pError.message : pError}`;
		}
		this.state.Loading = false;
		this.render();
	}

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#MC-Body').length === 0) { return; }
		if (!this.isAuthorized()) { tmpCA.assignContent('#MC-Body', this._guardHTML()); return; }
		tmpCA.assignContent('#MC-Body', this._tabsHTML() + `<div id="MC-Mode">${this._modeHTML()}</div>`);
		// assignContent is synchronous (innerHTML), so the picker mount point exists now — mount it in place.
		this._mountModePickers();
	}

	/** Tabs. Customers = anyone who reaches the screen (impersonators). Modules + Customer Team stay super-user only. */
	_tabsHTML()
	{
		const fTab = (pMode, pLabel) => `<button type="button" class="mc-tab${(this.state.Mode === pMode) ? ' is-active' : ''}" onclick="_Pict.providers.ManageCustomers.navigateMode('${pMode}')">${pLabel}</button>`;
		const tmpTabs = [ fTab('customers', 'Customers') ];
		if (this._isSuperUser()) { tmpTabs.push(fTab('modules', 'Modules')); }
		if (this._canManageTeam()) { tmpTabs.push(fTab('team', 'Customer Team')); }
		if (tmpTabs.length < 2) { return ''; }   // only Customers — no tab strip needed
		return `<div class="mc-tabs">${tmpTabs.join('')}</div>`;
	}

	_modeHTML()
	{
		// Modules + Customer Team are super-user-only surfaces; a support user landing on their route falls back to Customers.
		if ((this.state.Mode === 'team') && this._canManageTeam()) { return this._teamHTML(); }
		if ((this.state.Mode === 'modules') && this._isSuperUser()) { return this._modulesHTML(); }
		return this._bodyHTML();
	}

	/** Switch tabs. 'team' requires the entitlement; falls back to 'customers' otherwise. */
	/** Switch mode via a stable route (#/ManageCustomers/<Mode>) so the active tab lives in the URL. */
	navigateMode(pMode)
	{
		if ((typeof window !== 'undefined') && window.location) { window.location.hash = `#/ManageCustomers/${ pMode }`; }
		else { this.setMode(pMode); }
	}

	setMode(pMode)
	{
		const tmpAllowed = { customers: true, modules: true, team: this._canManageTeam() };
		this.state.Mode = tmpAllowed[pMode] ? pMode : 'customers';
		this.render();
	}

	/** Filter in place — only the list re-renders, so the filter input keeps focus. */
	onFilter(pValue)
	{
		this.state.Filter = pValue;
		this._renderList();
	}

	/** Repaint just the customer list (keeps the filter input alive + preserves the list's scroll position — no modal,
	 *  no full re-render). Used by the filter and by expanding/collapsing a customer's accounts. */
	_renderList()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpEl = tmpCA.getElement('#MC-List');
		if (!tmpEl || !tmpEl.length) { return; }
		const tmpTop = tmpEl[0].scrollTop;
		tmpCA.assignContent('#MC-List', this._listHTML());
		const tmpEl2 = tmpCA.getElement('#MC-List');
		if (tmpEl2 && tmpEl2.length) { tmpEl2[0].scrollTop = tmpTop; }
	}

	/** Expand (or collapse) a customer row to show its configuration-admin accounts. First expand loads them. No modal. */
	toggleAccounts(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		if (Number(this.state.ExpandedCustomerID) === tmpID) { this.state.ExpandedCustomerID = 0; this._renderList(); return; }
		this.state.ExpandedCustomerID = tmpID;
		this.state.AccountsError = '';
		if (!this.state.AccountsByCustomer[tmpID]) { this._loadAccountsAsync(tmpID); }
		this._renderList();
	}

	/**
	 * Load a customer's impersonatable accounts — the users who hold a PermissionLevel-'CustomerAdmin' role in that
	 * customer (the config-app write gate). Mirrors the server's resolveCustomerAdminUser query, but lists ALL of them.
	 * Cross-customer reads ride the super-user session (same pattern as SuperUserGrant / Entitlements).
	 */
	async _loadAccountsAsync(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		this.state.AccountsLoadingID = tmpID;
		this.state.AccountsError = '';
		this._renderList();
		try
		{
			const tmpRoles = await this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${tmpID}~FBV~PermissionLevel~EQ~CustomerAdmin~FBV~Deleted~EQ~0/0/200`);
			const tmpRoleIDs = (Array.isArray(tmpRoles) ? tmpRoles : []).map((pRole) => pRole.IDRole).filter(Boolean);
			let tmpAccounts = [];
			if (tmpRoleIDs.length)
			{
				const tmpJoins = await this._getJSON(`UserRoleJoins/FilteredTo/FBL~IDRole~INN~${tmpRoleIDs.join(',')}/0/1000`);
				const tmpUserIDs = Array.from(new Set((Array.isArray(tmpJoins) ? tmpJoins : []).map((pJoin) => pJoin.IDUser).filter(Boolean)));
				if (tmpUserIDs.length)
				{
					// Only live, enabled users actually IN the target customer qualify (mirrors the server's gate).
					const tmpUsers = await this._getJSON(`Users/FilteredTo/FBL~IDUser~INN~${tmpUserIDs.join(',')}~FBV~IDCustomer~EQ~${tmpID}~FBV~Deleted~EQ~0~FBV~Disabled~EQ~0/0/1000`);
					tmpAccounts = (Array.isArray(tmpUsers) ? tmpUsers : [])
						.map((pUser) => ({ IDUser: pUser.IDUser, Name: libUserSearch.userLabel(pUser), LoginID: pUser.LoginID || '', Email: pUser.Email || '' }))
						.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
				}
			}
			if (Number(this.state.ExpandedCustomerID) === tmpID) { this.state.AccountsByCustomer[tmpID] = tmpAccounts; }
		}
		catch (pError)
		{
			if (Number(this.state.ExpandedCustomerID) === tmpID) { this.state.AccountsError = `Could not load accounts: ${(pError && pError.message) ? pError.message : pError}`; }
		}
		this.state.AccountsLoadingID = 0;
		this._renderList();
	}

	/** Sign in as a specific account (no modal) via the app's per-user impersonation seam. */
	impersonateAccount(pIDUser)
	{
		if (this.app && (typeof this.app.impersonateUser === 'function')) { this.app.impersonateUser(Number(pIDUser)); }
	}

	_guardHTML()
	{
		return `<div class="mc-guard"><div class="mc-guard-title">Platform super-users only</div><p>This tool is available to level-5 platform administrators.</p></div>`;
	}

	_bodyHTML()
	{
		if (this.state.Loading && !this.state.Loaded) { return '<div class="mc-note"><i class="fas fa-spinner fa-spin"></i> Loading customers…</div>'; }
		if (this.state.Error) { return `<div class="mc-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.Error)}</div>`; }
		return `<input id="MC-Filter" class="mc-filter" type="text" autocomplete="off" placeholder="Filter customers by name or code…" oninput="_Pict.providers.ManageCustomers.onFilter(this.value)" />`
			+ `<div id="MC-List" class="mc-list">${this._listHTML()}</div>`;
	}

	_listHTML()
	{
		const tmpTerm = String(this.state.Filter || '').trim().toLowerCase();
		const tmpRows = this.state.Customers.filter((pCustomer) =>
			!tmpTerm || (String(pCustomer.Name).toLowerCase().indexOf(tmpTerm) > -1) || (String(pCustomer.Code).toLowerCase().indexOf(tmpTerm) > -1));
		if (!tmpRows.length) { return `<div class="mc-note">${tmpTerm ? 'No customers match your filter.' : 'No customers available.'}</div>`; }
		const tmpHeader = '<div class="mc-head-row"><span class="mc-col-name">Customer</span><span class="mc-col-code">Code</span><span class="mc-col-action"></span></div>';
		return tmpHeader + tmpRows.map((pCustomer) =>
		{
			const tmpID = Number(pCustomer.IDCustomer);
			const tmpExpanded = (Number(this.state.ExpandedCustomerID) === tmpID);
			const tmpDisabled = (Number(pCustomer.Enabled) === 0) ? ' <span class="mc-disabled">(disabled)</span>' : '';
			return `<div class="mc-item${tmpExpanded ? ' is-expanded' : ''}">`
				+ `<div class="mc-row">`
				+ `<span class="mc-col-name">${this._esc(pCustomer.Name)}${tmpDisabled}</span>`
				+ `<span class="mc-col-code">${this._esc(pCustomer.Code)}</span>`
				+ `<span class="mc-col-action"><button type="button" class="mc-btn${tmpExpanded ? ' is-open' : ''}" onclick="_Pict.providers.ManageCustomers.toggleAccounts(${tmpID})"><i class="fas fa-user-gear"></i> Manage Configuration <i class="fas fa-chevron-${tmpExpanded ? 'up' : 'down'} mc-btn-caret"></i></button></span>`
				+ `</div>`
				+ (tmpExpanded ? `<div class="mc-accounts">${this._accountsHTML(tmpID)}</div>` : '')
				+ `</div>`;
		}).join('');
	}

	/** The impersonatable accounts for one customer: loading / error / empty / a list of "Sign in as" account buttons. */
	_accountsHTML(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		if (this.state.AccountsError) { return `<div class="mc-accounts-note mc-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.AccountsError)}</div>`; }
		const tmpAccounts = this.state.AccountsByCustomer[tmpID];
		if (!tmpAccounts) { return `<div class="mc-accounts-note mc-note"><i class="fas fa-spinner fa-spin"></i> Loading accounts…</div>`; }
		if (!tmpAccounts.length)
		{
			return `<div class="mc-accounts-note mc-note">No configuration admin for this customer yet — <a href="#/GrantAccess">grant one in Grant Access</a> first.</div>`;
		}
		const tmpHead = '<div class="mc-accounts-head">Sign in as a configuration admin</div>';
		return tmpHead + tmpAccounts.map((pAccount) =>
			`<button type="button" class="mc-account" onclick="_Pict.providers.ManageCustomers.impersonateAccount(${Number(pAccount.IDUser)})">`
			+ `<span class="mc-account-avatar"><i class="fas fa-user"></i></span>`
			+ `<span class="mc-account-id"><span class="mc-account-name">${this._esc(pAccount.Name)}</span><span class="mc-account-login">${this._esc(pAccount.LoginID || pAccount.Email || `#${pAccount.IDUser}`)}</span></span>`
			+ `<span class="mc-account-go">Sign in <i class="fas fa-arrow-right-to-bracket"></i></span>`
			+ `</button>`).join('');
	}

	// --- Modules: enable/disable a customer's licensed Modules (CustomerModuleJoin) ---------------------
	//
	// A super-user's Meadow reads/writes are not customer-scoped, so this can read/write any customer's rows by
	// passing an explicit IDCustomer (the same cross-customer pattern SuperUserGrant uses for Role). Enablement is
	// a CustomerModuleJoin row {IDCustomer, ModuleHash, StartDate, EndDate}; disable is a physical delete (the
	// entity has no soft-delete column). The catalog of modules is the global Module entity.

	_moduleName(pModuleHash)
	{
		const tmpModule = (this.state.ModulesCatalog || []).find((pModule) => pModule.ModuleHash === pModuleHash);
		return tmpModule ? tmpModule.Name : pModuleHash;
	}

	/** Is a module currently enabled for the selected customer (a join row whose [Start,End] window holds now)? */
	_isModuleEnabled(pModuleHash)
	{
		const tmpNow = (new Date()).toISOString();
		return (this.state.ModulesJoins || []).some((pJoin) => (pJoin.ModuleHash === pModuleHash)
			&& (!pJoin.StartDate || String(pJoin.StartDate) <= tmpNow) && (!pJoin.EndDate || String(pJoin.EndDate) >= tmpNow));
	}

	_modulesHTML()
	{
		// The customer selector is a searchable pict-section-picker (mounted after paint by _mountModePickers), NOT a
		// native <select> — the roster runs to thousands of customers, so it must be type-to-filter.
		return `<p class="mc-team-help">Enable or disable licensed <strong>Modules</strong> for a customer. A customer only sees a gated feature (e.g. the Data Downloader) once its module is enabled here. Changes take effect the next time that customer loads the app.</p>`
			+ `<div class="mc-module-picker"><label class="mc-module-picklabel">Customer</label>`
			+ `<div id="MC-Module-Cust-Pick" class="mc-module-custpick"></div></div>`
			+ `<div id="MC-ModuleResults" class="mc-module-results">${this._moduleResultsHTML()}</div>`;
	}

	/** A "Name (CODE)" label for a customer roster row. */
	_customerLabel(pCustomer)
	{
		if (!pCustomer) { return ''; }
		return `${pCustomer.Name || `Customer #${pCustomer.IDCustomer}`}${pCustomer.Code ? ` (${pCustomer.Code})` : ''}`;
	}

	get pickerProvider() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }

	/** DataProvider over the in-memory customer roster (already loaded whole). Returns {results:[{Value,Text}], hasMore}. */
	_moduleCustomerDataProvider()
	{
		return (pTerm) =>
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
			const tmpRows = (this.state.Customers || [])
				.filter((pCustomer) => !tmpTerm
					|| (String(pCustomer.Name || '').toLowerCase().indexOf(tmpTerm) >= 0)
					|| (String(pCustomer.Code || '').toLowerCase().indexOf(tmpTerm) >= 0))
				.map((pCustomer) => ({ Value: Number(pCustomer.IDCustomer), Text: this._customerLabel(pCustomer) }));
			return Promise.resolve({ results: tmpRows.slice(0, 60), hasMore: tmpRows.length > 60 });
		};
	}

	_moduleCustomerResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			const tmpCustomer = (this.state.Customers || []).find((pCustomer) => Number(pCustomer.IDCustomer) === tmpID);
			return Promise.resolve(tmpCustomer ? { Value: tmpID, Text: this._customerLabel(tmpCustomer) } : null);
		};
	}

	/** Mount the searchable pickers for whatever mode just painted (currently just the Modules-tab customer picker). */
	_mountModePickers()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpPicker = this.pickerProvider;
		if (!tmpCA || !tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if ((this.state.Mode !== 'modules') || !this._isSuperUser()) { return; }
		if (tmpCA.getElement('#MC-Module-Cust-Pick').length === 0) { return; }
		if (!this.pict.AppData.ManageCustomerPickers) { this.pict.AppData.ManageCustomerPickers = {}; }
		const tmpInstance = tmpPicker.createPicker('ManageCustomers-ModuleCustomer',
			{
				DestinationAddress: '#MC-Module-Cust-Pick',
				ValueAddress: 'AppData.ManageCustomerPickers.ModuleCustomer',
				Searchable: true,
				AllowClear: true,
				ClearLabel: '— choose a customer —',
				Placeholder: 'Search customers by name or code…',
				DataProvider: this._moduleCustomerDataProvider(),
				ResolveValue: this._moduleCustomerResolveValue(),
				OnChange: (pValue) => this.selectModuleCustomer(Number(pValue) || 0),
			});
		if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
		if (tmpInstance && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(Number(this.state.ModulesCustomerID) || ''); }
	}

	_moduleResultsHTML()
	{
		if (!this.state.ModulesCustomerID) { return '<div class="mc-note">Choose a customer to manage its modules.</div>'; }
		if (this.state.ModulesLoading) { return '<div class="mc-note"><i class="fas fa-spinner fa-spin"></i> Loading modules…</div>'; }
		if (this.state.ModulesError) { return `<div class="mc-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.ModulesError)}</div>`; }
		return `<input id="MC-ModuleFilter" class="mc-filter" type="text" autocomplete="off" placeholder="Filter modules by name…" value="${this._esc(this.state.ModulesFilter)}" oninput="_Pict.providers.ManageCustomers.onModuleFilter(this.value)" />`
			+ `<div id="MC-ModuleList" class="mc-list">${this._moduleListHTML()}</div>`;
	}

	_moduleListHTML()
	{
		const tmpTerm = String(this.state.ModulesFilter || '').trim().toLowerCase();
		const tmpRows = this.state.ModulesCatalog.filter((pModule) =>
			!tmpTerm || (String(pModule.Name).toLowerCase().indexOf(tmpTerm) > -1) || (String(pModule.ModuleHash).toLowerCase().indexOf(tmpTerm) > -1));
		if (!tmpRows.length) { return `<div class="mc-note">${tmpTerm ? 'No modules match your filter.' : 'No modules in the catalog.'}</div>`; }
		return tmpRows.map((pModule) =>
		{
			const tmpOn = this._isModuleEnabled(pModule.ModuleHash);
			const tmpAppTag = pModule.App ? ' <span class="mc-app-tag">Desktop app</span>' : '';
			const tmpBadge = tmpOn ? ' <span class="mc-team-badge">Enabled</span>' : '';
			const tmpBusy = (this.state.ModulesBusyHash === pModule.ModuleHash);
			let tmpButton;
			if (tmpBusy) { tmpButton = '<button type="button" class="mc-btn" disabled><i class="fas fa-spinner fa-spin"></i></button>'; }
			else if (tmpOn) { tmpButton = `<button type="button" class="mc-btn mc-btn-remove" onclick="_Pict.providers.ManageCustomers.disableModule('${this._esc(pModule.ModuleHash)}')"><i class="fas fa-toggle-on"></i> Disable</button>`; }
			else { tmpButton = `<button type="button" class="mc-btn" onclick="_Pict.providers.ManageCustomers.enableModule('${this._esc(pModule.ModuleHash)}')"><i class="fas fa-toggle-off"></i> Enable</button>`; }
			return `<div class="mc-row">`
				+ `<span class="mc-col-name">${this._esc(pModule.Name || pModule.ModuleHash)}${tmpAppTag}${tmpBadge}</span>`
				+ `<span class="mc-col-code">${this._esc(pModule.ModuleHash)}</span>`
				+ `<span class="mc-col-action">${tmpButton}</span>`
				+ `</div>`;
		}).join('');
	}

	onModuleFilter(pValue)
	{
		this.state.ModulesFilter = pValue;
		this._renderModuleList();
	}

	selectModuleCustomer(pIDCustomer)
	{
		this.state.ModulesCustomerID = Number(pIDCustomer) || 0;
		this.state.ModulesFilter = '';
		if (this.state.ModulesCustomerID) { this._loadModuleDataAsync(); }
		else { this._renderModuleResults(); }
	}

	async _loadModuleDataAsync()
	{
		this.state.ModulesLoading = true;
		this.state.ModulesError = '';
		this._renderModuleResults();
		try
		{
			if (!this.state.ModulesCatalog.length)
			{
				const tmpCatalog = await this._getJSON('Modules/0/500');
				const tmpRows = (Array.isArray(tmpCatalog) ? tmpCatalog : [])
					.map((pModule) => ({ ModuleHash: pModule.ModuleHash, Name: pModule.Name || pModule.ModuleHash, Ordinal: Number(pModule.Ordinal) || 0, App: false }))
					.filter((pModule) => !!pModule.ModuleHash);
				// Merge the app's gated downloadable-app modules that aren't already in the platform catalog, so they
				// can be enabled per customer without a catalog row (the join gate is keyed by ModuleHash).
				const tmpHave = {};
				tmpRows.forEach((pModule) => { tmpHave[pModule.ModuleHash] = true; });
				(((libDataDownloaderProvider && libDataDownloaderProvider.DOWNLOAD_MODULES) || [])).forEach((pApp) =>
				{
					if (pApp && pApp.ModuleHash && !tmpHave[pApp.ModuleHash]) { tmpRows.push({ ModuleHash: pApp.ModuleHash, Name: pApp.Name || pApp.ModuleHash, Ordinal: 900, App: true }); }
				});
				this.state.ModulesCatalog = tmpRows.sort((pA, pB) => (pA.Ordinal - pB.Ordinal) || String(pA.Name).localeCompare(String(pB.Name)));
			}
			await this._refreshJoins();
			this.state.ModulesLoading = false;
			this._renderModuleResults();
		}
		catch (pError)
		{
			this.state.ModulesLoading = false;
			this.state.ModulesError = `Could not load modules: ${(pError && pError.message) ? pError.message : pError}`;
			this._renderModuleResults();
		}
	}

	async _refreshJoins()
	{
		const tmpJoins = await this._getJSON(`CustomerModuleJoins/FilteredTo/FBV~IDCustomer~EQ~${this.state.ModulesCustomerID}/0/500`);
		this.state.ModulesJoins = Array.isArray(tmpJoins) ? tmpJoins : [];
	}

	_renderModuleResults()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#MC-ModuleResults').length) { tmpCA.assignContent('#MC-ModuleResults', this._moduleResultsHTML()); }
	}

	_renderModuleList()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#MC-ModuleList').length) { tmpCA.assignContent('#MC-ModuleList', this._moduleListHTML()); }
	}

	async enableModule(pModuleHash)
	{
		if (!this.state.ModulesCustomerID || this.state.ModulesBusyHash) { return; }
		this.state.ModulesBusyHash = pModuleHash;
		this._renderModuleList();
		try
		{
			// Cross-customer create — explicit IDCustomer (a super-user is authorized server-side; see SuperUserGrant).
			const tmpSaved = await this._postJSON('CustomerModuleJoin',
				{ IDCustomer: Number(this.state.ModulesCustomerID), ModuleHash: pModuleHash, IDProgram: 0, StartDate: '2000-01-01T00:00:00.000Z', EndDate: '2050-01-01T00:00:00.000Z' });
			if (tmpSaved && tmpSaved.ErrorCode) { throw new Error('the server rejected the change'); }
			await this._refreshJoins();
			// The server may silently no-op an unauthorized write (empty body, no ErrorCode) — confirm it took.
			if (!this._isModuleEnabled(pModuleHash)) { throw new Error('the change did not take effect (you may not have permission).'); }
			this._toast(`Enabled ${this._moduleName(pModuleHash)} for this customer.`, 'success');
		}
		catch (pError)
		{
			this._toast(`Could not enable the module: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
		this.state.ModulesBusyHash = '';
		this._renderModuleList();
	}

	disableModule(pModuleHash)
	{
		if (!this.state.ModulesCustomerID || this.state.ModulesBusyHash) { return; }
		const tmpJoins = (this.state.ModulesJoins || []).filter((pJoin) => pJoin.ModuleHash === pModuleHash);
		if (!tmpJoins.length) { return; }
		const fGo = async () =>
		{
			this.state.ModulesBusyHash = pModuleHash;
			this._renderModuleList();
			try
			{
				for (const pJoin of tmpJoins) { await this._deleteEntity('CustomerModuleJoin', Number(pJoin.IDCustomerModuleJoin)); }
				await this._refreshJoins();
				if (this._isModuleEnabled(pModuleHash)) { throw new Error('the change did not take effect (you may not have permission).'); }
				this._toast(`Disabled ${this._moduleName(pModuleHash)} for this customer.`, 'success');
			}
			catch (pError)
			{
				this._toast(`Could not disable the module: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			}
			this.state.ModulesBusyHash = '';
			this._renderModuleList();
		};
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(`Disable ${this._moduleName(pModuleHash)} for this customer? This removes their access to the feature.`,
				{ title: 'Disable module', confirmLabel: 'Disable', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fGo(); } });
		}
		else { fGo(); }
	}

	// --- Customer Team: mark internal users as Headlight platform admins -------------------------------

	/** Whether a user is currently a Headlight platform admin (the flat "customer team" marker). */
	_isPlatformAdmin(pUser)
	{
		return (pUser.Classification === 'Headlight_Platform_Admin') && ((Number(pUser.PersistentPassword) === 1) || (pUser.PersistentPassword === true));
	}


	_teamHTML()
	{
		return `<p class="mc-team-help">Search any user, across every customer, and mark them as a <strong>Headlight platform admin</strong> — the internal team who may impersonate a customer&#8217;s configuration admin. This sets the user&#8217;s <code>Classification</code> and <code>PersistentPassword</code>.</p>`
			+ `<input id="MC-TeamSearch" class="mc-filter" type="text" autocomplete="off" placeholder="Search users by name, login ID or email…" value="${this._esc(this.state.TeamSearch)}" oninput="_Pict.providers.ManageCustomers.onTeamSearch(this.value)" />`
			+ `<div id="MC-TeamResults" class="mc-list">${this._teamResultsHTML()}</div>`;
	}

	_teamResultsHTML()
	{
		if (this.state.TeamError) { return `<div class="mc-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.TeamError)}</div>`; }
		if (this.state.TeamSearching) { return '<div class="mc-note"><i class="fas fa-spinner fa-spin"></i> Searching…</div>'; }
		const tmpTerm = String(this.state.TeamSearch || '').trim();
		if (tmpTerm.length < 2) { return '<div class="mc-note">Type at least 2 characters to search users.</div>'; }
		const tmpRows = this.state.TeamResults;
		if (!tmpRows.length) { return '<div class="mc-note">No users match your search.</div>'; }
		return tmpRows.map((pUser) =>
		{
			const tmpIsAdmin = this._isPlatformAdmin(pUser);
			const tmpBadge = tmpIsAdmin ? ' <span class="mc-team-badge">Platform admin</span>' : '';
			const tmpButton = tmpIsAdmin
				? `<button type="button" class="mc-btn mc-btn-remove" onclick="_Pict.providers.ManageCustomers.togglePlatformAdmin(${Number(pUser.IDUser)}, false)"><i class="fas fa-user-minus"></i> Remove from team</button>`
				: `<button type="button" class="mc-btn" onclick="_Pict.providers.ManageCustomers.togglePlatformAdmin(${Number(pUser.IDUser)}, true)"><i class="fas fa-user-plus"></i> Add to team</button>`;
			return `<div class="mc-row">`
				+ `<span class="mc-col-name">${this._esc(libUserSearch.userLabel(pUser))}${tmpBadge}</span>`
				+ `<span class="mc-col-code">${this._esc(pUser.Email || '')}</span>`
				+ `<span class="mc-col-action">${tmpButton}</span>`
				+ `</div>`;
		}).join('');
	}

	/** Debounced cross-customer user search; only the results re-render, so the search input keeps focus. */
	onTeamSearch(pValue)
	{
		this.state.TeamSearch = pValue;
		if (this._teamSearchTimer) { clearTimeout(this._teamSearchTimer); }
		this._teamSearchTimer = setTimeout(() => { this._teamSearchTimer = null; this._teamSearchAsync(); }, 250);
	}

	async _teamSearchAsync()
	{
		const tmpTerm = String(this.state.TeamSearch || '').trim();
		const tmpToken = ++this._teamSearchToken;
		if (tmpTerm.length < 2)
		{
			this.state.TeamResults = [];
			this.state.TeamSearching = false;
			this.state.TeamError = '';
			this._renderTeamResults();
			return;
		}
		this.state.TeamSearching = true;
		this.state.TeamError = '';
		this._renderTeamResults();
		try
		{
			// Cross-customer (no customer clause) — the super-user session may search everyone (like Grant Access).
			const tmpUsers = await libUserSearch.searchUsersAsync((pURL) => this._getJSON(pURL), tmpTerm, { PageSize: 50 });
			if (tmpToken !== this._teamSearchToken)
			{
				return;
			}
			this.state.TeamResults = tmpUsers;
		}
		catch (pError)
		{
			if (tmpToken !== this._teamSearchToken)
			{
				return;
			}
			this.state.TeamResults = [];
			this.state.TeamError = 'Could not search users. Try again.';
		}
		this.state.TeamSearching = false;
		this._renderTeamResults();
	}

	_renderTeamResults()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#MC-TeamResults').length) { tmpCA.assignContent('#MC-TeamResults', this._teamResultsHTML()); }
	}

	/** Add/remove a user from the platform-admin team by setting Classification + PersistentPassword (no IDCustomer sent). */
	togglePlatformAdmin(pIDUser, pOn)
	{
		const tmpUser = (this.state.TeamResults || []).find((pUser) => Number(pUser.IDUser) === Number(pIDUser));
		if (!tmpUser) { return; }
		const tmpPayload = { IDUser: Number(pIDUser), Classification: pOn ? 'Headlight_Platform_Admin' : '', PersistentPassword: pOn ? 1 : 0 };
		this._putJSON('User', tmpPayload).then((pSaved) =>
		{
			if (!pSaved || pSaved.ErrorCode)
			{
				this._toast('Could not update the user (you may not have permission to edit this customer’s users).', 'error');
				return;
			}
			tmpUser.Classification = tmpPayload.Classification;
			tmpUser.PersistentPassword = tmpPayload.PersistentPassword;
			this._toast(pOn ? `Added ${libUserSearch.userLabel(tmpUser)} to the platform-admin team.` : `Removed ${libUserSearch.userLabel(tmpUser)} from the platform-admin team.`, 'success');
			this._renderTeamResults();
		}).catch((pError) =>
		{
			this._toast(`Could not update the user: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		});
	}

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
}

ManageCustomersProvider.default_configuration = { ProviderIdentifier: 'ManageCustomers' };

module.exports = ManageCustomersProvider;
module.exports.default_configuration = ManageCustomersProvider.default_configuration;

},{"../access/User-Search.js":1064,"./DataDownloader-Provider.js":1330,"pict-provider":845}],1351:[function(require,module,exports){

const libPictProvider = require('pict-provider');

const libMasterListCatalog = require('../master-lists/Headlight-MasterLists.js');
const libMasterListBuilder = require('../master-lists/MasterList-Builder.js');
const libMasterListCategories = require('../master-lists/MasterList-Categories.js');
const libMasterListAssociations = require('../master-lists/MasterList-Associations.js');
const libConnectionsGenerated = require('../master-lists/Connections.generated.js');
const libNavigationGraph = require('../navigation-graph.js');

// NamespaceKey under which each master list's configuration lives in the cascading Headlight
// Configuration service. ONE NamespaceValue per entity (Material, PayItem, …) — never a shared
// blob — so a Customer/User override of one list cannot suppress the others (the service diffs
// each Put against the level above and hides parent keys absent from the payload; see api/config).
// Per-entity config object: { Enabled, Label, Domain, Icon, SearchFields, Columns, ReadTabs,
// ReadLayout, BulkAssociations, MatrixAssociations, UnlinkAssociations }.
const CATALOG_NAMESPACE = 'MasterListCatalog';

// Write scopes this tool exposes. Global = the platform default (super-user only); Customer = a
// customer-wide override (CustomerAdmin); User = a personal override (anyone). Project still
// cascades on read but is not authored here — this app has no project context.
const SCOPE_LEVELS = [ 'Global', 'Customer', 'User' ];
const SCOPE_LABELS = { Global: 'Platform Default', Customer: 'Customer', User: 'My Settings' };

// Config fields the tool persists. Everything else (Keywords / Description) stays code-seed
// metadata. Arrays are written whole (the Configuration service replaces arrays wholesale).
const PERSISTED_SCALARS = [ 'Enabled', 'Label', 'Domain', 'Icon', 'ReadLayout' ];
const PERSISTED_ARRAYS = [ 'SearchFields', 'Columns', 'ReadTabs', 'BulkAssociations', 'MatrixAssociations', 'UnlinkAssociations', 'ChildLists' ];

// The four association VIEW surfaces, in priority order (used to seed the editor + serialize back).
const ASSOCIATION_VIEW_FIELDS =
[
	{ Kind: 'readtab', Field: 'ReadTabs' },
	{ Kind: 'bulk', Field: 'BulkAssociations' },
	{ Kind: 'matrix', Field: 'MatrixAssociations' },
	{ Kind: 'unlink', Field: 'UnlinkAssociations' }
];

// Columns that are bookkeeping / system fields — hidden by default when a list has no
// curated column set yet, so an auto-generated list leads with real data, not GUIDs.
const SYSTEM_COLUMN = /^(ID[A-Z]|GUID|CreateDate$|CreatingIDUser$|UpdateDate$|UpdatingIDUser$|Deleted$|DeleteDate$|DeletingIDUser$|ExternalSyncDate$|ExternalSync)/;

/**
 * MasterListRegistry — the data layer behind the master-list configuration tool.
 *
 * Holds the merged catalog (static code seed ⊕ cascading Configuration-service overrides), lets
 * an admin add / remove / recategorize / curate lists and choose how each list surfaces its
 * associations (read tab / bulk / matrix / unlink), discovers columns from an entity's Meadow
 * /Schema, applies a config to the live pict-section-recordset registration, rebuilds the Master
 * Lists navigation tree, and persists each list as a per-entity Configuration entry at the chosen
 * scope (Global / Customer / User). The Configuration service merges the layers server-side
 * (Global → Customer → Project → User), so choices cascade — no code change, no redeploy.
 */
class MasterListRegistryProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// The static code seed, keyed by entity — the always-present baseline the cascading config
		// layers on top of (so the app works even with empty config).
		this._seedByEntity = {};
		libMasterListCatalog.forEach((pEntry) =>
		{
			if (pEntry && pEntry.Entity)
			{
				this._seedByEntity[pEntry.Entity] = pEntry;
			}
		});

		// Merged catalog keyed by entity name. Seeded from the static catalog; cascading config
		// overrides are layered on at load (loadCascadedConfigAsync).
		this.entries = {};
		this._resetEntriesToSeed();

		// Cache of discovered schema columns per entity.
		this.schemaColumns = {};

		// The working editor model for the currently-open list (null when none selected).
		this._editor = null;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get recordSetService()
	{
		return this.pict.services.PictSectionRecordSet;
	}

	// --- Session context + write-permission (mirrors the server's config gate) ---

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	get idUser()
	{
		return this.currentUser.UserID;
	}

	/**
	 * A customer-1 / role-5 super-user can write the Global platform default
	 * (the server's EndpointBase._isSuperUser).
	 * @return {Boolean}
	 */
	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	/**
	 * A user holding a role with PermissionLevel 'CustomerAdmin' can write Customer-scope config
	 * (the server's EndpointBase._hasCustomerScopedConfigWriteAccess). UserRoles is an array of
	 * role objects at runtime (the in-repo typedef saying string[] is stale).
	 * @return {Boolean}
	 */
	get hasCustomerAdmin()
	{
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin'));
	}

	/**
	 * Can the current user WRITE config at this scope? UI gate only — the server is authoritative
	 * and returns 403 if this is wrong.
	 * @param {String} pLevel - 'Global' | 'Customer' | 'User'
	 * @return {Boolean}
	 */
	canWriteScope(pLevel)
	{
		switch (pLevel)
		{
			case 'Global': return this.isSuperUser;
			case 'Customer': return this.isSuperUser || this.hasCustomerAdmin;
			case 'User': return true;
			default: return false;
		}
	}

	/**
	 * The default scope a user lands on: Platform for super-users (their job is the platform
	 * default), Customer for customer admins, else their personal settings.
	 * @return {String}
	 */
	get defaultScope()
	{
		if (this.isSuperUser) { return 'Global'; }
		if (this.hasCustomerAdmin) { return 'Customer'; }
		return 'User';
	}

	_levelIdFor(pLevel)
	{
		if (pLevel === 'Global') { return 0; }
		if (pLevel === 'User') { return this.idUser; }
		return this.idCustomer;
	}

	_scopeLabel(pLevel)
	{
		return SCOPE_LABELS[pLevel] || pLevel;
	}

	// --- REST helpers (promise wrappers over the Headlight rest client) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	// --- Cascading Configuration service (read + scoped write) ---

	/**
	 * Read an entire Configuration namespace, cascaded server-side from Global up to the current
	 * user (Global → Customer → Project → User, User-wins). Omitting NamespaceValue returns every
	 * value in one round-trip, grouped: { <NamespaceValue>: <mergedConfig>, … }.
	 * @param {String} pNamespaceKey
	 * @return {Promise<Object>}
	 */
	async _getCascadedNamespace(pNamespaceKey)
	{
		const tmpPayload = { LevelContext: 'User', LevelContextID: this.idUser, NamespaceKey: pNamespaceKey };
		const tmpResult = await this._postJSON('Configuration/Get', tmpPayload);
		return (tmpResult && (tmpResult.Document || tmpResult)) || {};
	}

	/**
	 * Write one NamespaceValue's config at a scope. SubKey IS the NamespaceValue; the service
	 * flattens the object to one row per leaf and diffs against the level above.
	 * @return {Promise<Object>}
	 */
	_putConfigSubKey(pNamespaceKey, pSubKey, pLevel, pLevelID, pConfig)
	{
		const tmpURL = `Configuration/Put/${pNamespaceKey}/${pSubKey}/${pLevel}/${pLevelID}`;
		return this._postJSON(tmpURL, { Config: pConfig });
	}

	// --- Catalog access ---

	/**
	 * The merged catalog as an array, in the static seed order with any config-only lists appended.
	 * @return {Array<Object>}
	 */
	getEntries()
	{
		const tmpSeedOrder = libMasterListCatalog.map((pEntry) => pEntry.Entity);
		const tmpKeys = Object.keys(this.entries).sort((pA, pB) =>
		{
			const tmpIA = tmpSeedOrder.indexOf(pA);
			const tmpIB = tmpSeedOrder.indexOf(pB);
			return (tmpIA < 0 ? 999 : tmpIA) - (tmpIB < 0 ? 999 : tmpIB);
		});
		return tmpKeys.map((pKey) => this.entries[pKey]);
	}

	/**
	 * Only the lists an admin has left enabled (a removed list is Enabled === false).
	 * @return {Array<Object>}
	 */
	getEnabledEntries()
	{
		return this.getEntries().filter((pEntry) => pEntry.Enabled !== false);
	}

	getEntry(pEntity)
	{
		return this.entries[pEntity];
	}

	/**
	 * Candidate entities that can be added as a list (not currently enabled, so removed
	 * ones can be re-added too).
	 * @return {Array<Object>}
	 */
	getAvailableCandidates()
	{
		return libMasterListCategories.CANDIDATES.filter((pCandidate) =>
		{
			const tmpEntry = this.entries[pCandidate.Entity];
			return !tmpEntry || (tmpEntry.Enabled === false);
		});
	}

	// --- Client merge (code seed ⊕ cascaded config; matches server: arrays replace) ---

	_isPlainObject(pValue)
	{
		return (pValue !== null) && (typeof pValue === 'object') && !Array.isArray(pValue);
	}

	/**
	 * Deep-merge `pOver` onto `pBase`: nested plain objects merge recursively; arrays and scalars
	 * from `pOver` replace `pBase` wholesale (the Configuration service treats arrays as atomic
	 * leaves, so the client must match). Returns a new object; inputs are not mutated.
	 * @param {Object} pBase
	 * @param {Object} pOver
	 * @return {Object}
	 */
	_deepMergeReplaceArrays(pBase, pOver)
	{
		if (!this._isPlainObject(pOver))
		{
			return this._isPlainObject(pBase) ? Object.assign({}, pBase) : pOver;
		}
		const tmpResult = Object.assign({}, this._isPlainObject(pBase) ? pBase : {});
		Object.keys(pOver).forEach((pKey) =>
		{
			const tmpOverValue = pOver[pKey];
			const tmpBaseValue = tmpResult[pKey];
			tmpResult[pKey] = (this._isPlainObject(tmpOverValue) && this._isPlainObject(tmpBaseValue))
				? this._deepMergeReplaceArrays(tmpBaseValue, tmpOverValue)
				: tmpOverValue;
		});
		return tmpResult;
	}

	/**
	 * Merge a cascaded config object over a code-seed entry (the effective entry the app uses).
	 * @param {Object} pSeedEntry
	 * @param {Object} pConfigEntry
	 * @return {Object}
	 */
	_mergeConfigEntry(pSeedEntry, pConfigEntry)
	{
		const tmpMerged = this._deepMergeReplaceArrays(pSeedEntry || {}, pConfigEntry || {});
		if (pSeedEntry && pSeedEntry.Entity) { tmpMerged.Entity = pSeedEntry.Entity; }
		return tmpMerged;
	}

	_resetEntriesToSeed()
	{
		this.entries = {};
		Object.keys(this._seedByEntity).forEach((pEntity) =>
		{
			this.entries[pEntity] = Object.assign({}, this._seedByEntity[pEntity]);
		});
	}

	// --- Schema discovery ---

	/**
	 * Discover the column names of an entity from its Meadow /Schema endpoint (cached).
	 * @param {String} pEntity
	 * @return {Promise<Array<String>>}
	 */
	async getSchemaColumnsAsync(pEntity)
	{
		if (this.schemaColumns[pEntity])
		{
			return this.schemaColumns[pEntity];
		}
		const tmpSchema = await this._getJSON(`${pEntity}/Schema`);
		const tmpColumns = (tmpSchema && tmpSchema.properties) ? Object.keys(tmpSchema.properties) : [];
		this.schemaColumns[pEntity] = tmpColumns;
		return tmpColumns;
	}

	// --- Cascading config load + scoped persistence ---

	/**
	 * Load the cascading catalog config (one Get for the whole MasterListCatalog namespace, merged
	 * Global → Customer → User server-side) and layer it over the static code seed.
	 * @return {Promise<void>}
	 */
	async loadCascadedConfigAsync()
	{
		this._resetEntriesToSeed();

		let tmpCatalogConfig = {};
		try
		{
			tmpCatalogConfig = await this._getCascadedNamespace(CATALOG_NAMESPACE);
		}
		catch (pError)
		{
			this.log.warn(`MasterListRegistry: catalog config read failed (using code seed only): ${pError.message || pError}`);
			tmpCatalogConfig = {};
		}

		Object.keys(tmpCatalogConfig || {}).forEach((pEntity) =>
		{
			if (!pEntity || !this._isPlainObject(tmpCatalogConfig[pEntity]))
			{
				return;
			}
			const tmpSeed = this._seedByEntity[pEntity] || { Entity: pEntity };
			this.entries[pEntity] = this._mergeConfigEntry(tmpSeed, Object.assign({ Entity: pEntity }, tmpCatalogConfig[pEntity]));
		});

		await this._overlayCustomerManifestsAsync(tmpCatalogConfig || {});
	}

	/**
	 * Layer the customer's List manifests (CustomerRecordManifests) between the Global and Customer levels.
	 * @param {Object} pCatalogConfig - the merged MasterListCatalog namespace
	 * @return {Promise<void>}
	 */
	async _overlayCustomerManifestsAsync(pCatalogConfig)
	{
		const tmpManifests = this.pict.providers.CustomerRecordManifests;
		if (!tmpManifests)
		{
			return;
		}
		try
		{
			await tmpManifests.overlayMasterListEntriesAsync(this.entries, pCatalogConfig, this._seedByEntity);
		}
		catch (pError)
		{
			this.log.warn(`MasterListRegistry: customer list manifests not applied: ${pError.message || pError}`);
		}
	}

	/**
	 * Reduce a catalog entry to the config object persisted in the Configuration service.
	 * @param {Object} pEntry
	 * @return {Object}
	 */
	_toCatalogConfig(pEntry)
	{
		const tmpConfig = {};
		PERSISTED_SCALARS.forEach((pKey) =>
		{
			if (pEntry[pKey] !== undefined) { tmpConfig[pKey] = pEntry[pKey]; }
		});
		PERSISTED_ARRAYS.forEach((pKey) =>
		{
			if (Array.isArray(pEntry[pKey])) { tmpConfig[pKey] = pEntry[pKey]; }
		});
		return tmpConfig;
	}

	/**
	 * Persist a catalog entry at a scope (Global / Customer / User), then re-read the cascaded
	 * config so local state reflects the server's diffing + cascade truthfully, and re-apply
	 * everything to the live recordset configs + nav.
	 * @param {Object} pEntry - the (partial) entry to save; merged over the current entry.
	 * @param {String} [pScopeLevel] - 'Global' | 'Customer' | 'User'
	 * @return {Promise<Object>} the merged entry after re-read.
	 */
	async saveEntryAsync(pEntry, pScopeLevel)
	{
		pScopeLevel = pScopeLevel || this.editorState.ScopeLevel || this.defaultScope;
		if (!this.canWriteScope(pScopeLevel))
		{
			throw new Error(`You do not have permission to save at the ${this._scopeLabel(pScopeLevel)} level.`);
		}

		// Persist the FULL effective entry (whole arrays — the service replaces arrays wholesale).
		const tmpEntry = Object.assign({}, this.entries[pEntry.Entity], pEntry);
		this.entries[pEntry.Entity] = tmpEntry;

		await this._putConfigSubKey(CATALOG_NAMESPACE, pEntry.Entity, pScopeLevel, this._levelIdFor(pScopeLevel), this._toCatalogConfig(tmpEntry));

		// Re-Get (no client cache): the server may have dropped leaves equal to the parent level.
		await this.loadCascadedConfigAsync();
		this.applyAllToLive();
		return this.entries[pEntry.Entity];
	}

	// --- Live application to pict-section-recordset + navigation ---

	/**
	 * Apply a catalog entry's curation (columns / search / title) and its association-view choices
	 * (read tabs / bulk screens) to the live recordset registration so the list reflects it without
	 * a reload. Registers the recordset dynamically if it is not already known.
	 * @param {Object} pEntry
	 */
	applyEntryToLiveConfig(pEntry)
	{
		const tmpService = this.recordSetService;
		if (!tmpService)
		{
			return;
		}
		let tmpConfig = tmpService.recordSetProviderConfigurations[pEntry.Entity];
		if (!tmpConfig)
		{
			const tmpBuilt = libMasterListBuilder.buildRecordSetConfiguration(pEntry);
			tmpService.loadRecordSetDynamically(tmpBuilt, pEntry.Entity);
			tmpConfig = tmpService.recordSetProviderConfigurations[pEntry.Entity] || tmpBuilt;
		}

		// Permission-expression layer (Phase 2): gate the list "New" button by the current user's create right
		// (ImprovedTabularRecordSetProvider's title template reads this flag). Covers the runtime master-list
		// rebuild path, mirroring the app's onAfterLogin stamp.
		const tmpEffectivePermissions = this.pict.fable.EffectivePermissionsService;
		if (tmpEffectivePermissions && (tmpConfig.RecordSetListShowCreateButton !== false))
		{
			tmpConfig.RecordSetListShowCreateButton = tmpEffectivePermissions.can(pEntry.Entity, 'Create');
		}

		if (Array.isArray(pEntry.Columns) && (pEntry.Columns.length > 0))
		{
			tmpConfig.RecordSetListColumns = libMasterListBuilder.markForeignKeyColumnsUnsortable(pEntry.Columns.map((pColumn) =>
				(typeof pColumn === 'string') ? { Key: pColumn, DisplayName: pColumn } : Object.assign({}, pColumn)), pEntry);
		}
		if (Array.isArray(pEntry.SearchFields) && (pEntry.SearchFields.length > 0))
		{
			tmpConfig.SearchFields = pEntry.SearchFields.slice();
		}
		if (pEntry.Label)
		{
			tmpConfig.Title = pEntry.Label;
		}

		// Association views are now cascading data (not code), so push them into the live config —
		// the recordset configs were built from the seed at construction time, before config loads.
		try
		{
			if (typeof libMasterListBuilder.applyAssociationViewsToConfig === 'function')
			{
				libMasterListBuilder.applyAssociationViewsToConfig(tmpConfig, pEntry);
			}
		}
		catch (pError)
		{
			this.log.warn(`MasterListRegistry: association-view apply failed for ${pEntry.Entity}: ${pError.message || pError}`);
		}
	}

	/**
	 * Make sure pict-section-recordset's routes cover any newly (dynamically) registered
	 * recordsets so #/PSRS/<Entity>/List resolves.
	 */
	_ensureRoutes()
	{
		try
		{
			const tmpRouter = this.pict.providers.RecordSetRouter;
			if (tmpRouter && tmpRouter.pictRouter)
			{
				tmpRouter.addRoutes(tmpRouter.pictRouter);
			}
		}
		catch (pError)
		{
			this.log.warn(`MasterListRegistry: addRoutes failed: ${pError.message || pError}`);
		}
	}

	/**
	 * Rebuild the Master Lists navigation tree (categorized) from the enabled lists and push it
	 * into the live navigation, then repaint.
	 */
	rebuildNav()
	{
		try
		{
			const tmpNav = this.pict.providers['Pict-Navigation'];
			if (!tmpNav || typeof tmpNav.setNavigationGraph !== 'function')
			{
				return;
			}
			const tmpReferenceSections = libMasterListBuilder.buildCategorizedSections(this.getEnabledEntries(), libMasterListCategories.CATEGORIES);
			const tmpGraph = (typeof libNavigationGraph.composeGraph === 'function')
				? libNavigationGraph.composeGraph(tmpReferenceSections)
				: tmpReferenceSections;
			tmpNav.setNavigationGraph(tmpGraph);
			this._repaintNav();
		}
		catch (pError)
		{
			this.log.error(`MasterListRegistry: rebuildNav failed: ${pError.message || pError}`);
		}
	}

	_repaintNav()
	{
		try
		{
			const tmpApp = this.pict.PictApplication;
			const tmpStyle = this.pict.AppData.NavRenderType
				|| (typeof window !== 'undefined' && window.localStorage && window.localStorage.getItem('headlight-platform-config-nav-render-type'))
				|| 'List';
			if (tmpApp && typeof tmpApp.applyNavigationStyle === 'function')
			{
				tmpApp.applyNavigationStyle(tmpStyle);
			}
		}
		catch (pError)
		{
			// Nav repaint is best-effort; the next nav render reads the graph live regardless.
		}
	}

	/**
	 * Apply every enabled list to its live recordset config, ensure routes, and rebuild the nav.
	 */
	applyAllToLive()
	{
		this.getEnabledEntries().forEach((pEntry) =>
		{
			try
			{
				this.applyEntryToLiveConfig(pEntry);
			}
			catch (pError)
			{
				this.log.error(`MasterListRegistry: apply failed for ${pEntry.Entity}: ${pError.message || pError}`);
			}
		});
		this._ensureRoutes();
		this.rebuildNav();
	}

	/**
	 * Boot hook: load the cascaded config, apply every enabled list to its live recordset config,
	 * ensure routes exist for dynamically-registered lists, and rebuild the nav. Called from the
	 * application's onAfterLoginAsync.
	 * @return {Promise<void>}
	 */
	async loadAndApplyAllAsync()
	{
		await this.loadCascadedConfigAsync();
		this.applyAllToLive();
		const tmpManifests = this.pict.providers.CustomerRecordManifests;
		if (tmpManifests)
		{
			try
			{
				await tmpManifests.applyFilterOverlaysAsync();
			}
			catch (pError)
			{
				this.log.warn(`MasterListRegistry: customer filter manifests not applied: ${pError.message || pError}`);
			}
		}
	}

	// --- Add / remove / categorize ---

	/**
	 * Add an entity as a managed list: discover its columns, default to a sensible
	 * (system-hidden) column set, register it, persist at the current scope, route it, rebuild the
	 * nav, then open it for editing.
	 * @param {String} pEntity
	 * @param {String} [pDomain]
	 * @return {Promise<void>}
	 */
	async addList(pEntity, pDomain)
	{
		pEntity = (pEntity || '').trim();
		const tmpState = this.editorState;
		if (!pEntity)
		{
			return;
		}

		let tmpColumns = [];
		try
		{
			tmpColumns = await this.getSchemaColumnsAsync(pEntity);
		}
		catch (pError)
		{
			tmpState.Message = `Could not add “${pEntity}” — no schema found (${pError.message || pError}).`;
			tmpState.MessageClass = 'is-danger';
			this._render();
			return;
		}

		const tmpCandidate = libMasterListCategories.CANDIDATES.find((pCandidate) => pCandidate.Entity === pEntity);
		const tmpEntry =
		{
			Entity: pEntity,
			Label: (this.entries[pEntity] && this.entries[pEntity].Label) || (tmpCandidate && tmpCandidate.Label) || pEntity,
			Domain: pDomain || (tmpCandidate && tmpCandidate.Domain) || 'Uncategorized',
			Icon: (tmpCandidate && tmpCandidate.Icon) || 'fas fa-list',
			Enabled: true,
			Columns: tmpColumns.filter((pKey) => !SYSTEM_COLUMN.test(pKey)).map((pKey) => ({ Key: pKey, DisplayName: pKey })),
			SearchFields: (tmpColumns.indexOf('Name') >= 0) ? [ 'Name' ] : []
		};

		// Optimistic: register + apply now so the session reflects it instantly, then persist.
		this.applyEntryToLiveConfig(tmpEntry);
		this._ensureRoutes();
		try
		{
			await this.saveEntryAsync(tmpEntry, tmpState.ScopeLevel);
			tmpState.Message = `Added “${tmpEntry.Label}” at the ${this._scopeLabel(tmpState.ScopeLevel)} level.`;
			tmpState.MessageClass = 'is-success';
		}
		catch (pError)
		{
			tmpState.Message = `Added “${pEntity}” to this session, but saving failed: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-warning';
		}
		tmpState.AddOpen = false;
		tmpState.AddEntity = '';
		this.rebuildNav();
		await this.selectList(pEntity);
	}

	addFromCandidate(pEntity)
	{
		const tmpCandidate = libMasterListCategories.CANDIDATES.find((pCandidate) => pCandidate.Entity === pEntity);
		this.addList(pEntity, tmpCandidate ? tmpCandidate.Domain : this.editorState.AddDomain);
	}

	addFromForm()
	{
		const tmpState = this.editorState;
		this.addList((tmpState.AddEntity || '').trim(), tmpState.AddDomain);
	}

	/**
	 * Remove a list (after a modal confirm): persist Enabled === false at the current scope, drop
	 * it from the editor + nav. The PSRS registration is left in place (the framework has no
	 * unregister), but nothing points at it.
	 * @param {String} pEntity
	 */
	removeList(pEntity)
	{
		const tmpEntry = this.getEntry(pEntity) || { Entity: pEntity, Label: pEntity };
		const tmpApply = async () =>
		{
			const tmpState = this.editorState;
			try
			{
				await this.saveEntryAsync(Object.assign({}, tmpEntry, { Entity: pEntity, Enabled: false }), tmpState.ScopeLevel);
				if (this._editor && (this._editor.entity === pEntity))
				{
					this._editor = null;
				}
				tmpState.Message = `Removed “${tmpEntry.Label || pEntity}” at the ${this._scopeLabel(tmpState.ScopeLevel)} level. Add it back any time.`;
				tmpState.MessageClass = 'is-info';
			}
			catch (pError)
			{
				tmpState.Message = `Could not remove “${tmpEntry.Label || pEntity}”: ${pError.message || pError}`;
				tmpState.MessageClass = 'is-danger';
			}
			this._render();
		};

		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && (typeof tmpModal.confirm === 'function'))
		{
			tmpModal.confirm(`Remove “${tmpEntry.Label || pEntity}” from the managed lists? You can add it back later.`,
				{ title: 'Remove list', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { tmpApply(); } });
		}
		else
		{
			tmpApply();
		}
	}

	/**
	 * Recategorize a list at the current scope and repaint the nav grouping.
	 * @param {String} pEntity
	 * @param {String} pDomain
	 * @return {Promise<void>}
	 */
	async setDomain(pEntity, pDomain)
	{
		const tmpEntry = Object.assign({}, this.getEntry(pEntity), { Entity: pEntity, Domain: pDomain });
		if (this._editor && (this._editor.entity === pEntity))
		{
			this._editor.domain = pDomain;
		}
		try
		{
			await this.saveEntryAsync(tmpEntry, this.editorState.ScopeLevel);
		}
		catch (pError)
		{
			this.editorState.Message = `Could not save the category: ${pError.message || pError}`;
			this.editorState.MessageClass = 'is-danger';
		}
		this._render();
	}

	// --- Association-view model helpers ---

	/**
	 * The associations a given entity participates in (it is one of the two sides), with the other
	 * side's label, from the code association registry.
	 * @param {String} pEntity
	 * @return {Array<{ Hash: String, OtherLabel: String }>}
	 */
	_associationsForEntity(pEntity)
	{
		const tmpRegistry = libMasterListAssociations.ASSOCIATIONS || {};
		const tmpList = [];
		Object.keys(tmpRegistry).forEach((pHash) =>
		{
			const tmpAssoc = tmpRegistry[pHash] || {};
			const tmpSideA = tmpAssoc.SideA || {};
			const tmpSideB = tmpAssoc.SideB || {};
			let tmpOther = null;
			if (tmpSideA.RecordSet === pEntity) { tmpOther = tmpSideB.RecordSet; }
			else if (tmpSideB.RecordSet === pEntity) { tmpOther = tmpSideA.RecordSet; }
			else { return; }
			tmpList.push({ Hash: pHash, OtherLabel: tmpOther || pHash });
		});
		return tmpList;
	}

	/**
	 * Read an entry's current view state for one association into the editor model: which view
	 * surfaces are on (a single association may appear in several) and a representative title.
	 * @param {Object} pEntry
	 * @param {String} pHash
	 * @param {String} pOtherLabel
	 * @return {Object}
	 */
	_readAssociationModel(pEntry, pHash, pOtherLabel)
	{
		const tmpModel = { readtab: false, bulk: false, matrix: false, unlink: false, title: '' };
		ASSOCIATION_VIEW_FIELDS.forEach((pView) =>
		{
			const tmpArray = Array.isArray(pEntry[pView.Field]) ? pEntry[pView.Field] : [];
			const tmpRecord = tmpArray.find((pItem) => pItem && (pItem.Association === pHash));
			if (tmpRecord)
			{
				tmpModel[pView.Kind] = true;
				if (!tmpModel.title && tmpRecord.Title) { tmpModel.title = tmpRecord.Title; }
			}
		});
		if (!tmpModel.title) { tmpModel.title = pOtherLabel || pHash; }
		return tmpModel;
	}

	/**
	 * Serialize the editor's association model back into the four view arrays on an entry.
	 * @param {Object} pEntry - mutated in place with ReadTabs/Bulk/Matrix/Unlink/ReadLayout.
	 */
	_writeAssociationModel(pEntry)
	{
		const tmpArrays = { readtab: [], bulk: [], matrix: [], unlink: [] };
		this._associationsForEntity(this._editor.entity).forEach((pAssoc) =>
		{
			const tmpModel = (this._editor.associations && this._editor.associations[pAssoc.Hash]) || {};
			const tmpTitle = (tmpModel.title || '').trim() || pAssoc.OtherLabel || pAssoc.Hash;
			ASSOCIATION_VIEW_FIELDS.forEach((pView) =>
			{
				if (tmpModel[pView.Kind])
				{
					tmpArrays[pView.Kind].push({ Association: pAssoc.Hash, Title: tmpTitle });
				}
			});
		});
		pEntry.ReadTabs = tmpArrays.readtab;
		pEntry.BulkAssociations = tmpArrays.bulk;
		pEntry.MatrixAssociations = tmpArrays.matrix;
		pEntry.UnlinkAssociations = tmpArrays.unlink;
		pEntry.ReadLayout = this._editor.readLayout || 'Split';
	}

	// --- Child-list (1:N FK) model helpers ---

	/**
	 * The FK child lists an entity can surface, from the generated connection graph. Each is keyed by
	 * RecordSet:FilterField (unique even when two foreign keys point at the same child entity).
	 * @param {String} pEntity
	 * @return {Array<{ Key, RecordSet, FilterField, DefaultTitle }>}
	 */
	_childListsForEntity(pEntity)
	{
		const tmpConnections = (libConnectionsGenerated.EntityConnections || {})[pEntity] || {};
		return (Array.isArray(tmpConnections.ChildLists) ? tmpConnections.ChildLists : []).map((pChild) =>
			({ Key: `${ pChild.RecordSet }:${ pChild.FilterField }`, RecordSet: pChild.RecordSet, FilterField: pChild.FilterField, DefaultTitle: pChild.Title }));
	}

	/**
	 * Read an entry's child-list choices into the editor model (which are on + their titles). An entry
	 * with NO ChildLists array is unconfigured → default every available child list on (the seed default).
	 * @param {Object} pEntry
	 * @param {String} pEntity
	 * @return {Object} keyed by RecordSet:FilterField → { on, title }
	 */
	_readChildListModel(pEntry, pEntity)
	{
		const tmpAvailable = this._childListsForEntity(pEntity);
		const tmpHasArray = Array.isArray(pEntry.ChildLists);
		const tmpByKey = {};
		if (tmpHasArray)
		{
			pEntry.ChildLists.forEach((pItem) =>
			{
				if (pItem && pItem.RecordSet) { tmpByKey[`${ pItem.RecordSet }:${ pItem.FilterField }`] = pItem; }
			});
		}
		const tmpModel = {};
		tmpAvailable.forEach((pChild) =>
		{
			const tmpItem = tmpByKey[pChild.Key];
			tmpModel[pChild.Key] = { on: tmpHasArray ? !!tmpItem : true, title: (tmpItem && tmpItem.Title) || pChild.DefaultTitle };
		});
		return tmpModel;
	}

	/**
	 * Serialize the editor's child-list model back onto an entry (only the on ones, minimal shape — the
	 * ChildListTab view instances carry the display columns; the builder needs just RecordSet/FilterField/Title).
	 * @param {Object} pEntry - mutated in place with ChildLists.
	 */
	_writeChildListModel(pEntry)
	{
		const tmpChildLists = [];
		this._childListsForEntity(this._editor.entity).forEach((pChild) =>
		{
			const tmpModel = (this._editor.childLists && this._editor.childLists[pChild.Key]) || {};
			if (tmpModel.on)
			{
				tmpChildLists.push({ RecordSet: pChild.RecordSet, FilterField: pChild.FilterField, Title: (tmpModel.title || '').trim() || pChild.DefaultTitle });
			}
		});
		pEntry.ChildLists = tmpChildLists;
	}

	// --- Editor state (drives the MasterListManager view via AppData) ---

	get editorState()
	{
		if (!this.pict.AppData.MasterListManager)
		{
			this.pict.AppData.MasterListManager =
			{
				RailGroups: [], SelectedEntity: null, SelectedLabel: '', Title: '',
				Columns: [], Loading: false, Saving: false, Message: '', MessageClass: '',
				EditorSlot: [], EmptySlot: [ {} ], LoadingSlot: [], MessageSlot: [],
				AddOpen: false, AddOpenSlot: [], AddEntity: '', AddDomain: '',
				CandidateGroups: [], AddCategoryOptions: [], EditorCategoryOptions: [],
				ScopeLevel: '', ScopeOptions: [], ScopeHint: '', ScopeHintSlot: [], CanWriteCurrentScope: true,
				Associations: [], AssociationSlot: [], ReadLayoutOptions: [], ReadLayoutSlot: [], ShowReadLayout: false
			};
		}
		return this.pict.AppData.MasterListManager;
	}

	_sortByCategory(pNames)
	{
		const tmpKnown = libMasterListCategories.CATEGORIES.map((pCategory) => pCategory.Name);
		return pNames.sort((pA, pB) =>
		{
			const tmpIA = tmpKnown.indexOf(pA);
			const tmpIB = tmpKnown.indexOf(pB);
			return (tmpIA < 0 ? 999 : tmpIA) - (tmpIB < 0 ? 999 : tmpIB);
		});
	}

	_categoryIcon(pName)
	{
		const tmpCategory = libMasterListCategories.CATEGORIES.find((pCategory) => pCategory.Name === pName);
		return (tmpCategory && tmpCategory.Icon) || 'fas fa-folder';
	}

	/**
	 * Is this entry customized vs the code seed (any persisted field overridden)? Coarse — drives
	 * the "customized" badge without per-level provenance reads.
	 * @param {Object} pEntry
	 * @return {Boolean}
	 */
	_isCustomized(pEntry)
	{
		const tmpSeed = this._seedByEntity[pEntry.Entity];
		if (!tmpSeed) { return true; }
		return JSON.stringify(this._toCatalogConfig(pEntry)) !== JSON.stringify(this._toCatalogConfig(tmpSeed));
	}

	/**
	 * Recompute the AppData the view renders from the working editor model.
	 */
	deriveRenderState()
	{
		const tmpState = this.editorState;
		const tmpSelectedEntity = this._editor && this._editor.entity;

		// Scope: default to the user's natural scope; recompute write-ability + the read-only hint.
		if (!tmpState.ScopeLevel) { tmpState.ScopeLevel = this.defaultScope; }
		tmpState.ScopeOptions = SCOPE_LEVELS.map((pLevel) =>
			(
				{
					Key: pLevel,
					Label: SCOPE_LABELS[pLevel],
					SelectedAttr: (pLevel === tmpState.ScopeLevel) ? 'selected' : '',
					DisabledAttr: this.canWriteScope(pLevel) ? '' : 'disabled'
				}));
		tmpState.CanWriteCurrentScope = this.canWriteScope(tmpState.ScopeLevel);
		tmpState.ScopeHint = tmpState.CanWriteCurrentScope ? ''
			: `You can view ${this._scopeLabel(tmpState.ScopeLevel)} settings but not change them. Switch to “My Settings”, or ask an administrator.`;
		tmpState.ScopeHintSlot = tmpState.ScopeHint ? [ { ScopeHint: tmpState.ScopeHint } ] : [];

		// Left rail: enabled lists grouped by category.
		const tmpByDomain = {};
		this.getEnabledEntries().forEach((pEntry) =>
		{
			const tmpDomain = pEntry.Domain || 'Uncategorized';
			if (!tmpByDomain[tmpDomain]) { tmpByDomain[tmpDomain] = []; }
			tmpByDomain[tmpDomain].push(pEntry);
		});
		tmpState.RailGroups = this._sortByCategory(Object.keys(tmpByDomain)).map((pDomain) =>
			(
				{
					Category: pDomain,
					Icon: this._categoryIcon(pDomain),
					Lists: tmpByDomain[pDomain].map((pEntry) =>
						(
							{
								Entity: pEntry.Entity,
								Label: pEntry.Label || pEntry.Entity,
								Icon: pEntry.Icon || 'fas fa-list',
								CuratedBadge: this._isCustomized(pEntry)
									? '<span class="tag is-info is-light ml-2">customized</span>' : '',
								RowClass: (pEntry.Entity === tmpSelectedEntity) ? 'is-active' : ''
							}))
				}));

		// Add panel: candidate entities grouped by category.
		const tmpCandByDomain = {};
		this.getAvailableCandidates().forEach((pCandidate) =>
		{
			const tmpDomain = pCandidate.Domain || 'Uncategorized';
			if (!tmpCandByDomain[tmpDomain]) { tmpCandByDomain[tmpDomain] = []; }
			tmpCandByDomain[tmpDomain].push(pCandidate);
		});
		tmpState.CandidateGroups = this._sortByCategory(Object.keys(tmpCandByDomain)).map((pDomain) =>
			(
				{
					Category: pDomain,
					Icon: this._categoryIcon(pDomain),
					Entities: tmpCandByDomain[pDomain].map((pCandidate) =>
						({ Entity: pCandidate.Entity, Label: pCandidate.Label || pCandidate.Entity, Icon: pCandidate.Icon || 'fas fa-list' }))
				}));

		if (!tmpState.AddDomain)
		{
			tmpState.AddDomain = (libMasterListCategories.CATEGORIES[0] || {}).Name || 'Uncategorized';
		}
		tmpState.AddOpenSlot = tmpState.AddOpen ? [ {} ] : [];
		tmpState.AddCategoryOptions = libMasterListCategories.CATEGORIES.map((pCategory) =>
			({ Name: pCategory.Name, SelectedAttr: (pCategory.Name === tmpState.AddDomain) ? 'selected' : '' }));

		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message, MessageClass: tmpState.MessageClass || 'is-info' } ] : [];
		tmpState.SaveDisabledAttr = (tmpState.Saving || !tmpState.CanWriteCurrentScope) ? 'disabled' : '';

		if (tmpState.Loading)
		{
			tmpState.LoadingSlot = [ {} ];
			tmpState.EditorSlot = [];
			tmpState.EmptySlot = [];
		}
		else if (this._editor)
		{
			tmpState.Columns = this._editor.columns.map((pColumn) =>
				Object.assign({}, pColumn,
					{
						VisibleAttr: pColumn.Visible ? 'checked' : '',
						SearchAttr: pColumn.Searchable ? 'checked' : '',
						RowClass: pColumn.Visible ? '' : 'has-text-grey',
						SystemBadge: pColumn.IsSystem ? '<span class="tag is-light ml-1">system</span>' : ''
					}));
			tmpState.Title = this._editor.title;
			tmpState.SelectedEntity = this._editor.entity;
			tmpState.SelectedLabel = this._editor.label;
			tmpState.VisibleCount = this._editor.columns.filter((pColumn) => pColumn.Visible).length;
			tmpState.SearchCount = this._editor.columns.filter((pColumn) => pColumn.Searchable).length;
			tmpState.EditorCategoryOptions = libMasterListCategories.CATEGORIES.map((pCategory) =>
				({ Name: pCategory.Name, SelectedAttr: (pCategory.Name === this._editor.domain) ? 'selected' : '' }));

			// Association-view editor: one row per association this entity participates in.
			const tmpAssociations = this._associationsForEntity(this._editor.entity);
			tmpState.AssociationSlot = tmpAssociations.length ? [ {} ] : [];
			tmpState.Associations = tmpAssociations.map((pAssoc) =>
			{
				const tmpModel = (this._editor.associations && this._editor.associations[pAssoc.Hash]) || {};
				return (
					{
						Hash: pAssoc.Hash,
						OtherLabel: pAssoc.OtherLabel,
						Title: tmpModel.title || '',
						ReadTabAttr: tmpModel.readtab ? 'checked' : '',
						BulkAttr: tmpModel.bulk ? 'checked' : '',
						MatrixAttr: tmpModel.matrix ? 'checked' : '',
						UnlinkAttr: tmpModel.unlink ? 'checked' : ''
					});
			});
			tmpState.ShowReadLayout = tmpAssociations.some((pAssoc) =>
			{
				const tmpModel = this._editor.associations && this._editor.associations[pAssoc.Hash];
				return tmpModel && tmpModel.readtab;
			});
			tmpState.ReadLayoutSlot = tmpState.ShowReadLayout ? [ {} ] : [];
			tmpState.ReadLayoutOptions = [ 'Split', 'Tab', 'Basic' ].map((pLayout) =>
				({ Value: pLayout, SelectedAttr: (pLayout === (this._editor.readLayout || 'Split')) ? 'selected' : '' }));

			// Child-list (1:N FK) editor: one row per FK child list this entity can surface.
			const tmpChildLists = this._childListsForEntity(this._editor.entity);
			tmpState.ChildListSlot = tmpChildLists.length ? [ {} ] : [];
			tmpState.ChildLists = tmpChildLists.map((pChild) =>
			{
				const tmpModel = (this._editor.childLists && this._editor.childLists[pChild.Key]) || {};
				return (
					{
						Key: pChild.Key,
						OtherLabel: pChild.RecordSet,
						ChildOnAttr: tmpModel.on ? 'checked' : '',
						Title: tmpModel.title || ''
					});
			});

			tmpState.LoadingSlot = [];
			tmpState.EditorSlot = [ tmpState ];
			tmpState.EmptySlot = [];
		}
		else
		{
			tmpState.LoadingSlot = [];
			tmpState.EditorSlot = [];
			tmpState.EmptySlot = [ {} ];
		}
	}

	_render()
	{
		this.deriveRenderState();
		if (this.pict.views.MasterListManager)
		{
			this.pict.views.MasterListManager.render();
		}
	}

	// --- Scope control ---

	setScope(pValue)
	{
		this.editorState.ScopeLevel = pValue;
		this.editorState.Message = '';
		this._render();
	}

	// --- Add panel controls ---

	toggleAddPanel(pForce)
	{
		const tmpState = this.editorState;
		tmpState.AddOpen = (typeof pForce === 'boolean') ? pForce : !tmpState.AddOpen;
		tmpState.Message = '';
		this._render();
	}

	setAddEntity(pValue) { this.editorState.AddEntity = pValue; }
	setAddDomain(pValue) { this.editorState.AddDomain = pValue; }

	// --- Column editor ---

	/**
	 * Open a list for editing: discover its schema, seed the working model from the current
	 * (merged) entry — columns plus the association-view choices.
	 * @param {String} pEntity
	 */
	async selectList(pEntity)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		tmpState.Message = '';
		this._render();

		let tmpSchemaColumns = [];
		try
		{
			tmpSchemaColumns = await this.getSchemaColumnsAsync(pEntity);
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the schema for ${pEntity}: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
			return;
		}

		const tmpEntry = this.getEntry(pEntity) || { Entity: pEntity, Label: pEntity };
		const tmpConfig = (this.recordSetService && this.recordSetService.recordSetProviderConfigurations[pEntity]) || {};

		const tmpCurated = (Array.isArray(tmpEntry.Columns) && tmpEntry.Columns.length > 0)
			? tmpEntry.Columns
			: (Array.isArray(tmpConfig.RecordSetListColumns) ? tmpConfig.RecordSetListColumns : null);
		const tmpCuratedKeys = tmpCurated ? tmpCurated.map((pColumn) => (typeof pColumn === 'string') ? pColumn : pColumn.Key) : null;
		const tmpLabelByKey = {};
		if (tmpCurated)
		{
			tmpCurated.forEach((pColumn) =>
			{
				if (typeof pColumn === 'object' && pColumn.DisplayName)
				{
					tmpLabelByKey[pColumn.Key] = pColumn.DisplayName;
				}
			});
		}
		const tmpSearchFields = Array.isArray(tmpEntry.SearchFields) ? tmpEntry.SearchFields
			: (Array.isArray(tmpConfig.SearchFields) ? tmpConfig.SearchFields : [ 'Name' ]);

		const tmpColumnByKey = {};
		tmpSchemaColumns.forEach((pKey) =>
		{
			tmpColumnByKey[pKey] =
			{
				Key: pKey,
				DisplayName: tmpLabelByKey[pKey] || pKey,
				IsSystem: SYSTEM_COLUMN.test(pKey),
				Visible: tmpCuratedKeys ? (tmpCuratedKeys.indexOf(pKey) >= 0) : !SYSTEM_COLUMN.test(pKey),
				Searchable: tmpSearchFields.indexOf(pKey) >= 0
			};
		});

		let tmpOrdered = [];
		if (tmpCuratedKeys)
		{
			tmpCuratedKeys.forEach((pKey) => { if (tmpColumnByKey[pKey]) { tmpOrdered.push(tmpColumnByKey[pKey]); } });
			tmpSchemaColumns.forEach((pKey) => { if (tmpCuratedKeys.indexOf(pKey) < 0) { tmpOrdered.push(tmpColumnByKey[pKey]); } });
		}
		else
		{
			tmpOrdered = tmpSchemaColumns.map((pKey) => tmpColumnByKey[pKey]);
		}

		// Seed the association-view model from the merged entry.
		const tmpAssociationModel = {};
		this._associationsForEntity(pEntity).forEach((pAssoc) =>
		{
			tmpAssociationModel[pAssoc.Hash] = this._readAssociationModel(tmpEntry, pAssoc.Hash, pAssoc.OtherLabel);
		});

		this._editor =
		{
			entity: pEntity,
			label: tmpEntry.Label || pEntity,
			title: tmpEntry.Label || pEntity,
			domain: tmpEntry.Domain || 'Uncategorized',
			columns: tmpOrdered,
			associations: tmpAssociationModel,
			childLists: this._readChildListModel(tmpEntry, pEntity),
			readLayout: tmpEntry.ReadLayout || 'Split'
		};
		tmpState.Loading = false;
		this._render();
	}

	_findColumn(pKey)
	{
		return this._editor ? this._editor.columns.find((pColumn) => pColumn.Key === pKey) : null;
	}

	toggleVisible(pKey)
	{
		const tmpColumn = this._findColumn(pKey);
		if (tmpColumn) { tmpColumn.Visible = !tmpColumn.Visible; this._render(); }
	}

	toggleSearch(pKey)
	{
		const tmpColumn = this._findColumn(pKey);
		if (tmpColumn) { tmpColumn.Searchable = !tmpColumn.Searchable; this._render(); }
	}

	setColumnLabel(pKey, pValue)
	{
		const tmpColumn = this._findColumn(pKey);
		if (tmpColumn) { tmpColumn.DisplayName = pValue; }
	}

	setTitle(pValue)
	{
		if (this._editor) { this._editor.title = pValue; }
	}

	setEditorDomain(pValue)
	{
		if (this._editor) { this.setDomain(this._editor.entity, pValue); }
	}

	// --- Association-view editor controls ---

	/**
	 * Toggle whether an association is surfaced through a given view (read tab / bulk / matrix /
	 * unlink). A single association can be on in several views at once.
	 * @param {String} pHash
	 * @param {String} pKind - 'readtab' | 'bulk' | 'matrix' | 'unlink'
	 * @param {Boolean} pOn
	 */
	setAssociationView(pHash, pKind, pOn)
	{
		if (!this._editor) { return; }
		if (!this._editor.associations[pHash])
		{
			this._editor.associations[pHash] = { readtab: false, bulk: false, matrix: false, unlink: false, title: '' };
		}
		this._editor.associations[pHash][pKind] = !!pOn;
		this._render();
	}

	setAssociationTitle(pHash, pValue)
	{
		if (this._editor && this._editor.associations[pHash])
		{
			this._editor.associations[pHash].title = pValue;
		}
	}

	setReadLayout(pValue)
	{
		if (this._editor) { this._editor.readLayout = pValue; }
	}

	setChildListView(pKey, pOn)
	{
		if (!this._editor) { return; }
		if (!this._editor.childLists[pKey]) { this._editor.childLists[pKey] = { on: false, title: '' }; }
		this._editor.childLists[pKey].on = !!pOn;
		this._render();
	}

	setChildListTitle(pKey, pValue)
	{
		if (this._editor && this._editor.childLists[pKey]) { this._editor.childLists[pKey].title = pValue; }
	}

	_move(pKey, pDelta)
	{
		if (!this._editor) { return; }
		const tmpColumns = this._editor.columns;
		const tmpIndex = tmpColumns.findIndex((pColumn) => pColumn.Key === pKey);
		const tmpTarget = tmpIndex + pDelta;
		if (tmpIndex < 0 || tmpTarget < 0 || tmpTarget >= tmpColumns.length) { return; }
		const tmpMoved = tmpColumns.splice(tmpIndex, 1)[0];
		tmpColumns.splice(tmpTarget, 0, tmpMoved);
		this._render();
	}

	moveUp(pKey) { this._move(pKey, -1); }
	moveDown(pKey) { this._move(pKey, 1); }

	/**
	 * Persist the working editor (columns + association-view choices) at the current scope and
	 * apply it to the live list.
	 */
	async save()
	{
		if (!this._editor) { return; }
		const tmpState = this.editorState;
		if (!this.canWriteScope(tmpState.ScopeLevel))
		{
			tmpState.Message = `You do not have permission to save at the ${this._scopeLabel(tmpState.ScopeLevel)} level.`;
			tmpState.MessageClass = 'is-warning';
			this._render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Message = '';
		this._render();

		const tmpVisible = this._editor.columns.filter((pColumn) => pColumn.Visible);
		const tmpEntry = Object.assign({}, this.getEntry(this._editor.entity),
			{
				Entity: this._editor.entity,
				Label: (this._editor.title || '').trim() || this._editor.entity,
				Domain: this._editor.domain || 'Uncategorized',
				Enabled: true,
				Columns: tmpVisible.map((pColumn) => ({ Key: pColumn.Key, DisplayName: pColumn.DisplayName || pColumn.Key })),
				SearchFields: this._editor.columns.filter((pColumn) => pColumn.Searchable).map((pColumn) => pColumn.Key)
			});
		this._writeAssociationModel(tmpEntry);
		this._writeChildListModel(tmpEntry);

		try
		{
			await this.saveEntryAsync(tmpEntry, tmpState.ScopeLevel);
			this._editor.label = tmpEntry.Label;
			tmpState.Saving = false;
			tmpState.Message = `Saved “${tmpEntry.Label}” at the ${this._scopeLabel(tmpState.ScopeLevel)} level — ${tmpVisible.length} column(s) shown.`;
			tmpState.MessageClass = 'is-success';
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Save failed: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
		}
		this._render();
	}

	/**
	 * Navigate to the live list to preview the current configuration.
	 * @param {String} pEntity
	 */
	openList(pEntity)
	{
		window.location.hash = `#/PSRS/${pEntity}/List`;
	}
}

module.exports = MasterListRegistryProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'MasterListRegistry',
	AutoInitialize: true,
	AutoInitializeOrdinal: 200
};

},{"../master-lists/Connections.generated.js":1289,"../master-lists/Headlight-MasterLists.js":1290,"../master-lists/MasterList-Associations.js":1291,"../master-lists/MasterList-Builder.js":1292,"../master-lists/MasterList-Categories.js":1293,"../navigation-graph.js":1294,"pict-provider":845}],1352:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libLogoSlotController = require('./LogoSlotController.js');
const libLabelManagerController = require('./LabelManagerController.js');
const libLabelBehaviorController = require('./LabelBehaviorController.js');

// "My Headlight" — the configuration landing for the signed-in user's own organization (customer). First
// section is Branding: the customer's primary logo (shown across Headlight) and the secondary / reports
// logo (shared LogoSlotController, bespoke /1.0/Customer/[Secondary]Logo endpoints, raw-PNG POST). Second
// section is the customer's DEFAULT project labels (ProjectTagType rows with IDProject=0) that seed every
// new project — managed via the shared LabelManagerController. Built to grow (more preferences land below).

const CUSTOMER_LOGO_SLOTS =
[
	{ Key: 'logo', Label: 'Customer logo', Base: 'Customer/Logo', Help: 'A PNG shown across Headlight for your organization — the portal and this console. A transparent background works best.' },
	{ Key: 'secondary', Label: 'Reports logo', Base: 'Customer/SecondaryLogo', Help: 'A PNG used on generated reports and documents. Falls back to the customer logo when unset.' },
];

class MyHeadlightProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._customerName = '';
		this._loading = false;
		this._logoController = new libLogoSlotController(this.pict, 'MyHeadlight', CUSTOMER_LOGO_SLOTS);
		this._labelController = new libLabelManagerController(this.pict, 'MyHeadlight');
		// Per-observation-type label BEHAVIORS at the customer-default scope (IDProject 0, LevelContext Customer).
		this._labelBehaviorController = new libLabelBehaviorController(this.pict, 'MyHeadlight');
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	/** Role 5+ (admin) or role 4 (customer admin) editing their own customer can manage the logos. */
	get canManageLogo()
	{
		const tmpRole = Number(this.currentUser.UserRoleIndex);
		return (tmpRole >= 5) || (tmpRole === 4);
	}

	/** Role 4+ (customer admin) can manage their own organization's default project labels. */
	get canManageLabels()
	{
		return Number(this.currentUser.UserRoleIndex) >= 4;
	}

	_getJSON(pURL)
	{
		return new Promise((resolve) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => resolve(pError ? null : pBody));
		});
	}

	// --- Loading ---

	async loadAsync()
	{
		this._loading = true;
		this._render();

		const tmpCustomer = await this._getJSON(`Customer/${this.idCustomer}`);
		this._customerName = (tmpCustomer && tmpCustomer.Name) ? tmpCustomer.Name : `Customer ${this.idCustomer}`;
		this._logoController.setContext(this.idCustomer, this.canManageLogo, () => this._render());
		this._labelController.setContext({ IDProject: 0, IDCustomer: this.idCustomer }, this.canManageLabels, () => this._render(), false);
		this._labelBehaviorController.setContext({ IDProject: 0, IDCustomer: this.idCustomer }, this.canManageLabels, () => this._syncLabelBehavior());
		this._loading = false;
		this._render();
		// Fill the logos + default labels in the background; each repaints when its data is ready.
		this._logoController.probeAll().then(() => this._render());
		this._labelController.load();
		this._labelBehaviorController.load();
	}

	// --- Logo slot delegates (the shared Headlight-LogoSlot template calls these by provider name) ---

	uploadSlot(pKey, pInput)
	{
		return this._logoController.upload(pKey, pInput);
	}

	removeSlot(pKey)
	{
		return this._logoController.remove(pKey);
	}

	// --- Default-label delegates (the shared Headlight-LabelManager template calls these by provider name) ---

	labelAdd() { return this._labelController.add(); }
	labelUpdateName(pID, pValue) { return this._labelController.updateName(pID, pValue); }
	labelRemove(pID) { return this._labelController.remove(pID); }
	labelSetNew(pField, pValue) { return this._labelController.setNew(pField, pValue); }
	labelCopyDefaults() { return this._labelController.copyDefaults(); }

	// --- Label-behavior delegates (the shared Headlight-LabelBehavior template calls these by provider name) ---

	labelBehaviorSelectType(pType) { return this._labelBehaviorController.selectType(pType); }
	labelBehaviorSetFreeEntry(pTagType, pDeny) { return this._labelBehaviorController.setFreeEntry(pTagType, pDeny); }
	labelBehaviorSetMaxCount(pTagType, pValue) { return this._labelBehaviorController.setMaxCount(pTagType, pValue); }
	labelBehaviorSetHidden(pTagType, pHidden) { return this._labelBehaviorController.setHidden(pTagType, pHidden); }
	labelBehaviorSetDistilling(pEnabled) { return this._labelBehaviorController.setDistilling(pEnabled); }

	/** Repaint ONLY the label-behavior host (keeps the type picker + scroll) — full re-render as fallback. */
	_syncLabelBehavior()
	{
		this.deriveRenderState();
		if (this.pict.ContentAssignment.getElement('#MH-LabelBehaviorHost').length > 0)
		{
			const tmpSlot = (this.viewState.LabelBehaviorStateSlot || [])[0];
			if (tmpSlot)
			{
				this.pict.ContentAssignment.assignContent('#MH-LabelBehaviorHost', this.pict.parseTemplateByHash('Headlight-LabelBehavior', tmpSlot));
				return;
			}
		}
		this._render();
	}

	// --- Render-state ---

	get viewState()
	{
		if (!this.pict.AppData.MyHeadlight)
		{
			this.pict.AppData.MyHeadlight =
			{
				LoadingSlot: [], BodySlot: [],
				CustomerName: '', CustomerLine: '', LogoSlots: [], LabelStateSlot: [], LabelBehaviorStateSlot: [],
			};
		}
		return this.pict.AppData.MyHeadlight;
	}

	deriveRenderState()
	{
		const tmpState = this.viewState;
		if (this._loading)
		{
			tmpState.LoadingSlot = [ {} ];
			tmpState.BodySlot = [];
			return;
		}
		tmpState.LoadingSlot = [];
		tmpState.BodySlot = [ {} ];
		tmpState.CustomerName = this._customerName;
		tmpState.CustomerLine = `${this._customerName} · Customer #${this.idCustomer}`;
		tmpState.LogoSlots = this._logoController.buildRecords();
		tmpState.LabelStateSlot = [ this._labelController.buildState() ];
		tmpState.LabelBehaviorStateSlot = [ this._labelBehaviorController.buildState() ];
	}

	_render()
	{
		this.deriveRenderState();
		if (this.pict.views.MyHeadlight)
		{
			this.pict.views.MyHeadlight.render();
		}
	}
}

module.exports = MyHeadlightProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'MyHeadlight',
	AutoInitialize: true,
	AutoInitializeOrdinal: 222,
};

},{"./LabelBehaviorController.js":1344,"./LabelManagerController.js":1345,"./LogoSlotController.js":1348,"pict-provider":845}],1353:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libConfigSync = require('./ConfigSync.js');

// An Observation Type is a relational graph: one ObservationManifest (Name / DisplayName / Category /
// IDCustomer) plus an ordered set of ObservationRequirementSpecification rows, each pointing at a
// shared ArtifactType. Journal vs Spreadsheet is NOT stored here — it is chosen per project when the
// type is associated (a later phase), and that association references the manifest BY NAME. So Name
// is load-bearing: renaming a type orphans its project associations, and cloning to a new Name is the
// safe way to make a variant. These are plain Meadow entity records, tenant-scoped by IDCustomer
// (0 = platform/default; a customer id = that customer's bespoke types).

// The persisted columns we round-trip on the manifest (audit + GUID are server-owned).
const MANIFEST_FIELDS = [ 'IDObservationManifest', 'Name', 'DisplayName', 'Category', 'IDCustomer', 'SettingsJSON' ];
// The persisted columns we round-trip on a requirement (GUID + audit are server-owned).
const REQUIREMENT_FIELDS = [ 'IDObservationRequirementSpecification', 'IDObservationManifest', 'IDArtifactType', 'Name', 'CountMinimum', 'CountMaximum', 'Required', 'DefaultJSON' ];

const DEFAULT_COUNT_MAXIMUM = 100;

/**
 * ObservationTypeEditor — the data layer behind the bespoke Observation Type builder.
 *
 * Loads a manifest and its requirement rows, exposes a working model the view edits, and persists
 * create / edit / clone back through the Meadow REST API. The pict-section-recordset list stays the
 * browse surface; this provider drives the bespoke record editor. State lives in
 * pict.AppData.ObservationTypeEditor; the view derives + repaints declaratively.
 */
class ObservationTypeEditorProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// The shared ArtifactType library (cached): the array + lookup maps by id and by name.
		this.artifactTypes = [];
		this.artifactByID = {};
		this.artifactByName = {};

		// Every manifest (cached) for category suggestions + Name-uniqueness checks.
		this._allManifests = null;

		// The working editor model (null until a load / new / clone). Held outside AppData so the
		// view derives a clean render-state from it each paint.
		this._editor = null;

		// Monotonic key for working requirement rows (stable handler references across re-renders).
		this._rowKeySeed = 1;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	// --- Session context + write-permission (mirrors the master-list tool / the server's gate) ---

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return this.currentUser.CustomerID;
	}

	get idUser()
	{
		return this.currentUser.UserID;
	}

	/** A customer-1 / role-5 super-user manages platform (IDCustomer 0) types and anything. */
	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	get hasCustomerAdmin()
	{
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'CustomerAdmin'));
	}

	/**
	 * Can the current user edit a type owned by this customer? A platform (IDCustomer 0) type is
	 * editable only by a super-user; a customer's own types by that customer; super-users edit all.
	 * @param {Number} pIDCustomer
	 * @return {Boolean}
	 */
	canEditCustomer(pIDCustomer)
	{
		if (this.isSuperUser) { return true; }
		return Number(pIDCustomer) === Number(this.idCustomer);
	}

	/**
	 * May the current user manage observation types AT ALL? A super-user always can (and edits the platform
	 * IDCustomer-0 defaults). A customer admin granted the "Manage observation types" entitlement (the
	 * ObservationManifest-Create capability) can manage their OWN customer's types — the per-type
	 * canEditCustomer() gate in deriveRenderState still keeps the shared platform defaults (IDCustomer 0) and
	 * any other customer's types read-only for them (they Clone to customize). The server enforces the same
	 * boundary (HeadlightController.checkAndInferRecordIDCustomer + ObservationManifestBundle
	 * .enforceRequirementSpecCustomerScope), so this is UI parity, not the only gate. Fail-CLOSED until the
	 * capability map has loaded — a write surface must never flash enabled before we can confirm the grant.
	 * @return {Boolean}
	 */
	get isAdmin()
	{
		if (this.isSuperUser) { return true; }
		const tmpService = this.pict.fable && this.pict.fable.EffectivePermissionsService;
		if (!tmpService || (typeof tmpService.canHash !== 'function') || (typeof tmpService.currentUserReady !== 'function')) { return false; }
		if (!tmpService.currentUserReady()) { return false; }
		return !!tmpService.canHash('ObservationManifest-Create');
	}

	// --- REST helpers (promise wrappers over the Headlight rest client) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	// Observation-type WRITES go through a credentialed fetch carrying `x-application-name: HeadLight`. That header
	// opts the request into the API's capability-based permission check (ObservationManifest-Create / Observation
	// RequirementSpecification-Create|Update|Delete, granted via the "Manage observation types" entitlement) plus
	// the server's per-customer IDCustomer stamping. WITHOUT it the config app is seen by the API as "Fieldbook"
	// (not a permission-enforcing app) and these writes fall through to the legacy schema authorizer, where
	// ObservationManifest.Create = Deny → 403 {Error:'UNAUTHORIZED ACCESS IS NOT ALLOWED', ErrorCode:405}. This is
	// SCOPED to this editor on purpose — a stopgap until the config app is made fully permission-enforcing for all
	// of its writes; every other config-app request keeps its current (rest-client) behavior. Reads are unaffected
	// (their schema level is Read = Allow), so only writes carry the header. The session cookie authenticates the
	// fetch, exactly as _deleteJSON already relied on. See HeadlightController.allowPermissionServiceCheck.
	_appHeaders() { return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'x-application-name': 'HeadLight' }; }

	_apiPrefix() { return (this.restClient && this.restClient.options && this.restClient.options.ServerURL) || '/1.0/'; }

	async _writeJSON(pMethod, pURL, pPayload)
	{
		const tmpResponse = await fetch(`${this._apiPrefix()}${pURL}`, { method: pMethod, credentials: 'include', headers: this._appHeaders(), body: JSON.stringify(pPayload) });
		let tmpBody = null; try { tmpBody = await tmpResponse.json(); } catch (pError) { /* a non-JSON/empty body is acceptable for some writes */ }
		if (!tmpResponse.ok || (tmpBody && tmpBody.Error)) { throw new Error((tmpBody && tmpBody.Error) || `${pMethod} ${pURL} failed (${tmpResponse.status})`); }
		return tmpBody;
	}

	_postJSON(pURL, pPayload) { return this._writeJSON('POST', pURL, pPayload); }

	_putJSON(pURL, pPayload) { return this._writeJSON('PUT', pURL, pPayload); }

	/**
	 * Delete a record (the Headlight rest client has no delete verb). Carries the same app-name header as the
	 * other writes so the API uses the capability check, not the legacy schema authorizer.
	 * @param {String} pURL - entity path under /1.0/ (e.g. 'ObservationRequirementSpecification/42').
	 * @return {Promise<void>}
	 */
	_deleteJSON(pURL)
	{
		return fetch(`${this._apiPrefix()}${pURL}`, { method: 'DELETE', credentials: 'include', headers: this._appHeaders() })
			.then((pResponse) =>
			{
				if (!pResponse.ok) { throw new Error(`DELETE ${pURL} failed (${pResponse.status})`); }
			});
	}

	// --- ArtifactType library ---

	/**
	 * Load + cache the ArtifactType library (the data-shapes a requirement can collect).
	 * @return {Promise<Array<Object>>}
	 */
	async loadArtifactTypesAsync()
	{
		if (this.artifactTypes.length > 0)
		{
			return this.artifactTypes;
		}
		const tmpRows = await this._getJSON('ArtifactTypes');
		this.artifactTypes = (Array.isArray(tmpRows) ? tmpRows : []).filter((pRow) => pRow && (pRow.Deleted !== 1));
		this.artifactByID = {};
		this.artifactByName = {};
		this.artifactTypes.forEach((pArtifact) =>
		{
			this.artifactByID[pArtifact.IDArtifactType] = pArtifact;
			this.artifactByName[pArtifact.Name] = pArtifact;
		});
		return this.artifactTypes;
	}

	/**
	 * Parse an ArtifactType's JSON-Schema `Schemata` into an ordered column list.
	 * @param {Object} pArtifact
	 * @return {Array<{ Key: String, DisplayName: String, Type: String }>}
	 */
	_artifactColumns(pArtifact)
	{
		if (!pArtifact || !pArtifact.Schemata) { return []; }
		let tmpSchema = pArtifact.Schemata;
		if (typeof tmpSchema === 'string')
		{
			try { tmpSchema = JSON.parse(tmpSchema); }
			catch (pError) { return []; }
		}
		const tmpProperties = (tmpSchema && tmpSchema.properties) || {};
		return Object.keys(tmpProperties)
			.map((pKey) => ({ Key: pKey, DisplayName: tmpProperties[pKey].displayName || pKey, Type: tmpProperties[pKey].type || 'string', Ordinal: tmpProperties[pKey].ordinal }))
			.sort((pA, pB) => ((pA.Ordinal == null ? 999 : pA.Ordinal) - (pB.Ordinal == null ? 999 : pB.Ordinal)));
	}

	/**
	 * A short human summary of an artifact's shape for the requirement row.
	 * @param {Number} pIDArtifactType
	 * @return {String}
	 */
	_artifactSummary(pIDArtifactType)
	{
		const tmpArtifact = this.artifactByID[pIDArtifactType];
		if (!tmpArtifact) { return ''; }
		const tmpColumns = this._artifactColumns(tmpArtifact);
		if (tmpColumns.length === 0) { return tmpArtifact.Name; }
		const tmpNames = tmpColumns.map((pColumn) => pColumn.Key);
		const tmpShown = tmpNames.slice(0, 5).join(', ') + ((tmpNames.length > 5) ? `, +${tmpNames.length - 5} more` : '');
		return `${tmpColumns.length} field${tmpColumns.length === 1 ? '' : 's'}: ${tmpShown}`;
	}

	// --- Preview (render a type's requirements as a Journal form or a Spreadsheet grid) ---

	/**
	 * The input kind a property previews as: select / checkbox / number / text.
	 * @param {Object} pProperty
	 * @return {String}
	 */
	_inputKindFor(pProperty)
	{
		if (Array.isArray(pProperty.enumOptions) && (pProperty.enumOptions.length > 0)) { return 'select'; }
		const tmpType = (`${pProperty.type || 'string'}`).toLowerCase();
		if (tmpType === 'boolean') { return 'checkbox'; }
		if ((tmpType === 'number') || (tmpType === 'integer') || (tmpType === 'double')) { return 'number'; }
		return 'text';
	}

	/**
	 * The visible, ordered fields of an artifact type, shaped for the preview (label + input kind).
	 * @param {Number} pIDArtifactType
	 * @return {Array<Object>}
	 */
	_artifactFields(pIDArtifactType)
	{
		const tmpArtifact = this.artifactByID[pIDArtifactType];
		if (!tmpArtifact) { return []; }
		let tmpSchema = tmpArtifact.Schemata;
		if (typeof tmpSchema === 'string') { try { tmpSchema = JSON.parse(tmpSchema); } catch (pError) { return []; } }
		const tmpProperties = (tmpSchema && tmpSchema.properties) || {};
		return Object.keys(tmpProperties)
			.map((pKey) => Object.assign({ Key: pKey }, tmpProperties[pKey]))
			.filter((pProperty) => (pProperty.visible !== false) && (pProperty.Hidden !== true))
			.sort((pA, pB) => ((pA.ordinal == null ? 999 : pA.ordinal) - (pB.ordinal == null ? 999 : pB.ordinal)))
			.map((pProperty) =>
			{
				const tmpKind = this._inputKindFor(pProperty);
				return (
					{
						Key: pProperty.Key,
						Label: pProperty.displayName || pProperty.Key,
						Kind: tmpKind,
						MultiField: false,
						IsSelect: (tmpKind === 'select'),
						IsCheckbox: (tmpKind === 'checkbox'),
						IsText: (tmpKind === 'text') || (tmpKind === 'number'),
						InputType: (tmpKind === 'number') ? 'number' : 'text',
						Options: (Array.isArray(pProperty.enumOptions) ? pProperty.enumOptions : []).map((pOption) => ({ Value: pOption }))
					});
			});
	}

	setPreviewMode(pMode)
	{
		this.editorState.PreviewMode = (pMode === 'spreadsheet') ? 'spreadsheet' : 'journal';
		this._render();
	}

	// --- Manifest catalog (categories + name uniqueness) ---

	async _ensureAllManifestsAsync()
	{
		if (this._allManifests) { return this._allManifests; }
		let tmpRows = [];
		try { tmpRows = await this._getJSON('ObservationManifests'); }
		catch (pError) { this.log.warn(`ObservationTypeEditor: could not load manifest catalog: ${pError.message || pError}`); }
		this._allManifests = Array.isArray(tmpRows) ? tmpRows : [];
		return this._allManifests;
	}

	_categories()
	{
		const tmpSet = {};
		(this._allManifests || []).forEach((pManifest) =>
		{
			if (pManifest && pManifest.Category) { tmpSet[pManifest.Category] = true; }
		});
		return Object.keys(tmpSet).sort();
	}

	/**
	 * Is this Name already used by a different manifest the current user can see? (Associations key
	 * on Name, so it must be unique to be safe.)
	 * @param {String} pName
	 * @param {Number} [pExcludeID]
	 * @return {Boolean}
	 */
	_nameInUse(pName, pExcludeID)
	{
		const tmpName = (pName || '').trim().toLowerCase();
		return (this._allManifests || []).some((pManifest) =>
			pManifest && (pManifest.Deleted !== 1) && ((pManifest.Name || '').trim().toLowerCase() === tmpName)
			&& (Number(pManifest.IDObservationManifest) !== Number(pExcludeID)));
	}

	// --- Working-model construction ---

	_blankRequirement(pSeed)
	{
		const tmpSeed = pSeed || {};
		return (
			{
				_key: this._rowKeySeed++,
				IDObservationRequirementSpecification: tmpSeed.IDObservationRequirementSpecification || null,
				IDArtifactType: (tmpSeed.IDArtifactType != null) ? tmpSeed.IDArtifactType : null,
				Name: tmpSeed.Name || '',
				CountMinimum: (tmpSeed.CountMinimum != null) ? tmpSeed.CountMinimum : 0,
				CountMaximum: (tmpSeed.CountMaximum != null) ? tmpSeed.CountMaximum : DEFAULT_COUNT_MAXIMUM,
				Required: !!(tmpSeed.Required === 1 || tmpSeed.Required === true),
				DefaultJSON: (tmpSeed.DefaultJSON != null) ? tmpSeed.DefaultJSON : ''
			});
	}

	/**
	 * Load an existing type into the editor (by ID — robust against the duplicate GUIDs in legacy data).
	 * @param {Number} pIDManifest
	 * @return {Promise<void>}
	 */
	async loadAsync(pIDManifest)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		tmpState.Message = '';
		this._render();

		try
		{
			await this.loadArtifactTypesAsync();
			await this._ensureAllManifestsAsync();

			const tmpManifest = await this._getJSON(`ObservationManifest/${pIDManifest}`);
			if (!tmpManifest || !tmpManifest.IDObservationManifest)
			{
				throw new Error(`Observation type ${pIDManifest} not found.`);
			}
			const tmpRequirements = await this._getJSON(`ObservationRequirementSpecifications/FilteredTo/FBV~IDObservationManifest~EQ~${tmpManifest.IDObservationManifest}`);

			this._editor =
			{
				mode: this.isAdmin ? 'edit' : 'view',
				manifest: tmpManifest,
				originalName: tmpManifest.Name,
				requirements: (Array.isArray(tmpRequirements) ? tmpRequirements : []).map((pRow) => this._blankRequirement(pRow)),
				removedRequirementIDs: []
			};
			tmpState.Loading = false;
			this._render();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the observation type: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	/**
	 * Start a brand-new type in the editor.
	 * @param {Number} [pIDCustomer] - tenant scope (defaults to the user's customer).
	 * @return {Promise<void>}
	 */
	async newType(pIDCustomer)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		this._render();

		await this.loadArtifactTypesAsync();
		await this._ensureAllManifestsAsync();

		this._editor =
		{
			mode: 'new',
			manifest: { Name: '', DisplayName: '', Category: '', IDCustomer: (pIDCustomer != null) ? pIDCustomer : this.idCustomer, SettingsJSON: '{}' },
			originalName: null,
			requirements: [],
			removedRequirementIDs: []
		};
		tmpState.Loading = false;
		this._render();
	}

	/**
	 * Stage a clone of an existing type as a new (unsaved) type — copy its content, mint a unique
	 * Name, and land in the editor so the user can review before saving. Saving creates the manifest
	 * and its requirement rows fresh (new ids / GUIDs, repointed to the new manifest).
	 * @param {Number} pIDSource
	 * @param {Number} [pIDCustomer] - tenant scope for the clone (defaults to the user's customer).
	 * @return {Promise<void>}
	 */
	async cloneFrom(pIDSource, pIDCustomer)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		tmpState.Message = '';
		this._render();

		try
		{
			await this.loadArtifactTypesAsync();
			await this._ensureAllManifestsAsync();

			const tmpSource = await this._getJSON(`ObservationManifest/${pIDSource}`);
			if (!tmpSource || !tmpSource.IDObservationManifest)
			{
				throw new Error(`Source observation type ${pIDSource} not found.`);
			}
			const tmpRequirements = await this._getJSON(`ObservationRequirementSpecifications/FilteredTo/FBV~IDObservationManifest~EQ~${tmpSource.IDObservationManifest}`);

			this._editor =
			{
				mode: 'new',
				manifest:
				{
					Name: this._uniqueName(`${tmpSource.Name} (copy)`),
					DisplayName: tmpSource.DisplayName || '',
					Category: tmpSource.Category || '',
					IDCustomer: (pIDCustomer != null) ? pIDCustomer : this.idCustomer,
					SettingsJSON: tmpSource.SettingsJSON || '{}'
				},
				originalName: null,
				// Copy requirement content WITHOUT ids so save() creates them fresh, repointed to the new manifest.
				requirements: (Array.isArray(tmpRequirements) ? tmpRequirements : []).map((pRow) =>
					this._blankRequirement({ IDArtifactType: pRow.IDArtifactType, Name: pRow.Name, CountMinimum: pRow.CountMinimum, CountMaximum: pRow.CountMaximum, Required: pRow.Required, DefaultJSON: pRow.DefaultJSON })),
				removedRequirementIDs: [],
				clonedFrom: tmpSource.Name
			};
			tmpState.Loading = false;
			tmpState.Message = `Cloned from “${tmpSource.Name}”. Review and Save to create it.`;
			tmpState.MessageClass = 'is-info';
			this._render();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not clone: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	/**
	 * A Name not currently used by any visible manifest (appends " 2", " 3", … if needed).
	 * @param {String} pBase
	 * @return {String}
	 */
	_uniqueName(pBase)
	{
		let tmpName = (pBase || 'Untitled').slice(0, 30);
		let tmpCounter = 2;
		while (this._nameInUse(tmpName))
		{
			const tmpSuffix = ` ${tmpCounter}`;
			tmpName = `${(pBase || 'Untitled').slice(0, 30 - tmpSuffix.length)}${tmpSuffix}`;
			tmpCounter++;
		}
		return tmpName;
	}

	// --- Persistence ---

	/**
	 * Persist the working editor: create-or-update the manifest, then create / update / delete its
	 * requirement rows, then reload. Guards Name (non-empty, unique, rename warning).
	 * @return {Promise<void>}
	 */
	async saveAsync()
	{
		if (!this._editor) { return; }
		const tmpState = this.editorState;
		const tmpManifest = this._editor.manifest;

		const tmpName = (tmpManifest.Name || '').trim();
		if (!tmpName)
		{
			tmpState.Message = 'A Name is required.';
			tmpState.MessageClass = 'is-warning';
			this._render();
			return;
		}
		if (this._nameInUse(tmpName, tmpManifest.IDObservationManifest))
		{
			tmpState.Message = `The name “${tmpName}” is already used by another observation type. Names must be unique (project associations reference types by name).`;
			tmpState.MessageClass = 'is-warning';
			this._render();
			return;
		}

		// Rename guard: an existing type's Name is referenced by project associations BY NAME.
		if ((this._editor.mode === 'edit') && this._editor.originalName && (tmpName !== this._editor.originalName))
		{
			const tmpModal = this.pict.views['Pict-Section-Modal'];
			const tmpConfirmed = (tmpModal && typeof tmpModal.confirm === 'function')
				? await tmpModal.confirm(`Renaming “${this._editor.originalName}” to “${tmpName}” will break any project associations that reference it by name. Continue?`,
					{ title: 'Rename observation type?', confirmLabel: 'Rename', cancelLabel: 'Cancel', dangerous: true })
				: true;
			if (!tmpConfirmed) { return; }
		}

		tmpState.Saving = true;
		tmpState.Message = '';
		this._render();

		try
		{
			// 1. Manifest.
			let tmpSavedManifest;
			if (tmpManifest.IDObservationManifest)
			{
				tmpSavedManifest = await this._putJSON('ObservationManifest', this._pick(tmpManifest, MANIFEST_FIELDS));
			}
			else
			{
				const tmpCreate = this._pick(tmpManifest, MANIFEST_FIELDS);
				delete tmpCreate.IDObservationManifest;
				tmpSavedManifest = await this._postJSON('ObservationManifest', tmpCreate);
			}
			const tmpIDManifest = (tmpSavedManifest && tmpSavedManifest.IDObservationManifest) || tmpManifest.IDObservationManifest;

			// 2. Requirements: delete removed, then upsert the working rows.
			for (const tmpRemovedID of this._editor.removedRequirementIDs)
			{
				await this._deleteJSON(`ObservationRequirementSpecification/${tmpRemovedID}`);
			}
			for (const tmpRow of this._editor.requirements)
			{
				const tmpRecord = this._requirementRecord(tmpRow, tmpIDManifest);
				if (tmpRow.IDObservationRequirementSpecification)
				{
					await this._putJSON('ObservationRequirementSpecification', tmpRecord);
				}
				else
				{
					delete tmpRecord.IDObservationRequirementSpecification;
					await this._postJSON('ObservationRequirementSpecification', tmpRecord);
				}
			}

			// 3. Refresh the catalog + reload the (now-persisted) type.
			this._allManifests = null;
			tmpState.Saving = false;
			await this.loadAsync(tmpIDManifest);
			this.editorState.Message = `Saved “${tmpName}”.`;
			this.editorState.MessageClass = 'is-success';
			this._render();

			// Creating/changing an Observation Type makes the published observation-manifest config stale until a
			// sync runs. Fire a SCOPED sync for just this type: Customer scope (which also refreshes the customer's
			// projects) for a tenant type, or the super-user-only Global scope for a platform default (IDCustomer 0).
			const tmpSyncCustomerID = Number((tmpSavedManifest && tmpSavedManifest.IDCustomer) != null ? tmpSavedManifest.IDCustomer : tmpManifest.IDCustomer);
			if (tmpSyncCustomerID > 0)
			{
				libConfigSync.requestScopedSync(this.pict, 'Customer', tmpSyncCustomerID, { manifest: tmpName });
			}
			else
			{
				libConfigSync.requestScopedSync(this.pict, 'Global', 0, { manifest: tmpName });
			}

			if (typeof window !== 'undefined' && window.location)
			{
				window.location.hash = `#/ObservationType/${tmpIDManifest}`;
			}
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Save failed: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	_pick(pObject, pFields)
	{
		const tmpResult = {};
		pFields.forEach((pField) => { if (pObject[pField] !== undefined) { tmpResult[pField] = pObject[pField]; } });
		return tmpResult;
	}

	_requirementRecord(pRow, pIDManifest)
	{
		return (
			{
				IDObservationRequirementSpecification: pRow.IDObservationRequirementSpecification || undefined,
				IDObservationManifest: pIDManifest,
				IDArtifactType: pRow.IDArtifactType,
				Name: (pRow.Name || '').trim(),
				CountMinimum: Number(pRow.CountMinimum) || 0,
				CountMaximum: Number(pRow.CountMaximum) || 0,
				Required: pRow.Required ? 1 : 0,
				DefaultJSON: (pRow.DefaultJSON && (`${pRow.DefaultJSON}`).trim().length > 0) ? pRow.DefaultJSON : null
			});
	}

	// --- Working-model mutations (called from the view) ---

	_row(pKey)
	{
		return this._editor ? this._editor.requirements.find((pRow) => pRow._key === Number(pKey)) : null;
	}

	setManifestField(pField, pValue)
	{
		if (this._editor) { this._editor.manifest[pField] = pValue; }
	}

	addRequirement()
	{
		if (!this._editor) { return; }
		this._editor.requirements.push(this._blankRequirement());
		this._render();
	}

	removeRequirement(pKey)
	{
		if (!this._editor) { return; }
		const tmpRow = this._row(pKey);
		if (!tmpRow) { return; }
		const tmpApply = () =>
		{
			if (tmpRow.IDObservationRequirementSpecification)
			{
				this._editor.removedRequirementIDs.push(tmpRow.IDObservationRequirementSpecification);
			}
			this._editor.requirements = this._editor.requirements.filter((pRow) => pRow._key !== tmpRow._key);
			this._render();
		};
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && (typeof tmpModal.confirm === 'function'))
		{
			tmpModal.confirm(`Remove the “${tmpRow.Name || 'unnamed'}” requirement?`,
				{ title: 'Remove requirement', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { tmpApply(); } });
		}
		else { tmpApply(); }
	}

	setRequirementArtifact(pKey, pArtifactName)
	{
		const tmpRow = this._row(pKey);
		if (!tmpRow) { return; }
		const tmpArtifact = this.artifactByName[pArtifactName];
		tmpRow.IDArtifactType = tmpArtifact ? tmpArtifact.IDArtifactType : null;
		// First time naming a requirement, default its Name to the artifact's name for convenience.
		if (tmpArtifact && !tmpRow.Name) { tmpRow.Name = tmpArtifact.Name; }
		this._render();
	}

	setRequirementField(pKey, pField, pValue)
	{
		const tmpRow = this._row(pKey);
		if (!tmpRow) { return; }
		if (pField === 'Required') { tmpRow.Required = !!pValue; }
		else if ((pField === 'CountMinimum') || (pField === 'CountMaximum')) { tmpRow[pField] = Number(pValue) || 0; }
		else { tmpRow[pField] = pValue; }
	}

	// --- Render-state (drives the ObservationTypeEditor view via AppData) ---

	get editorState()
	{
		if (!this.pict.AppData.ObservationTypeEditor)
		{
			this.pict.AppData.ObservationTypeEditor =
			{
				Loading: false, Saving: false, Message: '', MessageClass: '',
				LoadingSlot: [], EditorSlot: [], EmptySlot: [ {} ], MessageSlot: [],
				Mode: '', CanEdit: false, ScopeLabel: '', ReadOnlyNoticeSlot: [], ClonedNoticeSlot: [],
				Name: '', DisplayName: '', Category: '', RequirementCount: 0,
				Requirements: [], Categories: [], ArtifactOptions: [],
				SaveDisabledAttr: '', TitleText: 'Observation Type',
				PreviewMode: 'journal', PreviewJournal: [], PreviewColumns: [], PreviewRows: [],
				PreviewJournalSlot: [], PreviewSpreadsheetSlot: [], PreviewEmptySlot: [ {} ],
				JournalBtnClass: 'is-link is-selected', SpreadsheetBtnClass: '',
				ProjectsSlot: [], ProjectsHintSlot: []
			};
		}
		return this.pict.AppData.ObservationTypeEditor;
	}

	/**
	 * The anchor for the embedded Projects association editor: a SAVED manifest's Name (associations
	 * key on the manifest by name), or null for a new / clone-in-progress type (nothing to anchor on
	 * yet — the view shows a "save first" hint instead).
	 * @return {String|null}
	 */
	get projectsAnchorName()
	{
		if (!this._editor || (this._editor.mode === 'new')) { return null; }
		const tmpManifest = this._editor.manifest;
		return (tmpManifest && tmpManifest.IDObservationManifest && tmpManifest.Name) ? tmpManifest.Name : null;
	}

	deriveRenderState()
	{
		const tmpState = this.editorState;

		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message, MessageClass: tmpState.MessageClass || 'is-info' } ] : [];
		tmpState.ArtifactOptions = this.artifactTypes
			.slice()
			.sort((pA, pB) => (pA.Name || '').localeCompare(pB.Name || ''))
			.map((pArtifact) => ({ Name: pArtifact.Name }));
		tmpState.Categories = this._categories().map((pCategory) => ({ Name: pCategory }));

		if (tmpState.Loading)
		{
			tmpState.LoadingSlot = [ {} ];
			tmpState.EditorSlot = [];
			tmpState.EmptySlot = [];
			return;
		}
		if (!this._editor)
		{
			tmpState.LoadingSlot = [];
			tmpState.EditorSlot = [];
			tmpState.EmptySlot = [ {} ];
			return;
		}

		const tmpManifest = this._editor.manifest;
		// Can the user edit THIS type? They must be able to manage types at all (isAdmin) AND own it: a NEW type
		// is created for the user's own customer, but an EXISTING one is editable only by its owning customer
		// (canEditCustomer) — so the shared platform (IDCustomer 0) defaults and any other customer's types stay
		// read-only for a customer admin, who Clones them to customize. Super-users pass canEditCustomer for all.
		const tmpCanEdit = this.isAdmin
			&& ((this._editor.mode === 'new')
				|| ((this._editor.mode === 'edit') && this.canEditCustomer(tmpManifest.IDCustomer)));

		tmpState.Mode = this._editor.mode;
		tmpState.CanEdit = tmpCanEdit;
		tmpState.ReadOnlyAttr = tmpCanEdit ? '' : 'disabled';
		tmpState.Name = tmpManifest.Name || '';
		tmpState.DisplayName = tmpManifest.DisplayName || '';
		tmpState.Category = tmpManifest.Category || '';
		tmpState.TitleText = (this._editor.mode === 'new')
			? 'New Observation Type'
			: `${tmpManifest.DisplayName || tmpManifest.Name || 'Observation Type'}`;

		const tmpScope = (Number(tmpManifest.IDCustomer) === 0) ? 'Platform default' : `Customer ${tmpManifest.IDCustomer}`;
		tmpState.ScopeLabel = tmpScope;
		// The read-only notice shows whenever the current type can't be edited — a user without the capability,
		// OR a customer admin viewing a shared/global or another customer's type (who can still Clone it below).
		tmpState.ReadOnlyNoticeSlot = (!tmpCanEdit) ? [ { ScopeLabel: tmpScope } ] : [];
		tmpState.ClonedNoticeSlot = (this._editor.clonedFrom) ? [ { ClonedFrom: this._editor.clonedFrom } ] : [];
		tmpState.CanClone = this.isAdmin && (this._editor.mode === 'edit');

		tmpState.Requirements = this._editor.requirements.map((pRow) =>
			(
				{
					Key: pRow._key,
					Name: pRow.Name || '',
					ArtifactName: (this.artifactByID[pRow.IDArtifactType] || {}).Name || '',
					ArtifactSummary: this._artifactSummary(pRow.IDArtifactType),
					ArtifactMissing: (pRow.IDArtifactType == null),
					RequiredAttr: pRow.Required ? 'checked' : '',
					CountMinimum: pRow.CountMinimum,
					CountMaximum: pRow.CountMaximum,
					DefaultJSON: pRow.DefaultJSON || '',
					ReadOnlyAttr: tmpCanEdit ? '' : 'disabled'
				}));
		tmpState.RequirementCount = this._editor.requirements.length;
		tmpState.HasRequirements = (this._editor.requirements.length > 0);
		tmpState.EmptyRequirementsSlot = (this._editor.requirements.length > 0) ? [] : [ {} ];

		// Live preview — the same requirements rendered as a Journal form or a Spreadsheet grid.
		if (!tmpState.PreviewMode) { tmpState.PreviewMode = 'journal'; }
		const tmpPreviewReqs = this._editor.requirements.filter((pRow) => (pRow.IDArtifactType != null));
		tmpState.PreviewJournal = tmpPreviewReqs.map((pRow) =>
		{
			const tmpFields = this._artifactFields(pRow.IDArtifactType);
			const tmpMulti = (tmpFields.length > 1);
			tmpFields.forEach((pField) => { pField.MultiField = tmpMulti; });
			const tmpArtifact = this.artifactByID[pRow.IDArtifactType] || {};
			return (
				{
					Label: pRow.Name || '(unnamed)',
					RequiredFlag: !!pRow.Required,
					RepeatSlot: (Number(pRow.CountMaximum) > 1) ? [ { Text: `repeats up to ${pRow.CountMaximum}` } ] : [],
					Fields: tmpFields,
					CaptureSlot: (tmpFields.length === 0) ? [ { ArtifactName: tmpArtifact.Name || 'data' } ] : []
				});
		});
		const tmpColumns = [];
		tmpPreviewReqs.forEach((pRow) =>
		{
			const tmpFields = this._artifactFields(pRow.IDArtifactType);
			if (tmpFields.length <= 1)
			{
				const tmpField = tmpFields[0] || { Kind: 'text', IsText: true, IsSelect: false, IsCheckbox: false, InputType: 'text', Options: [] };
				tmpColumns.push(Object.assign({ Header: pRow.Name || '(unnamed)' }, tmpField));
			}
			else
			{
				tmpFields.forEach((pField) => { tmpColumns.push(Object.assign({}, pField, { Header: `${pRow.Name ? pRow.Name + ' · ' : ''}${pField.Label}` })); });
			}
		});
		tmpState.PreviewColumns = tmpColumns;
		tmpState.PreviewRows = [ { Cells: tmpColumns.slice() }, { Cells: tmpColumns.slice() } ];
		const tmpPreviewEmpty = (tmpPreviewReqs.length === 0);
		tmpState.PreviewEmptySlot = tmpPreviewEmpty ? [ {} ] : [];
		tmpState.PreviewJournalSlot = (!tmpPreviewEmpty && (tmpState.PreviewMode === 'journal')) ? [ {} ] : [];
		tmpState.PreviewSpreadsheetSlot = (!tmpPreviewEmpty && (tmpState.PreviewMode === 'spreadsheet')) ? [ {} ] : [];
		tmpState.JournalBtnClass = (tmpState.PreviewMode === 'journal') ? 'is-link is-selected' : '';
		tmpState.SpreadsheetBtnClass = (tmpState.PreviewMode === 'spreadsheet') ? 'is-link is-selected' : '';

		// Projects-using-this-type: the OTHER side of the ProjectObservationManifest association,
		// anchored on this manifest's Name. Only for a saved type (associations key on the name); a
		// new / clone-in-progress type shows a "save first" hint instead. The view paints the embedded
		// association editor into the container after render.
		const tmpAnchor = this.projectsAnchorName;
		tmpState.ProjectsSlot = tmpAnchor ? [ {} ] : [];
		tmpState.ProjectsHintSlot = tmpAnchor ? [] : [ {} ];

		tmpState.SaveDisabledAttr = (tmpState.Saving || !tmpCanEdit) ? 'disabled' : '';
		tmpState.LoadingSlot = [];
		tmpState.EmptySlot = [];
		tmpState.EditorSlot = [ tmpState ];
	}

	_render()
	{
		this.deriveRenderState();
		if (this.pict.views.ObservationTypeEditor)
		{
			this.pict.views.ObservationTypeEditor.render();
		}
	}

	/**
	 * Open a type by its GUID, resolving to the row's real ID first (robust against the duplicate
	 * GUIDs in legacy data). Bridges the pict-section-recordset list (which links by GUID) to the
	 * editor's ID-based load.
	 * @param {String} pGUID
	 * @return {Promise<void>}
	 */
	async openByGUIDAsync(pGUID)
	{
		const tmpState = this.editorState;
		tmpState.Loading = true;
		tmpState.Message = '';
		this._render();
		try
		{
			const tmpRows = await this._getJSON(`ObservationManifests/FilteredTo/FBV~GUIDObservationManifest~EQ~${pGUID}`);
			const tmpRecord = (Array.isArray(tmpRows) && tmpRows.length > 0) ? tmpRows[0] : null;
			if (!tmpRecord) { throw new Error(`No observation type found for GUID ${pGUID}.`); }
			await this.loadAsync(tmpRecord.IDObservationManifest);
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not open the observation type: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	/** Navigate to a record's edit route (used by the "Clone to my customer" / back actions). */
	openType(pIDManifest)
	{
		if (typeof window !== 'undefined' && window.location)
		{
			window.location.hash = `#/ObservationType/${pIDManifest}`;
		}
	}

	cloneCurrentToMyCustomer()
	{
		if (this._editor && this._editor.manifest && this._editor.manifest.IDObservationManifest)
		{
			this.cloneFrom(this._editor.manifest.IDObservationManifest, this.idCustomer);
		}
	}

	backToList()
	{
		if (typeof window !== 'undefined' && window.location)
		{
			window.location.hash = '#/PSRS/ObservationManifest/List';
		}
	}
}

module.exports = ObservationTypeEditorProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ObservationTypeEditor',
	AutoInitialize: true,
	AutoInitializeOrdinal: 210
};

},{"./ConfigSync.js":1313,"pict-provider":845}],1354:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');

/**
 * ObservationWorkspaceProvider — the engine behind the Observation view (#/Observation/Workspace/:ID[/:Tab], and the
 * bespoke bridge over /PSRS/Observation/View/:GUID). A subclass of the pict-section-workspace base: the base owns the
 * shell (header, tab bar, routing, record load); this subclass adds the four bespoke `render`-kind tab bodies that
 * present a field-captured observation:
 *   • Data       — visualization OF the data: the composited image (annotations burned in) + the per-artifact
 *                  captured data (from the fetched Observation's `.Details`, keyed by manifest slot) + labels.
 *   • Location   — WHERE it was captured: Capture (device/EXIF) + User (person) coordinates on a read-only Leaflet
 *                  map (the ObservationLocationMap instance), combined via fitBounds.
 *   • History    — older VERSIONS: the ObservationArchive snapshots (one per save), newest first, each previewable.
 *   • Artifacts  — different VERSIONS of each artifact's raw media (1..Artifact.Version).
 *
 * Read-only for now; roll-back / roll-forward / merge build on this later (PUT a chosen SnapshotJSON + re-version
 * artifact media). Config in [[Observation.config.js]]; map instance registered in PlatformConfiguration-Application-Web.
 */
class ObservationWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._obs = null;
		this._details = {};
		this._labels = {};
		this._points = { capture: null, user: null };
		this._creatorName = '';
		this._tabs = {};
	}

	get idObservation() { return this._obs ? this._obs.IDObservation : null; }

	// Map contract (the ObservationLocationMap reads these; showForProject is overridden to use mapPoints()).
	get center() { const p = this._points && (this._points.capture || this._points.user); return p ? { Latitude: p.lat, Longitude: p.lng } : { Latitude: null, Longitude: null }; }
	get hasCenter() { return !!(this._points && (this._points.capture || this._points.user)); }
	mapPoints() { return this._points; }

	// --- small helpers ---
	_get(pURI) { return this._getJSON(pURI); }   // base _getJSON resolves null on error
	_mediaUrl(pPath) { const rc = this.restClient; if (rc && (typeof rc.formatUrl === 'function')) { try { return rc.formatUrl(pPath); } catch (e) { /* fall through */ } } return `/1.0/${pPath}`; }
	_obsImagePath(pSize, pVersion) { const tmpBase = `Observation/${this.idObservation}/Image/${pSize}`; return (pVersion != null && pVersion !== '') ? `${tmpBase}/V/${pVersion}` : tmpBase; }
	_artifactMediaPath(pIDArtifact, pVersion) { return `Artifact/Media/${Number(pIDArtifact)}/${Number(pVersion) || 1}`; }
	_prettySlot(pSlot) { return String(pSlot || '').replace(/([a-z])([A-Z])/g, '$1 $2'); }
	_fmtDate(pValue) { if (!pValue) { return ''; } try { const d = new Date(pValue); if (!Number.isNaN(d.getTime())) { return d.toLocaleString(); } } catch (e) { /* fall through */ } return String(pValue).replace('T', ' ').slice(0, 16); }

	/** parse the two lat/long pairs (decimal strings; 0/near-0 = "no location" sentinel). */
	_computePoints(pObs)
	{
		const fPoint = (pLat, pLng) =>
		{
			const tmpLat = parseFloat(pLat); const tmpLng = parseFloat(pLng);
			if (!Number.isFinite(tmpLat) || !Number.isFinite(tmpLng)) { return null; }
			if ((Math.abs(tmpLat) < 0.0000001) && (Math.abs(tmpLng) < 0.0000001)) { return null; }
			return { lat: tmpLat, lng: tmpLng };
		};
		return { capture: fPoint(pObs.CaptureLatitude, pObs.CaptureLongitude), user: fPoint(pObs.UserLatitude, pObs.UserLongitude) };
	}

	async _lookupUserName(pID)
	{
		if (!pID) { return ''; }
		const r = await this._get(`User/${Number(pID)}`);
		if (r && !r.Error) { return [ r.NameFirst, r.NameLast ].filter(Boolean).join(' ') || r.Name || `#${pID}`; }
		return `#${pID}`;
	}

	/** The centralized observation renderer (registered in PlatformConfiguration-Application-Web). */
	get _obsRender() { return this.pict && this.pict.HeadlightObservationRender; }

	// --- hydrate: the base loaded the scalar record; re-fetch the full observation WITH its assembled .Details ---
	async hydrateAsync(pRecord)
	{
		this._tabs = {};
		const tmpFull = await this._get(`Observation/${pRecord.IDObservation}`);
		this._obs = (tmpFull && !tmpFull.Error) ? tmpFull : pRecord;
		this._details = (this._obs.Details && (typeof this._obs.Details === 'object')) ? this._obs.Details : {};
		this._labels = (this._obs.Labels && (typeof this._obs.Labels === 'object')) ? this._obs.Labels : {};
		this._points = this._computePoints(this._obs);
		this._creatorName = await this._lookupUserName(this._obs.CreatingIDUser);
		// Resolve the observation's schema (built-in OR custom — the API merges them) so the render service can lay out
		// columns/labels; a failure is non-fatal (it falls back to key-derived columns).
		this._spec = null;
		const tmpRender = this._obsRender;
		if (tmpRender && this._obs && this._obs.ObservationType && (typeof tmpRender.loadSpecification === 'function'))
		{
			await new Promise((resolve) => tmpRender.loadSpecification(this._obs.ObservationType, this._obs.IDProject,
				(pError, pSpec) => { this._spec = pError ? null : pSpec; resolve(); }));
		}
	}

	// --- Tab data (History loads on enter; Data/Location/Artifacts render from the already-hydrated record) ---
	_tabState(pTab) { return this._tabs[pTab] || {}; }
	_loadingOrEmpty(pTab, pEmptyMsg)
	{
		const t = this._tabState(pTab);
		if (t.Loading || (!t.Loaded && !t.Error)) { return `<div class="ow-note"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>`; }
		if (t.Error) { return `<div class="ow-error">${this._esc(t.Error)}</div>`; }
		if (!t.Rows || !t.Rows.length) { return `<div class="ow-note">${this._esc(pEmptyMsg)}</div>`; }
		return null;
	}

	async _ensureTabDataAsync(pTab)
	{
		if (!this._obs) { return; }
		if (this._tabs[pTab] && this._tabs[pTab].Loaded) { return; }
		this._tabs[pTab] = { Loading: true, Loaded: false };
		this.repaintBody();
		try
		{
			if (pTab === 'history') { this._tabs[pTab].Rows = await this._loadHistory(); }
			this._tabs[pTab].Loaded = true;
		}
		catch (e) { this._tabs[pTab].Error = (e && e.message) || String(e); this._tabs[pTab].Loaded = true; }
		finally { this._tabs[pTab].Loading = false; this.repaintBody(); }
	}

	async _loadHistory()
	{
		const tmpRows = await this._get(`ObservationArchives/FilteredTo/FBV~IDObservation~EQ~${this.idObservation}~FBV~Deleted~EQ~0~FSF~Version~DESC~0/0/100`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	// =====================================================================================================
	// Tab 1 — DATA (visualization of the captured data)
	// =====================================================================================================
	_dataHTML()
	{
		const tmpRender = this._obsRender;
		if (tmpRender && this._obs && (typeof tmpRender.renderObservationHTML === 'function'))
		{
			// The centralized service owns the whole Data body (hero + meta + description + captured-data slots + labels).
			// It is schema-driven: every artifact in every slot renders (spreadsheets as tables, journals as prose, media
			// as thumbnails/links) — replacing the old first-artifact-only walker that dropped rows and blanked spreadsheets.
			return tmpRender.renderObservationHTML(this._obs, { format: 'full', specification: this._spec || null, creatorName: this._creatorName });
		}
		return '<div class="ow-note">The observation renderer is unavailable.</div>';
	}

	// =====================================================================================================
	// Tab 2 — LOCATION (Capture + User on a map)
	// =====================================================================================================
	_locationHTML()
	{
		return `<div class="ow-loc">
			<div class="ow-loc-legend"><span class="ow-dot ow-dot-cap"></span> Capture <span class="ow-muted">(device / EXIF)</span> &nbsp;&nbsp; <span class="ow-dot ow-dot-usr"></span> User <span class="ow-muted">(person)</span></div>
			<div id="OW-MapHost" class="ow-map"></div>
			<div class="ow-loc-readout">${this._locReadoutHTML()}</div>
		</div>`;
	}

	_locReadoutHTML()
	{
		const p = this._points || {};
		const fmt = (x) => x ? `${x.lat.toFixed(6)}, ${x.lng.toFixed(6)}` : '<span class="ow-muted">Not recorded</span>';
		return `<div class="ow-loc-row"><span class="ow-loc-k">Capture</span><span class="ow-loc-v">${fmt(p.capture)}</span></div>`
			+ `<div class="ow-loc-row"><span class="ow-loc-k">User</span><span class="ow-loc-v">${fmt(p.user)}</span></div>`
			+ ((!p.capture && !p.user) ? `<div class="ow-note" style="margin-top:0.5rem">No location was recorded for this observation.</div>` : '');
	}

	/** Location tab OnEnter: (re)mount the read-only 2-marker map into the freshly-painted #OW-MapHost. */
	_mountMap()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA && (tmpCA.getElement('#OW-MapHost').length > 0))
		{
			const tmpMap = this.pict.views.ObservationLocationMap;
			if (tmpMap && (typeof tmpMap.showForProject === 'function')) { tmpMap.showForProject(); }
		}
	}

	// =====================================================================================================
	// Tab 3 — HISTORY (ObservationArchive versions)
	// =====================================================================================================
	_historyHTML()
	{
		const tmpBusy = this._loadingOrEmpty('history', 'No version history recorded for this observation yet.');
		if (tmpBusy) { return tmpBusy; }
		const tmpCurrent = this._obs ? Number(this._obs.Version) : null;
		const tmpRows = this._tabState('history').Rows.map((a) =>
		{
			const v = a.Version;
			const tmpWho = a.UpdatingIDUser || a.CreatingIDUser || '';
			const tmpIsCur = (Number(v) === tmpCurrent);
			return `<tr>
				<td class="ow-num">v${this._esc(v)}${tmpIsCur ? ' <span class="ow-badge ow-badge-cur">current</span>' : ''}</td>
				<td>${this._esc(this._fmtDate(a.UpdateDate || a.CreateDate))}</td>
				<td class="ow-mono">#${this._esc(tmpWho)}</td>
				<td><img class="ow-vthumb" src="${this._mediaUrl(this._obsImagePath('Thumbnail', v))}" loading="lazy" onerror="this.classList.add('ow-broken')"/></td>
			</tr>`;
		}).join('');
		return `<div class="ow-hint">Every save writes a full snapshot to the archive. Newest first; the preview is that version's rendered image (annotations included).</div>`
			+ `<table class="ow-table"><thead><tr><th>Version</th><th>When</th><th>By</th><th>Preview</th></tr></thead><tbody>${tmpRows}</tbody></table>`;
	}

	// =====================================================================================================
	// Tab 4 — ARTIFACT VERSIONS (raw media 1..Version per artifact)
	// =====================================================================================================
	_gatherArtifacts()
	{
		const tmpSeen = {}; const tmpOut = [];
		Object.keys(this._details).forEach((pSlot) =>
		{
			const arr = this._details[pSlot];
			(Array.isArray(arr) ? arr : []).forEach((a) =>
			{
				if (a && a.IDArtifact && !tmpSeen[a.IDArtifact])
				{
					tmpSeen[a.IDArtifact] = true;
					tmpOut.push({ IDArtifact: a.IDArtifact, ArtifactType: a.ArtifactType || pSlot, Version: Number(a.Version) || 1, Slot: pSlot });
				}
			});
		});
		return tmpOut;
	}

	_artifactsHTML()
	{
		const tmpArts = this._gatherArtifacts();
		if (!tmpArts.length) { return `<div class="ow-note">No artifacts are attached to this observation.</div>`; }
		const tmpCards = tmpArts.map((a) =>
		{
			const tmpIsImage = (a.ArtifactType === 'Image');
			const tmpTiles = [];
			for (let v = 1; v <= a.Version; v++)
			{
				const tmpCur = (v === a.Version);
				const tmpUrl = this._mediaUrl(this._artifactMediaPath(a.IDArtifact, v));
				if (tmpIsImage)
				{
					tmpTiles.push(`<div class="ow-vtile${tmpCur ? ' ow-vtile-cur' : ''}"><img class="ow-vtile-img" src="${tmpUrl}" loading="lazy" onerror="this.parentNode.classList.add('ow-broken')"/><div class="ow-vtile-cap">v${v}${tmpCur ? ' · current' : ''}</div></div>`);
				}
				else
				{
					tmpTiles.push(`<div class="ow-vtile${tmpCur ? ' ow-vtile-cur' : ''}"><a class="ow-vtile-file" href="${tmpUrl}" target="_blank" rel="noopener"><i class="fas fa-file"></i></a><div class="ow-vtile-cap">v${v}${tmpCur ? ' · current' : ''}</div></div>`);
				}
			}
			return `<div class="ow-art"><div class="ow-art-h">${this._esc(this._prettySlot(a.Slot))}<span class="ow-badge">${this._esc(a.ArtifactType)}</span><span class="ow-muted">${a.Version} version${a.Version > 1 ? 's' : ''}</span></div><div class="ow-vtiles">${tmpTiles.join('')}</div></div>`;
		}).join('');
		return `<div class="ow-hint">Each artifact's raw media versions, oldest → current. Annotation edits are tracked at the observation level (see <b>History</b>) and are NOT burned into this raw media.</div>${tmpCards}`;
	}
}

module.exports = ObservationWorkspaceProvider;

},{"pict-section-workspace":1049}],1355:[function(require,module,exports){

const libPictProvider = require('pict-provider');

const libCatalog = require('../access/Permission-Catalog.js');
const libMatrixBuilder = require('../access/Access-Matrix-Builder.js');

// PermissionsEnforcement modes (lib/permissions-control PermissionsControl). 'Default' = not enforced
// (grants are inert here); the rest bite. Ordered least → most restrictive for the picker.
const ENFORCEMENT_MODES = [ 'Default', 'Level', 'Mine', 'Hybrid', 'Strict' ];

/**
 * PermissionMatrix — the role/permission matrix tab of the Access workspace.
 *
 * Reads a role's (or permission group's) saved grants (RolePermission Allowed=1) and denies (Allowed=0) for
 * the workspace's current Context+IDContext, and turns them into the tri-state grid (rows = catalog entities
 * grouped by kind, cols = the 10 actions) via the pure Access-Matrix-Builder. Phase 1 is read-only; phase 2
 * adds the Grant/Deny/clear write path. The subject + context come from the AccessWorkspace provider (the
 * single owner); this provider only owns the matrix slice of AppData (AppData.AccessWorkspace.Matrix).
 */
class PermissionMatrixProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// The active catalog source: the STATIC entity catalog (default) or a DYNAMIC reports/forms catalog
		// built from the live ReportNamedInstance set. Built lazily; the reports source is rebuilt when the
		// context's report set changes. See Access-Matrix-Builder for the source interface.
		this._staticSource = null;
		this._reportSource = null;
	}

	get workspace()
	{
		return this.pict.providers.AccessWorkspace;
	}

	/**
	 * The catalog source for the current mode. Reports mode falls back to an empty reports source until the
	 * ReportNamedInstance set has loaded (so derive never throws mid-load).
	 * @return {Object}
	 */
	get activeSource()
	{
		if (this.matrix.CatalogMode === 'reports')
		{
			return this._reportSource || libMatrixBuilder.reportCatalogSource([], {});
		}
		if (!this._staticSource)
		{
			this._staticSource = libMatrixBuilder.staticCatalogSource();
		}
		return this._staticSource;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	/**
	 * The matrix slice of the shared workspace AppData (lazily created).
	 * @return {Object}
	 */
	get matrix()
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.Matrix)
		{
			tmpWorkspaceState.Matrix =
			{
				RoleID: 0, Context: '', IDContext: 0, Loading: false, Loaded: false, Error: '', Search: '',
				GrantHashes: [], DenyHashes: [], GrantByHash: {}, DenyByHash: {}, Edits: {},
				Actions: [], Sections: [], GrantCount: 0, DenyCount: 0,
				Editable: false, Saving: false, EditCount: 0, SaveNotice: '', SaveNoticeClass: '',
				LoadingSlot: [], ErrorSlot: [], GridSlot: [], NoMatchSlot: [],
				AllHeadSlot: [], EditHintSlot: [], SaveBarSlot: [], SaveNoticeSlot: [],
				// Reports/forms mode: the switchable catalog axis + the PermissionsEnforcement layer.
				CatalogMode: 'entities', ReportsKey: '', ReportsLoading: false,
				EnforcementDocument: {}, EnforcementConfig: null, EnforcementCustomerIDs: null, EnforcementLoadError: '',
				ModeSlot: [], EnforcementHeadSlot: [], EnforcementBannerSlot: [],
			};
		}
		return tmpWorkspaceState.Matrix;
	}

	// --- REST helpers ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			// The rest client exposes deleteEntity(entity, id) (there is no raw deleteJSON).
			const tmpMatch = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (tmpMatch)
			{
				this.restClient.deleteEntity(tmpMatch[1], tmpMatch[2], (pError, pBody) => pError ? reject(pError) : resolve(pBody));
				return;
			}
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((pResponse) =>
				{
					if (!pResponse.ok) { reject(new Error(`HTTP ${pResponse.status}`)); return; }
					pResponse.text().then((pText) => resolve(pText ? JSON.parse(pText) : {})).catch(() => resolve({}));
				})
				.catch(reject);
		});
	}

	/**
	 * Read an entire filtered set (Count then a single sized page).
	 * @param {String} pEntitySet
	 * @param {String} pFilter
	 * @param {Number} [pCap]
	 * @return {Promise<Array>}
	 */
	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 5000;
		let tmpTotal = tmpCap;
		try
		{
			const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`);
			tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap);
		}
		catch (pError)
		{
			tmpTotal = tmpCap;
		}
		if (!tmpTotal)
		{
			return [];
		}
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	/**
	 * Fetch the RolePermission rows for a role+context at a given Allowed flag.
	 * @param {Number} pIDRole
	 * @param {String} pContext
	 * @param {Number} pIDContext
	 * @param {Number} pAllowed - 1 (grant) or 0 (deny)
	 * @return {Promise<Array>}
	 */
	_readPermissionRows(pIDRole, pContext, pIDContext, pAllowed)
	{
		const tmpFilter = `FBV~Context~EQ~${pContext}~FBV~IDContext~EQ~${pIDContext}~FBV~IDRole~EQ~${pIDRole}~FBV~Allowed~EQ~${pAllowed}`;
		return this._getFilteredAll('RolePermissions', tmpFilter, 5000);
	}

	/**
	 * Resolve the RolePermission STORAGE scope for the current role + workspace context. A role's direct grants
	 * live in the membership context (Customer -> CustomerMembership) keyed by the role's OWN customer (0 for a
	 * global role) — not the entity 'Customer'/<userCustomer> scope, where the resolver only cascades them in.
	 * @return {{ Context: String, IDContext: Number }}
	 */
	_scope()
	{
		const tmpWorkspaceState = this.workspace.state;
		const tmpRole = tmpWorkspaceState.SubjectRecord || {};
		if (tmpWorkspaceState.Context === 'Customer')
		{
			const tmpRoleCustomer = Number(tmpRole.IDCustomer || 0);
			// GLOBAL roles store grants in the membership context (CustomerMembership/0); CUSTOMER-SPECIFIC
			// roles store them in the entity context keyed by their own customer (Customer/<IDCustomer>).
			return (tmpRoleCustomer === 0)
				? { Context: 'CustomerMembership', IDContext: 0 }
				: { Context: 'Customer', IDContext: tmpRoleCustomer };
		}
		return { Context: libCatalog.contextToMembership(tmpWorkspaceState.Context), IDContext: Number(tmpWorkspaceState.IDContext) };
	}

	// --- Load ---

	/**
	 * Load the matrix for the workspace's current role + context. No-op for a user subject. Skips the fetch
	 * when the role + context already match what's loaded (unless pForce).
	 * @param {Boolean} [pForce]
	 */
	async loadAsync(pForce)
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.SubjectRecord || tmpWorkspaceState.SubjectKind === 'user')
		{
			return;
		}
		const tmpRoleID = Number(tmpWorkspaceState.SubjectID);
		const tmpScope = this._scope();
		const tmpContext = tmpScope.Context;
		const tmpIDContext = tmpScope.IDContext;
		const tmpMatrix = this.matrix;
		tmpMatrix.Editable = !!this.workspace.isRoleManager;

		const tmpUnchanged = tmpMatrix.Loaded && !pForce &&
			(tmpMatrix.RoleID === tmpRoleID) && (tmpMatrix.Context === tmpContext) && (tmpMatrix.IDContext === tmpIDContext);
		if (tmpUnchanged)
		{
			this._render();
			return;
		}

		tmpMatrix.RoleID = tmpRoleID;
		tmpMatrix.Context = tmpContext;
		tmpMatrix.IDContext = tmpIDContext;
		tmpMatrix.Loaded = false;
		tmpMatrix.Error = '';
		tmpMatrix.Edits = {};

		if (tmpWorkspaceState.Context !== 'Customer' && !tmpIDContext)
		{
			tmpMatrix.Loading = false;
			tmpMatrix.Error = `Enter a ${tmpWorkspaceState.Context} ID above to scope the permissions.`;
			this._render();
			return;
		}

		tmpMatrix.Loading = true;
		this._render();
		try
		{
			const tmpRows = await Promise.all(
				[
					this._readPermissionRows(tmpRoleID, tmpContext, tmpIDContext, 1),
					this._readPermissionRows(tmpRoleID, tmpContext, tmpIDContext, 0),
				]);
			const tmpGrant = libMatrixBuilder.dedupRolePermissionRows(tmpRows[0]);
			const tmpDeny = libMatrixBuilder.dedupRolePermissionRows(tmpRows[1]);
			tmpMatrix.GrantByHash = tmpGrant.byHash;
			tmpMatrix.GrantHashes = tmpGrant.hashes;
			tmpMatrix.DenyByHash = tmpDeny.byHash;
			tmpMatrix.DenyHashes = tmpDeny.hashes;
			// The role's grant/deny rows are the same set regardless of axis; reports mode also needs the
			// context's ReportNamedInstance set + enforcement config to know which report ROWS to render.
			if (tmpMatrix.CatalogMode === 'reports')
			{
				await this._ensureReportsAsync();
			}
			tmpMatrix.Loaded = true;
		}
		catch (pError)
		{
			tmpMatrix.Error = `Could not load permissions: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpMatrix.Loading = false;
		this._render();
	}

	setSearch(pValue)
	{
		this.matrix.Search = pValue || '';
		this._render();
	}

	// --- Reports & Forms mode (dynamic ReportNamedInstance catalog + enforcement) ---

	/**
	 * Switch the matrix axis between the static entity catalog and the dynamic reports/forms catalog.
	 * @param {String} pMode - 'entities' | 'reports'
	 */
	setCatalogMode(pMode)
	{
		const tmpMode = (pMode === 'reports') ? 'reports' : 'entities';
		const tmpMatrix = this.matrix;
		if (tmpMatrix.CatalogMode === tmpMode)
		{
			return;
		}
		tmpMatrix.CatalogMode = tmpMode;
		tmpMatrix.Edits = {};   // pending edits don't carry across axes
		tmpMatrix.SaveNotice = '';
		tmpMatrix.Search = '';
		if (tmpMode === 'reports')
		{
			this._switchToReportsAsync();
		}
		else
		{
			this._render();
		}
	}

	async _switchToReportsAsync()
	{
		const tmpMatrix = this.matrix;
		tmpMatrix.ReportsLoading = true;
		this._render();
		try
		{
			await this._ensureReportsAsync();
		}
		catch (pError)
		{
			tmpMatrix.Error = `Could not load reports & forms: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpMatrix.ReportsLoading = false;
		this._render();
	}

	/**
	 * Ensure the reports/forms catalog source + enforcement config are loaded for the current context.
	 * Keyed by Context:IDContext so switching role (same context) reuses the report set; changing context
	 * refetches. No render (callers render).
	 */
	async _ensureReportsAsync()
	{
		const tmpMatrix = this.matrix;
		const tmpCtx = this.workspace.state.Context;
		const tmpCtxID = Number(this.workspace.state.IDContext) || 0;
		const tmpKey = `${tmpCtx}:${tmpCtxID}`;
		if (tmpMatrix.ReportsKey === tmpKey && this._reportSource)
		{
			return;
		}
		const tmpRNIs = await this._loadReportNamedInstancesAsync(tmpCtx, tmpCtxID);
		const tmpStatuses = await this._loadWorkflowStatusesAsync(tmpCtx, tmpCtxID, tmpRNIs);
		this._reportSource = libMatrixBuilder.reportCatalogSource(tmpRNIs, tmpStatuses);
		await this._loadEnforcementAsync(tmpCtx, tmpCtxID);
		tmpMatrix.ReportsKey = tmpKey;
	}

	/**
	 * The reports/forms available in the current context — by project when a project is scoped, else the
	 * admin's customer (mirrors the home app's ReportNamedInstancesByProject / By/IDCustomer enumeration).
	 * @return {Promise<Array>}
	 */
	async _loadReportNamedInstancesAsync(pContext, pIDContext)
	{
		const tmpCustomer = this.workspace.idCustomer;
		const tmpURL = (pContext === 'Project' && pIDContext > 0)
			? `ReportNamedInstancesByProject/${pIDContext}/0/1000`
			: `ReportNamedInstances/By/IDCustomer/${tmpCustomer}/0/1000`;
		const tmpRows = await this._getJSON(tmpURL);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	/**
	 * Per-report approval-workflow states → the `View-<Status>` action columns. Best-effort: a report only
	 * gets status columns when it has an approval-workflow binding (cleaner than the home app's always-four).
	 * @return {Promise<Object>} { '<RNI.Hash>': ['Draft','Approved', ...] }
	 */
	async _loadWorkflowStatusesAsync(pContext, pIDContext, pRNIs)
	{
		const tmpStatuses = {};
		try
		{
			const tmpCtx = (pContext === 'Project' || pContext === 'Contract') ? pContext : 'Customer';
			const tmpCtxID = (tmpCtx === 'Customer') ? this.workspace.idCustomer : pIDContext;
			const tmpBindings = await this._getJSON(`Configuration/For/ApprovalWorkflowBindings/In/${tmpCtx}/${tmpCtxID}`);
			const tmpWorkflows = await this._getJSON(`Configuration/For/ApprovalWorkflow/In/${tmpCtx}/${tmpCtxID}`);
			const tmpDocBindings = (tmpBindings && tmpBindings.Document) || {};
			(pRNIs || []).forEach((pRNI) =>
			{
				const tmpWFHash = tmpDocBindings[pRNI.Hash];
				const tmpWF = tmpWFHash && tmpWorkflows && tmpWorkflows[tmpWFHash];
				if (tmpWF && Array.isArray(tmpWF.States))
				{
					tmpStatuses[pRNI.Hash] = tmpWF.States.map((pState) => pState.Status).filter(Boolean);
				}
			});
		}
		catch (pError)
		{
			// Best-effort: no approval-workflow status columns if the config isn't available.
		}
		return tmpStatuses;
	}

	/**
	 * The scope the PermissionsEnforcement config is read/written at for the current context.
	 * @return {{ Scope: String, ScopeID: Number }}
	 */
	_enforcementScope(pContext, pIDContext)
	{
		if (pContext === 'Project' && pIDContext > 0)
		{
			return { Scope: 'Project', ScopeID: pIDContext };
		}
		if (pContext === 'Contract' && pIDContext > 0)
		{
			return { Scope: 'Contract', ScopeID: pIDContext };
		}
		return { Scope: 'Customer', ScopeID: this.workspace.idCustomer };
	}

	/**
	 * Read the PermissionsEnforcement config for the context: the per-report modes (NamespaceValue
	 * `EnforcementTypes` → Document.<RNI.Hash>.Actions) + the global customer-enrollment gate
	 * (NamespaceValue `Configuration` → CustomerIDs). The gate is best-effort. A failed modes read is remembered in
	 * EnforcementLoadError: a mode change writes the whole EnforcementTypes blob back, so writing it from an unknown
	 * starting point would wipe every other stanza at that scope (e.g. LADOTD's Entity.Sample.Delete).
	 */
	async _loadEnforcementAsync(pContext, pIDContext)
	{
		const tmpMatrix = this.matrix;
		tmpMatrix.EnforcementDocument = {};
		tmpMatrix.EnforcementConfig = null;
		tmpMatrix.EnforcementCustomerIDs = null;
		tmpMatrix.EnforcementLoadError = '';
		const tmpLevel = this._enforcementScope(pContext, pIDContext);
		try
		{
			const tmpTypes = await this._postJSON('Configuration/Get',
				{ LevelContext: tmpLevel.Scope, LevelContextID: tmpLevel.ScopeID, NamespaceKey: 'PermissionsEnforcement', NamespaceValue: 'EnforcementTypes' });
			const tmpConfig = this._unwrapConfig(tmpTypes);
			tmpMatrix.EnforcementConfig = tmpConfig;
			tmpMatrix.EnforcementDocument = tmpConfig.Document || {};
		}
		catch (pError)
		{
			// Modes unknown: display reads as Default, and mode changes are refused until a reload succeeds.
			tmpMatrix.EnforcementLoadError = `The current enforcement settings could not be read, so they can't be changed: a change would overwrite them. Reload and try again. (${pError && pError.message ? pError.message : pError})`;
		}
		try
		{
			const tmpGate = await this._postJSON('Configuration/Get',
				{ LevelContext: 'Global', LevelContextID: 0, NamespaceKey: 'PermissionsEnforcement', NamespaceValue: 'Configuration' });
			const tmpGateConfig = this._unwrapConfig(tmpGate);
			// Only claim (non-)enrollment when there is an explicit CustomerIDs list; an empty/absent gate means
			// unknown (null → no banner) rather than "nobody is enrolled".
			tmpMatrix.EnforcementCustomerIDs = Array.isArray(tmpGateConfig.CustomerIDs) ? tmpGateConfig.CustomerIDs : null;
		}
		catch (pError)
		{
			// enrollment gate unknown → suppress the banner rather than mislead
		}
	}

	/**
	 * Configuration/Get returns EITHER { Config, LevelControlRecords } OR the raw config object depending on
	 * the namespace (mirrors ConfigViewer._getConfigAt). Normalize to the config object.
	 * @return {Object}
	 */
	_unwrapConfig(pResult)
	{
		if (pResult && pResult.Config !== undefined)
		{
			return pResult.Config || {};
		}
		return pResult || {};
	}

	/**
	 * The effective enforcement mode for a report action, walking per-report → per-report default → global
	 * default-scope → 'Default'. The Document map is keyed by the raw RNI hash (no `DocumentType-` prefix).
	 * @return {String} Default|Level|Mine|Hybrid|Strict
	 */
	_enforcementModeFor(pRNIHash, pAction)
	{
		const tmpDoc = this.matrix.EnforcementDocument || {};
		const tmpPer = tmpDoc[pRNIHash] && tmpDoc[pRNIHash].Actions;
		const tmpDefault = tmpDoc.DefaultScope && tmpDoc.DefaultScope.Actions;
		return (tmpPer && (tmpPer[pAction] || tmpPer.DefaultAction))
			|| (tmpDefault && (tmpDefault[pAction] || tmpDefault.DefaultAction))
			|| 'Default';
	}

	/**
	 * Set a report's enforcement mode (governs all its actions via Actions.DefaultAction), writing the
	 * PermissionsEnforcement `EnforcementTypes` config at the context scope, then re-reading. Role-manager
	 * gated. The server diffs vs the parent scope (arrays replace, equal values drop).
	 * @param {String} pRNIHash - the raw RNI hash (Document map key)
	 * @param {String} pMode
	 */
	async setEnforcementModeAsync(pRNIHash, pMode)
	{
		const tmpMatrix = this.matrix;
		if (!tmpMatrix.Editable || tmpMatrix.Saving)
		{
			return;
		}
		if (tmpMatrix.EnforcementLoadError)
		{
			tmpMatrix.SaveNotice = tmpMatrix.EnforcementLoadError;
			tmpMatrix.SaveNoticeClass = 'is-warning';
			this._render();
			return;
		}
		const tmpCtx = this.workspace.state.Context;
		const tmpCtxID = Number(this.workspace.state.IDContext) || 0;
		const tmpLevel = this._enforcementScope(tmpCtx, tmpCtxID);
		const tmpConfig = tmpMatrix.EnforcementConfig ? JSON.parse(JSON.stringify(tmpMatrix.EnforcementConfig)) : {};
		if (!tmpConfig.Document) { tmpConfig.Document = {}; }
		if (!tmpConfig.Document[pRNIHash]) { tmpConfig.Document[pRNIHash] = {}; }
		if (!tmpConfig.Document[pRNIHash].Actions) { tmpConfig.Document[pRNIHash].Actions = {}; }
		tmpConfig.Document[pRNIHash].Actions.DefaultAction = pMode;
		tmpMatrix.Saving = true;
		this._render();
		try
		{
			await this._postJSON(`Configuration/Put/PermissionsEnforcement/EnforcementTypes/${tmpLevel.Scope}/${tmpLevel.ScopeID}`, { Config: tmpConfig });
			await this._loadEnforcementAsync(tmpCtx, tmpCtxID);
			tmpMatrix.SaveNotice = `Enforcement for this report set to ${pMode}.`;
			tmpMatrix.SaveNoticeClass = 'is-success is-light';
		}
		catch (pError)
		{
			tmpMatrix.SaveNotice = `Could not set enforcement: ${pError && pError.message ? pError.message : pError}`;
			tmpMatrix.SaveNoticeClass = 'is-warning';
		}
		tmpMatrix.Saving = false;
		this._render();
	}

	// --- Write (grant / deny / clear) ---

	/**
	 * Cycle a single cell (none -> on -> off -> none). No-op when not editable or the cell is unavailable.
	 * @param {String} pHash
	 */
	toggleCell(pHash)
	{
		const tmpMatrix = this.matrix;
		if (!tmpMatrix.Editable)
		{
			return;
		}
		const tmpParsed = libCatalog.parseHash(pHash);
		if (!this.activeSource.hasAction(tmpParsed.Entity, tmpParsed.Action))
		{
			return;
		}
		tmpMatrix.Edits = libMatrixBuilder.toggleCell(pHash, tmpMatrix.GrantHashes, tmpMatrix.DenyHashes, tmpMatrix.Edits);
		this._render();
	}

	/**
	 * Cycle an entire row via its "All" control, by the row's current meta-state. No-op when not editable.
	 * @param {String} pKey - the row key (an entity name, or `DocumentType-<RNI.Hash>`)
	 */
	toggleAll(pKey)
	{
		const tmpMatrix = this.matrix;
		if (!tmpMatrix.Editable)
		{
			return;
		}
		const tmpSource = this.activeSource;
		const tmpCells = tmpSource.actionsForKey(pKey).map((pAction) =>
			(
				{
					Available: true,
					State: libMatrixBuilder.effectiveState(tmpSource.buildHash(pKey, pAction), tmpMatrix.GrantHashes, tmpMatrix.DenyHashes, tmpMatrix.Edits),
				}));
		const tmpNext = libMatrixBuilder.cycleState(libMatrixBuilder.metaState(tmpCells));
		tmpMatrix.Edits = libMatrixBuilder.applyAllToggle(pKey, tmpNext, tmpMatrix.GrantHashes, tmpMatrix.DenyHashes, tmpMatrix.Edits, tmpSource);
		this._render();
	}

	discard()
	{
		this.matrix.Edits = {};
		this.matrix.SaveNotice = '';
		this._render();
	}

	dismissNotice()
	{
		this.matrix.SaveNotice = '';
		this._render();
	}

	/**
	 * Persist the pending edits: each changed cell -> Grant (on) / Deny (off) / delete the RolePermission row
	 * (none), mirroring the home app's PermissionService.savePermissionForRole. Re-reads after to reflect the
	 * server's truth, and reports any rows the server rejected (e.g. a missing Permission-Grant -> 403).
	 */
	async saveAsync()
	{
		const tmpMatrix = this.matrix;
		if (!tmpMatrix.Editable || tmpMatrix.Saving)
		{
			return;
		}
		const tmpEdits = libMatrixBuilder.diffChanges(tmpMatrix.Edits);
		const tmpHashes = Object.keys(tmpEdits);
		if (!tmpHashes.length)
		{
			return;
		}
		tmpMatrix.Saving = true;
		tmpMatrix.SaveNotice = '';
		this._render();

		let tmpFailures = 0;
		for (const tmpHash of tmpHashes)
		{
			try
			{
				await this._saveCell(tmpHash, tmpEdits[tmpHash]);
			}
			catch (pError)
			{
				tmpFailures++;
			}
		}

		tmpMatrix.Saving = false;
		tmpMatrix.Edits = {};
		// Re-read so the grid reflects exactly what persisted.
		await this.loadAsync(true);

		if (tmpFailures > 0)
		{
			tmpMatrix.SaveNotice = `${tmpHashes.length - tmpFailures} change(s) saved; ${tmpFailures} rejected by the server (you may lack Permission-Grant in this context). The grid shows what actually saved.`;
			tmpMatrix.SaveNoticeClass = 'is-warning';
		}
		else
		{
			tmpMatrix.SaveNotice = `Saved ${tmpHashes.length} change(s).`;
			tmpMatrix.SaveNoticeClass = 'is-success is-light';
		}
		this._render();
	}

	/**
	 * Persist one cell. on -> Grant, off -> Deny (both GET endpoints that upsert the RolePermission row),
	 * none -> delete the existing RolePermission row (no-op if there isn't one).
	 * @param {String} pHash
	 * @param {String} pState - 'on' | 'off' | 'none'
	 * @return {Promise}
	 */
	async _saveCell(pHash, pState)
	{
		const tmpMatrix = this.matrix;
		const tmpRole = tmpMatrix.RoleID;
		const tmpContext = tmpMatrix.Context;
		const tmpIDContext = tmpMatrix.IDContext;
		if (pState === 'on')
		{
			return this._getJSON(`Permissions/Grant/${pHash}/To/Role/${tmpRole}/For/${tmpContext}/${tmpIDContext}`);
		}
		if (pState === 'off')
		{
			return this._getJSON(`Permissions/Deny/${pHash}/To/Role/${tmpRole}/For/${tmpContext}/${tmpIDContext}`);
		}
		const tmpRows = await this._getFilteredAll('RolePermissions',
			`FBV~Hash~EQ~${pHash}~FBV~Context~EQ~${tmpContext}~FBV~IDContext~EQ~${tmpIDContext}~FBV~IDRole~EQ~${tmpRole}`, 50);
		if (tmpRows.length && tmpRows[0].IDRolePermission)
		{
			return this._deleteJSON(`RolePermission/${tmpRows[0].IDRolePermission}`);
		}
		return null;
	}

	// --- Derive (pure; called from the workspace render cycle) ---

	/**
	 * Recompute the matrix render slots from the loaded grant/deny sets + the search filter. No network.
	 */
	deriveMatrix()
	{
		const tmpMatrix = this.matrix;
		const tmpSource = this.activeSource;
		const tmpIsReports = (tmpMatrix.CatalogMode === 'reports');
		tmpMatrix.LoadingSlot = (tmpMatrix.Loading || tmpMatrix.ReportsLoading) ? [ {} ] : [];
		tmpMatrix.ErrorSlot = tmpMatrix.Error ? [ { Error: tmpMatrix.Error } ] : [];
		tmpMatrix.Actions = tmpSource.actions().map((pAction) => ({ Action: pAction }));
		tmpMatrix.GrantCount = (tmpMatrix.GrantHashes || []).length;
		tmpMatrix.DenyCount = (tmpMatrix.DenyHashes || []).length;

		// The [ Entities | Reports & Forms ] axis toggle.
		tmpMatrix.ModeSlot = [ { EntitiesClass: tmpIsReports ? '' : 'is-link is-selected', ReportsClass: tmpIsReports ? 'is-link is-selected' : '' } ];
		tmpMatrix.EnforcementHeadSlot = tmpIsReports ? [ {} ] : [];
		tmpMatrix.EnforcementBannerSlot = this._enforcementBanner(tmpIsReports);

		const tmpEditable = !!tmpMatrix.Editable;
		tmpMatrix.EditCount = Object.keys(tmpMatrix.Edits || {}).length;
		tmpMatrix.AllHeadSlot = tmpEditable ? [ {} ] : [];
		tmpMatrix.EditHintSlot = tmpEditable ? [] : [ { Text: 'You can view these permissions but not change them here — editing needs a Role Manager role. The server is the final authority on every change.' } ];
		tmpMatrix.SaveBarSlot = (tmpEditable && tmpMatrix.EditCount > 0) ? [ { EditCount: tmpMatrix.EditCount, SaveDisabledAttr: tmpMatrix.Saving ? 'disabled' : '' } ] : [];
		tmpMatrix.SaveNoticeSlot = tmpMatrix.SaveNotice ? [ { Text: tmpMatrix.SaveNotice, Class: tmpMatrix.SaveNoticeClass || 'is-info' } ] : [];

		if (tmpMatrix.Loading || tmpMatrix.ReportsLoading || tmpMatrix.Error)
		{
			tmpMatrix.GridSlot = [];
			tmpMatrix.NoMatchSlot = [];
			return;
		}

		const tmpBuilt = libMatrixBuilder.buildRows(tmpMatrix.GrantHashes || [], tmpMatrix.DenyHashes || [], tmpMatrix.Edits || {}, tmpSource);
		const tmpSearch = (tmpMatrix.Search || '').toLowerCase().trim();
		const tmpSections = tmpSource.sections().map((pDef) => ({ Key: pDef.Key, Title: pDef.Title, Rows: [] }));
		const tmpByKind = {};
		tmpSections.forEach((pSection) => { tmpByKind[pSection.Key] = pSection; });

		tmpBuilt.rows.forEach((pRow) =>
		{
			if (tmpSearch && pRow.Entity.toLowerCase().indexOf(tmpSearch) < 0)
			{
				return;
			}
			(tmpByKind[pRow.Kind] || tmpSections[0]).Rows.push(this._decorateRow(pRow, tmpEditable, tmpIsReports));
		});

		tmpMatrix.Sections = tmpSections
			.filter((pSection) => pSection.Rows.length > 0)
			.map((pSection) => ({ Title: pSection.Title, RowCount: pSection.Rows.length, Rows: pSection.Rows }));
		tmpMatrix.GridSlot = tmpMatrix.Sections.length ? [ {} ] : [];
		tmpMatrix.NoMatchSlot = tmpMatrix.Sections.length ? [] : [ {} ];
	}

	/**
	 * The "enforcement is off for this customer" banner (reports mode only) — even a Strict grant is inert
	 * until the customer is enrolled in PermissionsEnforcement → Configuration.CustomerIDs.
	 * @return {Array}
	 */
	_enforcementBanner(pIsReports)
	{
		if (!pIsReports || this.matrix.EnforcementCustomerIDs === null)
		{
			return [];
		}
		const tmpCustomer = Number(this.workspace.idCustomer);
		const tmpEnrolled = (this.matrix.EnforcementCustomerIDs || []).map(Number).indexOf(tmpCustomer) > -1;
		return tmpEnrolled ? [] : [ { Text: 'Permissions enforcement is not enabled for this customer — report grants below will not restrict access until the customer is added to PermissionsEnforcement → Configuration.CustomerIDs.' } ];
	}

	_decorateRow(pRow, pEditable, pIsReports)
	{
		return {
			Entity: pRow.Entity,
			Key: pRow.Key,
			AllSlot: pEditable ? [ this._decorateAll(pRow) ] : [],
			Cells: pRow.Cells.map((pCell) => this._decorateCell(pCell, pEditable)),
			EnforceSlot: pIsReports ? [ this._decorateEnforcement(pRow, pEditable) ] : [],
		};
	}

	/**
	 * The per-row "All" control (editable mode): its icon/class/tooltip reflect the row's meta-state. Its
	 * `Entity` field carries the row KEY (the toggleAll argument), which for a report is `DocumentType-<Hash>`.
	 * @param {Object} pRow
	 * @return {Object}
	 */
	_decorateAll(pRow)
	{
		if (pRow.MetaState === 'on')
		{
			return { Entity: pRow.Key, CellClass: 'acw-cell acw-cell-clickable acw-cell-on', Icon: '<i class="fas fa-circle-check"></i>', Title: 'All granted — click to deny all' };
		}
		if (pRow.MetaState === 'off')
		{
			return { Entity: pRow.Key, CellClass: 'acw-cell acw-cell-clickable acw-cell-off', Icon: '<i class="fas fa-ban"></i>', Title: 'All denied — click to clear all' };
		}
		return { Entity: pRow.Key, CellClass: 'acw-cell acw-cell-clickable acw-cell-none', Icon: '<i class="far fa-circle acw-faint"></i>', Title: 'Click to grant all' };
	}

	/**
	 * The per-report enforcement cell (reports mode): the effective mode (a picker when editable, a badge
	 * otherwise) + an "inert" flag when the mode is Default so grants that don't bite are obvious.
	 * @param {Object} pRow
	 * @param {Boolean} pEditable
	 * @return {Object}
	 */
	_decorateEnforcement(pRow, pEditable)
	{
		const tmpRNIHash = pRow.Key.slice(libCatalog.REPORT_ENTITY_PREFIX.length);
		const tmpMode = this._enforcementModeFor(tmpRNIHash, 'View');
		const tmpInert = (tmpMode === 'Default');
		const tmpLoadError = this.matrix.EnforcementLoadError;
		if (tmpLoadError)
		{
			return { RNIHash: tmpRNIHash, Mode: 'Unknown', InertSlot: [], EditSlot: [], ReadSlot: [ { Mode: 'Unknown', BadgeClass: 'is-danger is-light', Title: tmpLoadError } ] };
		}
		return {
			RNIHash: tmpRNIHash,
			Mode: tmpMode,
			InertSlot: tmpInert ? [ {} ] : [],
			EditSlot: pEditable ? [ { RNIHash: tmpRNIHash, Options: ENFORCEMENT_MODES.map((pMode) => ({ Value: pMode, Label: pMode, SelectedAttr: (pMode === tmpMode) ? 'selected' : '' })) } ] : [],
			ReadSlot: pEditable ? [] : [ { Mode: tmpMode, BadgeClass: tmpInert ? 'is-light' : 'is-warning is-light', Title: '' } ],
		};
	}

	/**
	 * Turn a builder cell into its display (icon + class + tooltip). Unavailable cells render a faint dash;
	 * on = green check, off = red ban, none = blank (a faint target when editable). Editable + available cells
	 * carry the clickable affordance; a pending (unsaved) edit is ringed.
	 * @param {Object} pCell
	 * @param {Boolean} pEditable
	 * @return {Object}
	 */
	_decorateCell(pCell, pEditable)
	{
		if (!pCell.Available)
		{
			return { Hash: pCell.Hash, CellClass: 'acw-cell acw-cell-na', Icon: '<span class="acw-dash">–</span>', Title: '' };
		}
		const tmpClickable = pEditable ? ' acw-cell-clickable' : '';
		const tmpChanged = pCell.Changed ? ' acw-cell-changed' : '';
		if (pCell.State === 'on')
		{
			return { Hash: pCell.Hash, CellClass: `acw-cell acw-cell-on${tmpClickable}${tmpChanged}`, Icon: '<i class="fas fa-circle-check"></i>', Title: `Granted: ${pCell.Hash}` };
		}
		if (pCell.State === 'off')
		{
			return { Hash: pCell.Hash, CellClass: `acw-cell acw-cell-off${tmpClickable}${tmpChanged}`, Icon: '<i class="fas fa-ban"></i>', Title: `Denied: ${pCell.Hash}` };
		}
		return { Hash: pCell.Hash, CellClass: `acw-cell acw-cell-none${tmpClickable}${tmpChanged}`, Icon: pEditable ? '<i class="far fa-circle acw-faint"></i>' : '', Title: `No rule: ${pCell.Hash}` };
	}

	_render()
	{
		if (this.pict.views.AccessWorkspace)
		{
			this.pict.views.AccessWorkspace.render();
		}
	}
}

module.exports = PermissionMatrixProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'PermissionMatrix',
	AutoInitialize: true,
	AutoInitializeOrdinal: 1,
};

},{"../access/Access-Matrix-Builder.js":1056,"../access/Permission-Catalog.js":1060,"pict-provider":845}],1356:[function(require,module,exports){

const libPictProvider = require('pict-provider');

const libCatalog = require('../access/Permission-Catalog.js');

/**
 * PermissionVisualizer — the Effective tab of the Access workspace.
 *
 * Shows the RESOLVED effective permissions for the selected subject, with provenance, grouped by CONTEXT:
 *   - User subject: every context the user holds a role in (Global + each project / contract / lab) as an
 *     expandable section, each listing every explicitly granted / denied permission with the implying
 *     role/membership. Any row drills to the full Explain ("why?") trace. This is the direct answer to
 *     "everything this user can/can't do, across their projects, and why".
 *   - Role/Group subject: the role's effective set in the workspace context, each grant tagged Direct vs
 *     Inherited (from an included permission group), as a single section.
 *
 * Read-only. It does NOT call the Permissions/* endpoints itself — it depends only on the
 * EffectivePermissionsService fable service (the swap seam), so a future server aggregation endpoint can
 * replace the service internals without touching this provider or the view. Subject + context come from the
 * AccessWorkspace provider; this owns AppData.AccessWorkspace.Effective.
 */
class PermissionVisualizerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get workspace()
	{
		return this.pict.providers.AccessWorkspace;
	}

	get service()
	{
		return this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
	}

	/**
	 * The Effective slice of the shared workspace AppData (lazily created).
	 * @return {Object}
	 */
	get visualizer()
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.Effective)
		{
			tmpWorkspaceState.Effective =
			{
				SubjectKind: '', SubjectID: 0, Context: '', IDContext: 0, Loading: false, Loaded: false, Error: '', Search: '',
				Matrix: { Contexts: [], Permissions: {}, Summary: null }, Explain: null,
				Sections: [], SummarySlot: [], LoadingSlot: [], ErrorSlot: [], NoMatchSlot: [], ExplainSlot: [],
			};
		}
		return tmpWorkspaceState.Effective;
	}

	// --- Load (via the service) ---

	/**
	 * Resolve the effective matrix for the workspace's current subject. For a user this is every context they
	 * belong to; for a role/group it is the workspace context. Skips the fetch when nothing relevant changed.
	 * @param {Boolean} [pForce]
	 */
	async loadAsync(pForce)
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.SubjectRecord)
		{
			return;
		}
		const tmpKind = tmpWorkspaceState.SubjectKind;
		const tmpID = Number(tmpWorkspaceState.SubjectID);
		const tmpContext = tmpWorkspaceState.Context;
		const tmpIDContext = Number(tmpWorkspaceState.IDContext);
		const tmpVisualizer = this.visualizer;

		// A user's effective view spans ALL contexts, so it is independent of the workspace context bar; a
		// role's is scoped to the chosen context.
		const tmpUnchanged = tmpVisualizer.Loaded && !pForce &&
			(tmpVisualizer.SubjectKind === tmpKind) && (tmpVisualizer.SubjectID === tmpID) &&
			((tmpKind === 'user') || ((tmpVisualizer.Context === tmpContext) && (tmpVisualizer.IDContext === tmpIDContext)));
		if (tmpUnchanged)
		{
			this._render();
			return;
		}

		tmpVisualizer.SubjectKind = tmpKind;
		tmpVisualizer.SubjectID = tmpID;
		tmpVisualizer.Context = tmpContext;
		tmpVisualizer.IDContext = tmpIDContext;
		tmpVisualizer.Loaded = false;
		tmpVisualizer.Error = '';
		tmpVisualizer.Explain = null;
		tmpVisualizer.Matrix = { Contexts: [], Permissions: {}, Summary: null };

		if (tmpKind !== 'user' && !tmpIDContext)
		{
			tmpVisualizer.Loading = false;
			tmpVisualizer.Error = `Enter a ${tmpContext} ID above to resolve permissions.`;
			this._render();
			return;
		}
		if (!this.service)
		{
			tmpVisualizer.Loading = false;
			tmpVisualizer.Error = 'The effective-permissions service is not available.';
			this._render();
			return;
		}

		tmpVisualizer.Loading = true;
		this._render();
		try
		{
			const tmpResult = (tmpKind === 'user')
				? await this.service.resolveUserMatrixAsync(tmpID, {})
				: await this.service.resolveRoleMatrixAsync(tmpID, tmpContext, tmpIDContext, tmpWorkspaceState.SubjectRecord);
			tmpVisualizer.Matrix = { Contexts: tmpResult.Contexts || [], Permissions: tmpResult.Permissions || {}, Summary: tmpResult.Summary || null };
			tmpVisualizer.Loaded = true;
		}
		catch (pError)
		{
			tmpVisualizer.Error = `Could not resolve permissions: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpVisualizer.Loading = false;
		this._render();
	}

	setSearch(pValue)
	{
		this.visualizer.Search = pValue || '';
		this._render();
	}

	/**
	 * Explain a single permission for the current user subject in a specific context (the "why?" drilldown).
	 * @param {String} pHash
	 * @param {String} pContext
	 * @param {Number} pIDContext
	 */
	async explainAsync(pHash, pContext, pIDContext)
	{
		const tmpVisualizer = this.visualizer;
		if (tmpVisualizer.SubjectKind !== 'user' || !this.service)
		{
			return;
		}
		tmpVisualizer.Explain = { Hash: pHash, Context: pContext, IDContext: pIDContext, Loading: true };
		this._render();
		try
		{
			const tmpResult = await this.service.explainAsync(tmpVisualizer.SubjectID, pHash, pContext, pIDContext);
			tmpVisualizer.Explain = { Hash: pHash, Loading: false, Result: tmpResult };
		}
		catch (pError)
		{
			tmpVisualizer.Explain = { Hash: pHash, Loading: false, Error: `Could not explain: ${pError && pError.message ? pError.message : pError}` };
		}
		this._render();
	}

	closeExplain()
	{
		this.visualizer.Explain = null;
		this._render();
	}

	// --- Derive (pure; called from the workspace render cycle) ---

	/**
	 * Recompute the visualizer render model: one section per context, each a filtered list of resolved
	 * permissions with provenance. No network.
	 */
	deriveVisualizer()
	{
		const tmpVisualizer = this.visualizer;
		tmpVisualizer.LoadingSlot = tmpVisualizer.Loading ? [ {} ] : [];
		tmpVisualizer.ErrorSlot = tmpVisualizer.Error ? [ { Error: tmpVisualizer.Error } ] : [];
		tmpVisualizer.ExplainSlot = this._deriveExplainSlot(tmpVisualizer);

		if (tmpVisualizer.Loading || tmpVisualizer.Error)
		{
			tmpVisualizer.Sections = [];
			tmpVisualizer.NoMatchSlot = [];
			tmpVisualizer.SummarySlot = [];
			return;
		}

		const tmpMatrix = tmpVisualizer.Matrix || { Contexts: [], Permissions: {} };
		const tmpSearch = (tmpVisualizer.Search || '').toLowerCase().trim();
		const tmpAllSections = (tmpMatrix.Contexts || []).map((pCtx) => this._buildSection(pCtx, tmpMatrix.Permissions, tmpSearch, tmpVisualizer.SubjectKind));
		const tmpVisible = tmpAllSections.filter((pSection) => (pSection.Rows.length > 0) || !tmpSearch);
		tmpVisualizer.Sections = tmpVisible;
		tmpVisualizer.NoMatchSlot = tmpVisible.length ? [] : [ {} ];

		let tmpAllowed = 0;
		let tmpDenied = 0;
		tmpAllSections.forEach((pSection) => { tmpAllowed += pSection.Allowed; tmpDenied += pSection.Denied; });
		if (tmpVisualizer.SubjectKind === 'user')
		{
			tmpVisualizer.SummarySlot = [ { Text: `${(tmpMatrix.Contexts || []).length} context(s) · ${tmpAllowed} granted · ${tmpDenied} denied` } ];
		}
		else if (tmpMatrix.Summary)
		{
			tmpVisualizer.SummarySlot = [ { Text: `${tmpMatrix.Summary.Total || 0} effective (${tmpMatrix.Summary.Direct || 0} direct · ${tmpMatrix.Summary.Inherited || 0} inherited)` } ];
		}
		else
		{
			tmpVisualizer.SummarySlot = [];
		}
	}

	/**
	 * Build a context section: its header (label + membership badges + counts) + the filtered permission rows.
	 * @return {Object}
	 */
	_buildSection(pCtx, pPermissions, pSearch, pSubjectKind)
	{
		const tmpKey = `${pCtx.Context}:${pCtx.IDContext}`;
		const tmpPerms = (pPermissions && pPermissions[tmpKey]) || {};
		const tmpHashes = Object.keys(tmpPerms).sort();
		const tmpRows = [];
		let tmpAllowed = 0;
		let tmpDenied = 0;
		tmpHashes.forEach((pHash) =>
		{
			const tmpEntry = tmpPerms[pHash];
			if (tmpEntry.Allowed) { tmpAllowed++; } else { tmpDenied++; }
			if (pSearch && pHash.toLowerCase().indexOf(pSearch) < 0)
			{
				return;
			}
			tmpRows.push(this._permissionRow(pHash, tmpEntry, pCtx, pSubjectKind));
		});
		const tmpMembers = (pCtx.MembershipVia || []).map((pMember) => ({ Label: pMember.RoleName, IDRole: pMember.IDRole, Type: pMember.MembershipType }));
		return {
			Key: tmpKey,
			Label: pCtx.Label,
			Context: pCtx.Context,
			IDContext: pCtx.IDContext,
			Allowed: tmpAllowed,
			Denied: tmpDenied,
			Total: tmpHashes.length,
			MemberSlot: tmpMembers.length ? [ { Members: tmpMembers } ] : [],
			SuperSlot: pCtx.IsSuperUser ? [ {} ] : [],
			Rows: tmpRows,
			EmptySlot: tmpRows.length ? [] : [ {} ],
		};
	}

	/**
	 * A single resolved-permission row: entity·action, allow/deny status, the implying source, and (user
	 * subjects) a "why?" drill.
	 * @return {Object}
	 */
	_permissionRow(pHash, pEntry, pCtx, pSubjectKind)
	{
		const tmpParsed = libCatalog.parseHash(pHash);
		const tmpAllowed = !!pEntry.Allowed;
		const tmpSource = pEntry.Source || 'Default';
		let tmpSourceLabel = tmpSource;
		let tmpSourceClass = 'is-light';
		if (tmpSource === 'RolePermission' || tmpSource === 'Role')
		{
			tmpSourceLabel = pEntry.RoleName ? `role: ${pEntry.RoleName}` : 'role';
			tmpSourceClass = 'is-info is-light';
		}
		else if (tmpSource === 'UserOverride' || tmpSource === 'Override')
		{
			tmpSourceLabel = 'user override';
			tmpSourceClass = 'is-warning is-light';
		}
		else if (tmpSource === 'Inherited')
		{
			tmpSourceLabel = 'inherited';
			tmpSourceClass = 'is-link is-light';
		}
		else if (tmpSource === 'Direct')
		{
			tmpSourceLabel = 'direct';
			tmpSourceClass = 'is-info is-light';
		}
		else if (tmpSource === 'Default')
		{
			tmpSourceLabel = tmpAllowed ? 'default (super-user)' : 'default';
			tmpSourceClass = 'is-light';
		}
		return {
			Hash: pHash,
			Entity: tmpParsed.Entity,
			Action: tmpParsed.Action,
			Context: pCtx.Context,
			IDContext: pCtx.IDContext,
			RowClass: tmpAllowed ? 'acw-eff-allow' : 'acw-eff-deny',
			StatusIcon: tmpAllowed ? '<i class="fas fa-circle-check has-text-success"></i>' : '<i class="fas fa-ban has-text-danger"></i>',
			SourceLabel: tmpSourceLabel,
			SourceClass: tmpSourceClass,
			WhySlot: (pSubjectKind === 'user') ? [ { Hash: pHash, Context: pCtx.Context, IDContext: pCtx.IDContext } ] : [],
		};
	}

	_deriveExplainSlot(pVisualizer)
	{
		const tmpExplain = pVisualizer.Explain;
		if (!tmpExplain)
		{
			return [];
		}
		return [
			{
				Hash: tmpExplain.Hash,
				LoadingSlot: tmpExplain.Loading ? [ {} ] : [],
				ErrorSlot: tmpExplain.Error ? [ { Error: tmpExplain.Error } ] : [],
				Lines: (!tmpExplain.Loading && !tmpExplain.Error) ? this._explainLines(tmpExplain.Result) : [],
			},
		];
	}

	/**
	 * Flatten an Explain result into readable trace lines.
	 * @param {Object} pResult
	 * @return {Array<Object>}
	 */
	_explainLines(pResult)
	{
		const tmpLines = [];
		if (!pResult)
		{
			return tmpLines;
		}
		const tmpDecided = pResult.DecidedBy || {};
		tmpLines.push({ Class: pResult.Allowed ? 'has-text-success' : 'has-text-danger', Text: `${pResult.Allowed ? 'ALLOWED' : 'DENIED'} — decided by ${tmpDecided.Step || '(unknown)'}${tmpDecided.RoleName ? ` (${tmpDecided.RoleName})` : ''}` });
		(pResult.Trace || []).forEach((pStep) =>
		{
			const tmpCount = (pStep.Records || []).length;
			let tmpDetail = pStep.Description || pStep.Step;
			if (pStep.Step === 'RolePermission' && pStep.Roles)
			{
				tmpDetail += ` — roles: ${(pStep.Roles).map((pRole) => pRole.Name).join(', ') || 'none'}`;
			}
			if (pStep.Step === 'Default')
			{
				tmpDetail += ` — ${pStep.IsSuperUser ? 'super-user' : 'not a super-user'}`;
			}
			tmpLines.push({ Class: 'has-text-grey', Text: `${pStep.Step}: ${tmpDetail}${tmpCount ? ` (${tmpCount} record${tmpCount === 1 ? '' : 's'})` : ''}` });
		});
		return tmpLines;
	}

	// --- Navigation helper ---

	selectRole(pID)
	{
		if (Number(pID) > 0)
		{
			this.workspace.selectRoleAsync(pID);
		}
	}

	_render()
	{
		if (this.pict.views.AccessWorkspace)
		{
			this.pict.views.AccessWorkspace.render();
		}
	}
}

module.exports = PermissionVisualizerProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'PermissionVisualizer',
	AutoInitialize: true,
	AutoInitializeOrdinal: 2,
};

},{"../access/Permission-Catalog.js":1060,"pict-provider":845}],1357:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libPictRouter = require('pict-router');

class PlatformConfigurationRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.currentView = 'unknown';
		// Settings (the full configuration browser) is the landing.
		this.defaultRoute = 'Settings';
		this.cachedLogoutRoute = false;

		// Monotonic navigation token for the "latest-wins" render guard. Every route
		// change (app + PSRS) advances it via the before-hook; each dispatched view is
		// stamped with the token current at dispatch, and a view skips its DOM
		// projection if the token has advanced by the time its async data resolves.
		// This stops slow, still-in-flight dashboard renders from flashing over (or
		// landing on top of) the screen the user actually navigated to last.
		this._routeToken = 0;

		/** @type {any} */
		this.pict;

		if (!('PictRouter' in this.pict.providers))
		{
			// SkipRouteResolveOnAdd ensures the router does NOT resolve the current
			// URL as each route is registered. Without it, the first route added
			// ('/') resolves immediately and navigates to the default Dashboard view
			// before the route the user actually deep-linked to has been registered,
			// causing the initial route to load ahead of the intended one. The app
			// performs a single explicit resolve once every route (including the PSRS
			// routes) is registered after login.
			this.pict.addProvider('PictRouter', { SkipRouteResolveOnAdd: true }, libPictRouter);
		}

		// Reusable "Dashboard Mode": any top-level view that sets `DashboardMode: true` in its configuration renders
		// edge-to-edge at the full browser width (no content gutters). The before-hook clears the mode on every
		// navigation and _renderRouteView re-applies it for dashboard views, so it is self-cleaning. See _applyDashboardMode.
		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('PlatformConfig-DashboardMode-CSS', _DASHBOARD_MODE_CSS, 400);
		}

		this.router.hooks(
		{
			before: async (next, params) =>
			{
				if (!this._confirmLeavingApprovalWorkflowEdits())
				{
					return next(false);
				}
				// Advance the navigation token for EVERY route change (including PSRS
				// routes, which are handled by the RecordSetRouter) so any view render
				// already in flight can detect it has been superseded — see _routeToken.
				this._routeToken++;
				// Dashboard Mode is off by default; _renderRouteView re-enables it for a DashboardMode view. Clearing here
				// (on every navigation, including routes that bypass _renderRouteView like the workspace) keeps it from lingering.
				this._applyDashboardMode(false);
				if (params?.url == 'Logout')
				{
					return next();
				}
				// Safety net: make sure AppData.CurrentUser is populated before a route
				// handler runs (handlers and the profile chrome read it). Only fetches
				// once — after login CurrentUser is already set, so normal navigation
				// does not incur a round-trip.
				if (!this.AppData.CurrentUser)
				{
					await new Promise((resolve) =>
					{
						this.pict.RestClient.getJSON('/1.0/CheckSession', (pError, pResponse, pBody) =>
						{
							if (pBody?.LoggedIn)
							{
								this.AppData.CurrentUser = pBody;
							}
							resolve();
						});
					});
				}
				// Route-aware help: if the documentation panel is open, point it at the
				// topic mapped to the new route (no-op while the panel is closed).
				if (this.pict.PictApplication && typeof this.pict.PictApplication.updateHelpForRoute === 'function')
				{
					this.pict.PictApplication.updateHelpForRoute();
				}
				// keep the docked navigation rail's active
				// highlight in step with the current route (no-op for page styles).
				if (this.pict.PictApplication && typeof this.pict.PictApplication.syncNavSidebarActive === 'function')
				{
					this.pict.PictApplication.syncNavSidebarActive();
				}
				// Keep the "editing the template for <type>" return banner in step with the route.
				if (this.pict.PictApplication && typeof this.pict.PictApplication.syncTemplateContextBanner === 'function')
				{
					this.pict.PictApplication.syncTemplateContextBanner();
				}
				next();
			},
		});
	}

	get pictRouter()
	{
		return this.pict.providers.PictRouter;
	}

	get router()
	{
		return this.pictRouter.router;
	}

	/**
	 * Resolve the route currently in the browser hash, falling back to the
	 * default route when the hash is empty. Call this once after every route
	 * (application + PSRS) is registered so deep-links land on their intended
	 * view without first rendering the default route.
	 */
	resolveCurrentRoute()
	{
		if (!this.pictRouter.navigateCurrent())
		{
			if (this.cachedLogoutRoute)
			{
				const tmpCachedRoute = this.cachedLogoutRoute;
				this.cachedLogoutRoute = false;
				this.router.navigate(tmpCachedRoute);
			}
			else
			{
				this.router.navigate(this.defaultRoute);
			}
		}
		// If a raced navigation strands the boot splash (nothing painted the container), re-resolve.
		this._armBootSplashWatchdog();
	}

	/**
	 * Ask before navigation throws away unsaved approval workflow edits. The hash has already changed when the router's
	 * before-hook runs, so declining puts it back without firing another route, which would reload over the edits.
	 *
	 * @return {boolean} true if navigation may proceed
	 */
	_confirmLeavingApprovalWorkflowEdits()
	{
		const tmpProvider = this.pict.providers.ApprovalWorkflow;
		const tmpView = this.pict.views.ApprovalWorkflowEditor;
		if ((this.currentView !== 'ApprovalWorkflowEditor') || !tmpProvider || !(tmpProvider.hasUnsavedEdits() || (tmpView && tmpView.hasPendingPanelEdits())))
		{
			return true;
		}
		if (window.confirm('This approval workflow has unsaved changes. Leave without saving them?'))
		{
			tmpProvider.state.Editor.Dirty = false;
			return true;
		}
		const tmpEditor = tmpProvider.state.Editor;
		const tmpProjectPath = tmpEditor.IDProject ? `/Project/${tmpEditor.IDProject}` : '';
		window.history.replaceState(null, '', tmpEditor.IsNew ? '#/ApprovalWorkflow/New' : `#/ApprovalWorkflow/${encodeURIComponent(tmpEditor.Hash)}${tmpProjectPath}`);
		return false;
	}

	/**
	 * Render a routed view with the latest-wins guard applied. Stamps the view with the
	 * navigation token current at dispatch so a slower, earlier render drops its paint if
	 * the user has navigated again before its data resolved. Use this from every route
	 * handler instead of calling the view's renderAsync directly.
	 *
	 * @param {string} pViewIdentifier - The view to render into the application container.
	 */
	_renderRouteView(pViewIdentifier)
	{
		const tmpView = this.pict.views[pViewIdentifier];
		if (!tmpView)
		{
			this.pict.log.warn(`Route view not found: ${pViewIdentifier}`);
			return;
		}
		// Full-browser-width Dashboard Mode when this view opts in (config `DashboardMode: true`).
		this._applyDashboardMode(!!(tmpView.options && tmpView.options.DashboardMode));
		this._installLatestWinsGuard(tmpView);
		// Stamp with the token set by the before-hook for THIS navigation.
		tmpView._platformConfigRenderToken = this._routeToken;
		tmpView.renderAsync((pRenderError) =>
		{
			if (pRenderError)
			{
				this.pict.log.error(`Error rendering ${pViewIdentifier} view: ${pRenderError}`);
			}
		});
	}

	/**
	 * Toggle the app-shell "Dashboard Mode" — a reusable full-browser-width layout for dashboard screens. When on, the
	 * `.app-wrapper-container.is-dashboard` CSS drops the content gutters + lifts the `.container` max-width so the active
	 * view spans edge to edge. Opt in per view with `DashboardMode: true`; the before-hook clears it on every navigation.
	 * @param {boolean} pOn
	 */
	_applyDashboardMode(pOn)
	{
		try
		{
			if (typeof document === 'undefined') { return; }
			const tmpWrapper = document.querySelector('.app-wrapper-container');
			if (tmpWrapper) { tmpWrapper.classList.toggle('is-dashboard', !!pOn); }
		}
		catch (pError) { /* best-effort — layout falls back to the standard gutters */ }
	}

	/**
	 * Idempotently wrap a view's onProjectAsync so it skips the DOM projection when a newer
	 * navigation has advanced the token since this render started. The async work (data
	 * fetch in onBeforeRenderAsync) still completes; only the paint is dropped, so a stale
	 * dashboard never flashes over the current one. Chart building in onAfterRender is
	 * already canvas-null-safe, so a dropped paint leaves no orphaned charts.
	 *
	 * @param {any} pView
	 */
	_installLatestWinsGuard(pView)
	{
		if (pView._platformConfigLatestWinsGuarded)
		{
			return;
		}
		pView._platformConfigLatestWinsGuarded = true;
		const tmpRouter = this;
		const fOriginalOnProjectAsync = pView.onProjectAsync.bind(pView);
		pView.onProjectAsync = function (fCallback, pRenderable)
		{
			if (pView._platformConfigRenderToken !== tmpRouter._routeToken)
			{
				// Superseded by a newer navigation — normally drop this stale paint to avoid a stale
				// view flashing over the current one. BUT if the boot splash is still up, nothing else
				// has painted the container yet: dropping here strands the "Loading…" spinner forever
				// (the classic infinite-spinner — a raced navigation, e.g. a PSRS list Search+Apply pair
				// or the login double-cycle restoring a list route, advances the token before this first
				// paint lands). A slightly-stale first paint is strictly better than a dead spinner, so
				// paint anyway while the splash is present; mid-session (no splash) the latest-wins drop
				// still stands.
				if (!tmpRouter._bootSplashPresent())
				{
					return fCallback();
				}
			}
			return fOriginalOnProjectAsync(fCallback, pRenderable);
		};
	}

	/**
	 * Is the boot "Loading…" splash still occupying the application container? (Shown at boot/login and
	 * only removed when the first routed view paints — so its lingering presence means no view has painted.)
	 * @return {boolean}
	 */
	_bootSplashPresent()
	{
		if (typeof document === 'undefined') { return false; }
		const tmpContainer = document.querySelector('#PlatformConfiguration-Application-Container');
		if (!tmpContainer) { return false; }
		const tmpSplash = tmpContainer.querySelector('.is-loading-splash');
		return !!(tmpSplash && !tmpSplash.classList.contains('is-hidden'));
	}

	/**
	 * Backstop for the infinite spinner: after resolving a route, if the boot splash is STILL up a beat
	 * later, a paint was never dispatched (not just dropped) — re-resolve the current hash once (fresh
	 * token, no competing navigation this time) so it paints. Bounded retries; disarms as soon as the
	 * splash clears. No-op on every healthy boot (the splash is already gone).
	 */
	_armBootSplashWatchdog()
	{
		if (typeof setTimeout === 'undefined') { return; }
		if (this._bootSplashTimer) { clearTimeout(this._bootSplashTimer); }
		this._bootSplashTimer = setTimeout(() =>
		{
			this._bootSplashTimer = null;
			if (!this._bootSplashPresent())
			{
				// Healthy boot: a view painted over the splash. Reset the retry counter and clear the
				// one-reload guard so a FUTURE stuck boot can recover again.
				this._bootSplashRetries = 0;
				try { if ((typeof window !== 'undefined') && window.sessionStorage) { window.sessionStorage.removeItem('PCApp-BootSplashReloaded'); } } catch (pError) { /* best effort */ }
				return;
			}
			this._bootSplashRetries = (this._bootSplashRetries || 0) + 1;
			if (this._bootSplashRetries <= 2)
			{
				// A raced/never-dispatched first paint left the splash up. Re-resolve the current hash
				// (fresh token; the guard above now lets a paint land while the splash is present).
				this.pict.log.warn(`Boot splash still up after route resolve — re-resolving the current route (attempt ${this._bootSplashRetries}).`);
				this.pictRouter.navigateCurrent();
				this._armBootSplashWatchdog();
				return;
			}
			// Last resort: re-resolves couldn't clear it (e.g. a paint that never dispatched, or a view
			// the app router's guard doesn't own). A stuck boot splash means nothing is in progress to
			// lose, so hard-reload ONCE to recover — guarded by sessionStorage so it can never loop.
			try
			{
				if ((typeof window !== 'undefined') && window.sessionStorage && (window.sessionStorage.getItem('PCApp-BootSplashReloaded') === '1'))
				{
					this.pict.log.error('Boot splash still stuck after a recovery reload — not reloading again (avoiding a loop).');
					return;
				}
				if ((typeof window !== 'undefined') && window.sessionStorage) { window.sessionStorage.setItem('PCApp-BootSplashReloaded', '1'); }
				this.pict.log.error('Boot splash stuck after re-resolve retries — hard-reloading once to recover.');
				if ((typeof window !== 'undefined') && window.location && (typeof window.location.reload === 'function')) { window.location.reload(); }
			}
			catch (pError) { /* best effort */ }
		}, 900);
	}

	onBeforeLoadDataAsync(fCallback)
	{
		super.onBeforeLoadDataAsync((pError) =>
		{
			this.pictRouter.addRoute('/',
			(pRouteData) =>
			{
				if (this.pict.PictApplication.loggedIn)
				{
					if (this.cachedLogoutRoute)
					{
						const tmpCachedRoute = this.cachedLogoutRoute;
						this.cachedLogoutRoute = false;
						this.router.navigate(tmpCachedRoute);
					}
					else
					{
						this.router.navigate(this.defaultRoute);
					}
				}
				else
				{
					this.pict.views.Empty.renderAsync();
				}
			});

			this.pictRouter.addRoute('/Logout',
			(pRouteData) =>
			{
				// The Logout link is `href="#/Logout" onclick="logout()"`, so this route resolves while the
				// real logout (Deauthenticate -> loginAsync) is in flight, and again — critically — when the
				// user logs back in: onAfterLoginAsync -> resolveCurrentRoute() re-resolves whatever hash is
				// still in the bar, which is #/Logout. This handler renders nothing, so without the redirect
				// below the user lands on a blank screen after re-login.
				//
				// Remember where they were so a re-login returns them there, then: if the session is live
				// (the pre-Deauthenticate instant OR the post-re-login resolve), bounce off the empty Logout
				// route to that cached route (or the default). While genuinely logged out, do nothing — the
				// login modal that onLoginAsync shows owns the screen.
				const tmpCurrentRoute = this.router.lastResolved();
				if (tmpCurrentRoute && tmpCurrentRoute.length > 0)
				{
					const tmpHash = tmpCurrentRoute[0].hashString;
					if (tmpHash && (tmpHash !== '/Logout'))
					{
						this.cachedLogoutRoute = tmpHash;
					}
				}
				if (this.pict.PictApplication.loggedIn)
				{
					const tmpTarget = this.cachedLogoutRoute || this.defaultRoute;
					this.cachedLogoutRoute = false;
					this.router.navigate(tmpTarget);
				}
			});

			// The KPI-tile Dashboard view was removed (several of its stats were unreliable). Keep the route
			// as a redirect to the configuration home so old bookmarks and the project-clone return link
			// still land somewhere real instead of a dead hash.
			this.pictRouter.addRoute('/Dashboard',
			(pRouteData) =>
			{
				this.router.navigate(this.defaultRoute);
			});

			// Settings = the full configuration browser (every category + the navigation-style chooser) and
			// the landing. #/Configurations stays as an alias so old links keep working. Both render the
			// pict-section-navigation switcher view (falls back to ConfigurationIndex if the nav provider is absent).
			const fRenderSettings = () =>
			{
				this.currentView = 'Settings';
				this._renderRouteView(this.pict.providers['Pict-Navigation'] ? 'ConfigurationNavigation' : 'ConfigurationIndex');
			};
			this.pictRouter.addRoute('/Settings', fRenderSettings);
			this.pictRouter.addRoute('/Configurations', fRenderSettings);

			// top-level header destinations — scoped topic pages. Each sets the current topic (KPI jumbotron
			// + pre-filtered nav scope) and renders TopicPage. (Settings is the catch-all above, not here.)
			const tmpTopics = require('../navigation-topics.js').TOPIC_CONFIGS;
			[ 'Users', 'Projects', 'Observations', 'Documents', 'Database' ].forEach((pKey) =>
			{
				this.pictRouter.addRoute(tmpTopics[pKey].Route.replace(/^#/, ''),
				(pRouteData) =>
				{
					this.currentView = pKey;
					this.pict.AppData.CurrentTopic = tmpTopics[pKey];
					this._renderRouteView(this.pict.providers['Pict-Navigation'] ? 'TopicPage' : 'ConfigurationIndex');
				});
			});

			// RETIRED (destructive): the Contract Administration Setup screen did full-replace Configuration/Put writes
			// against the operator's OWN customer — wiping their config (incl. the whole AppDashboards/HeadLight dashboard
			// set). It is being replaced by a non-destructive per-customer action in the Customer workspace Modules tab.
			// Neutralize it now: redirect any direct hit to the Customers dashboard and never render the destructive view.
			this.pictRouter.addRoute('/ContractAdmin',
			() => { if ((typeof window !== 'undefined') && window.location) { window.location.hash = '#/Customers'; } });

			this.pictRouter.addRoute('/CustomerProvisioning',
			(pRouteData) =>
			{
				this.currentView = 'CustomerProvisioning';
				this._renderRouteView('CustomerProvisioning');
			});

			// Internals version screens — Headlight customer (CustomerID === 1) ONLY. The nav filter hides the
			// entries for other tenants; this route guard also redirects a direct-URL hit to Settings, so the
			// views are genuinely reachable only by Customer 1 users (matching the standalone internals app).
			const fRenderInternalsView = (pViewIdentifier) => () =>
			{
				const tmpApp = this.pict.PictApplication;
				if (!tmpApp || (typeof tmpApp.isHeadlightSession !== 'function') || !tmpApp.isHeadlightSession())
				{
					this.router.navigate(this.defaultRoute);
					return;
				}
				this.currentView = pViewIdentifier;
				this._renderRouteView(pViewIdentifier);
			};
			this.pictRouter.addRoute('/ServiceVersions', fRenderInternalsView('ServiceVersions'));
			this.pictRouter.addRoute('/ServiceVersionsMultiEnv', fRenderInternalsView('ServiceVersionsMultiEnv'));

			this.pictRouter.addRoute('/ProjectClone',
			(pRouteData) =>
			{
				this.currentView = 'ProjectClone';
				this._renderRouteView('ProjectClone');
			});

			this.pictRouter.addRoute('/MasterLists',
			(pRouteData) =>
			{
				this.currentView = 'MasterListManager';
				this._renderRouteView('MasterListManager');
			});

			this.pictRouter.addRoute('/ATMDashboardConfig',
			(pRouteData) =>
			{
				this.currentView = 'ATMDashboardConfig';
				this._renderRouteView('ATMDashboardConfig');
			});
			// Tab (Validation rules / Display columns) as a stable route (the .atm-tab buttons set this hash via
			// ATMDashboardConfig.navigateTab). ScopeMode (Customer/Project) stays in-place — it's a scope filter.
			this.pictRouter.addRoute('/ATMDashboardConfig/:Tab',
			(pRouteData) =>
			{
				const tmpProvider = this.pict.providers.ATMDashboardConfig;
				const tmpTab = (pRouteData.data.Tab === 'display') ? 'display' : 'validation';
				const tmpAlreadyMounted = (this.currentView === 'ATMDashboardConfig');
				this.currentView = 'ATMDashboardConfig';
				if (!tmpAlreadyMounted) { this._renderRouteView('ATMDashboardConfig'); }
				if (tmpProvider) { tmpProvider.setTab(tmpTab); }
			});

			// --- SamplePlan dashboard (net-new pict recreation; a project picker + the shareable dashboard provider) ---
			this.pictRouter.addRoute('/SamplePlanDashboard',
			(pRouteData) =>
			{
				const tmpProvider = this.pict.providers.SamplePlanDashboard;
				if (tmpProvider) { tmpProvider.setRouteProject(0); }
				this.currentView = 'SamplePlanDashboard';
				this._renderRouteView('SamplePlanDashboard');
			});
			this.pictRouter.addRoute('/SamplePlanDashboard/:IDProject',
			(pRouteData) =>
			{
				const tmpProvider = this.pict.providers.SamplePlanDashboard;
				const tmpID = parseInt(pRouteData.data.IDProject, 10) || 0;
				const tmpAlready = (this.currentView === 'SamplePlanDashboard');
				if (tmpProvider) { tmpProvider.setRouteProject(tmpID); }
				this.currentView = 'SamplePlanDashboard';
				// Already on-screen: just open the newly-picked project (avoids a full view re-render + picker remount flash).
				if (tmpAlready && tmpProvider) { tmpProvider.openInto(tmpID, '#SamplePlanDashboard-Host'); }
				else { this._renderRouteView('SamplePlanDashboard'); }
			});
			// Copy one project's sample plan onto another. Deliberately has no menu entry anywhere.
			this.pictRouter.addRoute('/SamplePlan-Copy',
			(pRouteData) =>
			{
				this.currentView = 'SamplePlanCopy';
				this._renderRouteView('SamplePlanCopy');
			});

			// --- Observation list (bespoke, Solr-backed, filterable) — a literal that WINS over the generic
			// pict-section-recordset /PSRS/:RecordSet/List (which hangs scanning the ~21k-row Observations table).
			// Because the app router registers before the RecordSetRouter, this literal shadows the generic list;
			// it is also the workspace Header.ListRoute, so the workspace "back" button lands here (fixes the
			// "route changed but the view stayed" symptom — the fast list actually paints + replaces the detail).
			// One screen, one filter bar, three switchable bodies (List / Charts / Map). Each route selects the initial
			// view mode on the shared ObservationList provider; the in-screen tabs switch without a route change. If the
			// screen is already mounted we refresh in place, otherwise we render the view (its onAfterRender loads it).
			const fRenderObservationList = (pMode) => () =>
			{
				this.currentView = 'ObservationList';
				const tmpProvider = this.pict.providers && this.pict.providers['ObservationList'];
				let tmpMounted = false;
				try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#ObservationList-Host').length > 0); } catch (pError) { /* */ }
				if (tmpProvider) { tmpProvider._viewMode = pMode || 'list'; }
				if (tmpProvider && tmpMounted && (typeof tmpProvider.loadAsync === 'function')) { tmpProvider.loadAsync(); }
				else { this._renderRouteView('ObservationList'); }
			};
			this.pictRouter.addRoute('/PSRS/Observation/List', fRenderObservationList('list'));
			this.pictRouter.addRoute('/Observations', fRenderObservationList('list'));
			// The Explorer charts + the (next) Map are views OF this same filtered screen, not separate screens.
			this.pictRouter.addRoute('/ObservationExplorer', fRenderObservationList('charts'));
			this.pictRouter.addRoute('/Observations/Explore', fRenderObservationList('charts'));
			this.pictRouter.addRoute('/Observations/Map', fRenderObservationList('map'));

			// --- Documents browse (bespoke, Meadow-backed — no document search index exists) — the document cognate of
			// the Observations screen: one filter bar, List + Charts. Shadows the generic recordset list and takes over
			// the Documents topic route (config screens stay in the nav submenu). Registered before the RecordSetRouter. ---
			const fRenderDocumentList = (pMode) => () =>
			{
				this.currentView = 'DocumentList';
				const tmpProvider = this.pict.providers && this.pict.providers['DocumentList'];
				let tmpMounted = false;
				try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#DocumentList-Host').length > 0); } catch (pError) { /* */ }
				if (tmpProvider) { tmpProvider._viewMode = (pMode === 'charts') ? 'charts' : 'list'; }
				if (tmpProvider && tmpMounted && (typeof tmpProvider.loadAsync === 'function')) { tmpProvider.loadAsync(); }
				else { this._renderRouteView('DocumentList'); }
			};
			// NOTE: `#/Documents` is a topic route (config menu) registered earlier and wins under first-match, so the
			// browse lives at the generic-list shadow + an explicit browse/charts route (matching how the Observation
			// browse lives at /PSRS/Observation/List + /ObservationExplorer, not at the /Observations topic).
			this.pictRouter.addRoute('/PSRS/Document/List', fRenderDocumentList('list'));
			this.pictRouter.addRoute('/Documents/Browse', fRenderDocumentList('list'));
			this.pictRouter.addRoute('/Documents/Explore', fRenderDocumentList('charts'));

			// --- Inspection Schedule (program-level, bespoke, Meadow-backed) — the agency's Year/Month/Week/Agenda calendar
			// over every inspection. Full-width DashboardMode standalone screen; /:View deep-links a granularity. ---
			const fRenderInspectionSchedule = () => (pRouteData) =>
			{
				this.currentView = 'InspectionSchedule';
				const tmpProvider = this.pict.providers && this.pict.providers['InspectionSchedule'];
				const tmpRouteView = pRouteData && pRouteData.View;
				let tmpMounted = false;
				try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#InspectionSchedule-Host').length > 0); } catch (pError) { /* */ }
				if (tmpProvider && tmpRouteView && (typeof tmpProvider.applyViewFromRoute === 'function')) { tmpProvider.applyViewFromRoute(tmpRouteView); }
				if (tmpProvider && tmpMounted && (typeof tmpProvider.loadAsync === 'function')) { tmpProvider.loadAsync(); }
				else { this._renderRouteView('InspectionSchedule'); }
			};
			this.pictRouter.addRoute('/InspectionSchedule', fRenderInspectionSchedule());
			this.pictRouter.addRoute('/InspectionSchedule/:View', fRenderInspectionSchedule());

			// --- Document approval THROUGHPUT (reusable, bespoke, Meadow-backed) — submitted/approved-over-time for a
			// document type, from the DocumentApprovalLog transition history. :Type selects the per-type config (defaults
			// to Inspection-Dossier); the same screen serves Structural Concrete etc. by config. ---
			const fRenderDocumentThroughput = () => (pRouteData) =>
			{
				this.currentView = 'DocumentThroughput';
				const tmpView = this.pict.views && this.pict.views['DocumentThroughput'];
				if (tmpView) { tmpView._routeType = (pRouteData && pRouteData.Type) || ''; }
				this._renderRouteView('DocumentThroughput');
			};
			this.pictRouter.addRoute('/DocumentThroughput', fRenderDocumentThroughput());
			this.pictRouter.addRoute('/DocumentThroughput/:Type', fRenderDocumentThroughput());

			// --- Customer Support console — triage/work Support-Call documents under the revolving monthly Support
			// project, with approval-workflow actions + screenshot/file attachments. Full-width DashboardMode screen.
			// Plain addRoute (no gate wrapper): the nav tile is capability-gated for display; the server authorizes. ---
			// Stable routes for every Support view: /Support (Calls), /Support/Metrics|Docs|Settings, /Support/Call/:ID.
			// A WARM route (already mounted + loaded) applies in place — no re-mount, no re-fetch; a COLD one mounts the
			// shell and the provider applies the pending route once loadAsync resolves. See [[config-app-tab-stable-routes]].
			const fSupportRoute = (pApply) =>
			{
				this.currentView = 'Support';
				// Full-browser-width Dashboard Mode on every Support navigation — the before-hook clears `.is-dashboard`
				// each route, and a WARM apply skips _renderRouteView (which is what would otherwise re-apply it).
				this._applyDashboardMode(true);
				const tmpProvider = this.pict.providers && this.pict.providers['Support'];
				let tmpMounted = false;
				try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#Support-Host').length > 0); } catch (pError) { /* */ }
				if (tmpProvider && tmpMounted && tmpProvider._manifest && !(tmpProvider.state && tmpProvider.state.Loading)) { pApply(tmpProvider); }
				else { if (tmpProvider) { tmpProvider._pendingApply = pApply; } this._renderRouteView('Support'); }
			};
			// Registration order matters: the specific /Support/Call/:ID + /Support/Merge/:IDs come before /Support/:View
			// (so 'Call'/'Merge' aren't captured as a view). /Support/Merge/<id,id,…> deep-links the (deep-linkable) merge wizard.
			this.pictRouter.addRoute('/Support/Call/:ID', (pRouteData) => fSupportRoute((pProvider) => pProvider.routeApplyCall(Number(pRouteData.data.ID))));
			this.pictRouter.addRoute('/Support/Merge/:IDs', (pRouteData) => fSupportRoute((pProvider) => pProvider.routeApplyMerge(String(pRouteData.data.IDs || ''))));
			this.pictRouter.addRoute('/Support/:View', (pRouteData) => fSupportRoute((pProvider) => pProvider.routeApply(String(pRouteData.data.View || '').toLowerCase())));
			this.pictRouter.addRoute('/Support', () => fSupportRoute((pProvider) => pProvider.routeApply('calls')));

			// --- Form Concierge — platform super-users drive the plansheet form pipeline (create / update / build /
			// examples). Same warm/cold _pendingApply pattern as Support. A loaded non-super-user is bounced; before
			// CurrentUser arrives the provider itself fails closed (waits, then shows the locked notice). ---
			const fFormConciergeRoute = (pApply) =>
			{
				const tmpApp = this.pict.PictApplication;
				if (this.AppData.CurrentUser && (!tmpApp || (typeof tmpApp._isSuperUser !== 'function') || !tmpApp._isSuperUser()))
				{
					this.router.navigate(this.defaultRoute);
					return;
				}
				this.currentView = 'FormConcierge';
				const tmpProvider = this.pict.providers && this.pict.providers['FormConcierge'];
				let tmpMounted = false;
				try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#FormConcierge-Host').length > 0); } catch (pError) { /* */ }
				if (tmpProvider && tmpMounted && tmpProvider._statusLoaded && !(tmpProvider.state && tmpProvider.state.Loading)) { pApply(tmpProvider); }
				else { if (tmpProvider) { tmpProvider._pendingApply = pApply; } this._renderRouteView('FormConcierge'); }
			};
			// :Flow is lower-cased and whitelisted; anything else goes home (a lower-case 'session' still opens a session).
			const fFormConciergeFlow = (pRouteData) =>
			{
				const tmpData = (pRouteData && pRouteData.data) || {};
				const tmpFlow = String(tmpData.Flow || '').toLowerCase();
				if ((tmpFlow === 'session') && tmpData.IDProject)
				{
					fFormConciergeRoute((pProvider) => pProvider.routeApplySession(Number(tmpData.IDProject)));
					return;
				}
				if ([ 'create', 'update', 'examples', 'build' ].indexOf(tmpFlow) < 0)
				{
					this.router.navigate('FormConcierge');
					return;
				}
				fFormConciergeRoute((pProvider) => pProvider.routeApplyFlow(tmpFlow, Number(tmpData.IDProject) || 0));
			};
			// navigo takes the FIRST registered match: Session/:IDRequest must precede :Flow/:IDProject.
			this.pictRouter.addRoute('/FormConcierge/Session/:IDRequest', (pRouteData) => fFormConciergeRoute((pProvider) => pProvider.routeApplySession(Number(pRouteData.data.IDRequest))));
			this.pictRouter.addRoute('/FormConcierge/:Flow/:IDProject', fFormConciergeFlow);
			this.pictRouter.addRoute('/FormConcierge/:Flow', fFormConciergeFlow);
			this.pictRouter.addRoute('/FormConcierge', () => fFormConciergeRoute((pProvider) => pProvider.routeApplyHome()));

			// --- Customer-facing read-only support portal — the Support-View tier's open-cases dashboard. ---
			this.pictRouter.addRoute('/SupportPortal',
				(pRouteData) =>
				{
					this.currentView = 'SupportPortal';
					this._applyDashboardMode(true);   // full-browser-width; warm loadAsync path skips _renderRouteView which would re-apply it
					const tmpProvider = this.pict.providers && this.pict.providers['SupportPortal'];
					let tmpMounted = false;
					try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#SupportPortal-Host').length > 0); } catch (pError) { /* */ }
					if (tmpProvider && tmpMounted && (typeof tmpProvider.loadAsync === 'function')) { tmpProvider.loadAsync(); }
					else { this._renderRouteView('SupportPortal'); }
				});

			// --- Physical Asset (bridge) dashboard — Map/Browse/Overview over the inventory + backfilled SNBI data. ---
			const fRenderAssetDashboard = () => (pRouteData) =>
			{
				this.currentView = 'PhysicalAssetDashboard';
				const tmpProvider = this.pict.providers && this.pict.providers['PhysicalAssetDashboard'];
				if (tmpProvider && pRouteData && pRouteData.View && (typeof tmpProvider.applyViewFromRoute === 'function')) { tmpProvider.applyViewFromRoute(pRouteData.View); }
				let tmpMounted = false;
				try { tmpMounted = !!(this.pict.ContentAssignment && this.pict.ContentAssignment.getElement('#PAD-Host').length > 0); } catch (pError) { /* */ }
				if (tmpProvider && tmpMounted && (typeof tmpProvider.loadAsync === 'function')) { tmpProvider._paint(); }
				else { this._renderRouteView('PhysicalAssetDashboard'); }
			};
			this.pictRouter.addRoute('/AssetDashboard', fRenderAssetDashboard());
			this.pictRouter.addRoute('/AssetDashboard/:View', fRenderAssetDashboard());

			// The asset-type metadata shape editor (bespoke; gated by AssetTypeManifest-Read).
			this.pictRouter.addRoute('/AssetTypeDescriptor',
			(pRouteData) =>
			{
				this.currentView = 'AssetTypeDescriptor';
				this._renderRouteView('AssetTypeDescriptor');
			});

			// --- Sample configuration screens (bespoke; gated by SampleListColumns-Configure / SampleQRCode-Configure) ---
			this.pictRouter.addRoute('/SampleListColumnsConfig',
			(pRouteData) =>
			{
				this.currentView = 'SampleListColumnsConfig';
				this._renderRouteView('SampleListColumnsConfig');
			});
			this.pictRouter.addRoute('/SampleQRCodeConfig',
			(pRouteData) =>
			{
				this.currentView = 'SampleQRCodeConfig';
				this._renderRouteView('SampleQRCodeConfig');
			});
			// Scan Samples as a page of its own; the LIMS top nav's Scanning Cart links here.
			this.pictRouter.addRoute('/ScanSamples',
			(pRouteData) =>
			{
				this.currentView = 'ScanSamplesPage';
				this._renderRouteView('ScanSamplesPage');
			});
			// Scan Samples action cards; linked from the panels' Settings pane (href #/Printer-Codes), no menu entry.
			this.pictRouter.addRoute('/Printer-Codes',
			(pRouteData) =>
			{
				this.currentView = 'PrinterCodes';
				this._renderRouteView('PrinterCodes');
			});
			this.pictRouter.addRoute('/EntityDestinations',
			(pRouteData) =>
			{
				this.currentView = 'EntityDestinationsConfig';
				this._renderRouteView('EntityDestinationsConfig');
			});
			this.pictRouter.addRoute('/DashboardAccess',
			(pRouteData) =>
			{
				this.currentView = 'DashboardAccessConfig';
				this._renderRouteView('DashboardAccessConfig');
			});
			this.pictRouter.addRoute('/SampleScanningConfig',
			(pRouteData) =>
			{
				this.currentView = 'SampleScanningConfig-View';
				this._renderRouteView('SampleScanningConfig-View');
			});
			this.pictRouter.addRoute('/FormAccess',
			(pRouteData) =>
			{
				this.currentView = 'FormAccessConfig-View';
				this._renderRouteView('FormAccessConfig-View');
			});
			this.pictRouter.addRoute('/FieldbookDashboards',
			(pRouteData) =>
			{
				this.currentView = 'FieldbookDashboardsConfig-View';
				this._renderRouteView('FieldbookDashboardsConfig-View');
			});
			// Role-aware dashboards (headlight-dashboards): /Dashboards opens the person's landing dashboard,
			// /Dashboards/All the list, /Dashboards/:Hash[/Project/:IDProject] one dashboard.
			require('headlight-dashboards').addRoutes(this.pict,
				(pRoute, fHandler) => this.pictRouter.addRoute(pRoute, (pRouteData) =>
				{
					this.currentView = 'HeadlightDashboards';
					fHandler(pRouteData);
				}),
				(pViewIdentifier) => this._renderRouteView(pViewIdentifier));

			// --- Data Explorer (operational-database "folders" tree; surfaced under the Database topic) ---
			this.pictRouter.addRoute('/DataExplorer',
			(pRouteData) =>
			{
				this.currentView = 'DataExplorer';
				this._renderRouteView('DataExplorer');
			});

			// --- Sample Plan (a project's material sampling/testing plan) — lives ON the project as the bespoke
			// ProjectWorkspace Materials ▸ Sample Plan tab; these legacy standalone routes just redirect there
			// (an ID → that project's tab; no ID → the Projects list to pick one). No separate picker screen. ---
			this.pictRouter.addRoute('/SamplePlan',
			() => { window.location.hash = '#/PSRS/Project/List'; });
			this.pictRouter.addRoute('/SamplePlan/:ID',
			(pRouteData) => { window.location.hash = `#/Project/Workspace/${parseInt(pRouteData.data.ID, 10)}/sampleplan`; });

			// Important Project Files — now lives ON the project as the bespoke ProjectWorkspace Data ▸ Important
			// Files tab; these legacy standalone routes just redirect there (an ID → that project's tab; no ID →
			// the Projects list to pick one). No separate picker screen.
			this.pictRouter.addRoute('/ImportantFiles',
			() => { window.location.hash = '#/PSRS/Project/List'; });
			this.pictRouter.addRoute('/ImportantFiles/:ID',
			(pRouteData) => { window.location.hash = `#/Project/Workspace/${parseInt(pRouteData.data.ID, 10)}/data-files`; });

			// The funding dashboard lives ON the project as the bespoke ProjectWorkspace Contract ▸ Funding tab;
			// these legacy standalone routes just redirect there (an ID → that project's tab; no ID → the Projects
			// list to pick one). No separate funding project-picker screen.
			this.pictRouter.addRoute('/Project/Funding',
			() => { window.location.hash = '#/PSRS/Project/List'; });
			this.pictRouter.addRoute('/Project/Funding/:ID',
			(pRouteData) => { window.location.hash = `#/Project/Workspace/${parseInt(pRouteData.data.ID, 10)}/funding`; });

			// --- Configuration viewer/editor (provenance-aware cascading config; under the Database topic) ---
			this.pictRouter.addRoute('/ConfigViewer',
			(pRouteData) =>
			{
				this.currentView = 'ConfigViewer';
				this._renderRouteView('ConfigViewer');
			});

			// --- Documentation manager (in-app help content management, AcademyContent-backed) ---
			this.pictRouter.addRoute('/Documentation',
			(pRouteData) =>
			{
				this.currentView = 'Documentation';
				this._renderRouteView('Documentation');
			});

			// --- Entitlements (task-based feature entitlement over the RBAC system) ---
			this.pictRouter.addRoute('/Entitlements',
			(pRouteData) =>
			{
				this.currentView = 'Entitlements';
				this._renderRouteView('Entitlements');
			});
			// Subject + tab as a stable route (the rail sets this hash via Entitlements.navigateSubject, the tabs via
			// navigateTab), so both the selected Role/Group/User AND its active tab live in the URL. Mount only on a
			// cold arrival; re-select the subject only when it actually changed; then apply the tab — so an in-view
			// tab click is just a setTab and a rail click is a select, neither re-mounting the whole view.
			this.pictRouter.addRoute('/Entitlements/:Kind/:ID/:Tab',
			(pRouteData) =>
			{
				const tmpProvider = this.pict.providers.Entitlements;
				if (!tmpProvider) { return; }
				const tmpValidTabs = [ 'features', 'masterlists', 'contractadmin', 'forms' ];
				const tmpTab = (tmpValidTabs.indexOf(pRouteData.data.Tab) > -1) ? pRouteData.data.Tab : 'features';
				const tmpKind = pRouteData.data.Kind;
				const tmpID = parseInt(pRouteData.data.ID, 10);
				const tmpMounted = (this.currentView === 'Entitlements');
				const tmpSameSubject = tmpMounted && (tmpProvider.state.SubjectKind === tmpKind) && (Number(tmpProvider.state.SubjectID) === tmpID);
				this.currentView = 'Entitlements';
				if (!tmpMounted) { this._renderRouteView('Entitlements'); }
				if (!tmpSameSubject) { tmpProvider.selectSubject(tmpKind, tmpID); }
				tmpProvider.setTab(tmpTab);
			});

			this.pictRouter.addRoute('/Certifications',
			(pRouteData) =>
			{
				this.currentView = 'Certifications';
				this._renderRouteView('Certifications');
			});

			// --- Certification Types (bespoke management: type catalog + per-type config) ---
			this.pictRouter.addRoute('/CertificationTypes',
			(pRouteData) =>
			{
				this.currentView = 'CertificationTypes';
				this._renderRouteView('CertificationTypes');
			});

			// --- Asset Catalog Sync (seed this customer's PhysicalAsset* catalog from the shared public data lake) ---
			this.pictRouter.addRoute('/AssetCatalogSync',
			(pRouteData) =>
			{
				this.currentView = 'AssetCatalogSync';
				this._renderRouteView('AssetCatalogSync');
			});

			// The Asset workspace's read routes (/Asset/Workspace/:ID[/:Tab], /PSRS/PhysicalAsset/View/:GUIDRecord,
			// and the Edit→workspace lock) are now registered by workspace-configs.registerWorkspaceRoutes() above —
			// AssetWorkspace was migrated onto pict-section-workspace (Asset.config.js, Edit:{Route:'workspace'}).
			// Only the PhysicalAsset CREATE lock (externally synced → bounce back to the list) stays hand-written here.
			this.pictRouter.addRoute('/PSRS/PhysicalAsset/Create',
			() =>
			{
				window.location.hash = '#/PSRS/PhysicalAsset/List';
			});

			// The Sample workspace's routes (/Sample/Workspace/:ID[/:Tab], /PSRS/Sample/{View,Edit}/:GUIDRecord, and
			// /PSRS/Sample/Create[/ClonedFrom/:GUIDRecord]) are now registered by workspace-configs.registerWorkspaceRoutes()
			// below — SampleWorkspace was migrated onto pict-section-workspace (Sample.config.js; Edit + Create modes).

			// --- Config-driven Headlight Workspaces: register each one's GUID-bridge + /:Tab routes ---
			require('../workspace-configs').registerWorkspaceRoutes(this);

			// --- Project Types / Contract Types (bespoke editors: definition + statuses + dates + prototype) ---
			this.pictRouter.addRoute('/ProjectTypes',
			(pRouteData) =>
			{
				this.currentView = 'ProjectTypes';
				this._renderRouteView('ProjectTypes');
			});
			this.pictRouter.addRoute('/ProjectTypes/:ID',
			(pRouteData) =>
			{
				this.currentView = 'ProjectTypes';
				this._renderRouteView('ProjectTypes');
				this.pict.providers.ProjectContractTypes.openType('Project', pRouteData.data.ID);
			});
			this.pictRouter.addRoute('/ContractTypes',
			(pRouteData) =>
			{
				this.currentView = 'ContractTypes';
				this._renderRouteView('ContractTypes');
			});
			this.pictRouter.addRoute('/ContractTypes/:ID',
			(pRouteData) =>
			{
				this.currentView = 'ContractTypes';
				this._renderRouteView('ContractTypes');
				this.pict.providers.ProjectContractTypes.openType('Contract', pRouteData.data.ID);
			});

			// --- Important dates editors (ProjectDate / ContractDate) ---
			this.pictRouter.addRoute('/ProjectDates/:ID',
			(pRouteData) =>
			{
				this.currentView = 'RecordDates';
				this._renderRouteView('RecordDates');
				this.pict.providers.RecordDates.openAsync('Project', parseInt(pRouteData.data.ID, 10));
			});
			this.pictRouter.addRoute('/ContractDates/:ID',
			(pRouteData) =>
			{
				this.currentView = 'RecordDates';
				this._renderRouteView('RecordDates');
				this.pict.providers.RecordDates.openAsync('Contract', parseInt(pRouteData.data.ID, 10));
			});

			// --- Grant Access (super-user bootstrap: give a user Permission-Grant) ---
			this.pictRouter.addRoute('/GrantAccess',
			(pRouteData) =>
			{
				this.currentView = 'SuperUserGrant';
				this._renderRouteView('SuperUserGrant');
			});
			// Deep link that pre-scopes Grant Access to one customer (from the Customers screen's "grant one in
			// Grants first" action) — renders the same screen, then selects that customer in its filter.
			this.pictRouter.addRoute('/GrantAccess/:IDCustomer',
			(pRouteData) =>
			{
				this.currentView = 'SuperUserGrant';
				this._renderRouteView('SuperUserGrant');
				const tmpProvider = this.pict.providers.SuperUserGrant;
				const tmpIDCustomer = parseInt(pRouteData.data.IDCustomer, 10);
				if (tmpProvider && (typeof tmpProvider.applyCustomerScope === 'function') && tmpIDCustomer) { tmpProvider.applyCustomerScope(tmpIDCustomer); }
			});

			// --- Customers (front door: the customer roster → per-customer Customer workspace; plus a New Customers
			// tab listing provisioning-request documents). Both tabs share the Customers view + CustomersList provider;
			// the route just flips the provider's mode (a stable, linkable tab per the Support pattern).
			const fCustomersRoute = (pMode) =>
			{
				const tmpProvider = this.pict.providers.CustomersList;
				const tmpAlreadyMounted = (this.currentView === 'Customers');
				this.currentView = 'Customers';
				if (!tmpAlreadyMounted) { this._renderRouteView('Customers'); }
				if (tmpProvider && (typeof tmpProvider.setMode === 'function')) { tmpProvider.setMode(pMode); }
			};
			this.pictRouter.addRoute('/Customers', () => fCustomersRoute('roster'));
			this.pictRouter.addRoute('/Customers/New', () => fCustomersRoute('new'));
			// --- Manage Customers (RETIRED) — redirect to the new Customers list. The old screen's Modules + Customer
			// Team tooling moved into the Customer workspace; impersonation is the per-row "Manage Configuration" action.
			const fRedirectToCustomers = () => { if ((typeof window !== 'undefined') && window.location) { window.location.hash = '#/Customers'; } };
			this.pictRouter.addRoute('/ManageCustomers', fRedirectToCustomers);
			this.pictRouter.addRoute('/ManageCustomers/:Mode', fRedirectToCustomers);

			// --- Headlight Academy (full-page documentation browser; reuses the inline-doc pipeline) ---
			const fAcademyRoute = (pTopic) =>
			{
				const tmpAlreadyMounted = (this.currentView === 'Academy');
				this.currentView = 'Academy';
				const tmpProvider = this.pict.providers.Academy;
				// Set the target BEFORE rendering so the view's onViewRendered opens the requested article, not the
				// overview default; when already mounted, swap it in place with no re-render.
				if (tmpProvider) { tmpProvider.prepare(pTopic); }
				if (!tmpAlreadyMounted) { this._renderRouteView('Academy'); }
				else if (tmpProvider) { tmpProvider.showTargetIfMounted(); }
			};
			this.pictRouter.addRoute('/Academy', () => fAcademyRoute(null));
			this.pictRouter.addRoute('/Academy/:Topic', (pRouteData) => fAcademyRoute(pRouteData.data.Topic));

			// --- Activity observability (bespoke): per-user activity, user logins, per-project activity ---
			this.pictRouter.addRoute('/UserActivity',
			(pRouteData) =>
			{
				this.currentView = 'UserActivity';
				this._renderRouteView('UserActivity');
			});
			this.pictRouter.addRoute('/UserActivity/:IDUser',
			(pRouteData) =>
			{
				this.currentView = 'UserActivity';
				// Pre-set the target so the view's onAfterRender auto-load stands down, then load explicitly.
				this.pict.providers.ActivityObservability.userActivity.IDUser = parseInt(pRouteData.data.IDUser, 10);
				this._renderRouteView('UserActivity');
				this.pict.providers.ActivityObservability.loadUserActivityAsync(parseInt(pRouteData.data.IDUser, 10));
			});
			this.pictRouter.addRoute('/UserLoginOverview',
			(pRouteData) =>
			{
				this.currentView = 'UserLoginOverview';
				this._renderRouteView('UserLoginOverview');
			});
			this.pictRouter.addRoute('/ProjectActivity',
			(pRouteData) =>
			{
				if (this.pict.views.ProjectActivity && (typeof this.pict.views.ProjectActivity.exitEmbed === 'function')) { this.pict.views.ProjectActivity.exitEmbed(); }
				this.currentView = 'ProjectActivity';
				this._renderRouteView('ProjectActivity');
			});
			this.pictRouter.addRoute('/ProjectActivity/:IDProject',
			(pRouteData) =>
			{
				if (this.pict.views.ProjectActivity && (typeof this.pict.views.ProjectActivity.exitEmbed === 'function')) { this.pict.views.ProjectActivity.exitEmbed(); }
				this.currentView = 'ProjectActivity';
				this.pict.providers.ActivityObservability.projectActivity.IDProject = parseInt(pRouteData.data.IDProject, 10);
				this._renderRouteView('ProjectActivity');
				this.pict.providers.ActivityObservability.loadProjectActivityAsync(parseInt(pRouteData.data.IDProject, 10));
			});

			// --- Clone configuration across contexts ---
			this.pictRouter.addRoute('/ConfigClone',
			(pRouteData) =>
			{
				this.currentView = 'ConfigClone';
				this._renderRouteView('ConfigClone');
			});

			// --- Clone a role (deep-copy grants + edges into a new, renamed role) ---
			this.pictRouter.addRoute('/RoleClone',
			(pRouteData) =>
			{
				this.currentView = 'RoleClone';
				this._renderRouteView('RoleClone');
			});
			// Deep-link with a preselected source role (from the Access "Duplicate" action).
			this.pictRouter.addRoute('/RoleClone/:IDRole',
			(pRouteData) =>
			{
				this.currentView = 'RoleClone';
				this._renderRouteView('RoleClone');
				const tmpProvider = this.pict.providers.RoleCloneProvider;
				if (tmpProvider && pRouteData && pRouteData.data && pRouteData.data.IDRole)
				{
					tmpProvider.preselectSourceAsync(pRouteData.data.IDRole).then(() =>
					{
						if (this.pict.views.RoleClone) { this.pict.views.RoleClone.render(); }
					});
				}
			});

			// --- Data Mapper (pict-section-mapping; under the Data Lake topic) ---
			this.pictRouter.addRoute('/DataMapper',
			(pRouteData) =>
			{
				this.currentView = 'DataMapper';
				this._renderRouteView('DataMapper');
			});

			// --- Data Import (pict-section-dataimport; generic reference-entity import, under Master Lists) ---
			this.pictRouter.addRoute('/DataImport',
			(pRouteData) =>
			{
				this.currentView = 'DataImport';
				this._renderRouteView('DataImport');
			});

			// --- Contract Package Import (bespoke Contract → Project → Bid Item → Line Item importer) ---
			this.pictRouter.addRoute('/ContractImport',
			(pRouteData) =>
			{
				if (this.pict.providers.ContractPackageImportManager) { this.pict.providers.ContractPackageImportManager.setFlowQuiet('package'); }
				this.currentView = 'ContractPackageImport';
				this._renderRouteView('ContractPackageImport');
			});

			// --- Import Line Items (same view, 'items' flow: add Bid/Line Items to existing Projects) ---
			this.pictRouter.addRoute('/ItemImport',
			(pRouteData) =>
			{
				if (this.pict.providers.ContractPackageImportManager) { this.pict.providers.ContractPackageImportManager.setFlowQuiet('items'); }
				this.currentView = 'ContractPackageImport';
				this._renderRouteView('ContractPackageImport');
			});

			// --- Access & Permissions workspace (RBAC: roles, permission groups, matrix, assignment) ---
			this.pictRouter.addRoute('/Access',
			(pRouteData) =>
			{
				this.currentView = 'AccessWorkspace';
				this._renderRouteView('AccessWorkspace');
				this.pict.providers.AccessWorkspace.loadAsync();
			});

			this.pictRouter.addRoute('/Access/Role/:ID',
			(pRouteData) =>
			{
				this.currentView = 'AccessWorkspace';
				this._renderRouteView('AccessWorkspace');
				this.pict.providers.AccessWorkspace.loadAsync();
				this.pict.providers.AccessWorkspace.selectRoleAsync(pRouteData.data.ID);
			});

			this.pictRouter.addRoute('/Access/Group/:ID',
			(pRouteData) =>
			{
				this.currentView = 'AccessWorkspace';
				this._renderRouteView('AccessWorkspace');
				this.pict.providers.AccessWorkspace.loadAsync();
				this.pict.providers.AccessWorkspace.selectGroupAsync(pRouteData.data.ID);
			});

			this.pictRouter.addRoute('/Access/User/:ID',
			(pRouteData) =>
			{
				this.currentView = 'AccessWorkspace';
				this._renderRouteView('AccessWorkspace');
				this.pict.providers.AccessWorkspace.loadAsync();
				this.pict.providers.AccessWorkspace.selectUserAsync(pRouteData.data.ID);
			});

			// Subject + tab as a stable route (the tab buttons set this hash via AccessWorkspace.navigateTab), so
			// both the selected role/group/user AND its active detail tab live in the URL. When we're already on
			// that same subject the tab switch is a cheap setActiveTab (no re-select/re-fetch); otherwise the
			// subject is selected first, then the requested tab applied (selectXAsync lands on 'permissions', so the
			// tab is set after it resolves). One handler builder for the three subject kinds.
			const fAccessTabRoute = (pKind, pSelectMethod) =>
			{
				this.pictRouter.addRoute(`/Access/${ pKind }/:ID/:Tab`,
				(pRouteData) =>
				{
					const tmpProvider = this.pict.providers.AccessWorkspace;
					if (!tmpProvider) { return; }
					const tmpValidTabs = [ 'details', 'permissions', 'effective', 'composition', 'members', 'assignment', 'overrides', 'projectsgranted' ];
					const tmpTab = (tmpValidTabs.indexOf(pRouteData.data.Tab) > -1) ? pRouteData.data.Tab : 'details';
					const tmpID = parseInt(pRouteData.data.ID, 10);
					const tmpKind = pKind.toLowerCase();
					const tmpAlready = (this.currentView === 'AccessWorkspace') && (tmpProvider.state.SubjectKind === tmpKind) && (Number(tmpProvider.state.SubjectID) === tmpID);
					this.currentView = 'AccessWorkspace';
					if (tmpAlready) { tmpProvider.setActiveTab(tmpTab); return; }
					this._renderRouteView('AccessWorkspace');
					tmpProvider.loadAsync();
					Promise.resolve(tmpProvider[pSelectMethod](tmpID)).then(() => tmpProvider.setActiveTab(tmpTab));
				});
			};
			fAccessTabRoute('Role', 'selectRoleAsync');
			fAccessTabRoute('Group', 'selectGroupAsync');
			fAccessTabRoute('User', 'selectUserAsync');

			// Bridge the raw Role list's "+ New" into the cohesive Access workspace in create-role mode
			// (instead of the generic manifest form). Registered inside this literal block so it wins over the
			// generic /PSRS/:RecordSet/Create on the shared Navigo. newRole() (_startNew) is safe cold; loadAsync()
			// paints the left rail (it does not clobber the staged new-role subject).
			this.pictRouter.addRoute('/PSRS/Role/Create',
			() =>
			{
				this.currentView = 'AccessWorkspace';
				this._renderRouteView('AccessWorkspace');
				this.pict.providers.AccessWorkspace.loadAsync();
				this.pict.providers.AccessWorkspace.newRole();
			});

			// Bridge the raw Role list's read route into the cohesive Access workspace.
			this.pictRouter.addRoute('/PSRS/Role/View/:GUIDRecord',
			(pRouteData) =>
			{
				this.currentView = 'AccessWorkspace';
				this._renderRouteView('AccessWorkspace');
				this.pict.providers.AccessWorkspace.openRoleByGUIDAsync(pRouteData.data.GUIDRecord);
			});

			// --- Data Lake (materialized projections): catalog landing + dataset viewer + create wizard ---
			this.pictRouter.addRoute('/Datalake',
			(pRouteData) =>
			{
				this.currentView = 'DatalakeCatalog';
				this._renderRouteView('DatalakeCatalog');
				this.pict.providers.DatalakeCatalogProvider.loadAsync();
			});

			// Data Downloader: the gated desktop-app download page (literal segment near the other /Datalake/*
			// literals; no /Datalake/:param catch-all exists so ordering is unconstrained).
			this.pictRouter.addRoute('/Datalake/DataDownloader',
			(pRouteData) =>
			{
				this.currentView = 'DataDownloader';
				this._renderRouteView('DataDownloader');
				this.pict.providers.DataDownloaderProvider.loadAsync();
			});

			this.pictRouter.addRoute('/Datalake/New',
			(pRouteData) =>
			{
				this.currentView = 'DatalakeProjectionEditor';
				this._renderRouteView('DatalakeProjectionEditor');
				this.pict.providers.DatalakeProjectionEditorProvider.newProjection();
			});

			this.pictRouter.addRoute('/Datalake/Dataset/:GUIDRecord',
			(pRouteData) =>
			{
				this.currentView = 'DatalakeDataset';
				this._renderRouteView('DatalakeDataset');
				this.pict.providers.DatalakeDatasetProvider.openByGUIDAsync(pRouteData.data.GUIDRecord);
			});

			// Raw imported lake table (a clone table with no MaterializedProjection row), opened by physical name.
			this.pictRouter.addRoute('/Datalake/Table/:TableName',
			(pRouteData) =>
			{
				this.currentView = 'DatalakeDataset';
				this._renderRouteView('DatalakeDataset');
				this.pict.providers.DatalakeDatasetProvider.openByTableAsync(decodeURIComponent(pRouteData.data.TableName));
			});
			// Catalog kind (Projections / Imported) as a stable route (rail links set this hash via
			// DatalakeCatalogProvider.navigateKind). A distinct `/Kind/` segment so it never shadows the literal
			// /Datalake/New | /Datalake/Dataset/* | /Datalake/Table/* routes above. setKind is a cheap re-render.
			this.pictRouter.addRoute('/Datalake/Kind/:Kind',
			(pRouteData) =>
			{
				const tmpProvider = this.pict.providers.DatalakeCatalogProvider;
				const tmpKind = (pRouteData.data.Kind === 'imported') ? 'imported' : 'computed';
				const tmpAlreadyMounted = (this.currentView === 'DatalakeCatalog');
				this.currentView = 'DatalakeCatalog';
				if (!tmpAlreadyMounted) { this._renderRouteView('DatalakeCatalog'); if (tmpProvider) { tmpProvider.loadAsync(); } }
				if (tmpProvider) { tmpProvider.setKind(tmpKind); }
			});

			// --- Approval-workflow visual editor (list + graph over the 'ApprovalWorkflow' Config blob).
			// 'New' before the :Hash catch-all so it isn't read as a workflow hash. ---
			this.pictRouter.addRoute('/ApprovalWorkflows',
			(pRouteData) =>
			{
				this.currentView = 'ApprovalWorkflowList';
				this._renderRouteView('ApprovalWorkflowList');
				this.pict.providers.ApprovalWorkflow.loadListAsync();
			});

			// Document bindings — before the :Hash catch-all so 'Bindings' isn't read as a workflow hash.
			// Observation bindings — a second bindings page over the SAME shared workflow pool (binds observation
			// types instead of document types). Registered before the bare /Bindings route.
			this.pictRouter.addRoute('/ApprovalWorkflows/Bindings/Observation',
			(pRouteData) =>
			{
				this.currentView = 'ApprovalWorkflowBindings';
				this._renderRouteView('ApprovalWorkflowBindings');
				this.pict.providers.ApprovalWorkflow.loadBindingsAsync('Observation');
			});

			this.pictRouter.addRoute('/ApprovalWorkflows/Bindings',
			(pRouteData) =>
			{
				this.currentView = 'ApprovalWorkflowBindings';
				this._renderRouteView('ApprovalWorkflowBindings');
				this.pict.providers.ApprovalWorkflow.loadBindingsAsync('Document');
			});

			this.pictRouter.addRoute('/ApprovalWorkflow/New',
			(pRouteData) =>
			{
				this.currentView = 'ApprovalWorkflowEditor';
				this._renderRouteView('ApprovalWorkflowEditor');
				this.pict.providers.ApprovalWorkflow.newWorkflowAsync();
			});

			this.pictRouter.addRoute('/ApprovalWorkflow/:Hash/Project/:IDProject',
			(pRouteData) =>
			{
				this.currentView = 'ApprovalWorkflowEditor';
				this._renderRouteView('ApprovalWorkflowEditor');
				this.pict.providers.ApprovalWorkflow.loadWorkflowAsync(decodeURIComponent(pRouteData.data.Hash), parseInt(pRouteData.data.IDProject, 10) || 0);
			});

			this.pictRouter.addRoute('/ApprovalWorkflow/:Hash',
			(pRouteData) =>
			{
				this.currentView = 'ApprovalWorkflowEditor';
				this._renderRouteView('ApprovalWorkflowEditor');
				this.pict.providers.ApprovalWorkflow.loadWorkflowAsync(decodeURIComponent(pRouteData.data.Hash));
			});

			// --- Email Notifications (Email Rules) — migrated from Home's EmailRules.vue. List now; the
			// #/EmailRule/New and #/EmailRule/:ID editor routes land in the editor phase. ---
			this.pictRouter.addRoute('/EmailNotifications',
			(pRouteData) =>
			{
				this.currentView = 'EmailNotificationsList';
				this._renderRouteView('EmailNotificationsList');
				this.pict.providers.EmailNotifications.loadListAsync();
			});

			// New before the :ID catch-all so 'New' isn't read as a rule id.
			this.pictRouter.addRoute('/EmailRule/New',
			(pRouteData) =>
			{
				this.currentView = 'EmailNotificationsEditor';
				this._renderRouteView('EmailNotificationsEditor');
				this.pict.providers.EmailNotifications.newRuleAsync();
			});

			this.pictRouter.addRoute('/EmailRule/:ID',
			(pRouteData) =>
			{
				this.currentView = 'EmailNotificationsEditor';
				this._renderRouteView('EmailNotificationsEditor');
				this.pict.providers.EmailNotifications.loadRuleAsync(decodeURIComponent(pRouteData.data.ID));
			});

			// --- Observation Type builder (bespoke record editor; the pict-section-recordset list
			// stays the browse surface). New / Clone before the :ID catch-all so they aren't read as ids. ---
			this.pictRouter.addRoute('/ObservationType/New',
			(pRouteData) =>
			{
				this.currentView = 'ObservationTypeEditor';
				this._renderRouteView('ObservationTypeEditor');
				this.pict.providers.ObservationTypeEditor.newType();
			});

			this.pictRouter.addRoute('/ObservationType/Clone/:ID',
			(pRouteData) =>
			{
				this.currentView = 'ObservationTypeEditor';
				this._renderRouteView('ObservationTypeEditor');
				this.pict.providers.ObservationTypeEditor.cloneFrom(parseInt(pRouteData.data.ID, 10), this.pict.providers.ObservationTypeEditor.idCustomer);
			});

			this.pictRouter.addRoute('/ObservationType/:ID',
			(pRouteData) =>
			{
				this.currentView = 'ObservationTypeEditor';
				this._renderRouteView('ObservationTypeEditor');
				this.pict.providers.ObservationTypeEditor.loadAsync(parseInt(pRouteData.data.ID, 10));
			});

			// Bridge: the recordset list links to a record by GUID; intercept the ObservationManifest
			// read route and open our bespoke editor (resolving GUID -> real ID) instead of the auto form.
			this.pictRouter.addRoute('/PSRS/ObservationManifest/View/:GUIDRecord',
			(pRouteData) =>
			{
				this.currentView = 'ObservationTypeEditor';
				this._renderRouteView('ObservationTypeEditor');
				this.pict.providers.ObservationTypeEditor.openByGUIDAsync(pRouteData.data.GUIDRecord);
			});

			// Bridge: the "+ New" on the ObservationManifest recordset list shadows the generic create form.
			// Redirect to the bespoke Observation Type builder (ObservationTypeEditor.newType via /ObservationType/New).
			// Registered before the generic /PSRS/:RecordSet/Create so this literal wins on the shared Navigo.
			this.pictRouter.addRoute('/PSRS/ObservationManifest/Create',
			() =>
			{
				window.location.hash = '#/ObservationType/New';
			});

			// The Project workspace's read routes (/Project/Workspace/:ID[/:Tab] + /PSRS/Project/View/:GUIDRecord)
			// are now registered by workspace-configs.registerWorkspaceRoutes() above — ProjectWorkspace was migrated
			// onto pict-section-workspace (Project.config.js). The bespoke Edit + Create bridges stay hand-written here.

			// Bridge: intercept the Project EDIT route (shadows the generic recordset edit form) and open the
			// bespoke edit workspace, which locks the Financial & Schedule fields once the project is Active.
			this.pictRouter.addRoute('/PSRS/Project/Edit/:GUIDRecord',
			(pRouteData) =>
			{
				this.currentView = 'ProjectEditWorkspace';
				this._renderRouteView('ProjectEditWorkspace');
				this.pict.providers.ProjectEditWorkspace.openByGUIDAsync(pRouteData.data.GUIDRecord);
			});

			// Bridge: intercept the Project CREATE route (the "+ New" button, which shadows the generic recordset
			// create form) and open the bespoke create workspace instead of the plain manifest form. Registered
			// before the generic /PSRS/:RecordSet/Create so this literal wins on the shared Navigo.
			this.pictRouter.addRoute('/PSRS/Project/Create',
			() =>
			{
				this.currentView = 'ProjectCreateWorkspace';
				this._renderRouteView('ProjectCreateWorkspace');
				this.pict.providers.ProjectCreateWorkspace.startNew();
			});

			// The Contract workspace's read routes (/Contract/Workspace/:ID[/:Tab] + /PSRS/Contract/View/:GUIDRecord)
			// are now registered by workspace-configs.registerWorkspaceRoutes() above — ContractWorkspace was
			// migrated onto pict-section-workspace. Only the bespoke CREATE bridge stays hand-written here.

			// Bridge: intercept the Contract CREATE route (the "+ New" button, which shadows the generic recordset
			// create form) and open the bespoke create workspace instead of the plain manifest form. Registered
			// before the generic /PSRS/:RecordSet/Create so this literal wins on the shared Navigo.
			this.pictRouter.addRoute('/PSRS/Contract/Create',
			() =>
			{
				this.currentView = 'ContractCreateWorkspace';
				this._renderRouteView('ContractCreateWorkspace');
				this.pict.providers.ContractCreateWorkspace.startNew();
			});

			// Bridge: intercept the Inspection CREATE route so "+ New" opens the bespoke schedule screen rather
			// than the generic manifest form. This one is not cosmetic — the generic form POSTs a lone Inspection
			// row with no asset join, no project and no document packet, which no screen in the platform can then
			// show properly. Registered before the generic /PSRS/:RecordSet/Create so this literal wins.
			// /PSRS/Inspection/Create/ForAsset/:IDPhysicalAsset pre-selects the subject — that is how the Asset
			// workspace's "Schedule inspection" action arrives here.
			this.pictRouter.addRoute('/PSRS/Inspection/Create',
			() =>
			{
				this.currentView = 'InspectionCreateWorkspace';
				this._renderRouteView('InspectionCreateWorkspace');
				this.pict.providers.InspectionCreateWorkspace.startNewAsync();
			});
			this.pictRouter.addRoute('/PSRS/Inspection/Create/ForAsset/:IDPhysicalAsset',
			(pRouteData) =>
			{
				this.currentView = 'InspectionCreateWorkspace';
				this._renderRouteView('InspectionCreateWorkspace');
				this.pict.providers.InspectionCreateWorkspace.startNewAsync(pRouteData?.data?.IDPhysicalAsset);
			});

			// The User workspace's read routes (/User/Workspace/:ID[/:Tab] + /PSRS/User/View/:GUIDRecord) are now
			// registered by workspace-configs.registerWorkspaceRoutes() above — UserWorkspace was migrated onto
			// pict-section-workspace (User.config.js; adds an Activity tab). Only the bespoke CREATE bridge stays here.

			// Bridge: intercept the User CREATE route (the "+ New" button, which shadows the generic recordset
			// create form) and open the bespoke create workspace instead of the plain manifest form (which exposed
			// raw columns like Password Reset Key). Registered before the generic /PSRS/:RecordSet/Create.
			this.pictRouter.addRoute('/PSRS/User/Create',
			() =>
			{
				this.currentView = 'UserCreateWorkspace';
				this._renderRouteView('UserCreateWorkspace');
				this.pict.providers.UserCreateWorkspace.startNew();
			});

			// --- Error Log Viewer (read-only diagnostics — recent HLWebErrorLog artifacts) ---
			this.pictRouter.addRoute('/ErrorLog',
			() =>
			{
				this.currentView = 'ErrorLogViewer';
				this._renderRouteView('ErrorLogViewer');
				this.pict.providers.ErrorLogViewer.loadAsync();
			});

			// --- Report -> Project assignment (shared headlight-report-project-assignment view) ---
			this.pictRouter.addRoute('/ReportProjectAssignment',
			() =>
			{
				this.currentView = 'ReportNamedInstanceProjectForms';
				// The view owns its render + data load via onNavigate (mirrors the form editor's /ProjectForms).
				this.pict.views.ReportNamedInstanceProjectForms.onNavigate();
			});

			// --- My Headlight (the organization's own config landing — customer logo, branding) ---
			this.pictRouter.addRoute('/MyHeadlight',
			() =>
			{
				this.currentView = 'MyHeadlight';
				this._renderRouteView('MyHeadlight');
				this.pict.providers.MyHeadlight.loadAsync();
			});

			// --- Artifact Type builder (defines the fields/columns an observation collects) ---
			this.pictRouter.addRoute('/ArtifactType/New',
			(pRouteData) =>
			{
				this.currentView = 'ArtifactTypeEditor';
				this._renderRouteView('ArtifactTypeEditor');
				this.pict.providers.ArtifactTypeEditor.newType();
			});

			this.pictRouter.addRoute('/ArtifactType/:ID',
			(pRouteData) =>
			{
				this.currentView = 'ArtifactTypeEditor';
				this._renderRouteView('ArtifactTypeEditor');
				this.pict.providers.ArtifactTypeEditor.loadAsync(parseInt(pRouteData.data.ID, 10));
			});

			this.pictRouter.addRoute('/PSRS/ArtifactType/View/:GUIDRecord',
			(pRouteData) =>
			{
				this.currentView = 'ArtifactTypeEditor';
				this._renderRouteView('ArtifactTypeEditor');
				this.pict.providers.ArtifactTypeEditor.openByGUIDAsync(pRouteData.data.GUIDRecord);
			});

			// Bridge: the "+ New" on the ArtifactType recordset list shadows the generic create form.
			// Redirect to the bespoke Artifact Type builder (ArtifactTypeEditor.newType via /ArtifactType/New).
			// Registered before the generic /PSRS/:RecordSet/Create so this literal wins on the shared Navigo.
			this.pictRouter.addRoute('/PSRS/ArtifactType/Create',
			() =>
			{
				window.location.hash = '#/ArtifactType/New';
			});

			// (The Analytics dashboards were retired — the whole #/Analytics/* route set, its views, and its nav
			// entries were removed. ObservationExplorer / the Activity views cover the live reporting surface.)

			return fCallback(pError);
		});
	}
}

module.exports = PlatformConfigurationRouter;

module.exports.default_configuration = (
	{
		Name: 'PlatformConfigurationRouter',
	});

/**
 * Dashboard Mode CSS — a reusable full-browser-width layout any top-level view opts into via `DashboardMode: true`.
 * The router toggles `.is-dashboard` on the app content wrapper (see _applyDashboardMode); this drops the standard
 * side gutters and lifts the Bulma `.container` max-width so the view fills the whole browser width, edge to edge.
 */
const _DASHBOARD_MODE_CSS = /*css*/`
	.app-wrapper-container.is-dashboard { padding-left: 0; padding-right: 0; }
	.app-wrapper-container.is-dashboard > .container,
	.app-wrapper-container.is-dashboard #PlatformConfiguration-Application-Container { max-width: none; width: 100%; }
`;

},{"../navigation-topics.js":1295,"../workspace-configs":1516,"headlight-dashboards":45,"pict-provider":845,"pict-router":846}],1358:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

// The list is server-paged (a project can carry thousands of line items / equipment links), and server-side
// search narrows it before paging — so the tool never needs to load a whole long list into the browser.
const PAGE_SIZE = 100;      // rows fetched (and rendered) per page
const INN_CHUNK = 100;      // FK-batch size for name resolution
const CANDIDATE_CAP = 500;  // max related-name matches used to scope a join-entity search
const SELECT_ALL_CAP = 5000; // safety ceiling for "select all N matching" across pages

/**
 * ProjectBulkDelete — a reusable, project-scoped bulk-delete tool for the Project workspace's long lists
 * (line items, bid items, equipment links, personnel links, labels). Opened via openFor(pSpec) from a
 * per-tab "Delete…" button (gated by the `Project-BulkDelete` entitlement — see access/Task-Catalog.js).
 *
 * It renders its own overlay appended to <body> (so it never depends on, or is torn down by, the tab's own
 * rendering): a checkbox list of the project's rows with select-all, a live selected count, and a confirmed
 * "Delete selected" that removes each row through the API (soft-delete where the entity supports it; a hard
 * delete = unlink for the join tables). On close it calls pSpec.OnClose so the underlying tab refreshes.
 *
 * pSpec:
 *   Title, Noun, NounPlural       - human labels ("line item" / "line items")
 *   Verb                          - 'Delete' | 'Unlink' (wording only; the API call is the same deleteEntity)
 *   DeleteEntity                  - the Meadow entity to deleteEntity on (record entity, or the join entity)
 *   ItemsSet, IDField, Filter, Sort - server-paged list: `${ItemsSet}/FilteredTo/${Filter}[~FSF~${Sort}~ASC~0]/<offset>/PAGE`
 *   Columns: [ { Key, Label } ]   - display columns read off each row
 *   NameResolver?: { Set, IDField, NameField, FKField, Label } - for join rows, batch-resolve FK → name into a
 *                                   synthetic leading column (e.g. the Equipment/Contact name behind a join)
 *   SearchFields?: [ 'Field', … ] - DIRECT-field server search: the term is ANDed onto Filter as a LIKE stanza
 *                                   (via the picker's buildSearchFilter) so search + Count + paging stay accurate
 *   SearchResolver?: { Set, IDField, NameFields, JoinFKField } - JOIN-entity search: the term first resolves to a
 *                                   set of related ids (LIKE over NameFields on Set), then the join list is scoped
 *                                   `FBL~<JoinFKField>~INN~<ids>` — server search by a name the join row doesn't carry
 *   OnClose: fn                   - called after the overlay closes (refresh the tab)
 *
 * Handles arbitrarily long lists: only one PAGE_SIZE page is ever loaded/rendered, search filters server-side,
 * and selection persists across pages (keyed by row id) so a filtered batch can span pages before deleting.
 */
class ProjectBulkDeleteProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._spec = null;
		this._rows = [];           // the current page only
		this._total = 0;           // total matching the current filter (server Count)
		this._selected = {};       // rowID(string) -> true (persists across pages)
		this._loading = false;
		this._deleting = false;
		this._selecting = false;   // "select all matching" is walking the pages
		this._message = '';
		this._nameByFK = {};       // for NameResolver: FK value(string) -> resolved name
		this._hostSelector = '';   // the inline host on the active tab this tool renders into
		this._search = '';         // applied search term (server-side)
		this._searchDraft = '';    // what's typed in the box but not yet applied
		this._offset = 0;          // paging offset into the filtered set

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			this.pict.CSSMap.addCSS('ProjectBulkDelete-CSS', _CSS, 540);
		}
	}

	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_deleteEntity(pEntity, pID) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.deleteEntity(pEntity, pID, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_chunk(pArray, pSize) { const tmpOut = []; for (let i = 0; i < pArray.length; i += pSize) { tmpOut.push(pArray.slice(i, i + pSize)); } return tmpOut; }

	// --- Open / close ---

	/**
	 * Open the selectable bulk-delete list INLINE, rendered into pSpec.Host (a selector on the active tab) —
	 * it replaces the tab's read list in place (no modal overlay). The host is (re)mounted by the view after
	 * every workspace paint, so openFor is safe to call repeatedly for the same spec.
	 */
	async openFor(pSpec)
	{
		if (!pSpec || !pSpec.Host) { return; }
		const tmpSameOpen = this._spec && (this._spec.Host === pSpec.Host) && (this._spec.Filter === pSpec.Filter);
		this._spec = pSpec;
		this._hostSelector = pSpec.Host;
		if (tmpSameOpen && (this._loaded || this._loading))
		{
			// The workspace repainted the host — re-render from cache, don't reload/lose the selection.
			this._render();
			return;
		}
		this._rows = [];
		this._total = 0;
		this._selected = {};
		this._deleting = false;
		this._message = '';
		this._nameByFK = {};
		this._search = '';
		this._searchDraft = '';
		this._offset = 0;
		this._loaded = false;
		this._loading = true;
		this._render();
		await this._loadAsync();
		this._loading = false;
		this._loaded = true;
		this._render();
	}

	/** Close the inline tool: clear the host and let the caller (OnClose) restore the tab's normal list. */
	close()
	{
		const tmpOnClose = this._spec && this._spec.OnClose;
		this._spec = null;
		this._loaded = false;
		this._rows = [];
		this._selected = {};
		if (typeof tmpOnClose === 'function') { try { tmpOnClose(); } catch (pError) { /* refresh is best-effort */ } }
	}

	// --- Load ---

	async _loadAsync()
	{
		const tmpSpec = this._spec;
		const tmpSort = tmpSpec.Sort ? `~FSF~${tmpSpec.Sort}~ASC~0` : '';
		const tmpEffective = await this._effectiveFilterAsync();
		this._nameByFK = {};
		if (tmpEffective.empty)
		{
			// A join-entity search matched no related records — nothing on this project can match.
			this._rows = [];
			this._total = 0;
			return;
		}
		const tmpListBase = `${tmpSpec.ItemsSet}/FilteredTo/${tmpEffective.filter}${tmpSort}`;
		const [ tmpRows, tmpCount ] = await Promise.all(
			[
				this._getJSON(`${tmpListBase}/${this._offset}/${PAGE_SIZE}`),
				this._getJSON(`${tmpSpec.ItemsSet}/Count/FilteredTo/${tmpEffective.filter}`),
			]);
		this._rows = Array.isArray(tmpRows) ? tmpRows : [];
		this._total = (tmpCount && (tmpCount.Count != null)) ? Number(tmpCount.Count) : this._rows.length;
		// Deletes may have emptied the page we were on — clamp to the last real page and refetch once.
		if ((this._rows.length === 0) && (this._offset > 0) && (this._total > 0))
		{
			this._offset = Math.max(0, (this._pageCount() - 1) * PAGE_SIZE);
			const tmpRefetch = await this._getJSON(`${tmpListBase}/${this._offset}/${PAGE_SIZE}`);
			this._rows = Array.isArray(tmpRefetch) ? tmpRefetch : [];
		}
		if (tmpSpec.NameResolver) { await this._resolveNames(); }
	}

	/**
	 * Build the effective FoxHound filter for the current search term: the spec's base Filter, plus (when a term is
	 * applied) either a direct-field LIKE stanza (SearchFields) or an id-scoping INN resolved from a related set
	 * (SearchResolver). Returns { filter, empty } — empty:true means a join search resolved to zero related records.
	 */
	async _effectiveFilterAsync()
	{
		const tmpSpec = this._spec;
		let tmpFilter = tmpSpec.Filter;
		const tmpTerm = String(this._search || '').trim();
		if (tmpTerm)
		{
			if (tmpSpec.SearchResolver)
			{
				const tmpIDs = await this._resolveSearchCandidatesAsync(tmpSpec.SearchResolver, tmpTerm);
				if (!tmpIDs || tmpIDs.length === 0) { return { filter: tmpFilter, empty: true }; }
				tmpFilter += `~FBL~${tmpSpec.SearchResolver.JoinFKField}~INN~${tmpIDs.slice(0, CANDIDATE_CAP).join(',')}`;
			}
			else if (tmpSpec.SearchFields && tmpSpec.SearchFields.length)
			{
				const tmpClause = this._searchClause(tmpSpec.SearchFields, tmpTerm);
				if (tmpClause) { tmpFilter += `~${tmpClause}`; }
			}
		}
		return { filter: tmpFilter, empty: false };
	}

	/** Direct-field search stanza via the picker's canonical builder (single field → LK; many → OR-group). */
	_searchClause(pFields, pTerm)
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (tmpPicker && (typeof tmpPicker.buildSearchFilter === 'function')) { return tmpPicker.buildSearchFilter(pFields, pTerm); }
		const tmpTerm = String(pTerm || '').trim();
		return tmpTerm ? `FBV~${pFields[0]}~LK~${encodeURIComponent(`%${tmpTerm}%`)}` : '';
	}

	/**
	 * Join-entity search: the join row carries only an FK, so resolve the term to a set of related ids by LIKE-ing
	 * each NameField on the related Set (parallel single-field queries merged — the grouped-OR isn't honored on
	 * every endpoint) and returning the matched ids to scope the join list with INN.
	 */
	async _resolveSearchCandidatesAsync(pResolver, pTerm)
	{
		const tmpFields = (pResolver.NameFields && pResolver.NameFields.length) ? pResolver.NameFields : ['Name'];
		const tmpLike = encodeURIComponent(`%${String(pTerm).trim()}%`);
		const tmpResults = await Promise.all(tmpFields.map((pField) =>
			this._getJSON(`${pResolver.Set}/FilteredTo/FBV~${pField}~LK~${tmpLike}/0/${CANDIDATE_CAP}`)));
		const tmpSeen = {};
		tmpResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pRec) =>
		{
			const tmpID = Number(pRec && pRec[pResolver.IDField]);
			if (tmpID > 0) { tmpSeen[tmpID] = true; }
		}));
		return Object.keys(tmpSeen).map(Number);
	}

	/** For join specs: batch-resolve the FK → display name (chunked INN), stashed in _nameByFK. */
	async _resolveNames()
	{
		const tmpNR = this._spec.NameResolver;
		const tmpIDs = Array.from(new Set(this._rows.map((pRow) => Number(pRow[tmpNR.FKField])).filter((pV) => pV > 0)));
		if (tmpIDs.length === 0) { return; }
		const tmpChunks = this._chunk(tmpIDs, INN_CHUNK);
		const tmpResults = await Promise.all(tmpChunks.map((pChunk) =>
			this._getJSON(`${tmpNR.Set}/FilteredTo/FBL~${tmpNR.IDField}~INN~${pChunk.join(',')}/0/${INN_CHUNK}`)));
		tmpResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pRec) =>
		{
			if (pRec && pRec[tmpNR.IDField] != null) { this._nameByFK[String(pRec[tmpNR.IDField])] = pRec[tmpNR.NameField] || `#${pRec[tmpNR.IDField]}`; }
		}));
	}

	// --- Selection ---

	_selectedIDs() { return Object.keys(this._selected).filter((pK) => this._selected[pK]); }
	selectedCount() { return this._selectedIDs().length; }

	toggleRow(pID)
	{
		const tmpKey = String(pID);
		if (this._selected[tmpKey]) { delete this._selected[tmpKey]; } else { this._selected[tmpKey] = true; }
		this._syncSelectionUI(tmpKey);
	}

	/** True when every row on the CURRENT page is selected (selection can also span other pages). */
	_pageAllSelected() { return (this._rows.length > 0) && this._rows.every((pRow) => !!this._selected[String(pRow[this._spec.IDField])]); }

	/** Header checkbox: toggle only the current page's rows, leaving selections on other pages intact. */
	toggleSelectAll()
	{
		const tmpAll = this._pageAllSelected();
		this._rows.forEach((pRow) =>
		{
			const tmpKey = String(pRow[this._spec.IDField]);
			if (tmpAll) { delete this._selected[tmpKey]; } else { this._selected[tmpKey] = true; }
		});
		this._render();
	}

	/** Walk every page of the current filter and select all matching ids (capped) — for deleting a large filtered set. */
	async selectAllMatchingAsync()
	{
		if (this._loading || this._deleting || this._selecting) { return; }
		const tmpSpec = this._spec;
		const tmpEffective = await this._effectiveFilterAsync();
		if (tmpEffective.empty) { return; }
		const tmpSort = tmpSpec.Sort ? `~FSF~${tmpSpec.Sort}~ASC~0` : '';
		const tmpBase = `${tmpSpec.ItemsSet}/FilteredTo/${tmpEffective.filter}${tmpSort}`;
		this._selecting = true;
		this._message = '';
		this._render();
		let tmpOffset = 0;
		let tmpGuard = 0;
		while ((tmpOffset < this._total) && (tmpOffset < SELECT_ALL_CAP) && (tmpGuard < 200))
		{
			tmpGuard++;
			const tmpRows = await this._getJSON(`${tmpBase}/${tmpOffset}/${PAGE_SIZE}`);
			const tmpList = Array.isArray(tmpRows) ? tmpRows : [];
			if (tmpList.length === 0) { break; }
			tmpList.forEach((pRow) => { this._selected[String(pRow[tmpSpec.IDField])] = true; });
			tmpOffset += PAGE_SIZE;
		}
		this._selecting = false;
		if (this._total > SELECT_ALL_CAP) { this._message = `Selected the first ${SELECT_ALL_CAP.toLocaleString()} of ${this._total.toLocaleString()} — ${tmpSpec.Verb === 'Unlink' ? 'unlink' : 'delete'} these, then select more.`; }
		this._render();
	}

	// --- Paging ---

	_pageCount() { return Math.max(1, Math.ceil(this._total / PAGE_SIZE)); }
	_currentPage() { return Math.floor(this._offset / PAGE_SIZE); }

	async gotoPageAsync(pDelta)
	{
		if (this._loading || this._deleting || this._selecting) { return; }
		const tmpMax = (this._pageCount() - 1) * PAGE_SIZE;
		let tmpNext = this._offset + (Number(pDelta) * PAGE_SIZE);
		if (tmpNext < 0) { tmpNext = 0; }
		if (tmpNext > tmpMax) { tmpNext = tmpMax; }
		if (tmpNext === this._offset) { return; }
		this._offset = tmpNext;
		this._loading = true;
		this._render();
		await this._loadAsync();
		this._loading = false;
		this._render();
	}

	// --- Search ---

	/** Track the input value without re-rendering (so the field keeps focus while typing). */
	setSearchDraft(pValue) { this._searchDraft = String(pValue == null ? '' : pValue); }

	async applySearchAsync()
	{
		if (this._loading || this._deleting || this._selecting) { return; }
		const tmpTerm = String(this._searchDraft || '').trim();
		if (tmpTerm === this._search) { return; }
		this._search = tmpTerm;
		this._offset = 0;
		this._message = '';
		this._loading = true;
		this._render();
		await this._loadAsync();
		this._loading = false;
		this._render();
	}

	async clearSearchAsync()
	{
		if (!this._search && !this._searchDraft) { return; }
		this._search = '';
		this._searchDraft = '';
		this._offset = 0;
		this._message = '';
		this._loading = true;
		this._render();
		await this._loadAsync();
		this._loading = false;
		this._render();
	}

	/** Light per-row selection repaint (row class + toolbar count) without rebuilding the whole table. */
	_syncSelectionUI(pID)
	{
		if (typeof document === 'undefined') { return; }
		const tmpRow = document.getElementById(`pbd-row-${pID}`);
		if (tmpRow) { tmpRow.classList.toggle('pbd-row-sel', !!this._selected[String(pID)]); }
		const tmpBar = document.getElementById('pbd-toolbar');
		if (tmpBar) { tmpBar.innerHTML = this._toolbarHTML(); }
	}

	// --- Delete ---

	async deleteSelectedAsync()
	{
		if (this._deleting) { return; }
		const tmpIDs = this._selectedIDs();
		if (tmpIDs.length === 0) { return; }
		const tmpSpec = this._spec;
		const tmpVerb = (tmpSpec.Verb === 'Unlink') ? 'unlink' : 'delete';
		const tmpNoun = (tmpIDs.length === 1) ? tmpSpec.Noun : tmpSpec.NounPlural;
		const tmpConfirmText = `${tmpVerb === 'unlink' ? 'Unlink' : 'Delete'} ${tmpIDs.length} ${tmpNoun}? ${tmpVerb === 'unlink' ? 'The shared records stay; only their link to this project is removed.' : 'This can be undone by an administrator.'}`;
		const tmpOK = (this.modal && (typeof this.modal.confirm === 'function'))
			? await this.modal.confirm(tmpConfirmText, { title: `${tmpVerb === 'unlink' ? 'Unlink' : 'Delete'} ${tmpNoun}`, confirmLabel: (tmpVerb === 'unlink' ? 'Unlink' : 'Delete'), cancelLabel: 'Cancel', dangerous: true })
			: (typeof window !== 'undefined' ? window.confirm(tmpConfirmText) : false);
		if (!tmpOK) { return; }

		this._deleting = true;
		this._message = '';
		this._render();
		let tmpDone = 0;
		let tmpFail = 0;
		for (let i = 0; i < tmpIDs.length; i++)
		{
			const tmpRes = await this._deleteEntity(tmpSpec.DeleteEntity, tmpIDs[i]);
			if (tmpRes && !tmpRes.error && !(tmpRes.result && tmpRes.result.ErrorCode)) { tmpDone++; delete this._selected[tmpIDs[i]]; }
			else { tmpFail++; }
		}
		this._deleting = false;
		this._message = `${tmpVerb === 'unlink' ? 'Unlinked' : 'Deleted'} ${tmpDone} ${tmpDone === 1 ? tmpSpec.Noun : tmpSpec.NounPlural}${tmpFail ? `, ${tmpFail} failed (you may lack permission)` : ''}.`;
		// Reload the remaining rows from the server so the list reflects the deletions.
		this._loading = true;
		this._render();
		await this._loadAsync();
		this._loading = false;
		this._render();
	}

	// --- Render (inline into the active tab's host) ---

	_render()
	{
		if (!this._spec || !this._hostSelector) { return; }
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || (tmpCA.getElement(this._hostSelector).length === 0)) { return; }
		tmpCA.assignContent(this._hostSelector, this._panelHTML());
	}

	_panelHTML()
	{
		const tmpSpec = this._spec;
		let tmpBody;
		if (this._loading) { tmpBody = `<div class="pbd-empty">Loading ${this._esc(tmpSpec.NounPlural)}…</div>`; }
		else if (this._rows.length === 0)
		{
			tmpBody = this._search
				? `<div class="pbd-empty">No ${this._esc(tmpSpec.NounPlural)} match “${this._esc(this._search)}”.</div>`
				: `<div class="pbd-empty">This project has no ${this._esc(tmpSpec.NounPlural)}.</div>`;
		}
		else { tmpBody = this._tableHTML(); }
		const tmpMsg = this._message ? `<div class="pbd-msg">${this._esc(this._message)}</div>` : '';
		return `<div class="pbd-panel">
			<div class="pbd-head">
				<span class="pbd-title">${this._esc(tmpSpec.Title)}</span>
				<button type="button" class="pbd-btn pbd-cancel" onclick="_Pict.providers.ProjectBulkDelete.close()">Done</button>
			</div>
			${this._searchBarHTML()}
			<div id="pbd-toolbar" class="pbd-toolbar">${this._toolbarHTML()}</div>
			${this._pagerHTML()}
			${tmpMsg}
			<div class="pbd-tablewrap">${tmpBody}</div>
		</div>`;
	}

	_searchBarHTML()
	{
		const tmpSpec = this._spec || {};
		if (!tmpSpec.SearchFields && !tmpSpec.SearchResolver) { return ''; }
		const tmpHasSearch = !!this._search;
		return `<div class="pbd-search">
			<input type="text" class="pbd-search-input" placeholder="Search ${this._esc(tmpSpec.NounPlural)}…" value="${this._esc(this._searchDraft)}"
				oninput="_Pict.providers.ProjectBulkDelete.setSearchDraft(this.value)"
				onkeydown="if(event.key==='Enter'){event.preventDefault();_Pict.providers.ProjectBulkDelete.applySearchAsync();}">
			<button type="button" class="pbd-btn" onclick="_Pict.providers.ProjectBulkDelete.applySearchAsync()">Search</button>
			${tmpHasSearch ? `<button type="button" class="pbd-btn pbd-search-clear" onclick="_Pict.providers.ProjectBulkDelete.clearSearchAsync()">Clear</button>` : ''}
		</div>`;
	}

	_pagerHTML()
	{
		if (this._loading || (this._rows.length === 0)) { return ''; }
		const tmpTotal = this._total;
		const tmpFrom = (tmpTotal === 0) ? 0 : (this._offset + 1);
		const tmpTo = Math.min(this._offset + this._rows.length, tmpTotal);
		const tmpBusy = this._deleting || this._selecting;
		const tmpPrevDis = ((this._offset <= 0) || tmpBusy) ? 'disabled' : '';
		const tmpNextDis = (((this._offset + PAGE_SIZE) >= tmpTotal) || tmpBusy) ? 'disabled' : '';
		const tmpMore = (tmpTotal > this._rows.length);
		const tmpSelAll = (tmpMore && !tmpBusy)
			? `<button type="button" class="pbd-linkbtn" onclick="_Pict.providers.ProjectBulkDelete.selectAllMatchingAsync()">Select all ${tmpTotal.toLocaleString()} matching</button>`
			: (this._selecting ? `<span class="pbd-selecting">Selecting…</span>` : '');
		const tmpPageInd = tmpMore ? `<span class="pbd-pageind">Page ${this._currentPage() + 1} of ${this._pageCount()}</span>` : '';
		return `<div class="pbd-pager">
			<span class="pbd-range">${tmpFrom.toLocaleString()}–${tmpTo.toLocaleString()} of ${tmpTotal.toLocaleString()}</span>
			${tmpSelAll}
			<span class="pbd-pagerbtns">${tmpPageInd}
				<button type="button" class="pbd-btn" ${tmpPrevDis} onclick="_Pict.providers.ProjectBulkDelete.gotoPageAsync(-1)">‹ Prev</button>
				<button type="button" class="pbd-btn" ${tmpNextDis} onclick="_Pict.providers.ProjectBulkDelete.gotoPageAsync(1)">Next ›</button>
			</span>
		</div>`;
	}

	_toolbarHTML()
	{
		const tmpSpec = this._spec || {};
		const tmpSel = this.selectedCount();
		const tmpVerbCap = (tmpSpec.Verb === 'Unlink') ? 'Unlink' : 'Delete';
		const tmpDisabled = (tmpSel === 0 || this._deleting || this._selecting) ? 'disabled' : '';
		const tmpLabel = this._deleting ? 'Working…' : `${tmpVerbCap} selected${tmpSel ? ` (${tmpSel})` : ''}`;
		return `<span class="pbd-count">${tmpSel.toLocaleString()} selected</span>
			<button type="button" class="pbd-btn pbd-btn-danger" ${tmpDisabled} onclick="_Pict.providers.ProjectBulkDelete.deleteSelectedAsync()">${tmpLabel}</button>`;
	}

	_tableHTML()
	{
		const tmpSpec = this._spec;
		const tmpAllSelected = this._pageAllSelected();
		const tmpNameCol = tmpSpec.NameResolver ? `<th>${this._esc(tmpSpec.NameResolver.Label || 'Name')}</th>` : '';
		const tmpCols = (tmpSpec.Columns || []).map((pCol) => `<th>${this._esc(pCol.Label)}</th>`).join('');
		const tmpRows = this._rows.map((pRow) =>
		{
			const tmpID = pRow[tmpSpec.IDField];
			const tmpSel = !!this._selected[String(tmpID)];
			const tmpNameCell = tmpSpec.NameResolver
				? `<td>${this._esc(this._nameByFK[String(pRow[tmpSpec.NameResolver.FKField])] || `#${pRow[tmpSpec.NameResolver.FKField]}`)}</td>`
				: '';
			const tmpCells = (tmpSpec.Columns || []).map((pCol) => `<td>${this._esc(pRow[pCol.Key] != null && String(pRow[pCol.Key]).trim() !== '' ? pRow[pCol.Key] : '—')}</td>`).join('');
			return `<tr id="pbd-row-${tmpID}" class="pbd-row${tmpSel ? ' pbd-row-sel' : ''}" onclick="_Pict.providers.ProjectBulkDelete.toggleRow('${tmpID}')">
				<td class="pbd-check"><span class="pbd-checkbox${tmpSel ? ' pbd-checkbox-on' : ''}">${tmpSel ? '✓' : ''}</span></td>${tmpNameCell}${tmpCells}</tr>`;
		}).join('');
		return `<table class="pbd-table">
			<thead><tr><th class="pbd-check" title="Select all on this page" onclick="_Pict.providers.ProjectBulkDelete.toggleSelectAll()"><span class="pbd-checkbox${tmpAllSelected ? ' pbd-checkbox-on' : ''}">${tmpAllSelected ? '✓' : ''}</span></th>${tmpNameCol}${tmpCols}</tr></thead>
			<tbody>${tmpRows}</tbody></table>`;
	}
}

module.exports = ProjectBulkDeleteProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ProjectBulkDelete',
	AutoInitialize: true,
	AutoInitializeOrdinal: 225,
};

const _CSS = /*css*/`
	.pbd-panel { display: flex; flex-direction: column; border: 1px solid var(--theme-color-status-error, #cf5b5b); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-panel, #fff); }
	.pbd-head { display: flex; align-items: center; justify-content: space-between; padding: 0.7rem 1.1rem; background: color-mix(in srgb, var(--theme-color-status-error, #cf5b5b) 8%, transparent); border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.pbd-title { font-weight: 700; font-size: 0.98rem; color: var(--theme-color-text-primary, #1f2733); }
	.pbd-cancel { font-weight: 600; }
	.pbd-search { display: flex; align-items: center; gap: 0.55rem; padding: 0.7rem 1.1rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
	.pbd-search-input { flex: 1 1 auto; min-width: 0; font-size: 0.88rem; padding: 0.42rem 0.7rem; border-radius: 7px; border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
	.pbd-search-input:focus { outline: none; border-color: var(--theme-color-primary, #3f6fd1); box-shadow: 0 0 0 2px color-mix(in srgb, var(--theme-color-primary, #3f6fd1) 22%, transparent); }
	.pbd-toolbar { display: flex; align-items: center; gap: 0.9rem; padding: 0.7rem 1.1rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
	.pbd-count { font-size: 0.85rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); margin-right: auto; }
	.pbd-pager { display: flex; align-items: center; gap: 0.9rem; padding: 0.5rem 1.1rem; background: var(--theme-color-background-tertiary, #f4f6f9); border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
	.pbd-range { font-size: 0.8rem; color: var(--theme-color-text-secondary, #45505f); }
	.pbd-pagerbtns { display: flex; align-items: center; gap: 0.5rem; margin-left: auto; }
	.pbd-pageind { font-size: 0.78rem; color: var(--theme-color-text-muted, #6b7686); }
	.pbd-linkbtn { font-size: 0.8rem; font-weight: 600; padding: 0; border: 0; background: none; color: var(--theme-color-primary, #3f6fd1); cursor: pointer; text-decoration: underline; }
	.pbd-selecting { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); }
	.pbd-btn { font-size: 0.85rem; font-weight: 600; padding: 0.42rem 0.95rem; border-radius: 7px; border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); cursor: pointer; }
	.pbd-btn[disabled] { opacity: 0.5; cursor: default; }
	.pbd-btn-danger { color: #fff; background: var(--theme-color-status-error, #cf5b5b); border-color: var(--theme-color-status-error, #cf5b5b); }
	.pbd-note { font-size: 0.8rem; color: #8a6d1b; background: var(--theme-color-status-warning-bg, #fbf3d9); padding: 0.45rem 1.1rem; }
	.pbd-msg { font-size: 0.84rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.45rem 1.1rem; }
	.pbd-empty { padding: 2rem 1.1rem; text-align: center; color: var(--theme-color-text-muted, #6b7686); }
	.pbd-tablewrap { overflow-x: auto; }
	.pbd-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.88rem; }
	.pbd-table th { position: sticky; top: 0; text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.pbd-table td { padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); color: var(--theme-color-text-primary, #1f2733); }
	.pbd-row { cursor: pointer; }
	.pbd-row:hover { background: var(--theme-color-background-tertiary, #f4f6f9); }
	.pbd-row-sel { background: color-mix(in srgb, var(--theme-color-status-error, #cf5b5b) 10%, transparent); }
	.pbd-check { width: 1%; white-space: nowrap; text-align: center; }
	.pbd-checkbox { display: inline-flex; align-items: center; justify-content: center; width: 1.05rem; height: 1.05rem; border: 1.5px solid var(--theme-color-border-medium, #d5dbe3); border-radius: 4px; font-size: 0.72rem; font-weight: 800; color: #fff; background: var(--theme-color-background-panel, #fff); }
	.pbd-checkbox-on { background: var(--theme-color-status-error, #cf5b5b); border-color: var(--theme-color-status-error, #cf5b5b); }
	.pbd-check th, th.pbd-check { cursor: pointer; }
`;

},{"pict-provider":845}],1359:[function(require,module,exports){

const libPictProvider = require('pict-provider');

// Project cloning is driven entirely server-side via the API's
//   GET  /1.0/ProjectClone/Preview   — returns counts + warnings
//   POST /1.0/ProjectClone/Apply      — builds + pushes the comprehension
//                                       AND writes Configuration via the
//                                       deployed ElevatedUser → Concierge
//                                       impersonation flow
// Earlier the provider required `lib/service/headlight-project-cloning-adapter`
// and ran the adapter in-browser. That approach (a) shipped a big chunk of
// server code into every browser tab, (b) made every entity insert a separate
// browser-→-API round-trip, and (c) had no access to ElevatedUser secrets, so
// Configuration writes hit 403 in environments where the requesting user
// lacked the privilege. Server-side execution closes all three.

// Heavy entities — default EXCLUDED from the initial preview so the first
// build never pays for an Observation / Document fetch the user didn't ask
// for. They still appear in the entity table as opt-in rows (placeholder
// records "—", checkbox unchecked); checking one disables Proceed + offers a
// Refresh preview affordance, and the next build fetches them honoring the
// configured per-entity caps.
const DEFAULT_EXCLUDED_ENTITIES = [ 'Observation', 'Document', 'DocumentObservationJoin' ];

// Core comprehension keys that are NOT user-toggleable in the entity list:
//  - Project is always created/updated (it is the clone destination itself).
//  - Contract has its own dedicated toggle (it depends on the destination
//    project already having a contract), so it is excluded from the generic
//    entity row list.
//  - EmailRuleSchedule is a child of EmailRule: the adapter clones a rule's
//    schedules whenever the rule itself is cloned (a scheduled rule with no
//    schedule row never fires), so the schedule follows the "Email Rule" toggle
//    rather than being independently selectable.
const NON_TOGGLEABLE_ENTITIES = [ 'Project', 'Contract', 'EmailRuleSchedule' ];

// --- Pure helpers (exported for unit testing the workflow without a live
//     rest client / fable). Each is a deterministic transform of plain data. ---

/**
 * Return the configured default-exclusion list (copy, so callers can't mutate
 * the module constant).
 *
 * @returns {Array<string>}
 */
function getDefaultExclusionList()
{
	return DEFAULT_EXCLUDED_ENTITIES.slice();
}

/**
 * Convert raw Project entity rows into selector option rows.
 *
 * @param {Array<object>} pProjects - Project entity records from the rest client.
 * @returns {Array<{ IDProject: number, Name: string, Status: string, IDContract: number }>}
 */
function mapProjectsToOptions(pProjects)
{
	if (!Array.isArray(pProjects))
	{
		return [];
	}
	return pProjects
		.filter((pRow) => pRow && pRow.IDProject)
		.map((pRow) =>
		{
			return {
				IDProject: pRow.IDProject,
				Name: pRow.Name || `Project ${pRow.IDProject}`,
				Status: pRow.Status || '',
				IDContract: pRow.IDContract || 0,
			};
		})
		.sort((a, b) => String(a.Name).localeCompare(String(b.Name)));
}

/**
 * Find an option row by IDProject (string or number id).
 *
 * @param {Array<object>} pOptions
 * @param {string|number} pIDProject
 * @returns {object|null}
 */
function findProjectOption(pOptions, pIDProject)
{
	if (!Array.isArray(pOptions) || pIDProject === '' || pIDProject === null || typeof(pIDProject) === 'undefined')
	{
		return null;
	}
	const tmpID = parseInt(pIDProject, 10);
	if (isNaN(tmpID))
	{
		return null;
	}
	return pOptions.find((pOption) => pOption.IDProject === tmpID) || null;
}

/**
 * The placeholder/suggested name for the destination project, derived from the
 * selected source project. Defaults to "NEW PROJECT" when nothing is selected.
 *
 * @param {object|null} pSourceProject
 * @returns {string}
 */
function computeNameSuggestion(pSourceProject)
{
	if (pSourceProject && pSourceProject.Name)
	{
		return `CLONED FROM ${pSourceProject.Name}`;
	}
	return 'NEW PROJECT';
}

/**
 * Validate that the prepare-step selections are sufficient to generate a
 * comprehension. New-project mode only needs a source; existing-project mode
 * also needs a destination distinct from the source.
 *
 * @param {{ SourceIDProject:(string|number), DestMode:string, DestIDProject:(string|number) }} pState
 * @returns {boolean}
 */
function computeCanGenerate(pState)
{
	if (!pState)
	{
		return false;
	}
	const tmpSource = parseInt(pState.SourceIDProject, 10);
	if (isNaN(tmpSource) || tmpSource <= 0)
	{
		return false;
	}
	if (pState.DestMode === 'existing')
	{
		const tmpDest = parseInt(pState.DestIDProject, 10);
		if (isNaN(tmpDest) || tmpDest <= 0)
		{
			return false;
		}
		if (tmpDest === tmpSource)
		{
			return false;
		}
	}
	return true;
}

/**
 * Turn a camel/PascalCase entity name into a human-friendly label.
 *
 * @param {string} pEntity
 * @returns {string}
 */
function humanizeEntityName(pEntity)
{
	if (!pEntity)
	{
		return '';
	}
	return String(pEntity)
		.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
		.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
}

/**
 * Read the "records to create" count out of a per-entity count object from the
 * adapter's reportData.Counts. Different slices use different keys
 * (ToCreate / ToUpsert / ToUpdate), so fall back across them.
 *
 * @param {object} pCount
 * @returns {number}
 */
function extractEntityCount(pCount)
{
	if (!pCount || typeof(pCount) !== 'object')
	{
		return 0;
	}
	if (typeof(pCount.ToCreate) === 'number')
	{
		return pCount.ToCreate;
	}
	if (typeof(pCount.ToUpsert) === 'number')
	{
		return pCount.ToUpsert;
	}
	if (typeof(pCount.ToUpdate) === 'number')
	{
		return pCount.ToUpdate;
	}
	// Configuration slice uses { Namespaces, NamespaceValues, ToCopy } — each
	// NamespaceValue is one POST against the Configuration service, so that's
	// the most meaningful "records to apply" number for the entity table.
	if (typeof(pCount.NamespaceValues) === 'number')
	{
		return pCount.NamespaceValues;
	}
	if (typeof(pCount.ToCopy) === 'number')
	{
		return pCount.ToCopy;
	}
	return 0;
}

/**
 * Build the toggleable entity rows for the "Ready for Cloning" step from the
 * adapter's reportData.Counts. Project + Contract are filtered out (Project is
 * mandatory, Contract has its own toggle). The aggregate `Configuration` slice
 * IS included as a row even though it is applied separately from the Meadow
 * comprehension.
 *
 * Also appends opt-in placeholder rows for entities in `pPlaceholderEntities`
 * that the last build excluded entirely (so they're absent from `pCounts`).
 * Placeholders render with `Count: '—'`, an unchecked box, and `NotPreviewed:
 * true` so callers can flag the row visually and so toggling one on can
 * trigger a re-preview.
 *
 * @param {object} pCounts - reportData.Counts.
 * @param {object} pIncludeMap - entityName -> boolean (true = included).
 * @param {Array<string>} [pPlaceholderEntities] - heavy-entity names that
 *   should always appear in the table even when absent from `pCounts`
 *   (typically the default-excluded list).
 * @returns {Array<{ Entity:string, Label:string, Count:(number|string), SourceCount:number, Included:boolean, NotPreviewed:boolean, CheckedAttr:string, RowClass:string }>}
 */
function deriveEntityRows(pCounts, pIncludeMap, pPlaceholderEntities)
{
	const tmpCounts = (pCounts && typeof(pCounts) === 'object') ? pCounts : {};
	const tmpIncludeMap = pIncludeMap || {};
	const tmpPlaceholders = Array.isArray(pPlaceholderEntities) ? pPlaceholderEntities : [];
	const tmpRows = [];
	const tmpSeen = {};
	for (const tmpEntity of Object.keys(tmpCounts))
	{
		if (NON_TOGGLEABLE_ENTITIES.includes(tmpEntity))
		{
			continue;
		}
		const tmpCount = tmpCounts[tmpEntity];
		const tmpIncluded = (tmpIncludeMap[tmpEntity] !== false);
		tmpRows.push({
			Entity: tmpEntity,
			Label: humanizeEntityName(tmpEntity),
			Count: extractEntityCount(tmpCount),
			SourceCount: (tmpCount && typeof(tmpCount.Source) === 'number') ? tmpCount.Source : extractEntityCount(tmpCount),
			Included: tmpIncluded,
			NotPreviewed: false,
			CheckedAttr: tmpIncluded ? 'checked' : '',
			RowClass: tmpIncluded ? '' : 'has-text-grey',
		});
		tmpSeen[tmpEntity] = true;
	}
	// Append placeholder rows for heavy entities the user can opt into but
	// that the last build skipped (so they're absent from Counts).
	for (const tmpEntity of tmpPlaceholders)
	{
		if (tmpSeen[tmpEntity] || NON_TOGGLEABLE_ENTITIES.includes(tmpEntity))
		{
			continue;
		}
		const tmpIncluded = (tmpIncludeMap[tmpEntity] === true);
		tmpRows.push({
			Entity: tmpEntity,
			Label: humanizeEntityName(tmpEntity),
			Count: '—',
			SourceCount: 0,
			Included: tmpIncluded,
			NotPreviewed: true,
			CheckedAttr: tmpIncluded ? 'checked' : '',
			RowClass: 'has-text-grey is-italic',
		});
	}
	return tmpRows;
}

/**
 * Seed the include-map for a freshly generated comprehension: every toggleable
 * entity is ON unless it appears in the default-exclusion list.
 *
 * @param {object} pCounts - reportData.Counts.
 * @returns {object} entityName -> boolean
 */
function buildInitialIncludeMap(pCounts)
{
	const tmpMap = {};
	const tmpCounts = (pCounts && typeof(pCounts) === 'object') ? pCounts : {};
	for (const tmpEntity of Object.keys(tmpCounts))
	{
		if (NON_TOGGLEABLE_ENTITIES.includes(tmpEntity))
		{
			continue;
		}
		tmpMap[tmpEntity] = !DEFAULT_EXCLUDED_ENTITIES.includes(tmpEntity);
	}
	// Always seed an explicit `false` for default-excluded heavy entities,
	// even when they aren't in Counts (the initial build excluded them on
	// purpose). Without this, `toggleEntity` would read their state as
	// undefined and treat the next click as "turn OFF" instead of "turn ON".
	for (const tmpEntity of DEFAULT_EXCLUDED_ENTITIES)
	{
		if (!Object.prototype.hasOwnProperty.call(tmpMap, tmpEntity))
		{
			tmpMap[tmpEntity] = false;
		}
	}
	return tmpMap;
}

/**
 * Produce a pruned copy of a comprehension honoring the user's entity
 * selections. Project is always kept. Contract is kept only when the contract
 * toggle is on. Every other bucket is dropped when its include flag is false.
 *
 * Does not mutate the input comprehension.
 *
 * @param {object} pComprehension
 * @param {object} pIncludeMap - entityName -> boolean.
 * @param {boolean} pIncludeContract
 * @returns {object}
 */
function pruneComprehension(pComprehension, pIncludeMap, pIncludeContract)
{
	const tmpResult = {};
	if (!pComprehension || typeof(pComprehension) !== 'object')
	{
		return tmpResult;
	}
	const tmpIncludeMap = pIncludeMap || {};
	for (const tmpEntity of Object.keys(pComprehension))
	{
		if (tmpEntity === 'Project')
		{
			tmpResult[tmpEntity] = pComprehension[tmpEntity];
			continue;
		}
		if (tmpEntity === 'Contract')
		{
			if (pIncludeContract)
			{
				tmpResult[tmpEntity] = pComprehension[tmpEntity];
			}
			continue;
		}
		// Default-include: only drop when the user explicitly turned it off.
		if (tmpIncludeMap[tmpEntity] !== false)
		{
			tmpResult[tmpEntity] = pComprehension[tmpEntity];
		}
	}
	return tmpResult;
}

class ProjectCloneProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	/** @returns {*} The shared HeadlightRestClient registered on the fable. */
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	/**
	 * Repaint the view declaratively from current AppData.
	 */
	render()
	{
		this.pict.views.ProjectClone.render();
	}

	// --- State Initialization ---

	initializeState()
	{
		this.pict.AppData.ProjectClone = {
			ActiveStep: 1,
			CompletedSteps: [],

			// Step 1 — Prepare. The source/destination pickers are Select2-backed
			// Project inputs (AJAX via Select2Util.getOptionsAjax), so we only hold
			// the chosen id + display name rather than a pre-fetched project list.
			SourceIDProject: '',
			SourceProjectName: '',
			SourceProjectIDContract: 0,
			DestMode: 'new', // 'new' | 'existing'
			DestIDProject: '',
			DestProjectName: '',
			DestName: '',
			DestDescription: '',
			_nameEdited: false,
			NamePlaceholder: 'NEW PROJECT',
			CanGenerate: false,
			// Single-element-array slots that render the currently-selected <option>
			// inside each Select2 so the selection survives a re-render.
			SourceSelectedSlot: [],
			DestSelectedSlot: [],
			Generating: false,
			GenerateErrorSlot: [],

			// Step 2 — Ready for Cloning
			Build: null,
			EntityRows: [],
			IncludeMap: {},
			IncludeContract: false,
			ContractToggleEnabled: false,
			ContractCount: 0,
			ContractCheckedAttr: '',
			ContractDisabledAttr: 'disabled',
			// Heavy-entity caps. The per-entity Include toggles live in IncludeMap
			// (default OFF for Observation/Document via DEFAULT_EXCLUDED_ENTITIES);
			// these inputs let the user lower the upper bound on the fetch when they
			// DO opt in. Defaults match the adapter recipe defaults.
			MaxRecordsObservation: 5000,
			MaxRecordsDocument: 5000,
			WarningRows: [],
			SummaryLabel: '',

			// Step 3 — Results
			CloneState: {
				Phase: 'idle', // idle | cloning | complete | error
				StatusText: '',
				PanelClass: 'is-hidden',
			},
			ResultSlot: [], // success/error banner (single-element-array trick)
			ResultWarningRows: [],
		};
	}

	// --- Derived render state (called from the view before each render) ---

	deriveRenderState()
	{
		if (!this.pict.AppData.ProjectClone)
		{
			this.initializeState();
		}
		this.deriveStepState();
		this.deriveSelectorState();
		this.deriveEntityState();

		// "Done" is only enabled once the clone has finished (success or failure),
		// so the user can't easily leave mid-clone.
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpPhase = tmpState.CloneState && tmpState.CloneState.Phase;
		tmpState.DoneDisabledAttr = (tmpPhase === 'complete' || tmpPhase === 'error') ? '' : 'disabled';
	}

	/**
	 * Per-step accordion body visibility + status tag, from ActiveStep /
	 * CompletedSteps. Uses Bulma is-hidden.
	 */
	deriveStepState()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		for (let i = 1; i <= 3; i++)
		{
			tmpState['Step' + i + '_BodyClass'] = (tmpState.ActiveStep === i) ? '' : 'is-hidden';
			if (tmpState.CompletedSteps.includes(i))
			{
				tmpState['Step' + i + '_StatusLabel'] = '✓ Complete';
				tmpState['Step' + i + '_StatusClass'] = 'is-success';
			}
			else if (tmpState.ActiveStep === i)
			{
				tmpState['Step' + i + '_StatusLabel'] = 'Active';
				tmpState['Step' + i + '_StatusClass'] = 'is-info';
			}
			else
			{
				tmpState['Step' + i + '_StatusLabel'] = 'Pending';
				tmpState['Step' + i + '_StatusClass'] = '';
			}
		}
	}

	/**
	 * Recompute the dynamic name placeholder, the Select2 selected-option slots,
	 * and the generate-enabled flag.
	 */
	deriveSelectorState()
	{
		const tmpState = this.pict.AppData.ProjectClone;

		tmpState.NamePlaceholder = tmpState.SourceProjectName ?
			`CLONED FROM ${tmpState.SourceProjectName}` :
			'NEW PROJECT';

		// Render the currently-selected <option> back into each Select2 so the
		// selection is preserved across the view's re-renders.
		tmpState.SourceSelectedSlot = tmpState.SourceIDProject ?
			[ { IDProject: tmpState.SourceIDProject, Name: tmpState.SourceProjectName || `Project ${tmpState.SourceIDProject}` } ] :
			[];
		tmpState.DestSelectedSlot = (tmpState.DestMode === 'existing' && tmpState.DestIDProject) ?
			[ { IDProject: tmpState.DestIDProject, Name: tmpState.DestProjectName || `Project ${tmpState.DestIDProject}` } ] :
			[];

		tmpState.DestModeNewChecked = (tmpState.DestMode === 'new') ? 'checked' : '';
		tmpState.DestModeExistingChecked = (tmpState.DestMode === 'existing') ? 'checked' : '';
		tmpState.DestSelectorClass = (tmpState.DestMode === 'existing') ? '' : 'is-hidden';
		// Name + Description only apply when creating a NEW project; for an existing
		// destination they're hidden (the existing project keeps its own name/description).
		tmpState.NewProjectFieldsClass = (tmpState.DestMode === 'new') ? '' : 'is-hidden';

		// The optional contract clone is available whenever the SOURCE project has a
		// contract — the adapter creates a new linked contract or merges into the
		// destination's existing one as appropriate.
		tmpState.ContractToggleEnabled = (tmpState.SourceProjectIDContract > 0);

		tmpState.CanGenerate = computeCanGenerate(tmpState);
		tmpState.GenerateDisabledAttr = (tmpState.CanGenerate && !tmpState.Generating) ? '' : 'disabled';
		tmpState.GenerateButtonClass = tmpState.Generating ? 'is-loading' : '';
	}

	/**
	 * Recompute the entity toggle rows + contract toggle display from the build
	 * result and the include-map.
	 */
	deriveEntityState()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (!tmpState.Build || !tmpState.Build.reportData)
		{
			tmpState.EntityRows = [];
			return;
		}
		const tmpCounts = tmpState.Build.reportData.Counts || {};
		tmpState.EntityRows = deriveEntityRows(tmpCounts, tmpState.IncludeMap, DEFAULT_EXCLUDED_ENTITIES);
		tmpState.ContractCheckedAttr = tmpState.IncludeContract ? 'checked' : '';
		// Disabled when the source has no contract, or while a (re)build is running.
		tmpState.ContractDisabledAttr = (tmpState.ContractToggleEnabled && !tmpState.Generating) ? '' : 'disabled';
		// PendingRebuild fires when the user opts INTO a heavy entity that the
		// last build skipped (it's in IncludeMap as true but absent from Counts).
		// Toggling such a row needs a re-preview to fetch the actual rows / counts.
		// Opting OUT is fine without a rebuild (we just prune at apply time), so
		// it doesn't flip this flag.
		tmpState.PendingRebuild = DEFAULT_EXCLUDED_ENTITIES.some((tmpEntity) =>
			tmpState.IncludeMap && tmpState.IncludeMap[tmpEntity] === true && !Object.prototype.hasOwnProperty.call(tmpCounts, tmpEntity));
		// Proceed + entity toggles are locked while the preview is rebuilding,
		// AND while the user has opted-in heavy entities that haven't been
		// previewed yet (they need to click Refresh first).
		tmpState.ProceedDisabledAttr = (tmpState.Generating || tmpState.PendingRebuild) ? 'disabled' : '';
		tmpState.RebuildingClass = tmpState.Generating ? '' : 'is-hidden';
		tmpState.RefreshHiddenClass = tmpState.PendingRebuild ? '' : 'is-hidden';
		tmpState.RefreshDisabledAttr = tmpState.Generating ? 'disabled' : '';
	}

	// --- Step 1: Prepare for Cloning ---

	/**
	 * Source project chosen in the Select2 picker.
	 *
	 * @param {string} pIDProject - The selected IDProject (empty string when cleared).
	 * @param {string} [pName] - The display name from the Select2 selection.
	 */
	setSource(pIDProject, pName)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		tmpState.SourceIDProject = pIDProject || '';
		tmpState.SourceProjectName = pIDProject ? (pName || '') : '';
		tmpState.SourceProjectIDContract = 0;
		// Auto-fill the suggested destination name until the user edits it.
		if (!tmpState._nameEdited)
		{
			tmpState.DestName = tmpState.SourceProjectName ? `CLONED FROM ${tmpState.SourceProjectName}` : '';
		}
		this.render();
		if (!pIDProject)
		{
			return;
		}
		// Resolve the source's contract: the optional contract clone is available
		// whenever the SOURCE has a contract (it becomes a new linked contract for a
		// new/contract-less destination, or merges into an existing destination's).
		this.pict.providers.Select2Util.getEntityAsync('Project', parseInt(pIDProject, 10))
			.then((pProject) =>
			{
				if (String(tmpState.SourceIDProject) !== String(pIDProject))
				{
					return; // selection changed while the lookup was in flight
				}
				tmpState.SourceProjectIDContract = (pProject && pProject.IDContract) || 0;
				this.render();
			})
			.catch((pError) =>
			{
				this.pict.log.warn(`ProjectClone: could not resolve source project ${pIDProject}: ${pError.message || pError}`);
			});
	}

	setDestMode(pMode)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		tmpState.DestMode = (pMode === 'existing') ? 'existing' : 'new';
		if (tmpState.DestMode === 'new')
		{
			tmpState.DestIDProject = '';
			tmpState.DestProjectName = '';
			tmpState.DestProjectIDContract = 0;
		}
		this.render();
	}

	/**
	 * Destination project chosen in the Select2 picker. The adapter resolves the
	 * destination's own contract state at build time (merge vs. new linked), so we
	 * only need the id + display name here.
	 *
	 * @param {string} pIDProject - The selected IDProject (empty string when cleared).
	 * @param {string} [pName] - The display name from the Select2 selection.
	 */
	setDest(pIDProject, pName)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		tmpState.DestIDProject = pIDProject || '';
		tmpState.DestProjectName = pIDProject ? (pName || '') : '';
		this.render();
	}

	setName(pValue)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		tmpState.DestName = pValue || '';
		tmpState._nameEdited = true;
		// Don't re-render on every keystroke (it would reset the cursor); just
		// recompute the generate-enabled flag is not needed here since name is
		// optional. The value is read back at generate time.
	}

	setDescription(pValue)
	{
		this.pict.AppData.ProjectClone.DestDescription = pValue || '';
	}

	/**
	 * Build the comprehension (dry run) for the current selections and advance to
	 * the "Ready for Cloning" step.
	 */
	generateComprehension()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (!computeCanGenerate(tmpState) || tmpState.Generating)
		{
			return;
		}
		this._runBuild(true);
	}

	/**
	 * Compute the option block sent to /Preview or /Apply from the current
	 * Step 1+2 state. ExcludeEntities is derived from the IncludeMap (entities
	 * the user has unchecked), with DEFAULT_EXCLUDED_ENTITIES used as the seed
	 * before the first preview (so heavy entities don't get fetched on the
	 * initial run).
	 *
	 * @returns {object} option block matching the /Preview + /Apply contract.
	 */
	_buildCloneOptions()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpIncludeMap = tmpState.IncludeMap || {};
		const tmpExclude = (Object.keys(tmpIncludeMap).length === 0)
			? DEFAULT_EXCLUDED_ENTITIES.slice()
			: Object.keys(tmpIncludeMap).filter((tmpEntity) => tmpIncludeMap[tmpEntity] === false);

		// API accepts MaxObservations / MaxDocuments at the top level.
		// Only emit when the user supplied a value; otherwise let the server
		// apply the adapter's recipe defaults.
		const tmpOpts = {
			CloneContract: !!tmpState.IncludeContract,
			ExcludeEntities: tmpExclude,
		};
		const tmpRawObs = parseInt(tmpState.MaxRecordsObservation, 10);
		if (!isNaN(tmpRawObs) && tmpRawObs >= 0) tmpOpts.MaxObservations = tmpRawObs;
		const tmpRawDoc = parseInt(tmpState.MaxRecordsDocument, 10);
		if (!isNaN(tmpRawDoc) && tmpRawDoc >= 0) tmpOpts.MaxDocuments = tmpRawDoc;
		if (tmpState.DestName) tmpOpts.ProjectName = tmpState.DestName;
		if (tmpState.DestDescription) tmpOpts.ProjectDescription = tmpState.DestDescription;
		return tmpOpts;
	}

	/**
	 * Build the GET /ProjectClone/Preview query-string URI from the current
	 * source/dest pickers + option block. URL form so it slots straight into
	 * `restClient.getJSON(uri, cb)`.
	 *
	 * @returns {string} URI suitable for restClient.getJSON
	 */
	_buildPreviewURI()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpSource = parseInt(tmpState.SourceIDProject, 10);
		const tmpIsExisting = (tmpState.DestMode === 'existing');
		const tmpDest = tmpIsExisting ? parseInt(tmpState.DestIDProject, 10) : null;
		const tmpOpts = this._buildCloneOptions();

		const tmpParts = [ `SourceIDProject=${tmpSource}` ];
		if (tmpDest) tmpParts.push(`DestIDProject=${tmpDest}`);
		if (tmpOpts.CloneContract) tmpParts.push('CloneContract=true');
		if (tmpOpts.ExcludeEntities && tmpOpts.ExcludeEntities.length > 0)
		{
			tmpParts.push(`ExcludeEntities=${encodeURIComponent(tmpOpts.ExcludeEntities.join(','))}`);
		}
		if (tmpOpts.MaxObservations !== undefined) tmpParts.push(`MaxObservations=${tmpOpts.MaxObservations}`);
		if (tmpOpts.MaxDocuments !== undefined) tmpParts.push(`MaxDocuments=${tmpOpts.MaxDocuments}`);
		return `ProjectClone/Preview?${tmpParts.join('&')}`;
	}

	/**
	 * Hit GET /ProjectClone/Preview for the current selections + contract
	 * choice. The endpoint builds the comprehension server-side and returns
	 * only the per-entity counts + warnings (the raw comprehension stays on
	 * the server — at production scale it can be 100MB+). Contract toggling
	 * still re-runs preview because CloneContract changes the comprehension
	 * shape (NEW_LINKED vs. UPSERT_INTO_DEST vs. NONE).
	 *
	 * @param {boolean} pAdvanceStep - When true, advance to the Ready step on success.
	 */
	_runBuild(pAdvanceStep)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpSource = parseInt(tmpState.SourceIDProject, 10);
		const tmpIsExisting = (tmpState.DestMode === 'existing');
		const tmpDest = tmpIsExisting ? parseInt(tmpState.DestIDProject, 10) : null;
		const tmpURI = this._buildPreviewURI();

		tmpState.Generating = true;
		tmpState.GenerateErrorSlot = [];
		this.render();

		this.restClient.getJSON(tmpURI, (pError, pBody) =>
		{
			tmpState.Generating = false;
			if (pError)
			{
				tmpState.GenerateErrorSlot = [ { Message: pError.message || String(pError) } ];
				// A failed contract rebuild shouldn't strand the toggle ON with no data.
				tmpState.IncludeContract = false;
				this.render();
				return;
			}

			const tmpBody = pBody || {};
			const tmpReportData = tmpBody.ReportData || {};
			const tmpWarnings = tmpBody.Warnings || [];

			// Stash a lightweight "build summary" so downstream UI bits
			// (entity table, contract count, summary label) keep their
			// existing read shape — no need to refactor every caller.
			tmpState.Build =
				{
					reportData: tmpReportData,
					warnings: tmpWarnings,
				};
			// Preserve the user's entity include/exclude choices across rebuilds.
			const tmpPrevious = tmpState.IncludeMap || {};
			const tmpFresh = buildInitialIncludeMap(tmpReportData.Counts || {});
			for (const tmpKey of Object.keys(tmpFresh))
			{
				if (Object.prototype.hasOwnProperty.call(tmpPrevious, tmpKey))
				{
					tmpFresh[tmpKey] = tmpPrevious[tmpKey];
				}
			}
			tmpState.IncludeMap = tmpFresh;
			tmpState.ContractCount = (tmpReportData.Counts && tmpReportData.Counts.Contract)
				? extractEntityCount(tmpReportData.Counts.Contract)
				: 0;
			tmpState.WarningRows = tmpWarnings.map((pWarning) => ({ Message: pWarning }));
			tmpState.SummaryLabel = this._buildSummaryLabel({ reportData: tmpReportData, SourceIDProject: tmpSource, DestIDProject: tmpDest });

			if (pAdvanceStep)
			{
				this._completeStep(1);
			}
			else
			{
				this.render();
			}
		});
	}

	_buildSummaryLabel(pBuild)
	{
		const tmpReport = pBuild.reportData || {};
		const tmpMode = (tmpReport.ProjectMode === 'AUTO_CREATE') ? 'new project' : `existing project ${tmpReport.DestIDProject}`;
		return `Cloning from project ${tmpReport.SourceIDProject} into a ${tmpMode}.`;
	}

	// --- Step 2: Ready for Cloning ---

	toggleEntity(pEntity)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpCurrent = (tmpState.IncludeMap[pEntity] !== false);
		tmpState.IncludeMap[pEntity] = !tmpCurrent;
		// No rebuild here — opting OUT just prunes at apply time, opting IN
		// for a previously-skipped heavy entity surfaces the PendingRebuild
		// affordance via deriveEntityState (which gates Proceed + reveals
		// the Refresh button). The user then clicks Refresh to actually fetch.
		this.render();
	}

	/**
	 * Re-run the preview with the current IncludeMap so heavy entities the
	 * user just opted into are actually fetched. Invoked by the "Refresh
	 * preview" button surfaced when PendingRebuild is true.
	 */
	refreshPreview()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (tmpState.Generating)
		{
			return;
		}
		this._runBuild(false);
	}

	toggleContract()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (!tmpState.ContractToggleEnabled || tmpState.Generating)
		{
			return;
		}
		tmpState.IncludeContract = !tmpState.IncludeContract;
		// The contract choice changes the comprehension (new linked contract vs.
		// merge vs. none), so rebuild rather than prune.
		this._runBuild(false);
	}

	/**
	 * Update the per-entity record cap for heavy classes (Observation / Document).
	 * Setting a new cap does NOT rebuild — the existing fetch is whatever it is.
	 * The cap applies to the next build (e.g. after toggling the contract on/off,
	 * or after going back to Step 1 and re-generating).
	 *
	 * @param {string} pEntity - 'Observation' or 'Document'.
	 * @param {string|number} pValue - the new cap from the input field.
	 */
	updateMaxRecords(pEntity, pValue)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpParsed = parseInt(pValue, 10);
		if (isNaN(tmpParsed) || tmpParsed < 0) return;
		if (pEntity === 'Observation') tmpState.MaxRecordsObservation = tmpParsed;
		else if (pEntity === 'Document') tmpState.MaxRecordsDocument = tmpParsed;
	}

	/**
	 * Return to the prepare step to adjust selections.
	 */
	backToPrepare()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (tmpState.CloneState.Phase === 'cloning')
		{
			return;
		}
		this.goToStep(1);
	}

	/**
	 * Execute the clone end-to-end via POST /ProjectClone/Apply. The server
	 * builds + pushes the comprehension AND applies the Configuration
	 * namespaces via the concierge impersonation flow (uses the deployed
	 * `Headlight.ElevatedUser`). The browser doesn't need to know about
	 * entity push order, Configuration apply, or pruning — that all
	 * happens server-side, driven by the option block (including
	 * ExcludeEntities derived from the user's checkbox state).
	 */
	proceedWithClone()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (!tmpState.Build)
		{
			return;
		}

		// Move to the results step and lock the UI into the in-progress state.
		this._completeStep(2);
		tmpState.CloneState.Phase = 'cloning';
		tmpState.CloneState.PanelClass = '';
		tmpState.CloneState.StatusText = 'Cloning project — this can take a while for large projects. Please keep this tab open.';
		tmpState.ResultSlot = [];
		tmpState.ResultWarningRows = [];
		this.render();

		const tmpSource = parseInt(tmpState.SourceIDProject, 10);
		const tmpIsExisting = (tmpState.DestMode === 'existing');
		const tmpDest = tmpIsExisting ? parseInt(tmpState.DestIDProject, 10) : null;
		const tmpOpts = this._buildCloneOptions();

		const tmpBody = Object.assign({ SourceIDProject: tmpSource }, tmpOpts);
		if (tmpDest) tmpBody.DestIDProject = tmpDest;

		this.restClient.postJSON('ProjectClone/Apply', tmpBody, (pError, pBody) =>
		{
			if (pError)
			{
				// Full error payload to the console for debugging; UI sees a
				// short, human-friendly description.
				console.error('[ProjectClone] /Apply call failed:', pError);
				tmpState.CloneState.Phase = 'error';
				tmpState.CloneState.StatusText = '';
				tmpState.CloneState.PanelClass = 'is-hidden';
				tmpState.ResultSlot = [ {
					TypeClass: 'is-danger is-soft',
					Icon: 'fa-triangle-exclamation',
					Title: 'Project clone failed.',
					Detail: 'The clone request did not finish successfully. The destination project may be partially populated. Please retry the clone, and if the problem persists, contact your administrator.',
				} ];
				tmpState.ResultWarningRows = (tmpState.Build.warnings || []).map((pWarning) => ({ Message: pWarning }));
				this.render();
				if (this.pict.views.HeadlightPanels)
				{
					this.pict.views.HeadlightPanels.toast({ message: 'Project clone failed — see the result panel for details.', type: 'is-danger' });
				}
				return;
			}

			const tmpResponseReport = (pBody && pBody.ReportData) || {};
			const tmpResponseWarnings = (pBody && pBody.Warnings) || [];
			const tmpResolvedDestID = pBody && pBody.ResolvedDestIDProject;
			// Configuration apply is collected into a per-pair error array
			// rather than aborting the request, so an HTTP 200 can still hide
			// partial failures (e.g. permission-denied on a subset of
			// Configuration NamespaceValues). Treat any Configuration apply
			// errors as a soft-failure: surface them in the result panel so the
			// operator knows the clone is incomplete, and surface a warning
			// toast rather than the green success one.
			const tmpConfigApply = (pBody && pBody.ConfigurationApply) || { applied: 0, errors: [] };
			const tmpConfigErrors = Array.isArray(tmpConfigApply.errors) ? tmpConfigApply.errors : [];
			if (tmpConfigErrors.length > 0)
			{
				// Detailed payload goes to the console for debugging; the UI
				// gets human-readable summaries only.
				console.warn('[ProjectClone] Configuration apply errors (full payload):', tmpConfigErrors);
			}

			// Refresh the local build snapshot from the server's reply so the
			// success detail reflects what was actually executed (e.g. the
			// resolved AUTO_CREATE dest IDProject).
			if (tmpResolvedDestID && tmpResponseReport.ProjectMode === 'AUTO_CREATE')
			{
				tmpResponseReport.DestIDProject = tmpResolvedDestID;
			}
			tmpState.Build = { reportData: tmpResponseReport, warnings: tmpResponseWarnings };

			tmpState.CloneState.Phase = 'complete';
			tmpState.CloneState.StatusText = '';
			tmpState.CloneState.PanelClass = 'is-hidden';
			if (tmpConfigErrors.length === 0)
			{
				tmpState.ResultSlot = [ {
					TypeClass: 'is-success is-soft',
					Icon: 'fa-circle-check',
					Title: 'Project clone was successful!',
					Detail: this._buildSuccessDetail(),
				} ];
			}
			else
			{
				// Partial success: entity push completed, but N Configuration
				// namespace-value writes failed. Keep the panel message
				// user-facing — describe the impact, not the wire-format error.
				tmpState.ResultSlot = [ {
					TypeClass: 'is-warning is-soft',
					Icon: 'fa-triangle-exclamation',
					Title: 'Project clone completed, but some Configuration was not applied.',
					Detail: `${this._buildSuccessDetail()} ${tmpConfigErrors.length} of ${tmpConfigErrors.length + (Number(tmpConfigApply.applied) || 0)} Configuration namespace value(s) could not be written to the destination project. See the list below for which ones.`,
				} ];
			}
			// Merge build warnings + per-namespace Configuration errors into
			// the result panel's warning list. UI surfaces the namespace
			// identifier only; the full error JSON is in the console (logged
			// above) for debugging.
			tmpState.ResultWarningRows = tmpResponseWarnings.map((pWarning) => ({ Message: pWarning }))
				.concat(tmpConfigErrors.map((e) => ({
					Message: `Configuration namespace "${e.NamespaceKey}" value "${e.NamespaceValue}" was not applied to the destination.`
				})));
			this.render();
			if (this.pict.views.HeadlightPanels)
			{
				if (tmpConfigErrors.length === 0)
				{
					this.pict.views.HeadlightPanels.toast({ message: 'Project clone was successful!', type: 'is-success' });
				}
				else
				{
					this.pict.views.HeadlightPanels.toast({ message: 'Project clone finished, but some Configuration was not applied — see the result panel for details.', type: 'is-warning' });
				}
			}
		});
	}

	_buildSuccessDetail()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpReport = (tmpState.Build && tmpState.Build.reportData) || {};
		if (tmpReport.ProjectMode === 'AUTO_CREATE')
		{
			return `A new destination project was created from source project ${tmpReport.SourceIDProject}.`;
		}
		return `Destination project ${tmpReport.DestIDProject} was updated from source project ${tmpReport.SourceIDProject}.`;
	}

	/**
	 * Reset the workflow back to a clean prepare step so re-entry starts fresh.
	 */
	resetWorkflow()
	{
		this.initializeState();
		this.render();
	}

	/**
	 * "Done" handler: only acts once the clone has finished. Resets the workflow
	 * (without rendering, since we're leaving) and navigates back to the Dashboard.
	 */
	finishAndLeave()
	{
		const tmpState = this.pict.AppData.ProjectClone;
		const tmpPhase = tmpState && tmpState.CloneState && tmpState.CloneState.Phase;
		if (tmpPhase !== 'complete' && tmpPhase !== 'error')
		{
			return;
		}
		this.initializeState();
		window.location.hash = '#/Settings';
	}

	// --- Accordion navigation ---

	goToStep(pStepNumber)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (tmpState.CloneState.Phase === 'cloning')
		{
			// No navigation while the clone is in flight.
			return;
		}
		// Only allow jumping to a completed step or the current one.
		if (pStepNumber !== tmpState.ActiveStep && !tmpState.CompletedSteps.includes(pStepNumber) && pStepNumber > tmpState.ActiveStep)
		{
			return;
		}
		tmpState.ActiveStep = pStepNumber;
		this.render();
	}

	_completeStep(pStepNumber)
	{
		const tmpState = this.pict.AppData.ProjectClone;
		if (!tmpState.CompletedSteps.includes(pStepNumber))
		{
			tmpState.CompletedSteps.push(pStepNumber);
		}
		tmpState.ActiveStep = pStepNumber + 1;
		this.render();
	}

}

module.exports = ProjectCloneProvider;

module.exports.default_configuration = {
	ProviderIdentifier: 'ProjectCloneProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

// Pure helpers exported for unit tests.
module.exports.getDefaultExclusionList = getDefaultExclusionList;
module.exports.mapProjectsToOptions = mapProjectsToOptions;
module.exports.findProjectOption = findProjectOption;
module.exports.computeNameSuggestion = computeNameSuggestion;
module.exports.computeCanGenerate = computeCanGenerate;
module.exports.humanizeEntityName = humanizeEntityName;
module.exports.extractEntityCount = extractEntityCount;
module.exports.deriveEntityRows = deriveEntityRows;
module.exports.buildInitialIncludeMap = buildInitialIncludeMap;
module.exports.pruneComprehension = pruneComprehension;
module.exports.DEFAULT_EXCLUDED_ENTITIES = DEFAULT_EXCLUDED_ENTITIES;
module.exports.NON_TOGGLEABLE_ENTITIES = NON_TOGGLEABLE_ENTITIES;

},{"pict-provider":845}],1360:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libProjectTypeComprehensionBuilder = require('./ProjectTypeComprehensionBuilder.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

// Mount points (the ProjectTypes / ContractTypes views lay these out; this provider fills them with hand-built HTML —
// the CertificationTypes idiom). Only one of the two views is mounted at a time (routes are exclusive), so they share
// the same mount ids.
const RAIL_MOUNT = '#PCT-Rail';
const RAIL_LIST_MOUNT = '#PCT-Rail-List';
const DETAIL_MOUNT = '#PCT-Detail';
const ALLOWED_PICKER_MOUNT = '#PCT-AllowedPicker';

// Kind config — Project vs Contract type. The provider is parameterized by this so ~85% of the behavior is shared.
const KINDS =
{
	Project:
	{
		Kind: 'Project', Entity: 'ProjectType', Plural: 'ProjectTypes', IDField: 'IDProjectType', GUIDField: 'GUIDProjectType',
		SaveMethod: 'saveProjectType', Label: 'project type', LabelPlural: 'Project Types', Route: '#/ProjectTypes',
		HasOrdinal: true, HasAllowedTypes: false, HasFunding: false, HasDeleted: false,
		ProtoEntity: 'Project', ProtoIDField: 'IDProject', ProtoSettingKey: 'PrototypeIDProject', ProtoTab: '/Project/Workspace',
		DatesRoute: '#/ProjectDates', DefaultDatesLabel: 'Default project dates',
	},
	Contract:
	{
		Kind: 'Contract', Entity: 'ContractType', Plural: 'ContractTypes', IDField: 'IDContractType', GUIDField: 'GUIDContractType',
		SaveMethod: 'saveContractType', Label: 'contract type', LabelPlural: 'Contract Types', Route: '#/ContractTypes',
		HasOrdinal: false, HasAllowedTypes: true, HasFunding: true, HasDeleted: true,
		ProtoEntity: 'Contract', ProtoIDField: 'IDContract', ProtoSettingKey: 'PrototypeIDContract', ProtoTab: '/Contract/Workspace',
		DatesRoute: '#/ContractDates', DefaultDatesLabel: 'Default contract dates',
	},
};

// Prototype "template" steps surfaced in the detail — each a button that deep-links into the existing first-class
// editor scoped to the prototype. `Scope:'prototype'` steps are truly scoped; `'org'` steps are org-wide editors.
const PROTO_STEPS =
[
	{ Key: 'dates', Label: 'Important dates', Kinds: [ 'Project', 'Contract' ], Scope: 'prototype', route: (pKindCfg, pProtoID) => `${pKindCfg.DatesRoute}/${pProtoID}` },
	{ Key: 'observations', Label: 'Observation types', Kinds: [ 'Project' ], Scope: 'prototype', route: (pKindCfg, pProtoID) => `#/Project/Workspace/${pProtoID}/observations` },
	{ Key: 'labels', Label: 'Labels', Kinds: [ 'Project' ], Scope: 'prototype', route: (pKindCfg, pProtoID) => `#/Project/Workspace/${pProtoID}/labels` },
	{ Key: 'sampling', Label: 'Sample plan', Kinds: [ 'Project' ], Scope: 'prototype', route: (pKindCfg, pProtoID) => `#/SamplePlan/${pProtoID}` },
	{ Key: 'documents', Label: 'Forms & documents', Kinds: [ 'Project' ], Scope: 'org', route: () => '#/ReportProjectAssignment' },
	{ Key: 'approvals', Label: 'Approval workflow', Kinds: [ 'Project', 'Contract' ], Scope: 'org', route: () => '#/ApprovalWorkflows/Bindings/Observation' },
	{ Key: 'funding', Label: 'Funding', Kinds: [ 'Project', 'Contract' ], Scope: 'org', route: () => '#/ContractAdmin' },
];

/**
 * ProjectContractTypes — the bespoke #/ProjectTypes and #/ContractTypes editors, replacing the generic PSRS forms.
 * One provider, parameterized by kind (state sliced per kind in AppData.ProjectContractTypes.{Project,Contract} so
 * navigating between the two never clobbers unsaved edits). Reuses the server-side machinery unchanged:
 * `TypeComprehensionSaveProvider` (save → prototype → comprehension → statuses/dates/allowed-types) and
 * `TypeComprehensionReadProvider` (hydrate statuses / default dates / allowed types / prototype). The prototype is
 * surfaced openly with deep-links into the existing first-class editors.
 */
class ProjectContractTypesProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._fundKeySeq = 0;   // stable per-row key for the default-funding pickers (index shifts on add/remove)
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get _saveProvider() { return (this.pict.fable && this.pict.fable.TypeComprehensionSaveProvider) || this.fable.TypeComprehensionSaveProvider; }
	get _readProvider() { return (this.pict.fable && this.pict.fable.TypeComprehensionReadProvider) || this.fable.TypeComprehensionReadProvider; }
	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID || tmpUser.IDCustomer) : 0; }

	// ── Capability gates (server authoritative; fail-open before the map loads) ───
	_can(pEntity, pAction)
	{
		const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
		if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function')) { return tmpApp.EffectivePermissionsService.can(pEntity, pAction); }
		return true;
	}
	get _entity() { return this.cfg.Entity; }
	canCreate() { return this._can(this._entity, 'Create'); }
	canEditDef() { return this._can(this._entity, 'Update'); }
	canDelete() { return this._can(this._entity, 'Delete'); }
	canEditProto() { return this._can(this.cfg.ProtoEntity, 'Update'); }   // prototype is a real Project/Contract; gate on that kind's Update

	// ── State (sliced per kind) ──────────────────────────────────────────────────
	get root()
	{
		if (!this.pict.AppData.ProjectContractTypes)
		{
			this.pict.AppData.ProjectContractTypes = { ActiveKind: 'Project', Project: this._freshSlice(), Contract: this._freshSlice() };
		}
		return this.pict.AppData.ProjectContractTypes;
	}
	get state() { return this.root[this.root.ActiveKind]; }
	get cfg() { return KINDS[this.root.ActiveKind]; }

	_freshSlice()
	{
		return {
			Loaded: false, Loading: false,
			Types: [], TypeSearch: '',
			SelectedID: 0, Selected: null,
			ShowNew: false,
			Def: { Name: '', Description: '', Hash: '', Ordinal: 0 }, HashTouched: false, HashChangeConfirmed: false,
			Statuses: [], DefaultDates: [], ShowDateCodes: false,
			AllowedProjectTypeIDs: [],
			DefaultFunding: [],
			Prototype: null, DetailLoading: false,
			Saving: false, Notice: '', Error: '',
			DeleteConfirm: false, Deleting: false,
		};
	}

	/** Set the active kind (called from each view's onAfterRender), ensure loaded, render. */
	activate(pKind)
	{
		const tmpRoot = this.root;
		tmpRoot.ActiveKind = (pKind === 'Contract') ? 'Contract' : 'Project';
		this.render();
		const tmpSlice = this.state;
		if (!tmpSlice.Loaded && !tmpSlice.Loading) { this.loadAsync(); }
		this.mountPickers();
	}

	/** Deep-link entry (#/ProjectTypes/:ID): activate the kind then select the type — deferring until the rail loads. */
	openType(pKind, pID)
	{
		this.activate(pKind);
		if (String(pID).toLowerCase() === 'new') { this.showNew(); return; }   // #/{Project,Contract}Types/New → create form
		const tmpID = Number(pID) || 0;
		if (!tmpID) { return; }
		const tmpSlice = this.state;
		if (tmpSlice.Loaded) { this.selectType(tmpID); } else { tmpSlice.PendingSelectID = tmpID; }
	}

	// ── REST helpers ─────────────────────────────────────────────────────────────
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_getEntitySet(pEntity, pFilter, pCount) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getEntitySet(pEntity, pFilter, (pErr, pRows) => resolve((!pErr && Array.isArray(pRows)) ? pRows : []), 0, pCount || 2000)) : Promise.resolve([]); }
	_upsertEntity(pEntity, pRecord) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.upsertEntity(pEntity, pRecord, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_deleteEntity(pEntity, pID) { const tmpRC = this.restClient; return (tmpRC && (typeof tmpRC.deleteEntity === 'function')) ? new Promise((resolve) => tmpRC.deleteEntity(pEntity, pID, (pErr) => resolve(!pErr))) : Promise.resolve(false); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	// ── Load the rail ────────────────────────────────────────────────────────────
	loadAsync()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (tmpState.Loading) { return; }
		tmpState.Loading = true;
		this.render();
		// ProjectType has no Deleted column (ContractType does) — only include the Deleted clause where it exists.
		const tmpFilter = `${tmpCfg.HasDeleted ? 'FBV~Deleted~EQ~0~' : ''}FBV~IDCustomer~EQ~${this.callerCustomer()}`;
		this._getJSON(`${tmpCfg.Plural}/FilteredTo/${tmpFilter}/0/5000`).then((pRows) =>
		{
			const tmpTypes = Array.isArray(pRows) ? pRows.slice() : [];
			tmpTypes.sort((pA, pB) => tmpCfg.HasOrdinal
				? ((Number(pA.Ordinal || 0) - Number(pB.Ordinal || 0)) || String(pA.Name || '').localeCompare(String(pB.Name || '')))
				: String(pA.Name || '').localeCompare(String(pB.Name || '')));
			tmpState.Types = tmpTypes;
			tmpState.Loaded = true;
			tmpState.Loading = false;
			if (tmpState.PendingSelectID) { const tmpPending = tmpState.PendingSelectID; tmpState.PendingSelectID = 0; this.selectType(tmpPending); }
			else { this.render(); }
		});
	}

	_typeLabel(pType) { if (!pType) { return ''; } return String(pType.Name || pType.Hash || `Type ${pType[this.cfg.IDField]}`); }

	setTypeSearch(pValue)
	{
		this.state.TypeSearch = String(pValue == null ? '' : pValue);
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length > 0) { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		else { this.render(); }
	}

	// ── Select a type + hydrate its detail ───────────────────────────────────────
	selectType(pID)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpID = Number(pID);
		tmpState.SelectedID = tmpID;
		tmpState.Selected = (tmpState.Types || []).find((pT) => Number(pT[tmpCfg.IDField]) === tmpID) || null;
		tmpState.ShowNew = false;
		tmpState.Notice = ''; tmpState.Error = ''; tmpState.DeleteConfirm = false;
		tmpState.HashTouched = false; tmpState.HashChangeConfirmed = false;
		const tmpType = tmpState.Selected;
		tmpState.Def = tmpType
			? { Name: String(tmpType.Name || ''), Description: String(tmpType.Description || ''), Hash: String(tmpType.Hash || ''), Ordinal: Number(tmpType.Ordinal || 0) }
			: { Name: '', Description: '', Hash: '', Ordinal: 0 };
		tmpState.Statuses = []; tmpState.DefaultDates = []; tmpState.AllowedProjectTypeIDs = []; tmpState.DefaultFunding = []; tmpState.Prototype = null;
		this.render();
		if (tmpID > 0) { this._loadDetailAsync(tmpID, tmpType); }
	}

	async _loadDetailAsync(pID, pType)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		tmpState.DetailLoading = true;
		this.render();
		const tmpRead = this._readProvider;
		const [ tmpStatuses, tmpDates, tmpAllowed, tmpProto ] = await Promise.all([
			tmpRead ? tmpRead.loadStatuses(tmpCfg.Entity, pID) : Promise.resolve({ Available: [], RequiresChangeOrder: [] }),
			tmpRead ? tmpRead.loadDefaultDates(tmpCfg.Entity, pID) : Promise.resolve([]),
			(tmpCfg.HasAllowedTypes && tmpRead) ? tmpRead.loadAllowedProjectTypes(pID) : Promise.resolve([]),
			tmpRead ? tmpRead.loadPrototype(tmpCfg.Entity, pType) : Promise.resolve(null),
		]);
		if (Number(tmpState.SelectedID) !== Number(pID)) { return; }
		tmpState.Statuses = (tmpStatuses.Available || []).map((pName) => ({ Name: pName, RequiresChangeOrder: (tmpStatuses.RequiresChangeOrder || []).indexOf(pName) > -1 }));
		tmpState.DefaultDates = (tmpDates || []).map((pRow) => ({ Name: pRow.Name || pRow.Hash || '', Hash: pRow.Hash || '' }));
		tmpState.AllowedProjectTypeIDs = (tmpAllowed || []).map(Number).filter((pV) => pV > 0);
		tmpState.Prototype = tmpProto || null;
		if (tmpCfg.HasFunding) { await this._loadFundingAsync(tmpState, pID); }
		tmpState.DetailLoading = false;
		this.render();
	}

	// getEntitySet appends its own 's' — pass the SINGULAR Scope name. Each row gets a stable Key for its two
	// searchable pickers (source + category); the option sets are fetched on demand by the pickers, not preloaded
	// (FundingSource can be thousands of rows per customer). Writes to the passed slice (kind-switch safe).
	async _loadFundingAsync(pSlice, pIDContractType)
	{
		const tmpRows = await this._getEntitySet('ContractTypeDefaultFunding', `FBV~IDContractType~EQ~${pIDContractType}~FBV~Deleted~EQ~0`, 5000);
		pSlice.DefaultFunding = tmpRows.map((pRow) => ({ Key: ++this._fundKeySeq, IDRow: Number(pRow.IDContractTypeDefaultFunding) || 0, IDFundingSource: Number(pRow.IDFundingSource) || 0, IDFundingCategory: Number(pRow.IDFundingCategory) || 0 }));
	}

	// ── Definition editing ───────────────────────────────────────────────────────
	setDefField(pField, pValue)
	{
		const tmpState = this.state;
		if (pField === 'Ordinal') { tmpState.Def.Ordinal = Number(pValue) || 0; return; }
		if (!Object.prototype.hasOwnProperty.call(tmpState.Def, pField)) { return; }
		tmpState.Def[pField] = String(pValue == null ? '' : pValue);
		if (pField === 'Name' && !tmpState.HashTouched && (!tmpState.Selected)) { tmpState.Def.Hash = libProjectTypeComprehensionBuilder.slug(tmpState.Def.Name || ''); }
	}
	setHash(pValue) { const tmpState = this.state; tmpState.HashTouched = true; tmpState.Def.Hash = String(pValue == null ? '' : pValue); }
	confirmHashChange(pChecked) { this.state.HashChangeConfirmed = !!pChecked; this.render(); }

	// ── Status lifecycle ─────────────────────────────────────────────────────────
	addStatus() { this.state.Statuses.push({ Name: '', RequiresChangeOrder: false }); this._renderDetail(); }
	removeStatus(pIndex) { this.state.Statuses.splice(pIndex, 1); this._renderDetail(); }
	setStatusName(pIndex, pValue) { if (this.state.Statuses[pIndex]) { this.state.Statuses[pIndex].Name = String(pValue == null ? '' : pValue); } }
	toggleStatusCO(pIndex, pChecked) { if (this.state.Statuses[pIndex]) { this.state.Statuses[pIndex].RequiresChangeOrder = !!pChecked; } }
	moveStatus(pIndex, pDir)
	{
		const tmpList = this.state.Statuses; const tmpTo = pIndex + pDir;
		if (tmpTo < 0 || tmpTo >= tmpList.length) { return; }
		const tmpTmp = tmpList[pIndex]; tmpList[pIndex] = tmpList[tmpTo]; tmpList[tmpTo] = tmpTmp;
		this._renderDetail();
	}

	// ── Default dates ────────────────────────────────────────────────────────────
	addDefaultDate() { this.state.DefaultDates.push({ Name: '', Hash: '' }); this._renderDetail(); }
	removeDefaultDate(pIndex) { this.state.DefaultDates.splice(pIndex, 1); this._renderDetail(); }
	setDateName(pIndex, pValue)
	{
		const tmpRow = this.state.DefaultDates[pIndex];
		if (!tmpRow) { return; }
		tmpRow.Name = String(pValue == null ? '' : pValue);
		if (!tmpRow.Hash) { tmpRow.Hash = libProjectTypeComprehensionBuilder.slug(tmpRow.Name || ''); }   // freeze on first fill so renames update in place
	}
	setDateHash(pIndex, pValue) { const tmpRow = this.state.DefaultDates[pIndex]; if (tmpRow) { tmpRow.Hash = String(pValue == null ? '' : pValue); } }
	toggleDateCodes() { this.state.ShowDateCodes = !this.state.ShowDateCodes; this._renderDetail(); }

	// ── Default funding (ContractType) — searchable pickers per row, keyed by a stable row Key ───
	addFunding() { this.state.DefaultFunding.push({ Key: ++this._fundKeySeq, IDRow: 0, IDFundingSource: 0, IDFundingCategory: 0 }); this._renderDetail(); }
	removeFundingByKey(pKey) { this.state.DefaultFunding = (this.state.DefaultFunding || []).filter((pRow) => pRow.Key !== pKey); this._renderDetail(); }
	setFundingFieldByKey(pKey, pField, pValue) { const tmpRow = (this.state.DefaultFunding || []).find((pRow) => pRow.Key === pKey); if (tmpRow && (pField === 'IDFundingSource' || pField === 'IDFundingCategory')) { tmpRow[pField] = Number(pValue) || 0; } }

	// ── New type ─────────────────────────────────────────────────────────────────
	showNew()
	{
		const tmpState = this.state;
		tmpState.ShowNew = true; tmpState.SelectedID = 0; tmpState.Selected = null;
		tmpState.Def = { Name: '', Description: '', Hash: '', Ordinal: 0 }; tmpState.HashTouched = false;
		tmpState.Statuses = []; tmpState.DefaultDates = []; tmpState.AllowedProjectTypeIDs = []; tmpState.DefaultFunding = []; tmpState.Prototype = null;
		tmpState.Notice = ''; tmpState.Error = '';
		this.render();
	}
	cancelNew() { this.state.ShowNew = false; this.render(); }

	// ── Save (build the editor record → reuse TypeComprehensionSaveProvider) ─────
	async saveAsync()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (!this.canEditDef() || tmpState.Saving) { return; }
		const tmpIsCreate = !tmpState.Selected;
		const tmpName = String(tmpState.Def.Name || '').trim();
		if (!tmpName) { tmpState.Error = 'Give the type a name.'; tmpState.Notice = ''; this.render(); return; }
		const tmpHash = String(tmpState.Def.Hash || '').trim() || libProjectTypeComprehensionBuilder.slug(tmpName);
		// status name safety — the reuse path round-trips names through a comma-joined string
		if (tmpState.Statuses.some((pS) => String(pS.Name || '').indexOf(',') > -1)) { tmpState.Error = 'Status names cannot contain commas.'; tmpState.Notice = ''; this.render(); return; }
		tmpState.Saving = true; tmpState.Error = ''; tmpState.Notice = '';
		this.render();

		const tmpStatusesClean = tmpState.Statuses.map((pS) => ({ Name: String(pS.Name || '').trim(), RequiresChangeOrder: !!pS.RequiresChangeOrder })).filter((pS) => pS.Name);
		const tmpDatesClean = tmpState.DefaultDates.map((pD) => ({ Name: String(pD.Name || '').trim(), Hash: String(pD.Hash || '').trim() || libProjectTypeComprehensionBuilder.slug(String(pD.Name || '').trim()) })).filter((pD) => pD.Name || pD.Hash);
		const tmpSelected = tmpState.Selected || {};
		const tmpRecord = Object.assign({}, tmpSelected, {
			Name: tmpName, Description: String(tmpState.Def.Description || ''), Hash: tmpHash,
			IDCustomer: tmpSelected.IDCustomer || this.callerCustomer(),
			Settings: this._readProvider ? this._readProvider.parseSettings(tmpSelected) : {},
			_DisplaySettings: {
				AvailableStatusList: tmpStatusesClean.map((pS) => pS.Name).join(','),
				StatusesRequiringChangeOrder: tmpStatusesClean.filter((pS) => pS.RequiresChangeOrder).map((pS) => pS.Name).join(','),
				DefaultDates: tmpDatesClean,
			},
		});
		if (tmpCfg.HasOrdinal) { tmpRecord.Ordinal = Number(tmpState.Def.Ordinal) || 0; tmpRecord.IDProgram = tmpSelected.IDProgram || 0; }
		if (!tmpIsCreate) { tmpRecord[tmpCfg.GUIDField] = tmpSelected[tmpCfg.GUIDField]; }
		if (tmpCfg.HasAllowedTypes) { tmpRecord._DisplaySettings.AllowedProjectTypeIDs = (tmpState.AllowedProjectTypeIDs || []).map(Number).filter((pV) => pV > 0).join(','); }

		const tmpSave = this._saveProvider;
		let tmpSaved = null;
		try { tmpSaved = tmpSave ? await tmpSave[tmpCfg.SaveMethod](tmpRecord, tmpIsCreate) : null; }
		catch (pErr) { tmpState.Saving = false; tmpState.Error = 'The server rejected the save.'; this.render(); return; }
		if (!tmpSaved || !tmpSaved[tmpCfg.IDField]) { tmpState.Saving = false; tmpState.Error = 'The server rejected the save.'; this.render(); return; }

		// Reconcile funding against the slice saveAsync captured (NOT this.state) — the save's multi-second round-trips
		// mean the user may have navigated to the other kind, flipping this.state to the wrong (empty) slice.
		if (tmpCfg.HasFunding) { await this._reconcileFundingAsync(tmpState, Number(tmpSaved[tmpCfg.IDField])); }

		// merge/insert the saved type into the (captured) slice's rail
		const tmpIdx = tmpState.Types.findIndex((pT) => Number(pT[tmpCfg.IDField]) === Number(tmpSaved[tmpCfg.IDField]));
		if (tmpIdx > -1) { tmpState.Types[tmpIdx] = tmpSaved; } else { tmpState.Types.push(tmpSaved); }
		tmpState.Types.sort((pA, pB) => tmpCfg.HasOrdinal ? ((Number(pA.Ordinal || 0) - Number(pB.Ordinal || 0)) || String(pA.Name || '').localeCompare(String(pB.Name || ''))) : String(pA.Name || '').localeCompare(String(pB.Name || '')));
		tmpState.Saving = false;
		tmpState.ShowNew = false;
		// If the user switched to the other kind during the save, it already persisted — don't reselect/notify the wrong slice.
		if (this.root.ActiveKind !== tmpCfg.Kind) { return; }
		this.selectType(Number(tmpSaved[tmpCfg.IDField]));   // reselect + re-hydrate (clears Notice)…
		this.state.Notice = 'Saved.';                        // …so set the confirmation after, and repaint
		this.render();
	}

	/** Diff-reconcile the ContractType default-funding rows (plain Meadow CRUD; the save provider doesn't touch them).
	 * Operates on the passed slice (kind-switch safe). */
	async _reconcileFundingAsync(pSlice, pIDContractType)
	{
		const tmpExisting = await this._getEntitySet('ContractTypeDefaultFunding', `FBV~IDContractType~EQ~${pIDContractType}~FBV~Deleted~EQ~0`, 5000);
		const tmpExistingByID = {};
		tmpExisting.forEach((pRow) => { tmpExistingByID[Number(pRow.IDContractTypeDefaultFunding)] = pRow; });
		const tmpKeep = {};
		for (const tmpRow of pSlice.DefaultFunding)
		{
			if (!(tmpRow.IDFundingSource > 0) && !(tmpRow.IDFundingCategory > 0)) { continue; }
			const tmpBody = { IDContractTypeDefaultFunding: tmpRow.IDRow || 0, IDFundingSource: tmpRow.IDFundingSource || 0, IDFundingCategory: tmpRow.IDFundingCategory || 0, IDContractType: pIDContractType, IDCustomer: this.callerCustomer() };
			/* eslint-disable no-await-in-loop */
			const tmpRes = await this._upsertEntity('ContractTypeDefaultFunding', tmpBody);
			/* eslint-enable no-await-in-loop */
			const tmpSavedID = (tmpRes.result && Number(tmpRes.result.IDContractTypeDefaultFunding)) || tmpRow.IDRow;
			if (tmpSavedID) { tmpKeep[tmpSavedID] = true; }
		}
		for (const tmpID of Object.keys(tmpExistingByID)) { if (!tmpKeep[tmpID]) { /* eslint-disable-next-line no-await-in-loop */ await this._deleteEntity('ContractTypeDefaultFunding', Number(tmpID)); } }
	}

	// ── Delete ───────────────────────────────────────────────────────────────────
	askDelete() { this.state.DeleteConfirm = true; this.render(); }
	cancelDelete() { this.state.DeleteConfirm = false; this.render(); }
	async deleteTypeAsync()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (!this.canDelete() || tmpState.Deleting || !tmpState.Selected) { return; }
		tmpState.Deleting = true;
		this.render();
		const tmpID = Number(tmpState.SelectedID);
		const tmpOK = await this._deleteEntity(tmpCfg.Entity, tmpID);
		tmpState.Deleting = false; tmpState.DeleteConfirm = false;
		if (!tmpOK) { tmpState.Error = 'The server refused to delete this type (you may lack permission, or it is in use).'; this.render(); return; }
		tmpState.Types = tmpState.Types.filter((pT) => Number(pT[tmpCfg.IDField]) !== tmpID);
		tmpState.SelectedID = 0; tmpState.Selected = null;
		this.render();
	}

	// ── Prototype panel ──────────────────────────────────────────────────────────
	/** Record where we came from (for the return banner) and deep-link into a prototype editor. */
	openProtoStep(pStepKey)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpProto = tmpState.Prototype;
		const tmpProtoID = tmpProto ? Number(tmpProto[tmpCfg.ProtoIDField]) : 0;
		let tmpTarget = null;
		if (pStepKey === 'open')
		{
			if (!tmpProtoID) { return; }
			tmpTarget = `${tmpCfg.ProtoTab}/${tmpProtoID}`;
		}
		else
		{
			const tmpStep = PROTO_STEPS.find((pS) => pS.Key === pStepKey);
			if (!tmpStep) { return; }
			if ((tmpStep.Scope === 'prototype') && !tmpProtoID) { return; }
			tmpTarget = tmpStep.route(tmpCfg, tmpProtoID);
		}
		this.pict.AppData.PrototypeSetupContext = {
			Entity: tmpCfg.Kind, IDType: tmpState.SelectedID, TypeName: this._typeLabel(tmpState.Selected),
			IDPrototype: tmpProtoID, ReturnHash: `${tmpCfg.Route}/${tmpState.SelectedID}`,
		};
		window.location.hash = tmpTarget;
	}

	/** Create the prototype for a type that has none yet: re-save through the canonical path (saveAsync mints the
	 * prototype shell + writes the pointer, then reselects, which re-hydrates the prototype). */
	async setupPrototypeAsync()
	{
		if (!this.canEditDef() || !this.state.Selected || this.state.Saving) { return; }
		await this.saveAsync();
	}

	// ── Pickers ──────────────────────────────────────────────────────────────────
	mountPickers()
	{
		const tmpCfg = this.cfg;
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCfg.HasAllowedTypes && (tmpCA.getElement(ALLOWED_PICKER_MOUNT).length > 0))
		{
			const tmpP = tmpPicker.createPicker('PCT-AllowedPicker',
				{
					DestinationAddress: ALLOWED_PICKER_MOUNT, ValueAddress: 'AppData.ProjectContractTypes.Contract.AllowedProjectTypeIDs',
					Mode: 'multi', Searchable: true, Placeholder: 'Search project types…',
					DataProvider: this._allowedDataProvider(), ResolveValue: this._allowedResolveValue(),
				});
			if (tmpP && (typeof tmpP.render === 'function')) { tmpP.render(); }
			// Push the loaded value in explicitly so the picker seeds chip labels via ResolveValue (a re-mount alone
			// doesn't re-read ValueAddress for pre-set values); _seedSelectedRecords is idempotent per value.
			if (tmpP && (typeof tmpP.setValue === 'function')) { tmpP.setValue((this.state.AllowedProjectTypeIDs || []).slice()); }
		}
		if (tmpCfg.HasFunding) { this._mountFundingPickers(tmpPicker, tmpCA); }
	}
	_allowedDataProvider()
	{
		const tmpPageSize = 50;
		return (pTerm) =>
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			const tmpScope = `FBV~IDCustomer~EQ~${this.callerCustomer()}`;   // ProjectType has no Deleted column
			const fMap = (pRows) => (Array.isArray(pRows) ? pRows : []).map((pRec) => ({ Value: Number(pRec.IDProjectType), Text: pRec.Name || `#${pRec.IDProjectType}`, Record: pRec }));
			if (!tmpTerm) { return this._getJSON(`ProjectTypes/FilteredTo/${tmpScope}/0/${tmpPageSize}`).then((pRows) => ({ results: fMap(pRows), hasMore: false })); }
			const tmpLike = encodeURIComponent(`%${tmpTerm}%`);
			return this._getJSON(`ProjectTypes/FilteredTo/FBV~Name~LK~${tmpLike}~${tmpScope}/0/${tmpPageSize}`).then((pRows) => ({ results: fMap(pRows), hasMore: false }));
		};
	}
	_allowedResolveValue()
	{
		return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`ProjectType/${tmpID}`).then((pRec) => ((pRec && pRec.IDProjectType) ? { Value: tmpID, Text: pRec.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })); };
	}

	// Two searchable pickers per funding row (source + category), keyed by the row's stable Key. Uses OnChange (not a
	// ValueAddress) since the value lives at a dynamic array index; setValue() seeds the current label.
	_FUND_DEFS()
	{
		return [
			{ Field: 'IDFundingSource', Singular: 'FundingSource', Plural: 'FundingSources', Phrase: 'funding sources', One: 'funding source', HashPrefix: 'PCT-FundSrc-' },
			{ Field: 'IDFundingCategory', Singular: 'FundingCategory', Plural: 'FundingCategories', Phrase: 'funding categories', One: 'funding category', HashPrefix: 'PCT-FundCat-' },
		];
	}
	_mountFundingPickers(pPicker, pCA)
	{
		(this.state.DefaultFunding || []).forEach((pRow) =>
		{
			this._FUND_DEFS().forEach((pDef) =>
			{
				const tmpHash = `${pDef.HashPrefix}${pRow.Key}`;
				if (pCA.getElement(`#${tmpHash}`).length === 0) { return; }
				const tmpKey = pRow.Key;
				const tmpP = pPicker.createPicker(tmpHash,
					{
						DestinationAddress: `#${tmpHash}`, Searchable: true, AllowClear: true, ClearLabel: `— ${pDef.One} —`,
						Placeholder: `Search ${pDef.Phrase}…`,
						DataProvider: this._fundingDataProvider(pDef.Plural, pDef.Field),
						ResolveValue: this._fundingResolveValue(pDef.Singular),
						OnChange: (pValue) => this.setFundingFieldByKey(tmpKey, pDef.Field, pValue),
					});
				if (tmpP && (typeof tmpP.render === 'function')) { tmpP.render(); }
				if (tmpP && (typeof tmpP.setValue === 'function')) { tmpP.setValue(pRow[pDef.Field] > 0 ? pRow[pDef.Field] : ''); }
			});
		});
	}
	_fundingDataProvider(pEntityPlural, pIDField)
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Set: pEntityPlural, IDField: pIDField, Scope: () => `FBV~IDCustomer~EQ~${this.callerCustomer()}~FBV~Deleted~EQ~0`,
				ToOption: (pRec) => ({ Value: Number(pRec[pIDField]), Text: pRec.Name || '(unnamed)', Record: pRec }),
			});
	}
	_fundingResolveValue(pEntitySingular)
	{
		const tmpIDField = `ID${pEntitySingular}`;
		return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`${pEntitySingular}/${tmpID}`).then((pRec) => ((pRec && pRec[tmpIDField]) ? { Value: tmpID, Text: pRec.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })); };
	}

	// ── Render ───────────────────────────────────────────────────────────────────
	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(RAIL_MOUNT).length === 0) { return; }
		if (tmpCA.getElement(RAIL_LIST_MOUNT).length === 0) { tmpCA.assignContent(RAIL_MOUNT, this._railHTML()); }
		else { tmpCA.assignContent(RAIL_LIST_MOUNT, this._railListHTML()); }
		tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML());
		this.mountPickers();
	}
	_renderDetail()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(DETAIL_MOUNT).length > 0) { tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML()); this.mountPickers(); }
		else { this.render(); }
	}

	_railHTML()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (!tmpState.Loaded) { return '<div class="pct-empty">Loading…</div>'; }
		const tmpNew = this.canCreate() ? `<button class="pct-newtype-btn" onclick="_Pict.providers.ProjectContractTypes.showNew()"><i class="fas fa-plus"></i> New ${this._esc(tmpCfg.Label)}</button>` : '';
		return `<input class="pct-rail-search" type="text" autocomplete="off" spellcheck="false" placeholder="Search ${this._esc(tmpCfg.LabelPlural.toLowerCase())}…" value="${this._esc(tmpState.TypeSearch || '')}" oninput="_Pict.providers.ProjectContractTypes.setTypeSearch(this.value)" />`
			+ tmpNew
			+ `<div id="PCT-Rail-List" class="pct-rail-list">${this._railListHTML()}</div>`;
	}
	_railListHTML()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpQuery = String(tmpState.TypeSearch || '').trim().toLowerCase();
		const tmpTypes = (tmpState.Types || []).filter((pT) => !tmpQuery
			|| String(this._typeLabel(pT)).toLowerCase().indexOf(tmpQuery) > -1
			|| String(pT.Hash || '').toLowerCase().indexOf(tmpQuery) > -1
			|| String(pT.Description || '').toLowerCase().indexOf(tmpQuery) > -1);
		if (!tmpTypes.length) { return `<div class="pct-empty">${tmpQuery ? 'No matches.' : `No ${this._esc(tmpCfg.LabelPlural.toLowerCase())} yet.`}</div>`; }
		return tmpTypes.map((pT) =>
		{
			const tmpID = Number(pT[tmpCfg.IDField]);
			const tmpActive = (Number(tmpState.SelectedID) === tmpID) ? ' is-active' : '';
			return `<div class="pct-rail-item${tmpActive}" onclick="_Pict.providers.ProjectContractTypes.selectType(${tmpID})"><div class="pct-rail-name">${this._esc(this._typeLabel(pT))}</div>${pT.Description ? `<div class="pct-rail-sub">${this._esc(String(pT.Description).slice(0, 60))}</div>` : ''}</div>`;
		}).join('');
	}

	_detailHTML()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (tmpState.ShowNew) { return this._formHTML(true); }
		if (!tmpState.SelectedID || !tmpState.Selected) { return `<div class="pct-detail-empty">Pick a ${this._esc(tmpCfg.Label)} on the left to edit it and set up its template — or create a new one.</div>`; }
		return `<div class="pct-detail-head"><div class="pct-detail-title">${this._esc(this._typeLabel(tmpState.Selected))}</div>`
			+ (tmpState.Selected.Hash ? `<div class="pct-detail-sub">${this._esc(tmpState.Selected.Hash)}</div>` : '') + `</div>`
			+ this._prototypeHTML()
			+ this._formHTML(false);
	}

	_prototypeHTML()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpProto = tmpState.Prototype;
		if (tmpState.DetailLoading && !tmpProto) { return `<div class="pct-section"><div class="pct-section-head">Template (prototype ${this._esc(tmpCfg.Kind.toLowerCase())})</div><p class="pct-note">Loading…</p></div>`; }
		if (!tmpProto)
		{
			const tmpBtn = this.canEditDef() ? `<button class="pct-btn pct-btn-primary" onclick="_Pict.providers.ProjectContractTypes.setupPrototypeAsync()">Set up prototype</button>` : '';
			return `<div class="pct-section"><div class="pct-section-head">Template (prototype ${this._esc(tmpCfg.Kind.toLowerCase())})</div>`
				+ `<p class="pct-note">This type has no prototype ${this._esc(tmpCfg.Kind.toLowerCase())} yet — the template new ${this._esc(tmpCfg.Kind.toLowerCase())}s are cloned from. Create it, then configure its dates, labels, observation types and more.</p>${tmpBtn}</div>`;
		}
		const tmpProtoName = String(tmpProto.Name || `${tmpCfg.ProtoEntity} ${tmpProto[tmpCfg.ProtoIDField]}`);
		const tmpSteps = PROTO_STEPS.filter((pStep) => pStep.Kinds.indexOf(tmpCfg.Kind) > -1).map((pStep) =>
		{
			const tmpOrg = (pStep.Scope === 'org') ? '<span class="pct-org">org-wide</span>' : '';
			const tmpGate = (pStep.Scope === 'prototype') && !this.canEditProto();
			return `<button class="pct-step${tmpGate ? ' is-disabled' : ''}"${tmpGate ? ' disabled title="You do not have permission to edit projects."' : ''} onclick="_Pict.providers.ProjectContractTypes.openProtoStep('${pStep.Key}')"><span class="pct-step-label">${this._esc(pStep.Label)}</span>${tmpOrg}</button>`;
		}).join('');
		const tmpOpen = `<button class="pct-btn pct-btn-ghost" onclick="_Pict.providers.ProjectContractTypes.openProtoStep('open')">Open prototype ${this._esc(tmpCfg.Kind.toLowerCase())} →</button>`;
		return `<div class="pct-section"><div class="pct-section-head">Template (prototype ${this._esc(tmpCfg.Kind.toLowerCase())})</div>`
			+ `<p class="pct-note">New ${this._esc(tmpCfg.Kind.toLowerCase())}s of this type are cloned from <b>${this._esc(tmpProtoName)}</b>. Configure the template below — each opens the real editor for the prototype; use the banner at the top to come back.</p>`
			+ `<div class="pct-steps">${tmpSteps}</div><div class="pct-add-row">${tmpOpen}</div></div>`;
	}

	_formHTML(pIsNew)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpEditable = pIsNew ? this.canCreate() : this.canEditDef();
		if (!tmpEditable && pIsNew) { return ''; }
		const tmpDis = tmpEditable ? '' : ' disabled';
		const tmpNotice = tmpState.Notice ? `<div class="pct-notice">${this._esc(tmpState.Notice)}</div>` : '';
		const tmpError = tmpState.Error ? `<div class="pct-error">${this._esc(tmpState.Error)}</div>` : '';
		const tmpBusy = tmpState.Saving ? '<span class="pct-busy">saving…</span>' : '';
		const tmpHead = pIsNew ? `<div class="pct-detail-head"><div class="pct-detail-title">New ${this._esc(tmpCfg.Label)}</div></div>` : '';
		return tmpHead
			+ this._definitionHTML(tmpDis, pIsNew)
			+ this._statusesHTML(tmpEditable)
			+ this._datesHTML(tmpEditable)
			+ (tmpCfg.HasAllowedTypes ? this._allowedHTML(tmpEditable) : '')
			+ (tmpCfg.HasFunding ? this._fundingHTML(tmpEditable) : '')
			+ (tmpEditable ? `<div class="pct-add-row"><button class="pct-btn pct-btn-primary" onclick="_Pict.providers.ProjectContractTypes.saveAsync()">Save ${this._esc(tmpCfg.Label)}</button>${pIsNew ? `<button class="pct-btn pct-btn-ghost" onclick="_Pict.providers.ProjectContractTypes.cancelNew()">Cancel</button>` : ''}${tmpBusy}</div>` : '<p class="pct-note">You can view this type, but editing needs the Update permission.</p>')
			+ tmpNotice + tmpError
			+ ((!pIsNew && this.canDelete()) ? this._dangerHTML() : '');
	}

	_definitionHTML(pDis, pIsNew)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpHashWarn = (!pIsNew && !tmpState.HashChangeConfirmed)
			? `<div class="pct-hint"><i class="fas fa-triangle-exclamation"></i> The short code is a natural key — imports and a contract type's allowed-types list match on it. <label><input type="checkbox" onchange="_Pict.providers.ProjectContractTypes.confirmHashChange(this.checked)"> Yes, let me change it</label></div>`
			: '';
		const tmpHashDis = pDis || ((!pIsNew && !tmpState.HashChangeConfirmed) ? ' disabled' : '');
		const tmpOrdinal = tmpCfg.HasOrdinal ? `<label class="pct-field pct-field-inline"><span>Display order</span><input type="number" step="1"${pDis} value="${Number(tmpState.Def.Ordinal) || 0}" onchange="_Pict.providers.ProjectContractTypes.setDefField('Ordinal', this.value)"></label>` : '';
		return `<div class="pct-section"><div class="pct-section-head">Definition</div>`
			+ `<label class="pct-field"><span>Name</span><input type="text"${pDis} value="${this._esc(tmpState.Def.Name)}" oninput="_Pict.providers.ProjectContractTypes.setDefField('Name', this.value)"></label>`
			+ `<label class="pct-field"><span>Description</span><textarea rows="2"${pDis} oninput="_Pict.providers.ProjectContractTypes.setDefField('Description', this.value)">${this._esc(tmpState.Def.Description)}</textarea></label>`
			+ tmpOrdinal
			+ `<details class="pct-advanced"><summary>Advanced</summary><label class="pct-field"><span>Short code (hash)</span><input type="text"${tmpHashDis} value="${this._esc(tmpState.Def.Hash)}" oninput="_Pict.providers.ProjectContractTypes.setHash(this.value)"></label>${tmpHashWarn}</details>`
			+ `</div>`;
	}

	_statusesHTML(pEditable)
	{
		const tmpState = this.state;
		const tmpRows = (tmpState.Statuses || []).map((pS, pIdx) =>
			`<div class="pct-status-row"><input class="pct-status-name" type="text"${pEditable ? '' : ' disabled'} value="${this._esc(pS.Name)}" oninput="_Pict.providers.ProjectContractTypes.setStatusName(${pIdx}, this.value)" placeholder="Status name">`
			+ `<label class="pct-status-co"><input type="checkbox"${pS.RequiresChangeOrder ? ' checked' : ''}${pEditable ? '' : ' disabled'} onchange="_Pict.providers.ProjectContractTypes.toggleStatusCO(${pIdx}, this.checked)"> Requires a change order</label>`
			+ (pEditable ? `<span class="pct-row-tools"><button class="pct-icon" title="Move up" onclick="_Pict.providers.ProjectContractTypes.moveStatus(${pIdx}, -1)">↑</button><button class="pct-icon" title="Move down" onclick="_Pict.providers.ProjectContractTypes.moveStatus(${pIdx}, 1)">↓</button><button class="pct-icon pct-icon-x" title="Remove" onclick="_Pict.providers.ProjectContractTypes.removeStatus(${pIdx})">✕</button></span>` : '')
			+ `</div>`).join('');
		const tmpAdd = pEditable ? `<button class="pct-btn pct-btn-ghost pct-btn-sm" onclick="_Pict.providers.ProjectContractTypes.addStatus()">+ Add status</button>` : '';
		return `<div class="pct-section"><div class="pct-section-head">Statuses (lifecycle)</div>`
			+ `<p class="pct-note">The stages a ${this._esc(this.cfg.Kind.toLowerCase())} moves through. Tick the ones that require a change order to enter.</p>`
			+ (tmpRows || '<p class="pct-note">No statuses yet.</p>') + tmpAdd + `</div>`;
	}

	_datesHTML(pEditable)
	{
		const tmpState = this.state;
		const tmpRows = (tmpState.DefaultDates || []).map((pD, pIdx) =>
			`<div class="pct-date-row"><input class="pct-date-name" type="text"${pEditable ? '' : ' disabled'} value="${this._esc(pD.Name)}" oninput="_Pict.providers.ProjectContractTypes.setDateName(${pIdx}, this.value)" placeholder="e.g. Notice to Proceed">`
			+ (tmpState.ShowDateCodes ? `<input class="pct-date-code" type="text"${pEditable ? '' : ' disabled'} value="${this._esc(pD.Hash)}" oninput="_Pict.providers.ProjectContractTypes.setDateHash(${pIdx}, this.value)" placeholder="code">` : '')
			+ (pEditable ? `<button class="pct-icon pct-icon-x" title="Remove" onclick="_Pict.providers.ProjectContractTypes.removeDefaultDate(${pIdx})">✕</button>` : '')
			+ `</div>`).join('');
		const tmpTools = pEditable ? `<div class="pct-add-row"><button class="pct-btn pct-btn-ghost pct-btn-sm" onclick="_Pict.providers.ProjectContractTypes.addDefaultDate()">+ Add date</button><button class="pct-btn pct-btn-ghost pct-btn-sm" onclick="_Pict.providers.ProjectContractTypes.toggleDateCodes()">${tmpState.ShowDateCodes ? 'Hide' : 'Show'} agency codes</button></div>` : '';
		return `<div class="pct-section"><div class="pct-section-head">${this._esc(this.cfg.DefaultDatesLabel)}</div>`
			+ `<p class="pct-note">The milestone dates every ${this._esc(this.cfg.Kind.toLowerCase())} of this type should track. Their values are filled in per ${this._esc(this.cfg.Kind.toLowerCase())}.</p>`
			+ (tmpRows || '<p class="pct-note">No default dates yet.</p>') + tmpTools + `</div>`;
	}

	_allowedHTML(pEditable)
	{
		return `<div class="pct-section"><div class="pct-section-head">Allowed project types</div>`
			+ `<p class="pct-note">Which project types can live under a contract of this type. Leave empty to allow any.</p>`
			+ `<div id="PCT-AllowedPicker" class="pct-picker"${pEditable ? '' : ' style="pointer-events:none;opacity:0.6"'}></div></div>`;
	}

	_fundingHTML(pEditable)
	{
		const tmpState = this.state;
		const tmpRows = (tmpState.DefaultFunding || []).map((pRow) =>
			`<div class="pct-fund-row"><div id="PCT-FundSrc-${pRow.Key}" class="pct-fund-pick"></div><div id="PCT-FundCat-${pRow.Key}" class="pct-fund-pick"></div>`
			+ (pEditable ? `<button class="pct-icon pct-icon-x" title="Remove" onclick="_Pict.providers.ProjectContractTypes.removeFundingByKey(${pRow.Key})">✕</button>` : '')
			+ `</div>`).join('');
		const tmpAdd = pEditable ? `<button class="pct-btn pct-btn-ghost pct-btn-sm" onclick="_Pict.providers.ProjectContractTypes.addFunding()">+ Add funding</button>` : '';
		return `<div class="pct-section"><div class="pct-section-head">Default funding</div>`
			+ `<p class="pct-note">Funding sources &amp; categories seeded onto new contracts of this type.</p>`
			+ (tmpRows || '<p class="pct-note">No default funding yet.</p>') + tmpAdd + `</div>`;
	}

	_dangerHTML()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (tmpState.DeleteConfirm)
		{
			const tmpBusy = tmpState.Deleting ? '<span class="pct-busy">deleting…</span>' : '';
			return `<div class="pct-section pct-danger"><div class="pct-section-head">Delete</div>`
				+ `<p class="pct-note">Delete “${this._esc(this._typeLabel(tmpState.Selected))}”? The prototype ${this._esc(tmpCfg.Kind.toLowerCase())} and default-date rows are not removed.</p>`
				+ `<div class="pct-add-row"><button class="pct-btn pct-btn-danger" onclick="_Pict.providers.ProjectContractTypes.deleteTypeAsync()">Delete ${this._esc(tmpCfg.Label)}</button><button class="pct-btn pct-btn-ghost" onclick="_Pict.providers.ProjectContractTypes.cancelDelete()">Cancel</button>${tmpBusy}</div></div>`;
		}
		return `<div class="pct-section pct-danger"><button class="pct-btn pct-btn-ghost pct-btn-danger-link" onclick="_Pict.providers.ProjectContractTypes.askDelete()"><i class="fas fa-trash-can"></i> Delete this type</button></div>`;
	}
}

module.exports = ProjectContractTypesProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ProjectContractTypes',
	AutoInitialize: true,
	AutoInitializeOrdinal: 43,
};

},{"../services/Entity-Picker-Search.js":1398,"./ProjectTypeComprehensionBuilder.js":1366,"pict-provider":845}],1361:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

// The item grid is PAGINATED (server-side for the line/bid item entities; client-side for equipment, whose
// rows are derived from the join and bounded per project). PAGE_SIZE rows per page.
const PAGE_SIZE = 50;
// Equipment (ItemsViaJoin) derives its rows from ProjectEquipmentJoin; cap the join scan so a pathological
// project can't load unbounded, with an honest banner past the cap.
const VIAJOIN_MAX = 5000;
// Chunk id lists for INN filters so a project with hundreds of items never blows the URL length.
const INN_CHUNK = 100;

/**
 * ProjectContractorMatrix — a project-level grid for managing which CONTRACTORS (Organizations) are on which
 * of a project's items, over an M:N join (LineItemOrganizationJoin or BidItemOrganizationJoin). Registered as
 * TWO parameterized instances (ProjectContractorMatrixLine / ProjectContractorMatrixBid) sharing this one
 * class; each is embedded into a host div on the bespoke Project workspace via openInto('Project', id, mount)
 * — the same idiom as ProjectStaffing / RecordDates.
 *
 * Shape (items-as-rows, NOT a literal items×all-orgs matrix — a customer has thousands of orgs): each row is
 * one item, carrying toggle-chips for the project's PARTICIPATING contractors (the distinct orgs already
 * linked anywhere on the project's items + the pinned prime contractor). A chip toggles the item↔org link;
 * a small DBE pill on a linked chip toggles the join's DisadvantagedBusiness flag (LADOTD tracks DBE). A
 * per-row "+ contractor" button reveals a SERVER-SEARCHABLE Organization picker (mounted for that one row
 * only, like ProjectStaffing's "+role" — no picker storm) to add a contractor not yet participating; adding
 * one grows the chip columns. Edits stage into a per-item pending diff and commit on one Save (POST/DELETE/
 * PUT of join rows; IDCustomer is stamped by the server, never sent). A client-side row filter narrows the
 * already-loaded rows without a refetch.
 *
 * Config (from default_configuration, per instance): ItemEntity, ItemsSet, ItemIDField, ItemNumberField,
 * ItemNameField, JoinEntity, JoinsSet, JoinPKField, ProviderIdentifier, MountSelector, ItemNoun.
 */
class ProjectContractorMatrixProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;

		this._IDProject = 0;
		this._IDCustomer = 0;
		this._Mount = '';
		this._loading = false;
		this._loaded = false;
		this._saving = false;
		this._truncated = false;
		this._itemTotal = 0;
		this._message = '';
		this._messageClass = '';
		this._rowFilter = '';

		// Pagination + server-side search (line/bid page items on the server; equipment pages the derived list).
		this._page = 0;
		this._search = '';

		this._items = [];              // the CURRENT page's item rows
		this._viaJoinItems = [];       // ItemsViaJoin mode only: the full derived+filtered item list (client-paged)
		this._joinsByItem = {};        // itemId(string) -> [ { PK, IDOrganization, DBE, CreatingIDUser, IsPlaceholder } ]
		this._participating = [];      // ordered orgId(number) — prime first, then alpha by name
		this._orgLabelByID = {};       // orgId(string) -> name
		this._projectOrgIDs = [];      // the project's organization id-set (ProjectOrganizationJoin) — column + picker scope
		this._prime = 0;               // project's prime contractor IDOrganization (pinned)
		this._pending = {};            // itemId(string) -> { adds:{orgId:dbeBool}, removes:{orgId:true}, dbe:{orgId:bool} }
		this._addForItem = 0;          // the item whose inline add-picker is open (0 = none)
		this._addedItems = {};         // ItemsViaJoin mode: itemId -> { Name } for equipment staged via "+ Add equipment"
		this._removedItems = {};       // ItemsViaJoin mode: itemId -> true for equipment staged for removal from the project

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			// Idempotent by key — both instances register the same block; last identical write wins.
			this.pict.CSSMap.addCSS('ProjectContractorMatrix-CSS', _CSS, 521);
		}
	}

	// --- Config accessors ---
	get cfg() { return this.options || {}; }
	get providerName() { return this.cfg.ProviderIdentifier || 'ProjectContractorMatrix'; }
	// Per-link DisadvantagedBusiness flag — true for line/bid item joins (which have the column); false for
	// ProjectEquipmentJoin (no such column). Default true so the existing instances are unchanged.
	get supportsDBE() { return this.cfg.SupportsDBE !== false; }
	// Equipment mode: rows are DERIVED from the join (ProjectEquipmentJoin), not queried from a project-owned
	// item entity (Equipment is a shared master list with no IDProject). Also drives the "+ Add equipment" control.
	get itemsViaJoin() { return this.cfg.ItemsViaJoin === true; }
	// When set (e.g. 'IDProject'), the join carries the project id: filter the join load by it and stamp it on POST.
	get joinProjectField() { return this.cfg.JoinProjectField || ''; }
	// The master-list entity/set the "+ Add <item>" picker searches (ItemsViaJoin mode only).
	get addItemsSet() { return this.cfg.AddItemsSet || this.cfg.ItemsSet; }

	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	get pickerProvider() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }
	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID || tmpUser.IDCustomer) : 0; }

	/** AppData scratch for this instance (the add-picker's bound value lives here). */
	get scratch()
	{
		const tmpKey = this.providerName;
		if (!this.pict.AppData[tmpKey]) { this.pict.AppData[tmpKey] = { AddPick: '', AddItemPick: '' }; }
		return this.pict.AppData[tmpKey];
	}

	// --- REST helpers ---
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_deleteEntity(pEntity, pID) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.deleteEntity(pEntity, pID, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }

	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_isTruthy(pValue) { return (pValue === true) || (pValue === 1) || (pValue === '1'); }
	_chunk(pArray, pSize) { const tmpOut = []; for (let i = 0; i < pArray.length; i += pSize) { tmpOut.push(pArray.slice(i, i + pSize)); } return tmpOut; }

	_canEdit()
	{
		try
		{
			const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
			if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function'))
			{
				// Gate on the ITEM entity's Update (the proven LineItemBidItemMap gate; the join entity's
				// client-side permission set is less certain), unless GateEntity overrides it — equipment gates
				// on Project-Update, since its link is a project edit, not an edit of the shared Equipment master
				// list. The server still enforces join-level auth on each POST/DELETE at save time.
				return tmpApp.EffectivePermissionsService.can(this.cfg.GateEntity || this.cfg.ItemEntity, 'Update');
			}
		}
		catch (pError) { /* fall through */ }
		return true;
	}

	// --- Open (workspace embed) ---

	/**
	 * Render (and, on a project change, load) the grid into a host element. Safe to call on every workspace
	 * render — reloads only when the project changes; otherwise repaints from cache (the host is torn down
	 * on each whole-view render).
	 * @param {string} pMode  ignored ('Project' — matches the ProjectStaffing/RecordDates openInto signature)
	 * @param {number|string} pID
	 * @param {string} pMountSelector
	 */
	openInto(pMode, pID, pMountSelector)
	{
		const tmpID = Number(pID) || 0;
		this._Mount = pMountSelector || this.cfg.MountSelector;
		if (!tmpID) { return; }
		if (tmpID === this._IDProject && (this._loaded || this._loading))
		{
			this._render();
			return;
		}
		this._IDProject = tmpID;
		this._pending = {};
		this._addedItems = {};
		this._removedItems = {};
		this._addForItem = 0;
		this._rowFilter = '';
		this._page = 0;
		this._search = '';
		this._loaded = false;
		this._loading = true;
		this._message = '';
		this.scratch.AddPick = '';
		this._render();
		this._loadAsync(tmpID).catch((pError) => { this.pict.log.warn(`${this.providerName} load failed: ${pError && (pError.message || pError)}`); this._loading = false; this._loaded = true; this._render(); });
	}

	async _loadAsync(pIDProject)
	{
		const tmpProject = await this._getJSON(`Project/${pIDProject}`);
		this._IDCustomer = (tmpProject && Number(tmpProject.IDCustomer)) || this.callerCustomer();
		this._prime = (tmpProject && Number(tmpProject.IDOrganization)) || 0;

		// The project's organization set — the CONTRACTOR columns (stable across pages) and the add-picker's
		// candidate scope (issue #2: never the whole customer org list). Loaded once per project open.
		await this._loadProjectOrgsAsync(pIDProject);

		if (this.itemsViaJoin)
		{
			await this._loadViaJoinAsync(pIDProject);
		}
		else
		{
			await this._loadItemPageAsync();
		}

		this._loading = false;
		this._loaded = true;
		this._render();
	}

	/** Load the project's organization id-set (ProjectOrganizationJoin) + labels — the contractor column scope. */
	async _loadProjectOrgsAsync(pIDProject)
	{
		// ProjectOrganizationJoin is HARD-delete (no Deleted column — a ~FBV~Deleted~EQ~0 clause errors and drops
		// the whole result), so filter by project only.
		const tmpRows = await this._getJSON(`ProjectOrganizationJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}/0/2000`);
		const tmpIDs = new Set();
		(Array.isArray(tmpRows) ? tmpRows : []).forEach((pJoin) => { const tmpID = Number(pJoin.IDOrganization); if (tmpID > 0) { tmpIDs.add(tmpID); } });
		if (this._prime > 0) { tmpIDs.add(this._prime); }
		this._projectOrgIDs = Array.from(tmpIDs);
		await this._resolveOrgLabels(this._projectOrgIDs);
	}

	/** Server-side item page (line/bid): the current page's rows + true total, honoring the search term. */
	async _loadItemPageAsync()
	{
		const tmpSortField = this.cfg.SortField || this.cfg.ItemNumberField || 'Name';
		const tmpSearch = this._search.trim();
		const tmpSearchClause = tmpSearch ? `~FBV~${this.cfg.ItemNameField || 'Name'}~LK~${encodeURIComponent(`%${tmpSearch}%`)}` : '';
		const tmpBaseFilter = `FBV~IDProject~EQ~${this._IDProject}~FBV~Deleted~EQ~0${tmpSearchClause}`;
		const tmpStart = this._page * PAGE_SIZE;
		const [ tmpItems, tmpCount ] = await Promise.all(
			[
				this._getJSON(`${this.cfg.ItemsSet}/FilteredTo/${tmpBaseFilter}~FSF~${tmpSortField}~ASC~0/${tmpStart}/${PAGE_SIZE}`),
				this._getJSON(`${this.cfg.ItemsSet}/Count/FilteredTo/${tmpBaseFilter}`),
			]);
		this._items = Array.isArray(tmpItems) ? tmpItems : [];
		this._itemTotal = (tmpCount && (tmpCount.Count != null)) ? Number(tmpCount.Count) : this._items.length;
		this._truncated = false;
		await this._loadJoinsAsync();
	}

	/**
	 * Equipment (ItemsViaJoin): the project's equipment is defined ONLY by ProjectEquipmentJoin rows (Equipment is
	 * a shared master list with no IDProject). Load ALL the project's join rows once (filtered by JoinProjectField),
	 * bucket them, derive the distinct item list + names, then page + filter that list client-side.
	 */
	async _loadViaJoinAsync(pIDProject)
	{
		this._joinsByItem = {};
		const tmpField = this.joinProjectField || 'IDProject';
		let tmpAll = [];
		for (let tmpStart = 0; tmpStart < VIAJOIN_MAX; tmpStart += 1000)
		{
			/* eslint-disable-next-line no-await-in-loop */
			const tmpRows = await this._getJSON(`${this.cfg.JoinsSet}/FilteredTo/FBV~${tmpField}~EQ~${pIDProject}/${tmpStart}/1000`);
			if (!Array.isArray(tmpRows) || tmpRows.length === 0) { break; }
			tmpAll = tmpAll.concat(tmpRows);
			if (tmpRows.length < 1000) { break; }
		}
		this._truncated = (tmpAll.length >= VIAJOIN_MAX);
		// Bucket joins by item; an IDOrganization=0 row is a "on the project, unattributed" PLACEHOLDER, not a link.
		const tmpItemIDs = new Set();
		const tmpOrgIDs = new Set(this._projectOrgIDs);
		tmpAll.forEach((pJoin) =>
		{
			const tmpItemID = Number(pJoin[this.cfg.ItemIDField]);
			if (!(tmpItemID > 0)) { return; }
			tmpItemIDs.add(tmpItemID);
			const tmpKey = String(tmpItemID);
			if (!this._joinsByItem[tmpKey]) { this._joinsByItem[tmpKey] = []; }
			const tmpOrg = Number(pJoin.IDOrganization) || 0;
			this._joinsByItem[tmpKey].push({ PK: Number(pJoin[this.cfg.JoinPKField]), IDOrganization: tmpOrg, DBE: false, IsPlaceholder: (tmpOrg === 0) });
			if (tmpOrg > 0) { tmpOrgIDs.add(tmpOrg); }
		});
		// Resolve item (equipment) names + GUIDs via the master-list set, chunked INN.
		const tmpRecords = await this._resolveItemRecords(Array.from(tmpItemIDs));
		// Build the master row list, DEDUPED BY GUID: a customer can carry duplicate equipment records that share a
		// GUID (e.g. a re-import — "Air Compressor" as both IDEquipment 2 and 4016, GUID LADOTD-EQP-A15), and a project
		// can hold join rows to BOTH, so the raw list shows the same equipment twice. Collapse same-GUID records into
		// ONE row, merging their join buckets under a canonical id (the one with the most links; tiebreak lowest id).
		// Records with no GUID stay distinct. Line/bid items don't set ItemGUIDField, so they're never deduped.
		this._viaJoinMaster = [];
		this._projectItemGUIDs = {};
		const fLinkCount = (pID) => (this._joinsByItem[String(pID)] || []).length;
		const fMaster = (pCanonID, pAliasIDs, pGUID) =>
		{
			const tmpKey = String(pCanonID);
			if (!this._joinsByItem[tmpKey]) { this._joinsByItem[tmpKey] = []; }
			pAliasIDs.forEach((pAlias) =>
			{
				if (Number(pAlias) === Number(pCanonID)) { return; }
				(this._joinsByItem[String(pAlias)] || []).forEach((pLink) => this._joinsByItem[tmpKey].push(pLink));
				delete this._joinsByItem[String(pAlias)];
			});
			if (pGUID) { this._projectItemGUIDs[pGUID] = pCanonID; }
			this._viaJoinMaster.push({ [this.cfg.ItemIDField]: pCanonID, [this.cfg.ItemNameField]: (tmpRecords[tmpKey] && tmpRecords[tmpKey].Name) || `${this.cfg.ItemNoun} ${pCanonID}` });
		};
		if (this.cfg.ItemGUIDField)
		{
			const tmpByGUID = {};
			const tmpNoGuid = [];
			Array.from(tmpItemIDs).forEach((pID) =>
			{
				const tmpGUID = (tmpRecords[String(pID)] && tmpRecords[String(pID)].GUID) || '';
				if (tmpGUID) { (tmpByGUID[tmpGUID] = tmpByGUID[tmpGUID] || []).push(pID); }
				else { tmpNoGuid.push(pID); }
			});
			Object.keys(tmpByGUID).forEach((pGUID) =>
			{
				const tmpIDs = tmpByGUID[pGUID];
				const tmpCanon = tmpIDs.slice().sort((pA, pB) => (fLinkCount(pB) - fLinkCount(pA)) || (pA - pB))[0];
				fMaster(tmpCanon, tmpIDs, pGUID);
			});
			tmpNoGuid.forEach((pID) => fMaster(pID, [ pID ], ''));
		}
		else
		{
			Array.from(tmpItemIDs).forEach((pID) => fMaster(pID, [ pID ], ''));
		}
		await this._resolveOrgLabels(Array.from(tmpOrgIDs));
		this._rebuildParticipating();
		this._rebuildViaJoinPage();
	}

	/** Resolve item (equipment) name + GUID by INN over the master-list set. */
	async _resolveItemRecords(pItemIDs)
	{
		const tmpMap = {};
		const tmpGUIDField = this.cfg.ItemGUIDField;
		const tmpUnique = Array.from(new Set((pItemIDs || []).map(Number).filter((pID) => pID > 0)));
		const tmpChunks = this._chunk(tmpUnique, INN_CHUNK);
		const tmpResults = await Promise.all(tmpChunks.map((pChunk) =>
			this._getJSON(`${this.cfg.ItemsSet}/FilteredTo/FBL~${this.cfg.ItemIDField}~INN~${pChunk.join(',')}~FBV~Deleted~EQ~0/0/${INN_CHUNK}`)));
		tmpResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pRow) =>
		{
			if (pRow && (pRow[this.cfg.ItemIDField] != null))
			{
				tmpMap[String(pRow[this.cfg.ItemIDField])] = { Name: pRow[this.cfg.ItemNameField] || pRow.Name || '', GUID: tmpGUIDField ? (pRow[tmpGUIDField] || '') : '' };
			}
		}));
		return tmpMap;
	}

	/** ItemsViaJoin: (re)compute the current page of the derived item list, applying the client-side search + staged adds/removes. */
	_rebuildViaJoinPage()
	{
		const tmpQuery = this._search.trim().toLowerCase();
		let tmpAll = (this._viaJoinMaster || []).slice();
		// Fold in equipment staged via "+ Add equipment" (not yet saved) and drop equipment staged for removal.
		Object.keys(this._addedItems).forEach((pID) =>
		{
			if (!tmpAll.some((pItem) => String(pItem[this.cfg.ItemIDField]) === String(pID)))
			{
				tmpAll.push({ [this.cfg.ItemIDField]: Number(pID), [this.cfg.ItemNameField]: this._addedItems[pID].Name });
			}
		});
		tmpAll = tmpAll.filter((pItem) => !this._removedItems[String(pItem[this.cfg.ItemIDField])]);
		tmpAll.sort((pA, pB) => String(pA[this.cfg.ItemNameField] || '').localeCompare(String(pB[this.cfg.ItemNameField] || '')));
		if (tmpQuery) { tmpAll = tmpAll.filter((pItem) => String(pItem[this.cfg.ItemNameField] || '').toLowerCase().indexOf(tmpQuery) >= 0); }
		this._itemTotal = tmpAll.length;
		this._viaJoinItems = tmpAll;
		const tmpStart = this._page * PAGE_SIZE;
		this._items = tmpAll.slice(tmpStart, tmpStart + PAGE_SIZE);
	}

	/** (Re)load the join rows for the loaded items, rebuild the participating-contractor set + org labels. */
	async _loadJoinsAsync()
	{
		const tmpItemIDs = this._items.map((pItem) => Number(pItem[this.cfg.ItemIDField])).filter((pV) => pV > 0);
		this._joinsByItem = {};
		let tmpAllJoins = [];
		if (tmpItemIDs.length > 0)
		{
			// NOTE: these join tables (LineItemOrganizationJoin / BidItemOrganizationJoin) are HARD-delete —
			// they have no Deleted column, so a ~FBV~Deleted~EQ~0 clause errors ("Unknown column") and drops
			// the whole result. Filter by item id only. (A unique key AK_<Join>(item,org) means link/unlink is
			// create/hard-delete, with no soft-deleted row to revive.)
			const tmpChunks = this._chunk(tmpItemIDs, INN_CHUNK);
			const tmpResults = await Promise.all(tmpChunks.map((pChunk) =>
				this._getJSON(`${this.cfg.JoinsSet}/FilteredTo/FBL~${this.cfg.ItemIDField}~INN~${pChunk.join(',')}/0/${INN_CHUNK * 50}`)));
			tmpResults.forEach((pRows) => { if (Array.isArray(pRows)) { tmpAllJoins = tmpAllJoins.concat(pRows); } });
		}
		tmpAllJoins.forEach((pJoin) =>
		{
			const tmpItemKey = String(pJoin[this.cfg.ItemIDField]);
			if (!this._joinsByItem[tmpItemKey]) { this._joinsByItem[tmpItemKey] = []; }
			this._joinsByItem[tmpItemKey].push(
				{
					PK: Number(pJoin[this.cfg.JoinPKField]),
					IDOrganization: Number(pJoin.IDOrganization),
					DBE: this._isTruthy(pJoin.DisadvantagedBusiness),
					CreatingIDUser: Number(pJoin.CreatingIDUser) || 0,
				});
		});

		// Participating set = distinct linked orgs + the prime contractor. Load labels for all of them.
		const tmpOrgIDs = new Set();
		if (this._prime > 0) { tmpOrgIDs.add(this._prime); }
		tmpAllJoins.forEach((pJoin) => { const tmpID = Number(pJoin.IDOrganization); if (tmpID > 0) { tmpOrgIDs.add(tmpID); } });
		await this._resolveOrgLabels(Array.from(tmpOrgIDs));
		this._rebuildParticipating();
	}

	/** Batch-resolve organization names (chunked INN), merged into the label cache. */
	async _resolveOrgLabels(pOrgIDs)
	{
		const tmpMissing = (pOrgIDs || []).map(Number).filter((pID) => pID > 0 && !this._orgLabelByID[String(pID)]);
		if (tmpMissing.length === 0) { return; }
		const tmpChunks = this._chunk(tmpMissing, INN_CHUNK);
		const tmpResults = await Promise.all(tmpChunks.map((pChunk) =>
			this._getJSON(`Organizations/FilteredTo/FBL~IDOrganization~INN~${pChunk.join(',')}/0/${INN_CHUNK}`)));
		tmpResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pOrg) =>
		{
			if (pOrg && pOrg.IDOrganization != null) { this._orgLabelByID[String(pOrg.IDOrganization)] = pOrg.Name || `Organization ${pOrg.IDOrganization}`; }
		}));
	}

	/** Rebuild the ordered participating-contractor column set: prime first, then alpha by name. */
	_rebuildParticipating()
	{
		const tmpSet = new Set();
		if (this._prime > 0) { tmpSet.add(this._prime); }
		// The project's organizations are the stable contractor columns (project-scoped, consistent across pages).
		(this._projectOrgIDs || []).forEach((pID) => { if (pID > 0) { tmpSet.add(Number(pID)); } });
		Object.keys(this._joinsByItem).forEach((pItemKey) => this._joinsByItem[pItemKey].forEach((pJoin) => { if (pJoin.IDOrganization > 0) { tmpSet.add(pJoin.IDOrganization); } }));
		// Any orgs the user added via search this session (staged in pending adds) keep their columns too.
		Object.keys(this._pending).forEach((pItemKey) => Object.keys(this._pending[pItemKey].adds || {}).forEach((pOrg) => tmpSet.add(Number(pOrg))));
		const tmpList = Array.from(tmpSet);
		tmpList.sort((pA, pB) =>
		{
			if (pA === this._prime) { return -1; }
			if (pB === this._prime) { return 1; }
			return String(this._orgLabelByID[String(pA)] || pA).localeCompare(String(this._orgLabelByID[String(pB)] || pB));
		});
		this._participating = tmpList;
	}

	_orgLabel(pOrgID) { return this._orgLabelByID[String(pOrgID)] || `Organization ${pOrgID}`; }

	// --- Pending diff model ---

	_pendingFor(pItemID) { const tmpKey = String(pItemID); if (!this._pending[tmpKey]) { this._pending[tmpKey] = { adds: {}, removes: {}, dbe: {} }; } return this._pending[tmpKey]; }
	_cleanPending(pItemID) { const tmpKey = String(pItemID); const tmpP = this._pending[tmpKey]; if (tmpP && Object.keys(tmpP.adds).length === 0 && Object.keys(tmpP.removes).length === 0 && Object.keys(tmpP.dbe).length === 0) { delete this._pending[tmpKey]; } }
	_origJoin(pItemID, pOrgID) { return (this._joinsByItem[String(pItemID)] || []).find((pJoin) => pJoin.IDOrganization === Number(pOrgID)); }
	// ALL joins for an org on an item — a GUID-merged equipment row can carry the same org twice (once per
	// duplicate record), so a remove must delete every matching link, not just the first.
	_origJoins(pItemID, pOrgID) { return (this._joinsByItem[String(pItemID)] || []).filter((pJoin) => pJoin.IDOrganization === Number(pOrgID)); }
	_origLinked(pItemID, pOrgID) { return !!this._origJoin(pItemID, pOrgID); }
	_origDBE(pItemID, pOrgID) { const tmpJoin = this._origJoin(pItemID, pOrgID); return tmpJoin ? !!tmpJoin.DBE : false; }

	_isLinked(pItemID, pOrgID)
	{
		const tmpP = this._pending[String(pItemID)];
		const tmpOrg = String(pOrgID);
		if (tmpP)
		{
			if (tmpP.adds[tmpOrg] !== undefined) { return true; }
			if (tmpP.removes[tmpOrg]) { return false; }
		}
		return this._origLinked(pItemID, pOrgID);
	}

	_cellDBE(pItemID, pOrgID)
	{
		const tmpP = this._pending[String(pItemID)];
		const tmpOrg = String(pOrgID);
		if (tmpP && tmpP.adds[tmpOrg] !== undefined) { return !!tmpP.adds[tmpOrg]; }
		if (tmpP && tmpP.dbe[tmpOrg] !== undefined) { return !!tmpP.dbe[tmpOrg]; }
		return this._origDBE(pItemID, pOrgID);
	}

	_isStaged(pItemID, pOrgID)
	{
		const tmpP = this._pending[String(pItemID)];
		if (!tmpP) { return false; }
		const tmpOrg = String(pOrgID);
		return (tmpP.adds[tmpOrg] !== undefined) || (!!tmpP.removes[tmpOrg]) || (tmpP.dbe[tmpOrg] !== undefined);
	}

	pendingCount()
	{
		let tmpN = 0;
		Object.keys(this._pending).forEach((pKey) => { const tmpP = this._pending[pKey]; tmpN += Object.keys(tmpP.adds).length + Object.keys(tmpP.removes).length + Object.keys(tmpP.dbe).length; });
		// Equipment: staged add/remove of an item is itself a change even with no contractor toggles.
		Object.keys(this._addedItems).forEach((pKey) => { if (!this._pending[pKey]) { tmpN += 1; } });
		Object.keys(this._removedItems).forEach((pKey) => { tmpN += 1; });
		return tmpN;
	}

	/** The final set of REAL (org>0) contractors for an item after overlaying the pending diff — used for placeholder reconciliation. */
	_finalRealOrgs(pItemID)
	{
		const tmpKey = String(pItemID);
		const tmpSet = new Set((this._joinsByItem[tmpKey] || []).filter((pJoin) => pJoin.IDOrganization > 0).map((pJoin) => pJoin.IDOrganization));
		const tmpP = this._pending[tmpKey];
		if (tmpP)
		{
			Object.keys(tmpP.adds).forEach((pOrg) => tmpSet.add(Number(pOrg)));
			Object.keys(tmpP.removes).forEach((pOrg) => tmpSet.delete(Number(pOrg)));
		}
		return tmpSet;
	}

	/** The IDOrganization=0 "unattributed" placeholder join(s) for an item (a merged row may carry more than one). */
	_placeholderJoin(pItemID) { return (this._joinsByItem[String(pItemID)] || []).find((pJoin) => pJoin.IsPlaceholder); }
	_placeholderJoins(pItemID) { return (this._joinsByItem[String(pItemID)] || []).filter((pJoin) => pJoin.IsPlaceholder); }

	// --- Interactions ---

	toggleContractor(pItemID, pOrgID)
	{
		if (!this._canEdit()) { return; }
		const tmpP = this._pendingFor(pItemID);
		const tmpOrg = String(pOrgID);
		if (this._isLinked(pItemID, pOrgID))
		{
			if (tmpP.adds[tmpOrg] !== undefined) { delete tmpP.adds[tmpOrg]; }
			else { tmpP.removes[tmpOrg] = true; delete tmpP.dbe[tmpOrg]; }
		}
		else
		{
			if (tmpP.removes[tmpOrg]) { delete tmpP.removes[tmpOrg]; }
			else { tmpP.adds[tmpOrg] = false; }
		}
		this._cleanPending(pItemID);
		this._repaintRow(pItemID);
		this._syncSaveBar();
	}

	toggleDBE(pItemID, pOrgID)
	{
		if (!this._canEdit()) { return; }
		if (!this._isLinked(pItemID, pOrgID)) { return; }
		const tmpP = this._pendingFor(pItemID);
		const tmpOrg = String(pOrgID);
		if (tmpP.adds[tmpOrg] !== undefined)
		{
			tmpP.adds[tmpOrg] = !tmpP.adds[tmpOrg];
		}
		else
		{
			const tmpOrig = this._origDBE(pItemID, pOrgID);
			const tmpCur = (tmpP.dbe[tmpOrg] !== undefined) ? tmpP.dbe[tmpOrg] : tmpOrig;
			const tmpNext = !tmpCur;
			if (tmpNext === tmpOrig) { delete tmpP.dbe[tmpOrg]; }
			else { tmpP.dbe[tmpOrg] = tmpNext; }
		}
		this._cleanPending(pItemID);
		this._repaintRow(pItemID);
		this._syncSaveBar();
	}

	/** Open (or close) the inline add-a-contractor picker for one row. Only one row's picker mounts at a time. */
	toggleAddPicker(pItemID)
	{
		const tmpID = Number(pItemID) || 0;
		this._addForItem = (this._addForItem === tmpID) ? 0 : tmpID;
		this.scratch.AddPick = '';
		this._render();
	}

	/** The add-picker chose an organization: stage it as a link on the open row (grows the column set). */
	onAddPick(pOrgID)
	{
		const tmpOrg = Number(pOrgID) || 0;
		const tmpItem = this._addForItem;
		if (!tmpOrg || !tmpItem) { return; }
		// Stage the link FIRST (so _rebuildParticipating sees it in pending), unless already linked on this item.
		if (!this._isLinked(tmpItem, tmpOrg))
		{
			const tmpP = this._pendingFor(tmpItem);
			const tmpKey = String(tmpOrg);
			if (tmpP.removes[tmpKey]) { delete tmpP.removes[tmpKey]; }
			else { tmpP.adds[tmpKey] = false; }
			this._cleanPending(tmpItem);
		}
		// A newly-picked contractor becomes a participating COLUMN on every row, so a full repaint is needed
		// (not just this row). The open row's picker re-mounts afterwards because _addForItem stays set.
		this._rebuildParticipating();
		this.scratch.AddPick = '';
		this._render();
	}

	// --- Equipment (ItemsViaJoin) item add/remove ---

	/** Open/close the top-level "+ Add equipment" picker (ItemsViaJoin mode). */
	toggleAddItemPicker()
	{
		if (!this._canEdit()) { return; }
		this._addItemOpen = !this._addItemOpen;
		this.scratch.AddItemPick = '';
		this._render();
	}

	/** The add-item picker chose a piece of equipment: stage it onto the project (a row appears; it persists on save). */
	onAddItem(pItemID)
	{
		const tmpID = Number(pItemID) || 0;
		if (!tmpID) { return; }
		// Already on the project (loaded or staged)? just close.
		const tmpOnProject = (this._viaJoinMaster || []).some((pItem) => Number(pItem[this.cfg.ItemIDField]) === tmpID) || !!this._addedItems[String(tmpID)];
		if (this._removedItems[String(tmpID)]) { delete this._removedItems[String(tmpID)]; }
		if (!tmpOnProject)
		{
			this._addedItems[String(tmpID)] = { Name: (this._addItemNameByID && this._addItemNameByID[String(tmpID)]) || `${this.cfg.ItemNoun} ${tmpID}` };
		}
		this._addItemOpen = false;
		this.scratch.AddItemPick = '';
		this._page = 0;
		this._rebuildViaJoinPage();
		this._render();
	}

	/** Row × (ItemsViaJoin mode): stage this equipment for removal from the project (all its links go on save). */
	removeItem(pItemID)
	{
		if (!this._canEdit()) { return; }
		const tmpKey = String(pItemID);
		if (this._addedItems[tmpKey])
		{
			// Never-saved staged add — just drop it.
			delete this._addedItems[tmpKey];
			delete this._pending[tmpKey];
		}
		else if (this._removedItems[tmpKey])
		{
			delete this._removedItems[tmpKey];
		}
		else
		{
			this._removedItems[tmpKey] = true;
			delete this._pending[tmpKey];   // pending org edits are moot once the item leaves the project
		}
		this._rebuildViaJoinPage();
		this._render();
	}

	/** Equipment master-list search for "+ Add equipment", customer-scoped, excluding equipment already on the project. */
	_addItemDataProvider()
	{
		const tmpPageSize = 25;
		if (!this._addItemNameByID) { this._addItemNameByID = {}; }
		const fOnProject = (pID) => (this._viaJoinMaster || []).some((pItem) => Number(pItem[this.cfg.ItemIDField]) === Number(pID)) || !!this._addedItems[String(pID)];
		// Don't offer an item already on the project — by id, OR (equipment) by a GUID a duplicate record already covers.
		const fDuplicate = (pRow) => { const tmpGUID = this.cfg.ItemGUIDField ? (pRow[this.cfg.ItemGUIDField] || '') : ''; return !!(tmpGUID && this._projectItemGUIDs && this._projectItemGUIDs[tmpGUID]); };
		const fMap = (pRows) => (Array.isArray(pRows) ? pRows : [])
			.filter((pRow) => pRow && (pRow[this.cfg.ItemIDField] != null) && !fOnProject(pRow[this.cfg.ItemIDField]) && !fDuplicate(pRow))
			.map((pRow) =>
			{
				this._addItemNameByID[String(pRow[this.cfg.ItemIDField])] = pRow[this.cfg.ItemNameField] || pRow.Name || `${this.cfg.ItemNoun} ${pRow[this.cfg.ItemIDField]}`;
				return { Value: Number(pRow[this.cfg.ItemIDField]), Text: this._addItemNameByID[String(pRow[this.cfg.ItemIDField])], Record: pRow };
			});
		const tmpScope = `~FBV~IDCustomer~EQ~${this._IDCustomer || this.callerCustomer()}~FBV~Deleted~EQ~0`;
		const tmpNameField = this.cfg.ItemNameField || 'Name';
		return (pTerm, pPage) =>
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			if (!tmpTerm)
			{
				const tmpStart = (Number(pPage) || 0) * tmpPageSize;
				return this._getJSON(`${this.addItemsSet}/FilteredTo/FBV~IDCustomer~EQ~${this._IDCustomer || this.callerCustomer()}~FBV~Deleted~EQ~0~FSF~${tmpNameField}~ASC~0/${tmpStart}/${tmpPageSize}`)
					.then((pRows) => ({ results: fMap(pRows), hasMore: (Array.isArray(pRows) && pRows.length >= tmpPageSize) }));
			}
			return this._getJSON(`${this.addItemsSet}/FilteredTo/FBV~${tmpNameField}~LK~${encodeURIComponent(`%${tmpTerm}%`)}${tmpScope}/0/${tmpPageSize}`)
				.then((pRows) => ({ results: fMap(pRows), hasMore: false }));
		};
	}

	_addItemResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			const tmpName = this._addItemNameByID && this._addItemNameByID[String(tmpID)];
			return Promise.resolve({ Value: tmpID, Text: tmpName || `#${tmpID}` });
		};
	}

	// --- Search + pagination ---

	/** Debounced search: reset to page 0 and reload the item page (server-side for line/bid, client-side for equipment). */
	setSearch(pValue)
	{
		this._search = String(pValue == null ? '' : pValue);
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(() => { this._searchTimer = null; this._page = 0; this._reloadPage(); }, 300);
	}

	_pageCount() { return Math.max(1, Math.ceil((this._itemTotal || 0) / PAGE_SIZE)); }

	goToPage(pPage)
	{
		const tmpPage = Math.max(0, Math.min(this._pageCount() - 1, Number(pPage) || 0));
		if (tmpPage === this._page) { return; }
		this._page = tmpPage;
		this._reloadPage();
	}

	/** Reload just the current page (equipment re-slices the in-memory list; line/bid re-queries the server). */
	async _reloadPage()
	{
		if (this.itemsViaJoin)
		{
			this._rebuildViaJoinPage();
			this._renderResults();
			return;
		}
		this._loading = true;
		this._renderResults();
		try { await this._loadItemPageAsync(); }
		catch (pError) { this.pict.log.warn(`${this.providerName} page load failed: ${pError && (pError.message || pError)}`); }
		this._loading = false;
		this._renderResults();
	}

	// --- Save ---

	async saveAsync()
	{
		if (!this._canEdit()) { this._flash('You do not have permission to manage contractor links.', 'is-danger'); this._syncSaveBar(); return; }
		const tmpItemKeys = Array.from(new Set([].concat(Object.keys(this._pending), Object.keys(this._addedItems), Object.keys(this._removedItems))));
		if (tmpItemKeys.length === 0 || this._saving) { return; }

		this._saving = true;
		this._syncSaveBar();

		let tmpOK = 0;
		let tmpFail = 0;
		const fCount = (pRes) => { if (pRes && !pRes.error) { tmpOK++; } else { tmpFail++; } };
		for (let i = 0; i < tmpItemKeys.length; i++)
		{
			const tmpItemKey = tmpItemKeys[i];
			const tmpItemID = Number(tmpItemKey);

			// Equipment removed from the project — hard-delete every one of its join rows (real + placeholder).
			if (this.itemsViaJoin && this._removedItems[tmpItemKey])
			{
				for (const tmpJoin of (this._joinsByItem[tmpItemKey] || [])) { fCount(await this._deleteEntity(this.cfg.JoinEntity, tmpJoin.PK)); }
				continue;
			}

			const tmpP = this._pending[tmpItemKey] || { adds: {}, removes: {}, dbe: {} };

			// Adds — POST a new join (skip if the join already exists on the server, guarding double-submit).
			for (const tmpOrg of Object.keys(tmpP.adds))
			{
				if (this._origLinked(tmpItemID, tmpOrg)) { continue; }
				const tmpBody = { [this.cfg.ItemIDField]: tmpItemID, IDOrganization: Number(tmpOrg) };
				if (this.joinProjectField) { tmpBody[this.joinProjectField] = this._IDProject; }
				if (this.supportsDBE) { tmpBody.DisadvantagedBusiness = tmpP.adds[tmpOrg] ? 1 : 0; }
				const tmpRes = await this._postJSON(this.cfg.JoinEntity, tmpBody);
				if (tmpRes && !tmpRes.error && tmpRes.result && tmpRes.result[this.cfg.JoinPKField]) { tmpOK++; } else { tmpFail++; }
			}
			// Removes — DELETE every existing join for the org by PK (a GUID-merged row may hold more than one).
			for (const tmpOrg of Object.keys(tmpP.removes))
			{
				for (const tmpJoin of this._origJoins(tmpItemID, tmpOrg))
				{
					fCount(await this._deleteEntity(this.cfg.JoinEntity, tmpJoin.PK));
				}
			}
			// DBE changes on existing joins — PUT the flag (only where the join carries the column).
			if (this.supportsDBE)
			{
				for (const tmpOrg of Object.keys(tmpP.dbe))
				{
					const tmpJoin = this._origJoin(tmpItemID, tmpOrg);
					if (!tmpJoin) { continue; }
					fCount(await this._putJSON(this.cfg.JoinEntity, { [this.cfg.JoinPKField]: tmpJoin.PK, DisadvantagedBusiness: tmpP.dbe[tmpOrg] ? 1 : 0 }));
				}
			}
			// Equipment: keep the item ON the project with an IDOrganization=0 placeholder when it ends with no real
			// contractor, and clean the placeholder up once it has one. (Fieldbook drops org=0 rows, but the row keeps
			// the equipment attached to the project.)
			if (this.itemsViaJoin)
			{
				const tmpFinal = this._finalRealOrgs(tmpItemID);
				const tmpPlaceholder = this._placeholderJoin(tmpItemID);
				if (tmpFinal.size === 0 && !tmpPlaceholder)
				{
					const tmpBody = { [this.cfg.ItemIDField]: tmpItemID, IDOrganization: 0 };
					if (this.joinProjectField) { tmpBody[this.joinProjectField] = this._IDProject; }
					const tmpRes = await this._postJSON(this.cfg.JoinEntity, tmpBody);
					if (tmpRes && !tmpRes.error && tmpRes.result && tmpRes.result[this.cfg.JoinPKField]) { tmpOK++; } else { tmpFail++; }
				}
				else if (tmpFinal.size > 0 && tmpPlaceholder)
				{
					for (const tmpPH of this._placeholderJoins(tmpItemID))
					{
						fCount(await this._deleteEntity(this.cfg.JoinEntity, tmpPH.PK));
					}
				}
			}
		}

		// Refresh from the server so the grid reflects committed state, then clear the diff.
		if (this.itemsViaJoin) { await this._loadViaJoinAsync(this._IDProject); }
		else { await this._loadJoinsAsync(); }
		this._pending = {};
		this._addedItems = {};
		this._removedItems = {};
		this._saving = false;
		const tmpNote = tmpFail ? `, ${tmpFail} failed (a link may already exist, or you may lack permission)` : '';
		this._flash(`Saved ${tmpOK} change${tmpOK === 1 ? '' : 's'}${tmpNote}.`, tmpFail ? 'is-warning' : 'is-success');
		this._render();
	}

	_flash(pMessage, pClass) { this._message = pMessage; this._messageClass = pClass || 'is-info'; }

	// --- Render ---

	_syncSaveBar()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !this._Mount) { return; }
		if (tmpCA.getElement(`${this._Mount} .pcm-savebar`).length === 0) { return; }
		tmpCA.assignContent(`${this._Mount} .pcm-savebar`, this._saveBarHTML());
	}

	_saveBarHTML()
	{
		const tmpCount = this.pendingCount();
		const tmpDisabled = (tmpCount === 0 || this._saving || !this._canEdit()) ? 'disabled' : '';
		const tmpLabel = this._saving ? 'Saving…' : (tmpCount > 0 ? `Save ${tmpCount} change${tmpCount === 1 ? '' : 's'}` : 'No changes');
		return /*html*/`
			<span class="pcm-pending">${tmpCount > 0 ? `${tmpCount} unsaved change${tmpCount === 1 ? '' : 's'}` : 'All contractor links saved'}</span>
			<button class="pcm-btn pcm-btn-primary" ${tmpDisabled} onclick="_Pict.providers.${this.providerName}.saveAsync()">${tmpLabel}</button>`;
	}

	/** Repaint just one row's chips cell (keeps the rest of the grid + any open picker intact). */
	_repaintRow(pItemID)
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !this._Mount) { return; }
		const tmpSel = `${this._Mount} tr[data-item="${pItemID}"] .pcm-chips`;
		if (tmpCA.getElement(tmpSel).length === 0) { return; }
		tmpCA.assignContent(tmpSel, this._chipsHTML(pItemID));
		const tmpRowEl = tmpCA.getElement(`${this._Mount} tr[data-item="${pItemID}"]`);
		if (tmpRowEl && tmpRowEl.length && tmpRowEl[0].classList) { tmpRowEl[0].classList.toggle('pcm-row-changed', !!this._pending[String(pItemID)]); }
	}

	_chipsHTML(pItemID)
	{
		const tmpEditable = this._canEdit();
		if (this._participating.length === 0)
		{
			return `<span class="pcm-empty-chips">No contractors on this project yet — use “+ contractor”.</span>`;
		}
		return this._participating.map((pOrgID) =>
		{
			const tmpLinked = this._isLinked(pItemID, pOrgID);
			const tmpStaged = this._isStaged(pItemID, pOrgID);
			const tmpName = this._esc(this._orgLabel(pOrgID));
			const tmpPrime = (pOrgID === this._prime) ? '<span class="pcm-prime" title="Project prime contractor">★</span>' : '';
			if (!tmpLinked)
			{
				const tmpClick = tmpEditable ? `onclick="_Pict.providers.${this.providerName}.toggleContractor(${pItemID}, ${pOrgID})"` : '';
				return `<span class="pcm-chip pcm-off${tmpStaged ? ' pcm-staged' : ''}" ${tmpClick} title="Link this contractor">${tmpPrime}${tmpName}</span>`;
			}
			const tmpDBE = this._cellDBE(pItemID, pOrgID);
			const tmpDBEBtn = !this.supportsDBE ? ''
				: (tmpEditable
					? `<button class="pcm-dbe${tmpDBE ? ' pcm-dbe-on' : ''}" onclick="event.stopPropagation(); _Pict.providers.${this.providerName}.toggleDBE(${pItemID}, ${pOrgID})" title="Disadvantaged Business Enterprise — click to toggle">DBE</button>`
					: (tmpDBE ? '<span class="pcm-dbe pcm-dbe-on pcm-dbe-ro" title="Disadvantaged Business Enterprise">DBE</span>' : ''));
			const tmpX = tmpEditable ? `<button class="pcm-x" onclick="event.stopPropagation(); _Pict.providers.${this.providerName}.toggleContractor(${pItemID}, ${pOrgID})" title="Unlink this contractor">×</button>` : '';
			return `<span class="pcm-chip pcm-on${tmpStaged ? ' pcm-staged' : ''}">${tmpPrime}<span class="pcm-chip-name">${tmpName}</span>${tmpDBEBtn}${tmpX}</span>`;
		}).join('');
	}

	_rowHTML(pItem)
	{
		const tmpItemID = Number(pItem[this.cfg.ItemIDField]);
		const tmpNum = this._esc(pItem[this.cfg.ItemNumberField] || pItem.ItemCode || '');
		const tmpName = this._esc(pItem[this.cfg.ItemNameField] || pItem.Description || `${this.cfg.ItemNoun} ${tmpItemID}`);
		const tmpKey = String(tmpItemID);
		const tmpStagedItem = this._addedItems[tmpKey] || this._removedItems[tmpKey];
		const tmpChanged = (this._pending[tmpKey] || tmpStagedItem) ? ' pcm-row-changed' : '';
		const tmpFilterText = this._esc(`${tmpNum} ${tmpName}`.toLowerCase());
		const tmpEditable = this._canEdit();
		const tmpAdd = tmpEditable
			? (this._addForItem === tmpItemID
				? `<span class="pcm-addwrap"><span id="pcm-addpick-${this.providerName}" class="pcm-addpick"></span><button class="pcm-btn pcm-btn-sm" onclick="_Pict.providers.${this.providerName}.toggleAddPicker(${tmpItemID})">Done</button></span>`
				: `<button class="pcm-btn pcm-btn-sm pcm-addbtn" onclick="_Pict.providers.${this.providerName}.toggleAddPicker(${tmpItemID})">+ contractor</button>`)
			: '';
		// Equipment mode: a name-cell badge for staged add / pending removal + a row × to take the equipment off the project.
		const tmpBadge = this._removedItems[tmpKey] ? '<span class="pcm-itembadge pcm-itembadge-rm">removing</span>'
			: (this._addedItems[tmpKey] ? '<span class="pcm-itembadge pcm-itembadge-new">new</span>' : '');
		const tmpRemove = (this.itemsViaJoin && tmpEditable)
			? `<button class="pcm-itemx" title="${this._removedItems[tmpKey] ? 'Keep this equipment on the project' : 'Remove this equipment from the project'}" onclick="_Pict.providers.${this.providerName}.removeItem(${tmpItemID})">${this._removedItems[tmpKey] ? '↺' : '×'}</button>`
			: '';
		return /*html*/`
			<tr class="pcm-row${tmpChanged}" data-item="${tmpItemID}" data-filter="${tmpFilterText}">
				<td class="pcm-num">${tmpNum}</td>
				<td class="pcm-name">${tmpName}${tmpBadge}${tmpRemove}</td>
				<td class="pcm-cell"><span class="pcm-chips">${this._chipsHTML(tmpItemID)}</span><span class="pcm-add">${tmpAdd}</span></td>
			</tr>`;
	}

	/** Pagination + "+ Add <item>" toolbar controls. */
	_pagerHTML()
	{
		const tmpPageCount = this._pageCount();
		const tmpFrom = this._itemTotal === 0 ? 0 : (this._page * PAGE_SIZE) + 1;
		const tmpTo = Math.min(this._itemTotal, (this._page + 1) * PAGE_SIZE);
		const tmpNoun = this._esc(this.cfg.ItemNoun.toLowerCase());
		const tmpPrevDis = (this._page <= 0) ? 'disabled' : '';
		const tmpNextDis = (this._page >= tmpPageCount - 1) ? 'disabled' : '';
		if (tmpPageCount <= 1) { return `<div class="pcm-count">${this._itemTotal.toLocaleString()} ${tmpNoun}${this._itemTotal === 1 ? '' : 's'}</div>`; }
		return /*html*/`
			<div class="pcm-pager">
				<button class="pcm-btn pcm-btn-sm" ${tmpPrevDis} onclick="_Pict.providers.${this.providerName}.goToPage(${this._page - 1})">‹ Prev</button>
				<span class="pcm-pageinfo">${tmpFrom.toLocaleString()}–${tmpTo.toLocaleString()} of ${this._itemTotal.toLocaleString()}</span>
				<button class="pcm-btn pcm-btn-sm" ${tmpNextDis} onclick="_Pict.providers.${this.providerName}.goToPage(${this._page + 1})">Next ›</button>
			</div>`;
	}

	_render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !this._Mount) { return; }
		if (tmpCA.getElement(this._Mount).length === 0) { return; }

		if (this._loading) { tmpCA.assignContent(this._Mount, `<div class="pcm-empty">Loading ${this._esc(this.cfg.ItemNoun.toLowerCase())}s…</div>`); return; }

		const tmpNoun = this._esc(this.cfg.ItemNoun.toLowerCase());
		const tmpReadOnly = !this._canEdit();
		const tmpSearching = this._search.trim() !== '';
		// A genuinely empty grid (no items, not a no-match) still needs its toolbar in equipment mode so the user can
		// add equipment; for line/bid a truly empty project shows the simple empty note.
		if (this._items.length === 0 && !tmpSearching && this._itemTotal === 0 && !this.itemsViaJoin)
		{
			tmpCA.assignContent(this._Mount, `<div class="pcm-empty">This project has no ${tmpNoun}s.</div>`); return;
		}

		const tmpMessage = this._message ? `<div class="pcm-msg ${this._messageClass}">${this._esc(this._message)}</div>` : '';
		const tmpReadNote = tmpReadOnly ? `<div class="pcm-msg is-warning">You can view contractor links here but not change them.</div>` : '';
		const tmpTrunc = this._truncated ? `<div class="pcm-msg is-warning">This project has more than ${VIAJOIN_MAX.toLocaleString()} ${tmpNoun} links; showing the first set.</div>` : '';
		const tmpRows = this._items.map((pItem) => this._rowHTML(pItem)).join('');
		const tmpEmptyRows = (this._items.length === 0)
			? `<tr><td colspan="3" class="pcm-nomatch">${tmpSearching ? `No ${tmpNoun}s match your search.` : `No ${tmpNoun}s on this project yet.`}</td></tr>`
			: '';
		const tmpSearchVal = this._esc(this._search);
		const tmpAddItem = (this.itemsViaJoin && !tmpReadOnly)
			? (this._addItemOpen
				? `<span class="pcm-additemwrap"><span id="pcm-additempick-${this.providerName}" class="pcm-additempick"></span><button class="pcm-btn pcm-btn-sm" onclick="_Pict.providers.${this.providerName}.toggleAddItemPicker()">Done</button></span>`
				: `<button class="pcm-btn pcm-btn-sm pcm-btn-primary" onclick="_Pict.providers.${this.providerName}.toggleAddItemPicker()">+ Add ${tmpNoun}</button>`)
			: '';

		tmpCA.assignContent(this._Mount, /*html*/`
			<div class="pcm">
				${tmpReadNote}${tmpTrunc}${tmpMessage}
				<div class="pcm-toolbar">
					<input class="pcm-filter" type="text" placeholder="Search ${tmpNoun}s…" value="${tmpSearchVal}" oninput="_Pict.providers.${this.providerName}.setSearch(this.value)" />
					${tmpAddItem}
					<span id="pcm-pager-${this.providerName}">${this._pagerHTML()}</span>
					<div class="pcm-savebar">${this._saveBarHTML()}</div>
				</div>
				<div class="pcm-tablewrap" id="pcm-tablewrap-${this.providerName}">
					<table class="pcm-table">
						<thead><tr><th class="pcm-th-num">#</th><th class="pcm-th-name">${this._esc(this.cfg.ItemNoun)}</th><th>Contractors</th></tr></thead>
						<tbody>${tmpRows}${tmpEmptyRows}</tbody>
					</table>
				</div>
			</div>`);

		if (this._addForItem && !tmpReadOnly) { this._mountAddPicker(); }
		if (this._addItemOpen && this.itemsViaJoin && !tmpReadOnly) { this._mountAddItemPicker(); }
	}

	/**
	 * Repaint ONLY the results (table body + pager), leaving the toolbar's search <input> untouched. A full
	 * _render() rebuilds the input and drops focus/caret while typing — and its _loading branch replaces the
	 * whole mount (input included). Used by the search/pagination reload; falls back to a full render before
	 * the shell exists. The loading indicator is routed into #pcm-tablewrap so the input survives it.
	 */
	_renderResults()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpWrap = `#pcm-tablewrap-${this.providerName}`;
		if (!tmpCA || tmpCA.getElement(tmpWrap).length === 0) { this._render(); return; }
		const tmpNoun = this._esc(this.cfg.ItemNoun.toLowerCase());
		if (this._loading)
		{
			tmpCA.assignContent(tmpWrap, `<div class="pcm-empty">Loading ${tmpNoun}s…</div>`);
			return;
		}
		const tmpSearching = this._search.trim() !== '';
		const tmpRows = this._items.map((pItem) => this._rowHTML(pItem)).join('');
		const tmpEmptyRows = (this._items.length === 0)
			? `<tr><td colspan="3" class="pcm-nomatch">${tmpSearching ? `No ${tmpNoun}s match your search.` : `No ${tmpNoun}s on this project yet.`}</td></tr>`
			: '';
		tmpCA.assignContent(tmpWrap, /*html*/`
			<table class="pcm-table">
				<thead><tr><th class="pcm-th-num">#</th><th class="pcm-th-name">${this._esc(this.cfg.ItemNoun)}</th><th>Contractors</th></tr></thead>
				<tbody>${tmpRows}${tmpEmptyRows}</tbody>
			</table>`);
		tmpCA.assignContent(`#pcm-pager-${this.providerName}`, this._pagerHTML());
	}

	/** Mount the top-level "+ Add equipment" picker (ItemsViaJoin mode). */
	_mountAddItemPicker()
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const tmpDest = `#pcm-additempick-${this.providerName}`;
		if (tmpCA.getElement(tmpDest).length === 0) { return; }
		const tmpInstance = tmpPicker.createPicker(`${this.providerName}-AddItemPicker`,
			{
				DestinationAddress: tmpDest,
				ValueAddress: `AppData.${this.providerName}.AddItemPick`,
				Searchable: true,
				AllowClear: true,
				ClearLabel: `— add ${this._esc(this.cfg.ItemNoun.toLowerCase())} —`,
				Placeholder: `Search ${this._esc(this.cfg.ItemNoun.toLowerCase())}…`,
				DataProvider: this._addItemDataProvider(),
				ResolveValue: this._addItemResolveValue(),
				OnChange: (pValue) => this.onAddItem(pValue),
			});
		if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
		if (tmpInstance && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(''); }
	}

	// --- Add-a-contractor picker (server-side Organization search; only the open row mounts one) ---

	_mountAddPicker()
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const tmpDest = `#pcm-addpick-${this.providerName}`;
		if (tmpCA.getElement(tmpDest).length === 0) { return; }
		const tmpInstance = tmpPicker.createPicker(`${this.providerName}-AddPicker`,
			{
				DestinationAddress: tmpDest,
				ValueAddress: `AppData.${this.providerName}.AddPick`,
				Searchable: true,
				AllowClear: true,
				ClearLabel: '— pick a contractor —',
				Placeholder: 'Search organizations…',
				DataProvider: this._orgDataProvider(),
				ResolveValue: this._orgResolveValue(),
				OnChange: (pValue) => this.onAddPick(pValue),
			});
		this._addPickerInstance = tmpInstance;
		if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
		if (tmpInstance && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(''); }
	}

	/**
	 * Organization search for the add-a-contractor picker, SCOPED TO THE PROJECT'S ORGANIZATIONS (issue #2 — never
	 * the whole customer org list). The project org id-set is small (the orgs formally on the project), so the
	 * candidates are the project orgs (minus any already a column), filtered client-side by the typed term. Falls
	 * back to the customer scope only if the project has no organization set loaded.
	 */
	_orgDataProvider()
	{
		const tmpPageSize = 25;
		const fToOption = (pOrg) =>
		{
			if (pOrg && pOrg.IDOrganization != null) { this._orgLabelByID[String(pOrg.IDOrganization)] = pOrg.Name || `Organization ${pOrg.IDOrganization}`; }
			return { Value: Number(pOrg.IDOrganization), Text: pOrg.Name || `Organization ${pOrg.IDOrganization}`, Record: pOrg };
		};
		const fCustomerSearch = libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{ Set: 'Organizations', IDField: 'IDOrganization', PageSize: tmpPageSize, Scope: () => `FBV~IDCustomer~EQ~${this._IDCustomer || this.callerCustomer()}~FBV~Deleted~EQ~0`, ToOption: fToOption });
		return (pTerm, pPage) =>
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
			const tmpIDs = (this._projectOrgIDs || []).filter((pID) => pID > 0);
			if (tmpIDs.length > 0)
			{
				// The project's organizations, resolved + filtered by term — resolve any missing labels first.
				const tmpMissing = tmpIDs.filter((pID) => !this._orgLabelByID[String(pID)]);
				const fBuild = () =>
				{
					const tmpResults = tmpIDs
						.map((pID) => ({ Value: pID, Text: this._orgLabelByID[String(pID)] || `Organization ${pID}` }))
						.filter((pRow) => !tmpTerm || String(pRow.Text).toLowerCase().indexOf(tmpTerm) >= 0)
						.sort((pA, pB) => String(pA.Text).localeCompare(String(pB.Text)));
					return { results: tmpResults, hasMore: false };
				};
				if (tmpMissing.length === 0) { return Promise.resolve(fBuild()); }
				return this._resolveOrgLabels(tmpMissing).then(fBuild);
			}
			// Fallback: customer scope (project has no org set) — keeps the picker usable.
			return fCustomerSearch(pTerm, pPage);
		};
	}

	_orgResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			if (this._orgLabelByID[String(tmpID)]) { return Promise.resolve({ Value: tmpID, Text: this._orgLabelByID[String(tmpID)] }); }
			return this._getJSON(`Organization/${tmpID}`).then((pOrg) =>
			{
				const tmpName = (pOrg && pOrg.Name) ? pOrg.Name : `#${tmpID}`;
				this._orgLabelByID[String(tmpID)] = tmpName;
				return { Value: tmpID, Text: tmpName };
			});
		};
	}
}

module.exports = ProjectContractorMatrixProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ProjectContractorMatrix',
	AutoInitialize: true,
	AutoInitializeOrdinal: 223,
};

const _CSS = /*css*/`
	.pcm { font-size: 0.9rem; }
	.pcm-empty { padding: 1.2rem; color: var(--theme-color-text-muted,#6b7686); text-align:center; }
	.pcm-toolbar { display:flex; align-items:center; gap:0.8rem; margin:0 0 0.7rem; flex-wrap:wrap; }
	.pcm-filter { flex:1 1 14rem; min-width:10rem; max-width:22rem; font-size:0.86rem; padding:0.34rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
	.pcm-count { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); }
	.pcm-savebar { display:flex; align-items:center; gap:0.7rem; margin-left:auto; }
	.pcm-pending { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); }
	.pcm-btn { font-size:0.85rem; font-weight:600; padding:0.4rem 0.9rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
	.pcm-btn-sm { padding:0.22rem 0.6rem; font-size:0.8rem; font-weight:600; }
	.pcm-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
	.pcm-btn[disabled] { opacity:0.5; cursor:default; }
	.pcm-msg { font-size:0.84rem; border-radius:6px; padding:0.45rem 0.65rem; margin:0 0 0.6rem; }
	.pcm-msg.is-info { color:#1f5673; background:var(--theme-color-status-info-bg,#e5f2f8); }
	.pcm-msg.is-success { color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); }
	.pcm-msg.is-warning { color:#8a6d1b; background:var(--theme-color-status-warning-bg,#fbf3d9); }
	.pcm-msg.is-danger { color:#a12d22; background:var(--theme-color-status-danger-bg,#fbe6e3); }
	.pcm-tablewrap { overflow-x:auto; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; }
	.pcm-table { width:100%; border-collapse:separate; border-spacing:0; }
	.pcm-table th { text-align:left; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#f4f6f9); padding:0.5rem 0.85rem; border-bottom:1px solid var(--theme-color-border-light,#e8ebf0); }
	.pcm-table td { padding:0.5rem 0.85rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); vertical-align:top; }
	.pcm-table tbody tr:last-child td { border-bottom:none; }
	.pcm-th-num { width:1%; white-space:nowrap; }
	.pcm-th-name { width:22%; }
	.pcm-row-changed td { background:var(--theme-color-status-warning-bg,#fbf3d9); }
	.pcm-num { white-space:nowrap; color:var(--theme-color-text-muted,#6b7686); font-variant-numeric:tabular-nums; }
	.pcm-name { color:var(--theme-color-text-primary,#1f2733); }
	.pcm-cell { min-width:22rem; }
	.pcm-chips { display:flex; flex-wrap:wrap; gap:0.35rem; }
	.pcm-chip { display:inline-flex; align-items:center; gap:0.3rem; font-size:0.8rem; border-radius:999px; padding:0.12rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); cursor:pointer; user-select:none; }
	.pcm-chip.pcm-off { color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-panel,#fff); border-style:dashed; }
	.pcm-chip.pcm-off:hover { color:var(--theme-color-text-secondary,#45505f); border-color:var(--theme-color-primary,#2f6fed); }
	.pcm-chip.pcm-on { color:var(--theme-color-primary-text,#1f3a6d); background:var(--theme-color-background-selected,#eef1f8); border-color:var(--theme-color-primary,#2f6fed); cursor:default; }
	.pcm-chip.pcm-staged { box-shadow:0 0 0 2px var(--theme-color-status-warning,#d9a441); }
	.pcm-chip-name { font-weight:600; }
	.pcm-prime { color:var(--theme-color-status-warning,#d9a441); font-size:0.85rem; }
	.pcm-x { border:none; background:none; cursor:pointer; color:var(--theme-color-text-muted,#6b7686); font-size:1rem; line-height:1; padding:0 0 0 0.1rem; }
	.pcm-x:hover { color:var(--theme-color-status-danger,#cf5b5b); }
	.pcm-dbe { border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#6b7686); border-radius:5px; font-size:0.62rem; font-weight:700; letter-spacing:0.03em; padding:0.02rem 0.3rem; cursor:pointer; }
	.pcm-dbe.pcm-dbe-on { color:#fff; background:var(--theme-color-status-success,#3c9a5f); border-color:var(--theme-color-status-success,#3c9a5f); }
	.pcm-dbe.pcm-dbe-ro { cursor:default; }
	.pcm-add { display:inline-flex; margin-top:0.35rem; }
	.pcm-addbtn { border-style:dashed; color:var(--theme-color-text-secondary,#45505f); }
	.pcm-addwrap { display:inline-flex; align-items:center; gap:0.4rem; }
	.pcm-addpick { display:inline-block; min-width:18rem; }
	.pcm-empty-chips { font-size:0.82rem; color:var(--theme-color-text-muted,#9aa3ad); font-style:italic; }
	.pcm-nomatch { padding:0.8rem; color:var(--theme-color-text-muted,#6b7686); text-align:center; font-size:0.86rem; }
	.pcm-pager { display:flex; align-items:center; gap:0.5rem; }
	.pcm-pageinfo { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); font-variant-numeric:tabular-nums; white-space:nowrap; }
	.pcm-itembadge { margin-left:0.5rem; font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.05rem 0.4rem; border-radius:9px; vertical-align:middle; }
	.pcm-itembadge-new { color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); }
	.pcm-itembadge-rm { color:#a12d22; background:var(--theme-color-status-danger-bg,#fbe6e3); }
	.pcm-itemx { margin-left:0.4rem; border:none; background:none; cursor:pointer; color:var(--theme-color-text-muted,#9aa3ad); font-size:1rem; line-height:1; padding:0 0.15rem; vertical-align:middle; }
	.pcm-itemx:hover { color:var(--theme-color-status-danger,#cf5b5b); }
	.pcm-additemwrap { display:inline-flex; align-items:center; gap:0.4rem; }
	.pcm-additempick { display:inline-block; min-width:16rem; }
`;

},{"../services/Entity-Picker-Search.js":1398,"pict-provider":845}],1362:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const BODY_MOUNT = '#PCW-Body';
const MESSAGE_MOUNT = '#PCW-Message';
// CustomProperties lives in its OWN mount (a sibling of #PCW-Body) so a body repaint never tears down the
// editable object-editor tree mounted inside it (same split as the Edit workspace).
const CUSTOMPROPS_MOUNT = '#PCW-CustomProps';

// The editable Project fields offered at CREATE, grouped for the form. A new project is never Active, so
// nothing is gated (every field editable) — the difference from the Edit workspace. Name is required; the
// rest are optional and default on the server. IDCustomer is NEVER sent (the server stamps it from session).
const FIELD_GROUPS =
[
	{ Name: 'Identity', Fields:
		[
			{ Key: 'Name', Label: 'Project Name', Type: 'text', Wide: true, Required: true },
			{ Key: 'Status', Label: 'Status', Type: 'text' },
			{ Key: 'ExternalProjectID', Label: 'External Project ID', Type: 'text' },
		] },
	{ Name: 'Relationships', Fields:
		[
			{ Key: 'IDProjectType', Label: 'Project Type', Type: 'entity', Entity: 'ProjectType', Wide: true },
			{ Key: 'IDOrganization', Label: 'Prime Contractor', Type: 'entity', Entity: 'Organization', Wide: true },
			{ Key: 'IDContract', Label: 'Contract', Type: 'entity', Entity: 'Contract', Wide: true },
		] },
	{ Name: 'Schedule & Financials', Fields:
		[
			{ Key: 'InitialContractAmount', Label: 'Initial Contract Amount', Type: 'number' },
			{ Key: 'CostPerDay', Label: 'Cost / Day', Type: 'number' },
			{ Key: 'OriginalContractedDays', Label: 'Original Contracted Days', Type: 'number' },
			{ Key: 'ContractedDays', Label: 'Contracted Days', Type: 'number' },
		] },
	{ Name: 'Description', Fields:
		[
			{ Key: 'Description', Label: 'Description', Type: 'textarea', Wide: true },
		] },
];

// Server-side entity-picker config per relationship field (mirrors ProjectEditWorkspace-Provider). The
// picker searches on the server through HeadlightRestClient (this app has no pict.EntityProvider).
const PICKER_PAGE_SIZE = 25;
const ENTITY_CONFIG =
{
	IDOrganization: { Set: 'Organizations', One: 'Organization', IDField: 'IDOrganization', Noun: 'prime contractor', SearchFields: [ 'Name', 'City', 'State', 'VendorCode', 'Type' ], IgnoreFields: [ 'IDCustomer', 'GUIDOrganization' ] },
	IDContract: { Set: 'Contracts', One: 'Contract', IDField: 'IDContract', Noun: 'contract', SearchFields: [ 'Name', 'Description', 'PrimaryProjectNumber', 'ExternalContractID', 'Status' ], IgnoreFields: [ 'IDCustomer', 'GUIDContract' ] },
	// ProjectType is customer-scoped but has NO Deleted column — NoSoftDelete drops the `Deleted~EQ~0` clause the
	// picker otherwise appends, which would make the ProjectTypes query fail.
	IDProjectType: { Set: 'ProjectTypes', One: 'ProjectType', IDField: 'IDProjectType', Noun: 'project type', SearchFields: [ 'Name', 'Description' ], IgnoreFields: [ 'IDCustomer', 'GUIDProjectType' ], NoSoftDelete: true },
};

/**
 * ProjectCreateWorkspace — the data layer behind the bespoke Project CREATE screen. Reached by the app-router
 * Create bridge (#/PSRS/Project/Create) that shadows the generic recordset create form, so the "+ New" button
 * opens the same curated, grouped experience as the View/Edit workspaces instead of the plain manifest form.
 *
 * It starts from a blank working copy, POSTs a new Project (IDCustomer is stamped by the server from the
 * session — never sent), and on success navigates to #/PSRS/Project/View/<newGUID>, which the View bridge
 * opens as the bespoke ProjectWorkspace. Field parity + the searchable entity pickers come straight from the
 * Edit workspace; the only structural difference is no Active-gating (a new project can't be Active).
 */
class ProjectCreateWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get state()
	{
		if (!this.pict.AppData.ProjectCreateWorkspace)
		{
			this.pict.AppData.ProjectCreateWorkspace =
			{
				Ready: false, Message: '', MessageClass: '', Saving: false,
				IDCustomer: 0, Title: 'New Project',
				Fields: {}, Errors: {}, CustomPropsData: {},
			};
		}
		return this.pict.AppData.ProjectCreateWorkspace;
	}

	// --- REST helpers ---

	_create(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.createEntity('Project', pRecord, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	_toNumberOrNull(pValue)
	{
		if (pValue == null || String(pValue).trim() === '') { return null; }
		const tmpNumber = Number(pValue);
		return Number.isFinite(tmpNumber) ? tmpNumber : null;
	}

	// --- Start a new project ---

	/** Stash a one-shot prefill applied by the next startNew() (e.g. the Contract workspace's "New project"
	 *  passing { IDContract } so the created project is already linked to that contract). */
	prefillNew(pPrefill) { this._pendingPrefill = (pPrefill && typeof pPrefill === 'object') ? pPrefill : null; }

	/** Reset to a blank working copy and paint the empty form. Driven by the Create route bridge. */
	startNew()
	{
		const tmpState = this.state;
		tmpState.Message = '';
		tmpState.MessageClass = '';
		tmpState.Saving = false;
		tmpState.Errors = {};
		tmpState.Title = 'New Project';
		// Scope the entity pickers to the current user's customer (the server also scopes reads to MyCustomer;
		// this keeps parity with the Edit workspace and avoids a cross-customer browse for level-5 admins).
		tmpState.IDCustomer = Number(this.currentUser.CustomerID) || 0;
		const tmpFields = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			// Entity FKs start unset as '' (not 0) so the picker shows its placeholder, not a literal "0".
			tmpFields[pField.Key] = '';
		}));
		// A one-shot prefill (e.g. IDContract when created from the Contract workspace) seeds fields; the entity
		// pickers resolve a pre-set id to its display name on render.
		if (this._pendingPrefill)
		{
			Object.keys(this._pendingPrefill).forEach((pKey) => { if (pKey in tmpFields) { tmpFields[pKey] = this._pendingPrefill[pKey]; } });
			this._pendingPrefill = null;
		}
		tmpState.Fields = tmpFields;
		tmpState.CustomPropsData = {};
		// Reset the Location/map working state (center lives in Fields.Latitude/Longitude, unset at start).
		this._addressResults = [];
		this._addressSearching = false;
		this._addressError = '';
		this._locError = '';
		tmpState.Ready = true;
		this.render();
		this.renderCustomProps();
	}

	// --- Editing ---

	/** Update one working-copy field. onchange-driven, so no re-render (the DOM already holds the value). */
	setField(pKey, pValue)
	{
		this.state.Fields[pKey] = pValue;
		if (this.state.Errors[pKey]) { delete this.state.Errors[pKey]; }
	}

	_validate()
	{
		const tmpState = this.state;
		const tmpErrors = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			const tmpValue = tmpState.Fields[pField.Key];
			const tmpHasValue = (tmpValue != null && String(tmpValue).trim() !== '');
			if (pField.Required && !tmpHasValue) { tmpErrors[pField.Key] = `${pField.Label} is required.`; return; }
			if (pField.Type === 'number' && tmpHasValue)
			{
				const tmpNumber = Number(tmpValue);
				if (!Number.isFinite(tmpNumber)) { tmpErrors[pField.Key] = `${pField.Label} must be a number.`; }
				else if (tmpNumber < 0) { tmpErrors[pField.Key] = `${pField.Label} can’t be negative.`; }
			}
		}));
		tmpState.Errors = tmpErrors;
		return Object.keys(tmpErrors).length === 0;
	}

	// --- Save / navigation ---

	async saveAsync()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		if (!this._validate())
		{
			tmpState.Message = 'Please fix the highlighted fields.';
			tmpState.MessageClass = 'is-danger';
			this.render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Message = 'Creating…';
		tmpState.MessageClass = 'is-info';
		this._renderMessage();
		try
		{
			// Build the create payload — omit empty optionals so the server applies its own defaults. IDCustomer
			// is intentionally never included (stamped from the session).
			const tmpPayload = {};
			FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
			{
				const tmpValue = tmpState.Fields[pField.Key];
				if ((pField.Type === 'number') || (pField.Type === 'entity'))
				{
					const tmpNumber = this._toNumberOrNull(tmpValue);
					if (tmpNumber != null) { tmpPayload[pField.Key] = tmpNumber; }
				}
				else if (tmpValue != null && String(tmpValue).trim() !== '')
				{
					tmpPayload[pField.Key] = tmpValue;
				}
			}));
			// Latitude/Longitude come from the map/Location section (not the FIELD_GROUPS form).
			const tmpLat = this._toNumberOrNull(tmpState.Fields.Latitude);
			const tmpLng = this._toNumberOrNull(tmpState.Fields.Longitude);
			if (tmpLat != null) { tmpPayload.Latitude = tmpLat; }
			if (tmpLng != null) { tmpPayload.Longitude = tmpLng; }
			if (tmpState.CustomPropsData && Object.keys(tmpState.CustomPropsData).length > 0)
			{
				tmpPayload.CustomProperties = JSON.stringify(tmpState.CustomPropsData);
			}
			const tmpSaved = await this._create(tmpPayload);
			if (!tmpSaved || tmpSaved.ErrorCode || !tmpSaved.IDProject)
			{
				throw new Error((tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode))
					? String(tmpSaved.Error || tmpSaved.ErrorCode)
					: 'the server rejected the new project (you may not have permission to create projects).');
			}
			tmpState.Saving = false;
			this._navigateToView(tmpSaved);
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Could not create the project: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	cancel()
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = '#/PSRS/Project/List';
		}
	}

	/** Land on the bespoke read workspace for the just-created project (via the View bridge). */
	_navigateToView(pSaved)
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = pSaved.GUIDProject ? `#/PSRS/Project/View/${pSaved.GUIDProject}` : '#/PSRS/Project/List';
		}
	}

	// --- Geographic center / map (the Location section drives a Leaflet picker like the read workspace) ---

	/** The working center from the Fields (kept as Latitude/Longitude so save picks them up). */
	get center()
	{
		const tmpFields = this.state.Fields || {};
		return { Latitude: this._toNumberOrNull(tmpFields.Latitude), Longitude: this._toNumberOrNull(tmpFields.Longitude) };
	}

	get hasCenter()
	{
		const tmpCenter = this.center;
		return (tmpCenter.Latitude != null) && (tmpCenter.Longitude != null)
			&& !((Number(tmpCenter.Latitude) === 0) && (Number(tmpCenter.Longitude) === 0));
	}

	/**
	 * Set the working center (map click/drag, typed coords, or an address pick) — a LIGHT DOM update only
	 * (readout + input values), never a full re-render, so the live Leaflet map is not torn down under the
	 * user. pSyncMap moves the marker for non-map-driven changes (typed coords / address pick).
	 */
	setCenter(pLatitude, pLongitude, pSyncMap)
	{
		this.state.Fields.Latitude = Number(pLatitude);
		this.state.Fields.Longitude = Number(pLongitude);
		this._locError = '';
		this._syncCenterControls();
		if (pSyncMap)
		{
			const tmpMap = this.pict.views.ProjectCreateMap;
			if (tmpMap && (typeof tmpMap.moveMarkerTo === 'function')) { tmpMap.moveMarkerTo(Number(pLatitude), Number(pLongitude)); }
		}
	}

	/** Set the center from the editable lat/lng inputs (range-validated; bad input surfaces an inline error). */
	setCenterFromText(pLatitude, pLongitude)
	{
		const tmpLat = Number(pLatitude);
		const tmpLng = Number(pLongitude);
		if (!Number.isFinite(tmpLat) || !Number.isFinite(tmpLng) || (tmpLat < -90) || (tmpLat > 90) || (tmpLng < -180) || (tmpLng > 180))
		{
			this._locError = 'Enter a valid latitude (−90 to 90) and longitude (−180 to 180).';
			this._syncCenterControls();
			return;
		}
		this.setCenter(tmpLat, tmpLng, true);
	}

	/** Repaint just the readout + lat/lng input values (keeps the live map mounted). */
	_syncCenterControls()
	{
		if (typeof document === 'undefined') { return; }
		const tmpCenter = this.center;
		const tmpReadout = document.getElementById('PCW-LocReadout');
		if (tmpReadout) { tmpReadout.innerHTML = this._locReadoutHTML(); }
		const tmpLatEl = document.getElementById('PCW-LatInput');
		const tmpLngEl = document.getElementById('PCW-LngInput');
		if (tmpLatEl) { tmpLatEl.value = (tmpCenter.Latitude != null) ? String(tmpCenter.Latitude) : ''; }
		if (tmpLngEl) { tmpLngEl.value = (tmpCenter.Longitude != null) ? String(tmpCenter.Longitude) : ''; }
	}

	_locReadoutHTML()
	{
		const tmpCenter = this.center;
		const tmpText = this.hasCenter ? `${Number(tmpCenter.Latitude).toFixed(6)}, ${Number(tmpCenter.Longitude).toFixed(6)}` : 'Not set';
		const tmpErr = this._locError ? `<p class="pew-field-error">${this._esc(this._locError)}</p>` : '';
		return `<span>Geographic center: <code>${this._esc(tmpText)}</code></span>${tmpErr}`;
	}

	/** Geocode the address box via public Nominatim (same provider as the tiles — no API key). */
	async searchAddressAsync()
	{
		const tmpInput = (typeof document !== 'undefined') ? document.getElementById('PCW-AddressInput') : null;
		const tmpQuery = tmpInput ? String(tmpInput.value || '').trim() : '';
		if (!tmpQuery) { return; }
		this._addressSearching = true;
		this._addressError = '';
		this._addressResults = [];
		this._syncAddress();
		try
		{
			const tmpURL = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=5&q=${encodeURIComponent(tmpQuery)}`;
			const tmpResponse = await fetch(tmpURL, { headers: { 'Accept': 'application/json' } });
			if (!tmpResponse.ok) { throw new Error(`the geocoder returned ${tmpResponse.status}`); }
			const tmpRows = await tmpResponse.json();
			this._addressSearching = false;
			this._addressResults = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pRow) => ({ DisplayName: this._esc(pRow.display_name || 'result'), Latitude: Number(pRow.lat), Longitude: Number(pRow.lon) }))
				.filter((pRow) => Number.isFinite(pRow.Latitude) && Number.isFinite(pRow.Longitude))
				.slice(0, 5);
			this._addressError = (this._addressResults.length === 0) ? 'No matches found for that address.' : '';
			this._syncAddress();
		}
		catch (pError)
		{
			this._addressSearching = false;
			this._addressResults = [];
			this._addressError = `Address search failed: ${pError.message || pError}`;
			this._syncAddress();
		}
	}

	/** Pick an address result → drop the pin at its coordinates and clear the dropdown. */
	chooseAddressResult(pIndex)
	{
		const tmpRow = (this._addressResults || [])[Number(pIndex)];
		if (!tmpRow) { return; }
		this._addressResults = [];
		this._addressError = '';
		this.setCenter(tmpRow.Latitude, tmpRow.Longitude, true);
		this._syncAddress();
	}

	_syncAddress()
	{
		if (typeof document === 'undefined') { return; }
		const tmpEl = document.getElementById('PCW-AddressResults');
		if (tmpEl) { tmpEl.innerHTML = this._addressResultsHTML(); }
	}

	_addressResultsHTML()
	{
		const tmpStatus = this._addressSearching ? 'Searching…' : (this._addressError || '');
		const tmpStatusHTML = tmpStatus ? `<div class="pcw-addr-status${this._addressSearching ? '' : ' pcw-addr-status-error'}">${this._esc(tmpStatus)}</div>` : '';
		const tmpRows = (this._addressResults || []).map((pRow, pIndex) =>
			`<div class="pcw-addr-result" onclick="_Pict.providers.ProjectCreateWorkspace.chooseAddressResult(${pIndex}); return false;">${pRow.DisplayName}</div>`).join('');
		return tmpStatusHTML + tmpRows;
	}

	/** Mount the Leaflet picker into #PCW-MapHost (the ProjectCreateMap view reads this provider's center). */
	_mountMap()
	{
		if (!this.state.Ready) { return; }
		const tmpMap = this.pict.views.ProjectCreateMap;
		if (tmpMap && (typeof tmpMap.showForProject === 'function')) { tmpMap.showForProject(); }
	}

	// --- Render (hand-built HTML into the shell's mounts; mirrors ProjectEditWorkspace-Provider) ---

	/** Paint the whole create body into #PCW-Body. Called on start / save error (not on every keystroke). */
	render()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
		if (this.state.Ready) { this._mountPickers(); this._mountMap(); }
	}

	_mountPickers()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			if (pField.Type === 'entity') { this._mountPicker(pField.Key); }
		}));
	}

	_mountPicker(pKey)
	{
		const tmpMount = `#PCW-Picker-${pKey}`;
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; }
		const tmpConfig = ENTITY_CONFIG[pKey];
		if (!tmpConfig) { return; }
		const tmpPicker = this.pict.providers['Pict-Section-Picker'].createPicker(`PCW-Picker-${pKey}`,
			{
				DestinationAddress: tmpMount,
				ValueAddress: `AppData.ProjectCreateWorkspace.Fields.${pKey}`,
				Searchable: true,
				AllowClear: true,
				ClearLabel: '(none)',
				Placeholder: `Search a ${tmpConfig.Noun}…`,
				DataProvider: this._entityDataProvider(tmpConfig),
				ResolveValue: this._entityResolveValue(tmpConfig),
				Entity: tmpConfig.One,
				AllowFieldDecoration: true,
				DecorationIgnoreFields: tmpConfig.IgnoreFields,
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
	}

	_entityDataProvider(pConfig)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		return (pSearchTerm, pPage) =>
		{
			const tmpStart = (Number(pPage) || 0) * PICKER_PAGE_SIZE;
			// Most entities soft-delete; a few (e.g. ProjectType) have no Deleted column, so skip the clause for them.
			let tmpFilter = `FBV~IDCustomer~EQ~${this.state.IDCustomer}`;
			if (!pConfig.NoSoftDelete) { tmpFilter += `~FBV~Deleted~EQ~0`; }
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).trim();
			if (tmpTerm && tmpPickerProvider && (typeof tmpPickerProvider.buildSearchFilter === 'function'))
			{
				tmpFilter += `~${tmpPickerProvider.buildSearchFilter(pConfig.SearchFields, tmpTerm)}`;
			}
			return this._getJSON(`${pConfig.Set}/FilteredTo/${tmpFilter}/${tmpStart}/${PICKER_PAGE_SIZE}`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					return { results: tmpList.map((pRow) => ({ Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${pRow[pConfig.IDField]}`, Record: pRow })), hasMore: (tmpList.length >= PICKER_PAGE_SIZE) };
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	_entityResolveValue(pConfig)
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`${pConfig.One}/${tmpID}`)
				.then((pRow) => ((pRow && pRow[pConfig.IDField]) ? { Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/** Paint the Custom Properties section into its own mount and mount the editable object-editor tree. */
	renderCustomProps()
	{
		if (!this.state.Ready) { return; }
		if (this.pict.ContentAssignment.getElement(CUSTOMPROPS_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(CUSTOMPROPS_MOUNT, this._customPropsSectionHTML());
		const tmpView = this.pict.views.ProjectCreateWorkspace;
		if (tmpView && (typeof tmpView.mountCustomProps === 'function')) { tmpView.mountCustomProps(); }
	}

	_customPropsSectionHTML()
	{
		return `<div class="pew-form pew-customprops-panel"><div class="pew-group pew-group-customprops">`
			+ `<div class="pew-group-head">Custom Properties</div>`
			+ `<div class="pew-customprops-help">Optional. Double-click a value to edit; use the + controls to add properties.</div>`
			+ `<div id="PCW-CustomPropsHost" class="pew-objecteditor-host"></div>`
			+ `</div></div>`;
	}

	_renderMessage()
	{
		if (this.pict.ContentAssignment.getElement(MESSAGE_MOUNT).length === 0) { this.render(); return; }
		this.pict.ContentAssignment.assignContent(MESSAGE_MOUNT, this._messageHTML());
	}

	_messageHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Message) { return ''; }
		return `<div class="notification ${this._esc(tmpState.MessageClass || 'is-info')} is-soft py-2 px-3 mb-3">${this._esc(tmpState.Message)}</div>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Ready)
		{
			return `<div class="pew-empty box has-text-grey has-text-centered"><span class="pew-spinner"></span><p class="mt-3">Loading…</p></div>`;
		}
		return `<div class="pew-head">`
			+ `<div><div class="pew-eyebrow">New Project</div><h1 class="pew-title">Create a project</h1></div>`
			+ `<div class="pew-head-actions">`
			+ `<button class="button is-link"${tmpState.Saving ? ' disabled' : ''} onclick="_Pict.providers.ProjectCreateWorkspace.saveAsync(); return false;"><span>Create project</span></button>`
			+ `<button class="button is-light" onclick="_Pict.providers.ProjectCreateWorkspace.cancel(); return false;"><span>Cancel</span></button>`
			+ `</div></div>`
			+ `<div id="PCW-Message">${this._messageHTML()}</div>`
			+ `<div class="pew-form">${FIELD_GROUPS.map((pGroup) => this._groupHTML(pGroup)).join('')}</div>`
			+ this._locationSectionHTML();
	}

	/** The Location section: address search + editable lat/lng + a Leaflet map picker (click/drag to set). */
	_locationSectionHTML()
	{
		const tmpCenter = this.center;
		const tmpLat = (tmpCenter.Latitude != null) ? String(tmpCenter.Latitude) : '';
		const tmpLng = (tmpCenter.Longitude != null) ? String(tmpCenter.Longitude) : '';
		return `<div class="pew-form pcw-loc-panel"><div class="pew-group">`
			+ `<div class="pew-group-head">Location</div>`
			+ `<div class="pcw-loc-search"><div class="pcw-loc-search-row">`
			+ `<input id="PCW-AddressInput" class="input pcw-addr-input" type="text" placeholder="Search an address or place…" autocomplete="off" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.providers.ProjectCreateWorkspace.searchAddressAsync(); }" />`
			+ `<button class="button is-light" onclick="_Pict.providers.ProjectCreateWorkspace.searchAddressAsync(); return false;"><span>Search</span></button>`
			+ `</div><div id="PCW-AddressResults">${this._addressResultsHTML()}</div></div>`
			+ `<div class="pcw-loc-coords">`
			+ `<label class="pcw-loc-coord"><span>Latitude</span><input id="PCW-LatInput" class="input" type="number" step="any" placeholder="—" value="${this._esc(tmpLat)}" onchange="_Pict.providers.ProjectCreateWorkspace.setCenterFromText(this.value, (document.getElementById('PCW-LngInput')||{}).value)" /></label>`
			+ `<label class="pcw-loc-coord"><span>Longitude</span><input id="PCW-LngInput" class="input" type="number" step="any" placeholder="—" value="${this._esc(tmpLng)}" onchange="_Pict.providers.ProjectCreateWorkspace.setCenterFromText((document.getElementById('PCW-LatInput')||{}).value, this.value)" /></label>`
			+ `</div>`
			+ `<div id="PCW-LocReadout" class="pcw-loc-readout">${this._locReadoutHTML()}</div>`
			+ `<div id="PCW-MapHost" class="pcw-map-host"></div>`
			+ `<p class="pew-customprops-help">Search an address, type coordinates, or click the map / drag the marker to set this project’s location. Optional.</p>`
			+ `</div></div>`;
	}

	_groupHTML(pGroup)
	{
		const tmpRows = pGroup.Fields.map((pField) => this._fieldHTML(pField)).join('');
		return `<div class="pew-group"><div class="pew-group-head">${this._esc(pGroup.Name)}</div><div class="pew-grid">${tmpRows}</div></div>`;
	}

	_fieldHTML(pField)
	{
		const tmpState = this.state;
		const tmpValue = tmpState.Fields[pField.Key];
		const tmpError = tmpState.Errors[pField.Key] ? `<div class="pew-field-error">${this._esc(tmpState.Errors[pField.Key])}</div>` : '';
		const tmpWide = pField.Wide ? ' pew-field-wide' : '';
		return `<div class="pew-field${tmpWide}"><label class="pew-field-label">${this._esc(pField.Label)}</label>${this._controlHTML(pField, tmpValue)}${tmpError}</div>`;
	}

	_controlHTML(pField, pValue)
	{
		const tmpOnChange = `onchange="_Pict.providers.ProjectCreateWorkspace.setField('${pField.Key}', this.value)"`;
		if (pField.Type === 'textarea')
		{
			return `<textarea class="textarea pew-input" ${tmpOnChange}>${this._esc(pValue)}</textarea>`;
		}
		if (pField.Type === 'entity')
		{
			return `<div id="PCW-Picker-${pField.Key}" class="pew-input pew-picker-host"></div>`;
		}
		const tmpStep = (pField.Type === 'number') ? ' step="any"' : '';
		return `<input class="input pew-input" type="${(pField.Type === 'number') ? 'number' : 'text'}"${tmpStep} value="${this._esc(pValue)}" ${tmpOnChange} />`;
	}
}

module.exports = ProjectCreateWorkspaceProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ProjectCreateWorkspace',
	AutoInitialize: true,
	AutoInitializeOrdinal: 222,
};

},{"pict-provider":845}],1363:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libProjectEditAccess = require('../access/Project-Edit-Access.js');

const BODY_MOUNT = '#PEW-Body';
const MESSAGE_MOUNT = '#PEW-Message';
// CustomProperties lives in its OWN mount (a sibling of #PEW-Body), so repainting the body never tears down
// the editable object-editor tree mounted inside it. The tree edits AppData.ProjectEditWorkspace.CustomPropsData
// in place; the view owns the mount (see ProjectEditWorkspace.mountCustomProps).
const CUSTOMPROPS_MOUNT = '#PEW-CustomProps';

// The Financial/Schedule fields locked once a Project is Active. Editable before Active; read-only (and
// omitted from the save payload) once Status is 'Active'. Mirrors the Project-Edit.json "Schedule &
// Financials" section — the only editable Schedule/Financials fields (the rest are computed/read-only).
const GATED_FIELDS = [ 'InitialContractAmount', 'CostPerDay', 'OriginalContractedDays', 'ContractedDays' ];
const GATED_GROUP = 'Schedule & Financials';
const ACTIVE_STATUS = 'Active';

// Editable Project fields, grouped for the form (parity with default_manifests/Project-Edit.json). Order +
// grouping drive the render; Type picks the control. Gated fields lock when the loaded project is Active.
const FIELD_GROUPS =
[
	{ Name: 'Identity', Fields:
		[
			{ Key: 'Name', Label: 'Project Name', Type: 'text', Wide: true, Required: true },
			{ Key: 'Status', Label: 'Status', Type: 'text' },
			{ Key: 'ExternalProjectID', Label: 'External Project ID', Type: 'text' },
		] },
	{ Name: 'Relationships', Fields:
		[
			// Full-width + stacked: entity labels (contractor names, contract descriptions) are long, and a
			// half-width picker truncates both the search rows and the selected value to unreadable.
			{ Key: 'IDProjectType', Label: 'Project Type', Type: 'entity', Entity: 'ProjectType', Wide: true },
			{ Key: 'IDOrganization', Label: 'Prime Contractor', Type: 'entity', Entity: 'Organization', Wide: true },
			{ Key: 'IDContract', Label: 'Contract', Type: 'entity', Entity: 'Contract', Wide: true },
		] },
	{ Name: GATED_GROUP, Fields:
		[
			{ Key: 'InitialContractAmount', Label: 'Initial Contract Amount', Type: 'number', Gated: true },
			{ Key: 'CostPerDay', Label: 'Cost / Day', Type: 'number', Gated: true },
			{ Key: 'OriginalContractedDays', Label: 'Original Contracted Days', Type: 'number', Gated: true },
			{ Key: 'ContractedDays', Label: 'Contracted Days', Type: 'number', Gated: true },
		] },
	{ Name: 'Description', Fields:
		[
			{ Key: 'Description', Label: 'Description', Type: 'textarea', Wide: true },
		] },
];

// Server-side entity-picker config per relationship field (SearchFields mirror Project-Edit.json). The picker
// searches the whole set on the server (this app has no pict.EntityProvider, so the DataProvider/ResolveValue
// go through HeadlightRestClient) and shows the first PICKER_PAGE_SIZE, paging in more on scroll.
const PICKER_PAGE_SIZE = 25;
const ENTITY_CONFIG =
{
	IDOrganization: { Set: 'Organizations', One: 'Organization', IDField: 'IDOrganization', Noun: 'prime contractor', SearchFields: [ 'Name', 'City', 'State', 'VendorCode', 'Type' ], IgnoreFields: [ 'IDCustomer', 'GUIDOrganization' ] },
	IDContract: { Set: 'Contracts', One: 'Contract', IDField: 'IDContract', Noun: 'contract', SearchFields: [ 'Name', 'Description', 'PrimaryProjectNumber', 'ExternalContractID', 'Status' ], IgnoreFields: [ 'IDCustomer', 'GUIDContract' ] },
	// ProjectType is customer-scoped but has NO Deleted column (see Headlight.json) — NoSoftDelete drops the
	// `Deleted~EQ~0` clause the picker otherwise appends, which would otherwise make the ProjectTypes query fail.
	IDProjectType: { Set: 'ProjectTypes', One: 'ProjectType', IDField: 'IDProjectType', Noun: 'project type', SearchFields: [ 'Name', 'Description' ], IgnoreFields: [ 'IDCustomer', 'GUIDProjectType' ], NoSoftDelete: true },
};

/**
 * ProjectEditWorkspace — the data layer behind the bespoke Project EDIT screen. Reached by the app-router
 * Edit bridge (#/PSRS/Project/Edit/<GUID>) that shadows the generic recordset edit form; owns its own
 * render / save / validation. The reason it exists: the Financial & Schedule fields must be read-only once
 * a project is Active (editable before), and the manifest-driven recordset form has no per-record
 * conditional read-only. Full field parity with Project-Edit.json so it cleanly replaces that form. Someone the
 * server would refuse a save (canEdit) gets the same screen read-only, with no Save.
 *
 * State (a working copy of the record's editable fields) lives in pict.AppData.ProjectEditWorkspace; the
 * thin view re-derives its HTML from it each paint (Entitlements pattern — hand-built HTML into mounts).
 * Saving is a Meadow partial PUT (like ProjectWorkspace-Provider.saveCenterAsync).
 */
class ProjectEditWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// The loaded record (source of truth for gating + reset); the working copy lives in state.Fields.
		this._project = null;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get state()
	{
		if (!this.pict.AppData.ProjectEditWorkspace)
		{
			this.pict.AppData.ProjectEditWorkspace =
			{
				Loading: false, Loaded: false, Message: '', MessageClass: '', Saving: false,
				IDProject: 0, GUIDProject: '', IDCustomer: 0, Title: 'Edit Project',
				Status: '', IsActive: false,
				Fields: {}, Errors: {}, CustomPropsData: {},
			};
		}
		return this.pict.AppData.ProjectEditWorkspace;
	}

	/** The loaded project is Active — Financial/Schedule fields lock. Gate keys off the persisted Status. */
	get isActive()
	{
		return this.state.IsActive === true;
	}

	/**
	 * May the current user save the loaded project? The server's rule (admin, role 4 in the project's customer, or the
	 * project's creator; see access/Project-Edit-Access.js). Without it the screen opens read-only, with no Save.
	 * @return {boolean}
	 */
	get canEdit()
	{
		const tmpUser = (this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return libProjectEditAccess.canEditProject(tmpUser, this._project);
	}

	// --- REST helpers (mirrors ProjectWorkspace-Provider) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	_toNumberOrNull(pValue)
	{
		if (pValue == null || String(pValue).trim() === '') { return null; }
		const tmpNumber = Number(pValue);
		return Number.isFinite(tmpNumber) ? tmpNumber : null;
	}

	// --- Loading ---

	/** Open by GUID (the recordset list + the read workspace link by GUID); resolve to the row id, then load. */
	async openByGUIDAsync(pGUID)
	{
		const tmpState = this.state;
		tmpState.Loading = true;
		tmpState.Loaded = false;
		tmpState.Message = '';
		this.render();
		try
		{
			const tmpRows = await this._getJSON(`Projects/FilteredTo/FBV~GUIDProject~EQ~${pGUID}`);
			const tmpRecord = (Array.isArray(tmpRows) && tmpRows.length > 0) ? tmpRows[0] : null;
			if (!tmpRecord) { throw new Error(`No project found for GUID ${pGUID}.`); }
			await this.loadAsync(tmpRecord.IDProject);
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the project: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	/** Load a project into the edit workspace by id and seed the working copy. */
	async loadAsync(pIDProject)
	{
		const tmpState = this.state;
		tmpState.Loading = true;
		tmpState.Message = '';
		this.render();
		try
		{
			const tmpProject = await this._getJSON(`Project/${pIDProject}`);
			if (!tmpProject || !tmpProject.IDProject) { throw new Error(`Project ${pIDProject} not found.`); }
			this._project = tmpProject;
			tmpState.IDProject = tmpProject.IDProject;
			tmpState.GUIDProject = tmpProject.GUIDProject || '';
			tmpState.IDCustomer = Number(tmpProject.IDCustomer) || 0;
			tmpState.Status = tmpProject.Status || '';
			tmpState.IsActive = (String(tmpProject.Status) === ACTIVE_STATUS);
			tmpState.Title = tmpProject.Name || `Project ${tmpProject.IDProject}`;
			tmpState.Errors = {};
			// Seed the working copy from the record (one value per editable field). A set entity FK is kept as
			// a number so the picker (ValueAddress-bound) preselects the matching option; an UNSET FK is kept
			// as '' (not 0) so the picker shows its placeholder instead of a literal "0". On save, '' round-
			// trips back to null through _toNumberOrNull, clearing the FK.
			const tmpFields = {};
			FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
			{
				const tmpRaw = tmpProject[pField.Key];
				if (pField.Type === 'entity') { tmpFields[pField.Key] = Number(tmpRaw) || ''; return; }
				tmpFields[pField.Key] = (tmpRaw == null) ? '' : tmpRaw;
			}));
			tmpState.Fields = tmpFields;
			// CustomProperties → a live object the editable object-editor tree binds to + mutates in place.
			tmpState.CustomPropsData = this._parseCustomProperties(tmpProject.CustomProperties);
			tmpState.Loading = false;
			tmpState.Loaded = true;
			this.render();
			this.renderCustomProps();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not load the project: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	/** CustomProperties arrives as a JSON string or an already-parsed object; normalise to a plain object. */
	_parseCustomProperties(pValue)
	{
		if (pValue == null || pValue === '') { return {}; }
		if (typeof pValue === 'object') { return pValue; }
		try { const tmpParsed = JSON.parse(pValue); return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : {}; }
		catch (pError) { return {}; }
	}

	// --- Editing ---

	/** Update one working-copy field. onchange-driven, so no re-render (the DOM already holds the value). */
	setField(pKey, pValue)
	{
		this.state.Fields[pKey] = pValue;
		if (this.state.Errors[pKey]) { delete this.state.Errors[pKey]; }
	}

	_validate()
	{
		const tmpState = this.state;
		const tmpErrors = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			if (pField.Gated && this.isActive) { return; }   // locked fields aren't validated/saved
			const tmpValue = tmpState.Fields[pField.Key];
			const tmpHasValue = (tmpValue != null && String(tmpValue).trim() !== '');
			if (pField.Required && !tmpHasValue) { tmpErrors[pField.Key] = `${pField.Label} is required.`; return; }
			if (pField.Type === 'number' && tmpHasValue)
			{
				const tmpNumber = Number(tmpValue);
				if (!Number.isFinite(tmpNumber)) { tmpErrors[pField.Key] = `${pField.Label} must be a number.`; }
				else if (tmpNumber < 0) { tmpErrors[pField.Key] = `${pField.Label} can’t be negative.`; }
			}
		}));
		tmpState.Errors = tmpErrors;
		return Object.keys(tmpErrors).length === 0;
	}

	// --- Save / navigation ---

	async saveAsync()
	{
		const tmpState = this.state;
		if (tmpState.Saving || !this._project) { return; }
		if (!this.canEdit)
		{
			return;
		}
		if (!this._validate())
		{
			tmpState.Message = 'Please fix the highlighted fields.';
			tmpState.MessageClass = 'is-danger';
			this.render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Message = 'Saving…';
		tmpState.MessageClass = 'is-info';
		this._renderMessage();
		try
		{
			const tmpPayload = { IDProject: this._project.IDProject };
			FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
			{
				// Financial/Schedule fields are omitted entirely while Active — the persisted values stand.
				if (pField.Gated && this.isActive) { return; }
				const tmpValue = tmpState.Fields[pField.Key];
				if ((pField.Type === 'number') || (pField.Type === 'entity'))
				{
					tmpPayload[pField.Key] = this._toNumberOrNull(tmpValue);
				}
				else
				{
					tmpPayload[pField.Key] = (tmpValue == null) ? '' : tmpValue;
				}
			}));
			// Flush any pending guided metadata-form edit into CustomPropsData, then serialize the live bound object
			// (the guided form + the raw object editor both mutate it in place).
			const tmpMetaForm = this.pict.providers.EntityMetadataForm;
			if (tmpMetaForm && (typeof tmpMetaForm.flush === 'function')) { tmpMetaForm.flush(); }
			tmpPayload.CustomProperties = JSON.stringify(tmpState.CustomPropsData || {});
			const tmpSaved = await this._putJSON('Project', tmpPayload);
			if (tmpSaved && tmpSaved.ErrorCode)
			{
				throw new Error('the server rejected the update (you may not have permission to edit this project).');
			}
			tmpState.Saving = false;
			this._navigateToView();
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Could not save the project: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	cancel()
	{
		this._navigateToView();
	}

	_navigateToView()
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			const tmpState = this.state;
			window.location.hash = tmpState.GUIDProject ? `#/PSRS/Project/View/${tmpState.GUIDProject}` : '#/PSRS/Project/List';
		}
	}

	// --- Render (hand-built HTML into the shell's mounts) ---

	/** Paint the whole edit body into #PEW-Body. Called on load / save error (not on every keystroke). */
	render()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
		if (this.state.Loaded) { this._mountPickers(); }
	}

	/**
	 * (Re)mount the searchable entity pickers into their hosts inside #PEW-Body. createPicker reconfigures +
	 * reuses the same view, and each picker is ValueAddress-bound to its Fields entry, so a body repaint
	 * re-renders it with the current selection intact. Server-side search (DataProvider) + preselect-resolve
	 * (ResolveValue) go through HeadlightRestClient — this app has no pict.EntityProvider.
	 */
	_mountPickers()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			if (pField.Type === 'entity') { this._mountPicker(pField.Key); }
		}));
	}

	_mountPicker(pKey)
	{
		const tmpMount = `#PEW-Picker-${pKey}`;
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; }
		const tmpConfig = ENTITY_CONFIG[pKey];
		if (!tmpConfig) { return; }
		const tmpPicker = this.pict.providers['Pict-Section-Picker'].createPicker(`PEW-Picker-${pKey}`,
			{
				DestinationAddress: tmpMount,
				ValueAddress: `AppData.ProjectEditWorkspace.Fields.${pKey}`,
				Searchable: true,
				AllowClear: true,
				ReadOnly: !this.canEdit,
				ClearLabel: '(none)',
				Placeholder: this.canEdit ? `Search a ${tmpConfig.Noun}…` : '—',
				DataProvider: this._entityDataProvider(tmpConfig),
				ResolveValue: this._entityResolveValue(tmpConfig),
				// This is a custom picker (it bypasses recordset), so it opts into field decoration directly:
				// the ⚙ lets the user pin an extra column (e.g. VendorCode) onto each row to tell same-named
				// orgs apart. Entity keys the per-user localStorage choice; the rows carry a Record (see
				// _entityDataProvider) for the field values.
				Entity: tmpConfig.One,
				AllowFieldDecoration: true,
				DecorationIgnoreFields: tmpConfig.IgnoreFields,
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
	}

	/**
	 * A server-side search DataProvider — `(searchTerm, page) => Promise<{results:[{Value,Text}], hasMore}>` —
	 * scoped to the project's customer, paging PICKER_PAGE_SIZE at a time. Reuses the picker's own
	 * buildSearchFilter for the OR-group LIKE stanza so the FoxHound syntax matches the framework exactly.
	 */
	_entityDataProvider(pConfig)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		return (pSearchTerm, pPage) =>
		{
			const tmpStart = (Number(pPage) || 0) * PICKER_PAGE_SIZE;
			// Most entities soft-delete; a few (e.g. ProjectType) have no Deleted column, so skip the clause for them.
			let tmpFilter = `FBV~IDCustomer~EQ~${this.state.IDCustomer}`;
			if (!pConfig.NoSoftDelete) { tmpFilter += `~FBV~Deleted~EQ~0`; }
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).trim();
			if (tmpTerm && tmpPickerProvider && (typeof tmpPickerProvider.buildSearchFilter === 'function'))
			{
				tmpFilter += `~${tmpPickerProvider.buildSearchFilter(pConfig.SearchFields, tmpTerm)}`;
			}
			return this._getJSON(`${pConfig.Set}/FilteredTo/${tmpFilter}/${tmpStart}/${PICKER_PAGE_SIZE}`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					// Record carries the full row so the picker's field-decoration chooser can offer + show its columns.
					return { results: tmpList.map((pRow) => ({ Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${pRow[pConfig.IDField]}`, Record: pRow })), hasMore: (tmpList.length >= PICKER_PAGE_SIZE) };
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	/** Resolve a pre-bound FK id → {Value,Text} so the current selection shows its name on first render. */
	_entityResolveValue(pConfig)
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`${pConfig.One}/${tmpID}`)
				.then((pRow) => ((pRow && pRow[pConfig.IDField]) ? { Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/**
	 * Paint the Custom Properties section into its OWN mount and mount the editable object-editor tree — kept
	 * separate from #PEW-Body so a body repaint (save error / validation) never tears the tree down. Only runs
	 * once loaded; the tree binds to (and mutates in place) AppData.ProjectEditWorkspace.CustomPropsData.
	 */
	renderCustomProps()
	{
		if (!this.state.Loaded) { return; }
		if (this.pict.ContentAssignment.getElement(CUSTOMPROPS_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(CUSTOMPROPS_MOUNT, this._customPropsSectionHTML());
		// Guided per-customer metadata form (editable), with an entitlement-gated raw-JSON advanced toggle. Binds to
		// the same CustomPropsData object the save serializes (:290), so form edits + any advanced raw edits persist.
		const tmpProvider = this.pict.providers.EntityMetadataForm;
		if (tmpProvider && (typeof tmpProvider.openInto === 'function'))
		{
			tmpProvider.openInto({ entityType: 'Project', idCustomer: Number(this._project && this._project.IDCustomer) || 0, dataAddress: 'AppData.ProjectEditWorkspace.CustomPropsData', host: '#PEW-CustomPropsHost', mode: this.canEdit ? 'edit' : 'view' });
			return;
		}
		// Fallback: the bare editable object-editor tree.
		const tmpView = this.pict.views.ProjectEditWorkspace;
		if (tmpView && (typeof tmpView.mountCustomProps === 'function')) { tmpView.mountCustomProps(); }
	}

	_customPropsSectionHTML()
	{
		return `<div class="pew-form pew-customprops-panel"><div class="pew-group pew-group-customprops">`
			+ `<div class="pew-group-head">Custom Properties</div>`
			+ `<div id="PEW-CustomPropsHost" class="pew-objecteditor-host"></div>`
			+ `</div></div>`;
	}

	/** Repaint just the message region (save status) so the form isn't rebuilt mid-save. */
	_renderMessage()
	{
		if (this.pict.ContentAssignment.getElement(MESSAGE_MOUNT).length === 0) { this.render(); return; }
		this.pict.ContentAssignment.assignContent(MESSAGE_MOUNT, this._messageHTML());
	}

	_messageHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Message) { return ''; }
		return `<div class="notification ${this._esc(tmpState.MessageClass || 'is-info')} is-soft py-2 px-3 mb-3">${this._esc(tmpState.Message)}</div>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (tmpState.Loading && !tmpState.Loaded)
		{
			return `<div class="pew-empty box has-text-grey has-text-centered"><span class="pew-spinner"></span><p class="mt-3">Loading…</p></div>`;
		}
		if (!tmpState.Loaded)
		{
			return `<div id="PEW-Message">${this._messageHTML()}</div><div class="pew-empty box has-text-grey has-text-centered"><p>Pick a project to edit.</p></div>`;
		}
		const tmpCanEdit = this.canEdit;
		const tmpLockBanner = (tmpCanEdit && this.isActive)
			? `<div class="pew-lock-banner"><span class="pew-lock-icon">🔒</span><span>This project is <strong>Active</strong> — its Schedule &amp; Financials are locked. Other fields remain editable.</span></div>`
			: '';
		const tmpReadOnlyNote = tmpCanEdit
			? ''
			: `<div class="notification is-warning is-soft py-2 px-3 mb-3">You can view this project but not change it.</div>`;
		const tmpActions = tmpCanEdit
			? `<button class="button is-link"${tmpState.Saving ? ' disabled' : ''} onclick="_Pict.providers.ProjectEditWorkspace.saveAsync(); return false;"><span>Save</span></button>`
				+ `<button class="button is-light" onclick="_Pict.providers.ProjectEditWorkspace.cancel(); return false;"><span>Cancel</span></button>`
			: `<button class="button is-light" onclick="_Pict.providers.ProjectEditWorkspace.cancel(); return false;"><span>Back to project</span></button>`;
		return `<div class="pew-head">`
			+ `<div><div class="pew-eyebrow">${tmpCanEdit ? 'Edit Project' : 'Project'}</div><h1 class="pew-title">${this._esc(tmpState.Title)}</h1></div>`
			+ `<div class="pew-head-actions">${tmpActions}</div></div>`
			+ tmpReadOnlyNote
			+ `<div id="PEW-Message">${this._messageHTML()}</div>`
			+ tmpLockBanner
			+ `<div class="pew-form">${FIELD_GROUPS.map((pGroup) => this._groupHTML(pGroup)).join('')}</div>`;
	}

	_groupHTML(pGroup)
	{
		const tmpGated = (pGroup.Name === GATED_GROUP) && this.isActive;
		const tmpHint = tmpGated ? `<span class="pew-group-hint">🔒 Locked while Active</span>` : '';
		const tmpRows = pGroup.Fields.map((pField) => this._fieldHTML(pField)).join('');
		return `<div class="pew-group"><div class="pew-group-head">${this._esc(pGroup.Name)}${tmpHint}</div><div class="pew-grid">${tmpRows}</div></div>`;
	}

	_fieldHTML(pField)
	{
		const tmpState = this.state;
		const tmpValue = tmpState.Fields[pField.Key];
		const tmpDisabled = !this.canEdit || !!(pField.Gated && this.isActive);
		const tmpError = tmpState.Errors[pField.Key] ? `<div class="pew-field-error">${this._esc(tmpState.Errors[pField.Key])}</div>` : '';
		const tmpWide = pField.Wide ? ' pew-field-wide' : '';
		return `<div class="pew-field${tmpWide}"><label class="pew-field-label">${this._esc(pField.Label)}</label>${this._controlHTML(pField, tmpValue, tmpDisabled)}${tmpError}</div>`;
	}

	_controlHTML(pField, pValue, pDisabled)
	{
		const tmpDisabledAttr = pDisabled ? ' disabled' : '';
		const tmpOnChange = `onchange="_Pict.providers.ProjectEditWorkspace.setField('${pField.Key}', this.value)"`;
		if (pField.Type === 'textarea')
		{
			return `<textarea class="textarea pew-input"${tmpDisabledAttr} ${tmpOnChange}>${this._esc(pValue)}</textarea>`;
		}
		if (pField.Type === 'entity')
		{
			// A searchable pict-section-picker mounted into this host after render() (see _mountPickers).
			return `<div id="PEW-Picker-${pField.Key}" class="pew-input pew-picker-host"></div>`;
		}
		const tmpStep = (pField.Type === 'number') ? ' step="any"' : '';
		return `<input class="input pew-input" type="${(pField.Type === 'number') ? 'number' : 'text'}"${tmpStep}${tmpDisabledAttr} value="${this._esc(pValue)}" ${tmpOnChange} />`;
	}
}

module.exports = ProjectEditWorkspaceProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'ProjectEditWorkspace',
	AutoInitialize: true,
	AutoInitializeOrdinal: 221,
};

},{"../access/Project-Edit-Access.js":1061,"pict-provider":845}],1364:[function(require,module,exports){

// Shared controller for a project's "labels" — the Projects-app feature the user asked to mirror. A label
// here is an ObservationTagProjectJoin: a free-text `Tag` of a given `TagType` scoped to a project, which is
// what observations in that project get tagged with. (Contrast with LabelManagerController, which manages
// ProjectTagType — the *category vocabulary* the TagType dropdown below is drawn from.)
//
// Mirrors the LabelManagerController shape: a plain class (NOT a pict provider) driven by a host provider,
// exporting the shared list template (OBSLABEL_TEMPLATES) + CSS (OBSLABEL_CSS). Template handlers call back
// into the host by name via Record.ProviderName. Its own `.otl-` namespace keeps it decoupled from the
// ProjectTagType manager (which My Headlight also renders).
//
// SERVER-PAGINATED: a project can have tens of thousands of labels (10k+ of a single type), so the list is
// filtered/searched/paged on the server (a single one-page render at a time), never loaded whole:
//   - count:  GET ObservationTagProjectJoins/Count/FilteredTo/<filter>
//   - page:   GET ObservationTagProjectJoins/FilteredTo/<filter>~FSF~Tag~ASC~0/<offset>/<pageSize>
//     filter = FBV~IDProject~EQ~<id> [ ~FBV~TagType~EQ~<type> ] [ ~FBV~Tag~LK~%<search>% ]
//   - create: POST ObservationTagProjectJoin { Tag, TagType, IDProject }   (server mints/links the
//             ObservationTag + derives IDCustomer from the session — never send IDCustomer)
//   - remove: DELETE ObservationTagProjectJoin/<id>
// TagType options come from the project's ProjectTagTypes, falling back to the customer defaults (IDProject=0)
// then Headlight's platform defaults (IDProject=0, IDCustomer=0) — the same effective set the Projects app offers.

const PAGE_SIZE = 50;

const libConfigSync = require('./ConfigSync.js');

class ProjectObservationLabelController
{
	/**
	 * @param {any} pPict
	 * @param {String} pProviderName - the host provider's identifier (the list template calls it back).
	 */
	constructor(pPict, pProviderName)
	{
		this.pict = pPict;
		this.providerName = pProviderName;

		this.scope = { IDProject: 0, IDCustomer: 0 };
		this.canManage = false;
		this._onChange = () => {};

		// The current PAGE of the project's labels (ObservationTagProjectJoin rows).
		this.labels = [];
		// The effective TagType vocabulary for the ADD-row select (project types, else customer defaults,
		// else platform defaults).
		this.tagTypes = [];
		// The distinct TagTypes actually PRESENT in this project's labels — the type-filter is the union of
		// these and the vocabulary, so you can filter by a type that exists in the data (e.g. imported
		// BidItem labels) even when it isn't in the customer's type set. Loaded once, refreshed after writes.
		this.presentTypes = [];
		this._presentTypesLoaded = false;
		this.loading = false;
		this.busy = false;
		// Add-row state (stashed on every keystroke/pick WITHOUT a re-render so the inputs keep focus).
		this.newTag = '';
		this.newTagType = '';
		// Bulk-add panel state — stashed on the controller (not left in the DOM) so an unrelated full re-render
		// (e.g. a label-TYPE change in the sibling panel) can't silently discard an unsubmitted paste.
		this.bulkTag = '';
		this.bulkTagType = '';
		// Filter / search / paging state. `searchDraft` is the live input buffer (stashed without a render so
		// typing keeps focus); `search` is the applied term (Enter / Search button). `filterType` scopes to one
		// TagType. `offset`/`total` drive Prev/Next over the server-side result.
		this.searchDraft = '';
		this.search = '';
		this.filterType = '';
		this.offset = 0;
		this.pageSize = PAGE_SIZE;
		this.total = 0;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	_toast(pMessage, pType)
	{
		if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); }
	}

	/**
	 * After a label change, (debounced) publish this project's config to the field apps (Fieldbook) — without
	 * it, a new/removed label shows here but never reaches Fieldbook. Debounced + permission-gated in ConfigSync.
	 */
	_requestConfigSync()
	{
		if (Number(this.scope.IDProject) > 0)
		{
			libConfigSync.requestSync(this.pict, 'Project', this.scope.IDProject);
		}
	}

	// --- REST (promisified) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_create(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.createEntity('ObservationTagProjectJoin', pRecord, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_delete(pID)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.deleteEntity('ObservationTagProjectJoin', pID, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/**
	 * Point the controller at a project scope + permission and register the host's re-render.
	 * @param {{IDProject:Number, IDCustomer:Number}} pScope
	 * @param {Boolean} pCanManage
	 * @param {Function} pOnChange
	 */
	setContext(pScope, pCanManage, pOnChange)
	{
		this.scope = pScope || { IDProject: 0, IDCustomer: 0 };
		this.canManage = !!pCanManage;
		this._onChange = (typeof pOnChange === 'function') ? pOnChange : () => {};
		this.labels = [];
		this.tagTypes = [];
		this.presentTypes = [];
		this._presentTypesLoaded = false;
		this.newTag = '';
		this.newTagType = '';
		this.bulkTag = '';
		this.bulkTagType = '';
		this.searchDraft = '';
		this.search = '';
		this.filterType = '';
		this.offset = 0;
		this.total = 0;
	}

	// --- Data ops ---

	/** The FoxHound filter for the current project + active type filter + search term (no sort stanza). */
	_baseFilter()
	{
		let tmpFilter = `FBV~IDProject~EQ~${this.scope.IDProject}`;
		if (this.filterType) { tmpFilter += `~FBV~TagType~EQ~${encodeURIComponent(this.filterType)}`; }
		if (this.search) { tmpFilter += `~FBV~Tag~LK~${encodeURIComponent(`%${this.search}%`)}`; }
		return tmpFilter;
	}

	async load()
	{
		this.loading = true;
		this._onChange();
		try
		{
			await this._loadTagTypes();
			// The type-filter's option set (distinct types present in the data) — loaded once, then refreshed
			// after a write; navigation (page/search/filter) reuses it.
			if (!this._presentTypesLoaded) { await this._loadPresentTypes(); }
			const tmpBaseFilter = this._baseFilter();
			const tmpCount = await this._getJSON(`ObservationTagProjectJoins/Count/FilteredTo/${tmpBaseFilter}`);
			this.total = Number(tmpCount && (tmpCount.Count != null) ? tmpCount.Count : tmpCount) || 0;
			// Clamp the offset if it now sits past the end (after a filter change or a delete emptied the tail).
			if (this.offset > 0 && this.offset >= this.total)
			{
				this.offset = Math.max(0, (Math.ceil(this.total / this.pageSize) - 1) * this.pageSize);
			}
			const tmpLabels = await this._getJSON(`ObservationTagProjectJoins/FilteredTo/${tmpBaseFilter}~FSF~Tag~ASC~0/${this.offset}/${this.pageSize}`);
			this.labels = Array.isArray(tmpLabels) ? tmpLabels.slice() : [];
		}
		catch (pError)
		{
			this.labels = [];
			this.total = 0;
			this._toast(`Could not load labels: ${pError.message || pError}`, 'error');
		}
		this.loading = false;
		this._onChange();
	}

	/**
	 * The effective TagType vocabulary, cascaded like the manifest sibling + the legacy Projects app:
	 * the project's own ProjectTagTypes, else the customer defaults (IDProject=0), else Headlight's
	 * platform defaults (IDProject=0, IDCustomer=0).
	 */
	async _loadTagTypes()
	{
		const fSort = (pRows) => (Array.isArray(pRows) ? pRows.slice() : []).sort((a, b) => (Number(a.Ordinal || 0) - Number(b.Ordinal || 0)) || String(a.TagType || '').localeCompare(String(b.TagType || '')));
		let tmpTypes = fSort(await this._getJSON(`ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~${this.scope.IDProject}~FBV~IDCustomer~EQ~${this.scope.IDCustomer}/0/1000`));
		if (tmpTypes.length === 0)
		{
			tmpTypes = fSort(await this._getJSON(`ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~${this.scope.IDCustomer}/0/1000`));
		}
		if (tmpTypes.length === 0)
		{
			tmpTypes = fSort(await this._getJSON('ProjectTagTypes/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~0/0/1000'));
		}
		this.tagTypes = tmpTypes;
		// Default the add-row type to the first available (or keep a still-valid prior pick).
		const tmpCodes = this.tagTypes.map((pType) => String(pType.TagType));
		if (!this.newTagType || tmpCodes.indexOf(String(this.newTagType)) === -1)
		{
			this.newTagType = (this.tagTypes[0] && this.tagTypes[0].TagType) || '';
		}
		if (!this.bulkTagType || tmpCodes.indexOf(String(this.bulkTagType)) === -1)
		{
			this.bulkTagType = (this.tagTypes[0] && this.tagTypes[0].TagType) || '';
		}
		// NOTE: the type FILTER is intentionally NOT reset to a vocabulary type here — labels can exist on a
		// type that was later turned off (removed from the vocabulary), and filtering by such a type must stay
		// possible. The filter option set is the union of the vocabulary and the distinct present types.
	}

	/** Load the distinct TagTypes actually present in this project's labels (for the type-filter options). */
	async _loadPresentTypes()
	{
		try
		{
			const tmpRows = await this._getJSON(`ObservationTagProjectJoins/Distinct/TagType/FilteredTo/FBV~IDProject~EQ~${this.scope.IDProject}`);
			this.presentTypes = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pRow) => pRow && pRow.TagType)
				.filter((pType) => (pType != null) && (String(pType).trim() !== ''));
		}
		catch (pError)
		{
			this.presentTypes = [];
		}
		this._presentTypesLoaded = true;
	}

	/** Stash the add-row Tag WITHOUT a re-render (keeps the input focused while typing). */
	setNewTag(pValue)
	{
		this.newTag = pValue;
	}

	/** Stash the picked TagType WITHOUT a re-render (the <select> already reflects the choice). */
	pickTagType(pValue)
	{
		this.newTagType = pValue;
	}

	/** Stash the bulk-add paste WITHOUT a re-render, so an unrelated full render re-emits it (no data loss). */
	setBulkTag(pValue)
	{
		this.bulkTag = pValue;
	}

	/** Stash the bulk-add TagType WITHOUT a re-render. */
	pickBulkType(pValue)
	{
		this.bulkTagType = pValue;
	}

	// --- Filter / search / paging ---

	/** Stash the search box WITHOUT a re-render (keeps focus while typing; applied on Enter / Search). */
	setSearch(pValue)
	{
		this.searchDraft = pValue;
	}

	/** Apply the typed search term (Enter or the Search button): reset to the first page and reload. */
	applySearch()
	{
		const tmpTerm = String(this.searchDraft || '').trim();
		if (tmpTerm === this.search) { return; }
		this.search = tmpTerm;
		this.offset = 0;
		this.load();
	}

	/** Clear the search term and reload. */
	clearSearch()
	{
		if (!this.search && !this.searchDraft) { return; }
		this.searchDraft = '';
		this.search = '';
		this.offset = 0;
		this.load();
	}

	/** Scope the list to one TagType (or '' for all): reset to the first page and reload. */
	setFilterType(pValue)
	{
		const tmpValue = String(pValue == null ? '' : pValue);
		if (tmpValue === this.filterType) { return; }
		this.filterType = tmpValue;
		this.offset = 0;
		this.load();
	}

	/** Move one page forward (+1) or back (-1) within the server-side result. */
	page(pDelta)
	{
		const tmpNext = this.offset + (Number(pDelta) * this.pageSize);
		if (tmpNext < 0 || tmpNext >= this.total) { return; }
		this.offset = tmpNext;
		this.load();
	}

	async add()
	{
		if (!this.canManage) { return; }
		const tmpTagType = String(this.newTagType || '').trim();
		if (!tmpTagType) { this._toast('Pick a label type first.', 'error'); return; }
		// Parity with the Projects app: a single field can add several labels at once, split on "|".
		const tmpTags = String(this.newTag || '').split('|').map((pTag) => pTag.trim()).filter((pTag) => pTag.length > 0);
		if (tmpTags.length === 0) { this._toast('Enter a label.', 'error'); return; }

		this.busy = true;
		this._onChange();
		let tmpAdded = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpTags.length; i++)
		{
			const tmpTag = tmpTags[i];
			try
			{
				const tmpSaved = await this._create({ Tag: tmpTag, TagType: tmpTagType, IDProject: this.scope.IDProject });
				if (!tmpSaved || !tmpSaved.IDObservationTagProjectJoin)
				{
					// The server enforces uniqueness — a duplicate comes back as an Error body, not a throw.
					const tmpError = (tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode)) ? String(tmpSaved.Error || tmpSaved.ErrorCode) : '';
					if (/exist/i.test(tmpError)) { tmpFailed++; continue; }
					throw new Error(tmpError || 'the server returned an unexpected response.');
				}
				tmpAdded++;
			}
			catch (pError)
			{
				tmpFailed++;
				this._toast(`Could not add “${tmpTag}”: ${pError.message || pError}`, 'error');
			}
		}
		if (tmpAdded > 0)
		{
			this.newTag = '';
			const tmpNote = tmpFailed > 0 ? ` (${tmpFailed} already present or failed)` : '';
			this._toast(`Added ${tmpAdded} label${tmpAdded === 1 ? '' : 's'}${tmpNote}.`);
			this._requestConfigSync();
		}
		else if (tmpFailed > 0)
		{
			this._toast('That label is already on this project.', 'error');
		}
		this.busy = false;
		// Reload the current page + count (and refresh the present-types filter — a new type may now exist).
		this._presentTypesLoaded = false;
		await this.load();
	}

	/**
	 * Bulk-add many labels of ONE chosen type in a single action (the Projects-app "paste a list" feature).
	 * Accepts an array or a raw blob split on newlines / commas / pipes; de-dupes the paste, then creates
	 * each (server uniqueness rejects a duplicate as an Error body, not a throw — tallied, not fatal).
	 * @param {String} pTagType
	 * @param {String|String[]} pTags
	 */
	async bulkAdd(pTagType, pTags)
	{
		if (!this.canManage) { return; }
		const tmpTagType = String(pTagType || '').trim();
		if (!tmpTagType) { this._toast('Pick a label type first.', 'error'); return; }
		const tmpRaw = Array.isArray(pTags) ? pTags : String(pTags == null ? '' : pTags).split(/[\n,|]/);
		const tmpSeen = new Set();
		const tmpTags = tmpRaw
			.map((pTag) => String(pTag).trim())
			.filter((pTag) => pTag.length > 0)
			.filter((pTag) => { const tmpKey = pTag.toLowerCase(); if (tmpSeen.has(tmpKey)) { return false; } tmpSeen.add(tmpKey); return true; });
		if (tmpTags.length === 0) { this._toast('Enter one or more labels to add.', 'error'); return; }

		this.busy = true;
		this._onChange();
		let tmpAdded = 0;
		let tmpFailed = 0;
		for (let i = 0; i < tmpTags.length; i++)
		{
			const tmpTag = tmpTags[i];
			try
			{
				const tmpSaved = await this._create({ Tag: tmpTag, TagType: tmpTagType, IDProject: this.scope.IDProject });
				if (!tmpSaved || !tmpSaved.IDObservationTagProjectJoin)
				{
					const tmpError = (tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode)) ? String(tmpSaved.Error || tmpSaved.ErrorCode) : '';
					if (/exist/i.test(tmpError)) { tmpFailed++; continue; }
					throw new Error(tmpError || 'the server returned an unexpected response.');
				}
				tmpAdded++;
			}
			catch (pError)
			{
				tmpFailed++;
			}
		}
		if (tmpAdded > 0)
		{
			// Consumed — clear the stashed paste (kept on total failure so the user can fix and retry).
			this.bulkTag = '';
			const tmpNote = tmpFailed > 0 ? ` (${tmpFailed} already present or failed)` : '';
			this._toast(`Added ${tmpAdded} label${tmpAdded === 1 ? '' : 's'}${tmpNote}.`);
			this._requestConfigSync();
		}
		else
		{
			this._toast('No new labels were added — they may already be present on this project.', 'error');
		}
		this.busy = false;
		this._presentTypesLoaded = false;
		await this.load();
	}

	remove(pID)
	{
		if (!this.canManage) { return; }
		const tmpLabel = this.labels.find((pLabel) => pLabel.IDObservationTagProjectJoin === pID);
		if (!tmpLabel) { return; }
		const fApply = async () =>
		{
			try
			{
				await this._delete(pID);
				this._toast(`Removed the “${tmpLabel.Tag}” label.`);
				this._requestConfigSync();
			}
			catch (pError)
			{
				this._toast(`Could not remove the label: ${pError.message || pError}`, 'error');
			}
			// Reload the page + count (the row is gone; the tail may shift up; a type may now be empty).
			this._presentTypesLoaded = false;
			await this.load();
		};
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(`Remove the “${tmpLabel.Tag}” label from this project?`,
				{ title: 'Remove label', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fApply(); } });
		}
		else { fApply(); }
	}

	// --- Display ---

	_escape(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** Build the render record the shared Headlight-ObsLabelManager template consumes. */
	buildState()
	{
		const tmpRows = this.labels.map((pLabel) =>
		{
			const tmpTag = (pLabel.Tag != null && String(pLabel.Tag).trim() !== '') ? pLabel.Tag : '(unnamed)';
			return {
				ProviderName: this.providerName,
				ID: pLabel.IDObservationTagProjectJoin,
				Tag: this._escape(tmpTag),
				TagType: this._escape(pLabel.TagType || '—'),
				RemoveSlot: (this.canManage && !this.busy) ? [ { ProviderName: this.providerName, ID: pLabel.IDObservationTagProjectJoin } ] : [],
			};
		});
		const tmpTypeOptions = this.tagTypes.map((pType) =>
			(
				{
					Value: this._escape(pType.TagType),
					Text: this._escape((pType.Name != null && String(pType.Name).trim() !== '') ? pType.Name : pType.TagType),
					SelectedAttr: (String(pType.TagType) === String(this.newTagType)) ? 'selected' : '',
				}));
		// Same options for the bulk-add type select, but its selection tracks bulkTagType (a separate control).
		const tmpBulkTypeOptions = this.tagTypes.map((pType) =>
			(
				{
					Value: this._escape(pType.TagType),
					Text: this._escape((pType.Name != null && String(pType.Name).trim() !== '') ? pType.Name : pType.TagType),
					SelectedAttr: (String(pType.TagType) === String(this.bulkTagType)) ? 'selected' : '',
				}));
		const tmpHasTypes = tmpTypeOptions.length > 0;
		const tmpFiltering = !!(this.search || this.filterType);
		// Type-filter options: the vocabulary types (display names, in order) + any types PRESENT in the data
		// but not in the vocabulary (labels left on a since-removed type), appended alpha and marked
		// "(inactive)" so it's clear they're no longer in the add-a-label vocabulary but can still be filtered.
		const tmpVocabByCode = {};
		this.tagTypes.forEach((pType) => { tmpVocabByCode[String(pType.TagType).toLowerCase()] = pType; });
		const tmpFilterCodes = this.tagTypes.map((pType) => String(pType.TagType));
		const tmpExtraPresent = (this.presentTypes || [])
			.map((pCode) => String(pCode))
			.filter((pCode) => !tmpVocabByCode[pCode.toLowerCase()] && (tmpFilterCodes.indexOf(pCode) === -1))
			.sort((pA, pB) => pA.localeCompare(pB));
		const tmpFilterOptions = [ { Value: '', Text: 'All types', SelectedAttr: (this.filterType === '') ? 'selected' : '' } ].concat(
			tmpFilterCodes.concat(tmpExtraPresent).map((pCode) =>
			{
				const tmpVocabRow = tmpVocabByCode[String(pCode).toLowerCase()];
				const tmpText = tmpVocabRow
					? ((tmpVocabRow.Name != null && String(tmpVocabRow.Name).trim() !== '') ? tmpVocabRow.Name : tmpVocabRow.TagType)
					: `${pCode} (inactive)`;
				return {
					Value: this._escape(pCode),
					Text: this._escape(tmpText),
					SelectedAttr: (String(pCode) === String(this.filterType)) ? 'selected' : '',
				};
			}));
		// Add-row shows only when the user can manage AND there is at least one type to pick.
		const tmpAddSlot = (this.canManage && !this.busy && tmpHasTypes)
			? [ { ProviderName: this.providerName, NewTag: this._escape(this.newTag), TagTypeOptions: tmpTypeOptions } ]
			: [];
		const tmpHasTable = (tmpRows.length > 0) || tmpAddSlot.length > 0;
		const tmpFrom = (this.total === 0) ? 0 : (this.offset + 1);
		const tmpTo = Math.min(this.offset + this.labels.length, this.total);
		return {
			ProviderName: this.providerName,
			LoadingSlot: this.loading ? [ {} ] : [],
			NoTypesSlot: (!this.loading && this.canManage && !tmpHasTypes) ? [ {} ] : [],
			// Filter bar: available whenever the project has types to filter/search by (independent of whether
			// the current page has rows), so you can always narrow a huge list or clear a too-tight filter.
			FilterSlot: (!this.loading && tmpHasTypes) ? [ {
				ProviderName: this.providerName,
				Search: this._escape(this.searchDraft),
				FilterOptions: tmpFilterOptions,
				ClearSlot: (this.search || this.searchDraft) ? [ { ProviderName: this.providerName } ] : [],
				CountLabel: this.total ? `${this.total.toLocaleString()} label${this.total === 1 ? '' : 's'}${tmpFiltering ? ' (filtered)' : ''}` : '',
			} ] : [],
			TableSlot: (!this.loading && tmpHasTable) ? [ {
				Labels: tmpRows,
				AddSlot: tmpAddSlot,
				BusySlot: this.busy ? [ {} ] : [],
			} ] : [],
			// Bulk-add panel (a collapsed "paste a list" affordance): available whenever the user can manage
			// and there is at least one type to add under. Reuses the add-row's type options.
			BulkSlot: (!this.loading && this.canManage && !this.busy && tmpHasTypes)
				? [ { ProviderName: this.providerName, TagTypeOptions: tmpBulkTypeOptions, BulkTag: this._escape(this.bulkTag) } ]
				: [],
			// Pager only when the result spans more than one page.
			PagerSlot: (!this.loading && this.total > this.pageSize) ? [ {
				ProviderName: this.providerName,
				RangeLabel: `${tmpFrom.toLocaleString()}–${tmpTo.toLocaleString()} of ${this.total.toLocaleString()}`,
				PrevDisabled: (this.offset <= 0) ? 'disabled' : '',
				NextDisabled: ((this.offset + this.pageSize) >= this.total) ? 'disabled' : '',
			} ] : [],
			// "No matches" only when a filter/search yields nothing (distinct from a project with no labels yet).
			NoMatchSlot: (!this.loading && tmpFiltering && this.total === 0) ? [ { ProviderName: this.providerName } ] : [],
			EmptySlot: (!this.loading && !tmpFiltering && this.total === 0 && !this.canManage) ? [ {} ] : [],
			ReadOnlySlot: (!this.canManage && !this.loading) ? [ {} ] : [],
		};
	}
}

module.exports = ProjectObservationLabelController;

module.exports.OBSLABEL_CSS = /*css*/`
	.otl-mgr { font-size: 0.92rem; }
	.otl-filter { display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem; margin: 0 0 0.7rem; }
	.otl-filter-search { display: flex; align-items: center; gap: 0.35rem; flex: 1 1 16rem; min-width: 12rem; }
	.otl-filter-search .input { flex: 1 1 auto; min-width: 0; }
	.otl-filter-type { flex: 0 0 auto; min-width: 9rem; }
	.otl-filter-count { flex: 0 0 auto; margin-left: auto; font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); }
	.otl-table { width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
	.otl-table th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686);
		background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.45rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.otl-th-type { width: 26%; }
	.otl-th-act { width: 1%; }
	.otl-table td { padding: 0.45rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; }
	.otl-table tbody tr:last-child td { border-bottom: none; }
	.otl-tag { font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.otl-type-badge { display: inline-block; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.02em; color: var(--theme-color-brand-primary, #5650e6);
		background: var(--theme-color-background-selected, #eef1f8); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 999px; padding: 0.1rem 0.6rem; }
	.otl-input { max-width: 22rem; }
	.otl-act { text-align: right; white-space: nowrap; }
	.otl-add td { background: var(--theme-color-background-tertiary, #fafbfc); }
	.otl-pager { display: flex; align-items: center; gap: 0.6rem; margin-top: 0.7rem; }
	.otl-pager .otl-range { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); margin-right: auto; }
	.otl-bulk { margin-top: 0.9rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; background: var(--theme-color-background-tertiary, #fafbfc); }
	.otl-bulk > summary { cursor: pointer; font-weight: 650; font-size: 0.85rem; color: var(--theme-color-text-secondary, #45505f); padding: 0.55rem 0.85rem; list-style: none; display: flex; align-items: center; gap: 0.4rem; }
	.otl-bulk > summary::-webkit-details-marker { display: none; }
	.otl-bulk > summary::before { content: '▸'; font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); transition: transform 0.15s ease; }
	.otl-bulk[open] > summary::before { transform: rotate(90deg); }
	.otl-bulk-body { padding: 0 0.85rem 0.85rem; display: flex; flex-direction: column; gap: 0.55rem; }
	.otl-bulk-row { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
	.otl-bulk-label { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); }
	.otl-bulk-type { max-width: 16rem; }
	.otl-bulk-text { width: 100%; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; }
	.otl-bulk-actions { display: flex; justify-content: flex-end; }
	.otl-empty { color: var(--theme-color-text-muted, #6b7686); padding: 0.6rem 0.2rem; }
	.otl-ro-note { font-size: 0.84rem; color: var(--theme-color-text-muted, #6b7686); font-style: italic; margin-top: 0.6rem; }
	.otl-notypes { display: flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; color: var(--theme-color-text-secondary, #45505f);
		background: var(--theme-color-background-tertiary, #f4f6f9); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.6rem 0.85rem; margin: 0 0 0.85rem; line-height: 1.5; }
	.otl-notypes .icon { color: var(--theme-color-brand-primary, #5650e6); flex: 0 0 auto; }
	.otl-loading { color: var(--theme-color-text-muted, #6b7686); padding: 0.8rem 0.2rem; }
	.otl-spin { display: inline-block; width: 1rem; height: 1rem; border: 2px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: otl-spin 0.7s linear infinite; vertical-align: -0.15rem; margin-right: 0.4rem; }
	@keyframes otl-spin { to { transform: rotate(360deg); } }
`;

module.exports.OBSLABEL_TEMPLATES =
[
	{
		Hash: 'Headlight-ObsLabelManager',
		Template: /*html*/`
			<div class="otl-mgr">
				{~TS:Headlight-ObsLabelLoading:Record.LoadingSlot~}
				{~TS:Headlight-ObsLabelNoTypes:Record.NoTypesSlot~}
				{~TS:Headlight-ObsLabelFilter:Record.FilterSlot~}
				{~TS:Headlight-ObsLabelTable:Record.TableSlot~}
				{~TS:Headlight-ObsLabelNoMatch:Record.NoMatchSlot~}
				{~TS:Headlight-ObsLabelPager:Record.PagerSlot~}
				{~TS:Headlight-ObsLabelBulk:Record.BulkSlot~}
				{~TS:Headlight-ObsLabelEmpty:Record.EmptySlot~}
				{~TS:Headlight-ObsLabelReadOnly:Record.ReadOnlySlot~}
			</div>`
	},
	{
		Hash: 'Headlight-ObsLabelFilter',
		Template: /*html*/`
			<div class="otl-filter">
				<div class="otl-filter-search">
					<input class="input is-small" type="text" placeholder="Search labels…" value="{~D:Record.Search~}" oninput="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelSetSearch(this.value)" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.providers['{~D:Record.ProviderName~}'].obsLabelApplySearch(); }" />
					<button class="button is-small" title="Search labels" onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelApplySearch()"><span class="icon"><i class="fas fa-magnifying-glass"></i></span></button>
					{~TS:Headlight-ObsLabelClear:Record.ClearSlot~}
				</div>
				<select class="input is-small otl-filter-type" title="Filter by label type" onchange="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelSetFilterType(this.value)">{~TS:Headlight-ObsLabelFilterOption:Record.FilterOptions~}</select>
				<span class="otl-filter-count">{~D:Record.CountLabel~}</span>
			</div>`
	},
	{
		Hash: 'Headlight-ObsLabelFilterOption',
		Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Text~}</option>`
	},
	{
		Hash: 'Headlight-ObsLabelClear',
		Template: /*html*/`<button class="button is-small is-light" title="Clear search" onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelClearSearch()"><span class="icon"><i class="fas fa-xmark"></i></span></button>`
	},
	{
		Hash: 'Headlight-ObsLabelTable',
		Template: /*html*/`
			<table class="otl-table">
				<thead><tr><th>Label</th><th class="otl-th-type">Type</th><th class="otl-th-act"></th></tr></thead>
				<tbody>
					{~TS:Headlight-ObsLabelAdd:Record.AddSlot~}
					{~TS:Headlight-ObsLabelRow:Record.Labels~}
				</tbody>
			</table>`
	},
	{
		Hash: 'Headlight-ObsLabelRow',
		Template: /*html*/`
			<tr class="otl-row">
				<td class="otl-tag">{~D:Record.Tag~}</td>
				<td><span class="otl-type-badge">{~D:Record.TagType~}</span></td>
				<td class="otl-act">{~TS:Headlight-ObsLabelRemove:Record.RemoveSlot~}</td>
			</tr>`
	},
	{
		Hash: 'Headlight-ObsLabelRemove',
		Template: /*html*/`<button class="button is-light is-small" title="Remove label" onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelRemove({~D:Record.ID~})"><span class="icon"><i class="fas fa-trash"></i></span></button>`
	},
	{
		Hash: 'Headlight-ObsLabelAdd',
		Template: /*html*/`
			<tr class="otl-add">
				<td><input class="input is-small otl-input" type="text" placeholder="New label (e.g. Phase 1) — use | to add several" value="{~D:Record.NewTag~}" oninput="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelSetNewTag(this.value)" onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.providers['{~D:Record.ProviderName~}'].obsLabelAdd(); }" /></td>
				<td><select class="input is-small otl-input" onchange="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelPickType(this.value)">{~TS:Headlight-ObsLabelTypeOption:Record.TagTypeOptions~}</select></td>
				<td class="otl-act"><button class="button is-link is-small" onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelAdd()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add</span></button></td>
			</tr>`
	},
	{
		Hash: 'Headlight-ObsLabelTypeOption',
		Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Text~}</option>`
	},
	{
		Hash: 'Headlight-ObsLabelPager',
		Template: /*html*/`
			<div class="otl-pager">
				<span class="otl-range">{~D:Record.RangeLabel~}</span>
				<button class="button is-small" {~D:Record.PrevDisabled~} onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelPage(-1)"><span class="icon"><i class="fas fa-chevron-left"></i></span><span>Prev</span></button>
				<button class="button is-small" {~D:Record.NextDisabled~} onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelPage(1)"><span>Next</span><span class="icon"><i class="fas fa-chevron-right"></i></span></button>
			</div>`
	},
	{
		Hash: 'Headlight-ObsLabelBulk',
		Template: /*html*/`
			<details class="otl-bulk">
				<summary>Bulk add labels of a type</summary>
				<div class="otl-bulk-body">
					<div class="otl-bulk-row">
						<label class="otl-bulk-label">Type for all pasted labels</label>
						<select id="otl-bulk-type" class="input is-small otl-bulk-type" title="Every pasted label is added under this type" onchange="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelPickBulkType(this.value)">{~TS:Headlight-ObsLabelTypeOption:Record.TagTypeOptions~}</select>
					</div>
					<textarea id="otl-bulk-text" class="textarea is-small otl-bulk-text" rows="5" placeholder="Paste labels here — one per line, or separated by commas or | . Each is added under the type above." oninput="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelSetBulkTag(this.value)">{~D:Record.BulkTag~}</textarea>
					<div class="otl-bulk-actions">
						<button class="button is-link is-small" onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelBulkAdd()"><span class="icon"><i class="fas fa-layer-group"></i></span><span>Add all</span></button>
					</div>
				</div>
			</details>`
	},
	{
		Hash: 'Headlight-ObsLabelNoMatch',
		Template: /*html*/`<p class="otl-empty">No labels match your search or filter. <a onclick="_Pict.providers['{~D:Record.ProviderName~}'].obsLabelClearSearch()">Clear the search</a> or pick a different type.</p>`
	},
	{
		Hash: 'Headlight-ObsLabelNoTypes',
		Template: /*html*/`<div class="otl-notypes"><span class="icon"><i class="fas fa-circle-info"></i></span><span>This project has no label types yet. Add one under <strong>Label types</strong> below — types populate the dropdown you pick from when adding a label.</span></div>`
	},
	{
		Hash: 'Headlight-ObsLabelEmpty',
		Template: /*html*/`<p class="otl-empty">No labels have been added to this project yet.</p>`
	},
	{
		Hash: 'Headlight-ObsLabelReadOnly',
		Template: /*html*/`<p class="otl-ro-note">You don’t have permission to change this project’s labels.</p>`
	},
	{
		Hash: 'Headlight-ObsLabelLoading',
		Template: /*html*/`<div class="otl-loading"><span class="otl-spin"></span>Loading labels…</div>`
	}
];

},{"./ConfigSync.js":1313}],1365:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

const HOST_MOUNT = '#PW-StaffingHost';
const USER_PICKER = 'PS-UserPicker';
const ROLE_PICKER = 'PS-RolePicker';          // role for the "add staff" row
const MEMBER_ROLE_PICKER = 'PS-MemberRolePicker';   // role for an existing member's "add role"

/**
 * ProjectStaffing — the "Staffing" tab of the config-app Project workspace: manage which users are on a project and
 * their project role(s) (PE, Assistant PE, Contractor Approver, ADA, HQ AE, …). Mirrors the Home app's staffing page
 * and the member-sync model EXACTLY:
 *   - a member = one ProjectUserJoin {IDProject, IDUser, IDRole} (server computes the Synthesized* fields);
 *   - add a member: POST ProjectUserJoin { IDUser, IDProject, IDRole? };
 *   - a member's role(s) are UserContextRoles: add via PUT Permissions/Role/For/User {IDUser,Context:'Project',IDContext,IDRole},
 *     remove via DELETE Permissions/Role/:IDRole/For/User/:IDUser/In/Project/:IDContext;
 *   - remove a member: DELETE Permissions/Memberships/For/User/:IDUser/In/Project/:IDContext.
 * Project-assignable roles are Role records with Type IN ('','Role'). Gated by the User-Project / User-Role
 * association capabilities. Embedded via openInto(mount) — same host idiom as RecordDates.
 */
class ProjectStaffingProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._loadToken = 0;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID || tmpUser.IDCustomer) : 0; }

	_can(pEntity, pAction)
	{
		const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
		if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function')) { return tmpApp.EffectivePermissionsService.can(pEntity, pAction); }
		return true;
	}

	get state()
	{
		if (!this.pict.AppData.ProjectStaffing)
		{
			this.pict.AppData.ProjectStaffing =
			{
				IDProject: 0, IDCustomer: 0, MountSelector: HOST_MOUNT, LoadedKey: '',
				Loading: false, Loaded: false, Error: '',
				Members: [], AddUserID: '', AddRoleID: '', Adding: false, AddError: '',
				AddRoleForUser: 0, MemberRoleID: '', MemberBusy: 0, Notice: '',
				Can: { Associate: true, Disassociate: true, AssignRole: true, UnassignRole: true, ReadRoles: true },
			};
		}
		return this.pict.AppData.ProjectStaffing;
	}

	// ── REST helpers ─────────────────────────────────────────────────────────────
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_deleteJSON(pURL) { const tmpRC = this.restClient; return (tmpRC && (typeof tmpRC.deleteJSON === 'function')) ? new Promise((resolve) => tmpRC.deleteJSON(pURL, (pErr) => resolve(!pErr))) : Promise.resolve(false); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	// Richer label for the user-SELECTION dropdown (and the resolved chip): name plus LoginID and Email so an
	// admin can pick the right person among similarly-named users. The members list uses the plain userLabel
	// (name) alongside its own Email column, so it is not cluttered.
	_userOptionLabel(pUser)
	{
		const tmpBase = libUserSearch.userLabel(pUser);
		const tmpBits = [];
		if (pUser.LoginID && (pUser.LoginID !== tmpBase))
		{
			tmpBits.push(pUser.LoginID);
		}
		if (pUser.Email && (pUser.Email !== tmpBase))
		{
			tmpBits.push(pUser.Email);
		}
		return tmpBits.length ? `${ tmpBase } — ${ tmpBits.join(' · ') }` : tmpBase;
	}

	// ── Open (workspace embed) ───────────────────────────────────────────────────
	openInto(pMode, pID, pMountSelector)
	{
		const tmpState = this.state;
		const tmpID = Number(pID) || 0;
		const tmpKey = `Project:${tmpID}`;
		const tmpMount = pMountSelector || HOST_MOUNT;
		// Same project already loaded (workspace repainted the host on a background render): re-attach, don't reload.
		if (tmpState.LoadedKey === tmpKey && tmpState.Loaded && !tmpState.Loading)
		{
			tmpState.MountSelector = tmpMount;
			this.render();
			return;
		}
		tmpState.MountSelector = tmpMount;
		tmpState.IDProject = tmpID;
		tmpState.LoadedKey = '';
		tmpState.Loading = true; tmpState.Loaded = false; tmpState.Error = '';
		tmpState.Members = []; tmpState.AddUserID = ''; tmpState.AddRoleID = ''; tmpState.AddError = '';
		tmpState.AddRoleForUser = 0; tmpState.MemberRoleID = ''; tmpState.Notice = '';
		tmpState.Can = {
			Associate: this._can('User-Project', 'Associate'), Disassociate: this._can('User-Project', 'Disassociate'),
			AssignRole: this._can('User-Role', 'Associate'), UnassignRole: this._can('User-Role', 'Disassociate'),
			ReadRoles: this._can('Role', 'Read'),
		};
		const tmpToken = ++this._loadToken;
		this.render();
		this._loadAsync(tmpToken);
	}

	async _loadAsync(pToken)
	{
		const tmpState = this.state;
		const tmpID = tmpState.IDProject;
		const fStale = () => (pToken !== undefined) && (pToken !== this._loadToken);
		if (!tmpID) { tmpState.Loading = false; tmpState.Error = 'No project specified.'; this.render(); return; }
		const tmpProject = await this._getJSON(`Project/${tmpID}`);
		if (fStale()) { return; }
		tmpState.IDCustomer = (tmpProject && Number(tmpProject.IDCustomer)) || this.callerCustomer();
		const tmpJoins = await this._getJSON(`ProjectUserJoins/FilteredTo/FBV~IDProject~EQ~${tmpID}/0/2000`);
		if (fStale()) { return; }
		const tmpJoinRows = Array.isArray(tmpJoins) ? tmpJoins : [];
		const tmpUserIDs = Array.from(new Set(tmpJoinRows.map((pJoin) => Number(pJoin.IDUser)).filter((pV) => pV > 0)));
		if (!tmpUserIDs.length) { tmpState.Members = []; tmpState.Loading = false; tmpState.Loaded = true; tmpState.LoadedKey = `Project:${tmpID}`; this.render(); return; }
		const tmpUsers = await this._getJSON(`Users/FilteredTo/FBL~IDUser~INN~${tmpUserIDs.join(',')}/0/${tmpUserIDs.length + 10}`);
		if (fStale()) { return; }
		const tmpUserByID = {};
		(Array.isArray(tmpUsers) ? tmpUsers : []).forEach((pUser) => { if (pUser && pUser.IDUser != null) { tmpUserByID[Number(pUser.IDUser)] = pUser; } });
		// Resolve each member's project role(s) via the Permissions endpoint (mirrors the Home staffing cell).
		const tmpMembers = await Promise.all(tmpUserIDs.map(async (pIDUser) =>
		{
			const tmpRoles = await this._getJSON(`Permissions/Roles/For/User/${pIDUser}/In/Project/${tmpID}`);
			const tmpUser = tmpUserByID[pIDUser];
			return {
				IDUser: pIDUser,
				Name: tmpUser ? libUserSearch.userLabel(tmpUser) : `User #${pIDUser}`,
				Email: (tmpUser && tmpUser.Email) || '',
				Roles: (Array.isArray(tmpRoles) ? tmpRoles : [])
					.filter((pRole) => pRole && !this._isTruthy(pRole.Deleted) && pRole.Type !== 'UserGroup' && pRole.Type !== 'PermissionGroup')
					.map((pRole) => ({ IDRole: Number(pRole.IDRole), Name: pRole.Name || `Role #${pRole.IDRole}` })),
			};
		}));
		if (fStale()) { return; }
		tmpMembers.sort((pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || '')));
		tmpState.Members = tmpMembers;
		tmpState.Loading = false; tmpState.Loaded = true; tmpState.LoadedKey = `Project:${tmpID}`;
		this.render();
	}

	_isTruthy(pVal) { return (pVal === true) || (pVal === 1) || (pVal === '1'); }
	_reload() { const tmpToken = ++this._loadToken; this._loadAsync(tmpToken); }

	// ── Add a member (user + optional role) ──────────────────────────────────────
	async addMemberAsync()
	{
		const tmpState = this.state;
		if (!tmpState.Can.Associate || tmpState.Adding) { return; }
		const tmpIDUser = Number(tmpState.AddUserID) || 0;
		if (!tmpIDUser) { tmpState.AddError = 'Pick a user to add.'; this.render(); return; }
		if ((tmpState.Members || []).some((pMember) => pMember.IDUser === tmpIDUser)) { tmpState.AddError = 'That user is already on this project.'; this.render(); return; }
		tmpState.Adding = true; tmpState.AddError = ''; tmpState.Notice = '';
		this.render();
		const tmpBody = { IDProjectUserJoin: 0, IDUser: tmpIDUser, IDProject: tmpState.IDProject };
		const tmpIDRole = Number(tmpState.AddRoleID) || 0;
		if (tmpIDRole > 0) { tmpBody.IDRole = tmpIDRole; }
		const tmpRes = await this._postJSON('ProjectUserJoin', tmpBody);
		tmpState.Adding = false;
		if (tmpRes.error) { tmpState.AddError = 'The server rejected the assignment (you may lack permission).'; this.render(); return; }
		tmpState.AddUserID = ''; tmpState.AddRoleID = ''; tmpState.Notice = 'Added.';
		this._reload();
	}

	// ── Per-member role management ───────────────────────────────────────────────
	openAddRole(pIDUser) { this.state.AddRoleForUser = Number(pIDUser) || 0; this.state.MemberRoleID = ''; this.render(); }
	cancelAddRole() { this.state.AddRoleForUser = 0; this.state.MemberRoleID = ''; this.render(); }

	async assignRoleAsync(pIDUser)
	{
		const tmpState = this.state;
		if (!tmpState.Can.AssignRole) { return; }
		const tmpIDRole = Number(tmpState.MemberRoleID) || 0;
		if (!tmpIDRole) { return; }
		tmpState.MemberBusy = Number(pIDUser);
		this.render();
		const tmpRes = await this._putJSON('Permissions/Role/For/User', { IDUser: Number(pIDUser), Context: 'Project', IDContext: tmpState.IDProject, IDRole: tmpIDRole });
		tmpState.MemberBusy = 0; tmpState.AddRoleForUser = 0; tmpState.MemberRoleID = '';
		if (tmpRes.error) { tmpState.Error = 'Could not assign the role.'; this.render(); return; }
		this._reload();
	}

	async removeRoleAsync(pIDUser, pIDRole)
	{
		const tmpState = this.state;
		if (!tmpState.Can.UnassignRole) { return; }
		tmpState.MemberBusy = Number(pIDUser);
		this.render();
		const tmpOK = await this._deleteJSON(`Permissions/Role/${Number(pIDRole)}/For/User/${Number(pIDUser)}/In/Project/${tmpState.IDProject}`);
		tmpState.MemberBusy = 0;
		if (!tmpOK) { tmpState.Error = 'Could not remove the role.'; this.render(); return; }
		this._reload();
	}

	async removeMemberAsync(pIDUser)
	{
		const tmpState = this.state;
		if (!tmpState.Can.Disassociate) { return; }
		tmpState.MemberBusy = Number(pIDUser);
		this.render();
		const tmpOK = await this._deleteJSON(`Permissions/Memberships/For/User/${Number(pIDUser)}/In/Project/${tmpState.IDProject}`);
		tmpState.MemberBusy = 0;
		if (!tmpOK) { tmpState.Error = 'Could not remove the member.'; this.render(); return; }
		this._reload();
	}

	// ── Pickers ──────────────────────────────────────────────────────────────────
	_pickerProvider() { return this.pict.providers['Pict-Section-Picker']; }

	/** Searchable Users picker over the shared user search (name, login ID or email; every word must match), scoped
	 *  to the caller's customer. */
	_userDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Scope: () => `FBV~IDCustomer~EQ~${this.callerCustomer()}~FBV~Deleted~EQ~0`,
				PageSize: 50,
				ToOption: (pUser) => ({ Value: Number(pUser.IDUser), Text: this._userOptionLabel(pUser), Record: pUser }),
			});
	}
	_userResolveValue() { return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`User/${tmpID}`).then((pUser) => ((pUser && pUser.IDUser) ? { Value: tmpID, Text: this._userOptionLabel(pUser) } : { Value: tmpID, Text: `#${tmpID}` })); }; }

	/** Project-assignable Role picker — Type IN ('','Role') (excludes UserGroup / PermissionGroup), customer-scoped. */
	_roleDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Set: 'Roles', IDField: 'IDRole', PageSize: 50, Scope: () => `FBV~IDCustomer~EQ~${this.callerCustomer()}~FBL~Type~INN~,Role`,
				ToOption: (pRole) => ({ Value: Number(pRole.IDRole), Text: pRole.Name || `Role #${pRole.IDRole}`, Record: pRole }),
			});
	}
	_roleResolveValue() { return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`Role/${tmpID}`).then((pRole) => ((pRole && pRole.IDRole) ? { Value: tmpID, Text: pRole.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })); }; }

	mountPickers()
	{
		const tmpState = this.state;
		const tmpPicker = this._pickerProvider();
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		const tmpCA = this.pict.ContentAssignment;
		if (tmpState.Can.Associate && (tmpCA.getElement(`#${USER_PICKER}`).length > 0))
		{
			const tmpUP = tmpPicker.createPicker(USER_PICKER, { DestinationAddress: `#${USER_PICKER}`, ValueAddress: 'AppData.ProjectStaffing.AddUserID', Searchable: true, AllowClear: true, ClearLabel: '— pick a user —', Placeholder: 'Search users by name, login ID, or email…', DataProvider: this._userDataProvider(), ResolveValue: this._userResolveValue() });
			if (tmpUP && (typeof tmpUP.render === 'function')) { tmpUP.render(); }
			if (tmpUP && (typeof tmpUP.setValue === 'function')) { tmpUP.setValue(tmpState.AddUserID || ''); }
		}
		if (tmpState.Can.Associate && tmpState.Can.ReadRoles && (tmpCA.getElement(`#${ROLE_PICKER}`).length > 0))
		{
			const tmpRP = tmpPicker.createPicker(ROLE_PICKER, { DestinationAddress: `#${ROLE_PICKER}`, ValueAddress: 'AppData.ProjectStaffing.AddRoleID', Searchable: true, AllowClear: true, ClearLabel: '— role (optional) —', Placeholder: 'Search roles…', DataProvider: this._roleDataProvider(), ResolveValue: this._roleResolveValue() });
			if (tmpRP && (typeof tmpRP.render === 'function')) { tmpRP.render(); }
			if (tmpRP && (typeof tmpRP.setValue === 'function')) { tmpRP.setValue(tmpState.AddRoleID || ''); }
		}
		if (tmpState.AddRoleForUser && (tmpCA.getElement(`#${MEMBER_ROLE_PICKER}`).length > 0))
		{
			const tmpMP = tmpPicker.createPicker(MEMBER_ROLE_PICKER, { DestinationAddress: `#${MEMBER_ROLE_PICKER}`, ValueAddress: 'AppData.ProjectStaffing.MemberRoleID', Searchable: true, AllowClear: true, ClearLabel: '— pick a role —', Placeholder: 'Search roles…', DataProvider: this._roleDataProvider(), ResolveValue: this._roleResolveValue() });
			if (tmpMP && (typeof tmpMP.render === 'function')) { tmpMP.render(); }
			if (tmpMP && (typeof tmpMP.setValue === 'function')) { tmpMP.setValue(tmpState.MemberRoleID || ''); }
		}
	}

	// ── Render ───────────────────────────────────────────────────────────────────
	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpSel = this.state.MountSelector || HOST_MOUNT;
		if (tmpCA.getElement(tmpSel).length === 0) { return; }
		tmpCA.assignContent(tmpSel, this._html());
		this.mountPickers();
	}

	_html()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return '<div class="ps-wrap"><p class="ps-note">Loading…</p></div>'; }
		if (tmpState.Error) { return `<div class="ps-wrap"><p class="ps-error">${this._esc(tmpState.Error)}</p></div>`; }
		return `<div class="ps-wrap">${this._membersHTML()}${this._addHTML()}${tmpState.Notice ? `<div class="ps-notice">${this._esc(tmpState.Notice)}</div>` : ''}</div>`;
	}

	_membersHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Members.length) { return '<div class="ps-section"><div class="ps-section-head">Project staff</div><p class="ps-note">No one is assigned to this project yet.</p></div>'; }
		const tmpRows = tmpState.Members.map((pMember) =>
		{
			const tmpBusy = (tmpState.MemberBusy === pMember.IDUser);
			const tmpChips = pMember.Roles.length
				? pMember.Roles.map((pRole) => `<span class="ps-role">${this._esc(pRole.Name)}${tmpState.Can.UnassignRole ? `<button class="ps-x" title="Remove role" onclick="_Pict.providers.ProjectStaffing.removeRoleAsync(${pMember.IDUser}, ${pRole.IDRole})">×</button>` : ''}</span>`).join('')
				: '<span class="ps-norole">no role</span>';
			const tmpAddRole = (tmpState.Can.AssignRole && tmpState.Can.ReadRoles)
				? (tmpState.AddRoleForUser === pMember.IDUser
					? `<span class="ps-addrole"><span id="${MEMBER_ROLE_PICKER}" class="ps-rolepick"></span><button class="ps-btn ps-btn-sm ps-btn-primary" onclick="_Pict.providers.ProjectStaffing.assignRoleAsync(${pMember.IDUser})">Add</button><button class="ps-btn ps-btn-sm" onclick="_Pict.providers.ProjectStaffing.cancelAddRole()">Cancel</button></span>`
					: `<button class="ps-btn ps-btn-sm" onclick="_Pict.providers.ProjectStaffing.openAddRole(${pMember.IDUser})">+ role</button>`)
				: '';
			const tmpRemove = tmpState.Can.Disassociate ? `<button class="ps-icon ps-icon-x" title="Remove from project" onclick="_Pict.providers.ProjectStaffing.removeMemberAsync(${pMember.IDUser})">✕</button>` : '';
			return `<div class="ps-member${tmpBusy ? ' is-busy' : ''}"><div class="ps-member-main"><div class="ps-member-name">${this._esc(pMember.Name)}</div>${pMember.Email ? `<div class="ps-member-email">${this._esc(pMember.Email)}</div>` : ''}</div>`
				+ `<div class="ps-roles">${tmpChips} ${tmpAddRole}</div>${tmpRemove}</div>`;
		}).join('');
		return `<div class="ps-section"><div class="ps-section-head">Project staff <span class="ps-count">${tmpState.Members.length}</span></div>${tmpRows}</div>`;
	}

	_addHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Can.Associate) { return '<p class="ps-note">You can view staffing here, but adding members needs the manage-project-membership permission.</p>'; }
		const tmpBusy = tmpState.Adding ? '<span class="ps-busy">adding…</span>' : '';
		const tmpErr = tmpState.AddError ? `<div class="ps-error">${this._esc(tmpState.AddError)}</div>` : '';
		const tmpRolePick = tmpState.Can.ReadRoles ? `<span id="${ROLE_PICKER}" class="ps-rolepick"></span>` : '';
		return `<div class="ps-section ps-add"><div class="ps-section-head">Add staff</div>`
			+ `<div class="ps-add-row"><span id="${USER_PICKER}" class="ps-userpick"></span>${tmpRolePick}<button class="ps-btn ps-btn-primary" onclick="_Pict.providers.ProjectStaffing.addMemberAsync()">Add to project</button>${tmpBusy}</div>${tmpErr}</div>`;
	}
}

module.exports = ProjectStaffingProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ProjectStaffing',
	AutoInitialize: true,
	AutoInitializeOrdinal: 45,
};

},{"../access/User-Search.js":1064,"../services/Entity-Picker-Search.js":1398,"pict-provider":845}],1366:[function(require,module,exports){
/**
 * ProjectTypeComprehensionBuilder
 *
 * Pure utilities the HPC config app uses when a user creates/edits a PROJECT TYPE or
 * CONTRACT TYPE:
 *   - `build{Project,Contract}TypeComprehension` assemble the comprehension that
 *     creates/updates the type record + its prototype project/contract shell.
 *   - `computeDefaultDateReconciliation` produces the upsert/delete plan that keeps the
 *     type's default-date list (and the prototype's matching dates) in sync with the
 *     editor grid WITHOUT churning untouched rows or deleting user data.
 *
 * The type identifies its prototype by the `Settings.PrototypeID{Project,Contract}`
 * pointer written back after the push — the prototype carries no marker. Statuses,
 * allowed project types, and default dates are persisted by the caller AFTER the push
 * (they need the type's / prototype's numeric ids, unknown until the push creates them).
 *
 * DEFAULT DATES are deliberately NOT part of the comprehension. The type's default-date
 * definitions (`{Project,Contract}TypeDefaultDate`) and the prototype's matching dates
 * (`{Project,Contract}Date`) are reconciled by Hash (their natural key) so an unchanged
 * date keeps its row/id, an added row is created, and ONLY a row removed from the grid is
 * deleted. Crucially, dates a user added directly to the prototype (a Hash that was never
 * a default) are never touched — see `computeDefaultDateReconciliation`.
 *
 * Cross-entity links use external GUIDs the comprehension processor resolves at push
 * time: the prototype references the type via `GUID{Project,Contract}Type`. The caller
 * supplies random GUIDs (the existing record GUIDs on edit; freshly minted ones on
 * create) for `typeGUID` / `prototypeGUID` — opaque identity keys, never derived from
 * Hash, so a Hash reused across types or customers never collides.
 *
 * No Fable / pict dependencies — unit-tested in isolation.
 */

/** Stable, filesystem/url-safe-ish slug of a natural key. */
function slug(pValue)
{
	return String(pValue === null || pValue === undefined ? '' : pValue)
		.trim()
		.replace(/[^A-Za-z0-9_-]+/g, '_')
		.slice(0, 48);
}

/**
 * @typedef {Object} ProjectTypeComprehensionInput
 * @property {string} typeGUID - external GUID for the ProjectType (existing GUIDProjectType on edit, new on create).
 * @property {string} prototypeGUID - external GUID for the prototype Project.
 * @property {Object} type - { Name, Hash, Description, Ordinal, IDCustomer, IDProgram, Settings } (Settings = scalars only, no statuses/dates).
 */

/**
 * Build the project-type comprehension: the `ProjectType` record + its prototype
 * `Project` shell. Default dates are reconciled separately (see
 * `computeDefaultDateReconciliation`); the prototype's forms / observation types /
 * labels are configured through the normal project tools and cloned by the seeder.
 *
 * @param {ProjectTypeComprehensionInput} pInput
 * @returns {Object} comprehension keyed by entity name -> external GUID -> record
 */
function buildProjectTypeComprehension(pInput)
{
	const tmpInput = pInput || {};
	const tmpType = tmpInput.type || {};
	const tmpTypeGUID = tmpInput.typeGUID;
	const tmpProtoGUID = tmpInput.prototypeGUID;
	if (!tmpTypeGUID || !tmpProtoGUID)
	{
		throw new Error('buildProjectTypeComprehension requires typeGUID and prototypeGUID.');
	}
	const tmpCustomer = tmpType.IDCustomer || 0;
	const tmpProgram = tmpType.IDProgram || 0;
	const tmpTypeName = tmpType.Name || '';

	// The type's Settings blob carries scalars + the prototype pointer (by GUID; the
	// numeric PrototypeIDProject is resolved + written by the caller after the push).
	const tmpSettings = Object.assign({}, tmpType.Settings || {}, { PrototypeGUIDProject: tmpProtoGUID });

	const tmpComprehension = {};

	tmpComprehension.ProjectType =
	{
		[tmpTypeGUID]:
		{
			GUIDProjectType: tmpTypeGUID,
			Name: tmpTypeName,
			Hash: tmpType.Hash || '',
			Description: tmpType.Description || '',
			Ordinal: tmpType.Ordinal || 0,
			IDCustomer: tmpCustomer,
			IDProgram: tmpProgram,
			SettingsJSON: JSON.stringify(tmpSettings),
		},
	};

	// Prototype Project shell — references the type via GUIDProjectType. The type is the
	// authority on which project is its prototype (ProjectType.Settings.PrototypeIDProject,
	// written back after this push), so no marker is stamped on the project.
	tmpComprehension.Project =
	{
		[tmpProtoGUID]:
		{
			GUIDProject: tmpProtoGUID,
			GUIDProjectType: tmpTypeGUID,
			Name: `[PROTOTYPE] ${tmpTypeName || tmpType.Hash || 'Project Type'}`,
			Description: `Canonical prototype project for project type "${tmpTypeName || tmpType.Hash}". Managed by the project-type configuration.`,
			IDCustomer: tmpCustomer,
		},
	};

	return tmpComprehension;
}

/**
 * Build the contract-type comprehension: the `ContractType` record + its prototype
 * `Contract` shell. Default dates are reconciled separately (see
 * `computeDefaultDateReconciliation`).
 *
 * @param {{typeGUID:string, prototypeGUID:string, type:Object}} pInput
 * @returns {Object} comprehension keyed by entity name -> external GUID -> record
 */
function buildContractTypeComprehension(pInput)
{
	const tmpInput = pInput || {};
	const tmpType = tmpInput.type || {};
	const tmpTypeGUID = tmpInput.typeGUID;
	const tmpProtoGUID = tmpInput.prototypeGUID;
	if (!tmpTypeGUID || !tmpProtoGUID)
	{
		throw new Error('buildContractTypeComprehension requires typeGUID and prototypeGUID.');
	}
	const tmpCustomer = tmpType.IDCustomer || 0;
	const tmpTypeName = tmpType.Name || '';
	const tmpSettings = Object.assign({}, tmpType.Settings || {}, { PrototypeGUIDContract: tmpProtoGUID });

	const tmpComprehension = {};
	tmpComprehension.ContractType =
	{
		[tmpTypeGUID]:
		{
			GUIDContractType: tmpTypeGUID,
			Name: tmpTypeName,
			Hash: tmpType.Hash || '',
			Description: tmpType.Description || '',
			IDCustomer: tmpCustomer,
			SettingsJSON: JSON.stringify(tmpSettings),
		},
	};
	tmpComprehension.Contract =
	{
		[tmpProtoGUID]:
		{
			GUIDContract: tmpProtoGUID,
			GUIDContractType: tmpTypeGUID,
			Name: `[PROTOTYPE] ${tmpTypeName || tmpType.Hash || 'Contract Type'}`,
			IDCustomer: tmpCustomer,
		},
	};

	return tmpComprehension;
}

/** Trim + coerce a raw display value to a string. */
function cleanString(pValue)
{
	return (typeof pValue === 'string') ? pValue.trim() : '';
}

/**
 * Normalize the editor's default-date rows to `[{ Hash, Name }]` keyed by a non-empty
 * Hash (falling back to Name when Hash is blank), de-duplicated by Hash (last wins).
 *
 * @param {Array<{Hash?:string,Name?:string}>} pGridDates
 * @returns {Map<string,{Hash:string,Name:string}>}
 */
function normalizeGridDatesByHash(pGridDates)
{
	const tmpByHash = new Map();
	const tmpRows = Array.isArray(pGridDates) ? pGridDates : [];
	for (const tmpRow of tmpRows)
	{
		const tmpName = cleanString(tmpRow && tmpRow.Name);
		const tmpHash = cleanString(tmpRow && tmpRow.Hash) || tmpName;
		if (!tmpHash)
		{
			continue;
		}
		tmpByHash.set(tmpHash, { Hash: tmpHash, Name: tmpName || tmpHash });
	}
	return tmpByHash;
}

/** Index existing rows by their (non-blank) Hash; last row for a Hash wins. */
function indexRowsByHash(pRows)
{
	const tmpByHash = new Map();
	const tmpRows = Array.isArray(pRows) ? pRows : [];
	for (const tmpRow of tmpRows)
	{
		const tmpHash = cleanString(tmpRow && tmpRow.Hash);
		if (tmpHash)
		{
			tmpByHash.set(tmpHash, tmpRow);
		}
	}
	return tmpByHash;
}

/**
 * Compute the upsert/delete plan to reconcile a type's default dates with the editor grid
 * — applied by `TypeComprehensionSaveProvider`. Reconciliation is by Hash (the date
 * milestone's natural key):
 *   - an unchanged grid row produces NO write (its row + id are left intact),
 *   - a grid row whose Name changed produces an UPDATE that keeps the existing id,
 *   - a brand-new grid row produces a CREATE,
 *   - filled prototype dates keep their `Date` when their Name is updated.
 *
 * The type's own definition list (`*TypeDefaultDate`) is fully reconciled — a row removed
 * from the grid is DELETED, since the grid is that list's editor. The prototype's dates
 * (`{Project,Contract}Date`), by contrast, are ONLY added/updated and NEVER deleted: a
 * prototype is a real project/contract a user configures separately, so removing a row
 * from the grid simply drops it from the default list while leaving the prototype's date
 * (now a non-default date the user owns) untouched.
 *
 * @param {Array<Object>} pExistingTypeRows - current `{Project,Contract}TypeDefaultDate` rows for the type.
 * @param {Array<Object>} pExistingProtoRows - current `{Project,Contract}Date` rows on the prototype.
 * @param {Array<{Hash?:string,Name?:string}>} pGridDates - the editor's current date list.
 * @param {{typeDateEntity:string, protoDateEntity:string, typeIDField:string, protoIDField:string, typeID:number, protoID:number, idCustomer:number}} pKeys
 * @returns {{typeUpserts:Array<Object>, typeDeletes:Array<number>, protoUpserts:Array<Object>}}
 */
function computeDefaultDateReconciliation(pExistingTypeRows, pExistingProtoRows, pGridDates, pKeys)
{
	const tmpKeys = pKeys || {};
	const tmpTypeIDKey = `ID${tmpKeys.typeDateEntity}`;
	const tmpProtoIDKey = `ID${tmpKeys.protoDateEntity}`;

	const tmpGridByHash = normalizeGridDatesByHash(pGridDates);
	const tmpTypeByHash = indexRowsByHash(pExistingTypeRows);
	const tmpProtoByHash = indexRowsByHash(pExistingProtoRows);

	const tmpPlan = { typeUpserts: [], typeDeletes: [], protoUpserts: [] };

	for (const [tmpHash, tmpDate] of tmpGridByHash)
	{
		const tmpExistingType = tmpTypeByHash.get(tmpHash);
		if (!tmpExistingType)
		{
			tmpPlan.typeUpserts.push({ Name: tmpDate.Name, Hash: tmpHash, [tmpKeys.typeIDField]: tmpKeys.typeID, IDCustomer: tmpKeys.idCustomer });
		}
		else if (cleanString(tmpExistingType.Name) !== tmpDate.Name)
		{
			tmpPlan.typeUpserts.push({ [tmpTypeIDKey]: tmpExistingType[tmpTypeIDKey], Name: tmpDate.Name, Hash: tmpHash, [tmpKeys.typeIDField]: tmpKeys.typeID, IDCustomer: tmpKeys.idCustomer });
		}

		const tmpExistingProto = tmpProtoByHash.get(tmpHash);
		if (!tmpExistingProto)
		{
			tmpPlan.protoUpserts.push({ Name: tmpDate.Name, Hash: tmpHash, [tmpKeys.protoIDField]: tmpKeys.protoID, Date: null, IDCustomer: tmpKeys.idCustomer });
		}
		else if (cleanString(tmpExistingProto.Name) !== tmpDate.Name)
		{
			// Preserve a filled Date when only the Name changed.
			tmpPlan.protoUpserts.push({ [tmpProtoIDKey]: tmpExistingProto[tmpProtoIDKey], Name: tmpDate.Name, Hash: tmpHash, [tmpKeys.protoIDField]: tmpKeys.protoID, Date: (tmpExistingProto.Date != null ? tmpExistingProto.Date : null), IDCustomer: tmpKeys.idCustomer });
		}
	}

	// The type's own default-date list is fully reconciled — delete the rows the user
	// removed from the grid. Prototype dates are intentionally never deleted (see above).
	for (const tmpRow of (Array.isArray(pExistingTypeRows) ? pExistingTypeRows : []))
	{
		const tmpHash = cleanString(tmpRow && tmpRow.Hash);
		if (tmpHash && !tmpGridByHash.has(tmpHash) && tmpRow[tmpTypeIDKey])
		{
			tmpPlan.typeDeletes.push(tmpRow[tmpTypeIDKey]);
		}
	}

	return tmpPlan;
}

module.exports = {
	slug,
	buildProjectTypeComprehension,
	buildContractTypeComprehension,
	normalizeGridDatesByHash,
	computeDefaultDateReconciliation,
};

},{}],1367:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libLogoSlotController = require('./LogoSlotController.js');
const libLabelManagerController = require('./LabelManagerController.js');
const libLabelBehaviorController = require('./LabelBehaviorController.js');
const libProjectObservationLabelController = require('./ProjectObservationLabelController.js');
const libRecordSetAssociationEditor = require('pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js');
const libConfigSync = require('./ConfigSync.js');
const libProjectEditAccess = require('../access/Project-Edit-Access.js');

// The association-editor tabs — each a picker + current-list over a Project join, anchored on the Project side.
// Their host divs are re-created on every tab paint, so _mountTab re-mounts whichever one is on screen.
// NOTE: Equipment↔contractor is NOT here — it moved to the ProjectContractorMatrixEquipment M:N grid (equipment can
// have many contractors, matching ProjectEquipmentJoin's ternary key + Fieldbook), mounted like the line/bid matrices.
const ASSOC_TABS =
[
	// SyncOnChange: associating/removing an observation type changes what the field apps should offer for this
	// project, so a scoped Project config sync is fired (debounced) after each add/remove — see _ensureAssocEditorView.
	{ Host: '#PW-ObsHost', Hash: 'PW-ObsAssocEditor', Association: 'ProjectObservationManifest', SyncOnChange: true },
	{ Host: '#PW-LabHost', Hash: 'PW-LabAssocEditor', Association: 'LabProject' },
	{ Host: '#PW-ContactHost', Hash: 'PW-ContactAssocEditor', Association: 'ContactProject' },
	{ Host: '#PW-OrgHost', Hash: 'PW-OrgAssocEditor', Association: 'OrganizationProject' },
];

// Which per-tab template each leaf key paints (reused verbatim from the original view via parseTemplateByHash).
const TAB_TEMPLATE =
{
	overview: 'ProjectWorkspace-Overview', location: 'ProjectWorkspace-Location',
	lineitems: 'ProjectWorkspace-LineItems', biditems: 'ProjectWorkspace-BidItems', bidmap: 'ProjectWorkspace-BidItemMap',
	branding: 'ProjectWorkspace-Branding', labels: 'ProjectWorkspace-Labels', observations: 'ProjectWorkspace-Observations',
	equipment: 'ProjectWorkspace-Equipment', lab: 'ProjectWorkspace-Lab', contact: 'ProjectWorkspace-Contact', organization: 'ProjectWorkspace-Organization',
	linecontractors: 'ProjectWorkspace-LineContractors', bidcontractors: 'ProjectWorkspace-BidContractors',
	dates: 'ProjectWorkspace-Dates', staffing: 'ProjectWorkspace-Staffing', funding: 'ProjectWorkspace-Funding', changeorders: 'ProjectWorkspace-ChangeOrders',
	sampleplan: 'ProjectWorkspace-SamplePlan',
	sampleplandashboard: 'ProjectWorkspace-SamplePlanDashboard',
	'data-observations': 'ProjectWorkspace-DataObs', 'data-forms': 'ProjectWorkspace-DataForms',
	'data-files': 'ProjectWorkspace-Files', 'data-bulk-upload': 'ProjectWorkspace-BulkUpload', 'data-volume': 'ProjectWorkspace-DataVolume',
};

const PROJECT_LOGO_SLOTS =
[
	{ Key: 'logo', Label: 'Project logo', Base: 'Project/PrimaryLogo', Help: 'A PNG shown for this project across Headlight. Falls back to the customer logo when unset.' },
	{ Key: 'secondary', Label: 'Project reports logo', Base: 'Project/SecondaryLogo', Help: 'A PNG used on this project’s generated reports and documents.' },
];

// A Project is the richest config record in the platform: identity + schedule + financials + contract
// relationships + a geographic center (Latitude/Longitude) + a nested CustomProperties JSON blob +
// several connection sets (Observation Types, …). The stock recordset read renders a flat manifest
// form, which (a) coerces the parsed CustomProperties object to "[object Object]" and (b) can't host a
// map. This bespoke workspace owns the whole Project view: grouped read-only fields, formatted JSON, a
// Leaflet center-picker, and the association tabs — the same "bespoke UI for a complex config segment"
// pattern as the Observation Type builder. The pict-section-recordset list stays the browse surface.

// Read-only field groups for the Overview tab (declarative so the view iterates; values are formatted
// into display strings here — one-shot derived display data, not markup).
const FIELD_GROUPS =
[
	{ Name: 'Identity', Fields:
		[
			{ Key: 'Name', Label: 'Project Name', Wide: true },
			{ Key: 'ExternalProjectID', Label: 'External Project ID' },
			{ Key: 'Status', Label: 'Status' },
			{ Key: 'ImprovementTypeCode', Label: 'Improvement Type' },
		] },
	{ Name: 'Schedule', Fields:
		[
			{ Key: 'OriginalContractedDays', Label: 'Original Contracted Days', Format: 'number' },
			{ Key: 'ContractedDays', Label: 'Contracted Days', Format: 'number' },
			{ Key: 'CompletedDays', Label: 'Completed Days', Format: 'number' },
			{ Key: 'PaidDays', Label: 'Paid Days', Format: 'number' },
			{ Key: 'PercentComplete', Label: 'Percent Complete', Format: 'percent' },
			{ Key: 'PercentCompleteByDays', Label: 'Percent Complete (by days)', Format: 'percent' },
			{ Key: 'Timezone', Label: 'Timezone' },
		] },
	// Actions: 'financials' hangs the "Calculate initial contract" button off this group's header —
	// the only group with an action today.
	{ Name: 'Financials', Actions: 'financials', Fields:
		[
			{ Key: 'CostPerDay', Label: 'Cost / Day', Format: 'currency' },
			{ Key: 'InitialContractAmount', Label: 'Initial Contract', Format: 'currency' },
			{ Key: 'CurrentTotalContractAmount', Label: 'Current Total Contract', Format: 'currency' },
			{ Key: 'CurrentTotalContractPaid', Label: 'Total Paid', Format: 'currency' },
			{ Key: 'PurchaseOrderNumber', Label: 'Purchase Order #' },
		] },
	{ Name: 'Relationships', Fields:
		[
			{ Key: 'IDOrganization', Label: 'Prime Contractor', Card: 'Organization' },
			{ Key: 'IDContract', Label: 'Contract', Card: 'Contract' },
			{ Key: 'IDProjectType', Label: 'Project Type', Card: 'ProjectType' },
			{ Key: 'IDCustomer', Label: 'Customer', Card: 'Customer' },
		] },
	{ Name: 'Audit', Fields:
		[
			{ Key: 'CreateDate', Label: 'Created', Format: 'date' },
			{ Key: 'UpdateDate', Label: 'Last Updated', Format: 'date' },
			{ Key: 'GUIDProject', Label: 'GUID', Mono: true },
			{ Key: 'IDProject', Label: 'Project ID', Format: 'id' },
		] },
];

/**
 * ProjectWorkspace — the data layer behind the bespoke Project view. Loads a project, exposes a
 * grouped read-only render model, formats the CustomProperties JSON, holds the editable geographic
 * center, and persists the center back through Meadow. State lives in pict.AppData.ProjectWorkspace.
 */
class ProjectWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// The working model (null until a load). Held outside AppData so the render state derives cleanly each paint.
		this._project = null;
		// Serializes association-editor renders (only one assoc tab is on screen at a time).
		this._projAssocQueue = null;
		this._dataSearchTimers = {};
		// The tab the workspace is showing.
		this._activeTab = 'overview';
		// Working geographic center (decimal degrees), separate from the loaded record so the map can edit
		// it before a save.
		this._center = { Latitude: null, Longitude: null };
		this._centerDirty = false;
		this._savingCenter = false;
		// Inline validation error for the editable lat/lng inputs (cleared on any successful center set).
		this._locError = '';
		// Address-search (Nominatim) working state: the top matches, an in-flight flag, and an error string.
		this._addressResults = [];
		this._addressSearching = false;
		this._addressError = '';
		this._logoController = new libLogoSlotController(this.pict, 'ProjectWorkspace', PROJECT_LOGO_SLOTS);
		this._labelController = new libLabelManagerController(this.pict, 'ProjectWorkspace');
		// Per-observation-type label BEHAVIORS (Free Entry / Max Count / Hidden + Auto-Filter) — stored in the
		// ObservationType Configuration blob, a different axis from the vocabulary above (see LabelBehaviorController).
		this._labelBehaviorController = new libLabelBehaviorController(this.pict, 'ProjectWorkspace');
		// The Projects-app "labels" feature: a project's actual labels (ObservationTagProjectJoin), added by
		// picking a type from the vocabulary above. Distinct from _labelController (the ProjectTagType types).
		this._obsLabelController = new libProjectObservationLabelController(this.pict, 'ProjectWorkspace');
		// Observation-type defaults fallback (read-only) when the project has no joins of its own.
		this._obsDefaults = [];
		this._obsShowingDefaults = false;
		// The project's Line Items / Bid Items (loaded lazily for the Items tabs), each { Loaded, Rows }.
		this._lineItems = { Loaded: false, Rows: [] };
		this._bidItems = { Loaded: false, Rows: [] };
		// Data ▸ Observations / Forms lists — server-paged (a project can carry thousands of each), with per-list
		// page + free-text search. Loaded lazily when their tab first opens.
		this._dataLists = this._freshDataLists();
		// In-flight flag for the Financials group's "Calculate initial contract" action.
		this._calculatingContractAmount = false;
	}

	/** Role 5+ (admin) or role 4 editing a project in their own customer can manage project logos. */
	get canManageProjectLogo()
	{
		const tmpUser = (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return libProjectEditAccess.isProjectAdministrator(tmpUser, this._project);
	}

	/**
	 * May the current user save the Project record (gates the header Edit action)? The server's rule: admin, role 4 in
	 * the project's customer, or the project's creator (see access/Project-Edit-Access.js).
	 * @return {boolean}
	 */
	get canEditProject()
	{
		const tmpUser = (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return libProjectEditAccess.canEditProject(tmpUser, this._project);
	}

	/** Same gate as project logos: admin, or a role-4 customer admin on a project in their own customer. */
	get canManageLabels()
	{
		return this.canManageProjectLogo;
	}

	/** Headlight super-user (role index 5, customer 1) — gates the manual "Run Config Sync" header action. */
	get isSuperUser()
	{
		const tmpUser = (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1);
	}

	/**
	 * Manually trigger a SCOPED Configuration Sync for this project (header action; super-user only). Confirms,
	 * then fires immediately (no debounce) against the scoped endpoint, which rebuilds only this project.
	 * @return {Promise<void>}
	 */
	async syncConfiguration()
	{
		if (!this.idProject) { return; }
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		const tmpName = (this._project && this._project.Name) || `Project ${this.idProject}`;
		const tmpConfirmed = (tmpModal && (typeof tmpModal.confirm === 'function'))
			? await tmpModal.confirm(`Run a configuration sync for ${tmpName}? This publishes the project's observation-type configuration out to the field apps. It runs in the background and may take a little while.`,
				{ title: 'Run configuration sync?', confirmLabel: 'Run sync', cancelLabel: 'Cancel' })
			: true;
		if (!tmpConfirmed) { return; }
		libConfigSync.requestScopedSync(this.pict, 'Project', Number(this.idProject), { immediate: true });
	}

	/** Recalculating the initial contract amount writes to the Project, so it needs the same gate as the other project edits. */
	get canEditProjectFinancials()
	{
		return this.canManageProjectLogo;
	}

	/** The bulk-delete tools are gated by the 'Project-BulkDelete' entitlement (access/Task-Catalog.js). */
	get canBulkDelete()
	{
		try
		{
			const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
			if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function'))
			{
				return tmpApp.EffectivePermissionsService.can('Project', 'BulkDelete');
			}
		}
		catch (pError) { /* default closed */ }
		return false;
	}

	/**
	 * Open the project-scoped bulk-delete tool for one of the workspace's long lists. Line/bid items delete the
	 * records (soft); equipment/personnel/labels remove the project's link rows (the shared records stay). On
	 * close the affected tab is refreshed so it reflects the deletions.
	 * @param {'lineitems'|'biditems'|'equipment'|'contact'|'labels'} pKey
	 */
	openBulkDelete(pKey)
	{
		if (!this.canBulkDelete || !this._project) { return; }
		const tmpID = this._project.IDProject;
		// Closing the inline tool clears bulk mode, runs the per-list refresh, and repaints (which restores the
		// tab's normal read list and re-mounts any embedded editor).
		const fClose = (pRefresh) => () => { this._bulkDeleteKey = null; this._bulkSpec = null; if (typeof pRefresh === 'function') { pRefresh(); } this._render(); };
		const tmpHost = '#PW-BulkInlineHost';
		const tmpSpecs =
		{
			lineitems: {
				Title: 'Delete line items', Noun: 'line item', NounPlural: 'line items', Verb: 'Delete', Host: tmpHost,
				DeleteEntity: 'LineItem', ItemsSet: 'LineItems', IDField: 'IDLineItem',
				Filter: `FBV~IDProject~EQ~${tmpID}~FBV~Deleted~EQ~0`, Sort: 'ItemNumber',
				SearchFields: [ 'ItemNumber', 'Name' ],
				Columns: [ { Key: 'ItemNumber', Label: 'Item #' }, { Key: 'Name', Label: 'Description' } ],
				OnClose: fClose(() => { this._lineItems = { Loaded: false, Rows: [] }; if (this._activeTab === 'lineitems') { this._loadItemsAsync('lineitems'); } }),
			},
			biditems: {
				Title: 'Delete bid items', Noun: 'bid item', NounPlural: 'bid items', Verb: 'Delete', Host: tmpHost,
				DeleteEntity: 'BidItem', ItemsSet: 'BidItems', IDField: 'IDBidItem',
				Filter: `FBV~IDProject~EQ~${tmpID}~FBV~Deleted~EQ~0`, Sort: 'Name',
				SearchFields: [ 'Name' ],
				Columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'Units', Label: 'Units' } ],
				OnClose: fClose(() => { this._bidItems = { Loaded: false, Rows: [] }; if (this._activeTab === 'biditems') { this._loadItemsAsync('biditems'); } }),
			},
			equipment: {
				Title: 'Unlink equipment from this project', Noun: 'equipment link', NounPlural: 'equipment links', Verb: 'Unlink', Host: tmpHost,
				DeleteEntity: 'ProjectEquipmentJoin', ItemsSet: 'ProjectEquipmentJoins', IDField: 'IDProjectEquipmentJoin',
				Filter: `FBV~IDProject~EQ~${tmpID}`,
				NameResolver: { Set: 'Equipments', IDField: 'IDEquipment', NameField: 'Name', FKField: 'IDEquipment', Label: 'Equipment' },
				SearchResolver: { Set: 'Equipments', IDField: 'IDEquipment', NameFields: [ 'Name', 'Code' ], JoinFKField: 'IDEquipment' },
				Columns: [], OnClose: fClose(null),
			},
			contact: {
				Title: 'Unlink personnel from this project', Noun: 'personnel link', NounPlural: 'personnel links', Verb: 'Unlink', Host: tmpHost,
				DeleteEntity: 'ProjectContactJoin', ItemsSet: 'ProjectContactJoins', IDField: 'IDProjectContactJoin',
				Filter: `FBV~IDProject~EQ~${tmpID}`,
				NameResolver: { Set: 'Contacts', IDField: 'IDContact', NameField: 'NameFull', FKField: 'IDContact', Label: 'Personnel' },
				SearchResolver: { Set: 'Contacts', IDField: 'IDContact', NameFields: [ 'NameFull', 'NameFirst', 'NameLast' ], JoinFKField: 'IDContact' },
				Columns: [], OnClose: fClose(null),
			},
			labels: {
				Title: 'Delete labels', Noun: 'label', NounPlural: 'labels', Verb: 'Delete', Host: tmpHost,
				DeleteEntity: 'ObservationTagProjectJoin', ItemsSet: 'ObservationTagProjectJoins', IDField: 'IDObservationTagProjectJoin',
				Filter: `FBV~IDProject~EQ~${tmpID}`, Sort: 'Tag',
				SearchFields: [ 'Tag', 'TagType' ],
				Columns: [ { Key: 'Tag', Label: 'Label' }, { Key: 'TagType', Label: 'Type' } ],
				OnClose: fClose(() => { this._obsLabelController.load(); }),
			},
		};
		const tmpSpec = tmpSpecs[pKey];
		if (!tmpSpec) { return; }
		// Enter bulk mode: the active tab renders the inline host (instead of its read list); the view mounts
		// the tool into it after the paint (like the association editors).
		this._bulkDeleteKey = pKey;
		this._bulkSpec = tmpSpec;
		this._render();
	}

	uploadSlot(pKey, pInput)
	{
		return this._logoController.upload(pKey, pInput);
	}

	removeSlot(pKey)
	{
		return this._logoController.remove(pKey);
	}

	// --- Project-label delegates (the shared Headlight-LabelManager template calls these by provider name) ---

	labelAdd() { return this._labelController.add(); }
	labelUpdateName(pID, pValue) { return this._labelController.updateName(pID, pValue); }
	labelRemove(pID) { return this._labelController.remove(pID); }
	labelSetNew(pField, pValue) { return this._labelController.setNew(pField, pValue); }
	labelCopyDefaults() { return this._labelController.copyDefaults(); }

	// --- Label-behavior delegates (the shared Headlight-LabelBehavior template calls these by provider name) ---

	labelBehaviorSelectType(pType) { return this._labelBehaviorController.selectType(pType); }
	labelBehaviorSetFreeEntry(pTagType, pDeny) { return this._labelBehaviorController.setFreeEntry(pTagType, pDeny); }
	labelBehaviorSetMaxCount(pTagType, pValue) { return this._labelBehaviorController.setMaxCount(pTagType, pValue); }
	labelBehaviorSetHidden(pTagType, pHidden) { return this._labelBehaviorController.setHidden(pTagType, pHidden); }
	labelBehaviorSetDistilling(pEnabled) { return this._labelBehaviorController.setDistilling(pEnabled); }

	// --- Project observation-label delegates (the Headlight-ObsLabelManager template calls these by name) ---

	obsLabelAdd() { return this._obsLabelController.add(); }
	obsLabelRemove(pID) { return this._obsLabelController.remove(pID); }
	obsLabelSetNewTag(pValue) { return this._obsLabelController.setNewTag(pValue); }
	obsLabelPickType(pValue) { return this._obsLabelController.pickTagType(pValue); }
	obsLabelSetSearch(pValue) { return this._obsLabelController.setSearch(pValue); }
	obsLabelApplySearch() { return this._obsLabelController.applySearch(); }
	obsLabelClearSearch() { return this._obsLabelController.clearSearch(); }
	obsLabelSetFilterType(pValue) { return this._obsLabelController.setFilterType(pValue); }
	obsLabelPage(pDelta) { return this._obsLabelController.page(pDelta); }

	/** Bulk-add: add every pasted label under the chosen type (both stashed on the controller, so an unrelated
	 *  full re-render can't discard an unsubmitted paste). */
	obsLabelBulkAdd() { return this._obsLabelController.bulkAdd(this._obsLabelController.bulkTagType, this._obsLabelController.bulkTag); }
	obsLabelSetBulkTag(pValue) { return this._obsLabelController.setBulkTag(pValue); }
	obsLabelPickBulkType(pValue) { return this._obsLabelController.pickBulkType(pValue); }

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	// --- REST helpers ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_isTruthy(pValue)
	{
		return (pValue === true) || (pValue === 1) || (pValue === '1') || (String(pValue).toLowerCase() === 'true');
	}

	_escapeHtml(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/**
	 * Background-load the project's observation-type joins; if it has none of its own, fall back to the
	 * customer default set (IDProject=0 for this customer, then the global IDCustomer=0 set) shown read-only
	 * on the Observation Types tab — so the tab reflects what the project actually uses until customized.
	 * @param {Number} pIDProject
	 * @param {Number} pIDCustomer
	 */
	async _loadObservationDefaultsAsync(pIDProject, pIDCustomer)
	{
		this._obsDefaults = [];
		this._obsShowingDefaults = false;
		try
		{
			const tmpOwn = await this._getJSON(`ProjectObservationManifestJoins/FilteredTo/FBV~IDProject~EQ~${pIDProject}`);
			if (Array.isArray(tmpOwn) && tmpOwn.length > 0) { this._render(); return; }
			let tmpDefaults = await this._getJSON(`ProjectObservationManifestJoins/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~${pIDCustomer}`);
			if (!Array.isArray(tmpDefaults) || tmpDefaults.length === 0)
			{
				tmpDefaults = await this._getJSON('ProjectObservationManifestJoins/FilteredTo/FBV~IDProject~EQ~0~FBV~IDCustomer~EQ~0');
			}
			this._obsDefaults = Array.isArray(tmpDefaults) ? tmpDefaults : [];
			this._obsShowingDefaults = this._obsDefaults.length > 0;
		}
		catch (pError) { this._obsDefaults = []; this._obsShowingDefaults = false; }
		this._render();
	}

	// --- Loading (base owns loadAsync/openByGUIDAsync; hydrateAsync runs after the Project record arrives) ---

	async hydrateAsync(pRecord)
	{
		this._project = pRecord;
		this._relatedDisplay = {};
		this._lineItems = { Loaded: false, Rows: [] };
		this._bidItems = { Loaded: false, Rows: [] };
		this._dataLists = this._freshDataLists();
		this._center = { Latitude: this._toNumberOrNull(pRecord.Latitude), Longitude: this._toNumberOrNull(pRecord.Longitude) };
		this._centerDirty = false;
		this._logoController.setContext(pRecord.IDProject, this.canManageProjectLogo, () => this._render());
		this._labelController.setContext({ IDProject: pRecord.IDProject, IDCustomer: pRecord.IDCustomer }, this.canManageLabels, () => this._render(), true);
		this._labelBehaviorController.setContext({ IDProject: pRecord.IDProject, IDCustomer: pRecord.IDCustomer }, this.canManageLabels, () => this._syncLabelBehavior());
		this._obsLabelController.setContext({ IDProject: pRecord.IDProject, IDCustomer: pRecord.IDCustomer }, this.canManageLabels, () => this._syncObsLabels());
		// Background loads (fire-and-forget; each repaints when ready) — NOT awaited so the first paint is immediate.
		this._logoController.probeAll().then(() => this._render());
		this._labelController.load();
		this._labelBehaviorController.load();
		this._obsLabelController.load();
		this._loadObservationDefaultsAsync(pRecord.IDProject, pRecord.IDCustomer);
		this._resolveRelatedDisplayAsync(pRecord);
	}

	// --- Project items (Line Items / Bid Items) ---

	/**
	 * Lazily fetch the project's Line Items or Bid Items (server-filtered by IDProject) for the Items
	 * tabs. Read-only "see all my project info in one place" — one page is plenty for the config view.
	 * @param {'lineitems'|'biditems'} pWhich
	 */
	async _loadItemsAsync(pWhich)
	{
		if (!this._project || !this._project.IDProject) { return; }
		const tmpState = (pWhich === 'biditems') ? this._bidItems : this._lineItems;
		if (tmpState.Loaded || tmpState.Loading) { return; }
		tmpState.Loading = true;
		const tmpEntity = (pWhich === 'biditems') ? 'BidItems' : 'LineItems';
		const tmpItemFilter = `FBV~IDProject~EQ~${this._project.IDProject}`;
		const tmpPageSize = 500;
		try
		{
			// Also read the true total so a project with more than one page of pay items shows "showing 500 of N"
			// instead of silently reporting the truncated page length as the total (a large multi-year DOT project
			// can carry several hundred change-order items). Count is best-effort — the list still renders without it.
			const [ tmpRows, tmpCount ] = await Promise.all(
				[
					this._getJSON(`${tmpEntity}/FilteredTo/${tmpItemFilter}/0/${tmpPageSize}`),
					this._getJSON(`${tmpEntity}/Count/FilteredTo/${tmpItemFilter}`).catch(() => null),
				]);
			tmpState.Rows = Array.isArray(tmpRows) ? tmpRows : [];
			tmpState.Total = (tmpCount && (tmpCount.Count != null)) ? Number(tmpCount.Count) : tmpState.Rows.length;
			tmpState.PageSize = tmpPageSize;
		}
		catch (pError)
		{
			tmpState.Rows = [];
			tmpState.Total = 0;
			this.pict.log.warn(`ProjectWorkspace: could not load ${tmpEntity} for project ${this._project.IDProject}: ${pError && (pError.message || pError)}`);
		}
		tmpState.Loading = false;
		tmpState.Loaded = true;
		this._render();
	}

	// --- Data lists (Observations / Forms) --------------------------------------------------------

	_freshDataLists()
	{
		return {
			'data-observations': { Loaded: false, Loading: false, Rows: [], Total: 0, Term: '', Page: 0 },
			'data-forms': { Loaded: false, Loading: false, Rows: [], Total: 0, Term: '', Page: 0 },
		};
	}

	/** Read a data list's state for the view. */
	dataList(pKind) { return (this._dataLists && this._dataLists[pKind]) || null; }
	get dataPageSize() { return 50; }

	/** Per-kind query config. Observations carry a readable `ObservationType`; Forms are the project's Documents
	 *  with a readable `DocumentType` — neither needs a secondary lookup. Both are name-searchable + date-sorted. */
	_dataListConfig(pKind)
	{
		const tmpID = this._project ? this._project.IDProject : 0;
		if (pKind === 'data-forms')
		{
			// Sort by the same field the list shows (DocumentDate) so the Date column reads monotonically.
			return { Entity: 'Documents', Filter: `FBV~IDProject~EQ~${tmpID}~FBV~Deleted~EQ~0`, SearchField: 'Name', Sort: 'DocumentDate' };
		}
		return { Entity: 'Observations', Filter: `FBV~IDProject~EQ~${tmpID}~FBV~Deleted~EQ~0`, SearchField: 'Name', Sort: 'CreateDate' };
	}

	/**
	 * Load one page of a data list (server-paged + optional name search). pOpts: { Term, Page, Quiet }. The Quiet
	 * path (search / paging) repaints only the results container so the search box keeps focus; the non-quiet path
	 * (first open) does a full workspace render so the tab's shell appears.
	 * @param {'data-observations'|'data-forms'} pKind
	 * @param {{Term?:String, Page?:Number, Quiet?:Boolean}} [pOpts]
	 */
	async loadDataListAsync(pKind, pOpts)
	{
		const tmpState = this.dataList(pKind);
		if (!tmpState || !this._project || !this._project.IDProject) { return; }
		const tmpOpts = pOpts || {};
		// First-open guard: don't reload an already-loaded list just because the tab repainted.
		if (!tmpOpts.Quiet && (tmpOpts.Term == null) && (tmpOpts.Page == null) && tmpState.Loaded) { return; }
		if (tmpOpts.Term != null) { tmpState.Term = tmpOpts.Term; }
		tmpState.Page = (tmpOpts.Page != null) ? tmpOpts.Page : ((tmpOpts.Term != null) ? 0 : tmpState.Page);
		tmpState.Loading = true;
		const tmpCfg = this._dataListConfig(pKind);
		const tmpClean = String(tmpState.Term || '').replace(/~/g, '').trim();
		let tmpFilter = tmpCfg.Filter;
		if (tmpClean) { tmpFilter += `~FBV~${tmpCfg.SearchField}~LK~${encodeURIComponent(`%${tmpClean}%`)}`; }
		const tmpBegin = tmpState.Page * this.dataPageSize;
		const fFetch = (pWithSort) =>
		{
			const tmpSort = pWithSort ? `~FSF~${tmpCfg.Sort}~DESC~0` : '';
			return this._getJSON(`${tmpCfg.Entity}/FilteredTo/${tmpFilter}${tmpSort}/${tmpBegin}/${this.dataPageSize}`);
		};
		try
		{
			let tmpRows;
			try { tmpRows = await fFetch(true); }
			catch (pSortErr) { tmpRows = await fFetch(false); }   // some fields don't accept the sort — fall back unsorted
			const tmpCount = await this._getJSON(`${tmpCfg.Entity}/Count/FilteredTo/${tmpFilter}`).catch(() => null);
			tmpState.Rows = Array.isArray(tmpRows) ? tmpRows : [];
			tmpState.Total = (tmpCount && (tmpCount.Count != null)) ? Number(tmpCount.Count) : tmpState.Rows.length;
		}
		catch (pError)
		{
			tmpState.Rows = []; tmpState.Total = 0;
			this.pict.log.warn(`ProjectWorkspace: could not load ${pKind} for project ${this._project.IDProject}: ${pError && (pError.message || pError)}`);
		}
		tmpState.Loading = false;
		tmpState.Loaded = true;
		if (tmpOpts.Quiet) { this.paintDataResults(pKind); }
		else { this._render(); }
	}

	/**
	 * Shape the Line Items / Bid Items list into a render model for its tab: a loading slot, an empty
	 * slot, and formatted rows. Line Items show item code / description / quantity / unit cost; Bid Items
	 * show name / quantity / unit cost. Currency + number values are pre-formatted display strings.
	 * @param {'lineitems'|'biditems'} pWhich
	 */
	_buildItemsModel(pWhich)
	{
		const tmpIsLine = (pWhich !== 'biditems');
		const tmpState = tmpIsLine ? this._lineItems : this._bidItems;
		const tmpModel =
		{
			IsLineItems: tmpIsLine,
			Count: (tmpState.Rows || []).length,
			// Honest count: show "N of Total" when the page was truncated, else just the total.
			CountLabel: (function ()
			{
				const tmpShown = (tmpState.Rows || []).length;
				const tmpTotal = (tmpState.Total != null) ? tmpState.Total : tmpShown;
				return (tmpTotal > tmpShown) ? `${tmpShown} of ${tmpTotal}` : String(tmpTotal);
			})(),
			LoadingSlot: (!tmpState.Loaded) ? [ {} ] : [],
			EmptySlot: (tmpState.Loaded && ((tmpState.Rows || []).length === 0)) ? [ {} ] : [],
			// One-or-zero-element slot so the table template (which iterates rows) renders only when there
			// are rows — {~NE:~} would not recursively parse the inner {~TS:~} row loop.
			TableSlot: [],
			LineRows: [], BidRows: [],
			// "Delete records" button (gated by the Project-BulkDelete entitlement) — shown once the list has rows.
			BulkDeleteSlot: (this.canBulkDelete && tmpState.Loaded && ((tmpState.Rows || []).length > 0))
				? [ { Key: tmpIsLine ? 'lineitems' : 'biditems', Label: tmpIsLine ? 'Delete line items' : 'Delete bid items' } ]
				: [],
		};
		tmpModel.TableSlot = (tmpState.Loaded && ((tmpState.Rows || []).length > 0)) ? [ tmpModel ] : [];
		if (tmpIsLine)
		{
			tmpModel.LineRows = (tmpState.Rows || []).map((pRow) => (
				{
					GUID: this._escapeHtml(pRow.GUIDLineItem || ''),
					Code: this._escapeHtml(pRow.ItemCode || pRow.ItemNumber || '—'),
					Name: this._escapeHtml(pRow.Name || pRow.Description || '—'),
					Units: this._escapeHtml(pRow.Units || '—'),
					Quantity: this._formatValue({ Format: 'number' }, pRow.ContractQuantity),
					UnitCost: this._formatValue({ Format: 'currency' }, pRow.CostPerUnit),
				}));
		}
		else
		{
			tmpModel.BidRows = (tmpState.Rows || []).map((pRow) => (
				{
					GUID: this._escapeHtml(pRow.GUIDBidItem || ''),
					Name: this._escapeHtml(pRow.Name || pRow.Description || '—'),
					Units: this._escapeHtml(pRow.Units || '—'),
					Quantity: this._formatValue({ Format: 'number' }, pRow.Quantity),
					UnitCost: this._formatValue({ Format: 'currency' }, pRow.CostPerUnit),
				}));
		}
		return tmpModel;
	}

	// --- Tabs (base owns setTab/navigateTab/openTabAsync; each leaf's OnEnter calls _mountTab below) ---

	/**
	 * Rebuild one join type's tag index for this project — the old Projects app's per-join "Rebuild Tags"
	 * action. A side-effecting, authenticated GET with no body; the backend re-derives the project's
	 * searchable tags for that join from its current links. The response is inconsistent by design — either
	 * a bare JSON array of the rebuilt tag names, or an empty / 204 body — so both are accepted, and any
	 * failure is reported but treated as non-fatal (the underlying links already exist either way).
	 * @param {('Equipment'|'Contact'|'LineItem'|'BidItem')} pTagType - the RebuildTags path segment.
	 */
	async rebuildTags(pTagType)
	{
		const tmpIDProject = this.idProject;
		if (!tmpIDProject) { return; }
		const tmpState = this.workspaceState;
		tmpState.Message = `Rebuilding ${pTagType} tags…`;
		tmpState.MessageClass = 'is-info';
		this._render();
		try
		{
			const tmpResult = await this._getJSON(`RebuildTags/${encodeURIComponent(pTagType)}/${tmpIDProject}`);
			if (tmpResult && (tmpResult.ErrorCode || tmpResult.Error))
			{
				throw new Error(String(tmpResult.Error || tmpResult.ErrorCode));
			}
			const tmpCount = Array.isArray(tmpResult) ? tmpResult.length : null;
			tmpState.Message = (tmpCount != null)
				? `Rebuilt ${tmpCount.toLocaleString()} ${pTagType} tag${tmpCount === 1 ? '' : 's'}.`
				: `${pTagType} tags rebuilt.`;
			tmpState.MessageClass = 'is-success';
			this._render();
		}
		catch (pError)
		{
			tmpState.Message = `Could not rebuild ${pTagType} tags: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	// --- Geographic center ---

	get idProject()
	{
		return this._project ? this._project.IDProject : null;
	}

	/** The working center, falling back to a sensible default view when unset (0,0 is the null island). */
	get center()
	{
		return this._center;
	}

	get hasCenter()
	{
		return (this._center.Latitude != null) && (this._center.Longitude != null)
			&& !((Number(this._center.Latitude) === 0) && (Number(this._center.Longitude) === 0));
	}

	/**
	 * Set the working center from the map (marker drag / click). Updates state + the readout without a
	 * save; the user commits with Save.
	 * @param {Number} pLatitude
	 * @param {Number} pLongitude
	 */
	setCenter(pLatitude, pLongitude, pSyncMap)
	{
		this._center = { Latitude: Number(pLatitude), Longitude: Number(pLongitude) };
		this._centerDirty = true;
		this._locError = '';
		// Light update only: re-paint the readout + Save button + the lat/lng inputs, NOT the whole
		// workspace — a full render would recreate #PW-MapHost and tear down the live Leaflet map on
		// every marker drag/click.
		this.deriveRenderState();
		this.syncCenterControls();
		this.syncCenterInputs();
		// pSyncMap = a non-map-driven change (typed coordinates or an address result): move the live marker
		// and recenter so the map follows. Map gestures (drag/click) omit it — the marker already moved.
		if (pSyncMap)
		{
			const tmpMap = this.pict.views.ProjectCenterMap;
			if (tmpMap && (typeof tmpMap.moveMarkerTo === 'function')) { tmpMap.moveMarkerTo(this._center.Latitude, this._center.Longitude); }
		}
	}

	/**
	 * Set the working center from the editable latitude/longitude inputs. Validates ranges; on bad input
	 * it surfaces an inline error and leaves the center untouched.
	 * @param {string|number} pLatitude @param {string|number} pLongitude
	 */
	setCenterFromText(pLatitude, pLongitude)
	{
		const tmpLat = Number(pLatitude);
		const tmpLng = Number(pLongitude);
		if (!Number.isFinite(tmpLat) || !Number.isFinite(tmpLng) || (tmpLat < -90) || (tmpLat > 90) || (tmpLng < -180) || (tmpLng > 180))
		{
			this._locError = 'Enter a valid latitude (−90 to 90) and longitude (−180 to 180).';
			this.deriveRenderState();
			this.syncCenterControls();
			return;
		}
		this.setCenter(tmpLat, tmpLng, true);
	}

	/**
	 * Geocode the address-search box's text to coordinates via the public Nominatim (OpenStreetMap)
	 * service — the same provider as the map tiles, so no API key / new dependency. One request per
	 * explicit search (no as-you-type), keeping well under OSM's fair-use policy. Results populate a
	 * dropdown; picking one (chooseAddressResult) drops the pin.
	 */
	async searchAddressAsync()
	{
		const tmpInput = (typeof document !== 'undefined') ? document.getElementById('PW-AddressInput') : null;
		const tmpQuery = tmpInput ? String(tmpInput.value || '').trim() : '';
		if (!tmpQuery) { return; }
		this._addressSearching = true;
		this._addressError = '';
		this._addressResults = [];
		this._syncAddress();
		try
		{
			const tmpURL = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=5&q=${ encodeURIComponent(tmpQuery) }`;
			const tmpResponse = await fetch(tmpURL, { headers: { 'Accept': 'application/json' } });
			if (!tmpResponse.ok) { throw new Error(`the geocoder returned ${ tmpResponse.status }`); }
			const tmpRows = await tmpResponse.json();
			this._addressSearching = false;
			this._addressResults = (Array.isArray(tmpRows) ? tmpRows : [])
				.map((pRow) => ({ DisplayName: this._escapeHtml(pRow.display_name || 'result'), Latitude: Number(pRow.lat), Longitude: Number(pRow.lon) }))
				.filter((pRow) => Number.isFinite(pRow.Latitude) && Number.isFinite(pRow.Longitude))
				.slice(0, 5);
			this._addressError = (this._addressResults.length === 0) ? 'No matches found for that address.' : '';
			this._syncAddress();
		}
		catch (pError)
		{
			this._addressSearching = false;
			this._addressResults = [];
			this._addressError = `Address search failed: ${ pError.message || pError }`;
			this._syncAddress();
		}
	}

	/**
	 * Pick an address-search result: set the working center to its coordinates (drops the pin + recenters)
	 * and clear the results dropdown.
	 * @param {Number} pIndex
	 */
	chooseAddressResult(pIndex)
	{
		const tmpRow = (this._addressResults || [])[Number(pIndex)];
		if (!tmpRow) { return; }
		this._addressResults = [];
		this._addressError = '';
		this.setCenter(tmpRow.Latitude, tmpRow.Longitude, true);
		this._syncAddress();
	}

	/** Re-derive + repaint just the address-search results region (#PW-AddressResults). */
	_syncAddress()
	{
		this.deriveRenderState();
		this.syncAddressResults();
	}

	/**
	 * Re-derive + repaint JUST the observation-label (values) list region (#PW-ObsLabelHost) instead of the
	 * whole workspace. The values controller's add/remove/search/page all route here, so a label change no
	 * longer tears down the map / association editor / custom-props embeds on the other tabs, and the search
	 * filter (held on the controller instance) is re-emitted intact. Falls back to a full render if the host
	 * isn't mounted yet (e.g. the first background load, before the Labels tab has ever been shown).
	 */
	_syncObsLabels()
	{
		this.deriveRenderState();
		if (this.syncObsLabels()) { return; }
		this._render();
	}

	/**
	 * Persist the working center to the project (PUT Latitude/Longitude only — Meadow does a partial
	 * update). Surfaces a clean message if the role can't update this project (Update is role/ownership
	 * gated: User/Manager/Director = Mine, Executive = MyCustomer, Administrator = Allow).
	 * @return {Promise<void>}
	 */
	async saveCenterAsync()
	{
		if (!this._project || !this._centerDirty) { return; }
		const tmpState = this.workspaceState;
		this._savingCenter = true;
		tmpState.Message = '';
		this._render();
		try
		{
			const tmpSaved = await this._putJSON('Project', { IDProject: this._project.IDProject, Latitude: this._center.Latitude, Longitude: this._center.Longitude });
			if (tmpSaved && tmpSaved.ErrorCode)
			{
				throw new Error('the server rejected the update (you may not have permission to edit this project’s center).');
			}
			this._project.Latitude = this._center.Latitude;
			this._project.Longitude = this._center.Longitude;
			this._centerDirty = false;
			this._savingCenter = false;
			tmpState.Message = 'Geographic center saved.';
			tmpState.MessageClass = 'is-success';
			this._render();
		}
		catch (pError)
		{
			this._savingCenter = false;
			tmpState.Message = `Could not save the center: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	/**
	 * Ask the finance service to recalculate this project's initial contract amount from its contracted
	 * work items and stamp it onto the project. The service picks the source (bid items when they carry
	 * a value, line items otherwise) and reports anything the user should know about — a bid-vs-line
	 * disagreement, unpriced items — which is surfaced here rather than swallowed.
	 * @return {Promise<void>}
	 */
	async calculateInitialContractAmountAsync()
	{
		if (!this._project || this._calculatingContractAmount) { return; }
		const tmpState = this.workspaceState;
		this._calculatingContractAmount = true;
		tmpState.Message = '';
		this._render();
		try
		{
			const tmpResult = await this._postJSON(`Finance/ProjectSetup/InitialContractAmount/For/Project/${this._project.IDProject}`, {});
			if (!tmpResult || tmpResult.ErrorCode || tmpResult.code)
			{
				throw new Error(tmpResult && (tmpResult.message || tmpResult.Error) ?
					(tmpResult.message || tmpResult.Error) :
					'the server rejected the request (you may not have permission to edit this project).');
			}

			this._calculatingContractAmount = false;

			if (!tmpResult.Stamped)
			{
				tmpState.Message = tmpResult.Warnings && tmpResult.Warnings.length ? tmpResult.Warnings.join(' ') : 'There was nothing to calculate an initial contract amount from.';
				tmpState.MessageClass = 'is-warning';
				this._render();
				return;
			}

			this._project.InitialContractAmount = tmpResult.InitialContractAmount;

			const tmpFormatted = this._formatValue({ Format: 'currency' }, tmpResult.InitialContractAmount);
			const tmpPrevious = this._formatValue({ Format: 'currency' }, tmpResult.PreviousInitialContractAmount);
			const tmpSourceLabel = (tmpResult.Source === 'BidItem') ? 'bid items' : 'line items';
			let tmpMessage = `Initial contract set to ${tmpFormatted} from ${tmpResult.Source === 'BidItem' ? tmpResult.BidItemCount : tmpResult.LineItemCount} ${tmpSourceLabel} (was ${tmpPrevious}).`;
			if (tmpResult.Warnings && tmpResult.Warnings.length)
			{
				tmpMessage += ` ${tmpResult.Warnings.join(' ')}`;
			}
			tmpState.Message = tmpMessage;
			// a bid-vs-line disagreement is a real data problem the user should look at, not a success note
			tmpState.MessageClass = tmpResult.Discrepancy ? 'is-warning' : 'is-success';
			this._render();
		}
		catch (pError)
		{
			this._calculatingContractAmount = false;
			tmpState.Message = `Could not calculate the initial contract amount: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this._render();
		}
	}

	// --- Value formatting (one-shot display strings) ---

	_toNumberOrNull(pValue)
	{
		if (pValue == null || pValue === '') { return null; }
		const tmpNumber = Number(pValue);
		return Number.isFinite(tmpNumber) ? tmpNumber : null;
	}

	_formatValue(pField, pValue)
	{
		if (pValue == null || pValue === '') { return '—'; }
		switch (pField.Format)
		{
			case 'currency':
			{
				const tmpNumber = Number(pValue);
				if (!Number.isFinite(tmpNumber)) { return String(pValue); }
				return tmpNumber.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
			}
			case 'percent':
			{
				const tmpNumber = Number(pValue);
				if (!Number.isFinite(tmpNumber)) { return String(pValue); }
				return `${Math.round(tmpNumber * 10) / 10}%`;
			}
			case 'number':
			{
				const tmpNumber = Number(pValue);
				if (!Number.isFinite(tmpNumber)) { return String(pValue); }
				return tmpNumber.toLocaleString('en-US');
			}
			case 'id':
			{
				// Identifiers are not quantities — render the integer WITHOUT thousands separators (no "1,234").
				const tmpIDNumber = Number(pValue);
				return Number.isFinite(tmpIDNumber) ? String(Math.trunc(tmpIDNumber)) : String(pValue);
			}
			case 'date':
			{
				const tmpString = String(pValue);
				if (tmpString.indexOf('0000-00-00') === 0) { return '—'; }
				const tmpDate = new Date(tmpString);
				return Number.isNaN(tmpDate.getTime()) ? tmpString : tmpDate.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
			}
			default:
				return String(pValue);
		}
	}

	/**
	 * Resolve display names for the project's related entities (Organization, Contract, ProjectType,
	 * Customer) so the Overview "Relationships" fields render as named preview-card triggers rather than
	 * raw ids. Best-effort; re-renders when names arrive, and unresolved targets fall back to the id.
	 * @param {Record<string, any>} pProject
	 */
	async _resolveRelatedDisplayAsync(pProject)
	{
		const tmpTargets = [];
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			const tmpID = pProject[pField.Key];
			if (pField.Card && (tmpID != null) && (Number(tmpID) > 0))
			{
				tmpTargets.push({ Key: pField.Key, RecordSet: pField.Card, ID: tmpID });
			}
		}));
		const tmpDisplay = {};
		await Promise.all(tmpTargets.map(async (pTarget) =>
		{
			try
			{
				const tmpRecord = await this._getJSON(`${pTarget.RecordSet}/${pTarget.ID}`);
				if (tmpRecord && !tmpRecord.Error)
				{
					tmpDisplay[pTarget.Key] = tmpRecord.Name || tmpRecord.DisplayName || tmpRecord.Title || String(pTarget.ID);
				}
			}
			catch (pError) { /* leave unresolved → the field falls back to the id */ }
		}));
		this._relatedDisplay = tmpDisplay;
		this._render();
	}

	/** Parse the CustomProperties value (object OR JSON string) into a plain object for the embedded
	 *  read-only ObjectEditor tree; returns null when empty or unparseable. */
	_parseCustomProperties(pValue)
	{
		if (pValue == null || pValue === '') { return null; }
		let tmpObject = pValue;
		if (typeof pValue === 'string')
		{
			try { tmpObject = JSON.parse(pValue); }
			catch (pError) { return null; }
		}
		return (tmpObject && typeof tmpObject === 'object') ? tmpObject : null;
	}

	/**
	 * The Financials group's action row. The button stays visible but inert when the user can't edit the
	 * project or a calculation is already running, with a title explaining which it is.
	 * @return {{ DisabledAttr: string, Title: string, BusySlot: object[] }}
	 */
	_buildFinancialsActions()
	{
		const tmpAllowed = this.canEditProjectFinancials;
		const tmpBusy = this._calculatingContractAmount;
		let tmpTitle = 'Recalculate this project’s initial contract amount from its bid items, or its line items when the bid items carry no cost.';
		if (!tmpAllowed) { tmpTitle = 'You do not have permission to edit this project.'; }
		else if (tmpBusy) { tmpTitle = 'Calculating…'; }

		return {
			DisabledAttr: (!tmpAllowed || tmpBusy) ? 'disabled' : '',
			Title: tmpTitle,
			BusySlot: tmpBusy ? [ {} ] : [],
		};
	}

	// --- Render-state ---

	/** The base uses `state` for its shell (Loading/Message/Tab); Project's slot-rich model IS that same object. */
	get state() { return this.workspaceState; }
	get workspaceState()
	{
		if (!this.pict.AppData.ProjectWorkspace)
		{
			this.pict.AppData.ProjectWorkspace =
			{
				Loading: false, Message: '', MessageClass: '', Tab: '',
				LoadingSlot: [], EmptySlot: [ {} ], MessageSlot: [], WorkspaceSlot: [],
				Eyebrow: 'Project', Title: 'Project',
				Tabs: [], OverviewSlot: [], LocationSlot: [], LabelsSlot: [], ObservationsSlot: [],
				Groups: [], DescriptionSlot: [], CustomJSONSlot: [], CustomPropsData: {}, LabelStateSlot: [], LabelBehaviorStateSlot: [], ObsDefaultsSlot: [], ObsDefaults: [],
				CenterLatText: '', CenterLngText: '', CenterSummary: '', CenterSaveSlot: [],
				CenterLatInput: '', CenterLngInput: '', LocErrorSlot: [], AddressStatusSlot: [], AddressResultSlot: [],
			};
		}
		return this.pict.AppData.ProjectWorkspace;
	}

	deriveRenderState()
	{
		const tmpState = this.workspaceState;
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message, MessageClass: tmpState.MessageClass || 'is-info' } ] : [];

		if (tmpState.Loading)
		{
			tmpState.LoadingSlot = [ {} ];
			tmpState.WorkspaceSlot = [];
			tmpState.EmptySlot = [];
			return;
		}
		if (!this._project)
		{
			tmpState.LoadingSlot = [];
			tmpState.WorkspaceSlot = [];
			tmpState.EmptySlot = [ {} ];
			return;
		}

		const tmpProject = this._project;
		tmpState.Eyebrow = 'Project';
		tmpState.Title = tmpProject.Name || `Project ${tmpProject.IDProject}`;

		// The grouped tab structure now lives in the workspace config (Project.config.js); the base renders the
		// tab bar. deriveRenderState continues to populate the per-tab *Slot render models the tab templates read.
		tmpState.OverviewSlot = (this._activeTab === 'overview') ? [ {} ] : [];
		tmpState.DatesSlot = (this._activeTab === 'dates') ? [ {} ] : [];
		tmpState.StaffingSlot = (this._activeTab === 'staffing') ? [ {} ] : [];
		tmpState.LocationSlot = (this._activeTab === 'location') ? [ {} ] : [];
		// A long-list tab in bulk-delete mode renders the inline selectable tool INSTEAD of its read list (the
		// tool mounts into #PW-BulkInlineHost — see BulkInlineSlot below); the read list is hidden meanwhile.
		const tmpBulkKey = this._bulkDeleteKey;
		tmpState.LineItemsSlot = ((this._activeTab === 'lineitems') && (tmpBulkKey !== 'lineitems')) ? [ this._buildItemsModel('lineitems') ] : [];
		tmpState.BidItemsSlot = ((this._activeTab === 'biditems') && (tmpBulkKey !== 'biditems')) ? [ this._buildItemsModel('biditems') ] : [];
		tmpState.BrandingSlot = (this._activeTab === 'branding') ? [ {} ] : [];
		tmpState.LabelsSlot = ((this._activeTab === 'labels') && (tmpBulkKey !== 'labels')) ? [ {} ] : [];
		tmpState.ObservationsSlot = (this._activeTab === 'observations') ? [ {} ] : [];
		// Materials ▸ Sample Plan: a host the SamplePlan view embeds into (mounted by the view's _mountActiveTabEmbeds).
		tmpState.SamplePlanSlot = (this._activeTab === 'sampleplan') ? [ {} ] : [];
		// Contract ▸ Funding: a host the ProjectFunding view embeds into.
		tmpState.FundingSlot = (this._activeTab === 'funding') ? [ {} ] : [];
		// Contract ▸ Change Orders: a host the ChangeOrders view embeds into.
		tmpState.ChangeOrdersSlot = (this._activeTab === 'changeorders') ? [ {} ] : [];
		// Data ▸ Observations / Forms: hosts the view paints the server-paged lists into.
		tmpState.DataObsSlot = (this._activeTab === 'data-observations') ? [ {} ] : [];
		tmpState.DataFormsSlot = (this._activeTab === 'data-forms') ? [ {} ] : [];
		// Data ▸ Important Files: a host the ImportantFiles navigator embeds into.
		tmpState.FilesSlot = (this._activeTab === 'data-files') ? [ {} ] : [];
		// Data ▸ Bulk Upload: a host the BulkUpload tool embeds into.
		tmpState.BulkUploadSlot = (this._activeTab === 'data-bulk-upload') ? [ {} ] : [];
		// Data ▸ Data Volume: a host the ProjectActivity dashboard view embeds into.
		tmpState.DataVolumeSlot = (this._activeTab === 'data-volume') ? [ {} ] : [];
		// Association-editor join tabs (Equipment / Labs / Personnel). One-or-zero-element slot per tab; the
		// editor itself is mounted into the host div by the view's _mountActiveTabEmbeds after each paint.
		tmpState.EquipmentSlot = ((this._activeTab === 'equipment') && (tmpBulkKey !== 'equipment')) ? [ {} ] : [];
		tmpState.LabSlot = (this._activeTab === 'lab') ? [ {} ] : [];
		tmpState.ContactSlot = ((this._activeTab === 'contact') && (tmpBulkKey !== 'contact')) ? [ {} ] : [];
		tmpState.OrganizationSlot = (this._activeTab === 'organization') ? [ {} ] : [];
		// Inline bulk-delete host — rendered (in the active tab's panel) whenever a bulk-delete session is open.
		tmpState.BulkInlineSlot = tmpBulkKey ? [ {} ] : [];
		// Bulk-delete buttons (gated by the Project-BulkDelete entitlement) for the join-based long lists.
		const tmpCanBulk = this.canBulkDelete;
		tmpState.BulkDelEquipSlot = tmpCanBulk ? [ { Key: 'equipment', Label: 'Bulk unlink' } ] : [];
		tmpState.BulkDelContactSlot = tmpCanBulk ? [ { Key: 'contact', Label: 'Bulk unlink' } ] : [];
		tmpState.BulkDelLabelSlot = tmpCanBulk ? [ { Key: 'labels', Label: 'Bulk delete labels' } ] : [];
		// Contractor-matrix tabs (Line Item / Bid Item contractors). The grid provider is mounted into the host
		// div by the view's _mountActiveTabEmbeds after each paint (like the association editors).
		tmpState.LineContractorSlot = (this._activeTab === 'linecontractors') ? [ {} ] : [];
		tmpState.BidContractorSlot = (this._activeTab === 'bidcontractors') ? [ {} ] : [];
		tmpState.LogoSlots = this._logoController.buildRecords();
		tmpState.LabelStateSlot = [ this._labelController.buildState() ];
		tmpState.LabelBehaviorStateSlot = [ this._labelBehaviorController.buildState() ];
		tmpState.ObsLabelStateSlot = [ this._obsLabelController.buildState() ];
		tmpState.ObsDefaultsSlot = this._obsShowingDefaults ? [ {} ] : [];
		tmpState.ObsDefaults = (this._obsDefaults || []).map((pJoin) =>
			(
				{
					Name: this._escapeHtml(pJoin.ObservationManifestName || '(unnamed)'),
					Modes: [ this._isTruthy(pJoin.Journal) ? 'Journal' : null, this._isTruthy(pJoin.Spreadsheet) ? 'Spreadsheet' : null ].filter(Boolean).join(' · ') || '—',
				}));

		// Overview field groups.
		tmpState.Groups = FIELD_GROUPS.map((pGroup) =>
			(
				{
					Name: pGroup.Name,
					ActionsSlot: (pGroup.Actions === 'financials') ? [ this._buildFinancialsActions() ] : [],
					Fields: pGroup.Fields.map((pField) =>
						{
							const tmpRaw = tmpProject[pField.Key];
							// A relationship field with a registered preview card renders as a card trigger
							// (resolved entity name + popover) in place of the raw id — the name is resolved
							// lazily by _resolveRelatedDisplayAsync, falling back to the id until it arrives.
							const tmpCardOK = !!pField.Card && (tmpRaw != null) && (Number(tmpRaw) > 0);
							const tmpName = (this._relatedDisplay && this._relatedDisplay[pField.Key]) || '';
							return {
								Label: pField.Label,
								Value: tmpCardOK ? (tmpName || String(tmpRaw)) : (pField.Card ? '—' : this._formatValue(pField, tmpRaw)),
								CardRecordSet: tmpCardOK ? pField.Card : '',
								CardID: tmpCardOK ? String(tmpRaw) : '',
								WideClass: pField.Wide ? 'pw-field-wide' : '',
								MonoClass: pField.Mono ? 'pw-field-mono' : '',
							};
						}),
				}));
		const tmpDescription = (tmpProject.Description != null && String(tmpProject.Description).trim() !== '') ? String(tmpProject.Description) : '';
		tmpState.DescriptionSlot = tmpDescription ? [ { Description: tmpDescription } ] : [];
		// CustomProperties → a read-only ObjectEditor tree (the view mounts it into #PW-CustomPropsHost,
		// reading the stashed object); the slot just gates whether the group renders at all.
		const tmpCustomProps = this._parseCustomProperties(tmpProject.CustomProperties);
		tmpState.CustomPropsData = tmpCustomProps || {};
		tmpState.CustomJSONSlot = (tmpCustomProps && Object.keys(tmpCustomProps).length > 0) ? [ {} ] : [];

		// Location / center.
		tmpState.CenterLatText = (this._center.Latitude != null) ? Number(this._center.Latitude).toFixed(6) : '—';
		tmpState.CenterLngText = (this._center.Longitude != null) ? Number(this._center.Longitude).toFixed(6) : '—';
		tmpState.CenterSummary = this.hasCenter ? `${tmpState.CenterLatText}, ${tmpState.CenterLngText}` : 'Not set';
		tmpState.CenterSaveSlot = this._centerDirty ? [ { Saving: this._savingCenter } ] : [];
		tmpState.SaveDisabledAttr = this._savingCenter ? 'disabled' : '';
		// Editable lat/lng input values (raw number or empty — distinct from the '—' display readout above).
		tmpState.CenterLatInput = (this._center.Latitude != null) ? String(Number(this._center.Latitude)) : '';
		tmpState.CenterLngInput = (this._center.Longitude != null) ? String(Number(this._center.Longitude)) : '';
		tmpState.LocErrorSlot = this._locError ? [ { Text: this._locError } ] : [];

		// Address search: a single status line (searching / error / no-match) + the clickable result rows.
		const tmpAddressStatus = this._addressSearching ? 'Searching…' : (this._addressError || '');
		tmpState.AddressStatusSlot = tmpAddressStatus ? [ { Text: tmpAddressStatus, ErrorClass: this._addressSearching ? '' : 'pw-addr-status-error' } ] : [];
		tmpState.AddressResultSlot = (this._addressResults || []).map((pRow, pIndex) => ({ DisplayName: pRow.DisplayName, Index: pIndex }));

		tmpState.LoadingSlot = [];
		tmpState.EmptySlot = [];
		tmpState.WorkspaceSlot = [ tmpState ];
	}

	/** The ported methods below call _render for a full repaint; on the base that is renderWorkspace (which repaints
	 *  header + tab bar + the active tab body, then re-runs the active tab's OnEnter → _mountTab to re-mount widgets). */
	_render() { this.renderWorkspace(); }

	backToList()
	{
		if (typeof window !== 'undefined' && window.location)
		{
			window.location.hash = '#/PSRS/Project/List';
		}
	}

	/** Open this project's Sample Plan editor (material sampling/testing across its line items). */
	goToSamplePlan()
	{
		if (this._project && this._project.IDProject && (typeof window !== 'undefined') && window.location)
		{
			window.location.hash = `#/SamplePlan/${this._project.IDProject}`;
		}
	}

	/**
	 * Open the loaded project in the bespoke Project edit screen (the router bridges `/PSRS/Project/Edit/:GUIDRecord`
	 * to ProjectEditWorkspace). Only reachable from the header Edit action, which canEditProject gates.
	 */
	editProject()
	{
		if (!this._project || !this._project.GUIDProject)
		{
			return;
		}
		if (!this.canEditProject)
		{
			return;
		}
		if (typeof window !== 'undefined' && window.location)
		{
			window.location.hash = `#/PSRS/Project/Edit/${ this._project.GUIDProject }`;
		}
	}

	// --- Base `render` tab dispatch: paint the active tab's original template, then (re)mount its widgets --------

	/** Every tab is a `render` leaf pointing here: refresh the render model, then paint the tab's template. */
	_renderTabBody(pProv, pBodySel)
	{
		this.deriveRenderState();
		// The base calls the leaf OnEnter (→ _mountTab) on tab ENTRY, but a plain repaint (_renderActiveBody — e.g.
		// late boot data landing on a cold deep-link) re-paints this body WITHOUT re-mounting the tab's embeds,
		// wiping the map / association editor / bid-item-mapping host. Re-mount on the next tick after this paint so
		// an on-screen embed always survives a repaint (debounced; _mountTab only touches on-screen hosts + is idempotent).
		if (!this._remountScheduled && (typeof setTimeout === 'function'))
		{
			this._remountScheduled = true;
			setTimeout(() => { this._remountScheduled = false; try { this._mountTab(); } catch (pErr) { /* mount is best-effort */ } }, 0);
		}
		const tmpTab = this._activeTab;
		// Bulk-delete mode: the active long-list tab shows the inline selectable tool instead of its read list.
		if (this._bulkDeleteKey && (this._bulkDeleteKey === tmpTab))
		{
			this.pict.ContentAssignment.assignContent(pBodySel, this.pict.parseTemplateByHash('ProjectWorkspace-BulkInline', this.workspaceState));
			return;
		}
		const tmpTplHash = TAB_TEMPLATE[tmpTab];
		if (!tmpTplHash) { this.pict.ContentAssignment.assignContent(pBodySel, '<div class="pw-items-note">—</div>'); return; }
		// Line/Bid Items render with a per-list model as Record; the rest read absolute AppData paths (Record ignored).
		let tmpRecord = this.workspaceState;
		if (tmpTab === 'lineitems') { tmpRecord = this._buildItemsModel('lineitems'); }
		else if (tmpTab === 'biditems') { tmpRecord = this._buildItemsModel('biditems'); }
		this.pict.ContentAssignment.assignContent(pBodySel, this.pict.parseTemplateByHash(tmpTplHash, tmpRecord));
	}

	/** OnEnter for every tab (runs after the body is painted): mount the tab's map / association editor / embeds
	 *  and fire its lazy loads. Only the active tab's hosts are in the DOM, so exactly one widget mounts. */
	_mountTab()
	{
		if (!this.idProject) { return; }
		const tmpCA = this.pict.ContentAssignment;
		// Lazy loads for the active tab (were in the old setTab).
		if ((this._activeTab === 'lineitems') || (this._activeTab === 'biditems')) { this._loadItemsAsync(this._activeTab); }
		// (Data ▸ Documents/Forms now embeds the full DocumentList screen — see below — so no built-in mini-list load.)
		// Inline bulk-delete tool.
		if (tmpCA.getElement('#PW-BulkInlineHost').length > 0)
		{
			const tmpBulk = this.pict.providers.ProjectBulkDelete;
			if (tmpBulk && this._bulkSpec && (typeof tmpBulk.openFor === 'function')) { tmpBulk.openFor(this._bulkSpec); }
		}
		for (let i = 0; i < ASSOC_TABS.length; i++)
		{
			if (tmpCA.getElement(ASSOC_TABS[i].Host).length > 0) { this._renderAssoc(ASSOC_TABS[i]); }
		}
		if (tmpCA.getElement('#PW-MapHost').length > 0)
		{
			const tmpMap = this.pict.views.ProjectCenterMap;
			if (tmpMap && (typeof tmpMap.showForProject === 'function')) { tmpMap.showForProject(); }
		}
		if (tmpCA.getElement('#PW-CustomPropsHost').length > 0) { this._renderCustomProps(); }
		// Provider-hosted embeds (openInto('Project', id, host)) — mounted only when their host is on screen.
		if (tmpCA.getElement('#PW-DatesHost').length > 0) { const p = this.pict.providers.RecordDates; if (p && (typeof p.openInto === 'function')) { p.openInto('Project', this.idProject, '#PW-DatesHost'); } }
		if (tmpCA.getElement('#PW-StaffingHost').length > 0) { const p = this.pict.providers.ProjectStaffing; if (p && (typeof p.openInto === 'function')) { p.openInto('Project', this.idProject, '#PW-StaffingHost'); } }
		if (tmpCA.getElement('#PW-EquipmentContractorHost').length > 0) { const p = this.pict.providers.ProjectContractorMatrixEquipment; if (p && (typeof p.openInto === 'function')) { p.openInto('Project', this.idProject, '#PW-EquipmentContractorHost'); } }
		if (tmpCA.getElement('#PW-LineContractorHost').length > 0) { const p = this.pict.providers.ProjectContractorMatrixLine; if (p && (typeof p.openInto === 'function')) { p.openInto('Project', this.idProject, '#PW-LineContractorHost'); } }
		if (tmpCA.getElement('#PW-BidContractorHost').length > 0) { const p = this.pict.providers.ProjectContractorMatrixBid; if (p && (typeof p.openInto === 'function')) { p.openInto('Project', this.idProject, '#PW-BidContractorHost'); } }
		if (tmpCA.getElement('#PW-BidItemMapHost').length > 0) { const p = this.pict.providers.LineItemBidItemMap; if (p && (typeof p.openInto === 'function')) { p.openInto(this.idProject, '#PW-BidItemMapHost'); } }
		// Materials ▸ Sample Plan Dashboard: the shareable SamplePlanDashboard provider painted into this tab's host.
		if (tmpCA.getElement('#PW-SamplePlanDashboardHost').length > 0) { const p = this.pict.providers.SamplePlanDashboard; if (p && (typeof p.openInto === 'function')) { p.openInto(this.idProject, '#PW-SamplePlanDashboardHost'); } }
		// View-hosted embeds (openInto(id, host)) — mounted when on screen, exited (standalone) when not.
		this._mountEmbedView('SamplePlan', '#PW-SamplePlanHost');
		this._mountEmbedView('ProjectFunding', '#PW-FundingHost');
		this._mountEmbedView('ChangeOrders', '#PW-ChangeOrdersHost');
		this._mountEmbedView('ImportantFiles', '#PW-FilesHost');
		this._mountEmbedView('BulkUpload', '#PW-BulkUploadHost');
		this._mountEmbedView('ProjectActivity', '#PW-DataVolumeHost');
		// Data ▸ Observations: the full unified Observations screen (List / Charts / Map), embedded + locked to this
		// project (Project filter hidden). Replaces the old built-in mini-list wholesale.
		if (tmpCA.getElement('#PW-DataObsHost').length > 0) { const p = this.pict.providers.ObservationList; if (p && (typeof p.openInto === 'function')) { p.openInto(this.idProject, '#PW-DataObsHost'); } }
		// Data ▸ Documents/Forms: the full unified Documents screen (List + Charts), embedded + locked to this project.
		if (tmpCA.getElement('#PW-DataFormsHost').length > 0) { const p = this.pict.providers.DocumentList; if (p && (typeof p.openInto === 'function')) { p.openInto(this.idProject, '#PW-DataFormsHost'); } }
	}

	/** Mount a full view into the tab host (openInto) when present; exit its embed (back to standalone) otherwise. */
	_mountEmbedView(pViewName, pHostSel)
	{
		const tmpView = this.pict.views[pViewName];
		if (!tmpView) { return; }
		if (this.pict.ContentAssignment.getElement(pHostSel).length > 0)
		{
			if (typeof tmpView.openInto === 'function') { tmpView.openInto(this.idProject, pHostSel); }
		}
		else if (typeof tmpView.exitEmbed === 'function') { tmpView.exitEmbed(); }
	}

	// --- Data lists (Observations / Forms) — ported from the old view -----------------------------------------

	_dataHostSelector(pKind) { return (pKind === 'data-forms') ? '#PW-DataFormsHost' : '#PW-DataObsHost'; }
	_dataResultsSelector(pKind) { return (pKind === 'data-forms') ? '#PW-DataFormsResults' : '#PW-DataObsResults'; }

	renderDataList(pKind)
	{
		const tmpHost = this._dataHostSelector(pKind);
		if (this.pict.ContentAssignment.getElement(tmpHost).length === 0) { return; }
		const tmpState = this.dataList(pKind) || {};
		const tmpIsForms = (pKind === 'data-forms');
		const tmpNoun = tmpIsForms ? 'forms' : 'observations';
		const tmpResultsId = this._dataResultsSelector(pKind).slice(1);
		this.pict.ContentAssignment.assignContent(tmpHost,
			`<div class="pw-data">`
			+ `<div class="pw-data-toolbar">`
			+ `<input class="pw-data-search" type="text" autocomplete="off" placeholder="Search ${tmpNoun} by name…" value="${this._esc(tmpState.Term || '')}" oninput="_Pict.providers.ProjectWorkspace.onDataSearch('${pKind}', this.value)" />`
			+ `<span class="pw-data-count" id="${tmpResultsId}-count"></span>`
			+ `</div>`
			+ `<div id="${tmpResultsId}" class="pw-data-results"></div>`
			+ `</div>`);
		this.paintDataResults(pKind);
	}

	paintDataResults(pKind)
	{
		const tmpResults = this._dataResultsSelector(pKind);
		if (this.pict.ContentAssignment.getElement(tmpResults).length === 0) { return; }
		const tmpState = this.dataList(pKind) || {};
		const tmpCountEl = document.getElementById(tmpResults.slice(1) + '-count');
		const tmpPageSize = this.dataPageSize;
		const tmpRows = tmpState.Rows || [];
		if (tmpState.Loading && !tmpRows.length)
		{
			if (tmpCountEl) { tmpCountEl.textContent = ''; }
			this.pict.ContentAssignment.assignContent(tmpResults, '<div class="pw-data-state"><i class="fas fa-spinner fa-spin"></i> Loading…</div>');
			return;
		}
		if (!tmpRows.length)
		{
			if (tmpCountEl) { tmpCountEl.textContent = ''; }
			this.pict.ContentAssignment.assignContent(tmpResults, `<div class="pw-data-state">${tmpState.Term ? 'No matches.' : 'Nothing here yet.'}</div>`);
			return;
		}
		const tmpTotal = (tmpState.Total != null) ? tmpState.Total : tmpRows.length;
		const tmpStart = (tmpState.Page * tmpPageSize) + 1;
		const tmpEnd = tmpStart + tmpRows.length - 1;
		if (tmpCountEl) { tmpCountEl.textContent = `${tmpStart}–${tmpEnd} of ${tmpTotal}`; }
		const tmpIsForms = (pKind === 'data-forms');
		const tmpHead = tmpIsForms
			? '<tr><th>Form</th><th>Name</th><th>Status</th><th>Date</th></tr>'
			: '<tr><th>Type</th><th>Name</th><th>Status</th><th>Created</th></tr>';
		const tmpBody = tmpRows.map((pRow) => tmpIsForms ? this._dataFormRow(pRow) : this._dataObsRow(pRow)).join('');
		const tmpHasPrev = tmpState.Page > 0;
		const tmpHasNext = tmpEnd < tmpTotal;
		const tmpPager = (tmpHasPrev || tmpHasNext)
			? `<div class="pw-data-pager">`
				+ `<button class="button is-small" ${tmpHasPrev ? '' : 'disabled'} onclick="_Pict.providers.ProjectWorkspace.dataPage('${pKind}', -1)"><span class="icon"><i class="fas fa-chevron-left"></i></span><span>Prev</span></button>`
				+ `<span class="pw-data-pageno">Page ${tmpState.Page + 1}</span>`
				+ `<button class="button is-small" ${tmpHasNext ? '' : 'disabled'} onclick="_Pict.providers.ProjectWorkspace.dataPage('${pKind}', 1)"><span>Next</span><span class="icon"><i class="fas fa-chevron-right"></i></span></button>`
				+ `</div>`
			: '';
		this.pict.ContentAssignment.assignContent(tmpResults,
			`<div class="pw-data-tablewrap"><table class="pw-data-table"><thead>${tmpHead}</thead><tbody>${tmpBody}</tbody></table></div>${tmpPager}`);
	}

	_dataObsRow(pRow)
	{
		return `<tr><td class="pw-data-type">${this._esc(pRow.ObservationType || '—')}</td>`
			+ `<td class="pw-data-name">${this._esc(pRow.Name || pRow.Description || '—')}</td>`
			+ `<td>${this._dataStatusChip(pRow.Status || pRow.StateName)}</td>`
			+ `<td class="pw-data-date">${this._dataDate(pRow.CreateDate)}</td></tr>`;
	}

	_dataFormRow(pRow)
	{
		return `<tr><td class="pw-data-type">${this._esc(pRow.DocumentType || '—')}</td>`
			+ `<td class="pw-data-name">${this._esc(pRow.Name || pRow.Description || '—')}</td>`
			+ `<td>${this._dataStatusChip(pRow.Status || pRow.StateName)}</td>`
			+ `<td class="pw-data-date">${this._dataDate(pRow.DocumentDate || pRow.UpdateDate)}</td></tr>`;
	}

	_dataStatusChip(pStatus)
	{
		const tmpStatus = String(pStatus == null ? '' : pStatus).trim();
		if (!tmpStatus) { return '<span class="pw-data-status">—</span>'; }
		return `<span class="pw-data-status is-set">${this._esc(tmpStatus)}</span>`;
	}

	_dataDate(pValue)
	{
		if (!pValue) { return '—'; }
		const tmpDate = new Date(pValue);
		if (isNaN(tmpDate.getTime())) { return '—'; }
		return tmpDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
	}

	onDataSearch(pKind, pTerm)
	{
		this._dataSearchTimers = this._dataSearchTimers || {};
		if (this._dataSearchTimers[pKind]) { clearTimeout(this._dataSearchTimers[pKind]); }
		this._dataSearchTimers[pKind] = setTimeout(() =>
		{
			this.loadDataListAsync(pKind, { Term: pTerm, Page: 0, Quiet: true });
		}, 300);
	}

	dataPage(pKind, pDelta)
	{
		const tmpState = this.dataList(pKind) || {};
		const tmpNext = Math.max(0, (tmpState.Page || 0) + Number(pDelta));
		this.loadDataListAsync(pKind, { Page: tmpNext, Quiet: true });
	}

	// --- Association editors + Custom-properties tree — ported from the old view -------------------------------

	_ensureAssocEditorView(pConfig)
	{
		if (this.pict.views[pConfig.Hash]) { return this.pict.views[pConfig.Hash]; }
		const tmpManager = this.pict.providers.RecordSetAssociationManager;
		if (!tmpManager || !tmpManager.getAssociation(pConfig.Association)) { return null; }
		const tmpLib = pConfig.Lib || libRecordSetAssociationEditor;
		this.pict.addView(pConfig.Hash, Object.assign({}, tmpLib.default_configuration,
			{
				ViewIdentifier: pConfig.Hash,
				AssociationHash: pConfig.Association,
				ThisRecordSet: 'Project',
				DefaultDestinationAddress: pConfig.Host,
				PickerMode: 'single',
			}), tmpLib);
		const tmpView = this.pict.views[pConfig.Hash];
		// For the observation-type association editor, fire a scoped Project config sync after a CONFIRMED add/remove
		// so the field apps pick up the changed set of types. These jobs are expensive, so we fire ONLY when the
		// associated set actually changed: the editor's renderEditor() recomputes this._otherIDs on a successful
		// mutation and is skipped on cancel/no-op/error, so a change in its length is the reliable mutation signal.
		if (pConfig.SyncOnChange && tmpView && !tmpView._configSyncWrapped)
		{
			tmpView._configSyncWrapped = true;
			const tmpProvider = this;
			[ 'addStaged', 'removeItem' ].forEach((pMethodName) =>
			{
				if (typeof tmpView[pMethodName] !== 'function') { return; }
				const fOriginal = tmpView[pMethodName].bind(tmpView);
				tmpView[pMethodName] = async function ()
				{
					const tmpBefore = (tmpView._otherIDs || []).length;
					const tmpResult = await fOriginal.apply(tmpView, arguments);
					const tmpAfter = (tmpView._otherIDs || []).length;
					if ((tmpAfter !== tmpBefore) && tmpProvider.idProject)
					{
						try { libConfigSync.requestScopedSync(tmpProvider.pict, 'Project', Number(tmpProvider.idProject)); }
						catch (pError) { tmpProvider.pict.log.warn(`ProjectWorkspace: scoped sync after association change failed to start: ${pError && (pError.message || pError)}`); }
					}
					return tmpResult;
				};
			});
		}
		return tmpView;
	}

	_renderAssoc(pConfig)
	{
		const tmpEditor = this._ensureAssocEditorView(pConfig);
		if (!tmpEditor) { return; }
		tmpEditor.options.ThisID = this.idProject;
		tmpEditor.options.DefaultDestinationAddress = pConfig.Host;
		this._projAssocQueue = (this._projAssocQueue || Promise.resolve())
			.then(() => tmpEditor.renderEditor())
			.catch((pError) => { this.pict.log.warn(`ProjectWorkspace: ${pConfig.Association} association render failed: ${pError && (pError.message || pError)}`); });
	}

	_ensureCustomPropsView()
	{
		const tmpHash = 'PW-CustomPropsEditor';
		if (this.pict.views[tmpHash]) { return this.pict.views[tmpHash]; }
		const libObjectEditor = require('pict-section-objecteditor');
		this.pict.addView(tmpHash, Object.assign({}, libObjectEditor.default_configuration,
			{
				ViewIdentifier: tmpHash,
				AutoRender: false,
				Editable: false,
				InitialExpandDepth: 2,
				ObjectDataAddress: 'AppData.ProjectWorkspace.CustomPropsData',
				Renderables:
				[
					{ RenderableHash: 'ObjectEditor-Container', TemplateHash: 'ObjectEditor-Container-Template', DestinationAddress: '#PW-CustomPropsHost', RenderMethod: 'replace' }
				],
			}), libObjectEditor);
		const tmpView = this.pict.views[tmpHash];
		if (tmpView && typeof tmpView.initialize === 'function') { tmpView.initialize(); }
		return tmpView;
	}

	_renderCustomProps()
	{
		// Guided per-customer metadata form (read-only), with an entitlement-gated raw-JSON advanced toggle. The
		// provider owns the raw object editor too (its advanced/no-manifest fallback), bound to the same CustomPropsData.
		const tmpProvider = this.pict.providers.EntityMetadataForm;
		if (tmpProvider && (typeof tmpProvider.openInto === 'function'))
		{
			tmpProvider.openInto({ entityType: 'Project', idCustomer: Number(this._project && this._project.IDCustomer) || 0, dataAddress: 'AppData.ProjectWorkspace.CustomPropsData', host: '#PW-CustomPropsHost', mode: 'view' });
			return;
		}
		// Fallback: the bare read-only object editor if the metadata provider is unavailable.
		const tmpView = this._ensureCustomPropsView();
		if (!tmpView) { return; }
		tmpView.options.DefaultDestinationAddress = '#PW-CustomPropsHost';
		tmpView.render();
	}

	// --- Targeted light-update seams (never a full render → the live map / editors are preserved) --------------

	syncCenterControls()
	{
		if (this.pict.ContentAssignment.getElement('#PW-LocControls').length === 0) { return; }
		this.pict.ContentAssignment.assignContent('#PW-LocControls', this.pict.parseTemplateByHash('ProjectWorkspace-LocControls', this.workspaceState));
	}

	syncCenterInputs()
	{
		const tmpState = this.workspaceState;
		const tmpLat = this.pict.ContentAssignment.getElement('#PW-LatInput');
		const tmpLng = this.pict.ContentAssignment.getElement('#PW-LngInput');
		if (tmpLat && tmpLat.length > 0) { tmpLat[0].value = tmpState.CenterLatInput || ''; }
		if (tmpLng && tmpLng.length > 0) { tmpLng[0].value = tmpState.CenterLngInput || ''; }
	}

	syncAddressResults()
	{
		if (this.pict.ContentAssignment.getElement('#PW-AddressResults').length === 0) { return; }
		this.pict.ContentAssignment.assignContent('#PW-AddressResults', this.pict.parseTemplateByHash('ProjectWorkspace-AddressResults', this.workspaceState));
	}

	/** Repaint just the observation-label (values) list into #PW-ObsLabelHost; returns false if it isn't mounted. */
	syncObsLabels()
	{
		if (this.pict.ContentAssignment.getElement('#PW-ObsLabelHost').length === 0) { return false; }
		const tmpSlot = (this.workspaceState.ObsLabelStateSlot || [])[0];
		if (!tmpSlot) { return false; }
		this.pict.ContentAssignment.assignContent('#PW-ObsLabelHost', this.pict.parseTemplateByHash('Headlight-ObsLabelManager', tmpSlot));
		return true;
	}

	/** Repaint ONLY the label-behavior host (keeps the <details> open + scroll + focus) — falls back to a full render. */
	_syncLabelBehavior()
	{
		this.deriveRenderState();
		if (this.syncLabelBehavior()) { return; }
		this._render();
	}

	syncLabelBehavior()
	{
		if (this.pict.ContentAssignment.getElement('#PW-LabelBehaviorHost').length === 0) { return false; }
		const tmpSlot = (this.workspaceState.LabelBehaviorStateSlot || [])[0];
		if (!tmpSlot) { return false; }
		this.pict.ContentAssignment.assignContent('#PW-LabelBehaviorHost', this.pict.parseTemplateByHash('Headlight-LabelBehavior', tmpSlot));
		return true;
	}
}

module.exports = ProjectWorkspaceProvider;

},{"../access/Project-Edit-Access.js":1061,"./ConfigSync.js":1313,"./LabelBehaviorController.js":1344,"./LabelManagerController.js":1345,"./LogoSlotController.js":1348,"./ProjectObservationLabelController.js":1364,"pict-section-objecteditor":957,"pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js":988,"pict-section-workspace":1049}],1368:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const HOST_MOUNT = '#RecordDates-Host';

// Mode config — Project vs Contract important dates.
const MODES =
{
	Project:
	{
		Mode: 'Project', RecordEntity: 'Project', DateEntity: 'ProjectDate', DatePlural: 'ProjectDates',
		TypeDefaultPlural: 'ProjectTypeDefaultDates', RecordIDField: 'IDProject', TypeIDField: 'IDProjectType',
		DateRowIDField: 'IDProjectDate', PermEntity: 'ProjectDate', TypeDefaultTypeField: 'IDProjectType',
	},
	Contract:
	{
		Mode: 'Contract', RecordEntity: 'Contract', DateEntity: 'ContractDate', DatePlural: 'ContractDates',
		TypeDefaultPlural: 'ContractTypeDefaultDates', RecordIDField: 'IDContract', TypeIDField: 'IDContractType',
		DateRowIDField: 'IDContractDate', PermEntity: 'ContractDate', TypeDefaultTypeField: 'IDContractType',
	},
};

// Per-contract schedule basis (Calendar Day vs Working Day). Stored as a CONTRACT-scoped Configuration value
// (LevelContext 'Contract', LevelContextID = the contract id) under a fixed key. NOTE (R-Schedule): writing
// contract-scope config is permission-gated server-side (a normal contract editor currently 403s) and the payment
// engine must READ this for it to affect payments — both are being sorted out with the platform team.
const SCHEDULE_NAMESPACE = 'ContractSchedule';
const SCHEDULE_SUBKEY = 'ScheduleBasis';

/**
 * RecordDates — the bespoke "important dates" editor for a Project (ProjectDate) or Contract (ContractDate). Shows the
 * milestone set expected by the record's TYPE (ProjectTypeDefaultDate / ContractTypeDefaultDate, aligned by Hash) as
 * set-or-missing rows plus any ad-hoc dates, with a friendly date picker per row. Reachable standalone
 * (#/ProjectDates/:id, #/ContractDates/:id) and embedded as the "Important Dates" tab of the Project/Contract
 * workspaces. Contract mode also exposes the schedule basis (Calendar Day / Working Day). Writes are per-row.
 */
class RecordDatesProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._loadToken = 0;   // guards against a stale in-flight load painting a different record's dates
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	callerCustomer() { const tmpUser = this.pict.AppData.CurrentUser; return tmpUser ? Number(tmpUser.CustomerID || tmpUser.IDCustomer) : 0; }

	_can(pEntity, pAction)
	{
		const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
		if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function')) { return tmpApp.EffectivePermissionsService.can(pEntity, pAction); }
		return true;
	}

	get state()
	{
		if (!this.pict.AppData.RecordDates)
		{
			this.pict.AppData.RecordDates =
			{
				Mode: 'Project', IDRecord: 0, IDType: 0, IDCustomer: 0, MountSelector: HOST_MOUNT,
				Standalone: false, Record: null, LoadedKey: '',
				Loading: false, Loaded: false, Error: '',
				Rows: [], New: { Name: '', Hash: '', Date: '' }, NewError: '',
				// Project mode also surfaces the LINKED CONTRACT's important dates (read-only) — for some project
				// types the milestone dates live on the contract, not the project, so the tab shows both.
				ContractRows: [], ContractInfo: null,
				Schedule: { Basis: '', Loaded: false, Saving: false, Notice: '' },
			};
		}
		return this.pict.AppData.RecordDates;
	}
	get cfg() { return MODES[this.state.Mode] || MODES.Project; }

	// ── REST helpers ─────────────────────────────────────────────────────────────
	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_upsertEntity(pEntity, pRecord) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.upsertEntity(pEntity, pRecord, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_deleteEntity(pEntity, pID) { const tmpRC = this.restClient; return (tmpRC && (typeof tmpRC.deleteEntity === 'function')) ? new Promise((resolve) => tmpRC.deleteEntity(pEntity, pID, (pErr) => resolve(!pErr))) : Promise.resolve(false); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_isoToYMD(pISO) { const tmpV = String(pISO || ''); return (tmpV.length >= 10 && tmpV.slice(0, 10) !== '0000-00-00') ? tmpV.slice(0, 10) : ''; }
	_ymdToISO(pYMD) { const tmpV = String(pYMD || '').trim(); return tmpV ? `${tmpV}T00:00:00.000Z` : null; }

	// ── Open (standalone route or workspace embed) ───────────────────────────────
	// Standalone (its own route) shows a record-identity header; embedded (workspace tab) omits it since the
	// workspace already shows the record name + tabs around this host.
	openAsync(pMode, pID) { return this._openInternal(pMode, pID, HOST_MOUNT, true); }
	openInto(pMode, pID, pMountSelector) { return this._openInternal(pMode, pID, pMountSelector || HOST_MOUNT, false); }

	async _openInternal(pMode, pID, pMountSelector, pStandalone)
	{
		const tmpState = this.state;
		const tmpMode = (pMode === 'Contract') ? 'Contract' : 'Project';
		const tmpID = Number(pID) || 0;
		const tmpKey = `${tmpMode}:${tmpID}`;
		// Same record already loaded (e.g. the workspace repainted the host on a background render): just re-attach into
		// the current host — do NOT reset/reload. Prevents reload flicker and discarding an in-progress edit.
		if (tmpState.LoadedKey === tmpKey && tmpState.Loaded && !tmpState.Loading)
		{
			tmpState.MountSelector = pMountSelector; tmpState.Standalone = !!pStandalone;
			this.render();
			return;
		}
		tmpState.Mode = tmpMode;
		tmpState.MountSelector = pMountSelector;
		tmpState.Standalone = !!pStandalone;
		tmpState.Record = null; tmpState.LoadedKey = '';
		tmpState.IDRecord = tmpID;
		tmpState.Loading = true; tmpState.Loaded = false; tmpState.Error = '';
		tmpState.Rows = []; tmpState.New = { Name: '', Hash: '', Date: '' }; tmpState.NewError = '';
		tmpState.ContractRows = []; tmpState.ContractInfo = null;
		tmpState.Schedule = { Basis: '', Loaded: false, Saving: false, Notice: '' };
		const tmpCfg = this.cfg;
		tmpState.Can = { Create: this._can(tmpCfg.PermEntity, 'Create'), Update: this._can(tmpCfg.PermEntity, 'Update'), Delete: this._can(tmpCfg.PermEntity, 'Delete') };
		const tmpToken = ++this._loadToken;
		this.render();
		await this._loadAsync(tmpToken);
	}

	async _loadAsync(pToken)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpID = tmpState.IDRecord;
		const fStale = () => (pToken !== undefined) && (pToken !== this._loadToken);   // a newer open() superseded this load
		if (!tmpID) { tmpState.Loading = false; tmpState.Error = 'No record specified.'; this.render(); return; }
		const tmpRecord = await this._getJSON(`${tmpCfg.RecordEntity}/${tmpID}`);
		if (fStale()) { return; }
		if (!tmpRecord || !tmpRecord[tmpCfg.RecordIDField]) { tmpState.Loading = false; tmpState.Error = `${tmpCfg.RecordEntity} ${tmpID} not found.`; this.render(); return; }
		tmpState.Record = tmpRecord;
		tmpState.IDType = Number(tmpRecord[tmpCfg.TypeIDField]) || 0;
		tmpState.IDCustomer = Number(tmpRecord.IDCustomer) || this.callerCustomer();
		const tmpDefaults = tmpState.IDType
			? await this._getJSON(`${tmpCfg.TypeDefaultPlural}/FilteredTo/FBV~${tmpCfg.TypeDefaultTypeField}~EQ~${tmpState.IDType}/0/2000`)
			: [];
		if (fStale()) { return; }
		const tmpDates = await this._getJSON(`${tmpCfg.DatePlural}/FilteredTo/FBV~${tmpCfg.RecordIDField}~EQ~${tmpID}/0/2000`);
		if (fStale()) { return; }
		tmpState.Rows = this._alignRows(Array.isArray(tmpDefaults) ? tmpDefaults : [], Array.isArray(tmpDates) ? tmpDates : []);
		// Project tab ALSO shows the linked contract's important dates (read-only) — some project types carry their
		// milestone dates on the CONTRACT (ContractDate), not the project, so the tab surfaces both. (Steven 2026-10-01.)
		if (tmpState.Mode === 'Project')
		{
			const tmpIDContract = Number(tmpRecord.IDContract) || 0;
			if (tmpIDContract) { await this._loadLinkedContractDatesAsync(tmpIDContract); if (fStale()) { return; } }
		}
		if (tmpState.Mode === 'Contract') { await this._loadScheduleAsync(); if (fStale()) { return; } }
		tmpState.Loading = false; tmpState.Loaded = true;
		tmpState.LoadedKey = `${tmpState.Mode}:${tmpID}`;
		this.render();
	}

	/** Align the type's expected date set (by Hash) with the record's own date rows. pCfg lets the Project tab also
	 *  build the linked-contract rows with the Contract mode config (defaults to the active mode's config). */
	_alignRows(pDefaults, pDates, pCfg)
	{
		const tmpCfg = pCfg || this.cfg;
		const tmpDateByHash = {};
		pDates.forEach((pRow) => { const tmpH = String(pRow.Hash || '').toLowerCase(); if (tmpH) { tmpDateByHash[tmpH] = pRow; } });
		const tmpUsed = {};
		const tmpRows = [];
		// expected (type-default) rows first — in the type's order
		pDefaults.forEach((pDef) =>
		{
			const tmpHash = String(pDef.Hash || '').trim();
			const tmpHashKey = tmpHash.toLowerCase();
			const tmpMatch = tmpHashKey ? tmpDateByHash[tmpHashKey] : null;
			if (tmpMatch) { tmpUsed[Number(tmpMatch[tmpCfg.DateRowIDField])] = true; }
			tmpRows.push(this._rowFrom(pDef.Name || tmpHash, tmpHash, tmpMatch, true, tmpCfg));
		});
		// any ad-hoc record dates whose Hash is not a type default
		pDates.forEach((pRow) =>
		{
			if (tmpUsed[Number(pRow[tmpCfg.DateRowIDField])]) { return; }
			tmpRows.push(this._rowFrom(pRow.Name || pRow.Hash || '(unnamed)', pRow.Hash || '', pRow, false, tmpCfg));
		});
		return tmpRows;
	}

	_rowFrom(pName, pHash, pDateRow, pIsDefault, pCfg)
	{
		const tmpCfg = pCfg || this.cfg;
		const tmpYMD = pDateRow ? this._isoToYMD(pDateRow.Date) : '';
		return {
			Name: String(pName || ''), Hash: String(pHash || ''),
			RowID: pDateRow ? (Number(pDateRow[tmpCfg.DateRowIDField]) || 0) : 0,
			Date: tmpYMD, IsDefault: !!pIsDefault, IsSet: !!tmpYMD,
			Editing: false, Saving: false, Error: '', DeleteConfirm: false,
		};
	}

	/** Load the linked contract's important dates (Contract-mode config) for the read-only "Contract dates" section of
	 *  the Project tab. Mirrors the Contract tab's own load — type defaults aligned with the contract's own date rows. */
	async _loadLinkedContractDatesAsync(pIDContract)
	{
		const tmpState = this.state;
		const tmpCCfg = MODES.Contract;
		const tmpContract = await this._getJSON(`${tmpCCfg.RecordEntity}/${pIDContract}`);
		if (!tmpContract || !tmpContract[tmpCCfg.RecordIDField]) { return; }
		const tmpCType = Number(tmpContract[tmpCCfg.TypeIDField]) || 0;
		const tmpCDefaults = tmpCType
			? await this._getJSON(`${tmpCCfg.TypeDefaultPlural}/FilteredTo/FBV~${tmpCCfg.TypeDefaultTypeField}~EQ~${tmpCType}/0/2000`)
			: [];
		const tmpCDates = await this._getJSON(`${tmpCCfg.DatePlural}/FilteredTo/FBV~${tmpCCfg.RecordIDField}~EQ~${pIDContract}/0/2000`);
		tmpState.ContractRows = this._alignRows(Array.isArray(tmpCDefaults) ? tmpCDefaults : [], Array.isArray(tmpCDates) ? tmpCDates : [], tmpCCfg);
		tmpState.ContractInfo = { IDContract: pIDContract, Name: tmpContract.Name || `Contract #${pIDContract}` };
	}

	// ── Schedule basis (Contract) ────────────────────────────────────────────────
	async _loadScheduleAsync()
	{
		const tmpState = this.state;
		const tmpRes = await this._postJSON('Configuration/Get', { LevelContext: 'Contract', LevelContextID: tmpState.IDRecord, NamespaceKey: SCHEDULE_NAMESPACE, NamespaceValue: SCHEDULE_SUBKEY });
		const tmpBody = (tmpRes && (tmpRes.result !== undefined)) ? tmpRes.result : tmpRes;
		const tmpRaw = (tmpBody && (tmpBody.Config !== undefined)) ? tmpBody.Config : ((tmpBody && tmpBody.Document) || tmpBody);
		const tmpBasis = (tmpRaw && (tmpRaw.Basis === 'Calendar' || tmpRaw.Basis === 'Working')) ? tmpRaw.Basis : '';
		tmpState.Schedule = { Basis: tmpBasis, Loaded: true, Saving: false, Notice: '' };
	}

	async setScheduleBasis(pBasis)
	{
		const tmpState = this.state;
		if (!tmpState.Can || !tmpState.Can.Update) { return; }
		const tmpBasis = (pBasis === 'Working') ? 'Working' : 'Calendar';
		tmpState.Schedule.Basis = tmpBasis; tmpState.Schedule.Saving = true; tmpState.Schedule.Notice = '';
		this.render();
		const tmpRes = await this._postJSON(`Configuration/Put/${SCHEDULE_NAMESPACE}/${SCHEDULE_SUBKEY}/Contract/${tmpState.IDRecord}`, { Config: { Basis: tmpBasis } });
		tmpState.Schedule.Saving = false;
		tmpState.Schedule.Notice = tmpRes.error ? 'Could not save the schedule basis.' : 'Saved.';
		this.render();
	}

	// ── Row editing ──────────────────────────────────────────────────────────────
	editRow(pIndex) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { tmpRow._orig = { Name: tmpRow.Name, Hash: tmpRow.Hash, Date: tmpRow.Date }; tmpRow.Editing = true; tmpRow.Error = ''; this.render(); } }
	cancelEditRow(pIndex) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { if (tmpRow._orig) { tmpRow.Name = tmpRow._orig.Name; tmpRow.Hash = tmpRow._orig.Hash; tmpRow.Date = tmpRow._orig.Date; } tmpRow.Editing = false; tmpRow.Error = ''; this.render(); } }
	setRowDate(pIndex, pValue) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { tmpRow.Date = String(pValue || ''); } }
	setRowName(pIndex, pValue) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { tmpRow.Name = String(pValue == null ? '' : pValue); } }
	setRowHash(pIndex, pValue) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { tmpRow.Hash = String(pValue == null ? '' : pValue); } }
	setNewField(pField, pValue) { const tmpState = this.state; if (Object.prototype.hasOwnProperty.call(tmpState.New, pField)) { tmpState.New[pField] = String(pValue == null ? '' : pValue); } }

	async saveRowAsync(pIndex)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpRow = tmpState.Rows[pIndex];
		if (!tmpRow || !tmpState.Can.Update) { return; }
		const tmpName = String(tmpRow.Name || '').trim();
		if (!tmpName) { tmpRow.Error = 'Give the date a name.'; this.render(); return; }
		tmpRow.Name = tmpName;
		tmpRow.Hash = String(tmpRow.Hash || '').trim() || tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
		tmpRow.Saving = true; tmpRow.Error = '';
		this.render();
		// Persist Name + Hash + Date together — the code is editable when editing the record.
		const tmpBody = { Name: tmpRow.Name, Hash: tmpRow.Hash, Date: this._ymdToISO(tmpRow.Date) };
		tmpBody[tmpCfg.DateRowIDField] = tmpRow.RowID || 0;
		if (!tmpRow.RowID) { tmpBody[tmpCfg.RecordIDField] = tmpState.IDRecord; tmpBody.IDCustomer = tmpState.IDCustomer; }
		const tmpRes = await this._upsertEntity(tmpCfg.DateEntity, tmpBody);
		if (tmpRes && tmpRes.result && tmpRes.result[tmpCfg.DateRowIDField]) { tmpRow.RowID = Number(tmpRes.result[tmpCfg.DateRowIDField]); }
		tmpRow.Saving = false;
		if (tmpRes && tmpRes.error) { tmpRow.Error = 'Save failed.'; }
		else { tmpRow.IsSet = !!tmpRow.Date; tmpRow.Editing = false; tmpRow._orig = null; }
		this.render();
	}

	/** Clear just a row's DATE (persist Date=null) while keeping the row — a one-click shortcut for Edit → clear → Save. */
	async unsetRowAsync(pIndex)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpRow = tmpState.Rows[pIndex];
		if (!tmpRow || !tmpState.Can.Update || tmpRow.Saving) { return; }
		if (!tmpRow.Date && !tmpRow.RowID) { return; }   // nothing persisted to clear
		tmpRow.Saving = true; tmpRow.Error = '';
		this.render();
		const tmpBody = { Name: tmpRow.Name, Hash: tmpRow.Hash, Date: null };
		tmpBody[tmpCfg.DateRowIDField] = tmpRow.RowID || 0;
		if (!tmpRow.RowID) { tmpBody[tmpCfg.RecordIDField] = tmpState.IDRecord; tmpBody.IDCustomer = tmpState.IDCustomer; }
		const tmpRes = await this._upsertEntity(tmpCfg.DateEntity, tmpBody);
		if (tmpRes && tmpRes.result && tmpRes.result[tmpCfg.DateRowIDField]) { tmpRow.RowID = Number(tmpRes.result[tmpCfg.DateRowIDField]); }
		tmpRow.Saving = false;
		if (tmpRes && tmpRes.error) { tmpRow.Error = 'Could not clear the date.'; }
		else { tmpRow.Date = ''; tmpRow.IsSet = false; tmpRow.Editing = false; tmpRow._orig = null; }
		this.render();
	}

	async addAdHocAsync()
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		if (!tmpState.Can.Create) { return; }
		const tmpName = String(tmpState.New.Name || '').trim();
		if (!tmpName) { tmpState.NewError = 'Give the date a name.'; this.render(); return; }
		const tmpHash = String(tmpState.New.Hash || '').trim() || tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
		tmpState.NewError = '';
		const tmpBody = { Name: tmpName, Hash: tmpHash, Date: this._ymdToISO(tmpState.New.Date), IDCustomer: tmpState.IDCustomer };
		tmpBody[tmpCfg.DateRowIDField] = 0; tmpBody[tmpCfg.RecordIDField] = tmpState.IDRecord;
		const tmpRes = await this._upsertEntity(tmpCfg.DateEntity, tmpBody);
		if (tmpRes && tmpRes.error) { tmpState.NewError = 'Could not add the date.'; this.render(); return; }
		const tmpRow = this._rowFrom(tmpName, tmpHash, tmpRes.result || null, false);
		if (!tmpRow.RowID && tmpRes.result && tmpRes.result[tmpCfg.DateRowIDField]) { tmpRow.RowID = Number(tmpRes.result[tmpCfg.DateRowIDField]); }
		tmpState.Rows.push(tmpRow);
		tmpState.New = { Name: '', Hash: '', Date: '' };
		this.render();
	}

	askDeleteRow(pIndex) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { tmpRow.DeleteConfirm = true; this.render(); } }
	cancelDeleteRow(pIndex) { const tmpRow = this.state.Rows[pIndex]; if (tmpRow) { tmpRow.DeleteConfirm = false; this.render(); } }
	async deleteRowAsync(pIndex)
	{
		const tmpState = this.state;
		const tmpCfg = this.cfg;
		const tmpRow = tmpState.Rows[pIndex];
		if (!tmpRow || tmpRow.IsDefault || !tmpState.Can.Delete) { return; }   // default rows are owned by the type, never deleted here
		if (tmpRow.RowID) { const tmpOK = await this._deleteEntity(tmpCfg.DateEntity, tmpRow.RowID); if (!tmpOK) { tmpRow.Error = 'Delete failed.'; tmpRow.DeleteConfirm = false; this.render(); return; } }
		tmpState.Rows.splice(pIndex, 1);
		this.render();
	}

	// ── Render (into the mount selector) ─────────────────────────────────────────
	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpSel = this.state.MountSelector || HOST_MOUNT;
		if (tmpCA.getElement(tmpSel).length === 0) { return; }
		tmpCA.assignContent(tmpSel, this._html());
	}

	_html()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return `<div class="rd-wrap">${this._headerHTML()}<p class="rd-note">Loading…</p></div>`; }
		if (tmpState.Error) { return `<div class="rd-wrap">${this._headerHTML()}<p class="rd-error">${this._esc(tmpState.Error)}</p></div>`; }
		return `<div class="rd-wrap">${this._headerHTML()}${(tmpState.Mode === 'Contract') ? this._scheduleHTML() : ''}${this._rowsHTML()}${this._contractRowsHTML()}${this._addHTML()}</div>`;
	}

	/** Record-identity header — only on the standalone route (the workspace tab has its own chrome). */
	_headerHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Standalone) { return ''; }
		const tmpRec = tmpState.Record;
		const tmpName = this._esc((tmpRec && tmpRec.Name) || `${tmpState.Mode} #${tmpState.IDRecord}`);
		const tmpBits = tmpRec
			? ((tmpState.Mode === 'Contract')
				? [ tmpRec.PrimaryProjectNumber, tmpRec.StateProjectNumber, tmpRec.Status ]
				: [ tmpRec.Status, tmpRec.ExternalProjectID ]).filter((pBit) => pBit)
			: [];
		return `<div class="rd-head"><div class="rd-eyebrow">${this._esc(tmpState.Mode)} · Important dates</div>`
			+ `<div class="rd-title">${tmpName}</div>`
			+ (tmpBits.length ? `<div class="rd-sub">${this._esc(tmpBits.join(' · '))}</div>` : '') + `</div>`;
	}

	_scheduleHTML()
	{
		const tmpState = this.state;
		const tmpBasis = tmpState.Schedule.Basis;
		const tmpDisabled = (!tmpState.Can.Update || tmpState.Schedule.Saving) ? ' disabled' : '';
		const tmpNotice = tmpState.Schedule.Notice ? `<span class="rd-sched-notice">${this._esc(tmpState.Schedule.Notice)}</span>` : '';
		return `<div class="rd-section rd-schedule"><div class="rd-section-head">Contract schedule</div>`
			+ `<p class="rd-note">How contracted days are counted for contractor payments.</p>`
			+ `<div class="rd-sched-opts">`
			+ `<label class="rd-radio"><input type="radio" name="rd-basis"${tmpBasis === 'Calendar' ? ' checked' : ''}${tmpDisabled} onchange="_Pict.providers.RecordDates.setScheduleBasis('Calendar')"> Calendar Day</label>`
			+ `<label class="rd-radio"><input type="radio" name="rd-basis"${tmpBasis === 'Working' ? ' checked' : ''}${tmpDisabled} onchange="_Pict.providers.RecordDates.setScheduleBasis('Working')"> Working Day</label>`
			+ `${tmpNotice}</div></div>`;
	}

	_rowsHTML()
	{
		const tmpState = this.state;
		const tmpEditable = tmpState.Can.Update;
		// When the Project tab also shows the linked contract's dates below, label this section "Project dates".
		const tmpHead = (tmpState.Mode === 'Project' && tmpState.ContractInfo) ? 'Project dates' : 'Important dates';
		if (!tmpState.Rows.length)
		{
			const tmpEmpty = tmpState.ContractInfo
				? 'No dates on the project itself — the linked contract’s dates are shown below.'
				: `No dates defined for this ${this._esc(tmpState.Mode.toLowerCase())} yet.`;
			return `<div class="rd-section"><div class="rd-section-head">${tmpHead}</div><p class="rd-note">${tmpEmpty}</p></div>`;
		}
		const tmpRows = tmpState.Rows.map((pRow, pIdx) =>
		{
			const tmpChip = pRow.IsSet ? '<span class="rd-chip rd-chip-set">set</span>' : '<span class="rd-chip rd-chip-missing">not set</span>';
			const tmpKind = pRow.IsDefault ? '' : '<span class="rd-chip rd-chip-adhoc">added</span>';
			const tmpErr = pRow.Error ? `<span class="rd-row-err">${this._esc(pRow.Error)}</span>` : '';
			if (pRow.Editing)
			{
				return `<div class="rd-row rd-row-editing">`
					+ `<input class="rd-row-nameinput" type="text" value="${this._esc(pRow.Name)}" oninput="_Pict.providers.RecordDates.setRowName(${pIdx}, this.value)" placeholder="Date name">`
					+ `<input class="rd-row-code" type="text" value="${this._esc(pRow.Hash)}" oninput="_Pict.providers.RecordDates.setRowHash(${pIdx}, this.value)" placeholder="code" title="Stable code financial forms reference this date by (e.g. NTP)">`
					+ `<input class="rd-date" type="date" value="${this._esc(pRow.Date)}" onchange="_Pict.providers.RecordDates.setRowDate(${pIdx}, this.value)">`
					+ `<button class="rd-btn rd-btn-sm rd-btn-primary"${pRow.Saving ? ' disabled' : ''} onclick="_Pict.providers.RecordDates.saveRowAsync(${pIdx})">${pRow.Saving ? 'Saving…' : 'Save'}</button>`
					+ `<button class="rd-btn rd-btn-sm"${pRow.Saving ? ' disabled' : ''} onclick="_Pict.providers.RecordDates.cancelEditRow(${pIdx})">Cancel</button>${tmpErr}</div>`;
			}
			// read-only display (default) — editing is explicit via Edit
			const tmpCode = pRow.Hash ? `<span class="rd-code" title="Code referenced by financial forms">${this._esc(pRow.Hash)}</span>` : '';
			const tmpDateDisp = pRow.Date ? `<span class="rd-date-disp">${this._esc(pRow.Date)}</span>` : '<span class="rd-date-disp rd-muted">—</span>';
			const tmpEdit = tmpEditable ? `<button class="rd-btn rd-btn-sm" onclick="_Pict.providers.RecordDates.editRow(${pIdx})">Edit</button>` : '';
				// Unset clears just the DATE (back to null) and keeps the row — offered only when a date is set.
				const tmpUnset = (tmpEditable && pRow.IsSet) ? `<button class="rd-btn rd-btn-sm"${pRow.Saving ? ' disabled' : ''} title="Clear the date but keep this row" onclick="_Pict.providers.RecordDates.unsetRowAsync(${pIdx})">Unset</button>` : '';
			const tmpDel = (!pRow.IsDefault && tmpState.Can.Delete)
				? (pRow.DeleteConfirm
					? `<span class="rd-confirm">Delete? <button class="rd-btn rd-btn-sm rd-btn-danger" onclick="_Pict.providers.RecordDates.deleteRowAsync(${pIdx})">Yes</button><button class="rd-btn rd-btn-sm" onclick="_Pict.providers.RecordDates.cancelDeleteRow(${pIdx})">No</button></span>`
					: `<button class="rd-icon rd-icon-x" title="Remove" onclick="_Pict.providers.RecordDates.askDeleteRow(${pIdx})">✕</button>`)
				: '';
			return `<div class="rd-row"><div class="rd-row-name">${this._esc(pRow.Name)} ${tmpCode} ${this._sourceChip('Project')} ${tmpKind}</div>`
				+ `${tmpDateDisp}${tmpChip}${tmpEdit}${tmpUnset}${tmpDel}${tmpErr}</div>`;
		}).join('');
		return `<div class="rd-section"><div class="rd-section-head">${tmpHead}</div>${tmpRows}</div>`;
	}

	/** A "Project"/"Contract" source chip — only meaningful on the Project tab, which mixes both sources. Returns ''
	 *  on the Contract tab or a project with no linked contract (single source, so the section header already says it). */
	_sourceChip(pSource)
	{
		if (!((this.state.Mode === 'Project') && this.state.ContractInfo)) { return ''; }
		return (pSource === 'Contract')
			? '<span class="rd-chip rd-chip-src-contract" title="This date lives on the linked contract">Contract</span>'
			: '<span class="rd-chip rd-chip-src-project" title="This date lives on the project">Project</span>';
	}

	/** Read-only "Contract dates" section shown on the Project tab — the linked contract's milestone dates (they are
	 *  shared by every project on that contract, so they are edited on the contract, not here). */
	_contractRowsHTML()
	{
		const tmpState = this.state;
		if ((tmpState.Mode !== 'Project') || !tmpState.ContractInfo) { return ''; }
		const tmpLink = `#/Contract/Workspace/${Number(tmpState.ContractInfo.IDContract)}/dates`;
		const tmpHead = `<div class="rd-section-head">Contract dates <span class="rd-sub-inline">from <a href="${tmpLink}">${this._esc(tmpState.ContractInfo.Name)}</a></span></div>`;
		const tmpRows = tmpState.ContractRows || [];
		if (!tmpRows.length) { return `<div class="rd-section rd-section-contract">${tmpHead}<p class="rd-note">No dates on the linked contract.</p></div>`; }
		const tmpBody = tmpRows.map((pRow) =>
		{
			const tmpChip = pRow.IsSet ? '<span class="rd-chip rd-chip-set">set</span>' : '<span class="rd-chip rd-chip-missing">not set</span>';
			const tmpCode = pRow.Hash ? `<span class="rd-code" title="Code referenced by financial forms">${this._esc(pRow.Hash)}</span>` : '';
			const tmpDateDisp = pRow.Date ? `<span class="rd-date-disp">${this._esc(pRow.Date)}</span>` : '<span class="rd-date-disp rd-muted">—</span>';
			return `<div class="rd-row rd-row-readonly"><div class="rd-row-name">${this._esc(pRow.Name)} ${tmpCode} ${this._sourceChip('Contract')}</div>${tmpDateDisp}${tmpChip}</div>`;
		}).join('');
		return `<div class="rd-section rd-section-contract">${tmpHead}`
			+ `<p class="rd-note">These milestone dates live on the linked contract (shared by its projects). Edit them on the contract.</p>${tmpBody}</div>`;
	}

	_addHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Can.Create) { return ''; }
		const tmpErr = tmpState.NewError ? `<span class="rd-row-err">${this._esc(tmpState.NewError)}</span>` : '';
		return `<div class="rd-section rd-add"><div class="rd-section-head">Add a date</div><div class="rd-row">`
			+ `<input class="rd-new-name" type="text" placeholder="Date name" value="${this._esc(tmpState.New.Name)}" oninput="_Pict.providers.RecordDates.setNewField('Name', this.value)">`
			+ `<input class="rd-new-code" type="text" placeholder="code (optional)" title="Stable code financial forms reference this date by — e.g. NTP. Auto-derived from the name if left blank." value="${this._esc(tmpState.New.Hash)}" oninput="_Pict.providers.RecordDates.setNewField('Hash', this.value)">`
			+ `<input class="rd-date" type="date" value="${this._esc(tmpState.New.Date)}" onchange="_Pict.providers.RecordDates.setNewField('Date', this.value)">`
			+ `<button class="rd-btn rd-btn-sm rd-btn-primary" onclick="_Pict.providers.RecordDates.addAdHocAsync()">Add</button>${tmpErr}</div></div>`;
	}
}

module.exports = RecordDatesProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'RecordDates',
	AutoInitialize: true,
	AutoInitializeOrdinal: 44,
};

},{"pict-provider":845}],1369:[function(require,module,exports){
/**
 * RecordPhotoUploadAfterSave
 *
 * A record's photo (the ObservationPhoto field) is uploaded through POST {Entity}/{IDRecord}/Photo, which creates the
 * image observation and links it to the record. That route needs a record that exists, so the field only holds the
 * chosen image; this wraps the record's PSRS provider so the held image is uploaded once the save has an ID: after
 * createRecord for a new record (its image is held under ID 0), after updateRecord for an existing one.
 *
 * If the upload fails the record is still saved, and the admin is told to add the photo again. Wrapping twice is a
 * no-op. Kept out of the application class so it can be unit-tested without the browser bundle.
 */

/**
 * @param {Object} pPict - the application's pict
 * @param {Array<string>} pRecordSetNames - recordsets whose entity has a photo field (the recordset is the entity)
 */
function installPhotoUploadAfterSave(pPict, pRecordSetNames)
{
	const tmpMetaController = pPict.services.PictSectionRecordSet;
	if (!tmpMetaController || !tmpMetaController.recordSetProviders) { return; }
	for (const tmpRecordSet of pRecordSetNames)
	{
		const tmpProvider = tmpMetaController.recordSetProviders[tmpRecordSet];
		if (!tmpProvider || tmpProvider._photoUploadAfterSaveWrapped)
		{
			if (!tmpProvider) { pPict.log.warn(`Photo upload wiring: ${ tmpRecordSet } PSRS provider not found — skipping.`); }
			continue;
		}
		tmpProvider._photoUploadAfterSaveWrapped = true;
		const tmpIDField = `ID${ tmpRecordSet }`;

		/**
		 * @param {number} pHeldForIDRecord - the ID the form had when the image was chosen (0 for a new record)
		 * @param {Object} pResult - what the save answered: the record, or { Record }
		 * @param {number} [pKnownIDRecord] - the record's ID when the answer does not carry it
		 */
		const fUploadHeldPhoto = async (pHeldForIDRecord, pResult, pKnownIDRecord) =>
		{
			const tmpPhotoField = pPict.providers.ObservationPhoto;
			const tmpSaved = pResult && (pResult.Record || pResult);
			const tmpIDRecord = (tmpSaved && tmpSaved[tmpIDField]) || pKnownIDRecord;
			if (!tmpPhotoField || (typeof tmpPhotoField.savePendingPhoto !== 'function') || !tmpIDRecord) { return; }
			const tmpIDObservation = await tmpPhotoField.savePendingPhoto(tmpRecordSet, pHeldForIDRecord || 0, tmpIDRecord);
			if (tmpIDObservation && tmpSaved && (typeof tmpSaved === 'object'))
			{
				// the route linked it; keep the answer in step so the form shows (and later saves) the new photo
				tmpSaved.IDObservation = tmpIDObservation;
			}
			else if (tmpIDObservation === 0)
			{
				const tmpModal = pPict.views['Pict-Section-Modal'];
				if (tmpModal && (typeof tmpModal.toast === 'function'))
				{
					tmpModal.toast(`${ tmpRecordSet } saved, but its photo could not be uploaded — open it and add the photo again.`, { type: 'warning', duration: 8000 });
				}
			}
		};

		if (typeof tmpProvider.createRecord === 'function')
		{
			const tmpOriginalCreate = tmpProvider.createRecord.bind(tmpProvider);
			tmpProvider.createRecord = async (pRecord) =>
			{
				const tmpResult = await tmpOriginalCreate(pRecord);
				await fUploadHeldPhoto(0, tmpResult);
				return tmpResult;
			};
		}
		if (typeof tmpProvider.updateRecord === 'function')
		{
			const tmpOriginalUpdate = tmpProvider.updateRecord.bind(tmpProvider);
			tmpProvider.updateRecord = async (pRecord) =>
			{
				const tmpResult = await tmpOriginalUpdate(pRecord);
				const tmpIDRecord = pRecord && pRecord[tmpIDField];
				await fUploadHeldPhoto(tmpIDRecord, tmpResult, tmpIDRecord);
				return tmpResult;
			};
		}
		pPict.log.info(`Photo upload wired to ${ tmpRecordSet } PSRS provider (POST ${ tmpRecordSet }/{ID}/Photo after save).`);
	}
}

module.exports = { installPhotoUploadAfterSave };

},{}],1370:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libRoleDates = require('../access/RoleAssignment-Dates.js');

/**
 * RoleAssignment — the "Roles & Groups" + "Overrides" tabs for a User subject.
 *
 * This is the per-user MEMBERSHIP layer ("User Role Group"): which roles/permission-groups a user holds, in
 * which context. It is the rich-role binding, kept separate from the simple User.IDRole 0-5 base level (which
 * stays in user management). Reads `Permissions/Roles/For/User/<id>/All/Contexts`; assigns via
 * `PUT Permissions/Role/For/User` (Customer -> UserRoleJoin, Project/Lab -> UserContextRole, with optional
 * start and end days, taken in the project's or customer's time zone); removes via DELETE. The Overrides tab manages the user's own UserPermission grants/denies
 * (highest precedence) for the current context.
 *
 * Subject + context come from the AccessWorkspace provider; this owns AppData.AccessWorkspace.Assignment.
 */
class RoleAssignmentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get workspace()
	{
		return this.pict.providers.AccessWorkspace;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get assignment()
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.Assignment)
		{
			tmpWorkspaceState.Assignment =
			{
				UserID: 0, Context: '', IDContext: 0, Loading: false, Loaded: false, Error: '', Saving: false,
				Memberships: [], Overrides: [], AssignRoleID: '', StartDraft: '', ExpirationDraft: '', TimeZone: '', OverrideHash: '', OverrideAllow: 'on',
				LoadingSlot: [], ErrorSlot: [], MembershipsSlot: [], MembershipEmptySlot: [], AssignSlot: [], ExpirationSlot: [],
				RoleOptions: [], OverridesSlot: [], OverrideEmptySlot: [],
			};
		}
		return tmpWorkspaceState.Assignment;
	}

	// --- REST ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			// The rest client exposes deleteEntity(entity, id) (there is no raw deleteJSON). Entity/<id> paths
			// go through it; the custom Permissions/Role/.../For/User/... unassign path goes direct.
			const tmpMatch = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (tmpMatch)
			{
				this.restClient.deleteEntity(tmpMatch[1], tmpMatch[2], (pError, pBody) => pError ? reject(pError) : resolve(pBody));
				return;
			}
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((pResponse) =>
				{
					if (!pResponse.ok) { reject(new Error(`HTTP ${pResponse.status}`)); return; }
					pResponse.text().then((pText) => resolve(pText ? JSON.parse(pText) : {})).catch(() => resolve({}));
				})
				.catch(reject);
		});
	}

	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 2000;
		let tmpTotal = tmpCap;
		try
		{
			const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`);
			tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap);
		}
		catch (pError)
		{
			tmpTotal = tmpCap;
		}
		if (!tmpTotal)
		{
			return [];
		}
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	// --- Load ---

	/**
	 * Load the user's role memberships (all contexts) + their permission overrides for the current context.
	 * No-op for a non-user subject.
	 * @param {Boolean} [pForce]
	 */
	async loadAsync(pForce)
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.SubjectRecord || tmpWorkspaceState.SubjectKind !== 'user')
		{
			return;
		}
		const tmpID = Number(tmpWorkspaceState.SubjectID);
		const tmpContext = tmpWorkspaceState.Context;
		const tmpIDContext = Number(tmpWorkspaceState.IDContext);
		const tmpAssignment = this.assignment;
		if (tmpAssignment.Loaded && !pForce && tmpAssignment.UserID === tmpID &&
			tmpAssignment.Context === tmpContext && tmpAssignment.IDContext === tmpIDContext)
		{
			this._render();
			return;
		}
		tmpAssignment.UserID = tmpID;
		tmpAssignment.Context = tmpContext;
		tmpAssignment.IDContext = tmpIDContext;
		tmpAssignment.Loaded = false;
		tmpAssignment.Error = '';
		tmpAssignment.Loading = true;
		this._render();
		try
		{
			const tmpResults = await Promise.all(
				[
					this._getJSON(`Permissions/Roles/For/User/${tmpID}/All/Contexts`),
					tmpIDContext ? this._getFilteredAll('UserPermissions', `FBV~IDUser~EQ~${tmpID}~FBV~Context~EQ~${tmpContext}~FBV~IDContext~EQ~${tmpIDContext}`) : Promise.resolve([]),
					this._loadTimeZoneAsync(tmpContext, tmpIDContext),
				]);
			tmpAssignment.TimeZone = tmpResults[2];
			tmpAssignment.Memberships = this._buildMemberships(tmpResults[0]);
			tmpAssignment.Overrides = (tmpResults[1] || []).map((pRow) =>
				({ IDUserPermission: pRow.IDUserPermission, Hash: pRow.Hash, AllowLabel: pRow.Allowed ? 'Allow' : 'Deny', AllowClass: pRow.Allowed ? 'is-success' : 'is-danger' }));
			tmpAssignment.Loaded = true;
		}
		catch (pError)
		{
			tmpAssignment.Error = `Could not load assignments: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpAssignment.Loading = false;
		this._render();
	}

	/**
	 * The time zone assignment days are read in: the project's, else the customer's, else the browser's.
	 * @param {String} pContext
	 * @param {Number} pIDContext
	 * @return {Promise<String>} an IANA zone, or '' for the browser's.
	 */
	async _loadTimeZoneAsync(pContext, pIDContext)
	{
		const tmpSources = [];
		if ((pContext === 'Project') && pIDContext)
		{
			tmpSources.push(`Project/${pIDContext}`);
		}
		if (this.workspace.idCustomer)
		{
			tmpSources.push(`Customer/${this.workspace.idCustomer}`);
		}
		for (const tmpSource of tmpSources)
		{
			try
			{
				const tmpRecord = await this._getJSON(tmpSource);
				if (tmpRecord && libRoleDates.isValidTimeZone(tmpRecord.Timezone))
				{
					return tmpRecord.Timezone;
				}
			}
			catch (pError)
			{
				// Fall through to the next source; the browser's zone is the last resort.
			}
		}
		return '';
	}

	_buildMemberships(pResponse)
	{
		const tmpTimeZone = this.assignment.TimeZone;
		const tmpNameByID = {};
		(this.workspace.rolesAndGroups || []).forEach((pRole) =>
		{
			tmpNameByID[pRole.IDRole] = pRole;
		});
		const tmpFromContext = (pContext, pIDContext, pIDRole, pExpiration, pStart) =>
		{
			const tmpRole = tmpNameByID[pIDRole] || {};
			const tmpStartDay = libRoleDates.instantToDay(pStart, tmpTimeZone);
			const tmpEndDay = libRoleDates.instantToDay(pExpiration, tmpTimeZone);
			const tmpState = libRoleDates.getWindowState(pStart, pExpiration);
			return {
				Context: pContext,
				IDContext: pIDContext,
				IDRole: pIDRole,
				Label: tmpRole.Name || `Role ${pIDRole}`,
				KindLabel: (tmpRole.Type === 'PermissionGroup') ? 'Permission Group' : 'Role',
				Icon: (tmpRole.Type === 'PermissionGroup') ? 'fas fa-layer-group' : 'fas fa-user-shield',
				ContextLabel: ((Number(pIDContext) > 0 && pContext !== 'Customer') ? `${pContext} ${pIDContext}` : pContext) +
					(tmpStartDay ? ` · from ${tmpStartDay}` : '') + (tmpEndDay ? ` · until ${tmpEndDay}` : ''),
				Expiration: tmpEndDay,
				State: tmpState,
				StateSlot: (tmpState === 'Active') ? [] :
					[ (tmpState === 'Scheduled') ? { Label: 'scheduled', Class: 'is-warning', Title: `Takes effect ${tmpStartDay}` } : { Label: 'expired', Class: 'is-dark', Title: `Ended ${tmpEndDay}` } ],
			};
		};
		const tmpMemberships = [];
		const tmpSeen = new Set();
		(pResponse && pResponse.Contexts ? pResponse.Contexts : []).forEach((pEntry) =>
		{
			if (!pEntry || !pEntry.IDRole)
			{
				return;
			}
			const tmpKey = `${pEntry.Context}-${pEntry.IDContext}-${pEntry.IDRole}`;
			if (tmpSeen.has(tmpKey))
			{
				return;
			}
			tmpSeen.add(tmpKey);
			tmpMemberships.push(tmpFromContext(pEntry.Context, pEntry.IDContext, pEntry.IDRole, pEntry.ExpirationDate, pEntry.StartDate));
		});
		// Customer-level roles (UserRoleJoin) may come back under Roles[] as ids or objects.
		(pResponse && pResponse.Roles ? pResponse.Roles : []).forEach((pRole) =>
		{
			const tmpID = (pRole && typeof pRole === 'object') ? pRole.IDRole : pRole;
			if (!tmpID)
			{
				return;
			}
			const tmpKey = `Customer-${this.workspace.idCustomer}-${tmpID}`;
			if (tmpSeen.has(tmpKey))
			{
				return;
			}
			tmpSeen.add(tmpKey);
			tmpMemberships.unshift(tmpFromContext('Customer', this.workspace.idCustomer, tmpID, null, null));
		});
		return tmpMemberships;
	}

	// --- Form state ---

	setAssignRole(pValue)
	{
		this.assignment.AssignRoleID = pValue || '';
	}
	/**
	 * Draft the first day the assignment applies ("YYYY-MM-DD", or empty for now).
	 * @param {String} pValue
	 */
	setStart(pValue)
	{
		this.assignment.StartDraft = pValue || '';
	}
	setExpiration(pValue)
	{
		this.assignment.ExpirationDraft = pValue || '';
	}
	setOverrideHash(pValue)
	{
		this.assignment.OverrideHash = pValue || '';
	}
	setOverrideAllow(pValue)
	{
		this.assignment.OverrideAllow = pValue || 'on';
	}

	// --- Mutations ---

	/**
	 * Why the drafted start and end days cannot be saved as they are, if they cannot.
	 * @param {Number} pIDRole - the role being assigned
	 * @return {String} a message for the form, or '' when the days are fine.
	 */
	_checkDraftDays(pIDRole)
	{
		const tmpAssignment = this.assignment;
		if (tmpAssignment.StartDraft && tmpAssignment.ExpirationDraft && (tmpAssignment.StartDraft > tmpAssignment.ExpirationDraft))
		{
			return 'The start date has to be on or before the end date.';
		}
		if (tmpAssignment.StartDraft && (tmpAssignment.StartDraft > libRoleDates.todayIn(tmpAssignment.TimeZone)))
		{
			// Assigning a role the user already holds here updates that assignment, so a future start
			// would take the role away until then.
			const tmpHeld = tmpAssignment.Memberships.find((pMembership) =>
				(pMembership.Context === tmpAssignment.Context) && (Number(pMembership.IDContext) === Number(tmpAssignment.IDContext)) &&
				(Number(pMembership.IDRole) === Number(pIDRole)) && (pMembership.State === 'Active'));
			if (tmpHeld)
			{
				return `This user already has ${tmpHeld.Label} here. A future start date would remove it until then. ` +
					'Leave the start date empty to change only the end date, or remove the role first.';
			}
		}
		return '';
	}

	/**
	 * Assign the picked role/group to the user in the workspace's current context (optional start and end days
	 * for non-Customer contexts), via PUT Permissions/Role/For/User.
	 */
	async assignAsync()
	{
		const tmpAssignment = this.assignment;
		const tmpRoleID = Number(tmpAssignment.AssignRoleID);
		if (!(tmpRoleID > 0) || tmpAssignment.Saving)
		{
			return;
		}
		if (!tmpAssignment.IDContext)
		{
			tmpAssignment.Error = `Enter a ${tmpAssignment.Context} ID in the context bar first.`;
			this._render();
			return;
		}
		const tmpDayProblem = (tmpAssignment.Context !== 'Customer') ? this._checkDraftDays(tmpRoleID) : '';
		if (tmpDayProblem)
		{
			tmpAssignment.Error = tmpDayProblem;
			this._render();
			return;
		}
		tmpAssignment.Saving = true;
		tmpAssignment.Error = '';
		this._render();
		const tmpPayload =
		{
			IDRole: tmpRoleID,
			IDUser: tmpAssignment.UserID,
			Context: tmpAssignment.Context,
			IDContext: tmpAssignment.IDContext,
		};
		// Start and end days are only valid for non-Customer contexts (the server rejects them for Customer).
		if (tmpAssignment.Context !== 'Customer')
		{
			if (tmpAssignment.StartDraft)
			{
				tmpPayload.StartDate = libRoleDates.dayStartToInstant(tmpAssignment.StartDraft, tmpAssignment.TimeZone);
			}
			if (tmpAssignment.ExpirationDraft)
			{
				tmpPayload.ExpirationDate = libRoleDates.dayEndToInstant(tmpAssignment.ExpirationDraft, tmpAssignment.TimeZone);
			}
		}
		try
		{
			await this._putJSON('Permissions/Role/For/User', tmpPayload);
			tmpAssignment.AssignRoleID = '';
			tmpAssignment.StartDraft = '';
			tmpAssignment.ExpirationDraft = '';
			await this.loadAsync(true);
		}
		catch (pError)
		{
			tmpAssignment.Error = `Could not assign: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpAssignment.Saving = false;
		this._render();
	}

	/**
	 * Remove a membership (DELETE Permissions/Role/.../For/User/...).
	 * @param {Number} pIDRole
	 * @param {String} pContext
	 * @param {Number} pIDContext
	 */
	async removeMembershipAsync(pIDRole, pContext, pIDContext)
	{
		const tmpAssignment = this.assignment;
		if (tmpAssignment.Saving)
		{
			return;
		}
		tmpAssignment.Saving = true;
		tmpAssignment.Error = '';
		this._render();
		try
		{
			await this._deleteJSON(`Permissions/Role/${pIDRole}/For/User/${tmpAssignment.UserID}/In/${pContext}/${pIDContext}`);
			await this.loadAsync(true);
		}
		catch (pError)
		{
			tmpAssignment.Error = `Could not remove: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpAssignment.Saving = false;
		this._render();
	}

	/**
	 * Add a user permission override (Grant/Deny .../To/User/...) in the current context.
	 */
	async addOverrideAsync()
	{
		const tmpAssignment = this.assignment;
		const tmpHash = String(tmpAssignment.OverrideHash || '').trim();
		if (!tmpHash || tmpAssignment.Saving)
		{
			return;
		}
		if (!tmpAssignment.IDContext)
		{
			tmpAssignment.Error = `Enter a ${tmpAssignment.Context} ID in the context bar first.`;
			this._render();
			return;
		}
		tmpAssignment.Saving = true;
		tmpAssignment.Error = '';
		this._render();
		const tmpVerb = (tmpAssignment.OverrideAllow === 'off') ? 'Deny' : 'Grant';
		try
		{
			await this._getJSON(`Permissions/${tmpVerb}/${tmpHash}/To/User/${tmpAssignment.UserID}/For/${tmpAssignment.Context}/${tmpAssignment.IDContext}`);
			tmpAssignment.OverrideHash = '';
			await this.loadAsync(true);
		}
		catch (pError)
		{
			tmpAssignment.Error = `Could not add override: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpAssignment.Saving = false;
		this._render();
	}

	/**
	 * Remove a user permission override by deleting its row.
	 * @param {Number} pIDUserPermission
	 */
	async removeOverrideAsync(pIDUserPermission)
	{
		const tmpAssignment = this.assignment;
		if (tmpAssignment.Saving)
		{
			return;
		}
		tmpAssignment.Saving = true;
		tmpAssignment.Error = '';
		this._render();
		try
		{
			await this._deleteJSON(`UserPermission/${pIDUserPermission}`);
			await this.loadAsync(true);
		}
		catch (pError)
		{
			tmpAssignment.Error = `Could not remove override: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpAssignment.Saving = false;
		this._render();
	}

	// --- Derive ---

	deriveAssignment()
	{
		const tmpAssignment = this.assignment;
		const tmpEditable = !!this.workspace.isRoleManager;
		tmpAssignment.LoadingSlot = tmpAssignment.Loading ? [ {} ] : [];
		tmpAssignment.ErrorSlot = tmpAssignment.Error ? [ { Error: tmpAssignment.Error } ] : [];

		tmpAssignment.Memberships = tmpAssignment.Memberships.map((pMembership) =>
			Object.assign({}, pMembership, { RemoveSlot: tmpEditable ? [ pMembership ] : [] }));
		tmpAssignment.MembershipsSlot = tmpAssignment.Memberships.length ? [ {} ] : [];
		tmpAssignment.MembershipEmptySlot = (!tmpAssignment.Loading && !tmpAssignment.Memberships.length) ? [ {} ] : [];

		tmpAssignment.Overrides = tmpAssignment.Overrides.map((pOverride) =>
			Object.assign({}, pOverride, { RemoveSlot: tmpEditable ? [ { IDUserPermission: pOverride.IDUserPermission } ] : [] }));
		tmpAssignment.OverridesSlot = tmpAssignment.Overrides.length ? [ {} ] : [];
		tmpAssignment.OverrideEmptySlot = (!tmpAssignment.Loading && !tmpAssignment.Overrides.length) ? [ {} ] : [];

		if (tmpEditable)
		{
			tmpAssignment.RoleOptions = [ { IDRole: '', Label: 'Pick a role or group…' } ].concat(
				(this.workspace.rolesAndGroups || [])
					.map((pRole) => ({ IDRole: pRole.IDRole, Label: `${pRole.Name || `Role ${pRole.IDRole}`}${pRole.Type === 'PermissionGroup' ? ' (group)' : ''}` }))
					.sort((pA, pB) => String(pA.Label).localeCompare(String(pB.Label))));
			tmpAssignment.AssignSlot = [ { Context: tmpAssignment.Context } ];
			// Start and end days only offered for non-Customer contexts.
			tmpAssignment.ExpirationSlot = (tmpAssignment.Context !== 'Customer') ?
				[ { StartDraft: tmpAssignment.StartDraft, ExpirationDraft: tmpAssignment.ExpirationDraft, Today: libRoleDates.todayIn(tmpAssignment.TimeZone) } ] : [];
		}
		else
		{
			tmpAssignment.RoleOptions = [];
			tmpAssignment.AssignSlot = [];
			tmpAssignment.ExpirationSlot = [];
		}
	}

	_render()
	{
		if (this.pict.views.AccessWorkspace)
		{
			this.pict.views.AccessWorkspace.render();
		}
	}
}

module.exports = RoleAssignmentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'RoleAssignment',
	AutoInitialize: true,
	AutoInitializeOrdinal: 4,
};

},{"../access/RoleAssignment-Dates.js":1062,"pict-provider":845}],1371:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

/**
 * RoleCloneProvider — the data layer for "clone a role". Deep-copies an existing Role into a new,
 * independent one the admin can then diverge freely: the Role row, its RolePermission grants, and its
 * RoleEdge children (the composition that makes it inherit other roles/groups). The clone shares no rows
 * with the source.
 *
 * What is copied (mirrors the documented role model — Role / Role Permission / Role Edge):
 *   - Role: a new POST Role (IDRole/GUID dropped), Name from the admin, everything else from the source.
 *   - Grants: every RolePermission on the source, re-created against the new IDRole. A role's direct grants
 *     live in its membership STORAGE scope (global role -> CustomerMembership/0; customer role ->
 *     Customer/<IDCustomer>), so when the clone lands in a different customer than the source (localising a
 *     global template into a customer), those membership-scope grants are remapped to the new role's scope;
 *     deeper explicit-context grants are copied verbatim.
 *   - Edges: every RoleEdge where the source is the parent, re-created with the new role as parent.
 *
 * What is NOT touched: user assignments (a fresh role has no members yet — hand it out afterwards) and
 * project-type scoping (no such axis exists in the permission model today — a scoped variant is a follow-up).
 *
 * The copy is client-orchestrated (one create per record, no server transaction), so partial failures are
 * possible; the result reports per-record Succeeded/Failed so the admin can see exactly what landed.
 * State lives in pict.AppData.RoleClone; the RoleClone view derives a clean render-state from it.
 */
class RoleCloneProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	onAfterInitialize()
	{
		this._ensureState();
		return super.onAfterInitialize();
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get idCustomer()
	{
		return Number(this.currentUser.CustomerID) || 0;
	}

	/** Customer-1 / role-5 super-user, or the SuperAdminAccessRole (mirrors AccessWorkspace-Provider). */
	get isSuperUser()
	{
		const tmpUser = this.currentUser;
		if ((Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1))
		{
			return true;
		}
		const tmpRoles = tmpUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && pRole.Hash === 'SuperAdminAccessRole');
	}

	/** Holds a RoleManager/SuperAdminUser role, or is a super-user — the gate for creating/editing roles. */
	get isRoleManager()
	{
		if (this.isSuperUser)
		{
			return true;
		}
		const tmpRoles = this.currentUser.UserRoles;
		return Array.isArray(tmpRoles) && tmpRoles.some((pRole) => pRole && (pRole.PermissionLevel === 'RoleManager' || pRole.PermissionLevel === 'SuperAdminUser'));
	}

	// --- REST helpers (promise wrappers over the Headlight rest client) ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/** Read an entire filtered set (Count then one page sized to it) — mirrors AccessWorkspace._getFilteredAll. */
	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 1000;
		let tmpTotal = tmpCap;
		try
		{
			const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`);
			tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap);
		}
		catch (pError)
		{
			tmpTotal = tmpCap;
		}
		if (!tmpTotal)
		{
			return [];
		}
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	// --- State ---

	_ensureState()
	{
		if (!this.pict.AppData.RoleClone)
		{
			this.pict.AppData.RoleClone =
			{
				SourceIDRole: 0,
				SourceRole: null,           // the loaded source Role record
				RoleOptions: [],            // [{ Value, Label, Type, IDCustomer }]
				RolesLoaded: false,
				RolesLoading: false,
				IncludeGrants: true,
				IncludeEdges: true,
				NewName: '',
				TargetIDCustomer: null,     // number; null until defaulted from the source/session
				Preview: null,              // { GrantCount, EdgeCount }
				PreviewLoading: false,
				Loading: false,
				Result: null,               // { NewIDRole, Succeeded, Failed, Details:[{ Kind, Label, OK, Error? }] }
				Message: '',
			};
		}
		return this.pict.AppData.RoleClone;
	}

	get state()
	{
		return this._ensureState();
	}

	/** The role's grant STORAGE scope (mirrors PermissionMatrix-Provider._scope for the Customer context). */
	_membershipScope(pRole)
	{
		const tmpRoleCustomer = Number((pRole && pRole.IDCustomer) || 0);
		return (tmpRoleCustomer === 0)
			? { Context: 'CustomerMembership', IDContext: 0 }
			: { Context: 'Customer', IDContext: tmpRoleCustomer };
	}

	/** The effective target customer for the clone (defaults to the source's customer, else the session's). */
	_targetCustomer()
	{
		const tmpState = this.state;
		if (tmpState.TargetIDCustomer !== null && tmpState.TargetIDCustomer !== '' && !Number.isNaN(Number(tmpState.TargetIDCustomer)))
		{
			return Number(tmpState.TargetIDCustomer);
		}
		if (tmpState.SourceRole)
		{
			return Number(tmpState.SourceRole.IDCustomer || 0);
		}
		return this.idCustomer;
	}

	// --- Load ---

	/**
	 * Load the roles + permission groups the admin can clone from (global + this customer, not deleted).
	 * Concurrency-safe: the view auto-loads on render and the deep-link preselect also loads, so both share one
	 * in-flight request rather than racing (which would leave selectSourceAsync with an empty option list).
	 * @return {Promise<void>}
	 */
	loadRolesAsync()
	{
		if (this._rolesLoadPromise)
		{
			return this._rolesLoadPromise;
		}
		this._rolesLoadPromise = this._loadRolesInnerAsync();
		this._rolesLoadPromise.then(() => { this._rolesLoadPromise = null; }, () => { this._rolesLoadPromise = null; });
		return this._rolesLoadPromise;
	}

	async _loadRolesInnerAsync()
	{
		const tmpState = this.state;
		tmpState.RolesLoading = true;
		tmpState.Message = '';
		try
		{
			const tmpRoles = await this._getFilteredAll('Roles', `FBL~IDCustomer~INN~0,${this.idCustomer}~FBV~Deleted~EQ~0`, 1000);
			tmpRoles.sort((pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || '')));
			tmpState.RoleOptions = tmpRoles.map((pRole) => (
				{
					Value: Number(pRole.IDRole),
					Label: this._roleLabel(pRole),
					Type: pRole.Type || 'Role',
					IDCustomer: Number(pRole.IDCustomer || 0),
					Record: pRole,
				}));
			tmpState.RolesLoaded = true;
		}
		catch (pError)
		{
			tmpState.Message = `Could not load roles: ${pError && pError.message ? pError.message : pError}`;
		}
		tmpState.RolesLoading = false;
	}

	_roleLabel(pRole)
	{
		const tmpKind = (pRole.Type === 'PermissionGroup') ? 'Permission Group' : (pRole.Type === 'UserGroup') ? 'User Group' : 'Role';
		const tmpScope = (Number(pRole.IDCustomer || 0) === 0) ? ' · global' : '';
		return `${pRole.Name || `Role ${pRole.IDRole}`} (${tmpKind}${tmpScope})`;
	}

	// --- Source-role picker (server-side search; replaces the capped preloaded <select>) ---

	/**
	 * (Re)mount the searchable source-role picker into #RoleClone-SourcePicker. Called from the view's onAfterRender,
	 * so it re-creates into the freshly-rendered mount each repaint (RoleClone re-renders its whole wrap on every
	 * action) — the selection is preserved via the ValueAddress binding + ResolveValue, mirroring ProjectEditWorkspace.
	 */
	mountSourcePicker()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		const tmpMount = '#RoleClone-SourcePicker';
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; }
		const tmpView = this.pict.views.RoleClone;
		const tmpPicker = tmpPickerProvider.createPicker('RoleClone-SourcePicker',
			{
				DestinationAddress: tmpMount,
				ValueAddress: 'AppData.RoleClone.SourceIDRole',
				Searchable: true,
				AllowClear: true,
				ClearLabel: '— choose a role to clone —',
				Placeholder: 'Search a role or permission group…',
				DataProvider: this._roleDataProvider(),
				ResolveValue: this._roleResolveValue(),
				OnChange: (pValue) => { this.selectSourceAsync(pValue).then(() => { if (tmpView) { tmpView.render(); } }); },
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
	}

	/** Server-side search DataProvider: Roles by Name LIKE, global (0) + this customer, not deleted, paged. */
	_roleDataProvider()
	{
		const tmpPageSize = 25;
		return (pSearchTerm, pPage) =>
		{
			const tmpStart = (Number(pPage) || 0) * tmpPageSize;
			let tmpFilter = `FBL~IDCustomer~INN~0,${this.idCustomer}~FBV~Deleted~EQ~0`;
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).trim();
			if (tmpTerm) { tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`; }
			return this._getJSON(`Roles/FilteredTo/${tmpFilter}/${tmpStart}/${tmpPageSize}`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					return { results: tmpList.map((pRole) => ({ Value: Number(pRole.IDRole), Text: this._roleLabel(pRole), Record: pRole })), hasMore: (tmpList.length >= tmpPageSize) };
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	/** Resolve a preselected IDRole → {Value,Text} so the current selection shows its label on (re)mount. */
	_roleResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`Role/${tmpID}`)
				.then((pRole) => ((pRole && pRole.IDRole) ? { Value: Number(pRole.IDRole), Text: this._roleLabel(pRole) } : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/** Choose the source role by id: stash the record, default the new name + target customer, load the preview. */
	async selectSourceAsync(pIDRole)
	{
		const tmpState = this.state;
		const tmpID = parseInt(pIDRole, 10) || 0;
		tmpState.SourceIDRole = tmpID;
		tmpState.Result = null;
		tmpState.Message = '';
		const tmpOption = (tmpState.RoleOptions || []).find((pOption) => pOption.Value === tmpID);
		tmpState.SourceRole = tmpOption ? tmpOption.Record : null;
		// The source picker is server-side search (not a preloaded option list), so a chosen role won't be in
		// RoleOptions — fetch the record directly by id.
		if (!tmpState.SourceRole && tmpID)
		{
			tmpState.SourceRole = await this._getJSON(`Role/${tmpID}`).catch(() => null);
		}
		if (tmpState.SourceRole)
		{
			tmpState.NewName = `Copy of ${tmpState.SourceRole.Name || ''}`.trim();
			tmpState.TargetIDCustomer = Number(tmpState.SourceRole.IDCustomer || 0);
			// A customer role-manager can only create in their own customer — pin the target there.
			if (!this.isSuperUser)
			{
				tmpState.TargetIDCustomer = this.idCustomer;
			}
			await this.loadPreviewAsync();
		}
		else
		{
			tmpState.Preview = null;
		}
	}

	/** Preselect a source (from the Access "Duplicate" deep-link). selectSourceAsync resolves the record by id itself
	 * (and the picker's ResolveValue shows its label), so no preloaded role list is needed. */
	async preselectSourceAsync(pIDRole)
	{
		await this.selectSourceAsync(pIDRole);
	}

	/** Count what would be copied so the admin sees the size of the clone before running it. */
	async loadPreviewAsync()
	{
		const tmpState = this.state;
		if (!tmpState.SourceRole)
		{
			tmpState.Preview = null;
			return;
		}
		tmpState.PreviewLoading = true;
		try
		{
			const tmpGrants = await this._readGrantsAsync(tmpState.SourceRole);
			const tmpEdges = await this._readEdgesAsync(tmpState.SourceRole);
			tmpState.Preview = { GrantCount: tmpGrants.length, EdgeCount: tmpEdges.length };
		}
		catch (pError)
		{
			tmpState.Message = `Could not read the source role's grants: ${pError && pError.message ? pError.message : pError}`;
			tmpState.Preview = null;
		}
		tmpState.PreviewLoading = false;
	}

	_readGrantsAsync(pRole)
	{
		return this._getFilteredAll('RolePermissions', `FBV~IDRole~EQ~${Number(pRole.IDRole)}`, 5000);
	}

	_readEdgesAsync(pRole)
	{
		return this._getFilteredAll('RoleEdges', `FBV~ParentIDRole~EQ~${Number(pRole.IDRole)}~FBV~Deleted~EQ~0`, 2000);
	}

	// --- Field setters (from the view) ---

	setField(pField, pValue)
	{
		this.state[pField] = pValue;
	}

	toggleInclude(pField)
	{
		this.state[pField] = !this.state[pField];
	}

	// --- Apply ---

	/**
	 * Run the clone: create the new Role, then re-create its selected grants + edges against the new IDRole.
	 * Aggregates a per-record result. If the Role itself cannot be created nothing else is attempted.
	 * @return {Promise<object|null>} the result summary (also stashed on state.Result)
	 */
	async cloneAsync()
	{
		const tmpState = this.state;
		tmpState.Message = '';
		tmpState.Result = null;

		if (!this.isRoleManager)
		{
			tmpState.Message = 'You do not have permission to create roles.';
			return null;
		}
		const tmpSource = tmpState.SourceRole;
		if (!tmpSource)
		{
			tmpState.Message = 'Choose a source role to clone.';
			return null;
		}
		const tmpName = String(tmpState.NewName || '').trim();
		if (!tmpName)
		{
			tmpState.Message = 'Enter a name for the new role.';
			return null;
		}
		const tmpTargetCustomer = this._targetCustomer();
		if (!this.isSuperUser && tmpTargetCustomer !== this.idCustomer)
		{
			tmpState.Message = 'You can only create roles in your own customer.';
			return null;
		}

		tmpState.Loading = true;
		const tmpDetails = [];

		// 1) The Role row.
		let tmpNewID = 0;
		try
		{
			const tmpSaved = await this._postJSON('Role',
				{
					Name: tmpName,
					Type: tmpSource.Type || 'Role',
					PermissionLevel: tmpSource.PermissionLevel || '',
					Description: tmpSource.Description || '',
					IDCustomer: tmpTargetCustomer,
				});
			tmpNewID = Number(tmpSaved && tmpSaved.IDRole) || 0;
			if (!tmpNewID)
			{
				throw new Error('the server did not return a new role id');
			}
			tmpDetails.push({ Kind: 'Role', Label: `Role “${tmpName}” (#${tmpNewID})`, OK: true });
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.Message = `Could not create the role: ${pError && pError.message ? pError.message : pError}`;
			return null;
		}

		// 2) Grants.
		if (tmpState.IncludeGrants)
		{
			const tmpSrcScope = this._membershipScope(tmpSource);
			const tmpTgtScope = this._membershipScope({ IDCustomer: tmpTargetCustomer });
			let tmpGrants = [];
			try
			{
				tmpGrants = await this._readGrantsAsync(tmpSource);
			}
			catch (pError)
			{
				tmpDetails.push({ Kind: 'Grants', Label: 'Read grants', OK: false, Error: String(pError && pError.message ? pError.message : pError) });
			}
			const tmpSeen = {};
			for (let i = 0; i < tmpGrants.length; i++)
			{
				const tmpGrant = tmpGrants[i];
				let tmpContext = tmpGrant.Context;
				let tmpIDContext = Number(tmpGrant.IDContext || 0);
				// Membership-scope grants follow the role to its new customer; deeper grants stay put.
				if (tmpContext === tmpSrcScope.Context && tmpIDContext === tmpSrcScope.IDContext)
				{
					tmpContext = tmpTgtScope.Context;
					tmpIDContext = tmpTgtScope.IDContext;
				}
				const tmpKey = `${tmpGrant.Hash}|${tmpContext}|${tmpIDContext}|${tmpGrant.Allowed}`;
				if (tmpSeen[tmpKey]) { continue; }
				tmpSeen[tmpKey] = true;
				try
				{
					/* eslint-disable no-await-in-loop */
					await this._postJSON('RolePermission',
						{
							IDRole: tmpNewID,
							Hash: tmpGrant.Hash,
							Allowed: tmpGrant.Allowed,
							Context: tmpContext,
							IDContext: tmpIDContext,
							IDCustomer: tmpTargetCustomer,
						});
					/* eslint-enable no-await-in-loop */
					tmpDetails.push({ Kind: 'Grant', Label: `${tmpGrant.Allowed ? 'grant' : 'deny'} ${tmpGrant.Hash}`, OK: true });
				}
				catch (pError)
				{
					tmpDetails.push({ Kind: 'Grant', Label: `${tmpGrant.Allowed ? 'grant' : 'deny'} ${tmpGrant.Hash}`, OK: false, Error: String(pError && pError.message ? pError.message : pError) });
				}
			}
		}

		// 3) Edges (composition — the source's inherited roles/groups).
		if (tmpState.IncludeEdges)
		{
			let tmpEdges = [];
			try
			{
				tmpEdges = await this._readEdgesAsync(tmpSource);
			}
			catch (pError)
			{
				tmpDetails.push({ Kind: 'Edges', Label: 'Read edges', OK: false, Error: String(pError && pError.message ? pError.message : pError) });
			}
			const tmpSeenChild = {};
			for (let i = 0; i < tmpEdges.length; i++)
			{
				const tmpChildID = Number(tmpEdges[i].ChildIDRole);
				if (!tmpChildID || tmpChildID === tmpNewID || tmpSeenChild[tmpChildID]) { continue; }
				tmpSeenChild[tmpChildID] = true;
				try
				{
					/* eslint-disable no-await-in-loop */
					await this._postJSON('RoleEdge',
						{ ParentIDRole: tmpNewID, ChildIDRole: tmpChildID, IDCustomer: tmpTargetCustomer });
					/* eslint-enable no-await-in-loop */
					tmpDetails.push({ Kind: 'Edge', Label: `includes role #${tmpChildID}`, OK: true });
				}
				catch (pError)
				{
					tmpDetails.push({ Kind: 'Edge', Label: `includes role #${tmpChildID}`, OK: false, Error: String(pError && pError.message ? pError.message : pError) });
				}
			}
		}

		tmpState.Result =
		{
			NewIDRole: tmpNewID,
			NewName: tmpName,
			Succeeded: tmpDetails.filter((pDetail) => pDetail.OK).length,
			Failed: tmpDetails.filter((pDetail) => !pDetail.OK).length,
			Details: tmpDetails,
		};
		tmpState.Loading = false;
		return tmpState.Result;
	}

	// --- Derive view state ---

	deriveRenderState()
	{
		const tmpState = this.state;

		tmpState.RoleOptionRows = (tmpState.RoleOptions || []).map((pOption) => (
			{
				Value: pOption.Value,
				Label: pOption.Label,
				SelectedAttr: (Number(pOption.Value) === Number(tmpState.SourceIDRole)) ? 'selected' : '',
			}));

		const tmpHasSource = !!tmpState.SourceRole;
		const tmpTargetCustomer = this._targetCustomer();
		const tmpName = String(tmpState.NewName || '').trim();
		const tmpCanApply = tmpHasSource && !!tmpName && this.isRoleManager && !tmpState.Loading;

		tmpState.HasSource = tmpHasSource;
		tmpState.SourceTypeLabel = tmpHasSource ? this._roleLabel(tmpState.SourceRole) : '';
		tmpState.TargetCustomerValue = tmpTargetCustomer;
		tmpState.TargetCustomerReadOnly = this.isSuperUser ? '' : 'readonly';
		tmpState.IncludeGrantsAttr = tmpState.IncludeGrants ? 'checked' : '';
		tmpState.IncludeEdgesAttr = tmpState.IncludeEdges ? 'checked' : '';
		tmpState.NewNameValue = tmpState.NewName || '';
		tmpState.ApplyDisabledAttr = tmpCanApply ? '' : 'disabled';

		// Conditional slots (single-element-array trick).
		tmpState.NoPermSlot = this.isRoleManager ? [] : [ {} ];
		tmpState.LoadingSlot = tmpState.Loading ? [ {} ] : [];
		tmpState.MessageSlot = tmpState.Message ? [ { Message: tmpState.Message } ] : [];

		let tmpPreviewText = '';
		if (tmpState.PreviewLoading)
		{
			tmpPreviewText = 'Reading source…';
		}
		else if (tmpState.Preview)
		{
			tmpPreviewText = `${tmpState.Preview.GrantCount} grant(s) · ${tmpState.Preview.EdgeCount} included role(s)`;
		}
		tmpState.PreviewSlot = (tmpHasSource && tmpPreviewText) ? [ { Text: tmpPreviewText } ] : [];

		tmpState.ResultSlot = tmpState.Result ? [ tmpState.Result ] : [];
		tmpState.ResultRows = tmpState.Result ? tmpState.Result.Details.map((pDetail) => (
			{
				Label: pDetail.Label,
				StatusClass: pDetail.OK ? 'has-text-success' : 'has-text-danger',
				StatusText: pDetail.OK ? 'created' : ('failed: ' + (pDetail.Error || 'error')),
			})) : [];

		return tmpState;
	}
}

module.exports = RoleCloneProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'RoleCloneProvider',
	AutoInitialize: true,
	AutoInitializeOrdinal: 42,
};

},{"pict-provider":845}],1372:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libMasterListCatalog = require('../master-lists/Headlight-MasterLists.js');

const DETAIL_MOUNT = '#SLC-Detail';
const ENTITY = 'Sample';
// System / bookkeeping columns a user would rarely surface — offered under "Available" but de-emphasized.
const SYSTEM_COLUMN = /^(ID[A-Z]|GUID|CreateDate$|CreatingIDUser$|UpdateDate$|UpdatingIDUser$|Deleted$|DeleteDate$|DeletingIDUser$|ExternalSyncDate$|ExternalSync)/;

/**
 * SampleListColumnsConfig — the bespoke #/SampleListColumnsConfig screen. Lets an admin choose which columns the
 * config app's Samples list (#/PSRS/Sample/List) shows, rename their headers, reorder them, pick which are
 * searchable, and (advanced) set a per-column value template — saved as a cascading MasterListCatalog
 * Configuration (Platform / Customer / My Settings). Gated by the `SampleListColumns-Configure` entitlement.
 *
 * It is a thin UI over the existing MasterListRegistry provider: reads the effective Sample entry (static seed ⊕
 * cascade) from `registry.entries.Sample`, and saves via `registry.saveEntryAsync({Entity:'Sample', Columns,
 * SearchFields}, scope)` — which Puts to Configuration, re-reads the cascade, and applies to the live list without
 * a reload. Passing the Columns array with `PictDashboard.ValueTemplate` intact preserves the Status resolver
 * ({~SampleStatusName:Record.Payload.Status~}); the generic MasterListManager editor drops it, this screen does not.
 */
class SampleListColumnsConfigProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get registry() { return this.pict.providers.MasterListRegistry; }
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get state()
	{
		if (!this.pict.AppData.SampleListColumnsConfig)
		{
			this.pict.AppData.SampleListColumnsConfig =
			{
				Loaded: false, Loading: false, Saving: false, Error: '', Message: '',
				ScopeLevel: 'Customer', Columns: [],
			};
		}
		return this.pict.AppData.SampleListColumnsConfig;
	}

	/** The entitlement gate — `SampleListColumns-Configure`. Same capability the nav entry checks; server stays authoritative. */
	can()
	{
		const tmpSvc = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return true; }
		return tmpSvc.can('SampleListColumns', 'Configure');
	}

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	_seedEntry() { return libMasterListCatalog.find((pEntry) => pEntry && pEntry.Entity === ENTITY) || {}; }

	/** The effective Sample catalog entry (static seed ⊕ cascade override), from the registry when available. */
	_effectiveEntry()
	{
		const tmpRegistry = this.registry;
		if (tmpRegistry && tmpRegistry.entries && tmpRegistry.entries[ENTITY]) { return tmpRegistry.entries[ENTITY]; }
		return this._seedEntry();
	}

	scopeLevels() { const tmpRegistry = this.registry; return (tmpRegistry && tmpRegistry.constructor && tmpRegistry.constructor.SCOPE_LEVELS) ? tmpRegistry.constructor.SCOPE_LEVELS : [ 'Global', 'Customer', 'User' ]; }
	scopeLabel(pLevel) { return ({ Global: 'Platform Default', Customer: 'Customer', User: 'My Settings' })[pLevel] || pLevel; }
	canWriteScope(pLevel) { const tmpRegistry = this.registry; return (tmpRegistry && typeof tmpRegistry.canWriteScope === 'function') ? tmpRegistry.canWriteScope(pLevel) : (pLevel === 'User'); }

	async loadAsync()
	{
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		try
		{
			const tmpRegistry = this.registry;
			// Ensure the registry has loaded the cascade (it auto-inits at login; be defensive).
			if (tmpRegistry && typeof tmpRegistry.loadCascadedConfigAsync === 'function' && (!tmpRegistry.entries || !tmpRegistry.entries[ENTITY]))
			{
				await tmpRegistry.loadCascadedConfigAsync();
			}
			// Available columns = the live Sample schema.
			const tmpSchema = await this._getJSON(`${ENTITY}/Schema`);
			const tmpSchemaKeys = (tmpSchema && tmpSchema.properties) ? Object.keys(tmpSchema.properties) : [];
			// Current effective columns + search fields.
			const tmpEntry = this._effectiveEntry();
			const tmpCurrentCols = Array.isArray(tmpEntry.Columns) ? tmpEntry.Columns : [];
			const tmpSearchFields = Array.isArray(tmpEntry.SearchFields) ? tmpEntry.SearchFields : [ 'Name' ];

			const tmpModel = [];
			const tmpSeen = {};
			// Shown columns first, in their configured order.
			for (const tmpCol of tmpCurrentCols)
			{
				const tmpKey = (typeof tmpCol === 'string') ? tmpCol : tmpCol.Key;
				if (!tmpKey || tmpSeen[tmpKey]) { continue; }
				tmpSeen[tmpKey] = true;
				const tmpValueTemplate = (tmpCol && tmpCol.PictDashboard && tmpCol.PictDashboard.ValueTemplate) ? tmpCol.PictDashboard.ValueTemplate : '';
				tmpModel.push({
					Key: tmpKey,
					DisplayName: (typeof tmpCol === 'object' && tmpCol.DisplayName) ? tmpCol.DisplayName : tmpKey,
					ValueTemplate: tmpValueTemplate,
					Shown: true,
					Searchable: tmpSearchFields.indexOf(tmpKey) > -1,
					System: SYSTEM_COLUMN.test(tmpKey),
				});
			}
			// Remaining schema columns as available-to-add.
			for (const tmpKey of tmpSchemaKeys)
			{
				if (tmpSeen[tmpKey]) { continue; }
				tmpSeen[tmpKey] = true;
				tmpModel.push({ Key: tmpKey, DisplayName: tmpKey, ValueTemplate: '', Shown: false, Searchable: false, System: SYSTEM_COLUMN.test(tmpKey) });
			}

			tmpState.Columns = tmpModel;
			tmpState.ScopeLevel = (tmpRegistry && tmpRegistry.defaultScope) ? tmpRegistry.defaultScope : 'Customer';
			if (!this.canWriteScope(tmpState.ScopeLevel))
			{
				const tmpWritable = this.scopeLevels().find((pLevel) => this.canWriteScope(pLevel));
				if (tmpWritable) { tmpState.ScopeLevel = tmpWritable; }
			}
			tmpState.Loaded = true;
		}
		catch (pError)
		{
			tmpState.Error = `Could not load the Samples list configuration: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	// --- editor operations (each re-renders) -----------------------------------------------------------------
	_col(pKey) { return (this.state.Columns || []).find((pCol) => pCol.Key === pKey); }

	toggleShown(pKey)
	{
		const tmpCol = this._col(pKey);
		if (!tmpCol) { return; }
		tmpCol.Shown = !tmpCol.Shown;
		if (!tmpCol.Shown) { tmpCol.Searchable = false; }
		this.state.Message = '';
		this.render();
	}

	setLabel(pKey, pValue) { const tmpCol = this._col(pKey); if (tmpCol) { tmpCol.DisplayName = pValue; } }
	setValueTemplate(pKey, pValue) { const tmpCol = this._col(pKey); if (tmpCol) { tmpCol.ValueTemplate = pValue; } }
	toggleSearch(pKey) { const tmpCol = this._col(pKey); if (tmpCol) { tmpCol.Searchable = !tmpCol.Searchable; this.render(); } }

	_shownIndexes() { const tmpCols = this.state.Columns || []; const tmpOut = []; for (let i = 0; i < tmpCols.length; i++) { if (tmpCols[i].Shown) { tmpOut.push(i); } } return tmpOut; }

	moveUp(pKey)
	{
		const tmpCols = this.state.Columns || [];
		const tmpShown = this._shownIndexes();
		const tmpPos = tmpShown.findIndex((pIdx) => tmpCols[pIdx].Key === pKey);
		if (tmpPos <= 0) { return; }
		const tmpA = tmpShown[tmpPos]; const tmpB = tmpShown[tmpPos - 1];
		const tmpTemp = tmpCols[tmpA]; tmpCols[tmpA] = tmpCols[tmpB]; tmpCols[tmpB] = tmpTemp;
		this.render();
	}
	moveDown(pKey)
	{
		const tmpCols = this.state.Columns || [];
		const tmpShown = this._shownIndexes();
		const tmpPos = tmpShown.findIndex((pIdx) => tmpCols[pIdx].Key === pKey);
		if (tmpPos < 0 || tmpPos >= tmpShown.length - 1) { return; }
		const tmpA = tmpShown[tmpPos]; const tmpB = tmpShown[tmpPos + 1];
		const tmpTemp = tmpCols[tmpA]; tmpCols[tmpA] = tmpCols[tmpB]; tmpCols[tmpB] = tmpTemp;
		this.render();
	}

	setScope(pLevel) { this.state.ScopeLevel = pLevel; this.state.Message = ''; this.render(); }

	async save()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		const tmpRegistry = this.registry;
		if (!tmpRegistry || typeof tmpRegistry.saveEntryAsync !== 'function') { tmpState.Error = 'The list registry is not available.'; this.render(); return; }
		const tmpShown = (tmpState.Columns || []).filter((pCol) => pCol.Shown);
		if (!tmpShown.length) { tmpState.Error = 'Keep at least one column shown.'; this.render(); return; }
		const tmpColumns = tmpShown.map((pCol) =>
		{
			const tmpEntry = { Key: pCol.Key, DisplayName: (pCol.DisplayName || pCol.Key) };
			if (pCol.ValueTemplate) { tmpEntry.PictDashboard = { ValueTemplate: pCol.ValueTemplate }; }
			return tmpEntry;
		});
		const tmpSearchFields = tmpShown.filter((pCol) => pCol.Searchable).map((pCol) => pCol.Key);
		tmpState.Saving = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		try
		{
			await tmpRegistry.saveEntryAsync({ Entity: ENTITY, Columns: tmpColumns, SearchFields: (tmpSearchFields.length ? tmpSearchFields : [ 'Name' ]) }, tmpState.ScopeLevel);
			tmpState.Message = `Saved to ${this.scopeLabel(tmpState.ScopeLevel)}. The Samples list is updated.`;
		}
		catch (pError)
		{
			tmpState.Error = `Save failed: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Saving = false;
			this.render();
		}
	}

	openList() { window.location.hash = '#/PSRS/Sample/List'; }

	// --- render ----------------------------------------------------------------------------------------------
	render()
	{
		if (!this.pict.views.SampleListColumnsConfig) { return; }
		const tmpState = this.state;
		if (!this.can())
		{
			this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, `<div class="slc-empty">You don’t have the <strong>Configure the Samples list columns</strong> entitlement.</div>`);
			return;
		}
		if (tmpState.Loading && !tmpState.Loaded) { this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, '<div class="slc-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>'); return; }

		const tmpScopeBar = this.scopeLevels().map((pLevel) =>
		{
			const tmpDisabled = !this.canWriteScope(pLevel);
			const tmpActive = (tmpState.ScopeLevel === pLevel) ? ' is-active' : '';
			return `<button class="slc-scope-btn${tmpActive}" ${tmpDisabled ? 'disabled title="You cannot save at this scope"' : ''} onclick="_Pict.providers.SampleListColumnsConfig.setScope('${pLevel}')">${this._esc(this.scopeLabel(pLevel))}</button>`;
		}).join('');

		const tmpShownRows = (tmpState.Columns || []).filter((pCol) => pCol.Shown).map((pCol) => this._shownRowHTML(pCol)).join('');
		const tmpAvail = (tmpState.Columns || []).filter((pCol) => !pCol.Shown);
		const tmpAvailHTML = tmpAvail.length
			? tmpAvail.map((pCol) => `<button class="slc-avail${pCol.System ? ' is-system' : ''}" onclick="_Pict.providers.SampleListColumnsConfig.toggleShown('${this._esc(pCol.Key)}')" title="Add ${this._esc(pCol.Key)}"><i class="fas fa-plus"></i> ${this._esc(pCol.Key)}</button>`).join('')
			: '<span class="slc-avail-empty">All columns are shown.</span>';

		const tmpMsg = tmpState.Message ? `<div class="slc-msg">${this._esc(tmpState.Message)}</div>` : '';
		const tmpErr = tmpState.Error ? `<div class="slc-error">${this._esc(tmpState.Error)}</div>` : '';

		const tmpHTML = `
			${tmpErr}${tmpMsg}
			<div class="slc-scopebar"><span class="slc-scope-label">Save to</span>${tmpScopeBar}</div>
			<div class="slc-area-head">Shown columns <span class="slc-hint">— order top-to-bottom; edit the header label; ⚙ sets an advanced value template</span></div>
			<div class="slc-cols">
				<div class="slc-colhead"><span class="slc-ch-order"></span><span class="slc-ch-key">Field</span><span class="slc-ch-label">Header label</span><span class="slc-ch-search">Search</span><span class="slc-ch-actions"></span></div>
				${tmpShownRows}
			</div>
			<div class="slc-area-head">Add a column</div>
			<div class="slc-availwrap">${tmpAvailHTML}</div>
			<div class="slc-savebar">
				<button class="slc-save" ${tmpState.Saving ? 'disabled' : ''} onclick="_Pict.providers.SampleListColumnsConfig.save()">${tmpState.Saving ? 'Saving…' : 'Save columns'}</button>
				<button class="slc-preview" onclick="_Pict.providers.SampleListColumnsConfig.openList()">Preview the list</button>
			</div>`;
		this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, tmpHTML);
	}

	_shownRowHTML(pCol)
	{
		const tmpKey = this._esc(pCol.Key);
		const tmpTemplateBtn = pCol.ValueTemplate
			? `<button class="slc-tmpl-btn is-set" title="Value template: ${this._esc(pCol.ValueTemplate)}" onclick="_Pict.providers.SampleListColumnsConfig._toggleTemplateRow('${tmpKey}')"><i class="fas fa-gear"></i></button>`
			: `<button class="slc-tmpl-btn" title="Set an advanced value template" onclick="_Pict.providers.SampleListColumnsConfig._toggleTemplateRow('${tmpKey}')"><i class="fas fa-gear"></i></button>`;
		const tmpTemplateRow = pCol._showTemplate
			? `<div class="slc-tmpl-row"><input class="slc-tmpl-input" placeholder="e.g. {~SampleStatusName:Record.Payload.Status~}" value="${this._esc(pCol.ValueTemplate)}" oninput="_Pict.providers.SampleListColumnsConfig.setValueTemplate('${tmpKey}', this.value)"><span class="slc-tmpl-hint">Renders the cell; the row value is at <code>Record.Payload.&lt;field&gt;</code>.</span></div>`
			: '';
		return `<div class="slc-col">
			<span class="slc-order">
				<button class="slc-mv" title="Move up" onclick="_Pict.providers.SampleListColumnsConfig.moveUp('${tmpKey}')"><i class="fas fa-chevron-up"></i></button>
				<button class="slc-mv" title="Move down" onclick="_Pict.providers.SampleListColumnsConfig.moveDown('${tmpKey}')"><i class="fas fa-chevron-down"></i></button>
			</span>
			<span class="slc-key" title="${tmpKey}">${tmpKey}</span>
			<input class="slc-label" value="${this._esc(pCol.DisplayName)}" oninput="_Pict.providers.SampleListColumnsConfig.setLabel('${tmpKey}', this.value)">
			<button class="slc-search-btn${pCol.Searchable ? ' is-on' : ''}" title="Toggle searchable" onclick="_Pict.providers.SampleListColumnsConfig.toggleSearch('${tmpKey}')"><i class="fas fa-magnifying-glass"></i></button>
			<span class="slc-col-actions">${tmpTemplateBtn}<button class="slc-remove" title="Hide column" onclick="_Pict.providers.SampleListColumnsConfig.toggleShown('${tmpKey}')"><i class="fas fa-times"></i></button></span>
		</div>${tmpTemplateRow}`;
	}

	_toggleTemplateRow(pKey) { const tmpCol = this._col(pKey); if (tmpCol) { tmpCol._showTemplate = !tmpCol._showTemplate; this.render(); } }
}

module.exports = SampleListColumnsConfigProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'SampleListColumnsConfig',
	AutoInitialize: true,
	AutoInitializeOrdinal: 231,
};

},{"../master-lists/Headlight-MasterLists.js":1290,"pict-provider":845}],1373:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libQRCode = require('headlight-qrcode');

const DETAIL_MOUNT = '#SQR-Detail';
const LEGACY_TOKEN = 'SiteManagerSampleGUID';
const LIMS_PRODUCT = 'LIMS';
const PRINTABLE_SUBTYPE = `${LIMS_PRODUCT}-Sample-Printable`;

// The fields that can appear on a printed sample QR label. Keys are the addresses HeadlightQuickSummaries resolves
// on a Sample record for the 'Printable' action: raw columns, computed FK names (_Material from IDMaterial,
// _CreatingUser from CreatingIDUser, …), and formatted dates (DesignatedTime_Formatted). Each carries the descriptor
// metadata the label renderer needs (HeadlightPrintable / DataType).
const FIELD_PALETTE =
[
	{ Key: 'QRCode', Name: 'Sample ID' },
	{ Key: 'LabControlNumber', Name: 'PSID' },
	{ Key: 'Name', Name: 'Description' },
	{ Key: 'ReceivedFrom', Name: 'Source' },
	{ Key: 'Status', Name: 'Status' },
	{ Key: 'Notes', Name: 'Notes' },
	{ Key: '_Material', Name: 'Material' },
	{ Key: '_Project', Name: 'Project' },
	// Not columns: QRCodeProvider.addJoinedLabelFields fills these from the Sample's SampleLineItemJoins and TestInstances.
	{ Key: '_LineItems', Name: 'Line Items' },
	{ Key: '_Tests', Name: 'Tests' },
	{ Key: '_CreatingUser', Name: 'Sampled By', HeadlightPrintable: { DisplayFields: [ 'NameFirst', 'NameLast' ] } },
	{ Key: 'DesignatedTime_Formatted', Name: 'Sampled On', DataType: 'DateTime', HeadlightPrintable: { DateFormat: 'YYYY-MM-DD' } },
];
const PALETTE_BY_KEY = FIELD_PALETTE.reduce((pMap, pField) => { pMap[pField.Key] = pField; return pMap; }, {});
// Label layouts QRCodeProvider draws; anything else is drawn as 'wide'.
const PRINT_STYLES = [ 'thin', 'wide', 'tall' ];
const normalizePrintStyle = (pStyle) => (PRINT_STYLES.indexOf(pStyle) > -1 ? pStyle : 'wide');
// Date formats offered for date fields (dayjs format strings).
const DATE_FORMATS =
[
	{ Value: 'YYYY-MM-DD', Example: '2026-10-16' },
	{ Value: 'MMM D, YYYY', Example: 'Oct 16, 2026' },
	{ Value: 'MM/DD/YYYY', Example: '10/16/2026' },
];
// Code-format profiles (headlight-qrcode Profiles). 'Unconfigured' = no QRCodes config: SiteManager when
// CustomSampleGUID says so, otherwise the customer's default (Profiles.getDefaultProfileName).
const PROFILE_CHOICES =
[
	{ Value: 'Standard', Title: 'Standard', Description: 'Project + user + date + random characters. Never repeats; the format new customers get.' },
	{ Value: 'Legacy-Classic', Title: 'Pre-2026 web format', Description: 'Project + user + timestamp, exactly as samples were coded before 2026. For customers with systems that read these codes.' },
	{ Value: 'Legacy-SiteManager', Title: 'SiteManager / Legacy', Description: 'Sampler’s SiteManager id + timestamp. Use when samples must be found in SiteManager.' },
];
const DEFAULT_CONTENT_FIELDS =
[
	{ Key: 'QRCode', Name: 'Sample ID', Row: 1, Column: 1 },
	{ Key: '_Material', Name: 'Material', Row: 1, Column: 2 },
	{ Key: '_Project', Name: 'Project', Row: 2, Column: 1 },
	{ Key: 'DesignatedTime_Formatted', Name: 'Sampled On', Row: 2, Column: 2 },
];

/**
 * SampleQRCodeConfig — the bespoke #/SampleQRCodeConfig screen. Two tabs:
 *   • Format — how the QR string is generated: the customer's QRCodes/Profile configuration (Customer level),
 *     with CustomProperties.CustomSampleGUID kept in step for older readers.
 *   • Label content — what prints ON the QR label (title + fields laid out in rows/columns), stored as the
 *     customer's `LIMS-Sample-Printable` ManifestSchema (Type=RecordManifest) — the same manifest the LIMS app +
 *     the config app's Print Label read via QRCodeProvider.ensurePrintableManifests().
 * Gated by the `SampleQRCode-Configure` entitlement. Super-user may pick any customer; a customer-admin edits own.
 */
class SampleQRCodeConfigProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get qrService() { return (this.pict.fable.services && this.pict.fable.services.HeadlightQRCodeHash) || this.pict.fable.HeadlightQRCodeHash; }
	get qrProvider() { return this.pict.providers.QRCodeProvider; }

	get state()
	{
		if (!this.pict.AppData.SampleQRCodeConfig)
		{
			this.pict.AppData.SampleQRCodeConfig =
			{
				Loaded: false, Loading: false, Saving: false, Error: '', Message: '',
				Tab: 'format', Format: 'Standard', TargetCustomerID: 0, TargetCustomerName: '',
				Customers: [], PreviewCode: '', PreviewPayload: '',
				// Label-content tab
				ContentTitle: 'Sample', PrintStyle: 'wide', ContentFields: [], ContentSaving: false,
				ContentMessage: '', ContentError: '', PreviewSampleQR: '', _printableIDManifestSchema: 0,
				// Printing tab
				DefaultMediaPreset: '', PrintingConfigured: false, PrintingSaving: false, PrintingMessage: '', PrintingError: '',
			};
		}
		return this.pict.AppData.SampleQRCodeConfig;
	}

	get currentUser() { return this.pict.AppData.CurrentUser || {}; }
	callerCustomer() { return Number(this.currentUser.CustomerID) || 0; }
	isSuperUser() { return (Number(this.currentUser.UserRoleIndex) === 5) && (Number(this.currentUser.CustomerID) === 1); }

	can()
	{
		const tmpSvc = this.pict.fable.EffectivePermissionsService || (this.fable && this.fable.EffectivePermissionsService);
		if (!tmpSvc || (typeof tmpSvc.can !== 'function')) { return true; }
		return tmpSvc.can('SampleQRCode', 'Configure');
	}

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pRes) => resolve({ error: pErr, result: pRes }))) : Promise.resolve({ error: 'no client' }); }
	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	_parseProps(pRecord)
	{
		let tmpProps = (pRecord && pRecord.CustomProperties) || {};
		if (typeof tmpProps === 'string')
		{
			const tmpTrimmed = tmpProps.trim();
			if (tmpTrimmed.startsWith('{')) { try { tmpProps = JSON.parse(tmpTrimmed); } catch (pError) { tmpProps = {}; } }
			else { tmpProps = {}; }
		}
		return (tmpProps && typeof tmpProps === 'object') ? tmpProps : {};
	}

	/** The profile the editor currently describes, resolved the same way apps resolve it. */
	_editedProfile()
	{
		const tmpState = this.state;
		if (tmpState.Profile === 'Unconfigured')
		{
			return this._unconfiguredProfile();
		}
		return libQRCode.Profiles.resolveProfile(this._profileConfig(), {});
	}

	/** What the target customer gets with no QRCodes config. */
	_unconfiguredProfile()
	{
		const tmpState = this.state;
		return libQRCode.Profiles.resolveProfile({}, (tmpState.Format === 'SiteManager') ? { CustomSampleGUID: LEGACY_TOKEN } : {}, { IDCustomer: tmpState.TargetCustomerID });
	}

	/**
	 * @param {string} pProfileName
	 * @return {string} the plain-language title shown for a profile
	 */
	_profileTitle(pProfileName)
	{
		const tmpChoice = PROFILE_CHOICES.find((pChoice) => pChoice.Value === pProfileName);
		return tmpChoice ? tmpChoice.Title : pProfileName;
	}

	/** The QRCodes/Profile configuration object for the edited profile. */
	_profileConfig()
	{
		const tmpState = this.state;
		const tmpConfig = { Profile: tmpState.Profile, AllowCompact: !!tmpState.AllowCompact };
		// The sample-ID-only choice is offered for the legacy formats only, so it is saved only with them.
		if (tmpState.Envelope && (tmpState.Profile === 'Legacy-Classic' || tmpState.Profile === 'Legacy-SiteManager')) { tmpConfig.Envelope = tmpState.Envelope; }
		// Without explicit options every minter uses the materials app's shape (9 characters, 12-hour), so only write them when edited.
		if (tmpState.Profile === 'Legacy-SiteManager' && tmpState.SiteManagerOptionsSet)
		{
			tmpConfig.SiteManager = { MaxPrefixLength: Number(tmpState.SiteManagerMaxPrefix) || 9, HourFormat: (tmpState.SiteManagerHourFormat === '24') ? '24' : '12' };
		}
		return tmpConfig;
	}

	_computePreviews()
	{
		const tmpState = this.state;
		try
		{
			const tmpProfile = this._editedProfile();
			const tmpMinter = new libQRCode.QRCodeMinter();
			const tmpPrefix = this.currentUser.ExternalSyncGUID || `HL${Number(this.currentUser.UserID) || 0}`;
			const tmpContext = (tmpProfile.CodeFormat === 'SiteManager') ? { ExternalSyncGUID: tmpPrefix } : { IDProject: 0, IDUser: Number(this.currentUser.UserID) || 0 };
			const tmpCode = tmpMinter.mint(tmpProfile.CodeFormat, tmpContext, tmpProfile.SiteManager);
			const tmpCodec = new libQRCode.QRCodeCodec();
			tmpState.PreviewCode = tmpCode;
			tmpState.PreviewPayload = tmpCodec.encode({ Entity: 'Sample', Value: tmpCode }, { Envelope: tmpProfile.Envelope, Environment: libQRCode.Hosts.getEnvironmentFromHostname((typeof window !== 'undefined' && window.location) ? window.location.hostname : '') });
		}
		catch (pError)
		{
			tmpState.PreviewCode = '(preview unavailable)';
			tmpState.PreviewPayload = '';
		}
	}

	setTab(pTab)
	{
		this.state.Tab = ([ 'content', 'printing' ].includes(pTab)) ? pTab : 'format';
		this.render();
		if (this.state.Tab === 'content')
		{
			this._renderPreviewLater();
		}
	}

	async loadAsync()
	{
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Error = ''; tmpState.Message = '';
		this.render();
		try
		{
			if (this.isSuperUser())
			{
				const tmpCustomers = await this._getJSON('Customers/FilteredTo/FBV~Deleted~EQ~0~FSF~Name~ASC~0/0/2000');
				tmpState.Customers = Array.isArray(tmpCustomers) ? tmpCustomers.map((pC) => ({ IDCustomer: pC.IDCustomer, Name: pC.Name })) : [];
			}
			else { tmpState.Customers = []; }
			if (!tmpState.TargetCustomerID) { tmpState.TargetCustomerID = this.callerCustomer(); }
			await this._loadCustomerAsync(tmpState.TargetCustomerID);
			this._computePreviews();
			await this._loadContentAsync(tmpState.TargetCustomerID);
			tmpState.Loaded = true;
		}
		catch (pError)
		{
			tmpState.Error = `Could not load the QR-code configuration: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Loading = false;
			this.render();
		}
	}

	async _loadCustomerAsync(pIDCustomer)
	{
		const tmpState = this.state;
		const tmpRecord = pIDCustomer ? await this._getJSON(`Customer/${pIDCustomer}`) : null;
		tmpState.TargetCustomerName = (tmpRecord && tmpRecord.Name) ? tmpRecord.Name : '';
		const tmpProps = this._parseProps(tmpRecord);
		tmpState.Format = (tmpProps.CustomSampleGUID === LEGACY_TOKEN) ? 'SiteManager' : 'Standard';
		const tmpMap = pIDCustomer ? await this._getJSON(`Configuration/For/QRCodes/In/Customer/${pIDCustomer}`) : null;
		const tmpConfig = (tmpMap && tmpMap.Profile && typeof tmpMap.Profile === 'object') ? tmpMap.Profile : {};
		tmpState.ProfileConfigured = !!tmpConfig.Profile;
		tmpState.Profile = tmpConfig.Profile || 'Unconfigured';
		tmpState.AllowCompact = tmpConfig.AllowCompact === true;
		tmpState.Envelope = tmpConfig.Envelope || '';
		tmpState.SiteManagerOptionsSet = !!tmpConfig.SiteManager;
		tmpState.SiteManagerMaxPrefix = (tmpConfig.SiteManager && Number(tmpConfig.SiteManager.MaxPrefixLength)) || 9;
		tmpState.SiteManagerHourFormat = (tmpConfig.SiteManager && tmpConfig.SiteManager.HourFormat === '24') ? '24' : '12';
		const tmpPrinting = (tmpMap && tmpMap.Printing && typeof tmpMap.Printing === 'object') ? tmpMap.Printing : {};
		tmpState.PrintingConfigured = !!tmpPrinting.DefaultMediaPreset;
		tmpState.DefaultMediaPreset = tmpPrinting.DefaultMediaPreset || '';
		tmpState.PrintingMessage = '';
		tmpState.PrintingError = '';
		this._computePreviews();
	}

	// --- Label content: load the LIMS-Sample-Printable ManifestSchema for the target customer -----------------
	async _loadContentAsync(pIDCustomer)
	{
		const tmpState = this.state;
		tmpState._printableIDManifestSchema = 0;
		let tmpManifest = null;
		try
		{
			const tmpRows = await this._getJSON(`ManifestSchemas/FilteredTo/FBV~Type~EQ~RecordManifest~FBV~SubType~EQ~${PRINTABLE_SUBTYPE}/0/50`);
			const tmpRow = Array.isArray(tmpRows) ? tmpRows.find((pRow) => Number(pRow.IDCustomer) === Number(pIDCustomer)) : null;
			if (tmpRow)
			{
				tmpState._printableIDManifestSchema = tmpRow.IDManifestSchema;
				tmpManifest = (tmpRow.Manifest && typeof tmpRow.Manifest === 'object') ? tmpRow.Manifest
					: (typeof tmpRow.Manifest === 'string' ? JSON.parse(tmpRow.Manifest) : null);
			}
		}
		catch (pError) { /* fall through to defaults */ }

		if (tmpManifest && tmpManifest.Descriptors && Object.keys(tmpManifest.Descriptors).length)
		{
			tmpState.ContentTitle = tmpManifest.TitleTemplate || 'Sample';
			tmpState.PrintStyle = normalizePrintStyle(tmpManifest.PrintStyle);
			const tmpFields = Object.keys(tmpManifest.Descriptors).map((pKey) =>
			{
				const tmpDesc = tmpManifest.Descriptors[pKey] || {};
				const tmpField = { Key: pKey, Name: (typeof tmpDesc.Name === 'string') ? tmpDesc.Name : pKey, Row: Number(tmpDesc.Row) || 1, Column: Number(tmpDesc.Column) || 1 };
				if (tmpDesc.HeadlightPrintable && tmpDesc.HeadlightPrintable.DateFormat) { tmpField.DateFormat = tmpDesc.HeadlightPrintable.DateFormat; }
				return tmpField;
			});
			tmpFields.sort((pA, pB) => (pA.Row - pB.Row) || (pA.Column - pB.Column));
			tmpState.ContentFields = tmpFields;
		}
		else
		{
			tmpState.ContentTitle = 'Sample';
			tmpState.PrintStyle = 'wide';
			tmpState.ContentFields = DEFAULT_CONTENT_FIELDS.map((pField) => Object.assign({}, pField));
		}

		// A recent sample QR for the live preview (scoped to the caller's customer; best-effort).
		try
		{
			const tmpSamples = await this._getJSON('Samples/FilteredTo/FBV~Deleted~EQ~0~FSF~CreateDate~DESC~0/0/1');
			tmpState.PreviewSampleQR = (Array.isArray(tmpSamples) && tmpSamples.length && tmpSamples[0].QRCode) ? tmpSamples[0].QRCode : '';
		}
		catch (pError) { tmpState.PreviewSampleQR = ''; }
	}

	async selectCustomer(pIDCustomer)
	{
		const tmpState = this.state;
		tmpState.TargetCustomerID = Number(pIDCustomer) || 0;
		tmpState.Message = ''; tmpState.Error = ''; tmpState.ContentMessage = ''; tmpState.ContentError = '';
		if (tmpState.TargetCustomerID)
		{
			await this._loadCustomerAsync(tmpState.TargetCustomerID);
			await this._loadContentAsync(tmpState.TargetCustomerID);
		}
		this.render();
		if (tmpState.Tab === 'content') { this._renderPreviewLater(); }
	}

	// --- Format tab ------------------------------------------------------------------------------------------
	setProfile(pProfile)
	{
		const tmpKnown = PROFILE_CHOICES.some((pChoice) => pChoice.Value === pProfile);
		this.state.Profile = tmpKnown ? pProfile : 'Unconfigured';
		this.state.Message = '';
		this._computePreviews();
		this.render();
	}

	setProfileOption(pOption, pValue)
	{
		const tmpState = this.state;
		if (pOption === 'AllowCompact')
		{
			tmpState.AllowCompact = !!pValue;
		}
		else if (pOption === 'SampleIDOnly')
		{
			tmpState.Envelope = pValue ? 'Raw' : '';
		}
		else if (pOption === 'MaxPrefix')
		{
			tmpState.SiteManagerOptionsSet = true;
			tmpState.SiteManagerMaxPrefix = Math.max(1, Math.min(20, Number(pValue) || 9));
		}
		else if (pOption === 'HourFormat')
		{
			tmpState.SiteManagerOptionsSet = true;
			tmpState.SiteManagerHourFormat = (pValue === '24') ? '24' : '12';
		}
		tmpState.Message = '';
		this._computePreviews();
		this.render();
	}

	async save()
	{
		const tmpState = this.state;
		if (tmpState.Saving)
		{
			return;
		}
		if (!tmpState.TargetCustomerID)
		{
			tmpState.Error = 'Pick a customer first.';
			this.render();
			return;
		}
		if (tmpState.Profile === 'Unconfigured')
		{
			tmpState.Error = 'Choose a format to save.';
			this.render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Error = '';
		tmpState.Message = '';
		this.render();
		try
		{
			const tmpConfigResult = await this._postJSON(`Configuration/Put/QRCodes/Profile/Customer/${Number(tmpState.TargetCustomerID)}`, { Config: this._profileConfig() });
			if (tmpConfigResult && tmpConfigResult.error)
			{
				throw new Error(tmpConfigResult.error.message || String(tmpConfigResult.error));
			}
			// Older readers (the iPad materials app, sampleplan) still look at CustomSampleGUID; keep it in step.
			const tmpRecord = await this._getJSON(`Customer/${tmpState.TargetCustomerID}`);
			const tmpProps = this._parseProps(tmpRecord);
			const tmpWantsSiteManager = (tmpState.Profile === 'Legacy-SiteManager');
			if (tmpWantsSiteManager !== (tmpProps.CustomSampleGUID === LEGACY_TOKEN))
			{
				if (tmpWantsSiteManager)
				{
					tmpProps.CustomSampleGUID = LEGACY_TOKEN;
				}
				else
				{
					delete tmpProps.CustomSampleGUID;
				}
				const tmpResult = await this._putJSON('Customer', { IDCustomer: Number(tmpState.TargetCustomerID), CustomProperties: JSON.stringify(tmpProps) });
				if (tmpResult && tmpResult.error)
				{
					throw new Error(tmpResult.error.message || String(tmpResult.error));
				}
			}
			tmpState.Format = tmpWantsSiteManager ? 'SiteManager' : 'Standard';
			tmpState.ProfileConfigured = true;
			tmpState.Message = `Saved. New samples for ${tmpState.TargetCustomerName || 'this customer'} will use “${this._profileTitle(tmpState.Profile)}”. People already signed in pick it up when they next sign in.`;
		}
		catch (pError)
		{
			tmpState.Error = `Save failed: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.Saving = false;
			this.render();
		}
	}

	// --- Label content tab: editor ops -----------------------------------------------------------------------
	setContentTitle(pValue) { this.state.ContentTitle = pValue; }
	setPrintStyle(pStyle) { this.state.PrintStyle = normalizePrintStyle(pStyle); this.state.ContentMessage = ''; this.render(); this._renderPreviewLater(); }
	setFieldName(pIdx, pValue) { const tmpF = this.state.ContentFields[pIdx]; if (tmpF) { tmpF.Name = pValue; this._renderPreviewLater(); } }
	setFieldDateFormat(pIdx, pValue) { const tmpF = this.state.ContentFields[pIdx]; if (tmpF) { tmpF.DateFormat = pValue; this._renderPreviewLater(); } }
	setFieldRow(pIdx, pValue) { const tmpF = this.state.ContentFields[pIdx]; if (tmpF) { tmpF.Row = Math.max(1, Number(pValue) || 1); this._renderPreviewLater(); } }
	setFieldColumn(pIdx, pValue) { const tmpF = this.state.ContentFields[pIdx]; if (tmpF) { tmpF.Column = Math.max(1, Number(pValue) || 1); this._renderPreviewLater(); } }
	removeField(pIdx) { this.state.ContentFields.splice(pIdx, 1); this.state.ContentMessage = ''; this.render(); this._renderPreviewLater(); }
	addField(pKey)
	{
		const tmpPalette = PALETTE_BY_KEY[pKey];
		if (!tmpPalette) { return; }
		if (this.state.ContentFields.some((pF) => pF.Key === pKey)) { return; }
		const tmpMaxRow = this.state.ContentFields.reduce((pMax, pF) => Math.max(pMax, Number(pF.Row) || 1), 0);
		this.state.ContentFields.push({ Key: pKey, Name: tmpPalette.Name, Row: tmpMaxRow + 1, Column: 1 });
		this.state.ContentMessage = '';
		this.render();
		this._renderPreviewLater();
	}

	/** Build the printable manifest (typeConfig['Sample'] shape) from the editor state. */
	_buildManifest()
	{
		const tmpState = this.state;
		const tmpDescriptors = {};
		for (const tmpField of tmpState.ContentFields)
		{
			const tmpPalette = PALETTE_BY_KEY[tmpField.Key] || {};
			const tmpDescriptor = { Hash: tmpField.Key, Name: (typeof tmpField.Name === 'string') ? tmpField.Name.trim() : tmpField.Key, Row: Number(tmpField.Row) || 1, Column: Number(tmpField.Column) || 1 };
			if (tmpPalette.DataType) { tmpDescriptor.DataType = tmpPalette.DataType; }
			if (tmpPalette.HeadlightPrintable) { tmpDescriptor.HeadlightPrintable = Object.assign({}, tmpPalette.HeadlightPrintable); }
			if (tmpPalette.DataType === 'DateTime' && tmpField.DateFormat) { tmpDescriptor.HeadlightPrintable = Object.assign(tmpDescriptor.HeadlightPrintable || {}, { DateFormat: tmpField.DateFormat }); }
			tmpDescriptors[tmpField.Key] = tmpDescriptor;
		}
		return { Scope: 'Sample-Printable', TitleTemplate: tmpState.ContentTitle || 'Sample', PrintStyle: normalizePrintStyle(tmpState.PrintStyle), Descriptors: tmpDescriptors };
	}

	async saveContent()
	{
		const tmpState = this.state;
		if (tmpState.ContentSaving) { return; }
		if (!tmpState.TargetCustomerID) { tmpState.ContentError = 'Pick a customer first.'; this.render(); return; }
		if (!tmpState.ContentFields.length) { tmpState.ContentError = 'Add at least one field to the label.'; this.render(); return; }
		tmpState.ContentSaving = true; tmpState.ContentError = ''; tmpState.ContentMessage = '';
		this.render();
		try
		{
			const tmpManifest = this._buildManifest();
			let tmpResult;
			if (tmpState._printableIDManifestSchema)
			{
				tmpResult = await this._putJSON('ManifestSchema', { IDManifestSchema: Number(tmpState._printableIDManifestSchema), Manifest: tmpManifest });
			}
			else
			{
				tmpResult = await this._postJSON('ManifestSchema',
				{
					Hash: PRINTABLE_SUBTYPE, Type: 'RecordManifest', SubType: PRINTABLE_SUBTYPE, Title: PRINTABLE_SUBTYPE,
					Version: 1, IDCustomer: Number(tmpState.TargetCustomerID), Manifest: tmpManifest,
				});
				const tmpNew = tmpResult && tmpResult.result;
				if (tmpNew && tmpNew.IDManifestSchema) { tmpState._printableIDManifestSchema = tmpNew.IDManifestSchema; }
			}
			if (tmpResult && tmpResult.error) { throw new Error(tmpResult.error.message || String(tmpResult.error)); }
			// Apply to the live QRCodeProvider so Print Label reflects it immediately.
			if (this.qrProvider && typeof this.qrProvider.addManifestForType === 'function') { this.qrProvider.addManifestForType('Sample', tmpManifest); }
			tmpState.ContentMessage = 'Saved. Printed sample labels will show this content.';
		}
		catch (pError) { tmpState.ContentError = `Save failed: ${(pError && pError.message) || pError}`; }
		finally { tmpState.ContentSaving = false; this.render(); this._renderPreviewLater(); }
	}

	/** Render a live label preview into #SQR-Preview using a real sample + the current (unsaved) manifest. */
	_renderPreviewLater() { setTimeout(() => { this.renderPreview(); }, 30); }
	async renderPreview()
	{
		const tmpState = this.state;
		const tmpContainer = (typeof document !== 'undefined') ? document.querySelector('#SQR-Preview') : null;
		if (!tmpContainer) { return; }
		if (!tmpState.PreviewSampleQR) { tmpContainer.innerHTML = '<div class="sqr-preview-empty">No sample available to preview a label.</div>'; return; }
		const tmpQR = this.qrProvider;
		if (!tmpQR || typeof tmpQR.printDecoratedEntity !== 'function') { tmpContainer.innerHTML = '<div class="sqr-preview-empty">Label preview is not available.</div>'; return; }
		const tmpTypeConfig = tmpQR.typeConfig || {};
		const tmpSavedManifest = tmpTypeConfig.Sample;
		const tmpSavedEnsured = tmpQR._PrintableManifestsEnsured;
		const tmpPreviewManifest = this._buildManifest();
		try
		{
			// Apply the CURRENT (possibly unsaved) manifest so the preview reflects the edits in progress.
			if (typeof tmpQR.addManifestForType === 'function')
			{
				tmpQR.addManifestForType('Sample', tmpPreviewManifest);
			}
			tmpQR._PrintableManifestsEnsured = true;   // don't let a lazy load clobber the applied manifest
			await tmpQR.printDecoratedEntity('Sample', tmpState.PreviewSampleQR, 'SQR-Preview');
		}
		catch (pError) { tmpContainer.innerHTML = `<div class="sqr-preview-empty">Could not render the preview: ${this._esc((pError && pError.message) || pError)}</div>`; }
		finally
		{
			// Labels printed elsewhere in the app keep the saved layout until Save (which applies its own).
			if (tmpQR.typeConfig && (tmpQR.typeConfig.Sample === tmpPreviewManifest))
			{
				if (tmpSavedManifest)
				{
					tmpQR.typeConfig.Sample = tmpSavedManifest;
				}
				else
				{
					delete tmpQR.typeConfig.Sample;
				}
			}
			tmpQR._PrintableManifestsEnsured = tmpSavedEnsured;
		}
	}

	// --- render ----------------------------------------------------------------------------------------------
	render()
	{
		if (!this.pict.views.SampleQRCodeConfig) { return; }
		const tmpState = this.state;
		if (!this.can())
		{
			this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, `<div class="sqr-empty">You don’t have the <strong>Configure sample QR codes</strong> entitlement.</div>`);
			return;
		}
		if (tmpState.Loading && !tmpState.Loaded) { this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, '<div class="sqr-empty"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>'); return; }

		const tmpCustomerPicker = this.isSuperUser()
			? `<div class="sqr-field"><label class="sqr-field-label">Customer</label>
				<select class="sqr-select" onchange="_Pict.providers.SampleQRCodeConfig.selectCustomer(this.value)">
					${(tmpState.Customers || []).map((pC) => `<option value="${pC.IDCustomer}" ${Number(pC.IDCustomer) === Number(tmpState.TargetCustomerID) ? 'selected' : ''}>${this._esc(pC.Name)} (#${pC.IDCustomer})</option>`).join('')}
				</select></div>`
			: `<div class="sqr-field"><label class="sqr-field-label">Customer</label><div class="sqr-customer">${this._esc(tmpState.TargetCustomerName || ('#' + tmpState.TargetCustomerID))}</div></div>`;

		const tmpTabs = `<div class="sqr-tabs">
			<button class="sqr-tab${tmpState.Tab === 'format' ? ' is-active' : ''}" onclick="_Pict.providers.SampleQRCodeConfig.setTab('format')">QR format</button>
			<button class="sqr-tab${tmpState.Tab === 'content' ? ' is-active' : ''}" onclick="_Pict.providers.SampleQRCodeConfig.setTab('content')">Label content</button>
			<button class="sqr-tab${tmpState.Tab === 'printing' ? ' is-active' : ''}" onclick="_Pict.providers.SampleQRCodeConfig.setTab('printing')">Printing</button>
		</div>`;

		let tmpBody = this._formatHTML();
		if (tmpState.Tab === 'content')
		{
			tmpBody = this._contentHTML();
		}
		else if (tmpState.Tab === 'printing')
		{
			tmpBody = this._printingHTML();
		}
		this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, `${tmpCustomerPicker}${tmpTabs}${tmpBody}`);
	}

	_formatHTML()
	{
		const tmpState = this.state;
		const tmpMsg = tmpState.Message ? `<div class="sqr-msg">${this._esc(tmpState.Message)}</div>` : '';
		const tmpErr = tmpState.Error ? `<div class="sqr-error">${this._esc(tmpState.Error)}</div>` : '';
		const tmpCurrent = tmpState.ProfileConfigured ? '' : `<div class="sqr-note"><i class="fas fa-circle-info"></i> No format has been chosen for this customer yet, so new samples use “${this._esc(this._profileTitle(this._unconfiguredProfile().Name))}”. Choosing one here makes it explicit.</div>`;
		const tmpOptions = PROFILE_CHOICES.map((pChoice) => this._optionHTML(pChoice.Value, tmpState.Profile === pChoice.Value, pChoice.Title, pChoice.Description)).join('');
		const tmpSiteManager = (tmpState.Profile === 'Legacy-SiteManager')
			? `<div class="sqr-field"><label class="sqr-field-label">SiteManager id length</label>
					<input class="sqr-input sqr-rcnum" type="number" min="1" max="20" value="${Number(tmpState.SiteManagerMaxPrefix) || 9}" onchange="_Pict.providers.SampleQRCodeConfig.setProfileOption('MaxPrefix', this.value)"> characters at most</div>
				<div class="sqr-field"><label class="sqr-field-label">Clock</label>
					<select class="sqr-select" onchange="_Pict.providers.SampleQRCodeConfig.setProfileOption('HourFormat', this.value)">
						<option value="12" ${tmpState.SiteManagerHourFormat !== '24' ? 'selected' : ''}>12-hour (materials app)</option>
						<option value="24" ${tmpState.SiteManagerHourFormat === '24' ? 'selected' : ''}>24-hour</option>
					</select></div>`
			: '';
		const tmpSampleIDOnly = (tmpState.Profile === 'Legacy-Classic' || tmpState.Profile === 'Legacy-SiteManager')
			? `<div class="sqr-field"><label class="sqr-option-desc"><input type="checkbox" ${tmpState.Envelope === 'Raw' ? 'checked' : ''} onclick="_Pict.providers.SampleQRCodeConfig.setProfileOption('SampleIDOnly', this.checked)"> Put only the sample ID in the code, as the Materials app does. A phone camera then shows the ID instead of opening the sample.</label></div>`
			: '';
		const tmpCompact = (tmpState.Profile === 'Standard')
			? `<div class="sqr-field"><label class="sqr-option-desc"><input type="checkbox" ${tmpState.AllowCompact ? 'checked' : ''} onclick="_Pict.providers.SampleQRCodeConfig.setProfileOption('AllowCompact', this.checked)"> Print short labels (fit small stickers). Turn on only once every scanner this customer uses has been updated.</label></div>`
			: '';
		return `${tmpErr}${tmpMsg}${tmpCurrent}
			<div class="sqr-field-label">QR code format</div>
			<div class="sqr-options">${tmpOptions}</div>
			${tmpSiteManager}${tmpSampleIDOnly}${tmpCompact}
			<div class="sqr-option-preview"><span class="sqr-preview-label">Example code</span> <code>${this._esc(tmpState.PreviewCode || '')}</code></div>
			<div class="sqr-option-preview"><span class="sqr-preview-label">Printed as</span> <code>${this._esc(tmpState.PreviewPayload || '')}</code></div>
			<div class="sqr-note"><i class="fas fa-circle-info"></i> The example is generated by the same code new samples use. The SiteManager id comes from each sampler’s SiteManager id (<code>ExternalSyncGUID</code>), falling back to <code>HL&lt;user id&gt;</code>.</div>
			<div class="sqr-savebar"><button class="sqr-save" ${tmpState.Saving ? 'disabled' : ''} onclick="_Pict.providers.SampleQRCodeConfig.save()">${tmpState.Saving ? 'Saving…' : 'Save QR format'}</button></div>`;
	}

	// --- Printing tab: the customer's default label stock (QRCodes/Printing configuration) ------------------
	/** @return {Array<{ Id: string, Name: string }>} the label stocks the print dialog offers */
	_mediaPresets()
	{
		const tmpHL = this.pict.providers.HeadlightQR;
		return (tmpHL && typeof tmpHL.getMediaPresets === 'function') ? tmpHL.getMediaPresets() : [];
	}

	setDefaultMediaPreset(pPresetID)
	{
		this.state.DefaultMediaPreset = this._mediaPresets().some((pPreset) => pPreset.Id === pPresetID) ? pPresetID : '';
		this.state.PrintingMessage = '';
		this.state.PrintingError = '';
		this.render();
	}

	async savePrinting()
	{
		const tmpState = this.state;
		if (tmpState.PrintingSaving)
		{
			return;
		}
		if (!tmpState.TargetCustomerID || !tmpState.DefaultMediaPreset)
		{
			tmpState.PrintingError = !tmpState.TargetCustomerID ? 'Pick a customer first.' : 'Choose a label stock to save.';
			this.render();
			return;
		}
		tmpState.PrintingSaving = true;
		tmpState.PrintingError = '';
		tmpState.PrintingMessage = '';
		this.render();
		try
		{
			const tmpResult = await this._postJSON(`Configuration/Put/QRCodes/Printing/Customer/${Number(tmpState.TargetCustomerID)}`, { Config: { DefaultMediaPreset: tmpState.DefaultMediaPreset } });
			if (tmpResult && tmpResult.error)
			{
				throw new Error(tmpResult.error.message || String(tmpResult.error));
			}
			tmpState.PrintingConfigured = true;
			if ((Number(tmpState.TargetCustomerID) === this.callerCustomer()) && this.pict.providers.HeadlightQR)
			{
				this.pict.providers.HeadlightQR.setCustomerPrintSettings({ DefaultMediaPreset: tmpState.DefaultMediaPreset });
			}
			tmpState.PrintingMessage = `Saved. Print uses this label stock for ${tmpState.TargetCustomerName || 'this customer'}, except on devices where someone picked a different stock in Print options. Apps already open pick it up when they are reloaded.`;
		}
		catch (pError)
		{
			tmpState.PrintingError = `Save failed: ${(pError && pError.message) || pError}`;
		}
		finally
		{
			tmpState.PrintingSaving = false;
			this.render();
		}
	}

	_printingHTML()
	{
		const tmpState = this.state;
		const tmpPresets = this._mediaPresets();
		const tmpHL = this.pict.providers.HeadlightQR;
		const tmpAppDefaultName = ((tmpHL && tmpPresets.find((pPreset) => pPreset.Id === tmpHL.options.DefaultMediaPreset)) || {}).Name || '';
		const tmpMsg = tmpState.PrintingMessage ? `<div class="sqr-msg">${this._esc(tmpState.PrintingMessage)}</div>` : '';
		const tmpErr = tmpState.PrintingError ? `<div class="sqr-error">${this._esc(tmpState.PrintingError)}</div>` : '';
		const tmpCurrent = tmpState.PrintingConfigured ? '' : `<div class="sqr-note"><i class="fas fa-circle-info"></i> No label stock has been chosen for this customer yet, so Print uses “${this._esc(tmpAppDefaultName || 'the first stock in the list')}”.</div>`;
		const tmpOptions = [ `<option value="" ${tmpState.DefaultMediaPreset ? '' : 'selected'} disabled>Choose a label stock</option>` ]
			.concat(tmpPresets.map((pPreset) => `<option value="${this._esc(pPreset.Id)}" ${pPreset.Id === tmpState.DefaultMediaPreset ? 'selected' : ''}>${this._esc(pPreset.Name)}</option>`)).join('');
		return `${tmpErr}${tmpMsg}${tmpCurrent}
			<div class="sqr-field"><label class="sqr-field-label">Default label stock</label>
				<select class="sqr-select" onchange="_Pict.providers.SampleQRCodeConfig.setDefaultMediaPreset(this.value)">${tmpOptions}</select></div>
			<div class="sqr-note"><i class="fas fa-circle-info"></i> Print sends labels straight to the printer on this stock. Print options lets someone pick another stock and see the label first; their choice is remembered on that device only.</div>
			<div class="sqr-savebar"><button class="sqr-save" ${tmpState.PrintingSaving ? 'disabled' : ''} onclick="_Pict.providers.SampleQRCodeConfig.savePrinting()">${tmpState.PrintingSaving ? 'Saving…' : 'Save label stock'}</button></div>`;
	}

	_optionHTML(pValue, pActive, pTitle, pDesc)
	{
		return `<label class="sqr-option${pActive ? ' is-active' : ''}">
			<input type="radio" name="sqr-format" ${pActive ? 'checked' : ''} onclick="_Pict.providers.SampleQRCodeConfig.setProfile('${pValue}')">
			<div class="sqr-option-body">
				<div class="sqr-option-title">${this._esc(pTitle)}</div>
				<div class="sqr-option-desc">${this._esc(pDesc)}</div>
			</div>
		</label>`;
	}

	_contentHTML()
	{
		const tmpState = this.state;
		const tmpMsg = tmpState.ContentMessage ? `<div class="sqr-msg">${this._esc(tmpState.ContentMessage)}</div>` : '';
		const tmpErr = tmpState.ContentError ? `<div class="sqr-error">${this._esc(tmpState.ContentError)}</div>` : '';
		const tmpUsedKeys = {};
		const tmpRows = tmpState.ContentFields.map((pField, pIdx) =>
		{
			tmpUsedKeys[pField.Key] = true;
			const tmpPalette = PALETTE_BY_KEY[pField.Key];
			const tmpDateFormat = pField.DateFormat || (tmpPalette && tmpPalette.HeadlightPrintable && tmpPalette.HeadlightPrintable.DateFormat) || DATE_FORMATS[0].Value;
			const tmpDateHTML = (tmpPalette && tmpPalette.DataType === 'DateTime')
				? `<select class="sqr-input sqr-datefmt" title="Date format" onchange="_Pict.providers.SampleQRCodeConfig.setFieldDateFormat(${pIdx}, this.value)">${DATE_FORMATS.map((pFormat) => `<option value="${this._esc(pFormat.Value)}" ${pFormat.Value === tmpDateFormat ? 'selected' : ''}>${this._esc(pFormat.Example)}</option>`).join('')}</select>`
				: '';
			return `<div class="sqr-fieldrow">
				<span class="sqr-fieldkey">${this._esc(PALETTE_BY_KEY[pField.Key] ? PALETTE_BY_KEY[pField.Key].Key : pField.Key)}</span>
				<input class="sqr-input sqr-fieldname" value="${this._esc(pField.Name)}" oninput="_Pict.providers.SampleQRCodeConfig.setFieldName(${pIdx}, this.value)" placeholder="No label (value only)">
				${tmpDateHTML}
				<label class="sqr-rc">Row <input class="sqr-input sqr-rcnum" type="number" min="1" value="${Number(pField.Row) || 1}" onchange="_Pict.providers.SampleQRCodeConfig.setFieldRow(${pIdx}, this.value)"></label>
				${tmpState.PrintStyle === 'wide' ? `<label class="sqr-rc">Col <input class="sqr-input sqr-rcnum" type="number" min="1" max="2" value="${Number(pField.Column) || 1}" onchange="_Pict.providers.SampleQRCodeConfig.setFieldColumn(${pIdx}, this.value)"></label>` : ''}
				<button class="sqr-fieldremove" title="Remove" onclick="_Pict.providers.SampleQRCodeConfig.removeField(${pIdx})"><i class="fas fa-times"></i></button>
			</div>`;
		}).join('');
		const tmpAvail = FIELD_PALETTE.filter((pField) => !tmpUsedKeys[pField.Key]);
		const tmpAvailHTML = tmpAvail.length
			? tmpAvail.map((pField) => `<button class="sqr-avail" onclick="_Pict.providers.SampleQRCodeConfig.addField('${pField.Key}')" title="${this._esc(pField.Key)}"><i class="fas fa-plus"></i> ${this._esc(pField.Name)}</button>`).join('')
			: '<span class="sqr-avail-empty">All available fields are on the label.</span>';

		return `${tmpErr}${tmpMsg}
			<div class="sqr-field"><label class="sqr-field-label">Label title</label>
				<input class="sqr-input" style="max-width:20rem" value="${this._esc(tmpState.ContentTitle)}" oninput="_Pict.providers.SampleQRCodeConfig.setContentTitle(this.value)" placeholder="Sample"></div>
			<div class="sqr-field"><label class="sqr-field-label">Layout</label>
				<div class="sqr-styletoggle">
					<button class="sqr-stylebtn${tmpState.PrintStyle === 'thin' ? ' is-active' : ''}" onclick="_Pict.providers.SampleQRCodeConfig.setPrintStyle('thin')">Thin (1 column)</button>
					<button class="sqr-stylebtn${tmpState.PrintStyle === 'wide' ? ' is-active' : ''}" onclick="_Pict.providers.SampleQRCodeConfig.setPrintStyle('wide')">Wide (2 columns)</button>
					<button class="sqr-stylebtn${tmpState.PrintStyle === 'tall' ? ' is-active' : ''}" onclick="_Pict.providers.SampleQRCodeConfig.setPrintStyle('tall')">Large code (1 column)</button>
				</div>
				${tmpState.PrintStyle === 'tall' ? '<div class="sqr-note"><i class="fas fa-circle-info"></i> The code takes most of the label’s width, with the lines below it in one size. A long value wraps onto up to three lines.</div>' : ''}</div>
			<div class="sqr-field-label">Fields on the label</div>
			<div class="sqr-fields">${tmpRows || '<div class="sqr-avail-empty">No fields yet — add some below.</div>'}</div>
			<div class="sqr-field-label" style="margin-top:0.8rem">Add a field</div>
			<div class="sqr-availwrap">${tmpAvailHTML}</div>
			<div class="sqr-preview-wrap"><div class="sqr-field-label">Label preview</div><div id="SQR-Preview" class="sqr-preview"></div></div>
			<div class="sqr-savebar"><button class="sqr-save" ${tmpState.ContentSaving ? 'disabled' : ''} onclick="_Pict.providers.SampleQRCodeConfig.saveContent()">${tmpState.ContentSaving ? 'Saving…' : 'Save label content'}</button></div>`;
	}
}

module.exports = SampleQRCodeConfigProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'SampleQRCodeConfig',
	AutoInitialize: true,
	AutoInitializeOrdinal: 231,
};

},{"headlight-qrcode":19,"pict-provider":845}],1374:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

/**
 * Routes whose screen is a record form being filled in. A scan never navigates away from one of these.
 *
 * @type {Array<RegExp>}
 */
const FORM_ROUTE_PATTERNS =
[
	/^#\/PSRS\/[^/]+\/(Create|Edit)(\/|$)/,
];

/**
 * Where a found record opens, per entity. A target returns a hash route, or null to leave the scan to the
 * handlers below (the panels' default opens Sample Details).
 *
 * @type {Record<string, (pRecord: Record<string, any>) => string|null>}
 */
const DEFAULT_TARGETS =
{
	Sample: (pRecord) => (pRecord.IDSample ? `#/Sample/Workspace/${pRecord.IDSample}` : null),
	Location: (pRecord) => (pRecord.IDLocation ? `#/Location/Workspace/${pRecord.IDLocation}` : null),
};

/**
 * Scan to open: a keyboard or camera scan of a record's code opens that record's screen, except while a form
 * is being filled in, where it says so and stays put.
 *
 * Off by default. An app that wants it calls `enable()` after the panels have registered their default scan
 * handler, so this one sees scans first; an open Scan Samples panel or cart still takes scans ahead of it.
 */
class ScanToOpenProvider extends libPictProvider
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		/** @type {(() => void)|null} */
		this._removeScanHandler = null;
		this.targets = Object.assign({}, DEFAULT_TARGETS);
	}

	/**
	 * @return {boolean}
	 */
	isEnabled()
	{
		return !!this._removeScanHandler;
	}

	/**
	 * Start opening scanned records.
	 *
	 * @param {Record<string, (pRecord: Record<string, any>) => string|null>} [pTargets] - added to or replacing the default targets
	 * @return {boolean} whether the handler is registered
	 */
	enable(pTargets)
	{
		this.targets = Object.assign({}, DEFAULT_TARGETS, pTargets || {});
		if (this._removeScanHandler)
		{
			return true;
		}
		const tmpQR = this.pict.providers.HeadlightQR;
		if (!tmpQR || (typeof tmpQR.pushScanHandler !== 'function'))
		{
			return false;
		}
		this._removeScanHandler = tmpQR.pushScanHandler(
			{
				Hash: 'scan-to-open',
				Mode: 'GoTo',
				// A bare label code (no entity prefix) is looked up as each target entity in turn, so location labels open too.
				RawEntities: Object.keys(this.targets),
				onScan: (pResolution) => this.handleResolution(pResolution),
			});
		return true;
	}

	/**
	 * Stop opening scanned records.
	 */
	disable()
	{
		if (this._removeScanHandler)
		{
			this._removeScanHandler();
			this._removeScanHandler = null;
		}
	}

	/**
	 * @param {{ Status: string, Entity?: string, Record?: Record<string, any> }} pResolution
	 * @return {string|null} the route a found record opens, or null when this handler doesn't open it
	 */
	getTargetRoute(pResolution)
	{
		if (!pResolution || (pResolution.Status !== 'Found'))
		{
			return null;
		}
		const fTarget = this.targets[pResolution.Entity];
		if (typeof fTarget !== 'function')
		{
			return null;
		}
		return fTarget(pResolution.Record || {}) || null;
	}

	/**
	 * Is a form being filled in? Either the route is a create or edit form, the sample workspace is in edit or
	 * create mode on a sample route, or a document open in the document frames has unsaved work.
	 *
	 * @return {boolean}
	 */
	isEditingForm()
	{
		const tmpHash = this._currentHash();
		if (FORM_ROUTE_PATTERNS.some((pPattern) => pPattern.test(tmpHash)))
		{
			return true;
		}
		const tmpSampleWorkspace = this.pict.providers.SampleWorkspace;
		if (tmpSampleWorkspace && tmpSampleWorkspace.isEditing && /^#\/(Sample\/Workspace|PSRS\/Sample)\//.test(tmpHash))
		{
			return true;
		}
		const tmpFrames = this.pict.providers.DocumentFrameSwitcher;
		return !!(tmpFrames && (typeof tmpFrames.hasUnsavedWork === 'function') && tmpFrames.hasUnsavedWork());
	}

	/**
	 * The scan handler.
	 *
	 * @param {{ Status: string, Entity?: string, Record?: Record<string, any> }} pResolution
	 * @return {boolean} true when the scan was handled here
	 */
	handleResolution(pResolution)
	{
		const tmpUser = this.pict.AppData && this.pict.AppData.CurrentUser;
		if (!tmpUser || !tmpUser.LoggedIn)
		{
			return false;
		}
		const tmpRoute = this.getTargetRoute(pResolution);
		if (!tmpRoute)
		{
			return false;
		}
		if (this.isEditingForm())
		{
			const tmpRecord = pResolution.Record || {};
			this._toast(`Scanned ${tmpRecord.Name || tmpRecord.QRCode || 'a record'}. Save or cancel this form first, then scan it again to open it.`, 'is-warning');
			return true;
		}
		if (this._currentHash() !== tmpRoute)
		{
			this._navigate(tmpRoute);
		}
		return true;
	}

	/**
	 * @return {string}
	 */
	_currentHash()
	{
		return (typeof window !== 'undefined') ? String(window.location.hash || '') : '';
	}

	/**
	 * @param {string} pRoute
	 */
	_navigate(pRoute)
	{
		window.location.hash = pRoute;
	}

	/**
	 * @param {string} pMessage
	 * @param {string} pType
	 */
	_toast(pMessage, pType)
	{
		const tmpPanels = this.pict.views.HeadlightPanels;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast({ message: pMessage, type: pType });
		}
	}
}

module.exports = ScanToOpenProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'ScanToOpen',
	AutoInitialize: false,
};
module.exports.FORM_ROUTE_PATTERNS = FORM_ROUTE_PATTERNS;
module.exports.DEFAULT_TARGETS = DEFAULT_TARGETS;

},{"pict-provider":845}],1375:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libUserSearch = require('../access/User-Search.js');

const BODY_MOUNT = '#SUG-Body';
const SEARCH_MOUNT = '#SUG-Search';
const RESULTS_MOUNT = '#SUG-Results';
const DETAIL_MOUNT = '#SUG-Detail';
const PICKER_HASH = 'SUG-CustomerPicker';
const PICKER_MOUNT = '#SUG-CustomerPicker';

const GRANT_HASH = 'Permission-Grant';

// Elevating a user to "can manage configuration for their customer". The api/config write gate
// (_hasCustomerScopedConfigWriteAccess) passes for anyone holding a role/group whose PermissionLevel is
// 'CustomerAdmin' — it never inspects individual permission grants. So this tool find-or-creates a managed,
// per-customer Permission Group that carries that PermissionLevel and assigns it to the user. No server change:
// the user's session then carries a PermissionLevel === 'CustomerAdmin' entry and the config gate passes.
const CONFIG_ADMIN_LEVEL = 'CustomerAdmin';
const CONFIG_ADMIN_GROUP_NAME = 'Customer Config Admin';

// User.IDRole is the base permission LEVEL (0-5) — the strongest "likely config admin" signal. Names mirror the
// legacy user admin (RoleSelector.vue); shown on the "all users" list and used to rank it (seniors first).
const USER_LEVEL_NAMES = { 0: 'Read Only', 1: 'Field Personnel', 2: 'Office Staff', 3: 'Office Manager', 4: 'Executive Manager', 5: 'Pavia Administrator' };

/**
 * SuperUserGrant — provider behind the #/GrantAccess screen (a bespoke, platform-super-user-only bootstrap tool).
 *
 * What it does:
 *   1. Searches ALL users across every customer (a super-user's Meadow queries are not customer-scoped) by name or
 *      email — three parallel LIKE queries merged and de-duplicated.
 *   2. Grants a selected user `Permission-Grant`, scoped to that user's OWN customer, via the direct grant-to-user
 *      endpoint: GET Permissions/Grant/Permission-Grant/To/User/<IDUser>/For/Customer/<IDCustomer>. That writes a
 *      single UserPermission override row (idempotent). Revoking deletes that row (a clean reset to the default).
 *
 * Everything is gated to a customer-1 / role-index-5 super-user client-side; the server is authoritative (its own
 * grant handler re-checks that the caller holds Permission-Grant in the target context, which a super-user does).
 *
 * Render model mirrors Entitlements-Provider: hand-built HTML assigned into mounts. The search <input> is built
 * ONCE into #SUG-Body and never re-assigned, so keystroke re-renders (which only touch #SUG-Results / #SUG-Detail)
 * don't steal focus from it.
 */
class SuperUserGrantProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._pickerBuilt = false;
		this._customerPicker = null;
		this._searchTimer = null;
		this._searchToken = 0;
	}

	get app() { return this.pict.PictApplication; }
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get state()
	{
		if (!this.pict.AppData.SuperUserGrant)
		{
			this.pict.AppData.SuperUserGrant =
			{
				Loaded: false, Loading: false, CustomersByID: {},
				Query: '', Searching: false, Results: [], CustomerFilter: null,
				SelectedUser: null, GrantLoading: false, GrantRecord: null,
				ConfigAdminLoading: false, ConfigAdminGroup: null, ConfigAdminHeld: null,
				Busy: false, Error: '', Notice: '',
				ShowingAll: false, ListLoading: false, ListedCustomer: null,
			};
		}
		return this.pict.AppData.SuperUserGrant;
	}

	/** Customer-1 / role-index-5 super-user — the only session allowed to use this tool. Server stays authoritative. */
	isAuthorized()
	{
		if (this.app && typeof this.app._isSuperUser === 'function') { return this.app._isSuperUser(); }
		const tmpUser = this.pict.AppData.CurrentUser;
		return !!(tmpUser && (Number(tmpUser.UserRoleIndex) === 5) && (Number(tmpUser.CustomerID) === 1));
	}

	_getJSON(pURL) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.getJSON(pURL, (pErr, pBody) => resolve(pErr ? null : pBody))) : Promise.resolve(null); }
	_postJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.postJSON(pURL, pBody, (pErr, pB) => resolve(pErr ? null : pB))) : Promise.resolve(null); }
	_putJSON(pURL, pBody) { const tmpRC = this.restClient; return tmpRC ? new Promise((resolve) => tmpRC.putJSON(pURL, pBody, (pErr, pB) => resolve(pErr ? null : pB))) : Promise.resolve(null); }

	// ── Load (customer name map, for display) ────────────────────────────────────

	loadAsync()
	{
		const tmpState = this.state;
		if (tmpState.Loading || !this.isAuthorized()) { return; }
		tmpState.Loading = true;
		this._getJSON('Customers/0/2000').then((pCustomers) =>
		{
			const tmpMap = {};
			(Array.isArray(pCustomers) ? pCustomers : []).forEach((pCustomer) =>
			{
				if (pCustomer && (pCustomer.IDCustomer != null)) { tmpMap[Number(pCustomer.IDCustomer)] = pCustomer.Name || pCustomer.CustomerName || ''; }
			});
			tmpState.CustomersByID = tmpMap;
			tmpState.Loaded = true;
			tmpState.Loading = false;
			this.render();
		});
	}

	_customerName(pIDCustomer)
	{
		const tmpName = this.state.CustomersByID[Number(pIDCustomer)];
		return tmpName ? `${tmpName} (#${Number(pIDCustomer)})` : `Customer #${Number(pIDCustomer)}`;
	}

	// ── Search (three parallel LIKE queries, merged) ─────────────────────────────

	onSearchInput(pValue)
	{
		const tmpState = this.state;
		tmpState.Query = String(pValue == null ? '' : pValue);
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(() => { this._searchTimer = null; this.search(); }, 250);
	}

	/** Scope the search to a customer (or clear back to all). Fired by the customer picker's OnChange. */
	onCustomerChange(pValue)
	{
		const tmpState = this.state;
		tmpState.CustomerFilter = (pValue === null || pValue === undefined || pValue === '' || (Number(pValue) === 0)) ? null : Number(pValue);
		this.search();
	}

	/**
	 * Pre-scope the search to one customer — the deep-link entry point from the Customers screen's
	 * "grant one in Grants first" action (#/GrantAccess/:IDCustomer). Sets the filter and syncs the
	 * customer picker so the super-user lands with that customer already selected.
	 * @param {number} pIDCustomer
	 */
	applyCustomerScope(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer);
		if (!tmpID) { return; }
		this.state.CustomerFilter = tmpID;
		// Not loaded yet → loadAsync()'s render builds the picker already honoring state.CustomerFilter.
		if (!this.state.Loaded && !this.state.Loading) { this.loadAsync(); }
		// Already loaded → push the value into the existing picker.
		else if (this._customerPicker && (typeof this._customerPicker.setValue === 'function')) { this._customerPicker.setValue(tmpID); }
		// Auto-list this customer's users (most likely admins first) so setup needs no name-guessing.
		this.loadCustomerUsers();
	}

	/**
	 * Load every (non-deleted) user in the scoped customer, ranked most-likely-admin first (senior base level,
	 * then most recently active), so a super-user can pick the config admin without knowing a name. No-op without
	 * a customer scope. Cached per customer; re-fetches when the scope changes.
	 */
	loadCustomerUsers()
	{
		const tmpState = this.state;
		if (!this.isAuthorized() || !tmpState.CustomerFilter) { return; }
		const tmpID = Number(tmpState.CustomerFilter);
		tmpState.ShowingAll = true;
		// Already have this customer's list loaded → just show it (no refetch).
		if ((Number(tmpState.ListedCustomer) === tmpID) && tmpState.Results.length && !tmpState.ListLoading) { this.render(); return; }
		tmpState.ListLoading = true;
		tmpState.Results = [];
		this.render();
		const tmpToken = ++this._searchToken;   // supersede any in-flight keystroke search
		// Server-sort by base level DESC so the cap keeps the seniors on large customers; refined client-side below.
		this._getJSON(`Users/FilteredTo/FBV~IDCustomer~EQ~${tmpID}~FBV~Deleted~EQ~0~FSF~IDRole~DESC~0/0/200`).then((pRows) =>
		{
			if (tmpToken !== this._searchToken) { return; }   // a newer search/list superseded this one
			const tmpUsers = (Array.isArray(pRows) ? pRows : []).slice();
			tmpUsers.sort((pA, pB) =>
				(this._adminRank(pB) - this._adminRank(pA))
				|| (this._loginTime(pB) - this._loginTime(pA))
				|| String(pA.NameLast || '').localeCompare(String(pB.NameLast || ''))
				|| String(pA.NameFirst || '').localeCompare(String(pB.NameFirst || '')));
			tmpState.Results = tmpUsers;
			tmpState.ListedCustomer = tmpID;
			tmpState.ListLoading = false;
			this.render();
		});
	}

	/** Likely-config-admin rank: senior base level first; disabled users sink to the bottom. */
	_adminRank(pUser)
	{
		if (!pUser) { return -10000; }
		let tmpRank = Number(pUser.IDRole || 0);
		if (pUser.Disabled === true || Number(pUser.Disabled) === 1) { tmpRank -= 1000; }
		return tmpRank;
	}

	/** Epoch ms of the user's last login (0 when never / unparseable) — a recency tiebreak for the ranking. */
	_loginTime(pUser) { const tmpTime = (pUser && pUser.LastLoginTime) ? Date.parse(pUser.LastLoginTime) : 0; return tmpTime || 0; }

	search()
	{
		const tmpState = this.state;
		if (!this.isAuthorized()) { return; }
		const tmpQuery = String(tmpState.Query || '').trim();
		if (tmpQuery.length < 2)
		{
			tmpState.Searching = false;
			// Empty query + a customer in scope → show that customer's users (ranked) instead of a dead end.
			if (tmpState.CustomerFilter) { this.loadCustomerUsers(); return; }
			tmpState.ShowingAll = false;
			tmpState.Results = [];
			this.render();
			return;
		}
		tmpState.ShowingAll = false;
		const tmpToken = ++this._searchToken;
		tmpState.Searching = true;
		this.render();
		const tmpScope = tmpState.CustomerFilter ? `FBV~IDCustomer~EQ~${Number(tmpState.CustomerFilter)}` : '';
		libUserSearch.searchUsersAsync((pURL) => this._getJSON(pURL), tmpQuery, { Scope: tmpScope, PageSize: 50 }).then((pUsers) =>
		{
			if (tmpToken !== this._searchToken)
			{
				return;   // a newer search superseded this one
			}
			tmpState.Results = pUsers;
			tmpState.Searching = false;
			this.render();
		});
	}

	// ── Select a user + load its current Permission-Grant state ──────────────────

	selectUser(pIDUser)
	{
		const tmpState = this.state;
		const tmpUser = (tmpState.Results || []).find((pItem) => Number(pItem.IDUser) === Number(pIDUser)) || null;
		tmpState.SelectedUser = tmpUser;
		tmpState.GrantRecord = null;
		tmpState.ConfigAdminGroup = null;
		tmpState.ConfigAdminHeld = null;
		tmpState.Error = '';
		tmpState.Notice = '';
		tmpState.GrantLoading = !!tmpUser;
		tmpState.ConfigAdminLoading = !!tmpUser;
		this.render();
		if (tmpUser) { this._loadGrantState(tmpUser); this._loadConfigAdminState(tmpUser); }
	}

	/**
	 * Load whether the user already holds the managed "Customer Config Admin" group (PermissionLevel
	 * 'CustomerAdmin') in their own customer — i.e. whether they can already manage configuration.
	 */
	_loadConfigAdminState(pUser)
	{
		const tmpState = this.state;
		const tmpIDUser = Number(pUser.IDUser);
		const tmpIDCustomer = Number(pUser.IDCustomer);
		this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${tmpIDCustomer}~FBV~Name~EQ~${encodeURIComponent(CONFIG_ADMIN_GROUP_NAME)}~FBV~Deleted~EQ~0/0/1`).then((pRoles) =>
		{
			if (!tmpState.SelectedUser || (Number(tmpState.SelectedUser.IDUser) !== tmpIDUser)) { return; }
			const tmpGroup = (Array.isArray(pRoles) ? pRoles : []).find((pRole) => pRole && pRole.IDRole) || null;
			tmpState.ConfigAdminGroup = tmpGroup;
			if (!tmpGroup) { tmpState.ConfigAdminHeld = null; tmpState.ConfigAdminLoading = false; this.render(); return; }
			this._getJSON(`UserRoleJoins/FilteredTo/FBV~IDUser~EQ~${tmpIDUser}~FBV~IDRole~EQ~${Number(tmpGroup.IDRole)}`).then((pJoins) =>
			{
				if (!tmpState.SelectedUser || (Number(tmpState.SelectedUser.IDUser) !== tmpIDUser)) { return; }
				tmpState.ConfigAdminHeld = (Array.isArray(pJoins) ? pJoins : []).find((pJoin) => pJoin && pJoin.IDUserRoleJoin) || null;
				tmpState.ConfigAdminLoading = false;
				this.render();
			});
		});
	}

	/**
	 * Find (or create) the per-customer managed "Customer Config Admin" Permission Group carrying PermissionLevel
	 * 'CustomerAdmin'. Resolves the group record, or null on failure.
	 * @param {number} pIDCustomer
	 */
	_ensureConfigAdminGroup(pIDCustomer)
	{
		return this._getJSON(`Roles/FilteredTo/FBV~IDCustomer~EQ~${pIDCustomer}~FBV~Name~EQ~${encodeURIComponent(CONFIG_ADMIN_GROUP_NAME)}~FBV~Deleted~EQ~0/0/1`).then((pRoles) =>
		{
			const tmpExisting = (Array.isArray(pRoles) ? pRoles : []).find((pRole) => pRole && pRole.IDRole);
			if (tmpExisting) { return tmpExisting; }
			return this._postJSON('Role',
				{
					Name: CONFIG_ADMIN_GROUP_NAME, Type: 'PermissionGroup', PermissionLevel: CONFIG_ADMIN_LEVEL,
					Description: 'Grants configuration-admin rights (PermissionLevel CustomerAdmin) for this customer — approval workflows, cascading configuration, etc. Managed by Grant Access.',
					IDCustomer: pIDCustomer,
				});
		});
	}

	_loadGrantState(pUser)
	{
		const tmpState = this.state;
		const tmpIDUser = Number(pUser.IDUser);
		const tmpIDCustomer = Number(pUser.IDCustomer);
		const tmpURL = `UserPermissions/FilteredTo/FBV~IDUser~EQ~${tmpIDUser}~FBV~Hash~EQ~${GRANT_HASH}~FBV~Context~EQ~Customer~FBV~IDContext~EQ~${tmpIDCustomer}`;
		this._getJSON(tmpURL).then((pRows) =>
		{
			if (!tmpState.SelectedUser || (Number(tmpState.SelectedUser.IDUser) !== tmpIDUser)) { return; }
			tmpState.GrantRecord = (Array.isArray(pRows) ? pRows : []).find((pRow) => pRow && pRow.Allowed) || null;
			tmpState.GrantLoading = false;
			this.render();
		});
	}

	// ── Grant / revoke ───────────────────────────────────────────────────────────

	grant()
	{
		const tmpState = this.state;
		const tmpUser = tmpState.SelectedUser;
		if (!this.isAuthorized() || !tmpUser || tmpState.Busy) { return; }
		tmpState.Busy = true;
		tmpState.Error = '';
		tmpState.Notice = '';
		this.render();
		const tmpIDUser = Number(tmpUser.IDUser);
		const tmpIDCustomer = Number(tmpUser.IDCustomer);
		this._getJSON(`Permissions/Grant/${GRANT_HASH}/To/User/${tmpIDUser}/For/Customer/${tmpIDCustomer}`).then((pResult) =>
		{
			tmpState.Busy = false;
			if (!pResult)
			{
				tmpState.Error = 'The server rejected the grant. Nothing was changed.';
				this.render();
				return;
			}
			tmpState.Notice = `Granted Permission-Grant to ${libUserSearch.userLabel(tmpUser)} in ${this._customerName(tmpIDCustomer)}.`;
			this._loadGrantState(tmpUser);
		});
	}

	revoke()
	{
		const tmpState = this.state;
		const tmpUser = tmpState.SelectedUser;
		const tmpRecord = tmpState.GrantRecord;
		const tmpRC = this.restClient;
		if (!this.isAuthorized() || !tmpUser || !tmpRecord || tmpState.Busy) { return; }
		if (!tmpRC || (typeof tmpRC.deleteEntity !== 'function')) { return; }
		tmpState.Busy = true;
		tmpState.Error = '';
		tmpState.Notice = '';
		this.render();
		tmpRC.deleteEntity('UserPermission', tmpRecord.IDUserPermission, (pErr) =>
		{
			tmpState.Busy = false;
			if (pErr)
			{
				tmpState.Error = 'The server rejected the removal. Nothing was changed.';
				this.render();
				return;
			}
			tmpState.Notice = `Removed Permission-Grant from ${libUserSearch.userLabel(tmpUser)}.`;
			this._loadGrantState(tmpUser);
		});
	}

	// ── Config-admin: elevate a user to manage configuration for their own customer ──

	grantConfigAdmin()
	{
		const tmpState = this.state;
		const tmpUser = tmpState.SelectedUser;
		if (!this.isAuthorized() || !tmpUser || tmpState.Busy) { return; }
		tmpState.Busy = true;
		tmpState.Error = '';
		tmpState.Notice = '';
		this.render();
		const tmpIDUser = Number(tmpUser.IDUser);
		const tmpIDCustomer = Number(tmpUser.IDCustomer);
		this._ensureConfigAdminGroup(tmpIDCustomer).then((tmpGroup) =>
		{
			if (!tmpGroup || !tmpGroup.IDRole)
			{
				tmpState.Busy = false;
				tmpState.Error = 'Could not create the Customer Config Admin group. Nothing was changed.';
				this.render();
				return;
			}
			// Assign the group to the user at the Customer scope (a UserRoleJoin) — same path #/Access uses.
			this._putJSON('Permissions/Role/For/User', { IDRole: Number(tmpGroup.IDRole), IDUser: tmpIDUser, Context: 'Customer', IDContext: tmpIDCustomer }).then((pResult) =>
			{
				tmpState.Busy = false;
				if (!pResult)
				{
					tmpState.Error = 'The server rejected the assignment. Nothing was changed.';
					this.render();
					return;
				}
				tmpState.Notice = `${libUserSearch.userLabel(tmpUser)} can now manage configuration for ${this._customerName(tmpIDCustomer)}.`;
				this._loadConfigAdminState(tmpUser);
			});
		});
	}

	revokeConfigAdmin()
	{
		const tmpState = this.state;
		const tmpUser = tmpState.SelectedUser;
		const tmpHeld = tmpState.ConfigAdminHeld;
		const tmpRC = this.restClient;
		if (!this.isAuthorized() || !tmpUser || !tmpHeld || tmpState.Busy) { return; }
		if (!tmpRC || (typeof tmpRC.deleteEntity !== 'function')) { return; }
		tmpState.Busy = true;
		tmpState.Error = '';
		tmpState.Notice = '';
		this.render();
		// Remove the user's assignment to the group (the UserRoleJoin) — the group itself is left for reuse.
		tmpRC.deleteEntity('UserRoleJoin', tmpHeld.IDUserRoleJoin, (pErr) =>
		{
			tmpState.Busy = false;
			if (pErr)
			{
				tmpState.Error = 'The server rejected the removal. Nothing was changed.';
				this.render();
				return;
			}
			tmpState.Notice = `Removed configuration administration from ${libUserSearch.userLabel(tmpUser)}.`;
			this._loadConfigAdminState(tmpUser);
		});
	}

	// ── Render ───────────────────────────────────────────────────────────────────

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(BODY_MOUNT).length === 0) { return; }
		if (!this.isAuthorized())
		{
			this._pickerBuilt = false;
			tmpCA.assignContent(BODY_MOUNT, this._guardHTML());
			return;
		}
		// (Re)build the body shell whenever it's absent from the live DOM — first render, or a
		// re-navigation that replaced the container. Keying off the search input's presence (not a
		// sticky instance flag) keeps the mounts valid across route changes and preserves input focus
		// on the keystroke re-renders that only touch #SUG-Results / #SUG-Detail.
		if (tmpCA.getElement(SEARCH_MOUNT).length === 0)
		{
			tmpCA.assignContent(BODY_MOUNT, this._bodyShellHTML());
			this._pickerBuilt = false;   // the picker's mount is fresh — it must be recreated into it
		}
		this._ensureCustomerPicker();
		tmpCA.assignContent(RESULTS_MOUNT, this._resultsHTML());
		tmpCA.assignContent(DETAIL_MOUNT, this._detailHTML());
	}

	/** Create the customer scope picker once the customer list is loaded and its mount exists in the DOM. */
	_ensureCustomerPicker()
	{
		if (this._pickerBuilt || !this.state.Loaded) { return; }
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement(PICKER_MOUNT).length === 0) { return; }
		const tmpPicker = tmpPickerProvider.createPicker(PICKER_HASH,
		{
			DestinationAddress: PICKER_MOUNT,
			Placeholder: '(all)',
			AllowClear: true,
			ClearLabel: '(all)',
			Searchable: true,
			Options: this._customerOptions(),
			OnChange: (pValue) => this.onCustomerChange(pValue),
		});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
		this._customerPicker = tmpPicker;
		// Reflect a pre-set scope (arriving via #/GrantAccess/:IDCustomer) so the picker shows that customer.
		if (tmpPicker && (typeof tmpPicker.setValue === 'function') && this.state.CustomerFilter) { tmpPicker.setValue(Number(this.state.CustomerFilter)); }
		this._pickerBuilt = true;
	}

	/** The customer list as picker options ({ Value, Text }), sorted by name. The "(all)" state is the
	 * picker's own AllowClear row, so it is not an explicit option here. */
	_customerOptions()
	{
		const tmpMap = this.state.CustomersByID || {};
		return Object.keys(tmpMap)
			.map((pKey) => ({ Value: Number(pKey), Text: tmpMap[pKey] || `Customer #${pKey}` }))
			.sort((pA, pB) => String(pA.Text).localeCompare(String(pB.Text)));
	}

	_esc(pStr) { return String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }


	_guardHTML()
	{
		return `<div class="sug-guard"><div class="sug-guard-title">Restricted tool</div>`
			+ `This bootstrap tool is available to platform super-users only.</div>`;
	}

	_bodyShellHTML()
	{
		const tmpValue = this._esc(this.state.Query || '');
		return `<div class="sug-filterbar">`
			+ `<div class="sug-filter-field sug-filter-customer"><label class="sug-filter-label">Customer</label>`
			+ `<div id="SUG-CustomerPicker" class="sug-customer-picker"></div></div>`
			+ `<div class="sug-filter-field sug-filter-search"><label class="sug-filter-label">Search users</label>`
			+ `<input id="SUG-Search" class="sug-search" type="text" autocomplete="off" spellcheck="false" `
			+ `placeholder="Search users by name, login ID or email…" value="${tmpValue}" `
			+ `oninput="_Pict.providers.SuperUserGrant.onSearchInput(this.value)" /></div>`
			+ `</div>`
			+ `<div class="sug-cols"><div id="SUG-Results" class="sug-results"></div><div id="SUG-Detail" class="sug-detail"></div></div>`;
	}

	_resultsHTML()
	{
		const tmpState = this.state;
		const tmpQuery = String(tmpState.Query || '').trim();
		const tmpSearching = (tmpQuery.length >= 2);
		if (tmpState.Searching) { return `<div class="sug-hint">Searching…</div>`; }
		if (tmpState.ListLoading) { return `<div class="sug-hint">Loading users…</div>`; }
		// Full customer list (no active search) — most likely admins first.
		if (!tmpSearching && tmpState.ShowingAll && tmpState.CustomerFilter)
		{
			if (!tmpState.Results.length) { return `<div class="sug-results-empty">No users in ${this._esc(this._customerName(tmpState.CustomerFilter))} yet.</div>`; }
			const tmpHeader = `<div class="sug-results-head">Users in ${this._esc(this._customerName(tmpState.CustomerFilter))} &middot; most likely admins first</div>`;
			return tmpHeader + tmpState.Results.map((pUser) => this._resultRowHTML(pUser, false)).join('');
		}
		// No active search and nothing listed — prompt to search or list the scoped customer's users.
		if (!tmpSearching)
		{
			if (tmpState.CustomerFilter)
			{
				return `<div class="sug-hint">Type to search ${this._esc(this._customerName(tmpState.CustomerFilter))}, or <a class="sug-link" onclick="_Pict.providers.SuperUserGrant.loadCustomerUsers()">show all its users</a>.</div>`;
			}
			return `<div class="sug-hint">Type at least 2 characters to search across every customer, or pick a customer above to list its users.</div>`;
		}
		// Active search.
		if (!tmpState.Results.length) { return `<div class="sug-results-empty">No users match &ldquo;${this._esc(tmpQuery)}&rdquo;.</div>`; }
		return tmpState.Results.map((pUser) => this._resultRowHTML(pUser, true)).join('');
	}

	/** One result row: name + level/disabled chips, then email (and customer, in cross-customer search results). */
	_resultRowHTML(pUser, pShowCustomer)
	{
		const tmpState = this.state;
		const tmpActive = (tmpState.SelectedUser && (Number(tmpState.SelectedUser.IDUser) === Number(pUser.IDUser))) ? ' is-active' : '';
		const tmpLevel = this._levelLabel(pUser);
		const tmpLevelChip = tmpLevel ? `<span class="sug-result-tag">${this._esc(tmpLevel)}</span>` : '';
		const tmpDisabledChip = (pUser.Disabled === true || Number(pUser.Disabled) === 1) ? `<span class="sug-result-tag sug-result-tag-off">Disabled</span>` : '';
		const tmpMetaParts = [ pUser.Email || pUser.LoginID || '' ];
		if (pShowCustomer) { tmpMetaParts.push(this._customerName(pUser.IDCustomer)); }
		const tmpMeta = tmpMetaParts.filter((pPart) => pPart).join(' · ');
		return `<div class="sug-result${tmpActive}" onclick="_Pict.providers.SuperUserGrant.selectUser(${Number(pUser.IDUser)})">`
			+ `<div class="sug-result-name">${this._esc(libUserSearch.userLabel(pUser))}${tmpLevelChip}${tmpDisabledChip}</div>`
			+ `<div class="sug-result-meta">${this._esc(tmpMeta)}</div></div>`;
	}

	/** The user's base-level name (e.g. "Office Manager") for the result chip, or '' when unknown. */
	_levelLabel(pUser) { const tmpLvl = Number(pUser && pUser.IDRole); return Object.prototype.hasOwnProperty.call(USER_LEVEL_NAMES, tmpLvl) ? USER_LEVEL_NAMES[tmpLvl] : ''; }

	_detailHTML()
	{
		const tmpState = this.state;
		const tmpUser = tmpState.SelectedUser;
		if (!tmpUser) { return `<div class="sug-detail-empty">Search for a user on the left, then select them to manage their access.</div>`; }

		const tmpFacts = `<dl class="sug-facts">`
			+ `<dt>Email</dt><dd>${this._esc(tmpUser.Email || '—')}</dd>`
			+ `<dt>Customer</dt><dd>${this._esc(this._customerName(tmpUser.IDCustomer))}</dd>`
			+ `<dt>User ID</dt><dd>${Number(tmpUser.IDUser)}</dd>`
			+ `</dl>`;

		const tmpError = tmpState.Error ? `<p class="sug-error">${this._esc(tmpState.Error)}</p>` : '';
		const tmpNotice = tmpState.Notice ? `<p class="sug-ok">${this._esc(tmpState.Notice)}</p>` : '';

		return `<div class="sug-detail-name">${this._esc(libUserSearch.userLabel(tmpUser))}</div>`
			+ `<div class="sug-detail-sub">Elevate this user's access</div>`
			+ tmpFacts
			+ this._capPermissionGrantHTML(tmpUser)
			+ this._capConfigAdminHTML(tmpUser)
			+ tmpNotice + tmpError;
	}

	/** Capability card: Permission-Grant (the original bootstrap grant). */
	_capPermissionGrantHTML(pUser)
	{
		const tmpState = this.state;
		const tmpGranted = !!tmpState.GrantRecord;
		const tmpStatus = tmpState.GrantLoading
			? `<span class="sug-busy">checking…</span>`
			: (tmpGranted
				? `<span class="sug-status sug-status-granted">✔ Has Permission-Grant</span>`
				: `<span class="sug-status sug-status-none">No Permission-Grant</span>`);
		let tmpAction = '';
		if (tmpState.Busy) { tmpAction = `<span class="sug-busy">saving…</span>`; }
		else if (tmpState.GrantLoading) { tmpAction = ''; }
		else if (tmpGranted) { tmpAction = `<button class="sug-btn sug-btn-ghost" onclick="_Pict.providers.SuperUserGrant.revoke()">Remove Permission-Grant</button>`; }
		else { tmpAction = `<button class="sug-btn sug-btn-primary" onclick="_Pict.providers.SuperUserGrant.grant()">Grant Permission-Grant</button>`; }
		return `<div class="sug-cap"><div class="sug-cap-head"><span class="sug-cap-title">Permission granting</span>${tmpStatus}</div>`
			+ `<div class="sug-scope">The right to grant permissions within <strong>${this._esc(this._customerName(pUser.IDCustomer))}</strong> — the original bootstrap grant.</div>`
			+ `<div class="sug-actions">${tmpAction}</div></div>`;
	}

	/** Capability card: Customer configuration admin (assigns a PermissionLevel-'CustomerAdmin' group). */
	_capConfigAdminHTML(pUser)
	{
		const tmpState = this.state;
		const tmpHeld = !!tmpState.ConfigAdminHeld;
		const tmpStatus = tmpState.ConfigAdminLoading
			? `<span class="sug-busy">checking…</span>`
			: (tmpHeld
				? `<span class="sug-status sug-status-granted">✔ Can manage configuration</span>`
				: `<span class="sug-status sug-status-none">Cannot manage configuration</span>`);
		let tmpAction = '';
		if (tmpState.Busy) { tmpAction = `<span class="sug-busy">saving…</span>`; }
		else if (tmpState.ConfigAdminLoading) { tmpAction = ''; }
		else if (tmpHeld) { tmpAction = `<button class="sug-btn sug-btn-ghost" onclick="_Pict.providers.SuperUserGrant.revokeConfigAdmin()">Remove config admin</button>`; }
		else { tmpAction = `<button class="sug-btn sug-btn-primary" onclick="_Pict.providers.SuperUserGrant.grantConfigAdmin()">Make config admin</button>`; }
		return `<div class="sug-cap"><div class="sug-cap-head"><span class="sug-cap-title">Customer configuration admin</span>${tmpStatus}</div>`
			+ `<div class="sug-scope">Assigns a <strong>${this._esc(CONFIG_ADMIN_GROUP_NAME)}</strong> group (PermissionLevel <code>CustomerAdmin</code>) in <strong>${this._esc(this._customerName(pUser.IDCustomer))}</strong> — lets this user edit approval workflows and cascading configuration for their own customer.</div>`
			+ `<div class="sug-actions">${tmpAction}</div></div>`;
	}
}

module.exports = SuperUserGrantProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'SuperUserGrant',
	AutoInitialize: true,
	AutoInitializeOrdinal: 40,
};

},{"../access/User-Search.js":1064,"pict-provider":845}],1376:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libDocumentLookup = require('../documents/Document-Lookup.js');
const libUserSearch = require('../access/User-Search.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

/**
 * What the admin is told when a team change fails. The server's own text (e.g. "UNAUTHORIZED ACCESS IS NOT ALLOWED",
 * or a JSON body) is never shown.
 */
const WRITE_FAILURES =
{
	'add-member': 'That person could not be added to the team.',
	'set-role': 'The member\'s role could not be changed.',
	'remove-member': 'That person could not be removed from the team.',
	'grant': 'The document could not be granted to the team.',
	'revoke': 'The team\'s access to that document could not be removed.',
	'add-lab': 'The lab could not be added to the team.',
	'remove-lab': 'The lab could not be removed from the team.',
};

/**
 * @param {string} pAction - A WRITE_FAILURES key.
 * @param {any} pError - The failure (an Error, a message, or a response body).
 * @returns {string} One or two sentences for the admin: what failed and what to do.
 */
function writeFailureMessage(pAction, pError)
{
	const tmpWhat = WRITE_FAILURES[pAction] || 'The change could not be saved.';
	const tmpDetail = String((pError && (pError.message || pError.Error)) || pError || '');
	if (/already staffs/i.test(tmpDetail))
	{
		return `${tmpWhat} The team is already linked to that lab.`;
	}
	if (/unauthori[sz]ed|forbidden|not allowed|permission|\b40[135]\b/i.test(tmpDetail))
	{
		return `${tmpWhat} You don't have permission to change this team. Ask an administrator for the "Manage teams and document grants" access.`;
	}
	if (/timed out|ETIMEDOUT/i.test(tmpDetail))
	{
		return 'The server took too long to answer, so the change may have been saved. The list shows what the team holds now; check it before trying again.';
	}
	return `${tmpWhat} Check your connection and try again.`;
}

/**
 * TeamWorkspaceProvider — the engine behind the Team workspace (#/Team/Workspace/:ID[/:Tab], bridged over
 * /PSRS/Team/View/:GUID). Built on the finished server-side access engine (nothing new server-side is required):
 *   • Members & Roles — enroll a User in the team with a role (TeamUserJoin {IDTeam,IDUser,IDRole}); IDRole 0 = plain
 *                       member. Add / change role / remove.
 *   • Documents       — grant Documents to the team (DocumentAccessJoin {IDTeam,IDDocument,DocumentType,IDRole,
 *                       AccessKind,GrantRule}). The write projects into PermDocumentUser and PermProjectUser, so members
 *                       reach the document (and its project) with no project membership. Grant / revoke. A document is
 *                       found by number or by name within a project ([[Document-Lookup.js]]), never by a customer-wide scan.
 *   • Projects        — DERIVED read-only: the distinct projects of the team's granted documents (Steven's decision:
 *                       team→project is expressed as document grants, not a direct join). Granting a document here adds
 *                       the project automatically.
 *   • Sub-teams       — child Teams (ParentIDTeam); the access projection does not expand them (a grant reaches the
 *                       team's direct members only — docs/architecture/teams/05-gaps-and-direction.md).
 *   • Labs            — LabTeamJoin (which labs the team staffs). The API grants the team every test form whose tests
 *                       are assigned to that lab, and withdraws the grant when the lab is removed. A child lab's tests
 *                       are not included: link the team to each lab it works
 *                       (api/headlight/ts_source/bundles/contentmanagement/DocumentAccess-LabTeams.ts).
 * Config in [[Team.config.js]]. Inspection assignment (Team↔Inspection) is a later phase (needs a server InspectionTeamJoin).
 */
class TeamWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._team = null;
		this._parentName = '';
		this._tabs = {};            // per-tab {Loading, Loaded, Error, Rows, ...}
		this._names = { user: {}, login: {}, project: {}, lab: {}, role: {}, formType: {} };  // id/hash -> display caches
		// pending picker selections (the add-bars use searchable pickers, not native selects — there are 1,552 Roles)
		this._pendingUser = null; this._pendingRole = 0;
		this._pendingProject = 0; this._pendingDoc = null; this._pendingDocRole = 0;
		this._labAddPending = false;
		this._editMemberJoin = 0;   // the TeamUserJoin whose role is being edited inline
		/** @type {{ Kind: 'add' } | { Kind: 'remove', IDJoin: number } | null} the member add or removal waiting on the server */
		this._memberWrite = null;
		/** @type {{ Tab: string, Message: string } | null} the last failed change, shown on its tab until the next change */
		this._notice = null;
	}

	get idTeam() { return this._team ? this._team.IDTeam : null; }
	get idCustomer() { return (this._team && this._team.IDCustomer) || (this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0; }
	get providerName() { return (this.options && this.options.ProviderIdentifier) || 'TeamWorkspace'; }

	// --- REST helpers ---
	_get(pURL) { return this._getJSON(pURL); }
	_postJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pPayload, (e, b) => e ? reject(e) : resolve(b))); }
	_putJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pPayload, (e, b) => e ? reject(e) : resolve(b))); }
	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			const m = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (m) { this.restClient.deleteEntity(m[1], m[2], (e, b) => e ? reject(e) : resolve(b)); return; }
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((r) => { if (!r.ok) { reject(new Error(`HTTP ${r.status}`)); return; } r.text().then((t) => resolve(t ? JSON.parse(t) : {})).catch(() => resolve({})); })
				.catch(reject);
		});
	}
	_fmtDate(pV) { if (!pV) { return ''; } try { const d = new Date(pV); if (!Number.isNaN(d.getTime())) { return d.toLocaleDateString(); } } catch (e) { /* */ } return String(pV).slice(0, 10); }

	// Roles are huge (1,552 rows incl. permission-groups + user-groups) — never preload; resolve names by id, and select
	// via a searchable picker filtered to real roles (Type 'Role' or legacy '', excluding PermissionGroup/UserGroup).
	async _resolveRoleNames(pIDs)
	{
		const ids = [ ...new Set(pIDs.map(Number).filter((x) => x && !this._names.role[x])) ];
		if (!ids.length) { return; }
		const rows = await this._get(`Roles/FilteredTo/FBL~IDRole~INN~${ids.join(',')}/0/${ids.length}`);
		(Array.isArray(rows) ? rows : []).forEach((r) => { if (r.IDRole) { this._names.role[r.IDRole] = r.Name || `Role ${r.IDRole}`; } });
	}
	_roleLabel(pID) { const id = Number(pID) || 0; if (!id) { return '<span class="tw-muted">member</span>'; } return this._names.role[id] ? this._esc(this._names.role[id]) : `Role #${id}`; }
	_roleDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'Roles', IDField: 'IDRole', Scope: 'FBV~Type~NE~PermissionGroup~FBV~Type~NE~UserGroup~FBV~Deleted~EQ~0',
				ToOption: (r) => ({ Value: Number(r.IDRole), Text: r.Name || `Role ${r.IDRole}`, Record: r }),
			});
	}

	/**
	 * The picker option for a role, so a picker opened on a role already chosen shows its name.
	 * @param {any} pIDRole
	 * @returns {Promise<{ Value: number, Text: string } | null>} null for no role (a plain member).
	 */
	async _roleOption(pIDRole)
	{
		const tmpID = Number(pIDRole) || 0;
		if (!tmpID)
		{
			return null;
		}
		try
		{
			await this._resolveRoleNames([ tmpID ]);
		}
		catch (pError)
		{
			// the name stays unresolved; the option falls back to the number
		}
		return { Value: tmpID, Text: this._names.role[tmpID] || `Role #${tmpID}` };
	}
	/**
	 * @returns {number} The role (0 = plain member) of the member whose role is being edited.
	 */
	_editingMemberRole()
	{
		const tmpRow = (this._state('members').Rows || []).find((r) => r.IDTeamUserJoin === this._editMemberJoin);
		return (tmpRow && Number(tmpRow.IDRole)) || 0;
	}

	// --- hydrate: base loaded the scalar Team; resolve parent name + roles ---
	async hydrateAsync(pRecord)
	{
		this._tabs = {};
		const tmpFull = await this._get(`Team/${pRecord.IDTeam}`);
		this._team = (tmpFull && !tmpFull.Error) ? tmpFull : pRecord;
		this._parentName = '';
		if (this._team.ParentIDTeam)
		{
			const p = await this._get(`Team/${Number(this._team.ParentIDTeam)}`);
			if (p && p.IDTeam) { this._parentName = p.Name || `Team ${p.IDTeam}`; }
		}
	}

	// --- per-tab load + repaint (mirrors the Observation workspace) ---
	async _ensureTabDataAsync(pTab, pForce)
	{
		if (!this._team) { return; }
		if (!pForce && this._tabs[pTab] && this._tabs[pTab].Loaded) { this._scheduleMount(pTab); return; }
		this._tabs[pTab] = { Loading: true, Loaded: false };
		this.repaintBody();
		try
		{
			if (pTab === 'overview') { await this._loadOverview(); }
			else if (pTab === 'members') { this._tabs[pTab].Rows = await this._loadMembers(); }
			else if (pTab === 'documents') { this._tabs[pTab].Rows = await this._loadDocuments(); }
			else if (pTab === 'projects') { this._tabs[pTab].Rows = await this._loadProjects(); }
			else if (pTab === 'inspections') { this._tabs[pTab].Rows = await this._loadInspections(); }
			else if (pTab === 'subteams') { this._tabs[pTab].Rows = await this._loadSubteams(); }
			else if (pTab === 'labs') { this._tabs[pTab].Rows = await this._loadLabs(); }
			this._tabs[pTab].Loaded = true;
		}
		catch (e) { this._tabs[pTab].Error = (e && e.message) || String(e); this._tabs[pTab].Loaded = true; }
		finally { this._tabs[pTab].Loading = false; this.repaintBody(); this._scheduleMount(pTab); }
	}
	_reload(pTab) { if (this._tabs[pTab]) { this._tabs[pTab].Loaded = false; } this._ensureTabDataAsync(pTab, true); }
	_state(pTab) { return this._tabs[pTab] || {}; }
	_loadingOrError(pTab)
	{
		const t = this._state(pTab);
		if (t.Loading || (!t.Loaded && !t.Error)) { return `<div class="tw-note"><i class="fas fa-circle-notch fa-spin"></i> Loading…</div>`; }
		if (t.Error) { return `<div class="tw-error">${this._esc(t.Error)}</div>`; }
		return null;
	}

	async _resolveNames(pKind, pIDs, pURL, pLabel)
	{
		const tmpMissing = [ ...new Set(pIDs.map(Number).filter((x) => x && !this._names[pKind][x])) ];
		if (!tmpMissing.length) { return; }
		const rows = await this._get(pURL(tmpMissing));
		(Array.isArray(rows) ? rows : []).forEach((r) => { const id = pLabel.id(r); if (id) { this._names[pKind][id] = pLabel.name(r); } });
	}

	// --- data loaders ---
	/**
	 * Read every row of a team list, 250 at a time (the API's page limit is 499). A failed read throws, so the tab says
	 * it could not load rather than showing an empty list (which would read as "nothing granted").
	 * @param {string} pFilteredURL - `<Entities>/FilteredTo/<filter>`, without begin/cap.
	 * @param {string} pWhat - What the rows are, for the message ("members", "documents", …).
	 * @returns {Promise<Array<Record<string, any>>>}
	 */
	async _getRows(pFilteredURL, pWhat)
	{
		const tmpPageSize = 250;
		const tmpRows = [];
		for (let tmpStart = 0; tmpStart < (tmpPageSize * 20); tmpStart += tmpPageSize)
		{
			const tmpPage = await this._get(`${pFilteredURL}/${tmpStart}/${tmpPageSize}`);
			if (!Array.isArray(tmpPage))
			{
				throw new Error(`The team's ${pWhat} could not be loaded. Check your connection and open the tab again.`);
			}
			tmpRows.push(...tmpPage);
			if (tmpPage.length < tmpPageSize)
			{
				break;
			}
		}
		return tmpRows;
	}
	async _loadMembers()
	{
		const list = await this._getRows(`TeamUserJoins/FilteredTo/FBV~IDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`, 'members');
		await this._resolveNames('user', list.map((r) => r.IDUser), (ids) => `Users/FilteredTo/FBL~IDUser~INN~${ids.join(',')}/0/${ids.length}`,
			{
				id: (u) => u.IDUser,
				name: (u) =>
				{
					// The login ID (or email) tells apart two members with the same name.
					this._names.login[u.IDUser] = u.LoginID || u.Email || '';
					return [ u.NameFirst, u.NameLast ].filter(Boolean).join(' ') || u.LoginID || `#${u.IDUser}`;
				},
			});
		await this._resolveRoleNames(list.map((r) => r.IDRole));
		return list;
	}
	async _loadDocuments()
	{
		const list = await this._getRows(`DocumentAccessJoins/FilteredTo/FBV~IDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`, 'documents');
		this._docMeta = this._docMeta || {};
		// LiteExtended: name, project and type only. A full Document read would carry each document's FormData.
		const docs = await this._innFetch('Documents/LiteExtended/Name,DocumentType', 'IDDocument', list.map((r) => r.IDDocument));
		docs.forEach((d) =>
		{
			this._docMeta[d.IDDocument] = { Name: d.Name || `Document #${d.IDDocument}`, IDProject: d.IDProject, DocumentType: d.DocumentType };
		});
		await this._resolveFormTypeNames(list.map((r) => r.DocumentType || ((this._docMeta[r.IDDocument] || {}).DocumentType)));
		await this._resolveRoleNames(list.map((r) => r.IDRole));
		return list;
	}
	/**
	 * Cache the form names of document type hashes (LADOTD-ATM → "LADOTD Audit of Testing and Materials").
	 * @param {Array<string>} pTypeHashes
	 */
	async _resolveFormTypeNames(pTypeHashes)
	{
		const tmpMissing = (pTypeHashes || []).filter((pHash) => pHash && !this._names.formType[pHash]);
		const tmpURL = libDocumentLookup.buildFormTypeNamesURL(tmpMissing, this.idCustomer);
		if (!tmpURL)
		{
			return;
		}
		Object.assign(this._names.formType, libDocumentLookup.formTypeNamesByHash(await this._get(tmpURL), this.idCustomer));
	}
	/**
	 * @param {string} pTypeHash - A DocumentType.
	 * @returns {string} The form name, or a neutral placeholder when the type is unknown (never the raw hash).
	 */
	_formTypeLabel(pTypeHash)
	{
		if (!pTypeHash)
		{
			return '—';
		}
		return this._names.formType[pTypeHash] || 'Unnamed form type';
	}
	async _loadProjects()
	{
		// Derived from the team's document grants: distinct projects of the granted documents.
		const grants = await this._loadDocuments();
		const byProject = {};
		grants.forEach((g) => { const meta = (this._docMeta || {})[g.IDDocument]; const pid = meta && meta.IDProject; if (pid) { byProject[pid] = (byProject[pid] || 0) + 1; } });
		const pids = Object.keys(byProject).map(Number);
		await this._resolveNames('project', pids, (ids) => `Projects/Lite/FilteredTo/FBL~IDProject~INN~${ids.join(',')}/0/${ids.length}`, { id: (p) => p.IDProject, name: (p) => p.Value || p.Name || `Project ${p.IDProject}` });
		return pids.map((pid) => ({ IDProject: pid, DocCount: byProject[pid] })).sort((a, b) => b.DocCount - a.DocCount);
	}
	// Chunked INN fetch (Meadow filter-length safety) — concatenates FBL~<field>~INN pages of 100 ids.
	async _innFetch(pEntity, pField, pIDs, pExtra)
	{
		const ids = [ ...new Set(pIDs.map(Number).filter(Boolean)) ]; const out = [];
		for (let i = 0; i < ids.length; i += 100)
		{
			const chunk = ids.slice(i, i + 100);
			const rows = await this._get(`${pEntity}/FilteredTo/FBL~${pField}~INN~${chunk.join(',')}${pExtra || ''}/0/${chunk.length}`);
			if (Array.isArray(rows)) { out.push(...rows); }
		}
		return out;
	}
	// Derived, read-only: the inspections this team can reach. A team is granted an inspection's document packet
	// (DocumentAccessJoin per doc) → those docs belong to inspections (InspectionDocumentJoin) → distinct inspections.
	// This is the "team sees its upcoming / in-progress / completed inspections" list, with NO InspectionTeamJoin.
	async _loadInspections()
	{
		const grants = await this._getRows(`DocumentAccessJoins/FilteredTo/FBV~IDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`, 'documents');
		const docIDs = [ ...new Set(grants.map((g) => g.IDDocument).filter(Boolean)) ];
		if (!docIDs.length) { return []; }
		const idj = await this._innFetch('InspectionDocumentJoins', 'IDDocument', docIDs, '~FBV~Deleted~EQ~0');
		const inspIDs = [ ...new Set(idj.map((r) => r.IDInspection).filter(Boolean)) ];
		if (!inspIDs.length) { return []; }
		const insp = await this._innFetch('Inspections', 'IDInspection', inspIDs, '~FBV~Deleted~EQ~0');
		return insp;
	}
	_inspectionBucket(pInsp)
	{
		const s = String(pInsp.StatusDisplay || '').toLowerCase();
		if (s.indexOf('complete') >= 0 || s.indexOf('closed') >= 0 || pInsp.EndDate) { return 'completed'; }
		if (pInsp.StartDate || s.indexOf('progress') >= 0 || s.indexOf('active') >= 0 || s.indexOf('field') >= 0) { return 'inprogress'; }
		return 'upcoming';
	}
	async _loadSubteams()
	{
		return this._getRows(`Teams/FilteredTo/FBV~ParentIDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0~FSF~Name~ASC~0`, 'sub-teams');
	}
	async _loadLabs()
	{
		const list = await this._getRows(`LabTeamJoins/FilteredTo/FBV~IDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`, 'labs');
		await this._resolveNames('lab', list.map((r) => r.IDLab), (ids) => `Labs/FilteredTo/FBL~IDLab~INN~${ids.join(',')}/0/${ids.length}`, { id: (l) => l.IDLab, name: (l) => l.Name || `Lab ${l.IDLab}` });
		await this._resolveRoleNames(list.map((r) => r.IDRole));
		return list;
	}
	async _loadOverview()
	{
		const [ members, docs, subs ] = await Promise.all([
			this._get(`TeamUserJoins/Count/FilteredTo/FBV~IDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`),
			this._get(`DocumentAccessJoins/Count/FilteredTo/FBV~IDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`),
			this._get(`Teams/Count/FilteredTo/FBV~ParentIDTeam~EQ~${this.idTeam}~FBV~Deleted~EQ~0`),
		]);
		this._tabs.overview = Object.assign(this._tabs.overview || {}, {
			Members: (members && members.Count) || 0,
			Documents: (docs && docs.Count) || 0,
			Subteams: (subs && subs.Count) || 0,
		});
	}

	// =========================================================== interactions ===========================================================
	/**
	 * Show a message on a tab until the next change. Repaints the tab (and re-mounts its pickers).
	 * @param {string} pTab
	 * @param {string} pMessage
	 */
	_showNotice(pTab, pMessage)
	{
		this._notice = { Tab: pTab, Message: pMessage };
		this.repaintBody();
		this._scheduleMount(pTab);
	}
	/**
	 * Run one team change: clear the last notice, write, and on failure tell the admin (the console gets the detail).
	 * The tab reloads either way, so it shows what the server holds.
	 * @param {string} pTab - The tab the change belongs to.
	 * @param {string} pAction - A WRITE_FAILURES key.
	 * @param {() => Promise<any>} fWrite
	 * @returns {Promise<boolean>} Whether the change was saved.
	 */
	async _write(pTab, pAction, fWrite)
	{
		this._notice = null;
		let tmpSaved = true;
		try
		{
			await fWrite();
		}
		catch (pError)
		{
			tmpSaved = false;
			this.pict.log.error(`Team ${this.idTeam} ${pAction} failed: ${(pError && pError.message) || pError}`);
			this._notice = { Tab: pTab, Message: writeFailureMessage(pAction, pError) };
		}
		this._reload(pTab);
		return tmpSaved;
	}
	/**
	 * Empty a picker after its pick has been used, so the next add starts blank.
	 * @param {string} pName - The picker's name (MemberPicker, DocPicker, …).
	 */
	_clearPicker(pName)
	{
		const tmpView = this.pict.views && this.pict.views[`${this.providerName}-${pName}`];
		if (tmpView && (typeof tmpView.clearValue === 'function'))
		{
			tmpView.clearValue();
		}
	}
	// Add-a-member is a two-picker + button flow (person + optional role, both searchable); commit reads the pending picks.
	async commitAddMember()
	{
		if (this._memberWrite)
		{
			return;
		}
		const sel = this._pendingUser;
		if (!sel || !sel.id)
		{
			this._showNotice('members', 'Pick a person to add to the team.');
			return;
		}
		const role = this._pendingRole || 0;
		this._clearPicker('MemberPicker');
		this._clearPicker('MemberRolePicker');
		this._pendingUser = null; this._pendingRole = 0;
		await this._runMemberWrite({ Kind: 'add' }, () => this.addMember(sel.id, role));
	}
	/**
	 * Run one member add or removal, showing it as in progress and refusing another until the server answers, so a
	 * second click can't send a duplicate.
	 * @param {{ Kind: 'add' } | { Kind: 'remove', IDJoin: number }} pWrite
	 * @param {() => Promise<any>} fWrite
	 */
	async _runMemberWrite(pWrite, fWrite)
	{
		this._memberWrite = pWrite;
		this.repaintBody();
		this._scheduleMount('members');
		try
		{
			await fWrite();
		}
		finally
		{
			this._memberWrite = null;
			if (!this._state('members').Loading)
			{
				this.repaintBody();
				this._scheduleMount('members');
			}
		}
	}
	editRole(pIDJoin) { this._editMemberJoin = Number(pIDJoin) || 0; this.repaintBody(); this._scheduleMount('members'); }
	cancelEditRole() { this._editMemberJoin = 0; this.repaintBody(); this._scheduleMount('members'); }
	async applyEditRole(pIDRole)
	{
		const join = this._editMemberJoin; if (!join) { return; }
		this._editMemberJoin = 0;
		await this.setMemberRole(join, Number(pIDRole) || 0);
	}
	async commitGrantDocument()
	{
		const sel = this._pendingDoc;
		if (!sel || !sel.id)
		{
			this._showNotice('documents', 'Pick a document to grant: choose its project and search by name, or type its document number.');
			return;
		}
		const role = this._pendingDocRole || 0;
		this._clearPicker('DocPicker');
		this._clearPicker('DocRolePicker');
		this._pendingDoc = null; this._pendingDocRole = 0;
		await this.grantDocument(sel.id, sel.type, role);
	}
	/**
	 * A project was picked (or cleared) on the Documents tab: name searches now run in it. A document picked from
	 * another project no longer applies.
	 * @param {any} pIDProject
	 */
	setGrantProject(pIDProject)
	{
		const tmpIDProject = Number(pIDProject) || 0;
		if (tmpIDProject === this._pendingProject)
		{
			return;
		}
		this._pendingProject = tmpIDProject;
		if (this._pendingDoc && this._pendingDoc.project && (this._pendingDoc.project !== tmpIDProject))
		{
			this._clearPicker('DocPicker');
			this._pendingDoc = null;
		}
	}
	async addMember(pIDUser, pIDRole)
	{
		const id = Number(pIDUser) || 0;
		if (!id)
		{
			return;
		}
		await this._write('members', 'add-member', () => this._postJSON('TeamUserJoin', { IDTeam: this.idTeam, IDUser: id, IDRole: Number(pIDRole) || 0, IDCustomer: this.idCustomer }));
	}
	async setMemberRole(pIDJoin, pIDRole)
	{
		const id = Number(pIDJoin) || 0;
		if (!id)
		{
			return;
		}
		await this._write('members', 'set-role', () => this._putJSON('TeamUserJoin', { IDTeamUserJoin: id, IDRole: Number(pIDRole) || 0 }));
	}
	async removeMember(pIDJoin)
	{
		const id = Number(pIDJoin) || 0;
		if (!id || this._memberWrite)
		{
			return;
		}
		await this._runMemberWrite({ Kind: 'remove', IDJoin: id }, () => this._write('members', 'remove-member', () => this._deleteJSON(`TeamUserJoin/${id}`)));
	}
	async grantDocument(pIDDocument, pDocumentType, pIDRole)
	{
		const id = Number(pIDDocument) || 0;
		if (!id)
		{
			return;
		}
		await this._write('documents', 'grant', () => this._postJSON('DocumentAccessJoin', { IDDocument: id, DocumentType: pDocumentType || '', IDTeam: this.idTeam, IDRole: Number(pIDRole) || 0, AccessKind: 'Owner', GrantRule: 'Config', IDCustomer: this.idCustomer }));
	}
	async revokeDocument(pIDJoin)
	{
		const id = Number(pIDJoin) || 0;
		if (!id)
		{
			return;
		}
		await this._write('documents', 'revoke', () => this._deleteJSON(`DocumentAccessJoin/${id}`));
	}
	async addLab(pIDLab, pIDRole)
	{
		const id = Number(pIDLab) || 0;
		if (!id || this._labAddPending)
		{
			return;
		}
		this._clearPicker('LabPicker');
		if (this._isLabLinked(id, pIDRole))
		{
			this._showNotice('labs', `${this._names.lab[id] || ('Lab ' + id)} is already linked to this team.`);
			return;
		}
		this._labAddPending = true;
		try
		{
			await this._write('labs', 'add-lab', () => this._postJSON('LabTeamJoin', { IDLab: id, IDTeam: this.idTeam, IDRole: Number(pIDRole) || 0, SupportKind: '', IDCustomer: this.idCustomer }));
		}
		finally
		{
			this._labAddPending = false;
		}
	}
	/**
	 * @param {number} pIDLab
	 * @param {number} [pIDRole] - 0 or absent: the whole-team link the Labs tab adds.
	 * @returns {boolean} Whether the loaded Labs tab already links this team to the lab with that role.
	 */
	_isLabLinked(pIDLab, pIDRole)
	{
		const tmpIDRole = Number(pIDRole) || 0;
		return (this._state('labs').Rows || []).some((r) => (Number(r.IDLab) === Number(pIDLab)) && ((Number(r.IDRole) || 0) === tmpIDRole));
	}
	async removeLab(pIDJoin)
	{
		const id = Number(pIDJoin) || 0;
		if (!id)
		{
			return;
		}
		await this._write('labs', 'remove-lab', () => this._deleteJSON(`LabTeamJoin/${id}`));
	}
	openTeam(pID) { const id = Number(pID) || 0; if (id) { try { window.location.hash = `#/Team/Workspace/${id}`; } catch (e) { /* */ } } }

	// =========================================================== tab bodies ===========================================================
	/**
	 * @param {string} pTab
	 * @returns {string} The tab's failure notice, or ''.
	 */
	_noticeHTML(pTab)
	{
		if (!this._notice || (this._notice.Tab !== pTab))
		{
			return '';
		}
		return `<div class="tw-error" role="alert"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this._notice.Message)}</div>`;
	}

	_overviewHTML()
	{
		const t = this._team || {}; const s = this._state('overview');
		const loading = this._loadingOrError('overview');
		const stats = loading ? '' : `<div class="tw-stats">
			<div class="tw-stat"><div class="tw-stat-v">${(s.Members || 0).toLocaleString()}</div><div class="tw-stat-l">Members</div></div>
			<div class="tw-stat"><div class="tw-stat-v">${(s.Documents || 0).toLocaleString()}</div><div class="tw-stat-l">Documents granted</div></div>
			<div class="tw-stat"><div class="tw-stat-v">${(s.Subteams || 0).toLocaleString()}</div><div class="tw-stat-l">Sub-teams</div></div>
		</div>`;
		return `${stats}
			<div class="tw-fields">
				<div><div class="tw-field-label">Name</div><div class="tw-field-value">${this._esc(t.Name || '—')}</div></div>
				<div><div class="tw-field-label">Parent team</div><div class="tw-field-value">${this._parentName ? this._esc(this._parentName) : '<span class="tw-muted">— top-level —</span>'}</div></div>
			</div>
			${t.Description ? `<div class="tw-sec-h">Description</div><div class="tw-field-value">${this._esc(t.Description)}</div>` : ''}
			<div class="tw-hint"><i class="fas fa-circle-info"></i> Members can open and edit the documents granted to this team, and reach those documents' projects, without being added to the projects.</div>`;
	}

	_membersHTML()
	{
		const tmpNotice = this._noticeHTML('members');
		const loading = this._loadingOrError('members');
		if (loading)
		{
			return tmpNotice + loading;
		}
		const P = this.providerName; const rows = this._state('members').Rows || [];
		const tmpWrite = this._memberWrite;
		const tmpBusy = tmpWrite ? ' disabled' : '';
		const tmpAddLabel = (tmpWrite && (tmpWrite.Kind === 'add')) ? '<i class="fas fa-circle-notch fa-spin"></i> Adding…' : '<i class="fas fa-plus"></i> Add to team';
		const hint = `<div class="tw-hint"><i class="fas fa-circle-info"></i> A role here only matters for documents granted to members in that role (Documents tab). It does not give the person that role's permissions.</div>`;
		const add = `${hint}<div class="tw-addbar">
			<div class="tw-f"><span class="tw-f-l">Add person</span><div id="TeamWorkspace-MemberPicker" class="tw-pick"></div></div>
			<div class="tw-f"><span class="tw-f-l">Role (optional)</span><div id="TeamWorkspace-MemberRolePicker" class="tw-pick"></div></div>
			<button class="tw-add-btn"${tmpBusy} onclick="_Pict.providers.${P}.commitAddMember()">${tmpAddLabel}</button>
		</div>`;
		const removeIcon = (r) => ((tmpWrite && (tmpWrite.Kind === 'remove') && (tmpWrite.IDJoin === r.IDTeamUserJoin)) ? 'fas fa-circle-notch fa-spin' : 'fas fa-user-minus');
		const roleCell = (r) =>
		{
			if (this._editMemberJoin === r.IDTeamUserJoin)
			{
				return `<div class="tw-rolecell"><div id="TeamWorkspace-EditRolePicker" class="tw-pick"></div><button class="tw-editrole" title="Cancel" onclick="_Pict.providers.${P}.cancelEditRole()"><i class="fas fa-xmark"></i></button></div>`;
			}
			return `<span class="tw-chip">${this._roleLabel(r.IDRole)}</span> <button class="tw-editrole" title="Change role" onclick="_Pict.providers.${P}.editRole(${r.IDTeamUserJoin})"><i class="fas fa-pen"></i></button>`;
		};
		const memberCell = (r) =>
		{
			const tmpLogin = this._names.login[r.IDUser];
			return `<span class="tw-name">${this._esc(this._names.user[r.IDUser] || ('#' + r.IDUser))}</span>${tmpLogin ? `<span class="tw-sub">${this._esc(tmpLogin)}</span>` : ''}`;
		};
		const body = rows.length ? `<table class="tw-table"><thead><tr><th>Member</th><th class="tw-col-role">Role in team</th><th></th></tr></thead><tbody>${rows.map((r) => `<tr>
			<td>${memberCell(r)}</td>
			<td>${roleCell(r)}</td>
			<td style="text-align:right"><button class="tw-x" title="Remove from team"${tmpBusy} onclick="_Pict.providers.${P}.removeMember(${r.IDTeamUserJoin})"><i class="${removeIcon(r)}"></i></button></td>
		</tr>`).join('')}</tbody></table>` : `<div class="tw-empty">No members yet — add someone above.</div>`;
		return tmpNotice + add + body;
	}

	_documentsHTML()
	{
		const tmpNotice = this._noticeHTML('documents');
		const loading = this._loadingOrError('documents');
		if (loading)
		{
			return tmpNotice + loading;
		}
		const P = this.providerName; const rows = this._state('documents').Rows || [];
		const add = `<div class="tw-addbar">
			<div class="tw-f"><span class="tw-f-l">Project</span><div id="TeamWorkspace-DocProjectPicker" class="tw-pick"></div></div>
			<div class="tw-f"><span class="tw-f-l">Document (name, or number)</span><div id="TeamWorkspace-DocPicker" class="tw-pick"></div></div>
			<div class="tw-f"><span class="tw-f-l">Only members in this role (optional)</span><div id="TeamWorkspace-DocRolePicker" class="tw-pick"></div></div>
			<button class="tw-add-btn" onclick="_Pict.providers.${P}.commitGrantDocument()"><i class="fas fa-plus"></i> Grant</button>
		</div>`;
		const body = rows.length ? `<table class="tw-table"><thead><tr><th>Document</th><th>Form type</th><th>Granted to</th><th></th></tr></thead><tbody>${rows.map((r) =>
		{
			const m = (this._docMeta || {})[r.IDDocument] || {};
			return `<tr>
			<td><span class="tw-name">${this._esc(m.Name || ('Document #' + r.IDDocument))}</span><span class="tw-sub">#${Number(r.IDDocument)}</span></td>
			<td><span class="tw-chip">${this._esc(this._formTypeLabel(r.DocumentType || m.DocumentType))}</span></td>
			<td>${r.IDRole ? `members in role ${this._roleLabel(r.IDRole)}` : '<span class="tw-muted">whole team</span>'}</td>
			<td style="text-align:right"><button class="tw-x" title="Remove this grant" onclick="_Pict.providers.${P}.revokeDocument(${r.IDDocumentAccessJoin})"><i class="fas fa-xmark"></i></button></td>
		</tr>`;
		}).join('')}</tbody></table>` : `<div class="tw-empty">No documents are granted to this team yet. Members can open and edit a granted document, and reach its project, without being added to the project.</div>`;
		return tmpNotice + add + body;
	}

	_projectsHTML()
	{
		const loading = this._loadingOrError('projects'); if (loading) { return loading; }
		const rows = this._state('projects').Rows || [];
		const hint = `<div class="tw-hint"><i class="fas fa-diagram-project"></i><span>The team reaches these projects because it is granted documents in them; its members are not added to the projects. To add a project, grant one of its documents on the <b>Documents</b> tab.</span></div>`;
		const body = rows.length ? `<table class="tw-table"><thead><tr><th>Project</th><th>Documents granted</th></tr></thead><tbody>${rows.map((r) => `<tr>
			<td><span class="tw-name">${this._esc(this._names.project[r.IDProject] || ('Project ' + r.IDProject))}</span></td>
			<td><span class="tw-chip">${r.DocCount}</span></td>
		</tr>`).join('')}</tbody></table>` : `<div class="tw-empty">The team reaches no projects yet. Grant it a document to reach that document's project.</div>`;
		return hint + body;
	}

	_inspectionsHTML()
	{
		const loading = this._loadingOrError('inspections'); if (loading) { return loading; }
		const rows = this._state('inspections').Rows || [];
		if (!rows.length)
		{
			return `<div class="tw-hint"><i class="fas fa-clipboard-check"></i><span>Inspections this team can reach because it is granted their documents. Assign the team to an inspection from the <b>Inspection workspace → Teams</b> tab.</span></div><div class="tw-empty">No inspections assigned to this team yet.</div>`;
		}
		const fmt = (v) => this._fmtDate(v) || '<span class="tw-muted">—</span>';
		const buckets = { upcoming: [], inprogress: [], completed: [] };
		rows.forEach((r) => { buckets[this._inspectionBucket(r)].push(r); });
		const order = (a, b) => (new Date(a.ScheduledStartDate || a.DeadlineDate || 0)).getTime() - (new Date(b.ScheduledStartDate || b.DeadlineDate || 0)).getTime();
		const section = (pTitle, pIcon, pList) => !pList.length ? '' : `<div class="tw-sec-h"><i class="${pIcon}"></i> ${pTitle} <span class="tw-chip">${pList.length}</span></div>
			<table class="tw-table"><thead><tr><th>Inspection</th><th>Type</th><th>Scheduled</th><th>Deadline</th><th></th></tr></thead><tbody>${pList.sort(order).map((r) => `<tr>
				<td><span class="tw-name">${this._esc(r.Name || ('Inspection ' + r.IDInspection))}</span></td>
				<td>${r.TypeDisplay ? `<span class="tw-chip">${this._esc(r.TypeDisplay)}</span>` : '<span class="tw-muted">—</span>'}</td>
				<td style="white-space:nowrap">${fmt(r.ScheduledStartDate)}</td>
				<td style="white-space:nowrap">${fmt(r.DeadlineDate)}</td>
				<td style="text-align:right"><a class="tw-link" href="#/Inspection/Workspace/${r.IDInspection}">Open <i class="fas fa-arrow-right"></i></a></td>
			</tr>`).join('')}</tbody></table>`;
		return `<div class="tw-hint"><i class="fas fa-clipboard-check"></i> The team reaches these inspections because it is granted their documents.</div>
			${section('Upcoming', 'fas fa-calendar-day', buckets.upcoming)}
			${section('In progress', 'fas fa-person-digging', buckets.inprogress)}
			${section('Completed', 'fas fa-circle-check', buckets.completed)}`;
	}

	_subteamsHTML()
	{
		const loading = this._loadingOrError('subteams'); if (loading) { return loading; }
		const rows = this._state('subteams').Rows || [];
		const body = rows.length ? `<table class="tw-table"><thead><tr><th>Sub-team</th><th>Description</th><th></th></tr></thead><tbody>${rows.map((r) => `<tr>
			<td><span class="tw-name">${this._esc(r.Name || ('Team ' + r.IDTeam))}</span></td>
			<td>${r.Description ? this._esc(r.Description) : '<span class="tw-muted">—</span>'}</td>
			<td style="text-align:right"><a class="tw-link" href="#/Team/Workspace/${r.IDTeam}">Open <i class="fas fa-arrow-right"></i></a></td>
		</tr>`).join('')}</tbody></table>` : `<div class="tw-empty">No sub-teams.</div>`;
		return `<div class="tw-hint"><i class="fas fa-circle-info"></i> Sub-teams are for organizing only: a document granted to this team reaches this team's own members, not the members of its sub-teams. Grant documents to each sub-team that needs them.</div>${body}`;
	}

	_labsHTML()
	{
		const tmpNotice = this._noticeHTML('labs');
		const loading = this._loadingOrError('labs');
		if (loading)
		{
			return tmpNotice + loading;
		}
		const P = this.providerName; const rows = this._state('labs').Rows || [];
		const hint = `<div class="tw-hint"><i class="fas fa-circle-info"></i> The team's members can open and work every test form for tests assigned to these labs, without being added to the project. Tests at a lab's child labs are not included: add each lab the team works. Removing a lab takes those forms away from the team.</div>`;
		const add = `${hint}<div class="tw-addbar"><div class="tw-f"><span class="tw-f-l">Add a lab</span><div id="TeamWorkspace-LabPicker" class="tw-pick"></div></div></div>`;
		const body = rows.length ? `<table class="tw-table"><thead><tr><th>Lab</th><th>Support kind</th><th>Role</th><th></th></tr></thead><tbody>${rows.map((r) => `<tr>
			<td><span class="tw-name">${this._esc(this._names.lab[r.IDLab] || ('Lab ' + r.IDLab))}</span></td>
			<td>${r.SupportKind ? this._esc(r.SupportKind) : '<span class="tw-muted">—</span>'}</td>
			<td>${r.IDRole ? `<span class="tw-chip">${this._roleLabel(r.IDRole)}</span>` : '<span class="tw-muted">—</span>'}</td>
			<td style="text-align:right"><button class="tw-x" title="Remove" onclick="_Pict.providers.${P}.removeLab(${r.IDLabTeamJoin})"><i class="fas fa-xmark"></i></button></td>
		</tr>`).join('')}</tbody></table>` : `<div class="tw-empty">This team staffs no labs.</div>`;
		return tmpNotice + add + body;
	}

	// =========================================================== pickers ===========================================================
	_scheduleMount(pTab) { try { setTimeout(() => this._mountPickers(pTab), 0); } catch (e) { /* */ } }
	_picker() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }
	_mountPickers(pTab)
	{
		const tmpPicker = this._picker(); const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		const mount = (pHostID, pName, pDataProvider, pOnChange, pPlaceholder, pExtra) =>
		{
			if (tmpCA.getElement(`#${pHostID}`).length === 0)
			{
				return null;
			}
			const v = tmpPicker.createPicker(`${this.providerName}-${pName}`, Object.assign({
				DestinationAddress: `#${pHostID}`, ValueAddress: `AppData.${this.providerName}.${pName}`,
				Searchable: true, AllowClear: true, ClearLabel: `— ${pPlaceholder} —`, Placeholder: `${pPlaceholder}…`,
				DataProvider: pDataProvider, ResolveValue: () => Promise.resolve(null), OnChange: pOnChange,
			}, pExtra || {}));
			if (v && (typeof v.render === 'function'))
			{
				v.render();
			}
			return v;
		};
		if (pTab === 'members')
		{
			mount('TeamWorkspace-MemberPicker', 'MemberPicker', this._userDataProvider(), (val, rec) => { this._pendingUser = val ? { id: Number(val), rec: rec } : null; }, 'search people');
			mount('TeamWorkspace-MemberRolePicker', 'MemberRolePicker', this._roleDataProvider(), (val, rec) => { this._pendingRole = Number(val) || 0; this._cacheRoleName(val, rec); }, 'any role');
			if (this._editMemberJoin)
			{
				// Opens on the member's current role; clearing it makes them a plain member again.
				const fApply = (val, rec) =>
				{
					this._cacheRoleName(val, rec);
					this.applyEditRole(Number(val) || 0);
				};
				const tmpEdit = mount('TeamWorkspace-EditRolePicker', 'EditRolePicker', this._roleDataProvider(), fApply, 'member (no role)',
					{ Placeholder: 'member (no role)', ResolveValue: (pValue) => this._roleOption(pValue) });
				if (tmpEdit && (typeof tmpEdit.setValue === 'function'))
				{
					tmpEdit.setValue(this._editingMemberRole() || null);
				}
			}
		}
		else if (pTab === 'documents')
		{
			mount('TeamWorkspace-DocProjectPicker', 'DocProjectPicker', this._projectDataProvider(), (val) => this.setGrantProject(val), 'search projects');
			mount('TeamWorkspace-DocPicker', 'DocPicker', this._docDataProvider(), (val, rec) =>
			{
				const tmpRow = (rec && rec.Record) || {};
				this._pendingDoc = val ? { id: Number(val), type: tmpRow.DocumentType || '', project: Number(tmpRow.IDProject) || 0 } : null;
			}, 'name or number', { EmptyLabel: (pTerm) => libDocumentLookup.documentSearchEmptyLabel(pTerm, this._pendingProject) });
			mount('TeamWorkspace-DocRolePicker', 'DocRolePicker', this._roleDataProvider(), (val, rec) => { this._pendingDocRole = Number(val) || 0; this._cacheRoleName(val, rec); }, 'any role');
		}
		else if (pTab === 'labs') { mount('TeamWorkspace-LabPicker', 'LabPicker', this._labDataProvider(), (val) => { if (val) { this.addLab(val, 0); } }, 'search labs'); }
	}
	_cacheRoleName(pVal, pRec) { const id = Number(pVal) || 0; if (id && pRec && pRec.Record && pRec.Record.Name) { this._names.role[id] = pRec.Record.Name; } }
	_userDataProvider()
	{
		return libUserSearch.userPickerDataProvider((pURL) => this._get(pURL), { Scope: 'FBV~Deleted~EQ~0', PageSize: 25 });
	}
	// Documents are found by number, or by name within the picked project (never a customer-wide name scan).
	_docDataProvider()
	{
		return libDocumentLookup.documentPickerDataProvider((pURL) => this._get(pURL), () => ({ IDCustomer: this.idCustomer, IDProject: this._pendingProject }));
	}
	_projectDataProvider()
	{
		return libDocumentLookup.projectPickerDataProvider((pURL) => this._get(pURL));
	}
	_labDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._get(pURL),
			{
				Set: 'Labs', IDField: 'IDLab', Include: (r) => !this._isLabLinked(r.IDLab, 0),
				ToOption: (r) => ({ Value: Number(r.IDLab), Text: r.Name || `Lab ${r.IDLab}`, Record: r }),
			});
	}
}

module.exports = TeamWorkspaceProvider;
module.exports.default_configuration = { ProviderIdentifier: 'TeamWorkspace' };
module.exports.writeFailureMessage = writeFailureMessage;

},{"../access/User-Search.js":1064,"../documents/Document-Lookup.js":1269,"../services/Entity-Picker-Search.js":1398,"pict-section-workspace":1049}],1377:[function(require,module,exports){
'use strict';

const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * TypeComprehensionReadProvider
 *
 * The read-side counterpart to TypeComprehensionSaveProvider: hydrates the parts of a
 * ProjectType / ContractType that do NOT live on the base Meadow record —
 *   - statuses + change-order flags (ListDefault, via GET {Entity}/:id/Statuses),
 *   - the default-date definitions (*TypeDefaultDate rows),
 *   - a contract type's allowed project types (GET ContractType/:id/AllowedProjectTypes),
 *   - the prototype Project/Contract the type points at (Settings.PrototypeID{Project,Contract}).
 *
 * Returns PLAIN DATA (it does not mutate `_DisplaySettings`), so a bespoke editor loads it
 * into its own state. This is the single, shared implementation of those four reads —
 * mirroring the endpoints the legacy PSRS `_load*IntoDisplay` helpers use in
 * PlatformConfiguration-Application-Web.js — so the raw and bespoke paths cannot drift.
 * Registered as a fable service (resolve via `this.fable.TypeComprehensionReadProvider`).
 *
 * Exercised only at runtime in the browser against a live API — validate end-to-end on QA.
 */
class TypeComprehensionReadProvider extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict = this.fable;
		this.serviceType = 'TypeComprehensionReadProvider';
	}

	/** @returns {*} The shared HeadlightRestClient, or null when it isn't registered. */
	get _restClient()
	{
		return (this.fable && this.fable.HeadlightRestClient)
			|| (this.pict && this.pict.fable && this.pict.fable.HeadlightRestClient)
			|| (this.pict && this.pict.HeadlightRestClient)
			|| null;
	}

	/** @param {string} pEntity - 'ProjectType' | 'ContractType' */
	_idField(pEntity) { return (pEntity === 'ContractType') ? 'IDContractType' : 'IDProjectType'; }

	/**
	 * GET {Entity}/:id/Statuses → { Available:[names], RequiresChangeOrder:[names] }.
	 * Resolves to empty lists on any error / missing id (never rejects).
	 *
	 * @param {string} pEntity
	 * @param {number|string} pID
	 * @returns {Promise<{Available: Array<string>, RequiresChangeOrder: Array<string>}>}
	 */
	loadStatuses(pEntity, pID)
	{
		const tmpClient = this._restClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient || !pID) { return resolve({ Available: [], RequiresChangeOrder: [] }); }
			tmpClient.getJSON(`${pEntity}/${pID}/Statuses`, (pError, pBody) =>
			{
				if (pError || !pBody) { return resolve({ Available: [], RequiresChangeOrder: [] }); }
				return resolve(
					{
						Available: Array.isArray(pBody.Available) ? pBody.Available.map((pV) => String(pV)) : [],
						RequiresChangeOrder: Array.isArray(pBody.RequiresChangeOrder) ? pBody.RequiresChangeOrder.map((pV) => String(pV)) : [],
					});
			});
		});
	}

	/**
	 * The type's default-date definitions → [{ Hash, Name, IDRow }] (server order).
	 *
	 * @param {string} pEntity
	 * @param {number|string} pID
	 * @returns {Promise<Array<{Hash:string, Name:string, IDRow:number}>>}
	 */
	loadDefaultDates(pEntity, pID)
	{
		const tmpClient = this._restClient;
		const tmpIDField = this._idField(pEntity);
		const tmpDateEntity = (pEntity === 'ContractType') ? 'ContractTypeDefaultDate' : 'ProjectTypeDefaultDate';
		const tmpRowIDField = (pEntity === 'ContractType') ? 'IDContractTypeDefaultDate' : 'IDProjectTypeDefaultDate';
		return new Promise((resolve) =>
		{
			if (!tmpClient || !pID) { return resolve([]); }
			tmpClient.getEntitySet(tmpDateEntity, `FBV~${tmpIDField}~EQ~${pID}`, (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords)) { return resolve([]); }
				return resolve(pRecords.map((pRow) => (
					{
						Hash: (pRow && typeof pRow.Hash === 'string') ? pRow.Hash : '',
						Name: (pRow && typeof pRow.Name === 'string') ? pRow.Name : '',
						IDRow: (pRow && Number(pRow[tmpRowIDField])) || 0,
					})));
			}, 0, 200000);
		});
	}

	/**
	 * GET ContractType/:id/AllowedProjectTypes → [ '12', '15', … ] (numeric IDProjectType strings).
	 *
	 * @param {number|string} pID
	 * @returns {Promise<Array<string>>}
	 */
	loadAllowedProjectTypes(pID)
	{
		const tmpClient = this._restClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient || !pID) { return resolve([]); }
			tmpClient.getJSON(`ContractType/${pID}/AllowedProjectTypes`, (pError, pBody) =>
			{
				if (pError || !Array.isArray(pBody)) { return resolve([]); }
				return resolve(pBody.map((pV) => String(pV)));
			});
		});
	}

	/** Parse a type record's Settings defensively (object `Settings`, else `SettingsJSON` string). */
	parseSettings(pRecord)
	{
		if (pRecord && pRecord.Settings && typeof pRecord.Settings === 'object') { return pRecord.Settings; }
		if (pRecord && typeof pRecord.SettingsJSON === 'string' && pRecord.SettingsJSON.length > 0)
		{
			try { const tmpParsed = JSON.parse(pRecord.SettingsJSON); return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : {}; }
			catch (pError) { return {}; }
		}
		return {};
	}

	/** The numeric prototype id a type points at (Settings.PrototypeID{Project,Contract}), or 0. */
	prototypeID(pEntity, pRecord)
	{
		const tmpSettings = this.parseSettings(pRecord);
		return Number((pEntity === 'ContractType') ? tmpSettings.PrototypeIDContract : tmpSettings.PrototypeIDProject) || 0;
	}

	/**
	 * Resolve the prototype Project/Contract a type points at → the prototype record, or null.
	 *
	 * @param {string} pEntity
	 * @param {Object} pRecord - the type record (its Settings carry the pointer).
	 * @returns {Promise<Object|null>}
	 */
	loadPrototype(pEntity, pRecord)
	{
		const tmpClient = this._restClient;
		const tmpIsContract = (pEntity === 'ContractType');
		const tmpProtoEntity = tmpIsContract ? 'Contract' : 'Project';
		const tmpProtoIDField = tmpIsContract ? 'IDContract' : 'IDProject';
		const tmpProtoID = this.prototypeID(pEntity, pRecord);
		return new Promise((resolve) =>
		{
			if (!tmpClient || !tmpProtoID) { return resolve(null); }
			tmpClient.getEntitySet(tmpProtoEntity, `FBV~${tmpProtoIDField}~EQ~${tmpProtoID}`, (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords) || !pRecords[0]) { return resolve(null); }
				return resolve(pRecords[0]);
			}, 0, 1);
		});
	}
}

module.exports = TypeComprehensionReadProvider;
module.exports.default_configuration =
{
	ProviderIdentifier: 'TypeComprehensionReadProvider',
};

},{"fable-serviceproviderbase":838}],1378:[function(require,module,exports){
/**
 * TypeComprehensionSaveProvider
 *
 * The single, canonical "save a project/contract type" operation. From an
 * editor-shaped record (scalars + `_DisplaySettings.*` selections) it builds ONE
 * comprehension — the type + its `*TypeDefaultDate` definitions + the prototype
 * project/contract + the prototype's join rows (forms / observation types /
 * label types / labels) + placeholder dates — and pushes it so everything is
 * created/updated together (GUID-FKs resolved by the comprehension processor).
 * Then it resolves the prototype's numeric id into the type's Settings pointer,
 * prunes config the user deselected (on edit), and PUTs statuses (their ListDefault
 * NamespaceKey needs the type's numeric id, unknown until the push creates the type).
 *
 * Both the HPC type editor (the PSRS create/update wrap) and the spreadsheet
 * ImportProvider call this, so an imported type is identical to an editor-created
 * one — same prototype, dates, statuses. Registered as a fable service so any
 * provider can resolve it via `this.fable.TypeComprehensionSaveProvider`.
 *
 * Exercised only at runtime in the browser against a live API — validate end-to-end on QA.
 */

const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libProjectTypeComprehensionBuilder = require('./ProjectTypeComprehensionBuilder.js');
const libContractProjectTypesSettingsAdapter = require('./ContractProjectTypesSettingsAdapter.js');

class TypeComprehensionSaveProvider extends libFableServiceProviderBase
{
	/**
	 * @param {*} pFable - The fable instance.
	 * @param {*} [pOptions] - Provider options.
	 * @param {string} [pServiceHash] - Fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict = this.fable;
		this.serviceType = 'TypeComprehensionSaveProvider';
	}

	/**
	 * The logged-in user's customer id, stamped onto the type and every comprehension
	 * child row (prototype project/contract, contract dates) so they inherit the right
	 * customer. The editor record doesn't expose IDCustomer, so without this the rows
	 * push `IDCustomer: 0`, which the API's update guard rejects with "You do not have
	 * permission to change customer assignment on records". Mirrors the import path's
	 * stamping in ContractProjectTypesImportProvider.
	 *
	 * @returns {number} the current user's customer id, or 0 if unknown.
	 */
	get _currentIDCustomer()
	{
		const tmpUser = this.fable && this.fable.AppData && this.fable.AppData.CurrentUser;
		return (tmpUser && (Number(tmpUser.IDCustomer) || Number(tmpUser.CustomerID))) || 0;
	}

	/**
	 * Mint a fresh random external GUID for a brand-new comprehension record: a prefixed
	 * base36 token, e.g. `PROTO-k3f9x1q8z7m2a0b4`.
	 *
	 * Why not a UUID: `fable.getUUID()` returns a dashed v4 UUID, which Headlight
	 * normalizes to its `0x`-hex GUID storage format. That transformation breaks the
	 * comprehension processor's GUID->FK correlation (the prototype, which references the
	 * type by its supplied GUID, then fails to link/create). A plain prefixed base36 token
	 * is stored verbatim — matching the format the rest of the system already round-trips —
	 * and the leading non-hex prefix guarantees it is never mistaken for a hex GUID.
	 *
	 * These GUIDs are opaque identity keys (nothing reconstructs them from Hash), so a
	 * random value means a Hash reused across types or customers never collides. The
	 * type→prototype link rides on the stored `Settings.Prototype*` pointers and the date
	 * children on their FK to the type/prototype, so opaque GUIDs lose nothing.
	 *
	 * @param {string} pPrefix - short entity tag (e.g. 'PT', 'PROTO', 'CT', 'CTDD').
	 * @returns {string} `{prefix}-{16-char base36 token}`.
	 */
	_newGUID(pPrefix)
	{
		const tmpToken = (Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 16);
		return `${pPrefix || 'G'}-${tmpToken}`;
	}

	/**
	 * @returns {*} The shared HeadlightRestClient, or null when it isn't registered.
	 */
	get _typeStatusRestClient()
	{
		return (this.fable && this.fable.HeadlightRestClient)
			|| (this.pict && this.pict.fable && this.pict.fable.HeadlightRestClient)
			|| (this.pict && this.pict.HeadlightRestClient)
			|| null;
	}

	/**
	 * The primary-key field name for a type recordset.
	 *
	 * @param {string} pEntity - 'ProjectType' | 'ContractType'
	 * @returns {string}
	 */
	_typeStatusIDField(pEntity)
	{
		return (pEntity === 'ContractType') ? 'IDContractType' : 'IDProjectType';
	}

	/** @returns {*} the ProjectCloningAdapter fable service (its loadComprehension pushes a comprehension). */
	get _projectCloningAdapterService()
	{
		if (this.fable && this.fable.ProjectCloningAdapter)
		{
			return this.fable.ProjectCloningAdapter;
		}
		if (this.fable && this.fable.serviceManager)
		{
			return this.fable.serviceManager.instantiateServiceProvider('ProjectCloningAdapter', {});
		}
		return null;
	}

	/** Promisified loadComprehension (integrate/upsert) push. */
	_pushTypeComprehension(pComprehension)
	{
		const tmpAdapter = this._projectCloningAdapterService;
		return new Promise((resolve, reject) =>
		{
			if (!tmpAdapter || typeof tmpAdapter.loadComprehension !== 'function')
			{
				return reject(new Error('ProjectCloningAdapter.loadComprehension is unavailable — cannot push the type comprehension.'));
			}
			tmpAdapter.loadComprehension(pComprehension, (pError) => pError ? reject(pError) : resolve());
		});
	}

	/** Read the first entity matching a single-field equals filter, or null. */
	_readEntityByFilter(pEntity, pField, pValue)
	{
		const tmpClient = this._typeStatusRestClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient) return resolve(null);
			tmpClient.getEntitySet(pEntity, `FBV~${pField}~EQ~${pValue}`, (pError, pRecords) =>
			{
				if (pError || !Array.isArray(pRecords) || pRecords.length === 0) return resolve(null);
				return resolve(pRecords[0]);
			}, 0, 50);
		});
	}

	/**
	 * Snapshot the status textareas off `_DisplaySettings` so they can be
	 * PUT to /Statuses after the save.
	 *
	 * @param {Object} pRecord
	 * @returns {{AvailableStatusList: string, StatusesRequiringChangeOrder: string} | null}
	 */
	_captureTypeStatusDisplay(pRecord)
	{
		const tmpDisplay = pRecord && pRecord._DisplaySettings;
		if (!tmpDisplay)
		{
			return null;
		}
		return {
			AvailableStatusList: tmpDisplay.AvailableStatusList,
			StatusesRequiringChangeOrder: tmpDisplay.StatusesRequiringChangeOrder,
		};
	}

	/**
	 * PUT the captured status text to /1.0/{Entity}/:id/Statuses after a type
	 * create/update. Failures are logged, not thrown.
	 *
	 * @param {string} pEntity
	 * @param {Object} pSavedRecord
	 * @param {Object} pNormalizedRecord
	 * @param {{AvailableStatusList: string, StatusesRequiringChangeOrder: string} | null} pStatusDisplay
	 * @returns {Promise<void>}
	 */
	async _persistTypeStatuses(pEntity, pSavedRecord, pNormalizedRecord, pStatusDisplay)
	{
		if (!pStatusDisplay)
		{
			return;
		}
		const tmpClient = this._typeStatusRestClient;
		if (!tmpClient)
		{
			this.pict.log.warn(`HeadlightRestClient unavailable — cannot persist ${pEntity} statuses.`);
			return;
		}
		const tmpIDField = this._typeStatusIDField(pEntity);
		const tmpID = (pSavedRecord && (pSavedRecord[tmpIDField] || (pSavedRecord.Record && pSavedRecord.Record[tmpIDField])))
			|| (pNormalizedRecord && pNormalizedRecord[tmpIDField]);
		if (!tmpID)
		{
			this.pict.log.warn(`Saved ${pEntity} has no ${tmpIDField} — cannot persist statuses.`);
			return;
		}
		const tmpPayload = libContractProjectTypesSettingsAdapter.statusDisplayToPayload(pStatusDisplay);
		await new Promise((resolve) =>
		{
			tmpClient.putJSON(`${pEntity}/${tmpID}/Statuses`, tmpPayload, (pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Failed to persist ${pEntity} statuses for ID ${tmpID}.`, { Error: pError.message });
				}
				return resolve();
			});
		});
	}

	/** Parse a SettingsJSON string into an object (tolerant). */
	_parseSettingsJSON(pSettingsJSON)
	{
		if (typeof pSettingsJSON !== 'string' || pSettingsJSON.length === 0) return {};
		try { const tmpParsed = JSON.parse(pSettingsJSON); return (tmpParsed && typeof tmpParsed === 'object') ? tmpParsed : {}; }
		catch (pError) { return {}; }
	}

	/** Update the saved type's Settings with the resolved numeric prototype pointer. */
	async _writePrototypePointer(pSavedType, pIDProject, pProtoGUID)
	{
		const tmpClient = this._typeStatusRestClient;
		if (!tmpClient) return;
		const tmpSettings = (pSavedType.Settings && typeof pSavedType.Settings === 'object')
			? pSavedType.Settings : this._parseSettingsJSON(pSavedType.SettingsJSON);
		tmpSettings.PrototypeIDProject = pIDProject;
		tmpSettings.PrototypeGUIDProject = pProtoGUID;
		await new Promise((resolve) =>
		{
			tmpClient.upsertEntity('ProjectType', { IDProjectType: pSavedType.IDProjectType, Settings: tmpSettings },
				(pError) =>
				{
					if (pError) this.pict.log.error(`Failed to write prototype pointer onto ProjectType ${pSavedType.IDProjectType}.`, { Error: pError.message });
					return resolve();
				});
		});
	}

	/** Update the saved contract type's Settings with the resolved numeric prototype pointer. */
	async _writeContractPrototypePointer(pSavedType, pIDContract, pProtoGUID)
	{
		const tmpClient = this._typeStatusRestClient;
		if (!tmpClient) return;
		const tmpSettings = (pSavedType.Settings && typeof pSavedType.Settings === 'object')
			? pSavedType.Settings : this._parseSettingsJSON(pSavedType.SettingsJSON);
		tmpSettings.PrototypeIDContract = pIDContract;
		tmpSettings.PrototypeGUIDContract = pProtoGUID;
		await new Promise((resolve) =>
		{
			tmpClient.upsertEntity('ContractType', { IDContractType: pSavedType.IDContractType, Settings: tmpSettings },
				(pError) =>
				{
					if (pError) this.pict.log.error(`Failed to write prototype pointer onto ContractType ${pSavedType.IDContractType}.`, { Error: pError.message });
					return resolve();
				});
		});
	}

	/** Read all rows of an entity matching pIDField=pIDValue (single high-cap page). */
	_readAllEntities(pEntity, pIDField, pIDValue)
	{
		const tmpClient = this._typeStatusRestClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient || !pIDValue) return resolve([]);
			tmpClient.getEntitySet(pEntity, `FBV~${pIDField}~EQ~${pIDValue}`, (pError, pRecords) => resolve((!pError && Array.isArray(pRecords)) ? pRecords : []), 0, 200000);
		});
	}

	/** Promisified create-or-update (the rest client upserts by the PK present in the record). */
	_upsertEntity(pEntity, pRecord)
	{
		const tmpClient = this._typeStatusRestClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient) return resolve();
			tmpClient.upsertEntity(pEntity, pRecord, (pError) =>
			{
				if (pError) this.pict.log.error(`Failed to upsert ${pEntity}.`, { Error: pError.message });
				return resolve();
			});
		});
	}

	/** Promisified delete by numeric id. */
	_deleteEntity(pEntity, pID)
	{
		const tmpClient = this._typeStatusRestClient;
		return new Promise((resolve) =>
		{
			if (!tmpClient || !pID) return resolve();
			tmpClient.deleteEntity(pEntity, pID, (pError) =>
			{
				if (pError) this.pict.log.warn(`Failed to delete ${pEntity} ${pID}.`, { Error: pError.message });
				return resolve();
			});
		});
	}

	/**
	 * Reconcile a type's default-date list (and the prototype's matching dates) with the
	 * editor grid by Hash — the date milestone's natural key. Existing rows are upserted in
	 * place (their ids/GUIDs survive) and brand-new rows are created — no delete-and-recreate
	 * churn. The type's own definition list deletes rows the user removed from the grid; the
	 * prototype's dates are only added/updated, NEVER deleted (a user configures the prototype
	 * separately and may keep extra dates there).
	 *
	 * @param {string} pEntity - 'ProjectType' | 'ContractType'
	 * @param {Object} pSavedType
	 * @param {Object} pPrototype
	 * @param {Array<{Hash?:string,Name?:string}>} pGridDates - the editor's current date list.
	 * @returns {Promise<void>}
	 */
	async _reconcileTypeDefaultDates(pEntity, pSavedType, pPrototype, pGridDates)
	{
		if (!this._typeStatusRestClient || !pSavedType || !pPrototype) return;
		const tmpIsContract = (pEntity === 'ContractType');
		const tmpKeys = {
			typeDateEntity: tmpIsContract ? 'ContractTypeDefaultDate' : 'ProjectTypeDefaultDate',
			protoDateEntity: tmpIsContract ? 'ContractDate' : 'ProjectDate',
			typeIDField: tmpIsContract ? 'IDContractType' : 'IDProjectType',
			protoIDField: tmpIsContract ? 'IDContract' : 'IDProject',
			typeID: pSavedType[tmpIsContract ? 'IDContractType' : 'IDProjectType'],
			protoID: pPrototype[tmpIsContract ? 'IDContract' : 'IDProject'],
			idCustomer: pSavedType.IDCustomer || this._currentIDCustomer,
		};
		if (!tmpKeys.typeID || !tmpKeys.protoID) return;

		const tmpExistingType = await this._readAllEntities(tmpKeys.typeDateEntity, tmpKeys.typeIDField, tmpKeys.typeID);
		const tmpExistingProto = await this._readAllEntities(tmpKeys.protoDateEntity, tmpKeys.protoIDField, tmpKeys.protoID);
		const tmpPlan = libProjectTypeComprehensionBuilder.computeDefaultDateReconciliation(tmpExistingType, tmpExistingProto, pGridDates, tmpKeys);

		for (const tmpRow of tmpPlan.typeUpserts) await this._upsertEntity(tmpKeys.typeDateEntity, tmpRow);
		for (const tmpRow of tmpPlan.protoUpserts) await this._upsertEntity(tmpKeys.protoDateEntity, tmpRow);
		for (const tmpID of tmpPlan.typeDeletes) await this._deleteEntity(tmpKeys.typeDateEntity, tmpID);
	}

	/**
	 * Build + push the project-type comprehension, resolve the prototype's IDProject
	 * into Settings.PrototypeIDProject, prune deselected joins on edit, and PUT statuses.
	 *
	 * @param {Object} pRecord - the editor record (with _DisplaySettings selections).
	 * @param {boolean} pIsCreate
	 * @returns {Promise<Object>} the saved ProjectType record (for PSRS).
	 */
	async saveProjectType(pRecord, pIsCreate)
	{
		const tmpDisplay = (pRecord && pRecord._DisplaySettings) || {};
		const tmpHash = pRecord.Hash || libProjectTypeComprehensionBuilder.slug(pRecord.Name || `pt-${Date.now()}`);
		const tmpExistingSettings = (pRecord.Settings && typeof pRecord.Settings === 'object') ? pRecord.Settings : this._parseSettingsJSON(pRecord.SettingsJSON);

		// External GUIDs are opaque identity keys: reuse the stored record/prototype GUIDs
		// on edit; mint fresh random UUIDs on create so a Hash reused across types or
		// customers never collides (no longer derived from Hash).
		const tmpTypeGUID = (!pIsCreate && pRecord.GUIDProjectType) ? pRecord.GUIDProjectType : this._newGUID('PT');
		const tmpProtoGUID = (tmpExistingSettings && tmpExistingSettings.PrototypeGUIDProject) || this._newGUID('PROTO');

		// Capture statuses (PUT separately to the /Statuses endpoint after the save).
		const tmpStatusDisplay = this._captureTypeStatusDisplay(pRecord);
		const tmpDefaultDates = Array.isArray(tmpDisplay.DefaultDates) ? tmpDisplay.DefaultDates : [];

		// Type scalar fields (fromDisplay strips status display from Settings).
		const tmpNormalized = libContractProjectTypesSettingsAdapter.fromDisplay(JSON.parse(JSON.stringify(pRecord)));
		const tmpTypeFields = {
			Name: pRecord.Name || '', Hash: tmpHash, Description: pRecord.Description || '',
			Ordinal: pRecord.Ordinal || 0, IDCustomer: pRecord.IDCustomer || this._currentIDCustomer, IDProgram: pRecord.IDProgram || 0,
			Settings: (tmpNormalized && tmpNormalized.Settings) || {},
		};

		// Build the comprehension: just the type + its prototype project shell. The
		// prototype's forms/observation-types/labels are configured through the normal
		// project tools (and cloned by the type-seeding service); the default dates are
		// reconciled separately by Hash (see _reconcileTypeDefaultDates), not authored here.
		const tmpComprehension = libProjectTypeComprehensionBuilder.buildProjectTypeComprehension(
			{
				typeGUID: tmpTypeGUID,
				prototypeGUID: tmpProtoGUID,
				type: tmpTypeFields,
			});

		await this._pushTypeComprehension(tmpComprehension);

		// Resolve the saved type + prototype by the GUIDs we just pushed (Hash may be
		// reused across types, so it can't identify the row), wire the numeric prototype
		// pointer into the type's Settings, reconcile the default dates, then PUT statuses.
		const tmpSavedType = await this._readEntityByFilter('ProjectType', 'GUIDProjectType', tmpTypeGUID);
		const tmpPrototype = await this._readEntityByFilter('Project', 'GUIDProject', tmpProtoGUID);
		if (tmpSavedType && tmpPrototype && tmpPrototype.IDProject)
		{
			await this._writePrototypePointer(tmpSavedType, tmpPrototype.IDProject, tmpProtoGUID);
			await this._reconcileTypeDefaultDates('ProjectType', tmpSavedType, tmpPrototype, tmpDefaultDates);
			await this._persistTypeStatuses('ProjectType', tmpSavedType, tmpSavedType, tmpStatusDisplay);
		}
		return tmpSavedType || pRecord;
	}

	/**
	 * Contract-type analogue of saveProjectType. Contracts carry no
	 * form/observation/label joins — just the type, its default-date definitions, the
	 * prototype contract, and the prototype's placeholder ContractDate rows.
	 *
	 * @param {Object} pRecord
	 * @param {boolean} pIsCreate
	 * @returns {Promise<Object>} the saved ContractType record (for PSRS).
	 */
	async saveContractType(pRecord, pIsCreate)
	{
		const tmpDisplay = (pRecord && pRecord._DisplaySettings) || {};
		const tmpHash = pRecord.Hash || libProjectTypeComprehensionBuilder.slug(pRecord.Name || `ct-${Date.now()}`);
		const tmpExistingSettings = (pRecord.Settings && typeof pRecord.Settings === 'object') ? pRecord.Settings : this._parseSettingsJSON(pRecord.SettingsJSON);
		// Opaque GUIDs: reuse the stored ones on edit; mint fresh random UUIDs on create
		// so a reused Hash never collides across types/customers (not derived from Hash).
		const tmpTypeGUID = (!pIsCreate && pRecord.GUIDContractType) ? pRecord.GUIDContractType : this._newGUID('CT');
		const tmpProtoGUID = (tmpExistingSettings && tmpExistingSettings.PrototypeGUIDContract) || this._newGUID('PROTOC');

		const tmpStatusDisplay = this._captureTypeStatusDisplay(pRecord);
		const tmpAllowedProjectTypesDisplay = tmpDisplay.AllowedProjectTypeIDs;
		const tmpDefaultDates = Array.isArray(tmpDisplay.DefaultDates) ? tmpDisplay.DefaultDates : [];
		const tmpNormalized = libContractProjectTypesSettingsAdapter.fromDisplay(JSON.parse(JSON.stringify(pRecord)));
		const tmpTypeFields = {
			Name: pRecord.Name || '', Hash: tmpHash, Description: pRecord.Description || '',
			IDCustomer: pRecord.IDCustomer || this._currentIDCustomer, Settings: (tmpNormalized && tmpNormalized.Settings) || {},
		};

		// Just the type + its prototype contract shell; the default dates are reconciled
		// separately by Hash (see _reconcileTypeDefaultDates), not authored in the comprehension.
		const tmpComprehension = libProjectTypeComprehensionBuilder.buildContractTypeComprehension(
			{ typeGUID: tmpTypeGUID, prototypeGUID: tmpProtoGUID, type: tmpTypeFields });

		await this._pushTypeComprehension(tmpComprehension);

		// Resolve the saved type by the GUID we pushed (Hash may be reused, so it can't
		// identify the row); the prototype is already resolved by its GUID.
		const tmpSavedType = await this._readEntityByFilter('ContractType', 'GUIDContractType', tmpTypeGUID);
		const tmpPrototype = await this._readEntityByFilter('Contract', 'GUIDContract', tmpProtoGUID);
		if (tmpSavedType && tmpPrototype && tmpPrototype.IDContract)
		{
			await this._writeContractPrototypePointer(tmpSavedType, tmpPrototype.IDContract, tmpProtoGUID);
			await this._reconcileTypeDefaultDates('ContractType', tmpSavedType, tmpPrototype, tmpDefaultDates);
			await this._persistTypeStatuses('ContractType', tmpSavedType, tmpSavedType, tmpStatusDisplay);
			await this._persistContractTypeAllowedProjectTypes(tmpSavedType, tmpAllowedProjectTypesDisplay);
		}
		return tmpSavedType || pRecord;
	}

	/**
	 * Resolve the editor's selected allowed-project-type values to numeric
	 * IDProjectType strings and PUT them to
	 * `/1.0/ContractType/:id/AllowedProjectTypes` (ListDefault-backed). The
	 * endpoint stores by ID — sending IDs avoids the Hash → ID lookup at the
	 * boundary that (a) required a second server round-trip for the catalog
	 * and (b) picked the wrong ID when a customer had duplicate ProjectType
	 * Hashes. Failures are logged, not thrown.
	 *
	 * @param {Object} pSavedType - the saved ContractType (for IDContractType).
	 * @param {string | undefined} pAllowedDisplay - comma-joined selected values from the editor.
	 * @returns {Promise<void>}
	 */
	async _persistContractTypeAllowedProjectTypes(pSavedType, pAllowedDisplay)
	{
		// Field absent from the editor record → leave the existing allowed list untouched.
		if (pAllowedDisplay === undefined || pAllowedDisplay === null)
		{
			return;
		}
		const tmpClient = this._typeStatusRestClient;
		const tmpID = pSavedType && pSavedType.IDContractType;
		if (!tmpClient || !tmpID)
		{
			if (!tmpClient) this.pict.log.warn('HeadlightRestClient unavailable — cannot persist ContractType allowed project types.');
			return;
		}
		const tmpSelected = libContractProjectTypesSettingsAdapter.allowedProjectTypesDisplayToPayload({ AllowedProjectTypeIDs: pAllowedDisplay });
		const tmpIDs = await this._normalizeToProjectTypeIDs(tmpSelected);
		// Wrap in { IDs: [...] } rather than PUTting the bare array: the endpoint's
		// restify bodyParser runs with mapParams:true and rejects a top-level array
		// ("Cannot map POST body ... onto req.params"). An object body maps cleanly.
		await new Promise((resolve) =>
		{
			tmpClient.putJSON(`ContractType/${tmpID}/AllowedProjectTypes`, { IDs: tmpIDs }, (pError) =>
			{
				if (pError) this.pict.log.error(`Failed to persist ContractType allowed project types for ID ${tmpID}.`, { Error: pError.message });
				return resolve();
			});
		});
	}

	/**
	 * Map selected values (typically ProjectType Hashes emitted by the picker,
	 * or a stray numeric IDProjectType) to canonical numeric IDProjectType
	 * strings; unknown values are dropped. Fetches the customer's ProjectTypes
	 * once to build the lookup.
	 *
	 * Duplicate Hashes (which would map to more than one IDProjectType) are
	 * intentionally dropped rather than silently binding to whichever record
	 * the server catalog returned last. If the ProjectType catalog fails to
	 * load, we return an empty list rather than pass the raw picker values
	 * through: the endpoint would drop them anyway (they aren't IDs), and
	 * an empty list is preferable to a silent partial write of nothing.
	 *
	 * @param {Array<string>} pValues
	 * @returns {Promise<Array<string>>} decimal ID strings
	 */
	async _normalizeToProjectTypeIDs(pValues)
	{
		const tmpValues = Array.isArray(pValues) ? pValues : [];
		if (tmpValues.length === 0)
		{
			return [];
		}
		const tmpClient = this._typeStatusRestClient;
		const tmpTypes = await new Promise((resolve) =>
		{
			if (!tmpClient) return resolve([]);
			// Scope to this customer + a real page size. A bare `ProjectTypes` relies on the server's default row cap
			// (~250) and can silently omit rows — dropping the caller's selections during this Hash→ID resolution on a
			// write path. Project types are a bounded per-customer catalog, so one generous page covers them.
			const tmpTypesURL = this._currentIDCustomer
				? `ProjectTypes/FilteredTo/FBV~IDCustomer~EQ~${this._currentIDCustomer}/0/5000`
				: 'ProjectTypes/0/5000';
			tmpClient.getJSON(tmpTypesURL, (pError, pBody) => resolve((!pError && Array.isArray(pBody)) ? pBody : []));
		});
		if (tmpTypes.length === 0)
		{
			return [];
		}
		// Build TWO indexes:
		//   idBySelfID  — direct match on "3" (rare, only when the caller
		//                 passed an already-resolved ID)
		//   idByHash    — Hash → { ID, Count }; Count > 1 means ambiguous
		const tmpIDBySelfID = new Set();
		const tmpIDByHash = {};
		for (const tmpType of tmpTypes)
		{
			if (!tmpType || tmpType.IDProjectType == null) continue;
			tmpIDBySelfID.add(String(tmpType.IDProjectType));
			if (typeof tmpType.Hash === 'string' && tmpType.Hash.length > 0)
			{
				if (!tmpIDByHash[tmpType.Hash])
				{
					tmpIDByHash[tmpType.Hash] = { ID: String(tmpType.IDProjectType), Count: 1 };
				}
				else
				{
					tmpIDByHash[tmpType.Hash].Count++;
				}
			}
		}
		const tmpSeen = new Set();
		const tmpResult = [];
		for (const tmpRaw of tmpValues)
		{
			const tmpStr = String(tmpRaw).trim();
			let tmpID = null;
			if (tmpIDBySelfID.has(tmpStr))
			{
				tmpID = tmpStr;
			}
			else
			{
				const tmpMatch = tmpIDByHash[tmpStr];
				if (tmpMatch && tmpMatch.Count === 1) tmpID = tmpMatch.ID;
			}
			if (tmpID && !tmpSeen.has(tmpID))
			{
				tmpSeen.add(tmpID);
				tmpResult.push(tmpID);
			}
		}
		return tmpResult;
	}
}

TypeComprehensionSaveProvider.default_configuration = {
	Name: 'TypeComprehensionSaveProvider',
	ProviderType: 'TypeComprehensionSaveProvider',
};

module.exports = TypeComprehensionSaveProvider;

},{"./ContractProjectTypesSettingsAdapter.js":1319,"./ProjectTypeComprehensionBuilder.js":1366,"fable-serviceproviderbase":838}],1379:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const BODY_MOUNT = '#UCW-Body';
const MESSAGE_MOUNT = '#UCW-Message';

// The editable User fields offered at CREATE, grouped for the form. A curated subset of the User columns — the
// raw manifest create form exposed internal columns (Password Reset Key, GUID, audit) that don't belong on a
// "new user" screen. Name is helpful but not required; LoginID + Email are required (a user needs a login and a
// contact address). IDCustomer is NEVER sent (the server stamps it from the session). LoginPassword is a real
// User column but is NOT set by the User POST — it rides a separate POST /1.0/Password after create (see saveAsync).
const FIELD_GROUPS =
[
	{ Name: 'Identity', Fields:
		[
			{ Key: 'NameFirst', Label: 'First Name', Type: 'text' },
			{ Key: 'NameLast', Label: 'Last Name', Type: 'text' },
			{ Key: 'Email', Label: 'Email', Type: 'text', Wide: true, Required: true },
			{ Key: 'LoginID', Label: 'Login ID', Type: 'text', Required: true },
			{ Key: 'Phone', Label: 'Phone', Type: 'text' },
		] },
	{ Name: 'Role & Organization', Fields:
		[
			{ Key: 'IDRole', Label: 'Role', Type: 'entity', Entity: 'Role', Wide: true },
			{ Key: 'Title', Label: 'Title', Type: 'text' },
			{ Key: 'Classification', Label: 'Classification', Type: 'text' },
			{ Key: 'IDProjectOffice', Label: 'Project Office ID', Type: 'number' },
		] },
	{ Name: 'Security', Fields:
		[
			{ Key: 'LoginPassword', Label: 'Login Password', Type: 'password', Wide: true },
		] },
	{ Name: 'Status', Fields:
		[
			{ Key: 'Disabled', Label: 'Disabled (cannot sign in)', Type: 'bool' },
		] },
];

// Server-side entity-picker config per relationship field (this app has no pict.EntityProvider — the picker
// searches on the server through HeadlightRestClient, mirroring ProjectCreateWorkspace). Roles are NOT scoped by
// IDCustomer here (platform + customer roles are both assignable; the server scopes what the session can read).
const PICKER_PAGE_SIZE = 25;
const ENTITY_CONFIG =
{
	IDRole: { Set: 'Roles', One: 'Role', IDField: 'IDRole', Noun: 'role', CustomerScoped: false, SearchFields: [ 'Name', 'Description', 'Type' ], IgnoreFields: [ 'IDCustomer', 'GUIDRole' ] },
};

/**
 * UserCreateWorkspace — the data layer behind the bespoke User CREATE screen. Reached by the app-router Create
 * bridge (#/PSRS/User/Create) that shadows the generic recordset create form, so "+ New" opens a curated,
 * grouped experience instead of the plain manifest form (which exposed raw columns like Password Reset Key).
 *
 * It starts from a blank working copy, POSTs a new User (IDCustomer stamped by the server — never sent), then —
 * because the User POST does NOT establish the login credential — fires the separate POST /1.0/Password with the
 * new IDUser when a password was entered (mirroring the create-time password fix + the Reset Password action).
 * On success it navigates to #/PSRS/User/View/<newGUID>, which the View bridge opens as the bespoke UserWorkspace.
 */
class UserCreateWorkspaceProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get modal()
	{
		return this.pict.providers['Pict-Section-Modal'] || (this.pict.views && this.pict.views.PictSectionModal) || null;
	}

	get currentUser()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {};
	}

	get state()
	{
		if (!this.pict.AppData.UserCreateWorkspace)
		{
			this.pict.AppData.UserCreateWorkspace =
			{
				Ready: false, Message: '', MessageClass: '', Saving: false,
				IDCustomer: 0, Fields: {}, Errors: {},
			};
		}
		return this.pict.AppData.UserCreateWorkspace;
	}

	// --- REST helpers ---

	_create(pRecord)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.createEntity('User', pRecord, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/**
	 * Set the login password on the freshly-created user. POST /1.0/Password { IDUser, NewPassword } is the ONLY
	 * call that establishes the login credential (the User column does not) — a raw fetch, since the JSON rest
	 * client can't carry this bespoke endpoint (mirrors PlatformConfiguration-Application-Web._setUserPasswordAsync
	 * and the UserWorkspace Reset Password action).
	 */
	_setUserPasswordAsync(pIDUser, pPassword)
	{
		const tmpPrefix = (this.restClient && this.restClient.options && this.restClient.options.ServerURL) || '/1.0/';
		return fetch(`${tmpPrefix}Password`,
			{
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ IDUser: pIDUser, NewPassword: pPassword }),
			})
			.then((pResponse) =>
			{
				if (!pResponse.ok) { throw new Error(`server returned ${pResponse.status}`); }
				return pResponse.json().catch(() => null).then((pBody) =>
				{
					if (pBody && (pBody.Success === false)) { throw new Error(pBody.Error || 'password not set'); }
					return pBody;
				});
			});
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	_toNumberOrNull(pValue)
	{
		if (pValue == null || String(pValue).trim() === '') { return null; }
		const tmpNumber = Number(pValue);
		return Number.isFinite(tmpNumber) ? tmpNumber : null;
	}

	// --- Start a new user ---

	/** Reset to a blank working copy and paint the empty form. Driven by the Create route bridge. */
	startNew()
	{
		const tmpState = this.state;
		tmpState.Message = '';
		tmpState.MessageClass = '';
		tmpState.Saving = false;
		tmpState.Errors = {};
		tmpState.IDCustomer = Number(this.currentUser.CustomerID) || 0;
		const tmpFields = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			// Booleans start false; entity FKs start unset as '' (not 0) so the picker shows its placeholder.
			tmpFields[pField.Key] = (pField.Type === 'bool') ? false : '';
		}));
		tmpState.Fields = tmpFields;
		tmpState.Ready = true;
		this.render();
	}

	// --- Editing ---

	/** Update one working-copy field. onchange-driven, so no re-render (the DOM already holds the value). */
	setField(pKey, pValue)
	{
		this.state.Fields[pKey] = pValue;
		if (this.state.Errors[pKey]) { delete this.state.Errors[pKey]; }
	}

	setBool(pKey, pChecked)
	{
		this.state.Fields[pKey] = !!pChecked;
	}

	_validate()
	{
		const tmpState = this.state;
		const tmpErrors = {};
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			const tmpValue = tmpState.Fields[pField.Key];
			const tmpHasValue = (tmpValue != null && String(tmpValue).trim() !== '');
			if (pField.Required && !tmpHasValue) { tmpErrors[pField.Key] = `${pField.Label} is required.`; return; }
			if (pField.Type === 'number' && tmpHasValue)
			{
				const tmpNumber = Number(tmpValue);
				if (!Number.isFinite(tmpNumber)) { tmpErrors[pField.Key] = `${pField.Label} must be a number.`; }
			}
		}));
		// A supplied password must meet the server minimum (>= 2 chars); blank is allowed (created password-less).
		const tmpPassword = tmpState.Fields.LoginPassword;
		if (tmpPassword != null && String(tmpPassword) !== '' && String(tmpPassword).length < 2)
		{
			tmpErrors.LoginPassword = 'The password must be at least 2 characters (leave blank to set it later).';
		}
		tmpState.Errors = tmpErrors;
		return Object.keys(tmpErrors).length === 0;
	}

	// --- Save / navigation ---

	async saveAsync()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		if (!this._validate())
		{
			tmpState.Message = 'Please fix the highlighted fields.';
			tmpState.MessageClass = 'is-danger';
			this.render();
			return;
		}
		tmpState.Saving = true;
		tmpState.Message = 'Creating…';
		tmpState.MessageClass = 'is-info';
		this._renderMessage();
		try
		{
			// Build the create payload — omit empty optionals so the server applies its own defaults. LoginPassword
			// is stripped (set via POST /Password after create); IDCustomer is never sent (stamped from the session).
			const tmpPassword = (tmpState.Fields.LoginPassword == null) ? '' : String(tmpState.Fields.LoginPassword);
			const tmpPayload = {};
			FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
			{
				if (pField.Key === 'LoginPassword') { return; }
				const tmpValue = tmpState.Fields[pField.Key];
				if (pField.Type === 'bool')
				{
					tmpPayload[pField.Key] = tmpValue ? 1 : 0;
				}
				else if ((pField.Type === 'number') || (pField.Type === 'entity'))
				{
					const tmpNumber = this._toNumberOrNull(tmpValue);
					if (tmpNumber != null) { tmpPayload[pField.Key] = tmpNumber; }
				}
				else if (tmpValue != null && String(tmpValue).trim() !== '')
				{
					tmpPayload[pField.Key] = tmpValue;
				}
			}));
			const tmpSaved = await this._create(tmpPayload);
			const tmpIDUser = tmpSaved && (tmpSaved.IDUser || (tmpSaved.Record && tmpSaved.Record.IDUser));
			if (!tmpSaved || tmpSaved.ErrorCode || !tmpIDUser)
			{
				throw new Error((tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode))
					? String(tmpSaved.Error || tmpSaved.ErrorCode)
					: 'the server rejected the new user (you may not have permission to create users).');
			}
			// Second call: establish the login credential. A failure here is non-fatal — the user exists and can
			// get a password via the Reset Password action — so warn rather than error out.
			if (tmpPassword)
			{
				try { await this._setUserPasswordAsync(tmpIDUser, tmpPassword); }
				catch (pPwError)
				{
					if (this.modal && (typeof this.modal.toast === 'function'))
					{
						this.modal.toast('User created, but the login password could not be set — open the user and use "Reset Password".', { type: 'warning' });
					}
				}
			}
			tmpState.Saving = false;
			this._navigateToView(tmpSaved);
		}
		catch (pError)
		{
			tmpState.Saving = false;
			tmpState.Message = `Could not create the user: ${pError.message || pError}`;
			tmpState.MessageClass = 'is-danger';
			this.render();
		}
	}

	cancel()
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = '#/PSRS/User/List';
		}
	}

	/** Land on the bespoke read workspace for the just-created user (via the View bridge). */
	_navigateToView(pSaved)
	{
		if ((typeof window !== 'undefined') && window.location)
		{
			window.location.hash = pSaved.GUIDUser ? `#/PSRS/User/View/${pSaved.GUIDUser}` : '#/PSRS/User/List';
		}
	}

	// --- Render (hand-built HTML into the shell's mount; mirrors ProjectCreateWorkspace-Provider) ---

	render()
	{
		if (this.pict.ContentAssignment.getElement(BODY_MOUNT).length === 0) { return; }
		this.pict.ContentAssignment.assignContent(BODY_MOUNT, this._bodyHTML());
		if (this.state.Ready) { this._mountPickers(); }
	}

	_mountPickers()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			if (pField.Type === 'entity') { this._mountPicker(pField.Key); }
		}));
	}

	_mountPicker(pKey)
	{
		const tmpMount = `#UCW-Picker-${pKey}`;
		if (this.pict.ContentAssignment.getElement(tmpMount).length === 0) { return; }
		const tmpConfig = ENTITY_CONFIG[pKey];
		if (!tmpConfig) { return; }
		const tmpPicker = this.pict.providers['Pict-Section-Picker'].createPicker(`UCW-Picker-${pKey}`,
			{
				DestinationAddress: tmpMount,
				ValueAddress: `AppData.UserCreateWorkspace.Fields.${pKey}`,
				Searchable: true,
				AllowClear: true,
				ClearLabel: '(none)',
				Placeholder: `Search a ${tmpConfig.Noun}…`,
				DataProvider: this._entityDataProvider(tmpConfig),
				ResolveValue: this._entityResolveValue(tmpConfig),
				Entity: tmpConfig.One,
				AllowFieldDecoration: true,
				DecorationIgnoreFields: tmpConfig.IgnoreFields,
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
	}

	_entityDataProvider(pConfig)
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		return (pSearchTerm, pPage) =>
		{
			const tmpStart = (Number(pPage) || 0) * PICKER_PAGE_SIZE;
			let tmpFilter = (pConfig.CustomerScoped === false)
				? `FBV~Deleted~EQ~0`
				: `FBV~IDCustomer~EQ~${this.state.IDCustomer}~FBV~Deleted~EQ~0`;
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).trim();
			if (tmpTerm && tmpPickerProvider && (typeof tmpPickerProvider.buildSearchFilter === 'function'))
			{
				tmpFilter += `~${tmpPickerProvider.buildSearchFilter(pConfig.SearchFields, tmpTerm)}`;
			}
			return this._getJSON(`${pConfig.Set}/FilteredTo/${tmpFilter}/${tmpStart}/${PICKER_PAGE_SIZE}`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					return { results: tmpList.map((pRow) => ({ Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${pRow[pConfig.IDField]}`, Record: pRow })), hasMore: (tmpList.length >= PICKER_PAGE_SIZE) };
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	_entityResolveValue(pConfig)
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`${pConfig.One}/${tmpID}`)
				.then((pRow) => ((pRow && pRow[pConfig.IDField]) ? { Value: Number(pRow[pConfig.IDField]), Text: pRow.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	_renderMessage()
	{
		if (this.pict.ContentAssignment.getElement(MESSAGE_MOUNT).length === 0) { this.render(); return; }
		this.pict.ContentAssignment.assignContent(MESSAGE_MOUNT, this._messageHTML());
	}

	_messageHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Message) { return ''; }
		return `<div class="notification ${this._esc(tmpState.MessageClass || 'is-info')} is-soft py-2 px-3 mb-3">${this._esc(tmpState.Message)}</div>`;
	}

	_bodyHTML()
	{
		const tmpState = this.state;
		if (!tmpState.Ready)
		{
			return `<div class="pew-empty box has-text-grey has-text-centered"><span class="pew-spinner"></span><p class="mt-3">Loading…</p></div>`;
		}
		return `<div class="pew-head">`
			+ `<div><div class="pew-eyebrow">New User</div><h1 class="pew-title">Create a user</h1></div>`
			+ `<div class="pew-head-actions">`
			+ `<button class="button is-link"${tmpState.Saving ? ' disabled' : ''} onclick="_Pict.providers.UserCreateWorkspace.saveAsync(); return false;"><span>Create user</span></button>`
			+ `<button class="button is-light" onclick="_Pict.providers.UserCreateWorkspace.cancel(); return false;"><span>Cancel</span></button>`
			+ `</div></div>`
			+ `<div id="UCW-Message">${this._messageHTML()}</div>`
			+ `<div class="pew-form">${FIELD_GROUPS.map((pGroup) => this._groupHTML(pGroup)).join('')}</div>`;
	}

	_groupHTML(pGroup)
	{
		const tmpRows = pGroup.Fields.map((pField) => this._fieldHTML(pField)).join('');
		return `<div class="pew-group"><div class="pew-group-head">${this._esc(pGroup.Name)}</div><div class="pew-grid">${tmpRows}</div></div>`;
	}

	_fieldHTML(pField)
	{
		const tmpState = this.state;
		const tmpValue = tmpState.Fields[pField.Key];
		const tmpError = tmpState.Errors[pField.Key] ? `<div class="pew-field-error">${this._esc(tmpState.Errors[pField.Key])}</div>` : '';
		const tmpWide = pField.Wide ? ' pew-field-wide' : '';
		if (pField.Type === 'bool')
		{
			const tmpChecked = tmpValue ? ' checked' : '';
			return `<div class="pew-field${tmpWide}"><label class="ucw-check"><input type="checkbox"${tmpChecked} onchange="_Pict.providers.UserCreateWorkspace.setBool('${pField.Key}', this.checked)" /> <span>${this._esc(pField.Label)}</span></label>${tmpError}</div>`;
		}
		const tmpRequired = pField.Required ? ' <span class="ucw-req">*</span>' : '';
		return `<div class="pew-field${tmpWide}"><label class="pew-field-label">${this._esc(pField.Label)}${tmpRequired}</label>${this._controlHTML(pField, tmpValue)}${tmpError}</div>`;
	}

	_controlHTML(pField, pValue)
	{
		const tmpOnChange = `onchange="_Pict.providers.UserCreateWorkspace.setField('${pField.Key}', this.value)"`;
		if (pField.Type === 'entity')
		{
			return `<div id="UCW-Picker-${pField.Key}" class="pew-input pew-picker-host"></div>`;
		}
		if (pField.Type === 'password')
		{
			return `<input class="input pew-input" type="text" autocomplete="new-password" spellcheck="false" placeholder="Leave blank to set later via Reset Password" value="${this._esc(pValue)}" style="font-family: ui-monospace, SFMono-Regular, Menlo, monospace;" ${tmpOnChange} />`;
		}
		const tmpStep = (pField.Type === 'number') ? ' step="any"' : '';
		return `<input class="input pew-input" type="${(pField.Type === 'number') ? 'number' : 'text'}"${tmpStep} value="${this._esc(pValue)}" ${tmpOnChange} />`;
	}
}

module.exports = UserCreateWorkspaceProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'UserCreateWorkspace',
	AutoInitialize: true,
	AutoInitializeOrdinal: 225,
};

},{"pict-provider":845}],1380:[function(require,module,exports){

const libPictProvider = require('pict-provider');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

/**
 * UserGroupGrants — the "Projects Granted" tab of the Access workspace, shown ONLY for a User Group
 * (Role.Type === 'UserGroup'). It answers: "which projects/labs will a user be added to when I put them in
 * this group?" — the effective set, expanded exactly the way the server's member_sync engine materializes it.
 *
 * A User Group's context grants live in the RoleContextMembership table (one row per Role↔Context: Project /
 * Lab / Contract). When a user joins the group, member_sync stamps ProjectUserJoin/LabUserJoin rows with
 * SynthesizedIDRole = the group, from EXACTLY these rows — plus it (a) fans a Contract grant out to that
 * contract's projects and (b) folds in nested child User Groups (this group's RoleEdge children whose Type is
 * UserGroup). This provider reproduces that expansion client-side so the list is truthful.
 *
 * We NEVER use the Home app's `?Joins=` query form (the config app's Meadow endpoint ignores it). Every read is
 * a plain FilteredTo; names are resolved in a second batched FBL~INN call.
 *
 * Editing (add/remove) targets the group's OWN direct RoleContextMembership rows: add = POST RoleContextMembership,
 * remove = DELETE RoleContextMembership/{id}. Grants inherited via a Contract or a nested group are shown but not
 * directly removable here (edit the contract grant, or the nested group).
 *
 * Subject + customer come from the AccessWorkspace provider; this owns AppData.AccessWorkspace.Grants.
 */
class UserGroupGrantsProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get workspace() { return this.pict.providers.AccessWorkspace; }
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get grants()
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.Grants)
		{
			tmpWorkspaceState.Grants =
			{
				SubjectID: 0, Loading: false, Loaded: false, Error: '', Truncated: false,
				Projects: [], Labs: [], Contracts: [],
				// Add-a-grant control state (the picker value addresses).
				AddScope: 'Project', AddContextID: '', AddSaving: false, AddError: '', AddNotice: '', RemovingID: 0,
			};
		}
		return tmpWorkspaceState.Grants;
	}

	// --- REST (mirrors GroupComposition) ---

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pError, pBody2) => pError ? reject(pError) : resolve(pBody2))); }
	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			const tmpMatch = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (tmpMatch) { this.restClient.deleteEntity(tmpMatch[1], tmpMatch[2], (pError, pBody) => pError ? reject(pError) : resolve(pBody)); return; }
			const tmpBase = this.restClient.serverURL || '/1.0/';
			fetch(`${tmpBase}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((pResponse) => { if (!pResponse.ok) { reject(new Error(`HTTP ${pResponse.status}`)); return; } pResponse.text().then((pText) => resolve(pText ? JSON.parse(pText) : {})).catch(() => resolve({})); })
				.catch(reject);
		});
	}

	/** Count-then-page a filtered set (no ?Joins=). */
	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 2000;
		let tmpTotal = tmpCap;
		try { const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`); tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap); }
		catch (pError) { tmpTotal = tmpCap; }
		if (!tmpTotal) { return { rows: [], truncated: false }; }
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return { rows: (Array.isArray(tmpRows) ? tmpRows : []), truncated: (tmpTotal >= tmpCap) };
	}

	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	/** Batch-resolve entity ids → names (no ?Joins=): FBL~<IDField>~INN~<ids>. Best-effort; unknown ids fall back to #id. */
	async _resolveNames(pEntitySet, pIDField, pIDs)
	{
		const tmpUnique = Array.from(new Set((pIDs || []).map(Number).filter((pID) => pID > 0)));
		const tmpMap = {};
		if (!tmpUnique.length) { return tmpMap; }
		// Chunk the INN list so a group granting hundreds of contexts doesn't build an unbounded filter.
		const tmpChunk = 200;
		for (let i = 0; i < tmpUnique.length; i += tmpChunk)
		{
			const tmpSlice = tmpUnique.slice(i, i + tmpChunk);
			try
			{
				/* eslint-disable-next-line no-await-in-loop */
				const tmpResult = await this._getFilteredAll(pEntitySet, `FBL~${pIDField}~INN~${tmpSlice.join(',')}~FBV~Deleted~EQ~0`, tmpChunk);
				tmpResult.rows.forEach((pRow) => { if (pRow && (pRow[pIDField] != null)) { tmpMap[Number(pRow[pIDField])] = pRow.Name || pRow.Description || ''; } });
			}
			catch (pError) { /* leave unresolved ids to fall back to #id */ }
		}
		return tmpMap;
	}

	// --- Load + expand (the truthful effective set) ---

	/**
	 * Collect the RoleContextMemberships that member_sync would materialize for a user placed in this group:
	 * the group's OWN rows (marked direct, carrying the IDRoleContextMembership so they can be removed) plus
	 * those of its DIRECT child User Groups. This is ONE level only — it mirrors member_sync's
	 * `resolveRoleContextMemberships` exactly ("for now, looking 1 level in both directions"): it does NOT
	 * recurse into grandchildren, so it never shows a project a user would not actually receive. Child-group
	 * Types/Names are resolved from the SERVER (`Roles/…INN…~FBV~Type~EQ~UserGroup`), not the partial rail list.
	 */
	async _collectGrants(pTopIDRole)
	{
		const tmpTop = Number(pTopIDRole);
		const tmpGrants = [];
		let tmpTruncated = false;
		// Direct child User Groups (one level): RoleEdges with ParentIDRole=top, children whose Type='UserGroup'.
		const tmpEdges = await this._getFilteredAll('RoleEdges', `FBV~ParentIDRole~EQ~${tmpTop}~FBV~Deleted~EQ~0`);
		const tmpChildIDs = Array.from(new Set(tmpEdges.rows.map((pEdge) => Number(pEdge.ChildIDRole)).filter((pID) => pID > 0 && pID !== tmpTop)));
		const tmpChildGroupNames = {};
		for (let i = 0; i < tmpChildIDs.length; i += 150)
		{
			const tmpSlice = tmpChildIDs.slice(i, i + 150);
			/* eslint-disable-next-line no-await-in-loop */
			const tmpRoles = await this._getFilteredAll('Roles', `FBL~IDRole~INN~${tmpSlice.join(',')}~FBV~Type~EQ~UserGroup~FBV~Deleted~EQ~0`, 500);
			tmpRoles.rows.forEach((pRole) => { tmpChildGroupNames[Number(pRole.IDRole)] = pRole.Name || `#${pRole.IDRole}`; });
		}
		// Fetch RCMs for the group + its direct child User Groups (batched INN — one query per ~150 ids).
		const tmpRoleIDs = [ tmpTop ].concat(Object.keys(tmpChildGroupNames).map(Number));
		for (let i = 0; i < tmpRoleIDs.length; i += 150)
		{
			const tmpSlice = tmpRoleIDs.slice(i, i + 150);
			/* eslint-disable-next-line no-await-in-loop */
			const tmpRCM = await this._getFilteredAll('RoleContextMemberships', `FBL~IDRole~INN~${tmpSlice.join(',')}`);
			if (tmpRCM.truncated) { tmpTruncated = true; }
			tmpRCM.rows.forEach((pRow) =>
			{
				const tmpIDRole = Number(pRow.IDRole);
				const tmpIsTop = (tmpIDRole === tmpTop);
				tmpGrants.push(
					{
						Context: pRow.Context, IDContext: Number(pRow.IDContext) || 0,
						IDRCM: tmpIsTop ? (Number(pRow.IDRoleContextMembership) || 0) : 0,
						SourceLabel: tmpIsTop ? 'direct' : `via group ${tmpChildGroupNames[tmpIDRole] || `#${tmpIDRole}`}`,
					});
			});
		}
		return { grants: tmpGrants, truncated: tmpTruncated };
	}

	async loadGrantsAsync(pForce)
	{
		const tmpWorkspaceState = this.workspace.state;
		if (!tmpWorkspaceState.SubjectRecord || !this.workspace.isUserGroup) { return; }
		const tmpID = Number(tmpWorkspaceState.SubjectID);
		const tmpGrants = this.grants;
		if (tmpGrants.Loaded && !pForce && (tmpGrants.SubjectID === tmpID)) { this._render(); return; }
		tmpGrants.SubjectID = tmpID; tmpGrants.Loaded = false; tmpGrants.Error = ''; tmpGrants.Loading = true; tmpGrants.Truncated = false;
		this._render();
		try
		{
			const tmpCollected = await this._collectGrants(tmpID);
			const tmpAll = tmpCollected.grants;
			const tmpProjectGrants = tmpAll.filter((pGrant) => pGrant.Context === 'Project');
			const tmpLabGrants = tmpAll.filter((pGrant) => pGrant.Context === 'Lab');
			const tmpContractGrants = tmpAll.filter((pGrant) => pGrant.Context === 'Contract');

			// Resolve names for the directly-referenced projects / labs / contracts.
			const tmpProjNames = await this._resolveNames('Projects', 'IDProject', tmpProjectGrants.map((pGrant) => pGrant.IDContext));
			const tmpLabNames = await this._resolveNames('Labs', 'IDLab', tmpLabGrants.map((pGrant) => pGrant.IDContext));
			const tmpContractNames = await this._resolveNames('Contracts', 'IDContract', tmpContractGrants.map((pGrant) => pGrant.IDContext));

			// Build the effective PROJECT set (deduped), tracking each source + whether a direct grant is removable.
			const tmpProjectsByID = {};
			const fAddProject = (pIDProject, pName, pSourceLabel, pDirectIDRCM) =>
			{
				const tmpKey = Number(pIDProject) || 0;
				if (!tmpKey) { return; }
				if (!tmpProjectsByID[tmpKey]) { tmpProjectsByID[tmpKey] = { ID: tmpKey, Name: '', Sources: {}, DirectIDRCM: 0 }; }
				const tmpEntry = tmpProjectsByID[tmpKey];
				if (pName && (!tmpEntry.Name || tmpEntry.Name.charAt(0) === '#')) { tmpEntry.Name = pName; }
				tmpEntry.Sources[pSourceLabel] = true;
				if (pDirectIDRCM) { tmpEntry.DirectIDRCM = pDirectIDRCM; }
			};
			// Direct Project grants — drop any whose project no longer resolves (deleted), matching member_sync,
			// which filters RCMs pointing at deleted context entities before it materializes anything.
			tmpProjectGrants.forEach((pGrant) => { if (tmpProjNames[pGrant.IDContext]) { fAddProject(pGrant.IDContext, tmpProjNames[pGrant.IDContext], pGrant.SourceLabel, pGrant.IDRCM); } });
			// Fan each Contract grant out to that contract's projects (what member_sync's resolveContractProjectIDs
			// does). Skip a grant whose contract itself is deleted (unresolved name) — member_sync drops it too.
			for (let i = 0; i < tmpContractGrants.length; i++)
			{
				const tmpContract = tmpContractGrants[i];
				if (!tmpContractNames[tmpContract.IDContext]) { continue; }
				const tmpLabel = `via contract ${tmpContractNames[tmpContract.IDContext]}`;
				/* eslint-disable-next-line no-await-in-loop */
				const tmpContractProjects = await this._getFilteredAll('Projects', `FBV~IDContract~EQ~${tmpContract.IDContext}~FBV~Deleted~EQ~0`);
				if (tmpContractProjects.truncated) { tmpCollected.truncated = true; }
				tmpContractProjects.rows.forEach((pProject) => fAddProject(Number(pProject.IDProject), pProject.Name, tmpLabel, 0));
			}

			// Effective LAB set (no fan-out); drop deleted labs the same way.
			const tmpLabsByID = {};
			tmpLabGrants.forEach((pGrant) =>
			{
				const tmpKey = Number(pGrant.IDContext) || 0;
				if (!tmpKey || !tmpLabNames[tmpKey]) { return; }
				if (!tmpLabsByID[tmpKey]) { tmpLabsByID[tmpKey] = { ID: tmpKey, Name: tmpLabNames[tmpKey], Sources: {}, DirectIDRCM: 0 }; }
				tmpLabsByID[tmpKey].Sources[pGrant.SourceLabel] = true;
				if (pGrant.IDRCM) { tmpLabsByID[tmpKey].DirectIDRCM = pGrant.IDRCM; }
			});

			// The group's OWN direct Contract grants (removable; shown as a section). Deleted contracts dropped.
			const tmpDirectContracts = {};
			tmpContractGrants.filter((pGrant) => pGrant.IDRCM && tmpContractNames[pGrant.IDContext]).forEach((pGrant) =>
			{
				const tmpKey = Number(pGrant.IDContext) || 0;
				if (tmpKey && !tmpDirectContracts[tmpKey]) { tmpDirectContracts[tmpKey] = { ID: tmpKey, Name: tmpContractNames[tmpKey], IDRCM: pGrant.IDRCM }; }
			});

			const fSort = (pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || ''));
			tmpGrants.Projects = Object.keys(tmpProjectsByID).map((pKey) => this._effectiveRow(tmpProjectsByID[pKey])).sort(fSort);
			tmpGrants.Labs = Object.keys(tmpLabsByID).map((pKey) => this._effectiveRow(tmpLabsByID[pKey])).sort(fSort);
			tmpGrants.Contracts = Object.keys(tmpDirectContracts).map((pKey) => tmpDirectContracts[pKey]).sort(fSort);
			tmpGrants.Truncated = tmpCollected.truncated;
			tmpGrants.Loaded = true;
		}
		catch (pError) { tmpGrants.Error = `Could not load granted projects: ${pError && pError.message ? pError.message : pError}`; }
		tmpGrants.Loading = false;
		this._render();
	}

	_effectiveRow(pEntry)
	{
		const tmpSources = Object.keys(pEntry.Sources || {});
		return { ID: pEntry.ID, Name: pEntry.Name || `#${pEntry.ID}`, Sources: tmpSources, DirectIDRCM: pEntry.DirectIDRCM || 0 };
	}

	// --- Mutations (edit the group's OWN direct grants) ---

	setAddScope(pScope) { this.grants.AddScope = (pScope === 'Lab' || pScope === 'Contract') ? pScope : 'Project'; this.grants.AddContextID = ''; this.grants.AddError = ''; this.grants.AddNotice = ''; this._render(); }

	async addGrantAsync()
	{
		const tmpGrants = this.grants;
		if (!this.workspace.isRoleManager || tmpGrants.AddSaving) { return; }
		const tmpIDRole = Number(this.workspace.state.SubjectID);
		const tmpScope = tmpGrants.AddScope || 'Project';
		const tmpIDContext = Number(tmpGrants.AddContextID) || 0;
		if (!(tmpIDRole > 0)) { return; }
		if (!tmpIDContext) { tmpGrants.AddError = `Pick a ${tmpScope.toLowerCase()} to grant.`; tmpGrants.AddNotice = ''; this._render(); return; }
		tmpGrants.AddSaving = true; tmpGrants.AddError = ''; tmpGrants.AddNotice = '';
		this._render();
		const tmpRes = await this._postJSON('RoleContextMembership', { Context: tmpScope, IDContext: tmpIDContext, IDRole: tmpIDRole, IDCustomer: Number(this.workspace.idCustomer) || 0 });
		tmpGrants.AddSaving = false;
		if (tmpRes && tmpRes.error) { tmpGrants.AddError = `Could not add the grant: ${(tmpRes.error && tmpRes.error.message) || tmpRes.error} (you may lack permission).`; this._render(); return; }
		tmpGrants.AddNotice = `${tmpScope} grant added.`;
		tmpGrants.AddContextID = '';
		await this.loadGrantsAsync(true);
	}

	async removeGrantAsync(pIDRCM)
	{
		const tmpGrants = this.grants;
		if (!this.workspace.isRoleManager || tmpGrants.RemovingID) { return; }
		const tmpID = Number(pIDRCM) || 0;
		if (!tmpID) { return; }
		tmpGrants.RemovingID = tmpID; tmpGrants.AddError = ''; tmpGrants.AddNotice = '';
		this._render();
		try { await this._deleteJSON(`RoleContextMembership/${tmpID}`); tmpGrants.AddNotice = 'Grant removed.'; }
		catch (pError) { tmpGrants.RemovingID = 0; tmpGrants.AddError = `Could not remove the grant: ${pError && pError.message ? pError.message : pError}`; this._render(); return; }
		tmpGrants.RemovingID = 0;
		await this.loadGrantsAsync(true);
	}

	// --- Add-a-grant context picker (Project / Lab / Contract) ---

	_contextDataProvider(pScope)
	{
		const tmpMap = { Lab: { Set: 'Labs', ID: 'IDLab' }, Contract: { Set: 'Contracts', ID: 'IDContract' } };
		const tmpDef = tmpMap[pScope] || { Set: 'Projects', ID: 'IDProject' };
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Set: tmpDef.Set, IDField: tmpDef.ID, PageSize: 40, Scope: `FBV~IDCustomer~EQ~${Number(this.workspace.idCustomer) || 0}~FBV~Deleted~EQ~0`,
				ToOption: (pRow) => ({ Value: Number(pRow[tmpDef.ID]), Text: pRow.Name || pRow.Description || `#${pRow[tmpDef.ID]}`, Record: pRow }),
			});
	}
	_contextResolveValue(pScope)
	{
		const tmpMap = { Lab: { Set: 'Lab', ID: 'IDLab' }, Contract: { Set: 'Contract', ID: 'IDContract' } };
		const tmpDef = tmpMap[pScope] || { Set: 'Project', ID: 'IDProject' };
		return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`${tmpDef.Set}/${tmpID}`).then((pRow) => ((pRow && pRow[tmpDef.ID]) ? { Value: tmpID, Text: pRow.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })).catch(() => ({ Value: tmpID, Text: `#${tmpID}` })); };
	}

	mountGrantPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#acw-grant-picker').length === 0) { return; }
		const tmpScope = this.grants.AddScope || 'Project';
		const tmpView = tmpPicker.createPicker('AccessWorkspace-GrantPicker',
			{
				DestinationAddress: '#acw-grant-picker', ValueAddress: 'AppData.AccessWorkspace.Grants.AddContextID',
				Searchable: true, AllowClear: true, ClearLabel: `— pick a ${tmpScope.toLowerCase()} —`, Placeholder: `Search ${tmpScope.toLowerCase()}s…`,
				DataProvider: this._contextDataProvider(tmpScope), ResolveValue: this._contextResolveValue(tmpScope),
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
		if (tmpView && (typeof tmpView.setValue === 'function')) { tmpView.setValue(this.grants.AddContextID || ''); }
	}

	// --- Render (host-div paint, called from AccessWorkspace.onAfterRender) ---

	renderGrantsHost()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#acw-grants-host').length === 0) { return; }
		tmpCA.assignContent('#acw-grants-host', this._grantsHostHTML());
		this.mountGrantPicker();
	}

	_sourceBadgesHTML(pRow)
	{
		const tmpSources = pRow.Sources || [];
		// A popular project can be granted by a dozen sibling groups; showing every badge makes an unreadably tall
		// row, so cap the visible badges and fold the rest into a "+N more" chip that lists them all on hover.
		const tmpCap = 4;
		const tmpShown = tmpSources.slice(0, tmpCap).map((pSource) =>
			(pSource === 'direct')
				? '<span class="acw-grant-src acw-grant-src-direct">direct</span>'
				: `<span class="acw-grant-src acw-grant-src-via">${this._esc(pSource)}</span>`).join('');
		if (tmpSources.length <= tmpCap) { return tmpShown; }
		const tmpRest = tmpSources.slice(tmpCap);
		return `${tmpShown}<span class="acw-grant-src acw-grant-src-more" title="${this._esc(tmpRest.join('  •  '))}">+${tmpRest.length} more</span>`;
	}

	_effectiveRowHTML(pRow, pKind)
	{
		const tmpRemovable = this.workspace.isRoleManager && pRow.DirectIDRCM;
		const tmpRemove = tmpRemovable
			? `<button class="acw-grant-x" title="Remove this ${pKind} grant from the group" onclick="_Pict.providers.UserGroupGrants.removeGrantAsync(${Number(pRow.DirectIDRCM)})"><span class="icon is-small"><i class="fas fa-xmark"></i></span></button>` : '';
		return `<div class="acw-grant-row"><span class="acw-grant-name">${this._esc(pRow.Name)}</span><span class="acw-grant-id">#${Number(pRow.ID)}</span><span class="acw-grant-srcs">${this._sourceBadgesHTML(pRow)}</span>${tmpRemove}</div>`;
	}

	_sectionHTML(pTitle, pRows, pKind, pEmptyText)
	{
		// Cap the rendered rows — a group granting a large contract can fan out to hundreds of projects; render the
		// first RENDER_CAP and note the rest so the DOM stays light and the count stays honest.
		const tmpRenderCap = 300;
		let tmpBody;
		if (!pRows.length) { tmpBody = `<p class="acw-grant-empty">${this._esc(pEmptyText)}</p>`; }
		else
		{
			tmpBody = pRows.slice(0, tmpRenderCap).map((pRow) => this._effectiveRowHTML(pRow, pKind)).join('');
			if (pRows.length > tmpRenderCap) { tmpBody += `<p class="acw-grant-empty">Showing the first ${tmpRenderCap} of ${pRows.length}.</p>`; }
		}
		return `<div class="acw-grant-section"><div class="acw-grant-head"><span>${this._esc(pTitle)}</span><span class="acw-grant-count">${pRows.length}</span></div>${tmpBody}</div>`;
	}

	_contractSectionHTML(pContracts)
	{
		if (!pContracts.length) { return ''; }
		const tmpRows = pContracts.map((pContract) =>
		{
			const tmpRemove = this.workspace.isRoleManager
				? `<button class="acw-grant-x" title="Remove this contract grant" onclick="_Pict.providers.UserGroupGrants.removeGrantAsync(${Number(pContract.IDRCM)})"><span class="icon is-small"><i class="fas fa-xmark"></i></span></button>` : '';
			return `<div class="acw-grant-row"><span class="icon acw-grant-cicon"><i class="fas fa-file-contract"></i></span><span class="acw-grant-name">${this._esc(pContract.Name)}</span><span class="acw-grant-id">#${Number(pContract.ID)}</span><span class="acw-grant-srcs"><span class="acw-grant-src acw-grant-src-via">covers its projects (above)</span></span>${tmpRemove}</div>`;
		}).join('');
		return `<div class="acw-grant-section"><div class="acw-grant-head"><span>Contract grants</span><span class="acw-grant-count">${pContracts.length}</span></div>${tmpRows}</div>`;
	}

	_addBlockHTML()
	{
		if (!this.workspace.isRoleManager) { return ''; }
		const tmpGrants = this.grants;
		const tmpScope = tmpGrants.AddScope || 'Project';
		const tmpNotice = tmpGrants.AddNotice ? `<div class="acw-grant-notice">${this._esc(tmpGrants.AddNotice)}</div>` : '';
		const tmpError = tmpGrants.AddError ? `<div class="acw-grant-error">${this._esc(tmpGrants.AddError)}</div>` : '';
		const tmpBusy = tmpGrants.AddSaving ? '<span class="acw-grant-busy">saving…</span>' : '';
		return `<div class="acw-grant-add">
			<div class="acw-grant-add-head">Grant a project, lab, or contract to this group</div>
			<div class="acw-grant-add-row">
				<div class="acw-grant-field"><label class="acw-grant-flabel">Type</label>
					<div class="select"><select onchange="_Pict.providers.UserGroupGrants.setAddScope(this.value)">
						<option value="Project"${tmpScope === 'Project' ? ' selected' : ''}>Project</option>
						<option value="Lab"${tmpScope === 'Lab' ? ' selected' : ''}>Lab</option>
						<option value="Contract"${tmpScope === 'Contract' ? ' selected' : ''}>Contract</option>
					</select></div>
				</div>
				<div class="acw-grant-field"><label class="acw-grant-flabel">${this._esc(tmpScope)}</label><div id="acw-grant-picker" class="acw-grant-picker"></div></div>
				<button class="acw-grant-btn" onclick="_Pict.providers.UserGroupGrants.addGrantAsync()">Add grant</button>${tmpBusy}
			</div>
			${tmpNotice}${tmpError}
		</div>`;
	}

	_grantsHostHTML()
	{
		const tmpGrants = this.grants;
		const tmpHelp = `<p class="pw-help" style="margin:0 0 0.8rem">The projects and labs a user is added to when placed in this group — including projects from any <strong>contract</strong> grants and any <strong>nested user groups</strong> this group includes. Direct grants can be removed here.</p>`;
		if (tmpGrants.Loading && !tmpGrants.Loaded) { return `${tmpHelp}<div class="pw-empty box has-text-grey has-text-centered"><span class="pw-spinner"></span><p class="mt-3">Loading granted projects…</p></div>`; }
		if (tmpGrants.Error && !tmpGrants.Loaded) { return `${tmpHelp}<div class="notification is-warning is-soft py-2 px-3">${this._esc(tmpGrants.Error)}</div>${this._addBlockHTML()}`; }
		const tmpTrunc = tmpGrants.Truncated ? `<div class="acw-grant-notice">Some lists were large and may be truncated.</div>` : '';
		return `${tmpHelp}${tmpTrunc}`
			+ this._sectionHTML('Projects', tmpGrants.Projects, 'project', 'This group grants no projects.')
			+ this._sectionHTML('Labs', tmpGrants.Labs, 'lab', 'This group grants no labs.')
			+ this._contractSectionHTML(tmpGrants.Contracts)
			+ this._addBlockHTML();
	}

	_render() { if (this.pict.views.AccessWorkspace) { this.pict.views.AccessWorkspace.render(); } }
}

module.exports = UserGroupGrantsProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'UserGroupGrants',
	AutoInitialize: true,
	AutoInitializeOrdinal: 4,
};

},{"../services/Entity-Picker-Search.js":1398,"pict-provider":845}],1381:[function(require,module,exports){
'use strict';

const libWorkspace = require('pict-section-workspace');
const libRoleDates = require('../access/RoleAssignment-Dates.js');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

// UserWorkspace — refactored onto pict-section-workspace. The base owns the shell (header, tab bar, routing,
// load); this subclass carries the bespoke User surfaces: an editable Overview, the three legacy user-admin
// actions (reset password, impersonate, edit), the Roles & Groups read panel, the Certifications editor, and
// the per-user Activity dashboard (embedded from ActivityObservability). The Projects tab is a plain
// association editor (base `assoc` kind, ProjectUser). Config in [[User.config.js]]. Mirrors [[ContractWorkspace-Provider.js]].

// User.IDRole is NOT a Roles FK — it is the base permission LEVEL (0-5). Canonical level names (mirrors the
// legacy user admin's role list: web/app_headlight/src/components/RoleSelector.vue / UserListPage.vue).
const USER_LEVEL_NAMES =
{
	0: 'Read Only',
	1: 'Field Personnel',
	2: 'Office Staff',
	3: 'Office Manager',
	4: 'Executive Manager',
	5: 'Pavia Administrator',
};

// Overview groups. `Edit` marks a field editable in edit mode ('text' | 'number' | 'bool'); the rest (and the
// Audit group) are read-only. Credential columns + SettingsJSON are intentionally not listed.
const FIELD_GROUPS =
[
	{ Name: 'Identity', Fields:
		[
			{ Key: 'NameFirst', Label: 'First Name', Edit: 'text' },
			{ Key: 'NameLast', Label: 'Last Name', Edit: 'text' },
			{ Key: 'Email', Label: 'Email', Wide: true, Edit: 'text' },
			{ Key: 'LoginID', Label: 'Login ID', Edit: 'text' },
			{ Key: 'Phone', Label: 'Phone', Edit: 'text' },
		] },
	{ Name: 'Role & Organization', Fields:
		[
			{ Key: 'IDRole', Label: 'Role', Level: true, Edit: 'number' },
			{ Key: 'Title', Label: 'Title', Edit: 'text' },
			{ Key: 'Classification', Label: 'Classification', Edit: 'text' },
			{ Key: 'IDCustomer', Label: 'Customer', Card: 'Customer', Edit: 'number' },
			{ Key: 'IDProjectOffice', Label: 'Project Office', Card: 'ProjectOffice', Edit: 'number' },
		] },
	{ Name: 'Status', Fields:
		[
			{ Key: 'Disabled', Label: 'Disabled', Format: 'bool', Edit: 'bool' },
			{ Key: 'EmailPending', Label: 'Email Pending', Format: 'bool', Edit: 'bool' },
			{ Key: 'Timezone', Label: 'Timezone', Edit: 'text' },
			{ Key: 'Shift', Label: 'Shift', Edit: 'text' },
			{ Key: 'LastLoginTime', Label: 'Last Login', Format: 'date' },
		] },
	{ Name: 'Audit', Fields:
		[
			{ Key: 'CreateDate', Label: 'Created', Format: 'date' },
			{ Key: 'UpdateDate', Label: 'Last Updated', Format: 'date' },
			{ Key: 'GUIDUser', Label: 'GUID', Mono: true },
			{ Key: 'IDUser', Label: 'User ID', Format: 'id' },
		] },
];

class UserWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._user = null;
		this._pwInputEl = null;
		this._editing = false;
		this._edit = null;
		this._savingEdit = false;
		this._relatedDisplay = {};
		this._roleScopes = null;
		this._rolesLoading = false;
		this._rolesError = '';
		this._rolesLoadedFor = null;
		this._certs = null;
		this._certsLoading = false;
		this._certsError = '';
		this._certsLoadedFor = null;
		this._certTypeNames = {};
		this._certAdd = { On: '', Start: '', End: '', Notes: '' };
		this._certBusy = false;
		this._certNotice = '';
		this._rolesBusy = false;
		this._rolesNotice = '';
	}

	get currentUser() { return (this.pict && this.pict.AppData && this.pict.AppData.CurrentUser) || {}; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'success' }); } }
	get _prefix() { return (this.restClient && this.restClient.options && this.restClient.options.ServerURL) || '/1.0/'; }
	_deleteEntity(pEntity, pID) { return new Promise((resolve) => { if (this.restClient && (typeof this.restClient.deleteEntity === 'function')) { this.restClient.deleteEntity(pEntity, pID, (pError) => resolve(!pError)); } else { resolve(false); } }); }
	_escape(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	/** The base has no `_render`; the ported methods below call it — route it to a full workspace repaint. */
	_render() { this.renderWorkspace(); }
	/** The certification picker binds to AppData.UserWorkspace.CertAddTypeID; base `state` IS AppData.UserWorkspace. */
	get workspaceState() { return this.state; }
	get idUser() { return this._user ? this._user.IDUser : null; }

	// --- hydrate (runs inside the base load, after the User record arrives) ---
	async hydrateAsync(pRecord)
	{
		this._user = pRecord;
		this._editing = false; this._edit = null; this._savingEdit = false;
		this._roleScopes = null; this._rolesLoadedFor = null; this._rolesError = ''; this._rolesLoading = false;
		this._certs = null; this._certsLoadedFor = null; this._certsError = ''; this._certsLoading = false;
		this._certAdd = { On: '', Start: '', End: '', Notes: '' };
		this.state.CertAddTypeID = '';
		this._relatedDisplay = {};
		this._resolveRelatedDisplayAsync(pRecord);
		this._rolesBusy = false; this._rolesNotice = '';
		this.state.RoleAddID = ''; this.state.RoleAddScope = 'Customer'; this.state.RoleAddContextID = ''; this.state.RoleAddExpires = ''; this.state.RoleAddStarts = '';
	}

	// --- Permissions (mirror the server gates) ---
	get canResetPassword()
	{
		if (!this._user) { return false; }
		const tmpSession = this.currentUser;
		if (Number(tmpSession.IDUser) === Number(this._user.IDUser)) { return true; }
		return Number(tmpSession.UserRoleIndex) > Number(this._user.IDRole);
	}
	get canImpersonate()
	{
		if (!this._user) { return false; }
		const tmpSession = this.currentUser;
		if (Number(tmpSession.IDUser) === Number(this._user.IDUser)) { return false; }
		return Number(tmpSession.UserRoleIndex) >= 5;
	}
	get canEditUser()
	{
		if (!this._user) { return false; }
		const tmpSession = this.currentUser;
		return (Number(tmpSession.IDUser) === Number(this._user.IDUser)) || (Number(tmpSession.UserRoleIndex) >= 4);
	}
	/** Real hash-precise gate (mirrors ProjectStaffing). Fail-OPEN before the capability map loads; the server is
	 *  authoritative (both grant + remove check User-Role-Associate — there is no User-Role-Disassociate hash). */
	_can(pEntity, pAction)
	{
		const tmpApp = this.pict.fable;   // the EffectivePermissionsService lives on fable, not the app instance
		if (tmpApp && tmpApp.EffectivePermissionsService && (typeof tmpApp.EffectivePermissionsService.can === 'function')) { return tmpApp.EffectivePermissionsService.can(pEntity, pAction); }
		return true;
	}
	get canManageRoles() { return !!this._user && this._can('User-Role', 'Associate'); }
	/** Raw DELETE (the base only has _deleteEntity(entity,id)); Entity/<id> paths go through it, custom paths direct. */
	_deleteJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			const tmpMatch = /^([A-Za-z][A-Za-z0-9]*)\/(\d+)$/.exec(String(pURL));
			if (tmpMatch) { this.restClient.deleteEntity(tmpMatch[1], tmpMatch[2], (pError, pBody) => pError ? reject(pError) : resolve(pBody)); return; }
			fetch(`${this._prefix}${pURL}`, { method: 'DELETE', credentials: 'include' })
				.then((pResponse) =>
				{
					if (!pResponse.ok) { reject(new Error(`HTTP ${pResponse.status}`)); return; }
					pResponse.text().then((pText) => resolve(pText ? JSON.parse(pText) : {})).catch(() => resolve({}));
				})
				.catch(reject);
		});
	}

	// --- Overview (bespoke render: read or inline-edit) ---
	_fmtField(pField, pValue)
	{
		if (pField.Format === 'bool')
		{
			if (pValue == null || pValue === '') { return '—'; }
			const tmpTruthy = (pValue === true) || (pValue === 1) || (pValue === '1') || (String(pValue).toLowerCase() === 'true');
			return tmpTruthy ? 'Yes' : 'No';
		}
		if (pValue == null || pValue === '') { return '—'; }
		switch (pField.Format)
		{
		case 'number': { const tmpN = Number(pValue); return Number.isFinite(tmpN) ? tmpN.toLocaleString('en-US') : String(pValue); }
		case 'id': { const tmpN = Number(pValue); return Number.isFinite(tmpN) ? String(Math.trunc(tmpN)) : String(pValue); }
		case 'date':
		{
			const tmpString = String(pValue);
			if (tmpString.indexOf('0000-00-00') === 0) { return '—'; }
			const tmpDate = new Date(tmpString);
			return Number.isNaN(tmpDate.getTime()) ? tmpString : tmpDate.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
		}
		default: return String(pValue);
		}
	}

	/** Read-mode display string for an Overview field: resolved level name, resolved FK name (0 -> em-dash), else formatted. */
	_displayValue(pField)
	{
		const tmpRaw = this._user ? this._user[pField.Key] : null;
		if (pField.Level)
		{
			if ((tmpRaw == null) || (tmpRaw === '')) { return '—'; }
			return USER_LEVEL_NAMES[Number(tmpRaw)] || `Level ${tmpRaw}`;
		}
		if (pField.Card)
		{
			if ((tmpRaw == null) || (Number(tmpRaw) <= 0)) { return '—'; }
			return (this._relatedDisplay && this._relatedDisplay[pField.Key]) || String(Math.trunc(Number(tmpRaw)));
		}
		return this._fmtField(pField, tmpRaw);
	}

	/**
	 * Resolve display names for the user's related entities (Customer, Project Office) so the Overview
	 * "Role & Organization" fields render names rather than raw ids. Best-effort; re-renders when names
	 * arrive, and unresolved targets fall back to the id. (IDRole is a static level, resolved inline.)
	 */
	async _resolveRelatedDisplayAsync(pUser)
	{
		if (!pUser) { return; }
		const tmpTargets = [];
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			const tmpID = pUser[pField.Key];
			if (pField.Card && (tmpID != null) && (Number(tmpID) > 0)) { tmpTargets.push({ Key: pField.Key, RecordSet: pField.Card, ID: tmpID }); }
		}));
		if (!tmpTargets.length) { return; }
		const tmpDisplay = {};
		await Promise.all(tmpTargets.map(async (pTarget) =>
		{
			try
			{
				const tmpRecord = await this._getJSON(`${pTarget.RecordSet}/${pTarget.ID}`);
				if (tmpRecord && !tmpRecord.Error) { tmpDisplay[pTarget.Key] = tmpRecord.Name || tmpRecord.DisplayName || tmpRecord.Title || String(pTarget.ID); }
			}
			catch (pError) { /* leave unresolved -> the field falls back to the id */ }
		}));
		this._relatedDisplay = Object.assign({}, this._relatedDisplay, tmpDisplay);
		if (this._user && (Number(this._user.IDUser) === Number(pUser.IDUser))) { this._render(); }
	}
	_isTruthy(pValue) { return (pValue === true) || (pValue === 1) || (pValue === '1') || (String(pValue).toLowerCase() === 'true'); }

	renderOverview()
	{
		if (!this._user) { return ''; }
		return FIELD_GROUPS.map((pGroup) =>
		{
			const tmpFields = pGroup.Fields.map((pField) =>
			{
				const tmpEditable = this._editing && (pField.Edit === 'text' || pField.Edit === 'number' || pField.Edit === 'bool');
				const tmpWide = pField.Wide ? ' pw-field-wide' : '';
				let tmpValHTML;
				if (!tmpEditable)
				{
					const tmpMono = pField.Mono ? ' pw-field-mono' : '';
					tmpValHTML = `<span class="pw-field-value${tmpMono}">${this._esc(this._displayValue(pField))}</span>`;
				}
				else if (pField.Edit === 'bool')
				{
					tmpValHTML = `<label class="uw-check"><input type="checkbox" ${this._isTruthy(this._edit[pField.Key]) ? 'checked' : ''} onchange="_Pict.providers.UserWorkspace.editField('${pField.Key}', this.checked)" /></label>`;
				}
				else
				{
					const tmpRaw = (this._edit && this._edit[pField.Key] != null) ? this._edit[pField.Key] : '';
					tmpValHTML = `<input class="input uw-edit-input" type="${pField.Edit === 'number' ? 'number' : 'text'}" value="${this._escape(tmpRaw)}" oninput="_Pict.providers.UserWorkspace.editField('${pField.Key}', this.value)" />`;
				}
				return `<div class="pw-field${tmpWide}"><span class="pw-field-label">${this._esc(pField.Label)}</span>${tmpValHTML}</div>`;
			}).join('');
			return `<div class="pw-group"><div class="pw-group-head">${this._esc(pGroup.Name)}</div><div class="pw-grid">${tmpFields}</div></div>`;
		}).join('');
	}

	startEdit() { if (!this._user || !this.canEditUser) { return; } this._editing = true; this._edit = Object.assign({}, this._user); this.renderWorkspace(); }
	cancelEdit() { this._editing = false; this._edit = null; this.renderWorkspace(); }
	editField(pKey, pValue) { if (!this._edit) { return; } this._edit[pKey] = pValue; }

	async saveAsync()
	{
		if (!this._user || !this._edit || this._savingEdit) { return; }
		this._savingEdit = true;
		this.renderWorkspace();
		const tmpPayload = { IDUser: this._user.IDUser };
		FIELD_GROUPS.forEach((pGroup) => pGroup.Fields.forEach((pField) =>
		{
			if (pField.Edit === 'text') { tmpPayload[pField.Key] = (this._edit[pField.Key] == null) ? '' : String(this._edit[pField.Key]); }
			else if (pField.Edit === 'number') { const tmpNumber = Number(this._edit[pField.Key]); tmpPayload[pField.Key] = Number.isFinite(tmpNumber) ? tmpNumber : 0; }
			else if (pField.Edit === 'bool') { tmpPayload[pField.Key] = this._isTruthy(this._edit[pField.Key]) ? 1 : 0; }
		}));
		const tmpResult = await this._putJSON('User', tmpPayload);
		this._savingEdit = false;
		if (tmpResult && tmpResult.error)
		{
			this._toast('Could not save the user (you may not have permission to edit this user).', 'error');
			this.renderWorkspace();
			return;
		}
		this._user = Object.assign({}, this._user, tmpPayload);
		this._record = this._user;
		this._editing = false;
		this._edit = null;
		this.renderWorkspace();
		this._toast('User saved.', 'success');
	}

	// --- Reset password ---
	resetPasswordPrompt()
	{
		if (!this._user || !this.canResetPassword) { return; }
		if (!this.modal || (typeof this.modal.show !== 'function')) { this._toast('The modal service is unavailable.', 'error'); return; }
		const tmpName = `${this._user.NameFirst || ''} ${this._user.NameLast || ''}`.trim() || this._user.LoginID || `User ${this._user.IDUser}`;
		const tmpContent =
			`<p style="margin:0 0 0.75rem; color: var(--theme-color-text-secondary, #45505f);">Set a new password for <strong>${this._escape(tmpName)}</strong>. They can change it after their next sign-in.</p>`
			+ `<div class="field"><label class="label" style="font-size:0.8rem;">New password</label>`
			+ `<div class="control" style="display:flex; gap:0.5rem;">`
			+ `<input id="UW-NewPassword" class="input" type="text" autocomplete="new-password" placeholder="Enter or generate a password" style="font-family: ui-monospace, SFMono-Regular, Menlo, monospace;" />`
			+ `<button type="button" class="button is-light" onclick="_Pict.providers.UserWorkspace.fillGeneratedPassword()">Generate</button>`
			+ `</div></div>`;
		this._pwInputEl = null;
		this.modal.show(
			{
				title: 'Reset password', content: tmpContent, closeable: true,
				buttons: [ { Hash: 'cancel', Label: 'Cancel', Style: 'light' }, { Hash: 'reset', Label: 'Reset password', Style: 'link' } ],
				onOpen: (pDialog) => { this._pwInputEl = pDialog ? pDialog.querySelector('#UW-NewPassword') : null; if (this._pwInputEl) { this._pwInputEl.focus(); } },
			}).then((pHash) =>
			{
				if (pHash !== 'reset') { return; }
				const tmpPassword = this._pwInputEl ? String(this._pwInputEl.value || '') : '';
				this._pwInputEl = null;
				if (tmpPassword.length < 2) { this._toast('Enter a password of at least 2 characters.', 'error'); return; }
				this._submitPasswordAsync(tmpPassword);
			});
	}

	fillGeneratedPassword()
	{
		if (!this._pwInputEl) { return; }
		const tmpCharset = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
		let tmpPassword = '';
		for (let i = 0; i < 12; i++) { tmpPassword += tmpCharset.charAt(Math.floor(Math.random() * tmpCharset.length)); }
		this._pwInputEl.value = tmpPassword;
		this._pwInputEl.focus();
	}

	async _submitPasswordAsync(pNewPassword)
	{
		try
		{
			const tmpResponse = await fetch(`${this._prefix}Password`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ IDUser: this._user.IDUser, NewPassword: pNewPassword }) });
			let tmpBody = null;
			try { tmpBody = await tmpResponse.json(); } catch (pParseError) { tmpBody = null; }
			if (!tmpResponse.ok || (tmpBody && tmpBody.Success === false)) { throw new Error((tmpBody && tmpBody.Error) ? tmpBody.Error : `server returned ${tmpResponse.status}`); }
			this._toast('Password reset.', 'success');
		}
		catch (pError) { this._toast(`Could not reset the password: ${pError.message || pError}`, 'error'); }
	}

	// --- Impersonate ---
	impersonatePrompt()
	{
		if (!this._user || !this.canImpersonate) { return; }
		const tmpName = `${this._user.NameFirst || ''} ${this._user.NameLast || ''}`.trim() || this._user.LoginID || `User ${this._user.IDUser}`;
		const fApply = () => this._impersonateAsync();
		if (this.modal && (typeof this.modal.confirm === 'function'))
		{
			this.modal.confirm(`Sign in as ${tmpName}? Your current session will be replaced by theirs until you sign out.`, { title: 'Impersonate user', confirmLabel: 'Impersonate', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fApply(); } });
		}
		else { fApply(); }
	}

	async _impersonateAsync()
	{
		try
		{
			const tmpResult = await this._getJSON(`Authentication/Impersonate/${this._user.IDUser}`);
			if (!tmpResult || tmpResult.Success === false) { throw new Error((tmpResult && tmpResult.Error) ? tmpResult.Error : 'the server declined the impersonation request.'); }
			this._toast(`Now signed in as ${this._user.LoginID || this._user.Email || ('user ' + this._user.IDUser)}. Reloading…`, 'success');
			if (typeof window !== 'undefined' && window.location) { window.location.reload(); }
		}
		catch (pError) { this._toast(`Could not impersonate: ${pError.message || pError}`, 'error'); }
	}

	// --- Roles & Groups tab (membership panel + grant/remove) ---
	renderRoles(pProv, pHost)
	{
		const tmpHelp = `<p class="pw-help" style="margin:0 0 0.9rem">Roles and permission groups this user is a member of, grouped by where each is assigned. Grant a role below, or remove a directly-assigned one; memberships inherited through a user group (“via …”) are managed from the composing group in Access &amp; Permissions.</p>`;
		this.pict.ContentAssignment.assignContent(pHost, `${tmpHelp}<div id="UW-RoleHost"></div>`);
		this._renderRoleHost();
	}

	_renderRoleHost()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#UW-RoleHost').length === 0) { return; }
		tmpCA.assignContent('#UW-RoleHost', this._roleHostHTML());
		this.mountRolePickers();
	}

	_roleHostHTML()
	{
		if (this._rolesLoading && !this._roleScopes) { return `<div class="pw-empty box has-text-grey has-text-centered"><span class="pw-spinner"></span><p class="mt-3">Loading roles…</p></div>${this._roleAddBlockHTML()}`; }
		if (this._rolesError && !this._roleScopes) { return `<div class="notification is-warning is-soft py-2 px-3">${this._esc(this._rolesError)}</div>${this._roleAddBlockHTML()}`; }
		const tmpScopes = this._roleScopes || [];
		const tmpListHTML = tmpScopes.length
			? tmpScopes.map((pScope) => `
				<div class="pw-group">
					<div class="pw-group-head-row"><span class="pw-group-head">${this._esc(pScope.ScopeName)}</span><span class="uw-role-count">${this._esc(pScope.CountLabel)}</span></div>
					<p class="uw-role-hint">${this._esc(pScope.ScopeHint)}</p>
					<div class="uw-role-list">${pScope.Roles.map((pRole) => this._roleRowHTML(pRole)).join('')}</div>
				</div>`).join('')
			: `<p class="has-text-grey">This user is not a member of any roles or permission groups.</p>`;
		return `${tmpListHTML}${this._roleAddBlockHTML()}`;
	}

	_roleRowHTML(pRole)
	{
		const tmpContexts = (pRole.ContextListSlot && pRole.ContextListSlot.length)
			? `<div class="uw-role-contexts">${pRole.ContextListSlot[0].Contexts.map((pContext) => this._roleContextHTML(pContext)).join('')}</div>` : '';
		// Customer-scope roles are the removable unit (no per-context row); the × sits on the role itself.
		const tmpRemove = (this.canManageRoles && pRole.RemoveSlot && pRole.RemoveSlot.length)
			? `<button class="uw-role-x" title="Remove this role from the user" onclick="_Pict.providers.UserWorkspace.removeRoleAsync(${Number(pRole.RemoveSlot[0].IDRole)}, '${this._esc(pRole.RemoveSlot[0].Context)}', ${Number(pRole.RemoveSlot[0].IDContext)})"><span class="icon"><i class="fas fa-xmark"></i></span></button>` : '';
		return `<div class="uw-role-row"><div class="uw-role-main"><span class="icon uw-role-icon"><i class="${this._esc(pRole.Icon)}"></i></span><span class="uw-role-name">${this._esc(pRole.Name)}</span><span class="tag ${this._esc(pRole.KindClass)}">${this._esc(pRole.KindLabel)}</span>${tmpRemove}</div>${tmpContexts}</div>`;
	}

	_roleContextHTML(pContext)
	{
		const tmpStart = (pContext.StartSlot && pContext.StartSlot.length) ? `<span class="tag is-light" title="This assignment starts">from ${this._esc(pContext.StartSlot[0].Text)}</span>` : '';
		const tmpExp = (pContext.ExpirationSlot && pContext.ExpirationSlot.length) ? `<span class="tag is-light" title="This assignment expires">until ${this._esc(pContext.ExpirationSlot[0].Text)}</span>` : '';
		const tmpState = (pContext.StateSlot && pContext.StateSlot.length) ? `<span class="uw-cert-badge ${this._esc(pContext.StateSlot[0].Class)}">${this._esc(pContext.StateSlot[0].Label)}</span>` : '';
		const tmpVia = (pContext.ViaSlot && pContext.ViaSlot.length) ? `<span class="tag is-warning is-light" title="Granted through a user group rather than assigned directly">via ${this._esc(pContext.ViaSlot[0].ViaLabel)}</span>` : '';
		// Direct (non-inherited) project/lab assignments get a per-context ×.
		const tmpRemove = (this.canManageRoles && pContext.RemoveSlot && pContext.RemoveSlot.length)
			? `<button class="uw-role-x" title="Remove this role on this ${this._esc(String(pContext.RemoveSlot[0].Context).toLowerCase())}" onclick="_Pict.providers.UserWorkspace.removeRoleAsync(${Number(pContext.RemoveSlot[0].IDRole)}, '${this._esc(pContext.RemoveSlot[0].Context)}', ${Number(pContext.RemoveSlot[0].IDContext)})"><span class="icon is-small"><i class="fas fa-xmark"></i></span></button>` : '';
		return `<div class="uw-role-context"><span class="icon is-small uw-role-context-icon"><i class="fas fa-angle-right"></i></span><span class="uw-role-context-name">${this._esc(pContext.Label)}</span><span class="uw-role-context-id">${this._esc(pContext.IDLabel)}</span>${tmpStart}${tmpExp}${tmpState}${tmpVia}${tmpRemove}</div>`;
	}

	async loadRolesAsync(pForce)
	{
		if (!this._user) { return; }
		const tmpIDUser = this._user.IDUser;
		if (this._rolesLoading) { return; }
		if (!pForce && this._rolesLoadedFor === tmpIDUser) { this._renderRoleHost(); return; }
		this._rolesLoading = true;
		this._rolesError = '';
		this._renderRoleHost();
		try
		{
			const tmpResponse = await this._getJSON(`Permissions/Roles/For/User/${tmpIDUser}/All/Contexts`);
			this._roleTimeZone = await this._loadRoleTimeZoneAsync('Customer', 0);
			this._roleContexts = (tmpResponse && Array.isArray(tmpResponse.Contexts)) ? tmpResponse.Contexts : [];
			const tmpNames = await this._resolveContextNames(tmpResponse);
			this._roleScopes = this._buildRoleScopes(tmpResponse, tmpNames);
			this._rolesLoadedFor = tmpIDUser;
		}
		catch (pError) { this._roleScopes = null; this._rolesError = `Could not load roles and groups: ${pError && pError.message ? pError.message : pError}`; }
		this._rolesLoading = false;
		this._renderRoleHost();
	}

	async _resolveContextNames(pResponse)
	{
		const tmpNames = { Project: {}, Lab: {} };
		const tmpContexts = (pResponse && Array.isArray(pResponse.Contexts)) ? pResponse.Contexts : [];
		const fCollect = (pContext) => Array.from(new Set(tmpContexts.filter((pEntry) => pEntry && pEntry.Context === pContext && Number(pEntry.IDContext) > 0).map((pEntry) => Number(pEntry.IDContext))));
		await Promise.all([ this._fillNames('Projects', 'IDProject', fCollect('Project'), tmpNames.Project), this._fillNames('Labs', 'IDLab', fCollect('Lab'), tmpNames.Lab) ]);
		return tmpNames;
	}

	async _fillNames(pEntitySet, pIDField, pIDs, pTarget)
	{
		if (!pIDs || !pIDs.length) { return; }
		try
		{
			const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/FBL~${pIDField}~INN~${pIDs.join(',')}/0/${pIDs.length}`);
			(Array.isArray(tmpRows) ? tmpRows : []).forEach((pRow) => { if (pRow && pRow[pIDField] != null) { pTarget[pRow[pIDField]] = pRow.Name || pRow.Description || ''; } });
			// The batched list read is customer-filtered and excludes soft-deleted rows, so a cross-customer
			// view or a deleted project/lab resolves to no name and the row falls back to a bare id. Fill any
			// still-missing id from a single record-by-id GET (not list-scoped; same idiom as _roleResolveValue).
			const tmpEntity = pEntitySet.replace(/s$/, '');
			await Promise.all(pIDs.filter((pID) => !pTarget[pID]).map((pID) => this._getJSON(`${tmpEntity}/${pID}`)
				.then((pRow) => { if (pRow && pRow[pIDField] != null) { pTarget[pRow[pIDField]] = pRow.Name || pRow.Description || ''; } })
				.catch(() => {})));
		}
		catch (pError) { this.pict.log.warn(`UserWorkspace: could not resolve ${pEntitySet} names: ${pError && pError.message ? pError.message : pError}`); }
	}

	_buildRoleScopes(pResponse, pNames)
	{
		const tmpRolesByID = {};
		(pResponse && Array.isArray(pResponse.Roles) ? pResponse.Roles : []).forEach((pRole) => { if (pRole && pRole.IDRole != null) { tmpRolesByID[pRole.IDRole] = pRole; } });
		const tmpContexts = (pResponse && Array.isArray(pResponse.Contexts)) ? pResponse.Contexts : [];
		const tmpScopeOrder = [ 'Customer', 'Project', 'Lab' ];
		const tmpScopes = {};
		const fScope = (pContext) =>
		{
			const tmpKey = pContext || 'Customer';
			if (!tmpScopes[tmpKey]) { tmpScopes[tmpKey] = { Key: tmpKey, Meta: this._scopeMeta(tmpKey), RolesByID: {}, Order: [] }; if (tmpScopeOrder.indexOf(tmpKey) < 0) { tmpScopeOrder.push(tmpKey); } }
			return tmpScopes[tmpKey];
		};
		tmpContexts.forEach((pEntry) =>
		{
			if (!pEntry || pEntry.IDRole == null) { return; }
			const tmpRole = tmpRolesByID[pEntry.IDRole];
			if (!tmpRole) { return; }
			const tmpScope = fScope(pEntry.Context);
			let tmpRow = tmpScope.RolesByID[pEntry.IDRole];
			if (!tmpRow)
			{
				const tmpKind = this._roleKind(tmpRole.Type);
				tmpRow = { IDRole: pEntry.IDRole, Name: tmpRole.Name || `Role ${pEntry.IDRole}`, Icon: tmpKind.Icon, KindLabel: tmpKind.Label, KindClass: tmpKind.Class, Contexts: [], ContextSeen: {}, Direct: false, IDContext: 0 };
				tmpScope.RolesByID[pEntry.IDRole] = tmpRow;
				tmpScope.Order.push(pEntry.IDRole);
			}
			if (tmpScope.Key === 'Customer')
			{
				// Customer-wide: the role itself is the removable unit. Track whether it is held DIRECTLY (a
				// UserRoleJoin, removable) vs only inherited through a user group (SynthesizedIDRole → not removable).
				const tmpSynth = Number(pEntry.SynthesizedIDRole) || 0;
				const tmpInherited = tmpSynth && (tmpSynth !== Number(pEntry.IDRole));
				if (!tmpRow.IDContext) { tmpRow.IDContext = Number(pEntry.IDContext) || 0; }
				if (!tmpInherited) { tmpRow.Direct = true; tmpRow.IDContext = Number(pEntry.IDContext) || tmpRow.IDContext; }
			}
			else
			{
				const tmpIDContext = Number(pEntry.IDContext) || 0;
				if (!tmpRow.ContextSeen[tmpIDContext]) { tmpRow.ContextSeen[tmpIDContext] = true; tmpRow.Contexts.push(this._buildContextRow(tmpScope.Key, pEntry, tmpRolesByID, pNames)); }
			}
		});
		const tmpCustomerContext = Number((this._user && this._user.IDCustomer) || 0);
		return tmpScopeOrder
			.filter((pKey) => tmpScopes[pKey] && tmpScopes[pKey].Order.length)
			.map((pKey) =>
			{
				const tmpScope = tmpScopes[pKey];
				const tmpRoles = tmpScope.Order
					.map((pID) =>
					{
						const tmpRow = tmpScope.RolesByID[pID];
						const tmpContextRows = tmpRow.Contexts.sort((pA, pB) => String(pA.Label).localeCompare(String(pB.Label)));
						// Customer-scope: attach a remove target on the role when it is held directly.
						const tmpRemoveSlot = (tmpScope.Key === 'Customer' && tmpRow.Direct)
							? [ { IDRole: tmpRow.IDRole, Context: 'Customer', IDContext: tmpRow.IDContext || tmpCustomerContext } ] : [];
						return { Name: tmpRow.Name, Icon: tmpRow.Icon, KindLabel: tmpRow.KindLabel, KindClass: tmpRow.KindClass, ContextListSlot: tmpContextRows.length ? [ { Contexts: tmpContextRows } ] : [], RemoveSlot: tmpRemoveSlot };
					})
					.sort((pA, pB) => String(pA.Name).localeCompare(String(pB.Name)));
				return { ScopeName: tmpScope.Meta.Name, ScopeHint: tmpScope.Meta.Hint, CountLabel: String(tmpRoles.length), Roles: tmpRoles };
			});
	}

	_buildContextRow(pScopeKey, pEntry, pRolesByID, pNames)
	{
		const tmpIDContext = Number(pEntry.IDContext) || 0;
		const tmpNameMap = (pNames && pNames[pScopeKey]) || {};
		const tmpName = tmpNameMap[tmpIDContext];
		const tmpStart = libRoleDates.instantToDay(pEntry.StartDate, this._roleTimeZone);
		const tmpExpiration = libRoleDates.instantToDay(pEntry.ExpirationDate, this._roleTimeZone);
		const tmpState = libRoleDates.getWindowState(pEntry.StartDate, pEntry.ExpirationDate);
		const tmpStateSlot = [];
		if (tmpState === 'Scheduled')
		{
			tmpStateSlot.push({ Label: 'scheduled', Class: 'uw-cert-future' });
		}
		else if (tmpState === 'Expired')
		{
			tmpStateSlot.push({ Label: 'expired', Class: 'uw-cert-exp' });
		}
		let tmpVia = '';
		const tmpSynth = Number(pEntry.SynthesizedIDRole) || 0;
		const tmpInherited = !!(tmpSynth && (tmpSynth !== Number(pEntry.IDRole)));
		if (tmpInherited && pRolesByID[tmpSynth]) { tmpVia = pRolesByID[tmpSynth].Name || `Role ${tmpSynth}`; }
		// Direct project/lab assignment → removable; inherited "via group" → not removable.
		const tmpRemoveSlot = (!tmpInherited && tmpIDContext > 0)
			? [ { IDRole: Number(pEntry.IDRole), Context: pScopeKey, IDContext: tmpIDContext } ] : [];
		return { Label: tmpName || `${pScopeKey} ${tmpIDContext}`, IDLabel: tmpName ? `#${tmpIDContext}` : '', StartSlot: tmpStart ? [ { Text: tmpStart } ] : [], ExpirationSlot: tmpExpiration ? [ { Text: tmpExpiration } ] : [], StateSlot: tmpStateSlot, ViaSlot: tmpVia ? [ { ViaLabel: tmpVia } ] : [], RemoveSlot: tmpRemoveSlot };
	}

	_roleKind(pType)
	{
		if (pType === 'PermissionGroup') { return { Label: 'Permission Group', Icon: 'fas fa-layer-group', Class: 'is-primary is-light' }; }
		if (pType === 'UserGroup') { return { Label: 'User Group', Icon: 'fas fa-users', Class: 'is-warning is-light' }; }
		return { Label: 'Role', Icon: 'fas fa-user-shield', Class: 'is-light' };
	}
	_scopeMeta(pKey)
	{
		switch (pKey)
		{
		case 'Customer': return { Name: 'User level', Hint: 'Assigned customer-wide (via a User Role) — applies across all of this customer’s projects.' };
		case 'Project': return { Name: 'Project level', Hint: 'Assigned on specific projects.' };
		case 'Lab': return { Name: 'Lab level', Hint: 'Assigned on specific labs.' };
		default: return { Name: `${pKey} level`, Hint: `Assigned in the ${pKey} context.` };
		}
	}

	// --- Roles & Groups: the grant editor (add block + pickers + grant/remove) ---

	/** The customer whose roles/projects/labs are offered (the SUBJECT user's, not the session's — matters for super-user cross-customer edits). */
	_subjectCustomer() { return Number((this._user && this._user.IDCustomer) || (this.currentUser && (this.currentUser.CustomerID || this.currentUser.IDCustomer)) || 0); }

	/** Role picker source — roles AND permission/user groups (no Type filter), scoped to GLOBAL (0) + the subject
	 *  customer. The standard roles and all permission/user groups are seeded at IDCustomer 0, so an EQ on just the
	 *  customer dropped every one of them (the reported "limited set / no groups"); mirror AccessWorkspace's rail
	 *  which loads `INN~0,<customer>`. Groups are labelled so they're distinguishable from plain roles. */
	_roleDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Set: 'Roles', IDField: 'IDRole', PageSize: 50, Scope: () => `FBL~IDCustomer~INN~0,${this._subjectCustomer()}~FBV~Deleted~EQ~0`,
				ToOption: (pRole) => ({ Value: Number(pRole.IDRole), Text: (pRole.Name || `Role #${pRole.IDRole}`) + (pRole.Type === 'PermissionGroup' ? ' (permission group)' : (pRole.Type === 'UserGroup' ? ' (user group)' : '')), Record: pRole }),
			});
	}
	_roleResolveValue() { return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`Role/${tmpID}`).then((pRole) => ((pRole && pRole.IDRole) ? { Value: tmpID, Text: pRole.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })).catch(() => ({ Value: tmpID, Text: `#${tmpID}` })); }; }

	/** Project/Lab context picker source for a non-customer scope, scoped to the subject customer. */
	_contextDataProvider(pScope)
	{
		const tmpIsLab = (pScope === 'Lab');
		const tmpIDField = tmpIsLab ? 'IDLab' : 'IDProject';
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Set: tmpIsLab ? 'Labs' : 'Projects', IDField: tmpIDField, PageSize: 50, Scope: () => `FBV~IDCustomer~EQ~${this._subjectCustomer()}~FBV~Deleted~EQ~0`,
				ToOption: (pRow) => ({ Value: Number(pRow[tmpIDField]), Text: pRow.Name || `#${pRow[tmpIDField]}`, Record: pRow }),
			});
	}
	_contextResolveValue(pScope)
	{
		const tmpIsLab = (pScope === 'Lab');
		const tmpEntity = tmpIsLab ? 'Lab' : 'Project';
		const tmpIDField = tmpIsLab ? 'IDLab' : 'IDProject';
		return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`${tmpEntity}/${tmpID}`).then((pRow) => ((pRow && pRow[tmpIDField]) ? { Value: tmpID, Text: pRow.Name || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })).catch(() => ({ Value: tmpID, Text: `#${tmpID}` })); };
	}

	_roleAddBlockHTML()
	{
		if (!this.canManageRoles) { return ''; }
		const tmpScope = this.state.RoleAddScope || 'Customer';
		const tmpNotice = this._rolesNotice ? `<div class="uw-cert-notice">${this._esc(this._rolesNotice)}</div>` : '';
		const tmpError = (this._rolesError && this._roleScopes) ? `<div class="uw-cert-error">${this._esc(this._rolesError)}</div>` : '';
		const tmpBusy = this._rolesBusy ? '<span class="uw-cert-busy">saving…</span>' : '';
		// Project/Lab-scoped grants can carry optional start and end days; Customer-wide cannot (the server rejects them).
		const tmpContextField = (tmpScope !== 'Customer')
			? `<div class="uw-role-field"><label class="uw-role-flabel">${tmpScope === 'Lab' ? 'Lab' : 'Project'}</label><div id="UW-RoleContextPicker" class="uw-cert-typepicker"></div></div>` : '';
		const tmpToday = this._escape(libRoleDates.todayIn(this._roleTimeZone));
		const tmpStartsField = (tmpScope !== 'Customer')
			? `<div class="uw-role-field"><label class="uw-role-flabel">Starts <span class="uw-role-opt">(optional)</span></label><input class="uw-role-date" type="date" min="${tmpToday}" value="${this._escape(this.state.RoleAddStarts || '')}" onchange="_Pict.providers.UserWorkspace.setRoleAddStarts(this.value)" /></div>` : '';
		const tmpExpiresField = (tmpScope !== 'Customer')
			? `<div class="uw-role-field"><label class="uw-role-flabel">Ends <span class="uw-role-opt">(optional)</span></label><input class="uw-role-date" type="date" min="${tmpToday}" value="${this._escape(this.state.RoleAddExpires || '')}" onchange="_Pict.providers.UserWorkspace.setRoleAddExpires(this.value)" /></div>` : '';
		return `<div class="uw-cert-add">
			<div class="uw-cert-add-head">Add a role</div>
			<div class="uw-role-add-row">
				<div class="uw-role-field"><label class="uw-role-flabel">Role or group</label><div id="UW-RolePicker" class="uw-cert-typepicker"></div></div>
				<div class="uw-role-field"><label class="uw-role-flabel">Scope</label>
					<div class="select"><select class="uw-role-scope" onchange="_Pict.providers.UserWorkspace.setRoleAddScope(this.value)">
						<option value="Customer"${tmpScope === 'Customer' ? ' selected' : ''}>Customer-wide</option>
						<option value="Project"${tmpScope === 'Project' ? ' selected' : ''}>Project</option>
						<option value="Lab"${tmpScope === 'Lab' ? ' selected' : ''}>Lab</option>
					</select></div>
				</div>
				${tmpContextField}
				${tmpStartsField}
				${tmpExpiresField}
			</div>
			<div class="uw-cert-add-actions"><button class="uw-cert-btn" onclick="_Pict.providers.UserWorkspace.addRoleAsync()">Add role</button>${tmpBusy}</div>
			${tmpNotice}${tmpError}
		</div>`;
	}

	mountRolePickers()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#UW-RolePicker').length > 0)
		{
			const tmpRP = tmpPicker.createPicker('UW-RolePicker',
				{
					DestinationAddress: '#UW-RolePicker', ValueAddress: 'AppData.UserWorkspace.RoleAddID',
					Searchable: true, AllowClear: true, ClearLabel: '— pick a role or group —', Placeholder: 'Search roles & groups…',
					DataProvider: this._roleDataProvider(), ResolveValue: this._roleResolveValue(),
				});
			if (tmpRP && (typeof tmpRP.render === 'function')) { tmpRP.render(); }
			if (tmpRP && (typeof tmpRP.setValue === 'function')) { tmpRP.setValue(this.state.RoleAddID || ''); }
		}
		const tmpScope = this.state.RoleAddScope || 'Customer';
		if ((tmpScope !== 'Customer') && (tmpCA.getElement('#UW-RoleContextPicker').length > 0))
		{
			const tmpLabel = (tmpScope === 'Lab') ? 'lab' : 'project';
			const tmpCP = tmpPicker.createPicker('UW-RoleContextPicker',
				{
					DestinationAddress: '#UW-RoleContextPicker', ValueAddress: 'AppData.UserWorkspace.RoleAddContextID',
					Searchable: true, AllowClear: true, ClearLabel: `— pick a ${tmpLabel} —`, Placeholder: `Search ${tmpLabel}s…`,
					DataProvider: this._contextDataProvider(tmpScope), ResolveValue: this._contextResolveValue(tmpScope),
				});
			if (tmpCP && (typeof tmpCP.render === 'function')) { tmpCP.render(); }
			if (tmpCP && (typeof tmpCP.setValue === 'function')) { tmpCP.setValue(this.state.RoleAddContextID || ''); }
		}
	}

	setRoleAddScope(pScope)
	{
		this.state.RoleAddScope = (pScope === 'Project' || pScope === 'Lab') ? pScope : 'Customer';
		this.state.RoleAddContextID = '';
		this.state.RoleAddExpires = '';
		this.state.RoleAddStarts = '';
		this._rolesError = ''; this._rolesNotice = '';
		this._renderRoleHost();
	}
	/** Stash the optional expiration WITHOUT a re-render so the date input keeps focus (mirrors setCertAddDate). */
	setRoleAddExpires(pValue) { this.state.RoleAddExpires = String(pValue || ''); }
	/** Stash the optional start day, likewise without a re-render. */
	setRoleAddStarts(pValue)
	{
		this.state.RoleAddStarts = String(pValue || '');
	}

	/**
	 * The time zone role days are read in: the project's when one is given, else the user's customer's, else
	 * the browser's ('').
	 * @param {String} pScope - Customer | Project | Lab
	 * @param {Number} pIDContext - the project or lab
	 * @return {Promise<String>} an IANA zone, or ''.
	 */
	async _loadRoleTimeZoneAsync(pScope, pIDContext)
	{
		const tmpSources = [];
		if ((pScope === 'Project') && pIDContext)
		{
			tmpSources.push(`Project/${Number(pIDContext)}`);
		}
		if (this._user && this._user.IDCustomer)
		{
			tmpSources.push(`Customer/${Number(this._user.IDCustomer)}`);
		}
		for (const tmpSource of tmpSources)
		{
			try
			{
				const tmpRecord = await this._getJSON(tmpSource);
				if (tmpRecord && libRoleDates.isValidTimeZone(tmpRecord.Timezone))
				{
					return tmpRecord.Timezone;
				}
			}
			catch (pError)
			{
				// Fall through to the next source; the browser's zone is the last resort.
			}
		}
		return '';
	}

	/**
	 * Why the drafted start and end days cannot be saved, if they cannot.
	 * @param {Number} pIDRole - the role being added
	 * @param {String} pScope - Project | Lab
	 * @param {Number} pIDContext - the project or lab
	 * @param {String} pTimeZone - the zone the days are read in
	 * @return {String} a message for the form, or ''.
	 */
	_checkRoleAddDays(pIDRole, pScope, pIDContext, pTimeZone)
	{
		const tmpStarts = this.state.RoleAddStarts;
		const tmpEnds = this.state.RoleAddExpires;
		if (tmpStarts && tmpEnds && (tmpStarts > tmpEnds))
		{
			return 'The start date has to be on or before the end date.';
		}
		if (tmpStarts && (tmpStarts > libRoleDates.todayIn(pTimeZone)))
		{
			// Adding a role the user already holds here updates that assignment, so a future start would
			// take the role away until then.
			const tmpHeld = (this._roleContexts || []).some((pEntry) =>
				(pEntry.Context === pScope) && (Number(pEntry.IDContext) === Number(pIDContext)) && (Number(pEntry.IDRole) === Number(pIDRole)) &&
				(libRoleDates.getWindowState(pEntry.StartDate, pEntry.ExpirationDate) === 'Active'));
			if (tmpHeld)
			{
				return 'This user already has this role there. A future start date would remove it until then. ' +
					'Leave the start date empty to change only the end date, or remove the role first.';
			}
		}
		return '';
	}

	async addRoleAsync()
	{
		if (!this._user || this._rolesBusy || !this.canManageRoles) { return; }
		const tmpIDRole = Number(this.state.RoleAddID) || 0;
		if (!tmpIDRole) { this._rolesError = 'Pick a role or group to add.'; this._rolesNotice = ''; this._renderRoleHost(); return; }
		const tmpScope = this.state.RoleAddScope || 'Customer';
		let tmpIDContext;
		if (tmpScope === 'Customer')
		{
			tmpIDContext = Number(this._user.IDCustomer) || 0;
			if (!tmpIDContext) { this._rolesError = 'This user has no customer set, so a customer-wide role cannot be granted.'; this._renderRoleHost(); return; }
		}
		else
		{
			tmpIDContext = Number(this.state.RoleAddContextID) || 0;
			if (!tmpIDContext) { this._rolesError = `Pick a ${tmpScope === 'Lab' ? 'lab' : 'project'} to scope the role to.`; this._renderRoleHost(); return; }
		}
		const tmpBody = { IDUser: Number(this._user.IDUser), IDRole: tmpIDRole, Context: tmpScope, IDContext: tmpIDContext };
		// Start and end days are only valid for non-Customer scopes (the server rejects them for Customer). Like
		// the #/Access RoleAssignment editor, they cover whole days in the project's or customer's zone.
		if (tmpScope !== 'Customer')
		{
			const tmpTimeZone = await this._loadRoleTimeZoneAsync(tmpScope, tmpIDContext);
			const tmpDayProblem = this._checkRoleAddDays(tmpIDRole, tmpScope, tmpIDContext, tmpTimeZone);
			if (tmpDayProblem)
			{
				this._rolesError = tmpDayProblem;
				this._rolesNotice = '';
				this._renderRoleHost();
				return;
			}
			if (this.state.RoleAddStarts)
			{
				tmpBody.StartDate = libRoleDates.dayStartToInstant(this.state.RoleAddStarts, tmpTimeZone);
			}
			if (this.state.RoleAddExpires)
			{
				tmpBody.ExpirationDate = libRoleDates.dayEndToInstant(this.state.RoleAddExpires, tmpTimeZone);
			}
		}
		this._rolesBusy = true; this._rolesError = ''; this._rolesNotice = '';
		this._renderRoleHost();
		const tmpRes = await this._putJSON('Permissions/Role/For/User', tmpBody);
		this._rolesBusy = false;
		if (tmpRes && tmpRes.error) { this._rolesError = `Could not add the role: ${(tmpRes.error && tmpRes.error.message) || tmpRes.error} (you may lack permission).`; this._renderRoleHost(); return; }
		this._rolesNotice = 'Role added.';
		this.state.RoleAddID = ''; this.state.RoleAddContextID = ''; this.state.RoleAddExpires = '';
		this.state.RoleAddStarts = '';
		this.loadRolesAsync(true);
	}

	async removeRoleAsync(pIDRole, pContext, pIDContext)
	{
		if (!this._user || this._rolesBusy || !this.canManageRoles) { return; }
		this._rolesBusy = true; this._rolesError = ''; this._rolesNotice = '';
		this._renderRoleHost();
		try
		{
			await this._deleteJSON(`Permissions/Role/${Number(pIDRole)}/For/User/${Number(this._user.IDUser)}/In/${pContext}/${Number(pIDContext)}`);
			this._rolesNotice = 'Role removed.';
		}
		catch (pError)
		{
			this._rolesBusy = false;
			this._rolesError = `Could not remove the role: ${pError && pError.message ? pError.message : pError}`;
			this._renderRoleHost();
			return;
		}
		this._rolesBusy = false;
		this.loadRolesAsync(true);
	}

	// --- Certifications tab (list / add / remove) ---
	renderCertifications(pProv, pHost)
	{
		this.pict.ContentAssignment.assignContent(pHost, `<p class="pw-help" style="margin:0 0 0.8rem">Certifications this user holds — the type, its validity dates, and an active/expired badge. Add a certification below (dates optional) or remove one.</p><div id="UW-CertHost"></div>`);
		this._renderCertHost();
	}

	_dateToISO(pYMD) { const tmpV = String(pYMD || '').trim(); return tmpV ? `${tmpV}T00:00:00.000Z` : null; }
	_isoToYMD(pISO) { const tmpV = String(pISO || ''); return (tmpV.length >= 10) ? tmpV.slice(0, 10) : ''; }

	async loadCertificationsAsync(pForce)
	{
		if (!this._user) { return; }
		const tmpIDUser = this._user.IDUser;
		if (this._certsLoading) { return; }
		if (!pForce && (this._certsLoadedFor === tmpIDUser)) { this._renderCertHost(); return; }
		this._certsLoading = true;
		this._certsError = '';
		this._renderCertHost();
		try
		{
			const tmpJoins = await this._getJSON(`CertificationEntityPolyJoins/FilteredTo/FBV~EntityType~EQ~User~FBV~IDEntity~EQ~${tmpIDUser}~FBV~Deleted~EQ~0/0/500`);
			const tmpJoinRows = Array.isArray(tmpJoins) ? tmpJoins : [];
			const tmpCertIDs = tmpJoinRows.map((pJoin) => Number(pJoin.IDCertification)).filter((pID) => pID > 0);
			const tmpCertByID = {};
			if (tmpCertIDs.length)
			{
				const tmpCerts = await this._getJSON(`Certifications/FilteredTo/FBL~IDCertification~INN~${tmpCertIDs.join(',')}~FBV~Deleted~EQ~0/0/${tmpCertIDs.length + 10}`);
				(Array.isArray(tmpCerts) ? tmpCerts : []).forEach((pCert) => { tmpCertByID[Number(pCert.IDCertification)] = pCert; });
			}
			this._certs = tmpJoinRows.map((pJoin) =>
			{
				const tmpCert = tmpCertByID[Number(pJoin.IDCertification)];
				if (!tmpCert) { return null; }
				return { IDCertification: Number(pJoin.IDCertification), IDJoin: Number(pJoin.IDCertificationEntityPolyJoin), IDCertificationType: Number(tmpCert.IDCertificationType), On: this._isoToYMD(tmpCert.CertifiedOn), Start: this._isoToYMD(tmpCert.CertifiedStartDate), End: this._isoToYMD(tmpCert.CertifiedEndDate) };
			}).filter((pRow) => pRow);
			this._certsLoadedFor = tmpIDUser;
			await this._resolveCertTypeNames();
		}
		catch (pError) { this._certsError = `Could not load certifications: ${pError && pError.message ? pError.message : pError}`; }
		this._certsLoading = false;
		this._renderCertHost();
	}

	async _resolveCertTypeNames()
	{
		const tmpIDs = Array.from(new Set((this._certs || []).map((pCert) => pCert.IDCertificationType).filter((pID) => (pID > 0) && !this._certTypeNames[pID])));
		if (!tmpIDs.length) { return; }
		const tmpRows = await this._getJSON(`CertificationTypes/FilteredTo/FBL~IDCertificationType~INN~${tmpIDs.join(',')}/0/${tmpIDs.length}`);
		(Array.isArray(tmpRows) ? tmpRows : []).forEach((pType) => { this._certTypeNames[Number(pType.IDCertificationType)] = pType.Name || pType.Hash || `Type ${pType.IDCertificationType}`; });
	}

	setCertAddDate(pField, pValue) { if (pField === 'On') { this._certAdd.On = pValue || ''; } else if (pField === 'Start') { this._certAdd.Start = pValue || ''; } else if (pField === 'End') { this._certAdd.End = pValue || ''; } }
	setCertAddNotes(pValue) { this._certAdd.Notes = String(pValue == null ? '' : pValue); }

	applyCertPreset(pYears)
	{
		const tmpBase = this._certAdd.Start || this._certAdd.On;
		if (!tmpBase) { this._certsError = 'Set a start date first.'; this._renderCertHost(); return; }
		const tmpParts = String(tmpBase).split('-').map((pPart) => Number(pPart));
		if (tmpParts.length !== 3) { return; }
		this._certAdd.End = `${tmpParts[0] + Number(pYears)}-${String(tmpParts[1]).padStart(2, '0')}-${String(tmpParts[2]).padStart(2, '0')}`;
		if (typeof document !== 'undefined') { const tmpEl = document.getElementById('uw-cert-end'); if (tmpEl) { tmpEl.value = this._certAdd.End; } }
	}

	async addCertificationAsync()
	{
		if (!this._user || this._certBusy) { return; }
		const tmpTypeID = Number(this.state.CertAddTypeID);
		if (!(tmpTypeID > 0)) { this._certsError = 'Pick a certification type to add.'; this._certNotice = ''; this._renderCertHost(); return; }
		if (this._certAdd.Start && this._certAdd.End && (this._certAdd.Start > this._certAdd.End)) { this._certsError = 'The end date is before the start date.'; this._renderCertHost(); return; }
		this._certBusy = true; this._certsError = ''; this._certNotice = '';
		this._renderCertHost();
		const tmpCertBody = { IDCertification: 0, IDCertificationType: tmpTypeID, Notes: String(this._certAdd.Notes || '') };
		const tmpOn = this._dateToISO(this._certAdd.On); if (tmpOn) { tmpCertBody.CertifiedOn = tmpOn; }
		const tmpStartISO = this._dateToISO(this._certAdd.Start); if (tmpStartISO) { tmpCertBody.CertifiedStartDate = tmpStartISO; }
		const tmpEndISO = this._dateToISO(this._certAdd.End); if (tmpEndISO) { tmpCertBody.CertifiedEndDate = tmpEndISO; }
		const tmpCert = await this._postJSON('Certification', tmpCertBody);
		let tmpOk = false;
		if (!tmpCert.error && tmpCert.result && tmpCert.result.IDCertification)
		{
			const tmpJoin = await this._postJSON('CertificationEntityPolyJoin', { IDCertificationEntityPolyJoin: 0, IDCertification: Number(tmpCert.result.IDCertification), EntityType: 'User', IDEntity: Number(this._user.IDUser) });
			tmpOk = !tmpJoin.error;
		}
		this._certBusy = false;
		if (!tmpOk) { this._certsError = 'The server rejected the certification (you may lack permission).'; this._renderCertHost(); return; }
		this._certNotice = 'Certification added.';
		this._certAdd = { On: '', Start: '', End: '', Notes: '' };
		this.state.CertAddTypeID = '';
		this.loadCertificationsAsync(true);
	}

	async removeCertificationAsync(pIDCertification, pIDJoin)
	{
		if (!this._user) { return; }
		await this._deleteEntity('CertificationEntityPolyJoin', Number(pIDJoin));
		await this._deleteEntity('Certification', Number(pIDCertification));
		this.loadCertificationsAsync(true);
	}

	_certStatusBadge(pCert)
	{
		if (!pCert.End && !pCert.Start) { return ''; }
		const tmpToday = new Date().toISOString().slice(0, 10);
		if (pCert.End && (pCert.End < tmpToday)) { return '<span class="uw-cert-badge uw-cert-exp">expired</span>'; }
		if (pCert.Start && (pCert.Start > tmpToday)) { return '<span class="uw-cert-badge uw-cert-future">not yet active</span>'; }
		return '<span class="uw-cert-badge uw-cert-active">active</span>';
	}

	_certTypeDataProvider()
	{
		const tmpPageSize = 25;
		const fMap = (pRows) => (Array.isArray(pRows) ? pRows : []).map((pType) => ({ Value: Number(pType.IDCertificationType), Text: (pType.Name || pType.Hash || `Type ${pType.IDCertificationType}`), Record: pType }));
		return (pTerm, pPage) =>
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			if (!tmpTerm)
			{
				const tmpStart = (Number(pPage) || 0) * tmpPageSize;
				return this._getJSON(`CertificationTypes/FilteredTo/FBV~Deleted~EQ~0~FSF~Hash~ASC~0/${tmpStart}/${tmpPageSize}`).then((pRows) => ({ results: fMap(pRows), hasMore: (Array.isArray(pRows) && (pRows.length >= tmpPageSize)) })).catch(() => ({ results: [], hasMore: false }));
			}
			const tmpLike = encodeURIComponent(`%${tmpTerm}%`);
			return Promise.all(
				[
					this._getJSON(`CertificationTypes/FilteredTo/FBV~Name~LK~${tmpLike}~FBV~Deleted~EQ~0/0/${tmpPageSize}`).catch(() => []),
					this._getJSON(`CertificationTypes/FilteredTo/FBV~Hash~LK~${tmpLike}~FBV~Deleted~EQ~0/0/${tmpPageSize}`).catch(() => []),
				]).then((pResults) =>
			{
				const tmpByID = {};
				pResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pType) => { const tmpID = Number(pType.IDCertificationType); if ((tmpID > 0) && !tmpByID[tmpID]) { tmpByID[tmpID] = pType; } }));
				return { results: fMap(Object.keys(tmpByID).map((pKey) => tmpByID[pKey])).slice(0, 50), hasMore: false };
			});
		};
	}

	mountCertPicker()
	{
		const tmpPicker = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#UW-CertTypePicker').length === 0) { return; }
		const tmpView = tmpPicker.createPicker('UW-CertTypePicker',
			{
				DestinationAddress: '#UW-CertTypePicker', ValueAddress: 'AppData.UserWorkspace.CertAddTypeID',
				Searchable: true, AllowClear: true, ClearLabel: '— pick a certification type —', Placeholder: 'Search certification types…',
				DataProvider: this._certTypeDataProvider(),
				ResolveValue: (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`CertificationType/${tmpID}`).then((pType) => ((pType && pType.IDCertificationType) ? { Value: tmpID, Text: (pType.Name || pType.Hash || `Type ${tmpID}`) } : { Value: tmpID, Text: `#${tmpID}` })).catch(() => ({ Value: tmpID, Text: `#${tmpID}` })); },
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
	}

	_renderCertHost()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#UW-CertHost').length === 0) { return; }
		tmpCA.assignContent('#UW-CertHost', this._certHostHTML());
		this.mountCertPicker();
	}

	_certHostHTML()
	{
		if (this._certsLoading && !this._certs) { return '<p class="pw-help">Loading…</p>'; }
		const tmpNotice = this._certNotice ? `<div class="uw-cert-notice">${this._esc(this._certNotice)}</div>` : '';
		const tmpError = this._certsError ? `<div class="uw-cert-error">${this._esc(this._certsError)}</div>` : '';
		const tmpBusy = this._certBusy ? '<span class="uw-cert-busy">saving…</span>' : '';
		const tmpRows = (this._certs || []).map((pCert) =>
		{
			const tmpName = this._certTypeNames[pCert.IDCertificationType] || `Type ${pCert.IDCertificationType}`;
			const tmpRange = (pCert.Start || pCert.End) ? `${pCert.Start || '—'} → ${pCert.End || '—'}` : 'no dates';
			return `<div class="uw-cert-row"><div class="uw-cert-main"><span class="uw-cert-name">${this._esc(tmpName)}</span>${this._certStatusBadge(pCert)}</div><div class="uw-cert-dates">${this._esc(tmpRange)}</div><button class="uw-cert-x" title="Remove" onclick="_Pict.providers.UserWorkspace.removeCertificationAsync(${pCert.IDCertification}, ${pCert.IDJoin})"><i class="fas fa-xmark"></i></button></div>`;
		}).join('');
		const tmpAdd = `<div class="uw-cert-add"><div class="uw-cert-add-head">Add a certification</div>`
			+ `<div id="UW-CertTypePicker" class="uw-cert-typepicker"></div>`
			+ `<div class="uw-cert-dates-row">`
			+ `<label><span>Certified on</span><input type="date" value="${this._esc(this._certAdd.On)}" onchange="_Pict.providers.UserWorkspace.setCertAddDate('On', this.value)"></label>`
			+ `<label><span>Start</span><input type="date" value="${this._esc(this._certAdd.Start)}" onchange="_Pict.providers.UserWorkspace.setCertAddDate('Start', this.value)"></label>`
			+ `<label><span>End</span><input id="uw-cert-end" type="date" value="${this._esc(this._certAdd.End)}" onchange="_Pict.providers.UserWorkspace.setCertAddDate('End', this.value)"></label>`
			+ `<span class="uw-cert-presets"><button onclick="_Pict.providers.UserWorkspace.applyCertPreset(1)">+1 yr</button><button onclick="_Pict.providers.UserWorkspace.applyCertPreset(5)">+5 yr</button></span>`
			+ `</div>`
			+ `<label class="uw-cert-notes"><span>Notes</span><input type="text" value="${this._esc(this._certAdd.Notes)}" placeholder="(optional)" onchange="_Pict.providers.UserWorkspace.setCertAddNotes(this.value)"></label>`
			+ `<div class="uw-cert-add-actions"><button class="uw-cert-btn" onclick="_Pict.providers.UserWorkspace.addCertificationAsync()">Add certification</button>${tmpBusy}</div></div>`;
		return `<div class="uw-cert-list">${tmpRows || '<p class="pw-help">No certifications yet.</p>'}</div>${tmpNotice}${tmpError}${tmpAdd}`;
	}

	// --- Activity tab (per-user Activity dashboard, embedded from ActivityObservability) ---
	renderActivity()
	{
		return `<p class="pw-help" style="margin:0 0 0.8rem">This user’s record-authoring activity over time — counts of the records they created (or last updated), by type.</p><div id="AO-UserActivity-Body"></div>`;
	}
	_loadActivity()
	{
		const tmpActivity = this.pict.providers.ActivityObservability;
		if (tmpActivity && (typeof tmpActivity.loadUserActivityAsync === 'function')) { tmpActivity.loadUserActivityAsync(this.idUser); }
	}
}

module.exports = UserWorkspaceProvider;

},{"../access/RoleAssignment-Dates.js":1062,"../services/Entity-Picker-Search.js":1398,"pict-section-workspace":1049}],1382:[function(require,module,exports){
/**
 * Record preview cards for the Platform Configuration app.
 *
 * A config-driven registry of small "mini record" cards (pict-section-recordset >= 1.22's
 * RecordSetCardManager). When a card is registered for an entity, every foreign-key reference to that
 * entity — the "automatic dropdown" entities resolved by RecordSet's ProcessCell handler (Customer,
 * Project, Contract, Organization, …) — renders in list and read views as a clickable trigger that
 * opens an anchored popover card instead of a plain link. The association-editor row names pick the
 * same cards up automatically.
 *
 * Card shape: { Title, Subtitle?, Fields:[{ Label, Value }], Actions:[{ Label, Icon, Route }] }.
 * Every Title/Subtitle/Field Value is a field name (resolved as {~D:Record.<name>~}) OR a literal
 * {~...~} template. Action Routes use the standard PSRS read route — the app's router transparently
 * bridges the entities that own a bespoke workspace (Project, Contract, User, ObservationManifest,
 * ArtifactType) to their richer editor, so a single uniform route works everywhere.
 */

const RECORD_CARDS =
{
	Customer:
	{
		Title: 'Name',
		Fields:
		[
			{ Label: 'Code', Value: 'Code' },
			{ Label: 'Timezone', Value: 'Timezone' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/Customer/View/{~D:Record.GUIDCustomer~}' },
		],
	},
	Project:
	{
		Title: 'Name',
		Subtitle: '{~D:Record.Status~}',
		Fields:
		[
			{ Label: 'External ID', Value: 'ExternalProjectID' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/Project/View/{~D:Record.GUIDProject~}' },
		],
	},
	Material:
	{
		Title: 'Name',
		Subtitle: '{~D:Record.CategoryName~}',
		Fields:
		[
			{ Label: 'Material Code', Value: 'MaterialCode' },
			{ Label: 'Catalog Code', Value: 'CatalogCode' },
			{ Label: 'Item Code', Value: 'ItemCode' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/Material/View/{~D:Record.GUIDMaterial~}' },
		],
	},
	Contract:
	{
		Title: 'Name',
		Subtitle: '{~D:Record.Status~}',
		Fields:
		[
			{ Label: 'Primary Project #', Value: 'PrimaryProjectNumber' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/Contract/View/{~D:Record.GUIDContract~}' },
		],
	},
	Organization:
	{
		Title: 'Name',
		Subtitle: '{~D:Record.Type~}',
		Fields:
		[
			{ Label: 'Vendor Code', Value: 'VendorCode' },
			{ Label: 'City', Value: 'City' },
			{ Label: 'State', Value: 'State' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/Organization/View/{~D:Record.GUIDOrganization~}' },
		],
	},
	ObservationManifest:
	{
		Title: 'DisplayName',
		Subtitle: '{~D:Record.Category~}',
		Fields:
		[
			{ Label: 'Name', Value: 'Name' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/ObservationManifest/View/{~D:Record.GUIDObservationManifest~}' },
		],
	},
	ArtifactType:
	{
		Title: 'Name',
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/ArtifactType/View/{~D:Record.GUIDArtifactType~}' },
		],
	},
	User:
	{
		Title: '{~D:Record.NameFirst~} {~D:Record.NameLast~}',
		Subtitle: '{~D:Record.LoginID~}',
		Fields:
		[
			{ Label: 'Email', Value: 'Email' },
			{ Label: 'Role', Value: 'Role' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'User', Route: '#/PSRS/User/View/{~D:Record.GUIDUser~}' },
		],
	},
	Role:
	{
		Title: 'Name',
		Subtitle: '{~D:Record.Type~}',
		Fields:
		[
			{ Label: 'Level', Value: 'PermissionLevel' },
			{ Label: 'Description', Value: 'Description' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/Role/View/{~D:Record.GUIDRole~}' },
		],
	},
	ProjectType:
	{
		Title: 'Name',
		Fields:
		[
			{ Label: 'Description', Value: 'Description' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/ProjectType/View/{~D:Record.GUIDProjectType~}' },
		],
	},
	ContractType:
	{
		Title: 'Name',
		Fields:
		[
			{ Label: 'Description', Value: 'Description' },
		],
		Actions:
		[
			{ Label: 'View', Icon: 'Eye', Route: '#/PSRS/ContractType/View/{~D:Record.GUIDContractType~}' },
		],
	},
};

module.exports = { RECORD_CARDS };

},{}],1383:[function(require,module,exports){
/**
 * Sample Plan ↔ 2016 LADOTD Materials Sampling Manual (MSM) map.
 *
 * Two jobs, one source of truth:
 *   1. procedureForTest(TestDescription) → an MSM Part II procedure code (S101…S614), so the editor's
 *      Docs panel can resolve a "Sampling procedure" tier for any rule by its test.
 *   2. academyContentSeed() → the AcademyContent rows (Hash/Title/Content) to load once, so those docs
 *      actually exist for the panel to fetch by hash (SamplePlanProcedure-S###).
 *
 * Content is distilled from the MSM PDFs (Part II procedures, incl. OCR of the scanned ones) — what each
 * procedure samples, where/how, the container, the cited sampling standard, and the schedule frequency basis.
 * LADOTD-specific; lives in the Headlight app, never in the open-source modules.
 */

// Ordered most-specific → generic; first procedure with a matching keyword wins.
const MSM_PROCEDURES =
[
	{ Code: 'S102', Title: 'Mineral Filler, Portland Cement, Fly Ash, GGBFS & Hydrated Lime', Keywords: [ 'compressive strength mortar', 'mortar', 'fly ash', 'portland cement', 'mineral filler', 'hydrated lime', 'blast-furnace', 'ggbfs', 'cementitious' ] },
	{ Code: 'S203', Title: 'Asphaltic Mixtures', Keywords: [ 'asphaltic mixture', 'binder content', 'theoretical maximum density', 'rice', 'marshall', 'superpave', '% voids', 'percent voids', 'extraction', 'asphalt content', 'mix design' ] },
	{ Code: 'S201', Title: 'Asphaltic Materials', Keywords: [ 'asphalt binder', 'rotational viscosity', 'emulsion', 'percent residue', 'residue of emulsion', 'cutback', 'penetration', 'softening point', 'asphalt cement' ] },
	{ Code: 'S608', Title: 'Traffic Paint & Glass Beads', Keywords: [ 'traffic paint', 'glass bead', 'retroreflect', 'ftir', 'solid content', 'sheeting' ] },
	{ Code: 'S607', Title: 'Raised Pavement Markers', Keywords: [ 'raised pavement marker', 'pavement marker', 'rpm' ] },
	{ Code: 'S609', Title: 'Preformed Plastic Pavement Markings', Keywords: [ 'preformed', 'cold applied tape', 'marking tape' ] },
	{ Code: 'S610', Title: 'Thermoplastic Compound', Keywords: [ 'thermoplastic' ] },
	{ Code: 'S611', Title: 'Joint Sealant', Keywords: [ 'joint sealant', 'sealant' ] },
	{ Code: 'S612', Title: 'Asphalt Anti-Strip Additives & Concrete Admixtures', Keywords: [ 'anti-strip', 'anti strip', 'admixture', 'chloride' ] },
	{ Code: 'S613', Title: 'Erosion Control Systems', Keywords: [ 'erosion', 'erosion control', 'silt fence', 'blanket' ] },
	{ Code: 'S614', Title: 'Geotextile Fabric', Keywords: [ 'geotextile', 'fabric' ] },
	{ Code: 'S501', Title: 'Metals', Keywords: [ 'zinc', 'spelter', 'galvaniz', 'mill test', 'mill cert', 'nut', 'bolt', 'dowel', 'tension wire', 'fence', 'rebar', 'reinforc', 'mass of', 'steel', 'metal' ] },
	{ Code: 'S604', Title: 'Paints & Thinners', Keywords: [ 'dry-film', 'dry film thickness', 'thinner', 'paint' ] },
	{ Code: 'S301', Title: 'Sampling Fresh Concrete', Keywords: [ 'concrete compression', 'slump', 'air content', 'unit weight', 'flexural', 'cylinder', 'fresh concrete', 'concrete' ] },
	{ Code: 'S401', Title: 'Sampling Soils', Keywords: [ 'moisture - density', 'moisture-density', 'in-place density', 'field density', 'atterberg', 'classification of soils', 'proctor', 'moisture content', 'density', 'soil' ] },
	{ Code: 'S101', Title: 'Aggregates & Aggregate Mixtures', Keywords: [ 'sieve analysis', 'gradation', 'aggregate wash', 'deleterious', 'angularity', 'specific gravity and absorption', 'sand equivalent', 'abrasion', 'soundness', 'specific gravity', 'aggregate' ] },
	{ Code: 'S303', Title: 'Water', Keywords: [ 'water' ] },
	{ Code: 'S601', Title: 'Miscellaneous Materials', Keywords: [ 'non-shrink', 'grout', 'masonry', 'brick', 'block', 'bearing pad', 'membrane' ] },
];

/** Classify a 2026 TestDescription to an MSM procedure code, or '' if none matches. */
function procedureForTest(pTestDescription)
{
	const tmpText = String(pTestDescription || '').toLowerCase();
	if (!tmpText) { return ''; }
	for (let i = 0; i < MSM_PROCEDURES.length; i++)
	{
		const tmpProc = MSM_PROCEDURES[i];
		for (let j = 0; j < tmpProc.Keywords.length; j++)
		{
			if (tmpText.indexOf(tmpProc.Keywords[j]) !== -1) { return tmpProc.Code; }
		}
	}
	return '';
}

function procedureTitle(pCode)
{
	const tmpProc = MSM_PROCEDURES.find((p) => p.Code === pCode);
	return tmpProc ? tmpProc.Title : '';
}

// Distilled procedure docs (markdown). Keyed by code; rendered into the "Sampling procedure" doc tier.
const MSM_PROCEDURE_DOCS =
{
	S101: 'Samples **aggregates and aggregate mixtures** from stockpiles, windrows, conveyor belts, bins, roadways, and railroad cars/trucks (power equipment, sampling shovel + shield, or template/brush/catch-pan as appropriate).\n\n- **Container:** sample sacks (string-tied).\n- **Cited standards:** ASTM D75/D75M; AASHTO R 90-18; DOTD TR 108.\n- **Frequency basis (schedules):** sack-based, ~1 per 1,000 (gradation / wash / deleterious / specific gravity), or 1 per project for small quantities.\n- **Full procedure:** LADOTD MSM, Part II, **S 101-21**.',
	S102: 'Samples **mineral filler, Portland cement, fly ash, GGBFS, and hydrated lime** with a scoop or approved apparatus (PPE: goggles + respirator).\n\n- **Container:** plastic bags or 1-gal cans with lids.\n- **Cited standards:** AASHTO T 127; ASTM C 50.\n- **Frequency basis:** per lot / per project (mortar compressive strength typically 1 per project).\n- **Full procedure:** LADOTD MSM, Part II, **S 102-03**.',
	S201: 'Samples **asphaltic materials** by state: asphalt cement (1-qt friction-top cans), cutbacks (screw-top metal cans), and emulsions (1-gal plastic bottles); dip or hand-tool as appropriate.\n\n- **Container:** as above by material state.\n- **Frequency basis:** per lot / per shipment per the schedule.\n- **Full procedure:** LADOTD MSM, Part II, **S 201-03**.',
	S203: 'Samples **asphaltic mixtures**: cold mix (scoop), hot loose mix (scoop/shovel for the required size), and pavement cores (4-in or 6-in full-depth cores from an approved core drill).\n\n- **Container:** sample containers / core boxes.\n- **Frequency basis:** per lot/sublot (gradation, binder content, % voids, theoretical max density).\n- **Full procedure:** LADOTD MSM, Part II, **S 203-03**.',
	S301: 'Samples **fresh concrete** from transports (with or without discharge chutes); the sample feeds slump, air content, compressive cylinders, unit weight, and temperature.\n\n- **Container:** wheelbarrow → cylinder molds.\n- **Frequency basis (schedules):** plastic tests ~1 per 150 CY; compressive sets per lot (e.g. 1 set / 1,000 sacks for sacked/prepackaged concrete); 1 per project if < 1,000 CY.\n- **Full procedure:** LADOTD MSM, Part II, **S 301-99**.',
	S303: 'Samples **water** from supply lines (flush briefly first) or lakes/bayous/borrow pits (near the pump suction inlet, not on the bottom).\n\n- **Container:** 1-qt plastic sample bottle.\n- **Full procedure:** LADOTD MSM, Part II, **S 303-99**.',
	S401: 'Samples **soils** from borrow pits, subgrades, and roadway cut areas using spiral/hand augers and hand tools.\n\n- **Container:** DOTD sample sacks; **moisture-content** samples must be sealed immediately in a friction-top can (failure to seal invalidates the moisture test).\n- **Frequency basis (schedules):** sack-based per 1,000 (classification, Atterberg, moisture-density); field density ~1 per 1,000 CY; 1 per project for small quantities.\n- **Full procedure:** LADOTD MSM, Part II, **S 401-99**.',
	S501: 'Samples **metals** (reinforcing steel, fasteners, galvanized items, fence components) by cutting from reels/rolls/selected lengths.\n\n- **Container:** sample sacks with tamper-proof stickers.\n- **Frequency basis:** per lot / per heat; many items accepted by mill test report (1 per lot).\n- **Full procedure:** LADOTD MSM, Part II, **S 501-99**.',
	S601: 'Samples **miscellaneous materials** (grout, non-shrink grout, masonry, membranes, etc.): sample tube for powders/granular solids, stir/blend for liquids, cutting device for reels/rolls.\n\n- **Container:** 1-gal / 1-qt cans or sacks.\n- **Full procedure:** LADOTD MSM, Part II, **S 601-99**.',
	S604: 'Samples **paints and thinners** (incl. bridge coating systems): agitate with a Jiffy-type mixer, draw with a clean sampler, stamp the DOTD lot number.\n\n- **Container:** 1-pt friction-top can.\n- **Full procedure:** LADOTD MSM, Part II, **S 604-99**.',
	S607: 'Samples **raised pavement markers** at the warehouse: markers separated into DOTD lots of 10,000, sampled at random by the District Laboratory representative.\n\n- **Full procedure:** LADOTD MSM, Part II, **S 607-99**.',
	S608: 'Samples **traffic paint and glass beads** at an approved warehouse: agitate paint (Jiffy mixer) and draw into a 1-pt friction-top can; use a sample thief for glass beads into a 1-gal can.\n\n- **Full procedure:** LADOTD MSM, Part II, **S 608-24**.',
	S609: 'Samples **preformed plastic pavement markings** (cold-applied tape) at the warehouse.\n\n- **Container:** 1-gal friction-top can; seal sampled boxes.\n- **Full procedure:** LADOTD MSM, Part II, **S 609-99**.',
	S610: 'Samples **thermoplastic compound** (hot-applied pavement markings) at the warehouse; seal sampled pallets.\n\n- **Full procedure:** LADOTD MSM, Part II, **S 610-99**.',
	S611: 'Samples **joint sealant** by container/lot.\n\n- **Full procedure:** LADOTD MSM, Part II, **S 611-99**.',
	S612: 'Samples **asphalt anti-strip additives and concrete admixtures** (stir/blend liquids before drawing).\n\n- **Full procedure:** LADOTD MSM, Part II, **S 612-03**.',
	S613: 'Samples **erosion control systems** (blankets/rolls) per roll/lot.\n\n- **Cited standard:** DOTD S 601.\n- **Full procedure:** LADOTD MSM, Part II, **S 613-03**.',
	S614: 'Samples **geotextile fabric** by roll/lot.\n\n- **Full procedure:** LADOTD MSM, Part II, **S 614-99**.',
};

// The AcademyContent seed (procedure docs + the 82 section schedules) lives in SamplePlan-MSM-Seed.js so the
// large section content stays out of the browser bundle — the provider only needs the classifier above.

module.exports = { MSM_PROCEDURES, procedureForTest, procedureTitle, MSM_PROCEDURE_DOCS };

},{}],1384:[function(require,module,exports){
/**
 * Pure builder: turn a loaded SamplePlan/Lite payload (+ CalculatorData) into the in-memory tree the editor
 * navigates — Section -> LineItem -> Material -> Rule — with satisfaction rollups stamped on every tier.
 *
 *   const tmpModel = buildSamplePlanModel(samplePlanLite, calculatorData);
 *   // -> { project, sections[], lineItems[], materials[], rules[], plan }   (all plain records)
 *
 * REAL fields are read straight off the payload; everything is guarded so a missing array / sparse field never
 * throws (the live Lite shape varies slightly by deployment). Required/planned counts come from the server (resolvePlimtCounts); satisfaction is derived from created vs required
 * (manual overrides honored). Cert-vs-count: a rule whose computed required count is 0 is "accepted by
 * certificate" (shown as a CD chip, not a 0/N bar); a rule with a real required count shows a samples bar.
 * The pay-item Section number leads each section's tree label (a canonical spec-book identifier).
 */
const fNum = (pValue) => { const tmp = Number(pValue); return Number.isFinite(tmp) ? tmp : 0; };

// Required / planned sample counts come STRAIGHT FROM THE SERVER — never re-derived here. The SamplePlan/Lite
// endpoint runs the authoritative PLIMTCalculator (real placed quantities + temporal/plant data) and stamps
// ComputedRequired/PlannedSampleCount onto each PLIMT; a ManualRequired/PlannedSampleCount >= 0 is an operator
// override that wins. (The old client-side CEIL(qty / (rate*frequency)) ignored placed quantities + plant data and
// was wrong for time/lot-based rules — see PLIMTCalculator on the server.)
const resolvePlimtCounts = (pPLIMT) =>
{
	const fResolve = (pManual, pComputed) => { const tmpManual = Number(pManual); return ((pManual != null) && Number.isFinite(tmpManual) && (tmpManual >= 0)) ? tmpManual : fNum(pComputed); };
	return {
		Required: fResolve(pPLIMT.ManualRequiredSampleCount, pPLIMT.ComputedRequiredSampleCount),
		Planned: fResolve(pPLIMT.ManualPlannedSampleCount, pPLIMT.ComputedPlannedSampleCount),
	};
};
const fStr = (pValue) => ((pValue === undefined || pValue === null) ? '' : String(pValue));

// Derive a pay-item Section code for a line item: prefer an explicit field, else the ItemCode prefix
// (e.g. "601-04-63738" -> "601"), else a catch-all bucket.
const fSectionCode = (pLineItem) =>
{
	if (pLineItem.Section !== undefined && pLineItem.Section !== null && String(pLineItem.Section).trim() !== '') { return String(pLineItem.Section).trim(); }
	if (pLineItem.PayItemSection !== undefined && pLineItem.PayItemSection !== null && String(pLineItem.PayItemSection).trim() !== '') { return String(pLineItem.PayItemSection).trim(); }
	const tmpCode = fStr(pLineItem.ItemCode || pLineItem.Code);
	if (tmpCode.indexOf('-') > 0) { return tmpCode.split('-')[0]; }
	return tmpCode || 'Other';
};
const fSectionName = (pLineItem) => fStr(pLineItem.SectionName || pLineItem.PayItemName || pLineItem.PayItemDescription || '');

const fEmptyRollup = () => ({ SamplesRequired: 0, SamplesCreated: 0, CertCount: 0, CertPending: 0, Rules: 0 });
const fAddRuleToRollup = (pAgg, pRule) =>
{
	pAgg.Rules++;
	if (pRule.Kind === 'count') { pAgg.SamplesRequired += pRule.Required; pAgg.SamplesCreated += pRule.Created; }
	else if (pRule.CertOnFile) { pAgg.CertCount++; } else { pAgg.CertPending++; }
};
// Progress text = the real sample-completion ratio only. (Certificate "on file / pending" counts were dropped: the
// Lite payload has no certificate-received flag, so they were a guess — the nested sample-plan entry count is shown
// instead, via EntryCount.)
const fRollupText = (pAgg) => ((pAgg.SamplesRequired > 0) ? `${pAgg.SamplesCreated}/${pAgg.SamplesRequired} samples` : '');

const buildSamplePlanModel = (pSamplePlan) =>
{
	const tmpPlan = pSamplePlan || {};
	const tmpLineItemsRaw = tmpPlan.LineItems || [];
	const tmpMaterialsRaw = tmpPlan.Materials || [];
	const tmpMLIJRaw = tmpPlan.MaterialLineItemJoins || [];
	const tmpRulesRaw = tmpPlan.ProjectLineItemMaterialTests || [];

	// --- indexes ---
	const tmpMaterialByID = {};
	tmpMaterialsRaw.forEach((pMaterial) => { tmpMaterialByID[pMaterial.IDMaterial] = pMaterial; });
	const tmpTestByID = {};
	(tmpPlan.Tests || []).forEach((pTest) => { tmpTestByID[pTest.IDTest] = pTest; });
	const tmpLineItemByID = {};
	tmpLineItemsRaw.forEach((pLineItem) => { tmpLineItemByID[pLineItem.IDLineItem] = pLineItem; });

	// --- line items + sections ---
	const tmpSections = {};
	const tmpLineItems = {};
	tmpLineItemsRaw.forEach((pLineItem) =>
	{
		const tmpSectionCode = fSectionCode(pLineItem);
		if (!tmpSections[tmpSectionCode])
		{
			tmpSections[tmpSectionCode] = { IDSection: tmpSectionCode, Section: tmpSectionCode, Name: fSectionName(pLineItem) || `Section ${tmpSectionCode}`, LineItemCount: 0 };
		}
		else if (!tmpSections[tmpSectionCode].Name && fSectionName(pLineItem)) { tmpSections[tmpSectionCode].Name = fSectionName(pLineItem); }
		// Label a line item by its pay-item NUMBER (+ name when present) — not the long description. Lead with
		// the number (the canonical line-item identifier), append the proper Name if the payload carries one; the
		// description becomes secondary (subtitle / detail), so the row reads "0010 · Prime Coat" not a paragraph.
		const tmpNumber = fStr(pLineItem.ItemNumber || pLineItem.ItemCode || pLineItem.LineItemNumber || pLineItem.Code);
		let tmpLineName = fStr(pLineItem.Name);
		// The payload Name often already leads with the pay-item number ("0001 Clearing and Grubbing"); strip that
		// leading number so prepending Number below doesn't double it ("0001 · 0001 …" → "0001 · Clearing …").
		if (tmpNumber && (tmpLineName.indexOf(tmpNumber) === 0)) { tmpLineName = tmpLineName.slice(tmpNumber.length).replace(/^[\s·:.\-]+/, ''); }
		const tmpDescription = fStr(pLineItem.Description || pLineItem.ItemDescription);
		tmpLineItems[pLineItem.IDLineItem] =
		{
			IDLineItem: pLineItem.IDLineItem,
			IDSection: tmpSectionCode,
			Number: tmpNumber,
			Code: tmpNumber,
			Description: tmpDescription,
			Name: (tmpNumber && tmpLineName) ? `${tmpNumber}  ·  ${tmpLineName}` : (tmpNumber || tmpLineName || tmpDescription || `Line Item ${pLineItem.IDLineItem}`),
			Units: fStr(pLineItem.Units || pLineItem.UnitsImperial),
			ExpectedQty: fNum(pLineItem.ExpectedQuantity),
			InstalledQty: fNum(pLineItem.InstalledQuantity),
		};
	});

	// --- material nodes: one per (line item, material) pair seen in the BOM (MLIJ) or in the rules ---
	const tmpMaterials = {};
	const fEnsureMaterial = (pIDLineItem, pIDMaterial) =>
	{
		const tmpKey = `${pIDLineItem}:${pIDMaterial}`;
		if (!tmpMaterials[tmpKey])
		{
			const tmpMaterial = tmpMaterialByID[pIDMaterial] || {};
			tmpMaterials[tmpKey] =
			{
				Key: tmpKey, IDLineItem: pIDLineItem, IDMaterial: pIDMaterial,
				Name: fStr(tmpMaterial.Name || tmpMaterial.CatalogName || tmpMaterial.CategoryName) || `Material ${pIDMaterial}`,
				MaterialCode: fStr(tmpMaterial.MaterialCode),
			};
		}
		return tmpMaterials[tmpKey];
	};
	tmpMLIJRaw.forEach((pMLIJ) => { if (tmpLineItems[pMLIJ.IDLineItem]) { fEnsureMaterial(pMLIJ.IDLineItem, pMLIJ.IDMaterial); } });

	// --- rules (one per PLIMT row) + satisfaction via the calculator ---
	const tmpRules = [];
	tmpRulesRaw.forEach((pPLIMT) =>
	{
		if (!tmpLineItems[pPLIMT.IDLineItem]) { return; }   // orphan rule (no line item) — skip
		fEnsureMaterial(pPLIMT.IDLineItem, pPLIMT.IDMaterial);
		const tmpLineItem = tmpLineItemByID[pPLIMT.IDLineItem] || {};
		const tmpMaterial = tmpMaterialByID[pPLIMT.IDMaterial] || null;
		const tmpCounts = resolvePlimtCounts(pPLIMT);
		const tmpRequired = tmpCounts.Required;
		const tmpCreated = fNum(pPLIMT.CreatedSampleCount);
		// Three kinds: 'cert' = accepted by Certificate of Delivery (CertificateRequired) — a real certificate, no lab
		// test. 'perproject' = a TEST sampled once per project (the Frequency 999999 sentinel) — NOT a certificate,
		// even though it isn't an N/M cadence. 'count' = a real sampling cadence (N per unit). CertificateRequired wins
		// when both are set.
		const tmpIsCert = (fNum(pPLIMT.CertificateRequired) === 1);
		const tmpIsPerProject = !tmpIsCert && (fNum(pPLIMT.Frequency) === 999999);
		// The Test entity (when the rule names one via IDTest) carries the test's Hash (e.g. "TR207Ev1") — the
		// canonical test code engineers recognize. Lite omits Tests; the provider fetches + injects them.
		const tmpTest = tmpTestByID[pPLIMT.IDTest] || null;
		const tmpTestHash = tmpTest ? fStr(tmpTest.Hash) : '';
		const tmpSampleType = fStr(pPLIMT.SampleType) || 'ACPT';
		tmpRules.push(
			{
				IDRule: pPLIMT.IDProjectLineItemMaterialTest,
				IDLineItem: pPLIMT.IDLineItem,
				IDMaterial: pPLIMT.IDMaterial,
				MaterialKey: `${pPLIMT.IDLineItem}:${pPLIMT.IDMaterial}`,
				IDTest: pPLIMT.IDTest,
				TestHash: tmpTestHash,
				Title: fStr(pPLIMT.TestDescription || pPLIMT.SampleDescription) || 'Material Acceptance',
				SampleType: tmpSampleType,
				TestLabel: tmpTestHash ? `${tmpTestHash}  ·  ${tmpSampleType}` : tmpSampleType,
				Frequency: fNum(pPLIMT.Frequency),
				Rate: fNum(pPLIMT.Rate) || 1,
				ConversionFactor: fNum(pPLIMT.ConversionFactor) || 1,
				Units: fStr(pPLIMT.Units),
				Intent: fStr(pPLIMT.Intent),
				SamplingInstructions: fStr(pPLIMT.SamplingInstructions),
				Remarks: fStr(pPLIMT.Remarks),
				Kind: tmpIsCert ? 'cert' : (tmpIsPerProject ? 'perproject' : 'count'),
				Required: tmpRequired,
				Planned: tmpCounts.Planned,
				Created: tmpCreated,
				Passing: fNum(pPLIMT.PassingSampleCount),
				// No per-rule "CD received" flag in the Lite payload — use "a sample/cert exists" as the proxy for
				// on-file. (Refine once the live data exposes an explicit certificate status.)
				CertOnFile: (tmpCreated > 0) || (fNum(pPLIMT.CertificateRequired) === 1 && tmpCreated > 0),
			});
	});

	// --- rollups ---
	const tmpMaterialAgg = {};
	const tmpLineItemAgg = {};
	const tmpSectionAgg = {};
	Object.keys(tmpLineItems).forEach((pID) => { tmpLineItemAgg[pID] = fEmptyRollup(); });
	Object.keys(tmpSections).forEach((pCode) => { tmpSectionAgg[pCode] = Object.assign(fEmptyRollup(), { LineItems: {} }); });
	Object.keys(tmpMaterials).forEach((pKey) => { tmpMaterialAgg[pKey] = fEmptyRollup(); });
	const tmpPlanAgg = fEmptyRollup();
	tmpRules.forEach((pRule) =>
	{
		fAddRuleToRollup(tmpMaterialAgg[pRule.MaterialKey], pRule);
		if (tmpLineItemAgg[pRule.IDLineItem]) { fAddRuleToRollup(tmpLineItemAgg[pRule.IDLineItem], pRule); }
		const tmpSectionCode = tmpLineItems[pRule.IDLineItem].IDSection;
		if (tmpSectionAgg[tmpSectionCode]) { fAddRuleToRollup(tmpSectionAgg[tmpSectionCode], pRule); tmpSectionAgg[tmpSectionCode].LineItems[pRule.IDLineItem] = true; }
		fAddRuleToRollup(tmpPlanAgg, pRule);
	});

	// --- stamp display + rollup numbers ---
	const fStamp = (pRecord, pAgg) =>
	{
		pRecord.SamplesRequired = pAgg.SamplesRequired;
		pRecord.SamplesCreated = pAgg.SamplesCreated;
		pRecord.CertCount = pAgg.CertCount;
		pRecord.CertPending = pAgg.CertPending;
		pRecord.EntryCount = pAgg.Rules;
		pRecord.SatisfactionText = fRollupText(pAgg);
	};
	Object.values(tmpMaterials).forEach((pMat) => fStamp(pMat, tmpMaterialAgg[pMat.Key] || fEmptyRollup()));
	Object.values(tmpLineItems).forEach((pLI) => fStamp(pLI, tmpLineItemAgg[pLI.IDLineItem] || fEmptyRollup()));
	Object.values(tmpSections).forEach((pSec) =>
	{
		const tmpAgg = tmpSectionAgg[pSec.IDSection];
		pSec.LineItemCount = Object.keys(tmpAgg.LineItems).length;
		fStamp(pSec, tmpAgg);
		const tmpNumber = fStr(pSec.Section).trim();
		pSec.TreeLabel = (tmpNumber !== '') ? `${tmpNumber}  ·  ${pSec.Name}` : pSec.Name;
	});
	tmpRules.forEach((pRule) =>
	{
		pRule.SatisfactionText = (pRule.Kind === 'cert') ? 'By certificate'
			: (pRule.Kind === 'perproject') ? '1 / project'
			: `${pRule.Created}/${pRule.Required} samples`;
	});

	return {
		project: tmpPlan.Project || {},
		sections: Object.values(tmpSections).sort((a, b) => (String(a.Section) < String(b.Section) ? -1 : 1)),
		lineItems: Object.values(tmpLineItems).sort((a, b) => (a.Code < b.Code ? -1 : 1)),
		materials: Object.values(tmpMaterials),
		rules: tmpRules,
		plan: Object.assign({}, tmpPlanAgg, { SatisfactionText: fRollupText(tmpPlanAgg) }),
	};
};

/**
 * Recompute every satisfaction rollup (Material → LineItem → Section → plan) from the model's current rules, and
 * refresh each rule's SatisfactionText. Used after an in-place edit so the aggregates stay consistent with the changed
 * rule without a full reload. Mirrors the rollup+stamp pass in buildSamplePlanModel; TreeLabel/Name/counts of the
 * structural nodes are static (set once at build) and are left untouched.
 * @param {Object} pModel - the model returned by buildSamplePlanModel (mutated in place)
 * @returns {Object} the same model
 */
const restampRollups = (pModel) =>
{
	if (!pModel) { return pModel; }
	const tmpSections = pModel.sections || [];
	const tmpLineItems = pModel.lineItems || [];
	const tmpMaterials = pModel.materials || [];
	const tmpRules = pModel.rules || [];

	const tmpMaterialAgg = {};
	const tmpLineItemAgg = {};
	const tmpSectionAgg = {};
	const tmpSectionByLineItem = {};
	tmpMaterials.forEach((pMaterial) => { tmpMaterialAgg[pMaterial.Key] = fEmptyRollup(); });
	tmpLineItems.forEach((pLineItem) => { tmpLineItemAgg[pLineItem.IDLineItem] = fEmptyRollup(); tmpSectionByLineItem[pLineItem.IDLineItem] = pLineItem.IDSection; });
	tmpSections.forEach((pSection) => { tmpSectionAgg[pSection.IDSection] = Object.assign(fEmptyRollup(), { LineItems: {} }); });
	const tmpPlanAgg = fEmptyRollup();

	tmpRules.forEach((pRule) =>
	{
		if (tmpMaterialAgg[pRule.MaterialKey]) { fAddRuleToRollup(tmpMaterialAgg[pRule.MaterialKey], pRule); }
		if (tmpLineItemAgg[pRule.IDLineItem]) { fAddRuleToRollup(tmpLineItemAgg[pRule.IDLineItem], pRule); }
		const tmpSectionCode = tmpSectionByLineItem[pRule.IDLineItem];
		if (tmpSectionAgg[tmpSectionCode]) { fAddRuleToRollup(tmpSectionAgg[tmpSectionCode], pRule); tmpSectionAgg[tmpSectionCode].LineItems[pRule.IDLineItem] = true; }
		fAddRuleToRollup(tmpPlanAgg, pRule);
	});

	const fStamp = (pRecord, pAgg) =>
	{
		pRecord.SamplesRequired = pAgg.SamplesRequired;
		pRecord.SamplesCreated = pAgg.SamplesCreated;
		pRecord.CertCount = pAgg.CertCount;
		pRecord.CertPending = pAgg.CertPending;
		pRecord.EntryCount = pAgg.Rules;
		pRecord.SatisfactionText = fRollupText(pAgg);
	};
	tmpMaterials.forEach((pMaterial) => fStamp(pMaterial, tmpMaterialAgg[pMaterial.Key] || fEmptyRollup()));
	tmpLineItems.forEach((pLineItem) => fStamp(pLineItem, tmpLineItemAgg[pLineItem.IDLineItem] || fEmptyRollup()));
	tmpSections.forEach((pSection) =>
	{
		const tmpAgg = tmpSectionAgg[pSection.IDSection] || Object.assign(fEmptyRollup(), { LineItems: {} });
		pSection.LineItemCount = Object.keys(tmpAgg.LineItems).length;
		fStamp(pSection, tmpAgg);
	});
	tmpRules.forEach((pRule) =>
	{
		pRule.SatisfactionText = (pRule.Kind === 'cert') ? 'By certificate'
			: (pRule.Kind === 'perproject') ? '1 / project'
			: `${pRule.Created}/${pRule.Required} samples`;
	});
	pModel.plan = Object.assign({}, tmpPlanAgg, { SatisfactionText: fRollupText(tmpPlanAgg) });
	return pModel;
};

module.exports = { buildSamplePlanModel, restampRollups, resolvePlimtCounts };

},{}],1385:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const { buildSamplePlanModel, restampRollups, resolvePlimtCounts } = require('./SamplePlan-Model.js');
const { procedureForTest } = require('./SamplePlan-MSM-Map.js');

// The Intent vocabulary the legacy editor offers. Free text is still accepted (this is a combobox seed, not a gate).
const INTENT_OPTIONS = [ 'Ongoing', 'Final', 'Special', 'Other' ];
// The SamplePlan config defaults the Vue app merges over (Configuration/For/SamplePlan/HeadLight). Test selector on,
// rate toggle off, unless the customer's config says otherwise.
const DEFAULT_FEATURES = { ShowTestSelector: true, ShowRateToggle: false };

// Graduated satisfaction tones: near-complete reads green, in-progress amber, well-behind red.
const fBarTone = (pPercent) => ((pPercent >= 90) ? 'ok' : ((pPercent >= 50) ? 'warn' : 'bad'));

// A static resolver over an in-memory array — the shape pict-dataexplorer expects from a custom source.
const fStaticResolve = (pRows, pOptions) =>
{
	const tmpRows = pRows || [];
	if (pOptions && pOptions.CountOnly) { return { count: tmpRows.length }; }
	const tmpBegin = (pOptions && pOptions.begin) || 0;
	const tmpCount = (pOptions && pOptions.count) || tmpRows.length;
	return { records: tmpRows.slice(tmpBegin, tmpBegin + tmpCount), hasMore: (tmpBegin + tmpCount) < tmpRows.length };
};

// Section / Line Item / Material rollup → a samples bar (count rules) + the count of sample-plan entries nested here.
const fRollupMeters = (pRecord) =>
{
	const tmpMeters = [];
	if (pRecord.SamplesRequired > 0)
	{
		const tmpPercent = Math.round((pRecord.SamplesCreated / pRecord.SamplesRequired) * 100);
		tmpMeters.push({ Kind: 'bar', Percent: tmpPercent, Tone: fBarTone(tmpPercent), Label: `${pRecord.SamplesCreated}/${pRecord.SamplesRequired}`, Title: `${pRecord.SamplesCreated} of ${pRecord.SamplesRequired} samples created` });
	}
	if (pRecord.EntryCount > 0) { tmpMeters.push({ Kind: 'pill', Tone: 'muted', Text: `${pRecord.EntryCount} ${pRecord.EntryCount === 1 ? 'entry' : 'entries'}`, Title: `${pRecord.EntryCount} sample plan ${pRecord.EntryCount === 1 ? 'entry' : 'entries'} nested here` }); }
	return tmpMeters;
};

// A single rule: certificate rules show a certificate pill, once-per-project tests show a "1 / project" pill, and
// count rules show a samples-progress bar.
const fRuleMeters = (pRecord) =>
{
	if (pRecord.Kind === 'cert') { return [ { Kind: 'pill', Tone: 'muted', Text: 'by certificate', Title: 'Accepted by certificate of delivery' } ]; }
	if (pRecord.Kind === 'perproject') { return [ { Kind: 'pill', Tone: 'muted', Text: '1 / project', Title: 'Sampled once per project' } ]; }
	const tmpPercent = (pRecord.Required > 0) ? Math.round((pRecord.Created / pRecord.Required) * 100) : 0;
	return [ { Kind: 'bar', Percent: tmpPercent, Tone: fBarTone(tmpPercent), Label: `${pRecord.Created}/${pRecord.Required}`, Title: `${pRecord.Created} of ${pRecord.Required} samples created` } ];
};

// The columns each tier offers in its "Columns" chooser (surfaced as chips on the rows). These tiers are
// SYNTHESIZED in memory (custom Resolvers over the loaded plan — SamplePlan-Model), so there is no Meadow
// entity schema to discover: the explorer's default schema source would GET `/1.0/<Entity>/Schema` — a 404
// for the synthetic 'Rule' tier ("Endpoint does not exist!"), and for the real entities it offers columns the
// in-memory records don't carry (they render blank when checked, which is why only Description/Units showed).
// So we feed the chooser this explicit list of real, human-facing fields present on each tier's records
// instead (see chooserColumnsForEntity + SamplePlan.onAfterRender). Each tier's Display Title field is
// filtered out of the chooser by the explorer itself. Only scalar fields — a chip stringifies its value.
const SAMPLE_PLAN_TIER_COLUMNS =
{
	Section:  [ 'Name', 'LineItemCount', 'EntryCount', 'SamplesRequired', 'SamplesCreated', 'CertCount', 'CertPending', 'SatisfactionText' ],
	LineItem: [ 'Number', 'Description', 'Units', 'ExpectedQty', 'InstalledQty', 'EntryCount', 'SamplesRequired', 'SamplesCreated', 'CertCount', 'CertPending', 'SatisfactionText' ],
	Material: [ 'MaterialCode', 'EntryCount', 'SamplesRequired', 'SamplesCreated', 'CertCount', 'CertPending', 'SatisfactionText' ],
	Rule:     [ 'TestHash', 'SampleType', 'Kind', 'Frequency', 'Rate', 'ConversionFactor', 'Units', 'Required', 'Planned', 'Created', 'Passing', 'Intent', 'SamplingInstructions', 'Remarks', 'SatisfactionText' ],
};

/**
 * The Sample Plan editor's data/logic provider. Loads a project's whole plan once (SamplePlan/Lite, whose server-computed counts it uses verbatim), builds the in-memory Section→LineItem→Material→Rule model + satisfaction (SamplePlan-Model),
 * and hands pict-dataexplorer an in-memory ExplorerConfig (custom Resolvers + RowMeters + OnNodeSelect). The
 * SamplePlan view owns the chrome + the master/detail render; this provider owns the model, the explorer
 * config, selection → detail data, and the layered AcademyContent docs (fetched by hash).
 */
class SamplePlanProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._idProject = null;
		this._model = null;
		this._explorerConfig = null;
		this._selected = null;
		this._docsMode = true;
		this._academyCache = {};
		// Edit-mode support: the model's rule projection is lossy, so full edit works off the raw PLIMT rows. We retain the raw
		// line items + materials (for the edit form vocabularies) + the fresh Lite PLIMTs (whose server-computed counts the editor reads).
		this._rawLineItemByID = {};
		this._rawMaterialByID = {};
		this._unitsOptions = [];
		this._features = null;
		this._testOptions = null;
		this._sampleTypes = null;
		this._rawRuleCache = {};
		// Mutable tree indexes (populated by _buildExplorerConfig) so add-entry / add-material can splice nodes in place.
		this._lineItemsBySection = {};
		this._materialsByLineItem = {};
		this._rulesByMaterialKey = {};
		// Contract-id → spec year, resolved lazily for the front-door project list and cached across searches.
		this._contractSpecYearCache = {};
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }

	get workspaceState()
	{
		if (!this.pict.AppData.SamplePlan) { this.pict.AppData.SamplePlan = { Loading: false, Message: '', HasModel: false, ProjectName: '', ProjectCode: '', PlanText: '' }; }
		return this.pict.AppData.SamplePlan;
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	_render()
	{
		if (this.pict.views['SamplePlan']) { this.pict.views['SamplePlan'].render(); }
	}

	getExplorerConfig() { return this._explorerConfig; }

	/**
	 * The "Columns" chooser options for a synthesized tier — the real fields on that tier's in-memory records.
	 * Wired into the explorer as its SchemaSource so the chooser never fetches `/1.0/<Entity>/Schema` (there is
	 * no Meadow entity behind these tiers; the synthetic 'Rule' tier's endpoint 404s). Returns [] for unknown
	 * tiers, which the explorer treats as "no chooser".
	 * @param {String} pEntity
	 * @returns {Array<String>}
	 */
	chooserColumnsForEntity(pEntity) { return SAMPLE_PLAN_TIER_COLUMNS[pEntity] || []; }
	get model() { return this._model; }
	get selected() { return this._selected; }
	get docsMode() { return this._docsMode; }

	// --- Loading ------------------------------------------------------------------------------------

	/**
	 * Load a project's sample plan by ID, build the model + the explorer config, then re-render (the view's
	 * onAfterRender mounts the explorer once the config is present).
	 * @param {Number} pIDProject
	 */
	async loadAsync(pIDProject)
	{
		const tmpState = this.workspaceState;
		this._idProject = pIDProject;
		this._model = null;
		this._explorerConfig = null;
		this._selected = null;
		this._academyCache = {};
		this._rawLineItemByID = {};
		this._rawMaterialByID = {};
		this._unitsOptions = [];
		this._features = null;
		this._testOptions = null;
		this._rawRuleCache = {};
		tmpState.Loading = true;
		tmpState.Message = '';
		tmpState.HasModel = false;
		this._render();

		try
		{
			const tmpLite = await this._getJSON(`SamplePlan/Lite/By/IDProject/${pIDProject}`);
			// SamplePlan/Lite carries the BOM (MLIJ) + rules (PLIMT) — which reference IDMaterial + IDTest — but omits
			// the Material + Test entities. Fetch + inject them so the model can name/code materials and surface test
			// hashes (else materials show "Material <id>" and test hashes are unavailable).
			tmpLite.Materials = await this._fetchByIDs('Materials', 'IDMaterial', this._collectIDs(tmpLite, 'IDMaterial', [ 'MaterialLineItemJoins', 'ProjectLineItemMaterialTests' ]));
			tmpLite.Tests = await this._fetchByIDs('Tests', 'IDTest', this._collectIDs(tmpLite, 'IDTest', [ 'ProjectLineItemMaterialTests' ]));
			// The SamplePlan/Lite payload already carries the SERVER-computed ComputedRequired/PlannedSampleCount on each
			// PLIMT (the endpoint runs the authoritative PLIMTCalculator) — the model reads those directly; nothing is
			// computed client-side.
			const tmpModel = buildSamplePlanModel(tmpLite);
			this._model = tmpModel;
			this._explorerConfig = this._buildExplorerConfig(tmpModel);

			// Retain the raw payload pieces edit mode needs: the materials' UnitsImperial is the Units/Sample Units
			// dropdown vocabulary; line items carry the display quantities.
			(tmpLite.LineItems || []).forEach((pLineItem) => { this._rawLineItemByID[pLineItem.IDLineItem] = pLineItem; });
			(tmpLite.Materials || []).forEach((pMaterial) => { this._rawMaterialByID[pMaterial.IDMaterial] = pMaterial; });
			// Cache the FRESH Lite PLIMTs (they carry the server-recomputed Computed*SampleCount) as the raw edit rows,
			// so the editor's computed readouts match the tree instead of the stale ProjectLineItemMaterialTest table.
			(tmpLite.ProjectLineItemMaterialTests || []).forEach((pPLIMT) => { if (pPLIMT.IDProjectLineItemMaterialTest != null) { this._rawRuleCache[pPLIMT.IDProjectLineItemMaterialTest] = pPLIMT; } });
			this._unitsOptions = this._distinctUnits(tmpLite.Materials);
			// Feature flags gate the Rate toggle vs. numeric input and the Test/Intent selectors — best-effort, defaulted.
			this._features = await this._loadFeaturesAsync();

			tmpState.Loading = false;
			tmpState.HasModel = true;
			tmpState.ProjectName = (tmpModel.project && (tmpModel.project.Name || tmpModel.project.Description)) || `Project ${pIDProject}`;
			tmpState.ProjectCode = (tmpModel.project && (tmpModel.project.ExternalProjectID || tmpModel.project.ProjectCode)) || '';
			tmpState.PlanText = tmpModel.plan ? tmpModel.plan.SatisfactionText : '';
			tmpState.SectionCount = tmpModel.sections.length;
			tmpState.LineItemCount = tmpModel.lineItems.length;
			tmpState.RuleCount = tmpModel.rules.length;
			this._render();
		}
		catch (pError)
		{
			tmpState.Loading = false;
			tmpState.HasModel = false;
			tmpState.Message = `Could not load the sample plan for project ${pIDProject}: ${pError && pError.message ? pError.message : pError}`;
			this.pict.log.error(`SamplePlan load failed for project ${pIDProject}`, pError);
			this._render();
		}
	}

	/** Collect the distinct truthy values of pField across the named Lite collections. */
	_collectIDs(pLite, pField, pCollections)
	{
		const tmpMap = {};
		pCollections.forEach((pName) => { (pLite[pName] || []).forEach((pRow) => { if (pRow[pField]) { tmpMap[pRow[pField]] = true; } }); });
		return Object.keys(tmpMap);
	}

	/**
	 * Batch-fetch entity records by a list of ids — SamplePlan/Lite carries only the foreign keys (IDMaterial,
	 * IDTest), not the Material / Test entities, so the model can't name/code them without this. FBL (filter-by-
	 * list) IN, chunked to keep the URL bounded; failures degrade (names/codes fall back) rather than break load.
	 */
	async _fetchByIDs(pEntityPlural, pIDField, pIDs)
	{
		if (!pIDs || (pIDs.length === 0)) { return []; }
		const tmpRecords = [];
		const tmpChunkSize = 200;
		for (let i = 0; i < pIDs.length; i += tmpChunkSize)
		{
			const tmpChunk = pIDs.slice(i, i + tmpChunkSize);
			try
			{
				const tmpRows = await this._getJSON(`${pEntityPlural}/FilteredTo/FBL~${pIDField}~INN~${tmpChunk.join(',')}/0/${tmpChunk.length}`);
				if (Array.isArray(tmpRows)) { tmpRecords.push.apply(tmpRecords, tmpRows); }
			}
			catch (pError)
			{
				this.pict.log.warn(`SamplePlan: could not load ${tmpChunk.length} ${pEntityPlural}`, pError);
			}
		}
		return tmpRecords;
	}

	// --- Explorer config (in-memory) ----------------------------------------------------------------

	_buildExplorerConfig(pModel)
	{
		// Provider-level (MUTABLE) indexes so add-entry / add-material can splice new nodes in and refresh just the
		// affected folder in place (the resolvers read these live), without rebuilding or collapsing the whole tree.
		this._lineItemsBySection = {};
		this._materialsByLineItem = {};
		this._rulesByMaterialKey = {};
		for (let i = 0; i < pModel.lineItems.length; i++) { const li = pModel.lineItems[i]; (this._lineItemsBySection[li.IDSection] = this._lineItemsBySection[li.IDSection] || []).push(li); }
		for (let i = 0; i < pModel.materials.length; i++) { const m = pModel.materials[i]; (this._materialsByLineItem[m.IDLineItem] = this._materialsByLineItem[m.IDLineItem] || []).push(m); }
		for (let i = 0; i < pModel.rules.length; i++) { const r = pModel.rules[i]; (this._rulesByMaterialKey[r.MaterialKey] = this._rulesByMaterialKey[r.MaterialKey] || []).push(r); }

		return {
			PageSize: 50,
			MaxDepth: 8,
			OnNodeSelect: (pSelection) => this.onNodeSelect(pSelection),
			// A node whose only child is a single collection (LineItem→Materials, Material→Tests) auto-opens that
			// collection, so drilling in doesn't cost an extra click per level.
			AutoExpandSoleChild: true,
			Roots:
			[
				{ Label: 'By Pay-Item Section', Entity: 'Section' },
				{ Label: 'By Line Item', Entity: 'LineItem' },
			],
			Entities:
			{
				Section:
				{
					IDField: 'IDSection',
					Display: { Title: 'TreeLabel', Subtitle: '{~D:Record.LineItemCount~} line items' },
					RowMeters: fRollupMeters,
					Resolver: (pOptions) => fStaticResolve(pModel.sections, pOptions),
					Children: [ { Label: 'Line Items', Entity: 'LineItem', Resolve: 'count', Resolver: (pSection, pOptions) => fStaticResolve(this._lineItemsBySection[pSection.IDSection], pOptions) } ],
				},
				LineItem:
				{
					IDField: 'IDLineItem',
					Display: { Title: 'Name', Subtitle: '{~D:Record.Description~}' },
					RowMeters: fRollupMeters,
					Resolver: (pOptions) => fStaticResolve(pModel.lineItems, pOptions),
					Children: [ { Label: 'Materials', Entity: 'Material', Resolve: 'count', Resolver: (pLineItem, pOptions) => fStaticResolve(this._materialsByLineItem[pLineItem.IDLineItem], pOptions) } ],
				},
				Material:
				{
					IDField: 'Key',
					Display: { Title: 'Name', Subtitle: '{~D:Record.MaterialCode~}' },
					RowMeters: fRollupMeters,
					Children: [ { Label: 'Tests', Entity: 'Rule', Resolve: 'count', Resolver: (pMaterial, pOptions) => fStaticResolve(this._rulesByMaterialKey[pMaterial.Key], pOptions) } ],
				},
				Rule:
				{
					IDField: 'IDRule',
					Display: { Title: 'Title', Subtitle: '{~D:Record.TestLabel~}' },
					RowMeters: fRuleMeters,
				},
			},
		};
	}

	// --- Selection + detail data --------------------------------------------------------------------

	onNodeSelect(pSelection)
	{
		this._selected = pSelection;
		// The view repaints the detail and, if the docs side panel is open, refreshes it (fetching this
		// selection's docs as needed). The panel is opened explicitly via the Docs button, not on every select.
		if (this.pict.views['SamplePlan']) { this.pict.views['SamplePlan'].renderDetail(); }
	}

	setDocsMode(pOn)
	{
		this._docsMode = !!pOn;
		if (this.pict.views['SamplePlan']) { this.pict.views['SamplePlan'].renderDetail(); }
	}

	/** Programmatically make a model rule the current selection (used after creating an entry — the tree node may not exist yet). */
	selectRuleRecord(pRule) { this._selected = { Entity: 'Rule', Record: pRule, Key: pRule.IDRule }; }

	/** The layered AcademyContent hashes for a rule: project entry, state spec-year, federal/material. */
	docHashesForRule(pRule)
	{
		const tmpSection = this._sectionCodeForRule(pRule);
		const tmpProcedure = procedureForTest(pRule.Title);
		const tmpHashes = [];
		// The MSM Part II sampling procedure for this test (how to physically sample it) — seeded from the manual.
		if (tmpProcedure) { tmpHashes.push({ Tier: `Sampling procedure · MSM ${tmpProcedure}`, Hash: `SamplePlanProcedure-${tmpProcedure}` }); }
		tmpHashes.push({ Tier: 'Federal', Hash: `SamplePlanFHWA-${pRule.IDMaterial}` });
		// Section sampling schedule from the MSM (seeded per spec Section; manual edition noted in the content).
		tmpHashes.push({ Tier: 'State spec book', Hash: `SamplePlanSpec-${tmpSection}` });
		tmpHashes.push({ Tier: 'This project', Hash: `SamplePlanEntry-${pRule.IDRule}` });
		return tmpHashes;
	}

	_sectionCodeForRule(pRule)
	{
		if (!this._model) { return ''; }
		const tmpLineItem = this._model.lineItems.find((pLI) => pLI.IDLineItem === pRule.IDLineItem);
		return tmpLineItem ? tmpLineItem.IDSection : '';
	}

	/** Doc tiers for ANY selection: a rule's full tiers, or the section schedule for a section / line item / material. */
	docHashesForSelection(pSelection)
	{
		if (!pSelection) { return []; }
		if (pSelection.Entity === 'Rule') { return this.docHashesForRule(pSelection.Record); }
		const tmpSection = this._sectionCodeForSelection(pSelection);
		return tmpSection ? [ { Tier: 'State spec book', Hash: `SamplePlanSpec-${tmpSection}` } ] : [];
	}

	/** Resolve the spec Section code for any selection (sections carry it; line items/materials/rules reach it via their line item). */
	_sectionCodeForSelection(pSelection)
	{
		const tmpRecord = (pSelection && pSelection.Record) || {};
		if (pSelection && (pSelection.Entity === 'Section')) { return tmpRecord.IDSection || tmpRecord.Section || ''; }
		if (tmpRecord.IDSection) { return tmpRecord.IDSection; }
		if (tmpRecord.IDLineItem && this._model)
		{
			const tmpLineItem = this._model.lineItems.find((pLI) => pLI.IDLineItem === tmpRecord.IDLineItem);
			return tmpLineItem ? tmpLineItem.IDSection : '';
		}
		return '';
	}

	/** Resolve a single AcademyContent record by Hash (cached). Returns the record or null. */
	getCachedDoc(pHash) { return this._academyCache[pHash]; }

	/** Fetch + cache AcademyContent rows by hash (idempotent). Resolves true if anything was newly fetched. */
	async _ensureHashes(pHashes)
	{
		let tmpChanged = false;
		await Promise.all((pHashes || []).map(async (pHash) =>
		{
			if (this._academyCache[pHash] !== undefined) { return; }
			try
			{
				const tmpRows = await this._getJSON(`AcademyContents/FilteredTo/FBV~Hash~EQ~${encodeURIComponent(pHash)}`);
				this._academyCache[pHash] = (Array.isArray(tmpRows) && tmpRows.length) ? tmpRows[0] : null;
			}
			catch (pError) { this._academyCache[pHash] = null; }
			tmpChanged = true;
		}));
		return tmpChanged;
	}

	/** Ensure the docs for a selection (a rule's tiers, or a section schedule) are fetched + cached. */
	ensureSelectionDocs(pSelection) { return this._ensureHashes(this.docHashesForSelection(pSelection).map((pEntry) => pEntry.Hash)); }
	/** Ensure a single AcademyContent doc (by hash) is fetched + cached — used by the spec-index navigation. */
	ensureDoc(pHash) { return this._ensureHashes([ pHash ]); }

	/** The index of every seeded sampling-manual doc (Hash + Title), for the spec-navigation root. Cached. */
	async loadSpecIndex()
	{
		if (this._specIndex) { return this._specIndex; }
		try
		{
			const tmpRows = await this._getJSON(`AcademyContents/FilteredTo/FBV~Hash~LK~${encodeURIComponent('SamplePlan%')}/0/500`);
			this._specIndex = Array.isArray(tmpRows) ? tmpRows.map((pRow) => ({ Hash: pRow.Hash, Title: pRow.Title })) : [];
		}
		catch (pError) { this._specIndex = []; }
		return this._specIndex;
	}

	// --- Project picker (front door): a filterable, server-searched list of the caller's projects ------

	/**
	 * Search projects by name for the front-door list. Tenancy is scoped by the server (no client IDCustomer filter —
	 * a Headlight admin configures across customers, so the server owns the scope). Empty term = the first page. The
	 * ≤100 returned rows are name-sorted client-side for a tidy alphabetical list.
	 * @param {String} pTerm
	 * @returns {Promise<Array<{ IDProject: Number, Name: String, Code: String }>>}
	 */
	async searchProjectsAsync(pTerm)
	{
		const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
		let tmpFilter = 'FBV~Deleted~EQ~0';
		if (tmpTerm) { tmpFilter = `FBV~Name~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`; }
		const tmpRows = await this._getJSON(`Projects/Lite/FilteredTo/${tmpFilter}/0/100`).catch(() => []);
		// The Lite projection carries the display name in `Value` (the search filter still operates on the real Name column)
		// and the FK to the contract in `IDContract` (used to resolve the spec year below).
		const tmpProjects = (Array.isArray(tmpRows) ? tmpRows : [])
			.map((pRow) => (
				{
					IDProject: pRow.IDProject,
					Name: pRow.Value || pRow.Name || pRow.Description || `Project ${pRow.IDProject}`,
					IDContract: pRow.IDContract || 0,
					SpecYear: '',
				}));
		await this._resolveSpecYears(tmpProjects);
		return tmpProjects.sort((pA, pB) => (pA.Name.toLowerCase() < pB.Name.toLowerCase() ? -1 : ((pA.Name.toLowerCase() > pB.Name.toLowerCase()) ? 1 : 0)));
	}

	/**
	 * Fill each project row's SpecYear from its contract — there is no project-level spec year, so the canonical proxy
	 * is Contract.ItemSpecificationYear (the pay-item spec-book year). Batched by distinct contract id, cached across
	 * searches, tolerant of failures, and blank when a project has no contract. Tenancy stays server-managed.
	 */
	async _resolveSpecYears(pProjects)
	{
		const tmpNeeded = {};
		pProjects.forEach((pProject) => { const tmpID = Number(pProject.IDContract); if ((tmpID > 0) && !(tmpID in this._contractSpecYearCache)) { tmpNeeded[tmpID] = true; } });
		const tmpIDs = Object.keys(tmpNeeded);
		const tmpChunkSize = 100;
		for (let i = 0; i < tmpIDs.length; i += tmpChunkSize)
		{
			const tmpChunk = tmpIDs.slice(i, i + tmpChunkSize);
			const tmpContracts = await this._getJSON(`Contracts/FilteredTo/FBL~IDContract~INN~${tmpChunk.join(',')}/0/${tmpChunk.length}`).catch(() => []);
			(Array.isArray(tmpContracts) ? tmpContracts : []).forEach((pContract) =>
			{
				this._contractSpecYearCache[pContract.IDContract] = String(pContract.ItemSpecificationYear || pContract.MaterialsSpecificationYear || '').trim();
			});
			// Any ids that didn't resolve (deleted/inaccessible) → cache blank so we don't refetch them next keystroke.
			tmpChunk.forEach((pID) => { if (!(pID in this._contractSpecYearCache)) { this._contractSpecYearCache[pID] = ''; } });
		}
		pProjects.forEach((pProject) => { pProject.SpecYear = (Number(pProject.IDContract) > 0) ? (this._contractSpecYearCache[pProject.IDContract] || '') : ''; });
	}

	// --- Edit mode: full rule record, dropdown vocabularies, live counts, save --------------------------

	get features() { return this._features || DEFAULT_FEATURES; }
	get unitsOptions() { return this._unitsOptions || []; }
	get intentOptions() { return INTENT_OPTIONS.slice(); }

	/** Distinct, non-empty, case-insensitively sorted UnitsImperial across the loaded materials (the Units vocabulary). */
	_distinctUnits(pMaterials)
	{
		const tmpSeen = {};
		(pMaterials || []).forEach((pMaterial) =>
		{
			const tmpUnit = (pMaterial && (pMaterial.UnitsImperial != null)) ? String(pMaterial.UnitsImperial).trim() : '';
			if (tmpUnit !== '') { tmpSeen[tmpUnit] = true; }
		});
		return Object.keys(tmpSeen).sort((pA, pB) => (pA.toLowerCase() < pB.toLowerCase() ? -1 : 1));
	}

	/** Best-effort load of the SamplePlan config (same source the Vue app reads); merged over the shared defaults. */
	async _loadFeaturesAsync()
	{
		try
		{
			const tmpConfig = await this._getJSON('Configuration/For/SamplePlan/HeadLight');
			return Object.assign({}, DEFAULT_FEATURES, (tmpConfig && tmpConfig.Features) || {});
		}
		catch (pError) { return Object.assign({}, DEFAULT_FEATURES); }
	}

	/**
	 * Whether the current user may edit sample-plan rules (SamplePlanEntry/Update). Server-authoritative and
	 * fail-open before the capability map loads — matching the app's other capability gates; the server enforces
	 * the write (tenancy included), and a denied save surfaces as an inline error.
	 */
	canEditRule()
	{
		const tmpApp = this.pict.PictApplication;
		const tmpService = (tmpApp && tmpApp.EffectivePermissionsService) || (this.pict.fable && this.pict.fable.EffectivePermissionsService);
		if (tmpService && (typeof tmpService.can === 'function')) { return !!tmpService.can('SamplePlanEntry', 'Update'); }
		return true;
	}

	/** The raw PLIMT row for a rule, if already fetched/cached (the full editable field set the lossy model omits). */
	getRawRule(pIDRule) { return this._rawRuleCache[pIDRule]; }

	/**
	 * Fetch the full editable PLIMT row for a Rule selection — the in-memory model is a lossy projection, so VIEW
	 * (full field set) and EDIT both read the raw record. Cached by IDRule; tenancy is enforced server-side.
	 */
	async fetchRuleRecordAsync(pSelection)
	{
		if (!pSelection || (pSelection.Entity !== 'Rule')) { return null; }
		const tmpIDRule = (pSelection.Record || {}).IDRule;
		if (tmpIDRule == null) { return null; }
		if (this._rawRuleCache[tmpIDRule]) { return this._rawRuleCache[tmpIDRule]; }
		const tmpRecord = await this._getJSON(`ProjectLineItemMaterialTest/${tmpIDRule}`);
		if (tmpRecord && (tmpRecord.IDProjectLineItemMaterialTest != null)) { this._rawRuleCache[tmpIDRule] = tmpRecord; return tmpRecord; }
		return null;
	}

	/** Lazily load the Test catalog for the Test dropdown (server scopes it to what the user may see). Cached. */
	async ensureTestOptionsAsync()
	{
		if (this._testOptions) { return this._testOptions; }
		try
		{
			const tmpRows = await this._getJSON('Tests/0/2000');
			this._testOptions = Array.isArray(tmpRows) ? tmpRows : [];
		}
		catch (pError)
		{
			this.pict.log.warn('SamplePlan: could not load the Test catalog for the Test dropdown', pError);
			this._testOptions = [];
		}
		return this._testOptions;
	}

	/** Test dropdown options: a "(no test selected)" sentinel + the catalog, always keeping the current pick visible. */
	testOptionsFor(pCurrentIDTest)
	{
		const tmpOptions = [ { IDTest: 0, Name: '(no test selected)' } ];
		const tmpSeen = { 0: true };
		(this._testOptions || []).forEach((pTest) =>
		{
			tmpSeen[pTest.IDTest] = true;
			tmpOptions.push({ IDTest: pTest.IDTest, Name: pTest.Name || pTest.Hash || `Test ${pTest.IDTest}` });
		});
		if (pCurrentIDTest && !tmpSeen[pCurrentIDTest])
		{
			const tmpModelRule = this._model && this._model.rules.find((pRule) => Number(pRule.IDTest) === Number(pCurrentIDTest));
			tmpOptions.push({ IDTest: pCurrentIDTest, Name: (tmpModelRule && tmpModelRule.TestHash) ? tmpModelRule.TestHash : `Test ${pCurrentIDTest}` });
		}
		return tmpOptions;
	}

	/**
	 * Refresh every rule's required/planned/created counts from the SERVER after an edit or create. A saved PLIMT's
	 * ComputedRequiredSampleCount is stale until the endpoint recomputes it, and the count is NEVER derived client-side
	 * (the server's PLIMTCalculator uses placed quantities + temporal/plant data we don't have here). So we re-fetch
	 * SamplePlan/Lite — which recomputes the whole plan server-side — and copy the fresh counts onto the model rules,
	 * then re-roll the aggregates + satisfaction. Best-effort: a failed refresh leaves the last-known counts.
	 * @returns {Promise<void>}
	 */
	async _refreshPlanCountsAsync()
	{
		if (!this._model || !this._idProject) { return; }
		let tmpLite;
		try { tmpLite = await this._getJSON(`SamplePlan/Lite/By/IDProject/${this._idProject}`); }
		catch (pError) { this.pict.log.warn(`SamplePlan: could not refresh sample counts from the server: ${pError && pError.message ? pError.message : pError}`); return; }
		const tmpByID = {};
		((tmpLite && tmpLite.ProjectLineItemMaterialTests) || []).forEach((pPLIMT) => { tmpByID[Number(pPLIMT.IDProjectLineItemMaterialTest)] = pPLIMT; });
		const fNum = (pValue) => { const tmp = Number(pValue); return Number.isFinite(tmp) ? tmp : 0; };
		(this._model.rules || []).forEach((pRule) =>
		{
			const tmpPLIMT = tmpByID[Number(pRule.IDRule)];
			if (!tmpPLIMT) { return; }
			const tmpCounts = resolvePlimtCounts(tmpPLIMT);
			pRule.Required = tmpCounts.Required;
			pRule.Planned = tmpCounts.Planned;
			pRule.Created = fNum(tmpPLIMT.CreatedSampleCount);
			pRule.Passing = fNum(tmpPLIMT.PassingSampleCount);
		});
		restampRollups(this._model);
		if (this._model.plan) { this.workspaceState.PlanText = this._model.plan.SatisfactionText; }
	}

	/**
	 * Refresh ONE rule's counts from the server after an edit/create, cheaply: POST the entry to the single-entry
	 * SamplePlan/CalculateEntry endpoint (same authoritative PLIMTCalculator, no whole-plan re-pricing) and copy the
	 * fresh Computed* onto the rule + its raw-cache row, then re-roll. If that endpoint isn't available (older API),
	 * fall back to the whole-plan _refreshPlanCountsAsync. Counts are NEVER computed client-side either way.
	 * @param {Object} pRule the in-memory model rule @param {Object} pRawPLIMT the saved raw PLIMT (edited fields)
	 * @returns {Promise<void>}
	 */
	async _refreshRuleCountsAsync(pRule, pRawPLIMT)
	{
		if (!this._model || !this._idProject || !pRule || !pRawPLIMT) { return this._refreshPlanCountsAsync(); }
		let tmpResult;
		try { tmpResult = await this._postJSON(`SamplePlan/CalculateEntry/By/IDProject/${this._idProject}`, pRawPLIMT); }
		catch (pError) { return this._refreshPlanCountsAsync(); }
		if (!tmpResult || tmpResult.Error || (tmpResult.ComputedRequiredSampleCount == null)) { return this._refreshPlanCountsAsync(); }
		// Fold the fresh server Computed* into the raw-cache row, then resolve counts the same way the load path does
		// (so a manual override is honored identically). Created/Passing come from actual samples — an edit doesn't move them.
		const tmpRaw = (this._rawRuleCache[pRule.IDRule] = this._rawRuleCache[pRule.IDRule] || pRawPLIMT);
		tmpRaw.ComputedRequiredSampleCount = tmpResult.ComputedRequiredSampleCount;
		tmpRaw.ComputedPlannedSampleCount = tmpResult.ComputedPlannedSampleCount;
		const tmpCounts = resolvePlimtCounts(tmpRaw);
		pRule.Required = tmpCounts.Required;
		pRule.Planned = tmpCounts.Planned;
		restampRollups(this._model);
		if (this._model.plan) { this.workspaceState.PlanText = this._model.plan.SatisfactionText; }
	}

	/**
	 * The SERVER's computed required/planned counts for a rule (the raw PLIMT's Computed*SampleCount, cached fresh from
	 * SamplePlan/Lite). Used by the editor's readouts — NOT a client-side recompute. While a rule's Rate/Frequency is
	 * being edited these show the last server value; the real counts are refreshed from the endpoint on save.
	 * @returns {{ ComputedRequiredSampleCount: Number, ComputedPlannedSampleCount: Number }}
	 */
	serverCountsFor(pRecord)
	{
		const fNum = (pValue) => { const tmp = Number(pValue); return Number.isFinite(tmp) ? tmp : 0; };
		const tmpID = pRecord && pRecord.IDProjectLineItemMaterialTest;
		const tmpRaw = ((tmpID != null) && this._rawRuleCache[tmpID]) || pRecord || {};
		return { ComputedRequiredSampleCount: fNum(tmpRaw.ComputedRequiredSampleCount), ComputedPlannedSampleCount: fNum(tmpRaw.ComputedPlannedSampleCount) };
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/**
	 * Persist an edited rule. Mirrors the legacy save: strip transient/_-prefixed keys + Material/LineItem/
	 * IDMaterialLineItemJoin, PUT the array, partition the response by .Error. On success, patch the in-memory
	 * model rule (== the live selection record) so the detail reflects the saved values immediately.
	 * @returns {Promise<{ ok: Boolean, error: any, record: any }>}
	 */
	async saveRuleAsync(pRecord)
	{
		const tmpClean = JSON.parse(JSON.stringify(pRecord));
		Object.keys(tmpClean).forEach((pKey) =>
		{
			if ((pKey.charAt(0) === '_') || (pKey === 'Material') || (pKey === 'LineItem') || (pKey === 'IDMaterialLineItemJoin')) { delete tmpClean[pKey]; }
		});
		let tmpResult;
		try { tmpResult = await this._putJSON('ProjectLineItemMaterialTests', [ tmpClean ]); }
		catch (pError) { return { ok: false, error: (pError && pError.message) ? pError.message : String(pError), record: null }; }
		const tmpRows = Array.isArray(tmpResult) ? tmpResult : (tmpResult ? [ tmpResult ] : []);
		const tmpErrant = tmpRows.filter((pRow) => pRow && pRow.Error);
		if (tmpErrant.length) { return { ok: false, error: tmpErrant[0].Error || 'The server rejected the save.', record: null }; }
		const tmpSaved = tmpRows.find((pRow) => pRow && !pRow.Error) || tmpClean;
		this._rawRuleCache[tmpSaved.IDProjectLineItemMaterialTest || tmpClean.IDProjectLineItemMaterialTest] = tmpSaved;
		this._patchModelRule(tmpSaved);
		// The edit changed Rate/Frequency/etc., so the required/planned counts changed — pull the fresh, server-computed
		// counts from the endpoint (never recomputed here) and re-roll the ancestor aggregates + plan satisfaction.
		const tmpEditedRule = this._model.rules.find((pRule) => Number(pRule.IDRule) === Number(tmpSaved.IDProjectLineItemMaterialTest));
		await this._refreshRuleCountsAsync(tmpEditedRule, tmpSaved);
		return { ok: true, error: null, record: tmpSaved };
	}

	/** Update the in-memory model rule (the same object the explorer + detail read) from a saved raw PLIMT. */
	_patchModelRule(pSaved)
	{
		if (!this._model) { return; }
		const tmpRule = this._model.rules.find((pRule) => Number(pRule.IDRule) === Number(pSaved.IDProjectLineItemMaterialTest));
		if (!tmpRule) { return; }
		const fNum = (pValue) => { const tmp = Number(pValue); return Number.isFinite(tmp) ? tmp : 0; };
		const fStr = (pValue) => ((pValue == null) ? '' : String(pValue));
		tmpRule.Frequency = fNum(pSaved.Frequency);
		tmpRule.Rate = fNum(pSaved.Rate) || 1;
		tmpRule.ConversionFactor = fNum(pSaved.ConversionFactor) || 1;
		tmpRule.Units = fStr(pSaved.Units);
		tmpRule.Intent = fStr(pSaved.Intent);
		tmpRule.SamplingInstructions = fStr(pSaved.SamplingInstructions);
		tmpRule.Remarks = fStr(pSaved.Remarks);
		tmpRule.SampleType = fStr(pSaved.SampleType) || tmpRule.SampleType;
		tmpRule.IDTest = pSaved.IDTest;
		tmpRule.Title = fStr(pSaved.TestDescription || pSaved.SampleDescription) || tmpRule.Title;
		// Refresh the test code/label to match the saved IDTest. Clearing the test (IDTest 0) blanks the hash (mirroring
		// the model builder); a valid id that simply isn't in the loaded catalog keeps the existing hash as best-available.
		const tmpTest = (this._testOptions || []).find((pTest) => Number(pTest.IDTest) === Number(pSaved.IDTest));
		if (Number(pSaved.IDTest) === 0) { tmpRule.TestHash = ''; tmpRule.TestLabel = tmpRule.SampleType; }
		else if (tmpTest) { tmpRule.TestHash = fStr(tmpTest.Hash); tmpRule.TestLabel = tmpRule.TestHash ? `${tmpRule.TestHash}  ·  ${tmpRule.SampleType}` : tmpRule.SampleType; }
		// Kind reflects the saved rule shape; the required/planned counts + satisfaction text are refreshed from the
		// server by _refreshPlanCountsAsync (called right after this) — never computed client-side.
		const tmpIsCert = (fNum(pSaved.CertificateRequired) === 1);
		const tmpIsPerProject = !tmpIsCert && (fNum(pSaved.Frequency) === 999999);
		tmpRule.Kind = tmpIsCert ? 'cert' : (tmpIsPerProject ? 'perproject' : 'count');
	}

	// --- Add: new entries (PLIMT) and new materials (MLIJ) -----------------------------------------------

	_postJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.postJSON(pURL, pPayload, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/** Lazily load the customer's Sample Type vocabulary (server-scoped). Cached. */
	async ensureSampleTypesAsync()
	{
		if (this._sampleTypes) { return this._sampleTypes; }
		try
		{
			const tmpRows = await this._getJSON('SampleTypes/0/200');
			this._sampleTypes = (Array.isArray(tmpRows) ? tmpRows : []).filter((pRow) => (Number(pRow.Deleted) !== 1));
		}
		catch (pError) { this._sampleTypes = []; }
		return this._sampleTypes;
	}

	/** Sample Type dropdown options — value is the stored code (Hash), label is "Name (CODE)". */
	sampleTypeOptions()
	{
		return (this._sampleTypes || []).map((pType) => ({ value: pType.Hash, label: pType.Name ? `${pType.Name} (${pType.Hash})` : pType.Hash }));
	}

	/** A sensible default unit for a new entry: the material's unit, else the line item's, else 'VARI' (mirrors the legacy
	 *  add). An empty unit is NOT neutral — the calculator treats '' as a "1 per project" cadence, so never default to ''. */
	defaultUnitsForMaterial(pIDLineItem, pIDMaterial)
	{
		const fStr = (pValue) => ((pValue == null) ? '' : String(pValue).trim());
		const tmpMaterial = this._rawMaterialByID[pIDMaterial] || {};
		const tmpLineItem = this._rawLineItemByID[pIDLineItem] || {};
		return fStr(tmpMaterial.UnitsImperial) || fStr(tmpLineItem.Units || tmpLineItem.UnitsImperial) || 'VARI';
	}

	/** Build an in-memory model rule from a raw PLIMT (mirrors buildSamplePlanModel's rule shape), for post-create splicing. */
	_buildModelRuleFromRaw(pRaw)
	{
		const fNum = (pValue) => { const tmp = Number(pValue); return Number.isFinite(tmp) ? tmp : 0; };
		const fStr = (pValue) => ((pValue == null) ? '' : String(pValue));
		const tmpTest = (this._testOptions || []).find((pTest) => Number(pTest.IDTest) === Number(pRaw.IDTest));
		const tmpTestHash = tmpTest ? fStr(tmpTest.Hash) : '';
		const tmpSampleType = fStr(pRaw.SampleType) || 'ACPT';
		// Counts are seeded from the saved row's server values (0 if not yet computed) and then replaced with the
		// freshly server-computed counts by _refreshPlanCountsAsync — never derived client-side.
		const tmpCounts = resolvePlimtCounts(pRaw);
		const tmpCreated = fNum(pRaw.CreatedSampleCount);
		const tmpIsCert = (fNum(pRaw.CertificateRequired) === 1);
		const tmpIsPerProject = !tmpIsCert && (fNum(pRaw.Frequency) === 999999);
		const tmpRule =
		{
			IDRule: pRaw.IDProjectLineItemMaterialTest,
			IDLineItem: pRaw.IDLineItem,
			IDMaterial: pRaw.IDMaterial,
			MaterialKey: `${pRaw.IDLineItem}:${pRaw.IDMaterial}`,
			IDTest: pRaw.IDTest,
			TestHash: tmpTestHash,
			Title: fStr(pRaw.TestDescription || pRaw.SampleDescription) || 'Material Acceptance',
			SampleType: tmpSampleType,
			TestLabel: tmpTestHash ? `${tmpTestHash}  ·  ${tmpSampleType}` : tmpSampleType,
			Frequency: fNum(pRaw.Frequency),
			Rate: fNum(pRaw.Rate) || 1,
			ConversionFactor: fNum(pRaw.ConversionFactor) || 1,
			Units: fStr(pRaw.Units),
			Intent: fStr(pRaw.Intent),
			SamplingInstructions: fStr(pRaw.SamplingInstructions),
			Remarks: fStr(pRaw.Remarks),
			Kind: tmpIsCert ? 'cert' : (tmpIsPerProject ? 'perproject' : 'count'),
			Required: tmpCounts.Required,
			Planned: tmpCounts.Planned,
			Created: tmpCreated,
			Passing: fNum(pRaw.PassingSampleCount),
			CertOnFile: (tmpCreated > 0),
		};
		tmpRule.SatisfactionText = tmpIsCert ? 'By certificate' : (tmpIsPerProject ? '1 / project' : `${tmpRule.Created}/${tmpRule.Required} samples`);
		return tmpRule;
	}

	/**
	 * Create a new sample-plan entry (PLIMT) under an existing material. POSTs the stub, then splices the returned row
	 * into the model + the mutable Tests index + rollups so the tree and detail reflect it without a reload.
	 * @returns {Promise<{ ok: Boolean, error: any, rule: any }>}
	 */
	async createEntryAsync(pStub)
	{
		const tmpClean = JSON.parse(JSON.stringify(pStub));
		Object.keys(tmpClean).forEach((pKey) => { if ((pKey.charAt(0) === '_') || (pKey === 'Material') || (pKey === 'LineItem') || (pKey === 'IDMaterialLineItemJoin')) { delete tmpClean[pKey]; } });
		// PLIMT.IDProject is a real column the Lite reload filters on (SamplePlan/Lite …where('IDProject')). The server
		// does NOT backfill it, so a created entry without it (IDProject 0) would vanish on the next reload — set it.
		tmpClean.IDProject = Number(this._idProject);
		let tmpResult;
		try { tmpResult = await this._postJSON('ProjectLineItemMaterialTests', [ tmpClean ]); }
		catch (pError) { return { ok: false, error: (pError && pError.message) ? pError.message : String(pError), rule: null }; }
		const tmpRows = Array.isArray(tmpResult) ? tmpResult : (tmpResult ? [ tmpResult ] : []);
		const tmpErrant = tmpRows.filter((pRow) => pRow && pRow.Error);
		if (tmpErrant.length) { return { ok: false, error: tmpErrant[0].Error || 'The server rejected the new entry.', rule: null }; }
		const tmpSaved = tmpRows.find((pRow) => pRow && !pRow.Error && (pRow.IDProjectLineItemMaterialTest != null));
		if (!tmpSaved) { return { ok: false, error: 'The server did not return the created entry.', rule: null }; }
		this._rawRuleCache[tmpSaved.IDProjectLineItemMaterialTest] = tmpSaved;
		const tmpRule = this._buildModelRuleFromRaw(tmpSaved);
		this._model.rules.push(tmpRule);
		(this._rulesByMaterialKey[tmpRule.MaterialKey] = this._rulesByMaterialKey[tmpRule.MaterialKey] || []).push(tmpRule);
		// Pull the new entry's server-computed counts (and re-roll) from the endpoint — never computed client-side.
		await this._refreshRuleCountsAsync(tmpRule, tmpSaved);
		this.workspaceState.RuleCount = this._model.rules.length;   // keep the header's "N sample plan entries" current
		return { ok: true, error: null, rule: tmpRule };
	}

	/** Search the active materials catalog by name/code, excluding materials already on the given line item. Server-scoped. */
	async searchMaterialsAsync(pTerm, pIDLineItem)
	{
		// Strip the structural tilde (FoxHound stanza delimiter) so a typed "~" can't corrupt the filter.
		const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
		let tmpFilter = 'FBV~Active~EQ~1';
		if (tmpTerm)
		{
			const tmpLike = encodeURIComponent(`%${tmpTerm.replace(/\*/g, '%')}%`);
			tmpFilter += `~FOP~0~(~0~FBVOR~Name~LK~${tmpLike}~FBVOR~MaterialCode~LK~${tmpLike}~FCP~0~)~0`;
		}
		tmpFilter += '~FSF~Name~ASC~0';
		const tmpRows = await this._getJSON(`Materials/FilteredTo/${tmpFilter}/0/100`).catch(() => []);
		const tmpExisting = {};
		(this._materialsByLineItem[pIDLineItem] || []).forEach((pMaterial) => { tmpExisting[pMaterial.IDMaterial] = true; });
		return (Array.isArray(tmpRows) ? tmpRows : [])
			.filter((pRow) => !tmpExisting[pRow.IDMaterial])
			.map((pRow) => ({ IDMaterial: pRow.IDMaterial, Name: pRow.Name || `Material ${pRow.IDMaterial}`, MaterialCode: pRow.MaterialCode || pRow.CatalogCode || '', UnitsImperial: pRow.UnitsImperial || '' }));
	}

	/**
	 * Attach a material to a line item (create its MaterialLineItemJoin). Resolves Units (material → line item → 'VARI')
	 * and best-effort special instructions, then splices a new material node into the model + tree indexes.
	 * @returns {Promise<{ ok: Boolean, error: any, material: any }>}
	 */
	async addMaterialAsync(pLineItem, pMaterial)
	{
		const fStr = (pValue) => ((pValue == null) ? '' : String(pValue));
		const tmpRawLineItem = this._rawLineItemByID[pLineItem.IDLineItem] || {};
		const tmpUnits = fStr(pMaterial.UnitsImperial) || fStr(tmpRawLineItem.Units || tmpRawLineItem.UnitsImperial) || 'VARI';
		let tmpSpecial = '';
		try
		{
			const tmpTSMJ = await this._getJSON(`TestSpecificationMaterialJoins/FilteredTo/FBV~IDMaterial~EQ~${pMaterial.IDMaterial}~FSF~Year~DESC~0/0/1`);
			if (Array.isArray(tmpTSMJ) && tmpTSMJ.length) { tmpSpecial = fStr(tmpTSMJ[0].SpecialInstructions); }
		}
		catch (pError) { /* special instructions are best-effort */ }
		let tmpResult;
		try { tmpResult = await this._postJSON('MaterialLineItemJoins', [ { IDLineItem: pLineItem.IDLineItem, IDMaterial: pMaterial.IDMaterial, Units: tmpUnits, SpecialInstructions: tmpSpecial } ]); }
		catch (pError) { return { ok: false, error: (pError && pError.message) ? pError.message : String(pError), material: null }; }
		const tmpRows = Array.isArray(tmpResult) ? tmpResult : (tmpResult ? [ tmpResult ] : []);
		const tmpErrant = tmpRows.filter((pRow) => pRow && pRow.Error);
		if (tmpErrant.length) { return { ok: false, error: tmpErrant[0].Error || 'The server rejected the new material.', material: null }; }
		// Retain the raw material (units vocab + calculator parent lookup) and splice a model material node into the tree.
		this._rawMaterialByID[pMaterial.IDMaterial] = this._rawMaterialByID[pMaterial.IDMaterial] || { IDMaterial: pMaterial.IDMaterial, Name: pMaterial.Name, MaterialCode: pMaterial.MaterialCode, UnitsImperial: pMaterial.UnitsImperial };
		const tmpKey = `${pLineItem.IDLineItem}:${pMaterial.IDMaterial}`;
		const tmpMaterialNode =
		{
			Key: tmpKey, IDLineItem: pLineItem.IDLineItem, IDMaterial: pMaterial.IDMaterial,
			Name: fStr(pMaterial.Name) || `Material ${pMaterial.IDMaterial}`, MaterialCode: fStr(pMaterial.MaterialCode),
			SamplesRequired: 0, SamplesCreated: 0, CertCount: 0, CertPending: 0, EntryCount: 0, SatisfactionText: '',
		};
		this._model.materials.push(tmpMaterialNode);
		(this._materialsByLineItem[pLineItem.IDLineItem] = this._materialsByLineItem[pLineItem.IDLineItem] || []).push(tmpMaterialNode);
		this._rulesByMaterialKey[tmpKey] = this._rulesByMaterialKey[tmpKey] || [];
		return { ok: true, error: null, material: tmpMaterialNode };
	}
}

SamplePlanProvider.default_configuration = { ProviderIdentifier: 'SamplePlan' };

module.exports = SamplePlanProvider;
module.exports.default_configuration = SamplePlanProvider.default_configuration;

},{"./SamplePlan-MSM-Map.js":1383,"./SamplePlan-Model.js":1384,"pict-provider":845}],1386:[function(require,module,exports){
/**
 * Display shaping for the Sample Plan Copy screen (#/SamplePlan-Copy): turns the SamplePlanService
 * (headlight-lims-sampleplan) specification-set reports, preview stats and load results into template-ready fields.
 * Pure functions, no DOM.
 */

/** @type {Record<string, string>} */
const ENTITY_LABELS = (
	{
		Contract: 'Contract specification sets',
		LineItem: 'Line item pay items',
		ProjectLineItemMaterialTest: 'Sample plan tests',
		MaterialLineItemJoin: 'Line item materials',
	});

/** @type {Record<string, string>} */
const LOAD_STATUS_LABELS = (
	{
		'Loaded': 'Saved',
		'Errors': 'Some failed',
		'Not attempted': 'Skipped (an earlier step failed)',
	});

/**
 * @typedef {Object} ProjectSetsDisplay
 * @property {boolean} Known - True when the project resolves to one item specification set.
 * @property {number} ItemIDTestSpecificationSet
 * @property {number} MaterialIDTestSpecificationSet
 * @property {Array<number>} PayItemSetIDs - The sets the project's line item pay items are on.
 * @property {string} ItemLabel
 * @property {string} MaterialLabel
 * @property {string} BasisLabel - What the sets were read from.
 */

/**
 * @typedef {Object} CountRow
 * @property {string} Label
 * @property {number} Count
 */

/**
 * @param {number} pIDTestSpecificationSet - A set ID.
 * @param {Record<string, string>} pNames - Set names by ID.
 * @return {string} A display label.
 */
function formatSetLabel(pIDTestSpecificationSet, pNames)
{
	if (!(pIDTestSpecificationSet > 0))
	{
		return 'None';
	}
	return (pNames || {})[pIDTestSpecificationSet] || `Specification set ${pIDTestSpecificationSet}`;
}

/**
 * @param {Record<string, any>} pSets - A ProjectSpecificationSets from SamplePlanService.
 * @param {Record<string, string>} pNames - Set names by ID.
 * @return {ProjectSetsDisplay} Display fields for one project.
 */
function formatProjectSets(pSets, pNames)
{
	let tmpBasisLabel = 'Unknown: no contract, and the line items do not share one specification set';
	if (pSets.Basis === 'Contract')
	{
		tmpBasisLabel = `Its contract, ${pSets.Contract.Name || pSets.Contract.IDContract}`;
	}
	else if (pSets.Basis === 'PayItems')
	{
		tmpBasisLabel = 'Its line items\' pay items (no contract)';
	}
	return (
		{
			Known: pSets.ItemIDTestSpecificationSet > 0,
			ItemIDTestSpecificationSet: pSets.ItemIDTestSpecificationSet,
			MaterialIDTestSpecificationSet: pSets.MaterialIDTestSpecificationSet,
			PayItemSetIDs: Object.keys(pSets.PayItemSetDistribution || {}).map((pID) => parseInt(pID, 10)),
			ItemLabel: formatSetLabel(pSets.ItemIDTestSpecificationSet, pNames),
			MaterialLabel: formatSetLabel(pSets.MaterialIDTestSpecificationSet, pNames),
			BasisLabel: tmpBasisLabel,
		});
}

/**
 * @param {ProjectSetsDisplay|null} pSource - Source display sets.
 * @param {ProjectSetsDisplay|null} pDest - Destination display sets.
 * @return {boolean} True when a copy between them would realign the destination.
 */
function isSpecificationSetMismatch(pSource, pDest)
{
	if (!pSource || !pDest || !pSource.Known)
	{
		return false;
	}
	if (pDest.Known && ((pSource.ItemIDTestSpecificationSet !== pDest.ItemIDTestSpecificationSet) || (pSource.MaterialIDTestSpecificationSet !== pDest.MaterialIDTestSpecificationSet)))
	{
		return true;
	}
	return pDest.PayItemSetIDs.some((pID) => pID !== pSource.ItemIDTestSpecificationSet);
}

/**
 * Flatten the service's specification set report into template-ready fields.
 * @param {Record<string, any>} pSpecSets - reportData.specificationSets from SamplePlanService.
 * @return {Record<string, any>|null} Display fields, or null when the report carries none.
 */
function prepareSpecificationSetView(pSpecSets)
{
	if (!pSpecSets || !pSpecSets.Alignment)
	{
		return null;
	}
	const tmpNames = pSpecSets.Names || {};
	const tmpAlignment = pSpecSets.Alignment;
	const tmpSource = formatProjectSets(pSpecSets.Source, tmpNames);
	const tmpDest = formatProjectSets(pSpecSets.Dest, tmpNames);
	const tmpContract = tmpAlignment.Contract;
	const tmpShared = tmpContract ? tmpContract.SharedWithProjects : [];
	return (
		{
			Crossing: tmpAlignment.Crossing === true,
			ShowChanges: (tmpAlignment.Crossing === true) && (tmpAlignment.Flip !== false),
			ShowKept: (tmpAlignment.Crossing === true) && (tmpAlignment.Flip === false),
			SourceItemLabel: tmpSource.ItemLabel,
			SourceMaterialLabel: tmpSource.MaterialLabel,
			SourceBasisLabel: tmpSource.BasisLabel,
			DestItemLabel: tmpDest.ItemLabel,
			DestMaterialLabel: tmpDest.MaterialLabel,
			DestBasisLabel: tmpDest.BasisLabel,
			TargetItemLabel: formatSetLabel(tmpAlignment.ItemIDTestSpecificationSet, tmpNames),
			HasContractUpdate: !!tmpContract,
			NoContract: (tmpAlignment.Crossing === true) && !pSpecSets.Dest.Contract,
			ContractLabel: tmpContract ? `${tmpContract.Name || 'Contract'} [${tmpContract.IDContract}]` : '',
			ContractItemBefore: tmpContract ? formatSetLabel(tmpContract.Before.ItemIDTestSpecificationSet, tmpNames) : '',
			ContractItemAfter: tmpContract ? formatSetLabel(tmpContract.After.ItemIDTestSpecificationSet, tmpNames) : '',
			ContractMaterialBefore: tmpContract ? formatSetLabel(tmpContract.Before.MaterialIDTestSpecificationSet, tmpNames) : '',
			ContractMaterialAfter: tmpContract ? formatSetLabel(tmpContract.After.MaterialIDTestSpecificationSet, tmpNames) : '',
			ContractShared: tmpShared.length > 0,
			SharedProjectCount: tmpShared.length,
			SharedProjects: tmpShared.map((pProject) => ({ Value: `${pProject.Name || '(unnamed)'} [${pProject.IDProject}]` })),
			RemapCount: tmpAlignment.LineItemRemaps.length,
			Remaps: tmpAlignment.LineItemRemaps.map((pRemap) => (
				{
					ItemCode: pRemap.ItemCode,
					Name: pRemap.Name,
					From: formatSetLabel(pRemap.FromIDTestSpecificationSet, tmpNames),
					To: formatSetLabel(tmpAlignment.ItemIDTestSpecificationSet, tmpNames),
				})),
			HasUnmapped: tmpAlignment.Unmapped.length > 0,
			UnmappedCount: tmpAlignment.Unmapped.length,
			Unmapped: tmpAlignment.Unmapped,
		});
}

/**
 * The confirmation dialog's two count tables. The contract and pay item rows appear only when the copy changes them.
 * @param {Record<string, number>} pStats - reportData.stats from SamplePlanService.
 * @return {{ Changes: Array<CountRow>, Unchanged: Array<CountRow> }}
 */
function buildConfirmCountRows(pStats)
{
	const tmpChanges = [
		{ Label: ENTITY_LABELS.Contract, Count: pStats.contractUpdateCount || 0 },
		{ Label: ENTITY_LABELS.LineItem, Count: pStats.lineItemRemapCount || 0 },
		{ Label: ENTITY_LABELS.ProjectLineItemMaterialTest, Count: pStats.plimtCount },
		{ Label: ENTITY_LABELS.MaterialLineItemJoin, Count: pStats.mljCount },
	].filter((pRow, pIndex) => (pIndex > 1) || (pRow.Count > 0));
	const tmpUnchanged = [
		{ Label: 'Sample plan tests in the source', Count: pStats.sourcePlimtCount || 0 },
		{ Label: 'Source tests not copied (item code not on the destination)', Count: pStats.unmappedSourcePlimtCount || 0 },
		{ Label: 'Repeated source tests, copied once', Count: pStats.collapsedPlimtCount || 0 },
		{ Label: 'Sample plan tests already on the destination (kept)', Count: pStats.destExistingPlimtCount || 0 },
		{ Label: 'Line item materials already on the destination (kept)', Count: pStats.destExistingMljCount || 0 },
	];
	return { Changes: tmpChanges, Unchanged: tmpUnchanged };
}

/**
 * Add display labels to the per-entity load results.
 * @param {Array<Record<string, any>>} pEntities - loadResult.entities from SamplePlanService.loadComprehension.
 * @return {Array<Record<string, any>>} Copies with Label and StatusLabel.
 */
function labelLoadEntities(pEntities)
{
	return pEntities.map((pEntity) => Object.assign({}, pEntity,
		{
			Label: ENTITY_LABELS[pEntity.Entity] || pEntity.Entity,
			StatusLabel: LOAD_STATUS_LABELS[pEntity.Status] || pEntity.Status,
		}));
}

module.exports = (
	{
		ENTITY_LABELS,
		LOAD_STATUS_LABELS,
		formatSetLabel,
		formatProjectSets,
		isSpecificationSetMismatch,
		prepareSpecificationSetView,
		buildConfirmCountRows,
		labelLoadEntities,
	});

},{}],1387:[function(require,module,exports){
const libPictView = require('pict-view');

const libSamplePlanCopyDisplay = require('./SamplePlanCopy-Display.js');

/**
 * Sample Plan Copy (#/SamplePlan-Copy): copy one project's sample plan onto another through a previewed
 * MaterialsSamplePlan comprehension (SamplePlanService from headlight-lims-sampleplan). Deliberately
 * not in any menu.
 */
class SamplePlanCopy extends libPictView
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		this.comprehensionResult = null;
		this.loadResult = null;
		this.statusMessage = '';
		this.isProcessing = false;

		this._selectedSource = null;
		this._selectedDest = null;

		this.sourceSets = null;
		this.destSets = null;
		this.projectSetsDiffer = false;
		this.specSetView = null;

		this.flipTargetSpecificationSet = false;
	}

	/**
	 * @return {string} What the copy does about differing specification sets, given the checkbox.
	 */
	get setMismatchOutcome()
	{
		if (this.flipTargetSpecificationSet)
		{
			return 'The copy will also move the destination\'s contract and line item pay items onto the source\'s specification sets.';
		}
		return 'The destination keeps its specification sets; sample plan tests are copied onto its line items by item code.';
	}

	/**
	 * Record whether the copy also moves the destination onto the source's specification sets. A preview built
	 * with the other choice no longer matches, so it is cleared.
	 * @param {boolean} pChecked - The checkbox state.
	 */
	async setFlipTargetSpecificationSet(pChecked)
	{
		this.flipTargetSpecificationSet = pChecked === true;
		this.saveSelections();
		if (this.comprehensionResult)
		{
			this.comprehensionResult = null;
			this.loadResult = null;
			this.specSetView = null;
			this.pict.views.HeadlightPanels.toast({ message: 'Preview again to see the copy with this choice.', type: 'is-info' });
		}
		await this.rerender();
	}

	/**
	 * Close unpinned panels so the screen has the full width.
	 * @param {Function} pCallback
	 * @param {any} pRenderable
	 */
	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		super.onBeforeRenderAsync(pCallback, pRenderable);
	}

	/**
	 * Wire both project pickers and restore their selections after a re-render.
	 * @param {any} pRenderable
	 * @return {any}
	 */
	onAfterRender(pRenderable)
	{
		this.initializeSelect2Plugin({
			placeholder: 'Search for a source project...',
			ElementID: 'SamplePlanCopy-SourceProject',
			ParentID: 'SamplePlanCopy-SourceProjectParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: [ 'Name' ],
			PageSize: 50,
		});
		this.initializeSelect2Plugin({
			placeholder: 'Search for a destination project...',
			ElementID: 'SamplePlanCopy-DestProject',
			ParentID: 'SamplePlanCopy-DestProjectParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: [ 'Name' ],
			PageSize: 50,
		});

		$('#SamplePlanCopy-SourceProject').on('select2:select',
			() =>
			{
				this.onProjectSelected('Source');
			});
		$('#SamplePlanCopy-DestProject').on('select2:select',
			() =>
			{
				this.onProjectSelected('Dest');
			});

		// Restore previously selected values after rerender
		if (this._selectedSource)
		{
			const tmpOption = new Option(this._selectedSource.text, this._selectedSource.id, true, true);
			$('#SamplePlanCopy-SourceProject').append(tmpOption).trigger('change');
		}
		if (this._selectedDest)
		{
			const tmpOption = new Option(this._selectedDest.text, this._selectedDest.id, true, true);
			$('#SamplePlanCopy-DestProject').append(tmpOption).trigger('change');
		}

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Initializes a Select2 Selector via jQuery for project search.
	 * @param {object} pOptions - The select customization options.
	 */
	initializeSelect2Plugin(pOptions)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-light',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-light',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: 0,
			language: {
				searching: function()
				{
					return 'Searching...';
				},
				noResults: function()
				{
					return 'No projects found.';
				},
				loadingMore: function()
				{
					return 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return 'Type to search for a project...';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [
							{
								field: 'Deleted',
								comparator: 'EQ',
								target: '0',
							},
						],
						pagination: {
							start: 1,
							limit: pOptions.PageSize || 50,
						},
						sort: {
							field: 'Name',
							direction: 'ASC',
						},
					};
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;
					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, [], null, true),
					};
				},
			},
		});
	}

	/**
	 * Save the current select2 selections so they can be restored after rerender.
	 */
	saveSelections()
	{
		const tmpSourceEl = $('#SamplePlanCopy-SourceProject');
		const tmpDestEl = $('#SamplePlanCopy-DestProject');

		const tmpSourceData = tmpSourceEl.select2('data');
		if (tmpSourceData && tmpSourceData.length > 0)
		{
			this._selectedSource = { id: tmpSourceData[0].id, text: tmpSourceData[0].text };
		}

		const tmpDestData = tmpDestEl.select2('data');
		if (tmpDestData && tmpDestData.length > 0)
		{
			this._selectedDest = { id: tmpDestData[0].id, text: tmpDestData[0].text };
		}
	}

	/**
	 * Look up the specification sets of a newly selected project and show them under its picker.
	 * @param {string} pSide - 'Source' or 'Dest'.
	 */
	onProjectSelected(pSide)
	{
		const tmpElementID = (pSide === 'Source') ? '#SamplePlanCopy-SourceProject' : '#SamplePlanCopy-DestProject';
		const tmpIDProject = parseInt($(tmpElementID).val(), 10);
		if (isNaN(tmpIDProject))
		{
			return;
		}

		const tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
		tmpService.describeProjectSpecificationSets(tmpIDProject, null,
			(pError, pSets) =>
			{
				if (parseInt($(tmpElementID).val(), 10) !== tmpIDProject)
				{
					return;
				}

				let tmpDisplay = null;
				if (pError)
				{
					this.log.error(`Error describing specification sets for project ${tmpIDProject}`, pError);
					this.pict.views.HeadlightPanels.toast({ message: 'Could not read the specification sets for that project.', type: 'is-warning' });
				}
				else
				{
					tmpDisplay = this.formatProjectSets(pSets, pSets.SpecificationSetNames);
				}

				if (pSide === 'Source')
				{
					this.sourceSets = tmpDisplay;
				}
				else
				{
					this.destSets = tmpDisplay;
				}
				this.projectSetsDiffer = this.isSpecificationSetMismatch(this.sourceSets, this.destSets);
				this.saveSelections();
				this.rerender();
			});
	}

	/**
	 * @param {number} pIDTestSpecificationSet - A set ID.
	 * @param {Record<string, string>} pNames - Set names by ID.
	 * @return {string} A display label.
	 */
	formatSetLabel(pIDTestSpecificationSet, pNames)
	{
		return libSamplePlanCopyDisplay.formatSetLabel(pIDTestSpecificationSet, pNames);
	}

	/**
	 * @param {Record<string, any>} pSets - A ProjectSpecificationSets from SamplePlanService.
	 * @param {Record<string, string>} pNames - Set names by ID.
	 * @return {Record<string, any>} Display fields for one project.
	 */
	formatProjectSets(pSets, pNames)
	{
		return libSamplePlanCopyDisplay.formatProjectSets(pSets, pNames);
	}

	/**
	 * @param {Record<string, any>|null} pSource - Source display sets.
	 * @param {Record<string, any>|null} pDest - Destination display sets.
	 * @return {boolean} True when a copy between them would realign the destination.
	 */
	isSpecificationSetMismatch(pSource, pDest)
	{
		return libSamplePlanCopyDisplay.isSpecificationSetMismatch(pSource, pDest);
	}

	/**
	 * Flatten the service's specification set report into template-ready fields.
	 * @param {Record<string, any>} pSpecSets - reportData.specificationSets from SamplePlanService.
	 * @return {Record<string, any>|null} Display fields, or null when the report carries none.
	 */
	prepareSpecificationSetView(pSpecSets)
	{
		return libSamplePlanCopyDisplay.prepareSpecificationSetView(pSpecSets);
	}

	/**
	 * Build the copy comprehension for the picked projects and show it as a preview. Writes nothing.
	 * @return {Promise<void>}
	 */
	async buildComprehension()
	{
		const tmpSourceID = parseInt($('#SamplePlanCopy-SourceProject').val(), 10);
		const tmpDestID = parseInt($('#SamplePlanCopy-DestProject').val(), 10);

		if (isNaN(tmpSourceID) || isNaN(tmpDestID))
		{
			this.pict.views.HeadlightPanels.toast({ message: 'Please select both a source and destination project.', type: 'is-warning' });
			return;
		}

		if (tmpSourceID === tmpDestID)
		{
			this.pict.views.HeadlightPanels.toast({ message: 'Source and destination projects must be different.', type: 'is-warning' });
			return;
		}

		this.saveSelections();
		this.isProcessing = true;
		this.comprehensionResult = null;
		this.loadResult = null;
		this.specSetView = null;
		this.statusMessage = 'Preparing the preview... This may take a moment for large projects.';
		await this.rerender();

		try
		{
			const tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
			this.comprehensionResult = await new Promise((resolve, reject) =>
			{
				tmpService.buildComprehension(tmpSourceID, tmpDestID, { FlipTargetSpecificationSet: this.flipTargetSpecificationSet },
					(pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						else
						{
							resolve(pResult);
						}
					});
			});

			// Ensure warnings are plain strings for template rendering
			if (this.comprehensionResult && this.comprehensionResult.warnings)
			{
				this.comprehensionResult.warnings = this.comprehensionResult.warnings.map(
					(pWarning) => (typeof pWarning === 'string') ? { Value: pWarning } : pWarning,
				);
			}

			this.specSetView = this.prepareSpecificationSetView(this.comprehensionResult.reportData.specificationSets);

			this.statusMessage = '';
			this.pict.views.HeadlightPanels.toast({ message: 'Preview ready.', type: 'is-success' });
		}
		catch (pError)
		{
			this.log.error('Error building comprehension', pError);
			this.statusMessage = `Error: ${pError.message || pError}`;
			this.pict.views.HeadlightPanels.toast({ message: 'Could not prepare the preview. Check the console for details.', type: 'is-danger' });
		}

		this.isProcessing = false;
		await this.rerender();
	}

	/**
	 * Download the previewed comprehension as JSON.
	 */
	exportComprehension()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		const tmpJSON = JSON.stringify(this.comprehensionResult.comprehension, null, 2);
		const tmpBlob = new Blob([ tmpJSON ], { type: 'application/json' });
		const tmpURL = URL.createObjectURL(tmpBlob);

		const tmpSourceName = this.comprehensionResult.reportData.sourceProject.Name || this.comprehensionResult.reportData.sourceProject.IDProject;
		const tmpDestName = this.comprehensionResult.reportData.destProject.Name || this.comprehensionResult.reportData.destProject.IDProject;

		const tmpLink = document.createElement('a');
		tmpLink.href = tmpURL;
		tmpLink.download = `Comprehension-MaterialsSamplePlan_From_${tmpSourceName}_To_${tmpDestName}.json`;
		document.body.appendChild(tmpLink);
		tmpLink.click();
		document.body.removeChild(tmpLink);
		URL.revokeObjectURL(tmpURL);
	}

	/**
	 * Ask for confirmation, listing what the copy adds or changes on the destination.
	 */
	confirmLoadToDestination()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		const tmpStats = this.comprehensionResult.reportData.stats;
		const tmpDestName = this.comprehensionResult.reportData.destProject.Name || this.comprehensionResult.reportData.destProject.IDProject;
		const tmpSpecSetView = this.specSetView;
		const tmpSharedContract = !!(tmpSpecSetView && tmpSpecSetView.ContractShared);

		const fRenderRows = (pRows) => pRows.map((pRow) => /*html*/`
						<tr>
							<td>${pRow.Label}</td>
							<td class="has-text-right"><strong>${pRow.Count}</strong></td>
						</tr>`)
			.join('');
		const tmpCountRows = libSamplePlanCopyDisplay.buildConfirmCountRows(tmpStats);
		const tmpChangeRows = fRenderRows(tmpCountRows.Changes);
		const tmpUnchangedRows = fRenderRows(tmpCountRows.Unchanged);

		let tmpSpecSetNotices = '';
		if (tmpSpecSetView && tmpSpecSetView.ShowKept)
		{
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-info is-soft mb-3">
					<strong>The destination keeps its specification sets.</strong> Its contract and line item pay items are not changed; sample plan tests are copied onto its line items by item code.
				</div>`;
		}
		if (tmpSpecSetView && tmpSpecSetView.ShowChanges)
		{
			let tmpContractChange = '';
			if (tmpSpecSetView.HasContractUpdate)
			{
				tmpContractChange = ` Contract ${tmpSpecSetView.ContractLabel} moves to <strong>${tmpSpecSetView.ContractItemAfter}</strong> (item) and <strong>${tmpSpecSetView.ContractMaterialAfter}</strong> (material).`;
			}
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-warning is-soft mb-3">
					<strong>This copy crosses specification sets.</strong> The destination's line items move onto <strong>${tmpSpecSetView.TargetItemLabel}</strong> pay items.${tmpContractChange}
				</div>`;
		}
		if (tmpSharedContract)
		{
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-danger is-soft mb-3">
					<p><strong>Shared contract.</strong> ${tmpSpecSetView.ContractLabel} is also used by ${tmpSpecSetView.SharedProjectCount} other project(s). Their specification sets change too, while their line items stay on their current pay items:</p>
					<ul>${tmpSpecSetView.SharedProjects.map((pProject) => `<li>${pProject.Value}</li>`).join('')}</ul>
				</div>`;
		}

		this.fable.HeadlightModal.spawnModal({
			title: 'Confirm Sample Plan Copy',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5 has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-warning"></i>
					</span>
					<span> Copy the sample plan to the destination?</span>
				</p>
				${tmpSpecSetNotices}
				<p class="is-6 has-text-centered mb-3">This will add or update the following in <strong>${tmpDestName}</strong>:</p>
				<table class="table is-fullwidth is-narrow mx-auto" style="max-width:400px;">
					<tbody>${tmpChangeRows}
					</tbody>
				</table>
				<p class="is-6 has-text-centered mb-3">The copy does not remove anything:</p>
				<table class="table is-fullwidth is-narrow mx-auto" style="max-width:520px;">
					<tbody>${tmpUnchangedRows}
					</tbody>
				</table>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-soft" type="button" title="Cancel" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button ${tmpSharedContract ? 'is-danger' : 'is-success'}" type="button" title="Copy to Destination" onclick="_Pict.views.SamplePlanCopy.loadToDestination()">
					<span class="icon">
						<i class="fas fa-fw fa-upload" aria-hidden="true"></i>
					</span>
					<span>Copy to Destination</span>
				</button>
			</div>`,
			confirmText: 'Copy to Destination',
			cancelText: 'Cancel',
		});
	}

	/**
	 * Push the previewed comprehension to the destination project and show the per-entity results.
	 * @return {Promise<void>}
	 */
	async loadToDestination()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		this.fable.HeadlightModal.dismissModals();

		this.saveSelections();
		this.isProcessing = true;
		this.loadResult = null;
		this.statusMessage = 'Copying the sample plan to the destination project...';
		await this.rerender();

		try
		{
			const tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
			this.loadResult = await new Promise((resolve, reject) =>
			{
				tmpService.loadComprehension(this.comprehensionResult.comprehension,
					(pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						else
						{
							resolve(pResult);
						}
					});
			});

			this.loadResult.entities = libSamplePlanCopyDisplay.labelLoadEntities(this.loadResult.entities);

			this.statusMessage = '';
			if (this.loadResult.entities.some((pEntity) => pEntity.Failed > 0))
			{
				this.pict.views.HeadlightPanels.toast({ message: 'Sample plan copied, but some changes failed. See Copy Results.', type: 'is-warning' });
			}
			else
			{
				this.pict.views.HeadlightPanels.toast({ message: 'Sample plan copied.', type: 'is-success' });
			}
		}
		catch (pError)
		{
			this.log.error('Error loading comprehension', pError);
			this.statusMessage = `Error: ${pError.message || pError}`;
			this.pict.views.HeadlightPanels.toast({ message: 'Could not copy the sample plan. Check the console for details.', type: 'is-danger' });
		}

		this.isProcessing = false;
		await this.rerender();
	}

	/**
	 * Re-render the view, preserving select2 selections.
	 */
	async rerender()
	{
		return await new Promise((resolve) =>
		{
			this.renderAsync(() =>
			{
				resolve();
			});
		});
	}
}

module.exports = SamplePlanCopy;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'SamplePlanCopy',
		DefaultRenderable: 'SamplePlanCopy',
		DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',

		AutoRender: false,

		CSS: '',

		Templates: [
			{
				Hash: 'SamplePlanCopy-Wrapper',
				Template: /*html*/`
				<section id="SamplePlanCopy" class="form p-5">
					<h2 class="title is-4 mb-3">Copy Sample Plan</h2>
					<div class="content">
						<div class="box">
							<div class="columns">
								<div class="column">
									<div class="field">
										<label class="label">Source Project (Master Sample Plan)</label>
										<div class="control" id="SamplePlanCopy-SourceProjectParent">
											<select id="SamplePlanCopy-SourceProject" style="width:100%">
											</select>
										</div>
										<p class="help">The project containing the sample plan to copy from.</p>
										{~TIfAbs:SamplePlanCopy-ProjectSets:Context[0].sourceSets:Context[0].sourceSets^!=^null~}
									</div>
								</div>
								<div class="column">
									<div class="field">
										<label class="label">Destination Project</label>
										<div class="control" id="SamplePlanCopy-DestProjectParent">
											<select id="SamplePlanCopy-DestProject" style="width:100%">
											</select>
										</div>
										<p class="help">The project to copy the sample plan into.</p>
										{~TIfAbs:SamplePlanCopy-ProjectSets:Context[0].destSets:Context[0].destSets^!=^null~}
									</div>
								</div>
							</div>
							<div class="field">
								<label class="checkbox">
									<input
										type="checkbox"
										id="SamplePlanCopy-FlipTargetSpecificationSet"
										onchange="_Pict.views.SamplePlanCopy.setFlipTargetSpecificationSet(this.checked)"
										{~TIfAbs:SamplePlanCopy-Checked:Record:Context[0].flipTargetSpecificationSet^TRUE^x~}
										{~TIfAbs:SamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
									/>
									Also move the destination onto the source's specification sets
								</label>
								<p class="help">Changes the destination contract's specification sets and switches its line items to the source set's pay items. Leave this off to keep the destination on its current specification sets; sample plan tests are copied by item code either way.</p>
							</div>
							<div class="field">
								<div class="control">
									<button
										type="button"
										class="button is-info"
										onclick="_Pict.views.SamplePlanCopy.buildComprehension()"
										{~TIfAbs:SamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
									>
										<span class="icon mr-2">
											<i class="fas fa-fw fa-copy"></i>
										</span>
										Preview Copy
									</button>
								</div>
							</div>
						</div>
						{~TIfAbs:SamplePlanCopy-SetMismatch:Record:Context[0].projectSetsDiffer^TRUE^x~}
						{~T:SamplePlanCopy-Status:Record~}
						{~T:SamplePlanCopy-Results:Record~}
						{~T:SamplePlanCopy-LoadResults:Record~}
					</div>
				</section>`,
			},
			{
				Hash: 'SamplePlanCopy-Disabled',
				Template: 'disabled',
			},
			{
				Hash: 'SamplePlanCopy-Checked',
				Template: 'checked',
			},
			{
				Hash: 'SamplePlanCopy-Status',
				Template: /*html*/`
					{~TIfAbs:SamplePlanCopy-StatusMessage:Record:Context[0].statusMessage.length^>^0~}
				`,
			},
			{
				Hash: 'SamplePlanCopy-StatusMessage',
				Template: /*html*/`
				<div class="notification is-info is-soft">
					<span class="icon mr-2">
						<i class="fas fa-spinner fa-spin"></i>
					</span>
					{~D:Context[0].statusMessage~}
				</div>`,
			},
			{
				Hash: 'SamplePlanCopy-Results',
				Template: /*html*/`
					{~TIfAbs:SamplePlanCopy-ResultsContent:Record:Context[0].comprehensionResult^!=^null~}
				`,
			},
			{
				Hash: 'SamplePlanCopy-ResultsContent',
				Template: /*html*/`
				<div class="box">
					<h3 class="title is-5 mb-3">Copy Preview</h3>
					{~TIfAbs:SamplePlanCopy-Warnings:Record:Context[0].comprehensionResult.warnings.length^>^0~}
					{~TIfAbs:SamplePlanCopy-SpecSets:Record:Context[0].specSetView^!=^null~}
					<div class="columns">
						<div class="column">
							<table class="table is-fullwidth is-striped">
								<thead>
									<tr>
										<th>Metric</th>
										<th class="has-text-right">Count</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Source Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.sourceLineItemCount~}</td>
									</tr>
									<tr>
										<td>Destination Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.destLineItemCount~}</td>
									</tr>
									<tr>
										<td>Matched Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.matched~}</td>
									</tr>
									<tr>
										<td>Unmatched Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.unmatched~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests to Copy</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.plimtCount~}</td>
									</tr>
									<tr>
										<td>Line Item Materials to Copy</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.mljCount~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests in the Source</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.sourcePlimtCount~}</td>
									</tr>
									<tr>
										<td>Source Tests Not Copied (item code not on the destination)</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.unmappedSourcePlimtCount~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests Already on the Destination (kept)</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.destExistingPlimtCount~}</td>
									</tr>
									{~TIfAbs:SamplePlanCopy-RealignmentStatRows:Record:Context[0].specSetView.ShowChanges^TRUE^x~}
								</tbody>
							</table>
						</div>
						<div class="column">
							<div class="field mb-2">
								<strong>Source Project:</strong> {~D:Context[0].comprehensionResult.reportData.sourceProject.Name~}
								<span class="tag ml-2">ID: {~D:Context[0].comprehensionResult.reportData.sourceProject.IDProject~}</span>
							</div>
							<div class="field mb-4">
								<strong>Destination Project:</strong> {~D:Context[0].comprehensionResult.reportData.destProject.Name~}
								<span class="tag ml-2">ID: {~D:Context[0].comprehensionResult.reportData.destProject.IDProject~}</span>
							</div>
							<div class="field mb-2">
								<em>Generated: {~D:Context[0].comprehensionResult.reportData.generatedDate~}</em>
							</div>
						</div>
					</div>
					<div class="buttons">
						<button
							type="button"
							class="button is-link"
							onclick="_Pict.views.SamplePlanCopy.exportComprehension()"
						>
							<span class="icon mr-2">
								<i class="fas fa-fw fa-download"></i>
							</span>
							Download Preview (JSON)
						</button>
						<button
							type="button"
							class="button is-success"
							onclick="_Pict.views.SamplePlanCopy.confirmLoadToDestination()"
							{~TIfAbs:SamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
						>
							<span class="icon mr-2">
								<i class="fas fa-fw fa-upload"></i>
							</span>
							Copy to Destination
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'SamplePlanCopy-Warnings',
				Template: /*html*/`
				<div class="notification is-warning is-soft mb-3">
					<strong>Warnings:</strong>
					<ul>
						{~TS:SamplePlanCopy-WarningItem:Context[0].comprehensionResult.warnings~}
					</ul>
				</div>`,
			},
			{
				Hash: 'SamplePlanCopy-WarningItem',
				Template: /*html*/`<li>{~D:Record.Value~}</li>`,
			},
			{
				Hash: 'SamplePlanCopy-LoadResults',
				Template: /*html*/`
					{~TIfAbs:SamplePlanCopy-LoadResultsContent:Record:Context[0].loadResult^!=^null~}
				`,
			},
			{
				Hash: 'SamplePlanCopy-LoadResultsContent',
				Template: /*html*/`
				<div class="box">
					<h3 class="title is-5 mb-3">Copy Results</h3>
					<table class="table is-fullwidth is-striped">
						<thead>
							<tr>
								<th>Change</th>
								<th class="has-text-right">Records</th>
								<th class="has-text-right">Saved</th>
								<th class="has-text-right">Failed</th>
								<th>Status</th>
							</tr>
						</thead>
						<tbody>
							{~TS:SamplePlanCopy-LoadResultRow:Context[0].loadResult.entities~}
						</tbody>
					</table>
				</div>`,
			},
			{
				Hash: 'SamplePlanCopy-LoadResultRow',
				Template: /*html*/`
							<tr>
								<td>{~D:Record.Label~}</td>
								<td class="has-text-right">{~D:Record.Sent~}</td>
								<td class="has-text-right">{~D:Record.Succeeded~}</td>
								<td class="has-text-right">{~D:Record.Failed~}</td>
								<td>{~D:Record.StatusLabel~}</td>
							</tr>`,
			},
			{
				Hash: 'SamplePlanCopy-ProjectSets',
				Template: /*html*/`
					<div class="tags mt-2 mb-0">
						<span class="tag is-info">Item set: {~D:Record.ItemLabel~}</span>
						<span class="tag">Material set: {~D:Record.MaterialLabel~}</span>
					</div>
					<p class="help mt-0">Based on: {~D:Record.BasisLabel~}</p>`,
			},
			{
				Hash: 'SamplePlanCopy-SetMismatch',
				Template: /*html*/`
					<div class="notification is-warning is-soft">
						<span class="icon mr-2">
							<i class="fas fa-fw fa-exclamation-triangle"></i>
						</span>
						<strong>These projects use different specification sets.</strong>
						Source: {~D:Context[0].sourceSets.ItemLabel~} (item), {~D:Context[0].sourceSets.MaterialLabel~} (material).
						Destination: {~D:Context[0].destSets.ItemLabel~} (item), {~D:Context[0].destSets.MaterialLabel~} (material).
						{~D:Context[0].setMismatchOutcome~}
					</div>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSets',
				Template: /*html*/`
					<table class="table is-fullwidth is-narrow mb-3">
						<thead>
							<tr>
								<th>Specification Sets</th>
								<th>Item</th>
								<th>Material</th>
								<th>Based On</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Source</td>
								<td>{~D:Context[0].specSetView.SourceItemLabel~}</td>
								<td>{~D:Context[0].specSetView.SourceMaterialLabel~}</td>
								<td>{~D:Context[0].specSetView.SourceBasisLabel~}</td>
							</tr>
							<tr>
								<td>Destination</td>
								<td>{~D:Context[0].specSetView.DestItemLabel~}</td>
								<td>{~D:Context[0].specSetView.DestMaterialLabel~}</td>
								<td>{~D:Context[0].specSetView.DestBasisLabel~}</td>
							</tr>
						</tbody>
					</table>
					{~TIfAbs:SamplePlanCopy-SpecSetCrossing:Record:Context[0].specSetView.ShowChanges^TRUE^x~}
					{~TIfAbs:SamplePlanCopy-SpecSetKept:Record:Context[0].specSetView.ShowKept^TRUE^x~}`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetKept',
				Template: /*html*/`
					<div class="notification is-info is-soft mb-3">
						<strong>The destination keeps its specification sets.</strong> Its contract and line item pay items are not changed; sample plan tests are copied onto its line items by item code.
					</div>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetCrossing',
				Template: /*html*/`
					<div class="notification is-warning is-soft mb-3">
						<p class="mb-2"><strong>This copy crosses specification sets.</strong> Copying also updates the destination to match the source:</p>
						<ul>
							{~TIfAbs:SamplePlanCopy-SpecSetContractChange:Record:Context[0].specSetView.HasContractUpdate^TRUE^x~}
							{~TIfAbs:SamplePlanCopy-SpecSetNoContract:Record:Context[0].specSetView.NoContract^TRUE^x~}
							{~TIfAbs:SamplePlanCopy-SpecSetLineItemChange:Record:Context[0].specSetView.RemapCount^>^0~}
						</ul>
					</div>
					{~TIfAbs:SamplePlanCopy-SpecSetShared:Record:Context[0].specSetView.ContractShared^TRUE^x~}
					{~TIfAbs:SamplePlanCopy-SpecSetUnmapped:Record:Context[0].specSetView.HasUnmapped^TRUE^x~}
					{~TIfAbs:SamplePlanCopy-SpecSetRemaps:Record:Context[0].specSetView.RemapCount^>^0~}`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetContractChange',
				Template: /*html*/`
							<li>
								<strong>Contract</strong> {~D:Context[0].specSetView.ContractLabel~}:
								item set {~D:Context[0].specSetView.ContractItemBefore~} &rarr; {~D:Context[0].specSetView.ContractItemAfter~},
								material set {~D:Context[0].specSetView.ContractMaterialBefore~} &rarr; {~D:Context[0].specSetView.ContractMaterialAfter~}
							</li>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetNoContract',
				Template: /*html*/`<li><strong>Contract</strong>: the destination has no contract, so only its line items change.</li>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetLineItemChange',
				Template: /*html*/`<li><strong>Line items</strong>: {~D:Context[0].specSetView.RemapCount~} line item(s) switch to the pay item with the same item code in {~D:Context[0].specSetView.TargetItemLabel~}.</li>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetShared',
				Template: /*html*/`
					<div class="notification is-danger is-soft mb-3">
						<strong>Shared contract.</strong> {~D:Context[0].specSetView.ContractLabel~} is also used by {~D:Context[0].specSetView.SharedProjectCount~} other project(s). Their specification sets change too, while their line items stay on their current pay items:
						<ul>
							{~TS:SamplePlanCopy-WarningItem:Context[0].specSetView.SharedProjects~}
						</ul>
					</div>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetUnmapped',
				Template: /*html*/`
					<div class="notification is-warning is-soft mb-3">
						<strong>{~D:Context[0].specSetView.UnmappedCount~} line item(s) keep their current pay item</strong> because {~D:Context[0].specSetView.TargetItemLabel~} has no single pay item with the same item code:
						<ul>
							{~TS:SamplePlanCopy-UnmappedItem:Context[0].specSetView.Unmapped~}
						</ul>
					</div>`,
			},
			{
				Hash: 'SamplePlanCopy-UnmappedItem',
				Template: /*html*/`<li>{~D:Record.ItemCode~} {~D:Record.Name~}: {~D:Record.Reason~}</li>`,
			},
			{
				Hash: 'SamplePlanCopy-SpecSetRemaps',
				Template: /*html*/`
					<details class="mb-3">
						<summary>Line item pay item changes ({~D:Context[0].specSetView.RemapCount~})</summary>
						<div style="max-height:320px; overflow-y:auto;">
							<table class="table is-fullwidth is-narrow is-striped">
								<thead>
									<tr>
										<th>Item Code</th>
										<th>Line Item</th>
										<th>Current Pay Item Set</th>
										<th>New Pay Item Set</th>
									</tr>
								</thead>
								<tbody>
									{~TS:SamplePlanCopy-RemapRow:Context[0].specSetView.Remaps~}
								</tbody>
							</table>
						</div>
					</details>`,
			},
			{
				Hash: 'SamplePlanCopy-RemapRow',
				Template: /*html*/`
									<tr>
										<td>{~D:Record.ItemCode~}</td>
										<td>{~D:Record.Name~}</td>
										<td>{~D:Record.From~}</td>
										<td>{~D:Record.To~}</td>
									</tr>`,
			},
			{
				Hash: 'SamplePlanCopy-RealignmentStatRows',
				Template: /*html*/`
									<tr>
										<td>Contract Specification Set Changes</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.contractUpdateCount~}</td>
									</tr>
									<tr>
										<td>Line Item Pay Item Changes</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.lineItemRemapCount~}</td>
									</tr>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'SamplePlanCopy',
				TemplateHash: 'SamplePlanCopy-Wrapper',
				RenderMethod: 'replace',
			},
		],
	});

},{"./SamplePlanCopy-Display.js":1386,"pict-view":1053}],1388:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
const libEntityPickerSearch = require('../services/Entity-Picker-Search.js');

/**
 * SamplePlanDashboard — a net-new pict recreation of the legacy "Material LineItem Samples" dashboard
 * (web/app_dashboards/.../materials_samples). It presents the project's sampling data through a pill tab bar of
 * PRESETS, each a read grid over a shared bundle:
 *   • Sample Plan     — line-item folders → one row per ProjectLineItemMaterialTest (Material, Type, Rate, Frequency,
 *                       Bid/Installed Qty, Planned/Required Samples).
 *   • Samples         — line-item folders → material sub-groups → one row per SampleType (Units, Type, Rate, Frequency,
 *                       Conversion Factor, Approved Source, Special Instructions).
 *   • Failing Samples — a flat list of every actual Sample with Status FAIL (Sample name, Units, Type, Disposition).
 *
 * SHAREABLE: this provider owns the fetch (the lean SamplePlanBundle/Parts endpoint — a single streamed request for
 * only the parts a preset needs), the bundle→rows transforms (which reproduce the legacy SPBundle shaping row-for-row
 * from the raw parts), and the host-div paint. Any host embeds it with `provider.openInto(idProject, '#SomeHost')`;
 * the standalone #/SamplePlanDashboard screen uses the thin SamplePlanDashboard view. The provider never assumes an
 * entity name — it reads config off `this.cfg`.
 */
class SamplePlanDashboardProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._idProject = 0;
		this._mount = '';
		this._rawBundle = null;   // the last-fetched bundle parts (a superset once samples are loaded)
		this._haveSamples = false;// whether _rawBundle includes the Samples/SampleLineItemJoins parts
		this._model = null;       // uniform view model — see _buildForPreset
		this._preset = 'SamplePlan';
		this._search = '';
		this._sortBy = 'Material';
		this._sortDesc = false;
		this._editingSample = 0;  // Failing Samples: IDSample whose disposition is being edited inline (0 = none)
		this._savingSample = 0;   // IDSample whose disposition PUT is in flight
		this._customGroup = 'None';                                            // Custom: active grouping
		this._customColumns = SamplePlanDashboardProvider.CUSTOM_DEFAULT_COLUMNS.slice();  // Custom: chosen column keys
		this._fullscreen = false;  // standalone "full screen" — overlay the whole browser view (see toggleFullscreen)

		if (typeof document !== 'undefined')
		{
			// Esc leaves full screen (routed through toggleFullscreen).
			this._onKeydown = (pEvent) => { if (pEvent.key === 'Escape' && this._fullscreen) { this.toggleFullscreen(); } };
			document.addEventListener('keydown', this._onKeydown);
		}

		if (this.pict && this.pict.CSSMap && (typeof this.pict.CSSMap.addCSS === 'function'))
		{
			// Idempotent key — multiple instances register the same block harmlessly.
			this.pict.CSSMap.addCSS('SamplePlanDashboard-CSS', _CSS, 530);
		}
	}

	// --- config + services ---
	get cfg() { return this.options || {}; }
	get providerName() { return this.cfg.ProviderIdentifier || 'SamplePlanDashboard'; }
	get restClient() { return (this.pict.fable && this.pict.fable.HeadlightRestClient) || this.pict.HeadlightRestClient; }
	/** Show the per-row "New Sample" action column (off by default, mirroring the legacy dashboard's default). */
	get showAddSample() { return this.cfg.ShowAddSample === true; }
	get presets() { return SamplePlanDashboardProvider.PRESETS; }
	get activePreset() { return this.presets.find((pPreset) => pPreset.Key === this._preset) || this.presets[0]; }
	/** True when painted into a host OTHER than the standalone screen (e.g. the embedded Project-workspace tab), where a
	 *  "Full screen" pop-out to the standalone full-width dashboard is offered. */
	get isEmbedded() { return !!this._mount && this._mount !== '#SamplePlanDashboard-Host'; }

	get state()
	{
		const tmpKey = this.providerName;
		if (!this.pict.AppData[tmpKey]) { this.pict.AppData[tmpKey] = { Loading: false, Loaded: false, Error: '', IDProject: 0, ProjectName: '', RowCount: 0 }; }
		return this.pict.AppData[tmpKey];
	}

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pError, pResult) => pError ? reject(pError) : resolve(pResult))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pError, pResult) => pError ? reject(pError) : resolve(pResult))); }
	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_num(pValue) { const tmp = Number(pValue); return Number.isFinite(tmp) ? Math.round(tmp).toLocaleString() : ''; }
	_isZero(pValue) { const tmp = Number(pValue); return !pValue || (Number.isFinite(tmp) && tmp === 0); }

	/** The bundle parts a preset needs — lean by default; the sample-record presets add Samples + SampleLineItemJoins. */
	_partsFor(pPreset) { return (pPreset && pPreset.NeedsSamples) ? SamplePlanDashboardProvider.BUNDLE_PARTS.concat(['Samples', 'SampleLineItemJoins']) : SamplePlanDashboardProvider.BUNDLE_PARTS; }

	// --- Shareable mount seam ---

	/**
	 * Render the dashboard for a project into a host element. Safe to call on every host repaint — reloads only when
	 * the project changes; otherwise repaints from cache.
	 * @param {number|string} pIDProject @param {string} pMountSelector
	 */
	openInto(pIDProject, pMountSelector)
	{
		this._mount = pMountSelector || this.cfg.MountSelector || '#SamplePlanDashboard-Host';
		const tmpID = Number(pIDProject) || 0;
		if (tmpID && (tmpID !== this._idProject)) { this.loadAsync(tmpID); }
		else { this.render(); }
	}

	// --- Load + shape ---

	async loadAsync(pIDProject)
	{
		this._idProject = Number(pIDProject) || 0;
		const tmpState = this.state;
		tmpState.Loading = true; tmpState.Loaded = false; tmpState.Error = ''; tmpState.IDProject = this._idProject;
		this._rawBundle = null; this._haveSamples = false; this._model = null; this._search = '';
		this.render();
		if (!this._idProject) { tmpState.Loading = false; this.render(); return; }
		try
		{
			// Single lean endpoint: SamplePlanBundle/Parts streams ONLY the parts a preset needs — ~85% smaller than the
			// full SamplePlanBundle (it omits Samples/TestData/TestInstances/… unless a preset asks for them). The server
			// refreshes the PLIMTs' Computed{Required,Planned}SampleCount via PLIMTCalculator, so the builders rebuild the
			// per-SampleType aggregate client-side and produce the same rows the full bundle's mlij.SampleTypes did.
			const tmpParts = this._partsFor(this.activePreset);
			this._rawBundle = (await this._postJSON(`SamplePlanBundle/Parts/By/IDProject/${this._idProject}`, { Parts: tmpParts })) || {};
			this._haveSamples = tmpParts.indexOf('Samples') >= 0;
			tmpState.ProjectName = (this._rawBundle.Project && (this._rawBundle.Project.Name || this._rawBundle.Project.Description)) || `Project ${this._idProject}`;
			this._rebuild();
			tmpState.Loaded = true;
		}
		catch (pError) { tmpState.Error = `Could not load the sample plan dashboard: ${pError && pError.message ? pError.message : pError}`; }
		tmpState.Loading = false;
		this.render();
	}

	/** Rebuild the view model for the active preset from the cached raw bundle, and refresh the row count. */
	_rebuild()
	{
		this._model = this._buildForPreset(this._rawBundle || {});
		this.state.RowCount = this._modelRowCount();
	}

	_modelRowCount() { return ((this._model && this._model.Sections) || []).reduce((pSum, pSection) => pSum + pSection.Groups.reduce((pG, pGroup) => pG + pGroup.Rows.length, 0), 0); }

	_buildForPreset(pBundle)
	{
		if (this._preset === 'Samples') { return this._buildSamples(pBundle); }
		if (this._preset === 'FailingSamples') { return this._buildFailingSamples(pBundle); }
		if (this._preset === 'Custom') { return this._buildCustom(pBundle); }
		return this._buildSamplePlan(pBundle);
	}

	/** Shared bundle indexes used by the builders. */
	_indexBundle(pBundle)
	{
		const tmpMaterialByID = {};
		(pBundle.Materials || []).forEach((pMaterial) => { tmpMaterialByID[pMaterial.IDMaterial] = pMaterial; });
		const tmpMLIJByLineItem = {};
		(pBundle.MaterialLineItemJoins || []).forEach((pMLIJ) => { (tmpMLIJByLineItem[pMLIJ.IDLineItem] = tmpMLIJByLineItem[pMLIJ.IDLineItem] || []).push(pMLIJ); });
		const tmpPLIMTByJoin = {};
		(pBundle.ProjectLineItemMaterialTests || []).forEach((pPLIMT) => { const tmpKey = `${pPLIMT.IDLineItem}_${pPLIMT.IDMaterial}`; (tmpPLIMTByJoin[tmpKey] = tmpPLIMTByJoin[tmpKey] || []).push(pPLIMT); });
		return { materialByID: tmpMaterialByID, mlijByLineItem: tmpMLIJByLineItem, plimtByJoin: tmpPLIMTByJoin };
	}

	_materialName(pMaterial, pIDMaterial) { return (pMaterial && pMaterial.Name) || `Material ${pIDMaterial}`; }
	_materialCode(pMaterial) { return (pMaterial && (pMaterial.MaterialCode || pMaterial.CatalogCode)) || ''; }
	_lineItemName(pLineItem) { return pLineItem.Name || pLineItem.ItemNumber || `Line Item ${pLineItem.IDLineItem}`; }

	/**
	 * Sample Plan preset — line-item folders → one row per ProjectLineItemMaterialTest (verified row-for-row against the
	 * full SamplePlanBundle). Grouping mirrors getSamplePlanBundleData: group PLIMTs by `${IDLineItem}_${IDMaterial}` then
	 * by SampleType; the SampleType aggregate's Planned/Required are the largest of its PLIMTs' fresh Computed counts;
	 * Bid/Installed come from the LINE ITEM (ContractQuantity / InstalledQuantity), as the server does.
	 */
	_buildSamplePlan(pBundle)
	{
		const tmpIdx = this._indexBundle(pBundle);
		const tmpSections = [];
		(pBundle.LineItems || []).forEach((pLineItem) =>
		{
			const tmpMLIJs = tmpIdx.mlijByLineItem[pLineItem.IDLineItem] || [];
			const tmpBid = parseFloat(pLineItem.ContractQuantity) || 0;
			const tmpInstalled = parseFloat(pLineItem.InstalledQuantity) || 0;
			const tmpRows = [];
			tmpMLIJs.forEach((pMLIJ) =>
			{
				const tmpMaterial = tmpIdx.materialByID[pMLIJ.IDMaterial] || {};
				const tmpPLIMTs = tmpIdx.plimtByJoin[`${pMLIJ.IDLineItem}_${pMLIJ.IDMaterial}`] || [];
				if (tmpPLIMTs.length === 0) { return; }
				const tmpByType = this._groupBy(tmpPLIMTs, (pPLIMT) => pPLIMT.SampleType || '');
				Object.keys(tmpByType).forEach((pTypeKey) =>
				{
					const tmpGroup = tmpByType[pTypeKey];
					// One sample serves every test in the group; same rule as SampleTypeSummary.ts in api/headlight
					const tmpPlanned = Math.max(...tmpGroup.map((pPLIMT) => Number(pPLIMT.ComputedPlannedSampleCount) || 0));
					const tmpRequired = Math.max(...tmpGroup.map((pPLIMT) => Number(pPLIMT.ComputedRequiredSampleCount) || 0));
					tmpGroup.forEach((pPLIMT) =>
					{
						tmpRows.push(
							{
								IDLineItem: pLineItem.IDLineItem, IDMaterial: pMLIJ.IDMaterial,
								MaterialName: this._materialName(tmpMaterial, pMLIJ.IDMaterial),
								MaterialCode: this._materialCode(tmpMaterial),
								SampleType: pPLIMT.SampleType || pTypeKey,
								Rate: pPLIMT.Rate, Frequency: pPLIMT.Frequency,
								BidQuantity: tmpBid, InstalledQuantity: tmpInstalled,
								PlannedSampleCount: tmpPlanned, RequiredSampleCount: tmpRequired,
								Search: `${this._materialName(tmpMaterial, pMLIJ.IDMaterial)} ${this._materialCode(tmpMaterial)} ${pPLIMT.SampleType || pTypeKey} ${pMLIJ.Units || ''}`.toLowerCase(),
							});
					});
				});
			});
			if (tmpRows.length === 0) { return; }
			tmpSections.push(this._lineItemSection(pLineItem, [{ Banner: null, Rows: tmpRows }]));
		});
		return { Project: pBundle.Project || {}, Sections: tmpSections };
	}

	/**
	 * Samples preset — line-item folders → material sub-groups → one row per SampleType (ports getDataForSamplesDashboard).
	 * Rate/Frequency come from the SampleType's first PLIMT; Units/ConversionFactor/ApprovedSource/SpecialInstructions
	 * from the MaterialLineItemJoin. Material is a sub-banner, not a column.
	 */
	_buildSamples(pBundle)
	{
		const tmpIdx = this._indexBundle(pBundle);
		const tmpSections = [];
		(pBundle.LineItems || []).forEach((pLineItem) =>
		{
			const tmpMLIJs = tmpIdx.mlijByLineItem[pLineItem.IDLineItem] || [];
			const tmpGroups = [];
			tmpMLIJs.forEach((pMLIJ) =>
			{
				const tmpMaterial = tmpIdx.materialByID[pMLIJ.IDMaterial] || {};
				const tmpPLIMTs = tmpIdx.plimtByJoin[`${pMLIJ.IDLineItem}_${pMLIJ.IDMaterial}`] || [];
				if (tmpPLIMTs.length === 0) { return; }
				const tmpMatName = this._materialName(tmpMaterial, pMLIJ.IDMaterial);
				const tmpMatCode = this._materialCode(tmpMaterial);
				const tmpByType = this._groupBy(tmpPLIMTs, (pPLIMT) => pPLIMT.SampleType || '');
				const tmpRows = Object.keys(tmpByType).map((pTypeKey) =>
				{
					const tmpFirst = tmpByType[pTypeKey][0] || {};
					return {
						IDLineItem: pLineItem.IDLineItem, IDMaterial: pMLIJ.IDMaterial,
						MaterialName: tmpMatName, MaterialCode: tmpMatCode,
						Units: pMLIJ.Units, SampleType: pTypeKey,
						Rate: tmpFirst.Rate, Frequency: tmpFirst.Frequency, ConversionFactor: pMLIJ.ConversionFactor,
						ApprovedSourceRequired: (Number(pMLIJ.ApprovedSourceRequired) === 1),
						SpecialInstructions: pMLIJ.SpecialInstructions,
						Search: `${this._lineItemName(pLineItem)} ${pLineItem.ItemCode || ''} ${tmpMatName} ${tmpMatCode} ${pTypeKey} ${pMLIJ.Units || ''}`.toLowerCase(),
					};
				});
				if (tmpRows.length === 0) { return; }
				tmpGroups.push({ Banner: { Name: tmpMatName, Code: tmpMatCode }, Rows: tmpRows });
			});
			if (tmpGroups.length === 0) { return; }
			tmpSections.push(this._lineItemSection(pLineItem, tmpGroups));
		});
		return { Project: pBundle.Project || {}, Sections: tmpSections };
	}

	/**
	 * Failing Samples preset — a FLAT list of every actual Sample with Status FAIL (ports getFailingSamples). One row per
	 * failing sample: Sample name (QR code + name), Units (SampledQuantityUnits), Type (MaterialType || RepresentedQuantityUnits),
	 * Disposition (the sample's Notes). Needs the Samples + SampleLineItemJoins parts.
	 */
	_buildFailingSamples(pBundle)
	{
		const tmpIdx = this._indexBundle(pBundle);
		const tmpLineItemByID = {};
		(pBundle.LineItems || []).forEach((pLineItem) => { tmpLineItemByID[pLineItem.IDLineItem] = pLineItem; });
		const tmpLineItemsBySample = {};
		(pBundle.SampleLineItemJoins || []).forEach((pSLIJ) => { (tmpLineItemsBySample[pSLIJ.IDSample] = tmpLineItemsBySample[pSLIJ.IDSample] || []).push(pSLIJ.IDLineItem); });

		const tmpFailing = (pBundle.Samples || []).filter((pSample) => pSample.Status === 'FAIL' && (Number(pSample.Deleted) !== 1));
		const tmpRows = tmpFailing.map((pSample) =>
		{
			const tmpMaterial = tmpIdx.materialByID[pSample.IDMaterial] || {};
			const tmpLineItemNames = (tmpLineItemsBySample[pSample.IDSample] || []).map((pID) => tmpLineItemByID[pID] ? this._lineItemName(tmpLineItemByID[pID]) : '').filter((pName) => !!pName);
			return {
				IDSample: pSample.IDSample,
				QRCode: pSample.QRCode || '',
				Name: pSample.Name || '',
				Units: pSample.SampledQuantityUnits || pSample.Units || '',
				Type: pSample.MaterialType || pSample.RepresentedQuantityUnits || '',
				Disposition: pSample.Notes || '',
				MaterialName: this._materialName(tmpMaterial, pSample.IDMaterial),
				MaterialCode: this._materialCode(tmpMaterial),
				LineItems: tmpLineItemNames,
				Search: `${pSample.QRCode || ''} ${pSample.Name || ''} ${pSample.MaterialType || ''} ${pSample.Notes || ''} ${this._materialName(tmpMaterial, pSample.IDMaterial)} ${tmpLineItemNames.join(' ')}`.toLowerCase(),
			};
		});
		// Flat: a single bannerless section holding one bannerless group.
		return { Project: pBundle.Project || {}, Sections: tmpRows.length ? [{ Banner: null, Search: '', Groups: [{ Banner: null, Rows: tmpRows }] }] : [] };
	}

	/**
	 * Custom preset — a configurable view. Builds one flat row per (LineItem × Material × SampleType) carrying EVERY
	 * catalog field, then regroups by `_customGroup` (None / LineItem / LineItemMaterial / Material). The column chooser
	 * (`_customColumns`) decides which fields render. Created/Passing/Failing come from the SampleType's first PLIMT's
	 * fresh Computed counts (lean), consistent with Planned/Required.
	 */
	_buildCustom(pBundle)
	{
		const tmpIdx = this._indexBundle(pBundle);
		// Sample counts per (IDLineItem, IDMaterial, SampleType) from ACTUAL sample records — the PLIMT's stored
		// Created/Passing/Failing counts are stale, so (like the full bundle) we count real samples: a line item's
		// samples (via SampleLineItemJoins) filtered to the material, grouped by the sample's MaterialType.
		const tmpCounts = this._sampleCountIndex(pBundle);
		const tmpFlat = [];
		(pBundle.LineItems || []).forEach((pLineItem) =>
		{
			const tmpMLIJs = tmpIdx.mlijByLineItem[pLineItem.IDLineItem] || [];
			const tmpBid = parseFloat(pLineItem.ContractQuantity) || 0;
			const tmpInstalled = parseFloat(pLineItem.InstalledQuantity) || 0;
			tmpMLIJs.forEach((pMLIJ) =>
			{
				const tmpMaterial = tmpIdx.materialByID[pMLIJ.IDMaterial] || {};
				const tmpPLIMTs = tmpIdx.plimtByJoin[`${pMLIJ.IDLineItem}_${pMLIJ.IDMaterial}`] || [];
				if (tmpPLIMTs.length === 0) { return; }
				const tmpMatName = this._materialName(tmpMaterial, pMLIJ.IDMaterial);
				const tmpMatCode = this._materialCode(tmpMaterial);
				const tmpByType = this._groupBy(tmpPLIMTs, (pPLIMT) => pPLIMT.SampleType || '');
				Object.keys(tmpByType).forEach((pTypeKey) =>
				{
					const tmpFirst = tmpByType[pTypeKey][0] || {};
					const tmpCount = tmpCounts[`${pLineItem.IDLineItem}|${pMLIJ.IDMaterial}|${pTypeKey}`] || { created: 0, passing: 0, failing: 0 };
					tmpFlat.push(
						{
							IDLineItem: pLineItem.IDLineItem, IDMaterial: pMLIJ.IDMaterial,
							LineItem: this._lineItemName(pLineItem), ItemCode: pLineItem.ItemCode || '',
							MaterialName: tmpMatName, MaterialCode: tmpMatCode, Material: tmpMatName,
							Units: pMLIJ.Units, SampleType: pTypeKey,
							Rate: tmpFirst.Rate, Frequency: tmpFirst.Frequency, ConversionFactor: pMLIJ.ConversionFactor,
							BidQuantity: tmpBid, InstalledQuantity: tmpInstalled,
							PlannedSampleCount: tmpFirst.ComputedPlannedSampleCount, RequiredSampleCount: tmpFirst.ComputedRequiredSampleCount,
							CreatedSamples: tmpCount.created, PassingSamples: tmpCount.passing, FailingSamples: tmpCount.failing,
							ApprovedSourceRequired: (Number(pMLIJ.ApprovedSourceRequired) === 1),
							SpecialInstructions: pMLIJ.SpecialInstructions,
							Search: `${this._lineItemName(pLineItem)} ${pLineItem.ItemCode || ''} ${tmpMatName} ${tmpMatCode} ${pTypeKey} ${pMLIJ.Units || ''}`.toLowerCase(),
						});
				});
			});
		});
		return { Project: pBundle.Project || {}, Sections: this._groupCustomRows(tmpFlat) };
	}

	/** Assemble Custom's flat rows into the uniform Section→Group model per the active grouping (bundle order preserved). */
	_groupCustomRows(pFlat)
	{
		if (pFlat.length === 0) { return []; }
		if (this._customGroup === 'None') { return [{ Banner: null, Search: '', Groups: [{ Banner: null, Rows: pFlat }] }]; }
		if (this._customGroup === 'Material')
		{
			const tmpByMat = this._groupOrdered(pFlat, (pRow) => pRow.IDMaterial);
			const tmpGroups = tmpByMat.map((pEntry) => ({ Banner: { Name: pEntry.Items[0].MaterialName, Code: pEntry.Items[0].MaterialCode }, Rows: pEntry.Items }));
			return [{ Banner: null, Search: '', Groups: tmpGroups }];
		}
		// LineItem or LineItemMaterial → a section per line item
		const tmpByLI = this._groupOrdered(pFlat, (pRow) => pRow.IDLineItem);
		return tmpByLI.map((pEntry) =>
		{
			const tmpRows = pEntry.Items;
			const tmpFirst = tmpRows[0];
			let tmpGroups;
			if (this._customGroup === 'LineItemMaterial')
			{
				tmpGroups = this._groupOrdered(tmpRows, (pRow) => pRow.IDMaterial).map((pMat) => ({ Banner: { Name: pMat.Items[0].MaterialName, Code: pMat.Items[0].MaterialCode }, Rows: pMat.Items }));
			}
			else { tmpGroups = [{ Banner: null, Rows: tmpRows }]; }
			return { Banner: { Name: tmpFirst.LineItem, Code: tmpFirst.ItemCode }, Search: `${tmpFirst.LineItem} ${tmpFirst.ItemCode}`.toLowerCase(), Groups: tmpGroups };
		});
	}

	/**
	 * Count real samples per (IDLineItem, IDMaterial, MaterialType) → { created, passing, failing }, mirroring how the
	 * full SamplePlanBundle derives its SampleType counts: a line item's samples (joined via SampleLineItemJoins) are
	 * matched to the material, then grouped by the sample's MaterialType (which equals the SampleType key). Requires the
	 * Samples + SampleLineItemJoins parts; returns an empty index (all zero) when they are absent.
	 */
	_sampleCountIndex(pBundle)
	{
		const tmpSampleByID = {};
		(pBundle.Samples || []).forEach((pSample) => { if (Number(pSample.Deleted) !== 1) { tmpSampleByID[pSample.IDSample] = pSample; } });
		const tmpIndex = {};
		(pBundle.SampleLineItemJoins || []).forEach((pSLIJ) =>
		{
			const tmpSample = tmpSampleByID[pSLIJ.IDSample];
			if (!tmpSample) { return; }
			const tmpKey = `${pSLIJ.IDLineItem}|${tmpSample.IDMaterial}|${tmpSample.MaterialType || ''}`;
			const tmpEntry = tmpIndex[tmpKey] || (tmpIndex[tmpKey] = { created: 0, passing: 0, failing: 0 });
			tmpEntry.created += 1;
			if (tmpSample.Status === 'PASS') { tmpEntry.passing += 1; }
			else if (tmpSample.Status === 'FAIL') { tmpEntry.failing += 1; }
		});
		return tmpIndex;
	}

	/** group-by that preserves first-seen key order (unlike a plain object, whose integer keys reorder numerically). */
	_groupOrdered(pList, pKeyFn)
	{
		const tmpOrder = []; const tmpMap = {};
		(pList || []).forEach((pItem) => { const tmpKey = pKeyFn(pItem); if (!tmpMap[tmpKey]) { tmpMap[tmpKey] = []; tmpOrder.push(tmpKey); } tmpMap[tmpKey].push(pItem); });
		return tmpOrder.map((pKey) => ({ Key: pKey, Items: tmpMap[pKey] }));
	}

	_lineItemSection(pLineItem, pGroups)
	{
		return {
			Banner: { Name: this._lineItemName(pLineItem), Code: pLineItem.ItemCode || pLineItem.ItemNumber || '' },
			Search: `${pLineItem.Name || ''} ${pLineItem.ItemCode || ''}`.toLowerCase(),
			Groups: pGroups,
		};
	}

	_groupBy(pList, pKeyFn) { const tmpOut = {}; (pList || []).forEach((pItem) => { const tmpKey = pKeyFn(pItem); (tmpOut[tmpKey] = tmpOut[tmpKey] || []).push(pItem); }); return tmpOut; }

	// --- Interactions (called from inline handlers) ---

	/** Switch the active preset tab. Lazily augments the fetch with the Samples parts the first time a sample-record
	 *  preset (Failing Samples) is opened; otherwise repaints from the cached bundle. */
	async setPreset(pKey)
	{
		if (this._preset === pKey) { return; }
		const tmpPreset = this.presets.find((pPreset) => pPreset.Key === pKey);
		if (!tmpPreset) { return; }
		this._preset = pKey;
		this._search = '';
		this._sortBy = tmpPreset.DefaultSort || 'Material';
		this._sortDesc = false;

		const tmpState = this.state;
		if (tmpPreset.NeedsSamples && !this._haveSamples && this._idProject)
		{
			tmpState.Loading = true; tmpState.Error = ''; this.render();
			try
			{
				this._rawBundle = (await this._postJSON(`SamplePlanBundle/Parts/By/IDProject/${this._idProject}`, { Parts: this._partsFor(tmpPreset) })) || this._rawBundle;
				this._haveSamples = true;
			}
			catch (pError) { tmpState.Error = `Could not load samples: ${pError && pError.message ? pError.message : pError}`; }
			tmpState.Loading = false;
		}
		if (this._rawBundle) { this._rebuild(); }
		this.render();
	}

	setSearch(pValue) { this._search = String(pValue == null ? '' : pValue).toLowerCase(); this._paintTable(); }

	/** Print / save-as-PDF the active tab. Print CSS (`@media print`) hides the app chrome + this dashboard's own
	 *  toolbar/tabs/action buttons, leaving just the titled grid. */
	print()
	{
		try
		{
			const tmpTitle = document.title;
			const tmpName = `${this.state.ProjectName || 'Project'} - ${this.activePreset.Label}`.replace(/[^\w .-]+/g, ' ').trim();
			document.title = tmpName || tmpTitle;
			const fRestore = () => { document.title = tmpTitle; window.removeEventListener('afterprint', fRestore); };
			window.addEventListener('afterprint', fRestore);
			window.print();
		}
		catch (pError) { try { window.print(); } catch (pInner) { /* best-effort */ } }
	}

	setSort(pColumn)
	{
		if (this._sortBy === pColumn) { this._sortDesc = !this._sortDesc; }
		else { this._sortBy = pColumn; this._sortDesc = false; }
		this._paintTable();
	}

	/** Custom: change the grouping (regroups the rows) — repaints the shell so the active group button + table update. */
	setCustomGroup(pKey)
	{
		if (this._customGroup === pKey) { return; }
		this._customGroup = pKey;
		if (this._rawBundle) { this._rebuild(); }
		this.render();
	}

	/** Custom: toggle a column in the chooser — only the table (and the count badge) repaint, so the panel stays open. */
	toggleCustomColumn(pKey)
	{
		const tmpIndex = this._customColumns.indexOf(pKey);
		if (tmpIndex >= 0) { this._customColumns.splice(tmpIndex, 1); }
		else { this._customColumns.push(pKey); }
		if (this._customColumns.length === 0) { this._customColumns.push(pKey); }   // never leave zero columns
		this._paintTable();
		try { const tmpEl = document.querySelector(`${this._mount || '#SamplePlanDashboard-Host'} .spd-custom-count`); if (tmpEl) { tmpEl.textContent = String(this._customColumns.length); } } catch (pError) { /* best-effort */ }
	}

	// --- Failing-sample disposition editing (inline; writes Sample.Notes) ---

	editDisposition(pIDSample)
	{
		this._editingSample = Number(pIDSample) || 0;
		this._paintTable();
		// Focus the freshly-painted textarea and drop the cursor at the end.
		try { const tmpEl = document.getElementById(`spd-dispo-input-${Number(pIDSample)}`); if (tmpEl) { tmpEl.focus(); tmpEl.selectionStart = tmpEl.selectionEnd = tmpEl.value.length; } } catch (pError) { /* best-effort */ }
	}

	cancelDisposition() { this._editingSample = 0; this._paintTable(); }

	async saveDisposition(pIDSample)
	{
		const tmpID = Number(pIDSample) || 0;
		if (!tmpID) { return; }
		let tmpValue = '';
		try { const tmpEl = document.getElementById(`spd-dispo-input-${tmpID}`); tmpValue = tmpEl ? String(tmpEl.value || '') : ''; } catch (pError) { /* best-effort */ }
		await this._commitDisposition(tmpID, tmpValue);
	}

	async deleteDisposition(pIDSample)
	{
		const tmpID = Number(pIDSample) || 0;
		if (!tmpID) { return; }
		await this._commitDisposition(tmpID, '');
	}

	/** PUT the sample's Notes, then reflect it in the cached bundle + model so repaints show the saved value. */
	async _commitDisposition(pIDSample, pNotes)
	{
		this._editingSample = 0;
		this._savingSample = pIDSample;
		this._paintTable();
		try
		{
			await this._putJSON('Sample', { IDSample: pIDSample, Notes: pNotes });
			const tmpSample = (this._rawBundle && this._rawBundle.Samples || []).find((pSample) => pSample.IDSample === pIDSample);
			if (tmpSample) { tmpSample.Notes = pNotes; }
			const tmpRow = this._findFailingRow(pIDSample);
			if (tmpRow) { tmpRow.Disposition = pNotes; tmpRow.Search = `${tmpRow.QRCode || ''} ${tmpRow.Name || ''} ${tmpRow.Type || ''} ${pNotes || ''} ${tmpRow.MaterialName || ''} ${(tmpRow.LineItems || []).join(' ')}`.toLowerCase(); }
			this._toast('Disposition saved', 'success');
		}
		catch (pError) { this._toast(`Could not save disposition: ${pError && pError.message ? pError.message : pError}`, 'error'); }
		this._savingSample = 0;
		this._paintTable();
	}

	_findFailingRow(pIDSample)
	{
		const tmpSections = (this._model && this._model.Sections) || [];
		for (const tmpSection of tmpSections) { for (const tmpGroup of tmpSection.Groups) { const tmpFound = tmpGroup.Rows.find((pRow) => pRow.IDSample === pIDSample); if (tmpFound) { return tmpFound; } } }
		return null;
	}

	/** Fire a toast via the shared modal provider when available (guards the duration-undefined clobber). */
	_toast(pMessage, pKind)
	{
		try
		{
			const tmpModal = this.pict.providers && (this.pict.providers['Pict-Section-Modal'] || this.pict.providers['PictSectionModal']);
			if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast({ Content: pMessage, Type: (pKind === 'error') ? 'danger' : 'success', Duration: 3000 }); }
		}
		catch (pError) { /* best-effort */ }
	}

	/** The "New Sample" action for a row (only when ShowAddSample is on). Navigates to the bespoke Sample create,
	 *  seeding the project/line-item/material — the config-app equivalent of the legacy postMessage-to-host. */
	addSampleForRow(pIDLineItem, pIDMaterial, pType)
	{
		if (!this.showAddSample) { return; }
		try { window.location.hash = `#/PSRS/Sample/Create?IDProject=${Number(this._idProject)}&IDLineItem=${Number(pIDLineItem)}&IDMaterial=${Number(pIDMaterial)}&Type=${encodeURIComponent(String(pType || ''))}`; }
		catch (pError) { /* best-effort */ }
	}

	// --- Filtering + sorting (view-time) ---

	/** Compute the rendered view: sections → groups → filtered + sorted rows, with empties dropped. */
	_computeView()
	{
		const tmpQuery = (this._search || '').trim();
		const tmpSections = (this._model && this._model.Sections) || [];
		const tmpOut = [];
		tmpSections.forEach((pSection) =>
		{
			const tmpSectionMatches = pSection.Banner ? (pSection.Search.indexOf(tmpQuery) >= 0) : false;
			const tmpGroups = [];
			pSection.Groups.forEach((pGroup) =>
			{
				let tmpRows = pGroup.Rows;
				if (tmpQuery && !tmpSectionMatches) { tmpRows = tmpRows.filter((pRow) => pRow.Search.indexOf(tmpQuery) >= 0); }
				tmpRows = this._sortRows(tmpRows);
				if (tmpRows.length > 0) { tmpGroups.push({ Banner: pGroup.Banner, Rows: tmpRows }); }
			});
			if (tmpGroups.length > 0) { tmpOut.push({ Banner: pSection.Banner, Groups: tmpGroups, RowCount: tmpGroups.reduce((pSum, pGroup) => pSum + pGroup.Rows.length, 0) }); }
		});
		return tmpOut;
	}

	_sortRows(pRows)
	{
		const tmpKey = this._sortBy;
		const tmpDir = this._sortDesc ? -1 : 1;
		const fVal = (pRow) => (tmpKey === 'Material') ? String(pRow.MaterialName || '') : pRow[tmpKey];
		return pRows.slice().sort((pA, pB) =>
		{
			const tmpA = fVal(pA); const tmpB = fVal(pB);
			const tmpNumA = Number(tmpA); const tmpNumB = Number(tmpB);
			if (Number.isFinite(tmpNumA) && Number.isFinite(tmpNumB) && (tmpKey !== 'Material')) { return (tmpNumA - tmpNumB) * tmpDir; }
			return String(tmpA == null ? '' : tmpA).localeCompare(String(tmpB == null ? '' : tmpB)) * tmpDir;
		});
	}

	// --- Columns (per preset) ---

	_columns()
	{
		const tmpCols = [];
		if (this._preset === 'Custom')
		{
			const tmpHasLineItem = (this._customGroup === 'LineItem' || this._customGroup === 'LineItemMaterial');
			const tmpHasMaterial = (this._customGroup === 'Material' || this._customGroup === 'LineItemMaterial');
			const tmpChosen = SamplePlanDashboardProvider.CUSTOM_COLUMN_CATALOG
				.filter((pCol) => this._customColumns.indexOf(pCol.Key) >= 0)
				.filter((pCol) => !(tmpHasLineItem && pCol.Banner === 'lineitem'))
				.filter((pCol) => !(tmpHasMaterial && pCol.Banner === 'material'))
				.map((pCol) => Object.assign({}, pCol));
			// Give exactly one column the flex/wrap role so the grid fills the width without a scroll.
			const tmpFlex = tmpChosen.find((pCol) => pCol.Key === 'Material') || tmpChosen.find((pCol) => pCol.Key === 'SpecialInstructions') || tmpChosen.find((pCol) => pCol.Align === 'left');
			if (tmpFlex) { tmpFlex.Flex = true; if (tmpFlex.Text) { tmpFlex.Wrap = true; } }
			return tmpChosen.length ? tmpChosen : [{ Key: 'SampleType', Label: 'Type', Align: 'center' }];
		}
		if (this._preset === 'FailingSamples')
		{
			tmpCols.push({ Key: 'Name', Label: 'Sample', Align: 'left', Flex: true });
			tmpCols.push({ Key: 'Units', Label: 'Units', Align: 'left' });
			tmpCols.push({ Key: 'Type', Label: 'Type', Align: 'center' });
			tmpCols.push({ Key: 'Disposition', Label: 'Disposition', Align: 'left', Flex: true, Wrap: true });
			tmpCols.push({ Key: 'DispositionAction', Label: '', Align: 'left', NoSort: true, NoPrint: true });
			return tmpCols;
		}
		if (this._preset === 'Samples')
		{
			if (this.showAddSample) { tmpCols.push({ Key: 'Action', Label: '', Align: 'center', NoSort: true, NoPrint: true }); }
			tmpCols.push({ Key: 'Units', Label: 'Units', Align: 'left' });
			tmpCols.push({ Key: 'SampleType', Label: 'Type', Align: 'center' });
			tmpCols.push({ Key: 'Rate', Label: 'Rate', Align: 'right', Clean: true });
			tmpCols.push({ Key: 'Frequency', Label: 'Frequency', Align: 'right', Clean: true });
			tmpCols.push({ Key: 'ConversionFactor', Label: 'Conversion Factor', Align: 'right', Clean: true });
			tmpCols.push({ Key: 'ApprovedSourceRequired', Label: 'Approved Source', Align: 'center', Bool: true, NoSort: true });
			tmpCols.push({ Key: 'SpecialInstructions', Label: 'Special Instructions', Align: 'left', Flex: true, Wrap: true, Text: true });
			return tmpCols;
		}
		// SamplePlan
		if (this.showAddSample) { tmpCols.push({ Key: 'Action', Label: '', Align: 'center', NoSort: true, NoPrint: true }); }
		tmpCols.push({ Key: 'Material', Label: 'Material', Align: 'left', Flex: true });
		tmpCols.push({ Key: 'SampleType', Label: 'Type', Align: 'center' });
		tmpCols.push({ Key: 'Rate', Label: 'Rate', Align: 'right', Clean: true });
		tmpCols.push({ Key: 'Frequency', Label: 'Frequency', Align: 'right', Clean: true });
		tmpCols.push({ Key: 'BidQuantity', Label: 'Bid Qty.', Align: 'right', Clean: true });
		tmpCols.push({ Key: 'InstalledQuantity', Label: 'Installed Qty.', Align: 'right', Number: true });
		tmpCols.push({ Key: 'PlannedSampleCount', Label: 'Planned Samples', Align: 'right', Number: true });
		tmpCols.push({ Key: 'RequiredSampleCount', Label: 'Req. Samples', Align: 'right', Number: true });
		return tmpCols;
	}

	// --- Render (host-div paint) ---

	render()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpSel = this._mount || '#SamplePlanDashboard-Host';
		if (!tmpCA || tmpCA.getElement(tmpSel).length === 0) { return; }
		tmpCA.assignContent(tmpSel, this._shellHTML());
		this._paintTable();
	}
	// Full screen: overlay the dashboard across the whole browser view (above the app nav). State is a provider field so it
	// survives the shell rebuild; `.spd-fs` composites on its own layer (CSS transform) so it paints immediately. Standalone
	// only (embed offers a pop-out to this standalone route instead). Navigating away replaces the host → overlay torn down.
	toggleFullscreen() { if (this.isEmbedded) { return; } this._fullscreen = !this._fullscreen; this.render(); }

	_shellHTML()
	{
		const tmpState = this.state;
		const tmpCount = tmpState.RowCount || 0;
		const tmpTabs = this.presets.map((pPreset) =>
		{
			const tmpActive = (pPreset.Key === this._preset) ? ' spd-tab-active' : '';
			return `<button class="spd-tab${tmpActive}" onclick="_Pict.providers.${this.providerName}.setPreset('${pPreset.Key}')"><i class="fas ${pPreset.Icon}"></i> ${this._esc(pPreset.Label)}</button>`;
		}).join('');
		return /*html*/`
			<div class="spd${this._fullscreen ? ' spd-fullscreen' : ''}">
				<div class="spd-head">
					<div class="spd-title"><i class="fas fa-clipboard-check"></i> Material LineItem Samples</div>
					<div class="spd-headright"><span class="spd-count" id="spd-count">${tmpCount}</span></div>
				</div>
				<div class="spd-tabs">${tmpTabs}</div>
				${this._preset === 'Custom' ? this._customControlsHTML() : ''}
				<div class="spd-toolbar">
					<span class="spd-search"><i class="fas fa-search spd-search-ic"></i><input class="spd-search-input" type="search" placeholder="${this._esc(this.activePreset.SearchPlaceholder || 'Filter…')}" value="${this._esc(this._search)}" oninput="_Pict.providers.${this.providerName}.setSearch(this.value)" /></span>
					<button class="spd-print" title="Print / save as PDF" onclick="_Pict.providers.${this.providerName}.print()"><i class="fas fa-print"></i> Print</button>
					${this.isEmbedded
						? `<a class="spd-popout" title="Open this dashboard full screen" href="#/SamplePlanDashboard/${Number(this._idProject)}"><i class="fas fa-up-right-and-down-left-from-center"></i> Full screen</a>`
						: `<button class="spd-fullscreen-btn${this._fullscreen ? ' spd-fullscreen-btn-on' : ''}" title="${this._fullscreen ? 'Exit full screen (Esc)' : 'Full screen'}" onclick="_Pict.providers.${this.providerName}.toggleFullscreen()"><i class="fas ${this._fullscreen ? 'fa-compress' : 'fa-expand'}"></i> ${this._fullscreen ? 'Exit full screen' : 'Full screen'}</button>`}
				</div>
				<div class="spd-printhead" id="spd-printhead">${this._esc(this.state.ProjectName || '')} — ${this._esc(this.activePreset.Label)}</div>
				<div id="spd-table"></div>
			</div>`;
	}

	/** The Custom preset's controls: a grouping selector + a collapsible column chooser. */
	_customControlsHTML()
	{
		const tmpProv = `_Pict.providers.${this.providerName}`;
		const tmpGroupBtns = SamplePlanDashboardProvider.CUSTOM_GROUPS.map((pGroup) =>
		{
			const tmpActive = (pGroup.Key === this._customGroup) ? ' spd-cg-active' : '';
			return `<button class="spd-cg${tmpActive}" onclick="${tmpProv}.setCustomGroup('${pGroup.Key}')">${this._esc(pGroup.Label)}</button>`;
		}).join('');
		const tmpChecks = SamplePlanDashboardProvider.CUSTOM_COLUMN_CATALOG.map((pCol) =>
		{
			const tmpChecked = (this._customColumns.indexOf(pCol.Key) >= 0) ? ' checked' : '';
			return `<label class="spd-colpick"><input type="checkbox"${tmpChecked} onchange="${tmpProv}.toggleCustomColumn('${pCol.Key}')" /> ${this._esc(pCol.Label)}</label>`;
		}).join('');
		return /*html*/`
			<div class="spd-custom">
				<div class="spd-custom-row"><span class="spd-custom-label">Group by</span><div class="spd-cg-bar">${tmpGroupBtns}</div></div>
				<details class="spd-custom-cols">
					<summary><i class="fas fa-table-columns"></i> Columns <span class="spd-custom-count">${this._customColumns.length}</span></summary>
					<div class="spd-colgrid">${tmpChecks}</div>
				</details>
			</div>`;
	}

	/** Repaint ONLY the table region (keeps the search input + its focus intact across search/sort). */
	_paintTable()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpSel = this._mount || '#SamplePlanDashboard-Host';
		if (!tmpCA || tmpCA.getElement(`${tmpSel} #spd-table`).length === 0) { return; }
		tmpCA.assignContent(`${tmpSel} #spd-table`, this._tableHTML());
		if (tmpCA.getElement(`${tmpSel} #spd-count`).length > 0) { tmpCA.assignContent(`${tmpSel} #spd-count`, String(this._visibleRowCount())); }
	}

	_visibleRowCount() { return this._computeView().reduce((pSum, pSection) => pSum + pSection.RowCount, 0); }

	_tableHTML()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return `<div class="spd-empty"><span class="spd-spinner"></span> Loading…</div>`; }
		if (tmpState.Error) { return `<div class="spd-empty spd-error">${this._esc(tmpState.Error)}</div>`; }
		if (!tmpState.Loaded) { return `<div class="spd-empty">Choose a project to view its sample plan.</div>`; }

		const tmpView = this._computeView();
		if (tmpView.length === 0)
		{
			if (this._search.trim())
			{
				return `<div class="spd-empty">No results matching <span class="spd-term">${this._esc(this._search)}</span> <button class="spd-clear" title="Clear filter" onclick="_Pict.providers.${this.providerName}.setSearch('')"><i class="fas fa-times"></i></button></div>`;
			}
			return `<div class="spd-empty">${this._esc(this.activePreset.EmptyText || 'Nothing to display for this project.')}</div>`;
		}
		// ONE full-width table: line-item / material banners are full-span rows interleaved with their data rows, so every
		// column aligns across the whole grid and there is at most a single (page-level) scroll — never a per-section box.
		const tmpCols = this._columns();
		const tmpHead = tmpCols.map((pCol) => this._headCellHTML(pCol)).join('');
		const tmpBody = tmpView.map((pSection) => this._sectionHTML(pSection, tmpCols)).join('');
		return /*html*/`
			<div class="spd-tablewrap">
				<table class="spd-grid">
					<thead><tr>${tmpHead}</tr></thead>
					<tbody>${tmpBody}</tbody>
				</table>
			</div>`;
	}

	/** A section = optional line-item banner + its groups (each an optional material sub-banner + rows). */
	_sectionHTML(pSection, pCols)
	{
		let tmpHTML = '';
		if (pSection.Banner)
		{
			const tmpCode = pSection.Banner.Code ? `<span class="spd-li-code">${this._esc(pSection.Banner.Code)}</span>` : '';
			tmpHTML += `<tr class="spd-li-row"><td class="spd-li-cell" colspan="${pCols.length}"><div class="spd-li-inner"><span class="spd-li-ic"><i class="fas fa-folder"></i></span><span class="spd-li-name">${this._esc(pSection.Banner.Name)}</span>${tmpCode}<span class="spd-li-badge">${pSection.RowCount}</span></div></td></tr>`;
		}
		pSection.Groups.forEach((pGroup) =>
		{
			if (pGroup.Banner)
			{
				const tmpCode = pGroup.Banner.Code ? `<span class="spd-mat-code">${this._esc(pGroup.Banner.Code)}</span>` : '';
				tmpHTML += `<tr class="spd-mat-row"><td class="spd-mat-cell" colspan="${pCols.length}"><div class="spd-mat-inner"><span class="spd-mat-ic"><i class="fas fa-layer-group"></i></span><span class="spd-mat-name">${this._esc(pGroup.Banner.Name)}</span>${tmpCode}<span class="spd-mat-badge">${pGroup.Rows.length}</span></div></td></tr>`;
			}
			tmpHTML += pGroup.Rows.map((pRow) => this._rowHTML(pRow, pCols)).join('');
		});
		return tmpHTML;
	}

	_headCellHTML(pCol)
	{
		const tmpCls = `spd-th spd-${pCol.Align}${pCol.Flex ? ' spd-flex' : ''}${pCol.NoPrint ? ' spd-noprint' : ''}`;
		const tmpArrow = (this._sortBy === pCol.Key) ? ` <i class="fas fa-caret-${this._sortDesc ? 'down' : 'up'}"></i>` : '';
		if (pCol.NoSort) { return `<th class="${tmpCls}">${pCol.Label}</th>`; }
		return `<th class="${tmpCls} spd-sortable" onclick="_Pict.providers.${this.providerName}.setSort('${pCol.Key}')">${pCol.Label}${tmpArrow}</th>`;
	}

	_rowHTML(pRow, pCols)
	{
		return `<tr class="spd-row">${pCols.map((pCol) => this._cellHTML(pRow, pCol)).join('')}</tr>`;
	}

	_cellHTML(pRow, pCol)
	{
		const tmpCls = `spd-td spd-${pCol.Align}${pCol.Flex ? ' spd-flex' : ''}${pCol.Wrap ? ' spd-wrap' : ''}${pCol.NoPrint ? ' spd-noprint' : ''}`;
		if (pCol.Key === 'Action')
		{
			return `<td class="${tmpCls} spd-action spd-noprint"><button class="spd-newbtn" onclick="_Pict.providers.${this.providerName}.addSampleForRow(${Number(pRow.IDLineItem)}, ${Number(pRow.IDMaterial)}, '${this._esc(pRow.SampleType)}')"><i class="fas fa-plus"></i> New Sample</button></td>`;
		}
		if (pCol.Key === 'Material')
		{
			const tmpChip = pRow.MaterialCode ? `<span class="spd-matcode">${this._esc(pRow.MaterialCode)}</span>` : '';
			return `<td class="${tmpCls} spd-material"><span class="spd-matname">${this._esc(pRow.MaterialName)}</span>${tmpChip}</td>`;
		}
		if (pCol.Key === 'Name')   // Failing Samples: QR code + sample name (two lines)
		{
			const tmpQR = pRow.QRCode ? `<span class="spd-fs-qr">${this._esc(pRow.QRCode)}</span>` : '';
			const tmpName = pRow.Name ? `<span class="spd-fs-name">${this._esc(pRow.Name)}</span>` : '';
			return `<td class="${tmpCls} spd-fs-namecell">${tmpQR}${tmpName || (tmpQR ? '' : '<span class="spd-muted">—</span>')}</td>`;
		}
		if (pCol.Key === 'Disposition')
		{
			if (this._editingSample && (this._editingSample === pRow.IDSample))
			{
				return `<td class="${tmpCls}"><textarea id="spd-dispo-input-${Number(pRow.IDSample)}" class="spd-dispo-input" rows="2" placeholder="Enter a disposition for this failing sample…">${this._esc(pRow.Disposition || '')}</textarea></td>`;
			}
			const tmpNote = pRow.Disposition;
			if (tmpNote == null || tmpNote === '') { return `<td class="${tmpCls}"><span class="spd-dispo-empty">No disposition recorded</span></td>`; }
			return `<td class="${tmpCls}">${this._esc(tmpNote)}</td>`;
		}
		if (pCol.Key === 'DispositionAction')
		{
			const tmpID = Number(pRow.IDSample);
			const tmpProv = `_Pict.providers.${this.providerName}`;
			if (this._savingSample === pRow.IDSample) { return `<td class="${tmpCls} spd-dispo-actions spd-noprint"><span class="spd-spinner"></span></td>`; }
			if (this._editingSample === pRow.IDSample)
			{
				return `<td class="${tmpCls} spd-dispo-actions spd-noprint"><button class="spd-btn spd-btn-save" onclick="${tmpProv}.saveDisposition(${tmpID})">Save</button><button class="spd-btn spd-btn-ghost" onclick="${tmpProv}.cancelDisposition()">Cancel</button></td>`;
			}
			const tmpHasNote = !!(pRow.Disposition && String(pRow.Disposition).length);
			const tmpEdit = `<button class="spd-btn${tmpHasNote ? ' spd-btn-ghost' : ' spd-btn-warn'}" onclick="${tmpProv}.editDisposition(${tmpID})">${tmpHasNote ? 'Edit' : 'Add disposition'}</button>`;
			const tmpDel = tmpHasNote ? `<button class="spd-btn spd-btn-del" title="Clear disposition" onclick="${tmpProv}.deleteDisposition(${tmpID})"><i class="fas fa-trash"></i></button>` : '';
			return `<td class="${tmpCls} spd-dispo-actions spd-noprint">${tmpEdit}${tmpDel}</td>`;
		}
		if (pCol.Bool)
		{
			return pRow[pCol.Key]
				? `<td class="${tmpCls}"><i class="fas fa-check-square spd-ok"></i></td>`
				: `<td class="${tmpCls} spd-muted"><i class="far fa-square"></i></td>`;
		}
		if (pCol.Number)
		{
			const tmpVal = this._num(pRow[pCol.Key]);
			return `<td class="${tmpCls}${this._isZero(pRow[pCol.Key]) ? ' spd-muted' : ''}">${tmpVal === '' ? '—' : this._esc(tmpVal)}</td>`;
		}
		if (pCol.Clean)
		{
			// Numeric-ish rate/frequency/quantity — strip trailing zeros (1000.00000 → 1000), else N/A.
			const tmpN = parseFloat(pRow[pCol.Key]);
			if (Number.isFinite(tmpN)) { return `<td class="${tmpCls}${tmpN === 0 ? ' spd-muted' : ''}">${this._esc(String(tmpN))}</td>`; }
			return `<td class="${tmpCls} spd-muted">N/A</td>`;
		}
		const tmpRaw = pRow[pCol.Key];
		const tmpText = (tmpRaw == null || tmpRaw === '') ? 'N/A' : String(tmpRaw);
		return `<td class="${tmpCls}${(tmpRaw == null || tmpRaw === '') ? ' spd-muted' : ''}">${this._esc(tmpText)}</td>`;
	}

	// --- Standalone-screen project selection (front door) ---

	/** The router pushes the route's :IDProject here; the standalone view reads it in onAfterRender to open the dashboard. */
	setRouteProject(pIDProject) { this._routeIDProject = Number(pIDProject) || 0; }
	get routeProject() { return this._routeIDProject || 0; }

	/** Picker chose a project → navigate to the shareable per-project route (the router opens the dashboard). */
	selectProject(pIDProject)
	{
		const tmpID = Number(pIDProject) || 0;
		if (tmpID) { try { window.location.hash = `#/SamplePlanDashboard/${tmpID}`; } catch (pError) { this.openInto(tmpID, this._mount); } }
	}

	_projectDataProvider()
	{
		return libEntityPickerSearch.entityPickerDataProvider((pURL) => this._getJSON(pURL),
			{
				Set: 'Projects/Lite', IDField: 'IDProject',
				ToOption: (pRow) => ({ Value: Number(pRow.IDProject), Text: pRow.Value || pRow.Name || pRow.Description || `Project ${pRow.IDProject}`, Record: pRow }),
			});
	}

	_projectResolveValue()
	{
		return (pValue) => { const tmpID = Number(pValue); if (!tmpID) { return Promise.resolve(null); } return this._getJSON(`Project/${tmpID}`).then((pRow) => ((pRow && pRow.IDProject) ? { Value: tmpID, Text: pRow.Name || pRow.Description || `#${tmpID}` } : { Value: tmpID, Text: `#${tmpID}` })).catch(() => ({ Value: tmpID, Text: `#${tmpID}` })); };
	}

	/** Mount the searchable project picker into the standalone view's host (idempotent per render). */
	mountProjectPicker(pHostSelector)
	{
		const tmpPicker = this.pict.providers && this.pict.providers['Pict-Section-Picker'];
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		if (tmpCA.getElement(pHostSelector).length === 0) { return; }
		const tmpView = tmpPicker.createPicker(`${this.providerName}-ProjectPicker`,
			{
				DestinationAddress: pHostSelector,
				ValueAddress: `AppData.${this.providerName}.PickerProjectID`,
				Searchable: true, AllowClear: true, ClearLabel: '— pick a project —', Placeholder: 'Search projects…',
				DataProvider: this._projectDataProvider(), ResolveValue: this._projectResolveValue(),
				OnChange: (pValue) => this.selectProject(pValue),
			});
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
		if (tmpView && (typeof tmpView.setValue === 'function')) { tmpView.setValue(this._idProject || ''); }
	}

	/** Re-render the standalone view (when embedded, the host repaints via its own onAfterRender). */
	_renderStandaloneView() { if (this.pict.views[this.providerName]) { this.pict.views[this.providerName].render(); } }
}

module.exports = SamplePlanDashboardProvider;

/** The minimal SamplePlanBundle parts every preset needs — a single lean streamed request (see loadAsync). */
SamplePlanDashboardProvider.BUNDLE_PARTS = ['Project', 'LineItems', 'MaterialLineItemJoins', 'Materials', 'ProjectLineItemMaterialTests'];

/** The preset tabs (order + icons mirror the legacy dashboard.json Presets, by Ordinal). */
SamplePlanDashboardProvider.PRESETS =
[
	{ Key: 'SamplePlan', Label: 'Sample Plan', Icon: 'fa-tasks', DefaultSort: 'Material', NeedsSamples: false, SearchPlaceholder: 'Filter by line item, material, type, or units…', EmptyText: 'No planned samples for this project.' },
	{ Key: 'Samples', Label: 'Samples', Icon: 'fa-vials', DefaultSort: 'SampleType', NeedsSamples: false, SearchPlaceholder: 'Filter by line item, material, type, or units…', EmptyText: 'No sample types for this project.' },
	{ Key: 'FailingSamples', Label: 'Failing Samples', Icon: 'fa-triangle-exclamation', DefaultSort: 'Name', NeedsSamples: true, SearchPlaceholder: 'Filter by sample, material, type, or disposition…', EmptyText: 'No failing samples for this project.' },
	{ Key: 'Custom', Label: 'Custom', Icon: 'fa-sliders', DefaultSort: 'Material', NeedsSamples: true, SearchPlaceholder: 'Filter by line item, material, type, or units…', EmptyText: 'No data for this project.' },
];

/** The Custom preset's full column catalog (order = render order); the chooser toggles membership in _customColumns. */
SamplePlanDashboardProvider.CUSTOM_COLUMN_CATALOG =
[
	{ Key: 'LineItem', Label: 'Line Item', Align: 'left', Banner: 'lineitem' },
	{ Key: 'ItemCode', Label: 'Pay Item Code', Align: 'left', Banner: 'lineitem' },
	{ Key: 'Material', Label: 'Material', Align: 'left', Banner: 'material' },
	{ Key: 'MaterialCode', Label: 'Material Code', Align: 'left', Banner: 'material' },
	{ Key: 'Units', Label: 'Units', Align: 'left' },
	{ Key: 'SampleType', Label: 'Type', Align: 'center' },
	{ Key: 'Rate', Label: 'Rate', Align: 'right', Clean: true },
	{ Key: 'Frequency', Label: 'Frequency', Align: 'right', Clean: true },
	{ Key: 'ConversionFactor', Label: 'Conversion Factor', Align: 'right', Clean: true },
	{ Key: 'BidQuantity', Label: 'Bid Qty.', Align: 'right', Clean: true },
	{ Key: 'InstalledQuantity', Label: 'Installed Qty.', Align: 'right', Number: true },
	{ Key: 'PlannedSampleCount', Label: 'Planned Samples', Align: 'right', Number: true },
	{ Key: 'RequiredSampleCount', Label: 'Req. Samples', Align: 'right', Number: true },
	{ Key: 'CreatedSamples', Label: 'Created Samples', Align: 'right', Number: true },
	{ Key: 'PassingSamples', Label: 'Passing Samples', Align: 'right', Number: true },
	{ Key: 'FailingSamples', Label: 'Failing Samples', Align: 'right', Number: true },
	{ Key: 'ApprovedSourceRequired', Label: 'Approved Source', Align: 'center', Bool: true, NoSort: true },
	{ Key: 'SpecialInstructions', Label: 'Special Instructions', Align: 'left', Text: true },
];

/** Custom preset — the columns shown before the user customizes (mirrors dashboard.json Presets.Custom None DefaultValues). */
SamplePlanDashboardProvider.CUSTOM_DEFAULT_COLUMNS =
	['Units', 'SampleType', 'Rate', 'Frequency', 'ConversionFactor', 'BidQuantity', 'InstalledQuantity', 'PlannedSampleCount', 'RequiredSampleCount', 'CreatedSamples', 'PassingSamples', 'FailingSamples', 'ApprovedSourceRequired', 'SpecialInstructions'];

/** Custom preset — the grouping options (mirror dashboard.json Presets.Custom Groups). */
SamplePlanDashboardProvider.CUSTOM_GROUPS =
[
	{ Key: 'None', Label: 'None' },
	{ Key: 'LineItem', Label: 'Line Item' },
	{ Key: 'LineItemMaterial', Label: 'Line Item + Material' },
	{ Key: 'Material', Label: 'Material' },
];

module.exports.default_configuration =
{
	ProviderIdentifier: 'SamplePlanDashboard',
};

const _CSS = /*css*/`
	/* Fill the container. Width comes from the host: the app-shell Dashboard Mode makes the standalone screen full
	   browser width; embedded in a workspace tab it fills the workspace content width. */
	.spd { width: 100%; }
	.spd-head { display: flex; align-items: center; justify-content: space-between; gap: 0.8rem; margin: 0 0 0.6rem; }
	.spd-title { font-size: 1.05rem; font-weight: 700; color: var(--theme-color-text-primary,#1f2733); display: inline-flex; align-items: center; gap: 0.5rem; }
	.spd-title i { color: var(--theme-color-brand-primary,#2e7d74); }
	.spd-count { display: inline-block; min-width: 1.6rem; text-align: center; font-size: 0.78rem; font-weight: 700; color: #fff; background: var(--theme-color-text-secondary,#45505f); border-radius: 999px; padding: 0.12rem 0.55rem; }

	/* Preset tab pills */
	.spd-tabs { display: flex; flex-wrap: wrap; gap: 0.35rem; margin: 0 0 0.85rem; border-bottom: 1px solid var(--theme-color-border-light,#e8ebf0); padding-bottom: 0.55rem; }
	.spd-tab { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border: 1px solid transparent; border-radius: 7px; padding: 0.34rem 0.75rem; cursor: pointer; }
	.spd-tab i { font-size: 0.8rem; opacity: 0.85; }
	.spd-tab:hover { background: var(--theme-color-background-tertiary,#e3e8f0); }
	.spd-tab-active { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); }
	.spd-tab-active:hover { background: var(--theme-color-brand-primary,#2e7d74); filter: brightness(0.97); }

	/* Custom preset controls */
	.spd-custom { margin: 0 0 0.85rem; padding: 0.7rem 0.8rem; background: var(--theme-color-background-secondary,#f4f6f9); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 9px; }
	.spd-custom-row { display: flex; align-items: center; gap: 0.7rem; flex-wrap: wrap; }
	.spd-custom-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#7a8794); }
	.spd-cg-bar { display: inline-flex; gap: 0.3rem; flex-wrap: wrap; }
	.spd-cg { font-size: 0.8rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 6px; padding: 0.28rem 0.65rem; cursor: pointer; }
	.spd-cg:hover { background: var(--theme-color-background-tertiary,#eef1f6); }
	.spd-cg-active { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-color: var(--theme-color-brand-primary,#2e7d74); }
	.spd-cg-active:hover { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); filter: brightness(0.97); }
	.spd-custom-cols { margin-top: 0.6rem; }
	.spd-custom-cols > summary { cursor: pointer; font-size: 0.8rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); list-style: none; display: inline-flex; align-items: center; gap: 0.4rem; user-select: none; }
	.spd-custom-cols > summary::-webkit-details-marker { display: none; }
	.spd-custom-count { min-width: 1.4rem; text-align: center; font-size: 0.7rem; font-weight: 700; color: #fff; background: var(--theme-color-text-secondary,#45505f); border-radius: 999px; padding: 0.04rem 0.45rem; }
	.spd-colgrid { display: grid; grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr)); gap: 0.25rem 0.9rem; margin-top: 0.6rem; }
	.spd-colpick { display: flex; align-items: center; gap: 0.4rem; font-size: 0.8rem; color: var(--theme-color-text-primary,#1f2733); cursor: pointer; }
	.spd-colpick input { cursor: pointer; }

	.spd-toolbar { display: flex; align-items: center; gap: 0.6rem; margin: 0 0 0.9rem; }
	.spd-search { position: relative; display: inline-block; flex: 1 1 auto; max-width: 26rem; }
	.spd-search-ic { position: absolute; left: 0.6rem; top: 50%; transform: translateY(-50%); color: var(--theme-color-text-muted,#9aa3af); font-size: 0.8rem; }
	.spd-search-input { width: 100%; font-size: 0.86rem; padding: 0.4rem 0.6rem 0.4rem 1.9rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; background: var(--theme-color-background-input,#fff); color: var(--theme-color-text-primary,#1f2733); }
	.spd-empty { padding: 2.4rem 1rem; text-align: center; color: var(--theme-color-text-muted,#8a94a3); font-size: 0.9rem; }
	.spd-empty.spd-error { color: var(--theme-color-status-danger,#c0392b); }
	.spd-term { font-weight: 600; background: var(--theme-color-background-secondary,#eef1f6); border-radius: 5px; padding: 0.05rem 0.4rem; color: var(--theme-color-text-secondary,#45505f); }
	.spd-clear { border: none; background: transparent; color: var(--theme-color-text-muted,#98a2b3); cursor: pointer; }
	.spd-clear:hover { color: var(--theme-color-status-danger,#c0392b); }
	.spd-spinner { display: inline-block; width: 1rem; height: 1rem; border: 2px solid var(--theme-color-border-medium,#d5dbe3); border-top-color: var(--theme-color-brand-primary,#2e7d74); border-radius: 50%; animation: spd-spin 0.7s linear infinite; vertical-align: -2px; }
	@keyframes spd-spin { to { transform: rotate(360deg); } }

	/* Default (embedded in a workspace tab): the table's own horizontal scroll is CONTAINED here, so a wide grid never
	   blows off the side of the workspace — it scrolls inside this box, and a "Full screen" pop-out opens the full-width
	   dashboard. In Dashboard Mode (full-width standalone screen) this is overridden to overflow:visible so the WINDOW is
	   the scroller and the column header can stick to the viewport (see .is-dashboard rules below). */
	.spd-tablewrap { width: 100%; overflow-x: auto; background: var(--theme-color-background-primary,#fff); border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 9px; }
	.spd-grid { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.85rem; table-layout: auto; }

	/* Line-item banner (full-span row) */
	.spd-li-cell { padding: 0; background: #c9f5f3; border-top: 6px solid var(--theme-color-background-primary,#fff); }
	.spd-li-row:first-child .spd-li-cell { border-top: none; }
	.spd-li-inner { display: flex; align-items: center; gap: 0.55rem; padding: 0.4rem 0.85rem; }
	.spd-li-ic { display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 5px; background: #63b8b4; color: #fff; font-size: 0.72rem; flex: 0 0 auto; }
	.spd-li-name { font-weight: 700; color: #2c6f6b; font-size: 0.9rem; }
	.spd-li-code { font-size: 0.68rem; font-weight: 700; color: #2c6f6b; background: rgba(255,255,255,0.6); border-radius: 5px; padding: 0.05rem 0.4rem; }
	.spd-li-badge { margin-left: auto; min-width: 1.5rem; text-align: center; font-size: 0.72rem; font-weight: 700; color: #2c6f6b; background: rgba(255,255,255,0.7); border-radius: 999px; padding: 0.06rem 0.5rem; }

	/* Material sub-banner (full-span row, nested under a line item) */
	.spd-mat-cell { padding: 0; background: #fdeceb; border-top: 1px solid #f6d9d7; }
	.spd-mat-inner { display: flex; align-items: center; gap: 0.5rem; padding: 0.32rem 0.85rem 0.32rem 1.6rem; }
	.spd-mat-ic { display: inline-flex; align-items: center; justify-content: center; width: 19px; height: 19px; border-radius: 5px; background: #e37e7b; color: #fff; font-size: 0.64rem; flex: 0 0 auto; }
	.spd-mat-name { font-weight: 700; color: #ad4744; font-size: 0.82rem; }
	.spd-mat-code { font-size: 0.66rem; font-weight: 700; color: #ad4744; background: rgba(255,255,255,0.7); border: 1px solid #e37e7b; border-radius: 5px; padding: 0.02rem 0.4rem; }
	.spd-mat-badge { margin-left: auto; min-width: 1.4rem; text-align: center; font-size: 0.7rem; font-weight: 700; color: #ad4744; background: rgba(255,255,255,0.75); border-radius: 999px; padding: 0.04rem 0.5rem; }

	.spd-th { z-index: 3; text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#6b7686); background: var(--theme-color-background-tertiary,#f4f6f9); padding: 0.45rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-medium,#d5dbe3); box-shadow: 0 1px 0 var(--theme-color-border-light,#e8ebf0); white-space: nowrap; }
	/* Dashboard Mode (full-width standalone): the window is the scroller, so the grid grows down the page naturally and
	   the column header sticks below the app's fixed 3.25rem top navbar. (Embedded, the table box scrolls instead.) */
	.is-dashboard .spd-tablewrap { overflow: visible; }
	.is-dashboard .spd-th { position: sticky; top: 3.25rem; }
	/* Standalone: the chrome is inset by the page gutter (.spd-page), but the wide grid full-bleeds back to the browser
	   edges so it still uses the whole width. Scoped to .spd-page so the embedded copy (no .spd-page ancestor) is untouched. */
	.spd-page .spd-tablewrap { margin-left: calc(-1 * var(--spd-gutter)); margin-right: calc(-1 * var(--spd-gutter)); border-left: none; border-right: none; border-radius: 0; }
	.spd-th.spd-sortable { cursor: pointer; user-select: none; }
	.spd-th.spd-sortable:hover { color: var(--theme-color-text-secondary,#45505f); }
	.spd-td { padding: 0.45rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light,#eef1f5); color: var(--theme-color-text-primary,#1f2733); white-space: nowrap; vertical-align: top; }
	.spd-left { text-align: left; } .spd-right { text-align: right; font-variant-numeric: tabular-nums; } .spd-center { text-align: center; }
	.spd-muted { color: var(--theme-color-text-muted,#9aa3af); }
	.spd-ok { color: #2f9e6f; }

	/* The one "flex" column per preset absorbs slack and wraps, so the grid fills the browser width without a scroll. */
	.spd-th.spd-flex { width: 40%; }
	.spd-td.spd-flex { white-space: normal; min-width: 12rem; }
	.spd-td.spd-wrap { white-space: normal; }
	.spd-material .spd-matname { font-weight: 600; }
	.spd-matcode { display: inline-block; margin-left: 0.5rem; font-size: 0.68rem; font-weight: 700; color: #ad4744; border: 1px solid #e37e7b; border-radius: 5px; padding: 0.02rem 0.4rem; }
	.spd-fs-namecell .spd-fs-qr { display: block; font-weight: 700; font-family: var(--theme-font-family-mono,ui-monospace,SFMono-Regular,Menlo,monospace); font-size: 0.82rem; color: var(--theme-color-text-primary,#1f2733); }
	.spd-fs-namecell .spd-fs-name { display: block; font-size: 0.78rem; color: var(--theme-color-text-muted,#6b7686); }
	.spd-dispo-empty { color: var(--theme-color-text-muted,#9aa3af); font-style: italic; }
	.spd-action { width: 1%; }
	.spd-newbtn { display: inline-flex; align-items: center; gap: 0.3rem; white-space: nowrap; font-size: 0.76rem; font-weight: 600; color: #7a5b12; background: #efc865; border: none; border-radius: 6px; padding: 0.25rem 0.55rem; cursor: pointer; }
	.spd-newbtn:hover { filter: brightness(0.96); }

	/* Print button */
	.spd-print, .spd-popout, .spd-fullscreen-btn { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.82rem; font-weight: 600; color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 7px; padding: 0.36rem 0.7rem; cursor: pointer; text-decoration: none; white-space: nowrap; }
	.spd-print:hover, .spd-popout:hover, .spd-fullscreen-btn:hover { background: var(--theme-color-background-tertiary,#e3e8f0); }
	.spd-fullscreen-btn-on { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); border-color: var(--theme-color-brand-primary,#2e7d74); }
	.spd-fullscreen-btn-on:hover { color: #fff; background: var(--theme-color-brand-primary,#2e7d74); filter: brightness(1.05); }
	/* Full-screen overlay: fills the whole browser view above the app nav (top navbar z-index 30, bottom bar 1050). The page
	   gutter var cascades in, and 'transform' composites the layer from creation so it paints immediately. */
	.spd.spd-fullscreen { position: fixed; inset: 0; z-index: 1100; overflow: auto; background: var(--theme-color-background-tertiary,#f3f4f6); padding: 1.1rem var(--spd-gutter, 2rem) 1.6rem; transform: translateZ(0); }

	/* Disposition inline editor (Failing Samples) */
	.spd-dispo-input { width: 100%; min-width: 12rem; font-size: 0.82rem; font-family: inherit; padding: 0.35rem 0.5rem; border: 1px solid var(--theme-color-border-medium,#d5dbe3); border-radius: 6px; resize: vertical; box-sizing: border-box; }
	.spd-dispo-actions { width: 1%; white-space: nowrap; }
	.spd-btn { font-size: 0.74rem; font-weight: 600; border: 1px solid transparent; border-radius: 6px; padding: 0.22rem 0.55rem; margin-left: 0.3rem; cursor: pointer; white-space: nowrap; }
	.spd-btn:first-child { margin-left: 0; }
	.spd-btn-warn { color: #7a5b12; background: #efc865; }
	.spd-btn-save { color: #fff; background: #2f9e6f; }
	.spd-btn-ghost { color: var(--theme-color-text-secondary,#45505f); background: var(--theme-color-background-secondary,#eef1f6); border-color: var(--theme-color-border-medium,#d5dbe3); }
	.spd-btn-del { color: #fff; background: #c0605d; }
	.spd-btn:hover { filter: brightness(0.96); }

	/* Print head — shown only when printing */
	.spd-printhead { display: none; }

	@media print {
		body:where(:has(#SamplePlanDashboard-Host)) * { visibility: hidden !important; }
		#SamplePlanDashboard-Host, #SamplePlanDashboard-Host * { visibility: visible !important; }
		#SamplePlanDashboard-Host { position: absolute; left: 0; top: 0; width: 100%; }
		.spd-head, .spd-tabs, .spd-toolbar, .spd-noprint { display: none !important; }
		.spd-printhead { display: block !important; visibility: visible !important; font-size: 1.05rem; font-weight: 700; margin: 0 0 0.6rem; color: #000; }
		.spd-tablewrap { overflow: visible !important; border: none !important; }
		.spd-grid { font-size: 0.72rem; }
		.spd-li-cell, .spd-mat-cell { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
	}
`;

},{"../services/Entity-Picker-Search.js":1398,"pict-provider":845}],1389:[function(require,module,exports){
module.exports={
	"Form": "SampleCreateManifest",
	"InitialBundle":
	[
		{
			"Type": "Custom",
			"Protocol": "HTTPS",
			"URL": "Sample/Sequence",
			"Destination": "AppData.SampleSequence"
		}
	],
	"PickLists": [
		{
			"Hash": "CreateStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleSequence.Next": {
			"Name": "Sample Number",
			"Hash": "CreateSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "CreateDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "CreateReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "CreateSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "CreateContainer",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateContainers"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "CreateContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "CreateSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "CreateSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateCities",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-AutofillTriggerGroup"
				],
				"AutofillTriggerGroup": {
					"TriggerGroupHash": "SourceLocation",
					"SelectOptionsRefresh": true
				}
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "CreateSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"AllowCustomValues": true,
				"SelectOptionsPickList": "CreateStates",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-EntityBundleRequest",
					"Pict-Input-AutofillTriggerGroup"
				],
				"EntitiesBundle": [
					{
						"Entity": "ListDefault",
						"Filter": "FBV~Hash~EQ~{~D:Record.Value~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State",
						"Destination": "AppData.CurrentState",
						"SingleRecord": true
					},
					{
						"Entity": "ListDefaultListDefaultJoin",
						"Filter": "FBV~ScopeIDListDefault~EQ~{~D:AppData.CurrentState.IDListDefault~}",
						"Destination": "AppData.StateCityJoins"
					},
					{
						"Entity": "ListDefault",
						"Filter": "FBL~IDListDefault~INN~{~PJU:,^IDListDefault^AppData.StateCityJoins~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~City",
						"Destination": "AppData.SourceCities"
					}
				],
				"EntityBundleTriggerGroup": "SourceLocation"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "CreateSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateCountries",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "CreateLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "CreateStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "CreateMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "CreateNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample Create",
			"Hash": "SampleCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample Create",
					"Hash": "SampleCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1390:[function(require,module,exports){
module.exports={
	"Form": "SampleEditManifest",
	"PickLists": [
		{
			"Hash": "EditStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleDetails.LabControlNumber": {
			"Name": "Sample Number",
			"Hash": "EditSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "EditDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "EditReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "EditSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "EditContainer",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditContainers"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "EditContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "EditSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "EditSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditCities",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-AutofillTriggerGroup"
				],
				"AutofillTriggerGroup": {
					"TriggerGroupHash": "SourceLocation",
					"SelectOptionsRefresh": true
				}
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "EditSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditStates",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-EntityBundleRequest",
					"Pict-Input-AutofillTriggerGroup"
				],
				"EntitiesBundle": [
					{
						"Entity": "ListDefault",
						"Filter": "FBV~Hash~EQ~{~D:Record.Value~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State",
						"Destination": "AppData.CurrentState",
						"SingleRecord": true
					},
					{
						"Entity": "ListDefaultListDefaultJoin",
						"Filter": "FBV~ScopeIDListDefault~EQ~{~D:AppData.CurrentState.IDListDefault~}",
						"Destination": "AppData.StateCityJoins"
					},
					{
						"Entity": "ListDefault",
						"Filter": "FBL~IDListDefault~INN~{~PJU:,^IDListDefault^AppData.StateCityJoins~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~City",
						"Destination": "AppData.SourceCities"
					}
				],
				"EntityBundleTriggerGroup": "SourceLocation"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "EditSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditCountries",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "EditLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "EditStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "EditMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "EditNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample Edit",
			"Hash": "SampleEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample Edit",
					"Hash": "SampleEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1391:[function(require,module,exports){
module.exports={
	"Form": "SampleExtendedSchema",
	"PickLists": [
		{
			"Hash": "ViewStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "ViewLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleDetails.LabControlNumber": {
			"Name": "Sample Number",
			"Hash": "ViewSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "ViewDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "ViewReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "ViewSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "ViewContainer",
			"DataType": "String",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "ViewContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "ViewSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "ViewSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "ViewSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "ViewSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"Row": "4",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "ViewLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleView",
				"Group": "SampleView",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "ViewStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleView",
				"Group": "SampleView",
				"SelectOptionsPickList": "ViewLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "ViewMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleView",
				"Group": "SampleView"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "ViewNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleView",
				"Group": "SampleView"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample View",
			"Hash": "SampleView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample View",
					"Hash": "SampleView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}

},{}],1392:[function(require,module,exports){
module.exports={
	"Test":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"Description":
			{
				"Hash": "Description",
				"Name": "Description"
			},
			"Hash":
			{
				"Hash": "Hash",
				"Name": "Hash"
			}
		}
	},
	"Document":
	{
		"Descriptors":
		{
			"DocumentDate_Formatted":
			{
				"Hash": "DocumentDate_Formatted",
				"Name": "Date",
				"DataType": "DateTime"
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Creator"
			},
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Project":
			{
				"Hash": "_Project",
				"Name": "Project"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"StateName":
			{
				"Hash": "StateName",
				"Name": "Status Info"
			}
		}
	},
	"Project":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"Description":
			{
				"Hash": "Description",
				"Name": "Description"
			},
			"_Contract":
			{
				"Hash": "_Contract",
				"Name": "Contract"
			},
			"_Organization":
			{
				"Hash": "_Organization",
				"Name": "Contractor"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"ContractedDays":
			{
				"Hash": "ContractedDays",
				"Name": "Contracted Days",
				"DataType": "PreciseNumber"
			},
			"InitialContractAmount_Formatted":
			{
				"Hash": "InitialContractAmount",
				"Name": "Initial Contract Amount",
				"DataType": "PreciseNumber"
			},
			"CurrentTotalContractAmount_Formatted":
			{
				"Hash": "CurrentTotalContractAmount",
				"Name": "Current Total Contract Amount",
				"DataType": "PreciseNumber"
			},
			"CurrentTotalContractPaid_Formatted":
			{
				"Hash": "CurrentTotalContractPaid",
				"Name": "Current Total Contract Paid",
				"DataType": "PreciseNumber"
			}
		}
	},
	"TestInstance":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Test":
			{
				"Hash": "_Test",
				"Name": "Test"
			},
			"_Lab":
			{
				"Hash": "Lab",
				"Name": "Lab"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"TestResult":
			{
				"Hash": "TestResult",
				"Name": "Test Result"
			},
			"FormStatus":
			{
				"Hash": "FormStatus",
				"Name": "Form Status"
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Created By"
			}
		}
	},
	"LineItem": 
	{
		"Descriptors":
		{
			"ItemCode":
			{
				"Hash": "ItemCode",
				"Name": "Item Code"
			},
			"ItemNumber":
			{
				"Hash": "ItemNumber",
				"Name": "Item Number"
			},
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Project":
			{
				"Hash": "_Project",
				"Name": "Project"
			},
			"_Contract":
			{
				"Hash": "_Contract",
				"Name": "Contract"
			},
			"_BidItem":
			{
				"Hash": "_BidItem",
				"Name": "Bid Item"
			},
			"_PayItem":
			{
				"Hash": "_PayItem",
				"Name": "Pay Item"
			},
			"ContractQuantity_Formatted":
			{
				"Hash": "ContractQuantity_Formatted",
				"Name": "Contract Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ChangeOrderQuantity_Formatted":
			{
				"Hash": "ChangeOrderQuantity_Formatted",
				"Name": "Change Order Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ExpectedQuantity_Formatted":
			{
				"Hash": "ExpectedQuantity_Formatted",
				"Name": "Expected Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ActualQuantity_Formatted":
			{
				"Hash": "ActualQuantity_Formatted",
				"Name": "Actual Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"InstalledQuantity_Formatted":
			{
				"Hash": "InstalledQuantity_Formatted",
				"Name": "Installed Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"CreateDate_Formatted":
			{
				"Hash": "CreateDate_Formatted",
				"Name": "Created On",
				"DataType": "DateTime",
				"HeadlightSummary":
				{
					"DateFormat": "YYYY-MM-DD"
				}
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Created By",
				"HeadlightSummary":
				{
					"DisplayFields": ["NameFirst", "NameLast"]
				}
			}
		}
	}
}

},{}],1393:[function(require,module,exports){
'use strict';

/**
 * What the sample Documents rail says about each document's media. The test logic it used to hold (test codes, the
 * tests each form declares, results, story order) is in @paviasystems/headlight-samples (SampleTest-Rules.js).
 */

/**
 * The kind of media an observation carries, or '' for none. Same precedence as
 * lib/web/media-detail-cards/source/MediaCardBuilder.js curateMediaObservationList (image over audio over video, a file
 * only when none of those); keep the two in step.
 *
 * @param {Object} pObservation
 * @return {String} 'image' | 'audio' | 'video' | 'file' | ''
 */
function getMediaKind(pObservation)
{
	const tmpDetails = (pObservation && pObservation.Details) || {};
	const fHas = (pKey) => !!(tmpDetails[pKey] && tmpDetails[pKey][0] && (String(tmpDetails[pKey][0].ArtifactType || '').toLowerCase() === pKey.toLowerCase()));
	if (fHas('Image'))
	{
		return 'image';
	}
	if (fHas('Audio'))
	{
		return 'audio';
	}
	if (fHas('Video'))
	{
		return 'video';
	}
	return (tmpDetails.File && tmpDetails.File[0]) ? 'file' : '';
}

/**
 * Count each document's media observations.
 *
 * @param {Array<{ IDDocument: number, IDObservation: number }>} pJoins - DocumentObservationJoin rows
 * @param {Array<Object>} pObservations - the joined observations that are not deleted
 * @return {Record<number, Record<String, number>>} IDDocument -> media kind -> count
 */
function countDocumentMedia(pJoins, pObservations)
{
	const tmpKindByObservation = {};
	for (const tmpObservation of (pObservations || []))
	{
		tmpKindByObservation[tmpObservation.IDObservation] = getMediaKind(tmpObservation);
	}
	const tmpCounts = {};
	const tmpSeen = {};
	for (const tmpJoin of (pJoins || []))
	{
		const tmpKind = tmpKindByObservation[tmpJoin.IDObservation];
		const tmpKey = `${tmpJoin.IDDocument}:${tmpJoin.IDObservation}`;
		if (!tmpKind || tmpSeen[tmpKey])
		{
			continue;
		}
		tmpSeen[tmpKey] = true;
		const tmpDocument = tmpCounts[tmpJoin.IDDocument] || (tmpCounts[tmpJoin.IDDocument] = {});
		tmpDocument[tmpKind] = (tmpDocument[tmpKind] || 0) + 1;
	}
	return tmpCounts;
}

/**
 * The photos and videos joined to some documents, each observation once, oldest first.
 *
 * @param {Array<{ IDDocument: number, IDObservation: number }>} pJoins - DocumentObservationJoin rows
 * @param {Array<Object>} pObservations - the joined observations the reader could read
 * @return {Array<{ IDObservation: number, Name: String, Kind: String, When: String }>}
 */
function listDocumentMedia(pJoins, pObservations)
{
	const tmpJoined = new Set((pJoins || []).map((pJoin) => Number(pJoin.IDObservation)));
	const tmpSeen = new Set();
	const tmpMedia = [];
	for (const tmpObservation of (pObservations || []))
	{
		const tmpID = Number(tmpObservation && tmpObservation.IDObservation);
		const tmpKind = getMediaKind(tmpObservation);
		if (!tmpJoined.has(tmpID) || tmpSeen.has(tmpID) || ((tmpKind !== 'image') && (tmpKind !== 'video')))
		{
			continue;
		}
		tmpSeen.add(tmpID);
		tmpMedia.push({ IDObservation: tmpID, Name: tmpObservation.Name || '', Kind: tmpKind, When: tmpObservation.DesignatedTime || tmpObservation.CreateDate || '' });
	}
	return tmpMedia.sort((pA, pB) => (String(pA.When).localeCompare(String(pB.When))) || (pA.IDObservation - pB.IDObservation));
}

module.exports = { getMediaKind, countDocumentMedia, listDocumentMedia };

},{}],1394:[function(require,module,exports){
'use strict';

/**
 * A page's own Scan Samples cart: opened into a host element, with either a sample it can't drop (the Sample page's
 * Location tab) or a location it can't change (a Location page's Samples tab adding samples to itself), or as a whole
 * page of its own (Scan Samples, #/ScanSamples), which keeps its settings on the device like the panels' cart.
 *
 * Each page has its own named cart instance (CartName), separate from the other page's and from the panels' Scan
 * Samples, and nothing is saved between opens: its "Save each scan" switch and location start fresh every time and
 * never touch the settings the panels' cart remembers on the device. The cart takes scans through HeadlightQR while
 * open, has the panels' camera button (the app's camera scanner, QRCodeProvider), and closes when the route leaves
 * the page's tab.
 *
 * Used by samples/SampleWorkspace-LocationTab.js, providers/LocationWorkspace-Provider.js and views/ScanSamplesPage.js.
 */

const libSampleScanning = require('headlight-sample-scanning');

/**
 * Storage that keeps nothing, so an embedded cart's switches and location never carry over to its next opening.
 * @return {{ getItem: (pKey: string) => null, setItem: () => void, removeItem: () => void }}
 */
function noStorage()
{
	return { getItem: () => null, setItem: () => null, removeItem: () => null };
}

/**
 * @typedef {Object} SampleLocationCartOptions
 * @property {() => any} Pict - the app's pict
 * @property {string} CartName - this page's own cart instance (provider, view and element prefix)
 * @property {string} HostID - the element the cart draws into
 * @property {() => string} OwnHash - the route of the page's tab; leaving it closes the cart
 * @property {(pMessage: string, pType: string) => void} Toast - the page's toast ('success' | 'error' | 'info')
 * @property {(pMove: { Location: Object, Moved: Array<Object>, Failed: Array<Object>, Via: string }) => any} [OnMoved]
 * @property {(pMark: { Received: Array<Object>, Failed: Array<Object> }) => any} [OnReceived] - Check Samples into Lab ran
 * @property {() => void} [OnLeave] - the route left the tab and the cart was closed
 * @property {Object} [Storage] - where the cart keeps its settings; default: nowhere (nothing is saved)
 * @property {boolean} [RememberSettings] - open with the stored "Save each scan" and location, as the panels' cart
 *     does, instead of collecting with no location
 * @property {(pSample: Object) => any} [PrintLabel] - adds the panels' print button to collected samples
 * @property {(pToast: { message: string, type: string }) => void} [Notify] - shows the cart's messages as they come
 *     (is-success / is-warning / ...), instead of through Toast
 */

class SampleLocationCartSession
{
	/**
	 * @param {SampleLocationCartOptions} pOptions
	 */
	constructor(pOptions)
	{
		this.options = pOptions;
		this.isOpen = false;
		this.cameraOpen = false;
		this._cameraToggling = false;
		this._onHashChange = null;
	}

	/** @return {any} */
	get pict()
	{
		return this.options.Pict();
	}

	/** @return {any} this page's cart provider, once mount has attached it */
	get cart()
	{
		return this.pict.providers[this.options.CartName];
	}

	/**
	 * Open the cart into the host, or redraw an open one into a freshly drawn host.
	 *
	 * @param {{ KeepSample?: Object, FixedLocation?: Object }} [pSetup] - a sample to preload that can't be removed, or
	 *     the only location samples can be moved into
	 */
	mount(pSetup)
	{
		const tmpDestination = `#${this.options.HostID}`;
		if (this.isOpen && this.cart)
		{
			// Redrawing the cart replaces the camera's box, so a running camera is closed first.
			this.closeCamera();
			this.cart.view.renderShell(tmpDestination);
			return;
		}
		const tmpSetup = pSetup || {};
		const tmpCart = new libSampleScanning(this.pict).attachInstance(this.options.CartName, { SampleScanning: { Storage: this.options.Storage || noStorage() } });
		const tmpHost =
		{
			notify: (pToast) => (this.options.Notify ? this.options.Notify(pToast) : this.options.Toast(pToast.message, SampleLocationCartSession.toastType(pToast.type))),
			moved: (pMove) => (this.options.OnMoved ? this.options.OnMoved(pMove) : null),
			received: (pMark) => (this.options.OnReceived ? this.options.OnReceived(pMark) : null),
			camera: { toggle: (pContainerID) => this.toggleCamera(pContainerID), isOpen: () => this.cameraOpen },
		};
		if (this.options.PrintLabel)
		{
			tmpHost.printLabel = (pSample) => this.options.PrintLabel(pSample);
		}
		tmpCart.connect(tmpHost);
		if (this.options.RememberSettings)
		{
			// As the panels' cart: the device's last "Save each scan" setting and remembered location.
			tmpCart.open({ DestinationAddress: tmpDestination });
		}
		else
		{
			// Every opening starts the same way: collecting, with no location unless the page fixes one.
			tmpCart.open({ DestinationAddress: tmpDestination, SaveEachScan: false });
			tmpCart.setLocation(null);
		}
		this.isOpen = true;
		if (tmpSetup.FixedLocation)
		{
			tmpCart.fixLocation(tmpSetup.FixedLocation);
		}
		if (tmpSetup.KeepSample)
		{
			tmpCart.keepSample(tmpSetup.KeepSample);
		}
		if (this.pict.providers.HeadlightQR)
		{
			tmpCart.listen(this.pict.providers.HeadlightQR);
		}
		this._watchForLeaving();
	}

	/** Close the cart: it stops taking scans, and its camera stops. */
	close()
	{
		this.closeCamera();
		if (this._onHashChange && (typeof window !== 'undefined'))
		{
			window.removeEventListener('hashchange', this._onHashChange);
		}
		this._onHashChange = null;
		if (this.isOpen && this.cart)
		{
			this.cart.close();
		}
		this.isOpen = false;
	}

	/** Close the cart when the route leaves the page's tab. */
	_watchForLeaving()
	{
		if ((typeof window === 'undefined') || this._onHashChange)
		{
			return;
		}
		const tmpOwnHash = this.options.OwnHash();
		this._onHashChange = () =>
		{
			if (window.location.hash !== tmpOwnHash)
			{
				this.close();
				if (this.options.OnLeave)
				{
					this.options.OnLeave();
				}
			}
		};
		window.addEventListener('hashchange', this._onHashChange);
	}

	/**
	 * The cart's camera button: open or close the app's camera scanner in the cart's camera box. What it reads
	 * reaches the cart through HeadlightQR, like a hand scanner's scans.
	 * @param {string} pContainerID
	 * @return {Promise<boolean>} whether the camera is now open
	 */
	async toggleCamera(pContainerID)
	{
		const tmpQRCode = this.pict.providers.QRCodeProvider;
		// One toggle at a time: opening the camera takes a moment.
		if (this._cameraToggling || !tmpQRCode)
		{
			return this.cameraOpen;
		}
		this._cameraToggling = true;
		this.cameraOpen = !this.cameraOpen;
		try
		{
			if (this.cameraOpen)
			{
				const tmpPanels = this.pict.services && this.pict.services.HeadlightPanels;
				await tmpQRCode.openScanner(pContainerID, { isPhoneDevice: !!(tmpPanels && tmpPanels.isPhoneDevice) });
			}
			else
			{
				await tmpQRCode.closeScanner();
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`SampleLocationCart: the camera could not be ${this.cameraOpen ? 'opened' : 'closed'}: ${(pError && pError.message) || pError}`);
			if (this.cameraOpen)
			{
				this.cameraOpen = false;
				this.options.Toast('The camera could not be opened.', 'error');
			}
		}
		this._cameraToggling = false;
		return this.cameraOpen;
	}

	/** Stop the camera scanner if the cart has it open. */
	closeCamera()
	{
		if (!this.cameraOpen)
		{
			return;
		}
		this.cameraOpen = false;
		const tmpQRCode = this.pict.providers.QRCodeProvider;
		if (tmpQRCode && (typeof tmpQRCode.closeScanner === 'function'))
		{
			Promise.resolve(tmpQRCode.closeScanner()).catch((pError) => this.pict.log.warn(`SampleLocationCart: the camera could not be closed: ${(pError && pError.message) || pError}`));
		}
	}

	/**
	 * @param {string} pCartType - is-success / is-danger / is-warning / is-info
	 * @return {string} the page's toast type
	 */
	static toastType(pCartType)
	{
		if (pCartType === 'is-success')
		{
			return 'success';
		}
		return (pCartType === 'is-danger' || pCartType === 'is-warning') ? 'error' : 'info';
	}
}

module.exports = SampleLocationCartSession;

},{"headlight-sample-scanning":294}],1395:[function(require,module,exports){
'use strict';

/**
 * The Sample workspace's Location tab.
 *
 * Display: the location the sample is in (its newest SampleLocationJoin), with its photo thumbnail, type, QR code,
 * description, the locations it sits inside, and since when the sample has been there. Edit swaps that for the Scan
 * Samples cart with this sample already in it: pick or scan the new location and Move, which goes back to the
 * display (as Cancel does). The page has its own cart (SampleLocationCart, through SampleLocationCart-Session.js),
 * separate from the Location page's and the panels' Scan Samples, with nothing saved between opens.
 *
 * Owned by SampleWorkspace-Provider.js, which forwards renderLocation / editLocation / cancelLocationEdit to it.
 */

const libSampleScanning = require('headlight-sample-scanning');
const libSampleLocationCartSession = require('./SampleLocationCart-Session.js');

// The Sample page's own cart, separate from the Location page's and the panels'.
const CART_NAME = 'SampleLocationCart';
const CART_HOST_ID = 'SampleWorkspace-LocationCart';
const BODY_SELECTOR = '#SampleWorkspace-Body';

/**
 * @typedef {Object} SampleLocationState
 * @property {boolean} Loaded
 * @property {boolean} Loading
 * @property {string} Error
 * @property {Record<string, any>|null} Location - where the sample is now
 * @property {Array<Record<string, any>>} Ancestors - the locations that one sits inside, outermost first
 * @property {Record<string, any>|null} Join - the SampleLocationJoin that puts it there
 * @property {Array<Record<string, any>>} AlsoIn - any other locations the sample is joined to
 */

class SampleWorkspaceLocationTab
{
	/**
	 * @param {any} pWorkspace - the SampleWorkspace provider
	 */
	constructor(pWorkspace)
	{
		this.workspace = pWorkspace;
		this.editing = false;
		this._session = new libSampleLocationCartSession(
			{
				Pict: () => this.pict,
				CartName: CART_NAME,
				HostID: CART_HOST_ID,
				OwnHash: () => `#/Sample/Workspace/${Number(this.sample.IDSample)}/location`,
				Toast: (pMessage, pType) => this.workspace._toast(pMessage, pType),
				OnMoved: (pMove) => this._onMoved(pMove),
				OnReceived: (pMark) => this._onReceived(pMark),
				OnLeave: () => { this.editing = false; },
			});
		/** @type {SampleLocationState} */
		this.state = SampleWorkspaceLocationTab.emptyState();
	}

	/** @return {SampleLocationState} */
	static emptyState()
	{
		return { Loaded: false, Loading: false, Error: '', Location: null, Ancestors: [], Join: null, AlsoIn: [] };
	}

	/** @return {any} */
	get pict()
	{
		return this.workspace.pict;
	}

	/** @return {Record<string, any>} the loaded sample */
	get sample()
	{
		return this.workspace.state.Sample || {};
	}

	/** @return {any} the cart's provider, once edit has attached it */
	get cart()
	{
		return this.pict.providers[CART_NAME];
	}

	/** A new sample is loading: forget the old one's location and close any cart. */
	reset()
	{
		this._closeCart();
		this.editing = false;
		this.state = SampleWorkspaceLocationTab.emptyState();
	}

	// --- data ----------------------------------------------------------------------------------------------------

	/**
	 * Read where the sample is: its location joins (newest first), that location, and the location tree for the
	 * locations it sits inside.
	 * @return {Promise<void>}
	 */
	async loadAsync()
	{
		const tmpIDSample = Number(this.sample.IDSample);
		if (!(tmpIDSample > 0))
		{
			return;
		}
		this.state.Loading = true;
		const tmpState = SampleWorkspaceLocationTab.emptyState();
		try
		{
			const tmpJoins = await new libSampleScanning.AppSampleScanStore(this.pict).getSampleLocations(tmpIDSample);
			if (!Array.isArray(tmpJoins))
			{
				throw new Error('could not read the sample\'s location');
			}
			const tmpLocationProvider = this.pict.providers.LocationProvider;
			const tmpLocations = (tmpJoins.length && tmpLocationProvider && (typeof tmpLocationProvider.getAllLocations === 'function')) ?
				await Promise.resolve(tmpLocationProvider.getAllLocations()).catch(() => []) : [];
			const fFind = async (pIDLocation) =>
			{
				const tmpFound = (tmpLocations || []).find((pLocation) => Number(pLocation.IDLocation) === Number(pIDLocation));
				if (tmpFound || !tmpLocationProvider || (typeof tmpLocationProvider.getLocationByID !== 'function'))
				{
					return tmpFound || null;
				}
				return Promise.resolve(tmpLocationProvider.getLocationByID(Number(pIDLocation))).catch(() => null);
			};
			if (tmpJoins.length)
			{
				tmpState.Join = tmpJoins[0];
				tmpState.Location = await fFind(tmpJoins[0].IDLocation);
				tmpState.Ancestors = libSampleScanning.LocationTree.getAncestors(tmpJoins[0].IDLocation, tmpLocations || []);
				for (const tmpJoin of tmpJoins.slice(1))
				{
					const tmpOther = await fFind(tmpJoin.IDLocation);
					if (tmpOther && !tmpState.AlsoIn.some((pLocation) => pLocation.IDLocation === tmpOther.IDLocation) && (tmpOther.IDLocation !== (tmpState.Location || {}).IDLocation))
					{
						tmpState.AlsoIn.push(tmpOther);
					}
				}
				if (!tmpState.Location)
				{
					tmpState.Location = { IDLocation: Number(tmpJoins[0].IDLocation) };
				}
			}
		}
		catch (pError)
		{
			this.pict.log.warn(`SampleWorkspace: could not read sample ${tmpIDSample}'s location: ${(pError && pError.message) || pError}`);
			tmpState.Error = 'The sample\'s location could not be read. Try again in a moment.';
		}
		tmpState.Loaded = true;
		this.state = tmpState;
	}

	/**
	 * Load once per sample, then redraw the tab if it is still showing.
	 * @return {Promise<void>}
	 */
	async ensureLoadedAsync()
	{
		if (this.state.Loaded || this.state.Loading)
		{
			return;
		}
		await this.loadAsync();
		if (this.workspace._activeTab === 'location')
		{
			this.workspace.repaintBody();
		}
	}

	// --- display ---------------------------------------------------------------------------------------------------

	/**
	 * @param {Record<string, any>} pLocation
	 * @return {string} the location's thumbnail, through GET Location/:IDLocation/Photo/Thumbnail; '' without a photo
	 */
	thumbnailHTML(pLocation)
	{
		if (!(Number(pLocation.IDObservation) > 0))
		{
			return '<div class="sw-loc-thumb sw-loc-nothumb" title="No photo"><i class="fas fa-location-dot"></i></div>';
		}
		const tmpPath = `Location/${Number(pLocation.IDLocation)}/Photo/Thumbnail`;
		let tmpURL = `/1.0/${tmpPath}`;
		const tmpRestClient = this.workspace.restClient;
		if (tmpRestClient && (typeof tmpRestClient.formatUrl === 'function'))
		{
			try
			{
				tmpURL = tmpRestClient.formatUrl(tmpPath);
			}
			catch (pError)
			{
				// keep the relative URL
			}
		}
		const tmpName = pLocation.Name || `Location ${pLocation.IDLocation}`;
		// A photo still being processed can't load yet: show the placeholder instead of a broken image.
		return `<img class="sw-loc-thumb" src="${this.workspace._esc(tmpURL)}" alt="Photo of ${this.workspace._esc(tmpName)}" loading="lazy" ` +
			'onerror="this.classList.add(\'is-hidden\'); this.nextElementSibling.classList.remove(\'is-hidden\');" />' +
			'<div class="sw-loc-thumb sw-loc-nothumb is-hidden" title="Photo not available yet"><i class="fas fa-location-dot"></i></div>';
	}

	/**
	 * @param {Record<string, any>} pLocation
	 * @return {string} a link to the location's workspace
	 */
	linkHTML(pLocation)
	{
		const tmpName = pLocation.Name || `Location ${pLocation.IDLocation}`;
		return `<a href="#/Location/Workspace/${Number(pLocation.IDLocation)}">${this.workspace._esc(tmpName)}</a>`;
	}

	/** @return {string} the Edit / Set location button, when the user may move the sample */
	editButtonHTML()
	{
		if (!this.workspace.canChangeSample())
		{
			return '';
		}
		const tmpLabel = this.state.Location ? 'Change location' : 'Set location';
		return `<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.editLocation()"><span class="icon"><i class="fas fa-pen"></i></span><span>${tmpLabel}</span></button>`;
	}

	/** @return {string} the display: where the sample is, or that it isn't anywhere */
	displayHTML()
	{
		const tmpEsc = (pValue) => this.workspace._esc(pValue);
		const tmpState = this.state;
		if (!tmpState.Loaded)
		{
			return '<div class="sw-state"><span class="pw-spinner pw-spinner-inline"></span> Loading the sample\'s location…</div>';
		}
		if (tmpState.Error)
		{
			return `<div class="sw-loc-error"><i class="fas fa-triangle-exclamation"></i> ${tmpEsc(tmpState.Error)}</div>`;
		}
		const tmpToolbar = `<div class="sw-toolbar">${this.editButtonHTML()}</div>`;
		const tmpLocation = tmpState.Location;
		if (!tmpLocation)
		{
			return `${tmpToolbar}${this.workspace._empty('This sample isn\'t in a location.')}`;
		}
		const tmpFacts = [];
		if (tmpLocation.Type)
		{
			tmpFacts.push(`<span class="sw-loc-type">${tmpEsc(tmpLocation.Type)}</span>`);
		}
		if (tmpLocation.QRCode)
		{
			tmpFacts.push(`<span class="sw-muted"><i class="fas fa-qrcode"></i> ${tmpEsc(tmpLocation.QRCode)}</span>`);
		}
		const tmpInside = tmpState.Ancestors.length ?
			`<div class="sw-loc-line">Inside ${tmpState.Ancestors.map((pLocation) => this.linkHTML(pLocation)).join(' <span class="sw-loc-sep">›</span> ')}</div>` : '';
		const tmpDescription = tmpLocation.Description ? `<div class="sw-loc-line">${tmpEsc(tmpLocation.Description)}</div>` : '';
		const tmpSince = (tmpState.Join && tmpState.Join.CreateDate) ? `<div class="sw-loc-line sw-muted">Here since ${tmpEsc(this.workspace._fmtDateTime(tmpState.Join.CreateDate))}</div>` : '';
		const tmpAlso = tmpState.AlsoIn.length ?
			`<div class="sw-loc-line sw-muted">Also listed in ${tmpState.AlsoIn.map((pLocation) => this.linkHTML(pLocation)).join(', ')}</div>` : '';
		return `${tmpToolbar}
			<div class="sw-loc-card">
				${this.thumbnailHTML(tmpLocation)}
				<div class="sw-loc-body">
					<div class="sw-loc-name">${this.linkHTML(tmpLocation)}</div>
					${tmpFacts.length ? `<div class="sw-loc-facts">${tmpFacts.join('')}</div>` : ''}
					${tmpInside}${tmpDescription}${tmpSince}${tmpAlso}
				</div>
			</div>`;
	}

	/** @return {string} edit mode: what to do, Cancel, and the host the cart draws into */
	editHTML()
	{
		return `<div class="sw-toolbar sw-loc-edit-bar">
				<span class="sw-muted">Choose or scan the sample's new location, then Move.</span>
				<button class="button is-small is-light" onclick="_Pict.providers.SampleWorkspace.cancelLocationEdit()"><span class="icon"><i class="fas fa-xmark"></i></span><span>Cancel</span></button>
			</div>
			<div id="${CART_HOST_ID}" class="sw-loc-cart"></div>`;
	}

	/** Draw the tab into the workspace body: the display, or the cart while editing. */
	render()
	{
		if (!this.editing)
		{
			this.pict.ContentAssignment.assignContent(BODY_SELECTOR, this.displayHTML());
			if (!this.state.Loaded && !this.state.Loading)
			{
				this.ensureLoadedAsync();
			}
			return;
		}
		this.pict.ContentAssignment.assignContent(BODY_SELECTOR, this.editHTML());
		this._mountCart();
	}

	// --- edit ------------------------------------------------------------------------------------------------------

	/** Swap the display for the cart, with this sample already in it. */
	edit()
	{
		if (!this.workspace.canChangeSample())
		{
			if (this.workspace.isLockedForUser())
			{
				this.workspace._toastLocked();
			}
			return;
		}
		this.editing = true;
		this.workspace.repaintBody();
	}

	/** Leave the cart without moving anything and show the display again. */
	cancel()
	{
		this._closeCart();
		this.editing = false;
		this.workspace.repaintBody();
	}

	/** Open the cart in the tab with this sample in it (it can't be removed from here), or redraw an open one. */
	_mountCart()
	{
		this._session.mount({ KeepSample: this.sample });
	}

	/** @return {boolean} whether the cart's camera is open */
	get cameraOpen()
	{
		return this._session.cameraOpen;
	}

	/**
	 * @param {string} pContainerID
	 * @return {Promise<boolean>} whether the camera is now open
	 */
	toggleCamera(pContainerID)
	{
		return this._session.toggleCamera(pContainerID);
	}

	_closeCart()
	{
		this._session.close();
	}

	/**
	 * Check Samples into Lab ran in the cart. When it set this sample to RECV, read the sample and its log again; the
	 * cart stays open, since marking samples received doesn't finish the move.
	 * @param {{ Received: Array<Record<string, any>> }} pMark
	 * @return {Promise<void>}
	 */
	async _onReceived(pMark)
	{
		const tmpIDSample = Number(this.sample.IDSample);
		if (!(pMark && Array.isArray(pMark.Received) && pMark.Received.some((pSample) => Number(pSample.IDSample) === tmpIDSample)))
		{
			return;
		}
		await this.workspace.refreshAfterMoveAsync();
	}

	/**
	 * The cart moved samples. Once this sample has moved, close the cart, read the sample again (a location can set
	 * its status) along with its log and location, and show the display.
	 * @param {{ Location: Record<string, any>, Moved: Array<Record<string, any>>, Failed: Array<Record<string, any>> }} pMove
	 * @return {Promise<void>}
	 */
	async _onMoved(pMove)
	{
		const tmpIDSample = Number(this.sample.IDSample);
		if (!this.editing || !(pMove && Array.isArray(pMove.Moved) && pMove.Moved.some((pSample) => Number(pSample.IDSample) === tmpIDSample)))
		{
			return;
		}
		this._closeCart();
		this.editing = false;
		this.state = SampleWorkspaceLocationTab.emptyState();
		await this.workspace.refreshAfterMoveAsync();
	}

}

module.exports = SampleWorkspaceLocationTab;
module.exports.CART_NAME = CART_NAME;
module.exports.CART_HOST_ID = CART_HOST_ID;

},{"./SampleLocationCart-Session.js":1394,"headlight-sample-scanning":294}],1396:[function(require,module,exports){
'use strict';

/**
 * SampleWorkspace-Provider
 *
 * The bespoke per-sample workspace rebuilt from the LIMS `web/lims` Sample read/edit/create/view screens.
 * Samples are customer-scoped (MyCustomer auth; IDProject is a filter, not a parent), so this lives at the
 * top level (Materials Program) reached by a literal GUID bridge `#/PSRS/Sample/View/:GUIDRecord` that shadows
 * the generic PSRS read view — the PhysicalAsset -> AssetWorkspace precedent.
 *
 * The create/edit/view FORMS are "configuration-based": rendered from the customer's configured ManifestSchema
 * (Type=RecordManifest, SubType=LIMS-Sample-{Create,Edit,View}) loaded via the shared manifest-packaging-service
 * (ManifestPackagingService.loadRecordManifestSchema), falling back to a bundled default. The form is hosted in the
 * SampleFormHost (pict-section-form-host, DataAddress 'AppData' so descriptors SampleDetails.* marshal to
 * AppData.SampleDetails.* exactly like LIMS). Persistence goes through the ported LIMS SampleProvider
 * (createSample: QR minting, storage-location join, "Sample created" log; updateSample: PUT Sample/Upsert).
 *
 * See memory config-app-lims-samples.
 */

const libWorkspace = require('pict-section-workspace');
const DEFAULT_SAMPLE_VIEW_MANIFEST = require('./Default-Sample-View-Manifest.json');
const DEFAULT_SAMPLE_EDIT_MANIFEST = require('./Default-Sample-Edit-Manifest.json');
const DEFAULT_SAMPLE_CREATE_MANIFEST = require('./Default-Sample-Create-Manifest.json');
// The entity popover layouts legacy LIMS shipped (web/lims/source/views/defaultSummaryManifests.json).
const DEFAULT_SUMMARY_MANIFESTS = require('./Default-Summary-Manifests.json');
const libSampleWorkspaceLocationTab = require('./SampleWorkspace-LocationTab.js');
const libSampleDocumentDetails = require('./SampleDocument-Details.js');
const libSampleTestRules = require('@paviasystems/headlight-samples').SampleTestRules;

const TABS = [ 'details', 'location', 'lineitems', 'testinstances', 'documents', 'cores', 'logs', 'print' ];

// LIMS product string — the manifest SubType is <Product>-Sample-<Verb> (e.g. LIMS-Sample-View). MUST be 'LIMS' so
// the config app renders the SAME per-customer form the LIMS app does.
const LIMS_PRODUCT = 'LIMS';

// SampleWorkspace — refactored onto pict-section-workspace (the base now supports view/edit/CREATE modes + an
// EditContent form body). The base owns the shell (mode-aware header, tab bar in view mode, the form body in
// edit/create); this subclass keeps all of Sample's data + the config-driven manifest form + mutations, and the
// per-tab tables (ported from the old view). Config in [[Sample.config.js]].
class SampleWorkspaceProvider extends libWorkspace.HeadlightWorkspaceBaseProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		this._idSample = 0;
		this._guidSample = '';
		this._activeTab = 'details';
		/** @type {Record<String, import('@paviasystems/headlight-samples/source/SampleTest-Rules.js').FormTestCatalog>} - IDCustomer -> the tests each form type declares. */
		this._formTestCatalogs = {};
		/** @type {{ Key: String, Counts: Record<number, Record<String, number>> }} - media counts for the documents named in Key. */
		this._documentMedia = { Key: '', Counts: {} };
		/** @type {{ Key: String, Media: Array<Object> }} - photos and videos of the unreadable documents named in Key. */
		this._hiddenDocumentMedia = { Key: '', Media: [] };
		this._mode = 'view'; // 'view' | 'edit' | 'create'
		this._cloneFromGUID = '';
		this._activatedTabs = {};
		this._tabLoads = {};
		this._manifestsByVerb = {};
		/** @type {{ Create: boolean, Edit: boolean }|null} */
		this._formsOff = null;
		/** @type {Map<Record<string, any>, Promise<void>>} */
		this._initialBundleGathers = new Map();
		this._statusVocabularyLoaded = false;
		this._referenceBundleLoaded = false;
		this._summaryManifestsLoad = null;
		/** @type {Record<number, string>} IDUser -> display name, for "by <user>" lines. */
		this._userNames = {};
		this._pendingDocumentOpen = 0;
		// The Location tab: where the sample is, and moving it with the Scan Samples cart.
		this._locationTab = new libSampleWorkspaceLocationTab(this);
	}

	get app() { return this.pict.PictApplication; }
	get restClient() { return this.pict.fable.HeadlightRestClient; }
	get permissions() { return this.pict.fable.EffectivePermissionsService; }
	get view() { return this.pict.views.SampleWorkspace; }
	get formHost() { return this.pict.providers.SampleFormHost; }
	get idSample() { return this._idSample; }
	get mode() { return this._mode; }

	get state()
	{
		if (!this.pict.AppData.SampleWorkspace)
		{
			this.pict.AppData.SampleWorkspace =
			{
				Sample: {}, Tab: 'details', Mode: 'view', Loading: false, Message: '', Saving: false,
				LineItems: [], TestInstanceBundle: { TestInstances: [], TestMap: {}, TestInstanceDocumentMap: {} },
				Documents: [], InaccessibleDocumentCount: 0, InaccessibleDocumentIDs: [], HiddenDocumentObservationJoins: null, Cores: [], Logs: [], StatusVocabulary: {}, NewLogNotes: '',
			};
		}
		return this.pict.AppData.SampleWorkspace;
	}

	// --- permissions (fail-open until the capability map is ready) -------------------------------------------
	_canHash(pHash)
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || !tmpPermissions.currentUserReady || !tmpPermissions.currentUserReady())
		{
			return true;
		}
		// A role in the sample's project (a project engineer's, say) can grant what the customer-level map doesn't.
		const tmpIDProject = Number((this.state.Sample || {}).IDProject) || 0;
		if (tmpIDProject && (typeof tmpPermissions.canHashInProject === 'function'))
		{
			return !!tmpPermissions.canHashInProject(pHash, tmpIDProject);
		}
		return !!tmpPermissions.canHash(pHash);
	}
	/** While a sample loads, its project's grants aren't known yet, so loading shows instead of the lock. */
	canRead() { return !!this.state.Loading || this._canHash('Sample-Read'); }
	canCreate() { return this._canHash('Sample-Create') && !this.isFormOff('Create'); }
	canUpdate() { return this._canHash('Sample-Update'); }
	/** Edit the sample's own fields. Documents and notes need only canUpdate; line items and tests need canChangeSample. */
	canEditForm() { return this.canUpdate() && !this.isFormOff('Edit') && !this.isLockedForUser(); }
	/**
	 * Add, change or remove the sample's line items and tests.
	 * @return {boolean}
	 */
	canChangeSample()
	{
		return this.canUpdate() && !this.isLockedForUser();
	}

	// --- sample lock (browser-side only: the API doesn't refuse changes to a locked sample) ------------------
	/**
	 * @return {boolean} whether the loaded sample is locked
	 */
	isLocked()
	{
		const tmpSample = this.state.Sample || {};
		return !!(tmpSample.Locked && (Number(tmpSample.Locked) !== 0));
	}
	/**
	 * Fails closed, unlike _canHash: an override is never granted before the capability map is ready.
	 * @return {boolean}
	 */
	canOverrideLock()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || !tmpPermissions.currentUserReady || !tmpPermissions.currentUserReady())
		{
			return false;
		}
		return !!tmpPermissions.canHash('SampleLock-Override');
	}
	/**
	 * @return {boolean} whether the lock applies to this user
	 */
	isLockedForUser()
	{
		return this.isLocked() && !this.canOverrideLock();
	}
	/**
	 * Tell the user the sample is locked.
	 */
	_toastLocked()
	{
		this._toast('This sample is locked, so it can\'t be changed.', 'error');
	}

	// --- per-customer form availability ------------------------------------------------------------------------
	// A customer whose LIMS-Sample-Create or -Edit manifest exists with no fields doesn't create or edit samples
	// through the form (LADOTD and RIDOT on 2026-10-28). No row at all means the bundled default form.
	// Same rule as legacy LIMS applySampleDisabledState (web/lims/source/LIMS-Application-Web.js).
	async loadFormAvailabilityAsync()
	{
		const [ tmpCreate, tmpEdit ] = await Promise.all([ this._loadManifestAsync('Create'), this._loadManifestAsync('Edit') ]);
		const fEmpty = (pManifest) => !!(pManifest && pManifest.Descriptors && (Object.keys(pManifest.Descriptors).length === 0));
		this._formsOff = { Create: fEmpty(tmpCreate), Edit: fEmpty(tmpEdit) };
		return this._formsOff;
	}
	isFormOff(pVerb) { return !!(this._formsOff && this._formsOff[pVerb]); }

	/** Create mode, unless this customer has no create form: then back to the list. */
	async startCreateAsync(pArg)
	{
		await this.loadFormAvailabilityAsync();
		if (this.isFormOff('Create'))
		{
			this._toast('New samples aren\'t entered here for your organization.', 'info');
			this.backToList();
			return;
		}
		return super.startCreateAsync(pArg);
	}

	/** View or edit; edit falls back to view when this customer has no edit form. */
	async loadAsync(pID, pTab, pMode)
	{
		let tmpMode = pMode;
		if (tmpMode === 'edit')
		{
			await this.loadFormAvailabilityAsync();
			if (this.isFormOff('Edit'))
			{
				tmpMode = 'view';
				this._toast('Sample details aren\'t edited here for your organization.', 'info');
				if ((typeof window !== 'undefined') && window.history && (typeof window.history.replaceState === 'function'))
				{
					window.history.replaceState(null, '', `#/Sample/Workspace/${parseInt(pID, 10) || 0}`);
				}
			}
		}
		return super.loadAsync(pID, pTab, tmpMode);
	}
	canDelete() { return this._canHash('Sample-Delete'); }

	// --- REST helpers ----------------------------------------------------------------------------------------
	_getJSON(pURL)
	{
		return new Promise((resolve) =>
		{
			this.restClient.getJSON(pURL, (pError, pResponse, pBody) =>
			{
				if (pError) { resolve(null); return; }
				resolve((pBody !== undefined) ? pBody : pResponse);
			});
		});
	}

	_toast(pMessage, pType)
	{
		try
		{
			const tmpPanels = this.pict.views.HeadlightPanels;
			if (tmpPanels && (typeof tmpPanels.toast === 'function'))
			{
				tmpPanels.toast({ type: (pType === 'error') ? 'is-danger' : (pType === 'success' ? 'is-success' : 'is-info'), message: pMessage });
				return;
			}
		}
		catch (pError) { /* best-effort */ }
		this.pict.log.info(`SampleWorkspace: ${pMessage}`);
	}

	// --- status vocabulary (code -> label), mirrors LIMS loadSampleStatusVocabulary/resolveSampleStatusName -----
	async ensureStatusVocabularyAsync()
	{
		if (this._statusVocabularyLoaded) { return; }
		this._statusVocabularyLoaded = true;
		const tmpList = await this._getJSON('SampleStatuss/FilteredTo/FSF~Ordinal~ASC~0/0/500');
		const tmpMap = {};
		if (Array.isArray(tmpList))
		{
			for (const tmpRow of tmpList)
			{
				if (tmpRow && tmpRow.Hash) { tmpMap[String(tmpRow.Hash)] = tmpRow.Name || tmpRow.Hash; }
			}
		}
		this.state.StatusVocabulary = tmpMap;
	}

	resolveSampleStatusName(pCode)
	{
		if (!pCode) { return ''; }
		const tmpMap = this.state.StatusVocabulary || {};
		return tmpMap[String(pCode)] || String(pCode);
	}

	// --- entry points (base owns openByGUIDAsync/loadAsync/startCreateAsync; these hooks seed state) -----------

	/** CREATE-mode seed (called by the base startCreateAsync). Clone copies descriptor values (not identity fields). */
	/**
	 * Stash a one-shot prefill applied by the next create — a dashboard's "take a sample" for a sampling-plan line.
	 * @param {{ IDProject?: number, IDLineItem?: number, IDMaterial?: number, SampleType?: string }|null} pPrefill
	 */
	prefillNew(pPrefill)
	{
		this._pendingPrefill = (pPrefill && typeof pPrefill === 'object') ? pPrefill : null;
	}

	async hydrateCreateAsync(pCloneFromGUID)
	{
		this._initialBundleGathers = new Map();
		this._idSample = 0;
		this._guidSample = '';
		this._cloneFromGUID = pCloneFromGUID || '';
		this._activeTab = 'details';
		this._resetTabLoads();
		const tmpState = this.state;
		tmpState.Mode = 'create';
		tmpState.Tab = 'details';
		tmpState.Message = '';
		tmpState.Sample = {};
		tmpState.LineItems = []; tmpState.Documents = []; tmpState.InaccessibleDocumentCount = 0; tmpState.InaccessibleDocumentIDs = []; tmpState.HiddenDocumentObservationJoins = null; tmpState.Cores = []; tmpState.Logs = [];
		tmpState.TestInstanceBundle = { TestInstances: [], TestMap: {}, TestInstanceDocumentMap: {} };
		await this.ensureStatusVocabularyAsync();
		await this._loadReferenceBundleAsync();
		let tmpSeed = { Extension: {} };
		if (this._cloneFromGUID)
		{
			const tmpList = await this._getJSON(`Samples/FilteredTo/FBV~GUIDSample~EQ~${encodeURIComponent(this._cloneFromGUID)}`);
			const tmpSource = (Array.isArray(tmpList) && tmpList.length) ? tmpList[0] : null;
			if (tmpSource)
			{
				tmpSeed = Object.assign({}, tmpSource);
				delete tmpSeed.IDSample; delete tmpSeed.GUIDSample; delete tmpSeed.QRCode;
				delete tmpSeed.LabControlNumber; delete tmpSeed.LabReferenceNumber;
				delete tmpSeed.CreateDate; delete tmpSeed.UpdateDate; delete tmpSeed.Status;
			}
		}
		if (this._pendingPrefill)
		{
			await this._applyPrefillAsync(tmpSeed, this._pendingPrefill);
			this._pendingPrefill = null;
		}
		tmpState.Sample = tmpSeed;
		await this._loadSpecScopeAsync(tmpSeed.IDProject);
	}

	/**
	 * @param {Record<string, any>} pSeed - The new sample, mutated.
	 * @param {{ IDProject?: number, IDLineItem?: number, IDMaterial?: number, SampleType?: string }} pPrefill
	 * @return {Promise<void>}
	 */
	async _applyPrefillAsync(pSeed, pPrefill)
	{
		for (const tmpKey of [ 'IDProject', 'IDLineItem', 'IDMaterial' ])
		{
			if (Number(pPrefill[tmpKey]) > 0)
			{
				pSeed[tmpKey] = Number(pPrefill[tmpKey]);
			}
		}
		if (pPrefill.SampleType)
		{
			const tmpTypes = await this._getJSON(`SampleTypes/FilteredTo/FBV~Hash~EQ~${encodeURIComponent(pPrefill.SampleType)}~FBV~Deleted~EQ~0/0/1`);
			if (Array.isArray(tmpTypes) && tmpTypes.length > 0)
			{
				pSeed.IDSampleType = tmpTypes[0].IDSampleType;
			}
		}
	}

	/**
	 * Scope the form's material pickers to the project's specification year before the form renders. A sample
	 * with no project clears the previous sample's scope. Fails open: the pickers show everything.
	 * @param {number} pIDProject
	 * @return {Promise<void>}
	 */
	async _loadSpecScopeAsync(pIDProject)
	{
		const tmpResolver = this.pict.providers.SpecScopeResolver;
		if (!tmpResolver || (typeof tmpResolver.loadForProject !== 'function'))
		{
			return;
		}
		try
		{
			await tmpResolver.loadForProject(parseInt(pIDProject, 10) || 0);
		}
		catch (pError)
		{
			this.pict.log.warn(`SampleWorkspace: specification-year scope did not load for project ${pIDProject}: ${(pError && pError.message) || pError}`);
		}
	}

	_resetState()
	{
		const tmpState = this.state;
		tmpState.Sample = {}; tmpState.LineItems = []; tmpState.Documents = []; tmpState.InaccessibleDocumentCount = 0; tmpState.InaccessibleDocumentIDs = []; tmpState.HiddenDocumentObservationJoins = null; tmpState.Cores = []; tmpState.Logs = [];
		tmpState.TestInstanceBundle = { TestInstances: [], TestMap: {}, TestInstanceDocumentMap: {} };
		tmpState.Message = ''; tmpState.Saving = false;
		this._resetTabLoads();
	}

	/** VIEW/EDIT-mode seed (called by the base loadAsync after the Sample record arrives). */
	async hydrateAsync(pRecord)
	{
		this._initialBundleGathers = new Map();
		this._locationTab.reset();
		this._listenForPanelMoves();
		this._idSample = pRecord.IDSample;
		this._guidSample = pRecord.GUIDSample || this._guidSample;
		const tmpState = this.state;
		tmpState.Sample = pRecord;
		tmpState.Mode = this._mode;
		this._resetTabLoads();
		tmpState.LineItems = []; tmpState.Documents = []; tmpState.InaccessibleDocumentCount = 0; tmpState.InaccessibleDocumentIDs = []; tmpState.HiddenDocumentObservationJoins = null; tmpState.Cores = [];
		tmpState.TestInstanceBundle = { TestInstances: [], TestMap: {}, TestInstanceDocumentMap: {} };
		await Promise.all([ this.ensureStatusVocabularyAsync(), this.loadFormAvailabilityAsync(), this._loadProjectPermissionsAsync(pRecord.IDProject) ]);
		if ((this._mode === 'edit') && this.isLockedForUser())
		{
			this._mode = 'view';
			tmpState.Mode = 'view';
			this._toast('This sample is locked, so its details can\'t be edited.', 'info');
			if ((typeof window !== 'undefined') && window.history && (typeof window.history.replaceState === 'function'))
			{
				window.history.replaceState(null, '', `#/Sample/Workspace/${parseInt(pRecord.IDSample, 10) || 0}`);
			}
		}
		if (this.isEditing)
		{
			await Promise.all([ this._loadReferenceBundleAsync(), this._loadSpecScopeAsync(pRecord.IDProject) ]);   // edit-form picklists (best-effort)
		}
		// Not awaited: the popovers only need these by the time someone hovers one.
		this._ensureSummaryManifestsAsync();
		// Logs are eager in LIMS (always loaded); do the same.
		tmpState.Logs = await this._loadLogsAsync();
	}

	/**
	 * Read what the current user is granted in the sample's project, so _canHash can count it.
	 * @param {number} pIDProject
	 * @return {Promise<void>}
	 */
	async _loadProjectPermissionsAsync(pIDProject)
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.loadCurrentUserProjectAsync !== 'function'))
		{
			return;
		}
		try
		{
			await tmpPermissions.loadCurrentUserProjectAsync(pIDProject);
		}
		catch (pError)
		{
			this.pict.log.warn(`SampleWorkspace: project ${pIDProject} permissions did not load: ${(pError && pError.message) || pError}`);
		}
	}

	/** Once per app: refresh when the panels' Scan Samples cart moves the sample on screen. */
	_listenForPanelMoves()
	{
		const tmpPanel = this.pict.views.QRPanel;
		if (this._removePanelMovesListener || !tmpPanel || (typeof tmpPanel.addMovedListener !== 'function'))
		{
			return;
		}
		this._removePanelMovesListener = tmpPanel.addMovedListener((pMove) => this.onSamplesMoved(pMove));
	}

	/**
	 * A move made outside the Location tab: refresh when it took the sample on screen.
	 * @param {{ Moved?: Array<Record<string, any>> }} pMove
	 * @return {Promise<void>}
	 */
	async onSamplesMoved(pMove)
	{
		const tmpIDSample = Number(this._idSample);
		if (!(tmpIDSample > 0) || !(pMove && Array.isArray(pMove.Moved) && pMove.Moved.some((pSample) => Number(pSample.IDSample) === tmpIDSample)))
		{
			return;
		}
		await this.refreshAfterMoveAsync();
	}

	/**
	 * Re-read what a move changes (the sample's status, its log and its location) and redraw. While the sample's
	 * details are being edited only the log and location are re-read, so the form isn't redrawn under the person.
	 * @return {Promise<void>}
	 */
	async refreshAfterMoveAsync()
	{
		const tmpIDSample = Number(this._idSample);
		const tmpEditing = this.isEditing;
		const [ tmpSample, tmpLogs ] = await Promise.all(
			[
				tmpEditing ? Promise.resolve(null) : this._getJSON(`Sample/${tmpIDSample}`),
				this._loadLogsAsync(),
				this._locationTab.loadAsync(),
			]);
		if (Number(this._idSample) !== tmpIDSample)
		{
			return;
		}
		if (tmpSample && (Number(tmpSample.IDSample) === tmpIDSample))
		{
			this._record = tmpSample;
			this.state.Sample = tmpSample;
		}
		if (Array.isArray(tmpLogs))
		{
			this.state.Logs = tmpLogs;
		}
		if (!tmpEditing)
		{
			// The header too: the status pill can change with the move.
			this.renderWorkspace();
		}
	}

	// --- per-tab lazy loads ----------------------------------------------------------------------------------
	/** Forget every tab's data; a load still in flight for the previous sample is discarded when it lands. */
	_resetTabLoads()
	{
		this._activatedTabs = {};
		this._tabLoads = {};
	}

	/**
	 * @param {string} pTab
	 * @return {{ Promise: Promise<void>|null, Request: number, Loaded: boolean, Error: string }}
	 */
	_tabLoad(pTab)
	{
		if (!this._tabLoads)
		{
			this._tabLoads = {};
		}
		if (!this._tabLoads[pTab])
		{
			this._tabLoads[pTab] = { Promise: null, Request: 0, Loaded: false, Error: '' };
		}
		return this._tabLoads[pTab];
	}

	/**
	 * Mark a tab's data stale so the next _ensureTabDataLoaded fetches it again. The data already shown stays until the
	 * new fetch lands, and a fetch still in flight is superseded.
	 * @param {string} pTab
	 */
	_invalidateTab(pTab)
	{
		this._activatedTabs[pTab] = false;
		this._tabLoad(pTab).Promise = null;
	}

	/**
	 * Load a tab's data once per sample. Callers that arrive while the fetch is running share it.
	 * @param {string} pTab
	 * @return {Promise<void>}
	 */
	_ensureTabDataLoaded(pTab)
	{
		if (this._activatedTabs[pTab])
		{
			return Promise.resolve();
		}
		const tmpLoad = this._tabLoad(pTab);
		if (!tmpLoad.Promise)
		{
			tmpLoad.Promise = this._loadTabDataAsync(pTab, tmpLoad);
		}
		return tmpLoad.Promise;
	}

	/**
	 * @param {string} pTab
	 * @param {{ Promise: Promise<void>|null, Request: number, Loaded: boolean, Error: string }} pLoad
	 * @return {Promise<void>}
	 */
	async _loadTabDataAsync(pTab, pLoad)
	{
		pLoad.Request++;
		const tmpRequest = pLoad.Request;
		const fIsCurrent = () => (this._tabLoads[pTab] === pLoad) && (pLoad.Request === tmpRequest);
		try
		{
			const tmpData = await this._fetchTabDataAsync(pTab, this._idSample);
			if (!fIsCurrent())
			{
				return;
			}
			Object.assign(this.state, tmpData);
			pLoad.Loaded = true;
			pLoad.Error = '';
			this._activatedTabs[pTab] = true;
		}
		catch (pError)
		{
			const tmpMessage = (pError && pError.message) || String(pError);
			this.pict.log.error(`SampleWorkspace: tab '${pTab}' load failed: ${tmpMessage}`);
			if (fIsCurrent())
			{
				pLoad.Error = tmpMessage;
			}
		}
		finally
		{
			if (fIsCurrent())
			{
				pLoad.Promise = null;
			}
		}
	}

	/**
	 * @param {string} pTab
	 * @param {number} pIDSample
	 * @return {Promise<Record<string, any>>} the state fields the tab renders from
	 */
	async _fetchTabDataAsync(pTab, pIDSample)
	{
		if (pTab === 'lineitems')
		{
			const tmpLineItemProvider = this.pict.providers.LineItemProvider;
			return {
				LineItems: (tmpLineItemProvider && typeof tmpLineItemProvider.getLineItemsByIDSample === 'function')
					? (await tmpLineItemProvider.getLineItemsByIDSample(pIDSample)) || []
					: [],
			};
		}
		if (pTab === 'testinstances')
		{
			const tmpSamples = this.pict.fable.HeadlightSamples;
			if (!tmpSamples)
			{
				throw new Error('The samples provider is not available.');
			}
			const tmpScope = tmpSamples.forSample(pIDSample);
			tmpScope.invalidate();
			return { TestInstanceBundle: await tmpScope.getTestBundle() };
		}
		if (pTab === 'documents')
		{
			const tmpDocProvider = this.pict.providers.DocumentProvider;
			const [ tmpDocuments, tmpMedia ] = await Promise.all(
				[
					(tmpDocProvider && typeof tmpDocProvider.getDocumentsByRemoteID === 'function')
						? tmpDocProvider.getDocumentsByRemoteID(pIDSample, 'Sample')
						: [],
					this._getJSON(`Sample/${pIDSample}/DocumentMedia`),
				]);
			// The sample's own media route names documents the reader cannot open; a reader's DocumentPolyJoin read does not.
			const tmpHasMedia = !!(tmpMedia && Array.isArray(tmpMedia.Documents) && Array.isArray(tmpMedia.ObservationJoins));
			const tmpJoins = tmpHasMedia
				? tmpMedia.Documents.map((pIDDocument) => ({ IDDocument: pIDDocument }))
				: await this._getJSON(`DocumentPolyJoins/FilteredTo/FBV~IDRemote~EQ~${pIDSample}~FBV~RemoteType~EQ~Sample/0/1000`);
			const tmpHiddenIDs = this._inaccessibleDocumentIDs(tmpJoins, tmpDocuments || []);
			return {
				Documents: tmpDocuments || [],
				InaccessibleDocumentCount: tmpHiddenIDs.length,
				InaccessibleDocumentIDs: tmpHiddenIDs,
				HiddenDocumentObservationJoins: tmpHasMedia ? tmpMedia.ObservationJoins.filter((pJoin) => tmpHiddenIDs.indexOf(Number(pJoin.IDDocument)) > -1) : null,
			};
		}
		if (pTab === 'cores')
		{
			return { Cores: (await this._getJSON(`Cores/FilteredTo/FBV~IDSample~EQ~${pIDSample}~FBV~Deleted~EQ~0/0/500`)) || [] };
		}
		return {};
	}

	/**
	 * Fetch a tab whose load failed again, from its Try again button.
	 * @param {string} pTab
	 * @return {Promise<void>}
	 */
	async retryTab(pTab)
	{
		this._invalidateTab(pTab);
		this._tabLoad(pTab).Error = '';
		this.repaintBody();
		await this._ensureTabDataLoaded(pTab);
		this.repaintBody();
	}

	/**
	 * Until a tab's data has arrived, paint a loading state in its place, or the load's error with Try again, so an
	 * empty list never shows before the fetch answers.
	 * @param {string} pTab
	 * @param {string} pNoun - what the tab lists, e.g. 'tests'
	 * @return {boolean} true when the tab body was painted here and the renderer should stop
	 */
	_renderTabPending(pTab, pNoun)
	{
		const tmpLoad = this._tabLoad(pTab);
		if (tmpLoad.Loaded)
		{
			return false;
		}
		const tmpBody = document.querySelector('#SampleWorkspace-Body');
		if (!tmpBody)
		{
			return true;
		}
		const tmpState = document.createElement('div');
		tmpState.className = 'sw-state';
		if (tmpLoad.Error)
		{
			const tmpIcon = document.createElement('i');
			tmpIcon.className = 'fas fa-triangle-exclamation has-text-danger mr-2';
			const tmpMessage = document.createElement('span');
			tmpMessage.textContent = `Could not load this sample's ${pNoun}: ${tmpLoad.Error}`;
			const tmpRetry = document.createElement('button');
			tmpRetry.className = 'button is-small is-link is-soft mt-3';
			tmpRetry.textContent = 'Try again';
			tmpRetry.addEventListener('click', () => this.retryTab(pTab));
			const tmpActions = document.createElement('div');
			tmpActions.append(tmpRetry);
			tmpState.append(tmpIcon, tmpMessage, tmpActions);
		}
		else
		{
			const tmpSpinner = document.createElement('span');
			tmpSpinner.className = 'pw-spinner pw-spinner-inline';
			tmpState.append(tmpSpinner, ` Loading ${pNoun}…`);
		}
		tmpBody.innerHTML = '';
		tmpBody.append(tmpState);
		return true;
	}

	async _loadLogsAsync()
	{
		try
		{
			const tmpLogProvider = this.pict.providers.SampleLogProvider;
			if (tmpLogProvider && typeof tmpLogProvider.getSampleLogsByIDSample === 'function')
			{
				return (await tmpLogProvider.getSampleLogsByIDSample(this._idSample)) || [];
			}
			return (await this._getJSON(`SampleLogs/FilteredTo/FBV~IDSample~EQ~${this._idSample}~FSF~CreateDate~DESC~0/0/500`)) || [];
		}
		catch (pError) { return []; }
	}

	// --- configuration-based form (manifest-packaging-service + form-host) -----------------------------------
	/**
	 * The Sample record manifest for a verb, fetched once and shared by every caller, including those that ask while
	 * the fetch is still in flight (the form mounts several times as a sample opens).
	 * @param {string} pVerb - Create, Edit or View
	 * @return {Promise<Record<string, any>>}
	 */
	_loadManifestAsync(pVerb)
	{
		if (!this._manifestsByVerb[pVerb])
		{
			this._manifestsByVerb[pVerb] = this._fetchManifestAsync(pVerb);
		}
		return this._manifestsByVerb[pVerb];
	}

	async _fetchManifestAsync(pVerb)
	{
		let tmpManifest = null;
		try
		{
			const tmpService = this.pict.services.ManifestPackagingService || this.pict.ManifestPackagingService;
			if (tmpService && typeof tmpService.loadRecordManifestSchema === 'function')
			{
				tmpManifest = await tmpService.loadRecordManifestSchema('Sample', pVerb, LIMS_PRODUCT);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`SampleWorkspace: manifest load (${pVerb}) failed: ${(pError && pError.message) || pError}`);
		}
		if (!tmpManifest)
		{
			tmpManifest = (pVerb === 'Create') ? DEFAULT_SAMPLE_CREATE_MANIFEST
				: (pVerb === 'Edit') ? DEFAULT_SAMPLE_EDIT_MANIFEST
					: DEFAULT_SAMPLE_VIEW_MANIFEST;
		}
		return tmpManifest;
	}

	// Load the shared reference bundle the create/edit picklists need (Containers/States/Cities/Countries/Locations)
	// into the AppData addresses the manifests reference. Best-effort; read-only view mode does not need it.
	async _loadReferenceBundleAsync()
	{
		if (this._referenceBundleLoaded) { return; }
		this._referenceBundleLoaded = true;
		const tmpApp = this.pict.AppData;
		const tmpMap = (pList, pKey, pVal) => (Array.isArray(pList) ? pList.map((pRow) => ({ Hash: pRow[pKey], Value: pRow[pVal] || pRow[pKey] })) : []);
		try
		{
			const [ tmpContainers, tmpCountries, tmpStates, tmpLocations ] = await Promise.all(
			[
				this._getJSON('ListDefaults/FilteredTo/FBV~NamespaceKey~EQ~Misc~FBV~NamespaceValue~EQ~Container/0/500'),
				this._getJSON('ListDefaults/FilteredTo/FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~Country/0/500'),
				this._getJSON('ListDefaults/FilteredTo/FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State/0/500'),
				this.pict.providers.LocationProvider.getAllLocations().catch(() => []),
			]);
			tmpApp.Containers = tmpMap(tmpContainers, 'Hash', 'Name');
			tmpApp.SourceCountries = tmpMap(tmpCountries, 'Hash', 'Name');
			tmpApp.SourceStates = tmpMap(tmpStates, 'Hash', 'Name');
			tmpApp.SourceCities = tmpApp.SourceCities || [];
			tmpApp.Locations = Array.isArray(tmpLocations) ? tmpLocations : [];
		}
		catch (pError) { /* picklists degrade to empty; form still renders */ }
	}

	/**
	 * Gather the manifest's form-level InitialBundle through the LIMS FormInitialBundle provider, as the LIMS Sample
	 * views do: once per opened sample (the hydrate hooks start a new set), however many times the form mounts
	 * meanwhile. A failed gather is logged, the form still opens, and the next mount tries again.
	 * @param {Record<string, any>} pManifest - the Sample record manifest about to be loaded
	 * @return {Promise<void>}
	 */
	async _gatherInitialBundleAsync(pManifest)
	{
		const tmpGatherer = this.pict.providers.FormInitialBundle;
		if (!tmpGatherer || !pManifest || !Array.isArray(pManifest.InitialBundle) || (pManifest.InitialBundle.length < 1))
		{
			return;
		}
		const tmpGathers = this._initialBundleGathers;
		if (!tmpGathers.has(pManifest))
		{
			let fResolve;
			tmpGathers.set(pManifest, new Promise((pResolve) =>
			{
				fResolve = pResolve;
			}));
			const fDone = (pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`SampleWorkspace: InitialBundle gather failed: ${(pError && pError.message) || pError}`);
					tmpGathers.delete(pManifest);
				}
				fResolve();
			};
			try
			{
				tmpGatherer.gatherInitialBundle(pManifest, fDone);
			}
			catch (pError)
			{
				fDone(pError);
			}
		}
		await tmpGathers.get(pManifest);
	}

	/** Mount the config-driven form for the current mode into #Sample-FormHost (called by the view after it paints). */
	async mountFormAsync()
	{
		const tmpHost = this.formHost;
		if (!tmpHost || (typeof tmpHost.loadForm !== 'function'))
		{
			this.state.Message = 'The Sample form runner is not available.';
			return;
		}
		const tmpVerb = (this._mode === 'create') ? 'Create' : (this._mode === 'edit') ? 'Edit' : 'View';
		const tmpManifest = await this._loadManifestAsync(tmpVerb);
		await this._gatherInitialBundleAsync(tmpManifest);
		// Seed the marshal target: the form binds to AppData.SampleDetails.* (DataAddress 'AppData').
		this.pict.AppData.SampleDetails = (this._mode === 'create')
			? Object.assign({ Extension: {} }, this.state.Sample || {})
			: Object.assign({ Extension: {} }, this.state.Sample || {});
		try
		{
			const tmpMetacontroller = this.pict.views.PictFormMetacontroller;
			if (tmpMetacontroller && typeof tmpMetacontroller.clearManifestDescription === 'function')
			{
				tmpMetacontroller.clearManifestDescription();
			}
			this._applyFormTheme();
			tmpHost.loadForm(tmpManifest, { DestinationAddress: '#Sample-FormHost', DataAddress: 'AppData' });
			// Rebuild picklists declared by the manifest (create/edit).
			const tmpMetaLists = this.pict.providers.DynamicMetaLists;
			if (tmpMetaLists && Array.isArray(tmpManifest.PickLists))
			{
				for (const tmpPickList of tmpManifest.PickLists)
				{
					if (tmpPickList && tmpPickList.Hash && typeof tmpMetaLists.rebuildListByHash === 'function')
					{
						try { tmpMetaLists.rebuildListByHash(tmpPickList.Hash); } catch (pErr) { /* best-effort */ }
					}
				}
			}
			// The form renders asynchronously (Select2 + entity pickers resolve late), so pushing the data into the
			// inputs has to happen AFTER that render settles — a single immediate marshal leaves the plain text/date
			// inputs blank. Marshal on the next tick and again shortly after to catch the late-resolving pickers, then
			// apply the read-only treatment for view mode (the LIMS Read theme renders these default inputs read-only).
			const fnFinalize = () =>
			{
				if (typeof tmpHost.marshalToView === 'function') { try { tmpHost.marshalToView(); } catch (pErr) { /* best-effort */ } }
				if (this._mode === 'view') { this._applyViewReadOnly(); }
			};
			setTimeout(fnFinalize, 0);
			setTimeout(fnFinalize, 250);
		}
		catch (pError)
		{
			this.state.Message = `Could not open the Sample form: ${(pError && pError.message) ? pError.message : pError}`;
			if (this.view) { this.repaintBody(); }
		}
	}

	// --- actions ---------------------------------------------------------------------------------------------
	goToEdit()
	{
		if (!this._guidSample) { return; }
		window.location.hash = `#/PSRS/Sample/Edit/${this._guidSample}`;
	}
	goToClone()
	{
		if (!this._guidSample) { return; }
		window.location.hash = `#/PSRS/Sample/Create/ClonedFrom/${this._guidSample}`;
	}
	goToView()
	{
		if (this._guidSample) { window.location.hash = `#/PSRS/Sample/View/${this._guidSample}`; }
		else { this.backToList(); }
	}
	cancelForm()
	{
		const tmpHost = this.formHost;
		if (tmpHost && typeof tmpHost.destroy === 'function') { try { tmpHost.destroy(); } catch (pError) { /* best-effort */ } }
		if (this._mode === 'create') { this.backToList(); }
		else { this.goToView(); }
	}

	/** Save the config-driven form. Create -> ported SampleProvider.createSample (QR + log + location join); Edit -> updateSample. */
	async saveForm()
	{
		const tmpState = this.state;
		if (tmpState.Saving) { return; }
		const tmpHost = this.formHost;
		const tmpSampleProvider = this.pict.providers.SampleProvider;
		if (!tmpSampleProvider) { this._toast('The Sample save provider is not available.', 'error'); return; }
		if (!this.canCreate() && this._mode === 'create') { this._toast('You do not have permission to create samples.', 'error'); return; }
		if (!this.canEditForm() && this._mode === 'edit') { this._toast('You do not have permission to edit this sample.', 'error'); return; }
		if (tmpHost && typeof tmpHost.save === 'function') { try { tmpHost.save(); } catch (pError) { /* marshal best-effort */ } }
		const tmpSample = Object.assign({}, this.pict.AppData.SampleDetails || {});
		tmpState.Saving = true;
		try
		{
			let tmpResult;
			if (this._mode === 'create')
			{
				delete tmpSample.CreatingIDUser;
				tmpResult = await tmpSampleProvider.createSample(tmpSample, null, true);
			}
			else
			{
				tmpResult = await tmpSampleProvider.updateSample(tmpSample);
			}
			if (tmpResult && (tmpResult.IDSample || tmpResult.GUIDSample))
			{
				this._toast(this._mode === 'create' ? 'Sample created.' : 'Sample saved.', 'success');
				this._guidSample = tmpResult.GUIDSample || this._guidSample;
				this._manifestsByVerb = {};
				if (tmpHost && typeof tmpHost.destroy === 'function') { try { tmpHost.destroy(); } catch (pErr) { /* best-effort */ } }
				window.location.hash = `#/PSRS/Sample/View/${this._guidSample}`;
			}
			else
			{
				this._toast('The sample could not be saved (it may be locked).', 'error');
			}
		}
		catch (pError)
		{
			this._toast(`Save failed: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
		finally
		{
			tmpState.Saving = false;
		}
	}

	async deleteSample()
	{
		const tmpSample = this.state.Sample || {};
		if (!tmpSample.IDSample) { return; }
		if (!this.canDelete()) { this._toast('You do not have permission to delete this sample.', 'error'); return; }
		if (this.isLockedForUser()) { this._toast('This sample is locked and cannot be deleted.', 'error'); return; }
		const tmpSampleProvider = this.pict.providers.SampleProvider;
		try
		{
			if (tmpSampleProvider && typeof tmpSampleProvider.deleteSample === 'function')
			{
				await tmpSampleProvider.deleteSample(tmpSample.IDSample);
			}
			else
			{
				await new Promise((resolve) => this.restClient.deleteEntity('Sample', tmpSample.IDSample, () => resolve()));
			}
			this._toast('Sample deleted.', 'success');
			this.backToList();
		}
		catch (pError)
		{
			this._toast(`Delete failed: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
	}

	/**
	 * Pick the form theme for this mode before the form renders: the Read theme draws every field as display text
	 * (entity names resolved, no pickers), the Edit theme draws inputs. The theme is app-wide and other screens
	 * change it (the Samples list filter switches to Edit), so it has to be set here, as legacy LIMS did.
	 */
	_applyFormTheme()
	{
		const tmpApp = this.app;
		if (tmpApp && (typeof tmpApp.changeTheme === 'function'))
		{
			tmpApp.changeTheme((this._mode === 'view') ? 'Read' : 'Edit');
		}
	}

	/** View mode is read-only: lock the rendered form so the customer's View-manifest fields display (entities resolved) but cannot be edited. */
	_applyViewReadOnly()
	{
		try
		{
			const tmpHost = document.querySelector('#Sample-FormHost');
			if (!tmpHost) { return; }
			tmpHost.classList.add('sw-form-readonly');
			const tmpInputs = tmpHost.querySelectorAll('input, textarea');
			for (let i = 0; i < tmpInputs.length; i++) { tmpInputs[i].setAttribute('readonly', 'readonly'); tmpInputs[i].setAttribute('tabindex', '-1'); }
		}
		catch (pError) { /* decorative; ignore */ }
	}

	/**
	 * Print the Sample label: the same label LIMS prints, on this device's label stock.
	 * @param {boolean} [pShowOptions] - Open Print options (label stock and preview) instead of printing right away.
	 */
	async printLabel(pShowOptions)
	{
		const tmpSample = this.state.Sample || {};
		const tmpQR = this.pict.providers.QRCodeProvider;
		if (!tmpQR || !tmpSample.QRCode)
		{
			this._toast('QR label printing is not available for this sample.', 'error');
			return;
		}
		// The customer's label layout (LIMS-Sample-Printable); this app doesn't load it at startup as LIMS does.
		await tmpQR.ensurePrintableManifests();
		// printDecoratedEntity answers null only when the label couldn't be built.
		if (await tmpQR.printDecoratedEntity('Sample', tmpSample.QRCode, undefined, undefined, tmpSample, { ShowOptions: !!pShowOptions }) === null)
		{
			this._toast('The label could not be printed. Check your connection and try again.', 'error');
		}
	}

	/** Render the QR thumbnail into a container element (the view calls this after it paints the header). */
	renderQRThumbnail(pContainerSelector)
	{
		const tmpSample = this.state.Sample || {};
		const tmpQR = this.pict.providers.HeadlightQR;
		if (!tmpQR || !tmpSample.QRCode)
		{
			return;
		}
		try
		{
			const tmpContainer = document.querySelector(pContainerSelector);
			if (!tmpContainer)
			{
				return;
			}
			tmpContainer.innerHTML = tmpQR.renderSVG(tmpQR.encode('Sample', String(tmpSample.QRCode)), { SizePX: 128, Title: `QR ${tmpSample.QRCode}` });
		}
		catch (pError)
		{
			// The thumbnail is decorative.
		}
	}

	// --- Line-item mutations (LineItemProvider.saveSampleLineItemJoin/deleteSampleLineItemJoin + qty rollup) ------
	get lineItemAddState()
	{
		if (!this.state.LineItemAdd)
		{
			this.state.LineItemAdd = { Open: false, IDProject: 0, IDLineItem: 0, Quantity: 0 };
		}
		return this.state.LineItemAdd;
	}

	async _reloadLineItemsAsync()
	{
		const tmpLineItemProvider = this.pict.providers.LineItemProvider;
		this.state.LineItems = (tmpLineItemProvider && typeof tmpLineItemProvider.getLineItemsByIDSample === 'function')
			? (await tmpLineItemProvider.getLineItemsByIDSample(this._idSample)) || []
			: [];
	}

	/**
	 * The sample's represented quantity: the sum of its line items' represented quantities.
	 * @param {Array<Record<string, any>>} pLineItems - the sample's line items, each carrying its join's RepresentedQuantity
	 * @return {number}
	 */
	static sumRepresentedQuantity(pLineItems)
	{
		let tmpQuantity = 0;
		for (const tmpLI of (pLineItems || []))
		{
			tmpQuantity += Number(tmpLI && tmpLI.RepresentedQuantity) || 0;
		}
		return tmpQuantity;
	}

	/**
	 * Recompute Sample.RepresentedQuantity = sum of the line-item join quantities, then PUT Sample/Upsert (the LIMS rollup
	 * invariant). Throws when the sample can't be saved, so the caller says the total did not update.
	 * @return {Promise<void>}
	 */
	async _updateSampleQuantityFromLineItemsAsync()
	{
		const tmpSampleProvider = this.pict.providers.SampleProvider;
		if (!tmpSampleProvider || (typeof tmpSampleProvider.updateSample !== 'function'))
		{
			throw new Error('The sample save provider is not available.');
		}
		const tmpQuantity = SampleWorkspaceProvider.sumRepresentedQuantity(this.state.LineItems);
		const tmpSaved = await tmpSampleProvider.updateSample({ IDSample: this.state.Sample.IDSample, GUIDSample: this.state.Sample.GUIDSample, RepresentedQuantity: tmpQuantity });
		this.state.Sample.RepresentedQuantity = (tmpSaved && (tmpSaved.RepresentedQuantity !== undefined)) ? tmpSaved.RepresentedQuantity : tmpQuantity;
	}

	/**
	 * After a line item change: reload the list and roll the total up onto the sample, telling the user if the total
	 * could not be saved (the line item change itself already went through).
	 * @param {string} pDoneMessage
	 * @return {Promise<void>}
	 */
	async _afterLineItemChangeAsync(pDoneMessage)
	{
		await this._reloadLineItemsAsync();
		try
		{
			await this._updateSampleQuantityFromLineItemsAsync();
			this._toast(pDoneMessage, 'success');
		}
		catch (pError)
		{
			this._toast(`${pDoneMessage} The sample's represented quantity could not be updated: ${(pError && pError.message) || pError}`, 'error');
		}
		if (this.view) { this.renderWorkspace(); }
	}

	toggleLineItemAdd()
	{
		const tmpAdd = this.lineItemAddState;
		tmpAdd.Open = !tmpAdd.Open;
		tmpAdd.IDLineItem = 0;
		tmpAdd.Quantity = 0;
		// Start from the sample's own project; the user can pick another.
		tmpAdd.IDProject = (tmpAdd.Open && this.state.Sample && this.state.Sample.IDProject) ? Number(this.state.Sample.IDProject) : 0;
		if (this.view) { this.repaintBody(); }
	}

	/**
	 * The add form's Project picker changed: the Line Item picker lists that project's line items.
	 * @param {any} pIDProject
	 */
	selectLineItemProject(pIDProject)
	{
		const tmpAdd = this.lineItemAddState;
		const tmpID = parseInt(pIDProject, 10) || 0;
		if (tmpID === Number(tmpAdd.IDProject))
		{
			return;
		}
		tmpAdd.IDProject = tmpID;
		tmpAdd.IDLineItem = 0;
		this._mountLineItemPicker();
	}

	async addLineItem()
	{
		const tmpAdd = this.lineItemAddState;
		if (!this.canUpdate()) { this._toast('You do not have permission to modify this sample.', 'error'); return; }
		if (this.isLockedForUser())
		{
			this._toastLocked();
			return;
		}
		if (!Number(tmpAdd.IDLineItem)) { this._toast('Select a line item to add.', 'error'); return; }
		const tmpLineItemProvider = this.pict.providers.LineItemProvider;
		try
		{
			await tmpLineItemProvider.saveSampleLineItemJoin({ IDSample: this._idSample, IDLineItem: Number(tmpAdd.IDLineItem), RepresentedQuantity: Number(tmpAdd.Quantity) || 0 });
		}
		catch (pError)
		{
			this._toast(`Could not add line item: ${(pError && pError.message) || pError}`, 'error');
			return;
		}
		tmpAdd.Open = false; tmpAdd.IDLineItem = 0; tmpAdd.Quantity = 0;
		await this._afterLineItemChangeAsync('Line item added.');
	}

	/**
	 * Whether the user may change the sample's line items and tests; tells them why not when they can't.
	 * @return {boolean}
	 */
	_guardChangeSample()
	{
		if (!this.canUpdate())
		{
			this._toast('You do not have permission to modify this sample.', 'error');
			return false;
		}
		if (this.isLockedForUser())
		{
			this._toastLocked();
			return false;
		}
		return true;
	}

	async editLineItemQuantity(pIDJoin, pIDLineItem, pQuantity)
	{
		if (!this._guardChangeSample())
		{
			return;
		}
		const tmpLineItemProvider = this.pict.providers.LineItemProvider;
		const tmpJoin = (this.state.LineItems || []).find((pLI) => Number(pLI.IDSampleLineItemJoin) === Number(pIDJoin)) || {};
		const tmpPayload = { IDSampleLineItemJoin: Number(pIDJoin), IDSample: this._idSample, IDLineItem: Number(pIDLineItem), RepresentedQuantity: Number(pQuantity) || 0 };
		// Upsert by GUID as legacy LIMS did, so the existing join is updated rather than a second one created.
		if (tmpJoin.GUIDSampleLineItemJoin)
		{
			tmpPayload.GUIDSampleLineItemJoin = tmpJoin.GUIDSampleLineItemJoin;
		}
		try
		{
			await tmpLineItemProvider.saveSampleLineItemJoin(tmpPayload);
		}
		catch (pError)
		{
			this._toast(`Could not update quantity: ${(pError && pError.message) || pError}`, 'error');
			return;
		}
		await this._afterLineItemChangeAsync('Quantity updated.');
	}

	async removeLineItem(pIDJoin)
	{
		if (!this.canUpdate()) { this._toast('You do not have permission to modify this sample.', 'error'); return; }
		if (this.isLockedForUser())
		{
			this._toastLocked();
			return;
		}
		const tmpLineItemProvider = this.pict.providers.LineItemProvider;
		try
		{
			await tmpLineItemProvider.deleteSampleLineItemJoin(Number(pIDJoin));
		}
		catch (pError)
		{
			this._toast(`Could not remove line item: ${(pError && pError.message) || pError}`, 'error');
			return;
		}
		await this._afterLineItemChangeAsync('Line item removed.');
	}

	// --- Test instances (reuse the shared TestInstanceWizard panel — already registered by HeadlightPanels) --------
	async openTestWizard()
	{
		if (!this.canUpdate()) { this._toast('You do not have permission to modify this sample.', 'error'); return; }
		if (this.isLockedForUser())
		{
			this._toastLocked();
			return;
		}
		const tmpWizard = this.pict.views.TestInstanceWizard;
		if (!tmpWizard || (typeof tmpWizard.openTestInstanceWizard !== 'function')) { this._toast('The test wizard is not available.', 'error'); return; }
		// The wizard reads the sample from AppData.SampleDetails and offers the sample's unlocked documents
		// (AppData.ActiveLIMSSampleDocuments) to add the tests to. Never register a stand-in for the legacy
		// LIMSSampleRecordView: pict walks every registered view on solve and marshal, and a plain object there breaks
		// every form rendered afterwards (the Details tab looped and crashed the page).
		await this._ensureTabDataLoaded('documents');
		this.pict.AppData.SampleDetails = Object.assign({}, this.state.Sample || {});
		this.pict.AppData.ActiveLIMSSampleDocuments = this.state.Documents || [];
		try { tmpWizard.openTestInstanceWizard({ onTestsCreated: () => this._afterTestsCreated() }); }
		catch (pError) { this._toast(`Could not open the test wizard: ${(pError && pError.message) || pError}`, 'error'); }
	}

	/**
	 * The wizard saved new tests (and maybe new documents): reload both tabs' data.
	 * @return {Promise<void>}
	 */
	async _afterTestsCreated()
	{
		this._invalidateTab('documents');
		await this.refreshTestInstances();
	}

	/**
	 * Delete one of this sample's tests, after the user confirms.
	 * @param {number} pIDTestInstance
	 * @return {Promise<void>}
	 */
	async deleteTestInstance(pIDTestInstance)
	{
		if (!this.canUpdate() || !this._canHash('TestInstance-Delete'))
		{
			this._toast('You do not have permission to delete tests.', 'error');
			return;
		}
		if (this.isLockedForUser())
		{
			this._toastLocked();
			return;
		}
		const tmpTestProvider = this.pict.providers.TestInstanceProvider;
		if (!(pIDTestInstance > 0) || !tmpTestProvider || (typeof tmpTestProvider.deleteTestInstanceByID !== 'function'))
		{
			return;
		}
		const tmpModal = this.pict.views && this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || (typeof tmpModal.confirm !== 'function'))
		{
			this._toast('Could not ask to confirm the delete, so the test was kept.', 'error');
			return;
		}
		if (!(await tmpModal.confirm('Delete this test from the sample?', { title: 'Delete test', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true })))
		{
			return;
		}
		try
		{
			await tmpTestProvider.deleteTestInstanceByID(pIDTestInstance);
			this._toast('Test deleted.', 'success');
		}
		catch (pError)
		{
			this._toast(`Could not delete the test: ${(pError && pError.message) || pError}`, 'error');
		}
		await this.refreshTestInstances();
	}

	async refreshTestInstances()
	{
		this._invalidateTab('testinstances');
		await this._ensureTabDataLoaded('testinstances');
		if (this.view) { this.renderWorkspace(); }
	}

	// --- Documents (reuse the shared HeadlightPaneDocuments panel) -------------------------------------------
	attachDocument(pCreateMode)
	{
		if (!this.canUpdate()) { this._toast('You do not have permission to modify this sample.', 'error'); return; }
		const tmpPane = this.pict.views.HeadlightPaneDocuments;
		const tmpPanels = this.pict.views.HeadlightPanels;
		if (!tmpPane || !tmpPanels) { this._toast('The document panel is not available.', 'error'); return; }
		this.pict.AppData.SampleDetails = this.state.Sample || {};
		tmpPane.Intent =
		{
			type: 'add',
			handler: (pIDDocument) => { this._documentAttachHandler(pIDDocument); },
			afterRenderHandler: () =>
			{
				const tmpSample = this.state.Sample || {};
				if (tmpSample.IDProject && this.pict.views.DocumentCreate && this.pict.views.DocumentCreate.CurrentDocumentRecord)
				{
					this.pict.views.DocumentCreate.CurrentDocumentRecord.Project = tmpSample.IDProject;
				}
			},
		};
		tmpPanels.handlePanelToggle('Documents', 'open');
		if (pCreateMode && (typeof tmpPanels.toggleTabContent === 'function'))
		{
			try { tmpPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Create', 'Document'); } catch (pError) { /* best-effort */ }
		}
	}

	async _documentAttachHandler(pIDDocument)
	{
		try
		{
			await this.pict.providers.DocumentProvider.addRemoteToDocument(pIDDocument, this._idSample, 'Sample');
			try { this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'close'); } catch (pError) { /* best-effort */ }
			this._invalidateTab('documents');
			await this._ensureTabDataLoaded('documents');
			this._toast('Document attached.', 'success');
			if (this.view) { this.renderWorkspace(); }
		}
		catch (pError) { this._toast(`Could not attach document: ${(pError && pError.message) || pError}`, 'error'); }
	}

	async addLog()
	{
		const tmpState = this.state;
		const tmpNotes = (tmpState.NewLogNotes || '').trim();
		if (!tmpNotes || !this._idSample) { return; }
		const tmpLogProvider = this.pict.providers.SampleLogProvider;
		try
		{
			if (tmpLogProvider && typeof tmpLogProvider.addNote === 'function')
			{
				// Read fresh: the sample may have moved since the Location tab last loaded.
				await this._locationTab.loadAsync();
				const tmpIDLocation = Number((this._locationTab.state.Location || {}).IDLocation) || 0;
				await tmpLogProvider.addNote(this._idSample, tmpNotes, { IDLocation: tmpIDLocation });
			}
			tmpState.NewLogNotes = '';
			tmpState.Logs = await this._loadLogsAsync();
			this._toast('Log added.', 'success');
			if (this.view) { this.repaintBody(); }
		}
		catch (pError)
		{
			this._toast(`Could not add log: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
	}

	// --- Body renderers (ported from the old SampleWorkspace view; painted by the base `render` dispatch) --------

	/** Details tab (view) + the edit/create body: mount the config-driven manifest form into #Sample-FormHost. */
	renderForm()
	{
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', '<div id="Sample-FormHost" class="sw-form-host"></div>');
		this.mountFormAsync();
	}

	_tabActionsHTML(pInnerHTML) { return `<div class="sw-toolbar">${pInnerHTML}</div>`; }
	_empty(pText) { return `<div class="sw-empty"><i class="fas fa-inbox"></i><p>${this._esc(pText)}</p></div>`; }

	_statusClass(pCode)
	{
		const tmpCode = String(pCode || '').toUpperCase();
		if (tmpCode === 'PASS' || tmpCode === 'PASC') { return 'is-pass'; }
		if (tmpCode === 'FAIL' || tmpCode === 'FAIC') { return 'is-fail'; }
		if (tmpCode === 'VOID') { return 'is-void'; }
		if (tmpCode === 'PEND' || tmpCode === 'TEST' || tmpCode === 'TSTR') { return 'is-pending'; }
		return 'is-neutral';
	}
	_tiStatusClass(pStatus)
	{
		const tmpS = String(pStatus || '').toLowerCase();
		if (tmpS.indexOf('pass') > -1 || tmpS.indexOf('sqty') > -1) { return 'is-pass'; }
		if (tmpS.indexOf('fail') > -1) { return 'is-fail'; }
		return 'is-neutral';
	}

	/**
	 * @param {String} pTone - a SampleTest-Rules tone ('success' | 'danger' | ...)
	 * @return {String} the sw-chip class for it
	 */
	_toneClass(pTone)
	{
		if (pTone === 'success')
		{
			return 'is-pass';
		}
		if (pTone === 'danger')
		{
			return 'is-fail';
		}
		return 'is-neutral';
	}

	/**
	 * The marker beside a value a form holds until it is approved, or '' when the value is the test's own.
	 * @param {?Object} pDocument - the unapproved document the value comes from
	 * @return {String}
	 */
	_tiPendingHTML(pDocument)
	{
		if (!pDocument)
		{
			return '';
		}
		const tmpName = pDocument.Name || `Document #${pDocument.IDDocument}`;
		return ` <span class="sw-ti-pending" title="${this._esc(`From ${tmpName}. Saved to the test when the form is approved.`)}">(pending approval)</span>`;
	}

	_fmtDate(pDate)
	{
		if (!pDate) { return ''; }
		const tmpStr = String(pDate);
		return (tmpStr.indexOf('T') > -1) ? tmpStr.slice(0, 10) : tmpStr;
	}

	/** A date and time the way legacy LIMS showed them ("October 28, 2026 - 06:27 PM"). */
	_fmtDateTime(pDate)
	{
		if (!pDate) { return ''; }
		try
		{
			const tmpDay = this.pict.fable.Dates.dayJS(pDate);
			return tmpDay.isValid() ? tmpDay.format('MMMM DD, YYYY - hh:mm a') : this._fmtDate(pDate);
		}
		catch (pError) { return this._fmtDate(pDate); }
	}

	// --- entity names + tooltips (legacy LIMS {~Entity:~} / {~QuickSummary:~}) -------------------------------
	/**
	 * The entity popover button legacy LIMS put next to related records ({~QuickSummary:<Entity>^<ID>~}).
	 * @param {string} pEntity
	 * @param {any} pID
	 * @return {string} markup, or '' when the popover service isn't in this app or there is no ID
	 */
	_quickSummaryHTML(pEntity, pID)
	{
		const tmpID = Number(pID) || 0;
		if (!tmpID || !this.pict.services || !this.pict.services.HeadlightQuickSummaries) { return ''; }
		try { return this.pict.parseTemplate(`{~QuickSummary:${pEntity}^${tmpID}~}`, {}); }
		catch (pError) { return ''; }
	}

	/**
	 * Load the summary layouts the popovers use, once: legacy LIMS's defaults, overridden by the customer's
	 * LIMS-<Entity>-Summary rows. Best-effort; without them the popover builds one from the entity's schema.
	 * @return {Promise<void>}
	 */
	_ensureSummaryManifestsAsync()
	{
		if (!this._summaryManifestsLoad)
		{
			const tmpService = this.pict.services.ManifestPackagingService || this.pict.ManifestPackagingService;
			this._summaryManifestsLoad = (tmpService && (typeof tmpService.loadQuickSummaryManifests === 'function') && this.pict.services.HeadlightQuickSummaries)
				? tmpService.loadQuickSummaryManifests(Object.keys(DEFAULT_SUMMARY_MANIFESTS), JSON.parse(JSON.stringify(DEFAULT_SUMMARY_MANIFESTS)), LIMS_PRODUCT)
					.catch((pError) => { this.pict.log.warn(`SampleWorkspace: summary layouts did not load: ${(pError && pError.message) || pError}`); })
				: Promise.resolve();
		}
		return this._summaryManifestsLoad;
	}

	/**
	 * Fetch display names for records not already cached.
	 * @param {Record<number, string>} pCache - ID -> name, filled in place
	 * @param {string} pCollection - e.g. 'Users'
	 * @param {string} pIDField - e.g. 'IDUser'
	 * @param {Array<any>} pIDs
	 * @param {(pRecord: Record<string, any>) => string} fName
	 * @return {Promise<void>}
	 */
	async _loadNamesAsync(pCache, pCollection, pIDField, pIDs, fName)
	{
		const tmpMissing = [ ...new Set((pIDs || []).map((pID) => Number(pID) || 0)) ].filter((pID) => pID && !(pID in pCache));
		if (!tmpMissing.length) { return; }
		const tmpRows = await this._getJSON(`${pCollection}/FilteredTo/FBL~${pIDField}~INN~${tmpMissing.join(',')}/0/${tmpMissing.length}`);
		for (const tmpID of tmpMissing) { pCache[tmpID] = ''; }
		for (const tmpRow of (Array.isArray(tmpRows) ? tmpRows : []))
		{
			pCache[Number(tmpRow[pIDField])] = fName(tmpRow) || '';
		}
	}
	_loadUserNamesAsync(pIDs)
	{
		return this._loadNamesAsync(this._userNames, 'Users', 'IDUser', pIDs,
			(pUser) => `${pUser.NameFirst || ''} ${pUser.NameLast || ''}`.trim() || pUser.LoginID || pUser.Email || '');
	}
	_userName(pIDUser)
	{
		const tmpID = Number(pIDUser) || 0;
		if (!tmpID) { return ''; }
		return this._userNames[tmpID] || `User #${tmpID}`;
	}
	/** "on <date> by <user>", as legacy LIMS wrote it under each line item, test and log. */
	_createdLineHTML(pRecord)
	{
		const tmpWhen = this._fmtDateTime(pRecord && pRecord.CreateDate);
		const tmpWho = this._userName(pRecord && pRecord.CreatingIDUser);
		if (!tmpWhen && !tmpWho) { return ''; }
		return `<span class="sw-muted">${tmpWhen ? `on ${this._esc(tmpWhen)}` : ''}${tmpWho ? ` by ${this._esc(tmpWho)}` : ''}</span>`;
	}

	/**
	 * Names the tab rows show that aren't on the rows themselves (creating users, line item projects). Re-paints the
	 * tab once they arrive if it is still showing.
	 * @param {string} pTab
	 * @param {Array<any>} pUserIDs
	 * @param {Array<any>} [pProjectIDs]
	 */
	_resolveRowNames(pTab, pUserIDs, pProjectIDs)
	{
		this._projectNames = this._projectNames || {};
		const tmpBefore = JSON.stringify([ this._userNames, this._projectNames ]);
		Promise.all(
			[
				this._loadUserNamesAsync(pUserIDs),
				this._loadNamesAsync(this._projectNames, 'Projects', 'IDProject', pProjectIDs || [], (pProject) => pProject.Name || ''),
			])
			.then(() =>
			{
				if ((this._activeTab === pTab) && !this.isEditing && (JSON.stringify([ this._userNames, this._projectNames ]) !== tmpBefore))
				{
					this.repaintBody();
				}
			})
			.catch(() => { /* names stay as IDs */ });
	}

	renderLineItems()
	{
		if (this._renderTabPending('lineitems', 'line items'))
		{
			return;
		}
		const tmpRows = this.state.LineItems || [];
		const tmpCanEdit = this.canChangeSample();
		this._projectNames = this._projectNames || {};
		this._resolveRowNames('lineitems', tmpRows.map((pR) => pR.CreatingIDUser), tmpRows.map((pR) => pR.IDProject));
		const tmpBody = tmpRows.map((pR) =>
		{
			const tmpActions = tmpCanEdit ? `
				<td class="sw-row-actions">
					<button class="button is-tiny is-light" onclick="_Pict.providers.SampleWorkspace.promptEditLineItemQty(${Number(pR.IDSampleLineItemJoin) || 0}, ${Number(pR.IDLineItem) || 0}, ${Number(pR.RepresentedQuantity) || 0})" title="Edit quantity"><i class="fas fa-pen"></i></button>
					<button class="button is-tiny is-danger is-light" onclick="_Pict.providers.SampleWorkspace.removeLineItem(${Number(pR.IDSampleLineItemJoin) || 0})" title="Remove"><i class="fas fa-times"></i></button>
				</td>` : '<td></td>';
			const tmpProject = pR.IDProject ? (this._projectNames[Number(pR.IDProject)] || `Project #${pR.IDProject}`) : '';
			return `<tr>
				<td><span class="sw-cell-strong">${this._esc(pR.Name || pR.ItemNumber || '—')}</span> ${this._quickSummaryHTML('LineItem', pR.IDLineItem)}<div class="sw-subrow">${this._createdLineHTML(pR)}</div></td>
				<td>${this._esc(pR.Description || '')}</td>
				<td>${this._esc(tmpProject)} ${this._quickSummaryHTML('Project', pR.IDProject)}</td>
				<td class="sw-num">${this._esc(pR.RepresentedQuantity !== undefined ? pR.RepresentedQuantity : '')}</td>
				<td>${this._esc(pR.ItemCode || '')}</td>
				${tmpActions}
			</tr>`;
		}).join('');
		const tmpTable = tmpRows.length
			? `<div class="sw-tablewrap"><table class="sw-table"><thead><tr><th>Item</th><th>Description</th><th>Project</th><th class="sw-num">Represented Qty</th><th>Item Code</th><th></th></tr></thead><tbody>${tmpBody}</tbody></table></div>`
			: this._empty('No line items are linked to this sample.');
		const tmpSample = this.state.Sample || {};
		const tmpTotal = `<span class="sw-total">Sample represented quantity: <b>${this._esc((tmpSample.RepresentedQuantity !== undefined && tmpSample.RepresentedQuantity !== null && tmpSample.RepresentedQuantity !== '') ? tmpSample.RepresentedQuantity : '—')}</b></span>`;
		const tmpAddBtn = tmpCanEdit ? `<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.toggleLineItemAdd()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add Line Item</span></button>` : '';
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', `${this._tabActionsHTML(`${tmpAddBtn}${tmpTotal}`)}${this._lineItemAddFormHTML()}${tmpTable}`);
		if (this.lineItemAddState.Open)
		{
			this._mountLineItemPickers();
		}
	}

	_lineItemAddFormHTML()
	{
		const tmpAdd = this.lineItemAddState;
		if (!tmpAdd.Open || !this.canChangeSample()) { return ''; }
		return `<div class="sw-add-form">
			<div class="sw-add-row">
				<div class="sw-add-field"><span class="sw-add-label">Line item's project</span><div id="SampleWorkspace-LI-ProjectPicker" class="sw-add-picker"></div></div>
				<div class="sw-add-field"><span class="sw-add-label">Line item</span><div id="SampleWorkspace-LI-LineItemPicker" class="sw-add-picker"></div></div>
				<div class="sw-add-field"><span class="sw-add-label">Represented quantity</span><input class="sw-input sw-add-qty" type="number" placeholder="0" value="${this._esc(tmpAdd.Quantity || '')}" oninput="_Pict.providers.SampleWorkspace.lineItemAddState.Quantity = this.value"></div>
			</div>
			<div class="sw-add-row">
				<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.addLineItem()">Add</button>
				<button class="button is-small is-light" onclick="_Pict.providers.SampleWorkspace.toggleLineItemAdd()">Cancel</button>
			</div>
		</div>`;
	}

	/** Mount the add form's entity pickers (pict-section-picker, server-side search), as the other workspaces do. */
	_mountLineItemPickers()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#SampleWorkspace-LI-ProjectPicker').length > 0)
		{
			const tmpPicker = tmpPickerProvider.createPicker('SampleWorkspace-LI-ProjectPicker',
				{
					DestinationAddress: '#SampleWorkspace-LI-ProjectPicker',
					ValueAddress: 'AppData.SampleWorkspace.LineItemAdd.PickerProject',
					Searchable: true,
					AllowClear: true,
					ClearLabel: '(none)',
					Placeholder: 'Search projects…',
					DataProvider: this._pickerDataProvider('Projects', 'IDProject', [ 'Name' ], () => '', (pRow) => pRow.Name),
					ResolveValue: this._pickerResolveValue('Project', 'IDProject', (pRow) => pRow.Name),
					OnChange: (pValue) => this.selectLineItemProject(pValue),
				});
			if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
			if (tmpPicker && (typeof tmpPicker.setValue === 'function')) { tmpPicker.setValue(this.lineItemAddState.IDProject || ''); }
		}
		this._mountLineItemPicker();
	}

	/** (Re)mount the Line Item picker for the project chosen in the add form. */
	_mountLineItemPicker()
	{
		const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
		if (!tmpPickerProvider || (typeof tmpPickerProvider.createPicker !== 'function')) { return; }
		if (this.pict.ContentAssignment.getElement('#SampleWorkspace-LI-LineItemPicker').length < 1) { return; }
		const tmpAdd = this.lineItemAddState;
		const tmpPicker = tmpPickerProvider.createPicker('SampleWorkspace-LI-LineItemPicker',
			{
				DestinationAddress: '#SampleWorkspace-LI-LineItemPicker',
				ValueAddress: 'AppData.SampleWorkspace.LineItemAdd.PickerLineItem',
				Searchable: true,
				AllowClear: true,
				ClearLabel: '(none)',
				Placeholder: tmpAdd.IDProject ? 'Search line items…' : 'Pick a project first',
				DataProvider: this._pickerDataProvider('LineItems', 'IDLineItem', [ 'Name', 'ItemNumber', 'Description' ],
					() => (Number(this.lineItemAddState.IDProject) ? `FBV~IDProject~EQ~${Number(this.lineItemAddState.IDProject)}` : null),
					(pRow) => `${pRow.ItemNumber ? `${pRow.ItemNumber} — ` : ''}${pRow.Name || pRow.Description || ''}`),
				ResolveValue: this._pickerResolveValue('LineItem', 'IDLineItem', (pRow) => pRow.Name),
				OnChange: (pValue) => { this.lineItemAddState.IDLineItem = parseInt(pValue, 10) || 0; },
			});
		if (tmpPicker && (typeof tmpPicker.render === 'function')) { tmpPicker.render(); }
		if (tmpPicker && (typeof tmpPicker.setValue === 'function')) { tmpPicker.setValue(tmpAdd.IDLineItem || ''); }
	}

	/**
	 * A server-side search DataProvider for a picker: `(searchTerm, page) => Promise<{ results, hasMore }>`.
	 * @param {string} pCollection
	 * @param {string} pIDField
	 * @param {Array<string>} pSearchFields
	 * @param {() => ?string} fScope - extra FoxHound filter; null means list nothing yet
	 * @param {(pRow: Record<string, any>) => string} fText
	 */
	_pickerDataProvider(pCollection, pIDField, pSearchFields, fScope, fText)
	{
		const tmpPageSize = 25;
		return (pSearchTerm, pPage) =>
		{
			const tmpScope = fScope();
			if (tmpScope === null) { return Promise.resolve({ results: [], hasMore: false }); }
			const tmpPickerProvider = this.pict.providers['Pict-Section-Picker'];
			let tmpFilter = `FBV~Deleted~EQ~0${tmpScope ? `~${tmpScope}` : ''}`;
			const tmpTerm = String(pSearchTerm == null ? '' : pSearchTerm).replace(/~/g, '').trim();
			if (tmpTerm && tmpPickerProvider && (typeof tmpPickerProvider.buildSearchFilter === 'function'))
			{
				tmpFilter += `~${tmpPickerProvider.buildSearchFilter(pSearchFields, tmpTerm)}`;
			}
			const tmpStart = (Number(pPage) || 0) * tmpPageSize;
			return this._getJSON(`${pCollection}/FilteredTo/${tmpFilter}~FSF~${pSearchFields[0]}~ASC~0/${tmpStart}/${tmpPageSize}`)
				.then((pRows) =>
				{
					const tmpList = Array.isArray(pRows) ? pRows : [];
					return { results: tmpList.map((pRow) => ({ Value: Number(pRow[pIDField]), Text: fText(pRow) || `#${pRow[pIDField]}`, Record: pRow })), hasMore: (tmpList.length >= tmpPageSize) };
				})
				.catch(() => ({ results: [], hasMore: false }));
		};
	}

	/** Resolve a preselected ID to { Value, Text } so the picker shows its name on first render. */
	_pickerResolveValue(pEntity, pIDField, fText)
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue) || 0;
			if (!tmpID) { return Promise.resolve(null); }
			return this._getJSON(`${pEntity}/${tmpID}`)
				.then((pRow) => ({ Value: tmpID, Text: (pRow && pRow[pIDField] && fText(pRow)) || `#${tmpID}` }))
				.catch(() => ({ Value: tmpID, Text: `#${tmpID}` }));
		};
	}

	/**
	 * Ask for a line item's new represented quantity in the app's modal, then save it.
	 * @param {number} pIDJoin
	 * @param {number} pIDLineItem
	 * @param {number} pCurrentQty
	 * @return {Promise<void>}
	 */
	async promptEditLineItemQty(pIDJoin, pIDLineItem, pCurrentQty)
	{
		if (!this._guardChangeSample())
		{
			return;
		}
		const tmpModal = this.pict.views && this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || (typeof tmpModal.show !== 'function'))
		{
			this._toast('The quantity editor is not available.', 'error');
			return;
		}
		let tmpInput = null;
		const tmpChoice = await tmpModal.show(
			{
				title: 'Edit represented quantity',
				closeable: true,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'save', Label: 'Save', Style: 'primary' } ],
				onOpen: (pDialog) =>
				{
					tmpInput = this._appendQuantityInput(pDialog, pCurrentQty);
				},
			});
		if ((tmpChoice !== 'save') || !tmpInput)
		{
			return;
		}
		await this.editLineItemQuantity(pIDJoin, pIDLineItem, tmpInput.value);
	}

	/**
	 * Put a labelled number input in a PSM dialog's body; Enter presses the dialog's Save button.
	 * @param {HTMLElement} pDialog
	 * @param {number} pCurrentQty
	 * @return {HTMLInputElement|null}
	 */
	_appendQuantityInput(pDialog, pCurrentQty)
	{
		const tmpBody = pDialog && pDialog.querySelector('.pict-modal-dialog-body');
		if (!tmpBody)
		{
			return null;
		}
		const tmpLabel = document.createElement('label');
		tmpLabel.className = 'label';
		tmpLabel.setAttribute('for', 'SampleWorkspace-LI-QtyInput');
		tmpLabel.textContent = 'Represented quantity';
		const tmpInput = document.createElement('input');
		tmpInput.id = 'SampleWorkspace-LI-QtyInput';
		tmpInput.className = 'input';
		tmpInput.type = 'number';
		tmpInput.step = 'any';
		tmpInput.value = String(Number(pCurrentQty) || 0);
		tmpInput.addEventListener('keydown', (pEvent) =>
		{
			if (pEvent.key !== 'Enter')
			{
				return;
			}
			const tmpSave = pDialog.querySelector('.pict-modal-btn[data-hash="save"]');
			if (tmpSave)
			{
				tmpSave.click();
			}
		});
		tmpBody.append(tmpLabel, tmpInput);
		tmpInput.focus();
		tmpInput.select();
		return tmpInput;
	}

	renderTestInstances()
	{
		if (this._renderTabPending('testinstances', 'tests'))
		{
			return;
		}
		const tmpRows = libSampleTestRules.buildTestSummary(this.state.TestInstanceBundle);
		const tmpCanChange = this.canChangeSample();
		const tmpAddBtn = tmpCanChange ? this._tabActionsHTML(`<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.openTestWizard()"><span class="icon"><i class="fas fa-flask-vial"></i></span><span>Add Tests</span></button>`) : '';
		if (!tmpRows.length)
		{
			this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', `${tmpAddBtn}${this._empty('No tests are linked to this sample.')}`);
			return;
		}
		this._resolveRowNames('testinstances', tmpRows.map((pRow) => pRow.TestInstance.CreatingIDUser));
		const tmpMarkdown = this.pict.providers.MarkdownProvider;
		const tmpBody = tmpRows.map((pRow) =>
		{
			const tmpTI = pRow.TestInstance;
			let tmpRemarks = '';
			if (pRow.Notes)
			{
				tmpRemarks = (tmpMarkdown && (typeof tmpMarkdown.getRemarksAsHTML === 'function')) ?
					tmpMarkdown.getRemarksAsHTML(pRow.Notes, { Clamp: true }) :
					this._esc(pRow.Notes);
				tmpRemarks += this._tiPendingHTML(pRow.NotesDocument);
			}
			const tmpDocuments = pRow.Documents.map((pEntry) =>
			{
				const tmpDoc = pEntry.Document;
				const tmpDocStatus = pEntry.Status ? ` <span class="sw-chip ${this._toneClass(pEntry.StatusTone)}" title="Form status">${this._esc(pEntry.Status)}</span>` : '';
				const tmpDocName = this._esc(tmpDoc.Name || `Document #${tmpDoc.IDDocument}`);
				return `<div class="sw-ti-doc"><a href="javascript:void(0)" onclick="_Pict.providers.SampleWorkspace.openDocument(${Number(tmpDoc.IDDocument) || 0})">${tmpDocName}</a> ${this._quickSummaryHTML('Document', tmpDoc.IDDocument)}${tmpDocStatus}</div>`;
			}).join('');
			return `<tr>
				<td><span class="sw-cell-strong">${this._esc(pRow.Name)}</span> ${this._quickSummaryHTML('TestInstance', tmpTI.IDTestInstance)}<div class="sw-subrow">${this._createdLineHTML(tmpTI)}</div></td>
				<td><span class="sw-chip ${this._tiStatusClass(pRow.Result)}">${this._esc(pRow.Result || '—')}</span>${this._tiPendingHTML(pRow.ResultDocument)}</td>
				<td>${this._esc(tmpTI.SampleTestNumber || '')}</td>
				<td class="sw-ti-remarks">${tmpRemarks || '<span class="sw-muted">N/A</span>'}</td>
				<td>${tmpDocuments || '<span class="sw-muted">None</span>'}</td>
				${tmpCanChange ? `<td class="sw-row-actions"><button class="button is-tiny is-danger is-light" onclick="_Pict.providers.SampleWorkspace.deleteTestInstance(${Number(tmpTI.IDTestInstance) || 0})" title="Delete this test"><i class="fas fa-trash"></i></button></td>` : '<td></td>'}
			</tr>`;
		}).join('');
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body',
			`${tmpAddBtn}<div class="sw-tablewrap"><table class="sw-table"><thead><tr><th>Test</th><th>Status</th><th>Test #</th><th>Remarks</th><th>Attached Documents</th><th></th></tr></thead><tbody>${tmpBody}</tbody></table></div>`);
	}

	/**
	 * Documents tab: the sample's documents in the DocumentFrameSwitcher — a rail to switch between them and each one open in
	 * its own frame running the longhand form page, so edits, saves and approval actions behave exactly as they do there.
	 * The switcher's frames outlive this markup (tab switches, repaints, Edit and back), so open work is kept while the
	 * sample is.
	 */
	renderDocuments()
	{
		if (this._renderTabPending('documents', 'documents'))
		{
			return;
		}
		const tmpHidden = Number(this.state.InaccessibleDocumentCount) || 0;
		const tmpRailNote = (tmpHidden > 0)
			? `There ${(tmpHidden === 1) ? 'is 1 document' : `are ${tmpHidden} documents`} for this sample you do not have access to. If you think this is incorrect, please reach out to a supervisor.`
			: '';
		const tmpAddBtn = this.canUpdate() ? this._tabActionsHTML(`
			<button class="button is-small is-light" onclick="_Pict.providers.SampleWorkspace.attachDocument(false)"><span class="icon"><i class="fas fa-paperclip"></i></span><span>Attach Document</span></button>
			<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.attachDocument(true)"><span class="icon"><i class="fas fa-plus"></i></span><span>New Document</span></button>`) : '';
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', `${tmpAddBtn}<div id="SampleWorkspace-HiddenMedia"></div><div id="SampleWorkspace-DocFrames" class="sw-docframes"></div>`);
		const tmpSwitcher = this.pict.providers.DocumentFrameSwitcher;
		if (!tmpSwitcher)
		{
			return;
		}
		const tmpGUID = this._guidSample;
		tmpSwitcher.attach(
			{
				OwnerKey: `Sample:${tmpGUID}`,
				OwnerMatch: (pHash) => this.isOwnHash(pHash),
				AnchorID: 'SampleWorkspace-DocFrames',
				Documents: this._switcherDocuments(),
				RailNote: tmpRailNote,
			});
		this._loadDocumentTestsAsync();
		this._loadDocumentMediaAsync();
		this._loadHiddenDocumentMediaAsync();
		const tmpPendingOpen = this._pendingDocumentOpen;
		this._pendingDocumentOpen = 0;
		if (tmpPendingOpen)
		{
			tmpSwitcher.open(tmpPendingOpen);
		}
	}

	/**
	 * The sample's documents for the switcher rail, in story order (creation form, tests, authorization), each with its
	 * form's name, the tests its form covers (and which of them this sample assigned to it) and how many media
	 * observations it holds.
	 * @return {Array<Object>}
	 */
	_switcherDocuments()
	{
		const tmpCatalog = this._formTestCatalogs[Number(this.state.Sample && this.state.Sample.IDCustomer) || 0];
		const tmpBundle = this.state.TestInstanceBundle;
		return libSampleTestRules.orderDocumentStory(this.state.Documents, tmpCatalog).map((pDocument) =>
		{
			const tmpType = tmpCatalog && tmpCatalog.Types[pDocument.DocumentType];
			return Object.assign({}, pDocument,
				{
					FormName: (tmpType && tmpType.FormName) || '',
					Tests: libSampleTestRules.getDocumentTests(pDocument, tmpCatalog, tmpBundle),
					Media: this._documentMedia.Counts[pDocument.IDDocument] || {},
				});
		});
	}

	/**
	 * Load what the rail needs to name each document's tests, then repaint it: the tests each form type declares (its
	 * RNI's Options.TestHashes, cached per customer) and this sample's test instances (the Tests tab's data). Two batched
	 * reads for the catalog, never one per document; the rail shows the plain labels until they land.
	 * @return {Promise<void>}
	 */
	async _loadDocumentTestsAsync()
	{
		const tmpIDSample = this._idSample;
		const tmpIDCustomer = Number(this.state.Sample && this.state.Sample.IDCustomer) || 0;
		if (!tmpIDSample || !tmpIDCustomer)
		{
			return;
		}
		const tmpCatalog = this._formTestCatalogs[tmpIDCustomer] || (this._formTestCatalogs[tmpIDCustomer] = { Types: {}, Tests: {} });
		const tmpNewTypes = [ ...new Set((this.state.Documents || []).map((pDocument) => pDocument.DocumentType)) ]
			.filter((pType) => pType && !tmpCatalog.Types[pType] && (pType.indexOf(',') < 0));
		await Promise.all([ this._ensureTabDataLoaded('testinstances'), this._loadFormTestTypesAsync(tmpCatalog, tmpIDCustomer, tmpNewTypes) ]);
		this._repaintSwitcherDocuments(tmpIDSample);
	}

	/**
	 * Count the media observations joined to each of the sample's documents, then repaint the rail. Paged joins, then
	 * the observations in batches; skipped when the document list has not changed since the last count.
	 * @return {Promise<void>}
	 */
	async _loadDocumentMediaAsync()
	{
		const tmpIDSample = this._idSample;
		const tmpIDDocuments = (this.state.Documents || []).map((pDocument) => Number(pDocument.IDDocument)).filter((pID) => pID > 0);
		const tmpKey = `${tmpIDSample}:${tmpIDDocuments.join(',')}`;
		if (!tmpIDSample || !tmpIDDocuments.length || (this._documentMedia.Key === tmpKey))
		{
			return;
		}
		const tmpRead = await this._readDocumentObservationsAsync(tmpIDDocuments);
		if (!tmpRead || (this._idSample !== tmpIDSample))
		{
			return;
		}
		this._documentMedia = { Key: tmpKey, Counts: libSampleDocumentDetails.countDocumentMedia(tmpRead.Joins, tmpRead.Observations) };
		this._repaintSwitcherDocuments(tmpIDSample);
	}

	/**
	 * Load the photos and videos of the sample's documents the user may not open, then paint them above the switcher.
	 * The joins come from the sample's media route; the observations are read through their own gate, so only media
	 * the user may already read comes back.
	 * @return {Promise<void>}
	 */
	async _loadHiddenDocumentMediaAsync()
	{
		const tmpIDSample = this._idSample;
		const tmpIDDocuments = (this.state.InaccessibleDocumentIDs || []).filter((pID) => pID > 0);
		const tmpKey = `${tmpIDSample}:${tmpIDDocuments.join(',')}`;
		if (this._hiddenDocumentMedia.Key === tmpKey)
		{
			this._renderHiddenDocumentMedia(tmpIDSample);
			return;
		}
		let tmpRead = { Joins: [], Observations: [] };
		if (tmpIDDocuments.length && Array.isArray(this.state.HiddenDocumentObservationJoins))
		{
			const tmpObservations = await this._readObservationsAsync(this.state.HiddenDocumentObservationJoins);
			tmpRead = tmpObservations ? { Joins: this.state.HiddenDocumentObservationJoins, Observations: tmpObservations } : null;
		}
		else if (tmpIDDocuments.length)
		{
			tmpRead = await this._readDocumentObservationsAsync(tmpIDDocuments);
		}
		if (!tmpRead || (this._idSample !== tmpIDSample))
		{
			return;
		}
		this._hiddenDocumentMedia = { Key: tmpKey, Media: libSampleDocumentDetails.listDocumentMedia(tmpRead.Joins, tmpRead.Observations) };
		this._renderHiddenDocumentMedia(tmpIDSample);
	}

	/**
	 * The observations joined to some documents: paged joins, then the observations in batches.
	 * @param {Array<number>} pIDDocuments
	 * @return {Promise<{ Joins: Array<Object>, Observations: Array<Object> }|null>} null when a read fails
	 */
	async _readDocumentObservationsAsync(pIDDocuments)
	{
		const tmpJoins = [];
		for (let tmpOffset = 0; ; tmpOffset += 250)
		{
			const tmpPage = await this._getJSON(`DocumentObservationJoins/FilteredTo/FBL~IDDocument~INN~${pIDDocuments.join(',')}~FBV~Deleted~EQ~0/${tmpOffset}/250`);
			if (!Array.isArray(tmpPage))
			{
				return null;
			}
			tmpJoins.push(...tmpPage);
			if (tmpPage.length < 250)
			{
				break;
			}
		}
		const tmpObservations = await this._readObservationsAsync(tmpJoins);
		return tmpObservations ? { Joins: tmpJoins, Observations: tmpObservations } : null;
	}

	/**
	 * The live observations named by some document-observation joins, in batches, as the reader may read them.
	 * @param {Array<{ IDObservation: number }>} pJoins
	 * @return {Promise<Array<Object>|null>} null when a read fails
	 */
	async _readObservationsAsync(pJoins)
	{
		const tmpIDObservations = [ ...new Set(pJoins.map((pJoin) => Number(pJoin.IDObservation)).filter((pID) => pID > 0)) ];
		const tmpObservations = [];
		for (let tmpStart = 0; tmpStart < tmpIDObservations.length; tmpStart += 200)
		{
			const tmpBatch = tmpIDObservations.slice(tmpStart, tmpStart + 200);
			const tmpPage = await this._getJSON(`Observations/FilteredTo/FBL~IDObservation~INN~${tmpBatch.join(',')}~FBV~Deleted~EQ~0/0/${tmpBatch.length}`);
			if (!Array.isArray(tmpPage))
			{
				return null;
			}
			tmpObservations.push(...tmpPage);
		}
		return tmpObservations;
	}

	/**
	 * Paint the hidden documents' photos and videos as a strip of thumbnails, each opening the full image in a new tab.
	 * Empty, and so hidden, when there are none.
	 * @param {number} pIDSample - the sample the media was loaded for
	 */
	_renderHiddenDocumentMedia(pIDSample)
	{
		const tmpHost = (typeof document !== 'undefined') ? document.querySelector('#SampleWorkspace-HiddenMedia') : null;
		if (!tmpHost || (this._idSample !== pIDSample) || (this._activeTab !== 'documents'))
		{
			return;
		}
		tmpHost.innerHTML = '';
		const tmpMedia = this._hiddenDocumentMedia.Media || [];
		if (!tmpMedia.length)
		{
			return;
		}
		const tmpRender = this.pict.HeadlightObservationRender;
		const fImageURL = (pIDObservation, pSize) => ((tmpRender && (typeof tmpRender.observationImageURL === 'function')) ? tmpRender.observationImageURL(pIDObservation, pSize) : `/1.0/Observation/${pIDObservation}/Image/${pSize}`);

		const tmpPanel = document.createElement('div');
		tmpPanel.className = 'sw-hidden-media';
		const tmpTitle = document.createElement('div');
		tmpTitle.className = 'sw-hidden-media-title';
		const tmpIcon = document.createElement('i');
		tmpIcon.className = 'fas fa-images';
		const tmpCount = document.createElement('span');
		tmpCount.className = 'sw-muted';
		tmpCount.textContent = String(tmpMedia.length);
		tmpTitle.append(tmpIcon, ' Photos and videos from documents you cannot open ', tmpCount);
		const tmpStrip = document.createElement('div');
		tmpStrip.className = 'sw-hidden-media-strip';
		for (const tmpItem of tmpMedia)
		{
			const tmpLink = document.createElement('a');
			tmpLink.className = 'sw-hidden-media-item';
			tmpLink.href = fImageURL(tmpItem.IDObservation, 'Standard');
			tmpLink.target = '_blank';
			tmpLink.rel = 'noopener';
			tmpLink.title = tmpItem.Name;
			const tmpImage = document.createElement('img');
			tmpImage.src = fImageURL(tmpItem.IDObservation, 'Thumbnail');
			tmpImage.alt = tmpItem.Name;
			tmpImage.loading = 'lazy';
			tmpLink.append(tmpImage);
			if (tmpItem.Kind === 'video')
			{
				const tmpPlay = document.createElement('i');
				tmpPlay.className = 'fas fa-circle-play sw-hidden-media-play';
				tmpLink.append(tmpPlay);
			}
			tmpStrip.append(tmpLink);
		}
		tmpPanel.append(tmpTitle, tmpStrip);
		tmpHost.append(tmpPanel);
	}

	/**
	 * Give the switcher the enriched document list, if it is still showing this sample's documents.
	 * @param {number} pIDSample - the sample the data was loaded for
	 */
	_repaintSwitcherDocuments(pIDSample)
	{
		const tmpSwitcher = this.pict.providers.DocumentFrameSwitcher;
		if ((this._idSample !== pIDSample) || (this._activeTab !== 'documents') || !tmpSwitcher || (tmpSwitcher.OwnerKey !== `Sample:${this._guidSample}`))
		{
			return;
		}
		tmpSwitcher.setDocuments(this._switcherDocuments());
	}

	/**
	 * Add form types to a customer's catalog: their RNIs, then the tests those declare.
	 * @param {import('@paviasystems/headlight-samples/source/SampleTest-Rules.js').FormTestCatalog} pCatalog
	 * @param {number} pIDCustomer
	 * @param {Array<String>} pTypes - DocumentTypes not yet in the catalog
	 * @return {Promise<void>}
	 */
	async _loadFormTestTypesAsync(pCatalog, pIDCustomer, pTypes)
	{
		if (!pTypes.length)
		{
			return;
		}
		const tmpRNIs = await this._getJSON(`ReportNamedInstances/FilteredTo/FBL~Hash~INN~${pTypes.map(encodeURIComponent).join(',')}~FBV~IDCustomer~EQ~${pIDCustomer}~FBV~Deleted~EQ~0/0/250`);
		if (!Array.isArray(tmpRNIs))
		{
			return;
		}
		const tmpHashesByType = {};
		for (const tmpRNI of tmpRNIs)
		{
			tmpHashesByType[tmpRNI.Hash] = { FormName: tmpRNI.Name || '', TestHashes: libSampleTestRules.getRNITestHashes(tmpRNI), StoryRole: libSampleTestRules.getRNIStoryRole(tmpRNI) };
		}
		const tmpTestHashes = [ ...new Set(Object.values(tmpHashesByType).flatMap((pType) => pType.TestHashes)) ]
			.filter((pHash) => !pCatalog.Tests[pHash] && (pHash.indexOf(',') < 0));
		if (tmpTestHashes.length)
		{
			const tmpTests = await this._getJSON(`Tests/FilteredTo/FBL~Hash~INN~${tmpTestHashes.map(encodeURIComponent).join(',')}~FBV~IDCustomer~EQ~${pIDCustomer}~FBV~Deleted~EQ~0/0/250`);
			if (!Array.isArray(tmpTests))
			{
				return;
			}
			for (const tmpTest of tmpTests)
			{
				pCatalog.Tests[tmpTest.Hash] = { Name: tmpTest.Name || '' };
			}
		}
		for (const tmpType of pTypes)
		{
			pCatalog.Types[tmpType] = tmpHashesByType[tmpType] || { FormName: '', TestHashes: [], StoryRole: '' };
		}
	}

	/**
	 * The documents joined to the sample that did not come back from the Documents read, i.e. the ones the user may not
	 * read. Distinct, so a document joined twice is listed once.
	 * @param {Array<Object>} pJoins - the sample's DocumentPolyJoin rows
	 * @param {Array<Object>} pDocuments - the documents the user can read
	 * @return {Array<number>}
	 */
	_inaccessibleDocumentIDs(pJoins, pDocuments)
	{
		const tmpReadable = new Set((pDocuments || []).map((pDocument) => Number(pDocument.IDDocument)));
		const tmpJoined = new Set((Array.isArray(pJoins) ? pJoins : []).map((pJoin) => Number(pJoin.IDDocument)).filter((pID) => pID > 0));
		return [ ...tmpJoined ].filter((pID) => !tmpReadable.has(pID));
	}

	/**
	 * Whether a location hash is still this sample: its tab routes (`#/Sample/Workspace/<ID>[/<tab>]`, by ID) or its
	 * view and edit routes (by GUID). The document switcher closes its frames on any other hash, so it must not read a
	 * tab switch as leaving the sample.
	 * @param {string} pHash
	 * @return {boolean}
	 */
	isOwnHash(pHash)
	{
		const tmpHash = String(pHash || '');
		if (this._guidSample && (tmpHash.indexOf(this._guidSample) > -1))
		{
			return true;
		}
		const tmpMatch = /^#?\/Sample\/Workspace\/(\d+)(?:[/?]|$)/.exec(tmpHash);
		return !!(tmpMatch && this._idSample && (Number(tmpMatch[1]) === Number(this._idSample)));
	}

	/**
	 * Open one of the sample's documents in the Documents tab's switcher.
	 * @param {number} pIDDocument
	 */
	openDocument(pIDDocument)
	{
		const tmpID = Number(pIDDocument) || 0;
		if (!tmpID)
		{
			return;
		}
		this._pendingDocumentOpen = tmpID;
		if (this._activeTab === 'documents')
		{
			this.repaintBody();
		}
		else
		{
			this.navigateTab('documents');
		}
	}

	/**
	 * Go to a sample's Documents tab with one of its documents open (from a list elsewhere, such as a dashboard).
	 * @param {number} pIDSample
	 * @param {number} pIDDocument
	 */
	openSampleDocument(pIDSample, pIDDocument)
	{
		const tmpIDSample = Number(pIDSample) || 0;
		const tmpIDDocument = Number(pIDDocument) || 0;
		if (!tmpIDSample || !tmpIDDocument)
		{
			return;
		}
		if (tmpIDSample === Number(this._idSample))
		{
			return this.openDocument(tmpIDDocument);
		}
		this._pendingDocumentOpen = tmpIDDocument;
		this.pict.providers.PictRouter.navigate(`/Sample/Workspace/${tmpIDSample}/documents`);
	}

	renderCores()
	{
		if (this._renderTabPending('cores', 'cores'))
		{
			return;
		}
		const tmpRows = this.state.Cores || [];
		if (!tmpRows.length) { this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', this._empty('No cores are linked to this sample.')); return; }
		const tmpBody = tmpRows.map((pC) => `<tr>
			<td class="sw-cell-strong">${this._esc(pC.SublotName || pC.QRCode || `Core #${pC.IDCore}`)}</td>
			<td>${this._esc(pC.QRCode || '')}</td>
			<td class="sw-muted">${this._esc(this._fmtDate(pC.CreateDate))}</td>
		</tr>`).join('');
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body',
			`<div class="sw-tablewrap"><table class="sw-table"><thead><tr><th>Core</th><th>QR Code</th><th>Created</th></tr></thead><tbody>${tmpBody}</tbody></table></div>`);
	}

	renderLogs()
	{
		const tmpRows = this.state.Logs || [];
		this._resolveRowNames('logs', tmpRows.map((pL) => pL.CreatingIDUser));
		const tmpUtility = this.pict.providers.UtilityProvider;
		const fMap = (pL) =>
		{
			// Where the log was captured, as legacy LIMS showed it; a log without a location gets a plain marker.
			const tmpLat = Number(pL.CaptureLatitude || pL.UserLatitude) || 0;
			const tmpLng = Number(pL.CaptureLongitude || pL.UserLongitude) || 0;
			let tmpURL = '';
			if (tmpLat && tmpLng && tmpUtility && (typeof tmpUtility.getGoogleMapURLFromEntityRecord === 'function'))
			{
				try { tmpURL = tmpUtility.getGoogleMapURLFromEntityRecord(pL, { size: '100x100' }); }
				catch (pError) { tmpURL = ''; }
			}
			return tmpURL
				? `<img class="sw-log-map" src="${this._esc(tmpURL)}" alt="Where this log was captured" loading="lazy">`
				: '<div class="sw-log-map sw-log-nomap" title="No location recorded"><i class="fas fa-location-dot"></i></div>';
		};
		const tmpAdd = `<div class="sw-log-add">
			<textarea class="sw-input sw-log-input" placeholder="Add a note…" oninput="_Pict.AppData.SampleWorkspace.NewLogNotes = this.value"></textarea>
			<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.addLog()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add Log</span></button>
		</div>`;
		const tmpList = tmpRows.length
			? tmpRows.map((pL) => `<div class="sw-log">
				${fMap(pL)}
				<div class="sw-log-main">
					<div class="sw-log-id sw-muted">#${this._esc(pL.IDSampleLog || '')}</div>
					<div class="sw-log-notes">${this._esc(pL.Notes || '')}</div>
					<div class="sw-log-meta">${pL.FromStatus || pL.ToStatus ? `<span>${this._esc(this.resolveSampleStatusName(pL.FromStatus) || '')} → ${this._esc(this.resolveSampleStatusName(pL.ToStatus) || '')}</span>` : ''}${this._createdLineHTML(pL)}</div>
				</div>
			</div>`).join('')
			: this._empty('No log entries yet.');
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', `<div class="sw-logs">${tmpAdd}<div class="sw-log-list">${tmpList}</div></div>`);
	}

	/** Location tab: where the sample is, or the cart for moving it (see SampleWorkspace-LocationTab.js). */
	renderLocation() { this._locationTab.render(); }
	/** @return {Promise<void>} the Location tab's OnEnter: read where the sample is, once */
	ensureLocationLoaded() { return this._locationTab.ensureLoadedAsync(); }
	/** Location tab's Change location / Set location. */
	editLocation() { this._locationTab.edit(); }
	/** Location tab's Cancel: back to the display, nothing moved. */
	cancelLocationEdit() { this._locationTab.cancel(); }

	/**
	 * Print tab: the label drawn upright so it reads on screen (the printer gets it turned sideways), plus the print
	 * buttons. Same label, layout and customer manifest as Print.
	 */
	renderPrint()
	{
		const tmpSample = this.state.Sample || {};
		if (!tmpSample.QRCode)
		{
			this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', this._empty('This sample has no QR code to print.'));
			return;
		}
		this.pict.ContentAssignment.assignContent('#SampleWorkspace-Body', `
			<div class="sw-print">
				<div id="SampleWorkspace-PrintPreview" class="sw-print-preview"><span class="sw-muted">Drawing the label…</span></div>
				<div class="sw-toolbar">
					<button class="button is-small is-link" onclick="_Pict.providers.SampleWorkspace.printLabel()"><span class="icon"><i class="fas fa-print"></i></span><span>Print QR Code Label</span></button>
					<button class="button is-small is-light" onclick="_Pict.providers.SampleWorkspace.printLabel(true)">Print options…</button>
				</div>
			</div>`);
		this._renderPrintPreviewAsync();
	}

	async _renderPrintPreviewAsync()
	{
		const tmpSample = this.state.Sample || {};
		const tmpQR = this.pict.providers.QRCodeProvider;
		if (!tmpQR || !tmpSample.QRCode) { return; }
		try
		{
			await tmpQR.ensurePrintableManifests();
			if (this._activeTab !== 'print') { return; }
			await tmpQR.printDecoratedEntity('Sample', tmpSample.QRCode, 'SampleWorkspace-PrintPreview', undefined, tmpSample);
		}
		catch (pError)
		{
			this.pict.log.warn(`SampleWorkspace: label preview failed: ${(pError && pError.message) || pError}`);
		}
	}

	// --- Header helpers (mode-aware header parts read by the config) ------------------------------------------

	/** Header title: "New Sample" in create; otherwise the sample name + a status pill (markup passes through). */
	headerTitle()
	{
		const tmpSample = this.state.Sample || {};
		if (this._mode === 'create') { return 'New Sample'; }
		// Always markup: pict-section-workspace escapes a title again unless it contains a tag (_escTitle).
		const tmpName = `<span class="sw-title-name">${tmpSample.Name ? this._esc(tmpSample.Name) : '(unnamed sample)'}</span>`;
		const tmpStatus = tmpSample.Status ? `<span class="sw-status ${this._statusClass(tmpSample.Status)}">${this._esc(this.resolveSampleStatusName(tmpSample.Status))}</span>` : '';
		const tmpLock = this.isLocked() ? ` <i class="fas fa-lock sw-lock" title="${this.canOverrideLock() ? 'Locked. You can still change it.' : 'Locked'}"></i>` : '';
		return `${tmpName} ${tmpStatus}${tmpLock}`;
	}

	/** Header subline (view mode): PSID + QR code. */
	headerSubtitle()
	{
		const tmpSample = this.state.Sample || {};
		if (this._mode === 'create') { return ''; }
		const tmpBits = [];
		if (tmpSample.LabControlNumber) { tmpBits.push(`<span class="sw-psid">PSID ${this._esc(tmpSample.LabControlNumber)}</span>`); }
		if (tmpSample.QRCode) { tmpBits.push(`<span class="sw-qr"><i class="fas fa-qrcode"></i> ${this._esc(tmpSample.QRCode)}</span>`); }
		return tmpBits.length ? tmpBits.join('<span class="sw-dot">·</span>') : '';
	}

	/** Header extra (view mode): a QR thumbnail host mounted after render by headerAfterRender. */
	headerExtra()
	{
		const tmpSample = this.state.Sample || {};
		return (this._mode !== 'create' && tmpSample.QRCode) ? '<div class="sw-qr-thumb" id="SampleWorkspace-QR"></div>' : '';
	}
	headerAfterRender()
	{
		const tmpSample = this.state.Sample || {};
		if (this._mode !== 'create' && tmpSample.QRCode && (typeof this.renderQRThumbnail === 'function')) { this.renderQRThumbnail('#SampleWorkspace-QR'); }
	}
}

module.exports = SampleWorkspaceProvider;
module.exports.TABS = TABS;

},{"./Default-Sample-Create-Manifest.json":1389,"./Default-Sample-Edit-Manifest.json":1390,"./Default-Sample-View-Manifest.json":1391,"./Default-Summary-Manifests.json":1392,"./SampleDocument-Details.js":1393,"./SampleWorkspace-LocationTab.js":1395,"@paviasystems/headlight-samples":21,"pict-section-workspace":1049}],1397:[function(require,module,exports){
/**
 * EffectivePermissionsService — the aggregation seam for "what can this subject actually do, and why".
 *
 * The Access workspace's Effective visualization + (later) the permission-expression layer depend ONLY on
 * this service's interface, never on the raw Permissions/* endpoints. Today it COMPOSES the existing
 * endpoints client-side (there is no single "all contexts x all permissions" endpoint); when a server-side
 * `Permissions/Matrix/For/User` aggregation lands, its internals swap for that one call and no view changes.
 *
 * Interface (mirrors the future endpoint's payload):
 *   resolveUserMatrixAsync(pIDUser, pOptions) -> {
 *     User, Contexts:[{ Context, IDContext, Label, MembershipVia:[{IDRole,RoleName,MembershipType}], Roles, IsSuperUser }],
 *     Permissions:{ '<Context>:<IDContext>': { '<hash>': { Allowed, Source, IDRole, RoleName, GrantContext } } } }
 *   resolveRoleMatrixAsync(pIDRole, pContext, pIDContext, pRoleRecord) -> single-context variant (+ Summary)
 *   explainAsync(pIDUser, pHash, pContext, pIDContext) -> the Permissions/Explain trace (pass-through)
 *   compareAsync(...) / canAsync(...) -> secondary lenses over the same data
 *
 * Registered as a fable service so any provider resolves it via `this.fable.EffectivePermissionsService`.
 * Exercised only at runtime in the browser against a live API — verify end-to-end on QA.
 */

const libFableServiceProviderBase = require('fable-serviceproviderbase');
const libCatalog = require('../access/Permission-Catalog.js');

// Reads the home app always shows even without an explicit grant — the server row-filters them instead of
// gating the control (matches app_headlight PermissionService / bootstraps Permissions.js). Mirrored here so
// the expression layer doesn't over-hide list/nav entries the server would actually populate.
const ALWAYS_ALLOW = { 'Document-Read': true, 'Project-Read': true, 'Contract-Read': true };

class EffectivePermissionsService extends libFableServiceProviderBase
{
	/**
	 * @param {*} pFable - The fable instance.
	 * @param {*} [pOptions] - Provider options.
	 * @param {string} [pServiceHash] - Fable service hash for this instance.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict = this.fable;
		this.serviceType = 'EffectivePermissionsService';

		// Phase 2 — the CURRENT user's resolved capability map, cached for synchronous UI gating (create
		// buttons, nav). Populated by loadCurrentUserAsync() at login. See can()/canModule().
		this._currentUserCap = null;
	}

	get restClient()
	{
		return this.fable.HeadlightRestClient || (this.fable.pict && this.fable.pict.HeadlightRestClient);
	}

	// --- REST helpers ---

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => pError ? reject(pError) : resolve(pBody));
		});
	}

	/**
	 * Read an entire filtered set (Count then a single sized page).
	 * @return {Promise<Array>}
	 */
	async _getFilteredAll(pEntitySet, pFilter, pCap)
	{
		const tmpCap = pCap || 5000;
		let tmpTotal = tmpCap;
		try
		{
			const tmpCount = await this._getJSON(`${pEntitySet}/Count/FilteredTo/${pFilter}`);
			tmpTotal = Math.min((tmpCount && tmpCount.Count) || 0, tmpCap);
		}
		catch (pError)
		{
			tmpTotal = tmpCap;
		}
		if (!tmpTotal)
		{
			return [];
		}
		const tmpRows = await this._getJSON(`${pEntitySet}/FilteredTo/${pFilter}/0/${tmpTotal}`);
		return Array.isArray(tmpRows) ? tmpRows : [];
	}

	// --- Public interface -----------------------------------------------------

	/**
	 * The full effective-permission matrix for a user: every context they hold a role in (Global + each
	 * project / contract / lab), and per context every explicitly resolved permission with its provenance.
	 * @param {Number} pIDUser
	 * @param {Object} [pOptions] - { Module? } (Module scopes the per-context Map to one module)
	 * @return {Promise<Object>}
	 */
	async resolveUserMatrixAsync(pIDUser, pOptions)
	{
		const tmpOptions = pOptions || {};
		// 1. The contexts where the user holds roles, with membership attribution.
		let tmpContextsResult = null;
		try
		{
			tmpContextsResult = await this._getJSON(`Permissions/Roles/For/User/${pIDUser}/All/Contexts`);
		}
		catch (pError)
		{
			tmpContextsResult = null;
		}
		const tmpContexts = this._normalizeContexts(tmpContextsResult);
		// 2. Per context, resolve the full permission map (all modules unless one is named). Run the contexts
		// CONCURRENTLY in bounded batches instead of one sequential round-trip each — a long-tenured user on a large
		// customer holds roles in hundreds of contexts, and serial awaits made the Effective tab wait for hundreds of
		// sequential requests before it could render. Batching keeps it fast without flooding the server.
		const tmpPermissions = {};
		const tmpConcurrency = 8;
		for (let tmpStart = 0; tmpStart < tmpContexts.length; tmpStart += tmpConcurrency)
		{
			const tmpBatch = tmpContexts.slice(tmpStart, tmpStart + tmpConcurrency);
			/* eslint-disable no-await-in-loop */
			await Promise.all(tmpBatch.map((pCtx) => this._mapForContextAsync(pIDUser, pCtx.Context, pCtx.IDContext, tmpOptions).then((pMap) =>
			{
				tmpPermissions[`${pCtx.Context}:${pCtx.IDContext}`] = pMap.perms;
				pCtx.Roles = pMap.roles;
				pCtx.IsSuperUser = pMap.isSuperUser;
			})));
			/* eslint-enable no-await-in-loop */
		}
		return {
			User: (tmpContextsResult && tmpContextsResult.User) || null,
			Contexts: tmpContexts,
			Permissions: tmpPermissions,
		};
	}

	/**
	 * The effective permissions for a role/group in a single context (its direct grants + those inherited
	 * from included permission groups), each tagged Direct vs Inherited.
	 * @param {Number} pIDRole
	 * @param {String} pContext
	 * @param {Number} pIDContext
	 * @param {Object} [pRoleRecord] - the Role row (for its IDCustomer → storage scope)
	 * @return {Promise<Object>}
	 */
	async resolveRoleMatrixAsync(pIDRole, pContext, pIDContext, pRoleRecord)
	{
		const tmpEffective = await this._getJSON(`Permissions/For/Role/${pIDRole}/In/${pContext}/${pIDContext}`);
		const tmpList = Array.isArray(tmpEffective) ? tmpEffective : [];
		// The role's OWN direct grants live in its storage scope: GLOBAL roles in the membership context
		// (CustomerMembership/0), CUSTOMER-SPECIFIC roles in the entity context (Customer/<IDCustomer>).
		const tmpRoleCustomer = Number((pRoleRecord && pRoleRecord.IDCustomer) || 0);
		let tmpDirectContext;
		let tmpDirectID;
		if (pContext === 'Customer')
		{
			tmpDirectContext = (tmpRoleCustomer === 0) ? 'CustomerMembership' : 'Customer';
			tmpDirectID = (tmpRoleCustomer === 0) ? 0 : tmpRoleCustomer;
		}
		else
		{
			tmpDirectContext = libCatalog.contextToMembership(pContext);
			tmpDirectID = Number(pIDContext);
		}
		const tmpDirectRows = await this._getFilteredAll('RolePermissions',
			`FBV~Context~EQ~${tmpDirectContext}~FBV~IDContext~EQ~${tmpDirectID}~FBV~IDRole~EQ~${pIDRole}~FBV~Allowed~EQ~1`, 5000);
		const tmpDirect = new Set(tmpDirectRows.map((pRow) => pRow.Hash));
		const tmpPerms = {};
		tmpList.forEach((pHash) =>
		{
			tmpPerms[pHash] = { Allowed: true, Source: tmpDirect.has(pHash) ? 'Direct' : 'Inherited', IDRole: pIDRole, RoleName: '', GrantContext: pContext };
		});
		const tmpDirectCount = tmpList.filter((pHash) => tmpDirect.has(pHash)).length;
		return {
			Contexts: [ { Context: pContext, IDContext: pIDContext, Label: this._contextLabel(pContext, pIDContext), MembershipVia: [], Roles: [], IsSuperUser: false } ],
			Permissions: { [`${pContext}:${pIDContext}`]: tmpPerms },
			Summary: { Total: tmpList.length, Direct: tmpDirectCount, Inherited: tmpList.length - tmpDirectCount },
		};
	}

	/**
	 * The full "why?" trace for one permission for a user in a context (pass-through to Permissions/Explain).
	 * @return {Promise<Object>}
	 */
	async explainAsync(pIDUser, pHash, pContext, pIDContext)
	{
		return this._getJSON(`Permissions/Explain/${pHash}/In/${pContext}/${pIDContext}/For/User/${pIDUser}`);
	}

	/**
	 * "Why here but not there" for one permission across two contexts (pass-through to Permissions/Compare).
	 * Secondary lens (the simulator) — shape is best-effort until wired to a live response.
	 * @return {Promise<Object>}
	 */
	async compareAsync(pIDUser, pHash, pContextA, pIDContextA, pContextB, pIDContextB)
	{
		return this._getJSON(`Permissions/Compare/${pHash}/In/${pContextA}/${pIDContextA}/To/${pContextB}/${pIDContextB}/For/User/${pIDUser}`);
	}

	/**
	 * Phase-2 convenience: is a user allowed an (entity, action) in a context? Resolves the context map and
	 * checks the resolved hash. (The expression layer will cache a whole matrix rather than call per-check.)
	 * @return {Promise<Boolean>}
	 */
	async canAsync(pIDUser, pEntity, pAction, pContext, pIDContext)
	{
		const tmpMap = await this._mapForContextAsync(pIDUser, pContext, pIDContext, {});
		const tmpEntry = tmpMap.perms[libCatalog.buildHash(pEntity, pAction)];
		return !!(tmpEntry && tmpEntry.Allowed);
	}

	// --- Phase 2: the current user's capability cache (the UI permission-expression layer) --------------
	// Verified against the authoritative Permissions/Check endpoint: the resolved Map is fail-CLOSED —
	// a hash ALLOW/DENY in the Map matches Check, and a hash ABSENT from the Map is denied by Check too
	// (even accounting for PermissionsEnforcement). So the sync gates below hide a control iff the Map says
	// the current user can't (super-users bypass; before the map loads, nothing is hidden).

	/**
	 * Resolve + cache the CURRENT user's permission map at their operating context (default: their Customer),
	 * so the UI can gate synchronously. Idempotent per (user, context) unless pForce.
	 * @param {Number} pIDUser
	 * @param {Number} pIDCustomer - the operating context id (the user's customer)
	 * @param {Boolean} [pForce]
	 * @return {Promise<Object>} the cached capability record
	 */
	async loadCurrentUserAsync(pIDUser, pIDCustomer, pForce)
	{
		const tmpID = Number(pIDUser);
		const tmpCustomer = Number(pIDCustomer) || 0;
		if (this._currentUserCap && !pForce && this._currentUserCap.IDUser === tmpID && this._currentUserCap.IDContext === tmpCustomer)
		{
			return this._currentUserCap;
		}
		let tmpMap = { perms: {}, roles: [], isSuperUser: false };
		try
		{
			tmpMap = await this._mapForContextAsync(tmpID, 'Customer', tmpCustomer, {});
		}
		catch (pError)
		{
			// leave the cache un-ready → gates fail open (show everything) rather than hide on a load error
			this._currentUserCap = { IDUser: tmpID, IDContext: tmpCustomer, Perms: {}, IsSuperUser: false, Ready: false };
			return this._currentUserCap;
		}
		// Super-user comes from the MAP (the server resolver's own decision — true for a real customer-1/role-5
		// super-admin). We deliberately do NOT treat a session SuperAdminAccessRole as super here: the server
		// still resolves per-permission for those users (e.g. it denies them modules/entities they lack), so
		// gating on the resolved map keeps the UI matching the server rather than over-showing.
		this._currentUserCap = { IDUser: tmpID, IDContext: tmpCustomer, Perms: tmpMap.perms, IsSuperUser: !!tmpMap.isSuperUser, Ready: true };
		return this._currentUserCap;
	}

	/** @return {Boolean} whether the current user's capability map has loaded. */
	currentUserReady()
	{
		return !!(this._currentUserCap && this._currentUserCap.Ready);
	}

	/**
	 * Can the current user perform (entity, action)? Synchronous, for UI gating. Super-users → true; an
	 * unloaded cache → true (never hide before we know); otherwise the Map's decision (absent → false).
	 * @return {Boolean}
	 */
	can(pEntity, pAction)
	{
		return this.canHash(libCatalog.buildHash(pEntity, pAction));
	}

	/**
	 * can() by raw hash (e.g. an association or a `DocumentType-<Hash>-View`).
	 * @return {Boolean}
	 */
	canHash(pHash)
	{
		const tmpCap = this._currentUserCap;
		if (!tmpCap || !tmpCap.Ready)
		{
			return true;
		}
		if (tmpCap.IsSuperUser || ALWAYS_ALLOW[pHash])
		{
			return true;
		}
		const tmpEntry = tmpCap.Perms[pHash];
		return !!(tmpEntry && tmpEntry.Allowed);
	}

	/**
	 * Resolve + cache the current user's permission map in one project, for pages about a record that sits in a
	 * project: a project role can grant there what the customer-level map doesn't. Idempotent per project; a
	 * failed read caches nothing, so the next page load tries again.
	 * @param {Number} pIDProject
	 * @return {Promise<void>}
	 */
	async loadCurrentUserProjectAsync(pIDProject)
	{
		const tmpCap = this._currentUserCap;
		const tmpIDProject = Number(pIDProject) || 0;
		if (!tmpCap || !tmpCap.Ready || !(tmpIDProject > 0))
		{
			return;
		}
		if (!tmpCap.ProjectPerms)
		{
			tmpCap.ProjectPerms = {};
		}
		if (tmpCap.ProjectPerms[tmpIDProject])
		{
			return;
		}
		const tmpMap = await this._mapForContextAsync(tmpCap.IDUser, 'Project', tmpIDProject, {});
		if (Object.keys(tmpMap.perms).length > 0)
		{
			tmpCap.ProjectPerms[tmpIDProject] = tmpMap.perms;
		}
	}

	/**
	 * canHash(), also counting what the current user is granted in one project (once loadCurrentUserProjectAsync
	 * has read it).
	 * @param {String} pHash
	 * @param {Number} pIDProject
	 * @return {Boolean}
	 */
	canHashInProject(pHash, pIDProject)
	{
		if (this.canHash(pHash))
		{
			return true;
		}
		const tmpProjectPerms = this._currentUserCap && this._currentUserCap.ProjectPerms;
		const tmpEntry = tmpProjectPerms && tmpProjectPerms[Number(pIDProject) || 0] && tmpProjectPerms[Number(pIDProject) || 0][pHash];
		return !!(tmpEntry && tmpEntry.Allowed);
	}

	/**
	 * Can the current user access a module (nav gating)? Accepts `LIMS`, `Module-LIMS`, or `Module-LIMS-Access`.
	 * @return {Boolean}
	 */
	canModule(pModule)
	{
		const tmpCap = this._currentUserCap;
		if (!tmpCap || !tmpCap.Ready)
		{
			return true;
		}
		if (tmpCap.IsSuperUser)
		{
			return true;
		}
		let tmpHash = String(pModule || '');
		if (tmpHash.indexOf('Module-') !== 0)
		{
			tmpHash = `Module-${tmpHash}`;
		}
		if (!/-Access$/.test(tmpHash))
		{
			tmpHash = `${tmpHash}-Access`;
		}
		const tmpEntry = tmpCap.Perms[tmpHash];
		return !!(tmpEntry && tmpEntry.Allowed);
	}

	// --- Internal composition (swap this half for the aggregation endpoint later) ---

	/**
	 * Resolve the permission map for one context: `Permissions/Map/In/<Ctx>/<CtxID>/For/User/<id>` (all
	 * modules) — each permission annotated with Source + the implying role. Best-effort (a failing context
	 * yields an empty map rather than aborting the whole matrix).
	 * @return {Promise<{ perms: Object, roles: Array, isSuperUser: Boolean }>}
	 */
	async _mapForContextAsync(pIDUser, pContext, pIDContext, pOptions)
	{
		const tmpModule = pOptions && pOptions.Module;
		const tmpURL = tmpModule
			? `Permissions/Map/In/${pContext}/${pIDContext}/By/Module/${tmpModule}/For/User/${pIDUser}`
			: `Permissions/Map/In/${pContext}/${pIDContext}/For/User/${pIDUser}`;
		try
		{
			const tmpMap = await this._getJSON(tmpURL);
			return this._normalizePermissions(tmpMap);
		}
		catch (pError)
		{
			return { perms: {}, roles: [], isSuperUser: false };
		}
	}

	/**
	 * Normalize the `Permissions/Roles/For/User/:id/All/Contexts` payload into an ordered, DE-DUPLICATED
	 * context list. The endpoint returns one row PER role — { Context, IDContext, IDRole, ProxyIDRole } — plus
	 * a top-level `Roles` lookup (the role records). So a user with several roles in one project appears as
	 * several rows for the same Context:IDContext; we group them and resolve each IDRole to its name via the
	 * lookup (ProxyIDRole>0 marks a delegated assignment).
	 * @return {Array<Object>}
	 */
	_normalizeContexts(pResult)
	{
		const tmpEntries = (pResult && Array.isArray(pResult.Contexts)) ? pResult.Contexts : [];
		const tmpRolesRaw = (pResult && Array.isArray(pResult.Roles)) ? pResult.Roles : [];
		const tmpRoleLookup = {};
		tmpRolesRaw.forEach((pRole) =>
		{
			if (pRole && (pRole.IDRole !== undefined))
			{
				tmpRoleLookup[pRole.IDRole] = pRole;
			}
		});

		const tmpByKey = {};
		const tmpOrder = [];
		tmpEntries.forEach((pEntry) =>
		{
			const tmpContext = pEntry.Context || pEntry.Scope || 'Customer';
			const tmpID = Number(pEntry.IDContext || pEntry.ContextID || 0);
			const tmpKey = `${tmpContext}:${tmpID}`;
			if (!tmpByKey[tmpKey])
			{
				tmpByKey[tmpKey] = { Context: tmpContext, IDContext: tmpID, Label: this._contextLabel(tmpContext, tmpID), MembershipVia: [], _seen: {} };
				tmpOrder.push(tmpKey);
			}
			const tmpGroup = tmpByKey[tmpKey];
			const tmpIDRole = Number(pEntry.IDRole || 0);
			if (tmpIDRole && !tmpGroup._seen[tmpIDRole])
			{
				tmpGroup._seen[tmpIDRole] = true;
				const tmpRole = tmpRoleLookup[tmpIDRole] || {};
				tmpGroup.MembershipVia.push(
					{
						IDRole: tmpIDRole,
						RoleName: tmpRole.Name || `Role ${tmpIDRole}`,
						MembershipType: (Number(pEntry.ProxyIDRole) > 0) ? 'delegated' : (tmpRole.Type || ''),
					});
			}
		});
		return tmpOrder.map((pKey) =>
		{
			const tmpGroup = tmpByKey[pKey];
			delete tmpGroup._seen;
			return tmpGroup;
		});
	}

	/**
	 * Normalize a `Permissions/Map` payload: { Permissions:{ hash:{Allowed,Source,IDRole,RoleName} }, Roles, IsSuperUser }.
	 * @return {{ perms: Object, roles: Array, isSuperUser: Boolean }}
	 */
	_normalizePermissions(pMap)
	{
		const tmpPermissions = (pMap && pMap.Permissions) || {};
		const tmpPerms = {};
		Object.keys(tmpPermissions).forEach((pHash) =>
		{
			const tmpEntry = tmpPermissions[pHash] || {};
			tmpPerms[pHash] =
			{
				Allowed: !!tmpEntry.Allowed,
				Source: tmpEntry.Source || 'Default',
				IDRole: Number(tmpEntry.IDRole || 0),
				RoleName: tmpEntry.RoleName || '',
				GrantContext: tmpEntry.GrantContext || tmpEntry.Context || '',
			};
		});
		return { perms: tmpPerms, roles: (pMap && pMap.Roles) || [], isSuperUser: !!(pMap && pMap.IsSuperUser) };
	}

	_contextLabel(pContext, pIDContext)
	{
		if (pContext === 'Customer')
		{
			return pIDContext ? `Customer ${pIDContext}` : 'Global';
		}
		return pIDContext ? `${pContext} ${pIDContext}` : pContext;
	}
}

module.exports = EffectivePermissionsService;

},{"../access/Permission-Catalog.js":1060,"fable-serviceproviderbase":838}],1398:[function(require,module,exports){
/* eslint brace-style: ["error", "allman"] */
/**
 * Paged entity search for a pict-section-picker DataProvider: `(term, page) => Promise<{ results, hasMore }>`.
 *
 * One `<Set>/FilteredTo/<filter>/<begin>/<cap>` request per page, where begin is page × page size. Rows are sorted by
 * the sort field and then the ID field, so a name shared by two records cannot shift between pages.
 */

const DEFAULT_PAGE_SIZE = 25;
const MAX_PAGE_SIZE = 250;

/**
 * @typedef {Object} EntityPickerSearchOptions
 * @property {string} Set - The entity set path, e.g. `Labs` or `Projects/Lite`.
 * @property {string} IDField - The record's ID column, e.g. `IDLab`; the tie-break sort.
 * @property {string | (() => string)} [Scope] - FoxHound stanzas ANDed onto every request, e.g.
 *   `FBV~IDCustomer~EQ~10~FBV~Deleted~EQ~0`; a function is read at call time. Default `FBV~Deleted~EQ~0`.
 * @property {string} [SearchField] - The column the typed term is matched against with LIKE (default `Name`).
 * @property {string} [SortField] - The primary sort column, ascending (default `Name`).
 * @property {number} [PageSize] - Records per page (default 25, never above 250).
 * @property {(pRow: Record<string, any>) => { Value: any, Text: string, Record?: Record<string, any> }} ToOption
 * @property {(pRow: Record<string, any>) => boolean} [Include] - Drops rows from the results; `hasMore` still counts
 *   them, so a page the filter empties does not end the paging.
 */

/**
 * @param {EntityPickerSearchOptions} pOptions
 * @param {any} pTerm - What the user typed.
 * @param {any} pPage - Zero-based page index.
 * @returns {string} The request URL, relative to the API root.
 */
function entityPickerSearchURL(pOptions, pTerm, pPage)
{
	const tmpPageSize = Math.min(Math.max(Number(pOptions.PageSize) || DEFAULT_PAGE_SIZE, 1), MAX_PAGE_SIZE);
	const fScope = pOptions.Scope;
	const tmpScope = ((typeof fScope === 'function') ? fScope() : fScope) || 'FBV~Deleted~EQ~0';
	const tmpTerm = String(pTerm == null ? '' : pTerm).replace(/~/g, '').trim();
	const tmpSortField = pOptions.SortField || 'Name';
	let tmpFilter = tmpScope;
	if (tmpTerm)
	{
		tmpFilter = `FBV~${pOptions.SearchField || 'Name'}~LK~${encodeURIComponent(`%${tmpTerm}%`)}~${tmpFilter}`;
	}
	tmpFilter = `${tmpFilter}~FSF~${tmpSortField}~ASC~0`;
	if (tmpSortField !== pOptions.IDField)
	{
		tmpFilter = `${tmpFilter}~FSF~${pOptions.IDField}~ASC~0`;
	}
	const tmpBegin = Math.max(Math.floor(Number(pPage) || 0), 0) * tmpPageSize;
	return `${pOptions.Set}/FilteredTo/${tmpFilter}/${tmpBegin}/${tmpPageSize}`;
}

/**
 * @param {(pURL: string) => Promise<any>} fGetJSON - GET relative to the API root, resolving to the parsed body.
 * @param {EntityPickerSearchOptions} pOptions
 * @returns {(pTerm: any, pPage: number) => Promise<{ results: Array<{ Value: any, Text: string, Record?: Record<string, any> }>, hasMore: boolean }>}
 */
function entityPickerDataProvider(fGetJSON, pOptions)
{
	const tmpPageSize = Math.min(Math.max(Number(pOptions.PageSize) || DEFAULT_PAGE_SIZE, 1), MAX_PAGE_SIZE);
	const fToOption = pOptions.ToOption;
	return (pTerm, pPage) =>
	{
		return Promise.resolve()
			.then(() => fGetJSON(entityPickerSearchURL(pOptions, pTerm, pPage)))
			.then((pRows) =>
			{
				const tmpRows = Array.isArray(pRows) ? pRows : [];
				const tmpKept = (typeof pOptions.Include === 'function') ? tmpRows.filter(pOptions.Include) : tmpRows;
				return { results: tmpKept.map(fToOption), hasMore: (tmpRows.length >= tmpPageSize) };
			})
			.catch(() => ({ results: [], hasMore: false }));
	};
}

module.exports = { entityPickerDataProvider, entityPickerSearchURL, DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE };

},{}],1399:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');

const RNI_HASH = 'Support-Call';
const ACCORDION_HASH = 'SupportMergeWizard';
// The wizard steps, in order. Hashes drive the accordion rail + the body-container ids (#PSA_Body_<ACCORDION_HASH>_<hash>).
const STEPS = [ 'select', 'parent', 'preview', 'confirm' ];
// A reply/forward prefix stripped so a child subject and its parent read as one conversation in the preview.
const REPLY_PREFIX = /^\s*(?:(?:re|fwd?|fw|aw|sv|antw)\s*:\s*)+/i;

/**
 * SupportMergeProvider — the "merge tickets" wizard for the staff console (#/Support). It folds one or more DUPLICATE /
 * misfiled Support-Call tickets into an existing PARENT ticket: the children's messages are re-parented onto the parent
 * (as its comment thread), their attachments move into the parent's observation set, and each child is VOIDED with the
 * reason `Merged into #<parent>` (per Steven's model: Void = "not a real standalone ticket" — spam OR a misfile — while
 * Resolved stays reserved for a real case that was worked). It is the UI twin of the mailbox integration's `reconcile`
 * thread-graph fold. Each wizard merge is itself idempotent (a deterministic `MRG-C-<child>-<parent>` comment GUID so a
 * re-run no-ops), and `reconcile` skips tickets already voided/merged, so the two tools never double-fold the same ticket.
 *
 * Chrome + navigation are owned by `pict-section-accordion` in RenderMode 'wizard' (themed off the same --theme-color-*
 * tokens the console uses); THIS provider renders each step's body into the accordion's body container and performs the
 * merge on the final step's Next (OnComplete). Launches two ways (Support-Provider wires both):
 *   • from an open ticket  → open([thatID])
 *   • bulk from the filtered list → open([id,id,…]); the children come from the filter, but the PARENT is searched
 *     across the WHOLE queue (it need not match the filter — the "15 replies → one ticket" case).
 */
class SupportMergeProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// The wizard renders INLINE as a console view (Mode 'merge') — NOT a modal. The Support console paints the
		// #SupportMerge-Wizard container (in `_mergeViewHTML`) before calling open(); the accordion builds into it.
		this._mount = '#SupportMerge-Wizard';
		this._accordionBuilt = false;
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get support() { return this.pict.providers.Support; }
	get pickerProvider() { return this.pict.providers['Pict-Section-Picker']; }
	get accordionProvider() { return this.pict.providers['Pict-Section-Accordion']; }
	get permissions() { return this.pict.fable.EffectivePermissionsService; }

	get idUser() { return Number((this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.UserID) || 0); }

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	_toast(pMessage, pType) { const tmpModal = this.pict.views['Pict-Section-Modal']; if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast(pMessage, { type: pType || 'info' }); } }

	/** Only a support manager / super-user merges tickets. Delegates to the console's own gate when present. */
	canManage()
	{
		if (this.support && (typeof this.support.canManage === 'function')) { return this.support.canManage(); }
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function')) { return true; }
		return tmpPermissions.canHash('Support-Manage');
	}

	get state()
	{
		if (!this.pict.AppData.SupportMerge)
		{
			this.pict.AppData.SupportMerge = { Open: false, Children: [], Parent: null, Preview: null, Busy: false, Error: '', Done: false };
		}
		return this.pict.AppData.SupportMerge;
	}

	_cleanSubject(pValue) { return String(pValue || '').replace(REPLY_PREFIX, '').trim(); }
	_shortDate(pValue)
	{
		const tmpS = String(pValue || ''); if (!tmpS) { return ''; }
		const tmpD = new Date(tmpS); if (Number.isNaN(tmpD.getTime())) { return tmpS.slice(0, 10); }
		return tmpD.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
	}

	// ── Launch / teardown ────────────────────────────────────────────────────────────────────────────────────────

	/**
	 * Build the wizard for one or more child tickets INTO the console's inline merge view. The console (Support-Provider
	 * `enterMerge`) switches to Mode 'merge' and paints the #SupportMerge-Wizard container BEFORE calling this, so the
	 * accordion renders in-flow — there is no overlay/backdrop. Child models are pulled from the console's loaded list
	 * when present (no refetch), else fetched. The target parent is chosen in step 2 and may be any ticket in the queue.
	 * @param {Array<number>} pChildIDs
	 */
	async open(pChildIDs)
	{
		if (!this.canManage()) { this._toast('You do not have permission to merge tickets.', 'error'); return; }
		const tmpIDs = [ ...new Set((Array.isArray(pChildIDs) ? pChildIDs : [ pChildIDs ]).map((pX) => Number(pX)).filter(Boolean)) ];
		if (!tmpIDs.length) { return; }

		const tmpState = this.state;
		tmpState.Open = true; tmpState.Parent = null; tmpState.Preview = null; tmpState.Busy = false; tmpState.Error = ''; tmpState.Done = false;
		tmpState._pickValue = null;   // the picker binds here (ValueAddress); clear so a reused picker doesn't show a stale pick
		tmpState.Children = await this._resolveChildren(tmpIDs);
		// A reused picker view keeps its prior selection across opens — reset it so it agrees with the cleared Parent state.
		const tmpPrevPicker = this.pict.views['SupportMerge-Parent'];
		if (tmpPrevPicker && (typeof tmpPrevPicker.setValue === 'function')) { try { tmpPrevPicker.setValue(''); } catch (pErr) { /* best-effort */ } }

		// The console paints the in-view container synchronously before calling open(); if it's gone (the user navigated
		// away during the async child resolve above), bail quietly rather than building into nothing.
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !tmpCA.getElement(this._mount).length) { return; }
		this._buildWizard();
	}

	/** Reset wizard state when the console leaves the merge view (cancel / navigate-away / after a merge). The accordion
	 *  view object is reused across opens (createAccordion reconfigures + resets it), so there's nothing to destroy —
	 *  just drop the transient state and clear the reused parent picker so the next open starts clean. */
	teardown()
	{
		const tmpState = this.state;
		tmpState.Open = false; tmpState.Parent = null; tmpState.Preview = null; tmpState.Busy = false; tmpState.Done = false; tmpState._pickValue = null;
		const tmpPicker = this.pict.views['SupportMerge-Parent'];
		if (tmpPicker && (typeof tmpPicker.setValue === 'function')) { try { tmpPicker.setValue(''); } catch (pErr) { /* best-effort */ } }
	}

	/** Build child row models from the console's loaded calls when available, else fetch each Document. */
	async _resolveChildren(pIDs)
	{
		const tmpLoaded = (this.support && this.support.state && Array.isArray(this.support.state.Calls)) ? this.support.state.Calls : [];
		const tmpByID = {}; tmpLoaded.forEach((pC) => { tmpByID[Number(pC.IDDocument)] = pC; });
		const tmpOut = [];
		for (const pID of pIDs)
		{
			if (tmpByID[pID]) { tmpOut.push({ IDDocument: pID, Summary: tmpByID[pID].Summary, Caller: tmpByID[pID].Caller, Status: tmpByID[pID].Status, Designated: tmpByID[pID].Designated }); continue; }
			try
			{
				const tmpDoc = await this._getJSON(`Document/${pID}`);
				let tmpFD = tmpDoc && tmpDoc.FormData; if (typeof tmpFD === 'string') { try { tmpFD = JSON.parse(tmpFD); } catch (pErr) { tmpFD = {}; } }
				const tmpIssue = (tmpFD && tmpFD.Issue) || {};
				tmpOut.push({ IDDocument: pID, Summary: tmpIssue.Summary || (tmpDoc && tmpDoc.Name) || `#${pID}`, Caller: (tmpFD && tmpFD.Caller && tmpFD.Caller.Name) || '', Status: (tmpDoc && tmpDoc.Status) || '', Designated: (tmpDoc && tmpDoc.DocumentDate) || '' });
			}
			catch (pError) { tmpOut.push({ IDDocument: pID, Summary: `#${pID}`, Caller: '', Status: '', Designated: '' }); }
		}
		return tmpOut;
	}

	// ── Wizard shell ─────────────────────────────────────────────────────────────────────────────────────────────

	_buildWizard()
	{
		const tmpAccordion = this.accordionProvider;
		if (!tmpAccordion || (typeof tmpAccordion.createAccordion !== 'function')) { this._toast('The wizard component is unavailable.', 'error'); return; }
		tmpAccordion.createAccordion(ACCORDION_HASH,
			{
				DestinationAddress: '#SupportMerge-Wizard',
				RenderMode: 'wizard',
				DoneLabel: 'Merge tickets',
				Steps:
				[
					{ Hash: 'select',  Title: 'Select',      Subtitle: this.state.Children.length === 1 ? '1 ticket' : `${this.state.Children.length} tickets` },
					{ Hash: 'parent',  Title: 'Find parent', Subtitle: 'The ticket to merge into', CanAdvance: () => (this.state.Parent ? true : { allow: false, message: 'Pick a ticket to merge into.' }) },
					{ Hash: 'preview', Title: 'Preview',     Subtitle: 'What the merge does' },
					{ Hash: 'confirm', Title: 'Confirm',     Subtitle: 'Apply the merge' },
				],
				// pict-section-accordion fires OnStepChange with the step OBJECT (not the hash string) — read .Hash.
				OnStepChange: (pTo) => this._renderStepBody(pTo && (pTo.Hash || pTo)),
				OnComplete: () => this.performMerge(),
			});
		const tmpView = this.pict.views[ACCORDION_HASH];
		if (tmpView && (typeof tmpView.render === 'function')) { tmpView.render(); }
		this._accordionBuilt = true;
		// Render every body up front (cheap), then the accordion toggles visibility; lazy bodies (preview) refresh on entry.
		STEPS.forEach((pHash) => this._renderStepBody(pHash));
	}

	_bodyMount(pHash) { return `#PSA_Body_${ACCORDION_HASH}_${pHash}`; }
	_assignBody(pHash, pHTML) { const tmpCA = this.pict.ContentAssignment; if (tmpCA && tmpCA.getElement(this._bodyMount(pHash)).length) { tmpCA.assignContent(this._bodyMount(pHash), pHTML); } }

	_renderStepBody(pHash)
	{
		switch (pHash)
		{
			case 'select': this._assignBody('select', this._selectHTML()); break;
			case 'parent': this._assignBody('parent', this._parentHTML()); this._mountParentPicker(); break;
			case 'preview': this._assignBody('preview', this._previewHTML()); this._loadPreviewAsync(); break;
			case 'confirm': this._assignBody('confirm', this._confirmHTML()); break;
			default: break;
		}
	}

	// ── Step 1 — the children ────────────────────────────────────────────────────────────────────────────────────

	_childCardHTML(pChild)
	{
		return `<div class="supmg-tk">`
			+ `<div class="supmg-tk-top"><span class="sup-badge sup-st-open"><i class="fas fa-inbox"></i> ${this._esc(pChild.Status || 'Open')}</span><span class="supmg-tk-id">#${pChild.IDDocument}</span></div>`
			+ `<div class="supmg-tk-sum">${this._esc(pChild.Summary || '(no summary)')}</div>`
			+ `<div class="supmg-tk-meta">${pChild.Caller ? `<i class="fas fa-user"></i> ${this._esc(pChild.Caller)} · ` : ''}<i class="fas fa-clock"></i> ${this._esc(this._shortDate(pChild.Designated))}</div>`
			+ `</div>`;
	}

	_selectHTML()
	{
		const tmpN = this.state.Children.length;
		return `<div class="supmg-lede">You're merging ${tmpN === 1 ? 'this ticket' : `these ${tmpN} tickets`} into another:</div>`
			+ `<div class="supmg-tklist">${this.state.Children.map((pC) => this._childCardHTML(pC)).join('')}</div>`
			+ `<div class="supmg-note"><i class="fas fa-circle-info"></i> ${tmpN === 1 ? 'Its' : 'Their'} messages and attachments move into the ticket you pick next. ${tmpN === 1 ? 'It is' : 'They are'} then voided with the reason “Merged into #…” and leave the open queue.</div>`;
	}

	// ── Step 2 — find the parent (searchable picker over the whole queue) ─────────────────────────────────────────

	_parentHTML()
	{
		return `<div class="supmg-lede">Search for the ticket to merge into:</div>`
			+ `<div id="SupportMerge-ParentPick" class="supmg-pick"></div>`
			+ `<div id="SupportMerge-ParentSel" class="supmg-parentsel">${this._parentSelHTML()}</div>`
			+ `<div class="supmg-note"><i class="fas fa-ban"></i> The ticket${this.state.Children.length === 1 ? '' : 's'} you're merging ${this.state.Children.length === 1 ? 'is' : 'are'} excluded automatically, and already-voided tickets can't be a target.</div>`;
	}

	_parentSelHTML()
	{
		const tmpP = this.state.Parent;
		if (!tmpP) { return `<div class="supmg-parentempty">No target chosen yet.</div>`; }
		return `<div class="supmg-tk supmg-tk-sel"><div class="supmg-tk-top"><span class="supmg-pill-into">Merge into</span><span class="supmg-tk-id">#${tmpP.IDDocument}</span></div>`
			+ `<div class="supmg-tk-sum">${this._esc(tmpP.Summary || '(no summary)')}</div>`
			+ `<div class="supmg-tk-meta">${tmpP.Caller ? `<i class="fas fa-user"></i> ${this._esc(tmpP.Caller)} · ` : ''}<i class="fas fa-clock"></i> ${this._esc(this._shortDate(tmpP.Designated))}</div></div>`;
	}

	/** Candidate target tickets: the console's loaded queue, minus the children and any already-Void ticket. */
	_parentCandidates()
	{
		const tmpChildIDs = {}; this.state.Children.forEach((pC) => { tmpChildIDs[Number(pC.IDDocument)] = true; });
		const tmpCalls = (this.support && this.support.state && Array.isArray(this.support.state.Calls)) ? this.support.state.Calls : [];
		return tmpCalls.filter((pC) => !tmpChildIDs[Number(pC.IDDocument)] && String(pC.Status) !== 'Void');
	}

	_mountParentPicker()
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA || !tmpCA.getElement('#SupportMerge-ParentPick').length) { return; }
		const tmpInstance = tmpPicker.createPicker('SupportMerge-Parent',
			{
				DestinationAddress: '#SupportMerge-ParentPick',
				ValueAddress: 'AppData.SupportMerge._pickValue',
				Searchable: true,
				AllowClear: true,
				ClearLabel: '— none —',
				Placeholder: 'Search tickets by subject, #, or caller…',
				// pict-section-picker contract: DataProvider(term, page) → Promise<{results:[{Value,Text}], hasMore}>.
				// A pure #id term does an EXACT SERVER lookup (so a parent of ANY age — older than the console's recent,
				// capped window — is still findable, the "15 replies → one old ticket" case); a text term filters the
				// loaded recent queue client-side, PAGED (honoring the page arg so "Load more" terminates, not re-appends).
				DataProvider: (pTerm, pPage) =>
				{
					const tmpQ = String(pTerm || '').trim();
					const tmpPage = Number(pPage) || 0;
					const tmpChildIDs = {}; this.state.Children.forEach((pC) => { tmpChildIDs[Number(pC.IDDocument)] = true; });
					if (/^#?\d+$/.test(tmpQ))
					{
						const tmpID = Number(tmpQ.replace('#', ''));
						if (tmpChildIDs[tmpID]) { return Promise.resolve({ results: [], hasMore: false }); }
						return this._lookupSupportDoc(tmpID)
							.then((pDoc) => (!pDoc || String(pDoc.Status) === 'Void') ? { results: [], hasMore: false } : { results: [ this._candidateOption(pDoc) ], hasMore: false })
							.catch(() => ({ results: [], hasMore: false }));
					}
					const tmpLc = tmpQ.toLowerCase();
					let tmpRows = this._parentCandidates();
					if (tmpLc) { tmpRows = tmpRows.filter((pC) => String(pC.Summary || '').toLowerCase().indexOf(tmpLc) >= 0 || String(pC.Caller || '').toLowerCase().indexOf(tmpLc) >= 0); }
					const tmpSize = 50;
					const tmpSlice = tmpRows.slice(tmpPage * tmpSize, (tmpPage + 1) * tmpSize);
					return Promise.resolve({ results: tmpSlice.map((pC) => this._candidateOption(pC)), hasMore: tmpRows.length > (tmpPage + 1) * tmpSize });
				},
				ResolveValue: (pValue) =>
				{
					const tmpRow = this._parentCandidates().find((pC) => Number(pC.IDDocument) === Number(pValue));
					if (tmpRow) { return Promise.resolve(this._candidateOption(tmpRow)); }
					return this._lookupSupportDoc(Number(pValue)).then((pDoc) => (pDoc ? this._candidateOption(pDoc) : null)).catch(() => null);
				},
				OnChange: (pValue) => this._onParentChosen(Number(pValue) || 0),
			});
		if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
	}

	/** A picker option {Value,Text} for a candidate/doc row. */
	_candidateOption(pC) { return { Value: Number(pC.IDDocument), Text: `#${pC.IDDocument} · ${this._cleanSubject(pC.Summary) || '(no summary)'}${pC.Caller ? ` — ${pC.Caller}` : ''}` }; }

	/** Server-fetch a single Support-Call Document → the candidate row shape, or null. Finds parents of any age. */
	async _lookupSupportDoc(pID)
	{
		if (!pID) { return null; }
		const tmpRows = await this._getJSON(`Documents/FilteredTo/FBV~DocumentType~EQ~${RNI_HASH}~FBV~IDDocument~EQ~${Number(pID)}~FBV~Deleted~EQ~0/0/1`).catch(() => null);
		const tmpDoc = (Array.isArray(tmpRows) && tmpRows[0]) ? tmpRows[0] : null;
		if (!tmpDoc) { return null; }
		let tmpFD = tmpDoc.FormData; if (typeof tmpFD === 'string') { try { tmpFD = JSON.parse(tmpFD); } catch (pErr) { tmpFD = {}; } }
		const tmpIssue = (tmpFD && tmpFD.Issue) || {}; const tmpMeta = (tmpFD && tmpFD.Meta) || {};
		return { IDDocument: Number(tmpDoc.IDDocument), Summary: tmpIssue.Summary || tmpDoc.Name || `#${tmpDoc.IDDocument}`, Caller: (tmpFD && tmpFD.Caller && tmpFD.Caller.Name) || '', Designated: tmpMeta.ReceivedAt || tmpMeta.FirstEmail || tmpDoc.DocumentDate || tmpDoc.CreateDate || '', Status: tmpDoc.Status || '' };
	}

	_repaintParentSel()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA && tmpCA.getElement('#SupportMerge-ParentSel').length) { tmpCA.assignContent('#SupportMerge-ParentSel', this._parentSelHTML()); }
	}

	_onParentChosen(pIDDocument)
	{
		this.state.Preview = null;   // a new parent invalidates the loaded preview
		if (!pIDDocument) { this.state.Parent = null; this._repaintParentSel(); return; }
		const tmpRow = this._parentCandidates().find((pC) => Number(pC.IDDocument) === pIDDocument);
		if (tmpRow) { this.state.Parent = tmpRow; this._repaintParentSel(); return; }
		// Chosen by #id and not in the loaded set — show it immediately, then resolve its real subject from the server.
		this.state.Parent = { IDDocument: pIDDocument, Summary: `#${pIDDocument}`, Caller: '', Designated: '' };
		this._repaintParentSel();
		this._lookupSupportDoc(pIDDocument).then((pDoc) =>
		{
			if (pDoc && this.state.Parent && Number(this.state.Parent.IDDocument) === pIDDocument) { this.state.Parent = pDoc; this.state.Preview = null; this._repaintParentSel(); }
		}).catch(() => { /* keep the #id placeholder */ });
	}

	// ── Step 3 — preview the merged thread ───────────────────────────────────────────────────────────────────────

	_previewHTML()
	{
		const tmpP = this.state.Parent;
		if (!tmpP) { return `<div class="supmg-note"><i class="fas fa-triangle-exclamation"></i> Pick a target ticket first.</div>`; }
		const tmpPrev = this.state.Preview;
		const tmpHeader = `<div class="supmg-prev-head"><span class="supmg-muted">Into</span> <b>#${tmpP.IDDocument}</b> · ${this._esc(this._cleanSubject(tmpP.Summary) || '(no summary)')}</div>`;
		if (!tmpPrev) { return tmpHeader + `<div class="supmg-note"><i class="fas fa-spinner fa-spin"></i> Loading the thread…</div>`; }
		if (tmpPrev.error) { return tmpHeader + `<div class="supmg-err"><i class="fas fa-triangle-exclamation"></i> Couldn't load the thread preview: ${this._esc(tmpPrev.error)}. The merge will still work.</div>`; }
		const tmpNodes = tmpPrev.nodes.map((pNode) =>
			`<div class="supmg-node ${pNode.added ? 'supmg-node-add' : ''}">`
			+ `<div class="supmg-node-h">${pNode.added ? '<i class="fas fa-plus"></i> ' : ''}${this._esc(pNode.title)}</div>`
			+ `<div class="supmg-node-m">${this._esc(pNode.meta)}${pNode.added ? ` · from #${pNode.fromID}` : ''}</div></div>`).join('');
		const tmpAtt = tmpPrev.attachments > 0
			? `<div class="supmg-note"><i class="fas fa-photo-film"></i> ${tmpPrev.attachments} attachment${tmpPrev.attachments === 1 ? '' : 's'} from the merged ticket${this.state.Children.length === 1 ? '' : 's'} will join this ticket's observation set.</div>`
			: '';
		return tmpHeader + `<div class="supmg-tl">${tmpNodes}</div>` + tmpAtt;
	}

	async _loadPreviewAsync()
	{
		const tmpP = this.state.Parent;
		if (!tmpP || this.state.Preview) { return; }
		try
		{
			// Parent thread = its comment stream; each child contributes its summary node (+ its own replies) spliced in by date.
			const tmpParentComments = await this._getJSON(`DocumentComments/FilteredTo/FBV~IDDocument~EQ~${tmpP.IDDocument}~FBV~Deleted~EQ~0/0/200`).catch(() => []);
			const tmpNodes = [];
			tmpNodes.push({ title: this._cleanSubject(tmpP.Summary) || `#${tmpP.IDDocument}`, meta: `${this._shortDate(tmpP.Designated)} · the parent ticket`, added: false });
			(Array.isArray(tmpParentComments) ? tmpParentComments : []).forEach((pC) =>
			{
				let tmpMeta = {}; try { tmpMeta = pC.Metadata ? JSON.parse(pC.Metadata) : {}; } catch (pErr) { tmpMeta = {}; }
				tmpNodes.push({ title: tmpMeta.Kind === 'InboundEmail' ? 'Reply' : (tmpMeta.Kind || 'Note'), meta: `${this._shortDate(pC.CreateDate)}`, added: false });
			});
			let tmpAttachments = 0;
			for (const pChild of this.state.Children)
			{
				tmpNodes.push({ title: this._cleanSubject(pChild.Summary) || `#${pChild.IDDocument}`, meta: this._shortDate(pChild.Designated), added: true, fromID: pChild.IDDocument });
				try { const tmpObs = await this._childObservations(pChild.IDDocument); tmpAttachments += tmpObs.length; } catch (pErr) { /* count best-effort */ }
			}
			if (this.state.Parent !== tmpP) { return; }   // parent changed mid-load → a newer load owns the preview
			this.state.Preview = { nodes: tmpNodes, attachments: tmpAttachments };
		}
		catch (pError)
		{
			if (this.state.Parent !== tmpP) { return; }
			this.state.Preview = { nodes: [], attachments: 0, error: (pError && pError.message) || String(pError) };
		}
		if (this.state.Parent !== tmpP) { return; }
		this._assignBody('preview', this._previewHTML());
	}

	// ── Step 4 — confirm ─────────────────────────────────────────────────────────────────────────────────────────

	_confirmHTML()
	{
		const tmpP = this.state.Parent; const tmpN = this.state.Children.length;
		if (!tmpP) { return `<div class="supmg-note"><i class="fas fa-triangle-exclamation"></i> Pick a target ticket first.</div>`; }
		if (this.state.Done)
		{
			return `<div class="supmg-done"><div class="supmg-done-ic"><i class="fas fa-check"></i></div>`
				+ `<div class="supmg-done-t">Merged into #${tmpP.IDDocument}</div>`
				+ `<div class="supmg-done-s">${tmpN} ticket${tmpN === 1 ? '' : 's'} voided as “Merged into #${tmpP.IDDocument}” and left the open queue.</div></div>`;
		}
		const tmpArrow = `<div class="supmg-arrow">${this.state.Children.map((pC) => `<span class="sup-badge sup-st-open">#${pC.IDDocument}</span>`).join('')}<i class="fas fa-arrow-right"></i><span class="sup-badge sup-st-open">#${tmpP.IDDocument}</span></div>`;
		const tmpList = `<div class="supmg-outcome">`
			+ `<div><i class="fas fa-check"></i> ${tmpN} message thread${tmpN === 1 ? '' : 's'} appended to #${tmpP.IDDocument}</div>`
			+ `<div><i class="fas fa-check"></i> attachments moved into its observation set</div>`
			+ `<div><i class="fas fa-check"></i> ${tmpN === 1 ? 'the ticket' : `the ${tmpN} tickets`} marked <b>Void · Merged into #${tmpP.IDDocument}</b>, removed from the open queue</div></div>`;
		const tmpNote = `<div class="supmg-note"><i class="fas fa-rotate-left"></i> Nothing is deleted — a merged ticket stays reopenable (its moved attachments stay with the parent).</div>`;
		const tmpErr = this.state.Error ? `<div class="supmg-err"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.Error)}</div>` : '';
		const tmpBusy = this.state.Busy ? `<div class="supmg-note"><i class="fas fa-spinner fa-spin"></i> Merging…</div>` : '';
		return tmpArrow + tmpList + tmpNote + tmpErr + tmpBusy;
	}

	// ── The merge operation ──────────────────────────────────────────────────────────────────────────────────────

	/**
	 * The observation ids attached to a child Document, as [{IDObservation}]. Attachments link through
	 * DocumentObservationJoin (there is NO Observation.IDDocument column), so read the join rows; fall back to the
	 * parsed FormData.ObservationImageSet when the join query yields nothing.
	 */
	async _childObservations(pIDDocument)
	{
		const tmpOut = []; const tmpSeen = {};
		const tmpAdd = (pID) => { const tmpN = Number(pID); if (tmpN && !tmpSeen[tmpN]) { tmpSeen[tmpN] = true; tmpOut.push({ IDObservation: tmpN }); } };
		const tmpJoins = await this._getJSON(`DocumentObservationJoins/FilteredTo/FBV~IDDocument~EQ~${pIDDocument}~FBV~Deleted~EQ~0/0/200`).catch(() => []);
		(Array.isArray(tmpJoins) ? tmpJoins : []).forEach((pJ) => tmpAdd(pJ && pJ.IDObservation));
		if (!tmpOut.length)
		{
			try
			{
				const tmpDoc = await this._getJSON(`Document/${pIDDocument}`);
				let tmpFD = tmpDoc && tmpDoc.FormData; if (typeof tmpFD === 'string') { try { tmpFD = JSON.parse(tmpFD); } catch (pErr) { tmpFD = {}; } }
				const tmpSet = (tmpFD && Array.isArray(tmpFD.ObservationImageSet)) ? tmpFD.ObservationImageSet : [];
				tmpSet.forEach((pItem) => tmpAdd(pItem && (pItem.IDObservation || pItem)));
			}
			catch (pErr) { /* best-effort */ }
		}
		return tmpOut;
	}

	async performMerge()
	{
		const tmpState = this.state;
		const tmpP = tmpState.Parent;
		if (!tmpP || tmpState.Busy || tmpState.Done) { return; }
		tmpState.Busy = true; tmpState.Error = '';
		this._assignBody('confirm', this._confirmHTML());
		try
		{
			for (const pChild of tmpState.Children) { await this._mergeOne(pChild.IDDocument, tmpP.IDDocument); }
			tmpState.Busy = false; tmpState.Done = true;
			this._assignBody('confirm', this._confirmHTML());
			this._toast(`Merged ${tmpState.Children.length} ticket${tmpState.Children.length === 1 ? '' : 's'} into #${tmpP.IDDocument}.`, 'success');
		}
		catch (pError)
		{
			tmpState.Busy = false;
			tmpState.Error = (pError && pError.message) ? pError.message : String(pError);
			this._assignBody('confirm', this._confirmHTML());
			this._toast(`Merge failed: ${tmpState.Error}`, 'error');
		}
		finally
		{
			// Clear the list selection in BOTH cases — a partial failure still voided some children (a retry is idempotent
			// via the MRG-C key, so re-merging the rest is safe). The merge view stays put showing the Done/error card; the
			// list is reloaded when the user leaves via the view's "All calls" back link (Support.exitMerge → loadAsync),
			// so the just-merged tickets drop out of the queue then — no reload here (it would blow away the Done card).
			if (this.support && (typeof this.support.clearSelection === 'function')) { this.support.clearSelection(); }
		}
	}

	/**
	 * Fold one child ticket into the parent: re-parent its comment thread, move its observations, stamp Meta.MergedInto,
	 * and VOID it with the reason `Merged into #<parent>`. Idempotent — a merge comment carries a deterministic
	 * GUIDComment (MRG-C-<child>) so a re-run no-ops, and the child is left Deleted=0 so a reopen restores it.
	 */
	async _mergeOne(pChildID, pParentID)
	{
		if (Number(pChildID) === Number(pParentID)) { return; }

		const tmpChildDoc = await this._getJSON(`Document/${pChildID}`);
		let tmpChildFD = tmpChildDoc && tmpChildDoc.FormData; if (typeof tmpChildFD === 'string') { try { tmpChildFD = JSON.parse(tmpChildFD); } catch (pErr) { tmpChildFD = {}; } }
		tmpChildFD = tmpChildFD || {};
		const tmpIssue = tmpChildFD.Issue || {};
		// Idempotency key is (child, parent) so a reopened child re-merged to a DIFFERENT parent still carries its original
		// report to the new parent. 'MRG-C-<child>-<parent>' stays ≤36 (the GUIDComment column size).
		const tmpGuid = `MRG-C-${pChildID}-${pParentID}`;

		// 1. Append the child's original report onto the parent as a comment (once). The parent JOIN lives OUTSIDE the
		//    existence guard (idempotent, dup-safe) so a retry after a mid-way failure still links an already-created comment.
		const tmpExisting = await this._getJSON(`Comments/FilteredTo/FBV~GUIDComment~EQ~${tmpGuid}/0/1`).catch(() => []);
		let tmpIDComment = (Array.isArray(tmpExisting) && tmpExisting[0]) ? Number(tmpExisting[0].IDComment) : 0;
		if (!tmpIDComment)
		{
			const tmpBody = String(tmpIssue.Details || tmpIssue.Summary || tmpChildDoc.Name || '(no content)').trim() || '(no content)';
			const tmpMeta = { Kind: 'InboundEmail', MergedFromIDDocument: Number(pChildID), MergedBy: this.idUser, OriginalSubject: tmpIssue.Summary || tmpChildDoc.Name || '', OriginalDate: tmpChildDoc.DocumentDate || '' };
			const tmpComment = await this._postJSON('Comment', { Comment: tmpBody, CommentHtml: this._esc(tmpBody), GUIDComment: tmpGuid, Metadata: JSON.stringify(tmpMeta) });
			tmpIDComment = tmpComment && Number(tmpComment.IDComment);
		}
		if (tmpIDComment) { try { await this._postJSON('DocumentCommentJoins', [ { IDDocument: Number(pParentID), IDComment: tmpIDComment } ]); } catch (pErr) { /* join may already exist */ } }

		// 2. Re-parent the child's own reply comments onto the parent (add a join; a dup join is harmless/deduped).
		const tmpChildComments = await this._getJSON(`DocumentComments/FilteredTo/FBV~IDDocument~EQ~${pChildID}~FBV~Deleted~EQ~0/0/200`).catch(() => []);
		for (const pC of (Array.isArray(tmpChildComments) ? tmpChildComments : []))
		{
			if (!pC || !pC.IDComment) { continue; }
			try { await this._postJSON('DocumentCommentJoins', [ { IDDocument: Number(pParentID), IDComment: Number(pC.IDComment) } ]); } catch (pErr) { /* join may already exist */ }
		}

		// 3. Move the child's attachments into the parent's observation set via the canonical join endpoints
		//    (Document/:ID/AddObservation/:ID + .../RemoveObservation/:ID — there is no Observation.IDDocument column).
		const tmpObs = await this._childObservations(pChildID);
		const tmpMovedIDs = [];
		for (const pO of tmpObs)
		{
			const tmpIDObs = Number(pO && pO.IDObservation);
			if (!tmpIDObs) { continue; }
			try
			{
				await this._getJSON(`Document/${Number(pParentID)}/AddObservation/${tmpIDObs}`);
				await this._getJSON(`Document/${Number(pChildID)}/RemoveObservation/${tmpIDObs}`);
				tmpMovedIDs.push(tmpIDObs);
			}
			catch (pErr) { /* best-effort per observation */ }
		}
		if (tmpMovedIDs.length) { await this._mergeObservationSet(Number(pParentID), tmpMovedIDs); }

		// 4. Stamp the child's Meta and VOID it (reason carries the parent). Left Deleted=0 → reopen restores it.
		tmpChildFD.Meta = Object.assign({}, tmpChildFD.Meta, { MergedInto: Number(pParentID), MergedAt: (new Date()).toISOString(), MergedBy: this.idUser, MergedVia: 'ui-merge-wizard' });
		const tmpVoid = await this._putJSON('Document', { IDDocument: Number(pChildID), Status: 'Void', StateName: `Merged into #${pParentID}`, _StatusOverride: true, FormData: tmpChildFD });
		if (tmpVoid && (tmpVoid.Error || tmpVoid.ErrorCode)) { throw new Error(`#${pChildID}: ${String(tmpVoid.Error || tmpVoid.ErrorCode)}`); }
	}

	/** Add moved observation ids to the parent's FormData.ObservationImageSet so its attachment control shows them. */
	async _mergeObservationSet(pParentID, pObservationIDs)
	{
		try
		{
			const tmpDoc = await this._getJSON(`Document/${pParentID}`);
			let tmpFD = tmpDoc && tmpDoc.FormData; if (typeof tmpFD === 'string') { try { tmpFD = JSON.parse(tmpFD); } catch (pErr) { tmpFD = {}; } }
			tmpFD = tmpFD || {};
			const tmpSet = Array.isArray(tmpFD.ObservationImageSet) ? tmpFD.ObservationImageSet.slice() : [];
			const tmpSeen = {}; tmpSet.forEach((pItem) => { tmpSeen[Number(pItem && (pItem.IDObservation || pItem))] = true; });
			pObservationIDs.forEach((pID) => { if (!tmpSeen[Number(pID)]) { tmpSet.push({ IDObservation: Number(pID) }); } });
			tmpFD.ObservationImageSet = tmpSet;
			await this._putJSON('Document', { IDDocument: Number(pParentID), FormData: tmpFD });
		}
		catch (pError) { /* the observations are already re-parented; the set hint is best-effort */ }
	}
}

module.exports = SupportMergeProvider;
module.exports.default_configuration = { ProviderIdentifier: 'SupportMerge' };

},{"pict-provider":845}],1400:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
// The app's first-class segmented CodeMirror markdown editor (same component the inline-doc + Email Notifications
// editors use) — powers the support-documentation runbook editor. CodeMirror bundle is vendored + loaded app-wide.
const libMarkdownEditor = require('pict-section-markdowneditor');
// The shared, HTML-ESCAPING user-markdown renderer (marked + escapeHTML + safe URLs) — the same one every screen uses
// to render a remark, so composer notes/acknowledgements/resolutions display identically and safely in the timeline.
const libUserMarkdown = require('../../../../lib/web/headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js');

const RNI_HASH = 'Support-Call';           // the Support Call ReportNamedInstance / DocumentType
const ENTRY_STATUS = 'New';                // SupportCallWorkflow States[0].Status (a new doc enters here)
const FORM_MOUNT = '#Support-FormHost';    // where the pict-section-form-host paints the call form
const LIST_MOUNT = '#Support-List';        // the in-place-repainted list body
const DOC_CAP = 400;                       // newest-first cap on the call list
const LIST_PAGE_SIZE = 25;                 // calls per page in the triage list (client-side pagination of the filtered set)

// The lifecycle statuses (from the seeded SupportCallWorkflow) → display chrome. Unknown statuses fall back to neutral.
const STATUS_META =
{
	New:          { label: 'New',          cls: 'sup-st-new',  icon: 'fa-inbox' },
	Acknowledged: { label: 'Acknowledged', cls: 'sup-st-ack',  icon: 'fa-check-double' },
	Tier1:        { label: 'Tier 1',       cls: 'sup-st-t1',   icon: 'fa-signal' },
	Tier2:        { label: 'Tier 2',       cls: 'sup-st-t2',   icon: 'fa-signal' },
	Tier3:        { label: 'Tier 3',       cls: 'sup-st-t3',   icon: 'fa-signal' },
	Resolved:     { label: 'Resolved',     cls: 'sup-st-done', icon: 'fa-circle-check' },
	Void:         { label: 'Void (spam)',  cls: 'sup-st-void', icon: 'fa-ban' },
};

// The workflow verbs (POST DocumentApproval {Action}) → button chrome. The available set for the current
// user+state comes from GET DocumentApproval/:id/State (.Actions); this only styles what the server offers.
const ACTION_META =
{
	Acknowledge:   { label: 'Acknowledge',        cls: 'sup-act-primary', icon: 'fa-check-double' },
	Resolve:       { label: 'Resolve',            cls: 'sup-act-success', icon: 'fa-check' },
	EscalateTier1: { label: 'Escalate to Tier 1', cls: 'sup-act-warn',    icon: 'fa-angle-up' },
	EscalateTier2: { label: 'Escalate to Tier 2', cls: 'sup-act-warn',    icon: 'fa-angles-up' },
	EscalateTier3: { label: 'Escalate to Tier 3', cls: 'sup-act-warn',    icon: 'fa-arrow-up-wide-short' },
	Reopen:        { label: 'Reopen',             cls: 'sup-act-neutral', icon: 'fa-rotate-left' },
	Void:          { label: 'Mark as spam / Void', cls: 'sup-act-danger', icon: 'fa-ban' },
};

// Call-activity comment kinds (stored in Comment.Metadata.Kind) → composer + timeline chrome. Acknowledgement/Resolution
// are communications to the caller (RECORDED now; a NotifyCaller flag is written so email can be turned on later without
// a data migration). FollowUp carries {NeedByDate, WaitingOn, NextAction, Cleared}. Transitions come from the approval log.
const ACTIVITY_KIND =
{
	Note:            { label: 'Note',            comLabel: 'Internal note',        icon: 'fa-note-sticky',  cls: 'sup-ak-note', toCaller: false },
	Acknowledgement: { label: 'Acknowledged',    comLabel: 'Acknowledge the caller',icon: 'fa-paper-plane', cls: 'sup-ak-ack',  toCaller: true },
	Resolution:      { label: 'Resolution sent', comLabel: 'Send resolution',      icon: 'fa-circle-check', cls: 'sup-ak-res',  toCaller: true },
	FollowUp:        { label: 'Follow-up',       comLabel: 'Set a follow-up',       icon: 'fa-flag',         cls: 'sup-ak-fu',   toCaller: false },
	Stage:           { label: 'Stage',           comLabel: '',                      icon: 'fa-diagram-project', cls: 'sup-ak-stage', toCaller: false },
};

// The composer offers these kinds (Stage is set from the delivery bar, not typed as a comment).
const COMPOSER_KINDS = [ 'Note', 'Acknowledgement', 'Resolution', 'FollowUp' ];

// Optional ticket-handling stage for a support case — a lightweight lifecycle alongside the Open/…/Resolved approval
// status. Ordered; a case moves Acknowledge → Triage → Follow-up → Resolved.
const IMPL_STAGES =
[
	{ id: 'Acknowledge', label: 'Acknowledge', cls: 'sup-stg-ack' },
	{ id: 'Triage',      label: 'Triage',      cls: 'sup-stg-triage' },
	{ id: 'FollowUp',    label: 'Follow-up',   cls: 'sup-stg-fu' },
	{ id: 'Resolved',    label: 'Resolved',    cls: 'sup-stg-resolved' },
];
const IMPL_STAGE_MAP = IMPL_STAGES.reduce((pAcc, pStage) => { pAcc[pStage.id] = pStage; return pAcc; }, {});

// The canonical priority policy — the platform default, overridable per-customer (Configuration ns SupportPortal, key
// PriorityPolicy). `Rules` are evaluated against a call; the HIGHEST-ranked match wins, else `Default`. A rule matches on
// Category, App, and/or a Keyword regex over the summary + details. `SLA` maps a priority to a first-response target
// (surfaced as guidance on the form + in metrics later). Kept data-shaped so the settings editor can round-trip it.
const DEFAULT_PRIORITY_POLICY =
{
	Default: 'Normal',
	Rules:
	[
		{ Keyword: 'outage|down|cannot log|can.?t log|locked out|payroll|deadline|data loss|urgent|emergency', Priority: 'Urgent' },
		{ Category: 'Bug', Priority: 'High' },
		{ Category: 'Access', Priority: 'High' },
		{ Category: 'Data', Priority: 'Normal' },
		{ Category: 'PasswordReset', Priority: 'Normal' },
		{ Category: 'HowTo', Priority: 'Low' },
	],
	SLA: { Urgent: '4 hours', High: '1 business day', Normal: '3 business days', Low: '5 business days' },
};

const MONTHS = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
const MON_SHORT = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];

// Category id → label (mirrors the seeded manifest's Issue.Category SelectOptions), for the metrics breakdown + column.
const CATEGORY_LABELS =
{
	HowTo: 'How-to question', Bug: 'Something isn\'t working', PasswordReset: 'Password reset',
	Access: 'Access / permissions', Data: 'Data question', Device: 'Device', Other: 'Other', Uncategorized: 'Uncategorized',
};

// Priority id → sort rank (0 = most urgent, floats to the top ascending) + chip chrome. A manual lexical sort would be
// wrong (High < Low < Normal < Urgent), so the table sorts on `rank`.
const PRIORITY_META =
{
	Urgent: { label: 'Urgent', cls: 'sup-prio-urgent', rank: 0 },
	High:   { label: 'High',   cls: 'sup-prio-high',   rank: 1 },
	Normal: { label: 'Normal', cls: 'sup-prio-normal', rank: 2 },
	Low:    { label: 'Low',    cls: 'sup-prio-low',    rank: 3 },
};
// Status worklist order for sorting (New first → Resolved, then Void last). Also the source for the Status quick-filter
// chips and the Status filter facet, so Void appears there too — managers can pull up voided/spam calls to review.
const STATUS_ORDER = { New: 0, Acknowledged: 1, Tier1: 2, Tier2: 3, Tier3: 4, Resolved: 5, Void: 6 };

// Keyword THEME rules (ported from the runbook miner) — derive a coarse "what is this about" theme from a ticket's
// subject + issue text when it has no explicit Category (every legacy import does). First match wins, so order from
// most-specific to most-generic; "Error/Bug" is last so a concrete theme is preferred over the catch-all "not working".
const THEME_RULES =
[
	{ key: 'Sync', rx: /\b(sync|syncing|synchroniz|uploading|not uploading|won'?t sync|stuck (uploading|syncing)|spinning)\b/i },
	{ key: 'Login & Access', rx: /\b(log ?in|login|log ?on|password|reset|can'?t sign|sign in|signin|locked out|credential|forgot)\b/i },
	{ key: 'User & Permissions', rx: /\b(new user|add user|user level|permission|reviewer|deactivate|remove user|student worker|account request|access to)\b/i },
	{ key: 'Project Import', rx: /\b(project import|import request|bulk import|migrat|load(ing)? data|import the|spreadsheet import)\b/i },
	{ key: 'Reports & IDR', rx: /\b(report|pdf|\bidr\b|\bdwr\b|export|dossier|print(out|ed)?|generat)\b/i },
	{ key: 'Forms & Data', rx: /\b(form|observation|field ?book|drop.?list|dropdown|sample|material|test|narrative|journal|data entry)\b/i },
	{ key: 'Photos & Media', rx: /\b(photo|image|picture|media|download|not available|thumbnail|gallery)\b/i },
	{ key: 'iPad & Device', rx: /\b(ipad|tablet|device|reinstall|re-install|offline|app (crash|froze|freez|version|update))\b/i },
	{ key: 'Billing & Pay Items', rx: /\b(payment|progress payment|invoice|billing|pay ?item|bid item|change order|contract admin)\b/i },
	{ key: 'Error / Bug', rx: /\b(error|crash|bug|broken|glitch|failed|failure|not working|doesn'?t work|issue with)\b/i },
];

// App id → label — which HeadLight product a call is about. Mirrors the manifest Issue.App SelectOptions; the list
// column/filter/sort read from here. Existing calls with no App show as Unassigned.
const APP_LABELS =
{
	Fieldbook: 'Fieldbook', Bridge: 'Bridge', Home: 'Home', LIMS: 'LIMS',
	Configuration: 'Configuration', Academy: 'Academy', Mobile: 'Mobile', Other: 'Other',
};

// The base multi-select filter facets (drives the toolbar dropdowns generically). `valueFor` returns a call's value
// for that facet (compared as a string). A cross-customer Customer facet is appended at runtime for super-users.
const FILTER_FACETS =
[
	{ key: 'Status',   label: 'Status',   options: () => Object.keys(STATUS_ORDER),  labelFor: (v) => (STATUS_META[v] ? STATUS_META[v].label : v), valueFor: (c) => c.Status },
	{ key: 'Priority', label: 'Priority', options: () => Object.keys(PRIORITY_META), labelFor: (v) => (PRIORITY_META[v] ? PRIORITY_META[v].label : v), valueFor: (c) => c.Priority },
	{ key: 'Category', label: 'Category', options: () => Object.keys(CATEGORY_LABELS).filter((k) => k !== 'Uncategorized'), labelFor: (v) => (CATEGORY_LABELS[v] || v), valueFor: (c) => c.Category },
	{ key: 'App',      label: 'App',      options: () => Object.keys(APP_LABELS),    labelFor: (v) => (APP_LABELS[v] || v), valueFor: (c) => c.App },
];

/**
 * SupportProvider — the #/Support customer-service console. A support call is a Document of type `Support-Call`
 * (the seeded RNI form + SupportCallWorkflow), filed under the customer's revolving monthly Support Project;
 * attachments are Observations grouped as an ObservationSet on the document (the form's ObservationImageSet field).
 *
 * This provider owns the whole screen: the triage list of calls, the create/edit flow (rendered through the shared
 * SupportCallFormHost — a pict-section-form-host — with DataAddress AppData.DocumentData.ReportData.FormData so the
 * ObservationImageSet field and the production DocumentProvider auto-save agree on one FormData object), and the
 * approval-workflow actions (POST DocumentApproval). See [[config-app-support-portal]].
 */
class SupportProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#Support-Host';
		this._manifest = null;              // the customer's Support-Call DefaultFormManifest (cached)
		this._manifestError = '';
		this._justCreatedIDDocument = 0;    // a doc created this session but not yet given content (discard-on-cancel)
		this._loadGen = 0;
		this._metrics = null;               // computed metrics rollup (Metrics view)
		this._metricsLoading = false;
		this._agentNames = {};              // IDUser -> display name (metrics + list resolver cache)
		this._trailingMonths = 6;
		this._portal = null;                // per-customer SupportPortal settings { SelfService, AllowedCategories, ... }
		this._customers = null;             // super-user cross-customer roster { IDCustomer: { Name, Code } }
		this._docsCustomerID = 0;           // Docs view: which customer's runbooks a super-user is managing (0 → session customer)
		this._capped = false;               // the load hit DOC_CAP (surfaced as a note)
		this._activity = { loading: false, items: [] };            // the open call's merged transition + comment timeline
		this._composer = { kind: 'Note', text: '', needBy: '', waitingOn: '' };   // the call-sheet comment composer (uncontrolled)
		// Close an open filter dropdown when clicking outside it (capture phase so it runs before row/button handlers).
		if (typeof document !== 'undefined')
		{
			document.addEventListener('click', (pEvent) =>
			{
				const tmpState = this.pict && this.pict.AppData && this.pict.AppData.Support;
				if (!tmpState || !tmpState.OpenDropdown || tmpState.Mode !== 'list') { return; }
				const tmpTarget = pEvent.target;
				if (tmpTarget && tmpTarget.closest && tmpTarget.closest('.sup-dd')) { return; }
				tmpState.OpenDropdown = '';
				this._paint();
			}, true);
		}
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get permissions() { return this.pict.fable.EffectivePermissionsService; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	get formHost() { return this.pict.providers.SupportCallFormHost; }
	get idCustomer() { return Number((this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0); }
	get idUser() { return Number((this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.UserID) || 0); }

	get state()
	{
		if (!this.pict.AppData.Support)
		{
			this.pict.AppData.Support =
			{
				Mode: 'list', View: 'calls', Loading: false, Error: '', Calls: [],
				Filter: '', Saving: false, Busy: false,
				// Multi-select filters (one array per facet; empty = all) + layered sort (first key primary) + which
				// facet dropdown is open. Default sort = triage order: open first, then most urgent, then newest.
				Filters: { Status: [], Priority: [], Category: [], App: [], Stage: [], Customer: [] },
				DateFilter: { from: '', to: '' },   // designated-date (email timestamp) range, YYYY-MM-DD inclusive; '' = unbounded
				Sort: [ { key: 'Status', dir: 'asc' }, { key: 'Priority', dir: 'asc' }, { key: 'Updated', dir: 'desc' } ],
				ListPage: 0,   // current page of the filtered triage list (client-side; reset to 0 whenever the filter/search/sort changes)
				OpenDropdown: '',
				Selected: {},   // bulk-merge selection: { IDDocument: true } for tickets ticked in the list (manager-only)
				// Single-select dashboard filters (metrics view): '' = all. Support-user = resolver; customer-user = opener.
				MetricsFilters: { Customer: '', App: '', Category: '', Resolver: '', Opener: '' },
				// Dashboard DATE-RANGE scope — the metrics load their OWN set for this range (not the 400-cap call list),
				// so analytics span the whole 2020-2026 archive. Preset: 'last12' | 'all' | a 4-digit year.
				MetricsRange: { preset: 'last12' },
				FormMode: 'create', FormTitle: '', Active: null, Approval: null,
				RunbookOpen: true, RunbookSel: null,   // the read-only runbook companion beside the call form
			};
			// Sticky filters: overlay the last-used facets / date range / search / sort (survives nav + reload).
			Object.assign(this.pict.AppData.Support, this._loadPersistedFilters());
		}
		return this.pict.AppData.Support;
	}

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)))); }
	_postJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }
	_putJSON(pURL, pBody) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pBody, (pErr, pRes) => (pErr ? reject(pErr) : resolve(pRes)))); }

	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'info' }); } }

	/** The console is for support staff + self-service users: holders of Support-Agent or Support-Manage (or super-users). */
	canUse()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return true; }
		// Support staff OR a runbook editor (Document-edit holder) may open the console — the latter sees only the Docs surface (_isDocsOnly).
		return tmpPermissions.canHash('Support-Agent') || tmpPermissions.canHash('Support-Manage') || this._canAccessDocs();
	}

	/** Has a genuine SUPPORT role (agent/manager) or is a super-user — i.e. gets the full console, not the docs-only surface. */
	_hasSupportRole()
	{
		if (this._isSuperUser()) { return true; }
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return true; }
		return tmpPermissions.canHash('Support-Agent') || tmpPermissions.canHash('Support-Manage');
	}

	/** A RUNBOOK-ONLY user: can edit runbooks (Document-edit) but has no support role — the console shows ONLY the runbook
	 *  manager (no triage list, no calls, no metrics/settings). */
	_isDocsOnly() { return this._canAccessDocs() && !this._hasSupportRole(); }

	/**
	 * Full support management — triage every call, all categories, metrics, run the workflow. Super-users get this
	 * automatically (canHash → true); customer support leads get the `Support-Manage` grant. A user who only holds
	 * `Support-Agent` is a TIER-1 self-service user (files + tracks their own calls, categories restricted per config).
	 */
	canManage()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return true; }
		return tmpPermissions.canHash('Support-Manage');
	}

	/** Who may EDIT runbooks (add / upload / edit / delete). Platform (global) scope = super-user, since DocsGlobal is
	 *  cross-customer platform config. Customer scope = a support manager OR anyone holding the Document edit capability
	 *  (Document-Update) for the session customer — the "edit permissions for Documents" gate Steven asked for. */
	canEditRunbooks(pScope)
	{
		if (pScope === 'global') { return this._isSuperUser(); }
		if (this.canManage()) { return true; }   // also covers the perms-not-ready permissive case
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.can !== 'function') || !tmpPermissions.currentUserReady()) { return false; }
		return tmpPermissions.can('Document', 'Update');
	}

	/** May open the runbook manager (Docs view): a customer- or platform-scope runbook editor. (Metrics/Settings stay
	 *  manager-only; this opens ONLY the docs/runbook surface. The read-only call-side runbook aside stays manager-only.) */
	_canAccessDocs() { return this.canEditRunbooks('customer') || this.canEditRunbooks('global'); }

	/** A tier-1 self-service user: can use the console but is not a manager. Drives category + own-calls scoping. */
	isSelfService() { return this.canUse() && !this.canManage(); }

	/** Category ids a self-service user may file under (empty/absent list = all). Managers are never restricted. */
	_allowedCategories()
	{
		if (this.canManage()) { return null; }
		const tmpAllowed = this._portal && Array.isArray(this._portal.AllowedCategories) ? this._portal.AllowedCategories : [];
		return tmpAllowed.length ? tmpAllowed : null;
	}

	/** App ids a self-service user may file under (per-customer, mirrors AllowedCategories). Managers unrestricted. */
	_allowedApps()
	{
		if (this.canManage()) { return null; }
		const tmpAllowed = this._portal && Array.isArray(this._portal.AllowedApps) ? this._portal.AllowedApps : [];
		return tmpAllowed.length ? tmpAllowed : null;
	}

	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }
	/** Render a comment/remark body as SAFE markdown HTML (HTML is escaped before markdown, so a `<script>` in a comment is inert). */
	_renderMd(pValue) { try { return libUserMarkdown.renderUserMarkdown(String(pValue == null ? '' : pValue)); } catch (pError) { return this._esc(pValue); } }

	_date(pValue)
	{
		const tmpString = String(pValue == null ? '' : pValue);
		if (!tmpString || tmpString.indexOf('0000-00-00') === 0) { return '—'; }
		// A bare YYYY-MM-DD (e.g. a follow-up need-by) parses as UTC midnight → renders a day early in western zones; read it as a local date.
		const tmpDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(tmpString);
		const tmpDate = tmpDateOnly ? new Date(Number(tmpDateOnly[1]), Number(tmpDateOnly[2]) - 1, Number(tmpDateOnly[3])) : new Date(tmpString);
		return Number.isNaN(tmpDate.getTime()) ? tmpString : tmpDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
	}

	/** Normalize any date value — ISO, MySQL DATETIME, or a raw RFC822 email `Date` header — to an ISO-8601 string, or ''.
	 *  The designated date comes from mixed sources (DocumentDate is ISO; a mailbox ticket's stored Meta.ReceivedAt is the
	 *  raw email header), so normalizing here lets the column sort lexically and the YYYY-MM-DD range filter slice cleanly. */
	_isoDate(pValue)
	{
		const tmpString = String(pValue == null ? '' : pValue).trim();
		if (!tmpString || tmpString.indexOf('0000-00-00') === 0) { return ''; }
		const tmpDate = new Date(tmpString);
		return Number.isNaN(tmpDate.getTime()) ? '' : tmpDate.toISOString();
	}

	_statusMeta(pStatus) { return STATUS_META[pStatus] || { label: pStatus || 'New', cls: 'sup-st-new', icon: 'fa-circle' }; }
	_prioMeta(pPriority) { return PRIORITY_META[pPriority] || { label: pPriority || '—', cls: 'sup-prio-none', rank: 9 }; }
	_appLabel(pApp) { return pApp ? (APP_LABELS[pApp] || pApp) : '—'; }
	_catLabelList(pCat) { return pCat ? (CATEGORY_LABELS[pCat] || pCat) : '—'; }

	/**
	 * Platform super-user (HeadLight customer 1 + role 5) — reads CurrentUser synchronously so it never fails open like
	 * the capability gates. This is exactly the identity the server exempts from tenant scoping, so it (and ONLY it) can
	 * read Support-Call documents across every customer → the cross-customer support queue.
	 */
	_isSuperUser()
	{
		const tmpUser = (this.pict.AppData && this.pict.AppData.CurrentUser) || {};
		return Number(tmpUser.UserRoleIndex) === 5 && Number(tmpUser.CustomerID) === 1;
	}

	_customerName(pIDCustomer)
	{
		const tmpRow = this._customers && this._customers[pIDCustomer];
		return tmpRow ? (tmpRow.Name || tmpRow.Code || `Customer ${pIDCustomer}`) : (pIDCustomer ? `Customer ${pIDCustomer}` : '—');
	}

	/** The active facets — the base four, plus a cross-customer Customer facet for super-users (roster-driven). */
	_facets()
	{
		let tmpFacets = FILTER_FACETS;
		// The Delivery facet appears only once calls actually carry a stage, so it stays out of the way otherwise.
		if ((this.state.Calls || []).some((pC) => pC.Stage))
		{
			tmpFacets = tmpFacets.concat([ {
				key: 'Stage', label: 'Delivery',
				options: () => IMPL_STAGES.map((pS) => pS.id),
				labelFor: (v) => (IMPL_STAGE_MAP[v] ? IMPL_STAGE_MAP[v].label : v),
				valueFor: (c) => c.Stage || '',
			} ]);
		}
		if (!this._isSuperUser() || !this._customers) { return tmpFacets; }
		const tmpCustomers = this._customers;
		return tmpFacets.concat([ {
			key: 'Customer', label: 'Customer',
			options: () => Object.keys(tmpCustomers).map(Number).filter(Boolean)
				.sort((pA, pB) => String(this._customerName(pA)).localeCompare(String(this._customerName(pB)))).map(String),
			labelFor: (v) => this._customerName(v),
			valueFor: (c) => String(c.CallerCustomer || ''),
		} ]);
	}

	/** Load the customer roster once (super-user only) for the Customer column/filter — rides the super-user session. */
	async _loadCustomersAsync()
	{
		if (this._customers || !this._isSuperUser()) { return; }
		try
		{
			const tmpRows = await this._getJSON('Customers/0/2000');
			const tmpMap = {};
			(Array.isArray(tmpRows) ? tmpRows : []).forEach((pC) => { tmpMap[pC.IDCustomer] = { Name: pC.Name, Code: pC.Code }; });
			this._customers = tmpMap;
		}
		catch (pError) { this._customers = {}; }
	}

	// ── Searchable customer pickers (pict-section-picker, not native <select>) ──────────────────────────────────
	// The customer roster is hundreds long, so every customer selector in the console is a searchable
	// pict-section-picker. All are super-user-only. Each is mounted into its <span> AFTER a paint (createPicker
	// needs a live DOM node), the same mount-after-paint pattern the contractor-matrix pickers use.

	get pickerProvider() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }

	/** DataProvider over the in-memory customer roster. pIDs (optional) restricts to that id set (e.g. the metrics
	 *  filter's customers-with-calls); null = the whole roster. Returns {results:[{Value,Text}], hasMore}. */
	_customerDataProvider(pIDs)
	{
		const tmpAllow = Array.isArray(pIDs) ? new Set(pIDs.map(Number)) : null;
		return (pTerm) =>
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
			const tmpRows = Object.keys(this._customers || {}).map(Number).filter(Boolean)
				.filter((pID) => !tmpAllow || tmpAllow.has(pID))
				.map((pID) => ({ Value: pID, Text: this._customerName(pID) }))
				.filter((pRow) => !tmpTerm || String(pRow.Text).toLowerCase().indexOf(tmpTerm) >= 0)
				.sort((pA, pB) => String(pA.Text).localeCompare(String(pB.Text)));
			return Promise.resolve({ results: tmpRows.slice(0, 60), hasMore: tmpRows.length > 60 });
		};
	}

	_customerResolveValue()
	{
		return (pValue) =>
		{
			const tmpID = Number(pValue);
			return Promise.resolve(tmpID ? { Value: tmpID, Text: this._customerName(tmpID) } : null);
		};
	}

	/** Mount a searchable customer picker into pMountSel (a no-op if the span isn't in the DOM). pOnChange(idCustomer). */
	_mountCustomerPicker(pMountSel, pName, pCurrentID, pOnChange, pIDs, pOpts)
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		if (tmpCA.getElement(pMountSel).length === 0) { return; }
		const tmpOpts = pOpts || {};
		if (!this.pict.AppData.SupportPickers) { this.pict.AppData.SupportPickers = {}; }
		const tmpInstance = tmpPicker.createPicker(`Support-${pName}`,
			{
				DestinationAddress: pMountSel,
				ValueAddress: `AppData.SupportPickers.${pName}`,
				Searchable: true,
				AllowClear: !!tmpOpts.allowClear,
				ClearLabel: tmpOpts.clearLabel || '— all —',
				Placeholder: tmpOpts.placeholder || 'Search customers…',
				DataProvider: this._customerDataProvider(pIDs),
				ResolveValue: this._customerResolveValue(),
				OnChange: (pValue) => pOnChange(Number(pValue) || 0),
			});
		if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
		if (tmpInstance && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(Number(pCurrentID) || ''); }
	}

	/** Mount whichever customer picker(s) belong to the current view (each self-guards on its span). Call after a paint. */
	_mountViewPickers()
	{
		if (!this._isSuperUser()) { return; }
		this._mountCustomerPicker('#Support-Set-Cust-Pick', 'SettingsCustomer',
			(this._settings && this._settings.scopeCustomer) || this.idCustomer,
			(pID) => this.setSettingsCustomer(pID), null, { placeholder: 'Search customers…' });
		const tmpMetricIDs = [ ...new Set((this._metricsCalls || []).map((pC) => Number(pC.CallerCustomer)).filter(Boolean)) ];
		this._mountCustomerPicker('#Support-Metric-Cust-Pick', 'MetricCustomer',
			Number(this.state.MetricsFilters && this.state.MetricsFilters.Customer) || 0,
			(pID) => this.setMetricFilter('Customer', pID ? String(pID) : ''), tmpMetricIDs,
			{ allowClear: true, clearLabel: 'All customers', placeholder: 'Search customers…' });
		this._mountCustomerPicker('#Support-Docs-Cust-Pick', 'DocsCustomer',
			this._docsCustomerID || this.idCustomer,
			(pID) => this.setDocsCustomer(pID), null, { placeholder: 'Search customers…' });
	}

	// ── Data loading ───────────────────────────────────────────────────────────────────────────────────────────

	async loadAsync()
	{
		const gen = ++this._loadGen;
		const tmpState = this.state;
		tmpState.Mode = 'list';
		// Decide docs-only vs full console only against a READY permission map — the permissive-when-unready fallback would
		// otherwise briefly run the full triage load (+ fetch the call queue) for a runbook-only user on a reload race.
		// Retry (capped ~6s) until perms resolve; past the cap (a failed perms load) proceed permissively, like the rest of the app.
		const tmpPerms = this.permissions;
		if (tmpPerms && (typeof tmpPerms.currentUserReady === 'function') && !tmpPerms.currentUserReady())
		{
			tmpState.Loading = true; tmpState.Error = ''; this._paint();
			if ((this._permLoadWait = (this._permLoadWait || 0) + 1) <= 40)
			{
				setTimeout(() => { if (gen === this._loadGen) { this.loadAsync(); } }, 150);
				return;
			}
		}
		this._permLoadWait = 0;
		// Runbook-only user (Document-edit, no support role): no triage/manifest — just load the runbooks and show the
		// Docs surface (the shell forces View='docs'). Skips the Support-Call manifest + call list they can't use.
		if (this._isDocsOnly())
		{
			tmpState.View = 'docs'; tmpState.Loading = false; tmpState.Error = ''; this._manifestError = '';
			this._docsCustomerID = this.idCustomer; this._pendingApply = null;   // nothing to replay into a triage surface they don't have
			await this._loadDocsAsync();   // populates this._docs + paints the shell (docs-only branch)
			return;
		}
		this._metrics = null;               // the call set is changing — recompute metrics on next Metrics view
		tmpState.Loading = true; tmpState.Error = '';
		this._paint();
		try
		{
			// The customer's configured Support-Call form (cache once); also gates whether Support is set up here.
			if (!this._manifest) { await this._loadFormManifestAsync(); }
			if (!this._portal) { await this._loadPortalSettingsAsync(); }
			if (this._isSuperUser() && !this._customers) { await this._loadCustomersAsync(); }
			await this._loadCallsAsync();
			if (gen !== this._loadGen) { return; }
		}
		catch (pError)
		{
			if (gen !== this._loadGen) { return; }
			tmpState.Error = (pError && pError.message) ? pError.message : String(pError);
		}
		finally
		{
			if (gen === this._loadGen)
			{
				tmpState.Loading = false; this._paint();
				// A route arrived before the console had loaded (cold deep-link to /Support/Metrics, /Support/Call/:id, …) —
				// apply it now that the manifest + calls are in.
				if (this._pendingApply) { const tmpApply = this._pendingApply; this._pendingApply = null; try { tmpApply(this); } catch (pErr) { /* best-effort */ } }
			}
		}
	}

	async _loadFormManifestAsync()
	{
		// Prefer the customer's OWN Support-Call form if they've overridden it, else the platform-global one (IDCustomer 0).
		const tmpRows = await this._getJSON(`ReportNamedInstances/FilteredTo/FBV~Hash~EQ~${RNI_HASH}~FBL~IDCustomer~INN~${this.idCustomer},0~FBV~Deleted~EQ~0/0/5`);
		const tmpList = Array.isArray(tmpRows) ? tmpRows : [];
		const tmpRNI = tmpList.find((pR) => Number(pR.IDCustomer) === this.idCustomer) || tmpList.find((pR) => Number(pR.IDCustomer) === 0) || null;
		if (!tmpRNI) { this._manifestError = 'not-configured'; throw new Error('Support isn’t set up yet. Run the support-portal seeder (global platform seed) to create the Support Call form.'); }
		let tmpOptions = tmpRNI.Options;
		if (typeof tmpOptions === 'string') { try { tmpOptions = JSON.parse(tmpOptions); } catch (pError) { tmpOptions = {}; } }
		const tmpManifest = tmpOptions && tmpOptions.FormDefinition && tmpOptions.FormDefinition.DefaultFormManifest;
		if (!tmpManifest || !tmpManifest.Descriptors) { this._manifestError = 'bad-manifest'; throw new Error('The Support Call form is configured but its manifest is empty.'); }
		this._manifest = tmpManifest;
		this._manifestError = '';
	}

	/** Per-customer self-service settings (Configuration namespace SupportPortal, hash Settings). Absent → defaults. */
	async _loadPortalSettingsAsync()
	{
		let tmpSettings = null;
		let tmpPolicy = null;
		try
		{
			const tmpBlob = await this._getJSON(`Configuration/For/SupportPortal/In/Customer/${this.idCustomer}`);
			tmpSettings = tmpBlob && tmpBlob.Settings ? tmpBlob.Settings : (tmpBlob && typeof tmpBlob.SelfService !== 'undefined' ? tmpBlob : null);
			if (tmpBlob && tmpBlob.PriorityPolicy) { tmpPolicy = tmpBlob.PriorityPolicy; }
		}
		catch (pError) { /* no portal config → defaults below */ }
		this._portal = tmpSettings || { SelfService: false, AllowedCategories: [] };
		// Cascaded (Global → Customer) priority policy; fall back to the platform canonical when unset.
		this._priorityPolicy = (tmpPolicy && Array.isArray(tmpPolicy.Rules)) ? tmpPolicy : DEFAULT_PRIORITY_POLICY;
	}

	/** Evaluate the priority policy against a call's form → { priority, reason } (highest-ranked match wins), or null. */
	_suggestPriority(pFormData)
	{
		const tmpPolicy = this._priorityPolicy || DEFAULT_PRIORITY_POLICY;
		const tmpIssue = (pFormData && pFormData.Issue) || {};
		const tmpHay = `${tmpIssue.Summary || ''} ${tmpIssue.Details || ''} ${tmpIssue.StepsToReproduce || ''}`.toLowerCase();
		let tmpBest = null;
		(tmpPolicy.Rules || []).forEach((pRule) =>
		{
			let tmpMatch = true; let tmpReason = '';
			if (pRule.Category) { if (tmpIssue.Category !== pRule.Category) { tmpMatch = false; } else { tmpReason = this._catLabel(pRule.Category); } }
			if (tmpMatch && pRule.App) { if (tmpIssue.App !== pRule.App) { tmpMatch = false; } else { tmpReason = this._appLabel(pRule.App); } }
			if (tmpMatch && pRule.Keyword)
			{
				let tmpHit = false;
				try { tmpHit = new RegExp(pRule.Keyword, 'i').test(tmpHay); } catch (pErr) { tmpHit = tmpHay.indexOf(String(pRule.Keyword).toLowerCase()) >= 0; }
				if (!tmpHit) { tmpMatch = false; } else { tmpReason = 'keyword in the description'; }
			}
			if (!tmpMatch || !pRule.Priority) { return; }
			// rank is inverted (Urgent=0 is the most urgent) → the smallest rank is the highest priority.
			const tmpRank = (PRIORITY_META[pRule.Priority] || {}).rank;
			if (typeof tmpRank !== 'number') { return; }
			if (!tmpBest || tmpRank < tmpBest.rank) { tmpBest = { priority: pRule.Priority, reason: tmpReason, rank: tmpRank }; }
		});
		if (tmpBest) { return { priority: tmpBest.priority, reason: tmpBest.reason }; }
		return tmpPolicy.Default ? { priority: tmpPolicy.Default, reason: 'default' } : null;
	}

	async _loadCallsAsync()
	{
		// Super-users (customer-1 / role-5) read the WHOLE platform's support queue — the server injects no tenant filter
		// for them, so we omit the IDCustomer clause. Everyone else is hard-scoped to their own customer server-side.
		const tmpScope = this._isSuperUser() ? '' : `FBV~IDCustomer~EQ~${this.idCustomer}~`;
		// A tier-1 self-service user sees only the calls they filed; managers/staff see the whole (customer/platform) queue.
		const tmpOwn = this.isSelfService() ? `~FBV~CreatingIDUser~EQ~${this.idUser}` : '';
		const tmpFilter = `Documents/FilteredTo/${tmpScope}FBV~DocumentType~EQ~${RNI_HASH}~FBV~Deleted~EQ~0${tmpOwn}~FSF~IDDocument~DESC~0/0/${DOC_CAP}`;
		const tmpRows = await this._getJSON(tmpFilter);
		const tmpList = Array.isArray(tmpRows) ? tmpRows : [];
		this._capped = tmpList.length >= DOC_CAP;
		this.state.Calls = tmpList.map((pDoc) => this._callSummary(pDoc));
		// Resolve the "Last Updated By" display names (batched, cached) so the column is populated on first paint. A failed
		// lookup is a SECONDARY concern — degrade to the 'User <id>' fallback, never red-banner the whole (already-loaded) list.
		try { await this._resolveAgentNames(this.state.Calls.map((pC) => pC.UpdatedBy), this._loadGen); }
		catch (pError) { /* names are a non-critical overlay */ }
	}

	/** Distill a Document row into the list card model, reading the caller/issue fields out of FormData when present. */
	_callSummary(pDoc)
	{
		let tmpForm = pDoc.FormData;
		if (typeof tmpForm === 'string') { try { tmpForm = JSON.parse(tmpForm); } catch (pError) { tmpForm = {}; } }
		tmpForm = tmpForm || {};
		const tmpCaller = tmpForm.Caller || {};
		const tmpIssue = tmpForm.Issue || {};
		const tmpResolution = tmpForm.Resolution || {};
		// Legacy mailbox-import docs carry their TRUE dates in DocumentDate + FormData.Meta (the audit CreateDate/
		// UpdateDate and the approval-log CreateDate are all stamped at import time, which the API won't backdate). So
		// for these the list + metrics read the real email dates and the real caller, not the import stamps.
		const tmpMeta = tmpForm.Meta || {};
		const tmpLegacy = tmpMeta.Source === 'Mailbox-Legacy';
		// A support call still at the born 'Draft' status is conceptually Open (not yet worked) — normalize so the
		// list chips + badges group it under Open.
		const tmpStatus = STATUS_META[pDoc.Status] ? pDoc.Status : ENTRY_STATUS;
		return {
			IDDocument: Number(pDoc.IDDocument),
			IDProject: Number(pDoc.IDProject) || 0,
			IDCustomer: Number(pDoc.IDCustomer) || 0,   // the DOCUMENT's customer (= 1 for the central HeadLight queue)
			// The CALLER's customer (the org the ticket is ABOUT) — the meaningful dimension on the cross-customer queue,
			// where every doc's IDCustomer is 1. Drives the dashboard's By-customer card + Customer filter.
			CallerCustomer: Number(tmpCaller.IDCustomer) || 0,
			Status: tmpStatus,
			StateName: pDoc.StateName || '',
			Name: pDoc.Name || '',
			Summary: tmpIssue.Summary || pDoc.Name || '(no summary)',
			Caller: tmpCaller.Name || '',
			Category: tmpIssue.Category || '',
			// Derived subject/issue theme — real signal for the dashboard where legacy tickets carry no explicit Category.
			Theme: tmpIssue.Category || this._deriveTheme(tmpIssue.Summary, tmpIssue.Details),
			Priority: tmpIssue.Priority || '',
			App: tmpIssue.App || '',
			Stage: (tmpForm.Implementation && tmpForm.Implementation.Stage) || '',   // optional delivery lifecycle (Phase 4)
			// Phase-1 follow-up indicator: the existing Resolution.FollowUpNeeded boolean, surfaced in the list. Made
			// functional (need-by date / waiting-on) in the comms phase.
			FollowUp: tmpResolution.FollowUpNeeded === true || tmpResolution.FollowUpNeeded === 'true' || tmpResolution.FollowUpNeeded === 1,
			// Opened-by is the caller for legacy docs (the import ran as the operator, so CreatingIDUser is the operator).
			OpenedBy: tmpLegacy ? (Number(tmpCaller.IDUser) || 0) : (Number(pDoc.CreatingIDUser) || 0),
			// Who on the team last actioned the call (the Document's last writer). Name resolved on list load via _resolveAgentNames.
			UpdatedBy: Number(pDoc.UpdatingIDUser) || 0,
			Created: tmpLegacy ? (pDoc.DocumentDate || tmpMeta.FirstEmail || tmpMeta.OpenedAt || pDoc.CreateDate || '') : (pDoc.CreateDate || ''),
			Updated: tmpLegacy ? (tmpMeta.LastEmail || tmpMeta.ResolvedAt || pDoc.DocumentDate || pDoc.UpdateDate || '') : (pDoc.UpdateDate || pDoc.CreateDate || ''),
			// The "designated date" = the timestamp on the originating email, distinct from the audit Updated/UpdateDate.
			// Read the AUTHORITATIVE email timestamp the ingest stored on the ticket itself (legacy → Meta.FirstEmail;
			// live mailbox → Meta.ReceivedAt, the raw email Date header), falling back to DocumentDate then CreateDate.
			// Reading Meta here is what fixes the OLD tickets whose DocumentDate was stamped at import time, not send time —
			// no data migration needed. _isoDate normalizes the (possibly RFC822) value so sort + the range filter work.
			Designated: this._isoDate(tmpLegacy ? (tmpMeta.FirstEmail || pDoc.DocumentDate) : (tmpMeta.ReceivedAt || pDoc.DocumentDate || pDoc.CreateDate)),
			// Legacy overlay for the metrics resolve map (the approval log can't carry the real close date/agent).
			Legacy: tmpLegacy,
			ResolvedAt: tmpLegacy ? (tmpMeta.ResolvedAt || '') : '',
			ResolvedBy: tmpLegacy ? (Number(tmpMeta.ResolvedByIDUser) || 0) : 0,
		};
	}

	// ── The revolving monthly Support Project ──────────────────────────────────────────────────────────────────

	/** Find-or-create this month's per-customer Support Project by deterministic GUID (server stamps the customer). */
	async _ensureMonthlyProjectAsync()
	{
		const tmpNow = new Date();
		const tmpYM = `${tmpNow.getFullYear()}-${String(tmpNow.getMonth() + 1).padStart(2, '0')}`;
		const tmpGUID = `Support-${this.idCustomer}-${tmpYM}`;
		const tmpName = `Support — ${MONTHS[tmpNow.getMonth()]} ${tmpNow.getFullYear()}`;
		const tmpEnc = encodeURIComponent(tmpGUID);

		const tmpLive = await this._getJSON(`Projects/FilteredTo/FBV~GUIDProject~EQ~${tmpEnc}/0/2`);
		if (Array.isArray(tmpLive) && tmpLive[0]) { return tmpLive[0]; }

		// A soft-deleted row holds the GUID permanently (Meadow uniqueness sees deleted rows); fall back to a suffix.
		let tmpGUIDToUse = tmpGUID;
		try
		{
			const tmpAny = await this._getJSON(`Projects/FilteredTo/FBV~GUIDProject~EQ~${tmpEnc}/0/2?includeDeleted=true`);
			if (Array.isArray(tmpAny) && tmpAny[0]) { tmpGUIDToUse = `${tmpGUID}-2`; }
		}
		catch (pError) { /* probe best-effort; fall through to the canonical GUID */ }

		const tmpSaved = await this._postJSON('Project', { Name: tmpName, GUIDProject: tmpGUIDToUse, Status: 'Support', Description: 'Revolving monthly bucket for customer support calls.' });
		if (!tmpSaved || tmpSaved.ErrorCode || tmpSaved.Error || !tmpSaved.IDProject)
		{
			throw new Error((tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode)) ? String(tmpSaved.Error || tmpSaved.ErrorCode) : 'Could not create this month’s Support project.');
		}
		return tmpSaved;
	}

	/**
	 * Move a document into the SupportCallWorkflow entry state ('New'). Documents are created 'Draft' (the create
	 * ignores a client Status), which the custom workflow cannot resolve — a status-override PUT sets the declared
	 * entry state so the approval bar and its actions come alive. This is initialization, not an approval bypass;
	 * every real transition still goes through POST DocumentApproval (which logs it).
	 */
	async _ensureWorkflowEntryAsync(pIDDocument)
	{
		try { await this._putJSON('Document', { IDDocument: Number(pIDDocument), Status: ENTRY_STATUS, StateName: 'New', _StatusOverride: true }); }
		catch (pError) { /* best-effort; the action bar falls back to a status-only view */ }
	}

	// ── Create / open / save a call ────────────────────────────────────────────────────────────────────────────

	/**
	 * New call: ensure the monthly project, create the Document up-front (blank, Open) so the ObservationImageSet
	 * field has an IDDocument to attach to, then open the form editor on it.
	 */
	async startCreate()
	{
		const tmpState = this.state;
		if (this._isDocsOnly()) { return; }   // runbook-only user has no call-filing surface
		if (tmpState.Busy) { return; }
		if (!this._manifest) { this._toast('The Support Call form isn’t available.', 'error'); return; }
		tmpState.Busy = true; tmpState.Error = '';
		this._toast('Opening a new support call…', 'info');
		try
		{
			const tmpProject = await this._ensureMonthlyProjectAsync();
			const tmpNow = (new Date()).toISOString();
			const tmpDoc = await this._postJSON('Document',
				{ Name: 'New support call', DocumentDate: tmpNow, IDProject: Number(tmpProject.IDProject), DocumentType: RNI_HASH, Form: 1, FormData: {}, Status: ENTRY_STATUS, Observations: [] });
			if (!tmpDoc || tmpDoc.ErrorCode || tmpDoc.Error || !tmpDoc.IDDocument)
			{
				throw new Error((tmpDoc && (tmpDoc.Error || tmpDoc.ErrorCode)) ? String(tmpDoc.Error || tmpDoc.ErrorCode) : 'The server rejected the new call.');
			}
			this._justCreatedIDDocument = Number(tmpDoc.IDDocument);
			// A new Document is born 'Draft' (the create ignores a client Status); the SupportCallWorkflow has no
			// 'Draft' state, so move it to the workflow entry state 'New' before the approval bar reads its state.
			await this._ensureWorkflowEntryAsync(Number(tmpDoc.IDDocument));
			tmpState.Busy = false;
			this._openDoc({ IDDocument: Number(tmpDoc.IDDocument), IDProject: Number(tmpProject.IDProject), Status: ENTRY_STATUS, FormData: {} }, 'create', tmpProject);
			// The new draft now exists and has its own id, so the create form IS the call form — give it the call's route so
			// a reload / bookmark reopens THIS draft (instead of filing another). Use a REAL hash write, not replaceState:
			// routeApplyCall no-ops when the call is already the open form (Active.IDDocument matches, set by _openDoc above),
			// so this syncs the URL AND the router WITHOUT re-opening the form or dropping 'create' mode. replaceState would
			// leave the router's last-resolved path stale, so a later navigateView('calls') would look like a no-op to it.
			if ((typeof window !== 'undefined') && window.location) { window.location.hash = `#/Support/Call/${Number(tmpDoc.IDDocument)}`; }
		}
		catch (pError)
		{
			tmpState.Busy = false;
			this._toast(`Could not open a new call: ${(pError && pError.message) ? pError.message : pError}`, 'error');
		}
	}

	/** Open an existing call from the list into the form editor. */
	async openCall(pIDDocument)
	{
		const tmpState = this.state;
		if (this._isDocsOnly()) { return; }   // runbook-only user can't open calls (no triage access)
		if (tmpState.Busy) { return; }
		// Leaving the inline merge view to open a call (e.g. browser Back to a /Support/Call/:ID hash): tear the wizard down
		// and drop out of 'merge' BEFORE the first paint, so a failed fetch can't strand the user on an empty merge shell
		// (_openDoc's own merge teardown only runs on fetch success, after this first paint has already wiped the accordion).
		if (tmpState.Mode === 'merge')
		{
			const tmpMerge = this.pict.providers.SupportMerge;
			if (tmpMerge && (typeof tmpMerge.teardown === 'function')) { tmpMerge.teardown(); }
			tmpState.Mode = 'list';
		}
		tmpState.Busy = true; tmpState.Error = '';
		this._paint();
		try
		{
			const tmpDoc = await this._getJSON(`Document/${Number(pIDDocument)}`);
			if (!tmpDoc || !tmpDoc.IDDocument) { throw new Error('Could not load that call.'); }
			// Self-heal any call still sitting at the born 'Draft' status (e.g. created before it was worked) so its
			// approval bar resolves against the SupportCallWorkflow.
			if (!STATUS_META[tmpDoc.Status]) { await this._ensureWorkflowEntryAsync(Number(tmpDoc.IDDocument)); tmpDoc.Status = ENTRY_STATUS; }
			this._justCreatedIDDocument = 0;
			tmpState.Busy = false;
			this._openDoc(tmpDoc, 'edit');
		}
		catch (pError)
		{
			tmpState.Busy = false;
			this._toast(`Could not open the call: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			this._paint();
		}
	}

	/**
	 * Set up the document context the form + attachments read (AppData.DocumentData.ReportData), paint the form
	 * shell, mount the manifest, and fetch the approval state for the action bar.
	 */
	_openDoc(pDoc, pMode, pProject)
	{
		const tmpState = this.state;
		// Opening a call while the inline merge view is up (e.g. a deep link) → drop the wizard's transient state first.
		if (tmpState.Mode === 'merge') { const tmpMerge = this.pict.providers.SupportMerge; if (tmpMerge && (typeof tmpMerge.teardown === 'function')) { tmpMerge.teardown(); } }
		let tmpFormData = pDoc.FormData;
		if (typeof tmpFormData === 'string') { try { tmpFormData = JSON.parse(tmpFormData); } catch (pError) { tmpFormData = {}; } }
		tmpFormData = tmpFormData || {};

		// The document context every media/attachment control + the DocumentProvider auto-save reads.
		this.pict.AppData.DocumentData =
		{
			ReportData:
			{
				IDDocument: Number(pDoc.IDDocument),
				IDProject: Number(pDoc.IDProject) || 0,
				DocumentType: RNI_HASH,
				FormData: tmpFormData,
				Status: pDoc.Status || ENTRY_STATUS,
				CanEdit: true,
				Locked: false,
				Observations: Array.isArray(pDoc.Observations) ? pDoc.Observations : [],
			},
		};

		tmpState.Mode = 'form';
		tmpState.FormMode = pMode;
		tmpState.Active =
		{
			IDDocument: Number(pDoc.IDDocument),
			IDProject: Number(pDoc.IDProject) || 0,
			Status: pDoc.Status || ENTRY_STATUS,
			ProjectName: (pProject && pProject.Name) || '',
			Summary: (tmpFormData.Issue && tmpFormData.Issue.Summary) || '',
		};
		tmpState.FormTitle = pMode === 'create' ? 'New support call' : (tmpState.Active.Summary || `Call #${tmpState.Active.IDDocument}`);
		tmpState.Approval = null;
		this._composer = { kind: 'Note', text: '', needBy: '', waitingOn: '' };
		this._activity = { loading: pMode !== 'create', items: [] };
		this._paint();
		this._mountForm();
		if (this.canManage()) { this._ensureRunbooksAsync(); this._loadCallerRunbooksAsync((tmpFormData.Caller && tmpFormData.Caller.IDCustomer) || 0); }   // read-only runbook aside: platform runbooks + THIS caller's customer playbook
		this._refreshApprovalAsync(Number(pDoc.IDDocument));
		if (pMode !== 'create') { this._loadActivityAsync(Number(pDoc.IDDocument)); }
	}

	/** The manifest to render — for a tier-1 self-service user with a restricted category list, a filtered clone. */
	_effectiveManifest()
	{
		const tmpAllowedCats = this._allowedCategories();
		const tmpAllowedApps = this._allowedApps();
		if ((!tmpAllowedCats && !tmpAllowedApps) || !this._manifest) { return this._manifest; }
		const tmpManifest = JSON.parse(JSON.stringify(this._manifest));
		const tmpRestrict = (pAddress, pAllowed) =>
		{
			if (!pAllowed) { return; }
			const tmpDesc = tmpManifest.Descriptors && tmpManifest.Descriptors[pAddress];
			if (tmpDesc && tmpDesc.PictForm && Array.isArray(tmpDesc.PictForm.SelectOptions))
			{
				tmpDesc.PictForm.SelectOptions = tmpDesc.PictForm.SelectOptions.filter((pOpt) => pAllowed.indexOf(pOpt.id) >= 0);
				// One allowed value → default it so a self-service caller doesn't have to choose.
				if (tmpDesc.PictForm.SelectOptions.length === 1) { tmpDesc.Default = tmpDesc.PictForm.SelectOptions[0].id; }
			}
		};
		tmpRestrict('Issue.Category', tmpAllowedCats);
		tmpRestrict('Issue.App', tmpAllowedApps);
		return tmpManifest;
	}

	_mountForm()
	{
		const tmpHost = this.formHost;
		if (!tmpHost || (typeof tmpHost.loadForm !== 'function'))
		{
			this.state.Error = 'The support-call form runner is not available.';
			this._paint();
			return;
		}
		try
		{
			tmpHost.loadForm(this._effectiveManifest(), { DestinationAddress: FORM_MOUNT, DataAddress: 'AppData.DocumentData.ReportData.FormData' });
		}
		catch (pError)
		{
			this.state.Error = `Could not open the support-call form: ${(pError && pError.message) ? pError.message : pError}`;
			this._paint();
		}
	}

	/** Compose a human list title from the form so the triage list reads well: "Summary — Caller". */
	_composeName(pFormData)
	{
		const tmpIssue = (pFormData && pFormData.Issue) || {};
		const tmpCaller = (pFormData && pFormData.Caller) || {};
		const tmpSummary = String(tmpIssue.Summary || '').trim();
		const tmpWho = String(tmpCaller.Name || '').trim();
		if (!tmpSummary) { return tmpWho ? `Support call — ${tmpWho}` : 'Support call'; }
		return tmpWho ? `${tmpSummary} — ${tmpWho}` : tmpSummary;
	}

	/** Marshal the form host and PUT the Document — no navigation, no toast. Shared by save() and performAction(). */
	async _persistFormDataAsync()
	{
		const tmpState = this.state;
		if (!tmpState.Active) { return null; }
		const tmpHost = this.formHost;
		if (tmpHost && (typeof tmpHost.save === 'function')) { try { tmpHost.save(); } catch (pError) { /* marshal best-effort */ } }
		const tmpFormData = (tmpHost && typeof tmpHost.getFormData === 'function')
			? (tmpHost.getFormData() || {})
			: ((this.pict.AppData.DocumentData && this.pict.AppData.DocumentData.ReportData && this.pict.AppData.DocumentData.ReportData.FormData) || {});
		if (!tmpFormData.Meta) { tmpFormData.Meta = {}; }
		tmpFormData.Meta.DocumentCreatorApp = 'Platform Configuration';
		// Priority policy: fill a blank priority from the policy (never override an explicit choice), and note why.
		const tmpIssue = tmpFormData.Issue || (tmpFormData.Issue = {});
		if (!tmpIssue.Priority)
		{
			const tmpSuggest = this._suggestPriority(tmpFormData);
			if (tmpSuggest && tmpSuggest.priority)
			{
				tmpIssue.Priority = tmpSuggest.priority;
				const tmpWhy = (tmpSuggest.reason && tmpSuggest.reason !== 'default') ? ` (${tmpSuggest.reason})` : '';
				this._toast(`Priority set to ${(PRIORITY_META[tmpSuggest.priority] || {}).label || tmpSuggest.priority} per policy${tmpWhy}.`, 'info');
			}
		}
		const tmpSaved = await this._putJSON('Document',
			{ IDDocument: tmpState.Active.IDDocument, IDProject: tmpState.Active.IDProject, DocumentType: RNI_HASH, Form: 1, FormData: tmpFormData, Name: this._composeName(tmpFormData) });
		if (!tmpSaved || tmpSaved.ErrorCode || tmpSaved.Error)
		{
			throw new Error((tmpSaved && (tmpSaved.Error || tmpSaved.ErrorCode)) ? String(tmpSaved.Error || tmpSaved.ErrorCode) : 'the server rejected the call.');
		}
		this._justCreatedIDDocument = 0;   // it now has content — no longer a discardable blank
		tmpState.Active.Summary = (tmpFormData.Issue && tmpFormData.Issue.Summary) || tmpState.Active.Summary;
		return tmpSaved;
	}

	async save()
	{
		const tmpState = this.state;
		if (tmpState.Saving || !tmpState.Active) { return; }
		tmpState.Saving = true;
		this._paintFormActions();
		try
		{
			await this._persistFormDataAsync();
			tmpState.Saving = false;
			this._toast('Support call saved.', 'success');
			// Stay on the call — do NOT loadAsync() (it sets Mode='list' and bounces back to the dashboard). Just reset the
			// Save button and refresh the status bar in place; the list reloads on its own when you navigate back (routeApply).
			this._paintFormActions();
			if (tmpState.Active) { this._refreshApprovalAsync(Number(tmpState.Active.IDDocument)); }
		}
		catch (pError)
		{
			tmpState.Saving = false;
			this._toast(`Could not save the call: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			this._paintFormActions();
		}
	}

	/** Back to the list. If the call was created this session and never given a summary, discard the blank draft. */
	async cancel()
	{
		// Don't lose an in-progress call-activity note — confirm, and scroll back to the composer if the user stays.
		if (this._hasUnsavedComposer())
		{
			const tmpOk = (typeof window !== 'undefined' && typeof window.confirm === 'function')
				? window.confirm('You have an unsaved note in Call activity. Leave without adding it?\n\n(Click Cancel to stay and add it.)')
				: true;
			if (!tmpOk) { this._scrollToComposer(); return; }
		}
		const tmpHost = this.formHost;
		const tmpState = this.state;
		let tmpDiscarded = false;
		if (this._justCreatedIDDocument && tmpState.Active && Number(tmpState.Active.IDDocument) === this._justCreatedIDDocument)
		{
			const tmpFormData = (tmpHost && typeof tmpHost.getFormData === 'function') ? (tmpHost.getFormData() || {}) : {};
			const tmpSummary = tmpFormData.Issue && String(tmpFormData.Issue.Summary || '').trim();
			const tmpHasAttachment = tmpFormData.Issue && tmpFormData.Issue.Attachments;
			if (!tmpSummary && !tmpHasAttachment)
			{
				try { await new Promise((resolve) => this.restClient.deleteEntity('Document', this._justCreatedIDDocument, () => resolve())); tmpDiscarded = true; }
				catch (pError) { /* best-effort discard */ }
			}
		}
		this._justCreatedIDDocument = 0;
		if (tmpHost && (typeof tmpHost.destroy === 'function')) { try { tmpHost.destroy(); } catch (pError) { /* best-effort */ } }
		if (tmpDiscarded) { this._toast('Discarded the empty call.', 'info'); }
		this.navigateView('calls');   // back to the list via the hash (router reloads it) so the URL + back-button stay in sync
	}

	// ── Approval workflow ──────────────────────────────────────────────────────────────────────────────────────

	async _refreshApprovalAsync(pIDDocument)
	{
		try
		{
			const tmpState = await this._getJSON(`DocumentApproval/${Number(pIDDocument)}/State`);
			if (!this.state.Active || Number(this.state.Active.IDDocument) !== Number(pIDDocument)) { return; }
			this.state.Approval =
			{
				Status: (tmpState && tmpState.Status) || this.state.Active.Status || ENTRY_STATUS,
				StateName: (tmpState && tmpState.StateName) || '',
				Locked: !!(tmpState && tmpState.Locked),
				Actions: (tmpState && Array.isArray(tmpState.Actions)) ? tmpState.Actions : [],
			};
			this.state.Active.Status = this.state.Approval.Status;
			this._syncCallStatus(Number(pIDDocument), this.state.Approval.Status);   // keep the in-memory list + status chips in step
			this._paintApproval();
		}
		catch (pError) { /* the action bar just stays minimal if the state read fails */ }
	}

	/** Reflect a workflow status change onto the loaded call in state.Calls (so the list + status chips are correct without
	 *  waiting for the return-to-list reload). */
	_syncCallStatus(pIDDocument, pStatus)
	{
		if (!pStatus) { return; }
		const tmpCall = (this.state.Calls || []).find((pCall) => Number(pCall.IDDocument) === Number(pIDDocument));
		if (tmpCall) { tmpCall.Status = pStatus; tmpCall.Updated = (new Date()).toISOString(); }
	}

	/** Advance the approval workflow to Resolved. In the tiered model Resolve is available directly from
	 *  Acknowledged / Tier1 / Tier2 / Tier3; from the New entry state it must Acknowledge first
	 *  (New→Acknowledge→Resolve). Escalations are never auto-taken here. Returns true once Resolved. */
	async _resolveViaWorkflowAsync(pIDDocument)
	{
		const tmpID = Number(pIDDocument);
		for (let i = 0; i < 3; i++)
		{
			const tmpState = await this._getJSON(`DocumentApproval/${tmpID}/State`);
			const tmpStatus = tmpState && tmpState.Status;
			if (tmpStatus === 'Resolved') { return true; }
			const tmpActions = (tmpState && Array.isArray(tmpState.Actions)) ? tmpState.Actions : [];
			const tmpNext = (tmpActions.indexOf('Resolve') >= 0) ? 'Resolve'
				: (tmpActions.indexOf('Acknowledge') >= 0) ? 'Acknowledge' : null;
			if (!tmpNext) { return false; }
			const tmpRes = await this._postJSON('DocumentApproval', { IDDocument: tmpID, Action: tmpNext });
			if (tmpRes && (tmpRes.ErrorCode || tmpRes.Error || (tmpRes.code && tmpRes.message))) { return false; }
		}
		return false;
	}

	async performAction(pAction)
	{
		const tmpState = this.state;
		if (tmpState.Busy || !tmpState.Active) { return; }
		tmpState.Busy = true;
		this._paintApproval();
		try
		{
			// Persist any in-progress form edits before the transition (a Resolve may lock the document) — but stay on
			// the form: a transition updates the status bar in place, it does not navigate back to the list.
			try { await this._persistFormDataAsync(); } catch (pSaveError) { /* the transition is the goal; a save hiccup shouldn't block it */ }
			const tmpRes = await this._postJSON('DocumentApproval', { IDDocument: tmpState.Active.IDDocument, Action: pAction });
			if (tmpRes && (tmpRes.ErrorCode || tmpRes.Error)) { throw new Error(String(tmpRes.Error || tmpRes.ErrorCode)); }
			tmpState.Busy = false;
			this._toast(`Marked: ${(ACTION_META[pAction] && ACTION_META[pAction].label) || pAction}.`, 'success');
			await this._refreshApprovalAsync(tmpState.Active.IDDocument);
			if (tmpState.Active) { tmpState.FormTitle = tmpState.Active.Summary || tmpState.FormTitle; }
		}
		catch (pError)
		{
			tmpState.Busy = false;
			this._toast(`Could not ${pAction}: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			this._paintApproval();
		}
	}

	// ── Call activity: comms (acknowledge/resolve), functional follow-up, and a who-did-what history ─────────────

	_dateTime(pValue)
	{
		const tmpS = String(pValue || ''); if (!tmpS) { return ''; }
		const tmpD = new Date(tmpS); if (Number.isNaN(tmpD.getTime())) { return tmpS; }
		return tmpD.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' · ' + tmpD.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
	}

	/** Load the open call's timeline = DocumentApprovalLog transitions ⊕ DocumentComment stream, actor-resolved. */
	async _loadActivityAsync(pIDDocument)
	{
		this._activity = { loading: true, items: [] };
		this._paintActivity();
		try
		{
			const [ tmpLogs, tmpComments ] = await Promise.all([
				this._getJSON(`DocumentApprovalLogs/FilteredTo/FBV~IDDocument~EQ~${pIDDocument}~FBV~Deleted~EQ~0~FSF~CreateDate~DESC~0/0/200`).catch(() => []),
				this._getJSON(`DocumentComments/FilteredTo/FBV~IDDocument~EQ~${pIDDocument}~FBV~Deleted~EQ~0/0/200`).catch(() => []),
			]);
			if (!this.state.Active || Number(this.state.Active.IDDocument) !== Number(pIDDocument)) { return; }
			// Legacy docs: the approval-log CreateDate is import-stamped, so read the transition's true date from
			// FormData.Meta (Open → first email, Resolve → last email).
			let tmpMeta = {};
			try { const tmpRD = this.pict.AppData.DocumentData && this.pict.AppData.DocumentData.ReportData; const tmpFD = tmpRD && tmpRD.FormData; tmpMeta = ((typeof tmpFD === 'string') ? JSON.parse(tmpFD || '{}') : (tmpFD || {})).Meta || {}; } catch (pErr) { tmpMeta = {}; }
			const tmpIsLegacy = tmpMeta.Source === 'Mailbox-Legacy';
			const tmpItems = [];
			(Array.isArray(tmpLogs) ? tmpLogs : []).forEach((pL) =>
			{
				if (!pL.Action && !pL.AfterStatus) { return; }   // skip the silent born-Draft → Open status override
				let tmpAt = pL.CreateDate || '';
				if (tmpIsLegacy)
				{
					if (Number(pL.IsApproval) === 1 || /resolve/i.test(pL.Action || '')) { tmpAt = tmpMeta.ResolvedAt || tmpMeta.LastEmail || tmpAt; }
					else if (/open|acknowledge/i.test(pL.Action || '') || pL.AfterStatus === 'Open' || pL.AfterStatus === 'New' || pL.AfterStatus === 'Acknowledged') { tmpAt = tmpMeta.OpenedAt || tmpMeta.FirstEmail || tmpAt; }
				}
				tmpItems.push({ type: 'transition', action: pL.Action, status: pL.AfterStatus, isApproval: Number(pL.IsApproval) === 1, by: Number(pL.CreatingIDUser) || 0, at: tmpAt });
			});
			(Array.isArray(tmpComments) ? tmpComments : []).forEach((pC) =>
			{
				let tmpMeta = {}; try { tmpMeta = pC.Metadata ? JSON.parse(pC.Metadata) : {}; } catch (pErr) { tmpMeta = {}; }
				tmpItems.push({ type: 'comment', kind: tmpMeta.Kind || 'Note', text: pC.Comment || '', meta: tmpMeta, by: Number(pC.CreatingIDUser) || 0, at: pC.CreateDate || '' });
			});
			tmpItems.sort((pA, pB) => String(pB.at).localeCompare(String(pA.at)));
			await this._resolveAgentNames(tmpItems.map((pI) => pI.by), this._loadGen);
			if (!this.state.Active || Number(this.state.Active.IDDocument) !== Number(pIDDocument)) { return; }
			this._activity = { loading: false, items: tmpItems };
		}
		catch (pError) { this._activity = { loading: false, items: [], error: (pError && pError.message) || String(pError) }; }
		this._paintActivity();
	}

	setComposerKind(pKind) { this._captureComposerEditor(); this._composer.kind = ACTIVITY_KIND[pKind] ? pKind : 'Note'; this._paintComposer(); }
	setComposerText(pValue) { this._composer.text = pValue || ''; }
	setComposerField(pField, pValue) { this._composer[pField] = pValue || ''; }
	_paintComposer() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#Support-Composer').length) { tmpCA.assignContent('#Support-Composer', this._composerHTML()); this._mountComposerEditor(); } }
	_paintActivity() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#Support-Activity').length) { tmpCA.assignContent('#Support-Activity', this._activityHTML()); this._mountComposerEditor(); } }

	/** Mount (or re-render) the shared markdown editor into the composer, seeded with the in-progress message text. The
	 *  composer re-paints on kind switch / busy, so the editor is (re)mounted after every composer + activity paint and
	 *  its text is captured back into this._composer.text before any repaint (see _captureComposerEditor). */
	_mountComposerEditor()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !tmpCA.getElement('#Support-Composer-Editor-Mount').length) { return; }
		if (!this.pict.AppData.SupportComposerEditor) { this.pict.AppData.SupportComposerEditor = {}; }
		this.pict.AppData.SupportComposerEditor.Segments = [ { Content: this._composer.text || '' } ];
		if (!this.pict.views['Support-Composer-Editor'])
		{
			this.pict.addView('Support-Composer-Editor',
				{
					ViewIdentifier: 'Support-Composer-Editor',
					TargetElementAddress: '#Support-Composer-Editor-Mount',
					ContentDataAddress: 'AppData.SupportComposerEditor.Segments',
					AutoRender: false,
					EnableRichPreview: false,
					ReadOnly: false,
				}, libMarkdownEditor);
		}
		try { this.pict.views['Support-Composer-Editor'].render(); }
		catch (pError) { /* the composer just falls back to an empty mount if the markdown bundle hiccups */ }
	}

	/** Pull the markdown out of the composer editor into this._composer.text (before a repaint, a kind switch, or Add). */
	_captureComposerEditor()
	{
		// No live composer in the DOM (e.g. create mode, or not on the activity view) → nothing to marshal. Without this
		// guard the persistent CodeMirror view would surface a PRIOR call's text as a false "unsaved note" on the next call.
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || !tmpCA.getElement('#Support-Composer-Editor-Mount').length) { return; }
		const tmpView = this.pict.views['Support-Composer-Editor'];
		if (!tmpView) { return; }
		if (typeof tmpView.marshalFromView === 'function') { try { tmpView.marshalFromView(); } catch (pError) { /* editor already gone */ } }
		const tmpSegs = (this.pict.AppData.SupportComposerEditor && this.pict.AppData.SupportComposerEditor.Segments) || [];
		this._composer.text = tmpSegs.map((pSeg) => (pSeg && pSeg.Content) || '').join('\n\n');
	}

	/** Mirror an open follow-up onto the document's FormData so the LIST follow-up flag reflects it cheaply. */
	async _mirrorFollowUpAsync(pNeeded)
	{
		const tmpRD = this.pict.AppData.DocumentData && this.pict.AppData.DocumentData.ReportData;
		if (!tmpRD || !this.state.Active) { return; }
		const tmpFD = tmpRD.FormData || {};
		tmpFD.Resolution = tmpFD.Resolution || {};
		tmpFD.Resolution.FollowUpNeeded = !!pNeeded;
		try { await this._putJSON('Document', { IDDocument: this.state.Active.IDDocument, IDProject: this.state.Active.IDProject, DocumentType: RNI_HASH, Form: 1, FormData: tmpFD }); }
		catch (pError) { /* best-effort mirror */ }
	}

	/**
	 * Add a call-activity comment: an internal note, a caller acknowledgement/resolution (RECORDED now; NotifyCaller flag
	 * written so email can be enabled later), or a follow-up (need-by + waiting-on). Records via the customer-stamped
	 * Comment entity + a DocumentCommentJoin (no email side-effect yet).
	 */
	async addComment()
	{
		const tmpState = this.state;
		if (!tmpState.Active || tmpState.Busy) { return; }
		this._captureComposerEditor();   // pull the latest markdown out of the editor before we read/submit it
		const tmpKind = this._composer.kind;
		const tmpText = (this._composer.text || '').trim();
		const tmpIsFollowUp = tmpKind === 'FollowUp';
		if (!tmpText && !tmpIsFollowUp) { this._toast('Add a message first.', 'info'); return; }
		if (tmpIsFollowUp && !tmpText && !this._composer.needBy && !this._composer.waitingOn) { this._toast('Add a need-by date, what it’s waiting on, or a note.', 'info'); return; }
		const tmpMeta = { Kind: tmpKind };
		if (ACTIVITY_KIND[tmpKind] && ACTIVITY_KIND[tmpKind].toCaller) { tmpMeta.NotifyCaller = false; }   // record now, email later
		if (tmpIsFollowUp) { tmpMeta.NeedByDate = this._composer.needBy || ''; tmpMeta.WaitingOn = this._composer.waitingOn || ''; tmpMeta.Cleared = false; }
		tmpState.Busy = true; this._paintComposer();
		try
		{
			const tmpComment = await this._postJSON('Comment', { Comment: tmpText, CommentHtml: this._esc(tmpText), Metadata: JSON.stringify(tmpMeta) });
			const tmpIDComment = tmpComment && tmpComment.IDComment;
			if (!tmpIDComment) { throw new Error((tmpComment && (tmpComment.Error || tmpComment.ErrorCode)) || 'the comment was not saved.'); }
			await this._postJSON('DocumentCommentJoins', [ { IDDocument: tmpState.Active.IDDocument, IDComment: tmpIDComment } ]);
			if (tmpIsFollowUp) { await this._mirrorFollowUpAsync(true); }
			// "Send resolution" also CLOSES the case — the message and the status move are one action (what agents expect).
			// It advances the approval workflow to Resolved (intermediate Start/Resume handled). A status hiccup doesn't
			// lose the message: the comment is already saved.
			let tmpResolved = false;
			if (tmpKind === 'Resolution')
			{
				try { tmpResolved = await this._resolveViaWorkflowAsync(tmpState.Active.IDDocument); if (tmpResolved) { await this._refreshApprovalAsync(tmpState.Active.IDDocument); } }
				catch (pResolveError) { /* the message is saved; the status simply didn't move */ }
			}
			tmpState.Busy = false;
			this._composer = { kind: 'Note', text: '', needBy: '', waitingOn: '' };
			this._toast(tmpIsFollowUp ? 'Follow-up set.' : (tmpKind === 'Resolution' ? (tmpResolved ? 'Resolution sent — case marked Resolved.' : 'Resolution recorded.') : 'Added to the call.'), 'success');
			this._loadActivityAsync(tmpState.Active.IDDocument);
		}
		catch (pError)
		{
			tmpState.Busy = false;
			this._toast(`Could not add: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			this._paintComposer();
		}
	}

	/** Close an open follow-up: record a cleared marker and drop the list follow-up flag. */
	async clearFollowUp()
	{
		const tmpState = this.state;
		if (!tmpState.Active || tmpState.Busy) { return; }
		tmpState.Busy = true; this._paintActivity();
		try
		{
			const tmpComment = await this._postJSON('Comment', { Comment: 'Follow-up cleared.', CommentHtml: 'Follow-up cleared.', Metadata: JSON.stringify({ Kind: 'FollowUp', Cleared: true }) });
			const tmpIDComment = tmpComment && tmpComment.IDComment;
			if (tmpIDComment) { await this._postJSON('DocumentCommentJoins', [ { IDDocument: tmpState.Active.IDDocument, IDComment: tmpIDComment } ]); }
			await this._mirrorFollowUpAsync(false);
			tmpState.Busy = false;
			this._toast('Follow-up cleared.', 'success');
			this._loadActivityAsync(tmpState.Active.IDDocument);
		}
		catch (pError)
		{
			tmpState.Busy = false;
			this._toast(`Could not clear the follow-up: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			this._paintActivity();
		}
	}


	// ── Delivery stage: an optional second lifecycle for calls that become development work ──────────────────────

	_paintImpl() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#Support-Impl').length) { tmpCA.assignContent('#Support-Impl', this._implBarHTML()); } }

	async setImplStage(pStage)
	{
		const tmpState = this.state;
		if (!tmpState.Active || tmpState.Busy) { return; }
		const tmpRD = this.pict.AppData.DocumentData && this.pict.AppData.DocumentData.ReportData;
		if (!tmpRD) { return; }
		const tmpFD = tmpRD.FormData || (tmpRD.FormData = {});
		const tmpPrev = (tmpFD.Implementation && tmpFD.Implementation.Stage) || '';
		if (tmpPrev === pStage) { return; }
		tmpFD.Implementation = tmpFD.Implementation || {};
		tmpFD.Implementation.Stage = pStage;
		tmpState.Busy = true; this._paintImpl();
		try
		{
			await this._putJSON('Document', { IDDocument: tmpState.Active.IDDocument, IDProject: tmpState.Active.IDProject, DocumentType: RNI_HASH, Form: 1, FormData: tmpFD });
			const tmpLabel = pStage ? (IMPL_STAGE_MAP[pStage] ? IMPL_STAGE_MAP[pStage].label : pStage) : 'not tracked';
			const tmpComment = await this._postJSON('Comment', { Comment: `Delivery stage → ${tmpLabel}`, CommentHtml: this._esc(`Delivery stage → ${tmpLabel}`), Metadata: JSON.stringify({ Kind: 'Stage', Stage: pStage }) });
			if (tmpComment && tmpComment.IDComment) { await this._postJSON('DocumentCommentJoins', [ { IDDocument: tmpState.Active.IDDocument, IDComment: tmpComment.IDComment } ]); }
			tmpState.Busy = false;
			const tmpRow = (tmpState.Calls || []).find((pC) => pC.IDDocument === tmpState.Active.IDDocument);
			if (tmpRow) { tmpRow.Stage = pStage; }
			this._toast('Delivery stage updated.', 'success');
			this._paintImpl();
			this._loadActivityAsync(tmpState.Active.IDDocument);
		}
		catch (pError)
		{
			tmpState.Busy = false;
			tmpFD.Implementation.Stage = tmpPrev;   // revert the optimistic write on failure
			this._toast(`Could not update the stage: ${(pError && pError.message) ? pError.message : pError}`, 'error');
			this._paintImpl();
		}
	}

	_implBarHTML()
	{
		const tmpRD = this.pict.AppData.DocumentData && this.pict.AppData.DocumentData.ReportData;
		const tmpStage = (tmpRD && tmpRD.FormData && tmpRD.FormData.Implementation && tmpRD.FormData.Implementation.Stage) || '';
		const tmpBusy = this.state.Busy;
		const tmpCollapsed = this.state.DeliveryCollapsed === true;
		const tmpSteps = IMPL_STAGES.map((pS) =>
			`<button class="sup-stg ${pS.cls} ${tmpStage === pS.id ? 'sup-stg-on' : ''}" ${tmpBusy ? 'disabled' : ''} onclick="_Pict.providers.Support.setImplStage('${pS.id}'); return false;">${this._esc(pS.label)}</button>`
		).join('<span class="sup-stg-sep">›</span>');
		// Collapsible "Delivery" section: thin header (title + current stage chip + chevron) over the stage track.
		const tmpChip = (tmpStage && IMPL_STAGE_MAP[tmpStage])
			? `<span class="sup-stg-chip ${IMPL_STAGE_MAP[tmpStage].cls}">${this._esc(IMPL_STAGE_MAP[tmpStage].label)}</span>`
			: `<span class="sup-sec-hint">optional</span>`;
		return `<div class="sup-sec${tmpCollapsed ? ' sup-sec-collapsed' : ''}">`
			+ `<button type="button" class="sup-sec-head" onclick="_Pict.providers.Support.toggleDeliveryCollapsed(); return false;">`
			+   `<span class="sup-sec-title">Delivery</span>${tmpChip}<i class="fas fa-chevron-down sup-sec-chev"></i></button>`
			+ `<div class="sup-sec-body"><div class="sup-stg-track">${tmpSteps}</div>`
			+   (tmpStage
				? `<button class="sup-stg-clear" ${tmpBusy ? 'disabled' : ''} onclick="_Pict.providers.Support.setImplStage(''); return false;" title="Clear delivery stage"><i class="fas fa-xmark"></i> Clear</button>`
				: `<span class="sup-stg-hint">optional — for calls that become work</span>`)
			+ `</div></div>`;
	}

	toggleApprovalCollapsed() { this.state.ApprovalCollapsed = !(this.state.ApprovalCollapsed === true); this._persistFilters(); this._paintApproval(); }
	toggleDeliveryCollapsed() { this.state.DeliveryCollapsed = !(this.state.DeliveryCollapsed === true); this._persistFilters(); this._paintImpl(); }

	_activityHTML()
	{
		let tmpBanner = '';
		// Follow-up is event-sourced: each FollowUp comment is a state change, the latest one (items are newest-first) wins.
		const tmpFU = this._activity.items.filter((pI) => pI.type === 'comment' && pI.kind === 'FollowUp' && pI.meta);
		if (tmpFU.length && !tmpFU[0].meta.Cleared)
		{
			const tmpF = tmpFU[0].meta;
			tmpBanner = `<div class="sup-fu-banner"><i class="fas fa-flag"></i> <b>Follow-up needed</b>`
				+ (tmpF.NeedByDate ? ` · due ${this._date(tmpF.NeedByDate)}` : '')
				+ (tmpF.WaitingOn ? ` · waiting on ${this._esc(tmpF.WaitingOn)}` : '')
				+ (tmpFU[0].text ? ` — ${this._esc(tmpFU[0].text)}` : '')
				+ ` <button class="sup-fu-done" ${this.state.Busy ? 'disabled' : ''} onclick="_Pict.providers.Support.clearFollowUp(); return false;"><i class="fas fa-check"></i> Mark done</button></div>`;
		}
		return `<div class="sup-act-h"><i class="fas fa-clock-rotate-left"></i> Call activity</div>`
			+ tmpBanner
			+ `<div id="Support-Composer" class="sup-composer">${this._composerHTML()}</div>`
			+ `<div id="Support-Timeline">${this._timelineHTML()}</div>`;
	}

	_composerHTML()
	{
		const tmpC = this._composer;
		const tmpBusy = this.state.Busy;
		const tmpKinds = COMPOSER_KINDS.map((pK) =>
		{
			const tmpM = ACTIVITY_KIND[pK];
			return `<button class="sup-ck ${tmpC.kind === pK ? 'sup-ck-on' : ''}" onclick="_Pict.providers.Support.setComposerKind('${pK}'); return false;"><i class="fas ${tmpM.icon}"></i> ${this._esc(tmpM.comLabel)}</button>`;
		}).join('');
		const tmpFollow = (tmpC.kind === 'FollowUp')
			? `<div class="sup-ck-fu"><label>Need by <input type="date" value="${this._esc(tmpC.needBy)}" onchange="_Pict.providers.Support.setComposerField('needBy', this.value)"></label>`
				+ `<label>Waiting on <input type="text" placeholder="e.g. customer reply, deploy" value="${this._esc(tmpC.waitingOn)}" oninput="_Pict.providers.Support.setComposerField('waitingOn', this.value)"></label></div>` : '';
		const tmpToCaller = ACTIVITY_KIND[tmpC.kind] && ACTIVITY_KIND[tmpC.kind].toCaller;
		const tmpHint = tmpToCaller ? `<span class="sup-ck-hint"><i class="fas fa-circle-info"></i> Recorded now; caller email is a later step.</span>` : '';
		const tmpPlaceholder = (tmpC.kind === 'FollowUp') ? 'What is the next follow-up? (optional)' : (tmpToCaller ? 'Message to the caller…' : 'Add a note…');
		// The message body is the app's first-class markdown editor (mounted after paint by _mountComposerEditor), not a
		// plain textarea — so notes, acknowledgements, and resolutions can be written in markdown like the runbooks.
		return `<div class="sup-ck-kinds">${tmpKinds}</div>${tmpFollow}`
			+ `<div class="sup-ck-ph">${this._esc(tmpPlaceholder)}</div>`
			+ `<div id="Support-Composer-Editor-Mount" class="sup-ck-editor"></div>`
			+ `<div class="sup-ck-actions">${tmpHint}<button class="sup-btn sup-btn-primary" ${tmpBusy ? 'disabled' : ''} onclick="_Pict.providers.Support.addComment(); return false;">${tmpBusy ? '<i class="fas fa-spinner fa-spin"></i> Adding…' : '<i class="fas fa-plus"></i> Add'}</button></div>`;
	}

	_timelineHTML()
	{
		const tmpA = this._activity;
		if (tmpA.loading) { return `<div class="sup-note"><i class="fas fa-spinner fa-spin"></i> Loading activity…</div>`; }
		if (!tmpA.items.length) { return `<div class="sup-tl-empty">No activity yet — add a note or acknowledge the caller.</div>`; }
		return `<div class="sup-tl">` + tmpA.items.map((pIt) =>
		{
			const tmpWho = this._agentNames[pIt.by] || (pIt.by ? `User ${pIt.by}` : 'System');
			const tmpWhen = this._dateTime(pIt.at);
			if (pIt.type === 'transition')
			{
				const tmpAct = ACTION_META[pIt.action] || { icon: 'fa-arrow-right' };
				const tmpSt = this._statusMeta(pIt.status);
				const tmpVerb = pIt.isApproval ? 'resolved' : (pIt.action ? this._esc(String(pIt.action).replace(/([A-Z])/g, ' $1').trim().toLowerCase()) : 'updated');
				return `<div class="sup-tl-item"><span class="sup-tl-icon sup-ak-tr"><i class="fas ${tmpAct.icon}"></i></span>`
					+ `<div class="sup-tl-body"><div class="sup-tl-head"><b>${this._esc(tmpWho)}</b> ${tmpVerb} → <span class="sup-badge ${tmpSt.cls}">${tmpSt.label}</span> <span class="sup-tl-when">${tmpWhen}</span></div></div></div>`;
			}
			const tmpKind = ACTIVITY_KIND[pIt.kind] || ACTIVITY_KIND.Note;
			const tmpExtra = (pIt.kind === 'FollowUp' && pIt.meta)
				? `<div class="sup-tl-fu">${pIt.meta.NeedByDate ? `Due ${this._date(pIt.meta.NeedByDate)}` : ''}${pIt.meta.WaitingOn ? `${pIt.meta.NeedByDate ? ' · ' : ''}waiting on ${this._esc(pIt.meta.WaitingOn)}` : ''}${pIt.meta.Cleared ? ' · <em>cleared</em>' : ''}</div>` : '';
			return `<div class="sup-tl-item"><span class="sup-tl-icon ${tmpKind.cls}"><i class="fas ${tmpKind.icon}"></i></span>`
				+ `<div class="sup-tl-body"><div class="sup-tl-head"><b>${this._esc(tmpWho)}</b> <span class="sup-tl-kind ${tmpKind.cls}">${tmpKind.label}</span> <span class="sup-tl-when">${tmpWhen}</span></div>`
				+ (pIt.text ? `<div class="sup-tl-text sup-md">${this._renderMd(pIt.text)}</div>` : '') + tmpExtra + `</div></div>`;
		}).join('') + `</div>`;
	}

	// ── List filters + sort + export (all client-side over the loaded call set) ──────────────────────────────────

	onSearch(pValue) { this.state.Filter = pValue || ''; this.state.ListPage = 0; this._persistFilters(); this._repaintList(); }

	/** Toggle a value in a multi-select facet (Status/Priority/Category/App); empty facet = all. */
	toggleFilter(pFacet, pValue)
	{
		const tmpSel = this.state.Filters[pFacet] || (this.state.Filters[pFacet] = []);
		const tmpIdx = tmpSel.indexOf(pValue);
		if (tmpIdx >= 0) { tmpSel.splice(tmpIdx, 1); } else { tmpSel.push(pValue); }
		this.state.ListPage = 0;
		this._persistFilters();
		this._paint();
	}

	setDateFilter(pWhich, pValue)
	{
		if (!this.state.DateFilter) { this.state.DateFilter = { from: '', to: '' }; }
		this.state.DateFilter[pWhich] = pValue || '';
		this.state.ListPage = 0;
		this._persistFilters();
		this._paint();
	}

	clearFilters()
	{
		this.state.Filters = { Status: [], Priority: [], Category: [], App: [], Stage: [], Customer: [] };
		this.state.DateFilter = { from: '', to: '' };
		this.state.Filter = '';
		this.state.OpenDropdown = '';
		this.state.ListPage = 0;
		this._persistFilters();
		this._paint();
	}

	/** Persist the triage filters (facets / date range / search / sort) so they survive navigation AND a reload. */
	_persistFilters()
	{
		try
		{
			if (typeof localStorage === 'undefined') { return; }
			const tmpState = this.state;
			localStorage.setItem('Support.TriageFilters', JSON.stringify({ Filters: tmpState.Filters, DateFilter: tmpState.DateFilter, Filter: tmpState.Filter, Sort: tmpState.Sort, PanelWidth: tmpState.PanelWidth, RunbookOpen: tmpState.RunbookOpen, ApprovalCollapsed: tmpState.ApprovalCollapsed, DeliveryCollapsed: tmpState.DeliveryCollapsed }));
		}
		catch (pError) { /* best-effort — a blocked/full localStorage must never break filtering */ }
	}

	/** Restore persisted triage filters (shape-guarded) to overlay onto the state defaults. {} if none/unavailable. */
	_loadPersistedFilters()
	{
		try
		{
			const tmpRaw = (typeof localStorage !== 'undefined') ? localStorage.getItem('Support.TriageFilters') : null;
			if (!tmpRaw) { return {}; }
			const tmpSaved = JSON.parse(tmpRaw) || {};
			const tmpOut = {};
			if (tmpSaved.Filters && typeof tmpSaved.Filters === 'object') { tmpOut.Filters = tmpSaved.Filters; }
			if (tmpSaved.DateFilter && typeof tmpSaved.DateFilter === 'object') { tmpOut.DateFilter = tmpSaved.DateFilter; }
			if (typeof tmpSaved.Filter === 'string') { tmpOut.Filter = tmpSaved.Filter; }
			if (Array.isArray(tmpSaved.Sort) && tmpSaved.Sort.length) { tmpOut.Sort = tmpSaved.Sort; }
			if (typeof tmpSaved.PanelWidth === 'number') { tmpOut.PanelWidth = tmpSaved.PanelWidth; }
			if (typeof tmpSaved.RunbookOpen === 'boolean') { tmpOut.RunbookOpen = tmpSaved.RunbookOpen; }
			if (typeof tmpSaved.ApprovalCollapsed === 'boolean') { tmpOut.ApprovalCollapsed = tmpSaved.ApprovalCollapsed; }
			if (typeof tmpSaved.DeliveryCollapsed === 'boolean') { tmpOut.DeliveryCollapsed = tmpSaved.DeliveryCollapsed; }
			return tmpOut;
		}
		catch (pError) { return {}; }
	}

	toggleDropdown(pFacet) { this.state.OpenDropdown = (this.state.OpenDropdown === pFacet) ? '' : pFacet; this._paint(); }

	/**
	 * Sort by a column. Plain click = make it the sole (primary) sort, toggling asc/desc if already primary; Shift-click
	 * = add/adjust it as a secondary key, for layered sort (status → priority → category …).
	 */
	setSort(pKey, pAppend)
	{
		const tmpSort = this.state.Sort;
		const tmpIdx = tmpSort.findIndex((pS) => pS.key === pKey);
		if (pAppend)
		{
			if (tmpIdx >= 0) { tmpSort[tmpIdx].dir = tmpSort[tmpIdx].dir === 'asc' ? 'desc' : 'asc'; }
			else { tmpSort.push({ key: pKey, dir: 'asc' }); }
		}
		else if (tmpIdx === 0 && tmpSort.length === 1) { tmpSort[0].dir = tmpSort[0].dir === 'asc' ? 'desc' : 'asc'; }
		else { this.state.Sort = [ { key: pKey, dir: (tmpIdx === 0 && tmpSort[0]) ? (tmpSort[0].dir === 'asc' ? 'desc' : 'asc') : 'asc' } ]; }
		this.state.ListPage = 0;
		this._persistFilters();
		this._paint();
	}

	/** Jump to a page of the triage list (client-side pagination of the filtered set); repaints only the list body. */
	setListPage(pPage)
	{
		this.state.ListPage = Math.max(0, Number(pPage) || 0);
		this._repaintList();
		const tmpEl = this.pict.ContentAssignment.getElement(LIST_MOUNT);
		if (tmpEl && tmpEl.length && tmpEl[0].scrollIntoView) { try { tmpEl[0].scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (pError) { /* */ } }
	}

	/** The comparable value for a call on a sort key — rank maps for Status/Priority (lexical order would be wrong). */
	_sortValue(pCall, pKey)
	{
		switch (pKey)
		{
			case 'Status': return (STATUS_ORDER[pCall.Status] != null) ? STATUS_ORDER[pCall.Status] : 9;
			case 'Priority': return this._prioMeta(pCall.Priority).rank;
			case 'Category': return this._catLabelList(pCall.Category).toLowerCase();
			case 'App': return this._appLabel(pCall.App).toLowerCase();
			case 'Customer': return this._customerName(pCall.CallerCustomer).toLowerCase();
			case 'Summary': return String(pCall.Summary || '').toLowerCase();
			case 'Caller': return String(pCall.Caller || '').toLowerCase();
			case 'Created': return String(pCall.Created || '');
			case 'Updated': return String(pCall.Updated || '');
			case 'Designated': return String(pCall.Designated || '');
			case 'UpdatedBy': return String(this._agentNames[pCall.UpdatedBy] || '').toLowerCase();
			default: return '';
		}
	}

	_compareCalls(pA, pB)
	{
		for (const tmpKey of this.state.Sort)
		{
			const tmpVA = this._sortValue(pA, tmpKey.key);
			const tmpVB = this._sortValue(pB, tmpKey.key);
			if (tmpVA < tmpVB) { return tmpKey.dir === 'asc' ? -1 : 1; }
			if (tmpVA > tmpVB) { return tmpKey.dir === 'asc' ? 1 : -1; }
		}
		return pB.IDDocument - pA.IDDocument;   // stable tiebreak
	}

	_visibleCalls()
	{
		const tmpState = this.state;
		const tmpNeedle = String(tmpState.Filter || '').trim().toLowerCase();
		const tmpFacets = this._facets();
		const tmpRows = tmpState.Calls.filter((pCall) =>
		{
			for (const tmpFacet of tmpFacets)
			{
				const tmpSel = tmpState.Filters[tmpFacet.key];
				if (tmpSel && tmpSel.length && tmpSel.indexOf(String(tmpFacet.valueFor(pCall))) < 0) { return false; }
			}
			const tmpDF = tmpState.DateFilter || {};
			if (tmpDF.from || tmpDF.to)
			{
				// Compare on the ISO calendar-day prefix (YYYY-MM-DD) — a pure string compare, matching how the sort
				// treats these fields and sidestepping the _date() local/UTC gotcha; string <= gives an inclusive end.
				const tmpDay = String(pCall.Designated || '').slice(0, 10);
				if (!tmpDay) { return false; }
				if (tmpDF.from && tmpDay < tmpDF.from) { return false; }
				if (tmpDF.to && tmpDay > tmpDF.to) { return false; }
			}
			if (!tmpNeedle) { return true; }
			return [ pCall.Summary, pCall.Caller, this._catLabelList(pCall.Category), this._appLabel(pCall.App), pCall.Priority,
				(this._isSuperUser() ? this._customerName(pCall.CallerCustomer) : ''), (this._agentNames[pCall.UpdatedBy] || ''), `#${pCall.IDDocument}` ]
				.some((pField) => String(pField || '').toLowerCase().indexOf(tmpNeedle) >= 0);
		});
		return tmpRows.sort((pA, pB) => this._compareCalls(pA, pB));
	}

	// ── CSV export (the current filtered view; manager-gated) ────────────────────────────────────────────────────

	_triggerBrowserDownload(pBlob, pFileName)
	{
		try
		{
			const tmpURL = URL.createObjectURL(pBlob);
			const tmpAnchor = document.createElement('a');
			tmpAnchor.href = tmpURL; tmpAnchor.download = pFileName;
			document.body.appendChild(tmpAnchor); tmpAnchor.click(); document.body.removeChild(tmpAnchor);
			setTimeout(() => { try { URL.revokeObjectURL(tmpURL); } catch (pError) { /* */ } }, 10000);
		}
		catch (pError) { this._toast('Could not start the download.', 'error'); }
	}

	/** One CSV cell — quote-escape commas/quotes/newlines + neutralize an Excel formula-injection lead char. */
	_csvCell(pValue)
	{
		let tmpString = String(pValue == null ? '' : pValue);
		if (/^[=+\-@]/.test(tmpString)) { tmpString = '\'' + tmpString; }
		if (/[",\r\n]/.test(tmpString)) { tmpString = '"' + tmpString.replace(/"/g, '""') + '"'; }
		return tmpString;
	}

	exportCallsCSV()
	{
		if (!this.canManage()) { return; }
		const tmpRows = this._visibleCalls();
		if (!tmpRows.length) { this._toast('No calls to export in the current view.', 'info'); return; }
		const tmpSuper = this._isSuperUser();
		const tmpHeader = [ '#', 'Status' ].concat(tmpSuper ? [ 'Customer' ] : []).concat([ 'Priority', 'Category', 'App', 'Summary', 'Caller', 'Follow-up', 'Opened', 'Updated', 'Designated', 'Updated By' ]);
		const tmpLines = [ tmpHeader.map((pH) => this._csvCell(pH)).join(',') ];
		tmpRows.forEach((pCall) =>
		{
			const tmpCells = [ pCall.IDDocument, this._statusMeta(pCall.Status).label ]
				.concat(tmpSuper ? [ this._customerName(pCall.CallerCustomer) ] : [])
				.concat([ this._prioMeta(pCall.Priority).label, this._catLabelList(pCall.Category), this._appLabel(pCall.App),
					pCall.Summary, pCall.Caller, pCall.FollowUp ? 'Yes' : '', this._date(pCall.Created), this._date(pCall.Updated), this._date(pCall.Designated),
					pCall.UpdatedBy ? (this._agentNames[pCall.UpdatedBy] || ('User ' + pCall.UpdatedBy)) : '' ]);
			tmpLines.push(tmpCells.map((pV) => this._csvCell(pV)).join(','));
		});
		const tmpCSV = '\uFEFF' + tmpLines.join('\r\n');   // BOM → Excel reads UTF-8 cleanly
		const tmpStamp = (new Date()).toISOString().slice(0, 10);
		// Filtered to exactly one customer → name the file after them (the HDOT bi-weekly download).
		const tmpCustFilter = this.state.Filters.Customer || [];
		const tmpWho = (tmpSuper && tmpCustFilter.length === 1) ? ('-' + String(this._customerName(Number(tmpCustFilter[0]))).replace(/[^A-Za-z0-9]+/g, '')) : '';
		this._triggerBrowserDownload(new Blob([ tmpCSV ], { type: 'text/csv;charset=utf-8' }), `Support-Calls${tmpWho}-${tmpStamp}.csv`);
		this._toast(`Exported ${tmpRows.length} call${tmpRows.length === 1 ? '' : 's'}.`, 'success');
	}

	// ── Metrics ────────────────────────────────────────────────────────────────────────────────────────────────

	setView(pView)
	{
		if (this._isDocsOnly()) { pView = 'docs'; }   // runbook-only user is pinned to the Docs surface
		const tmpView = ([ 'metrics', 'settings', 'docs' ].indexOf(pView) >= 0) ? pView : 'calls';
		// Metrics + settings stay manager-only; the docs/runbook view also opens to runbook editors (Document-edit holders).
		if (tmpView !== 'calls' && !this.canManage() && !(tmpView === 'docs' && this._canAccessDocs())) { return; }
		if (this.state.View === tmpView && this.state.Mode !== 'form') { return; }
		this.state.View = tmpView;
		if (tmpView === 'metrics' && !this._metrics) { this._loadMetricsAsync(); }
		else if (tmpView === 'settings') { this._loadSettingsDraftAsync(); }
		else if (tmpView === 'docs') { this._loadDocsAsync(); }
		else { this._paint(); }
	}

	// ── Stable routes ─────────────────────────────────────────────────────────────────────────────────────────────
	// The tab buttons / gears / call rows write the URL hash; the router (below) applies it. So every surface is
	// deep-linkable + bookmarkable + back/forward-able — no view is reached by a bare JS state mutation. See [[config-app-tab-stable-routes]].

	/** Write the hash for a top-level view; a preset click closes any open call. Falls back to setView with no window. */
	navigateView(pView)
	{
		const tmpView = ([ 'metrics', 'settings', 'docs' ].indexOf(pView) >= 0) ? pView : 'calls';
		if ((typeof window === 'undefined') || !window.location) { this.routeApply(tmpView); return; }
		window.location.hash = '#/Support' + (tmpView === 'calls' ? '' : '/' + tmpView);
	}

	/** Write the hash to open a specific call. */
	navigateCall(pIDDocument)
	{
		if (this._isDocsOnly()) { return; }   // runbook-only user has no call access
		if ((typeof window === 'undefined') || !window.location) { this.openCall(pIDDocument); return; }
		window.location.hash = `#/Support/Call/${Number(pIDDocument)}`;
	}

	/** Router entry: land on a top-level view. Guarded so a warm tab click is an in-place switch (no reload); returning
	 *  from an open call reloads the list once so it reflects any edits. */
	routeApply(pView)
	{
		const tmpView = ([ 'metrics', 'settings', 'docs' ].indexOf(pView) >= 0) ? pView : 'calls';
		if (this.state.Mode === 'form' || this.state.Mode === 'merge')
		{
			if (this.state.Mode === 'form' && this.formHost && (typeof this.formHost.destroy === 'function')) { try { this.formHost.destroy(); } catch (pErr) { /* best-effort */ } }
			if (this.state.Mode === 'merge') { const tmpMerge = this.pict.providers.SupportMerge; if (tmpMerge && (typeof tmpMerge.teardown === 'function')) { tmpMerge.teardown(); } }
			this.state.View = tmpView;
			this._pendingApply = (pProvider) => pProvider.setView(tmpView);   // applied after loadAsync resolves (list mode)
			this.loadAsync();
			return;
		}
		this.setView(tmpView);
	}

	/** Router entry: open a specific call (no-op if it is already the open one). */
	routeApplyCall(pIDDocument)
	{
		if (this._isDocsOnly()) { this.navigateView('docs'); return; }   // deep-link to a call → bounce a runbook-only user to Docs
		const tmpID = Number(pIDDocument);
		if (this.state.Mode === 'form' && this.state.Active && Number(this.state.Active.IDDocument) === tmpID) { return; }
		this.openCall(tmpID);
	}

	/** The dashboard's active date-range scope → { from, to (YYYY-MM-DD, half-open), label, startY, startM, months }.
	 *  Drives BOTH the scoped document load and the trend-chart month buckets, so the two always agree. */
	_metricsRangeBounds()
	{
		const tmpNow = new Date();
		const tmpPreset = (this.state.MetricsRange && this.state.MetricsRange.preset) || 'last12';
		const tmpYMD = (pD) => `${pD.getFullYear()}-${String(pD.getMonth() + 1).padStart(2, '0')}-01`;
		if (/^\d{4}$/.test(tmpPreset))
		{
			const tmpY = Number(tmpPreset);
			return { from: `${tmpY}-01-01`, to: `${tmpY + 1}-01-01`, label: tmpPreset, startY: tmpY, startM: 0, months: 12 };
		}
		if (tmpPreset === 'all')
		{
			const tmpEnd = new Date(tmpNow.getFullYear(), tmpNow.getMonth() + 1, 1);
			return { from: '2020-01-01', to: tmpYMD(tmpEnd), label: 'All', startY: 2020, startM: 0, months: (tmpNow.getFullYear() - 2020) * 12 + tmpNow.getMonth() + 1 };
		}
		if (tmpPreset === 'custom')
		{
			const tmpR = this.state.MetricsRange || {};
			const tmpFrom = tmpR.from || `${tmpNow.getFullYear()}-01-01`;
			const tmpToPicked = tmpR.to || tmpYMD(tmpNow);
			const tmpFromD = new Date(tmpFrom + 'T00:00:00');
			const tmpToPickedD = new Date(tmpToPicked + 'T00:00:00');
			const tmpToD = new Date(tmpToPicked + 'T00:00:00'); tmpToD.setDate(tmpToD.getDate() + 1);   // make the picked end date INCLUSIVE (LT is exclusive)
			const tmpToExcl = `${tmpToD.getFullYear()}-${String(tmpToD.getMonth() + 1).padStart(2, '0')}-${String(tmpToD.getDate()).padStart(2, '0')}`;
			// Trend months span the PICKED range (from-month … to-month), not the +1-day exclusive bound.
			const tmpMonths = Math.max(1, Math.min(96, (tmpToPickedD.getFullYear() - tmpFromD.getFullYear()) * 12 + (tmpToPickedD.getMonth() - tmpFromD.getMonth()) + 1));
			return { from: tmpFrom, to: tmpToExcl, label: `${tmpFrom} → ${tmpToPicked}`, startY: tmpFromD.getFullYear(), startM: tmpFromD.getMonth(), months: tmpMonths };
		}
		const tmpStart = new Date(tmpNow.getFullYear(), tmpNow.getMonth() - 11, 1);
		const tmpEnd = new Date(tmpNow.getFullYear(), tmpNow.getMonth() + 1, 1);
		return { from: tmpYMD(tmpStart), to: tmpYMD(tmpEnd), label: 'Last 12 months', startY: tmpStart.getFullYear(), startM: tmpStart.getMonth(), months: 12 };
	}

	_monthBuckets()
	{
		const tmpB = this._metricsRangeBounds();
		this._trendSpan = tmpB.months;
		const tmpOut = [];
		for (let i = 0; i < tmpB.months; i++)
		{
			const tmpM = new Date(tmpB.startY, tmpB.startM + i, 1);
			tmpOut.push({ key: `${tmpM.getFullYear()}-${String(tmpM.getMonth() + 1).padStart(2, '0')}`, y: tmpM.getFullYear(), m: tmpM.getMonth() });
		}
		return tmpOut;
	}

	/** Fetch the resolution log once (earliest IsApproval per doc = resolution + resolver), then compute the dashboard. */
	/** Load the documents in the active date-range scope (its OWN set, independent of the 400-cap call list), paged by
	 *  DocumentDate = the opened/first-email date. */
	async _loadMetricsCallsAsync(pFrom, pTo, pGen)
	{
		const tmpScope = this._isSuperUser() ? '' : `FBV~IDCustomer~EQ~${this.idCustomer}~`;
		const tmpOwn = this.isSelfService() ? `~FBV~CreatingIDUser~EQ~${this.idUser}` : '';
		const tmpBase = `${tmpScope}FBV~DocumentType~EQ~${RNI_HASH}~FBV~Deleted~EQ~0~FBV~DocumentDate~GE~${pFrom}~FBV~DocumentDate~LT~${pTo}${tmpOwn}`;
		// A Count first gives the exact page plan so the pages can be fetched CONCURRENTLY (sequential paging of the big
		// FormData docs is the slow part). Sort DESC — on this large table an ASC sort with offset paging is pathologically
		// slow; DESC is index-fast, and the metrics aggregate over the set so order doesn't matter.
		const tmpCount = await this._getJSON(`Documents/Count/FilteredTo/${tmpBase}`);
		if (pGen !== this._loadGen) { return []; }
		const tmpTotal = Math.min((tmpCount && Number(tmpCount.Count)) || 0, 30000);
		const tmpOffsets = []; for (let tmpOff = 0; tmpOff < tmpTotal; tmpOff += 500) { tmpOffsets.push(tmpOff); }
		const tmpOut = [];
		const tmpConcurrency = 8;
		for (let i = 0; i < tmpOffsets.length; i += tmpConcurrency)
		{
			const tmpBatch = tmpOffsets.slice(i, i + tmpConcurrency);
			const tmpResults = await Promise.all(tmpBatch.map((pOff) => this._getJSON(`Documents/FilteredTo/${tmpBase}~FSF~IDDocument~DESC~0/${pOff}/500`).catch(() => [])));
			if (pGen !== this._loadGen) { return tmpOut; }
			tmpResults.forEach((pRows) => { (Array.isArray(pRows) ? pRows : []).forEach((pDoc) => tmpOut.push(this._callSummary(pDoc))); });
		}
		return tmpOut;
	}

	async _loadMetricsAsync()
	{
		const tmpGen = ++this._loadGen;   // shared guard: a list reload or a view switch supersedes a stale metrics load
		this._metricsLoading = true;
		this._paint();
		try
		{
			const tmpBounds = this._metricsRangeBounds();
			const tmpCalls = await this._loadMetricsCallsAsync(tmpBounds.from, tmpBounds.to, tmpGen);
			if (tmpGen !== this._loadGen) { return; }
			this._metricsCalls = tmpCalls;
			// Resolve map: LEGACY docs carry their real close date/agent in FormData.Meta (approval-log CreateDate is
			// import-stamped) — take those with no query. Only LIVE docs need the DocumentApprovalLog lookup, so at
			// archive scale (~all legacy) we issue almost none.
			const tmpResolve = {};
			const tmpLiveIDs = tmpCalls.filter((pCall) => !pCall.Legacy).map((pCall) => pCall.IDDocument).filter(Boolean);
			for (let i = 0; i < tmpLiveIDs.length; i += 100)
			{
				const tmpChunk = tmpLiveIDs.slice(i, i + 100);
				const tmpRows = await this._getJSON(`DocumentApprovalLogs/FilteredTo/FBL~IDDocument~INN~${tmpChunk.join(',')}~FBV~Deleted~EQ~0~FSF~CreateDate~DESC~0/0/8000`);
				if (tmpGen !== this._loadGen) { return; }
				(Array.isArray(tmpRows) ? tmpRows : []).forEach((pLog) =>
				{
					if (Number(pLog.IsApproval) !== 1) { return; }
					const tmpHave = tmpResolve[pLog.IDDocument];
					if (!tmpHave || pLog.CreateDate < tmpHave.date) { tmpResolve[pLog.IDDocument] = { date: pLog.CreateDate, resolver: Number(pLog.CreatingIDUser) || 0 }; }
				});
			}
			tmpCalls.forEach((pCall) =>
			{
				if (!pCall.Legacy || pCall.Status !== 'Resolved') { return; }
				tmpResolve[pCall.IDDocument] = { date: pCall.ResolvedAt || pCall.Updated || pCall.Created || '', resolver: pCall.ResolvedBy || (tmpResolve[pCall.IDDocument] && tmpResolve[pCall.IDDocument].resolver) || 0 };
			});
			this._resolveMap = tmpResolve;
			// Resolve names for the resolver (support user) + opener (customer user) filters/breakdowns.
			const tmpNames = [];
			Object.keys(tmpResolve).forEach((pK) => { if (tmpResolve[pK].resolver) { tmpNames.push(tmpResolve[pK].resolver); } });
			tmpCalls.forEach((pCall) => { if (pCall.OpenedBy) { tmpNames.push(pCall.OpenedBy); } });
			await this._resolveAgentNames(tmpNames, tmpGen);
			if (tmpGen !== this._loadGen) { return; }
			this._recomputeMetrics();
		}
		catch (pError) { this._metrics = { error: (pError && pError.message) ? pError.message : String(pError) }; }
		// Only repaint the full shell when the list is on screen — a metrics load that resolves after the user has moved to a
		// call form or the inline merge wizard must NOT _paint() (it would tear down the mounted #Support-FormHost or the
		// #SupportMerge-Wizard accordion). The metrics dashboard is itself a list-mode sub-view, so this still repaints it.
		finally { if (tmpGen === this._loadGen) { this._metricsLoading = false; if (this.state.Mode === 'list') { this._paint(); } } }
	}

	/** Switch the dashboard date-range scope and reload its metrics. */
	setMetricsRange(pPreset)
	{
		if (!this.state.MetricsRange) { this.state.MetricsRange = {}; }
		this.state.MetricsRange.preset = pPreset || 'last12';
		this._showCustomRange = false;   // a preset click closes the custom From/To editor
		this._metrics = null;
		this._loadMetricsAsync();
		this._paintMetrics();
	}

	/** Does a call pass the current dashboard filters (customer / support-user / customer-user / type)? */
	_metricCallPasses(pCall)
	{
		const tmpF = this.state.MetricsFilters || {};
		if (tmpF.Customer && String(pCall.CallerCustomer || '') !== tmpF.Customer) { return false; }
		if (tmpF.Category && (pCall.Category || '') !== tmpF.Category) { return false; }
		if (tmpF.App && (pCall.App || '') !== tmpF.App) { return false; }
		if (tmpF.Opener && String(pCall.OpenedBy || '') !== tmpF.Opener) { return false; }
		if (tmpF.Resolver)
		{
			const tmpRes = (this._resolveMap || {})[pCall.IDDocument];
			if (!tmpRes || String(tmpRes.resolver || '') !== tmpF.Resolver) { return false; }
		}
		return true;
	}

	/** Derive every dashboard aggregate from the loaded calls ⊕ the cached resolve map, honoring the metrics filters. */
	_recomputeMetrics()
	{
		const tmpResolve = this._resolveMap || {};
		const tmpCalls = (this._metricsCalls || []).filter((pCall) => this._metricCallPasses(pCall));
		const tmpByCustomer = {};   // IDCustomer → { total, resolved, open } (dashboard-from-the-polyjoins, #3)
		const tmpByTheme = {};      // derived theme → { total, resolved }
		const tmpMonths = this._monthBuckets();
		const tmpIdx = {}; tmpMonths.forEach((pMo, i) => { tmpIdx[pMo.key] = i; });
		const tmpOpened = new Array(tmpMonths.length).fill(0);
		const tmpResolved = new Array(tmpMonths.length).fill(0);
		const tmpBugOpened = new Array(tmpMonths.length).fill(0);
		const tmpBugResolved = new Array(tmpMonths.length).fill(0);
		const tmpCycles = [];
		const tmpCounts = { New: 0, Acknowledged: 0, Tier1: 0, Tier2: 0, Tier3: 0, Resolved: 0, Void: 0 };
		const tmpByCat = {}; const tmpByPrio = {}; const tmpByApp = {}; const tmpByAgent = {}; const tmpByBugApp = {};
		let tmpBugTotal = 0; let tmpBugBacklog = 0; const tmpBugCycles = [];

		tmpCalls.forEach((pCall) =>
		{
			const tmpIsBug = pCall.Category === 'Bug';
			if (tmpCounts[pCall.Status] != null) { tmpCounts[pCall.Status]++; }
			// A voided (spam / not-a-real-call) ticket is counted in the status breakdown above, then excluded from every
			// volume, resolution, backlog and trend rollup below — it is not a real call, so it must never show as a
			// customer's open backlog, inflate the bug backlog, or pollute the opened/resolved series.
			if (pCall.Status === 'Void') { return; }
			if (pCall.Created) { const tmpMi = tmpIdx[String(pCall.Created).slice(0, 7)]; if (tmpMi != null) { tmpOpened[tmpMi]++; if (tmpIsBug) { tmpBugOpened[tmpMi]++; } } }
			const tmpCat = tmpByCat[pCall.Category || 'Uncategorized'] || (tmpByCat[pCall.Category || 'Uncategorized'] = { total: 0, resolved: 0 }); tmpCat.total++;
			const tmpPrio = tmpByPrio[pCall.Priority || 'Unset'] || (tmpByPrio[pCall.Priority || 'Unset'] = { total: 0, resolved: 0 }); tmpPrio.total++;
			const tmpApp = tmpByApp[pCall.App || 'Unspecified'] || (tmpByApp[pCall.App || 'Unspecified'] = { total: 0, resolved: 0 }); tmpApp.total++;
			if (pCall.CallerCustomer) { const tmpC = tmpByCustomer[pCall.CallerCustomer] || (tmpByCustomer[pCall.CallerCustomer] = { total: 0, resolved: 0, open: 0 }); tmpC.total++; if (pCall.Status === 'Resolved') { tmpC.resolved++; } else { tmpC.open++; } }
			{ const tmpTh = tmpByTheme[pCall.Theme || 'Other'] || (tmpByTheme[pCall.Theme || 'Other'] = { total: 0, resolved: 0 }); tmpTh.total++; if (pCall.Status === 'Resolved') { tmpTh.resolved++; } }
			if (tmpIsBug)
			{
				tmpBugTotal++;
				if (pCall.Status !== 'Resolved') { tmpBugBacklog++; }
				const tmpBA = tmpByBugApp[pCall.App || 'Unspecified'] || (tmpByBugApp[pCall.App || 'Unspecified'] = { total: 0, resolved: 0 }); tmpBA.total++;
			}
			const tmpRes = tmpResolve[pCall.IDDocument];
			if (tmpRes)
			{
				tmpCat.resolved++; tmpPrio.resolved++; tmpApp.resolved++;
				const tmpMi = tmpIdx[String(tmpRes.date).slice(0, 7)]; if (tmpMi != null) { tmpResolved[tmpMi]++; if (tmpIsBug) { tmpBugResolved[tmpMi]++; } }
				if (pCall.Created && tmpRes.date >= pCall.Created)
				{
					const tmpDelta = (new Date(tmpRes.date) - new Date(pCall.Created)) / 86400000;
					tmpCycles.push(tmpDelta); if (tmpIsBug) { tmpBugCycles.push(tmpDelta); }
				}
				if (tmpIsBug) { const tmpBA = tmpByBugApp[pCall.App || 'Unspecified']; if (tmpBA) { tmpBA.resolved++; } }
				if (tmpRes.resolver) { const tmpA = tmpByAgent[tmpRes.resolver] || (tmpByAgent[tmpRes.resolver] = { resolved: 0 }); tmpA.resolved++; }
			}
		});
		const tmpMedianOf = (pArr) => { if (!pArr.length) { return null; } const tmpS = pArr.slice().sort((pA, pB) => pA - pB); return tmpS.length % 2 ? tmpS[(tmpS.length - 1) / 2] : (tmpS[tmpS.length / 2 - 1] + tmpS[tmpS.length / 2]) / 2; };

		this._metrics =
		{
			total: tmpCalls.length,
			counts: tmpCounts,
			backlog: tmpCounts.New + tmpCounts.Acknowledged + tmpCounts.Tier1 + tmpCounts.Tier2 + tmpCounts.Tier3,
			resolved: tmpCounts.Resolved,
			medianDays: tmpMedianOf(tmpCycles),
			months: tmpMonths, opened: tmpOpened, resolvedSeries: tmpResolved,
			byCat: tmpByCat, byPrio: tmpByPrio, byApp: tmpByApp, byAgent: tmpByAgent, byCustomer: tmpByCustomer, byTheme: tmpByTheme,
			rangeLabel: this._metricsRangeBounds().label,
			bug: { total: tmpBugTotal, backlog: tmpBugBacklog, medianDays: tmpMedianOf(tmpBugCycles), byApp: tmpByBugApp, opened: tmpBugOpened, resolved: tmpBugResolved },
		};
	}

	_paintMetrics() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#Support-Metrics').length) { tmpCA.assignContent('#Support-Metrics', this._metricsHTML()); this._mountViewPickers(); } }

	setMetricFilter(pDim, pValue)
	{
		if (!this.state.MetricsFilters) { this.state.MetricsFilters = {}; }
		this.state.MetricsFilters[pDim] = pValue || '';
		this._recomputeMetrics();
		this._paintMetrics();
	}

	clearMetricFilters() { this.state.MetricsFilters = { Customer: '', App: '', Category: '', Resolver: '', Opener: '' }; this._recomputeMetrics(); this._paintMetrics(); }

	async _resolveAgentNames(pIDs, pGen)
	{
		const tmpNeed = [ ...new Set(pIDs.filter((pX) => pX && !this._agentNames[pX])) ];
		for (let i = 0; i < tmpNeed.length; i += 100)
		{
			const tmpChunk = tmpNeed.slice(i, i + 100);
			const tmpRows = await this._getJSON(`Users/FilteredTo/FBL~IDUser~INN~${tmpChunk.join(',')}/0/${tmpChunk.length}`);
			if (pGen !== this._loadGen) { return; }
			(Array.isArray(tmpRows) ? tmpRows : []).forEach((pU) => { this._agentNames[pU.IDUser] = [ pU.NameFirst, pU.NameLast ].filter(Boolean).join(' ') || pU.LoginID || `User ${pU.IDUser}`; });
		}
	}

	_days(pDays) { const tmpD = Math.round(pDays * 10) / 10; return tmpD < 1 ? `${Math.max(1, Math.round(pDays * 24))}h` : `${tmpD}d`; }
	_catLabel(pKey) { return CATEGORY_LABELS[pKey] || pKey; }

	// ── Render ─────────────────────────────────────────────────────────────────────────────────────────────────

	_paint()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA || tmpCA.getElement(this._mount).length === 0) { return; }
		tmpCA.assignContent(this._mount, this._shellHTML());
		this._mountViewPickers();   // re-mount the current view's searchable customer picker(s) after the shell repaint
		this._mountRunbookArticlePicker();   // + the call-entry runbook article picker, when the sidebar is present
	}

	_repaintList()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement(LIST_MOUNT).length) { tmpCA.assignContent(LIST_MOUNT, this._listRowsHTML()); }
	}

	_paintFormActions()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#Support-Form-Actions').length) { tmpCA.assignContent('#Support-Form-Actions', this._formActionsHTML()); }
	}

	_paintApproval()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (tmpCA.getElement('#Support-Approval').length) { tmpCA.assignContent('#Support-Approval', this._approvalHTML()); }
	}

	// ── Settings editor: self-service tiers + priority policy, at Global (platform default) or per-customer ───────

	_settingsGearHTML()
	{
		if (!this.canManage()) { return ''; }
		return `<button class="sup-gear ${this.state.View === 'settings' ? 'sup-gear-on' : ''}" title="Support settings" onclick="_Pict.providers.Support.navigateView('settings'); return false;"><i class="fas fa-gear"></i></button>`;
	}

	_paintSettings() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#Support-Settings').length) { tmpCA.assignContent('#Support-Settings', this._settingsHTML()); this._mountViewPickers(); } }

	async _loadSettingsDraftAsync()
	{
		const tmpSuper = this._isSuperUser();
		if (!this._settings) { this._settings = { scope: tmpSuper ? 'Global' : 'Customer', scopeCustomer: this.idCustomer }; }
		const tmpS = this._settings;
		tmpS.loading = true; tmpS.error = ''; this._paint();
		if (tmpSuper && !this._customers) { try { await this._loadCustomersAsync(); } catch (pErr) { /* names optional */ } }
		try
		{
			const tmpPath = (tmpS.scope === 'Global') ? 'Configuration/For/SupportPortal/In/Global/0' : `Configuration/For/SupportPortal/In/Customer/${tmpS.scopeCustomer}`;
			const tmpBlob = (await this._getJSON(tmpPath)) || {};
			tmpS.blob =
			{
				Settings: (tmpBlob.Settings && typeof tmpBlob.Settings === 'object') ? JSON.parse(JSON.stringify(tmpBlob.Settings)) : { SelfService: false, AllowedCategories: [] },
				PriorityPolicy: (tmpBlob.PriorityPolicy && Array.isArray(tmpBlob.PriorityPolicy.Rules)) ? JSON.parse(JSON.stringify(tmpBlob.PriorityPolicy)) : JSON.parse(JSON.stringify(DEFAULT_PRIORITY_POLICY)),
			};
			if (!Array.isArray(tmpS.blob.Settings.AllowedCategories)) { tmpS.blob.Settings.AllowedCategories = []; }
			if (!tmpS.blob.PriorityPolicy.SLA) { tmpS.blob.PriorityPolicy.SLA = {}; }
			tmpS.loading = false;
		}
		catch (pError) { tmpS.loading = false; tmpS.error = (pError && pError.message) || String(pError); }
		// Same guard as the metrics load: only repaint the shell in list mode, so a settings load resolving after the user
		// has moved to a call form or the inline merge wizard can't clobber the mounted sub-view.
		if (this.state.Mode === 'list') { this._paint(); }
	}

	setSettingsScope(pScope) { if (!this._settings) { return; } this._settings.scope = (pScope === 'Global') ? 'Global' : 'Customer'; this._loadSettingsDraftAsync(); }
	setSettingsCustomer(pID) { if (!this._settings) { return; } this._settings.scopeCustomer = Number(pID) || this.idCustomer; this._loadSettingsDraftAsync(); }
	toggleSelfService(pOn) { if (!this._settings) { return; } this._settings.blob.Settings.SelfService = !!pOn; this._paintSettings(); }
	toggleAllowedCategory(pKey)
	{
		const tmpCats = this._settings.blob.Settings.AllowedCategories;
		const tmpAt = tmpCats.indexOf(pKey);
		if (tmpAt >= 0) { tmpCats.splice(tmpAt, 1); } else { tmpCats.push(pKey); }
		this._paintSettings();
	}
	setPriorityDefault(pValue) { this._settings.blob.PriorityPolicy.Default = pValue; }
	setSLA(pPriority, pValue) { this._settings.blob.PriorityPolicy.SLA[pPriority] = pValue; }
	addPriorityRule() { this._settings.blob.PriorityPolicy.Rules.push({ Keyword: '', Priority: 'High' }); this._paintSettings(); }
	removePriorityRule(pIndex) { this._settings.blob.PriorityPolicy.Rules.splice(pIndex, 1); this._paintSettings(); }
	setRuleType(pIndex, pType)
	{
		const tmpRule = this._settings.blob.PriorityPolicy.Rules[pIndex];
		delete tmpRule.Category; delete tmpRule.App; delete tmpRule.Keyword;
		tmpRule[pType] = '';
		this._paintSettings();
	}
	setRuleValue(pIndex, pValue)
	{
		const tmpRule = this._settings.blob.PriorityPolicy.Rules[pIndex];
		const tmpType = tmpRule.Category !== undefined ? 'Category' : (tmpRule.App !== undefined ? 'App' : 'Keyword');
		tmpRule[tmpType] = pValue;
	}
	setRulePriority(pIndex, pValue) { this._settings.blob.PriorityPolicy.Rules[pIndex].Priority = pValue; }

	async saveSettings()
	{
		const tmpS = this._settings;
		if (!tmpS || tmpS.saving) { return; }
		tmpS.saving = true; this._paintSettings();
		const tmpLevel = (tmpS.scope === 'Global') ? 'Global' : `Customer/${tmpS.scopeCustomer}`;
		try
		{
			const tmpR1 = await this._postJSON(`Configuration/Put/SupportPortal/Settings/${tmpLevel}`, tmpS.blob.Settings);
			if (tmpR1 && (tmpR1.Error || tmpR1.ErrorCode)) { throw new Error(String(tmpR1.Error || tmpR1.ErrorCode)); }
			const tmpR2 = await this._postJSON(`Configuration/Put/SupportPortal/PriorityPolicy/${tmpLevel}`, tmpS.blob.PriorityPolicy);
			if (tmpR2 && (tmpR2.Error || tmpR2.ErrorCode)) { throw new Error(String(tmpR2.Error || tmpR2.ErrorCode)); }
			tmpS.saving = false;
			// If this is the config the current session actually rides, refresh the live copies so guidance/suggestions update.
			const tmpAffectsMe = (tmpS.scope === 'Global') || (tmpS.scope === 'Customer' && Number(tmpS.scopeCustomer) === this.idCustomer);
			if (tmpAffectsMe) { this._portal = tmpS.blob.Settings; this._priorityPolicy = tmpS.blob.PriorityPolicy; }
			this._toast('Support settings saved.', 'success');
			this._paintSettings();
		}
		catch (pError) { tmpS.saving = false; this._toast(`Could not save settings: ${(pError && pError.message) ? pError.message : pError}`, 'error'); this._paintSettings(); }
	}

	_settingsHTML()
	{
		const tmpS = this._settings;
		if (!tmpS || tmpS.loading) { return `<div class="sup-note"><i class="fas fa-spinner fa-spin"></i> Loading settings…</div>`; }
		if (tmpS.error) { return `<div class="sup-note sup-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpS.error)}</div>`; }
		const tmpSuper = this._isSuperUser();
		const tmpSettings = tmpS.blob.Settings;
		const tmpPolicy = tmpS.blob.PriorityPolicy;

		// Scope bar (super-user): platform default vs a specific customer's override.
		let tmpScopeBar = '';
		if (tmpSuper)
		{
			tmpScopeBar = `<div class="sup-set-scope"><span class="sup-set-scopelabel">Editing</span>`
				+ `<button class="sup-scope-b ${tmpS.scope === 'Global' ? 'sup-scope-on' : ''}" onclick="_Pict.providers.Support.setSettingsScope('Global'); return false;"><i class="fas fa-earth-americas"></i> Platform default</button>`
				+ `<button class="sup-scope-b ${tmpS.scope === 'Customer' ? 'sup-scope-on' : ''}" onclick="_Pict.providers.Support.setSettingsScope('Customer'); return false;"><i class="fas fa-building"></i> One customer</button>`
				+ (tmpS.scope === 'Customer' ? `<span id="Support-Set-Cust-Pick" class="sup-set-pick"></span>` : '')
				+ `</div>`;
		}
		const tmpScopeNote = (tmpS.scope === 'Global')
			? `Platform default — inherited by every customer that hasn’t set its own override.`
			: `Override for <b>${this._esc(this._customerName(tmpS.scopeCustomer))}</b> — falls back to the platform default for anything left unset.`;

		// Self-service section.
		const tmpCatBoxes = Object.keys(CATEGORY_LABELS).filter((pK) => pK !== 'Uncategorized').map((pK) =>
		{
			const tmpOn = tmpSettings.AllowedCategories.indexOf(pK) >= 0;
			return `<label class="sup-set-chk ${tmpSettings.SelfService ? '' : 'sup-set-disabled'}"><input type="checkbox" ${tmpOn ? 'checked' : ''} ${tmpSettings.SelfService ? '' : 'disabled'} onchange="_Pict.providers.Support.toggleAllowedCategory('${pK}')"> ${this._esc(CATEGORY_LABELS[pK])}</label>`;
		}).join('');
		const tmpSelfService = `<div class="sup-set-card"><div class="sup-set-h"><i class="fas fa-user-gear"></i> Self-service</div>`
			+ `<label class="sup-set-toggle"><input type="checkbox" ${tmpSettings.SelfService ? 'checked' : ''} onchange="_Pict.providers.Support.toggleSelfService(this.checked)"> Let this tier’s users file their own calls</label>`
			+ `<div class="sup-set-sub">Categories they may choose${tmpSettings.SelfService ? '' : ' (enable self-service first)'}:</div>`
			+ `<div class="sup-set-cats">${tmpCatBoxes}</div></div>`;

		// Priority policy section.
		const tmpPrioOpts = (pSel) => Object.keys(PRIORITY_META).map((pP) => `<option value="${pP}" ${pSel === pP ? 'selected' : ''}>${PRIORITY_META[pP].label}</option>`).join('');
		const tmpSLARows = Object.keys(PRIORITY_META).map((pP) =>
			`<label class="sup-set-sla"><span class="sup-prio ${PRIORITY_META[pP].cls}">${PRIORITY_META[pP].label}</span>`
			+ `<input type="text" placeholder="e.g. 1 business day" value="${this._esc((tmpPolicy.SLA || {})[pP] || '')}" oninput="_Pict.providers.Support.setSLA('${pP}', this.value)"></label>`).join('');
		const tmpRuleRows = (tmpPolicy.Rules || []).map((pRule, pIndex) =>
		{
			const tmpType = pRule.Category !== undefined ? 'Category' : (pRule.App !== undefined ? 'App' : 'Keyword');
			const tmpTypeSel = [ 'Category', 'App', 'Keyword' ].map((pT) => `<option value="${pT}" ${tmpType === pT ? 'selected' : ''}>${pT}</option>`).join('');
			let tmpValueControl = '';
			if (tmpType === 'Category')
			{
				const tmpOpts = Object.keys(CATEGORY_LABELS).filter((pK) => pK !== 'Uncategorized').map((pK) => `<option value="${pK}" ${pRule.Category === pK ? 'selected' : ''}>${this._esc(CATEGORY_LABELS[pK])}</option>`).join('');
				tmpValueControl = `<select onchange="_Pict.providers.Support.setRuleValue(${pIndex}, this.value)"><option value="">—</option>${tmpOpts}</select>`;
			}
			else if (tmpType === 'App')
			{
				const tmpOpts = Object.keys(APP_LABELS).map((pK) => `<option value="${pK}" ${pRule.App === pK ? 'selected' : ''}>${this._esc(APP_LABELS[pK])}</option>`).join('');
				tmpValueControl = `<select onchange="_Pict.providers.Support.setRuleValue(${pIndex}, this.value)"><option value="">—</option>${tmpOpts}</select>`;
			}
			else
			{
				tmpValueControl = `<input type="text" placeholder="regex, e.g. outage|down" value="${this._esc(pRule.Keyword || '')}" oninput="_Pict.providers.Support.setRuleValue(${pIndex}, this.value)">`;
			}
			return `<div class="sup-set-rule"><select class="sup-rule-type" onchange="_Pict.providers.Support.setRuleType(${pIndex}, this.value)">${tmpTypeSel}</select>`
				+ `<span class="sup-rule-val">${tmpValueControl}</span>`
				+ `<span class="sup-rule-arrow">→</span>`
				+ `<select class="sup-rule-prio" onchange="_Pict.providers.Support.setRulePriority(${pIndex}, this.value)">${tmpPrioOpts(pRule.Priority)}</select>`
				+ `<button class="sup-rule-x" title="Remove rule" onclick="_Pict.providers.Support.removePriorityRule(${pIndex}); return false;"><i class="fas fa-xmark"></i></button></div>`;
		}).join('');
		const tmpPriority = `<div class="sup-set-card"><div class="sup-set-h"><i class="fas fa-gauge-high"></i> Priority policy</div>`
			+ `<label class="sup-set-inline">Default priority <select onchange="_Pict.providers.Support.setPriorityDefault(this.value)">${tmpPrioOpts(tmpPolicy.Default)}</select></label>`
			+ `<div class="sup-set-sub">First-response targets</div><div class="sup-set-slas">${tmpSLARows}</div>`
			+ `<div class="sup-set-sub">Suggestion rules <span class="sup-set-hint">— highest-priority match wins; applied when a call is filed without a priority</span></div>`
			+ `<div class="sup-set-rules">${tmpRuleRows || '<div class="sup-set-empty">No rules — calls default to the priority above.</div>'}</div>`
			+ `<button class="sup-btn sup-set-addrule" onclick="_Pict.providers.Support.addPriorityRule(); return false;"><i class="fas fa-plus"></i> Add rule</button></div>`;

		return tmpScopeBar
			+ `<div class="sup-set-note"><i class="fas fa-circle-info"></i> ${tmpScopeNote}</div>`
			+ `<div class="sup-set-grid">${tmpSelfService}${tmpPriority}</div>`
			+ `<div class="sup-set-actions"><button class="sup-btn sup-btn-primary" ${tmpS.saving ? 'disabled' : ''} onclick="_Pict.providers.Support.saveSettings(); return false;">${tmpS.saving ? '<i class="fas fa-spinner fa-spin"></i> Saving…' : '<i class="fas fa-floppy-disk"></i> Save settings'}</button></div>`;
	}

	// ── Support documentation: a staff runbook — platform-wide (Global) + this customer's own, NOT in public Academy ──

	_docsGearHTML()
	{
		// Managers, platform (super-user) editors, and Document-edit holders can open the runbook manager.
		if (!this._canAccessDocs()) { return ''; }
		return `<button class="sup-gear ${this.state.View === 'docs' ? 'sup-gear-on' : ''}" title="Support documentation" onclick="_Pict.providers.Support.navigateView('docs'); return false;"><i class="fas fa-book"></i></button>`;
	}

	_paintDocs()
	{
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpCA.getElement('#Support-Docs').length) { return; }
		tmpCA.assignContent('#Support-Docs', this._docsHTML());
		this._mountViewPickers();   // mount the super-user customer scope picker (#Support-Docs-Cust-Pick)
		// If we just painted the editor, mount the first-class markdown editor into it, seeded with the article body.
		const tmpSel = this.state.DocsSel;
		if (this.state.DocsEditing && tmpSel && tmpCA.getElement('#Support-Doc-Editor-Mount').length)
		{
			const tmpArt = this._docArticle(tmpSel.scope, tmpSel.hash);
			this._mountDocEditor(tmpArt ? (tmpArt.Body || '') : '');
		}
	}

	/** Mount (or re-render) the shared markdown editor into the docs editor, seeded with the article body. */
	_mountDocEditor(pMarkdown)
	{
		if (!this.pict.AppData.SupportDocEditor) { this.pict.AppData.SupportDocEditor = {}; }
		this.pict.AppData.SupportDocEditor.Segments = [ { Content: (pMarkdown == null) ? '' : String(pMarkdown) } ];
		if (!this.pict.views['Support-Doc-Editor'])
		{
			this.pict.addView('Support-Doc-Editor',
				{
					ViewIdentifier: 'Support-Doc-Editor',
					TargetElementAddress: '#Support-Doc-Editor-Mount',
					ContentDataAddress: 'AppData.SupportDocEditor.Segments',
					AutoRender: false,
					EnableRichPreview: true,
					ReadOnly: false,
				}, libMarkdownEditor);
		}
		try { this.pict.views['Support-Doc-Editor'].render(); }
		catch (pError) { this._toast('The markdown editor could not load.', 'error'); }
	}

	/** Marshal the edited markdown back out of the editor into the selected article's Body. */
	_captureDocEditor()
	{
		const tmpView = this.pict.views['Support-Doc-Editor'];
		if (!tmpView) { return; }
		if (typeof tmpView.marshalFromView === 'function') { try { tmpView.marshalFromView(); } catch (pError) { /* editor already gone */ } }
		const tmpSegments = (this.pict.AppData.SupportDocEditor && this.pict.AppData.SupportDocEditor.Segments) || [];
		const tmpBody = tmpSegments.map((pSeg) => (pSeg && pSeg.Content) || '').join('\n\n');
		const tmpSel = this.state.DocsSel;
		const tmpArt = tmpSel ? this._docArticle(tmpSel.scope, tmpSel.hash) : null;
		if (tmpArt) { tmpArt.Body = tmpBody; }
	}

	async _loadDocsAsync()
	{
		this._docs = { loading: true, error: '', global: [], customer: [] };
		this._afterDocsRepaint();
		const tmpSort = (pArr) => (Array.isArray(pArr) ? pArr : []).slice().sort((pA, pB) => (Number(pA.Order) || 0) - (Number(pB.Order) || 0));
		try
		{
			// One endpoint read yields the global (platform) runbooks + this customer's own, newest version each.
			// The docs VIEW may be retargeted by a super-user to manage another customer's runbooks; the sidebar
			// always resets this back to the session customer (see _ensureRunbooksAsync). The global set is returned
			// regardless (the server scopes to IDCustomer IN (0, this customer)), so only the customer set changes.
			const tmpDocsCust = this._docsCustomerID || this.idCustomer;
			// Runbooks are per-row ManifestSchema records (Type='SupportRunbook'); the endpoint returns the newest
			// version of each, split into Global (IDCustomer 0) + this customer's own, already sorted by Order.
			const tmpBlob = (await this._getJSON(`SupportRunbook/For/Customer/${tmpDocsCust}`)) || {};
			this._docs = {
				loading: false, error: '', customerID: tmpDocsCust,
				// Platform (global) runbooks are HeadLight-internal support docs - only show them for an actual support role
				// (agent/manager/super-user), NOT for a customer's Document-editor (who gets only their own customer scope).
				global: this._hasSupportRole() ? tmpSort(tmpBlob.Global) : [],
				customer: tmpSort(tmpBlob.Customer),
			};
			// Default selection: first available article.
			if (!this.state.DocsSel)
			{
				if (this._docs.global.length) { this.state.DocsSel = { scope: 'global', hash: this._docs.global[0].Hash }; }
				else if (this._docs.customer.length) { this.state.DocsSel = { scope: 'customer', hash: this._docs.customer[0].Hash }; }
			}
		}
		catch (pError) { this._docs = { loading: false, error: (pError && pError.message) || String(pError), global: [], customer: [] }; }
		this._afterDocsRepaint();
	}

	/** After runbook data changes: repaint only the call-entry aside while a call is open, else the full docs shell. */
	// A docs/runbooks load can resolve while the inline merge wizard owns #Support-Host (e.g. open a call → _ensureRunbooksAsync
	// fires → click "Merge into another ticket…" before the GET returns). A full _paint() here would rebuild an EMPTY
	// #SupportMerge-Wizard and wipe the accordion, so skip it in merge mode — the merge view hosts no runbook surface, and
	// this._docs stays loaded for when the user returns to the list (exitMerge → loadAsync → _paint).
	_afterDocsRepaint() { if (this.state.Mode === 'merge') { return; } if (this.state.Mode === 'form') { this._paintRunbook(); } else { this._paint(); } }

	// ── Runbook companion: a read-only browse+view of the same runbooks (this._docs) beside the call-entry form ──

	/** Lazily load runbook articles for the sidebar; reuses this._docs if a manager already opened the Docs view. */
	_ensureRunbooksAsync()
	{
		// The sidebar always shows the SESSION customer's docs. If the Docs view retargeted _docs to another
		// customer (super-user managing that customer's runbooks), reload for the session customer first.
		if (this._docs && Number(this._docs.customerID || this.idCustomer) === Number(this.idCustomer)) { this._paintRunbook(); return; }
		this._docsCustomerID = this.idCustomer;
		this._loadDocsAsync();
	}

	/** Super-user: point the Docs view at another customer's runbooks (DocsCustomer at that customer's scope). */
	setDocsCustomer(pID)
	{
		const tmpID = Number(pID) || this.idCustomer;
		if (tmpID === Number(this._docsCustomerID || this.idCustomer)) { return; }
		this._docsCustomerID = tmpID;
		this.state.DocsSel = null; this.state.DocsEditing = false;   // article selection is per-customer
		this._loadDocsAsync();
	}

	/** Load the ACTIVE CALL's customer playbook (DocsCustomer at that customer's scope) so the caller-specific runbook
	 *  shows beside the call even though the console itself runs as the central HeadLight queue (customer 1). */
	async _loadCallerRunbooksAsync(pIDCustomer)
	{
		const tmpID = Number(pIDCustomer) || 0;
		if (!tmpID || tmpID === Number(this.idCustomer)) { this._callerDocs = null; this._paintRunbook(); return; }
		if (this._callerDocs && this._callerDocs.idCustomer === tmpID && !this._callerDocs.loading) { return; }   // already loaded for this caller
		this._callerDocs = { idCustomer: tmpID, name: this._customerName(tmpID), loading: true, articles: [] };
		try
		{
			const tmpBlob = (await this._getJSON(`SupportRunbook/For/Customer/${tmpID}`)) || {};
			const tmpArts = tmpBlob.Customer || [];
			this._callerDocs = { idCustomer: tmpID, name: this._customerName(tmpID), loading: false, articles: (Array.isArray(tmpArts) ? tmpArts : []).slice().sort((pA, pB) => (Number(pA.Order) || 0) - (Number(pB.Order) || 0)) };
		}
		catch (pErr) { this._callerDocs = { idCustomer: tmpID, name: this._customerName(tmpID), loading: false, articles: [] }; }
		this._paintRunbook();
	}

	/** Repaint ONLY the runbook aside — never the shell (a full _paint would tear down the mounted #Support-FormHost). */
	_paintRunbook()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpEl = tmpCA.getElement('#Support-Runbook');
		if (!tmpEl || !tmpEl.length) { return; }
		tmpEl[0].classList.toggle('sup-runbook-collapsed', this.state.RunbookOpen === false);
		tmpEl[0].innerHTML = this._runbookHTML();
		this._mountRunbookArticlePicker();   // the article selector is a searchable picker, mounted after this repaint
	}

	toggleRunbook() { this.state.RunbookOpen = !(this.state.RunbookOpen !== false); this._persistFilters(); this._paintRunbook(); }
	selectRunbook(pScope, pHash) { this.state.RunbookSel = { scope: pScope, hash: pHash }; this._paintRunbook(); }

	_runbookHTML()
	{
		if (this.state.RunbookOpen === false)
		{
			return `<button class="sup-rb-tab" title="Show runbooks" onclick="_Pict.providers.Support.toggleRunbook(); return false;"><i class="fas fa-book"></i></button>`;
		}
		const tmpHead = `<div class="sup-rb-head"><span class="sup-rb-h"><i class="fas fa-book"></i> Runbooks</span>`
			+ `<button class="sup-rb-x" title="Hide" onclick="_Pict.providers.Support.toggleRunbook(); return false;"><i class="fas fa-angles-right"></i></button></div>`;
		const tmpD = this._docs;
		if (!tmpD || tmpD.loading) { return tmpHead + `<div class="sup-rb-msg"><i class="fas fa-spinner fa-spin"></i> Loading runbooks…</div>`; }
		if (tmpD.error) { return tmpHead + `<div class="sup-rb-msg sup-note-error">${this._esc(tmpD.error)}</div>`; }
		// The active caller's own customer playbook comes FIRST (most relevant to the call in hand), then platform-wide
		// runbooks, then the console customer's own.
		const tmpArts = this._runbookArticles();
		if (!tmpArts.length) { return tmpHead + `<div class="sup-rb-msg">No runbooks published yet — add them under the <i class="fas fa-book"></i> Docs view.</div>`; }
		const tmpSel = this.state.RunbookSel || { scope: tmpArts[0].scope, hash: tmpArts[0].Hash };
		// The article LIST is a searchable pict-section-picker (mounted after paint into #Support-Runbook-Pick), not a
		// long vertical nav — so a big runbook list no longer pushes the body down; you pick from the dropdown and read below.
		const tmpIcon = (pS) => (pS === 'global') ? 'fa-earth-americas' : (pS === 'caller' ? 'fa-building-user' : 'fa-building');
		const tmpWord = (pS) => (pS === 'global') ? 'Platform' : (pS === 'caller' ? 'Caller playbook' : 'Customer');
		const tmpArt = this._docArticle(tmpSel.scope, tmpSel.hash) || {};
		const tmpBody = `<div class="sup-rb-arth"><i class="fas ${tmpIcon(tmpSel.scope)} sup-rb-scope"></i> ${this._esc(tmpArt.Title || 'Untitled')} <span class="sup-rb-scopeword">${tmpWord(tmpSel.scope)}</span></div>`
			+ `<div class="sup-doc-content sup-rb-content">${this._md(tmpArt.Body)}</div>`;
		return tmpHead + `<div class="sup-rb-pick"><span id="Support-Runbook-Pick"></span></div><div class="sup-rb-body">${tmpBody}</div>`;
	}

	/** The runbook articles the sidebar offers, in priority order: the active caller's own playbook, then platform-wide,
	 *  then the console customer's own. Shared by _runbookHTML and the article picker. */
	_runbookArticles()
	{
		const tmpD = this._docs || {};
		const tmpCaller = this._callerDocs;
		return []
			.concat((tmpCaller && tmpCaller.articles || []).map((pA) => ({ scope: 'caller', Hash: pA.Hash, Title: pA.Title })))
			.concat((tmpD.global || []).map((pA) => ({ scope: 'global', Hash: pA.Hash, Title: pA.Title })))
			.concat((tmpD.customer || []).map((pA) => ({ scope: 'customer', Hash: pA.Hash, Title: pA.Title })));
	}

	/** Mount the searchable runbook-article picker into #Support-Runbook-Pick (a no-op if the span isn't present). */
	_mountRunbookArticlePicker()
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		if (tmpCA.getElement('#Support-Runbook-Pick').length === 0) { return; }
		const tmpArts = this._runbookArticles();
		if (!tmpArts.length) { return; }
		const tmpKey = (pA) => `${pA.scope}::${pA.Hash}`;
		const tmpWord = (pS) => (pS === 'global') ? 'Platform' : (pS === 'caller' ? 'Caller' : 'Customer');
		const tmpLabel = (pA) => `${tmpWord(pA.scope)} · ${pA.Title || 'Untitled'}`;
		if (!this.pict.AppData.SupportPickers) { this.pict.AppData.SupportPickers = {}; }
		const tmpInstance = tmpPicker.createPicker('Support-RunbookArticle',
			{
				DestinationAddress: '#Support-Runbook-Pick',
				ValueAddress: 'AppData.SupportPickers.RunbookArticle',
				Searchable: true, AllowClear: false, Placeholder: 'Find a runbook…',
				DataProvider: (pTerm) =>
				{
					const tmpT = String(pTerm == null ? '' : pTerm).trim().toLowerCase();
					const tmpRows = tmpArts.map((pA) => ({ Value: tmpKey(pA), Text: tmpLabel(pA) })).filter((pR) => !tmpT || pR.Text.toLowerCase().indexOf(tmpT) >= 0);
					return Promise.resolve({ results: tmpRows, hasMore: false });
				},
				ResolveValue: (pVal) => { const tmpA = tmpArts.find((pA) => tmpKey(pA) === pVal); return Promise.resolve(tmpA ? { Value: pVal, Text: tmpLabel(tmpA) } : null); },
				OnChange: (pValue) => { const tmpA = tmpArts.find((pA) => tmpKey(pA) === pValue); if (tmpA) { this.selectRunbook(tmpA.scope, tmpA.Hash); } },
			});
		if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
		const tmpSel = this.state.RunbookSel || { scope: tmpArts[0].scope, hash: tmpArts[0].Hash };
		if (tmpInstance && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(`${tmpSel.scope}::${tmpSel.hash}`); }
	}

	_docArticle(pScope, pHash)
	{
		if (pScope === 'caller') { return ((this._callerDocs && this._callerDocs.articles) || []).find((pA) => pA.Hash === pHash) || null; }
		return (this._docs && this._docs[pScope] || []).find((pA) => pA.Hash === pHash) || null;
	}
	selectDoc(pScope, pHash) { if (this.state.DocsEditing) { this._captureDocEditor(); } this.state.DocsSel = { scope: pScope, hash: pHash }; this.state.DocsEditing = false; this._paintDocs(); }
	toggleDocsEdit() { if (this.state.DocsEditing) { this._captureDocEditor(); } this.state.DocsEditing = !this.state.DocsEditing; this._paintDocs(); }

	docDragStart(pScope, pHash) { this._docDrag = { scope: pScope, hash: pHash }; }
	/** Drop onto a runbook nav item: a dragged .md file uploads into this scope; a dragged item reorders in place. */
	async docDrop(pEvent, pScope, pTargetHash)
	{
		const tmpFiles = pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files;
		if (tmpFiles && tmpFiles.length) { this._docDrag = null; return this.uploadDocs(pScope, tmpFiles); }   // a file dropped on an item still uploads
		const tmpDrag = this._docDrag; this._docDrag = null;
		if (!tmpDrag || tmpDrag.scope !== pScope || tmpDrag.hash === pTargetHash) { return; }
		if (!this.canEditRunbooks(pScope) || this.state.Busy) { return; }
		const tmpArr = (this._docs && this._docs[pScope]) || [];
		const tmpFrom = tmpArr.findIndex((pA) => pA.Hash === tmpDrag.hash);
		const tmpTo = tmpArr.findIndex((pA) => pA.Hash === pTargetHash);
		if (tmpFrom < 0 || tmpTo < 0) { return; }
		const tmpMoved = tmpArr.splice(tmpFrom, 1)[0];
		tmpArr.splice(tmpTo, 0, tmpMoved);
		tmpArr.forEach((pA, pIdx) => { pA.Order = pIdx; });   // renumber locally to mirror the server reorder
		this.state.Busy = true; this._paintDocs();
		try
		{
			const tmpRes = await this._putJSON('SupportRunbook/Reorder', { IDCustomer: this._scopeIDCustomer(pScope), Order: tmpArr.map((pA) => pA.Hash) });
			if (tmpRes && (tmpRes.Error || tmpRes.ErrorCode)) { throw new Error(String(tmpRes.Error || tmpRes.ErrorCode)); }
			this.state.Busy = false; this._paintDocs();
		}
		catch (pError) { this.state.Busy = false; this._toast(`Reorder failed: ${(pError && pError.message) ? pError.message : pError}`, 'error'); await this._loadDocsAsync(); }
	}

	addDoc(pScope)
	{
		if (!this._docs) { return; }
		const tmpHash = 'doc-' + Date.now().toString(36);
		const tmpMax = (this._docs[pScope] || []).reduce((pN, pA) => Math.max(pN, Number(pA.Order) || 0), 0);
		this._docs[pScope].push({ Hash: tmpHash, Title: 'Untitled article', Body: '', Order: tmpMax + 1 });
		this.state.DocsSel = { scope: pScope, hash: tmpHash };
		this.state.DocsEditing = true;
		this._paintDocs();
	}
	setDocField(pField, pValue)
	{
		const tmpSel = this.state.DocsSel; if (!tmpSel) { return; }
		const tmpArt = this._docArticle(tmpSel.scope, tmpSel.hash); if (!tmpArt) { return; }
		tmpArt[pField] = pValue;
	}

	/** The IDCustomer a runbook scope writes to: global -> 0, customer -> the viewed (or session) customer. */
	_scopeIDCustomer(pScope)
	{
		return (pScope === 'global') ? 0 : (Number(this._docsCustomerID || this.idCustomer) || 0);
	}

	/** Persist ONE runbook as a new version row via the scoped SupportRunbook endpoint (server enforces the edit gate). */
	async _persistRunbookAsync(pScope, pArticle)
	{
		const tmpRes = await this._putJSON('SupportRunbook', {
			IDCustomer: this._scopeIDCustomer(pScope),
			Hash: pArticle.Hash,
			Title: pArticle.Title || '',
			Body: pArticle.Body || '',
			Order: Number(pArticle.Order) || 0,
		});
		if (tmpRes && (tmpRes.Error || tmpRes.ErrorCode)) { throw new Error(String(tmpRes.Error || tmpRes.ErrorCode)); }
	}
	async saveDoc()
	{
		const tmpSel = this.state.DocsSel; if (!tmpSel || this.state.Busy) { return; }
		this._captureDocEditor();   // marshal the markdown editor's content into the article before persisting
		const tmpArt = this._docArticle(tmpSel.scope, tmpSel.hash); if (!tmpArt) { return; }
		this.state.Busy = true; this._paintDocs();
		try { await this._persistRunbookAsync(tmpSel.scope, tmpArt); this.state.Busy = false; this.state.DocsEditing = false; this._toast('Documentation saved.', 'success'); this._paintDocs(); }
		catch (pError) { this.state.Busy = false; this._toast(`Could not save: ${(pError && pError.message) ? pError.message : pError}`, 'error'); this._paintDocs(); }
	}
	async deleteDoc()
	{
		const tmpSel = this.state.DocsSel; if (!tmpSel || this.state.Busy) { return; }
		const tmpArt = this._docArticle(tmpSel.scope, tmpSel.hash);
		if (!tmpArt || (typeof window !== 'undefined' && !window.confirm(`Delete “${tmpArt.Title || 'this article'}”?`))) { return; }
		const tmpScope = tmpSel.scope, tmpHash = tmpSel.hash;
		this._docs[tmpScope] = this._docs[tmpScope].filter((pA) => pA.Hash !== tmpHash);
		this.state.DocsSel = null; this.state.DocsEditing = false;
		this.state.Busy = true; this._paintDocs();
		try { const tmpRes = await this._putJSON('SupportRunbook/Delete', { IDCustomer: this._scopeIDCustomer(tmpScope), Hash: tmpHash }); if (tmpRes && (tmpRes.Error || tmpRes.ErrorCode)) { throw new Error(String(tmpRes.Error || tmpRes.ErrorCode)); } this.state.Busy = false; this._toast('Article deleted.', 'info'); this._paintDocs(); }
		catch (pError) { this.state.Busy = false; this._toast(`Could not delete: ${(pError && pError.message) ? pError.message : pError}`, 'error'); await this._loadDocsAsync(); }
	}

	/** Minimal safe markdown → HTML (escape first) for support-doc bodies: headings, bold/italic/code, lists, links. */
	_md(pText)
	{
		// Render authored article markdown with the shared marked-based renderer (_renderMd → libUserMarkdown):
		// blockquotes, numbered + nested lists, tables and code fences all render, HTML-escaped + safe-URL, identically
		// to the composer/timeline and the editor's rich preview. The old hand-rolled parser only handled #/-/*/`/links,
		// so the blockquote-heavy runbooks (the acknowledgement email templates are `>` callouts) rendered every quoted
		// line as a literal "> " paragraph — the "markdown isn't rendering properly" the runbook sidebar showed.
		const tmpSource = String(pText == null ? '' : pText);
		if (!tmpSource.trim()) { return '<p class="sup-doc-empty">This article is empty.</p>'; }
		return this._renderMd(tmpSource);
	}

	_docNavHTML(pScope, pLabel, pCanEdit)
	{
		const tmpArts = (this._docs && this._docs[pScope]) || [];
		const tmpSel = this.state.DocsSel || {};
		const tmpItems = tmpArts.map((pA) =>
		{
			// Editors can drag to reorder these items; a .md file dropped onto an item still uploads into this scope
			// (docDrop inspects dataTransfer to tell a file-drop from an item-reorder).
			const tmpDrag = pCanEdit
				? ` draggable="true" ondragstart="_Pict.providers.Support.docDragStart('${pScope}','${this._esc(pA.Hash)}');" ondragover="event.preventDefault();" ondrop="event.preventDefault(); event.stopPropagation(); _Pict.providers.Support.docDrop(event,'${pScope}','${this._esc(pA.Hash)}'); return false;"`
				: '';
			return `<button class="sup-doc-nav-i ${tmpSel.scope === pScope && tmpSel.hash === pA.Hash ? 'sup-doc-nav-on' : ''}"${tmpDrag} onclick="_Pict.providers.Support.selectDoc('${pScope}','${this._esc(pA.Hash)}'); return false;">${this._esc(pA.Title || 'Untitled')}</button>`;
		}).join('')
			|| `<div class="sup-doc-nav-empty">None yet</div>`;
		// Editors (customer = manager, platform = super-user) get Add + Upload, plus the whole group is a drag-drop target
		// for bulk .md upload into THIS scope. The onchange clears value so re-picking the same file fires again.
		let tmpTools = '';
		let tmpDropAttrs = '';
		let tmpHint = '';
		if (pCanEdit)
		{
			const tmpInputId = `Support-Doc-Upload-${pScope}`;
			tmpTools = `<button class="sup-doc-add" onclick="_Pict.providers.Support.addDoc('${pScope}'); return false;"><i class="fas fa-plus"></i> Add</button>`
				+ `<button class="sup-doc-add" title="Upload markdown file(s)" ${this.state.Busy ? 'disabled' : ''} onclick="document.getElementById('${tmpInputId}').click(); return false;"><i class="fas fa-upload"></i> Upload</button>`
				+ `<input type="file" id="${tmpInputId}" accept=".md,.markdown,.txt,text/markdown" multiple style="display:none" onchange="_Pict.providers.Support.uploadDocs('${pScope}', this.files); this.value='';">`;
			tmpDropAttrs = ` ondragover="event.preventDefault(); this.classList.add('sup-doc-drag');" ondragleave="this.classList.remove('sup-doc-drag');" ondrop="event.preventDefault(); this.classList.remove('sup-doc-drag'); _Pict.providers.Support.uploadDocs('${pScope}', event.dataTransfer.files); return false;"`;
			tmpHint = `<div class="sup-doc-drophint"><i class="fas fa-cloud-arrow-up"></i> Drop .md files to upload</div>`;
		}
		return `<div class="sup-doc-navgroup"${tmpDropAttrs}><div class="sup-doc-navh">${this._esc(pLabel)}<span class="sup-doc-navtools">${tmpTools}</span></div>${tmpItems}${tmpHint}</div>`;
	}

	/** Read a File as text (Promise wrapper over FileReader). */
	_readFileText(pFile)
	{
		return new Promise((resolve, reject) =>
		{
			try { const tmpReader = new FileReader(); tmpReader.onload = () => resolve(String(tmpReader.result || '')); tmpReader.onerror = () => reject(tmpReader.error || new Error('read failed')); tmpReader.readAsText(pFile); }
			catch (pError) { reject(pError); }
		});
	}

	/** An article title from an uploaded file: its first markdown `# heading`, else the filename without extension. */
	_titleFromFile(pName, pText)
	{
		const tmpHeading = /^\s*#\s+(.+?)\s*$/m.exec(String(pText || ''));
		if (tmpHeading && tmpHeading[1].trim()) { return tmpHeading[1].trim().slice(0, 120); }
		return String(pName || 'Untitled').replace(/\.(md|markdown|txt)$/i, '').replace(/[-_]+/g, ' ').trim() || 'Untitled';
	}

	/** Bulk-upload markdown file(s) into a scope's runbooks: one article per file, then persist the scope once. */
	async uploadDocs(pScope, pFileList)
	{
		if (!this.canEditRunbooks(pScope)) { this._toast(`You don’t have permission to upload ${pScope === 'global' ? 'platform' : 'customer'} runbooks.`, 'error'); return; }
		if (!this._docs || !Array.isArray(this._docs[pScope])) { return; }
		const tmpFiles = Array.from(pFileList || []).filter((pF) => pF && /\.(md|markdown|txt)$/i.test(pF.name));
		if (!tmpFiles.length) { this._toast('Drop or choose markdown (.md) file(s).', 'info'); return; }
		if (this.state.Busy) { return; }
		this.state.Busy = true; this._paintDocs();
		try
		{
			const tmpBaseOrder = (this._docs[pScope] || []).reduce((pN, pA) => Math.max(pN, Number(pA.Order) || 0), 0);
			const tmpStamp = Date.now().toString(36);
			// Read ALL files first, then persist one runbook row per file. Each file is an independent row now, so a
			// mid-batch failure leaves the already-saved rows intact - report how many landed and resync from the server.
			const tmpBatch = [];
			for (let tmpI = 0; tmpI < tmpFiles.length; tmpI++)
			{
				const tmpText = await this._readFileText(tmpFiles[tmpI]);
				tmpBatch.push({ Hash: `doc-${tmpStamp}-${tmpI}`, Title: this._titleFromFile(tmpFiles[tmpI].name, tmpText), Body: tmpText, Order: tmpBaseOrder + 1 + tmpI });
			}
			let tmpSaved = 0;
			for (const tmpArticle of tmpBatch)
			{
				await this._persistRunbookAsync(pScope, tmpArticle);
				this._docs[pScope].push(tmpArticle);   // only reflect locally AFTER the row is persisted
				tmpSaved++;
			}
			this.state.Busy = false;
			if (tmpSaved) { this.state.DocsSel = { scope: pScope, hash: tmpBatch[tmpSaved - 1].Hash }; this.state.DocsEditing = false; }   // land on the last uploaded article
			this._toast(`Uploaded ${tmpSaved} runbook${tmpSaved === 1 ? '' : 's'} to ${pScope === 'global' ? 'Platform' : 'this customer'}.`, 'success');
			this._paintDocs();
		}
		catch (pError) { this.state.Busy = false; this._toast(`Upload failed after saving some files: ${(pError && pError.message) ? pError.message : pError}`, 'error'); await this._loadDocsAsync(); }
	}

	/** Download the selected runbook article as a .md file. */
	downloadCurrentDoc()
	{
		const tmpSel = this.state.DocsSel; if (!tmpSel) { return; }
		if (tmpSel.scope === 'global' && !this._hasSupportRole()) { return; }   // platform runbooks are support-staff-only
		const tmpArt = this._docArticle(tmpSel.scope, tmpSel.hash); if (!tmpArt) { return; }
		const tmpName = (String(tmpArt.Title || 'runbook').replace(/[^A-Za-z0-9 _-]+/g, '').trim().replace(/\s+/g, '-') || 'runbook').slice(0, 80);
		this._triggerBrowserDownload(new Blob([ String(tmpArt.Body || '') ], { type: 'text/markdown;charset=utf-8' }), `${tmpName}.md`);
	}

	_docsHTML()
	{
		const tmpD = this._docs;
		if (!tmpD || tmpD.loading) { return `<div class="sup-note"><i class="fas fa-spinner fa-spin"></i> Loading documentation…</div>`; }
		if (tmpD.error) { return `<div class="sup-note sup-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpD.error)}</div>`; }
		const tmpSuper = this._isSuperUser();
		const tmpDocsCust = this._docsCustomerID || this.idCustomer;
		// Super-users manage ANY customer's runbooks (pick via the searchable picker); non-super-users see only their own.
		const tmpCustNavLabel = tmpSuper ? (this._customerName(tmpDocsCust) || `Customer ${tmpDocsCust}`) : 'This customer';
		// The Platform (global) runbook section is visible only to support staff/super-users — not a customer Document-editor.
		const tmpNav = (this._hasSupportRole() ? this._docNavHTML('global', 'Platform', this.canEditRunbooks('global')) : '') + this._docNavHTML('customer', tmpCustNavLabel, this.canEditRunbooks('customer'));

		const tmpSel = this.state.DocsSel;
		const tmpArt = tmpSel ? this._docArticle(tmpSel.scope, tmpSel.hash) : null;
		let tmpBody;
		if (!tmpArt)
		{
			tmpBody = `<div class="sup-doc-placeholder"><i class="fas fa-book-open"></i><div>Pick an article, or add one.</div>`
				+ `<p class="sup-doc-note">Platform articles are the shared support runbook (every customer). “This customer” articles are private to this organization. Neither appears in the public Academy.</p></div>`;
		}
		else
		{
			// Customer docs: a manager OR a Document-edit (Document-Update) holder; platform docs: super-user only.
			const tmpCanEdit = this.canEditRunbooks(tmpSel.scope);
			if (this.state.DocsEditing && tmpCanEdit)
			{
				// The article body uses the app's first-class markdown editor (mounted into #Support-Doc-Editor-Mount
				// after this paint); the value is marshaled back on Preview/Save, not via an input binding.
				tmpBody = `<div class="sup-doc-editor">`
					+ `<input class="sup-doc-title-in" type="text" placeholder="Article title" value="${this._esc(tmpArt.Title || '')}" oninput="_Pict.providers.Support.setDocField('Title', this.value)">`
					+ `<div id="Support-Doc-Editor-Mount" class="sup-doc-mde"></div>`
					+ `<div class="sup-doc-ed-actions"><button class="sup-doc-del" ${this.state.Busy ? 'disabled' : ''} onclick="_Pict.providers.Support.deleteDoc(); return false;"><i class="fas fa-trash"></i> Delete</button>`
					+ `<span class="sup-doc-ed-right"><button class="sup-btn" onclick="_Pict.providers.Support.toggleDocsEdit(); return false;">Preview</button>`
					+ `<button class="sup-btn sup-btn-primary" ${this.state.Busy ? 'disabled' : ''} onclick="_Pict.providers.Support.saveDoc(); return false;">${this.state.Busy ? '<i class="fas fa-spinner fa-spin"></i>' : '<i class="fas fa-floppy-disk"></i> Save'}</button></span></div></div>`;
			}
			else
			{
				const tmpEditBtn = tmpCanEdit ? `<button class="sup-doc-editbtn" onclick="_Pict.providers.Support.toggleDocsEdit(); return false;"><i class="fas fa-pen"></i> Edit</button>` : '';
				const tmpDownloadBtn = `<button class="sup-doc-editbtn" title="Download this runbook as markdown" onclick="_Pict.providers.Support.downloadCurrentDoc(); return false;"><i class="fas fa-download"></i> .md</button>`;
				const tmpScopeTag = tmpSel.scope === 'global' ? `<span class="sup-doc-scope sup-doc-scope-g"><i class="fas fa-earth-americas"></i> Platform</span>` : `<span class="sup-doc-scope sup-doc-scope-c"><i class="fas fa-building"></i> This customer</span>`;
				tmpBody = `<div class="sup-doc-article"><div class="sup-doc-arth"><h2 class="sup-doc-title">${this._esc(tmpArt.Title || 'Untitled')}</h2>${tmpScopeTag}${tmpDownloadBtn}${tmpEditBtn}</div>`
					+ `<div class="sup-doc-content">${this._md(tmpArt.Body)}</div></div>`;
			}
		}
		// Super-user scope bar: choose which customer's runbooks to manage (searchable picker mounted after paint).
		const tmpScopeBar = tmpSuper
			? `<div class="sup-doc-scopebar"><span class="sup-doc-scopelabel"><i class="fas fa-building"></i> Customer runbooks for</span><span id="Support-Docs-Cust-Pick" class="sup-doc-cust-pick"></span></div>`
			: '';
		return `${tmpScopeBar}<div class="sup-docs"><aside class="sup-doc-nav">${tmpNav}</aside><section class="sup-doc-main">${tmpBody}</section></div>`;
	}

	_shellHTML()
	{
		const tmpState = this.state;
		if (!this.canUse()) { return `<div class="sup-note sup-note-locked"><i class="fas fa-lock"></i> You don’t have access to the Support console.</div>`; }
		if (this._manifestError) { return this._notConfiguredHTML(); }
		// A tier-1 user whose organization hasn't enabled self-service can't file here.
		// A runbook-ONLY user (no support role) falls through to the Docs surface (handled by the _isDocsOnly branch below)
		// even when self-service filing is off. A tier-1 AGENT (has a support role) still gets the blocking notice — exempting
		// them here would wrongly drop them onto the full triage list + New-call in a non-self-service customer.
		if (this.isSelfService() && !this._isDocsOnly() && this._portal && !this._portal.SelfService)
		{
			return `<div class="sup-note sup-note-empty"><i class="fas fa-headset"></i>`
				+ `<div><b>Support isn’t self-service for your organization.</b><br>Please reach your HeadLight support contact to open a call.</div></div>`;
		}
		// Runbook-only user: the entire console is the runbook manager — no triage list, calls, metrics or settings.
		if (this._isDocsOnly())
		{
			if (tmpState.View !== 'docs') { tmpState.View = 'docs'; }
			return `<div class="sup-toolbar"><div class="sup-toolbar-left"><span class="sup-docsonly-h"><i class="fas fa-book"></i> Support runbooks</span></div></div>`
				+ `<div id="Support-Docs">${this._docsHTML()}</div>`;
		}
		if (tmpState.Mode === 'merge') { return this._mergeViewHTML(); }
		if (tmpState.Mode === 'form') { return this._formHTML(); }
		return this._listHTML();
	}

	/** The inline merge-wizard view (Mode 'merge') — a first-class console surface, NOT a modal. It paints the container
	 *  the SupportMerge provider builds its accordion into; the page scrolls normally (no overlay, no nested scrollbox). */
	_mergeViewHTML()
	{
		return `<div class="sup-form-head">`
			+ `<div class="sup-form-head-left"><a class="sup-back" onclick="_Pict.providers.Support.exitMerge(); return false;"><i class="fas fa-arrow-left"></i> All calls</a>`
			+ `<h2 class="sup-form-title"><i class="fas fa-code-merge"></i> Merge tickets</h2></div></div>`
			+ `<div class="supmg-view"><div id="SupportMerge-Wizard" class="supmg-wizard"></div></div>`;
	}

	_notConfiguredHTML()
	{
		return `<div class="sup-note sup-note-empty"><i class="fas fa-headset"></i>`
			+ `<div><b>Support isn’t set up for this customer yet.</b><br>`
			+ `${this._esc(this.state.Error || 'Run the support-portal seeder to create the Support Call form and workflow.')}</div></div>`;
	}

	_listHTML()
	{
		const tmpState = this.state;
		const tmpCounts = { New: 0, Acknowledged: 0, Tier1: 0, Tier2: 0, Tier3: 0, Resolved: 0, Void: 0 };
		tmpState.Calls.forEach((pCall) => { if (tmpCounts[pCall.Status] != null) { tmpCounts[pCall.Status]++; } });
		const tmpNewBtn = `<button class="sup-btn sup-btn-primary" onclick="_Pict.providers.Support.startCreate(); return false;"><i class="fas fa-plus"></i> New support call</button>`;
		const tmpBusy = tmpState.Busy ? `<span class="sup-inline-busy"><i class="fas fa-spinner fa-spin"></i></span>` : '';
		const tmpTools = `${this._segHTML()}${this._docsGearHTML()}${this._settingsGearHTML()}`;
		if (tmpState.View === 'docs' && this._canAccessDocs())
		{
			return `<div class="sup-toolbar"><div class="sup-toolbar-left">${tmpTools}</div>`
				+ `<div class="sup-toolbar-right">${tmpNewBtn}</div></div>`
				+ `<div id="Support-Docs">${this._docsHTML()}</div>`;
		}
		if (tmpState.View === 'settings' && this.canManage())
		{
			return `<div class="sup-toolbar"><div class="sup-toolbar-left">${tmpTools}</div>`
				+ `<div class="sup-toolbar-right">${tmpNewBtn}</div></div>`
				+ `<div id="Support-Settings">${this._settingsHTML()}</div>`;
		}
		if (tmpState.View === 'metrics' && this.canManage())
		{
			return `<div class="sup-toolbar"><div class="sup-toolbar-left">${tmpTools}</div>`
				+ `<div class="sup-toolbar-right">${tmpNewBtn}</div></div>`
				+ `<div id="Support-Metrics">${this._metricsHTML()}</div>`;
		}
		const tmpExport = this.canManage() ? `<button class="sup-btn" onclick="_Pict.providers.Support.exportCallsCSV(); return false;"><i class="fas fa-file-csv"></i> Export</button>` : '';
		return `<div class="sup-toolbar">`
			+ `<div class="sup-toolbar-left">${this._segHTML()}${this._docsGearHTML()}${this._settingsGearHTML()}${this._statusChipsHTML(tmpCounts)}</div>`
			+ `<div class="sup-toolbar-right">`
			+ `<div class="sup-search"><i class="fas fa-magnifying-glass"></i><input type="text" placeholder="Search calls…" value="${this._esc(tmpState.Filter)}" oninput="_Pict.providers.Support.onSearch(this.value)" /></div>`
			+ `${tmpExport}${tmpNewBtn}${tmpBusy}</div></div>`
			+ `<div class="sup-filterbar">${this._filterBarHTML()}</div>`
			+ (this.canManage() ? `<div id="Support-MergeBar">${this._mergeBarHTML()}</div>` : '')
			+ (tmpState.Error ? `<div class="sup-note sup-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Error)}</div>` : '')
			+ `<div id="Support-List" class="sup-listwrap">${this._listRowsHTML()}</div>`;
	}

	/** Status quick-filter chips (multi-select into Filters.Status) with live counts. */
	_statusChipsHTML(pCounts)
	{
		const tmpSel = this.state.Filters.Status || [];   // a stale/foreign persisted filter blob may lack this facet key
		return `<div class="sup-chips">` + Object.keys(STATUS_ORDER).map((pStatus) =>
		{
			const tmpMeta = this._statusMeta(pStatus);
			const tmpActive = tmpSel.indexOf(pStatus) >= 0 ? ' sup-chip-active' : '';
			return `<button class="sup-chip ${tmpMeta.cls}${tmpActive}" onclick="_Pict.providers.Support.toggleFilter('Status','${pStatus}'); return false;">`
				+ `<i class="fas ${tmpMeta.icon}"></i> ${tmpMeta.label} <span class="sup-chip-n">${pCounts[pStatus] || 0}</span></button>`;
		}).join('') + `</div>`;
	}

	/** Priority / Category / App multi-select dropdowns + a Clear + a "showing N of M" count. */
	_filterBarHTML()
	{
		const tmpState = this.state;
		const tmpFacets = this._facets();
		const tmpActive = tmpFacets.reduce((pN, pF) => pN + ((tmpState.Filters[pF.key] || []).length), 0);
		const tmpDrops = tmpFacets.filter((pF) => pF.key !== 'Status').map((pF) => this._facetDropdownHTML(pF)).join('');
		const tmpDF = tmpState.DateFilter || { from: '', to: '' };
		const tmpDateActive = !!(tmpDF.from || tmpDF.to);
		const tmpDateRange = `<span class="sup-dd sup-dd-daterange${tmpDateActive ? ' sup-dd-on' : ''}">`
			+ `<span class="sup-dd-dr-label"><i class="fas fa-calendar-day"></i> Designated</span>`
			+ `<input type="date" class="sup-date-in" value="${this._esc(tmpDF.from)}" max="${this._esc(tmpDF.to || '')}" onchange="_Pict.providers.Support.setDateFilter('from', this.value)" title="Designated date — from" />`
			+ `<span class="sup-date-sep">→</span>`
			+ `<input type="date" class="sup-date-in" value="${this._esc(tmpDF.to)}" min="${this._esc(tmpDF.from || '')}" onchange="_Pict.providers.Support.setDateFilter('to', this.value)" title="Designated date — to" /></span>`;
		const tmpCapNote = this._capped ? `<span class="sup-fb-cap" title="Showing the ${DOC_CAP} most recent — narrow with filters"><i class="fas fa-circle-info"></i> capped at ${DOC_CAP}</span>` : '';
		return `<span class="sup-fb-label"><i class="fas fa-filter"></i> Filter</span>${tmpDrops}${tmpDateRange}`
			+ ((tmpActive || tmpState.Filter || tmpDateActive) ? `<button class="sup-fb-clear" onclick="_Pict.providers.Support.clearFilters(); return false;"><i class="fas fa-xmark"></i> Clear</button>` : '')
			+ `${tmpCapNote}<span class="sup-fb-count">${this._visibleCalls().length} of ${tmpState.Calls.length}</span>`;
	}

	_facetDropdownHTML(pFacet)
	{
		const tmpSel = this.state.Filters[pFacet.key] || [];
		const tmpOpen = this.state.OpenDropdown === pFacet.key;
		const tmpBadge = tmpSel.length ? `<span class="sup-dd-badge">${tmpSel.length}</span>` : '';
		const tmpItems = pFacet.options().map((pOpt) =>
		{
			const tmpOn = tmpSel.indexOf(pOpt) >= 0;
			return `<div class="sup-dd-item ${tmpOn ? 'sup-dd-on' : ''}" onclick="_Pict.providers.Support.toggleFilter('${pFacet.key}','${this._esc(pOpt)}'); return false;">`
				+ `<i class="fas ${tmpOn ? 'fa-square-check' : 'fa-square'}"></i> ${this._esc(pFacet.labelFor(pOpt))}</div>`;
		}).join('');
		return `<div class="sup-dd ${tmpOpen ? 'sup-dd-open' : ''}">`
			+ `<button class="sup-dd-btn ${tmpSel.length ? 'sup-dd-active' : ''}" onclick="_Pict.providers.Support.toggleDropdown('${pFacet.key}'); return false;">${this._esc(pFacet.label)}${tmpBadge} <i class="fas fa-chevron-down"></i></button>`
			+ (tmpOpen ? `<div class="sup-dd-panel">${tmpItems}</div>` : '')
			+ `</div>`;
	}

	_segHTML()
	{
		if (!this.canManage()) { return ''; }   // tier-1 self-service users get the Calls view only (no Metrics)
		const tmpMetrics = this.state.View === 'metrics';
		return `<div class="sup-seg">`
			+ `<button class="sup-seg-b ${tmpMetrics ? '' : 'sup-seg-on'}" onclick="_Pict.providers.Support.navigateView('calls'); return false;"><i class="fas fa-list-ul"></i> Calls</button>`
			+ `<button class="sup-seg-b ${tmpMetrics ? 'sup-seg-on' : ''}" onclick="_Pict.providers.Support.navigateView('metrics'); return false;"><i class="fas fa-chart-column"></i> Metrics</button>`
			+ `</div>`;
	}

	_metricsHTML()
	{
		const tmpRange = this._metricsRangeControlHTML();   // always show the range selector, even while a range loads
		if (this._metricsLoading && !this._metrics) { return tmpRange + `<div class="sup-note"><i class="fas fa-spinner fa-spin"></i> Loading ${this._esc(this._metricsRangeBounds().label)}…</div>`; }
		const tmpM = this._metrics;
		if (!tmpM) { return tmpRange + `<div class="sup-note sup-note-empty">No metrics yet.</div>`; }
		if (tmpM.error) { return tmpRange + `<div class="sup-note sup-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpM.error)}</div>`; }
		const tmpRate = tmpM.total ? Math.round(100 * tmpM.resolved / tmpM.total) : 0;
		const tmpStats = `<div class="sup-kpis">`
			+ this._kpi(tmpM.total, 'Total calls', '')
			+ this._kpi(tmpM.backlog, 'Open backlog', '#3a44b8')
			+ this._kpi(tmpM.resolved, 'Resolved', '#1f7a44')
			+ this._kpi(tmpM.medianDays == null ? '—' : this._days(tmpM.medianDays), 'Median time to resolve', '')
			+ this._kpi(tmpRate + '%', 'Resolve rate', '')
			+ `</div>`;
		return tmpRange
			+ this._metricsFilterBarHTML()
			+ tmpStats
			+ `<div class="sup-mgrid">`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">By status</div>${this._byStatusHTML(tmpM.counts, tmpM.total)}</div>`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">By priority</div>${this._breakdownHTML(tmpM.byPrio)}</div>`
			+ `</div>`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">Opened vs resolved · ${this._esc(tmpM.rangeLabel || '')}`
			+ ` <span class="sup-mlegend"><span class="sup-mdot" style="background:#3a44b8"></span>opened <span class="sup-mdot" style="background:#1f7a44"></span>resolved</span></div>`
			+ `${this._openedResolvedChart(tmpM)}</div>`
			+ this._bugWatchHTML(tmpM.bug)
			+ `<div class="sup-mgrid">`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">By customer</div>${this._customerBreakdownHTML(tmpM.byCustomer)}</div>`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">By theme <span class="sup-mcard-sub">derived from subject</span></div>${this._breakdownHTML(tmpM.byTheme, (pK) => pK)}</div>`
			+ `</div>`
			+ `<div class="sup-mgrid">`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">By application</div>${this._breakdownHTML(tmpM.byApp, this._appLabel.bind(this))}</div>`
			+ `<div class="sup-mcard"><div class="sup-mcard-h">Resolved by</div>${this._agentBreakdownHTML(tmpM.byAgent)}</div>`
			+ `</div>`;
	}

	/** Coarse "what is this about" theme from a ticket's subject + issue text (legacy tickets carry no explicit Category). */
	_deriveTheme(pSummary, pDetails)
	{
		const tmpText = `${pSummary || ''} ${String(pDetails || '').slice(0, 400)}`;
		for (let i = 0; i < THEME_RULES.length; i++) { if (THEME_RULES[i].rx.test(tmpText)) { return THEME_RULES[i].key; } }
		return 'Other';
	}

	/** Top customers in scope by ticket volume, with their open backlog — dashboards straight off the Caller/Customer join. */
	_customerBreakdownHTML(pByCustomer)
	{
		const tmpRows = Object.keys(pByCustomer || {}).map((pK) => ({ id: pK, total: pByCustomer[pK].total, resolved: pByCustomer[pK].resolved, open: pByCustomer[pK].open }))
			.sort((pA, pB) => pB.total - pA.total).slice(0, 10);
		if (!tmpRows.length) { return `<div class="sup-mempty">No customer-matched calls in scope.</div>`; }
		const tmpMax = Math.max(1, ...tmpRows.map((pR) => pR.total));
		const tmpBody = tmpRows.map((pR) => `<tr onclick="_Pict.providers.Support.setMetricFilter('Customer','${this._esc(pR.id)}'); return false;" class="sup-dim-click" title="Filter dashboard to this customer">`
			+ `<td class="sup-dim-n">${this._esc(this._customerName(pR.id))}</td>`
			+ `<td class="sup-dim-bar"><div class="sup-dimbar"><span style="width:${Math.round(100 * pR.total / tmpMax)}%"></span></div></td>`
			+ `<td class="sup-dim-v">${pR.total}</td>`
			+ `<td class="sup-dim-v" style="color:${pR.open ? '#b4324b' : '#8894a4'}" title="open backlog">${pR.open || '—'}</td></tr>`).join('');
		return `<table class="sup-dimtable"><thead><tr><th>Customer</th><th></th><th>Calls</th><th>Open</th></tr></thead><tbody>${tmpBody}</tbody></table>`;
	}

	/** Dashboard filter bar: customer (super-user) · type (category/app) · support user (resolver) · customer user (opener). */
	/** Date-range scope selector — the years present in the archive plus rolling/all shortcuts and a custom From/To. */
	_metricsRangeControlHTML()
	{
		const tmpR = this.state.MetricsRange || {};
		const tmpCur = tmpR.preset || 'last12';
		const tmpNow = new Date();
		const tmpYears = []; for (let y = 2020; y <= tmpNow.getFullYear(); y++) { tmpYears.push(String(y)); }
		const tmpBtn = (pVal, pLabel) => `<button class="sup-rng-b ${tmpCur === pVal ? 'sup-rng-on' : ''}" onclick="_Pict.providers.Support.setMetricsRange('${pVal}'); return false;">${this._esc(pLabel)}</button>`;
		let tmpHTML = `<div class="sup-rng"><span class="sup-rng-l"><i class="fas fa-calendar-range"></i> Range</span>`
			+ tmpBtn('last12', 'Last 12 mo') + tmpYears.map((pY) => tmpBtn(pY, pY)).join('') + tmpBtn('all', 'All time')
			+ `<button class="sup-rng-b ${tmpCur === 'custom' ? 'sup-rng-on' : ''}" onclick="_Pict.providers.Support.toggleCustomRange(); return false;"><i class="fas fa-sliders"></i> Custom</button></div>`;
		if (tmpCur === 'custom' || this._showCustomRange)
		{
			const tmpYMD = (pD) => `${pD.getFullYear()}-${String(pD.getMonth() + 1).padStart(2, '0')}-${String(pD.getDate()).padStart(2, '0')}`;
			const tmpFrom = tmpR.from || `${tmpNow.getFullYear()}-01-01`;
			const tmpTo = tmpR.to || tmpYMD(tmpNow);
			tmpHTML += `<div class="sup-rng sup-rng-custom"><span class="sup-rng-l">From</span><input type="date" class="sup-rng-in" id="Support-Range-From" value="${this._esc(tmpFrom)}" max="${this._esc(tmpYMD(tmpNow))}">`
				+ `<span class="sup-rng-l">To</span><input type="date" class="sup-rng-in" id="Support-Range-To" value="${this._esc(tmpTo)}" max="${this._esc(tmpYMD(tmpNow))}">`
				+ `<button class="sup-rng-b sup-rng-apply" onclick="_Pict.providers.Support.applyCustomRange(); return false;"><i class="fas fa-check"></i> Apply</button></div>`;
		}
		return tmpHTML;
	}

	toggleCustomRange() { this._showCustomRange = !this._showCustomRange; this._paintMetrics(); }

	applyCustomRange()
	{
		const tmpCA = this.pict.ContentAssignment;
		const tmpFromEl = tmpCA.getElement('#Support-Range-From'); const tmpToEl = tmpCA.getElement('#Support-Range-To');
		const tmpFrom = tmpFromEl && tmpFromEl[0] && tmpFromEl[0].value;
		const tmpTo = tmpToEl && tmpToEl[0] && tmpToEl[0].value;
		if (!tmpFrom || !tmpTo || tmpFrom > tmpTo) { this._toast('Pick a valid range — From must be on or before To.', 'error'); return; }
		this.state.MetricsRange = { preset: 'custom', from: tmpFrom, to: tmpTo };
		this._showCustomRange = true;
		this._metrics = null;
		this._loadMetricsAsync();
		this._paintMetrics();
	}

	_metricsFilterBarHTML()
	{
		const tmpF = this.state.MetricsFilters || {};
		const tmpCalls = this._metricsCalls || [];
		const tmpSelect = (pDim, pLabel, pOptions) =>
		{
			if (!pOptions.length) { return ''; }
			const tmpOpts = `<option value="">All</option>` + pOptions.map((pO) => `<option value="${this._esc(pO.value)}" ${tmpF[pDim] === pO.value ? 'selected' : ''}>${this._esc(pO.label)}</option>`).join('');
			return `<label class="sup-mf"><span class="sup-mf-l">${this._esc(pLabel)}</span><select class="sup-mf-sel ${tmpF[pDim] ? 'sup-mf-on' : ''}" onchange="_Pict.providers.Support.setMetricFilter('${pDim}', this.value)">${tmpOpts}</select></label>`;
		};
		// Option lists built from what's present in the loaded data (so no empty filters).
		const tmpUniq = (pFn) => { const tmpSet = {}; tmpCalls.forEach((pC) => { const tmpV = pFn(pC); if (tmpV) { tmpSet[tmpV] = true; } }); return Object.keys(tmpSet); };
		// Customer is a searchable pict-section-picker (mounted after paint into #Support-Metric-Cust-Pick), scoped to
		// the customers that actually have calls in the loaded range; only shown for super-users with >0 such customers.
		const tmpCustIDs = this._isSuperUser() ? tmpUniq((pC) => pC.CallerCustomer && String(pC.CallerCustomer)) : [];
		const tmpCustSel = tmpCustIDs.length
			? `<label class="sup-mf"><span class="sup-mf-l">Customer</span><span id="Support-Metric-Cust-Pick" class="sup-mf-pick ${tmpF.Customer ? 'sup-mf-on' : ''}"></span></label>`
			: '';
		const tmpCatSel = tmpSelect('Category', 'Category', tmpUniq((pC) => pC.Category).map((pV) => ({ value: pV, label: this._catLabel(pV) })));
		const tmpAppSel = tmpSelect('App', 'Application', tmpUniq((pC) => pC.App).map((pV) => ({ value: pV, label: this._appLabel(pV) })));
		const tmpResolvers = Object.keys(this._resolveMap || {}).map((pK) => this._resolveMap[pK].resolver).filter(Boolean);
		const tmpResSel = tmpSelect('Resolver', 'Support user', [ ...new Set(tmpResolvers) ].map((pV) => ({ value: String(pV), label: this._agentNames[pV] || ('User ' + pV) })).sort((pA, pB) => pA.label.localeCompare(pB.label)));
		const tmpOpenSel = tmpSelect('Opener', 'Customer user', tmpUniq((pC) => pC.OpenedBy && String(pC.OpenedBy)).map((pV) => ({ value: pV, label: this._agentNames[pV] || ('User ' + pV) })).sort((pA, pB) => pA.label.localeCompare(pB.label)));
		const tmpActive = Object.keys(tmpF).some((pK) => tmpF[pK]);
		const tmpClear = tmpActive ? `<button class="sup-fb-clear" onclick="_Pict.providers.Support.clearMetricFilters(); return false;"><i class="fas fa-xmark"></i> Clear</button>` : '';
		return `<div class="sup-mfilter"><span class="sup-fb-label"><i class="fas fa-filter"></i> Dashboard</span>${tmpCustSel}${tmpCatSel}${tmpAppSel}${tmpResSel}${tmpOpenSel}${tmpClear}</div>`;
	}

	/** Horizontal proportion bar of the backlog by status. */
	_byStatusHTML(pCounts, pTotal)
	{
		if (!pTotal) { return `<div class="sup-mempty">No calls in scope.</div>`; }
		const tmpBar = Object.keys(STATUS_ORDER).map((pS) =>
		{
			const tmpN = pCounts[pS] || 0; if (!tmpN) { return ''; }
			const tmpMeta = this._statusMeta(pS);
			return `<span class="sup-stbar-seg ${tmpMeta.cls}" style="width:${100 * tmpN / pTotal}%" title="${tmpMeta.label}: ${tmpN}"></span>`;
		}).join('');
		const tmpLegend = Object.keys(STATUS_ORDER).map((pS) =>
		{
			const tmpN = pCounts[pS] || 0; const tmpMeta = this._statusMeta(pS);
			return `<div class="sup-stleg"><span class="sup-badge ${tmpMeta.cls}"><i class="fas ${tmpMeta.icon}"></i> ${tmpMeta.label}</span><span class="sup-stleg-n">${tmpN}</span><span class="sup-stleg-p">${pTotal ? Math.round(100 * tmpN / pTotal) : 0}%</span></div>`;
		}).join('');
		return `<div class="sup-stbar">${tmpBar}</div><div class="sup-stlegwrap">${tmpLegend}</div>`;
	}

	/** "Something isn't working" watch — bug volume, backlog, cycle time + a by-application drill-in. */
	_bugWatchHTML(pBug)
	{
		if (!pBug || !pBug.total)
		{
			return `<div class="sup-mcard sup-bugcard"><div class="sup-mcard-h"><i class="fas fa-bug"></i> Something isn’t working</div>`
				+ `<div class="sup-mempty">No “Something isn’t working” calls in scope.</div></div>`;
		}
		const tmpMini = pBug.opened.map((pO, i) =>
		{
			const tmpMax = Math.max(1, ...pBug.opened, ...pBug.resolved);
			const tmpR = pBug.resolved[i] || 0; const tmpMo = this._metrics.months[i];
			return `<div class="sup-bar" title="${MON_SHORT[tmpMo.m]} ${tmpMo.y}: ${pO} opened, ${tmpR} resolved"><div class="sup-bar-pair">`
				+ `<span class="sup-bar-c" style="height:${Math.round(100 * pO / tmpMax)}%;background:#b4324b"><span class="sup-bar-n">${pO || ''}</span></span>`
				+ `<span class="sup-bar-c" style="height:${Math.round(100 * tmpR / tmpMax)}%;background:#1f7a44"><span class="sup-bar-n">${tmpR || ''}</span></span>`
				+ `</div><span class="sup-bar-x">${MON_SHORT[tmpMo.m]}</span></div>`;
		}).join('');
		const tmpFocused = this.state.MetricsFilters && this.state.MetricsFilters.Category === 'Bug';
		const tmpFocusBtn = tmpFocused
			? `<button class="sup-bug-focus sup-bug-focus-on" onclick="_Pict.providers.Support.setMetricFilter('Category',''); return false;"><i class="fas fa-xmark"></i> Clear bug focus</button>`
			: `<button class="sup-bug-focus" onclick="_Pict.providers.Support.setMetricFilter('Category','Bug'); return false;"><i class="fas fa-magnifying-glass"></i> Focus dashboard on bugs</button>`;
		return `<div class="sup-mcard sup-bugcard"><div class="sup-mcard-h"><i class="fas fa-bug"></i> Something isn’t working${tmpFocusBtn}</div>`
			+ `<div class="sup-bug-grid">`
			+ `<div class="sup-bug-kpis">`
			+ this._kpi(pBug.total, 'Bug calls', '#b4324b')
			+ this._kpi(pBug.backlog, 'Bug backlog', '#b4324b')
			+ this._kpi(pBug.medianDays == null ? '—' : this._days(pBug.medianDays), 'Median fix time', '')
			+ `</div>`
			+ `<div class="sup-bug-trend"><div class="sup-mcard-h">Bug trend · ${this._trailingMonths}mo <span class="sup-mlegend"><span class="sup-mdot" style="background:#b4324b"></span>opened <span class="sup-mdot" style="background:#1f7a44"></span>resolved</span></div><div class="sup-chart sup-chart-sm">${tmpMini}</div></div>`
			+ `</div>`
			+ `<div class="sup-mcard-h" style="margin-top:0.6rem">By application</div>${this._breakdownHTML(pBug.byApp, this._appLabel.bind(this))}</div>`;
	}

	_kpi(pValue, pLabel, pColor)
	{
		return `<div class="sup-kpi"><div class="sup-kpi-v"${pColor ? ` style="color:${pColor}"` : ''}>`
			+ `${typeof pValue === 'number' ? pValue.toLocaleString() : this._esc(pValue)}</div>`
			+ `<div class="sup-kpi-l">${this._esc(pLabel)}</div></div>`;
	}

	_openedResolvedChart(pM)
	{
		let tmpMax = 1;
		pM.months.forEach((pMo, i) => { tmpMax = Math.max(tmpMax, pM.opened[i] || 0, pM.resolvedSeries[i] || 0); });
		if (!pM.opened.some(Boolean) && !pM.resolvedSeries.some(Boolean)) { return `<div class="sup-mempty">No calls in this window.</div>`; }
		// Over a wide (multi-year) span, per-month labels get illegible — label only the January bars with the year
		// ('20, '21, …) as year markers; the hover title still names the exact month. Bar counts are hidden when dense.
		const tmpWide = pM.months.length > 14;
		const tmpBars = pM.months.map((pMo, i) =>
		{
			const tmpO = pM.opened[i] || 0; const tmpR = pM.resolvedSeries[i] || 0;
			const tmpLabel = tmpWide ? (pMo.m === 0 ? `’${String(pMo.y).slice(2)}` : '') : MON_SHORT[pMo.m];
			const tmpShowN = !tmpWide;
			return `<div class="sup-bar${tmpWide ? ' sup-bar-dense' : ''}" title="${MON_SHORT[pMo.m]} ${pMo.y}: ${tmpO} opened, ${tmpR} resolved"><div class="sup-bar-pair">`
				+ `<span class="sup-bar-c" style="height:${Math.round(100 * tmpO / tmpMax)}%;background:#3a44b8">${tmpShowN ? `<span class="sup-bar-n">${tmpO || ''}</span>` : ''}</span>`
				+ `<span class="sup-bar-c" style="height:${Math.round(100 * tmpR / tmpMax)}%;background:#1f7a44">${tmpShowN ? `<span class="sup-bar-n">${tmpR || ''}</span>` : ''}</span>`
				+ `</div><span class="sup-bar-x${pMo.m === 0 && tmpWide ? ' sup-bar-x-year' : ''}">${tmpLabel}</span></div>`;
		}).join('');
		return `<div class="sup-chart${tmpWide ? ' sup-chart-wide' : ''}">${tmpBars}</div>`;
	}

	_breakdownHTML(pGroups, pLabelFn)
	{
		const tmpLabel = pLabelFn || ((pK) => this._catLabel(pK));
		const tmpRows = Object.keys(pGroups).map((pK) => ({ key: pK, total: pGroups[pK].total, resolved: pGroups[pK].resolved })).sort((pA, pB) => pB.total - pA.total).slice(0, 10);
		if (!tmpRows.length) { return `<div class="sup-mempty">No data.</div>`; }
		const tmpMax = Math.max(1, ...tmpRows.map((pR) => pR.total));
		const tmpBody = tmpRows.map((pR) => `<tr><td class="sup-dim-n">${this._esc(tmpLabel(pR.key))}</td>`
			+ `<td class="sup-dim-bar"><div class="sup-dimbar"><span style="width:${Math.round(100 * pR.total / tmpMax)}%"></span></div></td>`
			+ `<td class="sup-dim-v">${pR.total}</td><td class="sup-dim-v" style="color:#1f7a44">${pR.resolved}</td></tr>`).join('');
		return `<table class="sup-dimtable"><thead><tr><th>Group</th><th></th><th>Calls</th><th>Res.</th></tr></thead><tbody>${tmpBody}</tbody></table>`;
	}

	_agentBreakdownHTML(pAgents)
	{
		const tmpRows = Object.keys(pAgents).map((pK) => ({ key: Number(pK), resolved: pAgents[pK].resolved })).sort((pA, pB) => pB.resolved - pA.resolved).slice(0, 10);
		if (!tmpRows.length) { return `<div class="sup-mempty">No resolutions yet.</div>`; }
		const tmpMax = Math.max(1, ...tmpRows.map((pR) => pR.resolved));
		const tmpBody = tmpRows.map((pR) => `<tr><td class="sup-dim-n">${this._esc(this._agentNames[pR.key] || ('User ' + pR.key))}</td>`
			+ `<td class="sup-dim-bar"><div class="sup-dimbar"><span style="width:${Math.round(100 * pR.resolved / tmpMax)}%;background:#1f7a44"></span></div></td>`
			+ `<td class="sup-dim-v">${pR.resolved}</td></tr>`).join('');
		return `<table class="sup-dimtable"><thead><tr><th>Agent</th><th></th><th>Res.</th></tr></thead><tbody>${tmpBody}</tbody></table>`;
	}

	_listRowsHTML()
	{
		const tmpState = this.state;
		if (tmpState.Loading) { return `<div class="sup-note"><i class="fas fa-spinner fa-spin"></i> Loading support calls…</div>`; }
		const tmpHead = this._tableHeadHTML();
		const tmpAll = this._visibleCalls();
		if (!tmpAll.length)
		{
			const tmpEmpty = tmpState.Calls.length ? 'No calls match these filters.' : 'No support calls yet. Start one with “New support call”.';
			return `<table class="sup-table">${tmpHead}<tbody><tr><td class="sup-empty-cell" colspan="${this._rowColSpan() + (this.canManage() ? 1 : 0)}"><i class="fas fa-inbox"></i> ${tmpEmpty}</td></tr></tbody></table>`;
		}
		// Client-side pagination of the already-loaded + faceted set (we page the rendered rows, not the fetch). Clamp so a
		// stale page left over from a wider filter can't blank the list after the set narrows.
		const tmpPageCount = Math.max(1, Math.ceil(tmpAll.length / LIST_PAGE_SIZE));
		const tmpPage = Math.min(Math.max(0, Number(tmpState.ListPage) || 0), tmpPageCount - 1);
		const tmpRows = tmpAll.slice(tmpPage * LIST_PAGE_SIZE, (tmpPage + 1) * LIST_PAGE_SIZE);
		// A pager at BOTH ends — the top one is visible immediately (the list is long: 25 two-row call groups), the bottom
		// one is there after you scroll. Each call renders as its OWN <tbody> (a metadata + a full-width summary row).
		const tmpTopPager = this._listPagerHTML(tmpAll.length, tmpPage, tmpPageCount, 'top');
		const tmpBottomPager = this._listPagerHTML(tmpAll.length, tmpPage, tmpPageCount, 'bottom');
		return `${tmpTopPager}<table class="sup-table">${tmpHead}${tmpRows.map((pCall) => this._callRowHTML(pCall)).join('')}</table>${tmpBottomPager}`;
	}

	/** Prev/Next pager + "Showing X–Y of N" for the triage list; hidden when everything fits on one page. pPos = 'top'|'bottom'. */
	_listPagerHTML(pTotal, pPage, pPageCount, pPos)
	{
		if (pTotal <= LIST_PAGE_SIZE) { return ''; }
		const tmpStart = pPage * LIST_PAGE_SIZE + 1;
		const tmpEnd = Math.min(pTotal, (pPage + 1) * LIST_PAGE_SIZE);
		return `<div class="sup-pager${pPos === 'top' ? ' sup-pager-top' : ''}">`
			+ `<button class="sup-pg" ${pPage <= 0 ? 'disabled' : ''} onclick="_Pict.providers.Support.setListPage(${pPage - 1}); return false;"><i class="fas fa-chevron-left"></i> Prev</button>`
			+ `<span class="sup-pg-info">Showing <b>${tmpStart.toLocaleString()}</b>–<b>${tmpEnd.toLocaleString()}</b> of <b>${pTotal.toLocaleString()}</b> · page ${pPage + 1} of ${pPageCount}</span>`
			+ `<button class="sup-pg" ${pPage >= pPageCount - 1 ? 'disabled' : ''} onclick="_Pict.providers.Support.setListPage(${pPage + 1}); return false;">Next <i class="fas fa-chevron-right"></i></button>`
			+ `</div>`;
	}

	_tableHeadHTML()
	{
		const tmpSort = this.state.Sort;
		const tmpTh = (pKey, pLabel, pClass) =>
		{
			const tmpIdx = tmpSort.findIndex((pS) => pS.key === pKey);
			let tmpCaret = '';
			if (tmpIdx >= 0)
			{
				tmpCaret = ` <i class="fas fa-caret-${tmpSort[tmpIdx].dir === 'asc' ? 'up' : 'down'} sup-th-caret"></i>`
					+ (tmpSort.length > 1 ? `<span class="sup-th-ord">${tmpIdx + 1}</span>` : '');
			}
			return `<th class="sup-th ${pClass || ''} ${tmpIdx >= 0 ? 'sup-th-sorted' : ''}" title="Click to sort · Shift-click to add a level" onclick="_Pict.providers.Support.setSort('${pKey}', event.shiftKey); return false;">${this._esc(pLabel)}${tmpCaret}</th>`;
		};
		const tmpSelCount = this._selectedIDs().length;
		const tmpSelTh = this.canManage()
			? `<th class="sup-th sup-col-sel" title="Select tickets to merge"><input type="checkbox" class="sup-cb" ${tmpSelCount ? 'checked' : ''} onclick="_Pict.providers.Support.toggleSelectAllVisible(this.checked); return false;" /></th>`
			: '';
		return `<thead><tr>`
			+ tmpSelTh
			+ tmpTh('Status', 'Status', 'sup-col-status')
			+ (this._isSuperUser() ? tmpTh('Customer', 'Customer', 'sup-col-cust') : '')
			+ tmpTh('Priority', 'Priority', 'sup-col-prio')
			+ tmpTh('Category', 'Category', 'sup-col-cat')
			+ tmpTh('App', 'App', 'sup-col-app')
			+ tmpTh('Caller', 'Caller', 'sup-col-caller')
			+ tmpTh('Updated', 'Updated', 'sup-col-date')
			+ tmpTh('Designated', 'Designated', 'sup-col-date')
			+ tmpTh('UpdatedBy', 'Updated By', 'sup-col-updby')
			+ `<th class="sup-th sup-col-fu" title="Follow-up needed"><i class="fas fa-flag"></i></th>`
			+ `<th class="sup-th sup-col-go"></th>`
			+ `</tr></thead>`;
	}

	/** Number of columns in a call's top (metadata) row — the summary row spans all of them. */
	_rowColSpan() { return this._isSuperUser() ? 11 : 10; }

	/**
	 * One call = a two-row group: a compact metadata row (status/customer/priority/category/app/caller/updated) and a
	 * full-width summary line underneath, so the metadata columns aren't cramped by a wide summary column.
	 */
	_callRowHTML(pCall)
	{
		const tmpStatus = this._statusMeta(pCall.Status);
		const tmpPrio = this._prioMeta(pCall.Priority);
		const tmpMuted = '<span class="sup-muted">—</span>';
		const tmpCust = this._isSuperUser() ? `<td class="sup-col-cust"><span class="sup-cust">${pCall.CallerCustomer ? this._esc(this._customerName(pCall.CallerCustomer)) : tmpMuted}</span></td>` : '';
		const tmpStage = (pCall.Stage && IMPL_STAGE_MAP[pCall.Stage]) ? ` <span class="sup-stg-chip ${IMPL_STAGE_MAP[pCall.Stage].cls}">${this._esc(IMPL_STAGE_MAP[pCall.Stage].label)}</span>` : '';
		const tmpSelCell = this.canManage()
			? `<td class="sup-col-sel" rowspan="2" onclick="event.stopPropagation();"><input type="checkbox" class="sup-cb" ${this._isSelected(pCall.IDDocument) ? 'checked' : ''} title="Select to merge" onclick="event.stopPropagation(); _Pict.providers.Support.toggleSelect(${pCall.IDDocument}, this.checked);" /></td>`
			: '';
		return `<tbody class="sup-callgroup${this._isSelected(pCall.IDDocument) ? ' sup-callgroup-sel' : ''}" onclick="_Pict.providers.Support.navigateCall(${pCall.IDDocument}); return false;">`
			+ `<tr class="sup-tr sup-tr-meta">`
			+ tmpSelCell
			+ `<td class="sup-col-status"><span class="sup-badge ${tmpStatus.cls}"><i class="fas ${tmpStatus.icon}"></i> ${tmpStatus.label}</span></td>`
			+ tmpCust
			+ `<td class="sup-col-prio">${pCall.Priority ? `<span class="sup-prio ${tmpPrio.cls}">${this._esc(tmpPrio.label)}</span>` : tmpMuted}</td>`
			+ `<td class="sup-col-cat">${pCall.Category ? `<span class="sup-tag">${this._esc(this._catLabelList(pCall.Category))}</span>` : tmpMuted}</td>`
			+ `<td class="sup-col-app">${pCall.App ? `<span class="sup-tag sup-tag-app">${this._esc(this._appLabel(pCall.App))}</span>` : tmpMuted}</td>`
			+ `<td class="sup-col-caller">${pCall.Caller ? this._esc(pCall.Caller) : tmpMuted}</td>`
			+ `<td class="sup-col-date">${this._date(pCall.Updated)}</td>`
			+ `<td class="sup-col-date" title="Designated date (email timestamp)">${this._date(pCall.Designated)}</td>`
			+ `<td class="sup-col-updby" title="Last team member to action this call">${pCall.UpdatedBy ? this._esc(this._agentNames[pCall.UpdatedBy] || ('User ' + pCall.UpdatedBy)) : tmpMuted}</td>`
			+ `<td class="sup-col-fu">${pCall.FollowUp ? '<i class="fas fa-flag sup-fu-on" title="Follow-up needed"></i>' : ''}</td>`
			+ `<td class="sup-col-go"><i class="fas fa-chevron-right"></i></td>`
			+ `</tr>`
			+ `<tr class="sup-tr sup-tr-sum">`
			+ `<td class="sup-sumcell" colspan="${this._rowColSpan()}"><span class="sup-summary-txt">${this._esc(pCall.Summary)}</span>`
			+ `<span class="sup-row-id">#${pCall.IDDocument}${tmpStage}</span></td>`
			+ `</tr>`
			+ `</tbody>`;
	}

	// ── Bulk-merge selection (manager-only) ──────────────────────────────────────────────────────────────────────

	_isSelected(pID) { const tmpSel = this.state.Selected || {}; return !!tmpSel[Number(pID)]; }
	_selectedIDs() { const tmpSel = this.state.Selected || {}; return Object.keys(tmpSel).filter((pK) => tmpSel[pK]).map((pK) => Number(pK)); }

	/** The IDDocuments on the current (client-paged) list page — the scope of "select all". */
	_visiblePageIDs()
	{
		const tmpAll = this._visibleCalls();
		const tmpPageCount = Math.max(1, Math.ceil(tmpAll.length / LIST_PAGE_SIZE));
		const tmpPage = Math.min(Math.max(0, Number(this.state.ListPage) || 0), tmpPageCount - 1);
		return tmpAll.slice(tmpPage * LIST_PAGE_SIZE, (tmpPage + 1) * LIST_PAGE_SIZE).map((pCall) => Number(pCall.IDDocument));
	}

	toggleSelect(pID, pChecked)
	{
		if (!this.state.Selected) { this.state.Selected = {}; }
		if (pChecked) { this.state.Selected[Number(pID)] = true; } else { delete this.state.Selected[Number(pID)]; }
		// Repaint the list too (not just the bar): refreshes the row highlight + the header select-all box, and re-syncs
		// the rendered checkbox if a concurrent repaint (e.g. closing a facet dropdown) re-rendered the row from old state.
		this._paintList();
		this._paintMergeBar();
	}

	toggleSelectAllVisible(pChecked)
	{
		if (!this.state.Selected) { this.state.Selected = {}; }
		this._visiblePageIDs().forEach((pID) => { if (pChecked) { this.state.Selected[pID] = true; } else { delete this.state.Selected[pID]; } });
		this._paintList();
		this._paintMergeBar();
	}

	clearSelection() { this.state.Selected = {}; this._paintList(); this._paintMergeBar(); }

	_paintList() { const tmpCA = this.pict.ContentAssignment; if (tmpCA && tmpCA.getElement('#Support-List').length) { tmpCA.assignContent('#Support-List', this._listRowsHTML()); } }
	_paintMergeBar() { const tmpCA = this.pict.ContentAssignment; if (tmpCA && tmpCA.getElement('#Support-MergeBar').length) { tmpCA.assignContent('#Support-MergeBar', this._mergeBarHTML()); } }

	/** The sticky selection bar shown above the list when one or more tickets are ticked. */
	_mergeBarHTML()
	{
		const tmpN = this._selectedIDs().length;
		if (!tmpN) { return ''; }
		return `<div class="sup-mergebar">`
			+ `<span class="sup-mergebar-n"><i class="fas fa-check-double"></i> ${tmpN} selected</span>`
			+ `<button class="sup-btn sup-btn-sm" onclick="_Pict.providers.Support.clearSelection(); return false;"><i class="fas fa-xmark"></i> Clear</button>`
			+ `<button class="sup-btn sup-btn-primary sup-mergebar-go" onclick="_Pict.providers.Support.openMergeSelected(); return false;"><i class="fas fa-code-merge"></i> Merge ${tmpN} into…</button>`
			+ `</div>`;
	}

	/** Launch the merge wizard for the ticked tickets (bulk). Routes to #/Support/Merge/<ids> so the wizard is deep-linkable. */
	openMergeSelected()
	{
		const tmpIDs = this._selectedIDs();
		if (!tmpIDs.length) { return; }
		this.navigateMerge(tmpIDs);
	}

	/** Launch the merge wizard for the single call currently open in the detail view. */
	openMergeCurrent()
	{
		const tmpActive = this.state.Active;
		if (!tmpActive || !tmpActive.IDDocument) { return; }
		// Coming from an open call with an unsaved Call-activity note: confirm BEFORE we route away (the route change tears
		// the form down). The guard lives here, not in enterMerge, because the router drives enterMerge AFTER the hash has
		// already changed — declining there would strand the URL on the merge route. Mirrors cancel() + the beforeunload guard.
		if (this.state.Mode === 'form' && this._hasUnsavedComposer())
		{
			const tmpOk = (typeof window !== 'undefined' && typeof window.confirm === 'function')
				? window.confirm('You have an unsaved note in Call activity. Leave without adding it?\n\n(Click Cancel to stay and add it.)')
				: true;
			if (!tmpOk) { this._scrollToComposer(); return; }
		}
		this.navigateMerge([ Number(tmpActive.IDDocument) ]);
	}

	// ── Merge wizard — a deep-linkable view (#/Support/Merge/<id,id,…>) ──────────────────────────────────────────

	/** Write the hash for the merge wizard so it is bookmarkable + reload-safe; the router applies it via routeApplyMerge.
	 *  No window (tests/SSR) → apply directly. */
	navigateMerge(pIDs)
	{
		const tmpIDs = (Array.isArray(pIDs) ? pIDs : [ pIDs ]).map((pX) => Number(pX)).filter(Boolean);
		if (!tmpIDs.length) { return; }
		if ((typeof window === 'undefined') || !window.location) { this.routeApplyMerge(tmpIDs); return; }
		window.location.hash = '#/Support/Merge/' + tmpIDs.join(',');
	}

	/** Router entry: open the merge wizard for the children named in the route. Parses the id list (tolerant of any
	 *  non-digit separator / url-encoding), and bounces a non-manager / docs-only user or an empty list to the queue. */
	routeApplyMerge(pIDs)
	{
		if (this._isDocsOnly()) { this.navigateView('docs'); return; }
		if (!this.canManage()) { this.navigateView('calls'); return; }
		const tmpRaw = (pIDs == null) ? '' : (Array.isArray(pIDs) ? pIDs.join(',') : String(pIDs));
		const tmpIDs = [ ...new Set(tmpRaw.split(/[^0-9]+/).map((pX) => Number(pX)).filter(Boolean)) ];
		if (!tmpIDs.length) { this.navigateView('calls'); return; }
		this.enterMerge(tmpIDs);
	}

	/** Enter the inline merge-wizard view (Mode 'merge') for the given child tickets. It is a VIEW, not a modal: we paint
	 *  the shell (so #SupportMerge-Wizard exists), then hand off to SupportMerge to build its accordion into that container.
	 *  Reached via the router (routeApplyMerge); the unsaved-composer confirm already ran in openMergeCurrent. Leave via exitMerge. */
	enterMerge(pIDs)
	{
		const tmpMerge = this.pict.providers.SupportMerge;
		if (!tmpMerge || (typeof tmpMerge.open !== 'function')) { this._toast('The merge wizard is unavailable.', 'error'); return; }
		if (!this.canManage()) { this._toast('You do not have permission to merge tickets.', 'error'); return; }
		const tmpIDs = (Array.isArray(pIDs) ? pIDs : [ pIDs ]).map((pX) => Number(pX)).filter(Boolean);
		if (!tmpIDs.length) { return; }
		// Coming from an open call (Mode 'form'): tear down the mounted form view so it doesn't leak (mirrors routeApply).
		if (this.state.Mode === 'form' && this.formHost && (typeof this.formHost.destroy === 'function')) { try { this.formHost.destroy(); } catch (pErr) { /* best-effort */ } }
		this.state.Mode = 'merge';
		this._paint();                 // paints _mergeViewHTML → #SupportMerge-Wizard now exists in the DOM
		tmpMerge.open(tmpIDs);         // builds the accordion into it (async child resolve; the container is already present)
	}

	/** Leave the merge view for the triage list via the hash (router reloads it, dropping any just-merged tickets). Mode
	 *  stays 'merge' so routeApply('calls') takes its merge branch (teardown + loadAsync). Mirrors cancel()'s exit. */
	exitMerge()
	{
		const tmpMerge = this.pict.providers.SupportMerge;
		if (tmpMerge && (typeof tmpMerge.teardown === 'function')) { tmpMerge.teardown(); }
		this.navigateView('calls');
	}

	_formHTML()
	{
		const tmpState = this.state;
		const tmpError = tmpState.Error ? `<div class="sup-note sup-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(tmpState.Error)}</div>` : '';
		// Everything actionable — Save (+ ⌘/Ctrl-S), the status/approval + delivery actions, and the runbook/content
		// library — lives in a width-resizable, top-sticky side panel that travels with you as you scroll, so you never
		// scroll to the top to save. The form + activity (the left column) scroll the page normally.
		this._ensureFormKeyHandlers();
		return `<div class="sup-form-head">`
			+ `<div class="sup-form-head-left"><a class="sup-back" onclick="_Pict.providers.Support.cancel(); return false;"><i class="fas fa-arrow-left"></i> All calls</a>`
			+ `<h2 class="sup-form-title">${this._esc(tmpState.FormTitle || 'Support call')}</h2></div></div>`
			+ tmpError
			+ `<div class="sup-work" style="--sup-panel-w:${this._panelWidthCss()};">`
			+   `<div class="sup-work-main">`
			+     `<div id="Support-FormHost" class="sup-form-host"></div>`
			+     (tmpState.FormMode === 'create' ? '' : `<div id="Support-Activity" class="sup-activity">${this._activityHTML()}</div>`)
			+   `</div>`
			+   `<aside class="sup-panel">`
			+     `<div class="sup-panel-grip" title="Drag to resize" onmousedown="_Pict.providers.Support.startPanelResize(event); return false;"><span class="sup-panel-grip-bar"></span></div>`
			+     `<div class="sup-panel-inner">`
			+       `<div id="Support-Form-Actions" class="sup-panel-actions">${this._formActionsHTML()}</div>`
			+       `<div id="Support-Approval">${this._approvalHTML()}</div>`
			+       (tmpState.FormMode === 'create' ? '' : `<div id="Support-Impl">${this._implBarHTML()}</div>`)
			+       (this.canManage() ? `<div id="Support-Runbook" class="sup-runbook${this.state.RunbookOpen === false ? ' sup-runbook-collapsed' : ''}">${this._runbookHTML()}</div>` : '')
			+     `</div>`
			+   `</aside>`
			+ `</div>`;
	}

	/** The persisted side-panel width as a CSS length (px), or the default. */
	_panelWidthCss() { const tmpW = Number(this.state.PanelWidth) || 0; return (tmpW >= 260 && tmpW <= 680) ? `${tmpW}px` : '22rem'; }

	/** Drag-resize the action panel (grip on its left edge; dragging left widens it). Persisted per-user. */
	startPanelResize(pEvent)
	{
		if (typeof document === 'undefined') { return; }
		const tmpCA = this.pict.ContentAssignment;
		const tmpWorkEls = tmpCA.getElement('.sup-work');
		if (!tmpWorkEls || !tmpWorkEls.length) { return; }
		const tmpWork = tmpWorkEls[0];
		const tmpPanel = tmpWork.querySelector('.sup-panel');
		const tmpStartX = pEvent.clientX;
		const tmpStartW = tmpPanel ? tmpPanel.getBoundingClientRect().width : 352;
		const tmpMove = (pMove) =>
		{
			const tmpW = Math.max(260, Math.min(680, Math.round(tmpStartW + (tmpStartX - pMove.clientX))));
			tmpWork.style.setProperty('--sup-panel-w', `${tmpW}px`);
			this.state.PanelWidth = tmpW;
		};
		const tmpUp = () =>
		{
			document.removeEventListener('mousemove', tmpMove);
			document.removeEventListener('mouseup', tmpUp);
			try { document.body.style.userSelect = ''; } catch (pErr) { /* */ }
			this._persistFilters();   // the prefs blob carries PanelWidth too
		};
		try { document.body.style.userSelect = 'none'; } catch (pErr) { /* */ }
		document.addEventListener('mousemove', tmpMove);
		document.addEventListener('mouseup', tmpUp);
	}

	/** Attach the one-time form-mode key handlers: ⌘/Ctrl-S saves without bouncing; beforeunload warns on an unsaved note. */
	_ensureFormKeyHandlers()
	{
		if (this._formKeyHandlersAttached || typeof document === 'undefined') { return; }
		this._formKeyHandlersAttached = true;
		document.addEventListener('keydown', (pEvent) =>
		{
			if ((pEvent.key === 's' || pEvent.key === 'S') && (pEvent.metaKey || pEvent.ctrlKey) && !pEvent.shiftKey && !pEvent.altKey
				&& this._isFormLive() && !this.state.Saving)
			{
				pEvent.preventDefault();
				this.save();
			}
		});
		if (typeof window !== 'undefined')
		{
			window.addEventListener('beforeunload', (pEvent) =>
			{
				if (this.state.Mode === 'form' && this._hasUnsavedComposer()) { pEvent.preventDefault(); pEvent.returnValue = ''; return ''; }
			});
		}
	}

	/** The support CALL FORM is the live, mounted view right now (Mode='form' is a stale AppData flag once you leave via
	 *  top-nav, which runs no Support teardown — so also require the form's own container to still be in the DOM). */
	_isFormLive() { return this.state.Mode === 'form' && !!this.state.Active && this.pict.ContentAssignment.getElement('#Support-Host').length > 0; }

	/** True when there's an in-progress call-activity note the user hasn't added yet (so leaving would lose it). */
	_hasUnsavedComposer()
	{
		if (!this._isFormLive()) { return false; }
		try { this._captureComposerEditor(); } catch (pError) { /* editor may be gone */ }
		const tmpText = String((this._composer && this._composer.text) || '').trim();
		const tmpFU = this._composer && this._composer.kind === 'FollowUp' && (this._composer.needBy || this._composer.waitingOn);
		return !!(tmpText || tmpFU);
	}

	/** Scroll the call-activity composer into view (when the user chooses to stay and finish a note). */
	_scrollToComposer()
	{
		const tmpEl = (typeof document !== 'undefined') && document.getElementById('Support-Composer');
		if (tmpEl && tmpEl.scrollIntoView) { try { tmpEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (pError) { /* */ } }
	}

	_formActionsHTML()
	{
		const tmpState = this.state;
		const tmpSaving = tmpState.Saving;
		return `<button class="sup-btn sup-btn-primary" ${tmpSaving ? 'disabled' : ''} onclick="_Pict.providers.Support.save(); return false;">`
			+ `${tmpSaving ? '<i class="fas fa-spinner fa-spin"></i> Saving…' : '<i class="fas fa-floppy-disk"></i> Save'}</button>`
			+ `<button class="sup-btn" onclick="_Pict.providers.Support.cancel(); return false;">Close</button>`;
	}

	_approvalHTML()
	{
		const tmpState = this.state;
		const tmpApproval = tmpState.Approval;
		const tmpStatus = (tmpApproval && tmpApproval.Status) || (tmpState.Active && tmpState.Active.Status) || ENTRY_STATUS;
		const tmpMeta = this._statusMeta(tmpStatus);
		let tmpActions = '';
		if (tmpApproval && tmpApproval.Actions && tmpApproval.Actions.length)
		{
			tmpActions = tmpApproval.Actions
				// Void (mark-as-spam) is a manager-only terminal action in the UI. The server workflow also gates it to
				// the Support lead / Admin, but the action bar otherwise renders every verb the server offers, so hide it
				// client-side from non-managers. (The seeded SupportCallWorkflow only ever offers it to the gated actors.)
				.filter((pAction) => (pAction !== 'Void') || this.canManage())
				.map((pAction) =>
				{
					const tmpA = ACTION_META[pAction] || { label: pAction, cls: 'sup-act-neutral', icon: 'fa-arrow-right' };
					return `<button class="sup-act ${tmpA.cls}" ${tmpState.Busy ? 'disabled' : ''} onclick="_Pict.providers.Support.performAction('${this._esc(pAction)}'); return false;">`
						+ `<i class="fas ${tmpA.icon}"></i> ${this._esc(tmpA.label)}</button>`;
				}).join('');
		}
		const tmpBusy = tmpState.Busy ? `<span class="sup-inline-busy"><i class="fas fa-spinner fa-spin"></i></span>` : '';
		// Managers can fold this ticket into another (duplicate / misfiled reply) — launches the merge wizard with this
		// call as the child. Hidden in create mode and once the call is itself voided.
		const tmpMergeBtn = (this.canManage() && tmpState.Active && tmpState.FormMode !== 'create' && tmpStatus !== 'Void')
			? `<button class="sup-act sup-act-neutral" ${tmpState.Busy ? 'disabled' : ''} onclick="_Pict.providers.Support.openMergeCurrent(); return false;"><i class="fas fa-code-merge"></i> Merge into another ticket…</button>`
			: '';
		// Collapsible "Status" section: thin header (title + live status badge + lock + chevron) over the action buttons.
		const tmpCollapsed = this.state.ApprovalCollapsed === true;
		return `<div class="sup-sec${tmpCollapsed ? ' sup-sec-collapsed' : ''}">`
			+ `<button type="button" class="sup-sec-head" onclick="_Pict.providers.Support.toggleApprovalCollapsed(); return false;">`
			+   `<span class="sup-sec-title">Status</span>`
			+   `<span class="sup-badge ${tmpMeta.cls}"><i class="fas ${tmpMeta.icon}"></i> ${tmpMeta.label}</span>`
			+   (tmpApproval && tmpApproval.Locked ? `<span class="sup-lock" title="Locked"><i class="fas fa-lock"></i></span>` : '')
			+   `<i class="fas fa-chevron-down sup-sec-chev"></i></button>`
			+ `<div class="sup-sec-body"><div class="sup-approval-actions">${tmpActions}${tmpMergeBtn}${tmpBusy}</div></div>`
			+ `</div>`;
	}
}

module.exports = SupportProvider;
module.exports.default_configuration = { ProviderIdentifier: 'Support' };

},{"../../../../lib/web/headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js":170,"pict-provider":845,"pict-section-markdowneditor":955}],1401:[function(require,module,exports){
'use strict';

const libPictProvider = require('pict-provider');
// Shared marked-based user-markdown renderer (HTML-escaped + safe URLs) — the same one the staff console + the rest of
// the app use, so a customer's case Details and the acknowledgement/resolution comments render fully (blockquotes,
// lists, links) instead of the old bold/italic/code-only subset.
const libUserMarkdown = require('../../../../lib/web/headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js');

// Customer-facing labels (a stable subset mirrored from the staff console; kept local so this read-only surface has no
// dependency on the console provider). The portal never shows internal-only fields (resolution notes, follow-ups, agent).
// The internal tiers (Acknowledged / Tier 1-3) are deliberately collapsed to a single caller-facing "In progress" —
// the portal never exposes the support team's triage/escalation level.
const STATUS_META =
{
	New:          { label: 'Open',        cls: 'spx-st-open', icon: 'fa-inbox' },
	Acknowledged: { label: 'In progress', cls: 'spx-st-prog', icon: 'fa-person-digging' },
	Tier1:        { label: 'In progress', cls: 'spx-st-prog', icon: 'fa-person-digging' },
	Tier2:        { label: 'In progress', cls: 'spx-st-prog', icon: 'fa-person-digging' },
	Tier3:        { label: 'In progress', cls: 'spx-st-prog', icon: 'fa-person-digging' },
	Resolved:     { label: 'Resolved',    cls: 'spx-st-done', icon: 'fa-circle-check' },
};
const OPEN_STATUSES = [ 'New', 'Acknowledged', 'Tier1', 'Tier2', 'Tier3' ];
const PRIORITY_META =
{
	Urgent: { label: 'Urgent', cls: 'spx-prio-urgent' },
	High:   { label: 'High',   cls: 'spx-prio-high' },
	Normal: { label: 'Normal', cls: 'spx-prio-normal' },
	Low:    { label: 'Low',    cls: 'spx-prio-low' },
};
const CATEGORY_LABELS =
{
	HowTo: 'How-to question', Bug: 'Something isn’t working', PasswordReset: 'Password reset',
	Access: 'Access / permissions', Data: 'Data question', Device: 'Device', Other: 'Other',
};
const APP_LABELS =
{
	Fieldbook: 'Fieldbook', Bridge: 'Bridge', Home: 'Home', LIMS: 'LIMS',
	Configuration: 'Configuration', Academy: 'Academy', Mobile: 'Mobile', Other: 'Other',
};
// The caller-facing comment kinds the portal surfaces (from Comment.Metadata.Kind). Internal notes / follow-ups / stage
// changes are NEVER shown here.
const CUSTOMER_COMM_KINDS = { Acknowledgement: { label: 'Acknowledged', icon: 'fa-paper-plane' }, Resolution: { label: 'Resolution', icon: 'fa-circle-check' } };
const PAGE_SIZE = 50;   // server-side page size; the portal pages through the customer's cases (Prev/Next)

/**
 * SupportPortalProvider — the read-only customer-facing open-cases dashboard (#/SupportPortal). It shows a customer's
 * own support calls (their organization's, or just the user's own, per config) with a curated, read-only set of fields
 * and the caller-facing updates (acknowledgement / resolution comments) — NO triage, NO create/edit, NO internal notes.
 *
 * Tenancy: support calls live in the central HeadLight queue (Document.IDCustomer = the support team, e.g. 1), NOT in
 * the tenant they concern — they are HeadLight cases ABOUT a customer, keyed to that customer by a `Customer`
 * DocumentPolyJoin. The plain Documents query is pinned by the server to Document.IDCustomer = the caller's customer,
 * which would hide every one of these from the very customer they are about, so this portal reads through the dedicated
 * `Document/Support/Cases/:Cap` endpoint. That endpoint reads at the repository level (outside the tenancy behavior) and
 * re-imposes scope itself: it returns only the SupportCall-archetype documents whose `Customer` polyjoin IDRemote equals
 * the caller's OWN customer, so a customer only ever sees calls about their own organization. The curated view is
 * configured by `SupportPortal/CustomerView` (Global⊕Customer cascade). See [[config-app-support-portal]].
 */
class SupportPortalProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._mount = '#SupportPortal-Host';
		this._loaded = false;
		this._loadGen = 0;
		this._config = null;                // { Scope:'customer'|'own', ShowResolution, ShowComms }
	}

	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get permissions() { return this.pict.fable.EffectivePermissionsService; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	get idCustomer() { return Number((this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.CustomerID) || 0); }
	get idUser() { return Number((this.pict.AppData && this.pict.AppData.CurrentUser && this.pict.AppData.CurrentUser.UserID) || 0); }

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pErr, pBody) => (pErr ? reject(pErr) : resolve(pBody)))); }
	_toast(pMessage, pType) { if (this.modal && (typeof this.modal.toast === 'function')) { this.modal.toast(pMessage, { type: pType || 'info' }); } }
	_esc(pValue) { return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar])); }

	/** Anyone with a support view/agent/manage grant (or a super-user) can see the portal. */
	canView()
	{
		const tmpPermissions = this.permissions;
		if (!tmpPermissions || (typeof tmpPermissions.canHash !== 'function') || !tmpPermissions.currentUserReady()) { return true; }
		return tmpPermissions.canHash('Support-View') || tmpPermissions.canHash('Support-Agent') || tmpPermissions.canHash('Support-Manage');
	}

	get state()
	{
		if (!this.pict.AppData.SupportPortal)
		{
			this.pict.AppData.SupportPortal = { Loading: true, Error: '', Calls: [], Total: 0, Page: 0, Filter: 'open', Search: '', ViewMode: 'list', Active: null, Comms: { loading: false, items: [] } };
		}
		return this.pict.AppData.SupportPortal;
	}

	_date(pValue)
	{
		const tmpS = String(pValue == null ? '' : pValue);
		if (!tmpS || tmpS.indexOf('0000-00-00') === 0) { return '—'; }
		const tmpDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(tmpS);
		const tmpD = tmpDateOnly ? new Date(Number(tmpDateOnly[1]), Number(tmpDateOnly[2]) - 1, Number(tmpDateOnly[3])) : new Date(tmpS);
		return Number.isNaN(tmpD.getTime()) ? tmpS : tmpD.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
	}
	_dateTime(pValue)
	{
		const tmpS = String(pValue || ''); if (!tmpS) { return ''; }
		const tmpD = new Date(tmpS); if (Number.isNaN(tmpD.getTime())) { return tmpS; }
		return tmpD.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' · ' + tmpD.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
	}
	_statusMeta(pStatus) { return STATUS_META[pStatus] || { label: pStatus || 'Open', cls: 'spx-st-open', icon: 'fa-circle' }; }
	_prioMeta(pPriority) { return PRIORITY_META[pPriority] || null; }

	async loadAsync()
	{
		if (!this.canView()) { this._paint(); return; }
		const tmpGen = ++this._loadGen;
		this.state.Loading = true; this.state.Error = '';
		this._paint();
		try
		{
			await this._loadConfigAsync();
			if (tmpGen !== this._loadGen) { return; }
			await this._loadCallsAsync();
			if (tmpGen !== this._loadGen) { return; }
			this.state.Loading = false;
			this._loaded = true;
		}
		catch (pError)
		{
			if (tmpGen !== this._loadGen) { return; }
			this.state.Loading = false;
			this.state.Error = (pError && pError.message) ? pError.message : String(pError);
		}
		this._paint();
	}

	async _loadConfigAsync()
	{
		let tmpView = null;
		try
		{
			const tmpBlob = await this._getJSON(`Configuration/For/SupportPortal/In/Customer/${this.idCustomer}`);
			if (tmpBlob && tmpBlob.CustomerView && typeof tmpBlob.CustomerView === 'object') { tmpView = tmpBlob.CustomerView; }
		}
		catch (pError) { /* defaults below */ }
		this._config = Object.assign({ Scope: 'customer', ShowResolution: true, ShowComms: true }, tmpView || {});
	}

	async _loadCallsAsync()
	{
		// Support calls sit in the central HeadLight queue, keyed to the customer they are ABOUT by a `Customer`
		// DocumentPolyJoin, so the plain tenancy-scoped Documents query cannot see them (see class header). The
		// Document/Support/Cases endpoint reads them by the SupportCall archetype and scopes to the caller's own
		// customer via that polyjoin. Returns Documents newest-first with FormData already parsed.
		// Server-side pagination: the endpoint returns { Records, Total } for the requested page + filters. Open/All
		// (status), search (title/#), and the 'own' scope are all applied server-side so paging is correct across the
		// customer's whole case set, not just a loaded slice.
		const tmpBegin = (this.state.Page || 0) * PAGE_SIZE;
		const tmpStatus = (this.state.Filter === 'all') ? 'all' : 'open';
		const tmpOwn = (this._config && this._config.Scope === 'own') ? '1' : '0';
		const tmpQ = String(this.state.Search || '').trim();
		const tmpURL = `Document/Support/Cases/${tmpBegin}/${PAGE_SIZE}?status=${tmpStatus}&own=${tmpOwn}`
			+ (tmpQ ? `&q=${encodeURIComponent(tmpQ)}` : '');
		const tmpBody = await this._getJSON(tmpURL);
		const tmpRecords = (tmpBody && Array.isArray(tmpBody.Records)) ? tmpBody.Records : (Array.isArray(tmpBody) ? tmpBody : []);
		// Never show a voided (spam) call to the customer. The server already excludes Void from the `open` set, but the
		// `all` view would return it, and the portal's unknown-status fallback would mislabel it 'Open' — so drop it here
		// and keep the page total self-consistent with what is rendered.
		const tmpVisible = tmpRecords.filter((pDoc) => String(pDoc && pDoc.Status) !== 'Void');
		const tmpDropped = tmpRecords.length - tmpVisible.length;
		this.state.Total = (tmpBody && typeof tmpBody.Total === 'number') ? Math.max(0, tmpBody.Total - tmpDropped) : tmpVisible.length;
		this.state.Calls = tmpVisible.map((pDoc) => this._summary(pDoc));
	}

	/** Reload the current page after a filter / search / page change. pFull repaints the whole shell (a deliberate
	 *  click — e.g. the Open/All toggle); otherwise only the list repaints, so a focused search box keeps its caret. */
	async _reloadAsync(pFull)
	{
		const tmpGen = ++this._loadGen;
		this.state.Loading = true;
		if (pFull) { this._paint(); } else { this._paintList(); }
		try
		{
			await this._loadCallsAsync();
			if (tmpGen !== this._loadGen) { return; }
			this.state.Loading = false;
		}
		catch (pError)
		{
			if (tmpGen !== this._loadGen) { return; }
			this.state.Loading = false;
			this.state.Error = (pError && pError.message) ? pError.message : String(pError);
		}
		this._paintList();
	}

	_summary(pDoc)
	{
		let tmpForm = pDoc.FormData;
		if (typeof tmpForm === 'string') { try { tmpForm = JSON.parse(tmpForm); } catch (pError) { tmpForm = {}; } }
		tmpForm = tmpForm || {};
		const tmpIssue = tmpForm.Issue || {};
		const tmpStatus = STATUS_META[pDoc.Status] ? pDoc.Status : 'New';
		return {
			IDDocument: Number(pDoc.IDDocument),
			Status: tmpStatus,
			Summary: tmpIssue.Summary || pDoc.Name || '(no summary)',
			Details: tmpIssue.Details || '',
			Category: tmpIssue.Category || '',
			Priority: tmpIssue.Priority || '',
			App: tmpIssue.App || '',
			Created: pDoc.CreateDate || '',
			Updated: pDoc.UpdateDate || pDoc.CreateDate || '',
		};
	}

	/** The current page's rows come straight from the server — filter, search, and paging are all server-side now. */
	_visibleCalls() { return this.state.Calls; }

	/** Prev/Next pager + "Showing X–Y of N" for the active filter/search; hidden when everything fits on one page. */
	_paginationHTML()
	{
		const tmpTotal = this.state.Total || 0;
		if (tmpTotal <= PAGE_SIZE) { return ''; }
		const tmpPages = Math.max(1, Math.ceil(tmpTotal / PAGE_SIZE));
		const tmpPage = this.state.Page || 0;
		const tmpStart = tmpPage * PAGE_SIZE + 1;
		const tmpEnd = Math.min(tmpTotal, (tmpPage + 1) * PAGE_SIZE);
		return `<div class="spx-pager">`
			+ `<button class="spx-pg" ${tmpPage <= 0 ? 'disabled' : ''} onclick="_Pict.providers.SupportPortal.setPage(${tmpPage - 1}); return false;"><i class="fas fa-chevron-left"></i> Prev</button>`
			+ `<span class="spx-pg-info">Showing <b>${tmpStart.toLocaleString()}–${tmpEnd.toLocaleString()}</b> of <b>${tmpTotal.toLocaleString()}</b></span>`
			+ `<button class="spx-pg" ${tmpPage >= (tmpPages - 1) ? 'disabled' : ''} onclick="_Pict.providers.SupportPortal.setPage(${tmpPage + 1}); return false;">Next <i class="fas fa-chevron-right"></i></button>`
			+ `</div>`;
	}

	setFilter(pFilter)
	{
		const tmpF = (pFilter === 'all') ? 'all' : 'open';
		if (tmpF === this.state.Filter) { return; }
		this.state.Filter = tmpF; this.state.Page = 0;
		this._reloadAsync(true);   // full repaint: updates the active toggle; it's a click, so there is no caret to preserve
	}
	onSearch(pValue)
	{
		this.state.Search = pValue || ''; this.state.Page = 0;
		if (this._searchTimer) { clearTimeout(this._searchTimer); }
		this._searchTimer = setTimeout(() => { this._searchTimer = null; this._reloadAsync(false); }, 300);   // list-only repaint keeps the search input focused
	}
	setPage(pPage)
	{
		const tmpMax = Math.max(0, Math.ceil((this.state.Total || 0) / PAGE_SIZE) - 1);
		const tmpP = Math.min(Math.max(0, Number(pPage) || 0), tmpMax);
		if (tmpP === (this.state.Page || 0)) { return; }
		this.state.Page = tmpP;
		this._reloadAsync(false);
	}

	// ── Read-only case detail ────────────────────────────────────────────────────────────────────────────────────

	async openCase(pIDDocument)
	{
		const tmpCall = this.state.Calls.find((pC) => pC.IDDocument === Number(pIDDocument));
		if (!tmpCall) { return; }
		this.state.Active = tmpCall;
		this.state.Comms = { loading: this._config && this._config.ShowComms, items: [] };
		this._paint();
		if (this._config && this._config.ShowComms) { this._loadCommsAsync(Number(pIDDocument)); }
	}

	backToList() { this.state.Active = null; this._paint(); }

	/** Load ONLY the caller-facing comments (acknowledgement / resolution) for the case — never internal notes. */
	async _loadCommsAsync(pIDDocument)
	{
		try
		{
			const tmpRows = await this._getJSON(`DocumentComments/FilteredTo/FBV~IDDocument~EQ~${pIDDocument}~FBV~Deleted~EQ~0/0/200`);
			if (!this.state.Active || this.state.Active.IDDocument !== pIDDocument) { return; }
			const tmpItems = [];
			(Array.isArray(tmpRows) ? tmpRows : []).forEach((pC) =>
			{
				let tmpMeta = {}; try { tmpMeta = pC.Metadata ? JSON.parse(pC.Metadata) : {}; } catch (pErr) { tmpMeta = {}; }
				if (!CUSTOMER_COMM_KINDS[tmpMeta.Kind]) { return; }   // caller-facing only
				tmpItems.push({ kind: tmpMeta.Kind, text: pC.Comment || '', at: pC.CreateDate || '' });
			});
			tmpItems.sort((pA, pB) => String(pB.at).localeCompare(String(pA.at)));
			this.state.Comms = { loading: false, items: tmpItems };
		}
		catch (pError) { this.state.Comms = { loading: false, items: [] }; }
		this._paintDetail();
	}

	// ── Render ───────────────────────────────────────────────────────────────────────────────────────────────────

	_paint() { const tmpCA = this.pict.ContentAssignment; if (tmpCA && tmpCA.getElement(this._mount).length) { tmpCA.assignContent(this._mount, this._shellHTML()); } }
	_paintList() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#SupportPortal-List').length) { tmpCA.assignContent('#SupportPortal-List', this._listHTML()); } }
	_paintDetail() { const tmpCA = this.pict.ContentAssignment; if (tmpCA.getElement('#SupportPortal-Detail').length) { tmpCA.assignContent('#SupportPortal-Detail', this._detailHTML()); } }

	_shellHTML()
	{
		if (!this.canView()) { return `<div class="spx-note"><i class="fas fa-lock"></i> You don’t have access to the support portal.</div>`; }
		if (this.state.Active) { return `<div id="SupportPortal-Detail">${this._detailHTML()}</div>`; }
		return `<div class="spx-toolbar">`
			+ `<div class="spx-seg">`
			+ `<button class="spx-seg-b ${this.state.Filter === 'open' ? 'spx-seg-on' : ''}" onclick="_Pict.providers.SupportPortal.setFilter('open'); return false;">Open</button>`
			+ `<button class="spx-seg-b ${this.state.Filter === 'all' ? 'spx-seg-on' : ''}" onclick="_Pict.providers.SupportPortal.setFilter('all'); return false;">All</button>`
			+ `</div>`
			+ `<div class="spx-toolbar-right">`
			+ `<div class="spx-search"><i class="fas fa-magnifying-glass"></i><input type="text" placeholder="Search your cases…" value="${this._esc(this.state.Search)}" oninput="_Pict.providers.SupportPortal.onSearch(this.value)" /></div>`
			+ `<div class="spx-viewtoggle">`
			+ `<button class="spx-vt-b ${this.state.ViewMode !== 'cards' ? 'spx-vt-on' : ''}" title="List view" onclick="_Pict.providers.SupportPortal.setViewMode('list'); return false;"><i class="fas fa-list-ul"></i></button>`
			+ `<button class="spx-vt-b ${this.state.ViewMode === 'cards' ? 'spx-vt-on' : ''}" title="Card view" onclick="_Pict.providers.SupportPortal.setViewMode('cards'); return false;"><i class="fas fa-table-cells-large"></i></button>`
			+ `</div>`
			+ `</div>`
			+ `</div>`
			+ (this.state.Error ? `<div class="spx-note spx-note-error"><i class="fas fa-triangle-exclamation"></i> ${this._esc(this.state.Error)}</div>` : '')
			+ `<div id="SupportPortal-List">${this._listHTML()}</div>`;
	}

	_listHTML()
	{
		if (this.state.Loading) { return `<div class="spx-note"><i class="fas fa-spinner fa-spin"></i> Loading your support cases…</div>`; }
		const tmpRows = this.state.Calls;
		if (!tmpRows.length)
		{
			const tmpFiltered = !!String(this.state.Search || '').trim() || this.state.Filter === 'open';
			const tmpMsg = tmpFiltered ? 'No cases match.' : 'No support cases on file for your organization yet.';
			return `<div class="spx-empty"><i class="fas fa-inbox"></i> ${tmpMsg}</div>`;
		}
		const tmpBody = (this.state.ViewMode === 'cards')
			? `<div class="spx-cards">` + tmpRows.map((pCall) => this._cardHTML(pCall)).join('') + `</div>`
			: `<div class="spx-list">` + tmpRows.map((pCall) => this._rowHTML(pCall)).join('') + `</div>`;
		return tmpBody + this._paginationHTML();
	}

	setViewMode(pMode) { this.state.ViewMode = (pMode === 'cards') ? 'cards' : 'list'; this._paint(); }

	/** A compact list row (the default view). */
	_rowHTML(pCall)
	{
		const tmpStatus = this._statusMeta(pCall.Status);
		const tmpPrio = this._prioMeta(pCall.Priority);
		const tmpTags = [];
		if (pCall.Category) { tmpTags.push(`<span class="spx-tag">${this._esc(CATEGORY_LABELS[pCall.Category] || pCall.Category)}</span>`); }
		if (pCall.App) { tmpTags.push(`<span class="spx-tag spx-tag-app">${this._esc(APP_LABELS[pCall.App] || pCall.App)}</span>`); }
		if (tmpPrio) { tmpTags.push(`<span class="spx-prio ${tmpPrio.cls}">${this._esc(tmpPrio.label)}</span>`); }
		return `<button class="spx-row" onclick="_Pict.providers.SupportPortal.openCase(${pCall.IDDocument}); return false;">`
			+ `<span class="spx-row-badge ${tmpStatus.cls}"><i class="fas ${tmpStatus.icon}"></i> ${tmpStatus.label}</span>`
			+ `<span class="spx-row-main"><span class="spx-row-sum">${this._esc(pCall.Summary)}</span>`
			+ (tmpTags.length ? `<span class="spx-row-tags">${tmpTags.join('')}</span>` : '')
			+ `</span>`
			+ `<span class="spx-row-updated"><i class="fas fa-clock"></i> ${this._date(pCall.Updated)}</span>`
			+ `<span class="spx-row-id">#${pCall.IDDocument}</span>`
			+ `<i class="fas fa-chevron-right spx-row-chev"></i>`
			+ `</button>`;
	}

	_cardHTML(pCall)
	{
		const tmpStatus = this._statusMeta(pCall.Status);
		const tmpPrio = this._prioMeta(pCall.Priority);
		const tmpTags = [];
		if (pCall.Category) { tmpTags.push(`<span class="spx-tag">${this._esc(CATEGORY_LABELS[pCall.Category] || pCall.Category)}</span>`); }
		if (pCall.App) { tmpTags.push(`<span class="spx-tag spx-tag-app">${this._esc(APP_LABELS[pCall.App] || pCall.App)}</span>`); }
		if (tmpPrio) { tmpTags.push(`<span class="spx-prio ${tmpPrio.cls}">${this._esc(tmpPrio.label)}</span>`); }
		return `<button class="spx-card" onclick="_Pict.providers.SupportPortal.openCase(${pCall.IDDocument}); return false;">`
			+ `<div class="spx-card-top"><span class="spx-badge ${tmpStatus.cls}"><i class="fas ${tmpStatus.icon}"></i> ${tmpStatus.label}</span><span class="spx-card-id">#${pCall.IDDocument}</span></div>`
			+ `<div class="spx-card-sum">${this._esc(pCall.Summary)}</div>`
			+ `<div class="spx-card-tags">${tmpTags.join('')}</div>`
			+ `<div class="spx-card-foot"><i class="fas fa-clock"></i> Updated ${this._date(pCall.Updated)}</div>`
			+ `</button>`;
	}

	_detailHTML()
	{
		const tmpCall = this.state.Active;
		if (!tmpCall) { return ''; }
		const tmpStatus = this._statusMeta(tmpCall.Status);
		const tmpPrio = this._prioMeta(tmpCall.Priority);
		const tmpMeta = [];
		tmpMeta.push(`<div class="spx-meta"><span class="spx-meta-l">Status</span><span class="spx-badge ${tmpStatus.cls}"><i class="fas ${tmpStatus.icon}"></i> ${tmpStatus.label}</span></div>`);
		if (tmpCall.Category) { tmpMeta.push(`<div class="spx-meta"><span class="spx-meta-l">Category</span><span class="spx-tag">${this._esc(CATEGORY_LABELS[tmpCall.Category] || tmpCall.Category)}</span></div>`); }
		if (tmpCall.App) { tmpMeta.push(`<div class="spx-meta"><span class="spx-meta-l">Application</span><span class="spx-tag spx-tag-app">${this._esc(APP_LABELS[tmpCall.App] || tmpCall.App)}</span></div>`); }
		if (tmpPrio) { tmpMeta.push(`<div class="spx-meta"><span class="spx-meta-l">Priority</span><span class="spx-prio ${tmpPrio.cls}">${this._esc(tmpPrio.label)}</span></div>`); }
		tmpMeta.push(`<div class="spx-meta"><span class="spx-meta-l">Opened</span><span>${this._date(tmpCall.Created)}</span></div>`);
		tmpMeta.push(`<div class="spx-meta"><span class="spx-meta-l">Updated</span><span>${this._date(tmpCall.Updated)}</span></div>`);

		const tmpDetails = tmpCall.Details
			? `<div class="spx-det-card"><div class="spx-det-h">What you told us</div><div class="spx-det-body">${this._renderMarkdownSafe(tmpCall.Details)}</div></div>`
			: '';
		const tmpUpdates = (this._config && this._config.ShowComms) ? this._commsHTML() : '';

		return `<a class="spx-back" onclick="_Pict.providers.SupportPortal.backToList(); return false;"><i class="fas fa-arrow-left"></i> All cases</a>`
			+ `<div class="spx-det-head"><span class="spx-card-id">#${tmpCall.IDDocument}</span><h2 class="spx-det-title">${this._esc(tmpCall.Summary)}</h2></div>`
			+ `<div class="spx-det-meta">${tmpMeta.join('')}</div>`
			+ tmpDetails
			+ tmpUpdates;
	}

	_commsHTML()
	{
		const tmpC = this.state.Comms || { loading: false, items: [] };
		let tmpBody;
		if (tmpC.loading) { tmpBody = `<div class="spx-note"><i class="fas fa-spinner fa-spin"></i> Loading updates…</div>`; }
		else if (!tmpC.items.length) { tmpBody = `<div class="spx-empty spx-empty-sm">No updates from the support team yet.</div>`; }
		else
		{
			tmpBody = tmpC.items.map((pIt) =>
			{
				const tmpKind = CUSTOMER_COMM_KINDS[pIt.kind] || { label: 'Update', icon: 'fa-comment' };
				return `<div class="spx-update"><span class="spx-update-icon spx-uk-${pIt.kind === 'Resolution' ? 'res' : 'ack'}"><i class="fas ${tmpKind.icon}"></i></span>`
					+ `<div class="spx-update-body"><div class="spx-update-head"><b>${tmpKind.label}</b><span class="spx-update-when">${this._dateTime(pIt.at)}</span></div>`
					+ `<div class="spx-update-text">${this._esc(pIt.text)}</div></div></div>`;
			}).join('');
		}
		return `<div class="spx-det-card"><div class="spx-det-h"><i class="fas fa-comments"></i> Updates from support</div><div class="spx-updates">${tmpBody}</div></div>`;
	}

	/** Minimal, safe markdown → HTML for the caller's own details (escape first, then a few inline/blocky bits). */
	_renderMarkdownSafe(pText)
	{
		const tmpSource = String(pText == null ? '' : pText);
		if (!tmpSource.trim()) { return ''; }
		try { return libUserMarkdown.renderUserMarkdown(tmpSource); }
		catch (pError) { return `<p>${this._esc(tmpSource)}</p>`; }
	}
}

module.exports = SupportPortalProvider;
module.exports.default_configuration = { ProviderIdentifier: 'SupportPortal' };

},{"../../../../lib/web/headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js":170,"pict-provider":845}],1402:[function(require,module,exports){
'use strict';

/**
 * UserRoleMembershipFilter — makes the Users list "Role" filter find every user who holds a selected role,
 * however that role is assigned. A role assignment can live in THREE disconnected places:
 *   - User.IDRole            — the base user level (Field Personnel / Office Staff / Office Manager / …)
 *   - UserRoleJoin.IDRole    — customer-level named-role grants (where e.g. "Lab Technician" lives)
 *   - UserContextRole.IDRole — project/lab-level role grants
 *
 * The filter UI is the stock external-join Role picker (declared on the User recordset's FieldFilterClauses,
 * marked `RoleMembershipUnion`). The stock filter resolution reaches only ONE join table, and the config-app
 * Meadow does NOT honor parenthesized OR groups (see AccessWorkspace-Provider note) — so a base-column OR an
 * external-join can't be expressed as one clause. Instead this patch intercepts the User record provider: when
 * the membership clause carries selected roles, it resolves the UNION of user ids across all three sources and
 * swaps the clause for a single `FBL~IDUser~INN~<union>` (which the FilterManager POSTs to `/Query`, so a large
 * membership rides the request body, not the URL). Resolution is cached per role-selection and pre-computed in
 * getRecords/getRecordSetCount (both async) before the synchronous clause swap in _prepareFilterState. If
 * resolution ever fails the clause is left untouched, degrading to the stock UserRoleJoin-only filter.
 */

const PAGE = 2000;
const MAX_MEMBERS = 50000;

/**
 * Patch the User recordset provider (idempotent) so the RoleMembershipUnion clause resolves the full union.
 * @param {any} pPict
 */
function patchUserRoleMembershipFilter(pPict, pAttempt)
{
	const tmpProvider = pPict.providers && pPict.providers['RSP-Provider-User'];
	if (!tmpProvider)
	{
		// The User recordset provider is created lazily (first list view). Retry briefly so the patch is in
		// place before the user opens the Users list; give up quietly after a few seconds.
		const tmpAttempt = Number(pAttempt) || 0;
		if (tmpAttempt < 40 && (typeof setTimeout === 'function'))
		{
			setTimeout(() => patchUserRoleMembershipFilter(pPict, tmpAttempt + 1), 500);
		}
		return;
	}
	if (tmpProvider._roleMembershipPatched) { return; }
	tmpProvider._roleMembershipPatched = true;
	tmpProvider._roleUnionCache = { Key: '__init__', Filter: '' };

	const fGetJSON = (pURL) =>
		new Promise((resolve) =>
		{
			const tmpRC = (pPict.fable && pPict.fable.HeadlightRestClient) || pPict.HeadlightRestClient;
			if (!tmpRC) { return resolve(null); }
			tmpRC.getJSON(pURL, (pError, pBody) => resolve(pError ? null : pBody));
		});

	// The membership clause currently in the User list's active filter state (marker-identified), if any.
	const fActiveClause = () =>
	{
		const tmpState = pPict.Bundle && pPict.Bundle._ActiveFilterState && pPict.Bundle._ActiveFilterState.User;
		const tmpClauses = (tmpState && Array.isArray(tmpState.FilterClauses)) ? tmpState.FilterClauses : [];
		return tmpClauses.find((pClause) => pClause && pClause.RoleMembershipUnion) || null;
	};
	const fRoleIDs = (pClause) => Array.from(new Set(((pClause && pClause.Values) || []).map(Number).filter((pID) => pID > 0))).sort((pA, pB) => pA - pB);

	// Distinct IDUsers from a join set (UserRoleJoin / UserContextRole) whose IDRole is one of the picks.
	const fJoinUsers = async (pSet, pRoleIDs, pInto) =>
	{
		const tmpFilter = `FBL~IDRole~INN~${pRoleIDs.join(',')}`;
		const tmpCount = await fGetJSON(`${pSet}/Count/FilteredTo/${tmpFilter}`);
		const tmpTotal = Math.min((tmpCount && (tmpCount.Count != null)) ? Number(tmpCount.Count) : MAX_MEMBERS, MAX_MEMBERS);
		for (let tmpStart = 0; tmpStart < tmpTotal; tmpStart += PAGE)
		{
			/* eslint-disable-next-line no-await-in-loop */
			const tmpRows = await fGetJSON(`${pSet}/FilteredTo/${tmpFilter}/${tmpStart}/${PAGE}`);
			if (!Array.isArray(tmpRows) || tmpRows.length === 0) { break; }
			tmpRows.forEach((pRow) => { const tmpID = Number(pRow.IDUser); if (tmpID > 0) { pInto.add(tmpID); } });
			if (tmpRows.length < PAGE) { break; }
		}
	};

	// Base-level users: User.IDRole is one of the picks, scoped to the session customer (non-deleted).
	const fBaseUsers = async (pRoleIDs, pInto) =>
	{
		const tmpUser = pPict.AppData && pPict.AppData.CurrentUser;
		const tmpCID = tmpUser ? Number(tmpUser.CustomerID || tmpUser.IDCustomer) : 0;
		const tmpFilter = `FBL~IDRole~INN~${pRoleIDs.join(',')}${tmpCID ? `~FBV~IDCustomer~EQ~${tmpCID}` : ''}~FBV~Deleted~EQ~0`;
		const tmpCount = await fGetJSON(`Users/Count/FilteredTo/${tmpFilter}`);
		const tmpTotal = Math.min((tmpCount && (tmpCount.Count != null)) ? Number(tmpCount.Count) : MAX_MEMBERS, MAX_MEMBERS);
		for (let tmpStart = 0; tmpStart < tmpTotal; tmpStart += PAGE)
		{
			/* eslint-disable-next-line no-await-in-loop */
			const tmpRows = await fGetJSON(`Users/FilteredTo/${tmpFilter}/${tmpStart}/${PAGE}`);
			if (!Array.isArray(tmpRows) || tmpRows.length === 0) { break; }
			tmpRows.forEach((pRow) => { const tmpID = Number(pRow.IDUser); if (tmpID > 0) { pInto.add(tmpID); } });
			if (tmpRows.length < PAGE) { break; }
		}
	};

	/** Resolve + cache the union RawFilter for the current role selection (no-op if unchanged). */
	tmpProvider._ensureRoleUnionAsync = async function ()
	{
		const tmpRoleIDs = fRoleIDs(fActiveClause());
		const tmpKey = tmpRoleIDs.join(',');
		if (this._roleUnionCache.Key === tmpKey) { return; }
		if (tmpRoleIDs.length === 0) { this._roleUnionCache = { Key: tmpKey, Filter: '' }; return; }
		try
		{
			const tmpUsers = new Set();
			await Promise.all(
				[
					fJoinUsers('UserRoleJoins', tmpRoleIDs, tmpUsers),
					fJoinUsers('UserContextRoles', tmpRoleIDs, tmpUsers),
					fBaseUsers(tmpRoleIDs, tmpUsers),
				]);
			const tmpIDs = Array.from(tmpUsers);
			// Empty union → a filter that matches nothing (IDUser can never be 0), so the list shows 0 rather than all.
			this._roleUnionCache = { Key: tmpKey, Filter: tmpIDs.length ? `FBL~IDUser~INN~${tmpIDs.join(',')}` : 'FBV~IDUser~EQ~0', Count: tmpIDs.length };
		}
		catch (pError)
		{
			// Degrade: Filter=null → the swap is skipped and the stock UserRoleJoin filter applies (still fixes the reported case).
			this._roleUnionCache = { Key: tmpKey, Filter: null };
			this.pict.log.warn(`UserRoleMembershipFilter: union resolution failed, using stock filter: ${pError && (pError.message || pError)}`);
		}
	};

	// Pre-resolve the union before the (synchronous) _prepareFilterState swap — for BOTH the records + count fetches.
	const fWrapAsync = (pName) =>
	{
		const tmpOriginal = tmpProvider[pName].bind(tmpProvider);
		tmpProvider[pName] = async function (pOptions)
		{
			if (fActiveClause()) { await this._ensureRoleUnionAsync(); }
			return tmpOriginal(pOptions);
		};
	};
	fWrapAsync('getRecords');
	fWrapAsync('getRecordSetCount');

	// Swap the membership clause for the resolved union RawFilter in the clause list handed to the FilterManager.
	// _prepareFilterState builds a fresh array (concat), so splicing it never mutates the global filter state.
	const tmpOrigPrepare = tmpProvider._prepareFilterState.bind(tmpProvider);
	tmpProvider._prepareFilterState = function (pEntity, pOptions, pResultAddress)
	{
		const tmpResult = tmpOrigPrepare(pEntity, pOptions, pResultAddress);
		try
		{
			const tmpClauses = tmpResult && tmpResult[0];
			if (!Array.isArray(tmpClauses)) { return tmpResult; }
			const tmpIdx = tmpClauses.findIndex((pClause) => pClause && pClause.RoleMembershipUnion);
			if (tmpIdx < 0) { return tmpResult; }
			const tmpKey = fRoleIDs(tmpClauses[tmpIdx]).join(',');
			const tmpCache = this._roleUnionCache;
			if (tmpCache && (tmpCache.Key === tmpKey) && (typeof tmpCache.Filter === 'string'))
			{
				if (tmpCache.Filter === '') { tmpClauses.splice(tmpIdx, 1); }               // no roles picked → no filtering
				else { tmpClauses.splice(tmpIdx, 1, { Type: 'RawFilter', Value: tmpCache.Filter }); }
			}
		}
		catch (pError) { /* leave the stock clause in place (degrade) */ }
		return tmpResult;
	};
}

module.exports = { patchUserRoleMembershipFilter };

},{}],1403:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * ATMDashboardConfig view — the shell for the bespoke #/ATMDashboardConfig screen. A thin host: it paints the
 * header + a single #ATM-Detail mount and hands rendering to the ATMDashboardConfig provider (which self-loads on
 * first render, mirroring Certifications / Entitlements).
 */
class ATMDashboardConfig extends libPictView
{
	get provider() { return this.pict.providers.ATMDashboardConfig; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ATMDashboardConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'ATMDashboardConfig',
	DefaultRenderable: 'ATMDashboardConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.atm-wrap { padding: 1.25rem 1.5rem 2rem; }
		.atm-head { margin: 0 0 1rem; }
		.atm-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.atm-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.atm-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:20rem; }
		.atm-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:14rem; color:var(--theme-color-text-muted,#6b7686); }
		.atm-scopebar { display:flex; align-items:center; gap:0.5rem; margin:0 0 0.5rem; }
		.atm-scope-label { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin-right:0.3rem; }
		.atm-scope-btn { font-size:0.84rem; font-weight:600; padding:0.35rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.atm-scope-btn.is-active { background:var(--theme-color-brand-primary,#2e7d74); border-color:var(--theme-color-brand-primary,#2e7d74); color:#fff; }
		.atm-project { position:relative; margin:0 0 0.9rem; max-width:32rem; }
		.atm-project-input { width:100%; box-sizing:border-box; font-size:0.88rem; padding:0.45rem 0.65rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.atm-project-current { display:inline-block; font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); margin-top:0.35rem; }
		.atm-project-results { position:relative; }
		.atm-project-item { padding:0.4rem 0.6rem; border:1px solid var(--theme-color-border-light,#eef1f6); border-top:none; font-size:0.86rem; color:var(--theme-color-text-secondary,#45505f); cursor:pointer; display:flex; justify-content:space-between; gap:0.6rem; }
		.atm-project-item:first-child { border-top:1px solid var(--theme-color-border-light,#eef1f6); margin-top:0.3rem; }
		.atm-project-item:hover { background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
		.atm-project-sub { color:var(--theme-color-text-muted,#8894a4); font-size:0.78rem; }
		.atm-project-empty { font-size:0.82rem; color:var(--theme-color-text-muted,#8894a4); padding:0.35rem 0.6rem; }
		.atm-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0.3rem 0 0.9rem; }
		.atm-tab { font-size:0.88rem; font-weight:600; padding:0.45rem 0.95rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.atm-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.atm-tab.is-active { color:var(--theme-color-primary,#2f6fed); border-bottom-color:var(--theme-color-primary,#2f6fed); }
		.atm-note { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.9rem; }
		.atm-note-warn { color:#8a6d1b; background:var(--theme-color-status-warning-bg,#fbf3d9); border-radius:6px; padding:0.5rem 0.7rem; }
		.atm-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.8rem; }
		.atm-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.8rem; }
		.atm-area { margin:0 0 1.2rem; }
		.atm-area-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0 0 0.3rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0 0 0.5rem; }
		.atm-row { display:flex; align-items:flex-start; gap:1rem; padding:0.5rem 0.15rem; border-bottom:1px solid var(--theme-color-border-light,#f2f4f8); }
		.atm-row-main { flex:1 1 auto; min-width:0; }
		.atm-row-label { font-size:0.92rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.atm-row-desc { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.1rem; }
		.atm-subfield { margin-top:0.45rem; display:flex; align-items:center; gap:0.5rem; }
		.atm-sublabel { font-size:0.78rem; color:var(--theme-color-text-secondary,#45505f); }
		.atm-select { font-size:0.84rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.atm-field { margin:0 0 0.7rem; }
		.atm-field-label { display:block; font-size:0.8rem; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.25rem; }
		.atm-input { width:100%; max-width:32rem; box-sizing:border-box; font-size:0.88rem; padding:0.42rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.atm-textarea { width:100%; max-width:32rem; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); resize:vertical; }
		.atm-col { display:flex; align-items:center; gap:1rem; padding:0.32rem 0.15rem; border-bottom:1px solid var(--theme-color-border-light,#f2f4f8); }
		.atm-col-main { flex:1 1 auto; min-width:0; display:flex; align-items:center; gap:0.8rem; }
		.atm-col-name { flex:0 0 13rem; font-size:0.86rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.atm-col-label { flex:1 1 auto; min-width:0; font-size:0.82rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-input,#fff); }
		.atm-col-show { flex:0 0 auto; display:flex; align-items:center; gap:0.4rem; font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); }
		.atm-switch { flex:0 0 auto; width:2.5rem; height:1.4rem; border-radius:999px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-tertiary,#eef1f6); cursor:pointer; position:relative; transition:background 0.12s; }
		.atm-switch-dot { position:absolute; top:0.12rem; left:0.14rem; width:1rem; height:1rem; border-radius:50%; background:#fff; box-shadow:0 1px 2px rgba(0,0,0,0.25); transition:left 0.12s; }
		.atm-switch.is-on { background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.atm-switch.is-on .atm-switch-dot { left:1.22rem; }
		.atm-switch[disabled] { opacity:0.5; cursor:default; }
		.atm-savebar { margin-top:1rem; }
		.atm-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#2e7d74); background:var(--theme-color-brand-primary,#2e7d74); color:#fff; cursor:pointer; }
		.atm-save[disabled] { opacity:0.6; cursor:default; }
	`,
	Templates:
	[
		{
			Hash: 'ATMDashboardConfig-Wrap',
			Template: /*html*/`
				<div class="atm-wrap">
					<div class="atm-head">
						<h1 class="atm-title">Audit of Testing &amp; Materials — Dashboard Configuration</h1>
						<p class="atm-subtitle">Tune the Sample Plan Checklist dashboard: which conformance checks run and the pass/fail vocabulary (Validation rules), and which columns the checklist shows (Display columns). Set a customer-wide default, or override it for one project.</p>
					</div>
					<div id="ATM-Detail" class="atm-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ATMDashboardConfigWrap',
			TemplateHash: 'ATMDashboardConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1404:[function(require,module,exports){

const libPictView = require('pict-view');
const libTabBar = require('./TabBar.js');

/**
 * Access & Permissions workspace.
 *
 * A single cohesive screen for the rich RBAC layer (Roles, Permission Groups, Users) that replaces the raw
 * Role / RolePermission / RoleEdge / UserRoleJoin recordset lists. A rail of subjects on the left, a
 * workspace-global context bar up top, and a tabbed editor on the right. Thin view: all behavior + state live
 * in the AccessWorkspace provider; this derives + repaints declaratively (the MasterListManager idiom).
 *
 * Phase 0 ships the shell + the Details tab; the Permissions matrix, Effective visualizer, Composition,
 * Members, assignment and overrides tabs are filled by later phases.
 */
class AccessWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.AccessWorkspace;
	}

	deriveRenderState()
	{
		if (this.provider)
		{
			this.provider.deriveRenderState();
		}
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		// A full re-render destroys + recreates the live-filter inputs (rail + matrix), dropping focus.
		// Remember the focused input (by id) + caret here so onAfterRender can restore it (see below).
		this._focusMemo = null;
		try
		{
			if (typeof document !== 'undefined' && document.activeElement)
			{
				const tmpActive = document.activeElement;
				if (tmpActive.id && (tmpActive.tagName === 'INPUT' || tmpActive.tagName === 'TEXTAREA'))
				{
					this._focusMemo = { id: tmpActive.id, start: tmpActive.selectionStart, end: tmpActive.selectionEnd };
				}
			}
		}
		catch (pError)
		{
			this._focusMemo = null;
		}
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		libTabBar.layout(document);
		// Restore focus + caret to the input that had it before this re-render, so typing in a live filter
		// stays fluid.
		try
		{
			if (this._focusMemo && typeof document !== 'undefined')
			{
				const tmpInput = document.getElementById(this._focusMemo.id);
				if (tmpInput)
				{
					tmpInput.focus();
					if (this._focusMemo.start !== null && this._focusMemo.start !== undefined && tmpInput.setSelectionRange)
					{
						try
						{
							tmpInput.setSelectionRange(this._focusMemo.start, this._focusMemo.end);
						}
						catch (pCaretError)
						{/* some input types don't support selection range */}
					}
				}
			}
		}
		catch (pError)
		{
			// non-fatal: focus restoration is a nicety
		}
		// Mount the "add users" multi-pickers (no-ops unless their mount is in the DOM): the Members tab's and the
		// Details (View/Create Role) form's.
		if (this.pict.providers.GroupComposition) { this.pict.providers.GroupComposition.mountAddMembersPicker(); }
		if (this.pict.providers.UserGroupGrants) { this.pict.providers.UserGroupGrants.renderGrantsHost(); }
		if (this.pict.providers.AccessWorkspace) { this.pict.providers.AccessWorkspace.mountDetailsAddMembersPicker(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = AccessWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'AccessWorkspace',
	DefaultRenderable: 'AccessWorkspace-Wrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		${ libTabBar.TABBAR_CSS }
		.acw-wrap { padding: 1.25rem 1.5rem 2rem; }
		.acw-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1rem; flex-wrap: wrap; }
		.acw-context { display: flex; align-items: center; }
		.acw-context .field { margin-bottom: 0; }
		.acw-context-label { display: inline-flex; align-items: center; height: 2.5em; padding: 0 0.6rem; font-size: 0.75rem; font-weight: 700;
			text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); background: var(--bulma-background, #f5f5f5); border-radius: 4px 0 0 4px; }
		.acw-rail { padding: 0.6rem; }
		.acw-search { margin-bottom: 0.6rem; }
		.acw-rail-group { margin-bottom: 0.75rem; }
		.acw-rail-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); padding: 0.35rem 0.4rem; display: flex; align-items: center; gap: 0.4rem; }
		.acw-rail-count { margin-left: auto; font-weight: 600; color: var(--bulma-text-weak, #9a9a9a); }
		.acw-rail-row { display: flex; flex-direction: column; gap: 0.05rem; padding: 0.4rem 0.55rem; border-radius: 6px; cursor: pointer; color: inherit; }
		.acw-rail-row:hover { background: var(--bulma-background, #f5f5f5); }
		.acw-rail-row.is-active { background: var(--theme-color-brand-primary, #2e7d74); }
		.acw-rail-row.is-active .acw-rail-label, .acw-rail-row.is-active .acw-rail-sub { color: #fff; }
		.acw-rail-label { font-weight: 600; }
		.acw-rail-sub { font-size: 0.72rem; color: var(--bulma-text-weak, #9a9a9a); }
		.acw-subject { padding: 1.1rem 1.25rem 1.5rem; }
		.acw-subject-head { display: flex; align-items: center; gap: 0.8rem; margin-bottom: 0.5rem; }
		.acw-subject-head .title { margin-bottom: 0.1rem; }
		.acw-subject-kind { font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); font-weight: 700; }
		.acw-tabs { margin-bottom: 1rem; }
		.acw-tab-body { min-height: 8rem; }
		.acw-details th.acw-detail-label { width: 14rem; color: var(--bulma-text-weak, #5a5a5a); font-weight: 600; }
		.acw-placeholder { padding: 2.5rem 1rem; border: 1px dashed var(--bulma-border, #dbdbdb); border-radius: 8px; }
		.acw-empty { padding: 3rem 1rem; }
		.acw-grants .pw-help { font-size: 0.85rem; color: var(--theme-color-text-muted, #6b7686); }
		.acw-grant-section { margin: 0 0 1.1rem; }
		.acw-grant-head { display: flex; align-items: baseline; gap: 0.5rem; font-size: 0.72rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #45505f); padding: 0 0.1rem 0.35rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f6); margin-bottom: 0.35rem; }
		.acw-grant-count { font-weight: 700; color: var(--theme-color-text-muted, #98a2b3); }
		.acw-grant-empty { font-size: 0.85rem; color: var(--theme-color-text-muted, #98a2b3); padding: 0.3rem 0.1rem; }
		.acw-grant-row { display: flex; align-items: center; gap: 0.55rem; padding: 0.4rem 0.2rem; border-bottom: 1px solid var(--theme-color-border-light, #f4f6f9); }
		.acw-grant-cicon { color: var(--theme-color-text-muted, #9aa3af); flex: 0 0 auto; }
		.acw-grant-name { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.acw-grant-id { font-size: 0.7rem; color: var(--theme-color-text-muted, #9aa3af); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.acw-grant-srcs { margin-left: auto; display: inline-flex; flex-wrap: wrap; gap: 0.3rem; justify-content: flex-end; }
		.acw-grant-src { font-size: 0.62rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.08rem 0.42rem; border-radius: 9px; }
		.acw-grant-src-direct { color: #276749; background: #e6f4ea; }
		.acw-grant-src-via { color: #45505f; background: var(--theme-color-background-secondary, #eef1f6); }
		.acw-grant-src-more { color: #5650e6; background: #ecebfb; cursor: default; }
		.acw-grant-x { flex: 0 0 auto; border: none; background: transparent; color: var(--theme-color-text-muted, #98a2b3); cursor: pointer; padding: 0.1rem 0.3rem; border-radius: 5px; line-height: 1; }
		.acw-grant-x:hover { color: var(--theme-color-status-danger, #c0392b); background: #fdecec; }
		.acw-grant-add { margin-top: 1.1rem; padding-top: 0.9rem; border-top: 1px solid var(--theme-color-border-light, #eef1f6); }
		.acw-grant-add-head { font-size: 0.7rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #45505f); margin: 0 0 0.6rem; }
		.acw-grant-add-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 0.7rem; }
		.acw-grant-field { display: flex; flex-direction: column; gap: 0.2rem; }
		.acw-grant-flabel { font-size: 0.72rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
		.acw-grant-picker { min-width: 20rem; }
		.acw-grant-btn { font-size: 0.85rem; font-weight: 600; padding: 0.4rem 0.9rem; border-radius: 7px; border: none; background: var(--theme-color-primary, #2f6fed); color: #fff; cursor: pointer; }
		.acw-grant-busy { font-size: 0.8rem; color: var(--theme-color-primary, #2f6fed); font-weight: 600; }
		.acw-grant-notice { font-size: 0.85rem; color: #276749; background: #e6f4ea; border-radius: 6px; padding: 0.45rem 0.6rem; margin: 0.6rem 0 0; }
		.acw-grant-error { font-size: 0.85rem; color: var(--theme-color-status-danger, #c0392b); margin: 0.5rem 0 0; }
		.acw-matrix-bar { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.75rem; }
		.acw-matrix-search { max-width: 22rem; }
		.acw-matrix-summary { margin-left: auto; display: flex; gap: 0.4rem; }
		.acw-matrix-scroll { overflow-x: auto; border: 1px solid var(--bulma-border, #ededed); border-radius: 6px; }
		.acw-matrix-table { margin-bottom: 0; font-size: 0.82rem; }
		.acw-matrix-table thead th { position: sticky; top: 0; background: var(--bulma-scheme-main, #fff); z-index: 2; border-bottom: 2px solid var(--bulma-border, #dbdbdb); }
		.acw-matrix-action { text-align: center; white-space: nowrap; font-size: 0.72rem; }
		.acw-matrix-entity-col, .acw-matrix-entity { position: sticky; left: 0; background: var(--bulma-scheme-main, #fff); z-index: 1; font-weight: 600; white-space: nowrap; }
		.acw-matrix-entity-col { z-index: 3; }
		.acw-matrix-section td { background: var(--bulma-background, #f5f5f5); font-weight: 700; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); }
		.acw-matrix-section-count { color: var(--bulma-text-weak, #9a9a9a); margin-left: 0.3rem; }
		.acw-cell { text-align: center; width: 2.2rem; }
		.acw-cell-on { color: var(--theme-color-status-success, #2e7d32); }
		.acw-cell-off { color: var(--theme-color-status-error, #c0392b); }
		.acw-cell-none { color: var(--bulma-border, #dbdbdb); }
		.acw-cell-na { background: repeating-linear-gradient(45deg, transparent, transparent 4px, rgba(0,0,0,0.02) 4px, rgba(0,0,0,0.02) 8px); }
		.acw-dash { color: var(--bulma-border, #cfcfcf); }
		.acw-cell-clickable { cursor: pointer; }
		.acw-cell-clickable:hover { background: var(--bulma-background, #f0f0f0); }
		.acw-cell-changed { outline: 2px solid var(--bulma-link, #485fc7); outline-offset: -2px; }
		.acw-faint { opacity: 0.35; }
		.acw-all-col { border-right: 2px solid var(--bulma-border, #dbdbdb); }
		.acw-matrix-mode { margin-bottom: 0 !important; margin-right: 0.5rem; }
		.acw-matrix-mode .button { margin-bottom: 0; }
		.acw-enforce-col { text-align: center; white-space: nowrap; border-left: 2px solid var(--bulma-border, #dbdbdb); padding-left: 0.5rem !important; padding-right: 0.5rem !important; }
		.acw-enforce-head { font-size: 0.72rem; }
		.acw-inert { display: inline-flex; align-items: center; gap: 0.15rem; color: #b06a00; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; margin-left: 0.3rem; white-space: nowrap; }
		.acw-matrix-savebar { display: flex; align-items: center; justify-content: space-between; }
		.acw-matrix-savebar-actions { display: flex; gap: 0.5rem; }
		.acw-roles-impact { display: flex; align-items: center; flex-wrap: wrap; gap: 0.4rem; margin-bottom: 0.75rem; }
		.acw-roles-impact-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); margin-right: 0.2rem; }
		.acw-role-chip { cursor: pointer; border: none; }
		.acw-role-chip-count { margin-left: 0.35rem; font-weight: 700; opacity: 0.7; }
		.acw-cell-override { color: #d9821b; }
		.acw-cell-default { color: #3273dc; }
		.acw-cell-inherited { color: #3273dc; }
		.acw-explain { position: relative; }
		.acw-explain-title { margin-bottom: 0.4rem; }
		.acw-explain-line { margin-bottom: 0.15rem; font-size: 0.85rem; font-family: monospace; }
		.acw-eff-section { border: 1px solid var(--bulma-border, #ededed); border-radius: 8px; margin-bottom: 0.85rem; overflow: hidden; }
		.acw-eff-head { display: flex; align-items: center; gap: 0.5rem; padding: 0.55rem 0.8rem; background: var(--bulma-background, #f7f7f7); flex-wrap: wrap; }
		.acw-eff-head-title { font-weight: 700; }
		.acw-eff-head-counts { margin-left: auto; display: flex; gap: 0.35rem; }
		.acw-eff-members { display: inline-flex; align-items: center; gap: 0.3rem; flex-wrap: wrap; font-size: 0.72rem; color: var(--bulma-text-weak, #7a7a7a); }
		.acw-eff-row { display: flex; align-items: center; gap: 0.6rem; padding: 0.35rem 0.8rem; border-top: 1px solid var(--bulma-border, #f3f3f3); font-size: 0.85rem; }
		.acw-eff-row-status { width: 1.2rem; text-align: center; }
		.acw-eff-row-entity { font-weight: 600; }
		.acw-eff-row-action { color: var(--bulma-text-weak, #7a7a7a); }
		.acw-eff-row-source { margin-left: auto; }
		.acw-eff-why { color: var(--bulma-link, #485fc7); }
		.acw-eff-deny .acw-eff-row-entity { color: var(--theme-color-status-error, #c0392b); }
		.acw-eff-empty { padding: 0.5rem 0.8rem; color: var(--bulma-text-weak, #9a9a9a); font-size: 0.82rem; }
		.acw-rail-actions { display: flex; gap: 0.4rem; margin-bottom: 0.6rem; }
		.acw-details-edit { max-width: 42rem; }
		.acw-details-actions { display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem; flex-wrap: wrap; }
		.acw-delete-confirm { display: inline-flex; align-items: center; gap: 0.4rem; }
		.acw-section-help { color: var(--bulma-text-weak, #7a7a7a); margin-bottom: 0.75rem; }
		.acw-add-members { max-width: 42rem; margin-bottom: 1rem; padding: 0.9rem 1rem; }
		.acw-add-members-head { display: flex; align-items: center; gap: 0.4rem; font-weight: 600; margin-bottom: 0.25rem; }
		.acw-add-members-help { color: var(--bulma-text-weak, #7a7a7a); font-size: 0.85rem; margin-bottom: 0.6rem; }
		.acw-add-members-row { display: flex; align-items: flex-start; gap: 0.5rem; }
		.acw-add-members-picker { flex: 1 1 auto; min-width: 0; }
		.acw-add-members-btn { flex: 0 0 auto; }
		.acw-add-members-saving { flex: 0 0 auto; align-self: center; }
		.acw-details-addmembers { margin-top: 1rem; }
		.acw-edge-list { border: 1px solid var(--bulma-border, #ededed); border-radius: 6px; max-width: 42rem; }
		.acw-edge-row { display: flex; align-items: center; padding: 0.4rem 0.6rem; border-bottom: 1px solid var(--bulma-border, #f3f3f3); }
		.acw-edge-row:last-child { border-bottom: none; }
		.acw-edge-main { display: flex; align-items: center; gap: 0.4rem; flex: 1 1 auto; cursor: pointer; color: inherit; }
		.acw-edge-add { display: flex; gap: 0.5rem; margin-top: 0.75rem; align-items: center; flex-wrap: wrap; }
		.acw-member-name { font-weight: 600; }
		.acw-member-sub { font-size: 0.72rem; color: var(--bulma-text-weak, #9a9a9a); margin-left: 0.4rem; }
		.acw-member-levels { display: inline-flex; gap: 0.35rem; align-items: center; margin-left: auto; flex-wrap: wrap; flex: 0 0 auto; }
		.acw-members-count { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); margin-bottom: 0.5rem; }
		.acw-assign-form { margin-top: 1rem; max-width: 42rem; }
		.acw-expiration-input { max-width: 11rem; }
		.acw-date-field { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.75rem; color: var(--bulma-text-weak, #7a7a7a); }
		.acw-spinner { display: inline-block; width: 1.4rem; height: 1.4rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #485fc7); border-radius: 50%; animation: acw-spin 0.8s linear infinite; }
		@keyframes acw-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		...libTabBar.TABBAR_TEMPLATES,
		{
			Hash: 'AccessWorkspace-Wrap',
			Template: /*html*/`
				<div class="acw-wrap">
					<div class="acw-header">
						<div>
							<h1 class="title is-4">Access &amp; Permissions</h1>
							<p class="subtitle is-6 has-text-grey">Roles, permission groups, the permission matrix, and who has what — in one place.</p>
						</div>
						<div class="acw-context">
							<div class="field has-addons">
								<div class="control"><span class="acw-context-label">Context</span></div>
								<div class="control"><div class="select"><select onchange="_Pict.providers.AccessWorkspace.setContext(this.value)">{~TS:AccessWorkspace-ContextOption:AppData.AccessWorkspace.ContextOptions~}</select></div></div>
								{~TS:AccessWorkspace-ContextID:AppData.AccessWorkspace.ContextIDSlot~}
							</div>
						</div>
					</div>
					{~TS:AccessWorkspace-Message:AppData.AccessWorkspace.MessageSlot~}
					<div class="columns">
						<div class="column is-one-third">
							<div class="acw-rail box">
								<input id="acw-rail-search" class="input acw-search" type="text" placeholder="Search roles, groups, users…" value="{~D:AppData.AccessWorkspace.Search~}" oninput="_Pict.providers.AccessWorkspace.setSearch(this.value)" />
								{~TS:AccessWorkspace-RailActions:AppData.AccessWorkspace.NewButtonsSlot~}
								{~TS:AccessWorkspace-RailLoading:AppData.AccessWorkspace.RailLoadingSlot~}
								{~TS:AccessWorkspace-RailGroup:AppData.AccessWorkspace.RailGroups~}
							</div>
						</div>
						<div class="column">
							{~TS:AccessWorkspace-Subject:AppData.AccessWorkspace.SubjectSlot~}
							{~TS:AccessWorkspace-Empty:AppData.AccessWorkspace.EmptySlot~}
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-ContextOption',
			Template: /*html*/`<option value="{~D:Record.Key~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'AccessWorkspace-ContextID',
			Template: /*html*/`<div class="control"><input class="input" type="number" placeholder="{~D:Record.Context~} ID" value="{~D:Record.ContextIDInput~}" onchange="_Pict.providers.AccessWorkspace.setContextID(this.value)" /></div>`,
		},
		{
			Hash: 'AccessWorkspace-RailLoading',
			Template: /*html*/`<div class="has-text-centered py-4"><span class="acw-spinner"></span><p class="mt-2 has-text-grey is-size-7">Loading…</p></div>`,
		},
		{
			Hash: 'AccessWorkspace-RailGroup',
			Template: /*html*/`
				<div class="acw-rail-group">
					<div class="acw-rail-head"><span class="icon is-small"><i class="{~D:Record.Icon~}"></i></span><span>{~D:Record.Label~}</span><span class="acw-rail-count">{~D:Record.Count~}</span></div>
					{~TS:AccessWorkspace-RailRow:Record.Rows~}
					{~TS:AccessWorkspace-RailHint:Record.HintSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-RailHint',
			Template: /*html*/`<p class="acw-rail-hint has-text-grey is-size-7 px-2 py-2">{~D:Record.Hint~}</p>`,
		},
		{
			Hash: 'AccessWorkspace-RailRow',
			Template: /*html*/`
				<a class="acw-rail-row {~D:Record.RowClass~}" onclick="_Pict.providers.AccessWorkspace.selectSubject('{~D:Record.Kind~}', {~D:Record.ID~})">
					<span class="acw-rail-label">{~D:Record.Label~}</span>
					<span class="acw-rail-sub">{~D:Record.Sub~}</span>
				</a>`,
		},
		{
			Hash: 'AccessWorkspace-Message',
			Template: /*html*/`<div class="notification {~D:Record.MessageClass~} is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-Subject',
			Template: /*html*/`
				<div class="acw-subject box">
					<div class="acw-subject-head">
						<span class="icon is-medium"><i class="{~D:Record.SubjectIcon~} fa-lg"></i></span>
						<div>
							<h2 class="title is-5">{~D:Record.SubjectTitle~}</h2>
							<p class="acw-subject-kind">{~D:Record.SubjectKindLabel~}</p>
						</div>
					</div>
					<div class="hltabs hltabs--menu acw-tabs">{~TS:HL-TabBar-Item:Record.Tabs~}</div>
					<div class="acw-tab-body">
						{~TS:AccessWorkspace-DetailsBody:Record.DetailsReadSlot~}
						{~TS:AccessWorkspace-DetailsEdit:Record.DetailsEditSlot~}
						{~TS:AccessWorkspace-Matrix:Record.MatrixActiveSlot~}
						{~TS:AccessWorkspace-Effective:Record.EffectiveActiveSlot~}
						{~TS:AccessWorkspace-Composition:Record.CompositionActiveSlot~}
						{~TS:AccessWorkspace-Members:Record.MembersActiveSlot~}
						{~TS:AccessWorkspace-ProjectsGranted:Record.ProjectsGrantedActiveSlot~}
						{~TS:AccessWorkspace-Assignment:Record.AssignmentActiveSlot~}
						{~TS:AccessWorkspace-Overrides:Record.OverridesActiveSlot~}
						{~TS:AccessWorkspace-Placeholder:Record.PlaceholderActiveSlot~}
					</div>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-DetailsBody',
			Template: /*html*/`
				<table class="table is-fullwidth acw-details">
					<tbody>{~TS:AccessWorkspace-DetailField:Record.Fields~}</tbody>
				</table>`,
		},
		{
			Hash: 'AccessWorkspace-DetailField',
			Template: /*html*/`<tr><th class="acw-detail-label">{~D:Record.Label~}</th><td>{~D:Record.Value~}</td></tr>`,
		},
		{
			Hash: 'AccessWorkspace-Placeholder',
			Template: /*html*/`
				<div class="acw-placeholder has-text-grey has-text-centered">
					<span class="icon is-large"><i class="fas fa-screwdriver-wrench fa-2x"></i></span>
					<p class="mt-3">{~D:Record.Text~}</p>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-Empty',
			Template: /*html*/`
				<div class="acw-empty box has-text-grey has-text-centered">
					<span class="icon is-large"><i class="fas fa-hand-pointer fa-2x"></i></span>
					<p class="mt-3">Pick a role, permission group, or user on the left to manage its access.</p>
				</div>`,
		},
		{
			// User-Group-only "Projects Granted" tab. The body is a host div the UserGroupGrants provider paints
			// from onAfterRender (effective projects/labs + contract grants + add control) — same host-mount idiom
			// as the User workspace Roles panel, so a full re-render never blows away the mounted grant picker.
			Hash: 'AccessWorkspace-ProjectsGranted',
			Template: /*html*/`<div class="acw-grants"><div id="acw-grants-host"></div></div>`,
		},
		{
			Hash: 'AccessWorkspace-Matrix',
			Template: /*html*/`
				<div class="acw-matrix">
					<div class="acw-matrix-bar">
						{~TS:AccessWorkspace-MatrixMode:AppData.AccessWorkspace.Matrix.ModeSlot~}
						<input id="acw-matrix-search-input" class="input acw-matrix-search" type="text" placeholder="Filter…" value="{~D:AppData.AccessWorkspace.Matrix.Search~}" oninput="_Pict.providers.PermissionMatrix.setSearch(this.value)" />
						<span class="acw-matrix-summary"><span class="tag is-success is-light">{~D:AppData.AccessWorkspace.Matrix.GrantCount~} granted</span><span class="tag is-danger is-light">{~D:AppData.AccessWorkspace.Matrix.DenyCount~} denied</span></span>
					</div>
					{~TS:AccessWorkspace-MatrixEnforceBanner:AppData.AccessWorkspace.Matrix.EnforcementBannerSlot~}
					{~TS:AccessWorkspace-MatrixEditHint:AppData.AccessWorkspace.Matrix.EditHintSlot~}
					{~TS:AccessWorkspace-MatrixSaveBar:AppData.AccessWorkspace.Matrix.SaveBarSlot~}
					{~TS:AccessWorkspace-MatrixNotice:AppData.AccessWorkspace.Matrix.SaveNoticeSlot~}
					{~TS:AccessWorkspace-MatrixLoading:AppData.AccessWorkspace.Matrix.LoadingSlot~}
					{~TS:AccessWorkspace-MatrixError:AppData.AccessWorkspace.Matrix.ErrorSlot~}
					{~TS:AccessWorkspace-MatrixGrid:AppData.AccessWorkspace.Matrix.GridSlot~}
					{~TS:AccessWorkspace-MatrixNoMatch:AppData.AccessWorkspace.Matrix.NoMatchSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixGrid',
			Template: /*html*/`
				<div class="acw-matrix-scroll">
					<table class="table is-narrow acw-matrix-table">
						<thead><tr><th class="acw-matrix-entity-col">Entity</th>{~TS:AccessWorkspace-MatrixAllHead:AppData.AccessWorkspace.Matrix.AllHeadSlot~}{~TS:AccessWorkspace-MatrixHead:AppData.AccessWorkspace.Matrix.Actions~}{~TS:AccessWorkspace-MatrixEnforceHead:AppData.AccessWorkspace.Matrix.EnforcementHeadSlot~}</tr></thead>
						<tbody>{~TS:AccessWorkspace-MatrixSection:AppData.AccessWorkspace.Matrix.Sections~}</tbody>
					</table>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixHead',
			Template: /*html*/`<th class="acw-matrix-action">{~D:Record.Action~}</th>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixSection',
			Template: /*html*/`
				<tr class="acw-matrix-section"><td colspan="20"><span class="icon is-small"><i class="fas fa-layer-group"></i></span> {~D:Record.Title~}<span class="acw-matrix-section-count">{~D:Record.RowCount~}</span></td></tr>
				{~TS:AccessWorkspace-MatrixRow:Record.Rows~}`,
		},
		{
			Hash: 'AccessWorkspace-MatrixRow',
			Template: /*html*/`<tr><td class="acw-matrix-entity">{~D:Record.Entity~}</td>{~TS:AccessWorkspace-MatrixAllCell:Record.AllSlot~}{~TS:AccessWorkspace-MatrixCell:Record.Cells~}{~TS:AccessWorkspace-MatrixEnforceCell:Record.EnforceSlot~}</tr>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixCell',
			Template: /*html*/`<td class="{~D:Record.CellClass~}" title="{~D:Record.Title~}" onclick="_Pict.providers.PermissionMatrix.toggleCell('{~D:Record.Hash~}')">{~D:Record.Icon~}</td>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixLoading',
			Template: /*html*/`<div class="has-text-centered py-5"><span class="acw-spinner"></span><p class="mt-2 has-text-grey">Loading permissions…</p></div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixError',
			Template: /*html*/`<div class="notification is-warning is-soft">{~D:Record.Error~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixNoMatch',
			Template: /*html*/`<div class="acw-placeholder has-text-grey has-text-centered"><p>No entities match your filter.</p></div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixAllHead',
			Template: /*html*/`<th class="acw-matrix-action acw-all-col" title="Set all actions for the entity">All</th>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixAllCell',
			Template: /*html*/`<td class="{~D:Record.CellClass~} acw-all-col" title="{~D:Record.Title~}" onclick="_Pict.providers.PermissionMatrix.toggleAll('{~D:Record.Entity~}')">{~D:Record.Icon~}</td>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixMode',
			Template: /*html*/`
				<div class="buttons has-addons acw-matrix-mode">
					<button class="button is-small {~D:Record.EntitiesClass~}" onclick="_Pict.providers.PermissionMatrix.setCatalogMode('entities')"><span class="icon is-small"><i class="fas fa-table-cells"></i></span><span>Entities</span></button>
					<button class="button is-small {~D:Record.ReportsClass~}" onclick="_Pict.providers.PermissionMatrix.setCatalogMode('reports')"><span class="icon is-small"><i class="fas fa-file-lines"></i></span><span>Reports &amp; Forms</span></button>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceBanner',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Text~}</span></div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceHead',
			Template: /*html*/`<th class="acw-matrix-action acw-enforce-col acw-enforce-head" title="Whether grants for a report/form are actually enforced (PermissionsEnforcement)">Enforce</th>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceCell',
			Template: /*html*/`<td class="acw-enforce-col">{~TS:AccessWorkspace-MatrixEnforceEdit:Record.EditSlot~}{~TS:AccessWorkspace-MatrixEnforceRead:Record.ReadSlot~}{~TS:AccessWorkspace-MatrixEnforceInert:Record.InertSlot~}</td>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceEdit',
			Template: /*html*/`<div class="select is-small"><select onchange="_Pict.providers.PermissionMatrix.setEnforcementModeAsync('{~D:Record.RNIHash~}', this.value)">{~TS:AccessWorkspace-MatrixEnforceOption:Record.Options~}</select></div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceRead',
			Template: /*html*/`<span class="tag {~D:Record.BadgeClass~}" title="{~D:Record.Title~}">{~D:Record.Mode~}</span>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEnforceInert',
			Template: /*html*/`<span class="acw-inert" title="Grants for this report are not enforced (mode Default) — they will not restrict access."><span class="icon is-small"><i class="fas fa-triangle-exclamation"></i></span>inert</span>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixEditHint',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3"><span class="icon"><i class="fas fa-lock"></i></span> <span>{~D:Record.Text~}</span></div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixSaveBar',
			Template: /*html*/`
				<div class="acw-matrix-savebar notification is-link is-soft py-2 px-3">
					<span><strong>{~D:Record.EditCount~}</strong> unsaved change(s)</span>
					<span class="acw-matrix-savebar-actions">
						<button class="button is-small" onclick="_Pict.providers.PermissionMatrix.discard()">Discard</button>
						<button class="button is-small is-link" {~D:Record.SaveDisabledAttr~} onclick="_Pict.providers.PermissionMatrix.saveAsync()"><span class="icon"><i class="fas fa-floppy-disk"></i></span><span>Save changes</span></button>
					</span>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-MatrixNotice',
			Template: /*html*/`<div class="notification {~D:Record.Class~} py-2 px-3"><button class="delete" onclick="_Pict.providers.PermissionMatrix.dismissNotice()"></button>{~D:Record.Text~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-Effective',
			Template: /*html*/`
				<div class="acw-effective">
					<div class="acw-matrix-bar">
						<input id="acw-effective-search-input" class="input acw-matrix-search" type="text" placeholder="Filter permissions…" value="{~D:AppData.AccessWorkspace.Effective.Search~}" oninput="_Pict.providers.PermissionVisualizer.setSearch(this.value)" />
						<span class="acw-matrix-summary">{~TS:AccessWorkspace-EffectiveSummary:AppData.AccessWorkspace.Effective.SummarySlot~}</span>
					</div>
					{~TS:AccessWorkspace-EffectiveExplain:AppData.AccessWorkspace.Effective.ExplainSlot~}
					{~TS:AccessWorkspace-MatrixLoading:AppData.AccessWorkspace.Effective.LoadingSlot~}
					{~TS:AccessWorkspace-MatrixError:AppData.AccessWorkspace.Effective.ErrorSlot~}
					{~TS:AccessWorkspace-EffSection:AppData.AccessWorkspace.Effective.Sections~}
					{~TS:AccessWorkspace-MatrixNoMatch:AppData.AccessWorkspace.Effective.NoMatchSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-EffSection',
			Template: /*html*/`
				<div class="acw-eff-section">
					<div class="acw-eff-head">
						<span class="icon is-small"><i class="fas fa-location-dot"></i></span>
						<span class="acw-eff-head-title">{~D:Record.Label~}</span>
						{~TS:AccessWorkspace-EffMembers:Record.MemberSlot~}
						{~TS:AccessWorkspace-EffSuper:Record.SuperSlot~}
						<span class="acw-eff-head-counts"><span class="tag is-success is-light">{~D:Record.Allowed~} granted</span><span class="tag is-danger is-light">{~D:Record.Denied~} denied</span></span>
					</div>
					<div class="acw-eff-rows">
						{~TS:AccessWorkspace-EffRow:Record.Rows~}
						{~TS:AccessWorkspace-EffEmpty:Record.EmptySlot~}
					</div>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-EffMembers',
			Template: /*html*/`<span class="acw-eff-members">via {~TS:AccessWorkspace-EffMemberChip:Record.Members~}</span>`,
		},
		{
			Hash: 'AccessWorkspace-EffMemberChip',
			Template: /*html*/`<button class="tag is-info is-light acw-role-chip" onclick="_Pict.providers.PermissionVisualizer.selectRole({~D:Record.IDRole~})" title="Jump to this role">{~D:Record.Label~}</button>`,
		},
		{
			Hash: 'AccessWorkspace-EffSuper',
			Template: /*html*/`<span class="tag is-warning">super-user — all by default</span>`,
		},
		{
			Hash: 'AccessWorkspace-EffRow',
			Template: /*html*/`
				<div class="acw-eff-row {~D:Record.RowClass~}">
					<span class="acw-eff-row-status">{~D:Record.StatusIcon~}</span>
					<span class="acw-eff-row-hash"><span class="acw-eff-row-entity">{~D:Record.Entity~}</span> · <span class="acw-eff-row-action">{~D:Record.Action~}</span></span>
					<span class="acw-eff-row-source"><span class="tag {~D:Record.SourceClass~}">{~D:Record.SourceLabel~}</span></span>
					{~TS:AccessWorkspace-EffWhy:Record.WhySlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-EffWhy',
			Template: /*html*/`<button class="button is-small is-white acw-eff-why" title="Why?" onclick="_Pict.providers.PermissionVisualizer.explainAsync('{~D:Record.Hash~}','{~D:Record.Context~}',{~D:Record.IDContext~})"><span class="icon is-small"><i class="fas fa-circle-question"></i></span></button>`,
		},
		{
			Hash: 'AccessWorkspace-EffEmpty',
			Template: /*html*/`<div class="acw-eff-empty">No explicit permissions in this context.</div>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveSummary',
			Template: /*html*/`<span class="tag is-info is-light">{~D:Record.Text~}</span>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveRolesImpact',
			Template: /*html*/`
				<div class="acw-roles-impact">
					<span class="acw-roles-impact-label">Roles in effect:</span>
					{~TS:AccessWorkspace-EffectiveRoleChip:AppData.AccessWorkspace.Effective.RolesImpact~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveRoleChip',
			Template: /*html*/`<button class="tag acw-role-chip {~D:Record.ChipClass~}" onclick="_Pict.providers.PermissionVisualizer.selectRole({~D:Record.IDRole~})" title="Jump to this role">{~D:Record.Label~} <span class="acw-role-chip-count">{~D:Record.Count~}</span></button>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveGrid',
			Template: /*html*/`
				<div class="acw-matrix-scroll">
					<table class="table is-narrow acw-matrix-table">
						<thead><tr><th class="acw-matrix-entity-col">Entity</th>{~TS:AccessWorkspace-MatrixHead:AppData.AccessWorkspace.Effective.Actions~}</tr></thead>
						<tbody>{~TS:AccessWorkspace-EffectiveSection:AppData.AccessWorkspace.Effective.Sections~}</tbody>
					</table>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveSection',
			Template: /*html*/`
				<tr class="acw-matrix-section"><td colspan="20"><span class="icon is-small"><i class="fas fa-layer-group"></i></span> {~D:Record.Title~}<span class="acw-matrix-section-count">{~D:Record.RowCount~}</span></td></tr>
				{~TS:AccessWorkspace-EffectiveRow:Record.Rows~}`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveRow',
			Template: /*html*/`<tr><td class="acw-matrix-entity">{~D:Record.Entity~}</td>{~TS:AccessWorkspace-EffectiveCell:Record.Cells~}</tr>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveCell',
			Template: /*html*/`<td class="{~D:Record.CellClass~}" title="{~D:Record.Title~}" onclick="_Pict.providers.PermissionVisualizer.explainAsync('{~D:Record.Hash~}')">{~D:Record.Icon~}</td>`,
		},
		{
			Hash: 'AccessWorkspace-EffectiveExplain',
			Template: /*html*/`
				<div class="acw-explain notification is-soft">
					<button class="delete" onclick="_Pict.providers.PermissionVisualizer.closeExplain()"></button>
					<p class="acw-explain-title"><strong>Why?</strong> <code>{~D:Record.Hash~}</code></p>
					{~TS:AccessWorkspace-ExplainLoading:Record.LoadingSlot~}
					{~TS:AccessWorkspace-ExplainError:Record.ErrorSlot~}
					{~TS:AccessWorkspace-ExplainLine:Record.Lines~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-ExplainLoading',
			Template: /*html*/`<p class="has-text-grey"><span class="acw-spinner"></span> Resolving…</p>`,
		},
		{
			Hash: 'AccessWorkspace-ExplainError',
			Template: /*html*/`<p class="has-text-danger">{~D:Record.Error~}</p>`,
		},
		{
			Hash: 'AccessWorkspace-ExplainLine',
			Template: /*html*/`<p class="acw-explain-line {~D:Record.Class~}">{~D:Record.Text~}</p>`,
		},
		{
			Hash: 'AccessWorkspace-RailActions',
			Template: /*html*/`
				<div class="acw-rail-actions">
					<button class="button is-small is-link is-light" onclick="_Pict.providers.AccessWorkspace.newRole()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Role</span></button>
					<button class="button is-small is-link is-light" onclick="_Pict.providers.AccessWorkspace.newGroup()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Group</span></button>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-DetailsEdit',
			Template: /*html*/`
				<div class="acw-details-edit">
					<div class="field"><label class="label is-small">Name</label><div class="control"><input id="acw-detail-name" class="input" type="text" value="{~D:Record.Name~}" oninput="_Pict.providers.AccessWorkspace.setDetailField('Name', this.value)" /></div></div>
					<div class="columns">
						<div class="column"><div class="field"><label class="label is-small">Type</label><div class="control"><div class="select is-fullwidth"><select onchange="_Pict.providers.AccessWorkspace.setDetailField('Type', this.value)">{~TS:AccessWorkspace-DetailTypeOption:Record.TypeOptions~}</select></div></div></div></div>
						<div class="column"><div class="field"><label class="label is-small">Permission level</label><div class="control"><input id="acw-detail-permlevel" class="input" type="text" placeholder="(optional)" value="{~D:Record.PermissionLevel~}" oninput="_Pict.providers.AccessWorkspace.setDetailField('PermissionLevel', this.value)" /></div></div></div>
					</div>
					<div class="field"><label class="label is-small">Description</label><div class="control"><textarea id="acw-detail-description" class="textarea" rows="2" oninput="_Pict.providers.AccessWorkspace.setDetailField('Description', this.value)">{~D:Record.Description~}</textarea></div></div>
					<p class="help mb-3">Scope: {~D:Record.Scope~}</p>
					<div class="acw-details-actions">
						<button class="button is-link" {~D:Record.SaveDisabledAttr~} onclick="_Pict.providers.AccessWorkspace.saveDetailsAsync()"><span class="icon"><i class="fas fa-floppy-disk"></i></span><span>Save</span></button>
						{~TS:AccessWorkspace-DetailDuplicate:Record.DuplicateButtonSlot~}
						{~TS:AccessWorkspace-DetailDelete:Record.DeleteButtonSlot~}
						{~TS:AccessWorkspace-DetailDeleteConfirm:Record.DeleteConfirmSlot~}
					</div>
					{~TS:AccessWorkspace-DetailsAddMembers:Record.AddMembersSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-DetailsAddMembers',
			Template: /*html*/`
				<div class="acw-add-members box acw-details-addmembers">
					<div class="acw-add-members-head"><span class="icon is-small"><i class="fas fa-user-plus"></i></span><span>Add members</span></div>
					<p class="acw-add-members-help">Search for users and add them to this role or group — many at once.</p>
					<div class="acw-add-members-row">
						<div id="acw-details-add-members-picker" class="acw-add-members-picker"></div>
						{~TS:AccessWorkspace-DetailsAddButton:Record.AddButtonSlot~}
						{~TS:AccessWorkspace-AddMembersSaving:Record.SavingSlot~}
					</div>
					{~TS:AccessWorkspace-DetailsAddNewHint:Record.NewHintSlot~}
					{~TS:AccessWorkspace-AddMembersNotice:Record.NoticeSlot~}
					{~TS:AccessWorkspace-AddMembersError:Record.ErrorSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-DetailsAddButton',
			Template: /*html*/`<button class="button is-link is-small acw-add-members-btn" onclick="_Pict.providers.AccessWorkspace.addDetailsMembersAsync()">Add selected</button>`,
		},
		{
			Hash: 'AccessWorkspace-DetailsAddNewHint',
			Template: /*html*/`<p class="help mt-2 mb-0">The users you pick here will be added to the role when you click <strong>Save</strong>.</p>`,
		},
		{
			Hash: 'AccessWorkspace-DetailTypeOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'AccessWorkspace-DetailDuplicate',
			Template: /*html*/`<button class="button is-light" title="Clone this role into a new one" onclick="window.location.hash = '#/RoleClone/{~D:Record.IDRole~}'"><span class="icon"><i class="fas fa-clone"></i></span><span>Duplicate</span></button>`,
		},
		{
			Hash: 'AccessWorkspace-DetailDelete',
			Template: /*html*/`<button class="button is-danger is-light" onclick="_Pict.providers.AccessWorkspace.requestDelete()"><span class="icon"><i class="fas fa-trash"></i></span><span>Delete</span></button>`,
		},
		{
			Hash: 'AccessWorkspace-DetailDeleteConfirm',
			Template: /*html*/`<span class="acw-delete-confirm"><span class="has-text-danger">Delete this for good?</span><button class="button is-small is-danger" onclick="_Pict.providers.AccessWorkspace.confirmDeleteAsync()">Yes, delete</button><button class="button is-small" onclick="_Pict.providers.AccessWorkspace.cancelDelete()">Cancel</button></span>`,
		},
		{
			Hash: 'AccessWorkspace-Composition',
			Template: /*html*/`
				<div class="acw-composition">
					<p class="acw-section-help">Permission groups and roles included here — their permissions are inherited by this role.</p>
					{~TS:AccessWorkspace-MatrixError:AppData.AccessWorkspace.Composition.ErrorSlot~}
					{~TS:AccessWorkspace-CompositionLoading:AppData.AccessWorkspace.Composition.LoadingSlot~}
					{~TS:AccessWorkspace-CompositionChildren:AppData.AccessWorkspace.Composition.ChildrenSlot~}
					{~TS:AccessWorkspace-CompositionEmpty:AppData.AccessWorkspace.Composition.ChildEmptySlot~}
					{~TS:AccessWorkspace-CompositionAdd:AppData.AccessWorkspace.Composition.AddSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionLoading',
			Template: /*html*/`<div class="has-text-centered py-4"><span class="acw-spinner"></span></div>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionChildren',
			Template: /*html*/`<div class="acw-edge-list">{~TS:AccessWorkspace-CompositionChildRow:AppData.AccessWorkspace.Composition.Children~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionChildRow',
			Template: /*html*/`
				<div class="acw-edge-row">
					<a class="acw-edge-main" onclick="_Pict.providers.GroupComposition.selectRole({~D:Record.IDRole~})"><span class="icon"><i class="{~D:Record.Icon~}"></i></span><span>{~D:Record.Label~}</span><span class="tag is-light ml-2">{~D:Record.KindLabel~}</span></a>
					{~TS:AccessWorkspace-CompositionRemove:Record.RemoveSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionRemove',
			Template: /*html*/`<button class="button is-small is-white" title="Remove" onclick="_Pict.providers.GroupComposition.removeChildAsync({~D:Record.IDRoleEdge~})"><span class="icon"><i class="fas fa-times"></i></span></button>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionEmpty',
			Template: /*html*/`<p class="has-text-grey">No permission groups or roles are included yet.</p>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionAdd',
			Template: /*html*/`
				<div class="acw-edge-add">
					<div class="select is-small"><select onchange="_Pict.providers.GroupComposition.setAddPicker(this.value)">{~TS:AccessWorkspace-CompositionCandidate:AppData.AccessWorkspace.Composition.CandidateOptions~}</select></div>
					<button class="button is-small is-link" onclick="_Pict.providers.GroupComposition.addChildAsync()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Include</span></button>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-CompositionCandidate',
			Template: /*html*/`<option value="{~D:Record.IDRole~}">{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'AccessWorkspace-Members',
			Template: /*html*/`
				<div class="acw-members">
					<p class="acw-section-help">People who hold this role or group — resolved the same way as the Home app, including anyone who inherits it through a role that composes it. Each is tagged with whether it applies at the User (customer-wide) level or on specific Projects.</p>
					{~TS:AccessWorkspace-AddMembers:AppData.AccessWorkspace.Membership.AddSlot~}
					{~TS:AccessWorkspace-MembersError:AppData.AccessWorkspace.Membership.ErrorSlot~}
					{~TS:AccessWorkspace-CompositionLoading:AppData.AccessWorkspace.Membership.LoadingSlot~}
					{~TS:AccessWorkspace-MembersList:AppData.AccessWorkspace.Membership.MembersSlot~}
					{~TS:AccessWorkspace-MembersEmpty:AppData.AccessWorkspace.Membership.MemberEmptySlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-AddMembers',
			Template: /*html*/`
				<div class="acw-add-members box">
					<div class="acw-add-members-head"><span class="icon is-small"><i class="fas fa-user-plus"></i></span><span>Add users to this role or group</span></div>
					<p class="acw-add-members-help">Search for users and add them all at once — they'll hold this role at the current context (the context bar above). This replaces adding them one user at a time.</p>
					<div class="acw-add-members-row">
						<div id="acw-add-members-picker" class="acw-add-members-picker"></div>
						<button class="button is-link is-small acw-add-members-btn" onclick="_Pict.providers.GroupComposition.addMembersAsync()">Add selected</button>
						{~TS:AccessWorkspace-AddMembersSaving:AppData.AccessWorkspace.Membership.AddSavingSlot~}
					</div>
					{~TS:AccessWorkspace-AddMembersNotice:AppData.AccessWorkspace.Membership.AddNoticeSlot~}
					{~TS:AccessWorkspace-AddMembersError:AppData.AccessWorkspace.Membership.AddErrorSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-AddMembersSaving',
			Template: /*html*/`<span class="acw-add-members-saving has-text-grey is-size-7">assigning…</span>`,
		},
		{
			Hash: 'AccessWorkspace-AddMembersNotice',
			Template: /*html*/`<div class="notification is-success is-soft py-2 px-3 mt-2 mb-0">{~D:Record.Notice~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-AddMembersError',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mt-2 mb-0">{~D:Record.Error~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-MembersError',
			Template: /*html*/`<div class="notification is-warning is-soft">{~D:Record.Error~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-MembersList',
			Template: /*html*/`
				<p class="acw-members-count">{~D:AppData.AccessWorkspace.Membership.CountLabel~}</p>
				<div class="acw-edge-list">{~TS:AccessWorkspace-MemberRow:AppData.AccessWorkspace.Membership.MembersRender~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-MemberRow',
			Template: /*html*/`
				<div class="acw-edge-row">
					<span class="acw-edge-main">
						<span class="icon"><i class="fas fa-user"></i></span>
						<span class="acw-member-name">{~D:Record.Label~}</span>
						<span class="acw-member-sub">{~D:Record.Sub~}</span>
						{~TS:AccessWorkspace-MemberVia:Record.ViaSlot~}
					</span>
					<span class="acw-member-levels">
						{~TS:AccessWorkspace-MemberUserLevel:Record.UserLevelSlot~}
						{~TS:AccessWorkspace-MemberProjectLevel:Record.ProjectLevelSlot~}
						{~TS:AccessWorkspace-MemberRemove:Record.RemoveSlot~}
					</span>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-MemberRemove',
			Template: /*html*/`<button class="button is-small is-white" title="Remove this user from the role or group" onclick="_Pict.providers.GroupComposition.removeMemberAsync({~D:Record.IDUser~})"><span class="icon"><i class="fas fa-times"></i></span></button>`,
		},
		{
			Hash: 'AccessWorkspace-MemberUserLevel',
			Template: /*html*/`<span class="tag is-link is-light" title="Assigned customer-wide via a User Role (UserRoleJoin)"><span class="icon is-small"><i class="fas fa-user-tag"></i></span><span>User level</span></span>`,
		},
		{
			Hash: 'AccessWorkspace-MemberProjectLevel',
			Template: /*html*/`<span class="tag is-info is-light" title="Assigned on one or more Projects (ProjectUserJoin / UserContextRole)"><span class="icon is-small"><i class="fas fa-diagram-project"></i></span><span>{~D:Record.CountLabel~}</span></span>`,
		},
		{
			Hash: 'AccessWorkspace-MemberVia',
			Template: /*html*/`<span class="tag is-light ml-2" title="Inherited because this role is composed into: {~D:Record.ViaLabel~}">via {~D:Record.ViaLabel~}</span>`,
		},
		{
			Hash: 'AccessWorkspace-MembersEmpty',
			Template: /*html*/`<p class="has-text-grey">No users hold this role at the User or Project level.</p>`,
		},
		{
			Hash: 'AccessWorkspace-Assignment',
			Template: /*html*/`
				<div class="acw-assignment">
					<p class="acw-section-help">Roles and permission groups this user holds, by context. This is separate from the base role level on the Details tab.</p>
					{~TS:AccessWorkspace-MatrixError:AppData.AccessWorkspace.Assignment.ErrorSlot~}
					{~TS:AccessWorkspace-CompositionLoading:AppData.AccessWorkspace.Assignment.LoadingSlot~}
					{~TS:AccessWorkspace-AssignmentList:AppData.AccessWorkspace.Assignment.MembershipsSlot~}
					{~TS:AccessWorkspace-MembershipEmpty:AppData.AccessWorkspace.Assignment.MembershipEmptySlot~}
					{~TS:AccessWorkspace-AssignForm:AppData.AccessWorkspace.Assignment.AssignSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-AssignmentList',
			Template: /*html*/`<div class="acw-edge-list">{~TS:AccessWorkspace-MembershipRow:AppData.AccessWorkspace.Assignment.Memberships~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-MembershipRow',
			Template: /*html*/`
				<div class="acw-edge-row">
					<span class="acw-edge-main"><span class="icon"><i class="{~D:Record.Icon~}"></i></span><span>{~D:Record.Label~}</span><span class="tag is-light ml-2">{~D:Record.KindLabel~}</span>
						<span class="tag is-info is-light ml-1">{~D:Record.ContextLabel~}</span>{~TS:AccessWorkspace-MembershipState:Record.StateSlot~}</span>
					{~TS:AccessWorkspace-MembershipRemove:Record.RemoveSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-MembershipState',
			Template: /*html*/`<span class="tag {~D:Record.Class~} is-light ml-1" title="{~D:Record.Title~}">{~D:Record.Label~}</span>`,
		},
		{
			Hash: 'AccessWorkspace-MembershipRemove',
			Template: /*html*/`<button class="button is-small is-white" title="Remove" onclick="_Pict.providers.RoleAssignment.removeMembershipAsync({~D:Record.IDRole~}, '{~D:Record.Context~}', {~D:Record.IDContext~})"><span class="icon"><i class="fas fa-times"></i></span></button>`,
		},
		{
			Hash: 'AccessWorkspace-MembershipEmpty',
			Template: /*html*/`<p class="has-text-grey">This user holds no rich roles yet — assign one below, or see their base level on Details.</p>`,
		},
		{
			Hash: 'AccessWorkspace-AssignForm',
			Template: /*html*/`
				<div class="acw-assign-form box">
					<p class="label is-small">Assign a role/group in {~D:Record.Context~}</p>
					<div class="acw-edge-add">
						<div class="select is-small"><select onchange="_Pict.providers.RoleAssignment.setAssignRole(this.value)">{~TS:AccessWorkspace-AssignRoleOption:AppData.AccessWorkspace.Assignment.RoleOptions~}</select></div>
						{~TS:AccessWorkspace-AssignExpiration:AppData.AccessWorkspace.Assignment.ExpirationSlot~}
						<button class="button is-small is-link" onclick="_Pict.providers.RoleAssignment.assignAsync()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Assign</span></button>
					</div>
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-AssignRoleOption',
			Template: /*html*/`<option value="{~D:Record.IDRole~}">{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'AccessWorkspace-AssignExpiration',
			Template: /*html*/`
				<label class="acw-date-field">Starts<input class="input is-small acw-expiration-input" type="date" title="Optional first day" min="{~D:Record.Today~}" value="{~D:Record.StartDraft~}" onchange="_Pict.providers.RoleAssignment.setStart(this.value)" /></label>
				<label class="acw-date-field">Ends<input class="input is-small acw-expiration-input" type="date" title="Optional last day" min="{~D:Record.Today~}" value="{~D:Record.ExpirationDraft~}" onchange="_Pict.providers.RoleAssignment.setExpiration(this.value)" /></label>`,
		},
		{
			Hash: 'AccessWorkspace-Overrides',
			Template: /*html*/`
				<div class="acw-overrides">
					<p class="acw-section-help">Direct permission overrides for this user in the current context — these win over any role. Use exact hashes like <code>Project-Read</code>.</p>
					{~TS:AccessWorkspace-MatrixError:AppData.AccessWorkspace.Assignment.ErrorSlot~}
					{~TS:AccessWorkspace-CompositionLoading:AppData.AccessWorkspace.Assignment.LoadingSlot~}
					{~TS:AccessWorkspace-OverridesList:AppData.AccessWorkspace.Assignment.OverridesSlot~}
					{~TS:AccessWorkspace-OverridesEmpty:AppData.AccessWorkspace.Assignment.OverrideEmptySlot~}
					{~TS:AccessWorkspace-OverrideForm:AppData.AccessWorkspace.Assignment.AssignSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-OverridesList',
			Template: /*html*/`<div class="acw-edge-list">{~TS:AccessWorkspace-OverrideRow:AppData.AccessWorkspace.Assignment.Overrides~}</div>`,
		},
		{
			Hash: 'AccessWorkspace-OverrideRow',
			Template: /*html*/`
				<div class="acw-edge-row">
					<span class="acw-edge-main"><code>{~D:Record.Hash~}</code><span class="tag {~D:Record.AllowClass~} is-light ml-2">{~D:Record.AllowLabel~}</span></span>
					{~TS:AccessWorkspace-OverrideRemove:Record.RemoveSlot~}
				</div>`,
		},
		{
			Hash: 'AccessWorkspace-OverrideRemove',
			Template: /*html*/`<button class="button is-small is-white" title="Remove" onclick="_Pict.providers.RoleAssignment.removeOverrideAsync({~D:Record.IDUserPermission~})"><span class="icon"><i class="fas fa-times"></i></span></button>`,
		},
		{
			Hash: 'AccessWorkspace-OverridesEmpty',
			Template: /*html*/`<p class="has-text-grey">No direct overrides in this context.</p>`,
		},
		{
			Hash: 'AccessWorkspace-OverrideForm',
			Template: /*html*/`
				<div class="acw-assign-form box">
					<div class="acw-edge-add">
						<input class="input is-small" type="text" placeholder="Permission hash (e.g. Project-Read)" value="{~D:AppData.AccessWorkspace.Assignment.OverrideHash~}" oninput="_Pict.providers.RoleAssignment.setOverrideHash(this.value)" />
						<div class="select is-small"><select onchange="_Pict.providers.RoleAssignment.setOverrideAllow(this.value)"><option value="on">Allow</option><option value="off">Deny</option></select></div>
						<button class="button is-small is-link" onclick="_Pict.providers.RoleAssignment.addOverrideAsync()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Add override</span></button>
					</div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'AccessWorkspace-Wrap',
			TemplateHash: 'AccessWorkspace-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"./TabBar.js":1479,"pict-view":1053}],1405:[function(require,module,exports){

const libPictView = require('pict-view');
require('../approval-workflow/ApprovalWorkflow-Help.js'); // sets window.ApprovalWorkflowHelp for the (i) icons

/**
 * ApprovalWorkflowBindings — the #/ApprovalWorkflows/Bindings page.
 *
 * Maps each document type (ReportNamedInstance) to the approval workflow that governs it. Reads/writes the
 * Configuration namespace 'ApprovalWorkflowBindings' (NamespaceValue 'Document') as a flat
 * { documentHash: workflowHash } map. A synthetic "Default" row is the fallback for unbound documents. All
 * data lives in ApprovalWorkflowProvider.bindingsState; this view derives the render rows + repaints.
 *
 * SCOPE. The screen edits two levels of that config (mirroring Home): the customer-wide DEFAULT set, and one
 * PROJECT's overrides. A project inherits every customer default unless it sets its own binding, so a project
 * can diverge from the default per document type. The scope bar switches between the two; in project scope each
 * row's dropdown gains a "use customer default" choice and rows that diverge are flagged.
 */
class ApprovalWorkflowBindings extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ApprovalWorkflow;
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	get bindingsState()
	{
		return this.provider ? this.provider.bindingsState : { Loading: false, Error: '', Rows: [], WorkflowHashes: [], Map: {}, CustomerMap: {}, Dirty: false, Editable: false, Scope: 'Customer', IDProject: 0, Projects: [] };
	}

	/**
	 * Build the per-row render records for the current scope. In customer scope a row's dropdown is
	 * "— None — + every workflow"; in project scope it is "use customer default + every workflow + no-approval
	 * override", and the row is tagged inherited / overrides-default / opt-out relative to the customer set.
	 */
	_buildRenderRows()
	{
		const tmpState = this.bindingsState;
		const tmpProject = (tmpState.Scope === 'Project');
		const tmpWorkflowHashes = tmpState.WorkflowHashes || [];
		const tmpInherit = this.provider ? this.provider.BINDING_INHERIT : '__INHERIT__';
		const tmpNone = this.provider ? this.provider.BINDING_NONE : '__NONE__';
		const tmpNoun = tmpState.TargetNoun || 'document type';
		return (tmpState.Rows || []).map((pRow) =>
		{
			const tmpCurrent = tmpState.Map[pRow.DocHash] || '';
			const tmpDefault = (tmpState.CustomerMap || {})[pRow.DocHash] || '';
			const tmpBound = (tmpCurrent !== '');
			const tmpDiverged = tmpProject && (tmpCurrent !== tmpDefault);
			const tmpOverridden = tmpDiverged && tmpBound;   // project overrides the default with a specific workflow
			const tmpOptedOut = tmpDiverged && !tmpBound;    // project overrides the default with "no approval"
			const tmpInherited = tmpProject && !tmpDiverged; // project takes the customer default as-is

			let tmpOptions;
			if (tmpProject)
			{
				const tmpDefaultLabel = tmpDefault ? tmpDefault : 'no approval';
				tmpOptions = [ { Hash: tmpInherit, Label: `Use customer default (${tmpDefaultLabel})`, SelectedAttr: tmpInherited ? 'selected' : '' } ];
				tmpWorkflowHashes.forEach((pHash) => { tmpOptions.push({ Hash: pHash, Label: pHash, SelectedAttr: (tmpOverridden && tmpCurrent === pHash) ? 'selected' : '' }); });
				// An override pointing at a workflow that no longer exists still needs to show as selected.
				if (tmpOverridden && tmpWorkflowHashes.indexOf(tmpCurrent) < 0)
				{
					tmpOptions.push({ Hash: tmpCurrent, Label: `${tmpCurrent} (missing)`, SelectedAttr: 'selected' });
				}
				// Opt-out only makes sense when there IS a customer default to override.
				if (tmpDefault)
				{
					tmpOptions.push({ Hash: tmpNone, Label: '— No approval (override) —', SelectedAttr: tmpOptedOut ? 'selected' : '' });
				}
			}
			else
			{
				tmpOptions = [ { Hash: '', Label: '— None —', SelectedAttr: tmpCurrent ? '' : 'selected' } ]
					.concat(tmpWorkflowHashes.map((pHash) => ({ Hash: pHash, Label: pHash, SelectedAttr: (tmpCurrent === pHash) ? 'selected' : '' })));
				if (tmpCurrent && tmpWorkflowHashes.indexOf(tmpCurrent) < 0)
				{
					tmpOptions.push({ Hash: tmpCurrent, Label: `${tmpCurrent} (missing)`, SelectedAttr: 'selected' });
				}
			}

			return {
				DocHash: pRow.DocHash,
				DocName: pRow.DocName,
				Filter: `${pRow.DocName} ${pRow.DocHash}`.toLowerCase(),
				RowClass: (tmpBound ? 'is-bound' : 'is-unbound')
					+ (pRow.Synthetic ? ' is-default' : '')
					+ (tmpOverridden ? ' is-override' : '')
					+ (tmpOptedOut ? ' is-optout' : '')
					+ (tmpInherited ? ' is-inherited' : ''),
				DotTitle: this._dotTitle(tmpProject, tmpBound, tmpCurrent, tmpDefault, tmpOverridden, tmpOptedOut, tmpInherited, tmpNoun),
				HashSlot: (pRow.DocName !== pRow.DocHash && !pRow.Synthetic) ? [ { DocHash: pRow.DocHash } ] : [],
				SyntheticSlot: pRow.Synthetic ? [ {} ] : [],
				OrphanSlot: pRow.Orphan ? [ {} ] : [],
				OverrideSlot: tmpOverridden ? [ {} ] : [],
				OptOutSlot: tmpOptedOut ? [ {} ] : [],
				// "Inherited" tag only when there is an actual default value being taken (not for inherited-none).
				InheritedSlot: (tmpInherited && tmpDefault) ? [ {} ] : [],
				Options: tmpOptions,
				Disabled: tmpState.Editable ? '' : 'disabled',
			};
		});
	}

	/**
	 * The header summary slot ("N / M governed · K overriding default") derived from the render rows. Empty
	 * while loading / erroring / choosing a project / when there's nothing but the Default row.
	 */
	_summarySlot(pRenderRows)
	{
		const tmpState = this.bindingsState;
		const tmpNoProjectChosen = (tmpState.Scope === 'Project') && !(tmpState.IDProject > 0);
		if (tmpState.Loading || tmpState.Error || tmpNoProjectChosen || (tmpState.Rows || []).length <= 1)
		{
			return [];
		}
		let tmpBound = 0;
		let tmpOverrides = 0;
		pRenderRows.forEach((pRow) =>
		{
			if (pRow.RowClass.indexOf('is-bound') > -1) { tmpBound++; }
			if (pRow.RowClass.indexOf('is-override') > -1 || pRow.RowClass.indexOf('is-optout') > -1) { tmpOverrides++; }
		});
		return [ { Bound: tmpBound, Total: (tmpState.Rows || []).length, OverrideSlot: (tmpState.Scope === 'Project' && tmpOverrides > 0) ? [ { Count: tmpOverrides } ] : [] } ];
	}

	/** Repaint the header summary region (its own region so an in-row edit keeps the count in sync). */
	_paintSummary(pRenderRows)
	{
		if (!this.pict.ContentAssignment.getElement('#ApprovalWorkflowBindings-Summary')) { return; }
		const tmpSlot = this._summarySlot(pRenderRows);
		this.pict.AppData.ApprovalWorkflowEditor.BindingsSummarySlot = tmpSlot;
		this.pict.ContentAssignment.assignContent('#ApprovalWorkflowBindings-Summary', this.pict.parseTemplateByHash('ApprovalWorkflow-Bindings-SummaryRegion', { Slot: tmpSlot }));
	}

	/** The green-dot tooltip text for a row, spelling out where its governing workflow comes from. (No quote
	 *  characters around the workflow name — the template renderer truncates the value at a smart quote.) */
	_dotTitle(pProject, pBound, pCurrent, pDefault, pOverridden, pOptedOut, pInherited, pNoun)
	{
		if (pProject)
		{
			if (pOverridden) { return `Overrides the customer default — governed by ${pCurrent}`; }
			if (pOptedOut) { return `Overrides the customer default — no approval workflow`; }
			if (pInherited && pBound) { return `Inherited from the customer default — governed by ${pCurrent}`; }
			return `Inherited from the customer default — no approval workflow`;
		}
		return pBound ? `Governed by ${pCurrent}` : `No approval workflow — this ${pNoun} is not governed`;
	}

	onBeforeRender(pRenderable)
	{
		const tmpState = this.bindingsState;
		const tmpApp = this.pict.AppData.ApprovalWorkflowEditor || {};
		const tmpProject = (tmpState.Scope === 'Project');
		const tmpNoProjectChosen = tmpProject && !(tmpState.IDProject > 0);

		const tmpRenderRows = this._buildRenderRows();
		tmpApp.BindingsRows = tmpRenderRows;

		tmpApp.BindingsLoadingSlot = tmpState.Loading ? [ {} ] : [];
		tmpApp.BindingsScopeLoadingSlot = tmpState.ScopeLoading ? [ {} ] : [];
		tmpApp.BindingsErrorSlot = tmpState.Error ? [ { Message: tmpState.Error } ] : [];
		tmpApp.BindingsChooseProjectSlot = tmpNoProjectChosen ? [ {} ] : [];
		tmpApp.BindingsEmptySlot = (!tmpState.Loading && !tmpState.Error && !tmpState.ScopeLoading && !tmpNoProjectChosen && (tmpState.Rows || []).length <= 1) ? [ {} ] : [];
		tmpApp.BindingsSummarySlot = this._summarySlot(tmpRenderRows);

		// Scope bar (customer default vs a specific project).
		tmpApp.BindingsScopeCustomerClass = tmpProject ? '' : 'is-link is-selected';
		tmpApp.BindingsScopeProjectClass = tmpProject ? 'is-link is-selected' : '';
		// The project scope picker is a searchable Pict-Section-Picker mounted in onAfterRender (server-side search);
		// the slot just gates whether its mount is present (project scope only).
		tmpApp.BindingsProjectSelectSlot = tmpProject ? [ {} ] : [];
		tmpApp.BindingsScopeNote = tmpProject
			? (tmpNoProjectChosen
				? `Choose a project to view or override its ${tmpState.TargetNounPlural || 'document types'}.`
				: `Overriding bindings for ${tmpState.ProjectName || 'this project'}. Rows left on the customer default inherit the customer set; changing one makes it diverge for this project only.`)
			: `These are the customer-wide defaults. Every project inherits them unless it sets its own override below.`;
		// The dot legend gains its override entry only in project scope.
		tmpApp.BindingsLegendProjectSlot = tmpProject ? [ {} ] : [];

		// Family-aware labels (Document vs Observation).
		const tmpNoun = tmpState.TargetNoun || 'document type';
		tmpApp.BindingsTitle = tmpState.Title || 'Document Bindings';
		tmpApp.BindingsTargetNoun = tmpNoun;
		tmpApp.BindingsTargetNounPlural = tmpState.TargetNounPlural || 'document types';
		tmpApp.BindingsTargetHeader = tmpNoun.charAt(0).toUpperCase() + tmpNoun.slice(1);
		tmpApp.BindingsServerPendingSlot = tmpState.ServerPending ? [ {} ] : [];
		return super.onBeforeRender(pRenderable);
	}

	/** Client-side filter of the binding rows by document name/hash (show/hide, no re-render). */
	filterRows(pQuery)
	{
		const tmpQuery = String(pQuery || '').trim().toLowerCase();
		let tmpVisible = 0;
		Array.prototype.forEach.call(document.querySelectorAll('.apwb-row'), (pRow) =>
		{
			const tmpText = pRow.getAttribute('data-filter') || '';
			const tmpMatch = !tmpQuery || tmpText.indexOf(tmpQuery) > -1;
			pRow.style.display = tmpMatch ? '' : 'none';
			if (tmpMatch) { tmpVisible++; }
		});
		const tmpEmpty = document.getElementById('ApprovalWorkflowBindings-NoMatch');
		if (tmpEmpty) { tmpEmpty.style.display = (tmpVisible === 0 && tmpQuery) ? '' : 'none'; }
	}

	/** Re-apply the current filter box to freshly rendered rows (rows are replaced on edit/scope change). */
	_reapplyFilter()
	{
		const tmpInput = document.getElementById('ApprovalWorkflowBindings-Filter');
		if (tmpInput && tmpInput.value) { this.filterRows(tmpInput.value); }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._renderActions();
		this.pict.CSSMap.injectCSS();
		// Mount the searchable project-scope picker (present only in project scope; the method no-ops otherwise).
		if (this.provider) { this.provider.mountBindingProjectPicker(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** The Save button + dirty badge (its own region so a dropdown change doesn't re-render the whole table). */
	_renderActions()
	{
		if (!this.pict.ContentAssignment.getElement('#ApprovalWorkflowBindings-Actions')) { return; }
		const tmpState = this.bindingsState;
		const tmpBlockedReason = (tmpState.Editable && this.provider) ? this.provider.bindingsSaveBlockedReason() : '';
		const tmpSaveLabel = (tmpState.Scope === 'Project') ? 'Save project overrides' : 'Save customer defaults';
		const tmpRecord =
		{
			EditSlot: (tmpState.Editable && !tmpBlockedReason) ? [ {} ] : [],
			BlockedSlot: (tmpState.Editable && tmpBlockedReason) ? [ { Reason: tmpBlockedReason, SaveLabel: tmpSaveLabel } ] : [],
			ReadOnlySlot: tmpState.Editable ? [] : [ {} ],
			DirtySlot: (tmpState.Editable && tmpState.Dirty) ? [ {} ] : [],
			SaveLabel: tmpSaveLabel,
		};
		this.pict.ContentAssignment.assignContent('#ApprovalWorkflowBindings-Actions', this.pict.parseTemplateByHash('ApprovalWorkflowBindings-Actions-Template', tmpRecord));
	}

	/** Re-render just the table rows (keeps the filter box + scope bar intact) so edits update the flags live. */
	_renderRows()
	{
		if (!this.pict.ContentAssignment.getElement('#ApprovalWorkflowBindings-Rows')) { return; }
		const tmpRows = this._buildRenderRows();
		this.pict.AppData.ApprovalWorkflowEditor.BindingsRows = tmpRows;
		this.pict.ContentAssignment.assignContent('#ApprovalWorkflowBindings-Rows', this.pict.parseTemplateByHash('ApprovalWorkflow-Bindings-RowSet', { Rows: tmpRows }));
		this._reapplyFilter();
		// Keep the header count in sync — the summary lives outside the table region.
		this._paintSummary(tmpRows);
	}

	onBindingChange(pDocHash, pValue)
	{
		this.provider.setBinding(pDocHash, pValue);
		this._renderRows();     // refresh inherited / overrides-default flags for the changed row
		this._renderActions();  // surface the dirty badge
	}

	// --- Scope switching (customer default vs a specific project) ---------------------------------------

	/** Guard scope changes behind a confirm when there are unsaved edits. @return {Promise<Boolean>} proceed? */
	async _confirmLoseEdits()
	{
		if (!this.bindingsState.Dirty) { return true; }
		return await this.modal.confirm('Discard your unsaved binding changes?',
			{ title: 'Unsaved changes', confirmLabel: 'Discard', cancelLabel: 'Keep editing', dangerous: true });
	}

	async onScopeChange(pScope)
	{
		const tmpState = this.bindingsState;
		if (pScope === tmpState.Scope) { return; }
		if (!(await this._confirmLoseEdits())) { return; }
		if (pScope === 'Project')
		{
			// Project scope uses a server-side SEARCH picker now — there is no preloaded Projects list to check
			// or default from (the old capped `Projects/Lite/…/0/1000` <select> was replaced by
			// mountBindingProjectPicker). Switch to Project scope reusing the last-chosen project if there is
			// one, else with no selection: the provider then shows the "pick a project" prompt and the picker
			// (onProjectChange) drives the actual selection. The stale `tmpState.Projects.length` guard here was
			// firing "No projects found" on every click because that array is never populated any more.
			await this.provider.switchBindingScopeAsync('Project', tmpState.IDProject || 0);
		}
		else
		{
			await this.provider.switchBindingScopeAsync('Customer', 0);
		}
	}

	async onProjectChange(pIDProject)
	{
		if (!(await this._confirmLoseEdits())) { this.render(); return; } // re-render to restore the select
		if (!pIDProject) { return; }
		await this.provider.switchBindingScopeAsync('Project', pIDProject);
	}

	async saveBindings()
	{
		try
		{
			const tmpResult = await this.provider.saveBindingsAsync();
			this._renderActions();
			this._renderRows();
			if (tmpResult.Scope === 'Project')
			{
				const tmpOverrides = tmpResult.OverrideCount || 0;
				this.modal.toast(`Saved. ${tmpOverrides} ${pluralizeCount(tmpOverrides, 'override', 'overrides')} for ${this.bindingsState.ProjectName || 'this project'}; the rest inherit the customer default.`, { type: 'success' });
			}
			else
			{
				this.modal.toast(`Saved ${tmpResult.Count} customer default binding${tmpResult.Count === 1 ? '' : 's'}.`, { type: 'success' });
			}
		}
		catch (pError)
		{
			this.modal.toast(`Save failed: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 6000 });
		}
	}
}

/** Tiny local pluralizer for the save toast. */
function pluralizeCount(pCount, pSingular, pPlural)
{
	return (Number(pCount) === 1) ? pSingular : pPlural;
}

module.exports = ApprovalWorkflowBindings;

module.exports.default_configuration =
{
	ViewIdentifier: 'ApprovalWorkflowBindings',
	DefaultRenderable: 'ApprovalWorkflowBindingsWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.apwb-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 66rem; }
		.apwb-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 0.5rem; }
		.apwb-actions { display: flex; align-items: center; gap: 0.6rem; }
		.apwb-dirty { display: inline-flex; align-items: center; gap: 0.35rem; color: #b8860b; font-size: 0.78rem; font-weight: 600; }
		.apwb-dirty .icon { font-size: 0.5rem; animation: apwb-pulse 1.6s ease-in-out infinite; }
		@keyframes apwb-pulse { 50% { opacity: 0.35; } }
		.apwb-badge { display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.75rem; padding: 0.2rem 0.6rem; border-radius: 999px; background: var(--bulma-scheme-main-bis, #f2f4f8); color: var(--bulma-text-weak, #7a7a7a); border: 1px solid var(--bulma-border, #e6e9ef); }
		.apwb-summary { display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 700; color: var(--bulma-link, #156dd1); background: #eef3fb; border-radius: 999px; padding: 0.1rem 0.6rem; margin-left: 0.5rem; vertical-align: middle; }
		.apwb-summary .apwb-summary-ovr { color: #8a4b16; }

		/* --- Scope bar: customer default vs a specific project. --- */
		.apwb-scopebar { display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap; margin: 0.9rem 0 0.35rem; padding: 0.6rem 0.75rem; border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 10px; background: var(--bulma-scheme-main-bis, #f7f9fc); }
		.apwb-scope-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--bulma-text-weak, #9aa3b2); }
		.apwb-scopebar .buttons { margin-bottom: 0; }
		.apwb-scopebar .buttons .button { margin-bottom: 0; }
		.apwb-scope-project { display: flex; align-items: center; gap: 0.4rem; }
		.apwb-scope-note { flex-basis: 100%; font-size: 0.76rem; color: var(--bulma-text-weak, #6b7484); margin-top: 0.1rem; }
		.apwb-scope-note strong { color: #4a5568; }

		.apwb-toolbar { margin: 0.85rem 0 0.6rem; max-width: 24rem; }

		/* --- Dot legend (explains the status dots). --- */
		.apwb-legend { display: flex; align-items: center; flex-wrap: wrap; gap: 0.35rem 1.1rem; padding: 0.5rem 0.2rem 0.75rem; font-size: 0.74rem; color: var(--bulma-text-weak, #6b7484); }
		.apwb-legend-item { display: inline-flex; align-items: center; gap: 0.4rem; }
		.apwb-legend-note { font-style: italic; }
		.apwb-legend .apwb-dot { position: static; }
		.apwb-dot.legend-bound { background: #2e9e5b; border-color: #2e9e5b; }
		.apwb-dot.legend-override { background: #2e9e5b; border-color: #156dd1; box-shadow: 0 0 0 3px rgba(21,109,209,0.22); }

		.apwb-table { width: 100%; border-collapse: collapse; }
		.apwb-table th { text-align: left; font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--bulma-text-weak, #9aa3b2); padding: 0.5rem 0.7rem; border-bottom: 2px solid var(--bulma-border, #e6e9ef); }
		.apwb-table td { padding: 0.55rem 0.7rem; border-bottom: 1px solid var(--bulma-border, #f0f2f5); vertical-align: middle; }
		.apwb-row { transition: background 0.1s; }
		.apwb-row:hover { background: var(--bulma-scheme-main-bis, #f6f8fc); }
		.apwb-row.is-default { background: #f5f8fe; }
		.apwb-row.is-default:hover { background: #eef3fb; }
		.apwb-name-cell { display: flex; align-items: baseline; gap: 0.5rem; }
		.apwb-dot { flex-shrink: 0; align-self: center; width: 0.55rem; height: 0.55rem; border-radius: 50%; border: 1.5px solid var(--bulma-border, #c7cdd8); background: transparent; }
		.apwb-row.is-bound .apwb-dot { background: #2e9e5b; border-color: #2e9e5b; box-shadow: 0 0 0 3px rgba(46,158,91,0.14); }
		/* Project scope: a diverging row rings its dot in the accent colour so overrides stand out from inherited rows. */
		.apwb-row.is-override .apwb-dot { border-color: #156dd1; box-shadow: 0 0 0 3px rgba(21,109,209,0.20); }
		.apwb-row.is-optout .apwb-dot { background: transparent; border-color: #b26a2c; box-shadow: 0 0 0 3px rgba(178,106,44,0.18); }
		.apwb-row.is-inherited .apwb-doc-name { color: #48566b; }
		.apwb-doc-name { font-weight: 600; color: #22334c; }
		.apwb-doc-hash { font-size: 0.74rem; color: var(--bulma-text-weak, #8a93a3); margin-left: 1.05rem; }
		.apwb-tag { font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.08rem 0.45rem; border-radius: 999px; margin-left: 0.4rem; }
		.apwb-tag.default { background: #e7eefb; color: #3a5a9b; }
		.apwb-tag.orphan { background: #fdeee6; color: #b26a2c; }
		.apwb-tag.override { background: #e6f0fd; color: #1c5fb0; }
		.apwb-tag.optout { background: #fdeee6; color: #b26a2c; }
		.apwb-tag.inherited { background: #eef0f3; color: #6b7484; text-transform: none; font-weight: 600; }
		.apwb-select-cell { width: 42%; min-width: 15rem; }
		.apwb-empty { padding: 2.5rem 1rem; }
		.apwb-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: apwb-spin 0.8s linear infinite; }
		@keyframes apwb-spin { to { transform: rotate(360deg); } }
	`,

	Templates:
	[
		{
			Hash: 'ApprovalWorkflow-Bindings-Wrap',
			Template: /*html*/`
				<div class="apwb-wrap">
					<div class="apwb-header">
						<div>
							<div class="apwe-crumbs" style="font-size:0.85rem;margin-bottom:0.15rem;"><a href="#/ApprovalWorkflows" style="color:var(--bulma-link,#156dd1)"><span class="icon is-small"><i class="fas fa-chevron-left"></i></span> Approval Workflows</a></div>
							<h1 class="title is-4"><span class="icon"><i class="fas fa-link"></i></span> {~D:AppData.ApprovalWorkflowEditor.BindingsTitle~}<span id="ApprovalWorkflowBindings-Summary">{~TS:ApprovalWorkflow-Bindings-Summary:AppData.ApprovalWorkflowEditor.BindingsSummarySlot~}</span> <span class="apw-help" role="button" tabindex="0" title="What are bindings?" onclick="ApprovalWorkflowHelp.show('bindings.overview', this)"><i class="fas fa-circle-info"></i></span></h1>
							<p class="subtitle is-6 has-text-grey">Choose which approval workflow governs each {~D:AppData.ApprovalWorkflowEditor.BindingsTargetNoun~}. The <strong>Default</strong> binding applies to any {~D:AppData.ApprovalWorkflowEditor.BindingsTargetNoun~} without its own.</p>
						</div>
						<div class="apwb-actions" id="ApprovalWorkflowBindings-Actions"></div>
					</div>

					<div class="apwb-scopebar">
						<span class="apwb-scope-label">Scope <span class="apw-help" role="button" tabindex="0" title="About binding scope" onclick="ApprovalWorkflowHelp.show('bindings.scope', this)"><i class="fas fa-circle-info"></i></span></span>
						<div class="buttons has-addons">
							<button class="button is-small {~D:AppData.ApprovalWorkflowEditor.BindingsScopeCustomerClass~}" onclick="_Pict.views.ApprovalWorkflowBindings.onScopeChange('Customer')"><span class="icon is-small"><i class="fas fa-building"></i></span><span>Customer default</span></button>
							<button class="button is-small {~D:AppData.ApprovalWorkflowEditor.BindingsScopeProjectClass~}" onclick="_Pict.views.ApprovalWorkflowBindings.onScopeChange('Project')"><span class="icon is-small"><i class="fas fa-folder-open"></i></span><span>Specific project</span></button>
						</div>
						{~TS:ApprovalWorkflow-Bindings-ProjectSelect:AppData.ApprovalWorkflowEditor.BindingsProjectSelectSlot~}
						<div class="apwb-scope-note">{~D:AppData.ApprovalWorkflowEditor.BindingsScopeNote~}</div>
					</div>

					{~TS:ApprovalWorkflow-Bindings-ServerPending:AppData.ApprovalWorkflowEditor.BindingsServerPendingSlot~}
					{~TS:ApprovalWorkflow-Bindings-Error:AppData.ApprovalWorkflowEditor.BindingsErrorSlot~}

					<div class="apwb-toolbar">
						<div class="control has-icons-left">
							<input class="input" type="text" id="ApprovalWorkflowBindings-Filter" placeholder="Filter {~D:AppData.ApprovalWorkflowEditor.BindingsTargetNounPlural~}…" oninput="_Pict.views.ApprovalWorkflowBindings.filterRows(this.value)">
							<span class="icon is-left"><i class="fas fa-magnifying-glass"></i></span>
						</div>
					</div>

					<div class="box">
						{~TS:ApprovalWorkflow-Bindings-Loading:AppData.ApprovalWorkflowEditor.BindingsLoadingSlot~}
						{~TS:ApprovalWorkflow-Bindings-ScopeLoading:AppData.ApprovalWorkflowEditor.BindingsScopeLoadingSlot~}
						{~TS:ApprovalWorkflow-Bindings-ChooseProject:AppData.ApprovalWorkflowEditor.BindingsChooseProjectSlot~}
						<div class="apwb-legend">
							<span class="apwb-legend-item"><span class="apwb-dot legend-bound"></span> Governed by a workflow</span>
							<span class="apwb-legend-item"><span class="apwb-dot"></span> Not governed</span>
							{~TS:ApprovalWorkflow-Bindings-LegendProject:AppData.ApprovalWorkflowEditor.BindingsLegendProjectSlot~}
							<span class="apw-help" role="button" tabindex="0" title="About the status dots" onclick="ApprovalWorkflowHelp.show('bindings.dots', this)"><i class="fas fa-circle-info"></i></span>
						</div>
						<table class="apwb-table">
							<thead><tr><th>{~D:AppData.ApprovalWorkflowEditor.BindingsTargetHeader~}</th><th class="apwb-select-cell">Approval workflow</th></tr></thead>
							<tbody id="ApprovalWorkflowBindings-Rows">{~TS:ApprovalWorkflow-Bindings-Row:AppData.ApprovalWorkflowEditor.BindingsRows~}</tbody>
						</table>
						<div id="ApprovalWorkflowBindings-NoMatch" class="apwb-empty has-text-grey has-text-centered" style="display:none"><span class="icon is-large"><i class="fas fa-magnifying-glass fa-lg"></i></span><p class="mt-2">No {~D:AppData.ApprovalWorkflowEditor.BindingsTargetNounPlural~} match your filter.</p></div>
						{~TS:ApprovalWorkflow-Bindings-Empty:AppData.ApprovalWorkflowEditor.BindingsEmptySlot~}
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-ProjectSelect',
			Template: /*html*/`
				<div class="apwb-scope-project">
					<div id="ApprovalWorkflowBindings-ProjectPicker" class="apwb-project-picker"></div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-ProjectOption',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" {~D:Record.SelectedAttr~}>{~D:Record.Name~}</option>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-LegendProject',
			Template: /*html*/`
				<span class="apwb-legend-item"><span class="apwb-dot legend-override"></span> Overrides the customer default</span>
				<span class="apwb-legend-item apwb-legend-note">Other rows inherit the customer default</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-SummaryRegion',
			Template: /*html*/`{~TS:ApprovalWorkflow-Bindings-Summary:Record.Slot~}`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Summary',
			Template: /*html*/`<span class="apwb-summary">{~D:Record.Bound~} / {~D:Record.Total~} governed{~TS:ApprovalWorkflow-Bindings-Summary-Ovr:Record.OverrideSlot~}</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Summary-Ovr',
			Template: /*html*/`<span class="apwb-summary-ovr">&nbsp;· {~D:Record.Count~} overriding default</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-RowSet',
			Template: /*html*/`{~TS:ApprovalWorkflow-Bindings-Row:Record.Rows~}`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Row',
			Template: /*html*/`
				<tr class="apwb-row {~D:Record.RowClass~}" data-filter="{~D:Record.Filter~}">
					<td>
						<div class="apwb-name-cell">
							<span class="apwb-dot" title="{~D:Record.DotTitle~}"></span>
							<span class="apwb-doc-name">{~D:Record.DocName~}</span>{~TS:ApprovalWorkflow-Bindings-DefaultTag:Record.SyntheticSlot~}{~TS:ApprovalWorkflow-Bindings-OverrideTag:Record.OverrideSlot~}{~TS:ApprovalWorkflow-Bindings-OptOutTag:Record.OptOutSlot~}{~TS:ApprovalWorkflow-Bindings-InheritedTag:Record.InheritedSlot~}{~TS:ApprovalWorkflow-Bindings-OrphanTag:Record.OrphanSlot~}
						</div>
						{~TS:ApprovalWorkflow-Bindings-Hash:Record.HashSlot~}
					</td>
					<td class="apwb-select-cell">
						<div class="select is-small is-fullwidth">
							<select {~D:Record.Disabled~} onchange="_Pict.views.ApprovalWorkflowBindings.onBindingChange('{~D:Record.DocHash~}', this.value)">{~TS:ApprovalWorkflow-Bindings-Option:Record.Options~}</select>
						</div>
					</td>
				</tr>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Hash',
			Template: /*html*/`<div class="apwb-doc-hash">{~D:Record.DocHash~}</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-DefaultTag',
			Template: /*html*/`<span class="apwb-tag default">fallback</span><span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('bindings.default', this)"><i class="fas fa-circle-info"></i></span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-OverrideTag',
			Template: /*html*/`<span class="apwb-tag override">overrides default</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-OptOutTag',
			Template: /*html*/`<span class="apwb-tag optout">no approval · override</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-InheritedTag',
			Template: /*html*/`<span class="apwb-tag inherited">inherited</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-OrphanTag',
			Template: /*html*/`<span class="apwb-tag orphan">not in document list</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Option',
			Template: /*html*/`<option value="{~D:Record.Hash~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'ApprovalWorkflowBindings-Actions-Template',
			Template: /*html*/`
				{~TS:ApprovalWorkflowBindings-Actions-ReadOnly:Record.ReadOnlySlot~}
				{~TS:ApprovalWorkflowBindings-Actions-Dirty:Record.DirtySlot~}
				{~TS:ApprovalWorkflowBindings-Actions-Save:Record.EditSlot~}
				{~TS:ApprovalWorkflowBindings-Actions-Blocked:Record.BlockedSlot~}`
		},
		{
			Hash: 'ApprovalWorkflowBindings-Actions-Blocked',
			Template: /*html*/`<span title="{~D:Record.Reason~}"><button class="button is-small is-success" disabled><span class="icon is-small"><i class="fas fa-floppy-disk"></i></span><span>{~D:Record.SaveLabel~}</span></button></span>`
		},
		{
			Hash: 'ApprovalWorkflowBindings-Actions-ReadOnly',
			Template: /*html*/`<span class="apwb-badge" title="Editing requires customer-admin permission."><span class="icon is-small"><i class="fas fa-eye"></i></span> Read only</span>`
		},
		{
			Hash: 'ApprovalWorkflowBindings-Actions-Dirty',
			Template: /*html*/`<span class="apwb-dirty"><span class="icon is-small"><i class="fas fa-circle"></i></span> Unsaved changes</span>`
		},
		{
			Hash: 'ApprovalWorkflowBindings-Actions-Save',
			Template: /*html*/`<button class="button is-small is-success" onclick="_Pict.views.ApprovalWorkflowBindings.saveBindings()"><span class="icon is-small"><i class="fas fa-floppy-disk"></i></span><span>{~D:Record.SaveLabel~}</span></button>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-ServerPending',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>You can configure these bindings now, but the approvals service does not yet enforce <strong>observation</strong> approvals — they take effect once server support ships.</span></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-ChooseProject',
			Template: /*html*/`<div class="apwb-empty has-text-grey has-text-centered"><span class="icon is-large"><i class="fas fa-folder-open fa-2x"></i></span><p class="mt-3">Choose a project from the scope bar above to view or override its bindings.</p></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Empty',
			Template: /*html*/`<div class="apwb-empty has-text-grey has-text-centered"><span class="icon is-large"><i class="fas fa-link fa-2x"></i></span><p class="mt-3">No {~D:AppData.ApprovalWorkflowEditor.BindingsTargetNounPlural~} found for your organization.</p></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Loading',
			Template: /*html*/`<div class="apwb-empty has-text-grey has-text-centered"><span class="apwb-spinner"></span><p class="mt-3">Loading document bindings…</p></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-ScopeLoading',
			Template: /*html*/`<div class="apwb-empty has-text-grey has-text-centered"><span class="apwb-spinner"></span><p class="mt-3">Loading project bindings…</p></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Bindings-Error',
			Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'ApprovalWorkflowBindingsWrap', TemplateHash: 'ApprovalWorkflow-Bindings-Wrap', ContentDestinationAddress: '#PlatformConfiguration-Application-Container' }
	]
};

},{"../approval-workflow/ApprovalWorkflow-Help.js":1067,"pict-view":1053}],1406:[function(require,module,exports){

const libPictView = require('pict-view');

const libGraphRenderer = require('../approval-workflow/ApprovalWorkflow-GraphRenderer.js');
const libModel = require('../approval-workflow/ApprovalWorkflow-Model.js');
// Loading this sets window.ApprovalWorkflowHelp, which the inline (i) help icons in the templates call.
require('../approval-workflow/ApprovalWorkflow-Help.js');

/**
 * ApprovalWorkflowEditor — the #/ApprovalWorkflow/:hash visual editor.
 *
 * The diagram is rendered by GRAPHVIZ (via ApprovalWorkflow-GraphRenderer): graphviz lays out the states,
 * routes the spline edges with proper attachment + arrowheads, places non-overlapping labels, and minimises
 * crossings — the things we previously hand-reconstructed in pict-section-flow. This view owns the chrome,
 * the side panels, and the editing flow; clicking a node/edge in the SVG opens the matching panel. All edits
 * mutate the working blob through ApprovalWorkflowProvider (the single source of truth); Save posts it back.
 */
class ApprovalWorkflowEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		// The graphviz renderer + the container it is bound to (re-bound if the wrap re-renders a fresh one)
		// + the workflow object last drawn (so a full-view re-render doesn't redraw needlessly).
		this._renderer = null;
		this._rendererContainer = null;
		this._renderedWorkflow = null;
		// Edit state.
		this._editMode = false;
		// The state currently highlighted in the steps rail / graph.
		this._activeStateStatus = null;
	}

	get provider()
	{
		return this.pict.providers.ApprovalWorkflow;
	}

	get editorState()
	{
		return this.provider ? this.provider.state.Editor : { Loading: false, Error: '', Workflow: null, Hash: '', IsNew: false, Editable: false, Dirty: false };
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	onBeforeRender(pRenderable)
	{
		const tmpEditor = this.editorState;
		const tmpAppState = this.pict.AppData.ApprovalWorkflowEditor || {};
		tmpAppState.EditorLoadingSlot = tmpEditor.Loading ? [ {} ] : [];
		tmpAppState.EditorErrorSlot = tmpEditor.Error ? [ { Message: tmpEditor.Error } ] : [];
		tmpAppState.EditorTitle = tmpEditor.IsNew ? 'New Approval Workflow' : this._esc(tmpEditor.Hash || 'Approval Workflow');
		// Leaving a workflow that is no longer loaded resets edit mode.
		if (!tmpEditor.Editable) { this._editMode = false; }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		const tmpEditor = this.editorState;
		if (tmpEditor.Workflow)
		{
			this._ensureRenderer();
			if (this._renderedWorkflow !== tmpEditor.Workflow)
			{
				this._renderedWorkflow = tmpEditor.Workflow;
				this._activeStateStatus = null; // a freshly loaded workflow has nothing selected yet
				this._renderGraph(false);
			}
		}
		this._renderActions();
		this._renderRail();
		this._renderLevelBanner();
		this._ensureUnloadGuard();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** A different workflow is loading: nothing about the previous one's editing session carries over. */
	onWorkflowLoadStarted()
	{
		this._editMode = false;
		this._editRefStatus = null;
		this._editStateStatus = null;
		this._closeDetail();
	}

	/** Where the workflow is set became known. */
	onLevelInfoLoaded()
	{
		this._renderLevelBanner();
		this._renderActions();
	}

	/** Say which level is open, and what editing it does and doesn't reach. */
	_renderLevelBanner()
	{
		if (!this.pict.ContentAssignment.getElement('#ApprovalWorkflow-LevelBanner'))
		{
			return;
		}
		const tmpEditor = this.editorState;
		const tmpInfo = tmpEditor.LevelInfo;
		let tmpMessage = '';
		let tmpLinks = [];
		let tmpRevertLabel = '';
		if (tmpEditor.IDProject)
		{
			const tmpName = (tmpInfo && tmpInfo.ProjectName) || `project ${tmpEditor.IDProject}`;
			tmpMessage = (tmpInfo && !tmpInfo.OnThisProject)
				? `Viewing this workflow as ${this._esc(tmpName)} inherits it. Saving creates a copy for this project.`
				: `Editing the copy on ${this._esc(tmpName)}. Changes to the customer's workflow don't reach it.`;
			if (tmpInfo && tmpInfo.OnThisProject)
			{
				tmpRevertLabel = (tmpInfo.OnCustomer || tmpInfo.OnGlobal) ? 'Remove copy and use the customer\'s' : 'Delete this copy';
			}
		}
		else if (tmpInfo)
		{
			if (tmpInfo.OnGlobal && !tmpInfo.OnCustomer)
			{
				tmpMessage = 'This is the global default. Saving creates a copy for your organization.';
			}
			else if (tmpInfo.OnGlobal)
			{
				tmpMessage = 'Your organization has customized this from the global default.';
				tmpRevertLabel = 'Revert to the global default';
			}
			if (tmpInfo.Projects.length)
			{
				const tmpCount = tmpInfo.Projects.length;
				tmpMessage += `${tmpMessage ? ' ' : ''}${tmpCount} project${(tmpCount === 1) ? ' has its' : 's have their'} own cop${(tmpCount === 1) ? 'y' : 'ies'}, which changes here don't reach:`;
				tmpLinks = tmpInfo.Projects.map((pProject) => ({ Href: `#/ApprovalWorkflow/${encodeURIComponent(tmpEditor.Hash)}/Project/${pProject.IDProject}`, Label: this._esc(pProject.ProjectName) }));
			}
		}
		const tmpRecord = { Slot: tmpMessage ? [ { Message: tmpMessage, Links: tmpLinks, RevertSlot: (tmpRevertLabel && tmpEditor.Editable) ? [ { Label: tmpRevertLabel } ] : [] } ] : [] };
		this.pict.ContentAssignment.assignContent('#ApprovalWorkflow-LevelBanner', this.pict.parseTemplateByHash('ApprovalWorkflow-LevelBanner-Template', tmpRecord));
	}

	/** Stop overriding what's inherited. */
	async revertToInherited()
	{
		const tmpEditor = this.editorState;
		const tmpOk = await this.modal.confirm(tmpEditor.IDProject ? 'Remove this project\'s copy of the workflow? Its changes will be lost, and documents already in a state only that copy has can\'t be acted on afterwards.' : 'Remove your organization\'s changes and use the global default? Your changes will be lost, and documents already in a state only your copy has can\'t be acted on afterwards.', { title: 'Remove copy', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk)
		{
			return;
		}
		try
		{
			await this.provider.revertToInheritedAsync();
			this.modal.toast('Copy removed.', { type: 'success' });
			window.location.hash = '#/ApprovalWorkflows';
		}
		catch (pError)
		{
			this.modal.toast(`Couldn't remove it: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 8000 });
		}
	}

	/** Delete the workflow, once nothing uses it. */
	async deleteWorkflow()
	{
		try
		{
			const tmpBlockers = await this.provider.workflowDeleteBlockersAsync(this.editorState.Hash);
			if (tmpBlockers.length)
			{
				await this.modal.show(
					{
						title: 'This workflow can\'t be deleted yet',
						width: 'min(720px, 92vw)',
						content: `<div class="apwe-preview">${tmpBlockers.map((pLine) => `<div class="apwe-preview-line">${this._esc(pLine)}</div>`).join('')}</div>`,
						buttons: [ { Hash: 'cancel', Label: 'Close' } ],
					});
				return;
			}
			const tmpOk = await this.modal.confirm(`Delete the workflow "${this.editorState.Hash}"? This can't be undone.`, { title: 'Delete workflow', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
			if (!tmpOk)
			{
				return;
			}
			const tmpResult = await this.provider.deleteWorkflowAsync();
			if (tmpResult.Deleted)
			{
				this.modal.toast('Workflow deleted.', { type: 'success' });
				window.location.hash = '#/ApprovalWorkflows';
			}
			else
			{
				this.modal.toast(tmpResult.Blockers.join(' '), { type: 'error', duration: 8000 });
			}
		}
		catch (pError)
		{
			this.modal.toast(`Couldn't delete it: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 8000 });
		}
	}

	/** Warn before a tab close or reload throws away unsaved edits. In-app navigation is guarded in the router's before-hook. */
	_ensureUnloadGuard()
	{
		if (this._unloadGuardBound || (typeof window === 'undefined'))
		{
			return;
		}
		this._unloadGuardBound = true;
		window.addEventListener('beforeunload', (pEvent) =>
		{
			if (this.provider && this.provider.hasUnsavedEdits())
			{
				pEvent.preventDefault();
				pEvent.returnValue = '';
			}
		});
	}

	// --- Graph (graphviz) ----------------------------------------------------------------------------

	/** Create the renderer once (re-created + re-bound if the wrap re-rendered a fresh container). */
	_ensureRenderer()
	{
		const tmpContainer = document.getElementById('ApprovalWorkflow-Flow-Container');
		if (!tmpContainer || (this._renderer && this._rendererContainer === tmpContainer)) { return; }
		if (this._renderer) { this._renderer.destroy(); }
		this._renderer = new libGraphRenderer(tmpContainer,
			{
				onNodeClick: (pStatus) => this._onNodeClick(pStatus),
				onEdgeClick: (pInfo) => this._onEdgeClick(pInfo),
				// Once graphviz has laid the graph out, re-list the rail in that exact top-to-bottom order.
				onRendered: () => this._renderRail(),
			});
		this._rendererContainer = tmpContainer;
		this._renderedWorkflow = null;
	}

	/** Draw the current working blob. pKeepView preserves pan/zoom (for incremental edits). */
	_renderGraph(pKeepView)
	{
		if (!this._renderer || !this.provider.workflow) { return; }
		this._renderer.render(this.provider.workflow, { keepView: !!pKeepView });
	}

	/** Re-draw after an edit, keeping the viewport. Called by every editing action. */
	_refreshGraph()
	{
		this._renderedWorkflow = this.provider.workflow;
		this._renderGraph(true);
		this._renderRail();
	}

	// On-canvas zoom controls (the floating +/−/fit cluster bottom-right of the graph).
	graphZoomIn() { if (this._renderer) { this._renderer.zoomBy(0.8); } }
	graphZoomOut() { if (this._renderer) { this._renderer.zoomBy(1 / 0.8); } }
	graphFit() { if (this._renderer) { this._renderer.fit(); } }

	/** Toggle the on-canvas colour legend. */
	toggleLegend()
	{
		const tmpEl = document.getElementById('ApprovalWorkflow-Legend');
		if (tmpEl) { tmpEl.classList.toggle('is-collapsed'); }
	}

	async _onNodeClick(pStatus)
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		const tmpStatus = (tmpCommit.RenamedFrom === pStatus) ? tmpCommit.RenamedTo : pStatus;
		this._setActiveState(tmpStatus);
		if (this._editMode)
		{
			this._showStateEditor(tmpStatus);
		}
		else
		{
			this._showStateDetail(tmpStatus);
		}
	}

	// --- Steps rail (the ordered state list beside the diagram) --------------------------------------

	/** Mark a state active in the rail + outline it in the graph. */
	_setActiveState(pStatus)
	{
		this._activeStateStatus = pStatus;
		if (this._renderer) { this._renderer.highlightStatus(pStatus); }
		this._renderRail();
	}

	/** Clicking a step selects that state (opens its panel + highlights it), same as clicking its node. */
	selectStateFromRail(pStatus)
	{
		this._onNodeClick(pStatus);
	}

	/** Collapse / expand the steps rail (its state lives as a class on the static wrap). */
	toggleRail()
	{
		const tmpWrap = document.getElementById('ApprovalWorkflow-RailWrap');
		if (tmpWrap) { tmpWrap.classList.toggle('is-collapsed'); }
	}

	/** Render the ordered list of states into the rail, in the diagram's top-to-bottom order. */
	_renderRail()
	{
		if (!this.pict.ContentAssignment.getElement('#ApprovalWorkflow-Rail')) { return; }
		const tmpEditing = !!(this._editMode && this.editorState.Editable);
		const tmpStates = (this.provider.workflow && this.provider.workflow.States) || [];
		const tmpSteps = this._railOrder(tmpStates).map((pIndex) =>
		{
			const tmpState = tmpStates[pIndex];
			return {
				Index: pIndex,
				Status: this._esc(tmpState.Status),
				StateName: this._esc(tmpState.StateName || tmpState.Status),
				Color: libModel.stateColor(tmpState.Status),
				Tint: libModel.stateTint(tmpState.Status),
				OutCount: (tmpState.Transitions || []).length,
				DocumentText: this._documentCountText(tmpState.Status),
				ActiveClass: (tmpState.Status === this._activeStateStatus) ? 'is-active' : '',
			};
		});
		this.pict.ContentAssignment.assignContent('#ApprovalWorkflow-Rail',
			this.pict.parseTemplateByHash('ApprovalWorkflow-Rail-Template',
				{ Steps: tmpSteps, CountText: `${tmpStates.length}`, EmptySlot: tmpSteps.length ? [] : [ {} ], AddStateSlot: tmpEditing ? [ {} ] : [] }));
	}

	/** The rail's document count for a state; empty until counts are loaded or when there are none. */
	_documentCountText(pStatus)
	{
		const tmpCount = this.provider.documentCountFor(pStatus);
		return tmpCount ? ` · ${tmpCount.toLocaleString()} doc${(tmpCount === 1) ? '' : 's'}` : '';
	}

	/**
	 * The state indices in the order the rail should list them: the diagram's ACTUAL laid-out order once
	 * graphviz has rendered (so the rail matches the graph exactly, cycles and all), falling back to the
	 * computed flow order before the async layout is ready. States not yet in the layout (e.g. just added)
	 * are appended in array order.
	 * @param {Array} pStates
	 * @return {Array<Number>}
	 */
	_railOrder(pStates)
	{
		const tmpStatusOrder = this._renderer ? this._renderer.getStatusOrder() : null;
		if (!tmpStatusOrder || !tmpStatusOrder.length)
		{
			return libModel.flowOrder(this.provider.workflow);
		}
		const tmpIndexByStatus = {};
		pStates.forEach((pState, pIndex) => { tmpIndexByStatus[pState.Status] = pIndex; });
		const tmpOrdered = [];
		const tmpSeen = {};
		tmpStatusOrder.forEach((pStatus) =>
		{
			if (tmpIndexByStatus.hasOwnProperty(pStatus) && !tmpSeen[pStatus]) { tmpSeen[pStatus] = true; tmpOrdered.push(tmpIndexByStatus[pStatus]); }
		});
		pStates.forEach((pState, pIndex) => { if (!tmpSeen[pState.Status]) { tmpOrdered.push(pIndex); } });
		return tmpOrdered;
	}

	async _onEdgeClick(pInfo)
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		if (this._editMode && !pInfo.IsBranch)
		{
			this._showTransitionEditor(pInfo.SourceStatus, pInfo.TransitionIndex);
			return;
		}
		const tmpDetail = this._transitionDetailRecord(pInfo);
		if (!tmpDetail) { return; }
		if (pInfo.IsBranch) { this._showBranchReadonly(tmpDetail); }
		else { this._showTransitionDetail(tmpDetail); }
	}

	// --- Edit-mode chrome ----------------------------------------------------------------------------

	async toggleEditMode()
	{
		if (!this.editorState.Editable) { return; }
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		this._editMode = !this._editMode;
		this._closeDetail();
		this._renderActions();
		if (this._editMode)
		{
			// Loaded on entering edit mode rather than on every view: these are real queries against Document.
			this.provider.loadDocumentCountsAsync().then(() => this._renderRail());
		}
	}

	/** Render the header action buttons (Edit / Done + Add State + Save + Discard + dirty badge). */
	_renderActions()
	{
		if (!this.pict.ContentAssignment.getElement('#ApprovalWorkflow-Actions')) { return; }
		const tmpEditor = this.editorState;
		const tmpCheckCount = (tmpEditor.Findings || []).filter((pFinding) => pFinding.Severity !== 'info').length;
		const tmpRecord =
		{
			CanEdit: !!tmpEditor.Editable,
			CheckSlot: tmpCheckCount ? [ { Count: tmpCheckCount, Plural: (tmpCheckCount === 1) ? '' : 's' } ] : [],
			JsonSlot: tmpEditor.Workflow ? [ {} ] : [],
			EditModeSlot: (tmpEditor.Editable && this._editMode) ? [ {} ] : [],
			ViewModeSlot: (tmpEditor.Editable && !this._editMode) ? [ {} ] : [],
			ReadOnlySlot: (!tmpEditor.Editable && !tmpEditor.Loading && !tmpEditor.Error) ? [ {} ] : [],
			DirtySlot: (tmpEditor.Editable && this._editMode && tmpEditor.Dirty) ? [ {} ] : [],
			DeleteSlot: (tmpEditor.Editable && this._editMode && !tmpEditor.IsNew && !tmpEditor.IDProject && tmpEditor.LevelInfo && !tmpEditor.LevelInfo.OnGlobal) ? [ {} ] : [],
		};
		this.pict.ContentAssignment.assignContent('#ApprovalWorkflow-Actions', this.pict.parseTemplateByHash('ApprovalWorkflow-Actions-Template', tmpRecord));
	}

	async addStateAndEdit()
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		const tmpStatus = await this.provider.addStateAsync();
		this._refreshGraph();
		this._renderActions();
		this._setActiveState(tmpStatus);
		this._showStateEditor(tmpStatus);
	}

	async saveWorkflow()
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		const tmpEditor = this.editorState;
		const tmpOptions = {};
		try
		{
			const tmpProblems = libModel.findSaveProblems(tmpEditor.Workflow);
			if (tmpProblems.length)
			{
				throw new Error(tmpProblems.join(' '));
			}
			if (tmpEditor.IsNew && !tmpEditor.Hash)
			{
				// A brand-new workflow needs a hash (the document-type key) — prompt for it.
				const tmpChoice = await this.modal.show(
					{
						title: 'Save new workflow',
						content: '<p>Enter a hash/name for this workflow (the key it is stored under):</p><input type="text" id="apw-new-hash" class="input" placeholder="e.g. MyChangeOrder" autofocus>',
						buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Save', Style: 'primary' } ],
					});
				if (tmpChoice !== 'ok')
				{
					return;
				}
				tmpOptions.Hash = ((document.getElementById('apw-new-hash') || {}).value || '').trim();
			}
			else if (!(await this._confirmSavePreview()))
			{
				return;
			}
			let tmpResult = await this.provider.saveAsync(tmpOptions);
			if (tmpResult.Conflict)
			{
				if (!(await this._confirmOverwrite(tmpResult.Changes)))
				{
					return;
				}
				tmpResult = await this.provider.saveAsync(Object.assign({}, tmpOptions, { Force: true }));
			}
			this._renderActions();
			this.modal.toast('Workflow saved.', { type: 'success' });
		}
		catch (pError)
		{
			this.modal.toast(`Save failed: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 8000 });
		}
	}

	/**
	 * Show what Save would change, and anything to check, and ask to go ahead.
	 * @return {Promise<Boolean>} true to save
	 */
	async _confirmSavePreview()
	{
		const tmpChanges = this.provider.pendingChanges();
		if (!tmpChanges.length)
		{
			this.modal.toast('There are no changes to save.', { type: 'info' });
			return false;
		}
		const tmpChecks = (this.editorState.Findings || []).filter((pFinding) => pFinding.Severity !== 'info');
		const tmpCheckHTML = tmpChecks.length
			? `<p class="mt-3"><strong>${tmpChecks.length} thing${(tmpChecks.length === 1) ? '' : 's'} to check</strong></p>${tmpChecks.map((pFinding) => `<div class="apwe-preview-line">${this._esc(pFinding.Message)}</div>`).join('')}`
			: '';
		const tmpChoice = await this.modal.show(
			{
				title: 'Save these changes?',
				width: 'min(720px, 92vw)',
				content: `<div class="apwe-preview">${tmpChanges.map((pLine) => `<div class="apwe-preview-line">${this._esc(pLine)}</div>`).join('')}${tmpCheckHTML}</div>`,
				buttons: [ { Hash: 'cancel', Label: 'Keep editing' }, { Hash: 'ok', Label: 'Save', Style: 'primary' } ],
			});
		return tmpChoice === 'ok';
	}

	/**
	 * Someone else saved this workflow first: show what they changed and ask whether to replace it.
	 * @param {Array<String>} pTheirChanges
	 * @return {Promise<Boolean>} true to replace their changes
	 */
	async _confirmOverwrite(pTheirChanges)
	{
		const tmpChoice = await this.modal.show(
			{
				title: 'Workflow changed',
				width: 'min(720px, 92vw)',
				content: `<p>Someone else changed this workflow after you opened it. Saving now replaces their changes with yours. To keep them, discard your edits and reopen the workflow.</p><p class="mt-3"><strong>What they changed</strong></p><div class="apwe-preview">${(pTheirChanges || []).map((pLine) => `<div class="apwe-preview-line">${this._esc(pLine)}</div>`).join('')}</div>`,
				buttons: [ { Hash: 'cancel', Label: 'Keep editing' }, { Hash: 'ok', Label: 'Replace their changes', Style: 'danger' } ],
			});
		return tmpChoice === 'ok';
	}

	/** List what's worth checking in the side panel. */
	showFindings()
	{
		const tmpFindings = (this.editorState.Findings || []).map((pFinding, pIndex) => ({
			Index: pIndex,
			Severity: pFinding.Severity,
			Kind: { error: 'Must fix', warning: 'Check', info: 'Note' }[pFinding.Severity],
			Message: this._esc(pFinding.Message),
		}));
		this._assignDetail(this.pict.parseTemplateByHash('ApprovalWorkflow-Findings-Template', { Findings: tmpFindings, EmptySlot: tmpFindings.length ? [] : [ {} ] }));
	}

	/** Go to the state or transition a finding concerns. */
	async openFinding(pIndex)
	{
		const tmpFinding = (this.editorState.Findings || [])[parseInt(pIndex, 10)];
		if (!tmpFinding || (tmpFinding.Status === undefined))
		{
			return;
		}
		this._setActiveState(tmpFinding.Status);
		if (this._editMode && (tmpFinding.TransitionIndex !== undefined))
		{
			this._showTransitionEditor(tmpFinding.Status, tmpFinding.TransitionIndex);
		}
		else if (this._editMode)
		{
			this._showStateEditor(tmpFinding.Status);
		}
		else
		{
			this._showStateDetail(tmpFinding.Status);
		}
	}

	/** See the workflow's full configuration; anyone who can edit it can also change it here. */
	async openJsonEditor()
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		const tmpEditable = !!(this._editMode && this.editorState.Editable);
		let tmpText = JSON.stringify(this.provider.workflow, null, '\t');
		let tmpError = '';
		for (;;)
		{
			const tmpChoice = await this.modal.show(
				{
					title: tmpEditable ? 'Edit workflow JSON' : 'Workflow JSON',
					width: 'min(900px, 94vw)',
					content: `${tmpError ? `<p class="apwe-json-error">${this._esc(tmpError)}</p>` : ''}${tmpEditable ? '' : '<p class="is-size-7 has-text-grey mb-2">To change this, press Edit first.</p>'}<textarea id="apw-json-text" class="textarea apwe-json-text" spellcheck="false"${tmpEditable ? '' : ' readonly'}>${this._esc(tmpText)}</textarea>`,
					buttons: tmpEditable ? [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Apply to diagram', Style: 'primary' } ] : [ { Hash: 'cancel', Label: 'Close' } ],
				});
			if (tmpChoice !== 'ok')
			{
				return;
			}
			tmpText = (document.getElementById('apw-json-text') || {}).value || '';
			const tmpResult = await this.provider.applyWorkflowJSONAsync(tmpText);
			if (!tmpResult.Error)
			{
				if (tmpResult.Changed)
				{
					this._editRefStatus = null;
					this._editStateStatus = null;
					this._closeDetail();
					this._refreshGraph();
					this._renderActions();
					this.modal.toast('Applied to the diagram. Press Save to keep it.', { type: 'success' });
				}
				return;
			}
			tmpError = tmpResult.Error;
		}
	}

	/** Whether the open side panel holds typed values that haven't reached the working model. */
	hasPendingPanelEdits()
	{
		if (!this._editMode || (typeof document === 'undefined'))
		{
			return false;
		}
		if ((this._editRefStatus != null) && document.getElementById('apw-edit-action'))
		{
			return this.provider.transitionPatchChanges(this._editRefStatus, this._editRefIndex, this._transitionPanelValues());
		}
		if ((this._editStateStatus != null) && document.getElementById('apw-state-name'))
		{
			return this.provider.statePatchChanges(this._editStateStatus, this._statePanelValues());
		}
		return false;
	}

	_transitionPanelValues()
	{
		const tmpValue = (pID) => (document.getElementById(pID) || {}).value;
		const tmpChecked = (pID) => !!(document.getElementById(pID) || {}).checked;
		return {
			Action: tmpValue('apw-edit-action'),
			ToStatus: tmpValue('apw-edit-target'),
			LockEntity: tmpChecked('apw-edit-lock'),
			UnlockEntity: tmpChecked('apw-edit-unlock'),
			IsApproval: tmpChecked('apw-edit-approval'),
			AllowOnLocked: tmpChecked('apw-edit-allowlocked'),
		};
	}

	_statePanelValues()
	{
		return {
			StateName: (document.getElementById('apw-state-name') || {}).value,
			Status: (document.getElementById('apw-state-status') || {}).value,
		};
	}

	/**
	 * Apply the state panel, asking first if the rename would strand documents.
	 * @return {Promise<{ OK: Boolean, RenamedFrom?: String, RenamedTo?: String, Changed?: Boolean }>}
	 */
	async _applyStatePanel()
	{
		const tmpPrior = this._editStateStatus;
		const tmpValues = this._statePanelValues();
		const tmpCount = this.provider.documentCountFor(tmpPrior);
		if ((String(tmpValues.Status || '').trim() !== tmpPrior) && tmpCount)
		{
			const tmpOk = await this.modal.confirm(`At least ${tmpCount.toLocaleString()} document${(tmpCount === 1) ? ' is' : 's are'} in "${tmpPrior}". They keep that hash and can't be acted on after a rename.`, { title: 'Rename state', confirmLabel: 'Rename anyway', cancelLabel: 'Keep the hash', dangerous: true });
			if (!tmpOk)
			{
				return { OK: false };
			}
		}
		const tmpResult = await this.provider.applyStateEditAsync(tmpPrior, tmpValues);
		if (tmpResult && tmpResult.Error)
		{
			this.modal.toast(tmpResult.Error, { type: 'error', duration: 5000 });
			return { OK: false };
		}
		if (tmpResult && tmpResult.Changed)
		{
			this._editStateStatus = tmpResult.Status;
			this._refreshGraph();
			this._renderActions();
		}
		return { OK: true, RenamedFrom: tmpPrior, RenamedTo: tmpResult ? tmpResult.Status : tmpPrior, Changed: !!(tmpResult && tmpResult.Changed) };
	}

	/**
	 * Put whatever is typed into the open side panel onto the working model, so leaving the panel or pressing Save can't
	 * drop it. OK is false when the panel holds a value that can't be applied; the panel stays open and says why.
	 * @return {Promise<{ OK: Boolean, RenamedFrom?: String, RenamedTo?: String }>}
	 */
	async _commitOpenPanel()
	{
		if (!this._editMode || (typeof document === 'undefined'))
		{
			return { OK: true };
		}
		if (await this._commitFields())
		{
			this._refreshGraph();
			this._renderActions();
		}
		if (!document.getElementById('apw-state-name') || (this._editStateStatus == null))
		{
			return { OK: true };
		}
		return this._applyStatePanel();
	}

	async discardChanges()
	{
		if (this.editorState.Dirty)
		{
			const tmpOk = await this.modal.confirm('Discard all unsaved changes to this workflow?', { title: 'Discard changes', confirmLabel: 'Discard', cancelLabel: 'Keep editing', dangerous: true });
			if (!tmpOk) { return; }
		}
		await this.provider.discardAsync();
		this._refreshGraph();
		this._closeDetail();
		this._renderActions();
	}

	// --- Detail / edit panels ------------------------------------------------------------------------

	_assignDetail(pHTML)
	{
		if (this.pict.ContentAssignment.getElement('#ApprovalWorkflow-Detail'))
		{
			this.pict.ContentAssignment.assignContent('#ApprovalWorkflow-Detail', pHTML);
		}
	}

	_showTransitionDetail(pData)
	{
		this._assignDetail(this.pict.parseTemplateByHash('ApprovalWorkflow-Detail-Template',
			{
				SourceStateName: pData.SourceStateName || pData.SourceStatus || '',
				ToStateName: pData.ToStateName || pData.ToStatus || '',
				SentenceText: pData.SentenceText || '',
				BranchSlot: pData.IsBranch ? [ {} ] : [],
				OtherSlot: pData.OtherSlot || [],
			}));
	}

	_showBranchReadonly(pData)
	{
		this._assignDetail(this.pict.parseTemplateByHash('ApprovalWorkflow-BranchReadonly-Template',
			{ SourceStateName: pData.SourceStateName || pData.SourceStatus || '', ToStateName: pData.ToStateName || pData.ToStatus || '', SentenceText: pData.SentenceText || '' }));
	}

	/** Read-only summary of a state (view mode): its identity + in/out counts + clickable outgoing transitions. */
	_stateDetailRecord(pStatus)
	{
		const tmpStates = (this.provider.workflow && this.provider.workflow.States) || [];
		const tmpState = tmpStates.find((pState) => pState.Status === pStatus);
		if (!tmpState) { return null; }
		const tmpNameOf = (pTarget) => { const tmpFound = tmpStates.find((pState) => pState.Status === pTarget); return tmpFound ? (tmpFound.StateName || tmpFound.Status) : pTarget; };
		const tmpTransitions = (tmpState.Transitions || []).map((pTransition, pIndex) => ({
			Status: this._esc(pStatus), TransitionIndex: pIndex, Action: this._esc(pTransition.Action || '(no action)'), ToStateName: this._esc(tmpNameOf(pTransition.ToStatus)),
		}));
		let tmpIncoming = 0;
		tmpStates.forEach((pState) => (pState.Transitions || []).forEach((pTransition) => { if (pTransition.ToStatus === pStatus) { tmpIncoming++; } }));
		return {
			Status: pStatus,
			StateName: tmpState.StateName || pStatus,
			Transitions: tmpTransitions,
			EmptySlot: tmpTransitions.length ? [] : [ {} ],
			IncomingText: `${tmpIncoming} in`,
			OutgoingText: `${tmpTransitions.length} out`,
			EditHintSlot: this.editorState.Editable ? [ {} ] : [],
		};
	}

	_showStateDetail(pStatus)
	{
		const tmpRecord = this._stateDetailRecord(pStatus);
		if (!tmpRecord) { this._closeDetail(); return; }
		this._assignDetail(this.pict.parseTemplateByHash('ApprovalWorkflow-StateDetail-Template', tmpRecord));
	}

	/** A clicked edge's detail, plus what else its transition carries. */
	_transitionDetailRecord(pInfo)
	{
		const tmpDetail = this.provider.edgeDetail(pInfo);
		if (!tmpDetail)
		{
			return null;
		}
		const tmpState = ((this.provider.workflow && this.provider.workflow.States) || []).find((pState) => pState.Status === pInfo.SourceStatus);
		const tmpTransition = tmpState && (tmpState.Transitions || [])[pInfo.TransitionIndex];
		return Object.assign({}, tmpDetail, { OtherSlot: (tmpTransition && !pInfo.IsBranch) ? this._otherSettingsSlot(tmpTransition) : [] });
	}

	/** From a read-only state panel, open a transition's read-only sentence detail. */
	viewTransitionDetail(pStatus, pIndex)
	{
		const tmpIndex = parseInt(pIndex, 10);
		const tmpStates = (this.provider.workflow && this.provider.workflow.States) || [];
		const tmpState = tmpStates.find((pState) => pState.Status === pStatus);
		const tmpTransition = tmpState && (tmpState.Transitions || [])[tmpIndex];
		if (!tmpTransition) { return; }
		const tmpDetail = this._transitionDetailRecord({ SourceStatus: pStatus, TransitionIndex: tmpIndex, IsBranch: false, ToStatus: tmpTransition.ToStatus });
		if (tmpDetail) { this._showTransitionDetail(tmpDetail); }
	}

	/** Look up a transition's current values from the working model (index is stable across edits). */
	_transitionRecord(pStatus, pIndex)
	{
		const tmpStates = (this.provider.workflow && this.provider.workflow.States) || [];
		const tmpState = tmpStates.find((pState) => pState.Status === pStatus);
		if (!tmpState) { return null; }
		const tmpTransition = (tmpState.Transitions || [])[pIndex];
		if (!tmpTransition) { return null; }
		const tmpOptions = this.provider.stateOptions().map((pOption) => ({ Status: this._esc(pOption.Status), StateName: this._esc(pOption.StateName || pOption.Status), SelectedAttr: (pOption.Status === tmpTransition.ToStatus) ? 'selected' : '' }));
		// A target that names no state stays selected; the first option would otherwise silently take its place.
		if (!this.provider.stateOptions().some((pOption) => pOption.Status === tmpTransition.ToStatus))
		{
			const tmpTarget = (tmpTransition.ToStatus == null) ? '' : String(tmpTransition.ToStatus);
			tmpOptions.unshift({ Status: this._esc(tmpTarget), StateName: this._esc(tmpTarget ? `${tmpTarget} (missing state)` : '(not set)'), SelectedAttr: 'selected' });
		}
		const tmpActors = this.provider.actorLabels(pStatus, pIndex).map((pRow) => Object.assign({}, pRow, { Label: this._esc(pRow.Label) }));
		return {
			SourceStatus: pStatus,
			SourceStateName: tmpState.StateName || pStatus,
			TransitionIndex: pIndex,
			Action: this._esc(tmpTransition.Action || ''),
			Options: tmpOptions,
			LockChecked: tmpTransition.LockEntity ? 'checked' : '',
			UnlockChecked: tmpTransition.UnlockEntity ? 'checked' : '',
			ApprovalChecked: tmpTransition.IsApproval ? 'checked' : '',
			AllowLockedChecked: tmpTransition.AllowOnLocked ? 'checked' : '',
			Actors: tmpActors,
			ActorEmptySlot: tmpActors.length ? [] : [ {} ],
			OtherSlot: this._otherSettingsSlot(tmpTransition),
		};
	}

	/**
	 * The "Other settings" section for a transition: one record holding its rows, or nothing when it has none.
	 * @param {Object} pTransition
	 * @return {Array<Object>}
	 */
	_otherSettingsSlot(pTransition)
	{
		const tmpRows = libModel.otherTransitionSettings(pTransition, libModel.buildStateMap(this.provider.workflow));
		return tmpRows.length ? [ { Rows: tmpRows.map((pRow) => ({ Label: this._esc(pRow.Label), Detail: this._esc(pRow.Detail) })) } ] : [];
	}

	_showTransitionEditor(pStatus, pIndex)
	{
		const tmpRecord = this._transitionRecord(pStatus, pIndex);
		if (!tmpRecord) { this._closeDetail(); return; }
		this._editRefStatus = pStatus;
		this._editRefIndex = pIndex;
		this._assignDetail(this.pict.parseTemplateByHash('ApprovalWorkflow-TransitionEditor-Template', tmpRecord));
	}

	async applyTransitionForm()
	{
		const tmpValue = (pID) => (document.getElementById(pID) || {}).value;
		const tmpAction = (tmpValue('apw-edit-action') || '').trim();
		const tmpTargetStatus = tmpValue('apw-edit-target');
		await this._commitFields();
		this._refreshGraph();
		this._renderActions();
		this._showTransitionEditor(this._editRefStatus, this._editRefIndex);
		// Make it obvious what the Apply just did to the diagram (and that it still needs saving).
		const tmpTargetName = (this.provider.stateOptions().find((pOption) => pOption.Status === tmpTargetStatus) || {}).StateName || tmpTargetStatus || '(unset)';
		const tmpSourceName = (this.provider.stateOptions().find((pOption) => pOption.Status === this._editRefStatus) || {}).StateName || this._editRefStatus;
		this.modal.toast(`Applied to the diagram: ${tmpSourceName} — '${tmpAction || 'no action'}' → ${tmpTargetName}. Press Save to keep it.`, { type: 'success' });
	}

	async deleteTransitionFromForm()
	{
		const tmpStatus = this._editRefStatus;
		const tmpOk = await this.modal.confirm('Delete this transition, including any conditional branches, triggers and other settings it carries?', { title: 'Delete transition', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk)
		{
			return;
		}
		await this.provider.removeTransitionAsync(tmpStatus, this._editRefIndex);
		this._refreshGraph();
		this._renderActions();
		this._showStateEditor(tmpStatus);
	}

	// --- P3 actor editing --------------------------------------------------------------------------------

	/**
	 * Commit the transition editor's field inputs into the working model.
	 * @return {Promise<Boolean>} true if anything changed
	 */
	async _commitFields()
	{
		if (this._editRefStatus == null || !document.getElementById('apw-edit-action'))
		{
			return false;
		}
		return this.provider.applyTransitionEditAsync(this._editRefStatus, this._editRefIndex, this._transitionPanelValues());
	}

	async removeActor(pActorIndex, pSettingIndex)
	{
		await this._commitFields();
		await this.provider.removeActorAsync(this._editRefStatus, this._editRefIndex, parseInt(pActorIndex, 10), parseInt(pSettingIndex, 10));
		this._refreshGraph();
		this._renderActions();
		this._showTransitionEditor(this._editRefStatus, this._editRefIndex);
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	async openAddActorModal()
	{
		await this._commitFields();
		await this.provider.loadCustomerRolesAsync();
		// Captured add-actor state (read on OK; the modal DOM is gone by then).
		this._addActor = { Type: 'ProjectRole', Role: (this.provider.customerRoles[0] || {}).PermissionLevel || '', Level: '3', User: null };
		this._userResults = [];
		this._actorTagOptions = libModel.actorTagOptions(this.provider.workflow);
		const tmpChoice = await this.modal.show(
			{
				title: 'Add actor',
				content: this._addActorModalContent(),
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Add', Style: 'primary' } ],
			});
		if (tmpChoice !== 'ok') { return; }
		this._addActor.Tags = this._readTagInput();
		const tmpSpec = this._buildActorSpec();
		if (!tmpSpec) { this.modal.toast('Choose a value for that actor type.', { type: 'warning' }); return; }
		await this.provider.addActorAsync(this._editRefStatus, this._editRefIndex, tmpSpec);
		this._refreshGraph();
		this._renderActions();
		this._showTransitionEditor(this._editRefStatus, this._editRefIndex);
	}

	_addActorModalContent()
	{
		const tmpTypes =
		[
			[ 'ProjectRole', 'Users with a project role' ],
			[ 'UserRole', 'Users with a role' ],
			[ 'UserRoleProjectMembership', 'Users with a role who are project members' ],
			[ 'FormLabRole', 'Users in the form\'s lab with a role' ],
			[ 'ProjectEntitlement', 'Users with a project entitlement' ],
			[ 'FormLabUser', 'Everyone in the form\'s lab' ],
			[ 'FormMaterialLabRole', 'Users assigned to the form\'s lab and material, with a role' ],
			[ 'FormMaterialLabInitialUser', 'First-contact users for the form\'s lab and material' ],
			[ 'FormMaterialLabEscalationUser', 'Escalation users for the form\'s lab and material' ],
			[ 'Users', 'A specific user' ],
			[ 'Admin', 'Administrators' ],
			[ 'CreatingUser', 'The user who created the entity' ],
			[ 'HigherUserLevelInProject', 'Higher-level users in the project' ],
			[ 'MinimumUserLevelInProject', 'Users at least a minimum level' ],
		];
		const tmpTypeOptions = tmpTypes.map((pType) => `<option value="${pType[0]}">${this._esc(pType[1])}</option>`).join('');
		// Roles use a SEARCHABLE, scrollable list (not a long <select>) so an admin can find the right role fast.
		// The full set is already loaded (customerRoles), so the search filters it in-memory; `_roleResults` tracks
		// the currently-shown (filtered) list that `_chooseRoleForActor` indexes into.
		this._roleResults = (this.provider.customerRoles || []).slice();
		const tmpRoleRows = this._roleRowsHTML(this._roleResults, this._addActor && this._addActor.Role);
		const tmpRoleChosen = this._roleChosenText(this._addActor && this._addActor.Role);
		return /*html*/`
			<div class="apwe-addactor">
				<label>Actor type</label>
				<div class="select is-small is-fullwidth"><select id="apw-actor-type" onchange="_Pict.views.ApprovalWorkflowEditor._setActorType(this.value)">${tmpTypeOptions}</select></div>
				<div id="apw-actor-role-wrap">
					<label>Role</label>
					<input type="text" class="input is-small" placeholder="Search roles…" oninput="_Pict.views.ApprovalWorkflowEditor._searchRolesForActor(this.value)">
					<div class="apwe-user-results" id="apw-actor-role-results">${tmpRoleRows}</div>
					<p class="is-size-7 has-text-grey" id="apw-actor-role-chosen">${tmpRoleChosen}</p>
				</div>
				<div id="apw-actor-level-wrap" style="display:none"><label>Minimum level</label><input type="number" id="apw-actor-level" class="input is-small" value="3" min="0" oninput="_Pict.views.ApprovalWorkflowEditor._setActorLevel(this.value)"></div>
				<div id="apw-actor-user-wrap" style="display:none">
					<label>Find user</label>
					<input type="text" class="input is-small" placeholder="Name, login ID or email…" oninput="_Pict.views.ApprovalWorkflowEditor._searchUsersForActor(this.value)">
					<div class="apwe-user-results" id="apw-actor-user-results"></div>
					<p class="is-size-7 has-text-grey" id="apw-actor-user-chosen">No user selected.</p>
				</div>
				<div id="apw-actor-keyword-wrap" style="display:none"><p class="is-size-7 has-text-grey mt-2">This actor type needs no further selection.</p></div>
				${this._tagInputHTML('')}
			</div>`;
	}

	_setActorType(pType)
	{
		this._addActor.Type = pType;
		const tmpRoleTypes = libModel.ROLE_ACTOR_TYPES;
		const tmpShow = (pID, pOn) => { const tmpEl = document.getElementById(pID); if (tmpEl) { tmpEl.style.display = pOn ? '' : 'none'; } };
		tmpShow('apw-actor-role-wrap', tmpRoleTypes.indexOf(pType) > -1);
		tmpShow('apw-actor-level-wrap', pType === 'MinimumUserLevelInProject');
		tmpShow('apw-actor-user-wrap', pType === 'Users');
		tmpShow('apw-actor-keyword-wrap', (libModel.KEYWORD_ACTOR_TYPES.indexOf(pType) > -1) && (pType !== 'MinimumUserLevelInProject'));
	}

	_setActorRole(pLevel) { this._addActor.Role = pLevel; }
	_setActorLevel(pValue) { this._addActor.Level = pValue; }

	async _searchUsersForActor(pQuery)
	{
		this._userResults = await this.provider.searchUsersAsync(pQuery);
		const tmpHTML = this._userResults.length
			? this._userResults.map((pUser, pIndex) => `<a class="panel-block is-size-7" onclick="_Pict.views.ApprovalWorkflowEditor._pickUser(${pIndex})">${this._esc(pUser.Name)}</a>`).join('')
			: '<p class="is-size-7 has-text-grey">No matches.</p>';
		if (document.getElementById('apw-actor-user-results'))
		{
			this.pict.ContentAssignment.assignContent('#apw-actor-user-results', tmpHTML);
		}
	}

	_pickUser(pIndex)
	{
		this._addActor.User = this._userResults[parseInt(pIndex, 10)] || null;
		const tmpEl = document.getElementById('apw-actor-user-chosen');
		if (tmpEl) { tmpEl.textContent = this._addActor.User ? `Selected: ${this._addActor.User.Name}` : 'No user selected.'; }
	}

	/** Render the (filtered) role list as clickable rows, highlighting the chosen one (mirrors the user results). */
	_roleRowsHTML(pRoles, pSelectedLevel)
	{
		if (!Array.isArray(pRoles) || !pRoles.length) { return '<p class="is-size-7 has-text-grey p-2">No matching roles.</p>'; }
		const tmpSelected = (pSelectedLevel == null) ? '' : String(pSelectedLevel);
		return pRoles.map((pRole, pIndex) =>
			`<a class="panel-block is-size-7${String(pRole.PermissionLevel) === tmpSelected ? ' has-text-link has-text-weight-semibold' : ''}" onclick="_Pict.views.ApprovalWorkflowEditor._chooseRoleForActor(${pIndex})">${this._esc(pRole.Name)}</a>`).join('');
	}

	/** The "Selected: …" line for the chosen role level (name resolved from customerRoles). */
	_roleChosenText(pSelectedLevel)
	{
		if (pSelectedLevel == null || pSelectedLevel === '') { return 'No role selected.'; }
		const tmpRole = (this.provider.customerRoles || []).find((pRole) => String(pRole.PermissionLevel) === String(pSelectedLevel));
		return `Selected: ${this._esc(tmpRole ? tmpRole.Name : pSelectedLevel)}`;
	}

	/** Filter the (already-loaded) roles client-side by name or permission level and repaint the results list. */
	_searchRolesForActor(pQuery)
	{
		const tmpQuery = String(pQuery || '').trim().toLowerCase();
		const tmpAll = this.provider.customerRoles || [];
		this._roleResults = tmpQuery
			? tmpAll.filter((pRole) => (String(pRole.Name || '').toLowerCase().indexOf(tmpQuery) > -1) || (String(pRole.PermissionLevel || '').toLowerCase().indexOf(tmpQuery) > -1))
			: tmpAll.slice();
		if (document.getElementById('apw-actor-role-results'))
		{
			this.pict.ContentAssignment.assignContent('#apw-actor-role-results', this._roleRowsHTML(this._roleResults, this._addActor && this._addActor.Role));
		}
	}

	/** Choose a role from the (filtered) list: capture its permission level + update the chosen line + highlight. */
	_chooseRoleForActor(pIndex)
	{
		const tmpRole = (this._roleResults || [])[parseInt(pIndex, 10)] || null;
		if (!tmpRole) { return; }
		this._addActor.Role = tmpRole.PermissionLevel;
		const tmpChosen = document.getElementById('apw-actor-role-chosen');
		if (tmpChosen) { tmpChosen.textContent = `Selected: ${tmpRole.Name}`; }
		if (document.getElementById('apw-actor-role-results'))
		{
			this.pict.ContentAssignment.assignContent('#apw-actor-role-results', this._roleRowsHTML(this._roleResults, this._addActor.Role));
		}
	}

	/** Build the actor spec (object for role/user, string for keyword/level unless tagged) from the captured modal state. */
	_buildActorSpec()
	{
		const tmpState = this._addActor || {};
		const tmpTags = tmpState.Tags || [];
		if (libModel.ROLE_ACTOR_TYPES.indexOf(tmpState.Type) > -1)
		{
			return tmpState.Role ? { Type: tmpState.Type, Hashes: [ String(tmpState.Role) ], Tags: tmpTags } : null;
		}
		if (tmpState.Type === 'Users')
		{
			return tmpState.User ? { Type: 'Users', Hashes: [ String(tmpState.User.IDUser) ], Tags: tmpTags } : null;
		}
		if (tmpState.Type === 'MinimumUserLevelInProject')
		{
			const tmpLevel = parseInt(tmpState.Level, 10);
			if (isNaN(tmpLevel))
			{
				return null;
			}
			return tmpTags.length ? { Type: tmpState.Type, Hashes: [ String(tmpLevel) ], Tags: tmpTags } : `MinimumUserLevelInProject:${tmpLevel}`;
		}
		return tmpTags.length ? { Type: tmpState.Type, Tags: tmpTags } : tmpState.Type;
	}

	/** The tag field shared by the add-actor and set-tags modals. */
	_tagInputHTML(pValue)
	{
		const tmpOptions = (this._actorTagOptions || []).map((pTag) => `<option value="${this._esc(pTag)}"></option>`).join('');
		return `<label>Tags <span class="has-text-weight-normal">(optional, separate with commas)</span></label><input type="text" id="apw-actor-tags" class="input is-small" list="apw-actor-tag-options" value="${this._esc(pValue)}" placeholder="e.g. Primary"><datalist id="apw-actor-tag-options">${tmpOptions}</datalist><p class="is-size-7 has-text-grey mt-1">Tags decide who gets prompted and notified. They don't change who can act. Usual ones: ${this._esc((this._actorTagOptions || []).join(', '))}.</p>`;
	}

	_readTagInput()
	{
		return libModel.parseActorTags((document.getElementById('apw-actor-tags') || {}).value, this._actorTagOptions);
	}

	/** Change the tags on one actor row. */
	async openActorTagsModal(pActorIndex, pSettingIndex)
	{
		await this._commitFields();
		const tmpRow = this.provider.actorLabels(this._editRefStatus, this._editRefIndex).find((pCandidate) => (pCandidate.ActorIndex === pActorIndex) && (pCandidate.SettingIndex === pSettingIndex));
		if (!tmpRow)
		{
			return;
		}
		this._actorTagOptions = libModel.actorTagOptions(this.provider.workflow);
		const tmpChoice = await this.modal.show(
			{
				title: 'Set tags',
				content: `<div class="apwe-addactor"><p class="is-size-7 mb-2">${this._esc(tmpRow.Label)}</p>${this._tagInputHTML(tmpRow.Tags.join(', '))}</div>`,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Apply', Style: 'primary' } ],
			});
		if (tmpChoice !== 'ok')
		{
			return;
		}
		await this.provider.setActorTagsAsync(this._editRefStatus, this._editRefIndex, pActorIndex, pSettingIndex, this._readTagInput());
		this._refreshGraph();
		this._renderActions();
		this._showTransitionEditor(this._editRefStatus, this._editRefIndex);
	}

	_stateEditorRecord(pStatus)
	{
		const tmpStates = (this.provider.workflow && this.provider.workflow.States) || [];
		const tmpState = tmpStates.find((pState) => pState.Status === pStatus);
		if (!tmpState) { return null; }
		const tmpTransitions = (tmpState.Transitions || []).map((pTransition, pIndex) => ({
			Status: this._esc(pStatus), TransitionIndex: pIndex, Action: this._esc(pTransition.Action || '(no action)'), ToStatus: this._esc(pTransition.ToStatus || '(unset)'),
		}));
		return {
			Status: this._esc(pStatus),
			StateName: this._esc(tmpState.StateName || ''),
			Transitions: tmpTransitions,
			EmptySlot: tmpTransitions.length ? [] : [ {} ],
		};
	}

	_showStateEditor(pStatus)
	{
		const tmpRecord = this._stateEditorRecord(pStatus);
		if (!tmpRecord) { this._closeDetail(); return; }
		this._editStateStatus = pStatus;
		this._assignDetail(this.pict.parseTemplateByHash('ApprovalWorkflow-StateEditor-Template', tmpRecord));
	}

	async applyStateForm()
	{
		const tmpValues = this._statePanelValues();
		const tmpResult = await this._applyStatePanel();
		if (!tmpResult.OK)
		{
			return;
		}
		this._showStateEditor(this._editStateStatus);
		this.modal.toast(`Applied to the diagram: state '${tmpValues.StateName || tmpValues.Status}'. Press Save to keep it.`, { type: 'success' });
	}

	async addTransitionFromState()
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		const tmpStatus = this._editStateStatus;
		const tmpIndex = await this.provider.addTransitionAsync(tmpStatus);
		this._refreshGraph();
		this._renderActions();
		this._showTransitionEditor(tmpStatus, tmpIndex);
	}

	async openTransitionEditor(pStatus, pIndex)
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		this._showTransitionEditor((tmpCommit.RenamedFrom === pStatus) ? tmpCommit.RenamedTo : pStatus, parseInt(pIndex, 10));
	}

	async deleteStateFromForm()
	{
		const tmpStatus = this._editStateStatus;
		const tmpCount = this.provider.documentCountFor(tmpStatus);
		const tmpDocuments = tmpCount ? ` At least ${tmpCount.toLocaleString()} document${(tmpCount === 1) ? ' is' : 's are'} in this state and can't be acted on afterwards.` : '';
		const tmpOk = await this.modal.confirm(`Delete the state "${tmpStatus}" and every transition into it?${tmpDocuments}`, { title: 'Delete state', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk) { return; }
		await this.provider.removeStateAsync(tmpStatus);
		this._editStateStatus = null;
		this._refreshGraph();
		this._renderActions();
		this._closeDetail();
	}

	async closeDetail()
	{
		const tmpCommit = await this._commitOpenPanel();
		if (!tmpCommit.OK)
		{
			return;
		}
		this._editRefStatus = null;
		this._editStateStatus = null;
		this._closeDetail();
	}

	_closeDetail()
	{
		this._assignDetail('');
	}
}

module.exports = ApprovalWorkflowEditor;

module.exports.default_configuration =
{
	ViewIdentifier: 'ApprovalWorkflowEditor',
	DefaultRenderable: 'ApprovalWorkflowEditorWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.apwe-wrap { display: flex; flex-direction: column; height: calc(100vh - 3.25rem); padding: 1rem 1.25rem 1rem; box-sizing: border-box; }
		.apwe-header { flex-shrink: 0; display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 0.75rem; }
		.apwe-crumbs { font-size: 0.8rem; margin-bottom: 0.2rem; }
		.apwe-crumbs a { color: var(--bulma-text-weak, #7a8598); font-weight: 600; text-decoration: none; }
		.apwe-crumbs a:hover { color: var(--bulma-link, #156dd1); }
		.apwe-title { font-weight: 700; font-size: 1.35rem; word-break: break-all; display: flex; align-items: center; gap: 0.5rem; }
		.apwe-title .icon { color: var(--bulma-link, #156dd1); }
		.apwe-actions { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; justify-content: flex-end; }
		.apwe-badge { display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.75rem; padding: 0.2rem 0.6rem; border-radius: 999px; background: var(--bulma-scheme-main-bis, #f2f4f8); color: var(--bulma-text-weak, #7a7a7a); border: 1px solid var(--bulma-border, #e6e9ef); }
		.apwe-dirty { display: inline-flex; align-items: center; gap: 0.35rem; color: #b8860b; font-size: 0.78rem; font-weight: 600; }
		.apwe-dirty .icon { font-size: 0.5rem; animation: apwe-pulse 1.6s ease-in-out infinite; }
		@keyframes apwe-pulse { 50% { opacity: 0.35; } }

		/* --- Body: steps rail + canvas side by side. --- */
		.apwe-body { flex: 1; min-height: 0; display: flex; gap: 0.75rem; }

		/* --- Steps rail: the ordered state list beside the diagram. --- */
		.apwe-rail { width: 15rem; flex-shrink: 0; display: flex; flex-direction: column; border: 1px solid var(--bulma-border, #e2e6ee); border-radius: 12px; background: var(--bulma-scheme-main, #fff); overflow: hidden; transition: width 0.16s ease; }
		.apwe-rail.is-collapsed { width: 2.5rem; }
		.apwe-rail.is-collapsed .apwe-rail-title, .apwe-rail.is-collapsed .apwe-rail-count, .apwe-rail.is-collapsed .apwe-steps, .apwe-rail.is-collapsed .apwe-rail-add { display: none; }
		.apwe-rail.is-collapsed .apwe-rail-head { justify-content: center; }
		.apwe-rail.is-collapsed .apwe-rail-toggle i { transform: rotate(180deg); }
		.apwe-rail > #ApprovalWorkflow-Rail { display: flex; flex-direction: column; min-height: 0; flex: 1; }
		.apwe-rail-head { display: flex; align-items: center; gap: 0.4rem; padding: 0.6rem 0.5rem 0.6rem 0.75rem; border-bottom: 1px solid var(--bulma-border, #eef0f4); flex-shrink: 0; }
		.apwe-rail-title { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--bulma-text-weak, #9aa3b2); }
		.apwe-rail-count { font-size: 0.68rem; font-weight: 700; color: var(--bulma-link, #156dd1); background: #eef3fb; border-radius: 999px; padding: 0.05rem 0.45rem; }
		.apwe-rail-toggle { margin-left: auto; border: none; background: transparent; color: var(--bulma-text-weak, #9aa3b2); cursor: pointer; padding: 0.2rem 0.3rem; border-radius: 5px; font-size: 0.75rem; }
		.apwe-rail-toggle:hover { background: var(--bulma-scheme-main-bis, #f1f4f9); color: var(--bulma-link, #156dd1); }
		.apwe-steps { overflow-y: auto; padding: 0.4rem; flex: 1; min-height: 0; }
		.apwe-step { display: flex; align-items: center; gap: 0.55rem; padding: 0.4rem 0.5rem; border-radius: 8px; cursor: pointer; border: 1px solid transparent; transition: background 0.1s, border-color 0.1s, box-shadow 0.1s, opacity 0.1s; }
		.apwe-step:hover { background: var(--bulma-scheme-main-bis, #f4f6fa); }
		.apwe-step.is-active { background: #eef4fd; border-color: #cfe0f6; }
		.apwe-step-dot { flex-shrink: 0; width: 0.85rem; height: 0.85rem; border-radius: 50%; border: 2px solid #999; }
		.apwe-step-main { min-width: 0; }
		.apwe-step-name { font-size: 0.82rem; font-weight: 600; color: #22334c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.apwe-step.is-active .apwe-step-name { color: var(--bulma-link, #156dd1); }
		.apwe-step-sub { font-size: 0.68rem; color: var(--bulma-text-weak, #9aa3b2); }
		.apwe-rail-empty { padding: 1rem 0.6rem; }
		.apwe-rail-add { display: flex; align-items: center; justify-content: center; gap: 0.4rem; margin: 0.4rem; padding: 0.5rem; flex-shrink: 0;
			border: 1px dashed var(--bulma-border, #cdd5e0); border-radius: 8px; background: transparent; color: var(--bulma-link, #156dd1); cursor: pointer; font-weight: 600; font-size: 0.8rem; }
		.apwe-rail-add:hover { background: #eef4fd; border-color: var(--bulma-link, #156dd1); }

		/* --- The graph canvas: a real diagramming surface (dot grid, inset depth). --- */
		.apwe-flow-host { flex: 1; min-height: 0; position: relative; border: 1px solid var(--bulma-border, #e2e6ee); border-radius: 12px; overflow: hidden;
			background-color: var(--bulma-scheme-main-bis, #fbfcfe);
			background-image: radial-gradient(rgba(99,115,145,0.18) 1px, transparent 1px);
			background-size: 22px 22px; background-position: -1px -1px;
			box-shadow: inset 0 1px 3px rgba(20,40,80,0.05); }
		#ApprovalWorkflow-Flow-Container { position: absolute; inset: 0; overflow: hidden; }
		#ApprovalWorkflow-Flow-Container svg { width: 100%; height: 100%; }
		/* graphviz emits <g class="node"> / <g class="edge"> — depth + clickable feel + hover lift. */
		#ApprovalWorkflow-Flow-Container .node, #ApprovalWorkflow-Flow-Container .edge { cursor: pointer; }
		#ApprovalWorkflow-Flow-Container .node { filter: drop-shadow(0 1px 2px rgba(20,40,80,0.16)); transition: filter 0.12s ease; }
		#ApprovalWorkflow-Flow-Container .node:hover { filter: drop-shadow(0 4px 8px rgba(20,40,80,0.26)); }
		#ApprovalWorkflow-Flow-Container .node:hover > text { font-weight: 700; }
		#ApprovalWorkflow-Flow-Container .edge > path { transition: stroke-width 0.12s ease; }
		#ApprovalWorkflow-Flow-Container .edge:hover > path { stroke-width: 3; }
		#ApprovalWorkflow-Flow-Container .edge:hover > text { font-weight: 700; }
		/* Node selected from the steps rail (or by clicking it): blue glow + heavier border. */
		#ApprovalWorkflow-Flow-Container .node.apw-selected { filter: drop-shadow(0 0 0 2px rgba(21,109,209,0.9)) drop-shadow(0 4px 10px rgba(21,109,209,0.35)); }
		#ApprovalWorkflow-Flow-Container .node.apw-selected > path { stroke-width: 3.4; }
		#ApprovalWorkflow-Flow-Container .node.apw-selected > text { font-weight: 700; }
		.apw-graph-error { padding: 2.5rem 1rem; color: var(--bulma-text-weak, #7a7a7a); text-align: center; }
		.apwe-overlay { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 5; background: var(--bulma-scheme-main, #fff); }
		.apwe-spinner { display: inline-block; width: 1.8rem; height: 1.8rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: apwe-spin 0.8s linear infinite; }
		@keyframes apwe-spin { to { transform: rotate(360deg); } }

		/* --- Floating on-canvas controls: zoom cluster + colour legend. --- */
		.apwe-zoom { position: absolute; right: 0.85rem; bottom: 0.85rem; z-index: 6; display: flex; flex-direction: column;
			border-radius: 9px; overflow: hidden; box-shadow: 0 3px 12px rgba(20,40,80,0.18); border: 1px solid var(--bulma-border, #dbe0e8); background: var(--bulma-scheme-main, #fff); }
		.apwe-zoom-btn { display: flex; align-items: center; justify-content: center; width: 2.1rem; height: 2.1rem; border: none; background: var(--bulma-scheme-main, #fff);
			color: #4a5568; cursor: pointer; font-size: 0.85rem; transition: background 0.12s, color 0.12s; }
		.apwe-zoom-btn + .apwe-zoom-btn { border-top: 1px solid var(--bulma-border, #eef0f4); }
		.apwe-zoom-btn:hover { background: var(--bulma-link, #156dd1); color: #fff; }
		.apwe-legend { position: absolute; left: 0.85rem; bottom: 0.85rem; z-index: 6; background: var(--bulma-scheme-main, #fff);
			border: 1px solid var(--bulma-border, #dbe0e8); border-radius: 9px; box-shadow: 0 3px 12px rgba(20,40,80,0.14); overflow: hidden; }
		.apwe-legend-toggle { display: none; align-items: center; justify-content: center; width: 2.1rem; height: 2.1rem; border: none; background: var(--bulma-scheme-main, #fff); color: #4a5568; cursor: pointer; }
		.apwe-legend-body { padding: 0.6rem 0.75rem; font-size: 0.74rem; color: #4a5568; }
		.apwe-legend.is-collapsed .apwe-legend-body { display: none; }
		.apwe-legend.is-collapsed .apwe-legend-toggle { display: flex; }
		.apwe-legend-title { font-size: 0.62rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--bulma-text-weak, #9aa3b2); margin-bottom: 0.4rem; }
		.apwe-legend-row { display: flex; align-items: center; gap: 0.45rem; line-height: 1.7; white-space: nowrap; }
		.apwe-swatch { display: inline-block; width: 0.85rem; height: 0.85rem; border-radius: 3px; border: 1.5px solid #999; flex-shrink: 0; }
		.apwe-line { display: inline-block; width: 0.9rem; height: 0; border-top: 2px solid #8a93a3; flex-shrink: 0; }
		.apwe-line.dashed { border-top-style: dashed; }
		.apwe-legend-sep { height: 1px; background: var(--bulma-border, #eef0f4); margin: 0.4rem 0; }

		/* --- Side detail / edit panel. --- */
		.apwe-detail { position: absolute; top: 0.85rem; right: 0.85rem; width: 23.5rem; max-width: calc(100% - 1.7rem); z-index: 7; pointer-events: none; }
		.apwe-detail-card { pointer-events: auto; background: var(--bulma-scheme-main, #fff); border: 1px solid var(--bulma-border, #dbe0e8); border-radius: 12px;
			box-shadow: 0 12px 34px rgba(20,40,80,0.20); overflow: hidden; max-height: calc(100vh - 8rem); overflow-y: auto;
			animation: apwe-panel-in 0.16s ease-out; }
		@keyframes apwe-panel-in { from { opacity: 0; transform: translateY(-6px); } }
		.apwe-detail-head { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.7rem 0.85rem;
			background: linear-gradient(180deg, var(--bulma-scheme-main-bis, #f6f8fc), var(--bulma-scheme-main, #fff));
			border-bottom: 1px solid var(--bulma-border, #e6e9ef); border-left: 3px solid var(--bulma-link, #156dd1); }
		.apwe-detail-route { font-weight: 700; font-size: 0.92rem; color: #22334c; display: flex; align-items: center; gap: 0.3rem; }
		.apwe-detail-route .icon { color: var(--bulma-link, #156dd1); }
		.apwe-detail-route .apwe-arrow { color: var(--bulma-text-weak, #8a93a3); margin: 0 0.35rem; }
		.apwe-detail-body { padding: 0.85rem; font-size: 0.9rem; line-height: 1.55; color: #2c3e50; }
		.apwe-state-meta { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; margin-bottom: 0.7rem; }
		.apwe-meta-chip { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.72rem; font-weight: 600; color: #5a6b82; background: var(--bulma-scheme-main-bis, #f1f4f9); border-radius: 999px; padding: 0.12rem 0.55rem; }
		.apwe-meta-chip .icon { font-size: 0.68rem; }
		.apwe-state-hash { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.7rem; color: var(--bulma-text-weak, #8a93a3); margin-left: auto; word-break: break-all; }
		.apwe-sublabel { font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--bulma-text-weak, #7a8598); margin: 0.2rem 0 0.35rem; }
		.apwe-detail-hint { margin-top: 0.85rem; padding-top: 0.6rem; border-top: 1px solid var(--bulma-border, #eef0f4); font-size: 0.76rem; color: var(--bulma-text-weak, #7a8598); }
		.apwe-detail-hint .icon { font-size: 0.7rem; color: var(--bulma-link, #156dd1); }
		.apwe-apply-hint { margin: 0.4rem 0 0; font-size: 0.72rem; color: var(--bulma-text-weak, #8a93a3); line-height: 1.4; }
		.apwe-apply-hint .icon { font-size: 0.66rem; color: var(--bulma-link, #156dd1); vertical-align: baseline; margin-right: 0.1rem; }
		.apwe-form label { display: block; font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--bulma-text-weak, #7a8598); margin: 0.7rem 0 0.2rem; }
		.apwe-form label:first-child { margin-top: 0; }
		.apwe-form .input, .apwe-form select { width: 100%; }
		.apwe-checks { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem 0.75rem; margin-top: 0.5rem;
			padding: 0.5rem 0.6rem; background: var(--bulma-scheme-main-bis, #f6f8fc); border-radius: 8px; }
		.apwe-checks label { display: flex; align-items: center; gap: 0.4rem; font-weight: 500; text-transform: none; letter-spacing: 0; color: #2c3e50; font-size: 0.82rem; margin: 0; }
		.apwe-form-actions { display: flex; gap: 0.5rem; margin-top: 0.9rem; }
		.apwe-section-div { height: 1px; background: var(--bulma-border, #eef0f4); margin: 1rem -0.85rem 0; }
		.apwe-trow { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.45rem 0.6rem; border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 8px; margin-bottom: 0.4rem; cursor: pointer; transition: border-color 0.12s, background 0.12s, box-shadow 0.12s; }
		.apwe-trow:hover { background: var(--bulma-scheme-main-bis, #f2f5f9); border-color: var(--bulma-link, #cfe0f6); box-shadow: 0 1px 4px rgba(21,109,209,0.08); }
		.apwe-trow-main { min-width: 0; }
		.apwe-trow-action { font-weight: 600; color: #22334c; }
		.apwe-trow-sub { font-size: 0.76rem; color: var(--bulma-text-weak, #7a7a7a); }
		.apwe-actor-row { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.35rem 0.55rem; background: var(--bulma-scheme-main-bis, #f4f6fa); border: 1px solid var(--bulma-border, #eef0f4); border-radius: 8px; margin-bottom: 0.35rem; }
		.apwe-actor-label { font-size: 0.82rem; color: #2c3e50; min-width: 0; }
		.apwe-level { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; font-size: 0.82rem; padding: 0.45rem 0.7rem; margin-bottom: 0.6rem; border-radius: 8px; background: var(--bulma-scheme-main-bis, #f4f6fa); border: 1px solid var(--bulma-border, #e6e9ef); }
		.apwe-level-link { margin-right: 0.5rem; white-space: nowrap; }
		.apwe-level-revert { margin-left: auto; }
		.apwe-actor-buttons { display: inline-flex; align-items: center; gap: 0.4rem; flex-shrink: 0; }
		.apwe-actor-tag { border: none; background: transparent; color: var(--bulma-text-weak, #7a8598); cursor: pointer; padding: 0.1rem 0.2rem; font-size: 0.75rem; }
		.apwe-actor-tag:hover { color: var(--bulma-link, #156dd1); }
		.apwe-other { margin-top: 0.85rem; padding-top: 0.6rem; border-top: 1px solid var(--bulma-border, #eef0f4); font-size: 0.8rem; }
		.apwe-other-note { font-weight: 400; text-transform: none; letter-spacing: 0; }
		.apwe-other-row { padding: 0.15rem 0; line-height: 1.4; }
		.apwe-other-label { font-weight: 600; margin-right: 0.25rem; }
		.apwe-other-label::after { content: ':'; }
		.apwe-finding { padding: 0.45rem 0.55rem; border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 8px; margin-bottom: 0.4rem; font-size: 0.82rem; line-height: 1.4; cursor: pointer; }
		.apwe-finding:hover { background: var(--bulma-scheme-main-bis, #f2f5f9); }
		.apwe-finding-kind { font-weight: 700; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.03em; margin-right: 0.25rem; }
		.apwe-finding-error .apwe-finding-kind { color: #D84028; }
		.apwe-finding-warning .apwe-finding-kind { color: #b8860b; }
		.apwe-finding-info .apwe-finding-kind { color: var(--bulma-text-weak, #7a8598); }
		.apwe-json-text { width: 100%; height: 60vh; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.78rem; white-space: pre; }
		.apwe-json-error { color: #D84028; font-size: 0.82rem; margin-bottom: 0.5rem; }
		.apwe-preview { max-height: 50vh; overflow-y: auto; font-size: 0.82rem; }
		.apwe-preview-line { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.74rem; padding: 0.15rem 0; word-break: break-word; }
		.apwe-addactor label { display: block; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: #7a8598; margin: 0.6rem 0 0.2rem; }
		.apwe-addactor .input, .apwe-addactor select { width: 100%; }
		.apwe-user-results { max-height: 9rem; overflow-y: auto; margin-top: 0.35rem; border: 1px solid var(--bulma-border, #eef0f4); border-radius: 6px; }
		.apw-actors { font-weight: 700; color: #22334c; }
		.apw-action { font-style: italic; font-weight: 600; }
		.apw-target { font-weight: 700; color: var(--bulma-link, #156dd1); }
		.apw-branch { color: #7a7a7a; font-style: italic; }
	`,

	Templates:
	[
		{
			Hash: 'ApprovalWorkflow-Editor-Wrap',
			Template: /*html*/`
				<div class="apwe-wrap">
					<div class="apwe-header">
						<div>
							<div class="apwe-crumbs"><a href="#/ApprovalWorkflows"><span class="icon is-small"><i class="fas fa-chevron-left"></i></span> Approval Workflows</a></div>
							<div class="apwe-title"><span class="icon"><i class="fas fa-diagram-project"></i></span> {~D:AppData.ApprovalWorkflowEditor.EditorTitle~} <span class="apw-help" role="button" tabindex="0" title="How to read this diagram" onclick="ApprovalWorkflowHelp.show('editor.graph', this)"><i class="fas fa-circle-info"></i></span></div>
						</div>
						<div class="apwe-actions" id="ApprovalWorkflow-Actions"></div>
					</div>

					{~TS:ApprovalWorkflow-Editor-Error:AppData.ApprovalWorkflowEditor.EditorErrorSlot~}
					<div id="ApprovalWorkflow-LevelBanner"></div>

					<div class="apwe-body">
					<div class="apwe-rail" id="ApprovalWorkflow-RailWrap">
						<div id="ApprovalWorkflow-Rail"></div>
					</div>

					<div class="apwe-flow-host">
						<div id="ApprovalWorkflow-Flow-Container"></div>

						<div id="ApprovalWorkflow-Legend" class="apwe-legend">
							<button class="apwe-legend-toggle" title="Legend" onclick="_Pict.views.ApprovalWorkflowEditor.toggleLegend()"><span class="icon is-small"><i class="fas fa-list"></i></span></button>
							<div class="apwe-legend-body">
								<div class="apwe-legend-title">Legend</div>
								<div class="apwe-legend-row"><span class="apwe-swatch" style="background:#e9f6ea;border-color:#449606"></span> Approved / review</div>
								<div class="apwe-legend-row"><span class="apwe-swatch" style="background:#e7f1fd;border-color:#2196F3"></span> Submitted / pending</div>
								<div class="apwe-legend-row"><span class="apwe-swatch" style="background:#fdece8;border-color:#D84028"></span> Rejected</div>
								<div class="apwe-legend-row"><span class="apwe-swatch" style="background:#f1f2f4;border-color:#6F727A"></span> Draft / other</div>
								<div class="apwe-legend-sep"></div>
								<div class="apwe-legend-row"><span class="apwe-line"></span> Transition</div>
								<div class="apwe-legend-row"><span class="apwe-line dashed"></span> Conditional branch</div>
							</div>
						</div>

						<div class="apwe-zoom">
							<button class="apwe-zoom-btn" title="Zoom in" onclick="_Pict.views.ApprovalWorkflowEditor.graphZoomIn()"><i class="fas fa-plus"></i></button>
							<button class="apwe-zoom-btn" title="Zoom out" onclick="_Pict.views.ApprovalWorkflowEditor.graphZoomOut()"><i class="fas fa-minus"></i></button>
							<button class="apwe-zoom-btn" title="Fit to screen" onclick="_Pict.views.ApprovalWorkflowEditor.graphFit()"><i class="fas fa-expand"></i></button>
						</div>

						<div id="ApprovalWorkflow-Detail" class="apwe-detail"></div>
						{~TS:ApprovalWorkflow-Editor-Loading:AppData.ApprovalWorkflowEditor.EditorLoadingSlot~}
					</div>
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Rail-Template',
			Template: /*html*/`
				<div class="apwe-rail-head">
					<span class="apwe-rail-title">Steps</span>
					<span class="apwe-rail-count">{~D:Record.CountText~}</span>
					<button class="apwe-rail-toggle" title="Collapse steps" onclick="_Pict.views.ApprovalWorkflowEditor.toggleRail()"><i class="fas fa-angles-left"></i></button>
				</div>
				<div class="apwe-steps">
					{~TS:ApprovalWorkflow-Rail-Step:Record.Steps~}
					{~TS:ApprovalWorkflow-Rail-Empty:Record.EmptySlot~}
				</div>
				{~TS:ApprovalWorkflow-Rail-AddState:Record.AddStateSlot~}`
		},
		{
			Hash: 'ApprovalWorkflow-Rail-Step',
			Template: /*html*/`
				<div class="apwe-step {~D:Record.ActiveClass~}" data-index="{~D:Record.Index~}" title="{~D:Record.StateName~}"
					data-status="{~D:Record.Status~}" onclick="_Pict.views.ApprovalWorkflowEditor.selectStateFromRail(this.dataset.status)">
					<span class="apwe-step-dot" style="background:{~D:Record.Tint~};border-color:{~D:Record.Color~}"></span>
					<div class="apwe-step-main">
						<div class="apwe-step-name">{~D:Record.StateName~}</div>
						<div class="apwe-step-sub">{~D:Record.OutCount~} out{~D:Record.DocumentText~}</div>
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Rail-AddState',
			Template: /*html*/`<button class="apwe-rail-add" onclick="_Pict.views.ApprovalWorkflowEditor.addStateAndEdit()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Add state</span></button>`
		},
		{
			Hash: 'ApprovalWorkflow-Rail-Empty',
			Template: /*html*/`<p class="apwe-rail-empty has-text-grey is-size-7">No states yet.</p>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-Template',
			Template: /*html*/`
				{~TS:ApprovalWorkflow-Actions-Check:Record.CheckSlot~}
				{~TS:ApprovalWorkflow-Actions-Json:Record.JsonSlot~}
				{~TS:ApprovalWorkflow-Actions-ReadOnly:Record.ReadOnlySlot~}
				{~TS:ApprovalWorkflow-Actions-View:Record.ViewModeSlot~}
				{~TS:ApprovalWorkflow-Actions-Dirty:Record.DirtySlot~}
				{~TS:ApprovalWorkflow-Actions-Delete:Record.DeleteSlot~}
				{~TS:ApprovalWorkflow-Actions-Edit:Record.EditModeSlot~}`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-ReadOnly',
			Template: /*html*/`<span class="apwe-badge" title="Editing requires customer-admin permission."><span class="icon is-small"><i class="fas fa-eye"></i></span> Read only</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-View',
			Template: /*html*/`<span class="apw-help" role="button" tabindex="0" title="About editing" onclick="ApprovalWorkflowHelp.show('editor.edit', this)"><i class="fas fa-circle-info"></i></span><button class="button is-small is-link" onclick="_Pict.views.ApprovalWorkflowEditor.toggleEditMode()"><span class="icon is-small"><i class="fas fa-pen"></i></span><span>Edit</span></button>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-Dirty',
			Template: /*html*/`<span class="apwe-dirty"><span class="icon is-small"><i class="fas fa-circle"></i></span> Unsaved changes</span>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-Edit',
			Template: /*html*/`
				<button class="button is-small" onclick="_Pict.views.ApprovalWorkflowEditor.addStateAndEdit()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Add state</span></button>
				<button class="button is-small is-light" onclick="_Pict.views.ApprovalWorkflowEditor.discardChanges()">Discard</button>
				<button class="button is-small is-success" onclick="_Pict.views.ApprovalWorkflowEditor.saveWorkflow()"><span class="icon is-small"><i class="fas fa-floppy-disk"></i></span><span>Save</span></button>
				<button class="button is-small is-link is-light" onclick="_Pict.views.ApprovalWorkflowEditor.toggleEditMode()">Done</button>`
		},
		{
			Hash: 'ApprovalWorkflow-Detail-Template',
			Template: /*html*/`
				<div class="apwe-detail-card">
					<div class="apwe-detail-head">
						<span class="apwe-detail-route">{~D:Record.SourceStateName~}<span class="apwe-arrow">→</span>{~D:Record.ToStateName~}</span>
						<button class="delete" aria-label="close" onclick="_Pict.views.ApprovalWorkflowEditor.closeDetail()"></button>
					</div>
					<div class="apwe-detail-body">
						{~TS:ApprovalWorkflow-Detail-Branch:Record.BranchSlot~}
						{~D:Record.SentenceText~}
						{~TS:ApprovalWorkflow-OtherSettings:Record.OtherSlot~}
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-OtherSettings',
			Template: /*html*/`
				<div class="apwe-other">
					<div class="apwe-sublabel">Other settings <span class="apwe-other-note">(kept when you save)</span></div>
					{~TS:ApprovalWorkflow-OtherSetting:Record.Rows~}
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-OtherSetting',
			Template: /*html*/`<div class="apwe-other-row"><span class="apwe-other-label">{~D:Record.Label~}</span> <span>{~D:Record.Detail~}</span></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Findings-Template',
			Template: /*html*/`
				<div class="apwe-detail-card">
					<div class="apwe-detail-head">
						<span class="apwe-detail-route"><span class="icon is-small"><i class="fas fa-triangle-exclamation"></i></span> Things to check</span>
						<button class="delete" aria-label="close" onclick="_Pict.views.ApprovalWorkflowEditor.closeDetail()"></button>
					</div>
					<div class="apwe-detail-body">
						{~TS:ApprovalWorkflow-Finding:Record.Findings~}
						{~TS:ApprovalWorkflow-Findings-Empty:Record.EmptySlot~}
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Finding',
			Template: /*html*/`<div class="apwe-finding apwe-finding-{~D:Record.Severity~}" onclick="_Pict.views.ApprovalWorkflowEditor.openFinding({~D:Record.Index~})"><span class="apwe-finding-kind">{~D:Record.Kind~}</span> {~D:Record.Message~}</div>`
		},
		{
			Hash: 'ApprovalWorkflow-Findings-Empty',
			Template: /*html*/`<p class="has-text-grey is-size-7">Nothing to check.</p>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-Delete',
			Template: /*html*/`<button class="button is-small is-danger is-light" onclick="_Pict.views.ApprovalWorkflowEditor.deleteWorkflow()">Delete workflow</button>`
		},
		{
			Hash: 'ApprovalWorkflow-LevelBanner-Template',
			Template: /*html*/`{~TS:ApprovalWorkflow-LevelBanner:Record.Slot~}`
		},
		{
			Hash: 'ApprovalWorkflow-LevelBanner',
			Template: /*html*/`
				<div class="apwe-level">
					<span class="icon is-small"><i class="fas fa-layer-group"></i></span>
					<span>{~D:Record.Message~} {~TS:ApprovalWorkflow-LevelLink:Record.Links~}</span>
					{~TS:ApprovalWorkflow-LevelRevert:Record.RevertSlot~}
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-LevelLink',
			Template: /*html*/`<a class="apwe-level-link" href="{~D:Record.Href~}">{~D:Record.Label~}</a>`
		},
		{
			Hash: 'ApprovalWorkflow-LevelRevert',
			Template: /*html*/`<button class="button is-small is-light apwe-level-revert" onclick="_Pict.views.ApprovalWorkflowEditor.revertToInherited()">{~D:Record.Label~}</button>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-Check',
			Template: /*html*/`<button class="button is-small is-warning is-light" onclick="_Pict.views.ApprovalWorkflowEditor.showFindings()"><span class="icon is-small"><i class="fas fa-triangle-exclamation"></i></span><span>{~D:Record.Count~} thing{~D:Record.Plural~} to check</span></button>`
		},
		{
			Hash: 'ApprovalWorkflow-Actions-Json',
			Template: /*html*/`<button class="button is-small is-light" title="See this workflow's full configuration" onclick="_Pict.views.ApprovalWorkflowEditor.openJsonEditor()"><span class="icon is-small"><i class="fas fa-code"></i></span><span>JSON</span></button>`
		},
		{
			Hash: 'ApprovalWorkflow-Detail-Branch',
			Template: /*html*/`<div class="mb-2"><span class="tag is-warning is-light">Conditional</span></div>`
		},
		{
			Hash: 'ApprovalWorkflow-BranchReadonly-Template',
			Template: /*html*/`
				<div class="apwe-detail-card">
					<div class="apwe-detail-head">
						<span class="apwe-detail-route">{~D:Record.SourceStateName~}<span class="apwe-arrow">→</span>{~D:Record.ToStateName~}</span>
						<button class="delete" aria-label="close" onclick="_Pict.views.ApprovalWorkflowEditor.closeDetail()"></button>
					</div>
					<div class="apwe-detail-body">
						<div class="mb-2"><span class="tag is-warning is-light">Conditional branch — read only</span></div>
						{~D:Record.SentenceText~}
						<p class="has-text-grey is-size-7 mt-2">Branch conditions aren't editable here yet.</p>
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-StateDetail-Template',
			Template: /*html*/`
				<div class="apwe-detail-card">
					<div class="apwe-detail-head">
						<span class="apwe-detail-route"><span class="icon is-small"><i class="fas fa-circle-nodes"></i></span> {~D:Record.StateName~}</span>
						<button class="delete" aria-label="close" onclick="_Pict.views.ApprovalWorkflowEditor.closeDetail()"></button>
					</div>
					<div class="apwe-detail-body">
						<div class="apwe-state-meta">
							<span class="apwe-meta-chip"><span class="icon is-small"><i class="fas fa-arrow-right-to-bracket"></i></span> {~D:Record.IncomingText~}</span>
							<span class="apwe-meta-chip"><span class="icon is-small"><i class="fas fa-arrow-right-from-bracket"></i></span> {~D:Record.OutgoingText~}</span>
							<span class="apwe-state-hash" title="State identity">{~D:Record.Status~}</span>
						</div>
						<div class="apwe-sublabel">Transitions out of this state</div>
						{~TS:ApprovalWorkflow-StateDetail-Transition:Record.Transitions~}
						{~TS:ApprovalWorkflow-StateDetail-Empty:Record.EmptySlot~}
						{~TS:ApprovalWorkflow-StateDetail-Hint:Record.EditHintSlot~}
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-StateDetail-Transition',
			Template: /*html*/`
				<div class="apwe-trow" data-status="{~D:Record.Status~}" data-index="{~D:Record.TransitionIndex~}" onclick="_Pict.views.ApprovalWorkflowEditor.viewTransitionDetail(this.dataset.status, this.dataset.index)">
					<div class="apwe-trow-main"><div class="apwe-trow-action">{~D:Record.Action~}</div><div class="apwe-trow-sub">→ {~D:Record.ToStateName~}</div></div>
					<span class="icon has-text-grey-light"><i class="fas fa-chevron-right"></i></span>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-StateDetail-Empty',
			Template: /*html*/`<p class="has-text-grey is-size-7">This is a terminal state — no transitions leave it.</p>`
		},
		{
			Hash: 'ApprovalWorkflow-StateDetail-Hint',
			Template: /*html*/`<p class="apwe-detail-hint"><span class="icon is-small"><i class="fas fa-pen"></i></span> Click <strong>Edit</strong> (top right) to modify this state.</p>`
		},
		{
			Hash: 'ApprovalWorkflow-TransitionEditor-Template',
			Template: /*html*/`
				<div class="apwe-detail-card">
					<div class="apwe-detail-head">
						<span class="apwe-detail-route"><span class="icon is-small"><i class="fas fa-arrow-right-arrow-left"></i></span> Transition from {~D:Record.SourceStateName~}</span>
						<button class="delete" aria-label="close" onclick="_Pict.views.ApprovalWorkflowEditor.closeDetail()"></button>
					</div>
					<div class="apwe-detail-body apwe-form">
						<label>Action <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('transition.action', this)"><i class="fas fa-circle-info"></i></span></label>
						<input type="text" id="apw-edit-action" class="input is-small" value="{~D:Record.Action~}" />
						<label>Goes to state <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('transition.target', this)"><i class="fas fa-circle-info"></i></span></label>
						<div class="select is-small is-fullwidth"><select id="apw-edit-target">{~TS:ApprovalWorkflow-Option:Record.Options~}</select></div>
						<label>Options <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('transition.flags', this)"><i class="fas fa-circle-info"></i></span></label>
						<div class="apwe-checks">
							<label><input type="checkbox" id="apw-edit-lock" {~D:Record.LockChecked~}> Locks entity</label>
							<label><input type="checkbox" id="apw-edit-unlock" {~D:Record.UnlockChecked~}> Unlocks entity</label>
							<label><input type="checkbox" id="apw-edit-approval" {~D:Record.ApprovalChecked~}> Is an approval</label>
							<label><input type="checkbox" id="apw-edit-allowlocked" {~D:Record.AllowLockedChecked~}> Allowed on locked</label>
						</div>
						<div class="apwe-form-actions">
							<button class="button is-small is-link" title="Put these edits on the diagram. Nothing is stored until you press Save (top right)." onclick="_Pict.views.ApprovalWorkflowEditor.applyTransitionForm()"><span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span><span>Apply to diagram</span></button>
							<button class="button is-small is-danger is-light" onclick="_Pict.views.ApprovalWorkflowEditor.deleteTransitionFromForm()">Delete</button>
						</div>
						<p class="apwe-apply-hint"><span class="icon is-small"><i class="fas fa-circle-info"></i></span> Updates the diagram now; press <strong>Save</strong> (top right) to store it.</p>

						<div class="apwe-section-div"></div>
						<label>Who can perform this action <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('transition.actors', this)"><i class="fas fa-circle-info"></i></span></label>
						{~TS:ApprovalWorkflow-ActorRow:Record.Actors~}
						{~TS:ApprovalWorkflow-ActorEmpty:Record.ActorEmptySlot~}
						<div class="apwe-form-actions">
							<button class="button is-small is-light" onclick="_Pict.views.ApprovalWorkflowEditor.openAddActorModal()"><span class="icon is-small"><i class="fas fa-user-plus"></i></span><span>Add actor</span></button>
						</div>
						{~TS:ApprovalWorkflow-OtherSettings:Record.OtherSlot~}
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-ActorRow',
			Template: /*html*/`
				<div class="apwe-actor-row">
					<span class="apwe-actor-label">{~D:Record.Label~}</span>
					<span class="apwe-actor-buttons">
						<button class="apwe-actor-tag" title="Set tags, which decide who gets notified" aria-label="set tags" onclick="_Pict.views.ApprovalWorkflowEditor.openActorTagsModal({~D:Record.ActorIndex~},{~D:Record.SettingIndex~})"><i class="fas fa-tag"></i></button>
						<button class="delete is-small" aria-label="remove" onclick="_Pict.views.ApprovalWorkflowEditor.removeActor({~D:Record.ActorIndex~},{~D:Record.SettingIndex~})"></button>
					</span>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-ActorEmpty',
			Template: /*html*/`<p class="has-text-grey is-size-7">No one is assigned — this action can't be performed until an actor is added.</p>`
		},
		{
			Hash: 'ApprovalWorkflow-Option',
			Template: /*html*/`<option value="{~D:Record.Status~}" {~D:Record.SelectedAttr~}>{~D:Record.StateName~}</option>`
		},
		{
			Hash: 'ApprovalWorkflow-StateEditor-Template',
			Template: /*html*/`
				<div class="apwe-detail-card">
					<div class="apwe-detail-head">
						<span class="apwe-detail-route"><span class="icon is-small"><i class="fas fa-circle-nodes"></i></span> State</span>
						<button class="delete" aria-label="close" onclick="_Pict.views.ApprovalWorkflowEditor.closeDetail()"></button>
					</div>
					<div class="apwe-detail-body apwe-form">
						<label>Display name <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('state.name', this)"><i class="fas fa-circle-info"></i></span></label>
						<input type="text" id="apw-state-name" class="input is-small" value="{~D:Record.StateName~}" />
						<label>State hash (identity) <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('state.status', this)"><i class="fas fa-circle-info"></i></span></label>
						<input type="text" id="apw-state-status" class="input is-small" value="{~D:Record.Status~}" />
						<div class="apwe-form-actions">
							<button class="button is-small is-link" title="Put these edits on the diagram. Nothing is stored until you press Save (top right)." onclick="_Pict.views.ApprovalWorkflowEditor.applyStateForm()"><span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span><span>Apply to diagram</span></button>
							<button class="button is-small is-danger is-light" onclick="_Pict.views.ApprovalWorkflowEditor.deleteStateFromForm()">Delete state</button>
						</div>
						<p class="apwe-apply-hint"><span class="icon is-small"><i class="fas fa-circle-info"></i></span> Updates the diagram now; press <strong>Save</strong> (top right) to store it.</p>
						<label class="mt-3">Transitions out of this state <span class="apw-help" role="button" tabindex="0" title="What's this?" onclick="ApprovalWorkflowHelp.show('state.transitions', this)"><i class="fas fa-circle-info"></i></span></label>
						{~TS:ApprovalWorkflow-StateEditor-Transition:Record.Transitions~}
						{~TS:ApprovalWorkflow-StateEditor-Empty:Record.EmptySlot~}
						<div class="apwe-form-actions">
							<button class="button is-small is-light" onclick="_Pict.views.ApprovalWorkflowEditor.addTransitionFromState()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Add transition</span></button>
						</div>
					</div>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-StateEditor-Transition',
			Template: /*html*/`
				<div class="apwe-trow" data-status="{~D:Record.Status~}" data-index="{~D:Record.TransitionIndex~}" onclick="_Pict.views.ApprovalWorkflowEditor.openTransitionEditor(this.dataset.status, this.dataset.index)">
					<div class="apwe-trow-main"><div class="apwe-trow-action">{~D:Record.Action~}</div><div class="apwe-trow-sub">→ {~D:Record.ToStatus~}</div></div>
					<span class="icon has-text-grey-light"><i class="fas fa-chevron-right"></i></span>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-StateEditor-Empty',
			Template: /*html*/`<p class="has-text-grey is-size-7">No transitions leave this state.</p>`
		},
		{
			Hash: 'ApprovalWorkflow-Editor-Loading',
			Template: /*html*/`<div class="apwe-overlay has-text-grey"><span class="apwe-spinner"></span><p class="mt-3">Loading workflow…</p></div>`
		},
		{
			Hash: 'ApprovalWorkflow-Editor-Error',
			Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'ApprovalWorkflowEditorWrap', TemplateHash: 'ApprovalWorkflow-Editor-Wrap', ContentDestinationAddress: '#PlatformConfiguration-Application-Container' }
	]
};

},{"../approval-workflow/ApprovalWorkflow-GraphRenderer.js":1066,"../approval-workflow/ApprovalWorkflow-Help.js":1067,"../approval-workflow/ApprovalWorkflow-Model.js":1068,"pict-view":1053}],1407:[function(require,module,exports){

const libPictView = require('pict-view');
require('../approval-workflow/ApprovalWorkflow-Help.js'); // sets window.ApprovalWorkflowHelp for the (i) icons

/**
 * ApprovalWorkflowList — the #/ApprovalWorkflows landing.
 *
 * A card list of the customer's saved approval workflows (Configuration NamespaceKey 'ApprovalWorkflow'),
 * each showing its hash + state/transition counts and linking to the visual editor. "New workflow" seeds a
 * default graph. All data lives in ApprovalWorkflowProvider (AppData.ApprovalWorkflowEditor); this view
 * derives loading/empty/error slots and repaints declaratively.
 */
class ApprovalWorkflowList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ApprovalWorkflow;
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	onBeforeRender(pRenderable)
	{
		const tmpState = this.provider ? this.provider.state : { List: [], ListLoading: false, ListError: '' };
		const tmpAppState = this.pict.AppData.ApprovalWorkflowEditor || {};
		// Conditional slots (single-element-array trick): loading / error / empty.
		tmpAppState.LoadingSlot = tmpState.ListLoading ? [ {} ] : [];
		tmpAppState.ErrorSlot = tmpState.ListError ? [ { Message: tmpState.ListError } ] : [];
		tmpAppState.EmptySlot = (!tmpState.ListLoading && !tmpState.ListError && tmpState.List.length === 0) ? [ {} ] : [];
		tmpAppState.CanEdit = this.provider ? this.provider.canEdit : false;
		tmpAppState.NewButtonSlot = tmpAppState.CanEdit ? [ {} ] : [];
		tmpAppState.WorkflowCount = tmpState.List.length;
		tmpAppState.CountSlot = (!tmpState.ListLoading && !tmpState.ListError && tmpState.List.length > 0) ? [ { Count: tmpState.List.length } ] : [];
		// Per-card Clone control (single-element-array trick): only for users who can edit.
		tmpState.List.forEach((pRow) =>
		{
			pRow.EncodedHash = encodeURIComponent(pRow.Hash);
			pRow.LevelSlot = pRow.LevelText ? [ { Text: this._escapeHTML(pRow.LevelText) } ] : [];
			pRow.CloneControlSlot = tmpAppState.CanEdit ? [ { Hash: this._escapeHTML(pRow.Hash) } ] : [];
		});
		const tmpProjectOnly = (tmpState.ProjectOnlyList || []).map((pRow) => ({ Hash: this._escapeHTML(pRow.Hash), ProjectName: this._escapeHTML(pRow.ProjectName), Href: `#/ApprovalWorkflow/${encodeURIComponent(pRow.Hash)}/Project/${pRow.IDProject}` }));
		tmpAppState.ProjectOnlySlot = tmpProjectOnly.length ? [ { Rows: tmpProjectOnly } ] : [];
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** Client-side filter of the workflow cards by hash (no re-render — just show/hide). */
	filterCards(pQuery)
	{
		const tmpQuery = String(pQuery || '').trim().toLowerCase();
		let tmpVisible = 0;
		Array.prototype.forEach.call(document.querySelectorAll('.apwl-row'), (pRow) =>
		{
			const tmpHash = (pRow.getAttribute('data-hash') || '').toLowerCase();
			const tmpMatch = !tmpQuery || tmpHash.indexOf(tmpQuery) > -1;
			pRow.style.display = tmpMatch ? '' : 'none';
			if (tmpMatch) { tmpVisible++; }
		});
		const tmpEmpty = document.getElementById('ApprovalWorkflow-List-NoMatch');
		if (tmpEmpty) { tmpEmpty.style.display = (tmpVisible === 0 && tmpQuery) ? '' : 'none'; }
	}

	_escapeHTML(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => (
			{ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
	}

	/** Suggest a free "<source>Copy" hash for the clone, bumping a numeric suffix past any collision. */
	_suggestCloneHash(pSourceHash)
	{
		const tmpBase = `${pSourceHash}Copy`;
		if (!this.provider.workflowHashExists(tmpBase)) { return tmpBase; }
		let tmpN = 2;
		while (this.provider.workflowHashExists(`${tmpBase}${tmpN}`)) { tmpN++; }
		return `${tmpBase}${tmpN}`;
	}

	/**
	 * Clone a workflow: prompt for a new name (the hash it is stored under), reject a name collision (a Put to an
	 * existing hash would overwrite it), copy the source blob verbatim, then open the copy in the editor.
	 */
	async cloneWorkflow(pSourceHash)
	{
		if (!this.provider || !this.provider.canEdit) { return; }
		const tmpModal = this.modal;
		const tmpChoice = await tmpModal.show(
			{
				title: 'Clone approval workflow',
				content: `<p>Copy <strong>${this._escapeHTML(pSourceHash)}</strong> to a new workflow. Enter a name (the key it is stored under):</p>`
					+ `<input type="text" id="apw-clone-hash" class="input" value="${this._escapeHTML(this._suggestCloneHash(pSourceHash))}" autofocus>`,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Clone', Style: 'primary' } ],
			});
		if (tmpChoice !== 'ok') { return; }
		const tmpNewHash = ((document.getElementById('apw-clone-hash') || {}).value || '').trim();
		if (!tmpNewHash) { return; }
		const tmpNameProblem = this.provider.nameProblem(tmpNewHash);
		if (tmpNameProblem)
		{
			tmpModal.toast(tmpNameProblem, { type: 'error', duration: 5000 });
			return;
		}
		if (tmpNewHash === pSourceHash) { tmpModal.toast('Choose a different name for the copy.', { type: 'warning' }); return; }
		if (this.provider.workflowHashExists(tmpNewHash))
		{
			tmpModal.toast(`A workflow named "${tmpNewHash}" already exists — choose a different name.`, { type: 'error', duration: 5000 });
			return;
		}
		try
		{
			await this.provider.cloneWorkflowAsync(pSourceHash, tmpNewHash);
			tmpModal.toast(`Cloned "${pSourceHash}" → "${tmpNewHash}".`, { type: 'success' });
			window.location.hash = `#/ApprovalWorkflow/${encodeURIComponent(tmpNewHash)}`;
		}
		catch (pError)
		{
			tmpModal.toast(`Clone failed: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 6000 });
		}
	}
}

module.exports = ApprovalWorkflowList;

module.exports.default_configuration =
{
	ViewIdentifier: 'ApprovalWorkflowList',
	DefaultRenderable: 'ApprovalWorkflowListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.apwl-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 78rem; }
		.apwl-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 0.5rem; }
		.apwl-count { display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 700; color: var(--bulma-link, #156dd1); background: #eef3fb; border-radius: 999px; padding: 0.1rem 0.6rem; margin-left: 0.5rem; vertical-align: middle; }
		.apwl-toolbar { margin: 0.85rem 0 1rem; max-width: 24rem; }
		.apwl-list { border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 12px; background: var(--bulma-scheme-main, #fff); overflow: hidden; }
		.apwl-row { position: relative; display: flex; align-items: center; gap: 0.85rem; padding: 0.7rem 1rem; text-decoration: none; color: inherit; cursor: pointer;
			border-bottom: 1px solid var(--bulma-border, #f0f2f5); border-left: 3px solid transparent; transition: background 0.1s, border-left-color 0.1s; }
		.apwl-row:last-child { border-bottom: none; }
		.apwl-row:hover { background: var(--bulma-scheme-main-bis, #f6f8fc); border-left-color: var(--bulma-link, #156dd1); }
		.apwl-row-ic { flex-shrink: 0; color: var(--bulma-link, #156dd1); }
		.apwl-row-name { flex: 1; min-width: 0; font-weight: 700; color: #22334c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.apwl-row-meta { display: flex; gap: 0.4rem; flex-wrap: wrap; flex-shrink: 0; }
		.apwl-chip { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.72rem; font-weight: 600; padding: 0.15rem 0.55rem; border-radius: 999px; background: var(--bulma-scheme-main-bis, #f1f4f9); color: #5a6b82; }
		.apwl-chip .icon { font-size: 0.72rem; }
		.apwl-clone { flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; width: 1.9rem; height: 1.9rem; border-radius: 8px; color: #8494a8; cursor: pointer; transition: background 0.1s, color 0.1s; }
		.apwl-clone:hover { background: #eef3fb; color: var(--bulma-link, #156dd1); }
		.apwl-clone:focus-visible { outline: 2px solid var(--bulma-link, #156dd1); outline-offset: 1px; }
		.apwl-row-arrow { flex-shrink: 0; color: var(--bulma-border, #cfd6e2); transition: color 0.12s, transform 0.12s; }
		.apwl-row:hover .apwl-row-arrow { color: var(--bulma-link, #156dd1); transform: translateX(2px); }
		.apwl-empty { padding: 2.5rem 1rem; }
		.apwl-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb);
			border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: apwl-spin 0.8s linear infinite; }
		@keyframes apwl-spin { to { transform: rotate(360deg); } }
	`,

	Templates:
	[
		{
			Hash: 'ApprovalWorkflow-List-Wrap',
			Template: /*html*/`
				<div class="apwl-wrap">
					<div class="apwl-header">
						<div>
							<h1 class="title is-4"><span class="icon"><i class="fas fa-diagram-project"></i></span> Approval Workflows{~TS:ApprovalWorkflow-List-Count:AppData.ApprovalWorkflowEditor.CountSlot~} <span class="apw-help" role="button" tabindex="0" title="What are approval workflows?" onclick="ApprovalWorkflowHelp.show('list.overview', this)"><i class="fas fa-circle-info"></i></span></h1>
							<p class="subtitle is-6 has-text-grey">The state-transition workflows that govern how documents and observations move between approval statuses. Open one to edit it as a visual graph.</p>
						</div>
						<div class="field is-grouped">
							<p class="control"><a class="button is-light" href="#/ApprovalWorkflows/Bindings"><span class="icon"><i class="fas fa-file-lines"></i></span><span>Document bindings</span></a></p>
							<p class="control"><a class="button is-light" href="#/ApprovalWorkflows/Bindings/Observation"><span class="icon"><i class="fas fa-clipboard-check"></i></span><span>Observation bindings</span></a></p>
							{~TS:ApprovalWorkflow-List-NewButton:AppData.ApprovalWorkflowEditor.NewButtonSlot~}
						</div>
					</div>

					{~TS:ApprovalWorkflow-List-Error:AppData.ApprovalWorkflowEditor.ErrorSlot~}

					<div class="apwl-toolbar">
						<div class="control has-icons-left">
							<input class="input" type="text" placeholder="Filter workflows…" oninput="_Pict.views.ApprovalWorkflowList.filterCards(this.value)">
							<span class="icon is-left"><i class="fas fa-magnifying-glass"></i></span>
						</div>
					</div>

					<div class="apwl-list">
						{~TS:ApprovalWorkflow-List-Loading:AppData.ApprovalWorkflowEditor.LoadingSlot~}
						{~TS:ApprovalWorkflow-List-Card:AppData.ApprovalWorkflowEditor.List~}
						<div id="ApprovalWorkflow-List-NoMatch" class="apwl-empty has-text-grey has-text-centered" style="display:none"><span class="icon is-large"><i class="fas fa-magnifying-glass fa-lg"></i></span><p class="mt-2">No workflows match your filter.</p></div>
						{~TS:ApprovalWorkflow-List-Empty:AppData.ApprovalWorkflowEditor.EmptySlot~}
					</div>
					{~TS:ApprovalWorkflow-List-ProjectOnly:AppData.ApprovalWorkflowEditor.ProjectOnlySlot~}
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-List-NewButton',
			Template: /*html*/`<button class="button is-link" onclick="window.location.hash = '#/ApprovalWorkflow/New'"><span class="icon"><i class="fas fa-plus"></i></span><span>New workflow</span></button>`
		},
		{
			Hash: 'ApprovalWorkflow-List-Count',
			Template: /*html*/`<span class="apwl-count">{~D:Record.Count~}</span>`
		},
		{
			Hash: 'ApprovalWorkflow-List-Card',
			Template: /*html*/`
				<a class="apwl-row" href="#/ApprovalWorkflow/{~D:Record.EncodedHash~}" data-hash="{~D:Record.Hash~}">
					<span class="icon apwl-row-ic"><i class="fas fa-diagram-project"></i></span>
					<span class="apwl-row-name">{~D:Record.Hash~}</span>
					<span class="apwl-row-meta">
						<span class="apwl-chip"><span class="icon"><i class="fas fa-circle-nodes"></i></span> {~D:Record.StateCount~} states</span>
						<span class="apwl-chip"><span class="icon"><i class="fas fa-arrow-right-arrow-left"></i></span> {~D:Record.TransitionCount~} transitions</span>
						{~TS:ApprovalWorkflow-List-Level:Record.LevelSlot~}
					</span>
					{~TS:ApprovalWorkflow-List-CloneControl:Record.CloneControlSlot~}
					<span class="icon apwl-row-arrow"><i class="fas fa-chevron-right"></i></span>
				</a>`
		},
		{
			Hash: 'ApprovalWorkflow-List-Level',
			Template: /*html*/`<span class="apwl-chip"><span class="icon"><i class="fas fa-layer-group"></i></span> {~D:Record.Text~}</span>`
		},
		{
			Hash: 'ApprovalWorkflow-List-ProjectOnly',
			Template: /*html*/`
				<h2 class="title is-6 mt-5 mb-2">Set only on a project</h2>
				<div class="apwl-list">{~TS:ApprovalWorkflow-List-ProjectOnlyRow:Record.Rows~}</div>`
		},
		{
			Hash: 'ApprovalWorkflow-List-ProjectOnlyRow',
			Template: /*html*/`
				<a class="apwl-project-row apwl-row" href="{~D:Record.Href~}" data-hash="{~D:Record.Hash~}">
					<span class="icon apwl-row-ic"><i class="fas fa-layer-group"></i></span>
					<span class="apwl-row-name">{~D:Record.Hash~}</span>
					<span class="apwl-row-meta"><span class="apwl-chip">{~D:Record.ProjectName~}</span></span>
					<span class="icon apwl-row-arrow"><i class="fas fa-chevron-right"></i></span>
				</a>`
		},
		{
			Hash: 'ApprovalWorkflow-List-CloneControl',
			Template: /*html*/`<span class="apwl-clone" role="button" tabindex="0" title="Clone this workflow" data-hash="{~D:Record.Hash~}" onclick="event.preventDefault();event.stopPropagation();_Pict.views.ApprovalWorkflowList.cloneWorkflow(this.dataset.hash);return false;"><span class="icon"><i class="fas fa-clone"></i></span></span>`
		},
		{
			Hash: 'ApprovalWorkflow-List-Empty',
			Template: /*html*/`
				<div class="apwl-empty has-text-grey has-text-centered">
					<span class="icon is-large"><i class="fas fa-diagram-project fa-2x"></i></span>
					<p class="mt-3">No approval workflows are configured for your organization yet.</p>
				</div>`
		},
		{
			Hash: 'ApprovalWorkflow-List-Loading',
			Template: /*html*/`<div class="apwl-empty has-text-grey has-text-centered"><span class="apwl-spinner"></span><p class="mt-3">Loading approval workflows…</p></div>`
		},
		{
			Hash: 'ApprovalWorkflow-List-Error',
			Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'ApprovalWorkflowListWrap',
			TemplateHash: 'ApprovalWorkflow-List-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"../approval-workflow/ApprovalWorkflow-Help.js":1067,"pict-view":1053}],1408:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * Artifact Type editor — the bespoke record page for an ArtifactType. Defines the artifact's
 * properties (the columns/fields an observation requirement collects). Thin shell: state in
 * pict.AppData.ArtifactTypeEditor, behavior in the ArtifactTypeEditor provider.
 */
class ArtifactTypeEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ArtifactTypeEditor; }

	deriveRenderState() { if (this.provider) { this.provider.deriveRenderState(); } }

	onBeforeRender(pRenderable) { this.deriveRenderState(); return super.onBeforeRender(pRenderable); }

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = ArtifactTypeEditor;

module.exports.default_configuration =
{
	ViewIdentifier: 'ArtifactTypeEditor',
	DefaultRenderable: 'ArtifactTypeEditorWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.ate-wrap { padding: 1.25rem 1.5rem 2rem; }
		.ate-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1rem; }
		.ate-header-actions { display: flex; gap: 0.5rem; flex-shrink: 0; }
		.ate-section-head { display: flex; justify-content: space-between; align-items: center; margin: 1.5rem 0 0.5rem; }
		.ate-prop-table td, .ate-prop-table th { vertical-align: top; }
		.ate-prop-table td { padding-top: 0.45rem; }
		.ate-prop-key { min-width: 8rem; }
		.ate-order .button { padding-left: 0.5rem; padding-right: 0.5rem; }
		.ate-empty { padding: 2.5rem 1rem; }
		.ate-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #485fc7); border-radius: 50%; animation: ate-spin 0.8s linear infinite; }
		@keyframes ate-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'ArtifactType-Wrap',
			Template: /*html*/`
				<div class="ate-wrap">
					{~TS:ArtifactType-Message:AppData.ArtifactTypeEditor.MessageSlot~}
					{~TS:ArtifactType-Loading:AppData.ArtifactTypeEditor.LoadingSlot~}
					{~TS:ArtifactType-Editor:AppData.ArtifactTypeEditor.EditorSlot~}
					{~TS:ArtifactType-Empty:AppData.ArtifactTypeEditor.EmptySlot~}
				</div>`
		},
		{
			Hash: 'ArtifactType-Editor',
			Template: /*html*/`
				<div class="ate-editor">
					<div class="ate-header">
						<div>
							<h1 class="title is-4">{~D:Record.TitleText~}</h1>
							<p class="subtitle is-6 has-text-grey">A reusable data-shape — its fields are the columns of a spreadsheet observation (or the fields of a journal one).</p>
						</div>
						<div class="ate-header-actions">
							<button class="button is-light" onclick="_Pict.providers.ArtifactTypeEditor.backToList()"><span class="icon">{~I:ChevronLeft~}</span><span>Back</span></button>
							{~TS:ArtifactType-SaveButton:AppData.ArtifactTypeEditor.EditorSlot~}
						</div>
					</div>

					{~TS:ArtifactType-ReadOnlyNotice:AppData.ArtifactTypeEditor.ReadOnlyNoticeSlot~}

					<div class="box">
						<div class="field">
							<label class="label is-small">Name</label>
							<div class="control"><input class="input" type="text" value="{~D:Record.Name~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setArtifactName(this.value)" /></div>
						</div>
					</div>

					<div class="ate-section-head">
						<h2 class="title is-5">Fields <span class="tag is-light">{~D:Record.PropertyCount~}</span></h2>
						{~TS:ArtifactType-AddButton:AppData.ArtifactTypeEditor.EditorSlot~}
					</div>
					<p class="help mb-2">Each field is a property of the shape. <strong>Key</strong> is the data key; <strong>Type</strong> picks the input; add comma-separated <strong>Options</strong> to make it a dropdown. Order sets how columns appear.</p>

					<table class="table is-fullwidth is-narrow is-hoverable ate-prop-table">
						<thead><tr><th>Key</th><th>Display name</th><th>Type</th><th>Options (dropdown)</th><th class="has-text-centered">Required</th><th class="has-text-centered">Hidden</th><th class="has-text-right">Order</th></tr></thead>
						<tbody>{~TS:ArtifactType-PropertyRow:AppData.ArtifactTypeEditor.Properties~}</tbody>
					</table>
					{~TS:ArtifactType-EmptyProperties:AppData.ArtifactTypeEditor.EmptyPropertiesSlot~}
				</div>`
		},
		{
			Hash: 'ArtifactType-SaveButton',
			Template: /*html*/`{~TIfAbs:ArtifactType-SaveButton-Inner:Record:Record.CanEdit^TRUE^~}`
		},
		{
			Hash: 'ArtifactType-SaveButton-Inner',
			Template: /*html*/`<button class="button is-link" {~D:Record.SaveDisabledAttr~} onclick="_Pict.providers.ArtifactTypeEditor.saveAsync()"><span class="icon">{~I:Save~}</span><span>Save</span></button>`
		},
		{
			Hash: 'ArtifactType-AddButton',
			Template: /*html*/`{~TIfAbs:ArtifactType-AddButton-Inner:Record:Record.CanEdit^TRUE^~}`
		},
		{
			Hash: 'ArtifactType-AddButton-Inner',
			Template: /*html*/`<button class="button is-small is-link is-light" onclick="_Pict.providers.ArtifactTypeEditor.addProperty()"><span class="icon">{~I:Plus~}</span><span>Add field</span></button>`
		},
		{
			Hash: 'ArtifactType-PropertyRow',
			Template: /*html*/`
				<tr>
					<td><input class="input is-small ate-prop-key" type="text" placeholder="Key" value="{~D:Record.KeyName~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setPropertyField('{~D:Record.Key~}','Key', this.value)" /></td>
					<td><input class="input is-small" type="text" placeholder="(optional)" value="{~D:Record.DisplayName~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setPropertyField('{~D:Record.Key~}','DisplayName', this.value)" /></td>
					<td><div class="select is-small"><select {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setPropertyField('{~D:Record.Key~}','Type', this.value)">{~TS:ArtifactType-TypeOption:Record.TypeOptions~}</select></div></td>
					<td><input class="input is-small" type="text" placeholder="e.g. M, F" value="{~D:Record.EnumOptions~}" {~D:Record.EnumDisabledAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setPropertyField('{~D:Record.Key~}','EnumOptions', this.value)" /></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.RequiredAttr~} {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setPropertyField('{~D:Record.Key~}','Required', this.checked)" /></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.HiddenAttr~} {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ArtifactTypeEditor.setPropertyField('{~D:Record.Key~}','Hidden', this.checked)" /></td>
					<td class="has-text-right ate-order">
						<button class="button is-small is-white" title="Move up" onclick="_Pict.providers.ArtifactTypeEditor.moveUp('{~D:Record.Key~}')">{~I:ArrowUp~}</button>
						<button class="button is-small is-white" title="Move down" onclick="_Pict.providers.ArtifactTypeEditor.moveDown('{~D:Record.Key~}')">{~I:ArrowDown~}</button>
						{~TIfAbs:ArtifactType-RemoveButton:Record:AppData.ArtifactTypeEditor.CanEdit^TRUE^~}
					</td>
				</tr>`
		},
		{
			Hash: 'ArtifactType-TypeOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Value~}</option>`
		},
		{
			Hash: 'ArtifactType-RemoveButton',
			Template: /*html*/`<button class="button is-small is-white" title="Remove field" onclick="_Pict.providers.ArtifactTypeEditor.removeProperty('{~D:Record.Key~}')">{~I:Trash~}</button>`
		},
		{
			Hash: 'ArtifactType-EmptyProperties',
			Template: /*html*/`<p class="has-text-grey has-text-centered py-4">No fields yet. Use <strong>Add field</strong> to define this shape.</p>`
		},
		{
			Hash: 'ArtifactType-ReadOnlyNotice',
			Template: /*html*/`<article class="message is-warning is-small"><div class="message-body"><span class="icon">{~I:Lock~}</span> This artifact type is <strong>read-only</strong> for you — you can edit ones you created (or any, as an admin). Create a new artifact type to define your own.</div></article>`
		},
		{
			Hash: 'ArtifactType-Message',
			Template: /*html*/`<div class="notification {~D:Record.MessageClass~} is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'ArtifactType-Loading',
			Template: /*html*/`<div class="ate-empty box has-text-grey has-text-centered"><span class="ate-spinner"></span><p class="mt-3">Loading…</p></div>`
		},
		{
			Hash: 'ArtifactType-Empty',
			Template: /*html*/`<div class="ate-empty box has-text-grey has-text-centered"><span class="icon is-large">{~I:Code~}</span><p class="mt-3">Pick an artifact type from the list, or create a new one.</p></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'ArtifactTypeEditorWrap',
			TemplateHash: 'ArtifactType-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-view":1053}],1409:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * AssetCatalogSync — the #/AssetCatalogSync screen. A single-pane action surface that seeds THIS customer's
 * PhysicalAsset* catalog (element types, materials, defects, and their links) from the shared public data
 * lake (the AASHTO/NBE national standard). All logic + data live in AssetCatalogSyncProvider, which paints the
 * plan table, buttons, and result into #AssetCatalogSync-Body. See that provider for the mapping + safety
 * (additive create-missing; never overwrites a customer's tuned rows).
 */
class AssetCatalogSync extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.AssetCatalogSync; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadPlanAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = AssetCatalogSync;
module.exports.default_configuration =
{
	ViewIdentifier: 'AssetCatalogSync',
	DefaultRenderable: 'AssetCatalogSyncWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.acs-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 60rem; }
		.acs-head { margin: 0 0 1rem; }
		.acs-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.acs-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.25rem 0 0; max-width:44rem; }
		.acs-panel { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; }
		.acs-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.5rem 0; }
		.acs-note-inline { font-size:0.82rem; color:var(--theme-color-text-muted,#8894a4); margin-left:0.6rem; }
		.acs-error { font-size:0.9rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.55rem 0.75rem; margin:0 0 0.9rem; }
		.acs-summary { font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.9rem; }
		.acs-summary-ok { color:var(--theme-color-text-muted,#6b7686); }
		.acs-table { width:100%; border-collapse:collapse; margin:0 0 1rem; font-size:0.9rem; }
		.acs-table th { text-align:left; font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding:0.4rem 0.5rem; }
		.acs-table td { border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); padding:0.5rem; color:var(--theme-color-text-primary,#1f2733); }
		.acs-table .acs-num { text-align:right; font-variant-numeric: tabular-nums; }
		.acs-cell-label i { color:var(--theme-color-text-muted,#8894a4); width:1.1rem; text-align:center; margin-right:0.35rem; }
		.acs-badge { display:inline-block; font-size:0.72rem; font-weight:700; border-radius:999px; padding:0.12rem 0.55rem; }
		.acs-badge-new { color:#1b6e3a; background:#e4f5ea; }
		.acs-badge-ok { color:#5a6472; background:#eef1f6; }
		.acs-badge-info { color:#1c5a8a; background:#e6f0f9; }
		.acs-result { font-size:0.9rem; color:#1b6e3a; background:#e4f5ea; border-radius:6px; padding:0.55rem 0.75rem; margin:0 0 0.9rem; }
		.acs-result i, .acs-badge-new { }
		.acs-actions { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin-top:0.6rem; }
		.acs-confirm { background:var(--theme-color-status-warning-bg,#fbf3d9); border-radius:7px; padding:0.55rem 0.7rem; }
		.acs-confirm-q { font-size:0.88rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.acs-progress { font-size:0.88rem; color:var(--theme-color-text-muted,#6b7686); }
		.acs-btn { font-size:0.85rem; font-weight:600; padding:0.45rem 0.85rem; border-radius:7px; border:1px solid transparent; cursor:pointer; }
		.acs-btn[disabled] { opacity:0.55; cursor:default; }
		.acs-btn-primary { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; }
		.acs-btn-ghost { background:transparent; border-color:var(--theme-color-border-medium,#c7cfda); color:var(--theme-color-text-primary,#1f2733); }
		.acs-btn-ghost:hover { background:var(--theme-color-background-secondary,#eef1f6); }
	`,
	Templates:
	[
		{
			Hash: 'AssetCatalogSync-Wrap',
			Template: /*html*/`<div class="acs-wrap">
				<div class="acs-head">
					<h1 class="acs-title"><i class="fas fa-cubes"></i> Sync AASHTO Catalog</h1>
					<p class="acs-subtitle">Seed this customer's asset catalog — element types, materials, and defects — from the shared public data lake (the AASHTO/NBE national standard). Adds only what's missing; rows you've already tuned are left untouched.</p>
				</div>
				<div class="acs-panel"><div id="AssetCatalogSync-Body"></div></div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'AssetCatalogSyncWrap',
			TemplateHash: 'AssetCatalogSync-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1410:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * AssetTypeDescriptor view — the shell for the bespoke #/AssetTypeDescriptor screen, where an asset
 * owner shapes what their asset type's metadata LOOKS LIKE: which fields appear on the detail panel,
 * what they are called, their units, their help text, and which of them the map can be coloured by.
 *
 * A thin host, the same shape as SampleListColumnsConfig: paint the header and a single #ATD-Detail
 * mount, then hand everything to the AssetTypeDescriptor provider, which self-loads on first render.
 */
class AssetTypeDescriptor extends libPictView
{
	get provider() { return this.pict.providers.AssetTypeDescriptor; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			// This is the STANDALONE screen, never an embed — clear any embed lock the AssetType workspace's
			// Metadata Shape tab left on the shared provider, so the asset-type picker shows here.
			if (typeof tmpProvider.exitEmbed === 'function') { tmpProvider.exitEmbed(); }
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = AssetTypeDescriptor;
module.exports.default_configuration =
{
	ViewIdentifier: 'AssetTypeDescriptor',
	DefaultRenderable: 'AssetTypeDescriptorWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.atd-wrap { padding: 1.25rem 1.5rem 2rem; }
		.atd-head { margin: 0 0 1rem; }
		.atd-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.atd-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.atd-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
		.atd-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:14rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }

		.atd-bar { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; padding:0 0 0.9rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0 0 0.9rem; }
		.atd-bar-label { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); }
		.atd-select { font-size:0.86rem; padding:0.35rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); max-width:20rem; }
		.atd-spacer { flex:1 1 auto; }
		.atd-pill { font-size:0.7rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; padding:0.2rem 0.6rem; border-radius:999px; border:1px solid var(--theme-color-border-medium,#d5dbe3); color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#f5f7fa); }
		.atd-pill--published { background:var(--theme-color-status-success,#1f7a4d); border-color:var(--theme-color-status-success,#1f7a4d); color:#fff; }
		.atd-pill--draft { background:var(--theme-color-status-warning,#9a6b00); border-color:var(--theme-color-status-warning,#9a6b00); color:#fff; }
		.atd-pill--dirty { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }

		.atd-ident { display:flex; align-items:flex-end; gap:0.8rem; flex-wrap:wrap; margin:0 0 1rem; }
		.atd-fieldwrap { display:flex; flex-direction:column; gap:0.2rem; }
		.atd-fieldwrap-label { font-size:0.64rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); }
		.atd-input { font-size:0.86rem; padding:0.32rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.atd-input--sm { width:7rem; }
		.atd-input--md { width:12rem; }

		.atd-area-head { display:flex; align-items:center; gap:0.5rem; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0 0 0.35rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:1.2rem 0 0.6rem; }
		.atd-hint { font-weight:500; text-transform:none; letter-spacing:normal; color:var(--theme-color-text-muted,#8894a4); }

		.atd-body { overflow-x:hidden; }
		.atd-grp { margin:0 0 1.1rem; }
		.atd-grp-head { display:flex; align-items:center; gap:0.5rem; padding:0.35rem 0.2rem; background:var(--theme-color-background-secondary,#f5f7fa); border-radius:6px; margin:0 0 0.3rem; }
		.atd-grp-key { font-size:0.68rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-muted,#8894a4); flex:0 0 auto; padding-left:0.4rem; }
		.atd-grp-label { flex:1 1 auto; min-width:0; font-size:0.9rem; font-weight:600; padding:0.25rem 0.5rem; border:1px solid transparent; border-radius:5px; background:transparent; color:var(--theme-color-text-primary,#1f2733); }
		.atd-grp-label:hover, .atd-grp-label:focus { border-color:var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-input,#fff); }
		.atd-grp-count { font-size:0.72rem; color:var(--theme-color-text-muted,#8894a4); flex:0 0 auto; }
		.atd-grp-bulk { font-size:0.72rem; font-weight:600; padding:0.2rem 0.5rem; border-radius:5px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }

		.atd-row { display:flex; align-items:center; gap:0.5rem; padding:0.3rem 0.2rem; border-bottom:1px solid var(--theme-color-border-light,#f2f4f8); }
		.atd-row.is-hidden { opacity:0.5; }
		.atd-toggles { flex:0 0 auto; display:flex; gap:0.2rem; }
		.atd-tg { width:1.85rem; height:1.85rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; font-size:0.78rem; padding:0; }
		.atd-tg:hover { color:var(--theme-color-text-primary,#1f2733); }
		.atd-tg.is-on { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.atd-tg.is-on-eye { background:var(--theme-color-status-success,#1f7a4d); border-color:var(--theme-color-status-success,#1f7a4d); color:#fff; }
		.atd-code { flex:0 0 9rem; font-size:0.78rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-muted,#6b7686); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; cursor:help; }
		.atd-label { flex:1 1 14rem; min-width:0; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.atd-units { flex:0 0 6rem; font-size:0.82rem; padding:0.3rem 0.45rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.atd-type { flex:0 0 4.5rem; font-size:0.7rem; text-align:center; color:var(--theme-color-text-muted,#8894a4); text-transform:uppercase; letter-spacing:0.03em; }
		.atd-mv { width:1.5rem; height:1.5rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:5px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.62rem; padding:0; }
		.atd-mv:hover { background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
		.atd-rowacts { flex:0 0 auto; display:flex; gap:0.15rem; }

		.atd-adv { padding:0.5rem 0.6rem 0.8rem 3.2rem; background:var(--theme-color-background-secondary,#f9fafc); border-bottom:1px solid var(--theme-color-border-light,#f2f4f8); }
		.atd-adv-grid { display:flex; gap:0.8rem; flex-wrap:wrap; align-items:flex-end; margin:0 0 0.5rem; }
		.atd-help { width:100%; font-size:0.82rem; padding:0.35rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); resize:vertical; min-height:3.2rem; font-family:inherit; }
		.atd-vals { margin:0.55rem 0 0; }
		.atd-vals-h { font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); margin:0 0 0.25rem; }
		.atd-val { display:flex; align-items:center; gap:0.5rem; padding:0.12rem 0; }
		.atd-val-code { flex:0 0 4rem; font-size:0.75rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-muted,#6b7686); }
		.atd-val-label { flex:1 1 auto; min-width:0; font-size:0.82rem; padding:0.22rem 0.45rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:5px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
			.atd-add { font-size:0.78rem; font-weight:600; padding:0.3rem 0.65rem; border-radius:6px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-brand-primary,#5650e6); cursor:pointer; display:inline-flex; align-items:center; gap:0.3rem; }
			.atd-add:hover { background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
			.atd-add--sm { font-size:0.7rem; padding:0.2rem 0.5rem; }
			.atd-del { width:1.5rem; height:1.5rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:5px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; font-size:0.68rem; padding:0; }
			.atd-del:hover { border-color:var(--theme-color-status-danger,#c0392b); color:var(--theme-color-status-danger,#c0392b); }
			.atd-body-actions { margin:0.7rem 0 0; }
			.atd-grp-key--edit { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.72rem; width:9rem; flex:0 0 9rem; padding:0.2rem 0.4rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:5px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
			.atd-code--edit { flex:0 0 9rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.76rem; padding:0.26rem 0.4rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:5px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
			.atd-type-edit { flex:0 0 7rem; font-size:0.74rem; padding:0.24rem 0.3rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:5px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
			.atd-fieldwrap--chk { flex-direction:row; align-items:center; gap:0.35rem; }
			.atd-val-code--edit { flex:0 0 4rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.74rem; padding:0.16rem 0.35rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:5px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
			.atd-val-mv { width:1.35rem; height:1.35rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:4px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.58rem; padding:0; }
			.atd-val-del { width:1.35rem; height:1.35rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:4px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; font-size:0.66rem; padding:0; }
			.atd-val-del:hover { border-color:var(--theme-color-status-danger,#c0392b); color:var(--theme-color-status-danger,#c0392b); }
			.atd-val-add { font-size:0.72rem; font-weight:600; padding:0.2rem 0.5rem; margin:0.35rem 0 0; border-radius:5px; border:1px dashed var(--theme-color-border-medium,#d5dbe3); background:transparent; color:var(--theme-color-brand-primary,#5650e6); cursor:pointer; }
			.atd-newset { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin:0 0 1rem; padding:0.6rem 0.75rem; background:var(--theme-color-background-tertiary,#fdf8ec); border:1px solid var(--theme-color-status-warning,#9a6b00); border-radius:7px; }
			.atd-newset-l { font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-status-warning,#9a6b00); }
			.atd-grp-label--ro { flex:1 1 auto; min-width:0; font-size:0.9rem; font-weight:600; padding:0.25rem 0.5rem; color:var(--theme-color-text-muted,#8894a4); font-style:italic; }

		.atd-savebar { margin-top:1.2rem; display:flex; gap:0.6rem; align-items:center; flex-wrap:wrap; }
		.atd-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.atd-save--primary { border-color:var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.atd-save[disabled] { opacity:0.55; cursor:default; }
		.atd-size { font-size:0.75rem; color:var(--theme-color-text-muted,#8894a4); }
		.atd-size.is-over { color:var(--theme-color-status-danger,#c0392b); font-weight:600; }
		.atd-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.atd-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); background:var(--theme-color-background-tertiary,#fdf2f0); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; white-space:pre-wrap; }
		.atd-warn { font-size:0.82rem; color:var(--theme-color-status-warning,#9a6b00); background:var(--theme-color-background-tertiary,#fdf8ec); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
	`,
	Templates:
	[
		{
			Hash: 'AssetTypeDescriptor-Wrap',
			Template: /*html*/`
				<div class="atd-wrap">
					<div class="atd-head">
						<h1 class="atd-title">Asset Metadata Shape</h1>
						<p class="atd-subtitle">Choose which metadata appears on an asset's detail panel, what each value is called, its units and its help text, and which values the map can be coloured by. Changes apply to every asset of this type once you publish them.</p>
					</div>
					<div id="ATD-Detail" class="atd-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'AssetTypeDescriptorWrap',
			TemplateHash: 'AssetTypeDescriptor-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1411:[function(require,module,exports){
'use strict';

/**
 * Bulk File Upload — view (ProjectWorkspace ▸ Data ▸ Bulk upload files).
 *
 * A drop zone + "Choose files" front end that stages many files into an editable grid (Name + Designated Date per
 * row, with the observation type auto-detected from the MIME), then uploads them all — one Observation per file —
 * with a per-row progress bar and a byte-weighted overall bar. Rows stay editable before upload (values are baked
 * into each observation) and after (a change PUTs the created observation). Embeds into the workspace Data tab via
 * the shared render()-override / openInto / exitEmbed pattern; the provider owns the row data + upload pipeline and
 * pokes per-row/overall progress straight into the DOM so inputs keep focus mid-upload.
 */

const libPictView = require('pict-view');

const html = String.raw;
const fEsc = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[pChar]));
const fAttr = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));

const TYPE_ICONS = { Image: 'fa-file-image', Video: 'fa-file-video', Audio: 'fa-file-audio', File: 'fa-file-lines' };
const fTypeIcon = (pType) => TYPE_ICONS[pType] || 'fa-file-lines';

const fBytes = (pBytes) =>
{
	const tmpBytes = Number(pBytes) || 0;
	if (tmpBytes < 1024) { return `${tmpBytes} B`; }
	const tmpUnits = [ 'KB', 'MB', 'GB' ];
	let tmpValue = tmpBytes / 1024;
	let tmpUnit = 0;
	while (tmpValue >= 1024 && tmpUnit < tmpUnits.length - 1) { tmpValue /= 1024; tmpUnit++; }
	return `${tmpValue.toFixed(tmpValue >= 10 ? 0 : 1)} ${tmpUnits[tmpUnit]}`;
};

const GRID_MOUNT = '#BulkUpload-Rows';
const OVERALL_MOUNT = '#BulkUpload-Overall';

class BulkUpload extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._embedDestination = null;
	}

	get provider() { return this.pict.providers['BulkUpload']; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType, pDuration)
	{
		if (this.modal && (typeof this.modal.toast === 'function'))
		{
			const tmpOptions = { type: pType || 'info' };
			if (pDuration !== undefined) { tmpOptions.duration = pDuration; }
			this.modal.toast(pMessage, tmpOptions);
		}
	}

	/** Render into the embed host when embedded (provider `_render()` repaints land in the Data tab). */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed for a fixed project. The provider clears staged rows when the project changes. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		if (this.provider) { this.provider.setProject(pIDProject); }
		this.render();
	}

	exitEmbed() { this._embedDestination = null; }

	onBeforeRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.BulkUpload) || {};
		const tmpProvider = this.provider;
		const tmpRows = tmpProvider ? tmpProvider.rows : [];
		tmpState.HasRows = tmpRows.length > 0;
		tmpState.Uploading = !!(tmpProvider && tmpProvider.isUploading);
		tmpState.CanUpload = !!(tmpProvider && tmpProvider.canUpload());
		const tmpTotalBytes = tmpRows.reduce((pSum, pRow) => pSum + (pRow.Size || 0), 0);
		tmpState.CountLabel = `${tmpRows.length} file${tmpRows.length === 1 ? '' : 's'} · ${fBytes(tmpTotalBytes)}`;
		tmpState.EmbedClass = this._embedDestination ? 'bu-embedded' : '';
		// Mutually-exclusive body sections via the single-element-array slot trick.
		tmpState.NoPermSlot = !tmpState.CanUpload ? [ tmpState ] : [];
		tmpState.ToolbarSlot = (tmpState.CanUpload && tmpState.HasRows) ? [ tmpState ] : [];
		tmpState.GridSlot = (tmpState.CanUpload && tmpState.HasRows) ? [ tmpState ] : [];
		this.pict.AppData.BulkUpload = tmpState;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.BulkUpload) || {};
		if (tmpState.CanUpload && tmpState.HasRows) { this.renderGrid(); this.paintOverall(); }
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	// --- File intake ---------------------------------------------------------------------------------

	/** Open the OS multi-file picker. */
	chooseFiles()
	{
		if (this.provider && !this.provider.canUpload()) { return; }
		let tmpInput = document.getElementById('BulkUpload-FileInput');
		if (!tmpInput)
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'file';
			tmpInput.id = 'BulkUpload-FileInput';
			tmpInput.multiple = true;
			tmpInput.style.display = 'none';
			document.body.appendChild(tmpInput);
		}
		tmpInput.value = '';
		tmpInput.onchange = () =>
		{
			const tmpFiles = tmpInput.files;
			tmpInput.onchange = null;
			if (tmpFiles && tmpFiles.length) { this.provider.addFiles(tmpFiles); }
		};
		tmpInput.click();
	}

	onDragOver(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); if (pEvent.dataTransfer) { pEvent.dataTransfer.dropEffect = 'copy'; } }
		const tmpZone = document.getElementById('BulkUpload-Drop');
		if (tmpZone) { tmpZone.classList.add('is-dragover'); }
	}

	onDragLeave(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpZone = document.getElementById('BulkUpload-Drop');
		if (tmpZone) { tmpZone.classList.remove('is-dragover'); }
	}

	onDrop(pEvent)
	{
		if (pEvent) { pEvent.preventDefault(); }
		const tmpZone = document.getElementById('BulkUpload-Drop');
		if (tmpZone) { tmpZone.classList.remove('is-dragover'); }
		if (this.provider && !this.provider.canUpload()) { return; }
		const tmpFiles = pEvent && pEvent.dataTransfer && pEvent.dataTransfer.files;
		if (tmpFiles && tmpFiles.length) { this.provider.addFiles(tmpFiles); }
	}

	// --- Grid ----------------------------------------------------------------------------------------

	renderGrid()
	{
		const tmpMount = this.pict.ContentAssignment.getElement(GRID_MOUNT);
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpRows = this.provider ? this.provider.rows : [];
		this.pict.ContentAssignment.assignContent(GRID_MOUNT, tmpRows.map((pRow) => this._rowHTML(pRow)).join(''));
	}

	_statusCellHTML(pRow)
	{
		if (pRow.Status === 'uploading')
		{
			return `<div class="bu-prog"><div class="bu-prog-fill" style="width:${Math.max(0, Math.min(100, pRow.Progress || 0))}%"></div></div>`
				+ `<span class="bu-prog-pct">${Math.round(pRow.Progress || 0)}%</span>`;
		}
		if (pRow.Status === 'done') { return `<span class="bu-st bu-st--done"><i class="fas fa-circle-check"></i> Uploaded</span>`; }
		if (pRow.Status === 'error') { return `<span class="bu-st bu-st--error" title="${fAttr(pRow.Message)}"><i class="fas fa-triangle-exclamation"></i> ${fEsc(pRow.Message || 'Failed')}</span>`; }
		return `<span class="bu-st bu-st--staged">Ready</span>`;
	}

	_rowHTML(pRow)
	{
		const tmpUID = fAttr(pRow.UID);
		const tmpBusy = (pRow.Status === 'uploading');
		const tmpDisabled = tmpBusy ? 'disabled' : '';
		// Staged/errored rows can be removed (from the list only); a done row is committed — no remove.
		const tmpRemovable = (pRow.Status === 'staged') || (pRow.Status === 'error');
		return html`<tr class="bu-row" data-uid="${tmpUID}" data-status="${fAttr(pRow.Status)}">`
			+ `<td class="bu-ic"><i class="fas ${fTypeIcon(pRow.Type)}"></i></td>`
			+ `<td class="bu-cell-name"><input type="text" class="bu-name" value="${fAttr(pRow.Name)}" ${tmpDisabled} oninput="_Pict.views.BulkUpload.onNameInput('${tmpUID}', this.value)" /></td>`
			+ `<td class="bu-cell-date"><input type="date" class="bu-date" value="${fAttr(pRow.DateISO)}" ${tmpDisabled} onchange="_Pict.views.BulkUpload.onDateInput('${tmpUID}', this.value)" /></td>`
			+ `<td class="bu-cell-type"><span class="bu-type bu-type--${fAttr(pRow.Type)}">${fEsc(pRow.Type)}</span></td>`
			+ `<td class="bu-size">${fEsc(fBytes(pRow.Size))}</td>`
			+ `<td class="bu-status">${this._statusCellHTML(pRow)}</td>`
			+ `<td class="bu-actions">${tmpRemovable ? `<button type="button" class="bu-remove" title="Remove from list" onclick="_Pict.views.BulkUpload.removeRow('${tmpUID}')"><i class="fas fa-xmark"></i></button>` : ''}</td>`
			+ `</tr>`;
	}

	/** Repaint a single row's status + input-disabled state in place (no full re-render → inputs keep focus). */
	paintRow(pUID)
	{
		const tmpRow = this.provider ? this.provider._findRow(pUID) : null;
		if (!tmpRow) { return; }
		const tmpTR = document.querySelector(`.bu-row[data-uid="${(window.CSS && CSS.escape) ? CSS.escape(pUID) : pUID}"]`);
		if (!tmpTR) { return; }
		tmpTR.setAttribute('data-status', tmpRow.Status);
		const tmpStatus = tmpTR.querySelector('.bu-status');
		if (tmpStatus) { tmpStatus.innerHTML = this._statusCellHTML(tmpRow); }
		const tmpBusy = (tmpRow.Status === 'uploading');
		const tmpName = tmpTR.querySelector('.bu-name');
		const tmpDate = tmpTR.querySelector('.bu-date');
		if (tmpName) { tmpName.disabled = tmpBusy; }
		if (tmpDate) { tmpDate.disabled = tmpBusy; }
		const tmpActions = tmpTR.querySelector('.bu-actions');
		if (tmpActions && !((tmpRow.Status === 'staged') || (tmpRow.Status === 'error'))) { tmpActions.innerHTML = ''; }
	}

	/** Repaint the overall progress bar + counts. */
	paintOverall()
	{
		const tmpMount = document.getElementById('BulkUpload-Overall');
		if (!tmpMount || !this.provider) { return; }
		const tmpStats = this.provider.overallStats();
		const tmpParts = [ `${tmpStats.done} of ${tmpStats.total} uploaded` ];
		if (tmpStats.uploading) { tmpParts.push(`${tmpStats.uploading} in progress`); }
		if (tmpStats.failed) { tmpParts.push(`${tmpStats.failed} failed`); }
		tmpMount.innerHTML = `<div class="bu-overall-bar"><div class="bu-overall-fill" style="width:${tmpStats.percent}%"></div></div>`
			+ `<div class="bu-overall-label"><span>${tmpStats.percent}%</span><span>${fEsc(tmpParts.join(' · '))}</span></div>`;
	}

	/** Re-render the toolbar's disabled state (called when an upload run starts/ends). */
	paintToolbar()
	{
		const tmpProvider = this.provider;
		const tmpBusy = !!(tmpProvider && tmpProvider.isUploading);
		const tmpChoose = document.getElementById('BulkUpload-Choose');
		const tmpClear = document.getElementById('BulkUpload-Clear');
		const tmpUpload = document.getElementById('BulkUpload-Start');
		if (tmpChoose) { tmpChoose.disabled = tmpBusy; }
		if (tmpClear) { tmpClear.disabled = tmpBusy; }
		if (tmpUpload)
		{
			tmpUpload.disabled = tmpBusy;
			tmpUpload.innerHTML = tmpBusy
				? '<i class="fas fa-spinner fa-spin"></i> Uploading…'
				: '<i class="fas fa-cloud-arrow-up"></i> Upload';
		}
		const tmpZone = document.getElementById('BulkUpload-Drop');
		if (tmpZone) { tmpZone.classList.toggle('is-disabled', tmpBusy); }
	}

	// --- Row edits + actions -------------------------------------------------------------------------

	onNameInput(pUID, pValue) { if (this.provider) { this.provider.setRowName(pUID, pValue); } }
	onDateInput(pUID, pValue) { if (this.provider) { this.provider.setRowDate(pUID, pValue); } }
	removeRow(pUID) { if (this.provider) { this.provider.removeRow(pUID); } }

	async clearAll()
	{
		if (!this.provider || this.provider.isUploading) { return; }
		const tmpHasDone = this.provider.rows.some((pRow) => pRow.Status === 'done');
		if (tmpHasDone && this.modal && this.modal.confirm)
		{
			const tmpOk = await this.modal.confirm('Clear the list? Uploaded observations stay on the project — this only clears the grid.', { title: 'Clear list', confirmLabel: 'Clear', cancelLabel: 'Cancel' });
			if (!tmpOk) { return; }
		}
		this.provider.clearAll();
	}

	startUpload() { if (this.provider) { this.provider.uploadAllAsync(); } }

}

module.exports = BulkUpload;
module.exports.default_configuration = {
	ViewIdentifier: 'BulkUpload',
	DefaultRenderable: 'BulkUploadWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.bu-wrap { max-width: 1000px; margin: 0 auto; padding: 1.5rem 1.25rem 4rem; }
		.bu-head { display: flex; align-items: flex-start; gap: 0.85rem; margin-bottom: 1.1rem; }
		.bu-head-ic { flex: none; width: 2.4rem; height: 2.4rem; border-radius: 10px; display: grid; place-items: center; background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.1rem; }
		.bu-title { font-size: 1.5rem; font-weight: 700; margin: 0; line-height: 1.15; color: var(--theme-color-text-primary, #1f2733); }
		.bu-sub { margin: 0.15rem 0 0; color: var(--theme-color-text-secondary, #5b6673); font-size: 0.92rem; }

		.bu-noperm { display: flex; align-items: center; gap: 0.6rem; padding: 1rem 1.1rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-secondary, #5b6673); font-size: 0.9rem; }
		.bu-noperm i { color: var(--theme-color-text-muted, #8a94a3); }

		/* Drop zone */
		.bu-drop { border: 2px dashed var(--theme-color-border-default, #d7dce3); border-radius: 12px; padding: 1.6rem 1rem; text-align: center; background: var(--theme-color-background-panel, #fff); transition: border-color 0.12s ease, background 0.12s ease; }
		.bu-drop.is-dragover { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); }
		.bu-drop.is-disabled { opacity: 0.55; pointer-events: none; }
		.bu-drop-ic { font-size: 1.7rem; color: var(--theme-color-brand-primary, #156dd1); opacity: 0.8; margin-bottom: 0.4rem; }
		.bu-drop-main { font-size: 0.98rem; color: var(--theme-color-text-primary, #1f2733); }
		.bu-drop-btn { display: inline-flex; align-items: center; gap: 0.4rem; margin: 0 0.15rem; font: inherit; font-size: 0.95rem; font-weight: 600; cursor: pointer; border: none; background: transparent; color: var(--theme-color-brand-primary, #156dd1); text-decoration: underline; padding: 0; }
		.bu-drop-sub { margin: 0.35rem 0 0; font-size: 0.82rem; color: var(--theme-color-text-muted, #8a94a3); }

		/* Toolbar + overall */
		.bu-toolbar { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; margin: 1rem 0 0.35rem; }
		.bu-count { font-size: 0.88rem; color: var(--theme-color-text-secondary, #5b6673); }
		.bu-spacer { flex: 1 1 auto; }
		.bu-btn { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.85rem; cursor: pointer; padding: 0.5rem 0.9rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.bu-btn:hover:not([disabled]) { background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-primary, #1f2733); }
		.bu-btn[disabled] { opacity: 0.55; cursor: default; }
		.bu-btn-primary { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
		.bu-btn-primary:hover:not([disabled]) { background: var(--theme-color-brand-primary-hover, #1160bd); color: #fff; }
		.bu-overall { margin: 0.35rem 0 0.6rem; }
		.bu-overall-bar { height: 8px; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); overflow: hidden; }
		.bu-overall-fill { height: 100%; background: var(--theme-color-brand-primary, #156dd1); border-radius: 999px; width: 0; transition: width 0.18s ease; }
		.bu-overall-label { display: flex; justify-content: space-between; margin-top: 0.3rem; font-size: 0.78rem; color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; }

		/* Grid */
		.bu-tablewrap { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 12px; overflow: hidden; background: var(--theme-color-background-panel, #fff); }
		.bu-table { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
		.bu-table thead th { text-align: left; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); padding: 0.55rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-secondary, #f7f8fa); }
		.bu-table tbody td { padding: 0.4rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); vertical-align: middle; }
		.bu-table tbody tr:last-child td { border-bottom: none; }
		.bu-row[data-status="error"] { background: rgba(207, 91, 91, 0.06); }
		.bu-row[data-status="done"] .bu-name, .bu-row[data-status="done"] .bu-date { border-color: transparent; background: transparent; }
		.bu-ic { width: 1.6rem; color: var(--theme-color-text-secondary, #5b6673); }
		.bu-cell-name { width: 40%; }
		.bu-name { width: 100%; font: inherit; font-size: 0.88rem; padding: 0.35rem 0.5rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.bu-date { font: inherit; font-size: 0.85rem; padding: 0.32rem 0.45rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.bu-name:focus, .bu-date:focus { outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: -1px; }
		.bu-name[disabled], .bu-date[disabled] { opacity: 0.7; }
		.bu-type { display: inline-block; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.12rem 0.4rem; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-secondary, #5b6673); }
		.bu-type--Image { background: #e8f1fb; color: #1c6bc4; }
		.bu-type--Video { background: #f2e9fb; color: #7a3fc0; }
		.bu-type--Audio { background: #e7f6ee; color: #2f8f57; }
		.bu-type--File { background: #eef0f3; color: #55606e; }
		.bu-size { color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; white-space: nowrap; }
		.bu-status { width: 9.5rem; }
		.bu-prog { display: inline-block; vertical-align: middle; width: 6.5rem; height: 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); overflow: hidden; }
		.bu-prog-fill { height: 100%; background: var(--theme-color-brand-primary, #156dd1); border-radius: 999px; width: 0; transition: width 0.15s ease; }
		.bu-prog-pct { margin-left: 0.4rem; font-size: 0.76rem; color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; }
		.bu-st { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.8rem; }
		.bu-st--staged { color: var(--theme-color-text-muted, #8a94a3); }
		.bu-st--done { color: var(--theme-color-status-success, #3a9e5c); }
		.bu-st--error { color: var(--theme-color-status-error, #cf5b5b); max-width: 12rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.bu-actions { width: 2rem; text-align: right; }
		.bu-remove { border: none; background: transparent; cursor: pointer; color: var(--theme-color-text-muted, #8a94a3); padding: 0.25rem 0.4rem; border-radius: 6px; }
		.bu-remove:hover { color: var(--theme-color-status-error, #cf5b5b); background: rgba(207, 91, 91, 0.12); }

		/* Embedded in the ProjectWorkspace Data tab: shed the standalone page framing + header. */
		.section.bu-embedded { padding: 0; }
		.bu-embedded .bu-wrap { max-width: none; margin: 0; padding: 0; }
		.bu-embedded .bu-head { display: none; }
	`,

	Templates:
	[
		{
			Hash: 'BulkUpload-Template',
			Template: html`
				<section class="section {~D:AppData.BulkUpload.EmbedClass~}">
					<div class="bu-wrap">
						<div class="bu-head">
							<span class="bu-head-ic"><i class="fas fa-cloud-arrow-up"></i></span>
							<div>
								<h1 class="bu-title">Bulk upload files</h1>
								<p class="bu-sub">Add many files at once — each becomes an observation on this project.</p>
							</div>
						</div>
						{~TS:BulkUpload-NoPerm:AppData.BulkUpload.NoPermSlot~}
						<div id="BulkUpload-Drop" class="bu-drop" ondragover="_Pict.views.BulkUpload.onDragOver(event)" ondragleave="_Pict.views.BulkUpload.onDragLeave(event)" ondrop="_Pict.views.BulkUpload.onDrop(event)">
							<div class="bu-drop-ic"><i class="fas fa-cloud-arrow-up"></i></div>
							<div class="bu-drop-main">Drag files here, or <button type="button" id="BulkUpload-Choose" class="bu-drop-btn" onclick="_Pict.views.BulkUpload.chooseFiles()">choose files</button></div>
							<p class="bu-drop-sub">Images become image observations; audio → audio; video → video; everything else → a file observation. You can edit each name &amp; date below before uploading.</p>
						</div>
						{~TS:BulkUpload-Toolbar:AppData.BulkUpload.ToolbarSlot~}
						{~TS:BulkUpload-Grid:AppData.BulkUpload.GridSlot~}
					</div>
				</section>`,
		},
		{ Hash: 'BulkUpload-NoPerm', Template: html`<div class="bu-noperm"><i class="fas fa-lock"></i> Adding observations to this project needs the “Observation create” permission. You can view this screen, but uploading is disabled.</div>` },
		{
			Hash: 'BulkUpload-Toolbar',
			Template: html`
				<div class="bu-toolbar">
					<span class="bu-count">{~D:AppData.BulkUpload.CountLabel~}</span>
					<span class="bu-spacer"></span>
					<button type="button" id="BulkUpload-Clear" class="bu-btn" onclick="_Pict.views.BulkUpload.clearAll()"><i class="fas fa-eraser"></i> Clear</button>
					<button type="button" id="BulkUpload-Start" class="bu-btn bu-btn-primary" onclick="_Pict.views.BulkUpload.startUpload()"><i class="fas fa-cloud-arrow-up"></i> Upload</button>
				</div>
				<div id="BulkUpload-Overall" class="bu-overall"></div>`,
		},
		{
			Hash: 'BulkUpload-Grid',
			Template: html`
				<div class="bu-tablewrap">
					<table class="bu-table">
						<thead><tr><th></th><th>Name</th><th>Designated date</th><th>Type</th><th>Size</th><th>Status</th><th></th></tr></thead>
						<tbody id="BulkUpload-Rows"></tbody>
					</table>
				</div>`,
		},
	],

	Renderables:
	[
		{ RenderableHash: 'BulkUploadWrap', TemplateHash: 'BulkUpload-Template', DestinationAddress: '#PlatformConfiguration-Application-Container' },
	],
};

},{"pict-view":1053}],1412:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * CertificationTypes — the #/CertificationTypes management screen. A left rail lists certification TYPES; the main
 * pane edits the type definition (Name/Hash/Verb/Description) and its per-type configuration (which entity kinds it
 * certifies + certifies-for + default validity). All logic + data live in CertificationTypesProvider, which assigns
 * hand-built HTML into #CertTypes-Rail / #CertTypes-Detail (no widgets — plain inputs + checkboxes).
 */
class CertificationTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.CertificationTypes; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = CertificationTypes;
module.exports.default_configuration =
{
	ViewIdentifier: 'CertificationTypes',
	DefaultRenderable: 'CertificationTypesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.ctp-wrap { padding: 1.25rem 1.5rem 2rem; }
		.ctp-head { margin: 0 0 1rem; }
		.ctp-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.ctp-cols { display:grid; grid-template-columns: 18rem 1fr; gap:1.1rem; align-items:start; }
		@media (max-width: 860px) { .ctp-cols { grid-template-columns: 1fr; } }
		.ctp-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; max-height:44rem; display:flex; flex-direction:column; }
		.ctp-rail-search { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; margin:0 0 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.ctp-newtype-btn { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.82rem; font-weight:600; padding:0.4rem 0.6rem; margin:0 0 0.55rem; border:1px dashed var(--theme-color-border-medium,#c7cfda); border-radius:7px; background:transparent; color:var(--theme-color-brand-primary,#2e7d74); cursor:pointer; }
		.ctp-newtype-btn:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.ctp-rail-list { flex:1 1 auto; min-height:0; overflow:auto; }
		.ctp-rail-item { padding:0.45rem 0.55rem; border-radius:6px; cursor:pointer; }
		.ctp-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.ctp-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); }
		.ctp-rail-item.is-active .ctp-rail-name, .ctp-rail-item.is-active .ctp-rail-sub { color:#fff; }
		.ctp-rail-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-rail-sub { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); margin-top:0.1rem; }
		.ctp-empty, .ctp-detail-empty { font-size:0.85rem; color:var(--theme-color-text-muted,#8894a4); padding:0.5rem 0.55rem; }
		.ctp-main, .ctp-detail-empty { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
		.ctp-detail-empty { display:flex; align-items:center; justify-content:center; text-align:center; }
		.ctp-detail-head { margin:0 0 1rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding-bottom:0.7rem; position:relative; }
		.ctp-detail-title { font-size:1.2rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-detail-sub { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.ctp-go { position:absolute; top:0; right:0; }
		.ctp-section { margin:0 0 1.3rem; }
		.ctp-section-head { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.5rem; }
		.ctp-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.7rem; }
		.ctp-hint { font-size:0.8rem; color:var(--theme-color-status-warning,#8a6d1b); background:var(--theme-color-status-warning-bg,#fbf3d9); border-radius:6px; padding:0.4rem 0.6rem; margin:0 0 0.7rem; }
		.ctp-field { display:flex; flex-direction:column; gap:0.2rem; font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.6rem; }
		.ctp-field input, .ctp-field textarea { font-size:0.9rem; font-weight:400; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); max-width:34rem; }
		.ctp-field-inline { flex-direction:row; align-items:center; gap:0.6rem; flex-wrap:wrap; }
		.ctp-field-inline input { max-width:6rem; }
		.ctp-hint-inline { font-size:0.72rem; font-weight:400; color:var(--theme-color-text-muted,#8894a4); }
		.ctp-cfg-group { margin:0 0 0.9rem; }
		.ctp-cfg-head { font-size:0.72rem; font-weight:700; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.35rem; }
		.ctp-checks { display:flex; flex-wrap:wrap; gap:0.3rem 1rem; }
		.ctp-check { display:inline-flex; align-items:center; gap:0.35rem; font-size:0.85rem; color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.ctp-add-row { display:flex; align-items:center; gap:0.5rem; margin:0.5rem 0 0; }
		.ctp-btn { font-size:0.82rem; font-weight:600; padding:0.4rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.ctp-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.ctp-btn-ghost { background:transparent; }
		.ctp-btn-danger { color:#fff; background:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.ctp-btn-danger-link { color:var(--theme-color-status-danger,#c0392b); border:none; background:transparent; padding:0.3rem 0; }
		.ctp-danger { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:0.8rem; }
		.ctp-busy { font-size:0.8rem; color:var(--theme-color-primary,#2f6fed); font-weight:600; }
		.ctp-notice { font-size:0.85rem; color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); border-radius:6px; padding:0.45rem 0.6rem; margin:0.6rem 0 0; }
		.ctp-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0.5rem 0 0; }
		.ctp-suggest-btn { color:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.ctp-suggest-list { display:flex; flex-direction:column; gap:0.6rem; margin:0.2rem 0 0.9rem; }
		.ctp-suggest { display:flex; align-items:center; gap:0.8rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; padding:0.7rem 0.85rem; background:var(--theme-color-background-secondary,#f7f9fc); }
		.ctp-suggest-main { flex:1 1 auto; min-width:0; }
		.ctp-suggest-name { font-size:0.95rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-suggest-desc { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); margin:0.15rem 0 0; }
		.ctp-suggest-meta { font-size:0.72rem; color:var(--theme-color-text-muted,#8894a4); margin:0.3rem 0 0; }
		.ctp-adopt { flex:0 0 auto; }
	`,
	Templates:
	[
		{
			Hash: 'CertificationTypes-Wrap',
			Template: /*html*/`
				<div class="ctp-wrap">
					<div class="ctp-head">
						<h1 class="ctp-title">Certification Types</h1>
						<p class="ctp-subtitle">Create and edit certification types, and configure what each one certifies (users, labs, materials, equipment, tests) and certifies-for. That configuration drives a simplified certifying screen.</p>
					</div>
					<div class="ctp-cols">
						<div id="CertTypes-Rail" class="ctp-rail"></div>
						<div id="CertTypes-Detail" class="ctp-main"></div>
					</div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CertificationTypesWrap',
			TemplateHash: 'CertificationTypes-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1413:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * Certifications — the #/Certifications workspace. A left rail lists certification TYPES; the main pane bulk-certifies
 * users (dates + multi-user picker), lists/removes current holders, and manages Material/Lab applicability. All logic
 * + data live in CertificationsProvider, which assigns hand-built HTML into #Cert-Rail / #Cert-Detail and mounts the
 * Pict-Section-Picker widgets (SamplePlan/Entitlements idiom).
 */
class Certifications extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.Certifications; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
			tmpProvider.mountPickers();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = Certifications;
module.exports.default_configuration =
{
	ViewIdentifier: 'Certifications',
	DefaultRenderable: 'CertificationsWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.cert-wrap { padding: 1.25rem 1.5rem 2rem; }
		.cert-head { margin: 0 0 1rem; }
		.cert-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.cert-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.cert-cols { display:grid; grid-template-columns: 18rem 1fr; gap:1.1rem; align-items:start; }
		@media (max-width: 860px) { .cert-cols { grid-template-columns: 1fr; } }
		.cert-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; max-height:44rem; display:flex; flex-direction:column; }
		.cert-rail-search { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; margin:0 0 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.cert-newtype-btn { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.82rem; font-weight:600; padding:0.4rem 0.6rem; margin:0 0 0.55rem; border:1px dashed var(--theme-color-border-medium,#c7cfda); border-radius:7px; background:transparent; color:var(--theme-color-brand-primary,#2e7d74); cursor:pointer; }
		.cert-newtype-btn:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.cert-rail-list { flex:1 1 auto; min-height:0; overflow:auto; }
		.cert-rail-item { padding:0.45rem 0.55rem; border-radius:6px; cursor:pointer; }
		.cert-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.cert-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); }
		.cert-rail-item.is-active .cert-rail-name, .cert-rail-item.is-active .cert-rail-sub { color:#fff; }
		.cert-rail-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.cert-rail-sub { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); margin-top:0.1rem; }
		.cert-empty, .cert-detail-empty { font-size:0.85rem; color:var(--theme-color-text-muted,#8894a4); padding:0.5rem 0.55rem; }
		.cert-main, .cert-detail-empty { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
		.cert-detail-empty { display:flex; align-items:center; justify-content:center; text-align:center; }
		.cert-detail-head { margin:0 0 1rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding-bottom:0.7rem; }
		.cert-detail-title { font-size:1.2rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.cert-detail-sub { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.cert-detail-desc { font-size:0.85rem; color:var(--theme-color-text-secondary,#45505f); margin:0.5rem 0 0; }
		.cert-section { margin:0 0 1.3rem; }
		.cert-section-head { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.5rem; display:flex; align-items:center; gap:0.5rem; }
		.cert-count { font-size:0.66rem; font-weight:700; color:var(--theme-color-text-muted,#6b7686); text-transform:none; letter-spacing:0; }
		.cert-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.7rem; }
		.cert-dates { display:flex; flex-wrap:wrap; align-items:flex-end; gap:0.7rem; margin:0 0 0.6rem; }
		.cert-date, .cert-notes, .cert-field { display:flex; flex-direction:column; gap:0.2rem; font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); }
		.cert-date input, .cert-notes input, .cert-field input, .cert-field textarea { font-size:0.85rem; font-weight:400; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.cert-notes, .cert-field { margin:0 0 0.6rem; }
		.cert-notes input, .cert-field input, .cert-field textarea { max-width:32rem; }
		.cert-presets { display:inline-flex; gap:0.3rem; padding-bottom:0.35rem; }
		.cert-preset { font-size:0.72rem; font-weight:600; padding:0.3rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.cert-preset:hover { background:var(--theme-color-background-tertiary,#e2e7ef); }
		.cert-add-row { display:flex; align-items:flex-start; gap:0.5rem; margin:0.4rem 0 0; }
		.cert-userpicker { flex:1 1 auto; min-width:0; max-width:34rem; }
		.cert-entpicker { flex:0 0 20rem; min-width:0; }
		.cert-btn { flex:0 0 auto; font-size:0.82rem; font-weight:600; padding:0.4rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.cert-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.cert-btn-ghost { background:transparent; }
		.cert-busy { font-size:0.8rem; color:var(--theme-color-primary,#2f6fed); font-weight:600; align-self:center; }
		.cert-notice { font-size:0.85rem; color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); border-radius:6px; padding:0.45rem 0.6rem; margin:0.6rem 0 0; }
		.cert-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0.5rem 0 0; }
		.cert-holder { display:flex; align-items:center; gap:0.7rem; padding:0.4rem 0.2rem; border-bottom:1px solid var(--theme-color-border-light,#f0f2f6); }
		.cert-holder-main { flex:1 1 auto; min-width:0; display:flex; align-items:center; gap:0.5rem; }
		.cert-holder-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.cert-holder-dates { flex:0 0 auto; font-size:0.78rem; color:var(--theme-color-text-muted,#6b7686); }
		.cert-badge { font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.06rem 0.4rem; border-radius:9px; }
		.cert-badge-active { color:#276749; background:#e6f4ea; }
		.cert-badge-exp { color:#9b2c2c; background:#fdecec; }
		.cert-badge-future { color:#8a6d1b; background:#fbf3d9; }
		.cert-kind-badge { font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.06rem 0.4rem; border-radius:9px; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-tertiary,#e2e7ef); }
		.cert-kind { display:flex; flex-direction:column; gap:0.2rem; font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.6rem; }
		.cert-kind-select { font-size:0.85rem; font-weight:400; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); max-width:16rem; }
		.cert-kind-fixed { font-size:0.9rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); padding:0.35rem 0 0.1rem; }
		.cert-preset-default { border-color:var(--theme-color-primary,#2f6fed); color:var(--theme-color-primary,#2f6fed); font-weight:700; }
		.cert-holder-search { width:100%; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; margin:0 0 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.cert-holders-meta { display:flex; flex-wrap:wrap; align-items:center; justify-content:space-between; gap:0.5rem; margin:0 0 0.4rem; }
		.cert-pager { display:inline-flex; align-items:center; gap:0.4rem; }
		.cert-page-ind { font-size:0.72rem; color:var(--theme-color-text-muted,#6b7686); }
		.cert-page-btn { font-size:0.75rem; font-weight:600; padding:0.2rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.cert-page-btn:disabled { opacity:0.45; cursor:default; }
		.cert-page-btn:not(:disabled):hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.cert-x { flex:0 0 auto; border:none; background:transparent; color:var(--theme-color-text-muted,#98a2b3); cursor:pointer; padding:0.2rem 0.35rem; border-radius:5px; }
		.cert-x:hover { color:var(--theme-color-status-danger,#c0392b); background:var(--theme-color-status-danger-bg,#fdecec); }
		.cert-applies-add { display:flex; align-items:center; flex-wrap:wrap; gap:0.5rem; margin:0.5rem 0 0.2rem; }
		.cert-applies-lbl { font-size:0.72rem; font-weight:700; color:var(--theme-color-text-secondary,#45505f); }
		.cert-applies-select { font-size:0.85rem; padding:0.4rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.cert-applies-fixed { font-size:0.9rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.cert-applies-add .cert-entpicker { flex:0 0 20rem; min-width:0; }
		.cert-applies-group { margin:0 0 0.9rem; }
		.cert-applies-head { font-size:0.72rem; font-weight:700; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.35rem; }
		.cert-chips { display:flex; flex-wrap:wrap; gap:0.4rem; }
		.cert-chip { display:inline-flex; align-items:center; gap:0.2rem; font-size:0.8rem; padding:0.2rem 0.2rem 0.2rem 0.55rem; border-radius:14px; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
	`,
	Templates:
	[
		{
			Hash: 'Certifications-Wrap',
			Template: /*html*/`
				<div class="cert-wrap">
					<div class="cert-head">
						<h1 class="cert-title">Certifications</h1>
						<p class="cert-subtitle">Pick or create a certification type, then certify holders in bulk — users, materials, labs, equipment or tests (with optional start/end dates) — and set which materials and labs it applies to.</p>
					</div>
					<div class="cert-cols">
						<div id="Cert-Rail" class="cert-rail"></div>
						<div id="Cert-Detail" class="cert-main"></div>
					</div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CertificationsWrap',
			TemplateHash: 'Certifications-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1414:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

const CO_CSS = /*css*/`
	.co-wrap { padding: 0.25rem 0.1rem 1.5rem; }
	.co-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
	.co-eyebrow { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #8a94a3); }
	.co-title { font-size: 1.3rem; font-weight: 700; color: var(--theme-color-text-primary, #1f2733); margin: 0.15rem 0 0; display: flex; align-items: center; gap: 0.6rem; }
	.co-back { cursor: pointer; color: var(--theme-color-brand-primary, #5650e6); }
	.co-back:hover { text-decoration: underline; }
	.co-head-actions { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
	.co-btn { font-size: 0.85rem; font-weight: 600; padding: 0.5rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); cursor: pointer; white-space: nowrap; }
	.co-btn:hover { background: var(--theme-color-background-secondary, #f5f6fb); }
	.co-btn-primary { background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); color: #fff; }
	.co-btn-primary:hover { background: var(--theme-color-brand-primary-hover, #4740d4); }
	.co-form-host { margin-top: 0.8rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.5rem; min-height: 12rem; background: var(--theme-color-background-primary, #fff); }
	.co-filter { width: 22rem; max-width: 100%; box-sizing: border-box; font-size: 0.9rem; padding: 0.5rem 0.7rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px; background: var(--theme-color-background-primary, #fff); }
	.co-filter:focus { outline: none; border-color: var(--theme-color-brand-primary, #5650e6); box-shadow: 0 0 0 2px rgba(86,80,230,0.15); }
	.co-note { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); padding: 1.4rem 0.4rem; }
	.co-note-error { color: var(--theme-color-status-error, #cf5b5b); }
	.co-note-info { background: var(--theme-color-background-secondary, #f5f6fb); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 7px; padding: 0.6rem 0.8rem; margin: 0 0 0.8rem; }
	.co-note-locked { text-align: center; }
	.co-mode { font-size: 0.86rem; border-radius: 7px; padding: 0.55rem 0.8rem; margin: 0 0 0.8rem; display: flex; align-items: center; gap: 0.5rem; }
	.co-mode-required { color: #8a5a00; background: rgba(184,134,11,0.12); border: 1px solid rgba(184,134,11,0.25); }
	.co-mode-direct { color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-secondary, #f5f6fb); border: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.co-list { display: flex; flex-direction: column; }
	.co-row { display: grid; grid-template-columns: 8rem 1fr 8rem 7.5rem 7rem 1.4rem; align-items: center; gap: 0.6rem; padding: 0.6rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
	.co-row-head { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
	.co-row-click { cursor: pointer; }
	.co-row-click:hover { background: var(--theme-color-background-secondary, #f5f6fb); }
	.co-c-num { font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.co-c-desc { color: var(--theme-color-text-secondary, #45505f); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.co-c-amt { text-align: right; font-variant-numeric: tabular-nums; color: var(--theme-color-text-primary, #1f2733); }
	.co-c-date { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.85rem; }
	.co-c-chev { color: var(--theme-color-text-muted, #c8cfd8); text-align: right; }
	.co-pill { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.1rem 0.5rem; border-radius: 9px; white-space: nowrap; }
	.co-st-draft { color: #5a6573; background: rgba(90,101,115,0.12); }
	.co-st-pending { color: #b8860b; background: rgba(184,134,11,0.14); }
	.co-st-submitted { color: #2f6fed; background: rgba(47,111,237,0.13); }
	.co-st-approved { color: #1c8a54; background: rgba(28,138,84,0.14); }
	.co-st-rejected { color: #cf5b5b; background: rgba(207,91,91,0.14); }
	.co-detail-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0.9rem 1.4rem; padding: 1rem 0.2rem 0.4rem; border-top: 1px solid var(--theme-color-border-light, #eef1f5); }
	.co-field { display: flex; flex-direction: column; gap: 0.2rem; }
	.co-field-label { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); }
	.co-field-value { font-size: 0.95rem; color: var(--theme-color-text-primary, #1f2733); font-variant-numeric: tabular-nums; }
	.co-form-link { color: var(--theme-color-brand-primary, #5650e6); text-decoration: none; font-size: 0.9rem; }
	.co-form-link:hover { text-decoration: underline; }
	.co-block { margin: 0.9rem 0.2rem 0; }
	.co-block-label { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.25rem; }
	.co-block-body { font-size: 0.92rem; color: var(--theme-color-text-secondary, #45505f); white-space: pre-wrap; }
	.co-lines-label { margin: 1.4rem 0.2rem 0.4rem; display: flex; align-items: center; gap: 0.5rem; }
	.co-lines-count { font-size: 0.7rem; font-weight: 700; color: #fff; background: var(--theme-color-text-muted, #8a94a3); border-radius: 9px; padding: 0.02rem 0.45rem; }
	.co-lines { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
	.co-lrow { display: grid; grid-template-columns: 5rem 1fr 7rem 8rem 8rem 8rem; align-items: center; gap: 0.5rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); font-size: 0.88rem; }
	.co-lrow:last-child { border-bottom: none; }
	.co-lrow-head { font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-tertiary, #f4f6f9); }
	.co-l-qty, .co-l-cpu, .co-l-amt { text-align: right; font-variant-numeric: tabular-nums; }
	.co-l-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`;

/**
 * ChangeOrders — the ProjectWorkspace Contract ▸ Change Orders tab. A thin shell embedded into the workspace tab
 * host (openInto / exitEmbed / render-override, like ProjectFunding); all logic + HTML live in the provider,
 * painted into #CO-Body.
 */
class ChangeOrders extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// When embedded in the ProjectWorkspace tab host this holds that host selector; every render targets it.
		this._embedDestination = null;
	}

	get provider() { return this.pict.providers.ChangeOrders; }

	/** Render into the embed host when embedded (so provider-triggered repaints land in the tab, not the app container). */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed the change-orders surface into a host for a fixed project; reloads only when the project differs. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		const tmpProvider = this.provider;
		if (tmpProvider && (!tmpProvider.hasModel || (Number(tmpProvider.idProject) !== Number(pIDProject))))
		{
			tmpProvider.loadAsync(pIDProject);
		}
		else { this.render(); }
	}

	exitEmbed() { this._embedDestination = null; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		if (this.provider) { this.provider.renderBody(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ChangeOrders;

module.exports.default_configuration =
{
	ViewIdentifier: 'ChangeOrders',
	DefaultRenderable: 'ChangeOrdersWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: CO_CSS,
	Templates:
	[
		{
			Hash: 'ChangeOrders-Wrap',
			Template: /*html*/`<div class="co-wrap"><div id="CO-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ChangeOrdersWrap',
			TemplateHash: 'ChangeOrders-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1415:[function(require,module,exports){
const libPictView = require('pict-view');

// Offer the filter box once the connected list exceeds one page.
const PAGE_SIZE = 25;

/**
 * ChildListTab — a generic, config-driven read-view tab that MANAGES an entity's 1:N foreign-key children
 * (e.g. a Test Specification Set's Test Specifications, a Pay Item's Line Items).
 *
 * pict-section-recordset's read view has no native "child list" tab type, but its `View` tab type renders
 * any registered pict-view into the tab body. One configured instance of this view is registered per
 * (parent, child, FK) relationship (see PlatformConfiguration-Application-Web.js); the builder points a
 * `{ Type: 'View', View: <id> }` read tab at it (see MasterList-Builder.childListViewId).
 *
 * Unlike a many-to-many join (managed by RecordSet-AssociationEditor via a join table), a 1:N child is
 * linked by SETTING the child record's own foreign-key column. So "link" = PUT the child with
 * { <FilterField>: <parentId> }; "unlink" = PUT it with { <FilterField>: 0 }.
 *
 * The connected list is SERVER-PAGINATED (a set can have thousands of children): one page of PAGE_SIZE at a
 * time, with a server-side filter (LK on the display field) and Prev/Next. The `_state` is passed as the
 * render RECORD (not a shared AppData slot) so many child-list tabs on one record never collide; the paged
 * list region re-renders into its own container (`#PCFG-CL-List-<viewID>`) so the filter input keeps focus.
 *
 * Per-instance options: ParentRecordSet, ChildRecordSet, FilterField, BaseField (parent PK, default
 * ID<ParentRecordSet>), DisplayField, Columns ([{ Key, DisplayName }]), ChipFields, Title.
 */
class ChildListTab extends libPictView
{
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	// The registered view id — inline handlers reach this exact instance via _Pict.views[viewID].
	get viewID()
	{
		return this.options.ViewIdentifier || this.Hash;
	}

	get childIDField() { return `ID${ this.options.ChildRecordSet }`; }
	get childGUIDField() { return `GUID${ this.options.ChildRecordSet }`; }
	get baseField() { return this.options.BaseField || `ID${ this.options.ParentRecordSet }`; }
	get displayField() { return this.options.DisplayField || 'Name'; }
	get noun() { return this.options.Title || this.options.ChildRecordSet; }

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)));
		});
	}

	_putJSON(pURL, pPayload)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.putJSON(pURL, pPayload, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)));
		});
	}

	_parentID()
	{
		const tmpParent = this.pict.AppData[`${ this.options.ParentRecordSet }Details`] || {};
		return tmpParent[this.baseField];
	}

	// Cell display: primitives as-is, empty/objects as an em dash so a JSON blob never dumps into a cell.
	_formatCell(pValue)
	{
		if ((pValue === null) || (typeof pValue === 'undefined') || (pValue === '')) { return '—'; }
		if (typeof pValue === 'object') { return '—'; }
		return String(pValue);
	}

	// Value for one configured column. A column names a single field (`Key`) or several (`Keys`) — the
	// latter joins the present values with a space (e.g. NameFirst + NameLast → a person's full name, the way
	// the record cards title a User), skipping blanks so an absent first or last name leaves no stray gap.
	_cellValue(pRecord, pColumn)
	{
		if (pColumn && Array.isArray(pColumn.Keys))
		{
			const tmpParts = pColumn.Keys
				.map((pKey) => pRecord[pKey])
				.filter((pValue) => (pValue !== null) && (typeof pValue !== 'undefined') && (String(pValue).trim() !== ''))
				.map((pValue) => String(pValue).trim());
			return tmpParts.length ? tmpParts.join(pColumn.Separator || ' ') : '—';
		}
		return this._formatCell(pRecord[pColumn.Key]);
	}

	_escapeHTML(pValue)
	{
		return String(pValue || '').replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[pChar]);
	}

	get columns()
	{
		return (Array.isArray(this.options.Columns) && (this.options.Columns.length > 0))
			? this.options.Columns
			: [ { Key: this.displayField, DisplayName: this.displayField } ];
	}

	// --- Server queries (base FK filter + optional LK on the display field) ---

	_listFilter(pWithSort)
	{
		let tmpFilter = `FBV~${ this.options.FilterField }~EQ~${ this._parentID() }`;
		if (this._filterTerm) { tmpFilter += `~FBV~${ this.displayField }~LK~${ encodeURIComponent(`%${ this._filterTerm }%`) }`; }
		if (pWithSort) { tmpFilter += `~FSF~${ this.displayField }~ASC~0`; }
		return tmpFilter;
	}

	async _fetchListPage()
	{
		const tmpChild = this.options.ChildRecordSet;
		try
		{
			const tmpCount = await this._getJSON(`${ tmpChild }s/Count/FilteredTo/${ this._listFilter(false) }`);
			const tmpTotal = (tmpCount && (typeof tmpCount.Count !== 'undefined')) ? Number(tmpCount.Count) : 0;
			const tmpOffset = (this._page || 0) * PAGE_SIZE;
			const tmpRecords = await this._getJSON(`${ tmpChild }s/FilteredTo/${ this._listFilter(true) }/${ tmpOffset }/${ PAGE_SIZE }`);
			return { records: Array.isArray(tmpRecords) ? tmpRecords : [], total: tmpTotal, failed: false };
		}
		catch (pError)
		{
			this.pict.log.warn(`ChildListTab (${ this.options.ParentRecordSet } → ${ tmpChild }): list fetch failed`, { Error: pError && (pError.message || pError) });
			return { records: [], total: 0, failed: true };
		}
	}

	// --- Context chips (a Line Item is meaningless without its Contract / Project) ---

	_normalizeChipFields()
	{
		return (Array.isArray(this.options.ChipFields) ? this.options.ChipFields : [])
			.map((pChip) => ((typeof pChip === 'string') ? { Field: pChip } : pChip))
			.filter((pChip) => pChip && pChip.Field);
	}

	// Direct fields render as-is; reference chips ({ Field, Entity, DisplayField }) are BATCH-resolved (one
	// INN fetch per referenced entity, per page — not per row). Returns an array parallel to pRecords.
	async _decorateChips(pRecords)
	{
		const tmpChips = this._normalizeChipFields();
		if ((tmpChips.length < 1) || (!Array.isArray(pRecords)) || (pRecords.length < 1)) { return (pRecords || []).map(() => []); }

		const tmpMaps = {};
		for (const pChip of tmpChips)
		{
			if (!pChip.Entity) { continue; }
			const tmpIDs = Array.from(new Set(pRecords.map((pRecord) => pRecord[pChip.Field]).filter((pID) => pID && (pID !== 0) && (pID !== '0'))));
			const tmpMap = {};
			if (tmpIDs.length > 0)
			{
				let tmpRefs = [];
				try { tmpRefs = await this._getJSON(`${ pChip.Entity }s/FilteredTo/FBL~ID${ pChip.Entity }~INN~${ tmpIDs.join(',') }/0/${ PAGE_SIZE * 4 }`); }
				catch (pError) { this.pict.log.warn(`ChildListTab chip resolve failed (${ pChip.Entity })`, { Error: pError && (pError.message || pError) }); }
				(Array.isArray(tmpRefs) ? tmpRefs : []).forEach((pRef) => { tmpMap[pRef[`ID${ pChip.Entity }`]] = pRef[pChip.DisplayField || 'Name']; });
			}
			tmpMaps[pChip.Field] = tmpMap;
		}

		return pRecords.map((pRecord) => tmpChips
			.map((pChip) =>
			{
				const tmpValue = pChip.Entity ? tmpMaps[pChip.Field][pRecord[pChip.Field]] : pRecord[pChip.Field];
				if ((tmpValue === undefined) || (tmpValue === null) || (tmpValue === '')) { return null; }
				return { Text: pChip.Label ? `${ pChip.Label }: ${ tmpValue }` : String(tmpValue) };
			})
			.filter(Boolean));
	}

	// --- Build the rows for a page (with context chips on the display cell) ---

	async _buildRows(pRecords)
	{
		const tmpChild = this.options.ChildRecordSet;
		const tmpColumns = this.columns;
		const tmpRows = pRecords.map((pRecord) =>
		(
			{
				ViewID: this.viewID,
				ID: pRecord[this.childIDField],
				Route: `#/PSRS/${ tmpChild }/View/${ pRecord[this.childGUIDField] || '' }`,
				Cells: tmpColumns.map((pColumn) => ({ Value: this._cellValue(pRecord, pColumn), Chips: [] }))
			}
		));
		// Chips hang on the DISPLAY column's cell (the primary identifier), not blindly Cells[0].
		const tmpDisplayIndex = Math.max(0, tmpColumns.findIndex((pColumn) => pColumn.Key === this.displayField));
		const tmpRowChips = await this._decorateChips(pRecords);
		tmpRows.forEach((pRow, pIndex) =>
		{
			const tmpCell = pRow.Cells[tmpDisplayIndex] || pRow.Cells[0];
			if (tmpCell) { tmpCell.Chips = tmpRowChips[pIndex] || []; }
		});
		return { Rows: tmpRows, Columns: tmpColumns };
	}

	// The paged list region (count + table + pagination) — rendered by the main template and re-rendered by
	// _reloadList on a page/filter change.
	_buildListState(pRows, pColumns, pTotal, pFailed)
	{
		const tmpStart = (pTotal === 0) ? 0 : ((this._page || 0) * PAGE_SIZE) + 1;
		const tmpEnd = Math.min(pTotal, ((this._page || 0) + 1) * PAGE_SIZE);
		const tmpHasRows = (pRows.length > 0);
		return {
			CountLabel: (pTotal > 0) ? `Showing ${ tmpStart }–${ tmpEnd } of ${ pTotal } ${ this.noun }` : '',
			TableSlot: tmpHasRows ? [ { Rows: pRows, Columns: pColumns } ] : [],
			EmptySlot: tmpHasRows ? [] : [ { EmptyMessage: pFailed
				? 'Could not load linked records.'
				: (this._filterTerm ? `No ${ this.noun } match &ldquo;${ this._escapeHTML(this._filterTerm) }&rdquo;.` : `No ${ this.noun } linked yet — search above to link some.`) } ],
			PaginationSlot: (pTotal > PAGE_SIZE) ? [ {
				ViewID: this.viewID,
				RangeLabel: `Page ${ (this._page || 0) + 1 } of ${ Math.max(1, Math.ceil(pTotal / PAGE_SIZE)) }`,
				PrevDisabled: ((this._page || 0) <= 0) ? 'disabled' : '',
				NextDisabled: (tmpEnd >= pTotal) ? 'disabled' : ''
			} ] : []
		};
	}

	async _loadState()
	{
		const tmpParentID = this._parentID();
		const tmpCanEdit = (typeof tmpParentID !== 'undefined') && (tmpParentID !== null) && (tmpParentID !== '');
		const tmpAddSlot = tmpCanEdit
			? [ { ViewID: this.viewID, AddLabel: `Link ${ this.noun }`, SearchPlaceholder: `Search ${ this.options.ChildRecordSet } to link…`, ResultsContainerID: `PCFG-CL-Results-${ this.viewID }` } ]
			: [];

		if (!tmpCanEdit)
		{
			this._currentIDs = new Set();
			this._state = {
				ViewID: this.viewID, AddSlot: [], FilterSlot: [], ListContainerID: `PCFG-CL-List-${ this.viewID }`,
				ListState: { CountLabel: '', TableSlot: [], EmptySlot: [ { EmptyMessage: 'Save the record before linking related records.' } ], PaginationSlot: [] }
			};
			return;
		}

		// Fresh render (initial open, or after a link/unlink) starts at page 0, unfiltered.
		this._page = 0;
		this._filterTerm = '';
		const tmpPage = await this._fetchListPage();
		this._total = tmpPage.total;
		this._currentIDs = new Set(tmpPage.records.map((pRecord) => pRecord[this.childIDField]));
		const tmpBuilt = await this._buildRows(tmpPage.records);

		this._state = {
			ViewID: this.viewID,
			AddSlot: tmpAddSlot,
			// The filter is a server query, so offer it whenever the full set spans more than one page.
			FilterSlot: (tmpPage.total > PAGE_SIZE) ? [ { ViewID: this.viewID, Noun: this.noun } ] : [],
			ListContainerID: `PCFG-CL-List-${ this.viewID }`,
			ListState: this._buildListState(tmpBuilt.Rows, tmpBuilt.Columns, tmpPage.total, tmpPage.failed)
		};
	}

	// Re-fetch the current page + count and re-render ONLY the list region (keeps the filter input focused).
	async _reloadList()
	{
		const tmpPage = await this._fetchListPage();
		this._total = tmpPage.total;
		this._currentIDs = new Set(tmpPage.records.map((pRecord) => pRecord[this.childIDField]));
		const tmpBuilt = await this._buildRows(tmpPage.records);
		const tmpHTML = this.pict.parseTemplateByHash('PCFG-ChildListTab-ListRegion', this._buildListState(tmpBuilt.Rows, tmpBuilt.Columns, tmpPage.total, tmpPage.failed));
		this.pict.ContentAssignment.assignContent(`#PCFG-CL-List-${ this.viewID }`, tmpHTML);
	}

	// The read view's `View` tab type calls renderAsync() with no arguments. Fetch first, then render the
	// per-instance state as the template Record into the tab-body destination the read view stamped on us.
	async renderAsync(pRenderable, pDestinationAddress, pData, fCallback)
	{
		await this._loadState();
		const tmpRenderable = pRenderable || this.options.DefaultRenderable;
		const tmpDestination = pDestinationAddress || this.options.DefaultDestinationAddress;
		return super.renderAsync(tmpRenderable, tmpDestination, pData || this._state, fCallback);
	}

	// --- Server-side filter + pagination over the connected list ---

	filterCurrent(pTerm)
	{
		clearTimeout(this._filterTimer);
		const tmpTerm = (pTerm || '').trim();
		// Debounce so we don't query the server on every keystroke.
		this._filterTimer = setTimeout(() =>
		{
			this._filterTerm = tmpTerm;
			this._page = 0;
			this._reloadList();
		}, 300);
	}

	gotoPage(pDelta)
	{
		const tmpMaxPage = Math.max(0, Math.ceil((this._total || 0) / PAGE_SIZE) - 1);
		const tmpNext = Math.min(tmpMaxPage, Math.max(0, (this._page || 0) + pDelta));
		if (tmpNext === (this._page || 0)) { return; }
		this._page = tmpNext;
		this._reloadList();
	}

	// --- Link / unlink (set or clear the child's foreign key to this parent) ---

	async link(pChildID)
	{
		const tmpParentID = this._parentID();
		if (!tmpParentID || !pChildID) { return; }
		try
		{
			await this._putJSON(this.options.ChildRecordSet, { [this.childIDField]: pChildID, [this.options.FilterField]: tmpParentID });
			this._toast(`Linked.`, 'success');
		}
		catch (pError)
		{
			this._toast(`Could not link: ${ pError && (pError.message || pError) }`, 'error');
		}
		this._searchResults = [];
		await this.renderAsync();
	}

	async unlink(pChildID)
	{
		if (!pChildID) { return; }
		try
		{
			await this._putJSON(this.options.ChildRecordSet, { [this.childIDField]: pChildID, [this.options.FilterField]: 0 });
			this._toast(`Unlinked.`, 'success');
		}
		catch (pError)
		{
			this._toast(`Could not unlink: ${ pError && (pError.message || pError) }`, 'error');
		}
		await this.renderAsync();
	}

	// --- Live candidate search (link more) — server LK on the display field, cull the current page's links ---

	async search(pTerm)
	{
		const tmpTerm = (pTerm || '').trim();
		if (tmpTerm.length < 2)
		{
			this._searchResults = [];
			this._renderResults();
			return;
		}
		const tmpChild = this.options.ChildRecordSet;
		const tmpField = this.displayField;
		let tmpRecords = [];
		try
		{
			tmpRecords = await this._getJSON(`${ tmpChild }s/FilteredTo/FBV~${ tmpField }~LK~${ encodeURIComponent(`%${ tmpTerm }%`) }~FSF~${ tmpField }~ASC~0/0/12`);
		}
		catch (pError)
		{
			this.pict.log.warn(`ChildListTab search failed`, { Error: pError && (pError.message || pError) });
		}
		tmpRecords = Array.isArray(tmpRecords) ? tmpRecords : [];
		const tmpCurrent = this._currentIDs || new Set();
		const tmpFiltered = tmpRecords.filter((pRecord) => !tmpCurrent.has(pRecord[this.childIDField])).slice(0, 10);
		const tmpChips = await this._decorateChips(tmpFiltered);
		this._searchResults = tmpFiltered.map((pRecord, pIndex) => (
			{
				ViewID: this.viewID,
				ID: pRecord[this.childIDField],
				Display: this._formatCell(pRecord[tmpField]) || `#${ pRecord[this.childIDField] }`,
				Chips: tmpChips[pIndex] || []
			}));
		this._renderResults();
	}

	_renderResults()
	{
		const tmpResults = this._searchResults || [];
		const tmpHTML = this.pict.parseTemplateByHash('PCFG-ChildListTab-Results', { Results: tmpResults });
		this.pict.ContentAssignment.assignContent(`#PCFG-CL-Results-${ this.viewID }`, tmpHTML);
	}

	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'PCFG-ChildListTab',

	DefaultRenderable: 'PCFG-ChildListTab-Renderable',
	DefaultDestinationAddress: '#PCFG-ChildListTab-Container',
	DefaultTemplateRecordAddress: false,

	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,

	CSS: /*css*/`
		.pcfg-childlist-add { margin: 0 0 1rem; }
		.pcfg-childlist-add label { display: block; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.3rem; }
		.pcfg-childlist-search { width: 100%; box-sizing: border-box; padding: 0.5rem 0.75rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); font: inherit; font-size: 0.92rem; }
		.pcfg-childlist-search:focus { outline: none; border-color: var(--theme-color-brand-primary, #5650e6); }
		.pcfg-childlist-results { margin-top: 0.25rem; }
		.pcfg-childlist-result { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; padding: 0.45rem 0.7rem; border: 1px solid var(--theme-color-border-light, #eef0f4); border-radius: 6px; margin-top: 0.25rem; cursor: pointer; background: var(--theme-color-background-primary, #fff); transition: background 0.12s ease; }
		.pcfg-childlist-result:hover { background: var(--theme-color-background-selected, #e3edfb); border-color: var(--theme-color-brand-primary, #5650e6); }
		.pcfg-childlist-result-add { flex: 0 0 auto; color: var(--theme-color-brand-primary, #5650e6); font-size: 0.8rem; font-weight: 600; white-space: nowrap; }
		.pcfg-childlist-result-main { display: flex; flex-direction: column; gap: 0.2rem; min-width: 0; }
		.pcfg-childlist-result-name { font-weight: 500; }
		.pcfg-childlist-chips { display: flex; flex-wrap: wrap; gap: 0.3rem; margin-top: 0.25rem; }
		.pcfg-childlist-chips:empty { margin-top: 0; }
		.pcfg-childlist-chip { display: inline-block; font-size: 0.7rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-tertiary, #eef0f4); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 999px; padding: 0.05rem 0.5rem; white-space: nowrap; }
		.pcfg-childlist-count { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.6rem; }
		.pcfg-childlist-filter { width: 100%; box-sizing: border-box; padding: 0.4rem 0.7rem; margin: 0 0 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); font: inherit; font-size: 0.88rem; }
		.pcfg-childlist-filter:focus { outline: none; border-color: var(--theme-color-brand-primary, #5650e6); }
		.pcfg-childlist-table { width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; overflow: hidden; }
		.pcfg-childlist-table thead th { text-align: left; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #eef0f4); padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
		.pcfg-childlist-table tbody td { padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--theme-color-border-light, #eef0f4); font-size: 0.92rem; color: var(--theme-color-text-primary, #1f2733); }
		.pcfg-childlist-table tbody tr.pcfg-childlist-row { cursor: pointer; transition: background 0.12s ease; }
		.pcfg-childlist-table tbody tr.pcfg-childlist-row:hover { background: var(--theme-color-background-tertiary, #f5f6f8); }
		.pcfg-childlist-table tbody tr:last-child td { border-bottom: none; }
		.pcfg-childlist-unlink { text-align: right; white-space: nowrap; }
		.pcfg-childlist-unlink button { border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-muted, #6b7686); border-radius: 6px; padding: 0.2rem 0.5rem; font: inherit; font-size: 0.8rem; cursor: pointer; transition: all 0.12s ease; }
		.pcfg-childlist-unlink button:hover { border-color: var(--theme-color-status-error, #c0504d); color: var(--theme-color-status-error, #c0504d); }
		.pcfg-childlist-empty { color: var(--theme-color-text-muted, #6b7686); text-align: center; padding: 1.25rem 0; }
		.pcfg-childlist-pagination { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; margin-top: 0.65rem; }
		.pcfg-childlist-page-label { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); }
		.pcfg-childlist-page-btn { display: inline-flex; align-items: center; gap: 0.3rem; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-secondary, #45505f); border-radius: 7px; padding: 0.35rem 0.75rem; font: inherit; font-size: 0.85rem; font-weight: 600; cursor: pointer; transition: all 0.12s ease; }
		.pcfg-childlist-page-btn:hover:not([disabled]) { border-color: var(--theme-color-brand-primary, #5650e6); color: var(--theme-color-brand-primary, #5650e6); }
		.pcfg-childlist-page-btn[disabled] { opacity: 0.45; cursor: default; }
	`,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'PCFG-ChildListTab-Template',
			Template: /*html*/`
				<div class="pcfg-childlist">
					{~TS:PCFG-ChildListTab-AddTemplate:Record.AddSlot~}
					{~TS:PCFG-ChildListTab-FilterInput:Record.FilterSlot~}
					<div id="{~D:Record.ListContainerID~}">{~T:PCFG-ChildListTab-ListRegion:Record.ListState~}</div>
				</div>`
		},
		{
			// Rendered inside {~TS:...:Record.AddSlot~}, so Record IS the AddSlot element (ViewID / AddLabel /
			// SearchPlaceholder / ResultsContainerID). Shown only when the record is saved.
			Hash: 'PCFG-ChildListTab-AddTemplate',
			Template: /*html*/`
				<div class="pcfg-childlist-add">
					<label>{~D:Record.AddLabel~}</label>
					<input class="pcfg-childlist-search" type="text" placeholder="{~D:Record.SearchPlaceholder~}" oninput="_Pict.views['{~D:Record.ViewID~}'].search(this.value)" />
					<div class="pcfg-childlist-results" id="{~D:Record.ResultsContainerID~}"></div>
				</div>`
		},
		{
			// Server-side filter over the connected list (Record is the FilterSlot element).
			Hash: 'PCFG-ChildListTab-FilterInput',
			Template: /*html*/`<input class="pcfg-childlist-filter" type="text" placeholder="Filter {~D:Record.Noun~}…" oninput="_Pict.views['{~D:Record.ViewID~}'].filterCurrent(this.value)" />`
		},
		{
			Hash: 'PCFG-ChildListTab-Results',
			Template: /*html*/`{~TS:PCFG-ChildListTab-ResultRow:Record.Results~}`
		},
		{
			Hash: 'PCFG-ChildListTab-ResultRow',
			Template: /*html*/`<div class="pcfg-childlist-result" onclick="_Pict.views['{~D:Record.ViewID~}'].link({~D:Record.ID~})"><span class="pcfg-childlist-result-main"><span class="pcfg-childlist-result-name">{~D:Record.Display~}</span><span class="pcfg-childlist-chips">{~TS:PCFG-ChildListTab-Chip:Record.Chips~}</span></span><span class="pcfg-childlist-result-add">{~I:Plus~} Link</span></div>`
		},
		{
			Hash: 'PCFG-ChildListTab-Chip',
			Template: /*html*/`<span class="pcfg-childlist-chip">{~D:Record.Text~}</span>`
		},
		{
			// The paged list region — Record is the ListState (count + table + pagination). Re-rendered whole
			// into #PCFG-CL-List-<viewID> by _reloadList on a page/filter change.
			Hash: 'PCFG-ChildListTab-ListRegion',
			Template: /*html*/`
				<div class="pcfg-childlist-count">{~D:Record.CountLabel~}</div>
				{~TS:PCFG-ChildListTab-TableTemplate:Record.TableSlot~}
				{~TS:PCFG-ChildListTab-EmptyTemplate:Record.EmptySlot~}
				{~TS:PCFG-ChildListTab-Pagination:Record.PaginationSlot~}`
		},
		{
			// Inside {~TS:...:Record.TableSlot~}, Record IS the TableSlot element carrying Rows + Columns.
			Hash: 'PCFG-ChildListTab-TableTemplate',
			Template: /*html*/`
				<table class="pcfg-childlist-table">
					<thead><tr>{~TS:PCFG-ChildListTab-HeadCell:Record.Columns~}<th></th></tr></thead>
					<tbody>{~TS:PCFG-ChildListTab-RowTemplate:Record.Rows~}</tbody>
				</table>`
		},
		{
			Hash: 'PCFG-ChildListTab-HeadCell',
			Template: /*html*/`<th>{~D:Record.DisplayName~}</th>`
		},
		{
			// Row-level nav (Record is the ROW, which carries Route); the unlink button stops propagation so it
			// doesn't also navigate.
			Hash: 'PCFG-ChildListTab-RowTemplate',
			Template: /*html*/`<tr class="pcfg-childlist-row" onclick="window.location.hash='{~D:Record.Route~}'">{~TS:PCFG-ChildListTab-Cell:Record.Cells~}<td class="pcfg-childlist-unlink"><button title="Unlink" onclick="event.stopPropagation(); _Pict.views['{~D:Record.ViewID~}'].unlink({~D:Record.ID~})">{~I:Close~} Unlink</button></td></tr>`
		},
		{
			// The display column's cell carries Chips (see _buildRows); other cells have none so the {~TS:~}
			// renders nothing there.
			Hash: 'PCFG-ChildListTab-Cell',
			Template: /*html*/`<td><span class="pcfg-childlist-open-cell">{~D:Record.Value~}</span><span class="pcfg-childlist-chips">{~TS:PCFG-ChildListTab-Chip:Record.Chips~}</span></td>`
		},
		{
			Hash: 'PCFG-ChildListTab-EmptyTemplate',
			Template: /*html*/`<p class="pcfg-childlist-empty">{~D:Record.EmptyMessage~}</p>`
		},
		{
			// Record is the PaginationSlot element (ViewID / RangeLabel / Prev/NextDisabled).
			Hash: 'PCFG-ChildListTab-Pagination',
			Template: /*html*/`
				<div class="pcfg-childlist-pagination">
					<button type="button" class="pcfg-childlist-page-btn" {~D:Record.PrevDisabled~} onclick="_Pict.views['{~D:Record.ViewID~}'].gotoPage(-1)">{~I:ChevronLeft~} Prev</button>
					<span class="pcfg-childlist-page-label">{~D:Record.RangeLabel~}</span>
					<button type="button" class="pcfg-childlist-page-btn" {~D:Record.NextDisabled~} onclick="_Pict.views['{~D:Record.ViewID~}'].gotoPage(1)">Next {~I:ChevronRight~}</button>
				</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PCFG-ChildListTab-Renderable',
			TemplateHash: 'PCFG-ChildListTab-Template',
			RenderMethod: 'replace'
		}
	]
};

module.exports = ChildListTab;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":1053}],1416:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * ConfigClone — the clone-across-contexts workflow: choose a namespace + a SOURCE scope/context, load
 * its values, pick which to copy, choose a TARGET scope/context (gated by write permission), preview,
 * and apply with a modal confirm. The modern replacement for the legacy "clone config from one place to
 * another". All state lives in AppData.ConfigClone; behaviour in the ConfigClone provider.
 */
class ConfigClone extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ConfigCloneProvider;
	}

	onBeforeRender(pRenderable)
	{
		if (this.provider) { this.provider.deriveRenderState(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_repaint() { this.render(); }

	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'success' }); }
	}

	setField(pField, pValue) { this.provider.setField(pField, pValue); this._repaint(); }
	toggleValue(pValue) { this.provider.toggleValue(pValue); this._repaint(); }
	selectAll(pChecked) { this.provider.setAllChecked(pChecked); this._repaint(); }

	loadValues() { this.provider.loadSourceValuesAsync().then(() => this._repaint()); }

	back() { window.location.hash = '#/ConfigViewer'; }

	apply()
	{
		const tmpProvider = this.provider;
		const tmpState = tmpProvider.state;
		const tmpPlan = tmpProvider.buildPlan();
		if (!tmpPlan.length) { tmpState.Message = 'Select at least one value to clone.'; this._repaint(); return; }
		const tmpSrc = `${tmpProvider.cv._scopeLabel(tmpState.SourceScope)} (${tmpProvider._idOrSession(tmpState.SourceScope, tmpState.SourceID)})`;
		const tmpTgt = `${tmpProvider.cv._scopeLabel(tmpState.TargetScope)} (${tmpProvider._idOrSession(tmpState.TargetScope, tmpState.TargetID)})`;
		const tmpMessage = `Copy ${tmpPlan.length} value(s) of “${tmpState.NamespaceKey}” from ${tmpSrc} to ${tmpTgt}? Existing overrides at the target will be replaced.`;
		const fApply = () => tmpProvider.applyAsync().then((pResult) =>
		{
			this._repaint();
			if (pResult) { this._toast(`Cloned ${pResult.Succeeded}/${pResult.Succeeded + pResult.Failed} value(s)`, pResult.Failed ? 'error' : 'success'); }
		});
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm(tmpMessage, { title: 'Clone configuration', confirmLabel: 'Clone', cancelLabel: 'Cancel', dangerous: true })
				.then((pOk) => { if (pOk) { fApply(); } });
		}
		else
		{
			fApply();
		}
	}
}

module.exports = ConfigClone;

module.exports.default_configuration =
{
	ViewIdentifier: 'ConfigClone',
	DefaultRenderable: 'ConfigCloneWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.cc-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 60rem; }
		.cc-head { display:flex; justify-content:space-between; align-items:flex-start; gap:1rem; margin:0 0 1rem; }
		.cc-title { font-size:1.5rem; font-weight:700; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.cc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.cc-grid { display:grid; grid-template-columns:1fr 1fr; gap:1rem; }
		@media (max-width: 760px) { .cc-grid { grid-template-columns:1fr; } }
		.cc-card { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.9rem 1.1rem; }
		.cc-card-head { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-brand-primary,#2e7d74); margin:0 0 0.7rem; }
		.cc-field { margin:0 0 0.6rem; }
		.cc-label { display:block; font-size:0.68rem; font-weight:600; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.15rem; }
		.cc-input, .cc-select { width:100%; font-size:0.9rem; padding:0.3rem 0.45rem; border-radius:6px; border:1px solid var(--theme-color-border-default,#d7dce3); }
		.cc-values { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.9rem 1.1rem; margin:1rem 0 0; }
		.cc-values-head { display:flex; justify-content:space-between; align-items:center; margin:0 0 0.6rem; }
		.cc-values-title { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-brand-primary,#2e7d74); }
		.cc-values-list { display:grid; grid-template-columns:repeat(auto-fill, minmax(13rem, 1fr)); gap:0.2rem 1rem; }
		.cc-value { font-size:0.88rem; color:var(--theme-color-text-secondary,#45505f); display:flex; align-items:center; gap:0.4rem; }
		.cc-applybar { margin:1.1rem 0 0; display:flex; align-items:center; gap:1rem; }
		.cc-warn { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); }
		.cc-result { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; background:var(--theme-color-background-tertiary,#f4f6f9); padding:0.9rem 1.1rem; margin:1rem 0 0; }
		.cc-result-row { font-size:0.88rem; padding:0.15rem 0; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
	`,
	Templates:
	[
		{
			Hash: 'ConfigClone-Wrap',
			Template: /*html*/`
				<div class="cc-wrap">
					<div class="cc-head">
						<div>
							<h1 class="cc-title">Clone configuration</h1>
							<p class="cc-subtitle">Copy a namespace’s configuration from one context to another. The service stores only what differs from the target’s parent.</p>
						</div>
						<button class="button is-light" onclick="_Pict.views.ConfigClone.back()"><span class="icon">{~I:ChevronLeft~}</span><span>Back</span></button>
					</div>
					{~TS:ConfigClone-Message:AppData.ConfigClone.MessageSlot~}
					<div class="cc-grid">
						<div class="cc-card">
							<div class="cc-card-head">1 · Source</div>
							<div class="cc-field"><span class="cc-label">Namespace</span><select class="cc-select" onchange="_Pict.views.ConfigClone.setField('NamespaceKey', this.value)">{~TS:ConfigClone-NsOption:AppData.ConfigClone.NamespaceOptions~}</select></div>
							<div class="cc-field"><span class="cc-label">Scope</span><select class="cc-select" onchange="_Pict.views.ConfigClone.setField('SourceScope', this.value)">{~TS:ConfigClone-ScopeOption:AppData.ConfigClone.SourceScopeOptions~}</select></div>
							<div class="cc-field"><span class="cc-label">Context ID</span><input class="cc-input" value="{~D:AppData.ConfigClone.SourceID~}" onchange="_Pict.views.ConfigClone.setField('SourceID', this.value)"></div>
							<button class="button is-small is-link is-light" onclick="_Pict.views.ConfigClone.loadValues()"><span class="icon">{~I:Search~}</span><span>Load values</span></button>
						</div>
						<div class="cc-card">
							<div class="cc-card-head">2 · Target</div>
							<div class="cc-field"><span class="cc-label">Scope</span><select class="cc-select" onchange="_Pict.views.ConfigClone.setField('TargetScope', this.value)">{~TS:ConfigClone-ScopeOption:AppData.ConfigClone.TargetScopeOptions~}</select></div>
							<div class="cc-field"><span class="cc-label">Context ID</span><input class="cc-input" value="{~D:AppData.ConfigClone.TargetID~}" onchange="_Pict.views.ConfigClone.setField('TargetID', this.value)"></div>
							{~TS:ConfigClone-NoPerm:AppData.ConfigClone.NoTargetPermSlot~}
						</div>
					</div>
					{~TS:ConfigClone-Loading:AppData.ConfigClone.LoadingSlot~}
					{~TS:ConfigClone-Values:AppData.ConfigClone.ValuesSlot~}
					<div class="cc-applybar">
						<button class="button is-link" {~D:AppData.ConfigClone.ApplyDisabledAttr~} onclick="_Pict.views.ConfigClone.apply()"><span class="icon">{~I:Copy~}</span><span>Clone {~D:AppData.ConfigClone.SelectedCount~} value(s) →</span></button>
					</div>
					{~TS:ConfigClone-Result:AppData.ConfigClone.ResultSlot~}
				</div>`
		},
		{
			Hash: 'ConfigClone-NsOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'ConfigClone-ScopeOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~} {~D:Record.DisabledAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'ConfigClone-NoPerm',
			Template: /*html*/`<p class="cc-warn">You don’t have permission to write the {~D:Record.Scope~} scope — pick a scope you can write.</p>`
		},
		{
			Hash: 'ConfigClone-Values',
			Template: /*html*/`
				<div class="cc-values">
					<div class="cc-values-head">
						<span class="cc-values-title">Values to clone</span>
						<span>
							<button class="button is-small is-white" onclick="_Pict.views.ConfigClone.selectAll(true)">All</button>
							<button class="button is-small is-white" onclick="_Pict.views.ConfigClone.selectAll(false)">None</button>
						</span>
					</div>
					<div class="cc-values-list">{~TS:ConfigClone-Value:AppData.ConfigClone.ValueRows~}</div>
				</div>`
		},
		{
			Hash: 'ConfigClone-Value',
			Template: /*html*/`<label class="cc-value"><input type="checkbox" {~D:Record.CheckedAttr~} onchange="_Pict.views.ConfigClone.toggleValue('{~D:Record.Value~}')"> {~D:Record.Value~}</label>`
		},
		{
			Hash: 'ConfigClone-Result',
			Template: /*html*/`
				<div class="cc-result">
					<div class="cc-values-title">Result — {~D:Record.Succeeded~} cloned, {~D:Record.Failed~} failed</div>
					{~TS:ConfigClone-ResultRow:AppData.ConfigClone.ResultRows~}
				</div>`
		},
		{
			Hash: 'ConfigClone-ResultRow',
			Template: /*html*/`<div class="cc-result-row"><span class="{~D:Record.StatusClass~}">{~D:Record.Value~}</span> — {~D:Record.StatusText~}</div>`
		},
		{
			Hash: 'ConfigClone-Message',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'ConfigClone-Loading',
			Template: /*html*/`<p class="cc-warn mt-3">Working…</p>`
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ConfigCloneWrap',
			TemplateHash: 'ConfigClone-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container',
		}
	]
};

},{"pict-view":1053}],1417:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libProvenanceObjectEditor = require('../config-editor/views/ProvenanceObjectEditor.js');

/**
 * ConfigViewer — the provenance-aware configuration viewer/editor. A left rail browses configuration
 * namespaces (cascading Configuration service) plus record CustomProperties; the centre renders the
 * effective merged object in a pict-section-objecteditor tree where every value carries a badge for the
 * scope that set it (Global / Customer / Project / User); a write-scope picker chooses where edits go;
 * a right panel explains what the namespace + its keys mean. All state lives in AppData.ConfigViewer and
 * all behaviour in the ConfigViewer provider; the view derives + repaints declaratively.
 */
class ConfigViewer extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ConfigViewer;
	}

	onBeforeRender(pRenderable)
	{
		if (this.provider) { this.provider.deriveRenderState(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._mountEditor();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** (Re)mount the embedded provenance editor after each paint (the main render replaces the host). */
	_mountEditor()
	{
		if (this.pict.ContentAssignment.getElement('#CV-EditorHost').length === 0) { return; }
		const tmpView = this._ensureEditorView();
		if (!tmpView) { return; }
		tmpView.options.Editable = !!(this.provider && this.provider.isEditable);
		tmpView.options.DefaultDestinationAddress = '#CV-EditorHost';
		tmpView.render();
	}

	/** Lazily register the ProvenanceObjectEditor bound to the live EditingConfig + ProvenanceMap. */
	_ensureEditorView()
	{
		const tmpHash = 'CV-ConfigEditor';
		if (this.pict.views[tmpHash]) { return this.pict.views[tmpHash]; }
		this.pict.addView(tmpHash, Object.assign({}, libProvenanceObjectEditor.default_configuration,
			{
				ViewIdentifier: tmpHash,
				AutoRender: false,
				Editable: false,
				InitialExpandDepth: 3,
				ObjectDataAddress: 'AppData.ConfigViewer.EditingConfig',
				ProvenanceDataAddress: 'AppData.ConfigViewer.ProvenanceMap',
				Renderables:
				[
					{
						RenderableHash: 'ObjectEditor-Container',
						TemplateHash: 'ObjectEditor-Container-Template',
						DestinationAddress: '#CV-EditorHost',
						RenderMethod: 'replace',
					}
				],
			}), libProvenanceObjectEditor);
		const tmpView = this.pict.views[tmpHash];
		// The editor builds its node renderers in onBeforeInitialize; a view added post-boot must be
		// initialized explicitly before its first render (same gotcha as ProjectWorkspace's embed).
		if (tmpView && typeof tmpView.initialize === 'function') { tmpView.initialize(); }
		return tmpView;
	}

	// --- inline handlers (orchestrate provider async + repaint) ---

	_repaint()
	{
		this.render();
	}

	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMessage, { type: pType || 'success' });
		}
	}

	selectRailItem(pKind, pNamespaceKey, pEntity, pRecordID)
	{
		if (pKind === 'customprops')
		{
			this.provider.selectCustomPropertiesAsync(pEntity, parseInt(pRecordID, 10), `${pEntity} CustomProperties`)
				.then(() => this._repaint());
			return;
		}
		this.provider.selectNamespaceAsync(pNamespaceKey).then(() => this._repaint());
	}

	selectValue(pValue)
	{
		const tmpSelected = this.provider.state.Selected;
		if (!tmpSelected) { return; }
		this.provider.selectNamespaceAsync(tmpSelected.NamespaceKey, pValue).then(() => this._repaint());
	}

	setWriteScope(pScope)
	{
		this.provider.setWriteScope(pScope);
		this._repaint();
	}

	save()
	{
		const tmpProvider = this.provider;
		const tmpSelected = tmpProvider.state.Selected;
		if (!tmpSelected) { return; }
		const fDone = (pMessage) => { tmpProvider.state.Message = ''; this._repaint(); this._toast(pMessage); };
		const fFail = (pError) => { tmpProvider.state.Message = `Save failed: ${pError.message || pError}`; this._repaint(); this._toast('Save failed', 'error'); };
		if (tmpSelected.Mode === 'customprops')
		{
			tmpProvider.saveCustomPropertiesAsync(tmpSelected.Entity, tmpSelected.RecordID).then(() => fDone('Saved.')).catch(fFail);
		}
		else
		{
			tmpProvider.saveConfigAsync(tmpProvider.state.WriteScope)
				.then(() => fDone(`Saved to ${tmpProvider._scopeLabel(tmpProvider.state.WriteScope)}.`)).catch(fFail);
		}
	}

	/** Route to the clone workflow (Part E). */
	openClone()
	{
		if (this.pict.providers.PlatformConfigurationRouter && this.pict.providers.PictRouter)
		{
			window.location.hash = '#/ConfigClone';
		}
	}
}

module.exports = ConfigViewer;

module.exports.default_configuration =
{
	ViewIdentifier: 'ConfigViewer',
	DefaultRenderable: 'ConfigViewerWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.cv-wrap { padding: 1.25rem 1.5rem 2rem; }
		.cv-head { display:flex; justify-content:space-between; align-items:flex-start; gap:1rem; margin:0 0 1rem; }
		.cv-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.cv-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.cv-cols { display:grid; grid-template-columns: 16rem 1fr 17rem; gap:1.1rem; align-items:start; }
		@media (max-width: 1100px) { .cv-cols { grid-template-columns: 14rem 1fr; } .cv-help-panel { display:none; } }
		.cv-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; }
		.cv-rail-group { margin:0 0 0.7rem; }
		.cv-rail-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0.25rem 0.5rem; }
		.cv-rail-item { padding:0.4rem 0.6rem; border-radius:6px; font-size:0.9rem; color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.cv-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
		.cv-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; font-weight:600; }
		.cv-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:20rem; }
		.cv-editor-head { display:flex; justify-content:space-between; align-items:center; gap:1rem; flex-wrap:wrap; margin:0 0 0.6rem; }
		.cv-editor-title { font-size:1.05rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.cv-value-select, .cv-scope-select { font-size:0.85rem; padding:0.2rem 0.4rem; border-radius:6px; border:1px solid var(--theme-color-border-default,#d7dce3); }
		.cv-scopebar { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; padding:0.5rem 0.7rem; margin:0 0 0.7rem; border-radius:7px; background:var(--theme-color-background-tertiary,#f4f6f9); border:1px solid var(--theme-color-border-light,#e8ebf0); }
		.cv-scopelabel { font-size:0.78rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); }
		.cv-legend { display:flex; gap:0.35rem; flex-wrap:wrap; margin-left:auto; }
		.cv-legend-item { font-size:0.6rem; font-weight:600; padding:0 0.42rem; border-radius:9px; line-height:1.6; }
		.cv-editor-host { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:7px; padding:0.5rem 0.4rem; min-height:9rem; background:var(--theme-color-background-secondary,#fbfcfd); }
		.cv-savebar { margin:0.8rem 0 0; display:flex; align-items:center; gap:0.8rem; }
		.cv-readonly { font-size:0.85rem; color:var(--theme-color-text-muted,#6b7686); }
		.cv-help-panel { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.9rem 1rem; }
		.cv-help-head { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-brand-primary,#2e7d74); margin:0 0 0.5rem; }
		.cv-help-ns { font-size:0.86rem; color:var(--theme-color-text-secondary,#45505f); line-height:1.45; margin:0 0 0.7rem; }
		.cv-help-key { margin:0 0 0.55rem; }
		.cv-help-key-addr { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:0.72rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.cv-help-key-text { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); line-height:1.4; }
		.cv-empty { padding:2.5rem 1rem; text-align:center; color:var(--theme-color-text-muted,#6b7686); }
		.cv-spinner { display:inline-block; width:1.6rem; height:1.6rem; border:3px solid var(--theme-color-border-default,#dbdbdb); border-top-color:var(--theme-color-brand-primary,#2e7d74); border-radius:50%; animation:cv-spin 0.8s linear infinite; }
		@keyframes cv-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'ConfigViewer-Wrap',
			Template: /*html*/`
				<div class="cv-wrap">
					<div class="cv-head">
						<div>
							<h1 class="cv-title">Configuration</h1>
							<p class="cv-subtitle">See where each setting comes from across scopes, edit it at the right level, and clone it between contexts.</p>
						</div>
						<button class="button is-light" onclick="_Pict.views.ConfigViewer.openClone()"><span class="icon">{~I:Copy~}</span><span>Clone…</span></button>
					</div>
					{~TS:ConfigViewer-Message:AppData.ConfigViewer.MessageSlot~}
					<div class="cv-cols">
						<div class="cv-rail">{~TS:ConfigViewer-RailGroup:AppData.ConfigViewer.RailGroups~}</div>
						<div class="cv-main">
							{~TS:ConfigViewer-Loading:AppData.ConfigViewer.LoadingSlot~}
							{~TS:ConfigViewer-Editor:AppData.ConfigViewer.SelectedSlot~}
							{~TS:ConfigViewer-Empty:AppData.ConfigViewer.EmptySlot~}
						</div>
						{~TS:ConfigViewer-HelpPanel:AppData.ConfigViewer.HelpSlot~}
					</div>
				</div>`
		},
		{
			Hash: 'ConfigViewer-RailGroup',
			Template: /*html*/`
				<div class="cv-rail-group">
					<div class="cv-rail-head">{~D:Record.Group~}</div>
					{~TS:ConfigViewer-RailItem:Record.Items~}
				</div>`
		},
		{
			Hash: 'ConfigViewer-RailItem',
			Template: /*html*/`<div class="cv-rail-item {~D:Record.ActiveClass~}" onclick="_Pict.views.ConfigViewer.selectRailItem('{~D:Record.Kind~}','{~D:Record.NamespaceKey~}','{~D:Record.Entity~}','{~D:Record.RecordID~}')">{~D:Record.Label~}</div>`
		},
		{
			Hash: 'ConfigViewer-Editor',
			Template: /*html*/`
				<div class="cv-editor-head">
					<div class="cv-editor-title">{~D:Record.Label~}</div>
					{~TS:ConfigViewer-ValuePicker:AppData.ConfigViewer.ValuePickerSlot~}
				</div>
				{~TS:ConfigViewer-ScopeBar:AppData.ConfigViewer.ScopePickerSlot~}
				{~TS:ConfigViewer-EditorBody:AppData.ConfigViewer.EditorBodySlot~}
				{~TS:ConfigViewer-NoValues:AppData.ConfigViewer.NoValuesSlot~}`
		},
		{
			Hash: 'ConfigViewer-EditorBody',
			Template: /*html*/`
				<div id="CV-EditorHost" class="cv-editor-host"></div>
				<div class="cv-savebar">
					{~TS:ConfigViewer-SaveBtn:AppData.ConfigViewer.SaveEnabledSlot~}
					{~TS:ConfigViewer-ReadOnly:AppData.ConfigViewer.ReadOnlySlot~}
				</div>`
		},
		{
			Hash: 'ConfigViewer-NoValues',
			Template: /*html*/`<div class="cv-empty"><span class="icon is-large">{~I:Info~}</span><p class="mt-3">Nothing is configured for this namespace at the current context yet. Values appear here once they’ve been set at some scope.</p></div>`
		},
		{
			Hash: 'ConfigViewer-ValuePicker',
			Template: /*html*/`<select class="cv-value-select" onchange="_Pict.views.ConfigViewer.selectValue(this.value)">{~TS:ConfigViewer-ValueOption:AppData.ConfigViewer.ValueOptions~}</select>`
		},
		{
			Hash: 'ConfigViewer-ValueOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Value~}</option>`
		},
		{
			Hash: 'ConfigViewer-ScopeBar',
			Template: /*html*/`
				<div class="cv-scopebar">
					<span class="cv-scopelabel">Edits write to:</span>
					<select class="cv-scope-select" onchange="_Pict.views.ConfigViewer.setWriteScope(this.value)">{~TS:ConfigViewer-ScopeOption:AppData.ConfigViewer.ScopeOptions~}</select>
					<span class="cv-legend">{~TS:ConfigViewer-LegendItem:AppData.ConfigViewer.Legend~}</span>
				</div>`
		},
		{
			Hash: 'ConfigViewer-ScopeOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~} {~D:Record.DisabledAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'ConfigViewer-LegendItem',
			Template: /*html*/`<span class="cv-legend-item {~D:Record.BadgeClass~}">{~D:Record.Label~}</span>`
		},
		{
			Hash: 'ConfigViewer-SaveBtn',
			Template: /*html*/`<button class="button is-link" onclick="_Pict.views.ConfigViewer.save()"><span class="icon">{~I:Save~}</span><span>{~D:Record.SaveLabel~}</span></button>`
		},
		{
			Hash: 'ConfigViewer-ReadOnly',
			Template: /*html*/`<span class="cv-readonly">Read-only — you don’t have write access at this scope.</span>`
		},
		{
			Hash: 'ConfigViewer-HelpPanel',
			Template: /*html*/`
				<div class="cv-help-panel">
					<div class="cv-help-head">What this means</div>
					<p class="cv-help-ns">{~D:AppData.ConfigViewer.HelpNamespace~}</p>
					{~TS:ConfigViewer-HelpKey:AppData.ConfigViewer.HelpKeyList~}
				</div>`
		},
		{
			Hash: 'ConfigViewer-HelpKey',
			Template: /*html*/`<div class="cv-help-key"><div class="cv-help-key-addr">{~D:Record.Address~}</div><div class="cv-help-key-text">{~D:Record.Text~}</div></div>`
		},
		{
			Hash: 'ConfigViewer-Message',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'ConfigViewer-Loading',
			Template: /*html*/`<div class="cv-empty"><span class="cv-spinner"></span><p class="mt-3">Loading…</p></div>`
		},
		{
			Hash: 'ConfigViewer-Empty',
			Template: /*html*/`<div class="cv-empty"><span class="icon is-large">{~I:Settings~}</span><p class="mt-3">Pick a configuration namespace from the left to see where its values come from.</p></div>`
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ConfigViewerWrap',
			TemplateHash: 'ConfigViewer-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container',
		}
	]
};

},{"../config-editor/views/ProvenanceObjectEditor.js":1080,"pict-view":1053}],1418:[function(require,module,exports){

const libPictView = require('pict-view');

class ConfigurationIndex extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	onAfterRender()
	{
		const session = this.pict.AppData.CurrentUser;
		const isHeadlightCustomer = session && session.IDCustomer === 1;

		if (!isHeadlightCustomer)
		{
			this.pict.ContentAssignment.addClass('.config-card-customer-only', 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.removeClass('.config-card-customer-only', 'is-hidden');
		}

		return super.onAfterRender();
	}
}

module.exports = ConfigurationIndex;

module.exports.default_configuration =
{
	ViewIdentifier: 'ConfigurationIndex',
	DefaultRenderable: 'ConfigurationIndexWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	Templates:
	[
		{
			Hash: 'ConfigurationIndexWrap',
			Template: /*html*/`
			<section class="section">
				<div class="container">
					<div class="mb-5">
						<h1 class="title is-3">
							<span class="icon-text">
								<span class="icon"><i class="fas fa-sliders"></i></span>
								<span>Configurations</span>
							</span>
						</h1>
						<p class="subtitle is-5 has-text-grey">
							Manage all platform entities and settings
						</p>
					</div>

					<div class="config-panel-grid">
						<!-- Core Entities -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-database"></i></span>
										<span>Core Entities</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block config-card-customer-only" href="#/PSRS/Customer/List">
									<span class="panel-icon"><i class="fas fa-city"></i></span>
									<span>
										<span class="has-text-weight-semibold">Customers</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage customer tenants, codes, timezone settings, and enabled status.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/User/List">
									<span class="panel-icon"><i class="fas fa-users"></i></span>
									<span>
										<span class="has-text-weight-semibold">Users</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage user accounts, login credentials, email addresses, and names.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/Project/List">
									<span class="panel-icon"><i class="fas fa-folder-open"></i></span>
									<span>
										<span class="has-text-weight-semibold">Projects</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage projects, their status, external IDs, and associated configuration.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/Organization/List">
									<span class="panel-icon"><i class="fas fa-building"></i></span>
									<span>
										<span class="has-text-weight-semibold">Organizations</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage contractors and organizations with addresses, vendor codes, and approval status.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Roles & Permissions -->
							<nav class="panel">
								<p class="panel-heading has-background-info-soft">
									<span class="icon-text">
										<span class="icon has-text-info"><i class="fas fa-shield-halved"></i></span>
										<span>Roles &amp; Permissions</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/Role/List">
									<span class="panel-icon"><i class="fas fa-user-shield"></i></span>
									<span>
										<span class="has-text-weight-semibold">Roles</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define named roles with permission levels, types, and descriptions.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/UserRoleJoin/List">
									<span class="panel-icon"><i class="fas fa-user-tag"></i></span>
									<span>
										<span class="has-text-weight-semibold">User Role Assignments</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Assign roles to users and configure proxy role delegation.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/RoleEdge/List">
									<span class="panel-icon"><i class="fas fa-sitemap"></i></span>
									<span>
										<span class="has-text-weight-semibold">Role Hierarchy</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define parent-child relationships between roles to build permission inheritance.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/RolePermission/List">
									<span class="panel-icon"><i class="fas fa-key"></i></span>
									<span>
										<span class="has-text-weight-semibold">Role Permissions</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Configure granular permission hashes, allowed/denied flags, and context scoping per role.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Observation & Document Types -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-shapes"></i></span>
										<span>Observation &amp; Document Types</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationManifest/List">
									<span class="panel-icon"><i class="fas fa-clipboard-check"></i></span>
									<span>
										<span class="has-text-weight-semibold">Observation Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define observation manifests with display names, categories, and settings.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ArtifactType/List">
									<span class="panel-icon"><i class="fas fa-puzzle-piece"></i></span>
									<span>
										<span class="has-text-weight-semibold">Artifact Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define artifact schemata used by observation types for data collection.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ReportNamedInstance/List">
									<span class="panel-icon"><i class="fas fa-file-lines"></i></span>
									<span>
										<span class="has-text-weight-semibold">Document Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage report templates, default report settings, and hash identifiers.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Tags & Labels -->
							<nav class="panel">
								<p class="panel-heading has-background-info-soft">
									<span class="icon-text">
										<span class="icon has-text-info"><i class="fas fa-tags"></i></span>
										<span>Tags &amp; Labels</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationTag/List">
									<span class="panel-icon"><i class="fas fa-tags"></i></span>
									<span>
										<span class="has-text-weight-semibold">Observation Tags</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Manage tag values classified by type, used for labeling observations.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ProjectTagType/List">
									<span class="panel-icon"><i class="fas fa-layer-group"></i></span>
									<span>
										<span class="has-text-weight-semibold">Project Tag Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Configure which tag type categories are available per project.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Document Approvals -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-diagram-project"></i></span>
										<span>Document Approvals</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/DocumentApprovalWorkflow/List">
									<span class="panel-icon"><i class="fas fa-diagram-project"></i></span>
									<span>
										<span class="has-text-weight-semibold">Doc Workflows</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">State transition edges defining how documents move between approval statuses.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/DocumentApprovalState/List">
									<span class="panel-icon"><i class="fas fa-circle-nodes"></i></span>
									<span>
										<span class="has-text-weight-semibold">Doc Approval States</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Named approval states (Draft, Submitted, Approved, etc.) for documents.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/DocumentApprovalStep/List">
									<span class="panel-icon"><i class="fas fa-list-ol"></i></span>
									<span>
										<span class="has-text-weight-semibold">Doc Approval Steps</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Sequential approval steps with role requirements, locking, and hierarchy options.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Observation Approvals -->
							<nav class="panel">
								<p class="panel-heading has-background-info-soft">
									<span class="icon-text">
										<span class="icon has-text-info"><i class="fas fa-diagram-project"></i></span>
										<span>Observation Approvals</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationApprovalWorkflow/List">
									<span class="panel-icon"><i class="fas fa-diagram-project"></i></span>
									<span>
										<span class="has-text-weight-semibold">Obs Workflows</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">State transition edges defining how observations move between approval statuses.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationApprovalState/List">
									<span class="panel-icon"><i class="fas fa-circle-nodes"></i></span>
									<span>
										<span class="has-text-weight-semibold">Obs Approval States</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Named approval states (Draft, Submitted, Approved, etc.) for observations.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ObservationApprovalStep/List">
									<span class="panel-icon"><i class="fas fa-list-ol"></i></span>
									<span>
										<span class="has-text-weight-semibold">Obs Approval Steps</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Sequential approval steps scoped by observation type with role requirements.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Contracts & Projects -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-file-contract"></i></span>
										<span>Contracts &amp; Projects</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/PSRS/ContractType/List">
									<span class="panel-icon"><i class="fas fa-file-contract"></i></span>
									<span>
										<span class="has-text-weight-semibold">Contract Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define contract lifecycle types — available statuses, default dates, allowed project types. CSV import available from the dashboard.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
								<a class="panel-block nav-panel-block" href="#/PSRS/ProjectType/List">
									<span class="panel-icon"><i class="fas fa-diagram-project"></i></span>
									<span>
										<span class="has-text-weight-semibold">Project Types</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Define project lifecycle types — available statuses, default dates, and which statuses require a Change Order for line-item edits.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>

						<!-- Platform Capabilities -->
							<nav class="panel">
								<p class="panel-heading has-background-primary-soft">
									<span class="icon-text">
										<span class="icon has-text-primary"><i class="fas fa-puzzle-piece"></i></span>
										<span>Platform Capabilities</span>
									</span>
								</p>
								<a class="panel-block nav-panel-block" href="#/ContractAdmin">
									<span class="panel-icon"><i class="fas fa-file-contract"></i></span>
									<span>
										<span class="has-text-weight-semibold">Contract Administration</span>
										<span class="is-block is-size-7 has-text-grey nav-panel-desc">Enable and configure Contract Administration including payments, change orders, funding, and dashboards.</span>
									</span>
									<span class="icon nav-panel-arrow"><i class="fas fa-circle-chevron-right"></i></span>
								</a>
							</nav>
					</div>
				</div>
			</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ConfigurationIndexWrap',
			TemplateHash: 'ConfigurationIndexWrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1419:[function(require,module,exports){

const libPictView = require('pict-view');
const libNavigationTopics = require('../navigation-topics.js');

const html = String.raw;

/**
 * Host view — the Configurations "home" screen and
 * the app's landing page. Renders:
 *   1. a KPI jumbotron (all platform counts as small wide rectangles, Customers gated);
 *   2. the navigation-style chooser (Sidebar / Hub / List / Command Palette);
 *   3. the full navigation (everything) — page styles render it here, the Sidebar style
 *      docks it as a rail (handled by the application) and this screen shows a welcome.
 */
class ConfigurationNavigation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get navigationProvider()
	{
		return this.pict.providers['Pict-Navigation'];
	}

	onBeforeRender(pRenderable)
	{
		// Jumbotron data (read by the template); KPI values come from the live counts.
		const tmpTopic = libNavigationTopics.TOPIC_CONFIGS.Settings;
		this.pict.AppData.NavJumbo = { Title: tmpTopic.Title, Icon: tmpTopic.Icon, Blurb: tmpTopic.Blurb };
		this.pict.AppData.NavKpis = libNavigationTopics.buildKpiRecords(
			this.pict.AppData.DashboardStats, tmpTopic.KpiKeys, this.pict.PictApplication.isHeadlightSession());
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		this._paintChooser();
		this.show(this.pict.PictApplication.navigationStyle);
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	/** Build the style chooser buttons from the provider's render-type metadata. */
	_paintChooser()
	{
		const tmpProvider = this.navigationProvider;
		if (!tmpProvider) { return; }
		let tmpButtons = '';
		tmpProvider.getRenderTypes().forEach((pType) =>
		{
			tmpButtons += `<button id="ConfigNavSwitch-${pType.Key}" type="button" class="button is-small" title="${pType.Blurb || ''}" onclick="_Pict.views.ConfigurationNavigation.show('${pType.Key}')">`
				+ `<span class="icon is-small">${this.pict.icon(pType.Icon || 'Menu')}</span><span>${pType.Label}</span></button>`;
		});
		this.pict.ContentAssignment.assignContent('#ConfigNav-Switcher',
			`<span class="config-nav-switcher-label">Navigation style</span><div class="buttons has-addons">${tmpButtons}</div>`);
	}

	/**
	 * Apply + render a navigation style. Persists/reshapes the shell only when the style
	 * actually changes (the shell was already applied at login), then paints this screen.
	 *
	 * @param {string} pStyle - 'Sidebar' | 'Hub' | 'List' | 'Palette'
	 */
	show(pStyle)
	{
		const tmpApp = this.pict.PictApplication;
		const tmpProvider = this.navigationProvider;
		if (pStyle !== tmpApp.navigationStyle)
		{
			tmpApp.setNavigationStyle(pStyle);
		}

		tmpProvider.getRenderTypes().forEach((pType) =>
		{
			const tmpActive = (pType.Key === pStyle);
			this.pict.ContentAssignment[tmpActive ? 'addClass' : 'removeClass'](`#ConfigNavSwitch-${pType.Key}`, 'is-link');
			this.pict.ContentAssignment[tmpActive ? 'addClass' : 'removeClass'](`#ConfigNavSwitch-${pType.Key}`, 'is-selected');
		});

		// Body: a welcome for the docked rail, or the (everything) page nav as a home screen.
		if (tmpProvider.isRailRenderType(pStyle))
		{
			this.pict.ContentAssignment.assignContent('#Navigation-Container', this._welcomeHTML());
		}
		else
		{
			tmpProvider.render(pStyle, '#Navigation-Container');
		}
	}

	_welcomeHTML()
	{
		return html`
			<div class="config-nav-welcome">
				<span class="config-nav-welcome-ic"><i class="fas fa-bars-staggered"></i></span>
				<h2 class="config-nav-welcome-title">Your navigation is docked on the left</h2>
				<p class="config-nav-welcome-sub">Every configuration area lives in the sidebar — search it or pick an area, and each entry explains what it does.</p>
				<div class="config-nav-welcome-keys">
					<span><kbd>⌘</kbd><kbd>K</kbd> &nbsp;jump to anything (or <kbd>Ctrl</kbd><kbd>K</kbd>)</span>
					<span><kbd>F1</kbd> &nbsp;open help</span>
				</div>
				<p class="config-nav-welcome-hint">Prefer a full-screen home? Choose <strong>Hub</strong>, <strong>List</strong>, or <strong>Command Palette</strong> above.</p>
			</div>`;
	}
}

module.exports = ConfigurationNavigation;

module.exports.default_configuration =
{
	ViewIdentifier: 'ConfigurationNavigation',
	DefaultRenderable: 'ConfigurationNavigationWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
/* Navigation-style chooser — a footer control: right-justified at the bottom of the page. */
.config-nav-switcher { display: flex; align-items: center; justify-content: flex-end; gap: 0.75rem; flex-wrap: wrap;
	margin-top: 1.75rem; padding-top: 1.1rem; border-top: 1px solid var(--bulma-border-weak, #e8ebf0); }
.config-nav-switcher .config-nav-switcher-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--bulma-text-weak, #6b7686); }
.config-nav-switcher .buttons { margin-bottom: 0; }
.config-nav-switcher .buttons .button { margin-bottom: 0; gap: 0.4rem; }
.config-nav-switcher .buttons .button .icon { font-size: 0.85em; }

/* Welcome panel shown on the Configurations home when the docked Sidebar style is active. */
.config-nav-welcome { max-width: 620px; margin: 2rem auto; text-align: center; color: var(--bulma-text, #1f2733); }
.config-nav-welcome-ic { display: inline-flex; align-items: center; justify-content: center; width: 64px; height: 64px;
	border-radius: 16px; font-size: 1.7rem; margin-bottom: 1rem;
	background: var(--bulma-scheme-main-bis, #f4f6fa); color: var(--bulma-link, #156dd1); }
.config-nav-welcome-title { font-size: 1.4rem; font-weight: 700; margin: 0 0 0.4rem; }
.config-nav-welcome-sub { color: var(--bulma-text-weak, #6b7686); margin: 0 0 1.4rem; }
.config-nav-welcome-keys { display: flex; gap: 1.5rem; justify-content: center; flex-wrap: wrap; margin-bottom: 1.4rem;
	font-size: 0.85rem; color: var(--bulma-text-weak, #6b7686); }
.config-nav-welcome-keys kbd { background: var(--bulma-scheme-main-bis, #eceef2); border: 1px solid var(--bulma-border, #d7dce3);
	border-radius: 5px; padding: 1px 6px; font: inherit; font-weight: 700; margin: 0 1px; }
.config-nav-welcome-hint { font-size: 0.85rem; color: var(--bulma-text-weak, #6b7686); }
`,

	Templates:
	[
		libNavigationTopics.KPI_CARD_TEMPLATE,
		{
			Hash: 'ConfigurationNavigation-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="nav-jumbo">
							<div class="nav-jumbo-head">
								<span class="nav-jumbo-ic"><i class="{~D:AppData.NavJumbo.Icon~}"></i></span>
								<div>
									<h1 class="nav-jumbo-title">{~D:AppData.NavJumbo.Title~}</h1>
									<p class="nav-jumbo-sub">{~D:AppData.NavJumbo.Blurb~}</p>
								</div>
							</div>
							<div class="nav-kpi-strip">{~TS:Nav-Kpi-Card:AppData.NavKpis~}</div>
						</div>
						<div id="Navigation-Container" class="pict-nav"></div>
						<div id="ConfigNav-Switcher" class="config-nav-switcher"></div>
					</div>
				</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ConfigurationNavigationWrap',
			TemplateHash: 'ConfigurationNavigation-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"../navigation-topics.js":1295,"pict-view":1053}],1420:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// One small addition on top of the reused .pew-* form styles: the required-field mark.
const CCW_CSS = /*css*/`
	.ccw-req { color: var(--theme-color-status-error, #cf5b5b); font-weight: 700; }
`;

/**
 * ContractCreateWorkspace — the bespoke Contract CREATE screen (reached by the app-router Create bridge on
 * #/PSRS/Contract/Create, which shadows the generic recordset create form so "+ New" opens the curated
 * experience). A thin shell: all data, behavior, and hand-built form HTML live in the ContractCreateWorkspace
 * provider, which assigns into the #CCW-Body mount. Reuses the Edit workspace's .pew-* CSS.
 */
class ContractCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ContractCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ContractCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'ContractCreateWorkspace',
	DefaultRenderable: 'ContractCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libProjectEditWorkspace.default_configuration.CSS + CCW_CSS,
	Templates:
	[
		{
			Hash: 'ContractCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="CCW-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ContractCreateWorkspaceWrap',
			TemplateHash: 'ContractCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./ProjectEditWorkspace.js":1463,"pict-view":1053}],1421:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

const html = String.raw;

// The orchestrator provider (schema/parse/build/push + wizard-free UI state).
const PROVIDER_HASH = 'ContractPackageImportManager';
const P = `_Pict.providers.${PROVIDER_HASH}`;

/**
 * Host page for the bespoke Contract-package importer.
 *
 * A purpose-built, entity-aware screen (not the generic per-entity wizard) that loads a whole
 * Contract -> Project -> BidItem -> LineItem graph in one pass. All behaviour lives in the
 * ContractPackageImportManager provider; this view is the shell + templates over AppData.ContractImportUI.
 * Three stages read top-to-bottom: (1) what to import (new package vs attach to an existing Contract),
 * (2) where the data is (one file — a sheet or workbook — or a file per level), (3) map each level's key + fields,
 * preview the counts, and import.
 */
class ContractPackageImport extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get manager()
	{
		return this.pict.providers[PROVIDER_HASH];
	}

	onBeforeRender(pRenderable)
	{
		if (this.manager) { this.manager.prepare(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		if (this.manager) { this.manager.mountUploaders(); this.manager.mountMappingAccordion(); this.manager.mountReviewTree(); this.manager.mountContractPicker(); this.manager.mountProjectPicker(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ContractPackageImport;

module.exports.default_configuration =
{
	ViewIdentifier: 'ContractPackageImport',
	DefaultRenderable: 'ContractPackageImportWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.cpi-head { display: flex; align-items: center; gap: 0.9rem; max-width: 1040px; margin: 0 auto 1.1rem; }
.cpi-head-ic { display: inline-flex; align-items: center; justify-content: center; width: 2.6rem; height: 2.6rem; border-radius: 12px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; flex: 0 0 auto; }
.cpi-title { font-size: 1.5rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.cpi-sub { font-size: 0.92rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.15rem 0 0; max-width: 70ch; }
.cpi-panel { max-width: 1040px; margin: 0 auto; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 1.1rem 1.2rem; min-height: 60vh; }
.cpi-step { padding: 0.6rem 0 1rem; border-bottom: 1px solid var(--theme-color-border-light, #f0f2f6); }
.cpi-step:last-child { border-bottom: none; }
.cpi-step-label { font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;
	color: var(--theme-color-text-muted, #8894a4); margin-bottom: 0.6rem; }
.cpi-seg-group { display: inline-flex; flex-wrap: wrap; gap: 0.4rem; }
.cpi-seg { cursor: pointer; font: inherit; font-size: 0.9rem; font-weight: 600; padding: 0.5rem 0.9rem; border-radius: 8px;
	border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-primary, #fff);
	color: var(--theme-color-text-secondary, #45596b); display: inline-flex; align-items: center; gap: 0.4rem; }
.cpi-seg:hover { border-color: var(--theme-color-brand-primary, #156dd1); }
.cpi-seg-on { background: var(--theme-color-brand-primary, #156dd1); border-color: var(--theme-color-brand-primary, #156dd1); color: #fff; }
.cpi-picker { display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem; margin-top: 0.7rem;
	padding: 0.6rem 0.75rem; border-radius: 8px; background: var(--theme-color-background-secondary, #f6f7f9); }
.cpi-picker-hint, .cpi-upload-hint { font-size: 0.84rem; color: var(--theme-color-text-muted, #6b7686); }
.cpi-picker-opt { color: var(--theme-color-text-muted, #8894a4); font-weight: 400; }
.cpi-tmpl-dl { display: flex; align-items: center; gap: 0.45rem; margin-top: 0.7rem; padding: 0.5rem 0.75rem; border-radius: 8px; font-size: 0.86rem;
	background: color-mix(in srgb, var(--theme-color-status-success, #2e7a3a) 9%, transparent); color: var(--theme-color-text-secondary, #45596b); }
.cpi-tmpl-dl i { color: #217346; }
.cpi-tmpl-dl a { color: var(--theme-color-brand-primary, #156dd1); font-weight: 600; text-decoration: none; }
.cpi-tmpl-dl a:hover { text-decoration: underline; }
.cpi-select { font: inherit; font-size: 0.9rem; padding: 0.35rem 0.5rem; border-radius: 6px; max-width: 22rem;
	border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.cpi-upload { display: flex; align-items: center; gap: 0.6rem; margin-top: 0.7rem; }
.cpi-upload-sm { margin-top: 0.4rem; }
.cpi-drop { flex: 1; min-width: 18rem; }
.cpi-drop-sm { min-width: 14rem; }
.cpi-level { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; padding: 0.7rem 0.85rem; margin-bottom: 0.7rem; }
.cpi-level-head { display: flex; align-items: center; gap: 0.55rem; flex-wrap: wrap; }
.cpi-level-ic { color: var(--theme-color-brand-primary, #156dd1); }
.cpi-level-count { font-size: 0.78rem; color: var(--theme-color-text-muted, #8894a4); }
.cpi-map-accordion { margin: 0.2rem 0 0.6rem; }
.cpi-level-body { padding: 0.4rem 0.1rem 0.2rem; }
.cpi-level-controls { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 0.9rem; margin-bottom: 0.9rem;
	padding-bottom: 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
.cpi-level-controls .field { margin-bottom: 0; }
.cpi-field-grid .label.is-small { margin-bottom: 0.2rem; font-weight: 600; }
.cpi-section { margin-bottom: 1.1rem; }
.cpi-section:last-child { margin-bottom: 0.2rem; }
.cpi-section-head { background: var(--theme-color-background-secondary, #f4f6f9); color: var(--theme-color-brand-primary, #4b56d2);
	font-size: 0.72rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em;
	padding: 0.42rem 0.8rem; border-radius: 6px; margin-bottom: 0.7rem; }
.cpi-key { font-size: 0.85rem; color: var(--theme-color-text-secondary, #45596b); display: inline-flex; align-items: center; gap: 0.4rem; }
.cpi-fields { display: grid; grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); gap: 0.35rem 0.9rem; margin-top: 0.6rem; }
.cpi-field { display: flex; align-items: center; gap: 0.4rem; }
.cpi-field-label { font-size: 0.84rem; color: var(--theme-color-text-secondary, #45596b); min-width: 8rem; }
.cpi-req { color: var(--theme-color-status-error, #b62828); }
.cpi-field .cpi-select { flex: 1; min-width: 0; }
.cpi-actions { display: flex; gap: 0.6rem; margin: 0.8rem 0 0.4rem; }
.cpi-btn { cursor: pointer; font: inherit; font-size: 0.9rem; font-weight: 600; padding: 0.5rem 1rem; border-radius: 8px; border: none;
	background: var(--theme-color-brand-primary, #156dd1); color: #fff; display: inline-flex; align-items: center; gap: 0.4rem; }
.cpi-btn:hover { background: var(--theme-color-brand-primaryhover, #1257ab); }
.cpi-btn-ghost { background: transparent; color: var(--theme-color-brand-primary, #156dd1); border: 1px solid var(--theme-color-border-medium, #d5dbe3); }
.cpi-preview { display: flex; align-items: center; gap: 0.45rem; margin: 0.5rem 0; padding: 0.6rem 0.8rem; border-radius: 8px; font-size: 0.92rem;
	background: var(--theme-color-state-success-bg, #e7f6ec); color: var(--theme-color-state-success-text, #1d7a3f); }
.cpi-warn { display: flex; align-items: center; gap: 0.45rem; margin: 0.3rem 0; padding: 0.45rem 0.7rem; border-radius: 8px; font-size: 0.86rem;
	background: var(--theme-color-state-warning-bg, #fff7e6); color: var(--theme-color-state-warning-text, #9a6a00); }
.cpi-tree { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; padding: 0.5rem 0.7rem; overflow-x: auto; background: var(--theme-color-background-primary, #fff); }
.cpi-tree-node { margin: 0.15rem 0; }
.cpi-tree-node > .cpi-tree-children { margin-left: 1.1rem; padding-left: 0.6rem; border-left: 2px solid var(--theme-color-border-light, #eef1f5); }
.cpi-tree-head { cursor: pointer; display: flex; align-items: center; gap: 0.5rem; padding: 0.32rem 0.4rem; border-radius: 6px; list-style: none; }
.cpi-tree-head:hover { background: var(--theme-color-background-secondary, #f6f7f9); }
.cpi-tree-head::-webkit-details-marker { display: none; }
.cpi-tree-head::before { content: '▸'; color: var(--theme-color-text-muted, #8894a4); font-size: 0.8rem; transition: transform 0.15s; }
details[open] > .cpi-tree-head::before { transform: rotate(90deg); }
.cpi-tree-leaf { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; padding: 0.3rem 0.4rem 0.3rem 1.3rem; }
.cpi-tree-badge { flex: 0 0 auto; font-size: 0.64rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em; padding: 0.1rem 0.4rem; border-radius: 999px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #4b56d2); }
.cpi-tree-title { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); font-size: 0.9rem; }
.cpi-tree-sub { font-size: 0.78rem; color: var(--theme-color-text-muted, #8894a4); }
.cpi-tree-fields { display: flex; flex-wrap: wrap; gap: 0.3rem 0.5rem; margin: 0.15rem 0 0.35rem 1.3rem; }
.cpi-tree-chip { font-size: 0.78rem; color: var(--theme-color-text-secondary, #45596b); background: var(--theme-color-background-secondary, #f6f7f9); border-radius: 5px; padding: 0.08rem 0.4rem; }
.cpi-tree-chip-k { color: var(--theme-color-text-muted, #8894a4); }
.cpi-tree-empty { color: var(--theme-color-text-muted, #8894a4); font-size: 0.9rem; padding: 0.6rem; }
.cpi-note { display: flex; align-items: center; gap: 0.45rem; margin: 0.6rem 0 0; padding: 0.5rem 0.75rem; border-radius: 8px; font-size: 0.88rem;
	background: var(--theme-color-background-secondary, #f6f7f9); color: var(--theme-color-text-secondary, #45596b); }
.cpi-result { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; margin: 0 0 0.7rem; padding: 0.6rem 0.8rem; border-radius: 8px; font-size: 0.92rem;
	background: var(--theme-color-state-success-bg, #e7f6ec); color: var(--theme-color-state-success-text, #1d7a3f); }
.cpi-result a { margin-left: 0.2rem; font-weight: 600; color: var(--theme-color-brand-primary, #156dd1); text-decoration: none; }
.cpi-error { display: flex; align-items: center; gap: 0.5rem; margin: 0 0 0.7rem; padding: 0.6rem 0.8rem; border-radius: 8px; font-size: 0.92rem;
	background: var(--theme-color-state-warning-bg, #fdecec); color: var(--theme-color-state-warning-text, #b3261e); }
`,

	Templates:
	[
		{
			Hash: 'CPI-Contract-Option-Template',
			Template: html`<option value="{~D:Record.IDContract~}" data-key="{~D:Record.Key~}" data-label="{~D:Record.Label~}">{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'CPI-Project-Option-Template',
			Template: html`<option value="{~D:Record.IDProject~}" data-key="{~D:Record.Key~}" data-label="{~D:Record.Label~}">{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'CPI-ProjectPicker-Template',
			Template: html`
				<label>Project <span class="cpi-picker-opt">(optional)</span>:
					<div id="CPI-ProjectPicker" class="cpi-picker-mount"></div>
				</label>`,
		},
		{
			Hash: 'CPI-Col-Option-Template',
			Template: html`<option value="{~D:Record.Name~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'CPI-Picker-Template',
			Template: html`
				<div class="cpi-picker">
					<label>Contract:
						<div id="CPI-ContractPicker" class="cpi-picker-mount"></div>
					</label>
					{~TS:CPI-ProjectPicker-Template:AppData.ContractImportUI.ProjectPickerSlot~}
						<span class="cpi-picker-hint">Attach to an existing Contract (and, optionally, a Project) — only the levels below your selection are created. Pick a Project to import just Bid Items &amp; Line Items.</span>
				</div>`,
		},
		{
			Hash: 'CPI-TopUpload-Template',
			Template: html`
				<div class="cpi-upload">
					<div id="CPI-Upload-sheet" class="cpi-drop"></div>
					<span class="cpi-upload-hint">{~D:Record.Hint~}</span>
				</div>`,
		},
		{
			Hash: 'CPI-LevelFile-Template',
			Template: html`
				<div class="cpi-upload cpi-upload-sm">
					<div id="CPI-Upload-{~D:Record.Entity~}" class="cpi-drop cpi-drop-sm"></div>
				</div>`,
		},
		{
			Hash: 'CPI-Tab-Option-Template',
			Template: html`<option value="{~D:Record.Name~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'CPI-LevelTab-Template',
			Template: html`
				<div class="field is-narrow">
					<label class="label is-small">Sheet</label>
					<div class="control">
						<div class="select is-small">
							<select onchange="${P}.setTab('{~D:Record.Entity~}', this.value)">
								{~TS:CPI-Tab-Option-Template:Record.TabItems~}
							</select>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'CPI-Field-Template',
			Template: html`
				<div class="column is-half-tablet is-one-quarter-desktop">
					<div class="field">
						<label class="label is-small">{~D:Record.Label~}{~NE:Record.Required^ <span class="cpi-req">*</span>~}</label>
						<div class="control">
							<div class="select is-small is-fullwidth">
								<select onchange="${P}.assignField('{~D:Record.Entity~}', '{~D:Record.Name~}', this.value)">
									{~TS:CPI-Col-Option-Template:Record.ColumnItems~}
								</select>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'CPI-Group-Template',
			Template: html`
				<div class="cpi-section">
					<div class="cpi-section-head">{~D:Record.Section~}</div>
					<div class="columns is-multiline cpi-field-grid">
						{~TS:CPI-Field-Template:Record.Fields~}
					</div>
				</div>`,
		},
		{
			Hash: 'CPI-Level-Body-Template',
			Template: html`
				<div class="cpi-level-body">
					<div class="cpi-level-controls">
						{~TS:CPI-LevelTab-Template:Record.TabSlot~}
						<div class="field is-narrow">
							<label class="label is-small">Key column</label>
							<div class="control">
								<div class="select is-small">
									<select onchange="${P}.setKeyColumn('{~D:Record.Entity~}', this.value)">
										{~TS:CPI-Col-Option-Template:Record.ColumnItems~}
									</select>
								</div>
							</div>
						</div>
					</div>
					{~TS:CPI-LevelFile-Template:Record.FileSlot~}
					{~TS:CPI-Group-Template:Record.Groups~}
				</div>`,
		},
		{
			Hash: 'CPI-Preview-Template',
			Template: html`<div class="cpi-preview"><i class="fas fa-circle-check"></i> <strong>Ready:</strong> {~D:Record.Summary~}</div>`,
		},
		{
			Hash: 'CPI-Warning-Template',
			Template: html`<div class="cpi-warn"><i class="fas fa-triangle-exclamation"></i> {~D:Record.Message~}</div>`,
		},
		{
			Hash: 'CPI-Note-Template',
			Template: html`<div class="cpi-note"><i class="fas fa-circle-info"></i> {~D:Record.Message~}</div>`,
		},
		{
			Hash: 'CPI-PackageScope-Template',
			Template: html`
				<div class="cpi-seg-group">
					<button class="cpi-seg{~D:AppData.ContractImportUI.ModeNewClass~}" onclick="${P}.setMode('new')"><i class="fas fa-plus"></i> New package</button>
					<button class="cpi-seg{~D:AppData.ContractImportUI.ModeExistingClass~}" onclick="${P}.setMode('existing')"><i class="fas fa-link"></i> Add to an existing Contract</button>
				</div>
				{~TS:CPI-Picker-Template:AppData.ContractImportUI.PickerSlot~}
				<div class="cpi-tmpl-dl"><i class="fas fa-file-excel"></i> <span>New to this? <a href="#" onclick="_Pict.providers.ContractPackageImportManager.downloadTemplate(); return false;">Download the Excel template</a>, fill in the tabs, and upload it below — the columns map themselves.</span></div>`,
		},
		{
			Hash: 'CPI-ItemsIntro-Template',
			Template: html`<div class="cpi-note"><i class="fas fa-circle-info"></i> Upload a file of Bid Items &amp; Line Items. Each row is matched to its existing Contract &amp; Project by a column you'll choose below — so one file can span many projects.</div>`,
		},
		{
			Hash: 'CPI-Link-Template',
			Template: html`
				<div class="cpi-step">
					<div class="cpi-step-label">Link rows to existing Contracts &amp; Projects</div>
					<div class="cpi-picker">
						<label>Contract column:
							<select class="cpi-select" onchange="${P}.setContractKeyColumn(this.value)">
								{~TS:CPI-Col-Option-Template:Record.ContractItems~}
							</select>
						</label>
						<label>Project column:
							<select class="cpi-select" onchange="${P}.setProjectKeyColumn(this.value)">
								{~TS:CPI-Col-Option-Template:Record.ProjectItems~}
							</select>
						</label>
						<span class="cpi-picker-hint">Each row's Contract &amp; Project are matched by these columns (e.g. a contract number and a project name).</span>
					</div>
				</div>`,
		},
		{
			Hash: 'CPI-Result-Template',
			Template: html`<div class="cpi-result"><i class="fas fa-circle-check"></i><span>{~D:Record.Message~}</span><a href="{~D:Record.ViewRoute~}">{~D:Record.ViewLabel~} →</a></div>`,
		},
		{
			Hash: 'CPI-Error-Template',
			Template: html`<div class="cpi-error"><i class="fas fa-triangle-exclamation"></i><span>{~D:Record.Message~}</span></div>`,
		},
		{
			Hash: 'CPI-Review-Template',
			Template: html`
				<div class="cpi-step">
					<div class="cpi-step-label">Review — the records that will be created</div>
					<p class="cpi-picker-hint" style="margin-bottom:0.6rem;">Expand to check the data before importing. Nothing is saved until you click <strong>Import</strong>.</p>
					<div id="CPI-Review-Tree" class="cpi-tree"></div>
				</div>`,
		},
		{
			Hash: 'CPI-Map-Template',
			Template: html`
				<div class="cpi-step">
					<div class="cpi-step-label">3 · Map &amp; import</div>
					<div id="CPI-Map-Accordion" class="cpi-map-accordion"></div>
					<div class="cpi-actions">
						<button class="cpi-btn cpi-btn-ghost" onclick="${P}.buildPreview()"><i class="fas fa-eye"></i> Preview</button>
						<button class="cpi-btn" onclick="${P}.runImport()"><i class="fas fa-cloud-arrow-up"></i> Import package</button>
					</div>
					{~TS:CPI-Preview-Template:AppData.ContractImportUI.PreviewSlot~}
					{~TS:CPI-Warning-Template:AppData.ContractImportUI.WarningSlot~}
				</div>`,
		},
		{
			Hash: 'ContractPackageImport-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="cpi-head">
							<span class="cpi-head-ic"><i class="{~D:AppData.ContractImportUI.HeadIcon~}"></i></span>
							<div>
								<h1 class="cpi-title">{~D:AppData.ContractImportUI.Title~}</h1>
								<p class="cpi-sub">{~D:AppData.ContractImportUI.Subtitle~}</p>
							</div>
						</div>
						<div class="cpi-panel">
							{~TS:CPI-Error-Template:AppData.ContractImportUI.ErrorSlot~}
							{~TS:CPI-Result-Template:AppData.ContractImportUI.ResultSlot~}

							<div class="cpi-step">
								<div class="cpi-step-label">1 · What are you importing?</div>
								{~TS:CPI-PackageScope-Template:AppData.ContractImportUI.PackageScopeSlot~}
								{~TS:CPI-ItemsIntro-Template:AppData.ContractImportUI.ItemsIntroSlot~}
							</div>

							<div class="cpi-step">
								<div class="cpi-step-label">2 · Where's the data?</div>
								<div class="cpi-seg-group">
									<button class="cpi-seg{~D:AppData.ContractImportUI.ShapeSheetClass~}" onclick="${P}.setSourceShape('sheet')"><i class="fas fa-file-lines"></i> One file</button>
									<button class="cpi-seg{~D:AppData.ContractImportUI.ShapeFilesClass~}" onclick="${P}.setSourceShape('files')"><i class="fas fa-copy"></i> Multiple files</button>
								</div>
								{~TS:CPI-TopUpload-Template:AppData.ContractImportUI.TopUploadSlot~}
								{~TS:CPI-Note-Template:AppData.ContractImportUI.NoteSlot~}
							</div>

							{~TS:CPI-Link-Template:AppData.ContractImportUI.LinkSlot~}
							{~TS:CPI-Map-Template:AppData.ContractImportUI.MapSlot~}
							{~TS:CPI-Review-Template:AppData.ContractImportUI.ReviewSlot~}
						</div>
					</div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'ContractPackageImportWrap',
			TemplateHash: 'ContractPackageImport-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1422:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libShared = require('./ProjectContractTypes-Shared.js');

/**
 * ContractTypes — the #/ContractTypes management screen. A thin view over the shared ProjectContractTypes provider
 * (activated in Contract mode). Logic/state live in the provider; this view just lays out the rail/detail shell.
 */
class ContractTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ProjectContractTypes; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.activate('Contract'); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ContractTypes;
module.exports.default_configuration =
{
	ViewIdentifier: 'ContractTypes',
	DefaultRenderable: 'ContractTypesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libShared.CSS,
	Templates:
	[
		{
			Hash: 'ContractTypes-Wrap',
			Template: libShared.wrapTemplate('Contract Types', 'Create and edit contract types, then set up each one’s template — statuses, default dates, allowed project types, default funding — that new contracts are cloned from.'),
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ContractTypesWrap',
			TemplateHash: 'ContractTypes-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./ProjectContractTypes-Shared.js":1461,"pict-view":1053}],1423:[function(require,module,exports){

const libPictView = require('pict-view');

class CustomerProvisioning extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	/**
	 * Recompute every derived render slot from the current AppData state.
	 *
	 * All template-facing arrays/flags live on AppData.CustomerProvisioning so the
	 * template repaints declaratively after any provider mutation + render().
	 */
	deriveRenderState()
	{
		let tmpProvider = this.pict.providers.CustomerProvisioningProvider;

		if (!this.pict.AppData.CustomerProvisioning)
		{
			tmpProvider.initializeState();
		}

		tmpProvider.deriveStepState();
		tmpProvider.deriveDatasetRows();
		tmpProvider.derivePersonaGroups();
		tmpProvider.deriveRoleRows();
		tmpProvider.deriveReviewState();
		tmpProvider.derivePushState();
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onBeforeRenderAsync(fCallback)
	{
		this.deriveRenderState();
		return fCallback();
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = CustomerProvisioning;

module.exports.default_configuration =
{
	ViewIdentifier: 'CustomerProvisioning',
	DefaultRenderable: 'CustomerProvisioningWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	Templates:
	[
		{
			Hash: 'CustomerProvisioning-DatasetRow',
			Template: /*html*/`
				<tr class="cp-dataset-row {~D:Record.RowClass~}">
					<td><strong>{~D:Record.Code~}</strong></td>
					<td>{~D:Record.Name~}</td>
					<td class="has-text-right">{~D:Record.Records~}</td>
					<td class="has-text-right">{~D:Record.TestForms~}</td>
					<td class="has-text-right">{~D:Record.TestProcedures~}</td>
					<td class="has-text-right">{~D:Record.ExampleProjects~}</td>
					<td class="has-text-right">{~D:Record.BidTabs~}</td>
					<td>
						<button class="button is-small is-info is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.selectDataset('{~D:Record.Code~}')">
							Select
						</button>
					</td>
				</tr>`,
		},
		{
			Hash: 'CustomerProvisioning-DatasetSummary',
			Template: /*html*/`
				<div class="notification is-info is-soft mt-4">
					<strong>{~D:Record.Name~} ({~D:Record.Code~})</strong> selected.
					{~D:Record.Records~} entity records, {~D:Record.ExampleProjects~} example projects, ~183 forms.
					<button class="button is-info is-small ml-4" onclick="_Pict.providers.CustomerProvisioningProvider.completeStep(1)">
						Continue <i class="fas fa-arrow-right ml-2"></i>
					</button>
				</div>`,
		},
		{
			Hash: 'CustomerProvisioning-PersonaUser',
			Template: /*html*/`
				<div class="column is-4">
					<label class="checkbox">
						<input type="checkbox" {~D:Record.CheckedAttr~} onchange="_Pict.providers.CustomerProvisioningProvider.togglePersona({~D:Record.Index~})" />
						<strong>{~D:Record.NameFirst~} {~D:Record.NameLast~}</strong>
						<br /><small class="has-text-grey">{~D:Record.Title~}</small>
					</label>
				</div>`,
		},
		{
			Hash: 'CustomerProvisioning-PersonaGroup',
			Template: /*html*/`
				<h6 class="title is-6 mt-3">{~D:Record.Category~}</h6>
				<div class="columns is-multiline">
					{~TS:CustomerProvisioning-PersonaUser:Record.Users~}
				</div>`,
		},
		{
			Hash: 'CustomerProvisioning-RoleRow',
			Template: /*html*/`
				<tr>
					<td>{~D:Record.Name~}</td>
					<td><code>{~D:Record.Code~}</code></td>
					<td><span class="tag">{~D:Record.Type~}</span></td>
				</tr>`,
		},
		{
			Hash: 'CustomerProvisioning-LogLine',
			Template: /*html*/`<div>{~D:Record.Display~}</div>`,
		},
		{
			Hash: 'CustomerProvisioningWrap',
			Template: /*html*/`
			<section class="section">
				<div class="container">
					<div class="mb-5">
						<h1 class="title is-3">
							<span class="icon"><i class="fas fa-wand-magic-sparkles"></i></span>
							&nbsp;Customer Provisioning
						</h1>
						<p class="subtitle is-5 has-text-grey">
							Create a complete new customer environment from a specifications library dataset
						</p>
					</div>

					<!-- Step 1: Dataset Selection -->
					<article class="message is-info mb-4" id="CP-Step1">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(1)">
							<p><span class="icon"><i class="fas fa-database"></i></span>&nbsp;Step 1: Select Dataset</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step1_StatusClass~}">{~D:AppData.CustomerProvisioning.Step1_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step1_BodyClass~}">
							<div class="field mb-4">
								<div class="control has-icons-left">
									<input class="input" type="text" placeholder="Filter by state name or code..."
										value="{~D:AppData.CustomerProvisioning.DatasetFilter~}"
										oninput="_Pict.providers.CustomerProvisioningProvider.filterDatasetTable(this.value)" />
									<span class="icon is-left"><i class="fas fa-search"></i></span>
								</div>
							</div>
							<div class="table-container">
								<table class="table is-fullwidth is-hoverable is-striped">
									<thead>
										<tr>
											<th>Code</th>
											<th>State</th>
											<th class="has-text-right">Records</th>
											<th class="has-text-right">Test Forms</th>
											<th class="has-text-right">Test Procedures</th>
											<th class="has-text-right">Example Projects</th>
											<th class="has-text-right">Bid Tabs</th>
											<th></th>
										</tr>
									</thead>
									<tbody id="CP-Dataset-Rows">
										{~TS:CustomerProvisioning-DatasetRow:AppData.CustomerProvisioning.DatasetRows~}
									</tbody>
								</table>
							</div>
							{~TS:CustomerProvisioning-DatasetSummary:AppData.CustomerProvisioning.DatasetSummarySlot~}
						</div>
					</article>

					<!-- Step 2: Customer Details -->
					<article class="message mb-4" id="CP-Step2">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(2)">
							<p><span class="icon"><i class="fas fa-building"></i></span>&nbsp;Step 2: Customer Details</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step2_StatusClass~}">{~D:AppData.CustomerProvisioning.Step2_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step2_BodyClass~}">
							<!-- Customer form -->
							<div class="columns">
								<div class="column is-6">
									<div class="field">
										<label class="label">Customer Name</label>
										<div class="control"><input class="input" type="text" id="CP-CustomerName" placeholder="e.g., Alabama DOT" value="{~D:AppData.CustomerProvisioning.Customer.Name~}" /></div>
									</div>
								</div>
								<div class="column is-3">
									<div class="field">
										<label class="label">Customer Code</label>
										<div class="control"><input class="input" type="text" id="CP-CustomerCode" placeholder="e.g., ALDOT-DEMO" maxlength="12" value="{~D:AppData.CustomerProvisioning.Customer.Code~}" /></div>
										<p class="help">Max 12 characters, used for GUIDs</p>
									</div>
								</div>
								<div class="column is-3">
									<div class="field">
										<label class="label">Timezone</label>
										<div class="control">
											<div class="select is-fullwidth">
												<select id="CP-Timezone">
													<option value="America/New_York">Eastern</option>
													<option value="America/Chicago">Central</option>
													<option value="America/Denver">Mountain</option>
													<option value="America/Los_Angeles">Pacific</option>
													<option value="America/Anchorage">Alaska</option>
													<option value="Pacific/Honolulu">Hawaii</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="field is-grouped is-grouped-right">
								<div class="control">
									<button class="button is-info" onclick="_Pict.providers.CustomerProvisioningProvider.saveCustomerConfig()">
										<span class="icon"><i class="fas fa-arrow-right"></i></span><span>Continue</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 3: User Accounts -->
					<article class="message mb-4" id="CP-Step3">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(3)">
							<p><span class="icon"><i class="fas fa-users"></i></span>&nbsp;Step 3: User Accounts</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step3_StatusClass~}">{~D:AppData.CustomerProvisioning.Step3_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step3_BodyClass~}">
							<!-- Admin User -->
							<h5 class="title is-5">Administrator Account</h5>
							<div class="columns">
								<div class="column is-4">
									<div class="field"><label class="label">First Name</label>
										<div class="control"><input class="input" type="text" id="CP-AdminFirst" value="{~D:AppData.CustomerProvisioning.AdminUser.NameFirst~}" /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Last Name</label>
										<div class="control"><input class="input" type="text" id="CP-AdminLast" value="{~D:AppData.CustomerProvisioning.AdminUser.NameLast~}" /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Email</label>
										<div class="control"><input class="input" type="email" id="CP-AdminEmail" value="{~D:AppData.CustomerProvisioning.AdminUser.Email~}" /></div>
									</div>
								</div>
							</div>
							<div class="columns">
								<div class="column is-4">
									<div class="field"><label class="label">Login ID</label>
										<div class="control"><input class="input" type="text" id="CP-AdminLogin" value="{~D:AppData.CustomerProvisioning.AdminUser.LoginID~}" /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Password</label>
										<div class="control"><input class="input" type="text" id="CP-AdminPassword" value="{~D:AppData.CustomerProvisioning.AdminUser.LoginPassword~}" /></div>
									</div>
								</div>
							</div>

							<hr />
							<h5 class="title is-5">Integration Service Account</h5>
							<p class="has-text-grey mb-3">Auto-generated from customer code. Used for data import operations.</p>
							<div class="columns">
								<div class="column is-4">
									<div class="field"><label class="label">Login ID</label>
										<div class="control"><input class="input" type="text" id="CP-IntegrationLogin" value="{~D:AppData.CustomerProvisioning.IntegrationUser.LoginID~}" readonly /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Password</label>
										<div class="control"><input class="input" type="text" id="CP-IntegrationPassword" value="{~D:AppData.CustomerProvisioning.IntegrationUser.LoginPassword~}" /></div>
									</div>
								</div>
							</div>

							<hr />
							<h5 class="title is-5">Example User Accounts</h5>
							<p class="has-text-grey mb-3">Based on HeadLight personas. Uncheck any you don't want to create.</p>
							<div id="CP-PersonaList">
								{~TS:CustomerProvisioning-PersonaGroup:AppData.CustomerProvisioning.PersonaGroups~}
							</div>

							<div class="field is-grouped is-grouped-right mt-4">
								<div class="control">
									<button class="button is-info" onclick="_Pict.providers.CustomerProvisioningProvider.saveUserConfig()">
										<span class="icon"><i class="fas fa-arrow-right"></i></span><span>Continue</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 4: Security & Defaults -->
					<article class="message mb-4" id="CP-Step4">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(4)">
							<p><span class="icon"><i class="fas fa-shield-halved"></i></span>&nbsp;Step 4: Security & Configuration</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step4_StatusClass~}">{~D:AppData.CustomerProvisioning.Step4_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step4_BodyClass~}">
							<h5 class="title is-5">Roles to Create</h5>
							<table class="table is-fullwidth is-striped">
								<thead><tr><th>Role</th><th>Code</th><th>Type</th></tr></thead>
								<tbody>
									{~TS:CustomerProvisioning-RoleRow:AppData.CustomerProvisioning.RoleRows~}
								</tbody>
							</table>
							<hr />
							<div class="field is-grouped is-grouped-right">
								<div class="control">
									<button class="button is-info" onclick="_Pict.providers.CustomerProvisioningProvider.saveSecurityConfig()">
										<span class="icon"><i class="fas fa-arrow-right"></i></span><span>Continue</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 5: Review & Generate -->
					<article class="message is-success mb-4" id="CP-Step5">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(5)">
							<p><span class="icon"><i class="fas fa-rocket"></i></span>&nbsp;Step 5: Review & Generate</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step5_StatusClass~}">{~D:AppData.CustomerProvisioning.Step5_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step5_BodyClass~}">
							<table class="table is-fullwidth is-striped">
								<tbody>
									<tr><td><strong>Customer</strong></td><td>{~D:AppData.CustomerProvisioning.CustomerLabel~}</td></tr>
									<tr><td><strong>Admin User</strong></td><td>{~D:AppData.CustomerProvisioning.AdminLabel~}</td></tr>
									<tr><td><strong>Example Personas</strong></td><td>{~D:AppData.CustomerProvisioning.PersonaSelectedCount~} selected</td></tr>
									<tr><td><strong>Dataset</strong></td><td>{~D:AppData.CustomerProvisioning.DatasetLabel~}</td></tr>
									<tr><td><strong>Spec Records</strong></td><td>{~D:AppData.CustomerProvisioning.SpecRecords~}</td></tr>
									<tr><td><strong>Roles</strong></td><td>{~D:AppData.CustomerProvisioning.RoleCount~} roles</td></tr>
								</tbody>
							</table>
							<hr />
							<div class="buttons is-right">
								<button class="button is-link is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.downloadComprehension(1)">
									<span class="icon"><i class="fas fa-download"></i></span><span>Download Phase 1 (Customer Setup)</span>
								</button>
								<button class="button is-link is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.downloadComprehension(2)">
									<span class="icon"><i class="fas fa-download"></i></span><span>Download Phase 2 (Spec Data)</span>
								</button>
								<button class="button is-primary" onclick="_Pict.providers.CustomerProvisioningProvider.createRequestDocument()">
									<span class="icon"><i class="fas fa-file-circle-plus"></i></span><span>Submit as New Customer Request</span>
								</button>
								<button class="button is-success is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.pushToHeadLight()" title="Provision immediately, skipping the approval request">
									<span class="icon"><i class="fas fa-cloud-arrow-up"></i></span><span>Push to HeadLight</span>
								</button>
							</div>
							<!-- Progress panel (shown during push) -->
							<div id="CP-PushProgress" class="box mt-4 {~D:AppData.CustomerProvisioning.PushState.PanelClass~}">
								<h5 class="title is-5">Push Progress</h5>
								<progress class="progress is-info" value="{~D:AppData.CustomerProvisioning.PushState.Progress~}" max="100">{~D:AppData.CustomerProvisioning.PushState.Progress~}%</progress>
								<p class="has-text-grey">{~D:AppData.CustomerProvisioning.PushState.StatusText~}</p>
								<div class="content" style="max-height:300px;overflow-y:auto;font-family:monospace;font-size:0.85em;">
									{~TS:CustomerProvisioning-LogLine:AppData.CustomerProvisioning.PushState.Log~}
								</div>
							</div>
						</div>
					</article>
				</div>
			</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CustomerProvisioningWrap',
			TemplateHash: 'CustomerProvisioningWrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1424:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * Customers — the #/Customers list (front door to the per-customer Customer workspace). A thin shell (like
 * ManageCustomers.js / SuperUserGrant.js): all data + logic + hand-built HTML live in the CustomersList provider,
 * which assigns into the #CL-Body mount. Rows open #/Customer/Workspace/:ID; the per-row "Manage Configuration"
 * button (impersonation-gated) signs in as the customer's configuration admin. See [[config-app-customer-dashboard]].
 */
class Customers extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.CustomersList; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = Customers;
module.exports.default_configuration =
{
	ViewIdentifier: 'Customers',
	DefaultRenderable: 'CustomersWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.cl-wrap { padding: 1.25rem 1.5rem 2rem; }
		.cl-head { margin: 0 0 1rem; }
		.cl-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.cl-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; max-width:60rem; }
		.cl-note { padding:0.9rem; font-size:0.9rem; color:var(--theme-color-text-muted,#8894a4); }
		.cl-error { padding:0.9rem; font-size:0.88rem; color:var(--theme-color-status-danger,#c0392b); }
		/* Tabs: Customers roster | New Customers requests */
		.cl-tabs { display:flex; gap:0.25rem; margin:0 0 1rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.cl-tab { display:inline-flex; align-items:center; gap:0.45rem; padding:0.55rem 0.95rem; font-size:0.92rem; font-weight:600; text-decoration:none; color:var(--theme-color-text-muted,#6b7686); border-bottom:2px solid transparent; margin-bottom:-1px; }
		.cl-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.cl-tab.is-active { color:var(--theme-color-primary,#2f6fed); border-bottom-color:var(--theme-color-primary,#2f6fed); }
		.cl-tab .fas { font-size:0.85em; }
		/* New Customers bar: summary + "New Customer" action */
		.cl-newbar { display:flex; align-items:center; justify-content:space-between; gap:1rem; margin:0 0 0.8rem; max-width:60rem; flex-wrap:wrap; }
		.cl-newsummary { font-size:0.88rem; color:var(--theme-color-text-muted,#6b7686); margin:0; }
		.cl-newsummary strong { color:var(--theme-color-text-primary,#1f2733); }
		.cl-newbtn { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.86rem; font-weight:600; cursor:pointer; padding:0.45rem 0.85rem; border-radius:8px; border:1px solid var(--theme-color-primary,#2f6fed); background:var(--theme-color-primary,#2f6fed); color:#fff; }
		.cl-newbtn:hover { filter:brightness(1.06); }
		.cl-col-status { flex:0 0 11rem; display:inline-flex; align-items:center; }
		/* New Customers filter row: name filter + provisioned segmented control */
		.cl-filterrow { display:flex; align-items:center; gap:0.75rem; margin:0 0 0.8rem; max-width:60rem; flex-wrap:wrap; }
		.cl-filter-inrow { flex:1 1 16rem; margin:0; max-width:none; }
		.cl-segctl { display:inline-flex; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; overflow:hidden; }
		.cl-seg { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.82rem; font-weight:600; cursor:pointer; padding:0.5rem 0.8rem; border:0; border-left:1px solid var(--theme-color-border-light,#eef1f5); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-muted,#6b7686); white-space:nowrap; }
		.cl-seg:first-child { border-left:0; }
		.cl-seg:hover { background:var(--theme-color-background-secondary,#f4f6f9); color:var(--theme-color-text-primary,#1f2733); }
		.cl-seg.is-active { background:var(--theme-color-primary,#2f6fed); color:#fff; }
		.cl-seg-count { font-size:0.72rem; font-weight:700; padding:0.02rem 0.4rem; border-radius:999px; background:var(--theme-color-background-secondary,#eef1f5); color:var(--theme-color-text-muted,#6b7686); }
		.cl-seg.is-active .cl-seg-count { background:rgba(255,255,255,0.25); color:#fff; }
		.cl-row-static { cursor:default; }
		.cl-row-static:hover { background:transparent; }
		/* New Customers row approval actions */
		.cl-col-newactions { flex:0 0 auto; display:inline-flex; align-items:center; gap:0.4rem; margin-left:auto; }
		.cl-actbtn { display:inline-flex; align-items:center; gap:0.35rem; font-size:0.8rem; font-weight:600; cursor:pointer; padding:0.3rem 0.65rem; border-radius:7px; white-space:nowrap; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.cl-actbtn:hover { border-color:var(--theme-color-primary,#2f6fed); color:var(--theme-color-primary,#2f6fed); }
		.cl-actbtn-approve { border-color:#b7dfc4; color:#1b6e3a; }
		.cl-actbtn-approve:hover { background:#1b6e3a; border-color:#1b6e3a; color:#fff; }
		.cl-actbtn-reject { border-color:#e3b7b4; color:#b3382f; }
		.cl-actbtn-reject:hover { background:#b3382f; border-color:#b3382f; color:#fff; }
		.cl-actbusy { color:var(--theme-color-text-muted,#8a94a3); font-size:0.85rem; padding:0 0.4rem; }
		.cl-badge { display:inline-block; font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.12rem 0.5rem; border-radius:999px; line-height:1.5; }
		.cl-badge-prov { color:#1b6e3a; background:#e4f5ea; }
		.cl-badge-pend { color:#8a5a00; background:#fdf1dc; }
		.cl-badge-draft { color:#5a6676; background:#eef1f5; }
		.cl-badge-rej { color:#b3382f; background:#fbeaea; }
		.cl-filter { width:100%; max-width:32rem; box-sizing:border-box; font-size:0.95rem; padding:0.55rem 0.75rem; margin:0 0 0.8rem;
			border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.cl-filter:focus { outline:none; border-color:var(--theme-color-primary,#2f6fed); box-shadow:0 0 0 2px rgba(47,111,237,0.15); }
		/* No max-height / overflow-y here: the app shell already scrolls the page (html overflow-y:scroll), so the
		   list flex-grows naturally and the browser's own scroll handles long lists — no nested scroll box. */
		.cl-list { border:1px solid var(--theme-color-border-light,#eef1f5); border-radius:10px; overflow:hidden; background:var(--theme-color-background-primary,#fff); max-width:60rem; }
		.cl-head-row { display:flex; align-items:center; gap:0.9rem; padding:0.45rem 0.9rem; font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8a94a3); background:var(--theme-color-background-secondary,#f4f6f9); border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.cl-row { display:flex; align-items:center; gap:0.9rem; padding:0.6rem 0.9rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.cl-row:last-child { border-bottom:none; }
		.cl-row:hover { background:var(--theme-color-background-secondary,#f4f6f9); }
		.cl-row:focus { outline:2px solid var(--theme-color-primary,#2f6fed); outline-offset:-2px; }
		.cl-col-name { flex:1 1 auto; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-weight:600; }
		.cl-col-code { flex:0 0 8rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.82rem; color:var(--theme-color-text-muted,#8a94a3); }
		.cl-col-action { flex:0 0 auto; display:inline-flex; align-items:center; gap:0.6rem; }
		.cl-disabled { color:var(--theme-color-text-muted,#aab2bf); font-style:italic; font-size:0.82rem; font-weight:400; }
		.cl-open-caret { font-size:0.8rem; color:var(--theme-color-text-muted,#aab2bf); }
		.cl-btn { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.8rem; font-weight:600; cursor:pointer; padding:0.3rem 0.65rem; border-radius:7px; white-space:nowrap; }
		.cl-btn-ghost { border:1px solid var(--theme-color-brand-primary,#156dd1); background:transparent; color:var(--theme-color-brand-primary,#156dd1); }
		.cl-btn-ghost:hover, .cl-btn-ghost.is-open { background:var(--theme-color-brand-primary,#156dd1); color:#fff; }
		.cl-btn-caret { font-size:0.7rem; opacity:0.85; }
		/* Each customer is an item (row + optional expanded accounts panel); the item carries the row divider. */
		.cl-item { border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.cl-item:last-child { border-bottom:none; }
		.cl-item .cl-row { border-bottom:none; }
		.cl-item.is-expanded { background:var(--theme-color-background-secondary,#f4f6f9); }
		.cl-item.is-expanded > .cl-row:hover { background:transparent; }
		.cl-accounts { display:flex; flex-direction:column; gap:0.3rem; padding:0 0.9rem 0.75rem 1.5rem; }
		.cl-accounts-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8a94a3); margin:0.1rem 0 0.25rem; }
		.cl-accounts-note { font-size:0.86rem; padding:0.35rem 0; }
		.cl-accounts-note a { color:var(--theme-color-brand-primary,#156dd1); font-weight:600; }
		.cl-account { display:flex; align-items:center; gap:0.6rem; width:100%; max-width:34rem; text-align:left; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; background:var(--theme-color-background-primary,#fff); cursor:pointer; }
		.cl-account:hover { border-color:var(--theme-color-brand-primary,#156dd1); background:var(--theme-color-brand-primary-subtle,#eaf2fc); }
		.cl-account-avatar { flex:0 0 auto; width:1.75rem; height:1.75rem; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-muted,#8a94a3); font-size:0.8rem; }
		.cl-account-id { flex:1 1 auto; min-width:0; display:flex; flex-direction:column; }
		.cl-account-name { font-size:0.88rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cl-account-login { font-size:0.74rem; color:var(--theme-color-text-muted,#8a94a3); font-family:ui-monospace,SFMono-Regular,Menlo,monospace; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cl-account-go { flex:0 0 auto; font-size:0.78rem; font-weight:600; color:var(--theme-color-brand-primary,#156dd1); display:inline-flex; align-items:center; gap:0.3rem; }
	`,
	Templates:
	[
		{
			Hash: 'Customers-Wrap',
			Template: /*html*/`
				<div class="cl-wrap">
					<div class="cl-head">
						<h1 class="cl-title">Customers</h1>
						<p class="cl-subtitle">Open a customer to manage its overview, users, modules, and team. <strong>Manage Configuration</strong> signs you in as the customer&#8217;s configuration admin to edit their configuration directly.</p>
					</div>
					<div id="CL-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CustomersWrap',
			TemplateHash: 'Customers-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1425:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * DashboardAccessConfig view: the shell for the #/DashboardAccess screen. Paints the header and a single #DAC-Detail
 * mount; the DashboardAccessConfig provider renders the rest. Shares the Where Records Open styles (`edc-*`).
 */
class DashboardAccessConfig extends libPictView
{
	get provider()
	{
		return this.pict.providers.DashboardAccessConfig;
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading)
			{
				tmpProvider.loadAsync();
			}
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DashboardAccessConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'DashboardAccessConfig',
	DefaultRenderable: 'DashboardAccessConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.dac-dashboards { display:flex; flex-direction:column; gap:0.45rem; }
		.dac-dashboard { padding:0.45rem 0.6rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:7px; background:var(--theme-color-background-panel,#fff); }
		.dac-dashboard.is-on { border-color:var(--theme-color-border-medium,#d5dbe3); }
		.dac-landing { margin-left:0.6rem; font-size:0.8rem; }
		.dac-filters { margin:0.45rem 0 0.1rem 1.4rem; display:flex; flex-direction:column; gap:0.35rem; align-items:flex-start; }
		.dac-filter { display:flex; flex-wrap:wrap; gap:0.35rem; align-items:center; }
		.dac-filter .edc-select { min-width:8rem; }
		.dac-field, .dac-value { max-width:12rem; }
		.dac-preview-list { margin:0.2rem 0 0.4rem 1.2rem; list-style:disc; }
	`,
	Templates:
	[
		{
			Hash: 'DashboardAccessConfig-Wrap',
			Template: /*html*/`
				<div class="edc-wrap">
					<div class="edc-head">
						<h1 class="edc-title">Dashboard Access</h1>
						<p class="edc-subtitle">Choose which dashboards each role sees, the one they open first, and what data each dashboard shows them. This applies everywhere dashboards appear: LIMS, the data app, and the Fieldbook iPad app.</p>
					</div>
					<div id="DAC-Detail" class="edc-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DashboardAccessConfigWrap',
			TemplateHash: 'DashboardAccessConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1426:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

const DD_CSS = /*css*/`
	.dd-wrap { max-width: 1100px; margin: 0 auto; padding: 1.5rem 1.25rem 3rem; }
	.dd-head { margin: 0 0 1.5rem; }
	.dd-eyebrow { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: var(--theme-color-brand-secondary, #6b7686); }
	.dd-title { font-size: 1.7rem; font-weight: 700; color: var(--theme-color-text-primary, #1f2733); margin: 0.15rem 0 0; }
	.dd-intro { font-size: 0.95rem; color: var(--theme-color-text-secondary, #45505f); margin: 0.5rem 0 0; max-width: 60ch; }
	.dd-app { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 12px; background: var(--theme-color-background-panel, #fff); padding: 1.25rem 1.35rem 1.4rem; margin: 0 0 1.25rem; }
	.dd-app-head { display: flex; align-items: center; gap: 0.85rem; }
	.dd-app-icon { flex: 0 0 auto; width: 2.6rem; height: 2.6rem; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center; font-size: 1.25rem; color: #fff; background: var(--theme-color-brand-primary, #5650e6); }
	.dd-app-name { font-size: 1.1rem; font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.dd-app-meta { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); }
	.dd-app-blurb { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); margin: 0.8rem 0 1.1rem; max-width: 66ch; }
	.dd-builds { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 0.7rem; }
	.dd-build { display: flex; align-items: center; gap: 0.75rem; padding: 0.7rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 9px; background: var(--theme-color-background-primary, #fff); text-decoration: none; color: inherit; transition: border-color 0.12s, background 0.12s, box-shadow 0.12s; }
	.dd-build:hover { border-color: var(--theme-color-brand-primary, #5650e6); background: var(--theme-color-background-secondary, #f5f6fb); box-shadow: 0 1px 4px rgba(86,80,230,0.12); }
	.dd-build-os { flex: 0 0 auto; width: 2rem; height: 2rem; border-radius: 7px; display: inline-flex; align-items: center; justify-content: center; font-size: 1.05rem; color: var(--theme-color-text-primary, #1f2733); background: var(--theme-color-background-tertiary, #eef0f4); }
	.dd-build-text { display: flex; flex-direction: column; min-width: 0; flex: 1 1 auto; }
	.dd-build-title { font-size: 0.9rem; font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.dd-build-sub { font-size: 0.74rem; color: var(--theme-color-text-muted, #8a94a3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
	.dd-build-dl { flex: 0 0 auto; color: var(--theme-color-brand-primary, #5650e6); font-size: 0.95rem; }
	.dd-gated { text-align: center; border: 1px dashed var(--theme-color-border-medium, #c8cfd8); border-radius: 12px; background: var(--theme-color-background-secondary, #f5f6fb); padding: 2.75rem 1.5rem; }
	.dd-gated-icon { font-size: 1.6rem; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.6rem; }
	.dd-gated-title { font-size: 1.05rem; font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.dd-gated-body { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); margin: 0.4rem auto 0; max-width: 46ch; }
`;

/**
 * DataDownloader — the bespoke #/Datalake/DataDownloader screen. A thin shell; the DataDownloaderProvider builds
 * the download cards into #DD-Body (and the gated notice when the customer's module isn't enabled).
 */
class DataDownloader extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.DataDownloaderProvider; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DataDownloader;

module.exports.default_configuration =
{
	ViewIdentifier: 'DataDownloader',
	DefaultRenderable: 'DataDownloaderWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: DD_CSS,
	Templates:
	[
		{
			Hash: 'DataDownloader-Wrap',
			Template: /*html*/`<div class="dd-wrap"><div id="DD-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DataDownloaderWrap',
			TemplateHash: 'DataDownloader-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1427:[function(require,module,exports){

const libPictView = require('pict-view');
const libOperationalExplorerConfig = require('../data-explorer/Operational-Explorer-Config.js');

const html = String.raw;

// The explorer view's identity + the mount point this page's template provides for it.
const EXPLORER_HASH = 'PlatformDataExplorer';
const MOUNT_SELECTOR = '#PlatformDataExplorer-Mount';

/**
 * Host page for the operational-database explorer (pict-dataexplorer).
 *
 * Mirrors the TopicPage shape (AutoRender false; renders its chrome into the shared application container).
 * The explorer itself is created + rendered in onAfterRender — not at app init — for two reasons: (1) the
 * destination mount div only exists once this page's template is in the DOM, and (2) the soft preview-card
 * dependency (RecordSetCardManager + the Platform-RecordCards) is registered post-login, so deferring the
 * first render until the user navigates here guarantees the cards are present. createExplorer is idempotent
 * (it reuses the existing explorer view), so re-visiting the page just rebuilds the tree from its roots.
 */
class DataExplorer extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.pict.providers['Pict-DataExplorer'];
		if (tmpProvider)
		{
			const tmpExplorer = tmpProvider.createExplorer(EXPLORER_HASH,
				Object.assign({ DestinationAddress: MOUNT_SELECTOR }, libOperationalExplorerConfig));
			tmpExplorer.renderExplorer();
		}
		else
		{
			this.pict.log.warn('DataExplorer: the Pict-DataExplorer provider is not registered — cannot render the explorer.');
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DataExplorer;

module.exports.default_configuration =
{
	ViewIdentifier: 'DataExplorer',
	DefaultRenderable: 'DataExplorerWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.dataexplorer-head { display: flex; align-items: center; gap: 0.9rem; max-width: 980px; margin: 0 auto 1.1rem; }
.dataexplorer-ic { display: inline-flex; align-items: center; justify-content: center; width: 2.6rem; height: 2.6rem; border-radius: 12px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; flex: 0 0 auto; }
.dataexplorer-title { font-size: 1.5rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.dataexplorer-sub { font-size: 0.92rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.15rem 0 0; }
.dataexplorer-panel { max-width: 980px; margin: 0 auto; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 0.9rem 1rem; min-height: 60vh; }
`,

	Templates:
	[
		{
			Hash: 'DataExplorer-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="dataexplorer-head">
							<span class="dataexplorer-ic"><i class="fas fa-sitemap"></i></span>
							<div>
								<h1 class="dataexplorer-title">Data Explorer</h1>
								<p class="dataexplorer-sub">Browse the operational database as an expandable graph — open a record to drill into its related collections.</p>
							</div>
						</div>
						<div class="dataexplorer-panel">
							<div id="PlatformDataExplorer-Mount"></div>
						</div>
					</div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DataExplorerWrap',
			TemplateHash: 'DataExplorer-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"../data-explorer/Operational-Explorer-Config.js":1088,"pict-view":1053}],1428:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

const html = String.raw;

// The orchestrator provider (entity catalog + schema/push seams + wizard lifecycle) and the mount the
// per-entity wizard renders into.
const PROVIDER_HASH = 'DataImportManager';

/**
 * Host page for the generic Meadow-entity importer.
 *
 * The screen is a thin shell: a target-entity picker + a mount div for the embedded
 * pict-section-dataimport wizard. Behaviour lives in the DataImportManager provider — picking an entity
 * (re)configures the wizard with a Headlight schema source + push target, and the wizard drives the
 * upload -> validate -> map -> generate -> push flow against the entity's live `/1.0/<Entity>/Schema`.
 * Like DataMapper / DataExplorer, the wizard is (re)mounted in onAfterRender because the page's main
 * render replaces the container each visit, so the mount div is only in the DOM after this paint.
 */
class DataImport extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get manager()
	{
		return this.pict.providers[PROVIDER_HASH];
	}

	onBeforeRender(pRenderable)
	{
		if (this.manager)
		{
			this.manager.prepare();
		}
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		if (this.manager)
		{
			this.manager.mountWizard();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DataImport;

module.exports.default_configuration =
{
	ViewIdentifier: 'DataImport',
	DefaultRenderable: 'DataImportWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.dataimport-head { display: flex; align-items: center; gap: 0.9rem; max-width: 1040px; margin: 0 auto 1.1rem; }
.dataimport-ic { display: inline-flex; align-items: center; justify-content: center; width: 2.6rem; height: 2.6rem; border-radius: 12px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; flex: 0 0 auto; }
.dataimport-title { font-size: 1.5rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.dataimport-sub { font-size: 0.92rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.15rem 0 0; }
.dataimport-panel { max-width: 1040px; margin: 0 auto; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 1rem 1.1rem; min-height: 60vh; }
.dataimport-picker { display: flex; flex-wrap: wrap; align-items: center; gap: 0.6rem; margin-bottom: 0.4rem; }
.dataimport-picker-label { font-size: 0.9rem; font-weight: 600; color: var(--theme-color-text-secondary, #45506180); }
.dataimport-select { font-size: 0.95rem; padding: 0.42rem 0.6rem; border-radius: 8px; min-width: 16rem;
	border: 1px solid var(--theme-color-border-medium, #d5dbe3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); }
.dataimport-selected { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.2rem 0 0.6rem; }
.dataimport-selected i { color: var(--theme-color-brand-primary, #156dd1); margin-right: 0.3rem; }
.dataimport-intro { background: var(--theme-color-background-tertiary, #f5f7fa); border: 1px dashed var(--theme-color-border-medium, #d5dbe3);
	border-radius: 10px; padding: 0.9rem 1rem; color: var(--theme-color-text-secondary, #455061); font-size: 0.92rem; }
.dataimport-intro p { margin: 0 0 0.4rem; }
.dataimport-intro-note { font-size: 0.85rem; color: var(--theme-color-text-muted, #6b7686); margin: 0; }
.dataimport-result { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; margin: 0.4rem 0 0.7rem; padding: 0.6rem 0.8rem;
	border-radius: 8px; background: var(--theme-color-state-success-bg, #e7f6ec); color: var(--theme-color-state-success-text, #1d7a3f); font-size: 0.92rem; }
.dataimport-result i { font-size: 1rem; }
.dataimport-result-link { margin-left: 0.2rem; font-weight: 600; color: var(--theme-color-brand-primary, #156dd1); text-decoration: none; }
.dataimport-result-link:hover { text-decoration: underline; }
.dataimport-error { display: flex; align-items: center; gap: 0.5rem; margin: 0.4rem 0 0.7rem; padding: 0.6rem 0.8rem;
	border-radius: 8px; background: var(--theme-color-state-warning-bg, #fdecec); color: var(--theme-color-state-warning-text, #b3261e); font-size: 0.92rem; }
.dataimport-missing { margin: 0.4rem 0 0.7rem; padding: 0.6rem 0.8rem; border-radius: 8px;
	background: var(--theme-color-state-warning-bg, #fdecec); color: var(--theme-color-state-warning-text, #b3261e); font-size: 0.92rem; }
.dataimport-mount { margin-top: 0.6rem; }
`,

	Templates:
	[
		{
			Hash: 'DataImport-Option-Template',
			Template: html`<option value="{~D:Record.Entity~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`,
		},
		{
			Hash: 'DataImport-SelectedHint-Template',
			Template: html`<div class="dataimport-selected"><i class="{~D:Record.Icon~}"></i><strong>{~D:Record.Label~}</strong> — {~D:Record.Description~}</div>`,
		},
		{
			Hash: 'DataImport-Intro-Template',
			Template: html`
				<div class="dataimport-intro">
					<p>Choose a target entity above to begin. You'll upload a file (CSV, TSV, or Excel), map its columns onto the entity's fields, preview the result, then push the records to the platform.</p>
					<p class="dataimport-intro-note">Re-importing the same file updates the matching records instead of creating duplicates — matched by the key column you map to the record's GUID.</p>
				</div>`,
		},
		{
			Hash: 'DataImport-Result-Template',
			Template: html`<div class="dataimport-result"><i class="fas fa-circle-check"></i><span>{~D:Record.Message~}</span><a class="dataimport-result-link" href="{~D:Record.ViewRoute~}">{~D:Record.ViewLabel~} →</a></div>`,
		},
		{
			Hash: 'DataImport-Error-Template',
			Template: html`<div class="dataimport-error"><i class="fas fa-triangle-exclamation"></i><span>{~D:Record.Message~}</span></div>`,
		},
		{
			Hash: 'DataImport-Missing-Template',
			Template: html`<div class="dataimport-missing"><i class="fas fa-triangle-exclamation"></i> The data-import control is unavailable. Please reload the page.</div>`,
		},
		{
			Hash: 'DataImport-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="dataimport-head">
							<span class="dataimport-ic"><i class="fas fa-file-import"></i></span>
							<div>
								<h1 class="dataimport-title">Import Data</h1>
								<p class="dataimport-sub">Bulk-import reference records (Materials, Pay Items, …) from a CSV, TSV, or Excel file. Columns map onto the entity's live platform schema.</p>
							</div>
						</div>
						<div class="dataimport-panel">
							{~TS:DataImport-Missing-Template:AppData.DataImportUI.MissingSlot~}
							<div class="dataimport-picker">
								<label class="dataimport-picker-label" for="DataImport-EntitySelect">Import into</label>
								<select id="DataImport-EntitySelect" class="dataimport-select" onchange="_Pict.providers.${PROVIDER_HASH}.selectEntity(this.value)">
									<option value="">— Choose an entity —</option>
									{~TS:DataImport-Option-Template:AppData.DataImportUI.Entities~}
								</select>
							</div>
							{~TS:DataImport-SelectedHint-Template:AppData.DataImportUI.SelectedSlot~}
							{~TS:DataImport-Result-Template:AppData.DataImportUI.ResultSlot~}
							{~TS:DataImport-Error-Template:AppData.DataImportUI.ErrorSlot~}
							{~TS:DataImport-Intro-Template:AppData.DataImportUI.IntroSlot~}
							<div id="DataImport-Mount" class="dataimport-mount"></div>
						</div>
					</div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DataImportWrap',
			TemplateHash: 'DataImport-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1429:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libPictSectionMapping = require('pict-section-mapping');

const html = String.raw;

// The embedded section view's identity + the mount point this page's template provides for it.
const MAPPER_VIEW_HASH = 'PSM-DataMapper';
const MOUNT_SELECTOR = '#DataMapper-Mount';

/**
 * Host page for the visual data-mapper (pict-section-mapping).
 *
 * The section is a self-contained Pict view that drives its own REST client against APIBaseUrl
 * ('/1.0/mapper' — the PDO mapper surface, reached same-origin via Kong so the session cookie carries
 * auth). Like DataExplorer/ConfigViewer, the section is registered + rendered lazily in onAfterRender —
 * the mount div only exists once this page's template is in the DOM, and the main render replaces the
 * container each visit, so we (re)mount the section every paint. Modal confirm/toast resolve to the
 * app's existing 'Pict-Section-Modal' (the section's _modal() falls back to it).
 */
class DataMapper extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		this._mountMapper();
		return super.onAfterRender(pRenderable);
	}

	/** (Re)mount the embedded mapping section into the page's mount div. */
	_mountMapper()
	{
		if (this.pict.ContentAssignment.getElement(MOUNT_SELECTOR).length === 0) { return; }
		const tmpView = this._ensureMapperView();
		if (!tmpView) { return; }
		tmpView.options.DefaultDestinationAddress = MOUNT_SELECTOR;
		tmpView.render();
	}

	/** Lazily register the pict-section-mapping section view pointed at the PDO /1.0/mapper surface. */
	_ensureMapperView()
	{
		if (this.pict.views[MAPPER_VIEW_HASH]) { return this.pict.views[MAPPER_VIEW_HASH]; }
		this.pict.addView(MAPPER_VIEW_HASH, Object.assign({}, libPictSectionMapping.default_configuration,
			{
				ViewIdentifier: MAPPER_VIEW_HASH,
				APIBaseUrl: '/1.0/mapper',
				Mode: 'manage',
				ShowToolbar: true,
				AutoRender: false,
				DefaultDestinationAddress: MOUNT_SELECTOR,
			}), libPictSectionMapping);
		const tmpView = this.pict.views[MAPPER_VIEW_HASH];
		// A view added after the boot cycle isn't initialized automatically — initialize before first render.
		if (tmpView && typeof tmpView.initialize === 'function') { tmpView.initialize(); }
		return tmpView;
	}
}

module.exports = DataMapper;

module.exports.default_configuration =
{
	ViewIdentifier: 'DataMapper',
	DefaultRenderable: 'DataMapperWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.datamapper-head { display: flex; align-items: center; gap: 0.9rem; max-width: 1040px; margin: 0 auto 1.1rem; }
.datamapper-ic { display: inline-flex; align-items: center; justify-content: center; width: 2.6rem; height: 2.6rem; border-radius: 12px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; flex: 0 0 auto; }
.datamapper-title { font-size: 1.5rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.datamapper-sub { font-size: 0.92rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.15rem 0 0; }
.datamapper-panel { max-width: 1040px; margin: 0 auto; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 0.9rem 1rem; min-height: 60vh; }
`,

	Templates:
	[
		{
			Hash: 'DataMapper-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="datamapper-head">
							<span class="datamapper-ic"><i class="fas fa-diagram-project"></i></span>
							<div>
								<h1 class="datamapper-title">Data Mapper</h1>
								<p class="datamapper-sub">Define source→target field mappings — the operations that compile materialized projections for your data lake.</p>
							</div>
						</div>
						<div class="datamapper-panel">
							<div id="DataMapper-Mount"></div>
						</div>
					</div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DataMapperWrap',
			TemplateHash: 'DataMapper-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-section-mapping":672,"pict-view":1053}],1430:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * Data Lake catalog — the #/Datalake/Browse landing.
 *
 * A two-tab catalog of the customer's lake datasets: IMPORTED clones (read-only copies of legacy systems,
 * e.g. walbec's Lastrada, grouped by source system) vs COMPUTED projections (derived from Headlight data,
 * grouped by pipeline / RefreshGroup). Searchable. Selecting a dataset opens its detail view; "New
 * projection" launches the create wizard. All state + behaviour live in DatalakeCatalogProvider; this view
 * derives + repaints declaratively (no HTML in AppData).
 */
class DatalakeCatalog extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.DatalakeCatalogProvider;
	}

	deriveRenderState()
	{
		if (this.provider)
		{
			this.provider.deriveRenderState();
		}
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = DatalakeCatalog;

module.exports.default_configuration =
{
	ViewIdentifier: 'DatalakeCatalog',
	DefaultRenderable: 'DatalakeCatalogWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.dlc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.dlc-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1rem; }
		.dlc-kpis { display: flex; flex-wrap: wrap; gap: 0.6rem; margin-bottom: 1rem; }
		.dlc-kpi { display: flex; align-items: center; gap: 0.55rem; background: var(--bulma-scheme-main-bis, #f6f8fb); border: 1px solid var(--bulma-border, #e6e9ef);
			border-radius: 10px; padding: 0.5rem 0.85rem; min-width: 8.5rem; }
		.dlc-kpi-ic { font-size: 1.05rem; }
		.dlc-kpi-val { font-size: 1.15rem; font-weight: 700; line-height: 1; }
		.dlc-kpi-lbl { font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--bulma-text-weak, #7a7a7a); }
		.dlc-toolbar { display: flex; align-items: center; gap: 1rem; margin-bottom: 0.75rem; flex-wrap: wrap; }
		.dlc-tabs { flex: 0 0 auto; }
		.dlc-search { flex: 1 1 16rem; max-width: 24rem; }
		.dlc-group { margin-bottom: 1.1rem; }
		.dlc-group-head { display: flex; align-items: baseline; gap: 0.6rem; padding: 0.3rem 0.2rem; border-bottom: 1px solid var(--bulma-border, #ededed); margin-bottom: 0.4rem; }
		.dlc-group-title { font-weight: 700; }
		.dlc-group-meta { font-size: 0.76rem; color: var(--bulma-text-weak, #7a7a7a); }
		.dlc-row { display: flex; align-items: center; gap: 0.75rem; padding: 0.6rem 0.7rem; border-radius: 8px; cursor: pointer; }
		.dlc-row:hover { background: var(--bulma-scheme-main-bis, #f2f5f9); }
		.dlc-row-main { flex: 1 1 auto; min-width: 0; }
		.dlc-row-name { font-weight: 600; }
		.dlc-row-sub { font-size: 0.78rem; color: var(--bulma-text-weak, #7a7a7a); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.dlc-row-sub code { color: var(--bulma-text-weak, #8a93a3); }
		.dlc-row-cadence { flex: 0 0 auto; font-size: 0.76rem; color: var(--bulma-text-weak, #7a7a7a); }
		.dlc-empty { padding: 2.5rem 1rem; }
		.dlc-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: dlc-spin 0.8s linear infinite; }
		@keyframes dlc-spin { to { transform: rotate(360deg); } }
	`,

	Templates:
	[
		{
			Hash: 'Datalake-Catalog-Wrap',
			Template: /*html*/`
				<div class="dlc-wrap">
					<div class="dlc-header">
						<div>
							<h1 class="title is-4"><span class="icon"><i class="fas fa-water"></i></span> Data Lake</h1>
							<p class="subtitle is-6 has-text-grey">Browse the datasets in your private data lake — imported copies of source systems and computed projections of your Headlight data — and create new projections from the Headlight data model.</p>
						</div>
						<button class="button is-link" onclick="_Pict.providers.DatalakeCatalogProvider.newProjection()"><span class="icon"><i class="fas fa-plus"></i></span><span>New projection</span></button>
					</div>

					<div class="dlc-kpis">{~TS:Datalake-Kpi:AppData.DatalakeCatalog.Kpis~}</div>

					{~TS:Datalake-Error:AppData.DatalakeCatalog.ErrorSlot~}

					<div class="dlc-toolbar">
						<div class="tabs is-toggle is-small dlc-tabs">
							<ul>
								<li class="{~D:AppData.DatalakeCatalog.ComputedTabClass~}"><a onclick="_Pict.providers.DatalakeCatalogProvider.navigateKind('computed')"><span class="icon is-small"><i class="fas fa-diagram-project"></i></span><span>Projections ({~D:AppData.DatalakeCatalog.ComputedCount~})</span></a></li>
								<li class="{~D:AppData.DatalakeCatalog.ImportedTabClass~}"><a onclick="_Pict.providers.DatalakeCatalogProvider.navigateKind('imported')"><span class="icon is-small"><i class="fas fa-box-archive"></i></span><span>Imported ({~D:AppData.DatalakeCatalog.ImportedCount~})</span></a></li>
							</ul>
						</div>
						<div class="control has-icons-left dlc-search">
							<input class="input is-small" type="text" placeholder="Search datasets…" value="{~D:AppData.DatalakeCatalog.Search~}" oninput="_Pict.providers.DatalakeCatalogProvider.setSearch(this.value)" />
							<span class="icon is-small is-left"><i class="fas fa-magnifying-glass"></i></span>
						</div>
					</div>

					<div class="box" id="Datalake-Results">
						{~TS:Datalake-Loading:AppData.DatalakeCatalog.LoadingSlot~}
						{~TS:Datalake-Group:AppData.DatalakeCatalog.RailGroups~}
						{~TS:Datalake-Empty:AppData.DatalakeCatalog.EmptySlot~}
					</div>
				</div>`
		},
		{
			// Rendered on its own into #Datalake-Results by setSearch so typing the search box never
			// rebuilds the (sibling) search <input>. Same three slots as the inline block in the Wrap.
			Hash: 'Datalake-Results',
			Template: /*html*/`
				{~TS:Datalake-Loading:AppData.DatalakeCatalog.LoadingSlot~}
				{~TS:Datalake-Group:AppData.DatalakeCatalog.RailGroups~}
				{~TS:Datalake-Empty:AppData.DatalakeCatalog.EmptySlot~}`
		},
		{
			Hash: 'Datalake-Kpi',
			Template: /*html*/`<div class="dlc-kpi"><span class="dlc-kpi-ic" style="color:{~D:Record.Accent~}"><i class="{~D:Record.Icon~}"></i></span><span><span class="dlc-kpi-val">{~D:Record.Value~}</span><br><span class="dlc-kpi-lbl">{~D:Record.Label~}</span></span></div>`
		},
		{
			Hash: 'Datalake-Group',
			Template: /*html*/`
				<div class="dlc-group">
					<div class="dlc-group-head"><span class="dlc-group-title">{~D:Record.GroupLabel~}</span><span class="dlc-group-meta">{~D:Record.Meta~}</span></div>
					{~TS:Datalake-DatasetRow:Record.Items~}
				</div>`
		},
		{
			Hash: 'Datalake-DatasetRow',
			Template: /*html*/`
				<div class="dlc-row" onclick="_Pict.providers.DatalakeCatalogProvider.openItem('{~D:Record.OpenKind~}','{~D:Record.OpenArg~}')">
					<div class="dlc-row-main">
						<div class="dlc-row-name">{~D:Record.Name~}</div>
						<div class="dlc-row-sub"><code>{~D:Record.PhysicalTableName~}</code>{~D:Record.DescriptionSuffix~}</div>
					</div>
					<span class="dlc-row-cadence">{~D:Record.Cadence~}</span>
					<span class="tag {~D:Record.ChipClass~}"><span class="icon is-small"><i class="fas {~D:Record.ChipIcon~}"></i></span><span>{~D:Record.ChipLabel~}</span></span>
					<span class="icon has-text-grey-light"><i class="fas fa-chevron-right"></i></span>
				</div>`
		},
		{
			Hash: 'Datalake-Empty',
			Template: /*html*/`
				<div class="dlc-empty has-text-grey has-text-centered">
					<span class="icon is-large"><i class="fas fa-water fa-2x"></i></span>
					<p class="mt-3">{~D:Record.Message~}</p>
				</div>`
		},
		{
			Hash: 'Datalake-Loading',
			Template: /*html*/`<div class="dlc-empty has-text-grey has-text-centered"><span class="dlc-spinner"></span><p class="mt-3">Loading the data lake catalog…</p></div>`
		},
		{
			Hash: 'Datalake-Error',
			Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'DatalakeCatalogWrap',
			TemplateHash: 'Datalake-Catalog-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-view":1053}],1431:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * Data Lake dataset viewer — #/Datalake/Dataset/:GUID.
 *
 * Shows one lake dataset: a type-aware header (imported clone vs computed projection), a metadata /
 * provenance panel, the column schema, a paginated table of the actual rows (columns derived at runtime
 * from the dataset's JSON-Schema), and lineage. State + behaviour live in DatalakeDatasetProvider; this
 * view derives + repaints declaratively. The management action bar (refresh / schedule / re-import) is
 * added by the management phase.
 */
class DatalakeDataset extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.DatalakeDatasetProvider;
	}

	deriveRenderState()
	{
		if (this.provider)
		{
			this.provider.deriveRenderState();
		}
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = DatalakeDataset;

module.exports.default_configuration =
{
	ViewIdentifier: 'DatalakeDataset',
	DefaultRenderable: 'DatalakeDatasetWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.dld-wrap { padding: 1.25rem 1.5rem 2rem; }
		.dld-back { margin-bottom: 0.5rem; }
		.dld-head { display: flex; align-items: flex-start; gap: 0.8rem; margin-bottom: 1rem; }
		.dld-title { font-size: 1.4rem; font-weight: 700; line-height: 1.1; }
		.dld-sub { color: var(--bulma-text-weak, #7a7a7a); font-size: 0.9rem; }
		.dld-cols2 { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 1rem; margin-bottom: 1rem; }
		@media (max-width: 980px) { .dld-cols2 { grid-template-columns: minmax(0,1fr); } }
		.dld-panel { background: var(--bulma-scheme-main-bis, #f8fafc); border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 10px; padding: 0.85rem 1rem; }
		.dld-panel h3 { font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); font-weight: 700; margin-bottom: 0.5rem; }
		.dld-meta-row { display: flex; gap: 0.6rem; padding: 0.18rem 0; font-size: 0.86rem; }
		.dld-meta-label { flex: 0 0 8rem; color: var(--bulma-text-weak, #7a7a7a); }
		.dld-meta-val { min-width: 0; word-break: break-word; }
		.dld-meta-val code, .dld-schema code { color: var(--bulma-text-strong, #363636); }
		.dld-schema { }
		.dld-data-head { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin: 0.5rem 0; }
		.dld-table-scroll { overflow-x: auto; border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 8px; }
		.dld-table { font-size: 0.82rem; white-space: nowrap; margin-bottom: 0; }
		.dld-table th { position: sticky; top: 0; background: var(--bulma-scheme-main-bis, #f2f5f9); }
		.dld-table td { max-width: 22rem; overflow: hidden; text-overflow: ellipsis; }
		.dld-empty { padding: 1.5rem 1rem; }
		.dld-spinner { display: inline-block; width: 1.4rem; height: 1.4rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: dld-spin 0.8s linear infinite; }
		@keyframes dld-spin { to { transform: rotate(360deg); } }
		.dld-lineage code { color: var(--bulma-text-weak, #8a93a3); }
		.dld-manage-row { display: flex; align-items: center; margin-bottom: 0.75rem; }
		.dld-sched { display: flex; align-items: center; flex-wrap: wrap; gap: 0.75rem; padding-top: 0.5rem; border-top: 1px dashed var(--bulma-border, #e6e9ef); }
		.dld-sched-modes { display: flex; gap: 0.9rem; }
		.dld-sched .field { margin-bottom: 0; }
		.dld-sched .input { max-width: 11rem; }
	`,

	Templates:
	[
		{
			Hash: 'Datalake-DS-Wrap',
			Template: /*html*/`
				<div class="dld-wrap">
					<div class="dld-back"><a class="button is-small is-light" onclick="_Pict.providers.DatalakeDatasetProvider.backToCatalog()"><span class="icon is-small"><i class="fas fa-arrow-left"></i></span><span>Data Lake</span></a></div>

					{~TS:Datalake-DS-Error:AppData.DatalakeDataset.ErrorSlot~}
					{~TS:Datalake-DS-RawAction:AppData.DatalakeDataset.RawActionSlot~}
					{~TS:Datalake-DS-Loading:AppData.DatalakeDataset.LoadingSlot~}

					<div class="dld-head">
						<div style="flex:1 1 auto; min-width:0;">
							<div class="dld-title">{~D:AppData.DatalakeDataset.HeaderName~}</div>
							<div class="dld-sub">{~D:AppData.DatalakeDataset.HeaderSub~}</div>
						</div>
						<span class="tag {~D:AppData.DatalakeDataset.ChipClass~}"><span class="icon is-small"><i class="fas {~D:AppData.DatalakeDataset.ChipIcon~}"></i></span><span>{~D:AppData.DatalakeDataset.ChipLabel~}</span></span>
					</div>

					<div class="dld-cols2">
						<div class="dld-panel">
							<h3>Dataset</h3>
							{~TS:Datalake-DS-MetaRow:AppData.DatalakeDataset.MetaRows~}
						</div>
						<div class="dld-panel">
							<h3>Schema ({~D:AppData.DatalakeDataset.SchemaColumnCount~} columns)</h3>
							<div class="dld-schema">
								<table class="table is-narrow is-fullwidth">
									<tbody>{~TS:Datalake-DS-SchemaRow:AppData.DatalakeDataset.SchemaRows~}</tbody>
								</table>
							</div>
						</div>
					</div>

					{~TS:Datalake-DS-Manage:AppData.DatalakeDataset.ManageSlot~}

					{~TS:Datalake-DS-Lineage:AppData.DatalakeDataset.LineageSlot~}

					<div class="dld-panel">
						<div class="dld-data-head">
							<h3 style="margin:0;">Data</h3>
							<div class="field has-addons" style="margin:0;">
								<span class="dld-sub" style="margin-right:0.6rem;">{~D:AppData.DatalakeDataset.PageLabel~}</span>
								<p class="control"><button class="button is-small" {~D:AppData.DatalakeDataset.PrevDisabledAttr~} onclick="_Pict.providers.DatalakeDatasetProvider.prevPage()"><span class="icon is-small"><i class="fas fa-chevron-left"></i></span></button></p>
								<p class="control"><button class="button is-small" {~D:AppData.DatalakeDataset.NextDisabledAttr~} onclick="_Pict.providers.DatalakeDatasetProvider.nextPage()"><span class="icon is-small"><i class="fas fa-chevron-right"></i></span></button></p>
							</div>
						</div>
						<p class="dld-sub mb-2">{~D:AppData.DatalakeDataset.ColumnsTruncatedNote~}</p>
						<div class="dld-table-scroll">
							<table class="table is-narrow is-hoverable is-fullwidth dld-table">
								<thead><tr>{~TS:Datalake-DS-ColHead:AppData.DatalakeDataset.Columns~}</tr></thead>
								<tbody>{~TS:Datalake-DS-Row:AppData.DatalakeDataset.Rows~}</tbody>
							</table>
						</div>
						{~TS:Datalake-DS-RowsLoading:AppData.DatalakeDataset.RowsLoadingSlot~}
						{~TS:Datalake-DS-RowsEmpty:AppData.DatalakeDataset.RowsEmptySlot~}
					</div>
				</div>`
		},
		{ Hash: 'Datalake-DS-MetaRow', Template: /*html*/`<div class="dld-meta-row"><span class="dld-meta-label">{~D:Record.Label~}</span><span class="dld-meta-val"><code>{~D:Record.Value~}</code></span></div>` },
		{ Hash: 'Datalake-DS-SchemaRow', Template: /*html*/`<tr><td><code>{~D:Record.Column~}</code></td><td class="has-text-grey">{~D:Record.Type~}</td><td class="has-text-grey is-size-7">{~D:Record.Size~}</td></tr>` },
		{ Hash: 'Datalake-DS-ColHead', Template: /*html*/`<th>{~D:Record.Label~}</th>` },
		{ Hash: 'Datalake-DS-Row', Template: /*html*/`<tr>{~TS:Datalake-DS-Cell:Record.Cells~}</tr>` },
		{ Hash: 'Datalake-DS-Cell', Template: /*html*/`<td title="{~D:Record.Value~}">{~D:Record.Value~}</td>` },
		{
			Hash: 'Datalake-DS-Lineage',
			Template: /*html*/`
				<div class="dld-panel dld-lineage mb-4">
					<h3>Lineage</h3>
					<div class="columns">
						<div class="column"><strong class="is-size-7">Upstream (feeds this)</strong>{~TS:Datalake-DS-LineageItem:AppData.DatalakeDataset.LineageUpstream~}</div>
						<div class="column"><strong class="is-size-7">Downstream (reads this)</strong>{~TS:Datalake-DS-LineageItem:AppData.DatalakeDataset.LineageDownstream~}</div>
					</div>
				</div>`
		},
		{ Hash: 'Datalake-DS-LineageItem', Template: /*html*/`<div class="is-size-7"><code>{~D:Record.Address~}</code></div>` },
		{
			Hash: 'Datalake-DS-Manage',
			Template: /*html*/`
				<div class="dld-panel mb-4">
					<h3>Manage</h3>
					{~TS:Datalake-DS-ActionResult:AppData.DatalakeDataset.ActionResultSlot~}
					{~TS:Datalake-DS-ManageComputed:AppData.DatalakeDataset.ComputedManageSlot~}
					{~TS:Datalake-DS-ManageImported:AppData.DatalakeDataset.ImportedManageSlot~}
				</div>`
		},
		{
			Hash: 'Datalake-DS-ManageComputed',
			Template: /*html*/`
				<div class="dld-manage">
					<div class="dld-manage-row">
						<button class="button is-link is-small" {~D:AppData.DatalakeDataset.RefreshDisabledAttr~} onclick="_Pict.providers.DatalakeDatasetProvider.refreshNow()"><span class="icon is-small"><i class="fas fa-rotate"></i></span><span>Refresh now</span></button>
						{~TS:Datalake-DS-ActionBusy:AppData.DatalakeDataset.ActionBusySlot~}
					</div>
					<div class="dld-sched">
						<label class="checkbox"><input type="checkbox" {~D:AppData.DatalakeDataset.ScheduleEnabledAttr~} onchange="_Pict.providers.DatalakeDatasetProvider.setScheduleEnabledLocal(this.checked)" /> Scheduled automatic refresh</label>
						<div class="dld-sched-modes">
							<label class="radio"><input type="radio" name="dld-sched-mode" {~D:AppData.DatalakeDataset.ScheduleModeIntervalChecked~} onchange="_Pict.providers.DatalakeDatasetProvider.setScheduleMode('interval')" /> Every N minutes</label>
							<label class="radio"><input type="radio" name="dld-sched-mode" {~D:AppData.DatalakeDataset.ScheduleModeCronChecked~} onchange="_Pict.providers.DatalakeDatasetProvider.setScheduleMode('cron')" /> Cron (UTC)</label>
						</div>
						<div class="field {~D:AppData.DatalakeDataset.ScheduleIntervalClass~}"><div class="control"><input class="input is-small" type="number" min="1" placeholder="minutes" value="{~D:AppData.DatalakeDataset.Schedule.IntervalMinutes~}" oninput="_Pict.providers.DatalakeDatasetProvider.setScheduleField('interval', this.value)" /></div></div>
						<div class="field {~D:AppData.DatalakeDataset.ScheduleCronClass~}"><div class="control"><input class="input is-small" type="text" placeholder="0 9 * * *" value="{~D:AppData.DatalakeDataset.Schedule.Cron~}" oninput="_Pict.providers.DatalakeDatasetProvider.setScheduleField('cron', this.value)" /></div></div>
						<button class="button is-small" {~D:AppData.DatalakeDataset.RefreshDisabledAttr~} onclick="_Pict.providers.DatalakeDatasetProvider.saveSchedule()"><span class="icon is-small"><i class="fas fa-floppy-disk"></i></span><span>Save schedule</span></button>
					</div>
				</div>`
		},
		{
			Hash: 'Datalake-DS-ManageImported',
			Template: /*html*/`
				<div class="dld-manage">
					<p class="dld-sub mb-2">This is a read-only imported copy of a source system. Re-importing re-pulls the source into the lake (the source is durable, so this is safe to repeat).</p>
					<div class="dld-manage-row">
						<button class="button is-link is-small" {~D:AppData.DatalakeDataset.RefreshDisabledAttr~} onclick="_Pict.providers.DatalakeDatasetProvider.reImport()"><span class="icon is-small"><i class="fas fa-cloud-arrow-down"></i></span><span>Re-import from source</span></button>
						{~TS:Datalake-DS-ActionBusy:AppData.DatalakeDataset.ActionBusySlot~}
					</div>
				</div>`
		},
		{ Hash: 'Datalake-DS-ActionResult', Template: /*html*/`<div class="notification {~D:Record.Class~} is-soft py-2 px-3 mb-2"><span class="icon"><i class="fas {~D:Record.Icon~}"></i></span> <span>{~D:Record.Message~}</span></div>` },
		{ Hash: 'Datalake-DS-ActionBusy', Template: /*html*/`<span class="dld-spinner" style="width:1.1rem; height:1.1rem; margin-left:0.6rem;"></span>` },
		{ Hash: 'Datalake-DS-Error', Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>` },
		{ Hash: 'Datalake-DS-RawAction', Template: /*html*/`<div class="mb-4"><button class="button is-link" onclick="_Pict.providers.DatalakeDatasetProvider.projectionizeThis()"><span class="icon"><i class="fas fa-wand-magic-sparkles"></i></span><span>Create a projection from this table</span></button></div>` },
		{ Hash: 'Datalake-DS-Loading', Template: /*html*/`<div class="dld-empty has-text-grey has-text-centered"><span class="dld-spinner"></span><p class="mt-2">Loading dataset…</p></div>` },
		{ Hash: 'Datalake-DS-RowsLoading', Template: /*html*/`<div class="dld-empty has-text-grey has-text-centered"><span class="dld-spinner"></span></div>` },
		{ Hash: 'Datalake-DS-RowsEmpty', Template: /*html*/`<div class="dld-empty has-text-grey has-text-centered"><p>No rows in this page.</p></div>` }
	],

	Renderables:
	[
		{
			RenderableHash: 'DatalakeDatasetWrap',
			TemplateHash: 'Datalake-DS-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-view":1053}],1432:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * Create-projection wizard view — #/Datalake/New.
 *
 * A 5-step accordion (Source → Columns → Name & schedule → Review → Create) over the
 * DatalakeProjectionEditorProvider. Thin view: derives + repaints declaratively; all behaviour + the
 * generated POST body live in the provider + the pure Datalake-Projection-Builder.
 */
class DatalakeProjectionEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.DatalakeProjectionEditorProvider;
	}

	deriveRenderState()
	{
		if (this.provider)
		{
			this.provider.deriveRenderState();
		}
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		// Mount the searchable lake-source picker (present only in Data-lake source mode; no-ops otherwise).
		if (this.provider) { this.provider.mountLakeSourcePicker(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = DatalakeProjectionEditor;

module.exports.default_configuration =
{
	ViewIdentifier: 'DatalakeProjectionEditor',
	DefaultRenderable: 'DatalakeProjectionEditorWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.dpe-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 980px; }
		.dpe-step { border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 10px; margin-bottom: 0.8rem; overflow: hidden; }
		.dpe-step-head { display: flex; align-items: center; gap: 0.7rem; padding: 0.7rem 1rem; background: var(--bulma-scheme-main-bis, #f8fafc); cursor: pointer; }
		.dpe-step-num { flex: 0 0 auto; width: 1.6rem; height: 1.6rem; border-radius: 50%; background: var(--bulma-border, #dfe3ea); color: var(--bulma-text, #4a4a4a); display: inline-flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 700; }
		.dpe-step-title { font-weight: 600; flex: 1 1 auto; }
		.dpe-step-body { padding: 1rem; }
		.dpe-fields { }
		.dpe-fields td, .dpe-fields th { vertical-align: middle; }
		.dpe-fields .input { max-width: 13rem; }
		.dpe-review { background: #1f2733; color: #e6edf3; border-radius: 8px; padding: 0.85rem 1rem; font-size: 0.8rem; overflow: auto; max-height: 26rem; }
		.dpe-target { font-family: monospace; background: var(--bulma-scheme-main-bis, #f2f5f9); border-radius: 6px; padding: 0.35rem 0.6rem; display: inline-block; }
		.dpe-sched { display: flex; align-items: center; flex-wrap: wrap; gap: 0.8rem; margin-top: 0.5rem; }
		.dpe-sched .input { max-width: 12rem; }
		.dpe-spinner { display: inline-block; width: 1.2rem; height: 1.2rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: dpe-spin 0.8s linear infinite; vertical-align: middle; }
		@keyframes dpe-spin { to { transform: rotate(360deg); } }
	`,

	Templates:
	[
		{
			Hash: 'DPE-Wrap',
			Template: /*html*/`
				<div class="dpe-wrap">
					<div class="dpe-back mb-3"><a class="button is-small is-light" onclick="window.location.hash='#/Datalake'"><span class="icon is-small"><i class="fas fa-arrow-left"></i></span><span>Data Lake</span></a></div>
					<h1 class="title is-4"><span class="icon"><i class="fas fa-plus"></i></span> New Projection</h1>
					<p class="subtitle is-6 has-text-grey">Create a materialized projection from the Headlight data model — pick a source, project the columns you want, and (optionally) schedule it to refresh.</p>

					{~TS:DPE-CloneBanner:AppData.DatalakeProjectionEditor.CloneBannerSlot~}

					<!-- Step 1: Source -->
					<div class="dpe-step {~D:AppData.DatalakeProjectionEditor.Step1_CardClass~}">
						<div class="dpe-step-head" onclick="_Pict.providers.DatalakeProjectionEditorProvider.goToStep(1)">
							<span class="dpe-step-num">1</span><span class="dpe-step-title">Source</span><span class="tag {~D:AppData.DatalakeProjectionEditor.Step1_StatusClass~}">{~D:AppData.DatalakeProjectionEditor.Step1_StatusLabel~}</span>
						</div>
						<div class="dpe-step-body {~D:AppData.DatalakeProjectionEditor.Step1_BodyClass~}">
							<div class="field">
								<label class="label is-small">Where does the data come from?</label>
								<div class="control">
									<label class="radio mr-4"><input type="radio" name="dpe-src-type" {~D:AppData.DatalakeProjectionEditor.SourceTypeEntityChecked~} onchange="_Pict.providers.DatalakeProjectionEditorProvider.setSourceType('entity')" /> Headlight data model</label>
									<label class="radio"><input type="radio" name="dpe-src-type" {~D:AppData.DatalakeProjectionEditor.SourceTypeLakeChecked~} onchange="_Pict.providers.DatalakeProjectionEditorProvider.setSourceType('lake')" /> Data lake (project from a projection or imported clone)</label>
								</div>
							</div>
							{~TS:DPE-EntityPicker:AppData.DatalakeProjectionEditor.EntityPickerSlot~}
							{~TS:DPE-LakePicker:AppData.DatalakeProjectionEditor.LakePickerSlot~}
							<div class="field"><label class="label is-small">Filter (optional, FoxHound)</label>
								<div class="control"><input class="input is-small" type="text" placeholder="FBV~Status~EQ~Active~FBV~Deleted~EQ~0" value="{~D:AppData.DatalakeProjectionEditor.Filter~}" oninput="_Pict.providers.DatalakeProjectionEditorProvider.setFilter(this.value)" /></div>
								<p class="help">Restrict which source rows are projected. Leave blank for all.</p>
							</div>
							{~TS:DPE-TestCount:AppData.DatalakeProjectionEditor.TestCountSlot~}
							{~TS:DPE-TestResult:AppData.DatalakeProjectionEditor.TestResultSlot~}
							<div class="field mt-3"><p class="control"><button class="button is-link" onclick="_Pict.providers.DatalakeProjectionEditorProvider.continueFromSource()">Continue</button></p></div>
						</div>
					</div>

					<!-- Step 2: Columns -->
					<div class="dpe-step {~D:AppData.DatalakeProjectionEditor.Step2_CardClass~}">
						<div class="dpe-step-head" onclick="_Pict.providers.DatalakeProjectionEditorProvider.goToStep(2)">
							<span class="dpe-step-num">2</span><span class="dpe-step-title">Columns &amp; key</span><span class="tag {~D:AppData.DatalakeProjectionEditor.Step2_StatusClass~}">{~D:AppData.DatalakeProjectionEditor.Step2_StatusLabel~}</span>
						</div>
						<div class="dpe-step-body {~D:AppData.DatalakeProjectionEditor.Step2_BodyClass~}">
							{~TS:DPE-SchemaLoading:AppData.DatalakeProjectionEditor.SchemaLoadingSlot~}
							{~TS:DPE-SchemaError:AppData.DatalakeProjectionEditor.SchemaErrorSlot~}
							<div class="level is-mobile mb-2"><div class="level-left"><p class="is-size-7 has-text-grey">{~D:AppData.DatalakeProjectionEditor.IncludedCount~} column(s) selected</p></div><div class="level-right"><button class="button is-small is-white" onclick="_Pict.providers.DatalakeProjectionEditorProvider.toggleShowAll()">{~D:AppData.DatalakeProjectionEditor.ShowAllLabel~}</button></div></div>
							<div class="dpe-fields">
								<table class="table is-narrow is-fullwidth is-hoverable">
									<thead><tr><th>Use</th><th>Source field</th><th>Output column</th><th>Type</th></tr></thead>
									<tbody>{~TS:DPE-FieldRow:AppData.DatalakeProjectionEditor.FieldRows~}</tbody>
								</table>
							</div>
							{~TS:DPE-FormDataSection:AppData.DatalakeProjectionEditor.FormDataSlot~}
							<div class="field mt-2"><label class="label is-small">Row key (GUID template)</label>
								<div class="control"><input class="input is-small" type="text" value="{~D:AppData.DatalakeProjectionEditor.GUIDTemplate~}" oninput="_Pict.providers.DatalakeProjectionEditorProvider.setGUIDTemplate(this.value)" /></div>
								<p class="help">A deterministic key per row so refreshes upsert instead of duplicating. Must reference a field, e.g. <code>{~D:Record.IDProject~}</code>.</p>
							</div>
							<div class="field"><p class="control"><button class="button is-link" onclick="_Pict.providers.DatalakeProjectionEditorProvider.continueFromColumns()">Continue</button></p></div>
						</div>
					</div>

					<!-- Step 3: Name & schedule -->
					<div class="dpe-step">
						<div class="dpe-step-head" onclick="_Pict.providers.DatalakeProjectionEditorProvider.goToStep(3)">
							<span class="dpe-step-num">3</span><span class="dpe-step-title">Name &amp; schedule</span><span class="tag {~D:AppData.DatalakeProjectionEditor.Step3_StatusClass~}">{~D:AppData.DatalakeProjectionEditor.Step3_StatusLabel~}</span>
						</div>
						<div class="dpe-step-body {~D:AppData.DatalakeProjectionEditor.Step3_BodyClass~}">
							<div class="field"><label class="label is-small">Projection name</label>
								<div class="control"><input class="input" type="text" placeholder="MoistureDaily" value="{~D:AppData.DatalakeProjectionEditor.Name~}" onchange="_Pict.providers.DatalakeProjectionEditorProvider.setName(this.value)" /></div>
								{~TS:DPE-NameError:AppData.DatalakeProjectionEditor.NameErrorSlot~}
							</div>
							<div class="field"><label class="label is-small">Target table</label><div class="control"><span class="dpe-target">{~D:AppData.DatalakeProjectionEditor.TargetPreview~}</span></div></div>
							<div class="field"><label class="label is-small">Description (optional)</label><div class="control"><input class="input is-small" type="text" value="{~D:AppData.DatalakeProjectionEditor.Description~}" oninput="_Pict.providers.DatalakeProjectionEditorProvider.setDescription(this.value)" /></div></div>
							<div class="field"><label class="checkbox"><input type="checkbox" {~D:AppData.DatalakeProjectionEditor.ScheduleEnabledAttr~} onchange="_Pict.providers.DatalakeProjectionEditorProvider.setScheduleEnabled(this.checked)" /> Refresh automatically on a schedule</label></div>
							<div class="{~D:AppData.DatalakeProjectionEditor.ScheduleFieldsClass~}">
								<div class="dpe-sched">
									<label class="radio"><input type="radio" name="dpe-sched-mode" {~D:AppData.DatalakeProjectionEditor.ScheduleModeIntervalChecked~} onchange="_Pict.providers.DatalakeProjectionEditorProvider.setScheduleMode('interval')" /> Every N minutes</label>
									<label class="radio"><input type="radio" name="dpe-sched-mode" {~D:AppData.DatalakeProjectionEditor.ScheduleModeCronChecked~} onchange="_Pict.providers.DatalakeProjectionEditorProvider.setScheduleMode('cron')" /> Cron (UTC)</label>
									<div class="field {~D:AppData.DatalakeProjectionEditor.ScheduleIntervalClass~}"><div class="control"><input class="input is-small" type="number" min="1" placeholder="minutes" value="{~D:AppData.DatalakeProjectionEditor.IntervalMinutes~}" oninput="_Pict.providers.DatalakeProjectionEditorProvider.setScheduleField('interval', this.value)" /></div></div>
									<div class="field {~D:AppData.DatalakeProjectionEditor.ScheduleCronClass~}"><div class="control"><input class="input is-small" type="text" placeholder="0 9 * * *" value="{~D:AppData.DatalakeProjectionEditor.Cron~}" oninput="_Pict.providers.DatalakeProjectionEditorProvider.setScheduleField('cron', this.value)" /></div></div>
									<div class="field"><div class="control"><input class="input is-small" type="text" placeholder="pipeline group (optional)" value="{~D:AppData.DatalakeProjectionEditor.Group~}" oninput="_Pict.providers.DatalakeProjectionEditorProvider.setScheduleField('group', this.value)" /></div></div>
								</div>
							</div>
							<div class="field mt-3"><p class="control"><button class="button is-link" onclick="_Pict.providers.DatalakeProjectionEditorProvider.continueFromName()">Review</button></p></div>
						</div>
					</div>

					<!-- Step 4: Review -->
					<div class="dpe-step">
						<div class="dpe-step-head" onclick="_Pict.providers.DatalakeProjectionEditorProvider.goToStep(4)">
							<span class="dpe-step-num">4</span><span class="dpe-step-title">Review</span><span class="tag {~D:AppData.DatalakeProjectionEditor.Step4_StatusClass~}">{~D:AppData.DatalakeProjectionEditor.Step4_StatusLabel~}</span>
						</div>
						<div class="dpe-step-body {~D:AppData.DatalakeProjectionEditor.Step4_BodyClass~}">
							<p class="is-size-7 has-text-grey mb-2">This is the exact request that will be sent to create the projection.</p>
							<pre class="dpe-review">{~D:AppData.DatalakeProjectionEditor.ReviewJSON~}</pre>
							<div class="field is-grouped mt-3"><p class="control"><button class="button is-light" onclick="_Pict.providers.DatalakeProjectionEditorProvider.goToStep(3)">Back</button></p><p class="control"><button class="button is-link" onclick="_Pict.providers.DatalakeProjectionEditorProvider.confirmReview()">Looks good</button></p></div>
						</div>
					</div>

					<!-- Step 5: Create -->
					<div class="dpe-step">
						<div class="dpe-step-head" onclick="_Pict.providers.DatalakeProjectionEditorProvider.goToStep(5)">
							<span class="dpe-step-num">5</span><span class="dpe-step-title">Create</span><span class="tag {~D:AppData.DatalakeProjectionEditor.Step5_StatusClass~}">{~D:AppData.DatalakeProjectionEditor.Step5_StatusLabel~}</span>
						</div>
						<div class="dpe-step-body {~D:AppData.DatalakeProjectionEditor.Step5_BodyClass~}">
							{~TS:DPE-Result:AppData.DatalakeProjectionEditor.ResultSlot~}
							<div class="field is-grouped">
								<p class="control"><button class="button is-link" onclick="_Pict.providers.DatalakeProjectionEditorProvider.submit()"><span class="icon is-small"><i class="fas fa-bolt"></i></span><span>Create projection</span></button>{~TS:DPE-Busy:AppData.DatalakeProjectionEditor.SubmitBusySlot~}</p>
								<p class="control"><button class="button is-light" onclick="_Pict.providers.DatalakeProjectionEditorProvider.viewInCatalog()">View in catalog</button></p>
							</div>
						</div>
					</div>
				</div>`
		},
		{ Hash: 'DPE-EntityOption', Template: /*html*/`<option value="{~D:Record.Entity~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>` },
		{ Hash: 'DPE-CloneBanner', Template: /*html*/`<div class="notification is-info is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-box-archive"></i></span> <span>Making the imported table <code>{~D:Record.Source~}</code> queryable — a 1:1 copy into a new, registered projection. Name it and create.</span></div>` },
		{
			Hash: 'DPE-EntityPicker',
			Template: /*html*/`
				<div class="field"><label class="label is-small">Source entity (from the Headlight data model)</label>
					<div class="control"><div class="select"><select onchange="_Pict.providers.DatalakeProjectionEditorProvider.setEntity(this.value)"><option value="">— pick an entity —</option>{~TS:DPE-EntityOption:AppData.DatalakeProjectionEditor.SourceEntityOptions~}</select></div></div>
				</div>
				{~TS:DPE-DocTypeField:AppData.DatalakeProjectionEditor.FormDataSlot~}`
		},
		{
			Hash: 'DPE-LakePicker',
			Template: /*html*/`
				<div class="field"><label class="label is-small">Data-lake source</label>
					{~TS:DPE-LakeLoading:AppData.DatalakeProjectionEditor.LakeSourcesLoadingSlot~}
					<div class="control"><div id="DPE-LakeSourcePicker" class="dpe-lake-picker"></div></div>
					{~TS:DPE-LakeEmpty:AppData.DatalakeProjectionEditor.LakeSourcesEmptySlot~}
					<p class="help">Chain off an existing computed projection, or project from an imported clone, into a new lake table.</p>
				</div>`
		},
		{ Hash: 'DPE-LakeGroup', Template: /*html*/`<optgroup label="{~D:Record.GroupLabel~}">{~TS:DPE-LakeOption:Record.Items~}</optgroup>` },
		{ Hash: 'DPE-LakeOption', Template: /*html*/`<option value="{~D:Record.Kind~}::{~D:Record.Physical~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>` },
		{ Hash: 'DPE-LakeLoading', Template: /*html*/`<p class="help is-size-7 has-text-grey">Loading data-lake sources…</p>` },
		{ Hash: 'DPE-LakeEmpty', Template: /*html*/`<p class="help is-warning">No computed projections or imported clones in your data lake yet.</p>` },
		{ Hash: 'DPE-TestCount', Template: /*html*/`<div class="field is-grouped"><p class="control"><button class="button is-small" onclick="_Pict.providers.DatalakeProjectionEditorProvider.testSource()"><span class="icon is-small"><i class="fas fa-list-ol"></i></span><span>Test source count</span></button></p></div>` },
		{ Hash: 'DPE-TestResult', Template: /*html*/`<div class="notification {~D:Record.Class~} is-soft py-1 px-3 mt-2 is-size-7">{~D:Record.Message~}</div>` },
		{
			Hash: 'DPE-FieldRow',
			Template: /*html*/`
				<tr class="{~D:Record.RowClass~}">
					<td class="has-text-centered"><input type="checkbox" {~D:Record.IncludeAttr~} onchange="_Pict.providers.DatalakeProjectionEditorProvider.toggleField('{~D:Record.SourceField~}')" /></td>
					<td><code>{~D:Record.SourceField~}</code></td>
					<td><input class="input is-small" type="text" value="{~D:Record.OutCol~}" onchange="_Pict.providers.DatalakeProjectionEditorProvider.setOutCol('{~D:Record.SourceField~}', this.value)" /></td>
					<td class="has-text-grey is-size-7">{~D:Record.MeadowType~}</td>
				</tr>`
		},
		{
			Hash: 'DPE-DocTypeField',
			Template: /*html*/`
				<div class="field"><label class="label is-small">Document type</label>
					<div class="control"><input class="input is-small" type="text" placeholder="e.g. WI-Moisture" value="{~D:AppData.DatalakeProjectionEditor.DocumentType~}" onchange="_Pict.providers.DatalakeProjectionEditorProvider.setDocumentType(this.value)" /></div>
					<p class="help">Scopes to documents of this type (sets the filter) and lets you project their form fields in the next step.</p>
				</div>`
		},
		{
			Hash: 'DPE-FormDataSection',
			Template: /*html*/`
				<div class="box mt-3" style="background: var(--bulma-scheme-main-bis, #f6f8fb);">
					<div class="level is-mobile mb-2"><div class="level-left"><strong class="is-size-7">Form fields (FormData)</strong></div><div class="level-right"><button class="button is-small" onclick="_Pict.providers.DatalakeProjectionEditorProvider.addFormDataField()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>Add form field</span></button></div></div>
					<p class="help mb-2">Project values from each document's form (e.g. <code>FormData.MeterMoisture</code>) — stored as text columns. Enter the form field's key.</p>
					<table class="table is-narrow is-fullwidth"><thead><tr><th>Form field key</th><th>Output column</th><th></th></tr></thead><tbody>{~TS:DPE-FormDataRow:AppData.DatalakeProjectionEditor.FormDataRows~}</tbody></table>
				</div>`
		},
		{
			Hash: 'DPE-FormDataRow',
			Template: /*html*/`
				<tr>
					<td><div class="field has-addons"><p class="control"><a class="button is-small is-static">FormData.</a></p><p class="control is-expanded"><input class="input is-small" type="text" value="{~D:Record.Key~}" onchange="_Pict.providers.DatalakeProjectionEditorProvider.setFormDataKey({~D:Record.Index~}, this.value)" /></p></div></td>
					<td><input class="input is-small" type="text" placeholder="(defaults to the key)" value="{~D:Record.OutCol~}" onchange="_Pict.providers.DatalakeProjectionEditorProvider.setFormDataOutCol({~D:Record.Index~}, this.value)" /></td>
					<td><button class="button is-small is-white" onclick="_Pict.providers.DatalakeProjectionEditorProvider.removeFormDataField({~D:Record.Index~})"><i class="fas fa-trash"></i></button></td>
				</tr>`
		},
		{ Hash: 'DPE-SchemaLoading', Template: /*html*/`<div class="has-text-grey has-text-centered py-3"><span class="dpe-spinner"></span> <span class="ml-2">Loading the entity's columns…</span></div>` },
		{ Hash: 'DPE-SchemaError', Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-2"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>` },
		{ Hash: 'DPE-NameError', Template: /*html*/`<p class="help is-danger">{~D:Record.Message~}</p>` },
		{ Hash: 'DPE-Busy', Template: /*html*/`<span class="dpe-spinner" style="margin-left:0.6rem;"></span>` },
		{
			Hash: 'DPE-Result',
			Template: /*html*/`<div class="notification {~D:Record.Class~} is-soft mb-3"><div class="is-flex"><span class="icon mr-2"><i class="fas {~D:Record.Icon~}"></i></span><div><strong>{~D:Record.Title~}</strong><br><span class="is-size-7">{~D:Record.Detail~}</span></div></div></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'DatalakeProjectionEditorWrap',
			TemplateHash: 'DPE-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-view":1053}],1433:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * DocumentList — the thin standalone screen (#/Documents, also #/PSRS/Document/List) that hosts the Meadow-backed,
 * filterable Documents browse (List + Charts). The DocumentList provider paints the whole screen into
 * #DocumentList-Host. Full browser width via Dashboard Mode. Document cognate of the Observation list.
 */
class DocumentListView extends libPictView
{
	get provider() { return this.pict.providers['DocumentList']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			// Standalone screen is never project-locked — exit any embed carried over from a Project workspace tab.
			if (typeof tmpProvider.exitEmbed === 'function') { tmpProvider.exitEmbed(); }
			tmpProvider._mount = '#DocumentList-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DocumentListView;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentList',
	DefaultRenderable: 'DocumentListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.dol-page { padding: 1.25rem 0 2rem; }
	`,

	Templates:
	[
		{
			Hash: 'DocumentList-Template',
			Template: html`
				<section class="section dol-page">
					<div id="DocumentList-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DocumentListWrap',
			TemplateHash: 'DocumentList-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1434:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libConfigs = require('../documents/DocumentThroughput-Configs.js');
const html = String.raw;

/**
 * DocumentThroughput — the thin standalone screen (#/DocumentThroughput[/:Type]) that hosts the reusable document-approval
 * throughput dashboard. The route's :Type selects the per-type config (defaults to Inspection-Dossier); the
 * DocumentThroughput provider paints into #DocumentThroughput-Host. Full browser width via Dashboard Mode.
 * See [[DocumentThroughput-Provider.js]] and [[DocumentThroughput-Configs.js]].
 */
class DocumentThroughputView extends libPictView
{
	get provider() { return this.pict.providers['DocumentThroughput']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			const tmpConfig = libConfigs.resolveConfig(this._routeType || '');
			// paint the header from the config
			try
			{
				const ca = this.pict.ContentAssignment;
				ca.assignContent('#DocumentThroughput-Title', `<i class="${tmpConfig.Icon || 'fas fa-file-signature'}"></i> ${tmpProvider._esc(tmpConfig.Title || 'Document throughput')}`);
				ca.assignContent('#DocumentThroughput-Sub', tmpProvider._esc(tmpConfig.Subtitle || ''));
			}
			catch (e) { /* */ }
			tmpProvider.renderInto('#DocumentThroughput-Host', tmpConfig);
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DocumentThroughputView;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentThroughput',
	DefaultRenderable: 'DocumentThroughputWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.dtp-page { padding: 1.25rem 2rem 2rem; }
		.dtp-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.dtp-page-h i { color: var(--theme-color-brand-primary,#2e7d74); }
		.dtp-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1rem; max-width: 60rem; }
	`,

	Templates:
	[
		{
			Hash: 'DocumentThroughput-Template',
			Template: html`
				<section class="section dtp-page">
					<h1 class="dtp-page-h" id="DocumentThroughput-Title"><i class="fas fa-file-signature"></i> Document throughput</h1>
					<p class="dtp-page-sub" id="DocumentThroughput-Sub"></p>
					<div id="DocumentThroughput-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DocumentThroughputWrap',
			TemplateHash: 'DocumentThroughput-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"../documents/DocumentThroughput-Configs.js":1272,"pict-view":1053}],1435:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * Documentation — the #/Documentation management screen. A left rail browses every platform help topic (grouped by
 * feature area, with a per-topic status chip: platform default vs. this customer's own copy vs. a customer topic);
 * the main pane views + edits the selected topic through the DocumentationProvider, which mounts the markdown
 * editor and writes to AcademyContent (the same path the F1 panel editor uses). The shell is static; all content
 * is assigned into #Doc-Rail / #Doc-Detail by the provider (SamplePlan hand-built-HTML pattern).
 */
class Documentation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.Documentation; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = Documentation;
module.exports.default_configuration =
{
	ViewIdentifier: 'Documentation',
	DefaultRenderable: 'DocumentationWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.doc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.doc-head { margin: 0 0 1rem; }
		.doc-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.doc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.doc-cols { display:grid; grid-template-columns: 17rem 1fr; gap:1.1rem; align-items:start; }
		@media (max-width: 820px) { .doc-cols { grid-template-columns: 1fr; } }
		.doc-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; }
		.doc-rail-loading { color:var(--theme-color-text-muted,#6b7686); font-style:italic; padding:0.6rem; }
		.doc-rail-group { margin:0 0 0.8rem; }
		.doc-rail-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0.25rem 0.5rem; }
		.doc-rail-item { display:flex; align-items:center; gap:0.4rem; padding:0.38rem 0.55rem; border-radius:6px; font-size:0.88rem; color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.doc-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
		.doc-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; font-weight:600; }
		.doc-rail-item-label { flex:1 1 auto; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.doc-rail-add { font-size:0.78rem; font-weight:600; color:var(--theme-color-brand-primary,#2e7d74); cursor:pointer; padding:0.32rem 0.55rem; }
		.doc-rail-add:hover { text-decoration:underline; }
		.doc-chip { font-size:0.58rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.08rem 0.4rem; border-radius:9px; line-height:1.7; white-space:nowrap; }
		.doc-chip-default, .doc-chip-canonical { color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#eef1f6); }
		.doc-chip-custom { color:#fff; background:var(--theme-color-primary,#2f6fed); }
		.doc-rail-item.is-active .doc-chip { color:#fff; background:rgba(255,255,255,0.25); }
		.doc-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
		.doc-detail-head { display:flex; justify-content:space-between; align-items:flex-start; gap:1rem; flex-wrap:wrap; margin:0 0 0.7rem; }
		.doc-detail-title { font-size:1.15rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.doc-detail-sub { display:flex; align-items:center; gap:0.5rem; margin-top:0.25rem; }
		.doc-detail-where { font-size:0.78rem; color:var(--theme-color-text-muted,#6b7686); }
		.doc-detail-where code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:0.72rem; }
		.doc-detail-note { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.7rem; }
		.doc-detail-actions { display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap; }
		.doc-delrow { margin-top:0.9rem; }
		.doc-detail-body { font-size:0.92rem; line-height:1.6; color:var(--theme-color-text-secondary,#45505f); }
			/* Markdown typography — mirrors the F1/? help panel so rendered docs read the same here (headers with
			   underline rules, spacing, lists, tables, code) instead of an unstyled run-on block. */
			.doc-detail-body > *:first-child { margin-top:0; }
			.doc-detail-body h1, .doc-detail-body h2, .doc-detail-body h3, .doc-detail-body h4 { color:var(--theme-color-text-primary,#1f2733); font-weight:700; line-height:1.25; margin:1.4rem 0 0.6rem; }
			.doc-detail-body h1 { font-size:1.4rem; padding-bottom:0.3rem; border-bottom:1px solid var(--theme-color-border-default,#d7dce3); }
			.doc-detail-body h2 { font-size:1.15rem; padding-bottom:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#e8ebf0); }
			.doc-detail-body h3 { font-size:1.02rem; }
			.doc-detail-body h4 { font-size:0.92rem; }
			.doc-detail-body p { margin:0.6rem 0; }
			.doc-detail-body ul, .doc-detail-body ol { margin:0.55rem 0; padding-left:1.5rem; }
			.doc-detail-body li { margin:0.25rem 0; }
			.doc-detail-body li > ul, .doc-detail-body li > ol { margin:0.2rem 0; }
			.doc-detail-body strong { color:var(--theme-color-text-primary,#1f2733); font-weight:650; }
			.doc-detail-body a { color:var(--theme-color-primary,#2f6fed); text-decoration:none; }
			.doc-detail-body a:hover { text-decoration:underline; }
			.doc-detail-body code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.85em; background:var(--theme-color-background-tertiary,#eef1f6); padding:0.1rem 0.35rem; border-radius:4px; }
			.doc-detail-body pre { background:var(--theme-color-background-tertiary,#eef1f6); padding:0.8rem 1rem; border-radius:8px; overflow-x:auto; margin:0.7rem 0; }
			.doc-detail-body pre code { background:none; padding:0; font-size:0.82rem; }
			.doc-detail-body blockquote { margin:0.7rem 0; padding:0.3rem 0.9rem; border-left:3px solid var(--theme-color-border-default,#d7dce3); color:var(--theme-color-text-muted,#6b7686); }
			.doc-detail-body hr { border:0; border-top:1px solid var(--theme-color-border-default,#d7dce3); margin:1.2rem 0; }
			.doc-detail-body table { border-collapse:collapse; width:100%; margin:0.8rem 0; font-size:0.86rem; display:block; overflow-x:auto; }
			.doc-detail-body th, .doc-detail-body td { border:1px solid var(--theme-color-border-light,#e8ebf0); padding:0.4rem 0.6rem; text-align:left; vertical-align:top; }
			.doc-detail-body th { background:var(--theme-color-background-secondary,#f7f8fa); font-weight:650; color:var(--theme-color-text-primary,#1f2733); }
			.doc-detail-body img { max-width:100%; }
		.doc-editor-host { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:7px; min-height:18rem; }
		.doc-input { flex:1 1 16rem; font:inherit; font-size:0.9rem; padding:0.4rem 0.55rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.doc-btn { font-size:0.84rem; font-weight:600; padding:0.42rem 0.9rem; border-radius:6px; cursor:pointer; border:1px solid transparent; }
		.doc-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); }
		.doc-btn-ghost { color:var(--theme-color-text,#22303f); background:transparent; border-color:var(--theme-color-border-medium,#d5dbe3); }
		.doc-btn-danger { color:var(--theme-color-status-danger,#c0392b); background:transparent; border-color:var(--theme-color-status-danger,#c0392b); }
		.doc-empty { padding:3rem 1rem; text-align:center; color:var(--theme-color-text-muted,#6b7686); }
		.doc-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.6rem; }
	`,
	Templates:
	[
		{
			Hash: 'Documentation-Wrap',
			Template: /*html*/`
				<div class="doc-wrap">
					<div class="doc-head">
						<h1 class="doc-title">Documentation</h1>
						<p class="doc-subtitle">Manage the platform's in-app help. Headlight administrators edit the platform-default topics; customer administrators customize their own copy of any topic (and add their own). Changes appear in the F1 / ? help right away.</p>
					</div>
					<div class="doc-cols">
						<div id="Doc-Rail" class="doc-rail"></div>
						<div id="Doc-Detail" class="doc-main"></div>
					</div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentationWrap',
			TemplateHash: 'Documentation-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1436:[function(require,module,exports){
/**
 * EmailNotifications-ConfigFieldSchema — the typed-editor registry for email-rule custom content.
 *
 * The email handlers are SERVER-DRIVEN (GET Email/Handlers returns each handler's defaultConfiguration +
 * configurationDocs). Their config values are not all scalars: several are arrays or objects whose shape is
 * meaningful (a recipient list, `[field, value]` document filters, a role list, actor tags, a routing map).
 * Rendering those as a raw JSON textarea — what Home does, and what this app did before — makes them
 * effectively un-editable by an admin.
 *
 * This module maps a handler + field key onto a typed EDITOR id, and carries the pure parse/serialize
 * helpers each editor needs. It is deliberately DOM-free and pict-free so the round-tripping can be unit
 * tested (test/EmailNotificationsConfigFields_tests.js).
 *
 * Anything the registry does not recognize falls back to the inferred scalar type, and any unmodeled
 * array/object still lands on the 'json' escape hatch — so a handler that grows a new field shape keeps
 * working (degraded) instead of breaking.
 */

/**
 * Curated recipient tokens — the handlebars entities the notify handlers expose that resolve to an email
 * address. Handlers document more entities than these (Customer, Project, Document); only the ones that
 * carry an Email are offered as a one-click choice. Anything else is reachable via the Custom template kind.
 */
const RECIPIENT_TOKENS =
[
	{ Value: '{{CreatingUser.Email}}', Label: 'The person who created the document' },
	{ Value: '{{UpdatingUser.Email}}', Label: 'The person who last updated the document' },
];

/** The `ProjectRole:` prefix statusChangeNotification expands into every user holding that role on the project. */
const PROJECT_ROLE_PREFIX = 'ProjectRole:';

/**
 * Field key -> editor id. Keyed by field name because the handlers reuse the same names for the same shapes
 * (they share sharedConfigDocs). A handler-specific override can be added as `'<Handler>.<Key>'`.
 */
const FIELD_EDITORS =
{
	'Recipients': 'recipients',
	'FilterDocuments': 'documentfilters',
	'UsersWithRole': 'roles',
	'RequireAllActorTags': 'tags',
	'RequireAnyActorTags': 'tags',
	'SendTo': 'sendmap',
	'CC': 'emaillist',
	'BCC': 'emaillist',
	'SendRestTo': 'emaillist',
	'Subject': 'template',
	'BasedOn': 'template',
	'DocumentFilename': 'template',
	'TextMessage': 'body',
	'HTMLMessage': 'body',
};

/** Editors that manage their own value shape (so the generic scalar capture must skip them). */
const COMPLEX_EDITORS = [ 'recipients', 'documentfilters', 'roles', 'tags', 'sendmap', 'emaillist' ];

/**
 * Common document fields worth suggesting in the FilterDocuments field picker. Free text is still allowed —
 * FormData.Content.* paths are customer-specific and cannot be enumerated here.
 */
const DOCUMENT_FILTER_FIELDS =
[
	'Status',
	'IDProject',
	'IDDocumentType',
	'CreatingIDUser',
	'UpdatingIDUser',
	'FormData.Content.',
];

/**
 * Resolve the editor id for a config field.
 *
 * @param {String} pHandler - the handler name (e.g. 'StatusChangeNotification')
 * @param {String} pKey - the config field key
 * @param {*} pDefaultValue - the handler's default value for the key (the shape authority)
 * @param {*} pCurrentValue - the rule's stored value, used when the handler has no default for the key
 * @return {String} one of: recipients | documentfilters | roles | tags | sendmap | emaillist | template | body | checkbox | text | json
 */
function resolveFieldEditor(pHandler, pKey, pDefaultValue, pCurrentValue)
{
	const tmpScoped = FIELD_EDITORS[`${pHandler}.${pKey}`];
	if (tmpScoped) { return tmpScoped; }
	const tmpMapped = FIELD_EDITORS[pKey];
	if (tmpMapped) { return tmpMapped; }
	// Not in the registry — infer from the shape, preferring the handler default over the stored value.
	const tmpShape = (pDefaultValue === undefined) ? pCurrentValue : pDefaultValue;
	if (typeof tmpShape === 'boolean') { return 'checkbox'; }
	if (Array.isArray(tmpShape) || (tmpShape && typeof tmpShape === 'object')) { return 'json'; }
	const tmpString = (tmpShape == null) ? '' : String(tmpShape);
	if (tmpString.indexOf('\n') > -1) { return 'body'; }
	return 'text';
}

/** Whether an editor owns its own value shape (arrays/objects/chips) rather than a plain scalar input. */
function isComplexEditor(pEditor)
{
	return COMPLEX_EDITORS.indexOf(pEditor) > -1;
}

// --- Recipients ---------------------------------------------------------------------------------------

/**
 * Classify one stored recipient string into an editable row.
 *
 * @param {String} pValue
 * @return {{ Kind: String, Value: String }}  Kind: 'role' | 'token' | 'email' | 'template'
 */
function parseRecipient(pValue)
{
	const tmpValue = (pValue == null) ? '' : String(pValue);
	if (tmpValue.indexOf(PROJECT_ROLE_PREFIX) === 0)
	{
		return { Kind: 'role', Value: tmpValue.slice(PROJECT_ROLE_PREFIX.length) };
	}
	if (RECIPIENT_TOKENS.some((pToken) => pToken.Value === tmpValue))
	{
		return { Kind: 'token', Value: tmpValue };
	}
	if (tmpValue.indexOf('{{') > -1)
	{
		return { Kind: 'template', Value: tmpValue };
	}
	return { Kind: 'email', Value: tmpValue };
}

/** Turn an editable recipient row back into the string the handler expects. */
function serializeRecipient(pRow)
{
	if (!pRow) { return ''; }
	const tmpValue = (pRow.Value == null) ? '' : String(pRow.Value).trim();
	if (pRow.Kind === 'role')
	{
		return tmpValue ? `${PROJECT_ROLE_PREFIX}${tmpValue}` : '';
	}
	return tmpValue;
}

/** Parse a whole Recipients array into rows (dropping empties). */
function parseRecipients(pValue)
{
	return toArray(pValue).map(parseRecipient);
}

/** Serialize recipient rows, dropping rows the admin left blank. */
function serializeRecipients(pRows)
{
	return (Array.isArray(pRows) ? pRows : []).map(serializeRecipient).filter((pValue) => pValue !== '');
}

// --- Document filters ---------------------------------------------------------------------------------

/**
 * FilterDocuments is an array of `[field, value]` pairs. Parse defensively — a hand-edited config can hold
 * a malformed entry, and dropping it silently would change what the rule matches.
 *
 * @return {Array<{ Field: String, Value: String }>}
 */
function parseDocumentFilters(pValue)
{
	return toArray(pValue).map((pPair) =>
	{
		if (Array.isArray(pPair))
		{
			return { Field: String(pPair[0] == null ? '' : pPair[0]), Value: String(pPair[1] == null ? '' : pPair[1]) };
		}
		return { Field: String(pPair == null ? '' : pPair), Value: '' };
	});
}

/** Serialize filter rows back to `[field, value]` pairs, dropping rows with no field. */
function serializeDocumentFilters(pRows)
{
	return (Array.isArray(pRows) ? pRows : [])
		.filter((pRow) => pRow && String(pRow.Field || '').trim() !== '')
		.map((pRow) => [ String(pRow.Field).trim(), coerceFilterValue(pRow.Value) ]);
}

/**
 * Filter values are compared against raw column values, so a numeric-looking value must go over as a number
 * (`["UpdatingIDUser", 4]` in the handler docs) or the match silently fails.
 */
function coerceFilterValue(pValue)
{
	const tmpValue = (pValue == null) ? '' : String(pValue).trim();
	if (tmpValue !== '' && !isNaN(Number(tmpValue)) && /^-?\d+(\.\d+)?$/.test(tmpValue))
	{
		return Number(tmpValue);
	}
	return tmpValue;
}

// --- Roles --------------------------------------------------------------------------------------------

/**
 * UsersWithRole holds PermissionLevel strings OR numeric IDRoles. Keep both — an existing config may use
 * ids, and rewriting them to permission levels would change which users match.
 *
 * @return {Array<String|Number>}
 */
function parseRoleList(pValue)
{
	return toArray(pValue).filter((pEntry) => pEntry !== null && pEntry !== undefined && pEntry !== '');
}

// --- Tags / email chips -------------------------------------------------------------------------------

/** Actor-tag arrays: normalize to trimmed, de-duplicated strings. */
function parseTagList(pValue)
{
	return dedupe(toArray(pValue).map((pTag) => String(pTag == null ? '' : pTag).trim()).filter(Boolean));
}

/**
 * CC / BCC / SendRestTo are comma-separated email STRINGS (not arrays) — sharedConfig splits them on comma.
 * Parse to chips for editing.
 */
function parseEmailList(pValue)
{
	if (Array.isArray(pValue))
	{
		return dedupe(pValue.map((pEntry) => String(pEntry == null ? '' : pEntry).trim()).filter(Boolean));
	}
	return dedupe(String(pValue == null ? '' : pValue).split(',').map((pEntry) => pEntry.trim()).filter(Boolean));
}

/** Serialize email chips back to the comma-separated string the handlers split on. */
function serializeEmailList(pChips)
{
	return dedupe((Array.isArray(pChips) ? pChips : []).map((pEntry) => String(pEntry == null ? '' : pEntry).trim()).filter(Boolean)).join(',');
}

/** A permissive address check — good enough to warn on a typo without rejecting valid odd addresses. */
function looksLikeEmail(pValue)
{
	return /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/.test(String(pValue == null ? '' : pValue).trim());
}

// --- SendTo map ---------------------------------------------------------------------------------------

/**
 * ApprovalRollup's SendTo is `{ <BasedOn result>: "a@x.com,b@y.com" }`. Rows preserve key order.
 *
 * @return {Array<{ Key: String, Value: String }>}
 */
function parseSendMap(pValue)
{
	if (!pValue || typeof pValue !== 'object' || Array.isArray(pValue)) { return []; }
	return Object.keys(pValue).map((pKey) => ({ Key: pKey, Value: String(pValue[pKey] == null ? '' : pValue[pKey]) }));
}

/** Serialize SendTo rows, dropping rows with no key. A later row with a duplicate key wins (object semantics). */
function serializeSendMap(pRows)
{
	const tmpMap = {};
	(Array.isArray(pRows) ? pRows : []).forEach((pRow) =>
	{
		if (!pRow) { return; }
		const tmpKey = String(pRow.Key == null ? '' : pRow.Key).trim();
		if (!tmpKey) { return; }
		tmpMap[tmpKey] = serializeEmailList(parseEmailList(pRow.Value));
	});
	return tmpMap;
}

// --- Shared helpers -----------------------------------------------------------------------------------

/** Coerce a stored value to an array — a JSON-string column, a single value, or already an array. */
function toArray(pValue)
{
	if (Array.isArray(pValue)) { return pValue; }
	if (pValue === null || pValue === undefined || pValue === '') { return []; }
	if (typeof pValue === 'string')
	{
		try { const tmpParsed = JSON.parse(pValue); if (Array.isArray(tmpParsed)) { return tmpParsed; } }
		catch (pError) { /* not JSON — treat as a single entry below */ }
		return [ pValue ];
	}
	return [ pValue ];
}

function dedupe(pList)
{
	const tmpSeen = {};
	const tmpResult = [];
	(pList || []).forEach((pEntry) =>
	{
		const tmpKey = String(pEntry);
		if (!tmpSeen[tmpKey]) { tmpSeen[tmpKey] = true; tmpResult.push(pEntry); }
	});
	return tmpResult;
}

/** Deep-ish equality good enough for comparing a config value against its handler default (JSON-safe values). */
function valuesEqual(pLeft, pRight)
{
	if (pLeft === pRight) { return true; }
	try { return JSON.stringify(pLeft) === JSON.stringify(pRight); }
	catch (pError) { return false; }
}

/** A DOM-id-safe slug for a config key (handler keys are identifiers today, but stored blobs are freeform). */
function fieldSlug(pKey)
{
	return String(pKey == null ? '' : pKey).replace(/[^A-Za-z0-9_]/g, '_');
}

module.exports =
{
	RECIPIENT_TOKENS,
	PROJECT_ROLE_PREFIX,
	FIELD_EDITORS,
	DOCUMENT_FILTER_FIELDS,

	resolveFieldEditor,
	isComplexEditor,

	parseRecipient,
	serializeRecipient,
	parseRecipients,
	serializeRecipients,

	parseDocumentFilters,
	serializeDocumentFilters,
	coerceFilterValue,

	parseRoleList,
	parseTagList,

	parseEmailList,
	serializeEmailList,
	looksLikeEmail,

	parseSendMap,
	serializeSendMap,

	toArray,
	valuesEqual,
	fieldSlug,
};

},{}],1437:[function(require,module,exports){

const libPictView = require('pict-view');
// Field key -> typed editor mapping plus the pure parse/serialize helpers (see the module for the rationale).
const libConfigFieldSchema = require('./EmailNotifications-ConfigFieldSchema.js');

const WEEKDAY_LABELS = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];

/** How many available-side rows a dual list puts in the DOM at once; the rest wait behind the filter. */
const AVAILABLE_RENDER_CAP = 250;

/**
 * EmailNotificationsEditor — the #/EmailRule/New and #/EmailRule/:ID editor.
 *
 * The core rule form (Enabled / Handler / Projects / DocumentType / Status) sits above a stable
 * #EmailNotifications-Dynamic region that renders, for the selected handler, the SCHEDULE editor (scheduled
 * handlers) and the custom-content CONFIG form.
 *
 * The config form is FORM-BASED end to end: every field the handler declares gets a per-key "Customize"
 * switch (off = the handler's built-in default applies and nothing is stored) and a typed editor chosen by
 * EmailNotifications-ConfigFieldSchema — recipient rows, `[field, value]` filter pairs, role checkboxes, tag
 * and address chips, routing rows, template inputs with a variable inserter, and plain code editors for the
 * message bodies. A raw JSON textarea survives only as the escape hatch for a shape the schema does not
 * model, and invalid JSON there blocks the save rather than silently storing a string.
 *
 * Save runs the full provider sequence (EmailRule/Upsert + double-save + Configuration/Put +
 * EmailRule/SetSchedule).
 *
 * The dynamic region is re-rendered on its own (never a full page re-render) so the code editors survive
 * base-field edits, and a single field can re-render in isolation (#emne-fld-<slug>) so adding a row does not
 * disturb the other fields' editors.
 */
class EmailNotificationsEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		// Config field keys currently rendered as code editors (for capture + re-mount).
		this._activeBodyFields = [];
		// Mounted CodeMirror instances, keyed by config field key.
		this._bodyEditors = {};
		// Per-field validation errors from the last capture, keyed by config field key. Blocks save.
		this._configErrors = {};
		// Filter text per dual-list picker ('projects' / 'status'), one per pane.
		this._dualFilters = {};
		this._dualSelectedFilters = {};
	}

	get provider()
	{
		return this.pict.providers.EmailNotifications;
	}

	get modal()
	{
		return this.pict.views['Pict-Section-Modal'];
	}

	_esc(pValue)
	{
		return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	/** Escape a value that lands inside a single-quoted inline JS handler argument (config keys, from the server). */
	_attr(pValue)
	{
		return this._esc(String(pValue == null ? '' : pValue).replace(/\\/g, '\\\\').replace(/'/g, "\\'"));
	}

	onBeforeRender(pRenderable)
	{
		const tmpEditor = this.provider ? this.provider.editorState : { Rule: null, Loading: false, Error: '' };
		const tmpApp = this.pict.AppData.EmailNotifications || {};
		tmpApp.EditorLoadingSlot = tmpEditor.Loading ? [ {} ] : [];
		tmpApp.EditorErrorSlot = tmpEditor.Error ? [ { Message: tmpEditor.Error } ] : [];
		tmpApp.EditorTitle = tmpEditor.IsNew ? 'New Email Rule' : 'Edit Email Rule';
		tmpApp.EditorRuleSlot = (tmpEditor.Rule && !tmpEditor.Loading && !tmpEditor.Error) ? [ this._formRecord(tmpEditor.Rule, tmpEditor) ] : [];
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._renderActions();
		// The base form just rendered; fill the handler description + the dynamic (schedule/config) region.
		if (this.provider.editorState.Rule)
		{
			// The whole form was just replaced — any previously mounted code editors are detached DOM now.
			this._destroyBodyEditors();
			this._activeBodyFields = [];
			this._renderHandlerDesc();
			this._renderDualLists();
			this._renderDynamic();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** Base form render record (the fields that don't depend on the handler's config). */
	_formRecord(pRule, pEditor)
	{
		const tmpLookups = this.provider.state.Lookups || {};
		const tmpHandlers = this.provider.state.Handlers || {};
		return {
			Enabled: pRule.Enabled ? 'checked' : '',
			DisabledAttr: pEditor.Editable ? '' : 'disabled',
			HandlerOptions: Object.keys(tmpHandlers).map((pHandler) => ({ Value: pHandler, Label: this.provider.handlerLabel(pHandler), SelectedAttr: (pHandler === pRule.Handler) ? 'selected' : '' })),
			DocTypeOptions: [ { Hash: '', Name: 'Any document type', SelectedAttr: pRule.DocumentType ? '' : 'selected' } ]
				.concat((tmpLookups.DocTypes || []).map((pDoc) => ({ Hash: pDoc.Hash, Name: pDoc.Name, SelectedAttr: (pDoc.Hash === pRule.DocumentType) ? 'selected' : '' }))),
			ExistingSlot: (!pEditor.IsNew) ? [ { IDEmailRule: pRule.IDEmailRule } ] : [],
			ReadOnlySlot: (!pEditor.Editable) ? [ {} ] : [],
		};
	}

	// --- Base field capture / change ----------------------------------------------------------------

	_captureForm()
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule) { return; }
		const tmpGet = (pID) => document.getElementById(pID);
		if (tmpGet('emne-enabled')) { tmpRule.Enabled = tmpGet('emne-enabled').checked; }
		if (tmpGet('emne-handler')) { tmpRule.Handler = tmpGet('emne-handler').value; }
		if (tmpGet('emne-doctype')) { tmpRule.DocumentType = tmpGet('emne-doctype').value; }
		// Projects and Status are held by the dual-list pickers directly on the rule — reading them back out of
		// the DOM is what used to drop any selection that was not in the loaded option set.
	}

	onFieldChanged()
	{
		this._captureForm();
		this.provider._markRuleDirty();
		this._renderActions();
	}

	/** Handler changed: capture everything, then refresh the description + dynamic region for the new handler. */
	onHandlerChanged()
	{
		// Read the config region FIRST — it is still showing the previous handler's fields, and capturing it
		// after _captureForm() adopts the new handler would interpret the old controls with the new schema.
		this._captureDynamic();
		this._captureForm();
		this._pruneOverridesForHandler();
		this.provider._markRuleDirty();
		this._renderHandlerDesc();
		this._renderDynamic();
		this._renderActions();
	}

	/**
	 * After an email-type change, drop the overrides the new handler does not declare. Keys the handlers share
	 * (Subject, CC/BCC, the message bodies, FilterDocuments) carry over, which is the portable part of the
	 * admin's work; anything else would be dead weight in the new handler's config blob.
	 */
	_pruneOverridesForHandler()
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule || !tmpRule.ConfigValue) { return; }
		const tmpMeta = (this.provider.state.Handlers || {})[tmpRule.Handler] || {};
		const tmpDefaults = tmpMeta.defaultConfiguration || {};
		Object.keys(tmpRule.ConfigValue).forEach((pKey) =>
		{
			if (!Object.prototype.hasOwnProperty.call(tmpDefaults, pKey)) { delete tmpRule.ConfigValue[pKey]; }
		});
	}

	// --- Handler description + dynamic region --------------------------------------------------------

	_renderHandlerDesc()
	{
		if (!this.pict.ContentAssignment.getElement('#EmailNotifications-Handler-Desc')) { return; }
		const tmpRule = this.provider.editorState.Rule;
		const tmpMeta = (this.provider.state.Handlers || {})[tmpRule.Handler] || {};
		const tmpSched = tmpMeta.scheduled ? `<span class="emne-sched-note"><span class="icon is-small"><i class="fas fa-clock"></i></span> Scheduled</span>` : '';
		this.pict.ContentAssignment.assignContent('#EmailNotifications-Handler-Desc',
			`<div class="emne-handler-desc">${this._esc(tmpMeta.description || '')} ${tmpSched}</div>`);
	}

	/** Render the schedule + config sections for the current handler into the dynamic region. */
	_renderDynamic()
	{
		if (!this.pict.ContentAssignment.getElement('#EmailNotifications-Dynamic')) { return; }
		// Capture the region we're about to replace (marshals the code editors out to ConfigValue), then tear
		// those editors down — their DOM is about to be discarded and a stale instance would leak listeners.
		this._captureDynamic();
		this._destroyBodyEditors();
		const tmpEditor = this.provider.editorState;
		const tmpRule = tmpEditor.Rule;
		const tmpMeta = (this.provider.state.Handlers || {})[tmpRule.Handler] || {};
		let tmpHTML = '';
		if (tmpMeta.scheduled) { tmpHTML += this._scheduleHTML(tmpRule, tmpEditor); }
		tmpHTML += this._configHTML(tmpRule, tmpEditor);
		this.pict.ContentAssignment.assignContent('#EmailNotifications-Dynamic', tmpHTML);
		this._mountActiveBodyEditors();
	}

	// --- "Applies to" dual-list pickers -------------------------------------------------------------
	//
	// Projects and Status are side-by-side available/selected lists rather than multi-selects. Two reasons
	// beyond ergonomics: a customer can have thousands of projects (QA customer 10 has 3334), which no
	// multi-select handles usefully, and — more importantly — the SELECTED side is driven by the rule itself,
	// not by the loaded option set. A selection the source list does not contain stays selected and is shown
	// by id, instead of vanishing from the form and being silently dropped on the next save.
	//
	// The available side renders at most AVAILABLE_RENDER_CAP rows and narrows through the filter box, so the
	// DOM stays small no matter how many projects the customer has.

	/** The dual lists on the base form: id -> how to read/write the rule and where to render. */
	get dualLists()
	{
		return {
			projects:
			{
				Target: '#EmailNotifications-Projects',
				Label: 'projects',
				Numeric: true,
				Options: () => (this.provider.state.Lookups.Projects || []).map((pProject) => ({ Value: pProject.IDProject, Label: pProject.Name })),
				Read: () => (this.provider.editorState.Rule.Projects || []),
				Write: (pValues) => { this.provider.editorState.Rule.Projects = pValues; },
				LabelFor: (pValue) => this.provider.projectLabel(pValue),
				// Projects are server-side search (a customer can have thousands) — the Available pane queries the
				// server per keystroke instead of filtering an in-memory list. Statuses stays a client-side list.
				ServerSearch:
				{
					Search: (pTerm) => this.provider.searchProjectsAsync(pTerm),
					SearchAll: (pTerm) => this.provider.searchAllProjectsAsync(pTerm),
				},
			},
			status:
			{
				Target: '#EmailNotifications-Status',
				Label: 'statuses',
				Numeric: false,
				Options: () => (this.provider.state.Lookups.Statuses || []).map((pStatus) => ({ Value: pStatus, Label: pStatus })),
				Read: () => (this.provider.editorState.Rule.Status || []),
				Write: (pValues) => { this.provider.editorState.Rule.Status = pValues; },
				LabelFor: (pValue) => String(pValue),
			},
		};
	}

	/** Render both dual lists into the base form (called after the form template lands). */
	_renderDualLists()
	{
		const tmpLists = this.dualLists;
		Object.keys(tmpLists).forEach((pID) => this._renderDualList(pID));
		return tmpLists;
	}

	_renderDualList(pID)
	{
		const tmpSpec = this.dualLists[pID];
		if (!tmpSpec || !this.pict.ContentAssignment.getElement(tmpSpec.Target)) { return; }
		this.pict.ContentAssignment.assignContent(tmpSpec.Target, this._dualListHTML(pID, tmpSpec));
		this.pict.CSSMap.injectCSS();
	}

	_dualListHTML(pID, pSpec)
	{
		const tmpDisabled = this.provider.editorState.Editable ? '' : 'disabled';
		const tmpFilter = (this._dualFilters || {})[pID] || '';
		const tmpSelected = pSpec.Read();
		const tmpTotal = pSpec.Options().length;
		const tmpSelectedFilter = (this._dualSelectedFilters || {})[pID] || '';
		// Both moves act on what the neighbouring pane is currently SHOWING, so they stay predictable while a
		// filter is applied ("add all" after filtering to a district adds that district, not all 3334).
		const tmpControls = tmpDisabled ? '' : `
			<div class="emne-dualmid">
				<button type="button" class="button is-small is-light" title="Add everything the Available list is showing" onclick="_Pict.views.EmailNotificationsEditor.onDualAddAll('${pID}')">Add all &raquo;</button>
				<button type="button" class="button is-small is-light" title="Remove everything the Selected list is showing" onclick="_Pict.views.EmailNotificationsEditor.onDualClear('${pID}')">&laquo; Remove all</button>
			</div>`;
		// The two panes are deliberately identical in structure — same header, same filter row, same list — so
		// their tops and bottoms line up whatever is in them.
		return `
			<div class="emne-dual">
				<div class="emne-dualpane">
					<div class="emne-dualhead">Available <span class="emne-dualcount" id="emne-dualavailcount-${pID}">${this._dualAvailableMatches(pID, pSpec).length}</span></div>
					<input type="text" class="input is-small emne-dualfilter" id="emne-dualfilter-${pID}" value="${this._esc(tmpFilter)}" placeholder="${pSpec.ServerSearch ? `Search ${this._esc(pSpec.Label)}…` : `Filter ${this._esc(String(tmpTotal))} ${this._esc(pSpec.Label)}…`}" ${tmpDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDualFilter('${pID}', this.value)">
					<div class="emne-duallist" id="emne-dualavail-${pID}">${this._dualAvailableHTML(pID, pSpec)}</div>
				</div>
				${tmpControls}
				<div class="emne-dualpane">
					<div class="emne-dualhead">Selected <span class="emne-dualcount" id="emne-dualselcount-${pID}">${tmpSelected.length}</span></div>
					<input type="text" class="input is-small emne-dualfilter" id="emne-dualselfilter-${pID}" value="${this._esc(tmpSelectedFilter)}" placeholder="Filter selected…" ${tmpDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDualSelectedFilter('${pID}', this.value)">
					<div class="emne-duallist emne-duallist-selected" id="emne-dualsel-${pID}">${this._dualSelectedHTML(pID, pSpec)}</div>
				</div>
			</div>`;
	}

	/** The available side: everything not already selected, narrowed by the filter and capped for the DOM. */
	_dualAvailableHTML(pID, pSpec)
	{
		const tmpDisabled = this.provider.editorState.Editable ? '' : 'disabled';
		const tmpMatches = this._dualAvailableMatches(pID, pSpec);
		if (!tmpMatches.length)
		{
			const tmpFilter = (this._dualFilters || {})[pID] || '';
			if (pSpec.ServerSearch)
			{
				if ((this._dualSearching || {})[pID]) { return `<p class="emne-dualempty">Searching…</p>`; }
				if (!tmpFilter) { return `<p class="emne-dualempty">Type to search ${this._esc(pSpec.Label)}…</p>`; }
				return `<p class="emne-dualempty">Nothing matches that search.</p>`;
			}
			return `<p class="emne-dualempty">${tmpFilter ? 'Nothing matches that filter.' : 'Everything is selected.'}</p>`;
		}
		const tmpShown = tmpMatches.slice(0, AVAILABLE_RENDER_CAP);
		let tmpHTML = tmpShown.map((pOption) =>
			`<button type="button" class="emne-dualitem" ${tmpDisabled} onclick="_Pict.views.EmailNotificationsEditor.onDualAdd('${pID}', this.getAttribute('data-val'))" data-val="${this._esc(pOption.Value)}">${this._esc(pOption.Label)}</button>`).join('');
		if (tmpMatches.length > tmpShown.length)
		{
			tmpHTML += `<p class="emne-dualempty">${tmpMatches.length - tmpShown.length} more — narrow the filter to see them.</p>`;
		}
		return tmpHTML;
	}

	/** Options not currently selected, filtered by the pane's filter text. */
	_dualAvailableMatches(pID, pSpec)
	{
		const tmpSelected = {};
		pSpec.Read().forEach((pValue) => { tmpSelected[String(pValue)] = true; });
		if (pSpec.ServerSearch)
		{
			// Server-search lists show the latest server results (already filtered by the term), minus what's selected.
			return ((this._serverResults || {})[pID] || []).filter((pOption) => !tmpSelected[String(pOption.Value)]);
		}
		const tmpFilter = String((this._dualFilters || {})[pID] || '').trim().toLowerCase();
		return pSpec.Options().filter((pOption) =>
		{
			if (tmpSelected[String(pOption.Value)]) { return false; }
			if (!tmpFilter) { return true; }
			return (String(pOption.Label).toLowerCase().indexOf(tmpFilter) > -1) || (String(pOption.Value).toLowerCase().indexOf(tmpFilter) > -1);
		});
	}

	/**
	 * The selected side, driven by the rule. A value the source list does not contain still renders (by id,
	 * flagged) so it survives the round trip instead of being dropped.
	 */
	_dualSelectedHTML(pID, pSpec)
	{
		const tmpDisabled = this.provider.editorState.Editable ? '' : 'disabled';
		const tmpAllSelected = pSpec.Read();
		if (!tmpAllSelected.length)
		{
			return `<p class="emne-dualempty">None selected — the rule applies to <strong>all ${this._esc(pSpec.Label)}</strong>.</p>`;
		}
		const tmpKnown = {};
		pSpec.Options().forEach((pOption) => { tmpKnown[String(pOption.Value)] = pOption.Label; });
		const tmpSelected = this._dualSelectedMatches(pID, pSpec);
		if (!tmpSelected.length)
		{
			return `<p class="emne-dualempty">None of the ${tmpAllSelected.length} selected ${this._esc(pSpec.Label)} match that filter.</p>`;
		}
		return tmpSelected.map((pValue) =>
		{
			const tmpIsKnown = Object.prototype.hasOwnProperty.call(tmpKnown, String(pValue));
			const tmpLabel = tmpIsKnown ? tmpKnown[String(pValue)] : pSpec.LabelFor(pValue);
			const tmpFlag = tmpIsKnown ? '' : `<span class="emne-dualunknown" title="Not in the current list — kept so it is not lost."><i class="fas fa-circle-question"></i></span>`;
			return `<button type="button" class="emne-dualitem emne-dualitem-selected" ${tmpDisabled} onclick="_Pict.views.EmailNotificationsEditor.onDualRemove('${pID}', this.getAttribute('data-val'))" data-val="${this._esc(pValue)}"><span>${this._esc(tmpLabel)}</span>${tmpFlag}<i class="fas fa-xmark emne-dualx"></i></button>`;
		}).join('');
	}

	/** Selected values narrowed by the selected pane's own filter. */
	_dualSelectedMatches(pID, pSpec)
	{
		const tmpFilter = String((this._dualSelectedFilters || {})[pID] || '').trim().toLowerCase();
		const tmpSelected = pSpec.Read();
		if (!tmpFilter) { return tmpSelected; }
		const tmpKnown = {};
		pSpec.Options().forEach((pOption) => { tmpKnown[String(pOption.Value)] = pOption.Label; });
		return tmpSelected.filter((pValue) =>
		{
			const tmpLabel = Object.prototype.hasOwnProperty.call(tmpKnown, String(pValue)) ? tmpKnown[String(pValue)] : pSpec.LabelFor(pValue);
			return (String(tmpLabel).toLowerCase().indexOf(tmpFilter) > -1) || (String(pValue).toLowerCase().indexOf(tmpFilter) > -1);
		});
	}

	onDualSelectedFilter(pID, pFilter)
	{
		if (!this._dualSelectedFilters) { this._dualSelectedFilters = {}; }
		this._dualSelectedFilters[pID] = pFilter;
		const tmpSelected = document.getElementById(`emne-dualsel-${pID}`);
		if (tmpSelected) { tmpSelected.innerHTML = this._dualSelectedHTML(pID, this.dualLists[pID]); }
	}

	/** Repaint just the two list panes (never the filter inputs, so typing keeps focus). */
	_refreshDualPanes(pID)
	{
		const tmpSpec = this.dualLists[pID];
		const tmpAvailable = document.getElementById(`emne-dualavail-${pID}`);
		const tmpSelected = document.getElementById(`emne-dualsel-${pID}`);
		if (tmpAvailable) { tmpAvailable.innerHTML = this._dualAvailableHTML(pID, tmpSpec); }
		if (tmpSelected) { tmpSelected.innerHTML = this._dualSelectedHTML(pID, tmpSpec); }
		const tmpSelectedCount = document.getElementById(`emne-dualselcount-${pID}`);
		if (tmpSelectedCount) { tmpSelectedCount.textContent = String(tmpSpec.Read().length); }
		const tmpAvailableCount = document.getElementById(`emne-dualavailcount-${pID}`);
		if (tmpAvailableCount) { tmpAvailableCount.textContent = String(this._dualAvailableMatches(pID, tmpSpec).length); }
	}

	/** Coerce a value read back off a DOM attribute to the type the rule field stores. */
	_dualCoerce(pID, pValue)
	{
		return this.dualLists[pID].Numeric ? Number(pValue) : String(pValue);
	}

	onDualFilter(pID, pFilter)
	{
		if (!this._dualFilters) { this._dualFilters = {}; }
		this._dualFilters[pID] = pFilter;
		const tmpSpec = this.dualLists[pID];
		if (tmpSpec.ServerSearch) { this._runDualServerSearch(pID, tmpSpec, pFilter); return; }
		this._refreshDualAvailable(pID);
	}

	/** Debounced (250ms) server search for a ServerSearch dual-list; stale-token guarded; repaints the Available pane. */
	_runDualServerSearch(pID, pSpec, pFilter)
	{
		if (!this._serverResults) { this._serverResults = {}; }
		if (!this._dualSearchTimers) { this._dualSearchTimers = {}; }
		if (!this._dualSearchTokens) { this._dualSearchTokens = {}; }
		if (!this._dualSearching) { this._dualSearching = {}; }
		if (this._dualSearchTimers[pID]) { clearTimeout(this._dualSearchTimers[pID]); }
		const tmpTerm = String(pFilter == null ? '' : pFilter).trim();
		if (!tmpTerm)
		{
			this._serverResults[pID] = [];
			this._dualSearching[pID] = false;
			this._refreshDualAvailable(pID);
			return;
		}
		this._dualSearchTimers[pID] = setTimeout(() =>
		{
			this._dualSearchTimers[pID] = null;
			const tmpToken = (this._dualSearchTokens[pID] = (this._dualSearchTokens[pID] || 0) + 1);
			this._dualSearching[pID] = true;
			this._refreshDualAvailable(pID);
			Promise.resolve(pSpec.ServerSearch.Search(tmpTerm)).then((pResults) =>
			{
				if (tmpToken !== this._dualSearchTokens[pID]) { return; }   // superseded by a newer keystroke
				this._serverResults[pID] = Array.isArray(pResults) ? pResults : [];
				this._dualSearching[pID] = false;
				this._refreshDualAvailable(pID);
			}).catch(() =>
			{
				if (tmpToken !== this._dualSearchTokens[pID]) { return; }
				this._serverResults[pID] = [];
				this._dualSearching[pID] = false;
				this._refreshDualAvailable(pID);
			});
		}, 250);
	}

	/** Repaint just the Available pane + its count (leaves the filter input alone so typing keeps focus). */
	_refreshDualAvailable(pID)
	{
		const tmpSpec = this.dualLists[pID];
		const tmpAvailable = document.getElementById(`emne-dualavail-${pID}`);
		if (tmpAvailable) { tmpAvailable.innerHTML = this._dualAvailableHTML(pID, tmpSpec); }
		const tmpAvailableCount = document.getElementById(`emne-dualavailcount-${pID}`);
		if (tmpAvailableCount) { tmpAvailableCount.textContent = String(this._dualAvailableMatches(pID, tmpSpec).length); }
	}

	onDualAdd(pID, pValue)
	{
		const tmpSpec = this.dualLists[pID];
		const tmpValue = this._dualCoerce(pID, pValue);
		const tmpSelected = tmpSpec.Read().slice();
		if (!tmpSelected.some((pEntry) => String(pEntry) === String(tmpValue))) { tmpSelected.push(tmpValue); }
		tmpSpec.Write(tmpSelected);
		this._afterDualChange(pID);
	}

	onDualRemove(pID, pValue)
	{
		const tmpSpec = this.dualLists[pID];
		tmpSpec.Write(tmpSpec.Read().filter((pEntry) => String(pEntry) !== String(pValue)));
		this._afterDualChange(pID);
	}

	/** Add every option currently matching the filter — the bulk path for "all projects in a district". */
	onDualAddAll(pID)
	{
		const tmpSpec = this.dualLists[pID];
		if (tmpSpec.ServerSearch)
		{
			// Server-side sweep of the WHOLE current filter (not just the rendered page). With no filter there's
			// nothing meaningful to bulk-add (leave the selection empty to mean "all"), so this is a no-op.
			const tmpTerm = String((this._dualFilters || {})[pID] || '').trim();
			if (!tmpTerm) { return; }
			Promise.resolve(tmpSpec.ServerSearch.SearchAll(tmpTerm)).then((pResults) =>
			{
				const tmpSelected = tmpSpec.Read().slice();
				const tmpSeen = {};
				tmpSelected.forEach((pValue) => { tmpSeen[String(pValue)] = true; });
				(Array.isArray(pResults) ? pResults : []).forEach((pOption) => { if (!tmpSeen[String(pOption.Value)]) { tmpSeen[String(pOption.Value)] = true; tmpSelected.push(pOption.Value); } });
				tmpSpec.Write(tmpSelected);
				this._afterDualChange(pID);
			});
			return;
		}
		const tmpSelected = tmpSpec.Read().slice();
		this._dualAvailableMatches(pID, tmpSpec).forEach((pOption) => tmpSelected.push(pOption.Value));
		tmpSpec.Write(tmpSelected);
		this._afterDualChange(pID);
	}

	/** Remove what the Selected pane is showing — everything, unless its filter has narrowed the list. */
	onDualClear(pID)
	{
		const tmpSpec = this.dualLists[pID];
		const tmpRemoving = {};
		this._dualSelectedMatches(pID, tmpSpec).forEach((pValue) => { tmpRemoving[String(pValue)] = true; });
		tmpSpec.Write(tmpSpec.Read().filter((pValue) => !tmpRemoving[String(pValue)]));
		this._afterDualChange(pID);
	}

	_afterDualChange(pID)
	{
		this.provider._markRuleDirty();
		this._refreshDualPanes(pID);
		this._renderActions();
	}

	// --- Schedule section ---------------------------------------------------------------------------

	_scheduleHTML(pRule, pEditor)
	{
		const tmpDisabled = pEditor.Editable ? '' : 'disabled';
		const tmpType = pRule.ScheduleType || 'Weekly';
		const tmpTypeOptions = [ 'Daily', 'Weekly', 'Monthly' ].map((pType) => `<option value="${pType}" ${pType === tmpType ? 'selected' : ''}>${pType}</option>`).join('');
		let tmpHours = '';
		for (let i = 0; i < 24; i++) { tmpHours += `<option value="${i}" ${Number(pRule.ScheduleHour) === i ? 'selected' : ''}>${('0' + i).slice(-2)}:00 UTC</option>`; }
		let tmpDays = '';
		if (tmpType === 'Daily')
		{
			tmpDays = `<p class="emne-help">Sends every day at the chosen hour.</p>`;
		}
		else
		{
			const tmpSelected = pRule.ScheduleDays || [];
			// Each box's id is the value SetSchedule stores, as services/email/source/emailSources/scheduledRules.js matches it: weekdays 0-6 from Sunday, days of the month 1-31.
			const tmpFirst = (tmpType === 'Monthly') ? 1 : 0;
			const tmpLast = (tmpType === 'Monthly') ? 31 : 6;
			let tmpBoxes = '';
			for (let i = tmpFirst; i <= tmpLast; i++)
			{
				const tmpLabel = (tmpType === 'Monthly') ? String(i) : WEEKDAY_LABELS[i];
				tmpBoxes += `<label class="emne-day"><input type="checkbox" id="emne-sched-day-${i}" ${tmpSelected.indexOf(i) > -1 ? 'checked' : ''} ${tmpDisabled} onchange="_Pict.views.EmailNotificationsEditor.onDynamicChanged()"> ${tmpLabel}</label>`;
			}
			tmpDays = `<div class="emne-days" id="emne-sched-days" data-emne-sched-type="${tmpType}">${tmpBoxes}</div>`;
		}
		return `
			<div class="emne-divider"></div>
			<div class="emne-section-title"><span class="icon is-small"><i class="fas fa-clock"></i></span> Schedule</div>
			<div class="emne-field">
				<label class="emne-label">Frequency</label>
				<div class="select is-fullwidth"><select id="emne-sched-type" ${tmpDisabled} onchange="_Pict.views.EmailNotificationsEditor.onScheduleTypeChanged()">${tmpTypeOptions}</select></div>
			</div>
			<div class="emne-field">
				<label class="emne-label">Hour of day</label>
				<div class="select is-fullwidth"><select id="emne-sched-hour" ${tmpDisabled} onchange="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">${tmpHours}</select></div>
			</div>
			<div class="emne-field"><label class="emne-label">${tmpType === 'Monthly' ? 'Days of month' : (tmpType === 'Weekly' ? 'Days of week' : 'Days')}</label>${tmpDays}</div>`;
	}

	_captureScheduleFromDOM()
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule || !document.getElementById('emne-sched-type')) { return; }
		tmpRule.ScheduleType = document.getElementById('emne-sched-type').value;
		if (document.getElementById('emne-sched-hour')) { tmpRule.ScheduleHour = Number(document.getElementById('emne-sched-hour').value) || 0; }
		const tmpDays = [];
		// Straight after a frequency change the boxes on screen are still the old frequency's, and _renderDynamic captures again before replacing them; their ticks don't carry over.
		const tmpDaysElement = document.getElementById('emne-sched-days');
		const tmpBoxes = (tmpDaysElement && (tmpDaysElement.getAttribute('data-emne-sched-type') === tmpRule.ScheduleType)) ? tmpDaysElement.querySelectorAll('[id^="emne-sched-day-"]') : [];
		Array.prototype.forEach.call(tmpBoxes, (pBox) =>
		{
			if (pBox.checked) { tmpDays.push(parseInt(pBox.id.replace('emne-sched-day-', ''), 10)); }
		});
		tmpRule.ScheduleDays = tmpDays;
	}

	onScheduleTypeChanged()
	{
		this._captureScheduleFromDOM();
		this.provider._markRuleDirty();
		this._renderDynamic(); // the day controls change with the frequency
		this._renderActions();
	}

	// --- Config (custom content) section ------------------------------------------------------------
	//
	// Overrides are PER KEY. Every field the handler declares is listed with a "Customize" switch: off shows
	// the handler's built-in default (read only) and stores nothing, on seeds an editable copy and writes just
	// that key to the Configuration blob. Each field renders a TYPED editor picked by the field-schema module
	// — recipient rows, filter pairs, role checkboxes, tag chips, routing rows — instead of a JSON textarea.

	_configHTML(pRule, pEditor)
	{
		const tmpMeta = (this.provider.state.Handlers || {})[pRule.Handler] || {};
		const tmpHasDefaults = tmpMeta.defaultConfiguration && Object.keys(tmpMeta.defaultConfiguration).length > 0;
		let tmpHTML = `
			<div class="emne-divider"></div>
			<div class="emne-section-title"><span class="icon is-small"><i class="fas fa-envelope-open-text"></i></span> Email content</div>`;
		if (!tmpHasDefaults)
		{
			return tmpHTML + `<p class="emne-help">This email type has no editable content.</p>`;
		}
		tmpHTML += `<p class="emne-help mb-4">Each setting below runs on this email type's built-in default until you switch it to <strong>Customize</strong>. Only the settings you customize are stored on this rule.</p>`;

		this._activeBodyFields = [];
		const tmpDescriptors = this.provider.configFieldDescriptors(pRule.Handler, pRule.ConfigValue || {});
		tmpDescriptors.forEach((pField) =>
		{
			tmpHTML += `<div class="emne-cfgfield" id="emne-fld-${libConfigFieldSchema.fieldSlug(pField.Key)}">${this._configFieldInnerHTML(pField, pEditor)}</div>`;
		});
		return tmpHTML;
	}

	/** Re-render one config field in place (used by the add/remove/kind-change handlers). */
	_renderConfigField(pKey)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pKey);
		if (!this.pict.ContentAssignment.getElement(`#emne-fld-${tmpSlug}`)) { return; }
		const tmpEditor = this.provider.editorState;
		const tmpRule = tmpEditor.Rule;
		const tmpField = this.provider.configFieldDescriptors(tmpRule.Handler, tmpRule.ConfigValue || {}).find((pField) => pField.Key === pKey);
		if (!tmpField) { return; }
		// This field's body editor (if any) is about to be destroyed — drop it from the active list first so a
		// later capture doesn't marshal a stale, unmounted editor over the value we just wrote.
		this._activeBodyFields = (this._activeBodyFields || []).filter((pActive) => pActive !== pKey);
		this.pict.ContentAssignment.assignContent(`#emne-fld-${tmpSlug}`, this._configFieldInnerHTML(tmpField, tmpEditor));
		this._mountBodyEditorForKey(pKey);
		this.pict.CSSMap.injectCSS();
	}

	/** The head (label + Customize switch + docs) and body (default preview, or the typed editor) of one field. */
	_configFieldInnerHTML(pField, pEditor)
	{
		const tmpDisabled = pEditor.Editable ? '' : 'disabled';
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpDoc = pField.Doc ? `<p class="emne-help">${this._esc(pField.Doc)}</p>` : '';
		const tmpUnknown = pField.KnownField ? '' : `<span class="emne-badge emne-badge-warn" title="This setting is stored on the rule but this email type no longer declares it.">unrecognized</span>`;
		const tmpSwitch = `<label class="emne-override"><input type="checkbox" id="emne-ovr-${tmpSlug}" ${pField.Overridden ? 'checked' : ''} ${tmpDisabled} onchange="_Pict.views.EmailNotificationsEditor.onOverrideToggle('${this._attr(pField.Key)}', this.checked)"> Customize</label>`;
		const tmpHead = `<div class="emne-cfghead"><label class="emne-label">${this._esc(this._fieldLabel(pField.Key))}</label>${tmpUnknown}<span class="emne-spacer"></span>${tmpSwitch}</div>`;
		const tmpBody = pField.Overridden ? this._configEditorHTML(pField, tmpDisabled) : this._defaultPreviewHTML(pField);
		return `${tmpHead}${tmpDoc}<div class="emne-cfgbody">${tmpBody}</div>`;
	}

	/** Field keys are CamelCase identifiers from the handler; space them out for the label. */
	_fieldLabel(pKey)
	{
		return String(pKey).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^HTML /, 'HTML ');
	}

	/** What "use the built-in default" means for this field, shown read-only while the switch is off. */
	_defaultPreviewHTML(pField)
	{
		const tmpValue = pField.Default;
		if (tmpValue === undefined) { return `<p class="emne-default emne-default-empty">Not set.</p>`; }
		if (typeof tmpValue === 'boolean') { return `<p class="emne-default">${tmpValue ? 'Yes' : 'No'}</p>`; }
		if (Array.isArray(tmpValue))
		{
			if (!tmpValue.length) { return `<p class="emne-default emne-default-empty">Empty — no restriction.</p>`; }
			return `<ul class="emne-default emne-default-list">${tmpValue.map((pEntry) => `<li>${this._esc(typeof pEntry === 'object' ? JSON.stringify(pEntry) : pEntry)}</li>`).join('')}</ul>`;
		}
		if (tmpValue && typeof tmpValue === 'object')
		{
			const tmpKeys = Object.keys(tmpValue);
			if (!tmpKeys.length) { return `<p class="emne-default emne-default-empty">Empty.</p>`; }
			return `<pre class="emne-default emne-default-pre">${this._esc(JSON.stringify(tmpValue, null, 2))}</pre>`;
		}
		const tmpString = String(tmpValue);
		if (!tmpString.trim()) { return `<p class="emne-default emne-default-empty">Empty.</p>`; }
		if (tmpString.indexOf('\n') > -1)
		{
			return `<details class="emne-default emne-default-details"><summary>Show the default template</summary><pre class="emne-default-pre">${this._esc(tmpString.trim())}</pre></details>`;
		}
		return `<p class="emne-default emne-default-pre">${this._esc(tmpString)}</p>`;
	}

	/** Dispatch to the typed editor for an overridden field. */
	_configEditorHTML(pField, pDisabled)
	{
		switch (pField.Editor)
		{
			case 'recipients':      return this._recipientsHTML(pField, pDisabled);
			case 'documentfilters': return this._documentFiltersHTML(pField, pDisabled);
			case 'roles':           return this._rolesHTML(pField, pDisabled);
			case 'tags':            return this._tagsHTML(pField, pDisabled);
			case 'emaillist':       return this._emailListHTML(pField, pDisabled);
			case 'sendmap':         return this._sendMapHTML(pField, pDisabled);
			case 'template':        return this._templateHTML(pField, pDisabled);
			case 'body':            return this._bodyHTML(pField, pDisabled);
			case 'checkbox':        return this._checkboxHTML(pField, pDisabled);
			case 'json':            return this._jsonHTML(pField, pDisabled);
			default:                return this._textHTML(pField, pDisabled);
		}
	}

	// --- Typed editors ------------------------------------------------------------------------------

	/**
	 * Recipients: one row per recipient, each row choosing a KIND. The stored value is a handlebars template
	 * string, so the row kinds are a readable front-end for the three shapes that actually occur in practice
	 * (a literal address, the handler's `ProjectRole:<level>` expansion, and a document-person token) plus a
	 * free-text escape hatch for anything else.
	 */
	_recipientsHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpRows = libConfigFieldSchema.parseRecipients(pField.Value);
		let tmpHTML = `<div class="emne-rows" id="emne-rows-${tmpSlug}">`;
		tmpRows.forEach((pRow, pIndex) => { tmpHTML += this._recipientRowHTML(pField.Key, tmpSlug, pRow, pIndex, pDisabled); });
		tmpHTML += `</div>`;
		if (!tmpRows.length) { tmpHTML += `<p class="emne-help emne-warn">No recipients — this rule will not send to anyone.</p>`; }
		tmpHTML += this._addRowButtonHTML(pField.Key, 'Add recipient', pDisabled);
		return tmpHTML;
	}

	_recipientRowHTML(pKey, pSlug, pRow, pIndex, pDisabled)
	{
		const tmpKinds =
		[
			{ Value: 'email', Label: 'Email address' },
			{ Value: 'role', Label: 'Project role' },
			{ Value: 'token', Label: 'Person on the document' },
			{ Value: 'template', Label: 'Custom template' },
		];
		const tmpKindSelect = `<div class="select is-small"><select class="emne-rk" ${pDisabled} onchange="_Pict.views.EmailNotificationsEditor.onRecipientKindChanged('${this._attr(pKey)}', ${pIndex}, this.value)">`
			+ tmpKinds.map((pKind) => `<option value="${pKind.Value}" ${pKind.Value === pRow.Kind ? 'selected' : ''}>${pKind.Label}</option>`).join('')
			+ `</select></div>`;
		let tmpValueControl = '';
		if (pRow.Kind === 'role')
		{
			const tmpOptions = this.provider.permissionLevelOptions.slice();
			// A level that no role uses any more must still be selectable, or opening the rule would silently
			// rewrite the recipient to whatever happened to be first in the list.
			if (pRow.Value && !tmpOptions.some((pOption) => pOption.PermissionLevel === pRow.Value))
			{
				tmpOptions.unshift({ PermissionLevel: pRow.Value, Label: `${pRow.Value} (no matching role)` });
			}
			tmpValueControl = `<div class="select is-small is-fullwidth"><select class="emne-rv" ${pDisabled} onchange="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
				+ (tmpOptions.length ? '' : `<option value="">No roles found</option>`)
				+ tmpOptions.map((pOption) => `<option value="${this._esc(pOption.PermissionLevel)}" ${pOption.PermissionLevel === pRow.Value ? 'selected' : ''}>${this._esc(pOption.Label)}</option>`).join('')
				+ `</select></div>`;
		}
		else if (pRow.Kind === 'token')
		{
			tmpValueControl = `<div class="select is-small is-fullwidth"><select class="emne-rv" ${pDisabled} onchange="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
				+ libConfigFieldSchema.RECIPIENT_TOKENS.map((pToken) => `<option value="${this._esc(pToken.Value)}" ${pToken.Value === pRow.Value ? 'selected' : ''}>${this._esc(pToken.Label)}</option>`).join('')
				+ `</select></div>`;
		}
		else
		{
			const tmpPlaceholder = (pRow.Kind === 'email') ? 'name@example.com' : '{{Project.Email}}';
			tmpValueControl = `<input type="text" class="input is-small emne-rv" value="${this._esc(pRow.Value)}" placeholder="${tmpPlaceholder}" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`;
		}
		const tmpWarn = (pRow.Kind === 'email' && pRow.Value && !libConfigFieldSchema.looksLikeEmail(pRow.Value))
			? `<span class="emne-rowwarn" title="This does not look like an email address."><i class="fas fa-triangle-exclamation"></i></span>` : '';
		return `<div class="emne-row" data-emne-row="${pSlug}">${tmpKindSelect}<span class="emne-rowvalue">${tmpValueControl}</span>${tmpWarn}${this._removeRowButtonHTML(pKey, pIndex, pDisabled)}</div>`;
	}

	/** FilterDocuments: `[field, value]` pairs, edited as two columns. */
	_documentFiltersHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpRows = libConfigFieldSchema.parseDocumentFilters(pField.Value);
		let tmpHTML = `<datalist id="emne-dl-${tmpSlug}">`
			+ libConfigFieldSchema.DOCUMENT_FILTER_FIELDS.map((pName) => `<option value="${this._esc(pName)}"></option>`).join('')
			+ `</datalist><div class="emne-rows" id="emne-rows-${tmpSlug}">`;
		tmpRows.forEach((pRow, pIndex) =>
		{
			tmpHTML += `<div class="emne-row" data-emne-row="${tmpSlug}">`
				+ `<input type="text" class="input is-small emne-ff" list="emne-dl-${tmpSlug}" value="${this._esc(pRow.Field)}" placeholder="Field" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
				+ `<span class="emne-rowop">is</span>`
				+ `<input type="text" class="input is-small emne-fv" value="${this._esc(pRow.Value)}" placeholder="Value" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
				+ `${this._removeRowButtonHTML(pField.Key, pIndex, pDisabled)}</div>`;
		});
		tmpHTML += `</div>`;
		if (!tmpRows.length) { tmpHTML += `<p class="emne-help">No filters — every document this rule matches is included.</p>`; }
		tmpHTML += this._addRowButtonHTML(pField.Key, 'Add filter', pDisabled);
		return tmpHTML;
	}

	/**
	 * UsersWithRole: a checkbox per PermissionLevel. Entries stored as numeric IDRoles are shown as their own
	 * checked rows so they survive a round-trip — rewriting them to permission levels would change who matches.
	 */
	_rolesHTML(pField, pDisabled)
	{
		const tmpSelected = libConfigFieldSchema.parseRoleList(pField.Value);
		const tmpOptions = this.provider.permissionLevelOptions.map((pOption) => ({ Value: pOption.PermissionLevel, Label: pOption.Label, Numeric: false }));
		tmpSelected.forEach((pEntry) =>
		{
			const tmpNumeric = (typeof pEntry === 'number') || /^\d+$/.test(String(pEntry));
			if (!tmpOptions.some((pOption) => String(pOption.Value) === String(pEntry)))
			{
				tmpOptions.push({ Value: pEntry, Label: this.provider.roleEntryLabel(pEntry), Numeric: tmpNumeric });
			}
		});
		if (!tmpOptions.length) { return `<p class="emne-help">No roles found for this customer.</p>`; }
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		// Selected levels sort to the top so a choice is never lost below the fold in a long list.
		tmpOptions.sort((pA, pB) =>
		{
			const tmpASelected = tmpSelected.some((pEntry) => String(pEntry) === String(pA.Value)) ? 0 : 1;
			const tmpBSelected = tmpSelected.some((pEntry) => String(pEntry) === String(pB.Value)) ? 0 : 1;
			return (tmpASelected - tmpBSelected) || String(pA.Label).localeCompare(String(pB.Label));
		});
		const tmpBoxes = tmpOptions.map((pOption) =>
		{
			const tmpChecked = tmpSelected.some((pEntry) => String(pEntry) === String(pOption.Value)) ? 'checked' : '';
			return `<label class="emne-checkitem" data-filter="${this._esc(String(pOption.Label).toLowerCase())} ${this._esc(String(pOption.Value).toLowerCase())}"><input type="checkbox" class="emne-role" data-emne-roleval="${this._esc(pOption.Value)}" data-emne-rolenum="${pOption.Numeric ? '1' : '0'}" ${tmpChecked} ${pDisabled} onchange="_Pict.views.EmailNotificationsEditor.onDynamicChanged()"> ${this._esc(pOption.Label)}</label>`;
		}).join('');
		const tmpNote = tmpSelected.length ? '' : `<p class="emne-help">Nothing selected — <strong>any</strong> role matches.</p>`;
		// A customer can have well over a hundred permission levels, so the list gets an in-place filter over
		// the already-rendered rows (no refetch, and the checkbox state of a hidden row is still captured).
		const tmpFilter = (tmpOptions.length > 12)
			? `<input type="text" class="input is-small emne-checkfilter" placeholder="Filter ${tmpOptions.length} roles…" oninput="_Pict.views.EmailNotificationsEditor.onFilterCheckList('${tmpSlug}', this.value)">` : '';
		return `${tmpFilter}<div class="emne-checklist" id="emne-checklist-${tmpSlug}">${tmpBoxes}</div><p class="emne-help emne-nomatch" id="emne-nomatch-${tmpSlug}" style="display:none;">No roles match that filter.</p>${tmpNote}`;
	}

	/** Actor tags: chips, with suggestions harvested from the customer's approval workflows. */
	_tagsHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpTags = libConfigFieldSchema.parseTagList(pField.Value);
		const tmpSuggestions = ((this.provider.state.Lookups || {}).ActorTags || []).filter((pTag) => tmpTags.indexOf(pTag) < 0);
		const tmpChips = tmpTags.map((pTag, pIndex) => this._chipHTML(pField.Key, pTag, pIndex, pDisabled)).join('');
		const tmpNote = tmpTags.length ? '' : `<p class="emne-help">No tags — this check is skipped.</p>`;
		return `<div class="emne-chips">${tmpChips}</div>${tmpNote}`
			+ `<datalist id="emne-dl-${tmpSlug}">${tmpSuggestions.map((pTag) => `<option value="${this._esc(pTag)}"></option>`).join('')}</datalist>`
			+ this._chipInputHTML(pField.Key, tmpSlug, 'Add a tag', pDisabled);
	}

	/** CC / BCC / SendRestTo: comma-separated email strings, edited as chips. */
	_emailListHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpChipValues = libConfigFieldSchema.parseEmailList(pField.Value);
		const tmpChips = tmpChipValues.map((pEmail, pIndex) => this._chipHTML(pField.Key, pEmail, pIndex, pDisabled, !libConfigFieldSchema.looksLikeEmail(pEmail))).join('');
		const tmpNote = tmpChipValues.length ? '' : `<p class="emne-help">Empty — nobody is added.</p>`;
		return `<div class="emne-chips">${tmpChips}</div>${tmpNote}` + this._chipInputHTML(pField.Key, tmpSlug, 'name@example.com', pDisabled);
	}

	/** ApprovalRollup's SendTo: a routing map from a BasedOn result to a literal address list. */
	_sendMapHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpRows = libConfigFieldSchema.parseSendMap(pField.Value);
		let tmpHTML = `<div class="emne-rows" id="emne-rows-${tmpSlug}">`;
		tmpRows.forEach((pRow, pIndex) =>
		{
			tmpHTML += `<div class="emne-row emne-row-map" data-emne-row="${tmpSlug}">`
				+ `<input type="text" class="input is-small emne-mk" value="${this._esc(pRow.Key)}" placeholder="Grouping value" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
				+ `<span class="emne-rowop">&rarr;</span>`
				+ `<input type="text" class="input is-small emne-mv" value="${this._esc(pRow.Value)}" placeholder="a@example.com, b@example.com" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
				+ `${this._removeRowButtonHTML(pField.Key, pIndex, pDisabled)}</div>`;
		});
		tmpHTML += `</div>`;
		if (!tmpRows.length) { tmpHTML += `<p class="emne-help">No routes — everything falls through to <strong>Send Rest To</strong>.</p>`; }
		tmpHTML += this._addRowButtonHTML(pField.Key, 'Add route', pDisabled);
		return tmpHTML;
	}

	/** A single-line handlebars template, with a variable inserter built from the handler's own docs. */
	_templateHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpVariables = this._templateVariables();
		const tmpInsert = (tmpVariables.length && !pDisabled)
			? `<div class="select is-small"><select class="emne-insert" onchange="_Pict.views.EmailNotificationsEditor.onInsertVariable('${this._attr(pField.Key)}', this)">`
				+ `<option value="">Insert variable…</option>`
				+ tmpVariables.map((pVariable) => `<option value="${this._esc(pVariable)}">${this._esc(pVariable)}</option>`).join('')
				+ `</select></div>` : '';
		return `<div class="emne-inline">`
			+ `<input type="text" class="input emne-cfg" id="emne-cfg-${tmpSlug}" value="${this._esc(pField.Value == null ? '' : pField.Value)}" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`
			+ `${tmpInsert}</div>`;
	}

	/** The handlebars entities a handler documents, scraped from its `docs` string ("  {{Project}}" lines). */
	_templateVariables()
	{
		const tmpRule = this.provider.editorState.Rule;
		const tmpMeta = (this.provider.state.Handlers || {})[tmpRule.Handler] || {};
		const tmpDocs = String(tmpMeta.docs || '');
		const tmpFound = [];
		const tmpMatcher = /^\s+(\{\{[A-Za-z0-9_.]+\}\})/gm;
		let tmpMatch = tmpMatcher.exec(tmpDocs);
		while (tmpMatch)
		{
			if (tmpFound.indexOf(tmpMatch[1]) < 0) { tmpFound.push(tmpMatch[1]); }
			tmpMatch = tmpMatcher.exec(tmpDocs);
		}
		return tmpFound;
	}

	_checkboxHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		return `<label class="emne-enable-row"><input type="checkbox" class="emne-cfg" id="emne-cfg-${tmpSlug}" ${pField.Value ? 'checked' : ''} ${pDisabled} onchange="_Pict.views.EmailNotificationsEditor.onDynamicChanged()"> Yes</label>`;
	}

	_textHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		return `<input type="text" class="input emne-cfg" id="emne-cfg-${tmpSlug}" value="${this._esc(pField.Value == null ? '' : pField.Value)}" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">`;
	}

	/**
	 * The escape hatch: any array/object shape the field schema does not model. Invalid JSON is reported and
	 * BLOCKS the save — silently keeping the raw text would store a string where the handler expects a
	 * structure, and the rule would fail at send time with no sign of it here.
	 */
	_jsonHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		const tmpJSON = (typeof pField.Value === 'string') ? pField.Value : JSON.stringify(pField.Value == null ? '' : pField.Value, null, 2);
		return `<textarea class="textarea emne-json emne-cfg" id="emne-cfg-${tmpSlug}" rows="5" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">${this._esc(tmpJSON)}</textarea>`
			+ `<p class="emne-help">JSON value.</p><p class="emne-fielderror" id="emne-err-${tmpSlug}"></p>`;
	}

	/** Message bodies: a plain code editor — these are handlebars/HTML templates, not markdown. */
	_bodyHTML(pField, pDisabled)
	{
		const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
		if (this._codeEditorAvailable())
		{
			this._activeBodyFields.push(pField.Key);
			return `<div id="EmailBody-${tmpSlug}" class="emne-code"></div>`;
		}
		return `<textarea class="textarea emne-code-fallback emne-cfg" id="emne-cfg-${tmpSlug}" rows="12" ${pDisabled} oninput="_Pict.views.EmailNotificationsEditor.onDynamicChanged()">${this._esc(pField.Value == null ? '' : pField.Value)}</textarea>`;
	}

	// --- Shared row / chip chrome -------------------------------------------------------------------

	_addRowButtonHTML(pKey, pLabel, pDisabled)
	{
		if (pDisabled) { return ''; }
		return `<button type="button" class="button is-small is-light emne-rowadd" onclick="_Pict.views.EmailNotificationsEditor.onAddRow('${this._attr(pKey)}')"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>${this._esc(pLabel)}</span></button>`;
	}

	_removeRowButtonHTML(pKey, pIndex, pDisabled)
	{
		if (pDisabled) { return ''; }
		return `<button type="button" class="emne-rowdel" title="Remove" onclick="_Pict.views.EmailNotificationsEditor.onRemoveRow('${this._attr(pKey)}', ${pIndex})"><i class="fas fa-xmark"></i></button>`;
	}

	_chipHTML(pKey, pValue, pIndex, pDisabled, pWarn)
	{
		const tmpRemove = pDisabled ? '' : `<button type="button" class="emne-chipdel" title="Remove" onclick="_Pict.views.EmailNotificationsEditor.onRemoveRow('${this._attr(pKey)}', ${pIndex})"><i class="fas fa-xmark"></i></button>`;
		return `<span class="emne-chip ${pWarn ? 'emne-chip-warn' : ''}" ${pWarn ? 'title="This does not look like an email address."' : ''}>${this._esc(pValue)}${tmpRemove}</span>`;
	}

	_chipInputHTML(pKey, pSlug, pPlaceholder, pDisabled)
	{
		if (pDisabled) { return ''; }
		return `<div class="emne-chipadd">`
			+ `<input type="text" class="input is-small" id="emne-chipin-${pSlug}" list="emne-dl-${pSlug}" placeholder="${this._esc(pPlaceholder)}" onkeydown="_Pict.views.EmailNotificationsEditor.onChipKeyDown(event, '${this._attr(pKey)}')">`
			+ `<button type="button" class="button is-small is-light" onclick="_Pict.views.EmailNotificationsEditor.onAddChip('${this._attr(pKey)}')">Add</button></div>`;
	}

	// --- Config field events ------------------------------------------------------------------------

	/** The per-key Customize switch. */
	onOverrideToggle(pKey, pChecked)
	{
		this._captureDynamic();
		this.provider.setFieldOverride(pKey, !!pChecked);
		this._renderConfigField(pKey);
		this._renderActions();
	}

	/** Changing a recipient row's kind rebuilds that row's value control, so re-render the whole field. */
	onRecipientKindChanged(pKey, pIndex, pKind)
	{
		this._captureDynamic();
		const tmpRows = libConfigFieldSchema.parseRecipients(this._fieldValue(pKey));
		if (!tmpRows[pIndex]) { return; }
		// The old value rarely means anything in the new kind (an address is not a role), so start it on the
		// new kind's first option — except between the two free-text kinds, where keeping it is what the admin
		// expects. Rows are written through unfiltered so the row being edited survives even while it is blank.
		const tmpKeepValue = ((tmpRows[pIndex].Kind === 'email') && (pKind === 'template')) || ((tmpRows[pIndex].Kind === 'template') && (pKind === 'email'));
		tmpRows[pIndex] = { Kind: pKind, Value: tmpKeepValue ? tmpRows[pIndex].Value : this._defaultRowValue(pKind) };
		this._setFieldValue(pKey, tmpRows.map((pRow) => libConfigFieldSchema.serializeRecipient(pRow)));
		this.provider._markRuleDirty();
		this._renderConfigField(pKey);
		this._renderActions();
	}

	/** A fresh row of a given kind starts on the first sensible option, so the select is never out of sync. */
	_defaultRowValue(pKind)
	{
		if (pKind === 'role') { return (this.provider.permissionLevelOptions[0] || {}).PermissionLevel || ''; }
		if (pKind === 'token') { return libConfigFieldSchema.RECIPIENT_TOKENS[0].Value; }
		return '';
	}

	onAddRow(pKey)
	{
		this._captureDynamic();
		const tmpField = this._descriptorFor(pKey);
		if (!tmpField) { return; }
		const tmpValue = this._fieldValue(pKey);
		if (tmpField.Editor === 'recipients')
		{
			const tmpRows = libConfigFieldSchema.toArray(tmpValue).slice();
			tmpRows.push('');
			this._setFieldValue(pKey, tmpRows);
		}
		else if (tmpField.Editor === 'documentfilters')
		{
			const tmpRows = libConfigFieldSchema.parseDocumentFilters(tmpValue);
			tmpRows.push({ Field: '', Value: '' });
			// A brand-new blank row would be dropped by serialize, so write the rows through unfiltered.
			this._setFieldValue(pKey, tmpRows.map((pRow) => [ pRow.Field, pRow.Value ]));
		}
		else if (tmpField.Editor === 'sendmap')
		{
			const tmpRows = libConfigFieldSchema.parseSendMap(tmpValue);
			// An object cannot hold a blank key, so the placeholder key is unique-by-index until it's named.
			let tmpIndex = tmpRows.length + 1;
			while (tmpRows.some((pRow) => pRow.Key === `key${tmpIndex}`)) { tmpIndex++; }
			tmpRows.push({ Key: `key${tmpIndex}`, Value: '' });
			this._setFieldValue(pKey, libConfigFieldSchema.serializeSendMap(tmpRows));
		}
		this.provider._markRuleDirty();
		this._renderConfigField(pKey);
		this._renderActions();
	}

	onRemoveRow(pKey, pIndex)
	{
		this._captureDynamic();
		const tmpField = this._descriptorFor(pKey);
		if (!tmpField) { return; }
		const tmpValue = this._fieldValue(pKey);
		if (tmpField.Editor === 'sendmap')
		{
			const tmpRows = libConfigFieldSchema.parseSendMap(tmpValue);
			tmpRows.splice(pIndex, 1);
			this._setFieldValue(pKey, libConfigFieldSchema.serializeSendMap(tmpRows));
		}
		else if (tmpField.Editor === 'emaillist')
		{
			const tmpChips = libConfigFieldSchema.parseEmailList(tmpValue);
			tmpChips.splice(pIndex, 1);
			this._setFieldValue(pKey, libConfigFieldSchema.serializeEmailList(tmpChips));
		}
		else if (tmpField.Editor === 'documentfilters')
		{
			const tmpRows = libConfigFieldSchema.parseDocumentFilters(tmpValue);
			tmpRows.splice(pIndex, 1);
			this._setFieldValue(pKey, tmpRows.map((pRow) => [ pRow.Field, pRow.Value ]));
		}
		else
		{
			const tmpRows = libConfigFieldSchema.toArray(tmpValue).slice();
			tmpRows.splice(pIndex, 1);
			this._setFieldValue(pKey, tmpRows);
		}
		this.provider._markRuleDirty();
		this._renderConfigField(pKey);
		this._renderActions();
	}

	onChipKeyDown(pEvent, pKey)
	{
		if (pEvent && (pEvent.key === 'Enter' || pEvent.key === ','))
		{
			pEvent.preventDefault();
			this.onAddChip(pKey);
		}
	}

	onAddChip(pKey)
	{
		const tmpField = this._descriptorFor(pKey);
		if (!tmpField) { return; }
		const tmpInput = document.getElementById(`emne-chipin-${libConfigFieldSchema.fieldSlug(pKey)}`);
		const tmpEntry = tmpInput ? String(tmpInput.value || '').trim() : '';
		if (!tmpEntry) { return; }
		this._captureDynamic();
		if (tmpField.Editor === 'emaillist')
		{
			const tmpChips = libConfigFieldSchema.parseEmailList(this._fieldValue(pKey));
			// A pasted "a@x.com, b@y.com" should become two chips, not one.
			libConfigFieldSchema.parseEmailList(tmpEntry).forEach((pEntry) => tmpChips.push(pEntry));
			this._setFieldValue(pKey, libConfigFieldSchema.serializeEmailList(tmpChips));
		}
		else
		{
			const tmpTags = libConfigFieldSchema.parseTagList(this._fieldValue(pKey));
			tmpTags.push(tmpEntry);
			this._setFieldValue(pKey, libConfigFieldSchema.parseTagList(tmpTags));
		}
		this.provider._markRuleDirty();
		this._renderConfigField(pKey);
		this._renderActions();
		const tmpFocus = document.getElementById(`emne-chipin-${libConfigFieldSchema.fieldSlug(pKey)}`);
		if (tmpFocus) { tmpFocus.focus(); }
	}

	/**
	 * Filter an already-rendered checkbox list in place. Rows are only hidden, never removed, so a checked
	 * row that scrolls out of the filter is still read back by the capture pass.
	 */
	onFilterCheckList(pSlug, pFilter)
	{
		const tmpList = document.getElementById(`emne-checklist-${pSlug}`);
		if (!tmpList) { return; }
		const tmpNeedle = String(pFilter || '').trim().toLowerCase();
		let tmpVisible = 0;
		Array.prototype.forEach.call(tmpList.querySelectorAll('[data-filter]'), (pRow) =>
		{
			const tmpMatch = !tmpNeedle || (pRow.getAttribute('data-filter').indexOf(tmpNeedle) > -1);
			pRow.style.display = tmpMatch ? '' : 'none';
			if (tmpMatch) { tmpVisible++; }
		});
		const tmpEmpty = document.getElementById(`emne-nomatch-${pSlug}`);
		if (tmpEmpty) { tmpEmpty.style.display = tmpVisible ? 'none' : ''; }
	}

	/** Insert a handlebars variable at the cursor in a single-line template field. */
	onInsertVariable(pKey, pSelect)
	{
		const tmpVariable = pSelect ? pSelect.value : '';
		pSelect.value = '';
		if (!tmpVariable) { return; }
		const tmpInput = document.getElementById(`emne-cfg-${libConfigFieldSchema.fieldSlug(pKey)}`);
		if (!tmpInput) { return; }
		const tmpStart = (tmpInput.selectionStart == null) ? tmpInput.value.length : tmpInput.selectionStart;
		const tmpEnd = (tmpInput.selectionEnd == null) ? tmpInput.value.length : tmpInput.selectionEnd;
		tmpInput.value = tmpInput.value.slice(0, tmpStart) + tmpVariable + tmpInput.value.slice(tmpEnd);
		tmpInput.focus();
		tmpInput.setSelectionRange(tmpStart + tmpVariable.length, tmpStart + tmpVariable.length);
		this.onDynamicChanged();
	}

	// --- Config value plumbing ----------------------------------------------------------------------

	_descriptorFor(pKey)
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule) { return null; }
		return this.provider.configFieldDescriptors(tmpRule.Handler, tmpRule.ConfigValue || {}).find((pField) => pField.Key === pKey) || null;
	}

	_fieldValue(pKey)
	{
		const tmpField = this._descriptorFor(pKey);
		return tmpField ? tmpField.Value : undefined;
	}

	/** Writing always goes to ConfigValue — these helpers only run for fields that are already overridden. */
	_setFieldValue(pKey, pValue)
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule) { return; }
		if (!tmpRule.ConfigValue) { tmpRule.ConfigValue = {}; }
		tmpRule.ConfigValue[pKey] = pValue;
	}

	/** A plain field inside the dynamic region changed (no structural re-render needed). */
	onDynamicChanged()
	{
		this._captureDynamic();
		this.provider._markRuleDirty();
		this._renderActions();
	}

	/** Read schedule + config fields (incl. marshaling the code editors) into the working rule. */
	_captureDynamic()
	{
		this._captureScheduleFromDOM();
		this._captureConfigFromDOM();
	}

	/**
	 * Read every overridden config field out of the DOM. Non-overridden fields are skipped entirely — they
	 * have no controls, and must stay absent from ConfigValue so the handler default keeps applying.
	 */
	_captureConfigFromDOM()
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule || !this.provider.editorState.Editable) { return; }
		if (!document.getElementById('EmailNotifications-Dynamic') && !this.pict.ContentAssignment.getElement('#EmailNotifications-Dynamic')) { return; }
		if (!tmpRule.ConfigValue) { tmpRule.ConfigValue = {}; }
		this._configErrors = {};
		this.provider.configFieldDescriptors(tmpRule.Handler, tmpRule.ConfigValue).forEach((pField) =>
		{
			if (!pField.Overridden) { return; }
			const tmpSlug = libConfigFieldSchema.fieldSlug(pField.Key);
			// The field is not on the page (a different handler is showing) — leave the stored value alone.
			if (!document.getElementById(`emne-fld-${tmpSlug}`)) { return; }
			const tmpCaptured = this._captureConfigField(pField, tmpSlug);
			if (tmpCaptured !== undefined) { tmpRule.ConfigValue[pField.Key] = tmpCaptured; }
		});
	}

	/** Read one overridden field's controls. Returns undefined when the field owns its value outside the DOM. */
	_captureConfigField(pField, pSlug)
	{
		const tmpContainer = document.getElementById(`emne-fld-${pSlug}`);
		switch (pField.Editor)
		{
			case 'recipients':
			{
				const tmpRows = Array.prototype.map.call(tmpContainer.querySelectorAll('.emne-row'), (pRow) =>
				{
					const tmpKind = pRow.querySelector('.emne-rk');
					const tmpValue = pRow.querySelector('.emne-rv');
					return { Kind: tmpKind ? tmpKind.value : 'email', Value: tmpValue ? tmpValue.value : '' };
				});
				return libConfigFieldSchema.serializeRecipients(tmpRows);
			}
			case 'documentfilters':
			{
				const tmpRows = Array.prototype.map.call(tmpContainer.querySelectorAll('.emne-row'), (pRow) =>
				{
					const tmpFieldInput = pRow.querySelector('.emne-ff');
					const tmpValueInput = pRow.querySelector('.emne-fv');
					return { Field: tmpFieldInput ? tmpFieldInput.value : '', Value: tmpValueInput ? tmpValueInput.value : '' };
				});
				return libConfigFieldSchema.serializeDocumentFilters(tmpRows);
			}
			case 'roles':
			{
				const tmpSelected = [];
				Array.prototype.forEach.call(tmpContainer.querySelectorAll('.emne-role'), (pBox) =>
				{
					if (!pBox.checked) { return; }
					const tmpValue = pBox.getAttribute('data-emne-roleval');
					tmpSelected.push((pBox.getAttribute('data-emne-rolenum') === '1') ? Number(tmpValue) : tmpValue);
				});
				return tmpSelected;
			}
			case 'sendmap':
			{
				const tmpRows = Array.prototype.map.call(tmpContainer.querySelectorAll('.emne-row'), (pRow) =>
				{
					const tmpKeyInput = pRow.querySelector('.emne-mk');
					const tmpValueInput = pRow.querySelector('.emne-mv');
					return { Key: tmpKeyInput ? tmpKeyInput.value : '', Value: tmpValueInput ? tmpValueInput.value : '' };
				});
				return libConfigFieldSchema.serializeSendMap(tmpRows);
			}
			// Chips own their value in ConfigValue directly (add/remove re-render the field), so there is
			// nothing to read back off the page.
			case 'tags':
			case 'emaillist':
				return undefined;
			case 'body':
			{
				if (this._activeBodyFields.indexOf(pField.Key) > -1) { return this._captureBodyEditor(pField.Key); }
				const tmpFallback = document.getElementById(`emne-cfg-${pSlug}`);
				return tmpFallback ? tmpFallback.value : undefined;
			}
			case 'checkbox':
			{
				const tmpBox = document.getElementById(`emne-cfg-${pSlug}`);
				return tmpBox ? tmpBox.checked : undefined;
			}
			case 'json':
			{
				const tmpArea = document.getElementById(`emne-cfg-${pSlug}`);
				if (!tmpArea) { return undefined; }
				try
				{
					const tmpParsed = JSON.parse(tmpArea.value);
					this._setFieldError(pSlug, '');
					return tmpParsed;
				}
				catch (pError)
				{
					// Keep the raw text so the admin does not lose their edit, and record the error so save blocks.
					this._configErrors[pField.Key] = `${pField.Key} is not valid JSON.`;
					this._setFieldError(pSlug, 'Not valid JSON — fix this before saving.');
					return tmpArea.value;
				}
			}
			default:
			{
				const tmpInput = document.getElementById(`emne-cfg-${pSlug}`);
				return tmpInput ? tmpInput.value : undefined;
			}
		}
	}

	_setFieldError(pSlug, pMessage)
	{
		const tmpError = document.getElementById(`emne-err-${pSlug}`);
		if (tmpError) { tmpError.textContent = pMessage || ''; }
	}

	// --- Message-body code editors ------------------------------------------------------------------
	//
	// TextMessage / HTMLMessage are handlebars templates (one plaintext, one HTML) — NOT markdown — so they
	// get a plain CodeMirror-6 editor built straight off the vendored bundle (basicSetup only: line numbers,
	// history, bracket matching, no language mode and no rich preview). Without the bundle on the page they
	// fall back to a monospace textarea.

	/** The vendored CodeMirror-6 bundle, or null when it is not on the page. */
	get codeMirrorModules()
	{
		const tmpWindow = /** @type {any} */ ((typeof window === 'undefined') ? null : window);
		const tmpModules = tmpWindow && tmpWindow.CodeMirrorModules;
		return (tmpModules && (typeof tmpModules.EditorView === 'function') && (typeof tmpModules.EditorState === 'function')) ? tmpModules : null;
	}

	_codeEditorAvailable()
	{
		return !!this.codeMirrorModules;
	}

	_mountActiveBodyEditors()
	{
		(this._activeBodyFields || []).slice().forEach((pKey) => this._mountBodyEditor(pKey));
	}

	/** Mount the editor for a single key, if that key is a body field on the current page. */
	_mountBodyEditorForKey(pKey)
	{
		const tmpField = this._descriptorFor(pKey);
		if (!tmpField || !tmpField.Overridden || (tmpField.Editor !== 'body')) { return; }
		if (!this._codeEditorAvailable()) { return; }
		if (this._activeBodyFields.indexOf(pKey) < 0) { this._activeBodyFields.push(pKey); }
		this._mountBodyEditor(pKey);
	}

	_mountBodyEditor(pKey)
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule) { return; }
		const tmpTarget = document.getElementById(`EmailBody-${libConfigFieldSchema.fieldSlug(pKey)}`);
		if (!tmpTarget) { return; }
		const tmpValue = (tmpRule.ConfigValue || {})[pKey];
		try
		{
			const tmpCM = this.codeMirrorModules;
			if (!tmpCM) { return; }
			const tmpExtensions = [ tmpCM.basicSetup ];
			if (!this.provider.editorState.Editable) { tmpExtensions.push(tmpCM.EditorState.readOnly.of(true)); }
			else { tmpExtensions.push(tmpCM.EditorView.updateListener.of((pUpdate) => { if (pUpdate.docChanged) { this.onBodyEditorChanged(); } })); }
			if (!this._bodyEditors) { this._bodyEditors = {}; }
			// Re-mounting after a field re-render: drop the old instance so its DOM and listeners go away.
			if (this._bodyEditors[pKey]) { try { this._bodyEditors[pKey].destroy(); } catch (pError) { /* already gone */ } }
			tmpTarget.innerHTML = '';
			this._bodyEditors[pKey] = new tmpCM.EditorView(
				{
					state: tmpCM.EditorState.create({ doc: (tmpValue == null) ? '' : String(tmpValue), extensions: tmpExtensions }),
					parent: tmpTarget,
				});
		}
		catch (pError)
		{
			this.pict.log.warn(`Email body code editor failed to mount`, { key: pKey, error: String(pError) });
			// Leave the container empty rather than a half-built editor; the value is still in ConfigValue.
			this._activeBodyFields = (this._activeBodyFields || []).filter((pActive) => pActive !== pKey);
		}
	}

	/** A code editor's document changed — mark dirty without a re-render (that would tear the editor down). */
	onBodyEditorChanged()
	{
		this.provider._markRuleDirty();
		this._renderActions();
	}

	_captureBodyEditor(pKey)
	{
		const tmpEditor = (this._bodyEditors || {})[pKey];
		if (!tmpEditor || !tmpEditor.state) { return undefined; }
		return tmpEditor.state.doc.toString();
	}

	/** Tear down every mounted code editor (the whole region is about to be replaced). */
	_destroyBodyEditors()
	{
		Object.keys(this._bodyEditors || {}).forEach((pKey) =>
		{
			try { this._bodyEditors[pKey].destroy(); } catch (pError) { /* already gone */ }
		});
		this._bodyEditors = {};
	}

	/** Capture base fields + dynamic region into the working rule. */
	_captureAll()
	{
		this._captureForm();
		this._captureDynamic();
	}
	// --- Actions / persistence ----------------------------------------------------------------------

	_renderActions()
	{
		if (!this.pict.ContentAssignment.getElement('#EmailNotifications-Editor-Actions')) { return; }
		const tmpEditor = this.provider.editorState;
		const tmpRecord =
		{
			EditSlot: tmpEditor.Editable ? [ {} ] : [],
			ReadOnlySlot: (!tmpEditor.Editable && !tmpEditor.Loading && !tmpEditor.Error) ? [ {} ] : [],
			DirtySlot: (tmpEditor.Editable && tmpEditor.Dirty) ? [ {} ] : [],
		};
		this.pict.ContentAssignment.assignContent('#EmailNotifications-Editor-Actions', this.pict.parseTemplateByHash('EmailNotifications-Editor-Actions-Template', tmpRecord));
	}

	async saveRule()
	{
		this._captureAll();
		// A JSON escape-hatch field that did not parse blocks the save — storing the raw text would put a
		// string where the handler expects a structure, and the rule would fail silently at send time.
		const tmpErrorKeys = Object.keys(this._configErrors || {});
		if (tmpErrorKeys.length)
		{
			this.modal.toast(`Fix ${tmpErrorKeys.length === 1 ? 'this setting' : 'these settings'} before saving: ${tmpErrorKeys.join(', ')}.`, { type: 'warning', duration: 6000 });
			return;
		}
		try
		{
			const tmpResult = await this.provider.saveRuleAsync();
			if (tmpResult && tmpResult.Error) { this.modal.toast(tmpResult.Error, { type: 'warning' }); return; }
			// A partial save (rule written, custom content rejected) stays on the page — navigating away would
			// hide that the content the admin just edited is not what the rule will actually send.
			if (tmpResult && tmpResult.Warning)
			{
				this.modal.toast(tmpResult.Warning, { type: 'warning', duration: 9000 });
				return;
			}
			this.modal.toast('Email rule saved.', { type: 'success' });
			window.location.hash = '#/EmailNotifications';
		}
		catch (pError)
		{
			this.modal.toast(`Save failed: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 6000 });
		}
	}

	cancel()
	{
		window.location.hash = '#/EmailNotifications';
	}

	async deleteRule()
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule || !tmpRule.IDEmailRule) { return; }
		const tmpOk = await this.modal.confirm('Delete this email rule? This cannot be undone.', { title: 'Delete rule', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk) { return; }
		try
		{
			await this.provider.deleteRuleAsync(tmpRule.IDEmailRule);
			this.modal.toast('Email rule deleted.', { type: 'success' });
			window.location.hash = '#/EmailNotifications';
		}
		catch (pError)
		{
			this.modal.toast(`Delete failed: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 6000 });
		}
	}

	async cloneRule()
	{
		const tmpRule = this.provider.editorState.Rule;
		if (!tmpRule || !tmpRule.IDEmailRule) { return; }
		const tmpOk = await this.modal.confirm('Create a copy of this rule? The copy keeps the same targeting; its custom email content resets to the handler default.', { title: 'Clone rule', confirmLabel: 'Clone', cancelLabel: 'Cancel' });
		if (!tmpOk) { return; }
		try
		{
			const tmpNewID = await this.provider.cloneRuleAsync(tmpRule);
			this.modal.toast('Rule cloned.', { type: 'success' });
			window.location.hash = tmpNewID ? `#/EmailRule/${tmpNewID}` : '#/EmailNotifications';
		}
		catch (pError)
		{
			this.modal.toast(`Clone failed: ${pError && pError.message ? pError.message : pError}`, { type: 'error', duration: 6000 });
		}
	}
}

module.exports = EmailNotificationsEditor;

module.exports.default_configuration =
{
	ViewIdentifier: 'EmailNotificationsEditor',
	DefaultRenderable: 'EmailNotificationsEditorWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.emne-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 46rem; }
		.emne-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1rem; }
		.emne-crumbs { font-size: 0.8rem; margin-bottom: 0.2rem; }
		.emne-crumbs a { color: var(--bulma-text-weak, #7a8598); font-weight: 600; text-decoration: none; }
		.emne-crumbs a:hover { color: var(--bulma-link, #156dd1); }
		.emne-title { font-weight: 700; font-size: 1.35rem; display: flex; align-items: center; gap: 0.5rem; }
		.emne-title .icon { color: var(--bulma-link, #156dd1); }
		.emne-actions { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; justify-content: flex-end; }
		.emne-dirty { display: inline-flex; align-items: center; gap: 0.35rem; color: #b8860b; font-size: 0.78rem; font-weight: 600; }
		.emne-dirty .icon { font-size: 0.5rem; }
		.emne-badge { display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.75rem; padding: 0.2rem 0.6rem; border-radius: 999px; background: var(--bulma-scheme-main-bis, #f2f4f8); color: var(--bulma-text-weak, #7a7a7a); border: 1px solid var(--bulma-border, #e6e9ef); }
		.emne-card { border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 12px; background: var(--bulma-scheme-main, #fff); padding: 1.25rem 1.35rem; }
		.emne-field { margin-bottom: 1.1rem; }
		.emne-field:last-child { margin-bottom: 0; }
		.emne-label { display: block; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--bulma-text-weak, #7a8598); margin-bottom: 0.35rem; }
		.emne-help { font-size: 0.75rem; color: var(--bulma-text-weak, #9aa3b2); margin-top: 0.3rem; }
		.emne-handler-desc { font-size: 0.82rem; color: #4a5568; background: var(--bulma-scheme-main-bis, #f6f8fc); border-radius: 8px; padding: 0.5rem 0.7rem; margin-top: 0.4rem; }
		.emne-enable-row { display: flex; align-items: center; gap: 0.5rem; font-weight: 600; color: #22334c; }
		.emne-divider { height: 1px; background: var(--bulma-border, #eef0f4); margin: 1.3rem -1.35rem; }
		.emne-section-title { display: flex; align-items: center; gap: 0.4rem; font-size: 0.9rem; font-weight: 700; color: #22334c; margin-bottom: 0.9rem; }
		.emne-section-title .icon { color: var(--bulma-link, #156dd1); }
		.emne-sched-note { display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.72rem; font-weight: 700; color: #b26a2c; background: #fdf3e0; border-radius: 999px; padding: 0.1rem 0.5rem; margin-left: 0.4rem; }
		.emne-days { display: grid; grid-template-columns: repeat(auto-fill, minmax(4rem, 1fr)); gap: 0.3rem 0.6rem; }
		.emne-day { display: flex; align-items: center; gap: 0.35rem; font-size: 0.82rem; color: #2c3e50; }
		.emne-json { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.8rem; }

		/* --- "Applies to" dual-list pickers --- */
		/* Fixed pane height + a flexing list: both panes end on exactly the same line, whatever they hold. */
		.emne-dual { display: grid; grid-template-columns: 1fr auto 1fr; gap: 0.6rem; align-items: stretch; }
		.emne-dualpane { min-width: 0; height: 17.5rem; display: flex; flex-direction: column; }
		.emne-dualhead { display: flex; align-items: center; gap: 0.35rem; font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--bulma-text-weak, #7a8598); margin-bottom: 0.3rem; }
		.emne-dualcount { font-weight: 600; color: var(--bulma-link, #156dd1); text-transform: none; letter-spacing: 0; }
		.emne-dualfilter { margin-bottom: 0.3rem; }
		.emne-duallist { border: 1px solid var(--bulma-border, #dbe0e8); border-radius: 8px; background: var(--bulma-scheme-main, #fff); flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: 0.2rem; }
		.emne-duallist-selected { background: var(--bulma-scheme-main-bis, #f8fafd); }
		.emne-dualitem { display: flex; align-items: center; gap: 0.35rem; width: 100%; text-align: left; border: none; background: transparent; font-size: 0.8rem; color: #22334c; padding: 0.22rem 0.4rem; border-radius: 5px; cursor: pointer; line-height: 1.25; }
		.emne-dualitem:hover:not([disabled]) { background: #eaf2fd; color: var(--bulma-link, #156dd1); }
		.emne-dualitem[disabled] { cursor: default; opacity: 0.75; }
		.emne-dualitem > span { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.emne-dualitem-selected:hover:not([disabled]) { background: #fdeaec; color: #cc2936; }
		.emne-dualx { opacity: 0; font-size: 0.7rem; }
		.emne-dualitem-selected:hover:not([disabled]) .emne-dualx { opacity: 0.8; }
		.emne-dualunknown { color: #b26a2c; font-size: 0.75rem; }
		.emne-dualempty { font-size: 0.75rem; color: var(--bulma-text-weak, #9aa3b2); padding: 0.4rem 0.45rem; margin: 0; }
		.emne-dualmid { display: flex; flex-direction: column; gap: 0.35rem; justify-content: center; }
		.emne-dualmid .button { white-space: nowrap; }
		@media (max-width: 44rem) { .emne-dual { grid-template-columns: 1fr; } .emne-dualpane { height: 14rem; } .emne-dualmid { flex-direction: row; justify-content: flex-start; } }

		/* --- Per-key config fields --- */
		.emne-cfgfield { border: 1px solid var(--bulma-border, #eef0f4); border-radius: 10px; padding: 0.85rem 0.95rem; margin-bottom: 0.85rem; background: var(--bulma-scheme-main, #fff); }
		.emne-cfghead { display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.15rem; }
		.emne-cfghead .emne-label { margin-bottom: 0; }
		.emne-cfghead .emne-spacer { flex: 1; }
		.emne-override { display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.75rem; font-weight: 600; color: var(--bulma-text-weak, #7a8598); white-space: nowrap; cursor: pointer; }
		.emne-cfgbody { margin-top: 0.55rem; }
		.emne-badge-warn { background: #fdf3e0; color: #b26a2c; border-color: #f0dcb8; }
		.emne-fielderror { color: #cc2936; font-size: 0.75rem; margin-top: 0.25rem; min-height: 0.9rem; }
		.emne-warn { color: #b26a2c; }

		/* --- Default (not-overridden) previews --- */
		.emne-default { font-size: 0.8rem; color: #4a5568; margin: 0; }
		.emne-default-empty { color: var(--bulma-text-weak, #9aa3b2); font-style: italic; }
		.emne-default-pre { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.76rem; background: var(--bulma-scheme-main-bis, #f6f8fc); border-radius: 6px; padding: 0.4rem 0.55rem; white-space: pre-wrap; word-break: break-word; overflow-x: auto; }
		.emne-default-list { margin: 0; padding-left: 1.1rem; list-style: disc; }
		.emne-default-details > summary { cursor: pointer; font-size: 0.78rem; color: var(--bulma-link, #156dd1); }
		.emne-default-details > .emne-default-pre { margin-top: 0.4rem; max-height: 18rem; overflow: auto; }

		/* --- Repeatable rows --- */
		.emne-rows { display: flex; flex-direction: column; gap: 0.4rem; }
		.emne-row { display: flex; align-items: center; gap: 0.4rem; }
		.emne-row .emne-rowvalue { flex: 1; min-width: 0; }
		.emne-row .emne-rowvalue > .select, .emne-row .emne-rowvalue > .select > select { width: 100%; }
		.emne-row .emne-ff, .emne-row .emne-fv, .emne-row .emne-mk, .emne-row .emne-mv { flex: 1; min-width: 0; }
		.emne-row .emne-mv, .emne-row .emne-fv { flex: 2; }
		.emne-rowop { font-size: 0.74rem; color: var(--bulma-text-weak, #9aa3b2); text-transform: uppercase; letter-spacing: 0.04em; }
		.emne-rowdel { border: none; background: transparent; color: var(--bulma-text-weak, #9aa3b2); cursor: pointer; padding: 0.2rem 0.35rem; border-radius: 5px; line-height: 1; }
		.emne-rowdel:hover { color: #cc2936; background: #fdeaec; }
		.emne-rowwarn { color: #b26a2c; font-size: 0.8rem; }
		.emne-rowadd { margin-top: 0.5rem; }

		/* --- Chips --- */
		.emne-chips { display: flex; flex-wrap: wrap; gap: 0.35rem; }
		.emne-chips:not(:empty) { margin-bottom: 0.45rem; }
		.emne-chip { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.78rem; padding: 0.15rem 0.3rem 0.15rem 0.55rem; border-radius: 999px; background: var(--bulma-scheme-main-bis, #f2f4f8); border: 1px solid var(--bulma-border, #e6e9ef); color: #22334c; }
		.emne-chip-warn { background: #fdf3e0; border-color: #f0dcb8; color: #b26a2c; }
		.emne-chipdel { border: none; background: transparent; color: inherit; opacity: 0.55; cursor: pointer; padding: 0 0.15rem; line-height: 1; font-size: 0.7rem; }
		.emne-chipdel:hover { opacity: 1; color: #cc2936; }
		.emne-chipadd { display: flex; gap: 0.4rem; align-items: center; }
		.emne-chipadd .input { flex: 1; }

		/* --- Checkbox lists / inline controls --- */
		.emne-checklist { display: grid; grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr)); gap: 0.25rem 0.75rem; max-height: 16rem; overflow-y: auto; }
		.emne-checkfilter { margin-bottom: 0.45rem; }
		.emne-nomatch { font-style: italic; }
		.emne-checkitem { display: flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; color: #2c3e50; }
		.emne-inline { display: flex; gap: 0.4rem; align-items: center; }
		.emne-inline > .input { flex: 1; }

		/* --- Message-body code editors --- */
		.emne-code { border: 1px solid var(--bulma-border, #dbe0e8); border-radius: 8px; overflow: hidden; }
		.emne-code .cm-editor { max-height: 26rem; font-size: 0.8rem; }
		.emne-code .cm-scroller { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.emne-code-fallback { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.8rem; }
		.emne-footer { display: flex; gap: 0.5rem; margin-top: 1.4rem; align-items: center; }
		.emne-footer .emne-spacer { flex: 1; }
		.emne-overlay { padding: 3rem 1rem; text-align: center; color: var(--bulma-text-weak, #7a7a7a); }
		.emne-spinner { display: inline-block; width: 1.8rem; height: 1.8rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: emne-spin 0.8s linear infinite; }
		@keyframes emne-spin { to { transform: rotate(360deg); } }
	`,

	Templates:
	[
		{
			Hash: 'EmailNotifications-Editor-Wrap',
			Template: /*html*/`
				<div class="emne-wrap">
					<div class="emne-header">
						<div>
							<div class="emne-crumbs"><a href="#/EmailNotifications"><span class="icon is-small"><i class="fas fa-chevron-left"></i></span> Email Notifications</a></div>
							<div class="emne-title"><span class="icon"><i class="fas fa-envelope-open-text"></i></span> {~D:AppData.EmailNotifications.EditorTitle~}</div>
						</div>
						<div class="emne-actions" id="EmailNotifications-Editor-Actions"></div>
					</div>
					{~TS:EmailNotifications-Editor-Error:AppData.EmailNotifications.EditorErrorSlot~}
					{~TS:EmailNotifications-Editor-Loading:AppData.EmailNotifications.EditorLoadingSlot~}
					{~TS:EmailNotifications-Editor-Form:AppData.EmailNotifications.EditorRuleSlot~}
				</div>`
		},
		{
			Hash: 'EmailNotifications-Editor-Form',
			Template: /*html*/`
				<div class="emne-card">
					<div class="emne-field">
						<label class="emne-enable-row"><input type="checkbox" id="emne-enabled" {~D:Record.Enabled~} {~D:Record.DisabledAttr~} onchange="_Pict.views.EmailNotificationsEditor.onFieldChanged()"> Rule enabled</label>
						<p class="emne-help">When off, this rule sends no email.</p>
					</div>

					<div class="emne-field">
						<label class="emne-label">Email type</label>
						<div class="select is-fullwidth"><select id="emne-handler" {~D:Record.DisabledAttr~} onchange="_Pict.views.EmailNotificationsEditor.onHandlerChanged()">{~TS:EmailNotifications-Editor-HandlerOption:Record.HandlerOptions~}</select></div>
						<div id="EmailNotifications-Handler-Desc"></div>
					</div>

					<div class="emne-divider"></div>
					<div class="emne-section-title"><span class="icon is-small"><i class="fas fa-filter"></i></span> Applies to</div>

					<div class="emne-field">
						<label class="emne-label">Projects</label>
						<div id="EmailNotifications-Projects"></div>
						<p class="emne-help">Select none = <strong>all projects</strong>.</p>
					</div>

					<div class="emne-field">
						<label class="emne-label">Document type</label>
						<div class="select is-fullwidth"><select id="emne-doctype" {~D:Record.DisabledAttr~} onchange="_Pict.views.EmailNotificationsEditor.onFieldChanged()">{~TS:EmailNotifications-Editor-DocTypeOption:Record.DocTypeOptions~}</select></div>
					</div>

					<div class="emne-field">
						<label class="emne-label">Status</label>
						<div id="EmailNotifications-Status"></div>
						<p class="emne-help">Select none = <strong>any status</strong>.</p>
					</div>

					<div id="EmailNotifications-Dynamic"></div>

					<div class="emne-footer">
						{~TS:EmailNotifications-Editor-DeleteClone:Record.ExistingSlot~}
						<span class="emne-spacer"></span>
						{~TS:EmailNotifications-Editor-ReadOnlyNote:Record.ReadOnlySlot~}
					</div>
				</div>`
		},
		{
			Hash: 'EmailNotifications-Editor-HandlerOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'EmailNotifications-Editor-DocTypeOption',
			Template: /*html*/`<option value="{~D:Record.Hash~}" {~D:Record.SelectedAttr~}>{~D:Record.Name~}</option>`
		},
		{
			Hash: 'EmailNotifications-Editor-DeleteClone',
			Template: /*html*/`
				<button class="button is-danger is-light" onclick="_Pict.views.EmailNotificationsEditor.deleteRule()"><span class="icon is-small"><i class="fas fa-trash"></i></span><span>Delete</span></button>
				<button class="button is-light" onclick="_Pict.views.EmailNotificationsEditor.cloneRule()"><span class="icon is-small"><i class="fas fa-clone"></i></span><span>Clone</span></button>`
		},
		{
			Hash: 'EmailNotifications-Editor-ReadOnlyNote',
			Template: /*html*/`<span class="emne-badge"><span class="icon is-small"><i class="fas fa-eye"></i></span> Read only</span>`
		},
		{
			Hash: 'EmailNotifications-Editor-Actions-Template',
			Template: /*html*/`
				{~TS:EmailNotifications-Editor-Actions-ReadOnly:Record.ReadOnlySlot~}
				{~TS:EmailNotifications-Editor-Actions-Dirty:Record.DirtySlot~}
				{~TS:EmailNotifications-Editor-Actions-Buttons:Record.EditSlot~}`
		},
		{
			Hash: 'EmailNotifications-Editor-Actions-ReadOnly',
			Template: /*html*/`<span class="emne-badge" title="Editing requires customer-admin permission."><span class="icon is-small"><i class="fas fa-eye"></i></span> Read only</span>`
		},
		{
			Hash: 'EmailNotifications-Editor-Actions-Dirty',
			Template: /*html*/`<span class="emne-dirty"><span class="icon is-small"><i class="fas fa-circle"></i></span> Unsaved changes</span>`
		},
		{
			Hash: 'EmailNotifications-Editor-Actions-Buttons',
			Template: /*html*/`
				<button class="button is-small is-light" onclick="_Pict.views.EmailNotificationsEditor.cancel()">Cancel</button>
				<button class="button is-small is-success" onclick="_Pict.views.EmailNotificationsEditor.saveRule()"><span class="icon is-small"><i class="fas fa-floppy-disk"></i></span><span>Save rule</span></button>`
		},
		{
			Hash: 'EmailNotifications-Editor-Loading',
			Template: /*html*/`<div class="emne-overlay"><span class="emne-spinner"></span><p class="mt-3">Loading…</p></div>`
		},
		{
			Hash: 'EmailNotifications-Editor-Error',
			Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'EmailNotificationsEditorWrap', TemplateHash: 'EmailNotifications-Editor-Wrap', ContentDestinationAddress: '#PlatformConfiguration-Application-Container' }
	]
};

},{"./EmailNotifications-ConfigFieldSchema.js":1436,"pict-view":1053}],1438:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * EmailNotificationsList — the #/EmailNotifications landing.
 *
 * A list of the customer's Email Rules (Meadow EmailRule entities): each shows its handler, the documents it
 * targets (type/status/projects), whether it is enabled, and links to the editor. Data lives in
 * EmailNotificationsProvider (AppData.EmailNotifications); this view derives loading/empty/error slots and
 * repaints declaratively. Styled to match the Approval Workflows list it sits beside.
 */
class EmailNotificationsList extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.EmailNotifications;
	}

	onBeforeRender(pRenderable)
	{
		const tmpState = this.provider ? this.provider.state : { List: [], ListLoading: false, ListError: '' };
		const tmpApp = this.pict.AppData.EmailNotifications || {};
		tmpApp.LoadingSlot = tmpState.ListLoading ? [ {} ] : [];
		tmpApp.ErrorSlot = tmpState.ListError ? [ { Message: tmpState.ListError } ] : [];
		tmpApp.EmptySlot = (!tmpState.ListLoading && !tmpState.ListError && tmpState.List.length === 0) ? [ {} ] : [];
		tmpApp.CanEdit = this.provider ? this.provider.canEdit : false;
		tmpApp.NewButtonSlot = tmpApp.CanEdit ? [ {} ] : [];
		tmpApp.CountSlot = (!tmpState.ListLoading && !tmpState.ListError && tmpState.List.length > 0) ? [ { Count: tmpState.List.length } ] : [];
		// Per-row filter text + enabled styling.
		tmpApp.Rows = (tmpState.List || []).map((pRow) => Object.assign({}, pRow, {
			Filter: `${pRow.HandlerLabel} ${pRow.DocumentTypeText} ${pRow.StatusText}`.toLowerCase(),
			EnabledClass: pRow.Enabled ? 'is-on' : 'is-off',
			EnabledText: pRow.Enabled ? 'On' : 'Off',
			ScheduledSlot: pRow.Scheduled ? [ {} ] : [],
		}));
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** Client-side filter of the rule rows by handler / document type / status (show/hide, no re-render). */
	filterRows(pQuery)
	{
		const tmpQuery = String(pQuery || '').trim().toLowerCase();
		let tmpVisible = 0;
		Array.prototype.forEach.call(document.querySelectorAll('.emnl-row'), (pRow) =>
		{
			const tmpText = pRow.getAttribute('data-filter') || '';
			const tmpMatch = !tmpQuery || tmpText.indexOf(tmpQuery) > -1;
			pRow.style.display = tmpMatch ? '' : 'none';
			if (tmpMatch) { tmpVisible++; }
		});
		const tmpEmpty = document.getElementById('EmailNotifications-NoMatch');
		if (tmpEmpty) { tmpEmpty.style.display = (tmpVisible === 0 && tmpQuery) ? '' : 'none'; }
	}
}

module.exports = EmailNotificationsList;

module.exports.default_configuration =
{
	ViewIdentifier: 'EmailNotificationsList',
	DefaultRenderable: 'EmailNotificationsListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.emnl-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 82rem; }
		.emnl-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 0.5rem; }
		.emnl-count { display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 700; color: var(--bulma-link, #156dd1); background: #eef3fb; border-radius: 999px; padding: 0.1rem 0.6rem; margin-left: 0.5rem; vertical-align: middle; }
		.emnl-toolbar { margin: 0.85rem 0 1rem; max-width: 24rem; }
		.emnl-list { border: 1px solid var(--bulma-border, #e6e9ef); border-radius: 12px; background: var(--bulma-scheme-main, #fff); overflow: hidden; }
		.emnl-row { position: relative; display: flex; align-items: center; gap: 0.85rem; padding: 0.7rem 1rem; text-decoration: none; color: inherit; cursor: pointer;
			border-bottom: 1px solid var(--bulma-border, #f0f2f5); border-left: 3px solid transparent; transition: background 0.1s, border-left-color 0.1s; }
		.emnl-row:last-child { border-bottom: none; }
		.emnl-row:hover { background: var(--bulma-scheme-main-bis, #f6f8fc); border-left-color: var(--bulma-link, #156dd1); }
		.emnl-enabled { flex-shrink: 0; width: 2.4rem; text-align: center; font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.12rem 0; border-radius: 999px; }
		.emnl-enabled.is-on { background: #e4f5ea; color: #2e9e5b; }
		.emnl-enabled.is-off { background: var(--bulma-scheme-main-bis, #f1f2f4); color: #9aa3b2; }
		.emnl-row-ic { flex-shrink: 0; color: var(--bulma-link, #156dd1); }
		.emnl-row-name { flex: 1 1 9rem; min-width: 8rem; font-weight: 700; color: #22334c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
		.emnl-row-meta { display: flex; gap: 0.4rem; flex-wrap: wrap; flex-shrink: 1; align-items: center; justify-content: flex-end; }
		.emnl-chip { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.72rem; font-weight: 600; padding: 0.15rem 0.55rem; border-radius: 999px; background: var(--bulma-scheme-main-bis, #f1f4f9); color: #5a6b82; white-space: nowrap; max-width: 15rem; overflow: hidden; text-overflow: ellipsis; }
		.emnl-chip .icon { font-size: 0.7rem; }
		.emnl-chip.is-sched { background: #fdf3e0; color: #b26a2c; }
		.emnl-row-arrow { flex-shrink: 0; color: var(--bulma-border, #cfd6e2); transition: color 0.12s, transform 0.12s; }
		.emnl-row:hover .emnl-row-arrow { color: var(--bulma-link, #156dd1); transform: translateX(2px); }
		.emnl-empty { padding: 2.5rem 1rem; }
		.emnl-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #156dd1); border-radius: 50%; animation: emnl-spin 0.8s linear infinite; }
		@keyframes emnl-spin { to { transform: rotate(360deg); } }
	`,

	Templates:
	[
		{
			Hash: 'EmailNotifications-List-Wrap',
			Template: /*html*/`
				<div class="emnl-wrap">
					<div class="emnl-header">
						<div>
							<h1 class="title is-4"><span class="icon"><i class="fas fa-envelope"></i></span> Email Notifications{~TS:EmailNotifications-List-Count:AppData.EmailNotifications.CountSlot~}</h1>
							<p class="subtitle is-6 has-text-grey">Rules that send automated emails when documents change status or on a schedule. Open one to edit who is notified and when.</p>
						</div>
						<div class="field is-grouped">
							{~TS:EmailNotifications-List-NewButton:AppData.EmailNotifications.NewButtonSlot~}
						</div>
					</div>

					{~TS:EmailNotifications-List-Error:AppData.EmailNotifications.ErrorSlot~}

					<div class="emnl-toolbar">
						<div class="control has-icons-left">
							<input class="input" type="text" placeholder="Filter rules…" oninput="_Pict.views.EmailNotificationsList.filterRows(this.value)">
							<span class="icon is-left"><i class="fas fa-magnifying-glass"></i></span>
						</div>
					</div>

					<div class="emnl-list">
						{~TS:EmailNotifications-List-Loading:AppData.EmailNotifications.LoadingSlot~}
						{~TS:EmailNotifications-List-Row:AppData.EmailNotifications.Rows~}
						<div id="EmailNotifications-NoMatch" class="emnl-empty has-text-grey has-text-centered" style="display:none"><span class="icon is-large"><i class="fas fa-magnifying-glass fa-lg"></i></span><p class="mt-2">No rules match your filter.</p></div>
						{~TS:EmailNotifications-List-Empty:AppData.EmailNotifications.EmptySlot~}
					</div>
				</div>`
		},
		{
			Hash: 'EmailNotifications-List-Count',
			Template: /*html*/`<span class="emnl-count">{~D:Record.Count~}</span>`
		},
		{
			Hash: 'EmailNotifications-List-NewButton',
			Template: /*html*/`<button class="button is-link" onclick="window.location.hash = '#/EmailRule/New'"><span class="icon"><i class="fas fa-plus"></i></span><span>New rule</span></button>`
		},
		{
			Hash: 'EmailNotifications-List-Row',
			Template: /*html*/`
				<a class="emnl-row" href="#/EmailRule/{~D:Record.IDEmailRule~}" data-filter="{~D:Record.Filter~}">
					<span class="emnl-enabled {~D:Record.EnabledClass~}">{~D:Record.EnabledText~}</span>
					<span class="icon emnl-row-ic"><i class="fas fa-envelope-open-text"></i></span>
					<span class="emnl-row-name">{~D:Record.HandlerLabel~}</span>
					<span class="emnl-row-meta">
						<span class="emnl-chip"><span class="icon"><i class="fas fa-file-lines"></i></span> {~D:Record.DocumentTypeText~}</span>
						<span class="emnl-chip"><span class="icon"><i class="fas fa-flag"></i></span> {~D:Record.StatusText~}</span>
						<span class="emnl-chip"><span class="icon"><i class="fas fa-diagram-project"></i></span> {~D:Record.ProjectsText~}</span>
						{~TS:EmailNotifications-List-SchedChip:Record.ScheduledSlot~}
					</span>
					<span class="icon emnl-row-arrow"><i class="fas fa-chevron-right"></i></span>
				</a>`
		},
		{
			Hash: 'EmailNotifications-List-SchedChip',
			Template: /*html*/`<span class="emnl-chip is-sched"><span class="icon"><i class="fas fa-clock"></i></span> Scheduled</span>`
		},
		{
			Hash: 'EmailNotifications-List-Empty',
			Template: /*html*/`
				<div class="emnl-empty has-text-grey has-text-centered">
					<span class="icon is-large"><i class="fas fa-envelope fa-2x"></i></span>
					<p class="mt-3">No email rules are configured for your organization yet.</p>
				</div>`
		},
		{
			Hash: 'EmailNotifications-List-Loading',
			Template: /*html*/`<div class="emnl-empty has-text-grey has-text-centered"><span class="emnl-spinner"></span><p class="mt-3">Loading email rules…</p></div>`
		},
		{
			Hash: 'EmailNotifications-List-Error',
			Template: /*html*/`<div class="notification is-danger is-soft py-2 px-3 mb-3"><span class="icon"><i class="fas fa-triangle-exclamation"></i></span> <span>{~D:Record.Message~}</span></div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'EmailNotificationsListWrap', TemplateHash: 'EmailNotifications-List-Wrap', ContentDestinationAddress: '#PlatformConfiguration-Application-Container' }
	]
};

},{"pict-view":1053}],1439:[function(require,module,exports){
module.exports={
	"ViewIdentifier": "Empty",
	"DefaultRenderable": "EmptyWrap",
	"DefaultDestinationAddress": "#PlatformConfiguration-MainViewport-Sink",
	"AutoRender": false,
	"Templates": [
		{
			"Hash": "EmptyWrap",
			"Template": ""
		}
	],
	"Renderables": [
		{
			"RenderableHash": "EmptyWrap",
			"TemplateHash": "EmptyWrap",
			"DestinationAddress": "#PlatformConfiguration-MainViewport-Sink"
		}
	]
}

},{}],1440:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libTabBar = require('./TabBar.js');

/**
 * Entitlements — the #/Entitlements screen. A left rail lists subjects (Roles / Permission Groups / Users); the
 * main pane shows the task catalog grouped by area, each task a switch you flip on/off for the selected subject.
 * All logic + data live in the EntitlementsProvider, which assigns hand-built HTML into #Ent-Rail / #Ent-Detail
 * (SamplePlan pattern) and writes grants through the RBAC grant path.
 */
class Entitlements extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.Entitlements; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = Entitlements;
module.exports.default_configuration =
{
	ViewIdentifier: 'Entitlements',
	DefaultRenderable: 'EntitlementsWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		${ libTabBar.TABBAR_CSS }
		.ent-wrap { padding: 1.25rem 1.5rem 2rem; }
		.ent-head { margin: 0 0 1rem; }
		.ent-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.ent-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.ent-cols { display:grid; grid-template-columns: 17rem 1fr; gap:1.1rem; align-items:start; }
		@media (max-width: 820px) { .ent-cols { grid-template-columns: 1fr; } }
		.ent-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; max-height:42rem; display:flex; flex-direction:column; }
		.ent-rail-search { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; margin:0 0 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.ent-rail-list { flex:1 1 auto; min-height:0; overflow:auto; }
		.ent-rail-group { margin:0 0 1rem; }
		.ent-rail-group:last-child { margin-bottom:0; }
		.ent-rail-head { display:flex; align-items:center; gap:0.45rem; font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.06em; color:var(--theme-color-text-secondary,#45505f); padding:0.4rem 0.55rem; margin:0 0 0.4rem; background:var(--theme-color-background-secondary,#eef1f6); border-radius:6px; position:sticky; top:0; z-index:1; }
		.ent-rail-head-icon { flex:0 0 auto; color:var(--theme-color-brand-primary,#2e7d74); font-size:0.82rem; }
		.ent-rail-head-text { flex:1 1 auto; }
		.ent-rail-count { flex:0 0 auto; min-width:1.1rem; text-align:center; font-size:0.66rem; font-weight:700; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-panel,#fff); border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:9px; padding:0.02rem 0.35rem; }
		.ent-rail-item { padding:0.38rem 0.55rem; border-radius:6px; font-size:0.88rem; color:var(--theme-color-text-secondary,#45505f); cursor:pointer; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.ent-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
		.ent-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; font-weight:600; }
		.ent-rail-empty { font-size:0.82rem; color:var(--theme-color-text-muted,#8894a4); padding:0.3rem 0.55rem; }
		.ent-main, .ent-empty { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
		.ent-empty { display:flex; align-items:center; justify-content:center; text-align:center; color:var(--theme-color-text-muted,#6b7686); }
		.ent-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0 0 0.9rem; }
		.ent-tab { font-size:0.86rem; font-weight:600; padding:0.45rem 0.9rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.ent-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.ent-tab.is-active { color:var(--theme-color-primary,#2f6fed); border-bottom-color:var(--theme-color-primary,#2f6fed); }
		.ent-forms-search { width:100%; max-width:26rem; font-size:0.9rem; padding:0.45rem 0.65rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; box-sizing:border-box; margin:0 0 0.7rem; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.ent-detail-head { margin:0 0 0.9rem; }
		.ent-detail-title { font-size:1.2rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.ent-detail-sub { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.ent-busy { color:var(--theme-color-primary,#2f6fed); font-weight:600; }
		.ent-note { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.7rem; }
		.ent-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.7rem; }
		.ent-area { margin:0 0 1.1rem; }
		.ent-area-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0 0 0.3rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0 0 0.4rem; }
		.ent-task { display:flex; align-items:center; gap:1rem; padding:0.45rem 0.15rem; }
		.ent-task-main { flex:1 1 auto; min-width:0; }
		.ent-task-label { font-size:0.92rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.ent-task-desc { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); }
		.ent-flag { font-size:0.58rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:#fff; background:var(--theme-color-status-warning,#b8860b); padding:0.05rem 0.35rem; border-radius:9px; vertical-align:middle; }
		.ent-hint { font-size:0.7rem; color:var(--theme-color-text-muted,#8894a4); font-style:italic; margin-left:0.3rem; }
		.ent-switch { flex:0 0 auto; width:2.5rem; height:1.4rem; border-radius:999px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-tertiary,#eef1f6); cursor:pointer; position:relative; transition:background 0.12s; }
		.ent-switch-dot { position:absolute; top:0.12rem; left:0.14rem; width:1rem; height:1rem; border-radius:50%; background:#fff; box-shadow:0 1px 2px rgba(0,0,0,0.25); transition:left 0.12s; }
		.ent-switch.is-on { background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.ent-switch.is-on .ent-switch-dot { left:1.22rem; }
		.ent-switch[disabled] { opacity:0.5; cursor:default; }
			.ent-mlist-row { align-items:flex-start; }
			.ent-mlist-icon { color:var(--theme-color-brand-primary,#2e7d74); font-size:0.82rem; margin-right:0.45rem; }
			.ent-mlist-read { flex:0 0 auto; display:flex; align-items:center; gap:0.5rem; padding-top:0.1rem; }
			.ent-read-lbl { font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); }
			.ent-mlist-adv-btn { display:inline-flex; align-items:center; gap:0.3rem; font-size:0.74rem; font-weight:600; color:var(--theme-color-primary,#2f6fed); background:none; border:none; cursor:pointer; padding:0.15rem 0 0; }
			.ent-mlist-adv-count { font-size:0.6rem; font-weight:700; color:#fff; background:var(--theme-color-primary,#2f6fed); border-radius:9px; padding:0.02rem 0.32rem; }
			.ent-mlist-adv { display:flex; flex-wrap:wrap; gap:0.55rem 1.6rem; padding:0.15rem 0 0.7rem 0.15rem; margin:0 0 0.35rem; border-bottom:1px solid var(--theme-color-border-light,#f0f2f6); }
			.ent-mlist-action { display:flex; align-items:center; gap:0.5rem; }
			.ent-mlist-action-lbl { font-size:0.8rem; color:var(--theme-color-text-secondary,#45505f); min-width:3.4rem; }
		.ent-confirm { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); display:inline-flex; align-items:center; gap:0.4rem; }
		.ent-btn { font-size:0.78rem; font-weight:600; padding:0.28rem 0.7rem; border-radius:6px; cursor:pointer; border:1px solid transparent; }
		.ent-btn-danger { color:#fff; background:var(--theme-color-status-danger,#c0392b); }
		.ent-btn-ghost { color:var(--theme-color-text,#22303f); background:transparent; border-color:var(--theme-color-border-medium,#d5dbe3); }
	`,
	Templates:
	[
		{
			Hash: 'Entitlements-Wrap',
			Template: /*html*/`
				<div class="ent-wrap">
					<div class="ent-head">
						<h1 class="ent-title">Entitlements</h1>
						<p class="ent-subtitle">Set up what a role, permission group, or user can do — in plain tasks. Flip a task on and this grants the right permissions behind the scenes; flip it off to take them away. Broad tasks are flagged; grant those sparingly.</p>
					</div>
					<div class="ent-cols">
						<div id="Ent-Rail" class="ent-rail"></div>
						<div id="Ent-Detail" class="ent-main"></div>
					</div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'EntitlementsWrap',
			TemplateHash: 'Entitlements-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./TabBar.js":1479,"pict-view":1053}],1441:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * EntityDestinationsConfig view: the shell for the #/EntityDestinations screen ("Where Records Open").
 * Paints the header and a single #EDC-Detail mount; the EntityDestinationsConfig provider renders the rest.
 */
class EntityDestinationsConfig extends libPictView
{
	get provider()
	{
		return this.pict.providers.EntityDestinationsConfig;
	}

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading)
			{
				tmpProvider.loadAsync();
			}
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = EntityDestinationsConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'EntityDestinationsConfig',
	DefaultRenderable: 'EntityDestinationsConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.edc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.edc-head { margin: 0 0 1rem; }
		.edc-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.edc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.edc-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:18rem; max-width:52rem; }
		.edc-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:12rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
		.edc-field { margin:0 0 0.9rem; }
		.edc-field-label { display:block; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.35rem; }
		.edc-select { font-size:0.9rem; padding:0.42rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); min-width:20rem; max-width:100%; }
		.edc-narrow { min-width:10rem; }
		.edc-input { font-size:0.88rem; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); box-sizing:border-box; width:100%; max-width:28rem; }
		.edc-route { max-width:100%; margin-top:0.4rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.edc-customer { font-size:0.98rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.edc-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0.2rem 0 0.8rem; flex-wrap:wrap; }
		.edc-tab { font-size:0.88rem; font-weight:600; padding:0.45rem 0.95rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.edc-tab.is-active { color:var(--theme-color-brand-primary,#5650e6); border-bottom-color:var(--theme-color-brand-primary,#5650e6); }
		.edc-help, .edc-hint { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.8rem; }
		.edc-hint code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.edc-note { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; margin:0 0 1rem; }
		.edc-rules { display:flex; flex-direction:column; gap:0.5rem; margin:0 0 0.9rem; }
		.edc-rule { display:flex; gap:0.75rem; align-items:center; padding:0.6rem 0.75rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:9px; background:var(--theme-color-background-panel,#fff); }
		.edc-rule.is-off { opacity:0.6; }
		.edc-rule-order { display:flex; flex-direction:column; gap:0.2rem; }
		.edc-mv { width:1.7rem; height:1.4rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:5px; background:transparent; color:var(--theme-color-text-muted,#8894a4); cursor:pointer; font-size:0.7rem; }
		.edc-mv[disabled] { opacity:0.35; cursor:default; }
		.edc-rule-body { flex:1 1 auto; min-width:0; }
		.edc-rule-label { font-weight:650; color:var(--theme-color-text-primary,#1f2733); }
		.edc-rule-sentence { font-size:0.84rem; color:var(--theme-color-text-secondary,#45505f); }
		.edc-off { font-size:0.7rem; font-weight:700; text-transform:uppercase; color:var(--theme-color-text-muted,#8894a4); margin-left:0.3rem; }
		.edc-rule-actions { display:flex; gap:0.3rem; flex-wrap:wrap; justify-content:flex-end; }
		.edc-btn { font-size:0.82rem; font-weight:600; padding:0.32rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.edc-btn.is-danger:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.edc-chips { display:flex; flex-wrap:wrap; gap:0.35rem 0.8rem; }
		.edc-rule.is-platform { background:var(--theme-color-background-secondary,#f7f9fb); border-style:dashed; }
		.edc-badge { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:999px; padding:0.05rem 0.45rem; margin-left:0.35rem; }
		.edc-picker { display:flex; flex-direction:column; gap:0.4rem; max-width:28rem; }
		.edc-tags { display:flex; flex-wrap:wrap; gap:0.3rem; }
		.edc-tag { display:inline-flex; align-items:center; gap:0.25rem; font-size:0.82rem; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-selected,#eef0fe);
			border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:999px; padding:0.1rem 0.2rem 0.1rem 0.6rem; }
		.edc-tag-x { border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.95rem; line-height:1; padding:0 0.3rem; }
		.edc-suggest { display:flex; flex-direction:column; align-items:stretch; }
		.edc-suggest:empty { display:none; }
		.edc-suggestion { text-align:left; font-size:0.85rem; padding:0.35rem 0.6rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-top:none; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.edc-suggestion:first-child { border-top:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px 6px 0 0; }
		.edc-suggestion:hover, .edc-suggestion:focus { background:var(--theme-color-background-selected,#f5f5fe); }
		.edc-chip { font-size:0.85rem; color:var(--theme-color-text-primary,#1f2733); display:inline-flex; gap:0.3rem; align-items:center; }
		.edc-editor { border:1px solid var(--theme-color-brand-primary,#5650e6); border-radius:9px; padding:0.9rem 1rem; margin:0 0 0.9rem; background:var(--theme-color-background-selected,#f5f5fe); }
		.edc-editor-actions { display:flex; gap:0.5rem; align-items:center; }
		.edc-savebar { margin:0.9rem 0 1.2rem; display:flex; gap:0.8rem; align-items:center; }
		.edc-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
		.edc-save[disabled] { opacity:0.6; cursor:default; }
		.edc-unsaved { font-size:0.82rem; color:var(--theme-color-status-warning,#b7791f); }
		.edc-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.edc-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
		.edc-preview { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:0.9rem; }
		.edc-preview-result { font-size:0.86rem; background:var(--theme-color-background-tertiary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; color:var(--theme-color-text-primary,#1f2733); }
		.edc-preview-result code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.8rem; word-break:break-all; }
		.edc-explain { margin-top:0.4rem; font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); }
		@media (max-width: 640px)
		{
			.edc-wrap { padding: 1rem; }
			.edc-rule { flex-wrap:wrap; }
			.edc-select { min-width:0; width:100%; }
		}
	`,
	Templates:
	[
		{
			Hash: 'EntityDestinationsConfig-Wrap',
			Template: /*html*/`
				<div class="edc-wrap">
					<div class="edc-head">
						<h1 class="edc-title">Where Records Open</h1>
						<p class="edc-subtitle">Choose where a scanned QR label or an emailed link takes each person. With no rules, labels and links open where they always have.</p>
					</div>
					<div id="EDC-Detail" class="edc-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'EntityDestinationsConfigWrap',
			TemplateHash: 'EntityDestinationsConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1442:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * ErrorLogViewer — read-only diagnostics page for recent Headlight web errors (HLWebErrorLog artifacts).
 * A per-day bar chart + a filterable, expandable table. All data + filtering live in the ErrorLogViewer
 * provider; the view paints declaratively. The free-text filter and row expand/collapse repaint ONLY the
 * table host (via syncTable) so the search input keeps focus and the chart isn't rebuilt.
 */
class ErrorLogViewer extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ErrorLogViewer;
	}

	onBeforeRender(pRenderable)
	{
		if (this.provider) { this.provider.deriveRenderState(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/** Repaint only the table host (count label + table) — keeps the search input focused on each keystroke. */
	syncTable()
	{
		if (this.pict.ContentAssignment.getElement('#ELV-TableHost').length === 0) { return; }
		const tmpHTML = this.pict.parseTemplateByHash('ErrorLogViewer-Table', this.pict.AppData.ErrorLogViewer);
		this.pict.ContentAssignment.assignContent('#ELV-TableHost', tmpHTML);
	}
}

module.exports = ErrorLogViewer;

module.exports.default_configuration =
{
	ViewIdentifier: 'ErrorLogViewer',
	DefaultRenderable: 'ErrorLogViewerWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.elv-wrap { padding: 1.25rem 1.5rem 2rem; }
		.elv-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
		.elv-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); }
		.elv-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); }
		.elv-sub { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 0.15rem; }
		.elv-panel { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; background: var(--theme-color-background-panel, #fff); padding: 1.25rem 1.4rem; margin-bottom: 1.1rem; }
		.elv-summary { display: flex; gap: 0.6rem; flex-wrap: wrap; align-items: center; margin-bottom: 0.9rem; }
		.elv-stat { font-size: 1.65rem; font-weight: 750; color: var(--theme-color-text-primary, #1f2733); line-height: 1; }
		.elv-stat-label { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.elv-chip { display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.8rem; font-weight: 600; padding: 0.2rem 0.6rem; border-radius: 999px; background: var(--theme-color-background-tertiary, #f4f6f9); color: var(--theme-color-text-secondary, #45505f); }
		.elv-chip .elv-dot { width: 0.55rem; height: 0.55rem; border-radius: 50%; background: var(--theme-color-text-muted, #9aa4b2); }
		.elv-app-fieldbook .elv-dot, .elv-badge.elv-app-fieldbook { background: var(--theme-color-brand-primary, #5650e6); }
		.elv-app-portal .elv-dot, .elv-badge.elv-app-portal { background: var(--theme-color-status-info, #3083dc); }
		.elv-app-tracker .elv-dot, .elv-badge.elv-app-tracker { background: var(--theme-color-status-success, #2aa65a); }
		.elv-app-unknown .elv-dot, .elv-badge.elv-app-unknown { background: var(--theme-color-text-muted, #9aa4b2); }
		/* Per-day bar chart (dependency-free). */
		.elv-chart-head { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 0.4rem; }
		.elv-chart-title { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
		.elv-chart-peak { font-size: 0.75rem; color: var(--theme-color-text-muted, #6b7686); }
		.elv-chart { display: flex; align-items: flex-end; gap: 2px; height: 130px; padding-top: 0.4rem; border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
		.elv-bar-col { flex: 1 1 0; min-width: 3px; height: 100%; display: flex; align-items: flex-end; cursor: default; }
		.elv-bar { width: 100%; background: var(--theme-color-brand-primary, #5650e6); border-radius: 2px 2px 0 0; min-height: 0; opacity: 0.85; transition: opacity 0.15s ease; }
		.elv-bar-col:hover .elv-bar { opacity: 1; }
		.elv-bar.is-max { background: var(--theme-color-status-warning, #f5a623); opacity: 1; }
		.elv-axis { display: flex; gap: 2px; margin-top: 0.3rem; }
		.elv-axis-col { flex: 1 1 0; min-width: 3px; font-size: 0.62rem; color: var(--theme-color-text-muted, #9aa4b2); text-align: center; white-space: nowrap; }
		/* Controls. */
		.elv-controls { display: flex; justify-content: space-between; gap: 1rem; align-items: center; flex-wrap: wrap; margin-bottom: 0.8rem; }
		.elv-filters { display: flex; gap: 0.35rem; flex-wrap: wrap; }
		.elv-filter { border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f);
			font-size: 0.82rem; font-weight: 600; padding: 0.3rem 0.7rem; border-radius: 7px; cursor: pointer; display: inline-flex; align-items: center; gap: 0.35rem; }
		.elv-filter:hover { background: var(--theme-color-background-tertiary, #f4f6f9); }
		.elv-filter.is-active { background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); color: #fff; }
		.elv-filter-count { font-size: 0.7rem; opacity: 0.8; background: rgba(0,0,0,0.08); border-radius: 999px; padding: 0 0.4rem; }
		.elv-filter.is-active .elv-filter-count { background: rgba(255,255,255,0.25); }
		.elv-search { max-width: 22rem; }
		.elv-count-label { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.5rem; }
		/* Table. */
		.elv-table { width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
		.elv-table th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686);
			background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.45rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.elv-row > td { padding: 0.5rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); font-size: 0.88rem; color: var(--theme-color-text-primary, #1f2733); vertical-align: top; }
		.elv-row { cursor: pointer; }
		.elv-row:hover > td { background: var(--theme-color-background-selected, #eef1f8); }
		.elv-row.is-expanded > td { background: var(--theme-color-background-selected, #eef1f8); border-bottom: none; }
		.elv-time { white-space: nowrap; color: var(--theme-color-text-secondary, #45505f); font-size: 0.82rem; }
		.elv-badge { display: inline-block; color: #fff; font-size: 0.7rem; font-weight: 700; padding: 0.1rem 0.5rem; border-radius: 5px; white-space: nowrap; }
		.elv-msg { font-weight: 500; word-break: break-word; }
		.elv-context { white-space: nowrap; color: var(--theme-color-text-muted, #6b7686); font-size: 0.78rem; }
		.elv-chev { color: var(--theme-color-text-muted, #9aa4b2); text-align: right; }
		.elv-detail-row > td { padding: 0 0.8rem 0.8rem; background: var(--theme-color-background-selected, #eef1f8); border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
		.elv-detail-head { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin: 0.6rem 0 0.25rem; }
		.elv-pre { margin: 0; padding: 0.7rem 0.85rem; border-radius: 6px; background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0);
			font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.76rem; line-height: 1.5; color: var(--theme-color-text-secondary, #45505f); overflow: auto; max-height: 18rem; white-space: pre-wrap; word-break: break-word; }
		.elv-empty { padding: 2.5rem 1rem; }
		.elv-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: elv-spin 0.8s linear infinite; }
		@keyframes elv-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'ErrorLogViewer-Wrap',
			Template: /*html*/`
				<div class="elv-wrap">
					<div class="elv-head">
						<div>
							<div class="elv-eyebrow">Diagnostics</div>
							<h1 class="elv-title">Web Error Log</h1>
							<div class="elv-sub">Client-side errors reported by the Headlight web apps · {~D:AppData.ErrorLogViewer.WindowLabel~}</div>
						</div>
						<button class="button is-light" onclick="_Pict.providers.ErrorLogViewer.reload()"><span class="icon"><i class="fas fa-rotate-right"></i></span><span>Refresh</span></button>
					</div>
					{~TS:ErrorLogViewer-Message:AppData.ErrorLogViewer.MessageSlot~}
					{~TS:ErrorLogViewer-Loading:AppData.ErrorLogViewer.LoadingSlot~}
					{~TS:ErrorLogViewer-Body:AppData.ErrorLogViewer.BodySlot~}
				</div>`
		},
		{
			Hash: 'ErrorLogViewer-Body',
			Template: /*html*/`
				<div class="elv-panel">
					<div class="elv-summary">
						<div>
							<div class="elv-stat">{~D:AppData.ErrorLogViewer.Total~}</div>
							<div class="elv-stat-label">errors in window</div>
						</div>
						<div style="flex:1"></div>
						{~TS:ErrorLogViewer-AppChip:AppData.ErrorLogViewer.AppChips~}
					</div>
					<div class="elv-chart-head">
						<span class="elv-chart-title">Errors per day</span>
						<span class="elv-chart-peak">{~D:AppData.ErrorLogViewer.ChartMaxLabel~}</span>
					</div>
					<div class="elv-chart">{~TS:ErrorLogViewer-Bar:AppData.ErrorLogViewer.Bars~}</div>
					<div class="elv-axis">{~TS:ErrorLogViewer-Axis:AppData.ErrorLogViewer.Bars~}</div>
				</div>
				<div class="elv-controls">
					<div class="elv-filters">{~TS:ErrorLogViewer-Filter:AppData.ErrorLogViewer.FilterButtons~}</div>
					<input class="input elv-search" type="text" placeholder="Filter by message, app, or stack…" value="{~D:AppData.ErrorLogViewer.TextFilter~}" oninput="_Pict.providers.ErrorLogViewer.setTextFilter(this.value)" />
				</div>
				<div id="ELV-TableHost">{~T:ErrorLogViewer-Table~}</div>`
		},
		{
			Hash: 'ErrorLogViewer-AppChip',
			Template: /*html*/`<span class="elv-chip {~D:Record.AppClass~}"><span class="elv-dot"></span>{~D:Record.Label~} · {~D:Record.Count~}</span>`
		},
		{
			Hash: 'ErrorLogViewer-Bar',
			Template: /*html*/`<div class="elv-bar-col" title="{~D:Record.Tooltip~}"><div class="elv-bar {~D:Record.MaxClass~}" style="height: {~D:Record.HeightPct~}%"></div></div>`
		},
		{
			Hash: 'ErrorLogViewer-Axis',
			Template: /*html*/`<div class="elv-axis-col">{~D:Record.AxisLabel~}</div>`
		},
		{
			Hash: 'ErrorLogViewer-Filter',
			Template: /*html*/`<button class="elv-filter {~D:Record.ActiveClass~}" onclick="_Pict.providers.ErrorLogViewer.setAppFilter('{~D:Record.Key~}')">{~D:Record.Label~} <span class="elv-filter-count">{~D:Record.Count~}</span></button>`
		},
		{
			Hash: 'ErrorLogViewer-Table',
			Template: /*html*/`
				<p class="elv-count-label">{~D:AppData.ErrorLogViewer.TableCountLabel~}</p>
				<table class="elv-table">
					<thead><tr><th>Time</th><th>App</th><th>Message</th><th>Context</th><th></th></tr></thead>
					<tbody>{~TS:ErrorLogViewer-Row:AppData.ErrorLogViewer.Rows~}</tbody>
				</table>
				{~TS:ErrorLogViewer-TableEmpty:AppData.ErrorLogViewer.TableEmptySlot~}`
		},
		{
			Hash: 'ErrorLogViewer-Row',
			Template: /*html*/`
				<tr class="elv-row {~D:Record.RowClass~}" onclick="_Pict.providers.ErrorLogViewer.toggleRow({~D:Record.ID~})">
					<td class="elv-time">{~D:Record.Time~}</td>
					<td><span class="elv-badge {~D:Record.AppClass~}">{~D:Record.AppDisplay~}</span></td>
					<td class="elv-msg">{~D:Record.Message~}</td>
					<td class="elv-context">{~D:Record.Context~}</td>
					<td class="elv-chev"><i class="fas {~D:Record.Chevron~}"></i></td>
				</tr>
				{~TS:ErrorLogViewer-RowDetail:Record.DetailSlot~}`
		},
		{
			Hash: 'ErrorLogViewer-RowDetail',
			Template: /*html*/`
				<tr class="elv-detail-row">
					<td colspan="5">
						<div class="elv-detail-head">Stack trace</div>
						<pre class="elv-pre">{~D:Record.Stack~}</pre>
						{~TS:ErrorLogViewer-Cause:Record.CauseSlot~}
						<div class="elv-detail-head">Full payload</div>
						<pre class="elv-pre">{~D:Record.JSON~}</pre>
					</td>
				</tr>`
		},
		{
			Hash: 'ErrorLogViewer-Cause',
			Template: /*html*/`<div class="elv-detail-head">Context</div><pre class="elv-pre">{~D:Record.Cause~}</pre>`
		},
		{
			Hash: 'ErrorLogViewer-TableEmpty',
			Template: /*html*/`<p class="has-text-grey has-text-centered py-5">No errors match the current filters.</p>`
		},
		{
			Hash: 'ErrorLogViewer-Message',
			Template: /*html*/`<div class="notification {~D:Record.MessageClass~} is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'ErrorLogViewer-Loading',
			Template: /*html*/`<div class="elv-panel elv-empty has-text-grey has-text-centered"><span class="elv-spinner"></span><p class="mt-3">Loading the error log…</p></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'ErrorLogViewerWrap',
			TemplateHash: 'ErrorLogViewer-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-view":1053}],1443:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * FormConcierge — the thin standalone screen (#/FormConcierge[/:Flow[/:IDProject]] and #/FormConcierge/Session/:ID)
 * for platform super-users: drop files, describe a form, and converse with the plansheet form pipeline. The
 * FormConcierge provider paints the whole surface into #FormConcierge-Host (a centered column, not Dashboard Mode).
 * See [[FormConcierge-Provider.js]].
 */
class FormConciergeView extends libPictView
{
	/** @return {any} the screen provider */
	get provider() { return this.pict.providers['FormConcierge']; }

	/**
	 * @param {any} pRenderable
	 * @return {any}
	 */
	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._mount = '#FormConcierge-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = FormConciergeView;

module.exports.default_configuration =
{
	ViewIdentifier: 'FormConcierge',
	DefaultRenderable: 'FormConciergeWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: false,

	// Theme tokens (with fallbacks) only, so dark mode follows the app theme. Tints use color-mix over the status
	// tokens rather than fixed light colors. No max-height + overflow anywhere: the shell scrolls the page.
	CSS: /*css*/`
		.fcg-page { padding: 1.25rem 1rem 2.5rem; }
		.fcg { max-width: 980px; margin: 0 auto; display: flex; flex-direction: column; gap: 1rem; color: var(--theme-color-text-primary,#1f2733); }
		.fcg-hidden { display: none !important; }
		.fcg-muted { color: var(--theme-color-text-muted,#6b7686); font-size: 0.88rem; }

		/* Header */
		.fcg-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; flex-wrap: wrap; }
		.fcg-head-l { min-width: 0; flex: 1 1 26rem; }
		.fcg-title { font-size: 1.4rem; font-weight: 800; margin: 0 0 0.15rem; display: flex; align-items: center; gap: 0.6rem; color: var(--theme-color-text-primary,#1f2733); }
		.fcg-title i { color: var(--theme-color-brand-primary,#156dd1); }
		.fcg-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0; }
		.fcg-head-r { display: flex; gap: 0.4rem; flex-wrap: wrap; align-items: center; padding-top: 0.35rem; }
		.fcg-h2 { font-size: 1.02rem; font-weight: 800; margin: 0; color: var(--theme-color-text-primary,#1f2733); }

		/* Pills + chips (status colours ride the theme's status tokens) */
		.fcg-pill, .fcg-chip { display: inline-flex; align-items: center; gap: 0.3rem; border-radius: 999px; white-space: nowrap; border: 1px solid var(--theme-color-border-default,#d7dce3); background: var(--theme-color-background-secondary,#f5f6f8); color: var(--theme-color-text-secondary,#45505f); }
		.fcg-pill { padding: 0.25rem 0.7rem; font-size: 0.78rem; font-weight: 700; }
		.fcg-chip { padding: 0.1rem 0.55rem; font-size: 0.74rem; font-weight: 600; }
		.fcg-pill-env { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.fcg-chip-flow { border-color: var(--theme-color-brand-primary,#156dd1); color: var(--theme-color-brand-primary,#156dd1); background: transparent; }
		.fcg-st-ok { color: var(--theme-color-status-success,#2e7a3a); border-color: color-mix(in srgb, var(--theme-color-status-success,#2e7a3a) 45%, transparent); background: color-mix(in srgb, var(--theme-color-status-success,#2e7a3a) 10%, transparent); }
		.fcg-st-warn { color: var(--theme-color-status-warning,#a86b00); border-color: color-mix(in srgb, var(--theme-color-status-warning,#a86b00) 45%, transparent); background: color-mix(in srgb, var(--theme-color-status-warning,#a86b00) 10%, transparent); }
		.fcg-st-err { color: var(--theme-color-status-error,#b62828); border-color: color-mix(in srgb, var(--theme-color-status-error,#b62828) 45%, transparent); background: color-mix(in srgb, var(--theme-color-status-error,#b62828) 10%, transparent); }
		.fcg-st-run { color: var(--theme-color-status-info,#0e8fa8); border-color: color-mix(in srgb, var(--theme-color-status-info,#0e8fa8) 45%, transparent); background: color-mix(in srgb, var(--theme-color-status-info,#0e8fa8) 10%, transparent); }
		.fcg-st-off { color: var(--theme-color-text-muted,#6b7686); }
		.fcg-chips { display: flex; gap: 0.35rem; flex-wrap: wrap; }

		/* Notices */
		.fcg-note { display: flex; align-items: flex-start; gap: 0.6rem; padding: 0.9rem 1rem; border-radius: 10px; background: var(--theme-color-background-secondary,#f5f6f8); color: var(--theme-color-text-secondary,#45505f); font-size: 0.92rem; overflow-wrap: anywhere; }
		.fcg-note > i { margin-top: 0.15rem; }
		.fcg-note b { color: var(--theme-color-text-primary,#1f2733); }
		.fcg-note-locked, .fcg-note-warn { background: color-mix(in srgb, var(--theme-color-status-warning,#a86b00) 12%, var(--theme-color-background-primary,#fff)); color: var(--theme-color-status-warning,#a86b00); }
		.fcg-note-error { background: color-mix(in srgb, var(--theme-color-status-error,#b62828) 12%, var(--theme-color-background-primary,#fff)); color: var(--theme-color-status-error,#b62828); }

		/* Buttons */
		.fcg-btn { display: inline-flex; align-items: center; gap: 0.45rem; border: 1px solid var(--theme-color-border-default,#d7dce3); background: var(--theme-color-background-primary,#fff); color: var(--theme-color-text-primary,#1f2733); border-radius: 8px; padding: 0.5rem 0.95rem; font: 600 0.9rem/1.1 inherit; cursor: pointer; text-decoration: none; transition: background .12s, border-color .12s, filter .12s; }
		.fcg-btn:hover:not([disabled]) { background: var(--theme-color-background-hover,#eef1f6); }
		.fcg-btn[disabled] { opacity: 0.55; cursor: default; }
		.fcg-btn-primary { background: var(--theme-color-brand-primary,#156dd1); border-color: var(--theme-color-brand-primary,#156dd1); color: var(--theme-color-text-on-brand,#fff); }
		.fcg-btn-primary:hover:not([disabled]) { background: var(--theme-color-brand-primary-hover,#1059ad); }
		.fcg-btn-sm { padding: 0.3rem 0.65rem; font-size: 0.82rem; }
		.fcg-linkbtn { border: none; background: transparent; padding: 0; font: inherit; font-weight: 600; color: var(--theme-color-brand-primary,#156dd1); text-decoration: underline; cursor: pointer; }
		.fcg-iconbtn { border: none; background: transparent; padding: 0.15rem 0.35rem; color: var(--theme-color-text-muted,#6b7686); cursor: pointer; border-radius: 6px; }
		.fcg-iconbtn:hover { background: var(--theme-color-background-hover,#eef1f6); color: var(--theme-color-text-primary,#1f2733); }
		.fcg-back { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.85rem; font-weight: 600; color: var(--theme-color-brand-primary,#156dd1); text-decoration: none; }

		/* Flow segments */
		.fcg-flow { display: flex; flex-wrap: wrap; gap: 0.35rem; padding: 0.3rem; border-radius: 10px; background: var(--theme-color-background-secondary,#f5f6f8); border: 1px solid var(--theme-color-border-light,#e8ebf0); }
		.fcg-seg { flex: 1 1 10rem; display: inline-flex; align-items: center; justify-content: center; gap: 0.45rem; padding: 0.55rem 0.8rem; border-radius: 8px; font-weight: 700; font-size: 0.9rem; color: var(--theme-color-text-secondary,#45505f); text-decoration: none; }
		.fcg-seg:hover { background: var(--theme-color-background-hover,#eef1f6); color: var(--theme-color-text-primary,#1f2733); }
		.fcg-seg-on, .fcg-seg-on:hover { background: var(--theme-color-background-primary,#fff); color: var(--theme-color-brand-primary,#156dd1); box-shadow: 0 1px 3px var(--theme-color-shadow-color,rgba(15,23,42,0.12)); }

		/* Cards + form controls */
		.fcg-card { border: 1px solid var(--theme-color-border-default,#d7dce3); border-radius: 12px; background: var(--theme-color-background-panel,#fff); padding: 1rem 1.1rem; display: flex; flex-direction: column; gap: 0.75rem; }
		.fcg-label { font-size: 0.82rem; font-weight: 700; color: var(--theme-color-text-secondary,#45505f); margin: 0 0 0.3rem; display: block; }
		.fcg-label .fcg-muted { font-weight: 500; }
		.fcg-input { width: 100%; box-sizing: border-box; border: 1px solid var(--theme-color-border-default,#d7dce3); border-radius: 8px; padding: 0.5rem 0.7rem; font: 0.92rem inherit; background: var(--theme-color-background-primary,#fff); color: var(--theme-color-text-primary,#1f2733); }
		.fcg-input:focus { outline: 2px solid color-mix(in srgb, var(--theme-color-brand-primary,#156dd1) 40%, transparent); outline-offset: 1px; }
		.fcg-input[disabled] { opacity: 0.6; }
		.fcg-check { display: inline-flex; align-items: center; gap: 0.45rem; font-size: 0.88rem; margin-top: 0.5rem; color: var(--theme-color-text-secondary,#45505f); cursor: pointer; }
		.fcg-target { display: flex; flex-direction: column; gap: 0.35rem; }
		.fcg-deliver { margin-top: 0.4rem; }
		.fcg-fixed { display: flex; align-items: center; gap: 0.45rem; flex-wrap: wrap; font-size: 0.92rem; overflow-wrap: anywhere; }
		.fcg-picker { min-width: 0; }
		.fcg-targetinfo:empty { display: none; }

		/* Drop zone + staged files */
		.fcg-drop { border: 2px dashed var(--theme-color-border-default,#d7dce3); border-radius: 12px; padding: 1.1rem 1rem; text-align: center; background: var(--theme-color-background-secondary,#f5f6f8); color: var(--theme-color-text-primary,#1f2733); transition: border-color .12s, background .12s; }
		.fcg-drop-sm { padding: 0.6rem 0.8rem; font-size: 0.88rem; }
		.fcg-drop.fcg-dragover { border-color: var(--theme-color-brand-primary,#156dd1); background: var(--theme-color-background-selected,#e3edfb); }
		.fcg-drop-ic { color: var(--theme-color-brand-primary,#156dd1); margin-right: 0.25rem; }
		.fcg-drop-sub { margin-top: 0.3rem; font-size: 0.8rem; color: var(--theme-color-text-muted,#6b7686); }
		.fcg-files:empty { display: none; }
		.fcg-filelist { list-style: none; margin: 0.6rem 0 0; padding: 0; display: flex; flex-direction: column; gap: 0.35rem; }
		.fcg-file { border: 1px solid var(--theme-color-border-light,#e8ebf0); border-radius: 8px; padding: 0.45rem 0.6rem; background: var(--theme-color-background-primary,#fff); }
		.fcg-file-error { border-color: color-mix(in srgb, var(--theme-color-status-error,#b62828) 45%, transparent); }
		.fcg-file-row { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; font-size: 0.86rem; min-width: 0; }
		.fcg-file-row > i { color: var(--theme-color-text-muted,#6b7686); }
		.fcg-file-name { font-weight: 600; min-width: 0; flex: 1 1 12rem; overflow-wrap: anywhere; word-break: break-word; }
		.fcg-file-size { color: var(--theme-color-text-muted,#6b7686); font-size: 0.8rem; }
		.fcg-file-note { font-size: 0.76rem; color: var(--theme-color-text-muted,#6b7686); overflow-wrap: anywhere; }
		.fcg-file-actions { display: inline-flex; align-items: center; gap: 0.35rem; margin-left: auto; }
		.fcg-file-err { margin-top: 0.3rem; font-size: 0.8rem; color: var(--theme-color-status-error,#b62828); overflow-wrap: anywhere; }
		.fcg-bar { height: 4px; border-radius: 2px; background: var(--theme-color-background-tertiary,#eceef2); margin-top: 0.4rem; overflow: hidden; }
		.fcg-bar-fill { height: 100%; background: var(--theme-color-brand-primary,#156dd1); transition: width .2s; }

		/* Markdown boxes (pict-section-markdowneditor): one segment, no segment chrome, grows with its text */
		.fcg-editor { border: 1px solid var(--theme-color-border-default,#d7dce3); border-radius: 8px; background: var(--theme-color-background-primary,#fff); padding: 0.25rem 0.25rem 0; }
		.fcg-editor .pict-mde-add-segment, .fcg-editor .pict-mde-drag-handle, .fcg-editor .pict-mde-left-controls, .fcg-editor .pict-mde-image-preview, .fcg-editor .pict-mde-rich-preview { display: none; }
		.fcg-editor .cm-editor { min-height: 10rem; }
		.fcg-fu .fcg-editor .cm-editor { min-height: 6rem; }
		.fcg-guidance { font-size: 0.84rem; color: var(--theme-color-text-muted,#6b7686); overflow-wrap: anywhere; }
		.fcg-guidance:empty { display: none; }
		.fcg-go { display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap; }
		.fcg-go-note { font-size: 0.84rem; color: var(--theme-color-text-secondary,#45505f); overflow-wrap: anywhere; flex: 1 1 18rem; }
		.fcg-go-note:empty { display: none; }

		/* Sessions list */
		.fcg-sessions { display: flex; flex-direction: column; gap: 0.5rem; }
		.fcg-sess-h { display: flex; align-items: baseline; gap: 0.6rem; }
		.fcg-slist { display: flex; flex-direction: column; border: 1px solid var(--theme-color-border-default,#d7dce3); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-panel,#fff); }
		.fcg-srow { display: flex; align-items: center; gap: 0.5rem; padding: 0.6rem 0.85rem; text-decoration: none; color: inherit; border-top: 1px solid var(--theme-color-border-light,#e8ebf0); flex-wrap: wrap; }
		.fcg-srow:first-child { border-top: none; }
		.fcg-srow:hover { background: var(--theme-color-background-hover,#eef1f6); }
		.fcg-srow-main { display: flex; flex-direction: column; min-width: 0; flex: 1 1 16rem; }
		.fcg-srow-name { font-weight: 700; font-size: 0.92rem; overflow-wrap: anywhere; }
		.fcg-srow-req { font-size: 0.78rem; color: var(--theme-color-text-muted,#6b7686); overflow-wrap: anywhere; }
		.fcg-srow-when { font-size: 0.78rem; color: var(--theme-color-text-muted,#6b7686); margin-left: auto; white-space: nowrap; }

		/* Session header */
		.fcg-shead { display: flex; flex-direction: column; gap: 0.3rem; }
		.fcg-shead-row { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
		.fcg-shead-t { font-size: 1.15rem; font-weight: 800; margin: 0; overflow-wrap: anywhere; }
		.fcg-shead-sub, .fcg-shead-mirror { font-size: 0.84rem; color: var(--theme-color-text-muted,#6b7686); overflow-wrap: anywhere; }
		.fcg-mirror-warn { color: var(--theme-color-status-warning,#a86b00); }
		.fcg-mirror-on a, .fcg-shead-link a { color: var(--theme-color-brand-primary,#156dd1); font-weight: 600; }

		/* Thread */
		.fcg-thread { display: flex; flex-direction: column; gap: 0.75rem; }
		.fcg-turn { border: 1px solid var(--theme-color-border-default,#d7dce3); border-radius: 12px; padding: 0.75rem 0.95rem; background: var(--theme-color-background-panel,#fff); min-width: 0; }
		.fcg-turn-user { background: var(--theme-color-background-secondary,#f5f6f8); border-color: var(--theme-color-border-light,#e8ebf0); }
		.fcg-turn-h { display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.45rem; flex-wrap: wrap; }
		.fcg-turn-who { font-weight: 800; font-size: 0.86rem; display: inline-flex; align-items: center; gap: 0.4rem; }
		.fcg-turn-assistant .fcg-turn-who i { color: var(--theme-color-brand-primary,#156dd1); }
		.fcg-turn-when { margin-left: auto; font-size: 0.76rem; color: var(--theme-color-text-muted,#6b7686); }
		.fcg-meta { margin-top: 0.6rem; padding-top: 0.6rem; border-top: 1px dashed var(--theme-color-border-light,#e8ebf0); font-size: 0.86rem; overflow-wrap: anywhere; }
		.fcg-meta pre { white-space: pre-wrap; }
		.fcg-attach { display: flex; gap: 0.35rem; flex-wrap: wrap; margin-top: 0.5rem; }
		.fcg-det { margin-top: 0.55rem; font-size: 0.84rem; }
		.fcg-det > summary { cursor: pointer; color: var(--theme-color-text-secondary,#45505f); font-weight: 600; }
		.fcg-pre { background: var(--theme-color-background-tertiary,#eceef2); color: var(--theme-color-text-primary,#1f2733); padding: 0.55rem 0.65rem; border-radius: 6px; font: 0.8rem/1.45 ui-monospace, SFMono-Regular, Menlo, monospace; white-space: pre-wrap; overflow-wrap: anywhere; word-break: break-word; margin: 0.4rem 0 0; }
		.fcg-linkhost { margin-left: 0.25rem; font-size: 0.78em; color: var(--theme-color-text-muted,#6b7686); }

		/* Rendered remote markdown — overflow guards keep long tokens, tables and code inside the column */
		.fcg-md { font-size: 0.92rem; line-height: 1.5; overflow-wrap: anywhere; word-break: break-word; }
		.fcg-md > * { max-width: 100%; }
		.fcg-md > :first-child { margin-top: 0; } .fcg-md > :last-child { margin-bottom: 0; }
		.fcg-md p { margin: 0.35rem 0; }
		.fcg-md ul, .fcg-md ol { margin: 0.35rem 0; padding-left: 1.3rem; } .fcg-md li { margin: 0.1rem 0; }
		.fcg-md h1, .fcg-md h2, .fcg-md h3, .fcg-md h4, .fcg-md h5, .fcg-md h6 { font-size: 1em; font-weight: 800; margin: 0.6rem 0 0.25rem; }
		.fcg-md h1, .fcg-md h2 { font-size: 1.06em; }
		.fcg-md code { background: var(--theme-color-background-tertiary,#eceef2); padding: 0.05rem 0.3rem; border-radius: 4px; font-size: 0.86em; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; overflow-wrap: anywhere; }
		.fcg-md pre { background: var(--theme-color-background-tertiary,#eceef2); padding: 0.55rem 0.65rem; border-radius: 6px; overflow-x: auto; max-width: 100%; }
		.fcg-md pre code { background: none; padding: 0; overflow-wrap: normal; word-break: normal; }
		.fcg-md table { display: block; width: 100%; max-width: 100%; overflow-x: auto; border-collapse: collapse; margin: 0.45rem 0; font-size: 0.86em; }
		.fcg-md th, .fcg-md td { border: 1px solid var(--theme-color-border-default,#d7dce3); padding: 0.25rem 0.5rem; text-align: left; vertical-align: top; }
		.fcg-md th { background: var(--theme-color-background-secondary,#f5f6f8); }
		.fcg-md a { color: var(--theme-color-brand-primary,#156dd1); overflow-wrap: anywhere; word-break: break-word; }
		.fcg-md blockquote { border-left: 3px solid var(--theme-color-border-default,#d7dce3); margin: 0.35rem 0; padding: 0.1rem 0.65rem; color: var(--theme-color-text-secondary,#45505f); }
		.fcg-md hr { border: none; border-top: 1px solid var(--theme-color-border-light,#e8ebf0); margin: 0.6rem 0; }

		/* Run status */
		.fcg-runwrap:empty { display: none; }
		.fcg-run { border-radius: 10px; padding: 0.7rem 0.9rem; border: 1px solid var(--theme-color-border-default,#d7dce3); font-size: 0.9rem; }
		.fcg-run-main { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
		.fcg-run-actions { display: inline-flex; gap: 0.4rem; margin-left: auto; flex-wrap: wrap; }
		.fcg-run-sub { margin-top: 0.3rem; font-size: 0.82rem; opacity: 0.9; overflow-wrap: anywhere; }
		.fcg-run-err { margin-top: 0.4rem; font-size: 0.82rem; color: var(--theme-color-status-error,#b62828); overflow-wrap: anywhere; }
		.fcg-elapsed { font-variant-numeric: tabular-nums; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.86rem; }
		.fcg-stage { font-size: 0.82rem; color: var(--theme-color-text-secondary,#45505f); overflow-wrap: anywhere; }

		/* Follow-up + next steps */
		.fcg-fu-actions { display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap; }
		.fcg-fu-locked .fcg-drop { opacity: 0.85; }
		.fcg-next { border: 1px solid var(--theme-color-border-default,#d7dce3); border-radius: 12px; padding: 0.8rem 1rem; background: var(--theme-color-background-panel,#fff); }
		.fcg-next-h { font-weight: 800; font-size: 0.9rem; margin-bottom: 0.5rem; }
		.fcg-next-actions { display: flex; gap: 0.5rem; flex-wrap: wrap; }
	`,

	Templates:
	[
		{
			Hash: 'FormConcierge-Template',
			Template: html`
				<section class="section fcg-page">
					<div id="FormConcierge-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'FormConciergeWrap',
			TemplateHash: 'FormConcierge-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1444:[function(require,module,exports){
'use strict';

/**
 * Important Project Files — host view (read-only navigator; management is entitlement-gated).
 *
 * Standalone project-scoped screen modeled on Sample Plan: a project-picker front door (shown when no project
 * is loaded) and, once a project is chosen (deep link #/ImportantFiles/:ID), a recursive collapsible folder
 * tree built from the provider's in-memory model. Client-side name filter + expand/collapse, plus per-file
 * download of the current version. With the 'manage-important-files' entitlement, per-row + toolbar affordances
 * appear (New folder / subfolder, rename, move, delete folder; rename, move, remove file; and Upload — toolbar
 * or per-folder, multi-file with a progress overlay) via modal prompts + confirms. A per-file Versions action
 * (read-only) lists every version with a download. Size visualization arrives in a later phase.
 */

const libPictView = require('pict-view');

const html = String.raw;
const fEsc = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[pChar]));
const fAttr = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));

const FILE_ICONS = { File: 'fa-file-lines', Image: 'fa-file-image', Video: 'fa-file-video', Audio: 'fa-file-audio' };
const fFileIcon = (pType) => FILE_ICONS[pType] || 'fa-file-lines';

const fDate = (pValue) =>
{
	if (!pValue) { return ''; }
	const tmpDate = new Date(pValue);
	return Number.isNaN(tmpDate.getTime()) ? '' : tmpDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const TREE_MOUNT = '#ImportantFiles-Tree';

class ImportantFiles extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._projectFilterTimer = null;
		this._projectLoadToken = 0;
		this._collapsed = new Set();   // folder RowIDs the user has collapsed (open by default)
		this._nameFilter = '';
		this._nameFilterTimer = null;
		// When embedded in a host (the ProjectWorkspace Data ▸ Important Files tab) this holds that host selector,
		// and every render — including provider-triggered repaints — targets it instead of the app container.
		this._embedDestination = null;
	}

	get provider() { return this.pict.providers['ImportantFiles']; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }
	_toast(pMessage, pType, pDuration) { if (this.modal && (typeof this.modal.toast === 'function')) { const tmpOptions = { type: pType || 'info' }; if (pDuration !== undefined) { tmpOptions.duration = pDuration; } this.modal.toast(pMessage, tmpOptions); } }

	/** Render into the embed host when embedded (so provider `_render()` repaints land in the Data tab, not the app
	 *  container). An explicit destination argument always wins. */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed the navigator into a host element for a fixed project (skips the front-door picker). ProjectWorkspace's
	 *  Data ▸ Important Files tab calls this after each paint; it only reloads when the loaded project differs. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		const tmpState = (this.pict.AppData && this.pict.AppData.ImportantFiles) || {};
		if (this.provider && (!tmpState.HasModel || (Number(this.provider.idProject) !== Number(pIDProject))))
		{
			this.provider.loadAsync(pIDProject);   // provider._render → this.render → the host
		}
		else { this.render(); }   // already loaded for this project — just (re)paint into the host
	}

	/** Leave embedded mode — the standalone #/ImportantFiles screen renders to the app container again. */
	exitEmbed() { this._embedDestination = null; }

	onBeforeRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.ImportantFiles) || {};
		// Mutually-exclusive body modes via the single-element-array slot trick (Sample Plan pattern).
		tmpState.LoadingSlot = tmpState.Loading ? [ tmpState ] : [];
		tmpState.ErrorSlot = (!tmpState.Loading && tmpState.Message) ? [ tmpState ] : [];
		tmpState.PickerSlot = (!tmpState.Loading && !tmpState.Message && !tmpState.HasModel) ? [ tmpState ] : [];
		tmpState.TreeSlot = (!tmpState.Loading && tmpState.HasModel) ? [ tmpState ] : [];
		// Management is entitlement-gated (Task-Catalog 'manage-important-files'); everyone else stays read-only.
		// The pill only shows once a project is loaded — no need on the picker.
		tmpState.CanManage = !!(this.provider && this.provider.canManage());
		tmpState.ReadOnlySlot = (tmpState.HasModel && !tmpState.Loading && !tmpState.CanManage) ? [ tmpState ] : [];
		tmpState.ManageSlot = (tmpState.HasModel && !tmpState.Loading && tmpState.CanManage) ? [ tmpState ] : [];
		tmpState.TitleText = (tmpState.HasModel && tmpState.ProjectName) ? `Important Files — ${tmpState.ProjectName}` : 'Important Project Files';
		tmpState.SubText = tmpState.HasModel
			? `${tmpState.FolderCount || 0} folder${(tmpState.FolderCount === 1) ? '' : 's'} · ${tmpState.FileCount || 0} file${(tmpState.FileCount === 1) ? '' : 's'}`
			: 'Organize a project’s important files into folders.';
		// Embedded in the ProjectWorkspace Data tab: drop the standalone header chrome + full-page framing (the
		// workspace supplies the project context); the standalone screen leaves this empty.
		tmpState.EmbedClass = this._embedDestination ? 'if-embedded' : '';
		this.pict.AppData.ImportantFiles = tmpState;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.ImportantFiles) || {};
		if (tmpState.HasModel && !tmpState.Loading) { this.renderTree(); }
		else if (tmpState.PickerSlot && tmpState.PickerSlot.length) { this._initProjectPicker(); }
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	// --- Front door: filterable project list (mirrors Sample Plan) ----------------------------------

	_initProjectPicker()
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#ImportantFiles-ProjectList');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpInput = document.getElementById('ImportantFiles-ProjectFilter');
		this._loadProjects(tmpInput ? tmpInput.value : '');
	}

	onProjectFilter(pValue)
	{
		if (this._projectFilterTimer) { clearTimeout(this._projectFilterTimer); }
		this._projectFilterTimer = setTimeout(() => { this._loadProjects(pValue); }, 200);
	}

	_loadProjects(pTerm)
	{
		const tmpProvider = this.provider;
		if (!tmpProvider) { return; }
		const tmpToken = (this._projectLoadToken = (this._projectLoadToken || 0) + 1);
		tmpProvider.searchProjectsAsync(pTerm).then((pProjects) =>
		{
			if (tmpToken === this._projectLoadToken) { this._renderProjectList(pProjects, pTerm); }
		}).catch(() =>
		{
			if (tmpToken === this._projectLoadToken) { this.pict.ContentAssignment.assignContent('#ImportantFiles-ProjectList', '<div class="if-note if-err">Could not load projects.</div>'); }
		});
	}

	_renderProjectList(pProjects, pTerm)
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#ImportantFiles-ProjectList');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpList = Array.isArray(pProjects) ? pProjects : [];
		if (!tmpList.length)
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			this.pict.ContentAssignment.assignContent('#ImportantFiles-ProjectList', `<div class="if-note">${tmpTerm ? `No projects match “${fEsc(tmpTerm)}”.` : 'No projects available.'}</div>`);
			return;
		}
		const tmpRows = tmpList.map((pProject) =>
			`<button type="button" class="if-proj-row" onclick="_Pict.views.ImportantFiles.openProject(${Number(pProject.IDProject)})">`
			+ `<span class="if-proj-name">${fEsc(pProject.Name)}</span>`
			+ `<span class="if-proj-go"><i class="fas fa-chevron-right"></i></span></button>`).join('');
		const tmpCapNote = (tmpList.length >= 100) ? '<div class="if-note if-cap">Showing the first 100 — type to narrow the list.</div>' : '';
		this.pict.ContentAssignment.assignContent('#ImportantFiles-ProjectList', tmpRows + tmpCapNote);
	}

	/** Open a project's important files (deep link the router resolves + loads). */
	openProject(pIDProject)
	{
		const tmpID = Number(pIDProject);
		if (Number.isFinite(tmpID) && (tmpID > 0)) { window.location.hash = `#/ImportantFiles/${tmpID}`; }
	}

	/** Back to the project picker (the no-ID route resets the model). */
	chooseAnotherProject() { window.location.hash = '#/ImportantFiles'; }

	// --- Folder tree --------------------------------------------------------------------------------

	/** (Re)build the tree HTML into the mount, honoring the name filter + collapse state. */
	renderTree()
	{
		const tmpMount = this.pict.ContentAssignment.getElement(TREE_MOUNT);
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		// Row-level management affordances render only when the entitlement is held (recomputed each render).
		this._canManage = !!(this.pict.AppData.ImportantFiles && this.pict.AppData.ImportantFiles.CanManage);
		const tmpTerm = String(this._nameFilter || '').trim().toLowerCase();
		const tmpTree = tmpTerm ? this._filterNodes(this.provider.tree, tmpTerm) : this.provider.tree;
		if (!tmpTree || !tmpTree.length)
		{
			const tmpEmpty = tmpTerm
				? `<div class="if-empty-state"><i class="fas fa-magnifying-glass"></i><p>No files or folders match “${fEsc(this._nameFilter)}”.</p></div>`
				: '<div class="if-empty-state"><i class="fas fa-folder-open"></i><p>This project has no important files yet.</p></div>';
			this.pict.ContentAssignment.assignContent(TREE_MOUNT, tmpEmpty);
			return;
		}
		// While filtering, force every surviving folder open so matches are visible.
		const tmpHTML = tmpTree.map((pNode) => this._nodeHTML(pNode, !!tmpTerm)).join('');
		this.pict.ContentAssignment.assignContent(TREE_MOUNT, tmpHTML);
	}

	/** Prune the tree to nodes matching the term: files by name; folders kept if their name matches (whole
	 *  subtree) or any descendant file matches. Returns a new array (does not mutate the model). */
	_filterNodes(pNodes, pTerm)
	{
		const tmpResult = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			const tmpNode = pNodes[i];
			const tmpMatch = String(tmpNode.Name || '').toLowerCase().indexOf(pTerm) >= 0;
			if (!tmpNode.IsFolder)
			{
				if (tmpMatch) { tmpResult.push(tmpNode); }
				continue;
			}
			if (tmpMatch)
			{
				// Folder name matches -> keep it and its whole subtree.
				tmpResult.push(tmpNode);
				continue;
			}
			const tmpKeptChildren = this._filterNodes(tmpNode.Children || [], pTerm);
			if (tmpKeptChildren.length) { tmpResult.push(Object.assign({}, tmpNode, { Children: tmpKeptChildren })); }
		}
		return tmpResult;
	}

	_nodeHTML(pNode, pForceOpen)
	{
		const tmpManage = this._canManage;
		if (!pNode.IsFolder)
		{
			const tmpRowID = fAttr(pNode.RowID);
			const tmpActions = tmpManage
				? `<button type="button" class="if-act" title="Rename" aria-label="Rename ${fAttr(pNode.Name)}" onclick="_Pict.views.ImportantFiles.renameFile('${tmpRowID}', event)"><i class="fas fa-pen"></i></button>`
					+ `<button type="button" class="if-act" title="Move to another folder" onclick="_Pict.views.ImportantFiles.moveFile('${tmpRowID}', event)"><i class="fas fa-folder-tree"></i></button>`
					+ `<button type="button" class="if-act if-act-danger" title="Remove from important files" onclick="_Pict.views.ImportantFiles.removeFile('${tmpRowID}', event)"><i class="fas fa-xmark"></i></button>`
				: '';
			return html`<div class="if-file" data-file="${tmpRowID}" data-name="${fAttr(String(pNode.Name || '').toLowerCase())}">`
				+ `<i class="if-icon fas ${fFileIcon(pNode.FileType)}"></i>`
				+ `<button type="button" class="if-name if-file-name" title="Download current version" onclick="_Pict.views.ImportantFiles.downloadFile('${tmpRowID}', event)">${fEsc(pNode.Name)}</button>`
				+ `<span class="if-type">${fEsc(pNode.FileType)}</span>`
				+ `<span class="if-meta">${fEsc(fDate(pNode.Date))}</span>`
				+ `<span class="if-row-actions">${tmpActions}`
				+ `<button type="button" class="if-act" title="Versions" aria-label="Versions of ${fAttr(pNode.Name)}" onclick="_Pict.views.ImportantFiles.showVersions('${tmpRowID}', event)"><i class="fas fa-clock-rotate-left"></i></button>`
				+ `<button type="button" class="if-dl" title="Download current version" aria-label="Download ${fAttr(pNode.Name)}" onclick="_Pict.views.ImportantFiles.downloadFile('${tmpRowID}', event)"><i class="fas fa-download"></i></button>`
				+ `</span></div>`;
		}
		const tmpRowID = fAttr(pNode.RowID);
		const tmpOpen = pForceOpen || !this._collapsed.has(pNode.RowID);
		const tmpChildren = pNode.Children || [];
		const tmpBody = tmpChildren.length
			? tmpChildren.map((pChild) => this._nodeHTML(pChild, pForceOpen)).join('')
			: '<div class="if-folder-empty">This folder is empty.</div>';
		const tmpFolderIcon = pNode.IsCustomer ? 'fa-box-archive' : (tmpOpen ? 'fa-folder-open' : 'fa-folder');
		const tmpBadge = tmpChildren.length ? `<span class="if-badge">${tmpChildren.length}</span>` : '';
		// The synthetic 'Customer Files' bucket isn't a real folder — no folder actions on it.
		const tmpActions = (tmpManage && !pNode.IsCustomer)
			? `<span class="if-row-actions">`
				+ `<button type="button" class="if-act" title="Upload files here" onclick="_Pict.views.ImportantFiles.uploadToFolder('${tmpRowID}', event)"><i class="fas fa-cloud-arrow-up"></i></button>`
				+ `<button type="button" class="if-act" title="Add an existing observation here" onclick="_Pict.views.ImportantFiles.addFromObservationsFolder('${tmpRowID}', event)"><i class="fas fa-clipboard-list"></i></button>`
				+ `<button type="button" class="if-act" title="New subfolder" onclick="_Pict.views.ImportantFiles.newSubfolder('${tmpRowID}', event)"><i class="fas fa-folder-plus"></i></button>`
				+ `<button type="button" class="if-act" title="Rename" onclick="_Pict.views.ImportantFiles.renameFolder('${tmpRowID}', event)"><i class="fas fa-pen"></i></button>`
				+ `<button type="button" class="if-act" title="Move" onclick="_Pict.views.ImportantFiles.moveFolder('${tmpRowID}', event)"><i class="fas fa-arrow-right-arrow-left"></i></button>`
				+ `<button type="button" class="if-act if-act-danger" title="Delete folder" onclick="_Pict.views.ImportantFiles.deleteFolder('${tmpRowID}', event)"><i class="fas fa-trash"></i></button>`
				+ `</span>`
			: '';
		return html`<div class="if-folder${pNode.IsCustomer ? ' is-customer' : ''}" data-folder="${tmpRowID}">`
			+ `<div class="if-frow">`
			+ `<button type="button" class="if-frow-toggle" onclick="_Pict.views.ImportantFiles.toggleFolder('${tmpRowID}')">`
			+ `<i class="if-caret fas ${tmpOpen ? 'fa-caret-down' : 'fa-caret-right'}"></i>`
			+ `<i class="if-icon if-foldericon fas ${tmpFolderIcon}"></i>`
			+ `<span class="if-name">${fEsc(pNode.Name)}</span>`
			+ tmpBadge
			+ (pNode.IsCustomer ? '<span class="if-tag" title="Files that are important but not in a folder">not in a folder</span>' : '')
			+ `</button>`
			+ tmpActions
			+ `</div>`
			+ `<div class="if-fbody${tmpOpen ? '' : ' is-hidden'}">${tmpBody}</div>`
			+ `</div>`;
	}

	/** Expand/collapse one folder by DOM toggle (keeps scroll; no full re-render). */
	toggleFolder(pRowID)
	{
		const tmpFolder = document.querySelector(`[data-folder="${(window.CSS && CSS.escape) ? CSS.escape(pRowID) : pRowID}"]`);
		if (!tmpFolder) { return; }
		const tmpBody = tmpFolder.querySelector(':scope > .if-fbody');
		const tmpCaret = tmpFolder.querySelector(':scope > .if-frow > .if-frow-toggle > .if-caret');
		const tmpIcon = tmpFolder.querySelector(':scope > .if-frow > .if-frow-toggle > .if-foldericon');
		if (!tmpBody) { return; }
		tmpBody.classList.toggle('is-hidden');
		const tmpCollapsed = tmpBody.classList.contains('is-hidden');
		if (tmpCaret) { tmpCaret.classList.toggle('fa-caret-down', !tmpCollapsed); tmpCaret.classList.toggle('fa-caret-right', tmpCollapsed); }
		if (tmpIcon && !tmpFolder.classList.contains('is-customer')) { tmpIcon.classList.toggle('fa-folder-open', !tmpCollapsed); tmpIcon.classList.toggle('fa-folder', tmpCollapsed); }
		if (tmpCollapsed) { this._collapsed.add(pRowID); } else { this._collapsed.delete(pRowID); }
	}

	expandAll() { this._collapsed.clear(); this.renderTree(); }

	collapseAll()
	{
		const fCollect = (pNodes) => pNodes.forEach((pNode) => { if (pNode.IsFolder) { this._collapsed.add(pNode.RowID); fCollect(pNode.Children || []); } });
		fCollect(this.provider.tree || []);
		this.renderTree();
	}

	onNameFilter(pValue)
	{
		if (this._nameFilterTimer) { clearTimeout(this._nameFilterTimer); }
		this._nameFilterTimer = setTimeout(() => { this._nameFilter = pValue || ''; this.renderTree(); }, 180);
	}

	// --- Download (Phase 2) -------------------------------------------------------------------------

	/** Download a file's CURRENT version. Fast path: stream a same-origin media URL straight to disk via a plain
	 *  download anchor (no memory blob — safe for big videos). Fallback: fetch the bytes through the authenticated
	 *  rest client (legacy rows / cross-origin) and save the blob. Per-row spinner while in flight; toast on
	 *  failure. Read-only — no server mutation. */
	async downloadFile(pRowID, pEvent)
	{
		if (pEvent && (typeof pEvent.stopPropagation === 'function')) { pEvent.stopPropagation(); }
		const tmpNode = this.provider && this.provider.findNode(pRowID);
		if (!tmpNode || tmpNode.IsFolder) { return; }
		const tmpRow = document.querySelector(`[data-file="${(window.CSS && CSS.escape) ? CSS.escape(pRowID) : pRowID}"]`);
		const tmpButton = tmpRow ? tmpRow.querySelector('.if-dl') : null;
		const tmpIcon = tmpButton ? tmpButton.querySelector('i') : null;
		if (tmpButton && tmpButton.classList.contains('is-loading')) { return; }   // a download is already in flight
		if (tmpButton) { tmpButton.classList.add('is-loading'); tmpButton.disabled = true; }
		if (tmpIcon) { tmpIcon.className = 'fas fa-spinner fa-spin'; }
		try
		{
			const tmpDirect = this.provider.directDownloadURL(tmpNode);
			if (tmpDirect)
			{
				// Anchor click is fire-and-forget (the browser's own download UI shows progress); a brief spinner
				// just acknowledges the click landed.
				this._triggerAnchorDownload(tmpDirect.url, tmpDirect.filename);
				await new Promise((resolve) => setTimeout(resolve, 600));
			}
			else
			{
				const tmpResult = await this.provider.resolveDownloadAsync(tmpNode);
				this._triggerBrowserDownload(tmpResult.blob, tmpResult.filename);
			}
		}
		catch (pError)
		{
			this.pict.log.error(`ImportantFiles: download failed for ${pRowID}: ${pError && pError.message ? pError.message : pError}`, pError);
			this._toast(`Could not download “${tmpNode.Name}”.${pError && pError.message ? ' ' + pError.message : ''}`, 'error', 6000);
		}
		finally
		{
			if (tmpButton) { tmpButton.classList.remove('is-loading'); tmpButton.disabled = false; }
			if (tmpIcon) { tmpIcon.className = 'fas fa-download'; }
		}
	}

	/** Stream a (same-origin) URL to disk via a transient download anchor — the browser attaches the session cookie
	 *  and honors the download attribute; nothing is buffered in memory. */
	_triggerAnchorDownload(pURL, pFilename)
	{
		const tmpAnchor = document.createElement('a');
		tmpAnchor.href = pURL;
		tmpAnchor.download = pFilename || 'download';
		tmpAnchor.rel = 'noopener';
		document.body.appendChild(tmpAnchor);
		tmpAnchor.click();
		tmpAnchor.remove();
	}

	/** Save an in-memory Blob to the user's machine via a transient object-URL anchor (fallback path). */
	_triggerBrowserDownload(pBlob, pFilename)
	{
		const tmpURL = URL.createObjectURL(pBlob);
		this._triggerAnchorDownload(tmpURL, pFilename);
		setTimeout(() => { try { URL.revokeObjectURL(tmpURL); } catch (pErr) { /* object URL already gone */ } }, 10000);
	}
	// --- Management (Phase 4: folder + file operations) ---------------------------------------------

	/** Run a provider mutation with consistent UX: success/error toast (the provider silently reloads the tree). */
	async _runManageOp(pWorkFn, pSuccessMessage)
	{
		try
		{
			await pWorkFn();
			if (pSuccessMessage) { this._toast(pSuccessMessage, 'success'); }
		}
		catch (pError)
		{
			this.pict.log.error(`ImportantFiles: management op failed: ${pError && pError.message ? pError.message : pError}`, pError);
			this._toast((pError && pError.message) ? pError.message : 'That didn’t work — please try again.', 'error', 6000);
		}
	}

	/** Prompt for a single line of text (rename/new name). Resolves to the trimmed value, or null if cancelled/empty. */
	async _promptText(pTitle, pLabel, pCurrent, pConfirmLabel, pPlaceholder)
	{
		const tmpChoice = await this.modal.show(
			{
				title: pTitle,
				content: `<p class="if-modal-label">${fEsc(pLabel)}</p><input type="text" id="if-text-input" class="input" value="${fAttr(pCurrent || '')}" placeholder="${fAttr(pPlaceholder || '')}">`,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: pConfirmLabel || 'Save', Style: 'primary' } ],
				onOpen: () => { const tmpEl = document.getElementById('if-text-input'); if (tmpEl) { tmpEl.focus(); tmpEl.select(); } },
			});
		if (tmpChoice !== 'ok') { return null; }
		const tmpValue = ((document.getElementById('if-text-input') || {}).value || '').trim();
		return tmpValue || null;
	}

	/** Prompt for a destination folder (a <select> of real folders + 'Top level'). Resolves to a folder ID (0 =
	 *  top level), or null if cancelled. `pExcludeFolderID` omits a folder + its subtree (folder moves only). */
	async _promptFolderTarget(pTitle, pExcludeFolderID)
	{
		const tmpChoices = this.provider.folderChoices(pExcludeFolderID);
		const tmpOptions = [ '<option value="0">— Top level (not in a folder) —</option>' ]
			.concat(tmpChoices.map((pC) => `<option value="${pC.ID}">${'&nbsp;&nbsp;&nbsp;'.repeat(pC.Depth)}${fEsc(pC.Name)}</option>`))
			.join('');
		const tmpChoice = await this.modal.show(
			{
				title: pTitle,
				content: `<p class="if-modal-label">Move to</p><div class="select is-fullwidth"><select id="if-move-target">${tmpOptions}</select></div>`,
				buttons: [ { Hash: 'cancel', Label: 'Cancel' }, { Hash: 'ok', Label: 'Move', Style: 'primary' } ],
			});
		if (tmpChoice !== 'ok') { return null; }
		const tmpValue = (document.getElementById('if-move-target') || {}).value;
		return (tmpValue == null) ? null : Number(tmpValue);
	}

	newRootFolder() { this._createFolderFlow(0, 'New folder'); }

	newSubfolder(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		this._createFolderFlow(tmpNode.ID, `New folder in “${tmpNode.Name}”`);
	}

	async _createFolderFlow(pParentID, pTitle)
	{
		const tmpName = await this._promptText(pTitle, 'Folder name', '', 'Create folder', 'e.g. Inspection Photos');
		if (!tmpName) { return; }
		await this._runManageOp(() => this.provider.createFolderAsync(tmpName, pParentID), `Created “${tmpName}”.`);
	}

	async renameFolder(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		const tmpName = await this._promptText('Rename folder', 'Folder name', tmpNode.Name, 'Save');
		if (!tmpName || tmpName === tmpNode.Name) { return; }
		await this._runManageOp(() => this.provider.renameFolderAsync(tmpNode, tmpName), `Renamed to “${tmpName}”.`);
	}

	async renameFile(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		const tmpName = await this._promptText('Rename file', 'File name', tmpNode.Name, 'Save');
		if (!tmpName || tmpName === tmpNode.Name) { return; }
		await this._runManageOp(() => this.provider.renameFileAsync(tmpNode, tmpName), `Renamed to “${tmpName}”.`);
	}

	async moveFolder(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		const tmpTarget = await this._promptFolderTarget(`Move “${tmpNode.Name}”`, tmpNode.ID);
		if (tmpTarget == null) { return; }
		await this._runManageOp(() => this.provider.moveFolderAsync(tmpNode, tmpTarget), `Moved “${tmpNode.Name}”.`);
	}

	async moveFile(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		const tmpTarget = await this._promptFolderTarget(`Move “${tmpNode.Name}”`, null);
		if (tmpTarget == null) { return; }
		await this._runManageOp(() => this.provider.moveFileAsync(tmpNode, tmpTarget), `Moved “${tmpNode.Name}”.`);
	}

	async deleteFolder(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		if (tmpNode.Children && tmpNode.Children.length)
		{
			this._toast('This folder isn’t empty. Move or remove everything inside it first.', 'warning', 5000);
			return;
		}
		const tmpOk = await this.modal.confirm(`Delete the folder “${tmpNode.Name}”?`, { title: 'Delete folder', confirmLabel: 'Delete', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk) { return; }
		await this._runManageOp(() => this.provider.deleteFolderAsync(tmpNode), `Deleted “${tmpNode.Name}”.`);
	}

	async removeFile(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		const tmpOk = await this.modal.confirm(`Remove “${tmpNode.Name}” from this project’s important files? The file stays on its observation — this only unlists it here.`, { title: 'Remove file', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk) { return; }
		await this._runManageOp(() => this.provider.removeFileAsync(tmpNode), `Removed “${tmpNode.Name}”.`);
	}

	// --- Upload (Phase 5) ---------------------------------------------------------------------------

	/** Toolbar upload → top level (not in a folder). */
	uploadToRoot() { this._pickAndUpload(0); }

	/** Folder-row 'upload here' → into that folder. */
	uploadToFolder(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (tmpNode) { this._pickAndUpload(tmpNode.ID); }
	}

	/** Open the OS file picker (multi-select) and upload whatever is chosen into pFolderID. */
	_pickAndUpload(pFolderID)
	{
		let tmpInput = document.getElementById('ImportantFiles-FileInput');
		if (!tmpInput)
		{
			tmpInput = document.createElement('input');
			tmpInput.type = 'file';
			tmpInput.id = 'ImportantFiles-FileInput';
			tmpInput.multiple = true;
			tmpInput.style.display = 'none';
			document.body.appendChild(tmpInput);
		}
		tmpInput.value = '';
		tmpInput.onchange = () =>
		{
			const tmpFiles = Array.from(tmpInput.files || []);
			tmpInput.onchange = null;
			if (tmpFiles.length) { this._uploadFiles(tmpFiles, pFolderID); }
		};
		tmpInput.click();
	}

	/** Upload a batch sequentially with a progress overlay; reload the tree once at the end; summarize via toast. */
	async _uploadFiles(pFiles, pFolderID)
	{
		const tmpTotal = pFiles.length;
		let tmpDone = 0;
		const tmpFailed = [];
		this._showUploadProgress();
		for (let i = 0; i < pFiles.length; i++)
		{
			const tmpFile = pFiles[i];
			const tmpLabel = `Uploading ${tmpFile.name} (${i + 1} of ${tmpTotal})…`;
			this._updateUploadProgress(null, tmpLabel);
			try
			{
				await this.provider.uploadFileAsync(tmpFile, pFolderID, (pEvent) =>
				{
					const tmpPct = this._progressPercent(pEvent);
					if (tmpPct !== null) { this._updateUploadProgress(tmpPct, tmpLabel); }
				});
				tmpDone++;
			}
			catch (pError)
			{
				this.pict.log.error(`ImportantFiles: upload failed for ${tmpFile.name}: ${pError && pError.message ? pError.message : pError}`, pError);
				tmpFailed.push(tmpFile.name);
			}
		}
		this._hideUploadProgress();
		try { await this.provider._reloadTreeAsync(); } catch (pErr) { /* the uploads landed; a failed refresh self-heals on next load */ }
		if (!tmpFailed.length) { this._toast(`Uploaded ${tmpDone} file${tmpDone === 1 ? '' : 's'}.`, 'success'); }
		else if (tmpDone > 0) { this._toast(`Uploaded ${tmpDone}, but ${tmpFailed.length} failed: ${tmpFailed.join(', ')}`, 'warning', 7000); }
		else { this._toast(`Upload failed: ${tmpFailed.join(', ')}`, 'error', 7000); }
	}

	/** Coax a 0–100 percentage out of whatever postBinary hands the progress callback (ProgressEvent, {percent},
	 *  or a bare number), or null when it isn't computable (→ the bar stays indeterminate). */
	_progressPercent(pEvent)
	{
		if (pEvent == null) { return null; }
		if (typeof pEvent === 'number') { return (pEvent <= 1) ? Math.round(pEvent * 100) : Math.round(pEvent); }
		if (pEvent.lengthComputable && pEvent.total) { return Math.round((pEvent.loaded / pEvent.total) * 100); }
		if (typeof pEvent.percent === 'number') { return Math.round(pEvent.percent); }
		if ((typeof pEvent.loaded === 'number') && (typeof pEvent.total === 'number') && pEvent.total) { return Math.round((pEvent.loaded / pEvent.total) * 100); }
		return null;
	}

	_showUploadProgress()
	{
		this._hideUploadProgress();
		const tmpEl = document.createElement('div');
		tmpEl.id = 'ImportantFiles-UploadProgress';
		tmpEl.className = 'if-upload-overlay';
		tmpEl.innerHTML = '<div class="if-upload-card"><div class="if-upload-title"><i class="fas fa-cloud-arrow-up"></i> Uploading</div>'
			+ '<div class="if-upload-label">Preparing…</div><div class="if-upload-bar"><div class="if-upload-fill is-indeterminate"></div></div></div>';
		document.body.appendChild(tmpEl);
	}

	_updateUploadProgress(pPct, pLabel)
	{
		const tmpEl = document.getElementById('ImportantFiles-UploadProgress');
		if (!tmpEl) { return; }
		const tmpFill = tmpEl.querySelector('.if-upload-fill');
		const tmpLabel = tmpEl.querySelector('.if-upload-label');
		if (tmpLabel && pLabel) { tmpLabel.textContent = pLabel; }
		if (tmpFill && (pPct !== null) && (pPct !== undefined))
		{
			tmpFill.classList.remove('is-indeterminate');
			tmpFill.style.width = Math.max(0, Math.min(100, pPct)) + '%';
		}
	}

	_hideUploadProgress() { const tmpEl = document.getElementById('ImportantFiles-UploadProgress'); if (tmpEl) { tmpEl.remove(); } }

	// --- Add existing observations (list an observation's file without re-uploading it) -------------

	/** Folder-row 'add observation here' → open the picker with that folder pre-selected as the destination. */
	addFromObservationsFolder(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		this.addFromObservations(tmpNode ? tmpNode.ID : 0);
	}

	/**
	 * Open a searchable picker of the project's file/photo observations; each row adds a ProjectFile pointer into a
	 * chosen destination folder (no re-upload — it lists the existing observation's file). Multi-add: the modal
	 * stays open so several can be added; the tree reloads once on close if anything was added.
	 * @param {Number} pFolderID destination folder to pre-select (0 = top level)
	 */
	async addFromObservations(pFolderID)
	{
		this._addObsFilterTimer = null;
		this._addObsLoadToken = 0;
		this._addObsAddedCount = 0;
		this._addObsRowsByID = {};
		const tmpFolderOptions = [ '<option value="0">— Top level (not in a folder) —</option>' ]
			.concat(this.provider.folderChoices(null).map((pC) => `<option value="${pC.ID}"${(Number(pC.ID) === Number(pFolderID)) ? ' selected' : ''}>${'&nbsp;&nbsp;&nbsp;'.repeat(pC.Depth)}${fEsc(pC.Name)}</option>`))
			.join('');
		const tmpContent = `<div class="if-addobs">`
			+ `<p class="if-modal-label">Add to folder</p>`
			+ `<div class="select is-fullwidth"><select id="if-addobs-folder">${tmpFolderOptions}</select></div>`
			+ `<div class="if-search if-addobs-search"><i class="fas fa-magnifying-glass"></i><input id="if-addobs-search" type="text" autocomplete="off" placeholder="Search files by name…" oninput="_Pict.views.ImportantFiles.onAddObsSearch(this.value)" /></div>`
			+ `<p class="if-addobs-note">Only observations that carry a file or photo can be added. Ones already listed here are hidden.</p>`
			+ `<div id="if-addobs-results" class="if-addobs-results"><div class="if-note"><i class="fas fa-spinner fa-spin"></i> Loading observations…</div></div>`
			+ `</div>`;
		await this.modal.show(
			{
				title: 'Add existing observation',
				content: tmpContent,
				buttons: [ { Hash: 'done', Label: 'Done', Style: 'primary' } ],
				width: '620px',
				onOpen: () => { const tmpEl = document.getElementById('if-addobs-search'); if (tmpEl) { tmpEl.focus(); } this._reloadAddObs(''); },
			});
		// Reflect all additions in the tree once, after the picker closes (per-add skips the reload).
		if (this._addObsAddedCount > 0) { try { await this.provider._reloadTreeAsync(); } catch (pErr) { /* the pointers landed; a failed refresh self-heals on next load */ } }
	}

	/** One-time load of the project's importable observations into the provider cache, then render (search over the
	 *  cache is client-side, so this only runs when the picker opens). */
	_reloadAddObs(pTerm)
	{
		const tmpMount = document.getElementById('if-addobs-results');
		if (!tmpMount) { return; }
		tmpMount.innerHTML = '<div class="if-note"><i class="fas fa-spinner fa-spin"></i> Loading observations…</div>';
		const tmpToken = (this._addObsLoadToken = (this._addObsLoadToken || 0) + 1);
		this.provider.loadImportableObservationsAsync().then(() =>
		{
			if (tmpToken === this._addObsLoadToken) { this._renderAddObsFromCache(pTerm); }
		}).catch(() =>
		{
			if (tmpToken === this._addObsLoadToken) { tmpMount.innerHTML = '<div class="if-note if-err">Could not load observations.</div>'; }
		});
	}

	onAddObsSearch(pValue)
	{
		if (this._addObsFilterTimer) { clearTimeout(this._addObsFilterTimer); }
		this._addObsFilterTimer = setTimeout(() => { this._renderAddObsFromCache(pValue); }, 160);
	}

	/** Render the cached importable observations narrowed by the current filename filter (client-side; sync). */
	_renderAddObsFromCache(pTerm)
	{
		const tmpMount = document.getElementById('if-addobs-results');
		if (!tmpMount) { return; }
		const tmpResult = this.provider.filterImportableObservations(pTerm);
		const tmpList = (tmpResult && tmpResult.rows) || [];
		this._addObsRowsByID = {};
		tmpList.forEach((pRow) => { this._addObsRowsByID[Number(pRow.IDObservation)] = pRow; });
		if (!tmpList.length)
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			tmpMount.innerHTML = `<div class="if-note">${tmpTerm ? `No files match “${fEsc(tmpTerm)}”.` : 'No observations with a file to add.'}</div>`;
			return;
		}
		// Honest count line: how many matched, whether the render list was capped, and whether older files weren't fetched.
		let tmpNote = '';
		if (tmpResult.total > tmpResult.shown) { tmpNote = `Showing the first ${tmpResult.shown} of ${tmpResult.total} — type to narrow.`; }
		else if (tmpResult.truncated) { tmpNote = `Showing files from the ${this.provider.importableCap} most recent observations — type to narrow.`; }
		const tmpNoteHTML = tmpNote ? `<div class="if-note if-cap">${fEsc(tmpNote)}</div>` : '';
		tmpMount.innerHTML = tmpList.map((pRow) => this._addObsRowHTML(pRow)).join('') + tmpNoteHTML;
	}

	_addObsRowHTML(pRow)
	{
		const tmpID = Number(pRow.IDObservation);
		return `<div class="if-addobs-row" data-obs="${tmpID}">`
			+ `<i class="if-icon fas ${fFileIcon(pRow.FileType)}"></i>`
			+ `<span class="if-addobs-name" title="${fAttr(pRow.Name)}">${fEsc(pRow.Name)}</span>`
			+ `<span class="if-type">${fEsc(pRow.FileType)}</span>`
			+ `<span class="if-meta">${fEsc(fDate(pRow.Date))}</span>`
			+ `<button type="button" class="if-addobs-add" onclick="_Pict.views.ImportantFiles.addObservationRow(${tmpID}, this)"><i class="fas fa-plus"></i> Add</button>`
			+ `</div>`;
	}

	_addObsHintFor(pIDObservation) { return (this._addObsRowsByID && this._addObsRowsByID[Number(pIDObservation)]) || null; }

	/** Add one observation row into the currently-selected destination folder; marks the row done on success. */
	async addObservationRow(pIDObservation, pButtonEl)
	{
		const tmpFolderEl = document.getElementById('if-addobs-folder');
		const tmpFolderID = tmpFolderEl ? Number(tmpFolderEl.value) : 0;
		if (pButtonEl) { pButtonEl.disabled = true; pButtonEl.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; }
		try
		{
			const tmpResult = await this.provider.addExistingObservationAsync(pIDObservation, tmpFolderID, this._addObsHintFor(pIDObservation), true);
			this._addObsAddedCount = (this._addObsAddedCount || 0) + 1;
			if (pButtonEl) { pButtonEl.classList.add('is-added'); pButtonEl.innerHTML = '<i class="fas fa-check"></i> Added'; }
			this._toast(`Added “${tmpResult.Name}”.`, 'success');
		}
		catch (pError)
		{
			this.pict.log.error(`ImportantFiles: add observation ${pIDObservation} failed: ${pError && pError.message ? pError.message : pError}`, pError);
			if (pButtonEl) { pButtonEl.disabled = false; pButtonEl.innerHTML = '<i class="fas fa-plus"></i> Add'; }
			this._toast((pError && pError.message) ? pError.message : 'Could not add that observation.', 'error', 6000);
		}
	}

	// --- Versions (Phase 6) -------------------------------------------------------------------------

	/** Open a modal listing every version of a file (newest first), each downloadable. A read affordance — no
	 *  entitlement needed. Extension point: per-version metadata, previews, restore, diffing. */
	async showVersions(pRowID, pEvent)
	{
		if (pEvent && pEvent.stopPropagation) { pEvent.stopPropagation(); }
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode || tmpNode.IsFolder) { return; }
		let tmpData;
		try { tmpData = await this.provider.listVersionsAsync(tmpNode); }
		catch (pError) { this._toast(`Could not load versions.${pError && pError.message ? ' ' + pError.message : ''}`, 'error', 6000); return; }
		// Cache the resolved artifact ref so per-version downloads skip re-fetching the observation.
		this._versionsRef = { idArtifact: tmpData.idArtifact, currentVersion: tmpData.currentVersion, fileName: tmpData.fileName, mime: tmpData.mime };
		const tmpRows = tmpData.versions.map((pVersion) => this._versionRowHTML(pRowID, pVersion)).join('');
		const tmpNote = (tmpData.versions.length === 1)
			? 'This file has a single version.'
			: `${tmpData.versions.length} versions — the current file plus its earlier uploads.`;
		await this.modal.show(
			{
				title: `Versions — ${tmpNode.Name}`,
				content: `<div class="if-versions"><p class="if-ver-note">${fEsc(tmpNote)}</p><div class="if-ver-list">${tmpRows}</div></div>`,
				buttons: [ { Hash: 'close', Label: 'Close', Style: 'primary' } ],
				width: '540px',
			});
	}

	_versionRowHTML(pRowID, pVersion)
	{
		const tmpDate = pVersion.date ? fDate(pVersion.date) : '';
		const tmpMeta = (pVersion.isCurrent ? '<span class="if-ver-current">Current</span>' : 'Previous version')
			+ (tmpDate ? ` · ${fEsc(tmpDate)}` : '');
		return `<div class="if-ver-row${pVersion.isCurrent ? ' is-current' : ''}">`
			+ `<span class="if-ver-badge"><i class="fas fa-code-branch"></i> v${pVersion.version}</span>`
			+ `<span class="if-ver-meta">${tmpMeta}</span>`
			+ `<button type="button" class="if-ver-dl" onclick="_Pict.views.ImportantFiles.downloadFileVersion('${fAttr(pRowID)}', ${Number(pVersion.version)}, this)"><i class="fas fa-download"></i> Download</button>`
			+ `</div>`;
	}

	/** Download one specific version (called from a version row's button, which passes itself for the spinner). */
	async downloadFileVersion(pRowID, pVersion, pButtonEl)
	{
		const tmpNode = this.provider.findNode(pRowID);
		if (!tmpNode) { return; }
		const tmpIcon = pButtonEl ? pButtonEl.querySelector('i') : null;
		if (pButtonEl) { pButtonEl.disabled = true; }
		if (tmpIcon) { tmpIcon.className = 'fas fa-spinner fa-spin'; }
		try
		{
			const tmpResult = await this.provider.downloadVersionAsync(tmpNode, pVersion, this._versionsRef);
			this._triggerBrowserDownload(tmpResult.blob, tmpResult.filename);
		}
		catch (pError)
		{
			this.pict.log.error(`ImportantFiles: version ${pVersion} download failed: ${pError && pError.message ? pError.message : pError}`, pError);
			this._toast(`Could not download version ${pVersion}.${pError && pError.message ? ' ' + pError.message : ''}`, 'error', 6000);
		}
		finally
		{
			if (pButtonEl) { pButtonEl.disabled = false; }
			if (tmpIcon) { tmpIcon.className = 'fas fa-download'; }
		}
	}

}

module.exports = ImportantFiles;
module.exports.default_configuration = {
	ViewIdentifier: 'ImportantFiles',
	DefaultRenderable: 'ImportantFilesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.if-wrap { max-width: 1000px; margin: 0 auto; padding: 1.5rem 1.25rem 4rem; }
		.if-head { display: flex; align-items: flex-start; gap: 0.85rem; margin-bottom: 1.25rem; }
		.if-head-ic { flex: none; width: 2.4rem; height: 2.4rem; border-radius: 10px; display: grid; place-items: center; background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.1rem; }
		.if-title { font-size: 1.5rem; font-weight: 700; margin: 0; line-height: 1.15; color: var(--theme-color-text-primary, #1f2733); }
		.if-sub { margin: 0.15rem 0 0; color: var(--theme-color-text-secondary, #5b6673); font-size: 0.92rem; }
		.if-head-spacer { flex: 1 1 auto; }
		.if-head-btn { flex: none; display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; cursor: pointer; padding: 0.4rem 0.75rem; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.if-head-btn:hover { background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-primary, #1f2733); }
		.if-ro-pill { flex: none; align-self: center; display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.25rem 0.55rem; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-muted, #8a94a3); border: 1px solid var(--theme-color-border-light, #e8ebf0); cursor: default; }
		.if-ro-pill i { font-size: 0.68rem; }

		.if-state { padding: 2.5rem 1rem; text-align: center; color: var(--theme-color-text-secondary, #5b6673); }
		.if-state i { margin-right: 0.4rem; }

		/* Front door */
		.if-picker { max-width: 620px; margin: 0.5rem auto 0; }
		.if-picker-h { font-size: 1.05rem; font-weight: 600; margin: 0 0 0.2rem; }
		.if-picker-sub { color: var(--theme-color-text-secondary, #5b6673); font-size: 0.9rem; margin: 0 0 0.9rem; }
		.if-proj-filter { width: 100%; padding: 0.6rem 0.8rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; font: inherit; font-size: 0.95rem; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); margin-bottom: 0.8rem; }
		.if-proj-filter:focus { outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: -1px; }
		.if-proj-list { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; overflow: hidden; }
		.if-proj-row { display: flex; align-items: center; gap: 0.6rem; width: 100%; text-align: left; border: none; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-panel, #fff); padding: 0.65rem 0.9rem; cursor: pointer; font: inherit; color: var(--theme-color-text-primary, #1f2733); }
		.if-proj-row:last-child { border-bottom: none; }
		.if-proj-row:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.if-proj-name { flex: 1 1 auto; font-size: 0.92rem; }
		.if-proj-go { flex: none; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.8rem; }
		.if-note { padding: 0.9rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.86rem; text-align: center; }
		.if-note.if-err { color: var(--theme-color-status-error, #cf5b5b); }
		.if-note.if-cap { border-top: 1px solid var(--theme-color-border-light, #e8ebf0); }

		/* Tree toolbar */
		.if-toolbar { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; margin-bottom: 0.85rem; }
		.if-search { position: relative; flex: 1 1 240px; }
		.if-search i { position: absolute; left: 0.7rem; top: 50%; transform: translateY(-50%); color: var(--theme-color-text-muted, #8a94a3); font-size: 0.85rem; }
		.if-search input { width: 100%; padding: 0.5rem 0.7rem 0.5rem 2rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; font: inherit; font-size: 0.9rem; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.if-search input:focus { outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: -1px; }
		.if-tool-btn { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.8rem; cursor: pointer; padding: 0.45rem 0.7rem; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.if-tool-btn:hover { background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-primary, #1f2733); }

		/* Tree */
		.if-tree { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 12px; background: var(--theme-color-background-panel, #fff); padding: 0.5rem 0.4rem; min-height: 6rem; }
		.if-folder { }
		.if-fbody { padding-left: 1.35rem; border-left: 1px dotted var(--theme-color-border-default, #d7dce3); margin-left: 0.75rem; }
		.if-fbody.is-hidden { display: none; }
		.if-frow { display: flex; align-items: center; border-radius: 7px; }
		.if-frow-toggle { display: flex; align-items: center; gap: 0.5rem; flex: 1 1 auto; min-width: 0; text-align: left; border: none; background: transparent; cursor: pointer; font: inherit; padding: 0.4rem 0.55rem; color: var(--theme-color-text-primary, #1f2733); }
		.if-frow:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.if-row-actions { display: inline-flex; align-items: center; gap: 0.05rem; flex: none; padding-right: 0.25rem; }
		.if-file .if-row-actions { margin-left: 0.25rem; }
		.if-act { border: none; background: transparent; cursor: pointer; color: var(--theme-color-text-muted, #8a94a3); padding: 0.2rem 0.42rem; border-radius: 6px; opacity: 0; transition: opacity 0.12s ease, color 0.12s ease, background 0.12s ease; font-size: 0.8rem; }
		.if-frow:hover .if-act, .if-file:hover .if-act { opacity: 0.7; }
		.if-act:hover { opacity: 1; color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); }
		.if-act.if-act-danger:hover { color: var(--theme-color-status-error, #cf5b5b); background: rgba(207, 91, 91, 0.12); }
		.if-act:focus-visible { opacity: 1; outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: -1px; }
		.if-tool-primary { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
		.if-tool-primary:hover { background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); }
		.if-modal-label { margin: 0 0 0.4rem; font-size: 0.85rem; color: var(--theme-color-text-secondary, #5b6673); }
		/* Add-existing-observation picker (modal) */
		.if-addobs-search { margin: 0.7rem 0 0; flex: none; }
		.if-addobs-note { font-size: 0.78rem; color: var(--theme-color-text-muted, #8a94a3); margin: 0.5rem 0 0.4rem; }
		.if-addobs-results { display: flex; flex-direction: column; gap: 0.35rem; max-height: 46vh; overflow-y: auto; margin-top: 0.4rem; }
		.if-addobs-row { display: flex; align-items: center; gap: 0.6rem; padding: 0.45rem 0.6rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.if-addobs-row .if-icon { color: var(--theme-color-text-secondary, #5b6673); }
		.if-addobs-name { flex: 1 1 auto; min-width: 0; font-size: 0.88rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--theme-color-text-primary, #1f2733); }
		.if-addobs-add { flex: none; display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.8rem; cursor: pointer; padding: 0.32rem 0.7rem; border-radius: 7px; border: 1px solid var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-brand-primary, #156dd1); }
		.if-addobs-add:hover { background: var(--theme-color-background-selected, #e3edfb); }
		.if-addobs-add[disabled] { cursor: default; }
		.if-addobs-add.is-added { border-color: var(--theme-color-border-light, #e8ebf0); color: var(--theme-color-status-success, #3a9e5c); background: var(--theme-color-background-panel, #fff); }
		.if-upload-overlay { position: fixed; inset: 0; background: rgba(20, 25, 35, 0.4); display: flex; align-items: center; justify-content: center; z-index: 10000; }
		.if-upload-card { background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 12px; padding: 1.4rem 1.6rem; min-width: 340px; max-width: 80vw; box-shadow: 0 16px 44px rgba(0, 0, 0, 0.28); }
		.if-upload-title { font-size: 1rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); margin-bottom: 0.7rem; }
		.if-upload-title i { color: var(--theme-color-brand-primary, #156dd1); margin-right: 0.35rem; }
		.if-upload-label { font-size: 0.86rem; color: var(--theme-color-text-secondary, #5b6673); margin-bottom: 0.7rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.if-upload-bar { height: 8px; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); overflow: hidden; position: relative; }
		.if-upload-fill { height: 100%; background: var(--theme-color-brand-primary, #156dd1); border-radius: 999px; width: 0; transition: width 0.15s ease; }
		.if-upload-fill.is-indeterminate { width: 35%; animation: if-upload-slide 1.1s ease-in-out infinite; }
		@keyframes if-upload-slide { 0% { transform: translateX(-120%); } 100% { transform: translateX(320%); } }
		.if-versions { }
		.if-ver-note { font-size: 0.85rem; color: var(--theme-color-text-secondary, #5b6673); margin: 0 0 0.85rem; }
		.if-ver-list { display: flex; flex-direction: column; gap: 0.4rem; max-height: 55vh; overflow-y: auto; }
		.if-ver-row { display: flex; align-items: center; gap: 0.75rem; padding: 0.55rem 0.75rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.if-ver-row.is-current { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); }
		.if-ver-badge { flex: none; font-weight: 600; font-size: 0.85rem; font-variant-numeric: tabular-nums; color: var(--theme-color-text-primary, #1f2733); }
		.if-ver-badge i { color: var(--theme-color-text-muted, #8a94a3); margin-right: 0.25rem; font-size: 0.72rem; }
		.if-ver-meta { flex: 1 1 auto; font-size: 0.8rem; color: var(--theme-color-text-secondary, #5b6673); }
		.if-ver-current { display: inline-block; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-brand-primary, #156dd1); }
		.if-ver-dl { flex: none; display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.8rem; cursor: pointer; padding: 0.35rem 0.7rem; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.if-ver-dl:hover { background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-brand-primary, #156dd1); }
		.if-ver-dl[disabled] { opacity: 0.6; cursor: default; }
		.if-caret { width: 0.7rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.8rem; flex: none; }
		.if-icon { flex: none; font-size: 0.92rem; }
		.if-foldericon { color: var(--theme-color-brand-primary, #156dd1); }
		.if-folder.is-customer > .if-frow .if-foldericon { color: var(--theme-color-text-muted, #8a94a3); }
		.if-name { flex: 0 1 auto; font-size: 0.9rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.if-frow .if-name { font-weight: 500; }
		.if-badge { flex: none; font-size: 0.68rem; font-weight: 600; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-secondary, #f0f2f6); border-radius: 999px; padding: 0.05rem 0.45rem; }
		.if-tag { flex: none; font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); }
		.if-file { display: flex; align-items: center; gap: 0.5rem; padding: 0.38rem 0.55rem 0.38rem 1.25rem; border-radius: 7px; }
		.if-file:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.if-file .if-icon { color: var(--theme-color-text-secondary, #5b6673); }
		.if-file .if-name { flex: 1 1 auto; }
		.if-file-name { text-align: left; border: none; background: transparent; cursor: pointer; font: inherit; font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); padding: 0; }
		.if-file-name:hover { color: var(--theme-color-brand-primary, #156dd1); text-decoration: underline; }
		.if-file-name:focus-visible { outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: 2px; border-radius: 3px; }
		.if-dl { flex: none; border: none; background: transparent; cursor: pointer; color: var(--theme-color-text-muted, #8a94a3); padding: 0.2rem 0.4rem; border-radius: 6px; opacity: 0.5; transition: opacity 0.12s ease, color 0.12s ease, background 0.12s ease; }
		.if-file:hover .if-dl { opacity: 1; }
		.if-dl:hover { color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-selected, #e3edfb); }
		.if-dl:focus-visible { opacity: 1; outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: -1px; }
		.if-dl.is-loading { opacity: 1; cursor: default; color: var(--theme-color-text-muted, #8a94a3); background: transparent; }
		.if-dl[disabled] { cursor: default; }
		.if-type { flex: none; font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); }
		.if-meta { flex: none; font-size: 0.76rem; color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; }
		.if-folder-empty { padding: 0.35rem 0.55rem 0.35rem 1.25rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.82rem; font-style: italic; }
		.if-empty-state { text-align: center; padding: 2.5rem 1rem; color: var(--theme-color-text-muted, #8a94a3); }
		.if-empty-state i { font-size: 1.6rem; display: block; margin-bottom: 0.5rem; opacity: 0.7; }
		.if-empty-state p { margin: 0; font-size: 0.9rem; }

		/* Embedded in the ProjectWorkspace Data tab: shed the standalone page framing + header chrome (the workspace
		   header already names the project; the tab label already says "Important Files"). */
		.section.if-embedded { padding: 0; }
		.if-embedded .if-wrap { max-width: none; margin: 0; padding: 0; }
		.if-embedded .if-head { margin: 0 0 0.5rem; }
		.if-embedded .if-head-ic, .if-embedded .if-head > div, .if-embedded .if-head-spacer, .if-embedded .if-head-btn { display: none; }
	`,

	Templates:
	[
		{
			Hash: 'ImportantFiles-Template',
			Template: html`
				<section class="section {~D:AppData.ImportantFiles.EmbedClass~}">
					<div class="if-wrap">
						<div class="if-head">
							<span class="if-head-ic"><i class="fas fa-folder-tree"></i></span>
							<div>
								<h1 class="if-title">{~D:AppData.ImportantFiles.TitleText~}</h1>
								<p class="if-sub">{~D:AppData.ImportantFiles.SubText~}</p>
							</div>
							{~TS:ImportantFiles-ReadOnly:AppData.ImportantFiles.ReadOnlySlot~}
							<span class="if-head-spacer"></span>
							{~TS:ImportantFiles-ChangeProject:AppData.ImportantFiles.TreeSlot~}
						</div>
						{~TS:ImportantFiles-Loading:AppData.ImportantFiles.LoadingSlot~}
						{~TS:ImportantFiles-Error:AppData.ImportantFiles.ErrorSlot~}
						{~TS:ImportantFiles-Picker:AppData.ImportantFiles.PickerSlot~}
						{~TS:ImportantFiles-Body:AppData.ImportantFiles.TreeSlot~}
					</div>
				</section>`,
		},
		{ Hash: 'ImportantFiles-ReadOnly', Template: html`<span class="if-ro-pill" title="You can browse and download these files. Creating folders, moving, and adding or removing files needs the “Manage important project files” entitlement."><i class="fas fa-lock"></i> Read-only</span>` },
		{ Hash: 'ImportantFiles-NewFolderBtn', Template: html`<button type="button" class="if-tool-btn if-tool-primary" onclick="_Pict.views.ImportantFiles.newRootFolder()"><i class="fas fa-folder-plus"></i> New folder</button>` },
		{ Hash: 'ImportantFiles-AddObsBtn', Template: html`<button type="button" class="if-tool-btn" onclick="_Pict.views.ImportantFiles.addFromObservations(0)"><i class="fas fa-clipboard-list"></i> Add observation</button>` },
		{ Hash: 'ImportantFiles-UploadBtn', Template: html`<button type="button" class="if-tool-btn if-tool-primary" onclick="_Pict.views.ImportantFiles.uploadToRoot()"><i class="fas fa-cloud-arrow-up"></i> Upload</button>` },
		{ Hash: 'ImportantFiles-ChangeProject', Template: html`<button type="button" class="if-head-btn" onclick="_Pict.views.ImportantFiles.chooseAnotherProject()"><i class="fas fa-arrow-left"></i> Choose another project</button>` },
		{ Hash: 'ImportantFiles-Loading', Template: html`<div class="if-state"><i class="fas fa-spinner fa-spin"></i> Loading files…</div>` },
		{ Hash: 'ImportantFiles-Error', Template: html`<div class="if-state"><i class="fas fa-triangle-exclamation"></i> {~D:Record.Message~}</div>` },
		{
			Hash: 'ImportantFiles-Picker',
			Template: html`
				<div class="if-picker">
					<h2 class="if-picker-h">Open a project’s important files</h2>
					<p class="if-picker-sub">Pick a project from the list below, or type to filter by name.</p>
					<input id="ImportantFiles-ProjectFilter" class="if-proj-filter" type="text" autocomplete="off" placeholder="Filter projects by name…" oninput="_Pict.views.ImportantFiles.onProjectFilter(this.value)" />
					<div id="ImportantFiles-ProjectList" class="if-proj-list"><div class="if-note"><i class="fas fa-spinner fa-spin"></i> Loading projects…</div></div>
				</div>`,
		},
		{
			Hash: 'ImportantFiles-Body',
			Template: html`
				<div class="if-toolbar">
					<div class="if-search"><i class="fas fa-magnifying-glass"></i><input type="text" autocomplete="off" placeholder="Filter files &amp; folders…" oninput="_Pict.views.ImportantFiles.onNameFilter(this.value)" /></div>
					<button type="button" class="if-tool-btn" onclick="_Pict.views.ImportantFiles.expandAll()"><i class="fas fa-angles-down"></i> Expand all</button>
					<button type="button" class="if-tool-btn" onclick="_Pict.views.ImportantFiles.collapseAll()"><i class="fas fa-angles-up"></i> Collapse all</button>
					{~TS:ImportantFiles-NewFolderBtn:AppData.ImportantFiles.ManageSlot~}
					{~TS:ImportantFiles-AddObsBtn:AppData.ImportantFiles.ManageSlot~}
					{~TS:ImportantFiles-UploadBtn:AppData.ImportantFiles.ManageSlot~}
				</div>
				<div id="ImportantFiles-Tree" class="if-tree"></div>`,
		},
	],

	Renderables:
	[
		{ RenderableHash: 'ImportantFilesWrap', TemplateHash: 'ImportantFiles-Template', DestinationAddress: '#PlatformConfiguration-Application-Container' },
	],
};

},{"pict-view":1053}],1445:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// Small additions on top of the reused .pew-* form styles: the required mark, and the inline notes that report
// the resolved project and the packet size (the two things a user cannot see but needs to know before saving).
const ICW_CSS = /*css*/`
	.icw-req { color: var(--theme-color-status-error, #cf5b5b); font-weight: 700; }
	.icw-note { display: block; margin-top: 0.35rem; font-size: 0.78rem; line-height: 1.35; color: var(--theme-color-text-muted, #6b7686); }
	.icw-note-ok { color: var(--theme-color-status-success, #3a8a63); }
	.icw-note-bad { color: var(--theme-color-status-error, #cf5b5b); }
	.icw-project { min-height: 1.1rem; }
`;

/**
 * InspectionCreateWorkspace — the bespoke Inspection CREATE screen, reached by the app-router Create bridge on
 * #/PSRS/Inspection/Create (which shadows the generic record-set create form).
 *
 * A thin shell: all data, behavior and hand-built form HTML live in the InspectionCreateWorkspace provider,
 * which assigns into the #ICW-Body mount. Reuses the Edit workspace's .pew-* CSS.
 */
class InspectionCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.InspectionCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = InspectionCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'InspectionCreateWorkspace',
	DefaultRenderable: 'InspectionCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libProjectEditWorkspace.default_configuration.CSS + ICW_CSS,
	Templates:
	[
		{
			Hash: 'InspectionCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="ICW-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'InspectionCreateWorkspaceWrap',
			TemplateHash: 'InspectionCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./ProjectEditWorkspace.js":1463,"pict-view":1053}],1446:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * InspectionSchedule — the thin standalone screen (#/InspectionSchedule[/:View]) that hosts the program-level asset
 * inspection schedule (Year / Month / Week / Agenda). The InspectionSchedule provider paints the whole screen into
 * #InspectionSchedule-Host. Full browser width via Dashboard Mode. See [[InspectionSchedule-Provider.js]].
 */
class InspectionScheduleView extends libPictView
{
	get provider() { return this.pict.providers['InspectionSchedule']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._mount = '#InspectionSchedule-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = InspectionScheduleView;

module.exports.default_configuration =
{
	ViewIdentifier: 'InspectionSchedule',
	DefaultRenderable: 'InspectionScheduleWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.isc-page { padding: 1.25rem 2rem 2rem; }
		.isc-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.isc-page-h i { color: var(--theme-color-brand-primary,#2e7d74); }
		.isc-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1rem; }
	`,

	Templates:
	[
		{
			Hash: 'InspectionSchedule-Template',
			Template: html`
				<section class="section isc-page">
					<h1 class="isc-page-h"><i class="fas fa-calendar-check"></i> Inspection Schedule</h1>
					<p class="isc-page-sub">Plan and run the inspection program — every scheduled and dynamic asset inspection, by year, month, week, or agenda.</p>
					<div id="InspectionSchedule-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'InspectionScheduleWrap',
			TemplateHash: 'InspectionSchedule-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1447:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * ManageCustomers — the #/ManageCustomers screen. A platform-super-user-only surface (the start of the bespoke
 * level-5 customer-management tooling): the customers a super-user can administer, each with a "Manage
 * Configuration" action that impersonates the customer's configuration admin so their configuration can be managed.
 *
 * Thin shell (like SuperUserGrant.js) — all data + logic + hand-built HTML live in the ManageCustomers provider,
 * which assigns into the #MC-Body mount. The impersonation itself goes through the single app client method
 * PlatformConfiguration-Application-Web.impersonateCustomerAdmin(); the level gate stays _isSuperUser().
 */
class ManageCustomers extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ManageCustomers; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ManageCustomers;
module.exports.default_configuration =
{
	ViewIdentifier: 'ManageCustomers',
	DefaultRenderable: 'ManageCustomersWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.mc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.mc-head { margin: 0 0 1rem; }
		.mc-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.mc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; max-width:60rem; }
		.mc-guard { border:1px solid var(--theme-color-status-warning,#b8860b); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.5rem; text-align:center; color:var(--theme-color-text-secondary,#45505f); }
		.mc-guard-title { font-size:1.05rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.4rem; }
		.mc-note { padding:0.9rem; font-size:0.9rem; color:var(--theme-color-text-muted,#8894a4); }
		.mc-error { padding:0.9rem; font-size:0.88rem; color:var(--theme-color-status-danger,#c0392b); }
		.mc-filter { width:100%; max-width:32rem; box-sizing:border-box; font-size:0.95rem; padding:0.55rem 0.75rem; margin:0 0 0.8rem;
			border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.mc-filter:focus { outline:none; border-color:var(--theme-color-primary,#2f6fed); box-shadow:0 0 0 2px rgba(47,111,237,0.15); }
		.mc-list { border:1px solid var(--theme-color-border-light,#eef1f5); border-radius:10px; overflow:hidden; max-height:64vh; overflow-y:auto; background:var(--theme-color-background-primary,#fff); max-width:56rem; }
		.mc-head-row { display:flex; align-items:center; gap:0.9rem; padding:0.45rem 0.9rem; font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8a94a3); background:var(--theme-color-background-secondary,#f4f6f9); border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.mc-row { display:flex; align-items:center; gap:0.9rem; padding:0.55rem 0.9rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); }
		.mc-row:last-child { border-bottom:none; }
		.mc-row:hover { background:var(--theme-color-background-secondary,#f4f6f9); }
		.mc-col-name { flex:1 1 auto; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.mc-col-code { flex:0 0 8rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.82rem; color:var(--theme-color-text-muted,#8a94a3); }
		.mc-col-action { flex:0 0 auto; }
		.mc-disabled { color:var(--theme-color-text-muted,#aab2bf); font-style:italic; font-size:0.82rem; }
		.mc-btn { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.82rem; font-weight:600; cursor:pointer; padding:0.35rem 0.75rem; border-radius:7px;
			border:1px solid var(--theme-color-brand-primary,#156dd1); background:var(--theme-color-brand-primary,#156dd1); color:#fff; white-space:nowrap; }
		.mc-btn:hover { background:var(--theme-color-brand-primary-dark,#115ab0); }
		.mc-btn-caret { font-size:0.7rem; opacity:0.85; }
		/* Each customer is an item (row + optional expanded accounts panel); the item carries the divider. */
		.mc-item { border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.mc-item:last-child { border-bottom:none; }
		.mc-item .mc-row { border-bottom:none; }
		.mc-item.is-expanded { background:var(--theme-color-background-secondary,#f4f6f9); }
		.mc-item.is-expanded > .mc-row:hover { background:transparent; }
		.mc-accounts { display:flex; flex-direction:column; gap:0.3rem; padding:0 0.9rem 0.75rem 1.5rem; }
		.mc-accounts-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8a94a3); margin:0.1rem 0 0.25rem; }
		.mc-accounts-note { font-size:0.86rem; padding:0.35rem 0; }
		.mc-accounts-note a { color:var(--theme-color-brand-primary,#156dd1); font-weight:600; }
		.mc-account { display:flex; align-items:center; gap:0.6rem; width:100%; max-width:34rem; text-align:left; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; background:var(--theme-color-background-primary,#fff); cursor:pointer; }
		.mc-account:hover { border-color:var(--theme-color-brand-primary,#156dd1); background:var(--theme-color-brand-primary-subtle,#eaf2fc); }
		.mc-account-avatar { flex:0 0 auto; width:1.75rem; height:1.75rem; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-muted,#8a94a3); font-size:0.8rem; }
		.mc-account-id { flex:1 1 auto; min-width:0; display:flex; flex-direction:column; }
		.mc-account-name { font-size:0.88rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.mc-account-login { font-size:0.74rem; color:var(--theme-color-text-muted,#8a94a3); font-family:ui-monospace,SFMono-Regular,Menlo,monospace; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.mc-account-go { flex:0 0 auto; font-size:0.78rem; font-weight:600; color:var(--theme-color-brand-primary,#156dd1); display:inline-flex; align-items:center; gap:0.3rem; }
		.mc-btn-remove { border-color:var(--theme-color-status-danger,#c0392b); background:transparent; color:var(--theme-color-status-danger,#c0392b); }
		.mc-btn-remove:hover { background:var(--theme-color-status-danger,#c0392b); color:#fff; }
		.mc-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); margin:0 0 0.9rem; }
		.mc-tab { font-size:0.88rem; font-weight:600; padding:0.5rem 0.95rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.mc-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.mc-tab.is-active { color:var(--theme-color-primary,#2f6fed); border-bottom-color:var(--theme-color-primary,#2f6fed); }
		.mc-team-help { font-size:0.88rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.8rem; max-width:56rem; }
		.mc-team-help code { font-size:0.85em; background:var(--theme-color-background-tertiary,#eef1f6); padding:0.05rem 0.3rem; border-radius:4px; color:var(--theme-color-text-primary,#1f2733); }
		.mc-team-badge { font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:#fff; background:var(--theme-color-status-warning,#b8860b); padding:0.08rem 0.4rem; border-radius:9px; vertical-align:middle; margin-left:0.4rem; }
		.mc-module-picker { display:flex; align-items:center; gap:0.6rem; margin:0 0 0.9rem; }
		.mc-module-picklabel { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); }
		.mc-module-custpick { flex:1 1 auto; min-width:22rem; max-width:32rem; }
		/* Plain wrapper around the filter + scrolling list — the single scroll container is the inner .mc-list (#MC-ModuleList);
		   this outer must NOT scroll or a second scrollbar stacks on top of it. */
		.mc-module-results { display:flex; flex-direction:column; gap:0.6rem; max-width:56rem; }
		.mc-app-tag { font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-brand-primary,#5650e6); background:rgba(86,80,230,0.1); padding:0.08rem 0.4rem; border-radius:9px; vertical-align:middle; margin-left:0.4rem; }
	`,
	Templates:
	[
		{
			Hash: 'ManageCustomers-Wrap',
			Template: /*html*/`
				<div class="mc-wrap">
					<div class="mc-head">
						<h1 class="mc-title">Manage Customers</h1>
						<p class="mc-subtitle">Platform super-users: the customers you can administer. Open <strong>Manage Configuration</strong> on a customer to pick one of its configuration-admin accounts and sign in as them to manage their configuration.</p>
					</div>
					<div id="MC-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ManageCustomersWrap',
			TemplateHash: 'ManageCustomers-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1448:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * Master List configuration tool.
 *
 * A product-manager-facing screen for managing the reference/catalog lists: add or remove a
 * list, file it under a category, choose which columns it shows (order + header label + search),
 * and choose how it surfaces its connections (read tab / bulk / matrix / unlink). Each change is
 * saved to a chosen scope — Platform Default (Global), Customer, or My Settings (User) — and the
 * Configuration service cascades the layers. All state lives in pict.AppData.MasterListManager
 * and all behavior lives in the MasterListRegistry provider; the view derives + repaints
 * declaratively.
 */
class MasterListManager extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.MasterListRegistry;
	}

	deriveRenderState()
	{
		if (this.provider)
		{
			this.provider.deriveRenderState();
		}
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = MasterListManager;

module.exports.default_configuration =
{
	ViewIdentifier: 'MasterListManager',
	DefaultRenderable: 'MasterListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.mlm-wrap { padding: 1.25rem 1.5rem 2rem; }
		.mlm-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1rem; }
		.mlm-list { padding: 0.5rem; }
		.mlm-rail-group { margin-bottom: 0.75rem; }
		.mlm-rail-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); padding: 0.35rem 0.5rem; display: flex; align-items: center; gap: 0.4rem; }
		.mlm-list-row { display: flex; align-items: center; border-radius: 6px; }
		.mlm-list-row:hover { background: var(--bulma-background, #f5f5f5); }
		.mlm-list-row.is-active { background: var(--theme-color-brand-primary, #2e7d74); }
		.mlm-list-row.is-active .mlm-list-main, .mlm-list-row.is-active .icon { color: #fff; }
		.mlm-list-main { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0.6rem; flex: 1 1 auto; cursor: pointer; color: inherit; min-width: 0; }
		.mlm-list-label { font-weight: 600; }
		.mlm-remove { opacity: 0; transition: opacity 0.12s; }
		.mlm-list-row:hover .mlm-remove { opacity: 1; }
		.mlm-add { border-left: 3px solid var(--theme-color-brand-primary, #2e7d74); }
		.mlm-add-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.25rem; }
		.mlm-cand-group { margin-bottom: 0.6rem; }
		.mlm-cand-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--bulma-text-weak, #7a7a7a); margin-bottom: 0.3rem; display: flex; align-items: center; gap: 0.4rem; }
		.mlm-cand-chips { display: flex; flex-wrap: wrap; gap: 0.4rem; }
		.mlm-editor-head { display: flex; align-items: flex-end; gap: 1rem; flex-wrap: wrap; }
		.mlm-editor-head .field { margin-bottom: 0; }
		.mlm-editor-head .field:first-child { flex: 1 1 14rem; }
		.mlm-scope label .icon { color: var(--theme-color-brand-primary, #2e7d74); }
		.mlm-editor-actions { display: flex; gap: 0.5rem; margin-left: auto; }
		.mlm-scope-hint { margin-top: 0.6rem; }
		.mlm-cols { margin-top: 0.75rem; }
		.mlm-cols td, .mlm-cols th { vertical-align: middle; }
		.mlm-cols tr.has-text-grey code { color: var(--bulma-text-weak, #9a9a9a); }
		.mlm-order .button { padding-left: 0.5rem; padding-right: 0.5rem; }
		.mlm-assoc { margin-top: 1.5rem; border-top: 1px solid var(--bulma-border, #ededed); padding-top: 1rem; }
		.mlm-assoc-table th, .mlm-assoc-table td { vertical-align: middle; }
		.mlm-assoc-table td code { color: var(--bulma-text-weak, #9a9a9a); }
		.mlm-empty { padding: 2.5rem 1rem; }
		.mlm-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #485fc7); border-radius: 50%; animation: mlm-spin 0.8s linear infinite; }
		@keyframes mlm-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'MasterList-Wrap',
			Template: /*html*/`
				<div class="mlm-wrap">
					<div class="mlm-header">
						<div>
							<h1 class="title is-4">Master Lists</h1>
							<p class="subtitle is-6 has-text-grey">Add, remove and categorize reference lists — choose the columns and connections each one shows. Changes save to the scope you pick (platform&nbsp;default, customer, or just&nbsp;you) and cascade on top of each other.</p>
						</div>
						<button class="button is-link" onclick="_Pict.providers.MasterListRegistry.toggleAddPanel()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add list</span></button>
					</div>
					{~TS:MasterList-AddPanel:AppData.MasterListManager.AddOpenSlot~}
					{~TS:MasterList-Message:AppData.MasterListManager.MessageSlot~}
					<div class="columns">
						<div class="column is-one-third">
							<div class="mlm-list box">
								{~TS:MasterList-RailGroup:AppData.MasterListManager.RailGroups~}
							</div>
						</div>
						<div class="column">
							{~TS:MasterList-Loading:AppData.MasterListManager.LoadingSlot~}
							{~TS:MasterList-Editor:AppData.MasterListManager.EditorSlot~}
							{~TS:MasterList-EmptyEditor:AppData.MasterListManager.EmptySlot~}
						</div>
					</div>
				</div>`
		},
		{
			Hash: 'MasterList-RailGroup',
			Template: /*html*/`
				<div class="mlm-rail-group">
					<div class="mlm-rail-head"><span class="icon is-small"><i class="{~D:Record.Icon~}"></i></span><span>{~D:Record.Category~}</span></div>
					{~TS:MasterList-RailRow:Record.Lists~}
				</div>`
		},
		{
			Hash: 'MasterList-RailRow',
			Template: /*html*/`
				<div class="mlm-list-row {~D:Record.RowClass~}">
					<a class="mlm-list-main" onclick="_Pict.providers.MasterListRegistry.selectList('{~D:Record.Entity~}')">
						<span class="icon"><i class="{~D:Record.Icon~}"></i></span>
						<span class="mlm-list-label">{~D:Record.Label~}{~D:Record.CuratedBadge~}</span>
					</a>
					<button class="button is-small is-white mlm-remove" title="Remove this list" onclick="_Pict.providers.MasterListRegistry.removeList('{~D:Record.Entity~}')"><i class="fas fa-trash"></i></button>
				</div>`
		},
		{
			Hash: 'MasterList-AddPanel',
			Template: /*html*/`
				<div class="mlm-add box">
					<div class="mlm-add-head">
						<strong>Add a list</strong>
						<button class="delete" aria-label="close" onclick="_Pict.providers.MasterListRegistry.toggleAddPanel(false)"></button>
					</div>
					<p class="help mb-3">Pick a suggested entity, or type any entity name and choose a category.</p>
					{~TS:MasterList-CandidateGroup:AppData.MasterListManager.CandidateGroups~}
					<div class="field has-addons mt-4">
						<div class="control is-expanded"><input class="input" type="text" placeholder="Entity name (e.g. MixDesign)" value="{~D:AppData.MasterListManager.AddEntity~}" oninput="_Pict.providers.MasterListRegistry.setAddEntity(this.value)" onkeydown="if(event.key==='Enter'){event.preventDefault();_Pict.providers.MasterListRegistry.addFromForm();}" /></div>
						<div class="control"><div class="select"><select onchange="_Pict.providers.MasterListRegistry.setAddDomain(this.value)">{~TS:MasterList-CategoryOption:AppData.MasterListManager.AddCategoryOptions~}</select></div></div>
						<div class="control"><button class="button is-link" onclick="_Pict.providers.MasterListRegistry.addFromForm()">Add</button></div>
					</div>
				</div>`
		},
		{
			Hash: 'MasterList-CandidateGroup',
			Template: /*html*/`
				<div class="mlm-cand-group">
					<div class="mlm-cand-head"><span class="icon is-small"><i class="{~D:Record.Icon~}"></i></span><span>{~D:Record.Category~}</span></div>
					<div class="mlm-cand-chips">{~TS:MasterList-Candidate:Record.Entities~}</div>
				</div>`
		},
		{
			Hash: 'MasterList-Candidate',
			Template: /*html*/`<button class="button is-small is-light" title="Add {~D:Record.Entity~}" onclick="_Pict.providers.MasterListRegistry.addFromCandidate('{~D:Record.Entity~}')"><span class="icon is-small"><i class="{~D:Record.Icon~}"></i></span><span>{~D:Record.Label~}</span></button>`
		},
		{
			Hash: 'MasterList-CategoryOption',
			Template: /*html*/`<option value="{~D:Record.Name~}" {~D:Record.SelectedAttr~}>{~D:Record.Name~}</option>`
		},
		{
			Hash: 'MasterList-ScopeOption',
			Template: /*html*/`<option value="{~D:Record.Key~}" {~D:Record.SelectedAttr~} {~D:Record.DisabledAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'MasterList-ScopeHint',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mlm-scope-hint"><span class="icon"><i class="fas fa-lock"></i></span> <span>{~D:Record.ScopeHint~}</span></div>`
		},
		{
			Hash: 'MasterList-Editor',
			Template: /*html*/`
				<div class="mlm-editor box">
					<div class="mlm-editor-head">
						<div class="field">
							<label class="label is-small">List title</label>
							<div class="control"><input class="input" type="text" value="{~D:Record.Title~}" onchange="_Pict.providers.MasterListRegistry.setTitle(this.value)" /></div>
						</div>
						<div class="field">
							<label class="label is-small">Category</label>
							<div class="control"><div class="select"><select onchange="_Pict.providers.MasterListRegistry.setEditorDomain(this.value)">{~TS:MasterList-CategoryOption:AppData.MasterListManager.EditorCategoryOptions~}</select></div></div>
						</div>
						<div class="field mlm-scope">
							<label class="label is-small"><span class="icon is-small"><i class="fas fa-layer-group"></i></span> Save to</label>
							<div class="control"><div class="select"><select onchange="_Pict.providers.MasterListRegistry.setScope(this.value)">{~TS:MasterList-ScopeOption:AppData.MasterListManager.ScopeOptions~}</select></div></div>
						</div>
						<div class="mlm-editor-actions">
							<button class="button is-link" {~D:Record.SaveDisabledAttr~} onclick="_Pict.providers.MasterListRegistry.save()"><span class="icon"><i class="fas fa-floppy-disk"></i></span><span>Save</span></button>
							<button class="button is-light" onclick="_Pict.providers.MasterListRegistry.openList('{~D:Record.SelectedEntity~}')"><span class="icon"><i class="fas fa-up-right-from-square"></i></span><span>Preview</span></button>
						</div>
					</div>
					{~TS:MasterList-ScopeHint:AppData.MasterListManager.ScopeHintSlot~}
					<p class="help mt-2">{~D:Record.VisibleCount~} column(s) shown · {~D:Record.SearchCount~} searchable</p>
					<table class="table is-fullwidth is-narrow is-hoverable mlm-cols">
						<thead><tr><th>Show</th><th>Column</th><th>Header label</th><th class="has-text-centered">Search</th><th class="has-text-right">Order</th></tr></thead>
						<tbody>{~TS:MasterList-ColumnRow:AppData.MasterListManager.Columns~}</tbody>
					</table>
					{~TS:MasterList-AssociationSection:AppData.MasterListManager.AssociationSlot~}
					{~TS:MasterList-ChildListSection:AppData.MasterListManager.ChildListSlot~}
				</div>`
		},
		{
			Hash: 'MasterList-ColumnRow',
			Template: /*html*/`
				<tr class="{~D:Record.RowClass~}">
					<td class="has-text-centered"><input type="checkbox" {~D:Record.VisibleAttr~} onchange="_Pict.providers.MasterListRegistry.toggleVisible('{~D:Record.Key~}')" /></td>
					<td><code>{~D:Record.Key~}</code>{~D:Record.SystemBadge~}</td>
					<td><input class="input is-small" type="text" value="{~D:Record.DisplayName~}" onchange="_Pict.providers.MasterListRegistry.setColumnLabel('{~D:Record.Key~}', this.value)" /></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.SearchAttr~} onchange="_Pict.providers.MasterListRegistry.toggleSearch('{~D:Record.Key~}')" /></td>
					<td class="has-text-right mlm-order">
						<button class="button is-small is-white" title="Move up" onclick="_Pict.providers.MasterListRegistry.moveUp('{~D:Record.Key~}')"><i class="fas fa-arrow-up"></i></button>
						<button class="button is-small is-white" title="Move down" onclick="_Pict.providers.MasterListRegistry.moveDown('{~D:Record.Key~}')"><i class="fas fa-arrow-down"></i></button>
					</td>
				</tr>`
		},
		{
			Hash: 'MasterList-AssociationSection',
			Template: /*html*/`
				<div class="mlm-assoc">
					<h2 class="label is-small">Connections (associations)</h2>
					<p class="help mb-2">Choose how each related list is surfaced on this one. A connection can appear in more than one place. Read tabs share one layout (below).</p>
					<table class="table is-fullwidth is-narrow mlm-assoc-table">
						<thead><tr><th>Connected list</th><th class="has-text-centered" title="An editor tab on each record">Read&nbsp;tab</th><th class="has-text-centered" title="A bulk assign screen in the menu">Bulk</th><th class="has-text-centered" title="A many-to-many grid screen">Matrix</th><th class="has-text-centered" title="An unlink screen">Unlink</th><th>Label</th></tr></thead>
						<tbody>{~TS:MasterList-AssociationRow:AppData.MasterListManager.Associations~}</tbody>
					</table>
					{~TS:MasterList-ReadLayoutField:AppData.MasterListManager.ReadLayoutSlot~}
				</div>`
		},
		{
			Hash: 'MasterList-AssociationRow',
			Template: /*html*/`
				<tr>
					<td><strong>{~D:Record.OtherLabel~}</strong> <code class="is-size-7">{~D:Record.Hash~}</code></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.ReadTabAttr~} onchange="_Pict.providers.MasterListRegistry.setAssociationView('{~D:Record.Hash~}','readtab',this.checked)" /></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.BulkAttr~} onchange="_Pict.providers.MasterListRegistry.setAssociationView('{~D:Record.Hash~}','bulk',this.checked)" /></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.MatrixAttr~} onchange="_Pict.providers.MasterListRegistry.setAssociationView('{~D:Record.Hash~}','matrix',this.checked)" /></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.UnlinkAttr~} onchange="_Pict.providers.MasterListRegistry.setAssociationView('{~D:Record.Hash~}','unlink',this.checked)" /></td>
					<td><input class="input is-small" type="text" value="{~D:Record.Title~}" onchange="_Pict.providers.MasterListRegistry.setAssociationTitle('{~D:Record.Hash~}', this.value)" /></td>
				</tr>`
		},
		{
			Hash: 'MasterList-ReadLayoutField',
			Template: /*html*/`
				<div class="field is-horizontal mt-2">
					<div class="field-label is-small"><label class="label">Read-tab layout</label></div>
					<div class="field-body"><div class="field is-narrow"><div class="control"><div class="select is-small"><select onchange="_Pict.providers.MasterListRegistry.setReadLayout(this.value)">{~TS:MasterList-ReadLayoutOption:AppData.MasterListManager.ReadLayoutOptions~}</select></div></div></div></div>
				</div>`
		},
		{
			Hash: 'MasterList-ReadLayoutOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Value~}</option>`
		},
		{
			Hash: 'MasterList-ChildListSection',
			Template: /*html*/`
				<div class="mlm-assoc">
					<h2 class="label is-small">Child lists (foreign-key)</h2>
					<p class="help mb-2">Filtered lists of records that point back at this one. Each shows as a read-view tab.</p>
					<table class="table is-fullwidth is-narrow mlm-assoc-table">
						<thead><tr><th>Child list</th><th class="has-text-centered" title="A filtered child-record tab on each record">Tab</th><th>Label</th></tr></thead>
						<tbody>{~TS:MasterList-ChildListRow:AppData.MasterListManager.ChildLists~}</tbody>
					</table>
				</div>`
		},
		{
			Hash: 'MasterList-ChildListRow',
			Template: /*html*/`
				<tr>
					<td><strong>{~D:Record.OtherLabel~}</strong></td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.ChildOnAttr~} onchange="_Pict.providers.MasterListRegistry.setChildListView('{~D:Record.Key~}',this.checked)" /></td>
					<td><input class="input is-small" type="text" value="{~D:Record.Title~}" onchange="_Pict.providers.MasterListRegistry.setChildListTitle('{~D:Record.Key~}', this.value)" /></td>
				</tr>`
		},
		{
			Hash: 'MasterList-Message',
			Template: /*html*/`<div class="notification {~D:Record.MessageClass~} is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'MasterList-EmptyEditor',
			Template: /*html*/`
				<div class="mlm-empty box has-text-grey has-text-centered">
					<span class="icon is-large"><i class="fas fa-hand-pointer fa-2x"></i></span>
					<p class="mt-3">Pick a list on the left to choose its columns and connections, or “Add list” to manage a new one.</p>
				</div>`
		},
		{
			Hash: 'MasterList-Loading',
			Template: /*html*/`
				<div class="mlm-empty box has-text-grey has-text-centered">
					<span class="mlm-spinner"></span>
					<p class="mt-3">Loading columns…</p>
				</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'MasterListWrap',
			TemplateHash: 'MasterList-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-view":1053}],1449:[function(require,module,exports){
const libAssociationEditor = require('pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js');

/**
 * MaterialOrganizationAssociationEditor — the "Organizations" tab on a Material read view (and the
 * reciprocal association manager for material↔organization relationships, the OrganizationMaterialJoin).
 *
 * The base RecordSet-AssociationEditor already flags a relationship whose join has a past ExpirationDate
 * (or a future EffectiveDate) with a read-only status badge via its zero-config _computeStatusBadge. This
 * subclass adds the missing WRITE side the task asks for: an inline `<input type="date">` on each row that
 * SETS, UPDATES or BACKFILLS the join's ExpirationDate. The editable column is declared on the association
 * (JoinEditableFields, Type:'date' — see PlatformConfiguration-Application-Web.js); everything else — the
 * add picker, remove button, the expired badge — is inherited unchanged.
 *
 * Why a subclass rather than config alone: the base editor's inline edit controls only know the
 * checkbox / number / select / text kinds, so a `date` field is invisible to it. Teaching it the kind
 * needs (a) a `_buildEditFields` that shapes a date row and (b) an edit-field template that emits the date
 * input. The base registers its templates GLOBALLY by hash (pict.TemplateProvider is last-writer-wins) and
 * other association tabs (e.g. Project↔ObservationManifest) share those PRSP-AssociationEditor-* hashes, so
 * this view renders from a PRIVATE, re-namespaced COPY of the base templates — it cannot clobber them, and
 * it stays self-contained even on a page where no base editor ever initialized.
 *
 * The read view instantiates the association tab's editor only if one is not already registered under the
 * hash `RSP-AssocEditor-<RecordSet>-<Association>` (see RecordSet-Read._buildValidTabs), so pre-registering
 * this subclass under `RSP-AssocEditor-Material-MaterialOrganization` makes the Material tab use it.
 */

const _BASE = libAssociationEditor.default_configuration;

// Rewrite the base editor's own template + renderable hashes into a private namespace, leaving every other
// tag (icons, {~RecordCard:~}, the .prsp-assoc-* CSS classes, Record.* data refs) untouched.
const fNamespace = (pString) => String(pString)
	.split('PRSP_Renderable_AssociationEditor').join('HLMaterialOrgAssoc_Renderable')
	.split('PRSP-AssociationEditor').join('HLMaterialOrgAssoc');

// A private copy of every base template under the namespaced hashes, then: teach the edit-field dispatcher
// a `date` branch and add the date-input template it dispatches to.
const _NamespacedTemplates = _BASE.Templates.map((pTemplate) => ({ Hash: fNamespace(pTemplate.Hash), Template: fNamespace(pTemplate.Template) }));
for (let i = 0; i < _NamespacedTemplates.length; i++)
{
	if (_NamespacedTemplates[i].Hash === 'HLMaterialOrgAssoc-EditField')
	{
		_NamespacedTemplates[i].Template += `{~TIfAbs:HLMaterialOrgAssoc-EditDate:Record:Record.IsDate^TRUE^~}`;
	}
}
_NamespacedTemplates.push(
	{
		Hash: 'HLMaterialOrgAssoc-EditDate',
		Template: /*html*/`<label class="prsp-assoc-cfg">{~D:Record.Label~}<input type="date" class="prsp-assoc-cfg-date" value="{~D:Record.Value~}" title="Set, update or clear the relationship expiration date" onchange="_Pict.views['{~D:Record.ViewHash~}'].setExpiration({~D:Record.JoinID~},this.value)" /></label>`
	});

const _NamespacedRenderables = (_BASE.Renderables || []).map((pRenderable) =>
	Object.assign({}, pRenderable, { RenderableHash: fNamespace(pRenderable.RenderableHash), TemplateHash: fNamespace(pRenderable.TemplateHash) }));

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION_MaterialOrgAssociationEditor = Object.assign({}, _BASE,
	{
		ViewIdentifier: 'RSP-AssocEditor-Material-MaterialOrganization',
		DefaultRenderable: fNamespace(_BASE.DefaultRenderable),
		Templates: _NamespacedTemplates,
		Renderables: _NamespacedRenderables,
		// Reuse the base widget CSS (same .prsp-assoc-* classes the namespaced templates still use, injected
		// idempotently) and add the one rule for the date control.
		CSS: `${ _BASE.CSS }
		.prsp-assoc-cfg-date { font: inherit; font-size: 0.8rem; padding: 0.1rem 0.3rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 5px; }
		`,
	});

class viewMaterialOrganizationAssociationEditor extends libAssociationEditor
{
	/**
	 * Shape each editable join field into per-row render data. Adds the `date` kind the base does not know
	 * (formatting the stored datetime down to the yyyy-mm-dd an `<input type="date">` expects); every other
	 * kind defers to the base's shaping unchanged.
	 * @param {Array<Record<string, any>>} pFields @param {Record<string, any>} pItem
	 * @return {Array<Record<string, any>>}
	 */
	_buildEditFields(pFields, pItem)
	{
		if (!Array.isArray(pFields) || pFields.length < 1)
		{
			return [];
		}
		return pFields.map((pField) =>
		{
			if (pField && (pField.Type === 'date'))
			{
				const tmpJoin = pItem.JoinRecord || {};
				return {
					ViewHash: this.Hash,
					JoinID: pItem.JoinID,
					Field: pField.Field,
					Label: pField.Label || pField.Field,
					IsCheckbox: false,
					IsNumber: false,
					IsSelect: false,
					IsText: false,
					IsDate: true,
					Value: this._toDateInputValue(tmpJoin[pField.Field]),
					Options: [],
				};
			}
			// Reuse the base single-field shaping for checkbox / number / select / text.
			return super._buildEditFields([ pField ], pItem)[0];
		});
	}

	/**
	 * Reduce a stored datetime to the `yyyy-mm-dd` an `<input type="date">` needs. Reads the date part off
	 * the string directly (no Date parse, so no timezone day-shift); an unset / zero / non-date value maps
	 * to '' so a relationship with no expiration shows an empty control the user can fill in (the "add
	 * missing expiration info" case).
	 * @param {any} pValue
	 * @return {string}
	 */
	_toDateInputValue(pValue)
	{
		if (!pValue)
		{
			return '';
		}
		const tmpMatch = String(pValue).match(/^(\d{4})-(\d{2})-(\d{2})/);
		if (!tmpMatch || (tmpMatch[1] === '0000'))
		{
			return '';
		}
		return `${ tmpMatch[1] }-${ tmpMatch[2] }-${ tmpMatch[3] }`;
	}

	/**
	 * Persist a set / updated / cleared expiration on one relationship's join row, then repaint from the
	 * server so the read-only Expired / Not-yet-effective badge reflects the new date immediately (the
	 * association manager clears its cached join list on the write, so the reload is fresh).
	 * @param {string|number} pJoinID @param {string} pValue - the date input value (yyyy-mm-dd, or '' to clear).
	 * @return {Promise<void>}
	 */
	async setExpiration(pJoinID, pValue)
	{
		const tmpItem = this._lastItems.find((pItem) => String(pItem.JoinID) === String(pJoinID));
		if (!tmpItem || !tmpItem.JoinRecord)
		{
			return;
		}
		try
		{
			await this.manager.updateJoin(this.options.AssociationHash, tmpItem.JoinRecord,
				{ ExpirationDate: ((pValue === undefined) || (pValue === null)) ? '' : pValue });
		}
		catch (pError)
		{
			this.pict.log.error(`MaterialOrganizationAssociationEditor [${ this.Hash }]: failed to save ExpirationDate for join ${ pJoinID }.`, pError);
			this._toast('Could not save the expiration date.', 'error');
		}
		await this.renderEditor();
	}
}

module.exports = viewMaterialOrganizationAssociationEditor;

module.exports.default_configuration = _DEFAULT_CONFIGURATION_MaterialOrgAssociationEditor;

},{"pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js":988}],1450:[function(require,module,exports){
const libPictView = require('pict-view');

// Cap the rendered set list: a heavily-referenced material can transitively reach a lot of specification
// sets, and dumping them all through one template pass is both slow and stack-risky. Show the first CAP
// with an honest "showing X of Y" note.
const RENDER_CAP = 250;
// Meadow filter list length guard — chunk the INN lookups so the FilteredTo URL never gets huge.
const INN_CHUNK = 150;

/**
 * MaterialSpecSetsTab — a read-only "Test Specification Sets" tab for a Material's read view.
 *
 * This is the reciprocal of SpecSetMaterialsTab. A material is not linked to a SET directly; it links to
 * individual Test Specifications (TestSpecificationMaterialJoin), and each spec belongs to a set
 * (TestSpecification.IDTestSpecificationSet). So "the sets this material belongs to" is a walk back up:
 * material → the specs joined to it → the distinct sets those specs live in. This view resolves the current
 * material id the same way ChildListTab does — from AppData.MaterialDetails, the record the read view stashes
 * — then renders a compact, scrollable table. Wired in as a { Type: 'View' } read tab (see MasterList-Builder
 * / Headlight-MasterLists ViewTabs on Material).
 */
class MaterialSpecSetsTab extends libPictView
{
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get destination()
	{
		return this.options.DefaultDestinationAddress || `#PSRS-Tab-TestSpecificationSets`;
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)));
		});
	}

	_materialID()
	{
		const tmpMaterial = this.pict.AppData.MaterialDetails || {};
		return tmpMaterial.IDMaterial;
	}

	_escapeHTML(pValue)
	{
		return String((pValue === null || typeof pValue === 'undefined') ? '' : pValue)
			.replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[pChar]);
	}

	_chunk(pArray, pSize)
	{
		const tmpChunks = [];
		for (let i = 0; i < pArray.length; i += pSize) { tmpChunks.push(pArray.slice(i, i + pSize)); }
		return tmpChunks;
	}

	/**
	 * Resolve the distinct specification sets this material's specs belong to. Returns { sets, total }.
	 * Each hydrated set carries a SpecCount — how many of THIS material's test specs live in that set.
	 */
	async _loadSpecSets(pMaterialID)
	{
		// Hop 1: the material's Test Specification join rows -> the specs it is attached to.
		const tmpJoins = await this._getJSON(`TestSpecificationMaterialJoins/FilteredTo/FBV~IDMaterial~EQ~${ pMaterialID }/0/5000`);
		const tmpSpecIDSet = {};
		(Array.isArray(tmpJoins) ? tmpJoins : []).forEach((pJoin) => { if (pJoin.IDTestSpecification > 0) { tmpSpecIDSet[pJoin.IDTestSpecification] = true; } });
		const tmpSpecIDs = Object.keys(tmpSpecIDSet);
		if (tmpSpecIDs.length < 1) { return { sets: [], total: 0 }; }

		// Hop 2: those specs -> their sets (chunked INN), de-duplicated to distinct set ids. Along the way,
		// tally how many of the material's specs fall in each set so the tab can show that context.
		const tmpSetSpecCount = {};
		for (const tmpChunk of this._chunk(tmpSpecIDs, INN_CHUNK))
		{
			const tmpSpecs = await this._getJSON(`TestSpecifications/FilteredTo/FBL~IDTestSpecification~INN~${ tmpChunk.join(',') }/0/${ INN_CHUNK }`);
			(Array.isArray(tmpSpecs) ? tmpSpecs : []).forEach((pSpec) =>
			{
				if (pSpec.IDTestSpecificationSet > 0) { tmpSetSpecCount[pSpec.IDTestSpecificationSet] = (tmpSetSpecCount[pSpec.IDTestSpecificationSet] || 0) + 1; }
			});
		}
		const tmpSetIDs = Object.keys(tmpSetSpecCount);
		const tmpTotal = tmpSetIDs.length;
		if (tmpTotal < 1) { return { sets: [], total: 0 }; }

		// Hop 3: hydrate only the first RENDER_CAP sets for display, attaching the per-set spec tally.
		const tmpDisplayIDs = tmpSetIDs.slice(0, RENDER_CAP);
		const tmpSets = [];
		for (const tmpChunk of this._chunk(tmpDisplayIDs, INN_CHUNK))
		{
			const tmpRows = await this._getJSON(`TestSpecificationSets/FilteredTo/FBL~IDTestSpecificationSet~INN~${ tmpChunk.join(',') }~FSF~Name~ASC~0/0/${ INN_CHUNK }`);
			(Array.isArray(tmpRows) ? tmpRows : []).forEach((pRow) => tmpSets.push(Object.assign({ SpecCount: tmpSetSpecCount[pRow.IDTestSpecificationSet] || 0 }, pRow)));
		}
		// Per-chunk sorting is only local; sort the assembled list by name so multi-chunk results read in order.
		tmpSets.sort((pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || '')));
		return { sets: tmpSets, total: tmpTotal };
	}

	/**
	 * The read view's `View` tab type calls renderAsync() with no arguments. Load the sets the material's
	 * specs belong to, stash the render model, and paint. Guarded so a failed hop shows a notice, not a blank.
	 */
	async renderAsync()
	{
		const tmpState = this.pict.AppData.MaterialSpecSets = this.pict.AppData.MaterialSpecSets || {};
		const tmpMaterialID = this._materialID();
		if (!tmpMaterialID)
		{
			this.pict.ContentAssignment.assignContent(this.destination, `<div class="mss-note">Select a material to see its specification sets.</div>`);
			return;
		}
		this.pict.ContentAssignment.assignContent(this.destination, `<div class="mss-note">Loading specification sets…</div>`);
		try
		{
			const { sets, total } = await this._loadSpecSets(tmpMaterialID);
			tmpState.Rows = sets.map((pSet) => (
				{
					Name: this._escapeHTML(pSet.Name || '—'),
					Year: this._escapeHTML(pSet.Year || '—'),
					SpecCount: this._escapeHTML(pSet.SpecCount || 0),
					GUID: this._escapeHTML(pSet.GUIDTestSpecificationSet || ''),
				}));
			tmpState.Count = total;
			tmpState.Shown = sets.length;
			tmpState.TruncatedSlot = (total > sets.length) ? [ { Shown: sets.length, Total: total } ] : [];
			tmpState.RowsSlot = (sets.length > 0) ? [ tmpState ] : [];
			tmpState.EmptySlot = (sets.length < 1) ? [ {} ] : [];
			// Render into the destination the read view assigned this tab (not a fixed renderable address,
			// which would only match one tab hash) — parse the container template against AppData.
			const tmpHTML = this.pict.parseTemplateByHash('MaterialSpecSets-Container-Template', {});
			this.pict.ContentAssignment.assignContent(this.destination, tmpHTML);
			this.pict.CSSMap.injectCSS();
		}
		catch (pError)
		{
			this.pict.log.warn(`MaterialSpecSetsTab: load failed for material ${ tmpMaterialID }: ${ pError && (pError.message || pError) }`);
			this.pict.ContentAssignment.assignContent(this.destination, `<div class="mss-note">Could not load the specification sets for this material.</div>`);
		}
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'MaterialSpecSets',
	DefaultDestinationAddress: '#PSRS-Tab-TestSpecificationSets',
	DefaultRenderable: 'MaterialSpecSets-Container',

	CSS: /*css*/`
.mss-wrap { padding: 0.25rem 0; }
.mss-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6); margin-bottom: 0.5rem; }
.mss-count { display: inline-block; margin-left: 0.4rem; padding: 0.02rem 0.5rem; border-radius: 999px; font-size: 0.72rem; font-weight: 700; background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-secondary, #45505f); }
.mss-note { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.5rem 0; }
.mss-trunc { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.35rem 0 0; }
.mss-scroll { overflow-x: auto; }
.mss-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
.mss-table th { position: sticky; top: 0; background: var(--theme-color-background-primary, #fff); text-align: left; font-weight: 600; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); padding: 0.4rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); white-space: nowrap; }
.mss-table td { padding: 0.45rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f6); color: var(--theme-color-text-primary, #1f2733); }
.mss-table td.mss-num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.mss-table tbody tr:hover { background: var(--theme-color-background-tertiary, #f4f6f9); }
`,

	Templates:
	[
		{
			Hash: 'MaterialSpecSets-Container-Template',
			Template: /*html*/`
				<div class="mss-wrap">
					<div class="mss-head">Test Specification Sets <span class="mss-count">{~D:AppData.MaterialSpecSets.Count~}</span></div>
					{~TS:MaterialSpecSets-Empty:AppData.MaterialSpecSets.EmptySlot~}
					{~TS:MaterialSpecSets-Table:AppData.MaterialSpecSets.RowsSlot~}
					{~TS:MaterialSpecSets-Trunc:AppData.MaterialSpecSets.TruncatedSlot~}
				</div>`
		},
		{
			Hash: 'MaterialSpecSets-Table',
			Template: /*html*/`<div class="mss-scroll"><table class="mss-table"><thead><tr><th>Specification Set</th><th>Year</th><th>Specs</th></tr></thead><tbody>{~TS:MaterialSpecSets-Row:Record.Rows~}</tbody></table></div>`
		},
		{
			Hash: 'MaterialSpecSets-Row',
			Template: /*html*/`<tr><td>{~D:Record.Name~}</td><td>{~D:Record.Year~}</td><td class="mss-num">{~D:Record.SpecCount~}</td></tr>`
		},
		{
			Hash: 'MaterialSpecSets-Empty',
			Template: /*html*/`<div class="mss-note">This material is not referenced by any test specification sets.</div>`
		},
		{
			Hash: 'MaterialSpecSets-Trunc',
			Template: /*html*/`<div class="mss-trunc">Showing the first {~D:Record.Shown~} of {~D:Record.Total~} specification sets.</div>`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'MaterialSpecSets-Container',
			TemplateHash: 'MaterialSpecSets-Container-Template',
			DestinationAddress: '#PSRS-Tab-TestSpecificationSets',
			RenderMethod: 'replace',
		},
	],
};

module.exports = MaterialSpecSetsTab;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":1053}],1451:[function(require,module,exports){

const libPictView = require('pict-view');
const libLogoSlotController = require('../providers/LogoSlotController.js');
const libLabelManagerController = require('../providers/LabelManagerController.js');
const libLabelBehaviorController = require('../providers/LabelBehaviorController.js');

/**
 * MyHeadlight — the configuration landing for the signed-in user's own organization. Sections: Branding
 * (customer primary + reports logos, shared Headlight-LogoSlot template) and Default project labels (the
 * customer's IDProject=0 ProjectTagType set, shared Headlight-LabelManager template). Thin view: state in
 * pict.AppData.MyHeadlight, behavior in the MyHeadlight provider. Built to grow.
 */
class MyHeadlight extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.MyHeadlight;
	}

	onBeforeRender(pRenderable)
	{
		if (this.provider) { this.provider.deriveRenderState(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = MyHeadlight;

module.exports.default_configuration =
{
	ViewIdentifier: 'MyHeadlight',
	DefaultRenderable: 'MyHeadlightWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.mh-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 58rem; }
		.mh-head { margin: 0 0 1.5rem; }
		.mh-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); }
		.mh-title { font-size: 1.55rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); }
		.mh-subtitle { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.2rem 0 0; }
		.mh-section { margin: 0 0 1.5rem; }
		.mh-section-title { font-size: 0.74rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6); margin: 0 0 0.6rem; }
		.mh-card { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; background: var(--theme-color-background-panel, #fff); padding: 1.4rem 1.5rem; }
		.mh-help { font-size: 0.85rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.9rem; line-height: 1.5; }
		.mh-loading { padding: 2.5rem 1rem; }
		${ libLogoSlotController.LOGO_SLOT_CSS }
		${ libLabelManagerController.LABEL_CSS }
		${ libLabelBehaviorController.LABELBEHAVIOR_CSS }
	`,
	Templates:
	[
		{
			Hash: 'MyHeadlight-Wrap',
			Template: /*html*/`
				<div class="mh-wrap">
					{~TS:MyHeadlight-Loading:AppData.MyHeadlight.LoadingSlot~}
					{~TS:MyHeadlight-Body:AppData.MyHeadlight.BodySlot~}
				</div>`
		},
		{
			Hash: 'MyHeadlight-Body',
			Template: /*html*/`
				<div class="mh-head">
					<div class="mh-eyebrow">My Headlight</div>
					<h1 class="mh-title">{~D:AppData.MyHeadlight.CustomerName~}</h1>
					<p class="mh-subtitle">{~D:AppData.MyHeadlight.CustomerLine~}</p>
				</div>
				<div class="mh-section">
					<h2 class="mh-section-title">Branding</h2>
					<div class="mh-card">
						{~TS:Headlight-LogoSlot:AppData.MyHeadlight.LogoSlots~}
					</div>
				</div>
				<div class="mh-section">
					<h2 class="mh-section-title">Default project labels</h2>
					<div class="mh-card">
						<p class="mh-help">Label types every new project starts with (e.g. Contractor, Phase, BidItem). Individual projects can add their own labels on top of these.</p>
						{~TS:Headlight-LabelManager:AppData.MyHeadlight.LabelStateSlot~}
					</div>
				</div>
				<div class="mh-section">
					<h2 class="mh-section-title">Label behavior <span class="pw-label-types-sub" style="font-size:0.85rem;font-weight:400;color:var(--theme-color-text-muted,#6b7686)">— per observation type</span></h2>
					<div class="mh-card">
						<p class="mh-help">How each label behaves during entry, per observation type — <strong>deny free entry</strong> (must pick from the list), a <strong>max per observation</strong>, or <strong>hide</strong> it. <strong>Auto-Filter</strong> narrows each list by the labels already chosen. These are your organization’s defaults; a project can override them on its own Labels tab.</p>
						<div id="MH-LabelBehaviorHost">{~TS:Headlight-LabelBehavior:AppData.MyHeadlight.LabelBehaviorStateSlot~}</div>
					</div>
				</div>`
		},
		{
			Hash: 'MyHeadlight-Loading',
			Template: /*html*/`<div class="mh-loading box has-text-grey has-text-centered"><span class="logo-spin"></span> Loading…</div>`
		},
		...libLogoSlotController.LOGO_SLOT_TEMPLATES,
		...libLabelManagerController.LABEL_TEMPLATES,
		...libLabelBehaviorController.LABELBEHAVIOR_TEMPLATES
	],
	Renderables:
	[
		{
			RenderableHash: 'MyHeadlightWrap',
			TemplateHash: 'MyHeadlight-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"../providers/LabelBehaviorController.js":1344,"../providers/LabelManagerController.js":1345,"../providers/LogoSlotController.js":1348,"pict-view":1053}],1452:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * ObservationList — the thin standalone screen (#/PSRS/Observation/List) that hosts the Solr-backed, filterable
 * ObservationList provider. It owns only the page host div; the provider paints the whole list (filter bar + results)
 * into #ObservationList-Host and does the fetching. Full browser width via Dashboard Mode (the router drops the app
 * content gutters for a wide, dense list). Replaces the generic pict-section-recordset Observation list, which hangs
 * scanning the ~21k-row Observations table.
 */
class ObservationListView extends libPictView
{
	get provider() { return this.pict.providers['ObservationList']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			// Standalone screen is never project-locked — exit any embed carried over from a Project workspace tab.
			if (typeof tmpProvider.exitEmbed === 'function') { tmpProvider.exitEmbed(); }
			tmpProvider._mount = '#ObservationList-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ObservationListView;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationList',
	DefaultRenderable: 'ObservationListWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reusable app-shell Dashboard Mode: render this dense filterable list full browser width.
	DashboardMode: true,

	CSS: /*css*/`
		.obl-page { padding: 1.25rem 0 2rem; }
	`,

	Templates:
	[
		{
			Hash: 'ObservationList-Template',
			Template: html`
				<section class="section obl-page">
					<div id="ObservationList-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'ObservationListWrap',
			TemplateHash: 'ObservationList-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1453:[function(require,module,exports){
'use strict';

const libProjectCenterMap = require('./ProjectCenterMap.js');

/**
 * ObservationLocationMap — the read-only Leaflet map for the Observation workspace's Location tab. Unlike the base
 * ProjectCenterMap (a single draggable center-picker), this plots up to TWO fixed markers for one observation:
 *   • Capture location (device GPS / EXIF) — red
 *   • User location (person) — teal
 * with a dashed connector between them and an auto fitBounds "combined" view. Nothing is draggable/clickable (the
 * observation's captured coordinates are historical field data, not editable here). A second instance, LocationViewMap,
 * plots a Location's single point the same way for the Location workspace's Details tab. The workspace calls
 * showForProject() from the Location tab's OnEnter, reading the points from the provider's mapPoints().
 */
class ObservationLocationMap extends libProjectCenterMap
{
	get provider() { return this.pict.providers[(this.options && this.options.ProviderName) || 'ObservationWorkspace']; }
	get mapHostID() { return (this.options && this.options.MapHostID) || 'OW-MapHost'; }

	showForProject()
	{
		const L = this.leafletLib;
		const tmpHost = (typeof document !== 'undefined') ? document.getElementById(this.mapHostID) : null;
		if (!L || !tmpHost || !this.provider) { return; }

		if (this._map) { try { this._map.remove(); } catch (pError) { /* prior map already detached */ } this._map = false; this._marker = false; }

		const tmpPoints = (typeof this.provider.mapPoints === 'function') ? (this.provider.mapPoints() || {}) : {};
		const tmpCapture = tmpPoints.capture || null;
		const tmpUser = tmpPoints.user || null;
		const tmpAny = tmpCapture || tmpUser;
		const tmpCenter = tmpAny ? [ tmpAny.lat, tmpAny.lng ] : [ 39.5, -98.35 ];

		this._map = L.map(tmpHost, { scrollWheelZoom: true }).setView(tmpCenter, tmpAny ? 15 : 4);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(this._map);

		const tmpBounds = [];
		// A point may name itself (the Location workspace's single point is 'Location'); otherwise the observation labels.
		if (tmpCapture) { this._dot(tmpCapture.lat, tmpCapture.lng, '#c0392b', tmpCapture.label || 'Capture — device / EXIF'); tmpBounds.push([ tmpCapture.lat, tmpCapture.lng ]); }
		if (tmpUser) { this._dot(tmpUser.lat, tmpUser.lng, '#2e7d74', tmpUser.label || 'User — person'); tmpBounds.push([ tmpUser.lat, tmpUser.lng ]); }
		if (tmpCapture && tmpUser) { L.polyline([ [ tmpCapture.lat, tmpCapture.lng ], [ tmpUser.lat, tmpUser.lng ] ], { color: '#8894a4', weight: 2, dashArray: '4 5' }).addTo(this._map); }
		if (tmpBounds.length > 1) { this._map.fitBounds(tmpBounds, { padding: [ 45, 45 ], maxZoom: 17 }); }

		setTimeout(() => { if (this._map) { this._map.invalidateSize(); } }, 60);
	}

	/** A fixed, non-interactive colored dot marker with a hover tooltip (no dragging — read-only field data). */
	_dot(pLat, pLng, pColor, pLabel)
	{
		const L = this.leafletLib;
		if (!L || !this._map) { return; }
		L.circleMarker([ pLat, pLng ], { radius: 9, color: '#ffffff', weight: 2, fillColor: pColor, fillOpacity: 0.95, interactive: true })
			.addTo(this._map)
			.bindTooltip(pLabel, { direction: 'top', offset: [ 0, -6 ] });
	}
}

module.exports = ObservationLocationMap;

module.exports.default_configuration = Object.assign({}, libProjectCenterMap.default_configuration,
	{
		ViewIdentifier: 'ObservationLocationMap',
		ProviderName: 'ObservationWorkspace',
		MapHostID: 'OW-MapHost',
		LeafletDestinationAddress: 'OW-MapHost',
	});

},{"./ProjectCenterMap.js":1459}],1454:[function(require,module,exports){

const libPictView = require('pict-view');
// The same pict-section-recordset association widget the Project view uses for its "Observation Types"
// tab — embedded here for the OTHER direction (the projects that use this type), anchored on the
// manifest's Name. One association, both sides: that consistency is the point.
const libRecordSetAssociationEditor = require('pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js');

/**
 * Observation Type editor — the bespoke record page for an ObservationManifest.
 *
 * The pict-section-recordset list stays the browse surface; this view is the create / edit / clone
 * experience. It is a thin shell: all state lives in pict.AppData.ObservationTypeEditor and all
 * behavior in the ObservationTypeEditor provider, which the routes drive (newType / loadAsync /
 * cloneFrom) before rendering. The view derives + repaints declaratively.
 */
class ObservationTypeEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ObservationTypeEditor;
	}

	deriveRenderState()
	{
		if (this.provider)
		{
			this.provider.deriveRenderState();
		}
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		// The main render replaces the whole editor container (and with it the empty Projects host), so
		// (re)paint the embedded association editor into it after every paint when a saved type is shown.
		this._renderProjectsAssociation();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/**
	 * Lazily register (once) a dedicated association-editor instance for the manifest side of the
	 * ProjectObservationManifest association. Mirrors how the PSRS read view registers an Association
	 * tab editor, but anchored on ObservationManifest (so it lists the PROJECTS using this type).
	 * AllowSynthesize is false because the defaults synthesizer is a project-side operation.
	 * @return {any|null} the registered view, or null if the association manager / association is absent.
	 */
	_ensureProjectsEditorView()
	{
		const tmpHash = 'OTE-ProjectsAssocEditor';
		if (this.pict.views[tmpHash]) { return this.pict.views[tmpHash]; }
		const tmpManager = this.pict.providers.RecordSetAssociationManager;
		if (!tmpManager || !tmpManager.getAssociation('ProjectObservationManifest')) { return null; }
		this.pict.addView(tmpHash, Object.assign({}, libRecordSetAssociationEditor.default_configuration,
			{
				ViewIdentifier: tmpHash,
				AssociationHash: 'ProjectObservationManifest',
				ThisRecordSet: 'ObservationManifest',
				DefaultDestinationAddress: '#OTE-ProjectsAssoc',
				PickerMode: 'single',
				AllowSynthesize: false,
			}), libRecordSetAssociationEditor);
		return this.pict.views[tmpHash];
	}

	/**
	 * Paint the embedded "Projects using this type" association editor into its host, anchored on the
	 * saved manifest's Name. No-op when there's no saved type (the host is absent — the template shows a
	 * "save first" hint instead). Renders are serialized so rapid OT-editor repaints don't race the
	 * association editor's async load.
	 */
	_renderProjectsAssociation()
	{
		const tmpProvider = this.provider;
		if (!tmpProvider) { return; }
		const tmpAnchor = tmpProvider.projectsAnchorName;
		const tmpHost = this.pict.ContentAssignment.getElement('#OTE-ProjectsAssoc');
		if (!tmpAnchor || !tmpHost || (tmpHost.length === 0)) { return; }
		const tmpEditor = this._ensureProjectsEditorView();
		if (!tmpEditor) { return; }
		tmpEditor.options.ThisID = tmpAnchor;
		tmpEditor.options.DefaultDestinationAddress = '#OTE-ProjectsAssoc';
		this._projectsRenderQueue = (this._projectsRenderQueue || Promise.resolve())
			.then(() => tmpEditor.renderEditor())
			.catch((pError) => { this.pict.log.warn(`ObservationTypeEditor: projects association render failed: ${pError && (pError.message || pError)}`); });
	}
}

module.exports = ObservationTypeEditor;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationTypeEditor',
	DefaultRenderable: 'ObservationTypeEditorWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.ote-wrap { padding: 1.25rem 1.5rem 2rem; }
		.ote-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin-bottom: 1rem; }
		.ote-header-actions { display: flex; gap: 0.5rem; flex-shrink: 0; }
		.ote-scope-tag { vertical-align: middle; }
		.ote-meta { display: flex; gap: 1rem; flex-wrap: wrap; }
		.ote-meta .field { margin-bottom: 0; }
		.ote-meta .field.ote-name { flex: 1 1 16rem; }
		.ote-meta .field.ote-display { flex: 1 1 12rem; }
		.ote-meta .field.ote-category { flex: 0 1 12rem; }
		.ote-section-head { display: flex; justify-content: space-between; align-items: center; margin: 1.5rem 0 0.5rem; }
		.ote-req-table td, .ote-req-table th { vertical-align: top; }
		.ote-req-table td { padding-top: 0.45rem; }
		.ote-req-artifact { min-width: 11rem; }
		.ote-req-summary { display: block; font-size: 0.72rem; color: var(--bulma-text-weak, #7a7a7a); margin-top: 0.15rem; }
		.ote-preview { background: var(--bulma-scheme-main-bis, #fafafa); }
		.ote-pv-req { padding: 0.5rem 0; border-bottom: 1px solid var(--bulma-border-weak, #f0f0f0); }
		.ote-pv-req:last-child { border-bottom: none; }
		.ote-pv-reqhead { margin-bottom: 0.35rem; }
		.ote-pv-field { margin: 0.3rem 0; max-width: 28rem; }
		.ote-pv-fieldlabel { display: block; font-size: 0.72rem; color: var(--bulma-text-weak, #7a7a7a); }
		.ote-pv-sheet { overflow-x: auto; }
		.ote-pv-sheet th { white-space: nowrap; font-size: 0.8rem; }
		.ote-pv-sheet input.input { min-width: 6rem; }
		.ote-req-num { width: 5.5rem; }
		.ote-req-missing { color: var(--bulma-danger, #cc0f35); }
		.ote-flavor-note { margin-top: 1.25rem; }
		.ote-projects-assoc { margin-top: 0.25rem; }
		.ote-empty { padding: 2.5rem 1rem; }
		.ote-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #485fc7); border-radius: 50%; animation: ote-spin 0.8s linear infinite; }
		@keyframes ote-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'ObservationType-Wrap',
			Template: /*html*/`
				<div class="ote-wrap">
					<datalist id="ote-artifact-options">{~TS:ObservationType-ArtifactOption:AppData.ObservationTypeEditor.ArtifactOptions~}</datalist>
					<datalist id="ote-category-options">{~TS:ObservationType-CategoryOption:AppData.ObservationTypeEditor.Categories~}</datalist>
					{~TS:ObservationType-Message:AppData.ObservationTypeEditor.MessageSlot~}
					{~TS:ObservationType-Loading:AppData.ObservationTypeEditor.LoadingSlot~}
					{~TS:ObservationType-Editor:AppData.ObservationTypeEditor.EditorSlot~}
					{~TS:ObservationType-Empty:AppData.ObservationTypeEditor.EmptySlot~}
				</div>`
		},
		{
			Hash: 'ObservationType-ArtifactOption',
			Template: /*html*/`<option value="{~D:Record.Name~}"></option>`
		},
		{
			Hash: 'ObservationType-CategoryOption',
			Template: /*html*/`<option value="{~D:Record.Name~}"></option>`
		},
		{
			Hash: 'ObservationType-Editor',
			Template: /*html*/`
				<div class="ote-editor">
					<div class="ote-header">
						<div>
							<h1 class="title is-4">{~D:Record.TitleText~}</h1>
							<p class="subtitle is-6 has-text-grey">Reference / catalog observation type · <span class="tag is-light ote-scope-tag">{~D:Record.ScopeLabel~}</span></p>
						</div>
						<div class="ote-header-actions">
							<button class="button is-light" onclick="_Pict.providers.ObservationTypeEditor.backToList()"><span class="icon">{~I:ChevronLeft~}</span><span>Back</span></button>
							{~TS:ObservationType-CloneButton:AppData.ObservationTypeEditor.EditorSlot~}
							{~TS:ObservationType-SaveButton:AppData.ObservationTypeEditor.EditorSlot~}
						</div>
					</div>

					{~TS:ObservationType-ReadOnlyNotice:AppData.ObservationTypeEditor.ReadOnlyNoticeSlot~}
					{~TS:ObservationType-ClonedNotice:AppData.ObservationTypeEditor.ClonedNoticeSlot~}

					<div class="box">
						<div class="ote-meta">
							<div class="field ote-name">
								<label class="label is-small">Name <span class="has-text-grey has-text-weight-normal">(unique · used by project associations)</span></label>
								<div class="control"><input class="input" type="text" maxlength="30" value="{~D:Record.Name~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setManifestField('Name', this.value)" /></div>
							</div>
							<div class="field ote-display">
								<label class="label is-small">Display name</label>
								<div class="control"><input class="input" type="text" maxlength="30" value="{~D:Record.DisplayName~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setManifestField('DisplayName', this.value)" /></div>
							</div>
							<div class="field ote-category">
								<label class="label is-small">Category</label>
								<div class="control"><input class="input" type="text" list="ote-category-options" value="{~D:Record.Category~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setManifestField('Category', this.value)" /></div>
							</div>
						</div>
					</div>

					<div class="ote-section-head">
						<h2 class="title is-5">Requirements <span class="tag is-light">{~D:Record.RequirementCount~}</span></h2>
						{~TS:ObservationType-AddButton:AppData.ObservationTypeEditor.EditorSlot~}
					</div>
					<p class="help mb-2">Each requirement collects a number of one artifact type. Min/Max bound how many; mark Required to force at least one.</p>

					<table class="table is-fullwidth is-narrow is-hoverable ote-req-table">
						<thead><tr><th>Name</th><th>Artifact type</th><th class="has-text-centered">Required</th><th>Min</th><th>Max</th><th>Default (JSON)</th><th></th></tr></thead>
						<tbody>{~TS:ObservationType-RequirementRow:AppData.ObservationTypeEditor.Requirements~}</tbody>
					</table>
					{~TS:ObservationType-EmptyRequirements:AppData.ObservationTypeEditor.EmptyRequirementsSlot~}

					<div class="ote-section-head">
						<h2 class="title is-5">Preview</h2>
						<div class="buttons has-addons mb-0">
							<button class="button is-small {~D:Record.JournalBtnClass~}" onclick="_Pict.providers.ObservationTypeEditor.setPreviewMode('journal')"><span class="icon">{~I:FileText~}</span><span>Journal</span></button>
							<button class="button is-small {~D:Record.SpreadsheetBtnClass~}" onclick="_Pict.providers.ObservationTypeEditor.setPreviewMode('spreadsheet')"><span class="icon">{~I:Spreadsheet~}</span><span>Spreadsheet</span></button>
						</div>
					</div>
					<p class="help mb-2">How this type looks when filled in the field. The same type can be associated to a project as either a journal or a spreadsheet.</p>
					<div class="box ote-preview">
						{~TS:ObservationType-PreviewEmpty:AppData.ObservationTypeEditor.PreviewEmptySlot~}
						{~TS:ObservationType-PreviewJournal:AppData.ObservationTypeEditor.PreviewJournalSlot~}
						{~TS:ObservationType-PreviewSheet:AppData.ObservationTypeEditor.PreviewSpreadsheetSlot~}
					</div>

					<div class="ote-section-head">
						<h2 class="title is-5">Projects <span class="tag is-light">using this type</span></h2>
					</div>
					<p class="help mb-2">The projects that use this observation type. For each, choose whether it appears as a <strong>Journal</strong> or a <strong>Spreadsheet</strong> and set its order — the same type can be used both ways across different projects.</p>
					{~TS:ObservationType-Projects:AppData.ObservationTypeEditor.ProjectsSlot~}
					{~TS:ObservationType-ProjectsHint:AppData.ObservationTypeEditor.ProjectsHintSlot~}
				</div>`
		},
		{
			Hash: 'ObservationType-Projects',
			Template: /*html*/`<div id="OTE-ProjectsAssoc" class="ote-projects-assoc"></div>`
		},
		{
			Hash: 'ObservationType-ProjectsHint',
			Template: /*html*/`<article class="message is-light is-small"><div class="message-body">Save this observation type first — then you can associate it with projects here.</div></article>`
		},
		{
			Hash: 'ObservationType-SaveButton',
			Template: /*html*/`{~TIfAbs:ObservationType-SaveButton-Inner:Record:Record.CanEdit^TRUE^~}`
		},
		{
			Hash: 'ObservationType-SaveButton-Inner',
			Template: /*html*/`<button class="button is-link" {~D:Record.SaveDisabledAttr~} onclick="_Pict.providers.ObservationTypeEditor.saveAsync()"><span class="icon">{~I:Save~}</span><span>Save</span></button>`
		},
		{
			Hash: 'ObservationType-CloneButton',
			Template: /*html*/`{~TIfAbs:ObservationType-CloneButton-Inner:Record:Record.CanClone^TRUE^~}`
		},
		{
			Hash: 'ObservationType-CloneButton-Inner',
			Template: /*html*/`<button class="button is-light" onclick="_Pict.providers.ObservationTypeEditor.cloneCurrentToMyCustomer()"><span class="icon">{~I:Copy~}</span><span>Clone</span></button>`
		},
		{
			Hash: 'ObservationType-AddButton',
			Template: /*html*/`{~TIfAbs:ObservationType-AddButton-Inner:Record:Record.CanEdit^TRUE^~}`
		},
		{
			Hash: 'ObservationType-AddButton-Inner',
			Template: /*html*/`<button class="button is-small is-link is-light" onclick="_Pict.providers.ObservationTypeEditor.addRequirement()"><span class="icon">{~I:Plus~}</span><span>Add requirement</span></button>`
		},
		{
			Hash: 'ObservationType-RequirementRow',
			Template: /*html*/`
				<tr>
					<td><input class="input is-small" type="text" value="{~D:Record.Name~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setRequirementField('{~D:Record.Key~}','Name', this.value)" /></td>
					<td>
						<input class="input is-small ote-req-artifact{~NE:Record.ArtifactMissing^ ote-req-missing~}" type="text" list="ote-artifact-options" placeholder="pick an artifact type" value="{~D:Record.ArtifactName~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setRequirementArtifact('{~D:Record.Key~}', this.value)" />
						<span class="ote-req-summary">{~D:Record.ArtifactSummary~}</span>
					</td>
					<td class="has-text-centered"><input type="checkbox" {~D:Record.RequiredAttr~} {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setRequirementField('{~D:Record.Key~}','Required', this.checked)" /></td>
					<td><input class="input is-small ote-req-num" type="number" min="0" value="{~D:Record.CountMinimum~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setRequirementField('{~D:Record.Key~}','CountMinimum', this.value)" /></td>
					<td><input class="input is-small ote-req-num" type="number" min="0" value="{~D:Record.CountMaximum~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setRequirementField('{~D:Record.Key~}','CountMaximum', this.value)" /></td>
					<td><input class="input is-small" type="text" value="{~D:Record.DefaultJSON~}" {~D:Record.ReadOnlyAttr~} onchange="_Pict.providers.ObservationTypeEditor.setRequirementField('{~D:Record.Key~}','DefaultJSON', this.value)" /></td>
					<td class="has-text-right">{~TIfAbs:ObservationType-RemoveButton:Record:AppData.ObservationTypeEditor.CanEdit^TRUE^~}</td>
				</tr>`
		},
		{
			Hash: 'ObservationType-RemoveButton',
			Template: /*html*/`<button class="button is-small is-white" title="Remove requirement" onclick="_Pict.providers.ObservationTypeEditor.removeRequirement('{~D:Record.Key~}')">{~I:Trash~}</button>`
		},
		{
			Hash: 'ObservationType-EmptyRequirements',
			Template: /*html*/`<p class="has-text-grey has-text-centered py-4">No requirements yet. Use <strong>Add requirement</strong> to compose this type.</p>`
		},
		{
			Hash: 'ObservationType-PreviewEmpty',
			Template: /*html*/`<p class="has-text-grey has-text-centered py-4">Add requirements with artifact types to preview the observation.</p>`
		},
		{
			Hash: 'ObservationType-PreviewJournal',
			Template: /*html*/`<div class="ote-pv-journal">{~TS:ObservationType-PreviewJournalReq:AppData.ObservationTypeEditor.PreviewJournal~}</div>`
		},
		{
			Hash: 'ObservationType-PreviewJournalReq',
			Template: /*html*/`
				<div class="ote-pv-req">
					<div class="ote-pv-reqhead"><strong>{~D:Record.Label~}</strong>{~TIfAbs:ObservationType-PvRequiredTag:Record:Record.RequiredFlag^TRUE^~}{~TS:ObservationType-PvRepeatTag:Record.RepeatSlot~}</div>
					{~TS:ObservationType-PreviewField:Record.Fields~}
					{~TS:ObservationType-PvCapture:Record.CaptureSlot~}
				</div>`
		},
		{
			Hash: 'ObservationType-PvRequiredTag',
			Template: /*html*/`<span class="tag is-danger is-light ml-2">required</span>`
		},
		{
			Hash: 'ObservationType-PvRepeatTag',
			Template: /*html*/`<span class="tag is-light ml-2">{~D:Record.Text~}</span>`
		},
		{
			Hash: 'ObservationType-PvCapture',
			Template: /*html*/`<div class="ote-pv-field has-text-grey"><span class="icon">{~I:Image~}</span> captures <strong>{~D:Record.ArtifactName~}</strong> <span class="is-size-7">(no editable fields)</span></div>`
		},
		{
			Hash: 'ObservationType-PreviewField',
			Template: /*html*/`<div class="ote-pv-field">{~TIfAbs:ObservationType-PvFieldLabel:Record:Record.MultiField^TRUE^~}{~TIfAbs:ObservationType-PreviewInputSelect:Record:Record.IsSelect^TRUE^~}{~TIfAbs:ObservationType-PreviewInputCheckbox:Record:Record.IsCheckbox^TRUE^~}{~TIfAbs:ObservationType-PreviewInputText:Record:Record.IsText^TRUE^~}</div>`
		},
		{
			Hash: 'ObservationType-PvFieldLabel',
			Template: /*html*/`<label class="ote-pv-fieldlabel">{~D:Record.Label~}</label>`
		},
		{
			Hash: 'ObservationType-PreviewInputSelect',
			Template: /*html*/`<span class="select is-small is-fullwidth"><select disabled>{~TS:ObservationType-PreviewOption:Record.Options~}</select></span>`
		},
		{
			Hash: 'ObservationType-PreviewInputCheckbox',
			Template: /*html*/`<input type="checkbox" disabled />`
		},
		{
			Hash: 'ObservationType-PreviewInputText',
			Template: /*html*/`<input class="input is-small" type="{~D:Record.InputType~}" placeholder="{~D:Record.Label~}" disabled />`
		},
		{
			Hash: 'ObservationType-PreviewOption',
			Template: /*html*/`<option>{~D:Record.Value~}</option>`
		},
		{
			Hash: 'ObservationType-PreviewSheet',
			Template: /*html*/`
				<div class="ote-pv-sheet">
					<table class="table is-bordered is-narrow">
						<thead><tr>{~TS:ObservationType-PreviewCol:AppData.ObservationTypeEditor.PreviewColumns~}</tr></thead>
						<tbody>{~TS:ObservationType-PreviewRow:AppData.ObservationTypeEditor.PreviewRows~}</tbody>
					</table>
				</div>`
		},
		{
			Hash: 'ObservationType-PreviewCol',
			Template: /*html*/`<th>{~D:Record.Header~}</th>`
		},
		{
			Hash: 'ObservationType-PreviewRow',
			Template: /*html*/`<tr>{~TS:ObservationType-PreviewCell:Record.Cells~}</tr>`
		},
		{
			Hash: 'ObservationType-PreviewCell',
			Template: /*html*/`<td>{~TIfAbs:ObservationType-PreviewInputSelect:Record:Record.IsSelect^TRUE^~}{~TIfAbs:ObservationType-PreviewInputCheckbox:Record:Record.IsCheckbox^TRUE^~}{~TIfAbs:ObservationType-PreviewInputText:Record:Record.IsText^TRUE^~}</td>`
		},
		{
			Hash: 'ObservationType-ReadOnlyNotice',
			Template: /*html*/`
				<article class="message is-warning is-small">
					<div class="message-body">
						<span class="icon">{~I:Lock~}</span>
						This <strong>{~D:Record.ScopeLabel~}</strong> observation type is <strong>read-only</strong> here. Editing your organization’s own types needs the <em>Manage observation types</em> permission; shared platform defaults can be <strong>cloned</strong> to make an editable copy for your organization.
					</div>
				</article>`
		},
		{
			Hash: 'ObservationType-ClonedNotice',
			Template: /*html*/`<article class="message is-success is-small"><div class="message-body">Cloned from <strong>{~D:Record.ClonedFrom~}</strong>. Review the name and requirements, then Save to create it.</div></article>`
		},
		{
			Hash: 'ObservationType-Message',
			Template: /*html*/`<div class="notification {~D:Record.MessageClass~} is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'ObservationType-Loading',
			Template: /*html*/`<div class="ote-empty box has-text-grey has-text-centered"><span class="ote-spinner"></span><p class="mt-3">Loading…</p></div>`
		},
		{
			Hash: 'ObservationType-Empty',
			Template: /*html*/`<div class="ote-empty box has-text-grey has-text-centered"><span class="icon is-large">{~I:File~}</span><p class="mt-3">Pick an observation type from the list, or create a new one.</p></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationTypeEditorWrap',
			TemplateHash: 'ObservationType-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};

},{"pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js":988,"pict-view":1053}],1455:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * OrganizationAddressTab — a master/detail editor for an Organization's addresses, rendered as a tab in the
 * Organization read view's Split layout (the secondary form "to the right" of the record).
 *
 * OrganizationAddress is a 1:N child of Organization (its IDOrganization FK). This view lists the current
 * org's addresses; clicking a row opens that address's edit form in place (edit in the panel, no navigation
 * away), and "Add address" opens a blank form. Save POSTs (new) or PUTs (existing) the OrganizationAddress
 * and returns to the list. Self-contained (own REST + templates), like the other bespoke read tabs
 * (ChildListTab, MaterialSpecSetsTab). Conditional rendering is done with 0/1-length "slot" arrays, the
 * pattern pict-template supports (there is no inline block-if).
 */

// The address fields the form exposes, in order. `Wide` spans the full row.
const FIELDS =
[
	{ Key: 'LocationName', Label: 'Location Name', Wide: true },
	{ Key: 'LocationType', Label: 'Location Type' },
	{ Key: 'Phone', Label: 'Phone' },
	{ Key: 'Email', Label: 'Email' },
	{ Key: 'Address', Label: 'Address', Wide: true },
	{ Key: 'City', Label: 'City' },
	{ Key: 'State', Label: 'State' },
	{ Key: 'Zip', Label: 'ZIP Code' },
];

class OrganizationAddressTab extends libPictView
{
	get restClient() { return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient; }
	get viewID() { return this.options.ViewIdentifier || this.Hash; }

	_getJSON(pURL) { return new Promise((resolve, reject) => this.restClient.getJSON(pURL, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)))); }
	_postJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.postJSON(pURL, pPayload, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)))); }
	_putJSON(pURL, pPayload) { return new Promise((resolve, reject) => this.restClient.putJSON(pURL, pPayload, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)))); }

	_parentID() { return (this.pict.AppData.OrganizationDetails || {}).IDOrganization; }
	_escape(pValue) { return String((pValue === null || typeof pValue === 'undefined') ? '' : pValue).replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[pChar]); }
	_str(pValue) { return (pValue === null || typeof pValue === 'undefined') ? '' : String(pValue).trim(); }

	async _fetchAddresses()
	{
		const tmpParent = this._parentID();
		if (!tmpParent) { return []; }
		try
		{
			// Meadow pluralizes an entity route naively (Entity + "s"), so OrganizationAddress -> OrganizationAddresss.
			const tmpRows = await this._getJSON(`OrganizationAddresss/FilteredTo/FBV~IDOrganization~EQ~${ tmpParent }~FSF~LocationName~ASC~0/0/100`);
			return Array.isArray(tmpRows) ? tmpRows : [];
		}
		catch (pError)
		{
			this.pict.log.warn(`OrganizationAddressTab: fetch failed`, { Error: pError && (pError.message || pError) });
			return null; // error signal
		}
	}

	// --- Render state (the render Record; conditional blocks are 0/1-length slot arrays) ---

	_listState(pRows, pFailed)
	{
		const tmpSaved = ![ undefined, null, '' ].includes(this._parentID());
		const tmpRows = (pRows || []).map((pRow) =>
		{
			const tmpName = this._str(pRow.LocationName) || this._str(pRow.Address) || `Address #${ pRow.IDOrganizationAddress }`;
			const tmpSub = [ this._str(pRow.City), this._str(pRow.State), this._str(pRow.Zip) ].filter(Boolean).join(', ');
			return { ViewID: this.viewID, ID: pRow.IDOrganizationAddress, Title: this._escape(tmpName), Sub: this._escape(tmpSub), Type: this._escape(this._str(pRow.LocationType)) };
		});
		const tmpShowEmpty = pFailed || (tmpRows.length === 0);
		const tmpMessage = pFailed ? 'Could not load addresses.' : (tmpSaved ? 'No addresses yet — add one.' : 'Save the organization before adding addresses.');
		return {
			ViewID: this.viewID,
			ListSlot: [ {
				ViewID: this.viewID,
				AddSlot: tmpSaved ? [ { ViewID: this.viewID } ] : [],
				EmptySlot: tmpShowEmpty ? [ { Message: tmpMessage } ] : [],
				Rows: tmpRows
			} ],
			EditSlot: []
		};
	}

	_editState(pRecord)
	{
		const tmpNew = !pRecord || !pRecord.IDOrganizationAddress;
		const tmpHeading = tmpNew ? 'New Address' : (this._str(pRecord.LocationName) || 'Edit Address');
		return {
			ViewID: this.viewID,
			ListSlot: [],
			EditSlot: [ {
				ViewID: this.viewID,
				Heading: this._escape(tmpHeading),
				Fields: FIELDS.map((pField) => ({ ViewID: this.viewID, Key: pField.Key, Label: pField.Label, WideClass: pField.Wide ? 'wide' : '', Value: this._escape(this._str((pRecord || {})[pField.Key])) }))
			} ]
		};
	}

	// The read view sets our DefaultDestinationAddress to the tab body and calls renderAsync() with no args;
	// internal re-renders (list <-> edit) call renderAsync() again and land back in that same panel.
	async renderAsync(pRenderable, pDestinationAddress, pData, fCallback)
	{
		if (!this._record) { const tmpRows = await this._fetchAddresses(); this._record = this._listState(tmpRows, tmpRows === null); }
		return super.renderAsync(pRenderable || this.options.DefaultRenderable, pDestinationAddress || this.options.DefaultDestinationAddress, this._record, fCallback);
	}

	async _showList()
	{
		const tmpRows = await this._fetchAddresses();
		this._record = this._listState(tmpRows, tmpRows === null);
		return this.renderAsync();
	}

	async edit(pID)
	{
		this._editID = pID;
		try
		{
			// Read-by-id uses the SINGULAR route (OrganizationAddress/:id) and returns the record directly.
			const tmpRecord = await this._getJSON(`OrganizationAddress/${ pID }`);
			this._record = this._editState((Array.isArray(tmpRecord) ? tmpRecord[0] : tmpRecord) || { IDOrganizationAddress: pID });
		}
		catch (pError) { this._toast(`Could not load address: ${ pError && (pError.message || pError) }`, 'error'); return; }
		return this.renderAsync();
	}

	add() { this._editID = null; this._record = this._editState(null); return this.renderAsync(); }
	cancel() { return this._showList(); }

	async save()
	{
		const tmpPayload = {};
		FIELDS.forEach((pField) => { tmpPayload[pField.Key] = this.pict.ContentAssignment.readContent(`#OAT-${ this.viewID }-${ pField.Key }`) || ''; });
		try
		{
			if (this._editID)
			{
				tmpPayload.IDOrganizationAddress = this._editID;
				await this._putJSON('OrganizationAddress', tmpPayload);
			}
			else
			{
				tmpPayload.IDOrganization = this._parentID();
				await this._postJSON('OrganizationAddress', tmpPayload);
			}
			this._toast('Address saved.', 'success');
		}
		catch (pError) { this._toast(`Could not save: ${ pError && (pError.message || pError) }`, 'error'); return; }
		return this._showList();
	}

	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && (typeof tmpModal.toast === 'function')) { tmpModal.toast(pMessage, { type: pType || 'info' }); }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'OrganizationAddresses',
	DefaultRenderable: 'OAT-Renderable',
	DefaultDestinationAddress: '#OAT-Container',
	DefaultTemplateRecordAddress: false,
	AutoInitialize: false,
	AutoRender: false,
	AutoSolveWithApp: false,
	CSS: /*css*/`
		.oat { font-size: 0.92rem; }
		.oat-head { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; margin: 0 0 0.85rem; }
		.oat-head h3 { margin: 0; font-size: 1rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.oat-add { display: inline-flex; align-items: center; gap: 0.35rem; border: 1px solid var(--theme-color-brand-primary, #5650e6); background: var(--theme-color-brand-primary, #5650e6); color: #fff; border-radius: 8px; padding: 0.4rem 0.8rem; font: inherit; font-size: 0.85rem; font-weight: 600; cursor: pointer; }
		.oat-add:hover { filter: brightness(1.05); }
		.oat-list { display: grid; gap: 0.5rem; }
		.oat-row { text-align: left; width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; padding: 0.7rem 0.9rem; background: var(--theme-color-background-primary, #fff); cursor: pointer; transition: all 0.12s ease; font: inherit; }
		.oat-row:hover { border-color: var(--theme-color-brand-primary, #5650e6); background: var(--theme-color-background-selected, #eef0fb); }
		.oat-row-main { min-width: 0; }
		.oat-row-name { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.oat-row-sub { display: block; font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); margin-top: 0.1rem; }
		.oat-row-type { flex: 0 0 auto; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-tertiary, #eef0f4); border-radius: 999px; padding: 0.15rem 0.6rem; }
		.oat-row-type:empty { display: none; }
		.oat-row-edit { flex: 0 0 auto; font-size: 0.8rem; font-weight: 600; color: var(--theme-color-brand-primary, #5650e6); white-space: nowrap; }
		.oat-empty { color: var(--theme-color-text-muted, #6b7686); text-align: center; padding: 1.5rem 0; }
		.oat-form { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem 1rem; }
		.oat-field.wide { grid-column: 1 / -1; }
		.oat-field label { display: block; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.3rem; }
		.oat-field input { width: 100%; box-sizing: border-box; padding: 0.5rem 0.7rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); font: inherit; font-size: 0.9rem; }
		.oat-field input:focus { outline: none; border-color: var(--theme-color-brand-primary, #5650e6); }
		.oat-actions { grid-column: 1 / -1; display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 0.4rem; }
		.oat-btn { border-radius: 8px; padding: 0.45rem 1rem; font: inherit; font-size: 0.88rem; font-weight: 600; cursor: pointer; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.oat-btn.primary { background: var(--theme-color-status-success, #1f9d55); border-color: var(--theme-color-status-success, #1f9d55); color: #fff; }
		.oat-btn:hover { filter: brightness(0.98); }
	`,
	CSSPriority: 500,

	Templates:
	[
		{
			Hash: 'OAT-Root',
			Template: /*html*/`
				<div class="oat" id="OAT-Container">
					{~TS:OAT-List:Record.ListSlot~}
					{~TS:OAT-Edit:Record.EditSlot~}
				</div>`
		},
		{
			Hash: 'OAT-List',
			Template: /*html*/`
				<div class="oat-head"><h3>Addresses</h3>{~TS:OAT-AddButton:Record.AddSlot~}</div>
				{~TS:OAT-Empty:Record.EmptySlot~}
				<div class="oat-list">{~TS:OAT-Row:Record.Rows~}</div>`
		},
		{
			Hash: 'OAT-AddButton',
			Template: /*html*/`<button type="button" class="oat-add" onclick="_Pict.views['{~D:Record.ViewID~}'].add()">{~I:Plus~} Add address</button>`
		},
		{
			Hash: 'OAT-Empty',
			Template: /*html*/`<p class="oat-empty">{~D:Record.Message~}</p>`
		},
		{
			Hash: 'OAT-Row',
			Template: /*html*/`<button type="button" class="oat-row" onclick="_Pict.views['{~D:Record.ViewID~}'].edit({~D:Record.ID~})"><span class="oat-row-main"><span class="oat-row-name">{~D:Record.Title~}</span><span class="oat-row-sub">{~D:Record.Sub~}</span></span><span class="oat-row-type">{~D:Record.Type~}</span><span class="oat-row-edit">Edit {~I:ChevronRight~}</span></button>`
		},
		{
			Hash: 'OAT-Edit',
			Template: /*html*/`
				<div class="oat-head"><h3>{~D:Record.Heading~}</h3></div>
				<div class="oat-form">
					{~TS:OAT-Field:Record.Fields~}
					<div class="oat-actions">
						<button type="button" class="oat-btn" onclick="_Pict.views['{~D:Record.ViewID~}'].cancel()">Cancel</button>
						<button type="button" class="oat-btn primary" onclick="_Pict.views['{~D:Record.ViewID~}'].save()">{~I:Save~} Save</button>
					</div>
				</div>`
		},
		{
			Hash: 'OAT-Field',
			Template: /*html*/`<div class="oat-field {~D:Record.WideClass~}"><label>{~D:Record.Label~}</label><input type="text" id="OAT-{~D:Record.ViewID~}-{~D:Record.Key~}" value="{~D:Record.Value~}" /></div>`
		}
	],

	Renderables:
	[
		{ RenderableHash: 'OAT-Renderable', TemplateHash: 'OAT-Root', RenderMethod: 'replace' }
	]
};

module.exports = OrganizationAddressTab;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":1053}],1456:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * PhysicalAssetDashboard — the thin standalone screen (#/AssetDashboard[/:View]) that hosts the physical-asset
 * dashboard: Map · Browse · Overview over the inventory + its backfilled metadata. The provider paints into
 * #PAD-Host. Full browser width via Dashboard Mode. See [[PhysicalAssetDashboard-Provider.js]].
 */
class PhysicalAssetDashboardView extends libPictView
{
	get provider() { return this.pict.providers['PhysicalAssetDashboard']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider._mount = '#PAD-Host'; tmpProvider.loadAsync(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PhysicalAssetDashboardView;

module.exports.default_configuration =
{
	ViewIdentifier: 'PhysicalAssetDashboard',
	DefaultRenderable: 'PhysicalAssetDashboardWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.pad-page { padding: 1.25rem 2rem 2rem; }
		.pad-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.pad-page-h i { color: var(--theme-color-brand-primary,#2e7d74); }
		.pad-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1rem; }
	`,

	Templates:
	[
		{
			Hash: 'PhysicalAssetDashboard-Template',
			Template: html`
				<section class="section pad-page">
					<h1 id="PAD-Heading" class="pad-page-h"><i class="fas fa-map-location-dot"></i> Asset Dashboard</h1>
					<p id="PAD-Subheading" class="pad-page-sub">Map, browse, and analyze the physical-asset inventory.</p>
					<div id="PAD-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PhysicalAssetDashboardWrap',
			TemplateHash: 'PhysicalAssetDashboard-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1457:[function(require,module,exports){
const libPictView = require('pict-view');
const { ActionCards } = require('headlight-sample-scanning');

/**
 * Printer Codes (#/Printer-Codes): one print button per Scan Samples action card. Reached from the panels'
 * Settings pane ("QR Printer Codes"), not from the navigation menu.
 */
class PrinterCodes extends libPictView
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		/** @type {any} */
		this.options;
	}

	/** @return {string} one row per Scan Samples action card */
	get cardsHTML()
	{
		return ActionCards.map((pCard) => /*html*/`
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>${ pCard.Description }</em>
							</div>
							<div class="column is-3">
								<button type="button" id="PrinterCodes-${ pCard.Hash }" class="button is-link is-fullwidth"
									onclick="_Pict.providers.QRCodeProvider.print('${ pCard.Payload }', { printStyle: 'thin', raw: true, footers: ['HLLOGO ${ pCard.Footer }']});">
									<span class="icon mr-3"><i class="fas fa-fw ${ pCard.Icon }"></i></span>
									${ pCard.Label }
								</button>
							</div>
						</div>`).join('');
	}
}

module.exports = PrinterCodes;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'PrinterCodes',
		DefaultRenderable: 'PrinterCodes',
		DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',

		AutoRender: false,

		CSS: '',

		Templates: [
			{
				Hash: 'PrinterCodes-Wrapper',
				Template: /*html*/`
				<section id="PrinterCodes" class="form p-5">
					<h2 class="title is-4 mb-3">Printer Codes</h2>
					<div class="content">{~D:Context[0].cardsHTML~}
					</div>
				</section>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'PrinterCodes',
				TemplateHash: 'PrinterCodes-Wrapper',
				RenderMethod: 'replace',
			} ],
	});

},{"headlight-sample-scanning":294,"pict-view":1053}],1458:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * ProjectActivity — the #/ProjectActivity[/:IDProject] screen. A per-project data-activity view: create/update
 * pressure for Documents, Observations and Line Items over time, plus a recent-activity stream of the latest
 * create/update events on the project.
 *
 * Thin shell over the shared ActivityObservability provider (renders into #AO-Project-Body).
 */
class ProjectActivity extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// When embedded (the ProjectWorkspace Data ▸ Data Volume tab) this holds the host selector; render() then
		// targets it, so the .ao-wrap shell — and thus the shared provider's global #AO-Project-Body / chart assigns
		// that live inside it — land in the tab host instead of the app container.
		this._embedDestination = null;
	}

	get provider() { return this.pict.providers.ActivityObservability; }

	/** Render into the embed host when embedded. An explicit destination argument always wins. */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed the data-volume dashboard into a host for a fixed project (skips the standalone picker). Unlike
	 *  SamplePlan/ProjectFunding, the SHARED ActivityObservability provider paints into global ids and never
	 *  redraws its chart on a plain repaint — so: render the shell into the host FIRST (creates #AO-Project-Body),
	 *  then either load (project changed) or just redraw the chart from cache (same-project repaint). The guard on
	 *  projectActivity.IDProject keeps a routine workspace repaint from re-firing the expensive COUNT fan-out. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		const tmpProvider = this.provider;
		const tmpSameProject = !!(tmpProvider && tmpProvider.projectActivity && (Number(tmpProvider.projectActivity.IDProject) === Number(pIDProject)));
		if (tmpProvider && tmpProvider.projectActivity) { tmpProvider.projectActivity.IDProject = Number(pIDProject); }
		this.render();   // paint .ao-wrap (+ #AO-Project-Body) into the host; onAfterRender fills the body
		if (tmpProvider && !tmpSameProject) { tmpProvider.loadProjectActivityAsync(pIDProject); }
		else if (tmpProvider && (typeof tmpProvider._drawProjectChart === 'function')) { tmpProvider._drawProjectChart(); }
	}

	/** Leave embedded mode — the standalone #/ProjectActivity screen renders to the app container again. */
	exitEmbed() { this._embedDestination = null; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._ensureStyles();
			tmpProvider.renderProjectActivity();
			// No auto-load here: there is no default project, and the :IDProject sub-route loads explicitly — so
			// loading from onAfterRender too would double-fire (two identical project-resolve + count passes).
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ProjectActivity;
module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectActivity',
	// Reusable app-shell Dashboard Mode — render full browser width (see PlatformConfiguration-Router _applyDashboardMode).
	DashboardMode: true,
	DefaultRenderable: 'ProjectActivityWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: '',
	Templates:
	[
		{
			Hash: 'ProjectActivity-Wrap',
			Template: /*html*/`
				<div class="ao-wrap">
					<div class="ao-head">
						<h1 class="ao-title">Project Activity</h1>
						<p class="ao-subtitle">A project&#8217;s data over time — Documents, Observations and Line Items created or updated per day, week or month, plus a stream of the most recent activity.</p>
					</div>
					<div id="AO-Project-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ProjectActivityWrap',
			TemplateHash: 'ProjectActivity-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1459:[function(require,module,exports){

const libPictSectionLeaflet = require('pict-section-leaflet');

/**
 * ProjectCenterMap — the geographic-center picker for the Project workspace. Extends the
 * pict-section-leaflet base but drives its own mount: the workspace calls showForProject() whenever the
 * Location tab becomes visible (Leaflet needs a visible, sized container), and the marker reports moves
 * back to the ProjectWorkspace provider's working center via a light update (so a marker drag never
 * re-renders the workspace and tears the map down under itself).
 */
class ProjectCenterMap extends libPictSectionLeaflet
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		this._map = false;
		this._marker = false;
	}

	/** The host provider whose working center this map drives — 'ProjectWorkspace' by default, but a second
	 *  instance (ProjectCreateMap) points at 'ProjectCreateWorkspace'. Both expose center/hasCenter/setCenter. */
	get provider()
	{
		return this.pict.providers[(this.options && this.options.ProviderName) || 'ProjectWorkspace'];
	}

	/** The DOM id of the map host div (configurable so the create screen can use its own #PCW-MapHost). */
	get mapHostID()
	{
		return (this.options && this.options.MapHostID) || 'PW-MapHost';
	}

	get leafletLib()
	{
		return (typeof window !== 'undefined' && window.L) ? window.L : false;
	}

	/**
	 * (Re)mount the map into #PW-MapHost for the current project's center. Called on every Location-tab
	 * show; the panel host is recreated by the workspace render, so we tear down any prior map first.
	 */
	showForProject()
	{
		const L = this.leafletLib;
		const tmpHost = (typeof document !== 'undefined') ? document.getElementById(this.mapHostID) : null;
		if (!L || !tmpHost || !this.provider) { return; }

		if (this._map)
		{
			try { this._map.remove(); } catch (pError) { /* prior map already detached */ }
			this._map = false;
			this._marker = false;
		}

		const tmpCenter = this.provider.center;
		const tmpHasCenter = this.provider.hasCenter;
		// When there's no real center yet (unset, or the 0,0 "null island" sentinel), open on a wide
		// default view rather than dropping the user in the Gulf of Guinea.
		const tmpLat = tmpHasCenter ? Number(tmpCenter.Latitude) : 39.5;
		const tmpLng = tmpHasCenter ? Number(tmpCenter.Longitude) : -98.35;

		this._map = L.map(tmpHost).setView([ tmpLat, tmpLng ], tmpHasCenter ? 13 : 4);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			{ maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(this._map);

		if (tmpHasCenter)
		{
			this._addMarker(tmpLat, tmpLng);
		}
		this._map.on('click', (pEvent) => { this._placeMarker(pEvent.latlng.lat, pEvent.latlng.lng); });

		// The container was just revealed; let Leaflet re-measure it on the next tick.
		setTimeout(() => { if (this._map) { this._map.invalidateSize(); } }, 60);
	}

	_addMarker(pLat, pLng)
	{
		const L = this.leafletLib;
		if (!L || !this._map) { return; }
		this._marker = L.marker([ pLat, pLng ], { draggable: true }).addTo(this._map);
		this._marker.on('dragend', (pEvent) =>
		{
			const tmpLatLng = pEvent.target.getLatLng();
			this._commit(tmpLatLng.lat, tmpLatLng.lng);
		});
	}

	_placeMarker(pLat, pLng)
	{
		if (!this._marker)
		{
			this._addMarker(pLat, pLng);
		}
		else
		{
			this._marker.setLatLng([ pLat, pLng ]);
		}
		this._commit(pLat, pLng);
	}

	/** Report the new center to the provider (light update: readout + Save only, map stays mounted). */
	_commit(pLat, pLng)
	{
		if (this.provider) { this.provider.setCenter(pLat, pLng); }
	}

	/**
	 * Move the marker + recenter the map to a programmatically supplied center (typed latitude/longitude
	 * or an address-search result). Unlike _placeMarker this does NOT _commit back to the provider — the
	 * provider's setCenter() already owns the working-center update, so committing here would loop.
	 * @param {Number} pLat @param {Number} pLng
	 */
	moveMarkerTo(pLat, pLng)
	{
		const tmpLat = Number(pLat);
		const tmpLng = Number(pLng);
		if (!this._map || !Number.isFinite(tmpLat) || !Number.isFinite(tmpLng)) { return; }
		if (!this._marker) { this._addMarker(tmpLat, tmpLng); }
		else { this._marker.setLatLng([ tmpLat, tmpLng ]); }
		this._map.setView([ tmpLat, tmpLng ], Math.max(this._map.getZoom() || 13, 13));
	}
}

module.exports = ProjectCenterMap;

module.exports.default_configuration = Object.assign({}, libPictSectionLeaflet.default_configuration,
	{
		ViewIdentifier: 'ProjectCenterMap',
		AutoRender: false,
		AutoInitialize: true,
		LeafletDestinationAddress: 'PW-MapHost',
		LeafletInitialCenter: [ 39.5, -98.35 ],
		LeafletInitialZoom: 4,
	});

},{"pict-section-leaflet":669}],1460:[function(require,module,exports){

const libPictView = require('pict-view');

/**
 * Project Clone workflow view.
 *
 * Three-step accordion (Prepare → Ready → Results). All state lives in
 * pict.AppData.ProjectClone and all behavior lives in ProjectCloneProvider; the
 * view only triggers derivation + a one-time project load and repaints
 * declaratively from AppData.
 */
class ProjectClone extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.ProjectCloneProvider;
	}

	deriveRenderState()
	{
		this.provider.deriveRenderState();
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onBeforeRenderAsync(fCallback)
	{
		this.deriveRenderState();
		return fCallback();
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		// Wire the Select2-backed Project pickers each render (the destination
		// picker only when in existing-project mode and the field is visible).
		this._initProjectSelect('#ProjectClone-SourceSelect', 'setSource', false);
		const tmpState = this.pict.AppData.ProjectClone;
		if (tmpState && tmpState.DestMode === 'existing')
		{
			this._initProjectSelect('#ProjectClone-DestSelect', 'setDest', true);
		}
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	/**
	 * Initialize a Select2-powered Project picker (AJAX, session-scoped, searchable)
	 * on the given select element and route its selection back into the provider.
	 *
	 * @param {string} pSelector - CSS selector for the <select> element.
	 * @param {string} pMethod - Provider method to call on change ('setSource' | 'setDest').
	 * @param {boolean} pExcludeSource - When true, filter the chosen source project out of results.
	 */
	_initProjectSelect(pSelector, pMethod, pExcludeSource)
	{
		const tmpJQuery = window.jQuery;
		if (!tmpJQuery || !tmpJQuery.fn || !tmpJQuery.fn.select2)
		{
			return;
		}
		const tmpElement = tmpJQuery(pSelector);
		if (tmpElement.length === 0 || tmpElement.data('select2'))
		{
			// Not in the DOM yet, or already initialized on this element.
			return;
		}
		const tmpProvider = this.provider;
		const tmpOptions = this.pict.providers.Select2Util.getOptionsAjax('Project',
			{
				SearchFallbackPlaceholder: 'Search projects by name...',
				HandleSearchFilters: (pFilters) =>
				{
					// Exclude the chosen source project from the destination results.
					if (pExcludeSource)
					{
						const tmpSourceID = this.pict.AppData.ProjectClone && this.pict.AppData.ProjectClone.SourceIDProject;
						if (tmpSourceID)
						{
							pFilters.push(`FBV~IDProject~NE~${parseInt(tmpSourceID, 10)}`);
						}
					}
					// Always sort results by Name ascending (mirrors the platform
					// ProjectSelector input).
					if (!pFilters.some((pFilter) => String(pFilter).indexOf('FSF') === 0))
					{
						pFilters.push('FSF~Name~ASC~0');
					}
					return pFilters;
				},
			});
		tmpElement.select2(tmpOptions);
		tmpElement.on('select2:select', (pEvent) =>
		{
			const tmpData = (pEvent.params && pEvent.params.data) || {};
			// Defer so Select2 finishes its own event cycle before the view re-renders
			// (the re-render replaces this element).
			window.setTimeout(() => tmpProvider[pMethod](String(tmpData.id), tmpData.text), 0);
		});
		tmpElement.on('select2:clear', () =>
		{
			window.setTimeout(() => tmpProvider[pMethod](''), 0);
		});
	}
}

module.exports = ProjectClone;

module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectClone',
	DefaultRenderable: 'ProjectCloneWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.project-clone-entity-row td { vertical-align: middle; }
		.project-clone-spinner { display: inline-block; width: 1.5rem; height: 1.5rem; border: 3px solid var(--bulma-border, #dbdbdb); border-top-color: var(--bulma-link, #485fc7); border-radius: 50%; animation: project-clone-spin 0.8s linear infinite; vertical-align: middle; }
		@keyframes project-clone-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'ProjectClone-SelectedOption',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'ProjectClone-EntityRow',
			Template: /*html*/`
				<tr class="project-clone-entity-row {~D:Record.RowClass~}">
					<td>
						<label class="checkbox">
							<input type="checkbox" {~D:Record.CheckedAttr~}
								onchange="_Pict.providers.ProjectCloneProvider.toggleEntity('{~D:Record.Entity~}')" />
							&nbsp;<strong>{~D:Record.Label~}</strong>
						</label>
					</td>
					<td class="has-text-right">{~D:Record.Count~}</td>
				</tr>`,
		},
		{
			Hash: 'ProjectClone-WarningRow',
			Template: /*html*/`<li>{~D:Record.Message~}</li>`,
		},
		{
			Hash: 'ProjectClone-GenerateError',
			Template: /*html*/`
				<div class="notification is-danger mt-3">
					<span class="icon"><i class="fas fa-triangle-exclamation"></i></span>
					&nbsp;Could not generate the clone preview: {~D:Record.Message~}
				</div>`,
		},
		{
			Hash: 'ProjectClone-ResultBanner',
			Template: /*html*/`
				<div class="notification {~D:Record.TypeClass~} mt-2">
					<h4 class="title is-4">
						<span class="icon"><i class="fas {~D:Record.Icon~}"></i></span>
						&nbsp;{~D:Record.Title~}
					</h4>
					<p>{~D:Record.Detail~}</p>
				</div>`,
		},
		{
			Hash: 'ProjectCloneWrap',
			Template: /*html*/`
			<section class="section">
				<div class="container">
					<div class="mb-5">
						<a href="#/Settings" class="button is-small mb-3">
							<span class="icon"><i class="fas fa-arrow-left"></i></span>
							<span>Back to Configuration</span>
						</a>
						<h1 class="title is-3">
							<span class="icon"><i class="fas fa-clone"></i></span>&nbsp;Clone Project
						</h1>
						<p class="subtitle is-5 has-text-grey">
							Copy configuration, line items, sample plans and more from one project to another
						</p>
					</div>

					<!-- Step 1: Prepare for Cloning -->
					<article class="message is-info mb-4" id="ProjectClone-Step1">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.ProjectCloneProvider.goToStep(1)">
							<p><span class="icon"><i class="fas fa-sliders"></i></span>&nbsp;Step 1: Prepare for Cloning</p>
							<span class="tag is-soft {~D:AppData.ProjectClone.Step1_StatusClass~}">{~D:AppData.ProjectClone.Step1_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.ProjectClone.Step1_BodyClass~}">
							<div class="field">
								<label class="label">Source Project</label>
								<div class="control">
									<select id="ProjectClone-SourceSelect" style="width:100%">
										<option value=""></option>
										{~TS:ProjectClone-SelectedOption:AppData.ProjectClone.SourceSelectedSlot~}
									</select>
								</div>
								<p class="help">Search and select the project to copy configuration and data from.</p>
							</div>

							<div class="field">
								<label class="label">Destination Project</label>
								<div class="control">
									<label class="radio">
										<input type="radio" name="ProjectClone-DestMode" {~D:AppData.ProjectClone.DestModeNewChecked~}
											onchange="_Pict.providers.ProjectCloneProvider.setDestMode('new')" />
										Create a new project
									</label>
									&nbsp;&nbsp;
									<label class="radio">
										<input type="radio" name="ProjectClone-DestMode" {~D:AppData.ProjectClone.DestModeExistingChecked~}
											onchange="_Pict.providers.ProjectCloneProvider.setDestMode('existing')" />
										Clone into an existing project
									</label>
								</div>
							</div>

							<div class="field {~D:AppData.ProjectClone.DestSelectorClass~}">
								<label class="label">Existing Destination Project</label>
								<div class="control">
									<select id="ProjectClone-DestSelect" style="width:100%">
										<option value=""></option>
										{~TS:ProjectClone-SelectedOption:AppData.ProjectClone.DestSelectedSlot~}
									</select>
								</div>
								<p class="help">Search and select an existing project to clone into. Must differ from the source.</p>
							</div>

							<div class="field {~D:AppData.ProjectClone.NewProjectFieldsClass~}">
								<label class="label">Destination Project Name</label>
								<div class="control">
									<input class="input" type="text"
										placeholder="{~D:AppData.ProjectClone.NamePlaceholder~}"
										value="{~D:AppData.ProjectClone.DestName~}"
										onfocus="this.select()"
										oninput="_Pict.providers.ProjectCloneProvider.setName(this.value)" />
								</div>
								<p class="help">Used when creating a new project. Click to select all and type to replace.</p>
							</div>

							<div class="field {~D:AppData.ProjectClone.NewProjectFieldsClass~}">
								<label class="label">Destination Project Description</label>
								<div class="control">
									<textarea class="textarea" rows="3"
										placeholder="Optional description for the destination project"
										oninput="_Pict.providers.ProjectCloneProvider.setDescription(this.value)">{~D:AppData.ProjectClone.DestDescription~}</textarea>
								</div>
							</div>

							{~TS:ProjectClone-GenerateError:AppData.ProjectClone.GenerateErrorSlot~}

							<div class="field is-grouped is-grouped-right mt-4">
								<div class="control">
									<button class="button is-link {~D:AppData.ProjectClone.GenerateButtonClass~}"
										{~D:AppData.ProjectClone.GenerateDisabledAttr~}
										onclick="_Pict.providers.ProjectCloneProvider.generateComprehension()">
										<span class="icon"><i class="fas fa-gears"></i></span>
										<span>Generate Clone Preview</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 2: Ready for Cloning -->
					<article class="message is-info mb-4" id="ProjectClone-Step2">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.ProjectCloneProvider.goToStep(2)">
							<p><span class="icon"><i class="fas fa-list-check"></i></span>&nbsp;Step 2: Ready for Cloning</p>
							<span class="tag is-soft {~D:AppData.ProjectClone.Step2_StatusClass~}">{~D:AppData.ProjectClone.Step2_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.ProjectClone.Step2_BodyClass~}">
							<p class="mb-3 has-text-grey">{~D:AppData.ProjectClone.SummaryLabel~}</p>
							<p class="mb-3">Choose which entities to include in the clone. Counts are the number of records that would be created.</p>

							<div class="table-container">
								<table class="table is-fullwidth is-hoverable is-striped">
									<thead>
										<tr>
											<th>Entity</th>
											<th class="has-text-right">Records</th>
										</tr>
									</thead>
									<tbody>
										{~TS:ProjectClone-EntityRow:AppData.ProjectClone.EntityRows~}
									</tbody>
								</table>
							</div>

							<!-- Refresh-preview affordance. Visible only when the user has
							     opted into a heavy entity that the last build skipped — the
							     comprehension currently has no data for it, so Proceed is
							     gated until we re-run the build. Clicking Refresh re-issues
							     buildComprehension with the current IncludeMap (and caps),
							     which fetches the newly-included entities and populates counts. -->
							<div class="notification is-warning is-soft mt-3 {~D:AppData.ProjectClone.RefreshHiddenClass~}">
								<div class="level is-mobile">
									<div class="level-left">
										<div class="level-item">
											<span class="icon"><i class="fas fa-rotate"></i></span>
											<span>&nbsp;You've opted into entities that weren't in the last preview. Refresh to fetch them before proceeding.</span>
										</div>
									</div>
									<div class="level-right">
										<div class="level-item">
											<button class="button is-warning is-small"
												{~D:AppData.ProjectClone.RefreshDisabledAttr~}
												onclick="_Pict.providers.ProjectCloneProvider.refreshPreview()">
												<span class="icon"><i class="fas fa-rotate"></i></span>
												<span>Refresh preview</span>
											</button>
										</div>
									</div>
								</div>
							</div>

							<!-- Per-entity record caps for heavy classes. Independent of the
							     Contract toggle below; these bound how many Observation / Document
							     rows the source-side preview / clone pulls. Defaults match the
							     adapter recipe defaults (5000 each); 0 lifts the cap entirely. -->
							<div class="mt-4">
								<p class="has-text-weight-semibold is-size-7 has-text-grey mb-2">Heavy entity caps</p>
								<div class="field is-horizontal">
									<div class="field-label is-normal">
										<label class="label is-size-7 has-text-grey">Max Observation rows</label>
									</div>
									<div class="field-body">
										<div class="field is-narrow">
											<div class="control">
												<input class="input is-small" type="number" min="0" step="100"
													value="{~D:AppData.ProjectClone.MaxRecordsObservation~}"
													onchange="_Pict.providers.ProjectCloneProvider.updateMaxRecords('Observation', this.value)" />
											</div>
											<p class="help">Cap on source Observation rows pulled into the clone. 0 = no cap. Uncheck the Observation row above to skip entirely.</p>
										</div>
									</div>
								</div>
								<div class="field is-horizontal">
									<div class="field-label is-normal">
										<label class="label is-size-7 has-text-grey">Max Document rows</label>
									</div>
									<div class="field-body">
										<div class="field is-narrow">
											<div class="control">
												<input class="input is-small" type="number" min="0" step="100"
													value="{~D:AppData.ProjectClone.MaxRecordsDocument~}"
													onchange="_Pict.providers.ProjectCloneProvider.updateMaxRecords('Document', this.value)" />
											</div>
											<p class="help">Cap on source Document rows pulled into the clone. 0 = no cap. Uncheck the Document row above to skip entirely.</p>
										</div>
									</div>
								</div>
							</div>

							<hr class="my-3" />

							<div class="field">
								<label class="checkbox">
									<input type="checkbox"
										{~D:AppData.ProjectClone.ContractCheckedAttr~}
										{~D:AppData.ProjectClone.ContractDisabledAttr~}
										onchange="_Pict.providers.ProjectCloneProvider.toggleContract()" />
									&nbsp;Also clone the source project's Contract
								</label>
								<p class="help">
									Creates a new linked contract for a new (or contract-less) destination, or merges the
									source contract into the destination's existing one. Available when the source project has a contract.
									<span class="{~D:AppData.ProjectClone.RebuildingClass~}"><em>&nbsp;Updating preview…</em></span>
								</p>
							</div>

							<div class="content mt-3">
								<p class="has-text-grey-light is-size-7" id="ProjectClone-WarningsHeader">Notes from the preview:</p>
								<ul class="is-size-7 has-text-grey">
									{~TS:ProjectClone-WarningRow:AppData.ProjectClone.WarningRows~}
								</ul>
							</div>

							<hr />
							<div class="field is-grouped is-grouped-right">
								<div class="control">
									<button class="button" onclick="_Pict.providers.ProjectCloneProvider.backToPrepare()">
										<span class="icon"><i class="fas fa-arrow-left"></i></span>
										<span>Back</span>
									</button>
								</div>
								<div class="control">
									<button class="button is-link" {~D:AppData.ProjectClone.ProceedDisabledAttr~}
										onclick="_Pict.providers.ProjectCloneProvider.proceedWithClone()">
										<span class="icon"><i class="fas fa-cloud-arrow-up"></i></span>
										<span>Proceed with Project Clone</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 3: Cloning Results -->
					<article class="message is-info mb-4" id="ProjectClone-Step3">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.ProjectCloneProvider.goToStep(3)">
							<p><span class="icon"><i class="fas fa-flag-checkered"></i></span>&nbsp;Step 3: Cloning Results</p>
							<span class="tag is-soft {~D:AppData.ProjectClone.Step3_StatusClass~}">{~D:AppData.ProjectClone.Step3_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.ProjectClone.Step3_BodyClass~}">
							<!-- In-progress experience -->
							<div class="has-text-centered py-5 {~D:AppData.ProjectClone.CloneState.PanelClass~}" id="ProjectClone-Progress">
								<span class="project-clone-spinner"></span>
								<p class="mt-3 has-text-weight-semibold">Cloning in progress…</p>
								<p class="has-text-grey">{~D:AppData.ProjectClone.CloneState.StatusText~}</p>
								<progress class="progress is-info mt-3" max="100">working…</progress>
								<p class="has-text-grey-light is-size-7">Please do not navigate away or close this tab until the clone finishes — it can take more than 30 seconds.</p>
							</div>

							<!-- Result banner (success or failure) -->
							{~TS:ProjectClone-ResultBanner:AppData.ProjectClone.ResultSlot~}

							<ul class="is-size-7 has-text-grey">
								{~TS:ProjectClone-WarningRow:AppData.ProjectClone.ResultWarningRows~}
							</ul>

							<hr />
							<div class="field is-grouped is-grouped-right">
								<div class="control">
									<button class="button is-link" {~D:AppData.ProjectClone.DoneDisabledAttr~}
										onclick="_Pict.providers.ProjectCloneProvider.finishAndLeave()">
										<span class="icon"><i class="fas fa-check"></i></span>
										<span>Done</span>
									</button>
								</div>
							</div>
						</div>
					</article>
				</div>
			</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ProjectCloneWrap',
			TemplateHash: 'ProjectCloneWrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1461:[function(require,module,exports){
'use strict';

/**
 * Shared CSS + wrap-template for the ProjectTypes / ContractTypes views — one copy of the `pct-` styling and the
 * two-column rail/detail shell. Both views back the same ProjectContractTypes provider (kind-sliced state).
 */

const CSS = /*css*/`
	.pct-wrap { padding: 1.25rem 1.5rem 2rem; }
	.pct-head { margin: 0 0 1rem; }
	.pct-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
	.pct-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
	.pct-cols { display:grid; grid-template-columns: 18rem 1fr; gap:1.1rem; align-items:start; }
	@media (max-width: 860px) { .pct-cols { grid-template-columns: 1fr; } }
	.pct-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; max-height:46rem; display:flex; flex-direction:column; }
	.pct-rail-search { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; margin:0 0 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
	.pct-newtype-btn { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.82rem; font-weight:600; padding:0.4rem 0.6rem; margin:0 0 0.55rem; border:1px dashed var(--theme-color-border-medium,#c7cfda); border-radius:7px; background:transparent; color:var(--theme-color-brand-primary,#2e7d74); cursor:pointer; }
	.pct-newtype-btn:hover { background:var(--theme-color-background-secondary,#eef1f6); }
	.pct-rail-list { flex:1 1 auto; min-height:0; overflow:auto; }
	.pct-rail-item { padding:0.45rem 0.55rem; border-radius:6px; cursor:pointer; }
	.pct-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); }
	.pct-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); }
	.pct-rail-item.is-active .pct-rail-name, .pct-rail-item.is-active .pct-rail-sub { color:#fff; }
	.pct-rail-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
	.pct-rail-sub { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); margin-top:0.1rem; }
	.pct-empty, .pct-detail-empty { font-size:0.85rem; color:var(--theme-color-text-muted,#8894a4); padding:0.5rem 0.55rem; }
	.pct-main, .pct-detail-empty { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
	.pct-detail-empty { display:flex; align-items:center; justify-content:center; text-align:center; }
	.pct-detail-head { margin:0 0 1rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding-bottom:0.7rem; }
	.pct-detail-title { font-size:1.2rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
	.pct-detail-sub { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
	.pct-section { margin:0 0 1.3rem; }
	.pct-section-head { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.5rem; }
	.pct-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.7rem; }
	.pct-hint { font-size:0.8rem; color:var(--theme-color-status-warning,#8a6d1b); background:var(--theme-color-status-warning-bg,#fbf3d9); border-radius:6px; padding:0.4rem 0.6rem; margin:0.4rem 0 0; display:flex; flex-wrap:wrap; align-items:center; gap:0.5rem; }
	.pct-hint label { display:inline-flex; align-items:center; gap:0.3rem; font-weight:600; }
	.pct-field { display:flex; flex-direction:column; gap:0.2rem; font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.6rem; }
	.pct-field input, .pct-field textarea { font-size:0.9rem; font-weight:400; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); max-width:34rem; }
	.pct-field-inline { flex-direction:row; align-items:center; gap:0.6rem; }
	.pct-field-inline input { max-width:6rem; }
	.pct-advanced { margin:0.2rem 0 0; }
	.pct-advanced > summary { font-size:0.78rem; font-weight:600; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; }
	.pct-advanced[open] > summary { margin-bottom:0.4rem; }
	.pct-add-row { display:flex; align-items:center; flex-wrap:wrap; gap:0.5rem; margin:0.5rem 0 0; }
	.pct-btn { font-size:0.82rem; font-weight:600; padding:0.4rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
	.pct-btn-sm { padding:0.28rem 0.6rem; font-size:0.78rem; }
	.pct-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
	.pct-btn-ghost { background:transparent; }
	.pct-btn-danger { color:#fff; background:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
	.pct-btn-danger-link { color:var(--theme-color-status-danger,#c0392b); border:none; background:transparent; padding:0.3rem 0; }
	.pct-danger { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:0.8rem; }
	.pct-busy { font-size:0.8rem; color:var(--theme-color-primary,#2f6fed); font-weight:600; }
	.pct-notice { font-size:0.85rem; color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); border-radius:6px; padding:0.45rem 0.6rem; margin:0.6rem 0 0; }
	.pct-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0.5rem 0 0; }
	.pct-status-row, .pct-date-row, .pct-fund-row { display:flex; align-items:center; flex-wrap:wrap; gap:0.5rem; padding:0.28rem 0; }
	.pct-status-name { flex:1 1 14rem; min-width:0; font-size:0.88rem; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
	.pct-status-co { font-size:0.8rem; color:var(--theme-color-text-secondary,#45505f); display:inline-flex; align-items:center; gap:0.35rem; }
	.pct-date-name { flex:1 1 16rem; min-width:0; font-size:0.88rem; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
	.pct-date-code { flex:0 0 8rem; font-size:0.85rem; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
	.pct-fund-pick { flex:1 1 14rem; min-width:0; }
	.pct-row-tools { display:inline-flex; gap:0.2rem; }
	.pct-icon { border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); border-radius:5px; cursor:pointer; font-size:0.8rem; line-height:1; padding:0.25rem 0.45rem; color:var(--theme-color-text-secondary,#45505f); }
	.pct-icon:hover { background:var(--theme-color-background-secondary,#eef1f6); }
	.pct-icon-x:hover { color:var(--theme-color-status-danger,#c0392b); }
	.pct-picker { max-width:34rem; }
	.pct-steps { display:flex; flex-wrap:wrap; gap:0.5rem; margin:0.2rem 0 0; }
	.pct-step { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.85rem; font-weight:600; padding:0.4rem 0.7rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; background:var(--theme-color-background-secondary,#f7f9fc); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
	.pct-step:hover { background:var(--theme-color-background-tertiary,#e2e7ef); }
	.pct-step.is-disabled { opacity:0.5; cursor:default; }
	.pct-org { font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.06rem 0.35rem; border-radius:9px; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#e2e7ef); }
`;

/**
 * Build a view wrap template (title/subtitle + the shared rail/detail mounts).
 * @param {string} pTitle
 * @param {string} pSubtitle
 * @returns {string}
 */
function wrapTemplate(pTitle, pSubtitle)
{
	return /*html*/`
		<div class="pct-wrap">
			<div class="pct-head">
				<h1 class="pct-title">${pTitle}</h1>
				<p class="pct-subtitle">${pSubtitle}</p>
			</div>
			<div class="pct-cols">
				<div id="PCT-Rail" class="pct-rail"></div>
				<div id="PCT-Detail" class="pct-main"></div>
			</div>
		</div>`;
}

module.exports = { CSS, wrapTemplate };

},{}],1462:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// The Location section's map + address-search styles (mirrors the read workspace's pw-loc-* / pw-map-host).
const PCW_LOC_CSS = /*css*/`
	.pcw-loc-panel { margin-top: 1.1rem; }
	.pcw-loc-search { margin: 0 0 0.8rem; }
	.pcw-loc-search-row { display: flex; gap: 0.5rem; align-items: stretch; }
	.pcw-addr-input { flex: 1 1 auto; }
	.pcw-addr-status { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.4rem 0.2rem 0.1rem; }
	.pcw-addr-status-error { color: var(--theme-color-status-error, #cf5b5b); }
	.pcw-addr-result { padding: 0.5rem 0.7rem; margin-top: 0.3rem; cursor: pointer; font-size: 0.86rem; color: var(--theme-color-text-secondary, #45505f);
		border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; background: var(--theme-color-background-primary, #fff); }
	.pcw-addr-result:hover { background: var(--theme-color-background-tertiary, #f4f6f9); border-color: var(--theme-color-border-default, #d7dce3); }
	.pcw-loc-coords { display: flex; gap: 1rem; margin: 0 0 0.6rem; flex-wrap: wrap; }
	.pcw-loc-coord { display: flex; flex-direction: column; gap: 0.2rem; }
	.pcw-loc-coord > span { font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
	.pcw-loc-coord .input { max-width: 12rem; }
	.pcw-loc-readout { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); margin: 0 0 0.6rem; }
	.pcw-loc-readout code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.1rem 0.4rem; border-radius: 5px; }
	.pcw-map-host { height: 22rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3); overflow: hidden; }
`;

/**
 * ProjectCreateWorkspace — the bespoke Project CREATE screen (reached by the app-router Create bridge on
 * #/PSRS/Project/Create, which shadows the generic recordset create form so "+ New" opens the curated
 * experience). A thin shell: all data, behavior, and hand-built form HTML live in the ProjectCreateWorkspace
 * provider, which assigns into the #PCW-Body mount. Reuses the Edit workspace's .pew-* CSS verbatim.
 */
class ProjectCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ProjectCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			tmpProvider.renderCustomProps();
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Lazily register an EDITABLE pict-section-objecteditor over the new project's CustomProperties, bound to
	 * AppData.ProjectCreateWorkspace.CustomPropsData (mutated in place as the user edits), into this screen's
	 * own mount so a body repaint never destroys it.
	 */
	_ensureCustomPropsView()
	{
		const tmpHash = 'PCW-CustomPropsEditor';
		if (this.pict.views[tmpHash]) { return this.pict.views[tmpHash]; }
		const libObjectEditor = require('pict-section-objecteditor');
		this.pict.addView(tmpHash, Object.assign({}, libObjectEditor.default_configuration,
			{
				ViewIdentifier: tmpHash,
				AutoRender: false,
				Editable: true,
				InitialExpandDepth: 2,
				ObjectDataAddress: 'AppData.ProjectCreateWorkspace.CustomPropsData',
				Renderables:
				[
					{
						RenderableHash: 'ObjectEditor-Container',
						TemplateHash: 'ObjectEditor-Container-Template',
						DestinationAddress: '#PCW-CustomPropsHost',
						RenderMethod: 'replace',
					}
				],
			}), libObjectEditor);
		const tmpView = this.pict.views[tmpHash];
		if (tmpView && (typeof tmpView.initialize === 'function')) { tmpView.initialize(); }
		return tmpView;
	}

	/** Render the editable CustomProperties tree into #PCW-CustomPropsHost (called by the provider). */
	mountCustomProps()
	{
		const tmpView = this._ensureCustomPropsView();
		if (!tmpView) { return; }
		tmpView.options.DefaultDestinationAddress = '#PCW-CustomPropsHost';
		tmpView.render();
	}
}

module.exports = ProjectCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectCreateWorkspace',
	DefaultRenderable: 'ProjectCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reuse the Edit workspace's .pew-* styles verbatim (injection is idempotent by class), plus the Location
	// section's map + address-search styles (the create screen's own; the read workspace's pw-* CSS isn't
	// guaranteed to be injected here).
	CSS: libProjectEditWorkspace.default_configuration.CSS + PCW_LOC_CSS,
	Templates:
	[
		{
			Hash: 'ProjectCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="PCW-Body"></div><div id="PCW-CustomProps"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ProjectCreateWorkspaceWrap',
			TemplateHash: 'ProjectCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./ProjectEditWorkspace.js":1463,"pict-section-objecteditor":957,"pict-view":1053}],1463:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * ProjectEditWorkspace — the bespoke Project EDIT screen (reached by the app-router Edit bridge on
 * #/PSRS/Project/Edit/<GUID>, which shadows the generic recordset edit form). A thin shell: all data,
 * behavior, and hand-built form HTML live in the ProjectEditWorkspace provider, which assigns into the
 * #PEW-Body mount (Entitlements pattern). It exists so the Financial & Schedule fields can be locked once
 * a project is Active — something the manifest-driven recordset form can't express per-record.
 */
class ProjectEditWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ProjectEditWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			// Repaint the CustomProperties mount too (it's a sibling of #PEW-Body); no-op until loaded.
			tmpProvider.renderCustomProps();
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Lazily register an EDITABLE pict-section-objecteditor over the project's CustomProperties, bound to
	 * AppData.ProjectEditWorkspace.CustomPropsData (mutated in place as the user edits). Mirrors ProjectWorkspace's
	 * read-only tree, but Editable + into this screen's own mount so a body repaint never destroys it.
	 */
	_ensureCustomPropsView()
	{
		const tmpHash = 'PEW-CustomPropsEditor';
		if (this.pict.views[tmpHash]) { return this.pict.views[tmpHash]; }
		const libObjectEditor = require('pict-section-objecteditor');
		this.pict.addView(tmpHash, Object.assign({}, libObjectEditor.default_configuration,
			{
				ViewIdentifier: tmpHash,
				AutoRender: false,
				Editable: true,
				InitialExpandDepth: 2,
				ObjectDataAddress: 'AppData.ProjectEditWorkspace.CustomPropsData',
				Renderables:
				[
					{
						RenderableHash: 'ObjectEditor-Container',
						TemplateHash: 'ObjectEditor-Container-Template',
						DestinationAddress: '#PEW-CustomPropsHost',
						RenderMethod: 'replace',
					}
				],
			}), libObjectEditor);
		const tmpView = this.pict.views[tmpHash];
		// The object editor builds its per-type node renderers in onBeforeInitialize; a view added after the
		// boot cycle isn't initialized automatically, so initialize it before the first render.
		if (tmpView && (typeof tmpView.initialize === 'function')) { tmpView.initialize(); }
		return tmpView;
	}

	/** Render the editable CustomProperties tree into #PEW-CustomPropsHost (called by the provider). */
	mountCustomProps()
	{
		const tmpView = this._ensureCustomPropsView();
		if (!tmpView) { return; }
		tmpView.options.DefaultDestinationAddress = '#PEW-CustomPropsHost';
		tmpView.render();
	}
}

module.exports = ProjectEditWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectEditWorkspace',
	DefaultRenderable: 'ProjectEditWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.pew-wrap { padding: 1.25rem 1.5rem 2rem; }
		.pew-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; margin: 0 0 1rem; }
		.pew-head-actions { display: flex; gap: 0.5rem; flex: 0 0 auto; }
		.pew-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); }
		.pew-title { font-size: 1.5rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); }
		.pew-lock-banner { display: flex; align-items: center; gap: 0.55rem; font-size: 0.9rem; line-height: 1.4; color: var(--theme-color-text-secondary, #45505f);
			background: var(--theme-color-status-warning-bg, #fdf6e3); border: 1px solid var(--theme-color-status-warning, #d9a441); border-radius: 8px; padding: 0.6rem 0.85rem; margin: 0 0 1rem; }
		.pew-lock-icon { flex: 0 0 auto; font-size: 1rem; }
		.pew-form { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; background: var(--theme-color-background-panel, #fff); padding: 1.4rem 1.5rem; }
		.pew-group { margin: 0 0 1.4rem; }
		.pew-group:last-child { margin-bottom: 0; }
		.pew-group-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6);
			background: var(--theme-color-background-selected, #eef1f8); padding: 0.35rem 0.7rem; border-radius: 6px; margin: 0 0 0.9rem; display: flex; align-items: center; }
		.pew-group-hint { margin-left: 0.6rem; font-size: 0.66rem; font-weight: 700; letter-spacing: 0.03em; color: var(--theme-color-status-warning, #b8860b); text-transform: none; }
		.pew-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr)); gap: 0.9rem 1.4rem; }
		.pew-field.pew-field-wide { grid-column: 1 / -1; }
		.pew-field-label { display: block; font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin-bottom: 0.25rem; }
		.pew-input { width: 100%; }
		.pew-input-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; }
		.pew-field-error { color: var(--theme-color-status-danger, #c0392b); font-size: 0.78rem; margin-top: 0.22rem; }
		.pew-input[disabled], .pew-input select[disabled] { background: var(--theme-color-background-tertiary, #f4f6f9); color: var(--theme-color-text-muted, #8894a4); cursor: not-allowed; }
		.pew-picker-host { width: 100%; }
		.pew-customprops-panel { margin-top: 1.1rem; }
		.pew-customprops-help { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.6rem; }
		.pew-objecteditor-host { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.6rem 0.8rem; background: var(--theme-color-background-tertiary, #f9fafb); min-height: 3rem; overflow: auto; }
		.pew-empty { padding: 2.5rem 1rem; }
		.pew-spinner { display: inline-block; width: 1.6rem; height: 1.6rem; border: 3px solid var(--theme-color-border-default, #dbdbdb); border-top-color: var(--theme-color-brand-primary, #5650e6); border-radius: 50%; animation: pew-spin 0.8s linear infinite; }
		@keyframes pew-spin { to { transform: rotate(360deg); } }
	`,
	Templates:
	[
		{
			Hash: 'ProjectEditWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="PEW-Body"></div><div id="PEW-CustomProps"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ProjectEditWorkspaceWrap',
			TemplateHash: 'ProjectEditWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-section-objecteditor":957,"pict-view":1053}],1464:[function(require,module,exports){
'use strict';

/**
 * Project Funding — host view (funding-config setup grid + accounting overview + line-item funding).
 *
 * Standalone project-scoped screen (front-door picker + deep link #/Project/Funding/:ID), mirroring the
 * ImportantFiles / Sample Plan shell. The funding-config setup grid is a nested table (Category → Source → Fund
 * buckets) with inline-editable bucket fields (saved via the provider's Finance …/Buckets call), searchable
 * add-pickers off the lazily-loaded finance profile, and per-bucket remove. The accounting overview renders the
 * digest totals + the funding-solution outcomes and violations. A full-width line-item funding panel assigns
 * each line item to one of the project's funding categories (uncategorized flagged). Simulation and the
 * purchase-order export arrive in later slices.
 */

const libPictView = require('pict-view');

const html = String.raw;
const fEsc = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[pChar]));
const fAttr = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));

const CURRENCY = (typeof Intl !== 'undefined') ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }) : null;
const fMoney = (pValue) => { const tmpN = Number(pValue); if (!Number.isFinite(tmpN)) { return '—'; } return CURRENCY ? CURRENCY.format(tmpN) : ('$' + tmpN.toFixed(2)); };
const fPct = (pValue) => { const tmpN = Number(pValue); if (!Number.isFinite(tmpN)) { return '0%'; } return (tmpN * 100).toFixed(1) + '%'; };   // API sends fractions (0.3333)

const GRID_MOUNT = '#ProjectFunding-Grid';
const ACCT_MOUNT = '#ProjectFunding-Accounting';

// Above this many line items we fall back from per-row Pict-Section-Pickers to native <select>s — mounting several
// hundred picker views at once is heavy; native dropdowns keep a very large project's funding panel responsive.
const LI_PICKER_CAP = 400;

// Source-bucket editable fields (label + numeric hint). EffectiveWeight is computed → read-only, shown separately.
const SOURCE_FIELDS =
[
	{ Key: 'Priority', Label: 'Priority', Kind: 'int' },
	{ Key: 'PriorityWeight', Label: 'Weight', Kind: 'num' },
	{ Key: 'ProjectFundCap', Label: 'Project Cap', Kind: 'money' },
	{ Key: 'FundCap', Label: 'Fund Cap', Kind: 'money' },
	{ Key: 'PurchaseOrderItem', Label: 'PO Item', Kind: 'text' },
];
const FUND_FIELDS =
[
	{ Key: 'Sequence', Label: 'Sequence', Kind: 'int' },
	{ Key: 'Weight', Label: 'Weight', Kind: 'num' },
	{ Key: 'PurchaseOrderItem', Label: 'PO Item', Kind: 'text' },
];

class ProjectFunding extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		this._projectFilterTimer = null;
		this._projectLoadToken = 0;
		this._pickTimer = null;
		this._pickToken = 0;
		// When embedded in a host (the ProjectWorkspace Contract ▸ Funding tab) this holds that host selector, and
		// every render — including provider-triggered repaints — targets it instead of the app container.
		this._embedDestination = null;
		// Accounting-overview panel collapse state (it sits full-width above the setup grid).
		this._acctCollapsed = false;
	}

	get provider() { return this.pict.providers['ProjectFunding']; }
	get modal() { return this.pict.views['Pict-Section-Modal']; }

	/** Render into the embed host when embedded (so provider `_render()` repaints land in the Contract ▸ Funding
	 *  tab, not the app container). An explicit destination argument always wins. */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed the funding dashboard into a host element for a fixed project (skips the front-door picker). The
	 *  ProjectWorkspace Contract ▸ Funding tab calls this after each paint; it reloads only when the project differs. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		const tmpState = (this.pict.AppData && this.pict.AppData.ProjectFunding) || {};
		if (this.provider && (!tmpState.HasModel || (Number(this.provider.idProject) !== Number(pIDProject))))
		{
			this.provider.loadAsync(pIDProject);   // provider._render → this.render → the host
		}
		else { this.render(); }   // already loaded for this project — just (re)paint into the host
	}

	/** Leave embedded mode — the standalone #/Project/Funding screen renders to the app container again. */
	exitEmbed() { this._embedDestination = null; }

	/** Collapse / expand the (full-width, top) Accounting overview panel. Toggles the DOM in place (no full
	 *  re-render needed — the content is already painted, just hidden) and keeps the persisted flag in sync. */
	toggleAccounting()
	{
		this._acctCollapsed = !this._acctCollapsed;
		const tmpState = (this.pict.AppData && this.pict.AppData.ProjectFunding) || {};
		tmpState.AcctClass = this._acctCollapsed ? 'is-collapsed' : '';
		tmpState.AcctChevron = this._acctCollapsed ? 'fa-chevron-down' : 'fa-chevron-up';
		const tmpPanel = document.querySelector('.pf-acct-panel');
		if (tmpPanel) { tmpPanel.classList.toggle('is-collapsed', this._acctCollapsed); }
		const tmpCaret = document.querySelector('.pf-acct-caret i');
		if (tmpCaret) { tmpCaret.className = 'fas ' + (this._acctCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'); }
	}
	get pickerProvider() { return this.pict.providers && this.pict.providers['Pict-Section-Picker']; }
	_toast(pMessage, pType, pDuration) { if (this.modal && (typeof this.modal.toast === 'function')) { const tmpOptions = { type: pType || 'info' }; if (pDuration !== undefined) { tmpOptions.duration = pDuration; } this.modal.toast(pMessage, tmpOptions); } }

	onBeforeRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.ProjectFunding) || {};
		tmpState.LoadingSlot = tmpState.Loading ? [ tmpState ] : [];
		tmpState.ErrorSlot = (!tmpState.Loading && tmpState.Message) ? [ tmpState ] : [];
		tmpState.PickerSlot = (!tmpState.Loading && !tmpState.Message && !tmpState.HasModel) ? [ tmpState ] : [];
		tmpState.BodySlot = (!tmpState.Loading && tmpState.HasModel) ? [ tmpState ] : [];
		tmpState.ManageSlot = (tmpState.HasModel && !tmpState.Loading && tmpState.CanManage) ? [ tmpState ] : [];
		tmpState.ReadOnlySlot = (tmpState.HasModel && !tmpState.Loading && !tmpState.CanManage) ? [ tmpState ] : [];
		tmpState.TitleText = (tmpState.HasModel && tmpState.ProjectName) ? `Funding — ${tmpState.ProjectName}` : 'Project Funding';
		tmpState.EmbedClass = this._embedDestination ? 'pf-embedded' : '';
		// "Choose another project" only makes sense on the standalone screen — embedded in a project's Contract tab
		// the project is already fixed, so suppress it.
		tmpState.ChangeProjectSlot = (!this._embedDestination && tmpState.HasModel && !tmpState.Loading) ? [ tmpState ] : [];
		// Accounting overview collapse state (persisted across full re-renders).
		tmpState.AcctClass = this._acctCollapsed ? 'is-collapsed' : '';
		tmpState.AcctChevron = this._acctCollapsed ? 'fa-chevron-down' : 'fa-chevron-up';
		this.pict.AppData.ProjectFunding = tmpState;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.ProjectFunding) || {};
		if (tmpState.HasModel && !tmpState.Loading) { this.renderHeaderTools(); this.renderGrid(); this.renderAccounting(); this.renderLineItems(); }
		else if (tmpState.PickerSlot && tmpState.PickerSlot.length) { this._initProjectPicker(); }
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	// --- Front door -------------------------------------------------------------------------------

	_initProjectPicker()
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#ProjectFunding-ProjectList');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpInput = document.getElementById('ProjectFunding-ProjectFilter');
		this._loadProjects(tmpInput ? tmpInput.value : '');
	}

	onProjectFilter(pValue)
	{
		if (this._projectFilterTimer) { clearTimeout(this._projectFilterTimer); }
		this._projectFilterTimer = setTimeout(() => { this._loadProjects(pValue); }, 200);
	}

	_loadProjects(pTerm)
	{
		if (!this.provider) { return; }
		const tmpToken = (this._projectLoadToken = (this._projectLoadToken || 0) + 1);
		this.provider.searchProjectsAsync(pTerm).then((pProjects) =>
		{
			if (tmpToken !== this._projectLoadToken) { return; }
			const tmpList = Array.isArray(pProjects) ? pProjects : [];
			if (!tmpList.length) { this.pict.ContentAssignment.assignContent('#ProjectFunding-ProjectList', '<div class="pf-note">No projects match.</div>'); return; }
			const tmpRows = tmpList.map((pProject) =>
				`<button type="button" class="pf-proj-row" onclick="_Pict.views.ProjectFunding.openProject(${Number(pProject.IDProject)})"><span>${fEsc(pProject.Name)}</span><i class="fas fa-chevron-right"></i></button>`).join('');
			this.pict.ContentAssignment.assignContent('#ProjectFunding-ProjectList', tmpRows + (tmpList.length >= 100 ? '<div class="pf-note">Showing the first 100 — type to narrow.</div>' : ''));
		}).catch(() => { if (tmpToken === this._projectLoadToken) { this.pict.ContentAssignment.assignContent('#ProjectFunding-ProjectList', '<div class="pf-note pf-err">Could not load projects.</div>'); } });
	}

	openProject(pIDProject) { const tmpID = Number(pIDProject); if (Number.isFinite(tmpID) && (tmpID > 0)) { window.location.hash = `#/Project/Funding/${tmpID}`; } }
	chooseAnotherProject() { window.location.hash = '#/Project/Funding'; }

	// --- Setup grid -------------------------------------------------------------------------------

	renderGrid()
	{
		const tmpMount = this.pict.ContentAssignment.getElement(GRID_MOUNT);
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpConfig = this.provider.config;
		const tmpManage = !!(this.pict.AppData.ProjectFunding && this.pict.AppData.ProjectFunding.CanManage);
		if (!tmpConfig.length)
		{
			this.pict.ContentAssignment.assignContent(GRID_MOUNT, `<div class="pf-empty"><i class="fas fa-sitemap"></i><p>No funding is configured for this project yet.</p>${tmpManage ? '<button class="button is-link is-small" onclick="_Pict.views.ProjectFunding.addCategory()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add a funding category</span></button>' : ''}</div>`);
			return;
		}
		this.pict.ContentAssignment.assignContent(GRID_MOUNT, tmpConfig.map((pCat) => this._categoryHTML(pCat, tmpManage)).join(''));
	}

	_categoryHTML(pCat, pManage)
	{
		const tmpKey = fAttr(pCat.Key);
		const tmpSources = pCat.FundingSourceBuckets || [];
		const tmpActions = pManage
			? `<span class="pf-cat-actions"><button class="pf-btn" title="Add funding source" onclick="_Pict.views.ProjectFunding.addSource('${tmpKey}')"><i class="fas fa-plus"></i> Source</button>`
				+ `<button class="pf-btn pf-btn-danger" title="Remove this category and everything under it" onclick="_Pict.views.ProjectFunding.removeBucket('${tmpKey}','category')"><i class="fas fa-trash"></i></button></span>`
			: '';
		const tmpBody = tmpSources.length
			? `<div class="pf-src-tablewrap"><table class="pf-src-table"><thead><tr><th>Funding Source</th>${SOURCE_FIELDS.map((f) => `<th>${fEsc(f.Label)}</th>`).join('')}<th title="Computed">Eff. Wt.</th>${pManage ? '<th></th>' : ''}</tr></thead><tbody>${tmpSources.map((pSrc) => this._sourceRowsHTML(pSrc, pManage)).join('')}</tbody></table></div>`
			: '<div class="pf-cat-empty">No funding sources yet.</div>';
		return `<div class="pf-cat"><div class="pf-cat-head"><i class="fas fa-folder-tree"></i><span class="pf-cat-name">${fEsc(pCat.Name)}</span>${pCat.Code ? `<span class="pf-tag">${fEsc(pCat.Code)}</span>` : ''}${pCat.Type ? `<span class="pf-tag pf-tag-type">${fEsc(pCat.Type)}</span>` : ''}${tmpActions}</div>${tmpBody}</div>`;
	}

	_sourceRowsHTML(pSrc, pManage)
	{
		const tmpKey = fAttr(pSrc.Key);
		const tmpFunds = pSrc.FundBuckets || [];
		const tmpCells = SOURCE_FIELDS.map((f) => `<td>${this._editCell(tmpKey, f, pSrc[f.Key], pManage)}</td>`).join('');
		const tmpAct = pManage
			? `<td class="pf-row-act"><button class="pf-btn" title="Add fund" onclick="_Pict.views.ProjectFunding.addFund('${tmpKey}')"><i class="fas fa-plus"></i> Fund</button><button class="pf-btn pf-btn-danger" title="Remove source" onclick="_Pict.views.ProjectFunding.removeBucket('${tmpKey}','source')"><i class="fas fa-xmark"></i></button></td>`
			: '';
		let tmpHTML = `<tr class="pf-src-row"><td class="pf-src-name">${fEsc(pSrc.Name)}</td>${tmpCells}<td class="pf-eff" data-eff="${tmpKey}">${fPct(pSrc.EffectiveWeight)}</td>${tmpAct}</tr>`;
		// Funds nested under the source
		tmpFunds.forEach((pFund) =>
		{
			const tmpFKey = fAttr(pFund.Key);
			const tmpFCells = FUND_FIELDS.map((f) => `<td>${this._editCell(tmpFKey, f, pFund[f.Key], pManage)}</td>`).join('');
			const tmpFAct = pManage ? `<td class="pf-row-act"><button class="pf-btn pf-btn-danger" title="Remove fund" onclick="_Pict.views.ProjectFunding.removeBucket('${tmpFKey}','fund')"><i class="fas fa-xmark"></i></button></td>` : '';
			// pad the fund row to align under the source columns (fund has fewer editable fields)
			const tmpPad = SOURCE_FIELDS.length - FUND_FIELDS.length;
			tmpHTML += `<tr class="pf-fund-row"><td class="pf-fund-name"><i class="fas fa-turn-up fa-rotate-90"></i> ${fEsc(pFund.Name)}${(pFund.Balance != null) ? ` <span class="pf-fund-bal">${fMoney(pFund.Balance)}</span>` : ''}</td>${tmpFCells}${'<td></td>'.repeat(Math.max(0, tmpPad))}<td></td>${tmpFAct}</tr>`;
		});
		return tmpHTML;
	}

	_editCell(pBucketKey, pField, pValue, pManage)
	{
		const tmpVal = (pValue == null) ? '' : String(pValue);
		if (!pManage) { return `<span class="pf-ro">${fEsc(pField.Kind === 'money' ? fMoney(tmpVal) : tmpVal)}</span>`; }
		const tmpType = (pField.Kind === 'text') ? 'text' : 'number';
		const tmpStep = (pField.Kind === 'int') ? '1' : (pField.Kind === 'money' || pField.Kind === 'num') ? 'any' : '';
		const tmpMin = (pField.Kind === 'text') ? '' : ' min="0"';
		return `<input class="pf-inp pf-inp-${pField.Kind}" type="${tmpType}"${tmpStep ? ` step="${tmpStep}"` : ''}${tmpMin} value="${fAttr(tmpVal)}" data-bucket="${fAttr(pBucketKey)}" data-field="${fAttr(pField.Key)}" data-kind="${fAttr(pField.Kind)}" onchange="_Pict.views.ProjectFunding.onFieldEdit(this)" />`;
	}

	async onFieldEdit(pEl)
	{
		if (!pEl) { return; }
		const tmpKey = pEl.getAttribute('data-bucket');
		const tmpField = pEl.getAttribute('data-field');
		const tmpKind = pEl.getAttribute('data-kind');
		const tmpValue = pEl.value;
		// Never persist an empty/invalid number — the funding engine does Big() math on these fields. Revert instead.
		if ((tmpKind !== 'text') && ((tmpValue === '') || !Number.isFinite(Number(tmpValue))))
		{
			const tmpBucket = this.provider.findBucket(tmpKey);
			pEl.value = (tmpBucket && tmpBucket.node && (tmpBucket.node[tmpField] != null)) ? String(tmpBucket.node[tmpField]) : '';
			return;
		}
		pEl.disabled = true;
		try { await this.provider.saveBucketAsync(tmpKey, { [tmpField]: tmpValue }); }
		catch (pError) { this._toast((pError && pError.message) ? pError.message : 'Could not save that change.', 'error', 6000); }
		finally { pEl.disabled = false; }
	}

	/** After a single bucket-field save (the provider's "quiet" path): refresh the accounting panel and patch the
	 *  computed Effective-Weight cells in place — WITHOUT rebuilding the grid, so the user's focus + any in-progress
	 *  edit in another cell survive (the grid inputs are keyed by data-bucket, not array position). */
	afterFieldSave()
	{
		this.renderAccounting();
		const tmpConfig = this.provider.config;
		const fEscKey = (pK) => ((window.CSS && CSS.escape) ? CSS.escape(pK) : pK);
		tmpConfig.forEach((pCat) => (pCat.FundingSourceBuckets || []).forEach((pSrc) =>
		{
			const tmpCell = document.querySelector(`.pf-eff[data-eff="${fEscKey(pSrc.Key)}"]`);
			if (tmpCell) { tmpCell.textContent = fPct(pSrc.EffectiveWeight); }
		}));
	}

	// --- Add flows (searchable pickers off the lazy finance profile) --------------------------------

	addCategory() { this._pickFromProfile('Add a funding category', 'FundingCategories', 'category', (pItem) => this.provider.addCategoryAsync(pItem), this.provider.config.map((pCat) => String(pCat.IDFundingCategory))); }

	addSource(pCategoryBucketKey)
	{
		this._pickFromProfile('Add a funding source', 'FundingSources', 'source', (pItem) => this.provider.addSourceAsync(pItem, pCategoryBucketKey));
	}

	addFund(pSourceBucketKey)
	{
		this._pickFromProfile('Add a fund', 'Funds', 'fund', (pItem) => this.provider.addFundsAsync([ pItem ], pSourceBucketKey));
	}

	/** Open a searchable modal over a (large) profile list; on pick, run pOnPick then refresh + toast. */
	async _pickFromProfile(pTitle, pListName, pNoun, pOnPick, pExcludeKeys)
	{
		this._pickList = pListName;
		this._pickExclude = new Set((pExcludeKeys || []).map(String));
		this._pickOnPick = pOnPick;
		this._pickNoun = pNoun;
		this.modal.show(
			{
				title: pTitle,
				content: `<p class="pf-modal-help">Search the customer’s ${fEsc(pNoun)} list and pick one to add.</p>`
					+ `<input id="PF-PickSearch" class="input" type="text" autocomplete="off" placeholder="Search by name…" oninput="_Pict.views.ProjectFunding.onPickSearch(this.value)" />`
					+ '<div id="PF-PickResults" class="pf-pick-list"><div class="pf-note">Loading…</div></div>',
				buttons: [ { Hash: 'close', Label: 'Close' } ],
				width: '560px',
			});
		await this.provider.loadProfileAsync();
		this.onPickSearch('');
	}

	onPickSearch(pTerm)
	{
		if (this._pickTimer) { clearTimeout(this._pickTimer); }
		const tmpToken = (this._pickToken = (this._pickToken || 0) + 1);
		this._pickTimer = setTimeout(() =>
		{
			if (tmpToken !== this._pickToken) { return; }
			this._renderPickResults(pTerm);
		}, 150);
	}

	_renderPickResults(pTerm)
	{
		const tmpHost = document.getElementById('PF-PickResults');
		if (!tmpHost) { return; }
		const tmpProfile = this.provider.profile || {};
		const tmpList = tmpProfile[this._pickList] || [];
		const tmpTerm = String(pTerm || '').trim().toLowerCase();
		const tmpMatches = [];
		for (let i = 0; (i < tmpList.length) && (tmpMatches.length < 100); i++)
		{
			const tmpItem = tmpList[i];
			if (this._pickExclude.has(String(tmpItem.Key))) { continue; }
			const tmpName = String(tmpItem.Name || '').toLowerCase();
			const tmpCode = String(tmpItem.Code || tmpItem.Hash || '').toLowerCase();
			if (!tmpTerm || (tmpName.indexOf(tmpTerm) >= 0) || (tmpCode.indexOf(tmpTerm) >= 0)) { tmpMatches.push(tmpItem); }
		}
		if (!tmpMatches.length) { tmpHost.innerHTML = '<div class="pf-note">No matches.</div>'; return; }
		tmpHost.innerHTML = tmpMatches.map((pItem, pIndex) =>
			`<button type="button" class="pf-pick-row" onclick="_Pict.views.ProjectFunding.pickResult(${pIndex})">`
			+ `<span class="pf-pick-name">${fEsc(pItem.Name)}</span>`
			+ (pItem.Type ? `<span class="pf-tag pf-tag-type">${fEsc(pItem.Type)}</span>` : '')
			+ ((pItem.Balance != null && this._pickList === 'Funds') ? `<span class="pf-pick-bal">${fMoney(pItem.Balance)}</span>` : '')
			+ '</button>').join('');
		this._pickMatches = tmpMatches;
	}

	pickResult(pIndex)
	{
		const tmpItem = (this._pickMatches || [])[pIndex];
		if (!tmpItem) { return; }
		const tmpOnPick = this._pickOnPick;
		const tmpNoun = this._pickNoun;
		if (this.modal && (typeof this.modal.dismissModals === 'function')) { this.modal.dismissModals(); }
		Promise.resolve(tmpOnPick(tmpItem))
			.then(() => this._toast(`Added ${tmpNoun} “${tmpItem.Name}”.`, 'success'))
			.catch((pError) => this._toast((pError && pError.message) ? pError.message : `Could not add the ${tmpNoun}.`, 'error', 6000));
	}

	async removeBucket(pKey, pNoun)
	{
		const tmpOk = await this.modal.confirm(`Remove this ${fEsc(pNoun || 'item')} from the project’s funding${pNoun === 'category' || pNoun === 'source' ? ' (and everything under it)' : ''}?`, { title: 'Remove funding', confirmLabel: 'Remove', cancelLabel: 'Cancel', dangerous: true });
		if (!tmpOk) { return; }
		try { await this.provider.deleteBucketsAsync([ pKey ]); this._toast('Removed.', 'success'); }
		catch (pError) { this._toast((pError && pError.message) ? pError.message : 'Could not remove that.', 'error', 6000); }
	}

	// --- Purchase-order export --------------------------------------------------------------------

	/** Header toolbar: the purchase-order export button, shown only when the customer's toggle enables it. Export is
	 *  an output action available to any viewer, so it is NOT gated on the manage permission. */
	renderHeaderTools()
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#ProjectFunding-HeaderTools');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpButtons = [];
		// Simulate is a read-only what-if; it's only useful once some line items are categorized (they carry the
		// Category.Key the scenario needs), so gate the button on that.
		if (this.provider.lineItemRows().some((pRow) => !pRow.IsUncategorized))
		{
			tmpButtons.push('<button type="button" class="pf-head-btn pf-sim-btn" onclick="_Pict.views.ProjectFunding.openSimulation()"><i class="fas fa-flask"></i> Funding Sim</button>');
		}
		if (this.provider.canExportPurchaseOrder())
		{
			const tmpBusy = this._exporting ? ' disabled' : '';
			const tmpIcon = this._exporting ? 'fa-spinner fa-spin' : 'fa-file-arrow-down';
			tmpButtons.push(`<button type="button" class="pf-head-btn pf-export-btn"${tmpBusy} onclick="_Pict.views.ProjectFunding.onExportPurchaseOrder()"><i class="fas ${tmpIcon}"></i> ${this._exporting ? 'Exporting…' : 'PO Export'}</button>`);
		}
		this.pict.ContentAssignment.assignContent('#ProjectFunding-HeaderTools', tmpButtons.join(''));
	}

	async onExportPurchaseOrder()
	{
		if (this._exporting) { return; }
		this._exporting = true;
		this.renderHeaderTools();
		try
		{
			const tmpResult = await this.provider.exportPurchaseOrderAsync();
			this._showExportResult(tmpResult);
		}
		catch (pError) { this._toast((pError && pError.message) ? pError.message : 'Could not generate the purchase order.', 'error', 7000); }
		finally { this._exporting = false; this.renderHeaderTools(); }
	}

	/** Present the generated purchase order in a modal: the file name, any notices, then a download button per file
	 *  format. The file contents already came back with the export, so the downloads are client-side blobs. */
	_showExportResult(pResult)
	{
		const tmpFiles = (pResult && Array.isArray(pResult.Files)) ? pResult.Files : [];
		if (!tmpFiles.length) { this._toast('The purchase order came back empty.', 'warning', 6000); return; }
		this._exportResult = pResult;   // stash for the download buttons
		const tmpWarnings = (pResult.Violations || []).map((pV) => `<li>${fEsc(pV.Message || pV.Type || 'Notice')}</li>`).join('');
		const tmpWarnHTML = tmpWarnings
			? `<div class="pf-export-warn"><i class="fas fa-triangle-exclamation"></i> This export has notices:<ul>${tmpWarnings}</ul></div>`
			: '';
		const tmpButtons = tmpFiles.map((pFile, pIndex) =>
		{
			const tmpKind = (Array.isArray(pFile.Types) && pFile.Types.length) ? pFile.Types.join(', ') : 'File';
			return `<button type="button" class="pf-tool-btn pf-tool-primary" onclick="_Pict.views.ProjectFunding.downloadExportFile(${pIndex})"><i class="fas fa-download"></i> Download ${fEsc(tmpKind)}</button>`;
		}).join('');
		const tmpContent = '<div class="pf-export-modal">'
			+ `<p class="pf-export-name"><i class="fas fa-file-invoice"></i> ${fEsc(pResult.FileName || 'Purchase order')}</p>`
			+ tmpWarnHTML
			+ `<div class="pf-export-actions">${tmpButtons}</div>`
			+ '</div>';
		if (this.modal && (typeof this.modal.show === 'function'))
		{
			this.modal.show({ title: 'Purchase order export', content: tmpContent, buttons: [ { Hash: 'close', Label: 'Close' } ], width: '560px' });
		}
		else { this.downloadExportFile(0); }   // no modal available — just download the primary file
	}

	downloadExportFile(pIndex)
	{
		const tmpResult = this._exportResult;
		const tmpFiles = (tmpResult && Array.isArray(tmpResult.Files)) ? tmpResult.Files : [];
		const tmpIndex = Number(pIndex) || 0;
		const tmpFile = tmpFiles[tmpIndex];
		if (!tmpFile) { return; }
		const tmpContent = String(tmpFile.Content == null ? '' : tmpFile.Content);
		this._triggerBrowserDownload(new Blob([ tmpContent ], { type: 'text/plain;charset=utf-8' }), this._exportFileName(tmpResult, tmpFile, tmpIndex));
	}

	/** The server sends one FileName (the primary/plaintext .dat); derive a distinct name for the other formats. */
	_exportFileName(pResult, pFile, pIndex)
	{
		const tmpBase = (pResult && pResult.FileName) ? String(pResult.FileName) : 'PurchaseOrder.dat';
		if (pIndex === 0) { return tmpBase; }
		const tmpKind = (pFile && Array.isArray(pFile.Types) && pFile.Types.length) ? pFile.Types.join('-') : `file-${pIndex}`;
		const tmpDot = tmpBase.lastIndexOf('.');
		return (tmpDot > 0) ? `${tmpBase.slice(0, tmpDot)}-${tmpKind}${tmpBase.slice(tmpDot)}` : `${tmpBase}-${tmpKind}`;
	}

	/** Client-side download of an in-memory blob (copied idiom from ImportantFiles view). */
	_triggerBrowserDownload(pBlob, pFileName)
	{
		const tmpURL = URL.createObjectURL(pBlob);
		const tmpAnchor = document.createElement('a');
		tmpAnchor.href = tmpURL;
		tmpAnchor.download = pFileName || 'download';
		tmpAnchor.rel = 'noopener';
		document.body.appendChild(tmpAnchor);
		tmpAnchor.click();
		document.body.removeChild(tmpAnchor);
		setTimeout(() => URL.revokeObjectURL(tmpURL), 10000);
	}

	// --- Funding simulation (what-if) -------------------------------------------------------------

	/** Open the simulation modal: a Configure tab (pick categorized line items + a payment amount each) and a Results
	 *  tab (how those payments would draw from the project's funds). Read-only — the scenario is never saved. */
	openSimulation()
	{
		if (!this.modal || (typeof this.modal.show !== 'function')) { this._toast('The simulation dialog needs the modal component.', 'error', 6000); return; }
		this._sim = { selected: [], result: null, error: null, tab: 'configure', searchTerm: '' };
		this.modal.show(
			{
				title: 'Funding simulation',
				content: '<div class="pf-sim">'
					+ '<div class="pf-sim-tabs">'
					+ '<button type="button" class="pf-sim-tab is-active" data-simtab="configure" onclick="_Pict.views.ProjectFunding.switchSimTab(\'configure\')">Configure</button>'
					+ '<button type="button" class="pf-sim-tab" data-simtab="results" onclick="_Pict.views.ProjectFunding.switchSimTab(\'results\')">Results</button>'
					+ '</div>'
					+ '<div id="PF-Sim-Configure" class="pf-sim-panel"></div>'
					+ '<div id="PF-Sim-Results" class="pf-sim-panel" hidden></div>'
					+ '</div>',
				buttons: [ { Hash: 'close', Label: 'Close' } ],
				width: '760px',
			});
		this.renderSimConfigure();
	}

	renderSimConfigure()
	{
		const tmpHost = document.getElementById('PF-Sim-Configure');
		if (!tmpHost) { return; }
		const tmpSelected = this._sim.selected;
		const tmpRows = tmpSelected.map((pSel) =>
			'<tr>'
			+ `<td class="pf-sim-liname">${fEsc(pSel.Name)}</td>`
			+ `<td class="pf-sim-licat"><span class="pf-tag pf-tag-type">${fEsc(pSel.CategoryName || '—')}</span></td>`
			+ `<td class="pf-sim-liamt"><span class="pf-sim-dollar">$</span><input class="pf-sim-amt" type="number" min="0" step="any" inputmode="decimal" value="${fAttr(pSel.Amount)}" data-simkey="${fAttr(pSel.Key)}" oninput="_Pict.views.ProjectFunding.onSimAmountEdit(this)" placeholder="0.00" /></td>`
			+ `<td class="pf-sim-lidel"><button type="button" class="pf-btn pf-btn-danger" title="Remove" onclick="_Pict.views.ProjectFunding.simRemoveLineItem('${fAttr(pSel.Key)}')"><i class="fas fa-xmark"></i></button></td>`
			+ '</tr>').join('');
		const tmpSelectedHTML = tmpSelected.length
			? `<table class="pf-sim-table"><thead><tr><th>Line item</th><th>Category</th><th>Payment amount</th><th></th></tr></thead><tbody>${tmpRows}</tbody></table>`
			: '<div class="pf-note">No line items selected yet — search above and click to add.</div>';
		const tmpReady = this._simReady();
		tmpHost.innerHTML =
			'<p class="pf-sim-help">Pick categorized line items and enter a payment amount for each. The simulation shows how those payments would draw from the project’s funds — nothing is saved.</p>'
			+ `<input id="PF-Sim-Search" class="input pf-sim-search" type="text" autocomplete="off" placeholder="Search line items by name or code…" value="${fAttr(this._sim.searchTerm || '')}" oninput="_Pict.views.ProjectFunding.onSimSearch(this.value)" />`
			+ '<div id="PF-Sim-PickList" class="pf-sim-picklist"></div>'
			+ `<div class="pf-sim-selected">${tmpSelectedHTML}</div>`
			+ '<div class="pf-sim-foot">'
			+ '<button type="button" class="pf-tool-btn" onclick="_Pict.views.ProjectFunding.simReset()"><i class="fas fa-rotate-left"></i> Reset</button>'
			+ `<button type="button" class="pf-tool-btn pf-tool-primary pf-sim-run"${tmpReady ? '' : ' disabled'} onclick="_Pict.views.ProjectFunding.runSimulation()"><i class="fas fa-play"></i> Run simulation</button>`
			+ '</div>';
		this._renderSimPickList(this._sim.searchTerm || '');
	}

	onSimSearch(pTerm)
	{
		this._sim.searchTerm = pTerm;
		if (this._simTimer) { clearTimeout(this._simTimer); }
		this._simTimer = setTimeout(() => this._renderSimPickList(pTerm), 150);
	}

	/** The categorized, not-yet-selected line items matching the search term (client-side over the loaded set). */
	_renderSimPickList(pTerm)
	{
		const tmpHost = document.getElementById('PF-Sim-PickList');
		if (!tmpHost) { return; }
		const tmpTerm = String(pTerm || '').trim().toLowerCase();
		const tmpSelectedKeys = new Set(this._sim.selected.map((pS) => String(pS.Key)));
		const tmpPool = this.provider.lineItemRows().filter((pR) => !pR.IsUncategorized && !tmpSelectedKeys.has(String(pR.Key)));
		const tmpMatches = [];
		for (let i = 0; (i < tmpPool.length) && (tmpMatches.length < 60); i++)
		{
			const tmpR = tmpPool[i];
			if (!tmpTerm || (String(tmpR.Name).toLowerCase().indexOf(tmpTerm) >= 0) || (String(tmpR.ItemCode).toLowerCase().indexOf(tmpTerm) >= 0)) { tmpMatches.push(tmpR); }
		}
		this._simMatches = tmpMatches;
		if (!tmpMatches.length) { tmpHost.innerHTML = '<div class="pf-note">No categorized line items match.</div>'; return; }
		tmpHost.innerHTML = tmpMatches.map((pR, pIndex) =>
			`<button type="button" class="pf-sim-pickrow" onclick="_Pict.views.ProjectFunding.simAddLineItem(${pIndex})"><span class="pf-sim-pickname">${fEsc(pR.Name)}</span><span class="pf-tag pf-tag-type">${fEsc(pR.CategoryName)}</span><i class="fas fa-plus"></i></button>`).join('');
	}

	simAddLineItem(pIndex)
	{
		const tmpR = (this._simMatches || [])[pIndex];
		if (!tmpR) { return; }
		if (this._sim.selected.some((pS) => String(pS.Key) === String(tmpR.Key))) { return; }
		this._sim.selected.push({ Key: tmpR.Key, Name: tmpR.Name, CategoryKey: tmpR.CategoryKey, CategoryName: tmpR.CategoryName, Amount: '' });
		this.renderSimConfigure();
	}

	simRemoveLineItem(pKey)
	{
		this._sim.selected = this._sim.selected.filter((pS) => String(pS.Key) !== String(pKey));
		this.renderSimConfigure();
	}

	/** Amount edits update state + toggle the Run button in place — never a re-render, so the input keeps focus. */
	onSimAmountEdit(pEl)
	{
		if (!pEl) { return; }
		const tmpSel = this._sim.selected.find((pS) => String(pS.Key) === String(pEl.getAttribute('data-simkey')));
		if (tmpSel) { tmpSel.Amount = pEl.value; }
		const tmpRun = document.querySelector('.pf-sim-run');
		if (tmpRun) { tmpRun.disabled = !this._simReady(); }
	}

	_simReady()
	{
		const tmpSel = (this._sim && this._sim.selected) || [];
		if (!tmpSel.length) { return false; }
		return tmpSel.every((pS) => { const tmpN = Number(pS.Amount); return (pS.Amount !== '') && Number.isFinite(tmpN) && (tmpN > 0); });
	}

	simReset() { this._sim.selected = []; this._sim.searchTerm = ''; this.renderSimConfigure(); }

	async runSimulation()
	{
		if (!this._simReady() || this._simRunning) { return; }
		this._simRunning = true;
		const tmpRun = document.querySelector('.pf-sim-run');
		if (tmpRun) { tmpRun.disabled = true; tmpRun.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Running…'; }
		const tmpPayload = this._sim.selected.map((pS) => ({ LineItem: { Key: pS.Key }, Category: { Key: pS.CategoryKey }, Amount: String(pS.Amount) }));
		try
		{
			this._sim.result = await this.provider.simulateAsync(tmpPayload);
			this._sim.error = null;
		}
		catch (pError)
		{
			this._sim.error = (pError && pError.message) ? pError.message : 'The simulation failed.';
			this._sim.result = null;
		}
		finally
		{
			this._simRunning = false;
			this.renderSimResults();
			this.switchSimTab('results');
			const tmpRun2 = document.querySelector('.pf-sim-run');
			if (tmpRun2) { tmpRun2.disabled = !this._simReady(); tmpRun2.innerHTML = '<i class="fas fa-play"></i> Run simulation'; }
		}
	}

	switchSimTab(pTab)
	{
		if (this._sim) { this._sim.tab = pTab; }
		const tmpCfg = document.getElementById('PF-Sim-Configure');
		const tmpRes = document.getElementById('PF-Sim-Results');
		if (tmpCfg) { tmpCfg.hidden = (pTab !== 'configure'); }
		if (tmpRes) { tmpRes.hidden = (pTab !== 'results'); }
		const tmpTabs = document.querySelectorAll('.pf-sim-tab');
		for (let i = 0; i < tmpTabs.length; i++) { tmpTabs[i].classList.toggle('is-active', tmpTabs[i].getAttribute('data-simtab') === pTab); }
	}

	renderSimResults()
	{
		const tmpHost = document.getElementById('PF-Sim-Results');
		if (!tmpHost) { return; }
		if (this._sim.error)
		{
			tmpHost.innerHTML = `<div class="pf-sim-err"><i class="fas fa-triangle-exclamation"></i> ${fEsc(this._sim.error)}</div>`
				+ '<div class="pf-sim-foot"><button type="button" class="pf-tool-btn" onclick="_Pict.views.ProjectFunding.switchSimTab(\'configure\')"><i class="fas fa-arrow-left"></i> Back to configure</button></div>';
			return;
		}
		const tmpSol = (this._sim.result && this._sim.result.Solution) || {};
		const tmpScn = (this._sim.result && this._sim.result.Scenario) || {};
		const tmpTypes = Array.isArray(tmpSol.FundingTypeOutcomes) ? tmpSol.FundingTypeOutcomes : [];
		const tmpFunds = Array.isArray(tmpSol.FundOutcomes) ? tmpSol.FundOutcomes : [];
		const tmpViolations = Array.isArray(tmpSol.Violations) ? tmpSol.Violations : [];
		const tmpLog = Array.isArray(tmpScn.LogEntry) ? tmpScn.LogEntry : [];

		const tmpStats = '<div class="pf-sim-stats">'
			+ `<div class="pf-sim-stat"><span class="pf-sim-stat-lbl">Requested payment</span><span class="pf-sim-stat-val">${fMoney(tmpSol.FinalPaymentAmount)}</span></div>`
			+ `<div class="pf-sim-stat"><span class="pf-sim-stat-lbl">Funded</span><span class="pf-sim-stat-val">${fMoney(tmpSol.ActualPaymentAmount)}</span></div>`
			+ '</div>';
		const tmpViolHTML = tmpViolations.length
			? `<div class="pf-violations">${tmpViolations.map((pV) => `<div class="pf-violation"><i class="fas fa-triangle-exclamation"></i> ${fEsc(pV.Message || pV.Type || 'Funding issue')}</div>`).join('')}</div>`
			: '<div class="pf-ok"><i class="fas fa-circle-check"></i> No simulation violations.</div>';
		const tmpTypeHTML = tmpTypes.length
			? `<div class="pf-outcomes"><div class="pf-outcomes-head">By funding type</div>${tmpTypes.map((pO) => `<div class="pf-outcome"><span>${fEsc(pO.FundingType)}</span><span>${fMoney(pO.Amount)}</span></div>`).join('')}</div>`
			: '';
		const tmpFundHTML = tmpFunds.length
			? `<div class="pf-outcomes"><div class="pf-outcomes-head">${tmpFunds.length} fund${tmpFunds.length === 1 ? '' : 's'} drawn</div>${tmpFunds.map((pF) => `<div class="pf-outcome"><span>${fEsc(pF.Name || pF.Hash || 'Fund')}</span><span>${fMoney(pF.Amount)}</span></div>`).join('')}</div>`
			: '<div class="pf-note">No funds were drawn for these payments.</div>';
		const tmpLogHTML = tmpLog.length
			? `<div class="pf-sim-log"><div class="pf-outcomes-head">Depletion history</div>${tmpLog.map((pL) => `<div class="pf-sim-logrow">${fEsc(pL.Message || pL.Description || '')}</div>`).join('')}</div>`
			: '';
		tmpHost.innerHTML = tmpStats
			+ tmpViolHTML
			+ `<div class="pf-sim-outcome-row">${tmpTypeHTML}${tmpFundHTML}</div>`
			+ tmpLogHTML
			+ '<div class="pf-sim-foot"><button type="button" class="pf-tool-btn" onclick="_Pict.views.ProjectFunding.switchSimTab(\'configure\')"><i class="fas fa-arrow-left"></i> Adjust and re-run</button></div>';
	}

	// --- Accounting overview ----------------------------------------------------------------------

	renderAccounting()
	{
		const tmpMount = this.pict.ContentAssignment.getElement(ACCT_MOUNT);
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpState = this.pict.AppData.ProjectFunding || {};
		const tmpDigest = tmpState.Digest || {};
		const tmpSolution = tmpState.Solution || {};
		const tmpTotals = Array.isArray(tmpDigest.TotalsSummary) ? tmpDigest.TotalsSummary : [];
		const tmpViolations = Array.isArray(tmpSolution.Violations) ? tmpSolution.Violations : [];

		const tmpViolationHTML = tmpViolations.length
			? `<div class="pf-violations">${tmpViolations.map((pV) => `<div class="pf-violation"><i class="fas fa-triangle-exclamation"></i> ${fEsc(pV.Message || pV.Type || 'Funding issue')}</div>`).join('')}</div>`
			: '<div class="pf-ok"><i class="fas fa-circle-check"></i> No funding violations.</div>';

		const tmpTotalCards = tmpTotals.map((pT) =>
		{
			const tmpPctDepleted = Number(pT.PercentageDepleted) || 0;
			const tmpAmber = tmpPctDepleted > 1;
			return `<div class="pf-total-card"><div class="pf-total-name">${fEsc(pT.Name || pT.Key || 'Funds')}</div>`
				+ `<div class="pf-total-grid">`
				+ `<div><span class="pf-total-lbl">Original</span><span class="pf-total-val">${fMoney(pT.OriginalBalance)}</span></div>`
				+ `<div><span class="pf-total-lbl">Balance</span><span class="pf-total-val">${fMoney(pT.Balance)}</span></div>`
				+ `<div><span class="pf-total-lbl">Committed</span><span class="pf-total-val">${fMoney(pT.TotalCommitted)}</span></div>`
				+ `<div><span class="pf-total-lbl">Spent</span><span class="pf-total-val">${fMoney(pT.Expenditure)}</span></div>`
				+ `</div>`
				+ `<div class="pf-bar"><div class="pf-bar-fill${tmpAmber ? ' is-over' : ''}" style="width:${Math.max(0, Math.min(100, tmpPctDepleted * 100)).toFixed(1)}%"></div></div>`
				+ `<div class="pf-bar-lbl">${fPct(pT.PercentageDepleted)} depleted · ${fPct(pT.PercentageRemaining)} remaining</div></div>`;
		}).join('');

		const tmpTypeOutcomes = Array.isArray(tmpSolution.FundingTypeOutcomes) ? tmpSolution.FundingTypeOutcomes : [];
		const tmpTypeHTML = tmpTypeOutcomes.length
			? `<div class="pf-outcomes"><div class="pf-outcomes-head">Funding type</div>${tmpTypeOutcomes.map((pO) => `<div class="pf-outcome"><span>${fEsc(pO.FundingType)}</span><span>${fMoney(pO.Amount)}</span></div>`).join('')}</div>`
			: '';
		const tmpAcctOutcomes = Array.isArray(tmpSolution.AccountTypeOutcomes) ? tmpSolution.AccountTypeOutcomes : [];
		const tmpAcctHTML = tmpAcctOutcomes.length
			? `<div class="pf-outcomes"><div class="pf-outcomes-head">Account type</div>${tmpAcctOutcomes.map((pO) => `<div class="pf-outcome"><span>${fEsc(pO.AccountType)}</span><span>${fMoney(pO.Amount)}</span></div>`).join('')}</div>`
			: '';

		this.pict.ContentAssignment.assignContent(ACCT_MOUNT,
			tmpViolationHTML
			+ (tmpTotalCards ? `<div class="pf-total-row">${tmpTotalCards}</div>` : '<div class="pf-note">No fund totals yet.</div>')
			+ `<div class="pf-outcome-row">${tmpTypeHTML}${tmpAcctHTML}</div>`);
	}

	// --- Line item funding (slice 2) --------------------------------------------------------------

	renderLineItems()
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#ProjectFunding-LineItems');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		// When the project's status requires a Change Order, line-item modifications (funding-category assignment
		// writes LineItem.IDFundingCategory) are locked — force the read-only render and show a prompt.
		const tmpRequiresCO = !!(this.pict.AppData.ProjectFunding && this.pict.AppData.ProjectFunding.RequiresChangeOrder);
		const tmpManage = !!(this.pict.AppData.ProjectFunding && this.pict.AppData.ProjectFunding.CanManage) && !tmpRequiresCO;
		const tmpCOBanner = tmpRequiresCO
			? `<div class="pf-co-lock"><i class="fas fa-lock"></i> This project’s status <strong>${fEsc((this.pict.AppData.ProjectFunding && this.pict.AppData.ProjectFunding.ProjectStatus) || '')}</strong> requires a <strong>Change Order</strong> to modify line items — funding assignments are read-only. Use the <strong>Change Orders</strong> tab.</div>`
			: '';
		const tmpRows = this.provider.lineItemRows();
		const tmpCats = this.provider.projectCategories || [];
		const tmpCountEl = document.getElementById('ProjectFunding-LICount');
		if (!tmpRows.length)
		{
			if (tmpCountEl) { tmpCountEl.textContent = ''; }
			this.pict.ContentAssignment.assignContent('#ProjectFunding-LineItems', '<div class="pf-note">This project has no line items.</div>');
			return;
		}
		const tmpUncat = tmpRows.filter((pR) => pR.IsUncategorized).length;
		if (tmpCountEl) { tmpCountEl.textContent = tmpUncat ? `${tmpUncat} of ${tmpRows.length} uncategorized` : `${tmpRows.length} line items`; }
		if (!tmpCats.length && tmpManage)
		{
			this.pict.ContentAssignment.assignContent('#ProjectFunding-LineItems', '<div class="pf-note">Add a funding category in the setup panel before assigning line items.</div>');
			return;
		}
		// The common case is a searchable Pict-Section-Picker per row (fed the project's funding categories as a
		// static, in-memory Options list). A project with a huge line-item set falls back to native <select>s so we
		// don't stand up hundreds of picker views at once. The row keys are Finance display keys (arbitrary strings),
		// so rows are addressed by index — RowKeys[i] maps the mount/AppData slot back to the line item's Key.
		const tmpUsePickers = tmpManage && (tmpRows.length <= LI_PICKER_CAP);
		this._liRowKeys = tmpRows.map((pR) => pR.Key);
		this._liUsePickers = tmpUsePickers;
		const tmpBigNote = (tmpManage && !tmpUsePickers)
			? '<div class="pf-note pf-li-note">This project has a lot of line items — using quick dropdowns instead of the searchable picker to stay responsive.</div>'
			: '';
		// A line item can't be un-assigned once categorized (the Finance API only reassigns) — the native placeholder
		// is a DISABLED option, and the picker simply shows its Placeholder until a real category is chosen.
		const tmpNativeOptions = (pSelected) => [ `<option value="" disabled${pSelected ? '' : ' selected'}>Select a category…</option>` ]
			.concat(tmpCats.map((pCat) => `<option value="${fAttr(pCat.Key)}"${String(pCat.Key) === String(pSelected) ? ' selected' : ''}>${fEsc(pCat.Name)}</option>`)).join('');
		const tmpBody = tmpRows.map((pR, pIndex) =>
		{
			let tmpCatCell;
			if (!tmpManage) { tmpCatCell = `<span class="pf-ro">${pR.CategoryName ? fEsc(pR.CategoryName) : '—'}</span>`; }
			else if (tmpUsePickers) { tmpCatCell = `<div class="pf-li-pickmount" id="ProjectFunding-LICat-${pIndex}"></div>`; }
			else { tmpCatCell = `<select class="pf-li-cat" data-li-index="${pIndex}" onchange="_Pict.views.ProjectFunding.onLineItemCategoryChange(this)">${tmpNativeOptions(pR.CategoryKey)}</select>`; }
			return `<tr class="pf-li-row${pR.IsUncategorized ? ' is-uncat' : ''}"><td class="pf-li-code">${fEsc(pR.ItemCode)}</td><td class="pf-li-name">${fEsc(pR.Name)}${pR.IsUncategorized ? '<span class="pf-li-badge">no category</span>' : ''}</td><td class="pf-li-catcell">${tmpCatCell}</td></tr>`;
		}).join('');
		this.pict.ContentAssignment.assignContent('#ProjectFunding-LineItems',
			`${tmpCOBanner}${tmpBigNote}<table class="pf-li-table"><thead><tr><th>Item</th><th>Name</th><th>Funding category</th></tr></thead><tbody>${tmpBody}</tbody></table>`);

		if (tmpUsePickers) { this._mountLineItemPickers(tmpRows, tmpCats); }
	}

	/** Stand up one searchable Pict-Section-Picker per line-item row, each fed the project's funding categories as a
	 *  static in-memory Options list. Selecting a category calls straight through to the same save path as the native
	 *  fallback. Uncategorized rows are left showing the placeholder (there is no un-assign). */
	_mountLineItemPickers(pRows, pCats)
	{
		const tmpPicker = this.pickerProvider;
		const tmpCA = this.pict.ContentAssignment;
		if (!tmpPicker || (typeof tmpPicker.createPicker !== 'function') || !tmpCA) { return; }
		this.pict.AppData.ProjectFunding = this.pict.AppData.ProjectFunding || {};
		const tmpStore = (this.pict.AppData.ProjectFunding.LICatValues = {});
		const tmpOptions = pCats.map((pCat) => ({ Value: String(pCat.Key), Text: pCat.Name }));

		for (let i = 0; i < pRows.length; i++)
		{
			const tmpDest = `#ProjectFunding-LICat-${i}`;
			if (tmpCA.getElement(tmpDest).length === 0) { continue; }
			const tmpValue = pRows[i].IsUncategorized ? '' : String(pRows[i].CategoryKey);
			tmpStore[i] = tmpValue;

			const tmpInstance = tmpPicker.createPicker(`ProjectFunding-LICat-${i}`,
				{
					DestinationAddress: tmpDest,
					ValueAddress: `AppData.ProjectFunding.LICatValues.${i}`,
					Searchable: true,
					Placeholder: 'Select a category…',
					Options: tmpOptions,
					OnChange: ((pRowIndex) => (pNewValue) => this.onLineItemPick(pRowIndex, pNewValue))(i),
				});
			if (tmpInstance && (typeof tmpInstance.render === 'function')) { tmpInstance.render(); }
			if (tmpInstance && tmpValue && (typeof tmpInstance.setValue === 'function')) { tmpInstance.setValue(tmpValue); }
		}
	}

	/** Picker OnChange — resolve the row index back to its line-item Key and assign the chosen category. */
	onLineItemPick(pRowIndex, pValue) { this._applyLineItemCategory((this._liRowKeys || [])[pRowIndex], pValue); }

	/** Native-fallback onchange (large projects). */
	onLineItemCategoryChange(pEl)
	{
		if (!pEl) { return; }
		const tmpIndex = parseInt(pEl.getAttribute('data-li-index'), 10);
		pEl.disabled = true;
		this._applyLineItemCategory((this._liRowKeys || [])[tmpIndex], pEl.value)
			.finally(() => { if (pEl && pEl.parentNode) { pEl.disabled = false; } });
	}

	/** Assign a line item's funding category. A full re-render follows (the provider re-solves) — fine here: it's a
	 *  discrete pick (no mid-type edit) and a category change ripples through the whole solution/accounting. */
	async _applyLineItemCategory(pRowKey, pCatValue)
	{
		if (!pRowKey || !pCatValue) { return; }
		try { await this.provider.saveLineItemCategoryAsync(pRowKey, pCatValue); this._toast('Line item funding updated.', 'success'); }
		catch (pError) { this._toast((pError && pError.message) ? pError.message : 'Could not update the line item.', 'error', 6000); }
	}
}

module.exports = ProjectFunding;
module.exports.default_configuration = {
	ViewIdentifier: 'ProjectFunding',
	DefaultRenderable: 'ProjectFundingWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
		.pf-wrap { max-width: 1180px; margin: 0 auto; padding: 1.5rem 1.25rem 4rem; }
		/* Embedded in a ProjectWorkspace Contract ▸ Funding tab: shed the standalone-page chrome + the redundant
		   project title (the workspace header + the "Contract ▸ Funding" breadcrumb already name the project), leaving
		   the header as a right-aligned Funding Sim / PO Export toolbar. */
		.section.pf-embedded { padding: 0; }
		.pf-embedded .pf-wrap { max-width: none; padding: 0.25rem 0 1rem; }
		.pf-embedded .pf-head { margin-bottom: 0.6rem; }
		.pf-embedded .pf-head-ic, .pf-embedded .pf-title { display: none; }
		.pf-head { display: flex; align-items: flex-start; gap: 0.85rem; margin-bottom: 1.1rem; }
		.pf-head-ic { flex: none; width: 2.4rem; height: 2.4rem; border-radius: 10px; display: grid; place-items: center; background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.1rem; }
		.pf-title { font-size: 1.5rem; font-weight: 700; margin: 0; line-height: 1.15; color: var(--theme-color-text-primary, #1f2733); }
		.pf-head-spacer { flex: 1 1 auto; }
		.pf-head-btn, .pf-tool-btn { display: inline-flex; align-items: center; gap: 0.4rem; white-space: nowrap; font-size: 0.82rem; cursor: pointer; padding: 0.4rem 0.75rem; border-radius: 7px; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.pf-head-btn:hover, .pf-tool-btn:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.pf-tool-primary { border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); }
		.pf-ro-pill { align-self: center; display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.25rem 0.55rem; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); color: var(--theme-color-text-muted, #8a94a3); border: 1px solid var(--theme-color-border-light, #e8ebf0); }

		.pf-state { padding: 2.5rem 1rem; text-align: center; color: var(--theme-color-text-secondary, #5b6673); }
		.pf-note { padding: 0.9rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.86rem; text-align: center; }
		.pf-err { color: var(--theme-color-status-error, #cf5b5b); }

		/* Front door */
		.pf-picker { max-width: 620px; margin: 0.5rem auto 0; }
		.pf-proj-filter { width: 100%; padding: 0.6rem 0.8rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; font: inherit; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); margin-bottom: 0.8rem; }
		.pf-proj-list { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 10px; overflow: hidden; }
		.pf-proj-row { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; width: 100%; text-align: left; border: none; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-panel, #fff); padding: 0.65rem 0.9rem; cursor: pointer; font: inherit; color: var(--theme-color-text-primary, #1f2733); }
		.pf-proj-row:last-child { border-bottom: none; }
		.pf-proj-row:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.pf-proj-row i { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.8rem; }

		/* Layout: two columns (setup grid + accounting) on wide screens */
		/* Full-width stack: accounting overview (collapsible) on top, then the full-width funding setup, then line items. */
		.pf-stack { display: flex; flex-direction: column; gap: 1.25rem; }
		.pf-panel { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 12px; background: var(--theme-color-background-panel, #fff); }
		.pf-acct-head { cursor: pointer; user-select: none; }
		.pf-acct-head:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.pf-acct-caret { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.85em; }
		.pf-acct-panel.is-collapsed .pf-panel-head { border-bottom: none; }
		.pf-acct-panel.is-collapsed .pf-acct-body { display: none; }
		.pf-panel-head { display: flex; align-items: center; gap: 0.6rem; padding: 0.7rem 0.9rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); font-weight: 600; font-size: 0.92rem; color: var(--theme-color-text-primary, #1f2733); }
		.pf-panel-head .pf-head-spacer { flex: 1 1 auto; }
		.pf-panel-body { padding: 0.6rem 0.7rem; }

		/* Setup grid */
		.pf-empty { text-align: center; padding: 2.2rem 1rem; color: var(--theme-color-text-muted, #8a94a3); }
		.pf-empty i { font-size: 1.6rem; display: block; margin-bottom: 0.5rem; opacity: 0.7; }
		.pf-empty p { margin: 0 0 0.8rem; }
		.pf-cat { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 9px; margin-bottom: 0.7rem; overflow: hidden; }
		.pf-cat-head { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0.7rem; background: var(--theme-color-background-secondary, #f0f2f6); }
		.pf-cat-head > i { color: var(--theme-color-brand-primary, #156dd1); }
		.pf-cat-name { font-weight: 600; font-size: 0.9rem; }
		.pf-tag { font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-panel, #fff); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 999px; padding: 0.05rem 0.4rem; }
		.pf-tag-type { color: var(--theme-color-brand-primary, #156dd1); }
		.pf-cat-actions { margin-left: auto; display: inline-flex; gap: 0.3rem; }
		.pf-cat-empty { padding: 0.5rem 0.8rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.82rem; font-style: italic; }
		.pf-btn { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.74rem; cursor: pointer; padding: 0.25rem 0.5rem; border-radius: 6px; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-secondary, #45505f); }
		.pf-btn:hover { background: var(--theme-color-background-selected, #e3edfb); color: var(--theme-color-brand-primary, #156dd1); }
		.pf-btn-danger:hover { color: var(--theme-color-status-error, #cf5b5b); background: rgba(207,91,91,0.1); }
		.pf-btn[disabled] { opacity: 0.55; cursor: default; }

		/* Header tools (purchase-order export) */
		.pf-head-tools { display: inline-flex; align-items: center; gap: 0.5rem; }
		.pf-export-btn[disabled] { opacity: 0.6; cursor: default; }

		/* Purchase-order export modal */
		.pf-export-modal { font-size: 0.9rem; }
		.pf-export-name { display: flex; align-items: center; gap: 0.45rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); margin: 0 0 0.8rem; word-break: break-all; }
		.pf-export-warn { font-size: 0.83rem; color: #8a6d1b; background: var(--theme-color-status-warning-bg, #fbf3d9); border-radius: 7px; padding: 0.55rem 0.7rem; margin: 0 0 0.9rem; }
		.pf-export-warn ul { margin: 0.35rem 0 0; padding-left: 1.1rem; }
		.pf-export-actions { display: flex; flex-wrap: wrap; gap: 0.55rem; }

		/* Funding simulation modal */
		.pf-sim { font-size: 0.9rem; }
		.pf-sim-tabs { display: flex; gap: 0.4rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); margin: 0 0 0.9rem; }
		.pf-sim-tab { appearance: none; border: none; background: none; cursor: pointer; font: inherit; font-size: 0.85rem; font-weight: 600; color: var(--theme-color-text-muted, #8a94a3); padding: 0.45rem 0.75rem; border-bottom: 2px solid transparent; margin-bottom: -1px; }
		.pf-sim-tab.is-active { color: var(--theme-color-brand-primary, #156dd1); border-bottom-color: var(--theme-color-brand-primary, #156dd1); }
		.pf-sim-help { color: var(--theme-color-text-secondary, #5b6673); font-size: 0.84rem; margin: 0 0 0.7rem; }
		.pf-sim-search { width: 100%; padding: 0.5rem 0.7rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px; font: inherit; margin: 0 0 0.5rem; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.pf-sim-picklist { max-height: 180px; overflow-y: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 7px; margin: 0 0 0.9rem; }
		.pf-sim-picklist:empty { display: none; }
		.pf-sim-pickrow { display: flex; align-items: center; gap: 0.6rem; width: 100%; text-align: left; appearance: none; border: none; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); background: var(--theme-color-background-panel, #fff); cursor: pointer; font: inherit; font-size: 0.84rem; padding: 0.45rem 0.65rem; color: var(--theme-color-text-primary, #1f2733); }
		.pf-sim-pickrow:last-child { border-bottom: none; }
		.pf-sim-pickrow:hover { background: var(--theme-color-background-selected, #e3edfb); }
		.pf-sim-pickname { flex: 1 1 auto; }
		.pf-sim-pickrow .fa-plus { color: var(--theme-color-brand-primary, #156dd1); }
		.pf-sim-table { width: 100%; border-collapse: collapse; font-size: 0.84rem; }
		.pf-sim-table th { text-align: left; font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); padding: 0.35rem 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.pf-sim-table td { padding: 0.35rem 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; }
		.pf-sim-liname { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.pf-sim-liamt { white-space: nowrap; }
		.pf-sim-dollar { color: var(--theme-color-text-muted, #8a94a3); margin-right: 0.15rem; }
		.pf-sim-amt { width: 8.5rem; padding: 0.25rem 0.4rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; font: inherit; font-size: 0.82rem; text-align: right; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.pf-sim-foot { display: flex; justify-content: flex-end; gap: 0.55rem; margin-top: 1rem; }
		.pf-sim-stats { display: flex; gap: 0.85rem; flex-wrap: wrap; margin: 0 0 0.9rem; }
		.pf-sim-stat { flex: 1 1 180px; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 9px; padding: 0.7rem 0.85rem; background: var(--theme-color-background-secondary, #fafbfc); }
		.pf-sim-stat-lbl { display: block; font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.25rem; }
		.pf-sim-stat-val { font-size: 1.2rem; font-weight: 700; color: var(--theme-color-text-primary, #1f2733); font-variant-numeric: tabular-nums; }
		.pf-sim-outcome-row { display: flex; gap: 0.85rem; flex-wrap: wrap; margin: 0.6rem 0; }
		.pf-sim-outcome-row > * { flex: 1 1 220px; }
		.pf-sim-log { margin-top: 0.6rem; }
		.pf-sim-logrow { font-size: 0.8rem; color: var(--theme-color-text-secondary, #5b6673); padding: 0.3rem 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); font-variant-numeric: tabular-nums; }
		.pf-sim-err { display: flex; align-items: center; gap: 0.5rem; font-size: 0.88rem; color: var(--theme-color-status-error, #a12d22); background: var(--theme-color-status-danger-bg, #fbe6e3); border-radius: 8px; padding: 0.7rem 0.85rem; }
		.pf-src-tablewrap { overflow-x: auto; }
		.pf-src-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
		/* Reserve room for the (long) funding-source names so they stop hard-wrapping now that the setup is full width;
		   the numeric inputs stay compact (min-width) and the table scrolls horizontally if the viewport is narrow. */
		.pf-src-table th:first-child, .pf-src-name, .pf-fund-name { min-width: 15rem; }
		.pf-src-table th { text-align: left; font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); padding: 0.35rem 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.pf-src-table td { padding: 0.3rem 0.5rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; }
		.pf-src-row .pf-src-name { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.pf-fund-row td { background: var(--theme-color-background-secondary, #fafbfc); }
		.pf-fund-name { color: var(--theme-color-text-secondary, #5b6673); padding-left: 1rem; }
		.pf-fund-name i { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.7rem; margin-right: 0.2rem; }
		.pf-fund-bal { font-size: 0.72rem; color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; }
		.pf-eff { font-variant-numeric: tabular-nums; color: var(--theme-color-text-muted, #8a94a3); }
		.pf-row-act { white-space: nowrap; text-align: right; }
		.pf-row-act .pf-btn { margin-left: 0.25rem; }
		.pf-inp { width: 100%; min-width: 52px; max-width: 7rem; padding: 0.2rem 0.35rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 5px; font: inherit; font-size: 0.8rem; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); font-variant-numeric: tabular-nums; }
		.pf-inp:focus { outline: 2px solid var(--theme-color-brand-primary, #156dd1); outline-offset: -1px; }
		.pf-inp-text { min-width: 70px; }
		.pf-ro { font-variant-numeric: tabular-nums; color: var(--theme-color-text-secondary, #5b6673); }

		/* Accounting overview */
		.pf-violations { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 0.7rem; }
		.pf-violation { font-size: 0.8rem; padding: 0.45rem 0.6rem; border-radius: 7px; background: rgba(207,91,91,0.1); color: var(--theme-color-status-error, #cf5b5b); }
		.pf-ok { font-size: 0.8rem; padding: 0.45rem 0.6rem; border-radius: 7px; background: rgba(72,163,106,0.12); color: var(--theme-color-status-success, #3c9d63); margin-bottom: 0.7rem; }
		.pf-total-row { display: flex; flex-flow: row wrap; gap: 0.6rem; }
		.pf-total-card { flex: 1 1 240px; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 9px; padding: 0.6rem 0.7rem; }
		.pf-total-name { font-size: 0.8rem; font-weight: 600; margin-bottom: 0.4rem; color: var(--theme-color-text-primary, #1f2733); }
		.pf-total-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem 0.6rem; margin-bottom: 0.5rem; }
		.pf-total-grid > div { display: flex; justify-content: space-between; gap: 0.5rem; font-size: 0.78rem; }
		.pf-total-lbl { color: var(--theme-color-text-muted, #8a94a3); }
		.pf-total-val { font-variant-numeric: tabular-nums; color: var(--theme-color-text-primary, #1f2733); font-weight: 500; }
		.pf-bar { height: 7px; border-radius: 999px; background: var(--theme-color-background-secondary, #f0f2f6); overflow: hidden; }
		.pf-bar-fill { height: 100%; background: var(--theme-color-brand-primary, #156dd1); border-radius: 999px; }
		.pf-bar-fill.is-over { background: var(--theme-color-status-warning, #d99a2b); }
		.pf-bar-lbl { font-size: 0.7rem; color: var(--theme-color-text-muted, #8a94a3); margin-top: 0.25rem; }
		.pf-outcome-row { display: flex; flex-flow: row wrap; gap: 0.7rem 1.5rem; margin-top: 0.8rem; }
		.pf-outcome-row > .pf-outcomes { flex: 1 1 260px; }
		.pf-outcomes-head { font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.3rem; }
		.pf-outcome { display: flex; justify-content: space-between; font-size: 0.8rem; padding: 0.2rem 0; border-bottom: 1px solid var(--theme-color-border-light, #f0f2f6); font-variant-numeric: tabular-nums; }
		.pf-li-panel { margin-top: 0; }
		.pf-li-count { font-size: 0.78rem; color: var(--theme-color-text-muted, #8a94a3); font-weight: 500; }
		.pf-li-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
		.pf-li-table th { text-align: left; font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); padding: 0.4rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.pf-li-table td { padding: 0.4rem 0.6rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
		.pf-li-code { font-variant-numeric: tabular-nums; color: var(--theme-color-text-secondary, #5b6673); white-space: nowrap; }
		.pf-li-name { color: var(--theme-color-text-primary, #1f2733); }
		.pf-li-row.is-uncat td { background: rgba(217, 154, 43, 0.06); }
		.pf-li-badge { margin-left: 0.5rem; font-size: 0.62rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-status-warning, #d99a2b); border: 1px solid var(--theme-color-status-warning, #d99a2b); border-radius: 999px; padding: 0.05rem 0.4rem; }
		.pf-li-cat { width: 100%; max-width: 340px; padding: 0.25rem 0.4rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 6px; font: inherit; font-size: 0.82rem; background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.pf-li-catcell { min-width: 220px; }
		.pf-li-pickmount { width: 100%; max-width: 340px; min-width: 200px; }
		.pf-li-note { text-align: left; margin: 0 0 0.6rem; }
		.pf-co-lock { display: flex; align-items: center; gap: 0.5rem; font-size: 0.86rem; color: #8a5a00; background: rgba(184,134,11,0.12); border: 1px solid rgba(184,134,11,0.25); border-radius: 7px; padding: 0.55rem 0.8rem; margin: 0 0 0.7rem; }

		/* Pick modal */
		.pf-modal-help { font-size: 0.86rem; color: var(--theme-color-text-secondary, #5b6673); margin: 0 0 0.6rem; }
		.pf-pick-list { max-height: 52vh; overflow-y: auto; margin-top: 0.6rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.pf-pick-row { display: flex; align-items: center; gap: 0.6rem; width: 100%; text-align: left; border: none; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-panel, #fff); padding: 0.5rem 0.75rem; cursor: pointer; font: inherit; color: var(--theme-color-text-primary, #1f2733); }
		.pf-pick-row:last-child { border-bottom: none; }
		.pf-pick-row:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.pf-pick-name { flex: 1 1 auto; font-size: 0.88rem; }
		.pf-pick-bal { font-size: 0.72rem; color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; }
	`,

	Templates:
	[
		{
			Hash: 'ProjectFunding-Template',
			Template: html`
				<section class="section {~D:AppData.ProjectFunding.EmbedClass~}">
					<div class="pf-wrap">
						<div class="pf-head">
							<span class="pf-head-ic"><i class="fas fa-scale-balanced"></i></span>
							<div><h1 class="pf-title">{~D:AppData.ProjectFunding.TitleText~}</h1></div>
							{~TS:ProjectFunding-ReadOnly:AppData.ProjectFunding.ReadOnlySlot~}
							<span class="pf-head-spacer"></span>
							<span id="ProjectFunding-HeaderTools" class="pf-head-tools"></span>
							{~TS:ProjectFunding-ChangeProject:AppData.ProjectFunding.ChangeProjectSlot~}
						</div>
						{~TS:ProjectFunding-Loading:AppData.ProjectFunding.LoadingSlot~}
						{~TS:ProjectFunding-Error:AppData.ProjectFunding.ErrorSlot~}
						{~TS:ProjectFunding-Picker:AppData.ProjectFunding.PickerSlot~}
						{~TS:ProjectFunding-Body:AppData.ProjectFunding.BodySlot~}
					</div>
				</section>`,
		},
		{ Hash: 'ProjectFunding-ReadOnly', Template: html`<span class="pf-ro-pill" title="You can view this project’s funding. Configuring it needs the funding entitlement."><i class="fas fa-lock"></i> Read-only</span>` },
		{ Hash: 'ProjectFunding-ChangeProject', Template: html`<button type="button" class="pf-head-btn" onclick="_Pict.views.ProjectFunding.chooseAnotherProject()"><i class="fas fa-arrow-left"></i> Choose another project</button>` },
		{ Hash: 'ProjectFunding-Loading', Template: html`<div class="pf-state"><i class="fas fa-spinner fa-spin"></i> Loading funding…</div>` },
		{ Hash: 'ProjectFunding-Error', Template: html`<div class="pf-state"><i class="fas fa-triangle-exclamation"></i> {~D:Record.Message~}</div>` },
		{
			Hash: 'ProjectFunding-Picker',
			Template: html`
				<div class="pf-picker">
					<input id="ProjectFunding-ProjectFilter" class="pf-proj-filter" type="text" autocomplete="off" placeholder="Filter projects by name…" oninput="_Pict.views.ProjectFunding.onProjectFilter(this.value)" />
					<div id="ProjectFunding-ProjectList" class="pf-proj-list"><div class="pf-note"><i class="fas fa-spinner fa-spin"></i> Loading projects…</div></div>
				</div>`,
		},
		{
			Hash: 'ProjectFunding-Body',
			Template: html`
				<div class="pf-stack">
					<div class="pf-panel pf-acct-panel {~D:AppData.ProjectFunding.AcctClass~}">
						<div class="pf-panel-head pf-acct-head" role="button" tabindex="0" onclick="_Pict.views.ProjectFunding.toggleAccounting()"><i class="fas fa-chart-pie"></i> Accounting overview <span class="pf-head-spacer"></span><span class="pf-acct-caret icon"><i class="fas {~D:AppData.ProjectFunding.AcctChevron~}"></i></span></div>
						<div class="pf-panel-body pf-acct-body"><div id="ProjectFunding-Accounting"></div></div>
					</div>
					<div class="pf-panel">
						<div class="pf-panel-head"><i class="fas fa-sitemap"></i> Funding setup <span class="pf-head-spacer"></span>{~TS:ProjectFunding-AddCatBtn:AppData.ProjectFunding.ManageSlot~}</div>
						<div class="pf-panel-body"><div id="ProjectFunding-Grid"></div></div>
					</div>
					<div class="pf-panel pf-li-panel">
						<div class="pf-panel-head"><i class="fas fa-list-ol"></i> Line item funding <span class="pf-head-spacer"></span><span id="ProjectFunding-LICount" class="pf-li-count"></span></div>
						<div class="pf-panel-body"><div id="ProjectFunding-LineItems"></div></div>
					</div>
				</div>`,
		},
		{ Hash: 'ProjectFunding-AddCatBtn', Template: html`<button type="button" class="pf-tool-btn pf-tool-primary" onclick="_Pict.views.ProjectFunding.addCategory()"><i class="fas fa-plus"></i> Add category</button>` },
	],

	Renderables:
	[
		{ RenderableHash: 'ProjectFundingWrap', TemplateHash: 'ProjectFunding-Template', DestinationAddress: '#PlatformConfiguration-Application-Container' },
	],
};

},{"pict-view":1053}],1465:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libShared = require('./ProjectContractTypes-Shared.js');

/**
 * ProjectTypes — the #/ProjectTypes management screen. A thin view over the shared ProjectContractTypes provider
 * (activated in Project mode). Logic/state live in the provider; this view just lays out the rail/detail shell.
 */
class ProjectTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ProjectContractTypes; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.activate('Project'); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ProjectTypes;
module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectTypes',
	DefaultRenderable: 'ProjectTypesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libShared.CSS,
	Templates:
	[
		{
			Hash: 'ProjectTypes-Wrap',
			Template: libShared.wrapTemplate('Project Types', 'Create and edit project types, then set up each one’s template — statuses, default dates, observation types, labels and more — that new projects are cloned from.'),
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ProjectTypesWrap',
			TemplateHash: 'ProjectTypes-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./ProjectContractTypes-Shared.js":1461,"pict-view":1053}],1466:[function(require,module,exports){
'use strict';

// ProjectWorkspace chrome — the CSS + per-tab templates extracted from the original ProjectWorkspace view so the
// migrated (pict-section-workspace) ProjectWorkspace can register them as ExtraTemplates and paint each tab body
// via pict.parseTemplateByHash, reusing the exact markup verbatim. The shell templates (Wrap/Body/Message/
// Loading/Empty) and the tab bar are owned by the base workspace, so they are intentionally NOT here.

const libLogoSlotController = require('../providers/LogoSlotController.js');
const libLabelManagerController = require('../providers/LabelManagerController.js');
const libLabelBehaviorController = require('../providers/LabelBehaviorController.js');
const libProjectObservationLabelController = require('../providers/ProjectObservationLabelController.js');

const PROJECT_WORKSPACE_CSS = /*css*/`
	/* Data ▸ Observations / Forms lists */
	.pw-data-toolbar { display: flex; align-items: center; gap: 0.85rem; margin: 0 0 0.9rem; }
	.pw-data-search { flex: 1 1 auto; max-width: 32rem; padding: 0.5rem 0.75rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; font: inherit; background: var(--theme-color-background-input, #fff); color: var(--theme-color-text-primary, #1f2733); }
	.pw-data-count { font-size: 0.8rem; color: var(--theme-color-text-muted, #8a94a3); white-space: nowrap; font-variant-numeric: tabular-nums; }
	.pw-data-state { padding: 1.6rem 1rem; text-align: center; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.9rem; }
	.pw-data-tablewrap { overflow-x: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
	.pw-data-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.86rem; }
	.pw-data-table th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); position: sticky; top: 0; }
	.pw-data-table td { padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; }
	.pw-data-table tbody tr:last-child td { border-bottom: none; }
	.pw-data-table tbody tr:hover td { background: var(--theme-color-background-secondary, #f7f9fb); }
	.pw-data-type { white-space: nowrap; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
	.pw-data-name { color: var(--theme-color-text-secondary, #45505f); }
	.pw-data-date { white-space: nowrap; color: var(--theme-color-text-muted, #8a94a3); font-variant-numeric: tabular-nums; }
	.pw-data-status { font-size: 0.76rem; color: var(--theme-color-text-muted, #8a94a3); }
	.pw-data-status.is-set { display: inline-block; padding: 0.12rem 0.5rem; border-radius: 999px; background: var(--theme-color-background-secondary, #eef1f5); color: var(--theme-color-text-secondary, #45505f); font-weight: 600; }
	.pw-data-pager { display: flex; align-items: center; justify-content: flex-end; gap: 0.75rem; margin-top: 0.8rem; }
	.pw-data-pageno { font-size: 0.82rem; color: var(--theme-color-text-muted, #8a94a3); }
	#PW-DataVolumeHost .ao-head, #PW-DataVolumeHost .ao-pickrow { display: none; }
	#PW-DataVolumeHost .ao-wrap { max-width: none; margin: 0; padding: 0; }
	.pw-group-head-row { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; }
	.pw-group-actions { display: inline-flex; align-items: center; gap: 0.5rem; text-transform: none; letter-spacing: normal; }
	.pw-group-actions .button { text-transform: none; letter-spacing: normal; font-weight: 600; }
	.pw-assoc-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; margin: 0 0 0.9rem; }
	.pw-assoc-head .pw-help { flex: 1 1 auto; }
	.pw-assoc-head .button { flex: 0 0 auto; }
	.pw-head-btns { display: inline-flex; gap: 0.4rem; flex: 0 0 auto; }
	.pw-bulkdel-row { display: flex; justify-content: flex-end; }
	.pw-bulkdel-row:empty { display: none; }
	.pw-bulkdel-btn { text-transform: none; letter-spacing: normal; font-weight: 600; }
	.pw-bulk-inline { margin: 0.2rem 0; }
	.pw-rebuild-btn { text-transform: none; letter-spacing: normal; font-weight: 600; }
	.pw-desc { white-space: pre-wrap; font-weight: 500; font-size: 0.98rem; color: var(--theme-color-text-primary, #1f2733); }
	.pw-items-count { display: inline-block; margin-left: 0.4rem; padding: 0.02rem 0.5rem; border-radius: 999px; font-size: 0.72rem; font-weight: 700; background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-secondary, #45505f); }
	.pw-items-note { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.4rem 0; }
	.pw-items-scroll { overflow-x: auto; }
	.pw-items-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
	.pw-items-table th { text-align: left; font-weight: 600; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); padding: 0.4rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); white-space: nowrap; }
	.pw-items-table td { padding: 0.45rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f6); color: var(--theme-color-text-primary, #1f2733); }
	.pw-items-table td.pw-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; white-space: nowrap; }
	.pw-items-table th.pw-num, .pw-items-table td.pw-num { text-align: right; white-space: nowrap; }
	.pw-items-table tbody tr:hover { background: var(--theme-color-background-tertiary, #f4f6f9); }
	.pw-items-table tbody tr.pw-items-clickable { cursor: pointer; }
	.pw-items-table tbody tr.pw-items-clickable:hover { background: color-mix(in srgb, var(--theme-color-brand-primary, #5650e6) 8%, transparent); }
	.pw-loc-head { display: flex; justify-content: space-between; align-items: center; gap: 1rem; margin: 0 0 0.7rem; flex-wrap: wrap; }
	.pw-loc-readout { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); }
	.pw-loc-readout code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.1rem 0.4rem; border-radius: 5px; }
	.pw-loc-search { margin: 0 0 0.8rem; }
	.pw-loc-search-row { display: flex; gap: 0.5rem; align-items: stretch; }
	.pw-addr-input { flex: 1 1 auto; }
	.pw-addr-status { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.4rem 0.2rem 0.1rem; }
	.pw-addr-status-error { color: var(--theme-color-status-error, #cf5b5b); }
	.pw-addr-result { padding: 0.5rem 0.7rem; margin-top: 0.3rem; cursor: pointer; font-size: 0.86rem; color: var(--theme-color-text-secondary, #45505f); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; background: var(--theme-color-background-primary, #fff); }
	.pw-addr-result:hover { background: var(--theme-color-background-tertiary, #f4f6f9); border-color: var(--theme-color-border-default, #d7dce3); }
	.pw-loc-coords { display: flex; gap: 1rem; margin: 0 0 0.6rem; flex-wrap: wrap; }
	.pw-loc-coord { display: flex; flex-direction: column; gap: 0.2rem; }
	.pw-loc-coord > span { font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); }
	.pw-loc-coord .input { max-width: 12rem; }
	.pw-loc-error { color: var(--theme-color-status-error, #cf5b5b); font-size: 0.85rem; margin: 0.3rem 0 0; }
	.pw-map-host { height: 24rem; border-radius: 8px; border: 1px solid var(--theme-color-border-default, #d7dce3); overflow: hidden; }
	.ps-wrap { max-width: 52rem; }
	.ps-note { font-size: 0.88rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.4rem 0; }
	.ps-error { color: var(--theme-color-status-error, #cf5b5b); font-size: 0.85rem; margin: 0.4rem 0; }
	.ps-notice { color: var(--theme-color-status-success, #3c9a5f); font-size: 0.85rem; margin: 0.5rem 0 0; }
	.ps-section { margin: 0 0 1.4rem; }
	.ps-section-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.6rem; display: flex; align-items: center; gap: 0.5rem; }
	.ps-count { background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-text-secondary, #45505f); border-radius: 10px; padding: 0.05rem 0.5rem; font-size: 0.72rem; font-weight: 700; }
	.ps-member { display: flex; align-items: center; gap: 0.85rem; padding: 0.6rem 0.2rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.ps-member.is-busy { opacity: 0.5; pointer-events: none; }
	.ps-member-main { min-width: 12rem; }
	.ps-member-name { font-weight: 600; color: var(--theme-color-text-primary, #232a33); }
	.ps-member-email { font-size: 0.78rem; color: var(--theme-color-text-muted, #6b7686); }
	.ps-roles { flex: 1; display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; }
	.ps-role { display: inline-flex; align-items: center; gap: 0.25rem; background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-text-secondary, #45505f); border-radius: 12px; padding: 0.15rem 0.6rem; font-size: 0.8rem; }
	.ps-role .ps-x { border: none; background: none; cursor: pointer; color: var(--theme-color-text-muted, #6b7686); font-size: 0.95rem; line-height: 1; padding: 0 0 0 0.1rem; }
	.ps-role .ps-x:hover { color: var(--theme-color-status-error, #cf5b5b); }
	.ps-norole { font-size: 0.8rem; color: var(--theme-color-text-muted, #9aa3ad); font-style: italic; }
	.ps-addrole { display: inline-flex; align-items: center; gap: 0.35rem; }
	.ps-userpick { flex: 1 1 100%; min-width: 24rem; }
	.ps-rolepick { display: inline-block; min-width: 18rem; }
	.ps-userpick .pps-panel, .ps-rolepick .pps-panel { min-width: 100%; }
	.ps-userpick .pps-option-label, .ps-rolepick .pps-option-label { white-space: normal; overflow: visible; text-overflow: clip; }
	.ps-add-row { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
	.ps-btn { border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-default, #fff); color: var(--theme-color-text-secondary, #45505f); border-radius: 6px; padding: 0.35rem 0.7rem; font-size: 0.82rem; cursor: pointer; }
	.ps-btn:hover { border-color: var(--theme-color-brand-primary, #5650e6); }
	.ps-btn-sm { padding: 0.2rem 0.5rem; font-size: 0.78rem; }
	.ps-btn-primary { background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); color: #fff; }
	.ps-icon { border: none; background: none; cursor: pointer; color: var(--theme-color-text-muted, #6b7686); font-size: 0.95rem; padding: 0.2rem 0.4rem; }
	.ps-icon-x:hover { color: var(--theme-color-status-error, #cf5b5b); }
	.ps-busy { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); font-style: italic; }
	.pw-defaults { margin: 0 0 1rem; }
	.pw-defaults-banner { display: flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-selected, #eef1f8); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.6rem 0.85rem; margin: 0 0 0.7rem; line-height: 1.5; }
	.pw-defaults-banner .icon { color: var(--theme-color-brand-primary, #5650e6); flex: 0 0 auto; }
	.pw-defaults-table { width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
	.pw-defaults-table th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.4rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.pw-defaults-table td { padding: 0.4rem 0.8rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); }
	.pw-defaults-table tbody tr:last-child td { border-bottom: none; }
	.pw-defaults-name { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
	.pw-defaults-mode { white-space: nowrap; }
	${ libLogoSlotController.LOGO_SLOT_CSS }
	${ libLabelManagerController.LABEL_CSS }
	${ libLabelBehaviorController.LABELBEHAVIOR_CSS }
	${ libProjectObservationLabelController.OBSLABEL_CSS }
	.pw-label-types { margin-top: 1.4rem; border-top: 1px solid var(--theme-color-border-light, #e8ebf0); padding-top: 0.4rem; }
	.pw-label-types > summary { cursor: pointer; font-weight: 650; color: var(--theme-color-text-secondary, #45505f); padding: 0.5rem 0.2rem; list-style: none; display: flex; align-items: center; gap: 0.4rem; }
	.pw-label-types > summary::-webkit-details-marker { display: none; }
	.pw-label-types > summary::before { content: '▸'; font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); transition: transform 0.15s ease; }
	.pw-label-types[open] > summary::before { transform: rotate(90deg); }
	.pw-label-types-body { padding: 0.2rem 0.2rem 0.4rem; }
	.pw-label-types-sub { font-weight: 400; color: var(--theme-color-text-muted, #6b7686); font-size: 0.85em; }
`;

const PROJECT_WORKSPACE_TEMPLATES =
[
	{ Hash: 'ProjectWorkspace-Overview', Template: /*html*/`
		{~TS:ProjectWorkspace-Group:AppData.ProjectWorkspace.Groups~}
		{~TS:ProjectWorkspace-Description:AppData.ProjectWorkspace.DescriptionSlot~}
		{~TS:ProjectWorkspace-CustomJSON:AppData.ProjectWorkspace.CustomJSONSlot~}` },
	{ Hash: 'ProjectWorkspace-Group', Template: /*html*/`
		<div class="pw-group">
			<div class="pw-group-head pw-group-head-row"><span>{~D:Record.Name~}</span>{~TS:ProjectWorkspace-FinancialsActions:Record.ActionsSlot~}</div>
			<div class="pw-grid">{~TS:ProjectWorkspace-Field:Record.Fields~}</div>
		</div>` },
	{ Hash: 'ProjectWorkspace-FinancialsActions', Template: /*html*/`
		<span class="pw-group-actions">
			{~TS:ProjectWorkspace-GroupBusy:Record.BusySlot~}
			<button class="button is-small is-link is-light" {~D:Record.DisabledAttr~} title="{~D:Record.Title~}" onclick="_Pict.providers.ProjectWorkspace.calculateInitialContractAmountAsync()"><span class="icon">{~I:Refresh~}</span><span>Calculate initial contract</span></button>
		</span>` },
	{ Hash: 'ProjectWorkspace-GroupBusy', Template: /*html*/`<span class="pw-spinner pw-spinner-inline"></span>` },
	{ Hash: 'ProjectWorkspace-Field', Template: /*html*/`
		<div class="pw-field {~D:Record.WideClass~}">
			<span class="pw-field-label">{~D:Record.Label~}</span>
			<span class="pw-field-value {~D:Record.MonoClass~}">{~RecordCard:Record.CardRecordSet^Record.CardID^Record.Value~}</span>
		</div>` },
	{ Hash: 'ProjectWorkspace-LineItems', Template: /*html*/`
		<div class="pw-group">
			<div class="pw-group-head pw-group-head-row"><span>Line Items <span class="pw-items-count">{~D:Record.CountLabel~}</span></span><span class="pw-head-btns"><button class="button is-small is-light pw-rebuild-btn" title="Rebuild this project’s line-item tag index from its current items" onclick="_Pict.providers.ProjectWorkspace.rebuildTags('LineItem')"><span class="icon"><i class="fas fa-rotate"></i></span><span>Rebuild tags</span></button>{~TS:ProjectWorkspace-BulkDeleteBtn:Record.BulkDeleteSlot~}</span></div>
			{~TS:ProjectWorkspace-ItemsLoading:Record.LoadingSlot~}
			{~TS:ProjectWorkspace-ItemsEmpty:Record.EmptySlot~}
			{~TS:ProjectWorkspace-LineItemsTable:Record.TableSlot~}
		</div>` },
	{ Hash: 'ProjectWorkspace-LineItemsTable', Template: /*html*/`<div class="pw-items-scroll"><table class="pw-items-table"><thead><tr><th>Item Code</th><th>Description</th><th>Units</th><th class="pw-num">Contract Qty</th><th class="pw-num">Unit Cost</th></tr></thead><tbody>{~TS:ProjectWorkspace-LineItemRow:Record.LineRows~}</tbody></table></div>` },
	{ Hash: 'ProjectWorkspace-LineItemRow', Template: /*html*/`<tr class="pw-items-clickable" title="Open this line item to manage its bid item, contractors, and materials" onclick="window.location.hash='#/PSRS/LineItem/View/{~D:Record.GUID~}'"><td class="pw-mono">{~D:Record.Code~}</td><td>{~D:Record.Name~}</td><td>{~D:Record.Units~}</td><td class="pw-num">{~D:Record.Quantity~}</td><td class="pw-num">{~D:Record.UnitCost~}</td></tr>` },
	{ Hash: 'ProjectWorkspace-BidItems', Template: /*html*/`
		<div class="pw-group">
			<div class="pw-group-head pw-group-head-row"><span>Bid Items <span class="pw-items-count">{~D:Record.CountLabel~}</span></span><span class="pw-head-btns"><button class="button is-small is-light pw-rebuild-btn" title="Rebuild this project’s bid-item tag index from its current items" onclick="_Pict.providers.ProjectWorkspace.rebuildTags('BidItem')"><span class="icon"><i class="fas fa-rotate"></i></span><span>Rebuild tags</span></button>{~TS:ProjectWorkspace-BulkDeleteBtn:Record.BulkDeleteSlot~}</span></div>
			{~TS:ProjectWorkspace-ItemsLoading:Record.LoadingSlot~}
			{~TS:ProjectWorkspace-ItemsEmpty:Record.EmptySlot~}
			{~TS:ProjectWorkspace-BidItemsTable:Record.TableSlot~}
		</div>` },
	{ Hash: 'ProjectWorkspace-BidItemsTable', Template: /*html*/`<div class="pw-items-scroll"><table class="pw-items-table"><thead><tr><th>Name</th><th>Units</th><th class="pw-num">Quantity</th><th class="pw-num">Unit Cost</th></tr></thead><tbody>{~TS:ProjectWorkspace-BidItemRow:Record.BidRows~}</tbody></table></div>` },
	{ Hash: 'ProjectWorkspace-BidItemRow', Template: /*html*/`<tr class="pw-items-clickable" title="Open this bid item to manage its line items and contractor" onclick="window.location.hash='#/PSRS/BidItem/View/{~D:Record.GUID~}'"><td>{~D:Record.Name~}</td><td>{~D:Record.Units~}</td><td class="pw-num">{~D:Record.Quantity~}</td><td class="pw-num">{~D:Record.UnitCost~}</td></tr>` },
	{ Hash: 'ProjectWorkspace-BulkDeleteBtn', Template: /*html*/`<button class="button is-small is-danger is-light pw-bulkdel-btn" onclick="_Pict.providers.ProjectWorkspace.openBulkDelete('{~D:Record.Key~}')"><span class="icon"><i class="fas fa-trash"></i></span><span>{~D:Record.Label~}</span></button>` },
	{ Hash: 'ProjectWorkspace-BulkInline', Template: /*html*/`<div id="PW-BulkInlineHost" class="pw-bulk-inline"></div>` },
	{ Hash: 'ProjectWorkspace-ItemsLoading', Template: /*html*/`<div class="pw-items-note">Loading…</div>` },
	{ Hash: 'ProjectWorkspace-ItemsEmpty', Template: /*html*/`<div class="pw-items-note">No items associated with this project.</div>` },
	{ Hash: 'ProjectWorkspace-Description', Template: /*html*/`<div class="pw-group"><div class="pw-group-head">Description</div><div class="pw-desc">{~D:Record.Description~}</div></div>` },
	{ Hash: 'ProjectWorkspace-CustomJSON', Template: /*html*/`<div class="pw-group"><div class="pw-group-head">Custom Properties</div><div id="PW-CustomPropsHost" class="pw-objecteditor-host"></div></div>` },
	{ Hash: 'ProjectWorkspace-Location', Template: /*html*/`
		<div class="pw-loc-search">
			<div class="pw-loc-search-row">
				<input id="PW-AddressInput" class="input pw-addr-input" type="text" placeholder="Search an address or place…" autocomplete="off"
					onkeydown="if (event.key === 'Enter') { event.preventDefault(); _Pict.providers.ProjectWorkspace.searchAddressAsync(); }" />
				<button class="button is-light" onclick="_Pict.providers.ProjectWorkspace.searchAddressAsync()"><span class="icon">{~I:Search~}</span><span>Search</span></button>
			</div>
			<div id="PW-AddressResults">{~T:ProjectWorkspace-AddressResults~}</div>
		</div>
		<div class="pw-loc-coords">
			<label class="pw-loc-coord"><span>Latitude</span>
				<input id="PW-LatInput" class="input" type="number" step="any" placeholder="—" value="{~D:AppData.ProjectWorkspace.CenterLatInput~}"
					onchange="_Pict.providers.ProjectWorkspace.setCenterFromText(this.value, (document.getElementById('PW-LngInput')||{}).value)" /></label>
			<label class="pw-loc-coord"><span>Longitude</span>
				<input id="PW-LngInput" class="input" type="number" step="any" placeholder="—" value="{~D:AppData.ProjectWorkspace.CenterLngInput~}"
					onchange="_Pict.providers.ProjectWorkspace.setCenterFromText((document.getElementById('PW-LatInput')||{}).value, this.value)" /></label>
		</div>
		<div id="PW-LocControls">{~T:ProjectWorkspace-LocControls~}</div>
		<div id="PW-MapHost" class="pw-map-host"></div>
		<p class="pw-help">Search an address, type coordinates, or click the map / drag the marker to set this project’s geographic center, then Save.</p>` },
	{ Hash: 'ProjectWorkspace-LocControls', Template: /*html*/`
		<div class="pw-loc-head">
			<div class="pw-loc-readout">Geographic center: <code>{~D:AppData.ProjectWorkspace.CenterSummary~}</code></div>
			{~TS:ProjectWorkspace-CenterSave:AppData.ProjectWorkspace.CenterSaveSlot~}
		</div>
		{~TS:ProjectWorkspace-LocError:AppData.ProjectWorkspace.LocErrorSlot~}` },
	{ Hash: 'ProjectWorkspace-LocError', Template: /*html*/`<p class="pw-loc-error">{~D:Record.Text~}</p>` },
	{ Hash: 'ProjectWorkspace-AddressResults', Template: /*html*/`{~TS:ProjectWorkspace-AddressStatus:AppData.ProjectWorkspace.AddressStatusSlot~}{~TS:ProjectWorkspace-AddressResult:AppData.ProjectWorkspace.AddressResultSlot~}` },
	{ Hash: 'ProjectWorkspace-AddressStatus', Template: /*html*/`<div class="pw-addr-status {~D:Record.ErrorClass~}">{~D:Record.Text~}</div>` },
	{ Hash: 'ProjectWorkspace-AddressResult', Template: /*html*/`<div class="pw-addr-result" onclick="_Pict.providers.ProjectWorkspace.chooseAddressResult({~D:Record.Index~})">{~D:Record.DisplayName~}</div>` },
	{ Hash: 'ProjectWorkspace-CenterSave', Template: /*html*/`<button class="button is-link" {~D:AppData.ProjectWorkspace.SaveDisabledAttr~} onclick="_Pict.providers.ProjectWorkspace.saveCenterAsync()"><span class="icon">{~I:Save~}</span><span>Save center</span></button>` },
	{ Hash: 'ProjectWorkspace-Branding', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 1rem">Logos for this project. A project logo overrides the customer logo where Headlight shows project branding.</p>
		{~TS:Headlight-LogoSlot:AppData.ProjectWorkspace.LogoSlots~}` },
	{ Hash: 'ProjectWorkspace-Labels', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Labels for this project — the tags observations can be marked with. Pick a type and enter a label to add one (use <code>|</code> to add several at once), or open <strong>Bulk add labels of a type</strong> to paste a whole list.</p>
		<div class="pw-bulkdel-row">{~TS:ProjectWorkspace-BulkDeleteBtn:AppData.ProjectWorkspace.BulkDelLabelSlot~}</div>
			<div id="PW-ObsLabelHost">{~TS:Headlight-ObsLabelManager:AppData.ProjectWorkspace.ObsLabelStateSlot~}</div>
		<details class="pw-label-types">
			<summary>Label types</summary>
			<div class="pw-label-types-body">
				<p class="pw-help" style="margin:0 0 0.8rem">The categories labels fall into — these populate the <strong>Type</strong> dropdown above. “Copy customer defaults” seeds this project with your organization’s default set.</p>
				{~TS:Headlight-LabelManager:AppData.ProjectWorkspace.LabelStateSlot~}
			</div>
		</details>
		<details class="pw-label-types pw-label-behaviors">
			<summary>Label behavior <span class="pw-label-types-sub">— per observation type</span></summary>
			<div class="pw-label-types-body">
				<p class="pw-help" style="margin:0 0 0.8rem">How each label behaves during entry for a chosen observation type — <strong>deny free entry</strong> (must pick from the list), a <strong>max per observation</strong>, or <strong>hide</strong> it from entry. <strong>Auto-Filter</strong> narrows each label’s list by the labels already chosen. Changes save immediately and sync to the field apps.</p>
				<div id="PW-LabelBehaviorHost">{~TS:Headlight-LabelBehavior:AppData.ProjectWorkspace.LabelBehaviorStateSlot~}</div>
			</div>
		</details>` },
	{ Hash: 'ProjectWorkspace-Observations', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Observation types associated with this project. Choose Journal or Spreadsheet and order per type; adding a type — or “Customize Defaults” — seeds this project from the customer set.</p>
		{~TS:ProjectWorkspace-ObsDefaults:AppData.ProjectWorkspace.ObsDefaultsSlot~}
		<div id="PW-ObsHost"></div>` },
	{ Hash: 'ProjectWorkspace-Equipment', Template: /*html*/`
		<div class="pw-assoc-head">
			<p class="pw-help" style="margin:0">Equipment on this project and the <strong>contractors</strong> that operate each piece. Click a contractor chip to link or unlink it; a piece of equipment can have several contractors. Use <strong>+ Add equipment</strong> to put equipment on the project, then Save.</p>
			<span class="pw-head-btns"><button class="button is-small is-light" title="Rebuild this project’s equipment tag index from its current links" onclick="_Pict.providers.ProjectWorkspace.rebuildTags('Equipment')"><span class="icon"><i class="fas fa-rotate"></i></span><span>Rebuild tags</span></button></span>
		</div>
		<div id="PW-EquipmentContractorHost"></div>` },
	{ Hash: 'ProjectWorkspace-Lab', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Testing labs associated with this project. Add or remove a lab link.</p>
		<div id="PW-LabHost"></div>` },
	{ Hash: 'ProjectWorkspace-Organization', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Contractors (external organizations) linked to this project. Add or remove a contractor, and toggle <strong>DBE</strong> to mark a Disadvantaged Business Enterprise.</p>
		<div id="PW-OrgHost"></div>` },
	{ Hash: 'ProjectWorkspace-Contact', Template: /*html*/`
		<div class="pw-assoc-head">
			<p class="pw-help" style="margin:0">Personnel linked to this project — the contacts used for certified payroll and similar reporting. Add or remove a person.</p>
			<span class="pw-head-btns"><button class="button is-small is-light" title="Rebuild this project’s personnel tag index from its current links" onclick="_Pict.providers.ProjectWorkspace.rebuildTags('Contact')"><span class="icon"><i class="fas fa-rotate"></i></span><span>Rebuild tags</span></button>{~TS:ProjectWorkspace-BulkDeleteBtn:AppData.ProjectWorkspace.BulkDelContactSlot~}</span>
		</div>
		<div id="PW-ContactHost"></div>` },
	{ Hash: 'ProjectWorkspace-LineContractors', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Contractors on each of this project’s line items. Click a contractor chip to link or unlink it; toggle <strong>DBE</strong> to mark a Disadvantaged Business Enterprise. Use <strong>+ contractor</strong> to add one not yet on the project, then Save.</p>
		<div id="PW-LineContractorHost"></div>` },
	{ Hash: 'ProjectWorkspace-BidContractors', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Contractors on each of this project’s bid items. Click a contractor chip to link or unlink it; toggle <strong>DBE</strong> to mark a Disadvantaged Business Enterprise. Use <strong>+ contractor</strong> to add one not yet on the project, then Save.</p>
		<div id="PW-BidContractorHost"></div>` },
	{ Hash: 'ProjectWorkspace-BidItemMap', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Map each of this project’s line items to a bid item. Pick a bid item per row (searchable), then Save — changes are written to <strong>LineItem.IDBidItem</strong>.</p>
		<div id="PW-BidItemMapHost"></div>` },
	{ Hash: 'ProjectWorkspace-Dates', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">Milestone dates for this project — the set expected by its type, plus any you add. Set a date and Save each row.</p>
		<div id="PW-DatesHost"></div>` },
	{ Hash: 'ProjectWorkspace-Staffing', Template: /*html*/`
		<p class="pw-help" style="margin:0 0 0.8rem">The people assigned to this project and their project role (PE, Assistant PE, Contractor Approver, ADA, HQ AE, …). Add a user with a role, or adjust roles per member.</p>
		<div id="PW-StaffingHost"></div>` },
	{ Hash: 'ProjectWorkspace-Funding', Template: /*html*/`<div id="PW-FundingHost"></div>` },
	{ Hash: 'ProjectWorkspace-ChangeOrders', Template: /*html*/`<div id="PW-ChangeOrdersHost"></div>` },
	{ Hash: 'ProjectWorkspace-SamplePlan', Template: /*html*/`<div id="PW-SamplePlanHost"></div>` },
	{ Hash: 'ProjectWorkspace-SamplePlanDashboard', Template: /*html*/`<div id="PW-SamplePlanDashboardHost"></div>` },
	{ Hash: 'ProjectWorkspace-DataObs', Template: /*html*/`<div id="PW-DataObsHost"></div>` },
	{ Hash: 'ProjectWorkspace-DataForms', Template: /*html*/`<div id="PW-DataFormsHost"></div>` },
	{ Hash: 'ProjectWorkspace-Files', Template: /*html*/`<div id="PW-FilesHost"></div>` },
	{ Hash: 'ProjectWorkspace-BulkUpload', Template: /*html*/`<div id="PW-BulkUploadHost"></div>` },
	{ Hash: 'ProjectWorkspace-DataVolume', Template: /*html*/`<div id="PW-DataVolumeHost"></div>` },
	{ Hash: 'ProjectWorkspace-ObsDefaults', Template: /*html*/`
		<div class="pw-defaults">
			<div class="pw-defaults-banner"><span class="icon"><i class="fas fa-circle-info"></i></span><span>Showing your organization’s default observation types — this project hasn’t customized its own yet. Adding any type below — or “Customize Defaults” — seeds this project with them.</span></div>
			<table class="pw-defaults-table"><thead><tr><th>Observation type</th><th>Mode</th></tr></thead><tbody>{~TS:ProjectWorkspace-ObsDefaultRow:AppData.ProjectWorkspace.ObsDefaults~}</tbody></table>
		</div>` },
	{ Hash: 'ProjectWorkspace-ObsDefaultRow', Template: /*html*/`<tr><td class="pw-defaults-name">{~D:Record.Name~}</td><td class="pw-defaults-mode">{~D:Record.Modes~}</td></tr>` },
].concat(libLogoSlotController.LOGO_SLOT_TEMPLATES, libLabelManagerController.LABEL_TEMPLATES, libLabelBehaviorController.LABELBEHAVIOR_TEMPLATES, libProjectObservationLabelController.OBSLABEL_TEMPLATES);

module.exports = { PROJECT_WORKSPACE_CSS, PROJECT_WORKSPACE_TEMPLATES };

},{"../providers/LabelBehaviorController.js":1344,"../providers/LabelManagerController.js":1345,"../providers/LogoSlotController.js":1348,"../providers/ProjectObservationLabelController.js":1364}],1467:[function(require,module,exports){
'use strict';

/**
 * Read-view tab-bar decoration — render the GENERIC pict-section-recordset read view (RSP-RecordSet-Read) tab
 * strip with the app's shared TabBar LOOK (compact underline-active tabs + FontAwesome icons + horizontal-scroll
 * overflow) instead of the boxy `.psrs-tab` pills, so every master-list read view (Line Item, Material, Lab,
 * Sample, TestSpecificationSet, …) matches the bespoke workspaces (Project / User / Access / Contract …) that
 * already use `views/TabBar.js`. App-side, best-effort, NO node_module edits — same pattern as
 * Association-Chip-Decoration.js.
 *
 * SEAM: RecordSet-Read renders each tab from `tab.TabTemplate` (an HTML string built in `_structureTabs`) joined
 * into `<div id="PRSP-Read-Tab-Nav">` (RecordSet-Read.js renderRead). `setTab` toggles `.is-active` on the
 * elements matched by `document.querySelectorAll('.psrs-tab')` + the id `PSRS-TabNav-<Hash>`. So we wrap
 * `_structureTabs` and rewrite ONLY each tab's `TabTemplate` into a button that KEEPS `class="psrs-tab"` and
 * `id="PSRS-TabNav-<Hash>"` (so `setTab` needs NO patch) and adds an icon + label span. The underline look is
 * applied by the CSS block injected in PlatformConfiguration-Application-Web.js (scoped under the app container
 * id so it outranks the `.psrs-split-tabnav` pill rules by specificity). Everything else on the tab
 * (`Template` / `Hash` / `render` / `Type`) is left untouched, so the body + render pipeline is unchanged.
 *
 * MIGRATION: this is a PROTOTYPE to prove the look on the generic read view before lifting it upstream into
 * pict-section-recordset itself (RecordSet-Read._structureTabs emitting `.hltab` markup + carrying TabBar's CSS).
 * When that lands: delete this module + its wiring + the injected CSS block; the markup here mirrors TabBar.js's
 * `.hltab` item (icon span + `.hltab-label`) precisely to make that port a drop-in. See TabBar.js.
 */

// Per-tab-TYPE fallback icon (RecordSetReadTabs entries carry a Type; FullRecord/Record are the record itself,
// Association = a join editor, View = a filtered child list). A curated per-entity icon could later be threaded
// through MasterList-Builder.buildReadTabs, but the type-level default already gives every tab a meaningful glyph.
const ICON_BY_TYPE =
{
	FullRecord: 'fas fa-file-lines',
	Record: 'fas fa-file-lines',
	Association: 'fas fa-link',
	View: 'fas fa-list',
	Manifest: 'fas fa-file-lines',
	AttachedRecord: 'fas fa-paperclip',
};
const ICON_DEFAULT = 'fas fa-folder';

function _escapeAttr(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) =>
		({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
}

/**
 * Build the shared-TabBar button markup for one tab, preserving the `.psrs-tab` + `PSRS-TabNav-<Hash>` hooks the
 * module's `setTab` drives. `hltab has-icon` is carried as a forward marker for the eventual PSRS migration; the
 * active styling is applied by the app-side CSS block via the `.psrs-tab` / `.is-active` classes.
 * @param {{Hash:String, Title:String, Type?:String, Icon?:String}} pTab
 * @returns {String}
 */
function readTabTemplate(pTab)
{
	const tmpHash = _escapeAttr(pTab.Hash);
	const tmpTitle = _escapeAttr(pTab.Title);
	const tmpIcon = _escapeAttr(pTab.Icon || ICON_BY_TYPE[pTab.Type] || ICON_DEFAULT);
	// navigateTab (not setTab) so the read view's tab is a stable, deep-linkable route
	// (#/PSRS/<RecordSet>/View/<GUID>/<Tab>) — added upstream in pict-section-recordset 1.25.13.
	return `<button type="button" class="psrs-tab hltab has-icon" id="PSRS-TabNav-${ tmpHash }" title="${ tmpTitle }" onclick="_Pict.views['RSP-RecordSet-Read'].navigateTab('${ tmpHash }')"><span class="icon"><i class="${ tmpIcon }"></i></span><span class="hltab-label">${ tmpTitle }</span></button>`;
}

/**
 * Wrap the read view's `_structureTabs` so every tab renders with the shared TabBar look. Idempotent; best-effort
 * per tab (a rewrite failure keeps that tab's original TabTemplate, so a bad tab never blanks the whole strip).
 * @param {any} pReadView - the `RSP-RecordSet-Read` view instance.
 * @returns {Boolean} true when the wrap is in place after this call.
 */
function patchReadViewTabBar(pReadView)
{
	if (!pReadView || (typeof pReadView._structureTabs !== 'function')) { return false; }
	if (pReadView.__readViewTabBarPatched) { return true; }
	pReadView.__readViewTabBarPatched = true;
	const fOriginal = pReadView._structureTabs.bind(pReadView);
	pReadView._structureTabs = async function (pConfig, pRecord)
	{
		const tmpTabs = await fOriginal(pConfig, pRecord);
		if (Array.isArray(tmpTabs))
		{
			tmpTabs.forEach((pTab) =>
			{
				try { if (pTab && pTab.Hash) { pTab.TabTemplate = readTabTemplate(pTab); } }
				catch (pError) { /* keep this tab's original TabTemplate — never break the tab strip */ }
			});
		}
		return tmpTabs;
	};
	return true;
}

/**
 * Give the read view's tab strip the shared TabBar "More ▾" overflow behaviour (the `hltabs--menu` strategy the
 * bespoke workspaces use): tabs that don't fit collapse into a right-aligned dropdown instead of scrolling off
 * unreachably. After each `setTab` (which the module also calls once on first paint), we tag `#PRSP-Read-Tab-Nav`
 * as an `.hltabs--menu` bar and let `TabBar.layout` partition it — on a rAF so widths are measured post-layout.
 * Idempotent; best-effort. Requires `TabBar.TABBAR_CSS` to be injected (for `.hltabs-more` / `.is-overflow`).
 * @param {any} pReadView - the `RSP-RecordSet-Read` view instance.
 * @param {{layout:Function}} pLibTabBar - the `views/TabBar.js` module.
 * @returns {Boolean} true when the wrap is in place after this call.
 */
function wrapReadViewMenuOverflow(pReadView, pLibTabBar)
{
	if (!pReadView || !pLibTabBar || (typeof pReadView.setTab !== 'function') || (typeof pLibTabBar.layout !== 'function')) { return false; }
	if (pReadView.__readViewMenuOverflowWrapped) { return true; }
	pReadView.__readViewMenuOverflowWrapped = true;
	const fRelayout = () =>
	{
		try
		{
			if (typeof document === 'undefined') { return; }
			const tmpNav = document.getElementById('PRSP-Read-Tab-Nav');
			if (!tmpNav) { return; }
			tmpNav.classList.add('hltabs', 'hltabs--menu');
			// Measure after the browser has laid the row out (offsetLeft/clientWidth) rather than mid-mutation.
			if ((typeof window !== 'undefined') && window.requestAnimationFrame)
			{
				window.requestAnimationFrame(() => { try { pLibTabBar.layout(document); } catch (pInner) { /* best-effort */ } });
			}
			else { pLibTabBar.layout(document); }
		}
		catch (pError) { /* overflow handling is best-effort — never break the tab bar */ }
	};
	const fOriginalSetTab = pReadView.setTab.bind(pReadView);
	pReadView.setTab = async function (pTab)
	{
		const tmpResult = await fOriginalSetTab(pTab);
		fRelayout();
		return tmpResult;
	};
	return true;
}

module.exports = { patchReadViewTabBar, wrapReadViewMenuOverflow, readTabTemplate, ICON_BY_TYPE };

},{}],1468:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * RecordDates — the standalone container for the Project/Contract important-dates editor. All logic/state live in the
 * RecordDates provider, which renders hand-built HTML into #RecordDates-Host (the route handler calls openAsync after
 * this view mounts). The same provider also renders into a workspace tab host via openInto().
 */
class RecordDates extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.RecordDates; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider && (this.pict.AppData.RecordDates)) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = RecordDates;
module.exports.default_configuration =
{
	ViewIdentifier: 'RecordDates',
	DefaultRenderable: 'RecordDatesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.rd-wrap { padding: 1.1rem 1.25rem 1.5rem; max-width: 52rem; }
		.rd-head { margin: 0 0 1.1rem; border-bottom: 1px solid var(--theme-color-border-light,#eef1f6); padding-bottom: 0.7rem; }
		.rd-eyebrow { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#8894a4); }
		.rd-title { font-size:1.3rem; font-weight:700; line-height:1.2; color:var(--theme-color-text-primary,#1f2733); margin-top:0.15rem; }
		.rd-sub { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.rd-section { margin: 0 0 1.2rem; }
		.rd-section-head { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.5rem; }
		.rd-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.6rem; }
		.rd-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); }
		.rd-row { display:flex; align-items:center; flex-wrap:wrap; gap:0.6rem; padding:0.35rem 0; border-bottom:1px solid var(--theme-color-border-light,#f0f2f6); }
		.rd-row-name { flex:1 1 15rem; min-width:0; font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); display:flex; align-items:center; gap:0.4rem; }
		.rd-row-nameinput { flex:1 1 12rem; min-width:0; font-size:0.88rem; font-weight:600; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.rd-row-code { flex:0 0 7rem; font-size:0.82rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-input,#fff); }
		.rd-date { flex:0 0 auto; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.rd-date-disp { flex:0 0 auto; font-size:0.86rem; color:var(--theme-color-text-primary,#1f2733); min-width:6.5rem; }
		.rd-muted { color:var(--theme-color-text-muted,#8894a4); }
		.rd-new-name { flex:1 1 12rem; min-width:0; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
		.rd-new-code { flex:0 0 8rem; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
		.rd-code { font-size:0.66rem; font-weight:700; letter-spacing:0.02em; padding:0.06rem 0.4rem; border-radius:9px; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#e2e7ef); }
		.rd-chip { font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.06rem 0.4rem; border-radius:9px; }
		.rd-chip-set { color:#276749; background:#e6f4ea; }
		.rd-chip-missing { color:#6b7686; background:#eef1f6; }
		.rd-chip-adhoc { color:#8a6d1b; background:#fbf3d9; }
		.rd-btn { font-size:0.8rem; font-weight:600; padding:0.32rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.rd-btn-sm { padding:0.24rem 0.55rem; font-size:0.78rem; }
		.rd-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.rd-btn-danger { color:#fff; background:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.rd-icon { border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); border-radius:5px; cursor:pointer; font-size:0.8rem; line-height:1; padding:0.24rem 0.45rem; color:var(--theme-color-text-secondary,#45505f); }
		.rd-icon-x:hover { color:var(--theme-color-status-danger,#c0392b); }
		.rd-confirm { font-size:0.8rem; color:var(--theme-color-text-secondary,#45505f); display:inline-flex; align-items:center; gap:0.3rem; }
		.rd-row-err { font-size:0.78rem; color:var(--theme-color-status-danger,#c0392b); }
		.rd-sched-opts { display:flex; align-items:center; gap:1.2rem; flex-wrap:wrap; }
		.rd-radio { font-size:0.88rem; color:var(--theme-color-text-primary,#1f2733); display:inline-flex; align-items:center; gap:0.4rem; }
		.rd-sched-notice { font-size:0.78rem; color:#276749; }
		.rd-section-contract { margin-top:1.4rem; padding-top:1rem; border-top:1px dashed var(--theme-color-border-medium,#d5dbe3); }
		.rd-sub-inline { font-size:0.68rem; font-weight:600; text-transform:none; letter-spacing:0; color:var(--theme-color-text-muted,#8894a4); margin-left:0.35rem; }
		.rd-sub-inline a { color:var(--theme-color-primary,#2f6fed); }
		.rd-row-readonly { opacity:0.95; }
		.rd-chip-src-project { color:#1f5fbf; background:#e7eefb; }
		.rd-chip-src-contract { color:#6b3fa0; background:#efe8f7; }
	`,
	Templates:
	[
		{
			Hash: 'RecordDates-Wrap',
			Template: /*html*/`<div id="RecordDates-Host"></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'RecordDatesWrap',
			TemplateHash: 'RecordDates-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1469:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * RoleClone — the #/RoleClone screen: pick a SOURCE role, choose what carries over (grants / edges), name
 * the NEW role, optionally retarget the customer (super-users, to localise a global template), then run the
 * clone with a modal confirm. The modern replacement for copy/pasting a role's grants by hand. All state
 * lives in AppData.RoleClone; behaviour in the RoleCloneProvider.
 */
class RoleClone extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.RoleCloneProvider;
	}

	onBeforeRender(pRenderable)
	{
		if (this.provider) { this.provider.deriveRenderState(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		// (Re)mount the searchable source-role picker into its fresh mount each render (the whole wrap repaints on
		// every action). Replaces the old capped `Roles/…/0/1000` preload + <select>, which hid roles past the cap.
		if (tmpProvider) { tmpProvider.mountSourcePicker(); }
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_repaint() { this.render(); }

	_toast(pMessage, pType)
	{
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function') { tmpModal.toast(pMessage, { type: pType || 'success' }); }
	}

	selectSource(pValue) { this.provider.selectSourceAsync(pValue).then(() => this._repaint()); }
	setField(pField, pValue) { this.provider.setField(pField, pValue); this._repaint(); }
	toggleInclude(pField) { this.provider.toggleInclude(pField); this._repaint(); }

	back() { window.location.hash = '#/Access'; }

	apply()
	{
		const tmpProvider = this.provider;
		const tmpState = tmpProvider.state;
		if (!tmpState.SourceRole || !String(tmpState.NewName || '').trim())
		{
			tmpState.Message = 'Choose a source role and enter a name for the new role.';
			this._repaint();
			return;
		}
		const tmpParts = [];
		if (tmpState.IncludeGrants) { tmpParts.push('its permission grants'); }
		if (tmpState.IncludeEdges) { tmpParts.push('its included roles/groups'); }
		const tmpWhat = tmpParts.length ? tmpParts.join(' and ') : 'no grants or edges (an empty role)';
		const tmpMessage = `Create a new role “${String(tmpState.NewName).trim()}” copying ${tmpWhat} from “${tmpState.SourceRole.Name}”? The new role has no members until you assign it.`;
		const fApply = () => tmpProvider.cloneAsync().then((pResult) =>
		{
			this._repaint();
			if (pResult) { this._toast(`Cloned — ${pResult.Succeeded} created, ${pResult.Failed} failed`, pResult.Failed ? 'error' : 'success'); }
		});
		const tmpModal = this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm(tmpMessage, { title: 'Clone role', confirmLabel: 'Clone role', cancelLabel: 'Cancel' })
				.then((pOk) => { if (pOk) { fApply(); } });
		}
		else
		{
			fApply();
		}
	}
}

module.exports = RoleClone;

module.exports.default_configuration =
{
	ViewIdentifier: 'RoleClone',
	DefaultRenderable: 'RoleCloneWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.rc-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 60rem; }
		.rc-head { display:flex; justify-content:space-between; align-items:flex-start; gap:1rem; margin:0 0 1rem; }
		.rc-title { font-size:1.5rem; font-weight:700; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.rc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.rc-grid { display:grid; grid-template-columns:1fr 1fr; gap:1rem; }
		@media (max-width: 760px) { .rc-grid { grid-template-columns:1fr; } }
		.rc-card { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.9rem 1.1rem; }
		.rc-card-head { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-brand-primary,#2e7d74); margin:0 0 0.7rem; }
		.rc-field { margin:0 0 0.6rem; }
		.rc-label { display:block; font-size:0.68rem; font-weight:600; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.15rem; }
		.rc-input, .rc-select { width:100%; font-size:0.9rem; padding:0.3rem 0.45rem; border-radius:6px; border:1px solid var(--theme-color-border-default,#d7dce3); box-sizing:border-box; }
		.rc-source-meta { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); margin:0.35rem 0 0; }
		.rc-source-count { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0.15rem 0 0; }
		.rc-check { display:flex; align-items:center; gap:0.5rem; font-size:0.88rem; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.4rem; }
		.rc-hint { font-size:0.75rem; color:var(--theme-color-text-muted,#8894a4); margin:0.1rem 0 0.6rem 1.6rem; }
		.rc-applybar { margin:1.1rem 0 0; display:flex; align-items:center; gap:1rem; }
		.rc-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); }
		.rc-result { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; background:var(--theme-color-background-tertiary,#f4f6f9); padding:0.9rem 1.1rem; margin:1rem 0 0; }
		.rc-result-title { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-brand-primary,#2e7d74); margin:0 0 0.4rem; }
		.rc-result-list { }
		.rc-result-row { font-size:0.85rem; padding:0.1rem 0; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
	`,
	Templates:
	[
		{
			Hash: 'RoleClone-Wrap',
			Template: /*html*/`
				<div class="rc-wrap">
					<div class="rc-head">
						<div>
							<h1 class="rc-title">Clone a role</h1>
							<p class="rc-subtitle">Copy an existing role or permission group into a new, independent one — its permission grants and the roles it includes carry over, then you rename it and diverge freely. The new role has no members until you assign it.</p>
						</div>
						<button class="button is-light" onclick="_Pict.views.RoleClone.back()"><span class="icon">{~I:ChevronLeft~}</span><span>Back to Access</span></button>
					</div>
					{~TS:RoleClone-NoPerm:AppData.RoleClone.NoPermSlot~}
					{~TS:RoleClone-Message:AppData.RoleClone.MessageSlot~}
					<div class="rc-grid">
						<div class="rc-card">
							<div class="rc-card-head">1 · Source role</div>
							<div class="rc-field">
								<span class="rc-label">Role or permission group</span>
								<div id="RoleClone-SourcePicker" class="rc-picker"></div>
							</div>
							{~TS:RoleClone-SourceMeta:AppData.RoleClone.PreviewSlot~}
						</div>
						<div class="rc-card">
							<div class="rc-card-head">2 · New role</div>
							<div class="rc-field">
								<span class="rc-label">Name</span>
								<input class="rc-input" value="{~D:AppData.RoleClone.NewNameValue~}" onchange="_Pict.views.RoleClone.setField('NewName', this.value)" placeholder="e.g. Railroad Estimates Approval">
							</div>
							<div class="rc-field">
								<span class="rc-label">Include</span>
								<label class="rc-check"><input type="checkbox" {~D:AppData.RoleClone.IncludeGrantsAttr~} onchange="_Pict.views.RoleClone.toggleInclude('IncludeGrants')"> Permission grants</label>
								<label class="rc-check"><input type="checkbox" {~D:AppData.RoleClone.IncludeEdgesAttr~} onchange="_Pict.views.RoleClone.toggleInclude('IncludeEdges')"> Included roles / groups (edges)</label>
							</div>
							<div class="rc-field">
								<span class="rc-label">Target customer (0 = global)</span>
								<input class="rc-input" value="{~D:AppData.RoleClone.TargetCustomerValue~}" {~D:AppData.RoleClone.TargetCustomerReadOnly~} onchange="_Pict.views.RoleClone.setField('TargetIDCustomer', this.value)">
							</div>
						</div>
					</div>
					<div class="rc-applybar">
						<button class="button is-link" {~D:AppData.RoleClone.ApplyDisabledAttr~} onclick="_Pict.views.RoleClone.apply()"><span class="icon">{~I:Copy~}</span><span>Clone role</span></button>
						<span class="rc-note">Project-type scoping isn't part of the permission model yet — scope the new role by assigning it where needed.</span>
					</div>
					{~TS:RoleClone-Loading:AppData.RoleClone.LoadingSlot~}
					{~TS:RoleClone-Result:AppData.RoleClone.ResultSlot~}
				</div>`
		},
		{
			Hash: 'RoleClone-RoleOption',
			Template: /*html*/`<option value="{~D:Record.Value~}" {~D:Record.SelectedAttr~}>{~D:Record.Label~}</option>`
		},
		{
			Hash: 'RoleClone-SourceMeta',
			Template: /*html*/`<p class="rc-source-count">Will copy: {~D:Record.Text~}</p>`
		},
		{
			Hash: 'RoleClone-NoPerm',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mb-3">You need role-manager permission to clone roles. You can review the source here, but the clone will be rejected.</div>`
		},
		{
			Hash: 'RoleClone-Message',
			Template: /*html*/`<div class="notification is-warning is-soft py-2 px-3 mb-3">{~D:Record.Message~}</div>`
		},
		{
			Hash: 'RoleClone-Loading',
			Template: /*html*/`<p class="rc-note mt-3">Cloning…</p>`
		},
		{
			Hash: 'RoleClone-Result',
			Template: /*html*/`
				<div class="rc-result">
					<div class="rc-result-title">Result — new role “{~D:Record.NewName~}” (#{~D:Record.NewIDRole~}) · {~D:Record.Succeeded~} created, {~D:Record.Failed~} failed</div>
					<div class="rc-result-list">{~TS:RoleClone-ResultRow:AppData.RoleClone.ResultRows~}</div>
				</div>`
		},
		{
			Hash: 'RoleClone-ResultRow',
			Template: /*html*/`<div class="rc-result-row"><span class="{~D:Record.StatusClass~}">{~D:Record.Label~}</span> — {~D:Record.StatusText~}</div>`
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'RoleCloneWrap',
			TemplateHash: 'RoleClone-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container',
		}
	]
};

},{"pict-view":1053}],1470:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * SampleListColumnsConfig view — the shell for the bespoke #/SampleListColumnsConfig screen. A thin host: paints
 * the header + a single #SLC-Detail mount and hands rendering to the SampleListColumnsConfig provider (which
 * self-loads on first render, mirroring ATMDashboardConfig / Certifications).
 */
class SampleListColumnsConfig extends libPictView
{
	get provider() { return this.pict.providers.SampleListColumnsConfig; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SampleListColumnsConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'SampleListColumnsConfig',
	DefaultRenderable: 'SampleListColumnsConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.slc-wrap { padding: 1.25rem 1.5rem 2rem; }
		.slc-head { margin: 0 0 1rem; }
		.slc-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.slc-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.slc-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:20rem; }
		.slc-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:14rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
		.slc-scopebar { display:flex; align-items:center; gap:0.4rem; margin:0 0 1rem; }
		.slc-scope-label { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin-right:0.3rem; }
		.slc-scope-btn { font-size:0.84rem; font-weight:600; padding:0.35rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.slc-scope-btn.is-active { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.slc-scope-btn[disabled] { opacity:0.5; cursor:default; }
		.slc-area-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); padding:0 0 0.35rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:1.1rem 0 0.6rem; }
		.slc-area-head:first-of-type { margin-top:0; }
		.slc-hint { font-weight:500; text-transform:none; letter-spacing:normal; color:var(--theme-color-text-muted,#8894a4); }
		.slc-cols { display:flex; flex-direction:column; }
		.slc-colhead { display:flex; align-items:center; gap:0.6rem; padding:0 0.2rem 0.3rem; font-size:0.64rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); }
		.slc-ch-order { flex:0 0 3rem; }
		.slc-ch-key { flex:0 0 13rem; }
		.slc-ch-label { flex:1 1 auto; }
		.slc-ch-search { flex:0 0 2rem; text-align:center; }
		.slc-ch-actions { flex:0 0 4rem; }
		.slc-col { display:flex; align-items:center; gap:0.6rem; padding:0.35rem 0.2rem; border-bottom:1px solid var(--theme-color-border-light,#f2f4f8); }
		.slc-order { flex:0 0 3rem; display:flex; gap:0.15rem; }
		.slc-mv { width:1.4rem; height:1.4rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:5px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#6b7686); cursor:pointer; font-size:0.66rem; padding:0; }
		.slc-mv:hover { color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-secondary,#eef1f6); }
		.slc-key { flex:0 0 13rem; font-size:0.86rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.slc-label { flex:1 1 auto; min-width:0; font-size:0.86rem; padding:0.32rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.slc-search-btn { flex:0 0 auto; width:1.9rem; height:1.9rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; }
		.slc-search-btn.is-on { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.slc-col-actions { flex:0 0 auto; display:flex; gap:0.25rem; }
		.slc-tmpl-btn, .slc-remove { width:1.9rem; height:1.9rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; }
		.slc-tmpl-btn.is-set { color:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); }
		.slc-remove:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.slc-tmpl-row { display:flex; align-items:center; gap:0.6rem; padding:0.15rem 0.2rem 0.6rem 3.6rem; flex-wrap:wrap; }
		.slc-tmpl-input { flex:1 1 22rem; font-size:0.82rem; padding:0.32rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.slc-tmpl-hint { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); }
		.slc-tmpl-hint code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.slc-availwrap { display:flex; flex-wrap:wrap; gap:0.4rem; }
		.slc-avail { font-size:0.8rem; padding:0.28rem 0.6rem; border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:999px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.slc-avail:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.slc-avail.is-system { opacity:0.55; }
		.slc-avail-empty { font-size:0.84rem; color:var(--theme-color-text-muted,#8894a4); }
		.slc-savebar { margin-top:1.2rem; display:flex; gap:0.6rem; align-items:center; }
		.slc-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
		.slc-save[disabled] { opacity:0.6; cursor:default; }
		.slc-preview { font-size:0.88rem; font-weight:600; padding:0.5rem 1rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.slc-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.slc-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
	`,
	Templates:
	[
		{
			Hash: 'SampleListColumnsConfig-Wrap',
			Template: /*html*/`
				<div class="slc-wrap">
					<div class="slc-head">
						<h1 class="slc-title">Samples List — Columns</h1>
						<p class="slc-subtitle">Choose which columns the Samples list shows, rename their headers, reorder them, and pick which are searchable. Save as a platform default, a customer-wide default, or your own preference.</p>
					</div>
					<div id="SLC-Detail" class="slc-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleListColumnsConfigWrap',
			TemplateHash: 'SampleListColumnsConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1471:[function(require,module,exports){

const libPictView = require('pict-view');

const html = String.raw;

const EXPLORER_HASH = 'SamplePlanExplorer';
const TREE_MOUNT = '#SamplePlan-Tree';
const DETAIL_MOUNT = '#SamplePlan-Detail';

const fEsc = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[pChar]));
const fMeterHTML = (pMeters) => (pMeters || []).map((pMeter) => (pMeter.Kind === 'bar')
	? `<span class="pdex-meter pdex-meter-${pMeter.Tone}" title="${fEsc(pMeter.Title)}"><span class="pdex-meter-track"><span class="pdex-meter-fill" style="width: ${pMeter.Percent}%;"></span></span><span class="pdex-meter-text">${fEsc(pMeter.Label)}</span></span>`
	: `<span class="pdex-pill pdex-pill-${pMeter.Tone}" title="${fEsc(pMeter.Title)}">${fEsc(pMeter.Text)}</span>`).join(' ');
const fField = (pLabel, pValue) => ((pValue == null || pValue === '') ? '' : `<div class="sp-d-field"><div class="sp-d-flabel">${fEsc(pLabel)}</div><div class="sp-d-fval">${fEsc(pValue)}</div></div>`);
// A full-width read-only field for the long-form text columns (descriptions, instructions, remarks).
const fFieldWide = (pLabel, pValue) => ((pValue == null || pValue === '') ? '' : `<div class="sp-d-field sp-d-field-wide"><div class="sp-d-flabel">${fEsc(pLabel)}</div><div class="sp-d-fval sp-d-fval-long">${fEsc(pValue)}</div></div>`);

// Attribute-safe escaping (fEsc only covers text nodes — attribute values also need quotes escaped).
const fAttr = (pValue) => String(pValue == null ? '' : pValue).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));

// --- Edit-mode input helpers (parallel vocabulary to fField). Every control writes into the view's edit buffer via
//     _Pict.views.SamplePlan.onEditField(field, value); text/number inputs use oninput so live counts stay current. ---
const fInput = (pLabel, pField, pValue, pType, pStep) =>
	`<div class="sp-d-editrow"><label class="sp-d-flabel">${fEsc(pLabel)}</label>`
	+ `<input class="sp-d-input" type="${pType || 'text'}"${(pType === 'number') ? ` step="${fAttr(pStep || 'any')}"` : ''} value="${fAttr(pValue)}" `
	+ `oninput="_Pict.views.SamplePlan.onEditField('${pField}', this.value)" /></div>`;

const fTextarea = (pLabel, pField, pValue) =>
	`<div class="sp-d-editrow sp-d-field-wide"><label class="sp-d-flabel">${fEsc(pLabel)}</label>`
	+ `<textarea class="sp-d-textarea" rows="2" oninput="_Pict.views.SamplePlan.onEditField('${pField}', this.value)">${fEsc(pValue)}</textarea></div>`;

const fSelect = (pLabel, pField, pValue, pOptions) =>
{
	const tmpOptions = (pOptions || []).map((pOption) =>
	{
		const tmpValue = (pOption && (typeof pOption === 'object')) ? pOption.value : pOption;
		const tmpText = (pOption && (typeof pOption === 'object')) ? pOption.label : pOption;
		return `<option value="${fAttr(tmpValue)}"${(String(tmpValue) === String(pValue)) ? ' selected' : ''}>${fEsc(tmpText)}</option>`;
	}).join('');
	return `<div class="sp-d-editrow"><label class="sp-d-flabel">${fEsc(pLabel)}</label>`
		+ `<select class="sp-d-select" onchange="_Pict.views.SamplePlan.onEditField('${pField}', this.value)">${tmpOptions}</select></div>`;
};

// A native combobox (free text + a suggestion list) — the faithful equivalent of the legacy filterable comboboxes.
const fCombo = (pLabel, pField, pValue, pOptions, pListID) =>
{
	const tmpOptions = (pOptions || []).map((pOption) => `<option value="${fAttr(pOption)}"></option>`).join('');
	return `<div class="sp-d-editrow"><label class="sp-d-flabel">${fEsc(pLabel)}</label>`
		+ `<input class="sp-d-input" list="${pListID}" value="${fAttr(pValue)}" oninput="_Pict.views.SamplePlan.onEditField('${pField}', this.value)" />`
		+ `<datalist id="${pListID}">${tmpOptions}</datalist></div>`;
};

/**
 * Host page for the Sample Plan editor. Renders the chrome (project header + Docs toggle + a master/detail
 * split) into the shared application container; the SamplePlan provider supplies the in-memory ExplorerConfig
 * (pict-dataexplorer renders the tree into the left pane) and the selected-record detail data. Like the Data
 * Explorer host, the explorer is created in onAfterRender (the mount div + post-login record cards must exist
 * first); createExplorer is idempotent so re-renders just rebuild from the current config.
 */
class SamplePlan extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// Detail panel view/edit state. Keyed off the current selection so moving to another row resets to view mode.
		this._detailKey = null;
		this._detailMode = 'view';
		this._editBuffer = null;
		this._editError = '';
		this._editSaving = false;
		this._detailFetchFailed = false;
		// Front-door project list state.
		this._projectFilterTimer = null;
		this._projectLoadToken = 0;
		// Add-entry / add-material state.
		this._explorer = null;
		this._addMode = null;      // null | 'entry' | 'material'
		this._addBuffer = null;    // the new-entry draft (add-entry mode)
		this._addTarget = null;    // the Material (add-entry) or LineItem (add-material) being added to
		this._addError = '';
		this._addSaving = false;
		this._materialFilterTimer = null;
		this._materialLoadToken = 0;
		this._addEntryToken = 0;
		// When embedded in a host (the ProjectWorkspace Materials ▸ Sample Plan tab) this holds that host selector,
		// and every render — including provider-triggered repaints — targets it instead of the app container.
		this._embedDestination = null;
	}

	get provider() { return this.pict.providers['SamplePlan']; }

	/** Render into the embed host when embedded (so provider `_render()` repaints land in the Materials tab, not the
	 *  app container). An explicit destination argument always wins. */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed this plan into a host element for a fixed project (skips the front-door picker). ProjectWorkspace's
	 *  Materials ▸ Sample Plan tab calls this after each paint; it only reloads when the loaded project differs. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		const tmpState = (this.pict.AppData && this.pict.AppData.SamplePlan) || {};
		if (this.provider && (!tmpState.HasModel || (Number(this.provider._idProject) !== Number(pIDProject))))
		{
			this.provider.loadAsync(pIDProject);   // provider._render → this.render → the host
		}
		else { this.render(); }   // already loaded for this project — just (re)paint into the host
	}

	/** Leave embedded mode — the standalone #/SamplePlan screen renders to the app container again. */
	exitEmbed() { this._embedDestination = null; }

	onBeforeRender(pRenderable)
	{
		const tmpState = (this.pict.AppData && this.pict.AppData.SamplePlan) || {};
		// Mutually-exclusive body modes, driven by the single-element-array trick.
		tmpState.LoadingSlot = tmpState.Loading ? [ tmpState ] : [];
		tmpState.ErrorSlot = (!tmpState.Loading && tmpState.Message) ? [ tmpState ] : [];
		tmpState.PickerSlot = (!tmpState.Loading && !tmpState.Message && !tmpState.HasModel) ? [ tmpState ] : [];
		tmpState.PlanSlot = (!tmpState.Loading && tmpState.HasModel) ? [ tmpState ] : [];
		tmpState.TitleText = (tmpState.HasModel && tmpState.ProjectName) ? `Sample Plan — ${tmpState.ProjectName}` : 'Sample Plan';
		tmpState.SubText = tmpState.HasModel
			? this._planSubText(tmpState)
			: 'Plan a project’s material sampling and testing across its line items.';
		tmpState.EmbedClass = this._embedDestination ? 'sp-embedded' : '';
		this.pict.AppData.SamplePlan = tmpState;
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		const tmpProvider = this.provider;
		const tmpExplorerProvider = this.pict.providers['Pict-DataExplorer'];
		const tmpConfig = tmpProvider ? tmpProvider.getExplorerConfig() : null;
		if (tmpConfig && tmpExplorerProvider)
		{
			const tmpModel = tmpProvider.model;
			// No configured sample plan (no pay-item sections and no line items) → show an empty state instead of the two
			// always-present "By Pay-Item Section" / "By Line Item" folders expanding to nothing.
			if (tmpModel && !(tmpModel.sections || []).length && !(tmpModel.lineItems || []).length)
			{
				this.pict.ContentAssignment.assignContent(TREE_MOUNT,
					'<div class="sp-d-empty"><i class="fas fa-flask"></i> No sample plan configured for this project yet.'
					+ ' Add materials and sampling rules to its line items to build one.</div>');
				this._explorer = null;
				this.renderDetail();
				this.pict.CSSMap.injectCSS();
				return super.onAfterRender(pRenderable);
			}
			const tmpExplorer = tmpExplorerProvider.createExplorer(EXPLORER_HASH, Object.assign({ DestinationAddress: TREE_MOUNT }, tmpConfig));
			// The tiers are synthesized in memory (custom Resolvers), so there is no Meadow entity schema to
			// discover: the default schema source GETs `/1.0/<Entity>/Schema` — a 404 for the synthetic 'Rule'
			// tier ("Endpoint does not exist!", and so no column chooser at all there) and, for the real
			// entities, offers columns the in-memory records don't carry (they render blank when checked — the
			// "only Description and Units show up" symptom). Point the "Columns" chooser at each tier's real
			// record fields instead; no server round-trip, and every offered column exists on the record.
			tmpExplorer.SchemaSource = (pEntity, fCallback) => fCallback(null, tmpProvider.chooserColumnsForEntity(pEntity));
			// The whole plan is held in memory and material/section/rule nodes are keyed synthetically (e.g. a
			// material's Key is "IDLineItem:IDMaterial"), so the explorer's default ⓘ card — which re-fetches the
			// record from the server by the node id — both 404s and is unnecessary. Render the preview card straight
			// from the node's own in-memory record instead (Rich:false skips the fetch; the default card still
			// renders its dynamic body from whatever record it is handed).
			tmpExplorer.openCardForNode = function (pKey, pAnchorElement)
			{
				const tmpNode = this._node(pKey);
				const tmpManager = this.pict.providers.RecordSetCardManager;
				if (!tmpNode || !tmpManager || (typeof tmpManager.openCard !== 'function')) { return; }
				tmpManager.openCard(tmpNode.Entity, tmpNode.Record, pAnchorElement, { Rich: false, Audit: false, EntityConfig: tmpNode.EntityConfig });
			};
			tmpExplorer.renderExplorer();
			this._explorer = tmpExplorer;   // retained so add-entry / add-material can refresh a single subtree in place
			this.renderDetail();
		}
		else
		{
			// No plan loaded → the front-door project list is showing; populate it (with any typed filter preserved).
			this._initProjectPicker();
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}

	// --- Front-door: a filterable list of projects (replaces the raw "type an IDProject" box) -----------

	/** Populate the project list mount, if present, seeding from whatever is currently in the filter box. */
	_initProjectPicker()
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#SamplePlan-ProjectList');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpInput = document.getElementById('SamplePlan-ProjectFilter');
		this._loadProjects(tmpInput ? tmpInput.value : '');
	}

	/** Debounced filter handler — server-searches projects by name and re-renders just the list (input keeps focus). */
	onProjectFilter(pValue)
	{
		if (this._projectFilterTimer) { clearTimeout(this._projectFilterTimer); }
		this._projectFilterTimer = setTimeout(() => { this._loadProjects(pValue); }, 200);
	}

	/** Fetch the (filtered) project list and render it; a token guards against out-of-order responses. */
	_loadProjects(pTerm)
	{
		const tmpProvider = this.provider;
		if (!tmpProvider) { return; }
		const tmpToken = (this._projectLoadToken = (this._projectLoadToken || 0) + 1);
		tmpProvider.searchProjectsAsync(pTerm).then((pProjects) =>
		{
			if (tmpToken === this._projectLoadToken) { this._renderProjectList(pProjects, pTerm); }
		}).catch(() =>
		{
			if (tmpToken === this._projectLoadToken) { this.pict.ContentAssignment.assignContent('#SamplePlan-ProjectList', '<div class="sp-proj-note sp-proj-err">Could not load projects.</div>'); }
		});
	}

	/** Render the project rows into the list mount. */
	_renderProjectList(pProjects, pTerm)
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#SamplePlan-ProjectList');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpList = Array.isArray(pProjects) ? pProjects : [];
		if (!tmpList.length)
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			this.pict.ContentAssignment.assignContent('#SamplePlan-ProjectList', `<div class="sp-proj-note">${tmpTerm ? `No projects match “${fEsc(tmpTerm)}”.` : 'No projects available.'}</div>`);
			return;
		}
		const tmpHeader = '<div class="sp-proj-head"><span class="sp-proj-name">Project</span><span class="sp-proj-year">Spec Year</span><span class="sp-proj-go"></span></div>';
		const tmpRows = tmpList.map((pProject) =>
		{
			const tmpYear = pProject.SpecYear ? fEsc(pProject.SpecYear) : '—';
			return `<button type="button" class="sp-proj-row" onclick="_Pict.views.SamplePlan.openProject(${Number(pProject.IDProject)})">`
				+ `<span class="sp-proj-name">${fEsc(pProject.Name)}</span>`
				+ `<span class="sp-proj-year" title="Specification year (from the project’s contract)">${tmpYear}</span>`
				+ `<span class="sp-proj-go"><i class="fas fa-chevron-right"></i></span></button>`;
		}).join('');
		const tmpCapNote = (tmpList.length >= 100) ? '<div class="sp-proj-note sp-proj-cap">Showing the first 100 — type to narrow the list.</div>' : '';
		this.pict.ContentAssignment.assignContent('#SamplePlan-ProjectList', tmpHeader + tmpRows + tmpCapNote);
	}

	/** Open a project's sample plan. */
	openProject(pIDProject)
	{
		const tmpID = Number(pIDProject);
		if (Number.isFinite(tmpID) && (tmpID > 0)) { window.location.hash = `#/SamplePlan/${tmpID}`; }
	}

	/** The "Docs" button: pop the inline-documentation side panel open, showing the current selection's docs
	 *  (or the navigable spec index when nothing doc-relevant is selected). */
	openDocs()
	{
		// Suppress the app's route-aware help for this open — we drive the panel's content, not the app docs.
		const tmpApp = this.pict.PictApplication;
		if (tmpApp) { tmpApp._helpSuppressRouteDoc = true; }
		this._setHelpPanel(true);
		if (tmpApp) { tmpApp._helpSuppressRouteDoc = false; }
		this._renderCurrentDocs();
	}

	_panelOpen()
	{
		const tmpApp = this.pict.PictApplication;
		return !!(tmpApp && tmpApp._helpPanelOpen);
	}

	// --- Detail panel -------------------------------------------------------------------------------

	renderDetail()
	{
		const tmpElement = this.pict.ContentAssignment.getElement(DETAIL_MOUNT);
		if (!tmpElement || (tmpElement.length === 0)) { return; }
		this._syncSelectionState();
		this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
		this._syncDocsPanel();
	}

	/**
	 * On a new selection: drop any in-progress edit (never carry an edit buffer between rows) and, for a rule, kick off
	 * the full-record fetch so VIEW can show every field. Browsing stays instant — the summary paints now and the panel
	 * re-paints when the full record arrives.
	 */
	_syncSelectionState()
	{
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		const tmpKey = tmpSelection ? tmpSelection.Key : null;
		if (tmpKey === this._detailKey) { return; }
		this._detailKey = tmpKey;
		this._detailMode = 'view';
		this._editBuffer = null;
		this._editError = '';
		this._editSaving = false;
		this._detailFetchFailed = false;
		// Moving to another node abandons any in-progress add (never carry a draft between rows).
		this._addMode = null;
		this._addBuffer = null;
		this._addTarget = null;
		this._addError = '';
		this._addSaving = false;
		this._addEntryToken = (this._addEntryToken || 0) + 1;   // invalidate any in-flight add-entry vocab load
		if (tmpSelection && (tmpSelection.Entity === 'Rule') && !tmpProvider.getRawRule((tmpSelection.Record || {}).IDRule))
		{
			tmpProvider.fetchRuleRecordAsync(tmpSelection).then((pRecord) =>
			{
				// Re-paint only if this is still the current selection and we haven't since entered edit mode.
				if (tmpProvider.selected && (tmpProvider.selected.Key === tmpKey) && (this._detailMode === 'view'))
				{
					if (!pRecord) { this._detailFetchFailed = true; }
					this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
				}
			}).catch(() =>
			{
				// Full detail is best-effort, but a hard failure should read as an error, not a perpetual spinner.
				if (tmpProvider.selected && (tmpProvider.selected.Key === tmpKey) && (this._detailMode === 'view'))
				{
					this._detailFetchFailed = true;
					this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
				}
			});
		}
	}

	/** Retry a failed full-detail fetch for the current rule selection. */
	retryDetailLoad()
	{
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		if (!tmpSelection || (tmpSelection.Entity !== 'Rule')) { return; }
		this._detailFetchFailed = false;
		this._editError = '';
		this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
		tmpProvider.fetchRuleRecordAsync(tmpSelection).then((pRecord) =>
		{
			if (tmpProvider.selected && (tmpProvider.selected.Key === tmpSelection.Key) && (this._detailMode === 'view'))
			{
				if (!pRecord) { this._detailFetchFailed = true; }
				this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
			}
		}).catch(() =>
		{
			if (tmpProvider.selected && (tmpProvider.selected.Key === tmpSelection.Key) && (this._detailMode === 'view'))
			{
				this._detailFetchFailed = true;
				this.pict.ContentAssignment.assignContent(DETAIL_MOUNT, this._detailHTML());
			}
		});
	}

	/** The plan header subtitle: structural counts + the total sample-plan entries + (only when relevant) sample progress. */
	_planSubText(pState)
	{
		const tmpEntries = pState.RuleCount || 0;
		const tmpEntryLabel = (tmpEntries === 1) ? 'entry' : 'entries';
		const tmpSamples = pState.PlanText ? ` · ${pState.PlanText}` : '';
		return `${pState.SectionCount || 0} sections · ${pState.LineItemCount || 0} line items · ${tmpEntries} sample plan ${tmpEntryLabel}${tmpSamples}`;
	}

	/** Refresh the header subtitle in place (the plan total changes after a save; tree meters lag until reload). */
	_refreshHeader()
	{
		const tmpState = this.provider ? this.provider.workspaceState : null;
		if (!tmpState || !tmpState.HasModel) { return; }
		const tmpSubtitle = document.querySelector('.sampleplan-sub');
		if (tmpSubtitle) { tmpSubtitle.textContent = this._planSubText(tmpState); }
	}

	/**
	 * Keep the docs side panel in sync with the current selection — but only when the panel is already open
	 * (the Docs button opens it). Documentation renders in the inline-documentation panel, never in the record.
	 */
	_syncDocsPanel()
	{
		if (this._panelOpen()) { this._renderCurrentDocs(); }
	}

	/** Render the current selection's docs into the side panel — or the navigable spec index when nothing relevant is selected. */
	_renderCurrentDocs()
	{
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		const tmpEntries = tmpSelection ? tmpProvider.docHashesForSelection(tmpSelection) : [];
		if (!tmpSelection || !tmpEntries.length) { this._showSpecIndex(); return; }
		this._displayDocs(this._docNavHTML() + this._docsEditBarHTML(tmpSelection) + this._parseMd(this._docsMarkdownForSelection(tmpSelection)));
		tmpProvider.ensureSelectionDocs(tmpSelection).then((pChanged) =>
		{
			if (pChanged && tmpProvider.selected && (tmpProvider.selected.Key === tmpSelection.Key) && this._panelOpen())
			{
				this._displayDocs(this._docNavHTML() + this._docsEditBarHTML(tmpSelection) + this._parseMd(this._docsMarkdownForSelection(tmpSelection)));
			}
		});
	}

	/** The navigable root: every seeded sampling-manual doc (procedures + section schedules), grouped + linked. */
	_showSpecIndex()
	{
		const tmpProvider = this.provider;
		if (!tmpProvider) { return; }
		this._setHelpPanel(true);
		this._displayDocs('<div class="sp-docidx-loading">Loading sampling-manual index…</div>');
		tmpProvider.loadSpecIndex().then((pList) => { if (this._panelOpen()) { this._displayDocs(this._specIndexHTML(pList)); } });
	}

	/** A single doc-by-hash view, reached from the spec index. */
	openSpecDoc(pHash)
	{
		const tmpProvider = this.provider;
		if (!tmpProvider) { return; }
		this._setHelpPanel(true);
		this._displayDocs(this._docNavHTML() + '<div class="sp-docidx-loading">Loading…</div>');
		tmpProvider.ensureDoc(pHash).then(() =>
		{
			if (!this._panelOpen()) { return; }
			const tmpDoc = tmpProvider.getCachedDoc(pHash);
			this._displayDocs(this._docNavHTML() + this._parseMd((tmpDoc && tmpDoc.Content) ? tmpDoc.Content : '_Document not found._'));
		});
	}

	/** Assemble one markdown document from a selection's populated AcademyContent doc tiers. */
	_docsMarkdownForSelection(pSelection)
	{
		const tmpProvider = this.provider;
		const tmpRecord = pSelection.Record || {};
		const tmpEntries = tmpProvider.docHashesForSelection(pSelection);
		const tmpHeader = `# ${tmpRecord.Title || tmpRecord.Name || tmpRecord.TreeLabel || pSelection.Entity}\n`;
		if (tmpEntries.some((pEntry) => tmpProvider.getCachedDoc(pEntry.Hash) === undefined)) { return `${tmpHeader}\n_Loading documentation…_`; }
		const tmpParts = [];
		tmpEntries.forEach((pEntry) =>
		{
			const tmpDoc = tmpProvider.getCachedDoc(pEntry.Hash);
			if (tmpDoc && tmpDoc.Content) { tmpParts.push(`## ${pEntry.Tier}\n\n${tmpDoc.Content}`); }
		});
		return tmpParts.length ? `${tmpHeader}\n${tmpParts.join('\n\n---\n\n')}` : `${tmpHeader}\n_No documentation entries for this yet — browse the full manual below._`;
	}

	/** The grouped, linked root index (hand-built HTML so the links carry click handlers reliably). */
	_specIndexHTML(pList)
	{
		const fEscape = (pStr) => String(pStr == null ? '' : pStr).replace(/[&<>"']/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[pChar]));
		const fLink = (pDoc) => `<li><a href="#" onclick="_Pict.views.SamplePlan.openSpecDoc('${fEscape(pDoc.Hash)}'); return false;">${fEscape(pDoc.Title || pDoc.Hash)}</a></li>`;
		const tmpList = Array.isArray(pList) ? pList : [];
		const tmpProcedures = tmpList.filter((pDoc) => pDoc.Hash.indexOf('SamplePlanProcedure-') === 0).sort((pA, pB) => pA.Hash.localeCompare(pB.Hash));
		const tmpSections = tmpList.filter((pDoc) => pDoc.Hash.indexOf('SamplePlanSpec-') === 0).sort((pA, pB) => pA.Hash.localeCompare(pB.Hash, undefined, { numeric: true }));
		let tmpHTML = '<div class="sp-docidx"><h1>Materials Sampling Manual</h1>';
		if (tmpProcedures.length) { tmpHTML += `<h2>Sampling procedures</h2><ul>${tmpProcedures.map(fLink).join('')}</ul>`; }
		if (tmpSections.length) { tmpHTML += `<h2>Section schedules</h2><ul>${tmpSections.map(fLink).join('')}</ul>`; }
		if (!tmpProcedures.length && !tmpSections.length) { tmpHTML += '<p>No sampling-manual documents are seeded yet.</p>'; }
		return tmpHTML + '</div>';
	}

	_docNavHTML()
	{
		return '<div class="sp-docnav"><a href="#" onclick="_Pict.views.SamplePlan._showSpecIndex(); return false;">📖 All sampling docs</a></div>';
	}

	/**
	 * When the user has documentation-edit rights, offer a per-tier Edit control for the selection's docs — reusing the
	 * app's existing platform-doc editor (editPlatformHelpDoc). The project-specific entry (SamplePlanEntry-{IDRule}) is
	 * the one most worth editing; the canonical/override split + save are all handled by the shared machinery.
	 */
	_docsEditBarHTML(pSelection)
	{
		const tmpApp = this.pict.PictApplication;
		if (!tmpApp || (typeof tmpApp._platformDocsEditMode !== 'function') || !tmpApp._platformDocsEditMode()) { return ''; }
		const tmpEntries = this.provider.docHashesForSelection(pSelection);
		if (!tmpEntries.length) { return ''; }
		const tmpButtons = tmpEntries.map((pEntry) =>
			`<button type="button" class="sp-doc-editbtn" onclick="_Pict.PictApplication.editPlatformHelpDoc('${fAttr(pEntry.Hash)}'); return false;"><i class="fas fa-pen"></i> ${fEsc(pEntry.Tier)}</button>`).join('');
		return `<div class="sp-doc-editbar"><span class="sp-doc-editbar-label">Edit documentation:</span>${tmpButtons}</div>`;
	}

	/** Render markdown → HTML via the inline-doc content provider (falls back to the raw string if absent). */
	_parseMd(pMarkdown)
	{
		const tmpDocProvider = this.pict.providers['Pict-InlineDocumentation'];
		return (tmpDocProvider && tmpDocProvider._ContentProvider) ? tmpDocProvider._ContentProvider.parseMarkdown(pMarkdown) : pMarkdown;
	}

	/** Show HTML in the inline-documentation panel body (no-op if the host has no such panel). */
	_displayDocs(pHTML)
	{
		const tmpContentView = this.pict.views['InlineDoc-Content'];
		if (tmpContentView && (typeof tmpContentView.displayContent === 'function')) { tmpContentView.displayContent(pHTML); }
		// Flag the shared panel as showing OUR content, so the app restores its own docs the next time "?" or a
		// route change drives the panel (otherwise the sampling manual lingers on other pages).
		const tmpApp = this.pict.PictApplication;
		if (tmpApp) { tmpApp._helpShowingForeignDocs = true; }
	}

	/** Open/close the shared inline-documentation side panel, if the host exposes one. */
	_setHelpPanel(pOpen)
	{
		const tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.toggleHelp === 'function') { tmpApp.toggleHelp(!!pOpen); }
	}

	_detailHTML()
	{
		// An in-progress add takes over the panel (it is bound to _addTarget, not the tree selection).
		if (this._addMode === 'material') { return this._addMaterialHTML(); }
		if (this._addMode === 'entry') { return this._addEntryHTML(); }
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		if (!tmpSelection)
		{
			return '<div class="sp-d-empty">Select any row to see its detail, satisfaction, and documentation.</div>';
		}
		const tmpRecord = tmpSelection.Record || {};
		if (tmpSelection.Entity === 'Rule')
		{
			return (this._detailMode === 'edit') ? this._ruleEditHTML(tmpSelection) : this._ruleViewHTML(tmpSelection);
		}
		const tmpKindLabel = ({ Section: 'Pay-item section', LineItem: 'Line item', Material: 'Material' })[tmpSelection.Entity] || tmpSelection.Entity;
		const tmpTitle = (tmpSelection.Entity === 'Section') ? tmpRecord.TreeLabel : (tmpRecord.Name || tmpRecord.Title || '');
		// Add affordances: a Material can gain a new entry; a Line Item can gain a new material. Gated on edit rights.
		let tmpAddButton = '';
		if (tmpProvider.canEditRule())
		{
			if (tmpSelection.Entity === 'Material') { tmpAddButton = `<button type="button" class="sp-d-editbtn" onclick="_Pict.views.SamplePlan.enterAddEntry()"><i class="fas fa-plus"></i> Add entry</button>`; }
			else if (tmpSelection.Entity === 'LineItem') { tmpAddButton = `<button type="button" class="sp-d-editbtn" onclick="_Pict.views.SamplePlan.enterAddMaterial()"><i class="fas fa-plus"></i> Add material</button>`; }
		}
		const tmpFields = ((tmpSelection.Entity === 'Section') ? fField('Line items', tmpRecord.LineItemCount) : '')
			+ ((tmpSelection.Entity === 'LineItem') ? fField('Number', tmpRecord.Number) + fField('Description', tmpRecord.Description) + fField('Expected qty', `${tmpRecord.ExpectedQty} ${tmpRecord.Units || ''}`.trim()) : '')
			+ fField('Sample plan entries', tmpRecord.EntryCount)
			+ ((tmpRecord.SamplesRequired > 0) ? fField('Samples', `${tmpRecord.SamplesCreated} / ${tmpRecord.SamplesRequired}`) : '');
		return `<div class="sp-d-head"><div class="sp-d-headrow"><div class="sp-d-kind">${fEsc(tmpKindLabel)}</div>${tmpAddButton}</div><div class="sp-d-title">${fEsc(tmpTitle)}</div><div class="sp-d-meters">${fMeterHTML(this._meterFor(tmpSelection))}</div></div><div class="sp-d-grid">${tmpFields}</div>`;
	}

	// --- Rule VIEW mode: the full read-only field set (progressively enriched from the raw record) -------

	_ruleViewHTML(pSelection)
	{
		const tmpProvider = this.provider;
		const tmpRecord = pSelection.Record || {};
		const tmpRaw = tmpProvider.getRawRule(tmpRecord.IDRule);
		const tmpFeatures = tmpProvider.features;
		const tmpEditButton = tmpProvider.canEditRule()
			? `<button type="button" class="sp-d-editbtn" onclick="_Pict.views.SamplePlan.enterEdit()"><i class="fas fa-pen"></i> Edit</button>`
			: '';
		const tmpHead = `<div class="sp-d-head"><div class="sp-d-headrow"><div class="sp-d-kind">Sampling rule</div>${tmpEditButton}</div>`
			+ `<div class="sp-d-title">${fEsc(tmpRecord.Title)}</div><div class="sp-d-meters">${fMeterHTML(this._meterFor(pSelection))}</div></div>`;

		const tmpFreq = (tmpRecord.Kind === 'cert') ? 'By certificate'
			: (tmpRecord.Kind === 'perproject') ? '1 / project'
			: `1 / ${tmpRecord.Frequency} ${tmpRecord.Units || ''}`.trim();
		let tmpFields = fField('Sample type', tmpRecord.SampleType) + fField('Frequency', tmpFreq) + fField('Rate', tmpRecord.Rate) + fField('Units', tmpRecord.Units);
		if (tmpRaw)
		{
			tmpFields += fField('Conversion factor', tmpRaw.ConversionFactor) + fField('Sample size', tmpRaw.SampleSize) + fField('Sample units', tmpRaw.SampleUnits);
			if (tmpFeatures.ShowTestSelector) { tmpFields += fField('Test', tmpRecord.TestLabel || tmpRecord.TestHash) + fField('Intent', tmpRaw.Intent); }
		}
		// count → sampling progress; per-project test → the samples actually taken; certificate → the acceptance basis.
		if (tmpRecord.Kind === 'count') { tmpFields += fField('Required (est.)', tmpRecord.Required) + fField('Created', tmpRecord.Created) + fField('Passing', tmpRecord.Passing); }
		else if (tmpRecord.Kind === 'perproject') { tmpFields += fField('Created', tmpRecord.Created) + fField('Passing', tmpRecord.Passing); }
		else { tmpFields += fField('Acceptance', 'By certificate'); }

		let tmpWide = '';
		if (tmpRaw)
		{
			tmpWide = fFieldWide('Sample description', tmpRaw.SampleDescription) + fFieldWide('Sampling instructions', tmpRaw.SamplingInstructions)
				+ fFieldWide('Test description', tmpRaw.TestDescription) + fFieldWide('Remarks', tmpRaw.Remarks)
				+ ((Number(tmpRaw.ErrorOmission) === 1) ? fFieldWide('Error / omission', tmpRaw.ErrorOmissionDetail || 'Flagged') : '');
		}
		else if (this._detailFetchFailed)
		{
			tmpWide = '<div class="sp-d-loadingnote sp-d-loadfail"><i class="fas fa-triangle-exclamation"></i> Could not load the full detail. <a href="#" onclick="_Pict.views.SamplePlan.retryDetailLoad(); return false;">Retry</a></div>';
		}
		else
		{
			tmpWide = '<div class="sp-d-loadingnote"><i class="fas fa-spinner fa-spin"></i> Loading full detail…</div>';
		}
		// A failed enterEdit leaves an error but stays in VIEW — surface it here (mirrors the edit form's banner).
		const tmpErrorBanner = this._editError ? `<div class="sp-d-error"><i class="fas fa-triangle-exclamation"></i> ${fEsc(this._editError)}</div>` : '';
		// Documentation lives in the inline-documentation side panel (see _syncDocsPanel), not in the record.
		return tmpHead + tmpErrorBanner + `<div class="sp-d-grid">${tmpFields}</div>${tmpWide}`;
	}

	// --- Rule EDIT mode: the editable form (dropdowns where the legacy editor has them) -----------------

	/** The shared editable field body (used by both the edit form and the add-entry form), bound to the given buffer. */
	_ruleFormFieldsHTML(pBuffer)
	{
		const tmpProvider = this.provider;
		const tmpFeatures = tmpProvider.features;
		// Rate: a 0/1 toggle when the customer's config enables it, else a numeric input (matching the legacy editor).
		const tmpRateHTML = tmpFeatures.ShowRateToggle
			? `<div class="sp-d-editrow"><label class="sp-d-flabel">Rate</label><label class="sp-d-toggle"><span>0</span>`
				+ `<input type="checkbox"${(Number(pBuffer.Rate) === 1) ? ' checked' : ''} onchange="_Pict.views.SamplePlan.onRateToggle(this.checked)" /><span>1</span></label></div>`
			: fInput('Rate', 'Rate', pBuffer.Rate, 'number');

		const tmpUnitsOptions = this._withCurrent(tmpProvider.unitsOptions, pBuffer.Units).map((pUnit) => ({ value: pUnit, label: pUnit }));
		if (pBuffer.Units == null || (pBuffer.Units === '')) { tmpUnitsOptions.unshift({ value: '', label: '— none —' }); }
		const tmpCounts = tmpProvider.serverCountsFor(pBuffer);
		const tmpPlannedHTML = this._overrideRowHTML('Planned Samples', 'Planned', (Number(pBuffer.ManualPlannedSampleCount) > -1), pBuffer.ManualPlannedSampleCount, tmpCounts.ComputedPlannedSampleCount, 'sp-ed-plan-val');
		const tmpRequiredHTML = this._overrideRowHTML('Required Samples', 'Required', (Number(pBuffer.ManualRequiredSampleCount) > -1), pBuffer.ManualRequiredSampleCount, tmpCounts.ComputedRequiredSampleCount, 'sp-ed-req-val');

		let tmpTestHTML = '';
		if (tmpFeatures.ShowTestSelector)
		{
			const tmpTestOptions = tmpProvider.testOptionsFor(pBuffer.IDTest).map((pOption) => ({ value: pOption.IDTest, label: pOption.Name }));
			tmpTestHTML = fSelect('Test', 'IDTest', (pBuffer.IDTest == null ? 0 : pBuffer.IDTest), tmpTestOptions)
				+ fCombo('Intent', 'Intent', pBuffer.Intent, tmpProvider.intentOptions, 'sp-ed-intent-list');
		}

		const tmpErrorOmission = (Number(pBuffer.ErrorOmission) === 1);
		const tmpShowDetail = tmpErrorOmission || (pBuffer.ErrorOmissionDetail && (pBuffer.ErrorOmissionDetail !== ''));
		const tmpEOHTML = `<div class="sp-d-editrow sp-d-field-wide"><label class="sp-d-checkline"><input type="checkbox"${tmpErrorOmission ? ' checked' : ''} onchange="_Pict.views.SamplePlan.onToggleErrorOmission(this.checked)" /> Error / Omission</label>`
			+ (tmpShowDetail ? `<textarea class="sp-d-textarea" rows="2" placeholder="Enter Error/Omission details"${tmpErrorOmission ? '' : ' disabled'} oninput="_Pict.views.SamplePlan.onEditField('ErrorOmissionDetail', this.value)">${fEsc(pBuffer.ErrorOmissionDetail || '')}</textarea>` : '')
			+ `</div>`;

		return tmpRateHTML
			+ fInput('Frequency', 'Frequency', pBuffer.Frequency, 'number')
			+ fInput('Conversion Factor', 'ConversionFactor', pBuffer.ConversionFactor, 'number', '0.00001')
			+ fSelect('Units', 'Units', pBuffer.Units, tmpUnitsOptions)
			+ tmpPlannedHTML
			+ tmpRequiredHTML
			+ fTextarea('Sample Description', 'SampleDescription', pBuffer.SampleDescription)
			+ fTextarea('Sampling Instructions', 'SamplingInstructions', pBuffer.SamplingInstructions)
			+ fInput('Sample Size', 'SampleSize', pBuffer.SampleSize, 'number', '1')
			+ fCombo('Sample Units', 'SampleUnits', pBuffer.SampleUnits, tmpProvider.unitsOptions, 'sp-ed-units-list')
			+ tmpTestHTML
			+ fTextarea('Test Description', 'TestDescription', pBuffer.TestDescription)
			+ fTextarea('Remarks', 'Remarks', pBuffer.Remarks)
			+ tmpEOHTML;
	}

	_ruleEditHTML(pSelection)
	{
		const tmpBuffer = this._editBuffer || {};
		const tmpRecord = pSelection.Record || {};
		const tmpTitle = tmpBuffer.TestDescription || tmpBuffer.SampleDescription || tmpRecord.Title || 'Material Acceptance';
		const tmpSampleType = tmpBuffer.SampleType || tmpRecord.SampleType || '';
		const tmpErrorBanner = this._editError ? `<div class="sp-d-error"><i class="fas fa-triangle-exclamation"></i> ${fEsc(this._editError)}</div>` : '';
		const tmpBusy = this._editSaving ? ' disabled' : '';
		const tmpActions = `<div class="sp-d-actions">`
			+ `<button type="button" class="sp-d-btn sp-d-btn-primary" onclick="_Pict.views.SamplePlan.saveDetail()"${tmpBusy}>${this._editSaving ? 'Saving…' : 'Save'}</button>`
			+ `<button type="button" class="sp-d-btn" onclick="_Pict.views.SamplePlan.cancelDetail()"${tmpBusy}>Cancel</button></div>`;
		return `<div class="sp-d-head"><div class="sp-d-headrow"><div class="sp-d-kind">Sampling rule · editing</div></div>`
			+ `<div class="sp-d-title">${fEsc(tmpTitle)}</div><div class="sp-d-subkind">Sample Type: ${fEsc(tmpSampleType)}</div></div>`
			+ tmpErrorBanner
			+ `<div class="sp-d-form">${this._ruleFormFieldsHTML(tmpBuffer)}</div>`
			+ tmpActions;
	}

	/** One Planned/Required row: an Override checkbox plus either a manual number input or the live computed readout. */
	_overrideRowHTML(pLabel, pWhich, pOverride, pManualValue, pComputed, pReadoutID)
	{
		const tmpField = (pWhich === 'Planned') ? 'ManualPlannedSampleCount' : 'ManualRequiredSampleCount';
		const tmpCheckbox = `<label class="sp-d-checkinline"><input type="checkbox"${pOverride ? ' checked' : ''} onchange="_Pict.views.SamplePlan.onToggleOverride('${pWhich}', this.checked)" /> Override</label>`;
		const tmpBody = pOverride
			? `<input class="sp-d-input" type="number" step="1" value="${fAttr(pManualValue)}" oninput="_Pict.views.SamplePlan.onEditField('${tmpField}', this.value)" />`
			: `<div class="sp-d-computed">Computed: <span id="${pReadoutID}">${fEsc(pComputed)}</span></div>`;
		return `<div class="sp-d-editrow"><div class="sp-d-overhead"><label class="sp-d-flabel">${fEsc(pLabel)}</label>${tmpCheckbox}</div>${tmpBody}</div>`;
	}

	/** Keep an existing value selectable even when it isn't in the derived vocabulary (so nothing renders blank). */
	_withCurrent(pOptions, pValue)
	{
		const tmpList = (pOptions || []).slice();
		const tmpValue = (pValue == null) ? '' : String(pValue);
		if ((tmpValue !== '') && (tmpList.indexOf(tmpValue) === -1)) { tmpList.unshift(tmpValue); }
		return tmpList;
	}

	// --- Edit handlers ----------------------------------------------------------------------------------

	/** Enter edit mode: fetch the full rule record (+ the Test catalog when needed), buffer it, then paint the form. */
	enterEdit()
	{
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		if (!tmpSelection || (tmpSelection.Entity !== 'Rule') || !tmpProvider.canEditRule()) { return; }
		this._editError = '';
		this._editSaving = false;
		Promise.all(
		[
			tmpProvider.fetchRuleRecordAsync(tmpSelection),
			tmpProvider.features.ShowTestSelector ? tmpProvider.ensureTestOptionsAsync() : Promise.resolve(null),
		])
			.then((pResults) =>
			{
				if (!tmpProvider.selected || (tmpProvider.selected.Key !== tmpSelection.Key)) { return; }   // selection moved on
				const tmpRaw = pResults[0];
				if (!tmpRaw) { this._editError = 'Could not load the full rule record to edit.'; this.renderDetail(); return; }
				this._editBuffer = this._normalizeBuffer(tmpRaw);
				this._detailMode = 'edit';
				this.renderDetail();
			})
			.catch((pError) =>
			{
				this._editError = (pError && pError.message) ? pError.message : 'Could not load the rule record.';
				this.renderDetail();
			});
	}

	/** Clone the raw record into the edit buffer and coerce the numeric/flag columns so the form binds cleanly. */
	_normalizeBuffer(pRaw)
	{
		const tmpBuffer = JSON.parse(JSON.stringify(pRaw));
		const fNum = (pValue, pDefault) => { const tmp = Number(pValue); return Number.isFinite(tmp) ? tmp : pDefault; };
		tmpBuffer.Rate = fNum(tmpBuffer.Rate, 1);
		tmpBuffer.Frequency = fNum(tmpBuffer.Frequency, 0);
		tmpBuffer.ConversionFactor = fNum(tmpBuffer.ConversionFactor, 1);
		tmpBuffer.SampleSize = fNum(tmpBuffer.SampleSize, 0);
		tmpBuffer.ManualPlannedSampleCount = fNum(tmpBuffer.ManualPlannedSampleCount, -1);
		tmpBuffer.ManualRequiredSampleCount = fNum(tmpBuffer.ManualRequiredSampleCount, -1);
		tmpBuffer.ErrorOmission = (Number(tmpBuffer.ErrorOmission) === 1) ? 1 : 0;
		tmpBuffer.IDTest = (tmpBuffer.IDTest == null) ? 0 : fNum(tmpBuffer.IDTest, 0);
		return tmpBuffer;
	}

	/** The buffer the form is currently bound to — the add draft when adding, else the edit buffer. */
	_activeBuffer() { return this._addBuffer || this._editBuffer; }

	/** A field changed: write it to the active buffer (coercing numerics) and refresh the live computed counts when relevant. */
	onEditField(pField, pValue)
	{
		const tmpBuffer = this._activeBuffer();
		if (!tmpBuffer) { return; }
		const tmpNumericFields = { Rate: 1, Frequency: 1, ConversionFactor: 1, SampleSize: 1, ManualPlannedSampleCount: 1, ManualRequiredSampleCount: 1, IDTest: 1 };
		// Integer columns — round so a pasted/typed decimal never reaches an int column (the DB would silently truncate).
		const tmpIntegerFields = { SampleSize: 1, ManualPlannedSampleCount: 1, ManualRequiredSampleCount: 1, IDTest: 1 };
		if (tmpNumericFields[pField])
		{
			const tmpNum = Number(pValue);
			tmpBuffer[pField] = Number.isFinite(tmpNum) ? (tmpIntegerFields[pField] ? Math.round(tmpNum) : tmpNum) : 0;
		}
		else
		{
			tmpBuffer[pField] = pValue;
		}
		if ((pField === 'Rate') || (pField === 'Frequency') || (pField === 'ConversionFactor') || (pField === 'Units')) { this._updateComputedReadouts(); }
	}

	/**
	 * A count-affecting field (Rate/Frequency/Conversion/Units) changed. The required/planned counts are computed by
	 * the SERVER (never client-side), so they can't update live — mark the readouts as pending; they refresh from the
	 * endpoint when the rule is saved. (The readouts are only present while their manual override is off.)
	 */
	_updateComputedReadouts()
	{
		const tmpBuffer = this._activeBuffer();
		if (!tmpBuffer) { return; }
		const tmpPlanned = document.getElementById('sp-ed-plan-val');
		const tmpRequired = document.getElementById('sp-ed-req-val');
		const fPending = (pEl) => { if (pEl) { pEl.textContent = 'recalculates on save'; pEl.title = 'Required and planned counts are computed by the server; they update when you save.'; pEl.classList.add('sp-ed-pending'); } };
		fPending(tmpPlanned);
		fPending(tmpRequired);
	}

	/** The Rate 0/1 toggle. */
	onRateToggle(pChecked)
	{
		const tmpBuffer = this._activeBuffer();
		if (!tmpBuffer) { return; }
		tmpBuffer.Rate = pChecked ? 1 : 0;
		this._updateComputedReadouts();
	}

	/** Toggle a Planned/Required override: seed the manual value with the current computed count (no legacy -1 in the box). */
	onToggleOverride(pWhich, pChecked)
	{
		const tmpBuffer = this._activeBuffer();
		if (!tmpBuffer) { return; }
		const tmpField = (pWhich === 'Planned') ? 'ManualPlannedSampleCount' : 'ManualRequiredSampleCount';
		if (pChecked)
		{
			const tmpCounts = this.provider.serverCountsFor(tmpBuffer);
			tmpBuffer[tmpField] = (pWhich === 'Planned') ? Number(tmpCounts.ComputedPlannedSampleCount) : Number(tmpCounts.ComputedRequiredSampleCount);
		}
		else
		{
			tmpBuffer[tmpField] = -1;
		}
		this.renderDetail();
	}

	/** Toggle the Error/Omission flag (shows/enables the detail field). Keeps any typed detail rather than dropping it. */
	onToggleErrorOmission(pChecked)
	{
		const tmpBuffer = this._activeBuffer();
		if (!tmpBuffer) { return; }
		tmpBuffer.ErrorOmission = pChecked ? 1 : 0;
		this.renderDetail();
	}

	/** Save the buffered edits through the provider, then return to VIEW (or surface the server error). */
	saveDetail()
	{
		if (!this._editBuffer || this._editSaving) { return; }
		this._editSaving = true;
		this._editError = '';
		this.renderDetail();
		this.provider.saveRuleAsync(this._editBuffer).then((pResult) =>
		{
			this._editSaving = false;
			if (pResult && pResult.ok)
			{
				this._detailMode = 'view';
				this._editBuffer = null;
				this._editError = '';
				this.renderDetail();
				this._refreshHeader();
				return;
			}
			this._editError = (pResult && pResult.error) ? String(pResult.error) : 'The save failed.';
			this.renderDetail();
		}).catch((pError) =>
		{
			this._editSaving = false;
			this._editError = (pError && pError.message) ? pError.message : 'The save failed.';
			this.renderDetail();
		});
	}

	/** Discard the buffered edits and return to VIEW. */
	cancelDetail()
	{
		this._detailMode = 'view';
		this._editBuffer = null;
		this._editError = '';
		this.renderDetail();
	}

	// --- Add: a new entry under a material, or a new material on a line item -----------------------------

	/** Refresh just one already-loaded tree folder in place (its resolver re-reads the mutable index) — no collapse. */
	_refreshTreeFolders(pLabel, pMatchFn)
	{
		const tmpExplorer = this._explorer;
		if (!tmpExplorer || (typeof tmpExplorer._state !== 'function') || (typeof tmpExplorer._reloadFolderMembers !== 'function')) { return; }
		const tmpNodes = (tmpExplorer._state() || {}).Nodes || {};
		Object.keys(tmpNodes).forEach((pKey) =>
		{
			const tmpNode = tmpNodes[pKey];
			if (tmpNode && (tmpNode.Kind === 'folder') && (tmpNode.Label === pLabel) && tmpNode.Loaded && pMatchFn(tmpNode)) { tmpExplorer._reloadFolderMembers(pKey, tmpNode); }
		});
	}

	/** "+ Add entry" on a selected Material. */
	enterAddEntry()
	{
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		if (!tmpSelection || (tmpSelection.Entity !== 'Material') || !tmpProvider.canEditRule()) { return; }
		this._beginAddEntry(tmpSelection.Record);
	}

	/** Start an add-entry draft for a material node (used by the Material button and right after adding a material). */
	_beginAddEntry(pMaterial)
	{
		const tmpProvider = this.provider;
		this._addError = '';
		this._addSaving = false;
		// Guard the async vocab load: if the user cancels or moves on before it resolves, this stale callback must not
		// revive the add form for the wrong material (cancelAdd / a selection change bump _addEntryToken).
		const tmpToken = (this._addEntryToken = (this._addEntryToken || 0) + 1);
		const fShow = () =>
		{
			if (tmpToken !== this._addEntryToken) { return; }
			this._addTarget = pMaterial;
			this._addBuffer = this._newEntryBuffer(pMaterial);
			this._addMode = 'entry';
			this.renderDetail();
		};
		Promise.all(
		[
			tmpProvider.ensureSampleTypesAsync(),
			tmpProvider.features.ShowTestSelector ? tmpProvider.ensureTestOptionsAsync() : Promise.resolve(null),
		]).then(fShow).catch(fShow);
	}

	/** A sensible default new-entry draft under a material. */
	_newEntryBuffer(pMaterial)
	{
		const tmpProvider = this.provider;
		const tmpDefaultSampleType = (tmpProvider.sampleTypeOptions()[0] && tmpProvider.sampleTypeOptions()[0].value) || 'ACPT';
		return {
			IDLineItem: pMaterial.IDLineItem,
			IDMaterial: pMaterial.IDMaterial,
			SampleType: tmpDefaultSampleType,
			IDTest: 0,
			Rate: 1,
			Frequency: 1,
			ConversionFactor: 1,
			Units: tmpProvider.defaultUnitsForMaterial(pMaterial.IDLineItem, pMaterial.IDMaterial),
			SampleSize: 0,
			SampleUnits: '',
			SampleDescription: '',
			SamplingInstructions: '',
			TestDescription: '',
			Remarks: '',
			Intent: '',
			ErrorOmission: 0,
			ErrorOmissionDetail: '',
			ManualPlannedSampleCount: -1,
			ManualRequiredSampleCount: -1,
		};
	}

	/** The add-entry form: a Sample Type dropdown + the shared rule fields, with Create / Cancel. */
	_addEntryHTML()
	{
		const tmpProvider = this.provider;
		const tmpBuffer = this._addBuffer || {};
		const tmpMaterial = this._addTarget || {};
		const tmpOptions = tmpProvider.sampleTypeOptions();
		const tmpSampleTypeOptions = tmpOptions.length ? tmpOptions : [ { value: tmpBuffer.SampleType || 'ACPT', label: tmpBuffer.SampleType || 'ACPT' } ];
		const tmpErrorBanner = this._addError ? `<div class="sp-d-error"><i class="fas fa-triangle-exclamation"></i> ${fEsc(this._addError)}</div>` : '';
		const tmpBusy = this._addSaving ? ' disabled' : '';
		const tmpActions = `<div class="sp-d-actions">`
			+ `<button type="button" class="sp-d-btn sp-d-btn-primary" onclick="_Pict.views.SamplePlan.createEntry()"${tmpBusy}>${this._addSaving ? 'Adding…' : 'Create entry'}</button>`
			+ `<button type="button" class="sp-d-btn" onclick="_Pict.views.SamplePlan.cancelAdd()"${tmpBusy}>Cancel</button></div>`;
		return `<div class="sp-d-head"><div class="sp-d-headrow"><div class="sp-d-kind">New sample plan entry</div></div>`
			+ `<div class="sp-d-title">${fEsc(tmpMaterial.Name || 'Material')}</div><div class="sp-d-subkind">Adding a test entry to this material</div></div>`
			+ tmpErrorBanner
			+ `<div class="sp-d-form">${fSelect('Sample Type', 'SampleType', tmpBuffer.SampleType, tmpSampleTypeOptions)}${this._ruleFormFieldsHTML(tmpBuffer)}</div>`
			+ tmpActions;
	}

	/** Create the drafted entry through the provider, then show it and refresh its material's Tests folder in place. */
	createEntry()
	{
		if (!this._addBuffer || this._addSaving) { return; }
		this._addSaving = true;
		this._addError = '';
		this.renderDetail();
		this.provider.createEntryAsync(this._addBuffer).then((pResult) =>
		{
			this._addSaving = false;
			if (pResult && pResult.ok)
			{
				const tmpRule = pResult.rule;
				this._addMode = null;
				this._addBuffer = null;
				this._addTarget = null;
				this._addError = '';
				this._refreshTreeFolders('Tests', (pNode) => pNode.ParentRecord && (String(pNode.ParentRecord.Key) === String(tmpRule.MaterialKey)));
				// Land on the new entry (VIEW), forcing a fresh selection so its detail loads.
				this.provider.selectRuleRecord(tmpRule);
				this._detailKey = null;
				this.renderDetail();
				this._refreshHeader();
				return;
			}
			this._addError = (pResult && pResult.error) ? String(pResult.error) : 'Could not create the entry.';
			this.renderDetail();
		}).catch((pError) =>
		{
			this._addSaving = false;
			this._addError = (pError && pError.message) ? pError.message : 'Could not create the entry.';
			this.renderDetail();
		});
	}

	/** "+ Add material" on a selected Line Item → the material picker. */
	enterAddMaterial()
	{
		const tmpProvider = this.provider;
		const tmpSelection = tmpProvider ? tmpProvider.selected : null;
		if (!tmpSelection || (tmpSelection.Entity !== 'LineItem') || !tmpProvider.canEditRule()) { return; }
		this._addTarget = tmpSelection.Record;
		this._addMode = 'material';
		this._addError = '';
		this._materialLoadToken = 0;
		this.renderDetail();
		this._loadMaterials('');
	}

	/** The material picker: a search box + a filterable list of catalog materials not already on this line item. */
	_addMaterialHTML()
	{
		const tmpLineItem = this._addTarget || {};
		const tmpErrorBanner = this._addError ? `<div class="sp-d-error"><i class="fas fa-triangle-exclamation"></i> ${fEsc(this._addError)}</div>` : '';
		return `<div class="sp-d-head"><div class="sp-d-headrow"><div class="sp-d-kind">Add material</div></div>`
			+ `<div class="sp-d-title">${fEsc(tmpLineItem.Name || 'Line item')}</div><div class="sp-d-subkind">Attach a material to this line item</div></div>`
			+ tmpErrorBanner
			+ `<input id="SamplePlan-MaterialFilter" class="sp-proj-filter" type="text" autocomplete="off" placeholder="Search materials by name or code…" oninput="_Pict.views.SamplePlan.onMaterialFilter(this.value)" />`
			+ `<div id="SamplePlan-MaterialList" class="sp-proj-list"><div class="sp-proj-note"><i class="fas fa-spinner fa-spin"></i> Loading materials…</div></div>`
			+ `<div class="sp-d-actions"><button type="button" class="sp-d-btn" onclick="_Pict.views.SamplePlan.cancelAdd()">Cancel</button></div>`;
	}

	/** Debounced material search (into #SamplePlan-MaterialList). */
	onMaterialFilter(pValue)
	{
		if (this._materialFilterTimer) { clearTimeout(this._materialFilterTimer); }
		this._materialFilterTimer = setTimeout(() => { this._loadMaterials(pValue); }, 200);
	}

	_loadMaterials(pTerm)
	{
		const tmpProvider = this.provider;
		const tmpTarget = this._addTarget;
		if (!tmpProvider || !tmpTarget) { return; }
		const tmpToken = (this._materialLoadToken = (this._materialLoadToken || 0) + 1);
		tmpProvider.searchMaterialsAsync(pTerm, tmpTarget.IDLineItem).then((pMaterials) =>
		{
			if (tmpToken === this._materialLoadToken) { this._renderMaterialList(pMaterials, pTerm); }
		}).catch(() =>
		{
			if (tmpToken === this._materialLoadToken) { this.pict.ContentAssignment.assignContent('#SamplePlan-MaterialList', '<div class="sp-proj-note sp-proj-err">Could not load materials.</div>'); }
		});
	}

	_renderMaterialList(pMaterials, pTerm)
	{
		const tmpMount = this.pict.ContentAssignment.getElement('#SamplePlan-MaterialList');
		if (!tmpMount || (tmpMount.length === 0)) { return; }
		const tmpList = Array.isArray(pMaterials) ? pMaterials : [];
		this._materialResults = tmpList;   // so addMaterialPick can recover the chosen record (with UnitsImperial)
		if (!tmpList.length)
		{
			const tmpTerm = String(pTerm == null ? '' : pTerm).trim();
			this.pict.ContentAssignment.assignContent('#SamplePlan-MaterialList', `<div class="sp-proj-note">${tmpTerm ? `No materials match “${fEsc(tmpTerm)}”.` : 'No materials available.'}</div>`);
			return;
		}
		const tmpRows = tmpList.map((pMaterial) =>
		{
			const tmpCode = pMaterial.MaterialCode ? fEsc(pMaterial.MaterialCode) : '';
			return `<button type="button" class="sp-proj-row" onclick="_Pict.views.SamplePlan.addMaterialPick(${Number(pMaterial.IDMaterial)})">`
				+ `<span class="sp-proj-name">${fEsc(pMaterial.Name)}</span><span class="sp-proj-year">${tmpCode}</span>`
				+ `<span class="sp-proj-go"><i class="fas fa-plus"></i></span></button>`;
		}).join('');
		const tmpCapNote = (tmpList.length >= 100) ? '<div class="sp-proj-note sp-proj-cap">Showing the first 100 — narrow with search.</div>' : '';
		this.pict.ContentAssignment.assignContent('#SamplePlan-MaterialList', tmpRows + tmpCapNote);
	}

	/** Pick a material → create its join, refresh the tree, then flow into adding its first entry. */
	addMaterialPick(pIDMaterial)
	{
		const tmpProvider = this.provider;
		const tmpLineItem = this._addTarget;
		if (!tmpProvider || !tmpLineItem) { return; }
		const tmpMaterial = (this._materialResults || []).find((pMaterial) => Number(pMaterial.IDMaterial) === Number(pIDMaterial));
		if (!tmpMaterial) { return; }
		this._addError = '';
		this.pict.ContentAssignment.assignContent('#SamplePlan-MaterialList', '<div class="sp-proj-note"><i class="fas fa-spinner fa-spin"></i> Adding material…</div>');
		tmpProvider.addMaterialAsync(tmpLineItem, tmpMaterial).then((pResult) =>
		{
			if (pResult && pResult.ok)
			{
				const tmpLineItemID = tmpLineItem.IDLineItem;
				this._refreshTreeFolders('Materials', (pNode) => pNode.ParentRecord && (Number(pNode.ParentRecord.IDLineItem) === Number(tmpLineItemID)));
				this._refreshHeader();
				this._beginAddEntry(pResult.material);   // continue inline into the first entry
				return;
			}
			this._addError = (pResult && pResult.error) ? String(pResult.error) : 'Could not add the material.';
			this.renderDetail();
			this._loadMaterials('');
		}).catch((pError) =>
		{
			this._addError = (pError && pError.message) ? pError.message : 'Could not add the material.';
			this.renderDetail();
			this._loadMaterials('');
		});
	}

	/** Abandon the add flow and return to the selected node's detail. */
	cancelAdd()
	{
		this._addMode = null;
		this._addBuffer = null;
		this._addTarget = null;
		this._addError = '';
		this._addSaving = false;
		this._addEntryToken = (this._addEntryToken || 0) + 1;   // invalidate any in-flight add-entry vocab load
		this.renderDetail();
	}

	// Re-derive the meter strip for the detail header (same shapes the tree rows use).
	_meterFor(pSelection)
	{
		const tmpRecord = pSelection.Record || {};
		const fBarTone = (pPercent) => ((pPercent >= 90) ? 'ok' : ((pPercent >= 50) ? 'warn' : 'bad'));
		if (pSelection.Entity === 'Rule')
		{
			if (tmpRecord.Kind === 'cert') { return [ { Kind: 'pill', Tone: 'muted', Text: 'by certificate' } ]; }
			if (tmpRecord.Kind === 'perproject') { return [ { Kind: 'pill', Tone: 'muted', Text: '1 / project' } ]; }
			const tmpPct = (tmpRecord.Required > 0) ? Math.round((tmpRecord.Created / tmpRecord.Required) * 100) : 0;
			return [ { Kind: 'bar', Percent: tmpPct, Tone: fBarTone(tmpPct), Label: `${tmpRecord.Created}/${tmpRecord.Required}` } ];
		}
		const tmpMeters = [];
		if (tmpRecord.SamplesRequired > 0) { const tmpPct = Math.round((tmpRecord.SamplesCreated / tmpRecord.SamplesRequired) * 100); tmpMeters.push({ Kind: 'bar', Percent: tmpPct, Tone: fBarTone(tmpPct), Label: `${tmpRecord.SamplesCreated}/${tmpRecord.SamplesRequired}` }); }
		if (tmpRecord.EntryCount > 0) { tmpMeters.push({ Kind: 'pill', Tone: 'muted', Text: `${tmpRecord.EntryCount} ${tmpRecord.EntryCount === 1 ? 'entry' : 'entries'}` }); }
		return tmpMeters;
	}
}

module.exports = SamplePlan;

module.exports.default_configuration =
{
	ViewIdentifier: 'SamplePlan',
	DefaultRenderable: 'SamplePlanWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.sampleplan-head { display: flex; align-items: center; gap: 0.9rem; max-width: 1180px; margin: 0 auto 1rem; }
.sampleplan-ic { display: inline-flex; align-items: center; justify-content: center; width: 2.6rem; height: 2.6rem; border-radius: 12px;
	background: var(--theme-color-background-tertiary, #eef1f5); color: var(--theme-color-brand-primary, #156dd1); font-size: 1.2rem; flex: 0 0 auto; }
.sampleplan-title { font-size: 1.5rem; font-weight: 700; line-height: 1.1; color: var(--theme-color-text-primary, #1f2733); margin: 0; }
.sampleplan-sub { font-size: 0.92rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.15rem 0 0; }
.sampleplan-docs { margin-left: auto; display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.9rem; flex: 0 0 auto; cursor: pointer; padding: 0.35rem 0.75rem; border: 1px solid var(--theme-color-border, #d6dbe3); border-radius: 6px; background: var(--theme-color-background, #fff); color: var(--theme-color-text-secondary, #5a6573); }
.sampleplan-docs:hover { background: var(--theme-color-background-secondary, #f4f6f9); color: var(--theme-color-text-primary, #1f2733); }
.sp-docnav { margin-bottom: 0.8rem; font-size: 0.85rem; }
.sp-docnav a, .sp-docidx a { cursor: pointer; color: var(--theme-color-brand-primary, #2E7D74); text-decoration: none; }
.sp-docnav a:hover, .sp-docidx a:hover { text-decoration: underline; }
.sp-docidx h1 { font-size: 1.1rem; margin: 0 0 0.6rem; }
.sp-docidx h2 { font-size: 0.95rem; margin: 1rem 0 0.4rem; color: var(--theme-color-text-secondary, #5a6573); }
.sp-docidx ul { margin: 0; padding-left: 1.1rem; }
.sp-docidx li { margin: 0.2rem 0; }
.sp-docidx-loading { color: var(--theme-color-text-muted, #9aa3b1); font-size: 0.9rem; padding: 0.5rem 0; }
.sampleplan-wrap { max-width: 1180px; margin: 0 auto; }
.sp-split { display: flex; gap: 1rem; align-items: flex-start; }
.sp-tree { flex: 1 1 58%; min-width: 0; overflow-x: auto; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 0.7rem 0.8rem; min-height: 60vh; }
.sp-tree .pdex-title { min-width: 5rem; }
.sp-detail { flex: 1 1 42%; min-width: 0; position: sticky; top: 1rem; background: var(--theme-color-background-primary, #fff);
	border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 12px; padding: 1rem 1.1rem; max-height: 82vh; overflow: auto; }
.sp-d-empty { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.9rem; padding: 2.5rem 1rem; text-align: center; }
.sp-d-head { border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); padding-bottom: 0.6rem; margin-bottom: 0.75rem; }
.sp-d-kind { font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); }
.sp-d-title { font-size: 1.05rem; font-weight: 600; margin: 0.1rem 0 0.55rem; line-height: 1.3; }
.sp-d-meters { display: flex; gap: 0.45rem; align-items: center; flex-wrap: wrap; }
.sp-d-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; margin-bottom: 1rem; }
.sp-d-field { background: var(--theme-color-background-tertiary, #f6f8fb); border-radius: 8px; padding: 0.4rem 0.6rem; }
.sp-d-flabel { font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); }
.sp-d-fval { font-size: 0.9rem; font-weight: 500; margin-top: 0.05rem; }
.sp-d-docs-h { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5a6573); margin-bottom: 0.5rem; }
.sp-d-docs-src { font-weight: 400; color: var(--theme-color-text-muted, #9aa3b1); text-transform: none; letter-spacing: 0; }
.sp-d-doc { border: 1px solid var(--theme-color-border-light, #eef1f5); border-left: 3px solid var(--theme-color-brand-primary, #156dd1); border-radius: 8px; padding: 0.45rem 0.6rem; margin-bottom: 0.45rem; }
.sp-d-dochead { display: flex; justify-content: space-between; align-items: baseline; gap: 0.5rem; margin-bottom: 0.2rem; }
.sp-d-doclabel { font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-secondary, #5a6573); }
.sp-d-dochash { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.66rem; color: var(--theme-color-text-muted, #aab2bf); }
.sp-d-docbody { font-size: 0.85rem; line-height: 1.5; white-space: pre-wrap; }
.sp-d-docempty { color: var(--theme-color-text-muted, #aab2bf); font-style: italic; }
.sampleplan-picker { max-width: 640px; margin: 1.5rem auto; }
.sp-proj-h { font-size: 1.15rem; font-weight: 700; color: var(--theme-color-text-primary, #1f2733); margin: 0 0 0.2rem; }
.sp-proj-sub { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.9rem; }
.sp-proj-filter { width: 100%; box-sizing: border-box; font-size: 0.95rem; padding: 0.55rem 0.75rem; margin: 0 0 0.7rem;
	border: 1px solid var(--theme-color-border, #d6dbe3); border-radius: 8px; background: var(--theme-color-background-input, #fff); color: var(--theme-color-text-primary, #1f2733); }
.sp-proj-filter:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1); box-shadow: 0 0 0 2px var(--theme-color-brand-primary-faded, rgba(21, 109, 209, 0.18)); }
.sp-proj-list { border: 1px solid var(--theme-color-border-light, #eef1f5); border-radius: 10px; overflow: hidden; background: var(--theme-color-background-primary, #fff); }
.sp-proj-row { display: flex; align-items: center; gap: 0.6rem; width: 100%; text-align: left; box-sizing: border-box; cursor: pointer;
	padding: 0.6rem 0.85rem; border: none; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); background: transparent; color: var(--theme-color-text-primary, #1f2733); font-size: 0.92rem; }
.sp-proj-row:last-child { border-bottom: none; }
.sp-proj-row:hover { background: var(--theme-color-background-secondary, #f4f6f9); }
.sp-proj-name { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sp-proj-head { display: flex; align-items: center; gap: 0.6rem; padding: 0.4rem 0.85rem; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-secondary, #f4f6f9); border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
.sp-proj-year { flex: 0 0 5.5rem; text-align: right; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; color: var(--theme-color-text-secondary, #5a6573); }
.sp-proj-head .sp-proj-year { font-family: inherit; }
.sp-proj-go { flex: 0 0 1rem; text-align: center; color: var(--theme-color-text-muted, #b3bcc9); font-size: 0.8rem; }
.sp-proj-row:hover .sp-proj-go { color: var(--theme-color-brand-primary, #156dd1); }
.sp-proj-note { padding: 0.85rem 0.9rem; font-size: 0.88rem; color: var(--theme-color-text-muted, #8a94a3); }
.sp-proj-cap { border-top: 1px solid var(--theme-color-border-light, #eef1f5); font-style: italic; }
.sp-proj-err { color: var(--theme-color-status-danger, #c0392b); }
.sampleplan-state { max-width: 720px; margin: 2rem auto; text-align: center; color: var(--theme-color-text-muted, #6b7686); }
.sp-d-headrow { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; }
.sp-d-subkind { font-size: 0.78rem; color: var(--theme-color-text-muted, #8a94a3); margin-top: 0.2rem; }
.sp-d-editbtn { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.8rem; font-weight: 600; cursor: pointer;
	padding: 0.28rem 0.7rem; border-radius: 6px; border: 1px solid var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-brand-primary, #156dd1); }
.sp-d-editbtn:hover { background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
.sp-d-field-wide { grid-column: 1 / -1; }
.sp-d-fval-long { font-weight: 400; white-space: pre-wrap; line-height: 1.45; }
.sp-d-loadingnote { color: var(--theme-color-text-muted, #9aa3b1); font-size: 0.85rem; padding: 0.4rem 0; }
.sp-d-loadfail { color: var(--theme-color-status-danger, #c0392b); }
.sp-d-loadfail a { color: var(--theme-color-brand-primary, #156dd1); cursor: pointer; text-decoration: underline; }
.sp-d-form { display: flex; flex-direction: column; gap: 0.7rem; margin-bottom: 0.9rem; }
.sp-d-editrow { display: flex; flex-direction: column; gap: 0.28rem; }
.sp-ed-pending { font-style: italic; font-weight: 500; font-size: 0.78rem; color: var(--theme-color-text-muted, #8a94a3); }
.sp-d-editrow .sp-d-flabel { font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); font-weight: 600; }
.sp-d-overhead { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; }
.sp-d-input, .sp-d-select, .sp-d-textarea { width: 100%; box-sizing: border-box; font: inherit; font-size: 0.88rem; padding: 0.42rem 0.55rem;
	border: 1px solid var(--theme-color-border, #d6dbe3); border-radius: 6px; background: var(--theme-color-background-input, #fff); color: var(--theme-color-text-primary, #1f2733); }
.sp-d-input:focus, .sp-d-select:focus, .sp-d-textarea:focus { outline: none; border-color: var(--theme-color-brand-primary, #156dd1); box-shadow: 0 0 0 2px var(--theme-color-brand-primary-faded, rgba(21, 109, 209, 0.18)); }
.sp-d-textarea { resize: vertical; min-height: 2.4rem; }
.sp-d-computed { font-size: 0.86rem; color: var(--theme-color-text-secondary, #5a6573); background: var(--theme-color-background-tertiary, #f6f8fb); border-radius: 6px; padding: 0.42rem 0.55rem; }
.sp-d-checkinline, .sp-d-checkline { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; color: var(--theme-color-text-secondary, #5a6573); cursor: pointer; }
.sp-d-checkline { font-weight: 600; }
.sp-d-toggle { display: inline-flex; align-items: center; gap: 0.45rem; font-size: 0.85rem; color: var(--theme-color-text-secondary, #5a6573); }
.sp-d-actions { display: flex; gap: 0.5rem; justify-content: flex-end; border-top: 1px solid var(--theme-color-border-light, #eef1f5); padding-top: 0.7rem; }
.sp-d-btn { font-size: 0.85rem; font-weight: 600; cursor: pointer; padding: 0.42rem 1rem; border-radius: 6px; border: 1px solid var(--theme-color-border, #d6dbe3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-secondary, #5a6573); }
.sp-d-btn:hover { background: var(--theme-color-background-secondary, #f4f6f9); }
.sp-d-btn[disabled] { opacity: 0.6; cursor: default; }
.sp-d-btn-primary { border-color: var(--theme-color-brand-primary, #156dd1); background: var(--theme-color-brand-primary, #156dd1); color: #fff; }
.sp-d-btn-primary:hover { background: var(--theme-color-brand-primary-dark, #115ab0); }
.sp-d-error { font-size: 0.84rem; color: var(--theme-color-status-danger, #c0392b); background: var(--theme-color-status-danger-faded, rgba(192, 57, 43, 0.08)); border: 1px solid var(--theme-color-status-danger, #c0392b); border-radius: 6px; padding: 0.45rem 0.6rem; margin-bottom: 0.7rem; }
.sp-doc-editbar { display: flex; flex-wrap: wrap; align-items: center; gap: 0.4rem; margin-bottom: 0.8rem; padding-bottom: 0.6rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
.sp-doc-editbar-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #8a94a3); }
.sp-doc-editbtn { display: inline-flex; align-items: center; gap: 0.3rem; font-size: 0.76rem; cursor: pointer; padding: 0.2rem 0.55rem; border-radius: 5px; border: 1px solid var(--theme-color-border, #d6dbe3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-brand-primary, #2E7D74); }
.sp-doc-editbtn:hover { background: var(--theme-color-background-secondary, #f4f6f9); }
/* Embedded in a ProjectWorkspace Materials tab: shed the standalone-page chrome (padding / centered container / big head). */
.section.sp-embedded { padding: 0; }
.sp-embedded .container { max-width: none; padding: 0; }
/* Drop the redundant project title (the workspace header + "Materials ▸ Sample Plan" breadcrumb already name it);
   keep the head bar for the Docs button. */
.sp-embedded .sampleplan-head { margin: 0 0 0.5rem; }
.sp-embedded .sampleplan-ic, .sp-embedded .sampleplan-title, .sp-embedded .sampleplan-sub { display: none; }
`,

	Templates:
	[
		{
			Hash: 'SamplePlan-Template',
			Template: html`
				<section class="section {~D:AppData.SamplePlan.EmbedClass~}">
					<div class="container">
						<div class="sampleplan-head">
							<span class="sampleplan-ic"><i class="fas fa-vials"></i></span>
							<div>
								<h1 class="sampleplan-title">{~D:AppData.SamplePlan.TitleText~}</h1>
								<p class="sampleplan-sub">{~D:AppData.SamplePlan.SubText~}</p>
							</div>
							{~TS:SamplePlan-DocsToggle:AppData.SamplePlan.PlanSlot~}
						</div>
						<div class="sampleplan-wrap">
							{~TS:SamplePlan-Loading:AppData.SamplePlan.LoadingSlot~}
							{~TS:SamplePlan-Error:AppData.SamplePlan.ErrorSlot~}
							{~TS:SamplePlan-Picker:AppData.SamplePlan.PickerSlot~}
							{~TS:SamplePlan-Plan:AppData.SamplePlan.PlanSlot~}
						</div>
					</div>
				</section>`,
		},
		{ Hash: 'SamplePlan-DocsToggle', Template: html`<button type="button" class="sampleplan-docs" onclick="_Pict.views.SamplePlan.openDocs()" title="Open the sampling-manual documentation panel"><i class="fas fa-book"></i> Docs</button>` },
		{ Hash: 'SamplePlan-Loading', Template: html`<div class="sampleplan-state"><i class="fas fa-spinner fa-spin"></i> Loading the sample plan…</div>` },
		{ Hash: 'SamplePlan-Error', Template: html`<div class="sampleplan-state"><i class="fas fa-triangle-exclamation"></i> {~D:Record.Message~}</div>` },
		{
			Hash: 'SamplePlan-Picker',
			Template: html`
				<div class="sampleplan-picker">
					<h2 class="sp-proj-h">Open a project’s sample plan</h2>
					<p class="sp-proj-sub">Pick a project from the list below, or type to filter by name.</p>
					<input id="SamplePlan-ProjectFilter" class="sp-proj-filter" type="text" autocomplete="off" placeholder="Filter projects by name…" oninput="_Pict.views.SamplePlan.onProjectFilter(this.value)" />
					<div id="SamplePlan-ProjectList" class="sp-proj-list"><div class="sp-proj-note"><i class="fas fa-spinner fa-spin"></i> Loading projects…</div></div>
				</div>`,
		},
		{
			Hash: 'SamplePlan-Plan',
			Template: html`
				<div class="sp-split">
					<div id="SamplePlan-Tree" class="sp-tree"></div>
					<div id="SamplePlan-Detail" class="sp-detail"><div class="sp-d-empty">Select any row to see its detail, satisfaction, and documentation.</div></div>
				</div>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'SamplePlanWrap',
			TemplateHash: 'SamplePlan-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1472:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * SamplePlanDashboard — the thin standalone screen (#/SamplePlanDashboard[/:IDProject]) that hosts the shareable
 * SamplePlanDashboard provider. It owns only the page chrome: a project picker bar + the dashboard host div. The
 * provider does all the fetching + painting (into #SamplePlanDashboard-Host), so any OTHER view can embed the same
 * dashboard by calling `provider.openInto(idProject, host)` — this view is just one such host.
 */
class SamplePlanDashboardView extends libPictView
{
	get provider() { return this.pict.providers['SamplePlanDashboard']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.mountProjectPicker('#SamplePlanDashboard-ProjectPicker');
			const tmpID = tmpProvider.routeProject;
			if (tmpID) { tmpProvider.openInto(tmpID, '#SamplePlanDashboard-Host'); }
			else { tmpProvider._mount = '#SamplePlanDashboard-Host'; tmpProvider.render(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SamplePlanDashboardView;

module.exports.default_configuration =
{
	ViewIdentifier: 'SamplePlanDashboard',
	DefaultRenderable: 'SamplePlanDashboardWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reusable app-shell Dashboard Mode: the router renders this screen edge-to-edge at the full browser width.
	DashboardMode: true,

	CSS: /*css*/`
		/* Dashboard Mode gives this screen the full browser width (the router drops the app content gutters); zero side
		   padding here keeps the grid edge-to-edge. */
		.spd-page { --spd-gutter: clamp(1rem, 2.2vw, 2rem); padding: 1.25rem var(--spd-gutter) 2rem; }
		.spd-page-bar { display: flex; align-items: center; gap: 0.7rem; margin: 0 0 1.1rem; flex-wrap: wrap; }
		.spd-page-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted,#7a8794); }
		.spd-page-picker { min-width: 22rem; max-width: 34rem; flex: 1 1 22rem; }
	`,

	Templates:
	[
		{
			Hash: 'SamplePlanDashboard-Template',
			Template: html`
				<section class="section spd-page">
					<div class="spd-page-bar">
						<span class="spd-page-label">Project</span>
						<div id="SamplePlanDashboard-ProjectPicker" class="spd-page-picker"></div>
					</div>
					<div id="SamplePlanDashboard-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'SamplePlanDashboardWrap',
			TemplateHash: 'SamplePlanDashboard-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1473:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * SampleQRCodeConfig view — the shell for the bespoke #/SampleQRCodeConfig screen. Thin host: paints the header +
 * a single #SQR-Detail mount and hands rendering to the SampleQRCodeConfig provider (self-loads on first render).
 */
class SampleQRCodeConfig extends libPictView
{
	get provider() { return this.pict.providers.SampleQRCodeConfig; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SampleQRCodeConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'SampleQRCodeConfig',
	DefaultRenderable: 'SampleQRCodeConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.sqr-wrap { padding: 1.25rem 1.5rem 2rem; }
		.sqr-head { margin: 0 0 1rem; }
		.sqr-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.sqr-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:18rem; max-width:44rem; }
		.sqr-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:12rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
		.sqr-field { margin:0 0 1rem; }
		.sqr-field-label { display:block; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.35rem; }
		.sqr-select { font-size:0.9rem; padding:0.42rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); min-width:20rem; max-width:100%; }
		.sqr-customer { font-size:0.98rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-options { display:flex; flex-direction:column; gap:0.7rem; margin:0.2rem 0 1rem; }
		.sqr-option { display:flex; gap:0.75rem; align-items:flex-start; padding:0.85rem 1rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:9px; cursor:pointer; background:var(--theme-color-background-panel,#fff); }
		.sqr-option.is-active { border-color:var(--theme-color-brand-primary,#5650e6); box-shadow:0 0 0 1px var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-background-selected,#f5f5fe); }
		.sqr-option input { margin-top:0.2rem; flex:0 0 auto; }
		.sqr-option-body { flex:1 1 auto; min-width:0; }
		.sqr-option-title { font-size:0.98rem; font-weight:650; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-option-desc { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0.15rem 0 0.4rem; }
		.sqr-option-preview { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); display:flex; align-items:center; gap:0.5rem; }
		.sqr-preview-label { font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#8894a4); }
		.sqr-option-preview code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.86rem; background:var(--theme-color-background-tertiary,#f0f2f6); padding:0.12rem 0.45rem; border-radius:5px; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; margin:0 0 1rem; }
		.sqr-note code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.sqr-savebar { margin-top:0.5rem; }
		.sqr-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
		.sqr-save[disabled] { opacity:0.6; cursor:default; }
		.sqr-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.sqr-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
		.sqr-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0.2rem 0 1rem; }
		.sqr-tab { font-size:0.88rem; font-weight:600; padding:0.45rem 0.95rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.sqr-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.sqr-tab.is-active { color:var(--theme-color-brand-primary,#5650e6); border-bottom-color:var(--theme-color-brand-primary,#5650e6); }
		.sqr-input { font-size:0.86rem; padding:0.38rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); box-sizing:border-box; }
		.sqr-styletoggle { display:flex; gap:0.4rem; }
		.sqr-stylebtn { font-size:0.84rem; font-weight:600; padding:0.35rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.sqr-stylebtn.is-active { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sqr-fields { display:flex; flex-direction:column; gap:0.4rem; }
		.sqr-fieldrow { display:flex; align-items:center; gap:0.5rem; }
		.sqr-fieldkey { flex:0 0 11rem; font-size:0.8rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-secondary,#45505f); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.sqr-fieldname { flex:1 1 auto; min-width:0; }
		.sqr-rc { display:flex; align-items:center; gap:0.3rem; font-size:0.74rem; color:var(--theme-color-text-muted,#8894a4); flex:0 0 auto; }
		.sqr-rcnum { width:3.2rem; }
		.sqr-datefmt { flex:0 0 auto; width:auto; }
		.sqr-fieldremove { flex:0 0 auto; width:1.9rem; height:1.9rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; }
		.sqr-fieldremove:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.sqr-availwrap { display:flex; flex-wrap:wrap; gap:0.4rem; }
		.sqr-avail { font-size:0.8rem; padding:0.28rem 0.6rem; border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:999px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.sqr-avail:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sqr-avail-empty { font-size:0.84rem; color:var(--theme-color-text-muted,#8894a4); }
		.sqr-preview-wrap { margin:1.1rem 0 0.6rem; }
		.sqr-preview { border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:8px; padding:0.8rem; min-height:5rem; background:var(--theme-color-background-tertiary,#f7f9fb); display:flex; align-items:center; justify-content:center; overflow:auto; }
		.sqr-preview-empty { font-size:0.84rem; color:var(--theme-color-text-muted,#8894a4); }
	`,
	Templates:
	[
		{
			Hash: 'SampleQRCodeConfig-Wrap',
			Template: /*html*/`
				<div class="sqr-wrap">
					<div class="sqr-head">
						<h1 class="sqr-title">Sample QR Codes</h1>
						<p class="sqr-subtitle">Choose how new sample QR codes are generated for a customer. This affects only samples created from now on; existing QR codes are unchanged.</p>
					</div>
					<div id="SQR-Detail" class="sqr-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleQRCodeConfigWrap',
			TemplateHash: 'SampleQRCodeConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1474:[function(require,module,exports){
const libPictView = require('pict-view');
const libSampleLocationCartSession = require('../samples/SampleLocationCart-Session.js');

// The page's own cart instance: separate from the panels' Scan Samples and the Sample and Location pages' carts.
const CART_NAME = 'ScanSamplesCart';
const CART_HOST_ID = 'ScanSamplesPage-Cart';
// Its device settings ("Save each scan", the remembered location) are kept apart from the panels' cart's.
const SETTINGS_PREFIX = 'ScanSamplesPage-';

/**
 * The device's storage under this page's own prefix, so the page and the panels' Scan Samples remember their settings
 * separately. Storage the browser refuses (a private window) just keeps nothing.
 * @return {{ getItem: (pKey: string) => string|null, setItem: (pKey: string, pValue: string) => void, removeItem: (pKey: string) => void }}
 */
function deviceStorage()
{
	const fStorage = () =>
	{
		try
		{
			return ((typeof window !== 'undefined') && window.localStorage) ? window.localStorage : null;
		}
		catch (pError)
		{
			return null;
		}
	};
	return {
		getItem: (pKey) =>
		{
			const tmpStorage = fStorage();
			return tmpStorage ? tmpStorage.getItem(`${SETTINGS_PREFIX}${pKey}`) : null;
		},
		setItem: (pKey, pValue) =>
		{
			const tmpStorage = fStorage();
			if (tmpStorage)
			{
				tmpStorage.setItem(`${SETTINGS_PREFIX}${pKey}`, pValue);
			}
		},
		removeItem: (pKey) =>
		{
			const tmpStorage = fStorage();
			if (tmpStorage)
			{
				tmpStorage.removeItem(`${SETTINGS_PREFIX}${pKey}`);
			}
		},
	};
}

/**
 * Scan Samples (#/ScanSamples): the panels' Scan Samples cart as a page of its own; the LIMS micro app's top nav
 * Scanning Cart links here (web/lims/html/index.html). It
 * works as the panel does (pick or scan a location, collect samples and Move all or save each scan right away, Undo,
 * remembered settings, the camera, label printing, the action cards), with its own cart: nothing it holds or remembers
 * is shared with the panel. Leaving the page closes the cart (it stops taking scans and its camera stops).
 */
class ScanSamplesPage extends libPictView
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		/** @type {any} */
		this.options;
	}

	/** @return {any} the page's cart session, made on first use */
	get session()
	{
		if (!this._session)
		{
			this._session = new libSampleLocationCartSession(
				{
					Pict: () => this.pict,
					CartName: CART_NAME,
					HostID: CART_HOST_ID,
					OwnHash: () => '#/ScanSamples',
					Storage: deviceStorage(),
					RememberSettings: true,
					Notify: (pToast) => this.toast(pToast),
					Toast: (pMessage, pType) => this.toast({ message: pMessage, type: (pType === 'error') ? 'is-danger' : ((pType === 'success') ? 'is-success' : 'is-info') }),
					PrintLabel: (pSample) => this.printSampleLabel(pSample),
				});
		}
		return this._session;
	}

	/** @return {any} the page's cart provider, once the page has drawn */
	get cart()
	{
		return this.pict.providers[CART_NAME];
	}

	/**
	 * @param {{ message: string, type: string }} pToast
	 */
	toast(pToast)
	{
		const tmpPanels = this.pict.views.HeadlightPanels;
		if (tmpPanels && (typeof tmpPanels.toast === 'function'))
		{
			tmpPanels.toast(pToast);
			return;
		}
		this.pict.log.info(`ScanSamplesPage: ${pToast.message}`);
	}

	/**
	 * Print a collected sample's label, as the panel does: the customer's label layout, with the sample already in hand.
	 * @param {Record<string, any>} pSample
	 * @return {Promise<void>}
	 */
	async printSampleLabel(pSample)
	{
		const tmpQRCode = this.pict.providers.QRCodeProvider;
		if (!tmpQRCode || !pSample || !pSample.QRCode)
		{
			return;
		}
		await tmpQRCode.ensurePrintableManifests();
		tmpQRCode.printDecoratedEntity('Sample', pSample.QRCode, undefined, undefined, pSample);
	}

	/**
	 * The page was drawn: open the cart in it (or redraw an open one).
	 * @param {any} pRenderable
	 * @return {any}
	 */
	onAfterRender(pRenderable)
	{
		this.session.mount();
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ScanSamplesPage;
module.exports.CART_NAME = CART_NAME;
module.exports.SETTINGS_PREFIX = SETTINGS_PREFIX;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'ScanSamplesPage',
		DefaultRenderable: 'ScanSamplesPage',
		DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',

		AutoRender: false,

		CSS: /*css*/`
			.ssp-cart { max-width: 44rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
			.ssp-cart .hl-scan {
				--hl-scan-background: var(--theme-color-background-panel, var(--theme-color-background-primary, #fff));
				--hl-scan-text: var(--theme-color-text-secondary, #45505f);
				--hl-scan-text-strong: var(--theme-color-text-primary, #1f2733);
				--hl-scan-text-weak: var(--theme-color-text-muted, #8a94a3);
				--hl-scan-border: var(--theme-color-border-light, #e8ebf0);
				--hl-scan-border-weak: var(--theme-color-border-light, #eef1f5);
				--hl-scan-head-background: var(--theme-color-background-tertiary, #f4f6f9);
				--hl-scan-input-background: var(--theme-color-background-primary, #fff);
				--hl-scan-input-text: var(--theme-color-text-primary, #1f2733);
				--hl-scan-input-border: var(--theme-color-border-default, #d7dce3);
			}
		`,

		Templates: [
			{
				Hash: 'ScanSamplesPage-Wrapper',
				Template: /*html*/`
				<section id="ScanSamplesPage" class="form p-5">
					<h2 class="title is-4 mb-3"><span class="icon mr-2"><i class="fas fa-qrcode"></i></span>Scan Samples</h2>
					<div id="${ CART_HOST_ID }" class="ssp-cart"></div>
				</section>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'ScanSamplesPage',
				TemplateHash: 'ScanSamplesPage-Wrapper',
				RenderMethod: 'replace',
			} ],
	});

},{"../samples/SampleLocationCart-Session.js":1394,"pict-view":1053}],1475:[function(require,module,exports){
const libPictView = require('pict-view');

// Browse loads this many materials at a time; "Load more" pulls the next batch. Kept modest because each batch
// is one template pass and a set can transitively reach thousands of materials (2016 Specifications → 2000+).
const BROWSE_BATCH = 250;
// Meadow filter list length guard — chunk the INN lookups so the FilteredTo URL never gets huge.
const INN_CHUNK = 150;
// Server search pulls up to this many global name/code matches, then keeps the ones that belong to THIS set.
// Generous so a set's matches are rarely missed; if the global result hits this, we hint the user to refine.
const SEARCH_LIMIT = 500;
// Don't fire a server search until the term is at least this long — a 1-char LK matches most of the table.
const SEARCH_MIN_CHARS = 2;
// Offer the search box once the set has more than a handful of materials.
const SEARCH_THRESHOLD = 10;
// Debounce keystrokes into one query.
const SEARCH_DEBOUNCE_MS = 300;

/**
 * SpecSetMaterialsTab — a read-only "Materials" tab for a Test Specification Set's read view.
 *
 * Materials are not linked to a SET directly; they link to individual Test Specifications
 * (TestSpecificationMaterialJoin), and each spec belongs to a set (TestSpecification.IDTestSpecificationSet).
 * So "the materials in this set" is a 2-hop:  set → its specs → the materials joined to those specs
 * (de-duplicated). This view resolves the current set id the same way ChildListTab does — from
 * AppData.TestSpecificationSetDetails, the record the read view stashes. Wired in as a { Type: 'View' } read
 * tab (see MasterList-Builder / Headlight-MasterLists).
 *
 * A set can reach thousands of materials, so we don't render them all: the 2-hop resolves the full DISTINCT
 * member-id list once (held in memory), and the tab renders a BROWSE batch (first BROWSE_BATCH, "Load more"
 * for the next). The search box is SERVER-side over the whole set — it queries the Materials table by
 * name/code and keeps only the ids that belong to this set — so any material is findable even when it sits
 * past the loaded browse batch. Browse and search render into two sibling regions (#ssm-browse / #ssm-results)
 * BELOW the search input, so the input is never re-rendered and keeps focus while typing.
 */
class SpecSetMaterialsTab extends libPictView
{
	get restClient()
	{
		return this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
	}

	get destination()
	{
		return this.options.DefaultDestinationAddress || `#PSRS-Tab-Materials`;
	}

	_getJSON(pURL)
	{
		return new Promise((resolve, reject) =>
		{
			this.restClient.getJSON(pURL, (pError, pBody) => (pError ? reject(pError) : resolve(pBody)));
		});
	}

	_setID()
	{
		const tmpSet = this.pict.AppData.TestSpecificationSetDetails || {};
		return tmpSet.IDTestSpecificationSet;
	}

	_escapeHTML(pValue)
	{
		return String((pValue === null || typeof pValue === 'undefined') ? '' : pValue)
			.replace(/[&<>"]/g, (pChar) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[pChar]);
	}

	_chunk(pArray, pSize)
	{
		const tmpChunks = [];
		for (let i = 0; i < pArray.length; i += pSize) { tmpChunks.push(pArray.slice(i, i + pSize)); }
		return tmpChunks;
	}

	_parse(pHash, pRecord)
	{
		return this.pict.parseTemplateByHash(pHash, pRecord || {});
	}

	// --- Data: resolve the set's distinct member material ids (2-hop), then hydrate ids on demand ---

	/**
	 * Resolve the DISTINCT material ids reachable from this set's specs. Returns a numeric id array (no
	 * hydration — just the ids, so we know the full membership without pulling thousands of rows).
	 */
	async _loadMemberIDs(pSetID)
	{
		// Hop 1: the set's Test Specifications — paged to exhaustion (like hop 2's chunking) so a large spec book that
		// exceeds one page doesn't silently truncate the membership that hops 2/3 and the "exact" scoped search rely on.
		const tmpSpecIDs = [];
		const tmpSpecPageSize = 2000;
		for (let tmpBegin = 0; ; tmpBegin += tmpSpecPageSize)
		{
			const tmpSpecs = await this._getJSON(`TestSpecifications/FilteredTo/FBV~IDTestSpecificationSet~EQ~${ pSetID }/${ tmpBegin }/${ tmpSpecPageSize }`);
			const tmpSpecRows = Array.isArray(tmpSpecs) ? tmpSpecs : [];
			tmpSpecRows.forEach((pSpec) => { if (pSpec.IDTestSpecification > 0) { tmpSpecIDs.push(pSpec.IDTestSpecification); } });
			if (tmpSpecRows.length < tmpSpecPageSize) { break; }   // last (short) page
		}
		if (tmpSpecIDs.length < 1) { return []; }

		// Hop 2: the material joins for those specs (chunked INN), de-duplicated to distinct material ids.
		const tmpMaterialIDSet = {};
		for (const tmpChunk of this._chunk(tmpSpecIDs, INN_CHUNK))
		{
			const tmpJoins = await this._getJSON(`TestSpecificationMaterialJoins/FilteredTo/FBL~IDTestSpecification~INN~${ tmpChunk.join(',') }/0/5000`);
			(Array.isArray(tmpJoins) ? tmpJoins : []).forEach((pJoin) => { if (pJoin.IDMaterial > 0) { tmpMaterialIDSet[pJoin.IDMaterial] = true; } });
		}
		return Object.keys(tmpMaterialIDSet).map((pID) => Number(pID));
	}

	/**
	 * Hydrate a list of material ids into records (chunked INN so the URL never gets huge), each chunk sorted
	 * by name.
	 */
	async _hydrate(pIDs)
	{
		const tmpRows = [];
		for (const tmpChunk of this._chunk(pIDs, INN_CHUNK))
		{
			const tmpBatch = await this._getJSON(`Materials/FilteredTo/FBL~IDMaterial~INN~${ tmpChunk.join(',') }~FSF~Name~ASC~0/0/${ INN_CHUNK }`);
			(Array.isArray(tmpBatch) ? tmpBatch : []).forEach((pRow) => tmpRows.push(pRow));
		}
		return tmpRows;
	}

	// --- Row / region HTML builders ---

	_rowRecord(pMaterial)
	{
		return {
			Name: this._escapeHTML(pMaterial.Name || '—'),
			Code: this._escapeHTML(pMaterial.MaterialCode || pMaterial.CatalogCode || '—'),
			Type: this._escapeHTML(pMaterial.Type || '—'),
		};
	}

	// Just the <tr> rows for a set of materials — used to APPEND a freshly-loaded browse batch to the tbody.
	_rowsHTML(pMaterials)
	{
		return this._parse('SpecSetMaterials-Rows', { Rows: pMaterials.map((pMaterial) => this._rowRecord(pMaterial)) });
	}

	// The scrollable table for a set of materials (pBodyID lets the browse tbody be targeted for appends).
	_tableHTML(pMaterials, pBodyID)
	{
		return this._parse('SpecSetMaterials-Table', { Rows: pMaterials.map((pMaterial) => this._rowRecord(pMaterial)), BodyID: pBodyID || '' });
	}

	// The browse footer: an honest "Showing X of Y" (X = rows actually shown, never the id count — some ids can
	// be stale) plus a "Load more" button while ids remain.
	_browseFootHTML()
	{
		const tmpMore = (this._browseCursor < this._total);
		const tmpNote = tmpMore
			? `Showing ${ this._browseShown } of ${ this._total } materials.`
			: `Showing all ${ this._browseShown } material${ (this._browseShown === 1) ? '' : 's' }.`;
		const tmpRemaining = Math.max(0, this._total - this._browseCursor);
		return this._parse('SpecSetMaterials-BrowseFoot',
			{
				Note: tmpNote,
				MoreSlot: tmpMore ? [ { MoreLabel: `Load ${ Math.min(BROWSE_BATCH, tmpRemaining) } more` } ] : [],
			});
	}

	_renderBrowseRegion(pMaterials)
	{
		const tmpHTML = this._tableHTML(pMaterials, 'ssm-browse-body') + `<div id="ssm-browse-foot">${ this._browseFootHTML() }</div>`;
		this.pict.ContentAssignment.assignContent('#ssm-browse', tmpHTML);
	}

	// --- Render entry point: load membership, paint the container + first browse batch ---

	_resetState()
	{
		clearTimeout(this._searchTimer);
		this._memberIDs = [];
		this._memberIDSet = new Set();
		this._total = 0;
		this._browseCursor = 0; // ids consumed from _memberIDs (the browse offset)
		this._browseShown = 0; // rows actually rendered (≤ cursor; some ids can fail to hydrate)
		this._loadingMore = false;
		this._searchSeq = 0;
	}

	/**
	 * The read view's `View` tab type calls renderAsync() with no arguments. Resolve the set's membership,
	 * paint the container (header + search + empty browse/results regions), then hydrate and show the first
	 * browse batch. Guarded so a failed hop shows a notice, not a blank.
	 */
	async renderAsync()
	{
		this._resetState();
		const tmpSetID = this._setID();
		if (!tmpSetID)
		{
			this.pict.ContentAssignment.assignContent(this.destination, `<div class="ssm-note">Select a specification set to see its materials.</div>`);
			return;
		}
		this.pict.ContentAssignment.assignContent(this.destination, `<div class="ssm-note">Loading materials…</div>`);
		try
		{
			this._memberIDs = await this._loadMemberIDs(tmpSetID);
			this._total = this._memberIDs.length;
			this._memberIDSet = new Set(this._memberIDs);

			const tmpState = this.pict.AppData.SpecSetMaterials = this.pict.AppData.SpecSetMaterials || {};
			tmpState.Count = this._total;
			tmpState.SearchSlot = (this._total > SEARCH_THRESHOLD) ? [ {} ] : [];
			tmpState.EmptySlot = (this._total < 1) ? [ {} ] : [];

			const tmpHTML = this._parse('SpecSetMaterials-Container-Template', {});
			this.pict.ContentAssignment.assignContent(this.destination, tmpHTML);

			if (this._total > 0)
			{
				const tmpFirstIDs = this._memberIDs.slice(0, BROWSE_BATCH);
				const tmpMaterials = await this._hydrate(tmpFirstIDs);
				this._browseCursor = tmpFirstIDs.length;
				this._browseShown = tmpMaterials.length;
				this._renderBrowseRegion(tmpMaterials);
			}
			this.pict.CSSMap.injectCSS();
		}
		catch (pError)
		{
			this.pict.log.warn(`SpecSetMaterialsTab: load failed for set ${ tmpSetID }: ${ pError && (pError.message || pError) }`);
			this.pict.ContentAssignment.assignContent(this.destination, `<div class="ssm-note">Could not load the materials for this specification set.</div>`);
		}
	}

	// --- Browse: load the next batch and APPEND it (O(batch), never a full re-parse of the loaded list) ---

	async loadMore()
	{
		if (this._loadingMore) { return; }
		const tmpNextIDs = (this._memberIDs || []).slice(this._browseCursor, this._browseCursor + BROWSE_BATCH);
		if (tmpNextIDs.length < 1) { return; }
		this._loadingMore = true;
		const tmpFoot = document.querySelector('#ssm-browse-foot');
		if (tmpFoot) { tmpFoot.innerHTML = `<div class="ssm-foot"><span class="ssm-foot-note">Loading…</span></div>`; }
		try
		{
			const tmpMaterials = await this._hydrate(tmpNextIDs);
			const tmpBody = document.querySelector('#ssm-browse-body');
			if (tmpBody) { tmpBody.insertAdjacentHTML('beforeend', this._rowsHTML(tmpMaterials)); }
			this._browseCursor += tmpNextIDs.length;
			this._browseShown += tmpMaterials.length;
		}
		catch (pError)
		{
			this.pict.log.warn(`SpecSetMaterialsTab: load-more failed for set ${ this._setID() }: ${ pError && (pError.message || pError) }`);
		}
		this._loadingMore = false;
		const tmpFootAfter = document.querySelector('#ssm-browse-foot');
		if (tmpFootAfter) { tmpFootAfter.innerHTML = this._browseFootHTML(); }
	}

	// --- Search: server-side over the WHOLE set (name/code), exact — never just the loaded browse rows ---

	search(pTerm)
	{
		clearTimeout(this._searchTimer);
		// Strip the structural `~` so a stray tilde can't break the filter stanza; trim edges.
		const tmpTerm = String(pTerm || '').replace(/~/g, '').trim();
		this._searchTimer = setTimeout(() => { this._runSearch(tmpTerm); }, SEARCH_DEBOUNCE_MS);
	}

	async _runSearch(pTerm)
	{
		if (pTerm.length < SEARCH_MIN_CHARS)
		{
			// Too short to query — fall back to the browse view (which is still in the DOM, just hidden).
			this._showBrowse();
			return;
		}
		const tmpSeq = (this._searchSeq = (this._searchSeq || 0) + 1);
		const tmpPending = document.querySelector('#ssm-results');
		if (tmpPending) { tmpPending.innerHTML = `<div class="ssm-note">Searching…</div>`; }
		this._showResults();
		try
		{
			const tmpMatches = await this._searchMembers(pTerm);
			if (tmpSeq !== this._searchSeq) { return; } // a newer keystroke already superseded this one
			this._renderResults(pTerm, tmpMatches);
		}
		catch (pError)
		{
			if (tmpSeq !== this._searchSeq) { return; }
			this.pict.log.warn(`SpecSetMaterialsTab: search failed for “${ pTerm }”: ${ pError && (pError.message || pError) }`);
			const tmpEl = document.querySelector('#ssm-results');
			if (tmpEl) { tmpEl.innerHTML = `<div class="ssm-note">Could not search materials right now.</div>`; }
		}
	}

	// Build the name/code OR-group filter stanza (without a sort). FoxHound FBVOR ORs all prior clauses, so the
	// chain is wrapped in a FOP…FCP group to stay self-contained — it then ANDs cleanly with an INN id scope.
	_searchGroup(pTerm)
	{
		const tmpLike = encodeURIComponent(`%${ pTerm }%`);
		const tmpFields = [ 'Name', 'MaterialCode', 'CatalogCode' ];
		const tmpClauses = tmpFields.map((pField, pIndex) => `${ (pIndex === 0) ? 'FBV' : 'FBVOR' }~${ pField }~LK~${ tmpLike }`).join('~');
		return `FOP~~(~~${ tmpClauses }~FCP~~)~`;
	}

	/**
	 * Find the set's materials matching a name/code term. Fast path: one global query — if it did NOT hit the
	 * cap, every match is present, so intersecting with the set's ids is exact and cheap. Broad terms (global
	 * matches ≥ SEARCH_LIMIT) could hide set-members past the cap, so those fall back to a set-SCOPED search
	 * (the id list chunked into INN filters, each ANDed with the name/code group) — exact, bounded by set size.
	 * Returns the matched material records, name-sorted.
	 */
	async _searchMembers(pTerm)
	{
		const tmpGroup = this._searchGroup(pTerm);
		const tmpGlobal = await this._getJSON(`Materials/FilteredTo/${ tmpGroup }~FSF~Name~ASC~0/0/${ SEARCH_LIMIT }`);
		const tmpGlobalRows = Array.isArray(tmpGlobal) ? tmpGlobal : [];
		if (tmpGlobalRows.length < SEARCH_LIMIT)
		{
			return tmpGlobalRows.filter((pRow) => this._memberIDSet.has(pRow.IDMaterial));
		}
		return this._searchScoped(tmpGroup);
	}

	// Exact set-scoped search: chunk the member ids into INN filters, AND each with the name/code group, union
	// the (deduped) results. Chunks run in parallel; a failed chunk contributes nothing rather than failing all.
	async _searchScoped(pGroup)
	{
		const tmpChunks = this._chunk(this._memberIDs, INN_CHUNK);
		const tmpResults = await Promise.all(tmpChunks.map((pChunk) =>
			this._getJSON(`Materials/FilteredTo/FBL~IDMaterial~INN~${ pChunk.join(',') }~${ pGroup }~FSF~Name~ASC~0/0/${ INN_CHUNK }`).catch(() => [])));
		const tmpSeen = new Set();
		const tmpMatches = [];
		tmpResults.forEach((pRows) => (Array.isArray(pRows) ? pRows : []).forEach((pRow) =>
		{
			if (!tmpSeen.has(pRow.IDMaterial)) { tmpSeen.add(pRow.IDMaterial); tmpMatches.push(pRow); }
		}));
		tmpMatches.sort((pA, pB) => String(pA.Name || '').localeCompare(String(pB.Name || '')));
		return tmpMatches;
	}

	_renderResults(pTerm, pMatches)
	{
		const tmpEl = document.querySelector('#ssm-results');
		if (!tmpEl) { return; }
		const tmpTotal = pMatches.length;
		if (tmpTotal < 1)
		{
			tmpEl.innerHTML = this._parse('SpecSetMaterials-SearchEmpty', { Term: this._escapeHTML(pTerm) });
			return;
		}
		const tmpShown = pMatches.slice(0, BROWSE_BATCH);
		const tmpParts = [ `${ tmpTotal } material${ (tmpTotal === 1) ? '' : 's' } in this set match${ (tmpTotal === 1) ? 'es' : '' } “${ this._escapeHTML(pTerm) }”.` ];
		if (tmpTotal > tmpShown.length) { tmpParts.push(`Showing the first ${ tmpShown.length }.`); }
		tmpEl.innerHTML = this._tableHTML(tmpShown, 'ssm-results-body') + `<div class="ssm-foot"><span class="ssm-foot-note">${ tmpParts.join(' ') }</span></div>`;
	}

	// Toggle the two regions. The search input lives above both and is never re-rendered, so it keeps focus.
	_showResults()
	{
		const tmpBrowse = document.querySelector('#ssm-browse');
		const tmpResults = document.querySelector('#ssm-results');
		if (tmpBrowse) { tmpBrowse.style.display = 'none'; }
		if (tmpResults) { tmpResults.style.display = ''; }
	}

	_showBrowse()
	{
		const tmpResults = document.querySelector('#ssm-results');
		const tmpBrowse = document.querySelector('#ssm-browse');
		if (tmpResults) { tmpResults.style.display = 'none'; tmpResults.innerHTML = ''; }
		if (tmpBrowse) { tmpBrowse.style.display = ''; }
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

const _DEFAULT_CONFIGURATION =
{
	ViewIdentifier: 'SpecSetMaterials',
	DefaultDestinationAddress: '#PSRS-Tab-Materials',
	DefaultRenderable: 'SpecSetMaterials-Container',

	CSS: /*css*/`
.ssm-wrap { padding: 0.25rem 0; }
.ssm-head { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6); margin-bottom: 0.5rem; }
.ssm-count { display: inline-block; margin-left: 0.4rem; padding: 0.02rem 0.5rem; border-radius: 999px; font-size: 0.72rem; font-weight: 700; background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-secondary, #45505f); }
.ssm-note { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); padding: 0.5rem 0; }
.ssm-search { margin: 0 0 0.6rem; }
.ssm-search-input { width: 100%; box-sizing: border-box; padding: 0.4rem 0.7rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 8px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); font: inherit; font-size: 0.88rem; }
.ssm-search-input:focus { outline: none; border-color: var(--theme-color-brand-primary, #5650e6); }
.ssm-scroll { overflow-x: auto; }
.ssm-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
.ssm-table th { position: sticky; top: 0; background: var(--theme-color-background-primary, #fff); text-align: left; font-weight: 600; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); padding: 0.4rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); white-space: nowrap; }
.ssm-table td { padding: 0.45rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f6); color: var(--theme-color-text-primary, #1f2733); }
.ssm-table td.ssm-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.82rem; white-space: nowrap; }
.ssm-table tbody tr:hover { background: var(--theme-color-background-tertiary, #f4f6f9); }
.ssm-foot { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; padding: 0.45rem 0 0.15rem; }
.ssm-foot-note { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); }
.ssm-more-btn { display: inline-flex; align-items: center; gap: 0.3rem; border: 1px solid var(--theme-color-border-default, #d7dce3); background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-secondary, #45505f); border-radius: 7px; padding: 0.3rem 0.75rem; font: inherit; font-size: 0.82rem; font-weight: 600; cursor: pointer; white-space: nowrap; transition: all 0.12s ease; }
.ssm-more-btn:hover { border-color: var(--theme-color-brand-primary, #5650e6); color: var(--theme-color-brand-primary, #5650e6); }
`,

	Templates:
	[
		{
			Hash: 'SpecSetMaterials-Container-Template',
			Template: /*html*/`
				<div class="ssm-wrap">
					<div class="ssm-head">Materials <span class="ssm-count">{~D:AppData.SpecSetMaterials.Count~}</span></div>
					{~TS:SpecSetMaterials-Search:AppData.SpecSetMaterials.SearchSlot~}
					{~TS:SpecSetMaterials-Empty:AppData.SpecSetMaterials.EmptySlot~}
					<div id="ssm-browse" class="ssm-region"></div>
					<div id="ssm-results" class="ssm-region" style="display:none"></div>
				</div>`
		},
		{
			// Shown only when the set is more than a handful (SearchSlot). Fires a server search over the WHOLE
			// set (see search()/_searchMembers). The view id is fixed (registered once as 'SpecSetMaterials').
			Hash: 'SpecSetMaterials-Search',
			Template: /*html*/`<div class="ssm-search"><input class="ssm-search-input" type="text" placeholder="Search materials by name or code…" oninput="_Pict.views['SpecSetMaterials'].search(this.value)" /></div>`
		},
		{
			// Record: { Rows, BodyID }. BodyID lets the browse tbody be targeted for "Load more" appends.
			Hash: 'SpecSetMaterials-Table',
			Template: /*html*/`<div class="ssm-scroll"><table class="ssm-table"><thead><tr><th>Material</th><th>Code</th><th>Type</th></tr></thead><tbody id="{~D:Record.BodyID~}">{~TS:SpecSetMaterials-Row:Record.Rows~}</tbody></table></div>`
		},
		{
			// Just the rows — used to append a freshly-loaded browse batch to an existing tbody.
			Hash: 'SpecSetMaterials-Rows',
			Template: /*html*/`{~TS:SpecSetMaterials-Row:Record.Rows~}`
		},
		{
			Hash: 'SpecSetMaterials-Row',
			Template: /*html*/`<tr><td>{~D:Record.Name~}</td><td class="ssm-mono">{~D:Record.Code~}</td><td>{~D:Record.Type~}</td></tr>`
		},
		{
			// Record: { Note, MoreSlot:[{ MoreLabel }] } — the browse footer note + optional "Load more" button.
			Hash: 'SpecSetMaterials-BrowseFoot',
			Template: /*html*/`<div class="ssm-foot"><span class="ssm-foot-note">{~D:Record.Note~}</span>{~TS:SpecSetMaterials-More:Record.MoreSlot~}</div>`
		},
		{
			Hash: 'SpecSetMaterials-More',
			Template: /*html*/`<button type="button" class="ssm-more-btn" onclick="_Pict.views['SpecSetMaterials'].loadMore()">{~D:Record.MoreLabel~}</button>`
		},
		{
			Hash: 'SpecSetMaterials-Empty',
			Template: /*html*/`<div class="ssm-note">No materials are associated with the specifications in this set.</div>`
		},
		{
			Hash: 'SpecSetMaterials-SearchEmpty',
			Template: /*html*/`<div class="ssm-note">No materials in this set match “{~D:Record.Term~}”.</div>`
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'SpecSetMaterials-Container',
			TemplateHash: 'SpecSetMaterials-Container-Template',
			DestinationAddress: '#PSRS-Tab-Materials',
			RenderMethod: 'replace',
		},
	],
};

module.exports = SpecSetMaterialsTab;
module.exports.default_configuration = _DEFAULT_CONFIGURATION;

},{"pict-view":1053}],1476:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * SuperUserGrant — the #/GrantAccess screen. A bespoke, platform-super-user-only bootstrap tool: search ALL
 * users across every customer and grant a selected user the `Permission-Grant` capability (the right to grant
 * permissions), scoped to that user's own customer.
 *
 * This exists to break the chicken-and-egg: normal role/entitlement administration itself requires Permission-Grant,
 * so a customer with nobody holding it has no in-app way to bootstrap the first grantor. A level-5 super-user uses
 * this to seed that first person; from there the #/Entitlements and #/Access workspaces take over.
 *
 * The view is a thin shell (like Entitlements.js) — all logic + data + hand-built HTML live in the
 * SuperUserGrantProvider, which assigns into the #SUG-Body mount and writes through the RBAC grant path.
 */
class SuperUserGrant extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.SuperUserGrant; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SuperUserGrant;
module.exports.default_configuration =
{
	ViewIdentifier: 'SuperUserGrant',
	DefaultRenderable: 'SuperUserGrantWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.sug-wrap { padding: 1.25rem 1.5rem 2rem; }
		.sug-head { margin: 0 0 1rem; }
		.sug-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.sug-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; max-width:60rem; }
		.sug-guard { border:1px solid var(--theme-color-status-warning,#b8860b); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.5rem; text-align:center; color:var(--theme-color-text-secondary,#45505f); }
		.sug-guard-title { font-size:1.05rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.4rem; }
		.sug-filterbar { display:flex; gap:1rem; align-items:flex-end; flex-wrap:wrap; margin:0 0 1rem; }
		.sug-filter-field { display:flex; flex-direction:column; gap:0.3rem; }
		.sug-filter-label { font-size:0.7rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); }
		.sug-filter-customer { flex:0 0 auto; min-width:16rem; }
		.sug-filter-search { flex:1 1 22rem; }
		.sug-customer-picker { min-width:16rem; }
		.sug-search { width:100%; font-size:0.95rem; padding:0.55rem 0.75rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; box-sizing:border-box; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.sug-search:focus { outline:none; border-color:var(--theme-color-primary,#2f6fed); box-shadow:0 0 0 2px rgba(47,111,237,0.15); }
		.sug-cols { display:grid; grid-template-columns: 22rem 1fr; gap:1.1rem; align-items:start; }
		@media (max-width: 860px) { .sug-cols { grid-template-columns: 1fr; } }
		.sug-results { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.5rem; max-height:42rem; overflow:auto; }
		.sug-result { padding:0.5rem 0.6rem; border-radius:6px; cursor:pointer; border:1px solid transparent; }
		.sug-result:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.sug-result.is-active { background:var(--theme-color-brand-primary,#2e7d74); border-color:var(--theme-color-brand-primary,#2e7d74); }
		.sug-result.is-active .sug-result-name, .sug-result.is-active .sug-result-meta { color:#fff; }
		.sug-result-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.sug-result-meta { font-size:0.76rem; color:var(--theme-color-text-muted,#6b7686); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.sug-results-head { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#6b7686); padding:0.25rem 0.5rem 0.5rem; }
		.sug-result-tag { display:inline-block; margin-left:0.45rem; font-size:0.64rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.05rem 0.4rem; border-radius:999px; background:var(--theme-color-background-tertiary,#eef1f6); color:var(--theme-color-text-secondary,#45505f); vertical-align:middle; }
		.sug-result.is-active .sug-result-tag { background:rgba(255,255,255,0.22); color:#fff; }
		.sug-result-tag-off { background:rgba(192,57,43,0.12) !important; color:#b23b2e !important; }
		.sug-link { color:var(--theme-color-primary,#2f6fed); cursor:pointer; text-decoration:underline; }
		.sug-hint, .sug-results-empty { font-size:0.82rem; color:var(--theme-color-text-muted,#8894a4); padding:0.6rem; }
		.sug-detail, .sug-detail-empty { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:20rem; }
		.sug-detail-empty { display:flex; align-items:center; justify-content:center; text-align:center; color:var(--theme-color-text-muted,#6b7686); }
		.sug-detail-name { font-size:1.2rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.sug-detail-sub { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.sug-facts { list-style:none; margin:0.9rem 0 1.1rem; padding:0; display:grid; grid-template-columns:auto 1fr; gap:0.3rem 1rem; font-size:0.86rem; }
		.sug-facts dt { color:var(--theme-color-text-muted,#6b7686); }
		.sug-facts dd { margin:0; color:var(--theme-color-text-primary,#1f2733); font-weight:600; }
		.sug-status { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.85rem; font-weight:600; padding:0.25rem 0.6rem; border-radius:999px; }
		.sug-status-granted { color:#0b6b3a; background:rgba(16,150,80,0.12); }
		.sug-status-none { color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#eef1f6); }
		.sug-actions { margin-top:1.1rem; display:flex; align-items:center; gap:0.7rem; flex-wrap:wrap; }
		.sug-btn { font-size:0.86rem; font-weight:600; padding:0.5rem 1rem; border-radius:7px; cursor:pointer; border:1px solid transparent; }
		.sug-btn[disabled] { opacity:0.5; cursor:default; }
		.sug-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); }
		.sug-btn-ghost { color:var(--theme-color-text,#22303f); background:transparent; border-color:var(--theme-color-border-medium,#d5dbe3); }
		.sug-busy { font-size:0.84rem; color:var(--theme-color-primary,#2f6fed); font-weight:600; }
		.sug-note { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0.9rem 0 0; }
		.sug-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0.7rem 0 0; }
		.sug-ok { font-size:0.85rem; color:#0b6b3a; margin:0.7rem 0 0; }
		.sug-scope { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-tertiary,#eef1f6); border-radius:7px; padding:0.55rem 0.7rem; margin:0.9rem 0 0; }
			.sug-cap { border:1px solid var(--theme-color-border-light,#e6eaf1); border-radius:8px; padding:0.85rem 1rem; margin:1rem 0 0; }
			.sug-cap-head { display:flex; align-items:center; justify-content:space-between; gap:0.6rem; flex-wrap:wrap; }
			.sug-cap-title { font-size:0.95rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
			.sug-cap .sug-scope { margin-top:0.55rem; }
			.sug-cap .sug-actions { margin-top:0.7rem; }
			.sug-cap code { font-size:0.85em; background:var(--theme-color-background-tertiary,#eef1f6); padding:0.05rem 0.3rem; border-radius:4px; color:var(--theme-color-text-primary,#1f2733); }
	`,
	Templates:
	[
		{
			Hash: 'SuperUserGrant-Wrap',
			Template: /*html*/`
				<div class="sug-wrap">
					<div class="sug-head">
						<h1 class="sug-title">Grant Access</h1>
						<p class="sug-subtitle">Bootstrap tool for platform super-users. Search any user across every customer and give them <strong>Permission&#8209;Grant</strong> — the right to grant permissions — scoped to their own customer. Use this to seed the first grantor for a customer; after that, the Entitlements and Access &amp; Permissions workspaces take over.</p>
					</div>
					<div id="SUG-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SuperUserGrantWrap',
			TemplateHash: 'SuperUserGrant-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1477:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * Support — the thin standalone screen (#/Support) hosting the customer-support console. The Support provider paints
 * the whole surface (call triage list + create/edit form + approval actions) into #Support-Host. Full browser width
 * via Dashboard Mode. See [[Support-Provider.js]] and [[config-app-support-portal]].
 */
class SupportView extends libPictView
{
	get provider() { return this.pict.providers['Support']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._mount = '#Support-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SupportView;

module.exports.default_configuration =
{
	ViewIdentifier: 'Support',
	DefaultRenderable: 'SupportWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.sup-page { padding: 1.25rem 2rem 2rem; }
		.sup-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.sup-page-h i { color: var(--theme-color-brand-primary,#5650e6); }
		.sup-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1.1rem; }

		/* Toolbar */
		.sup-toolbar { display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; margin-bottom:1rem; }
		.sup-chips { display:flex; gap:0.4rem; flex-wrap:wrap; }
		.sup-chip { display:inline-flex; align-items:center; gap:0.4rem; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); border-radius:999px; padding:0.35rem 0.8rem; font:600 0.82rem/1 inherit; cursor:pointer; transition:background .12s, border-color .12s, color .12s; }
		.sup-chip:hover { background:var(--theme-color-background-secondary,#f0f2f6); }
		.sup-chip .sup-chip-n { background:rgba(0,0,0,0.06); border-radius:999px; padding:0.05rem 0.45rem; font-size:0.75rem; }
		.sup-chip-active { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); box-shadow:inset 0 0 0 1px var(--theme-color-brand-primary,#5650e6); }
		.sup-toolbar-right { display:flex; align-items:center; gap:0.6rem; }
		.sup-search { display:flex; align-items:center; gap:0.45rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; padding:0.35rem 0.7rem; background:var(--theme-color-background-primary,#fff); }
		.sup-search i { color:var(--theme-color-text-muted,#9aa3b1); font-size:0.85rem; }
		.sup-search input { border:none; outline:none; background:transparent; font:0.9rem inherit; min-width:12rem; color:var(--theme-color-text-primary,#1f2733); }

		/* Buttons */
		.sup-btn { display:inline-flex; align-items:center; gap:0.4rem; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); border-radius:8px; padding:0.45rem 0.9rem; font:600 0.88rem/1 inherit; cursor:pointer; transition:background .12s, border-color .12s; }
		.sup-btn:hover { background:var(--theme-color-background-secondary,#f0f2f6); }
		.sup-btn-primary { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-btn-primary:hover { filter:brightness(1.05); background:var(--theme-color-brand-primary,#5650e6); }
		.sup-btn[disabled] { opacity:0.6; cursor:default; }
		.sup-inline-busy { color:var(--theme-color-text-muted,#9aa3b1); }

		/* Filter bar — Priority / Category / App multi-select dropdowns */
		.sup-filterbar { display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap; margin:0 0 0.7rem; }
		.sup-fb-label { font-size:0.68rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#9aa3b1); font-weight:800; }
		.sup-dd { position:relative; }
		.sup-dd-btn { display:inline-flex; align-items:center; gap:0.35rem; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); border-radius:8px; padding:0.35rem 0.7rem; font:600 0.82rem/1 inherit; cursor:pointer; }
		.sup-dd-btn:hover { background:var(--theme-color-background-secondary,#f0f2f6); }
		.sup-dd-btn > i { font-size:0.65rem; opacity:0.7; }
		.sup-dd-active { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-dd-badge { background:var(--theme-color-brand-primary,#5650e6); color:#fff; border-radius:999px; padding:0.02rem 0.4rem; font-size:0.68rem; margin-left:0.15rem; }
		/* Designated-date range filter — two native date inputs inline in the filter bar */
		.sup-dd-daterange { display:inline-flex; align-items:center; gap:0.35rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; padding:0.2rem 0.5rem; background:var(--theme-color-background-primary,#fff); }
		.sup-dd-daterange.sup-dd-on { border-color:var(--theme-color-brand-primary,#5650e6); }
		.sup-dd-dr-label { font-size:0.74rem; font-weight:700; color:var(--theme-color-text-muted,#6b7686); display:inline-flex; align-items:center; gap:0.3rem; }
		.sup-dd-daterange.sup-dd-on .sup-dd-dr-label { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-date-in { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:6px; padding:0.2rem 0.35rem; font:600 0.78rem/1 inherit; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-primary,#fff); }
		.sup-date-sep { color:var(--theme-color-text-muted,#9aa3b1); font-size:0.8rem; }
		.sup-dd-panel { position:absolute; top:calc(100% + 4px); left:0; z-index:30; min-width:12rem; background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; box-shadow:0 6px 20px rgba(0,0,0,.12); padding:0.3rem; max-height:16rem; overflow:auto; }
		.sup-dd-item { display:flex; align-items:center; gap:0.5rem; padding:0.35rem 0.5rem; border-radius:6px; cursor:pointer; font-size:0.85rem; color:var(--theme-color-text-primary,#1f2733); white-space:nowrap; }
		.sup-dd-item:hover { background:var(--theme-color-background-secondary,#f0f2f6); }
		.sup-dd-item i { color:var(--theme-color-text-muted,#c2c8d2); width:0.9rem; }
		.sup-dd-item.sup-dd-on i { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-fb-clear { border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); font:600 0.8rem/1 inherit; cursor:pointer; display:inline-flex; align-items:center; gap:0.3rem; }
		.sup-fb-clear:hover { color:#b3261e; }
		.sup-fb-count { margin-left:auto; font-size:0.78rem; color:var(--theme-color-text-muted,#8894a4); font-variant-numeric:tabular-nums; }

		/* Dense call table */
		.sup-listwrap { border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:10px; overflow-x:auto; overflow-y:hidden; background:var(--theme-color-background-primary,#fff); }
		.sup-table { width:100%; min-width:52rem; border-collapse:collapse; font-size:0.86rem; }
		.sup-th { text-align:left; font-size:0.66rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#8894a4); font-weight:800; padding:0.5rem 0.7rem; white-space:nowrap; cursor:pointer; user-select:none; background:var(--theme-color-background-secondary,#f4f6f9); border-bottom:1px solid var(--theme-color-border-default,#e2e6ee); }
		.sup-th:hover { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-th-sorted { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-th-caret { font-size:0.8rem; }
		.sup-th-ord { font-size:0.58rem; vertical-align:super; opacity:0.8; margin-left:0.05rem; }
		/* Each call is a <tbody> group: a compact metadata row + a full-width summary line beneath it. */
		.sup-callgroup { cursor:pointer; border-bottom:1px solid var(--theme-color-border-default,#e2e6ee); transition:background .1s; }
		.sup-callgroup:last-child { border-bottom:none; }
		.sup-callgroup:hover td { background:var(--theme-color-background-secondary,#f5f7fb); }
		.sup-table td { padding:0.35rem 0.7rem; vertical-align:middle; }
		.sup-tr-meta td { padding-top:0.6rem; padding-bottom:0.15rem; }
		.sup-tr-sum td { padding-top:0.05rem; padding-bottom:0.65rem; }
		.sup-sumcell { line-height:1.4; }
		.sup-summary-txt { font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.sup-col-date { white-space:nowrap; color:var(--theme-color-text-muted,#6b7686); font-size:0.8rem; }
		.sup-col-caller { color:var(--theme-color-text-secondary,#45505f); white-space:nowrap; }
		.sup-col-updby { color:var(--theme-color-text-secondary,#45505f); white-space:nowrap; font-size:0.82rem; max-width:11rem; overflow:hidden; text-overflow:ellipsis; }
		.sup-col-cust { max-width:12rem; }
		.sup-cust { font-weight:600; color:var(--theme-color-text-primary,#1f2733); display:block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.sup-fb-cap { font-size:0.75rem; color:#b4620a; display:inline-flex; align-items:center; gap:0.25rem; }
		.sup-col-fu, .sup-col-go { text-align:center; color:var(--theme-color-text-muted,#c2c8d2); width:1.6rem; }
		.sup-fu-on { color:#b4620a; }
		.sup-row-id { color:var(--theme-color-text-muted,#aab2bf); font-size:0.72rem; margin-left:0.55rem; white-space:nowrap; }
		.sup-muted { color:var(--theme-color-text-muted,#c2c8d2); }
		.sup-empty-cell { padding:2rem; text-align:center; color:var(--theme-color-text-muted,#8894a4); }
		.sup-pager { position:sticky; left:0; display:flex; align-items:center; justify-content:center; gap:0.9rem; padding:0.7rem 0.9rem; border-top:1px solid var(--theme-color-border-default,#e2e6ee); background:var(--theme-color-background-primary,#fff); }
		.sup-pager-top { border-top:none; border-bottom:1px solid var(--theme-color-border-default,#e2e6ee); }
		.sup-pg { border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); font:700 0.8rem/1 inherit; padding:0.42rem 0.75rem; border-radius:7px; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; }
		.sup-pg:hover:not([disabled]) { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-pg[disabled] { opacity:0.45; cursor:default; }
		.sup-pg-info { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); font-variant-numeric:tabular-nums; }
		.sup-tag { display:inline-block; background:var(--theme-color-background-secondary,#eef1f6); border-radius:5px; padding:0.1rem 0.45rem; font-size:0.75rem; color:var(--theme-color-text-secondary,#45505f); white-space:nowrap; }
		.sup-tag-app { background:#eef2ff; color:#3a44b8; }

		/* Status badges + chips share color roles */
		.sup-badge { display:inline-flex; align-items:center; gap:0.35rem; border-radius:999px; padding:0.2rem 0.6rem; font:600 0.78rem/1 inherit; white-space:nowrap; }
		.sup-st-new    { background:#eef2ff; color:#3a44b8; } .sup-chip.sup-st-new .sup-chip-n{ color:#3a44b8; }
		.sup-st-ack    { background:#e7f0ff; color:#2f5fd0; }
		.sup-st-t1     { background:#fff4e5; color:#a15c00; }
		.sup-st-t2     { background:#fde8d6; color:#b4530a; }
		.sup-st-t3     { background:#fdecef; color:#a3324b; }
		.sup-st-done   { background:#e7f6ec; color:#1f7a44; }
		.sup-st-void   { background:#eceef2; color:#6b7280; }

		/* Priority pills */
		.sup-prio { border-radius:5px; padding:0.1rem 0.45rem; font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.02em; }
		.sup-prio-urgent { background:#fde7e7; color:#b3261e; }
		.sup-prio-high { background:#fff1e0; color:#b4620a; }
		.sup-prio-normal { background:#eef1f6; color:#5a6473; }
		.sup-prio-low { background:#eef1f6; color:#8a93a1; }

		/* Form surface */
		.sup-form-head { display:flex; align-items:flex-start; justify-content:space-between; gap:1rem; flex-wrap:wrap; margin-bottom:0.5rem; }
		.sup-back { display:inline-flex; align-items:center; gap:0.35rem; color:var(--theme-color-text-muted,#6b7686); font-size:0.85rem; cursor:pointer; text-decoration:none; }
		.sup-back:hover { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-form-title { font-size:1.25rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); margin:0.15rem 0 0; }
		.sup-form-actions { display:flex; align-items:center; gap:0.5rem; }
		.sup-approval { display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; background:var(--theme-color-background-secondary,#f5f7fb); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:10px; padding:0.6rem 0.9rem; margin:0.5rem 0 1rem; }
		.sup-approval-status { display:flex; align-items:center; gap:0.6rem; }
		.sup-approval-label { font-size:0.75rem; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#9aa3b1); font-weight:700; }
		.sup-lock { font-size:0.78rem; color:#a3324b; }
		.sup-approval-actions { display:flex; align-items:center; gap:0.4rem; flex-wrap:wrap; }
		.sup-act { display:inline-flex; align-items:center; gap:0.35rem; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); border-radius:8px; padding:0.4rem 0.8rem; font:600 0.84rem/1 inherit; cursor:pointer; color:var(--theme-color-text-primary,#1f2733); transition:filter .12s, background .12s; }
		.sup-act[disabled] { opacity:0.6; cursor:default; }
		.sup-act-primary { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-act-success { background:#1f7a44; border-color:#1f7a44; color:#fff; }
		.sup-act-warn { background:#a15c00; border-color:#a15c00; color:#fff; }
		.sup-act-danger { background:#b3261e; border-color:#b3261e; color:#fff; }
		.sup-act-neutral:hover, .sup-act-primary:hover, .sup-act-success:hover, .sup-act-warn:hover, .sup-act-danger:hover { filter:brightness(1.06); }
		/* Priority policy guidance (first-response SLA targets) */
		.sup-pguide { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin:-0.5rem 0 1rem; padding:0.45rem 0.9rem; background:var(--theme-color-background-secondary,#f7f8fb); border:1px solid var(--theme-color-border-light,#e7ebf2); border-radius:9px; font-size:0.8rem; color:var(--theme-color-text-muted,#7a8494); }
		.sup-pguide > b { color:var(--theme-color-text-secondary,#45505f); font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; }
		.sup-sla { display:inline-flex; align-items:center; gap:0.35rem; }
		.sup-sla + .sup-sla { margin-left:0.15rem; }

		/* Delivery stage bar (optional second lifecycle) */
		.sup-impl { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin:-0.5rem 0 1rem; padding:0.5rem 0.9rem; background:var(--theme-color-background-primary,#fff); border:1px dashed var(--theme-color-border-default,#dfe4ee); border-radius:10px; }
		.sup-stg-track { display:flex; align-items:center; gap:0.15rem; flex-wrap:wrap; }
		.sup-stg { border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-secondary,#f5f7fb); color:var(--theme-color-text-muted,#7a8494); padding:0.28rem 0.55rem; border-radius:6px; font:700 0.72rem/1 inherit; cursor:pointer; white-space:nowrap; }
		.sup-stg:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-stg[disabled] { opacity:0.6; cursor:default; }
		.sup-stg-sep { color:var(--theme-color-text-muted,#c3cad6); font-size:0.7rem; }
		.sup-stg-hint { font-size:0.75rem; color:var(--theme-color-text-muted,#9aa3b1); font-style:italic; }
		.sup-stg-clear { margin-left:auto; border:none; background:transparent; color:var(--theme-color-text-muted,#9aa3b1); cursor:pointer; font-size:0.85rem; padding:0.2rem 0.3rem; }
		.sup-stg-clear:hover { color:#a3324b; }
		/* Active stage = solid fill (you-are-here); list chips = light tint */
		.sup-stg-on.sup-stg-ack { background:#2f5fd0; border-color:#2f5fd0; color:#fff; }
		.sup-stg-on.sup-stg-triage { background:#3a44b8; border-color:#3a44b8; color:#fff; }
		.sup-stg-on.sup-stg-fu { background:#c67a12; border-color:#c67a12; color:#fff; }
		.sup-stg-on.sup-stg-resolved { background:#1f8a4c; border-color:#1f8a4c; color:#fff; }
		.sup-stg-chip.sup-stg-ack { background:#e7f0ff; border-color:#b9d2ff; color:#2f5fd0; }
		.sup-stg-chip.sup-stg-triage { background:#e9edfb; border-color:#c3ccf3; color:#3a44b8; }
		.sup-stg-chip.sup-stg-fu { background:#fbefd8; border-color:#f0d29a; color:#a35f0a; }
		.sup-stg-chip.sup-stg-resolved { background:#e5f6ec; border-color:#b6e2c5; color:#1f8a4c; }
		.sup-stg-chip { display:inline-block; margin-left:0.4rem; padding:0.05rem 0.4rem; border:1px solid; border-radius:5px; font:700 0.62rem/1.5 inherit; text-transform:uppercase; letter-spacing:0.02em; vertical-align:middle; }
		.sup-tl-icon.sup-ak-stage { background:#e9edfb; color:#3a44b8; }
		.sup-tl-kind.sup-ak-stage { background:#e9edfb; color:#3a44b8; }

		.sup-form-host { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:10px; padding:1rem 1.25rem; }

		/* Call-entry work area: the form (+ activity) beside a read-only runbook companion */
		.sup-work { display:grid; grid-template-columns:minmax(0,1fr) var(--sup-panel-w,22rem); gap:1rem; align-items:start; }
		.sup-work-main { min-width:0; }
		/* The sticky, width-resizable action panel (Save + status/approval + delivery + runbook). Travels as you scroll;
		   its own content scrolls internally when taller than the viewport, with the Save bar pinned to its top. */
		.sup-panel { position:sticky; top:0.5rem; align-self:start; max-height:calc(100vh - 6rem); display:flex; }
		.sup-panel-grip { flex:0 0 0.6rem; margin-left:-0.3rem; cursor:col-resize; display:flex; align-items:center; justify-content:center; }
		.sup-panel-grip-bar { width:3px; height:2.8rem; border-radius:3px; background:var(--theme-color-border-default,#d7dce3); transition:background .12s; }
		.sup-panel-grip:hover .sup-panel-grip-bar, .sup-panel-grip:active .sup-panel-grip-bar { background:var(--theme-color-brand-primary,#5650e6); }
		.sup-panel-inner { flex:1 1 auto; min-width:0; max-height:calc(100vh - 6rem); overflow-y:auto; overflow-x:hidden; display:flex; flex-direction:column; gap:0.7rem; padding-right:0.1rem; }
		.sup-panel-actions { display:flex; gap:0.5rem; position:sticky; top:0; z-index:3; background:var(--theme-color-background-secondary,#f5f7fb); padding:0.1rem 0 0.5rem; }
		.sup-panel-actions .sup-btn { flex:1 1 auto; justify-content:center; }
		/* Inside the narrow panel, the approval + delivery bars stack vertically instead of the full-width row layout. */
		.sup-panel .sup-approval { flex-direction:column; align-items:stretch; margin:0; }
		.sup-panel .sup-approval-status { justify-content:flex-start; }
		.sup-panel .sup-approval-actions { flex-direction:column; align-items:stretch; }
		.sup-panel .sup-approval-actions .sup-act { justify-content:center; }
		.sup-panel .sup-impl { flex-direction:column; align-items:stretch; margin:0; }
		.sup-runbook { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:10px; }
		.sup-runbook-collapsed { overflow:hidden; }
		/* The runbook header no longer sticks inside the panel — the panel's Save bar owns top:0, so a sticky runbook head would collide under it. */
		.sup-panel .sup-rb-head { position:static; }
		/* Mini-accordion sections (Status + Delivery): a thin clickable header row over a collapsible body. */
		.sup-sec { border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:10px; background:var(--theme-color-background-primary,#fff); overflow:hidden; }
		.sup-sec-head { display:flex; align-items:center; gap:0.5rem; width:100%; padding:0.5rem 0.7rem; background:var(--theme-color-background-secondary,#f5f7fb); border:none; border-radius:0; cursor:pointer; font:inherit; color:inherit; text-align:left; }
		.sup-sec-head:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.sup-sec-title { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); font-weight:800; }
		.sup-sec-hint { font-size:0.74rem; color:var(--theme-color-text-muted,#9aa3b1); }
		.sup-sec-chev { margin-left:auto; color:var(--theme-color-text-muted,#9aa3b1); font-size:0.72rem; transition:transform .15s; }
		.sup-sec-collapsed .sup-sec-chev { transform:rotate(-90deg); }
		.sup-sec-body { padding:0.6rem 0.7rem; }
		.sup-sec-collapsed .sup-sec-body { display:none; }
		.sup-rb-head { display:flex; align-items:center; justify-content:space-between; gap:0.5rem; padding:0.65rem 0.85rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); position:sticky; top:0; background:var(--theme-color-background-primary,#fff); z-index:1; }
		.sup-rb-h { font:800 0.78rem/1 inherit; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); display:inline-flex; align-items:center; gap:0.45rem; }
		.sup-rb-x { border:none; background:transparent; color:var(--theme-color-text-muted,#9aa3b1); cursor:pointer; font-size:0.9rem; }
		.sup-rb-x:hover { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-rb-tab { width:100%; min-height:7rem; border:none; background:transparent; color:var(--theme-color-brand-primary,#5650e6); cursor:pointer; font-size:1rem; writing-mode:vertical-rl; padding:0.6rem 0; }
		.sup-rb-tab:hover { background:var(--theme-color-background-secondary,#f2f4f8); }
		.sup-rb-nav { display:flex; flex-direction:column; gap:0.1rem; padding:0.5rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); }
		.sup-rb-nav-i { text-align:left; border:none; background:transparent; color:var(--theme-color-text-secondary,#45505f); padding:0.4rem 0.5rem; border-radius:7px; font:600 0.83rem/1.3 inherit; cursor:pointer; display:flex; align-items:center; gap:0.4rem; }
		.sup-rb-nav-i:hover { background:var(--theme-color-background-secondary,#f2f4f8); }
		.sup-rb-nav-on, .sup-rb-nav-on:hover { background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-rb-scope { opacity:0.7; width:0.9rem; text-align:center; }
		/* Runbook article selector: a searchable picker instead of the old scroll-past nav list. */
		.sup-rb-pick { padding:0.55rem 0.6rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); }
		.sup-rb-pick .pps { width:100%; }
		.sup-rb-body { padding:0.85rem 1rem 1.1rem; }
		.sup-rb-arth { font:800 1.02rem/1.3 inherit; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.5rem; display:flex; align-items:center; gap:0.4rem; flex-wrap:wrap; }
		.sup-rb-scopeword { font:700 0.66rem/1 inherit; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); background:var(--theme-color-background-secondary,#f2f4f8); border-radius:5px; padding:0.15rem 0.4rem; }
		.sup-rb-content { font-size:0.86rem; }
		.sup-rb-msg { padding:1rem; color:var(--theme-color-text-muted,#8894a4); font-size:0.85rem; line-height:1.5; }
		@media (max-width:900px) { .sup-work { grid-template-columns:1fr; } .sup-panel { position:static; max-height:none; } .sup-panel-inner { max-height:none; overflow:visible; } .sup-panel-grip { display:none; } .sup-panel-actions { position:static; } }

		/* Call activity: comms + follow-up composer + history timeline */
		.sup-activity { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:10px; padding:1rem 1.25rem; margin-top:1rem; }
		.sup-act-h { font-size:0.8rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.75rem; display:flex; align-items:center; gap:0.5rem; }
		.sup-fu-banner { display:flex; align-items:baseline; gap:0.4rem; flex-wrap:wrap; background:#fff4e5; color:#8a4b00; border:1px solid #f2d9b0; border-radius:8px; padding:0.5rem 0.75rem; font-size:0.85rem; margin:0 0 0.85rem; }
		.sup-fu-banner b { color:#7a4200; }
		.sup-fu-done { margin-left:auto; display:inline-flex; align-items:center; gap:0.3rem; border:1px solid #e0b784; background:#fff; color:#8a4b00; padding:0.22rem 0.55rem; border-radius:6px; font:600 0.75rem/1 inherit; cursor:pointer; }
		.sup-fu-done:hover { background:#ffe9cc; }
		.sup-fu-done:disabled { opacity:0.55; cursor:default; }
		/* Composer */
		.sup-composer { background:var(--theme-color-background-secondary,#f7f8fb); border:1px solid var(--theme-color-border-light,#e7ebf2); border-radius:9px; padding:0.7rem 0.8rem; margin:0 0 1rem; }
		.sup-ck-kinds { display:flex; gap:0.35rem; flex-wrap:wrap; margin:0 0 0.55rem; }
		.sup-ck { display:inline-flex; align-items:center; gap:0.35rem; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); padding:0.32rem 0.6rem; border-radius:7px; font:600 0.78rem/1 inherit; cursor:pointer; }
		.sup-ck:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-ck-on { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-ck-on:hover { color:#fff; }
		.sup-ck-fu { display:flex; gap:0.75rem; flex-wrap:wrap; margin:0 0 0.55rem; }
		.sup-ck-fu label { display:flex; flex-direction:column; gap:0.2rem; font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#8894a4); }
		.sup-ck-fu input { font:inherit; font-size:0.85rem; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:6px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.sup-ck-ph { font-size:0.7rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#8894a4); margin:0 0 0.3rem; }
		.sup-ck-editor { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:7px; background:var(--theme-color-background-primary,#fff); max-height:24rem; overflow:auto; }
		.sup-ck-editor .cm-editor { min-height:4.5rem; }
		.sup-ck-actions { display:flex; align-items:center; justify-content:flex-end; gap:0.75rem; margin-top:0.55rem; }
		.sup-ck-hint { margin-right:auto; font-size:0.75rem; color:var(--theme-color-text-muted,#8894a4); display:inline-flex; align-items:center; gap:0.3rem; }
		/* Timeline */
		.sup-tl { display:flex; flex-direction:column; gap:0.1rem; }
		.sup-tl-empty { font-size:0.85rem; color:var(--theme-color-text-muted,#8894a4); padding:0.4rem 0; }
		.sup-tl-item { display:flex; gap:0.65rem; padding:0.55rem 0; border-top:1px solid var(--theme-color-border-light,#eef1f6); }
		.sup-tl-item:first-child { border-top:none; }
		.sup-tl-icon { flex:0 0 auto; width:1.65rem; height:1.65rem; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:0.75rem; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-secondary,#5a6572); margin-top:0.05rem; }
		.sup-tl-icon.sup-ak-ack { background:#e7f0ff; color:#2f5fd0; }
		.sup-tl-icon.sup-ak-res { background:#e5f6ec; color:#1f8a4c; }
		.sup-tl-icon.sup-ak-fu { background:#fff0e0; color:#b4620a; }
		.sup-tl-icon.sup-ak-note { background:#f0eefe; color:#5650e6; }
		.sup-tl-icon.sup-ak-tr { background:#eef1f6; color:#6b7686; }
		.sup-tl-body { flex:1 1 auto; min-width:0; }
		.sup-tl-head { display:flex; align-items:baseline; gap:0.4rem; flex-wrap:wrap; font-size:0.85rem; color:var(--theme-color-text-secondary,#45505f); }
		.sup-tl-head b { color:var(--theme-color-text-primary,#1f2733); font-weight:700; }
		.sup-tl-kind { font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; padding:0.08rem 0.4rem; border-radius:5px; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-secondary,#5a6572); }
		.sup-tl-kind.sup-ak-ack { background:#e7f0ff; color:#2f5fd0; }
		.sup-tl-kind.sup-ak-res { background:#e5f6ec; color:#1f8a4c; }
		.sup-tl-kind.sup-ak-fu { background:#fff0e0; color:#b4620a; }
		.sup-tl-kind.sup-ak-note { background:#f0eefe; color:#5650e6; }
		.sup-tl-when { margin-left:auto; font-size:0.72rem; color:var(--theme-color-text-muted,#9aa3b1); white-space:nowrap; font-variant-numeric:tabular-nums; }
		.sup-tl-text { font-size:0.88rem; color:var(--theme-color-text-primary,#2a323d); margin-top:0.2rem; word-break:break-word; overflow-wrap:anywhere; min-width:0; }
		/* Rendered-markdown remark body (timeline). Tight block spacing so short notes stay compact. */
		.sup-md > :first-child { margin-top:0; } .sup-md > :last-child { margin-bottom:0; }
		.sup-md p { margin:0.3rem 0; }
		.sup-md ul, .sup-md ol { margin:0.3rem 0; padding-left:1.25rem; } .sup-md li { margin:0.1rem 0; }
		.sup-md code { background:var(--theme-color-background-secondary,#eef1f6); padding:0.05rem 0.3rem; border-radius:4px; font-size:0.85em; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.sup-md pre { background:var(--theme-color-background-secondary,#eef1f6); padding:0.5rem 0.6rem; border-radius:6px; overflow-x:auto; max-width:100%; } .sup-md pre code { background:none; padding:0; overflow-wrap:normal; word-break:normal; }
		/* Inbound email content must stay INSIDE its container: break long tokens/URLs/Message-IDs, scroll wide tables, cap images. */
		.sup-md { overflow-wrap:anywhere; word-break:break-word; }
		.sup-md > * { max-width:100%; }
		.sup-md code { overflow-wrap:anywhere; word-break:break-word; }
		.sup-md a { overflow-wrap:anywhere; word-break:break-word; }
		.sup-md img { max-width:100%; height:auto; }
		.sup-md table { display:block; width:100%; max-width:100%; overflow-x:auto; border-collapse:collapse; }
		.sup-md h1, .sup-md h2, .sup-md h3, .sup-md h4 { font-size:1em; font-weight:800; margin:0.45rem 0 0.2rem; }
		.sup-md a { color:var(--theme-color-brand-primary,#5650e6); }
		.sup-md blockquote { border-left:3px solid var(--theme-color-border-default,#d7dce3); margin:0.3rem 0; padding:0.1rem 0.6rem; color:var(--theme-color-text-secondary,#5a6572); }
		.sup-tl-fu { font-size:0.78rem; color:#b4620a; margin-top:0.2rem; }

		/* Notes */
		.sup-note { display:flex; align-items:center; gap:0.6rem; padding:1rem 1.1rem; border-radius:10px; background:var(--theme-color-background-secondary,#f5f7fb); color:var(--theme-color-text-secondary,#45505f); font-size:0.92rem; }
		.sup-note-empty { color:var(--theme-color-text-muted,#6b7686); }
		.sup-note-error { background:#fdecef; color:#a3324b; }
		.sup-note-locked { background:#fff4e5; color:#a15c00; }
		.sup-note b { color:var(--theme-color-text-primary,#1f2733); }

		/* Calls / Metrics segmented toggle */
		.sup-toolbar-left { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; }
		.sup-seg { display:inline-flex; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; overflow:hidden; background:var(--theme-color-background-primary,#fff); }
		.sup-seg-b { display:inline-flex; align-items:center; gap:0.35rem; border:none; background:transparent; color:var(--theme-color-text-secondary,#45505f); padding:0.4rem 0.8rem; font:600 0.84rem/1 inherit; cursor:pointer; }
		.sup-seg-b + .sup-seg-b { border-left:1px solid var(--theme-color-border-default,#d7dce3); }
		.sup-seg-on { background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-gear { border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); border-radius:8px; width:2.1rem; height:2.1rem; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; font-size:0.9rem; }
		.sup-gear:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-gear-on { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }

		/* Settings editor */
		.sup-set-scope { display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap; margin:0 0 0.8rem; }
		.sup-set-scopelabel { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#9aa3b1); font-weight:700; }
		.sup-scope-b { display:inline-flex; align-items:center; gap:0.35rem; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); padding:0.35rem 0.7rem; border-radius:7px; font:600 0.82rem/1 inherit; cursor:pointer; }
		.sup-scope-b:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-scope-on { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-scope-on:hover { color:#fff; }
		.sup-set-sel { font:inherit; font-size:0.85rem; padding:0.35rem 0.5rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:7px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		/* Searchable customer pickers (pict-section-picker) mounted in place of the old native selects. */
		.sup-set-pick { display:inline-block; min-width:16rem; vertical-align:middle; }
		.sup-set-pick .pps, .sup-doc-cust-pick .pps, .sup-mf-pick .pps { min-width:100%; }
		.sup-doc-scopebar { display:flex; align-items:center; gap:0.6rem; margin:0 0 0.9rem; flex-wrap:wrap; }
		.sup-doc-scopelabel { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#9aa3b1); font-weight:700; }
		.sup-doc-cust-pick { display:inline-block; min-width:18rem; vertical-align:middle; }
		.sup-set-note { display:flex; align-items:baseline; gap:0.45rem; font-size:0.83rem; color:var(--theme-color-text-muted,#7a8494); margin:0 0 1rem; }
		.sup-set-note b { color:var(--theme-color-text-primary,#1f2733); }
		.sup-set-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(20rem,1fr)); gap:1rem; align-items:start; }
		.sup-set-card { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; padding:1rem 1.1rem; }
		.sup-set-h { font-size:0.8rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.8rem; display:flex; align-items:center; gap:0.5rem; }
		.sup-set-toggle { display:flex; align-items:center; gap:0.5rem; font-size:0.9rem; color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.sup-set-inline { display:flex; align-items:center; gap:0.5rem; font-size:0.88rem; color:var(--theme-color-text-primary,#1f2733); }
		.sup-set-inline select, .sup-rule-type, .sup-rule-prio, .sup-rule-val select, .sup-rule-val input, .sup-set-sla input { font:inherit; font-size:0.85rem; padding:0.3rem 0.45rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:6px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.sup-set-sub { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#8894a4); font-weight:700; margin:0.9rem 0 0.5rem; }
		.sup-set-hint { text-transform:none; letter-spacing:0; font-weight:400; font-style:italic; }
		.sup-set-cats { display:grid; grid-template-columns:1fr 1fr; gap:0.3rem 0.8rem; }
		.sup-set-chk { display:flex; align-items:center; gap:0.4rem; font-size:0.85rem; color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.sup-set-disabled { color:var(--theme-color-text-muted,#a9b2bf); cursor:default; }
		.sup-set-slas { display:grid; grid-template-columns:1fr 1fr; gap:0.4rem 0.8rem; }
		.sup-set-sla { display:flex; align-items:center; gap:0.5rem; font-size:0.85rem; }
		.sup-set-sla input { flex:1; min-width:0; }
		.sup-set-rules { display:flex; flex-direction:column; gap:0.4rem; }
		.sup-set-rule { display:flex; align-items:center; gap:0.35rem; flex-wrap:wrap; }
		.sup-rule-val { flex:1; min-width:7rem; display:flex; }
		.sup-rule-val select, .sup-rule-val input { width:100%; }
		.sup-rule-arrow { color:var(--theme-color-text-muted,#9aa3b1); }
		.sup-rule-x { border:none; background:transparent; color:var(--theme-color-text-muted,#9aa3b1); cursor:pointer; padding:0.2rem 0.3rem; font-size:0.9rem; }
		.sup-rule-x:hover { color:#a3324b; }
		.sup-set-empty { font-size:0.85rem; color:var(--theme-color-text-muted,#9aa3b1); font-style:italic; }
		.sup-set-addrule { margin-top:0.6rem; }
		.sup-set-actions { margin-top:1rem; display:flex; justify-content:flex-end; }

		/* Support documentation (staff runbook) */
		.sup-docs { display:grid; grid-template-columns:15rem 1fr; gap:1rem; align-items:start; }
		.sup-doc-nav { display:flex; flex-direction:column; gap:1rem; }
		.sup-doc-navgroup { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:11px; padding:0.6rem 0.55rem; }
		.sup-doc-navh { display:flex; align-items:center; justify-content:space-between; font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); padding:0.15rem 0.4rem 0.5rem; }
		.sup-doc-add { border:none; background:transparent; color:var(--theme-color-brand-primary,#5650e6); font:700 0.72rem/1 inherit; cursor:pointer; display:inline-flex; align-items:center; gap:0.25rem; }
		.sup-doc-add:hover { text-decoration:underline; } .sup-doc-add[disabled] { opacity:0.5; cursor:default; text-decoration:none; }
		.sup-doc-navtools { display:inline-flex; align-items:center; gap:0.6rem; }
		.sup-docsonly-h { font-weight:800; display:inline-flex; align-items:center; gap:0.5rem; font-size:1rem; color:var(--theme-color-text-primary,#1f2733); }
		.sup-docsonly-h i { color:var(--theme-color-brand-primary,#5650e6); }
		/* Drag-drop bulk upload target (per scope) + its hint. */
		.sup-doc-navgroup.sup-doc-drag { outline:2px dashed var(--theme-color-brand-primary,#5650e6); outline-offset:-3px; background:#f3f2fe; }
		.sup-doc-drophint { margin-top:0.45rem; padding:0.35rem 0.5rem; border:1px dashed var(--theme-color-border-default,#d7dce3); border-radius:7px; font-size:0.72rem; color:var(--theme-color-text-muted,#9aa3b1); display:flex; align-items:center; gap:0.35rem; }
		.sup-doc-navgroup.sup-doc-drag .sup-doc-drophint { color:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); }
		.sup-doc-nav-i { display:block; width:100%; text-align:left; border:none; background:transparent; color:var(--theme-color-text-secondary,#45505f); padding:0.4rem 0.5rem; border-radius:7px; font:600 0.85rem/1.3 inherit; cursor:pointer; }
		.sup-doc-nav-i:hover { background:var(--theme-color-background-secondary,#f2f4f8); }
		.sup-doc-nav-on { background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sup-doc-nav-on:hover { background:var(--theme-color-brand-primary,#5650e6); }
		.sup-doc-nav-empty { font-size:0.8rem; color:var(--theme-color-text-muted,#a9b2bf); font-style:italic; padding:0.2rem 0.5rem; }
		.sup-doc-nav-i[draggable="true"] { cursor:grab; }
		.sup-doc-nav-i[draggable="true"]:active { cursor:grabbing; }
		.sup-doc-main { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; padding:1.1rem 1.4rem; min-height:16rem; min-width:0; }
		.sup-doc-placeholder { text-align:center; color:var(--theme-color-text-muted,#8894a4); padding:2.5rem 1rem; }
		.sup-doc-placeholder i { font-size:1.8rem; opacity:0.5; display:block; margin-bottom:0.6rem; }
		.sup-doc-note { font-size:0.82rem; max-width:32rem; margin:0.8rem auto 0; line-height:1.5; }
		.sup-doc-arth { display:flex; align-items:center; gap:0.7rem; flex-wrap:wrap; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding-bottom:0.7rem; margin-bottom:0.9rem; }
		.sup-doc-title { font-size:1.3rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); margin:0; }
		.sup-doc-scope { font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; padding:0.15rem 0.5rem; border-radius:6px; display:inline-flex; align-items:center; gap:0.3rem; }
		.sup-doc-scope-g { background:#e9edfb; color:#3a44b8; } .sup-doc-scope-c { background:#e2f5f2; color:#12796b; }
		.sup-doc-editbtn { margin-left:auto; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); padding:0.3rem 0.7rem; border-radius:7px; font:600 0.8rem/1 inherit; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; }
		.sup-doc-editbtn:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sup-doc-content { font-size:0.92rem; color:var(--theme-color-text-primary,#2a323d); line-height:1.6; overflow-wrap:anywhere; word-break:break-word; }
		/* Keep wide rendered content (long unbroken strings/URLs, images, code blocks, tables) inside the pane so it never widens the page and pushes the Edit button off-screen. Mirrors the .sup-md guards. */
		.sup-doc-content > * { max-width:100%; }
		.sup-doc-content img { max-width:100%; height:auto; }
		.sup-doc-content h2 { font-size:1.15rem; margin:1.1rem 0 0.5rem; color:var(--theme-color-text-primary,#1f2733); }
		.sup-doc-content h3 { font-size:1rem; margin:1rem 0 0.4rem; color:var(--theme-color-text-primary,#1f2733); }
		.sup-doc-content h4, .sup-doc-content h5 { font-size:0.9rem; margin:0.8rem 0 0.35rem; color:var(--theme-color-text-secondary,#45505f); }
		.sup-doc-content p { margin:0 0 0.7rem; } .sup-doc-content ul { margin:0 0 0.7rem; padding-left:1.3rem; } .sup-doc-content li { margin:0.2rem 0; }
		.sup-doc-content code { background:var(--theme-color-background-secondary,#eef1f6); padding:0.05rem 0.35rem; border-radius:4px; font-size:0.86em; }
		.sup-doc-content a { color:var(--theme-color-brand-primary,#5650e6); }
		/* Elements the shared marked renderer emits that the old hand-rolled parser never did (blockquote email templates, ordered + nested lists, code blocks, tables). */
		.sup-doc-content blockquote { margin:0 0 0.7rem; padding:0.4rem 0.9rem; border-left:3px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-secondary,#f5f7fb); color:var(--theme-color-text-secondary,#45505f); border-radius:0 6px 6px 0; }
		.sup-doc-content blockquote p { margin:0.25rem 0; }
		.sup-doc-content ol { margin:0 0 0.7rem; padding-left:1.4rem; } .sup-doc-content ol li { margin:0.2rem 0; }
		.sup-doc-content ul ul, .sup-doc-content ul ol, .sup-doc-content ol ul, .sup-doc-content ol ol { margin:0.2rem 0; }
		.sup-doc-content pre { background:var(--theme-color-background-secondary,#eef1f6); padding:0.6rem 0.8rem; border-radius:6px; overflow-x:auto; max-width:100%; margin:0 0 0.7rem; }
		.sup-doc-content pre code { background:none; padding:0; font-size:0.82em; }
		.sup-doc-content table { display:block; max-width:100%; overflow-x:auto; border-collapse:collapse; margin:0 0 0.7rem; font-size:0.9em; }
		.sup-doc-content th, .sup-doc-content td { border:1px solid var(--theme-color-border-default,#e2e6ee); padding:0.3rem 0.5rem; text-align:left; }
		.sup-doc-content th { background:var(--theme-color-background-secondary,#f5f7fb); }
		.sup-doc-empty { color:var(--theme-color-text-muted,#9aa3b1); font-style:italic; }
		.sup-doc-editor { display:flex; flex-direction:column; gap:0.7rem; }
		.sup-doc-title-in { font:700 1.1rem/1.3 inherit; padding:0.5rem 0.6rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.sup-doc-mde { min-height:18rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; overflow:hidden; }
		.sup-doc-mde .cm-editor { min-height:16rem; }
		.sup-doc-ed-actions { display:flex; align-items:center; justify-content:space-between; gap:0.6rem; }
		.sup-doc-ed-right { display:flex; align-items:center; gap:0.5rem; }
		.sup-doc-del { border:1px solid #e6b8c1; background:#fff; color:#a3324b; padding:0.4rem 0.7rem; border-radius:7px; font:600 0.8rem/1 inherit; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; }
		.sup-doc-del:hover { background:#fdecef; }
		@media (max-width:640px) { .sup-docs { grid-template-columns:1fr; } }

		/* Metrics */
		.sup-kpis { display:grid; grid-template-columns:repeat(auto-fit,minmax(9rem,1fr)); gap:0.7rem; margin:0 0 1rem; }
		.sup-kpi { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:11px; padding:0.75rem 0.95rem; }
		.sup-kpi-v { font-size:1.6rem; font-weight:800; line-height:1; color:var(--theme-color-text-primary,#1f2733); font-variant-numeric:tabular-nums; }
		.sup-kpi-l { font-size:0.68rem; color:var(--theme-color-text-muted,#8894a4); margin-top:0.3rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:700; }
		.sup-mcard { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; padding:0.9rem 1rem; margin:0 0 0.9rem; }
		.sup-mcard-h { font-size:0.8rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.75rem; display:flex; align-items:center; gap:0.5rem; }
		.sup-mlegend { margin-left:auto; font-weight:600; text-transform:none; letter-spacing:0; color:var(--theme-color-text-muted,#8894a4); display:inline-flex; align-items:center; gap:0.3rem; }
		.sup-mdot { width:0.6rem; height:0.6rem; border-radius:50%; display:inline-block; margin-left:0.5rem; }
		.sup-mgrid { display:grid; grid-template-columns:repeat(auto-fit,minmax(16rem,1fr)); gap:0.9rem; }
		.sup-mgrid .sup-mcard { margin:0; }
		.sup-chart { display:flex; align-items:flex-end; gap:0.5rem; height:11rem; overflow-x:auto; }
		.sup-chart-wide { gap:1px; padding-bottom:0.2rem; }
		.sup-bar { flex:1; display:flex; flex-direction:column; align-items:center; justify-content:flex-end; gap:0.3rem; height:100%; }
		.sup-bar-dense { flex:0 0 5px; min-width:5px; }
		.sup-bar-dense .sup-bar-c { width:2px; max-width:2px; }
		.sup-bar-x-year { color:var(--theme-color-text-secondary,#45505f); font-weight:800; white-space:nowrap; }
		.sup-bar-pair { display:flex; align-items:flex-end; gap:2px; height:100%; width:100%; justify-content:center; }
		.sup-bar-c { width:38%; max-width:1.1rem; min-height:2px; border-radius:3px 3px 0 0; position:relative; display:flex; justify-content:center; }
		.sup-bar-n { position:absolute; top:-1rem; font-size:0.6rem; font-weight:800; color:var(--theme-color-text-secondary,#45505f); }
		.sup-bar-x { font-size:0.62rem; color:var(--theme-color-text-muted,#8894a4); font-weight:700; }
		.sup-dimtable { width:100%; border-collapse:collapse; font-size:0.85rem; }
		.sup-dimtable th { text-align:left; font-size:0.62rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#8894a4); font-weight:800; padding:0 0.4rem 0.4rem; }
		.sup-dimtable td { padding:0.35rem 0.4rem; border-top:1px solid var(--theme-color-border-light,#eef1f6); }
		.sup-dim-n { font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.sup-dim-bar { width:45%; }
		.sup-dimbar { height:0.55rem; background:var(--theme-color-background-secondary,#eef1f6); border-radius:4px; overflow:hidden; }
		.sup-dimbar span { display:block; height:100%; background:#3a44b8; }
		.sup-dim-v { text-align:right; font-weight:700; font-variant-numeric:tabular-nums; }
		.sup-mempty { color:var(--theme-color-text-muted,#8894a4); font-size:0.85rem; padding:1.2rem; text-align:center; }

		/* Dashboard filter bar */
		.sup-rng { display:flex; align-items:center; gap:0.3rem; flex-wrap:wrap; margin:0 0 0.6rem; padding:0.2rem; }
		.sup-rng-l { font-size:0.68rem; text-transform:uppercase; letter-spacing:0.04em; font-weight:800; color:var(--theme-color-text-muted,#8894a4); margin-right:0.35rem; }
		.sup-rng-b { font:inherit; font-size:0.8rem; font-weight:700; padding:0.28rem 0.6rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:999px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.sup-rng-b:hover { border-color:#3a44b8; color:#3a44b8; }
		.sup-rng-on { background:#3a44b8; border-color:#3a44b8; color:#fff; }
		.sup-rng-custom { margin-top:0.1rem; }
		.sup-rng-in { font:inherit; font-size:0.82rem; padding:0.24rem 0.4rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:7px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.sup-rng-apply { background:#1f7a44; border-color:#1f7a44; color:#fff; }
		.sup-rng-apply:hover { background:#1a6b3b; border-color:#1a6b3b; color:#fff; }
		.sup-mcard-sub { font-size:0.62rem; font-weight:600; color:var(--theme-color-text-muted,#8894a4); text-transform:none; letter-spacing:0; margin-left:0.3rem; }
		.sup-dim-click { cursor:pointer; }
		.sup-dim-click:hover td { background:var(--theme-color-background-hover,#f5f7fb); }
		.sup-mfilter { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin:0 0 1rem; padding:0.5rem 0.2rem; }
		.sup-mf { display:inline-flex; align-items:center; gap:0.35rem; }
		.sup-mf-l { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-muted,#8894a4); font-weight:700; }
		.sup-mf-sel { font:inherit; font-size:0.83rem; padding:0.3rem 0.45rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:7px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); max-width:11rem; }
		.sup-mf-pick { display:inline-block; min-width:13rem; vertical-align:middle; }
		.sup-mf-on { border-color:var(--theme-color-brand-primary,#5650e6); box-shadow:0 0 0 2px rgba(86,80,230,0.12); }
		/* By-status proportion bar */
		.sup-stbar { display:flex; height:1.5rem; border-radius:7px; overflow:hidden; background:var(--theme-color-background-secondary,#eef1f6); margin:0 0 0.8rem; }
		.sup-stbar-seg { height:100%; min-width:2px; transition:width .2s; }
		.sup-stbar-seg.sup-st-new  { background:#5661d6; }
		.sup-stbar-seg.sup-st-ack  { background:#2f5fd0; }
		.sup-stbar-seg.sup-st-t1   { background:#d98a2b; }
		.sup-stbar-seg.sup-st-t2   { background:#c2691a; }
		.sup-stbar-seg.sup-st-t3   { background:#c9506b; }
		.sup-stbar-seg.sup-st-done { background:#2b9a5b; }
		.sup-stbar-seg.sup-st-void { background:#9aa3b1; }
		.sup-stlegwrap { display:flex; flex-direction:column; gap:0.3rem; }
		.sup-stleg { display:flex; align-items:center; gap:0.5rem; }
		.sup-stleg-n { margin-left:auto; font-weight:800; font-variant-numeric:tabular-nums; color:var(--theme-color-text-primary,#1f2733); }
		.sup-stleg-p { width:2.6rem; text-align:right; font-size:0.78rem; color:var(--theme-color-text-muted,#8894a4); font-variant-numeric:tabular-nums; }
		/* Bug watch card */
		.sup-bugcard { border-color:#f0cdd4; }
		.sup-bugcard .sup-mcard-h { color:#a3324b; }
		.sup-bug-focus { margin-left:auto; text-transform:none; letter-spacing:0; display:inline-flex; align-items:center; gap:0.35rem; border:1px solid #e6b8c1; background:#fff; color:#a3324b; padding:0.25rem 0.6rem; border-radius:7px; font:700 0.72rem/1 inherit; cursor:pointer; }
		.sup-bug-focus:hover { background:#fdecef; }
		.sup-bug-focus-on { background:#a3324b; border-color:#a3324b; color:#fff; }
		.sup-bug-focus-on:hover { background:#8f2a41; }
		.sup-bug-grid { display:grid; grid-template-columns:minmax(9rem,1fr) 2fr; gap:1rem; align-items:stretch; }
		.sup-bug-kpis { display:grid; grid-template-columns:1fr; gap:0.5rem; align-content:start; }
		.sup-bug-kpis .sup-kpi { margin:0; }
		.sup-bug-trend .sup-mcard-h { margin:0 0 0.4rem; }
		.sup-chart-sm { height:7rem; }
		@media (max-width:640px) { .sup-bug-grid { grid-template-columns:1fr; } }

		/* ── Bulk-merge selection (list) ─────────────────────────────── */
		.sup-col-sel { width:2.2rem; text-align:center; }
		.sup-cb { width:16px; height:16px; cursor:pointer; accent-color:var(--theme-color-brand-primary,#5650e6); }
		.sup-callgroup-sel td { background:var(--theme-color-background-secondary,#ecebfc) !important; }
		.sup-mergebar { display:flex; align-items:center; gap:0.6rem; margin:0 0 0.7rem; padding:0.5rem 0.85rem; border:1px solid var(--theme-color-brand-primary,#5650e6); background:#ecebfc; border-radius:9px; }
		.sup-mergebar-n { font-weight:800; color:var(--theme-color-brand-primary,#5650e6); display:inline-flex; align-items:center; gap:0.4rem; }
		.sup-mergebar-go { margin-left:auto; }
		.sup-btn-sm { padding:0.3rem 0.65rem; font-size:0.8rem; }

		/* ── Merge wizard (inline console view — NOT a modal) ──────────── */
		.supmg-view { max-width:820px; margin:0 auto; }
		.supmg-wizard { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; padding:0.5rem 1.25rem 1.25rem; }
		.supmg-lede { font-size:0.9rem; color:var(--theme-color-text-secondary,#45505f); margin:0.6rem 0 0.7rem; }
		.supmg-note { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); margin:0.8rem 0 0.2rem; line-height:1.55; }
		.supmg-err { font-size:0.85rem; color:#b3261e; margin:0.6rem 0; }
		.supmg-tklist { display:flex; flex-direction:column; gap:0.5rem; }
		.supmg-tk { border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:8px; padding:0.6rem 0.8rem; background:var(--theme-color-background-primary,#fff); }
		.supmg-tk-sel { border:2px solid var(--theme-color-brand-primary,#5650e6); background:#ecebfc; }
		.supmg-tk-top { display:flex; align-items:center; gap:0.5rem; margin-bottom:0.3rem; }
		.supmg-tk-id { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); }
		.supmg-tk-sum { font-size:0.92rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.supmg-tk-meta { font-size:0.78rem; color:var(--theme-color-text-secondary,#45505f); margin-top:0.2rem; }
		.supmg-pill-into { font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-brand-primary,#5650e6); }
		.supmg-pick { margin:0.2rem 0 0.6rem; }
		.supmg-parentsel { margin-top:0.4rem; }
		.supmg-parentempty { font-size:0.82rem; color:var(--theme-color-text-muted,#8894a4); font-style:italic; }
		.supmg-prev-head { font-size:0.88rem; margin:0.5rem 0 0.7rem; color:var(--theme-color-text-primary,#1f2733); }
		.supmg-muted { color:var(--theme-color-text-muted,#8894a4); }
		.supmg-tl { border-left:2px solid var(--theme-color-border-default,#e2e6ee); margin-left:0.4rem; padding-left:1rem; display:flex; flex-direction:column; gap:0.5rem; }
		.supmg-node { position:relative; border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:7px; padding:0.45rem 0.7rem; background:var(--theme-color-background-primary,#fff); }
		.supmg-node::before { content:""; position:absolute; left:-1.32rem; top:0.7rem; width:9px; height:9px; border-radius:50%; background:var(--theme-color-border-default,#c2c8d2); }
		.supmg-node-add { border:2px solid var(--theme-color-brand-primary,#5650e6); background:#ecebfc; }
		.supmg-node-add::before { background:var(--theme-color-brand-primary,#5650e6); }
		.supmg-node-h { font-size:0.85rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.supmg-node-add .supmg-node-h i { color:var(--theme-color-brand-primary,#5650e6); }
		.supmg-node-m { font-size:0.76rem; color:var(--theme-color-text-secondary,#45505f); margin-top:0.1rem; }
		.supmg-arrow { display:flex; align-items:center; justify-content:center; gap:0.6rem; flex-wrap:wrap; margin:0.8rem 0 1rem; }
		.supmg-arrow i { color:var(--theme-color-brand-primary,#5650e6); }
		.supmg-outcome { border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:8px; padding:0.6rem 0.9rem; background:var(--theme-color-background-secondary,#f6f7fb); font-size:0.85rem; line-height:1.9; }
		.supmg-outcome i { color:var(--theme-color-brand-primary,#5650e6); margin-right:0.3rem; }
		.supmg-done { text-align:center; padding:2rem 0; }
		.supmg-done-ic { width:46px; height:46px; border-radius:50%; background:#ecebfc; display:flex; align-items:center; justify-content:center; margin:0 auto 0.7rem; color:var(--theme-color-brand-primary,#5650e6); font-size:1.4rem; }
		.supmg-done-t { font-size:1rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); }
		.supmg-done-s { font-size:0.84rem; color:var(--theme-color-text-secondary,#45505f); margin-top:0.25rem; }
	`,

	Templates:
	[
		{
			Hash: 'Support-Template',
			Template: html`
				<section class="section sup-page">
					<h1 class="sup-page-h"><i class="fas fa-headset"></i> Support</h1>
					<p class="sup-page-sub">Log, triage, and work customer support calls. Each call is a document with its own approval workflow; screenshots and files attach as observations.</p>
					<div id="Support-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'SupportWrap',
			TemplateHash: 'Support-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1478:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * SupportPortal — the read-only customer-facing open-cases dashboard (#/SupportPortal). The SupportPortal provider
 * paints a curated, read-only list of the customer's support cases + a read-only case detail (with the caller-facing
 * acknowledgement / resolution updates) into #SupportPortal-Host. Full width via Dashboard Mode.
 * See [[SupportPortal-Provider.js]] and [[config-app-support-portal]].
 */
class SupportPortalView extends libPictView
{
	get provider() { return this.pict.providers['SupportPortal']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._mount = '#SupportPortal-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SupportPortalView;

module.exports.default_configuration =
{
	ViewIdentifier: 'SupportPortal',
	DefaultRenderable: 'SupportPortalWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.spx-page { padding: 1.25rem 2rem 2rem; }
		/* The case LIST fills the dashboard width; a single case is a reading pane, so cap it to a comfortable measure. */
		#SupportPortal-Detail { max-width: 66rem; }
		.spx-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.spx-page-h i { color: var(--theme-color-brand-primary,#5650e6); }
		.spx-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1.1rem; }

		.spx-toolbar { display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; margin-bottom:1rem; }
		.spx-seg { display:inline-flex; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; overflow:hidden; background:var(--theme-color-background-primary,#fff); }
		.spx-seg-b { display:inline-flex; align-items:center; gap:0.4rem; border:none; background:transparent; color:var(--theme-color-text-secondary,#45505f); padding:0.45rem 0.9rem; font:600 0.85rem/1 inherit; cursor:pointer; }
		.spx-seg-b + .spx-seg-b { border-left:1px solid var(--theme-color-border-default,#d7dce3); }
		.spx-seg-on { background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.spx-seg-n { font-size:0.72rem; opacity:0.85; font-weight:800; }
		.spx-search { display:flex; align-items:center; gap:0.45rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; padding:0.4rem 0.7rem; background:var(--theme-color-background-primary,#fff); min-width:15rem; }
		.spx-search i { color:var(--theme-color-text-muted,#9aa3b1); }
		.spx-search input { border:none; outline:none; font:inherit; font-size:0.9rem; width:100%; background:transparent; color:var(--theme-color-text-primary,#1f2733); }

		.spx-cards { display:grid; grid-template-columns:repeat(auto-fill,minmax(17rem,1fr)); gap:0.85rem; }
		.spx-card { text-align:left; display:flex; flex-direction:column; gap:0.55rem; background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; padding:0.9rem 1rem; cursor:pointer; transition:border-color .12s, box-shadow .12s, transform .12s; font:inherit; }
		.spx-card:hover { border-color:var(--theme-color-brand-primary,#5650e6); box-shadow:0 3px 12px rgba(20,30,60,0.07); transform:translateY(-1px); }
		.spx-card-top { display:flex; align-items:center; justify-content:space-between; gap:0.5rem; }
		.spx-card-id { font-size:0.72rem; color:var(--theme-color-text-muted,#9aa3b1); font-variant-numeric:tabular-nums; }
		.spx-card-sum { font-size:0.95rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); line-height:1.3; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
		.spx-card-tags { display:flex; align-items:center; gap:0.35rem; flex-wrap:wrap; }
		.spx-card-foot { font-size:0.75rem; color:var(--theme-color-text-muted,#9aa3b1); display:flex; align-items:center; gap:0.35rem; margin-top:auto; }

		.spx-badge { display:inline-flex; align-items:center; gap:0.35rem; border-radius:999px; padding:0.2rem 0.6rem; font:600 0.76rem/1 inherit; white-space:nowrap; }
		.spx-st-open   { background:#eef2ff; color:#3a44b8; }
		.spx-st-prog   { background:#fff4e5; color:#a15c00; }
		.spx-st-wait   { background:#fdecef; color:#a3324b; }
		.spx-st-done   { background:#e7f6ec; color:#1f7a44; }
		.spx-tag { display:inline-block; padding:0.12rem 0.5rem; border-radius:6px; font-size:0.74rem; font-weight:600; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-secondary,#45505f); }
		.spx-tag-app { background:#eef0ff; color:#4a4fce; }
		.spx-prio { display:inline-block; padding:0.12rem 0.5rem; border-radius:6px; font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.02em; }
		.spx-prio-urgent { background:#fbe4e8; color:#b4324b; } .spx-prio-high { background:#fdeede; color:#a15c00; }
		.spx-prio-normal { background:#eef1f6; color:#5a6572; } .spx-prio-low { background:#eef1f6; color:#8894a4; }
		/* Toolbar right group + list/cards view toggle */
		.spx-toolbar-right { display:flex; align-items:center; gap:0.6rem; }
		.spx-viewtoggle { display:inline-flex; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; overflow:hidden; background:var(--theme-color-background-primary,#fff); }
		.spx-vt-b { border:none; background:transparent; color:var(--theme-color-text-muted,#8894a4); padding:0.42rem 0.62rem; font:inherit; font-size:0.9rem; cursor:pointer; }
		.spx-vt-b + .spx-vt-b { border-left:1px solid var(--theme-color-border-default,#d7dce3); }
		.spx-vt-on { background:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		/* Default LIST view */
		.spx-list { display:flex; flex-direction:column; border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; overflow:hidden; background:var(--theme-color-background-primary,#fff); }
		.spx-row { display:flex; align-items:center; gap:0.9rem; text-align:left; background:transparent; border:none; border-top:1px solid var(--theme-color-border-light,#eef1f6); padding:0.7rem 1rem; cursor:pointer; font:inherit; width:100%; transition:background .1s; }
		.spx-row:first-child { border-top:none; }
		.spx-row:hover { background:var(--theme-color-background-hover,#f5f7fb); }
		.spx-row-badge { display:inline-flex; align-items:center; gap:0.35rem; border-radius:999px; padding:0.22rem 0.6rem; font:600 0.76rem/1 inherit; white-space:nowrap; flex:0 0 auto; min-width:8.5rem; justify-content:center; }
		.spx-row-main { flex:1 1 auto; min-width:0; display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; }
		.spx-row-sum { font-size:0.92rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100%; }
		.spx-row-tags { display:inline-flex; align-items:center; gap:0.3rem; flex-wrap:wrap; }
		.spx-row-updated { flex:0 0 auto; font-size:0.76rem; color:var(--theme-color-text-muted,#9aa3b1); display:flex; align-items:center; gap:0.35rem; white-space:nowrap; }
		.spx-row-id { flex:0 0 auto; font-size:0.74rem; color:var(--theme-color-text-muted,#9aa3b1); font-variant-numeric:tabular-nums; }
		.spx-row-chev { flex:0 0 auto; color:var(--theme-color-text-muted,#c2cad6); font-size:0.8rem; }
		@media (max-width:640px) { .spx-row-updated, .spx-row-id { display:none; } .spx-row-sum { white-space:normal; } }

		.spx-note { display:flex; align-items:center; gap:0.6rem; padding:1rem 1.1rem; border-radius:10px; background:var(--theme-color-background-secondary,#f5f7fb); color:var(--theme-color-text-secondary,#45505f); font-size:0.92rem; }
		.spx-note-error { background:#fdecef; color:#a3324b; }
		.spx-pager { display:flex; align-items:center; justify-content:center; gap:1rem; margin-top:1rem; flex-wrap:wrap; }
		.spx-pg { display:inline-flex; align-items:center; gap:0.4rem; font:600 0.84rem/1 inherit; padding:0.45rem 0.9rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.spx-pg:hover:not([disabled]) { background:var(--theme-color-background-secondary,#f2f4f8); }
		.spx-pg[disabled] { opacity:0.4; cursor:default; }
		.spx-pg-info { font-size:0.85rem; color:var(--theme-color-text-muted,#6b7686); font-variant-numeric:tabular-nums; }
		.spx-empty { text-align:center; padding:3rem 1rem; color:var(--theme-color-text-muted,#8894a4); font-size:0.95rem; }
		.spx-empty i { display:block; font-size:1.8rem; margin-bottom:0.6rem; opacity:0.5; }
		.spx-empty-sm { padding:1.2rem; font-size:0.85rem; }

		/* Detail */
		.spx-back { display:inline-flex; align-items:center; gap:0.35rem; color:var(--theme-color-text-muted,#6b7686); font-size:0.85rem; cursor:pointer; text-decoration:none; margin-bottom:0.6rem; }
		.spx-back:hover { color:var(--theme-color-brand-primary,#5650e6); }
		.spx-det-head { display:flex; flex-direction:column; gap:0.15rem; margin-bottom:0.9rem; }
		.spx-det-title { font-size:1.25rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); margin:0; }
		.spx-det-meta { display:flex; flex-wrap:wrap; gap:0.6rem 1.4rem; padding:0.9rem 1.1rem; background:var(--theme-color-background-secondary,#f7f8fb); border:1px solid var(--theme-color-border-light,#e7ebf2); border-radius:11px; margin-bottom:1rem; }
		.spx-meta { display:flex; flex-direction:column; gap:0.25rem; }
		.spx-meta-l { font-size:0.66rem; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#9aa3b1); font-weight:800; }
		.spx-det-card { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-default,#e2e6ee); border-radius:12px; padding:1rem 1.2rem; margin-bottom:1rem; }
		.spx-det-h { font-size:0.78rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.7rem; display:flex; align-items:center; gap:0.5rem; }
		.spx-det-body { font-size:0.92rem; color:var(--theme-color-text-primary,#2a323d); line-height:1.55; overflow-wrap:anywhere; word-break:break-word; }
		/* Keep inbound email content (long tokens/URLs/Message-IDs, wide tables, big images) inside the card. */
		.spx-det-body > * { max-width:100%; } .spx-det-body a, .spx-det-body code { overflow-wrap:anywhere; word-break:break-word; } .spx-det-body img { max-width:100%; height:auto; }
		.spx-det-body p { margin:0 0 0.6rem; } .spx-det-body p:last-child { margin-bottom:0; }
		.spx-det-body code { background:var(--theme-color-background-secondary,#eef1f6); padding:0.05rem 0.3rem; border-radius:4px; font-size:0.85em; }
		.spx-det-body h1, .spx-det-body h2, .spx-det-body h3, .spx-det-body h4 { font-size:1.02rem; margin:0.7rem 0 0.35rem; color:var(--theme-color-text-primary,#1f2733); }
		.spx-det-body ul, .spx-det-body ol { margin:0 0 0.6rem; padding-left:1.35rem; } .spx-det-body li { margin:0.15rem 0; }
		.spx-det-body a { color:var(--theme-color-brand-primary,#5650e6); }
		.spx-det-body blockquote { margin:0 0 0.6rem; padding:0.35rem 0.85rem; border-left:3px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-secondary,#f5f7fb); color:var(--theme-color-text-secondary,#45505f); border-radius:0 6px 6px 0; }
		.spx-det-body pre { background:var(--theme-color-background-secondary,#eef1f6); padding:0.5rem 0.7rem; border-radius:6px; overflow-x:auto; margin:0 0 0.6rem; } .spx-det-body pre code { background:none; padding:0; }
		.spx-det-body table { display:block; width:100%; max-width:100%; overflow-x:auto; border-collapse:collapse; margin:0 0 0.6rem; font-size:0.9em; } .spx-det-body th, .spx-det-body td { border:1px solid var(--theme-color-border-default,#e2e6ee); padding:0.3rem 0.5rem; text-align:left; }

		.spx-updates { display:flex; flex-direction:column; gap:0.1rem; }
		.spx-update { display:flex; gap:0.65rem; padding:0.6rem 0; border-top:1px solid var(--theme-color-border-light,#eef1f6); }
		.spx-update:first-child { border-top:none; }
		.spx-update-icon { flex:0 0 auto; width:1.8rem; height:1.8rem; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:0.8rem; }
		.spx-uk-ack { background:#e7f0ff; color:#2f5fd0; } .spx-uk-res { background:#e5f6ec; color:#1f8a4c; }
		.spx-update-body { flex:1 1 auto; min-width:0; }
		.spx-update-head { display:flex; align-items:baseline; gap:0.5rem; }
		.spx-update-head b { color:var(--theme-color-text-primary,#1f2733); font-size:0.88rem; }
		.spx-update-when { margin-left:auto; font-size:0.72rem; color:var(--theme-color-text-muted,#9aa3b1); white-space:nowrap; }
		.spx-update-text { font-size:0.9rem; color:var(--theme-color-text-primary,#2a323d); margin-top:0.2rem; white-space:pre-wrap; word-break:break-word; }
	`,

	Templates:
	[
		{
			Hash: 'SupportPortal-Template',
			Template: html`
				<section class="section spx-page">
					<h1 class="spx-page-h"><i class="fas fa-headset"></i> Support Cases</h1>
					<p class="spx-page-sub">Track your organization’s open support cases and updates from the HeadLight support team.</p>
					<div id="SupportPortal-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'SupportPortalWrap',
			TemplateHash: 'SupportPortal-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"pict-view":1053}],1479:[function(require,module,exports){
// Promoted to the `pict-section-tabbar` library. This shim keeps the existing app imports
// (require('./TabBar.js') / require('../views/TabBar.js')) working unchanged; new code should
// require the library directly. See source/pict-section-tabbar/.
module.exports = require('pict-section-tabbar');

},{"pict-section-tabbar":1039}],1480:[function(require,module,exports){

const libPictView = require('pict-view');
const libNavigationTopics = require('../navigation-topics.js');

const html = String.raw;

/**
 * Host view — a per-topic dashboard page.
 *
 * One generic view drives every top-level topic (Users, Projects, Observations, Forms,
 * Data Lake). The router sets AppData.CurrentTopic to a TOPIC_CONFIGS entry before
 * rendering; this view paints a KPI jumbotron for that topic and a pre-filtered nav list
 * (pict-section-navigation List scoped to the topic's category hashes).
 */
class TopicPage extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get _topic()
	{
		return this.pict.AppData.CurrentTopic || libNavigationTopics.TOPIC_CONFIGS.Settings;
	}

	onBeforeRender(pRenderable)
	{
		const tmpTopic = this._topic;
		this.pict.AppData.NavJumbo = { Title: tmpTopic.Title, Icon: tmpTopic.Icon, Blurb: tmpTopic.Blurb };
		this.pict.AppData.NavKpis = libNavigationTopics.buildKpiRecords(
			this.pict.AppData.DashboardStats, tmpTopic.KpiKeys, this.pict.PictApplication.isHeadlightSession());
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		const tmpTopic = this._topic;

		// Optional "coming soon" banner (Data Lake).
		this.pict.ContentAssignment.assignContent('#TopicPage-Note', tmpTopic.ComingSoon
			? `<div class="topic-comingsoon"><span class="icon"><i class="fas fa-hard-hat"></i></span> <span>This area is just getting started — the tools below are available now, with more on the way.</span></div>`
			: '');

		// Pre-filtered nav list for this topic (the global customer gate still applies).
		const tmpProvider = this.pict.providers['Pict-Navigation'];
		if (tmpProvider)
		{
			tmpProvider.render('List', '#TopicPage-Nav', { Scope: tmpTopic.Scope });
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}
}

module.exports = TopicPage;

module.exports.default_configuration =
{
	ViewIdentifier: 'TopicPage',
	DefaultRenderable: 'TopicPageWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.topic-comingsoon { display: flex; align-items: center; gap: 0.6rem; max-width: 780px; margin: 0 auto 1.25rem;
	background: var(--bulma-scheme-main-bis, #f4f6fa); border: 1px dashed var(--bulma-border, #d7dce3);
	border-radius: 10px; padding: 0.7rem 1rem; color: var(--bulma-text-weak, #6b7686); font-size: 0.9rem; }
.topic-comingsoon .icon { color: var(--bulma-link, #156dd1); }
`,

	Templates:
	[
		libNavigationTopics.KPI_CARD_TEMPLATE,
		{
			Hash: 'TopicPage-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="nav-jumbo">
							<div class="nav-jumbo-head">
								<span class="nav-jumbo-ic"><i class="{~D:AppData.NavJumbo.Icon~}"></i></span>
								<div>
									<h1 class="nav-jumbo-title">{~D:AppData.NavJumbo.Title~}</h1>
									<p class="nav-jumbo-sub">{~D:AppData.NavJumbo.Blurb~}</p>
								</div>
							</div>
							<div class="nav-kpi-strip">{~TS:Nav-Kpi-Card:AppData.NavKpis~}</div>
						</div>
						<div id="TopicPage-Note"></div>
						<div id="TopicPage-Nav" class="pict-nav"></div>
					</div>
				</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'TopicPageWrap',
			TemplateHash: 'TopicPage-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};

},{"../navigation-topics.js":1295,"pict-view":1053}],1481:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * UserActivity — the #/UserActivity[/:IDUser] screen. A per-user temporal "create pressure" view: how many
 * Observations, Documents, Comments and Document-Approval actions a user created (or updated) per day/week/month.
 *
 * Thin shell (SuperUserGrant/ManageCustomers style): all data + logic + HTML live in the shared
 * ActivityObservability provider, which renders into #AO-UserActivity-Body and owns the Chart.js canvas.
 */
class UserActivity extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ActivityObservability; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._ensureStyles();
			tmpProvider.renderUserActivity();
			// Base route (no :IDUser) — default to the signed-in user. The :IDUser sub-route pre-sets IDUser and
			// loads explicitly, so skip the auto-load when a user is already targeted.
			if (!tmpProvider.userActivity.IDUser && !tmpProvider.userActivity.Loading) { tmpProvider.loadUserActivityAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = UserActivity;
module.exports.default_configuration =
{
	ViewIdentifier: 'UserActivity',
	// Reusable app-shell Dashboard Mode — render full browser width (see PlatformConfiguration-Router _applyDashboardMode).
	DashboardMode: true,
	DefaultRenderable: 'UserActivityWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: '',
	Templates:
	[
		{
			Hash: 'UserActivity-Wrap',
			Template: /*html*/`
				<div class="ao-wrap">
					<div class="ao-head">
						<h1 class="ao-title">User Activity</h1>
						<p class="ao-subtitle">A user&#8217;s record-creation pressure over time — Observations, Documents, Comments and Document Approval actions, bucketed by day, week or month.</p>
					</div>
					<div id="AO-UserActivity-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'UserActivityWrap',
			TemplateHash: 'UserActivity-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1482:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// Small additions on top of the reused .pew-* form styles: the Disabled checkbox row and the required-field mark.
const UCW_CSS = /*css*/`
	.ucw-check { display: inline-flex; align-items: center; gap: 0.5rem; font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); cursor: pointer; }
	.ucw-check input { width: 1rem; height: 1rem; }
	.ucw-req { color: var(--theme-color-status-error, #cf5b5b); font-weight: 700; }
`;

/**
 * UserCreateWorkspace — the bespoke User CREATE screen (reached by the app-router Create bridge on
 * #/PSRS/User/Create, which shadows the generic recordset create form so "+ New" opens the curated experience
 * instead of the plain manifest form). A thin shell: all data, behavior, and hand-built form HTML live in the
 * UserCreateWorkspace provider, which assigns into the #UCW-Body mount. Reuses the Edit workspace's .pew-* CSS.
 */
class UserCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.UserCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = UserCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'UserCreateWorkspace',
	DefaultRenderable: 'UserCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	// Reuse the Edit workspace's .pew-* styles verbatim (injection is idempotent by class), plus this screen's
	// two small additions.
	CSS: libProjectEditWorkspace.default_configuration.CSS + UCW_CSS,
	Templates:
	[
		{
			Hash: 'UserCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="UCW-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'UserCreateWorkspaceWrap',
			TemplateHash: 'UserCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"./ProjectEditWorkspace.js":1463,"pict-view":1053}],1483:[function(require,module,exports){
'use strict';

const libPictView = require('pict-view');

/**
 * UserLoginOverview — the #/UserLoginOverview screen. A roster of the customer's users with login recency
 * (Active / Idle / Dormant / Never), a recency doughnut computed from exact server counts, and a search/filter.
 *
 * Thin shell over the shared ActivityObservability provider (renders into #AO-Logins-Body).
 */
class UserLoginOverview extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ActivityObservability; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._ensureStyles();
			tmpProvider.renderLogins();
			if (!tmpProvider.logins.Loading) { tmpProvider.loadLoginsAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = UserLoginOverview;
module.exports.default_configuration =
{
	ViewIdentifier: 'UserLoginOverview',
	// Reusable app-shell Dashboard Mode — render full browser width (see PlatformConfiguration-Router _applyDashboardMode).
	DashboardMode: true,
	DefaultRenderable: 'UserLoginOverviewWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: '',
	Templates:
	[
		{
			Hash: 'UserLoginOverview-Wrap',
			Template: /*html*/`
				<div class="ao-wrap">
					<div class="ao-head">
						<h1 class="ao-title">User Logins</h1>
						<p class="ao-subtitle">Every user and when they last signed in — with an at-a-glance breakdown of who is active, idle, dormant, or has never logged in.</p>
					</div>
					<div id="AO-Logins-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'UserLoginOverviewWrap',
			TemplateHash: 'UserLoginOverview-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":1053}],1484:[function(require,module,exports){

const libPictProvider = require('pict-provider');

/**
 * Data provider for platform dashboard views.
 *
 * Centralizes API calls to the Platform Data Operations service,
 * Chart.js instance management, and common formatting utilities.
 */
class PlatformDashboardDataProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;

		this._Charts = {};
		this._RNIMap = null;
	}

	/**
	 * Get the customer ID for the current session.
	 * @return {number|null}
	 */
	getCustomerID()
	{
		return this.pict.AppData.CurrentUser?.CustomerID || null;
	}

	/**
	 * Fetch dashboard data from the Platform Data Operations service.
	 *
	 * @param {string} pEndpoint - The endpoint path (after /1.0/).
	 * @return {Promise<any>}
	 */
	async fetchData(pEndpoint)
	{
		return new Promise((resolve, reject) =>
		{
			const restClient = this.pict.fable.HeadlightRestClient || this.pict.HeadlightRestClient;
			if (!restClient)
			{
				this.pict.log.warn('HeadlightRestClient not available for dashboard data');
				resolve(null);
				return;
			}

			restClient.getJSON(pEndpoint, (pError, pBody, pRawResponse) =>
			{
				if (pError)
				{
					this.pict.log.warn(`Dashboard fetch error for ${pEndpoint}: ${pError}`);
					resolve(null);
					return;
				}
				this.pict.log.info(`Dashboard data for ${pEndpoint}: type=${typeof pBody}, isArray=${Array.isArray(pBody)}, keys=${pBody ? Object.keys(pBody).slice(0, 5).join(',') : 'null'}`);
				resolve(pBody);
			});
		});
	}

	/**
	 * Page through a list endpoint that returns `{total, items}` envelopes
	 * (or a bare array — both shapes are tolerated) and concatenate the
	 * results.  Used by panels that need the *whole* customer set rather
	 * than the first server page, e.g. the Users panel computing KPIs.
	 *
	 * Bounded by `maxPages` so a runaway customer doesn't drag the browser
	 * down; defaults match the service's `_pagingFromQuery` max cap of 200.
	 *
	 * @param {string} pEndpoint - Endpoint path (no query string).
	 * @param {object} [pOptions]
	 * @param {number} [pOptions.pageSize=200]
	 * @param {number} [pOptions.maxPages=100]
	 * @return {Promise<Array<object>>}
	 */
	async fetchAllPages(pEndpoint, pOptions)
	{
		const tmpPageSize = (pOptions && pOptions.pageSize) || 200;
		const tmpMaxPages = (pOptions && pOptions.maxPages) || 100;
		const tmpJoin = pEndpoint.indexOf('?') === -1 ? '?' : '&';
		const tmpAll = [];
		for (let i = 0; i < tmpMaxPages; i++)
		{
			const tmpOffset = i * tmpPageSize;
			const tmpURL = `${pEndpoint}${tmpJoin}offset=${tmpOffset}&limit=${tmpPageSize}`;
			const tmpData = await this.fetchData(tmpURL);
			const tmpItems = Array.isArray(tmpData)
				? tmpData
				: (tmpData && Array.isArray(tmpData.items) ? tmpData.items : []);
			if (tmpItems.length === 0)
			{
				break;
			}
			tmpAll.push(...tmpItems);
			if (tmpItems.length < tmpPageSize)
			{
				break;
			}
			if (i === tmpMaxPages - 1)
			{
				this.pict.log.warn(
					`fetchAllPages(${pEndpoint}): hit ${tmpMaxPages}-page ceiling (${tmpAll.length} rows) — caller should narrow`);
			}
		}
		return tmpAll;
	}

	/**
	 * Get the ReportNamedInstance hash→name mapping (cached).
	 * @return {Promise<object>}
	 */
	async getRNIMap()
	{
		if (this._RNIMap)
		{
			return this._RNIMap;
		}
		const data = await this.fetchData('PlatformDashboard/RNIMap');
		this._RNIMap = data || {};
		return this._RNIMap;
	}

	/**
	 * Resolve a DocumentType hash to a friendly name.
	 * @param {string} pHash
	 * @return {string}
	 */
	rniName(pHash)
	{
		if (!pHash)
		{
			return pHash;
		}
		return (this._RNIMap && this._RNIMap[pHash]) || pHash;
	}

	/**
	 * Destroy a chart by container ID, if it exists.
	 * @param {string} pChartID
	 */
	destroyChart(pChartID)
	{
		if (this._Charts[pChartID])
		{
			this._Charts[pChartID].destroy();
			delete this._Charts[pChartID];
		}
	}

	/**
	 * Create or replace a Chart.js chart.
	 *
	 * @param {string} pCanvasID - The canvas element ID.
	 * @param {string} pType - Chart type (line, bar, doughnut, etc.).
	 * @param {object} pData - Chart.js data config.
	 * @param {object} [pOptions] - Chart.js options.
	 * @return {object|null} The Chart instance, or null if canvas not found.
	 */
	createChart(pCanvasID, pType, pData, pOptions)
	{
		this.destroyChart(pCanvasID);

		const canvas = document.getElementById(pCanvasID);
		if (!canvas)
		{
			return null;
		}

		const Chart = window.Chart;
		if (!Chart)
		{
			this.pict.log.warn('Chart.js not loaded');
			return null;
		}

		const chart = new Chart(canvas.getContext('2d'),
			{
				type: pType,
				data: pData,
				options: Object.assign(
					{
						responsive: true,
						maintainAspectRatio: false,
						plugins:
						{
							legend: { position: 'bottom' },
						},
					}, pOptions || {}),
			});

		this._Charts[pCanvasID] = chart;
		return chart;
	}

	/**
	 * Standard color palette for charts.
	 * @return {string[]}
	 */
	get chartColors()
	{
		return [
			'#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6',
			'#ec4899', '#64748b', '#14b8a6', '#f97316', '#06b6d4',
			'#84cc16', '#a855f7', '#e11d48', '#0ea5e9', '#eab308',
		];
	}

	/**
	 * Format a number with commas.
	 * @param {number} pNum
	 * @return {string}
	 */
	formatNumber(pNum)
	{
		if (pNum == null || isNaN(pNum))
		{
			return '--';
		}
		return Number(pNum).toLocaleString();
	}

	/**
	 * Format a date string for display.
	 * @param {string} pDate
	 * @return {string}
	 */
	formatDate(pDate)
	{
		if (!pDate)
		{
			return '--';
		}
		try
		{
			return new Date(pDate).toLocaleDateString();
		}
		catch (e)
		{
			return pDate;
		}
	}

	/**
	 * Format a currency amount.
	 * @param {number} pAmount
	 * @return {string}
	 */
	formatMoney(pAmount)
	{
		if (pAmount == null || isNaN(pAmount))
		{
			return '--';
		}
		return '$' + Number(pAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	/**
	 * Destroy all tracked charts (for cleanup on view tear-down).
	 */
	destroyAllCharts()
	{
		for (const chartID of Object.keys(this._Charts))
		{
			this.destroyChart(chartID);
		}
	}
}

module.exports = PlatformDashboardDataProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: 'PlatformDashboardData',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

},{"pict-provider":845}],1485:[function(require,module,exports){
'use strict';

// Account workspace — a balance-bearing ledger account, typed by AccountType and scoped to an entity (EntityName +
// IDEntity). Overview-only: Identity (+ AccountType FK card) · Scope · Balances.
module.exports = {
	Identifier: 'AccountWorkspace', Ordinal: 252,
	Entity: { Name: 'Account', IDField: 'IDAccount', Collection: 'Accounts', GUIDField: 'GUIDAccount' },
	Header: { Eyebrow: 'Account', Title: (r) => r.Name || `Account ${r.IDAccount}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Account/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'IDAccountType', Label: 'Account Type', Card: 'AccountType' }, { Key: 'Description', Label: 'Description', Wide: true } ] },
		{ Name: 'Scope', Fields: [ { Key: 'EntityName', Label: 'Entity' }, { Key: 'IDEntity', Label: 'Entity ID', Format: 'id' } ] },
		{ Name: 'Balances', Fields: [ { Key: 'Balance', Label: 'Balance', Format: 'currency' }, { Key: 'Pending', Label: 'Pending', Format: 'currency' } ] },
	],
};

},{}],1486:[function(require,module,exports){
'use strict';

// AccountType workspace — a ledger account classification. Overview + the Accounts of this type (FK childlist on
// Account.IDAccountType).
module.exports = {
	Identifier: 'AccountTypeWorkspace', Ordinal: 253,
	Entity: { Name: 'AccountType', IDField: 'IDAccountType', Collection: 'AccountTypes', GUIDField: 'GUIDAccountType' },
	Header: { Eyebrow: 'Account Type', Title: (r) => r.Name || `Account Type ${r.IDAccountType}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/AccountType/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'accounts', Label: 'Accounts', Icon: 'fas fa-wallet', Content: { kind: 'childlist', ref: 'Account', parentField: 'IDAccountType',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'EntityName', Label: 'Entity' }, { Key: 'Balance', Label: 'Balance', Num: true }, { Key: 'Pending', Label: 'Pending', Num: true } ], empty: 'No accounts of this type.' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'EntityName', Label: 'Entity' }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};

},{}],1487:[function(require,module,exports){
'use strict';

// Asset workspace (PhysicalAsset) — refactored onto pict-section-workspace. Records live under the PhysicalAsset
// recordset (#/PSRS/PhysicalAsset/List) but the workspace routes read #/Asset/Workspace/:ID (RoutePrefix). All
// seven tab bodies are bespoke `render` methods on the AssetWorkspaceProvider subclass; the Location tab hosts the
// reused ProjectCenterMap (mounted from its OnEnter). See [[AssetWorkspace-Provider.js]].

const libAssetWorkspaceProvider = require('../providers/AssetWorkspace-Provider.js');

module.exports = {
	Identifier: 'AssetWorkspace',
	Ordinal: 30,
	ProviderClass: libAssetWorkspaceProvider,
	Entity: { Name: 'PhysicalAsset', IDField: 'IDPhysicalAsset', Collection: 'PhysicalAssets', GUIDField: 'GUIDPhysicalAsset' },
	RoutePrefix: 'Asset',
	Header:
	{
		Eyebrow: 'Asset',
		Title: (pRec) => pRec.Name || `#${pRec.IDPhysicalAsset}`,
		Subtitle: (pRec) => [ pRec.AssetNumber ? 'Asset #' + pRec.AssetNumber : '', pRec.ExternalSyncGUID ? 'Structure ' + pRec.ExternalSyncGUID : '', pRec.__typeName || '', pRec.__classificationName || '' ].filter(Boolean).join(' · '),
		// Scheduling an inspection starts from the asset being inspected — that is the loop the bridge apps have
		// always had. Hands the asset to the create screen, which resolves its project and generates the packet.
		Actions: [ { Label: 'Schedule inspection', Icon: 'fas fa-calendar-plus', Style: 'is-link', OnClick: 'scheduleInspection()' } ],
		ListRoute: '#/PSRS/PhysicalAsset/List',
	},
	// PhysicalAsset is externally synced: its generic EDIT form opens the (view-only) workspace instead.
	Edit: { Route: 'workspace' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'render', ref: '_overviewHTML' }, OnEnter: (pProv) => pProv._scheduleCPMount() },
		{ Key: 'location', Label: 'Location', Icon: 'fas fa-location-dot', Content: { kind: 'render', ref: '_locationHTML' }, OnEnter: (pProv) => pProv._mountMap() },
		{ Key: 'elements', Label: 'Elements', Icon: 'fas fa-diagram-project', Content: { kind: 'render', ref: '_elementsHTML' }, OnEnter: (pProv) => pProv._ensureTabDataAsync('elements') },
		{ Key: 'defects', Label: 'Defects', Icon: 'fas fa-triangle-exclamation', Content: { kind: 'render', ref: '_defectsHTML' }, OnEnter: (pProv) => pProv._ensureTabDataAsync('defects') },
		{ Key: 'observations', Label: 'Observations', Icon: 'fas fa-clipboard-check', Content: { kind: 'render', ref: '_observationsHTML' }, OnEnter: (pProv) => pProv._ensureTabDataAsync('observations') },
		{ Key: 'documents', Label: 'Documents', Icon: 'fas fa-file-lines', Content: { kind: 'render', ref: '_documentsHTML' }, OnEnter: (pProv) => pProv._ensureTabDataAsync('documents') },
		{ Key: 'migrate', Label: 'Migrate', Icon: 'fas fa-cloud-arrow-down', Content: { kind: 'render', ref: '_migrateHTML' } },
	],
	CSSExtra: /*css*/`
		.aw-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.6rem 0; }
		.aw-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.aw-error-inline { font-size:0.8rem; color:var(--theme-color-status-error,#b3382f); margin-left:0.5rem; }
		.aw-result { font-size:0.88rem; color:#1b6e3a; background:#e4f5ea; border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.aw-muted { color:var(--theme-color-text-muted,#aab3c0); }
		.aw-mono { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.82rem; color:var(--theme-color-text-primary,#1f2733); }
		.aw-fields { display:grid; grid-template-columns:repeat(auto-fill,minmax(14rem,1fr)); gap:0.9rem 1.4rem; }
		.aw-field-label { font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.aw-field-value { font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); margin-top:0.1rem; }
		.aw-cp-note { margin-top:1.2rem; font-size:0.83rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#eef1f6); border-radius:7px; padding:0.55rem 0.7rem; }
		.aw-cp-head { display:flex; align-items:center; gap:0.5rem; margin:1.4rem 0 0.6rem; font-size:0.74rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding-bottom:0.35rem; }
		.aw-cp-edit { margin-left:auto; font-weight:600; text-transform:none; letter-spacing:normal; font-size:0.78rem; }
		.aw-cp-group { margin:0 0 1rem; }
		.aw-cp-group-h { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8894a4); margin:0 0 0.4rem; }
		.aw-cp-actions { margin-left:auto; display:inline-flex; align-items:center; gap:0.5rem; }
		.aw-cp-in { width:100%; font-size:0.9rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#c7cfda); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.aw-cp-ta { min-height:3rem; resize:vertical; font-family:inherit; }
		.aw-cp-pick { min-width:12rem; }
		.aw-cp-chk { display:inline-flex; align-items:center; }
		.aw-req { color:var(--theme-color-status-error,#b3382f); font-weight:800; }
		.aw-table { width:100%; border-collapse:collapse; font-size:0.86rem; }
		.aw-table th { text-align:left; font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding:0.35rem 0.5rem; }
		.aw-table td { border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); padding:0.4rem 0.5rem; color:var(--theme-color-text-primary,#1f2733); vertical-align:middle; }
		.aw-num { text-align:right; font-variant-numeric:tabular-nums; }
		.aw-csbar-cell { width:9rem; }
		.aw-csbar { display:flex; height:0.7rem; width:8rem; border-radius:4px; overflow:hidden; background:var(--theme-color-background-secondary,#eef1f6); }
		.aw-cs { display:block; height:100%; }
		.aw-cs1 { background:#3a9b5c; } .aw-cs2 { background:#d0b02c; } .aw-cs3 { background:#d8862c; } .aw-cs4 { background:#cf5b5b; }
		.aw-cs1-h, .aw-cs1-t { color:#2f7d46; } .aw-cs2-h, .aw-cs2-t { color:#977c17; } .aw-cs3-h, .aw-cs3-t { color:#b56a1e; } .aw-cs4-h, .aw-cs4-t { color:#b3382f; }
		.aw-cs1-h, .aw-cs2-h, .aw-cs3-h, .aw-cs4-h { font-weight:800; }
		.aw-loc-top { display:flex; align-items:center; gap:0.8rem; margin-bottom:0.6rem; }
		.aw-loc-coords { font-size:0.95rem; }
		.aw-map { height:22rem; width:100%; border-radius:8px; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-secondary,#eef1f6); }
		.aw-hint { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); margin:0.5rem 0; }
		.aw-plan { font-size:0.88rem; margin:0 0 0.6rem; }
		.aw-actions { display:flex; align-items:center; gap:0.55rem; flex-wrap:wrap; margin-top:0.4rem; }
		.aw-confirm-q { font-size:0.86rem; font-weight:600; }
		.aw-btn { font-size:0.84rem; font-weight:600; padding:0.4rem 0.8rem; border-radius:7px; border:1px solid transparent; cursor:pointer; }
		.aw-btn[disabled] { opacity:0.5; cursor:default; }
		.aw-btn-primary { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; }
		.aw-btn-ghost { background:transparent; border-color:var(--theme-color-border-medium,#c7cfda); color:var(--theme-color-text-primary,#1f2733); }
		.aw-btn-ghost:hover:not([disabled]) { background:var(--theme-color-background-secondary,#eef1f6); }
		.aw-btn-sm { font-size:0.78rem; padding:0.28rem 0.6rem; }
		/* element management (master + detail) */
		.aw-addbar { display:flex; align-items:center; gap:0.7rem; flex-wrap:wrap; margin:0 0 0.8rem; padding:0.5rem 0.7rem; background:var(--theme-color-background-secondary,#eef1f6); border-radius:8px; }
		.aw-addbar-l { font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.aw-pick { min-width:20rem; flex:1 1 20rem; max-width:34rem; }
		.aw-link { color:var(--theme-color-brand-primary,#156dd1); cursor:pointer; text-decoration:none; }
		.aw-link:hover { text-decoration:underline; }
		.aw-chip { display:inline-block; font-size:0.68rem; font-weight:700; padding:0.05rem 0.4rem; border-radius:10px; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-secondary,#45505f); vertical-align:middle; }
		.aw-row-act { text-align:right; white-space:nowrap; }
		.aw-x { background:transparent; border:none; cursor:pointer; color:var(--theme-color-text-muted,#8894a4); font-size:0.85rem; padding:0.2rem 0.35rem; border-radius:5px; }
		.aw-x:hover { background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-primary,#1f2733); }
		.aw-x-yes { color:#1b6e3a; }
		.aw-detail-head { display:flex; align-items:center; gap:0.7rem; margin:0 0 0.7rem; }
		.aw-detail-title { font-size:1.05rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); }
		.aw-basics { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin:0 0 1rem; padding:0.5rem 0.7rem; background:var(--theme-color-background-secondary,#eef1f6); border-radius:8px; }
		.aw-units { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); }
		.aw-inl { display:inline-flex; align-items:center; gap:0.35rem; font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); }
		.aw-in { font-size:0.86rem; padding:0.28rem 0.4rem; border:1px solid var(--theme-color-border-medium,#c7cfda); border-radius:6px; background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.aw-in-num { width:5.5rem; text-align:right; font-variant-numeric:tabular-nums; }
		.aw-in-yr { width:4.5rem; }
		.aw-sec { margin:1.1rem 0 0; }
		.aw-sec-h { display:flex; align-items:center; justify-content:space-between; gap:0.7rem; font-size:0.74rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding:0 0 0.35rem; margin:0 0 0.5rem; }
		.aw-sec-h i { margin-right:0.3rem; }
		.aw-subtable td, .aw-subtable th { padding:0.35rem 0.5rem; }
		.aw-editing td { background:var(--theme-color-background-secondary,#f4f7fb); }
		.aw-csedit { display:inline-flex; align-items:center; gap:0.6rem; flex-wrap:wrap; }
		.aw-editbar { display:inline-flex; align-items:center; gap:0.4rem; margin-left:0.6rem; }
		.aw-defadd { display:flex; align-items:center; gap:0.6rem; flex-wrap:wrap; margin:0 0 0.5rem; }
		.aw-defedit-name { font-size:0.9rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); margin:0 0 0.45rem; }
	`,
};

},{"../providers/AssetWorkspace-Provider.js":1307}],1488:[function(require,module,exports){
'use strict';

// AssetType workspace (#/AssetType/Workspace/:ID[/:Tab]) — unifies the asset type's former three screens
// (the master list, the retired flat manifest editor, and the metadata-shape editor) into one tabbed page.
// Overview edits Name/Description; the Metadata Shape tab embeds the AssetTypeDescriptor editor (now both
// an authoring and a display-tailoring surface) scoped to this type. See [[AssetTypeWorkspace-Provider.js]].

const libAssetTypeWorkspaceProvider = require('../providers/AssetTypeWorkspace-Provider.js');

module.exports = {
	Identifier: 'AssetTypeWorkspace',
	Ordinal: 31,
	ProviderClass: libAssetTypeWorkspaceProvider,
	Entity: { Name: 'AssetType', IDField: 'IDAssetType', Collection: 'AssetTypes', GUIDField: 'GUIDAssetType' },
	RoutePrefix: 'AssetType',
	Header:
	{
		Eyebrow: 'Asset Type',
		Title: (pRec) => pRec.Name || `#${ pRec.IDAssetType }`,
		Subtitle: (pRec) => pRec.Description || '',
		ListRoute: '#/PSRS/AssetType/List',
	},
	// The generic PSRS Edit link opens the workspace (identical to Asset.config.js — harmless without EditContent).
	Edit: { Route: 'workspace' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'render', ref: '_overviewHTML' } },
		{ Key: 'metadata', Label: 'Metadata Shape', Icon: 'fas fa-sliders', Content: { kind: 'embed', ref: 'AssetTypeDescriptor', style: 'provider' } },
	],
	CSSExtra: /*css*/`
		.atw-form { display:flex; flex-direction:column; gap:0.9rem; max-width:40rem; }
		.atw-field { display:flex; flex-direction:column; gap:0.25rem; }
		.atw-label { font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.atw-in { font-size:0.9rem; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#c7cfda); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.atw-ta { min-height:5rem; resize:vertical; font-family:inherit; }
		.atw-actions { display:flex; gap:0.6rem; align-items:center; margin-top:0.3rem; }
		.atw-btn { font-size:0.86rem; font-weight:600; padding:0.45rem 1rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#2e7d74); background:var(--theme-color-brand-primary,#2e7d74); color:#fff; cursor:pointer; }
		.atw-btn[disabled] { opacity:0.55; cursor:default; }
		.atw-msg { font-size:0.85rem; color:#1b6e3a; margin:0 0 0.6rem; }
		.atw-err { font-size:0.85rem; color:var(--theme-color-status-error,#b3382f); margin:0 0 0.6rem; }
		.atw-hint { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); }
		.atw-note { margin-top:1.1rem; font-size:0.83rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#eef1f6); border-radius:7px; padding:0.55rem 0.7rem; }
	`,
};

},{"../providers/AssetTypeWorkspace-Provider.js":1306}],1489:[function(require,module,exports){
'use strict';

// Contact workspace — a person record with a primary Organization FK plus M:N ties to Organizations and Projects.
// Overview + two association tabs.
module.exports = {
	Identifier: 'ContactWorkspace', Ordinal: 255,
	Entity: { Name: 'Contact', IDField: 'IDContact', Collection: 'Contacts', GUIDField: 'GUIDContact' },
	Header: { Eyebrow: 'Contact', Title: (r) => r.NameFull || `${r.NameFirst || ''} ${r.NameLast || ''}`.trim() || `Contact ${r.IDContact}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Contact/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'organizations', Label: 'Organizations', Icon: 'fas fa-building', Content: { kind: 'assoc', ref: 'ContactOrganization' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'ContactProject' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'NameFirst', Label: 'First Name' }, { Key: 'NameLast', Label: 'Last Name' }, { Key: 'Title', Label: 'Title' }, { Key: 'IDOrganization', Label: 'Organization', Card: 'Organization' } ] },
		{ Name: 'Contact', Fields: [ { Key: 'Email', Label: 'Email', Wide: true }, { Key: 'Phone', Label: 'Phone' } ] },
	],
};

},{}],1490:[function(require,module,exports){
'use strict';

// Contract workspace — the construction-contract hub. Refactored onto pict-section-workspace: the base owns
// the shell + Overview + the RecordDates embed; the ContractWorkspace subclass carries the bespoke Projects tab
// (FK children + add/remove/create-under-contract management) and the Bid Items list (the contract's bid items,
// each showing its Project when set). The line-item ↔ bid-item MAPPING is a project-scoped concern (line items
// are project-scoped) and lives on the Project workspace, not here. See [[ContractWorkspace-Provider.js]].

const libContractWorkspaceProvider = require('../providers/ContractWorkspace-Provider.js');

module.exports = {
	Identifier: 'ContractWorkspace',
	Ordinal: 221,
	ProviderClass: libContractWorkspaceProvider,
	Entity: { Name: 'Contract', IDField: 'IDContract', Collection: 'Contracts', GUIDField: 'GUIDContract' },
	Header:
	{
		Eyebrow: 'Contract',
		Title: (pRec) => pRec.Name || `Contract ${pRec.IDContract}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ],
		ListRoute: '#/PSRS/Contract/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'dates', Label: 'Important Dates', Icon: 'fas fa-calendar-day', Content: { kind: 'embed', ref: 'RecordDates', style: 'provider', args: [ 'Contract' ] } },
		{ Key: 'projects', Label: (pProv) => `Projects (${(pProv._projects || []).length})`, Icon: 'fas fa-folder-open', Content: { kind: 'render', ref: 'renderProjects' } },
		{ Key: 'biditems', Label: 'Bid Items', Icon: 'fas fa-gavel', Content: { kind: 'render', ref: 'renderBidItems' }, OnEnter: 'loadBidItemsAsync' },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [
			{ Key: 'Name', Label: 'Contract Name', Wide: true },
			{ Key: 'Status', Label: 'Status' },
			{ Key: 'ExternalContractID', Label: 'External Contract ID' },
		] },
		{ Name: 'Project Numbers', Fields: [
			{ Key: 'PrimaryProjectNumber', Label: 'Primary' },
			{ Key: 'CountyProjectNumber', Label: 'County' },
			{ Key: 'StateProjectNumber', Label: 'State' },
			{ Key: 'FederalProjectNumber', Label: 'Federal' },
		] },
		{ Name: 'Route & Limits', Fields: [
			{ Key: 'RouteNumber', Label: 'Route #' },
			{ Key: 'HighwayNumber', Label: 'Highway #' },
			{ Key: 'PavingMaterial', Label: 'Paving Material' },
			{ Key: 'StationBegin', Label: 'Station Begin' },
			{ Key: 'TerminusBegin', Label: 'Terminus Begin' },
			{ Key: 'StationEnd', Label: 'Station End' },
			{ Key: 'TerminusEnd', Label: 'Terminus End' },
		] },
		{ Name: 'Financials', Fields: [
			{ Key: 'TotalBidAmount', Label: 'Total Bid Amount', Format: 'currency' },
			{ Key: 'NetChangeOrderAmount', Label: 'Net Change Orders', Format: 'currency' },
			{ Key: 'VendorAccountCode', Label: 'Vendor Account Code' },
		] },
		{ Name: 'Specifications', Fields: [
			{ Key: 'ItemSpecificationYear', Label: 'Item Spec Year' },
			{ Key: 'MaterialsSpecificationYear', Label: 'Materials Spec Year' },
			{ Key: 'ItemIDTestSpecificationSet', Label: 'Item Test Spec Set', Format: 'id' },
			{ Key: 'MaterialIDTestSpecificationSet', Label: 'Material Test Spec Set', Format: 'id' },
			{ Key: 'DBEStructure', Label: 'DBE Structure' },
		] },
		{ Name: 'Relationships & Schedule', Fields: [
			{ Key: 'IDOrganization', Label: 'Prime Contractor', Card: 'Organization' },
			{ Key: 'IDContractType', Label: 'Contract Type', Card: 'ContractType' },
			{ Key: 'IDCustomer', Label: 'Customer', Card: 'Customer' },
			{ Key: 'EstimatedCompletionDate', Label: 'Estimated Completion', Format: 'date' },
		] },
		{ Name: 'Audit', Fields: [
			{ Key: 'CreateDate', Label: 'Created', Format: 'date' },
			{ Key: 'UpdateDate', Label: 'Last Updated', Format: 'date' },
			{ Key: 'GUIDContract', Label: 'GUID', Mono: true },
			{ Key: 'IDContract', Label: 'Contract ID', Format: 'id' },
		] },
	],
	CSSExtra: /*css*/`
		.cw-modal-help { font-size: 0.86rem; color: var(--theme-color-text-secondary, #5b6673); margin: 0 0 0.7rem; }
		.cw-addproj-list { max-height: 50vh; overflow-y: auto; margin-top: 0.6rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.cw-addproj-row { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; width: 100%; text-align: left; border: none; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); background: var(--theme-color-background-panel, #fff); padding: 0.55rem 0.8rem; cursor: pointer; font: inherit; color: var(--theme-color-text-primary, #1f2733); }
		.cw-addproj-row:last-child { border-bottom: none; }
		.cw-addproj-row:hover { background: var(--theme-color-background-secondary, #f0f2f6); }
		.cw-addproj-name { font-size: 0.9rem; }
		.cw-addproj-tag { font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--theme-color-text-muted, #8a94a3); flex: none; }
		.cw-addproj-note { padding: 0.9rem; text-align: center; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.86rem; }
		.cw-addproj-err { color: var(--theme-color-status-error, #cf5b5b); }
	`,
};

},{"../providers/ContractWorkspace-Provider.js":1320}],1491:[function(require,module,exports){
'use strict';

// Customer workspace (Headlight-only) — the "Customer dashboard". Overview is the declarative FieldGroups; Modules
// and Customer Team are bespoke `render` tabs on CustomerWorkspace-Provider (lifted from the old #/ManageCustomers
// screen, re-bound to THIS record's customer). The header "Manage Configuration" action impersonates the customer's
// configuration admin. See [[config-app-customer-dashboard]] + source/providers/CustomerWorkspace-Provider.js.

const libCustomerWorkspaceProvider = require('../providers/CustomerWorkspace-Provider.js');

module.exports = {
	Identifier: 'CustomerWorkspace', Ordinal: 248,
	ProviderClass: libCustomerWorkspaceProvider,
	// The customer's per-customer metadata (CustomProperties) rendered as a guided read/edit form under the Overview.
	MetadataBlob: { column: 'CustomProperties', label: 'Customer Metadata' },
	Entity: { Name: 'Customer', IDField: 'IDCustomer', Collection: 'Customers', GUIDField: 'GUIDCustomer' },
	Header:
	{
		Eyebrow: 'Customer',
		// Title carries the customer code badge; the subtitle is the live-counts dashboard strip (filled by AfterRender).
		// (No enabled/disabled badge — Customer.Enabled is an unmaintained column, 0 for ~all customers, gated by nothing.)
		// pict-section-workspace's _escTitle passes a Title through as HTML only when it already contains markup, else it
		// escapes it. So WITH a code we emit the badge <span> (HTML) and must escape the name ourselves; WITHOUT a code we
		// return the RAW name and let the library escape it once — pre-escaping here would double-escape ("Aguirre &amp; Fields").
		Title: (r, prov) =>
		{
			const tmpName = r.Name || ('Customer ' + r.IDCustomer);
			return r.Code ? `${prov._esc(tmpName)} <span class="cw-title-code">${prov._esc(r.Code)}</span>` : tmpName;
		},
		Subtitle: (r, prov) => prov._headerMetricsHTML(),
		AfterRender: (prov) => prov._ensureCountsAsync(),
		Actions:
		[
			// Gated to anyone who may impersonate (a level-5 super-user OR a support user with Customer-Impersonate).
			{ Label: 'Manage Configuration', Icon: 'fas fa-gear', Style: 'is-link', OnClick: 'manageConfiguration()', When: (prov) => prov.canImpersonate() },
			// Publishes this customer's observation-type config out to the field apps (scoped sync). Headlight super-users only.
			{ Label: 'Run Config Sync', Icon: 'fas fa-cloud-arrow-up', Style: 'is-light', OnClick: 'syncConfiguration()', When: (prov) => prov.isSuperUser },
			{ Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-light', OnClick: 'goToEdit()' },
		],
		ListRoute: '#/Customers',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'users', Label: 'Users', Icon: 'fas fa-users', Content: { kind: 'childlist', ref: 'User', parentField: 'IDCustomer',
			columns: [ { Key: 'NameFirst', Label: 'First' }, { Key: 'NameLast', Label: 'Last' }, { Key: 'LoginID', Label: 'Login' } ], empty: 'No users.', cap: 500 } },
		{ Key: 'modules', Label: 'Modules', Icon: 'fas fa-cubes', Content: { kind: 'render', ref: '_modulesHTML' }, OnEnter: (prov) => prov._ensureModulesAsync() },
		{ Key: 'team', Label: 'Customer Team', Icon: 'fas fa-user-shield', Content: { kind: 'render', ref: '_teamHTML' } },
		{ Key: 'grants', Label: 'Grants', Icon: 'fas fa-user-lock', Content: { kind: 'render', ref: '_grantsHTML' }, OnEnter: (prov) => prov._ensureGrantsAsync() },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields:
			[
				{ Key: 'Name', Label: 'Name', Wide: true },
				{ Key: 'Code', Label: 'Code', Mono: true },
				{ Key: 'Timezone', Label: 'Timezone' },
				{ Key: 'Enabled', Label: 'Enabled', Format: 'bool' },
			] },
	],
	CSSExtra: /*css*/`
		.cw-help { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.9rem; line-height:1.5; }
		.cw-help code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.82em; background:var(--theme-color-background-secondary,#eef1f6); border-radius:4px; padding:0.05rem 0.3rem; }
		.cw-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.7rem 0.1rem; }
		.cw-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.cw-filter { width:100%; box-sizing:border-box; font-size:0.9rem; padding:0.5rem 0.7rem; margin:0 0 0.7rem; border:1px solid var(--theme-color-border,#d5dbe3); border-radius:7px; background:var(--theme-color-background,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.cw-filter:focus { outline:2px solid var(--theme-color-primary,#2b6cb0); outline-offset:1px; border-color:transparent; }
		.cw-list { border:1px solid var(--theme-color-border-light,#eef1f6); border-radius:8px; }
		.cw-module-results { margin-top:0.2rem; }
		.cw-row { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,14rem) auto; align-items:center; gap:0.8rem; padding:0.55rem 0.8rem; border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); }
		.cw-row:last-child { border-bottom:0; }
		.cw-col-name { font-size:0.92rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); min-width:0; }
		.cw-col-code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.78rem; color:var(--theme-color-text-muted,#6b7686); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cw-col-action { justify-self:end; }
		.cw-badge { display:inline-block; font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:#1b6e3a; background:#e4f5ea; border-radius:4px; padding:0.08rem 0.4rem; margin-left:0.4rem; vertical-align:middle; }
		.cw-app-tag { display:inline-block; font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:#5a4b8a; background:#ece7f6; border-radius:4px; padding:0.08rem 0.4rem; margin-left:0.4rem; vertical-align:middle; }
		.cw-btn { font-size:0.82rem; font-weight:600; cursor:pointer; white-space:nowrap; display:inline-flex; align-items:center; gap:0.35rem; padding:0.35rem 0.7rem; border:1px solid var(--theme-color-border,#d5dbe3); border-radius:7px; background:var(--theme-color-background,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.cw-btn:hover:not([disabled]) { border-color:var(--theme-color-primary,#2b6cb0); color:var(--theme-color-primary,#2b6cb0); }
		.cw-btn[disabled] { opacity:0.6; cursor:default; }
		.cw-btn-remove { color:var(--theme-color-status-error,#b3382f); border-color:var(--theme-color-status-error,#e3b7b4); }
		.cw-btn-remove:hover:not([disabled]) { border-color:var(--theme-color-status-error,#b3382f); color:var(--theme-color-status-error,#b3382f); }
		/* Manage Configuration modal — the configuration-admin account picker (sign in as a specific account). */
		.cw-modal-note { margin:0 0 0.75rem; font-size:0.9rem; color:var(--theme-color-text-secondary,#45505f); line-height:1.5; }
		.cw-modal-note a { color:var(--theme-color-brand-primary,#156dd1); font-weight:600; }
		.cw-modal-accounts { display:flex; flex-direction:column; gap:0.35rem; max-height:22rem; overflow-y:auto; }
		.cw-account { display:flex; align-items:center; gap:0.6rem; width:100%; text-align:left; padding:0.45rem 0.6rem; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; background:var(--theme-color-background-primary,#fff); cursor:pointer; }
		.cw-account:hover { border-color:var(--theme-color-brand-primary,#156dd1); background:var(--theme-color-brand-primary-subtle,#eaf2fc); }
		.cw-account-avatar { flex:0 0 auto; width:1.75rem; height:1.75rem; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-muted,#8a94a3); font-size:0.8rem; }
		.cw-account-id { flex:1 1 auto; min-width:0; display:flex; flex-direction:column; }
		.cw-account-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cw-account-login { font-size:0.74rem; color:var(--theme-color-text-muted,#8a94a3); font-family:ui-monospace,SFMono-Regular,Menlo,monospace; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cw-account-go { flex:0 0 auto; font-size:0.78rem; font-weight:600; color:var(--theme-color-brand-primary,#156dd1); display:inline-flex; align-items:center; gap:0.3rem; }
		/* Header dashboard strip — code/enabled badges by the title + the live-counts metrics row. */
		.cw-title-code { display:inline-block; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.56em; font-weight:700; letter-spacing:0.02em; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#eef1f6); border-radius:5px; padding:0.12rem 0.45rem; vertical-align:middle; }
		.cw-metrics { display:flex; flex-wrap:wrap; gap:1.6rem; margin-top:0.55rem; }
		.cw-metric { display:flex; flex-direction:column; gap:0.05rem; }
		.cw-metric-label { font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#8a94a3); }
		.cw-metric-value { font-size:1.15rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); font-variant-numeric:tabular-nums; }
		/* Grants tab — read-only users × roles grid. */
		.cw-actions { margin:0 0 0.8rem; }
		.cw-grant-results { margin-top:0.2rem; }
		.cw-grant-row { grid-template-columns:minmax(0,12rem) minmax(0,11rem) minmax(0,1fr); align-items:start; }
		.cw-col-grants { display:flex; flex-wrap:wrap; gap:0.3rem; align-items:center; }
		.cw-col-grants .cw-badge { margin-left:0; }
		.cw-badge-level { color:#2a4b8d; background:#e6edfb; }
		.cw-muted { font-size:0.8rem; color:var(--theme-color-text-muted,#8a94a3); }
	`,
};

},{"../providers/CustomerWorkspace-Provider.js":1327}],1492:[function(require,module,exports){
'use strict';
// Document workspace — READ-ONLY. Minimal for now; extend with form data / observations / approval / access tabs.
module.exports = {
	Identifier: 'DocumentWorkspace', Ordinal: 250,
	Entity: { Name: 'Document', IDField: 'IDDocument', Collection: 'Documents', GUIDField: 'GUIDDocument' },
	Header: { Eyebrow: 'Document', Title: (r) => r.Name || `Document ${r.IDDocument}`, ListRoute: '#/PSRS/Document/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [
		{ Key: 'Name', Label: 'Name', Wide: true }, { Key: 'DocumentType', Label: 'Type' }, { Key: 'Status', Label: 'Status' },
		{ Key: 'DocumentDate', Label: 'Date', Format: 'date' }, { Key: 'IDProject', Label: 'Project', Mono: true } ] } ],
};

},{}],1493:[function(require,module,exports){
'use strict';
module.exports = {
	Identifier: 'EquipmentWorkspace', Ordinal: 247,
	Entity: { Name: 'Equipment', IDField: 'IDEquipment', Collection: 'Equipments', GUIDField: 'GUIDEquipment' },
	Header: { Eyebrow: 'Equipment', Title: (r) => r.Name || `Equipment ${r.IDEquipment}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Equipment/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'organizations', Label: 'Organizations', Icon: 'fas fa-building', Content: { kind: 'assoc', ref: 'EquipmentOrganization' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'Code', Label: 'Code', Mono: true }, { Key: 'Description', Label: 'Description', Wide: true }, { Key: 'Status', Label: 'Status' } ] } ],
};

},{}],1494:[function(require,module,exports){
'use strict';

// Fund workspace — a funding pool with running balances. No associations/children in the schema graph, so an
// overview-only detail screen (Identity + Balances + Description).
module.exports = {
	Identifier: 'FundWorkspace', Ordinal: 250,
	Entity: { Name: 'Fund', IDField: 'IDFund', Collection: 'Funds', GUIDField: 'GUIDFund' },
	Header: { Eyebrow: 'Fund', Title: (r) => r.Name || `Fund ${r.IDFund}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Fund/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'CostCenter', Label: 'Cost Center', Mono: true }, { Key: 'ExternalAccountID', Label: 'External Account ID', Mono: true }, { Key: 'Active', Label: 'Active', Format: 'bool' } ] },
		{ Name: 'Balances', Fields: [ { Key: 'OriginalBalance', Label: 'Original Balance', Format: 'currency' }, { Key: 'Balance', Label: 'Balance', Format: 'currency' }, { Key: 'TotalCommitted', Label: 'Total Committed', Format: 'currency' }, { Key: 'CommittedBalance', Label: 'Committed Balance', Format: 'currency' }, { Key: 'TotalPendingCharge', Label: 'Pending Charge', Format: 'currency' } ] },
		{ Name: 'Detail', Fields: [ { Key: 'Description', Label: 'Description', Wide: true } ] },
	],
};

},{}],1495:[function(require,module,exports){
'use strict';

// FundingCategory workspace — a classification for line-item funding. Overview-only (a LineItem→category childlist
// is deferred: it can be large and the LineItem display columns are not settled). NOTE: the Meadow collection is
// `FundingCategorys` (naive pluralization), not `FundingCategories`.
module.exports = {
	Identifier: 'FundingCategoryWorkspace', Ordinal: 251,
	Entity: { Name: 'FundingCategory', IDField: 'IDFundingCategory', Collection: 'FundingCategorys', GUIDField: 'GUIDFundingCategory' },
	Header: { Eyebrow: 'Funding Category', Title: (r) => r.Name || `Funding Category ${r.IDFundingCategory}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/FundingCategory/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'Code', Label: 'Code', Mono: true }, { Key: 'Type', Label: 'Type' }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};

},{}],1496:[function(require,module,exports){
'use strict';

// FundingSource workspace — a balance-bearing source of project funding (FundingSourceProject association).
// Overview + a Projects association tab.
module.exports = {
	Identifier: 'FundingSourceWorkspace', Ordinal: 258,
	Entity: { Name: 'FundingSource', IDField: 'IDFundingSource', Collection: 'FundingSources', GUIDField: 'GUIDFundingSource' },
	Header: { Eyebrow: 'Funding Source', Title: (r) => r.Name || `Funding Source ${r.IDFundingSource}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/FundingSource/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'FundingSourceProject' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'FundingSourceAccountCode', Label: 'Account Code', Mono: true }, { Key: 'Type', Label: 'Type' } ] },
		{ Name: 'Balance', Fields: [ { Key: 'Balance', Label: 'Balance', Format: 'currency' } ] },
		{ Name: 'Detail', Fields: [ { Key: 'Description', Label: 'Description', Wide: true } ] },
	],
};

},{}],1497:[function(require,module,exports){
'use strict';

// Inspection workspace — the first-class per-record interface for a scheduled/dynamic asset inspection, replacing the
// anemic legacy Bridge "Inspection-View" (a read-only info column + a bolted-on Documents/Users panel, with the actual
// conduct forms opening in separate browser tabs). Everything an inspection IS lives here in one tabbed workspace:
//   • Overview   — status (denormalized StatusDisplay), type, the four dates (Scheduled/Start/End/Deadline), name,
//                  description, linked project; inline "Edit details" for the schedulable fields.
//   • Assets     — the PhysicalAssets under inspection (InspectionPhysicalAssetJoin); add/remove, link to the Asset workspace.
//   • Documents  — the inspection's document packet (InspectionDocumentJoin): the IncludeOnDossier flag + ordinal ordering,
//                  Open/View (same-origin HTML via HeadlightDocumentRender — NEVER Fieldbook) + PDF; add/remove/reorder.
//   • Inspectors — assigned users (InspectionUserJoin); add/remove. This is the seam where Phase-3 Team assignment plugs in.
//   • Timeline   — read-only audit trail (InspectionEventLog).
// All 8 Inspection scopes are plain Meadow CRUD (server-side InspectionsBundle) — no bespoke endpoints, no server work.
// Config-driven on pict-section-workspace; auto-routes /Inspection/Workspace/:ID[/:Tab] + shadows /PSRS/Inspection/View/:GUID.
// "Inspection" is already in Permission-Catalog.json. See [[InspectionWorkspace-Provider.js]].

const libInspectionWorkspaceProvider = require('../providers/InspectionWorkspace-Provider.js');

module.exports = {
	Identifier: 'InspectionWorkspace',
	Ordinal: 220,
	ProviderClass: libInspectionWorkspaceProvider,
	Entity: { Name: 'Inspection', IDField: 'IDInspection', Collection: 'Inspections', GUIDField: 'GUIDInspection' },
	RoutePrefix: 'Inspection',
	Header:
	{
		Eyebrow: 'Inspection',
		Title: (r) => r.Name || `Inspection ${r.IDInspection}`,
		Subtitle: (r) => [ r.StatusDisplay || '', r.TypeDisplay || '' ].filter(Boolean).join(' · '),
		ListRoute: '#/PSRS/Inspection/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-clipboard-check', Content: { kind: 'render', ref: '_overviewHTML' }, OnEnter: (p) => p._ensureTabDataAsync('overview') },
		{ Key: 'assets', Label: 'Assets', Icon: 'fas fa-cube', Content: { kind: 'render', ref: '_assetsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('assets') },
		{ Key: 'documents', Label: 'Documents & Dossier', Icon: 'fas fa-folder-open', Content: { kind: 'render', ref: '_documentsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('documents') },
		{ Key: 'inspectors', Label: 'Inspectors', Icon: 'fas fa-user-helmet-safety', Content: { kind: 'render', ref: '_inspectorsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('inspectors') },
		{ Key: 'teams', Label: 'Teams', Icon: 'fas fa-users', Content: { kind: 'render', ref: '_teamsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('teams') },
		{ Key: 'timeline', Label: 'Timeline', Icon: 'fas fa-clock-rotate-left', Content: { kind: 'render', ref: '_timelineHTML' }, OnEnter: (p) => p._ensureTabDataAsync('timeline') },
	],
	CSSExtra: /*css*/`
		.iw-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.6rem 0; display:flex; align-items:center; gap:0.5rem; }
		.iw-hint { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); margin:0 0 0.8rem; display:flex; align-items:center; gap:0.4rem; }
		.iw-hint i { color:var(--theme-color-brand-primary,#2e7d74); }
		.iw-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.iw-muted { color:var(--theme-color-text-muted,#aab3c0); }
		.iw-sec-h { font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:1.2rem 0 0.6rem; }
		/* stat cards + status/type pills (overview) */
		.iw-stats { display:grid; grid-template-columns:repeat(auto-fill,minmax(11rem,1fr)); gap:0.85rem; margin:0 0 0.5rem; }
		.iw-stat { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-light,#e2e8ec); border-radius:12px; padding:0.85rem 1rem; }
		.iw-stat-v { font-size:1.6rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); line-height:1; }
		.iw-stat-l { font-size:0.72rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.3rem; }
		.iw-pillrow { display:flex; flex-wrap:wrap; gap:0.5rem; align-items:center; margin:0 0 0.4rem; }
		.iw-status { font-size:0.74rem; font-weight:800; letter-spacing:0.02em; border-radius:999px; padding:0.2rem 0.7rem; text-transform:uppercase; }
		.iw-status.is-scheduled { color:#1e5fa8; background:#e4f0fb; } .iw-status.is-progress { color:#8a5a00; background:#fdf0d8; }
		.iw-status.is-complete { color:#1f7a44; background:#e2f5ea; } .iw-status.is-other { color:#45505f; background:#eef1f6; }
		.iw-typepill { font-size:0.74rem; font-weight:700; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#eef1f6); border-radius:999px; padding:0.2rem 0.7rem; }
		.iw-fields { display:grid; grid-template-columns:repeat(auto-fill,minmax(13rem,1fr)); gap:0.9rem 1.4rem; margin:1rem 0; }
		.iw-field-label { font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.iw-field-value { font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); margin-top:0.1rem; }
		.iw-overdue { color:var(--theme-color-status-error,#c0392b); font-weight:700; }
		/* edit-details form */
		.iw-editbar { display:flex; justify-content:flex-end; gap:0.5rem; margin:0 0 0.4rem; }
		.iw-editgrid { display:grid; grid-template-columns:repeat(auto-fill,minmax(14rem,1fr)); gap:0.8rem 1.2rem; background:var(--theme-color-background-secondary,#f4f6f9); border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:10px; padding:0.9rem 1rem; margin:0 0 0.8rem; }
		.iw-editgrid label { display:flex; flex-direction:column; gap:0.2rem; font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.iw-editgrid input, .iw-editgrid select, .iw-editgrid textarea { font-size:0.9rem; padding:0.4rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; background:var(--theme-color-background-input,#fff); font-family:inherit; }
		.iw-editgrid textarea { grid-column:1/-1; min-height:3.2rem; resize:vertical; }
		/* add-row control (asset/doc/user pickers) */
		.iw-addbar { display:flex; align-items:flex-end; gap:0.6rem; flex-wrap:wrap; background:var(--theme-color-background-secondary,#f4f6f9); border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:10px; padding:0.7rem 0.85rem; margin:0 0 1rem; }
		.iw-addbar .iw-f { display:flex; flex-direction:column; gap:0.15rem; }
		.iw-addbar .iw-f-l { font-size:0.64rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.iw-pick { min-width:17rem; }
		/* table */
		.iw-table { width:100%; border-collapse:collapse; font-size:0.88rem; }
		.iw-table th { text-align:left; font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding:0.45rem 0.55rem; white-space:nowrap; }
		.iw-table td { border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); padding:0.5rem 0.55rem; vertical-align:middle; }
		.iw-table tr:hover td { background:var(--theme-color-background-secondary,#f6f8fb); }
		.iw-name { font-weight:600; color:var(--theme-color-text-primary,#1f2733); } .iw-sub { display:block; font-size:0.74rem; color:var(--theme-color-text-muted,#9aa3af); }
		.iw-chip { font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#eef1f6); border-radius:5px; padding:0.08rem 0.45rem; white-space:nowrap; }
		.iw-btn { font-size:0.82rem; font-weight:700; color:#fff; background:var(--theme-color-brand-primary,#2e7d74); border:none; border-radius:7px; padding:0.45rem 0.85rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; white-space:nowrap; } .iw-btn:hover { filter:brightness(1.05); }
		.iw-btn.iw-ghost { color:var(--theme-color-brand-primary,#2e7d74); background:transparent; border:1px solid var(--theme-color-border-medium,#d5dbe3); }
		.iw-act { font-size:0.78rem; font-weight:600; color:var(--theme-color-brand-primary,#2e7d74); background:var(--theme-color-background-secondary,#eef4f3); border:1px solid var(--theme-color-border-light,#dfe7e5); border-radius:6px; padding:0.22rem 0.5rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.3rem; }
		.iw-act:hover { background:var(--theme-color-brand-primary,#2e7d74); color:#fff; } .iw-act-icon { padding:0.22rem 0.45rem; }
		.iw-ord { border:none; background:transparent; color:var(--theme-color-text-muted,#98a2b3); cursor:pointer; font-size:0.85rem; padding:0.1rem 0.3rem; border-radius:5px; } .iw-ord:hover { color:var(--theme-color-brand-primary,#2e7d74); background:var(--theme-color-background-secondary,#eef1f6); } .iw-ord[disabled] { opacity:0.3; cursor:default; }
		.iw-x { border:none; background:transparent; color:var(--theme-color-text-muted,#98a2b3); cursor:pointer; font-size:0.95rem; border-radius:6px; padding:0.2rem 0.45rem; } .iw-x:hover { color:var(--theme-color-status-error,#c0392b); background:var(--theme-color-status-error-bg,#fbeaea); }
		.iw-dossier { cursor:pointer; font-size:1rem; } .iw-dossier.on { color:var(--theme-color-brand-primary,#2e7d74); } .iw-dossier.off { color:var(--theme-color-border-medium,#c8d0da); }
		.iw-link { color:var(--theme-color-brand-primary,#2e7d74); text-decoration:none; font-weight:600; } .iw-link:hover { text-decoration:underline; }
		.iw-empty { padding:1.6rem; text-align:center; color:var(--theme-color-text-muted,#8a94a3); font-size:0.88rem; border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:10px; }
	`,
};

},{"../providers/InspectionWorkspace-Provider.js":1343}],1498:[function(require,module,exports){
'use strict';
module.exports = {
	Identifier: 'LabWorkspace', Ordinal: 246,
	Entity: { Name: 'Lab', IDField: 'IDLab', Collection: 'Labs', GUIDField: 'GUIDLab' },
	Header: { Eyebrow: 'Lab', Title: (r) => r.Name || `Lab ${r.IDLab}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Lab/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'tests', Label: 'Tests', Icon: 'fas fa-flask', Content: { kind: 'assoc', ref: 'LabTest' } },
		{ Key: 'specsets', Label: 'Specification Sets', Icon: 'fas fa-vials', Content: { kind: 'assoc', ref: 'LabTestSpecificationSet' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'assoc', ref: 'LabSample' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'ExternalLabID', Label: 'External Lab ID', Mono: true }, { Key: 'Notes', Label: 'Notes', Wide: true } ] } ],
};

},{}],1499:[function(require,module,exports){
'use strict';

const libLocationWorkspaceProvider = require('../providers/LocationWorkspace-Provider.js');

const isView = (pProv) => pProv.mode === 'view';
const hasQRCode = (pProv) => isView(pProv) && !!pProv.record.QRCode;

module.exports =
{
	Identifier: 'LocationWorkspace',
	Ordinal: 259,
	ProviderClass: libLocationWorkspaceProvider,
	Entity: { Name: 'Location', IDField: 'IDLocation', Collection: 'Locations', GUIDField: 'GUIDLocation' },
	Header:
	{
		Eyebrow: 'Location',
		Title: (pRec) => pRec.Name || `Location ${pRec.IDLocation}`,
		Subtitle: (pRec, pProv) => pProv.headerSubtitle(),
		// The location's QR code in the header corner, as the Sample page shows a sample's.
		Extra: (pProv) => pProv.headerExtra(),
		AfterRender: (pProv) => pProv.headerAfterRender(),
		Actions:
		[
			{ Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()', When: (pProv) => isView(pProv) && pProv.canUpdate() },
			{ Label: 'Print', Icon: 'fas fa-print', Style: 'is-light', OnClick: 'printLabel()', When: hasQRCode },
			{ Label: 'Print options…', Style: 'is-light', OnClick: 'printLabel(true)', When: hasQRCode },
			{ Label: '', Icon: 'fas fa-trash', Style: 'is-danger', OnClick: 'deleteLocation()', When: (pProv) => isView(pProv) && pProv.canDelete() },
		],
		ListRoute: '#/PSRS/Location/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Details', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'render', ref: 'renderSamples' }, OnEnter: (pProv) => pProv.ensureSamplesAsync() },
	],
	FieldGroups:
	[
		{
			Name: 'Location',
			Fields:
			[
				{ Key: 'Name', Label: 'Name', Wide: true },
				{ Key: 'Type', Label: 'Type' },
				{ Key: 'QRCode', Label: 'QR Code', Mono: true },
				{ Key: 'ParentIDLocation', Label: 'Inside', Card: 'Location' },
				{ Key: 'Description', Label: 'Description', Wide: true },
			],
		},
		{
			Name: 'Photo',
			Fields:
			[
				{ Key: 'IDObservation', Label: 'Photo', Wide: true, Value: (pRec, pProv) => pProv.photoHTML() },
			],
		},
		{
			Name: 'Map Location',
			Fields:
			[
				{ Key: 'Latitude', Label: 'Latitude', Mono: true },
				{ Key: 'Longitude', Label: 'Longitude', Mono: true },
				{ Key: 'Map', Label: 'Map', Wide: true, Value: (pRec, pProv) => pProv.mapHTML() },
			],
		},
		{
			Name: 'Address',
			Fields:
			[
				{ Key: 'Address', Label: 'Street', Wide: true },
				{ Key: 'City', Label: 'City' },
				{ Key: 'State', Label: 'State' },
				{ Key: 'Zip', Label: 'Zip' },
				{ Key: 'Phone', Label: 'Phone' },
			],
		},
	],
	CSSExtra: /*css*/`
		.locw-subline { display: flex; flex-wrap: wrap; align-items: center; gap: 0.6rem; margin-top: 0.35rem; font-size: 0.82rem; color: var(--theme-color-text-muted, #8a94a3); }
		.locw-type { font-size: 0.7rem; font-weight: 700; padding: 0.12rem 0.55rem; border-radius: 999px; background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-brand-primary, #5650e6); }
		.locw-crumbs a { color: var(--theme-color-text-secondary, #45505f); }
		.locw-crumbs a:hover { color: var(--theme-color-brand-primary, #5650e6); }
		.locw-sep { opacity: 0.6; }
		.locw-inside { margin-bottom: 0.75rem; font-size: 0.9rem; }
		.locw-count { margin-bottom: 0.6rem; font-size: 0.86rem; color: var(--theme-color-text-muted, #6b7686); }
		.locw-photo-link { display: inline-block; }
		.locw-photo { display: block; max-width: 100%; max-height: 280px; border-radius: 6px; }
		.locw-coords { font-size: 0.86rem; margin-bottom: 0.45rem; font-variant-numeric: tabular-nums; }
		.locw-map { height: 300px; border-radius: 8px; border: 1px solid var(--theme-color-border-light, #e8ebf0); z-index: 0; }
		.locw-qr-thumb { flex: 0 0 auto; width: 80px; height: 80px; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; padding: 3px; background: #fff; margin-left: 0.4rem; }
		.locw-qr-thumb canvas, .locw-qr-thumb img, .locw-qr-thumb svg { width: 100%; height: 100%; display: block; }
		.locw-toolbar { display: flex; gap: 0.5rem; margin-bottom: 0.75rem; }
		.locw-cart-bar { align-items: center; justify-content: space-between; }
		.locw-cart { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
		.locw-cart .hl-scan {
			--hl-scan-background: var(--theme-color-background-panel, var(--theme-color-background-primary, #fff));
			--hl-scan-text: var(--theme-color-text-secondary, #45505f);
			--hl-scan-text-strong: var(--theme-color-text-primary, #1f2733);
			--hl-scan-text-weak: var(--theme-color-text-muted, #8a94a3);
			--hl-scan-border: var(--theme-color-border-light, #e8ebf0);
			--hl-scan-border-weak: var(--theme-color-border-light, #eef1f5);
			--hl-scan-head-background: var(--theme-color-background-tertiary, #f4f6f9);
			--hl-scan-input-background: var(--theme-color-background-primary, #fff);
			--hl-scan-input-text: var(--theme-color-text-primary, #1f2733);
			--hl-scan-input-border: var(--theme-color-border-default, #d7dce3);
		}
		.locw-error { font-size: 0.88rem; color: var(--theme-color-status-error, #b3382f); background: var(--theme-color-status-error-bg, #fbeaea); border-radius: 6px; padding: 0.5rem 0.7rem; }
	`,
};

},{"../providers/LocationWorkspace-Provider.js":1347}],1500:[function(require,module,exports){
'use strict';

// Lot workspace — a production/validation lot tied to a MixDesign + Contract, holding the line items sampled from
// it (LineItemLot association). Overview + a Line Items association tab + a "Sub Lots" tab that NESTS each sub lot's
// per-customer metadata (SubLotMetadata) in the shared guided-metadata editor. See source/providers/LotWorkspace-Provider.js.
const libLotWorkspaceProvider = require('../providers/LotWorkspace-Provider.js');

module.exports = {
	Identifier: 'LotWorkspace', Ordinal: 257,
	ProviderClass: libLotWorkspaceProvider,
	Entity: { Name: 'Lot', IDField: 'IDLot', Collection: 'Lots', GUIDField: 'GUIDLot' },
	Header: { Eyebrow: 'Lot', Title: (r) => r.Name || `Lot ${r.IDLot}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Lot/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'sublots', Label: 'Sub Lots', Icon: 'fas fa-boxes-stacked', Content: { kind: 'render', ref: '_subLotsHTML' }, OnEnter: (prov) => prov._ensureSubLotsAsync() },
		{ Key: 'lineitems', Label: 'Line Items', Icon: 'fas fa-list-ul', Content: { kind: 'assoc', ref: 'LineItemLot' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'StartDate', Label: 'Start Date', Format: 'date' }, { Key: 'ValidationSequence', Label: 'Validation Sequence', Format: 'number' } ] },
		{ Name: 'Relationships', Fields: [ { Key: 'IDMixDesign', Label: 'Mix Design', Card: 'MixDesign' }, { Key: 'IDContract', Label: 'Contract', Card: 'Contract' } ] },
	],
	CSSExtra: /*css*/`
		.lw-help { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.9rem; line-height:1.5; }
		.lw-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.7rem 0.1rem; }
		.lw-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.lw-sublots { display:flex; flex-direction:column; gap:0.5rem; }
		.lw-sublot { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; overflow:hidden; background:var(--theme-color-background,#fff); }
		.lw-sublot.is-open { border-color:var(--theme-color-border,#d5dbe3); }
		.lw-sublot-head { display:flex; align-items:center; justify-content:space-between; gap:0.8rem; width:100%; text-align:left; cursor:pointer; padding:0.6rem 0.85rem; border:0; background:transparent; color:var(--theme-color-text-primary,#1f2733); }
		.lw-sublot-head:hover { background:var(--theme-color-background-secondary,#f5f7fa); }
		.lw-sublot-name { font-size:0.95rem; font-weight:600; display:inline-flex; align-items:center; gap:0.55rem; min-width:0; }
		.lw-sublot-name .fas { color:var(--theme-color-text-muted,#8a94a3); font-size:0.78em; width:0.8em; }
		.lw-sublot-summary { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); font-variant-numeric:tabular-nums; text-align:right; }
		.lw-sublot-body { padding:0.4rem 0.95rem 0.95rem; border-top:1px solid var(--theme-color-border-light,#eef1f6); }
		.lw-sublot-body[hidden] { display:none; }
	`,
};

},{"../providers/LotWorkspace-Provider.js":1349}],1501:[function(require,module,exports){
'use strict';

// Material workspace — the materials catalog hub. Config-only. The Suppliers tab reuses the bespoke
// MaterialOrganization association editor (inline expiry date); Pay Items is the Material↔PayItem cross-entity tool.

const libMaterialOrgEditor = require('../views/MaterialOrganizationAssociationEditor.js');

module.exports = {
	Identifier: 'MaterialWorkspace',
	Ordinal: 241,
	Entity: { Name: 'Material', IDField: 'IDMaterial', Collection: 'Materials', GUIDField: 'GUIDMaterial' },
	Header:
	{
		Eyebrow: 'Material',
		Title: (pRec) => pRec.Name || `Material ${pRec.IDMaterial}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ],
		ListRoute: '#/PSRS/Material/List',
	},
	EditorLibs: { MaterialOrganizationEditor: libMaterialOrgEditor },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'payitems', Label: 'Pay Items', Icon: 'fas fa-dollar-sign', Content: { kind: 'assoc', ref: 'MaterialPayItem' } },
		{ Key: 'testspecs', Label: 'Test Specifications', Icon: 'fas fa-vial', Content: { kind: 'assoc', ref: 'MaterialTestSpecification' } },
		{ Key: 'mixspecs', Label: 'Mix Specifications', Icon: 'fas fa-file-lines', Content: { kind: 'assoc', ref: 'MaterialMixSpecification' } },
		{ Key: 'suppliers', Label: 'Suppliers', Icon: 'fas fa-truck', Content: { kind: 'assoc', ref: 'MaterialOrganization', editorLib: 'MaterialOrganizationEditor' } },
		{ Key: 'lineitems', Label: 'Line Items', Icon: 'fas fa-list-ul', Content: { kind: 'assoc', ref: 'LineItemMaterial' } },
		{ Key: 'mixdesigns', Label: 'Mix Designs', Icon: 'fas fa-flask-vial', Content: { kind: 'childlist', ref: 'MixDesign', parentField: 'IDMaterial',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'MaterialCode', Label: 'Material Code' }, { Key: 'Description', Label: 'Description' } ], empty: 'No mix designs use this material.' } },
		{ Key: 'products', Label: 'Products', Icon: 'fas fa-box', Content: { kind: 'childlist', ref: 'Product', parentField: 'IDMaterial',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'ManufacturerCode', Label: 'Mfr Code' }, { Key: 'CatalogCode', Label: 'Catalog Code' } ], empty: 'No products of this material.' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'childlist', ref: 'Sample', parentField: 'IDMaterial',
			columns: [ { Key: 'LabControlNumber', Label: 'PSID' }, { Key: 'Name', Label: 'Description' }, { Key: 'ReceivedFrom', Label: 'Source' } ], empty: 'No samples of this material.', cap: 200 } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [
			{ Key: 'Name', Label: 'Name', Wide: true },
			{ Key: 'NameAbbreviated', Label: 'Abbreviation' },
			{ Key: 'Type', Label: 'Type' },
			{ Key: 'MaterialCode', Label: 'Material Code', Mono: true },
			{ Key: 'CatalogCode', Label: 'Catalog Code', Mono: true },
			{ Key: 'Description', Label: 'Description', Wide: true },
		] },
	],
};

},{"../views/MaterialOrganizationAssociationEditor.js":1449}],1502:[function(require,module,exports){
'use strict';

// Mix Design workspace. The reusable EntityMetadataWorkspace provider renders the record's MixMetadata blob as the
// guided per-customer metadata form (read-only + inline Edit/Save) underneath the Overview field groups —
// MetadataBlob names the column + section heading. See source/providers/EntityMetadataWorkspace-Provider.js.
const libEntityMetadataWorkspaceProvider = require('../providers/EntityMetadataWorkspace-Provider.js');

module.exports = {
	Identifier: 'MixDesignWorkspace', Ordinal: 244,
	ProviderClass: libEntityMetadataWorkspaceProvider,
	MetadataBlob: { column: 'MixMetadata', label: 'Mix Metadata' },
	Entity: { Name: 'MixDesign', IDField: 'IDMixDesign', Collection: 'MixDesigns', GUIDField: 'GUIDMixDesign' },
	Header: { Eyebrow: 'Mix Design', Title: (r) => r.Name || `Mix Design ${r.IDMixDesign}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/MixDesign/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'lots', Label: 'Lots', Icon: 'fas fa-boxes-stacked', Content: { kind: 'childlist', ref: 'Lot', parentField: 'IDMixDesign',
			columns: [ { Key: 'Name', Label: 'Name' } ], empty: 'No lots use this mix design.' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'childlist', ref: 'Sample', parentField: 'IDMixDesign',
			columns: [ { Key: 'LabControlNumber', Label: 'PSID' }, { Key: 'Name', Label: 'Description' } ], empty: 'No samples of this mix design.', cap: 200 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'MaterialCode', Label: 'Material Code', Mono: true }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};

},{"../providers/EntityMetadataWorkspace-Provider.js":1339}],1503:[function(require,module,exports){
'use strict';

// Mix Type workspace. The reusable EntityMetadataWorkspace provider renders the record's MetaData blob as the guided
// per-customer metadata form (read-only + inline Edit/Save) underneath the Overview field groups. Reachable as a
// Master List (Materials & Mixes). See source/providers/EntityMetadataWorkspace-Provider.js.
const libEntityMetadataWorkspaceProvider = require('../providers/EntityMetadataWorkspace-Provider.js');

module.exports = {
	Identifier: 'MixTypeWorkspace', Ordinal: 246,
	ProviderClass: libEntityMetadataWorkspaceProvider,
	// Meadow exposes the DB column MetaDataJSON as the field `MetaData`.
	MetadataBlob: { column: 'MetaData', label: 'Mix Type Metadata' },
	Entity: { Name: 'MixType', IDField: 'IDMixType', Collection: 'MixTypes', GUIDField: 'GUIDMixType' },
	Header: { Eyebrow: 'Mix Type', Title: (r) => r.Name || `Mix Type ${r.IDMixType}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/MixType/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields:
			[
				{ Key: 'Name', Label: 'Name', Wide: true },
				{ Key: 'Code', Label: 'Code', Mono: true },
				{ Key: 'Description', Label: 'Description', Wide: true },
				{ Key: 'ApprovingAgency', Label: 'Approving Agency' },
				{ Key: 'Active', Label: 'Active', Format: 'bool' },
			] },
	],
};

},{"../providers/EntityMetadataWorkspace-Provider.js":1339}],1504:[function(require,module,exports){
'use strict';

// Observation workspace — the field-captured observation record page (read-only first). Refactored onto
// pict-section-workspace with a bespoke ProviderClass. Reached via /Observation/Workspace/:ID[/:Tab] and the bespoke
// bridge over /PSRS/Observation/View/:GUIDRecord. Four bespoke `render` tabs present the four requested surfaces:
// Data (visualization) · Location (Capture + User on a map) · History (ObservationArchive versions) · Artifacts
// (per-artifact raw media versions). Roll-back / roll-forward / merge come later. See [[ObservationWorkspace-Provider.js]].

const libObservationWorkspaceProvider = require('../providers/ObservationWorkspace-Provider.js');

module.exports = {
	Identifier: 'ObservationWorkspace',
	Ordinal: 249,
	ProviderClass: libObservationWorkspaceProvider,
	Entity: { Name: 'Observation', IDField: 'IDObservation', Collection: 'Observations', GUIDField: 'GUIDObservation' },
	RoutePrefix: 'Observation',
	Header: {
		Eyebrow: 'Observation',
		Title: (r) => r.Name || r.ObservationType || `Observation ${r.IDObservation}`,
		Subtitle: (r) => [ r.ObservationType || '', r.Status || '' ].filter(Boolean).join(' · '),
		ListRoute: '#/PSRS/Observation/List',
	},
	Tabs: [
		{ Key: 'data', Label: 'Data', Icon: 'fas fa-image', Content: { kind: 'render', ref: '_dataHTML' } },
		{ Key: 'location', Label: 'Location', Icon: 'fas fa-location-dot', Content: { kind: 'render', ref: '_locationHTML' }, OnEnter: (pProv) => pProv._mountMap() },
		{ Key: 'history', Label: 'History', Icon: 'fas fa-clock-rotate-left', Content: { kind: 'render', ref: '_historyHTML' }, OnEnter: (pProv) => pProv._ensureTabDataAsync('history') },
		{ Key: 'artifacts', Label: 'Artifact Versions', Icon: 'fas fa-layer-group', Content: { kind: 'render', ref: '_artifactsHTML' } },
	],
	CSSExtra: /*css*/`
		.ow-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.6rem 0; }
		.ow-hint { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); margin:0 0 0.7rem; }
		.ow-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.ow-muted { color:var(--theme-color-text-muted,#aab3c0); }
		.ow-mono { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.82rem; }
		.ow-section-h { font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:1.3rem 0 0.6rem; }
		/* Data tab */
		.ow-hero { margin:0 0 1rem; }
		.ow-hero-img { max-width:100%; max-height:26rem; border-radius:10px; border:1px solid var(--theme-color-border-light,#e8ebf0); background:var(--theme-color-background-secondary,#eef1f6); display:block; }
		.ow-hero-img.ow-broken { display:none; }
		.ow-fields { display:grid; grid-template-columns:repeat(auto-fill,minmax(13rem,1fr)); gap:0.9rem 1.4rem; }
		.ow-field-label { font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.ow-field-value { font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); margin-top:0.1rem; }
		.ow-desc { margin-top:1.1rem; } .ow-desc-body { font-size:0.92rem; white-space:pre-wrap; margin-top:0.2rem; }
		.ow-cards { display:grid; grid-template-columns:repeat(auto-fill,minmax(16rem,1fr)); gap:0.8rem; }
		.ow-card { border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:9px; overflow:hidden; }
		.ow-card-h { display:flex; align-items:center; justify-content:space-between; gap:0.5rem; font-weight:700; font-size:0.86rem; padding:0.5rem 0.7rem; background:var(--theme-color-background-secondary,#f4f6f9); }
		.ow-card-b { padding:0.6rem 0.7rem; font-size:0.86rem; }
		.ow-badge { font-size:0.66rem; font-weight:700; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-light,#e0e5ec); border-radius:5px; padding:0.05rem 0.4rem; }
		.ow-badge-cur { color:#1b6e3a; background:#e4f5ea; border-color:#bfe6cd; }
		.ow-kv { display:flex; justify-content:space-between; gap:0.8rem; padding:0.18rem 0; border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); }
		.ow-kvlist .ow-kv:last-child { border-bottom:none; } .ow-k { color:var(--theme-color-text-muted,#6b7686); flex:0 0 auto; } .ow-v { font-weight:600; text-align:right; word-break:break-word; }
		/* Adaptive datum renderer — text blocks, nested sub-groups, wide cards */
		.ow-card-wide { grid-column: 1 / -1; }
		.ow-textblock { margin:0 0 0.5rem; }
		.ow-textblock .ow-k { display:block; margin-bottom:0.15rem; }
		.ow-textbody { white-space:pre-wrap; font-size:0.88rem; line-height:1.5; color:var(--theme-color-text-primary,#1f2733); }
		.ow-sub { margin-top:0.45rem; padding-left:0.6rem; border-left:2px solid var(--theme-color-border-light,#e8ebf0); }
		.ow-sub-h { font-size:0.64rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em; color:var(--theme-color-text-secondary,#45505f); margin-bottom:0.2rem; }
		.ow-sub-b { display:flex; flex-wrap:wrap; gap:0.3rem; }
		.ow-subitem { flex-basis:100%; }
		.ow-file { color:var(--theme-color-brand-primary,#2e7d74); text-decoration:none; font-weight:600; }
		.ow-labels { display:flex; flex-direction:column; gap:0.4rem; }
		.ow-label { display:flex; align-items:center; gap:0.4rem; flex-wrap:wrap; }
		.ow-label-t { font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); min-width:8rem; }
		.ow-chip { font-size:0.78rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-secondary,#eef1f6); border-radius:999px; padding:0.1rem 0.6rem; }
		/* Location tab */
		.ow-loc-legend { font-size:0.82rem; margin:0 0 0.6rem; }
		.ow-dot { display:inline-block; width:0.8rem; height:0.8rem; border-radius:50%; border:2px solid #fff; vertical-align:-1px; box-shadow:0 0 0 1px rgba(0,0,0,0.1); }
		.ow-dot-cap { background:#c0392b; } .ow-dot-usr { background:#2e7d74; }
		.ow-map { height:24rem; width:100%; border-radius:8px; border:1px solid var(--theme-color-border-default,#d7dce3); background:var(--theme-color-background-secondary,#eef1f6); }
		.ow-loc-readout { margin-top:0.7rem; display:grid; grid-template-columns:repeat(auto-fill,minmax(16rem,1fr)); gap:0.4rem 1.4rem; }
		.ow-loc-row { display:flex; gap:0.6rem; font-size:0.9rem; } .ow-loc-k { font-weight:700; min-width:5rem; color:var(--theme-color-text-secondary,#45505f); } .ow-loc-v { font-variant-numeric:tabular-nums; }
		/* History tab */
		.ow-table { width:100%; border-collapse:collapse; font-size:0.88rem; }
		.ow-table th { text-align:left; font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding:0.4rem 0.5rem; }
		.ow-table td { border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); padding:0.45rem 0.5rem; vertical-align:middle; }
		.ow-num { font-variant-numeric:tabular-nums; white-space:nowrap; }
		.ow-vthumb { height:3rem; width:auto; max-width:5rem; border-radius:5px; border:1px solid var(--theme-color-border-light,#e8ebf0); object-fit:cover; }
		.ow-vthumb.ow-broken { display:none; }
		/* Artifacts tab */
		.ow-art { margin:0 0 1.2rem; }
		.ow-art-h { display:flex; align-items:center; gap:0.5rem; font-weight:700; font-size:0.9rem; margin:0 0 0.5rem; }
		.ow-vtiles { display:flex; gap:0.7rem; flex-wrap:wrap; }
		.ow-vtile { width:9rem; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; overflow:hidden; background:var(--theme-color-background-secondary,#f4f6f9); }
		.ow-vtile-cur { border-color:var(--theme-color-brand-primary,#2e7d74); box-shadow:0 0 0 1px var(--theme-color-brand-primary,#2e7d74); }
		.ow-vtile-img { width:100%; height:7rem; object-fit:cover; display:block; }
		.ow-vtile.ow-broken .ow-vtile-img { display:none; }
		.ow-vtile.ow-broken::before { content:'unavailable'; display:flex; align-items:center; justify-content:center; height:7rem; font-size:0.72rem; color:var(--theme-color-text-muted,#aab3c0); }
		.ow-vtile-file { display:flex; align-items:center; justify-content:center; height:7rem; font-size:1.6rem; color:var(--theme-color-text-muted,#8894a4); text-decoration:none; }
		.ow-vtile-cap { font-size:0.72rem; text-align:center; padding:0.3rem; color:var(--theme-color-text-secondary,#45505f); }
	`,
};

},{"../providers/ObservationWorkspace-Provider.js":1354}],1505:[function(require,module,exports){
'use strict';

// Organization workspace — the richest relationship graph of the new set. Config-only (no bespoke renderers):
// Overview field groups + M:N association tabs + FK child-list tabs, all resolved by the pict-section-workspace base.

module.exports = {
	Identifier: 'OrganizationWorkspace',
	Ordinal: 240,
	Entity: { Name: 'Organization', IDField: 'IDOrganization', Collection: 'Organizations', GUIDField: 'GUIDOrganization' },
	Header:
	{
		Eyebrow: 'Organization',
		Title: (pRec) => pRec.Name || `Organization ${pRec.IDOrganization}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ],
		ListRoute: '#/PSRS/Organization/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'contacts', Label: 'Contacts', Icon: 'fas fa-address-card', Content: { kind: 'assoc', ref: 'ContactOrganization' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'OrganizationProject' } },
		{ Key: 'equipment', Label: 'Equipment', Icon: 'fas fa-screwdriver-wrench', Content: { kind: 'assoc', ref: 'EquipmentOrganization' } },
		{ Key: 'materials', Label: 'Materials', Icon: 'fas fa-cube', Content: { kind: 'assoc', ref: 'MaterialOrganization' } },
		{ Key: 'products', Label: 'Products', Icon: 'fas fa-box', Content: { kind: 'childlist', ref: 'Product', parentField: 'IDOrganization',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'ManufacturerCode', Label: 'Mfr Code' }, { Key: 'CatalogCode', Label: 'Catalog Code' } ], empty: 'No products from this organization.' } },
		{ Key: 'plants', Label: 'Production Plants', Icon: 'fas fa-industry', Content: { kind: 'childlist', ref: 'ProductionPlant', parentField: 'IDOrganization',
			columns: [ { Key: 'Name', Label: 'Name' } ], empty: 'No production plants for this organization.' } },
		{ Key: 'mixdesigns', Label: 'Mix Designs', Icon: 'fas fa-flask-vial', Content: { kind: 'childlist', ref: 'MixDesign', parentField: 'IDOrganization',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'MaterialCode', Label: 'Material Code' } ], empty: 'No mix designs.' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'VendorCode', Label: 'Vendor Code', Mono: true }, { Key: 'Type', Label: 'Type' } ] },
		{ Name: 'Contact', Fields: [ { Key: 'Address', Label: 'Address', Wide: true }, { Key: 'City', Label: 'City' }, { Key: 'State', Label: 'State' }, { Key: 'Zip', Label: 'Zip' }, { Key: 'Phone', Label: 'Phone' }, { Key: 'Email', Label: 'Email' } ] },
		{ Name: 'Status', Fields: [ { Key: 'Approved', Label: 'Approved', Format: 'bool' }, { Key: 'DisadvantagedBusiness', Label: 'Disadvantaged Business', Format: 'bool' }, { Key: 'FederalTaxCode', Label: 'Federal Tax Code', Mono: true }, { Key: 'ExternalOrganizationID', Label: 'External ID', Mono: true } ] },
	],
};

},{}],1506:[function(require,module,exports){
'use strict';
// Pay Item workspace. Materials is the reciprocal of the Material↔PayItem cross-entity tool.
module.exports = {
	Identifier: 'PayItemWorkspace', Ordinal: 242,
	Entity: { Name: 'PayItem', IDField: 'IDPayItem', Collection: 'PayItems', GUIDField: 'GUIDPayItem' },
	Header: { Eyebrow: 'Pay Item', Title: (r) => r.Name || `Pay Item ${r.IDPayItem}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/PayItem/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'materials', Label: 'Materials', Icon: 'fas fa-cube', Content: { kind: 'assoc', ref: 'MaterialPayItem' } },
		{ Key: 'specsets', Label: 'Specification Sets', Icon: 'fas fa-vials', Content: { kind: 'assoc', ref: 'PayItemTestSpecificationSet' } },
		{ Key: 'biditems', Label: 'Bid Items', Icon: 'fas fa-list-check', Content: { kind: 'childlist', ref: 'BidItem', parentField: 'IDPayItem',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'Description', Label: 'Description' } ], empty: 'No bid items reference this pay item.' } },
		{ Key: 'lineitems', Label: 'Line Items', Icon: 'fas fa-list-ul', Content: { kind: 'childlist', ref: 'LineItem', parentField: 'IDPayItem',
			columns: [ { Key: 'ItemNumber', Label: 'Item #' }, { Key: 'Name', Label: 'Name' }, { Key: 'Description', Label: 'Description' } ], empty: 'No line items reference this pay item.', cap: 300 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'ItemCode', Label: 'Item Code', Mono: true }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};

},{}],1507:[function(require,module,exports){
'use strict';

// Product workspace. The reusable EntityMetadataWorkspace provider renders the record's MetadataJSON blob as the
// guided per-customer metadata form (read-only + inline Edit/Save) underneath the Overview field groups.
const libEntityMetadataWorkspaceProvider = require('../providers/EntityMetadataWorkspace-Provider.js');

module.exports = {
	Identifier: 'ProductWorkspace', Ordinal: 245,
	ProviderClass: libEntityMetadataWorkspaceProvider,
	// Meadow exposes the DB column MetadataJSON as the field `Metadata`, returned as an already-parsed object.
	MetadataBlob: { column: 'Metadata', label: 'Product Metadata', encoding: 'object' },
	Entity: { Name: 'Product', IDField: 'IDProduct', Collection: 'Products', GUIDField: 'GUIDProduct' },
	Header: { Eyebrow: 'Product', Title: (r) => r.Name || `Product ${r.IDProduct}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Product/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'childlist', ref: 'Sample', parentField: 'IDProduct',
			columns: [ { Key: 'LabControlNumber', Label: 'PSID' }, { Key: 'Name', Label: 'Description' } ], empty: 'No samples of this product.', cap: 200 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'ManufacturerCode', Label: 'Mfr Code', Mono: true }, { Key: 'CatalogCode', Label: 'Catalog Code', Mono: true } ] } ],
};

},{"../providers/EntityMetadataWorkspace-Provider.js":1339}],1508:[function(require,module,exports){
'use strict';

// ProductionPlant workspace — a producer's plant, owned by an Organization. Overview-only for now (plant approval
// join tables — ProductionPlantMaterialApproval / PlantMixApproval — are candidate childlists once their display
// columns are settled).
module.exports = {
	Identifier: 'ProductionPlantWorkspace', Ordinal: 254,
	Entity: { Name: 'ProductionPlant', IDField: 'IDProductionPlant', Collection: 'ProductionPlants', GUIDField: 'GUIDProductionPlant' },
	Header: { Eyebrow: 'Production Plant', Title: (r) => r.Name || `Production Plant ${r.IDProductionPlant}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/ProductionPlant/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'IDOrganization', Label: 'Organization', Card: 'Organization' }, { Key: 'ExternalProductionPlantID', Label: 'External ID', Mono: true }, { Key: 'Notes', Label: 'Notes', Wide: true } ] } ],
};

},{}],1509:[function(require,module,exports){
'use strict';

// Project workspace — the richest record page in the platform, refactored onto pict-section-workspace. The base
// owns the shell (header, grouped tab bar, routing, load); the ProjectWorkspaceProvider subclass keeps ALL of the
// original behavior + controllers and paints each tab by parseTemplateByHash-ing its original template (registered
// here as ExtraTemplates) into the base body, then mounting that tab's map / association editor / embeds from a
// single OnEnter (_mountTab). See [[ProjectWorkspace-Provider.js]] and [[ProjectWorkspace-Chrome.js]].

const libProjectWorkspaceProvider = require('../providers/ProjectWorkspace-Provider.js');
const { PROJECT_WORKSPACE_CSS, PROJECT_WORKSPACE_TEMPLATES } = require('../views/ProjectWorkspace-Chrome.js');

// Every leaf renders via the base `render` kind (paint its template) with the same OnEnter (mount its widgets).
const LEAF = (pKey, pLabel, pIcon) => ({ Key: pKey, Label: pLabel, Icon: pIcon, Content: { kind: 'render', ref: '_renderTabBody' }, OnEnter: (pProv) => pProv._mountTab() });

module.exports = {
	Identifier: 'ProjectWorkspace',
	Ordinal: 220,
	ProviderClass: libProjectWorkspaceProvider,
	Entity: { Name: 'Project', IDField: 'IDProject', Collection: 'Projects', GUIDField: 'GUIDProject' },
	Header:
	{
		Eyebrow: 'Project',
		Title: (pRec) => pRec.Name || `Project ${pRec.IDProject}`,
		Actions: [
			// Only people the server lets save the Project see Edit (admin, role 4 in the customer, or the creator).
			{ Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'editProject()', When: (prov) => prov.canEditProject },
			// Publishes this project's observation-type config out to the field apps (scoped sync). Headlight super-users only.
			{ Label: 'Run Config Sync', Icon: 'fas fa-cloud-arrow-up', Style: 'is-light', OnClick: 'syncConfiguration()', When: (prov) => prov.isSuperUser },
		],
		ListRoute: '#/PSRS/Project/List',
	},
	Tabs:
	[
		Object.assign(LEAF('overview', 'Overview', 'fas fa-circle-info'), { Pin: 'left' }),
		Object.assign(LEAF('location', 'Location', 'fas fa-location-dot'), { Pin: 'left' }),
		{ Key: 'contract', Label: 'Contract', Icon: 'fas fa-file-contract', Children:
			[
				LEAF('funding', 'Funding', 'fas fa-scale-balanced'),
				LEAF('changeorders', 'Change Orders', 'fas fa-file-pen'),
				LEAF('dates', 'Important Dates', 'fas fa-calendar-day'),
				LEAF('lineitems', 'Line Items', 'fas fa-list-ul'),
				LEAF('biditems', 'Bid Items', 'fas fa-gavel'),
				LEAF('bidmap', 'Bid Item Mapping', 'fas fa-right-left'),
				LEAF('organization', 'Contractors', 'fas fa-building'),
				LEAF('linecontractors', 'Line Item Contractors', 'fas fa-handshake'),
				LEAF('bidcontractors', 'Bid Item Contractors', 'fas fa-file-signature'),
			] },
		{ Key: 'materials', Label: 'Materials', Icon: 'fas fa-vials', Children:
			[
				LEAF('sampleplan', 'Sample Plan', 'fas fa-clipboard-check'),
				LEAF('sampleplandashboard', 'Sample Plan Dashboard', 'fas fa-table-list'),
			] },
		{ Key: 'connections', Label: 'Connections', Icon: 'fas fa-diagram-project', Children:
			[
				LEAF('equipment', 'Equipment', 'fas fa-truck'),
				LEAF('lab', 'Labs', 'fas fa-flask'),
				LEAF('contact', 'Personnel', 'fas fa-id-badge'),
				LEAF('staffing', 'Staffing', 'fas fa-users'),
			] },
		{ Key: 'config', Label: 'Config', Icon: 'fas fa-sliders', Children:
			[
				LEAF('branding', 'Branding', 'fas fa-image'),
				LEAF('labels', 'Labels', 'fas fa-tags'),
				LEAF('observations', 'Observation Types', 'fas fa-clipboard-check'),
			] },
		{ Key: 'data', Label: 'Data', Icon: 'fas fa-database', Pin: 'right', Children:
			[
				LEAF('data-observations', 'Observations', 'fas fa-clipboard-list'),
				LEAF('data-forms', 'Documents', 'fas fa-file-lines'),
				LEAF('data-files', 'Important Files', 'fas fa-folder-tree'),
				LEAF('data-bulk-upload', 'Bulk Upload', 'fas fa-cloud-arrow-up'),
				LEAF('data-volume', 'Data Volume', 'fas fa-chart-column'),
			] },
	],
	ExtraTemplates: PROJECT_WORKSPACE_TEMPLATES,
	CSSExtra: PROJECT_WORKSPACE_CSS,
};

},{"../providers/ProjectWorkspace-Provider.js":1367,"../views/ProjectWorkspace-Chrome.js":1466}],1510:[function(require,module,exports){
'use strict';

// ProjectOffice workspace — an office/location that owns users (User.IDProjectOffice). Overview + a Users childlist.
// (Project has no IDProjectOffice, so there is no Projects childlist.)
module.exports = {
	Identifier: 'ProjectOfficeWorkspace', Ordinal: 256,
	Entity: { Name: 'ProjectOffice', IDField: 'IDProjectOffice', Collection: 'ProjectOffices', GUIDField: 'GUIDProjectOffice' },
	Header: { Eyebrow: 'Project Office', Title: (r) => r.Name || `Project Office ${r.IDProjectOffice}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/ProjectOffice/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'users', Label: 'Users', Icon: 'fas fa-users', Content: { kind: 'childlist', ref: 'User', parentField: 'IDProjectOffice',
			columns: [ { Key: 'NameFirst', Label: 'First' }, { Key: 'NameLast', Label: 'Last' }, { Key: 'Email', Label: 'Email' } ], empty: 'No users in this office.' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'OfficeCode', Label: 'Office Code', Mono: true } ] },
		{ Name: 'Location', Fields: [ { Key: 'Address', Label: 'Address', Wide: true }, { Key: 'City', Label: 'City' }, { Key: 'State', Label: 'State' }, { Key: 'Zip', Label: 'Zip' }, { Key: 'Phone', Label: 'Phone' } ] },
	],
};

},{}],1511:[function(require,module,exports){
'use strict';

// Sample workspace — the LIMS per-sample CRUD workspace, refactored onto pict-section-workspace (whose base now
// supports view/edit/CREATE modes + an EditContent form body + header extras). The base owns the shell; the
// SampleWorkspaceProvider subclass keeps the config-driven manifest form, all mutations, and the per-tab tables.
// In view mode: header (Edit/Clone/Print/Delete) + tabs (Details=the form + location / line items / tests / documents
// / cores / logs). In edit/create mode: no tabs — the form IS the body — with Save/Cancel. See [[SampleWorkspace-Provider.js]].

const libSampleWorkspaceProvider = require('../samples/SampleWorkspace-Provider.js');

const isView = (pProv) => pProv.mode === 'view';

module.exports = {
	Identifier: 'SampleWorkspace',
	Ordinal: 230,
	ProviderClass: libSampleWorkspaceProvider,
	Entity: { Name: 'Sample', IDField: 'IDSample', Collection: 'Samples', GUIDField: 'GUIDSample' },
	Header:
	{
		Eyebrow: 'Sample',
		Title: (pRec, pProv) => pProv.headerTitle(),
		Subtitle: (pRec, pProv) => pProv.headerSubtitle(),
		Extra: (pProv) => pProv.headerExtra(),
		AfterRender: (pProv) => pProv.headerAfterRender(),
		Actions:
		[
			{ Label: 'Create Sample', Icon: 'fas fa-save', Style: 'is-link', OnClick: 'saveForm()', When: (pProv) => pProv.mode === 'create' },
			{ Label: 'Save Changes', Icon: 'fas fa-save', Style: 'is-link', OnClick: 'saveForm()', When: (pProv) => pProv.mode === 'edit' },
			{ Label: 'Cancel', Icon: 'fas fa-xmark', Style: 'is-light', OnClick: 'cancelForm()', When: (pProv) => pProv.isEditing },
			{ Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()', When: (pProv) => isView(pProv) && pProv.canEditForm() },
			{ Label: 'Clone', Icon: 'fas fa-clone', Style: 'is-light', OnClick: 'goToClone()', When: (pProv) => isView(pProv) && pProv.canCreate() },
			{ Label: 'Print', Icon: 'fas fa-print', Style: 'is-light', OnClick: 'printLabel()', When: (pProv) => isView(pProv) && !!(pProv.state.Sample && pProv.state.Sample.QRCode) },
			{ Label: 'Print options…', Style: 'is-light', OnClick: 'printLabel(true)', When: (pProv) => isView(pProv) && !!(pProv.state.Sample && pProv.state.Sample.QRCode) },
			{ Label: '', Icon: 'fas fa-trash', Style: 'is-danger', OnClick: 'deleteSample()', When: (pProv) => isView(pProv) && pProv.canDelete() && !pProv.isLockedForUser() },
		],
		ListRoute: '#/PSRS/Sample/List',
	},
	Tabs:
	[
		{ Key: 'details', Label: 'Details', Icon: 'fas fa-circle-info', Content: { kind: 'render', ref: 'renderForm' } },
		// Where the sample is kept; Change location opens the Scan Samples cart with this sample in it.
		{ Key: 'location', Label: 'Location', Icon: 'fas fa-location-dot', Content: { kind: 'render', ref: 'renderLocation' }, OnEnter: (pProv) => pProv.ensureLocationLoaded() },
		{ Key: 'lineitems', Label: 'Line Items', Icon: 'fas fa-list-tree', Content: { kind: 'render', ref: 'renderLineItems' }, OnEnter: (pProv) => pProv._ensureTabDataLoaded('lineitems').then(() => pProv.repaintBody()) },
		{ Key: 'testinstances', Label: 'Tests', Icon: 'fas fa-flask-vial', Content: { kind: 'render', ref: 'renderTestInstances' }, OnEnter: (pProv) => pProv._ensureTabDataLoaded('testinstances').then(() => pProv.repaintBody()) },
		{ Key: 'documents', Label: 'Documents', Icon: 'fas fa-files', Content: { kind: 'render', ref: 'renderDocuments' }, OnEnter: (pProv) => pProv._ensureTabDataLoaded('documents').then(() => pProv.repaintBody()) },
		{ Key: 'cores', Label: 'Cores', Icon: 'fas fa-circle-dot', Content: { kind: 'render', ref: 'renderCores' }, OnEnter: (pProv) => pProv._ensureTabDataLoaded('cores').then(() => pProv.repaintBody()) },
		{ Key: 'logs', Label: 'Logs', Icon: 'fas fa-list-timeline', Content: { kind: 'render', ref: 'renderLogs' } },
		// The label drawn upright, as legacy LIMS's Print tab showed it (the printer gets it sideways).
		{ Key: 'print', Label: 'Print', Icon: 'fas fa-qrcode', Content: { kind: 'render', ref: 'renderPrint' } },
	],
	// Edit/Create body: the config-driven manifest form (renderForm reads the current mode).
	EditContent: { kind: 'render', ref: 'renderForm' },
	Edit: { Route: 'workspace' },
	Create: { Route: '/PSRS/Sample/Create', CloneRoute: '/PSRS/Sample/Create/ClonedFrom/:GUIDRecord' },
	CSSExtra: /*css*/`
		.sw-subline { display: flex; align-items: center; gap: 0.5rem; margin-top: 0.35rem; font-size: 0.82rem; color: var(--theme-color-text-muted, #8a94a3); }
		.sw-lock { font-size: 0.75em; color: var(--theme-color-text-muted, #8a94a3); }
		.sw-psid { font-weight: 600; font-variant-numeric: tabular-nums; color: var(--theme-color-text-secondary, #45505f); }
		.sw-qr { color: var(--theme-color-text-muted, #8a94a3); }
		.sw-dot { opacity: 0.5; }
		.sw-back { font-size: 0.82rem; color: var(--theme-color-text-muted, #6b7686); white-space: nowrap; margin-left: 0.3rem; }
		.sw-back:hover { color: var(--theme-color-brand-primary, #5650e6); }
		.sw-qr-thumb { flex: 0 0 auto; width: 80px; height: 80px; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; padding: 3px; background: #fff; margin-left: 0.4rem; }
		.sw-qr-thumb canvas, .sw-qr-thumb img, .sw-qr-thumb svg { width: 100%; height: 100%; display: block; }
		.sw-status { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.14rem 0.55rem; border-radius: 999px; }
		.sw-status.is-pass { background: rgba(46,122,67,0.14); color: #2f7a43; }
		.sw-status.is-fail { background: rgba(178,59,59,0.14); color: #b23b3b; }
		.sw-status.is-void { background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-muted, #6b7686); }
		.sw-status.is-pending { background: rgba(216,161,59,0.16); color: #8a5a00; }
		.sw-status.is-neutral { background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-brand-primary, #5650e6); }
		.sw-state { padding: 1.6rem 0.5rem; color: var(--theme-color-text-muted, #8a94a3); font-size: 0.9rem; }
		.sw-empty { text-align: center; color: var(--theme-color-text-muted, #8a94a3); padding: 2rem 0; }
		.sw-empty .fa-inbox { font-size: 1.6rem; opacity: 0.45; }
		.sw-empty p { margin-top: 0.5rem; font-size: 0.9rem; }
		.sw-toolbar { display: flex; gap: 0.5rem; margin-bottom: 0.9rem; }
		.sw-form-host { margin: -0.2rem 0 0; }
		.sw-form-host.sw-form-readonly select, .sw-form-host.sw-form-readonly .select2, .sw-form-host.sw-form-readonly button, .sw-form-host.sw-form-readonly a.button { pointer-events: none; }
		.sw-form-host.sw-form-readonly input, .sw-form-host.sw-form-readonly textarea, .sw-form-host.sw-form-readonly select { background: var(--theme-color-background-tertiary, #f7f9fb); border-color: var(--theme-color-border-light, #e8ebf0); color: var(--theme-color-text-primary, #1f2733); }
		.sw-form-host.sw-form-readonly .delete, .sw-form-host.sw-form-readonly .select2-selection__clear { display: none !important; }
		.sw-docframes { height: calc(100vh - 15rem); min-height: 30rem; }
		.sw-hidden-media { margin-bottom: 0.75rem; }
		.sw-hidden-media-title { font-size: 0.78rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); margin-bottom: 0.4rem; }
		.sw-hidden-media-strip { display: flex; gap: 0.5rem; overflow-x: auto; padding-bottom: 0.2rem; }
		.sw-hidden-media-item { position: relative; flex: 0 0 auto; width: 88px; height: 88px; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 6px; overflow: hidden; background: var(--theme-color-background-tertiary, #f4f6f9); }
		.sw-hidden-media-item:hover { border-color: var(--theme-color-brand-primary, #5650e6); }
		.sw-hidden-media-item img { width: 100%; height: 100%; object-fit: cover; display: block; }
		.sw-hidden-media-play { position: absolute; inset: 0; margin: auto; width: 1.6rem; height: 1.6rem; font-size: 1.6rem; color: #fff; text-shadow: 0 0 4px rgba(0,0,0,0.6); }
		.sw-tablewrap { overflow-x: auto; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; }
		.sw-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.86rem; }
		.sw-table thead th { text-align: left; font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #6b7686); background: var(--theme-color-background-tertiary, #f4f6f9); padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.sw-table tbody td { padding: 0.5rem 0.85rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); vertical-align: middle; color: var(--theme-color-text-secondary, #45505f); }
		.sw-table tbody tr:last-child td { border-bottom: none; }
		.sw-table tbody tr:hover td { background: var(--theme-color-background-secondary, #f7f9fb); }
		.sw-cell-strong { font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.sw-table .sw-num { text-align: right; font-variant-numeric: tabular-nums; }
		.sw-muted { color: var(--theme-color-text-muted, #8a94a3); white-space: nowrap; font-variant-numeric: tabular-nums; }
		.sw-chip { font-size: 0.7rem; font-weight: 700; padding: 0.1rem 0.5rem; border-radius: 999px; }
		.sw-chip.is-pass { background: rgba(46,122,67,0.14); color: #2f7a43; }
		.sw-chip.is-fail { background: rgba(178,59,59,0.14); color: #b23b3b; }
		.sw-chip.is-neutral { background: var(--theme-color-background-tertiary, #eef1f6); color: var(--theme-color-text-muted, #6b7686); }
		.sw-row-actions { white-space: nowrap; text-align: right; }
		.sw-row-actions .button { margin-left: 0.25rem; }
		.sw-input { padding: 0.4rem 0.6rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px; font: inherit; font-size: 0.86rem; background: var(--theme-color-background-input, #fff); color: var(--theme-color-text-primary, #1f2733); }
		.sw-add-form { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.8rem; margin-bottom: 0.9rem; background: var(--theme-color-background-secondary, #f7f9fb); display: flex; flex-direction: column; gap: 0.55rem; }
		.sw-add-row { display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap; }
		.sw-add-select { min-width: 13rem; }
		.sw-add-qty { width: 6rem; }
		.sw-add-field { display: flex; flex-direction: column; gap: 0.2rem; }
		.sw-add-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: var(--theme-color-text-muted, #6b7686); }
		.sw-add-picker { min-width: 16rem; }
		.sw-toolbar .sw-total { margin-left: auto; align-self: center; font-size: 0.86rem; color: var(--theme-color-text-secondary, #45505f); }
		.sw-subrow { font-size: 0.74rem; margin-top: 0.15rem; }
		.sw-ti-remarks { max-width: 22rem; min-width: 0; }
		.sw-ti-doc { white-space: nowrap; }
		.sw-ti-pending { color: var(--theme-color-text-muted, #8a94a3); font-style: italic; font-size: 0.78rem; white-space: nowrap; }
		.sw-log { display: flex; gap: 0.75rem; align-items: flex-start; }
		.sw-log-main { flex: 1 1 auto; min-width: 0; }
		.sw-log-id { font-size: 0.7rem; }
		.sw-log-map { flex: 0 0 auto; width: 100px; height: 100px; border-radius: 6px; object-fit: cover; border: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.sw-log-nomap { display: flex; align-items: center; justify-content: center; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-tertiary, #f4f6f9); font-size: 1.3rem; opacity: 0.6; }
		.sw-print { display: flex; flex-direction: column; gap: 0.9rem; }
		.sw-print-preview { padding: 0.75rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; background: #fff; overflow-x: auto; }
		.sw-print-preview img, .sw-print-preview canvas { max-width: 100%; height: auto; }
		.sw-print-preview img.hl-label-preview--vertical { max-height: 32rem; width: auto; }
		.sw-logs { display: flex; flex-direction: column; gap: 0.9rem; }
		.sw-log-add { display: flex; flex-direction: column; gap: 0.5rem; align-items: flex-start; }
		.sw-log-input { min-height: 3rem; width: 100%; resize: vertical; }
		.sw-log-list { display: flex; flex-direction: column; gap: 0.5rem; }
		.sw-log { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.6rem 0.75rem; }
		.sw-log-notes { font-size: 0.9rem; color: var(--theme-color-text-primary, #1f2733); }
		.sw-log-meta { display: flex; gap: 0.85rem; font-size: 0.74rem; margin-top: 0.35rem; color: var(--theme-color-text-muted, #8a94a3); }
		.sw-loc-card { display: flex; gap: 1rem; align-items: flex-start; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.85rem; }
		.sw-loc-thumb { flex: 0 0 auto; width: 96px; height: 96px; border-radius: 6px; object-fit: cover; border: 1px solid var(--theme-color-border-light, #e8ebf0); }
		.sw-loc-nothumb { display: flex; align-items: center; justify-content: center; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-tertiary, #f4f6f9); font-size: 1.6rem; opacity: 0.6; }
		.sw-loc-thumb.is-hidden { display: none; }
		.sw-loc-body { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 0.3rem; }
		.sw-loc-name { font-size: 1.05rem; font-weight: 600; }
		.sw-loc-facts { display: flex; flex-wrap: wrap; align-items: center; gap: 0.6rem; font-size: 0.82rem; }
		.sw-loc-type { font-size: 0.7rem; font-weight: 700; padding: 0.12rem 0.55rem; border-radius: 999px; background: var(--theme-color-background-selected, #eef1f8); color: var(--theme-color-brand-primary, #5650e6); }
		.sw-loc-line { font-size: 0.88rem; color: var(--theme-color-text-secondary, #45505f); }
		.sw-loc-sep { opacity: 0.6; }
		.sw-loc-error { font-size: 0.88rem; color: var(--theme-color-status-error, #b3382f); background: var(--theme-color-status-error-bg, #fbeaea); border-radius: 6px; padding: 0.5rem 0.7rem; }
		.sw-loc-edit-bar { align-items: center; justify-content: space-between; }
		.sw-loc-cart { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
		.sw-loc-cart .hl-scan {
			--hl-scan-background: var(--theme-color-background-panel, var(--theme-color-background-primary, #fff));
			--hl-scan-text: var(--theme-color-text-secondary, #45505f);
			--hl-scan-text-strong: var(--theme-color-text-primary, #1f2733);
			--hl-scan-text-weak: var(--theme-color-text-muted, #8a94a3);
			--hl-scan-border: var(--theme-color-border-light, #e8ebf0);
			--hl-scan-border-weak: var(--theme-color-border-light, #eef1f5);
			--hl-scan-head-background: var(--theme-color-background-tertiary, #f4f6f9);
			--hl-scan-input-background: var(--theme-color-background-primary, #fff);
			--hl-scan-input-text: var(--theme-color-text-primary, #1f2733);
			--hl-scan-input-border: var(--theme-color-border-default, #d7dce3);
		}
		.button.is-tiny { font-size: 0.72rem; padding: 0.12rem 0.5rem; height: auto; line-height: 1.4; }
	`,
};

},{"../samples/SampleWorkspace-Provider.js":1396}],1512:[function(require,module,exports){
'use strict';

// Team workspace — the people-manager surface for the NEW Teams architecture. A Team enrolls users in roles
// (TeamUserJoin), is granted Documents (DocumentAccessJoin), and — through the server-side access engine
// (DocumentAccessJoin → materialized PermDocumentUser → PermProjectUser) — gives its members reach into the Projects
// those documents live in WITHOUT any per-user project membership.
//
// Steven's decision: Team→Project enrollment is DERIVED via document grants (no new server join), so the "Projects"
// tab is read-only effective-reach computed from the team's granted documents. Inspection assignment (Team↔Inspection)
// is a later phase (needs a server-side InspectionTeamJoin). Built on pict-section-workspace like the other config-app
// workspaces; auto-routed at /Team/Workspace/:ID[/:Tab] + shadows /PSRS/Team/View/:GUID. See [[TeamWorkspace-Provider.js]].

const libTeamWorkspaceProvider = require('../providers/TeamWorkspace-Provider.js');

module.exports = {
	Identifier: 'TeamWorkspace',
	Ordinal: 210,
	ProviderClass: libTeamWorkspaceProvider,
	Entity: { Name: 'Team', IDField: 'IDTeam', Collection: 'Teams', GUIDField: 'GUIDTeam' },
	RoutePrefix: 'Team',
	Header:
	{
		Eyebrow: 'Team',
		Title: (r) => r.Name || `Team ${r.IDTeam}`,
		Subtitle: (r) => r.Description || '',
		ListRoute: '#/PSRS/Team/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-users', Content: { kind: 'render', ref: '_overviewHTML' }, OnEnter: (p) => p._ensureTabDataAsync('overview') },
		{ Key: 'members', Label: 'Members & Roles', Icon: 'fas fa-user-plus', Content: { kind: 'render', ref: '_membersHTML' }, OnEnter: (p) => p._ensureTabDataAsync('members') },
		{ Key: 'documents', Label: 'Documents', Icon: 'fas fa-file-shield', Content: { kind: 'render', ref: '_documentsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('documents') },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-diagram-project', Content: { kind: 'render', ref: '_projectsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('projects') },
		{ Key: 'inspections', Label: 'Inspections', Icon: 'fas fa-clipboard-check', Content: { kind: 'render', ref: '_inspectionsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('inspections') },
		{ Key: 'subteams', Label: 'Sub-teams', Icon: 'fas fa-sitemap', Content: { kind: 'render', ref: '_subteamsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('subteams') },
		{ Key: 'labs', Label: 'Labs', Icon: 'fas fa-flask', Content: { kind: 'render', ref: '_labsHTML' }, OnEnter: (p) => p._ensureTabDataAsync('labs') },
	],
	CSSExtra: /*css*/`
		.tw-note { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); padding:0.6rem 0; display:flex; align-items:center; gap:0.5rem; }
		.tw-hint { font-size:0.8rem; color:var(--theme-color-text-muted,#8894a4); margin:0 0 0.8rem; display:flex; align-items:center; gap:0.4rem; }
		.tw-hint i { color:var(--theme-color-brand-primary,#2e7d74); }
		.tw-error { font-size:0.88rem; color:var(--theme-color-status-error,#b3382f); background:var(--theme-color-status-error-bg,#fbeaea); border-radius:6px; padding:0.5rem 0.7rem; margin:0 0 0.6rem; }
		.tw-muted { color:var(--theme-color-text-muted,#aab3c0); }
		.tw-sec-h { font-size:0.72rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:1.2rem 0 0.6rem; }
		/* stat cards (overview) */
		.tw-stats { display:grid; grid-template-columns:repeat(auto-fill,minmax(11rem,1fr)); gap:0.85rem; margin:0 0 0.5rem; }
		.tw-stat { background:var(--theme-color-background-primary,#fff); border:1px solid var(--theme-color-border-light,#e2e8ec); border-radius:12px; padding:0.85rem 1rem; }
		.tw-stat-v { font-size:1.6rem; font-weight:800; color:var(--theme-color-text-primary,#1f2733); line-height:1; }
		.tw-stat-l { font-size:0.72rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.3rem; }
		.tw-fields { display:grid; grid-template-columns:repeat(auto-fill,minmax(14rem,1fr)); gap:0.9rem 1.4rem; margin:1rem 0; }
		.tw-field-label { font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		.tw-field-value { font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); margin-top:0.1rem; }
		/* add-row control (member/doc/lab pickers) */
		.tw-addbar { display:flex; align-items:flex-end; gap:0.6rem; flex-wrap:wrap; background:var(--theme-color-background-secondary,#f4f6f9); border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:10px; padding:0.7rem 0.85rem; margin:0 0 1rem; }
		.tw-addbar .tw-f { display:flex; flex-direction:column; gap:0.15rem; flex:1 1 0; min-width:12rem; max-width:28rem; }
		.tw-addbar .tw-f-l { font-size:0.64rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); }
		/* the fields share the row whatever they hold: a long pick truncates instead of widening its field and pushing the next control */
		.tw-pick { width:100%; min-width:0; } .tw-pick .pps-option-label { white-space:normal; overflow:visible; text-overflow:clip; }
		.tw-rolecell { display:flex; align-items:center; gap:0.25rem; } .tw-rolecell .tw-pick { flex:1 1 auto; } .tw-col-role { width:22rem; }
		/* table */
		.tw-table { width:100%; border-collapse:collapse; font-size:0.88rem; }
		.tw-table th { text-align:left; font-size:0.66rem; font-weight:800; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-secondary,#45505f); border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding:0.45rem 0.55rem; white-space:nowrap; }
		.tw-table td { border-bottom:1px solid var(--theme-color-border-light,#f1f4f8); padding:0.5rem 0.55rem; vertical-align:middle; }
		.tw-table tr:hover td { background:var(--theme-color-background-secondary,#f6f8fb); }
		.tw-name { font-weight:600; color:var(--theme-color-text-primary,#1f2733); } .tw-sub { display:block; font-size:0.74rem; color:var(--theme-color-text-muted,#9aa3af); }
		.tw-chip { font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-secondary,#eef1f6); border-radius:5px; padding:0.08rem 0.45rem; white-space:nowrap; }
		.tw-add-btn { align-self:flex-end; font-size:0.82rem; font-weight:700; color:#fff; background:var(--theme-color-brand-primary,#2e7d74); border:none; border-radius:7px; padding:0.45rem 0.85rem; cursor:pointer; display:inline-flex; align-items:center; gap:0.35rem; white-space:nowrap; }
		.tw-add-btn:hover { filter:brightness(1.05); }
		.tw-add-btn[disabled] { opacity:0.6; cursor:default; filter:none; }
		.tw-x[disabled], .tw-x[disabled]:hover { opacity:0.6; cursor:default; color:var(--theme-color-text-muted,#98a2b3); background:transparent; }
		.tw-editrole { border:none; background:transparent; color:var(--theme-color-text-muted,#98a2b3); cursor:pointer; font-size:0.78rem; border-radius:5px; padding:0.12rem 0.35rem; margin-left:0.15rem; } .tw-editrole:hover { color:var(--theme-color-brand-primary,#2e7d74); background:var(--theme-color-background-secondary,#eef1f6); }
		.tw-x { border:none; background:transparent; color:var(--theme-color-text-muted,#98a2b3); cursor:pointer; font-size:0.95rem; border-radius:6px; padding:0.2rem 0.45rem; } .tw-x:hover { color:var(--theme-color-status-error,#c0392b); background:var(--theme-color-status-error-bg,#fbeaea); }
		.tw-link { color:var(--theme-color-brand-primary,#2e7d74); text-decoration:none; font-weight:600; } .tw-link:hover { text-decoration:underline; }
		.tw-empty { padding:1.6rem; text-align:center; color:var(--theme-color-text-muted,#8a94a3); font-size:0.88rem; border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:10px; }
	`,
};

},{"../providers/TeamWorkspace-Provider.js":1376}],1513:[function(require,module,exports){
'use strict';
// Test (material sample test definition) workspace.
module.exports = {
	Identifier: 'TestWorkspace', Ordinal: 243,
	Entity: { Name: 'Test', IDField: 'IDTest', Collection: 'Tests', GUIDField: 'GUIDTest' },
	Header: { Eyebrow: 'Test', Title: (r) => r.Name || `Test ${r.IDTest}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Test/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'labs', Label: 'Labs', Icon: 'fas fa-flask', Content: { kind: 'assoc', ref: 'LabTest' } },
		{ Key: 'specsets', Label: 'Specification Sets', Icon: 'fas fa-vials', Content: { kind: 'assoc', ref: 'TestTestSpecificationSet' } },
		{ Key: 'requirements', Label: 'Requirements', Icon: 'fas fa-list-check', Content: { kind: 'childlist', ref: 'TestSpecificationRequirement', parentField: 'IDTest',
			columns: [ { Key: 'Name', Label: 'Name' } ], empty: 'No requirements defined for this test.' } },
		{ Key: 'instances', Label: 'Test Instances', Icon: 'fas fa-microscope', Content: { kind: 'childlist', ref: 'TestInstance', parentField: 'IDTest',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'Status', Label: 'Status' }, { Key: 'SampleTestNumber', Label: 'Test #' } ], empty: 'No test instances yet.', cap: 200 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};

},{}],1514:[function(require,module,exports){
'use strict';

// User workspace — refactored onto pict-section-workspace. The base owns the shell; the UserWorkspaceProvider
// subclass carries the editable Overview, the reset-password / impersonate / edit actions, the Roles & Groups
// read panel, the Certifications editor, and the per-user Activity dashboard (moved in from the standalone User
// Activity view). The Projects tab is a plain association editor (base `assoc` kind). See [[UserWorkspace-Provider.js]].

const libUserWorkspaceProvider = require('../providers/UserWorkspace-Provider.js');

module.exports = {
	Identifier: 'UserWorkspace',
	Ordinal: 222,
	ProviderClass: libUserWorkspaceProvider,
	Entity: { Name: 'User', IDField: 'IDUser', Collection: 'Users', GUIDField: 'GUIDUser' },
	Header:
	{
		Eyebrow: 'User',
		Title: (pRec) => `${pRec.NameFirst || ''} ${pRec.NameLast || ''}`.trim() || pRec.LoginID || `User ${pRec.IDUser}`,
		Subtitle: (pRec) => pRec.Email || pRec.LoginID || '',
		Actions:
		[
			{ Label: 'Save', Icon: 'fas fa-floppy-disk', Style: 'is-link', OnClick: 'saveAsync()', When: (pProv) => pProv._editing },
			{ Label: 'Cancel', Icon: 'fas fa-xmark', Style: 'is-light', OnClick: 'cancelEdit()', When: (pProv) => pProv._editing },
			{ Label: 'Edit', Icon: 'fas fa-pen-to-square', Style: 'is-light', OnClick: 'startEdit()', When: (pProv) => !pProv._editing && pProv.canEditUser },
			{ Label: 'Reset password', Icon: 'fas fa-key', Style: 'is-light', OnClick: 'resetPasswordPrompt()', When: (pProv) => !pProv._editing && pProv.canResetPassword },
			{ Label: 'Impersonate', Icon: 'fas fa-user-secret', Style: 'is-light', OnClick: 'impersonatePrompt()', When: (pProv) => !pProv._editing && pProv.canImpersonate },
		],
		ListRoute: '#/PSRS/User/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'render', ref: 'renderOverview' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'ProjectUser', editorOptions: { AllowSynthesize: false } } },
		{ Key: 'roles', Label: 'Roles & Groups', Icon: 'fas fa-user-shield', Content: { kind: 'render', ref: 'renderRoles' }, OnEnter: (pProv) => pProv.loadRolesAsync() },
		{ Key: 'certifications', Label: 'Certifications', Icon: 'fas fa-stamp', Content: { kind: 'render', ref: 'renderCertifications' }, OnEnter: (pProv) => pProv.loadCertificationsAsync() },
		{ Key: 'activity', Label: 'Activity', Icon: 'fas fa-chart-line', Content: { kind: 'render', ref: 'renderActivity' }, OnEnter: (pProv) => pProv._loadActivity() },
	],
	CSSExtra: /*css*/`
		.pw-help { font-size: 0.85rem; color: var(--theme-color-text-muted, #6b7686); }
		.pw-group-head-row { display: flex; align-items: baseline; justify-content: space-between; gap: 0.6rem; }
		.uw-check { display: inline-flex; align-items: center; height: 2rem; }
		.uw-check input { width: 1.15rem; height: 1.15rem; }
		.uw-edit-input { height: 2rem; font-size: 0.95rem; max-width: 100%; margin-top: 0.1rem; }
		.uw-role-hint { font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.6rem; }
		.uw-role-count { font-size: 0.72rem; font-weight: 700; color: var(--theme-color-text-muted, #8a94a3); }
		.uw-role-list { display: flex; flex-direction: column; gap: 0.5rem; }
		.uw-role-row { border: 1px solid var(--theme-color-border-default, #e2e6ec); border-radius: 7px; padding: 0.55rem 0.7rem; background: var(--theme-color-background-subtle, #fafbfc); }
		.uw-role-main { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
		.uw-role-icon { color: var(--theme-color-brand-primary, #5650e6); flex: 0 0 auto; }
		.uw-role-name { font-weight: 600; }
		.uw-role-contexts { margin: 0.5rem 0 0.1rem; padding-left: 1.55rem; display: flex; flex-direction: column; gap: 0.3rem; }
		.uw-role-context { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; font-size: 0.9rem; }
		.uw-role-context-icon { color: var(--theme-color-text-muted, #9aa3af); flex: 0 0 auto; }
		.uw-role-context-name { color: var(--theme-color-text-secondary, #45505f); }
		.uw-role-context-id { font-size: 0.72rem; color: var(--theme-color-text-muted, #9aa3af); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
		.uw-role-x { flex: 0 0 auto; margin-left: auto; border: none; background: transparent; color: var(--theme-color-text-muted, #98a2b3); cursor: pointer; padding: 0.1rem 0.3rem; border-radius: 5px; line-height: 1; }
		.uw-role-x:hover { color: var(--theme-color-status-danger, #c0392b); background: #fdecec; }
		.uw-role-context .uw-role-x { margin-left: 0.15rem; }
		.uw-role-add-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 0.7rem; margin: 0 0 0.6rem; }
		.uw-role-field { display: flex; flex-direction: column; gap: 0.2rem; }
		.uw-role-flabel { font-size: 0.72rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
		.uw-role-field .uw-cert-typepicker { min-width: 20rem; margin: 0; }
		.uw-role-scope { font-size: 0.9rem; }
		.uw-role-date { font-size: 0.85rem; padding: 0.35rem 0.5rem; border: 1px solid var(--theme-color-border-medium, #d5dbe3); border-radius: 6px; }
		.uw-role-opt { font-weight: 400; color: var(--theme-color-text-muted, #9aa3af); }
		.uw-cert-list { display: flex; flex-direction: column; }
		.uw-cert-row { display: flex; align-items: center; gap: 0.7rem; padding: 0.45rem 0.2rem; border-bottom: 1px solid var(--theme-color-border-light, #f0f2f6); }
		.uw-cert-main { flex: 1 1 auto; min-width: 0; display: flex; align-items: center; gap: 0.5rem; }
		.uw-cert-name { font-size: 0.92rem; font-weight: 600; color: var(--theme-color-text-primary, #1f2733); }
		.uw-cert-dates { flex: 0 0 auto; font-size: 0.8rem; color: var(--theme-color-text-muted, #6b7686); }
		.uw-cert-badge { font-size: 0.6rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.06rem 0.4rem; border-radius: 9px; }
		.uw-cert-active { color: #276749; background: #e6f4ea; } .uw-cert-exp { color: #9b2c2c; background: #fdecec; } .uw-cert-future { color: #8a6d1b; background: #fbf3d9; }
		.uw-cert-x { flex: 0 0 auto; border: none; background: transparent; color: var(--theme-color-text-muted, #98a2b3); cursor: pointer; padding: 0.2rem 0.35rem; border-radius: 5px; }
		.uw-cert-x:hover { color: var(--theme-color-status-danger, #c0392b); background: #fdecec; }
		.uw-cert-add { margin-top: 1.1rem; padding-top: 0.9rem; border-top: 1px solid var(--theme-color-border-light, #eef1f6); }
		.uw-cert-add-head { font-size: 0.7rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-secondary, #45505f); margin: 0 0 0.5rem; }
		.uw-cert-typepicker { max-width: 30rem; margin: 0 0 0.6rem; }
		.uw-cert-dates-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 0.7rem; margin: 0 0 0.6rem; }
		.uw-cert-dates-row label, .uw-cert-notes { display: flex; flex-direction: column; gap: 0.2rem; font-size: 0.72rem; font-weight: 600; color: var(--theme-color-text-secondary, #45505f); }
		.uw-cert-dates-row input, .uw-cert-notes input { font-size: 0.85rem; font-weight: 400; padding: 0.35rem 0.5rem; border: 1px solid var(--theme-color-border-medium, #d5dbe3); border-radius: 6px; }
		.uw-cert-notes { margin: 0 0 0.6rem; } .uw-cert-notes input { max-width: 30rem; }
		.uw-cert-presets { display: inline-flex; gap: 0.3rem; padding-bottom: 0.35rem; }
		.uw-cert-presets button { font-size: 0.72rem; font-weight: 600; padding: 0.3rem 0.55rem; border: 1px solid var(--theme-color-border-medium, #d5dbe3); border-radius: 6px; background: var(--theme-color-background-secondary, #eef1f6); color: var(--theme-color-text-secondary, #45505f); cursor: pointer; }
		.uw-cert-btn { font-size: 0.85rem; font-weight: 600; padding: 0.4rem 0.9rem; border-radius: 7px; border: none; background: var(--theme-color-primary, #2f6fed); color: #fff; cursor: pointer; }
		.uw-cert-add-actions { display: flex; align-items: center; gap: 0.6rem; }
		.uw-cert-busy { font-size: 0.8rem; color: var(--theme-color-primary, #2f6fed); font-weight: 600; }
		.uw-cert-notice { font-size: 0.85rem; color: #276749; background: #e6f4ea; border-radius: 6px; padding: 0.45rem 0.6rem; margin: 0.6rem 0 0; }
		.uw-cert-error { font-size: 0.85rem; color: var(--theme-color-status-danger, #c0392b); margin: 0.5rem 0 0; }
	`,
};

},{"../providers/UserWorkspace-Provider.js":1381}],1515:[function(require,module,exports){
'use strict';

/**
 * Where a workspace's Back link goes: the list or dashboard URL its record was opened from, with that list's
 * filter, sort, search and paging still in the route, or the config's Header.ListRoute when the record was
 * opened some other way (a pasted link, a new tab, another workspace).
 */
class WorkspaceReturnRoutes
{
	constructor()
	{
		/** @type {Array<{ Config: any, DefaultListRoute: string, RecordPattern: RegExp, ListPattern: RegExp }>} */
		this.entries = [];
		/** @type {Object<string, string>} the remembered return route, by workspace Identifier */
		this.returnRoutes = {};
		this.installed = false;
	}

	/**
	 * Track a workspace config and point its Header.ListRoute at the remembered return route.
	 *
	 * @param {any} pConfig - a pict-section-workspace config
	 */
	applyTo(pConfig)
	{
		const tmpHeader = pConfig && pConfig.Header;
		if (!tmpHeader || (typeof tmpHeader.ListRoute !== 'string') || !pConfig.Entity || !pConfig.Entity.Name)
		{
			return;
		}
		const tmpEntity = escapeRegExp(pConfig.Entity.Name);
		const tmpPrefix = escapeRegExp(pConfig.RoutePrefix || pConfig.Entity.Name);
		const tmpEntry =
		{
			Config: pConfig,
			DefaultListRoute: tmpHeader.ListRoute,
			RecordPattern: new RegExp(`^#/(PSRS/${tmpEntity}/(View|Edit|Create)(/|$)|${tmpPrefix}/Workspace/)`),
			ListPattern: new RegExp(`^#/(PSRS/${tmpEntity}/List(/|$)|Dashboards(/|$))`)
		};
		this.entries.push(tmpEntry);
		Object.defineProperty(tmpHeader, 'ListRoute',
			{
				configurable: true,
				enumerable: true,
				get: () => this.listRouteFor(pConfig.Identifier, tmpEntry.DefaultListRoute)
			});
	}

	/**
	 * @param {string} pIdentifier - the workspace Identifier
	 * @param {string} pDefaultListRoute
	 * @return {string} the remembered return route, else the default
	 */
	listRouteFor(pIdentifier, pDefaultListRoute)
	{
		return this.returnRoutes[pIdentifier] || pDefaultListRoute;
	}

	/**
	 * Remember the list a record was opened from: a move from a workspace's own list (or a dashboard) into one of
	 * its record routes. Moves between record routes (tabs, edit, save) keep what was remembered.
	 *
	 * @param {string} pFromHash - e.g. '#/PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0'
	 * @param {string} pToHash - e.g. '#/PSRS/Sample/View/<GUID>'
	 */
	noteRouteChange(pFromHash, pToHash)
	{
		for (const tmpEntry of this.entries)
		{
			if (tmpEntry.RecordPattern.test(pToHash) && tmpEntry.ListPattern.test(pFromHash))
			{
				this.returnRoutes[tmpEntry.Config.Identifier] = pFromHash;
			}
		}
	}

	/**
	 * Listen for route changes. Link clicks (a list row, a Sample ID link) and `location.hash` assignments fire
	 * hashchange, whose oldURL is the list's URL as shown, including routes the router pushed without one.
	 *
	 * @param {any} pWindow
	 */
	install(pWindow)
	{
		if (this.installed || !pWindow || (typeof pWindow.addEventListener !== 'function'))
		{
			return;
		}
		this.installed = true;
		pWindow.addEventListener('hashchange', (pEvent) =>
		{
			this.noteRouteChange(hashOf(pEvent && pEvent.oldURL), hashOf(pEvent && pEvent.newURL));
		});
	}
}

/**
 * @param {string} pURL
 * @return {string} the '#…' part of a URL, or ''
 */
function hashOf(pURL)
{
	if (typeof pURL !== 'string')
	{
		return '';
	}
	const tmpIndex = pURL.indexOf('#');
	return (tmpIndex < 0) ? '' : pURL.slice(tmpIndex);
}

/**
 * @param {string} pValue
 * @return {string}
 */
function escapeRegExp(pValue)
{
	return String(pValue).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

module.exports = WorkspaceReturnRoutes;
module.exports.hashOf = hashOf;

},{}],1516:[function(require,module,exports){
'use strict';

// Central registry of config-driven workspaces built on pict-section-workspace. App-Web calls registerWorkspaces()
// (registers each provider+view pair); the router calls registerWorkspaceRoutes() (the GUID-bridge + :Tab routes).
// Hand-built workspaces (Project/Contract/User/Asset/Sample) migrate into this list as they are converted.

const libWorkspace = require('pict-section-workspace');
const libWorkspaceReturnRoutes = require('./Workspace-ReturnRoutes.js');

const CONFIGS =
[
	// Tier 1 — new operational-entity workspaces
	require('./Organization.config.js'),
	require('./Material.config.js'),
	require('./PayItem.config.js'),
	require('./Test.config.js'),
	require('./MixDesign.config.js'),
	require('./MixType.config.js'),
	require('./Product.config.js'),
	// Tier 2
	require('./Lab.config.js'),
	require('./Equipment.config.js'),
	require('./Location.config.js'),
	require('./Customer.config.js'),
	// New architecture — Teams (people-manager enrollment; access via the DocumentAccessJoin projection engine)
	require('./Team.config.js'),
	// New architecture — Inspections (per-record workspace over the Inspection* Meadow joins; Bridge-app replacement)
	require('./Inspection.config.js'),
	// Read-only (field / approval data)
	require('./Observation.config.js'),
	require('./Document.config.js'),
	// Financial entities
	require('./Fund.config.js'),
	require('./FundingCategory.config.js'),
	require('./Account.config.js'),
	require('./AccountType.config.js'),
	require('./FundingSource.config.js'),
	// Organization sub-entities
	require('./ProductionPlant.config.js'),
	require('./Contact.config.js'),
	require('./ProjectOffice.config.js'),
	// Fulfillment
	require('./Lot.config.js'),
	// Migrated existing workspaces (were hand-built views/providers; now config + a bespoke-methods subclass)
	require('./Contract.config.js'),
	require('./Asset.config.js'),
	require('./AssetType.config.js'),
	require('./User.config.js'),
	require('./Project.config.js'),
	require('./Sample.config.js'),
];

const _ReturnRoutes = new libWorkspaceReturnRoutes();

function registerWorkspaces(pPict)
{
	// pict-section-workspace (>=1.0.1) exposes app-wide config hooks; wire the three things this app needs once,
	// up front, so no per-config plumbing is required:
	//  - the mount point (the published default `#Pict-Application-Container` does not exist in this app);
	//  - the record REST client (the published default `RestClient` is a generic client with no `/1.0/` base URL;
	//    HeadlightRestClient prepends it — otherwise reads hit `/<Entity>/:id` and 404);
	//  - the association editor (browserify drops the library's optional computed require, so `assoc` tabs need the
	//    RecordSet editor injected explicitly).
	if (typeof libWorkspace.setDefaultDestination === 'function') { libWorkspace.setDefaultDestination('#PlatformConfiguration-Application-Container'); }
	if (typeof libWorkspace.setDefaultRestClientName === 'function') { libWorkspace.setDefaultRestClientName('HeadlightRestClient'); }
	if (typeof libWorkspace.setAssociationEditorLib === 'function') { libWorkspace.setAssociationEditorLib(require('pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js')); }
	for (const tmpConfig of CONFIGS) { libWorkspace.createWorkspace(pPict, tmpConfig); }
	// Each workspace's Back link returns to the list (or dashboard) its record was opened from, filters and all.
	if (_ReturnRoutes.entries.length < 1)
	{
		for (const tmpConfig of CONFIGS)
		{
			_ReturnRoutes.applyTo(tmpConfig);
		}
	}
	if (typeof window !== 'undefined')
	{
		_ReturnRoutes.install(window);
	}
}

function registerWorkspaceRoutes(pRouter)
{
	for (const tmpConfig of CONFIGS) { libWorkspace.registerWorkspaceRoutes(pRouter, tmpConfig); }
}

/**
 * Note a move the router makes without a hashchange (PictRouter.navigate pushes history), so a workspace opened that
 * way still gets a Back link to where it was opened from.
 *
 * @param {string} pFromHash - the current location hash
 * @param {string} pToRoute - the route about to be navigated to, with or without its leading '#'
 */
function noteRouteChange(pFromHash, pToRoute)
{
	const tmpTo = String(pToRoute || '');
	_ReturnRoutes.noteRouteChange(pFromHash || '', (tmpTo.charAt(0) === '#') ? tmpTo : `#${tmpTo}`);
}

module.exports = { CONFIGS, registerWorkspaces, registerWorkspaceRoutes, noteRouteChange };

},{"./Account.config.js":1485,"./AccountType.config.js":1486,"./Asset.config.js":1487,"./AssetType.config.js":1488,"./Contact.config.js":1489,"./Contract.config.js":1490,"./Customer.config.js":1491,"./Document.config.js":1492,"./Equipment.config.js":1493,"./Fund.config.js":1494,"./FundingCategory.config.js":1495,"./FundingSource.config.js":1496,"./Inspection.config.js":1497,"./Lab.config.js":1498,"./Location.config.js":1499,"./Lot.config.js":1500,"./Material.config.js":1501,"./MixDesign.config.js":1502,"./MixType.config.js":1503,"./Observation.config.js":1504,"./Organization.config.js":1505,"./PayItem.config.js":1506,"./Product.config.js":1507,"./ProductionPlant.config.js":1508,"./Project.config.js":1509,"./ProjectOffice.config.js":1510,"./Sample.config.js":1511,"./Team.config.js":1512,"./Test.config.js":1513,"./User.config.js":1514,"./Workspace-ReturnRoutes.js":1515,"pict-section-recordset/source/views/associate/RecordSet-AssociationEditor.js":988,"pict-section-workspace":1049}],1517:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "v1", {
  enumerable: true,
  get: function () {
    return _v.default;
  }
});
Object.defineProperty(exports, "v3", {
  enumerable: true,
  get: function () {
    return _v2.default;
  }
});
Object.defineProperty(exports, "v4", {
  enumerable: true,
  get: function () {
    return _v3.default;
  }
});
Object.defineProperty(exports, "v5", {
  enumerable: true,
  get: function () {
    return _v4.default;
  }
});
Object.defineProperty(exports, "NIL", {
  enumerable: true,
  get: function () {
    return _nil.default;
  }
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function () {
    return _version.default;
  }
});
Object.defineProperty(exports, "validate", {
  enumerable: true,
  get: function () {
    return _validate.default;
  }
});
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function () {
    return _stringify.default;
  }
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function () {
    return _parse.default;
  }
});

var _v = _interopRequireDefault(require("./v1.js"));

var _v2 = _interopRequireDefault(require("./v3.js"));

var _v3 = _interopRequireDefault(require("./v4.js"));

var _v4 = _interopRequireDefault(require("./v5.js"));

var _nil = _interopRequireDefault(require("./nil.js"));

var _version = _interopRequireDefault(require("./version.js"));

var _validate = _interopRequireDefault(require("./validate.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

var _parse = _interopRequireDefault(require("./parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./nil.js":1519,"./parse.js":1520,"./stringify.js":1524,"./v1.js":1525,"./v3.js":1526,"./v4.js":1528,"./v5.js":1529,"./validate.js":1530,"./version.js":1531}],1518:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports.default = _default;
},{}],1519:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports.default = _default;
},{}],1520:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports.default = _default;
},{"./validate.js":1530}],1521:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports.default = _default;
},{}],1522:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
},{}],1523:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports.default = _default;
},{}],1524:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports.default = _default;
},{"./validate.js":1530}],1525:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.default)(b);
}

var _default = v1;
exports.default = _default;
},{"./rng.js":1522,"./stringify.js":1524}],1526:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _md = _interopRequireDefault(require("./md5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports.default = _default;
},{"./md5.js":1518,"./v35.js":1527}],1527:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.URL = exports.DNS = void 0;

var _stringify = _interopRequireDefault(require("./stringify.js"));

var _parse = _interopRequireDefault(require("./parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function _default(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.default)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
},{"./parse.js":1520,"./stringify.js":1524}],1528:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.default)(rnds);
}

var _default = v4;
exports.default = _default;
},{"./rng.js":1522,"./stringify.js":1524}],1529:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _sha = _interopRequireDefault(require("./sha1.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports.default = _default;
},{"./sha1.js":1523,"./v35.js":1527}],1530:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regex = _interopRequireDefault(require("./regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports.default = _default;
},{"./regex.js":1521}],1531:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

var _default = version;
exports.default = _default;
},{"./validate.js":1530}],1532:[function(require,module,exports){
/**
 * Fills a modal's body and footer with the outcome of copying a document (clone or duplicate).
 *
 * Built with DOM nodes rather than an HTML string, so document names land as text.
 *
 * @module DocumentCopyResultModal
 */

/**
 * A run of message text; `Strong` runs render bold.
 * @typedef {string | { Strong: string }} DocumentCopyResultTextRun
 */

/**
 * @typedef {object} DocumentCopyResultButton
 * @property {string} Label - The button text
 * @property {string} Icon - The Font Awesome icon class, e.g. `fa-times`
 * @property {string} ClassName - The Bulma button classes, e.g. `button is-link is-soft`
 * @property {string} Title - The button's tooltip
 * @property {(pEvent: MouseEvent) => void} onClick - Runs when the button is clicked
 */

/**
 * @typedef {object} DocumentCopyResult
 * @property {boolean} Succeeded - Picks the success or failure icon colour
 * @property {string} Title - The headline
 * @property {Array<DocumentCopyResultTextRun>} Message - The explanation under the headline
 * @property {string} Instruction - What the user should do next
 * @property {Array<DocumentCopyResultButton>} Buttons - The footer buttons, left to right
 */

/**
 * @param {string} pIconClassName - The full class list for the `<i>` element
 * @param {boolean} [pHidden] - Whether to hide the icon from assistive technology
 * @return {HTMLSpanElement}
 */
function createIcon(pIconClassName, pHidden)
{
	const tmpIconWrapper = document.createElement('span');
	tmpIconWrapper.className = 'icon';
	const tmpIcon = document.createElement('i');
	tmpIcon.className = pIconClassName;
	if (pHidden)
	{
		tmpIcon.setAttribute('aria-hidden', 'true');
	}
	tmpIconWrapper.appendChild(tmpIcon);
	return tmpIconWrapper;
}

/**
 * @param {string} pClassName
 * @param {Array<DocumentCopyResultTextRun>} pRuns
 * @return {HTMLParagraphElement}
 */
function createParagraph(pClassName, pRuns)
{
	const tmpParagraph = document.createElement('p');
	tmpParagraph.className = pClassName;
	for (const tmpRun of pRuns)
	{
		if (typeof tmpRun === 'string')
		{
			tmpParagraph.append(tmpRun);
		}
		else
		{
			const tmpStrong = document.createElement('strong');
			tmpStrong.textContent = (tmpRun.Strong === undefined || tmpRun.Strong === null) ? '' : String(tmpRun.Strong);
			tmpParagraph.appendChild(tmpStrong);
		}
	}
	return tmpParagraph;
}

/**
 * @param {DocumentCopyResultButton} pButton
 * @return {HTMLButtonElement}
 */
function createButton(pButton)
{
	const tmpButton = document.createElement('button');
	tmpButton.className = pButton.ClassName;
	tmpButton.type = 'button';
	tmpButton.title = pButton.Title;
	tmpButton.appendChild(createIcon(`fas fa-fw ${pButton.Icon}`, true));
	const tmpLabel = document.createElement('span');
	tmpLabel.textContent = pButton.Label;
	tmpButton.appendChild(tmpLabel);
	tmpButton.addEventListener('click', pButton.onClick);
	return tmpButton;
}

/**
 * Replace the contents of a modal's body and footer with a copy result.
 *
 * @param {HTMLElement} pBodyElement - The modal body container
 * @param {HTMLElement} pFooterElement - The modal footer container
 * @param {DocumentCopyResult} pResult - What to show
 * @return {void}
 */
function renderDocumentCopyResult(pBodyElement, pFooterElement, pResult)
{
	const tmpContainer = document.createElement('div');
	tmpContainer.className = 'container column is-12';

	const tmpHeadline = document.createElement('p');
	tmpHeadline.className = 'title is-5 has-text-centered p-2 mb-5';
	tmpHeadline.appendChild(createIcon(`fa fa-fw fa-circle-check ${pResult.Succeeded ? 'has-text-success' : 'has-text-danger'}`));
	const tmpHeadlineText = document.createElement('span');
	tmpHeadlineText.textContent = ` ${pResult.Title}`;
	tmpHeadline.appendChild(tmpHeadlineText);
	tmpContainer.appendChild(tmpHeadline);

	tmpContainer.appendChild(createParagraph('subtitle is-6 has-text-centered', pResult.Message));
	tmpContainer.appendChild(createParagraph('subtitle is-6 has-text-centered', [ pResult.Instruction ]));

	pBodyElement.innerHTML = '';
	pBodyElement.appendChild(tmpContainer);
	pFooterElement.innerHTML = '';
	for (const tmpButton of pResult.Buttons)
	{
		pFooterElement.appendChild(createButton(tmpButton));
	}
}

/**
 * What a successful copy tells the user to do next, and the footer buttons that go with it.
 *
 * With an opener: Close, then Open New Document. Without one (the page cannot open another document), the
 * instruction points to the forms list and the footer is a single Done.
 *
 * @param {() => void} fDismiss - Closes the modal
 * @param {?(pEvent: MouseEvent) => void} fOpenNewDocument - Opens the new document; runs before the modal closes
 * @return {{ Instruction: string, Buttons: Array<DocumentCopyResultButton> }}
 */
function createNewDocumentFollowUp(fDismiss, fOpenNewDocument)
{
	if (!fOpenNewDocument)
	{
		return {
			Instruction: 'To open it, go back to your forms list and sync. The new document will be listed there.',
			Buttons: [ { Label: 'Done', Icon: 'fa-check', ClassName: 'button is-link', Title: 'Close modal', onClick: () => fDismiss() } ],
		};
	}
	return {
		Instruction: 'Please click button below to open your new document or close this modal.',
		Buttons: [
			{ Label: 'Close', Icon: 'fa-times', ClassName: 'button is-link is-soft', Title: 'Close modal', onClick: () => fDismiss() },
			{
				Label: 'Open New Document',
				Icon: 'fa-external-link-alt',
				ClassName: 'button is-link',
				Title: 'Open new document',
				onClick: (pEvent) =>
				{
					fOpenNewDocument(pEvent);
					fDismiss();
				},
			},
		],
	};
}

module.exports = { renderDocumentCopyResult, createNewDocumentFollowUp };

},{}],1533:[function(require,module,exports){
/**
 * How a document's workflow state should read on screen.
 *
 * An approval workflow carries two names per state: `Status` is the hash it keys transitions off
 * (`InTest`, `Pending_DLE`, `Approved`), and `StateName` is the name authored for people ("In Test",
 * "Waiting for District Lab Engineer Approval", "Authorized in Sitemanager"). The panels label this
 * field "Status" to the user, so the authored name is the one that belongs there.
 *
 * The fallback is not decoration. A Draft is created by the API service without consulting the
 * approval workflow, so it carries a `Status` and no `StateName` at all - on LADOTD that is 818 of a
 * 6,000-document sample. Preferring `StateName` without falling back would blank every one of them.
 *
 * @module DocumentStateDisplay
 */

/** @param {any} pValue @return {string} the value as trimmed display text, '' when there is none. */
const asDisplayText = (pValue) => (pValue === undefined || pValue === null) ? '' : String(pValue).trim();

/**
 * The workflow state of a document, as it should be shown to a person.
 *
 * @param {Record<string, any>} pRecord - a document-shaped record carrying `StateName` and/or `Status`.
 * @return {string} the authored state name, else the raw status, else '' (never 'undefined').
 */
function resolveDocumentStateDisplay(pRecord)
{
	if (!pRecord || typeof pRecord !== 'object')
	{
		return '';
	}
	return asDisplayText(pRecord.StateName) || asDisplayText(pRecord.Status);
}

module.exports = { resolveDocumentStateDisplay, asDisplayText };

},{}],1534:[function(require,module,exports){
/**
 * HeadlightToastAdapter
 *
 * Pure, framework-free translation between the legacy object-first toast options
 * (`{ message, type: 'is-danger', ... }`) used across ~45 Headlight call sites and
 * the Pict-Section-Modal `toast(message, options)` API. Kept as a plain class (no
 * Pict/DOM dependencies) so it is unit-testable in isolation.
 *
 * Behaviors preserved from the former bulma-toast wrapper:
 *  - `is-*` type classes mapped to PSM's enum (info/success/warning/error)
 *  - single-toast (only one visible at a time) via handle bookkeeping
 *  - duplicate throttle (identical type+message within a short window is dropped)
 *  - HTML messages rendered (auto-detected, or forced via `allowHTML`)
 *
 * Added since: `sticky` toasts, which opt out of auto-dismiss, the throttle, and single-toast eviction.
 */

const _TYPE_MAP =
{
	'is-info': 'info',
	'is-success': 'success',
	'is-warning': 'warning',
	'is-danger': 'error',
	'is-error': 'error',
	// pass-through for callers already using PSM enum values
	'info': 'info',
	'success': 'success',
	'warning': 'warning',
	'error': 'error',
};

class HeadlightToastAdapter
{
	constructor(pOptions)
	{
		this._throttleWindowMS = (pOptions && typeof pOptions.ThrottleWindowMS === 'number') ? pOptions.ThrottleWindowMS : 1000;
		this._recent = {};          // key -> last-shown epoch ms
		this._activeHandles = [];   // outstanding PSM handles (single-toast bookkeeping)
	}

	mapType(pType)
	{
		return _TYPE_MAP[pType] || 'info';
	}

	looksLikeHTML(pMessage)
	{
		// Accept both primitive strings and boxed String objects (typeof 'object').
		if (typeof pMessage !== 'string' && !(pMessage instanceof String))
		{
			return false;
		}
		// RegExp.test coerces a boxed String to its primitive value.
		return /<[a-z][\s\S]*>/i.test(pMessage);
	}

	/**
	 * Translate legacy options into a PSM toast call.
	 * @param {object} pOptions - Legacy toast options ({ message, type, duration, position, dismissible, allowHTML, sticky }).
	 * @param {number} pNowMS - Current epoch ms (injected for testability).
	 * @returns {?{ message: string, sticky: boolean, options: object }} null when throttled or invalid.
	 */
	translate(pOptions, pNowMS)
	{
		if (!pOptions || !pOptions.message)
		{
			return null;
		}

		let tmpType = this.mapType(pOptions.type);
		const tmpSticky = (pOptions.sticky === true);

		// A sticky toast is a state indicator, not a notification: its owner locks the UI on the
		// assumption it is showing, so the duplicate throttle must not be able to swallow it.
		if (!tmpSticky)
		{
			const tmpKey = tmpType + '::' + pOptions.message;

			if (this._recent[tmpKey] && (pNowMS - this._recent[tmpKey]) < this._throttleWindowMS)
			{
				return null;
			}
			this._recent[tmpKey] = pNowMS;
		}

		let tmpAllowHTML = (typeof pOptions.allowHTML === 'boolean') ? pOptions.allowHTML : this.looksLikeHTML(pOptions.message);

		return (
			{
				message: pOptions.message,
				sticky: tmpSticky,
				options:
				{
					type: tmpType,
					duration: tmpSticky ? 0 : ((typeof pOptions.duration === 'number') ? pOptions.duration : 3000),
					position: pOptions.position || 'bottom-center',
					dismissible: (typeof pOptions.dismissible === 'boolean') ? pOptions.dismissible : true,
					allowHTML: tmpAllowHTML,
				},
			});
	}

	/**
	 * Single-toast bookkeeping: dismiss any outstanding non-sticky toast(s), then remember the new handle.
	 * Call with `null` to just clear the prior toast (before showing a new one), then again with
	 * the new handle to track it.
	 *
	 * Sticky handles survive this eviction. A sticky toast explains a UI the user cannot interact with,
	 * so the transient toasts that fire *during* that state must not take the explanation away.
	 * @param {?{ dismiss: function }} pHandle
	 * @param {boolean} [pSticky] - Exempt this handle from eviction until releaseHandle takes it back.
	 */
	trackHandle(pHandle, pSticky)
	{
		const tmpRetained = [];
		while (this._activeHandles.length > 0)
		{
			const tmpPrev = this._activeHandles.pop();
			if (!tmpPrev)
			{
				continue;
			}
			if (tmpPrev.Sticky)
			{
				tmpRetained.push(tmpPrev);
				continue;
			}
			if (tmpPrev.Handle && typeof tmpPrev.Handle.dismiss === 'function')
			{
				tmpPrev.Handle.dismiss();
			}
		}
		this._activeHandles = tmpRetained;
		if (pHandle)
		{
			this._activeHandles.push({ Handle: pHandle, Sticky: Boolean(pSticky) });
		}
	}

	/**
	 * Dismiss a specific handle and stop tracking it. Sticky handles are never evicted automatically,
	 * so their owner hands them back here when the state they describe ends.
	 * @param {?{ dismiss: function }} pHandle
	 */
	releaseHandle(pHandle)
	{
		if (!pHandle)
		{
			return;
		}
		this._activeHandles = this._activeHandles.filter((pEntry) => pEntry.Handle !== pHandle);
		if (typeof pHandle.dismiss === 'function')
		{
			pHandle.dismiss();
		}
	}
}

module.exports = HeadlightToastAdapter;

},{}],1535:[function(require,module,exports){
module.exports={
    "NavBar": {
        "hideNavbar": false,
        "colorClass": "is-dark",
        "location": "bottom",
        "Brand": {
            "id": "HeadlightPanels-NavBar-Brand",
            "name": "Approval Actions",
            "displayName": "Draft",
            "hideIcon": null,
            "iconClass": "fa-pencil has-text-text-75",
            "buttonClass": "is-dark is-ghost has-text-white",
            "wrapperClass": "has-background-grey",
            "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Status')"
        },
        "Buttons": [
            {
                "id": "HeadlightPanels-NavBar-CurrentSamples-Button",
                "name": "Current Samples",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-qrcode",
                "buttonClass": "is-dark",
                "wrapperClass": "is-hidden",
                "onclick": "_Pict.views.HeadlightPaneSamples.openCurrentSamplesTab(event)"
            },
            {
                "id": "HeadlightPanels-NavBar-Solver-Button",
                "name": "Solver Logs",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-calculator",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Solver')"
            },
            {
                "id": "HeadlightPanels-NavBar-Validations-Button",
                "name": "Validation Logs",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-exclamation-triangle",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Validations')"
            },
            {
                "id": "HeadlightPanels-NavBar-Download-Button",
                "name": "Download",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-download",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPaneNavigation.toggleDownloadDropdown(event)"
            },
            {
                "id": "HeadlightPanels-NavBar-FullScreen-Button",
                "name": "screenResize",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-up-right-and-down-left-from-center",
                "buttonClass": "is-dark",
                "wrapperClass": "is-hidden-mobile is-hidden-tablet-only",
                "onclick": "_Pict.providers.DocumentProvider.handleScreenResize()"
            },
            {
                "id": "HeadlightPanels-NavBar-Save-Button",
                "name": "save",
                "displayName": "Save",
                "hideIcon": null,
                "iconClass": "fa-save",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "showAutoSaveStatus": true,
                "onclick": "_Pict.providers.DocumentProvider.handleSave()"
            },
            {
                "id": "HeadlightPanels-NavBar-Actions-Button",
                "name": "actions",
                "displayName": null,
                "hideIcon": null,
                "iconClass": "fa-bars",
                "buttonClass": "is-dark",
                "wrapperClass": null,
                "onclick": "_Pict.views.HeadlightPanels.handlePanelToggle('Navigation')"
            }
        ]
    },
    "NavigationList": [],
    "PanelList": [
        {
            "location": "right",
            "name": "navigation",
            "displayName": "Actions",
            "iconClass": "fa-check-list",
            "view": "HeadlightPaneNavigation"
        },
        {
            "location": "right",
            "name": "settings",
            "displayName": "Settings",
            "iconClass": "fa-cog",
            "view": "HeadlightPaneSettings",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Settings', 'open')"
        },
        {
            "location": "left",
            "name": "status",
            "displayName": "Approval Actions",
            "iconClass": "fa-pencil",
            "view": "HeadlightPaneStatus",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Status')"
        },
        {
            "location": "left",
            "name": "solver",
            "displayName": "Solver Logs",
            "iconClass": "fa-calculator",
            "view": "HeadlightPaneSolver"
        },
        {
            "location": "left",
            "name": "validations",
            "displayName": "Validation Logs",
            "iconClass": "fa-exclamation-triangle",
            "view": "HeadlightPaneValidations"
        },
        {
            "location": "right",
            "name": "profile",
            "displayName": "User Profile",
            "iconClass": "fa-user",
            "view": "HeadlightPaneProfile",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Profile')"
        },
        {
            "location": "right",
            "name": "secret",
            "displayName": "Secrets",
            "iconClass": "fa-person-to-portal",
            "view": "HeadlightPaneSecret"
        },
        {
            "location": "left",
            "name": "bridges",
            "displayName": "Bridges",
            "iconClass": "fa-bridge",
            "view": "HeadlightPaneBridges"
        },
        {
            "location": "left",
            "name": "observations",
            "displayName": "Observations",
            "iconClass": "fa-images",
            "view": "HeadlightPaneObservations",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Observations')"
        },
        {
            "location": "right",
            "name": "observationdetails",
            "displayName": "Observation Details",
            "iconClass": "fa-image",
            "view": "ObservationDetails"
        },
        {
            "location": "left",
            "name": "observationannotation",
            "displayName": "Observation Annotation",
            "iconClass": "fa-image",
            "view": "ObservationAnnotation"
        },
        {
            "location": "left",
            "name": "observationsubimageselector",
            "displayName": "Create Note",
            "iconClass": "fa-sticky-note",
            "view": "ObservationSubImageSelector"
        },
        {
            "location": "left",
            "name": "testinstancewizard",
            "displayName": "Add Test",
            "iconClass": "fa-flask-vial",
            "view": "TestInstanceWizard"
        },
        {
            "location": "left",
            "name": "qrpanel",
            "displayName": "Scanning",
            "iconClass": "fa-qrcode",
            "view": "QRPanel",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('QRPanel')"
        },
        {
            "location": "right",
            "name": "pictsectionopenseadragonannotationselector",
            "displayName": "Annotation Comments",
            "iconClass": "fa-comments",
            "view": "PictSectionOpenSeaDragonAnnotationSelector"
        },
        {
            "location": "right",
            "name": "academyview",
            "displayName": "Academy",
            "iconClass": "fa-graduation-cap",
            "view": "AcademyView"
        },
        {
            "location": "left",
            "name": "documents",
            "displayName": "Documents",
            "iconClass": "fa-files",
            "view": "HeadlightPaneDocuments",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Documents')"
        },
        {
            "location": "left",
            "name": "documentdetails",
            "displayName": "Document Details",
            "iconClass": "fa-documents",
            "view": "DocumentDetails"
        },
        {
            "location": "left",
            "name": "inspection",
            "displayName": "Inspection",
            "iconClass": "fa-building-magnifying-glass",
            "view": "Inspection",
            "navigationHandler": "_Pict.views.HeadlightPaneNavigation.handleInspectionPanelToggle(event)"
        },
        {
            "location": "left",
            "name": "samples",
            "displayName": "Samples",
            "iconClass": "fa-vial",
            "view": "HeadlightPaneSamples",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Samples')"
        },
        {
            "location": "right",
            "name": "sampledetails",
            "displayName": "Sample Details",
            "iconClass": "fa-vial",
            "view": "SampleDetails",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('SampleDetails')"
        },
        {
            "location": "right",
            "name": "projectfilesearch",
            "displayName": "Project Files",
            "iconClass": "fa-files",
            "view": "ProjectFileSearch",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch')"
        },
        {
            "location": "right",
            "name": "comments",
            "displayName": "Comments",
            "iconClass": "fa-comment",
            "view": "CommentCurrent",
            "navigationHandler": "_Pict.views.HeadlightPanels.handlePanelToggle('Comments')"
        }
        
    ],
    "CurrentStatus": {
        "status": "Draft",
        "statusClass": "has-text-text-75",
        "statusIcon": "fa-pencil"
    },
    "PanelLocations": {
        "left": { 
            "name": "left",
            "displayName": "Left",
            "animateIn": "animate__slideInLeft", 
            "animateOut": "animate__slideOutLeft", 
            "animateDuration": 500 
        },
        "right": { 
            "name": "right",
            "displayName": "Right",
            "animateIn": "animate__slideInRight", 
            "animateOut": "animate__slideOutRight", 
            "animateDuration": 500 
        }
    },
    "PanelOptions": {
        "LeftyMode": false,
        "Context": "",
        "HelpText": true
    }
}

},{}],1536:[function(require,module,exports){
const libFableService = require('fable-serviceproviderbase');

class HeadlightPanelsFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & { views: any, ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }} */
		this.fable;

		this.serviceType = 'HeadlightPanels';
		this.isPhoneDevice = false; // This will be set later based on the device type
	}

	// TODO: Add Pin state functions (need to adjust the HeadlightPanels view to support this by data state)
	// TODO: Add color options for the custom panel headers
	// TODO: Add a subtitle option for the custom panel headers

	/**
	 * This function is used to check if the HeadlightPanels view is available.
	 * @return {boolean}
	 */
	checkPanels()
	{
		return this.fable.views.hasOwnProperty('HeadlightPanels');
	}

	/**
	 ********** LEFT **********
	*/

	/**
	 * This function is used to toggle the left panel.
	 * @return {void}
	 */
	leftPanelToggle()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the right panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('right', 'close');
		}
		// toggle the left panel
		return this.fable.views.HeadlightPanels.togglePanel('left');
	}

	/**
	 * This function is used to show the left panel.
	 * @return {void}
	 */
	leftPanelShow()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the right panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('right', 'close');
		}
		// toggle the left panel
		return this.fable.views.HeadlightPanels.togglePanel('left', 'open');
	}

	/**
	 * This function is used to show the left custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	leftCustomPanelShow(pTitle)
	{
		this.leftPanelShow();
		this.fable.views.HeadlightPaneCustomLeft.render();
		this.leftPanelSetCustomTitle(pTitle);
	}

	/**
	 * This function is used to hide the left panel.
	 * @return {void}
	 */
	leftPanelHide()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		this.leftPanelResetCustomWidth();
		return this.fable.views.HeadlightPanels.togglePanel('left', 'close');
	}

	/**
	 * This function is used to set the title of the left custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	leftPanelSetCustomTitle(pTitle)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.ContentAssignment.assignContent('#HeadlightPanels-CustomPanel-Left-Header-Title', pTitle || 'Left Panel');
	}

	/**
	 * This function is used to get the address of the left custom panel content.
	 * @return {string}
	 */
	leftPanelCustomContentAddress()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return '#HeadlightPanels-CustomPanel-Left-Content';
	}

	/**
	 * This function is used to toggle the pin state of the left panel.
	 * @param {string} state - The state to set the pin to
	 * @return {void}
	 */
	leftPanelTogglePinState(state)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.togglePanelPinState('left', null, state);
	}

	/**
	 * This function is used to set the width of the left panel.
	 * @param {number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	leftPanelCustomWidth(pPercentage)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.setPanelCustomWidth('left', pPercentage);
	}

	/**
	 * This function is used to reset the width of the left panel.
	 * @return {void}
	 */
	leftPanelResetCustomWidth()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.resetPanelCustomWidth('left');
	}


	/**
	 ********** RIGHT **********
	*/

	/**
	 * This function is used to toggle the right panel.
	 * @return {void}
	 */
	rightPanelToggle()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the left panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('left', 'close');
		}
		// toggle the right panel
		return this.fable.views.HeadlightPanels.togglePanel('right');
	}

	/**
	 * This function is used to show the right panel.
	 * @return {void}
	 */
	rightPanelShow()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		// if the device is a phone, we have to close the left panel first because we only allow one panel to be open at a time
		if (this.isPhoneDevice)
		{
			this.fable.views.HeadlightPanels.togglePanel('left', 'close');
		}
		// toggle the right panel
		return this.fable.views.HeadlightPanels.togglePanel('right', 'open');
	}

	/**
	 * This function is used to show the right custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	rightCustomPanelShow(pTitle)
	{
		this.rightPanelShow();
		this.fable.views.HeadlightPaneCustomRight.render();
		this.rightPanelSetCustomTitle(pTitle);
	}

	/**
	 * This function is used to hide the right panel.
	 * @return {void}
	 */
	rightPanelHide()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		this.rightPanelResetCustomWidth();
		return this.fable.views.HeadlightPanels.togglePanel('right', 'close');
	}

	/**
	 * This function is used to set the title of the right custom panel.
	 * @param {string} pTitle - The title of the custom panel
	 * @return {void}
	 */
	rightPanelSetCustomTitle(pTitle)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.ContentAssignment.assignContent('#HeadlightPanels-CustomPanel-Right-Header-Title', pTitle || 'Right Panel');
	}

	/**
	 * This function is used to get the address of the right custom panel content.
	 * @return {string}
	 */
	rightPanelCustomContentAddress()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return '#HeadlightPanels-CustomPanel-Right-Content';
	}

	/**
	 * This function is used to toggle the pin state of the right panel.
	 * @param {string} state - The state to set the pin to
	 * @return {void}
	 */
	rightPanelTogglePinState(state)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.togglePanelPinState('right', null, state);
	}

	/**
	 * This function is used to set the width of the right panel.
	 * @param {number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	rightPanelCustomWidth(pPercentage)
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.setPanelCustomWidth('right', pPercentage);
	}

	/**
	 * This function is used to reset the width of the right panel.
	 * @return {void}
	 */
	rightPanelResetCustomWidth()
	{
		if (!this.checkPanels())
		{
			this.log.error('HeadlightPanels not found');
			return;
		}
		return this.fable.views.HeadlightPanels.resetPanelCustomWidth('right');
	}

	/**
	 ********** Content Highlighting **********
	 */

	/**
	 * This function is used to apply a UI highlight to the given selector or passed content area.
	 * @param {HTMLElement|string} pSelector - The selector or content area to apply the highlight to
	 */
	applyUIHighlight(pSelector)
	{
		// always clear any existing highlights first
		this.clearUIHighlights();

		if (pSelector instanceof HTMLElement)
		{
			pSelector.classList.add('panels-ui-highlight');
			return;
		}
		else if (Array.isArray(pSelector))
		{
			Array.from(document.querySelectorAll(pSelector)).forEach(
				(el) => el.classList.add('panels-ui-highlight'),
			);
		}
		else
		{
			document.querySelector(pSelector).classList.add('panels-ui-highlight');
		}
	}

	/**
	 * This function is used to clear all UI highlights.
	 */
	clearUIHighlights()
	{
		Array.from(document.querySelectorAll('.panels-ui-highlight')).forEach(
			(el) => el.classList.remove('panels-ui-highlight'),
		);
	}

	/**
	 * This function constructs a url for opening academy content.
	 * @param {string} content - The content to open
	 */
	openAcademyContent(content)
	{
		if (content?.includes('headlight.com'))
		{
			this.fable.views.AcademyView.openWithURL(content);
		}
		else if (window.location.href.includes('localhost'))
		{
			this.fable.views.AcademyView.openWithURL( 'https://fieldbook.qa.headlight.com/Assets/templates/documentation/' + content);
		}
		else
		{
			//@ts-ignore
			this.fable.views.AcademyView.openWithURL(_Pict?.HeadlightRestClient?.serverURL?.replace('/1.0/', '/Assets/templates/documentation/') + content);
		}
	}

	/**
	 * Check if the device is a phone based on user agent or screen size.
	 * @return {boolean}
	 */
	checkIfPhoneDevice()
	{
		// Check if the device is a phone based on the user agent or screen size
		const isPhone = /Mobi|Android/i.test(navigator.userAgent) || screen.width < 744;
		this.setIsPhoneDevice(isPhone);
		return isPhone;
	}

	/**
	 * Get if the device is a phone or not.
	 * @return {boolean}
	 */
	getIsPhoneDevice()
	{
		return this.isPhoneDevice;
	}

	/**
	 * Set if the device is a phone or not.
	 * @param {boolean} pIsPhone
	 * @return {boolean}
	 */
	setIsPhoneDevice(pIsPhone)
	{
		this.isPhoneDevice = pIsPhone;
		this.log.info(`HeadlightPanelsFableService: Device set to ${pIsPhone ? 'phone' : 'desktop'}`);
		return this.isPhoneDevice;
	}
}

module.exports = HeadlightPanelsFableService;
module.exports.default_configuration = {};

},{"fable-serviceproviderbase":438}],1537:[function(require,module,exports){
module.exports = ({
	ViewIdentifier: 'HeadlightPanels',
	DefaultRenderable: 'HeadlightPanels',
	DefaultDestinationAddress: '#HeadlightPanels-Container',
	CSS: /*css*/`
		#HeadlightPanels-Navbar-Brand-Container {
			display: flex;
		}

		/* Auto-save indicator — sits immediately left of the navbar Save button. Quiet by design:
		   it is ambient status, not a notification. */
		.hl-autosave-status-container {
			display: inline-flex;
			align-items: center;
			margin-right: 0.5rem;
		}
		/* Below Bulma's desktop breakpoint .navbar-item is display: block, which drops the status onto the text baseline. */
		.navbar-item:has(> .hl-autosave-status-container) {
			display: flex;
			align-items: center;
		}
		.hl-autosave-status {
			display: inline-flex;
			align-items: center;
			gap: 0.25rem;
			font-size: 0.75rem;
			line-height: 1;
			white-space: nowrap;
			opacity: 0.65;
			transition: opacity 200ms ease-in-out;
		}
		.hl-autosave-status .icon.is-small {
			font-size: 0.75rem;
		}
		.hl-autosave-status.is-retrying,
		.hl-autosave-status.is-suspended,
		.hl-autosave-status.is-offline {
			opacity: 1;
		}
		.hl-autosave-status.is-saved.is-flashing {
			animation: hl-autosave-flash 2s ease-in-out 1;
		}
		@keyframes hl-autosave-flash {
			0% { opacity: 1; }
			40% { opacity: 1; }
			100% { opacity: 0.65; }
		}
		@media (prefers-reduced-motion: reduce) {
			.hl-autosave-status.is-saved.is-flashing { animation: none; }
		}
		/* Auto-save preferences in the Settings panel. The seconds field is fixed-width and the row wraps
		   rather than growing, so opening this panel never changes its width. */
		.hl-autosave-interval {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 0.4rem;
			font-size: 0.85rem;
			min-width: 0;
		}
		.hl-autosave-interval-input {
			flex: 0 0 auto;
			width: 5.5rem;
		}
		.hl-autosave-note {
			font-size: 0.8rem;
			opacity: 0.7;
		}
		/* Approval actions are inert while a save (manual or auto) is in flight. pointer-events is what
		   actually blocks the click — the handler is bound with onclick, not a disabled attribute.
		   The same treatment covers a Settings row the form manifest has taken out of the user's hands. */
		.panel-block.is-disabled,
		a.panel-block.is-disabled {
			pointer-events: none;
			cursor: not-allowed;
			opacity: 0.5;
		}
		/* An approval action is in flight. The form stays readable on purpose — the user should still be
		   able to see what they just submitted — so this dims and de-fangs rather than covering with a
		   scrim. Scoped to the body because Select2 and flatpickr portal their popups outside the form.
		   The inert attribute is what actually blocks the keyboard; pointer-events only stops the mouse. */
		body.hl-approval-busy {
			cursor: progress;
		}
		body.hl-approval-busy #Headlight-Document-Form {
			pointer-events: none;
			opacity: 0.55;
			transition: opacity 150ms ease-in-out;
		}
		body.hl-approval-busy .select2-container--open,
		body.hl-approval-busy .flatpickr-calendar.open {
			display: none;
		}
		@media (prefers-reduced-motion: reduce) {
			body.hl-approval-busy #Headlight-Document-Form { transition: none; }
		}
		`,
	Templates:
		[
			{
				Hash: 'HeadlightPanels-Template',
				Template: /*html*/`
				<div id="HeadlightPanels-LeftPanel" class="hl-panel-wrapper hl-panel-wrapper-left animate__animated animate__faster"></div>
				<div id="HeadlightPanels-RightPanel" class="hl-panel-wrapper hl-panel-wrapper-right animate__animated animate__faster"></div>
				<nav id="HeadlightPanels-NavBar" class="navbar is-flex is-fixed-{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.location~} {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.colorClass~}">
					<span id="HeadlightPanels-Navbar-Brand-Container">{~T:HeadlightPanels-NavBar-Brand~}</span>
					<div id="HeadlightPanels-Navbar-Button-Container" class="navbar-end">{~T:HeadlightPanels-NavBar-Button-Wrapper~}</div>
				</nav>
				<aside id="HeadlightPanels-FullScreenModal-Container"></aside>`,
			},
			{
				'Hash': 'HeadlightPanels-NavBar-Brand',
				'Template': /*html*/`
				<div class="navbar-brand {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.wrapperClass~}">
					<button 
						id="{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.id~}" 
						type="button" 
						class="button {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.buttonClass~}" 
						name="{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.name~}" 
						onclick="{~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.onclick~}"
					>
						<span class="icon {~Hide:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.hideIcon~}">
							<i id="HeadlightPanels-NavBar-Brand-Icon" class="fas fa-fw {~D:Pict.settings.HeadlightPanels.Configuration.NavBar.Brand.iconClass~}"></i>
						</span>
						<span id="HeadlightPanels-NavBar-Brand-Text" title="{~DocumentState:AppData.DocumentData.ReportData~}">{~DocumentState:AppData.DocumentData.ReportData~}</span>
					</button>

				</div>`,
			},
			{
				Hash: 'HeadlightPanels-NavBar-Button-Wrapper',
				Template: /*html*/`{~TS:HeadlightPanels-NavBar-Button:Pict.settings.HeadlightPanels.Configuration.NavBar.Buttons~}`,
			},
			{
				Hash: 'HeadlightPanels-NavBar-Button',
				Template: /*html*/`
				<div class="navbar-item {~D:Record.wrapperClass~}">
					{~NE:Record.showAutoSaveStatus^<span id="HeadlightPanels-Navbar-AutoSaveStatus-Container" class="hl-autosave-status-container"></span>~}
					<button id="{~D:Record.id~}" type="button" class="button {~D:Record.buttonClass~}" name="{~D:Record.name~}" onclick="{~D:Record.onclick~}">
						<span class="icon {~Hide:Record.hideIcon~}">
							<i id="{~D:Record.id~}-Icon" class="fas fa-fw {~D:Record.iconClass~}"></i>
						</span>
						{~If:Record.displayName~}
					</button>
				</div>`,
			},
			{
				// Auto-save indicator. Deliberately not a toast: a notification every 90 seconds trains
				// users to dismiss notifications. StatusSlot is empty whenever auto-save is off or the
				// document is not editable, which renders nothing at all.
				Hash: 'HeadlightPanels-NavBar-AutoSaveStatus',
				Template: /*html*/`{~TS:HeadlightPanels-NavBar-AutoSaveStatus-Content:AppData.AutoSave.StatusSlot~}`,
			},
			{
				Hash: 'HeadlightPanels-NavBar-AutoSaveStatus-Content',
				Template: /*html*/`
				<span class="hl-autosave-status {~D:Record.StateClass~} {~D:Record.FlashClass~}" role="status" aria-live="polite" title="{~D:Record.Tooltip~}">
					<span class="icon is-small">
						<i class="fas fa-fw {~D:Record.IconClass~}" aria-hidden="true"></i>
					</span>
					<span class="hl-autosave-status-label is-hidden-mobile">{~D:Record.Label~}</span>
				</span>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ButtonGroup',
				Template: /*html*/`
				<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event)">
					<span class="icon">
						<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
					</span>
				</button>
				<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
					<span class="icon">
						<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
					</span>
				</button>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ModeBanner-Observations',
				Template: /*html*/`
				<div data-panel-mode-show-if="add-to-set" class="notification is-radiusless add-mode-banner px-4 py-2">
					<div class="add-mode-banner-content mr-5">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<strong class="add-mode-message">Adding Observations to <span id="HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target" class="add-mode-title">{~T:HeadlightPanels-ObservationPanel-BannerTarget~}</span></strong>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ModeBanner-Samples',
				Template: /*html*/`
				<div data-panel-mode-show-if="add-to-set" class="notification is-radiusless add-mode-banner px-4 py-2">
					<div class="add-mode-banner-content mr-5">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<strong class="add-mode-message">Adding Samples to <span id="HeadlightPanels-SamplePanel-Sample-Header-Mode-Target" class="add-mode-title">Sample Selector</strong>
					</div>
					<button type="button" class="delete" onclick="_Pict.views.HeadlightPaneSamples.clearSamplePanelTarget()"></button>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Header-ModeBanner-Documents',
				Template: /*html*/`
				<div data-panel-mode-show-if="add-to-inspection" class="notification is-radiusless add-mode-banner px-4 py-2">
					<div class="add-mode-banner-content mr-5">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<strong class="add-mode-message">Adding Documents to <span id="HeadlightPanels-DocumentPanel-Document-Header-Mode-Target" class="add-mode-title">{~T:HeadlightPanels-DocumentPanel-BannerTarget~}</span></strong>
					</div>
				</div>`,
			},
			{
				// This is a generic modal container to be used for any full screen modal content by other views as needed.
				// Treat this as the ONE modal to rule them all.
				Hash: 'HeadlightPanels-FullScreenModal',
				Template: /*html*/`
				<div id="HeadlightPanels-FullScreenModal" class="modal is-active">
					<div class="modal-background"></div>
					<div class="modal-content">
						<div class="box">
							<p>
								<span class="icon">
									<i class="fa fa-fw fa-circle-question"></i>
								</span>
								<span>No content has been set here yet.</span>
							</p>
						</div>
					</div>
					<button class="modal-close is-large" aria-label="close" onclick="_Pict.views.HeadlightPanels.togglePanelFullScreenModal('close')"></button>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-InDevelopmentMessage',
				Template: /*html*/`
				<div class="notification is-warning is-soft has-text-centered m-4">
					<span class="icon">
						<i class="fas fa-fw fa-tools has-text-warning" aria-hidden="true"></i>
					</span>
					<span class="icon-text">This feature is still in development and is not fully available at this time.</span>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'HeadlightPanels',
				TemplateHash: 'HeadlightPanels-Template',
				ContentDestinationAddress: '#HeadlightPanels-Container',
			},
			{
				RenderableHash: 'HeadlightPanels-NavBar-Brand',
				TemplateHash: 'HeadlightPanels-NavBar-Brand',
				ContentDestinationAddress: '#HeadlightPanels-Navbar-Brand-Container',
			},
			{
				RenderableHash: 'HeadlightPanels-NavBar-Button-Wrapper',
				TemplateHash: 'HeadlightPanels-NavBar-Button-Wrapper',
				ContentDestinationAddress: '#HeadlightPanels-Navbar-Button-Container',
			},
			{
				RenderableHash: 'HeadlightPanels-ObservationPanel',
				TemplateHash: 'HeadlightPanels-ObservationPanel',
				ContentDestinationAddress: '#HeadlightPanels-ObservationPanel',
			},
			{
				RenderableHash: 'HeadlightPanels-ObservationPanel-Included',
				TemplateHash: 'HeadlightPanels-ObservationPanel-Included',
				ContentDestinationAddress: '#HeadlightPanels-ObservationPanel-Included-Content',
			},
			{
				RenderableHash: 'HeadlightPanels-ObservationPanel-Detail',
				TemplateHash: 'HeadlightPanels-ObservationPanel-Detail',
				ContentDestinationAddress: '#HeadlightPanels-ObservationPanel-Detail-Content',
			},
			{
				RenderableHash: 'HeadlightPanels-FullScreenModal',
				TemplateHash: 'HeadlightPanels-FullScreenModal',
				ContentDestinationAddress: '#HeadlightPanels-FullScreenModal-Container',
			},
			{
				RenderableHash: 'ObservationDetails-FullScreenModal',
				TemplateHash: 'ObservationDetails-FullScreenModal',
				DestinationAddress: '#HeadlightPanels-FullScreenModal-Container',
				RenderType: 'replace',
			},
		],
});

},{}],1538:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class AcademyView extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.settings =
		{
			url: '',
		};
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		this.pict.HeadlightPanels.rightPanelCustomWidth(40);
		this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		return super.onAfterRender(pRenderable);
	}

	/**
	 * This is a test
	 */
	openWithURL(url)
	{
		this.settings.url = url;
		this.pict.HeadlightPanels.leftPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.leftPanelHide();
		this.pict.views.HeadlightPanels.handlePanelToggle('AcademyView', 'open');
	}

	resetAndClose()
	{
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelResetCustomWidth();
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
	}

	toggleWidth()
	{
		const toggleEl = this.pict.ContentAssignment.getElement('#split-toggle-icon')?.[0];
		const animate = (el)=>
		{
			el.classList.add('fa-flip');
			setTimeout(()=>
			{
				el.classList.remove('fa-flip');
			}, 500);
		};
		if (toggleEl?.classList?.contains('fa-flip-horizontal'))
		{
			animate(toggleEl);
			toggleEl.classList.remove('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(60);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		}
		else
		{
			animate(toggleEl);
			toggleEl.classList.add('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(40);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelTogglePinState('pin');
		}
	}
}

module.exports = AcademyView;

module.exports.default_configuration =
{
	ViewIdentifier: 'AcademyView',
	DefaultRenderable: 'AcademyView',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'AcademyView-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-AcademyViewPanel" class="panel is-active">
				<p id="HeadlightPanels-AcademyViewPanel-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-left hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.AcademyView.resetAndClose()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button mr-2" class="is-pulled-right" aria-label="expand" title="Resize content" onclick="_Pict.views.AcademyView.toggleWidth()">
						<span class="icon">
							<i class="fas fa-fw fa-table-layout fa-flip-horizontal" aria-hidden="true" id="split-toggle-icon"></i>
						</span>
					</button>
					<span class="icon ml-5">
						<i id="HeadlightPanels-AcademyView-Header-Icon" class="fas fa-fw fa-graduation-cap" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-AcademyView-Header-Title" class="mr-3">Academy</span>
				</p>
				<div id="HeadlightPanels-AcademyView-Content">
					{~T:AcademyView-Content:Pict.views.AcademyView.settings~}
				</div>
			</article>`,
		},
		{
			Hash: 'AcademyView-Content',
			Template: /*html*/`
			<iframe class="has-background-text-40" style="width: 100%; height: 80vh;" src="{~D:Record.url~}" />`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'AcademyView',
			TemplateHash: 'AcademyView-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'AcademyView-Content',
			TemplateHash: 'AcademyView-Content',
			DestinationAddress: '#HeadlightPanels-AcademyView-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":733}],1539:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
* @typedef {Object} CommentResult
* @property {number} IDComment
* @property {number} CreatingIDUser
* @property {string} Comment
* @property {string} Date
* @property {number} IsCreatingUser
* @property {Array<CommentResult>} [Children]
* @property {Object} [CreatingUserData]
* @property {string} [CreatingUserData.NameFirst]
* @property {string} [CreatingUserData.NameLast]
* @property {string} [_RowID]
*/

class CommentCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialResultsLoaded = false;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'Date',
			SortDirection: 'DESC',
		};
		this.CurrentSearchEntity = '';
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		this.CurrentSearchFilters.IDDocument = this.AppData?.DocumentData?.ReportData?.IDDocument;
		if (pCallback)
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// if we don't have results, fetch them
		if (!this.initialResultsLoaded)
		{
			this.initialResultsLoaded = true;
			this.fetchComments(null, null, null);
		}
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method fetches all comments.
	 * @param {Event} event - The event that triggered the search.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @param {boolean} pIsChild - Whether the row is a child row.
	 * @return {Promise<void>}
	 * @async
	 */
	async fetchComments(event, pRowID, pIsChild)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// if new comment container exists
		if (document.getElementById('CommentCurrent-Add-Comment-Container'))
		{
			// hide add new comment container
			document.getElementById('CommentCurrent-Add-Comment-Container').classList.add('is-hidden');
		}
		// collapse the filter panel to get out the way of the results
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('CommentCurrentFilters', 'close');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('CommentCurrent-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// TODO: this should probably be moved to a provider but keeping it here for now because it works
		/**
		 * @callback GetCommentStructureCallback
		 * @param {CommentResult[]|any} pResult
		 * @return {void}
		 */
		/**
		 * Fetches the comment structure and updates the UI.
		 * @param {string|null} pRowID
		 * @param {boolean|null} pIsChild
		 * @param {Event|null} event
		 * @return {Promise<void>}
		 */
		this.pict.providers.CommentProvider.getCommentStructure(this.CurrentSearchFilters.IDCustomer, this.CurrentSearchFilters.IDDocument, this.AppData?.DocumentData?.ReportData?.Comments || [],
			/** @type {GetCommentStructureCallback} */
			(pResult) =>
			{
				if (!Array.isArray(pResult))
				{
					// Render comment results template (non-blocking, no side effects here)
					this.pict.views.CommentCurrent.renderAsync('CommentCurrent', '#CommentCurrent-Entry-Container', false, false, () =>
					{
						try
						{
							if (this.CommentCurrentResultsCallback)
							{
									// eslint-disable-next-line new-cap
									this.CommentCurrentResultsCallback(this.CurrentSearchResults);
							}
							else
							{
									this.updateWithResults(/** @type {CommentResult[]} */(pResult), pRowID, pIsChild);
							}
						}
						catch (innerError)
						{
								this.pict.log.error('Error in renderAsync callback:', innerError);
						}
					},
					);
				}
				else
				{
					this.updateWithResults(/** @type {CommentResult[]} */(pResult), pRowID, pIsChild);
				}
			},
		);
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setCommentResultsCallback((pResults) => { console.log(pResults); });
	 */
	setCommentCurrentResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.CommentCurrentResultsCallback = pCallback;
	}

	/**
	 * This method updates the IsCreatingUser property for each comment
	 * in the results to display edit and delete buttons correctly.
	 * @param {CommentResult[]} comments
	 * @return {void}
	 */
	updateIsCreatingUser(comments)
	{
		comments.forEach((comment) =>
		{
			comment.IsCreatingUser = (this.pict.AppData.CurrentUser.UserID === comment.CreatingIDUser) ? 1 : 0;

			if (Array.isArray(comment.Children) && comment.Children.length > 0)
			{
				this.updateIsCreatingUser(comment.Children); // recursive call
			}
		});
	}

	/**
	 * This method updates the results/UI based on new results and total count passed in.
	 * @param {Array} pResults - The results to update with.
	 * @param {string} [pRowID] - The ID of the row to update.
	 * @param {boolean} [pIsChild] - Whether the row is a child row.
	 * @return {void}
	 */
	updateWithResults(pResults, pRowID, pIsChild)
	{
		try
		{
			// update our results list
			this.CurrentSearchResults = pResults;
			// check if the current user is the same as the user who created the comment
			this.updateIsCreatingUser(this.CurrentSearchResults);
			// display results in descending order by updated date
			this.CurrentSearchResults.sort((a, b) =>
			{
				const dateA = new Date(a.Date);
				const dateB = new Date(b.Date);
				return dateB.getTime() - dateA.getTime(); // Sort in descending order
			});

			const pTotalCount = pResults?.length || 0;

			// update the total possible count so we can calculate the total pages
			this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalCount / this.CurrentSearchFilters.PageSize);
			// render the search results view
			this.pict.views.CommentCurrent.renderAsync('CommentCurrent-Results', '#CommentCurrent-Results-Container', false, () =>
			{
				// render the pagination buttons
				this.pict.views.CommentCurrent.renderAsync('CommentCurrent-Pagination', '#CommentCurrent-Pagination-Container', false, () =>
				{
					this.log.info('Comment Search Pagination rendered');
				});
				// if there is a callback function, call it
				if (this.CommentCurrentResultsCallback)
				{
					// eslint-disable-next-line new-cap
					this.CommentCurrentResultsCallback(this.CurrentSearchResults);
				};
			});
		}
		catch (outerError)
		{
			this.pict.log.error('Failed to update with comment results:', outerError);
		}
	}

	/**
	 * This method adds a new comment.
	 * @param {Event} [event] - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	addNewComment(event)
	{
		if (!this.pict.AppData.DocumentData.ReportData.IDDocument)
		{
			this.log.error(`No Document; can't add comment to document that doesn't exist: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Document; can't add comment to document that doesn't exist: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the add comment button
		if (event)
		{
			// if editable container exists
			if (document.getElementById('CommentCurrent-Add-Comment-Container'))
			{
				// show add new comment container
				document.getElementById('CommentCurrent-Add-Comment-Container').classList.remove('is-hidden');
			}
		}
	}

	/**
	 * This method hides the new comment container on cancel event.
	 * @param {Event} event - The event that triggered the search.
	 * @param {string} [pIDComment] - The comment ID of the comment in the treeview.
	 * @async
	 */
	cancelCommentEdit(event, pIDComment)
	{
		// if user clicked the add comment button
		if (event)
		{
			// if new comment container exists
			if (document.getElementById('CommentCurrent-Add-Comment-Container'))
			{
				// hide reply comment container
				document.getElementById('CommentCurrent-Add-Comment-Container').classList.add('is-hidden');
			}
			// if reply container exists
			if (document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`))
			{
				// hide reply comment container
				document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`).classList.add('is-hidden');
			}
			// if editable container exists
			if (document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`))
			{
				// swap editable textarea for readonly
				document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`).classList.add('is-hidden');
				document.getElementById(`CommentCurrent-Readonly-Comment_${pIDComment}`).classList.remove('is-hidden');
			}
		}
	}

	/**
	 * This method adds a new comment.
	 * @param {Event} event - The event that triggered the search.
	 * @param {string} pIDComment - The ID of the comment to reply to.
	 * @return {Promise<void>}
	 * @async
	 */
	handleCommentReplyButton(event, pIDComment)
	{
		if (!pIDComment)
		{
			this.log.error(`No Comment ID; can't reply to comment that doesn't exist: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Comment ID; can't reply to comment that doesn't exist: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the reply to comment button
		if (event)
		{
			// if child and editable containers exist
			if (document.getElementById(`CommentCurrent-Child-Comment_${pIDComment}`) && document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`))
			{
				// show reply comment container under the comment
				document.getElementById(`CommentCurrent-Child-Comment_${pIDComment}`).classList.remove('is-hidden');
				document.getElementById(`CommentCurrent-Reply-Comment-Container_${pIDComment}`).classList.remove('is-hidden');
			}
		}
	}

	/**
	 * This method edits a comment.
	 * @param {Event} event - The event that triggered the edit.
	 * @param {string} pIDComment - The ID of the comment to edit.
	 * @return {Promise<void>}
	 * @async
	 */
	handleCommentEditButton(event, pIDComment)
	{
		if (!pIDComment)
		{
			this.log.error(`No Comment ID; can't reply to comment that doesn't exist: .`);
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			// if editable container exists
			if (document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`))
			{
				// swap readonlies for inputs
				document.getElementById(`CommentCurrent-Readonly-Comment_${pIDComment}`).classList.add('is-hidden');
				document.getElementById(`CommentCurrent-Edit-Comment_${pIDComment}`).classList.remove('is-hidden');
			}
		}
	}

	/**
	 * @spec puts a loading spinner on the element for a short time: 1.5 seconds.
	 * @param {HTMLElement} htmlElement
	 */
	animateLoading(htmlElement)
	{
		htmlElement.classList.add('is-loading');
		setTimeout(() => htmlElement.classList.remove('is-loading'), 1500);
	}

	/**
	 * Handles the deletion of a comment.
	 * @param {Event} event - The event that triggered the delete action.
	 * @param {string} pIDComment - The ID of the comment to delete.
	 * @return {void}
	 */
	handleCommentDeleteButton(event, pIDComment)
	{
		// the body and footer templates for the delete modal
		const deleteModalBodyTemplate = /*html*/`
		<span id="DeleteModalBody">
			<div class="cell is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">Are you sure you want to delete this comment?</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to delete or close this modal.</p>
				</div>
			</div>
		</span>`;
		const deleteModalFooterTemplate = /*html*/`
		<div id="DeleteModalFooter" class="buttons is-right">
			<button class="button is-danger is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-danger" type="button" title="Delete Comment" onclick="_Pict.views.CommentCurrent.handleCommentDelete(${pIDComment}, event)">
				<span class="icon">
					<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
				</span>
				<span>Delete</span>
			</button>
		</div>`;
		// the options for the edit modal
		const deleteModalOptions = {
			title: 'Delete Comment?',
			modalBodyTemplate: deleteModalBodyTemplate,
			modalFooterTemplate: deleteModalFooterTemplate,
			confirmText: 'Delete',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(deleteModalOptions, this.confirmDeleteCallback.bind(this));
	}

	/**
	 * Handles deleting comment
	 * @param {number} pIDComment - The ID of the comment to delete.
	 * @param {Event} event - The event that triggered the save action.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleCommentDelete(pIDComment, event)
	{
		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		await this.pict.providers.CommentProvider.deleteComment(pIDComment, (pResult) =>
		{
			if (pResult)
			{
				this.fetchComments(event, null, null);
			}
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Comment Deleted',
				type: 'is-success',
			});
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles updating an existing comment
	 * @param {Event} event - The event that triggered the update
	 * @param {number} pIDComment - The ID of the comment being updated
	 * @param {string} pRowID - The ID of the row in the treeview
	 * @return {Promise<void>}
	 */
	async applyCommentEdit(event, pIDComment, pRowID)
	{
		// set the loading ui state
		if (event?.currentTarget instanceof HTMLElement)
		{
			event.currentTarget.classList.add('is-loading');
		}

		const elValue = document.getElementById(`CommentCurrent-Edit-Textarea-Comment_${pIDComment}`);
		const tmpCommentValue = elValue ? /** @type {HTMLTextAreaElement} */ (elValue).value.trim() : '';

		if (!tmpCommentValue)
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Comment cannot be empty.',
				type: 'is-warning',
			});
			return;
		}

		const tmpComment = {
			IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer,
			IDComment: pIDComment,
			Comment: tmpCommentValue,
		};

		await this.pict.providers.CommentProvider.updateComment(tmpComment, (pResult) =>
		{
			if (pResult)
			{
				this.fetchComments(event, pRowID, true);
			}
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Comment Updated',
				type: 'is-success',
			});
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles adding a new comment or a reply
	 * @param {Event} event - The event that triggered the save
	 * @param {number} [pParentID] - ID of the parent comment (0 for new top-level comment)
	 * @return {Promise<void>}
 	*/
	async handleCommentAdd(event, pParentID)
	{
		const elReply = document.getElementById(`CommentCurrent-Reply-Textarea-Comment_${pParentID}`);
		const tmpCommentReplyValue = elReply ? /** @type {HTMLTextAreaElement} */ (elReply).value.trim() : '';

		const elNewValue = document.getElementById('CommentCurrent-Add-Comment-Textarea');
		const tmpCommentNewValue = elNewValue ? /** @type {HTMLTextAreaElement} */ (elNewValue).value.trim() : '';

		if (event?.currentTarget instanceof HTMLElement)
		{
			event.currentTarget.classList.add('is-loading');
		}

		// Add reply comment
		if (pParentID)
		{
			if (!tmpCommentReplyValue)
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Reply cannot be empty.',
					type: 'is-warning',
				});
				return;
			}
			// Create a new comment object for the reply
			const tmpComment = {
				IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer,
				IDComment: 0,
				IDParent: pParentID,
				Comment: tmpCommentReplyValue,
			};

			await this.pict.providers.CommentProvider.createComment(tmpComment, async (pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Reply Added',
					type: 'is-success',
				});
				if (pResult)
				{
					const newCommentID = pResult.IDComment;
					if (Array.isArray(this.AppData?.DocumentData?.ReportData?.Comments))
					{
						this.AppData.DocumentData.ReportData.Comments.push(newCommentID);
					}

					await this.pict.providers.CommentProvider.addCommentToDocument(this.AppData?.DocumentData?.ReportData?.IDDocument, newCommentID, (pNewResult) =>
					{
						if (pNewResult)
						{
							this.fetchComments(event, null, null);
						}
					});
				}
			});
		}
		// Add top-level comment
		else
		{
			if (!tmpCommentNewValue)
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Comment cannot be empty.',
					type: 'is-warning',
				});
				return;
			}
			// Create a new comment object for the new comment
			const tmpComment = {
				IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer,
				IDComment: 0,
				IDParent: 0,
				Comment: tmpCommentNewValue,
			};

			await this.pict.providers.CommentProvider.createComment(tmpComment, async (pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Comment Added',
					type: 'is-success',
				});
				if (pResult)
				{
					const newCommentID = pResult.IDComment;
					if (Array.isArray(this.AppData?.DocumentData?.ReportData?.Comments))
					{
						this.AppData.DocumentData.ReportData.Comments.push(newCommentID);
					}

					await this.pict.providers.CommentProvider.addCommentToDocument(this.AppData?.DocumentData?.ReportData?.IDDocument, newCommentID, (pNewResult) =>
					{
						if (pNewResult)
						{
							this.fetchComments(event, null, null);
							// if the comment was created successfully, clear out the comment container in the UI
							const elNewComment = document.getElementById(`CommentCurrent-Add-Comment-Textarea`);
							if (elNewComment)
							{
								/** @type {HTMLTextAreaElement} */ (elNewComment).value = '';
							}
						}
					});
				}
			});
		}
		// hide the add new comment container
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// render the current state of the comment panel
			this.pict.views.CommentCurrent.renderAsync(() =>
			{
				this.pict.log.info('Comment Panel Rendered');
			});
		}
	}

	/**
	 * Callback to run when user confirms comment delete
	 * @param {object} event - The click event
	 */
	async confirmDeleteCallback(event)
	{
		if (event)
		{
			// render the current state of the comment panel
			this.pict.views.CommentCurrent.renderAsync(() =>
			{
				this.pict.log.info('Comment Panel Rendered');
			});
		}
	}

	/**
	 * Toggle the visibility of comments with responses
	 * @param {*} event - the event object
	 * @param {string} _RowID - the name and id of the comment
	 * @return {void}
	 */
	toggleSectionVisibility(event, _RowID)
	{
		// find the icon in the button and swap it out
		const tmpIcon = event?.currentTarget?.querySelector('i') || event?.parentElement?.currentTarget?.querySelector('i');
		if (!tmpIcon)
		{
			return;
		}
		if (tmpIcon.classList.contains('fa-chevron-left'))
		{
			tmpIcon.classList.remove('fa-chevron-left');
			tmpIcon.classList.add('fa-chevron-down');
		}
		else
		{
			tmpIcon.classList.remove('fa-chevron-down');
			tmpIcon.classList.add('fa-chevron-left');
		}
		// toggle the visibility of the child folders
		const tmpElementID = `CommentCurrent-Child-${_RowID}`;
		// if the element is not found, return
		if (!document.getElementById(tmpElementID))
		{
			this.log.error(`Element with ID ${tmpElementID} not found`);
			return;
		}
		document.getElementById(tmpElementID)?.classList.toggle('is-hidden', document.getElementById(tmpElementID)?.classList.contains('is-hidden') ? false : true);
	}
}

module.exports = CommentCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'CommentCurrent',
	DefaultRenderable: 'CommentCurrent-Wrapper',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
		[
			{
				Hash: 'CommentCurrent-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-CommentCurrentPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-CommentCurrentPanel-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event, 'Comments')">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('right', 'Comments')">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-CommentCurrent-Header-Icon" class="fas fa-fw fa-comment" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-CommentCurrent-Header-Title" class="mr-3">Comments</span>
					</p>
					<div class="panel-content nested-scroll-content">
						<div id="CommentCurrent-Entry-Container">
							{~T:CommentCurrent-Entry~}
						</div>
						<div id="HeadlightPanels-CommentCurrent-Content" class="has-bottom-navbar-offset">
							{~T:CommentCurrent-Results~}
						</div>
					</div>
				</article>`,
			},
			{
				Hash: 'CommentCurrent-Entry',
				Template: /*html*/`
				<div id="CommentCurrent-Entry-Container" class="container">
					<div class="field p-4">
						<div class="buttons is-right">
							<button class="button is-primary is-fullwidth" id="CommentCurrent-AddButton" title="Add comment" onclick="_Pict.views.CommentCurrent.addNewComment(event)">
								<i class="fas fa-fw fa-plus mr-1"></i> Create New Comment
							</button>
						</div>
					</div>
				</div>
				{~T:CommentCurrent-Add-Comment~}`,
			},
			{
				Hash: 'CommentCurrent-Add-Comment',
				Template: /*html*/`
                <div id="CommentCurrent-Add-Comment-Container" class="column is-hidden">
                    <div class="field">
                        <label class="label block" for="CommentCurrent-Add-Comment-Textarea">Comment</label>
                        <div id="CommentCurrent-Add-Comment-Edit" class="control is-fullwidth is-relative">
                            <textarea
                                id="CommentCurrent-Add-Comment-Textarea"
                                class="textarea"
                                placeholder="Enter a comment..."
                                rows="2"
                            ></textarea>
                        </div>
                    </div>
                    {~T:CommentCurrent-New-Comment-Buttons:Record~}
                </div>`,
			},
			{
				Hash: 'CommentCurrent-Results',
				Template: /*html*/`
				<div id="CommentCurrent-Results-Container" class="container table-container">
					{~TIfAbs:CommentCurrent-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:CommentCurrent-Container:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'CommentCurrent-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fas fa-search"></i>
						</span>
						<span>No comments found.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'CommentCurrent-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			/* ----- start Tree View ---- */
			{
				Hash: 'CommentCurrent-Container',
				Template: /*html*/`{~TS:CommentCurrent:Record.CurrentSearchResults~}`,
			},
			/* ----- Tree View > first layer (results or empty check) ----- */
			{
				Hash: 'CommentCurrent',
				Template: /*html*/`{~T:CommentCurrent-CommentList:Record~}`,
			},
			/* ----- Tree View > second layer (empty) ----- */
			{
				Hash: 'CommentCurrent-Empty',
				Template: /*html*/`
				<div class="notification m-3 p-2 empty-message has-background-text-30">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						No responses found for this comment.
					</p>
				</div>`,
			},
			/* ----- Tree View > second layer (search results processed list) ----- */
			{
				Hash: 'CommentCurrent-Content',
				Template: /*html*/`{~T:CommentCurrent-CommentList:Record~}`,
			},
			{
				Hash: 'CommentCurrent-Child-Content',
				Template: /*html*/`{~T:CommentCurrent-Child-CommentList:Record~}`,
			},
			/* ----- Tree View > third layer (comments) ----- */
			{
				Hash: 'CommentCurrent-CommentList',
				Template: /*html*/`
				<div class="comment mx-3 mb-3" style="border-radius: 15px; overflow: hidden;">
					<div class="panel-block-group">
						<div
							id="CommentCurrent-{~D:Record._RowID~}"
							class="panel-block panel-block-group-header is-relative p-0 has-background-primary-25">
							<div class="navbar-item">
								<span class="icon">
									<i class="fas fa-solid fa-user-circle fa-xl"></i>
								</span>
								<span class="icon-text">{~D:Record.CreatingUserData.NameFirst~} {~D:Record.CreatingUserData.NameLast~}</span>
							</div>
						</div>
						<div class="p-3 has-background-text-30">
							<div id="CommentCurrent-Readonly-{~D:Record._RowID~}" class="is-size-6 has-text-text-100">{~D:Record.Comment~}</div>
							<p id="CommentCurrent-Edit-{~D:Record._RowID~}" class="control is-fullwidth is-relative is-hidden">
								<textarea
									id="CommentCurrent-Edit-Textarea-{~D:Record._RowID~}"
									class="textarea has-background-text-30"
									rows="2"
								>{~D:Record.Comment~}</textarea>
								{~T:CommentCurrent-Edit-Comment-Buttons:Record~}
							</p>
							<div class="help has-text-text-85 mt-2">{~DateFormat:Record.Date^MMMM DD, YYYY - hh:mm a~}
								{~T:CommentCurrent-ActionMenu:Record~}
							</div>
						</div>
					</div>
					<div id="CommentCurrent-Child-{~D:Record._RowID~}" class="is-hoverable panel-block-group">
						<div class="treeview-child">
							{~TS:CommentCurrent-Child-Content:Record.Children~}
							{~T:CommentCurrent-Reply-Comment~}
						</div>
					</div>
				</div>`,
			},
			/* ----- Tree View > third layer (comments) ----- */
			{
				Hash: 'CommentCurrent-Child-CommentList',
				Template: /*html*/`
				<div class="comment">
					<div class="panel-block-group" style="border-left: 10px solid var(--bulma-text-40);">
						<div
							id="CommentCurrent-{~D:Record._RowID~}"
							class="panel-block panel-block-group-header is-relative p-0 has-background-text-20">
							<div class="navbar-item">
								<span class="icon">
									<i class="fas fa-solid fa-user-circle fa-xl"></i>
								</span>
								<span class="icon-text">{~D:Record.CreatingUserData.NameFirst~} {~D:Record.CreatingUserData.NameLast~}</span>
							</div>
						</div>
						<div class="p-3 has-background-text-30">
							<div id="CommentCurrent-Readonly-{~D:Record._RowID~}" class="is-size-6 has-text-text-100">{~D:Record.Comment~}</div>
							<p id="CommentCurrent-Edit-{~D:Record._RowID~}" class="control is-fullwidth is-relative is-hidden">
								<textarea
									id="CommentCurrent-Edit-Textarea-{~D:Record._RowID~}"
									class="textarea has-background-text-30"
									rows="2"
								>{~D:Record.Comment~}</textarea>
								{~T:CommentCurrent-Edit-Comment-Buttons:Record~}
							</p>
							<div class="help has-text-text-85 mt-2">{~DateFormat:Record.Date^MMMM DD, YYYY - hh:mm a~}
								{~T:CommentCurrent-ActionMenu:Record~}
							</div>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'CommentCurrent-ActionMenu',
				Template: /*html*/`
				<ul class="is-inline-flex list-menu visible-mode_{~D:Pict.views.CommentCurrent.SearchPanelMode~}">
					{~TIfAbs:CommentCurrent-Reply-Button:Record:Record.IDParent^==^0~}
					{~TIfAbs:CommentCurrent-Edit-Button:Record:Record.IsCreatingUser^==^1~}
					{~TIfAbs:CommentCurrent-Delete-Button:Record:Record.IsCreatingUser^==^1~}
				</ul>`,
			},
			{
				Hash: 'CommentCurrent-Reply-Button',
				Template: /*html*/
				`<li class="mx-2 list-menu-item mode_comment-reply">
					<a class="move-table-row-down-button has-text-primary-70" onclick="_Pict.views.CommentCurrent.handleCommentReplyButton(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-reply"></i>
						</span>
						<span>Reply</span>
					</a>
				</li>`,
			},
			{
				Hash: 'CommentCurrent-Delete-Button',
				Template: /*html*/
				`<li class="mx-2 list-menu-item mode_comment-delete">
					<a class="delete-table-row-button has-text-primary-70" onclick="_Pict.views.CommentCurrent.handleCommentDeleteButton(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-trash"></i>
						</span>
						<span>Delete</span>
					</a>
				</li>`,
			},
			{
				Hash: 'CommentCurrent-Edit-Button',
				Template: /*html*/
				`<li class="mx-2 list-menu-item mode_comment-edit">
					<a class="move-table-row-down-button has-text-primary-70" onclick="_Pict.views.CommentCurrent.handleCommentEditButton(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-pencil"></i>
						</span>
						<span>Edit</span>
					</a>
				</li>`,
			},
			{
				Hash: 'CommentCurrent-Reply-Comment',
				Template: /*html*/`
				<div id="CommentCurrent-Reply-Comment-Container_{~D:Record.IDComment~}" class="column has-background-text-30 is-hidden" style="border-left: 10px solid var(--bulma-text-40);">
					<textarea 
						id="CommentCurrent-Reply-Textarea-Comment_{~D:Record.IDComment~}"
						class="textarea has-background-text-25"
						rows="2"
						placeholder="Enter a reply to this comment..."
					></textarea>
					{~T:CommentCurrent-New-Comment-Buttons:Record~}
				</div>`,
			},
			{
				Hash: 'CommentCurrent-New-Comment-Buttons',
				Template: /*html*/
				`<span class="buttons is-right mt-2">
					<button class="button is-primary is-dark" type="button" title="Cancel Save" onclick="_Pict.views.CommentCurrent.cancelCommentEdit(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-fw fa-times" aria-hidden="true"></i>
						</span>
						<span>Cancel</span>
					</button>
					<button class="button is-primary" type="button" title="Save Comment" onclick="_Pict.views.CommentCurrent.handleCommentAdd(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-fw fa-comment" aria-hidden="true"></i>
						</span>
						<span>Save</span>
					</button>
				</span>`,
			},
			{
				Hash: 'CommentCurrent-Edit-Comment-Buttons',
				Template: /*html*/
				`<span class="buttons is-right mt-2">
					<button class="button is-primary is-dark" type="button" title="Cancel Save" onclick="_Pict.views.CommentCurrent.cancelCommentEdit(event, '{~D:Record.IDComment~}')">
						<span class="icon">
							<i class="fas fa-fw fa-times" aria-hidden="true"></i>
						</span>
						<span>Cancel</span>
					</button>
					<button class="button is-primary" type="button" title="Save Comment" onclick="_Pict.views.CommentCurrent.applyCommentEdit(event, '{~D:Record.IDComment~}', '{~D:Record._RowID~}')">
						<span class="icon">
							<i class="fas fa-fw fa-comment" aria-hidden="true"></i>
						</span>
						<span>Save</span>
					</button>
				</span>`,
			},
			/* ----- end Tree View ----- */
		],
	Renderables:
		[
			{
				RenderableHash: 'CommentCurrent-Wrapper',
				TemplateHash: 'CommentCurrent-Wrapper',
				DestinationAddress: '#HeadlightPanels-RightPanel',
			},
			{
				RenderableHash: 'CommentCurrent-Results',
				TemplateHash: 'CommentCurrent-Results',
				DestinationAddress: '#CommentCurrent-Results-Container',
			},
			{
				RenderableHash: 'CommentCurrent-Pagination',
				TemplateHash: 'CommentCurrent-Pagination',
				DestinationAddress: '#CommentCurrent-Pagination-Container',
			},
		],
};


},{"pict-view":733}],1540:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.CurrentDocumentRecord = {
			DocumentType: '',
			DocumentDate: null,
			Form: 0,
			IDProject: 0,
			Name: '',
			Shift: 'Day',
		};
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.rnis = [];
	}

	async onAfterRenderAsync(pCallback)
	{
		if (this.pict.views.HeadlightPaneDocuments.Intent?.afterRenderHandler)
		{
			this.pict.views.HeadlightPaneDocuments.Intent.afterRenderHandler();
		}
		// set the customer ID if it exists
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser.CustomerID || 0;
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.CurrentDocumentRecord.IDProject = tmpProject ? tmpProject.id : 0;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Enter a project...',
			ElementID: 'DocumentCreate-Entry-Project',
			ParentID: 'DocumentCreate-Container',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		this.rnis = this.CurrentDocumentRecord.Project ? (await this.pict.providers.DocumentProvider.getReportNamedInstancesByProject(this.CurrentDocumentRecord.Project, true, true)) : (await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.CurrentSearchFilters.IDCustomer, true, true));
		this.CurrentDocumentRecord.DocumentType = this.rnis[0]?.Hash || '';
		this.CurrentDocumentRecord.Form = this.rnis[0]?.Options?.FormOnly ? 1 : 0;
		// convert the document types to a format that select2 can use
		const dataDocumentTypes = this.rnis.map((pItem) =>
		{
			return {
				id: pItem.Hash,
				text: pItem.Name,
				_isForm: pItem?.Options?.FormOnly ? 1 : 0,
			};
		});
		// DOCUMENT TYPE Selector Filter
		// if we are in a form already, make it's type the sticky on the top of the list
		const tmpDocumentType = dataDocumentTypes.find((pItem) => pItem.id === this.AppData?.DocumentData?.ReportData?.DocumentType);
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark',
			placeholder: 'Enter a document type...',
			ElementID: 'DocumentCreate-Entry-DocumentType',
			ParentID: 'DocumentCreate-Container',
			data: dataDocumentTypes,
			StickyOption: tmpDocumentType,
			PreselectOption: tmpDocumentType,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		this.updateDocumentNamePrefill(tmpDocumentType);

		//  DESIGNATEDDATE date picker
		window.flatpickr('#DocumentCreate-Entry-Date', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentCreate-Date');
			},
		});

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		const tmpOptions = {
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
		};
		// use local data if provided, else assume server-side paging via entity endpoint
		if (pOptions.data)
		{
			tmpOptions.data = pOptions.data;
		}
		else
		{
			tmpOptions.ajax = {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.DocumentCreate.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.DocumentCreate.CurrentSearchFilters.PageSize : data.length === _Pict.views.DocumentCreate.CurrentSearchFilters.PageSize,
					};
				},
			};
		}
		// initialize the select2 plugin
		$('#' + pOptions.ElementID).select2(tmpOptions);
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method updates the current Document record with the value of the specified field.
	 * @param {string} pField - The field to update in the current Document record.
	 * @return {void}
	 */
	handleNewDocumentRecordChange(pField)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(`#DocumentCreate-Entry-${pField}`);
		this.CurrentDocumentRecord[pField] = tmpValue;
		this.log.info(`Current Document Record updated: ${pField} = ${this.CurrentDocumentRecord[pField]}`);
		// update the Document name prefill if the Document type changes
		if (pField === 'DocumentType')
		{
			this.updateDocumentNamePrefill($('#DocumentCreate-Entry-DocumentType').select2('data')[0]);
			this.CurrentDocumentRecord['Form'] = this.rnis.find((rni) =>
			{
				return rni.Hash === tmpValue;
			})?.Options?.FormOnly ? 1 : 0;
		}
	}

	/**
	 * This method updates the Document name prefill based on the selected Document type.
	 * @param {Object} pDocumentTypeSelect2Option - The selected Document type.
	 * @return {void}
	 */
	updateDocumentNamePrefill(pDocumentTypeSelect2Option)
	{
		// Set the new name to current type as prefill
		if (pDocumentTypeSelect2Option && pDocumentTypeSelect2Option.text)
		{
			this.CurrentDocumentRecord.Name = pDocumentTypeSelect2Option.text + ' (New)';
			this.pict.ContentAssignment.assignContent('#DocumentCreate-Entry-Name', this.CurrentDocumentRecord.Name);
		}
		// need to set the form flag for the document
		this.CurrentDocumentRecord.Form = pDocumentTypeSelect2Option?._isForm;
	}

	/**
	 * This method clears the current Document record.
	 * @return {void}
	 */
	clearDocument()
	{
		this.CurrentDocumentRecord = {
			DocumentType: '',
			DocumentDate: null,
			Form: 0,
			IDProject: 0,
			Name: '',
			Shift: 'Day',
		};
		this.renderAsync(() =>
		{
			this.log.info('Document Create view cleared');
		});
	}

	async createNewDocument(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		document.getElementById('DocumentCreate-CreateButton').classList.add('is-loading');
		this.log.info('Creating new Document...');

		const tmpDocumentRecord = {};
		Object.keys(this.CurrentDocumentRecord).forEach((pKey) =>
		{
			switch (pKey)
			{
			case 'Date':
				//defaulting to current time if date is set
				const currentTime = this.pict.providers.DocumentProvider.getDocumentDateCurrentTime();
				tmpDocumentRecord.DocumentDate = this.CurrentDocumentRecord.Date ? this.fable.Dates.dayJS(this.CurrentDocumentRecord.Date + currentTime).toISOString() : null;
				break;
			case 'Project':
				tmpDocumentRecord.IDProject = parseInt(this.CurrentDocumentRecord.Project);
				break;
			case 'Name':
				tmpDocumentRecord.Name = this.CurrentDocumentRecord.Name || (this.CurrentDocumentRecord.DocumentType + ' (New)');
				break;
			case 'Shift':
				tmpDocumentRecord.Shift = this.CurrentDocumentRecord.Shift;
				break;
			case 'DocumentType':
				tmpDocumentRecord.DocumentType = this.CurrentDocumentRecord.DocumentType;
				break;
			case 'Form':
				tmpDocumentRecord.Form = this.CurrentDocumentRecord.Form;
				break;
			default:
				this.pict.log.warn(`Unknown field to map for CreateNewDocument(): ${pKey}`);
				break;
			}
		});

		this.pict.log.info('Creating new Document with the following data:');
		this.pict.log.info(JSON.stringify(tmpDocumentRecord));

		if (!tmpDocumentRecord.IDProject || !tmpDocumentRecord.Name || !tmpDocumentRecord.DocumentType)
		{
			document.getElementById('DocumentCreate-CreateButton').classList.remove('is-loading');
			this.pict.log.warn('Not all required fields are filled out.');
			return;
		}

		// create the new Document
		const newDocumentResult = await this.pict.providers.DocumentProvider.createDocument(tmpDocumentRecord);
		document.getElementById('DocumentCreate-CreateButton').classList.remove('is-loading');
		this.log.info('Document created, going to the Details view...');

		if (this.pict.views.HeadlightPaneDocuments.Intent?.type === 'add')
		{
			this.pict.views.HeadlightPaneDocuments.Intent.handler(newDocumentResult.IDDocument);
		}
		else
		{
			// navigate to the new Document's Details view
			this.pict.views.DocumentDetails.ActiveDocumentDetails = newDocumentResult;
			this.pict.views.DocumentDetails.showDocumentDetailView(null, newDocumentResult.IDDocument, newDocumentResult);
		}
	}
}

module.exports = DocumentCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentCreate',
	DefaultRenderable: 'DocumentCreate',
	DefaultDestinationAddress: '#DocumentCreate-Container',
	Templates:
	[
		{
			Hash: 'DocumentCreate',
			Template: /*html*/`
			{~T:DocumentCreate-Entry~}`,
		},
		{
			Hash: 'DocumentCreate-Entry',
			Template: /*html*/`
			<form id="DocumentCreate-Form" onsubmit="_Pict.views.DocumentCreate.createNewDocument(event)">
				<div class="columns px-4 mb-0 mt-1">
					{~T:DocumentCreate-Entry-ProjectSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:DocumentCreate-Entry-DocumentTypeSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:DocumentCreate-Entry-NameInput~}
				</div>
				<div class="columns px-4 mb-0 theme-dark">
					{~T:DocumentCreate-Entry-ShiftSelector~}
					{~T:DocumentCreate-Entry-DateInput~}
				</div>
				<div class="columns px-4 mb-0 mt-1">
					<div class="column">
						<div class="buttons is-right">
							<button id="DocumentCreate-ClearButton" type="button" class="button is-primary is-dark" title="Clear documents" onclick="_Pict.views.DocumentCreate.clearDocument()">
								<span class="icon">
									<i class="fa fa-fw fa-refresh"></i>
								</span>
								<span class="icon-text">Clear</span>
							</button>
							<button id="DocumentCreate-CreateButton" type="submit" class="button is-primary" title="Create new document">
								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span class="icon-text">Create New Document</span>
							</button>
						</div>
					</div>
				</div>
			</form>`,
		},
		{
			Hash: 'DocumentCreate-Entry-NameInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Name">Document Name</label>
					<div class="control">
						<input 
							id="DocumentCreate-Entry-Name" 
							class="input" 
							type="text" 
							placeholder="Enter a name for the Document..."
							autocomplete="off"
							{~SelectOnFocus:Record~}
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Name')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-DateInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Date">Document Date</label>
					<div class="control">
						<input 
							id="DocumentCreate-Entry-Date" 
							class="input" 
							type="date" 
							placeholder="Enter a date for the Document..." 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Date')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-DocumentTypeSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-DocumentType">Document Type</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-DocumentType" 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('DocumentType')"
						>{~TS:DocumentCreate-Entry-DocumentTypeSelector-SelectedOptions:Context[0].CurrentSearchFilters.DocumentType~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-ProjectSelector',
			Template: /*html*/`
			<div class="column" id="DocumentCreate-Entry-Project-Wrapper">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Project">Project</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-Project" 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Project')"
						>{~TS:DocumentCreate-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-ShiftSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Shift">Shift</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-Shift" 
							class="input"
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Shift')"
						>
							<option value="Day" selected>Day</option>
							<option value="Night">Night</option>
							<option value="Swing">Swing</option>
						</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Enty-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentCreate',
			TemplateHash: 'DocumentCreate',
			DestinationAddress: '#DocumentCreate-Container',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":733}],1541:[function(require,module,exports){
/* eslint-disable no-extra-bind */
const PictViewClass = require('pict-view');
const { renderDocumentCopyResult, createNewDocumentFollowUp } = require('../behaviors/DocumentCopyResultModal.js');

class DocumentCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.CurrentDocumentCloneAction = 'Duplicate';
		this.AvailableCloneForms = [];
		this.AvailableCloneFormsWithMaps = [];
	}

	onBeforeRenderAsync(pCallback)
	{
		if (!this.AppData?.DocumentData)
		{
			this.log.warn('No document data found.');
		}
		else
		{
			this.CurrentDocumentData = this.AppData.DocumentData;
		}

		if (pCallback) pCallback();
	}

	async onAfterRenderAsync(pCallback)
	{
		if (pCallback) pCallback();
	}

	/**
	 * Download the PDF for the selected Document
	 * @param {object} event - The click event
	 */
	handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading');

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, this.AppData?.DocumentData?.ReportData, () =>
			{
				element.classList.remove('is-loading');
			});
		}
	}

	/**
	 * A callback to run when the user confirms the cloning of data into a new form type. This will clone all data from the current form into a new form of a different type.
	 * @param {*} event - the click event
	 */
	confirmCloneCallback(event)
	{
		const tmpConfirmButton = event?.target?.closest?.('button');
		if (tmpConfirmButton)
		{
			tmpConfirmButton.classList.add('is-loading');
			tmpConfirmButton.disabled = true;
		}
		// the custom options for the clone
		const customOptions = {};
		// fetch the custom title for the cloned document
		const newDocumentTitle = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Title');
		// set the new document title in case it was changed
		customOptions.Name = newDocumentTitle;
		//set window Target based on call from mobile device or desktop
		const windowTarget = this.pict.providers.DocumentProvider.isOpenDocumentCalledFromMobileDevice() ? '_top' : '_blank';

		const tmpAnticipate = this.fable.newAnticipate();
		const tmpCloneData = {};
		let abandonClone = false;

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Workflow')
				{
					// fetch the clone rules record from the server
					const tmpSelectedMapValue = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
					if (tmpSelectedMapValue)
					{
						this.pict.EntityProvider.getEntitySetPage('ManifestSchema', `FBV~Type~EQ~Clone~FBV~Hash~EQ~${tmpSelectedMapValue}`, 0, 10,
						function(pError, pRecords)
						{
							if (pError)
							{
								this.log.error('Error fetching cloning map manifest schema:', pError);
								abandonClone = true;
								this.pict.views.HeadlightPanels.toast({
									message: 'Failed to clone document!',
									type: 'is-danger',
								});
								fCallback();
							}
							else if (pRecords && pRecords.length > 0)
							{
								if (pRecords.length > 1)
								{
									this.log.warn('Multiple cloning map manifest schemas found, using the first one.');
								}
								else
								{
									this.log.info('Applying cloning map manifest schema:', pRecords[0]);
								}
								tmpCloneData.CloneRulesManifest = pRecords[0];
								fCallback();
							}
							else
							{
								// set this flag to skip the cloning process
								abandonClone = true;
								this.log.warn('No cloning map manifest schema found, skipping cloning map application.');
								const tmpDisplayName = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
								renderDocumentCopyResult(document.getElementById('CloneDocumentModalBody'), document.getElementById('CloneDocumentModalFooter'),
									{
										Succeeded: false,
										Title: 'Form data failed to clone.',
										Message: [ 'The form workflow named ', { Strong: tmpDisplayName }, ' did not have a valid cloning map defined. Please check the workflow settings and try again.' ],
										Instruction: 'Please click button below to close this modal.',
										Buttons: [ { Label: 'Close', Icon: 'fa-check', ClassName: 'button is-link', Title: 'Close modal', onClick: () => this.fable.services.HeadlightModal.dismissModals() } ],
									});
								fCallback();
							}
						}.bind(this));
					}
					else
					{
						this.log.warn('No cloning map selected, nothing to clone into.');
						abandonClone = true;
						this.pict.views.HeadlightPanels.toast({
							message: 'This form has no workflow to clone into.',
							type: 'is-warning',
						});
						fCallback();
					}
				}
				else
				{
					fCallback();
				}
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Workflow' && tmpCloneData.CloneRulesManifest)
				{
					// create a new document record to clone to
					tmpCloneData.NewDocumentCloneRecord = tmpCloneData?.CloneRulesManifest?.Manifest?.DocumentPayload || {};
					// set the document type to the selected form type
					if (!('FormData' in tmpCloneData?.NewDocumentCloneRecord))
					{
						tmpCloneData.NewDocumentCloneRecord.FormData = {};
					}
					tmpCloneData.NewDocumentCloneRecord.FormData.SourceRecordFormData = this.pict.AppData.DocumentData.ReportData.FormData || {};

					if (!('Descriptors' in tmpCloneData?.CloneRulesManifest?.Manifest))
					{
						tmpCloneData.CloneRulesManifest.Manifest.Descriptors = {};
					}
					// map the data from the current document to the new document based on the cloning map
					const tempDescriptorKeys = Object.keys(tmpCloneData.CloneRulesManifest.Manifest.Descriptors);
					tempDescriptorKeys.forEach(function(pDescriptorKey)
					{
						const tmpDescriptor = tmpCloneData.CloneRulesManifest.Manifest.Descriptors[pDescriptorKey];
						if (tmpDescriptor.hasOwnProperty('ToAddress'))
						{
							this.pict.manifest.setValueAtAddress(tmpCloneData.NewDocumentCloneRecord.FormData, tmpDescriptor.ToAddress, this.pict.manifest.getValueAtAddress(_Pict.AppData.DocumentData.ReportData.FormData, pDescriptorKey));
						}
					}.bind(this));
					// set the document date to now
					tmpCloneData.NewDocumentCloneRecord.DocumentDate = new Date().toISOString();
					// set the name to the new document title
					tmpCloneData.NewDocumentCloneRecord.Name = newDocumentTitle || tmpCloneData?.CloneRulesManifest?.Manifest?.NewDocumentName;
					// set the document project from the cloned document
					tmpCloneData.NewDocumentCloneRecord.IDProject = this.AppData.DocumentData.ReportData.IDProject;
				}
				fCallback();
			}.bind(this));

		// for the non-workflow cloning actions, set up the new document record accordingly
		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				if (this.CurrentDocumentCloneAction === 'Duplicate' || this.CurrentDocumentCloneAction === 'Clone')
				{
					tmpCloneData.NewDocumentCloneRecord = {
						Form: 1,
					};
					// create a new document record to clone to
					tmpCloneData.NewDocumentCloneRecord.FormData = Object.assign({}, this.pict.AppData.DocumentData.ReportData.FormData);
					// set the document date to now
					tmpCloneData.NewDocumentCloneRecord.DocumentDate = new Date().toISOString();
					// set the name to the new document title
					tmpCloneData.NewDocumentCloneRecord.Name = newDocumentTitle;
					// set the document project from the cloned document
					tmpCloneData.NewDocumentCloneRecord.IDProject = this.AppData.DocumentData.ReportData.IDProject;
					// set the document type to the selected form type
					if (this.CurrentDocumentCloneAction === 'Duplicate')
					{
						tmpCloneData.NewDocumentCloneRecord.DocumentType = this.pict.AppData.DocumentData.ReportData.DocumentType;
					}
					else
					{
						// TODO: This needs to take the doc type and actually go fetch the RNI Hash (see Document Provider "handleDocumentDuplication()" for reference)
						//		 however, we're punting this feature for now until we discuss how to best implement this so we don't just orphan a buncha FormData on new docs.

						// const tmpSelectedFormType = this.pict.ContentAssignment.readContent('#CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type');
						// if (tmpSelectedFormType)
						// {
						// 	tmpCloneData.NewDocumentCloneRecord.DocumentType = tmpSelectedFormType;
						// }
					}
				}
				fCallback();
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				this.pict.HeadlightRestClient.postJSON(`Document`, tmpCloneData.NewDocumentCloneRecord,
					function(pError, pResponse)
					{
						if (pError || !pResponse?.IDDocument)
						{
							this.log.error('Error cloning document data:', pError || pResponse);
							abandonClone = true;
							this.pict.views.HeadlightPanels.toast({
								message: 'Failed to clone document!',
								type: 'is-danger',
							});
						}
						else
						{
							this.log.info('Document data cloned successfully:', pResponse);
						}
						tmpCloneData.CreatedDocument = pResponse;
						fCallback();
					}.bind(this));
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fCallback)
			{
				if (abandonClone)
				{
					fCallback();
					return;
				}
				const tmpOpenNewDocument = this.pict.providers.DocumentProvider.canOpenOtherDocument() ? (pEvent) => this.pict.providers.DocumentProvider.openFormByIDDocument(pEvent, tmpCloneData.CreatedDocument.IDDocument, windowTarget) : null;
				renderDocumentCopyResult(document.getElementById('CloneDocumentModalBody'), document.getElementById('CloneDocumentModalFooter'),
					{
						Succeeded: true,
						Title: 'Form data successfully cloned.',
						Message: [ 'A new document titled ', { Strong: newDocumentTitle }, ' has been created with all previously selected data from the original ', { Strong: this.AppData.DocumentData.ReportData.Name }, ' document.' ],
						...createNewDocumentFollowUp(() => this.fable.services.HeadlightModal.dismissModals(), tmpOpenNewDocument),
					});

				fCallback();
			}.bind(this));

		tmpAnticipate.wait(
			function(pError)
			{
				if (pError)
				{
					this.log.error('Error during anticipation wait:', pError);
				}
				if (tmpConfirmButton)
				{
					tmpConfirmButton.classList.remove('is-loading');
					tmpConfirmButton.disabled = false;
				}
			}.bind(this));
	};

	/**
	 * Clone the Form for the selected Document into a new form type
	 */
	cloneDataFromForm()
	{
		if (!this.pict.providers.DocumentProvider.ensureCanCreateDocument('Clone Data to New Form'))
		{
			return;
		}
		// filter out the forms that are designed to accept cloned data with a map
		this.AvailableCloneFormsWithMaps = this.collectAllFormsWithCloneActions();
		const tmpHasWorkflows = this.AvailableCloneFormsWithMaps.length > 0;
		this.CurrentDocumentCloneAction = 'Duplicate';
		// the body and footer templates for the duplication modal
		const cloneModalBodyTemplate = /*html*/`
		<span id="CloneDocumentModalBody">
			<div class="column is-12">
				<label class="label">Clone Action</label>
				<div class="field">
					<div class="control">
						<div class="control">
							<div class="select is-fullwidth">
								<select id="CLONE-FOR-DocumentDetails-Document-Clone-Action" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, event.target.value)">
									<option value="Duplicate" selected>Duplicate this form</option>
									<option value="Workflow" ${ tmpHasWorkflows ? '' : 'disabled' }>${ tmpHasWorkflows ? 'Workflow to new form' : 'Workflow to new form (none set up for this form)' }</option>
									<!-- IN DEVELOPMENT FEATURE: Hidden for future use <option value="Clone">Clone data to new form</option> -->
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Current Document</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Current-Header-Title" disabled="disabled" class="input" type="text" placeholder="Document Title" value="${this.AppData?.DocumentData?.ReportData?.Name}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field" id="CloneDocument-DuplicateSelectField">
					<label class="label">New Document Type</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Current-Header-Title" disabled="disabled" class="input" type="text" placeholder="Document Title" value="${this.AppData?.DocumentData?.ReportData?.Name}">
					</div>
				</div>
				<div class="field is-hidden" id="CloneDocument-WorkflowSelectField">
					<!-- Workflow-based cloning -->
					<label class="label">New Document Type from Workflow</label>
					<div class="control">
						<div class="select is-fullwidth">
							<select id="CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, 'Workflow')">
								${ this.AvailableCloneFormsWithMaps.map((form) => `<option value="${form.Default}">${form.Name}</option>`).join('') }
							</select>
						</div>
					</div>
				</div>
				<div class="field is-hidden" id="CloneDocument-CloneSelectField">
					<label class="label">New Document Type with Cloned Data</label>
					<div class="control">
						<div class="select is-fullwidth">
							<select id="CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type" onchange="_Pict.views.DocumentCurrent.onCloneFormTypeChange(event, 'Clone')">
								${ this.AvailableCloneForms.map((form) => `<option value="${form.IDReportNamedInstance}" ${form.Hash === this.AppData.DocumentData.ReportData.DocumentType ? 'selected' : ''}>${form.Name}</option>`).join('') }
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">New Document Title</label>
					<div class="control">
						<input id="CLONE-FOR-DocumentDetails-Document-Header-Title" class="input" type="text" placeholder="Document Title" value="${this.AppData.DocumentData.ReportData.Name}">
					</div>
				</div>
			</div>
		</span>`;
		const cloneModalFooterTemplate = /*html*/`
		<div id="CloneDocumentModalFooter" class="buttons is-right">
			<button id="CloneDocument-CancelButton" class="button is-link is-soft" type="button" title="Cancel Cloning" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button id="CloneDocument-ConfirmationButton" class="button is-link" type="button" title="Clone Document" onclick="_Pict.views.DocumentCurrent.confirmCloneCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-clone" aria-hidden="true"></i>
				</span>
				<span>Clone Document</span>
			</button>
		</div>`;
		// the options for the duplication modal
		const duplicationModalOptions = {
			title: 'Clone Data To New Form',
			modalBodyTemplate: cloneModalBodyTemplate,
			modalFooterTemplate: cloneModalFooterTemplate,
			confirmText: 'Clone Data',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(duplicationModalOptions, this.confirmCloneCallback.bind(this));
	}

	/**
	 * Handle the change event from the form type select to update the document title with the selected form name.
	 * @param {*} event - the change event from the form type select
	 * @param {string} pCloneType - the type of cloning being performed ('Duplicate' 'Workflow', or 'Clone')
	 */
	async onCloneFormTypeChange(event, pCloneType)
	{
		if (event && event.target instanceof HTMLSelectElement)
		{
			const tmpCloneType = pCloneType || event.target.value;

			// hide all three fields initially
			document.getElementById('CloneDocument-WorkflowSelectField').classList.add('is-hidden');
			document.getElementById('CloneDocument-CloneSelectField').classList.add('is-hidden');
			document.getElementById('CloneDocument-DuplicateSelectField').classList.add('is-hidden');
			this.CurrentDocumentCloneAction = tmpCloneType;

			// enable the clone button in case it was disabled previously
			document.getElementById('CloneDocument-ConfirmationButton').removeAttribute('disabled');
			document.getElementById('CloneDocument-ConfirmationButton').removeAttribute('title');
			document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').removeAttribute('disabled');

			let displayFormName = '';

			// show the appropriate field based on the selected clone type
			switch (tmpCloneType)
			{
			case 'Duplicate':
				document.getElementById('CloneDocument-DuplicateSelectField').classList.remove('is-hidden');
				displayFormName = this.pict.AppData.DocumentData.ReportData.Name;
				this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
				setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				break;
			case 'Workflow':
				// show the workflow select field
				const workflowMapElement = document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Workflow-Map');
				const workflowMap = (workflowMapElement instanceof HTMLSelectElement) ? workflowMapElement.selectedOptions?.[0]?.label : undefined;
				if (workflowMap)
				{
					document.getElementById('CloneDocument-WorkflowSelectField').classList.remove('is-hidden');
					// set the document title to the selected form name and highlight it for easy editing
					displayFormName = workflowMap;
					this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
					setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				}
				break;
			// NOTE: This feature is currently not active in the UI, but the code is left here for future use.
			case 'Clone':
				// fetch the available forms for cloning
				this.AvailableCloneForms = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.pict.AppData?.DocumentData?.ReportData?.IDCustomer).catch((error) =>
				{
					this.log.error('Error fetching available forms for cloning:', error);
					document.getElementById('CloneDocument-ConfirmationButton').setAttribute('disabled', 'true');
					document.getElementById('CloneDocument-ConfirmationButton').setAttribute('title', 'Cloning not available');
					document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-Title').setAttribute('disabled', 'true');
					return [];
				});
				// filter out any non-forms because we can only clone into forms
				this.AvailableCloneForms = this.AvailableCloneForms.filter((document) => document?.Options?.FormOnly);
				// show the clone select field
				const cloneSelectElement = document.getElementById('CLONE-FOR-DocumentDetails-Document-Header-New-Form-Type');
				const cloneSelectedForm = (cloneSelectElement instanceof HTMLSelectElement) ? cloneSelectElement.selectedOptions?.[0]?.label : undefined;
				if (cloneSelectedForm)
				{
					document.getElementById('CloneDocument-CloneSelectField').classList.remove('is-hidden');
					displayFormName = cloneSelectedForm + ' (with cloned data)';
					this.pict.ContentAssignment.assignContent('#CLONE-FOR-DocumentDetails-Document-Header-Title', displayFormName);
					setTimeout(() => $('#CLONE-FOR-DocumentDetails-Document-Header-Title').trigger('focus').trigger('select'), 100);
				}
				break;
			default:
				this.log.warn(`Unknown clone type selected: ${tmpCloneType}`);
			}
		}
	}

	/**
	 * Collect all forms with CloneAction input types from the PictFormMetacontroller manifest
	 * @returns {Array} - An array of form descriptors with CloneAction input types
	 */
	collectAllFormsWithCloneActions()
	{
		const tmpDescriptors = this.pict.views.PictFormMetacontroller?.manifestDescription?.Descriptors || {};
		const tmpDescriptorsKeys = Object.keys(tmpDescriptors);
		const tmpDescritporsWithCloneActions = [];
		// iterate through all descriptors to find forms with CloneAction input types
		tmpDescriptorsKeys.forEach((descriptorKey) =>
		{
			const descriptor = tmpDescriptors[descriptorKey];
			if (descriptor?.PictForm)
			{
				const hasCloneAction = descriptor?.PictForm?.InputType === 'CloneAction';
				if (hasCloneAction)
				{
					tmpDescritporsWithCloneActions.push(descriptor);
				}
			}
		});
		return tmpDescritporsWithCloneActions;
	}
}

module.exports = DocumentCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentCurrent',
	DefaultRenderable: 'DocumentCurrent',
	DefaultDestinationAddress: '#DocumentCurrent-Container',
	Templates:
		[
			{
				Hash: 'DocumentCurrent',
				Template: /*html*/`
				<div id="DocumentCurrent-Container" class="container"  style="min-width: 33vw;" data-document-id="{~D:Context[0].CurrentDocumentData.IDDocument~}">
					{~TIfAbs:DocumentCurrent-Empty:Context[0].CurrentDocumentData:Context[0].CurrentDocumentData^==^0~}
					{~TIfAbs:DocumentCurrent-Content:Context[0].CurrentDocumentData:Context[0].CurrentDocumentData^>^0~}
				</div>`,
			},
			{
				Hash: 'DocumentCurrent-Content',
				Template: /*html*/`
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-15">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:Record.ReportData.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">
							<span class="is-pulled-right">
								{~TIfAbs:DocumentCurrent-Locked:Record.ReportData.Locked:Record.ReportData.Locked^==^1~}
								{~TIfAbs:DocumentCurrent-Unlocked:Record.ReportData.Locked:Record.ReportData.Locked^==^0~}
							</span>
							<span class="mr-1">#{~D:Record.ReportData.IDDocument~}</span>
							<span class="mr-1 is-size-7">Form #{~D:Record.ReportData.SequenceNumber~}</span>
						</p>
					</div>
				</div>
				<div class="columns px-5 mt-3">
					<div class="column is-12">
						<span class="title is-block is-6 has-text-text-60">Project</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:Project^Record.ReportData.IDProject^DocumentCurrent-Content-Project^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.ReportData.CreatingIDUser^DocumentCurrent-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Document Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ReportData.DocumentDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.ReportData.UpdatingIDUser^DocumentCurrent-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ReportData.UpdateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Document Type</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.TidingsData.Type~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Timezone</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Timezone~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Status~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Observations</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Observations.length~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Work Shift</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.ReportData.Shift~}</span>
					</div>
				</div>
				<div class="buttons is-right py-2 px-5">
					<button id="DocumentCurrent-CloneButton" class="button is-primary {~Show:Record.ReportData.Form~} {~HideIfCannotCreateDocument~}" type="button" title="View document" onclick="_Pict.views.DocumentCurrent.cloneDataFromForm()">
						<span class="icon">
							<i class="fas fa-fw fa-clone" aria-hidden="true"></i>
						</span>
						<span>Clone Data To New Form</span>
					</button>
					<button class="button is-primary" type="button" title="Download document PDF" onclick="_Pict.views.DocumentCurrent.handleDocumentDownload(event)">
						<span class="icon">
							<i class="fas fa-fw fa-file-pdf" aria-hidden="true"></i>
						</span>
						<span>Download PDF</span>
					</button>
				</div>`,
			},
			{
				Hash: 'DocumentCurrent-Content-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'DocumentCurrent-Content-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentCurrent-Locked',
				Template: /*html*/`
					<span class="icon has-text-text-95">
						<i class="fas fa-fw fa-sm fa-lock"></i>
					</span>
					<span class="icon-text has-text-text-95">Locked</span>`,
			},
			{
				Hash: 'DocumentCurrent-Unlocked',
				Template: /*html*/`
					<span class="icon">
						<i class="fas fa-fw fa-sm fa-unlock"></i>
					</span>
					<span class="icon-text">Unlocked</span>`,
			},
			{
				Hash: 'DocumentCurrent-Empty',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="title is-5 has-text-white has-text-centered">No Document Selected</p>
					<p class="subtitle is-6 has-text-text-65 has-text-centered">Please select a record to set as the current document.</p>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'DocumentCurrent',
				TemplateHash: 'DocumentCurrent',
				DestinationAddress: '#DocumentCurrent-Container',
				RenderType: 'replace',
			},
		],
};

},{"../behaviors/DocumentCopyResultModal.js":1532,"pict-view":733}],1542:[function(require,module,exports){
const PictViewClass = require('pict-view');
const { renderDocumentCopyResult, createNewDocumentFollowUp } = require('../behaviors/DocumentCopyResultModal.js');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveDocumentDetails = {};
	}

	/**
	 * This method resets the state of the Document Details view to a default state.
	 */
	resetDocumentDetailsView()
	{
		this.ActiveDocumentDetails = {};
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {object} event - The click event
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {string} [pDocumentRecord] - The record of the Document to view (optional)
	 */
	showDocumentDetailView(event, pIDDocument, pDocumentRecord)
	{
		// check the document data first to make sure it's not already loaded
		this.pict.views.DocumentDetails.ActiveDocumentDetails = this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument ? this.pict.AppData.DocumentData.ReportData : null;
		// if not found, try the search results next
		if (!this.pict.views.DocumentDetails.ActiveDocumentDetails)
		{
			this.pict.views.DocumentDetails.ActiveDocumentDetails = pDocumentRecord || this.pict.views.DocumentSearch.CurrentSearchResults.find((obs) => obs.IDDocument == pIDDocument);
		}
		// open the panel if it is not already open
		this.pict.views.HeadlightPanels.handlePanelToggle('DocumentDetails', 'open');
		// render the Document detail view
		this.pict.views.DocumentDetails.renderAsync(false, false, false, false, () =>
		{
			this.log.info('Document Details View Rendered with Active Record', this.pict.views.DocumentDetails.ActiveDocumentDetails);
		});
	}

	/**
	 * Confirmation Modal to open a form in the webApp
	 */
	confirmOpenForm(pIDDocument, windowTarget)
	{
		// footer templates for the confirmation modal
		const confirmModalFooterTemplate = /*html*/`
		<div id="ConfirmModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Open" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Open Document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, ${pIDDocument}, '${windowTarget}'); _Pict.fable.services.HeadlightModal.dismissModals();">
				<span class="icon">
					<i class="fas fa-fw fa-check" aria-hidden="true"></i>
				</span>
				<span>Continue</span>
			</button>
		</div>`;
		// the options for the confirmation modal
		const confirmModalOptions = {
			title: 'Open Document?',
			message: 'Are you sure you want to open this document? This will replace the current document.',
			modalFooterTemplate: confirmModalFooterTemplate,
		};
		this.fable.HeadlightModal.spawnModal(confirmModalOptions, this.pict.providers.DocumentProvider.openFormByIDDocument.bind(this));
	}

	// the callback to run when the user confirms the duplication
	confirmDuplicateCallback(event)
	{
		const tmpConfirmButton = event?.target?.closest?.('button');
		if (tmpConfirmButton)
		{
			tmpConfirmButton.classList.add('is-loading');
			tmpConfirmButton.disabled = true;
		}
		// the custom options for the duplication
		const customOptions = {};
		const originalTitle = this.ActiveDocumentDetails.Name;
		// fetch the custom title for the duplicated document
		const newDocumentTitle = this.pict.ContentAssignment.readContent('#DUPLICATE-FOR-DocumentDetails-Document-Header-Title');
		// set the new document title in case it was changed
		customOptions.Name = newDocumentTitle;
		const newDocumentDate = this.pict.ContentAssignment.readContent('#DUPLICATE-FOR-DocumentDetails-Document-Header-Date');
		const currentTime = this.pict.providers.DocumentProvider.getDocumentDateCurrentTime();
		customOptions.DocumentDate = newDocumentDate ? this.fable.Dates.dayJS(newDocumentDate + currentTime).toISOString() : this.fable.Dates.dayJS(new Date()).toISOString();

		//set window Target based on call from mobile device or desktop
		const windowTarget = this.pict.providers.DocumentProvider.isOpenDocumentCalledFromMobileDevice() ? '_top' : '_blank';
		// duplicate the document
		this.pict.providers.DocumentProvider.handleDocumentDuplication(customOptions, this.ActiveDocumentDetails, (pError, pNewDocument) =>
		{
			if (tmpConfirmButton)
			{
				tmpConfirmButton.classList.remove('is-loading');
				tmpConfirmButton.disabled = false;
			}
			if (pError)
			{
				return;
			}
			const tmpOpenNewDocument = this.pict.providers.DocumentProvider.canOpenOtherDocument() ? (pEvent) => this.pict.providers.DocumentProvider.openFormByIDDocument(pEvent, pNewDocument?.IDDocument, windowTarget) : null;
			renderDocumentCopyResult(document.getElementById('DuplicateDocumentModalBody'), document.getElementById('DuplicateDocumentModalFooter'),
				{
					Succeeded: true,
					Title: 'Document successfully duplicated.',
					Message: [ 'A new document titled ', { Strong: newDocumentTitle }, ' has been created with all previously saved data from the original ', { Strong: originalTitle }, ' document.' ],
					...createNewDocumentFollowUp(() => this.fable.services.HeadlightModal.dismissModals(), tmpOpenNewDocument),
				});
		});
	};

	handleDeleteActiveForm()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Document',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this document?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.ActiveDocumentDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Document" onclick="_Pict.views.DocumentDetails.onDeleteConfirm()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Document</span>
				</button>
			</div>`,
			confirmText: 'Delete Document',
			cancelText: 'Cancel',
		});
	}

	/**
	 * Handle the deletion of the active Document after confirmation
	 */
	onDeleteConfirm()
	{
		this.pict.providers.DocumentProvider.handleDocumentDeletion(this.ActiveDocumentDetails.IDDocument, (pResponse) =>
		{
			this.fable.services.HeadlightModal.dismissModals();
			// show a success toast
			this.pict.views.HeadlightPanels.toast({
				message: 'Document deleted successfully.',
				type: 'is-success',
			});
			this.resetDocumentDetailsView();
			// close the panel
			this.fable.views.HeadlightPanels.handlePanelToggle('DocumentDetails', 'close');
		});
	}

	/**
	 * Duplicate the Form for the selected Document
	 */
	duplicateActiveForm()
	{
		if (!this.pict.providers.DocumentProvider.ensureCanCreateDocument('Duplicate'))
		{
			return;
		}
		// the body and footer templates for the duplication modal
		const duplicateModalBodyTemplate = /*html*/`
		<span id="DuplicateDocumentModalBody">
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Title</label>
					<div class="control">
						<input id="DUPLICATE-FOR-DocumentDetails-Document-Header-Title" class="input" type="text" placeholder="Document Title" value="${this.ActiveDocumentDetails.Name}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Type</label>
					<div class="control">
						<input id="DUPLICATE-FOR-DocumentDetails-Document-Header-Type" disabled class="input" type="text" placeholder="Document Type" value="${this.ActiveDocumentDetails.TidingsData.Type}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Date</label>
					<div class="control">
						<input 
							id="DUPLICATE-FOR-DocumentDetails-Document-Header-Date" 
							class="input flatpickr-input active" 
							type="date" 
							placeholder="Enter the date of the Document" 
						/>
					</div>
				</div>
			</div>
		</span>`;
		const duplicateModalFooterTemplate = /*html*/`
		<div id="DuplicateDocumentModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Duplication" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-link" type="button" title="Duplicate Document" onclick="_Pict.views.DocumentDetails.confirmDuplicateCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Duplicate Document</span>
			</button>
		</div>`;
		// the options for the duplication modal
		const duplicationModalOptions = {
			title: 'Duplicate Document',
			modalBodyTemplate: duplicateModalBodyTemplate,
			modalFooterTemplate: duplicateModalFooterTemplate,
			confirmText: 'Create Duplicate',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(duplicationModalOptions, this.confirmDuplicateCallback.bind(this));
	}

	async onBeforeRenderAsync(pCallback)
	{
		if (this.ActiveDocumentDetails && !this.ActiveDocumentDetails?.TidingsData?.Type)
		{
			const customerRNIs = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.ActiveDocumentDetails?.IDCustomer);
			// find the matching document type via the project RNIs
			const match = customerRNIs.find((rni) => rni.Hash === this.ActiveDocumentDetails?.DocumentType);
			if (!match)
			{
				this.pict.log.warn('No matching RNI Hash has been set on this customer!');
			}
			this.ActiveDocumentDetails.TidingsData = match?.Options?.TidingsData;
		}
		pCallback();
	}

	/**
	 * Download the PDF for the selected Document
	 * @param {object} event - The click event
	 */
	handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading');

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, this.ActiveDocumentDetails, () =>
			{
				element.classList.remove('is-loading');
			});
		}
	}
}

module.exports = DocumentDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentDetails',
	DefaultRenderable: 'DocumentDetails',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'DocumentDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-DocumentDetailsPanel" class="panel is-active">
				<p id="HeadlightPanels-DocumentDetailsPanel-Document-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.DocumentDetails.resetDocumentDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-DocumentDetailsPanel-Document-Header-Icon" class="fas fa-fw fa-files" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-DocumentDetailsPanel-Document-Header-Title" class="mr-3">Document Details</span>
				</p>
				<div id="HeadlightPanels-DocumentDetails-Content" class="container panel-content"  style="min-width: 33vw;">
					{~T:DocumentDetails-Content:Context[0].ActiveDocumentDetails~}
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentDetails-Content',
			Template: /*html*/`
			<div class="columns px-4 py-2 m-0 has-background-text-20">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:Record.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">
							<span class="is-pulled-right">
								{~TIfAbs:DocumentDetails-Locked:Record.Locked:Record.Locked^==^1~}
								{~TIfAbs:DocumentDetails-Unlocked:Record.Locked:Record.Locked^==^0~}
							</span>
							<span class="mr-1">#{~D:Record.IDDocument~}</span>
							<span class="mr-1 is-size-7">Form #{~D:Record.SequenceNumber~}</span>
						</p>
					</div>
				</div>
				<div class="columns px-5 mt-3">
					<div class="column is-12">
						<span class="title is-block is-6 has-text-text-60">Project</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:Project^Record.IDProject^DocumentDetails-Content-Project^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^DocumentDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Document Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DocumentDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.UpdatingIDUser^DocumentDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.UpdateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Document Type</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.TidingsData.Type~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Timezone</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Timezone~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~DocumentState:Record~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Observations</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Observations.length~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Work Shift</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Shift~}</span>
					</div>
				</div>
				<div class="buttons is-right py-2 px-5">
					<button class="button is-primary is-dark {~Show:Record.Form~}" type="button" title="Delete document" onclick="_Pict.views.DocumentDetails.handleDeleteActiveForm()">
						<span class="icon">
							<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
						</span>
						<span>Delete</span>
					</button>
					<button class="button is-primary {~Show:Record.Form~} {~HideIfCannotCreateDocument~}" type="button" title="Duplicate document" onclick="_Pict.views.DocumentDetails.duplicateActiveForm()">
						<span class="icon">
							<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
						</span>
						<span>Duplicate</span>
					</button>
					<button class="button is-primary {~Show:Record.Form~}" type="button" title="Open document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocumentHandler(event, {~D:Record.IDDocument~})">
						<span class="icon">
							<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
						</span>
						<span>Open</span>
					</button>
					<button class="button is-primary" type="button" title="Download document PDF" onclick="_Pict.views.DocumentDetails.handleDocumentDownload(event)">
						<span class="icon">
							<i class="fas fa-fw fa-file-pdf" aria-hidden="true"></i>
						</span>
						<span>Download PDF</span>
					</button>
				</div>`,
		},
		{
			Hash: 'DocumentDetails-Content-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'DocumentDetails-Content-Project',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'DocumentDetails-Locked',
			Template: /*html*/`
				<span class="icon has-text-text-95">
					<i class="fas fa-fw fa-sm fa-lock"></i>
				</span>
				<span class="icon-text has-text-text-95">Locked</span>`,
		},
		{
			Hash: 'DocumentDetails-Unlocked',
			Template: /*html*/`
				<span class="icon">
					<i class="fas fa-fw fa-sm fa-unlock"></i>
				</span>
				<span class="icon-text">Unlocked</span>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentDetails',
			TemplateHash: 'DocumentDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'DocumentDetails-Content',
			TemplateHash: 'DocumentDetails-Content',
			DestinationAddress: '#HeadlightPanels-DocumentDetails-Content',
			RenderType: 'replace',
		},
	],
};

},{"../behaviors/DocumentCopyResultModal.js":1532,"pict-view":733}],1543:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			Materials: [],
			MixDesigns: [],
			StartDate: '',
			EndDate: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'DocumentDate',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		// this is the active Document that is selected; will be one we see in the "Document Details" panel, etc.
		this.selectedDocument = {};
		this.mode = 'none';
		this.documentSearchResultsCallback = (results) =>
		{};
	}

	setMode(newMode)
	{
		this.mode = newMode;
	}

	onBeforeRenderAsync(pCallback)
	{
		if (this.pict.views.HeadlightPaneDocuments.Intent?.type === 'add')
		{
			this.mode = 'add-with-intent';
		}
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'DocumentSearch-Projects',
			ParentID: 'DocumentSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// User Selector Filter
		// if we have a user already (we always should...), make them sticky on the top of the list
		const tmpUser = this.AppData?.CurrentUser?.UserID ? { id: this.AppData?.CurrentUser?.UserID, text: this.AppData?.CurrentUser?.NameFirst + ' ' + this.AppData?.CurrentUser?.NameLast } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpUser ? ' has-sticky-option' : ''),
			placeholder: 'Search by users...',
			ElementID: 'DocumentSearch-Users',
			ParentID: 'DocumentSearch-SearchEntry',
			URL: 'Users',
			IDField: 'IDUser',
			TextField: 'NameFirst',
			StickyOption: tmpUser,
			minimumInputLength: 0,
			formatMethod: (pResults) =>
			{
				return pResults.map((pResult) =>
				{
					return {
						IDUser: pResult.IDUser,
						NameFirst: `${pResult.NameFirst} ${pResult.NameLast}`,
					};
				});
			},
		}, () =>
		{
			this.log.info('Select2 Users initialized');
		});

		// START DATE date picker
		window.flatpickr('#DocumentSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				const siblingElement = document.getElementById('DocumentSearch-EndDate');
				siblingElement['_flatpickr'].config.minDate = dateStr ? dateStr : null;
				siblingElement['_flatpickr'].redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#DocumentSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				const siblingElement = document.getElementById('DocumentSearch-StartDate');
				siblingElement['_flatpickr'].config.maxDate = dateStr ? dateStr : null;
				siblingElement['_flatpickr'].redraw();
			},
		});

		this.setCurrentSearchFilters();

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method performs a search based on the current search filters.
	 * @param {Event} event - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleDocumentSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#DocumentSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('DocumentSearch-Results-Container', this.CurrentSearchFilters.PageSize, '2.5rem');
		// collapse the filter panel to get out the way of the results
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters', 'close');
		// perform the search
		const tmpSearchResults = await this.pict.providers.DocumentProvider.performDocumentSearch(this.CurrentSearchFilters);
		// update the search results/UI based on the search results and total search count passed in
		this.updateWithSearchResults(tmpSearchResults.results, tmpSearchResults.count);
	}

	/**
	 * This function is used to handle the selection of a Document from the search results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDDocument - The ID of the Document that was selected
	 * @param {object} pContext - The context of the Document that was selected
	 * @return {void}
	 */
	handleDocumentSelection(event, pIDDocument, pContext)
	{
		if (!pIDDocument)
		{
			this.log.error('No IDDocument provided');
			return;
		}
		// figure out the context of the selection
		switch (pContext)
		{
		case 'Add':
			if (this.pict.views.DocumentSearch.DocumentSelectionCallback)
			{
				if (this.pict.views.DocumentSearch.CurrentSearchResults.length > 0)
				{
					const tmpDocument = this.pict.views.DocumentSearch.CurrentSearchResults.find((pDocument) => pDocument.IDDocument == pIDDocument);
					this.pict.views.DocumentSearch.documentSelectionCallback(tmpDocument);
					this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'close');
				}
			}
			break;
		case 'Details':
			this.pict.views.DocumentDetails.showDocumentDetailView(null, pIDDocument);
			break;
		case 'Add-With-Intent':
			this.pict.views.HeadlightPaneDocuments.Intent.handler(pIDDocument);
			break;
		case 'Inspection-Add':
			if (this.pict.AppData?.CurrentInspection?.IDInspection && pIDDocument)
			{
				this.pict.BridgeDocumentManager.addDocumentToInspection(pIDDocument, this.pict.AppData.CurrentInspection.IDInspection)
					.then((pResult) =>
					{
						// auto-add document to Dossier before switching back to Inspection view
						this.log.debug('auto-adding document to dossier as part of adding document to inspection');
						return this.pict.BridgeDocumentManager.includeDocumentInInspectionDossier(Number(pIDDocument), this.pict.AppData.CurrentInspection.IDInspection, true)
						.catch((pError) =>
						{
							this.log.error(`Error auto-adding document to dossier`, pError);
							this.pict.views.HeadlightPanels?.toast?.({
								message: `Error updating inspection dossier as part of adding document to inspection`,
								type: 'is-danger',
							});
						});
					})
					.then((pResult) =>
					{
						this.pict.views.Inspection.invalidate();
						// show a success message
						this.pict.views.HeadlightPanels.toast({
							message: 'The document has been added to the inspection.',
							type: 'is-success',
						});
						// TODO: understand why this doesn't for updating the popover from add/goto right after the initial add
						// update this currentSearchResults to reflect the document is now in the inspection
						const tmpDocument = this.pict.views.DocumentSearch.CurrentSearchResults.find((pDocument) => pDocument.IDDocument == pIDDocument);
						if (tmpDocument)
						{
							tmpDocument._InCurrentInspection = true;
							// re-render the search results to reflect the change
							this.pict.views.DocumentSearch.updateWithSearchResults(this.pict.views.DocumentSearch.CurrentSearchResults, this.pict.views.DocumentSearch.CurrentSearchFilters.TotalCount);
						}
					})
					.catch((pError) =>
					{
						this.log.error('Error adding document to inspection: ', pError);
						this.pict.views.HeadlightPanels?.toast?.({
							message: `<strong>Error adding document to inspection.</strong>`,
							type: 'is-danger',
						});
					});
			}
			else
			{
				this.pict.views.HeadlightPanels.handlePanelToggle('Inspection');
				this.setMode('none');
			}
			break;
		case 'Inspection-GoTo':
			// clear add mode so we don't accidentally add the document to the inspection again
			this.setMode('none');
			// TODO: pass the highlighted document to the inspection view so we scroll/highlight it
			this.pict.views.HeadlightPanels.handlePanelToggle('Inspection', 'open', () =>
			{
				// try to highlight the document in the inspection view
				this.pict.providers.UtilityProvider.highlightListItemRowElement('#DocumentRow_' + pIDDocument, '.nested-scroll-content');
			});
			break;
		default:
			this.log.error('Unknown context for handleDocumentSelection()!', { pContext });
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.DocumentSearch.CurrentSearchFilters[pOptions.URL] || [];
					let formattedData = [];
					// if we have a custom format method, use it
					if (data && data.length > 0)
					{
						formattedData = pOptions.formatMethod ? pOptions.formatMethod(data) : data;
					}

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(formattedData, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.DocumentSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.DocumentSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.DocumentSearch.handleDocumentSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.DocumentSearch.handleDocumentSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], Materials: [5678]})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('DocumentSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#DocumentSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#DocumentSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setDocumentSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setDocumentSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.DocumentSearchResultsCallback = pCallback;
	}


	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Projects');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#DocumentSearch-Projects');
			break;
		case 'User':
		case 'Users':
			this.CurrentSearchFilters.Users = this.pict.ContentAssignment.readContent('#DocumentSearch-Users');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#DocumentSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#DocumentSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#DocumentSearch-SearchText');
			break;
		case 'Status':
			this.CurrentSearchFilters.Status = this.pict.ContentAssignment.readContent('#DocumentSearch-Status');
			break;
		case 'SortBy':
			const tempSortBy = this.pict.ContentAssignment.readContent('#DocumentSearch-SortBy');
			if (typeof tempSortBy === 'string' && tempSortBy != null)
			{
				this.CurrentSearchFilters.SortBy = tempSortBy.split('_')[0];
				this.CurrentSearchFilters.SortDirection = tempSortBy.split('_')[1];
			}
			else
			{
				this.CurrentSearchFilters.SortBy = 'DocumentDate';
				this.CurrentSearchFilters.SortDirection = 'DESC';
			}
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {Promise<void>}
	 */
	async updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// if the mode is 'add-to-inspection', we need to look up if the documents are already in the inspection
		if (this.mode === 'add-to-inspection')
		{
			// if we have an inspection, check if the documents are already in the inspection
			if (this.pict.AppData?.CurrentInspection?.IDInspection)
			{
				await this.pict.BridgeDocumentManager.getListOfCurrentInspectionIDDocuments(this.pict.AppData.CurrentInspection.IDInspection)
					.then((pInspectionDocuments) =>
					{
						// loop through the search results and mark the documents that are already in the inspection
						this.CurrentSearchResults.forEach((pDocument) =>
						{
							// if the document is in the inspection, mark it as such
							if (pInspectionDocuments.find((pInspectionDocument) => pInspectionDocument == pDocument.IDDocument))
							{
								pDocument._InCurrentInspection = true;
							}
							else
							{
								pDocument._InCurrentInspection = false;
							}
						});
					})
					.catch((pError) =>
					{
						this.log.error('Error getting inspection documents for add-to-inspection mode', pError);
					});
			}
			else
			{
				this.log.warn('No current inspection found for add-to-inspection mode, skipping inspection document check.');
			}
		}
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Results', '#DocumentSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#DocumentSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Pagination', '#DocumentSearch-Pagination-Container', false, false, () =>
			{
				this.log.info('Document Search Pagination rendered');
			});
			// if there is a callback function, call it
			if (this.documentSearchResultsCallback)
			{
				this.documentSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}

	/**
	 * This method handles the action popover for the observation search results.
	 * @param {string} pElementId - The ID of the element to attach the popover to.
	 * @param {number} IDDocument - The ID of the document.
	 */
	handleActionPopover(pElementId, IDDocument)
	{
		const tmpMenuElement = document.getElementById(pElementId);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${pElementId} not found for Observation search rults action popover.`);
			return;
		}
		// create the popover menu
		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'DocumentSearch-Results-Popover-Menu',
			PopoverTemplateRecord:
			{
				IDDocument: IDDocument,
				InCurrentInspection: this.CurrentSearchResults.find((pDocument) => pDocument.IDDocument == IDDocument)?._InCurrentInspection || false,
			},
			theme: 'dropdown-dark',
		});
	}
}

module.exports = DocumentSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentSearch',
	DefaultRenderable: 'DocumentSearch-Entry',
	DefaultDestinationAddress: '#DocumentSearch-Entry-Container',
	CSS: /*css*/`
		.mode_add-to-inspection {
			display: none;
		}
		.visible-mode_add-to-inspection .mode_add-to-inspection {
			display: block;
		}
		.mode_add-with-intent {
			display: none;
		}
		.visible-mode_add-with-intent .mode_add-with-intent {
			display: block;
		}
		`,
	Templates:
		[
			{
				Hash: 'DocumentSearch-Entry',
				Template: /*html*/`
				<div id="DocumentSearch-SearchEntry" class="container">
					<form autocomplete="off" role="Document-search" onsubmit="_Pict.views.DocumentSearch.handleDocumentSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="DocumentSearchFilters">
							<div class="columns mb-0 is-hidden">
								{~T:DocumentSearch-Entry-CurrentPage~}
								{~T:DocumentSearch-Entry-PageSize~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-SearchText~}
								{~T:DocumentSearch-Entry-Status~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-UserSelector~}
								{~T:DocumentSearch-Entry-SortBy~}
							</div>
							<div class="columns mb-0">
								{~T:DocumentSearch-Entry-StartDate~}
								{~T:DocumentSearch-Entry-EndDate~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="DocumentSearch-Pagination-Container" style="flex:auto"></div>
							<button 
								id="DocumentSearch-ToggleButton"
								type="button"
								title="Set filters"
								class="button is-primary is-soft" 
								data-collapsible-toggle="DocumentSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters')"
							>
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="DocumentSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:DocumentSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" id="DocumentSearch-ResetButton" title="Reset filters" onclick="_Pict.views.DocumentSearch.resetSearchFilters()">
								<i class="fas fa-fw fa-undo mr-1"></i> 
								Clear Filters
							</button>
							<button class="button is-primary" type="submit" id="DocumentSearch-SearchButton" title="Search documents">
								<i class="fas fa-fw fa-search mr-1"></i> 
								Search Documents
							</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'DocumentSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="DocumentSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('CurrentPage')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-PageSize" class="block">Page Size</label>
						<input 
							id="DocumentSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('PageSize')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field" style="margin-bottom: 10px;">
						<label class="label block" for="DocumentSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="DocumentSearch-Projects" 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('Projects')"
								multiple
							>{~TS:DocumentSearch-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Projects~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Enty-ProjectSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'DocumentSearch-Entry-UserSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="DocumentSearch-Users">Users</label>
						<div class="control select is-fullwidth">
							<select 
								id="DocumentSearch-Users" 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('Users')"
								multiple
							>{~TS:DocumentSearch-Entry-UserSelector-SelectedOptions:Context[0].CurrentSearchFilters.Users~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="DocumentSearch-SearchText" class="block">Text Search</label>
					<input 
						id="DocumentSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-Status',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="DocumentSearch-Status" class="block">Status</label>
					<input 
						id="DocumentSearch-Status"
						type="text"
						class="input" 
						placeholder="Enter a status to search"
						onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('Status')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Enty-UserSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDUser~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'DocumentSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="DocumentSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="DocumentSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="DocumentSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="DocumentSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.DocumentSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="DocumentDate_DESC">Document Date (Newest)</option>
								<option value="DocumentDate_ASC">Document Date (Oldest)</option>
								<option value="Status_ASC">Status (A-Z)</option>
								<option value="Status_DESC">Status (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Results',
				Template: /*html*/`
				<div id="DocumentSearch-Results-Container" class="container table-container">
					{~TIfAbs:DocumentSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:DocumentSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th style="min-width: 115px">Document Date</th>
							<th>Project</th>
							<th>Name</th>
							<th>User</th>
							<th class="has-text-centered">Status</th>
							<th class="has-text-centered is-vcentered">Actions</th>
						</tr>
					</thead>
					<tbody id="DocumentSearch-Results-Entries">
						{~TS:DocumentSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'DocumentSearch-Results-Row',
				Template: /*html*/`
				<tr>
					<td>{~DateFormat:Record.DocumentDate^YYYY-MM-DD~}</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-EntityValue-Project:Record:Record.IDProject^>^0~}
						{~TIfAbs:DocumentSearch-Results-EntityValue-NA:Record:Record.IDProject^<=^0~}
					</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:DocumentSearch-Results-DatumValue-NA:Record:Record.Name^<=^0~}
					</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-EntityValue-User:Record:Record.CreatingIDUser^>^0~}
						{~TIfAbs:DocumentSearch-Results-EntityValue-NA:Record:Record.CreatingIDUser^<=^0~}
					</td>
					<td>
						{~TIfAbs:DocumentSearch-Results-DatumValue-Status:Record:Record.Status^>^0~}
						{~TIfAbs:DocumentSearch-Results-DatumValue-NA:Record:Record.Status^<=^0~}
					</td>
					<td class="has-text-centered is-vcentered" id="DocumentSearch-Results-Popover-TriggerButton-{~D:Record.IDDocument~}">
						{~T:DocumentSearch-Results-Popover-TriggerButton:Record~}
					</td>
				</tr>`,
			},
			{
				Hash: 'DocumentSearch-Results-Popover-TriggerButton',
				Template: /*html*/`
				<button 
					id="DocumentSearch-DetailsButton-{~D:Record.IDDocument~}"
					type="button" 
					class="button is-ghost has-text-primary-75 p-0" 
					title="Actions" 
					onclick="_Pict.views.DocumentSearch.handleActionPopover(id, '{~D:Record.IDDocument~}')"
					onmouseover="_Pict.views.DocumentSearch.handleActionPopover(id, '{~D:Record.IDDocument~}')">
					<span class="icon">
						<i class="fas fa-fw fa-lg fa-circle-ellipsis"></i>
					</span>
				</button>`,
			},
			{
				Hash: 'DocumentSearch-Results-Popover-Menu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.DocumentSearch.mode~}">
					<li class="list-menu-item mode_add-with-intent {~Hide:Record.InCurrentInspection~}">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Add-With-Intent');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-plus-circle"></i>
							</span>
							<span class="icon-text">Add</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-inspection {~Hide:Record.InCurrentInspection~}">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Inspection-Add');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-plus-circle"></i>
							</span>
							<span class="icon-text">Add to Inspection</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-inspection {~Show:Record.InCurrentInspection~}">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Inspection-GoTo');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-building-magnifying-glass"></i>
							</span>
							<span class="icon-text">Go to Inspection</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a onclick="_Pict.views.DocumentSearch.handleDocumentSelection(event, '{~D:Record.IDDocument~}', 'Details');_Pict.fable.HeadlightPopover.hideAll();">
							<span class="icon mr-1">
								<i class="fa fa-fw fa-memo"></i>
							</span>
							<span class="icon-text">View Details</span>
						</a>
					</li>
				</ul>
				`,
			},
			{
				Hash: 'DocumentSearch-Results-EntityValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'DocumentSearch-Results-DatumValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'DocumentSearch-Results-EntityValue-Project',
				Template: /*html*/`{~Entity:Project^Record.IDProject^DocumentSearch-Results-Project^~}`,
			},
			{
				Hash: 'DocumentSearch-Results-EntityValue-User',
				Template: /*html*/`{~Entity:User^Record.CreatingIDUser^DocumentSearch-Results-User^~}`,
			},
			{
				Hash: 'DocumentSearch-Results-DatumValue-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentSearch-Results-DatumValue-Status',
				Template: /*html*/`{~DocumentState:Record~}`,
			},
			{
				Hash: 'DocumentSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any Documents based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'DocumentSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'DocumentSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'DocumentSearch-Pagination',
				Template: /*html*/`
				<nav id="DocumentSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="DocumentSearch-PreviousButton" type="button" class="button is-soft mr-2" title="Previous page" onclick="_Pict.views.DocumentSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="DocumentSearch-NextButton" type="button" class="button is-soft" title="Next page" onclick="_Pict.views.DocumentSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'DocumentSearch-Entry',
				TemplateHash: 'DocumentSearch-Entry',
				DestinationAddress: '#DocumentSearch-Entry-Container',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-ProjectSelector',
				TemplateHash: 'DocumentSearch-Entry-ProjectSelector',
				DestinationAddress: '#DocumentSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-MaterialSelector',
				TemplateHash: 'DocumentSearch-Entry-MaterialSelector',
				DestinationAddress: '#DocumentSearch-Entry-MaterialSelector',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-MixDesignSelector',
				TemplateHash: 'DocumentSearch-Entry-MixDesignSelector',
				DestinationAddress: '#DocumentSearch-Entry-MixDesignSelector',
			},
			{
				RenderableHash: 'DocumentSearch-Entry-ActiveFilterCount',
				TemplateHash: 'DocumentSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#DocumentSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'DocumentSearch-Results',
				TemplateHash: 'DocumentSearch-Results',
				DestinationAddress: '#DocumentSearch-Results-Container',
			},
			{
				RenderableHash: 'DocumentSearch-Pagination',
				TemplateHash: 'DocumentSearch-Pagination',
				DestinationAddress: '#DocumentSearch-Pagination-Container',
			},
			{
				RenderableHash: 'DocumentSearch-Results-Popover-TriggerButton',
				TemplateHash: 'DocumentSearch-Results-Popover-TriggerButton',
				DestinationAddress: '#DocumentSearch-Results-Popover-TriggerButton-{~D:Record.IDDocument~}',
			},
		],
};

},{"pict-view":733}],1544:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-BridgesPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */
/** @typedef {(bridge: any) => void} BridgeSelectionCallback */

class HeadlightPaneBridges extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.dataLakeBridgeClient = this.fable.instantiateServiceProvider('RestClient', 'LakeBridgeClient');

		this.CurrentBridgeSearchResults = [];
		this.CurrentSearchFiltersCount = 0;
		this.StateAbbreviation = '';
		/**
		 * @type {BridgeSelectionCallback}
		 * @param {any} bridge
		 */
		this.bridgeSelectionCallback = (bridge) =>
		{
			// optional callback function to run when a bridge is selected
		};

		this.currentStart = 0;
		this.pageSize = 100;
	}

	/**
	 * This function is used to handle the search for bridges.
	 * @param {Event} event - The event that triggered the search
	 * @return {boolean} - Always returns false
	 */
	handleBridgeSearch(event)
	{
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#BridgeSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('BridgePanel-SearchResults-Container', this.pageSize, '2rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('BridgeSearchFilters', 'close');

		const tmpCounty = String(this.pict.ContentAssignment.readContent('#BridgesSearchCounty'));

		if (tmpCounty.trim().length > 0)
		{
			this.CountySearch = tmpCounty.trim();
		}
		else
		{
			this.CountySearch = false;
		}

		const tmpStructureNumber = String(this.pict.ContentAssignment.readContent('#BridgesSearchStructureNumber'));

		if (tmpStructureNumber.trim().length > 0)
		{
			this.StructureSearch = tmpStructureNumber.trim();
		}
		else
		{
			this.StructureSearch = false;
		}

		const tmpFacilityCarried = String(this.pict.ContentAssignment.readContent('#BridgesSearchFacilityCarried'));

		if (tmpFacilityCarried.trim().length > 0)
		{
			this.FacilityCarriedSearch = tmpFacilityCarried.trim();
		}
		else
		{
			this.FacilityCarriedSearch = false;
		}

		const tmpFeatureIntersected = String(this.pict.ContentAssignment.readContent('#BridgesSearchFeatureIntersected'));

		if (tmpFeatureIntersected.trim().length > 0)
		{
			this.FeatureIntersectedSearch = tmpFeatureIntersected.trim();
		}
		else
		{
			this.FeatureIntersectedSearch = false;
		}

		const tmpYearBuilt = String(this.pict.ContentAssignment.readContent('#BridgesSearchYearBuilt'));

		if (tmpYearBuilt.trim().length > 0)
		{
			this.YearBuiltSearch = tmpYearBuilt.trim();
		}
		else
		{
			this.YearBuiltSearch = false;
		}

		this.currentStart = 0;

		this.loadBridgeData();
		return false;
	}

	/**
	 * This function is used to load the bridges from the lake.
	 * @return {void}
	 */
	loadBridgeData()
	{
		// get the state filter for the user
		this.pict.providers.ConfigurationProvider.getConfigurationByScope(this.AppData?.CurrentUser?.CustomerID,
		(pResult) =>
		{
			// set the state abbreviation for the user (if it exists)
			this.StateAbbreviation = pResult?.StateAbbreviation;
			// set the search filters to pass to the provider
			const tmpFilters = {
				County: this.CountySearch,
				StructureNumber: this.StructureSearch,
				FacilityCarried: this.FacilityCarriedSearch,
				FeatureIntersected: this.FeatureIntersectedSearch,
				YearBuilt: this.YearBuiltSearch,
				Start: this.currentStart,
				PageSize: this.pageSize,
				StateAbbreviation: this.StateAbbreviation,
			};
			// perform the search
			this.pict.providers.BridgeProvider.performBridgeSearch(tmpFilters, (pError, pBridgeResults) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error rendering HeadlightPanels-Bridges-SearchResults: ${pError}`);
					this.pict.views.HeadlightPanels?.toast?.({
						message: `<strong>Error loading bridge search results:</strong><br/><em>${pError.message || pError}</em>`,
						type: 'is-danger',
					});
					return;
				}
				this.CurrentBridgeSearchResults = pBridgeResults;
				this.pict.views.HeadlightPaneBridges.renderAsync('HeadlightPanels-Bridges-SearchResults', '#BridgePanel-SearchResults-Container', null, null,
					(pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error rendering HeadlightPanels-Bridges-SearchResults: ${pError}`);
						}
						document.getElementById('BridgeSearch-SearchButton')?.classList?.remove('is-loading');
					});
			});
		});
	}

	/**
	 * This function is used to reset the search filters and reload the bridges from the lake.
	 * @return {boolean} - Always returns
	 */
	resetSearchFilters()
	{
		document.getElementById('BridgeSearch-SearchButton')?.classList?.add('is-loading');

		this.pict.ContentAssignment.assignContent('#BridgesSearchStructureNumber', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchFacilityCarried', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchYearBuilt', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchFeatureIntersected', '');
		this.pict.ContentAssignment.assignContent('#BridgesSearchCounty', '');

		this.StructureSearch = false;
		this.FacilityCarriedSearch = false;
		this.YearBuiltSearch = false;
		this.FeatureIntersectedSearch = false;
		this.CountySearch = false;

		this.currentStart = 0;

		this.loadBridgeData();

		return false;
	}

	/**
	 * This function is used to handle the selection of a bridge from the search results.
	 * @param {string} pIDBridge - The ID of the bridge that was selected
	 * @return {void}
	 */
	handleBridgeSelection(pIDBridge)
	{
		if (this.bridgeSelectionCallback)
		{
			if (this.CurrentBridgeSearchResults.length > 0)
			{
				const tmpBridge = this.CurrentBridgeSearchResults.find((pBridge) => pBridge.IDBridge == pIDBridge);
				this.bridgeSelectionCallback(tmpBridge);
				this.pict.views.HeadlightPanels.handlePanelToggle('Bridges', 'close');
			}
		}
	}

	/**
	 * This function is used to set the callback that is run when a bridge is selected from the search results.
	 * @param {BridgeSelectionCallback} fCallback - The callback function to run when a bridge is selected
	 * @return {void}
	 */
	setBridgeSelectionCallback(fCallback)
	{
		this.bridgeSelectionCallback = fCallback;
	}

	/**
	 * This function is used to handle the opening of the bridge panel from the advanced button.
	 * @param {Event} event - The event that triggered the opening of the bridge panel
	 */
	openBridgePanelFromAdvancedButton(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			event.preventDefault();
			// find the parent column of the advanced button
			const tmpParentColumn = event.target.closest('.column');
			// if the parent column exists
			if (tmpParentColumn)
			{
				this.fable.HeadlightPanels.applyUIHighlight(tmpParentColumn);
			}
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Bridges', 'open', () =>
		{
			this.pict.ContentAssignment.setAttribute('#HeadlightPanels-BridgesPanel', 'data-panel-mode', 'add-to-set');
		});
	}
}

module.exports = HeadlightPaneBridges;
// additional view-specific templates
const viewSpecificTemplates = [
	/* Bridge Search Templates - overrides to the default views */
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults',
		Template: /*html*/`
		<div id="HeadlightPanels-Bridges-SearchResults" class="container table-container">
			<table class="table is-striped is-hoverable is-fullwidth">
				<thead>
					<tr>
						<th>County</th>
						<th>Facility Carried</th>
						<th>Feature Intersected</th>
						<th class="has-text-right">Structure #</th>
						<th class="has-text-right">Year Built</th>
						{~T:HeadlightPanels-Bridges-SearchResults-Extra-Header~}
						{~T:HeadlightPanels-Bridges-SearchResults-Selection-Header~}
					</tr>
				</thead>
				<tbody id="HeadlightPanels-Bridges-ResultsEntries">
					{~TS:HeadlightPanels-Bridges-SearchResults-Row:Context[0].CurrentBridgeSearchResults~}
					{~TIfAbs:HeadlightPanels-Bridges-SearchResults-NoResults:Context[0]:Context[0].CurrentBridgeSearchResults.length^==^0~}
				</tbody>
			</table>
		</div>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Row',
		Template: /*html*/`
		<tr>
			<td>{~E:FIPSCounty^Record.IDFIPSCounty^HeadlightPanels-Bridges-SearchResults-County-Row-Cell~}</td>
			<td>{~D:Record.FacilityCarried~}</td>
			<td>{~D:Record.FeatureIntersected~}</td>
			<td class="has-text-right">{~D:Record.StructureNumber~}</td>
			<td class="has-text-right">{~D:Record.YearBuilt~}</td>
			{~T:HeadlightPanels-Bridges-SearchResults-Extra-Column:Record~}
			{~T:HeadlightPanels-Bridges-SearchResults-Selection-Column:Record~}
		</tr>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-NoResults',
		Template: /*html*/`
		<tr>
			<td colspan="5" class="has-text-centered">
				<span class="icon">
					<i class="fa fa-fw fa-info-circle"></i>
				</span>
				<span class="icon-text">No results found</span>
			</td>
		</tr>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-County-Row-Cell',
		Template: /*html*/`{~D:Record.Name~} {~D:Record.GUIDFIPSCounty~}`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Selection-Header',
		Template: /*html*/`<th class="has-text-centered" data-panel-mode-show-if="add-to-set">Select</th>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Selection-Column',
		Template: /*html*/`
		<td class="has-text-centered is-vcentered" data-panel-mode-show-if="add-to-set">
			<button type="button" class="button p-0 is-ghost has-text-primary-75" onclick="_Pict.views.HeadlightPaneBridges.handleBridgeSelection('{~D:Record.IDBridge~}')">
				<span class="icon">
					<i class="fa fa-fw fa-lg fa-plus-circle"></i>
				</span>
			</button>
		</td>`,
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Extra-Header',
		Template: /*html*/``, // This is intentionally blank
	},
	{
		Hash: 'HeadlightPanels-Bridges-SearchResults-Extra-Column',
		Template: /*html*/``, // This is intentionally blank
	},
	{
		Hash: 'HeadlightPanels-Bridges-ActiveFilterCount',
		Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
	},
];
// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];

const viewSpecificRenderables =
[
	{
		RenderableHash: 'HeadlightPanels-Bridges-SearchResults',
		TemplateHash: 'HeadlightPanels-Bridges-SearchResults',
		DestinationAddress: '#BridgePanel-SearchResults-Container',
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Renderables = [ ..._ViewConfiguration.Renderables, ...viewSpecificRenderables ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1545:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-CustomPaneHtml-View'];

class HeadlightPaneCustom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = HeadlightPaneCustom;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1546:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-DocumentsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */
/** @typedef {(bridge: any) => void} BridgeSelectionCallback */

class HeadlightPaneDocuments extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.Intent = { type: 'none', handler: () =>
		{} };
	}

	closeHandler()
	{
		console.log('[HeadlightPaneDocuments] Documents panel closed.');
		// Reset the intent on close.
		this.resetIntent();
		this.pict.views.DocumentSearch.setMode('none');
	}

	resetIntent()
	{
		this.Intent = { type: 'none', handler: () =>
		{} };
	}

	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(pCallback)
	{
		// set the callback that runs when the search results are returned
		this.pict.views.DocumentSearch.setDocumentSearchResultsCallback((pResults) =>
		{
			// collapse the filter panel
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('DocumentSearchFilters', 'close');
			// render the pagination controls
			this.pict.views.DocumentSearch.renderAsync('DocumentSearch-Results', '#DocumentSearch-Results-Container', false, () =>
			{
				// TODO: is this the proper location for this? Should we be using the Entity object?
				const tmpDocuments = this.AppData?.DocumentData;
				if (tmpDocuments)
				{
					// for each Document, if the Document is already included, toggle the button to "on"
					pResults.forEach((pResult) =>
					{
						if (tmpDocuments.find((obs) => obs.IDDocument === pResult.IDDocument))
						{
							document.querySelector(`[data-document-add-context="${pResult.IDDocument}"]`)?.classList?.add('is-active');
						}
					});
				}
			});
		});
		// set the default search filter options for the Document search view
		this.pict.views.DocumentSearch.setCurrentSearchFilters({
			PageSize: 30,
		});
		// render each tab's view; a failure in one must not strand the others
		this.renderTabView('DocumentSearch');
		this.renderTabView('DocumentCreate');
		this.renderTabView('DocumentCurrent');

		if (!this.pict.AppData.DocumentData?.ReportData?.IDDocument)
		{
			const currentTab = document.getElementById('HeadlightPanels-DocumentPanel-Current-Tab');
			if (currentTab)
			{
				currentTab.classList.add('is-hidden');
			}
		}

		// the panel opens in this callback, so we need to wait for it to open before we can build the included Documents list
		if (pCallback)
		{
			pCallback();
		}
	}
}

module.exports = HeadlightPaneDocuments;
// additional view-specific templates
const viewSpecificTemplates = [
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1547:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-NavigationPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneNavigation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// local copy of the navigation list objects
		this.navigationList = [];
		// local copy of the custom navigation list objects
		this.customNavigationList = [];
		// handle the href vs onclick for custom navigation items
		this.pict.MetaTemplate.addPattern('{~CustomNavItemHandler:', '~}', (pHash, pData, fCallback) =>
		{
			// if the url is set, use that as the href
			if (pData && pData.href)
			{
				return `href="${pData.href}" onclick="_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'close');"`; // close the navigation panel after clicking
			}
			// if the navigationHandler is set, use that as the onclick handler
			else if (pData && pData.navigationHandler)
			{
				return `onclick="_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'close', ()=>{${pData.navigationHandler}});"`;
			}
			// otherwise, use the default onclick handler to toggle a panel
			else
			{
				return `onclick="_Pict.views.HeadlightPanels.handlePanelToggle('${pData.name}');"`;
			}
		});
	}

	compileNavigation()
	{
		if (this.pict.settings.HeadlightPanels.Configuration.CustomNavigationList)
		{
			this.compileCustomNavigationList();
		}
		else if (this.pict.settings.HeadlightPanels.Configuration.NavigationList)
		{
			this.compileNavigationList();
		}
		else
		{
			this.pict.log.error('No NavigationList or CustomNavigationList found in the configuration, skipping Navigation panel');
			return;
		}
	}

	/**
	 * Compile the navigation list based on the configuration that has been passed in at the start with
	 * the NavigationList property via the HeadlightPanels.Configuration object
	 * @return {void}
	 */
	compileNavigationList()
	{
		// if the navigation list is already populated, skip processing it again (creating duplicates, etc)
		if (this.navigationList.length)
		{
			return;
		}
		// get the navigation list
		const tempNavList = this.pict.settings.HeadlightPanels.Configuration.NavigationList;

		if (!tempNavList || tempNavList.length === 0)
		{
			this.pict.log.error('No NavigationList found in the configuration, skipping Navigation panel');
			return;
		}

		for (let i = 0; i < tempNavList.length; i++)
		{
			// for each item in the list, look up if there's a corresponding panel and add it to the list
			const tempPanel = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((p) => p.name === tempNavList[i].toLowerCase());
			if (tempPanel)
			{
				this.navigationList.push(tempPanel);
			}
			// if the item is a special case, add it to the list
			// TODO: We should expand this to be more dynamic when we find other special cases we want to add
			else if (tempNavList[i] === 'DownloadDocument')
			{
				this.navigationList.push({
					displayName: 'Download PDF',
					iconClass: 'fa-file-pdf',
					hideOniOS: true,
					navigationHandler: '_Pict.views.HeadlightPaneNavigation.handleDocumentDownload(event)',
				});
			}
			else if (tempNavList[i] === 'CloneDataToNewForm')
			{
				if (this.pict.providers.DocumentProvider && !this.pict.providers.DocumentProvider.canCreateDocument())
				{
					continue;
				}
				this.navigationList.push({
					displayName: 'Clone Data to New Form',
					iconClass: 'fa-copy',
					navigationHandler: '_Pict.views.DocumentCurrent.cloneDataFromForm()',
				});
			}
			else
			{
				this.pict.log.warn(`Panel ${tempNavList[i]} not found in the PanelList, skipping Navigation item`);
			}
		}
		// Secret panel for users with role index 4 or higher
		if (this.pict.AppData?.CurrentUser?.UserRoleIndex >= 4)
		{
			this.pict.log.info('User role allows for custom navigation list, checking for CustomNavigationList');
			this.navigationList.push({
				'location': 'right',
				'name': 'secret',
				'displayName': 'Secrets',
				'iconClass': 'fa-person-to-portal',
				'view': 'HeadlightPaneSecret',
			});
		}

		this.renderAsync(() =>
		{
			this.pict.log.info('Custom panel configuration set. Re-rendering the panels.');
		});
	}

	compileCustomNavigationList()
	{
		// if the navigation list is already populated, skip processing it again (creating duplicates, etc)
		if (this.customNavigationList.length)
		{
			return;
		}

		this.customNavigationList = this.pict.settings.HeadlightPanels.Configuration.CustomNavigationList || [];

		/* Example of a custom navigation list items
		...,
		{
			Hash: 'Locations',
			Name: 'Locations Of Interest',
			Icon: 'fas fa-location-dot',
			Address: '#/Location/List',
			PanelSource: null
		},
		{
			Hash: 'Settings',
			Name: 'Settings',
			Icon: 'fas fa-cog',
			Address: null,
			PanelSource: 'HeadlightPanels-Settings',
		}
		...,
		*/

		const tmpNavList = [];
		for (let i = 0; i < this.customNavigationList.length; i++)
		{
			// for each item in the list, look up if there's a corresponding panel and add it to the list
			if (this.customNavigationList[i].PanelSource)
			{
				const tmpPanel = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((p) => p.name === this.customNavigationList[i].PanelSource.toLowerCase());
				if (tmpPanel)
				{
					tmpNavList.push(tmpPanel);
				}
				else
				{
					this.pict.log.warn(`Panel ${this.customNavigationList[i].PanelSource} not found in the PanelList, skipping Navigation item`);
				}
			}
			// use the configuration passed in to the custom navigation list
			else
			{
				tmpNavList.push({
					name: this.customNavigationList[i].Hash.toLowerCase(),
					displayName: this.customNavigationList[i].Name || 'Custom Panel',
					iconClass: this.customNavigationList[i].Icon || 'fas fa-wrench',
					href: this.customNavigationList[i].Address || null,
					navigationHandler: this.customNavigationList[i].NavigationHandler || null,
					hideOniOS: this.customNavigationList[i].HideOniOS || false,
				});
			}
		}
		// finally, we just replace the navigationList with the custom navigation list and render it
		// TODO: Do this better, this is a bit of a hack bc I don't want to change the templates right now to avoid regressions
		this.navigationList = tmpNavList;

		// Secret panel for users with role index 4 or higher
		if (this.pict.AppData?.CurrentUser?.UserRoleIndex >= 4)
		{
			this.pict.log.info('User role allows for custom navigation list, checking for CustomNavigationList');
			this.navigationList.push({
				'location': 'right',
				'name': 'secret',
				'displayName': 'Secrets',
				'iconClass': 'fa-person-to-portal',
				'view': 'HeadlightPaneSecret',
			});
		}
		this.renderAsync(() =>
		{
			this.pict.log.info('Custom panel configuration set. Re-rendering the panels.');
		});
	}

	/**
	 * Handle the download of the document
	 * @param {Event} event - The event object
	 * @return {void}
	 */
	async handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading', 'is-dark', 'button');

			// The server re-renders the PDF from the SERVER-PERSISTED FormData,
			// so flush any unsaved in-memory form state first or the download is
			// stale — same root cause as the form-conversion export (PD-8714).
			// Locked documents are read-only and have nothing to save.
			const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
			if (tmpReportData && !tmpReportData.Locked)
			{
				const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync(true);
				if (tmpSaveError)
				{
					this.pict.log.error('Failed to save document before download; the downloaded PDF may be out of date.', tmpSaveError);
					this.pict.views.HeadlightPanels.toast({
						message: 'Could not save the latest changes — the downloaded PDF may be out of date.',
						type: 'is-warning',
					});
				}
			}

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, null, () =>
			{
				element.classList.remove('is-loading', 'is-dark', 'button');
			});
		}
	}

	handleInspectionPanelToggle(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading', 'is-dark', 'button');

			// download the pdf
			this.pict.views.HeadlightPanels.handlePanelToggle('Inspection', 'toggle', () =>
			{
				element.classList.remove('is-loading', 'is-dark', 'button');
			});
		}
	}

	/**
	 * Toggle the download dropdown menu using HeadlightModal.
	 * Loads form conversion options on first open.
	 * @param {Event} pEvent - The click event from the download button
	 * @return {void}
	 */
	async toggleDownloadDropdown(pEvent)
	{
		// If the menu is already open, toggle it closed.
		if (this._downloadMenuOpen)
		{
			this.fable.HeadlightModal.dismissAnchoredMenu();
			this._downloadMenuOpen = false;
			return;
		}

		// Show loading state on the button while fetching schemas
		const tmpButton = document.getElementById('HeadlightPanels-NavBar-Download-Button');
		if (!this._FormConversionSchemasLoaded && tmpButton)
		{
			tmpButton.classList.add('is-loading');
			try
			{
				await this._loadFormConversionSchemas();
			}
			finally
			{
				tmpButton.classList.remove('is-loading');
			}
		}

		// Build the menu items
		let tmpMenuItems = /*html*/`
			<a class="panel-block" onclick="_Pict.views.HeadlightPaneNavigation.handleDropdownPDFDownload(event)">
				<span class="panel-icon"><i class="fas fa-fw fa-file-pdf"></i></span>
				Download PDF
			</a>`;

		if (this._FormConversionSchemas && this._FormConversionSchemas.length > 0)
		{
			for (const tmpSchema of this._FormConversionSchemas)
			{
				const tmpTitle = tmpSchema.Title || ('Template ' + tmpSchema.IDManifestSchema);

				// Determine the file type icon from the template Artifact's mime type
				let tmpIconClass = 'fa-file-arrow-down';
				const tmpMime = tmpSchema.TemplateMimeType || '';
				if (tmpMime.includes('pdf'))
				{
					tmpIconClass = 'fa-file-pdf';
				}
				else if (tmpMime.includes('spreadsheet') || tmpMime.includes('excel') || tmpMime.includes('ms-excel'))
				{
					tmpIconClass = 'fa-file-excel';
				}

				tmpMenuItems += /*html*/`
					<a class="panel-block" onclick="_Pict.views.HeadlightPaneNavigation.handleFormConversionDownload(${tmpSchema.IDManifestSchema}, event)">
						<span class="panel-icon"><i class="fas fa-fw ${tmpIconClass}"></i></span>
						${tmpTitle}
					</a>`;
			}
		}

		// Anchor the menu to the download button. PSM's dropdown handles positioning,
		// auto-flip, viewport clamping, and outside-click / Escape dismissal — the anchor
		// is excluded from its outside-click test, so this button's onclick toggles cleanly.
		const tmpDownloadButton = document.getElementById('HeadlightPanels-NavBar-Download-Button');
		this._downloadMenuOpen = true;
		const tmpMenu = this.fable.HeadlightModal.spawnAnchoredMenu(
			tmpDownloadButton,
			/*html*/`<nav class="panel" style="background-color:var(--bulma-scheme-main);">${tmpMenuItems}</nav>`,
			{ position: 'above', align: 'left' });
		if (tmpMenu && typeof tmpMenu.then === 'function')
		{
			tmpMenu.then(() => { this._downloadMenuOpen = false; });
		}
	}

	/**
	 * Load form conversion schemas from the provider and cache them.
	 * @return {Promise<void>}
	 * @private
	 */
	async _loadFormConversionSchemas()
	{
		try
		{
			const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
			if (!tmpReportData || !tmpReportData.DocumentType || !tmpReportData.IDProject)
			{
				this._FormConversionSchemasLoaded = true;
				this._FormConversionSchemas = [];
				return;
			}

			this._FormConversionSchemas = await this.pict.providers.FormConversionProvider
				.getFormConversionSchemasForDocument(tmpReportData.DocumentType, tmpReportData.IDProject);

			this._FormConversionSchemasLoaded = true;
		}
		catch (pError)
		{
			this.pict.log.error('Error loading form conversion schemas for download dropdown:', pError);
			this._FormConversionSchemas = [];
			this._FormConversionSchemasLoaded = true;
		}
	}

	/**
	 * Handle downloading the standard PDF from the download modal.
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handleDropdownPDFDownload(pEvent)
	{
		this.fable.HeadlightModal.dismissModals();
		this.handleDocumentDownload(pEvent);
	}

	/**
	 * Handle downloading a filled form conversion template.
	 * @param {number} pIDManifestSchema - The ManifestSchema ID to fill
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	async handleFormConversionDownload(pIDManifestSchema, pEvent)
	{
		this.fable.HeadlightModal.dismissModals();

		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData || !tmpReportData.IDDocument)
		{
			this.pict.log.error('No document data available for form conversion download.');
			return;
		}

		this.pict.views.HeadlightPanels.toast({
			message: 'Generating filled template...',
			type: 'is-success',
		});

		// The fill-<IDManifestSchema> renderer fills the template from the
		// SERVER-PERSISTED FormData, not the in-memory form. If the user just
		// changed an input — e.g. a MaterialsEntitySelector whose dependent
		// fields are computed asynchronously after entity-bundle fetches — the
		// latest values may not have reached the server yet, so the exported
		// file would be stale (PD-8714). Flush the current form state with an
		// awaited save before downloading. Locked documents are read-only and
		// have nothing to save, so skip the save for them.
		if (!tmpReportData.Locked)
		{
			const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync(true);
			if (tmpSaveError)
			{
				this.pict.log.error('Failed to save document before form conversion download; the exported file may be out of date.', tmpSaveError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Could not save the latest changes — the exported file may be out of date.',
					type: 'is-warning',
				});
			}
		}

		// Create a download link using the fill-<IDManifestSchema> renderer.
		// The fill URL is otherwise byte-for-byte identical on every export, so
		// the browser (or any intermediate HTTP cache) can serve a previously
		// rendered, now-stale PDF even after the document has been re-saved with
		// new values (PD-8714). Append a unique cache-buster so each export is a
		// distinct request and the server re-fills from the latest saved
		// FormData. The extra query parameter is ignored by the renderer.
		const tmpCacheBuster = `${Date.now()}-${this.pict.getUUID()}`;
		const tmpDownloadLink = document.createElement('a');
		tmpDownloadLink.href = `/1.0/Document/${tmpReportData.IDDocument}/Load/fill-${pIDManifestSchema}?cachebuster=${tmpCacheBuster}`;
		tmpDownloadLink.classList.add('is-hidden');
		tmpDownloadLink.download = '';
		document.body.appendChild(tmpDownloadLink);
		tmpDownloadLink.click();
		document.body.removeChild(tmpDownloadLink);
	}
}

module.exports = HeadlightPaneNavigation;

// additional view-specific templates
const viewSpecificTemplates = [
	{
		// TODO: Make this path less brittle, need to understand local scoping variables to templates better
		Hash: 'HeadlightPanels-NavigationPanel-NavList',
		Template: /*html*/`{~TS:HeadlightPanels-NavigationPanel-NavItem:Context[0].navigationList~}`,
	},
	{
		Hash: 'HeadlightPanels-NavigationPanel-NavItem',
		Template: /*html*/`
		<a class="panel-block {~HideOniOS:Record.hideOniOS~}" {~CustomNavItemHandler:Record~}>
			<span class="panel-icon">
				<i class="fas fa-fw {~D:Record.iconClass~}" aria-hidden="true"></i>
			</span>
			{~D:Record.displayName~}
		</a>`,
	},
	// This is an example of a button that is not part of the navigation list that we want to add to the navigation panel
	{
		Hash: 'HeadlightPanels-NavigationPanel-ExtraButton',
		Template: /*html*/`
		<a class="panel-block is-hidden" onclick="_Pict.views.HeadlightPanels.handlePanelToggle('Secret')">
			<span class="panel-icon">
				<i class="fas fa-fw fa-person-to-portal" aria-hidden="true"></i>
			</span>
			Secrets
		</a>`,
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1548:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ObservationsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneObservations extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// the location to inject an observation into the DOM, if set
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.AddImageTargetDisplayName = '';
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object
	 */
	onBeforeRender(pRenderable)
	{
		this.pict.views.ObservationIncluded.buildIncludedObservationsList(false);

		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback to run after the view is rendered
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object
	 */
	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(fCallback, pRenderable)
	{
		super.onAfterRenderAsync((pError) =>
		{
			// set the callback that runs when the search results are returned
			this.pict.views.ObservationSearch.setObservationSearchResultsCallback((pResults) =>
			{
				// collapse the filter panel
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters', 'close');
				// render the pagination controls
				this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Results', '#ObservationSearch-Results-Container', false, false, () =>
				{
					this.log.info('Observation Search results rendered');
				});
			});
			// set the search filters for the observation search view
			this.pict.views.ObservationSearch.setCurrentSearchFilters({
				PageSize: 15,
			});
			// render each tab's view; a failure in one must not strand the others
			this.renderTabView('ObservationSearch');

			// set the instance configuration for the observation create media view, then render it
			try
			{
				this.pict.views.ObservationCreateMedia.setInstanceConfiguration({
					IDProject: this.AppData?.DocumentData?.ReportData?.IDProject || 0,
					IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0,
					IDDocument: this.AppData?.DocumentData?.ReportData?.IDDocument || 0,
				});
				this.pict.views.ObservationCreateMedia.render();
			}
			catch (pRenderError)
			{
				this.log.error(`Failed to render the ObservationCreateMedia tab: ${pRenderError?.message || pRenderError}`);
			}
			// render the set view
			this.renderTabView('ObservationSet');

			// the panel opens in this callback, so we need to wait for it to open before we can build the included observations list
			if (fCallback)
			{
				fCallback(pError);
			}
		}, pRenderable);
	}

	/**
	 * This function is used to clear the observation panel target and the banner on the header. The removes the "add mode" flow.
	 * @return {void}
	 */
	clearObservationPanelTarget()
	{
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.pict.views.HeadlightPanels.ModePanelLeft = '';
		this.pict.views.HeadlightPanels.ModePanelRight = '';
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', '');
		// hide the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = '';

		this.pict.views.ObservationSearch.setMode('');
	}

	/**
	 * This function is used to handle the selection of an observation detail view or adding an observation to the document.
	 * @param {object} event - The click event
	 * @param {number} pIDObservation - The ID of the observation to add to the document
	 * @param {string} pBackState - The state to return to when the observation detail view is closed
	 * @return {void}
	 */
	handleObservationImagePreviewClick(event, pIDObservation, pBackState)
	{
		this.showObservationDetailView(event, pIDObservation, pBackState);
	}

	/**
	 * This function is used to handle the selection of an observation detail view or adding an observation to the document.
	 * @param {object} event - The click event
	 * @param {number} pIDObservation - The ID of the observation to add to the document
	 */
	async handleObservationAddToProjectFileClick(event, pIDObservation)
	{
		// if in Add Mode, add the observation to project files
		if (document.getElementById('HeadlightPanels-ObservationPanel').getAttribute('data-panel-mode') !== 'add-to-folder')
		{
			this.pict.log.error('Observation Panel is not in "add" mode. Cannot add observation to project files.', { pIDObservation });
			return;
		}
		// and attach it to the project file folder
		await this.handleObservationListSelection(event, pIDObservation, 'add-to-folder');
		// then, re-render the view target
		//FIXME: this is "sharing" the callback with another view, seems like a bad idea
		// const tmpInjectionMethod = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onAfterCallback;
		// if (tmpInjectionMethod)
		// {
		// 	await tmpInjectionMethod([ { IDObservation: pIDObservation } ], event);
		// }
	}

	/**
	 * This function is used to remove an observation from a document.
	 * @param {number} pIDObservation - The observation id to remove from the document
	 * @return {Promise<boolean>}
	 */
	async addObservationToDocument(pIDObservation)
	{
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return false;
		}
		// check if the observation is already included in the document
		const includedObservation = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		if (includedObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is already included in the document.',
				type: 'is-warning',
			});
			return false;
		}
		// we should push the observation record to the document observation list for consistency (not just the ID)
		const tmpObservationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		if (!tmpObservationRecord)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is not found in the system.',
				type: 'is-danger',
			});
			return false;
		}
		// add the observation to the document
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations.concat(tmpObservationRecord);
		}
		else
		{
			this.AppData.DocumentData.ReportData.Observations = [ tmpObservationRecord ];
		}
		// show a success message
		this.pict.views.HeadlightPanels.toast({
			message: 'The observation has been added to the document.',
			type: 'is-success',
		});
		return true;
	}

	/**
	 * This function is used to remove an observation from a document.
	 * @param {number} pIDObservation - The observation id to remove from the document
	 * @return {boolean}
	 */
	removeObservationFromDocument(pIDObservation)
	{
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return false;
		}
		// check if the observation is already included in the document
		const includedObservation = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		if (!includedObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is not included in the document.',
				type: 'is-warning',
			});
			return false;
		}
		// remove the observation from the document
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations.filter((observation) => observation.IDObservation != pIDObservation);
		}
		else
		{
			this.AppData.DocumentData.ReportData.Observations = [];
		}
		// show a success message
		this.pict.views.HeadlightPanels.toast({
			message: 'The observation has been removed from the document.',
			type: 'is-success',
		});
		return true;
	}

	closeHandler()
	{
		// Clear any Add/QuickCapture buttons in ObservationCardDeck inputs that were left in an
		// `is-loading` state by an add flow the user has now dismissed (X, escape, background click,
		// or toggling a different panel). Without this, the button stays stuck because the flow's
		// onAfterCallback (which normally removes the class) only fires when the add completes.
		this.pict.providers?.ObservationCardDeckProvider?.clearPendingAddButtonLoadingState?.();
		this.pict.views.ObservationSearch.setMode('add-to-document');
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterDocumentJoinCallback = undefined;
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = undefined;
	}

	/**
	 * This function is used to handle the addition of an observation to a document.
	 * @param {Event} event - The click event
	 * @param {object} pIDObservation - The observation id to add to the document
	 * @param {string} pAction - The action to take (add or remove)
	 * @param {boolean} [pClosePanel=false] - Whether to close the panel after the action is completed
	 * @return {Promise<void>}
	 * @async
	 */
	async handleObservationListSelection(event, pIDObservation, pAction, pClosePanel = false)
	{
		// prevent the panels from closing
		if (event)
		{
			event.stopPropagation();
			event.preventDefault();
		}
		let observationRecord = this.pict.views.ObservationSearch.CurrentSearchResults?.find((/** @type {{ IDObservation: any; }} */ observation) => observation.IDObservation == pIDObservation);
		if (!observationRecord)
		{
			this.log.warn('Failed to find observation record from search results. Doing a look up for this record...', { pIDObservation });
			// if the observation is not found in the search results, try to get it from the provider
			observationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		}
		// check if the observation is already included in the document
		switch (pAction)
		{
		case 'add-to-document':
			await this.addObservationToDocument(observationRecord.IDObservation);
			// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the added observation
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'add', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
			}
			break;
		case 'add-to-folder':
		case 'add-to-root':
			await this.pict.views.ProjectFileSearch.addObservationToProjectFolderRecord(observationRecord);
			break;
		case 'add-to-set':
			// join to the document record
			if (this.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				// if record is not already in the document, add it
				const tmpObservations = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(observationRecord.IDObservation);
				if (!tmpObservations)
				{
					this.AppData.DocumentData.ReportData.Observations.push(observationRecord);
				}
				// add the observation to the active observation set entity (not just the document)
				if (this.pict.views.ObservationSet?.ActiveObservationSet)
				{
					await this.pict.views.ObservationSet.addObservationToSet(observationRecord.IDObservation);
					this.pict.views.HeadlightPanels.toast({
						message: `Observation added to ${this.pict.views.ObservationSet.ActiveObservationSet.Name || 'Observation Set'}.`,
						type: 'is-success',
					});
				}
				else
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'The observation has been added to the document.',
						type: 'is-success',
					});
				}
				// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the added observation
				if (this.pict.providers.ObservationCardDeckProvider)
				{
					await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'add', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Sets');
				}
			}
			break;
		case 'remove-from-set':
			// nothing to do here
			break;
		case 'remove-from-document':
			this.removeObservationFromDocument(observationRecord.IDObservation);
			// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the removed observation
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'remove', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
			}
			break;
		case 'remove-from-folder':
			this.pict.views.ProjectFileSearch.removeObservationFromProjectFolderRecord(observationRecord);
			break;
		default:
			this.log.warn('Invalid action for observation selection', { pAction });
			break;
		}
		// save the document now that the observation list is in order. handleSaveAsync resolves WITH the save
		// error (it does not reject), so inspect the returned value — a try/catch here would never fire.
		const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync();
		if (tmpSaveError)
		{
			this.pict.log.error('Failed to save document!', tmpSaveError);
			this.pict.views.HeadlightPanels.toast({
				message: 'Failed to save document!',
				type: 'is-danger',
			});
		}
		// rebuild the included observations list now that the document is saved
		this.pict.views.ObservationIncluded.buildIncludedObservationsList(true);

		// don't clear/close by default - the user may want to add more observations
		if (pClosePanel)
		{
			// finally, close the observation panel and clear the target
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
			// clear the observation panel target and the banner on the header
			this.pict.views.HeadlightPaneObservations.clearObservationPanelTarget();
		}
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();

		// gross
		this.hackyBridgeStuffToSeparateOutLater();
		// also gross
		this.handleMediaUploadCallbacks(event, pIDObservation, pAction);
	}

	// TODO: Relocate this asafp
	hackyBridgeStuffToSeparateOutLater()
	{
		// TODO: This logic should be abstracted away from here so that the panels don't need to know about the ElementConditions view.
		if (this.pict.views?.ElementConditions?.findAllOrphanObservations)
		{
			this.pict.views.ElementConditions.findAllOrphanObservations();
		}
	}

	// TODO: Relocate this asafp
	async handleMediaUploadCallbacks(event, pIDObservation, pAction)
	{
		// then, re-render the view target
		//FIXME: this is "sharing" the callback with another view, seems like a bad idea
		const tmpInjectionMethod = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onAfterCallback;
		if (tmpInjectionMethod)
		{
			await tmpInjectionMethod([ { IDObservation: pIDObservation } ], event);
		}
		// adding to the grossness
		const tmpFallbackCallback = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onFallbackCallback;
		if (pAction === 'add-to-document' && tmpFallbackCallback)
		{
			await tmpFallbackCallback([ { IDObservation: pIDObservation } ], event);
		}
	}

	/**
	 * This function is used to set the observation panel target and the banner on the header. This sets the "add mode" flow.
	 * @param {string} pViewHash - The hash of the view that the observation is being added to
	 * @param {string} pInputHash - The hash of the input that the observation is being added to
	 * @param {string} pInputName - The name of the input that the observation is being added to
	 * @param {string} [pMode] - The mode to set the observation panel to (add, remove, etc.)
	 * @return {void}
	 */
	setObservationPanelTarget(pViewHash, pInputHash, pInputName, pMode)
	{
		const tmpMode = pMode || 'add-to-set';
		this.AddImageTargetView = pViewHash;
		this.AddImageTargetInput = pInputHash;
		this.AddImageTargetDisplayName = pInputName;
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', `${tmpMode}`);
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = `${tmpMode}`;
		this.pict.views.HeadlightPanels.ModePanelRight = `${tmpMode}`;
		// set the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = pInputName;
		this.pict.views.ObservationSearch.setMode(pMode);
	}

	/**
	 * Open the observation detail view for the selected observation to view the full details
	 * @param {object} event - The click event
	 * @param {number|string} pIDObservation - The ID of the observation to view
	 * @param {string} pBackTo - The view to return to when the observation detail view is closed
	 * @param {function} [pCallback] - The callback to run after the observation detail view is rendered
	 * @return {Promise<void>}
	 * @async
	 */
	async showObservationDetailView(event, pIDObservation, pBackTo, pCallback)
	{
		// set the view to return to when the observation detail view is closed
		this.pict.views.ObservationDetails.ObservationDetailsBackTo = pBackTo;
		if (pBackTo && document.getElementById('HeadlightPanels-ObservationPanel').getAttribute('data-panel-mode') === 'add-to-set')
		{
			this.pict.views.ObservationDetails.ObservationDetailsBackToSet = true;
		}
		else
		{
			this.pict.views.ObservationDetails.ObservationDetailsBackToSet = false;
		}

		if (event)
		{
			event.currentTarget.classList.add('is-active');
		}
		await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation).then((pResult) =>
		{
			this.pict.views.ObservationDetails.ActiveObservationDetails = pResult;
		});
		// open the panel if it is not already open
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
		// render the observation detail view
		this.pict.views.ObservationDetails.renderAsync(false, false, false, false, () =>
		{
			this.log.info('Observation Details View Rendered with Active Record', this.pict.views.ObservationDetails.ActiveObservationDetails);
			if (pCallback)
			{
				pCallback();
			}
		});
	}
}

module.exports = HeadlightPaneObservations;
// additional view-specific templates
const viewSpecificTemplates = [];
// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1549:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ProfilePaneHtml-View'];

class HeadlightPaneProfile extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	navigateToProfileApp(event)
	{
		const hostParts = document.location.host.split('.');
		hostParts.shift(); // remove current application
		hostParts.unshift('profile');
		const profileURL = '//' + hostParts.join('.');
		window.open(profileURL, '_blank');
	}
}

module.exports = HeadlightPaneProfile;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1550:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SamplesPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSamples extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(pCallback)
	{
		// set the callback that runs when the search results are returned
		this.pict.views.SampleSearch.setSampleSearchResultsCallback((pResults) =>
		{
			// collapse the filter panel
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters', 'close');
			// render the pagination controls
			this.pict.views.SampleSearch.renderAsync('SampleSearch-Results', '#SampleSearch-Results-Container', false, false, () =>
			{
				// TODO: is this the proper location for this? Should we be using the Entity object?
				const tmpSamples = this.AppData?.DocumentData?.ReportData?.Samples;
				if (tmpSamples)
				{
					// for each Sample, if the Sample is already included, toggle the button to "on"
					pResults.forEach((pResult) =>
					{
						if (tmpSamples.find((obs) => obs.IDSample === pResult.IDSample))
						{
							document.querySelector(`[data-sample-add-context="${pResult.IDSample}"]`)?.classList?.add('is-active');
						}
					});
				}
			});
		});
		// set the default search filter options for the sample search view
		this.pict.views.SampleSearch.setCurrentSearchFilters({
			PageSize: 20,
		});
		// render each tab's view; a failure in one must not strand the others
		// (SampleCurrent's data still loads lazily, when its tab is opened)
		this.renderTabView('SampleSearch');
		this.renderTabView('SampleCreate');
		this.renderTabView('SampleScan');
		this.renderTabView('SampleCurrent');

		// the panel opens in this callback, so we need to wait for it to open before we can build the included samples list
		if (pCallback)
		{
			pCallback();
		}
	}

	closeHandler()
	{
		if (this.pict.views.SampleScan)
		{
			this.pict.views.SampleScan.stopScanWorkflow();
		}
		this.pict.providers.QRCodeProvider.closeScanner();
	}

	/**
	 * This function is used to set the callback that is run when a sample is selected from the search results.
	 * @param {function} fCallback - The callback function to run when a sample is selected
	 * @return {void}
	 */
	setSampleSelectionCallback(fCallback)
	{
		this.pict.views.SampleSearch.sampleSelectionCallback = fCallback;
	}

	/**
	 * This function is used to handle the opening of the Sample panel from the advanced button.
	 * @param {Event} event - The event that triggered the opening of the Sample panel
	 */
	openSamplePanelFromAdvancedButton(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			event.preventDefault();
			// find the parent column of the advanced button
			const tmpParentColumn = event.target.closest('.column');
			// if the parent column exists
			if (tmpParentColumn)
			{
				this.fable.HeadlightPanels.applyUIHighlight(tmpParentColumn);
			}
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
		{
			this.pict.ContentAssignment.setAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode', 'add-to-set');
		});
	}

	/**
	 * Open the Samples panel straight to the Current tab. Entry point for the navbar Current Samples
	 * button, which is only visible when this document actually has Samples joined to it.
	 * @param {Event} [event] - The click event
	 * @return {void}
	 */
	openCurrentSamplesTab(event)
	{
		if (event)
		{
			event.preventDefault();
		}
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample');
			this.pict.views.SampleCurrent.handleTabOpened();
		});
	}

	/**
	 * This function is used to clear the Sample panel target and the banner on the header. The removes the "add mode" flow.
	 * @return {void}
	 */
	clearSamplePanelTarget()
	{
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.pict.views.HeadlightPanels.ModePanelLeft = '';
		this.pict.views.HeadlightPanels.ModePanelRight = '';
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-SamplePanel').setAttribute('data-panel-mode', '');
		// hide the banner on the header that you are adding an Sample
		document.getElementById('HeadlightPanels-SamplePanel-Sample-Header-Mode-Target').innerText = '';
	}
}

module.exports = HeadlightPaneSamples;
// additional view-specific templates
const viewSpecificTemplates = [
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1551:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SecretPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSecret extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Toggle the minimum input length for search queries - ex: either 0 or 2
	 * Used to make it easier to search for samples, etc. when server-side searching is enabled
	 * @param {Number} pValue - The value to set the minimum input length to
	 * @return {void}
	 */
	toggleMinimumInputLengthForSearch(pValue)
	{
		// set the minimum input length for search queries
		this.pict.views.HeadlightPanels.MinimumInputLengthForSearch = pValue || 0;
		// re-render the search view to update the search input field
		this.pict.PictApplication.changeTheme('Edit');
	}

	handleDocumentRefreshAndDownload(event)
	{
		if (event)
		{
			// set the button to be loading
			event.target.classList.add('is-loading', 'is-dark', 'button');
		}
		// download the pdf with the forced refresh flag set
		this.pict.providers.DocumentProvider.handleDocumentDownload(true, null, () =>
		{
			event.target.classList.remove('is-loading', 'is-dark', 'button');
		});
	}
}

module.exports = HeadlightPaneSecret;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1552:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SettingsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSettings extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.getLocallyStoredTheme();
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback function to call after rendering
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object to render
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		const tmpPanelSettings = this.AppData.CurrentUser?.Settings;
		if (!tmpPanelSettings || !tmpPanelSettings.HeadlightPanels)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to load the user preferences.');
		}
		else
		{
			for (const [ key, value ] of Object.entries(tmpPanelSettings.HeadlightPanels))
			{
				if (value)
				{
					const setting = document.getElementById(`setting-${key}`) ||
						document.getElementById(`setting-${key}-${value}`);
					if (setting)
					{
						setting.classList.add('is-active');
					}
				}
			}
		}
		this.syncAutoSaveSettings();
		super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Resolve the shared auto-save provider, if this application has one.
	 * @return {any}
	 */
	get autoSaveProvider()
	{
		return this.pict.providers?.AutoSave;
	}

	/**
	 * Paint the auto-save rows from the provider's effective state.
	 *
	 * Called on every render of this pane, because the pane is built on demand and the state it shows
	 * is a blend of the form manifest and the user's stored preference.
	 * @return {void}
	 */
	syncAutoSaveSettings()
	{
		const tmpToggle = document.getElementById('setting-AutoSave');
		const tmpIntervalBlock = document.getElementById('setting-AutoSaveIntervalSeconds');
		const tmpNote = document.getElementById('setting-AutoSave-Note');
		if (!tmpToggle || !tmpIntervalBlock || !tmpNote)
		{
			return;
		}
		const tmpState = this.autoSaveProvider?.getUserFacingState?.();
		// No auto-save provider, or an application with no form to save: hide the controls rather than
		// offering a preference that could not do anything.
		if (!tmpState || !tmpState.Available)
		{
			tmpToggle.classList.add('is-hidden');
			tmpIntervalBlock.classList.add('is-hidden');
			tmpNote.classList.add('is-hidden');
			return;
		}
		tmpToggle.classList.remove('is-hidden');
		tmpToggle.classList.toggle('is-active', tmpState.Enabled);
		// onAfterRenderAsync's generic preference sweep stamps is-active on any `setting-<Key>` element
		// whose stored value is truthy, which catches the interval block because the cadence is a number.
		// It holds an input, not a toggle, so clear it.
		tmpIntervalBlock.classList.remove('is-active');

		// Locked means the user cannot change it from here — the form manifest opted out, or the document
		// belongs to another customer — so the row goes inert. A reason without a lock (impersonation,
		// which only moves the default) still explains itself but leaves the toggle live.
		tmpToggle.classList.toggle('is-disabled', tmpState.Locked);
		tmpNote.classList.toggle('is-hidden', !tmpState.Reason);
		if (tmpState.Reason)
		{
			tmpNote.textContent = tmpState.Reason;
		}

		// The cadence only means anything while auto-save is on.
		tmpIntervalBlock.classList.toggle('is-hidden', !tmpState.Enabled || tmpState.Locked);

		const tmpInput = /** @type {HTMLInputElement} */ (document.getElementById('setting-AutoSaveIntervalSeconds-Input'));
		if (tmpInput)
		{
			tmpInput.min = String(tmpState.MinimumIntervalSeconds);
			tmpInput.max = String(tmpState.MaximumIntervalSeconds);
			tmpInput.value = String(tmpState.IntervalSeconds);
		}
	}

	/**
	 * Turn auto-save on or off for this user, across every form they open.
	 * @return {void}
	 */
	toggleAutoSave()
	{
		const tmpState = this.autoSaveProvider?.getUserFacingState?.();
		if (!tmpState || !tmpState.Available || tmpState.Locked)
		{
			return;
		}
		this.updateUserPreferences('AutoSave', !tmpState.Enabled);
		// Take effect on the document already open rather than at the next page load.
		this.autoSaveProvider.reconfigure();
		this.syncAutoSaveSettings();
	}

	/**
	 * Persist the auto-save cadence, in seconds.
	 *
	 * Wired to the field's change event, so it fires once the user leaves the field or presses Enter
	 * rather than on every keystroke. The value is clamped to the range auto-save supports and echoed
	 * back into the field: the min/max attributes only gate the spinner, so a typed-in 5 would otherwise
	 * sit there reading 5 while auto-save quietly ran at 15.
	 *
	 * @param {string|number} pSeconds - The entered interval, in seconds.
	 * @return {void}
	 */
	setAutoSaveInterval(pSeconds)
	{
		const tmpState = this.autoSaveProvider?.getUserFacingState?.();
		const tmpInput = /** @type {HTMLInputElement} */ (document.getElementById('setting-AutoSaveIntervalSeconds-Input'));
		const tmpSeconds = Math.round(Number(pSeconds));
		if (!Number.isFinite(tmpSeconds) || tmpSeconds <= 0)
		{
			this.log.warn(`Ignoring an unusable auto-save interval: ${pSeconds}`);
			// Put the field back to the value that is actually in effect.
			if (tmpInput && tmpState)
			{
				tmpInput.value = String(tmpState.IntervalSeconds);
			}
			return;
		}
		const tmpMinimum = tmpState?.MinimumIntervalSeconds ?? 15;
		const tmpMaximum = tmpState?.MaximumIntervalSeconds ?? 3600;
		const tmpClamped = Math.min(tmpMaximum, Math.max(tmpMinimum, tmpSeconds));
		if (tmpInput)
		{
			tmpInput.value = String(tmpClamped);
		}
		this.updateUserPreferences('AutoSaveIntervalSeconds', tmpClamped);
		// Re-arming restarts the countdown, which is what someone who just changed the cadence expects.
		this.autoSaveProvider?.reconfigure?.();
	}

	/**
	 * Check the user settings for an active chip type that is passed in.
	 * @param {string} pType - The chip type to check for
	 * @return {boolean} - Whether the chip type is active or not
	 * @example
	 * checkChipTypeActive('New');
	 * checkChipTypeActive('ExternalDatabaseIDs');
	 */
	checkChipTypeActive(pType)
	{
		return this.AppData.CurrentUser?.Settings?.HeadlightPanels?.ActiveChipTypes?.includes(pType);
	}

	/**
	 * This function is used to get the user preferences for the headlight panels.
	 * @param {string} pSetting - The setting to get the user preference for
	 * @return {any} - The user preference for the setting
	 * @example
	 * readUserPrefrence('DocumentTheme');
	 * readUserPrefrence('NavBarLocation');
	 */
	readUserPreference(pSetting)
	{
		const tmpPanelSettings = this.AppData.CurrentUser?.Settings;
		if (!tmpPanelSettings)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to load the user preferences.');
			return;
		}
		// create the HeadlightPanels object if it doesn't exist
		if (!tmpPanelSettings.hasOwnProperty('HeadlightPanels'))
		{
			this.log.warn('No HeadLightPanel user settings found to load the user preferences.');
			return;
		}
		return this.AppData.CurrentUser?.Settings?.HeadlightPanels?.[pSetting];
	}

	/**
	 * This function is used to render the user preferences for the headlight panels and apply them to the document.
	 * @return {void}
	 * @async
	 */
	/**
	 * Resolve the current user's HeadlightPanels preference bag, creating it if this is their first visit.
	 * @return {Object|null} The preference object, or null when there is no user to read preferences from
	 */
	getUserPanelPreferences()
	{
		// these settings are only applicable in interactive mode
		if (!this.AppData.Interactive)
		{
			return null;
		}
		const tmpPanelSettings = this.AppData.CurrentUser?.Settings;
		if (!tmpPanelSettings)
		{
			return null;
		}
		// create the HeadlightPanels object if it doesn't exist
		if (!tmpPanelSettings.hasOwnProperty('HeadlightPanels'))
		{
			tmpPanelSettings.HeadlightPanels = {};
		}
		return tmpPanelSettings.HeadlightPanels;
	}

	/**
	 * Apply the preferences that decide what the very first paint looks like.
	 *
	 * These come straight off the already-loaded CurrentUser record -- there is no fetch to wait on -- and
	 * the navbar's position is baked into the template at render time. Applying them after the render
	 * means the navbar renders in the default position and then visibly jumps to the user's, taking a
	 * body-class reflow with it; the same goes for the theme and the page width.
	 * @return {void}
	 */
	applyPreRenderUserPreferences()
	{
		const tmpPanelPreferences = this.getUserPanelPreferences();
		if (!tmpPanelPreferences)
		{
			return;
		}
		// if a theme is set, apply it to the document
		if (tmpPanelPreferences.hasOwnProperty('DocumentTheme'))
		{
			this.toggleDocumentColorTheme(tmpPanelPreferences.DocumentTheme, true);
		}
		// if a screen width is set, apply it to the document
		//widescreen, fancy, standard
		if (!tmpPanelPreferences.hasOwnProperty('ScreenWidth'))
		{
			tmpPanelPreferences.ScreenWidth = 'standard';
		}
		this.toggleScreenWidth(tmpPanelPreferences.ScreenWidth, true);
		// set the navbar location based on the user's preference (this moves the navbar to the top or bottom of the screen)
		if (tmpPanelPreferences.NavBarLocation)
		{
			this.toggleNavbarLocation(tmpPanelPreferences.NavBarLocation, true);
		}
	}

	loadUserPreferences()
	{
		const tmpPanelPreferences = this.getUserPanelPreferences();
		if (this.AppData.Interactive && !tmpPanelPreferences)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to load the user preferences.');
			return;
		}
		if (!tmpPanelPreferences)
		{
			return;
		}
		// re-applying the first-paint preferences is a no-op; this keeps the call correct on its own
		// for any caller that reaches loadUserPreferences() without the pre-render pass having run
		this.applyPreRenderUserPreferences();
		// the rest need the rendered panel elements, so they can only run after the render
		// set the lefty mode based on the user's preference (this inverts the left and right panel locations)
		if (tmpPanelPreferences.LeftyMode)
		{
			this.toggleLeftyMode(tmpPanelPreferences.LeftyMode, true);
		}
		// handle the state of all active chips based on the user's preference
		if (tmpPanelPreferences.ActiveChipTypes?.length)
		{
			tmpPanelPreferences.ActiveChipTypes.forEach((chip) => this.toggleChipTypeActive(null, chip, true, true));
		}
		// handle the state of the help text based on the user's preference
		if (tmpPanelPreferences.HelpText !== undefined)
		{
			this.toggleHelpText(tmpPanelPreferences.HelpText, true);
		}
	}

	/**
	 * This function is used to toggle the theme of the application between light and dark styling.
	 * This will also store the user's preference in the current user object on the server.
	 * @param {string} pTheme - The theme to set the application to if provided (system, light, dark)
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	*/
	toggleDocumentColorTheme(pTheme, skipSave = false)
	{
		document.documentElement.setAttribute('data-theme', pTheme);

		// NOTE: This is to clear out the old location of the theme in the user settings
		if (this.AppData?.CurrentUser?.Settings.hasOwnProperty('Theme'))
		{
			delete this.AppData.CurrentUser.Settings.Theme;
		}

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('DocumentTheme', pTheme);
	}

	/**
	 * This function is used to get the theme from localStorage for the application,
	 * and toggle between light, dark and system themes.
	 * @return {void}
	*/
	getLocallyStoredTheme()
	{
		const storedTheme = localStorage.getItem('data-theme');
		const themeIcon = document.getElementById('themeIcon');

		if (!themeIcon) return;
		// remove icon classes on init so correct icon displays on toggle
		themeIcon.classList.remove('fa-desktop');
		themeIcon.classList.remove('fa-sun');
		themeIcon.classList.remove('fa-moon');

		// Apply the theme from localStorage as default
		if (storedTheme)
		{
			document.documentElement.setAttribute('data-theme', storedTheme);
		}
		else
		{
			// if there is no stored theme, default to light theme
			document.documentElement.setAttribute('data-theme', 'light');
			localStorage.setItem('data-theme', 'light');
			themeIcon.classList.add('fa-sun');
		}
		if (storedTheme === 'system')
		{
			// if theme is system add desktop icon
			themeIcon.classList.add('fa-desktop');
			themeIcon.title = 'Change the theme to dark mode.';
		}
		// todo: take out this trash, does checking for && storedTheme is dark defeat the purpose of checking user preference? not sure but this makes it work
		else if ((window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) && storedTheme === 'dark')
		{
			document.documentElement.setAttribute('data-theme', 'dark');
			localStorage.setItem('data-theme', 'dark');
			themeIcon.classList.add('fa-moon');
			themeIcon.title = 'Change the theme to light mode.';
		}
		else
		{
			document.documentElement.setAttribute('data-theme', 'light');
			localStorage.setItem('data-theme', 'light');
			themeIcon.classList.add('fa-sun');
			themeIcon.title = 'Change the theme to system mode.';
		}
	}

	/**
	 * This function is used to get the theme from localStorage for the application,
	 * and toggle between light, dark and system themes.
	 * @return {void}
	*/
	toggleLocallyStoredTheme()
	{
		const themeIcon = document.getElementById('themeIcon');

		if (!themeIcon) return;

		if (themeIcon.classList.contains('fa-moon'))
		{
			themeIcon.classList.remove('fa-moon');
			themeIcon.classList.add('fa-sun');
			themeIcon.title = 'Change the theme to system mode.';
			localStorage.setItem('data-theme', 'light');
			document.documentElement.setAttribute('data-theme', 'light');
		}
		else if (themeIcon.classList.contains('fa-sun'))
		{
			themeIcon.classList.remove('fa-sun');
			themeIcon.classList.add('fa-desktop');
			themeIcon.title = 'Change the theme to dark mode.';
			localStorage.setItem('data-theme', 'system');
			document.documentElement.setAttribute('data-theme', 'system');
		}
		else
		{
			themeIcon.classList.remove('fa-desktop');
			themeIcon.classList.add('fa-moon');
			themeIcon.title = 'Change the theme to light mode.';
			localStorage.setItem('data-theme', 'dark');
			document.documentElement.setAttribute('data-theme', 'dark');
		}
	}

	/**
	 * This function is used to toggle the help text visibility on the document.
	 * @param {boolean} pHelpText - The value to set the help text to if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	toggleHelpText(pHelpText, skipSave = false)
	{
		if (pHelpText === undefined)
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText = !this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText;
		}
		else
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText = pHelpText;
		}
		// handle the help text visibility on the document
		if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText)
		{
			document.body.classList.remove('has-hidden-help-text');
		}
		else
		{
			document.body.classList.add('has-hidden-help-text');
		}

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('HelpText', this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useHelpText);
	}

	/**
	 * This function is used to toggle between widescreen or standard for all documents.
	 * @param {boolean} pWidth - The value to set the document width if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	//TODO: add a 3rd option for "fancy" that is user defined width
	toggleScreenWidth(pWidth, skipSave = false)
	{
		if (pWidth === undefined)
		{
			this.pict.settings.HeadlightPanels.Configuration.ScreenWidth = 'standard';
		}
		else
		{
			this.pict.settings.HeadlightPanels.Configuration.ScreenWidth = pWidth;
		}
		// apply the widescreen to the document if one desktop
		const isPhoneDevice = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
		const alwaysWideScreenModeClass = 'always-widescreen-mode';
		// set view to default width and icon to standard (it wont be displayed
		// else icon to minimize if widescreen on desktop, else set to standard
		if (isPhoneDevice)
		{
			document.body.classList.remove(alwaysWideScreenModeClass);
			this.pict.providers.DocumentProvider.setScreenResizeIcon('standard');
		}
		else
		{
			if (this.pict.settings.HeadlightPanels.Configuration.ScreenWidth === 'widescreen')
			{
				document.body.classList.add(alwaysWideScreenModeClass);
			}
			else
			{
				document.body.classList.remove(alwaysWideScreenModeClass);
			}
			this.pict.providers.DocumentProvider.setScreenResizeIcon(this.pict.settings.HeadlightPanels.Configuration.ScreenWidth);
		}

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('ScreenWidth', this.pict.settings.HeadlightPanels.Configuration.ScreenWidth);
	}

	/**
	 * This function is used to toggle "lefty mode" for the application. This inverts all
	 * the panels to the opposite side of the screen for left-handed users.
	 * @param {boolean} pUseLeftyMode - The value to set the lefty mode to if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	toggleLeftyMode(pUseLeftyMode, skipSave = false)
	{
		if (pUseLeftyMode === undefined)
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode = !this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode;
		}
		else
		{
			this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode = pUseLeftyMode;
		}
		// hide the panels from jutting out on the opposite side of the screen from the switch
		if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode)
		{
			document.body.classList.add('use-lefty-mode');
			// animate the panels to the opposite side of the screen
			document.getElementById('HeadlightPanels-LeftPanel').classList.remove('animate__slideOutLeft');
			document.getElementById('HeadlightPanels-RightPanel').classList.remove('animate__slideOutRight');
			document.getElementById('HeadlightPanels-LeftPanel').classList.add('animate__slideOutRight');
			document.getElementById('HeadlightPanels-RightPanel').classList.add('animate__slideOutLeft');
		}
		else
		{
			document.body.classList.remove('use-lefty-mode');
			// remove old classes and reset back to the default side of the screen
			document.getElementById('HeadlightPanels-LeftPanel').classList.remove('animate__slideOutRight');
			document.getElementById('HeadlightPanels-RightPanel').classList.remove('animate__slideOutLeft');
			document.getElementById('HeadlightPanels-LeftPanel').classList.add('animate__slideOutLeft');
			document.getElementById('HeadlightPanels-RightPanel').classList.add('animate__slideOutRight');
		}
		// close any open panels to get us back to a clean slate
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('LeftyMode', this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode);
	}

	/**
	 * This function is used to toggle the location of the navbar between top and bottom.
	 * @param {string} pLocation - The location to set the navbar to if provided (top, bottom)
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 */
	toggleNavbarLocation(pLocation, skipSave = false)
	{
		let newLocation = '';
		if (!pLocation)
		{
			switch (this.pict.settings.HeadlightPanels.Configuration.NavBar.location)
			{
			case 'top':
				newLocation = 'bottom';
				break;
			case 'bottom':
				newLocation = 'top';
				break;
			default:
				newLocation = 'bottom';
			}
		}
		else
		{
			newLocation = pLocation;
		}
		// update the navbar location classes on the DOM
		// (the navbar element does not exist yet when this runs ahead of the first render -- the
		// configuration update below is what puts it in the right place to begin with)
		const navbar = document.getElementById('HeadlightPanels-NavBar');
		if (navbar)
		{
			navbar.classList.remove('is-fixed-' + this.pict.settings.HeadlightPanels.Configuration.NavBar.location);
			navbar.classList.add('is-fixed-' + newLocation);
		}
		document.body.classList.remove('has-navbar-fixed-' + this.pict.settings.HeadlightPanels.Configuration.NavBar.location);
		document.body.classList.add('has-navbar-fixed-' + newLocation);
		// update our configuration
		this.pict.settings.HeadlightPanels.Configuration.NavBar.location = newLocation;

		// save the user's preference if we're not skipping the save
		if (skipSave) return;

		this.updateUserPreferences('NavBarLocation', newLocation);
	}

	/**
	 * This function is used to toggle the visiblity of the a specific label type on the document.
	 * @param {object} event - The event object that triggered the function
	 * @param {string} pChip - The chip type to toggle the visibility of
	 * @param {boolean} pIsActive - The value to set the chip type to if provided
	 * @param {boolean} skipSave - Whether to skip saving the user's preference to the server
	 * @return {void}
	 * @example
	 * toggleChipTypeActive('ExternalDatabaseIDs', false);
	 * toggleChipTypeActive('New');
	 */
	toggleChipTypeActive(event, pChip, pIsActive, skipSave = false)
	{
		// if an event was passed in, prevent the default behavior (like clicking a link or toggling date picker)
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		// get the user settings object
		const tmpCurrentUserSettings = this.AppData?.CurrentUser?.Settings;
		if (!tmpCurrentUserSettings)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to save the chip type visibility.');
			return;
		}
		// make sure the user settings object exists
		if (!tmpCurrentUserSettings.hasOwnProperty('HeadlightPanels'))
		{
			tmpCurrentUserSettings.HeadlightPanels = {};
		}
		if (!tmpCurrentUserSettings.HeadlightPanels.hasOwnProperty('ActiveChipTypes'))
		{
			tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = [];
		}
		// if the value is not provided, toggle the chip type
		if (pIsActive === undefined)
		{
			if (tmpCurrentUserSettings?.HeadlightPanels?.ActiveChipTypes?.includes(pChip))
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.filter((chip) => chip !== pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.remove('is-active'));
			}
			else
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.push(pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.add('is-active'));
			}
		}
		else
		{
			if (pIsActive)
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.push(pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.add('is-active'));
			}
			else
			{
				tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes.filter((chip) => chip !== pChip);
				document.querySelectorAll(`[data-chip-for="${pChip}"]`).forEach((chip) => chip.classList.remove('is-active'));
			}
		}
		// filter out duplicates
		tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes = [ ...new Set(tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes) ];
		// save the user's preference if we're not skipping the save
		if (skipSave) return;
		// tell the server to update (but no need to wait for it to finish)
		this.pict.services.HeadlightDocumentService.updateUserSettings(
			{ HeadlightPanels: { ActiveChipTypes: tmpCurrentUserSettings.HeadlightPanels.ActiveChipTypes } });
	}

	/**
	 * This function is used to bus various settings for the user.
	 *
	 * Booleans and strings additionally paint the matching `setting-<Key>` / `setting-<Key>-<value>`
	 * panel row. Numbers (the auto-save cadence) are stored and persisted but painted by their own
	 * control, since a numeric field has no active/inactive row to toggle.
	 * @param {string} pSetting - The setting to update
	 * @param {boolean|string|number} pValue - The value to set the setting to
	 * @return {void}
	 * @example
	 * updateUserPreferences('LeftyMode', true);
	 * updateUserPreferences('Theme', 'dark');
	 */
	updateUserPreferences(pSetting, pValue)
	{
		const tmpCurrentUserSettings = this.AppData?.CurrentUser?.Settings;
		if (!tmpCurrentUserSettings)
		{
			// if we don't have a user, we can't save their preferences
			this.log.warn('No user settings found to save the user preferences.');
			return;
		}
		if (!tmpCurrentUserSettings.hasOwnProperty('HeadlightPanels'))
		{
			tmpCurrentUserSettings.HeadlightPanels = {};
		}
		if (!tmpCurrentUserSettings.HeadlightPanels.hasOwnProperty(pSetting))
		{
			tmpCurrentUserSettings.HeadlightPanels[pSetting] = false;
		}
		tmpCurrentUserSettings.HeadlightPanels[pSetting] = pValue;
		// tell the server to update (but no need to wait for it to finish). The changed key is passed
		// because an impersonated session saves onto the real user's record and must not carry the
		// impersonated user's other preferences across with it.
		this.pict.services.HeadlightDocumentService.updateUserSettings({ HeadlightPanels: { [pSetting]: pValue } });
		// if the setting is a boolean, toggle the class on the setting element
		if (typeof pValue === 'boolean')
		{
			const tmpPanelBlock = document.getElementById(`setting-${pSetting}`);
			if (tmpPanelBlock)
			{
				if (pValue)
				{
					tmpPanelBlock.classList.add('is-active');
				}
				else
				{
					tmpPanelBlock.classList.remove('is-active');
				}
			}
			else
			{
				this.log.warn(`No panel block found for setting ${pSetting}`);
			}
		}
		// if the setting is a string, set the class on the setting element
		else if (typeof pValue === 'string')
		{
			// clear all classes on the setting element by getting a partial id match
			const tmpPanelBlocks = document.querySelectorAll(`[id^="setting-${pSetting}-"]`);
			tmpPanelBlocks.forEach((block) =>
			{
				block.classList.remove('is-active');
			});
			// set the class on the setting element
			const tmpPanelBlock = document.getElementById(`setting-${pSetting}-${pValue}`);
			if (tmpPanelBlock)
			{
				tmpPanelBlock.classList.add('is-active');
			}
			else
			{
				this.log.warn(`No panel block found for setting ${pSetting}-${pValue}`);
			}
		}
	}
}

module.exports = HeadlightPaneSettings;

module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1553:[function(require,module,exports){
const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SolverPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSolver extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
	/** @param {()=>void} pCallback */
	onAfterRenderAsync(pCallback)
	{
		this.pict.views.PictFormsSolver.renderAsync(pCallback);
	}
}

module.exports = HeadlightPaneSolver;

module.exports.default_configuration = _ViewConfiguration;

// additional view-specific templates
const viewSpecificTemplates = [];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1554:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-StatusPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
 * Create an element with classes and, optionally, text. Server values (statuses, action and user names)
 * only ever reach the DOM through here as text, never as markup.
 * @param {string} pTag - The tag name
 * @param {string} [pClassName] - Space-separated classes
 * @param {any} [pText] - Text content; null or undefined leaves the element empty
 * @return {HTMLElement}
 */
function createElement(pTag, pClassName, pText)
{
	const tmpElement = document.createElement(pTag);
	if (pClassName)
	{
		tmpElement.className = pClassName;
	}
	if ((pText !== undefined) && (pText !== null))
	{
		tmpElement.textContent = String(pText);
	}
	return tmpElement;
}

/**
 * A Bulma panel icon: `<span class="panel-icon"><i class="fa fa-fw <icon>"></i></span>`.
 * @param {string} pIconClass - The Font Awesome icon class
 * @return {HTMLElement}
 */
function createPanelIcon(pIconClass)
{
	const tmpIconWrapper = createElement('span', 'panel-icon');
	tmpIconWrapper.appendChild(createElement('i', `fa fa-fw ${pIconClass}`));
	return tmpIconWrapper;
}

class HeadlightPaneStatus extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// Approval payloads from the last open, so reopening paints immediately instead of waiting on
		// three round-trips. Keyed by document: the same pane serves whatever document is loaded, and
		// showing one document's approvals under another would be worse than a slow open. A successful
		// approval action discards it (refreshApprovalRegions, or the page reload), so it never outlives
		// the user's own change.
		this.ApprovalCache = { IDDocument: null, State: undefined, Users: undefined, History: undefined };
		// True while a cached copy is on screen and the fresh copy is still in flight. Approval actions
		// stay disabled for that window -- painting a stale action live would let the user act on an
		// approval state the server has already moved past.
		this.ApprovalRevalidating = false;
	}

	/**
	 * Read a cached approval payload, discarding the cache if it belongs to a different document.
	 * @param {string} pKey - Which payload (State, Users, History)
	 * @return {any} The cached payload, or undefined when there is nothing usable
	 */
	getCachedApproval(pKey)
	{
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument ?? null;
		if (this.ApprovalCache.IDDocument !== tmpIDDocument)
		{
			this.ApprovalCache = { IDDocument: tmpIDDocument, State: undefined, Users: undefined, History: undefined };
		}
		return this.ApprovalCache[pKey];
	}

	/**
	 * Store an approval payload against the document it was fetched for.
	 * @param {string} pKey - Which payload (State, Users, History)
	 * @param {any} pValue - The payload to keep
	 * @return {void}
	 */
	setCachedApproval(pKey, pValue)
	{
		this.ApprovalCache.IDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument ?? null;
		this.ApprovalCache[pKey] = pValue;
	}

	/**
	 * Drop the cached approval payloads and repaint whichever status regions are on screen, after an
	 * approval action moved the document without reloading the page. A region that is not rendered
	 * fetches fresh the next time the pane opens.
	 * @return {Promise<void>}
	 */
	async refreshApprovalRegions()
	{
		this.ApprovalCache = { IDDocument: null, State: undefined, Users: undefined, History: undefined };
		this.ApprovalRevalidating = false;
		this.paintStatusHeader();
		const tmpBuilds = [];
		if (document.getElementById('HeadlightPanels-StatusPanel-Approval-Actions-Content'))
		{
			tmpBuilds.push(this.buildApprovalActionButtons());
		}
		if (document.getElementById('HeadlightPanels-StatusPanel-Users-Content'))
		{
			tmpBuilds.push(this.buildApprovalUserList());
		}
		if (document.getElementById('HeadlightPanels-StatusPanel-History-Content'))
		{
			tmpBuilds.push(this.buildApprovalLogs());
		}
		await Promise.all(tmpBuilds);
	}

	/**
	 * Repaint the pane's heading (status name, icon and colour) from the document's current status. The
	 * template draws it once when the pane renders, so a status change without a reload has to repaint it.
	 * @return {void}
	 */
	paintStatusHeader()
	{
		const tmpHeader = document.getElementById('HeadlightPanels-StatusPanel-Status-Header');
		if (!tmpHeader)
		{
			return;
		}
		const tmpStatus = this.pict.AppData?.DocumentData?.ReportData?.Status || '';
		const tmpStyle = this.pict.providers.DocumentProvider.getApprovalStatusStyle(tmpStatus);
		tmpHeader.className = `panel-heading ${tmpStyle.backgroundColor}`;
		const tmpIcon = document.getElementById('HeadlightPanels-StatusPanel-Status-Header-Icon');
		if (tmpIcon)
		{
			tmpIcon.className = `fas fa-fw ${tmpStyle.iconClass}`;
		}
		const tmpTitle = document.getElementById('HeadlightPanels-StatusPanel-Status-Header-Title');
		if (tmpTitle)
		{
			tmpTitle.textContent = tmpStatus;
		}
	}

	onAfterRenderAsync(pCallback)
	{
		this.buildApprovalActionButtons();
		this.buildApprovalUserList();
		this.buildApprovalLogs();

		// the panel opens in this callback, so we need to wait for it to open before we can build the content
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Replace a status region's contents -- including its loading skeleton -- with a single message.
	 *
	 * Shared by the empty and the failed states so a region never keeps spinning: the pane HTML ships
	 * a `skeleton-block` placeholder per region, and whatever happens it has to be painted over.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {string} pMessage - The message to display
	 * @return {void}
	 */
	renderPanelMessage(pPanel, pMessage)
	{
		const tmpNotification = document.createElement('div');
		tmpNotification.className = 'notification has-text-text-light is-dark m-3';
		tmpNotification.textContent = pMessage;
		pPanel.innerHTML = '';
		pPanel.appendChild(tmpNotification);
	}

	/**
	 * This function is used to build the approval action buttons for the status panel.
	 * @param {function} [pCallback] - The callback function to execute after the action buttons are built
	 * @return {Promise<void>}
	 * @async
	 */
	async buildApprovalActionButtons(pCallback)
	{
		const id = 'HeadlightPanels-StatusPanel-Approval-Actions-Content';
		const panel = document.getElementById(id);
		if (!panel)
		{
			this.log.error('Failed to find panel element', { id });
			return;
		}
		// Paint whatever the last open left us, so a reopen is not a blank wait, then revalidate behind it.
		const tmpCached = this.getCachedApproval('State');
		const tmpHadCache = (tmpCached !== undefined);
		if (tmpHadCache)
		{
			this.ApprovalRevalidating = true;
			this.paintApprovalActionButtons(panel, tmpCached);
		}
		else
		{
			this.renderPanelMessage(panel, 'Loading approval actions…');
		}
		let fetchedData;
		try
		{
			fetchedData = await this.fable.services.HeadlightDocumentService.fetchApprovalState();
		}
		catch (pError)
		{
			// The service rethrows on failure; unhandled, that both leaves this region on its loading
			// skeleton forever and surfaces as an unhandled rejection (the caller does not await us).
			this.log.error(`Failed to load the approval actions: ${pError?.message || pError}`);
			this.ApprovalRevalidating = false;
			if (tmpHadCache)
			{
				// A stale copy the user can act on beats an error message replacing content they can see;
				// re-enable it now that nothing fresher is coming.
				this.syncApprovalActionButtonState();
			}
			else
			{
				this.renderPanelMessage(panel, 'Could not load the approval actions. Reopen the panel to try again.');
			}
			if (pCallback)
			{
				pCallback();
			}
			return;
		}
		this.setCachedApproval('State', fetchedData);
		this.ApprovalRevalidating = false;
		// Only repaint when something actually moved -- an unnecessary rebuild throws away the buttons
		// the user is reaching for.
		if (!tmpHadCache || JSON.stringify(tmpCached) !== JSON.stringify(fetchedData))
		{
			this.paintApprovalActionButtons(panel, fetchedData);
		}
		// The panel is built on demand, so a save that started before it opened has to be reflected here
		// rather than only on the save-latch transition.
		this.syncApprovalActionButtonState();
		// optional callback
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * Paint the approval actions region from a payload. Split out so the cached copy and the freshly
	 * fetched copy go through exactly the same rendering.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {any} pData - The approval state payload
	 * @return {void}
	 */
	paintApprovalActionButtons(pPanel, pData)
	{
		// handle empty message display
		if (!pData?.Actions?.length)
		{
			this.renderPanelMessage(pPanel, 'No approval actions available at this time.');
			return;
		}
		pPanel.innerHTML = '';
		pData.Actions.forEach((item) =>
		{
			const newItem = document.createElement('a');
			newItem.classList.add('panel-block');
			// The marker is what syncApprovalActionButtonState finds; it survives this rebuild.
			newItem.setAttribute('data-approval-action', item);
			newItem.onclick = (event) => this.pict.providers.DocumentProvider.handleApprovalStatusChange(event, item);
			newItem.append(createPanelIcon(this.pict.providers.DocumentProvider.getApprovalStatusStyle(item).iconClass), createElement('span', '', item));
			pPanel.appendChild(newItem);
		});
		this.syncApprovalActionButtonState();
	}

	/**
	 * Disable the approval action buttons while the document is being written.
	 *
	 * An approval action changes the document server-side and usually locks it. Taken while a save is
	 * still in flight, the lock lands first and the resolving save is rejected -- the user's last edits
	 * are silently lost. Auto-save makes that window recur on a timer, so the buttons have to reflect
	 * the save latch rather than relying on the user not being quick.
	 *
	 * Derives entirely from provider state, so it is safe to call before the panel has been built.
	 * @return {void}
	 */
	syncApprovalActionButtonState()
	{
		const panel = document.getElementById('HeadlightPanels-StatusPanel-Approval-Actions-Content');
		if (!panel)
		{
			return;
		}
		const documentProvider = this.pict.providers?.DocumentProvider;
		const isBusy = Boolean(documentProvider?.IsSaving) || Boolean(documentProvider?.isTakingAction) || this.ApprovalRevalidating;
		let busyTitle = 'An approval action is already in progress.';
		if (documentProvider?.IsSaving)
		{
			busyTitle = 'Saving the document; approval actions are available once the save completes.';
		}
		else if (this.ApprovalRevalidating)
		{
			busyTitle = 'Checking the current approval state...';
		}
		panel.querySelectorAll('a[data-approval-action]').forEach((element) =>
		{
			element.classList.toggle('is-disabled', isBusy);
			if (isBusy)
			{
				element.setAttribute('aria-disabled', 'true');
				element.setAttribute('tabindex', '-1');
				element.setAttribute('title', busyTitle);
			}
			else
			{
				element.removeAttribute('aria-disabled');
				element.removeAttribute('tabindex');
				element.removeAttribute('title');
			}
		});
	}

	/**
	 * This function is used to build the approval logs for the document.
	 * @return {Promise<void>}
	 * @async
	 */
	async buildApprovalLogs()
	{
		const id = 'HeadlightPanels-StatusPanel-History-Content';
		const panel = document.getElementById(id);
		if (!panel)
		{
			this.log.error('Failed to find panel element', { id });
			return;
		}
		// Paint the last known history first; it is read-only, so a stale copy is harmless while we check.
		const tmpCached = this.getCachedApproval('History');
		const tmpHadCache = (tmpCached !== undefined);
		if (tmpHadCache)
		{
			this.paintApprovalLogs(panel, tmpCached);
		}
		/** @type {{ CreateDate: string, Status: string, AfterStatus: string }[]} */
		let fetchedData;
		try
		{
			fetchedData = await this.fable.services.HeadlightDocumentService.fetchApprovalHistory();
		}
		catch (pError)
		{
			this.log.error(`Failed to load the approval history: ${pError?.message || pError}`);
			if (!tmpHadCache)
			{
				this.renderPanelMessage(panel, 'Could not load the approval history. Reopen the panel to try again.');
			}
			return;
		}
		this.setCachedApproval('History', fetchedData);
		if (!tmpHadCache || JSON.stringify(tmpCached) !== JSON.stringify(fetchedData))
		{
			this.paintApprovalLogs(panel, fetchedData);
		}
	}

	/**
	 * Paint the approval history region from a payload.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {{ CreateDate: string, Status: string, AfterStatus: string }[]} pData - The history payload
	 * @return {void}
	 */
	paintApprovalLogs(pPanel, pData)
	{
		// handle empty message display
		if (!pData || !Array.isArray(pData) || pData.length === 0)
		{
			this.renderPanelMessage(pPanel, 'No logs available at this time.');
			return;
		}
		// sort by most recent first (on a copy -- the cached payload is shared with the next open)
		const tmpSorted = pData.slice().sort((a, b) => new Date(b.CreateDate).getTime() - new Date(a.CreateDate).getTime());
		pPanel.innerHTML = '';
		tmpSorted.forEach((item) =>
		{
			const newItem = document.createElement('div');
			newItem.classList.add('panel-block');
			// TODO:DOUG: CSS class clean up
			newItem.append(
				createElement('span', 'mr-1 has-text-text-65 has-text-weight-semibold', item.Status),
				createElement('i', 'fa fa-fw fa-arrow-right'),
				createElement('span', 'ml-1 has-text-weight-semibold', item.AfterStatus),
				createElement('span', 'is-size-7 ml-2 has-text-text-75 mt-1', ` on ${ this.fable.Dates.dayJS(item.CreateDate).format('MMMM DD, YYYY - hh:mm a') }`));
			pPanel.appendChild(newItem);
		});
	}

	/**
	 * This function is used to build the list of users that can approve the document.
	 * @return {Promise<void>}
	 * @async
	 */
	async buildApprovalUserList()
	{
		const id = 'HeadlightPanels-StatusPanel-Users-Content';
		const panel = document.getElementById(id);
		if (!panel)
		{
			this.log.error('Failed to find panel element', { id });
			return;
		}
		// Paint the last known approver list first; it is read-only, so a stale copy is harmless.
		const tmpCached = this.getCachedApproval('Users');
		const tmpHadCache = (tmpCached !== undefined);
		if (tmpHadCache)
		{
			this.paintApprovalUserList(panel, tmpCached);
		}
		let fetchedData;
		try
		{
			fetchedData = await this.fable.services.HeadlightDocumentService.fetchApprovalUsersList();
		}
		catch (pError)
		{
			this.log.error(`Failed to load the approval user list: ${pError?.message || pError}`);
			if (!tmpHadCache)
			{
				this.renderPanelMessage(panel, 'Could not load the approver list. Reopen the panel to try again.');
			}
			return;
		}
		this.setCachedApproval('Users', fetchedData);
		if (!tmpHadCache || JSON.stringify(tmpCached) !== JSON.stringify(fetchedData))
		{
			this.paintApprovalUserList(panel, fetchedData);
		}
	}

	/**
	 * Paint the approver list region from a payload.
	 * @param {HTMLElement} pPanel - The region element to fill
	 * @param {any[]} pData - The approver list payload
	 * @return {void}
	 */
	paintApprovalUserList(pPanel, pData)
	{
		// handle empty message display
		if (!pData || !Array.isArray(pData) || pData.length === 0)
		{
			this.renderPanelMessage(pPanel, 'No users available at this time.');
			return;
		}
		pPanel.innerHTML = '';
		pData.forEach((item) =>
		{
			const newItem = document.createElement('div');
			newItem.classList.add('panel-block');
			newItem.append(
				createPanelIcon('fa-user'),
				createElement('span', '', `${ item.NameFirst ?? '' } ${ item.NameLast ?? '' }`.trim()),
				createElement('span', 'has-text-text-65 is-size-7 pl-1', item.Title));
			pPanel.appendChild(newItem);
		});
	}

	/**
	 * This function is used to update the style of the approval status based on the status of the document.
	 * @param {string} pStatus - The status of the document
	 * @return {void}
	 * @example
	 * updateApprovalsStyleState('Draft');
	 * updateApprovalsStyleState('Submit');
	 */
	updateApprovalsStyleState(pStatus)
	{
		const documentStatus = pStatus || this.pict.AppData?.DocumentData?.ReportData?.Status;
		const backgroundColor = this.pict.providers.DocumentProvider.getApprovalStatusStyle(pStatus).backgroundColor;
		const iconClass = this.pict.providers.DocumentProvider.getApprovalStatusStyle(pStatus).iconClass;

		this.pict.fable.log.info(`Updating approval style state based on status: ${documentStatus}`, { iconClass, backgroundColor });
		this.pict.settings.HeadlightPanels.Configuration.NavBar.Brand.iconClass = iconClass;
		this.pict.settings.HeadlightPanels.Configuration.NavBar.Brand.wrapperClass = backgroundColor;
		this.pict.settings.HeadlightPanels.Configuration.CurrentStatus.iconClass = iconClass;
		this.pict.settings.HeadlightPanels.Configuration.CurrentStatus.wrapperClass = backgroundColor;
	}
}

module.exports = HeadlightPaneStatus;
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733}],1555:[function(require,module,exports){
const libPictView = require('pict-view');
const { v4: uuidv4 } = require('uuid');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ValidationsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
 * @typedef {Object} SeverityTreatment
 * @property {string} Label             - Human-readable label (e.g. "Warning").
 * @property {string} IconClass         - FontAwesome icon classes (e.g. "fas fa-fw fa-triangle-exclamation").
 * @property {string} AccentClass       - Bulma color modifier applied to the panel-block (e.g. "is-warning").
 * @property {string} TextClass         - Bulma text-color helper (e.g. "has-text-warning-dark").
 * @property {string} BackgroundClass   - Bulma background-tone helper (e.g. "has-background-warning-light").
 * @property {string} BorderColorVar    - CSS variable used for the left accent border (e.g. "var(--bulma-warning)").
 */

/**
 * @typedef {Object} LogInput
 * @property {string} Message
 * @property {string=} Severity         - One of the keys in the severity map (info, warning, error, success, debug, ...). Case-insensitive.
 * @property {function=} onClickHandler
 */

/**
 * @typedef {Object} ValidationLogEntry
 * @property {string} Key
 * @property {string} Log
 * @property {string} Severity
 * @property {function=} onClickHandler
 */

/**
 * @typedef {Object} ValidationsSection
 * @property {string} Key
 * @property {string} Name
 * @property {ValidationLogEntry[]} Logs
 * @property {boolean=} Collapsed              - Persistent collapse state, flipped by toggleSectionCollapse.
 * @property {string=} ToggleKey               - Computed in onBeforeRenderAsync; identifies the collapsible group in DOM data attributes.
 * @property {string=} HiddenClass             - Computed in onBeforeRenderAsync; 'is-hidden' when Collapsed, '' otherwise.
 * @property {string=} ChevronIconClass        - Computed in onBeforeRenderAsync; 'fa-chevron-right' when Collapsed, 'fa-chevron-down' otherwise.
 */

/**
 * Default severity treatments. Forms can extend or override these via
 * `registerSeverityTreatments(...)` instead of editing this file.
 *
 * @type {Record<string, SeverityTreatment>}
 */
const DEFAULT_SEVERITY_MAP =
{
	info:
	{
		Label: 'Info',
		IconClass: 'fas fa-fw fa-circle-info',
		AccentClass: 'is-info',
		TextClass: 'has-text-info-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-info-dark)',
	},
	success:
	{
		Label: 'Success',
		IconClass: 'fas fa-fw fa-circle-check',
		AccentClass: 'is-success',
		TextClass: 'has-text-success-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-success-dark)',
	},
	warning:
	{
		Label: 'Warning',
		IconClass: 'fas fa-fw fa-triangle-exclamation',
		AccentClass: 'is-warning',
		TextClass: 'has-text-warning-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-warning-dark)',
	},
	error:
	{
		Label: 'Error',
		IconClass: 'fas fa-fw fa-circle-exclamation',
		AccentClass: 'is-danger',
		TextClass: 'has-text-danger-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-danger-dark)',
	},
	debug:
	{
		Label: 'Debug',
		IconClass: 'fas fa-fw fa-bug',
		AccentClass: 'is-dark',
		TextClass: 'has-text-grey-lighter',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-grey-dark)',
	},
	default:
	{
		Label: 'Note',
		IconClass: 'fas fa-fw fa-circle-dot',
		AccentClass: 'is-dark',
		TextClass: 'has-text-light',
		BackgroundClass: 'has-background-black-ter',
		BorderColorVar: 'var(--bulma-grey-light)',
	},
};

class HeadlightPaneValidations extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// we'll need to keep track of logs here for re-rendering the pane
		this.HeadlightPaneValidationLog = [];
		/** @type {ValidationsSection[]} */
		this.HeadlightPaneValidationSections = [];

		// Severity map is per-instance so callers can layer in form-specific treatments
		// without leaking into other apps that share this view module. Deep-copy each
		// treatment so registerSeverityTreatments() can mutate fields safely.
		/** @type {Record<string, SeverityTreatment>} */
		this._severityMap = {};
		for (const key of Object.keys(DEFAULT_SEVERITY_MAP))
		{
			this._severityMap[key] = Object.assign({}, DEFAULT_SEVERITY_MAP[key]);
		}
	}

	/**
	 * Merge custom severity treatments into the active severity map. Each entry in
	 * `pCustomMap` is shallow-merged onto the existing treatment for that key, so
	 * callers can override just `IconClass` (for example) without re-stating every
	 * other field. New keys are added wholesale.
	 *
	 * @param {Record<string, Partial<SeverityTreatment>>} pCustomMap
	 */
	registerSeverityTreatments(pCustomMap)
	{
		if (!pCustomMap || typeof pCustomMap !== 'object')
		{
			return;
		}
		for (const rawKey of Object.keys(pCustomMap))
		{
			const key = String(rawKey).toLowerCase();
			const existing = this._severityMap[key] || this._severityMap.default;
			this._severityMap[key] = Object.assign({}, existing, pCustomMap[rawKey]);
		}
	}

	/**
	 * Resolve a severity string (case-insensitive) to a treatment, falling back to
	 * the `default` treatment if the key is missing.
	 *
	 * @param {string=} pSeverity
	 * @return {SeverityTreatment & { Key: string }}
	 */
	getSeverityTreatment(pSeverity)
	{
		const key = (pSeverity ? String(pSeverity).toLowerCase() : 'default');
		const treatment = this._severityMap[key] || this._severityMap.default;
		return Object.assign({ Key: this._severityMap[key] ? key : 'default' }, treatment);
	}

	/**
	 * @return {ValidationsSection[]}
	 */
	get sections()
	{
		return this.HeadlightPaneValidationSections;
	}

	/**
	 * @return {ValidationLogEntry[]}
	 */
	get validations()
	{
		return this.sections.map((s) => s.Logs).flat();
	}

	/**
	 *
	 * @param {string} sectionKey
	 * @return {ValidationsSection | undefined}
	 */
	getSection(sectionKey)
	{
		return this.sections.find((s) => s.Key === sectionKey);
	}

	indexOfSection(sectionKey)
	{
		return this.sections.findIndex((s) => s.Key === sectionKey);
	}

	/**
	 *
	 * @param {string} logKey
	 * @return {ValidationLogEntry | undefined}
	 */
	getLogEntry(logKey)
	{
		return this.validations.find((l) => l.Key === logKey);
	}

	/**
	 * @param {LogInput} logInput
	 * @return {ValidationLogEntry}
	 */
	generateLogEntry(logInput)
	{
		const treatment = this.getSeverityTreatment(logInput.Severity);
		const key = uuidv4();
		// Row-style entry: full-width with an 8px leading border whose
		// color is driven by --hl-log-row-accent-color (panels-logs.scss).
		// We set the var inline from `treatment.BorderColorVar` so custom
		// severities registered via registerSeverityTreatments() pick up
		// their own accent color end-to-end. The `severity-${Key}` and
		// Bulma `is-*` classes provide the same fallback for built-in
		// severities, and `treatment.AccentClass` stays on the row so
		// existing callers/tests that look for it still match.
		// `BackgroundClass` is intentionally NOT applied — the panel's
		// dark surface stays clean and the leading border carries the
		// severity tone. `TextClass` styles the label line only.
		const log = /*html*/`
		<div class="hl-log-row severity-${treatment.Key} ${treatment.AccentClass} is-clickable"
			style="--hl-log-row-accent-color: ${treatment.BorderColorVar};"
			onclick="_Pict.views.HeadlightPaneValidations.onClickEntry('${key}')">
			<p class="hl-log-row-label ${treatment.TextClass}">
				<span class="icon"><i class="${treatment.IconClass}" aria-hidden="true"></i></span>
				<span>${treatment.Label}</span>
			</p>
			<p class="hl-log-row-message">${logInput.Message}</p>
		</div>`;
		return {
			Key: key,
			Log: log,
			Severity: treatment.Key,
			onClickHandler: logInput.onClickHandler,
		};
	}

	/**
	 * Normalize the variadic / array message arguments accepted by addLogSection
	 * and addToLogSection. Allows callers to use any of:
	 *   - a single LogInput object: fn(key, { Message: 'x' })
	 *   - spread args:               fn(key, msg1, msg2, msg3)
	 *   - a single array:            fn(key, [msg1, msg2])
	 *
	 * @param {(LogInput|LogInput[])[]} pRestArgs - The rest-collected `...messages` argument.
	 * @return {LogInput[]}
	 * @private
	 */
	_normalizeMessages(pRestArgs)
	{
		if (pRestArgs.length === 1 && Array.isArray(pRestArgs[0]))
		{
			return pRestArgs[0];
		}
		return /** @type {LogInput[]} */ (pRestArgs);
	}

	/**
	 * Append messages to a section's existing logs (creates the section if it doesn't exist).
	 *
	 * @param {string} sectionKey
	 * @param {...(LogInput|LogInput[])} messages - One or more LogInput objects, spread or as an array.
	 */
	addToLogSection(sectionKey, ...messages)
	{
		const list = this._normalizeMessages(messages);
		let section = this.getSection(sectionKey);
		if (!section)
		{
			section = { Key: sectionKey, Name: sectionKey, Logs: [] };
			// Append new sections so they line up with the order the form's
			// validators registered them (and, by extension, the visual order
			// of the form content itself).
			this.sections.push(section);
		}
		const newLogEntries = list.map((m) => this.generateLogEntry(m));
		// Append within the section too so logs read top-down in the order
		// the validator emitted them.
		section.Logs.push(...newLogEntries);

		this.pict.views.HeadlightPanels.updateNavButtonBadge('Validations', this.validations.length);
		this.render();
	}

	/**
	 * Replace a section's logs with a new set (creates the section if it doesn't exist).
	 *
	 * @param {string} sectionKey
	 * @param {...(LogInput|LogInput[])} messages - One or more LogInput objects, spread or as an array.
	 */
	addLogSection(sectionKey, ...messages)
	{
		const list = this._normalizeMessages(messages);
		const newLogEntries = list.map((m) => this.generateLogEntry(m));
		const existingIndex = this.indexOfSection(sectionKey);
		if (existingIndex >= 0)
		{
			this.sections[existingIndex].Logs = newLogEntries;
		}
		else
		{
			// Append new sections so they line up with the order the form's
			// validators registered them.
			this.sections.push({ Key: sectionKey, Name: sectionKey, Logs: newLogEntries });
		}

		this.pict.views.HeadlightPanels.updateNavButtonBadge('Validations', this.validations.length);
		this.render();
	}

	/**
	 *
	 * @param {string} sectionKey
	 */
	clearSection(sectionKey)
	{
		const index = this.indexOfSection(sectionKey);
		if (index < 0)
		{
			return;
		}
		this.sections.splice(index, 1);

		this.pict.views.HeadlightPanels.updateNavButtonBadge('Validations', this.validations.length);
		this.render();
	}

	generateFlatLogsList()
	{
		this.HeadlightPaneValidationLog = this.validations;
	}

	/**
	 * Compute the data-attribute toggle key used to wire each section's header
	 * to `toggleCollapsiblePanelBlockGroup`. Prefixed so it can't collide with
	 * other collapsibles in the panel pane.
	 *
	 * @param {string} sectionKey
	 * @return {string}
	 * @private
	 */
	_getSectionToggleKey(sectionKey)
	{
		return `ValidationsSection-${sectionKey}`;
	}

	/**
	 * Flip the collapsed state for a section. Updates the persistent
	 * `Collapsed` flag on the section data so the state survives the next
	 * re-render, and toggles the DOM directly via the existing
	 * `toggleCollapsiblePanelBlockGroup` helper for snappy UX.
	 *
	 * @param {string} sectionKey
	 */
	toggleSectionCollapse(sectionKey)
	{
		const section = this.getSection(sectionKey);
		if (!section)
		{
			return;
		}
		section.Collapsed = !section.Collapsed;
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(this._getSectionToggleKey(sectionKey));
	}

	/**
	 * Lifecycle hook that runs ahead of every render — both sync `render()`
	 * and `renderAsync()` flows route through this (the base class's
	 * onBeforeRenderAsync delegates to onBeforeRender). Recomputes the flat
	 * log list used by the empty-state conditional and pre-computes
	 * per-section presentation strings for the section template.
	 *
	 * @param {any} _pRenderable
	 * @return {boolean}
	 */
	onBeforeRender(_pRenderable)
	{
		this.generateFlatLogsList();
		for (const section of this.sections)
		{
			section.ToggleKey = this._getSectionToggleKey(section.Key);
			section.HiddenClass = section.Collapsed ? 'is-hidden' : '';
			section.ChevronIconClass = section.Collapsed ? 'fa-chevron-right' : 'fa-chevron-down';
		}
		return true;
	}

	/**
	 *
	 * @param {string} logKey
	 */
	onClickEntry(logKey)
	{
		this.pict.log.debug(`[Pane-Validations] onClickEntry logKey[${logKey}]`);
		const logEntry = this.getLogEntry(logKey);
		if (!logEntry)
		{
			this.pict.log.error(`[onClickEntry] logKey[${logKey}] is missing`);
			return;
		}
		if (typeof(logEntry.onClickHandler) === 'function')
		{
			this.pict.log.debug(`[Pane-Validations] onClickEntry logKey[${logKey}] calling onClickHandler()`);
			logEntry.onClickHandler();
			return;
		}
		// default behavior: highlight source dom element and shift focus to it
	}
}

module.exports = HeadlightPaneValidations;
module.exports.DEFAULT_SEVERITY_MAP = DEFAULT_SEVERITY_MAP;

// additional view-specific templates
const viewSpecificTemplates = [
	{
		Hash: 'HeadlightPanels-ValidationPanel-Content',
		Template: /*html*/`{~TS:HeadlightPanels-ValidationPanel-Content-Section:Pict.views.HeadlightPaneValidations.HeadlightPaneValidationSections~}`,
	},
	{
		Hash: 'HeadlightPanels-ValidationPanel-Content-Section',
		Template: /*html*/`
		<div class="hl-log-section">
			<div class="hl-log-section-header" data-collapsible-toggle="{~D:Record.ToggleKey~}" onclick="_Pict.views.HeadlightPaneValidations.toggleSectionCollapse('{~D:Record.Key~}')">
				<span class="hl-log-section-icon icon">
					<i class="fas fa-fw fa-list-check" aria-hidden="true"></i>
				</span>
				<span class="hl-log-section-name">{~D:Record.Name~}</span>
				<span class="hl-log-section-badge">{~D:Record.Logs.length~}</span>
				<span class="hl-log-section-chevron icon">
					<i class="fas fa-fw {~D:Record.ChevronIconClass~}" aria-hidden="true"></i>
				</span>
			</div>
			<div data-collapsible-content="{~D:Record.ToggleKey~}" class="hl-log-section-body {~D:Record.HiddenClass~}">
				{~TS:HeadlightPanels-ValidationPanel-Content-LogEntry:Record.Logs~}
			</div>
		</div>
		`,
	},
	{
		Hash: 'HeadlightPanels-ValidationPanel-Content-LogEntry',
		Template: /*html*/`{~D:Record.Log~}`,
	},
	{
		Hash: 'HeadlightPanels-ValidationPanel-EmptyMessage',
		Template: /*html*/`
		<div class="hl-log-row severity-success is-success" style="border-left-width: 5px; padding: 0.85rem 1rem; text-align: center;">
			<p class="hl-log-row-label has-text-success-light is-justify-content-center" style="font-size: 0.85rem;">
				<span class="icon"><i class="fas fa-fw fa-circle-check" aria-hidden="true"></i></span>
				<span>All clear</span>
			</p>
			<p class="hl-log-row-message">No validation issues to address right now.</p>
		</div>`,
	},
];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;

},{"./panes/HeadlightPanels-Pane-View-Templates.json":1574,"pict-view":733,"uuid":1517}],1556:[function(require,module,exports){
const PictViewClass = require('pict-view');
const DefaultConfiguration = require('../configuration/HeadlightPanels-Configuration-Default.json');

const libHeadlightPaneValidations = require('./HeadlightPanels-Pane-Validations.js');
const libDocumentStateDisplay = require('../behaviors/DocumentStateDisplay.js');
const libHeadlightPaneNavigation = require('./HeadlightPanels-Pane-Navigation.js');
const libHeadlightPaneObservations = require('./HeadlightPanels-Pane-Observations.js');
const libHeadlightPaneSecret = require('./HeadlightPanels-Pane-Secret.js');
const libHeadlightPaneProfile = require('./HeadlightPanels-Pane-Profile.js');
const libHeadlightPaneSettings = require('./HeadlightPanels-Pane-Settings.js');
const libHeadlightPaneSolver = require('./HeadlightPanels-Pane-Solver.js');
const libPictFormSolver = require('./Pict-Form-Solver.js');
const libHeadlightPaneStatus = require('./HeadlightPanels-Pane-Status.js');
const libHeadlightPaneBridges = require('./HeadlightPanels-Pane-Bridges.js');
const libHeadlightPaneDocuments = require('./HeadlightPanels-Pane-Documents.js');
const libHeadlightPaneSamples = require('./HeadlightPanels-Pane-Samples.js');
const libHeadlightPaneCustom = require('./HeadlightPanels-Pane-Custom.js');
const libHeadlightPanelsFableService = require('../services/HeadlightPanels-Fable-Service.js');
const libHeadlightModalService = require('../../../../lib/web/headlight-modal/Headlight-Modal-Service.js');
const libMaterialsFormManagerService = require('../../../../lib/service/materials-form-manager/Materials-Form-Manager.js');
const libHeadlightPopoverService = require('../../../../lib/web/headlight-popover/Headlight-Popover-Service.js');
const libNativeBridgeService = require('../../../../lib/web/native-bridge/index.js');
const libEntityProvider = require('../../../../web/providers/Entity-Provider.js');
const libQRPanel = require('./QRPanel.js');
const libHeadlightToastAdapter = require('../behaviors/HeadlightToastAdapter.js');

// Where remembered pane widths live between sessions. They are a cosmetic hint for the loading
// skeleton only -- nothing behaves differently when they are missing, stale or unreadable.
const _PaneWidthStorageKey = 'HeadlightPanels.PaneWidths';

/** @typedef {import('pict') & import('fable') &
 *   {
 *     log: any,
 *     instantiateServiceProviderWithoutRegistration: (hash: String) => any,
 *     instantiateServiceProviderIfNotExists: (hash: string) => any,
 *     TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking'),
 *     MetaTemplate: any,
 *     fable: import('fable'),
 *     HeadlightPanels: import('../services/HeadlightPanels-Fable-Service.js'),
 *     HeadlightRestClient: import('headlight-rest-client'),
 *     BridgeDocumentManager: import('../../../../lib/service/headlight-bridge-document-manager'),
 *     PictApplication: InstanceType<import('headlight-document-application')>,
 *     HeadlightModal: libHeadlightModalService,
 *	   HeadlightPopover: libHeadlightPopoverService,
 *     views: {
 *       HeadlightPanels: HeadlightPanels,
 *     },
 *   }
 * } Pict */
class HeadlightPanels extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {Pict} */
		this.pict;
		// set the default configuration for the view
		this.setDefaultPanelConfiguration();
		// panel states
		this.LeftPanelActive = false;
		this.LeftPanelPinned = false;
		this.LeftPanelMode = '';
		this.LeftPanelView = '';
		this.RightPanelActive = false;
		this.RightPanelPinned = false;
		this.RightPanelMode = '';
		this.RightPanelView = '';
		this.MinimumInputLengthForSearch = 0;
		// Width of each pane the last time it rendered, so the loading skeleton can hold the panel at the
		// width the content is about to need. The wrapper shrinks to fit, and panes vary widely (a
		// Navigation pane is ~230px where Observations hits the 50vw cap), so there is no useful default.
		this.PaneWidths = this.loadPaneWidths();

		// Adapter that translates legacy object-first toast options into Pict-Section-Modal
		// toast calls (type mapping, single-toast, duplicate throttle, HTML handling).
		this._ToastAdapter = new libHeadlightToastAdapter({ ThrottleWindowMS: 1000 });

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));
		this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });

		this.pict.MetaTemplate.addPattern('{~CacheBustPostfix:', '~}', (pHash, pData, fCallback) =>
		{
			return `?t=${ new Date().getTime() }`;
		});

		// add the ".is-hidden" class to the element if the browser is iOS and the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideOniOS:', '~}', (pHash, pData, fCallback) =>
		{
			// do we want to hide the element T/F value
			const tmpHideValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// check if the URL param flag is set to hide the download button by parent apps (SmartForms, etc.)
			const tmpURLParamFlag = new URLSearchParams(window.location.search).get('hideDownloadButton');
			// check if the user agent is iOS (works for browsers, not webview apps)
			const tmpIsIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			// if the hide value is true and the URL param flag is set or the user agent is iOS, return the hidden
			return tmpHideValue && (tmpURLParamFlag || tmpIsIOS) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if this page cannot create a new document (Clone, Duplicate)
		this.pict.MetaTemplate.addPattern('{~HideIfCannotCreateDocument', '~}', (pHash, pData, fCallback) =>
		{
			const tmpDocumentProvider = this.pict.providers.DocumentProvider;
			return tmpDocumentProvider && !tmpDocumentProvider.canCreateDocument() ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~Hide:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpValue ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is false
		this.pict.MetaTemplate.addPattern('{~Show:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpValue ? '' : 'is-hidden';
		});

		// do return the value in span tag if the passed value is true and the value is not empty
		this.pict.MetaTemplate.addPattern('{~If:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const tmpDataId = pData && pData.id ? `id="${pData.id}-Text"` : '';
			return tmpValue && tmpValue.length ? `<span ${tmpDataId}>` + tmpValue + '</span>' : '';
		});

		// A document's workflow state as a person should read it. The approval workflow authors a
		// display name per state (`StateName` - "In Test", "Waiting for District Lab Engineer
		// Approval"); `Status` is the machine hash the workflow keys off and was never meant for
		// the screen. Drafts are created by the API without consulting the workflow, so they carry
		// a Status and no StateName - the fallback is what keeps those from rendering blank.
		//
		// Takes the address of the RECORD, not of a field: `{~DocumentState:Record~}`.
		this.pict.MetaTemplate.addPattern('{~DocumentState:', '~}', (pHash, pData, fCallback) =>
		{
			return libDocumentStateDisplay.resolveDocumentStateDisplay(this.pict.resolveStateFromAddress(pHash, pData, fCallback));
		});

		// replace the value with a mapped css class from the Observation Provider
		this.pict.MetaTemplate.addPattern('{~LabelClass:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.pict.providers.ObservationProvider.getLabelClassFromObservationTagObject(tmpRecord);
		});

		// replace the observation type with a mapped display name from the Observation Provider
		this.pict.MetaTemplate.addPattern('{~ObsTypeDisplay:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpRecord = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return this.pict.providers.ObservationProvider.getObservationMappedDetails(tmpRecord)?.Type || pData;
		});

		// take a code string and return a canvas QR code image
		this.pict.MetaTemplate.addPattern('{~QRCodeImage:', '~}', (pHash, pData, fCallback) =>
		{
			// if the record has a size option from the template string, use that build the QR code image
			// EX: "{~QRCodeImage:Record^128x128^~}" will return a 128x128 QR code image
			const tmpType = pHash.includes('^') && pHash.split('^')?.length > 2 ? pHash.split('^')[2] : null;
			const tmpSize = pHash.includes('^') ? pHash.split('^')[1] : null;
			const tmpHash = pHash.includes('^') ? pHash.split('^')[0] : pHash;
			const tmpRecord = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			if (!tmpRecord)
			{
				return '';
			}
			let tmpHeight;
			let tmpWidth;
			// if we have a size option, make sure it's in the correct format
			if (tmpSize && !tmpSize.includes('x'))
			{
				this.pict.fable.log.error('Invalid QR code size. Please use the format "128x128"');
				return '';
			}
			else
			{
				tmpHeight = tmpSize ? tmpSize.split('x')[1] : '128';
				tmpWidth = tmpSize ? tmpSize.split('x')[0] : '128';
			}
			// create the QR code canvas and return the image tag, adding a white border around the image
			const tmpCanvas = this.pict.providers.QRCodeProvider.create(tmpRecord, { width: tmpWidth, height: tmpHeight, type: tmpType });
			return `<img style="outline: 1px solid white" src="${tmpCanvas}" alt="QR Code" />`;
		});

		this.pict.MetaTemplate.addPattern('{~GoogleMapURL:', '~}', (pHash, pData, fCallback) =>
		{
			// if the record has a size option from the template string, use that to get the map URL
			// EX: "{~GoogleMapURL:Record^128x128^~}" will return the URL for a 128x128 map
			const tmpSize = pHash.includes('^') ? pHash.split('^')[1] : null;
			const tmpHash = pHash.includes('^') ? pHash.split('^')[0] : pHash;
			const tmpRecord = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			// pass the size option to the provider if it exists, it will handle the fallback if not
			return this.pict.providers.UtilityProvider.getGoogleMapURLFromEntityRecord(tmpRecord, { size: tmpSize });
		});

		// watch for the escape key to close the active panel(s)
		document.body.addEventListener('keydown', (event) =>
		{
			// close the modal or the panels on escape key press
			if (event.key === 'Escape')
			{
				if (this.AppData.FullScreenModalActive)
				{
					this.togglePanelFullScreenModal('close');
				}
				else
				{
					this.closeAllUnpinnedPanels();
				}
			}
		});
		// shared providers for core entities
		this.pict.addProvider('EntityDocumentProvider', { Entity: 'Document' }, libEntityProvider);
		this.pict.addProvider('EntityInspectionDocumentProvider', { Entity: 'InspectionDocumentJoin' }, libEntityProvider);
		this.pict.addProvider('EntityInspectionTypeProvider', { Entity: 'InspectionType' }, libEntityProvider);
		this.pict.addProvider('ConfigurationProvider', {}, require('../../../../web/providers/ConfigurationProvider.js'));
		this.pict.addProvider('UploadTracking', {}, require('../../../../web/providers/UploadTrackingProvider.js'));
		this.pict.addProvider('UtilityProvider', {}, require('../../../../web/providers/UtilityProvider.js'));
		this.pict.addProvider('DocumentProvider', {}, require('../../../../web/providers/DocumentProvider.js'));
		this.pict.addProvider('TestInstanceProvider', {}, require('../../../../web/providers/TestInstanceProvider.js'));
		this.pict.addProvider('ProjectProvider', {}, require('../../../../web/providers/ProjectProvider.js'));
		this.pict.addProvider('ObservationProvider', {}, require('../../../../web/providers/ObservationProvider.js'));
		this.pict.addProvider('LocationProvider', {}, require('../../../../web/providers/LocationProvider.js'));
		this.pict.addProvider('SampleProvider', {}, require('../../../../web/providers/SampleProvider.js'));
		this.pict.addProvider('SampleLogProvider', {}, require('../../../../web/providers/SampleLogProvider.js'));
		this.pict.addProvider('GeoProvider', {}, require('../../../../web/providers/GeoProvider.js'));
		this.pict.addProvider('FieldSettingsProvider', {}, require('../../../../web/providers/FieldSettingsProvider.js'));
		this.pict.addProvider('MaterialProvider', {}, require('../../../../web/providers/MaterialProvider.js'));
		this.pict.addProvider('MixDesignProvider', {}, require('../../../../web/providers/MixDesignProvider.js'));
		this.pict.addProvider('UserProvider', {}, require('../../../../web/providers/UserProvider.js'));
		this.pict.addProvider('MarkdownProvider', {}, require('../../../../web/providers/MarkdownProvider.js'));
		this.pict.addProvider('QRCodeProvider', {}, require('../../../../web/providers/QRCodeProvider.js'));
		this.registerScanHandling();
		this.pict.addProvider('ObservationSetProvider', {}, require('../../../../web/providers/ObservationSetProvider.js'));
		this.pict.addProvider('ImportantFilesProvider', {}, require('../../../../web/providers/ImportantFilesProvider.js'));
		this.pict.addProvider('FormConversionProvider', {}, require('../../../../web/providers/FormConversionProvider.js'));
		this.pict.addProvider('FileNavigatorProvider', {}, require('../../../../web/providers/FileNavigatorProvider.js'));
		// TODO: how do we determine if need these included here vs just in dynamic forms?
		this.pict.addProvider('MixSpecificationProvider', {}, require('../../../../web/providers/MixSpecificationProvider.js'));
		this.pict.addProvider('ProductProvider', {}, require('../../../../web/providers/ProductProvider.js'));
		this.pict.addProvider('ProducerProvider', {}, require('../../../../web/providers/ProducerProvider.js'));
		this.pict.addProvider('PlantProvider', {}, require('../../../../web/providers/PlantProvider.js'));
		this.pict.addProvider('LabProvider', {}, require('../../../../web/providers/LabProvider.js'));
		this.pict.addProvider('LineItemProvider', {}, require('../../../../web/providers/LineItemProvider.js'));
		this.pict.addProvider('ProjectFileProvider', {}, require('../../../../web/providers/ProjectFileProvider.js'));
		// TODO: when CommentEntityJoin is complete - I think this needs to move to CORE
		this.pict.addProvider('CommentProvider', {}, require('../../../../web/providers/CommentProvider.js'));
		this.pict.addProvider('InspectionProvider', {}, require('../../../../web/providers/InspectionProvider.js'));

		// Isolated Views (these could be moved to the new location - are not exclusive to the panels)
		this.pict.addView('ObservationIncluded', {}, require('../views/Observation-View-Included.js'));
		this.pict.addView('ObservationCreateMedia', {}, require('../views/Observation-View-Create-Media.js'));
		this.pict.addView('ObservationSearch', {}, require('../views/Observation-View-Search.js'));
		this.pict.addView('ObservationDetails', {}, require('../views/Observation-View-Details.js'));
		this.pict.addView('ObservationAnnotation', {}, require('../views/Observation-Edit-Annotation.js'));
		this.pict.addView('AcademyView', {}, require('../views/Academy-View.js'));
		this.pict.addView('Inspection', {}, require('../views/Inspection-View.js'));
		this.pict.addView('ObservationSubImageSelector', {}, require('../views/Observation-Edit-SubImage.js'));
		this.pict.addView('TestInstanceWizard', {}, require('../views/TestInstance-Wizard.js'));
		this.pict.addView('ObservationSet', {}, require('./Observation-View-Sets.js'));
		this.pict.addView('SampleSearch', {}, require('../views/Sample-View-Search.js'));
		this.pict.addView('SampleDetails', {}, require('../views/Sample-View-Details.js'));
		this.pict.addView('SampleCreate', {}, require('../views/Sample-View-Create.js'));
		this.pict.addView('SampleScan', {}, require('../views/Sample-View-Scan.js'));
		this.pict.addView('SampleCurrent', {}, require('../views/Sample-View-Current.js'));
		this.pict.addView('DocumentSearch', {}, require('../views/Document-View-Search.js'));
		this.pict.addView('DocumentCreate', {}, require('../views/Document-View-Create.js'));
		this.pict.addView('DocumentCurrent', {}, require('../views/Document-View-Current.js'));
		this.pict.addView('DocumentDetails', {}, require('../views/Document-View-Details.js'));
		this.pict.addView('ProjectFileSearch', {}, require('../views/ProjectFile-View-Search.js'));
		this.pict.addView('CommentCurrent', {}, require('../views/Comment-View-Current.js'));
		this.pict.addView('PictFormsSolver', libPictFormSolver.default_configuration, libPictFormSolver);
		// Views
		this.pict.addView('HeadlightPaneValidations', libHeadlightPaneValidations.default_configuration, libHeadlightPaneValidations);
		this.pict.views.HeadlightPaneValidations.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneNavigation', libHeadlightPaneNavigation.default_configuration, libHeadlightPaneNavigation);
		this.pict.views.HeadlightPaneNavigation.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneObservations', libHeadlightPaneObservations.default_configuration, libHeadlightPaneObservations);
		this.pict.views.HeadlightPaneObservations.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneSecret', libHeadlightPaneSecret.default_configuration, libHeadlightPaneSecret);
		this.pict.views.HeadlightPaneSecret.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneProfile', libHeadlightPaneProfile.default_configuration, libHeadlightPaneProfile);
		this.pict.views.HeadlightPaneProfile.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneSettings', libHeadlightPaneSettings.default_configuration, libHeadlightPaneSettings);
		this.pict.views.HeadlightPaneSettings.options.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneSolver', libHeadlightPaneSolver.default_configuration, libHeadlightPaneSolver);
		this.pict.views.HeadlightPaneSolver.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneStatus', libHeadlightPaneStatus.default_configuration, libHeadlightPaneStatus);
		this.pict.views.HeadlightPaneStatus.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneBridges', libHeadlightPaneBridges.default_configuration, libHeadlightPaneBridges);
		this.pict.views.HeadlightPaneBridges.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneDocuments', libHeadlightPaneDocuments.default_configuration, libHeadlightPaneDocuments);
		this.pict.views.HeadlightPaneDocuments.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneSamples', libHeadlightPaneSamples.default_configuration, libHeadlightPaneSamples);
		this.pict.views.HeadlightPaneSamples.options.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('QRPanel', libQRPanel.default_configuration, libQRPanel);
		// Custom Panels
		const tmpCustomLeftPanelConfiguration = JSON.parse(JSON.stringify(libHeadlightPaneCustom.default_configuration));
		tmpCustomLeftPanelConfiguration.PanelName = 'Left';
		tmpCustomLeftPanelConfiguration.PanelTitle = 'Left Panel';
		tmpCustomLeftPanelConfiguration.PanelIcon = 'fa-circle-notch';
		tmpCustomLeftPanelConfiguration.PanelMode = '';
		tmpCustomLeftPanelConfiguration.PanelView = '';
		tmpCustomLeftPanelConfiguration.DefaultDestinationAddress = '#HeadlightPanels-LeftPanel';
		this.pict.addView('HeadlightPaneCustomLeft', tmpCustomLeftPanelConfiguration, libHeadlightPaneCustom);

		const tmpCustomRightPanelConfiguration = JSON.parse(JSON.stringify(libHeadlightPaneCustom.default_configuration));
		tmpCustomRightPanelConfiguration.PanelName = 'Right';
		tmpCustomRightPanelConfiguration.PanelTitle = 'Right Panel';
		tmpCustomRightPanelConfiguration.PanelIcon = 'fa-circle-notch';
		tmpCustomRightPanelConfiguration.PanelMode = '';
		tmpCustomRightPanelConfiguration.PanelView = '';
		tmpCustomRightPanelConfiguration.DefaultDestinationAddress = '#HeadlightPanels-RightPanel';
		this.pict.addView('HeadlightPaneCustomRight', tmpCustomRightPanelConfiguration, libHeadlightPaneCustom);

		// Fable Service
		this.fable.addAndInstantiateServiceTypeIfNotExists('HeadlightPanels', libHeadlightPanelsFableService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('HeadlightModal', libHeadlightModalService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('MaterialsFormManager', libMaterialsFormManagerService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('NativeBridge', libNativeBridgeService);
		this.fable.addAndInstantiateServiceTypeIfNotExists('HeadlightPopover', libHeadlightPopoverService);
		this.pict.serviceManager.addAndInstantiateServiceType('BridgeDocumentManager', require('../../../../lib/service/headlight-bridge-document-manager'));
	}

	onAfterInitialize()
	{
		this.pict.CSSMap.injectCSS();

		return super.onAfterInitialize();
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		this.pict.fable.log.info('Headlight Panels view onBeforeRender');

		this.pict.views.ObservationCreateMedia.instantiateConfiguration();

		this.pict.services.HeadlightPanels.checkIfPhoneDevice();

		// Apply the preferences that shape the first paint (theme, page width, navbar position) BEFORE
		// the template runs -- the navbar's position is read out of the configuration at render time, so
		// doing this afterwards makes the user watch it jump. The values are already in AppData, so this
		// costs nothing and waits on nothing.
		this.pict.views.HeadlightPaneSettings.applyPreRenderUserPreferences();

		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.fable.log.info('Headlight Panels view onAfterRenderAsync');

		// initialize context specific elements. Will show or hide based on the current context
		const isDocumentContext = this.pict.AppData?.DocumentData?.ReportData;
		isDocumentContext ? this.toggleContextSpecficElements('show') : this.toggleContextSpecficElements('hide');

		// set the body element offset for the fixed navbar
		this.setBodyElementOffsetForFixedNavbar();

		this.adjustBottomToolbarOptions();

		// The navbar renders the Current Samples button hidden by default. Re-apply the known state first
		// (synchronously, so a later render cannot clobber it), then refresh it from the server.
		this.applyCurrentSamplesButtonState();
		this.syncCurrentSamplesButtonState();
		// The navbar render recreates the Save button and the (empty) auto-save indicator container.
		this.syncSaveButtonState();
		this.syncAutoSaveStatus();

		// login expired, redirect to login page
		if (!this.AppData.CurrentUser)
		{
			this.pict.fable.log.warn('No user found. Unable to load user settings.');
		}
		else
		{
			// load the user settings for the panels
			this.pict.views.HeadlightPaneSettings.loadUserPreferences();
		}

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Toggle the class name based on the action provided
	 * @param {HTMLElement} pElement - The element to toggle the class on
	 * @param {string} pAction - The action to take on the element (show, hide, toggle)
	 * @return {void}
	 */
	_toggleElementClass(pElement, pAction)
	{
		if (pAction === 'show')
		{
			pElement.classList.remove('is-hidden');
		}
		else if (pAction === 'hide')
		{
			pElement.classList.add('is-hidden');
		}
		else
		{
			pElement.classList.toggle('is-hidden');
		}
	}

	/**
	 * Some elements are hidden or shown based on the context of the content. This method toggles the visibility of these elements.
	 * @param {string} pAction - The action to take on the context specific elements (show, hide, toggle)
	 * @return {void}
	 */
	toggleContextSpecficElements(pAction)
	{
		const tmpNavBar = document.getElementById('HeadlightPanels-Navbar-Brand-Container');
		const tmpSaveButton = document.getElementById('HeadlightPanels-NavBar-Save-Button')?.parentElement;
		const tmpSolverButton = document.getElementById('HeadlightPanels-NavBar-Solver-Button')?.parentElement;
		const tmpFullScreenButton = document.getElementById('HeadlightPanels-Navbar-FullScreen-Button')?.parentElement;
		if (tmpNavBar)
		{
			this._toggleElementClass(tmpNavBar, pAction);
		}
		if (tmpSaveButton)
		{
			this._toggleElementClass(tmpSaveButton, pAction);
		}
		if (tmpSolverButton)
		{
			this._toggleElementClass(tmpSolverButton, pAction);
		}
		if (tmpFullScreenButton)
		{
			this._toggleElementClass(tmpFullScreenButton, pAction);
		}
	}

	/**
	 * Update the navbar once a document has been selected (or removed)
	 * @return {void}
	 */
	updatePanelsBasedOnDocumentContext()
	{
		// if this is a document/form context, show the approval actions branding and document save button
		const isDocumentContext = this.pict.AppData?.DocumentData?.ReportData;
		// if the status panel is enabled, update the approvals style state
		if (isDocumentContext && this.pict.settings.HeadlightPanels.Configuration.PanelList.find((panel) => panel.name === 'status'))
		{
			this.pict.views.HeadlightPaneStatus.updateApprovalsStyleState();
		}
		// re-render the buttons and the branding now that we have the document context
		this.pict.views.HeadlightPanels.renderAsync('HeadlightPanels-NavBar-Brand', null, null, null, () =>
		{
			this.pict.fable.log.info('Re-rendered the navbar branding');

			this.pict.views.HeadlightPanels.renderAsync('HeadlightPanels-NavBar-Button-Wrapper', null, null, null, () =>
			{
				this.pict.fable.log.info('Re-rendered the navbar buttons');
				// adjust the bottom toolbar options based on the context
				if (isDocumentContext)
				{
					this.toggleContextSpecficElements('show');
				}
				else
				{
					this.toggleContextSpecficElements('hide');
				}
				// the re-render above replaces the button element, so re-apply the locked/saving state
				this.syncSaveButtonState();
				// ...and empties the auto-save indicator's container along with it.
				this.syncAutoSaveStatus();
				this.applyCurrentSamplesButtonState();
				this.syncCurrentSamplesButtonState();
			});
		});
	}

	/**
	 * Reflect the current save/approval/locked state on the navbar Save button.
	 *
	 * Called both on every save-latch transition and from the navbar render path, since re-rendering the
	 * button wrapper replaces the element and drops any attribute set on the previous one. Derives entirely
	 * from state, so it is safe to call before the button exists — the next render picks it up.
	 * @return {void}
	 */
	syncSaveButtonState()
	{
		const tmpSaveButton = document.getElementById('HeadlightPanels-NavBar-Save-Button');
		if (!tmpSaveButton)
		{
			return;
		}
		const tmpDocumentProvider = this.pict.providers?.DocumentProvider;
		const tmpIsSaving = Boolean(tmpDocumentProvider?.IsSaving);
		const tmpIsTakingAction = Boolean(tmpDocumentProvider?.isTakingAction);
		const tmpIsLocked = Boolean(this.pict.AppData?.DocumentData?.ReportData?.Locked);
		// is-loading stays keyed to the save alone: a spinner on Save while the user is watching an
		// *approval* land reads as "it is saving", which is not what is happening.
		tmpSaveButton.classList.toggle('is-loading', tmpIsSaving);
		tmpSaveButton.setAttribute('aria-busy', (tmpIsSaving || tmpIsTakingAction) ? 'true' : 'false');
		if (tmpIsSaving || tmpIsTakingAction || tmpIsLocked)
		{
			tmpSaveButton.setAttribute('disabled', 'disabled');
			// The document is not locked yet during an approval action, so that reason outranks the others.
			tmpSaveButton.setAttribute('title', tmpIsTakingAction ? 'An approval action is in progress.' : (tmpIsLocked ? 'Document is locked and can not be saved.' : 'Saving...'));
		}
		else
		{
			tmpSaveButton.removeAttribute('disabled');
			tmpSaveButton.removeAttribute('title');
		}
	}

	/**
	 * Repaint the auto-save indicator that sits beside the navbar Save button.
	 *
	 * The AutoSave provider owns the state and pushes it into `AppData.AutoSave`; this only asks the
	 * template to redraw. Called on every auto-save state transition and from the navbar render path,
	 * because re-rendering the button wrapper replaces the container element. A no-op when the
	 * container is absent (a host application whose navbar has no Save button).
	 * @return {void}
	 */
	syncAutoSaveStatus()
	{
		if (!document.getElementById('HeadlightPanels-Navbar-AutoSaveStatus-Container'))
		{
			return;
		}
		// A one-shot parse rather than render('...'): this fires on every auto-save transition, and the
		// view's own render lifecycle re-instantiates the media configuration and re-probes the device
		// on the way through. None of that belongs on a 90-second timer.
		const tmpStatusHTML = this.pict.parseTemplateByHash('HeadlightPanels-NavBar-AutoSaveStatus', {});
		this.pict.ContentAssignment.assignContent('#HeadlightPanels-Navbar-AutoSaveStatus-Container', tmpStatusHTML);
	}

	/**
	 * Paint the navbar Current Samples button from the cached lookup result.
	 *
	 * Deliberately synchronous, and separate from the lookup: the navbar wrapper re-renders from
	 * configuration (which defaults the button to is-hidden) and replaces the element, so the state has to
	 * be re-applied on every render. An async apply loses that race whenever a render lands between the
	 * lookup starting and finishing -- which is exactly how this button ended up intermittently hidden.
	 * @return {void}
	 */
	applyCurrentSamplesButtonState()
	{
		const tmpWrapper = document.getElementById('HeadlightPanels-NavBar-CurrentSamples-Button')?.parentElement;
		if (!tmpWrapper)
		{
			return;
		}
		tmpWrapper.classList.toggle('is-hidden', !this.HasJoinedSamples && !this.hasFormHeldSamples());
	}

	/**
	 * Whether the open form holds a Sample with a QR code, saved or not. A form that mints its Sample on load
	 * has one before the first save writes the join, and the Current tab lists and prints it from the form.
	 * @return {boolean}
	 */
	hasFormHeldSamples()
	{
		const tmpSampleProvider = this.pict.providers.SampleProvider;
		if (!tmpSampleProvider || typeof tmpSampleProvider.getFormHeldSamples !== 'function')
		{
			return false;
		}
		try
		{
			return tmpSampleProvider.getFormHeldSamples().length > 0;
		}
		catch (pError)
		{
			this.log.warn(`Could not read the Samples this form holds for the Current Samples button: ${pError?.message || pError}`);
			return false;
		}
	}

	/**
	 * Refresh whether this document has Samples joined to it, then paint the button.
	 *
	 * The DocumentPolyJoin rows are written server-side, so a Sample created on this form only shows up
	 * after a save round-trip -- hence this runs from the save-drain completion as well as the render path.
	 * Until then a Sample the form holds keeps the button visible (see hasFormHeldSamples). A failed lookup
	 * falls back to that alone rather than surfacing an error: it is an optional shortcut.
	 * @return {Promise<void>}
	 * @async
	 */
	async syncCurrentSamplesButtonState()
	{
		if (this._CurrentSamplesLookupInFlight)
		{
			return;
		}
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		let tmpHasSamples = false;
		if (tmpIDDocument)
		{
			this._CurrentSamplesLookupInFlight = true;
			try
			{
				const tmpJoins = await this.pict.providers.SampleProvider.getDocumentSampleJoins(tmpIDDocument);
				tmpHasSamples = Array.isArray(tmpJoins) && tmpJoins.length > 0;
			}
			catch (pError)
			{
				this.log.warn(`Could not resolve joined Samples for the Current Samples button: ${pError?.message || pError}`);
			}
			finally
			{
				this._CurrentSamplesLookupInFlight = false;
			}
		}
		this.HasJoinedSamples = tmpHasSamples;
		this.applyCurrentSamplesButtonState();
	}

	/**
	 * This method adds loading skeleton rows to the specified container.
	 * @param {string} pContainerID - The ID of the container to add the skeleton rows to.
	 * @param {number} [pRowCount] - The number of skeleton rows to add.
	 * @param {number} [pMinHeight] - The minimum height of each skeleton row.
	 * @return {void}
	 */
	addLoadingSkeletonRows(pContainerID, pRowCount, pMinHeight)
	{
		const tmpRowCount = pRowCount || 3;
		const tmpMinHeight = pMinHeight || '4.5rem'; // Bulma default height
		const tmpContainer = document.getElementById(pContainerID);
		if (!tmpContainer)
		{
			this.log.error('Container not found. Please check the ID you provided for skeleton loading UI.');
			return;
		}
		// get the inner width of the container to set the gradient overlay width to reduce the horizontal flicker
		const currentElementInnerWidth = tmpContainer.clientWidth;
		// clear the container before adding the skeleton rows
		tmpContainer.innerHTML = '';
		// add a gradient overlay to the skeleton rows to make it look like an inifinite scroll
		let tmpContent = `<div class="results-loading-gradient-overlay"></div>`;
		for (let i = 0; i < tmpRowCount; i++)
		{
			tmpContent += `<div class="panel-block skeleton-block has-background-text-40 mx-3 mb-1" style="min-height: ${tmpMinHeight}"></div>`;
		}
		// add a div to the end of the skeleton rows with the previous width to prevent the horizontal flicker
		tmpContent += `<div style="width: ${currentElementInnerWidth}px;"></div>`;
		// add the skeleton rows to the container
		tmpContainer.insertAdjacentHTML('beforeend', tmpContent);
	}

	/**
	 * This function is used to adjust the bottom toolbar options based on the context of the content. If the
	 * content is a document, the bottom toolbar is hidden.
	 * @param {boolean} [pIsDocumentContext=false] - The context of the content
	 * @return {void}
	 */
	adjustBottomToolbarOptions(pIsDocumentContext = false)
	{
		const tmpBottomToolbar = document.getElementById('HeadlightPanels-NavBar');
		if (!tmpBottomToolbar)
		{
			this.log.error('Bottom toolbar not found. Please check the ID you provided.');
			return;
		}
		if (pIsDocumentContext)
		{
			tmpBottomToolbar.classList.add('is-hidden');
		}
		else
		{
			tmpBottomToolbar.classList.remove('is-hidden');
		}
	}

	/**
	 * This function is used to close the panel via the x icon for itself.
	 * @param {Event} event - The event object
	 * @param {string} pPanelName - The name of the panel to close
	 * @return {void}
	 */
	closeThisPanel(event, pPanelName)
	{
		// if this panel is pinned, do nothing
		let tmpEventTargetName;
		if (event)
		{
			// if the target is a child of a pinned panel, don't close the panel
			const parentPanel = window.jQuery(event.target).parents('.hl-panel-wrapper')?.[0];
			if (parentPanel?.classList.contains('pinned-open'))
			{
				this.log.info('Panel is pinned open. Ignoring close request.');
				return;
			}
			tmpEventTargetName = event ? window.jQuery(event.target).parents('article[id]')?.[0]?.id : null;
			// strip the panel name from the ID if it's a panel (yuck)
			if (tmpEventTargetName)
			{
				tmpEventTargetName = tmpEventTargetName.replace('HeadlightPanels-', '').replace('Panel', '').toLowerCase();
			}
		}
		const tmpPanelName = pPanelName || tmpEventTargetName;
		if (!tmpPanelName)
		{
			this.log.error('Panel not found. Please check the ID you provided.');
			return;
		}
		this.handlePanelToggle(tmpPanelName, 'close');
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * This function is used to close all unpinned panels at once for background click and escape key hits.
	 * @return {void}
	 */
	closeAllUnpinnedPanels()
	{
		this.log.info('Closing all unpinned panels');
		// if the left panel has any pinned-open panels, don't close the wrapper
		const leftPanel = document.getElementById('HeadlightPanels-LeftPanel');
		if (leftPanel?.classList.contains('is-active') && !leftPanel?.classList.contains('pinned-open'))
		{
			this.togglePanel('left', 'close');
			this.LeftPanelActive = null;
		}
		// if the right panel has any pinned-open panels, don't close the wrapper
		const rightPanel = document.getElementById('HeadlightPanels-RightPanel');
		if (rightPanel?.classList.contains('is-active') && !rightPanel?.classList.contains('pinned-open'))
		{
			this.togglePanel('right', 'close');
			this.RightPanelActive = null;
		}
		// we assume that if the user is pressing escape/closing, they want to close any active media
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * This function is used to close all panels at once and discards all pinned states.
	 * @return {void}
	 */
	closeAllPanels()
	{
		this.log.info('Closing all panels, regardless of pinned state');
		// if the left panel has any pinned-open panels, don't close the wrapper
		const leftPanel = document.getElementById('HeadlightPanels-LeftPanel');
		if (leftPanel?.classList.contains('is-active'))
		{
			this.togglePanel('left', 'close');
			this.LeftPanelActive = null;
			this.LeftPanelPinned = false;
			document.body.style['marginLeft'] = '0';
		}
		// if the right panel has any pinned-open panels, don't close the wrapper
		const rightPanel = document.getElementById('HeadlightPanels-RightPanel');
		if (rightPanel?.classList.contains('is-active'))
		{
			this.togglePanel('right', 'close');
			this.RightPanelActive = null;
			this.RightPanelPinned = false;
			document.body.style['marginRight'] = '0';
		}
		// we assume that if the user is pressing escape/closing, they want to close any active media
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * This function is used to close all panels without prompting to save changes
	 * @return {void}
	 */
	closeAllPanelsWithoutPrompt()
	{
		this.log.info('Closing all panels, regardless of pinned state');
		// if the left panel has any pinned-open panels, don't close the wrapper
		const leftPanel = document.getElementById('HeadlightPanels-LeftPanel');
		if (leftPanel?.classList.contains('is-active'))
		{
			this.togglePanel('left', 'close');
			this.LeftPanelActive = null;
			this.LeftPanelPinned = false;
			document.body.style['marginLeft'] = '0';
		}
		// if the right panel has any pinned-open panels, don't close the wrapper
		const rightPanel = document.getElementById('HeadlightPanels-RightPanel');
		if (rightPanel?.classList.contains('is-active'))
		{
			this.togglePanel('right', 'close');
			this.RightPanelActive = null;
			this.RightPanelPinned = false;
			document.body.style['marginRight'] = '0';
		}
		// we assume that if the user is pressing escape/closing, they want to close any active media
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		this.fable.HeadlightPanels.clearUIHighlights();
	}

	/**
	 * Calls the close handler for the currently active panel based on the given location.
	 * @param {string} location - The panel location identifier (e.g., 'Left', 'Right').
	 * @returns {void}
	 */
	callCloseHandler(location)
	{
	/** @type {string} */
		const activePanelKey = 'ActivePanel' + location;

		/** @type {string | undefined} */
		const activePanelName = this[activePanelKey];

		if (!activePanelName)
		{
			this.pict.log.warn(`No active panel name found for key: ${activePanelKey}`);
			return;
		}

		/** @type {{ name: string, view: string }[]} */
		const panelList = this.pict.settings.HeadlightPanels?.Configuration?.PanelList || [];

		/** @type {{ name: string, view: string } | undefined} */
		const activePanel = panelList.find((panel) => panel.name === activePanelName);

		if (!activePanel)
		{
			this.pict.log.warn(`No panel found in PanelList with name: ${activePanelName}`);
			return;
		}

		/** @type {{ closeHandler?: Function } | undefined} */
		const panelView = this.pict.views[activePanel.view];

		if (panelView && typeof panelView.closeHandler === 'function')
		{
			panelView.closeHandler();
		}
		else
		{
			this.pict.log.warn(`No closeHandler found for panel view: ${activePanel.view}`);
		}
	}


	/**
	 * This function is used to toggle the visibility of both the panel and any content within the panel.
	 * @param {string} pPanelName - The name of the panel to toggle
	 * @param {string} pState - The forced state to toggle the panel to (open or close) - not setting this will just toggle the current state
	 * @param {function} [pCallback] - (optional) The callback function to execute after the panel is toggled
	 * @return {void}
	 * @example
	 * handlePanelToggle('Validations', 'open');
	 * handlePanelToggle('Status', 'close);
	 * handlePanelToggle('Settings');
	 *
	*/
	handlePanelToggle(pPanelName, pState, pCallback)
	{
		const tmpPanelSingular = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((panel) => panel.name === pPanelName.toLowerCase());
		const tmpPanelPlural = this.pict.settings.HeadlightPanels.Configuration.PanelList.find((panel) => panel.name === (pPanelName + 's').toLowerCase());
		// TODO: refactor the panel names to be always singular to handle this stupid quirk better
		const tmpPanel = tmpPanelSingular || tmpPanelPlural;
		if (!tmpPanel)
		{
			this.log.error(`Panel not found in the default configuration: ${pPanelName}`);
			if (pCallback) pCallback();
			return;
		}
		const tmpLocation = tmpPanel.location;
		const tmpLocationCap = (tmpLocation.charAt(0).toUpperCase() + tmpLocation.slice(1));
		const tmpState = pState ? pState : 'toggle';
		// if this is panel is already active, close it
		if (this['ActivePanel' + tmpLocationCap] === tmpPanel.name && tmpState === 'toggle')
		{
			this.callCloseHandler(tmpLocationCap);
			// check if the active panel state on the DOM is active
			if (document.getElementById('HeadlightPanels-' + tmpLocationCap + 'Panel').classList.contains('is-active'))
			{
				this.log.info('Closing active panel');
				this['ActivePanel' + tmpLocationCap] = null;
				this.togglePanel(tmpLocation, 'close');
			}
			else
			{
				this.log.info('Opening active panel');
				this['ActivePanel' + tmpLocationCap] = tmpPanel.name;
				this.togglePanel(tmpLocation, 'open');
			}
			if (pCallback) pCallback();
			return;
		}
		// if a DIFFERENT panel is already active in this location and we're about to swap it out,
		// fire the outgoing panel's closeHandler so it can release any pending state (e.g. clearing
		// `is-loading` buttons on inputs that opened the panel). Without this, togglePanel's
		// "panel is already open" early-return swallows the close lifecycle and the previous panel's
		// pending work is silently abandoned.
		if (this['ActivePanel' + tmpLocationCap] && this['ActivePanel' + tmpLocationCap] !== tmpPanel.name)
		{
			this.callCloseHandler(tmpLocationCap);
		}
		// if we are in mobile view, we need to close the other panel if it's open
		if (this.pict.services.HeadlightPanels.isPhoneDevice)
		{
			// if the other panel is open, close it
			const otherPanelLocation = tmpLocation === 'left' ? 'right' : 'left';
			if (this['ActivePanel' + (otherPanelLocation.charAt(0).toUpperCase() + otherPanelLocation.slice(1))])
			{
				this.log.info(`Closing other panel: ${otherPanelLocation}`);
				this.callCloseHandler(otherPanelLocation.charAt(0).toUpperCase() + otherPanelLocation.slice(1));
				this['ActivePanel' + (otherPanelLocation.charAt(0).toUpperCase() + otherPanelLocation.slice(1))] = null;
				this.togglePanel(otherPanelLocation, 'close');
			}
			// TODO: Revisit this later if we need to deal with iOS Safari and the resize event for the dynamic url bar not respecting 100vh in CSS
			// window.addEventListener('resize', () =>
			// {
			// 	const style = window.getComputedStyle(document.querySelector('#HeadlightPanels-Container'));
			// 	const navBarHeight = style.getPropertyValue('--panels-navbar-height');
			// 	const computedHeightValue = `calc(${ window.innerHeight }px - ${ navBarHeight })`;
			// 	style.setProperty('--panels-panel-height', computedHeightValue);
			// });
		}
		this.log.info(`Rendering panel: ${tmpPanel.name} (${tmpPanel.view}) in ${tmpLocation} panel with forced state: ${tmpState}`);
		// Closing: there is nothing to show, so skip the content render entirely and just close.
		if (tmpState === 'close')
		{
			this['ActivePanel' + tmpLocationCap] = tmpPanel.name;
			this.togglePanel(tmpLocation, tmpState, () =>
			{
				if (pCallback) pCallback();
			});
			return;
		}
		// Open the panel FIRST, then render into it. Rendering first leaves the click with no feedback
		// at all for the whole render -- the panel does not even begin to slide in until the content is
		// ready -- and the slide is then pure added latency instead of cover for the render.
		const tmpPanelElement = document.getElementById(`HeadlightPanels-${tmpLocationCap}Panel`);
		if (!tmpPanelElement?.classList.contains('is-active'))
		{
			// The container still holds the previously opened pane's markup, so a closed panel has to be
			// cleared before it slides in or the user watches stale content arrive.
			this.showPaneLoadingSkeleton(tmpLocation, tmpPanel.name);
		}
		this['ActivePanel' + tmpLocationCap] = tmpPanel.name;
		// pCallback has always meant "content rendered AND the panel finished animating", so hold that
		// contract now that the two run concurrently rather than one after the other.
		let tmpPendingSteps = 2;
		const fStepComplete = () =>
		{
			tmpPendingSteps--;
			if (tmpPendingSteps < 1 && pCallback)
			{
				pCallback();
			}
		};
		this.togglePanel(tmpLocation, tmpState, fStepComplete);
		// A pane that fails mid-render would otherwise leave the panel stuck on the loading skeleton it
		// was just opened with, swallow the open callback, and let the error escape to the click handler.
		// Panes render their tab views in a serial chain, so one bad tab is enough to trigger this.
		let tmpRenderSettled = false;
		const fRenderComplete = (pError) =>
		{
			if (tmpRenderSettled)
			{
				return;
			}
			tmpRenderSettled = true;
			if (pError)
			{
				this.log.error(`Failed to render the ${tmpPanel.name} panel: ${pError?.message || pError}`);
				this.showPaneRenderError(tmpLocation);
			}
			else
			{
				this.log.info(`Rendered ${tmpPanel.name} panel content`);
				this.recordPaneWidth(tmpPanel.name, tmpLocationCap);
			}
			fStepComplete();
		};
		try
		{
			this.pict.views[tmpPanel.view].renderAsync(false, false, false, false, fRenderComplete);
		}
		catch (pError)
		{
			fRenderComplete(pError);
		}
	}

	removeLoadingSkeleton(pElement)
	{
		// if the parent element has the skeleton class, remove it there instead
		this.pict.providers.UtilityProvider.removeLoadingSkeleton(pElement);
	}

	/**
	 * Remember how wide a pane rendered, so its next loading skeleton can hold the panel at that width.
	 * @param {string} pPaneName - The pane that just rendered
	 * @param {string} pLocationCap - The capitalised panel location (Left or Right)
	 * @return {void}
	 */
	recordPaneWidth(pPaneName, pLocationCap)
	{
		const tmpPanel = document.getElementById(`HeadlightPanels-${pLocationCap}Panel`);
		if (!tmpPanel)
		{
			return;
		}
		const tmpWidth = Math.round(tmpPanel.getBoundingClientRect().width);
		if (tmpWidth < 1 || this.PaneWidths[pPaneName] === tmpWidth)
		{
			return;
		}
		this.PaneWidths[pPaneName] = tmpWidth;
		this.savePaneWidths();
	}

	/**
	 * Read the remembered pane widths back.
	 *
	 * Storage can be unavailable (private windows, blocked site data) or hold something unexpected, and
	 * this is only a hint for how wide to draw a loading skeleton, so any failure just starts us empty.
	 * @return {Object} Map of pane name to width in pixels
	 */
	loadPaneWidths()
	{
		try
		{
			const tmpStored = window.localStorage.getItem(_PaneWidthStorageKey);
			if (!tmpStored)
			{
				return {};
			}
			const tmpParsed = JSON.parse(tmpStored);
			if (!tmpParsed || typeof tmpParsed !== 'object' || Array.isArray(tmpParsed))
			{
				return {};
			}
			// a corrupted entry should never get to size a panel
			const tmpWidths = {};
			for (const tmpKey of Object.keys(tmpParsed))
			{
				const tmpValue = tmpParsed[tmpKey];
				if (typeof tmpValue === 'number' && isFinite(tmpValue) && tmpValue > 0)
				{
					tmpWidths[tmpKey] = tmpValue;
				}
			}
			return tmpWidths;
		}
		catch (pError)
		{
			this.log?.info(`Could not read the remembered panel widths: ${pError?.message || pError}`);
			return {};
		}
	}

	/**
	 * Persist the remembered pane widths, so only the first ever open of a pane in this browser draws
	 * its skeleton at the bare minimum width.
	 * @return {void}
	 */
	savePaneWidths()
	{
		try
		{
			window.localStorage.setItem(_PaneWidthStorageKey, JSON.stringify(this.PaneWidths));
		}
		catch (pError)
		{
			// full, disabled or unavailable -- the widths simply will not survive the reload
			this.log?.info(`Could not persist the remembered panel widths: ${pError?.message || pError}`);
		}
	}

	/**
	 * A remembered width, clamped into the band the CSS actually allows at the CURRENT viewport.
	 *
	 * Panes that hit the wrapper's cap remember the cap itself rather than their content, so a width
	 * stored on a wide screen would otherwise draw a skeleton wider than the panel can ever be on a
	 * narrow one.
	 * @param {string} pPaneName - The pane to look up
	 * @return {number} A usable width in pixels, or 0 when nothing is remembered
	 */
	getRememberedPaneWidth(pPaneName)
	{
		const tmpRemembered = this.PaneWidths[pPaneName];
		if (!tmpRemembered)
		{
			return 0;
		}
		const tmpViewportWidth = window.innerWidth || 0;
		if (!tmpViewportWidth)
		{
			return tmpRemembered;
		}
		// mirrors `.panel { min-width: 15vw }` and `.hl-panel-wrapper { max-width: 50vw }`
		return Math.min(Math.max(tmpRemembered, tmpViewportWidth * 0.15), tmpViewportWidth * 0.5);
	}

	/**
	 * Replace a panel's loading skeleton with a failure message.
	 *
	 * Without this a pane that throws mid-render leaves the panel pulsing on the skeleton forever, which
	 * reads as "still loading" rather than "this is broken".
	 * @param {string} pLocation - The panel location to fill (left or right)
	 * @param {string} [pMessage] - The message to display
	 * @return {void}
	 */
	showPaneRenderError(pLocation, pMessage)
	{
		const tmpLocationCap = (pLocation.charAt(0).toUpperCase() + pLocation.slice(1));
		const tmpPanel = document.getElementById(`HeadlightPanels-${tmpLocationCap}Panel`);
		if (!tmpPanel)
		{
			return;
		}
		const tmpNotification = document.createElement('div');
		tmpNotification.className = 'notification has-text-text-light is-dark m-3';
		tmpNotification.textContent = pMessage || 'This panel could not be loaded. Close it and try again.';
		tmpPanel.innerHTML = '';
		tmpPanel.appendChild(tmpNotification);
	}

	/**
	 * Paint a placeholder into a panel container so the panel can be shown before its pane has rendered.
	 *
	 * `.skeleton-block` carries its own min-height and pulse animation, so this needs no extra styling.
	 * @param {string} pLocation - The panel location to fill (left or right)
	 * @param {number} [pRowCount] - The number of placeholder rows to paint
	 * @return {void}
	 */
	showPaneLoadingSkeleton(pLocation, pPaneName, pRowCount)
	{
		const tmpLocationCap = (pLocation.charAt(0).toUpperCase() + pLocation.slice(1));
		const tmpPanel = document.getElementById(`HeadlightPanels-${tmpLocationCap}Panel`);
		if (!tmpPanel)
		{
			this.log.error(`Panel not found for the loading skeleton: [${pLocation}]`);
			return;
		}
		// Stand in for the pane as an actual `.panel`, so the placeholder picks up the panel's height and
		// its heading bar from the styles the real pane will use. Every pane has exactly one
		// `.panel-heading`, so this is always the right shape; the tabs strip that five of them add on
		// top of it is deliberately not reproduced.
		const tmpWrapper = document.createElement('article');
		tmpWrapper.className = 'panel is-active hl-pane-loading-skeleton';
		// The panel wrapper shrinks to fit, and it is normally the rendered pane that gives it a width.
		// Bare skeleton rows are much narrower than that, so without a width here the panel slides in as
		// a sliver and snaps wide when the content lands. Match the pane's own floor, then its last
		// known width when we have one.
		tmpWrapper.style.minWidth = '15vw';
		const tmpLastWidth = pPaneName ? this.getRememberedPaneWidth(pPaneName) : 0;
		if (tmpLastWidth)
		{
			tmpWrapper.style.width = `${tmpLastWidth}px`;
		}
		const tmpHeading = document.createElement('p');
		tmpHeading.className = 'panel-heading';
		// the heading draws from its padding rather than its content, but it still needs something in it
		tmpHeading.textContent = '\u00A0';
		tmpWrapper.appendChild(tmpHeading);
		for (let i = 0; i < (pRowCount || 5); i++)
		{
			const tmpRow = document.createElement('div');
			tmpRow.className = 'panel-block skeleton-block has-background-text-40 mx-3 mb-1';
			tmpWrapper.appendChild(tmpRow);
		}
		tmpPanel.innerHTML = '';
		tmpPanel.appendChild(tmpWrapper);
	}

	/**
	 * Add the theme class to the body to account for the navbar location offset
	 * @return {void}
	 */
	setBodyElementOffsetForFixedNavbar()
	{
		if (this.pict.settings.HeadlightPanels.Configuration.NavBar?.location === 'top')
		{
			document.body.classList.add('has-navbar-fixed-top');
			document.body.classList.remove('has-navbar-fixed-bottom');
		}
		else
		{
			document.body.classList.remove('has-navbar-fixed-top');
			document.body.classList.add('has-navbar-fixed-bottom');
		}
	}

	/**
	 * This function is used to set the default configuration for the view. It will blend any custom configuration with the default configuration.
	 * @return {void}
	 */
	setDefaultPanelConfiguration()
	{
		if (!this.pict.settings.HeadlightPanels)
		{
			this.pict.settings.HeadlightPanels = {};
		}
		this.pict.log.info('Setting default panel configuration.');
		this.pict.settings.HeadlightPanels.Configuration = Object.assign({}, DefaultConfiguration);
		// set the default configuration for reference in the view (for developers to see)
		this.pict.settings.HeadlightPanels.Configuration_Default = DefaultConfiguration;
	}

	/**
	 * This function is used to set the custom configuration for the view to be meshed with the default config on init.
	 * @param {Object} pConfiguration - The default configuration to set
	 * @return {void}
	 */
	setPanelConfiguration(pConfiguration)
	{
		this.pict.log.info('Setting custom panel configuration.');
		if (typeof pConfiguration !== 'object')
		{
			this.pict.log.error('Invalid configuration object provided. Please check the configuration object you provided.');
			return;
		}
		if (!this.pict.settings.HeadlightPanels)
		{
			this.pict.settings.HeadlightPanels = {};
		}
		this.pict.settings.HeadlightPanels.Configuration = { ...DefaultConfiguration, ...pConfiguration };
		// set the custom configuration for reference in the view (for developers to see)
		this.pict.settings.HeadlightPanels.Configuration_Custom = Object.assign({}, pConfiguration);
		// recompile and render the view with the new configuration
		this.pict.views.HeadlightPaneNavigation.compileNavigation();
	}

	/**
	 * @typedef {object} HeadlightToastOptions
	 * @property {string} message - The message to show (HTML permitted; rendered when it looks like markup or allowHTML is set).
	 * @property {string} [type='is-info'] - Legacy Bulma type class (is-info/is-success/is-warning/is-danger) or a PSM enum value.
	 * @property {number} [duration=3000] - Auto-dismiss delay in ms; 0 for a persistent toast.
	 * @property {string} [position='bottom-center'] - PSM position key.
	 * @property {boolean} [dismissible=true] - Show a close button.
	 * @property {boolean} [allowHTML] - Force raw-HTML rendering; auto-detected from the message when omitted.
	 * @property {boolean} [sticky=false] - Keep this toast up until dismissToast() takes it back. Exempt from
	 *   auto-dismiss, from the duplicate throttle, and from single-toast eviction. For state, not events.
	 */

	/**
	 * Resolve the Pict-Section-Modal view, tolerating both registration names in use
	 * (canonical 'Pict-Section-Modal' from the shared scaffold, and form-editor's 'PictSectionModal').
	 * @returns {?object}
	 */
	_resolveModal()
	{
		if (!this.pict || !this.pict.views)
		{
			return null;
		}
		return this.pict.views['Pict-Section-Modal'] || this.pict.views['PictSectionModal'] || null;
	}

	/**
	 * What a keyboard or camera scan does when no panel has taken the scanner: a sample opens Sample Details, and the
	 * Scan Samples cards open Scan Samples. Registered at the bottom of the app's HeadlightQR scan handlers, so an app
	 * (LIMS) or an open panel can handle scans first.
	 */
	registerScanHandling()
	{
		const tmpQR = this.pict.providers.HeadlightQR;
		if (!tmpQR || typeof tmpQR.pushScanHandler !== 'function')
		{
			return;
		}
		tmpQR.pushScanHandler(
			{
				Hash: 'panels-default',
				Mode: 'GoTo',
				onScan: (pResolution) =>
				{
					if (!this.pict.AppData || !this.pict.AppData.CurrentUser || !this.pict.AppData.CurrentUser.LoggedIn)
					{
						return true;
					}
					if (pResolution.Status === 'Found' && pResolution.Entity === 'Sample' && pResolution.Record && pResolution.Record.IDSample)
					{
						this.pict.views.SampleDetails.open(pResolution.Record.IDSample, pResolution.Record);
					}
					else if (pResolution.Status === 'Deleted')
					{
						this.toast({ message: `That ${String(pResolution.Entity || 'record').toLowerCase()} was deleted.`, type: 'is-warning' });
					}
					else if (pResolution.Status !== 'Found')
					{
						this.toast({ message: 'Nothing found for that code.', type: 'is-warning' });
					}
					return true;
				},
			});
		tmpQR.registerActionEntry('cart', 'open', () => this.pict.views.QRPanel.open('putaway'));
		tmpQR.registerActionEntry('receive', 'start', () => this.pict.views.QRPanel.open('receive'));
		const fNeedsPanel = () => this.toast({ message: 'That card is for Scan Samples. Open Scan Samples first, then scan it again.', type: 'is-warning' });
		tmpQR.registerActionEntry('cart', 'submit', fNeedsPanel);
		tmpQR.registerActionEntry('cart', 'clear', fNeedsPanel);
	}

	/**
	 * Show a toast notification to the user, customized based on the options provided.
	 * Delegates to Pict-Section-Modal via HeadlightToastAdapter (replaces the former bulma-toast wrapper).
	 * @param {HeadlightToastOptions} pOptions
	 * @returns {{ dismiss: function }}
	 */
	toast(pOptions)
	{
		const tmpNoop = { dismiss: () => {} };
		// Check if a message was provided, mininum requirement for a toast notification
		if (!pOptions || !pOptions.message)
		{
			this.pict.log.error('No message provided for toast notification');
			return tmpNoop;
		}

		const tmpModal = this._resolveModal();
		if (!tmpModal || typeof tmpModal.toast !== 'function')
		{
			this.pict.log.warn('Pict-Section-Modal unavailable; toast suppressed', { Message: pOptions.message });
			return tmpNoop;
		}

		const tmpPlan = this._ToastAdapter.translate(pOptions, Date.now());
		if (!tmpPlan)
		{
			// Duplicate suppressed by the throttle window.
			return tmpNoop;
		}

		// Single-toast: dismiss any prior toast before showing the new one, then track the new handle.
		this._ToastAdapter.trackHandle(null);
		const tmpHandle = tmpModal.toast(tmpPlan.message, tmpPlan.options);
		this._ToastAdapter.trackHandle(tmpHandle, tmpPlan.sticky);
		return tmpHandle;
	}

	/**
	 * Dismiss a toast this view handed out, releasing any sticky tracking it held.
	 * Tolerates the noop handle toast() returns when the modal view is unavailable or the throttle fired.
	 * @param {?{ dismiss: function }} pHandle - A handle returned by toast().
	 * @returns {void}
	 */
	dismissToast(pHandle)
	{
		this._ToastAdapter.releaseHandle(pHandle);
	}

	/**
	 * Announce a status message to assistive technology.
	 *
	 * Pict-Section-Modal renders toasts with no live-region semantics, so a screen reader never hears
	 * one at all. This keeps a single polite region on the body and rewrites it.
	 * @param {string} pMessage - The message to announce; an empty string clears the region.
	 * @returns {void}
	 */
	announceStatus(pMessage)
	{
		let tmpRegion = document.getElementById('HeadlightPanels-StatusLiveRegion');
		if (!tmpRegion)
		{
			tmpRegion = document.createElement('div');
			tmpRegion.id = 'HeadlightPanels-StatusLiveRegion';
			tmpRegion.className = 'is-sr-only';
			tmpRegion.setAttribute('role', 'status');
			tmpRegion.setAttribute('aria-live', 'polite');
			tmpRegion.setAttribute('aria-atomic', 'true');
			document.body.appendChild(tmpRegion);
		}
		tmpRegion.textContent = pMessage || '';
	}

	/**
	 * This handles the hide/show collapsing of a block group inside a pane of content.
	 * @param {string} pKey - the key of the group we are toggling
	 * @param {string} pState - the state to toggle the group to (open or close)
	 */
	toggleCollapsiblePanelBlockGroup(pKey, pState)
	{
		const group = document.querySelector(`[data-collapsible-toggle="${pKey}"]`);
		const content = document.querySelector(`[data-collapsible-content="${pKey}"]`);
		if (!group || !content)
		{
			return;
		}
		// handle forced open state
		if (pState === 'open')
		{
			content.classList.remove('is-hidden');
			content.classList.add('animate', 'animate__fadeIn', 'animate__faster');
			// if we have a chevron, turn it
			if (group.querySelector('.fa-chevron-right'))
			{
				group.querySelector('.fa-chevron-right').classList.replace('fa-chevron-right', 'fa-chevron-down');
			}
		}
		// handle forced close state
		else if (pState === 'close')
		{
			content.classList.add('is-hidden');
			// if we have a chevron, turn it
			if (group.querySelector('.fa-chevron-down'))
			{
				group.querySelector('.fa-chevron-down').classList.replace('fa-chevron-down', 'fa-chevron-right');
			}
		}
		// handle toggle state
		else
		{
			// if the content is hidden, show it
			if (content.classList.contains('is-hidden'))
			{
				content.classList.remove('is-hidden');
				// if we have a chevron, turn it
				if (group.querySelector('.fa-chevron-right'))
				{
					group.querySelector('.fa-chevron-right').classList.replace('fa-chevron-right', 'fa-chevron-down');
				}
			}
			// if the content is shown, hide it
			else
			{
				content.classList.add('is-hidden');
				// if we have a chevron, turn it
				if (group.querySelector('.fa-chevron-down'))
				{
					group.querySelector('.fa-chevron-down').classList.replace('fa-chevron-down', 'fa-chevron-right');
				}
			}
		}
	}

	/**
	 * This function is used to toggle the visibility of a panel.
	 * @param {string} pLocation - The location of the panel to toggle (left or right)
	 * @param {string} pState - The state to toggle the panel to (open or close)
	 * @param {function} [fCallback] - (optional) The callback function to execute after the panel is toggled
	 * @return {void}
	 * @example
	 * togglePanel('left', 'open');
	 * togglePanel('right', 'close');
	 */
	togglePanel(pLocation, pState, fCallback = () =>
	{})
	{
		if (!pLocation)
		{
			this.log.error('Panel location not found. Please check the location you provided.');
			fCallback();
			return;
		}
		// get the panel and panel wrapper (always capitalize the first letter of the location for the ID look up)
		const tmpLocationCap = (pLocation.charAt(0).toUpperCase() + pLocation.slice(1));
		const tmpPanelID = `HeadlightPanels-${tmpLocationCap}Panel`;
		const tmpPanel = document.getElementById(tmpPanelID);
		// if the panel is not found, log an error and return
		if (!tmpPanel)
		{
			this.log.error(`Panel not found: [${pLocation}; id=${tmpPanelID}]  Please check the name you provided.`);
			fCallback();
			return;
		}
		// if the panel is already active, determine if we're closing it or opening another panel
		const isPanelActive = tmpPanel.classList.contains('is-active');
		if (isPanelActive && pState === 'open')
		{
			this.log.info('Panel is already open');
			this['ActivePanel' + tmpLocationCap] = tmpPanel.id;
			fCallback();
			return;
		}
		if (!isPanelActive && pState === 'close')
		{
			this.log.info('Panel is already closed');
			this['ActivePanel' + tmpLocationCap] = null;
			fCallback();
			return;
		}
		// // account for the lefty mode setting
		// if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode)
		// {
		// 	pLocation = pLocation === 'left' ? 'right' : 'left';
		// }
		// if the panel is already active, close it
		if (isPanelActive && pState === 'close')
		{
			this.callCloseHandler(tmpLocationCap);
			this.log.info('Closing panel');
			tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateIn);
			tmpPanel.classList.add(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateOut);
			// set a timeout to remove the active/transition classes after the transition duration
			setTimeout(() =>
			{
				this.log.info('Closing panel');
				tmpPanel.classList.remove('is-active');
				tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateOut);
				this.fable.HeadlightPanels.clearUIHighlights();
				this.fable.HeadlightPanels[pLocation + 'PanelResetCustomWidth']();
				fCallback();
			}, this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateDuration);
		}
		else
		{
			this.log.info('Opening panel');
			// if the panel is not active, open it
			tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateOut);
			tmpPanel.classList.add(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateIn);
			tmpPanel.classList.add('is-active');

			// TODO: Revisit these once we separate out "sticky panel that won't close" vs "flex background content shifts when panel opens/closes"
			// for user settings to allow overlapping vs flexing background content (wip)
			// if (this.pict.views.HeadlightPaneSettings.readUserPreference(`PanelOverlap-${pLocation}`))
			// {
			// 	tmpPanel.classList.add('pinned-open');
			// 	document.body.style['margin' + tmpLocationCap] = tmpPanel.offsetWidth + 'px';
			// }
			// else
			// {
			// 	tmpPanel.classList.remove('pinned-open');
			// 	document.body.style['margin' + tmpLocationCap] = 0;
			// }

			// set a timeout to remove the active/transition classes after the transition duration
			setTimeout(() =>
			{
				tmpPanel.classList.remove(this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateIn);
				fCallback();
			}, this.pict.settings.HeadlightPanels.Configuration.PanelLocations[pLocation].animateDuration);
		}
	}

	/**
	 * A general utility function to toggle the visibility of the tab content within a panel.
	 * NOTE: this expects the ID pattern to follow this example:
	 * Tab Elements -> `#HeadlightPanels-{Context}Panel-Tabs`
	 * Tab Buttton -> `#HeadlightPanels-{Context}Panel-TabName`
	 * Tab Content -> `#HeadlightPanels-{Context}Panel-Content`
	 * @param {string} id - the ID of the panel to toggle
	 * @param {string} context - the context of the panel
	 * @return {void}
	 */
	toggleTabContent(id, context)
	{
		if (!id)
		{
			this.log.error('Panel ID not found. Please check the ID you provided.', id);
			return;
		}
		if (!context)
		{
			this.log.error('Panel context not found. Please check the context you provided.', context);
			return;
		}
		const panelID = `HeadlightPanels-${context}Panel`;
		const panel = document.getElementById(panelID);
		if (!panel)
		{
			this.log.error(`Panel not found: [${context}; id=${panelID}]  Please check the name you provided.`, panel);
			return;
		}
		// get the clicked tab and panel
		const tabs = document.getElementById('HeadlightPanels-' + context + 'Panel-Tabs').querySelectorAll('a');
		// remove active class from all tabs
		for (let i = 0; i < tabs.length; i++)
		{
			tabs[i].classList.remove('is-active');
		}
		document.getElementById(id + '-Tab').classList.add('is-active');
		// hide all panels
		const contentList = document.getElementById('HeadlightPanels-' + context + 'Panel').querySelectorAll('.panel-content');
		for (let i = 0; i < contentList.length; i++)
		{
			contentList[i].classList.add('is-hidden');
		}
		const activeContent = document.getElementById(id + '-Content');
		// show the clicked panel
		if (activeContent.classList.contains('is-hidden'))
		{
			activeContent.classList.remove('is-hidden');
		}
		else
		{
			activeContent.classList.add('is-hidden');
		}
	}

	/**
	 * This function is used to toggle the full screen modal with populated content.
	 * @param {string} pState - The forced state to toggle the modal to (open or close) - not setting this will just toggle the current state
	 * @param {Object} pOptions - Optional data to populate the modal with
	 * @return {void}
	 */
	togglePanelFullScreenModal(pState, pOptions)
	{
		const pData = pOptions || {};
		const tmpRenderableHash = pOptions?.RenderableHash || 'HeadlightPanels-FullScreenModal';
		const tmpContentDestinationAddress = pOptions?.ContentDestinationAddress || '#HeadlightPanels-FullScreenModal-Container';
		const tmpCallback = pOptions?.Callback || ((pData) =>
		{
			this.log.info('Rendered Headlight Panels fullscreen modal content with the following optional data:', pData);
		});
		// in case we have any active media playing (video, audio), pause it
		this.pict.providers.UtilityProvider.pauseAnyActiveMedia();
		// handle the forced state or the toggle state
		if (pState === 'close')
		{
			this.AppData.FullScreenModalActive = false;
			document.getElementById('HeadlightPanels-FullScreenModal-Container').innerHTML = '';
		}
		else if (pState === 'open')
		{
			this.AppData.FullScreenModalActive = true;
			this.pict.views.HeadlightPanels.renderAsync(tmpRenderableHash, tmpContentDestinationAddress, pData, false, tmpCallback);
		}
		else
		{
			this.AppData.FullScreenModalActive = !this.AppData.FullScreenModalActive;
			// if the modal is active, render the content
			if (this.AppData.FullScreenModalActive)
			{
				this.pict.views.HeadlightPanels.renderAsync(tmpRenderableHash, tmpContentDestinationAddress, pData, false, tmpCallback);
			}
			// if the modal is not active, clear the content
			else
			{
				document.getElementById('HeadlightPanels-FullScreenModal-Container').innerHTML = '';
			}
		}
	}

	/**
	 * This function is used to toggle the pin state of a panel.
	 * @param {string} pLocation - The location of the panel to toggle the pin state for
	 * @param {string} pContext - The context of the panel to toggle the pin state for
	 * @param {string} pState - The forced state to toggle the pin to (true or false) - not setting this will just toggle the current state
	 * @return {void}
	 */
	togglePanelPinState(pLocation, pContext, pState)
	{
		const locMap =
		{
			'left': 'Left',
			'right': 'Right',
		};
		pLocation = locMap[pLocation] || pLocation;
		const panelWrapperElement = pLocation ? document.getElementById('HeadlightPanels-' + pLocation + 'Panel') : document.getElementById('HeadlightPanels-LeftPanel');
		// get the location from the config
		let locationCap = panelWrapperElement.id.split('-')[1].replace('Panel', '');
		// update our pin state so we can track it in the AppData
		this.AppData[locationCap + 'PanelPinned'] = !this.AppData[locationCap + 'PanelPinned'];

		// account for lefty mode
		if (this.pict.settings.HeadlightPanels.Configuration.PanelOptions.useLeftyMode)
		{
			if (locationCap === 'Left')
			{
				locationCap = 'Right';
			}
			else
			{
				locationCap = 'Left';
			}
		}
		// toggle the pinned-open class
		if (panelWrapperElement.classList.contains('pinned-open') && pState !== 'pin')
		{
			this.log.info('Removing pin from panel');
			panelWrapperElement.classList.remove('pinned-open');
			// reset the body padding
			document.body.style['margin' + locationCap] = 0;
		}
		else if (pState !== 'unpin')
		{
			this.log.info('Pinning panel open');
			panelWrapperElement.classList.add('pinned-open');
			// offset the body padding to account for the pinned panel
			document.body.style['margin' + locationCap] = panelWrapperElement.offsetWidth + 'px';
		}
	}

	/**
	 * This function is used to update the badge on the nav button for a panel.
	 * @param {string} pContext - The context of the panel to update the badge for
	 * @param {number} pLogCount - The number of logs to display in the badge
	 * @return {void}
	 * @example
	 * updateNavButtonBadge('HeadlightPanels-ErrorPanel');
	 */
	updateNavButtonBadge(pContext, pLogCount)
	{
		if (!pContext)
		{
			this.log.error('Panel context not found. Please check the context you provided.');
			return;
		}
		const panelButton = document.getElementById('HeadlightPanels-NavBar-' + pContext + '-Button');
		if (!panelButton)
		{
			this.log.error('Panel button not found. Please check the button you provided.');
			return;
		}
		// TODO: hoist this up to the configuration later
		const panelColorMap = {
			'Solver': 'is-warning',
			'Validations': 'is-danger',
		};
		// get the panel name and log count
		const logCount = pLogCount || 0;
		const navButtonWrapper = panelButton.parentElement;
		// always remove the last badge before adding a new one
		if (navButtonWrapper.querySelector('.badge'))
		{
			navButtonWrapper.removeChild(navButtonWrapper.querySelector('.badge'));
		}
		// only add a badge if there are logs to display
		if (navButtonWrapper && logCount > 0)
		{
			const badge = document.createElement('span');
			badge.classList.add('badge', panelColorMap[pContext] || 'is-info');
			badge.innerText = `${logCount}`;
			navButtonWrapper.append(badge);
		}
	}

	/**
	 * set the width of a panel to a custom (pre-determined) percentage width
	 * @param {String} pDirection - The direction of the panel to toggle
	 * @param {Number} pPercentage - The percentage width to set the panel to
	 * @return {void}
	 */
	setPanelCustomWidth(pDirection, pPercentage)
	{
		const tmpDirections = [ 'left', 'right' ];
		const tmpWidths = [ 0, 20, 25, 33, 40, 50, 60, 67, 75, 80, 100 ];
		// validate the direction before we proceed
		if (!tmpDirections.includes(pDirection))
		{
			this.log.error('Invalid direction provided. Please provide a valid direction. Supported directions are:', tmpDirections);
			return;
		}
		// let's validate the width before we proceed
		if (!tmpWidths.find((width) => width == pPercentage))
		{
			this.log.error('Invalid percentage width provided. Please provide a valid percentage width. Supported widths are:', tmpWidths);
			return;
		}
		// reset the panel width before setting the new width
		this.resetPanelCustomWidth(pDirection);
		// get the panel and set the new width
		const tmpPanel = document.querySelector('.hl-panel-wrapper-' + pDirection);
		if (tmpPanel)
		{
			// remove all the width classes, then add the new width
			tmpPanel.classList.add('is-wide-' + pPercentage);
		}
	}

	/**
	 * Reset the width of a panel to default non-wide width
	 * @param {String} pDirection - The direction of the panel to reset
	 * @return {void}
	 */
	resetPanelCustomWidth(pDirection)
	{
		const tmpDirections = [ 'left', 'right' ];
		const tmpWidths = [ 0, 20, 25, 33, 40, 50, 60, 67, 75, 80, 100 ];
		// validate the direction before we proceed
		if (!tmpDirections.includes(pDirection))
		{
			this.log.error('Invalid direction provided. Please provide a valid direction. Supported directions are:', tmpDirections);
			return;
		}
		// get the panel and remove the width class
		const tmpPanel = document.querySelector('.hl-panel-wrapper-' + pDirection);
		if (tmpPanel)
		{
			// remove all the width classes
			tmpPanel.classList.remove(...tmpWidths.map((width) => 'is-wide-' + width));
		}
	}
}

module.exports = HeadlightPanels;
module.exports.default_configuration = require('../templates/HeadlightPanels-Templates-Default.js');

},{"../../../../lib/service/headlight-bridge-document-manager":2,"../../../../lib/service/materials-form-manager/Materials-Form-Manager.js":26,"../../../../lib/web/headlight-modal/Headlight-Modal-Service.js":270,"../../../../lib/web/headlight-popover/Headlight-Popover-Service.js":273,"../../../../lib/web/native-bridge/index.js":306,"../../../../web/providers/CommentProvider.js":1576,"../../../../web/providers/ConfigurationProvider.js":1578,"../../../../web/providers/DocumentProvider.js":1579,"../../../../web/providers/Entity-Provider.js":1580,"../../../../web/providers/FieldSettingsProvider.js":1581,"../../../../web/providers/FileNavigatorProvider.js":1583,"../../../../web/providers/FormConversionProvider.js":1584,"../../../../web/providers/GeoProvider.js":1586,"../../../../web/providers/ImportantFilesProvider.js":1587,"../../../../web/providers/InspectionProvider.js":1589,"../../../../web/providers/LabProvider.js":1590,"../../../../web/providers/LineItemProvider.js":1591,"../../../../web/providers/LocationProvider.js":1592,"../../../../web/providers/MarkdownProvider.js":1593,"../../../../web/providers/MaterialProvider.js":1594,"../../../../web/providers/MixDesignProvider.js":1595,"../../../../web/providers/MixSpecificationProvider.js":1596,"../../../../web/providers/ObservationProvider.js":1597,"../../../../web/providers/ObservationSetProvider.js":1598,"../../../../web/providers/PlantProvider.js":1599,"../../../../web/providers/ProducerProvider.js":1600,"../../../../web/providers/ProductProvider.js":1601,"../../../../web/providers/ProjectFileProvider.js":1602,"../../../../web/providers/ProjectProvider.js":1603,"../../../../web/providers/QRCodeProvider.js":1604,"../../../../web/providers/SampleLogProvider.js":1606,"../../../../web/providers/SampleProvider.js":1607,"../../../../web/providers/TestInstanceProvider.js":1609,"../../../../web/providers/UploadTrackingProvider.js":1610,"../../../../web/providers/UserProvider.js":1611,"../../../../web/providers/UtilityProvider.js":1612,"../behaviors/DocumentStateDisplay.js":1533,"../behaviors/HeadlightToastAdapter.js":1534,"../configuration/HeadlightPanels-Configuration-Default.json":1535,"../services/HeadlightPanels-Fable-Service.js":1536,"../templates/HeadlightPanels-Templates-Default.js":1537,"../views/Academy-View.js":1538,"../views/Comment-View-Current.js":1539,"../views/Document-View-Create.js":1540,"../views/Document-View-Current.js":1541,"../views/Document-View-Details.js":1542,"../views/Document-View-Search.js":1543,"../views/Inspection-View.js":1557,"../views/Observation-Edit-Annotation.js":1558,"../views/Observation-Edit-SubImage.js":1559,"../views/Observation-View-Create-Media.js":1560,"../views/Observation-View-Details.js":1561,"../views/Observation-View-Included.js":1562,"../views/Observation-View-Search.js":1563,"../views/ProjectFile-View-Search.js":1566,"../views/Sample-View-Create.js":1568,"../views/Sample-View-Current.js":1569,"../views/Sample-View-Details.js":1570,"../views/Sample-View-Scan.js":1571,"../views/Sample-View-Search.js":1572,"../views/TestInstance-Wizard.js":1573,"./HeadlightPanels-Pane-Bridges.js":1544,"./HeadlightPanels-Pane-Custom.js":1545,"./HeadlightPanels-Pane-Documents.js":1546,"./HeadlightPanels-Pane-Navigation.js":1547,"./HeadlightPanels-Pane-Observations.js":1548,"./HeadlightPanels-Pane-Profile.js":1549,"./HeadlightPanels-Pane-Samples.js":1550,"./HeadlightPanels-Pane-Secret.js":1551,"./HeadlightPanels-Pane-Settings.js":1552,"./HeadlightPanels-Pane-Solver.js":1553,"./HeadlightPanels-Pane-Status.js":1554,"./HeadlightPanels-Pane-Validations.js":1555,"./Observation-View-Sets.js":1564,"./Pict-Form-Solver.js":1565,"./QRPanel.js":1567,"headlight-rest-client":20,"pict-view":733}],1557:[function(require,module,exports){
const libPictView = require('pict-view');
/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class Inspection extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideIfEqual:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			return tmpValue == tmpCompare ? 'is-hidden' : '';
		});

		this.pict.MetaTemplate.addPattern('{~BitElse:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpTrue, tmpFalse ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			return tmpValue == '1' ? tmpTrue : tmpFalse;
		});

		// add the ".is-hidden" class to the Select a Bridge  title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~HideForBridge:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			const tmpLocked = this.pict.AppData?.DocumentData?.ReportData?.Locked;
			return tmpValue && tmpValue !== tmpCompare || tmpLocked === 1 ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the Add To Inspection btn if the passed value is false
		this.pict.MetaTemplate.addPattern('{~HideForInspection:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			const tmpLocked = this.pict.AppData?.DocumentData?.ReportData?.Locked;
			const tmpDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			// if there is no document, dont allow to add inspections
			return tmpValue && tmpValue > tmpCompare && tmpLocked === 0 && tmpDocument ? '' : 'is-hidden';
		});
	}

	includeChangeHandler(pID)
	{
		this.log.info(`includeChangeHandler: ${pID}`);
		if (!this.pict.AppData.CurrentInspection)
		{
			this.log.error(`No Current Inspection set; can't update include state for document ${pID}.`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Current Inspection set; can't update include state for document: ${pID}.`,
				type: 'is-danger',
			});
			return;
		}
		const tmpDocumentID = pID.split('_')[1];
		if (!tmpDocumentID)
		{
			return;
		}
		const tmpDocument = this.AppData.InspectionDocumentRecords?.find?.((pRecord) => pRecord.IDDocument == tmpDocumentID);
		const tmpCheckbox = document.getElementById(pID);
		const tmpInclude = tmpCheckbox instanceof HTMLInputElement && tmpCheckbox.checked;
		if (tmpDocument)
		{
			tmpDocument.IncludeOnDossier = tmpInclude ? 1 : 0;
		}
		this.pict.BridgeDocumentManager.includeDocumentInInspectionDossier(tmpDocumentID, this.pict.AppData.CurrentInspection.IDInspection, tmpInclude)
		.catch((pError) =>
		{
			this.log.error(`Error updating inspection dossier include state.`, pError);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Error updating inspection dossier.`,
				type: 'is-danger',
			});
		});
	}

	/**
	 * Set Current Inspection Type
	 * @param {object} event - The click event
	 */

	getCurrentType(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		// get current inspection type
		const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
		if (inspectionTypeSelector instanceof HTMLSelectElement)
		{
			const currentInspectionType = this.AppData.InspectionTypes?.find((pType) => pType.IDInspectionType == inspectionTypeSelector.value);
			// set current inspection type name
			this.currentInspectionTypeName = currentInspectionType.Name;
			// update current inspection type based on selection on Current Inspection
			this.AppData.CurrentInspection.IDInspectionType = inspectionTypeSelector.value;
			// update current inspection name in report data based on selection
			this.AppData.DocumentData.ReportData.FormData.CurrentInspection.Type = this.currentInspectionTypeName;
			this.pict.log.info('Current Document FormData:', this.AppData.DocumentData?.ReportData?.FormData);
		}
	}


	inspectionTypeChangeHandler(event)
	{
		if (!this.pict.AppData.CurrentInspection)
		{
			this.log.error(`No Current Inspection set; can't update inspection type for inspection: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Current Inspection set; can't update inspection type for inspection: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
			if (inspectionTypeSelector instanceof HTMLSelectElement)
			{
				// enable inspection type selector
				inspectionTypeSelector.disabled = false;
			}
			if (document.getElementById('CurrentInspection-Type-Button'))
			{
				// change edit aesthetics to save aesthetics
				document.getElementById('CurrentInspection-Type-Button').classList.remove('is-link');
				document.getElementById('CurrentInspection-Type-Button').classList.add('is-success');
				document.getElementById('CurrentInspection-Type-Icon').classList.remove('fa-pencil');
				document.getElementById('CurrentInspection-Type-Icon').classList.add('fa-save');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('title', 'Save Inspection Type');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('onclick', '_Pict.views.Inspection.confirmInspectionType()');
			}
		}
	}

	/**
	 * Confirmation Modal to save the form with the new Inspection Type
	 */
	confirmInspectionType()
	{
		// the body and footer templates for the confirmation modal
		const confirmModalBodyTemplate = /*html*/`
		<span id="ConfirmModalBody">
			<div class="column is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">The Inspection Type will be changed from <strong>${this.existingInspectionTypeName}</strong> to <strong>${this.currentInspectionTypeName}</strong> for form <strong>${this.AppData.CurrentInspection.Name}</strong>.</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to save or close this modal.</p>
				</div>
			</div>
		</span>`;
		const confirmModalFooterTemplate = /*html*/`
		<div id="ConfirmModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Inspection Type" onclick="_Pict.views.Inspection.confirmSaveCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the confirmation modal
		const confirmModalOptions = {
			title: 'Save Inspection Type?',
			modalBodyTemplate: confirmModalBodyTemplate,
			modalFooterTemplate: confirmModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(confirmModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// show save spinner
			event.target.innerHTML = '<span class="icon"><i class="fas fa-fw fa-spinner fa-spin" aria-hidden="true"></i></span>';
		}
		// update bridge current inspection
		await this.pict.providers.BridgeProvider.updateBridgeInspection(this.pict.AppData.CurrentInspection)
		.catch((pError) =>
		{
			this.log.error(`Error updating inspection type.`, pError);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Error updating inspection type.`,
				type: 'is-danger',
			});
		});
		await this.pict.providers.DocumentProvider.handleSave();
		if (event)
		{
			// change save spinner back to save text
			event.target.innerHTML = '<span class="icon"><i class="fas fa-fw fa-save" aria-hidden="true"></i></span><span>Save</span>';
			this.pict.fable.services.HeadlightModal.dismissModals();
			this.log.info(`Inspection type update successful.`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Inspection type has been updated.`,
				type: 'is-success',
			});
			const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
			if (inspectionTypeSelector instanceof HTMLSelectElement)
			{
				// disable inspection type selector after successful save
				inspectionTypeSelector.disabled = true;
			}
			if (document.getElementById('CurrentInspection-Type-Button'))
			{
				// change save aesthetics back to edit aesthetics
				document.getElementById('CurrentInspection-Type-Button').classList.remove('is-success');
				document.getElementById('CurrentInspection-Type-Button').classList.add('is-link');
				document.getElementById('CurrentInspection-Type-Icon').classList.remove('fa-save');
				document.getElementById('CurrentInspection-Type-Icon').classList.add('fa-pencil');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('title', 'Edit Inspection Type');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('onclick', '_Pict.views.Inspection.inspectionTypeChangeHandler(event)');
			}
			// update inspection type values
			this.initializeInspectionTypeSelect();
			// render the current state of the document data
			this.pict.views.BridgeSelection.renderAsync(() =>
			{
				this.pict.log.info('Bridge Selection Rendered');
			});
		}
	}

	invalidate()
	{
		delete this.AppData.InspectionDocumentRecords;
		delete this.AppData.CachedInspectionDocumentRecordsIDInspection;
	}

	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync(async () =>
		{
			const noInspectionSet = !this.pict.AppData.CurrentInspection && this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			const cacheDeleted = !this.AppData.CachedInspectionDocumentRecordsIDInspection && !this.AppData.InspectionDocumentRecords;
			if (noInspectionSet || cacheDeleted)
			{
				try
				{
					await this.pict.providers.InspectionProvider.getCurrentInspectionDocuments(this.pict.AppData?.DocumentData?.ReportData?.IDDocument);
				}
				catch (pError)
				{
					this.log.error('Error loading current Inspection Documents.', pError);
					this.pict.views.HeadlightPanels?.toast?.({
						message: `Error loading current Inspection Documents.`,
						type: 'is-danger',
					});
					return fCallback(pError);
				}
			}
			else
			{
				this.log.info('Current Inspection already set, skipping loading from Document.');
			}
			fCallback();
		}, pRenderable);
	}

	/**
	 * Adds the current document to inspection selected.
	 */
	async setCurrentInspection()
	{
		//there is no Inspection associated with the document yet
		//check if an inspection is selected
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection') || this.pict.views.Inspection.CurrentSearchFilters.Inspection;
		if (selectedInspection)
		{
			const inspectionID = selectedInspection.toString();
			const documentID = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			if (documentID)
			{
				const newInspectionDoc = await this.pict.BridgeDocumentManager.addDocumentToInspection(documentID, inspectionID, true);
				if (newInspectionDoc)
				{
					this.pict.views.HeadlightPanels?.toast?.({
						message: `Document has been added to Inspection.`,
						type: 'is-success',
					});
					this.pict.views.Inspection.renderAsync(() =>
					{
						this.log.info('Current Inspection rendered');
					});
				}
			}
		}
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 */
	updateSelectedInspection()
	{
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection');
		if (selectedInspection)
		{
			this.pict.ContentAssignment.removeAttribute('#buttonAddToInspection', 'disabled');
			this.pict.views.Inspection.CurrentSearchFilters.Inspection = selectedInspection;
		}
	}
	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		this.initializeInspectionTypeSelect();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Add a Document to the current Inspection
	 */
	addDocumentToInspection()
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents');
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-DocumentPanel').setAttribute('data-panel-mode', 'add-to-inspection');
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-inspection';
		this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-inspection';
		this.pict.views.DocumentSearch.setMode('add-to-inspection');
		// set the banner on the header that you are adding an Document
		document.getElementById('HeadlightPanels-DocumentPanel-Document-Header-Mode-Target').innerText = this.AppData.CurrentInspection.Name || ' the current inspection';
	}

	resetInspectionView()
	{
		this.invalidate();
		this.pict.views.Inspection.renderAsync(() =>
		{
			this.log.info('Inspection rendered');
		});
	}

	/**
	 * Validate changes before closing the panel
	 * @param {object} event
	 */
	handleClosePanelEvent(event)
	{
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection');
		if (selectedInspection && !this.pict.AppData?.DocumentData?.ReportData?.CurrentInspection)
		{
			this.fable.HeadlightModal.spawnMiniModal(
				{
					...this.fable.HeadlightModal.MiniModalPreset,
					message: 'Close Current Inspection Panel?',
				},
				() =>
				{
					this.pict.HeadlightPanels.leftPanelHide();
					this.pict.views.Inspection.resetInspectionView();
				},
			null);
		}
		else
		{
			this.pict.views.HeadlightPanels.closeThisPanel(event);
		}
	}

	/**
	 * Add a form to an inspection
	 */
	addFormToInspection()
	{
		this.pict.ContentAssignment.removeClass('#InspectionSelector', 'is-hidden');
		this.pict.ContentAssignment.removeClass('#buttonAddToInspection', 'is-hidden');
		this.pict.ContentAssignment.setAttribute('#buttonShowInspections', 'disabled', 'disabled');
		const tmpInspection = this.AppData?.DocumentData?.ReportData?.CurrentInspection ? { id: this.AppData?.DocumentData?.ReportData?.CurrentInspection.IDInspection, text: this.AppData?.DocumentData?.ReportData?.CurrentInspection?.Name } : null;
		const tmpProject = this.AppData?.DocumentData?.ReportData?.Project?.IDProject ? this.AppData?.DocumentData?.ReportData?.Project?.IDProject : null;
		//this.pict.providers.InspectionSelector.initializeSelect2('Inspection', tmpBridge );
		this.initializeSelect2Plugin({
			IDProject: tmpProject,
			dropdownCssClass: 'theme-dark' + (tmpInspection ? ' has-sticky-option' : ''),
			placeholder: 'Search by Inspections...',
			ElementID: 'Inspection',
			ParentID: 'InspectionSelector',
			URL: 'Inspections',
			IDField: 'IDInspection',
			TextField: 'Name',
			StickyOption: tmpInspection,
			PreselectOption: tmpInspection,
		}, () =>
		{
			this.log.info('Select2 Inspection initialized');
		});
	}


	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Inspection',
				{
					Input: pOptions.ElementID,
					SearchFields: [ 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Enter a inspection name ...',
					HandleSearchFilters: (pFilters) =>
					{
						if (!pOptions.IDProject)
						{
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						pFilters.push(`FBV~IDProject~EQ~${pOptions.IDProject}`);
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](`#${pOptions.ElementID}`).data('select2'))
			{
				//NOTE:has to be attached to a Parent for the drop down to show
				window['jQuery'](`#${pOptions.ElementID}`).select2(Object.assign( { dropdownParent: `#${pOptions.ParentID}` }, tmpSelectOptions));
			}
		}

		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}
	/**
	 * Initialize the Inspection Type Selector
	 */

	initializeInspectionTypeSelect()
	{
		const tmpSelect = document.getElementById('CurrentInspection-Type-Selector');
		if (tmpSelect instanceof HTMLSelectElement)
		{
            tmpSelect.value = this.pict.AppData.CurrentInspection.IDInspectionType;
            const existingInspectionType = this.AppData.InspectionTypes?.find((pType) => pType.IDInspectionType == tmpSelect.value);
			this.existingInspectionTypeName = existingInspectionType.Name;
		}
	}
}

const _ViewConfiguration = (
	{
		ViewIdentifier: 'HeadlightPanels-Inspection',
		DefaultRenderable: 'HeadlightPanels-Inspection',
		DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
		AutoRender: true,
		CSS: '',
		Templates: [
			{
				Hash: 'Datum-Value-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-Inspection" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-Inspection-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.Inspection.handleClosePanelEvent(event);">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-Inspection-Icon" class="fas fa-fw fa-building-magnifying-glass" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-Inspection-Header-Title" class="mr-3">Current Inspection</span>
					</p>
					<div class="column nested-scroll-content has-bottom-navbar-offset">
						{~TIfAbs:HeadlightPanels-Inspection-Empty:AppData.CurrentInspection:AppData.CachedInspectionDocumentRecordsIDInspection^==^0~}
						{~TIfAbs:HeadlightPanels-Inspection-Content:AppData.CurrentInspection:AppData.CachedInspectionDocumentRecordsIDInspection^>^0~}
					</div>
				</article>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Empty',
				Template: /*html*/`
				<div class="notification is-dark has-text-grey has-text-centered {~Show:Pict.AppData.DocumentData.ReportData.Locked~}">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">Document is locked.</span>
				</div>
				<div class="is-dark has-text-grey has-text-centered {~HideForInspection:Pict.AppData.DocumentData.ReportData.Project.IDProject^0~}">
					<button id="buttonShowInspections" class="button is-fullwidth is-primary" type="button" title="Add to inspection" onclick="_Pict.views.Inspection.addFormToInspection()">
						<span class="icon">
							<i class="fas fa-fw fa-plus" aria-hidden="true"></i>
						</span>
						<span>Add to Inspection</span>
					</button>
					<div>
						{~T:HeadlightPanels-Inspection-InspectionSelector~}
						<button id="buttonAddToInspection" class="button is-centered is-primary pt-2 is-hidden" disabled type="button" title="Save" onclick="_Pict.views.Inspection.setCurrentInspection()">
							<span class="icon">
								<i class="fas fa-fw fa-save" aria-hidden="true"></i>
							</span>
							<span>Save</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-InspectionSelector',
				Template: /*html*/`
				<div id="InspectionSelector" class="column is-hidden theme-dark">
					<div class="field" style="margin-bottom: 10px;">
						<label class="label block" for="Inspection">Inspections</label>
						<div class="control control-status select is-fullwidth">
							<select
								id="Inspection"
								onchange="_Pict.views.Inspection.updateSelectedInspection('Inspection')"
							>{~TS:HeadlightPanels-Inspection-InspectionSelector-SelectedOptions:Context[0].CurrentSearchFilters.Inpsection~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Content',
				Template: /*html*/`
				
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-20">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:AppData.CurrentInspection.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">#{~D:AppData.CurrentInspection.IDInspection~}</p>
					</div>
				</div>
				{~T:HeadlightPanels-Inspection-Details:AppData.CurrentInspection~}
				{~T:HeadlightPanels-Inspection-Documents:AppData.InspectionDocumentRecords~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-Empty',
				Template: /*html*/`
				<tr>
					<td colspan="3" class="has-text-centered">
						<div class="notification is-dark">
							<span class="icon">
								<i class="fas fa-info-circle"></i>
							</span>
							<span class="icon-text">No inspection documents found.</span>
						</div>
					</td>
				</tr>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Details',
				Template: /*html*/`
				<div id="InspectionType-Details" data-theme="dark" class="columns m-0 px-3 my-3">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.StatusDisplay~}</span>
					</div>
					<div class="column is-6">
						<div class="field">
							<label class="title is-block is-6 has-text-text-60" for="CurrentInspection-Type-Selector">Type</label>
							{~T:HeadlightPanels-Inspection-Type-Selector~}
						</div>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^ObservationDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Scheduled Start Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ScheduledStartDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Deadline Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DeadlineDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Description</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Description~}</span>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents',
				Template: /*html*/`
				<h3 class="title has-text-text-90 is-5 p-0 m-0 ml-1 mb-2">Inspection Documents</h3>
				<table class="table is-striped is-hoverable is-fullwidth mb-2">
					<thead>
						<tr>
							<th class="has-text-centered">Included in Dossier</th>
							<th colspan="2">Name</th>
						</tr>
					</thead>
					<tbody>
						{~TIfAbs:HeadlightPanels-Inspection-Documents-Empty:AppData.InspectionDocumentRecords:AppData.InspectionDocumentRecords.length^==^0~}
						{~TIfAbs:HeadlightPanels-Inspection-Documents-List:AppData.InspectionDocumentRecords:AppData.InspectionDocumentRecords.length^>^0~}
					</tbody>
				</table>
				<button class="button is-fullwidth is-primary" type="button" title="Add document to inspection" onclick="_Pict.views.Inspection.addDocumentToInspection()">
					<span class="icon">
						<i class="fas fa-fw fa-plus" aria-hidden="true"></i>
					</span>
					<span>Add Document to Inspection</span>
				</button>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-List',
				Template: /*html*/`
				{~TS:HeadlightPanels-Inspection-Documents-List-Entry:Record~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-List-Entry',
				Template: /*html*/`
				<tr id="DocumentRow_{~D:Record.IDDocument~}">
					<td class="is-vcentered has-text-centered">
						<div class="{~HideIfEqual:Record.DocumentType^Inspection-Dossier~}">
							<input type="checkbox" title="Toggle for Dossier inclusion" class="is-checkbox is-success" id="Include_{~D:Record.IDDocument~}" name="document" {~BitElse:Record.IncludeOnDossier^checked^~} onchange="_Pict.views.Inspection.includeChangeHandler(id)">
						</div>
					</td>
					<td class="is-vcentered">{~D:Record.Name~}</td>
					<td class="is-vcentered has-text-right">
						<button class="button is-ghost has-text-primary-75" type="button" title="Open document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocumentHandler(event, '{~D:Record.IDDocument~}')">
							<span class="icon">
								<i class="fas fa-fw fa-edit" aria-hidden="true"></i>
							</span>
							<span>Open</span>
						</button>
					</td>
				</tr>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Type-Selector',
				Template: /*html*/`
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<select 
							id="CurrentInspection-Type-Selector"
							onchange="_Pict.views.Inspection.getCurrentType(event)"
							disabled
						>
						{~TS:HeadlightPanels-Inspection-Types:AppData.InspectionTypes~}
						</select>
					</p>
					<p class="control">
						<button id="CurrentInspection-Type-Button" class="button is-link" type="button" title="Edit Inspection Type" onclick="_Pict.views.Inspection.inspectionTypeChangeHandler(event)">
							<span class="icon is-small">
								<i id="CurrentInspection-Type-Icon" class="fas fa-pencil"></i>
							</span>
						</button>
					</p>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Types',
				Template: /*html*/`
				<option value="{~D:Record.IDInspectionType~}">{~D:Record.Name~}</option>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'HeadlightPanels-Inspection',
				TemplateHash: 'HeadlightPanels-Inspection-Wrapper',
			},
		],
	});


module.exports = Inspection;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":733}],1558:[function(require,module,exports){
const PictViewClass = require('pict-view');
const libPictSectionOpenSeaDragon = require('pict-section-openseadragon');
const libPictSectionOpenSeaDragonAnnotationSelector = require('pict-section-openseadragon/source/Pict-Section-OpenSeaDragonAnnotationSelector');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class OSDExtended extends libPictSectionOpenSeaDragon
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.osdSettings;

		/** @type {Pict} */
		this.pict;
	}

	customConfigureViewerSettings()
	{
		Object.assign(this.osdSettings,
		{
			zoomInButton: 'osd-zoom-in',
			zoomOutButton: 'osd-zoom-out',
			homeButton: 'osd-home',
		});
	}
}

class ObservationAnnotation extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationDetailsInFullScreen = false;
		this.ObservationAnnotationBackTo = 'ObservationDetails';
		this.CurrentZoomLevel = 1;
		if (!this.pict.ContentAssignment.getElement('#OSD-SVG-Sandbox')?.length)
		{
			const sandbox = document.createElement('div');
			sandbox.innerHTML = /*html*/`<div id="OSD-SVG-Sandbox" class="osd-sandbox"></div>`;
			document.body.insertBefore(sandbox, document.body.firstChild);
		}
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.ActiveObservationDetails?.IDObservation)
		{
			this.pict.providers.ObservationProvider.getObservationByID(this.ActiveObservationDetails.IDObservation, (returnedObs) =>
			{
				if (this.ActiveObservationDetails?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image')
				{
					const tmpIDArtifact = this.ActiveObservationDetails?.Details?.Image?.[0]?.IDArtifact;
					const tmpVersion = this.ActiveObservationDetails?.Details?.Image?.[0]?.Version;
					const ImageConfiguration =
					{
						ViewIdentifier: 'PictSectionOpenSeaDragon',
						ViewAddress: 'PictSectionOpenSeaDragon',
						EnableAnnotation: true,
						PrefixUrl: './images/',
						Colors:
						{
							'red': 'red',
							'green': 'green',
							'blue': 'blue',
							'cyan': '#4dd0e1',
							'deep-purple': '#673ab7',
							'pink': '#ff4081',
						},
						DrawModeLabel: 'Auto Annotate',
						TileSources:
						{
							type: 'image',
							url: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }`,
						},
					};
					this.ActiveObservationDetails = returnedObs;
					const existingAnnotations = this.ActiveObservationDetails?.Details?.Annotation?.[0]?.Datum?.Annotations;
					if (existingAnnotations)
					{
						ImageConfiguration.Annotations = existingAnnotations;
					}

					const commentConfiguration =
					{
						ViewIdentifier: 'PictSectionOpenSeaDragonAnnotationSelector',
						ViewAddress: 'PictSectionOpenSeaDragonAnnotationSelector',
						Colors:
						{
							'red': 'red',
							'green': 'green',
							'blue': 'blue',
							'cyan': '#4dd0e1',
							'deep-purple': '#673ab7',
							'pink': '#ff4081',
						},
					};
					if (!this.pict.views?.PictSectionOpenSeaDragon)
					{
						this.pict.addView('PictSectionOpenSeaDragon', Object.assign(libPictSectionOpenSeaDragon.default_configuration, ImageConfiguration), OSDExtended);
					}
					else
					{
						this.pict.views.PictSectionOpenSeaDragon.setTileSources(
						{
							type: 'image',
							url: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }`,
						});
						this.pict.views.PictSectionOpenSeaDragon.setAnnotations(ImageConfiguration.Annotations || []);
					}
					if (!this.pict.views?.PictSectionOpenSeaDragonAnnotationSelector)
					{
						this.pict.addView('PictSectionOpenSeaDragonAnnotationSelector', Object.assign(libPictSectionOpenSeaDragonAnnotationSelector.default_configuration, commentConfiguration), libPictSectionOpenSeaDragonAnnotationSelector);
					}
					this.pict.views.PictSectionOpenSeaDragon.render();
					if (!this.pict.views?.OSDCommentWrapper)
					{
						const wrapperConfig =
						{
							ViewIdentifier: 'OSDCommentWrapper',
							DefaultDestinationAddress: '#ObservationComments-Container-Div',
							DefaultRenderable: 'Comment-Wrap',
							Templates: [
								{
									Hash: 'Comment-Wrap-Container',
									Template: /*html*/`
									<article id="HeadlightPanels-NavigationPanel" class="panel is-active" style="max-width: 100%; height: 100%">
										<p id="HeadlightPanels-NavigationPanel-Header" class="px-5 pt-4 pb-4 has-background-text-20" style="color: white;">
											<span class="icon has-text-text-75">
												<i class="fas fa-fw fa-comments" aria-hidden="true"></i>
											</span>
											<span>Comments</span>
										</p>
										<div class="container" style="height: calc(100% - var(--panels-navbar-height));">
											<div id="OpenSeaDragonAnnotationSelector-Container-Div" style="width:100%; height: 100%"></div>
										</div>
										<style>
											.osd-drawmode-toggle-box {
												background-color: var(--bulma-text-70);
												padding-top: 5px;
												padding-left: 10px;
											}
											.osd-drawmode-text {
    											color: var(--bulma-text-15);
											}
											.osd-hatchmode-toggle-box {
												background-color: var(--bulma-text-70);
												padding-top: 5px;
												padding-left: 10px;
											}
											.osd-hatchmode-text {
    											color: var(--bulma-text-15);
											}
											.osd-sandbox {
												position: fixed !important;
												z-index: 9999;
											}
											.osd-scrollable-comments {
												background-color: var(--bulma-text-70) !important;
											}
											.osd-editor-inner {
												border-radius: 6px !important;
												border: 0px !important;
											}
											.osd-comment-color-flag {
												border-bottom: 3px solid var(--bulma-text-70) !important;
												border-right: 3px solid var(--bulma-text-70) !important;
											}
											.osd-editor-inner:hover > span.osd-comment-color-flag{
												height: 14px;
												width: calc(60% + 2px);
												margin-bottom: -2px;
												margin-right: -2px;
												border-bottom: 5px solid var(--bulma-text-70) !important;
												border-right: 5px solid var(--bulma-text-70) !important;
											}
											.osd-scrollable-comments .r6o-widget.comment {
												background-color: var(--bulma-text-35) !important;
												color: white !important;
												border-bottom: 0px !important;
											}
											.osd-scrollable-comments .r6o-widget.comment:last-child {
												border-radius: 0px 0px 6px 6px !important;
											}
											.osd-scrollable-comments .r6o-widget.r6o-tag {
												background-color: var(--bulma-warning-50) !important;
												border-radius: 0px 0px 6px 6px !important;
												border: none !important;
											}
											.osd-scrollable-comments ul.r6o-taglist > li {
												border: 1px solid var(--bulma-text-20) !important;
												background-color: transparent !important;
												border-radius: 6px !important;
												margin: 2px !important;
											}
											.osd-scrollable-comments .r6o-taglist {
												border: none !important;
											}
											.osd-scrollable-comments .r6o-editor-inner {
												background-color: var(--bulma-text-35) !important;
												color: white !important;
											}
											.osd-scrollable-comments span.r6o-label {
												background-color: var(--bulma-text-40) !important;
												padding: 0px 6px !important;
												background-color: transparent !important;
												color: var(--bulma-text-20) !important;
												border: none !important;
												border-radius: 6px !important;
											}
											.osd-scrollable-comments .r6o-widget > .r6o-editable-text.osd-editable-text:not(:first-child) {
												border-top: 1px solid var(--bulma-text-25) !important;
											}
										</style>
									</article>`,
								},
							],
							Renderables: [
								{
									'RenderableHash': 'Comment-Wrap',
									'TemplateHash': 'Comment-Wrap-Container',
									'DestinationAddress': '#HeadlightPanels-RightPanel',
									'RenderType': 'replace',
								},
							],

						};
						this.pict.addView('OSDCommentWrapper', wrapperConfig, PictViewClass);
					}
					this.pict.views.OSDCommentWrapper.render();
					this.pict.views.PictSectionOpenSeaDragonAnnotationSelector.render();
				}
			});
		}
		this.toggleFullScreenView({ val: true });
		this.pict.views.HeadlightPanels.togglePanel('right', 'close');
		return super.onAfterRender(pRenderable);
	}

	// Saves the observation annotations.
	async saveAnnotations()
	{
		const annotationsToSave = this.pict.views?.PictSectionOpenSeaDragon?.captureAnnotations() || [];
		if (this.ActiveObservationDetails?.Details?.Annotation?.[0]?.Datum)
		{
			this.ActiveObservationDetails.Details.Annotation[0].Datum.Annotations = annotationsToSave;
		}
		else if (this.ActiveObservationDetails?.Details)
		{
			this.ActiveObservationDetails.Details.Annotation = [ { Datum: { Annotations: annotationsToSave } } ];
		}

		await this.pict.providers.ObservationProvider.updateObservation(this.ActiveObservationDetails, (returnedObs)=>
		{
			this.ActiveObservationDetails = returnedObs;
			this.pict.views.HeadlightPanels.toast({
				message: 'Annotations Saved Successfully.',
				type: 'is-success',
			});
		});
	}

	async saveAndCloseAnnotation(event)
	{
		// this is kind of  a hacky workaround until we refactor panels to handle state w/ the browser routing
		await this.saveAnnotations();
		this.pict.views.HeadlightPanels.closeAllPanels();
		this.pict.fable.services.HeadlightPanels.rightPanelShow();
		this.pict.fable.services.HeadlightPanels.leftPanelShow();
		//resetting back to half the screen because annotations forces a full screen view
		this.pict.HeadlightPanels.rightPanelCustomWidth(50);
		await this.pict.views.HeadlightPaneObservations.showObservationDetailView(event, this.ActiveObservationDetails.IDObservation, null, async () =>
		{
			// Refresh any active CardDecks so the annotation update is visible.
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.reMarshalAllViewsWithCardDecks(this.ActiveObservationDetails.IDObservation, 'AllDocumentLists', true);
			}
		}).then(() =>
		{
			// wait for transcoder to finish processing the image
			this.pict.providers.ObservationProvider.cacheBustObsImages(this.ActiveObservationDetails.IDObservation, [ 5000, 20000 ]);
		});
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open');
	}

	/**
	 * This method will set the left hand annotation panel to be as large as possible if the user toggles the mode active.
	 * @param {Object} [force] - The force object
	 * @property {boolean} force.val
	 */
	toggleFullScreenView(force)
	{
		this.ObservationDetailsInFullScreen = force ? force.val : !this.ObservationDetailsInFullScreen;
		const tmpContainer = document.querySelector('#OpenSeaDragon-Container-Div');
		if (this.ObservationDetailsInFullScreen)
		{
			if (tmpContainer instanceof HTMLElement)
			{
				tmpContainer.style.height = 'calc(100vh - 65px  - 56px - 45px)';
			}
			this.fable.HeadlightPanels.leftPanelCustomWidth(100);
			this.fable.HeadlightPanels.rightPanelCustomWidth(20);
		}
		else
		{
			if (tmpContainer instanceof HTMLElement)
			{
				tmpContainer.style.height = '60vh';
				tmpContainer.style.marginTop = '0';
			}
			document.querySelector('.panel-heading').classList.remove('is-hidden');
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
		}
		// make the image redraw to fit the new size every time the user toggles the full screen mode
		setTimeout(() =>
		{
			this.pict.views.ObservationAnnotation.goHome();
		});
	}

	goHome()
	{
		this.pict.views.PictSectionOpenSeaDragon?.viewer?.viewport?.goHome();
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetObservationAnnotationView()
	{
		this.ActiveObservationDetails = {};
		this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		this.fable.HeadlightPanels.rightPanelResetCustomWidth();
	}

	/**
	 * @deprecated
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		this.pict.HeadlightModal.spawnMiniModal(
		{
			...this.pict.HeadlightModal.MiniModalPreset,
			message: 'Return to Observations List?',
		},
		() =>
		{
			this.pict.views.ObservationDetails.ActiveObservationDetails = this.ActiveObservationDetails;
			this.pict.views.ObservationDetails.returnToPreviousLocation(event, 'ObservationDetails');
			this.pict.views.HeadlightPanels.handlePanelToggle('PictSectionOpenSeaDragonAnnotationSelector', 'close');
			this.resetObservationAnnotationView();
		},
		null);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Observation Annotation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
		},
		null);
	}
}

module.exports = ObservationAnnotation;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationAnnotation',
	DefaultRenderable: 'ObservationAnnotation',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'ObservationAnnotation-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationAnnotationPanel" class="panel is-active">
				<p id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.ObservationAnnotation.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="button is-small is-rounded is-pulled-right hl-panel-fullscreen-button mr-2" aria-label="fullscreen" title="Toggle full screen view" onclick="_Pict.views.ObservationAnnotation.toggleFullScreenView()">
						<span class="hl-panel-fullscreen-button">
							<i class="fas fa-fw fa-expand"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationAnnotationPanel-Observation-Header-Title" class="mr-3">Observation Annotation</span>
				</p>
				<div id="HeadlightPanels-ObservationAnnotation-Content">
					{~T:ObservationAnnotation-Content:Pict.views.ObservationAnnotation.ActiveObservationDetails~}
				</div>
				<style>
					@media screen and (max-width: 900px) {
						.hl-panel-wrapper .open-sea-dragon-content .osd-toolbar
						{
							flex-direction: column;
							height: 100px;
						}
					}
					@media screen and (min-width: 901px) {
						.hl-panel-wrapper .open-sea-dragon-content .osd-toolbar
						{
							flex-direction: row;
							height: 50px;
						}
					}
				</style>
			</article>`,
		},
		{
			Hash: 'ObservationAnnotation-Content',
			Template: /*html*/`
			<div class="container panel-content" style="max-width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<div class="columns" style="margin: 0;">
					<div style="width: 100%; position: relative;">
						<div id="OpenSeaDragon-Container-Div" class="open-sea-dragon-content" style="height: calc(100vh - 65px - 56px - 45px);"></div>
						<div id="OpenSeaDragon-Navigation-Controls" class="open-sea-dragon-navigation-controls">{~T:ObservationAnnotation-Navigation-Controls~}</div>
					</div>
					<div id="ObservationComments-Container-Div" class="" style="height: calc(100vh - 65px - 56px - 45px);"></div>
				</div>
				<button title="Done" onclick="_Pict.views.ObservationAnnotation.saveAndCloseAnnotation()" 
				style="float: right; margin: 10px;" class="button is-small is-primary"><i class="fas fa-fw fa-check-circle" style="margin-right: 5px;"></i>Done</button></div>
				<button title="Save annotation" onclick="_Pict.views.ObservationAnnotation.saveAnnotations()" style="float: right; margin: 10px;" class="button is-success is-small"><i class="fas fa-fw fa-save" style="margin-right: 5px;"></i>Save Annotations</button>
			</div>`,
		},
		{
			Hash: 'ObservationAnnotation-Navigation-Controls',
			Template: /*html*/`
			<div class="buttons is-right" style="width: 50px; position: absolute; top: 0.5rem; right: 0.5rem;">
				<button id="osd-zoom-in" title="Zoom in" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-plus"></i>
					</span>
				</button>
				<button id="osd-zoom-out" title="Zoom out" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-minus"></i>
					</span>
				</button>
				<button id="osd-home" title="Re-center image" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-arrows-to-dot"></i>
					</span>
				</button>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationAnnotation',
			TemplateHash: 'ObservationAnnotation-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationAnnotation-Content',
			TemplateHash: 'ObservationAnnotation-Content',
			DestinationAddress: '#HeadlightPanels-ObservationAnnotation-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-section-openseadragon":707,"pict-section-openseadragon/source/Pict-Section-OpenSeaDragonAnnotationSelector":708,"pict-view":733}],1559:[function(require,module,exports){
const PictViewClass = require('pict-view');
const libPictSectionOpenSeaDragon = require('pict-section-openseadragon');
const libPictSectionPDFJS = require('pict-section-pdfjs');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class OSDExtended extends libPictSectionOpenSeaDragon
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.osdSettings;

		/** @type {Pict} */
		this.pict;
	}

	customConfigureViewerSettings()
	{
		Object.assign(this.osdSettings,
		{
			zoomInButton: 'osd-zoom-in',
			zoomOutButton: 'osd-zoom-out',
			homeButton: 'osd-home',
		});
	}
}

class ObservationSubImageSelector extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationSubImageSelectorBackTo = 'ObservationDetails';
		this.pict.MetaTemplate.addPattern('{~PreviewPages:', '~}', (pHash, pData, fCallback) =>
		{
			const template = /*html*/`
			<div class="has-background-text-40" id="PDFJS-Markup-Container-Div" style="min-width: 100%; height: calc(100vh - 65px - 44px - 56px);" ></div>`;
			return template;
		});
		this.wizardStep = 1;
		this.intent =
		{
			type: 'Document',
		};

		this.registerListenersForPDFViewer();
	}

	renderOSD(tileSources)
	{
		if (this.ActiveObservationDetails.IDObservation)
		{
			const ImageConfiguration =
			{
				ViewIdentifier: 'PictSectionOpenSeaDragonSubImage',
				ViewAddress: 'PictSectionOpenSeaDragonSubImage',
				EnableAnnotation: false,
				PrefixUrl: './images/',
				TileSources: tileSources,
			};
			if (!this.pict.views?.PictSectionOpenSeaDragonSubImage)
			{
				this.pict.addView('PictSectionOpenSeaDragonSubImage', Object.assign(libPictSectionOpenSeaDragon.default_configuration, ImageConfiguration), OSDExtended);
			}
			else
			{
				this.pict.views.PictSectionOpenSeaDragonSubImage.setTileSources(tileSources);
			}
			this.pict.views.PictSectionOpenSeaDragonSubImage.render();
		}
	}

	continue()
	{
		function getClosestZoomLevel(osdZoom, zoomLevels)
		{
			let closestZoomLevel;
			for (let i = 0; i < zoomLevels.length; i++)
			{
				if (zoomLevels[i] >= osdZoom)
				{
					closestZoomLevel = zoomLevels[i];
					break;
				}
			}
			if (!closestZoomLevel)
			{
				closestZoomLevel = zoomLevels[zoomLevels.length - 1];
			}
			return Math.max(1, closestZoomLevel);
		}
		const zoomLevels = [ 0.25, 0.5, 1, 2, 4, 8 ];

		const continueButton = document.getElementById('OSD-SubImageSelector-Continue');
		continueButton.classList.add('is-loading');

		this.pict.providers.ObservationProvider.extractInfoByID(this.ActiveObservationDetails.IDObservation, (extractedInfo) =>
		{
			const pageChoice = this.pict.views.PDFMarkupViewer.getCurrentPage();
			if (pageChoice < 1 || pageChoice > extractedInfo?.pages?.length)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'You must pick a page number within the document to proceed.',
					type: 'is-danger',
				});
				return;
			}
			this.wizardStep += 1;
			if (this.wizardStep === 2)
			{
				const pageObj = extractedInfo.pages.find((item)=>
				{
					return item.number == pageChoice;
				});
				const generatedTiles = {
					type: 'legacy-image-pyramid',
					levels: [],
				};
				for (const z of zoomLevels)
				{
					generatedTiles.levels.push(
					{
						url: `/1.0/Observation/${ this.ActiveObservationDetails.IDObservation }/Extract/${ encodeURIComponent(`Page:${ pageObj.number };Scale:${ z }`) }`,
						height: pageObj.height * z,
						width: pageObj.width * z,
					});
				}
				this.renderOSD(generatedTiles);
			}
			if (this.wizardStep === 3)
			{
				this.pict.providers.ObservationProvider.extractSubImage(this.ActiveObservationDetails.IDObservation,
				{
					Page: pageChoice,
					Bounds: this.pict.views.PictSectionOpenSeaDragonSubImage.captureViewport(),
					Scale: getClosestZoomLevel(this.pict.views.PictSectionOpenSeaDragonSubImage.viewer.viewport.getZoom(), zoomLevels),
				},
				(obs)=>
				{
					const openAnnotator = () =>
					{
						this.pict.HeadlightPanels.rightPanelResetCustomWidth();
						this.pict.HeadlightPanels.leftPanelResetCustomWidth();
						try
						{
							this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
							this.pict.views.ObservationAnnotation.ActiveObservationDetails = obs;
							this.pict.views.HeadlightPanels.handlePanelToggle('ObservationAnnotation', 'open');
							this.intent =
							{
								type: 'Document',
							};
							this.pict.views['PictFormMetacontroller-DynamicInputs']?.marshalToViewAsync();
							console.log('Opening annotation panel...');
						}
						catch (e)
						{
							console.error(e);
						}
					};
					if (this.intent?.type === 'ObservationSet' && this.intent?.IDObservationSet !== null)
					{
						this.pict.providers.ObservationSetProvider.addObservation(null, obs, this.intent.IDObservationSet).then(() =>
						{
							openAnnotator();
						});
					}
					else
					{
						if (this.AppData?.DocumentData?.ReportData?.IDDocument)
						{
							this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(obs.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument, openAnnotator);
						}
						else
						{
							openAnnotator();
						}
					}
				});
			}
			const steps = document.querySelectorAll('#ObservationSubImageSelector-Steps-List li');
			steps.forEach((step, i) =>
			{
				if (i + 1 === this.wizardStep - 1)
				{
					step.classList.add('prev-active');
				}
				else
				{
					step.classList.remove('prev-active');
				}
				if (i + 1 === this.wizardStep)
				{
					step.classList.add('is-active');
				}
				else
				{
					step.classList.remove('is-active');
				}
			});
			const stepBodies = document.querySelectorAll('#OSD-Wizard-Body-Pane > div');
			stepBodies.forEach((stepBody, i) =>
			{
				if (i + 1 === this.wizardStep)
				{
					stepBody.classList.add('is-active');
				}
				else
				{
					stepBody.classList.remove('is-active');
				}
			});
			if (this.wizardStep === 3)
			{
				continueButton.classList.add('is-hidden');
			}
			continueButton.classList.remove('is-loading');
		});
	}

	goHome()
	{
		this.pict.views.PictSectionOpenSeaDragon?.viewer?.viewport?.goHome();
	}

	/**
	 * Toggles the disabled attribute on/off for the passed in elements
	 * @param {Array.<{id:string, title:string}>} elements - {id: id of the element to target, title: tooltip when not disabled }
	 * @param {string} disabledText (optional) - tooltip to display when element is disabled
	 */
	toggleDisabled(elements, disabledText)
	{
		for (const [ key ] of Object.entries(elements))
		{
			const element = elements[key];
			if (!element.hasOwnProperty('id') )
			{
				continue;
			}
			const el = document.getElementById(element.id);

			if (!el)
			{
				continue;
			}

			if (el.hasAttribute('disabled'))
			{
				this.pict.ContentAssignment.removeAttribute(`#${element.id}`, 'disabled');
				if (element.title && typeof element.title === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', element.title );
				}
			}
			else
			{
				this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'disabled', 'disabled');
				if (typeof disabledText === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', disabledText);
				}
			}
		};
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 * @param {boolean} [noIntentReset=false] - If true, the intent will not be reset
	 * @param {boolean} [directPanels=false] - If true, the panels will be directly manipulated
	 * @param {string} [startingPage=undefined] - The page to start at
	 */
	resetObservationSubImageSelectorView(noIntentReset, directPanels, startingPage=undefined)
	{
		this.ActiveObservationDetails = {};
		this.wizardStep = 1;
		this.intent = noIntentReset ? this.intent : { type: 'Document' };
		if (directPanels)
		{
			this.pict.HeadlightPanels.leftPanelCustomWidth(100);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelHide();
		}

		// if caller is requesting we start at a specific page, set. Else, clears the selection.
		this.startingPage = startingPage;
	}

	/**
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		this.pict.HeadlightModal.spawnMiniModal(
		{
			...this.pict.HeadlightModal.MiniModalPreset,
			message: 'Return to Observations List?',
		},
		()=>
		{
			this.resetObservationSubImageSelectorView();
			this.pict.HeadlightPanels.rightPanelResetCustomWidth();
			this.pict.HeadlightPanels.leftPanelResetCustomWidth();
			this.pict.views.ObservationDetails.ActiveObservationDetails = this.ActiveObservationDetails;
			this.pict.views.ObservationDetails.returnToPreviousLocation(event, 'ObservationDetails');
			this.pict.views.HeadlightPanels.handlePanelToggle('ObservationSubImageSelector', 'close');
		},
		null);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Markup Observation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		},
		null);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const tmpIDArtifact = this.ActiveObservationDetails?.Details?.File?.[0]?.IDArtifact;
		const tmpVersion = this.ActiveObservationDetails?.Details?.File?.[0]?.Version;
		if (!this.pict.views?.PDFMarkupViewer)
		{
			this.pict.addView('PDFMarkupViewer', Object.assign(libPictSectionPDFJS.default_configuration, { pdfUrl: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`, DefaultDestinationAddress: '#PDFJS-Markup-Container-Div' }), libPictSectionPDFJS);
		}
		if (this.pict.views?.PDFMarkupViewer)
		{
			this.pict.views.PDFMarkupViewer.options.pdfUrl = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
			this.pict.views.PDFMarkupViewer.render();
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * TODO: move to the PDFViewer pict section, and allow parent view to inject a page number
	 * TODO: can we do this without the global listener?
	 * @spec listens for the pdf viewer loading. when fully loaded, auto-moves to a specific page if one is requested (i.e. last viewed one)
	 */
	registerListenersForPDFViewer()
	{
		document.addEventListener('webviewerloaded', async () =>
		{
			const viewer = document.querySelector('pdfjs-viewer-element');
			// Wait for the viewer initialization, receive PDFViewerApplication
			const viewerApp = await viewer.initialize();
			// Use event bus to handle viewer application events
			viewerApp.eventBus.on('pagesloaded', () =>
			{
				this.pict.log.info('Viewer pages loaded, startingPage=', this.startingPage);
				if (this.startingPage)
				{
					viewerApp.page = this.startingPage;
				}
			});
		});
		this.pict.log.debug('PDFViewer Handlers registered');
	}

	handleOnCloseEvent(pEvent)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Markup Observation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationSubImageSelector.resetObservationSubImageSelectorView();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		});
	}

	handleOnPinPanelEvent(pEvent)
	{
		this.pict.views.ObservationSubImageSelector.toggleDisabled(
		[
			{
				_id: 'ObservationEditSubImage-CloseButton',
				title: 'Close panel',
			},
			{
				_id: 'ObservationEditSubImage-BackButton',
				title: 'Back to Included List view',
			},
		],
		'Please unpin panel');

		this.pict.views.HeadlightPanels.togglePanelPinState();
	}
}

module.exports = ObservationSubImageSelector;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSubImageSelector',
	DefaultRenderable: 'ObservationSubImageSelector',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'ObservationSubImageSelector-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationSubImageSelectorPanel" class="panel is-active">
				<p id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header" class="panel-heading pr-4">
					<button id="ObservationEditSubImage-CloseButton" type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.ObservationSubImageSelector.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" 
						onclick="_Pict.views.ObservationSubImageSelector.handleOnPinPanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header-Title" class="mr-3">Create Markup Observation</span>
				</p>
				<div id="HeadlightPanels-ObservationSubImageSelector-Content">
					{~T:ObservationSubImageSelector-Content:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
			</article>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Content',
			Template: /*html*/`
			<header class="has-background-text-15">
				<ul id="ObservationSubImageSelector-Steps-List" class="wizard-list">
					<li id="OSD-Wizard-Tag-1" class="wizard-step-1 is-active"><div><span>Choose a Page</span></div></li>
					<li id="OSD-Wizard-Tag-2" class="wizard-step-2"><div><span>Select an Image Section</span></div></li>
					<li id="OSD-Wizard-Tag-3" class="wizard-step-3 end-block"><div><span>Annotate</span></div></li>
				</ul>
			</header>
			<div id="OSD-Wizard-Body-Pane">
				<div id="OSD-Wizard-Step-1" class="wizard-pane is-active">
					{~T:ObservationSubImageSelector-Wizard-Step-1:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
				<div id="OSD-Wizard-Step-2" class="wizard-pane">
					{~T:ObservationSubImageSelector-Wizard-Step-2:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
				<div id="OSD-Wizard-Step-3" class="wizard-pane">
					{~T:ObservationSubImageSelector-Wizard-Step-3~}
				</div>
			</div>
			<div class="buttons is-right" style="width: 50px; position: absolute; top: calc(100% - 60px); right: 0.5rem;">
				<button id="OSD-SubImageSelector-Continue" title="Continue" onclick="_Pict.views.ObservationSubImageSelector.continue()" 
				style="float: right; margin: 10px;" class="button is-primary has-text-white has-shadow is-normal"><i class="fas fa-fw fa-square-chevron-right" style="margin-right: 5px;"></i>Continue</button>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-1',
			Template: /*html*/`
			<div class="container panel-content" style="min-width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<figure class="image">
					{~PreviewPages:Record~}
				</figure>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-2',
			Template: /*html*/`
			<div class="container panel-content" data-observation-id="{~D:Record.IDObservation~}" style="min-width: 100%;">
				<div id="OpenSeaDragon-Container-Div" class="open-sea-dragon-content" style="height: calc(100vh - 65px - 44px - 56px); min-width: 100%;"></div>
				<div id="OpenSeaDragon-Navigation-Controls" class="open-sea-dragon-navigation-controls">{~T:ObservationSubImageSelector-Navigation-Controls~}</div>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-3',
			Template: /*html*/`
			<div class="container panel-content" data-observation-id="{~D:Record.IDObservation~}">
				<div class="p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<style>
								.lds-ring,
								.lds-ring div {
									box-sizing: border-box;
								}
								.lds-ring {
									display: inline-block;
									position: relative;
									width: 80px;
									height: 80px;
								}
								.lds-ring div {
									box-sizing: border-box;
									display: block;
									position: absolute;
									width: 64px;
									height: 64px;
									margin: 8px;
									border: 8px solid currentColor;
									border-radius: 50%;
									animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
									border-color: currentColor transparent transparent transparent;
								}
								.lds-ring div:nth-child(1) {
									animation-delay: -0.45s;
								}
								.lds-ring div:nth-child(2) {
									animation-delay: -0.3s;
								}
								.lds-ring div:nth-child(3) {
									animation-delay: -0.15s;
								}
								@keyframes lds-ring {
									0% {
										transform: rotate(0deg);
									}
									100% {
										transform: rotate(360deg);
									}
								}
							</style>
							<div class="lds-ring wizard-loader" style="color: white;"><div></div><div></div><div></div><div></div></div>
							<div class="is-size-6 has-text-centered" style="color: white; text-wrap: wrap: max-width: 50vw;">Preparing Image for Annotation...</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Navigation-Controls',
			Template: /*html*/`
			<div class="buttons is-right" style="width: 50px; position: absolute; top: 0.5rem; right: 0.5rem;">
				<button id="osd-zoom-in" title="Zoom in" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-plus"></i>
					</span>
				</button>
				<button id="osd-zoom-out" title="Zoom out"class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-minus"></i>
					</span>
				</button>
				<button id="osd-home" title="Original view" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-home"></i>
					</span>
				</button>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationSubImageSelector',
			TemplateHash: 'ObservationSubImageSelector-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationSubImageSelector-Content',
			TemplateHash: 'ObservationSubImageSelector-Content',
			DestinationAddress: '#HeadlightPanels-ObservationSubImageSelector-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-section-openseadragon":707,"pict-section-pdfjs":709,"pict-view":733}],1560:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationCreateMedia extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.FileListToUpload = []; // the list of files to upload, accessible across the component

		// the default options for the component
		this.DefaultConfiguration = {
			ObservationTypes: [ 'Legacy Image', 'Legacy Video', 'Legacy Audio', 'File' ],
			TagTypes: [ 'Tag' ], // TODO: add more types
			TagsList: [], // TODO: replace with types later
			FileSizeLimit: 4000000000, // 4 GB
			FileNumberLimit: 20,
			AllowCamera: true,
			AllowLocationRequest: true,
			FileRestrictions: [],
			DocumentInjectionTarget: null, // passed by method to target a specific element
			DocumentInjectionMethod: 'append', // replace, append, prepend,
			DocumentPreviewIdentifierAttribute: 'data-observation-id', // this is the unique attribute the template agrees to use to locate the preview image for each observation id
			onAfterDocumentJoinCallback: () =>
			{
				// optional callback to run after document join
			},
			onAfterCallback: (observationInfos, event) =>
			{
				// NOTE: You should override this method via configuration to do anything here besides close the panel and clear the banner after an upload action.
				// EX: Observation Image Sets will set this callback to inject the new images into the specific set location on the DOM.
				this.pict.log.info('No custom onAfterCallback specified in configuration for ObservationCreateMedia panel.');
			},
			onFallbackCallback: (observationInfoList) =>
			{
				// NOTE: this override does NOT get overwritten when the panel closes. You should use this when you need to do something on your view whenever a file is uploaded.
				// Example: show uploaded photo as inspection photo on bridge form after upload.
				this.pict.log.info('No custom onFallbackCallback specified in configuration for ObservationCreateMedia panel.');
			},
		};

		// add a pattern to the template engine to convert bytes to megabytes
		this.pict.MetaTemplate.addPattern('{~ToMegaBytes:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpColumnData = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpColumnData ? this.convertBytesToMegabytes(tmpColumnData) : 0;
		});
		this.pict.MetaTemplate.addPattern('{~ToGigaBytes:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpColumnData = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			return tmpColumnData ? this.convertBytesToGigabytes(tmpColumnData) : 0;
		});
	}

	instantiateConfiguration()
	{
		this.log.info('Initializing ObservationCreateMedia view...');
		if (!this.InstanceConfiguration)
		{
			this.DefaultConfiguration.IDDocument = this.AppData?.DocumentData?.ReportData?.IDDocument;
			this.DefaultConfiguration.IDProject = this.AppData?.DocumentData?.ReportData?.IDProject;
			this.DefaultConfiguration.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID;
			// the instance configuration for the component (the devloper can mutate this)
			this.InstanceConfiguration = JSON.parse(JSON.stringify(this.DefaultConfiguration));
		}
	}

	/**
	 * This method is used to build the tag selection list for the user to choose from as an observation tag.
	 * This is useful for the user to select from a list of tags that are relevant to the project or customer.
	 * @param {String} pFileGUID - the GUID of the file to build the tag selection list for
	 * @return {void}
	 */
	lookUpTagsForSelectionList(pFileGUID)
	{
		// if we have tags already, use them
		if (this.InstanceConfiguration.TagsList.length > 0)
		{
			this.buildTagSelectionList(pFileGUID);
			return;
		}
		this.log.info('Looking up tags for the selection list...');
		// get the tags from the server
		let tmpUrl = 'ObservationTags/FilteredTo/FBV~TagType~EQ~Tag';
		// if we have a project, filter the tags by the project
		if (this.InstanceConfiguration.IDProject)
		{
			tmpUrl = `ObservationTagProjectJoins/FilteredTo/FBV~IDProject~EQ~${ this.InstanceConfiguration.IDProject }`;
		}
		this.pict.HeadlightRestClient.getJSON(tmpUrl,
		(pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to retrieve tags for selection list.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: `<strong>Failed to retrieve tags for selection list.</strong><br/><em>${pError.message || pError}</em>`,
					type: 'is-danger',
				});
				this.buildTagSelectionList(pFileGUID);
				return;
			}
			if (pBody && Array.isArray(pBody))
			{
				this.InstanceConfiguration.TagsList = pBody;
				this.buildTagSelectionList(pFileGUID);
			}
		});
	}

	/**
	 * This method is to build the tag selection list for the user to choose from as an observation tag.
	 * This is useful for the user to select from a list of tags that are relevant to the project or customer.
	 * @param {String} pFileGUID
	 */
	buildTagSelectionList(pFileGUID)
	{
		const tmpTagList = this.InstanceConfiguration.TagsList;
		// list the tags by name/id for the selection list
		const elementId = '#ObservationCreateMedia-FileList-LabelSelect';
		// pretty up the Tag selector
		if (window.jQuery)
		{
			if (this.pict.ContentAssignment.hasClass(elementId, 'select2-hidden-accessible'))
			{
				window.jQuery(elementId).select2('destroy');
			}
			const tmpSelect2Data = [];
			let tmpSelectedTags = [];
			// if we have a file that already has tags set (multiple files), get the tags from the file
			if (pFileGUID)
			{
				const tmpFile = this.findFileByGUID(pFileGUID);
				if (tmpFile && tmpFile.Tags && tmpFile.Tags.length > 0)
				{
					tmpSelectedTags = tmpFile.Tags;
				}
			}

			// clear out any active selections from the select2 dropdown so they don't double pick
			for (let i=0; i < tmpTagList.length; i++)
			{
				tmpSelect2Data.push({
					id: tmpTagList[i].Tag,
					text: tmpTagList[i].Tag,
					selected: tmpSelectedTags.includes(tmpTagList[i].Tag), // NOTE: Could be an issue if we have two tags with the same name (but that shouldn't be allowed)
				});
			}
			let placeholder = 'Select tags...';
			// if we have no tags, show a message
			if (tmpSelect2Data.length === 0)
			{
				placeholder = 'No tags available.';
			}
			window.jQuery(elementId).html('').select2({
				dropdownParent: $('#ObservationCreateMedia-Content-Entry'),
				placeholder: placeholder,
				width: '100%',
				multiple: true,
				data: tmpSelect2Data,
				tags: true,
				dropdownCssClass: 'theme-dark',
				createTag: function(params)
				{
					const term = params.term.trim();
					if (term === '')
					{
						return null;
					}
					return {
						id: term,
						text: term,
						newTag: true,
					};
				},
			});
		}
	}

	/**
	 * Basic utility method to convert bytes to megabytes.
	 * @param {Number} pBytes
	 * @return {Number}
	 */
	convertBytesToMegabytes(pBytes)
	{
		return Math.round(pBytes / 1000000);
	}

	/**
	 * Basic utility method to convert bytes to gigabytes.
	 * @param {Number} pBytes
	 * @return {Number}
	 */
	convertBytesToGigabytes(pBytes)
	{
		return Math.round(pBytes / 1000000000);
	}

	/**
	 * This is a utility method to find a file in the list by the GUID.
	 * @param {String} pFileGUID
	 * @return {Object}
	 */
	findFileByGUID(pFileGUID)
	{
		let tmpFile = null;
		// find the file in our list by the guid string
		this.FileListToUpload.forEach((pFile, i) =>
		{
			if (pFile.GUID === pFileGUID)
			{
				tmpFile = pFile;
				return;
			}
		});
		return tmpFile;
	}

	/**
	 * This method is used to check if the document is locked before uploading files.
	 * If the document is locked, it will prevent the upload and show a message to the user.
	 * @param {Event} e - the event object
	 */
	checkIfLocked(e)
	{
		if (this.AppData?.DocumentData?.ReportData?.Locked)
		{
			e.preventDefault();
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
		}
	}
	/**
	 * This method is used to update the selection list to show the user which file they have selected for preview/editing.
	 * @param {Object} [pQuickCaptureFile] - a file object from the quick capture event, which bypasses the file picker
	 */
	handleUpdateSelectionList(pQuickCaptureFile)
	{
		// warn developers to migrate to the new event system
		if (pQuickCaptureFile)
		{
			this.pict.log.warn('Use the dedicated quick capture method to add files. See "quickCaptureImage()".');
			return;
		}
		this.log.info('Updating file selection list...');
		this.updateStepsListActiveState(1);
		const filesInput = document.getElementById('ObservationCreateMedia-FileList-Input');
		const tmpFileList = filesInput instanceof HTMLInputElement && filesInput.files;
		const tmpIncludedFileList = [];
		const tmpExcludedFileList = [];
		// clear out the list on the UI everytime
		this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-SelectionList', '');
		// show the empty row message
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-FileList-EmptyRow', 'is-hidden');

		// prevent more files than the limit (if set)
		if (this.InstanceConfiguration.FileNumberLimit && tmpFileList.length > this.InstanceConfiguration.FileNumberLimit)
		{
			this.pict.log.warn('File number limit exceeded! Limit: ', this.InstanceConfiguration.FileNumberLimit, ' Selected: ', tmpFileList.length);
			// inject message on the file picker
			this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-ErrorMessage', /*html*/`
			<div class="column notification is-danger is-dark mb-3 is-size-7">The maximum limit of files allowed for a single upload is set to ${ this.InstanceConfiguration.FileNumberLimit }. Please try again with fewer files selected.</div>`);
			return;
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-ErrorMessage', '');
		}

		// if we have files, then process them
		if (tmpFileList && tmpFileList.length > 0)
		{
			// disable the button until they reset the list
			this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-FileList-CreateButton', 'disabled', 'disabled');
			this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-FileList-ResetButton', 'disabled');
			// hide the empty row
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-FileList-EmptyRow', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-FileList-EmptyRow', 'is-active');

			// for each file, generate a UI element
			for (let i = 0; i < tmpFileList.length; i++)
			{
				// limit file size (if set)
				if (this.InstanceConfiguration.FileSizeLimit && tmpFileList[i].size > this.InstanceConfiguration.FileSizeLimit)
				{
					this.pict.log.warn('File size limit exceeded! Limit: ', this.InstanceConfiguration.FileSizeLimit, ' Selected: ', tmpFileList[i].size);
					tmpExcludedFileList.push(tmpFileList[i]);
				}
				else
				{
					const tmpFile = tmpFileList[i];
					// formatted object to store in the list
					const tmpFileDetails = {
						Name: tmpFile.name, // can be updated by the user - becomes the 'Observation Name'
						FileName: tmpFile.name, // for display purposes only
						Description: '', // can be updated by the user - becomes the 'Observation Description'
						Tags: [], // can be updated by the user - becomes the 'Observation Tags'
						File: tmpFile, // the original file object in its entirety
						FileTypeIcon: this.pict.providers.ObservationProvider.returnFileIconFromFileType(tmpFile.type), // the icon to display for the file type
						ObservationType: this.pict.providers.ObservationProvider.returnObservationTypeFromFileType(tmpFile.type), // the type of observation to create
						GUID: this.pict.getUUID(), // a unique identifier for the file
					};
					// store this in the 'valid' list to be set to the global list after the loop
					tmpIncludedFileList.push(tmpFileDetails);
					// add the file list item to the page
					this.render('ObservationCreateMedia-Renderable-SelectionListRow', '#ObservationCreateMedia-FileList-SelectionList', tmpFileDetails);
				}
			}

			// now show the error message if we have any excluded files
			if (tmpExcludedFileList.length)
			{
				let tmpUIList = '';
				for (let i = 0; i < tmpExcludedFileList.length; i++)
				{
					tmpUIList += `<li>${ tmpExcludedFileList[i].name }</li>`;
				}
				// inject message above the file list
				this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-FileList-ErrorMessage', /*html*/`
				<div class="column notification is-danger is-dark mb-3 is-size-7">
					<span>The following files exceed the max individual file size limit of ${ this.convertBytesToGigabytes(this.InstanceConfiguration.FileSizeLimit) } GB:</span>
					<ol class="pl-5">${ tmpUIList }</ol>
				</div>`);
			}
		}
		const newCount = tmpIncludedFileList.length + '';
		// update the count in the header
		this.pict.ContentAssignment.assignContent('#FilesToUploadCount', newCount);
		// store our local copy for the next step
		this.FileListToUpload = tmpIncludedFileList;
		this.handleUploadButton();

		// set the first row as active
		if (this.FileListToUpload.length > 0)
		{
			const button = document.querySelector('#ObservationCreateMedia-FileList-SelectionList .panel-block:first-child');
			if (button instanceof HTMLElement)
			{
				button.click();
			}
		}
	}

	/**
	 * This method is used to handle the upload button state based on the file list.
	 * If there are files in the list, the button is enabled, otherwise it is disabled.
	 * This is useful for the user to know when they can upload the files.
	 */
	handleUploadButton()
	{
		if ( this.FileListToUpload.length > 0)
		{
			this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-FileList-UploadButton', 'disabled');
		}
		else
		{
			this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-FileList-UploadButton', 'disabled', 'disabled');
		}
	}

	/**
	 * This method is used to handle the quick capture image event. This does everything from
	 * capturing the image, to uploading it to the server, and then updating the UI, but hides
	 * the details from the user. This is limited to single file only and does not use the upload panel flow.
	 * @param {Object} pFileInput
	 * @param {Object} pConfiguration
	 * @param {Function} pCallback
	 */
	async quickCaptureImage(pFileInput, pConfiguration, pCallback)
	{
		this.pict.log.info('Quick capture image: ', pConfiguration);

		if (!(pFileInput instanceof HTMLInputElement) || !pFileInput.files || pFileInput.files.length === 0)
		{
			this.pict.log.warn('No files selected for quick capture.');
			return;
		}
		else if (pFileInput.files.length > 1)
		{
			this.pict.log.warn('Multiple files selected for quick capture. Only the first file will be used.');
		}
		// set the button to "loading" since we have no other UI to show the user
		if (window.jQuery)
		{
			window.jQuery(pFileInput).parents('.button').addClass('is-loading');
		}
		// if we passed a callback set it now before we set the configuration
		// NOTE: this will run after the uploads are completed
		if (typeof pCallback === 'function')
		{
			this.InstanceConfiguration.onAfterCallback = pCallback;
		}
		this.setInstanceConfiguration(pConfiguration);

		const tmpFile = pFileInput.files[0];
		// formatted object to store in the list
		const tmpFileDetails = {
			Name: tmpFile.name, // can be updated by the user - becomes the 'Observation Name'
			FileName: tmpFile.name, // for display purposes only
			File: tmpFile, // the original file object in its entirety
			ObservationType: this.pict.providers.ObservationProvider.returnObservationTypeFromFileType(tmpFile.type), // the type of observation to create
			GUID: this.pict.getUUID(), // a unique identifier for the file
		};
		this.FileListToUpload = [ tmpFileDetails ];

		this.pict.log.info('Uploading file via Quick Capture: ', this.FileListToUpload);

		const observationResultList = [];

		// for each file, upload it and create an observation in a Promise
		await new Promise((resolve) =>
		{
			this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(tmpFileDetails, this.InstanceConfiguration.IDProject,
			(observationResult) =>
			{
				// add the result to the list
				observationResultList.push(observationResult);
				// update the file object with the result so we can use it for the preview replacement
				tmpFileDetails._ObservationResult = observationResult;
				// join to the document, if we have one
				this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.InstanceConfiguration.IDDocument, async () =>
				{
					// add the new observation to the document list (these are 'included' observations)
					const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
					// add result to our document if we have one and it is not already in the observations list
					if (tmpObservations && Array.isArray(tmpObservations) && tmpObservations.findIndex((o) => o.IDObservation === observationResult.IDObservation) < 0)
					{
						tmpObservations.push(observationResult);
					}
					resolve(observationResult);
				});
			});
		});
		// if we have a callback, run it now
		//FIXME: it seems like we don't need a callback here? we can just return the result?
		if (typeof this.InstanceConfiguration.onAfterCallback == 'function')
		{
			this.log.info('Running onAfterCallback...', this.InstanceConfiguration.onAfterCallback);
			this.FileListToUpload = [];
			await this.InstanceConfiguration.onAfterCallback(observationResultList.map((o) =>
			{
				return { IDObservation: o.IDObservation, Observation: o, FileDetails: tmpFileDetails };
			}));
		}
		else
		{
			const lastObservation = observationResultList[observationResultList.length - 1];
			this.uploadViewFinished(true, lastObservation);
		}
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	/**
	 * This method is used to reset the interim view content back to the initial state.
	 */
	resetIntermViewContent()
	{
		this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value');
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-Content-Interim-ProgressBar', 'is-success');
		this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-Button', 'disabled', '');
		this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', 'File 0 of 0 completed.');
	}

	/**
	 * This method is used to reset the file selection list back to the initial state.
	 * This is useful if the user wants to start over or if they have a file that is too large
	 * and they need to remove it from the list.
	 */
	resetFileSelectionList()
	{
		this.log.info('Resetting file selection list...');
		const tmpFileList = document.getElementById('ObservationCreateMedia-FileList-Input');
		// this may not be set if the user is using the quick capture method
		if (!tmpFileList || !(tmpFileList instanceof HTMLInputElement))
		{
			return;
		}
		// clear out the list on the UI everytime
		tmpFileList.value = '';
		// the re-run the selection flow
		this.handleUpdateSelectionList();
		// swap out the empty panel for the detail panel
		this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel', 'is-hidden');
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-Empty', 'is-hidden');
		// enable the add button again, disable the reset button
		this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-FileList-CreateButton', 'disabled');
		this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-FileList-ResetButton', 'disabled', 'disabled');
		this.updateStepsListActiveState(0);
		this.handleUploadButton();
	}

	/**
	 * This method is used to set the active row in the file selection list and show the details for the file.
	 * @param {String} pFileGUID
	 */
	setFileSelectionRowActive(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);

		if (!tmpFile)
		{
			this.pict.log.warn('File not found for GUID: ', pFileGUID);
			return;
		}

		// swap out the active row
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-FileList-SelectionList .panel-block', [ 'is-active', 'has-background-link-40' ]);
		this.pict.ContentAssignment.addClass(`#ObservationCreateMedia-FileList-SelectionList .panel-block[data-guid="${ pFileGUID }"]`, [ 'is-active', 'has-background-link-40' ]);
		// swap out the empty panel for the detail panel
		this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel', 'is-hidden');
		this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-Empty', 'is-hidden');
		// update the detail panel
		this.render('ObservationCreateMedia-Renderable-SelectionListDetails', ('#ObservationCreateMedia-DetailPanel'), tmpFile);
		// build the tag selection list
		this.lookUpTagsForSelectionList(pFileGUID);

		// if we have an image, show it in the preview
		if (tmpFile && tmpFile.File.type.includes('image'))
		{
			// update the image file preview
			const fileReader = new FileReader();
			const preview = document.querySelector('#ObservationCreateMedia-DetailPanel img');
			fileReader.onload = (event) =>
			{
				const result = event.target.result;
				if (typeof result === 'string')
				{
					preview.setAttribute('src', result);
				}
			};
			fileReader.readAsDataURL(tmpFile.File);
			// this file type is not an image, swap out the image preview for a placeholder
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-Image', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-NoImage', 'is-hidden');
		}
		else if (tmpFile && tmpFile.File.type.includes('pdf'))
		{
			const fileReader = new FileReader();
			const preview = document.querySelector('#ObservationCreateMedia-DetailPanel iframe');
			fileReader.onload = (event) =>
			{
				const result = event.target.result;
				if (typeof result === 'string')
				{
					preview.setAttribute('src', result);
				}
				this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-skeleton');
			};
			fileReader.readAsDataURL(tmpFile.File);
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-Image', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-skeleton');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-NoImage', 'is-hidden');
		}
		// files don't have a preview
		else
		{
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-Image', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-DetailPanel-FilePreview', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-DetailPanel-NoImage', 'is-hidden');
		}
	}

	/**
	 * This can be used by a developer to set the configuration for all instances if they
	 * prefer to set project/customer level defaults in the configuration file this is useful
	 * if you want to set the same configuration for all instances other than the target
	 * project/customer.
	 * @param {Object} pConfiguration
	 */
	setInstanceConfiguration(pConfiguration)
	{
		this.InstanceConfiguration = { ...this.InstanceConfiguration, ...pConfiguration };
	}

	/**
	 * This method is used to update the steps list to show the user where they are in the process.
	 */
	toggleContentViews()
	{
		if (this.pict.ContentAssignment.hasClass('#ObservationCreateMedia-Content-Entry', 'is-hidden'))
		{
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-Content-Entry', 'is-hidden');
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-Content-Interim', 'is-hidden');
		}
		else
		{
			this.pict.ContentAssignment.addClass('#ObservationCreateMedia-Content-Entry', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#ObservationCreateMedia-Content-Interim', 'is-hidden');
		}
	}

	/**
	 * This method is used to update the title of Observation that will be created.
	 * @param {String} pFileGUID
	 */
	updateFileTitle(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);
		tmpFile.Name = this.pict.ContentAssignment.readContent('#ObservationCreateMedia-DetailPanel input');
	}

	/**
	 * This method is used to update the description of the Observation that will be created.
	 * @param {String} pFileGUID
	 */
	updateFileDescription(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);
		tmpFile.Description = this.pict.ContentAssignment.readContent('#ObservationCreateMedia-DetailPanel textarea');
	}

	/**
	 * This method is used to update the tags of the Observation that will be created.
	 * @param {String} pFileGUID
	 */
	updateFileLabels(pFileGUID)
	{
		const tmpFile = this.findFileByGUID(pFileGUID);
		tmpFile.Tags = this.pict.ContentAssignment.readContent('#ObservationCreateMedia-DetailPanel select');
	}

	/**
	 * This method is used to update the interim view content to show the user that the upload is complete.
	 */
	updateIntermViewContent()
	{
		this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value', '100');
		this.pict.ContentAssignment.addClass('#ObservationCreateMedia-Content-Interim-ProgressBar', 'is-success');
		this.pict.ContentAssignment.removeAttribute('#ObservationCreateMedia-Content-Interim-Button', 'disabled');
		this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', 'Upload complete!');
	}

	/**
	 * This method is used to upload the selected files to the server and create the observations. Optional
	 * callback can be passed to run after the upload is complete.
	 */
	async uploadSelectedFiles()
	{
		// update the UI to show the user we are uploading
		this.updateStepsListActiveState(2);
		// switch to the interim content
		this.toggleContentViews();

		this.pict.log.info('Uploading files: ', this.FileListToUpload);

		const observationResultList = [];
		const observationInfoList = [];

		// for each file, upload it and create an observation in a Promise
		const uploadPromises = this.FileListToUpload.map((pFile, i) =>
		{
			return new Promise((resolve, reject) =>
			{
				// update the current file count
				this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', `Uploading File ${ i + 1 } of ${ this.FileListToUpload.length }.`);
				this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value', '0');
				this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(pFile, this.InstanceConfiguration.IDProject,
				(observationResult) =>
				{
					// add the result to the list
					observationResultList.push(observationResult);
					observationInfoList.push({ IDObservation: observationResult.IDObservation, Observation: observationResult, FileDetails: pFile });
					// update the file object with the result so we can use it for the preview replacement
					pFile._ObservationResult = observationResult;
					// join to the document, if we have one
					this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.InstanceConfiguration.IDDocument, async () =>
					{
						// add the new observation to the document list (these are 'included' observations)
						const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
						// add result to our document if we have one (and only if it is not already added to the document)
						if (tmpObservations && Array.isArray(tmpObservations) && !tmpObservations.map((o) => o.IDObservation).includes(observationResult.IDObservation))
						{
							tmpObservations.push(observationResult);
						}
						// if an observation set is active, add the observation to the set too
						if (this.pict.views.ObservationSet.ActiveObservationSet)
						{
							this.pict.views.ObservationSet.addObservationToSet(observationResult.IDObservation);
						}
						// if we have a post-join callback, then run it now
						if (this.InstanceConfiguration.onAfterDocumentJoinCallback && typeof this.InstanceConfiguration.onAfterDocumentJoinCallback === 'function')
						{
							this.InstanceConfiguration.onAfterDocumentJoinCallback(observationResult);
						}
						resolve(observationResult);
					});
				},
				(pctComplete) =>
				{
					// update the progress bar's value
					const tmpValue = pctComplete * 100 + '';
					this.pict.ContentAssignment.setAttribute('#ObservationCreateMedia-Content-Interim-ProgressBar', 'value', tmpValue);
				});
			});
		});
		// wait for all the promises to resolve — use allSettled so one failed
		// upload doesn't prevent the rest from completing or skip cleanup
		const uploadResults = await Promise.allSettled(uploadPromises);
		const failedUploads = uploadResults.filter((r) => r.status === 'rejected');
		if (failedUploads.length > 0)
		{
			this.pict.log.error(`${failedUploads.length} of ${uploadResults.length} file(s) failed to upload:`, failedUploads);
			this.pict.views.HeadlightPanels.toast({
				message: `${failedUploads.length} of ${uploadResults.length} file(s) failed to upload. Check the console for details.`,
				type: 'is-danger',
			});
		}
		this.pict.log.info('All files uploaded: ', observationResultList);
		this.FileListToUpload = [];
		// if we have a callback, run it now
		if (typeof this.InstanceConfiguration.onAfterCallback == 'function')
		{
			//reset the tag list
			this.resetObservationTagList();
			this.log.info('Running onAfterCallback...', this.InstanceConfiguration.onAfterCallback);
			await this.InstanceConfiguration.onAfterCallback(observationInfoList);
		}
		else
		{
			if (typeof this.InstanceConfiguration.onFallbackCallback == 'function')
			{
				this.log.info('Running onFallbackCallback...', this.InstanceConfiguration.onFallbackCallback);
				await this.InstanceConfiguration.onFallbackCallback(observationInfoList);
			}
			// update the UI to say the view is done (it's safe to close now)
			this.updateStepsListActiveState(3);
			this.updateIntermViewContent();
			// for the upload complete message
			const delayInSeconds = 3;
			// finally, let the user know we are done, then close the view for them if they don't
			for (let i = 0; i < delayInSeconds; i++)
			{
				this.pict.ContentAssignment.assignContent('#ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage', `<p class="p-2 is-size-5">Upload complete!<p><p class="p-2 has-text-primary-light">Closing in ${ delayInSeconds - i }...</p>`);
				await new Promise((resolve) => setTimeout(resolve, 1000));
			}
		}
		// clean up the panel upload view and run any cache busting for media section content
		const lastObservation = observationResultList[observationResultList.length - 1];
		this.uploadViewFinished(false, lastObservation);
		// close the observation panel
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
		// clear the observation panel target and the banner on the header
		this.pict.views.HeadlightPaneObservations.clearObservationPanelTarget();
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	/**
	 * This method is used to update the active state of the steps list in the header.
	 * @param {Number} pStepNumber
	 */
	updateStepsListActiveState(pStepNumber)
	{
		const steps = document.querySelectorAll('#ObservationCreateMedia-Steps-List li');
		steps.forEach((step, i) =>
		{
			if (i === pStepNumber)
			{
				step.classList.add('is-active');
			}
			else
			{
				step.classList.remove('is-active');
			}
		});
	}

	/**
	 * Resets the tags list for the observation creation view to ensure that new tags are displayed.
	 */
	resetObservationTagList()
	{
		this.InstanceConfiguration.TagsList = [];
	}

	/**
	 * This method is used to handle the file selection event and update the UI accordingly.
	 * @param {boolean} [pQuickCapture=false] - if the file was captured via the quick capture method
	 * @param {Object} [pLastObservation] - the last observation created, if available
	 * @returns {void}
	 */
	uploadViewFinished(pQuickCapture, pLastObservation)
	{
		this.pict.log.info('Upload view completed!');
		this.resetIntermViewContent();
		this.toggleContentViews();
		this.resetFileSelectionList();
		this.resetObservationTagList();

		this.pict.views.ObservationIncluded.buildIncludedObservationsList(true);
		// if we used quick capture, we don't want to open the observation included panel
		if (!pQuickCapture)
		{
			// switch to the included tab
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
				// toggle open the collapsed Image obersvation group
				// TODO: might want to check the file upload type and open the correct group, but the 99% use case is images
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('Legacy Image');
			});
		}
	}
}

module.exports = ObservationCreateMedia;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationCreateMedia',
	DefaultRenderable: 'ObservationCreateMedia',
	DefaultDestinationAddress: '#ObservationCreateMedia-Container',
	Templates:
	[
		{
			Hash: 'ObservationCreateMedia-Template',
			Template: /*html*/`
			<div id="ObservationCreateMedia">
				<header class="has-background-text-15 p-4">
					<ol id="ObservationCreateMedia-Steps-List" class="steps-list">
						<li class="is-active">Add Files</li>
						<li>Edit Details</li>
						<li>Upload Data</li>
						<li>Complete</li>
					</ol>
				</header>
				<!-- step 1: select files / edit details -->
				<div id="ObservationCreateMedia-Content-Entry" class="p-4">
					<div class="columns is-mobile">
						<div class="column is-one-third-tablet">{~T:ObservationCreateMedia-FileSelection-ListPanel~}</div>
						<div class="column has-text-white">
							<div class="notification has-text-centered p-6 empty-message" id="ObservationCreateMedia-DetailPanel-Empty">
								<span class="icon">
									<i class="fas fa-info-circle" aria-hidden="true"></i>
								</span>
								<span>No file preview available.</span>
							</div>
							<div id="ObservationCreateMedia-DetailPanel" class="is-hidden">
								{~T:ObservationCreateMedia-FileSelection-DetailPanel~}
							</div>
							<footer class="mt-4 buttons is-right">
								<button type="button" title="Upload selected file" id="ObservationCreateMedia-FileList-UploadButton" disabled class="button is-primary" onclick="_Pict.views.ObservationCreateMedia.uploadSelectedFiles()">
									<span class="icon"><i class="fas fa-fw fa-upload"></i></span>
									<span>Upload Files</span>
								</button>
							</footer>
						</div>
					</div>
				</div>
				<!-- step 2: upload files / results -->
				<div id="ObservationCreateMedia-Content-Interim" class="is-hidden p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<p class="title is-6 has-text-centered mb-3 has-text-white" id="ObservationCreateMedia-Content-Interim-CurrentUploadCountMessage">File 0 of 0 completed.</p>
							<progress id="ObservationCreateMedia-Content-Interim-ProgressBar" class="progress is-primary" max="100"></progress>
							<div class="is-size-7 has-text-centered">This may take a few minutes depending on the size of the files and your internet connection.</div>
							<div class="is-size-7 has-text-centered">Please do not close this window until the upload is complete.</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationCreateMedia-FileSelection-ListRow',
			Template: /*html*/`
			<a class="panel-block has-background-text-20 mt-1" data-guid="{~D:Record.GUID~}" onclick="_Pict.views.ObservationCreateMedia.setFileSelectionRowActive('{~D:Record.GUID~}')">
				<span class="panel-icon">
					<i class="fas fa-fw {~D:Record.FileTypeIcon~}"></i>
				</span>
				<span class="is-clipped">{~D:Record.FileName~}</span>
			</a>`,
		},
		{
			Hash: 'ObservationCreateMedia-FileSelection-ListPanel',
			Template: /*html*/`
			<div id="ObservationCreateMedia-FileList-Limitations">
				<div class="column notification is-dark is-text mb-3">
					<p class="is-size-7"><strong>Upload Limitations:</strong></p>
					<p class="is-size-7">File Count: <span class="has-text-text-90">{~D:Context[0].InstanceConfiguration.FileNumberLimit~}</span></p>
					<p class="is-size-7">Individual File Size: <span class="has-text-text-90">{~ToGigaBytes:Context[0].InstanceConfiguration.FileSizeLimit~} GB</span></p>
					<p class="is-size-7 mt-2"><i class="fa fa-fw fa-info-circle"></i> You can hold "Shift" or "Control" to select multiple files.</p>
				</div>
			</div>
			<div id="ObservationCreateMedia-FileList-ErrorMessage"><!-- error message - reserved space --></div>
			<article class="is-primary">
				<p class="tag is-dark is-rounded is-pulled-right mt-3 mr-3" id="FilesToUploadCount">0</p>
				<p class="panel-heading is-size-6 has-background-text-15">Files to upload</p>
				<div class="overflow-list-container" id="ObservationCreateMedia-FileList-SelectionList" style="max-height: 50vh; overflow-y: auto;"></div>
				<div class="notification has-text-centered empty-message" style="border-top-left-radius: 0; border-top-right-radius: 0;" id="ObservationCreateMedia-FileList-EmptyRow">
					<p class="is-size-7 mt-3 mb-5">No files selected.</p>
					<label class="button p-0 is-primary is-fullwidth" 
					id="ObservationCreateMedia-FileList-CreateButton">
						<input 
							class="file-input" 
							type="file"
							id="ObservationCreateMedia-FileList-Input"
							name="file-list-to-upload"
							multiple
							onclick="_Pict.views.ObservationCreateMedia.checkIfLocked(event)"
							onchange="_Pict.views.ObservationCreateMedia.handleUpdateSelectionList()"
							/>
						<span class="file-cta" style="border:none">
							<span class="file-icon">
								<i class="fas fa-plus-circle"></i>
							</span>
							<span class="file-label is-hidden-mobile is-hidden-tablet-only"> Select files</span>
							<span class="file-label is-hidden-desktop"> Add</span>
						</span>
					</label>
				</div>
			</article>
			<div class="buttons is-right">
				<button 
					class="button is-primary is-dark mt-2" 
					id="ObservationCreateMedia-FileList-ResetButton"
					disabled 
					type="buton" 
					onclick="_Pict.views.ObservationCreateMedia.resetFileSelectionList()"
					>
					<span class="icon"><i class="fas fa-fw fa-undo"></i></span>
					<span>Reset list</span>
				</button>
			</div>`,
		},
		{
			Hash: 'ObservationCreateMedia-FileSelection-DetailPanel',
			Template: /*html*/`
			<div class="notification has-text-centered p-6 empty-message" id="ObservationCreateMedia-DetailPanel-NoImage">
				<span class="icon">
					<i class="fas fa-question-circle" aria-hidden="true"></i>
				</span>
				<span>No preview available for this file type.</span>
			</div>
			<figure class="image mb-4 is-hidden" id="ObservationCreateMedia-DetailPanel-FilePreview">
				<iframe class="preview-image has-background-text-15" style="width: 100%; height: 25vh; max-height: 350px; object-fit: contain;"></iframe>
			</figure>
			<figure class="image mb-4 is-hidden" id="ObservationCreateMedia-DetailPanel-Image">
				<img class="preview-image has-background-text-15" style="max-width: 100%; height: 25vh; max-height: 350px; object-fit: contain;">
			</figure>
			<div class="field">
				<label class="label">Title</label>
				<div class="control">
					<input 
						class="input" 
						type="text" 
						placeholder="Title" 
						value="{~D:Record.Name~}"
						onchange="_Pict.views.ObservationCreateMedia.updateFileTitle('{~D:Record.GUID~}')"
						>
				</div>
			</div>
			<div class="field">
				<label class="label">Description</label>
				<div class="control">
					<textarea onchange="_Pict.views.ObservationCreateMedia.updateFileDescription('{~D:Record.GUID~}')"
						class="textarea shrunken-textarea" 
						style="min-height: 5em;"
						placeholder="Description">{~D:Record.Description~}</textarea>
				</div>
			</div>
			<div class="field">
				<label class="label">Tags</label>
				<div class="control">
					<div class="select is-fullwidth">
						<select 
							class="is-skeleton"
							multiple
							id="ObservationCreateMedia-FileList-LabelSelect"
							onchange="_Pict.views.ObservationCreateMedia.updateFileLabels('{~D:Record.GUID~}')">
							<option value="" selected>Select a tag</option>
						</select>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationCreateMedia',
			TemplateHash: 'ObservationCreateMedia-Template',
			DestinationAddress: '#ObservationCreateMedia-Container',
		},
		{
			RenderableHash: 'ObservationCreateMedia-Renderable-SelectionListRow',
			TemplateHash: 'ObservationCreateMedia-FileSelection-ListRow',
			RenderMethod: 'append',
		},
		{
			RenderableHash: 'ObservationCreateMedia-Renderable-SelectionListDetails',
			TemplateHash: 'ObservationCreateMedia-FileSelection-DetailPanel',
			RenderMethod: 'replace',
		},
	],
};

},{"pict-view":733}],1561:[function(require,module,exports){
const PictViewClass = require('pict-view');
const libPictSectionPDFJS = require('pict-section-pdfjs');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationDetailsBackTo = null;
		this.ObservationDetailsBackToSet = false;

		// if the observation type is a PDF, use an embed tag, otherwise use an img tag
		this.pict.MetaTemplate.addPattern('{~PreviewImage:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isPDF = tmpValue?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
			const isVideo = tmpValue?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video';
			const isAudio = tmpValue?.Details?.Audio?.[0]?.ArtifactType?.toLowerCase() === 'audio';
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			let tmpIDArtifact;
			let tmpVersion;
			// show a PDF viewer if the observation is a PDF file type
			if (isPDF)
			{
				tmpIDArtifact = tmpValue?.Details?.File?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.File?.[0]?.Version;
				const template = /*html*/`
				<div class="has-background-text-40" id="PDFJS-Container-Div" style="width: 100%; height: 500px; max-height: 500px; overflow: hidden;"></div>
				<div class="image-floated-button buttons" style="box-shadow: none;">
					<button type="button" style="box-shadow: var(--panels-button-shadow);" title="Add Markup Observation" class="button is-warning is-rounded mr-2" onclick="_Pict.views.ObservationDetails.handlePDFNotesButtonClick(event)">
						<span class="icon">
							<i class="fa fa-fw fa-sticky-note"></i>
						</span>
						<span>Add Markup Observation</span>
					</button>
				</div>`;
				return template;
			}
			// show a video player if the observation is a video file type
			else if (isVideo)
			{
				tmpIDArtifact = tmpValue?.Details?.Video?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Video?.[0]?.Version;
				return `<video autoplay muted class="has-background-text-40" style="width: 500px; height: auto" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="video/mp4"></video>`;
			}
			// show an audio player if the observation is an audio file type
			else if (isAudio)
			{
				tmpIDArtifact = tmpValue?.Details?.Audio?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Audio?.[0]?.Version;
				return `<audio class="has-background-text-40" style="width: 500px; height: 75px; padding: 10px" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="audio/mp3"></audio>`;
			}
			else if (isImage)
			{
				// if the observation is locked, don't show the annotate button
				if (this.pict.AppData.DocumentData?.ReportData?.Locked)
				{
					return '';
				}
				const template =
				`<img class="has-background-text-40 detail-image" src="/1.0/Observation/${tmpValue.IDObservation}/Image/Preview?t=${ new Date().getTime() }" alt="Observation Preview" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />
				<button type="button" title="Annotate observation" class="button is-warning is-rounded image-floated-button" onclick="_Pict.views.ObservationDetails.handleAnnotationButtonClick(event)">
					<span class="icon">
						<i class="fa fa-fw fa-pen"></i>
					</span>
					<span>Annotate</span>
				</button>`;
				return template;
			}
			else
			{
				return `<img class="has-background-text-40 detail-image" src="/1.0/Observation/${tmpValue.IDObservation}/Image/Preview?t=${ new Date().getTime() }" alt="Observation Preview" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />`;
			}
		});

		// if the observation is a PDF or an image, show the skeleton loading class (audio/video tags don't have a skeleton)
		this.pict.MetaTemplate.addPattern('{~UseSkeltonLoading:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			return isImage ? 'is-skeleton' : '';
		});

		// TODO: since we no longer have full-screen mode, should we remove this pattern?
		// if the observation type is a PDF, use an embed tag, otherwise use an img tag
		this.pict.MetaTemplate.addPattern('{~FullImage:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isPDF = tmpValue?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
			const isVideo = tmpValue?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video';
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			let tmpIDArtifact; let tmpVersion;
			// show a PDF viewer if the observation is a PDF file type
			if (isPDF)
			{
				tmpIDArtifact = tmpValue?.Details?.File?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.File?.[0]?.Version;
				return `<embed class="has-background-text-40 full-size-pdf-with-offsets" src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />`;
			}
			// show a video player if the observation is a video file type
			else if (isVideo)
			{
				tmpIDArtifact = tmpValue?.Details?.Video?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Video?.[0]?.Version;
				return `<video autoplay class="has-background-text-40 full-size-video-with-offsets" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="video/mp4"></video>`;
			}
			// show a full size image if the observation is an image file type
			else if (isImage)
			{
				tmpIDArtifact = tmpValue?.Details?.Image?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Image?.[0]?.Version;
				return `<img class="has-background-text-40 full-size-image-with-offsets" src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }" alt="Observation Fullsize" />`;
			}
			// audio doesn't have a full size view, nothing else should be shown
			else
			{
				return `<div class="notification has-text-centered m-3"><span class="icon"><i class="fa fa-fw fa-exclamation-triangle"></i></span><span>No full size available.</span></div>`;
			}
		});

		// if the observation has a map location, show it, otherwise show an image message
		this.pict.MetaTemplate.addPattern('{~ShowMiniMap:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hasValidCaptureGeoLocation = false;
			let hasValidUserGeoLocation = false;
			// check if the observation has a valid capture or user geolocation
			if (tmpValue?.CaptureLatitude && tmpValue?.CaptureLongitude)
			{
				hasValidCaptureGeoLocation = this.pict.providers.UtilityProvider.isValidLatitude(tmpValue?.CaptureLatitude) && this.pict.providers.UtilityProvider.isValidLongitude(tmpValue?.CaptureLongitude) && (Number(tmpValue?.CaptureLatitude) !== 0 && Number(tmpValue?.CaptureLongitude) !== 0);
			}
			if (tmpValue?.UserLatitude && tmpValue?.UserLongitude)
			{
				hasValidUserGeoLocation = this.pict.providers.UtilityProvider.isValidLatitude(tmpValue?.UserLatitude) && this.pict.providers.UtilityProvider.isValidLongitude(tmpValue?.UserLongitude) && (Number(tmpValue?.UserLatitude) !== 0 && Number(tmpValue?.UserLongitude) !== 0);
			}
			return hasValidCaptureGeoLocation || hasValidUserGeoLocation ? `/1.0/Observation/Map/For/${tmpValue.IDObservation}` : `null`;
		});

		// If the observation has edit capability, show the edit button
		this.pict.MetaTemplate.addPattern('{~CanEdit:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			this.pict.log.info('ObservationDetails:CanEdit:', tmpValue);
			// if the observation is locked, hide the edit button
			if (this.pict.AppData.DocumentData?.ReportData?.Locked)
			{
				return '';
			}
			// if the user does not have CanEdit ability, hide the edit button
			if (!this.pict.AppData.DocumentData?.ReportData?.CanEdit)
			{
				return '';
			}
			if (tmpValue?.Locked)
			{
				return '';
			}
			const template =
					`<button id="ObservationDetails-Content-Edit-Button" type="button" title="Edit Observation Details" class="button is-primary" onclick="_Pict.views.ObservationDetails.observationDetailsEditHandler(event)">
						<span class="icon">
							<i id="ObservationDetails-Content-Edit-Icon" class="fa fa-fw fa-pencil"></i>
						</span>
						<span>Edit Details</span>
					</button>
					<button id="ObservationDetails-Content-Save-Button" type="button" title="Save Observation Details" class="button is-success is-hidden" onclick="_Pict.views.ObservationDetails.observationDetailsSaveHandler(event)">
						<span class="icon">
							<i id="ObservationDetails-Content-Save-Icon" class="fa fa-fw fa-save"></i>
						</span>
						<span>Save Details</span>
					</button>`;
			return template;
		});
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetObservationDetailsView()
	{
		if (this.pict?.views?.ObservationSubImageSelector?.intent)
		{
			this.pict.views.ObservationSubImageSelector.intent =
			{
				type: 'Document',
			};
		}
		this.ActiveObservationDetails = {};
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const isPDF = this.ActiveObservationDetails?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
		if (isPDF)
		{
			const tmpIDArtifact = this.ActiveObservationDetails?.Details?.File?.[0]?.IDArtifact;
			const tmpVersion = this.ActiveObservationDetails?.Details?.File?.[0]?.Version;
			if (!this.pict.views?.PDFViewer)
			{
				this.pict.addView('PDFViewer', Object.assign(libPictSectionPDFJS.default_configuration, { pdfUrl: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}` }), libPictSectionPDFJS);
			}
			if (this.pict.views?.PDFViewer)
			{
				this.pict.views.PDFViewer.options.pdfUrl = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
				this.pict.views.PDFViewer.render();
			}
		}
		this.fillObservationText();
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Put the observation's name and description into the read-only text and the edit boxes as text, not through the
	 * template, so markup typed into either shows as typed.
	 */
	fillObservationText()
	{
		const tmpName = this.ActiveObservationDetails?.Name || '';
		const tmpDescription = this.ActiveObservationDetails?.Description || '';
		const tmpTargets = [
			[ 'ObservationDetails-Content-Title-Readonly', 'textContent', tmpName ],
			[ 'ObservationDetails-Content-Title-Input', 'value', tmpName ],
			[ 'ObservationDetails-Content-Description-Readonly', 'textContent', tmpDescription ],
			[ 'ObservationDetails-Content-Description-Input', 'value', tmpDescription ],
		];
		for (const [ tmpID, tmpProperty, tmpValue ] of tmpTargets)
		{
			const tmpElement = document.getElementById(tmpID);
			if (tmpElement)
			{
				tmpElement[tmpProperty] = tmpValue;
			}
		}
	}

	resetObservationTargetPanel()
	{
		if (this.ObservationDetailsBackToSet)
		{
			const observationSetName = document.getElementById('HeadlightPanels-ObservationSet-Title-Wrapper').innerText;
			document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', 'add-to-set');
			document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = observationSetName;
			this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-set';
			this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-set';
			this.pict.views.ObservationSearch.setMode('add-to-set');
		}
	}
	/**
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		// TODO: probably should update this to use data state to track pinned open panels
		if (event && event.target instanceof HTMLElement && event.target.closest('.hl-panel-wrapper').classList.contains('pinned-open'))
		{
			this.log.info('Panel is pinned open, not going back to Observation List view');
			return;
		}
		const tempGroupKey = this.ActiveObservationDetails.ObservationType;
		this.resetObservationDetailsView();
		// go back to the search view if the user came from there
		if (this.ObservationDetailsBackTo === 'Search')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				this.pict.views.ObservationSearch.updateWithSearchResults(this.pict.views.ObservationSearch.CurrentSearchResults, this.pict.views.ObservationSearch.CurrentSearchResults.length);
			});
		}
		else if (this.ObservationDetailsBackTo === 'Included')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(tempGroupKey, 'open');
			});
		}
		else if (this.ObservationDetailsBackTo === 'ProjectFileSearch')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.log.info('Returning to Project Files Search view');
			});
		}
		else
		{
			// close all panels and reset the Observation Details view (same as clicking the close button)
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationDetails.resetObservationDetailsView();
		}
	}

	/**
	 *
	 * @return {number | undefined} the current page being viewed on the PDFViewer
	 */
	getCurrentPage()
	{
		const pageChoice = this.pict.views.PDFViewer.getCurrentPage();
		if (pageChoice && !isNaN(pageChoice))
		{
			return Number(pageChoice);
		}
		return undefined;
	}

	observationDetailsEditHandler(event)
	{
		if (!this.pict.AppData.DocumentData.ReportData.Observations)
		{
			this.log.error(`No Observations; can't update observation details for observation: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Observations; can't update observation details for observation: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			// if editable containers exist
			if (document.getElementById('ObservationDetail-Content-Title-Container') && document.getElementById('ObservationDetail-Content-Description-Container'))
			{
				// swap readonlies for inputs
				document.getElementById('ObservationDetails-Content-Title-Readonly').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Title-Edit').classList.remove('is-hidden');
				document.getElementById('ObservationDetails-Content-Description-Readonly').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Description-Edit').classList.remove('is-hidden');
			}
			// if edit button exists
			if (document.getElementById('ObservationDetails-Content-Edit-Button'))
			{
				// change edit aesthetics to save aesthetics
				document.getElementById('ObservationDetails-Content-Edit-Button').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Save-Button').classList.remove('is-hidden');
			}
		}
	}

	async observationDetailsSaveHandler(event)
	{
		if (event)
		{
			event.currentTarget.classList.add('is-loading');
		}
		const tmpObservationDetails = {};
		// TODO: fix this to be "correct" and not use ts-ignore
		/** @ts-ignore */
		const tmpName = document.getElementById('ObservationDetails-Content-Title-Input').value;
		/** @ts-ignore */
		const tmpDescription = document.getElementById('ObservationDetails-Content-Description-Input').value;
		tmpObservationDetails.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		tmpObservationDetails.IDObservation = this.ActiveObservationDetails.IDObservation;
		tmpObservationDetails.Name = tmpName || tmpObservationDetails.Name;
		tmpObservationDetails.Description = tmpDescription || '';
		// TODO: Future enhancement - list documents that contain observation being changed and alert user the title and/or description will change for all
		await this.pict.providers.ObservationProvider.updateObservation(tmpObservationDetails, (observationResult) =>
		{
			this.ActiveObservationDetails = observationResult;
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
		this.renderAsync(()=>
		{
			this.pict.log.info('Observation Details Updated');
		});
	}

	handlePDFNotesButtonClick(event)
	{
		if (event && event.currentTarget)
		{
			event.currentTarget.classList.add('is-loading');
		}
		this.log.info('PDF Notes button clicked');
		this.pict.views.ObservationSubImageSelector.resetObservationSubImageSelectorView(true, true, this.getCurrentPage());
		this.pict.views.ObservationSubImageSelector.ActiveObservationDetails = this.ActiveObservationDetails;
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationSubImageSelector', 'open');

		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	handleAnnotationButtonClick(event)
	{
		if (event && event.currentTarget)
		{
			event.currentTarget.classList.add('is-loading');
		}
		this.log.info('Annotation button clicked');
		this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
		this.pict.views.ObservationAnnotation.ActiveObservationDetails = this.ActiveObservationDetails;
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationAnnotation', 'open');

		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	toggleWidth()
	{
		const toggleEl = this.pict.ContentAssignment.getElement('#split-toggle-icon')?.[0];
		const animate = (el)=>
		{
			el.classList.add('fa-flip');
			setTimeout(()=>
			{
				el.classList.remove('fa-flip');
			}, 500);
		};
		if (toggleEl?.classList?.contains('fa-flip-horizontal'))
		{
			animate(toggleEl);
			toggleEl.classList.remove('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(40);
		}
		else
		{
			animate(toggleEl);
			toggleEl.classList.add('fa-flip-horizontal');
			// 50 has the right panel flush with the left panel. Any more and it covers the left panel.
			this.pict.HeadlightPanels.rightPanelCustomWidth(50);
		}
	}
}

module.exports = ObservationDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationDetails',
	DefaultRenderable: 'ObservationDetails',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'ObservationDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationDetailsPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
				<p id="HeadlightPanels-ObservationDetailsPanel-Observation-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.ObservationDetails.resetObservationDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					{~TIfAbs:ObservationDetails-BackButton:Record:Pict.views.ObservationDetails.ObservationDetailsBackTo^===^ProjectFileSearch~}
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('Right')">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right mr-2" aria-label="expand" title="Resize observation" onclick="_Pict.views.ObservationDetails.toggleWidth()">
						<span class="icon">
							<i class="fas fa-fw fa-table-layout fa-flip-horizontal" aria-hidden="true" id="split-toggle-icon"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationDetailsPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationDetailsPanel-Observation-Header-Title" class="mr-3">Observation Details</span>
				</p>
				<div id="HeadlightPanels-ObservationDetails-Content" class="nested-scroll-content has-bottom-navbar-offset">
					{~T:ObservationDetails-Content:Pict.views.ObservationDetails.ActiveObservationDetails~}
				</div>
			</article>`,
		},
		{
			Hash: 'ObservationDetails-BackButton',
			Template: /*html*/`
				<button type="button" class="is-pulled-right hl-panel-close-button mr-2 {~Show:Pict.views.ObservationDetails.ObservationDetailsBackTo~}" aria-label="back" title="Back to Project Files" onclick="_Pict.views.ObservationDetails.returnToPreviousLocation(event)">
					<span class="icon">
						<i class="fas fa-fw fa-chevron-circle-left" aria-hidden="true"></i>
					</span>
				</button>
			`,
		},
		{
			Hash: 'ObservationDetails-Content',
			Template: /*html*/`
			<div class="container panel-content nested-scroll-content has-bottom-navbar-offset" style="width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<figure class="image detail-image-wrapper {~UseSkeltonLoading:Record~}">
					{~PreviewImage:Record~}
				</figure>
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-20">
					{~T:ObservationDetails-Content-Title:Record~}
				</div>
				<div class="columns m-0 p-0 mb-4">
					<div class="column is-6 px-5">
						<span class="title is-block is-6 has-text-text-60">Observation Type</span>
						<span class="subtitle is-6 has-text-text-90">{~ObsTypeDisplay:Record.ObservationType~}</span>
					</div>
					<div class="column p-0">
						{~T:ObservationDetails-Content-Map:Record~}
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^ObservationDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Designated Time</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DesignatedTime^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				{~T:ObservationDetails-Content-Description:Record~}
				<div class="columns px-5">
					<div class="column has-text-right">
						{~CanEdit:Record~}
					</div>
				</div>
				<div class="columns is-multiline px-5">
					{~TS:ObservationDetails-Content-TagType:Pict.providers.ObservationProvider.getObservationTagTypes(Context[0].ActiveObservationDetails)~}
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-TagType',
			Template: /*html*/`
			<div class="column">
				<span class="label has-text-text-65">{~D:Record.TagType~}</span>
				<div class="tags tag-list">
					{~TS:ObservationDetails-Content-Tag:Pict.providers.ObservationProvider.getObservationTags(Pict.views.ObservationDetails.ActiveObservationDetails,Record.TagType)~}
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Title',
			Template: /*html*/`
			<div id="ObservationDetail-Content-Title-Container" class="column">
				<p id="ObservationDetails-Content-Title-Readonly" class="title is-4 has-text-white mb-2"></p>
				<p id="ObservationDetails-Content-Title-Edit" class="control is-fullwidth is-relative is-hidden">
					<input 
						id="ObservationDetails-Content-Title-Input"
						class="input has-background-text-30"
					/>
				</p>
				<p class="subtitle is-6 has-text-text-65">
					<span class="is-pulled-right">
						{~TIfAbs:ObservationDetails-Locked:Record.Locked:Record.Locked^==^1~}
						{~TIfAbs:ObservationDetails-Unlocked:Record.Locked:Record.Locked^==^0~}
					</span>
					<span class="mr-1">#{~D:Record.IDObservation~}</span>
				</p>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Description',
			Template: /*html*/`
			<div id="ObservationDetail-Content-Description-Container" class="columns px-5">
				<div class="column">
					<p class="title is-6 has-text-text-65 mb-1">Description</p>
					<div id="ObservationDetails-Content-Description-Readonly" class="is-6 has-text-text-90"></div>
					<p id="ObservationDetails-Content-Description-Edit" class="control is-fullwidth is-relative is-hidden">
						<textarea 
							id="ObservationDetails-Content-Description-Input"
							class="textarea has-background-text-30"
							rows="2"
						></textarea>
					</p>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Map',
			Template: /*html*/`
			<figure class="image">
				<img onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~ShowMiniMap:Record~}" />
			</figure>`,
		},
		{
			Hash: 'ObservationDetails-Content-Tag',
			Template: /*html*/`<span class="tag {~LabelClass:Record~}">{~D:Record.Tag~}</span>`,
		},
		{
			Hash: 'ObservationDetails-Content-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'ObservationDetails-Locked',
			Template: /*html*/`
				<span class="icon has-text-text-95">
					<i class="fas fa-fw fa-sm fa-lock"></i>
				</span>
				<span class="icon-text has-text-text-95">Locked</span>`,
		},
		{
			Hash: 'ObservationDetails-Unlocked',
			Template: /*html*/`
				<span class="icon">
					<i class="fas fa-fw fa-sm fa-unlock"></i>
				</span>
				<span class="icon-text">Unlocked</span>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationDetails',
			TemplateHash: 'ObservationDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationDetails-Content',
			TemplateHash: 'ObservationDetails-Content',
			DestinationAddress: '#HeadlightPanels-ObservationDetails-Content',
			RenderType: 'replace',
		},
	],
};

},{"pict-section-pdfjs":709,"pict-view":733}],1562:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationIncluded extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		// set the default data for the included observations
		this.IncludedObservationsGroupedByType = {};
	}

	/**
	 * Build (or rebuild) the included observations list
	 * @param {Boolean} rerender - Whether or not to re-render the panel after building the list
	 * @return {void}
	 */
	buildIncludedObservationsList(rerender = false)
	{
		// group the current observations by type, then re-render the panel
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		this.IncludedObservationsGroupedByType = this.pict.providers.ObservationProvider.groupObservationsByType(tmpObservations);
		if (rerender)
		{
			this.pict.views.HeadlightPanels.renderAsync('HeadlightPanels-ObservationPanel-Included', null, null, null, () =>
			{
				this.log.info('Included observations list rendered.');
			});
		}
	}

	/**
	 * This function is used to handle the removal of an observation from a document.
	 * @param {Event} pEvent - The event for removing an observation from a document.
	 * @param {string} pIDObservation - The observation id to remove from the document
	 * @param {string} pGroupKey - The group key to re-open the collapsible panel
	 * @return {Promise<void>}
	 * @async
	 */
	async handleRemoveIncludedObservation(pEvent, pIDObservation, pGroupKey)
	{
		// prevent onclick event attached to table row that opens detail panel when clicking remove observation
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return;
		}
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations?.filter((observation) => observation.IDObservation != pIDObservation);
		}
		await this.pict.providers.DocumentProvider.handleSave(true);
		// rebuild the included observations list
		this.buildIncludedObservationsList(true);
		// re-open the collapsible panel group if still has items
		if (pGroupKey)
		{
			this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(pGroupKey);
		}
		// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the removed observation
		if (this.pict.providers.ObservationCardDeckProvider)
		{
			await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'remove', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
		}
	}
}

module.exports = ObservationIncluded;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationIncluded',
	DefaultRenderable: 'ObservationIncluded',
	DefaultDestinationAddress: '#ObservationIncluded-Container',
	Templates:
		[
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included',
				Template: /*html*/`
				<!-- Observation Panel Content > Included View > Empty Message or Observation List (depending on list length) -->
				{~TIfAbs:HeadlightPanels-ObservationPanel-Included-EmptyMessage:AppData:AppData.DocumentData.ReportData.Observations.length^==^0~}
				{~TIfAbs:HeadlightPanels-ObservationPanel-Included-List:AppData:AppData.DocumentData.ReportData.Observations.length^>^0~}`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-EmptyMessage',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationPanel-Included-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="has-text-centered">No observations are included in this document.</p>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List',
				Template: /*html*/`
				<!-- Observation Panel Content > Included View > List -->
				<div id="HeadlightPanels-ObservationPanel-Included-List" class="nested-scroll-content panel-views-height-offset has-preivew-images">
					{~TS:HeadlightPanels-ObservationPanel-Included-List-Group:Pict.views.ObservationIncluded.IncludedObservationsGroupedByType~}
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group',
				Template: /*html*/`
				<div class="panel-block is-collapsible-header pr-6 is-relative" data-collapsible-toggle="{~D:Record.ObservationType~}" onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('{~D:Record.ObservationType~}')">
					<span class="panel-icon panel-block-toggle-icon">
						<i class="fa fa-fw fa-chevron-right"></i>
					</span>
					<span class="panel-icon panel-block-type-icon">
						<i class="fa fa-fw {~D:Record.ObservationTypeDetails.Icon~}"></i>
					</span>
					<span class="has-text-weight-semibold">{~D:Record.ObservationTypeDetails.Type~}</span>
					<span class="tag is-dark has-background-text-15 is-rounded" style="position: absolute; right: 1rem;">{~D:Record.ObservationList.length~}</span>
				</div>
				<div class="is-collapsible-content is-hidden" data-collapsible-content="{~D:Record.ObservationType~}">
					{~TS:HeadlightPanels-ObservationPanel-Included-List-Group-Item:Record.ObservationList~}
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item',
				Template: /*html*/`
				<div id="ObservationPanel-Row" class="panel-block is-block-flex is-align-items-left is-relative p-2 is-clickable" 
					onclick="_Pict.views.HeadlightPaneObservations.handleObservationImagePreviewClick(event, '{~D:Record.IDObservation~}', 'Included')" data-observation-id="{~D:Record.IDObservation~}">
					<a class="preview-image-wrapper" >
						<img class="preview-image" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" alt="Observation Preview for #{~D:Record.IDObservation~}" />
					</a>
					<div class="is-block-flex is-align-items-left mx-4" style="flex-grow: 1">
						<div class="is-size-7 has-text-text-75">
							{~TIfAbs:HeadlightPanels-ObservationPanel-Included-List-Group-Item-Locked:Record.Locked:Record.Locked^==^1~}
							{~TIfAbs:HeadlightPanels-ObservationPanel-Included-List-Group-Item-Unlocked:Record.Locked:Record.Locked^==^0~}
							<span>#{~D:Record.IDObservation~}</span>
						</div>
						<div>{~D:Record.Name~}</div>
						<div class="is-size-7 has-text-text-75">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</div>
						<div class="is-size-7 has-text-text-75"><i class="fa fa-fw fa-user"></i> {~Entity:User^Record.CreatingIDUser^HeadlightPanels-ObservationPanel-Included-List-Group-Item-User^~}</div>
					</div>
					<!-- TODO: convert this to a popover -->
					<div class="buttons mr-4" style="max-width: 100px;">
						<button type="button" data-panel-mode-show-if="add-to-set" title="Add observation to set" data-observation-id="{~D:Record.IDObservation~}" class="button is-ghost-icon has-text-success-75 p-0 mr-2"
							onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-set')">
							<span class="icon">
								<i class="fa fa-fw fa-circle-plus"></i>
							</span>
							<span class="add-to-set-link">Add to Set</span>
						</button>
						<button type="button" title="Remove observation from document" class="button is-ghost-icon has-text-text-85 p-0 mr-2" onclick="_Pict.views.ObservationIncluded.handleRemoveIncludedObservation(event, '{~D:Record.IDObservation~}', '{~D:Record.ObservationType~}')">
							<span class="icon">
								<i class="fa fa-fw fa-times-circle"></i>
							</span>
							<span data-panel-mode-show-if="add-to-set" style="white-space: normal;">Remove from Document</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-BannerTarget',
				Template: /*html*/`{~D:Pict.views.HeadlightPaneObservations.AddImageTargetDisplayName~}`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item-Locked',
				Template: /*html*/`
					<span class=" has-text-text-75" title="Locked">
						<i class="fas fa-fw fa-sm fa-lock"></i>
					</span>`,
			},
			{
				Hash: 'HeadlightPanels-ObservationPanel-Included-List-Group-Item-Unlocked',
				Template: /*html*/`
					<span class="has-text-text-40" title="Unlocked">
						<i class="fas fa-fw fa-sm fa-unlock"></i>
					</span>`,
			},
		],
	Renderables:
		[

		],
};

},{"pict-view":733}],1563:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialSearchResultsLoaded = false;

		this.DefaultSearchFilters = {
			Projects: [],
			ObservationTypes: [],
			StartDate: '',
			EndDate: '',
			SearchText: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'DesignatedTime',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		this.selectedObservation = {};
		this.ObservationTypeManifest = [];
		this.SearchPanelMode = '';
		this.setSelected = false;

		// TODO: We should hide any columns that have exactly one search filter criteria, as they are redundant
		// ex: if you search for "Legacy Image" only, don't show the ObservationType column, bc all results will be "Legacy Image"
	}

	async onBeforeRenderAsync(pCallback)
	{
		if (typeof pCallback == 'function')
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'ObservationSearch-Projects',
			ParentID: 'ObservationSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			width: 'element',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject, // && !this.initialSearchResultsLoaded, // NOTE: was causing weird bug: when re-opening panel the project dropdown filter was losing its value.
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// OBSERVATION TYPE Selector Filter
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark has-sticky-option',
			placeholder: 'Select an observation types...',
			ElementID: 'ObservationSearch-ObservationTypes',
			ParentID: 'ObservationSearch-SearchEntry',
			URL: 'ObservationManifests',
			IDField: 'Name',
			TextField: 'DisplayName',
			StickyOption: { id: 'Legacy Image', text: 'Image' },
		}, () =>
		{
			this.log.info('Select2 ObservationTypes initialized');
		});

		// START DATE date picker
		window.flatpickr('#ObservationSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'ObservationSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				/** @type {any} silence warnings about _flatpickr not being present */
				const siblingElement = document.getElementById('ObservationSearch-EndDate');
				siblingElement._flatpickr.config.minDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#ObservationSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'ObservationSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				/** @type {any} silence warnings about _flatpickr not being present */
				const siblingElement = document.getElementById('ObservationSearch-StartDate');
				siblingElement._flatpickr.config.maxDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		this.setCurrentSearchFilters();
		// if we don't have search results, perform a search
		if (!this.initialSearchResultsLoaded)
		{
			this.initialSearchResultsLoaded = true;
			this.handleObservationSearch();
		}

		if (pCallback) pCallback();
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Event} [event] - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleObservationSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#ObservationSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('ObservationSearch-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters', 'close');
		// perform the observation search
		await this.pict.providers.ObservationProvider.performObservationSearch(this.CurrentSearchFilters, (pSearchResults, pTotalSearchCount) =>
		{
			this.updateWithSearchResults(pSearchResults, pTotalSearchCount);
		});
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.ObservationSearch.handleObservationSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.ObservationSearch.handleObservationSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], ObservationTypes: ['Legacy Narrative'], SearchText: 'dog'})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('ObservationSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#ObservationSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-ObservationTypes', this.CurrentSearchFilters?.ObservationTypes);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-SearchText', this.CurrentSearchFilters?.SearchText || '');
			this.pict.ContentAssignment.assignContent('#ObservationSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.ObservationTypes && my.ObservationTypes.length > 0)
		{
			this.CurrentSearchFiltersCount += my.ObservationTypes.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setObservationSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setObservationSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.observationSearchResultsCallback = pCallback;
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Project');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#ObservationSearch-Projects');
			break;
		case 'ObservationType':
		case 'ObservationTypes':
			this.CurrentSearchFilters.ObservationTypes = this.pict.ContentAssignment.readContent('#ObservationSearch-ObservationTypes');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#ObservationSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#ObservationSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#ObservationSearch-SearchText');
			break;
		case 'SortBy':
			const tmpSortBy = this.pict.ContentAssignment.readContent('#ObservationSearch-SortBy');
			this.CurrentSearchFilters.SortBy = typeof tmpSortBy == 'string' ? tmpSortBy.split('_')[0] : 'DesignatedTime';
			this.CurrentSearchFilters.SortDirection = typeof tmpSortBy == 'string' ? tmpSortBy.split('_')[1] : 'DESC';
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalResultCount = pTotalSearchCount;
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Results', '#ObservationSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#ObservationSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Pagination', '#ObservationSearch-Pagination-Container', false, false, () =>
			{
				this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Pagination-State', '#ObservationSearch-Pagination-State-Container', false, false, () =>
				{
					this.log.info('Observation Search Pagination rendered');
				});
			});
			// if there is a callback function, call it
			if (this.observationSearchResultsCallback)
			{
				this.observationSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}

	/**
	 * This method handles the action popover for the observation search results.
	 * @param {Event} event - The event that triggered the popover.
	 * @param {string} pElementId - The ID of the element to attach the popover to.
	 * @param {number} pIDObservation - The ID of the observation.
	 */
	handleActionPopover(event, pElementId, pIDObservation)
	{
		// prevent the default action of the event
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		const isIncludedInForm = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		const tmpMenuElement = document.getElementById(pElementId);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${pElementId} not found for Observation search rults action popover.`);
			return;
		}
		// create the popover menu
		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'ObservationSearch-Reults-Extra-Row-ActionMenu',
			PopoverTemplateRecord:
			{
				IDObservation: pIDObservation,
				IncludedInForm: isIncludedInForm,
			},
			theme: 'dropdown-dark',
		});
	}

	/**
	 * This method sets the mode of the search panel.
	 * @param {string} pMode - The mode to set the search panel to.
	 * @return {void}
	 */
	setMode(pMode)
	{
		this.SearchPanelMode = pMode;
		if (pMode === 'add-to-set')
		{
			this.setSelected = true;
		}
		else
		{
			this.setSelected = false;
		}
		// render the search entry form with the new mode
		this.renderAsync(() =>
		{
			this.pict.log.info('Search panel mode set to: ' + pMode);
		});
	}
}

module.exports = ObservationSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSearch',
	DefaultRenderable: 'ObservationSearch-Entry',
	DefaultDestinationAddress: '#ObservationSearch-Entry-Container',
	CSS: /*css*/`
		.mode_add-to-set {
			display: none;
		}
		.hide-in-mode_add-to-folder {
			display: none;
		}
		.visible-mode_add-to-set .mode_add-to-set {
			display: block;
		}
		.mode_add-to-folder {
			display: none;
		}
		.visible-mode_add-to-folder .mode_add-to-folder {
			display: block;
		}
		.mode_add-to-root {
			display: none;
		}
		.visible-mode_add-to-root .mode_add-to-root {
			display: block;
		}`,
	Templates:
		[
			{
				Hash: 'ObservationSearch-Entry',
				Template: /*html*/`
				<div id="ObservationSearch-SearchEntry" class="container">
					<form autocomplete="off" role="observation-search" onsubmit="_Pict.views.ObservationSearch.handleObservationSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="ObservationSearchFilters">
							<div class="columns is-hidden">
								{~T:ObservationSearch-Entry-CurrentPage~}
								{~T:ObservationSearch-Entry-PageSize~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-ObservationTypeSelector~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-StartDate~}
								{~T:ObservationSearch-Entry-EndDate~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-SearchText~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="ObservationSearch-Pagination-Container" style="flex:auto"></div>
							<button class="button is-primary is-soft" type="button" data-collapsible-toggle="ObservationSearchFilters" title="Set filters" onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters')" id="ObservationSearch-ToggleButton">
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="ObservationSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:ObservationSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" id="ObservationSearch-ResetButton" title="Reset filters" onclick="_Pict.views.ObservationSearch.resetSearchFilters()"><i class="fas fa-fw fa-undo mr-1"></i> Clear Filters</button>
							<button class="button is-primary" type="submit" title="Search observations" id="ObservationSearch-SearchButton"><i class="fas fa-fw fa-search mr-1"></i> Search Observations</button>
							<div id="ObservationSearch-Pagination-State-Container"></div>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'ObservationSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="ObservationSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('CurrentPage')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-PageSize" class="block">Page Size</label>
						<input 
							id="ObservationSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('PageSize')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ObservationSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-Projects" 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('Projects')"
								multiple
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ObservationTypeSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ObservationSearch-ObservationTypes">Observation Types</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-ObservationTypes" 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('ObservationTypes')"
								multiple
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="ObservationSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="ObservationSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="DesignatedTime_DESC">Designated Time (Newest)</option>
								<option value="DesignatedTime_ASC">Designated Time (Oldest)</option>
								<option value="ObservationType_ASC">Observation Type (A-Z)</option>
								<option value="ObservationType_DESC">Observation Type (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ObservationSearch-SearchText" class="block">Text Search</label>
					<input 
						id="ObservationSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results',
				Template: /*html*/`
				<div id="ObservationSearch-Results-Container" class="container table-container">
					{~TIfAbs:ObservationSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:ObservationSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Designated Time</th>
							<th>Type</th>
							<th>Creating User</th>
							<th>Project</th>
							{~T:ObservationSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="ObservationSearch-ResultsEntries">
						{~TS:ObservationSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'ObservationSearch-Results-Row',
				Template: /*html*/`
				<tr onclick="_Pict.views.HeadlightPaneObservations.handleObservationImagePreviewClick(event, '{~D:Record.IDObservation~}', 'Search')" data-observation-id="{~D:Record.IDObservation~}">
					<td>{~DateFormat:Record.DesignatedTime^YYYY-MM-DD~}</td>
					<td>{~ObsTypeDisplay:Record.ObservationType~}</td>
					<td>{~Entity:User^Record.CreatingIDUser^ObservationSearch-Results-User^~}</td>
					<td>{~Entity:Project^Record.IDProject^ObservationSearch-Results-Project^~}</td>
					{~T:ObservationSearch-Results-Extra-Row:Record~}
				</tr>`,
			},
			{
				Hash: 'ObservationSearch-Results-Extra-Header',
				Template: /*html*/`
				<th>Thumbnail</th>
				<th>Actions</th>`,
			},
			{
				Hash: 'ObservationSearch-Results-Extra-Row',
				Template: /*html*/`
				<td>
					<a class="preview-image-wrapper" style="min-width:100px; min-height:100px">
						<img class="preview-image is-skeleton" height="128" width="128" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" 
							alt="Observation Preview for #{~D:Record.IDObservation~}" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />
					</a>
				</td>
				<td class="is-vcentered">
					<button
						id="PANEL-MENU-BUTTON-FOR-OBSERVATION-{~D:Record.IDObservation~}"
						class="button icon-button is-ghost has-text-primary-60 p-0 ml-3 is-size-5"
						style="float: none"
						title="Actions"
						type="button"
						aria-haspopup="true"
						onmouseover="_Pict.views.ObservationSearch.handleActionPopover(event, id, '{~D:Record.IDObservation~}')"
						onclick="_Pict.views.ObservationSearch.handleActionPopover(event, id, '{~D:Record.IDObservation~}')"
						data-observation-id="{~D:Record.IDObservation~}">
						<span class="icon is-small">
							<i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
						</span>
					</button>
				</td>`,
			},
			{
				Hash: 'ObservationSearch-Reults-Extra-Row-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ObservationSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_add-to-set">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-set');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-plus-circle"></i>
							</span>
							<span>Add to Set</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-folder">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-folder');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-file-plus"></i>
							</span>
							<span>Add File to Folder</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-root">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-root');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-file-plus"></i>
							</span>
							<span>Add File to Project Files</span>
						</a>
					</li>
					<li class="list-menu-item {~Hide:Record.IsObservationLinked~}{~Hide:Pict.views.ObservationSearch.setSelected~}">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-document');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-link"></i>
							</span>
							<span>Include in document</span>
						</a>
					</li>
					<li class="list-menu-item {~Show:Record.IsObservationLinked~}">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'remove-from-document');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-unlink"></i>
							</span>
							<span>Remove from document</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ObservationSearch-Pagination',
				Template: /*html*/`
				<nav id="ObservationSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="ObservationSearch-PreviousButton" type="button" title="Previous page" class="button is-soft mr-2" onclick="_Pict.views.ObservationSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="ObservationSearch-NextButton" type="button" title="Next page" class="button is-soft" onclick="_Pict.views.ObservationSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
			{
				Hash: 'ObservationSearch-Pagination-State',
				Template: /*html*/`
				<div id="ObservationSearch-Pagination-State" class="pagination-state" aria-label="pagination state">
					<p class="is-size-7 has-text-grey">Page {~D:Context[0].CurrentSearchFilters.CurrentPage~} of {~D:Context[0].CurrentSearchFilters.TotalPages~} ({~HumanCount:Context[0].CurrentSearchFilters.TotalResultCount^0~} total records)</p>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any observations based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ObservationSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'ObservationSearch-Entry',
				TemplateHash: 'ObservationSearch-Entry',
				DestinationAddress: '#ObservationSearch-Entry-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ProjectSelector',
				TemplateHash: 'ObservationSearch-Entry-ProjectSelector',
				DestinationAddress: '#ObservationSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ObservationTypeSelector',
				TemplateHash: 'ObservationSearch-Entry-ObservationTypeSelector',
				DestinationAddress: '#ObservationSearch-Entry-ObservationTypeSelector',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ActiveFilterCount',
				TemplateHash: 'ObservationSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#ObservationSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'ObservationSearch-Results',
				TemplateHash: 'ObservationSearch-Results',
				DestinationAddress: '#ObservationSearch-Results-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Pagination',
				TemplateHash: 'ObservationSearch-Pagination',
				DestinationAddress: '#ObservationSearch-Pagination-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Pagination-State',
				TemplateHash: 'ObservationSearch-Pagination-State',
				DestinationAddress: '#ObservationSearch-Pagination-State-Container',
			},
		],
};

},{"pict-view":733}],1564:[function(require,module,exports){
/* eslint-disable new-cap */
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationSet extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.IncludedObservationSets = [];
		this.ActiveObservationSetID = null;
		this.ActiveObservationSet = null;
		this.ActiveObservationSetAddCallback = (pIDObservation, ActiveObservationSet)=>
		{
			if (this.pict.views?.['PictFormMetacontroller-DynamicInputs'])
			{
				this.pict.views['PictFormMetacontroller-DynamicInputs'].marshalToViewAsync(()=>
				{});
			}
		};
		this.ActiveObservationSetRemoveCallback = (pIDObservation, ActiveObservationSet)=>
		{
			if (this.pict.views?.['PictFormMetacontroller-DynamicInputs'])
			{
				this.pict.views['PictFormMetacontroller-DynamicInputs'].marshalToViewAsync(()=>
				{});
			}
		};
	}

	/**
	 * Get the active observation set from the provider
	 * @param {string} [pSetID] - The observation set id to get
	 * @return {Promise<boolean>} - Returns true if the active observation set is set
	 */
	async getActiveObservationSet(pSetID)
	{
		if (!this.ActiveObservationSetID)
		{
			this.pict.log.warn('ObservationSet.getActiveObservationSet: ActiveObservationSetID is not defined');
			return;
		}
		this.ActiveObservationSet = await this.pict.providers.ObservationSetProvider.loadSet(this.ActiveObservationSetID);
		return this.ActiveObservationSet;
	}

	/**
	 * Render the observation set view before the main render function is called
	 * @param {import('pict-view').ErrorCallback} pCallback - The callback to call after rendering
	 * @param {import('pict-view').Renderable} pRenderable - The renderable to use for rendering
	 * @return {void}
	 */
	onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.getActiveObservationSet().catch((err) =>
		{
			this.pict.log.error('ObservationSet.onBeforeRenderAsync: Error getting active observation set', err);
		}).finally(() =>
		{
			// set the intent for the sub image selector view
			if (this.pict.views?.ObservationSubImageSelector?.intent)
			{
				this.pict.views.ObservationSubImageSelector.intent =
				{
					type: 'ObservationSet',
					IDObservationSet: this.ActiveObservationSetID,
				};
			}
			super.onBeforeRenderAsync(pCallback, pRenderable);
		});
	}

	/**
	 * Handle the click event for the manage set button in the form selector addon - a button can use this to set the active observation set by passing the id
	 * @param {string} pValue - The observation set id to manage
	 * @param {Function} pCallback - The callback to call after setting the active observation set
	 * @return {Promise<void>}
	 */
	async handleFormManageSetButtonClick(pValue, pCallback)
	{
		// if we specifically want to create a new set, do that now
		if (!pValue)
		{
			this.pict.log.error('ObservationSet.handleFormManageSetButtonClick: pValue is required');
			return;
		}
		// set the active observation set to the selected set for rendering
		await this.setObservationSetID(pValue);
		// open the observation panel and switch to the sets tab
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Sets', 'Observation');
			this.setObservationPanelTarget();
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
	}

	/**
	 * Add an observation to the active observation set
	 * @param {string} pIDObservation - The observation id to add to the set
	 * @return {Promise<void>}
	 */
	async addObservationToSet(pIDObservation)
	{
		if (!this.ActiveObservationSet)
		{
			this.pict.log.warn('ObservationSet.addObservationToSet: ActiveObservationSet is not defined');
			return;
		}
		if (!pIDObservation)
		{
			this.pict.log.error('ObservationSet.addObservationToSet: pIDObservation is required');
			return;
		}
		// get the observation record from the passed id
		const tmpObservationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		// add the observation to the set
		await this.pict.providers.ObservationSetProvider.addObservation(this.ActiveObservationSet, tmpObservationRecord);
		// render the observation set view with the new data
		this.renderAsync('ObservationSet', () =>
		{
			this.pict.log.info('ObservationSet view rendered from addObservationToSet.');
		});
		// if we have a callback, call it
		if (this.ActiveObservationSetAddCallback)
		{
			await this.ActiveObservationSetAddCallback(pIDObservation, this.ActiveObservationSet);
		}
	}

	/**
	 * Handle the removal of an observation from the set via the x button
	 * @param {Event} event - The click event
	 * @param {string} pIDObservation - The observation id to remove from the set
	 * @return {Promise<void>}
	 * @async
	 */
	async handleRemoveObservationFromSet(event, pIDObservation)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		this.pict.log.info('ObservationSet.handleRemoveObservationFromSet: pIDObservation', pIDObservation);
		// find the observation in the set and pass it to the removal function in the provider
		const tmpRemovalObs = this.ActiveObservationSet.Observations.find((obs) => obs.IDObservation == pIDObservation);
		await this.pict.providers.ObservationSetProvider.removeObservation(this.ActiveObservationSet, tmpRemovalObs);
		// render the observation set view with the new data
		this.renderAsync('ObservationSet', () =>
		{
			this.pict.log.info('ObservationSet view rendered from addObservationToSet.');
		});
		// if we have a callback, call it
		if (this.ActiveObservationSetRemoveCallback)
		{
			this.ActiveObservationSetRemoveCallback(pIDObservation, this.ActiveObservationSet);
		}
	}

	/**
	 * Set the observation panel target to the active observation set and enable the "add" mode banner/logic
	 * @return {void}
	 */
	setObservationPanelTarget()
	{
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', 'add-to-set');
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-set';
		this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-set';
		// set the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = this.ActiveObservationSet.Name;
		this.pict.views.ObservationSearch.setMode('add-to-set');
	}

	/**
	 * Handle the click event for the add observation button in the observation set view panel - opens the observation panel to search
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handlePanelAddObservationButtonClick(pEvent)
	{
		// set the tab to the search results
		this.setObservationPanelTarget();
		this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
	}

	/**
	 * Handle the click event for the create media file button in the observation set view panel - opens the observation panel to upload
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handlePanelCreateObservationButtonClick(pEvent)
	{
		// add the loading class to the button
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// open the observation panel and switch to the create tab
		this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
		{
			this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation');
			this.setObservationPanelTarget();
			// remove the loading class from the button
			if (pEvent && pEvent.currentTarget)
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			}
		});
	}

	/**
	 * TODO: Handle the click event for the important files button in the observation set view panel - ???
	 * @param {Event} pEvent - The click event
	 * @return {void}
	 */
	handlePanelImportantFilesButtonClick(pEvent)
	{
		// add the loading class to the button
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// open the observation panel and switch to the create tab
		this.pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch', 'open', () =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
	}

	/**
	 * Set the active observation set id for the view
	 * @param {string} pIDObservationSetID - The observation set id to set as active
	 * @return {Promise<void>} - Returns the active observation set
	 */
	async setObservationSetID(pIDObservationSetID)
	{
		this.ActiveObservationSetID = pIDObservationSetID;
		await this.getActiveObservationSet();
	}

	/**
	 * Reset the observation set view to its default state
	 * @return {void}
	 */
	resetObservationSetView()
	{
		this.ActiveObservationSetID = null;
		this.ActiveObservationSet = null;
		this.ActiveObservationSetAddCallback = null;
		this.ActiveObservationSetRemoveCallback = null;
	}

	/**
	 * Handle the click event for the image preview in the observation set list
	 * @param {Event} pEvent - The click event
	 * @param {string} pIDObservation - The observation id to preview
	 * @return {void}
	 */
	handleImagePreviewClick(pEvent, pIDObservation)
	{
		// add the loading class to the image
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// show the observation detail view
		this.pict.log.info('ObservationSet.handleImagePreviewClick: pIDObservation', pIDObservation);
		this.pict.views.HeadlightPaneObservations.showObservationDetailView(pEvent, pIDObservation, null, () =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
	}

	showEditSetNameView()
	{
		this.pict.log.info('ObservationSet.showEditSetNameView: ActiveObservationSet', this.ActiveObservationSet);
		this.renderAsync('ObservationSet-Title-Edit', '#HeadlightPanels-ObservationSet-Title-Wrapper', () =>
		{
			this.pict.log.info('ObservationSet-Title-Edit view rendered.');
		});
	}

	async updateSetName(event)
	{
		// prevent the form from submitting (aka refreshing the page)
		event.preventDefault();
		event.stopPropagation();

		const tmpNewName = document.getElementById('ObservationSet-Edit-Title-Form').querySelector('input').value;
		this.pict.log.info('ObservationSet.updateSetName: tmpNewName', tmpNewName);
		this.ActiveObservationSet.Name = tmpNewName;
		await this.pict.providers.ObservationSetProvider.saveSet(this.ActiveObservationSet);
		this.renderAsync('ObservationSet', '#ObservationSet-ActiveSet-Container', () =>
		{
			this.pict.log.info('ObservationSet view rendered from updateSetName.');
		});
	}

	async updateDisplayedObservationSet(event, observationSet)
	{
		await this.setObservationSetID(observationSet);
		if (event.isDefaultPrevented())
		{
			return;
		}
		this.renderAsync();
	}

	async onAfterRenderAsync(pCallback)
	{
		// OBSERVATION TYPE Selector Filter
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark has-sticky-option',
			ElementID: 'ObservationSets-IncludedList',
			ParentID: 'HeadlightPanels-ObservationSet-Selector-Container',
			URL: 'ObservationManifests',
			IDField: 'Name',
			TextField: 'DisplayName',
			useAjax: false,
		}, () =>
		{
			console.log('ObservationSet Select2 Initialized.');
		});
		pCallback();
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 */
	async initializeSelect2Plugin(pOptions, pCallback)
	{
		const select2Config = {
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
		};

		if (pOptions.useAjax)
		{
			select2Config.ajax = {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${this.pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = this.pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: this.pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === this.pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === this.pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			};
		}
		else
		{
			const IDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			const data = await this.pict.providers.ObservationSetProvider.getObservationSetsForDocument(IDDocument);
			select2Config.data = this.pict.providers.UtilityProvider.formatSelect2Results(data, 'IDObservationSet', 'Name');
		}

		$('#' + pOptions.ElementID).select2(select2Config);

		if (this.ActiveObservationSetID)
		{
			$('#' + pOptions.ElementID).val(this.ActiveObservationSetID);
			const event = $.Event('change');
			event.preventDefault();
			$('#' + pOptions.ElementID).trigger(event);
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}
}

module.exports = ObservationSet;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSet',
	DefaultRenderable: 'ObservationSet',
	DefaultDestinationAddress: '#ObservationSet-ActiveSet-Container',
	Templates:
		[
			{
				Hash: 'ObservationSet',
				Template: /*html*/`
				{~TIfAbs:ObservationSet-ActiveSet:Context[0]:Context[0].ActiveObservationSetID^>^0~}
				{~TIfAbs:ObservationSet-Unset:Context[0]:Context[0].ActiveObservationSetID^<=^0~}`,
			},
			{
				Hash: 'ObservationSet-Unset',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Unset-Message" class="notification has-text-text-light is-dark m-3">
					<p class="has-text-centered">No active observation set.</p>
				</div>`,
			},
			{
				Hash: 'ObservationSet-ActiveSet',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Title-Wrapper" class="p-4 mb-0 has-background-text-15">
					{~T:ObservationSet-Title-Display~}
				</div>
				{~T:ObservationSet-Selector~}
				{~TIfAbs:ObservationSet-List:Context[0].ActiveObservationSet.Observations:Context[0].ActiveObservationSet.Observations.length^>^0~}
				{~TIfAbs:ObservationSet-Empty:Context[0].ActiveObservationSet.Observations:Context[0].ActiveObservationSet.Observations.length^<=^0~}
				<div class="buttons is-right m-4">
					<button type="button" class="button is-primary" title="Add Observation" onclick="_Pict.views.ObservationSet.handlePanelAddObservationButtonClick(event)">
						<span class="icon">
							<i class="fas fa-plus"></i>
						</span>
						<span class="icon-text">Add Observation</span>
					</button>
					<button type="button" class="button is-primary" title="Add Observation" onclick="_Pict.views.ObservationSet.handlePanelCreateObservationButtonClick(event)">
						<span class="icon">
							<i class="fas fa-upload"></i>
						</span>
						<span class="icon-text">Create New Observation</span>
					</button>
					<button type="button" class="button is-primary" title="Add Important File" onclick="_Pict.views.ObservationSet.handlePanelImportantFilesButtonClick(event)">
						<span class="icon">
							<i class="fas fa-file"></i>
						</span>
						<span class="icon-text">Include Project File</span>
					</button>
				</div>`,
			},
			{
				Hash: 'ObservationSet-List',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSetPanel-List">
					{~TS:ObservationSet-List-Item:Record.Observations~}
				</div>`,
			},
			{
				Hash: 'ObservationSet-List-Item',
				Template: /*html*/`
				<div class="panel-block is-block-flex is-align-items-left is-relative p-2 is-clickable" onclick="_Pict.views.ObservationSet.handleImagePreviewClick(event, '{~D:Record.IDObservation~}')" data-observation-id="{~D:Record.IDObservation~}">
					<a class="preview-image-wrapper">
						<img class="preview-image" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" alt="Observation Preview for #{~D:Record.IDObservation~}" />
					</a>
					<div class="is-block-flex is-align-items-left mx-4" style="flex-grow: 1">
						<div class="is-size-7 has-text-text-75">#{~D:Record.IDObservation~}</div>
						<div>{~D:Record.Name~}</div>
						<div class="is-size-7 has-text-text-75">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</div>
						<div class="is-size-7 has-text-text-75"><i class="fa fa-fw fa-user"></i> {~Entity:User^Record.CreatingIDUser^ObservationSet-List-Item-User^~}</div>
					</div>
					<div class="buttons mr-4">
						<button type="button" title="Remove observation from document" class="button is-ghost has-text-text-85 p-0 ml-3" onclick="_Pict.views.ObservationSet.handleRemoveObservationFromSet(event, '{~D:Record.IDObservation~}')">
							<span class="icon">
								<i class="fa fa-fw fa-times-circle"></i>	
							</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSet-Title-Display',
				Template: /*html*/`
				<h1 class="title is-5 has-text-text-90">
					{~D:Context[0].ActiveObservationSet.Name~}
					<a class="ml-1 has-text-link-75" title="Edit Set Name" onclick="_Pict.views.ObservationSet.showEditSetNameView()">
						<span class="icon">
							<i class="fas fa-edit"></i>
						</span>
					</a>
				</h1>`,
			},
			{
				Hash: 'ObservationSet-Title-Edit',
				Template: /*html*/`
				<form id="ObservationSet-Edit-Title-Form" onsubmit="_Pict.views.ObservationSet.updateSetName(event)">
					<div class="field has-addons has-addons-right">
						<div class="control is-expanded">
							<input class="input" type="text" placeholder="Observation Set Name" value="{~D:Context[0].ActiveObservationSet.Name~}">
						</div>
						<div class="control">
							<button id="ObservationSet-Edit-Title-Save-Button" title="Save title" type="submit" class="button is-primary">
								Save
							</button>
						</div>
					</div>
				</form>`,
			},
			{
				Hash: 'ObservationSet-List-Item-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ObservationSet-Empty',
				Template: /*html*/`
				<div id="HeadlightPanels-ObservationSet-Empty-Message" class="notification has-text-text-light is-dark m-3">
					<p class="has-text-centered">No observations found in this set.</p>
				</div>`,
			},
			{
				Hash: 'ObservationSet-Selector',
				Template: /*html*/`
				<div class="columns p-4">
					<div class="column" id="HeadlightPanels-ObservationSet-Selector-Container">
						<div class="field">
							<label class="label block" for="ObservationSets-IncludedList">Document Included Observation Sets</label>
							<div class="control select is-fullwidth">
								<select 
									id="ObservationSets-IncludedList" 
									onchange="_Pict.views.ObservationSet.updateDisplayedObservationSet(event, this.value)">
								></select>
							</div>
						</div>
					</div>
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'ObservationSet',
				TemplateHash: 'ObservationSet',
				DestinationAddress: '#ObservationSet-ActiveSet-Container',
				RenderType: 'replace',
			},
			{
				RenderableHash: 'ObservationSet-Title-Display',
				TemplateHash: 'ObservationSet-Title-Display',
				DestinationAddress: '#HeadlightPanels-ObservationSet-Title-Wrapper',
				RenderType: 'replace',
			},
			{
				RenderableHash: 'ObservationSet-Title-Edit',
				TemplateHash: 'ObservationSet-Title-Edit',
				DestinationAddress: '#HeadlightPanels-ObservationSet-Title-Wrapper',
				RenderType: 'replace',
			},
			{
				RenderableHash: 'ObservationSet-Selector',
				TemplateHash: 'ObservationSet-Selector',
				DestinationAddress: '#HeadlightPanels-ObservationSet-Selector-Container',
				RenderType: 'replace',
			},
		],
};

},{"pict-view":733}],1565:[function(require,module,exports){
const libPictSectionForm = require(`pict-section-form`);
//const PictViewClass = require('pict-view');


const defaultViewConfiguration = (
	{
		ViewIdentifier: 'Pict-Form-Solver',
		DefaultRenderable: 'HL-Pict-Form-Solver-Renderable',
		DefaultDestinationAddress: '#Pict-Form-Solver-In-Panel-Wrapper',
		RenderOnLoad: false,
		CSS: /*css*/`
            #Pict-Form-Solver-Content {
                color: var(--panels-content-block-text-color);
            }
            /* ── Filter bar ──────────────────────────────────────────
               Sticky search input above the solver entries. Sticky so
               the user keeps the filter affordance in view while
               scrolling through long log lists. The clear (×) button
               and the "no matches" banner are toggled in JS via the
               .is-active class set on their parents. */
            .PSFS-Filter-Bar {
                position: sticky;
                top: 0;
                z-index: 5;
                display: flex;
                align-items: center;
                gap: 0.55rem;
                padding: 0.5rem 0.65rem;
                background-color: var(--bulma-black-bis);
                border-bottom: 1px solid var(--panels-content-block-divider-color);
            }
            /* The Solve button shares the bar with the filter input — pin
               its size so it doesn't shrink when the panel narrows, and
               keep a clear visual gap so the action button doesn't read
               as part of the filter affordance to its right. */
            .PSFS-Filter-Solve {
                flex: 0 0 auto;
            }
            .PSFS-Filter-Bar .control {
                flex: 1 1 auto;
                position: relative;
            }
            /* Match counter on the right of the filter bar. Always
               visible so the user gets a feel for total log volume
               even before they start typing. The leading filter icon
               anchors the column visually; tabular-nums keeps digits
               aligned as the count ticks down character-by-character. */
            .PSFS-Filter-Counter {
                flex: 0 0 auto;
                display: inline-flex;
                align-items: center;
                gap: 0.35rem;
                font-size: 0.72rem;
                color: var(--bulma-text-60);
                font-variant-numeric: tabular-nums;
                white-space: nowrap;
                letter-spacing: 0.02em;
            }
            .PSFS-Filter-Counter .icon {
                font-size: 0.75rem;
                color: inherit;
            }
            .PSFS-Filter-Bar.is-active .PSFS-Filter-Counter {
                color: var(--bulma-warning);
            }
            /* In-place highlighting of matched substrings, à la browser
               Find. The mark element is wrapped around each token hit
               in visible entries by _applyHighlightsTo(). Warning-yellow
               background reads as "active filter highlight" without
               competing with the existing severity-* tones used by
               custom log entries. */
            .PSFS-Filter-Highlight {
                background-color: var(--bulma-warning);
                color: var(--bulma-black);
                padding: 0 0.1rem;
                border-radius: 0.15rem;
                font-weight: 600;
                /* Pict's solver-entry rule uses !important on color to
                   override Pict defaults — we inherit-and-override here
                   so highlights stay visible inside the warning-tinted
                   .PSFExt-Solver-Entry expression band, monospace token
                   chips, and severity-tinted custom log rows alike. */
                box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
            }
            .PSFS-Filter-Input {
                width: 100%;
                padding: 0.4rem 2rem 0.4rem 2rem;
                background-color: var(--panels-input-background-color) !important;
                color: var(--panels-input-text-color) !important;
                border: 1px solid var(--panels-input-border-color) !important;
                border-radius: 0.25rem;
                font-size: 0.85rem;
                line-height: 1.3;
            }
            .PSFS-Filter-Input:focus {
                outline: none;
                border-color: var(--bulma-warning) !important;
                box-shadow: 0 0 0 2px rgba(255, 184, 0, 0.18);
            }
            .PSFS-Filter-Icon {
                position: absolute;
                left: 0.55rem;
                top: 50%;
                transform: translateY(-50%);
                color: var(--bulma-text-60);
                font-size: 0.8rem;
                pointer-events: none;
            }
            .PSFS-Filter-Clear {
                position: absolute;
                right: 0.3rem;
                top: 50%;
                transform: translateY(-50%);
                color: var(--bulma-text-60);
                background: transparent;
                border: 0;
                padding: 0.2rem 0.35rem;
                cursor: pointer;
                border-radius: 0.2rem;
                display: none;
                font-size: 0.8rem;
                line-height: 1;
            }
            .PSFS-Filter-Clear:hover {
                color: var(--bulma-text-95);
                background: rgba(255, 255, 255, 0.06);
            }
            .PSFS-Filter-Bar.is-active .PSFS-Filter-Clear {
                display: inline-flex;
                align-items: center;
            }
            /* Hide-by-filter rule. Used in addition to (not instead of)
               Bulma's .is-hidden so we don't fight collapsible-section
               state — the filter and the user's manual collapse remain
               independently controllable. */
            .PSFS-Filter-Hidden {
                display: none !important;
            }
            .PSFS-Filter-Empty {
                padding: 1.5rem 1rem;
                text-align: center;
                color: var(--bulma-text-60);
                font-size: 0.85rem;
                display: none;
            }
            .PSFS-Filter-Empty.is-active {
                display: block;
            }
            /* Override Bulma's .panel.is-warning tinting on the panel body
               so the Solver pane matches the dark Validations panel. The
               gold .panel-heading is preserved because Bulma themes that
               independently via the heading-specific rule. */
            #HeadlightPanels-SolverPanel-Content {
                background-color: var(--panels-background-color) !important;
            }

            /* ── Standard solver entries (Pict-rendered solver list) ───
               One .PSFExt-Section per solver expression. The caps dark
               header band sits on top with an 8px warning-yellow leading
               border; content rows beneath get an 8px black-ter leading
               border so the eye reads "yellow = parent, gray = children".
               Sections stack flush.
               Pict's support base also ships defaults that paint things
               light (.PSFExt-Section-ExtraData → #fafafa, .PSFExt-Solver-Entry
               → 1px dotted #ccc bottom border, etc) at the same selector
               specificity as our rules, so most overrides need !important
               to win the load-order tiebreak. */
            .PSFExt-Section {
                background-color: transparent !important;
                margin: 0 !important;
                padding: 0 !important;
                border-radius: 0 !important;
            }
            .PSFExt-Section-ExtraData {
                background-color: transparent !important;
                margin: 0 !important;
                padding: 0 !important;
            }
            .PSFExt-Section-Header {
                display: flex;
                align-items: center;
                gap: 0.4rem;
                padding: 0.5rem 0.65rem 0.5rem 0.25rem !important;
                margin: 0 !important;
                background-color: var(--bulma-grey-darker) !important;
                color: var(--bulma-text-95);
                font-size: 0.75rem !important;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                border-left: 8px solid var(--bulma-warning);
            }
            .PSFExt-Section-Header span.PSFExt-DeEmphasize {
                color: var(--bulma-text-65) !important;
                font-weight: 500;
                margin-left: 0.25rem;
                margin-right: 0.25rem;
            }
            /* Section header layout — meta on the left, actions hard-right —
               is handled by Bulma flex utility classes (.is-flex,
               .is-flex-grow-1, .ml-auto) directly on the markup. The
               Edit / More chips use Bulma's .button.is-small.is-dark so
               their look + hover comes from the framework. */

            /* ── Expression display (read-only) ────────────────────────
               This is the always-visible <p class="PSFExt-Solver-Entry">
               that shows the formula. Pict's default theme paints the
               text magenta; we override to a softer dark overlay that
               reads as a code block while still feeling part of the
               panel's gray-tone palette (rather than a stark black band
               against the panel bg). */
            .PSFExt-Solver-Entry {
                word-wrap: break-word;
                margin: 0 !important;
                padding: 0.5rem 0.75rem 0.5rem 0.75rem !important;
                color: var(--bulma-warning-85) !important;
                background-color: rgba(0, 0, 0, 0.25) !important;
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.8rem;
                line-height: 1.5;
                border-bottom: none !important;
                border-left: 8px solid var(--bulma-black-ter) !important;
            }

            /* The expression editor textarea (shown after clicking Edit)
               picks up the panel's input theme so it feels native to the
               surrounding form fields. Pict's default sets a 100%-20px
               width and 80px min-height — overridden so the editor sits
               flush inside our row layout. */
            .PSFExt-ExpressionEditbox {
                width: 100% !important;
                min-height: 60px !important;
                padding: 0.5rem !important;
                background-color: var(--panels-input-background-color) !important;
                color: var(--panels-input-text-color) !important;
                border: 1px solid var(--panels-input-border-color) !important;
                border-radius: 0.25rem;
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.8rem;
                line-height: 1.5;
            }

            /* Small inline "Value:" / "Tokens:" rows under the expression.
               Pict's default sets margin-left, line-height: 0.85, and
               font-size: smaller — all overridden here so rows breathe. */
            .PSFExt-Section .PSFExt-Data {
                margin: 0 !important;
                padding: 0.35rem 0.65rem 0.35rem 0.75rem !important;
                font-size: 0.8rem !important;
                line-height: 1.5 !important;
                color: var(--panels-content-block-text-color);
                border-left: 8px solid var(--bulma-black-ter) !important;
            }
            /* Alternating row tint — slightly lighter wash on every other
               .PSFExt-Data row, matching the custom-logs alternating
               pattern. :nth-of-type counts among <p> siblings, so h5
               group dividers ("Postfix Tokens", "Virtual Symbols") don't
               break the alternation but the visual still feels banded. */
            .PSFExt-Section-ExtraData .PSFExt-Data:nth-of-type(even) {
                background-color: rgba(255, 255, 255, 0.04);
            }
            .PSFExt-Section .PSFExt-Label {
                color: var(--bulma-text-60);
                font-size: 0.7rem;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                margin-right: 0.25rem;
            }

            /* ── Sub-section group headers ─────────────────────────────
               "Postfix Tokens" / "Virtual Symbols" / "Postfix Solve List"
               and the per-entry "Postfix Solve Entry #N Symbol …" bands.
               Sit one tier below the main section header in the visual
               hierarchy: still a caps band, but smaller and on a darker
               surface so the parent → children relationship reads.
               Pict ships defaults that paint these light (#ebebff /
               #fafafa); !important overrides keep the dark caps band. */
            .PSFExt-Content-Header {
                font-weight: 600;
                margin: 0 !important;
                padding: 0.35rem 0.65rem 0.35rem 0.75rem !important;
                background-color: var(--bulma-black-ter) !important;
                color: var(--bulma-text-85);
                text-transform: uppercase;
                letter-spacing: 0.05em;
                font-size: 0.7rem;
                border-left: 8px solid var(--bulma-black-ter) !important;
            }
            .PSFExt-Content-Header.PSFExt-Section-Group-Header {
                font-size: 0.75rem !important;
            }
            .PSFExt-Content-Header.PSFExt-Data-Header {
                background-color: rgba(255, 255, 255, 0.04) !important;
                color: var(--bulma-text-75);
            }

            /* ── Data tables (postfix solve entry breakdowns) ──────────
               Caps headers, dark theme borders, monospace cells where
               appropriate via the Token chip styling on contained spans. */
            .PSFExt-Data-Table {
                margin: 0.25rem 0.5rem;
            }
            .PSFExt-Data-Table th {
                font-weight: 600;
                font-size: 0.7rem;
                padding: 0.4rem 0.5rem;
                color: var(--bulma-text-95);
                background-color: var(--bulma-grey-darker);
                text-transform: uppercase;
                letter-spacing: 0.05em;
                text-align: left;
                border-bottom: 1px solid var(--panels-content-block-divider-color);
            }
            .PSFExt-Data-Table td {
                word-wrap: break-word;
                padding: 0.35rem 0.5rem;
                font-size: 0.8rem;
                border: 1px solid var(--panels-content-block-divider-color);
                color: var(--panels-content-block-text-color);
            }
            .PSFExt-Data-Table td.cell-header {
                font-weight: 600;
                font-size: 0.7rem;
                color: var(--bulma-text-60);
                background-color: var(--panels-content-block-hover-background-color);
                text-transform: uppercase;
                letter-spacing: 0.05em;
            }

            /* ── Custom Solver Log styles ──────────────────────────────
               Section header / badge / collapse styling lives in
               panels-logs.scss (.hl-log-section, .hl-log-section-header,
               .hl-log-section-body) — shared with the Validations pane.
               Below are just the bits unique to the Custom Solver Logs:
               the wrapper banner, entry/calc rows, severity tags, and
               the variable-chip / numeric-formula display used inside
               calc rows. */
            .PSFS-CustomLog-Header {
                font-weight: bold;
                font-size: 1.1rem;
                padding: 0.5rem;
                color: var(--bulma-text-95);
                background-color: var(--bulma-black-ter);
                margin: 0;
            }
            .PSFS-CustomLog-Header .icon {
                color: var(--bulma-warning);
                margin-left: 0.5rem;
            }
            .PSFS-CustomLog-Entry {
                padding: 0.35rem 0.5rem 0.35rem 0.75rem;
                font-size: 0.85rem;
                border-left: 8px solid var(--bulma-black-ter);
                color: var(--panels-content-block-text-color);
            }
            .PSFS-CustomLog-Entry-Severity {
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.7rem;
                padding: 0.05rem 0.3rem;
                border-radius: 0.2rem;
                margin-right: 0.35rem;
            }
            .PSFS-CustomLog-Entry-Severity.severity-error {
                background-color: var(--bulma-danger-dark);
                color: var(--bulma-danger-light);
            }
            .PSFS-CustomLog-Entry-Severity.severity-warning {
                background-color: var(--bulma-warning-dark);
                color: var(--bulma-warning-light);
            }
            .PSFS-CustomLog-Entry-Severity.severity-info {
                background-color: var(--bulma-info-dark);
                color: var(--bulma-info-light);
            }
            .PSFS-CustomLog-Entry-Severity.severity-trace {
                background-color: var(--panels-content-block-hover-background-color);
                color: var(--bulma-text-60);
            }
            .PSFS-CustomLog-Calc {
                padding: 0.35rem 0.5rem 0.35rem 0.75rem;
                font-size: 0.85rem;
                border-left: 8px solid var(--bulma-black-ter);
                color: var(--panels-content-block-text-color);
            }
            .PSFS-CustomLog-Calc-Result {
                font-weight: 700;
                color: var(--bulma-info-light);
            }
            .PSFS-CustomLog-Calc-Formula {
                font-size: 0.8rem;
                color: var(--bulma-text-60);
                margin-top: 0.2rem;
                line-height: 1.6;
            }
            /* Inline pill — used for formula variable references in custom
               log calculations AND Pict's postfix-token names. Subtle
               blue tint so chips stay readable on the dark panel without
               the loud saturated tone we had before. !important on
               bg/color is needed for .PSFExt-Token to override Pict's
               default lime-green token color. */
            .PSFS-CustomLog-Chip,
            .PSFExt-Token {
                display: inline-block;
                padding: 0.1rem 0.4rem;
                background: rgba(78, 154, 220, 0.15) !important;
                color: #7db8e8 !important;
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.75rem;
                border: 1px solid rgba(78, 154, 220, 0.25);
                border-radius: 0.25rem;
                vertical-align: baseline;
            }
            .PSFS-CustomLog-Chip-Op {
                display: inline-block;
                font-size: 0.75rem;
                color: var(--bulma-text-65);
                padding: 0 0.2rem;
                vertical-align: baseline;
            }
            .PSFS-CustomLog-Calc-NumericFormula {
                font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Cascadia Code', monospace;
                font-size: 0.75rem;
                color: var(--bulma-text-65);
                margin-top: 0.1rem;
            }
        `,
		Templates: [
			{
				Hash: 'HL-Pict-Form-Solver-Content',
				Template: /*html*/`
<div id="Pict-Form-Solver-Content">
    <div id="PSFS-Filter-Bar" class="PSFS-Filter-Bar">
        <button type="button" class="button is-small is-primary PSFS-Filter-Solve"
            title="Re-run the solver"
            onclick="{~P~}.views.PictFormMetacontroller.solve(); {~P~}.views.PictFormMetacontroller.marshalFormSections(); {~P~}.views['{~D:Context[0].Hash~}'].render();">
            <span class="icon is-small"><i class="fas fa-fw fa-calculator" aria-hidden="true"></i></span>
            <span>Solve</span>
        </button>
        <div class="control">
            <span class="PSFS-Filter-Icon icon"><i class="fas fa-fw fa-magnifying-glass" aria-hidden="true"></i></span>
            <input id="PSFS-Filter-Input" type="text" class="PSFS-Filter-Input"
                placeholder="Filter logs..."
                aria-label="Filter solver logs"
                value="{~D:Context[0].FilterQuery~}"
                oninput="{~P~}.views.PictFormsSolver.applyFilter(this.value)" />
            <button type="button" class="PSFS-Filter-Clear" title="Clear filter"
                onclick="{~P~}.views.PictFormsSolver.clearFilter()">
                <span class="icon is-small"><i class="fas fa-fw fa-xmark" aria-hidden="true"></i></span>
            </button>
        </div>
        <span id="PSFS-Filter-Counter" class="PSFS-Filter-Counter" aria-live="polite">
            <span class="icon"><i class="fas fa-fw fa-filter" aria-hidden="true"></i></span>
            <span id="PSFS-Filter-Counter-Text"></span>
        </span>
    </div>
    {~TS:HL-Pict-Form-Solver-Entries:Context[0].getDynamicState().Solvers~}
    {~TS:HL-Pict-Form-Solver-CustomLogWrap:Context[0].CustomLogSectionsSorted~}
    <div id="PSFS-Filter-Empty" class="PSFS-Filter-Empty">No logs match your filter.</div>
</div>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-Entries',
				Template: /*html*/`
    <div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
        <h3 class="PSFExt-Section-Header">
            <span class="is-flex is-align-items-center is-flex-grow-1">
                <span class="PSFExt-DeEmphasize">{~D:Record.ExpressionScope~}</span> {~D:Record.SectionOrdinal~}.G.{~D:Record.GroupOrdinal~}
                <span class="PSFExt-DeEmphasize">Ord</span>{~D:Record.Ordinal~}
                <span class="PSFExt-DeEmphasize">Ind</span>{~D:Record.Index~}
            </span>
            <span class="is-flex is-align-items-center ml-auto">
                <a class="button is-small is-dark mr-1" href="javascript:void(0);"
                    onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">
                    <span class="icon is-small"><i class="fas fa-fw fa-pencil" aria-hidden="true"></i></span>
                    <span>Edit</span>
                </a>
                <a class="button is-small is-dark" href="javascript:void(0);"
                    onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer', 'PSFExt-Hidden');">
                    <span class="icon is-small"><i class="fas fa-fw fa-circle-info" aria-hidden="true"></i></span>
                    <span>More</span>
                </a>
            </span>
        </h3>
        
        <div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer" class="PSFExt-Hidden">
            <p class="PSFExt-Data">
                <textarea id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox" class="PSFExt-ExpressionEditbox">{~D:Record.Expression~}</textarea>
            </p>
            <div class="buttons is-right p-2 m-0">
                <button type="button" class="button is-small is-primary"
                    onclick="
                        {~P~}.views['{~D:Context[0].Hash~}'].updateExpressionFromElement(
                            '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox',
                            '{~D:Record.ExpressionScope~}', '{~D:Record.ViewHash~}', {~D:Record.SectionOrdinal~}, {~D:Record.Index~},
                            '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display'
                        );
                        {~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');
                    ">
                    <span class="icon is-small"><i class="fas fa-fw fa-check" aria-hidden="true"></i></span>
                    <span>Apply</span>
                </button>
            </div>
        </div>
        <div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Extra" class="PSFExt-Section-ExtraData">
            <p class="PSFExt-Solver-Entry" id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display">{~D:Record.Expression~}</p>
            <p class="PSFExt-Data">
                <span class="PSFExt-Label">Value</span> {~TBT:Record.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record:HL-Pict-Form-RecordValueDisplaySimple~}
            </p>
        </div>
        <div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer" class="PSFExt-Section-ExtraData PSFExt-Hidden">
            <h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Tokens</h5>
            {~TS:HL-Pict-Form-Solver-PostfixToken:Record.LastResultsObject.PostfixTokenObjects~}
            <h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">Virtual Symbols</h5>
            {~TVS:HL-Pict-Form-Solver-VirtualSymbols:Record.LastResultsObject.VirtualSymbols~}
            <h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Solve List</h5>
            {~TVS:HL-Pict-Form-Solver-PostFixSolveEntry:Record.LastResultsObject.PostfixSolveList~}
        </div>
    </div>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-PostfixToken',
				Template: /*html*/`
            <p class="PSFExt-Data">
                <span class="PSFExt-Label">{~D:Record.Type~}</span> <span class="PSFExt-Token">{~D:Record.Token~}</span>
            </p>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-VirtualSymbols',
				Template: /*html*/`
            <p class="PSFExt-Data">
                <span class="PSFExt-Label">{~D:Record.Key~}</span> {~TBT:Record.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record:HL-Pict-Form-RecordValueDisplaySimple~}
            </p>
`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplayComplex',
				Template: /*html*/`
            <!-- Complex Value -->
            {~TBT:Record.Value:array:HL-Pict-Form-RecordValueDisplayArray:Record:HL-Pict-Form-RecordValueDisplayObject~}
`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplayObject',
				Template: /*html*/`JSON Object
            <!-- RAW Object
{~DJ:Record.Value~}
            -->`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplayArray',
				Template: /*html*/`JSON Array ({~D:Record.Value.length~} items)
            <!-- RAW Array
{~DJ:Record.Value~}
            -->`,
			},
			{
				Hash: 'HL-Pict-Form-RecordValueDisplaySimple',
				Template: /*html*/`{~D:Record.Value~}`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-PostFixSolveEntry',
				Template: /*html*/`
            <div>
                <h6 class="PSFExt-Content-Header PSFExt-Data-Header">Postfix Solve Entry #{~D:Record.Key~} Symbol <span class="PSFExt-Token">{~D:Record.Value.VirtualSymbolName~}</span></h6>
                <table class="PSFExt-Data-Table" style="width: 98%;">
                    <thead>
                        <tr>
                            <th width="15%">&nbsp;</th>
                            <th width="30%">Left</th>
                            <th width="25%">Operation</th>
                            <th width="30%">Right</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="cell-header">Virtual Symbol</td>
                            <td> {~D:Record.Value.LeftValue.VirtualSymbolName~} </td>
                            <td> {~D:Record.Value.Operation.VirtualSymbolName~} </td>
                            <td> {~D:Record.Value.RightValue.VirtualSymbolName~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Value</td>
                            <td> {~TBT:Record.Value.LeftValue.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record.Value.LeftValue:HL-Pict-Form-RecordValueDisplaySimple~} </td>
                            <td>&nbsp;</td>
                            <td> {~TBT:Record.Value.RightValue.Value:object,array:HL-Pict-Form-RecordValueDisplayComplex:Record.Value.RightValue:HL-Pict-Form-RecordValueDisplaySimple~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Tokens</td>
                            <td> {~D:Record.Value.LeftValue.Token~} </td>
                            <td> {~D:Record.Value.Operation.Token~} </td>
                            <td> {~D:Record.Value.RightValue.Token~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Type</td>
                            <td> {~D:Record.Value.LeftValue.Type~} </td>
                            <td> {~D:Record.Value.Operation.Type~} </td>
                            <td> {~D:Record.Value.RightValue.Type~} </td>
                        </tr>
                        <tr>
                            <td class="cell-header">Solve Layer</td>
                            <td> {~D:Record.Value.LeftValue.SolveLayerStack~} </td>
                            <td>&nbsp;</td>
                            <td> {~D:Record.Value.RightValue.SolveLayerStack~} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
`,
			},
			// ── Custom Solver Log templates ──────────────────────────────
			{
				Hash: 'HL-Pict-Form-Solver-CustomLogWrap',
				Template: /*html*/`
    <div class="PSFS-CustomLog-Header">
        <span class="icon"><i class="fas fa-fw fa-scroll" aria-hidden="true"></i></span>
        Custom Solver Logs
    </div>
    {~TS:HL-Pict-Form-Solver-CustomLogSection:Record.Sections~}
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-CustomLogSection',
				Template: /*html*/`
    <div class="hl-log-section">
        <div class="hl-log-section-header"
             onclick="{~P~}.views.PictFormsSolver.toggleCustomLogSection('{~D:Record.Key~}')">
            <span class="hl-log-section-icon icon">
                <i class="fas fa-fw fa-list-ol" aria-hidden="true"></i>
            </span>
            <span class="hl-log-section-name">{~D:Record.Name~}</span>
            <span class="hl-log-section-badge">{~D:Record.Entries.length~}</span>
            <span class="hl-log-section-chevron icon">
                <i class="fas fa-fw {~D:Record.ChevronIconClass~}" data-custom-log-chevron="{~D:Record.Key~}" aria-hidden="true"></i>
            </span>
        </div>
        <div data-custom-log-section="{~D:Record.Key~}" class="hl-log-section-body {~D:Record.HiddenClass~}">
            {~TS:HL-Pict-Form-Solver-CustomLogEntry:Record.Entries~}
        </div>
    </div>
`,
			},
			{
				Hash: 'HL-Pict-Form-Solver-CustomLogEntry',
				Template: /*html*/`{~D:Record.Html~}`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'HL-Pict-Form-Solver-Renderable',
				TemplateHash: 'HL-Pict-Form-Solver-Content',
			},
		],
	});

/**
 * @typedef {Object} CustomLogEntry
 * @property {string} Type       - 'Entry' or 'Calculation'
 * @property {string} Category   - Section key used for grouping
 * @property {string} Label      - Display label (section display name)
 * @property {string} Message    - Human-readable message / description
 * @property {string} Severity   - 'Trace' | 'Info' | 'Warning' | 'Error'
 * @property {string=} Result    - Calculated value (Calculation entries only)
 * @property {string=} Formula   - Expression string (Calculation entries only)
 * @property {string=} FormulaDescription - Variable explanation (Calculation entries only)
 * @property {string} Html       - Pre-rendered HTML for the template
 */

/**
 * @typedef {Object} CustomLogSection
 * @property {string} Key
 * @property {string} Name
 * @property {CustomLogEntry[]} Entries
 * @property {boolean} Collapsed
 * @property {string} HiddenClass
 */

// @ts-ignore
class PictFormsSolver extends libPictSectionForm.PictFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.DisplayShortName = 'HL-SV';
		this.DisplayLongName = 'Headlight-SolverVisualization';

		/** @type {CustomLogSection[]} */
		this._customLogSections = [];

		// Active filter query applied across both the standard Pict
		// solver entries and the custom log sections. Held on the
		// instance (rather than the DOM) so the filter survives every
		// re-render — onAfterRender re-applies it to the freshly
		// rendered nodes. Cleared via clearFilter() or by emptying
		// the input.
		/** @type {string} */
		this._filterQuery = '';
	}

	/**
	 * Current filter query string. Exposed as a getter so the
	 * content template can hydrate the input's `value` attribute on
	 * each render via `{~D:Context[0].FilterQuery~}`.
	 * @return {string}
	 */
	get FilterQuery()
	{
		return this._filterQuery;
	}

	// ── Custom Solver Log API ────────────────────────────────────────

	/**
	 * Sorted snapshot of sections for template consumption.
	 * Exposed as `CustomLogSectionsSorted` on the view instance so the
	 * content template can iterate it via `{~TS:...:Context[0].CustomLogSectionsSorted~}`.
	 *
	 * Returns an array containing a single wrapper object whose `.Sections`
	 * property holds the sorted section list — this matches the `{~TS:...~}`
	 * pattern (iterates an array, each Record has `.Sections`).
	 *
	 * @return {Array<{ Sections: CustomLogSection[] }>}
	 */
	get CustomLogSectionsSorted()
	{
		if (this._customLogSections.length === 0)
		{
			return [];
		}
		const sorted = this._customLogSections.slice().sort((a, b) => a.Key.localeCompare(b.Key));
		// Pre-compute presentation state for each section
		for (const section of sorted)
		{
			section.HiddenClass = section.Collapsed ? 'is-hidden' : '';
			section.ChevronIconClass = section.Collapsed ? 'fa-chevron-right' : 'fa-chevron-down';
		}
		return [ { Sections: sorted } ];
	}

	/**
	 * Find or create a section by key.
	 *
	 * @param {string} pSectionKey
	 * @param {string=} pDisplayName - Human-readable name; defaults to pSectionKey.
	 * @return {CustomLogSection}
	 * @private
	 */
	_getOrCreateSection(pSectionKey, pDisplayName)
	{
		let section = this._customLogSections.find((s) => s.Key === pSectionKey);
		if (!section)
		{
			section = { Key: pSectionKey, Name: pDisplayName || pSectionKey, Entries: [], Collapsed: false, HiddenClass: '' };
			this._customLogSections.push(section);
		}
		return section;
	}

	/**
	 * Parse a formula description string and render variable names as
	 * styled chip elements with operators as plain muted text between them.
	 *
	 * Input strings look like: `TotalWorkCompletedAmount &plus; SubtotalAmount`
	 * where operators are HTML entities (`&plus;`, `&times;`, `&minus;`,
	 * `&divide;`, `&equals;`).
	 *
	 * @param {string} pFormulaDescription - Variable names separated by HTML entity operators
	 * @return {string} HTML string with chip-wrapped variables and operator spans
	 * @private
	 */
	_renderFormulaChips(pFormulaDescription)
	{
		if (!pFormulaDescription)
		{
			return '';
		}

		// Split on HTML entity operators, keeping the delimiters
		const splitPattern = /(&plus;|&times;|&minus;|&divide;|&equals;)/g;
		// Non-global regex for classifying each token (avoids lastIndex drift)
		const isOperator = /^&(?:plus|times|minus|divide|equals);$/;
		const parts = pFormulaDescription.split(splitPattern);

		let html = '';
		for (const part of parts)
		{
			const trimmed = part.trim();
			if (!trimmed)
			{
				continue;
			}

			if (isOperator.test(trimmed))
			{
				html += `<span class="PSFS-CustomLog-Chip-Op">${trimmed}</span>`;
			}
			else
			{
				html += `<span class="PSFS-CustomLog-Chip">${trimmed}</span>`;
			}
		}
		return html;
	}

	/**
	 * Map a severity string to a CSS modifier class.
	 *
	 * @param {string=} pSeverity
	 * @return {string}
	 * @private
	 */
	_severityClass(pSeverity)
	{
		const key = (pSeverity || 'trace').toLowerCase();
		if (key === 'error') return 'severity-error';
		if (key === 'warning') return 'severity-warning';
		if (key === 'info') return 'severity-info';
		return 'severity-trace';
	}

	/**
	 * Add a general log entry. Signature matches the legacy
	 * `Headlight-Section-SolverLog.addEntry()` API so existing call sites
	 * can be routed here without modification.
	 *
	 * @param {string} pCategory     - Section key used for grouping (e.g. '001PaymentObservationQuantities')
	 * @param {string} pLabel        - Section display name (e.g. 'Payment Quantities')
	 * @param {string} pMessage      - Human-readable log message
	 * @param {string=} pSeverity    - 'Trace' | 'Info' | 'Warning' | 'Error'
	 */
	addEntry(pCategory, pLabel, pMessage, pSeverity)
	{
		const section = this._getOrCreateSection(pCategory, pLabel);
		const sevClass = this._severityClass(pSeverity);
		const sevLabel = (pSeverity || 'Trace');

		const html = /*html*/`
		<div class="PSFS-CustomLog-Entry">
			<span class="PSFS-CustomLog-Entry-Severity ${sevClass}">${sevLabel}</span>
			${pMessage}
		</div>`;

		section.Entries.push({
			Type: 'Entry',
			Category: pCategory,
			Label: pLabel,
			Message: pMessage,
			Severity: sevLabel,
			Html: html,
		});
	}

	/**
	 * Add a calculation log entry. Signature matches the legacy
	 * `Headlight-Section-SolverLog.addCalculation()` API.
	 *
	 * @param {string} pCategory           - Section key
	 * @param {string} pLabel              - Section display name
	 * @param {string} pDescription        - What is being calculated
	 * @param {string|number} pResult      - Computed value
	 * @param {string=} pFormula           - Expression string
	 * @param {string=} pFormulaDescription - Human-readable variable breakdown
	 */
	addCalculation(pCategory, pLabel, pDescription, pResult, pFormula, pFormulaDescription)
	{
		const section = this._getOrCreateSection(pCategory, pLabel);

		// Build the formula line with variable chips
		let formulaHtml = '';
		if (pFormulaDescription)
		{
			const chips = this._renderFormulaChips(pFormulaDescription);
			formulaHtml += /*html*/`<div class="PSFS-CustomLog-Calc-Formula">${chips}</div>`;
		}
		// Show the numeric expression on its own quieter line
		if (pFormula)
		{
			formulaHtml += /*html*/`<div class="PSFS-CustomLog-Calc-NumericFormula">${pFormula}</div>`;
		}

		const html = /*html*/`
		<div class="PSFS-CustomLog-Calc">
			<span>${pDescription}</span>
			<span class="PSFS-CustomLog-Calc-Result">= ${pResult}</span>
			${formulaHtml}
		</div>`;

		section.Entries.push({
			Type: 'Calculation',
			Category: pCategory,
			Label: pLabel,
			Message: pDescription,
			Severity: 'Info',
			Result: String(pResult),
			Formula: pFormula || '',
			FormulaDescription: pFormulaDescription || '',
			Html: html,
		});
	}

	/**
	 * Clear all custom log sections. Intended to be called at the start
	 * of each solve cycle so stale entries don't accumulate.
	 */
	resetEntries()
	{
		this._customLogSections = [];
	}

	/**
	 * Toggle the collapsed state of a custom log section.
	 * Called from the section header onclick in the template.
	 *
	 * @param {string} pSectionKey
	 */
	toggleCustomLogSection(pSectionKey)
	{
		const section = this._customLogSections.find((s) => s.Key === pSectionKey);
		if (!section) return;
		section.Collapsed = !section.Collapsed;
		// Toggle the DOM directly for responsiveness — the next full
		// render will pick up the persisted Collapsed flag.
		const el = document.querySelector(`[data-custom-log-section="${pSectionKey}"]`);
		if (el)
		{
			el.classList.toggle('is-hidden');
		}
		// Flip the chevron icon to match
		const chevron = document.querySelector(`[data-custom-log-chevron="${pSectionKey}"]`);
		if (chevron)
		{
			chevron.classList.toggle('fa-chevron-down', !section.Collapsed);
			chevron.classList.toggle('fa-chevron-right', section.Collapsed);
		}
	}

	/**
	 * Trigger a render of the custom log portion. Forms can call this
	 * explicitly after a batch of addEntry/addCalculation calls to
	 * update the panel in one shot rather than per-entry.
	 */
	renderCustomLogs()
	{
		this.render();
	}

	// ── Filter / highlight ──────────────────────────────────────────

	/**
	 * Apply the filter query across all standard solver entries and
	 * custom log sections / entries — hides non-matches and wraps
	 * matched substrings in `<mark>` tags for browser-Find-style
	 * highlighting. Called from the search input's `oninput` handler,
	 * so it runs synchronously against the rendered DOM and the user
	 * sees feedback as they type. The active query is stored on the
	 * instance so it survives re-renders.
	 *
	 * Matching is multi-token substring: the query is split on
	 * whitespace and every token must appear (case-insensitively) as
	 * a literal substring of the target text.
	 *
	 * @param {string} pQuery
	 */
	applyFilter(pQuery)
	{
		this._filterQuery = (pQuery == null ? '' : String(pQuery)).trim();
		this._refreshFilterDOM();
	}

	/**
	 * Clear the active filter and restore visibility of every entry.
	 * Wired to the inline (×) button in the filter bar.
	 */
	clearFilter()
	{
		this._filterQuery = '';
		const tmpInput = document.getElementById('PSFS-Filter-Input');
		if (tmpInput)
		{
			tmpInput.value = '';
			tmpInput.focus();
		}
		this._refreshFilterDOM();
	}

	/**
	 * Walk the rendered solver content and update three things based
	 * on the active filter query:
	 *
	 *   • Visibility — hide entries / sections that don't match.
	 *   • Highlighting — wrap matched substrings in `<mark>` tags so
	 *     the user can see exactly what landed (browser-Find style).
	 *   • Counter + empty state — refresh the right-side count
	 *     ("12 / 47") and toggle the "no logs match" banner.
	 *
	 * Visibility cascades through three layers:
	 *
	 *   1. `.PSFExt-Section` — Pict-rendered solver expression blocks.
	 *      Each is a single coherent unit (header + expression display
	 *      + extra data), matched as a whole by its full text content.
	 *   2. `.hl-log-section` — custom log collapsible groups. Match
	 *      hierarchically: if the section header text matches, every
	 *      entry stays visible; otherwise entries are filtered
	 *      individually and the group hides only when nothing inside
	 *      matches.
	 *   3. The "Custom Solver Logs" wrap header — hides when nothing
	 *      inside it survives, so the user isn't left with an orphan
	 *      heading floating above filtered-away content.
	 *
	 * Sections are hidden via the dedicated `PSFS-Filter-Hidden` class
	 * (not Bulma's `is-hidden`) so the user's manual collapse state on
	 * a custom log section remains independent of the filter — toggling
	 * the chevron and toggling the filter don't fight each other.
	 *
	 * @private
	 */
	_refreshFilterDOM()
	{
		const tmpRoot = document.getElementById('Pict-Form-Solver-Content');
		if (!tmpRoot)
		{
			return;
		}
		const tmpTokens = this._tokenizeFilterQuery(this._filterQuery);
		const tmpHasQuery = tmpTokens.length > 0;
		const tmpFilterBar = document.getElementById('PSFS-Filter-Bar');
		const tmpEmptyMsg = document.getElementById('PSFS-Filter-Empty');
		const tmpCounterText = document.getElementById('PSFS-Filter-Counter-Text');
		if (tmpFilterBar)
		{
			tmpFilterBar.classList.toggle('is-active', tmpHasQuery);
		}

		// Strip last cycle's <mark> highlights before re-evaluating. We
		// do this up front so the textContent reads we use for matching
		// (and any subsequent re-highlight pass) operate on a clean DOM
		// — otherwise mark wrappers from a previous keystroke would
		// accumulate.
		this._clearHighlights(tmpRoot);

		// Pre-build the multi-token highlight regex once per call so we
		// don't compile it inside the inner loop. Null when there's no
		// active query — the per-entry highlight pass becomes a no-op.
		const tmpHighlightRegex = tmpHasQuery ? this._buildHighlightRegex(tmpTokens) : null;

		// Tally counts as we go so the on-screen counter ("12 / 47")
		// reflects the same leaf-level definition the user perceives:
		// each standard solver expression block counts as 1, and each
		// custom log entry row inside a collapsible group counts as 1.
		let tmpVisibleCount = 0;
		let tmpTotalCount = 0;

		// Standard Pict-rendered solver expressions
		const tmpPsfSections = tmpRoot.querySelectorAll('.PSFExt-Section');
		for (const tmpSection of tmpPsfSections)
		{
			tmpTotalCount++;
			const tmpText = (tmpSection.textContent || '').toLowerCase();
			const tmpMatch = !tmpHasQuery || this._matchesAllTokens(tmpTokens, tmpText);
			tmpSection.classList.toggle('PSFS-Filter-Hidden', !tmpMatch);
			if (tmpMatch)
			{
				tmpVisibleCount++;
				if (tmpHighlightRegex)
				{
					this._applyHighlightsTo(tmpSection, tmpHighlightRegex);
				}
			}
		}

		// Custom Solver Log sections (collapsible groups)
		const tmpLogSections = tmpRoot.querySelectorAll('.hl-log-section');
		for (const tmpSection of tmpLogSections)
		{
			const tmpHeaderEl = tmpSection.querySelector('.hl-log-section-name');
			const tmpHeaderText = (tmpHeaderEl ? tmpHeaderEl.textContent || '' : '').toLowerCase();
			const tmpHeaderMatch = !tmpHasQuery || this._matchesAllTokens(tmpTokens, tmpHeaderText);
			let tmpSectionHasMatch = tmpHeaderMatch;

			// Highlight the header itself when it matches — gives the
			// user immediate visual confirmation of which group is
			// pinned by the section-name match path.
			if (tmpHighlightRegex && tmpHeaderEl && tmpHeaderMatch)
			{
				this._applyHighlightsTo(tmpHeaderEl, tmpHighlightRegex);
			}

			const tmpEntries = tmpSection.querySelectorAll('.hl-log-section-body > *');
			for (const tmpEntry of tmpEntries)
			{
				tmpTotalCount++;
				const tmpEntryText = (tmpEntry.textContent || '').toLowerCase();
				// When the section header itself matches, all entries
				// stay visible — the user is exploring the whole group.
				const tmpEntryMatch = tmpHeaderMatch || !tmpHasQuery || this._matchesAllTokens(tmpTokens, tmpEntryText);
				tmpEntry.classList.toggle('PSFS-Filter-Hidden', !tmpEntryMatch);
				if (tmpEntryMatch)
				{
					tmpSectionHasMatch = true;
					tmpVisibleCount++;
					if (tmpHighlightRegex)
					{
						this._applyHighlightsTo(tmpEntry, tmpHighlightRegex);
					}
				}
			}
			tmpSection.classList.toggle('PSFS-Filter-Hidden', !tmpSectionHasMatch);
		}

		// Hide the "Custom Solver Logs" wrap header when nothing inside
		// it survives the filter, so the user isn't left with an orphan
		// section heading floating above filtered-away content.
		const tmpCustomLogHeader = tmpRoot.querySelector('.PSFS-CustomLog-Header');
		if (tmpCustomLogHeader)
		{
			const tmpAnyLogVisible = Array.from(tmpLogSections).some((s) => !s.classList.contains('PSFS-Filter-Hidden'));
			tmpCustomLogHeader.classList.toggle('PSFS-Filter-Hidden', tmpHasQuery && !tmpAnyLogVisible);
		}

		if (tmpEmptyMsg)
		{
			tmpEmptyMsg.classList.toggle('is-active', tmpHasQuery && tmpVisibleCount === 0);
		}

		if (tmpCounterText)
		{
			if (tmpHasQuery)
			{
				tmpCounterText.textContent = `${tmpVisibleCount} / ${tmpTotalCount}`;
			}
			else
			{
				tmpCounterText.textContent = `${tmpTotalCount} log${tmpTotalCount === 1 ? '' : 's'}`;
			}
		}
	}

	/**
	 * Tokenize a filter query into the whitespace-separated lowercase
	 * words used as substring needles. Computed once per filter pass
	 * (not on every target match) so a long log list filters in
	 * O(targets * tokens) rather than re-splitting per row.
	 *
	 * @param {string} pQuery
	 * @return {string[]}
	 * @private
	 */
	_tokenizeFilterQuery(pQuery)
	{
		if (!pQuery)
		{
			return [];
		}
		const tmpTokens = [];
		for (const tmpRaw of String(pQuery).toLowerCase().split(/\s+/))
		{
			if (tmpRaw)
			{
				tmpTokens.push(tmpRaw);
			}
		}
		return tmpTokens;
	}

	/**
	 * Multi-word substring match. Every token in `pTokens` must appear
	 * as a literal (case-insensitive) substring of `pTarget`. Tokens
	 * may match in any order, but each one has to actually be in there
	 * — no character-anywhere-in-order looseness, which let "Result"
	 * pass for queries like "ConnectionsCalculationsLength".
	 *
	 * Single-token queries collapse to the equivalent of a normal
	 * browser-Find substring search; multi-token queries let users
	 * combine keywords ("calc width") without caring about ordering.
	 *
	 * `pTarget` must be pre-lowercased by the caller.
	 *
	 * @param {string[]} pTokens  Lowercased query tokens (non-empty).
	 * @param {string}   pTarget  Pre-lowercased target string.
	 * @return {boolean}
	 * @private
	 */
	_matchesAllTokens(pTokens, pTarget)
	{
		if (!pTokens || pTokens.length === 0)
		{
			return true;
		}
		if (!pTarget)
		{
			return false;
		}
		for (const tmpToken of pTokens)
		{
			if (pTarget.indexOf(tmpToken) === -1)
			{
				return false;
			}
		}
		return true;
	}

	/**
	 * Escape a literal string for safe inclusion in a RegExp source.
	 * Without this, query characters like `(`, `.`, `*`, `?`, `|` etc.
	 * would change the regex's meaning (the user types these often when
	 * filtering for things like `(VFE_4)` or `result=`).
	 *
	 * @param {string} pSource
	 * @return {string}
	 * @private
	 */
	_escapeRegex(pSource)
	{
		return pSource.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	/**
	 * Build a single case-insensitive global regex that captures any
	 * occurrence of any token. Compiled once per filter call and reused
	 * across every visible entry — much cheaper than per-entry compile.
	 *
	 * The capture group is what `String.prototype.split` uses to keep
	 * the matched delimiters in the result array, which is the trick
	 * that drives the chunk-and-wrap loop in `_applyHighlightsTo`.
	 *
	 * @param {string[]} pTokens  Lowercased tokens (non-empty).
	 * @return {RegExp}
	 * @private
	 */
	_buildHighlightRegex(pTokens)
	{
		const tmpAlternation = pTokens.map((t) => this._escapeRegex(t)).join('|');
		return new RegExp(`(${tmpAlternation})`, 'gi');
	}

	/**
	 * Strip every previous-cycle highlight wrapper from `pRoot`. Called
	 * before each filter pass so highlights don't accumulate as the
	 * user keeps typing. Replaces each <mark> with its text content
	 * and normalizes the parent so adjacent text nodes coalesce.
	 *
	 * @param {ParentNode} pRoot
	 * @private
	 */
	_clearHighlights(pRoot)
	{
		if (!pRoot)
		{
			return;
		}
		const tmpMarks = pRoot.querySelectorAll('mark.PSFS-Filter-Highlight');
		const tmpDirtyParents = new Set();
		for (const tmpMark of tmpMarks)
		{
			const tmpParent = tmpMark.parentNode;
			if (!tmpParent)
			{
				continue;
			}
			tmpParent.replaceChild(document.createTextNode(tmpMark.textContent || ''), tmpMark);
			tmpDirtyParents.add(tmpParent);
		}
		for (const tmpParent of tmpDirtyParents)
		{
			if (tmpParent && typeof tmpParent.normalize === 'function')
			{
				tmpParent.normalize();
			}
		}
	}

	/**
	 * Wrap every match of `pRegex` inside `pRootEl` in a styled <mark>
	 * tag — same idea as the browser's Find highlight. Walks text
	 * nodes via TreeWalker so attributes, event handlers, and existing
	 * markup (icons, chips, severity tags, table cells) are preserved.
	 *
	 * Skips text inside <input>, <textarea>, <script>, <style>, and
	 * already-highlighted <mark> wrappers. Empty-value text nodes are
	 * filtered out as well; whitespace-only nodes pass through, but
	 * the regex won't match against them so they're effectively no-ops.
	 *
	 * The DOM mutation runs after the walk completes — modifying nodes
	 * during walking would invalidate the TreeWalker's cursor.
	 *
	 * @param {Element} pRootEl  Element whose descendant text gets highlighted.
	 * @param {RegExp}  pRegex   Global, case-insensitive regex with one capture group.
	 * @private
	 */
	_applyHighlightsTo(pRootEl, pRegex)
	{
		if (!pRootEl || !pRegex)
		{
			return;
		}
		const tmpWalker = document.createTreeWalker(
			pRootEl,
			NodeFilter.SHOW_TEXT,
			{
				acceptNode(pNode)
				{
					const tmpParent = pNode.parentNode;
					if (!tmpParent)
					{
						return NodeFilter.FILTER_REJECT;
					}
					const tmpTag = tmpParent.nodeName;
					if (tmpTag === 'INPUT' || tmpTag === 'TEXTAREA' || tmpTag === 'SCRIPT' || tmpTag === 'STYLE')
					{
						return NodeFilter.FILTER_REJECT;
					}
					if (tmpTag === 'MARK' && tmpParent.classList && tmpParent.classList.contains('PSFS-Filter-Highlight'))
					{
						return NodeFilter.FILTER_REJECT;
					}
					if (!pNode.nodeValue)
					{
						return NodeFilter.FILTER_REJECT;
					}
					return NodeFilter.FILTER_ACCEPT;
				},
			},
		);
		// Collect first, mutate after — TreeWalker doesn't tolerate
		// removing the current text node mid-walk.
		const tmpTextNodes = [];
		while (tmpWalker.nextNode())
		{
			tmpTextNodes.push(tmpWalker.currentNode);
		}
		for (const tmpNode of tmpTextNodes)
		{
			const tmpText = tmpNode.nodeValue;
			// Reset lastIndex so the global regex doesn't carry state
			// between text nodes (each split() resets it implicitly,
			// but being explicit keeps the intent obvious).
			pRegex.lastIndex = 0;
			if (!pRegex.test(tmpText))
			{
				continue;
			}
			pRegex.lastIndex = 0;
			const tmpParts = tmpText.split(pRegex);
			if (tmpParts.length <= 1)
			{
				continue;
			}
			const tmpFragment = document.createDocumentFragment();
			for (let tmpIndex = 0; tmpIndex < tmpParts.length; tmpIndex++)
			{
				const tmpChunk = tmpParts[tmpIndex];
				if (!tmpChunk)
				{
					continue;
				}
				// `String.split` with a capturing group emits the
				// captured matches at odd indices in the result array.
				if (tmpIndex % 2 === 1)
				{
					const tmpMark = document.createElement('mark');
					tmpMark.className = 'PSFS-Filter-Highlight';
					tmpMark.textContent = tmpChunk;
					tmpFragment.appendChild(tmpMark);
				}
				else
				{
					tmpFragment.appendChild(document.createTextNode(tmpChunk));
				}
			}
			const tmpParent = tmpNode.parentNode;
			if (tmpParent)
			{
				tmpParent.replaceChild(tmpFragment, tmpNode);
			}
		}
	}

	/**
	 * Re-apply the active filter and refresh the match counter after
	 * every render. Pict's render pipeline replaces the content
	 * wholesale on each solve cycle, so any filter state held only in
	 * DOM classes would be wiped — this hook reads from the persisted
	 * `_filterQuery` and re-toggles the filter classes against the
	 * freshly rendered nodes. Always runs (even with an empty filter)
	 * so the counter shows total log count by default.
	 *
	 * @param {any} pRenderable
	 * @return {boolean}
	 */
	onAfterRender(pRenderable)
	{
		const tmpResult = super.onAfterRender(pRenderable);
		this._refreshFilterDOM();
		return tmpResult;
	}
}
module.exports = PictFormsSolver;
module.exports.default_configuration = defaultViewConfiguration;

},{"pict-section-form":587}],1566:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ProjectFileSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialSearchResultsLoaded = false;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			SearchText: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'Date',
			SortDirection: 'DESC',
		};
		this.CurrentProjectSelection = this.AppData?.DocumentData?.ReportData?.IDProject || null;
		this.CurrentProjectName = this.AppData?.DocumentData?.ReportData?.Project?.Name || null;
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		this.CurrentFolderName = '';
		this.selectedObservation = {};
		this.ObservationTypeManifest = [];
		this.SearchPanelMode = '';
		this.SelectedFileFolder = null;
		this.SelectedFileFolderName = '';

		// TODO: We need to get this from the server from configured types by IDProgram
		// TODO: We also need a default set configured for Headlight
		this.FileTypes = [
			{ id: '', text: 'Select a type', disabled: true },
			{ id: 'Calculations', text: 'Calculations' },
			{ id: 'Images', text: 'Images' },
			{ id: 'Inspection Report', text: 'Inspection Report' },
			{ id: 'Load Rating', text: 'Load Rating' },
			{ id: 'Miscellaneous', text: 'Miscellaneous' },
			{ id: 'Plan', text: 'Plan' },
			{ id: 'Scour', text: 'Scour' },
			{ id: 'Structural Inventory and Appraisal', text: 'Structural Inventory and Appraisal' },
			{ id: 'Unknown', text: 'Unknown' },
			{ id: 'Custom', text: 'Custom' },
		];
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		const elementID = 'ProjectFileSearch-Projects';
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list

		// Bridge App has no DocumentData but exposes the active project on AppData.BridgeProject
		const tmpDefaultIDProject = this.AppData?.DocumentData?.ReportData?.IDProject || this.AppData?.BridgeProject?.IDProject;
		const tmpDefaultProjectName = this.AppData?.DocumentData?.ReportData?.Project?.Name || this.AppData?.BridgeProject?.Name;

		const tmpProject = this.CurrentSearchFilters?.Projects.length === 0 ?
			(tmpDefaultIDProject ? { id: tmpDefaultIDProject, text: tmpDefaultProjectName } : null ) :
			{ id: this.CurrentProjectSelection || tmpDefaultIDProject, text: this.CurrentProjectName || tmpDefaultProjectName };

		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: elementID,
			ParentID: 'ProjectFileSearch-SearchEntry',
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		this.setCurrentSearchFilters();
		//if we don't have search results, perform a search
		if (!this.initialSearchResultsLoaded)
		{
			//handle a preselected option if it exists
			if (tmpProject.id && tmpProject.id > 0)
			{
				//moved this out of the initialization to allow for the select2 change event to trigger after the initial load
				const select2 = $(`#${elementID}`);
				// create the option and append to Select2
				const option = new Option(tmpProject.text, tmpProject.id, true, true);
				select2.append(option).trigger('change');

				// manually trigger the `select2:select` event
				select2.trigger(
				{
					type: 'select2:select',
					params:
					{
						data: tmpProject,
					},
				});
			}
			this.initialSearchResultsLoaded = true;
			this.handleProjectFileSearch();
		}

		// if project container exists
		if (document.getElementById('ProjectFileSearch-Project-Container'))
		{
			// if we have a project, show it
			if (tmpDefaultIDProject)
			{
				document.getElementById('ProjectFileSearch-Project-Selected').classList.remove('is-hidden');
			}
			// if we don't have a project, show empty project id container
			else
			{
				document.getElementById('ProjectFileSearch-Project-Empty').classList.remove('is-hidden');
			}
		}
		this.toggleAllSectionVisibility('open');
		if (pCallback) pCallback();
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Event} [event] - The event that triggered the search.
	 * @param {string} [pRowID] - The ID of the row to search for.
	 * @param {boolean} [pIsChild] - Whether the search is for a child file or folder.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileSearch(event, pRowID, pIsChild)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#ProjectFileSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('ProjectFileSearch-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ProjectFileSearchFilters', 'close');
		// perform the project file search
		await this.pict.providers.ProjectFileProvider.getProjectFilesDataStructure(this.CurrentProjectSelection, this.CurrentSearchFilters, (/** @type {any} */ pResult) =>
		{
			if (!Array.isArray(pResult))
			{
				// Render search results template (non-blocking, no side effects here)
				this.pict.views.ProjectFileSearch.renderAsync('ProjectFileSearch-Results', '#ProjectFileSearch-Results-Container', false, () =>
				{
					try
					{
							this.pict.ContentAssignment.removeClass('#ProjectFileSearch-SearchButton', 'is-loading');

							if (this.ProjectFileSearchResultsCallback)
							{
								// eslint-disable-next-line new-cap
								this.ProjectFileSearchResultsCallback(this.CurrentSearchResults);
							}
					}
					catch (innerError)
					{
							this.pict.log.error('Error in renderAsync callback:', innerError);
					}
				},
				);
			}
			else
			{
				this.updateWithSearchResults(pResult, pRowID, pIsChild);
			}
		});
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ProjectFileSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ProjectFileSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ProjectFileSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});

		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.handleProjectFileSearch();
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], ObservationTypes: ['Legacy Narrative'], SearchText: 'dog'})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('ProjectFileSearch-SearchEntry'))
		{
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-SearchText', this.CurrentSearchFilters?.SearchText || '');
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-SearchFolder', this.CurrentSearchFilters?.SearchFolder || '');
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#ProjectFileSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setProjectFileSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setProjectFileSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.ProjectFileSearchResultsCallback = pCallback;
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Project');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentProjectSelection = /** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).value;
			this.CurrentProjectName	 = /** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).options[/** @type {HTMLSelectElement} */ (document.getElementById('ProjectFileSearch-Projects')).selectedIndex].text;
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#ProjectFileSearch-Projects');
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#ProjectFileSearch-SearchText');
			break;
		case 'SearchFolder':
			this.CurrentSearchFilters.SearchFolder = this.pict.ContentAssignment.readContent('#ProjectFileSearch-SearchFolder');
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {string} [pRowID] - The ID of the row to update.
	 * @param {boolean} [pIsChild] - Whether the row is a child row.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pRowID, pIsChild)
	{
		try
		{
			this.CurrentSearchResults = pSearchResults;
			const pTotalSearchCount = pSearchResults.length;

			// Calculate pagination pages - doesn't really apply to Project File Search, but keeping for future enhancements (sort, filter, etc.)
			this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);

			// Render search results template (non-blocking, no side effects here)
			this.pict.views.ProjectFileSearch.renderAsync(
				'ProjectFileSearch-Results',
				'#ProjectFileSearch-Results-Container',
				false,
				() =>
				{
					try
					{
						this.pict.ContentAssignment.removeClass('#ProjectFileSearch-SearchButton', 'is-loading');

						if (this.ProjectFileSearchResultsCallback)
						{
							// eslint-disable-next-line new-cap
							this.ProjectFileSearchResultsCallback(this.CurrentSearchResults);
						}

						// Delay scroll to ensure DOM is patched
						requestAnimationFrame(() =>
						{
							this._tryScrollToRow(pRowID, pIsChild);
						});
					}
					catch (innerError)
					{
						this.pict.log.error('Error in renderAsync callback:', innerError);
					}
				},
			);
		}
		catch (outerError)
		{
			this.pict.log.error('Failed to update with search results:', outerError);
		}
	}

	/**
	* Smoothly scrolls to a row inside a scrollable container using jQuery.
	* @param {string} pRowID - The row ID to scroll to.
	* @param {boolean} pIsChild - Whether the row is a child row.
	* @param {number} [offset=70] - Offset in pixels from the top of the container.
	* @param {string} [containerSelector='#ProjectFileSearch-Results-Container'] - The scrollable container selector.
	*/
	_tryScrollToRow(pRowID, pIsChild, offset = 70, containerSelector = '#HeadlightPanels-ProjectFileSearch-Content')
	{
		if (!pRowID)
		{
			return;
		}

		const $container = $(containerSelector);
		if ($container.length === 0)
		{
			this.pict.log.warn(`Scroll container "${containerSelector}" not found.`);
			return;
		}

		const elID = pIsChild ?
		`ProjectFileSearch-Results-Treeview-Child-${pRowID}` :
		`ProjectFileSearch-Results-Treeview-${pRowID}`;

		const maxAttempts = 10;
		let attempt = 0;
		const interval = 100;

		const tryScroll = () =>
		{
			const $el = $(`#${elID}`);
			if ($el.length > 0)
			{
			// Offset of element and container from document
				const containerOffset = $container.offset().top;
				const elOffset = $el.offset().top;

				// Calculate scrollTop relative to container's current scroll
				const relativeScrollTop = $container.scrollTop() + (elOffset - containerOffset - offset);

				$container.animate({ scrollTop: relativeScrollTop }, 400);

				$el.addClass('highlight');
				setTimeout(() => $el.removeClass('highlight'), 5000);
			}
			else if (attempt++ < maxAttempts)
			{
				setTimeout(tryScroll, interval);
			}
			else
			{
				this.pict.log.warn(`Row with ID "${elID}" not found after ${maxAttempts} attempts.`);
			}
		};

		setTimeout(tryScroll, interval);
	}


	/**
	 * @spec puts a loading spinner on the element for a short time: 1.5 seconds.
	 * @param {HTMLElement} htmlElement
	 */
	animateLoading(htmlElement)
	{
		htmlElement.classList.add('is-loading');
		setTimeout(() => htmlElement.classList.remove('is-loading'), 1500);
	}

	/**
	 * This method handles the Details button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to view details for.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFilesDetailsClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			this.animateLoading(pEvent.currentTarget);
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);
		// and go to the observation detail view for the new observation
		this.pict.views.ObservationDetails.ActiveObservationDetails = tmpObservation;
		this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
	}

	/**
	 * This method handles the Clone button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to clone.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileCloneClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);

		let tmpIDArtifact;
		let tmpVersion;
		// show a PDF viewer if the observation is a PDF file type
		if (tmpObservation?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf')
		{
			tmpIDArtifact = tmpObservation?.Details?.File?.[0]?.IDArtifact;
			tmpVersion = tmpObservation?.Details?.File?.[0]?.Version;
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The selected project file is not a PDF file and cannot be added to the document.',
				type: 'is-danger',
			});
			return;
		}
		// download the file off of the observation
		const tmpFile = await this.pict.providers.ObservationProvider.downloadFileFromObservation(tmpIDArtifact, tmpVersion);
		// create a temporary file object to pass to the observation provider
		const newObservationObject = {
			File: tmpFile,
			ObservationType: tmpObservation.ObservationType,
			Name: tmpObservation.Details.File[0].Datum.FileName,
		};
		// TODO: Make this convert the file to an observation and add it to the document
		// Create an observation from the file
		await this.pict.providers.ObservationProvider.prepareObservationObjectFromFile(newObservationObject, this.AppData?.DocumentData?.ReportData?.IDProject,
		(observationResult) =>
		{
			// remove the loading spinner from the button
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			// join to the document, if we have one
			this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(observationResult.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument);
			const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
			// add result to our document if we have one
			if (tmpObservations && Array.isArray(tmpObservations))
			{
				tmpObservations.push(observationResult);
			}
			// if we have a set (we always should in this case), add the observation to the set
			if (this.pict.views.ObservationSet.ActiveObservationSet)
			{
				this.pict.views.ObservationSet.addObservationToSet(observationResult?.IDObservation);
			}
			// and go to the observation detail view for the new observation
			this.pict.views.ObservationDetails.ActiveObservationDetails = observationResult;
			this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
			this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
		});
	}

	/**
	 * This method handles the Clone button click for an observation.
	 * @param {Event} pEvent - The event that triggered the click.
	 * @param {number} pIDObservation - The ID of the observation to clone.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleProjectFileAddClick(pEvent, pIDObservation)
	{
		if (pEvent && pEvent.currentTarget instanceof HTMLElement)
		{
			pEvent.currentTarget.classList.add('is-loading');
		}
		// get the observation from the server
		const tmpObservation = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		this.log.info('Observation to pull the file from:', tmpObservation);
		// remove the loading spinner from the button
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		// join to the document, if we have one
		this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(tmpObservation.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument);
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		// add result to our document if we have one
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			tmpObservations.push(tmpObservation);
		}
		// if we have a set (we always should in this case), add the observation to the set
		if (this.pict.views.ObservationSet.ActiveObservationSet)
		{
			this.pict.views.ObservationSet.addObservationToSet(tmpObservation?.IDObservation);
		}
		// and go to the observation detail view for the new observation
		this.pict.views.ObservationDetails.ActiveObservationDetails = tmpObservation;
			this.pict.views.ObservationDetails.ObservationDetailsBackTo = 'ProjectFileSearch';
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
	}

	/**
	 * Handles the change of file type in the dropdown.
	 * @param {HTMLSelectElement} selectEl - The select element that triggered the change.
	 * @param {string} fileID - The ID of the file whose type is being changed.
	 * @return {void}
	 */
	handleFileTypeChange(selectEl, fileID)
	{
		const customInput = /** @type {HTMLInputElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${fileID}`));
		if (selectEl.value === 'Custom')
		{
			customInput.classList.remove('is-hidden');
			customInput.focus();
		}
		else
		{
			customInput.classList.add('is-hidden');
		}
	}

	/**
	 * Add a dropdown menu to the toggle button for a table row.
	 * @param {string} pDate - The date of the file.
	 * @param {string} pName - The name of the file.
	 * @param {string} pFileID - The IDFile of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pFileType - The Type of the file.
	 * @param {Event} event - The event that triggered the function.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFileEditHandler(event, pDate, pName, pFileID, pRowID, pFileType, pParentIDProjectFileFolder)
	{
		// this is to get any changes to the file name made outside of the EDIT modal
		const fileNameElement = /** @type {HTMLElement} */ (document.getElementById(this.getFileNameDisplayID(pRowID)));
		const fileName = fileNameElement ? fileNameElement.textContent.trim() : pName;
		// the body and footer templates for the confirmation modal
		const editModalBodyTemplate = /*html*/`
		<span id="EditModalBody">
			<div class="fixed-grid has-2-cols">
				<div class="grid">
					<div class="cell">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-Date">Create Date</label>
						<input type="text" class="input" disabled="disabled" id="ProjectFileSearch-Results-Treeview-List-Date" value="${pDate || 'Unknown Date'}" />
					</div>
					<div class="cell">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}">File Type</label>
						<p class="control select is-fullwidth is-relative">
							<select 
								id="ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}" 
								class="input ml-auto mr-2"
								onchange="_Pict.views.ProjectFileSearch.handleFileTypeChange(this, ${pFileID})"
								title="Select File Type">
								${_Pict.views.ProjectFileSearch.renderFileTypeOptions(pFileType)}
							</select>
							<input type="text" class="input mt-2 is-hidden"
								id="ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${pFileID}"
								placeholder="Enter custom file type" />
						</p>
					</div>
					<div class="cell is-col-span-2">
						<div class="control">
						<label class="label" for="ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}">File Name</label>
						<textarea class="textarea is-justify-content-left" rows="2" max-rows="2" id="ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}">${fileName}</textarea>
						</div>
					</div>
				</div>
			</div>
		</span>`;
		const editModalFooterTemplate = /*html*/`
		<div id="EditModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project File" onclick="_Pict.views.ProjectFileSearch.projectFileSaveHandler(event, ${pFileID}, '${pRowID}', '${fileName}', '${pParentIDProjectFileFolder}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const editModalOptions = {
			title: 'Edit Project File?',
			modalBodyTemplate: editModalBodyTemplate,
			modalFooterTemplate: editModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(editModalOptions, this.confirmSaveCallback.bind(this));
	}

	getFileDisplayID(pRowID)
	{
		return `DISPLAY-FOR-${pRowID}`;
	}

	getFileNameDisplayID(pRowID)
	{
		return `NAME-FOR-${pRowID}`;
	}

	getFileEditID(pRowID)
	{
		return `EDIT-FOR-${pRowID}`;
	}

	getFileInputID(pRowID)
	{
		return `INPUT-FOR-${pRowID}`;
	}

	/**
	 * Switch between edit and display views for a given row.
	 * @param {*} pRowID The row id to switch modes for.
	 */
	projectFileRenameSwitchMode(pRowID)
	{
		// Swap out the display and the input
		const displayElement = document.getElementById(this.getFileDisplayID(pRowID));
		const editElement = document.getElementById(this.getFileEditID(pRowID));
		const inputElement = document.getElementById(this.getFileInputID(pRowID));
		if (displayElement.classList.contains('is-hidden'))
		{
			displayElement.classList.remove('is-hidden');
			editElement.classList.add('is-hidden');
		}
		else
		{
			displayElement.classList.add('is-hidden');
			editElement.classList.remove('is-hidden');
			inputElement.focus();
			// @ts-ignore
			inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
		}
	}

	setProjectFileNameInCurrentSearchResults(pName, pIDProjectFile)
	{
		// Safer findParentNode
		function findNode(nodes, id)
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip undefined or null nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findNode(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		}

		const node = findNode(this.CurrentSearchResults, parseInt(pIDProjectFile));
		node.Name = pName;
	}

	/**
	 * Validates a file name against a set of rules.
	 * @param {string} pFileName - The file name to validate.
	 * @param {string} pParentIDProjectFileFolder - The parent folder ID for the file.
	 * @param {Array} [allowedExtensions=[]] - An array of allowed file extensions.
	 * @param {number} [maxLength=255] - The maximum allowed length for the file name.
	 * @return {boolean} - Returns true if the file name is valid, otherwise false.
	 */
	isValidFileName(pFileName, pParentIDProjectFileFolder, allowedExtensions = [], maxLength = 255)
	{
		const invalidCharsRegex = /[\\/:*?"<>|]/;
		const nameRegex = /^(.*)(\.[^.]+)$/; //if extension is provided

		if (!pFileName || pFileName.trim() === '')
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'File name cannot be blank',
				type: 'is-danger',
			});
			return;
		}

		// Check for invalid characters
		if (invalidCharsRegex.test(pFileName))
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Filename contains invalid characters. Valid characters are alphanumeric, spaces, - _ .',
				type: 'is-danger',
				duration: 5000,
			});
			return false;
		}

		// The regex checks for at least one character before the dot and allows an optional extension after the dot.
		if (nameRegex.test(pFileName) === false)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Filename is not valid. Valid format is name.extension.',
				type: 'is-danger',
				duration: 5000,
			});
			return false;
		}

		// db has name set to Char(255) so check for length
		if (pFileName.length > maxLength)
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filename exceeds maximum length of ${maxLength} characters.`,
				type: 'is-danger',
			});
			return false;
		}

		// Check for extension if allowedExtensions are provided
		if (allowedExtensions.length > 0)
		{
			const parts = pFileName.split('.');
			const extension = parts.pop().toLowerCase();
			if (!allowedExtensions.includes(extension))
			{
				this.pict.views.HeadlightPanels.toast({
					message: `Invalid file extension. Allowed extensions: ${allowedExtensions.join(', ')}`,
					type: 'is-danger',
				});
				return false;
			}
		}

		const checkFileName = this.checkFileNameExists(this.CurrentSearchResults, pFileName, pParentIDProjectFileFolder);
		if (checkFileName !== pFileName)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'A file with this name already exists in this folder',
				type: 'is-danger',
			});
			return false;
		}
		return true;
	}

	async projectFileRename(event, pName, pIDProjectFile, pParentIDProjectFileFolder, pRowID)
	{
		const inputElement = $(`#${this.getFileInputID(pRowID)}`);
		const newFileName = inputElement.val().toString();

		const hasFileNameChanged = pName !== newFileName;
		if (hasFileNameChanged)
		{
			const isValidFileName = this.isValidFileName(newFileName, pParentIDProjectFileFolder);
			if (!isValidFileName)
			{
				return;
			}
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: pIDProjectFile,
			Name: inputElement.val(),
		};

		await this.pict.providers.ProjectFileProvider.updateProjectFile(tmpFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project file name updated',
				type: 'is-success',
			});
			if (pResult)
			{
				$(`#${this.getFileNameDisplayID(pRowID)}`).text(newFileName.toString());
				inputElement.val(newFileName);
				this.setProjectFileNameInCurrentSearchResults(newFileName, pIDProjectFile);
			}
		});

		// Switch back to non-editing mode
		this.projectFileRenameSwitchMode(pRowID);
	}

	/**
	 * Handles the deletion of a project file.
	 * @param {string} pName - The name of the file to delete.
	 * @param {string} pIDProjectFile - The ID of the project file to delete.
	 * @param {Event} event - The event that triggered the delete action.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFileDelete(event, pName, pIDProjectFile)
	{
		// the body and footer templates for the delete modal
		const deleteModalBodyTemplate = /*html*/`
		<span id="DeleteModalBody">
			<div class="cell is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">Delete<strong> ${pName}</strong>?</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to delete or close this modal.</p>
				</div>
			</div>
		</span>`;
		const deleteModalFooterTemplate = /*html*/`
		<div id="DeleteModalFooter" class="buttons is-right">
			<button class="button is-danger is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-danger" type="button" title="Delete Project File" onclick="_Pict.views.ProjectFileSearch.projectFileDeleteHandler(event, ${pIDProjectFile})">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Delete</span>
			</button>
		</div>`;
		// the options for the edit modal
		const deleteModalOptions = {
			title: 'Delete Project File?',
			modalBodyTemplate: deleteModalBodyTemplate,
			modalFooterTemplate: deleteModalFooterTemplate,
			confirmText: 'Delete',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(deleteModalOptions, this.confirmDeleteCallback.bind(this));
	}

	/**
	 * Handles deleting project file
	 * @param {number} pIDProjectFile - The ID of the project file to delete.
	 * @param {Event} event - The event that triggered the save action.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFileDeleteHandler(event, pIDProjectFile)
	{
		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		await this.pict.providers.ProjectFileProvider.handleProjectFileDeletion(pIDProjectFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Deleted',
				type: 'is-success',
			});
			if (pResult)
			{
				this.handleProjectFileSearch(event, null, null);
			}
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Handles saving updated file type for project file
	 * @param {Event} event - The event that triggered the save action.
	 * @param {number} pFileID - The file object being saved.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFileSaveHandler(event, pFileID, pRowID, pFileName, pParentIDProjectFileFolder)
	{
		//save filename changes
		const tmpFileNameInput = /** @type {HTMLTextAreaElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Name-${pFileID}`));
		const newFileName = tmpFileNameInput.value;

		//compare newFileName to previous name and only check for existance or validity if it has changed.
		const hasFileNameChanged = pFileName !== newFileName;
		if (hasFileNameChanged)
		{
			const isValidFileName = this.isValidFileName(newFileName, pParentIDProjectFileFolder);
			if (!isValidFileName)
			{
				return;
			}
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}
		const tmpFileTypeSelect = /** @type {HTMLSelectElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Select-${pFileID}`));
		const tmpFileType = tmpFileTypeSelect.value;
		const tmpCustomFileTypeInput = /** @type {HTMLInputElement} */ (document.getElementById(`ProjectFileSearch-Results-Treeview-List-File-Type-Custom-${pFileID}`));
		const tmpCustomFileType = tmpCustomFileTypeInput.value;

		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: pFileID,
			FileType: tmpFileType === 'Custom' ? tmpCustomFileType : tmpFileType,
			Name: newFileName,
		};

		await this.pict.providers.ProjectFileProvider.updateProjectFile(tmpFile, (/** @type {any} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Updated',
				type: 'is-success',
			});
			if (pResult)
			{
				this.handleProjectFileSearch(event, pRowID, true);
			}
		});
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Add a new project folder.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectRootFolderAddHandler(event, pName, pRowID)
	{
		// the body and footer templates for the confirmation modal
		const addRootFolderModalBodyTemplate = /*html*/`
		<span id="AddRootFolderModalBody">
			<div class="grid">
				<div class="cell is-6">
					<strong>Folder Name</strong>
					<input type="text input is-fullwidth" class="input mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
		       			placeholder="Enter folder name" />
				</div>
			</div>
		</span>`;
		const addRootFolderModalFooterTemplate = /*html*/`
		<div id="AddRootFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project Folder" onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, null, null, document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const addRootFolderModalOptions = {
			title: 'Add Project Folder (root level)?',
			modalBodyTemplate: addRootFolderModalBodyTemplate,
			modalFooterTemplate: addRootFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(addRootFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Add a new project folder.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {number} pParentIDProjectFolder - The IDFile of the parent folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFolderAddHandler(event, pName, pParentIDProjectFolder, pRowID)
	{
		// the body and footer templates for the confirmation modal
		const addFolderModalBodyTemplate = /*html*/`
		<span id="AddFolderModalBody">
			<div class="grid">
				<div class="cell is-6">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name">Folder Name</label>
					<input type="text" class="input is-fullwidth mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
		       			placeholder="Enter folder name" />
				</div>
				<div class="cell is-6">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name-Parent">Parent Folder</label>
					<input type="text" class="input is-fullwidth is-static mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name-Parent"
						value="${pName}" />
				</div>
			</div>
		</span>`;
		const addFolderModalFooterTemplate = /*html*/`
		<div id="AddFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Project Folder" onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, null, ${pParentIDProjectFolder}, document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const addFolderModalOptions = {
			title: 'Add Project Folder (to parent folder)?',
			modalBodyTemplate: addFolderModalBodyTemplate,
			modalFooterTemplate: addFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(addFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Edit a project folder name.
	 * @param {Event} event - The event that triggered the function.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {void}
	 */
	// @ts-ignore
	// @ts-ignore
	projectFolderEditHandler(event, pName, pIDProjectFileFolder, pParentIDProjectFileFolder, pRowID)
	{
		// the body and footer templates for the rename folder modal
		const renameFolderModalBodyTemplate = /*html*/`
		<span id="RenameFolderModalBody">
			<div class="grid">
				<div class="cell is-12">
					<label class="label" for="ProjectFileSearch-Results-Treeview-List-Folder-Name">Folder Name</label>
					<input type="text input is-fullwidth" class="input mt-2"
		       			id="ProjectFileSearch-Results-Treeview-List-Folder-Name"
						value="${pName}"
		       			placeholder="Enter folder name" />
				</div>
			</div>
		</span>`;
		const renameFolderModalFooterTemplate = /*html*/`
		<div id="RenameFolderModalFooter" class="buttons is-right">
			<button class="button is-primary is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" 
					type="button" 
					title="Save Project Folder" 
					onclick="_Pict.views.ProjectFileSearch.projectFolderSaveHandler(event, '${pIDProjectFileFolder}', '${pParentIDProjectFileFolder}', document.getElementById('ProjectFileSearch-Results-Treeview-List-Folder-Name').value, '${pRowID}')">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the edit modal
		const renameFolderModalOptions = {
			title: 'Rename Project Folder?',
			modalBodyTemplate: renameFolderModalBodyTemplate,
			modalFooterTemplate: renameFolderModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(renameFolderModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// render the current state of the project file panel
			this.pict.views.ProjectFileSearch.renderAsync(() =>
			{
				this.pict.log.info('Project File Panel Rendered');
			});
		}
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmDeleteCallback(event)
	{
		if (event)
		{
			// render the current state of the project file panel
			this.pict.views.ProjectFileSearch.renderAsync(() =>
			{
				this.pict.log.info('Project File Panel Rendered');
			});
		}
	}

	/**
	 * Ensures a file name is unique among all files recursively under a given parent folder.
	 * Appends `_1`, `_2`, etc. if needed.
	 *
	 * @param {Array} folders - Array of root folder objects.
	 * @param {string} pNewFileName - Desired file name to insert.
	 * @param {any} pParentID - ID of the folder to start checking from (null/0 = root).
	 * @return {string} - A unique file name.
	 */
	checkFileNameExists(folders, pNewFileName, pParentID = null)
	{
		const nameRegex = /^(.*?)(\.[^.]*)?$/; // base + optional extension

		// Safer findParentNode
		function findParentNode(nodes, id)
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip undefined or null nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findParentNode(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		}

		let parentNode;
		if (!pParentID || parseInt(pParentID) === 0)
		{
			parentNode = { Children: folders }; // virtual root node
		}
		else
		{
			parentNode = findParentNode(folders, parseInt(pParentID));
			if (!parentNode) return pNewFileName;
		}

		function collectAllFileNames(node, resultSet)
		{
			if (!node || !node.Children || !Array.isArray(node.Children)) return;

			for (const child of node.Children)
			{
				if (!child) continue; // skip invalid
				if (child.IsFolder)
				{
					collectAllFileNames(child, resultSet);
				}
				else
				{
					if (child.Name)
					{
					resultSet.add(child.Name.toLowerCase());
					}
				}
			}
		}

		const existingNames = new Set();
		collectAllFileNames(parentNode, existingNames);

		if (!existingNames.has(pNewFileName.toLowerCase()))
		{
			return pNewFileName;
		}

		const match = pNewFileName.match(nameRegex);
		const base = match[1];
		const ext = match[2] || '';
		let counter = 1;
		let newName;

		do
		{
			newName = `${base}_${counter}${ext}`;
			counter++;
		} while (existingNames.has(newName.toLowerCase()));

		return newName;
	}


	/**
	 * Recursively checks if a folder name exists under a given parent folder node.
	 * @param {Array} folders - Array of root folders (tree structure).
	 * @param {string} pNewFolderName - Name to check.
	 * @param {any} pParentID - Parent folder ID to start from; null or 0 means root level.
	 * @return {boolean} True if folder name exists under that parent.
	 */
	checkFolderNameExists(folders, pNewFolderName, pParentID = null)
	{
		const lowerName = pNewFolderName.toLowerCase();

		// Safer findParent function
		const findParent = (nodes, id) =>
		{
			if (!nodes || !Array.isArray(nodes)) return null;

			for (const node of nodes)
			{
				if (!node) continue; // skip null/undefined nodes
				if (node.ID === id) return node;
				if (node.Children && Array.isArray(node.Children) && node.Children.length > 0)
				{
					const found = findParent(node.Children, id);
					if (found) return found;
				}
			}
			return null;
		};

		let parentNode;
		if (!pParentID || parseInt(pParentID) === 0)
		{
			parentNode = { Children: folders }; // virtual root node
		}
		else
		{
			parentNode = findParent(folders, parseInt(pParentID));
			if (!parentNode) return false; // parent not found
		}

		const checkChildren = (nodes) =>
		{
			if (!nodes || !Array.isArray(nodes)) return false;

			for (const node of nodes)
			{
				if (!node) continue; // skip invalid
				if (node.IsFolder && node.Name && node.Name.toLowerCase() === lowerName)
				{
					return true;
				}
			}
			return false;
		};

		// Only check immediate children of parent node
		return checkChildren(parentNode.Children);
	}


	/** Handles the addition of a project file.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/
	projectRootFileAddHandler(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.SelectedFileFolder = 0; // 0 indicates root folder
		this.pict.providers.ProjectFileProvider.openSearchPanel(this.pict.views.ProjectFileSearch, 'Project Files', 'add-to-root');
	}

	/** Handles the addition of a project file.
	* @param {Object} pIDObservation - The Observation object.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/

	/** Handles the addition of a project file.
	* @param {Event} event - The event that triggered the function.
	* @param {string} pName - The name of the project folder.
	* @param {number} pIDProjectFileFolder - The ID of the project folder.
	* @return {void}
	*/
	projectFileAddHandler(event, pName, pIDProjectFileFolder)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		this.SelectedFileFolder = pIDProjectFileFolder;
		this.SelectedFileFolderName = pName;
		this.pict.providers.ProjectFileProvider.openSearchPanel(this.pict.views.ProjectFileSearch, 'Project Files', 'add-to-folder');
	}

	/** Handles the addition of a project file.
	* @param {Object} pIDObservation - The Observation object.
	* @param {Event} event - The event that triggered the function.
	* @return {void}
	*/

	addObservationToProjectFolderRecord(pIDObservation, event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		if (!pIDObservation || !pIDObservation.IDObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No observation selected to add to project folder',
				type: 'is-danger',
			});
			return;
		}

		let checkFileName = '';
		if (pIDObservation?.Details?.Image?.Datum?.FileName)
		{
			checkFileName = pIDObservation?.Details?.Image?.Datum?.FileName;
		}
		else if (pIDObservation?.Name)
		{
			checkFileName = pIDObservation?.Name;
		}

		const updatedFileName = this.checkFileNameExists(this.CurrentSearchResults, checkFileName, this.SelectedFileFolder);

		this.pict.log.info('Adding observation to project folder record:', pIDObservation, this.SelectedFileFolder);
		// map file object with correct db properties
		const tmpFile = {
			IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
			IDProjectFile: 0,
			IDObservation: pIDObservation.IDObservation,
			IDProjectFileFolder: this.SelectedFileFolder,
			Name: updatedFileName || pIDObservation.Name,
			FileType: pIDObservation.ObservationType,
		};
		this.pict.providers.ProjectFileProvider.addProjectFile(tmpFile, (/** @type {{ IDProjectFile: any; IDObservation: any; }} */ pResult) =>
		{
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
			this.pict.views.HeadlightPanels.toast({
				message: 'Project File Added',
				type: 'is-success',
			});
			if (pResult)
			{
				const _RowID = `File-${pResult.IDProjectFile}_${pResult.IDObservation}`;
				this.handleProjectFileSearch(event, _RowID, true);
			}
		});
	}

	/**
	 * Handles saving updated file type for project file
	 * @param {Event} event - The event that triggered the save action.
	 * @param {string} pIDProjectFileFolder - The ID of the project folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent project folder.
	 * @param {string} pNewFolderName - The name of the new folder.
	 * @param {string} pRowID - The ID of the row in the treeview.
	 * @return {Promise<void>}
	 * @async
	 */
	async projectFolderSaveHandler(event, pIDProjectFileFolder, pParentIDProjectFileFolder, pNewFolderName, pRowID)
	{
		const existingFolderName = this.checkFolderNameExists(this.CurrentSearchResults, pNewFolderName, pParentIDProjectFileFolder);

		if (existingFolderName)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'A folder with this name already exists',
				type: 'is-danger',
			});
			return;
		}

		if (event)
		{
			if (event.currentTarget instanceof HTMLElement)
			{
				event.currentTarget.classList.add('is-loading');
			}
		}

		// safe guard for no changes to save
		// todo: add disable flag to button that re-evals until something changes
		if (!pIDProjectFileFolder && !pParentIDProjectFileFolder && !pNewFolderName)
		{
			return;
		}

		// if we're renaming the folder, update the row ID to match the new name
		if (pIDProjectFileFolder)
		{
			pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pIDProjectFileFolder}`;
		}

		if (pIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: parseInt(pIDProjectFileFolder),
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};
			await this.pict.providers.ProjectFileProvider.updateProjectFolder(tmpFolder, (/** @type {any} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Updated',
					type: 'is-success',
				});
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
			this.pict.fable.services.HeadlightModal.dismissModals();
			return;
		}
		else if (pParentIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: 0,
				ParentIDProjectFileFolder: parseInt(pParentIDProjectFileFolder),
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};

			await this.pict.providers.ProjectFileProvider.addProjectFolder(tmpFolder, (/** @type {{ IDProjectFileFolder: any; }} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Added',
					type: 'is-success',
				});
				// if we're creating a new folder, update the row ID to match the new name
				pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pResult.IDProjectFileFolder}`;
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
		}
		else if (!pParentIDProjectFileFolder && !pIDProjectFileFolder)
		{
			// map folder object with correct db properties
			const tmpFolder = {
				IDProject: this.AppData?.DocumentData?.ReportData?.IDProject,
				IDProjectFileFolder: 0,
				ParentIDProjectFileFolder: 0,
				Name: pNewFolderName.replace(/['"]/g, '_'),
			};

			await this.pict.providers.ProjectFileProvider.addProjectFolder(tmpFolder, (/** @type {{ IDProjectFileFolder: any; }} */ pResult) =>
			{
				this.pict.providers.UtilityProvider.removeAllLoadingClasses();
				this.pict.views.HeadlightPanels.toast({
					message: 'Project Folder Added',
					type: 'is-success',
				});
				// if we're creating a new folder, update the row ID to match the new name
				pRowID = `${pNewFolderName.trim().replace(/['"]/g, '_').replace(/ /g, '_')}_${pResult.IDProjectFileFolder}`;
				if (pResult)
				{
					this.handleProjectFileSearch(event, pRowID, false);
				}
			});
		}
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	/**
	 * Renders the file type options for a select dropdown.
	 * Ensures the selectedTypeID is always included, even if it's not in the default list.
	 * @param {string} selectedTypeID - The ID of the currently selected file type.
	 * @return {string} The HTML string for the file type options.
	 */
	renderFileTypeOptions(selectedTypeID)
	{
	/** @type {{ id: string, text: string }[]} */
		let options = this.FileTypes;

		// Check if selectedTypeID exists in the options list
		const selectedExists = options.some((opt) => opt.id === selectedTypeID);

		// If it doesn't exist, add a custom option for it
		if (!selectedExists && selectedTypeID)
		{
			options = [
				...options,
				{ id: selectedTypeID, text: `${selectedTypeID}` },
			];
		}

		return options.map((opt) =>
		{
			const isSelected = opt.id === selectedTypeID ? 'selected' : '';
			const isDisabled = opt.id === '' ? 'disabled selected' : '';
			return `
			<option value="${opt.id}" id="${opt.id}" ${isSelected} ${isDisabled}>
				${opt.text}
			</option>`;
		}).join('');
	}


	/**
	 * Toggle the visibility of Project File Folder
	 * @param {*} event - the event object
	 * @param {string} _RowID - the name and id of the folder
	 * @return {void}
	 */
	toggleSectionVisibility(event, _RowID)
	{
		// find the icon in the button and swap it out
		const tmpIcon = event?.currentTarget?.querySelector('i') || event?.parentElement?.currentTarget?.querySelector('i');
		if (!tmpIcon)
		{
			return;
		}
		if (tmpIcon.classList.contains('fa-folder-open'))
		{
			tmpIcon.classList.remove('fa-folder-open');
			tmpIcon.classList.add('fa-folder-closed');
		}
		else
		{
			tmpIcon.classList.remove('fa-folder-closed');
			tmpIcon.classList.add('fa-folder-open');
		}
		// toggle the visibility of the child folders
		const tmpElementID = `ProjectFileSearch-Results-Treeview-Child-${_RowID}`;
		// if the element is not found, return
		if (!document.getElementById(tmpElementID))
		{
			this.log.error(`Element with ID ${tmpElementID} not found`);
			return;
		}
		document.getElementById(tmpElementID)?.classList.toggle('is-hidden', document.getElementById(tmpElementID)?.classList.contains('is-hidden') ? false : true);
	}

	/**
	 * Toggle the visibility of all sections
	 * @param {*} pVisibility - the visibility to set
	 * @return {void}
	 */
	toggleAllSectionVisibility(pVisibility)
	{
		const tmpSections = document.querySelectorAll('.panel-block-group');
		tmpSections.forEach((section) =>
		{
			if (pVisibility === 'open')
			{
				section.classList.remove('is-hidden');
			}
			else
			{
				section.classList.add('is-hidden');
			}
		});
		const tmpIcons = document.querySelectorAll('.panel-block-group-header i');
		tmpIcons.forEach((icon) =>
		{
			if (icon.classList.contains('fa-folder-open') && pVisibility === 'close')
			{
				icon.classList.remove('fa-folder-open');
				icon.classList.add('fa-folder-closed');
			}
			else
			{
				icon.classList.remove('fa-folder-closed');
				icon.classList.add('fa-folder-open');
			}
		});
	}

	//-----TODO: Extract into it's own provider once nailed down and make dynamic ------ BEGINNING

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pDate - The date of the file.
	 * @param {string} pName - The name of the file.
	 * @param {string} pFileID - The ID of the file.
	 * @param {string} pFileType - The type of the file.
	 */
	handleFileActionPopover(id, pRowID, pDate, pName, pFileID, pFileType)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-FILE-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for file menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-File-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Date: pDate,
				Name: pName,
				ID: pFileID,
				Type: pFileType,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 * @param {string} pParentIDProjectFileFolder - The ID of the parent folder.
	 */
	handleFolderActionPopover(id, pRowID, pName, pIDProjectFileFolder, pParentIDProjectFileFolder)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-FOLDER-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for folder menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-Folder-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Name: pName,
				ID: pIDProjectFileFolder,
				ParentFolder: pParentIDProjectFileFolder,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	/**
	 * Add a dropdown menu to the toggle button for a file row.
	 * @param {string} id - The ID of the file.
	 * @param {string} pRowID - The ID of the row.
	 * @param {string} pName - The name of the folder.
	 * @param {string} pIDProjectFileFolder - The ID of the folder.
	 */
	handleRootActionPopover(id, pRowID, pName, pIDProjectFileFolder)
	{
		const tmpMenuElement = document.getElementById(`PANEL-MENU-BUTTON-FOR-ROOT-${pRowID}`);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${tmpMenuElement} not found for root menu`);
			return;
		}

		const popoverConfiguration = {
			PopoverTemplateHash: 'ProjectFileSearch-Results-Treeview-Root-ActionMenu',
			PopoverDestinationAddress: id,
			PopoverTemplateRecord:
			{
				Name: pName,
				ID: pIDProjectFileFolder,
				_RowID: pRowID,
			},
			theme: 'dropdown-dark',
		};
		// create the popover menu
		this.fable.HeadlightPopover.createPopover(popoverConfiguration);
	}

	//-----TODO: Extract into it's own provider once nailed down and make dynamic ------ END
}

module.exports = ProjectFileSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectFileSearch',
	DefaultRenderable: 'ProjectFileSearch-Wrapper',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
		[
			{
				Hash: 'ProjectFileSearch-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-ProjectFileSearchPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event)">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('right')">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header-Icon" class="fas fa-fw fa-files" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-ProjectFileSearchPanel-Observation-Header-Title" class="mr-3">Project Files</span>
					</p>
					<div class="panel-content nested-scroll-content">
						<div id="HeadlightPanels-ProjectFileSearch-Entry">
							{~T:ProjectFileSearch-Entry~}
						</div>
						<div id="HeadlightPanels-ProjectFileSearch-Content" class="has-bottom-navbar-offset">
							{~T:ProjectFileSearch-Project-Container~}
							{~T:ProjectFileSearch-Results~}
						</div>
					</div>
				</article>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry',
				Template: /*html*/`
				<div id="ProjectFileSearch-SearchEntry" class="container">
					<form autocomplete="off" role="observation-search" onsubmit="_Pict.views.ProjectFileSearch.handleProjectFileSearch(event, null, null);">
						<div class="px-4 pt-4" data-collapsible-content="ProjectFileSearchFilters">
							<div class="columns is-hidden">
								{~T:ProjectFileSearch-Entry-CurrentPage~}
								{~T:ProjectFileSearch-Entry-PageSize~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-SearchText~}
							</div>
							<div class="columns">
								{~T:ProjectFileSearch-Entry-SearchFolder~}
							</div>
						</div>
						<div class="buttons m-3 mb-5" data-theme="dark">
							<button
								type="button"
								class="button is-primary" 
								title="Add Folder" 
								onclick="_Pict.views.ProjectFileSearch.projectRootFolderAddHandler(event, '{~D:Record.Name~}', '{~D:Record._RowID~}')">
								<span class="icon">
									<i class="fa fa-fw fa-folder-plus"></i>
								</span>
								<span class="icon-text">Add Folder</span>
							</button>
							<button
								type="button" 
								class="button is-primary" 
								title="Add File" 
								onclick="_Pict.views.ProjectFileSearch.projectRootFileAddHandler(event)">
								<span class="icon">
									<i class="fa fa-fw fa-file-plus"></i>
								</span>
								<span class="icon-text">Add File</span>
							</button>
							<button 
								type="button"
								id="ProjectFileSearch-ToggleButton"
								class="button is-primary is-soft" 
								title="Open search panel" 
								data-collapsible-toggle="ProjectFileSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ProjectFileSearchFilters')">
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span class="icon-text">Set Filters</span>
							</button>
							<button 
								type="button"
								class="button is-primary is-soft" 
								title="Reset filters" 
								id="ProjectFileSearch-ResetButton" 
								onclick="_Pict.views.ProjectFileSearch.resetSearchFilters()">
								<span class="icon">
									<i class="fas fa-fw fa-undo mr-1"></i>
								</span>
								<span class="icon-text">Clear Filters</span>
							</button>
							<button
								type="submit" 
								id="ProjectFileSearch-SearchButton"
								class="button is-primary" 
								title="Search project files">
								<span class="icon">
									<i class="fas fa-fw fa-search mr-1"></i>
								</span>
								<span class="icon-text">Search Project Files</span>
							</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ProjectFileSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="ProjectFileSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('CurrentPage')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ProjectFileSearch-PageSize" class="block">Page Size</label>
						<input 
							id="ProjectFileSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('PageSize')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ProjectFileSearch-Projects">Project</label>
						<div class="control select is-fullwidth">
							<select 
								id="ProjectFileSearch-Projects" 
								onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('Projects');_Pict.views.ProjectFileSearch.handleProjectFileSearch(event, null, null);"
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ProjectFileSearch-SearchText" class="block">File Search</label>
					<input 
						id="ProjectFileSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Entry-SearchFolder',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ProjectFileSearch-SearchFolder" class="block">Folder Search</label>
					<input
						id="ProjectFileSearch-SearchFolder"
						type="text"
						class="input"
						placeholder="Enter the name of the folder to search"
						onchange="_Pict.views.ProjectFileSearch.updateSearchFilterValue('SearchFolder')"
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-Container" class="container table-container">
					{~TIfAbs:ProjectFileSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Container:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span>We could not find any project files based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Type</th>
							<th>File Name</th>
							{~T:ProjectFileSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="ProjectFileSearch-ResultsEntries">
						{~TS:ProjectFileSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Row',
				Template: /*html*/`
				<tr class="is-clickable">
					<td class="is-vcentered" onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}">
						{~TIfAbs:ProjectFileSearch-Results-ProjectFileFolder-Empty:Record:Record.IDProjectFileFolder^==^0~}
						{~TIfAbs:ProjectFileSearch-Results-ProjectFileFolder:Record:Record.IDProjectFileFolder^>^0~}
					</td>
					<td class="is-vcentered" onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}">{~D:Record.Name~}</td>
					{~T:ProjectFileSearch-Results-Extra-Row:Record~}
				</tr>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Extra-Header',
				Template: /*html*/``,
			},
			{
				Hash: 'ProjectFileSearch-Results-Extra-Row',
				Template: /*html*/``,
			},
			{
				Hash: 'ProjectFileSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder',
				Template: /*html*/`{~E:ProjectFileFolder^Record.IDProjectFileFolder^ProjectFileSearch-Results-ProjectFileFolder-Name^~}`,
			},
			/* ----- start Tree View ---- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Container',
				Template: /*html*/`
				<div class="treeview treeview overflow-scroll-container-for-search-results nested-scroll-content has-bottom-navbar-offset">
					{~TS:ProjectFileSearch-Results-Treeview:Record.CurrentSearchResults~}
				</div>`,
			},
			/* ----- Tree View > first layer (results or empty check) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview',
				Template: /*html*/`
					{~T:ProjectFileSearch-Results-Treeview-Content:Record~}
				`,
			},
			/* ----- Tree View > second layer (empty) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span>We could not find any project files based on the current search criteria.</span>
					</p>
				</div>`,
			},
			/* ----- Tree View > second layer (search results processed list) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Content',
				Template: /*html*/`
				{~TIfAbs:ProjectFileSearch-Results-Treeview-File:Record:Record.IsFolder^==^0~}
				{~TIfAbs:ProjectFileSearch-Results-Treeview-FolderList:Record:Record.IsFolder^==^1~}`,
			},
			/* ----- Tree View > third layer (folder of files) ----- */
			{
				Hash: 'ProjectFileSearch-Results-Treeview-FolderList',
				Template: /*html*/`
				<div
					id="ProjectFileSearch-Results-Treeview-{~D:Record._RowID~}"
					class="panel-block panel-block-group-header is-relative is-clickable px-1 py-0" 
					onclick="_Pict.views.ProjectFileSearch.toggleSectionVisibility(event, '{~D:Record._RowID~}')">
					<a class="button is-ghost has-text-primary-60">
						<span class="icon">
							<i class="fa fa-fw fa-folder-open"></i>
						</span>
					</a>
					<h4 class="title is-size-6 label has-text-text-90">{~D:Record.Name~}</h4>
					{~T:ProjectFileSearch-Results-Treeview-Folder-Action-Button~}
				</div>
				<div id="ProjectFileSearch-Results-Treeview-Child-{~D:Record._RowID~}" class="is-hoverable is-hidden panel-block-group">
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Folder-Content:Record:Record.Children.length^>^0~}
					{~TIfAbs:ProjectFileSearch-Results-Treeview-Folder-Empty:Record:Record.Children.length^==^0~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File',
				Template: /*html*/`
				<div 
					id="ProjectFileSearch-Results-Treeview-Child-{~D:Record._RowID~}"
					class="panel-block is-file-row is-clickable py-2"
					title="View File Details" 
					onclick="_Pict.views.ProjectFileSearch.handleProjectFilesDetailsClick(event, '{~D:Record.IDObservation~}', 'ProjectFiles')" data-observation-id="{~D:Record.IDObservation~}"
					data-observation-id="{~D:Record.IDObservation~}"
				>
					<span class="icon has-text-primary-90">
						<i class="fa fa-fw fa-file"></i>
					</span>
					<span id="DISPLAY-FOR-{~D:Record._RowID~}" class="has-text-text-90">
						<span id="NAME-FOR-{~D:Record._RowID~}">
							{~D:Record.Name~}
						</span>
						{~T:ProjectFileSearch-Results-Treeview-File-Action-Button~}
					</span>
					<span id="EDIT-FOR-{~D:Record._RowID~}" class="is-hidden columns is-align-self-center" onclick="event.stopPropagation();">
						<span class="column is-three-fifths py-0">
							<input class="input is-normal" id="INPUT-FOR-{~D:Record._RowID~}" type="text" value="{~D:Record.Name~}" />
						</span>
						<span class="column is-align-content-center py-0">
							<button
								type="button"
								class="button is-small is-link is-soft is-outlined"
								onclick="_Pict.views.ProjectFileSearch.projectFileRenameSwitchMode('{~D:Record._RowID~}')"
								title="Cancel"
							>
								<i id="ObservationDetails-Content-Save-Icon" class="fas fa-fw fa-times"></i>
							</button>
							<button
								type="button"
								class="button is-small is-link"
								onclick="_Pict.views.ProjectFileSearch.projectFileRename(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}', '{~D:Record._RowID~}')"
								title="Save"
							>
								<i class="fa fa-fw fa-save"></i>
							</button>
						</span>
					</span>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Action-Button',
				Template: /*html*/`
				<button
                    id="PANEL-MENU-BUTTON-FOR-FILE-{~D:Record._RowID~}"
                    class="button icon-button is-ghost has-text-primary-60 p-0 ml-3"
					style="float: none"
					title="Actions"
                    type="button"
                    aria-haspopup="true"
                    onmouseover="_Pict.views.ProjectFileSearch.handleFileActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Date~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.Type~}')"
                    onclick="_Pict.views.ProjectFileSearch.handleFileActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Date~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.Type~}'); event.stopPropagation();">
                    <span class="icon is-small">
                        <i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
                    </span>
                </button>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ProjectFileSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_project-file">
						<a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFileEditHandler(event, '{~DateFormat:Record.Date^YYYY-MM-DD - HH:mm a~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record._RowID~}', '{~D:Record.Type~}', '{~D:Record.ParentFolder~}')">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span>Edit</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-file">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFileDelete(event, '{~D:Record.Name~}', '{~D:Record.ID~}')">
							<span class="icon">
								<i class="fas fa-trash"></i>
							</span>
							<span>Delete</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-file">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFileRenameSwitchMode('{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-pen-field"></i>
							</span>
							<span>Rename File</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Action-Button',
				Template: /*html*/`
				<button
                    id="PANEL-MENU-BUTTON-FOR-FOLDER-{~D:Record._RowID~}"
                    class="button icon-button is-ghost has-text-primary-60 p-0 ml-3"
					style="float: none"
					title="Actions"
                    type="button"
                    aria-haspopup="true"
                    onmouseover="_Pict.views.ProjectFileSearch.handleFolderActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}')"
                    onclick="_Pict.views.ProjectFileSearch.handleFolderActionPopover(id, '{~D:Record._RowID~}', '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}')">
                    <span class="icon is-small">
                        <i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
                    </span>
                </button>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ProjectFileSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_project-folder">
                        <a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFileAddHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}')">
                            <span class="icon">
                                <i class="fas fa-file-plus"></i>
                            </span>
                            <span>Add File</span>
                        </a>
                    </li>
					<li class="list-menu-item mode_project-folder">
						<a class="move-table-row-down-button" onclick="_Pict.views.ProjectFileSearch.projectFolderAddHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-folder-plus"></i>
							</span>
							<span>Add Folder</span>
						</a>
					</li>
					<li class="list-menu-item mode_project-folder">
						<a class="delete-table-row-button" onclick="_Pict.views.ProjectFileSearch.projectFolderEditHandler(event, '{~D:Record.Name~}', '{~D:Record.ID~}', '{~D:Record.ParentFolder~}', '{~D:Record._RowID~}')">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span>Rename Folder</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Visibility-Buttons',
				Template: /*html*/`
				<div class="buttons mx-4 mb-0">
					<button type="button" class="button is-ghost has-text-primary-soft" title="Expand all" onclick="_Pict.views.ProjectFileSearch.toggleAllSectionVisibility('open')">
						<span class="icon">
							<i class="fa fa-fw fa-expand"></i>
						</span>
						<span class="icon-text">Expand All</span>
					</button>
					<button type="button" class="button is-ghost has-text-primary-soft" title="Collapse all" onclick="_Pict.views.ProjectFileSearch.toggleAllSectionVisibility('close')">
						<span class="icon">
							<i class="fa fa-fw fa-compress"></i>
						</span>
						<span class="icon-text">Collapse All</span>
					</button>
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Type-Selector',
				Template: /*html*/`
                <p id="ProjectFileSearch-Results-Treeview-File-Type-Readonly-{~D:Record.ID~}">
					<span class="subtitle is-6 has-text-text-90">{~D:Record.Type~}</span>
				</p>
				<p id="ProjectFileSearch-Results-Treeview-File-Type-Edit-{~D:Record.FolderID~}" class="control select is-fullwidth is-relative is-hidden">
					<select 
						id="ProjectFileSearch-Results-Treeview-File-Type-Select-{~D:Record.ID~}"
						class="input mr-2"
						onchange="_Pict.views.ProjectFileSearch.handleFileTypeChange(event, '{~D:Record.ID~}')">
						{~TS:ProjectFileSearch-Results-Treeview-File-Type-Options:Context[0].Context[0].FileTypes~}
					</select>
					<input 
						type="text" 
						class="input mt-2 is-hidden"
		       			id="ProjectFileSearch-Results-Treeview-File-Type-Custom-{~D:Record.ID~}"
		       			placeholder="Enter custom file type" />
				</p>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-File-Type-Options',
				Template: /*html*/`<option value="{~D:Record.id~}">{~D:Record.text~}</option>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Content',
				Template: /*html*/`
				<div class="treeview-folder">
					{~TS:ProjectFileSearch-Results-Treeview-Content:Record.Children~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-Treeview-Folder-Empty',
				Template: /*html*/`
                <div class="notification mx-3 p-2 empty-message has-background-text-30">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa-regular fa-info-circle"></i>
						</span>
						<span class="icon-text">This folder is empty.</span>
					</p>
				</div>`,
			},
			// TODO: Project File Paths for Name: https://bridge.qa.headlight.com/1.0/ImportantProjectFiles/10337/ (which does one folder at a time)
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFileFolder-Empty',
				Template: /*html*/`/`,
			},
			{
				Hash: 'ProjectFileSearch-Project-Container',
				Template: /*html*/`
				<div id="ProjectFileSearch-Project-Container" class="columns has-background-text-20">
					<div id="ProjectFileSearch-Project-Selected" class="column is-hidden">
						<span class="title is-6 has-text-white ml-4">{~D:AppData.DocumentData.ReportData.Name~}</span>
					</div>
					<div id="ProjectFileSearch-Project-Empty" class="column is-hidden">
						{~T:ProjectFileSearch-Project-Empty~}
					</div>
					{~T:ProjectFileSearch-Results-Visibility-Buttons~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFiles-Root',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-ProjectFile-Root" class="column">
					{~TS:ProjectFileSearch-Results-ProjectFile-Root-Files:Record.Children~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Results-ProjectFile-Root-Files',
				Template: /*html*/`
				<div id="ProjectFileSearch-Results-ProjectFile-Root-File-{~D:Record.IDProjectFile~}" class="column">
					{~D:Record.Name~}
				</div>`,
			},
			{
				Hash: 'ProjectFileSearch-Project-Empty',
				Template: /*html*/`<p class="title is-5 has-text-white" >No project selected. These are all the files you have access to.</p>`,
			},
			/* ----- end Tree View ----- */
		],
	Renderables:
		[
			{
				RenderableHash: 'ProjectFileSearch-Wrapper',
				TemplateHash: 'ProjectFileSearch-Wrapper',
				DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
			},
			{
				RenderableHash: 'ProjectFileSearch-Entry-ProjectSelector',
				TemplateHash: 'ProjectFileSearch-Entry-ProjectSelector',
				DestinationAddress: '#ProjectFileSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				TemplateHash: 'ProjectFileSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#ProjectFileSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'ProjectFileSearch-Results',
				TemplateHash: 'ProjectFileSearch-Results',
				DestinationAddress: '#ProjectFileSearch-Results-Container',
			},
			{
				RenderableHash: 'ProjectFileSearch-Pagination',
				TemplateHash: 'ProjectFileSearch-Pagination',
				DestinationAddress: '#ProjectFileSearch-Pagination-Container',
			},
		],
};

},{"pict-view":733}],1567:[function(require,module,exports){
const PictViewClass = require('pict-view');
const HeadlightSampleScanningBundle = require('headlight-sample-scanning');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
 * The panels' left-hand "Scan Samples" panel: the panel chrome, the camera and label printing. Everything else
 * (location, settings, moves, lists, and taking scans from the app's HeadlightQR provider while open) is the
 * SampleScanning provider and view from headlight-sample-scanning, which any app can mount without the panels.
 */
class QRPanel extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.cameraOpen = false;
		this.toggleRunning = false;
		/** @type {boolean|undefined} the switch setting asked for by open(), applied when the panel draws */
		this.pendingSaveEachScan = undefined;
		this.scanningOptions = { SampleScanning: { RemoveFromCurrentLocation: pOptions.removeFromCurrentLocation ?? true } };
		/** @type {Array<(pMove: Record<string, any>) => any>} */
		this.movedListeners = [];
	}

	/** @return {any} the SampleScanning provider, attached on first use */
	get scanning()
	{
		return new HeadlightSampleScanningBundle(this.pict).attach(this.scanningOptions);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.cameraOpen)
		{
			// The camera's box was just redrawn.
			this.cameraOpen = false;
			this.pict.providers.QRCodeProvider.closeScanner().catch((e) =>
			{
				console.log('Error stopping qr code scanner: ', e);
			});
		}
		const tmpScanning = this.scanning;
		tmpScanning.connect(
			{
				notify: (pToast) => this.pict.views.HeadlightPanels.toast(pToast),
				printLabel: (pSample) => this.printEntityLabel('Sample', pSample.QRCode),
				moved: (pMove) => this.reportMoved(pMove),
				// Samples marked received changed status, so a page showing one refreshes as it does for a move.
				received: (pMark) => this.reportMoved({ Location: null, Moved: pMark.Received, Failed: pMark.Failed, Via: 'received' }),
				camera: { toggle: (pContainerID) => this.toggleCamera(pContainerID), isOpen: () => this.cameraOpen },
			});
		tmpScanning.open({ SaveEachScan: this.pendingSaveEachScan, DestinationAddress: '#QRPanel-Body' });
		// The panels nav opens this pane by rendering it, not through open(); take the scanner either way.
		tmpScanning.listen(this.pict.providers.HeadlightQR);
		this.pendingSaveEachScan = undefined;
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Opens the scanner in the left hand panel.
	 * @param {'putaway'|'receive'} [pMode] - 'receive' turns on saving each scan, 'putaway' turns it off; left out,
	 *   the setting stays as this device last had it.
	 */
	open(pMode)
	{
		this.pendingSaveEachScan = (pMode === 'receive') ? true : ((pMode === 'putaway') ? false : undefined);
		this.pict.views.HeadlightPanels.handlePanelToggle('QRPanel', 'open');
		this.pict.views.HeadlightPanels.setPanelCustomWidth('left', 40);
	}

	closeHandler()
	{
		console.log('Closing QR Code Panel.');
		this.scanning.close();
		this.cameraOpen = false;
		this.pict.providers.QRCodeProvider.closeScanner();
	}

	/**
	 * Hear about moves made from this panel, e.g. so a page showing one of the moved samples can refresh. Samples marked
	 * received come through here too (Via 'received', Moved = the samples marked, no Location).
	 * @param {(pMove: { Location: Record<string, any>|null, Moved: Array<Record<string, any>>, Failed: Array<Record<string, any>>, Via?: string }) => any} fListener
	 * @return {() => void} removes the listener
	 */
	addMovedListener(fListener)
	{
		this.movedListeners.push(fListener);
		return () =>
		{
			const tmpIndex = this.movedListeners.indexOf(fListener);
			if (tmpIndex >= 0)
			{
				this.movedListeners.splice(tmpIndex, 1);
			}
		};
	}

	/**
	 * Pass a move on to every listener; one that fails is logged and doesn't stop the others.
	 * @param {{ Location: Record<string, any>, Moved: Array<Record<string, any>>, Failed: Array<Record<string, any>> }} pMove
	 * @return {Promise<void>}
	 */
	async reportMoved(pMove)
	{
		for (const fListener of this.movedListeners.slice())
		{
			try
			{
				await fListener(pMove);
			}
			catch (pError)
			{
				this.log.error(`Scan Samples panel: a move listener failed: ${(pError && pError.message) || pError}`);
			}
		}
	}

	/**
	 * Opens or closes the camera scanner in the given container.
	 * @param {string} pContainerID
	 * @return {Promise<boolean>} whether the camera is now open
	 */
	async toggleCamera(pContainerID)
	{
		// Don't run this function again until the ui transition is finished.
		if (this.toggleRunning)
		{
			return this.cameraOpen;
		}
		this.toggleRunning = true;
		this.cameraOpen = !this.cameraOpen;
		try
		{
			if (this.cameraOpen)
			{
				await this.pict.providers.QRCodeProvider.openScanner(pContainerID, { isPhoneDevice: this.pict.services.HeadlightPanels.isPhoneDevice });
			}
			else
			{
				await this.pict.providers.QRCodeProvider.closeScanner();
			}
		}
		catch (e)
		{
			console.log('Error toggling the qr code scanner: ', e);
		}
		this.toggleRunning = false;
		return this.cameraOpen;
	}

	/**
	 * This method is used to handle the closing of the panel.
	 * @param {Event} [event] - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
	}

	/**
	 * Print an entity's QR label, loading the customer's label configuration first.
	 *
	 * Without the ensure these buttons print the built-in fallback layout: the panels app never loaded the
	 * printable manifests, so QRCodeProvider.typeConfig was empty and per-customer printer configuration
	 * (PrintStyle, title, field rows/columns) was silently ignored.
	 * @param {String} pEntity - The entity type being printed ('Sample' | 'Location')
	 * @param {String} pQRCode - The entity's QR code
	 * @return {Promise<void>}
	 * @async
	 */
	async printEntityLabel(pEntity, pQRCode)
	{
		if (!pQRCode)
		{
			return;
		}
		await this.pict.providers.QRCodeProvider.ensurePrintableManifests();
		const tmpKnown = (pEntity === 'Sample') ? this.scanning.samples.find((pSample) => pSample.QRCode === pQRCode) : null;
		this.pict.providers.QRCodeProvider.printDecoratedEntity(pEntity, pQRCode, undefined, undefined, tmpKnown);
	}
}

module.exports = QRPanel;

module.exports.default_configuration =
{
	ViewIdentifier: 'QRPanel',
	DefaultRenderable: 'QRPanel',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'QRPanel-Wrapper',
			Template: /*html*/`
				<article id="HeadlightPanels-QRPanel" class="panel is-active">
					<style>
						#HeadlightPanels-QRPanel
						{
							background-color: var(--panels-background-color);
						}
						/* The Scan Samples cart in the panels' dark palette, like the other panels. */
						#HeadlightPanels-QRPanel .hl-scan
						{
							--hl-scan-background: var(--panels-background-color);
							--hl-scan-text: var(--panels-content-block-text-color);
							--hl-scan-text-strong: var(--panels-label-color);
							--hl-scan-text-weak: var(--panels-content-block-type-icon-color);
							--hl-scan-border: var(--panels-content-block-divider-color);
							--hl-scan-border-weak: var(--panels-content-block-divider-color);
							--hl-scan-head-background: var(--panels-tabs-background-color);
							--hl-scan-input-background: var(--panels-input-background-color);
							--hl-scan-input-text: var(--panels-input-text-color);
							--hl-scan-input-border: var(--panels-input-border-color);
						}
						#QRPanel-Body
						{
							max-height: calc(100vh - var(--panels-header-height) - var(--panels-navbar-height)) !important;
							overflow-y: auto !important;
						}
					</style>
					<p id="HeadlightPanels-QRPanel-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
							onclick="_Pict.views.QRPanel.handleClosePanelEvent(event)">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-QRPanel-Header-Icon" class="fas fa-fw fa-qrcode" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-QRPanel-Header-Title" class="mr-3">Scan Samples</span>
					</p>
					<div id="QRPanel-Body" class="panel-content panel-has-nested-scroll-content"></div>
				</article>
			`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'QRPanel',
			TemplateHash: 'QRPanel-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
	],
};

},{"headlight-sample-scanning":294,"pict-view":733}],1568:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// TODO: could we make this 'ActiveSampleRecord' and use to edit samples too?
		this.CurrentSampleRecord = {};
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// set the customer ID if it exists
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser.CustomerID || 0;
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Enter a project...',
			ElementID: 'SampleCreate-Entry-Project',
			ParentID: 'SampleCreate-Container',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// MATERIAL Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a material..',
			ElementID: 'SampleCreate-Entry-Material',
			ParentID: 'SampleCreate-Container',
			URL: 'Materials',
			IDField: 'IDMaterial',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Materials initialized');
		});

		// MIX Design Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a mix Design...',
			ElementID: 'SampleCreate-Entry-MixDesign',
			ParentID: 'SampleCreate-Container',
			URL: 'MixDesigns',
			IDField: 'IDMixDesign',
			TextField: 'MixID',
		}, () =>
		{
			this.log.info('Select2 Mix Designs initialized');
		});

		// PRODUCER Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a producer...',
			ElementID: 'SampleCreate-Entry-Producer',
			ParentID: 'SampleCreate-Container',
			URL: 'Organizations',
			IDField: 'IDOrganization',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Producers initialized');
		});

		// PRODUCT Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a product...',
			ElementID: 'SampleCreate-Entry-Product',
			ParentID: 'SampleCreate-Container',
			URL: 'Products',
			IDField: 'IDProduct',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Products initialized');
		});

		// PLANT Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a plant...',
			ElementID: 'SampleCreate-Entry-Plant',
			ParentID: 'SampleCreate-Container',
			URL: 'ProductionPlants',
			IDField: 'IDProductionPlant',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Plants initialized');
		});

		// LAB Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Enter a lab...',
			ElementID: 'SampleCreate-Entry-Lab',
			ParentID: 'SampleCreate-Container',
			URL: 'Labs',
			IDField: 'IDLab',
			TextField: 'Name',
			minimumInputLength: 0,
		}, () =>
		{
			this.log.info('Select2 Labs initialized');
		});

		//  DESIGNATEDDATE date picker
		window.flatpickr('#SampleCreate-Entry-Date', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleCreate-Date');
			},
		});

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.SampleCreate.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.SampleCreate.CurrentSearchFilters.PageSize : data.length === _Pict.views.SampleCreate.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method updates the current sample record with the value of the specified field.
	 * @param {string} id - The id of the element to get the value from.
	 * @param {string} pField - The field to update in the current sample record.
	 * @return {void}
	 */
	handleNewSampleRecordChange(id, pField)
	{
		const tmpElement = document.getElementById(id);
		if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLTextAreaElement || tmpElement instanceof HTMLSelectElement)
		{
			this.CurrentSampleRecord[pField] = tmpElement.value;
			this.log.info(`Current Sample Record updated: ${pField} = ${this.CurrentSampleRecord[pField]}`);
		}
	}

	/**
	 * This method clears the current sample record.
	 * @return {void}
	 */
	clearSample()
	{
		this.CurrentSampleRecord = {};
		this.renderAsync(() =>
		{
			this.log.info('Sample Create view cleared');
		});
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.CurrentSampleRecord));

		const tmpSampleRecord = {};
		Object.keys(this.CurrentSampleRecord).forEach((pKey) =>
		{
			switch (pKey)
			{
			case 'Date':
				tmpSampleRecord.DesignatedTime = this.CurrentSampleRecord.Date ? this.fable.Dates.dayJS(this.CurrentSampleRecord.Date).toISOString() : null;
				break;
			case 'Project':
				tmpSampleRecord.IDProject = this.CurrentSampleRecord.Project;
				break;
			case 'Material':
				tmpSampleRecord.IDMaterial = this.CurrentSampleRecord.Material;
				break;
			case 'MixDesign':
				tmpSampleRecord.IDMixDesign = this.CurrentSampleRecord.MixDesign;
				break;
			case 'Producer':
				tmpSampleRecord.IDOrganization = this.CurrentSampleRecord.Producer;
				break;
			case 'Product':
				tmpSampleRecord.IDProduct = this.CurrentSampleRecord.Product;
				break;
			case 'Plant':
				tmpSampleRecord.IDProductionPlant = this.CurrentSampleRecord.Plant;
				break;
			case 'Quantity':
				tmpSampleRecord.RepresentedQuantity = this.CurrentSampleRecord.Quantity;
				break;
			case 'Units':
				tmpSampleRecord.RepresentedQuantityUnits = this.CurrentSampleRecord.Units;
				break;
			case 'Notes':
				tmpSampleRecord.Notes = this.CurrentSampleRecord.Notes;
				break;
			case 'Name':
				tmpSampleRecord.Name = this.CurrentSampleRecord.Name;
				break;
			case 'IntendedUse':
				tmpSampleRecord.IntendedUse = this.CurrentSampleRecord.IntendedUse;
				break;
			case 'ManufacturerCode':
				tmpSampleRecord.ManufacturerCode = this.CurrentSampleRecord.ManufacturerCode;
				break;
			case 'Lab':
				// TODO: Lab is not set on the record?, may have to remove this line
				//tmpSampleRecord.IDLab = this.CurrentSampleRecord.Lab;
				break;
			case 'SampleType':
				// TODO: SampleType is not set on the record?, may have to remove this line
				//tmpSampleRecord.SampleType = this.CurrentSampleRecord.SampleType;
				break;
			default:
				tmpSampleRecord[pKey] = this.CurrentSampleRecord[pKey];
				break;
			}
		});

		try
		{
			const pResult = await this.pict.providers.SampleProvider.createSample(tmpSampleRecord);
			this.log.info('Sample created, going to the Details view...');

			// if we are in add mode, we need to update the selector to show the new sample
			// NOTE: Need to do this first before we swap panels since Details view doesn't have an "add mode" (yet)
			if (this.pict.ContentAssignment.readAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode') === 'add-to-set')
			{
				// TODO: This assumes search panel is already rendered, which it is, but we should revisit if we change that
				this.pict.views.SampleSearch.sampleSelectionCallback(pResult);
				this.pict.views.HeadlightPanels.closeAllPanels();
				this.pict.views.HeadlightPanels.toast({ message: 'Sample created and added to the input selector.', type: 'is-success' });
			}

			// show the details view for the new sample
			this.pict.views.SampleDetails.showSampleDetailView(pResult.IDSample, null, 'Details');
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
		}
	}
}

module.exports = SampleCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleCreate',
	DefaultRenderable: 'SampleCreate',
	DefaultDestinationAddress: '#SampleCreate-Container',
	Templates:
	[
		{
			Hash: 'SampleCreate',
			Template: /*html*/`
			{~T:SampleCreate-Entry~}`,
		},
		{
			Hash: 'SampleCreate-Entry',
			Template: /*html*/`
			<form id="SampleCreate-Form" onsubmit="_Pict.views.SampleCreate.createNewSample(event)">
				<div class="columns px-4 my-0">
					{~T:SampleCreate-Entry-NameInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ProjectSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-MixDesignSelector~}
					{~T:SampleCreate-Entry-MaterialSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ProducerSelector~}
					{~T:SampleCreate-Entry-ProductSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-PlantSelector~}
					{~T:SampleCreate-Entry-QuantityInput~}
					{~T:SampleCreate-Entry-UnitsInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-ManufacturerCodeInput~}
					{~T:SampleCreate-Entry-IndendedUseInput~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:SampleCreate-Entry-NotesInput~}
				</div>
				<div class="columns px-4 mb-0 mt-1">
					<div class="column">
						<div class="buttons is-right">
							<button type="button" class="button is-primary is-soft" title="Clear sample" onclick="_Pict.views.SampleCreate.clearSample()">
								<span class="icon">
									<i class="fa fa-fw fa-refresh"></i>
								</span>
								<span class="icon-text">Clear</span>
							</button>
							<button type="submit" class="button is-primary" title="Create new sample">
								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span class="icon-text">Create New Sample</span>
							</button>
						</div>
					</div>
				</div>
			</form>`,
		},
		{
			Hash: 'SampleCreate-Entry-NameInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Name">Sample Name</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Name" 
							class="input" 
							type="text" 
							placeholder="Enter a name for the sample..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Name')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-DateInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Date">Sample Date</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Date" 
							class="input" 
							type="date" 
							placeholder="Enter a date for the sample..." 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Date')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-SampleTypeInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-SampleType">Sample Type</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-SampleType" 
							class="input" 
							type="text" 
							value="Acceptance" 
							placeholder="Enter a type for the sample..."
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'SampleType')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-QuantityInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Quantity">Rep. Quantity</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Quantity" 
							class="input" 
							type="number" 
							value="0.000" 
							placeholder="Enter a Quantity for the sample..." 
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Quantity')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-UnitsInput',
			Template: /*html*/`
			<div class="column is-3">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Units">Units</label>
					<div class="control">
						<input 
							id="SampleCreate-Entry-Units" 
							class="input" 
							type="text" 
							value="" 
							placeholder="Variable Units (English)"
							autocomplete="off" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Units')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ManufacturerCodeInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-ManufacturerCode">Manufacturer Code</label>
					<div class="control">
						<input
							id="SampleCreate-Entry-ManufacturerCode"
							class="input"
							type="text"
							value=""
							placeholder="Enter a manufacturer code..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'ManufacturerCode')"
							/>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-IndendedUseInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-IndendedUse">Intended Use</label>
					<div class="control">
						<input
							id="SampleCreate-Entry-IndendedUse"
							class="input"
							type="text"
							value=""
							placeholder="Enter the intended use..."
							autocomplete="off"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'IntendedUse')"
							/>
						</div>
					</div>
				</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-NotesInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Notes">Notes</label>
					<div class="control">
						<textarea 
							id="SampleCreate-Entry-Notes" 
							class="textarea" 
							placeholder="Enter any notes for the sample..."
							rows="2" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Notes')"
						></textarea>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProjectSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Project">Project</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-Project" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Project')"
						>{~TS:SampleCreate-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Enty-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-MaterialSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Material">Material</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-Material" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Material')"
						>{~TS:SampleCreate-Entry~MaterialSelector-SelectedOptions:Context[0].CurrentSearchFilters.Material~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-MaterialSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDMaterial~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-MixDesignSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-MixDesign">Mix Designs</label>
					<div class="control select is-fullwidth">
						<select 
							id="SampleCreate-Entry-MixDesign" 
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'MixDesign')"
						>{~TS:SampleCreate-Entry~MixDesignSelector-SelectedOptions:Context[0].CurrentSearchFilters.MixDesign~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-MixDesignSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDMixDesign~}" selected>{~D:Record.MixID~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProducerSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Producer">Producer</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Producer"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Producer')"
						>{~TS:SampleCreate-Entry~ProducerSelector-SelectedOptions:Context[0].CurrentSearchFilters.Producer~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProducerSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDOrganization~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProductSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Product">Product</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Product"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Product')"
						>{~TS:SampleCreate-Entry~ProductSelector-SelectedOptions:Context[0].CurrentSearchFilters.Product~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-ProductSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProduct~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-PlantSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Plant">Plant</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Plant"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Plant')"
						>{~TS:SampleCreate-Entry~PlantSelector-SelectedOptions:Context[0].CurrentSearchFilters.Plant~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-PlantSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProductionPlant~}" selected>{~D:Record.Name~}</option>`,
		},
		{
			Hash: 'SampleCreate-Entry-LabSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="SampleCreate-Entry-Lab">Destination Lab</label>
					<div class="control select is-fullwidth">
						<select
							id="SampleCreate-Entry-Lab"
							onchange="_Pict.views.SampleCreate.handleNewSampleRecordChange(id, 'Lab')"
						>{~TS:SampleCreate-Entry~LabSelector-SelectedOptions:Context[0].CurrentSearchFilters.Lab~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCreate-Entry-LabSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDLab~}" selected>{~D:Record.Name~}</option>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleCreate',
			TemplateHash: 'SampleCreate',
			DestinationAddress: '#SampleCreate-Container',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":733}],1569:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

/**
 * The "Current" tab of the Samples panel: the Samples joined to the document being edited.
 *
 * Selecting a row opens the existing Sample Details panel on the RIGHT while this list stays open on
 * the left, so the list and the selected sample's Details/Location/Logs/Print tabs are visible together.
 * That split is why `sampledetails` is configured `location: "right"` (mirroring observations /
 * observationdetails) rather than replacing this panel.
 */
class SampleCurrent extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {Array<Object>} Samples joined to the current document. */
		this.CurrentSamples = [];
		/** @type {number|string|null} The row currently open in the Sample Details panel. */
		this.ActiveIDSample = null;
		/** @type {'loading'|'items'|'empty'} Drives which of the three list states the template paints. */
		this.ListState = 'loading';
	}

	/**
	 * Run when the Current tab is activated: load the per-customer print configuration (once) and
	 * refresh the list. Deliberately not done at panel render time — a document whose user never opens
	 * this tab should not pay for either.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleTabOpened()
	{
		await this.pict.providers.QRCodeProvider.ensurePrintableManifests();
		await this.refreshCurrentSamples();
	}

	/**
	 * Fetch the Samples joined to the current document and repaint the list.
	 * @return {Promise<void>}
	 * @async
	 */
	async refreshCurrentSamples()
	{
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		try
		{
			const tmpSamples = await this.pict.providers.SampleProvider.getDocumentCurrentSamples(tmpIDDocument);
			this.CurrentSamples = tmpSamples.map((pSample) =>
			{
				const tmpHasServerRow = Number(pSample.IDSample) > 0;
				return Object.assign({}, pSample,
					{
						// Sample.Name is very often just the QR code again; only carry it when it adds something.
						_DisplayName: (pSample.Name && pSample.Name !== pSample.QRCode) ? pSample.Name : '',
						_DetailsClass: tmpHasServerRow ? '' : 'is-hidden',
						_RowClass: tmpHasServerRow ? 'is-clickable' : '',
						_PendingLabel: tmpHasServerRow ? '' : 'Not synced yet',
					});
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to load the Samples joined to document ${tmpIDDocument}.`, pError);
			this.CurrentSamples = [];
		}
		this.ListState = this.CurrentSamples.length > 0 ? 'items' : 'empty';
		return new Promise((resolve) =>
		{
			this.renderAsync(() =>
			{
				this._paintActiveRow();
				resolve();
			});
		});
	}

	/**
	 * Open a Sample in the Sample Details panel (right side) and mark its row active here.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to open
	 * @return {void}
	 */
	selectSample(event, pIDSample)
	{
		if (!pIDSample)
		{
			return;
		}
		this.ActiveIDSample = pIDSample;
		this._paintActiveRow();
		const tmpSampleRecord = this.CurrentSamples.find((pSample) => String(pSample.IDSample) === String(pIDSample));
		// so the Details panel's back button returns here rather than to Search
		this.pict.views.SampleDetails.SampleDetailsBackTo = 'Current';
		this.pict.views.SampleDetails.showSampleDetailView(pIDSample, tmpSampleRecord, 'Details');
	}

	/**
	 * Print the QR label for a Sample. Same call the Sample Details Print tab uses, minus the preview
	 * container -- omitting it sends the label to the printer instead of rendering it inline.
	 * @param {Event} event - The click event
	 * @param {string} pQRCode - The Sample QR code
	 * @return {void}
	 */
	printSample(event, pQRCode)
	{
		if (event)
		{
			// the row itself opens the details panel; printing should not also do that
			event.stopPropagation();
		}
		if (!pQRCode)
		{
			return;
		}
		const tmpSampleProvider = this.pict.providers.SampleProvider;
		if (typeof tmpSampleProvider.getFormHeldSamples === 'function' && tmpSampleProvider.getFormHeldSamples().some((pSample) => pSample.QRCode === pQRCode))
		{
			// The open form holds this Sample, so its label should show the form's current selections.
			tmpSampleProvider.printFormSample(pQRCode);
			return;
		}
		const tmpKnownRecord = this.CurrentSamples.find((pSample) => pSample.QRCode === pQRCode);
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', pQRCode, undefined, undefined, tmpKnownRecord);
	}

	/**
	 * Open a Sample straight to its Print tab, where the label preview renders.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to preview
	 * @return {void}
	 */
	previewSample(event, pIDSample)
	{
		this._openSampleOnTab(event, pIDSample, 'Print');
	}

	/**
	 * Open a Sample straight to its Logs tab.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to open
	 * @return {void}
	 */
	openSampleLogs(event, pIDSample)
	{
		this._openSampleOnTab(event, pIDSample, 'Logs');
	}

	/**
	 * Shared row-action path: mark the row active and open Sample Details on a given tab.
	 * @param {Event} event - The click event
	 * @param {number|string} pIDSample - The Sample to open
	 * @param {string} pTab - The Sample Details tab to open
	 * @return {void}
	 */
	_openSampleOnTab(event, pIDSample, pTab)
	{
		if (event)
		{
			// the row itself opens the Details tab; a row-action button picks its own
			event.stopPropagation();
		}
		if (!pIDSample)
		{
			return;
		}
		this.ActiveIDSample = pIDSample;
		this._paintActiveRow();
		const tmpSampleRecord = this.CurrentSamples.find((pSample) => String(pSample.IDSample) === String(pIDSample));
		this.pict.views.SampleDetails.SampleDetailsBackTo = 'Current';
		this.pict.views.SampleDetails.showSampleDetailView(pIDSample, tmpSampleRecord, pTab);
	}

	/**
	 * Move the `is-active` highlight onto the row for ActiveIDSample. Re-applied after every render,
	 * since rendering replaces the row elements.
	 * @return {void}
	 */
	_paintActiveRow()
	{
		if (typeof document === 'undefined')
		{
			return;
		}
		const tmpRows = document.querySelectorAll('[data-sample-current-id]');
		tmpRows.forEach((pRow) =>
		{
			const tmpIsActive = this.ActiveIDSample != null &&
				pRow.getAttribute('data-sample-current-id') === String(this.ActiveIDSample);
			pRow.classList.toggle('is-active', tmpIsActive);
		});
	}
}

module.exports = SampleCurrent;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleCurrent',
	DefaultRenderable: 'SampleCurrent-List',
	DefaultDestinationAddress: '#SampleCurrent-Container',
	Templates:
	[
		{
			Hash: 'SampleCurrent-List',
			Template: /*html*/`
			<div id="SampleCurrent-List">
				{~TIfAbs:SampleCurrent-Loading:Context[0]:Context[0].ListState^===^loading~}
				{~TIfAbs:SampleCurrent-Items:Context[0].CurrentSamples:Context[0].ListState^===^items~}
				{~TIfAbs:SampleCurrent-Empty:Context[0]:Context[0].ListState^===^empty~}
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Loading',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left p-5">
				<div class="has-text-centered has-text-text-75" style="flex-grow: 1">
					<span class="icon"><i class="fa fa-fw fa-spinner fa-pulse"></i></span>
					<span class="icon-text">Loading samples&hellip;</span>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Empty',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left p-5">
				<div class="has-text-centered" style="flex-grow: 1">
					<span class="icon"><i class="fa fa-fw fa-vial"></i></span>
					<span class="icon-text">No samples are attached to this document yet.</span>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Items',
			Template: /*html*/`
			<div id="SampleCurrent-Items" class="nested-scroll-content">
				{~TS:SampleCurrent-Item:Record~}
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0 {~D:Record._RowClass~}"
				data-sample-current-id="{~D:Record.IDSample~}"
				title="Open this sample's details"
				onclick="_Pict.views.SampleCurrent.selectSample(event, '{~D:Record.IDSample~}')">
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div>
						<span class="icon"><i class="fas fa-fw fa-qrcode"></i></span>
						<b>{~D:Record.QRCode~}</b>
						<span class="has-text-text-75">{~D:Record._DisplayName~}</span>
						<span class="has-text-text-75"><i>{~D:Record._PendingLabel~}</i></span>
					</div>
					<div class="is-size-7 has-text-text-75">{~StatusPill:Record.Status~}</div>
					<div class="is-size-7 has-text-text-75"><b>Material:</b> {~Entity:Material^Record.IDMaterial^SampleCurrent-Item-Material^~}</div>
					<div class="is-size-7 has-text-text-75"><b>Project:</b> {~Entity:Project^Record.IDProject^SampleCurrent-Item-Project^~}</div>
					<div class="is-size-7 has-text-text-75">
						<span class="has-text-text-60"><b class="has-text-text-80">Created</b> on</span>
						<span class="has-text-text-80">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-60">by</span>
						<span class="has-text-text-80">{~Entity:User^Record.CreatingIDUser^SampleCurrent-Item-User^~}</span>
					</div>
				</div>
				<div class="buttons are-small mr-3 my-2">
					<button type="button" class="button is-soft is-primary {~D:Record._DetailsClass~}" title="Open this sample's logs"
						onclick="_Pict.views.SampleCurrent.openSampleLogs(event, '{~D:Record.IDSample~}')">
						<span class="icon"><i class="fas fa-fw fa-list-timeline"></i></span>
					</button>
					<button type="button" class="button is-soft is-primary {~D:Record._DetailsClass~}" title="Preview the QR code label"
						onclick="_Pict.views.SampleCurrent.previewSample(event, '{~D:Record.IDSample~}')">
						<span class="icon"><i class="fas fa-fw fa-print-magnifying-glass"></i></span>
					</button>
					<button type="button" class="button is-primary" title="Print the QR code label"
						onclick="_Pict.views.SampleCurrent.printSample(event, '{~D:Record.QRCode~}')">
						<span class="icon"><i class="fas fa-fw fa-print"></i></span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleCurrent-Item-Material',
			Template: /*html*/`{~D:Record.Name:Unknown~}`,
		},
		{
			Hash: 'SampleCurrent-Item-Project',
			Template: /*html*/`{~D:Record.Name:Unknown~}`,
		},
		{
			Hash: 'SampleCurrent-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleCurrent-List',
			TemplateHash: 'SampleCurrent-List',
			DestinationAddress: '#SampleCurrent-Container',
		},
	],
};

},{"pict-view":733}],1570:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveSampleDetails = {};
		this.ActiveSampleLogs = [];
		this.SampleDetailsBackTo = null;
	}

	async onRenderAsync(pCallback)
	{
		this.log.info('Sample Details view rendered with Active Record', this.ActiveSampleDetails);

		if (pCallback) pCallback();
	}

	/**
	 * Open the Sample detail view for the selected Sample to view the full details
	 * @param {number|string} pIDSample - The ID of the Sample to view
	 * @param {object} pSampleRecord - The Sample record to view
	 * @param {string} pOpenTab - The tab to open when the Sample detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showSampleDetailView(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		// if a Sample record is passed in, use it, otherwise get the Sample record by ID
		if (pSampleRecord)
		{
			this.ActiveSampleDetails = Array.isArray(pSampleRecord) ? pSampleRecord[0] : pSampleRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.SampleProvider.getSampleByID(pIDSample);
			this.ActiveSampleDetails = tmpRecord;
		}
		// if the Sample record is not found, log an error and return
		if (!this.ActiveSampleDetails)
		{
			this.log.error('Sample record not found for ID', pIDSample);
			return;
		}
		else
		{
			// get the logs for the Sample
			const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.ActiveSampleDetails.IDSample);
			this.ActiveSampleLogs = tmpLogs;
		}
		// render the Sample detail view
		this.renderAsync(() =>
		{
			this.log.info('Sample Details View Rendered with Active Record', this.ActiveSampleDetails);
			// open the panel if it is not already open
			this.pict.views.HeadlightPanels.handlePanelToggle('SampleDetails', 'open');
			// set the active tab to the one passed in
			this.pict.views.HeadlightPanels.toggleTabContent(`HeadlightPanels-SampleDetailsPanel-${pOpenTab}`, 'SampleDetails');
			if (pOpenTab === 'Print')
			{
				this.renderPrintPreview();
			}
		});
	}

	open(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		this.resetSampleDetailsView();
		this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open');
		this.showSampleDetailView(pIDSample, pSampleRecord, pOpenTab);
	}

	/**
	 * This method resets the state of the Sample Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetSampleDetailsView()
	{
		this.log.info('Resetting Active Sample Details');
		this.ActiveSampleDetails = {};
	}

	/**
	 * This method returns the user to the Sample List view and resets the Sample Details view.
	 * This method is called when the user clicks the back button in the Sample Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		// TODO: probably should update this to use data state to track pinned open panels
		if (event && event.target instanceof HTMLElement && event.target.closest('.hl-panel-wrapper').classList.contains('pinned-open'))
		{
			this.log.info('Panel is pinned open, not going back to Sample List view');
			return;
		}
		this.resetSampleDetailsView();
		// go back to the search view if the user came from there
		switch (this.SampleDetailsBackTo)
		{
		case 'Search':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Search', 'Sample');
				this.pict.views.SampleSearch.updateWithSearchResults(this.pict.views.SampleSearch.CurrentSearchResults, this.pict.views.SampleSearch.CurrentSearchResults?.length);
			});
			break;
		case 'Scan':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Scan', 'Sample');
			});
			break;
		case 'Current':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample');
				this.pict.views.SampleCurrent.handleTabOpened();
			});
			break;
		case 'Create':
			this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'open', () =>
			{
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Create', 'Sample');
			});
			break;
		default:
			// close all panels and reset the Sample Details view (same as clicking the close button)
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.resetSampleDetailsView();
			break;
		}
	}

	/**
	 * This method is used to add a new log to the Sample and refresh the Sample Details view.
	 * @return {Promise<void>}
	 * @async
	 */
	async addNewLogToSample()
	{
		if (!this.ActiveSampleDetails)
		{
			this.log.error('No active Sample to add log to');
			return;
		}
		this.pict.ContentAssignment.addClass('#HeadlightPanels-SampleDetailsPanel-Logs-Add-Button', 'is-loading');
		this.log.info('Adding new log to Sample ID:', this.ActiveSampleDetails.IDSample);

		const tmpLogMessage = this.pict.ContentAssignment.readContent('#SampleDetails-Tab-Logs-CreateNewLog-Textarea');
		await this.pict.providers.SampleLogProvider.addNote(this.ActiveSampleDetails.IDSample, tmpLogMessage);
		this.log.info('Sample Log added to Sample', this.ActiveSampleDetails.IDSample);
		await this.showSampleDetailView(this.ActiveSampleDetails.IDSample, null, 'Logs');
	}

	/**
	 * This method is used to clear the new log entry field in the Sample Details view.
	 * @return {void}
	 */
	clearNewLogEntry()
	{
		this.pict.ContentAssignment.assignContent('#SampleDetails-Tab-Logs-CreateNewLog-Textarea', '');
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @param {boolean} [pShowOptions] - Open Print options (label stock and preview) instead of printing right away.
	 * @return {void}
	 */
	printQRCodeLabel(pShowOptions)
	{
		if (!this.ActiveSampleDetails)
		{
			this.log.error('No active Sample to print QR Code for');
			return;
		}
		this.log.info('Printing Sample Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.ActiveSampleDetails.QRCode, undefined, undefined, this.ActiveSampleDetails, { ShowOptions: !!pShowOptions });
	}

	/**
	 * Render the QR label preview into the Print tab.
	 *
	 * `printDecoratedEntity` with a previewID short-circuits the print dialog and paints the label into
	 * that container instead -- the same call the real print uses, so what is previewed is what prints.
	 * @return {Promise<void>}
	 * @async
	 */
	async renderPrintPreview()
	{
		if (!this.ActiveSampleDetails)
		{
			return;
		}
		// per-customer label layout, loaded lazily the first time a label is needed
		await this.pict.providers.QRCodeProvider.ensurePrintableManifests();
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.ActiveSampleDetails.QRCode, 'SampleDetails-PrintPreview', undefined, this.ActiveSampleDetails);
	}

	/**
	 * This method is used to clear the QR Code label entry fields in the Sample Details view.
	 * @return {void}
	 */
	clearQRCodeLabel()
	{
		this.pict.ContentAssignment.assignContent('#SampleDetails-Tab-Print-HeaderText', '');
		this.pict.ContentAssignment.assignContent('#SampleDetails-Tab-Print-FooterText', '');
	}
}

module.exports = SampleDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleDetails',
	DefaultRenderable: 'SampleDetails',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'SampleDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-SampleDetailsPanel" class="panel is-active">
				<!-- Sample ID: {~D:Context[0].ActiveSampleDetails.IDSample~} -->
				<div id="HeadlightPanels-SampleDetailsPanel-Sample-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.SampleDetails.resetSampleDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-SampleDetailsPanel-Sample-Header-Icon" class="fas fa-fw fa-vial" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-SampleDetailsPanel-Sample-Header-Title" class="mr-3">Sample Details</span>
				</div>
				<!-- Sample Panel Tabs -->
				<div id="HeadlightPanels-SampleDetailsPanel-Tabs" class="panel-tabs pr-6">					
					<a id="HeadlightPanels-SampleDetailsPanel-Details-Tab" class="is-active" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Details', 'SampleDetails')">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span class="icon-text">
							Details
						</span>
					</a>
					<a id="HeadlightPanels-SampleDetailsPanel-Location-Tab" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Location', 'SampleDetails')">
						<span class="icon">
							<i class="fa fa-fw fa-location-pin"></i>
						</span>
						<span class="icon-text">
							Location
						</span>
					</a>
					<a id="HeadlightPanels-SampleDetailsPanel-Logs-Tab" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Logs', 'SampleDetails')">
						<span class="icon">
							<i class="fa fa-fw fa-list-timeline"></i>
						</span>
						<span class="icon-text">
							Logs
						</span>
					</a>
					<a id="HeadlightPanels-SampleDetailsPanel-Print-Tab" onclick="_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SampleDetailsPanel-Print', 'SampleDetails'); _Pict.views.SampleDetails.renderPrintPreview();">
						<span class="icon">
							<i class="fa fa-fw fa-qrcode"></i>
						</span>
						<span class="icon-text">
							Print
						</span>
					</a>
				</div>
				<!-- SampleDetails Panel Content -->
				<div id="HeadlightPanels-SampleDetailsPanel-Content" style="min-width:40vw" data-sample-id="{~D:Record.IDSample~}">
					{~T:SampleDetails-SampleHeader:Context[0].ActiveSampleDetails~}
					<!-- SampleDetails Content > Tab Details View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Details-Content" class="panel-content panel-with-tabs-offset-plus-sample-header">
						<div id="SampleDetails-Details-Container">{~T:SampleDetails-Tab-Details:Context[0].ActiveSampleDetails~}</div>
					</div>
					<!-- SampleDetails Content > Tab Location View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Location-Content" class="panel-content panel-with-tabs-offset-plus-sample-header">
						<div id="SampleDetails-Location-Container">{~T:SampleDetails-Tab-Location:Context[0].ActiveSampleDetails~}</div>
					</div>
					<!-- SampleDetails Content > Tab Logs View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Logs-Content" class="panel-content panel-with-tabs-offset-plus-sample-header panel-has-nested-scroll-content">
						<div id="SampleDetails-Logs-Container">{~T:SampleDetails-Tab-Logs:Context[0].ActiveSampleLogs~}</div>
					</div>
					<!-- SampleDetails Content > Tab Print View -->
					<div id="HeadlightPanels-SampleDetailsPanel-Print-Content" class="panel-content panel-with-tabs-offset-plus-sample-header">
						<div id="SampleDetails-Print-Container">{~T:SampleDetails-Tab-Print:Context[0].ActiveSampleDetails~}</div>
					</div>
				</div>
			</article>`,
		},
		{
			Hash: 'SampleDetails-SampleHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-15 is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4 has-text-white">
						{~TIfAbs:SampleDetails-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-65 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
					<span class="label is-size-7 has-text-text-65 mb-0">Status:</p>
					{~StatusPill:Record.Status~}
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Details',
			Template: /*html*/`
			<div class="columns px-3 m-0 mt-3">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Created by</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-User:Record:Record.CreatingIDUser^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.CreatingIDUser^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Created on</span>
					<span class="subtitle is-6 has-text-text-90">
						{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Project</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Project:Record:Record.IDProject^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDProject^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Line Item</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-MixDesign:Record:Record.IDLineItem^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDLineItem^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Material Type</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Material:Record:Record.IDMaterial^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDMaterial^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Mix Design</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-MixDesign:Record:Record.IDMixDesign^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDMixDesign^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Producer</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Organization:Record:Record.IDOrganization^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDOrganization^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Product</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-Product:Record:Record.IDProduct^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDProduct^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Production Plant</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-EntityValue-ProductionPlant:Record:Record.IDProductionPlant^>^0~}
						{~TIfAbs:SampleDetails-EntityValue-NA:Record:Record.IDProductionPlant^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Manufacturer Code</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-ManufacturerCode:Record:Record.ManufacturerCode^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.ManufacturerCode^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Intended Use</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-IntendedUse:Record:Record.IntendedUse^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.IntendedUse^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Represented Quantity</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-RepresentedQuantity:Record:Record.RepresentedQuantity^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.RepresentedQuantity^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Units</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-RepresentedQuantityUnits:Record:Record.RepresentedQuantityUnits^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-RepresentedQuantityUnits-Empty:Record:Record.RepresentedQuantityUnits^<=^0~}
					</span>
				</div>
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-60">Buy USA</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-BuyUSA-Yes:Record:Record.BuyUSA^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-BuyUSA-No:Record:Record.BuyUSA^<=^0~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column p-3">
					<span class="title is-block is-6 has-text-text-65">Notes</span>
					<div class="subtitle is-6 has-text-text-90">
						{~T:SampleDetails-DatumValue-Notes:Record~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'SampleDetails-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'SampleDetails-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Sample #{~D:Record.IDSample~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-Status',
			Template: /*html*/`{~D:Record.Status~}`,
		},
		{
			// Remarks are authored as markdown (the test forms' RichText editor writes markdown into
			// Notes), so they are rendered rather than printed raw. The expression carries its own
			// empty case, which also fixes remarks that start with `#` or `-`: the comparison this
			// replaced sorted those below '0' and showed N/A for a note that was actually there.
			Hash: 'SampleDetails-DatumValue-Notes',
			Template: /*html*/`{~MarkdownRemarks:Record.Notes^SampleDetails-DatumValue-NA^~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-GeographicalArea',
			Template: /*html*/`{~D:Record.GeographicalArea~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-ManufacturerCode',
			Template: /*html*/`{~D:Record.ManufacturerCode~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-IntendedUse',
			Template: /*html*/`{~D:Record.IntendedUse~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-BuyUSA-Yes',
			Template: /*html*/`Yes`,
		},
		{
			Hash: 'SampleDetails-DatumValue-BuyUSA-No',
			Template: /*html*/`No`,
		},
		{
			Hash: 'SampleDetails-DatumValue-ProductName',
			Template: /*html*/`{~D:Record.ProductName~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-RepresentedQuantity',
			Template: /*html*/`{~D:Record.RepresentedQuantity~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-RepresentedQuantityUnits',
			Template: /*html*/`{~D:Record.RepresentedQuantityUnits~}`,
		},
		{
			Hash: 'SampleDetails-DatumValue-RepresentedQuantityUnits-Empty',
			Template: /*html*/`Variable Units (English)`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Project',
			Template: /*html*/`{~Entity:Project^Record.IDProject^SampleDetails-EntityValue-Project-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Project-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Material',
			Template: /*html*/`{~Entity:Material^Record.IDMaterial^SampleDetails-EntityValue-Material-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Material-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-LineItem',
			Template: /*html*/`{~Entity:LineItem^Record.IDLineItem^SampleDetails-EntityValue-LineItem-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-LineItem-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Product',
			Template: /*html*/`{~Entity:Product^Record.IDProduct^SampleDetails-EntityValue-Product-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Product-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Organization',
			Template: /*html*/`{~Entity:Organization^Record.IDOrganization^SampleDetails-EntityValue-Organization-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-Organization-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-ProductionPlant',
			Template: /*html*/`{~Entity:ProductionPlant^Record.IDProductionPlant^SampleDetails-EntityValue-ProductionPlant-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-ProductionPlant-Record',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-MixDesign',
			Template: /*html*/`{~Entity:MixDesign^Record.IDMixDesign^SampleDetails-EntityValue-MixDesign-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-MixDesign-Record',
			Template: /*html*/`{~D:Record.MixID~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-User',
			Template: /*html*/`{~Entity:User^Record.CreatingIDUser^SampleDetails-EntityValue-User-Record^~}`,
		},
		{
			Hash: 'SampleDetails-EntityValue-User-Record',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'SampleDetails-Tab-Location',
			Template: /*html*/`
			<figure class="image">
				<img class="has-background-text-40" onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~GoogleMapURL:Record^640x480^~}" alt="Sample location on a map" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)">
			</figure>
			<div class="columns px-3 m-0 mt-3">
				<div class="column">
					<span class="title is-block is-6 has-text-text-60">Latitude</span>
					<span class="subtitle is-6 has-text-text-90">
						{~D:Record.CaptureLatitude~}
					</span>
				</div>
				<div class="column">
					<span class="title is-block is-6 has-text-text-60">Longitude</span>
					<span class="subtitle is-6 has-text-text-90">
						{~D:Record.CaptureLongitude~}
					</span>
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<span class="title is-block is-6 has-text-text-60">Geographical Area</span>
					<span class="subtitle is-6 has-text-text-90">
						{~TIfAbs:SampleDetails-DatumValue-GeographicalArea:Record:Record.GeographicalArea^>^0~}
						{~TIfAbs:SampleDetails-DatumValue-NA:Record:Record.GeographicalArea^<=^0~}
					</span>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs',
			Template: /*html*/`
				{~TIfAbs:SampleDetails-Tab-Logs-Items:Record:Record.length^>^0~}
				{~TIfAbs:SampleDetails-Tab-Logs-Empty:Record:Record.length^<=^0~}
				{~T:SampleDetails-Tab-Logs-Entry:Context[0].ActiveSampleDetails~}`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Empty',
			Template: /*html*/`
			<div class="notification has-text-text-light is-dark m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No logs are available for this sample.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Items',
			Template: /*html*/`
			<div id="SampleDetails-Tab-Logs-Items" class="nested-scroll-content panel-views-height-offset has-sample-header-offset">
				{~TS:SampleDetails-Tab-Logs-Item:Record~}
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-0">
				<figure class="image">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Geolocation for sample" />
				</figure>
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div class="is-size-7 has-text-text-75">#{~D:Record.IDSampleLog~}</div>
					<div>{~D:Record.Notes~}</div>
					<div class="is-size-7 has-text-text-75">
						<span class="has-text-text-60">on</span>
						<span class="has-text-text-80">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-text-60">by</span>
						<span class="has-text-text-80">{~Entity:User^Record.CreatingIDUser^SampleDetails-Tab-Logs-Item-User^~}</span>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'SampleDetails-Tab-Logs-Entry',
			Template: /*html*/`
			<div class="column" style="border-top: 1px solid var(--bulma-text-20)">
				<textarea id="SampleDetails-Tab-Logs-CreateNewLog-Textarea" style="min-height: 4rem" class="textarea" placeholder="Enter log notes here"></textarea>
				<div class="buttons mt-2 is-right">
					<button type="button" class="button is-primary is-soft" title="Clear log entry" onclick="_Pict.views.SampleDetails.clearNewLogEntry()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span>Clear</span>
					</button>
					<button type="button" class="button is-primary" title="Add new log to sample"onclick="_Pict.views.SampleDetails.addNewLogToSample()">
						<span class="icon">
							<i class="fa fa-fw fa-pencil"></i>
						</span>
						<span>Add Log</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'SampleDetails-Tab-Print',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column has-background-white p-3" id="SampleDetails-PrintPreview"></div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-primary" title="Print qrcode label" onclick="_Pict.views.SampleDetails.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span>Print QRCode Label</span>
						</button>
						<button type="button" class="button is-light" title="Choose the label stock and see the label before printing" onclick="_Pict.views.SampleDetails.printQRCodeLabel(true)">
							<span>Print options…</span>
						</button>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleDetails',
			TemplateHash: 'SampleDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
	],
};

},{"pict-view":733}],1571:[function(require,module,exports){
/* eslint-disable no-extra-bind */
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleScan extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.InAddMode = false;
		this.currentScannedSampleResult = null;
		this.cameraOpen = false;
		this.cameraToggleRunning = false;
	}

	onBeforeRenderAsync(pCallback)
	{
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// start a new QR code scanning workflow
		this.customOpenQRScannerWorkflow();
		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	customOpenQRScannerWorkflow()
	{
		this.currentScannedSampleResult = null;
		this.stopScanWorkflow();
		const tmpQR = this.pict.providers.HeadlightQR;
		if (!tmpQR)
		{
			return;
		}
		// While this tab is up, a scanned sample is picked here; anything else goes on to the app's handlers.
		this._removeScanHandler = tmpQR.pushScanHandler(
			{
				Hash: 'sample-pane-scan',
				Mode: 'Pick',
				Label: 'Pick a sample',
				Accept: [ 'Sample' ],
				onScan: (pResolution) =>
				{
					if (pResolution.Status !== 'Found' || !pResolution.Record || !pResolution.Record.IDSample)
					{
						return false;
					}
					this.closeCamera();
					this.currentScannedSampleResult = pResolution.Record;
					this.handleSampleScanSelection(null, pResolution.Record.IDSample, pResolution.Record);
					return true;
				},
			});
		this._releaseWedge = tmpQR.holdWedge();
	}

	stopScanWorkflow()
	{
		this.closeCamera();
		if (this._removeScanHandler)
		{
			this._removeScanHandler();
			this._removeScanHandler = null;
		}
		if (this._releaseWedge)
		{
			this._releaseWedge();
			this._releaseWedge = null;
		}
	}

	/**
	 * Opens or closes the camera in this tab's scanner box.
	 * @return {Promise<boolean>} whether the camera is now open
	 */
	async toggleCamera()
	{
		// Don't run this function again until the ui transition is finished.
		if (this.cameraToggleRunning)
		{
			return this.cameraOpen;
		}
		this.cameraToggleRunning = true;
		this.cameraOpen = !this.cameraOpen;
		try
		{
			if (this.cameraOpen)
			{
				await this.pict.providers.QRCodeProvider.openScanner('QRPanel-ScannerBox', { isPhoneDevice: this.pict.services.HeadlightPanels.isPhoneDevice });
			}
			else
			{
				await this.pict.providers.QRCodeProvider.closeScanner();
			}
		}
		catch (e)
		{
			console.log('Error toggling the qr code scanner: ', e);
		}
		document.querySelector('#QRPanel-ScannerBox-Outer')?.classList.toggle('is-hidden', !this.cameraOpen);
		document.querySelector('#SampleScan-CameraButton')?.classList.toggle('is-close-button', this.cameraOpen);
		this.cameraToggleRunning = false;
		return this.cameraOpen;
	}

	/**
	 * Closes the camera if this tab opened it.
	 * @return {Promise<boolean>|undefined}
	 */
	closeCamera()
	{
		if (!this.cameraOpen)
		{
			return;
		}
		return this.toggleCamera();
	}

	/**
	 * This function is used to handle the selection of a sample from the scan results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDSample - The ID of the sample that was selected
	 * @param {object} pSampleObject - The sample object that was selected
	 * @return {void}
	 */
	handleSampleScanSelection(event, pIDSample, pSampleObject)
	{
		// determine if we are in "add to set" mode
		this.InAddMode = this.pict.ContentAssignment.readAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode') === 'add-to-set';

		if (!pIDSample)
		{
			this.log.error('No IDSample provided');
			return;
		}
		// handle the context of the sample selection
		if (this.InAddMode)
		{
			if (this.pict.views.SampleSearch.sampleSelectionCallback)
			{
				if (pIDSample && pSampleObject)
				{
					this.pict.views.SampleSearch.sampleSelectionCallback(pSampleObject);
					this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'close');
					this.InAddMode = false;
				}
			}
		}
		else
		{
			if (_Pict.PictApplication.options.Name == 'LIMS')
			{
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
				window.open(`#/Sample/${ pSampleObject.GUIDSample }`, '_self');
			}
			else
			{
				this.pict.views.SampleDetails.showSampleDetailView(pIDSample, null, 'Details');
			}
		}
	}
}

module.exports = SampleScan;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleScan',
	DefaultRenderable: 'SampleScan',
	DefaultDestinationAddress: '#SampleScan-Container',
	Templates:
		[
			{
				Hash: 'SampleScan',
				Template: /*html*/`
				<div id="SampleScan-Content" class="container">
					<style>
						.sample-container {
							overflow: scroll;
						}
						.panel-content-samples {
							max-height: calc(100vh - var(--panels-header-height) - var(--panels-navbar-height)) !important;
							overflow-y: scroll !important;
						}
						.icon-text-for-open-button
						{
							display: inline;
						}
						.icon-text-for-close-button
						{
							display: none;
						}
						.is-close-button .icon-text-for-close-button
						{
							display: inline;
						}
						.is-close-button .icon-text-for-open-button
						{
							display: none;
						}
					
					</style>
					<div id="QRPanel-SampleScan-Container" class="has-background-text-35 has-text-white" style="max-height: 50vh; overflow-y: scroll;">
						<style>
							@media screen and (max-width: 768px) {
								#QRPanel-ScannerBox__scan_region > video {
									max-height: 180px;
									object-fit: cover;
								}
							}
						</style>
						<div id="QRPanel-ScannerBox-Outer" class="is-hidden">
							<div id="QRPanel-ScannerBox"></div>
						</div>
					</div>
					<div class="notification is-dark has-text-text-65 mx-4 mt-4 mb-0 scanning-instructions">
						<span class="icon-text">
							<span class="icon">
								<i class="fas fa-fw fa-info-circle"></i>
							</span>
							<span>
								Point your device camera or scanner gun at a QR code to select a valid sample.
							</span>
						</span>
					</div>
					<div class="columns m-0 is-mobile">
						<div class="column is-6">
							<button type="button" id="SampleScan-CameraButton" class="button is-primary is-fullwidth" onclick="_Pict.views.SampleScan.toggleCamera()">
								<span class="icon mr-3">
									<i class="fas fa-fw fa-camera-viewfinder"></i>
								</span>
								<span class="icon-text icon-text-for-open-button">Open Camera</span>
								<span class="icon-text icon-text-for-close-button">Close Camera</span>
							</button>
						</div>
					</div>
				
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'SampleScan',
				TemplateHash: 'SampleScan',
				DestinationAddress: '#SampleScan-Container',
			},
		],
};

},{"pict-view":733}],1572:[function(require,module,exports){
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.DefaultSearchFilters = {
			IDCustomer: null,
			Projects: [],
			Materials: [],
			MixDesigns: [],
			StartDate: '',
			EndDate: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'CreateDate',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		// this is the active sample that is selected; will be one we see in the "Sample Details" panel, etc.
		this.selectedSample = {};

		// make the status a pretty little pill
		this.pict.MetaTemplate.addPattern('{~StatusPill:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpStatusValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			// get the status details, this will return a name, color, and icon for any status value
			const tmpStatus = this.pict.providers.SampleProvider.getSampleStatusMappedDetails(tmpStatusValue);
			const tmpDisplayTag =
			`
			<style>
				.is-unknown
				{
					background-color: transparent;
					border: 1px solid var(--bulma-text-70);
					/* the panels chrome is dark; without this the tag inherits .tag's dark text */
					color: var(--bulma-text-70);
				}
				.has-text-unkown
				{
					color: var(--bulma-text-70);
				}
			</style>
			<span class="tag is-rounded pl-1 ${tmpStatus?.color}">
				<span class="icon m-0 ${tmpStatus.iconColor}">
					<i class="fas fa-fw ${tmpStatus?.icon}"></i>
				</span>
				<span class="icon-text">${tmpStatus?.name}</span>
			</span>`;
			return tmpDisplayTag;
		});
	}

	onBeforeRenderAsync(pCallback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0;
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'SampleSearch-Projects',
			ParentID: 'SampleSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// MATERIAL Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			placeholder: 'Search by materials..',
			ElementID: 'SampleSearch-Materials',
			ParentID: 'SampleSearch-SearchEntry',
			URL: 'Materials',
			IDField: 'IDMaterial',
			TextField: 'Name',
		}, () =>
		{
			this.log.info('Select2 Materials initialized');
		});

		// MIX DESIGN Selector Filter
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters?.IDCustomer,
			placeholder: 'Search by mix designs...',
			ElementID: 'SampleSearch-MixDesigns',
			ParentID: 'SampleSearch-SearchEntry',
			URL: 'MixDesigns',
			IDField: 'IDMixDesign',
			TextField: 'MixID',
		}, () =>
		{
			this.log.info('Select2 Mix Designs initialized');
		});

		// START DATE date picker
		window.flatpickr('#SampleSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				/** @type {any}  silence _flatpickr error */
				const siblingElement = document.getElementById('SampleSearch-EndDate');
				siblingElement._flatpickr.config.minDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#SampleSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'SampleSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				/** @type {any}  silence _flatpickr error */
				const siblingElement = document.getElementById('SampleSearch-StartDate');
				siblingElement._flatpickr.config.maxDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		this.setCurrentSearchFilters();

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method performs a search based on the current search filters.
	 * @param {Event} event - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleSampleSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#SampleSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('SampleSearch-Results-Container', this.CurrentSearchFilters.PageSize, '2.5rem');
		// collapse the filter panel to get out the way of the results
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters', 'close');
		// perform the search
		const tmpSearchResults = await this.pict.providers.SampleProvider.performSampleSearch(this.CurrentSearchFilters);
		// update the search results/UI based on the search results and total search count passed in
		this.updateWithSearchResults(tmpSearchResults.results, tmpSearchResults.count);
	}

	/**
	 * This function is used to handle the selection of a sample from the search results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDSample - The ID of the sample that was selected
	 * @param {object} pContext - The context of the sample that was selected
	 * @return {void}
	 */
	handleSampleSelection(event, pIDSample, pContext)
	{
		if (!pIDSample)
		{
			this.log.error('No IDSample provided');
			return;
		}
		if (event)
		{
			event.preventDefault();
			if (event.target instanceof HTMLElement)
			{
				// add loading class to button if it exists
				// TODO: probably should have a "find the parents until the button" function to handle this
				if (event.target?.classList?.contains('button'))
				{
					event.target.classList.add('is-loading');
				}
				else if (event.target?.parentElement?.classList?.contains('button'))
				{
					event.target.parentElement.classList.add('is-loading');
				}
				else if (event.target?.parentElement?.parentElement?.classList?.contains('button'))
				{
					event.target.parentElement.parentElement.classList.add('is-loading');
				}
				else
				{
					this.log.info('No button found to add loading class to');
				}
			}
		}
		// handle the context of the sample selection
		if (pContext === 'Add')
		{
			if (this.pict.views.SampleSearch.sampleSelectionCallback)
			{
				if (this.pict.views.SampleSearch.CurrentSearchResults.length > 0)
				{
					const tmpSample = this.pict.views.SampleSearch.CurrentSearchResults.find((pSample) => pSample.IDSample == pIDSample);
					this.pict.views.SampleSearch.sampleSelectionCallback(tmpSample);
					this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'close');
				}
			}
		}
		else if (pContext === 'Details')
		{
			this.pict.views.SampleDetails.showSampleDetailView(pIDSample, null, 'Details');
		}
		else
		{
			this.log.error('Unknown context for handleSampleSelection()!', { pContext });
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.SampleSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.SampleSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.SampleSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.SampleSearch.handleSampleSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.SampleSearch.handleSampleSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], Materials: [5678]})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('SampleSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#SampleSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#SampleSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#SampleSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#SampleSearch-Materials', this.CurrentSearchFilters?.Materials);
			this.pict.ContentAssignment.assignContent('#SampleSearch-MixDesigns', this.CurrentSearchFilters?.MixDesigns);
			this.pict.ContentAssignment.assignContent('#SampleSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#SampleSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#SampleSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.Materials && my.Materials.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Materials.length;
		}
		if (my.MixDesigns && my.MixDesigns.length > 0)
		{
			this.CurrentSearchFiltersCount += my.MixDesigns.length;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setSampleSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setSampleSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.sampleSearchResultsCallback = pCallback;
	}


	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Projects');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#SampleSearch-Projects');
			break;
		case 'Material':
		case 'Materials':
			this.CurrentSearchFilters.Materials = this.pict.ContentAssignment.readContent('#SampleSearch-Materials');
			break;
		case 'MixDesign':
		case 'MixDesigns':
			this.CurrentSearchFilters.MixDesigns = this.pict.ContentAssignment.readContent('#SampleSearch-MixDesigns');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#SampleSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#SampleSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SortBy':
			const tempSortBy = this.pict.ContentAssignment.readContent('#SampleSearch-SortBy');
			this.CurrentSearchFilters.SortBy = typeof tempSortBy == 'string' ? tempSortBy.split('_')[0] : 'CreateDate';
			this.CurrentSearchFilters.SortDirection = typeof tempSortBy == 'string' ? tempSortBy.split('_')[1] : 'DESC';
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.SampleSearch.renderAsync('SampleSearch-Results', '#SampleSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#SampleSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.SampleSearch.renderAsync('SampleSearch-Pagination', '#SampleSearch-Pagination-Container', false, false, () =>
			{
				this.log.info('Sample Search Pagination rendered');
			});
			// if there is a callback function, call it
			if (this.sampleSearchResultsCallback)
			{
				this.sampleSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}
}

module.exports = SampleSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleSearch',
	DefaultRenderable: 'SampleSearch-Entry',
	DefaultDestinationAddress: '#SampleSearch-Entry-Container',
	Templates:
		[
			{
				Hash: 'SampleSearch-Entry',
				Template: /*html*/`
				<div id="SampleSearch-SearchEntry" class="container">
					<form autocomplete="off" role="sample-search" onsubmit="_Pict.views.SampleSearch.handleSampleSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="SampleSearchFilters">
							<div class="columns mb-0 is-hidden">
								{~T:SampleSearch-Entry-CurrentPage~}
								{~T:SampleSearch-Entry-PageSize~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-MaterialSelector~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-MixDesignSelector~}
							</div>
							<div class="columns mb-0">
								{~T:SampleSearch-Entry-StartDate~}
								{~T:SampleSearch-Entry-EndDate~}
								{~T:SampleSearch-Entry-SortBy~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="SampleSearch-Pagination-Container" style="flex:auto"></div>
							<button 
								id="SampleSearch-ToggleButton"
								type="button"
								title="Toggle filters" 
								class="button is-primary is-soft" 
								data-collapsible-toggle="SampleSearchFilters" 
								onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('SampleSearchFilters')"
							>
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="SampleSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:SampleSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" title="Reset search" id="SampleSearch-ResetButton" onclick="_Pict.views.SampleSearch.resetSearchFilters()"><i class="fas fa-fw fa-undo mr-1"></i> Clear Filters</button>
							<button class="button is-primary" type="submit" title="Search samples" id="SampleSearch-SearchButton"><i class="fas fa-fw fa-search mr-1"></i> Search Samples</button>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'SampleSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="SampleSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.SampleSearch.updateSearchFilterValue('CurrentPage')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-PageSize" class="block">Page Size</label>
						<input 
							id="SampleSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.SampleSearch.updateSearchFilterValue('PageSize')" 
							value="" 
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="SampleSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-Projects" 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('Projects')"
								multiple
							>{~TS:SampleSearch-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Projects~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Enty-ProjectSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'SampleSearch-Entry-MaterialSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="SampleSearch-Materials">Materials</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-Materials" 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('Materials')"
								multiple
							>{~TS:SampleSearch-Entry~MaterialSelector-SelectedOptions:Context[0].CurrentSearchFilters.Materials~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-MaterialSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDMaterial~}" selected>{~D:Record.Name~}</option>`,
			},
			{
				Hash: 'SampleSearch-Entry-MixDesignSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="SampleSearch-MixDesigns">Mix Designs</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-MixDesigns" 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('MixDesigns')"
								multiple
							>{~TS:SampleSearch-Entry~MixDesignSelector-SelectedOptions:Context[0].CurrentSearchFilters.MixDesigns~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-MixDesignSelector-SelectedOptions',
				Template: /*html*/`<option value="{~D:Record.IDMixDesign~}" selected>{~D:Record.MixID~}</option>`,
			},
			{
				Hash: 'SampleSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="SampleSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="SampleSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="SampleSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="SampleSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.SampleSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="CreateDate_DESC">Create Date (Newest)</option>
								<option value="CreateDate_ASC">Create Date (Oldest)</option>
								<option value="Status_ASC">Status (A-Z)</option>
								<option value="Status_DESC">Status (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Results',
				Template: /*html*/`
				<div id="SampleSearch-Results-Container" class="container table-container">
					{~TIfAbs:SampleSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:SampleSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'SampleSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Create Date</th>
							<th>Project</th>
							<th>Material</th>
							<th>Mix Design</th>
							<th class="has-text-centered">Status</th>
							<th class="has-text-centered">Details</th>
							{~T:SampleSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="SampleSearch-Results-Entries">
						{~TS:SampleSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'SampleSearch-Results-Row',
				Template: /*html*/`
				<tr>
					<td>{~DateFormat:Record.CreateDate^YYYY-MM-DD~}</td>
					<td>
						{~TIfAbs:SampleSearch-Results-EntityValue-Project:Record:Record.IDProject^>^0~}
						{~TIfAbs:SampleSearch-Results-EntityValue-NA:Record:Record.IDProject^<=^0~}
					</td>
					<td>
						{~TIfAbs:SampleSearch-Results-EntityValue-Material:Record:Record.IDMaterial^>^0~}
						{~TIfAbs:SampleSearch-Results-EntityValue-NA:Record:Record.IDMaterial^<=^0~}
					</td>
					<td>
						{~TIfAbs:SampleSearch-Results-EntityValue-MixDesign:Record:Record.IDMixDesign^>^0~}
						{~TIfAbs:SampleSearch-Results-EntityValue-NA:Record:Record.IDMixDesign^<=^0~}
					</td>
					<td class="has-text-centered">
						{~StatusPill:Record.Status~}
					</td>
					<td class="has-text-centered is-vcentered">
						<button type="button" class="button is-ghost has-text-primary-75 p-0" title="See Details" onclick="_Pict.views.SampleSearch.handleSampleSelection(event, '{~D:Record.IDSample~}', 'Details')">
							<span class="icon">
								<i class="fas fa-fw fa-lg fa-circle-ellipsis"></i>
							</span>
						</button>
					</td>
					{~T:SampleSearch-Results-Extra-Column:Record~}
				</tr>`,
			},
			{
				Hash: 'SampleSearch-Results-Extra-Header',
				Template: /*html*/`<th class="has-text-centered" data-panel-mode-show-if="add-to-set">Select</th>`,
			},
			{
				Hash: 'SampleSearch-Results-Extra-Column',
				Template: /*html*/`
				<td class="has-text-centered is-vcentered" data-panel-mode-show-if="add-to-set">
					<button type="button" class="button is-ghost has-text-primary-75 p-0" title="Select Sample" onclick="_Pict.views.SampleSearch.handleSampleSelection(event, '{~D:Record.IDSample~}', 'Add')">
						<span class="icon">
							<i class="fa fa-fw fa-lg fa-plus-circle"></i>
						</span>
					</button>
				</td>`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'SampleSearch-Results-DatumValue-NA',
				Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-Project',
				Template: /*html*/`{~Entity:Project^Record.IDProject^SampleSearch-Results-Project^~}`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-Material',
				Template: /*html*/`{~Entity:Material^Record.IDMaterial^SampleSearch-Results-Material^~}`,
			},
			{
				Hash: 'SampleSearch-Results-EntityValue-MixDesign',
				Template: /*html*/`{~Entity:MixDesign^Record.IDMixDesign^SampleSearch-Results-MixDesign^~}`,
			},
			{
				Hash: 'SampleSearch-Results-DatumValue-Status',
				Template: /*html*/`{~D:Record.Status~}`,
			},
			{
				Hash: 'SampleSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any samples based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'SampleSearch-Results-Material',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'SampleSearch-Results-MixDesign',
				Template: /*html*/`{~D:Record.MixID~}`,
			},
			{
				Hash: 'SampleSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'SampleSearch-Pagination',
				Template: /*html*/`
				<nav id="SampleSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="SampleSearch-PreviousButton" type="button" title="Previous page" class="button is-soft mr-2" onclick="_Pict.views.SampleSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="SampleSearch-NextButton" type="button" title="Next page" class="button is-soft" onclick="_Pict.views.SampleSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'SampleSearch-Entry',
				TemplateHash: 'SampleSearch-Entry',
				DestinationAddress: '#SampleSearch-Entry-Container',
			},
			{
				RenderableHash: 'SampleSearch-Entry-ProjectSelector',
				TemplateHash: 'SampleSearch-Entry-ProjectSelector',
				DestinationAddress: '#SampleSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'SampleSearch-Entry-MaterialSelector',
				TemplateHash: 'SampleSearch-Entry-MaterialSelector',
				DestinationAddress: '#SampleSearch-Entry-MaterialSelector',
			},
			{
				RenderableHash: 'SampleSearch-Entry-MixDesignSelector',
				TemplateHash: 'SampleSearch-Entry-MixDesignSelector',
				DestinationAddress: '#SampleSearch-Entry-MixDesignSelector',
			},
			{
				RenderableHash: 'SampleSearch-Entry-ActiveFilterCount',
				TemplateHash: 'SampleSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#SampleSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'SampleSearch-Results',
				TemplateHash: 'SampleSearch-Results',
				DestinationAddress: '#SampleSearch-Results-Container',
			},
			{
				RenderableHash: 'SampleSearch-Pagination',
				TemplateHash: 'SampleSearch-Pagination',
				DestinationAddress: '#SampleSearch-Pagination-Container',
			},
		],
};

},{"pict-view":733}],1573:[function(require,module,exports){
const PictViewClass = require('pict-view');
const ComprehensionProcessor = require('headlight-comprehension-processor');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class TestInstanceWizard extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.wizardStep = 1;
		this.finalStep = 3;
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.SelectedIDTest = 0;
		this.testsToCreate = [];
		this.documentList = [];
		this.formsToCreate = [];
		this.decoratedDocumentRecords = [];
		/** @type {?Function} */
		this.onTestsCreated = null;
	}

	async continue()
	{
		const continueButton = document.getElementById('TestInstanceWizard-Continue');
		continueButton.classList.add('is-loading');

		switch (this.wizardStep)
		{
			case 1:
				if (!this.testsToCreate.length)
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'No Tests were selected.',
						type: 'is-danger',
					});
					continueButton.classList.remove('is-loading');
					return;
				}
				const foundManifests = [];
				const allSatisfiedIDTests = this.formsToCreate.flatMap((f) => f.SatisfiedIDTests || []);
				const testsForForms = allSatisfiedIDTests.length > 0
					? await this.pict.providers.TestInstanceProvider.getTestsByIDs(allSatisfiedIDTests)
					: [];
				const hashMap = {};
				testsForForms.forEach(t =>
				{
					hashMap[t.Hash] = t;
				});
				for (let f of this.formsToCreate)
				{
					if (f.IDReportNamedInstance)
					{
						const satisfiedHashes = f.SatisfiedTestHashes || [f.TestHash];
						this.decoratedDocumentRecords.push(
							{
								Index: this.decoratedDocumentRecords.length,
								Name: `${ satisfiedHashes.join(', ') } for Sample ${ this.AppData.SampleDetails.QRCode }`,
								DocumentType: f.Hash,
								Tests: satisfiedHashes.map((h) => hashMap[h]).filter(Boolean),
								FormattedTests: [f],
								Type: f.Name
							}
						);
						if (f.LabName)
						{
							const rec = this.decoratedDocumentRecords[this.decoratedDocumentRecords.length - 1];
							rec.Name = `${rec.Name} in ${f.LabName}`;
						}
					}
					else
					{
						foundManifests.push(f);
					}
				}
				if (foundManifests.length)
				{
					const rnis = await this.pict.services.MaterialsFormManager._getAvailableRNIs(this.AppData.SampleDetails?.IDProject);
					let foundGenericMaterialForm = null;
					for (let r of rnis)
					{
						//if (r.Options.TidingsData.Type === 'materials-form' && !foundGenericMaterialForm)
						if (r.GUIDReportNamedInstance == 'LADOTD-LIMS-ContainerForm' && !foundGenericMaterialForm)
						{
							foundGenericMaterialForm = r;
						}
					}
					if (foundGenericMaterialForm)
					{
						const foundManifestsByLab = {};
						for (let f of foundManifests)
						{
							const labName = f.LabName || '';
							if (!foundManifestsByLab[labName])
							{
								foundManifestsByLab[labName] = [];
							}
							foundManifestsByLab[labName].push(f);
						}
						for (const labName of Object.keys(foundManifestsByLab))
						{
							const labManifests = foundManifestsByLab[labName];
							this.decoratedDocumentRecords.push(
								{
									Index: this.decoratedDocumentRecords.length,
									Name: `${ labManifests.map(f => f.TestHash).join(', ') } for Sample ${ this.AppData.SampleDetails.QRCode }`,
									DocumentType: foundGenericMaterialForm.Hash,
									Tests: [...labManifests.map(f => hashMap[f.TestHash])],
									FormattedTests: labManifests,
									Type: foundGenericMaterialForm.Name
								}
							);
							if (labName)
							{
								const rec = this.decoratedDocumentRecords[this.decoratedDocumentRecords.length - 1];
								rec.Name = `${rec.Name} in ${labName}`;
							}
						}
					}
				}
				break;
			case 2:
				const docsToPush = [];
				const comprehensionsToPush = [];
				for (const d of this.decoratedDocumentRecords)
				{
					const tempDoc = {
						Name: d.Name,
						DocumentType: d.DocumentType,
						IDProject: this.AppData.SampleDetails?.IDProject,
						Form: 1
					};
					for (const f of d.FormattedTests)
					{
						if (f.LabID > 0 && !f.TestInstance)
						{
							f.TestInstance = { IDProject: this.AppData.SampleDetails?.IDProject, IDLab: f.LabID };
						}
					}
					comprehensionsToPush.push(await this.pict.services.MaterialsFormManager.applyMaterialTestsToDocumentRecord(d.FormattedTests, tempDoc, this.AppData.SampleDetails?.GUIDSample));
					docsToPush.push(tempDoc);
				}
				console.log('Documents to push: ', docsToPush);
				console.log('Comprehensions to push: ', comprehensionsToPush);
				this.uploadData(docsToPush, comprehensionsToPush);
				break;
			case 3:
				break;
			default:
				this.pict.log.warn(`Step in TestInstance creation was not found, this should not happen.`);
				break;
		}
		this.wizardStep += 1;

		this.renderAsync(()=>
		{
			const steps = document.querySelectorAll('#TestInstanceWizard-Steps-List li');
			steps.forEach((step, i) =>
			{
				if (i + 1 === this.wizardStep - 1)
				{
					step.classList.add('prev-active');
				}
				else
				{
					step.classList.remove('prev-active');
				}
				if (i + 1 === this.wizardStep)
				{
					step.classList.add('is-active');
				}
				else
				{
					step.classList.remove('is-active');
				}
			});
			const stepBodies = document.querySelectorAll('#TestInstanceWizard-Body-Pane > div');
			stepBodies.forEach((stepBody, i) =>
			{
				if (i + 1 === this.wizardStep)
				{
					stepBody.classList.add('is-active');
				}
				else
				{
					stepBody.classList.remove('is-active');
				}
			});
			if (this.wizardStep === this.finalStep)
			{
				document.getElementById('TestInstanceWizard-Continue').classList.add('is-hidden');
			}
			document.getElementById('TestInstanceWizard-Continue').classList.remove('is-loading');
		});
	}

	updateDocumentName(index)
	{
		// @ts-ignore
		this.decoratedDocumentRecords[index].Name = document.getElementById(`DocumentCreate-Entry-Name-${ index }`)?.value;
	}

	async uploadData(documents, comprehensions)
	{
		this.fable.addServiceType('ComprehensionProcessor', ComprehensionProcessor);

		/** @type {ComprehensionProcessor} */
		const processor = this.fable.instantiateServiceProviderWithoutRegistration('ComprehensionProcessor', this.options);
		for (let d of documents)
		{
			await this.pict.providers.DocumentProvider.createDocument(d, true);
		}
		for (let c of comprehensions)
		{
			await new Promise((resolve, reject) => 
			{
				processor.integrateComprehension(c, () =>
				{
					resolve();
				});
			});
		}
		if (this.onTestsCreated)
		{
			const fOnTestsCreated = this.onTestsCreated;
			this.onTestsCreated = null;
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			fOnTestsCreated();
		}
		else if (this.pict.views.LIMSSampleRecordView)
		{
			this.pict.views.LIMSSampleRecordView.renderAsync(()=>
			{
				this.pict.views.LIMSSampleRecordView.toggleTabContent({ currentTarget: document.getElementById('LIMSSampleRecordPanel-TestInstance-Tab') }, 'LIMSSampleRecordPanel-TestInstances');
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			});
		}
		else
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		}
	}

	/**
	 * Toggles the disabled attribute on/off for the passed in elements
	 * @param {Array.<{id:string, title:string}>} elements - {id: id of the element to target, title: tooltip when not disabled }
	 * @param {string} disabledText (optional) - tooltip to display when element is disabled
	 */
	toggleDisabled(elements, disabledText)
	{
		for (const [ key ] of Object.entries(elements))
		{
			const element = elements[key];
			if (!element.hasOwnProperty('id') )
			{
				continue;
			}
			const el = document.getElementById(element.id);

			if (!el)
			{
				continue;
			}

			if (el.hasAttribute('disabled'))
			{
				this.pict.ContentAssignment.removeAttribute(`#${element.id}`, 'disabled');
				if (element.title && typeof element.title === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', element.title );
				}
			}
			else
			{
				this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'disabled', 'disabled');
				if (typeof disabledText === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', disabledText);
				}
			}
		};
	}

	/**
	 * This method resets the state of the Wizard Panel view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetTestInstanceWizardView()
	{
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.SelectedIDTest = 0;
		this.documentList = [];
		this.testsToCreate = [];
		this.formsToCreate = [];
		this.decoratedDocumentRecords = [];
		this.wizardStep = 1;
		this.setSampleData();
		this.pict.HeadlightPanels.leftPanelCustomWidth(75);
		this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
		this.pict.HeadlightPanels.rightPanelHide();
	}

	setSampleData()
	{
		for (const d of (this.AppData.ActiveLIMSSampleDocuments || []))
		{
			if (!d.Locked)
			{
				this.documentList.push(d);
			}
		}
	}

	async addDefaultTests()
	{
		let sampleLabIDs = await this.pict.services.MaterialsFormManager.getSampleLabIDs(this.AppData.SampleDetails?.IDSample);
		if (!Array.isArray(sampleLabIDs) || sampleLabIDs.length < 1)
		{
			sampleLabIDs = null;
		}
		// The sample's line items are its SampleLineItemJoins (Sample.IDLineItem is not used).
		const sampleLineItemIDs = await this.pict.services.MaterialsFormManager.getSampleLineItemIDs(this.AppData.SampleDetails?.IDSample);
		const defaults = await this.pict.services.MaterialsFormManager.getMaterialTestDefaults(this.AppData.SampleDetails?.IDMaterial, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.MaterialType, sampleLabIDs, undefined, sampleLineItemIDs);
		console.log('Found defaults: ', defaults);
		if (defaults.length)
		{
			const allSatisfiedIDTests = defaults.flatMap((f) => f.SatisfiedIDTests || []);
			const defaultTests = allSatisfiedIDTests.length > 0
				? await this.pict.providers.TestInstanceProvider.getTestsByIDs(allSatisfiedIDTests)
				: [];
			this.addTests(defaultTests.map(t => { return { IDTest: t.IDTest } }));
			this.addForms(defaults);
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: `No Default Tests found for this Sample.`,
				type: 'is-warning',
			});
		}
	}

	/**
	 * The lab a test added by hand routes to: the sample's default routing when it covers the test, otherwise
	 * the sample's first lab, which is where the concierge falls back to.
	 * @param {number} pIDTest - The test being added
	 * @return {Promise<{ LabID: number, LabName: string }>} LabID is 0 when nothing resolves
	 */
	async getLabForTest(pIDTest)
	{
		const tmpManager = this.pict.services.MaterialsFormManager;
		let tmpSampleLabIDs = await tmpManager.getSampleLabIDs(this.AppData.SampleDetails?.IDSample);
		if (!Array.isArray(tmpSampleLabIDs) || tmpSampleLabIDs.length < 1)
		{
			tmpSampleLabIDs = null;
		}
		const tmpSampleLineItemIDs = await tmpManager.getSampleLineItemIDs(this.AppData.SampleDetails?.IDSample);
		const tmpDefaults = await tmpManager.getMaterialTestDefaults(this.AppData.SampleDetails?.IDMaterial, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.MaterialType, tmpSampleLabIDs, undefined, tmpSampleLineItemIDs);
		const tmpDefault = tmpDefaults.find((pDefault) => pDefault.LabID > 0 && (pDefault.SatisfiedIDTests || []).includes(pIDTest));
		if (tmpDefault)
		{
			return { LabID: tmpDefault.LabID, LabName: tmpDefault.LabName || '' };
		}
		return { LabID: (tmpSampleLabIDs && tmpSampleLabIDs[0]) || 0, LabName: '' };
	}

	async addActiveTest()
	{
		if (!this.SelectedIDTest)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Test was selected to add.',
				type: 'is-danger',
			});
			return;
		}
		const tempForm = await this.pict.services.MaterialsFormManager.getTestDefinitionForTestID(this.SelectedIDTest, this.AppData.SampleDetails?.IDProject, this.AppData.SampleDetails?.IDMaterial);
		if (tempForm)
		{
			// @ts-ignore
			const tmpIDTest = parseInt(this.SelectedIDTest);
			const tmpLab = await this.getLabForTest(tmpIDTest);
			if (!(tmpLab.LabID > 0))
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'No Lab was found for this Test, so it will not route to a Lab.',
					type: 'is-warning',
				});
			}
			this.addTests([{ IDTest: tmpIDTest }]);
			this.addForms([Object.assign({ }, tempForm, tmpLab)]);
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'No Form is available for this Test.',
				type: 'is-warning',
			});
		}
	}

	/**
	 * Open the wizard for the sample in AppData.SampleDetails.
	 * @param {Object} [pOptions]
	 * @param {Function} [pOptions.onTestsCreated] - Called once the tests and their documents are saved, instead of
	 * 	refreshing the legacy LIMS sample view.
	 */
	openTestInstanceWizard(pOptions)
	{
		this.resetTestInstanceWizardView();
		this.onTestsCreated = (pOptions && (typeof pOptions.onTestsCreated === 'function')) ? pOptions.onTestsCreated : null;
		this.pict.views.HeadlightPanels.handlePanelToggle('TestInstanceWizard', 'open');
	}

	async addTests(testArray)
	{
		this.testsToCreate = this.testsToCreate.concat(testArray).sort((a, b) => a.IDTest - b.IDTest);
		this.renderAsync();
	}

	addForms(formsArray)
	{
		this.formsToCreate = this.formsToCreate.concat(formsArray).sort((a, b) => a.TestHash - b.TestHash);
	}

	async removeTest(test)
	{
		const tempTests = [];
		
		let found = false;
		for (const t of this.testsToCreate)
		{
			if (test !== t.IDTest || found)
			{
				tempTests.push(t);
			}
			else
			{
				found = true;
			}
		}
		this.testsToCreate = tempTests.sort();
		const tempTest = await this.pict.providers.TestInstanceProvider.getTestByID(test);
		const tempForms = [];
		for (let f of this.formsToCreate)
		{
			const satisfiedHashes = f.SatisfiedTestHashes || [f.TestHash];
			const satisfiedIDTests = f.SatisfiedIDTests || [];
			if (!satisfiedHashes.includes(tempTest.Hash))
			{
				// This form doesn't cover the removed test; keep it as-is
				tempForms.push(f);
			}
			else if (satisfiedHashes.length > 1)
			{
				// This form covers the removed test but also satisfies others; keep it
				// with the removed test's entries pruned from the satisfied lists
				const hashIdx = satisfiedHashes.indexOf(tempTest.Hash);
				f.SatisfiedTestHashes = satisfiedHashes.filter((h) => h !== tempTest.Hash);
				f.SatisfiedIDTests = satisfiedIDTests.filter((id) => id !== test);
				tempForms.push(f);
			}
			// else: form only satisfied this one test — drop it entirely
		}
		this.formsToCreate = tempForms.sort();
		this.renderAsync();
	}

	/**
	 * This method is used to handle the closing of the Wizard panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close panel and cancel Test creation?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		},
		null);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		return super.onAfterRender(pRenderable);
	}

	async onAfterRenderAsync(callback)
	{
		this.CurrentSearchFilters.IDCustomer = this.AppData?.CurrentUser.CustomerID || 0;

		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			placeholder: 'Select a Test..',
			ElementID: 'TestInstanceWizard-TestSelector',
			ParentID: 'TestInstanceWizard-Step-1',
			URL: 'Tests',
			IDField: 'IDTest',
			TextField: ['Hash', 'Name'],
		}, () =>
		{
			this.log.info('Select2 Tests initialized');
		});
		callback();
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						},
						{
							field: 'Active',
							comparator: 'EQ',
							target: '1',
						},
						{
							field: '',
							target: '',
							comparator: 'FOP',
						},
						{
							field: 'Standalone',
							comparator: 'EQ',
							target: '1',
						},
						{
							field: 'Injectable',
							comparator: 'EQ',
							target: '1',
							connector: 'OR'
						},
						{
							field: '',
							target: '',
							comparator: 'FCP',
						}],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// Spec-year scope: narrow to tests reachable from the contract's
					// material spec set (via TSMTJ+TSSTJ). Resolver returns null when
					// the gate fails open (no FK, empty stub, no spec infra), which
					// leaves the picker at its default customer-wide filter.
					const tmpAllowedTestIDs = _Pict.providers.SpecScopeResolver?.getAllowedTestIDs?.();
					if (tmpAllowedTestIDs && tmpAllowedTestIDs.size > 0)
					{
						tmpSearchQuery.filters.push({
							field: 'IDTest',
							comparator: 'INN',
							target: Array.from(tmpAllowedTestIDs).join(','),
						});
					}
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: 'Hash',
							comparator: 'LK',
							target: params.term,
							connector: 'OR'
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.TestInstanceWizard.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption, true),
						more: params.term ? data.length === _Pict.views.TestInstanceWizard.CurrentSearchFilters.PageSize : data.length === _Pict.views.TestInstanceWizard.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	handleOnCloseEvent(pEvent)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close panel and cancel Test creation?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.TestInstanceWizard.resetTestInstanceWizardView();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		});
	}

	handleOnPinPanelEvent(pEvent)
	{
		this.pict.views.TestInstanceWizard.toggleDisabled(
		[
			{
				_id: 'TestInstanceWizard-CloseButton',
				title: 'Close panel',
			}
		],
		'Please unpin panel');

		this.pict.views.HeadlightPanels.togglePanelPinState();
	}

	updateIDTest(IDTest)
	{
		this.SelectedIDTest = IDTest;
	}
}

module.exports = TestInstanceWizard;

module.exports.default_configuration =
{
	ViewIdentifier: 'TestInstanceWizard',
	DefaultRenderable: 'TestInstanceWizard',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'TestInstanceWizard-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-TestInstanceWizardPanel" class="panel is-active">
				<p id="HeadlightPanels-TestInstanceWizardPanel-Header" class="panel-heading pr-4">
					<button id="TestInstanceWizard-CloseButton" type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.TestInstanceWizard.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" 
						onclick="_Pict.views.TestInstanceWizard.handleOnPinPanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-TestInstanceWizardPanel-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-TestInstanceWizardPanel-Header-Title" class="mr-3">Add Tests</span>
				</p>
				<div id="HeadlightPanels-TestInstanceWizard-Content">
					{~T:TestInstanceWizard-Content~}
				</div>
			</article>`,
		},
		{
			Hash: 'TestInstanceWizard-Content',
			Template: /*html*/`
			<header class="has-background-text-15">
				<ul id="TestInstanceWizard-Steps-List" class="wizard-list">
					<li id="Wizard-Tag-1" class="wizard-step-1 is-active"><div><span>Select Tests</span></div></li>
					<li id="Wizard-Tag-2" class="wizard-step-2"><div><span>Test Forms</span></div></li>
					<li id="Wizard-Tag-3" class="wizard-step-3 end-block"><div><span>Finalize</span></div></li>
				</ul>
			</header>
			<div id="TestInstanceWizard-Body-Pane">
				<div id="TestInstanceWizard-Step-1" class="wizard-pane is-active">
					{~T:TestInstanceWizard-Wizard-Step-1~}
				</div>
				<div id="TestInstanceWizard-Step-2" class="wizard-pane">
					{~T:TestInstanceWizard-Wizard-Step-2~}
				</div>
				<div id="TestInstanceWizard-Step-3" class="wizard-pane">
					{~T:TestInstanceWizard-Wizard-Step-3~}
				</div>
			</div>
			<div class="buttons is-right" style="width: 50px; position: absolute; top: calc(100% - 60px); right: 0.5rem;">
				<button id="TestInstanceWizard-Continue" title="Continue" onclick="_Pict.views.TestInstanceWizard.continue()" 
				style="float: right; margin: 10px;" class="button is-primary has-text-white has-shadow is-normal"><i class="fas fa-fw fa-square-chevron-right" style="margin-right: 5px;"></i>Continue</button>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-1',
			Template: /*html*/`
			<div class="container panel-content" id="TestInstanceWizard-Step-1" style="min-width: 100%;">
				<div class="columns px-4 mb-3 mt-3">
					<div class="column">
						{~T:TestInstanceWizard-TestSelector~}
						{~T:TestInstanceWizard-Tab-Tests-Items~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Tests-Items',
			Template: /*html*/`
			<div id="TestInstanceWizard-Tab-Tests-Items">
				<style>
					.test-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.test-entry
					{
						border-top: 1px solid var(--bulma-border);
						border-bottom: 1px solid var(--bulma-border);
					}
				</style>
				{~TS:TestInstanceWizard-Tab-Test-Item:Context[0].testsToCreate~}
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Test-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 test-entry">
				<div class="test-entry-row mx-4 my-2" style="flex-grow: 1">
					<div>{~Entity:Test^Record.IDTest^TestInstanceWizard-Entity^~}{~QuickSummary:Test^Record.IDTest~}</div>
					<button type="button" class="is-pulled-right hl-panel-close-button" 
						onclick="_Pict.views.TestInstanceWizard.removeTest({~D:Record.IDTest~})">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Entity',
			Template: /*html*/`{~D:Record.Hash~} {~D:Record.Name~}`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-2',
			Template: /*html*/`
			<div class="container panel-content" style="min-width: 100%;">
				<div id="TestInstanceWizard-Document-List">
					{~T:TestInstanceWizard-Tab-Documents:Context[0].decoratedDocumentRecords~}
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Wizard-Step-3',
			Template: /*html*/`
			<div class="container panel-content">
				<div class="p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<style>
								.lds-ring,
								.lds-ring div {
									box-sizing: border-box;
								}
								.lds-ring {
									display: inline-block;
									position: relative;
									width: 80px;
									height: 80px;
								}
								.lds-ring div {
									box-sizing: border-box;
									display: block;
									position: absolute;
									width: 64px;
									height: 64px;
									margin: 8px;
									border: 8px solid currentColor;
									border-radius: 50%;
									animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
									border-color: currentColor transparent transparent transparent;
								}
								.lds-ring div:nth-child(1) {
									animation-delay: -0.45s;
								}
								.lds-ring div:nth-child(2) {
									animation-delay: -0.3s;
								}
								.lds-ring div:nth-child(3) {
									animation-delay: -0.15s;
								}
								@keyframes lds-ring {
									0% {
										transform: rotate(0deg);
									}
									100% {
										transform: rotate(360deg);
									}
								}
							</style>
							<div class="lds-ring wizard-loader" style="color: white;"><div></div><div></div><div></div><div></div></div>
							<div class="is-size-6 has-text-centered" style="color: white; text-wrap: wrap: max-width: 50vw;">Creating Tests and Forms...</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-TestSelector',
			Template: /*html*/`
			<div style="margin-bottom: 10px; display: flex;">
				<div style="width: 100%; max-width: 30%; margin-right: 10px;">
					<div class="field">
						<label class="label block" for="TestInstanceWizard-TestSelector">Select a Test to Add:</label>
						<div class="control select is-fullwidth">
							<select 
								id="TestInstanceWizard-TestSelector" 
								onchange="_Pict.views.TestInstanceWizard.updateIDTest(value)"
							></select>
						</div>
					</div>
				</div>
				<div style="margin-right: 10px;"><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.TestInstanceWizard.addActiveTest()" class="button is-primary has-text-white is-normal"><i class="fas fa-fw fa-plus" style="margin-right: 5px;"></i>Add Selected Test</button></div>
				<div><label class="label block">&nbsp;</label><button type="button" onclick="_Pict.views.TestInstanceWizard.addDefaultTests()" class="button is-primary has-text-white is-normal"><i class="fas fa-fw fa-list" style="margin-right: 5px;"></i>Add Default Tests</button></div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents',
			Template: /*html*/`
				{~TIfAbs:TestInstanceWizard-Tab-Documents-Items:Record:Record.length^>^0~}
				{~TIfAbs:TestInstanceWizard-Tab-Documents-Empty:Record:Record.length^<=^0~}
			`
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No valid documents found to add this test to.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Items',
			Template: /*html*/`
			<div id="TestInstanceWizard-Tab-Documents-Items">
				<style>
					.document-entry-row
					{
						display:flex;
						justify-content: space-between;
					}
					.document-entry
					{
						border-top: 1px solid var(--bulma-border);
						border-bottom: 1px solid var(--bulma-border);
					}
					.document-status
					{
						margin-right: 10vw;
					}
				</style>
				<div style="margin-bottom: 10px; font-weight: bold; color: white; margin-left: 10px; margin-top: 10px;">Test Forms to Create:</div>
				{~TS:TestInstanceWizard-Tab-Documents-Item:Record~}
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4 document-entry">
				<div class="is-block-flex is-align-items-left mx-4 my-2" style="flex-grow: 1">
					<div class="field">
						<label class="label block" for="DocumentCreate-Entry-Name">Document Name</label>
						<div class="control">
							<input 
								id="DocumentCreate-Entry-Name-{~D:Record.Index~}" 
								class="input" 
								type="text" 
								placeholder="Enter a name for the Document..."
								autocomplete="off"
								value="{~D:Record.Name~}"
								onChange="_Pict.views.TestInstanceWizard.updateDocumentName({~D:Record.Index~})"
							/>
						</div>
					</div>
					<div class="document-entry-row is-size-7">
						<span>
							<b>Document Type:</b> {~D:Record.Type~}
						</span>
					</div>
					<div class="is-size-7">
						<b>Attached Tests:</b>
					</div>
					<div class="is-size-7">
						{~TS:TestInstanceWizard-Tab-Attached-Test-Item:Record.Tests~}
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Attached-Test-Item',
			Template: /*html*/`{~D:Record.Hash~} {~D:Record.Name~} <br />`,
		},
		{
			Hash: 'TestInstanceWizard-Tab-Documents-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'TestInstanceWizard',
			TemplateHash: 'TestInstanceWizard-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'TestInstanceWizard-Content',
			TemplateHash: 'TestInstanceWizard-Content',
			DestinationAddress: '#HeadlightPanels-TestInstanceWizard-Content',
			RenderType: 'replace',
		},
	],
};

},{"headlight-comprehension-processor":4,"pict-view":733}],1574:[function(require,module,exports){
module.exports={
    "HeadlightPanels-Pane-BridgesPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-BridgesPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-BridgesPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-BridgesPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-BridgesPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-BridgesPanel-Header\" class=\"panel-heading pr-4\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-BridgesPanel-Header-Icon\" class=\"fas fa-fw fa-bridge\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-BridgesPanel-Header-Title\">Bridges</span>\n    </div>\n    <div id=\"HeadlightPanels-BridgePanel-Content\" class=\"panel-content\">\n        <div id=\"HeadlightPanels-Bridges-SearchEntry\" class=\"container\">\n            <form autocomplete=\"off\" role=\"Bridge-search\" onsubmit=\"_Pict.views.HeadlightPaneBridges.handleBridgeSearch(event);\">\n                <div class=\"px-4 pt-4\" data-collapsible-content=\"BridgeSearchFilters\">\n                    <div class=\"columns\">\n                        <!-- TODO: convert this to an entity selector later -->\n                        <div class=\"column is-hidden\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchCounty\" class=\"block\">County</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchCounty\" placeholder=\"Enter a county\">\n                            </div>\n                        </div>\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchStructureNumber\" class=\"block\">Structure Number</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchStructureNumber\" placeholder=\"Enter a structure number\">\n                            </div>\n                        </div>\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchYear\" class=\"block\">Year Built</label>\n                                <input class=\"input\" type=\"number\" id=\"BridgesSearchYearBuilt\" placeholder=\"Enter a year\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"columns\">\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchFacilityCarried\" class=\"block\">Facility Carried</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchFacilityCarried\" placeholder=\"Enter a facility\">\n                            </div>\n                        </div>\n                        <div class=\"column\">\n                            <div class=\"field\">\n                                <label class=\"label\" for=\"BridgesSearchFeatureIntersected\" class=\"block\">Feature Intersected</label>\n                                <input class=\"input\" type=\"text\" id=\"BridgesSearchFeatureIntersected\" placeholder=\"Enter an intersection\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"buttons p-4 is-right\" data-theme=\"dark\">\n                    <div id=\"BridgeSearch-Pagination-Container\" style=\"flex:auto\"></div>\n                    <button \n                        id=\"BridgeSearch-ToggleButton\"\n                        type=\"button\" \n                        class=\"button is-primary is-soft\" \n                        data-collapsible-toggle=\"BridgeSearchFilters\" \n                        onclick=\"_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('BridgeSearchFilters')\"\n                    >\n                        <span class=\"icon\">\n                            <i class=\"fas fa-fw fa-filter\"></i>\n                        </span>\n                        <span>Set Filters</span>\n                        <!-- hide the badge until we fix the count to be accurate -->\n                        <span id=\"BridgeSearch-Entry-ActiveFilterCount\" class=\"is-hidden badge is-warning\">{~T:HeadlightPanels-Bridges-ActiveFilterCount~}</span>\n                    </button>\n                    <button class=\"button is-primary is-soft\" type=\"button\" id=\"BridgeSearch-ResetButton\" onclick=\"_Pict.views.HeadlightPaneBridges.resetSearchFilters()\"><i class=\"fas fa-fw fa-undo mr-1\"></i> Clear Filters</button>\n                    <button class=\"button is-primary\" type=\"submit\" id=\"BridgeSearch-SearchButton\"><i class=\"fas fa-fw fa-search mr-1\"></i> Search Bridges</button>\n                </div>\n            </form>\n        </div>\n        <div id=\"BridgePanel-SearchResults-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-BridgesPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-BridgesPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/BridgesPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-CommentsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-CommentsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-CommentsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-CommentsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-CommentPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-CommentPanel-Header\" class=\"panel-heading pr-4 {~D:options.HeadlightPanels.Configuration.CurrentDocument.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-CommentPanel-Header-Icon\" class=\"fas fa-fw fa-comment\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-CommentPanel-Header-Title\">Comments</span>\n    </div>\n    <div id=\"HeadlightPanels-CommentPanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Comments~}\n    </div>\n    <!-- Comment Panel Tabs -->\n    <!-- <div id=\"HeadlightPanels-CommentPanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\n        <a id=\"HeadlightPanels-CommentPanel-Current-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-CommentPanel-Current', 'Comment')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-comment\"></i>\n            </span>\n            <span title=\"Current comments\" class=\"icon-text\">\n                Current\n            </span>\n        </a>\n    </div> -->\n    <!-- Comment Panel Content > Current View -->\n    <div id=\"HeadlightPanels-CommentPanel-Current-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"CommentCurrent-Entry-Container\"></div>\n        <div id=\"CommentCurrent-Results-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-CommentsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-CommentsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/CommentsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-CustomPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-CustomPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-CustomPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-CustomPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}\" data-panel-mode=\"{~D:Context[0].options.PanelMode~}\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Header\" class=\"panel-heading pr-4\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Header-Icon\" class=\"fas fa-fw {~D:Context[0].options.PanelIcon~}\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Header-Title\">{~D:Context[0].options.PanelTitle~}</span>\n    </div>\n    <div id=\"HeadlightPanels-CustomPanel-{~D:Context[0].options.PanelName~}-Content\" class=\"panel-content\">\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-CustomPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-CustomPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/CustomPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-DocumentsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-DocumentsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-DocumentsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-DocumentsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-DocumentPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-DocumentPanel-Header\" class=\"panel-heading pr-4 {~D:options.HeadlightPanels.Configuration.CurrentDocument.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-DocumentPanel-Header-Icon\" class=\"fas fa-fw fa-files\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-DocumentPanel-Header-Title\">Documents</span>\n    </div>\n    <div id=\"HeadlightPanels-DocumentPanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Documents~}\n    </div>\n    <!-- Document Panel Tabs -->\n    <div id=\"HeadlightPanels-DocumentPanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\n        <a id=\"HeadlightPanels-DocumentPanel-Search-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Search', 'Document')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-search\"></i>\n            </span>\n            <span title=\"Search documents\" class=\"icon-text\">\n                Search\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-DocumentPanel-Create-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Create', 'Document')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-plus-circle\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Create\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-DocumentPanel-Current-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Current', 'Document')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-file\"></i>\n            </span>\n            <span title=\"Current document\" class=\"icon-text\">\n                Current\n            </span>\n        </a>\n    </div>\n    <!-- Document Panel Content > Search View -->\n    <div id=\"HeadlightPanels-DocumentPanel-Search-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"DocumentSearch-Entry-Container\"></div>\n        <div id=\"DocumentSearch-Results-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n    <!-- Document Panel Content > Create View -->\n    <div id=\"HeadlightPanels-DocumentPanel-Create-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"DocumentCreate-Container\"><!-- Injected from Document-View-Create.js --></div>\n    </div>\n    <!-- Document Panel Content > Current View -->\n    <div id=\"HeadlightPanels-DocumentPanel-Current-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"DocumentCurrent-Container\"><!-- Injected from Document-View-Current.js --></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-DocumentsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-DocumentsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/DocumentsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-NavigationPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-NavigationPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-NavigationPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-NavigationPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-NavigationPanel\" class=\"panel is-active is-dark\">\n    <p id=\"HeadlightPanels-NavigationPanel-Header\" class=\"panel-heading\">\n        <button type=\"button\" class=\"is-pulled-right hl-panel-close-button ml-2\" aria-label=\"close\" title=\"Close panel\" onclick=\"_Pict.views.HeadlightPanels.closeThisPanel(event)\">\n            <span class=\"icon\">\n                <i class=\"fas fa-fw fa-times-circle\" aria-hidden=\"true\"></i>\n            </span>\n        </button>\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-list-check\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Actions</span>\n    </p>\n    <div id=\"HeadlightPanels-NavigationPanel-Content\" class=\"panel-content\">\n        {~T:HeadlightPanels-NavigationPanel-NavList~}\n        {~TIfAbs:HeadlightPanels-NavigationPanel-ExtraButton:AppData:AppData.CurrentUser.UserRoleIndex^>=^4~}\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-NavigationPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-NavigationPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/NavigationPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-ObservationsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-ObservationsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-ObservationsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-ObservationsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-ObservationPanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-ObservationPanel-Header\" class=\"panel-heading pr-4 {~D:Pict.settings.HeadlightPanels.Configuration.CurrentObservation.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-ObservationPanel-Header-Icon\" class=\"fas fa-fw fa-images\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-ObservationPanel-Header-Title\">Observations</span>\n    </div>\n    <div id=\"HeadlightPanels-ObservationPanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Observations~}\n        {~T:HeadlightPanels-Header-ModeBanner-ObservationsToProjectFiles~}\n    </div>\n    <!-- Observation Panel Tabs -->\n    <div id=\"HeadlightPanels-ObservationPanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\t\n        <a id=\"HeadlightPanels-ObservationPanel-Included-Tab\" title=\"Included in form\" class=\"is-active {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-paperclip\"></i>\n            </span>\n            <span class=\"icon-text\">Included<span class=\"is-hidden-mobile\"> in form</span></span>\n        </a>\n        <a id=\"HeadlightPanels-ObservationPanel-Search-Tab\" title=\"Search observations\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-search\"></i>\n            </span>\n            <span class=\"icon-text\">Search</span>\n            </a>\n        <a id=\"HeadlightPanels-ObservationPanel-Upload-Tab\" title=\"Upload observations\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Upload', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-upload\"></i>\n            </span>\n            <span class=\"icon-text\">Upload</span>\n        </a>\n        <a id=\"HeadlightPanels-ObservationPanel-Sets-Tab\" title=\"Observation sets\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Sets', 'Observation')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-layer-group\"></i>\n            </span>\n            <span class=\"icon-text\">Sets</span>\n        </a>\n    </div>\n    <!-- Observation Panel Content > Included View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Included-Content\" class=\"panel-content panel-with-tabs-offset {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\">\n        {~T:HeadlightPanels-ObservationPanel-Included~}\n    </div>\n    <!-- Observation Panel Content > Search View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Search-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"ObservationSearch-Entry-Container\"></div>\n        <div id=\"ObservationSearch-Results-Container\" class=\"overflow-scroll-container-for-search-results\"></div>\n    </div>\n    <!-- Observation Panel Content > Upload View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Upload-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"ObservationCreateMedia-Container\"></div>\n    </div>\n    <!-- Observtion Panel Contenst > Sets View -->\n    <div id=\"HeadlightPanels-ObservationPanel-Sets-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"ObservationSet-Selector-Container\"></div>\n        <div id=\"ObservationSet-ActiveSet-Container\">{~T:ObservationSet-Unset~}</div>\n    </div>\n\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-ObservationsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-ObservationsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/ObservationsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-ProfilePaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-ProfilePaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-ProfilePaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-ProfilePaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-ProfilePanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-ProfilePanel-Header\" style=\"min-width:300px\" class=\"panel-heading pr-4 {~D:Pict.settings.HeadlightPanels.Configuration.CurrentProfile.wrapperClass~}\">\n        <button type=\"button\" class=\"is-pulled-right hl-panel-close-button\" aria-label=\"close\" title=\"Close panel\" onclick=\"_Pict.views.HeadlightPanels.closeThisPanel(event)\">\n            <span class=\"icon\">\n                <i class=\"fas fa-fw fa-times-circle\" aria-hidden=\"true\"></i>\n            </span>\n        </button>\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-ProfilePanel-Header-Icon\" class=\"fas fa-fw fa-user-circle\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-ProfilePanel-Header-Title\">User Profile</span>\n    </div>\n    <div id=\"HeadlightPanels-ProfilePanel-Content\" class=\"panel-content panel-has-nested-scroll-content\">\n        <div class=\"nested-scroll-content has-bottom-navbar-offset\">\n            <div class=\"columns px-5 pt-4 pb-2 mb-3 has-background-text-20\">\n                <div class=\"column\">\n                    <p class=\"title is-4 has-text-white\">{~D:AppData.CurrentUser.NameFirst~} {~D:AppData.CurrentUser.NameLast~}</p>\n                    <p class=\"subtitle is-6 has-text-text-65\">{~D:AppData.CurrentUser.Title~}</p>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">Login</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.LoginID~}</span>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">Email</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.Email~}</span>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">User Role</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.UserRole~}</span>\n                </div>\n            </div>\n            <div class=\"columns px-5\">\n                <div class=\"column\">\n                    <span class=\"title is-block is-6 has-text-text-60\">Timezone</span>\n                    <span class=\"subtitle is-6 has-text-text-90\">{~D:AppData.CurrentUser.Timezone~}</span>\n                </div>\n            </div>\n            <div class=\"columns\">\n                <div class=\"column\">\n                    <a class=\"panel-block px-5\" onclick=\"_Pict.views.HeadlightPaneProfile.navigateToProfileApp(event)\">\n                        <span class=\"panel-icon\">\n                            <i class=\"fas fa-edit has-text-primary-75\" aria-hidden=\"true\"></i>\n                        </span>\n                        <span class=\"has-text-primary-85\">Edit Profile</span>\n                    </a>\n                </div>\n            </div>\n            <div class=\"columns\">\n                <div class=\"column\">\n                    <a class=\"panel-block px-5\" href=\"#/Logout\" onclick=\"_Pict.PictApplication.logout()\">\n                        <span class=\"panel-icon\">\n                            <i class=\"fas fa-sign-out has-text-primary-75\" aria-hidden=\"true\"></i>\n                        </span>\n                        <span class=\"has-text-primary-85\">Logout</span>\n                    </a>\n                </div>\n            </div>\n        </div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-ProfilePaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-ProfilePaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/ProfilePane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SamplesPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SamplesPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SamplesPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SamplesPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SamplePanel\" data-panel-mode=\"\" class=\"panel is-active\">\n    <div id=\"HeadlightPanels-SamplePanel-Header\" class=\"panel-heading pr-4 {~D:options.HeadlightPanels.Configuration.CurrentDocument.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-SamplePanel-Header-Icon\" class=\"fas fa-fw fa-vial\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-SamplePanel-Header-Title\">Samples</span>\n    </div>\n    <div id=\"HeadlightPanels-SamplePanel-Header-ModeBanner\">\n        {~T:HeadlightPanels-Header-ModeBanner-Samples~}\n    </div>\n    <!-- Sample Panel Tabs -->\n    <div id=\"HeadlightPanels-SamplePanel-Tabs\" class=\"panel-tabs pr-6\">\t\t\t\t\t\n        <a id=\"HeadlightPanels-SamplePanel-Search-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Search', 'Sample')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-search\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Search\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-SamplePanel-Create-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Create', 'Sample')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-plus-circle\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Create\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-SamplePanel-Scan-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Scan', 'Sample')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-qrcode\"></i>\n            </span>\n            <span class=\"icon-text\">\n                Scan QR Code\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-SamplePanel-Current-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-SamplePanel-Current', 'Sample'); _Pict.views.SampleCurrent.handleTabOpened();\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-vial\"></i>\n            </span>\n            <span title=\"Samples on this document\" class=\"icon-text\">\n                Current\n            </span>\n        </a>\n    </div>\n    <!-- Sample Panel Content > Search View -->\n    <div id=\"HeadlightPanels-SamplePanel-Search-Content\" class=\"panel-content panel-with-tabs-offset\">\n\t\t<div id=\"SampleSearch-Entry-Container\"></div>\n        <div id=\"SampleSearch-Results-Container\" class=\"overflow-scroll-container-for-search-results\" style=\"min-width: 40vw;\"></div>\n    </div>\n    <!-- Sample Panel Content > Create View -->\n    <div id=\"HeadlightPanels-SamplePanel-Create-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"SampleCreate-Container\" style=\"min-width: 40vw;\"><!-- Injected from Sample-View-Create.js --></div>\n    </div>\n    <!-- Sample Panel Content > Scan View -->\n    <div id=\"HeadlightPanels-SamplePanel-Scan-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"SampleScan-Container\" style=\"min-width: 40vw;\"><!-- Injected from Sample-View-Scan.js --></div>\n    </div>\n    <!-- Sample Panel Content > Current View -->\n    <div id=\"HeadlightPanels-SamplePanel-Current-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div id=\"SampleCurrent-Container\" style=\"min-width: 40vw;\"><!-- Injected from Sample-View-Current.js --></div>\n    </div>\n</article>"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SamplesPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SamplesPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SamplesPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SecretPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SecretPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SecretPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SecretPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SecretPanel\" class=\"panel is-active is-dark\">\n    <p id=\"HeadlightPanels-SecretPanel-Header\" class=\"panel-heading\">\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-person-from-portal\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Secrets</span>\n    </p>\n    <div id=\"HeadlightPanels-SecretPanel-Content\" class=\"panel-content\">\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.PictFormMetacontroller.showSupportViewInlineEditor();_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'close')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-wrench\" aria-hidden=\"true\"></i>\n            </span>\n            Open Support View Inline Tool\n        </a>\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.providers.DocumentProvider.viewDocumentFile(null, true)\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-code\" aria-hidden=\"true\"></i>\n            </span>\n            View Document JSON\n        </a>\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.HeadlightPaneSecret.handleDocumentRefreshAndDownload(event)\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-download\" aria-hidden=\"true\"></i>\n            </span>\n            Regenerate PDF Download\n        </a>\n        <a class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" onclick=\"_Pict.views.HeadlightPaneSecret.toggleMinimumInputLengthForSearch(0)\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-filter-slash\" aria-hidden=\"true\"></i>\n            </span>\n            Disable All \"Minimum Input Length\"\n        </a>\n        <div class=\"panel-block {~Show:Pict.settings.HeadlightPanels.Configuration.PanelOptions.Context~}\" style=\"align-items: normal;\">\n            <span class=\"panel-icon mt-1\">\n                <i class=\"fas fa-palette\" aria-hidden=\"true\"></i>\n            </span>\n            <div class=\"field theme-dark\">\n                <label class=\"label\" for=\"HeadlightPanels-SecretPanel-Theme\">Theme</label>\n                <p class=\"control select is-fullwidth\" style=\"min-width: 250px;\">\n                    <select id=\"HeadlightPanels-SecretPanel-Theme\" onchange=\"_Pict.PictApplication.changeTheme(event.target.value)\">\n                        <option value=\"Edit\" selected>Edit (Default)</option>\n                        <option value=\"Read\">Read-only/Locked</option>\n                        <option value=\"Print\">Print/PDF</option>\n                    </select>\n                </p>\n            </div>\n        </div>\n        <div class=\"panel-block\" style=\"align-items: normal;\">\n            <span class=\"panel-icon mt-1\">\n                <i class=\"fas fa-ruler\" aria-hidden=\"true\"></i>\n            </span>\n            <div class=\"field theme-dark\">\n                <label class=\"label\" for=\"HeadlightPanels-SecretPanel-Theme\">Left Panel Width</label>\n                <p class=\"control select is-fullwidth\" style=\"min-width: 250px;\">\n                    <select id=\"HeadlightPanels-SecretPanel-Theme\" onchange=\"_Pict.views.HeadlightPanels.setPanelCustomWidth('left', event.target.value)\">\n                        <option value=\"75\" selected>Default</option>\n                        <option value=\"0\">0% (Hidden)</option>\n                        <option value=\"20\">20% (1/5th)</option>\n                        <option value=\"25\">25% (1/4th)</option>\n                        <option value=\"33\">33% (1/3rd)</option>\n                        <option value=\"40\">40% (2/5th)</option>\n                        <option value=\"50\">50% (1/2)</option>\n                        <option value=\"60\">60% (3/5th)</option>\n                        <option value=\"67\">67% (2/3rd)</option>\n                        <option value=\"75\">75% (3/4th)</option>\n                        <option value=\"80\">80% (4/5th)</option>\n                        <option value=\"100\">100% (Full)</option>\n                    </select>\n                </p>\n            </div>\n        </div>\n        <div class=\"panel-block\" style=\"align-items: normal;\">\n            <span class=\"panel-icon mt-1\">\n                <i class=\"fas fa-ruler\" aria-hidden=\"true\"></i>\n            </span>\n            <div class=\"field theme-dark\">\n                <label class=\"label\" for=\"HeadlightPanels-SecretPanel-Theme\">Right Panel Width</label>\n                <p class=\"control select is-fullwidth\" style=\"min-width: 250px;\">\n                    <select id=\"HeadlightPanels-SecretPanel-Theme\" onchange=\"_Pict.views.HeadlightPanels.setPanelCustomWidth('right', event.target.value)\">\n                        <option value=\"25\" selected>Default</option>\n                        <option value=\"0\">0% (Hidden)</option>\n                        <option value=\"20\">20% (1/5th)</option>\n                        <option value=\"25\">25% (1/4th)</option>\n                        <option value=\"33\">33% (1/3rd)</option>\n                        <option value=\"40\">40% (2/5th)</option>\n                        <option value=\"50\">50% (1/2)</option>\n                        <option value=\"60\">60% (3/5th)</option>\n                        <option value=\"67\">67% (2/3rd)</option>\n                        <option value=\"75\">75% (3/4th)</option>\n                        <option value=\"80\">80% (4/5th)</option>\n                        <option value=\"100\">100% (Full)</option>\n                    </select>\n                </p>\n            </div>\n        </div>\n        <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'open')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-chevron-left\" aria-hidden=\"true\"></i>\n            </span>\n            Back to Actions\n        </a>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SecretPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SecretPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SecretPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SettingsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SettingsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SettingsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SettingsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SettingsPanel\" class=\"panel is-active is-dark\">\n    <p id=\"HeadlightPanels-SettingsPanel-Header\" class=\"panel-heading\">\n        <button type=\"button\" class=\"is-pulled-right hl-panel-close-button\" aria-label=\"close\" title=\"Close panel\" onclick=\"_Pict.views.HeadlightPanels.handlePanelToggle('navigation', 'close')\">\n            <span class=\"icon\">\n                <i class=\"fas fa-fw fa-times-circle\" aria-hidden=\"true\"></i>\n            </span>\n        </button>\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-cogs\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Settings</span>\n    </p>\n    <div id=\"HeadlightPanels-SettingsPanel-Content\" class=\"panel-content\">\n        <a id=\"setting-DocumentTheme-light\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleDocumentColorTheme('light')\">\n        <span class=\"panel-icon\">\n            <i class=\"fas fa-sun\" aria-hidden=\"true\"></i>\n        </span>\n            Set Light Theme\n        </a>\n        <a id=\"setting-DocumentTheme-dark\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleDocumentColorTheme('dark')\">\n        <span class=\"panel-icon\">\n            <i class=\"fas fa-moon\" aria-hidden=\"true\"></i>\n        </span>\n            Set Dark Theme\n        </a>\n        <a id=\"setting-DocumentTheme-system\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleDocumentColorTheme('system')\">\n        <span class=\"panel-icon\">\n            <i class=\"fas fa-desktop\" aria-hidden=\"true\"></i>\n        </span>\n            Use System Theme\n        </a>\n\n        <!-- TODO: Revisit these once we separate out \"sticky panel that won't close\" vs \"flex background content shifts when panel opens/closes\" -->\n        <!-- <a id=\"setting-PanelOverlap-left\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.togglePanelOverlap('left')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-chevron-circle-right\" aria-hidden=\"true\"></i>\n            </span>\n            Panels Overlap Left\n        </a>\n        <a id=\"setting-PanelOverlap-right\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.togglePanelOverlap('right')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-chevron-circle-left\" aria-hidden=\"true\"></i>\n            </span>\n            Panels Overlap Right\n        </a> -->\n\n        <!-- TODO: Revisit these when we build a top nav that other apps can hook into via configuration -->\n        <!-- <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleNavbarLocation()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-arrow-up-arrow-down\" aria-hidden=\"true\"></i>\n            </span>\n            Toggle Navbar Location\n        </a>\n        <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleLeftyMode()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-right-left\" aria-hidden=\"true\"></i>\n            </span>\n            Toggle Left-hand Mode\n        </a> -->\n\n        <!-- TODO: Invest time into this panel to allow custom options to be pushed in per app -->\n        <a id=\"setting-PrinterCodes\" class=\"panel-block is-hidden\" href=\"#/Printer-Codes\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-print\" aria-hidden=\"true\"></i>\n            </span>\n            QR Printer Codes\n        </a>\n        <a id=\"setting-HelpText\" class=\"panel-block\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleHelpText()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-question-circle\" aria-hidden=\"true\"></i>\n            </span>\n            Toggle Help Text\n        </a>\n\n        <!-- Auto-save preferences. Hidden wholesale by syncAutoSaveSettings() in applications that have\n             no form to save (LIMS, the configuration apps) or whose navbar offers no Save button. -->\n        <a id=\"setting-AutoSave\" class=\"panel-block is-hidden\" onclick=\"_Pict.views.HeadlightPaneSettings.toggleAutoSave()\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-clock-rotate-left\" aria-hidden=\"true\"></i>\n            </span>\n            Auto-save this form\n        </a>\n        <div id=\"setting-AutoSaveIntervalSeconds\" class=\"panel-block hl-autosave-interval-block is-hidden\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-stopwatch\" aria-hidden=\"true\"></i>\n            </span>\n            <label class=\"hl-autosave-interval\" for=\"setting-AutoSaveIntervalSeconds-Input\">\n                <span>Auto-save every</span>\n                <input\n                    id=\"setting-AutoSaveIntervalSeconds-Input\"\n                    class=\"input is-small hl-autosave-interval-input\"\n                    type=\"number\"\n                    min=\"15\"\n                    max=\"3600\"\n                    step=\"1\"\n                    value=\"90\"\n                    onchange=\"_Pict.views.HeadlightPaneSettings.setAutoSaveInterval(this.value)\"\n                />\n                <span>seconds</span>\n            </label>\n        </div>\n        <p id=\"setting-AutoSave-Note\" class=\"panel-block hl-autosave-note is-hidden\">\n            Auto-save is turned off for this form type.\n        </p>\n        <a class=\"panel-block\" onclick=\"_Pict.views.HeadlightPanels.handlePanelToggle('Navigation', 'open')\">\n            <span class=\"panel-icon\">\n                <i class=\"fas fa-fw fa-chevron-left\" aria-hidden=\"true\"></i>\n            </span>\n            Back to Actions\n        </a>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SettingsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SettingsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SettingsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-SolverPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-SolverPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-SolverPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-SolverPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-SolverPanel\" class=\"panel is-active is-warning\">\n    <p id=\"HeadlightPanels-SolverPanel-Header\" class=\"panel-heading\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-calculator\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Solver Logs</span>\n    </p>\n    <div id=\"HeadlightPanels-SolverPanel-Content\" class=\"panel-content\">\n        <div id=\"Pict-Form-Solver-In-Panel-Wrapper\" class=\"overflow-scroll-container\"></div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-SolverPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-SolverPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/SolverPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-StatusPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-StatusPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-StatusPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-StatusPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-StatusPanel\" class=\"panel is-active\">\n    <p id=\"HeadlightPanels-StatusPanel-Status-Header\" class=\"panel-heading {~D:Pict.settings.HeadlightPanels.Configuration.CurrentStatus.wrapperClass~}\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i id=\"HeadlightPanels-StatusPanel-Status-Header-Icon\" class=\"fas fa-fw {~D:Pict.settings.HeadlightPanels.Configuration.CurrentStatus.iconClass~}\" aria-hidden=\"true\"></i>\n        </span>\n        <span id=\"HeadlightPanels-StatusPanel-Status-Header-Title\">{~D:AppData.DocumentData.ReportData.Status~}</span>\n    </p>\n    <!-- Status Panel Tabs -->\n    <p id=\"HeadlightPanels-StatusPanel-Tabs\" class=\"panel-tabs\">\n        <a id=\"HeadlightPanels-StatusPanel-Approval-Actions-Tab\" class=\"is-active\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-Approval-Actions', 'Status')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-clipboard\"></i>\n            </span>\n            <span title=\"Status\" class=\"icon-text\">\n                Status\n            </span>\n        </a>\n        <a id=\"HeadlightPanels-StatusPanel-History-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-History', 'Status')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-clock\"></i>\n            </span>\n            <span title=\"History\" class=\"icon-text\">\n                History\n            </span>\n        </a>\n        <!--<a id=\"HeadlightPanels-StatusPanel-Workflow-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-Workflow', 'Status')\">Workflow</a>-->\n        <a id=\"HeadlightPanels-StatusPanel-Users-Tab\" onclick=\"_Pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-StatusPanel-Users', 'Status')\">\n            <span class=\"icon\">\n                <i class=\"fa fa-fw fa-users\"></i>\n            </span>\n            <span title=\"Users\" class=\"icon-text\">\n                Users\n            </span>\n        </a>\n    </p>\n    <!-- Status Panel Content > Approval Actions View -->\n    <div id=\"HeadlightPanels-StatusPanel-Approval-Actions-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div class=\"panel-block skeleton-block has-background-text-40\"></div>\n    </div>\n    <!-- Status Panel Content > History View -->\n    <div id=\"HeadlightPanels-StatusPanel-History-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div class=\"panel-block skeleton-block has-background-text-40\"></div>\n    </div>            \n    <!-- Status Panel Content > Workflow View -->\n    <div id=\"HeadlightPanels-StatusPanel-Users-Content\" class=\"panel-content panel-with-tabs-offset\">\n        <div class=\"panel-block skeleton-block has-background-text-40\"></div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-StatusPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-StatusPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/StatusPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    },
    "HeadlightPanels-Pane-ValidationsPaneHtml-View": {
        "ViewIdentifier": "HeadlightPanels-Pane-ValidationsPaneHtml-View",
        "DefaultRenderable": "HeadlightPanels-Pane-ValidationsPaneHtml-Renderable",
        "DefaultDestinationAddress": "#HeadlightPanels-Pane-Content-Container",
        "AutoRender": false,
        "Templates": [
            {
                "Hash": "HeadlightPanels-Pane-ValidationsPaneHtml-Content-Template",
                "Template": "<article id=\"HeadlightPanels-ValidationsPanel\" class=\"panel is-active is-danger\">\n    <p id=\"HeadlightPanels-ValidationsPanel-Header\" class=\"panel-heading\">\n        {~T:HeadlightPanels-Header-ButtonGroup~}\n        <span class=\"icon\">\n            <i class=\"fas fa-fw fa-triangle-exclamation\" aria-hidden=\"true\"></i>\n        </span>\n        <span>Validation Logs</span>\n    </p>\n    <div id=\"HeadlightPanels-ValidationsPanel-Content\" class=\"panel-content\">\n        <div class=\"overflow-scroll-container\">\n            {~TIfAbs:HeadlightPanels-ValidationPanel-EmptyMessage:Record:Pict.views.HeadlightPaneValidations.HeadlightPaneValidationLog.length^==^0~}\n            {~T:HeadlightPanels-ValidationPanel-Content~}\n        </div>\n    </div>\n</article>\n"
            }
        ],
        "Renderables": [
            {
                "RenderableHash": "HeadlightPanels-Pane-ValidationsPaneHtml-Renderable",
                "TemplateHash": "HeadlightPanels-Pane-ValidationsPaneHtml-Content-Template"
            }
        ],
        "CommentOriginalFilePath": "/working/web/headlight_panels/source/views/panes/HTML/ValidationsPane.html",
        "CommentOriginalRootPath": "/working/web/headlight_panels/source/views/panes/HTML"
    }
}
},{}],1575:[function(require,module,exports){
const markdown = `
##### *To use a barcode scanner in this application while using firefox, you need to disable the "/" shortcut key in the browser settings.*

#### Step 1

* Go to the *Advanced Prefences* menu in Firefox by opening a new tab and entering **about:config** in the address bar.

#### Step 2

* In the search bar, enter the following setting name: **accessibility.typeaheadfind.manual**

#### Step 3

* Toggle the setting to false with the button on the right.
* This should disable the "/" shortcut key and allow the scanner to work properly.
`;

const title = 'Disabling the "/" shortcut key in Firefox';
module.exports = 
{
    markdown,
    title
};
},{}],1576:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
// @ts-ignore
const PictProvider = require('pict-provider');

class CommentProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	getParentCommentKey(pIDParent)
	{
		return `ParentKey~${pIDParent}`;
	}

	/**
	 * Get comments by customer ID
	 * @param {Number} pIDCustomer - The ID of the customer to get comments for
	 * @param {Number} pIDDocument - The ID of the document to get comments for
	 * @param {Array<Number>} pCommentIDs - The IDs of the comments to get
	 * @param {Function} fCallback - The callback function to call when the comments are fetched
	 * @async
	 */
	getCommentStructure(pIDCustomer, pIDDocument, pCommentIDs, fCallback)
	{
		this.pict.log.info(`I am getting all comments for ${pIDCustomer}`);

		// @ts-ignore
		const tmpAnticipate = this.pict.newAnticipate();

		const tmpCommentDataStructureState = {
			CommentIDs: [],
			Comments: [],
			ParentCommentMap: {},
			MergedComments: [],
			Users: [],
		};

		// Step 1: Fetch commentIDs for Document
		tmpAnticipate.anticipate(function(fNext)
		{
			// force the cache to expire for this document so it picks up the latest comments
			this.pict.EntityProvider?.recordSetCache?.['Document']?.expire(`FBV~IDDocument~EQ~${pIDDocument}`);
			// force the cache to expire for the comment id's so it picks up the latest comments
			this.pict.EntityProvider?.recordSetCache?.['Comment']?.expire(`FBL~IDComment~INN~${pCommentIDs.join(',')}`);
			// Get the comment IDs for the document
			this.pict.EntityProvider.getEntitySet(
				'Document',
				`FBV~IDDocument~EQ~${pIDDocument}`,
				function(pError, pRecordSet)
				{
					if (pError)
					{
						this.log.error(`Error downloading data for document ${pIDDocument}: ${pError}`, pError);
						return fCallback(pError);
					}
					// Check actual structure of pRecordSet
					const firstRecord = Array.isArray(pRecordSet) ? pRecordSet[0] : (pRecordSet.Entities ? pRecordSet.Entities[0] : pRecordSet);
					tmpCommentDataStructureState.CommentIDs = (firstRecord && firstRecord.Comments) ? firstRecord.Comments : [];

					fNext();
				}.bind(this),
			);
		}.bind(this));

		// Step 2: Get comment data for each comment by Document ID
		tmpAnticipate.anticipate(function(fNext)
		{
			if (tmpCommentDataStructureState.CommentIDs.length === 0)
			{
				this.pict.log.info('No comments found for the document.');
				return fNext([]);
			}

			const commentIDs = tmpCommentDataStructureState.CommentIDs.join(',');
			this.pict.EntityProvider.getEntitySet(
				'Comment',
				`FBL~IDComment~INN~${commentIDs}`,
				function(pError, pRecordSet)
				{
					if (pError)
					{
						this.pict.log.error(`Error downloading comments: ${pError}`, pError);
						return fCallback(pError);
					}

					tmpCommentDataStructureState.Comments = pRecordSet;
					fNext();
				}.bind(this),
			);
		}.bind(this));

		// Step 3: Fetch user data for customer
		tmpAnticipate.anticipate(function(fNext)
		{
			// fetch all the users that appear in the comments
			if (tmpCommentDataStructureState.Comments.length === 0)
			{
				this.pict.log.info('No comments found, skipping user fetch.');
				tmpCommentDataStructureState.Users = [];
				return fNext();
			}
			// Collect unique user IDs from comments (rather than fetching all users)
			const userIDs = tmpCommentDataStructureState.Comments.reduce((acc, comment) =>
			{
				if (comment.CreatingIDUser && !acc.includes(comment.CreatingIDUser))
				{
					acc.push(comment.CreatingIDUser);
				}
				if (comment.UpdatingIDUser && !acc.includes(comment.UpdatingIDUser))
				{
					acc.push(comment.UpdatingIDUser);
				}
				return acc;
			}, []);
			this.pict.EntityProvider.getEntitySet(
				'User',
				`FBL~IDUser~INN~${userIDs.join(',')}`,
				function(pError, pRecordSet)
				{
					if (pError)
					{
						this.log.error(`Error downloading users for customer ${pIDCustomer}: ${pError}`, pError);
						return fCallback(pError);
					}

					tmpCommentDataStructureState.Users = pRecordSet;
					fNext();
				}.bind(this),
			);
		}.bind(this));

		// Step 4: Transform and nest comments
		tmpAnticipate.anticipate(function(fNext)
		{
			const { Comments, ParentCommentMap, MergedComments } = tmpCommentDataStructureState;

			// Build map of comments by ID
			for (const raw of Comments)
			{
				// for each comment, we need to find the user who created it and the user who last updated it
				const creatingUser = tmpCommentDataStructureState.Users.find((user) => user.IDUser === raw.CreatingIDUser);
				const updatingUser = tmpCommentDataStructureState.Users.find((user) => user.IDUser === raw.UpdatingIDUser);
				if (creatingUser)
				{
					raw.CreatingUserData = creatingUser;
				}
				if (updatingUser)
				{
					raw.UpdatingUserData = updatingUser;
				}

				const structured = {
					IDComment: raw.IDComment,
					CreateDate: raw.CreateDate,
					CreatingIDUser: raw.CreatingIDUser,
					CreatingUserData: raw.CreatingUserData || null,
					UpdatingIDUser: raw.UpdatingIDUser,
					UpdatingUserData: raw.UpdatingUserData || null,
					Date: raw.UpdateDate,
					Entity: raw.Entity || '',
					IDParent: raw.IDParent || 0,
					IDEntity: raw.IDEntity || 0,
					Comment: raw.Comment,
					CommentHtml: raw.CommentHtml,
					Children: [],
					_RowID: `Comment_${raw.IDComment}`,
				};

				ParentCommentMap[structured.IDComment] = structured;
			}

			// Nest comments under their parents
			for (const id in ParentCommentMap)
			{
				if (Object.prototype.hasOwnProperty.call(ParentCommentMap, id))
				{
					const comment = ParentCommentMap[id];
					if (comment.IDParent && ParentCommentMap[comment.IDParent])
					{
						ParentCommentMap[comment.IDParent].Children.push(comment);
					}
					else
					{
						MergedComments.push(comment);
					}
				}
			}

			fNext(MergedComments);
		});

		tmpAnticipate.wait(fCallback);
	}

	/**
	 * Get comments by entity
	 * @param {Number} pIDEntity - The ID of the entity to get comments for. Currently doesn't exist - created for future use.
	 * @param {Function} pCallback - The callback function to call when the comments are fetched
	 * @return {Promise}
	 * @async
	 */
	async getCommentsByEntity(pIDEntity, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// force the cache to expire for this entity so it picks up the latest comments
				this.pict.EntityProvider?.recordSetCache?.['Entity']?.expire(`FBV~IDEntity~EQ~${pIDEntity}`);
				// Get the comments for the entity
				this.fable.services.HeadlightRestClient.getJSON(`Comments/By/IDEntity/${pIDEntity}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching comments: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching comments: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get comments by customer ID
	 * @param {Number} pIDCustomer - The ID of the customer to get comments for
	 * @param {Function} pCallback - The callback function to call when the comments are fetched
	 * @return {Promise}
	 * @async
	 */
	async getCommentsByCustomer(pIDCustomer, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// force the cache to expire for this customer so it picks up the latest comments
				this.pict.EntityProvider?.recordSetCache?.['Customer']?.expire(`FBV~IDCustomer~EQ~${pIDCustomer}`);
				// Get the comments for the customer
				this.fable.services.HeadlightRestClient.getJSON(`Comments/By/IDCustomer/${pIDCustomer}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching comments: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching comments: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get comments by comment ID
	 * @param {Number} pIDComment - The ID of the customer to get comments for
	 * @param {Function} pCallback - The callback function to call when the comments are fetched
	 * @return {Promise}
	 * @async
	 */
	async getCommentByID(pIDComment, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// force the cache to expire for this comment so it picks up the latest changes on comment edit actions
				this.pict.EntityProvider?.recordSetCache?.['Comment']?.expire(`${pIDComment}`);
				// Get the comment by ID
				this.fable.services.HeadlightRestClient.getJSON(`Comment/${pIDComment}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching comment by ID: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching comment by ID: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Add a new comment to the server.
	 * @param {Object} pComment - The new comment to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async createComment(pComment, fOnSaveResult)
	{
		const tmpURL = `Comment/`;
		await new Promise((resolve, reject) => this.fable.services.HeadlightRestClient.postJSON(tmpURL, pComment,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating comment: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred creating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating comment: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error creating comment: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred creating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating comment: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
			},
		));
	}

	/**
	 * Post an update to a comment to the server.
	 * @param {Object} pIDComment - The updated IDComment to post
	 * @param {Function} fOnSaveResult - The callback function to call when the comment is posted
	 */
	async updateComment(pIDComment, fOnSaveResult)
	{
		const tmpURL = `Comment/`;
		// force the cache to expire for this comment so it picks up the latest changes on comment edit actions
		this.pict.EntityProvider?.recordSetCache?.['Comment']?.expire(`${pIDComment}`);
		// update the comment
		await new Promise((resolve, reject) => this.fable.services.HeadlightRestClient.putJSON(tmpURL, pIDComment,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating comment: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating comment: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
			},
		));
	}

	/**
	 * Attach a comment to a document. This route, unlike a document update, is open on a locked document.
	 * @param {number} pIDDocument - The document to attach the comment to
	 * @param {number} pIDComment - The comment to attach
	 * @param {Function} fOnSaveResult - The callback function to call with the updated document
	 */
	async addCommentToDocument(pIDDocument, pIDComment, fOnSaveResult)
	{
		const tmpURL = `Document/${pIDDocument}/Comment/Add/${pIDComment}`;
		// force the cache to expire for this document so it picks up the latest comments
		this.pict.EntityProvider?.recordSetCache?.['Document']?.expire(`FBV~IDDocument~EQ~${pIDDocument}`);
		await new Promise((resolve, reject) => this.fable.services.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating comment record for document: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment record attached to this document.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment record for document: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating comment record for document: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the comment record attached to this document.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating comment record for document: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
			},
		));
	}

	/**
	 * Delete a comment.
	 * @param {number} pIDComment - The comment to delete
	 * @param {Function} fOnDeleteResult - The callback function to call when the project file is posted
	 */
	deleteComment(pIDComment, fOnDeleteResult)
	{
		if (!pIDComment)
		{
			this.pict.log.error('pIDComment was not passed.');
			return;
		}
		this.fable.HeadlightRestClient.deleteEntity('Comment', pIDComment, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete comment.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete comment!',
					type: 'is-danger',
				});
				fOnDeleteResult(pError);
			}
			else
			{
				this.pict.log.info('Comment deleted successfully.', pBody);
				if (typeof fOnDeleteResult === 'function')
				{
					fOnDeleteResult(pBody);
				}
			}
		});
	}
}

module.exports = CommentProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1577:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ComplexFilterProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.filterState = {};
		this.blacklistedFilters = [ 'DeleteDate', 'ExternalSyncDate', 'ExternalSyncGUID', 'UpdatingIDUser', 'UpdateDate' ];
		this.renderOverriden = false;
		// NOTE: endCapTemplate is kept as a public option but is no longer rendered — its only
		// consumer was the old PRSP-SUBSET-Filters-Template-Input-Fieldset (removed). The module owns
		// the search row now; reintroduce an end-cap slot there if an app turns out to need one.
		this.endCapTemplate = pOptions.endCapTemplate || '';
		// a local copy of the current route params to avoid "ComplexFilterView" view being set to pViewContext at any given time
		this.routeViewHash = null;
		this.routeRecordSet = null;
	}
	/*
		KNOWN TODO/BUGS:
		- Wrong input types generating for filter descriptors ("DateRange" is generating a "StringMatch" input, etc) -> This is a lib bug (added hack/workaround for now).
		- Add "complex filters" like "IDUser > (User Name First + User Name Last)", etc
		- Basic search query doesn't persist across views when doing a search (core library/route issue)
	*/

	/**
	 * Initializes the filter experience manager for the LIMS app by extracting the record set and view context from the current route, opening the filter persistence UI, and setting callbacks to update the filter experience view when filters are added, updated, or deleted.
	 * This ensures that the filter experience view is always ready to go when the user opens it, and that it stays in sync with the current filters and any changes made to them.
	 */
	initializeFilterExperienceManagerForLIMSApp()
	{
		const tmpRouteUrl = this.pict.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.url;
		this.routeRecordSet = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[0];
		this.routeViewHash = tmpRouteUrl?.split?.('PSRS/')?.[1]?.split?.('/')?.[1];
		// always initiailize the filter experience view so that it's ready to go when the user opens it, but keep it hidden until then
		this.pict.views.FilterPersistenceView.initializeFilterPersistenceViewUI(this.routeRecordSet, this.routeViewHash, () =>
		{
			this.inintializeSelect2('#FilterPersistenceView-StoredFiltersSelect');
			// set the callback to reset the filter experience view when adding a new filter to the filter list
			this.pict.views['PRSP-Filters'].setAddFilterCallback(() =>
			{
				this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = true;
				this.pict.views.FilterPersistenceView.handleModifiedFiltersState();
			});
			// set the callback to reset the filter experience view when updating/deleting a filter in the filter list
			this.pict.views['PRSP-Filters'].setRemoveFilterCallback(() =>
			{
				this.pict.providers.FilterDataProvider.filterExperienceModifiedFromURLHash = true;
				this.pict.views.FilterPersistenceView.handleModifiedFiltersState();
			});
		});
	}

	/**
	 * Initializes the select2 dropdown for saved filter experiences.
	 * This is called when the user opens the filter experience section for the first time, and also whenever the filter experience data is updated to ensure the dropdown is in sync.
	 * @param {string} pHTMLElementSelector - The selector for the HTML select element to initialize select2 on.
	 */
	inintializeSelect2(pHTMLElementSelector)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectElementSelector = document.querySelector(pHTMLElementSelector);
			// get all the options with values on the select element and use them to populate the select2 dropdown, this is needed to properly display the saved filter experiences in the filter experience dropdown
			const tmpOptions = [];
			if (tmpSelectElementSelector && tmpSelectElementSelector instanceof HTMLSelectElement)
			{
				for (const option of tmpSelectElementSelector.options)
				{
					if (option.value)
					{
						tmpOptions.push({ id: option.value, text: option.text });
					}
				}
			}
			const tmpSelectOptions = {
				data: tmpOptions,
				width: '100%',
				placeholder: 'Select a filter experience',
				dropdownParent: document.querySelector('#FilterPersistenceView-Container'),
			};
			// if the select2 plugin is not already initialized, initialize it now
			if (!window['jQuery'](tmpSelectElementSelector).data('select2'))
			{
				window['jQuery'](tmpSelectElementSelector).select2(tmpSelectOptions);
			}
			else
			{
				// if it is already initialized, we need to update the options manually and trigger a change to update the display
				window['jQuery'](tmpSelectElementSelector).empty().select2(tmpSelectOptions);
				window['jQuery'](tmpSelectElementSelector).trigger('change');
			}
		}
	}

	handleSaveFilterPersistenceSettings(event, recordSet, viewContext)
	{
		const tmpCurrentFilterName = this.pict.providers.FilterDataProvider.getCurrentFilterName();
		this.pict.views.FilterPersistenceView.saveFilterPersistenceSettings(event, () =>
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filter experience "${tmpCurrentFilterName}" saved successfully`,
				type: 'is-success',
			});
		});
	}

	handleDeleteFilterPersistenceSettings(event)
	{
		const tmpCurrentFilterName = this.pict.providers.FilterDataProvider.getCurrentFilterName();
		this.pict.views.FilterPersistenceView.deleteFilterPersistenceSettings(event, () =>
		{
			this.pict.views.HeadlightPanels.toast({
				message: `Filter experience "${tmpCurrentFilterName}" deleted successfully`,
				type: 'is-success',
			});
		});
	}


	getActiveFilters()
	{
		const activeRecordSet = this.pict.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet || '';
		const activeFilters = this.pict?.Bundle?._ActiveFilterState?.[activeRecordSet]?.FilterClauses || [];
		//FIXME: don't want to make everything cascading async but want to force load this if it isn't there
		this.pict.providers?.[`RSP-Provider-${ activeRecordSet }`]?.getRecordSchema?.()?.catch?.((e) =>
		{
			this.pict.log.error('Failed to get record schema for active record set', e);
		});
		const activeSchema = this.pict.providers?.[`RSP-Provider-${ activeRecordSet }`]?.getFilterSchema();
		return { activeFilters, activeRecordSet, activeSchema };
	}

	updateFilters()
	{
		this.filterState = this.getActiveFilters();
	}


	/**
	 * Prepares the complex filter view by overriding the onBeforeRender and onAfterRender functions of the filter view to update the filter state and apply visibility states for disabled filters.
	 * Also overrides the prepareRecord function for specific filter types to ensure the correct input types are generated for the filter descriptors (workaround for lib bug).
	 * This is called when the filter view is rendered to ensure the complex filter functionality is properly integrated into the filter view.
	 */
	prepareComplexFilter()
	{
		if (!this.renderOverriden)
		{
			const beforeRenderStub = this.pict.views['PRSP-Filters'].onBeforeRender.bind(this.pict.views['PRSP-Filters']); ;
			this.pict.views['PRSP-Filters'].onBeforeRender =
			function(callback, renderable)
			{
				this.pict.providers.ComplexFilterProvider.prepareComplexFilter();
				beforeRenderStub(callback, renderable);
			};
			this.pict.views['PRSP-Filters'].onBeforeRender = this.pict.views['PRSP-Filters'].onBeforeRender.bind(this.pict.views['PRSP-Filters']);
			const afterRenderStub = this.pict.views['PRSP-Filters'].onAfterRender.bind(this.pict.views['PRSP-Filters']); ;
			this.pict.views['PRSP-Filters'].onAfterRender =
			function(callback, renderable)
			{
				this.pict.providers.ComplexFilterProvider.initializeFilterExperienceManagerForLIMSApp();
				afterRenderStub(callback, renderable);
			};
			this.pict.views['PRSP-Filters'].onAfterRender = this.pict.views['PRSP-Filters'].onAfterRender.bind(this.pict.views['PRSP-Filters']);
			// Entity-reference filters now delegate their input to the pict-native 'Picker' InputType
			// (the select2-free replacement for EntitySelectorMultiple). pict-section-recordset's Phase 3
			// entity-reference base natively stamps the ClauseDescriptor InputType + Entity and bridges
			// Values↔StringArrayValue, so the prepareRecord patches that used to live here are gone — we
			// just opt the filter types into the picker.
			[ 'InternalJoinSelectedValue', 'InternalJoinSelectedValueList', 'ExternalJoinSelectedValue', 'ExternalJoinSelectedValueList' ].forEach((pType) =>
			{
				const tmpEntityFilterView = this.pict.views['PRSP-FilterType-' + pType];
				if (tmpEntityFilterView) { tmpEntityFilterView.options.EntityInputType = 'Picker'; }
			});
			const tempPrepareStringRecord = this.pict.views['PRSP-FilterType-StringMatch'].prepareRecord.bind(this.pict.views['PRSP-FilterType-StringMatch']);
			this.pict.views['PRSP-FilterType-StringMatch'].prepareRecord =
			function(pRecord)
			{
				tempPrepareStringRecord(pRecord);
				if (!pRecord.ClauseDescriptor?.DataType)
				{
					pRecord.ClauseDescriptor.DataType = pRecord.DataType || 'String';
				}
				if (!pRecord.ClauseDescriptor?.PictForm)
				{
					pRecord.ClauseDescriptor.PictForm = pRecord.PictForm || {};
				}
			};
			// The module's add-filter popover owns field visibility now — hand it our blacklist so
			// internal/audit columns (DeleteDate, ExternalSync*, etc.) stay hidden from it.
			this.pict.views['PRSP-Filters'].filterFieldBlacklist = this.blacklistedFilters;
			// Quick Filters are opt-in across Headlight: the curated bar shows only on record sets that
			// declare an explicit `QuickFilters` config (no schema-derived clever defaults). (The recordset
			// date-range filter fix still applies everywhere regardless of this.)
			this.pict.views['PRSP-Filters'].quickFiltersAutoDefault = false;
			this.renderOverriden = true;
		}
		// update the filter state
		this.updateFilters();

		// (The entity SelectedValueList template overrides that used to live here are gone — the module's
		// entity-reference base owns its input template natively now, delegating to the Picker InputType.)
		//@ts-ignore
		this.pict.PictApplication.changeTheme('Edit');
		// The filter clause + chrome + the add-filter popover + the entity-reference inputs are all owned
		// by pict-section-recordset now (entity filters delegate to the pict-native 'Picker' InputType,
		// opted in above) and branded via Headlight's --theme-color-* tokens; this provider just hands the
		// module its field blacklist (above). What remains here is the filter-experience manager (below).
		this.pict.TemplateProvider.addTemplate('FilterPersistenceView-Container', /*html*/`
			<!-- LIMS Custom pict view template: [FilterPersistenceView-Container] -->
			<div id="FilterPersistenceView-Content">
				<!-- Content for Filter Persistence View goes here -->
				<div id="FilterPersistenceView-Body">
					<label class="label" for="FilterPersistenceView-CurrentFilterNameInput">Current Filter Experience: <span id="FilterPersistenceView-CurrentFilterNameInput-ValidationMessage" class="is-size-7 has-text-weight-normal has-text-danger-50 ml-1"></span></label>
					<fieldset class="FilterPersistenceView-ActiveSettings field has-addons has-addons-right">						
						<p class="control is-expanded">
							<input class="input" type="text" id="FilterPersistenceView-CurrentFilterNameInput" name="CurrentFilterName" value="" onfocus="this.select()" />
						</p>
						<p class="control has-text-right">

							<button type="button" class="button is-info" id="FilterPersistenceView-SaveFilterButton" onclick="_Pict.providers.ComplexFilterProvider.handleSaveFilterPersistenceSettings(event, '{~D:Record.RecordSet~}', '{~D:Record.ViewContext~}')">
								<span class="icon"><i class="fas fa-save"></i></span>
								<span id="FilterPersistenceView-SaveFilterButtonText" class="icon-text">Save</span>
							</button>
						</p>
					</fieldset>
					<div class="FilterPersistenceView-StoredSettings">
						<!-- Dropdown for stored filter experiences -->
						<fieldset class="field">
							<label class="label" for="FilterPersistenceView-StoredFiltersSelect">Saved Filter Experiences:</label>
							<p class="control select is-fullwidth">
								<select class="input" id="FilterPersistenceView-StoredFiltersSelect" onchange="_Pict.views['FilterPersistenceView'].setFilterExperienceToSelection(event)" name="StoredFilterName">
									<!-- Options will be populated dynamically -->
								</select>
							</p>
							<p class="control has-text-right mt-2">
								<button type="button" class="button is-info" id="FilterPersistenceView-LoadFilterButton" 
									onclick="_Pict.views['FilterPersistenceView'].loadFilterPersistenceSettings(event);">
									<span class="icon"><i class="fas fa-download"></i></span>
									<span class="icon-text">Load</span>
								</button>
								<button type="button" class="button is-info" id="FilterPersistenceView-SetAsDefaultButton" onclick="_Pict.views['FilterPersistenceView'].toggleFilterExperienceAsTheDefault(event, true)">
									<span class="icon"><i class="fas fa-star"></i></span>
									<span class="icon-text">Set As Default</span>
								</button>
								<button type="button" class="button is-info" id="FilterPersistenceView-RemoveAsDefaultButton" onclick="_Pict.views['FilterPersistenceView'].toggleFilterExperienceAsTheDefault(event, false)">
									<span class="icon"><i class="fas fa-star-half-alt"></i></span>
									<span class="icon-text">Remove As Default</span>
								</button>
								<button type="button" class="button is-info" id="FilterPersistenceView-DeleteFilterButton" onclick="_Pict.providers.ComplexFilterProvider.handleDeleteFilterPersistenceSettings(event)">
									<span class="icon"><i class="fas fa-trash"></i></span>
									<span class="icon-text">Delete</span>
								</button>
							</p>
						</fieldset>
					</div>
				</div>
				<div id="FilterPersistenceView-Footer" class="container pt-3">
					<div class="columns is-vcentered">
						<div class="column">
							<label for="OptionalSettings-RememberLastUsed" class="label">
								<input type="checkbox" id="OptionalSettings-RememberLastUsed" name="RememberLastUsed" onchange="_Pict.views['FilterPersistenceView'].toggleRememberLastUsedFilterExperience(event)"	 />
								Remember my last search filter experience
							</label>
						</div>
					</div>
				</div>
			</div>
			<!-- LIMS Custom end view template:  [FilterPersistenceView-Container] -->
		`);
	}
}

module.exports = ComplexFilterProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1578:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ConfigurationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		// temporary configuration by scope for testing
		// TODO: Remove this when the Configuration API is available
		this.tmpConfigurationByScope = [
			{
				'IDCustomer': 117,
				'ConfigurationID': 'HDOT',
				'State': 'Hawaii',
				'StateAbbreviation': 'HI',
				'Agency': 'HDOT',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 13,
					'LeafletInitialCenter': [ 21.315603, -157.858093 ],
				},
			},
			{
				'IDCustomer': 63,
				'ConfigurationID': 'ALDOT',
				'State': 'Alabama',
				'StateAbbreviation': 'AL',
				'Agency': 'ALDOT',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 32.4074958, -86.2651064 ],
				},
			},
			{
				'IDCustomer': 16,
				'ConfigurationID': 'Transystems',
				'State': [ 'South Carolina', 'Pennsylvania' ],
				'StateAbbreviation': [ 'SC', 'PA' ],
				'Agency': 'Transystems',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 32.89979011186591, -79.97861499691103 ],
				},
			},
			{
				'IDCustomer': 1,
				'ConfigurationID': 'Headlight',
				'State': 'Headlight',
				'StateAbbreviation': null,
				'Agency': 'Headlight',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 47.6142773, -122.3586997 ],
				},
			},
			{
				'IDCustomer': 188,
				'ConfigurationID': 'MoffattNichol',
				'State': [ 'Alaska', 'Louisiana' ],
				'StateAbbreviation': [ 'AK', 'LA' ],
				'Agency': 'Moffatt & Nichol',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 61.1070663, -150.0733888 ],
				},
			},
			{
				'IDCustomer': 178,
				'ConfigurationID': 'BridgeEngineering',
				'State': 'Headlight',
				'StateAbbreviation': null,
				'Agency': 'Bridge Engineering',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 5,
					'LeafletInitialCenter': [ 32.8001818028968, -96.67293809033943 ],
				},
			},
			{
				'IDCustomer': 184,
				'ConfigurationID': 'IndustrySolutions',
				'State': 'Pennsylvania',
				'StateAbbreviation': 'PA',
				'Agency': 'Industry Solutions',
				'BridgeMapConfiguration': {
					'LeafletInitialZoom': 10,
					'LeafletInitialCenter': [ 40.437801138712196, -79.99294555569139 ],
				},
			},
		];
	}

	getConfigurationByScope(pScope, pCallback)
	{
		if (!pScope)
		{
			this.pict.log.error('No Configuration Scope provided.');
			return new Error('No Configuration Scope provided.');
		}
		const tmpScopeConfig = this.tmpConfigurationByScope.filter((pConfig) => pConfig.IDCustomer === pScope);

		// find the temporary configuration by scope for testing where the pScope is the IDCustomer (for now)
		if (tmpScopeConfig && tmpScopeConfig.length > 0)
		{
			// return the first configuration found
			const tmpResult = tmpScopeConfig[0];
			this.pict.log.info(`Configuration found for ${pScope}`, tmpResult);
			if (pCallback)
			{
				pCallback(tmpResult);
			}
			return tmpResult;
		}
		else
		{
			this.pict.log.error(`Configuration not found for passed value: ${pScope}`);
			if (pCallback)
			{
				pCallback({});
			}
			return {};
		}
		// this.pict.HeadlightRestClient.getJSON(`Configuration/Scope/${pScope}`, (pError, pBody) =>
		// {
		// 	if (pError)
		// 	{
		// 		this.pict.log.error(`Error getting Configuration: ${pError}`, pError);
		// 		return reject(pError);
		// 	}
		// 	resolve(pBody);
		// });
	}
}

module.exports = ConfigurationProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1579:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const EntityDataBaseline = require('headlight-dynamic-inputs-bundle/source/providers/_EntityDataBaseline.js');

// Bounds one drain of the save queue. Reachable only by a save trigger that fires from inside the save
// lifecycle itself (an onAfterDocumentSave override, say), which would otherwise re-queue forever.
const MAX_CONSECUTIVE_SAVE_CYCLES = 25;

// Busy-toast phrasing keyed on the lowercased approval action. The action list is server-defined
// (fetchApprovalState), so anything unrecognized falls back to naming the action verbatim.
const APPROVAL_BUSY_PHRASE =
{
	'submit': 'Submitting this document for approval.',
	'approve': 'Approving this document.',
	'reject': 'Rejecting this document.',
	'draft': 'Returning this document to draft.',
};
const APPROVAL_BUSY_SUFFIX = ' This can take a few moments; the page will refresh when it finishes.';
// How long a silent server gets before the busy toast escalates its wording. Never releases the lock.
const APPROVAL_BUSY_ESCALATION_MS = 30000;
// What the page does once an approval action has landed.
const APPROVAL_REFRESH_OUTCOME =
{
	// The page now shows the document's new state; nothing else to do.
	Refreshed: 'Refreshed',
	// Load the page again: the action changed something an in-place refresh does not redraw.
	Reload: 'Reload',
	// The page cannot load itself again (the iOS app starts it only once); ask the user to reopen it.
	Reopen: 'Reopen',
};
// ReportData fields the page keeps its own copy of across an in-place refresh. Each is what the save this
// action made just sent, and the refresh only runs when the server still holds exactly that form data.
const APPROVAL_REFRESH_LOCAL_FIELDS = [ 'FormData', 'EntityData', 'Observations' ];

class DocumentProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & Pict} */
		this.fable;
		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;
		/** @type {any} */
		this.AppData;
		/** @type {any} */
		this.log;
		/** @type {any} */
		this.services;

		this.pict.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProvider('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });

		/** @type {boolean} - Whether a save lifecycle is currently running. */
		this.IsSaving = false;
		/** @type {boolean} - Whether a save was requested while one was already running. */
		this._SavePending = false;
		/** @type {boolean} - Mute setting for the queued trailing save; any un-muted requester un-mutes it. */
		this._PendingMuteNotification = true;
		/** @type {Array<(pError?: Error) => void>} - Resolvers waiting on the trailing save that will carry their mutation. */
		this._PendingSaveWaiters = [];
		/** @type {Array<() => void>} - Resolvers waiting for the current save drain to finish, whatever its outcome. */
		this._SaveSettledWaiters = [];
		/** @type {boolean} - Whether an approval action (submit/approve/reject) is currently running. */
		this.isTakingAction = false;
		/** @type {?{ dismiss: function }} - Handle for the persistent toast shown while an action runs. */
		this._ApprovalBusyToast = null;
		/** @type {string} - The action the busy state is describing, for the toast copy. */
		this._ApprovalBusyAction = '';
		/** @type {any} - Timer that escalates the busy toast wording when the server goes quiet. */
		this._ApprovalBusyEscalationTimer = null;
		/** @type {boolean} - Whether a page reload has been requested and now owns the busy state. */
		this._ApprovalReloadPending = false;
		/** @type {boolean} - Whether an approval action left a page that must be closed and reopened, so the busy state stays. */
		this._ApprovalReopenRequired = false;
		/** @type {?string} - The FormData the server echoed back from the last save, as JSON; null when the save was not to the server. */
		this._LastSavedServerFormDataJSON = null;
	}

	/**
	 * Resolve once no save lifecycle is in flight.
	 *
	 * Unlike handleSaveAsync this never *requests* a save - it only waits for one that is already
	 * running. Callers that must not act on a half-written document (approval actions, which lock it)
	 * use this to close the window where the user could beat an in-flight save to the punch.
	 *
	 * @return {Promise<void>} Resolves immediately when nothing is saving.
	 */
	whenSaveSettled()
	{
		if (!this.IsSaving)
		{
			return Promise.resolve();
		}
		return new Promise((resolve) =>
		{
			this._SaveSettledWaiters.push(resolve);
		});
	}

	/**
	 * This function is used to get the style of the approval status based on the status of the document.
	 * @param {string} pStatus - The status of the document
	 * @return {object} - The icon class and background color for the status
	 * @example
	 * getApprovalStatusStyle('Draft');
	 * getApprovalStatusStyle('Submit');
	 * getApprovalStatusStyle('Approve');
	 */
	getApprovalStatusStyle(pStatus)
	{
		const returnObject = {};
		const documentStatus = pStatus || this.pict.AppData?.DocumentData?.ReportData?.Status;
		switch (documentStatus)
		{
		case 'Draft':
			returnObject.iconClass = 'fa-clipboard';
			returnObject.backgroundColor = 'has-background-grey';
			break;
		case 'Submit':
		case 'Submitted':
			returnObject.iconClass = 'fa-paper-plane';
			returnObject.backgroundColor = 'has-background-info-40';
			break;
		case 'Approve':
		case 'Approved':
			returnObject.iconClass = 'fa-check-circle';
			returnObject.backgroundColor = 'has-background-success-40';
			break;
		case 'Reject':
		case 'Rejected':
			returnObject.iconClass = 'fa-ban';
			returnObject.backgroundColor = 'has-background-danger-40';
			break;
		default:
			returnObject.iconClass = 'fa-question-circle';
			returnObject.backgroundColor = 'has-background-grey';
			break;
		}
		return returnObject;
	}

	/**
	 * This function is used to handle the change of the approval status of a document.
	 * @param {Event} event - The click event
	 * @param {string} action - The action to take on the document
	 * @return {void}
	 * @example
	 * handleApprovalStatusChange(event, 'Approve');
	 * handleApprovalStatusChange(event, 'Reject');
	 * handleApprovalStatusChange(event, 'Submit');
	 * handleApprovalStatusChange(event, 'Draft');
	 */
	handleApprovalStatusChange(event, action)
	{
		if (event)
		{
			event.preventDefault();
		}
		this.takeApprovalAction(action);
	}

	/**
	 * This function is used to determine if the open document action was called from a mobile device.
	 * @return {boolean} - True if the open document action was called from a mobile device, false otherwise
	 */
	isOpenDocumentCalledFromMobileDevice()
	{
		// @ts-ignore
		const platform = window.navigator?.platform || window.navigator?.userAgentData?.platform || '';
		const isMobileDevice = (window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g) || platform.toUpperCase() === 'MACINTEL') && window.navigator.maxTouchPoints > 1;
		const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
		if (isMobileDevice && !isSafari)
		{
			return true;
		}
		return false;
	}

	/**
	 * Whether this page can open another document itself. The iOS app runs a form from a local copy, with no
	 * server origin to load another document from and no tabs to open it in, so a new document is reached
	 * from the app's forms list instead.
	 * @return {boolean} - True when the page can open another document
	 */
	canOpenOtherDocument()
	{
		return !(/** @type {any} */ (window))._OfflineMode;
	}

	/**
	 * Whether this page can create a new document (Clone, Duplicate). The iOS app's offline form writes every
	 * Document create onto the document that is open (`mpi_ios` `bridgeWriteDocument:`), so a copy made there
	 * would overwrite the original instead.
	 * @return {boolean} - True when the page can create a new document
	 */
	canCreateDocument()
	{
		return !(/** @type {any} */ (window))._OfflineMode;
	}

	/**
	 * Check that this page can create a new document, and tell the user when it cannot.
	 * @param {string} pAction - What the user tried, for the message ("Clone", "Duplicate")
	 * @return {boolean} - True when the page can create a new document
	 */
	ensureCanCreateDocument(pAction)
	{
		if (this.canCreateDocument())
		{
			return true;
		}
		this.pict.views.HeadlightPanels.toast({
			message: `${pAction} isn't available in the iOS app yet. Open this document in Headlight on the web to copy it.`,
			type: 'is-warning',
		});
		return false;
	}

	/**
	 * Open the Form Handler to show a confirmation modal when called from the webapp
	 * @param {object} event - The click event
	 * @param {number|string} [pIDDocument] - The ID of the Document to view
	 */
	//TODO: is this method in the right file as it calls a view ?
	openFormByIDDocumentHandler(event, pIDDocument)
	{
		const tmpIDDocument = pIDDocument || this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (this.isOpenDocumentCalledFromMobileDevice())
		{
			this.pict.views.DocumentDetails.confirmOpenForm(tmpIDDocument, '_top');
			return;
		}

		this.openFormByIDDocument(event, tmpIDDocument);
	}

	/**
	 * Opens a document in a new tab.
	 * @param {Object} event
	 * @param {Number} tmpIDDocument
	 * @param {String} [windowTarget='_blank'] - The target window for the document (default is '_blank')
	 */
	openFormByIDDocument(event, tmpIDDocument, windowTarget = '_blank')
	{
		const tmpElement = event.currentTarget;
		this.log.info('Open Form for Document ID:', tmpIDDocument);
		if (event)
		{
			tmpElement.classList.add('is-loading');
		}
		// Needed for handling ios issues.
		const windowReference = window.open('', windowTarget);
		const template =
		`<style> 
			@-webkit-keyframes load8 { 
				0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 
				100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); } 
			} 
			@keyframes load8 { 
				0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 
				100% { -webkit-transform: rotate(360deg);transform: rotate(360deg); } 
			} 
			*, *:before, *:after { 
				box-sizing: border-box;
			}
			body { 
				padding: 15px 0; 
				margin: 0 auto; 
				background-color: #53565A; 
				font-family: Arial, sans-serif; 
				width: 100%; 
				font-size: 15px; 
				max-width: 1000px;
			}
			.loading-splash-screen {
				width: 100%; 
				height: 100vh; 
				background: #53565A; 
				position: fixed; 
				top: 0; 
				left: 0; 
				text-align: center; 
				z-index: 10002; 
				display:flex; 
				align-items: center;
			}
			 .loading-splash-screen .loading-spinner, 
			 .loading-splash-screen .loading-spinner:after { 
			 	border-radius: 50%; width: 15em; height: 15em;
			}  
			.loading-spinner { 
				margin: 60px auto; 
				font-size: 10px; 
				position: relative; 
				text-indent: -9999em; 
				border-top: 1.1em solid rgba(255, 255, 255, 0.2); 
				border-right: 1.1em solid rgba(255, 255, 255, 0.2); 
				border-bottom: 1.1em solid rgba(255, 255, 255, 0.2); 
				border-left: 1.1em solid #ffffff; 
				-webkit-transform: translateZ(0); 
				-ms-transform: translateZ(0); 
				transform: translateZ(0); 
				-webkit-animation: load8 1.1s infinite linear; animation: load8 1.1s infinite linear;
			}
			</style>
			<div id="LoadingSplashScreen" class="loading-splash-screen">
				<div class="loading-spinner">Loading...</div>
			</div>
		`;
        windowReference.document.write(template);
		this.pict.HeadlightRestClient.getJSON('Report/Render/' + tmpIDDocument + '/default',
		(pError, pBody) =>
		{
			if (event)
			{
				tmpElement.classList.remove('is-loading');
			}
			if (pError)
			{
				windowReference.close();
				this.log.error('Error retrieving Report Description:', pError);
				this.pict.views.HeadlightPanels?.toast?.({
					message: `<strong>Error retrieving Report Description:</strong><br/><em>${pError.message || pError}</em>`,
					type: 'is-danger',
				});
				return;
			}
			windowReference.location = window.location.origin + '/1.0/Report/' + pBody.GUIDReportDescription + '/index.html';
		});
	}

	/**
	 * This function is used to handle the download of a document.
	 * @param {boolean} forceRender - Whether to force the document to render in the browser
	 * @param {object} [pReportData] - The report data to use when rendering the document (optional, used for "not my current document" scenarios)
	 * @param {Function} [pCallback] - The callback function to call when the download is complete
	 * @return {Promise<void>}
	 * @async
	 */
	async handleDocumentDownload(forceRender = false, pReportData = null, pCallback)
	{
		if (!this.IsDownloading)
		{
			this.IsDownloading = true;

			const tmpReportData = pReportData || this.AppData?.DocumentData?.ReportData;
			try
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'Document download started...',
					type: 'is-success',
				});
				await this.services.HeadlightDocumentService.downloadDocument(forceRender, tmpReportData);
			}
			catch (e)
			{
				this.pict.log.error('Failed to download document', { error: e });
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to download document!',
					type: 'is-danger',
				});
			}
			finally
			{
				this.IsDownloading = false;
				// Call the callback function if provided
				if (pCallback)
				{
					pCallback();
				}
			}
		}
		else
		{
			this.pict.log.warn('Form processor not found or download operation is already in progress.');
		}
	}

	/**
	 * Fire-and-forget document save: requests a save and returns immediately - it does NOT wait for the
	 * Document PUT to land. Callers that must wait before proceeding (e.g. before locking on submit, or
	 * before reading the freshly-persisted copy) must use handleSaveAsync - which awaits the full lifecycle.
	 * `await handleSave(...)` is a no-op wait; not-async by design so that reads honestly.
	 * @param {boolean} [muteNotification] - Whether to mute the save notification.
	 * @return {void}
	 */
	handleSave(muteNotification = false)
	{
		this.handleSaveAsync(muteNotification);
	}

	/**
	 * Awaitable variant of handleSave.
	 *
	 * Resolves only after a save lifecycle carrying this caller's state has completed (including
	 * _saveDocument's PUT /Document/), so callers that must read the freshly-persisted server copy can
	 * guarantee the latest in-memory FormData has been flushed first. The form-conversion / PDF export is the
	 * motivating case: it downloads a server-rendered file filled from the persisted FormData, so it must
	 * save before fetching (PD-8714).
	 *
	 * Resolves with the save error (if any) rather than rejecting, so callers can decide whether to continue.
	 *
	 * Save lifecycles are serialized - only one runs at a time. A caller arriving while a save is in flight
	 * (a double-clicked Save button, or a background trigger firing mid-save) does not start a second
	 * lifecycle; it queues exactly one trailing save that runs after the in-flight one drains, and so carries
	 * whatever it mutated. Coalescing onto the in-flight save instead would silently drop those mutations,
	 * because callers mutate ReportData/FormData immediately before asking for a save.
	 *
	 * @param {boolean} [muteNotification] - Whether to mute the save toast.
	 * @return {Promise<Error|undefined>} Resolves once a save covering this request has completed.
	 */
	handleSaveAsync(muteNotification = false)
	{
		if (this.IsSaving)
		{
			this._SavePending = true;
			this._PendingMuteNotification = this._PendingMuteNotification && muteNotification;
			return new Promise((resolve) =>
			{
				this._PendingSaveWaiters.push(resolve);
			});
		}
		return this._drainSaveQueue(muteNotification);
	}

	/**
	 * Run save lifecycles until nothing further has been requested, holding the single-flight latch across
	 * the whole drain so the Save button does not flicker between queued cycles.
	 * @param {boolean} pMuteNotification - Whether to mute the toast for the first cycle.
	 * @return {Promise<Error|undefined>} Resolves with the error from the last cycle run, if any.
	 */
	async _drainSaveQueue(pMuteNotification)
	{
		this.IsSaving = true;
		this._syncSaveButtonState();
		// Approval actions must not be reachable while the document is being written; see
		// _syncApprovalActionState.
		this._syncApprovalActionState();
		let tmpMuteNotification = pMuteNotification;
		let tmpCycleCount = 0;
		/** @type {Error|undefined} */
		let tmpError;
		try
		{
			do
			{
				// Snapshot before running: these waiters queued during the previous cycle, so the cycle about
				// to run is the one that carries their mutation.
				this._SavePending = false;
				const tmpWaiters = this._PendingSaveWaiters;
				this._PendingSaveWaiters = [];
				tmpError = await this._runSaveLifecycle(tmpMuteNotification);
				tmpMuteNotification = this._PendingMuteNotification;
				this._PendingMuteNotification = true;
				for (const fWaiter of tmpWaiters)
				{
					fWaiter(tmpError);
				}
				tmpCycleCount++;
				if (tmpCycleCount >= MAX_CONSECUTIVE_SAVE_CYCLES && this._SavePending)
				{
					this.pict.log.error(`Document save queue drained ${tmpCycleCount} consecutive cycles and is still being re-queued; abandoning the queued save to avoid a save loop.`);
					break;
				}
			}
			while (this._SavePending);
		}
		finally
		{
			this.IsSaving = false;
			this._SavePending = false;
			this._PendingMuteNotification = true;
			const tmpOrphanedWaiters = this._PendingSaveWaiters;
			this._PendingSaveWaiters = [];
			for (const fWaiter of tmpOrphanedWaiters)
			{
				fWaiter(tmpError);
			}
			this._syncSaveButtonState();
			this._syncApprovalActionState();
			this._syncCurrentSamplesButtonState();
			const tmpSettledWaiters = this._SaveSettledWaiters;
			this._SaveSettledWaiters = [];
			for (const fSettledWaiter of tmpSettledWaiters)
			{
				fSettledWaiter();
			}
			// Restart the auto-save countdown from this save, so a manual save buys the user a full
			// interval rather than an auto-save moments later.
			this.pict.providers?.AutoSave?.onSaveLifecycleSettled?.(tmpError);
			this.pict.providers?.DocumentFrame?.notifyChanged?.();
		}
		return tmpError;
	}

	/**
	 * Execute one full save lifecycle. Never rejects; resolves with the error when one occurred.
	 *
	 * The lifecycle is an Anticipate waterfall fanned out across providers, and it stalls forever if any hook
	 * fails to invoke its callback - a hung socket in FormEntityCreator's Document PUT is the realistic case.
	 * The watchdog releases the latch on a stall so the user is not stranded behind a permanently disabled
	 * Save button with no indication of what happened.
	 * @param {boolean} pMuteNotification - Whether to mute the save toast.
	 * @return {Promise<Error|undefined>}
	 */
	_runSaveLifecycle(pMuteNotification)
	{
		this._MuteNotification = pMuteNotification;
		const tmpUploadID = this.pict.providers.UploadTracking.trackUpload();
		// Falls back rather than trusting options: a missing value would otherwise become a 0ms timeout and
		// make every save look like it stalled.
		const tmpWatchdogTimeoutMS = this.options.SaveWatchdogTimeoutMS || 120000;
		return new Promise((resolve) =>
		{
			let tmpSettled = false;
			/** @type {any} */
			let tmpWatchdogTimer = null;
			/**
			 * @param {Error} [pError] - The error the lifecycle (or the watchdog) produced.
			 * @return {void}
			 */
			const fSettle = (pError) =>
			{
				if (tmpSettled)
				{
					return;
				}
				tmpSettled = true;
				if (tmpWatchdogTimer)
				{
					clearTimeout(tmpWatchdogTimer);
					tmpWatchdogTimer = null;
				}
				this.pict.providers.UploadTracking.untrackUpload(tmpUploadID);
				return resolve(pError);
			};
			tmpWatchdogTimer = setTimeout(() =>
			{
				const tmpTimeoutError = new Error(`Document save did not complete within ${tmpWatchdogTimeoutMS}ms.`);
				this.pict.log.error('Document save watchdog fired; releasing the save lock.', { error: tmpTimeoutError });
				// Surfaced even when the save was muted - a stalled background save is exactly the condition
				// the user otherwise has no way to see.
				this.pict.views?.HeadlightPanels?.toast({
					message: 'The server has not responded to the save. Your latest changes may not be saved.',
					type: 'is-warning',
				});
				return fSettle(tmpTimeoutError);
			}, tmpWatchdogTimeoutMS);
			this.pict.PictApplication.saveDataAsync(fSettle);
		});
	}

	/**
	 * Push the current save state onto the navbar Save button. The button belongs to the panels view and is
	 * re-rendered whenever the document context changes, so that render path calls this too.
	 * @return {void}
	 */
	_syncSaveButtonState()
	{
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (tmpPanelsView && typeof tmpPanelsView.syncSaveButtonState === 'function')
		{
			tmpPanelsView.syncSaveButtonState();
		}
	}

	/**
	 * Push the current save/approval state onto the approval action buttons in the Status panel.
	 *
	 * The buttons live in a panel that is built on demand and rebuilt whenever the approval state is
	 * re-fetched, so both this and that build path apply the state. Derives entirely from provider
	 * state, so calling it before the panel exists is a no-op that the next build picks up.
	 * @return {void}
	 */
	_syncApprovalActionState()
	{
		const tmpStatusPane = this.pict.views?.HeadlightPaneStatus;
		if (tmpStatusPane && typeof tmpStatusPane.syncApprovalActionButtonState === 'function')
		{
			tmpStatusPane.syncApprovalActionButtonState();
		}
	}

	/**
	 * Latch (or release) the approval busy state and repaint everything that reflects it.
	 *
	 * Latch first, then repaint: the latch is what stands auto-save down and blocks a second entry into
	 * takeApprovalAction; the repaints are what tell the user. Every _sync below derives entirely from
	 * the latch, so each is a safe no-op before its DOM exists.
	 * @param {boolean} pIsBusy - Whether an approval action is running.
	 * @param {string} [pAction] - The action being taken, used for the toast copy.
	 * @return {void}
	 */
	_setApprovalBusy(pIsBusy, pAction)
	{
		// A reload is committing, or the page has to be reopened. Releasing now would re-enable a form that
		// is about to be replaced or is out of date, and take away the only explanation the user has; see
		// _beginApprovalReload and _requireReopenAfterApprovalAction.
		if (!pIsBusy && (this._ApprovalReloadPending || this._ApprovalReopenRequired))
		{
			return;
		}
		this.isTakingAction = Boolean(pIsBusy);
		this._ApprovalBusyAction = pIsBusy ? (pAction || '') : '';
		this._syncDocumentFormBusyState();
		this._syncSaveButtonState();
		this._syncApprovalActionState();
		this._syncApprovalBusyToast();
		this.pict.providers?.DocumentFrame?.notifyChanged?.();
	}

	/**
	 * Make the document form inert while an approval action runs.
	 *
	 * `inert` is what actually stops the keyboard - pointer-events only stops the mouse, and almost
	 * nothing in a manifest-driven form carries a disabled attribute. The class goes on the body rather
	 * than the form because Select2 dropdowns and flatpickr calendars portal outside it.
	 * @return {void}
	 */
	_syncDocumentFormBusyState()
	{
		const tmpFormElement = document.getElementById('Headlight-Document-Form');
		if (!tmpFormElement)
		{
			return;
		}
		if (this.isTakingAction)
		{
			// Blur before going inert so focus lands on the body rather than being dropped mid-subtree.
			if (tmpFormElement.contains(document.activeElement) && typeof document.activeElement?.blur === 'function')
			{
				document.activeElement.blur();
			}
			document.body.classList.add('hl-approval-busy');
			tmpFormElement.setAttribute('aria-busy', 'true');
			tmpFormElement.setAttribute('inert', '');
		}
		else
		{
			document.body.classList.remove('hl-approval-busy');
			tmpFormElement.setAttribute('aria-busy', 'false');
			tmpFormElement.removeAttribute('inert');
		}
	}

	/**
	 * Compose the busy-toast copy for an approval action.
	 * @param {string} pAction - The action being taken.
	 * @return {string}
	 */
	_getApprovalBusyMessage(pAction)
	{
		// hasOwnProperty, not a bare lookup: the action name is server-defined, so "constructor" or
		// "toString" would otherwise resolve off Object.prototype and render a function into the toast.
		const tmpKey = String(pAction || '').toLowerCase();
		if (Object.prototype.hasOwnProperty.call(APPROVAL_BUSY_PHRASE, tmpKey))
		{
			return APPROVAL_BUSY_PHRASE[tmpKey] + APPROVAL_BUSY_SUFFIX;
		}
		// A server-defined action name. Name it verbatim rather than guessing a verb for it.
		return (pAction ? `Applying the ${pAction} action to this document.` : 'Updating the document status.') + APPROVAL_BUSY_SUFFIX;
	}

	/**
	 * Show or tear down the persistent toast that explains the busy state.
	 *
	 * Sticky, because the toasts this action itself fires (a failed save, a validation error, the save
	 * watchdog) would otherwise evict the one explanation the user has for a page that stopped responding.
	 * @return {void}
	 */
	_syncApprovalBusyToast()
	{
		if (this._ApprovalBusyEscalationTimer)
		{
			clearTimeout(this._ApprovalBusyEscalationTimer);
			this._ApprovalBusyEscalationTimer = null;
		}
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (!this.isTakingAction)
		{
			// Only clear the announcement this toast made; a later release must not wipe the outcome message.
			if (this._ApprovalBusyToast)
			{
				tmpPanelsView?.dismissToast?.(this._ApprovalBusyToast);
				this._ApprovalBusyToast = null;
				tmpPanelsView?.announceStatus?.('');
			}
			return;
		}
		if (this._ApprovalBusyToast || typeof tmpPanelsView?.toast !== 'function')
		{
			return;
		}
		const tmpMessage = this._getApprovalBusyMessage(this._ApprovalBusyAction);
		this._ApprovalBusyToast = tmpPanelsView.toast(
			{
				message: tmpMessage,
				type: 'is-info',
				sticky: true,
				// No dismiss button: closing it would leave the page locked with nothing left saying why.
				dismissible: false,
				// The action name comes from the server; never let it reach the DOM as markup.
				allowHTML: false,
			});
		tmpPanelsView.announceStatus?.(tmpMessage);
		this._ApprovalBusyEscalationTimer = setTimeout(() => this._escalateApprovalBusyToast(), this.options.ApprovalBusyEscalationMS || APPROVAL_BUSY_ESCALATION_MS);
	}

	/**
	 * Swap the busy toast for a "still waiting" one. Deliberately does not release the lock: the action
	 * may still land server-side, and re-arming auto-save and the action buttons underneath it is exactly
	 * the race the save guard closed.
	 * @return {void}
	 */
	_escalateApprovalBusyToast()
	{
		this._ApprovalBusyEscalationTimer = null;
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (!this.isTakingAction || this._ApprovalReloadPending || this._ApprovalReopenRequired || typeof tmpPanelsView?.toast !== 'function')
		{
			return;
		}
		this.pict.log.warn(`Approval action "${this._ApprovalBusyAction}" has not responded yet; escalating the busy notice.`);
		tmpPanelsView.dismissToast?.(this._ApprovalBusyToast);
		const tmpMessage = 'The server has not responded yet. Keep this page open; it will refresh as soon as the action finishes.';
		this._ApprovalBusyToast = tmpPanelsView.toast({ message: tmpMessage, type: 'is-warning', sticky: true, dismissible: false, allowHTML: false });
		tmpPanelsView.announceStatus?.(tmpMessage);
	}

	/**
	 * Latch the reload phase of an approval action, then reload.
	 *
	 * window.location.reload() does not stop the caller - the finally in takeApprovalAction still runs and
	 * the page keeps executing until the navigation commits. The latch makes that release a no-op, so the
	 * form stays inert and the toast stays up right through the fetch. Extracted so tests can drive the
	 * success path without navigating.
	 * @return {void}
	 */
	_beginApprovalReload()
	{
		this._ApprovalReloadPending = true;
		if (this._ApprovalBusyEscalationTimer)
		{
			clearTimeout(this._ApprovalBusyEscalationTimer);
			this._ApprovalBusyEscalationTimer = null;
		}
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (typeof tmpPanelsView?.toast === 'function')
		{
			// The action landed; what is left is the reload. Say so, so a slow refresh does not read as a hang.
			tmpPanelsView.dismissToast?.(this._ApprovalBusyToast);
			const tmpMessage = 'Status updated. Refreshing the page...';
			this._ApprovalBusyToast = tmpPanelsView.toast({ message: tmpMessage, type: 'is-success', sticky: true, dismissible: false, allowHTML: false });
			tmpPanelsView.announceStatus?.(tmpMessage);
		}
		this.pict.providers?.DocumentFrame?.notifyChanged?.(true);
		window.location.reload();
	}

	/**
	 * Whether a document can be edited, with a TINYINT Locked that arrived as the string "0" read as unlocked.
	 * @param {any} pReportData - The document's ReportData, or an approval state carrying Locked.
	 * @return {{ Locked: boolean, CanEdit: boolean }}
	 */
	_getDocumentEditState(pReportData)
	{
		const tmpLocked = Boolean(pReportData?.Locked) && (pReportData.Locked !== '0');
		return { Locked: tmpLocked, CanEdit: Boolean(pReportData?.CanEdit) };
	}

	/**
	 * The form data a document record carries, as JSON, or null when it carries none.
	 * @param {any} pRecord - A document record from the server.
	 * @return {?string}
	 */
	_getFormDataJSON(pRecord)
	{
		if (!pRecord || (typeof pRecord !== 'object'))
		{
			return null;
		}
		if (pRecord.FormData && (typeof pRecord.FormData === 'object'))
		{
			return JSON.stringify(pRecord.FormData);
		}
		if (typeof pRecord.FormDataJSON === 'string')
		{
			try
			{
				return JSON.stringify(JSON.parse(pRecord.FormDataJSON));
			}
			catch (pError)
			{
				return null;
			}
		}
		return null;
	}

	/**
	 * Log why an approval action falls back from an in-place refresh, and return that fallback.
	 * @param {string} pOutcome - An APPROVAL_REFRESH_OUTCOME value.
	 * @param {string} pReason - Why the page cannot simply be refreshed in place.
	 * @return {string} pOutcome
	 */
	_approvalRefreshFallback(pOutcome, pReason)
	{
		this.pict.log.info(`Approval action: ${pOutcome === APPROVAL_REFRESH_OUTCOME.Reopen ? 'asking the user to reopen the form' : 'reloading the page'} because ${pReason}.`);
		return pOutcome;
	}

	/**
	 * Why the approval service says this action changed more than the document's status, or null when it
	 * says nothing else changed. A response without the list comes from a service that predates it, so it
	 * cannot vouch for anything.
	 * @param {any} pActionResponse - The approval action's response.
	 * @return {?string}
	 */
	_getApprovalSideEffectsReason(pActionResponse)
	{
		const tmpSideEffects = pActionResponse?.SideEffects;
		if (!Array.isArray(tmpSideEffects))
		{
			return 'the approval service did not say what else the action changed';
		}
		if (tmpSideEffects.length > 0)
		{
			return `the action also ran ${tmpSideEffects.join(', ')}, which can change records the form shows`;
		}
		return null;
	}

	/**
	 * Bring the page up to date after an approval action landed, without reloading it when that is safe.
	 *
	 * A reload rebuilds everything from the server, so the in-place path only runs when the action left
	 * nothing it cannot redraw: the approval service reports nothing ran beyond the status change (no
	 * trigger, comprehension or form handler that could change a record the form shows), the edit/lock
	 * state is unchanged and the server still holds exactly the form data this action's save sent.
	 * Anything else falls back to the reload on the web, or to asking the user to reopen the form in the
	 * iOS app, which starts a form only once and would show an empty page after a reload.
	 * @param {{ Locked: boolean, CanEdit: boolean }} pEditStateBefore - The document's edit state before the action.
	 * @param {?string} pSavedFormDataJSON - The form data the server echoed back from this action's save, as JSON.
	 * @param {any} pActionResponse - The approval action's response, carrying `SideEffects`.
	 * @return {Promise<string>} An APPROVAL_REFRESH_OUTCOME value.
	 */
	async _refreshDocumentAfterApprovalAction(pEditStateBefore, pSavedFormDataJSON, pActionResponse)
	{
		const tmpDocumentService = this.services.HeadlightDocumentService;
		const tmpIsLocalTransport = (typeof tmpDocumentService.isLocalDocumentTransport === 'function') && tmpDocumentService.isLocalDocumentTransport();
		const tmpSideEffectsReason = this._getApprovalSideEffectsReason(pActionResponse);
		if (tmpSideEffectsReason)
		{
			return this._approvalRefreshFallback(tmpIsLocalTransport ? APPROVAL_REFRESH_OUTCOME.Reopen : APPROVAL_REFRESH_OUTCOME.Reload, tmpSideEffectsReason);
		}
		try
		{
			if (tmpIsLocalTransport)
			{
				return await this._refreshLocalDocumentAfterApprovalAction(pEditStateBefore);
			}
			return await this._refreshServerDocumentAfterApprovalAction(pEditStateBefore, pSavedFormDataJSON);
		}
		catch (pError)
		{
			this.pict.log.error(`Approval action: could not refresh the page in place: ${pError?.message || pError}`, { Stack: pError?.stack });
			return tmpIsLocalTransport ? APPROVAL_REFRESH_OUTCOME.Reopen : APPROVAL_REFRESH_OUTCOME.Reload;
		}
	}

	/**
	 * The in-place refresh for a page that loads its document from the server.
	 * @param {{ Locked: boolean, CanEdit: boolean }} pEditStateBefore - The document's edit state before the action.
	 * @param {?string} pSavedFormDataJSON - The form data the server echoed back from this action's save, as JSON.
	 * @return {Promise<string>} An APPROVAL_REFRESH_OUTCOME value.
	 */
	async _refreshServerDocumentAfterApprovalAction(pEditStateBefore, pSavedFormDataJSON)
	{
		if (pEditStateBefore.Locked || !pEditStateBefore.CanEdit)
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reload, 'the document was read-only before the action');
		}
		if (!pSavedFormDataJSON)
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reload, 'the save before the action did not return the stored form data');
		}
		const tmpReportData = this.AppData.DocumentData.ReportData;
		const tmpParameters = await this.services.HeadlightDocumentService.fetchDocumentReportParameters(tmpReportData.IDDocument);
		const tmpServerReportData = tmpParameters?.ReportData;
		if (!tmpServerReportData || (Number(tmpServerReportData.IDDocument) !== Number(tmpReportData.IDDocument)))
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reload, 'the server did not return this document');
		}
		const tmpEditStateAfter = this._getDocumentEditState(tmpServerReportData);
		if ((tmpEditStateAfter.Locked !== pEditStateBefore.Locked) || (tmpEditStateAfter.CanEdit !== pEditStateBefore.CanEdit))
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reload, 'the action changed whether the document can be edited');
		}
		if (this._getFormDataJSON(tmpServerReportData) !== pSavedFormDataJSON)
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reload, 'the server changed the form data during the action');
		}
		this._adoptServerDocumentState(tmpServerReportData);
		await this._repaintAfterApprovalAction();
		return APPROVAL_REFRESH_OUTCOME.Refreshed;
	}

	/**
	 * The in-place refresh for the iOS app, where the document comes from the device and only the approval
	 * calls reach the server.
	 *
	 * The device's copy does not learn of the action until it syncs, so the new state is read from the
	 * approval endpoints rather than from the document.
	 * @param {{ Locked: boolean, CanEdit: boolean }} pEditStateBefore - The document's edit state before the action.
	 * @return {Promise<string>} An APPROVAL_REFRESH_OUTCOME value.
	 */
	async _refreshLocalDocumentAfterApprovalAction(pEditStateBefore)
	{
		const tmpDocumentService = this.services.HeadlightDocumentService;
		const tmpState = await tmpDocumentService.fetchApprovalState();
		if (!tmpState || !tmpState.Status)
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reopen, 'the server did not return the new approval state');
		}
		if (this._getDocumentEditState(tmpState).Locked !== pEditStateBefore.Locked)
		{
			return this._approvalRefreshFallback(APPROVAL_REFRESH_OUTCOME.Reopen, 'the action changed whether the document is locked');
		}
		const tmpHistory = await tmpDocumentService.fetchApprovalHistory();
		const tmpServerState = { Status: tmpState.Status, StateName: tmpState.StateName, StateStep: tmpState.StateStep };
		if (Array.isArray(tmpHistory))
		{
			tmpServerState.ApprovalActions = tmpHistory;
		}
		this._adoptServerDocumentState(tmpServerState);
		await this._repaintAfterApprovalAction();
		return APPROVAL_REFRESH_OUTCOME.Refreshed;
	}

	/**
	 * Take the server's copy of everything about the document except what this page owns.
	 * @param {Record<string, any>} pServerReportData - The document's ReportData (or part of it) from the server.
	 * @return {void}
	 */
	_adoptServerDocumentState(pServerReportData)
	{
		const tmpReportData = this.AppData.DocumentData.ReportData;
		Object.keys(pServerReportData).forEach((pKey) =>
		{
			if ((APPROVAL_REFRESH_LOCAL_FIELDS.indexOf(pKey) < 0) && (pServerReportData[pKey] !== undefined))
			{
				tmpReportData[pKey] = pServerReportData[pKey];
			}
		});
	}

	/**
	 * Redraw what shows the document's approval state: the navbar, the status pane and the signature section.
	 *
	 * Resolves once the navbar and the signature section are drawn. The status pane's lists are not waited
	 * for: each refetches (the approver list can take several seconds) and shows its own loading message
	 * meanwhile, never the pre-action actions, so holding the form locked for them only delays the user.
	 * @return {Promise<void>}
	 */
	async _repaintAfterApprovalAction()
	{
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (typeof tmpPanelsView?.updatePanelsBasedOnDocumentContext === 'function')
		{
			tmpPanelsView.updatePanelsBasedOnDocumentContext();
		}
		const tmpStatusPane = this.pict.views?.HeadlightPaneStatus;
		if (typeof tmpStatusPane?.refreshApprovalRegions === 'function')
		{
			Promise.resolve()
				.then(() => tmpStatusPane.refreshApprovalRegions())
				.catch((pError) =>
				{
					this.pict.log.error(`Approval action: the status pane could not refresh; reopening the pane fetches it again: ${pError?.message || pError}`);
				});
		}
		const tmpApplication = this.pict.PictApplication;
		if (typeof tmpApplication?.renderSignatureSection === 'function')
		{
			await tmpApplication.renderSignatureSection();
		}
	}

	/**
	 * Release the busy state once the page shows the document's new state, and say what changed.
	 *
	 * Released before the toast: the release clears the busy toast and the screen-reader region, which
	 * would otherwise take the confirmation with it.
	 * @return {void}
	 */
	_announceApprovalRefreshed()
	{
		this._setApprovalBusy(false);
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (typeof tmpPanelsView?.toast !== 'function')
		{
			return;
		}
		const tmpStatus = this.AppData?.DocumentData?.ReportData?.Status;
		const tmpMessage = tmpStatus ? `Status updated to ${tmpStatus}.` : 'Status updated.';
		tmpPanelsView.toast({ message: tmpMessage, type: 'is-success', allowHTML: false });
		tmpPanelsView.announceStatus?.(tmpMessage);
	}

	/**
	 * Keep the form locked and tell the user to reopen it: the action landed, but this page cannot show the
	 * result and cannot reload itself.
	 * @return {void}
	 */
	_requireReopenAfterApprovalAction()
	{
		this._ApprovalReopenRequired = true;
		if (this._ApprovalBusyEscalationTimer)
		{
			clearTimeout(this._ApprovalBusyEscalationTimer);
			this._ApprovalBusyEscalationTimer = null;
		}
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (typeof tmpPanelsView?.toast === 'function')
		{
			tmpPanelsView.dismissToast?.(this._ApprovalBusyToast);
			const tmpStatus = this.AppData?.DocumentData?.ReportData?.Status;
			const tmpMessage = `${tmpStatus ? `Status updated to ${tmpStatus}.` : 'Status updated.'} Close this form and open it again to keep working.`;
			this._ApprovalBusyToast = tmpPanelsView.toast({ message: tmpMessage, type: 'is-success', sticky: true, dismissible: false, allowHTML: false });
			tmpPanelsView.announceStatus?.(tmpMessage);
		}
		this.pict.providers?.DocumentFrame?.notifyChanged?.(true);
	}

	/**
	 * Re-check whether this document has joined Samples once a save settles, so the navbar Current Samples
	 * button appears without a full view refresh. The join is created server-side, so it cannot be derived
	 * from local state at creation time.
	 * @return {void}
	 */
	_syncCurrentSamplesButtonState()
	{
		const tmpPanelsView = this.pict.views?.HeadlightPanels;
		if (tmpPanelsView && typeof tmpPanelsView.syncCurrentSamplesButtonState === 'function')
		{
			tmpPanelsView.syncCurrentSamplesButtonState();
		}
	}

	// eslint-disable-next-line valid-jsdoc
	/**
	 * This function is used to tie the document save for forms into the application save lifecycle.
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		let onBeforeSavePromise = Promise.resolve();
		//FIXME: migrate this to the new lifecycle events and sunset this
		if (typeof this.pict.PictApplication.onBeforeDocumentSave === 'function')
		{
			onBeforeSavePromise = this.pict.PictApplication.onBeforeDocumentSave();
			if (typeof onBeforeSavePromise.then !== 'function')
			{
				onBeforeSavePromise = Promise.resolve();
			}
		}
		onBeforeSavePromise.then(() =>
		{
			return super.onBeforeSaveDataAsync(fCallback);
		}).catch((error) =>
		{
			this.pict.log.error('Error in onBeforeDocumentSave:', error);
			// Proceed with the save operation even if onBeforeDocumentSave fails
			return super.onBeforeSaveDataAsync(fCallback);
		});
	}

	// eslint-disable-next-line valid-jsdoc
	/**
	 * Ties the document save for forms into the application save lifecycle.
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onSaveDataAsync(fCallback)
	{
		this._saveDocument().then(() =>
		{
			return super.onSaveDataAsync(fCallback);
		}).catch((err) =>
		{
			return super.onSaveDataAsync((pParentError) =>
			{
				return fCallback(err || pParentError);
			});
		});
	}

	/**
	 * Persist the document, then run the application's post-save hook.
	 *
	 * Rethrows a save failure so it reaches the save-data lifecycle callback and, through it, the value
	 * handleSaveAsync resolves with - callers that gate on a successful save (submit, which locks the
	 * document) cannot honour a failure they were never told about. Because the lifecycle waterfall
	 * short-circuits on error, a failed save also skips the remaining onAfterSaveDataAsync hooks, so entity
	 * comprehension is not pushed against a document whose own write did not land.
	 * @return {Promise<void>}
	 */
	async _saveDocument()
	{
		// The baseline advances on the server having seen the payload, not on the record being persisted.
		// It describes what the comprehension has already asked the server to write, and the server is the
		// only thing that applies it - so on the local transport the baseline must stay where it is and
		// every save re-emits everything changed since load. Folding on a local write instead would have
		// the next save's prune drop the records the first save emitted, because they now match the
		// baseline, and only the final document is ever synced.
		const tmpDocumentService = this.pict.services.HeadlightDocumentService;
		const tmpIsServerTransport = (typeof tmpDocumentService.isLocalDocumentTransport !== 'function') ||
			!tmpDocumentService.isLocalDocumentTransport();
		try
		{
			// Fold every provider's emission into the delta baseline ONCE, here, immediately before the
			// PUT: the baseline lives in FormData, and FormData is snapshotted into the PUT body, so a fold
			// after the save would never reach the server and every reload would start from a stale one.
			if (tmpIsServerTransport)
			{
				const tmpPendingRoots = EntityDataBaseline.getPendingEmissionRoots(this.pict);
				EntityDataBaseline.foldPendingEmission(this.pict);
				// The server stores a JSON column whole; a form that binds part of one would drop the rest.
				await new Promise((fResolve) => EntityDataBaseline.mergePendingObjectFieldsWithServer(this.pict, tmpPendingRoots, fResolve));
			}
			this._LastSavedServerFormDataJSON = null;
			const tmpSavedRecord = await this.pict.services.HeadlightDocumentService.saveDocument();
			if (tmpIsServerTransport)
			{
				this._LastSavedServerFormDataJSON = this._getFormDataJSON(tmpSavedRecord);
			}
			this._adoptResolvedRecordIdentities(tmpSavedRecord);
			if (tmpIsServerTransport)
			{
				this._releaseUnappliedRecords(tmpSavedRecord);
			}
		}
		catch (pSaveError)
		{
			// The delta baseline was folded forward before this PUT so it would ride the same payload. The
			// PUT did not land, so it is now claiming records were written that may not have been -
			// discarding it makes the retry project everything whole rather than silently emitting nothing.
			// Nothing was folded on the local transport, so there is nothing to unwind.
			if (tmpIsServerTransport)
			{
				EntityDataBaseline.clearBaseline(this.pict);
			}
			this.pict.log.error('Failed to save document', { error: pSaveError });
			if (!this._MuteNotification)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to save document!',
					type: 'is-danger',
				});
			}
			throw pSaveError;
		}
		if (!this._MuteNotification)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Document saved successfully!',
				type: 'is-success',
			});
		}
		// The document is already persisted by this point, so a failure in the post-save hook is not a save
		// failure and must not be reported as one.
		if (typeof this.pict.PictApplication.onAfterDocumentSave === 'function')
		{
			try
			{
				await this.pict.PictApplication.onAfterDocumentSave();
			}
			catch (pAfterSaveError)
			{
				this.pict.log.error('Document saved, but onAfterDocumentSave failed', { error: pAfterSaveError });
			}
		}
	}

	/**
	 * Adopt the row ids the server resolved for records this save created.
	 *
	 * The form mints GUIDs and the server resolves them to rows; until the ids come back the form
	 * cannot tell a record it created from one it has never saved, and re-asserts every field of it on
	 * every subsequent save. Runs here rather than in the input providers' post-save hook because it has
	 * to land BEFORE those hooks fold the emission into the delta baseline.
	 *
	 * Absent on any path the server does not decorate - bulk writes, offline replay, a form not on the
	 * scoped path - and a save with nothing to resolve. All of those simply keep today's behaviour.
	 *
	 * @param {Record<string, any>} [pSavedRecord] - The document record the save returned.
	 * @return {void}
	 */
	_adoptResolvedRecordIdentities(pSavedRecord)
	{
		const tmpIdentities = pSavedRecord && pSavedRecord.ComprehensionRecordIdentities;
		if (!tmpIdentities || typeof tmpIdentities !== 'object')
		{
			return;
		}
		try
		{
			const tmpAdopted = EntityDataBaseline.applyResolvedIdentities(this.pict, tmpIdentities);
			// Trace, not info: one line per save is noise in normal operation, but the count is the only
			// thing that separates "the save carried no identities" from "it carried some and none matched
			// a held record", which is worth having when a form starts re-emitting records it should not.
			this.pict.log.trace(`DocumentProvider: took ${tmpAdopted} server-resolved record id(s) from the save.`);
		}
		catch (pError)
		{
			this.pict.log.error(`DocumentProvider: could not adopt the server-resolved record ids; the next save may re-assert those records whole: ${pError.message || pError}`);
		}
	}

	/**
	 * Un-baseline the records this save asked for and the server refused, so the next save sends them again.
	 *
	 * The baseline was folded before the PUT and already counts them as written. The save response carries
	 * the document's `EntityData` with the new `ExecutionLog` entry, which is the source of record for what
	 * landed.
	 *
	 * @param {Record<string, any>} [pSavedRecord] - The document record the save returned.
	 * @return {void}
	 */
	_releaseUnappliedRecords(pSavedRecord)
	{
		if (!pSavedRecord || typeof pSavedRecord !== 'object')
		{
			return;
		}
		try
		{
			EntityDataBaseline.releaseUnappliedRecords(this.pict, pSavedRecord.EntityData || pSavedRecord.EntityDataJSON);
		}
		catch (pError)
		{
			this.pict.log.error(`DocumentProvider: could not read which records the save left unapplied; they will not be retried until the document is reopened: ${pError.message || pError}`);
		}
	}

	/**
	 * This function is used to take an approval action on a document.
	 * @param {string} action - The action to take on the document
	 * @return {Promise<void>}
	 * @async
	 * @example
	 * takeApprovalAction('Approve');
	 * takeApprovalAction('Reject');
	 * takeApprovalAction('Submit');
	 */
	async takeApprovalAction(action)
	{
		if (!this.isTakingAction)
		{
			// Latch and lock before the first await - the user needs to know something is happening at
			// click time, not after the save settles. The latch is also what stands auto-save down and
			// stops a second click landing.
			this._setApprovalBusy(true, action);
			let isFormValid = true;
			const tmpEditStateBefore = this._getDocumentEditState(this.AppData?.DocumentData?.ReportData);
			// Only a save made by this action may vouch for the server's copy of the form data.
			this._LastSavedServerFormDataJSON = null;

			try
			{
				// An approval action changes (and often locks) the document server-side. Acting while a
				// save is still in flight lets the lock land first, which rejects the resolving save and
				// loses whatever it carried -- the "beat the clock" race. The buttons are disabled for
				// the duration of a save, so reaching this await means something bypassed the UI (an
				// auto-save that started between the click and the handler, a keyboard activation, a
				// programmatic call); wait it out rather than racing it.
				await this.whenSaveSettled();
				// toggle the panel before rendering the new status
				this.pict.views.HeadlightPanels.handlePanelToggle('Status');

				const tmpIsSubmit = action?.toLowerCase() === 'submit';
				// Await the full save (Document PUT) BEFORE the approval action runs. Every action ends in a page
				// reload, so anything not yet saved is lost (a Start on a LIMS test form came back In Test with
				// the entered values gone); and an action that locks the doc rejects a save that lands after it,
				// losing the GUID->id resolution too. Abort on save failure rather than act over unsaved state.
				if (tmpIsSubmit || this._canSaveBeforeApprovalAction())
				{
					const tmpSaveError = await this.handleSaveAsync(true);
					if (tmpSaveError)
					{
						this.log.error(`Aborting approval action "${action}": the document save failed`, { error: tmpSaveError });
						const tmpHeadline = tmpIsSubmit ? 'Failed to save document; can\'t submit.' : 'Failed to save document; the status was not changed.';
						this.pict.views.HeadlightPanels.toast({
							message: `<strong>${tmpHeadline}</strong><br/><em>${tmpSaveError.message || tmpSaveError}</em>`,
							type: 'is-danger',
						});
						return;
					}
				}

				// if the action is to submit the form, we need to check validation before proceeding
				//FIXME: these being hard-coded is no-bueno
				if (tmpIsSubmit || action?.toLowerCase() === 'approve')
				{
					// All form-validation logic + styling is delegated to the
					// InputValidation provider so it stays consistent with
					// the per-input flows (visibility-aware required sync,
					// correct ancestor traversal via closest(), Select2
					// widget mirroring, data-required hidden-bearer value
					// checks for custom widgets like Signature, aria-invalid
					// sync, etc).
					const formElement = document.getElementById('Headlight-Document-Form');
					const inputValidationProvider = this.pict.providers.InputValidation;
					const hasInputValidationProvider = inputValidationProvider
						&& typeof inputValidationProvider.preSubmitVisibilitySweep === 'function'
						&& typeof inputValidationProvider.applyFormSubmissionStyling === 'function';

					if (formElement && hasInputValidationProvider)
					{
						// Step 1 - sync `required` on every manifest-required
						// input based on current visibility. Hidden-tab
						// fields lose `required`, fields that came back
						// into view get it restored. Keeps the browser's
						// native checkValidity() honest.
						inputValidationProvider.preSubmitVisibilitySweep(formElement);

						// Step 2 - apply styling across the form and let the
						// provider tell us whether anything visible is still
						// in a failing state. Provider handles all the
						// per-input edge cases (Select2 widget mirroring,
						// hidden data-bearer value checks, etc).
						const tmpProviderSaysValid = inputValidationProvider.applyFormSubmissionStyling(formElement);
						const tmpNativeInvalid = formElement instanceof HTMLFormElement && !formElement.checkValidity();

						if (tmpNativeInvalid || !tmpProviderSaysValid)
						{
							formElement.classList.add('show-validation');
							this.pict.views.HeadlightPanels.toast({
								message: 'Form validation failed. Please correct the errors and try again.',
								type: 'is-danger',
							});
							isFormValid = false;
						}
					}
					else if (formElement instanceof HTMLFormElement && !formElement.checkValidity())
					{
						// Fallback when the InputValidation provider isn't
						// available - purely native checks, no styling
						// niceties.
						formElement.classList.add('show-validation');
						this.pict.views.HeadlightPanels.toast({
							message: 'Form validation failed. Please correct the errors and try again.',
							type: 'is-danger',
						});
						isFormValid = false;
					}
				}
				// if the form is verfied as valid (on submission checks), then proceed with the action
				if (isFormValid)
				{
					// remove the validation class from the form
					document.getElementById('Headlight-Document-Form')?.classList.remove('show-validation');
					// send the action to the service to update the document status
					const response = await this.services.HeadlightDocumentService.doApprovalAction(action);
					this.AppData.DocumentData.ReportData.Status = response.Status;
					const tmpOutcome = await this._refreshDocumentAfterApprovalAction(tmpEditStateBefore, this._LastSavedServerFormDataJSON, response);
					if (tmpOutcome === APPROVAL_REFRESH_OUTCOME.Reload)
					{
						this._beginApprovalReload();
					}
					else if (tmpOutcome === APPROVAL_REFRESH_OUTCOME.Reopen)
					{
						this._requireReopenAfterApprovalAction();
					}
					else
					{
						this._announceApprovalRefreshed();
					}
				}
			}
			catch (e)
			{
				this.pict.log.error('Failed to change the document status', { error: e });
				// post a note to the user that the action failed
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to change the document status!',
					type: 'is-danger',
				});
			}
			finally
			{
				// A no-op once a reload is committing, so the lock and its toast survive the navigation.
				this._setApprovalBusy(false);
			}
		}
		else
		{
			this.pict.log.warn('Approval action is already in progress.');
		}
	}

	/**
	 * Whether an approval action other than Submit should save the document before it runs: only when the
	 * user could have edited it, since a save on a locked or read-only document is rejected and would
	 * block an action (an approver's Approve or Reject) that does not need one.
	 * @return {boolean}
	 */
	_canSaveBeforeApprovalAction()
	{
		const tmpReportData = this.pict.AppData?.DocumentData?.ReportData;
		if (!tmpReportData)
		{
			return false;
		}
		// A TINYINT Locked can arrive as the string "0", which is JS-truthy.
		if (tmpReportData.Locked && tmpReportData.Locked !== '0')
		{
			return false;
		}
		return Boolean(tmpReportData.CanEdit);
	}

	/**
	 * This method is sued to view the document file as a PDF or JSON blob in a new tab.
	 * @param {string} pTarget - The target for the document file
	 * @param {boolean} asRawJSON - Whether to view the document file as raw JSON
	 * @param {number} [passedID] - If an id is passed, view that document file instead.
	 * @return {Promise<Window>}
	 * @example
	 * viewDocumentFile('_blank', false);
	 */
	viewDocumentFile(pTarget, asRawJSON = false, passedID)
	{
		return new Promise((resolve, reject) =>
		{
			const documentId = passedID || this.AppData?.DocumentData?.ReportData?.IDDocument;

			if (!documentId)
			{
				return reject(new Error('Document ID is missing'));
			}

			const extension = asRawJSON ? 'json' : 'pdf';

			try
			{
				const openedWindow = window.open(`${this.options.HeadlightAPIURL}Document/${documentId}/DCR.${extension}`, pTarget || '_blank');
				if (openedWindow)
				{
					return resolve(openedWindow);
				}
				else
				{
					return reject(new Error('Failed to open document'));
				}
			}
			catch (e)
			{
				return reject(e);
			}
		});
	}

	/**
	 * This method is used to get the document record for a specific document id.
	 * @param {any} pIDDocument - The document id to get the record for
	 * @param {Function} [pCallback] - The callback function to call when the document record is retrieved
	 * @return {Promise<Object>}
	 */
	async getDocument(pIDDocument, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Document/${pIDDocument}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Document: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Document: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * This method is used to get the document record for a specific document guid.
	 * @param {any} pGUIDDocument - The document guid to get the record for
	 * @param {Function} pCallback - The callback function to call when the document record is retrieved
	 * @return {Promise<Object>}
	 */
	async getDocumentByGUID(pGUIDDocument, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Documents/By/GUIDDocument/${pGUIDDocument}`,
					(pError, pBody) =>
					{
						if (pError || !pBody.length)
						{
							this.pict.log.error(`Error fetching Document: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody[0]);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody[0]);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Document: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Add a polyjoin for a remote entity to a document (only if it does not already exist).
	 * @param {Number} pIDDocument - The ID of the Document being added to.
	 * @param {Number} pIDRemote - The ID of the RemoteEntity to get Documents for
	 * @param {Number} pRemoteType - The Type of Entity to get Documents for
	 * @param {Function} [pCallback] - The callback function to call when the Documents are fetched
	 * @return {Promise}
	 */
	async addRemoteToDocument(pIDDocument, pIDRemote, pRemoteType, pCallback)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`DocumentPolyJoins/FilteredTo/FBV~IDDocument~EQ~${ pIDDocument }~FBV~IDRemote~EQ~${ pIDRemote }~FBV~RemoteType~EQ~${ pRemoteType }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error joining to document: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
							this.pict.providers.UploadTracking.untrackUpload(uploadID);
						}
						else
						{
							if (pBody.length)
							{
								resolve(true);
								if (pCallback)
								{
									pCallback(true);
								}
								this.pict.providers.UploadTracking.untrackUpload(uploadID);
							}
							else
							{
								this.pict.fable.services.HeadlightRestClient.postJSON('DocumentPolyJoin',
									{
										RemoteType: pRemoteType,
										IDRemote: pIDRemote,
										IDDocument: pIDDocument,
									},
									async (pError, pBody) =>
									{
										if (pError)
										{
											this.pict.log.error(`Error joining to document: `, pError);
											reject(pError);
											// if we have a callback, run it now
											if (pCallback)
											{
												pCallback(null);
											}
										}
										else
										{
											resolve(true);
											if (pCallback)
											{
												pCallback(true);
											}
										}
										this.pict.providers.UploadTracking.untrackUpload(uploadID);
									});
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error joining to document: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
		}
	}

	/**
	 * Get Documents by a DocumentPolyJoin Remote ID
	 * @param {Number} pIDRemote - The ID of the RemoteEntity to get Documents for
	 * @param {Number} pRemoteType - The Type of Entity to get Documents for
	 * @param {Function} [pCallback] - The callback function to call when the Documents are fetched
	 * @return {Promise}
	 */
	async getDocumentsByRemoteID(pIDRemote, pRemoteType, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`DocumentPolyJoins/FilteredTo/FBV~IDRemote~EQ~${ pIDRemote }~FBV~RemoteType~EQ~${ pRemoteType }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Documents: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							if (pBody.length)
							{
								// Batch-fetch every joined Document in ONE request (no Count)
								// instead of one Document/{id} GET per join. This N+1 used to
								// dominate Sample-open time when a sample had many documents.
								const tmpDocumentIDs = pBody.map((pJoin) => pJoin.IDDocument);
								this.pict.fable.services.HeadlightRestClient.getJSON(`Documents/FilteredTo/FBL~IDDocument~INN~${ tmpDocumentIDs.join(',') }/0/${ tmpDocumentIDs.length }`,
									(pDocumentError, pDocumentBody) =>
									{
										if (pDocumentError)
										{
											this.pict.log.error(`Error fetching Documents: `, pDocumentError);
											reject(pDocumentError);
											if (pCallback)
											{
												pCallback(null);
											}
											return;
										}
										// Preserve the CreateDate-DESC order from the join query.
										const tmpDocumentsByID = {};
										for (const tmpDocument of (pDocumentBody || []))
										{
											tmpDocumentsByID[tmpDocument.IDDocument] = tmpDocument;
										}
										const fullDocuments = tmpDocumentIDs.map((pID) => tmpDocumentsByID[pID]).filter((pDocument) => pDocument);
										resolve(fullDocuments);
										if (pCallback)
										{
											pCallback(fullDocuments);
										}
									});
							}
							else
							{
								resolve([]);
								if (pCallback)
								{
									pCallback([]);
								}
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Documents: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the Documents
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	async getDocuments()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Documents';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Documents/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Documents list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Document search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<number>}
	 * @async
	 * @example
	 * getDocumentSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getDocumentSearchCount(pSearchQuery)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `Documents/Count${tmpFilter ? `/${tmpFilter}` : ''}`;

		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
					reject(pError);
				}
				else
				{
					resolve(pBody?.Count || 0);
				}
			});
		});
	}

	/**
	 * Get the Document search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 * getDocumentSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getDocumentSearchResults(pSearchQuery)
	{
		const tmpURL = `Documents/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
					reject(pError);
				}
				if (!Array.isArray(pBody))
				{
					//FIXME: ...
					return resolve([]);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Returns the current time formatted as HH:mm:ss (using dayjs)
	 * @return {string} The current time formatted as HH:mm:ss
	 */
	getDocumentDateCurrentTime()
	{
		return ` ${ this.fable.Dates.dayJS(new Date()).format('HH:mm:ss') }`;
	}

	/**
	 * This method performs an Document search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @return {Promise<{ results: any, count: number }>}
	 * @async
	 */
	async performDocumentSearch(pOptions = {})
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions)
			{
				this.pict.log.error('No search options provided.');
				return reject(new Error('No search options provided.'));
			}

			const tmpSearchQuery = {
				filters: [],
				pagination: {
					start: pOptions?.CurrentPage || 1,
					limit: pOptions?.PageSize || 25,
				},
				sort: {
					field: pOptions.SortBy || 'DocumentDate',
					direction: pOptions.SortDirection || 'DESC',
				},
			};

			// handle the search filters
			if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'Name',
					comparator: 'LK',
					target: pOptions.SearchText,
				});
			}

			// handle the search filters
			if (pOptions?.Status && pOptions.Status?.trim().length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'Status',
					comparator: 'LK',
					target: pOptions.Status,
				});
			}

			if (pOptions?.Projects && pOptions.Projects.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDProject',
					comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
				});
			}

			if (pOptions?.Users && pOptions.Users.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'CreatingIDUser',
					comparator: pOptions.Users.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Users.length === 1 ? pOptions.Users[0] : pOptions.Users,
				});
			}

			if (pOptions?.StartDate && pOptions.StartDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'DocumentDate',
					comparator: 'GE',
					target: pOptions.StartDate,
				});
			}

			if (pOptions?.EndDate && pOptions.EndDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'DocumentDate',
					comparator: 'LE',
					target: pOptions.EndDate,
				});
			}

			// Perform the search by calling both getDocumentSearchCount and getDocumentSearchResults
			Promise.all([
				this.getDocumentSearchCount(tmpSearchQuery),
				this.getDocumentSearchResults(tmpSearchQuery),
			])
				.then(([ tmpCountResults, tmpResults ]) =>
				{
					resolve({ results: tmpResults, count: tmpCountResults });
				})
				.catch((error) =>
				{
					this.log.error('Error during Document search:', error);
					reject(error);
				});
		});
	}

	/**
	 * This method is used to get the document types for a specific Customer.
	 * @param {number} pIDCustomer - The Customer id to get the document types for
	 * @param {Boolean} [excludeContainers] - Exclude "container" type forms from the list. Defaults to false.
	 *  @param {Boolean} [excludeNonManual] - Exclude forms that are not meant to be manually created. Defaults to false.
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 * getReportNamedInstancesByCustomer(1234);
	 */
	async getReportNamedInstancesByCustomer(pIDCustomer, excludeContainers = false, excludeNonManual = false)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('ReportNamedInstance', `FBV~IDCustomer~EQ~${ pIDCustomer }~FSF~Name~ASC~0`, ()=>{}, ()=>{}, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Document Types list.', pError);
					return reject(pError);
				}
				if (excludeContainers)
				{
					const nonContainerForms = [];
					for (const f of pBody)
					{
						if (!f.Options?.Container)
						{
							nonContainerForms.push(f);
						}
					}
					pBody = nonContainerForms;
				}
				if (excludeNonManual)
				{
					const nonManualForms = [];
					for (const f of pBody)
					{
						if (!f.Options?.NoManualCreation)
						{
							nonManualForms.push(f);
						}
					}
					pBody = nonManualForms;
				}
				resolve(pBody.sort((a, b) => 
				{
					if ( a.Name < b.Name ){
						return -1;
					}
					if ( a.Name > b.Name ){
						return 1;
					}
				}));
			});
		});
	}

	async _getReportNamedInstancesByProjectPaged(pIDProject, page)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`ReportNamedInstancesByProject/${ pIDProject }/${ page * 250 }/250`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
					reject(pError);
				}
				if (!Array.isArray(pBody))
				{
					return resolve([]);
				}
				resolve(pBody);
			});
		});
	}

	async getCreatableContainerRNIsByProject(pIDProject)
	{
		const results = await this.getReportNamedInstancesByProject(pIDProject);
		const containerForms = [];
		for (let r of results)
		{
			if (r.Options?.Container && !r.Options?.NoManualCreation)
			{
				containerForms.push(r);
			}
		}
		return containerForms;
	}

	async getReportNamedInstancesByProject(pIDProject, excludeContainers = false, excludeNonManual = false)
	{
		let hitEnd = false;
		let results = [];
		let page = 0;
		while (!hitEnd)
		{
			const pagedResults = await this._getReportNamedInstancesByProjectPaged(pIDProject, page);
			page += 1;
			if (pagedResults?.length < 250)
			{
				hitEnd = true;
			}
			results = results.concat(pagedResults);
		}
		if (excludeContainers)
		{
			const nonContainerForms = [];
			for (const f of results)
			{
				if (!f.Options?.Container)
				{
					nonContainerForms.push(f);
				}
			}
			results = nonContainerForms
		}
		if (excludeNonManual)
		{
			const nonManualForms = [];
			for (const f of results)
			{
				if (!f.Options?.NoManualCreation)
				{
					nonManualForms.push(f);
				}
			}
			results = nonManualForms;
		}
		return results.sort((a, b) => 
		{
			if ( a.Name < b.Name ){
				return -1;
			}
			if ( a.Name > b.Name ){
				return 1;
			}
		});
	}

	/**
	 * This method is used to handle the duplication of a document (a new instance by the clonee user, with all the previous form data carried over).
	 * @param {object} pCustomOptions - The custom options to use when duplicating the document
	 * @param {object} pDocumentObject - The document object to duplicate
	 * @param {(pError?: Error, pNewDocument?: object) => void} pCallback - Called with the new document once duplicated, or with an error if duplication failed
	 */
	async handleDocumentDuplication(pCustomOptions, pDocumentObject, pCallback)
	{
		const tmpFailDuplication = (pError) =>
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'Failed to duplicate document!',
				type: 'is-danger',
			});
			if (typeof pCallback === 'function')
			{
				pCallback(pError);
			}
		};
		if (!pDocumentObject || typeof pDocumentObject !== 'object')
		{
			this.pict.log.error('Document object was not passed.');
			tmpFailDuplication(new Error('Document object was not passed.'));
			return;
		}
		if (!this.ensureCanCreateDocument('Duplicate'))
		{
			if (typeof pCallback === 'function')
			{
				pCallback(new Error('This page cannot create a new document.'));
			}
			return;
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		// NOTE: This is super confusing, but a legacy thing that we need to work around
		// The document TYPE is stored in the TidingsData.Type field, but we need to find the matching document HASH to set the exact instance for the new document
		const documentRNIHash = pCustomOptions.Type || pDocumentObject?.ReportData?.DocumentType || pDocumentObject?.DocumentType;
		// get the RNIs for the customer
		let customerRNIs;
		try
		{
			customerRNIs = await this.getReportNamedInstancesByCustomer(pDocumentObject?.ReportData?.IDCustomer || pDocumentObject?.IDCustomer);
		}
		catch (pError)
		{
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
			tmpFailDuplication(pError);
			return;
		}
		// find the matching document type via the project RNIs
		const match = customerRNIs.find((rni) => rni.Hash === documentRNIHash);
		if (!match)
		{
			this.pict.log.error('No matching RNI Hash has been set on this customer!');
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
			tmpFailDuplication(new Error('No matching RNI Hash has been set on this customer!'));
			return;
		}
		const documentName = pCustomOptions.Name || match?.Name || pDocumentObject?.ReportData?.Name || pDocumentObject?.Name;
		// duplicate the document
		const newDocument = {
			IDDocument: 0,
			Version: 0,
			Form: pDocumentObject?.ReportData?.Form || pDocumentObject?.Form,
			Name: documentName,
			DocumentType: match.Hash,
			FormData: pDocumentObject?.ReportData?.FormData || pDocumentObject?.FormData || {},
			IDProject: pDocumentObject?.ReportData?.IDProject || pDocumentObject?.IDProject,
		};
		// if we have a custom document date, set it, otherwise use the current date
		if (pCustomOptions.DocumentDate)
		{
			newDocument.DocumentDate = pCustomOptions.DocumentDate;
		}
		// Stuff our meta data into the document (someday the server will provide this for us so we don't have to do this manually)
		newDocument.FormData.Meta = {
			ClonedFromDocumentType: pDocumentObject?.ReportData?.DocumentType || pDocumentObject?.DocumentType,
			ClonedFromDocumentId: pDocumentObject?.ReportData?.IDDocument || pDocumentObject?.IDDocument,
			ClonedFromGUIDDocument: pDocumentObject?.ReportData?.GUIDDocument || pDocumentObject?.GUIDDocument,
		};
		const tmpURL = 'Document';
		this.pict.HeadlightRestClient.postJSON(tmpURL, newDocument, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to duplicate document.', pError);
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
				tmpFailDuplication(pError);
			}
			else
			{
				this.pict.log.info('Document duplicated successfully.', pBody);
				// Form-version pinning is now SERVER-SIDE (the Document controller's onAfterCreate shim), so it
				// works for EVERY document regardless of client - no client-side stamp here.
				if (typeof pCallback === 'function')
				{
					pCallback(null, pBody);
					this.pict.providers.UploadTracking.untrackUpload(uploadID);
				}
			}
		});
	}

	/**
	 * This method is used to handle the deletion of a document.
	 * @param {any} pIDDocument - The document id to delete
	 * @param {Function} pCallback - The callback function to call when the deletion is complete
	 * @return {void}
	 */
	handleDocumentDeletion(pIDDocument, pCallback)
	{
		if (!pIDDocument)
		{
			this.pict.log.error('IDDocument object was not passed.');
			return;
		}
		this.pict.HeadlightRestClient.deleteEntity('Document', pIDDocument, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete document.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete document!',
					type: 'is-danger',
				});
				pCallback(pError);
			}
			else
			{
				this.pict.log.info('Document deleted successfully.', pBody);
				if (typeof pCallback === 'function')
				{
					pCallback(pBody);
				}
			}
		});
	}

	/**
	 * This method is used to handle the creation of a document.
	 * @param {object} pDocument - The document object to create
	 * @param {boolean} pMuteToasts - Whether to mute the toasts
	 * @return {Promise<any>}
	 * @async
	 */
	async createDocument(pDocument, pMuteToasts = false)
	{
		if (!pDocument || typeof pDocument !== 'object')
		{
			this.pict.log.error('Document object was not passed.');
			return;
		}
		// check for required fields
		if (!pDocument?.Name || !pDocument?.DocumentType || !pDocument?.IDProject)
		{
			this.pict.log.error('Document object is missing required fields.');
			return;
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		// create a new document object to send to the server
		const newDocument = {
			IDDocument: 0,
			Version: 0,
			Form: pDocument?.Form,
			Name: pDocument?.Name,
			DocumentType: pDocument?.DocumentType,
			IDProject: pDocument?.IDProject,
		};
		if (pDocument.GUIDDocument)
		{
			newDocument.GUIDDocument = pDocument.GUIDDocument;
		}
		// optional fields
		if (pDocument?.DocumentDate)
		{
			newDocument.DocumentDate = pDocument.DocumentDate;
		}
		if (pDocument?.FormData)
		{
			newDocument.FormData = pDocument.FormData;
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON('Document', pDocument, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to create document.', pError);
					if (!pMuteToasts)
					{
						this.pict.views.HeadlightPanels.toast({
							message: 'Failed to create document!',
							type: 'is-danger',
						});
					}
					this.pict.providers.UploadTracking.untrackUpload(uploadID);
					return reject(pError);
				}
				if (!pMuteToasts)
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'Document created successfully!',
						type: 'is-success',
					});
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
				// Form-version pinning is now SERVER-SIDE (the Document controller's onAfterCreate shim), universal across clients.
				resolve(pBody);
			});
		});
	}

	setScreenResizeIcon(screenMode)
	{
		const iconElement = document.getElementById('HeadlightPanels-NavBar-FullScreen-Button-Icon');
		const maximizeClass = 'fa-up-right-and-down-left-from-center';
		const minimizeClass = 'fa-down-left-and-up-right-to-center';
		if (iconElement)
		{
			if (screenMode === 'widescreen')
			{
				iconElement.classList.remove(maximizeClass);
				iconElement.classList.add(minimizeClass);
			}
			else
			{
				iconElement.classList.remove(minimizeClass);
				iconElement.classList.add(maximizeClass);
			}
		}
	}

	handleScreenResize(passedID)
	{
		let screenMode = 'standard';
		const alwaysWideScreenModeClass = 'always-widescreen-mode';
		const docElement = passedID ? document.getElementById(passedID) : document.body;
		if (docElement.classList.contains(alwaysWideScreenModeClass))
		{
			screenMode = 'standard';
			docElement.classList.remove(alwaysWideScreenModeClass);
		}
		else
		{
			screenMode = 'widescreen';
			docElement.classList.add(alwaysWideScreenModeClass);
		}
		this.pict.views.HeadlightPaneSettings.updateUserPreferences('ScreenWidth', screenMode);
		this.setScreenResizeIcon(screenMode);
	}

	/**
	 * This method is used to check if an observation is included in the document.
	 * @param {string} pObservationID - The observation ID to check
	 * @return {boolean} - True if the observation is included in the document, false otherwise
	 * @example
	 * isObservationIncludedInDocument('1234');
	 */
	isObservationIncludedInDocument(pObservationID)
	{
		if (!pObservationID)
		{
			this.pict.log.error('No Observation ID provided.');
			return false;
		}
		const tmpObservation = this.AppData?.DocumentData?.ReportData?.Observations?.find((observation) => observation.IDObservation === pObservationID);
		if (tmpObservation)
		{
			return true;
		}
		return false;
	}
}

module.exports = DocumentProvider;
module.exports.default_configuration = { AutoSaveDataWithApp: true, SaveWatchdogTimeoutMS: 120000 };

},{"headlight-dynamic-inputs-bundle/source/providers/_EntityDataBaseline.js":154,"headlight-rest-client":20,"pict-provider":552}],1580:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

const libPictProvider = require('pict-provider');

class EntityProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.HasInitialized = false;
		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		// Check to see that the Entiy was passed in with the options object or not
		if (typeof(this.options.Entity) !== 'string')
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity not defined or is not a string in provider options; initializeEntity must be called manually.`);
		}
		else if (this.options.Entity.length === 0)
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity is an empty string in provider options; initializeEntity must be called manually.`);
		}
		else
		{
			this.Entity = this.options.Entity;
			this.HasEntity = true;
		}
	}

	onInitializeAsync(fCallback)
	{
		const tmpAnticipate = this.pict.newAnticipate();

		if (this.HasEntity && this.pict.PictApplication.loggedIn)
		{
			tmpAnticipate.anticipate(this.initializeEntity.bind(this));
		}

		tmpAnticipate.wait(fCallback);
	}

	onBeforeLoadDataAsync(fCallback)
	{
		const tmpAnticipate = this.pict.newAnticipate();

		if (this.HasEntity && this.pict.PictApplication.loggedIn && !this.HasInitialized)
		{
			tmpAnticipate.anticipate(this.initializeEntity.bind(this));
		}

		tmpAnticipate.wait(fCallback);
	}

	setEntity(pEntity)
	{
		if (this.HasEntity)
		{
			this.pict.log.error(`Entity already set to ${this.Entity} so setEntity cannot be called again.`);
			return false;
		}
		if (typeof(pEntity) !== 'string')
		{
			this.pict.log.error(`Entity must be a string when calling setEntity.`);
			return false;
		}
		if (pEntity.length === 0)
		{
			this.pict.log.error(`Entity must be a non-empty string when calling setEntity.`);
			return false;
		}

		this.Entity = pEntity;
		this.HasEntity = true;
		return true;
	}

	initializeEntity(fCallback)
	{
		if (!this.HasEntity)
		{
			this.pict.log.error(`Entity not set so initializeEntity cannot be called.`);
			return fCallback('Entity not set so initializeEntity cannot be called.');
		}
		if (this.HasInitialized)
		{
			this.pict.log.error(`Entity already initialized so initializeEntity cannot be called again.`);
			return fCallback('Entity already initialized so initializeEntity cannot be called again.');
		}

		const tmpAnticipate = this.pict.newAnticipate();

		tmpAnticipate.anticipate(this.loadSchema.bind(this));

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error initializing Entity [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Entity [${this.Entity}] successfully initialized.`);
					this.HasInitialized = true;
				}
				return fCallback(pError);
			});
	}


	loadSchema(fCallback)
	{
		const tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () =>
		{};
		return tmpCallback();
		// TODO: Why does this take 100ms per schema; these should be instant...
		// let tmpAnticipate = this.pict.newAnticipate();

		// tmpAnticipate.anticipate(
		// 	(fRequestCallback) =>
		// 	{
		// 		return this.pict.HeadlightRestClient.getJSON(`${this.Entity}/Schema`,
		// 			(pError, pResponse) =>
		// 			{
		// 				if (pError)
		// 				{
		// 					this.pict.log.error(`Error loading schema for Entity [${this.Entity}]: ${pError}`);
		// 				}
		// 				else
		// 				{
		// 					this.EntitySchema = pResponse;
		// 					this.pict.log.info(`Schema successfully loaded by provider for Entity [${this.Entity}]`);
		// 				}
		// 				return fRequestCallback(pError);
		// 			}
		// 		);
		// 	});

		// tmpAnticipate.wait(
		// 	function(pError)
		// 	{
		// 		if (pError)
		// 		{
		// 			this.pict.log.error(`Error loading schema for Entity [${this.Entity}]: ${pError}`);
		// 		}
		// 		else
		// 		{
		// 			this.pict.log.info(`Schema successfully loaded by provider for Entity [${this.Entity}]`);
		// 		}
		// 		return tmpCallback(pError);
		// 	});
	}


	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecords(fCallback, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Default to 0 for the cursor start
		const tmpRecordCursorStart = (typeof(pRecordCursorStart) === 'number') ? pRecordCursorStart : 0;
		// Default to 100 records
		const tmpRecordCount = (typeof(pRecordCount) === 'number') ? pRecordCount : 100;
		// Default to no meadow filter
		const tmpMeadowFilter = (typeof(pMeadowFilter) === 'string') ? pMeadowFilter : false;

		// Construct the URI
		let tmpURI = `${this.Entity}s`;
		if (tmpMeadowFilter)
		{
			tmpURI += `/${tmpMeadowFilter}`;
		}
		tmpURI += `/${tmpRecordCursorStart}/${tmpRecordCount}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		if (this.Entity == 'BridgeRawData')
		{
			tmpAnticipate.anticipate((fRequestCallback) =>
			{
				tmpRequestResponse.Response =
				tmpRequestResponse.Response.map((record) =>
				{
					return {
						...record,
						'Record': JSON.parse(record['Record']),
					};
				});

				return fRequestCallback();
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Loaded ${tmpRequestResponse.Response.length} records loaded for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordsToAddress(fCallback, pAddress, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		return this.loadRecords(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pMeadowFilter, pRecordCursorStart, pRecordCount);
	}


	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecordByID(fCallback, pIDEntity)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		if (typeof(pIDEntity) == 'undefined')
		{
			this.pict.log.error(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
			return fCallback(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		let tmpURI = `${this.Entity}`;
		// TODO: Guards on the data type?  We want to at least support string and number but maybe function?  aaah.
		tmpURI += `/${pIDEntity}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		if (this.Entity == 'BridgeRawData')
		{
			tmpAnticipate.anticipate(
				(fRequestCallback) =>
				{
					return this.pict.HeadlightRestClient.getJSON(tmpURI,
						(pError, pResponse) =>
						{
							tmpRequestResponse.Response = {
								...pResponse,
								'Record': JSON.parse(pResponse['Record']),
							};

							return fRequestCallback(pError);
						});
				});
		}

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading record for [${this.Entity}] by ID ${pIDEntity} URI [${tmpURI}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Record loaded for [${this.Entity}] by ID ${pIDEntity}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordByIDToAddress(fCallback, pAddress, pIDEntity)
	{
		return this.loadRecordByID(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pIDEntity);
	}


	upsertRecord(fCallback, pRecord)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}
		if (typeof(pRecord) != 'object')
		{
			this.pict.log.error(`Record must be an object when calling upsertRecord.`);
			return fCallback(`Record must be an object when calling upsertRecord.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		const tmpURI = `${this.Entity}/Upsert`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.putJSON(tmpURI, pRecord,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error Upserting record for [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.error(`Record upserted for [${this.Entity}].`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	upsertRecordToAddress(fCallback, pAddress, pRecord)
	{
		return this.upsertRecord(
			(pUpsertError, pRecords) =>
			{
				if (pUpsertError)
				{
					this.pict.log.error(`Error upserting record for [${this.Entity}] to address ${pAddress}: ${pUpsertError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pUpsertError, pRecords);
			}, pRecord);
	}


	// generateEmptyRecord(fCallback)
	// {
	// 	if (!this.HasInitialized)
	// 	{
	// 		this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
	// 		return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
	// 	}

	// 	let tmpAnticipate = this.pict.newAnticipate();

	// 	// Construct the URI
	// 	let tmpURI = `${this.Entity}/Schema/New`;

	// 	// Create a container object for the request (we may tack more onto this for other types of requests)
	// 	let tmpRequestResponse = {};

	// 	tmpAnticipate.anticipate(
	// 		(fRequestCallback) =>
	// 		{
	// 			return this.pict.HeadlightRestClient.getJSON(tmpURI,
	// 				(pError, pResponse) =>
	// 				{
	// 					tmpRequestResponse.Response = pResponse;
	// 					return fRequestCallback(pError);
	// 				});
	// 		});

	// 	tmpAnticipate.anticipate(
	// 		(fCleanupCallback) =>
	// 		{
	// 			if (typeof(tmpRequestResponse.Response) !== 'object')
	// 			{
	// 				this.pict.log.error(`Empty record prototype for [${this.Entity}] URI [${tmpURI}] is not an object.`);
	// 				return fCleanupCallback(`Empty record prototype for [${this.Entity}] URI [${tmpURI}] is not an object.`);
	// 			}
	// 			// Delete the Identifier columns if they are in the schema for the record, so this can be used as a clean prototype for a new record
	// 			if (`ID${this.Entity}` in tmpRequestResponse.Response)
	// 			{
	// 				delete tmpRequestResponse.Response[`ID${this.Entity}`];
	// 			}
	// 			if (`GUID${this.Entity}` in tmpRequestResponse.Response)
	// 			{
	// 				delete tmpRequestResponse.Response[`GUID${this.Entity}`];
	// 			}
	// 			return fCleanupCallback();
	// 		});

	// 	return tmpAnticipate.wait(
	// 		function(pError)
	// 		{
	// 			if (pError)
	// 			{
	// 				this.pict.log.error(`Error generating new record prototype for [${this.Entity}] URI [${tmpURI}]: ${pError}`);
	// 			}
	// 			else
	// 			{
	// 				this.pict.log.error(`Record prototype generated for [${this.Entity}].`);
	// 			}
	// 			return fCallback(pError, tmpRequestResponse.Response);
	// 		}
	// 	);
	// }
}

module.exports = EntityProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'InterimEntityProvider',
	});

},{"pict-provider":552}],1581:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/**
 * Show/Hide fields config example:
 * FieldDisplaySets:
 * {
 * 		"Default":
 * 		{
 * 			"Sample":
 * 			{
 * 				"Hide": ["IDLineItem", "Station", "Offset"],
 * 				"Show": ["Name", "QRCode", "IDMaterial"]
 * 			}
 * 		},
 * 		"List":
 * 		{
 * 			"Sample":
 * 			{
 * 				"Show": ["Name", "QRCode", "IDMaterial"]
 * 			}
 * 		},
 * 		"Edit":
 * 		{
 * 		},
 * 		"Create":
 * 		{
 * 		},
 * 		"Read":
 * 		{
 * 		},
 * }
 */

class FieldSettingsProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
        this.fieldNamespaces = {};
	}

	/**
	 * Registers a set of fields with a namespace.
	 * For each field, creates a settings object with default values.
	 * Currently the only settings field is "hide" but more can be added as needed.
	 * @param {String} name
	 * @param {Array<String>} fields
	 */
	registerNamespace(name, fields)
	{
		this.fieldNamespaces[name] = { };
		for (const f of fields)
		{
			this.fieldNamespaces[name][f] =
			{
				hide: false,
			};
		}
	}

	/**
	 * Registers a namespace using a schema to derive fields.
	 * @param {String} name
	 * @param {Object} schema
	 */
	registerNamespaceBySchema(name, schema)
	{
		this.registerNamespace(name, Object.keys(schema.properties));
	}

	/**
	 * Registers a namespace by looking up an entity name to pull the schema and generate the field list.
	 * @param {String} name - namespace being used for the field set.
	 * @param {String} entity - the entity we are getting the fields for.
	 * @param {String} [viewType] - the type of view (List/Edit/Read/Create). If not provided we will only use default config.
	 * @param {Boolean} [defaultToShow] - Should fields default to showing? I.e. do we use the "hide specific fields" config vs. the "only show these specific fields" config.
	 * @param {Array<string>} [defaultFields] - A default set of fields to show. Only applicable if defaultToShow is false.
	 */
	async registerNamespaceByEntity(name, entity, viewType, defaultToShow = true, defaultFields = [ 'Name' ])
	{
		try
		{
			const schema = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`${ entity }/Schema`, (error, result) =>
				{
					if (error)
					{
						reject(error);
					}
					else
					{
						resolve(result);
					}
				});
			});

			const config = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Configuration/For/FieldDisplaySets`, (error, result) =>
				{
					if (error)
					{
						reject(error);
					}
					else
					{
						resolve(result);
					}
				});
			});

			const fields = Object.keys(schema.properties);

			this.registerNamespace(name, fields);

			const configFields = defaultToShow ?
								(config?.[viewType || 'Default']?.[entity]?.['Hide'] || config?.['Default']?.[entity]?.['Hide'] || []) :
								(config?.[viewType || 'Default']?.[entity]?.['Show'] || config?.['Default']?.[entity]?.['Show'] || []);
			if (defaultToShow)
			{
				// If fields should default to shown, just hide the ones in the "Hide" config.
				this.hideFields(name, configFields);
			}
			else
			{
				// Otherwise, hide all the fields not in the "Show" config. If nothing is specified in the show config then default to only showing the name.
				if (!configFields.length)
				{
					this.hideFields(name, fields.filter((f) =>
					{
						return !defaultFields.includes(f);
					}));
				}
				else
				{
					this.hideFields(name, fields.filter((f) =>
					{
						return !configFields.includes(f);
					}));
				}
			}
		}
		catch (e)
		{
			this.pict.log.error(`Failed to get the field information for ${ entity }: `, e);
		}
	}

	/**
	 * Checks if a namespace has already been instantiated.
	 * @param {String} name
	 * @return {Boolean}
	 */
	checkNamespace(name)
	{
		return this.fieldNamespaces[name] ? true : false;
	}

	/**
	 * Sets the hide setting to true for the specified fields in the given namespace.
	 * @param {String} name
	 * @param {Array<String>} fields
	 */
	hideFields(name, fields)
	{
		this.fieldNamespaces[name] = this.fieldNamespaces[name] || {};
		for (const f of fields)
		{
			this.fieldNamespaces[name][f] = this.fieldNamespaces[name][f] || {};
			this.fieldNamespaces[name][f].hide = true;
		}
	}

	/**
	 * Sets the hide setting to false for the specified fields in the given namespace.
	 * @param {String} name
	 * @param {Array<String>} fields
	 */
	unhideFields(name, fields)
	{
		this.fieldNamespaces[name] = this.fieldNamespaces[name] || {};
		for (const f of fields)
		{
			this.fieldNamespaces[name][f] = this.fieldNamespaces[name][f] || {};
			this.fieldNamespaces[name][f].hide = false;
		}
	}

	/**
	 * Sets the hide setting to true for one field in the given namespace.
	 * @param {String} name
	 * @param {String} field
	 */
	hideField(name, field)
	{
		this.hideFields(name, [ field ]);
	}

	/**
	 * Sets the hide setting to false for one field in the given namespace.
	 * @param {String} name
	 * @param {String} field
	 */
	unhideField(name, field)
	{
		this.unhideFields(name, [ field ]);
	}

	/**
	 * Returns if a field within a namespace is hidden or not.
	 * @param {String} name
	 * @param {String} field
	 * @return {Boolean}
	 */
	isHidden(name, field)
	{
		return this.fieldNamespaces?.[name]?.[field]?.hide || false;
	}

	/**
	 * Returns the set of fields that are not hidden for a namespace.
	 * @param {String} name
	 * @return {Array<String>}
	 */
	getShownFields(name)
	{
		return this.fieldNamespaces?.[name] ?
			Object.keys(this.fieldNamespaces[name]).filter((field) =>
			{
				return !this.isHidden(name, field);
			}) : [];
	}

	/**
	 * Returns the set of fields that are hidden for a namespace.
	 * @param {String} name
	 * @return {Array<String>}
	 */
	getHiddenFields(name)
	{
		return this.fieldNamespaces?.[name] ?
			Object.keys(this.fieldNamespaces[name]).filter((field) =>
			{
				return this.isHidden(name, field);
			}) : [];
	}
}

module.exports = FieldSettingsProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1582:[function(require,module,exports){

class FileHandle
{
	/**
	 * @param {Object} pFileInfo - File metadata.
	 * @param {FileHandle} [pParent] - (optional) Parent file handle.
	 */
	constructor(pFileInfo, pParent)
	{
		this._FileInfo = pFileInfo || { };
		this._Parent = pParent || null;
	}

	get name()
	{
		return this._FileInfo.Name;
	}

	get type()
	{
		return this._FileInfo.Type;
	}

	get subType()
	{
		return this._FileInfo.SubType || '';
	}

	get path()
	{
		return this._FileInfo.Path;
	}

	get isFolder()
	{
		return this._FileInfo.IsFolder;
	}

	get index()
	{
		return this._FileInfo.Index || 0;
	}

	get parent()
	{
		return this._Parent;
	}

	get observation()
	{
		return this._FileInfo.Observation;
	}
}

module.exports = FileHandle;
module.exports.default_configuration = {};

},{}],1583:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/** @typedef {import('./FileHandle.js')} FileHandle */
/** @typedef {Symbol} NavClass */
/**
 * Enum for navigation classes.
 *
 * @readonly
 * @enum {NavClass}
 *
 * @property {NavClass} SIMPLE - non-navigable - ex. a single image
 * @property {NavClass} LINEAR - Linear navigation, ex. pages in a PDF or word document
 * @property {NavClass} UNKNOWN - unknown (or unsupported) file type
 */
const NavClass = Object.freeze(
	{
		SIMPLE: Symbol('simple'),
		LINEAR: Symbol('linear'),
		UNKNOWN: Symbol('unknown'),
	});

/**
 * Flow:
 *
 * 1. Navigate (ex. to a page)
 * 2. Extract (ex. a rectangle)
 * Result: a canvas with the rasterized subimage?
 */
class FileNavigatorProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON PUT request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON POST request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _post(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON DELETE request.
	 *
	 * @param {string} entityType - The entity type to delete.
	 * @param {number} entityID - The entity ID to delete.
	 * @return {Promise<any>} - The response.
	 */
	async _del(entityType, entityID)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.deleteEntity(entityType, entityID, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {FileHandle} pFileHandle
	 * @return {NavClass}
	 */
	getFileNavClass(pFileHandle)
	{
		if (pFileHandle.type === 'application/pdf')
		{
			return NavClass.LINEAR;
		}
		return NavClass.UNKNOWN;
	}

	/**
	 * @typedef {Object} FileHandleInfo
	 * @property {Array<FileHandle>} items
	 */

	/**
	 * @typedef {Object} NavParams
	 * TODO: define what this supports...
	 */

	/**
	 * Used to explore the file. List pages, preview them, etc.
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {Object} pNavParams
	 * @return {Promise<FileHandleInfo>}
	 */
	async navigateFile(pFileHandle, pNavParams)
	{
		const navClass = this.getFileNavClass(pFileHandle);
		if (navClass !== NavClass.LINEAR)
		{
			throw new Error(`Unsupported navigation class: ${navClass.toString()}`);
		}
		return await this._navigateFileLinear(pFileHandle, pNavParams);
	}

	/**
	 * Used to explore the file. List pages, preview them, etc. For linear navigation file types.
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {NavParams} pNavParams
	 * @return {Promise<FileHandleInfo>}
	 */
	async _navigateFileLinear(pFileHandle, pNavParams)
	{
		if (pFileHandle.type !== 'application/pdf')
		{
			throw new Error(`Unsupported file type: ${pFileHandle.type}`);
		}
		const nav =
		{
			items:
			[
			],
		};
		return nav;
	}

	/**
	 * Extract an item from a file.
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {Object} pExtractParams - Provide { canvas, scale, index }. Canvas will be resized to the desired dimensions. Scale is the zoom factor.
	 * NOTE: index in specific to linear navigation. will rev this doc eventually
	 * @return {Promise<string>} URL for the extracted item
	 */
	async extract(pFileHandle, pExtractParams)
	{
		if (pFileHandle.subType !== 'page')
		{
			throw new Error(`Unsupported file type for extract: ${pFileHandle.type}`);
		}
		const observationID = pFileHandle.observation?.IDObservation;
		if (!observationID)
		{
			throw new Error('No observation ID for source file');
		}
		const extractParamsString = Object.entries(pExtractParams).map(([ key, value ]) => `${key}:${encodeURIComponent(value)}`).join(';');
		return `Observation/${observationID}/Extract/${encodeURIComponent(extractParamsString)}`;
	}

	/**
	 * Extract items from a file. Useful for doing a page preview
	 *
	 * @param {FileHandle} pFileHandle
	 * @param {Object} pExtractParams - Provide { items, scale }. Canvas will be resized to the desired dimensions. Scale is the zoom factor.
	 * @return {Promise<Array<string>>}
	 */
	async bulkExtract(pFileHandle, pExtractParams)
	{
		const result = [];
		for (const item of pExtractParams.items)
		{
			//FIXME: probably too slow like this...
			//FIXME: this assumes each page has the same paramemeters...
			result.push(await this.extract(item, pExtractParams));
		}
		return result;
	}

	/**
	 * Extract a subimage from a file and clone it to a new image observation.
	 *
	 * @param {FileHandle} pFileHandle The source observation.
	 * @param {Object} pExtractParams The extract parameters: { Page: number, Bounds: { } } (bounds from openseadragon)
	 */
	async cloneExtract(pFileHandle, pExtractParams)
	{
		if (pFileHandle.subType !== 'page')
		{
			throw new Error(`Unsupported file type for extract: ${pFileHandle.type}`);
		}
		const observationID = pFileHandle.observation?.IDObservation;
		if (!observationID)
		{
			throw new Error('No observation ID for source file');
		}
		await this._post(`Observation/${observationID}/Extract/Clone`, pExtractParams);
	}
}

module.exports = FileNavigatorProvider;
module.exports.NavClass = NavClass;
module.exports.default_configuration = {};

},{"headlight-rest-client":20,"pict-provider":552}],1584:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

/**
 * Provider for looking up Form-Conversion ManifestSchemas associated with a
 * ReportNamedInstance via the ReportNamedInstanceManifestSchemaJoin table.
 *
 * @class FormConversionProvider
 * @extends PictProvider
 */
class FormConversionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/**
		 * Cached Form-Conversion schemas keyed by IDReportNamedInstance.
		 * @type {Object.<number, Array>}
		 */
		this._SchemaCache = {};
	}

	/**
	 * Get Form-Conversion ManifestSchemas for a ReportNamedInstance.
	 *
	 * 1. Queries ReportNamedInstanceManifestSchemaJoins filtered by IDReportNamedInstance
	 * 2. Collects IDManifestSchema values from the join records
	 * 3. Batch-fetches ManifestSchemas with FBL~IDManifestSchema~INN~{ids}~FBV~Type~EQ~Form-Conversion
	 *
	 * @param {number} pIDReportNamedInstance
	 * @returns {Promise<Array>} Array of ManifestSchema records with Type = 'Form-Conversion'
	 */
	async getFormConversionSchemas(pIDReportNamedInstance)
	{
		if (!pIDReportNamedInstance)
		{
			return [];
		}

		// Check cache first
		if (this._SchemaCache[pIDReportNamedInstance])
		{
			return this._SchemaCache[pIDReportNamedInstance];
		}

		// Step 1: Get join records
		const tmpJoinRecords = await new Promise((pResolve, pReject) =>
		{
			this.fable.HeadlightRestClient.getJSON(
				`ReportNamedInstanceManifestSchemaJoins/FilteredTo/FBV~IDReportNamedInstance~EQ~${pIDReportNamedInstance}/0/100`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.error('Error fetching ReportNamedInstanceManifestSchemaJoins:', pError);
						return pReject(pError);
					}
					return pResolve(pBody || []);
				});
		});

		if (!tmpJoinRecords.length)
		{
			this._SchemaCache[pIDReportNamedInstance] = [];
			return [];
		}

		// Step 2: Collect ManifestSchema IDs
		const tmpManifestSchemaIDs = tmpJoinRecords
			.map((pJoin) => pJoin.IDManifestSchema)
			.filter((pID) => pID && pID > 0);

		if (!tmpManifestSchemaIDs.length)
		{
			this._SchemaCache[pIDReportNamedInstance] = [];
			return [];
		}

		// Step 3: Batch-fetch ManifestSchemas filtered to Form-Conversion type
		const tmpIDList = tmpManifestSchemaIDs.join(',');
		const tmpSchemas = await new Promise((pResolve, pReject) =>
		{
			this.fable.HeadlightRestClient.getJSON(
				`ManifestSchemas/FilteredTo/FBL~IDManifestSchema~INN~${tmpIDList}~FBV~Type~EQ~Form-Conversion/0/100`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.error('Error fetching ManifestSchemas for Form-Conversion:', pError);
						return pReject(pError);
					}
					return pResolve(pBody || []);
				});
		});

		// Enrich schemas with file type info from their template Artifacts
		const tmpArtifactIDs = tmpSchemas
			.map((pSchema) => pSchema.IDArtifact)
			.filter((pID) => pID && pID > 0);

		if (tmpArtifactIDs.length > 0)
		{
			const tmpArtifactIDList = [...new Set(tmpArtifactIDs)].join(',');
			const tmpArtifacts = await new Promise((pResolve, pReject) =>
			{
				this.fable.HeadlightRestClient.getJSON(
					`Artifacts/FilteredTo/FBL~IDArtifact~INN~${tmpArtifactIDList}/0/100`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.log.warn('Error fetching Artifacts for Form-Conversion schemas:', pError);
							return pResolve([]);
						}
						return pResolve(pBody || []);
					});
			});

			// Build a lookup map by IDArtifact
			const tmpArtifactMap = {};
			for (const tmpArtifact of tmpArtifacts)
			{
				tmpArtifactMap[tmpArtifact.IDArtifact] = tmpArtifact;
			}

			// Resolve file type for each schema from its Artifact
			for (const tmpSchema of tmpSchemas)
			{
				const tmpArtifact = tmpArtifactMap[tmpSchema.IDArtifact];
				if (tmpArtifact)
				{
					let tmpDatum = tmpArtifact.Datum;
					if (typeof tmpDatum === 'string')
					{
						try { tmpDatum = JSON.parse(tmpDatum); }
						catch (pErr) { tmpDatum = {}; }
					}

					// Resolve mime type from Datum.FileMimeType, with fallback to FileName extension
					let tmpMimeType = tmpDatum?.FileMimeType || '';
					if (!tmpMimeType && tmpDatum?.FileName)
					{
						const tmpExtMatch = tmpDatum.FileName.match(/\.([^.]+)$/);
						const tmpExt = tmpExtMatch ? tmpExtMatch[1].toLowerCase() : '';
						if (tmpExt === 'pdf') { tmpMimeType = 'application/pdf'; }
						else if (tmpExt === 'xlsx') { tmpMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; }
						else if (tmpExt === 'xls') { tmpMimeType = 'application/vnd.ms-excel'; }
					}

					tmpSchema.TemplateMimeType = tmpMimeType;
				}
			}
		}

		this._SchemaCache[pIDReportNamedInstance] = tmpSchemas;
		return tmpSchemas;
	}

	/**
	 * Resolve the IDReportNamedInstance from a DocumentType hash and IDProject,
	 * then load associated Form-Conversion schemas.
	 *
	 * Uses the ReportNamedInstancesByProject endpoint to find the matching RNI,
	 * then delegates to getFormConversionSchemas().
	 *
	 * @param {string} pDocumentType - The DocumentType hash (e.g. 'MI-CAG-Walbec')
	 * @param {number} pIDProject - The project ID (from ReportData.IDProject)
	 * @returns {Promise<Array>} Array of ManifestSchema records with Title for display
	 */
	async getFormConversionSchemasForDocument(pDocumentType, pIDProject)
	{
		if (!pDocumentType || !pIDProject)
		{
			return [];
		}

		// Look up RNIs for this project
		const tmpRNIs = await new Promise((pResolve, pReject) =>
		{
			this.fable.HeadlightRestClient.getJSON(
				`ReportNamedInstancesByProject/${pIDProject}/0/250`,
				(pError, pBody) =>
				{
					if (pError)
					{
						this.log.error('Error fetching ReportNamedInstances for project:', pError);
						return pReject(pError);
					}
					return pResolve(pBody || []);
				});
		});

		// Find the RNI matching the document type hash
		const tmpMatchingRNI = tmpRNIs.find((pRNI) => pRNI.Hash === pDocumentType);
		if (!tmpMatchingRNI)
		{
			this.log.warn(`No ReportNamedInstance found with Hash '${pDocumentType}' for project ${pIDProject}`);
			return [];
		}

		return this.getFormConversionSchemas(tmpMatchingRNI.IDReportNamedInstance);
	}
}

module.exports = FormConversionProvider;

},{"pict-provider":552}],1585:[function(require,module,exports){
const PictProvider = require('pict-provider');

const DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'FormInitialBundle-Provider',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

class FormInitialBundleProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, DEFAULT_PROVIDER_CONFIGURATION, pOptions), pServiceHash);

		/** @type {import('headlight-configurable-application').Pict} */
		this.pict;
	}

	/**
	 * Whether a bundle has a ProjectDataset step.
	 *
	 * @param {Array<Record<string, any>>} pBundle - The entity bundle description.
	 * @return {boolean}
	 */
	hasProjectDatasetStep(pBundle)
	{
		return Array.isArray(pBundle) && pBundle.some((pStep) => pStep && (pStep.Type === 'ProjectDataset'));
	}

	/**
	 * Remove the output of every ProjectDataset step in a bundle, so the next gather builds it fresh.
	 * pict's projectDataset only creates its output when missing and otherwise appends to it or updates it in place.
	 *
	 * @param {Array<Record<string, any>>} pBundle - The entity bundle description.
	 * @return {Array<{ Address: string, Value: any }>} The removed outputs, for restoreProjectDatasetOutputs.
	 */
	clearProjectDatasetOutputs(pBundle)
	{
		const tmpCleared = [];
		if (!Array.isArray(pBundle))
		{
			return tmpCleared;
		}
		const tmpAddressSpace = this.pict.EntityProvider.prepareState({});
		for (const tmpStep of pBundle)
		{
			if (tmpStep && (tmpStep.Type === 'ProjectDataset') && (typeof tmpStep.OutputRecordsetAddress === 'string') && (tmpStep.OutputRecordsetAddress.length > 0))
			{
				tmpCleared.push({ Address: tmpStep.OutputRecordsetAddress, Value: this.pict.manifest.getValueByHash(tmpAddressSpace, tmpStep.OutputRecordsetAddress) });
				this.pict.manifest.deleteValueByHash(tmpAddressSpace, tmpStep.OutputRecordsetAddress);
			}
		}
		return tmpCleared;
	}

	/**
	 * Put back the outputs clearProjectDatasetOutputs removed.
	 *
	 * @param {Array<{ Address: string, Value: any }>} pCleared - The return value of clearProjectDatasetOutputs.
	 * @return {void}
	 */
	restoreProjectDatasetOutputs(pCleared)
	{
		const tmpAddressSpace = this.pict.EntityProvider.prepareState({});
		for (const tmpEntry of pCleared)
		{
			if (typeof tmpEntry.Value !== 'undefined')
			{
				this.pict.manifest.setValueByHash(tmpAddressSpace, tmpEntry.Address, tmpEntry.Value);
			}
		}
	}

	/**
	 * Rebuild every pick list a form manifest declares.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest.
	 * @return {void}
	 */
	rebuildPickLists(pManifest)
	{
		for (const tmpPickList of (pManifest && pManifest.PickLists) || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(tmpPickList.Hash);
		}
	}

	/**
	 * Gather a form manifest's InitialBundle, replacing any ProjectDataset output from an earlier gather, then
	 * rebuild the manifest's pick lists. When the gather fails, the earlier ProjectDataset outputs are put back and
	 * the lists are still rebuilt.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest.
	 * @param {Function} fCallback - Called with the gather error, if any.
	 * @return {void}
	 */
	gatherInitialBundle(pManifest, fCallback)
	{
		const tmpBundle = pManifest ? pManifest.InitialBundle : undefined;
		const tmpCleared = this.clearProjectDatasetOutputs(tmpBundle);
		this.pict.EntityProvider.gatherDataFromServer(tmpBundle, (pError) =>
		{
			if (pError)
			{
				this.restoreProjectDatasetOutputs(tmpCleared);
			}
			this.rebuildPickLists(pManifest);
			return fCallback(pError);
		});
	}
}

module.exports = FormInitialBundleProvider;
module.exports.default_configuration = DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":552}],1586:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libScanGeolocation = require('headlight-qrcode-web/source/scanning/Scan-Geolocation.js');

class GeoProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Function to get user's geocoordinates from the browser. Returns null if it cannot get them.
	 * @param {Object} [pOptions]
	 * @param {boolean} [pOptions.NoPrompt] - Read the browser position only when permission is already granted; never ask.
	 * @return {Promise<Object|null>}
	 */
	async getGeoCoords(pOptions)
	{
		// Attempt to fetch a location from the native app.
		try
		{
			const coords = await this.fable.NativeBridge.getLocation();
			return {
				CaptureLatitude: coords.Latitude,
				CaptureLongitude: coords.Longitude,
				Latitude: coords.Latitude,
				Longitude: coords.Longitude,
			};
		}
		catch (error)
		{
			console.log('No native location method available: ', error);
		}

		// Check for a passed location from the native app if available.
		if (typeof window.Mixins?.deviceGeolocation === 'object')
		{
			return {
				CaptureLatitude: window.Mixins.deviceGeolocation.Latitude || window.Mixins.deviceGeolocation.latitude,
				CaptureLongitude: window.Mixins.deviceGeolocation.Longitude || window.Mixins.deviceGeolocation.longitude,
				Latitude: window.Mixins.deviceGeolocation.Latitude || window.Mixins.deviceGeolocation.latitude,
				Longitude: window.Mixins.deviceGeolocation.Longitude || window.Mixins.deviceGeolocation.longitude,
			};
		}

		if (pOptions?.NoPrompt)
		{
			const tmpPosition = await libScanGeolocation.getPositionIfPermitted();
			return tmpPosition ? { CaptureLatitude: tmpPosition.Latitude, CaptureLongitude: tmpPosition.Longitude, Latitude: tmpPosition.Latitude, Longitude: tmpPosition.Longitude } : null;
		}

		return await new Promise((resolve, reject) =>
		{
			window.navigator.geolocation.getCurrentPosition(
				(position) =>
				{
					resolve({
						CaptureLatitude: position.coords.latitude,
						CaptureLongitude: position.coords.longitude,
						Latitude: position.coords.latitude,
						Longitude: position.coords.longitude,
					});
				},
				() =>
				{
					this.pict.log.info('Couldn\'t get geolocation, returning null...');
					resolve(null);
				},
				{
					maximumAge: 12*60*60*1000,
				},
			);
		});
	}
}

module.exports = GeoProvider;
module.exports.default_configuration = {};

},{"headlight-qrcode-web/source/scanning/Scan-Geolocation.js":283,"pict-provider":552}],1587:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

const FileHandle = require('./FileHandle.js');

class ImportantFilesProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {string|number} pIDProject - The project ID.
	 * @param {string} pPath - The path to the directory to list.
	 * @return {Promise<FileHandle[]>}
	 */
	async listFiles(pIDProject, pPath = '/')
	{
		const files = await this._get(`ImportantProjectFiles/${pIDProject}${pPath}`);
		const result = [];
		for (const folder of files.Folders)
		{
			result.push(new FileHandle({ Name: folder.Name, IsFolder: true, Path: `${pPath}/${folder.Name}` }));
		}
		for (const file of files.Files)
		{
			//TODO: populate the file type, etc. - can we tell from the observation? maybe the artifact datum?
			//FIXME: populate `Parent` when we start populating that as part of the artifact extraction adventure
			//       probably create a factory or something so we can centralize building this for file handles
			result.push(new FileHandle({ Name: file.Name, Path: `${pPath}/${file.Name}`, IsFolder: false, Observation: file.Observation }));
		}
		return result;
	}

	/**
	 * @param {FileHandle} pFileHandle - The file to get the URL for.
	 * @return {string} - The URI.
	 */
	getDownloadURI(pFileHandle)
	{
		if (!pFileHandle.observation)
		{
			throw new Error(`Cannot provide a URL for a file that isn't an observation.`);
		}
		return `/1.0/ImportantProjectFile/${pFileHandle.observation.IDProject}/${pFileHandle.path}`;
	}
}

module.exports = ImportantFilesProvider;
module.exports.default_configuration = {};

},{"./FileHandle.js":1582,"headlight-rest-client":20,"pict-provider":552}],1588:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ImprovedTabularRecordSetProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.options = pOptions;
		this.renderOverriden = false;
	}

	prepareTable()
	{
		const activeRecordSet = this.pict.providers?.RecordSetRouter?.pictRouter?.router?.current?.[0]?.data?.RecordSet || '';
		const isDocumentRecord = activeRecordSet === 'Document';
		// override table display logic
		if (!this.renderOverriden)
		{
			const beforeRenderStubList = this.pict.views['PRSP-List-RecordList'].onBeforeRender.bind(this.pict.views['PRSP-List-RecordList']); ;
			this.pict.views['PRSP-List-RecordList'].onBeforeRender =
			function(callback, renderable)
			{
				this.pict.providers.ImprovedTabularRecordSetProvider.prepareTable();
				beforeRenderStubList(callback, renderable);
			};
			const beforeRenderStubDashboard = this.pict.views['PRSP-Dashboard-RecordList'].onBeforeRender.bind(this.pict.views['PRSP-Dashboard-RecordList']); ;
			this.pict.views['PRSP-Dashboard-RecordList'].onBeforeRender =
			function(callback, renderable)
			{
				this.pict.providers.ImprovedTabularRecordSetProvider.prepareTable();
				beforeRenderStubDashboard(callback, renderable);
			};
			// Permission-expression layer (Phase 2b): gate the record read-view Edit/Save buttons by
			// can(entity,'Update'). The read view shows the Edit button via getElementById after render
			// (RecordSet-Read.js), so removing it from the DOM would null-crash those calls — instead a body
			// class + !important CSS (below) hides it while it stays in the DOM. renderRead is the definitive
			// per-record-page method; wrapping it sets the body class from the active route each time.
			const tmpReadView = this.pict.views['RSP-RecordSet-Read'];
			if (tmpReadView && typeof tmpReadView.renderRead === 'function' && !tmpReadView._pcfgEditGateInstalled)
			{
				const tmpOriginalRenderRead = tmpReadView.renderRead.bind(tmpReadView);
				tmpReadView.renderRead = async function(...pRenderArgs)
				{
					const tmpRenderResult = await tmpOriginalRenderRead(...pRenderArgs);
					try { _Pict.providers.ImprovedTabularRecordSetProvider.applyReadEditGate(); }
					catch (pGateError) { /* non-fatal: gating is a UI hint, the server stays authoritative */ }
					return tmpRenderResult;
				};
				tmpReadView._pcfgEditGateInstalled = true;
			}
			this.renderOverriden = true;
			if (this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
			{
				// Neutral list "New" button (see PRSP-List-Title-Template below); brand-coloured on hover/focus.
				this.pict.CSSMap.addCSS('ImprovedTabularRecordSet-ListNew-CSS', /*css*/`
					.button.prsp-list-new { background: transparent; border-color: var(--theme-color-border-default, #d7dce3); color: var(--theme-color-text-muted, #6b7686); transition: color 0.12s ease, border-color 0.12s ease; }
					.button.prsp-list-new:hover, .button.prsp-list-new:focus { background: transparent; border-color: var(--theme-color-brand-primary, #156dd1); color: var(--theme-color-brand-primary, #156dd1); box-shadow: none; }
					.hl-view-description { margin: 0.25rem 0 0.75rem; color: var(--theme-color-text-muted, #6b7686); font-size: 0.875rem; }
					.hl-view-description:empty { display: none; }
					th.prsp-sortable-header { cursor: pointer; user-select: none; white-space: nowrap; }
					th.prsp-sortable-header:hover { color: var(--theme-color-brand-primary, #156dd1); }
					th.prsp-sortable-header .prsp-sort-indicator { margin-left: 0.25em; }
					/* Permission-expression layer: hide the record Edit/Save buttons when the current user can't update the active entity. */
					body.pcfg-cannot-update-record #PRSP-Read-EditButton, body.pcfg-cannot-update-record #PRSP-Read-SaveButton { display: none !important; }
				`, 500);
				this.pict.CSSMap.injectCSS();
			}
		}
		if (this.options?.overrideURLTemplate)
		{
			this.pict.TemplateProvider.addTemplate('PRSP-Read-Link-URL-Template', this.options.overrideURLTemplate);
		}
		// List "New" action. createFromActiveList() reads the live #/PSRS/<RecordSet>/List hash at CLICK time and
		// routes to that record-set's Create form, so it is always correct regardless of render/route ordering
		// (baking the record-set into the template at registration time races with the title render). Rendered
		// here, not via an app-level override, so it survives prepareTable()'s per-render re-registration.
		// Neutral .prsp-list-new style, brand-coloured on hover.
		// Permission-expression layer (Phase 2): the "New" button renders only where the current user can
		// create the entity. Gated by a template tag on the record set's OWN config flag
		// (RecordSetListShowCreateButton, stamped per can(entity,'Create') at login) — not a JS-time check on
		// the active route, which the title can out-race (the same reason createFromActiveList reads the hash
		// at click time). Record.RecordSetConfiguration is always the correct entity's config at title render.
		this.pict.TemplateProvider.addTemplate('HLPC-List-New-Button', /*html*/`<div class="column is-narrow"><button class="button is-small prsp-list-new" title="Create a new record" onclick="_Pict.providers.ImprovedTabularRecordSetProvider.createFromActiveList()"><span class="icon is-small"><i class="fas fa-plus"></i></span><span>New</span></button></div>`);
		const tmpNewButton = `{~TIfAbs:HLPC-List-New-Button:Record:Record.RecordSetConfiguration.RecordSetListShowCreateButton^TRUE^~}`;
		this.pict.TemplateProvider.addTemplate('PRSP-List-Title-Template', /*html*/`
			<!--START ImprovedTabularRecordSet Custom: [PRSP-List-Title-Template] -->
				<header id="PRSP_Title_Container" class="columns is-mobile is-vcentered">
					<div class="column"><h2 class="title is-size-4 mb-0" id="PRSP_Title">{~D:Record.Title~}</h2></div>
					${ this.options?.endCapTemplate || '' }
					<div class="is-hidden-mobile column is-narrow pt-3 has-text-text is-size-7 has-text-right">{~T:PRSP-List-Pagination-Template-Description~}</div>
					${ tmpNewButton }
				</header>
				<div class="is-hidden-desktop is-hidden-tablet pb-2 has-text-text is-size-7 has-text-centered">{~T:PRSP-List-Pagination-Template-Description~}</div>
				<p class="hl-view-description">{~D:Record.RecordSetConfiguration.RecordSetHeaderDescription~}</p>
			<!--  END ImprovedTabularRecordSet Custom: [PRSP-List-Title-Template] -->
		`);

		// Trim the verbose "… total records." tail from the shared pagination description (used by the title bar
		// and the top/bottom pagination). Keeps the live-updated count spans the pagination logic writes to.
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Description', /*html*/`
			<div>
				Showing
				<span id="PRSP_Pagination_Description_Records_Start">{~D:Record.PageStart~}</span> to
				<span id="PRSP_Pagination_Description_Records_End">{~D:Record.PageEnd~}</span> of
				<span id="PRSP_Pagination_Description_Records_Total">{~D:Record.TotalRecordCount.Count~}</span>
			</div>
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordList-Template-Table', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-Table] -->
			<div class="table-container">
				<table id="PRSP_List_Table" class="table is-striped is-hoverable is-fullwidth is-bordered">
					<thead>{~T:PRSP-List-RecordListHeader-Template~}</thead>
					<tbody id="PRSP_RecordList_Container_Entries">
						{~T:PRSP-List-RecordListEntry-Template~}
						{~T:PRSP-List-RecordList-Template-EmptyTable~}
					</tbody>
				</table>
			</div>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-Table] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordList-Template-EmptyTable', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-EmptyTable] -->
			<tr id="PRSP_List_Table_Empty">
				<td colspan="100%" class="has-text-centered has-text-text-50">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">No records found.</span>
				</td>
			</tr>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-RecordList-Template-EmptyTable] -->
		`);
		// Row "Print" action (QR label, or the file for a Document row). On for every list when the provider is
		// registered with includePrint: true; otherwise per record set, through the RecordSetListShowPrintButton
		// flag on the record set's own config (LIMS turns it on for Sample and Location). TIfAbs TRUE is a strict
		// `=== true` test, so the flag must be a real boolean.
		this.pict.TemplateProvider.addTemplate('HLPC-List-Print-Button', /*html*/`
						<li>
							<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault();
									if (window.location.href.includes('Document/List'))
									{
										_Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.Data.IDDocument~});
									}
									else
									{
										_Pict.providers.QRCodeProvider.printDecoratedEntity('{~D:Record.Payload.RecordSetConfiguration.Entity~}', '{~D:Record.Data.QRCode~}');
									}">
								<span class="icon">
									<i class="fas fa-print"></i>
								</span>
								<span class="icon-text">Print</span>
							</a>
						</li>`);
		this.pict.TemplateProvider.addTemplate('HLPC-List-Print-Button-Gate', this.options.includePrint
			? `{~T:HLPC-List-Print-Button~}`
			: `{~TIfAbs:HLPC-List-Print-Button:Record:Record.Payload.RecordSetConfiguration.RecordSetListShowPrintButton^TRUE^~}`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListAction-Template-Cell', this.options.disableActions ? '' : /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordListAction-Template-Cell'] -->
			<td class="has-text-centered prsp-row-actions">
				<ul class="buttons has-addons is-centered">
					{~T:HLPC-List-Print-Button-Gate~}
					{~TSWP:PRSP-List-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
					${ isDocumentRecord ? /*html*/`<li>
						<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.Data.IDDocument~});" title="{~TBR:Record.Name~}">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span class="icon-text">Edit</span>
						</a>
					</li>` : ''}
				</ul>
			</td>
			<!-- END ImprovedTabularRecordSet Custom:   [PRSP-List-RecordListAction-Template-Cell] -->`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListAction-Template-Cell-Datum', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-RecordListAction-Template-Cell-Datum] -->
			<li>
				<a class="button is-ghost" {~NE:Record.Data.Default^data-prsp-default="1"~} href="{~TBR:Record.Data.URL~}" title="{~TBR:Record.Data.Name~}">
					<span class="icon">
						<i class="fas fa-search"></i>
					</span>
					<span class="icon-text">View</span>
				</a>
			</li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-RecordListAction-Template-Cell-Datum] -->
		`);
		// Keep pict-section-recordset's per-column dispatch so record sets that opt into RecordSetListSortable get clickable headers.
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListHeader-Template-Header', /*html*/`{~TS:PRSP-List-RecordListHeader-Header-Sortable:Record.SortableSlot~}{~TS:PRSP-List-RecordListHeader-Header-Plain:Record.PlainSlot~}`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListHeader-Header-Plain', /*html*/`<th>{~D:Record.DisplayName~}</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListHeader-Header-Sortable', /*html*/`<th class="prsp-sortable-header" title="Sort by {~D:Record.DisplayName~}" onclick="_Pict.views['RSP-RecordSet-List'].sortByColumn('{~D:Record.RecordSet~}', '{~D:Record.Key~}')">{~D:Record.DisplayName~}<span class="icon is-small prsp-sort-indicator">{~TS:PRSP-List-RecordListHeader-Header-SortAscending:Record.AscendingSlot~}{~TS:PRSP-List-RecordListHeader-Header-SortDescending:Record.DescendingSlot~}</span></th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListHeader-Header-SortAscending', /*html*/`<i class="fas fa-sort-up"></i>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListHeader-Header-SortDescending', /*html*/`<i class="fas fa-sort-down"></i>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-RecordListActions-Template-Header', this.options.disableActions ? '' : /*html*/`<th class="has-text-centered">Actions</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Button-Previous',
			`<a class="pagination-previous" href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">Previous</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Button-Next',
			`<a class="pagination-next" href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-PaginationTop-Template', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-PaginationTop-Template] -->
			<nav class="pagination is-small my-3 is-rounded" id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
				{~TIfAbs:PRSP-List-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
				{~TIfAbs:PRSP-List-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
				<ul class="pagination-list">{~TS:PRSP-List-Pagination-Template-Pages:Record.PageLinksLimited~}</ul>
			</nav>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-PaginationTop-Template] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-Pagination-Template-Pages', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-List-Pagination-Template-Pages] -->
			<li><a class="pagination-link page-offset_{~D:Record.RelativeOffset~} {~TIfAbs:PaginationActiveClass:Record:Record.RelativeOffset^==^0~}" href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-List-Pagination-Template-Pages] -->
		`);
		this.pict.TemplateProvider.addTemplate('PaginationActiveClass', /*html*/`is-current`);
		this.pict.TemplateProvider.addTemplate('PRSP-List-PaginationBottom-Template', `{~T:PRSP-List-PaginationTop-Template~}`);
		this.pict.TemplateProvider.addTemplate('PRSP-SUBSET-Filters-Template-Button-Fieldset', /*html*/`<!-- intentionally blank -->`);

		// Dashboard templates
		if (this.options?.overrideDashboardURLTemplate)
		{
			this.pict.TemplateProvider.addTemplate('PRSP-Read-Dashboard-URL-Template', this.options.overrideURLTemplate);
		}
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Title-Template', /*html*/`
			<!--START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Title-Template] -->
				<header id="PRSP_Title_Container" class="columns is-mobile is-vcentered">
					<div class="column"><h2 class="title is-size-4 mb-0" id="PRSP_Title">{~D:Record.Title~}</h2></div>
					${ this.options?.endCapTemplate || '' }
					<div class="is-hidden-mobile column pt-3 has-text-text is-size-7 has-text-right">{~T:PRSP-Dashboard-Pagination-Template-Description~}</div>
				</header>
				<div class="is-hidden-desktop is-hidden-tablet pb-2 has-text-text is-size-7 has-text-centered">{~T:PRSP-Dashboard-Pagination-Template-Description~}</div>
				<p class="hl-view-description">{~D:Record.RecordSetConfiguration.RecordSetHeaderDescription~}</p>
			<!--  END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Title-Template] -->
		`);

		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordList-Template-Table', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-Table] -->
			<div class="table-container">
				<table id="PRSP_List_Table" class="table is-striped is-hoverable is-fullwidth is-bordered">
					<thead>{~T:PRSP-Dashboard-RecordListHeader-Template~}</thead>
					<tbody id="PRSP_RecordList_Container_Entries">
						{~T:PRSP-Dashboard-RecordListEntry-Template~}
						{~T:PRSP-Dashboard-RecordList-Template-EmptyTable~}
					</tbody>
				</table>
			</div>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-Table] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordList-Template-EmptyTable', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-EmptyTable] -->
			<tr id="PRSP_List_Table_Empty">
				<td colspan="100%" class="has-text-centered has-text-text-50">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">No records found.</span>
				</td>
			</tr>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordList-Template-EmptyTable] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListEntry-Template-Row-Cell', /*html*/`<td>{~TBDA:Record.Data.PictDashboard.ValueTemplate~}</td>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListAction-Template-Cell', this.options.disableActions ? '' : /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordListAction-Template-Cell'] -->
			<td class="has-text-centered">
				<ul class="buttons has-addons is-centered">
					{~T:HLPC-List-Print-Button-Gate~}
					{~TSWP:PRSP-Dashboard-RecordListAction-Template-Cell-Datum:Pict.providers.RecordSetLinkManager.linkTemplates:Record~}
					${ isDocumentRecord ? /*html*/`<li>
						<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.Data.IDDocument~});" title="{~TBR:Record.Name~}">
							<span class="icon">
								<i class="fas fa-pencil"></i>
							</span>
							<span class="icon-text">Edit</span>
						</a>
					</li>` : ''}
				</ul>
			</td>
			<!-- END ImprovedTabularRecordSet Custom:   [PRSP-Dashboard-RecordListAction-Template-Cell] -->`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListAction-Template-Cell-Datum', this.options.disableActions ? '' : /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordListAction-Template-Cell-Datum] -->
			<li>
				<a class="button is-ghost" href="{~TBR:Record.Data.URL~}" title="{~TBR:Record.Data.Name~}">
					<span class="icon">
						<i class="fas fa-search"></i>
					</span>
					<span class="icon-text">View</span>
				</a>
			</li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-RecordListAction-Template-Cell-Datum] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListHeader-Template-Header', /*html*/`<th>{~D:Record.DisplayName~}</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-RecordListActions-Template-Header', this.options.disableActions ? '' : /*html*/`<th class="has-text-centered">Actions</th>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Pagination-Template-Button-Previous',
			`<a class="pagination-previous" href="{~D:Record.PageLinkBookmarks.PreviousLink.URL~}" aria-label="Previous page">Previous</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Pagination-Template-Button-Next',
			`<a class="pagination-next" href="{~D:Record.PageLinkBookmarks.NextLink.URL~}" aria-label="Next page">Next</a>`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-PaginationTop-Template', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-PaginationTop-Template] -->
			<nav class="pagination is-small my-3 is-rounded" id="RSP_Upper_Pagination_Container" role="navigation" aria-label="pagination">
				{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Previous:Record:Record.PageLinkBookmarks.ShowPreviousLink^TRUE^true~}
				{~TIfAbs:PRSP-Dashboard-Pagination-Template-Button-Next:Record:Record.PageLinkBookmarks.ShowNextLink^TRUE^true~}
				<ul class="pagination-list">{~TS:PRSP-Dashboard-Pagination-Template-Pages:Record.PageLinksLimited~}</ul>
			</nav>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-PaginationTop-Template] -->
		`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-Pagination-Template-Pages', /*html*/`
			<!-- START ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Pagination-Template-Pages] -->
			<li><a class="pagination-link page-offset_{~D:Record.RelativeOffset~} {~TIfAbs:PaginationActiveClass:Record:Record.RelativeOffset^==^0~}" href="{~D:Record.URL~}" aria-label="Go to page {~D:Record.Page~}">{~D:Record.Page~}</a></li>
			<!-- END ImprovedTabularRecordSet Custom: [PRSP-Dashboard-Pagination-Template-Pages] -->
		`);
		this.pict.TemplateProvider.addTemplate('PaginationActiveClass', /*html*/`is-current`);
		this.pict.TemplateProvider.addTemplate('PRSP-Dashboard-PaginationBottom-Template', `{~T:PRSP-Dashboard-PaginationTop-Template~}`);
		this.pict.TemplateProvider.addTemplate('PRSP-SUBSET-Filters-Template-Button-Fieldset', /*html*/`<!-- intentionally blank -->`);
	}

	/**
	 * The list title-bar "New" button handler. Resolves the active record-set from the current
	 * #/PSRS/<RecordSet>/List hash at click time (race-free) and routes to its Create form. One handler
	 * serves every record-set list in every app that mounts this provider.
	 */
	createFromActiveList()
	{
		const tmpHash = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
		const tmpMatch = tmpHash.match(/\/PSRS\/([^/?#]+)/);
		if (tmpMatch && tmpMatch[1])
		{
			window.location.hash = `#/PSRS/${tmpMatch[1]}/Create`;
		}
	}

	/**
	 * Permission-expression layer (Phase 2b): after a record read page renders, toggle a body class that
	 * hides the Edit/Save buttons (via CSS) when the current user can't update the active entity. The entity
	 * is read from the live #/PSRS/<Entity>/(View|Edit|Read) hash, so it is always the record on screen.
	 * Fail-open (no service / no entity / not-yet-loaded → editable); the server stays authoritative.
	 */
	applyReadEditGate()
	{
		if (typeof document === 'undefined' || !document.body)
		{
			return;
		}
		let tmpEntity = '';
		const tmpHash = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
		const tmpMatch = /#?\/PSRS\/([A-Za-z0-9_]+)\/(View|Edit|Read)/.exec(tmpHash);
		if (tmpMatch)
		{
			tmpEntity = tmpMatch[1];
		}
		const tmpPermissions = this.pict.fable.EffectivePermissionsService;
		const tmpCanUpdate = (!tmpPermissions || !tmpEntity) ? true : tmpPermissions.can(tmpEntity, 'Update');
		document.body.classList.toggle('pcfg-cannot-update-record', !tmpCanUpdate);
	}
}

module.exports = ImprovedTabularRecordSetProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1589:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class InspectionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	async getInspectionFromDocumentID(pDocumentID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pDocumentID)
			{
				this.pict.log.error('No Document ID provided.');
				return reject(new Error('No Document ID provided.'));
			}
			this.fable.HeadlightRestClient.getJSON(`Inspections/FilteredTo/FBV~InspectionDocumentJoin.IDDocument~EQ~${ pDocumentID }/0/100?Joins=InspectionDocumentJoin,IDInspection,IDInspection;`,
				(pError, pResponse) =>
				{
					if (pError)
					{
						this.log.error('Error loading Inspection from Document:', pError);
						return reject(pError);
					}
					if (pResponse?.length)
					{
						this.pict.AppData.CurrentInspection = pResponse[0];
					}
					if (!this.pict.AppData.CurrentInspection)
					{
						this.log.warn(`No Current Inspection set. Can't load Inspection Documents.`);
						this.AppData.InspectionDocumentRecords = [];
						this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
						return resolve();
					}
					const currentInspectionID = this.pict.AppData.CurrentInspection.IDInspection;
					const cachedInspectionID = this.pict.AppData.CachedInspectionDocumentRecordsIDInspection;
					if ('InspectionDocumentRecords' in this.pict.AppData && currentInspectionID == cachedInspectionID)
					{
						return resolve(currentInspectionID);
					}
					delete this.AppData.InspectionDocumentRecords;
					delete this.AppData.CachedInspectionDocumentRecordsIDInspection;
					resolve(currentInspectionID);
				});
		});
	}

	async getInspectionDocumentJoins(inspectionID)
	{
		await new Promise((resolve, reject) =>
		{
			return this.pict.providers.EntityInspectionDocumentProvider.loadRecordsToAddress((error) =>
			{
				if (error)
				{
					this.log.warn(`Error retrieving Documents for Inspection ID ${inspectionID}:`, error);
					return reject(error);
				}
				resolve();
			}, 'AppData.InspectionDocumentJoins', `FilteredTo/FBV~IDInspection~EQ~${inspectionID}`, 0, 100);
		});
	}

	async getInspectionTypes()
	{
		await new Promise((resolve, reject) =>
		{
			if (Array.isArray(this.pict.AppData.InspectionTypes))
			{
				this.pict.log.info('InspectionTypes loaded', this.pict.AppData.InspectionTypes);
				return resolve();
			}
			// todo: do inspection types exist by default? this may need a fallback
			return this.pict.providers.EntityInspectionTypeProvider.loadRecordsToAddress((error) =>
			{
				if (error)
				{
					this.log.warn(`Error retrieving Inspection Types`, error);
					return reject(error);
				}
				resolve();
			}, 'AppData.InspectionTypes', null, null, null);
		});
	}

	async getCurrentInspectionDocumentRecords(inspectionID)
	{
		await new Promise((resolve, reject) =>
		{
			if (this.pict.AppData.InspectionDocumentJoins.length < 1)
			{
				// no need to hit server for nothing
				this.pict.AppData.CachedInspectionDocumentRecordsIDInspection = inspectionID;
				this.pict.AppData.InspectionDocumentRecords = [];
				return resolve();
			}

			const documentIds = this.pict.AppData.InspectionDocumentJoins.map((pJoin) => pJoin.IDDocument).join(',');

			return this.pict.providers.EntityDocumentProvider.loadRecordsToAddress(() =>
			{
				this.pict.AppData.CachedInspectionDocumentRecordsIDInspection = inspectionID;
				this.AppData.InspectionDocumentRecords.forEach((d) =>
				{
					//FIXME: zzzz - propagating include bit from join record to document record for UI, for now
					const join = this.AppData.InspectionDocumentJoins.find((pJoin) => pJoin.IDDocument == d.IDDocument);
					d.IncludeOnDossier = join ? join.IncludeOnDossier : 0;
					d.Ordinal = join ? join.Ordinal : this.AppData.InspectionDocumentJoins.length;

					const timeDelta = Math.abs(new Date().getTime() - new Date(join.CreateDate).getTime());
					// doc was added within 1 minute of rendering this screen. Probably from current user's action.
					d.NewlyAdded = timeDelta <= 60000;
				});
				this.AppData.InspectionDocumentRecords.sort((a, b) => a.Ordinal - b.Ordinal);
				resolve();
			}, 'AppData.InspectionDocumentRecords', `FilteredTo/FBL~IDDocument~INN~${documentIds}`, 0, this.AppData.InspectionDocumentJoins.length);
		});
	}

	async getCurrentInspectionDocuments(pDocumentID)
	{
		return new Promise(async (resolve, reject) =>
		{
			if (!pDocumentID)
			{
				this.pict.log.warn('No Document ID provided. Returning empty Inspection Documents.');
				this.AppData.InspectionDocumentRecords = [];
				this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
				return resolve();
			}

			// If the InspectionDocumentRecords are already loaded and match the current inspection, return them
			if (this.AppData.InspectionDocumentRecords && this.AppData.CachedInspectionDocumentRecordsIDInspection == this.pict.AppData.CurrentInspection?.IDInspection)
			{
				this.pict.log.info('Returning cached Inspection Documents for Document ID:', pDocumentID);
				return resolve();
			}

			try
			{
				await this.getInspectionTypes();
				const inspectionID = await this.getInspectionFromDocumentID(pDocumentID);
				if (!inspectionID)
				{
					this.pict.log.warn('No Inspection ID found for Document ID:', pDocumentID);
					this.AppData.InspectionDocumentRecords = [];
					this.AppData.CachedInspectionDocumentRecordsIDInspection = 0;
					return resolve();
				}
				await this.getInspectionDocumentJoins(inspectionID);
				await this.getCurrentInspectionDocumentRecords(inspectionID);
				resolve();
			}
			catch (pError)
			{
				this.pict.log.error(`Error retrieving Inspection Document Record for document id ${pDocumentID}:`, pError);
				reject(pError);
			}
		});
	}
}

module.exports = InspectionProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1590:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LabProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Lab by ID
	 * @param {String|Number} pLabID - The Lab ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getLabByID(pLabID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pLabID)
			{
				this.pict.log.error('No Lab ID provided.');
				return reject(new Error('No Lab ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Lab/${pLabID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Lab: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = LabProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1591:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LineItemProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the LineItem by ID
	 * @param {String|Number} pLineItemID - The LineItem ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getLineItemByID(pLineItemID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pLineItemID)
			{
				this.pict.log.error('No LineItem ID provided.');
				return reject(new Error('No LineItem ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`LineItem/${pLineItemID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting LineItem: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	async saveSampleLineItemJoin(payload)
	{
		await this._put('SampleLineItemJoin/Upsert', payload);
	}

	/**
	 * Get the LineItems
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */

	getLineItems()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'LineItems';

			// Check if we need to filter by customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `LineItems/By/IDCustomer/${this.pict.AppData.DocumentData.ReportData.IDCustomer}`;
			}

			// Make the request to get LineItems
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get LineItems list.', pError);
					return reject(pError);
				}

				resolve(pBody);
			});
		});
	}

	async _getSampleLineItemJoinsByIDSample(IDSample)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('SampleLineItemJoin', `FBV~IDSample~EQ~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLineItemJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
	}

	async _getLineItemsByIDs(IDLineItems)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('LineItem', `FBL~IDLineItem~INN~${ IDLineItems.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting LineItems: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
	}

	async getLineItemsByIDSample(IDSample)
	{
		const slijs = await this._getSampleLineItemJoinsByIDSample(IDSample);
		if (!slijs?.length)
		{
			return [];
		}
		const lineItems = await this._getLineItemsByIDs(slijs.map(slij => slij.IDLineItem));
		const slijMap = [];
		for (let s of slijs)
		{
			slijMap[s.IDLineItem] = s;
		}
		const decoratedLineItems = [];
		for (let l of lineItems)
		{
			// Decorate the LI with the important join information.
			decoratedLineItems.push(Object.assign(l, { RepresentedQuantity: slijMap[l.IDLineItem].RepresentedQuantity, IDSampleLineItemJoin: slijMap[l.IDLineItem].IDSampleLineItemJoin, GUIDSampleLineItemJoin: slijMap[l.IDLineItem].GUIDSampleLineItemJoin }));
		}
		return decoratedLineItems;
	}

	async deleteSampleLineItemJoin(IDSampleLineItemJoin)
	{
		return await new Promise((resolve, reject) => 
		{
			this.pict.HeadlightRestClient.deleteEntity('SampleLineItemJoin', IDSampleLineItemJoin, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error removing lineitem from sample: `, pError);
					return reject(pError);
				}
				resolve(true);
			});
		});
	}
}

module.exports = LineItemProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1592:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libLocationTree = require('headlight-sample-scanning').LocationTree;

class LocationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Every location the signed-in customer can see, read a page at a time so no list is cut short.
	 * @param {number} [pPageSize] - Default 1000.
	 * @return {Promise<Array<Object>>}
	 */
	async getAllLocations(pPageSize = 1000)
	{
		const tmpLocations = [];
		for (let tmpOffset = 0; ; tmpOffset += pPageSize)
		{
			const tmpPage = await new Promise((fResolve, fReject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Locations/FilteredTo/FBV~IDLocation~GT~0/${ tmpOffset }/${ pPageSize }`, (pError, pBody) => (pError ? fReject(pError) : fResolve(Array.isArray(pBody) ? pBody : [])));
			});
			tmpLocations.push(...tmpPage);
			if (tmpPage.length < pPageSize)
			{
				return tmpLocations;
			}
		}
	}

	/**
	 * Samples whose current location (their newest location join) is this location or any location inside it.
	 * @param {number} pIDLocation
	 * @param {Array<Object>} pLocations - The customer's locations, for walking the tree.
	 * @param {number} [pLimit] - Most samples to return. Default 500.
	 * @return {Promise<{ Samples: Array<Object>, LocationIDs: Array<number>, Truncated: boolean }>}
	 */
	async getSamplesAtLocation(pIDLocation, pLocations, pLimit = 500)
	{
		const tmpLocationIDs = [ Number(pIDLocation) ].concat(libLocationTree.getDescendantIDs(pIDLocation, pLocations));
		const tmpLocationSet = new Set(tmpLocationIDs);
		const fGet = (pURL) => new Promise((fResolve, fReject) =>
		{
			this.pict.HeadlightRestClient.getJSON(pURL, (pError, pBody) => (pError ? fReject(pError) : fResolve(Array.isArray(pBody) ? pBody : [])));
		});
		const fBatches = (pIDs) =>
		{
			const tmpBatches = [];
			for (let i = 0; i < pIDs.length; i += 100)
			{
				tmpBatches.push(pIDs.slice(i, i + 100));
			}
			return tmpBatches;
		};
		const tmpCandidateIDs = new Set();
		for (const tmpBatch of fBatches(tmpLocationIDs))
		{
			for (const tmpJoin of await fGet(`SampleLocationJoins/FilteredTo/FBL~IDLocation~INN~${ tmpBatch.join(',') }/0/5000`))
			{
				tmpCandidateIDs.add(Number(tmpJoin.IDSample));
			}
		}
		// A sample can keep older joins after it moves; it is here only if its newest join is.
		const tmpCurrentIDs = [];
		for (const tmpBatch of fBatches(Array.from(tmpCandidateIDs)))
		{
			const tmpNewest = new Map();
			for (const tmpJoin of await fGet(`SampleLocationJoins/FilteredTo/FBL~IDSample~INN~${ tmpBatch.join(',') }~FSF~CreateDate~DESC~0/0/10000`))
			{
				if (!tmpNewest.has(Number(tmpJoin.IDSample)))
				{
					tmpNewest.set(Number(tmpJoin.IDSample), Number(tmpJoin.IDLocation));
				}
			}
			for (const [ tmpIDSample, tmpIDLocation ] of tmpNewest)
			{
				if (tmpLocationSet.has(tmpIDLocation))
				{
					tmpCurrentIDs.push({ IDSample: tmpIDSample, IDLocation: tmpIDLocation });
				}
			}
		}
		const tmpTruncated = tmpCurrentIDs.length > pLimit;
		const tmpWanted = tmpCurrentIDs.slice(0, pLimit);
		const tmpLocationBySample = new Map(tmpWanted.map((pRow) => [ pRow.IDSample, pRow.IDLocation ]));
		const tmpSamples = [];
		for (const tmpBatch of fBatches(tmpWanted.map((pRow) => pRow.IDSample)))
		{
			for (const tmpSample of await fGet(`Samples/FilteredTo/FBL~IDSample~INN~${ tmpBatch.join(',') }/0/100`))
			{
				tmpSamples.push(Object.assign({}, tmpSample, { CurrentIDLocation: tmpLocationBySample.get(Number(tmpSample.IDSample)) }));
			}
		}
		return { Samples: tmpSamples, LocationIDs: tmpLocationIDs, Truncated: tmpTruncated };
	}

	/**
	 * Get the Locations by Sample ID
	 * @param {Number} pIDSample - The ID of the Sample to get Locations for
	 * @param {Function} [pCallback] - The callback function to call when the Location is fetched
	 * @return {Promise}
	 * @async
	 */
	async getLocationsBySampleID(pIDSample, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// First check if there is already a join between these.
				this.pict.fable.services.HeadlightRestClient.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${ pIDSample }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Locations: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							if (pBody.length)
							{
								const fullLocations = [];
								for (const j of pBody)
								{
									fullLocations.push(await this.getLocationByID(j.IDLocation));
								}
								resolve(fullLocations);
								if (pCallback)
								{
									pCallback(fullLocations);
								}
							}
							else
							{
								resolve([]);
								if (pCallback)
								{
									pCallback([]);
								}
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Locations: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the Location by GUID
	 * @param {Number} pGUIDLocation - The GUID of the Location to get
	 * @param {Function} [pCallback] - The callback function to call when the Location is fetched
	 * @param {Number} [recursiveDepth] - The depth of current recursion
	 * @return {Promise}
	 * @async
	 */
	async getLocationByGUID(pGUIDLocation, pCallback, recursiveDepth = 0)
	{
		const maxRecursiveDepth = 1;
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Locations/By/GUIDLocation/${ pGUIDLocation }`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Location: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							pBody = pBody[0];
							if (pBody.ParentIDLocation && recursiveDepth < maxRecursiveDepth)
							{
								try
								{
									pBody.ParentLocation = await this.getLocationByID(pBody.ParentIDLocation, null, recursiveDepth + 1);
								}
								catch (pError)
								{
									this.pict.log.error(`Error fetching Location: `, pError);
									reject(pError);
									// if we have a callback, run it now
									if (pCallback)
									{
										pCallback(null);
									}
								}
							}
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the Location by ID
	 * @param {Number} pIDLocation - The ID of the Location to get
	 * @param {Function} [pCallback] - The callback function to call when the Location is fetched
	 * @param {Number} [recursiveDepth] - The depth of current recursion
	 * @return {Promise}
	 * @async
	 */
	async getLocationByID(pIDLocation, pCallback, recursiveDepth = 0)
	{
		const maxRecursiveDepth = 1;
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Location/${ pIDLocation }`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching Location: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							if (pBody.ParentIDLocation && recursiveDepth < maxRecursiveDepth)
							{
								try
								{
									pBody.ParentLocation = await this.getLocationByID(pBody.ParentIDLocation, null, recursiveDepth + 1);
								}
								catch (pError)
								{
									this.pict.log.error(`Error fetching Location: `, pError);
									reject(pError);
									// if we have a callback, run it now
									if (pCallback)
									{
										pCallback(null);
									}
								}
							}
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Add a sample to a location.
	 * @param {Number} pIDSample - The ID of the Sample to add to the location
	 * @param {Number} pIDLocation - The ID of the Location to add the Sample to
	 * @param {Function} [pCallback] - The callback function to call when the action is complete
	 * @return {Promise}
	 * @async
	 */
	async addSampleToLocation(pIDSample, pIDLocation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// First check if there is already a join between these.
				this.pict.fable.services.HeadlightRestClient.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${ pIDSample }~FSF~CreateDate~DESC~0`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error adding sample to location: `, pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
								return;
							}
							reject(pError);
						}
						else
						{
							// If we found a join already, return it.
							if (pBody?.length && pBody[0].IDLocation == pIDLocation)
							{
								resolve(pBody[0]);
								// if we have a callback, run it now
								if (pCallback)
								{
									pCallback(pBody[0]);
								}
							}
							else
							{
								// Otherwise, create the join and return that.
								this.pict.HeadlightRestClient.putJSON('SampleLocationJoin/Upsert', { IDSample: pIDSample, IDLocation: pIDLocation }, (pError, pBody) =>
								{
									if (pError)
									{
										this.pict.log.error(`Error adding sample to location: `, pError);
										// if we have a callback, run it now
										if (pCallback)
										{
											pCallback(null);
											return;
										}
										reject(pError);
									}
									else
									{
										this.pict.HeadlightRestClient.getJSON(`Sample/${ pIDSample }`, async (pError, pBody) =>
										{
											if (pError)
											{
												this.pict.log.error(`Error adding sample to location: `, pError);
												// if we have a callback, run it now
												if (pCallback)
												{
													pCallback(null);
													return;
												}
												reject(pError);
											}
											else
											{
												if (parseInt(pBody?.Extension?.StorageLocation) !== pIDLocation)
												{
													this.pict.HeadlightRestClient.putJSON('Sample',
													{
														IDSample: pIDSample,
														Extension: Object.assign(pBody.Extension, { StorageLocation: `${ pIDLocation }` }),
													}, async (pError, pBody) =>
													{
														if (pError)
														{
															this.pict.log.error(`Error adding sample to location: `, pError);
															// if we have a callback, run it now
															if (pCallback)
															{
																pCallback(null);
																return;
															}
															reject(pError);
														}
														else
														{
															resolve(pBody);
															// if we have a callback, run it now
															if (pCallback)
															{
																pCallback(pBody);
															}
														}
													});
												}
												else
												{
													resolve(pBody);
													// if we have a callback, run it now
													if (pCallback)
													{
														pCallback(pBody);
													}
												}
											}
										});
									}
								});
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error adding Sample to Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
			else
			{
				throw error;
			}
		}
	}

	/**
	 * Remove a sample from a location.
	 * @param {Number} pIDSample - The ID of the Sample to remove from the location
	 * @param {Number} pIDLocation - The ID of the Location to remove the Sample from
	 * @param {Function} [pCallback] - The callback function to call when the action is complete
	 * @return {Promise}
	 * @async
	 */
	async removeSamplefromLocation(pIDSample, pIDLocation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// First check if there is already a join between these.
				this.pict.fable.services.HeadlightRestClient.getJSON(`SampleLocationJoins/FilteredTo/FBV~IDSample~EQ~${ pIDSample }~FBV~IDLocation~EQ~${ pIDLocation }`,
					async (pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error removing sample from location: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							// Delete every join for the pair; repeated moves can leave more than one.
							if (pBody?.length)
							{
								const tmpJoins = pBody.slice();
								const fDeleteNext = () =>
								{
									const tmpJoin = tmpJoins.shift();
									if (!tmpJoin)
									{
										resolve(true);
										// if we have a callback, run it now
										if (pCallback)
										{
											pCallback(true);
										}
										return;
									}
									this.pict.HeadlightRestClient.deleteEntity('SampleLocationJoin', tmpJoin.IDSampleLocationJoin, (pError) =>
									{
										if (pError)
										{
											this.pict.log.error(`Error removing sample from location: `, pError);
											reject(pError);
											// if we have a callback, run it now
											if (pCallback)
											{
												pCallback(null);
											}
											return;
										}
										fDeleteNext();
									});
								};
								fDeleteNext();
							}
							else
							{
								// Otherwise, just return;
								resolve(true);
								// if we have a callback, run it now
								if (pCallback)
								{
									pCallback(true);
								}
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error removing Sample from Location: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
			else
			{
				throw error;
			}
		}
	}
}

module.exports = LocationProvider;
module.exports.default_configuration = {};

},{"headlight-sample-scanning":294,"pict-provider":552}],1593:[function(require,module,exports){
const FirefoxHotkeyInstructions = require('../../web/markdown_display/FirefoxHotkeyInstructions');

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libMarked = require('marked');
// The shared renderer for markdown a user typed, deep-required from the dynamic inputs bundle the
// same way LIMS already requires _VocabularySelectorMap.js. Shared so a remark reads the same way
// on a panel, in the LIMS sample record and on a dynamic form.
const libUserMarkdown = require('headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js');

class MarkdownProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.markdownFilesMap =
		{
			FirefoxHotkeyInstructions: FirefoxHotkeyInstructions,
		};

		this._remarksCSSRegistered = false;

		// `{~MarkdownRemarks:Record.Notes~}` renders a remark as markdown.
		// `{~MarkdownRemarksClamped:Record.Notes~}` does the same but collapses a long one behind a
		// Read more toggle. Both take an optional template hash to render when the remark is empty:
		// `{~MarkdownRemarks:Record.Notes^SampleDetails-DatumValue-NA^~}`.
		this.pict.MetaTemplate.addPattern('{~MarkdownRemarks:', '~}', (pHash, pData, pContext) =>
		{
			return this.renderRemarksExpression(pHash, pData, pContext, false);
		});
		this.pict.MetaTemplate.addPattern('{~MarkdownRemarksClamped:', '~}', (pHash, pData, pContext) =>
		{
			return this.renderRemarksExpression(pHash, pData, pContext, true);
		});
	}

	/**
	 * Uses the name of the file to get the markdown from a file as a string (see the markdown_display folder).
	 * This will return null if the file name is not present.
	 * @param {String} name
	 * @return {String|null}
	 */
	getMarkdownByName(name)
	{
		return this.markdownFilesMap[name]?.markdown || null;
	}

	/**
	 * Uses the name of the file to get the title from a file as a string (see the markdown_display folder).
	 * This will return null if the file name is not present.
	 * @param {String} name
	 * @return {String|null}
	 */
	getMarkdownTitleByName(name)
	{
		return this.markdownFilesMap[name]?.title || null;
	}

	/**
	 * Uses the name of the file to get the markdown from a file converted to html.
	 * This will return null if the file name is not present.
	 * @param {String} name
	 * @return {String|null}
	 */
	getMarkdownAsHTMLByName(name)
	{
		const md = this.getMarkdownByName(name);
		if (!md)
		{
			return null;
		}
		return this.getMarkdownAsHTML(md);
	}

	/**
	 * Converts markdown to html.
	 * @param {String} markdown
	 * @return {String}
	 */
	getMarkdownAsHTML(markdown)
	{
		return this._addBulmaFlavor(String(libMarked.parse(markdown)));
	}

	/**
	 * Opens markdown in modal by file name (if file with that name is registered).
	 * @param {String} name
	 */
	openMarkdownInModalByName(name)
	{
		const md = this.getMarkdownByName(name);
		const title = this.getMarkdownTitleByName(name);
		if (md)
		{
			this.openMarkdownInModal(md, title);
		}
	}

	/**
	 * Opens markdown in a modal. Can optionally include a title for the modal.
	 * @param {String} markdown
	 * @param {String} [title]
	 */
	openMarkdownInModal(markdown, title)
	{
		const markdownModalOptions = {
			title: `<b>${ title || '' }</b>`,
			modalBodyTemplate: /*html*/`
				<div>
					${ this.getMarkdownAsHTML(markdown) }
				</div>
			`,
			modalFooterTemplate: /*html*/`
				<div class="columns">
					<div id="Footer-ButtonGroup" class="buttons is-right">
						<button id="Footer-Button-Cancel" type="button" class="button is-link is-soft" onclick="_Pict.fable.HeadlightModal.cancelCallback()">
							<span class="icon"><i class="fas fa-fw fa-times"></i></span>
							<span> Close </span>
						</button>
					</div>
				</div>
			`,
			confirmText: '',
			style: 'wide',
			cancelText: 'Cancel',
		};
		this.pict.services.HeadlightModal.spawnModal(markdownModalOptions);
	}

	/**
	 * Escapes a value for use as HTML text or as an attribute value.
	 *
	 * @param {any} pValue
	 * @return {String}
	 */
	escapeHTML(pValue)
	{
		return libUserMarkdown.escapeHTML(pValue);
	}

	/**
	 * Converts markdown a user typed (a remark, a note, a comment) to display HTML.
	 * Returns an empty string for an empty or null value.
	 *
	 * @param {any} pMarkdown
	 * @return {String}
	 */
	getUserMarkdownAsHTML(pMarkdown)
	{
		return libUserMarkdown.renderUserMarkdown(pMarkdown, this.log);
	}

	/**
	 * Renders a remark as the shared remarks block: the same markdown treatment the Sample
	 * Authorization form gives test remarks, so a remark reads the same way wherever it is shown.
	 *
	 * @param {any} pMarkdown - the remark source.
	 * @param {Object} [pOptions] - `Clamp` clamps the remark to three lines, with a Read more toggle when it runs longer.
	 * @return {String} - the rendered block, or an empty string when there is no remark.
	 */
	getRemarksAsHTML(pMarkdown, pOptions)
	{
		const tmpContent = this.getUserMarkdownAsHTML(pMarkdown);
		if (!tmpContent)
		{
			return '';
		}
		this.registerRemarksCSS();
		if (pOptions && pOptions.Clamp)
		{
			return `<details class="hl-md-remarks-collapse"><summary><div class="content hl-md-remarks hl-md-remarks-text">${ tmpContent }</div></summary></details>`;
		}
		return `<div class="content hl-md-remarks">${ tmpContent }</div>`;
	}

	/**
	 * Renders a `{~MarkdownRemarks:~}` / `{~MarkdownRemarksClamped:~}` expression.
	 *
	 * The expression is `<DataAddress>` or `<DataAddress>^<EmptyTemplateHash>^`. The empty-template
	 * hash is rendered in place of the remark when there is nothing to show -- it carries whatever
	 * "N/A" treatment the screen already uses.
	 *
	 * @param {String} pHash - the contents of the template expression.
	 * @param {any} pData - the Record the expression is rendering against.
	 * @param {Array<any>} pContext - the template context array.
	 * @param {Boolean} pClamp - true to collapse a long remark behind a Read more toggle.
	 * @return {String}
	 */
	renderRemarksExpression(pHash, pData, pContext, pClamp)
	{
		const tmpHashParts = String(pHash).split('^');
		const tmpRemarks = this.pict.resolveStateFromAddress(tmpHashParts[0].trim(), pData, pContext);
		const tmpContent = this.getRemarksAsHTML(tmpRemarks, { Clamp: pClamp });
		if (tmpContent)
		{
			return tmpContent;
		}
		const tmpEmptyTemplateHash = (tmpHashParts.length > 1) ? tmpHashParts[1].trim() : '';
		return tmpEmptyTemplateHash ? this.pict.parseTemplateByHash(tmpEmptyTemplateHash, pData, null, pContext) : '';
	}

	/**
	 * Puts the remarks styling in the page. Called the first time a remark actually renders rather
	 * than from the constructor, because the provider is built before the document is ready.
	 */
	registerRemarksCSS()
	{
		if (this._remarksCSSRegistered || !this.pict.CSSMap)
		{
			return;
		}
		this._remarksCSSRegistered = true;
		this.pict.CSSMap.addCSS('Headlight-Markdown-Remarks', libUserMarkdown.RemarksCSS, 500, 'MarkdownProvider');
		this.pict.CSSMap.injectCSS();
		libUserMarkdown.watchRemarksTruncation();
	}

	/**
	 * Adds Bulma flavor to the provided content (expected "default Bulma classes" on HTML elements).
	 * @param {string} pContent - The content to which to add Bulma flavor.
	 * @return {string} - The content with Bulma flavor added.
	 */
	_addBulmaFlavor(pContent)
	{
		if (pContent)
		{
			// for tables, add the table class
			pContent = pContent.replace(/<table>/g, '<table class="table is-fullwidth is-striped is-hoverable">');
			// for images, add the image class
			pContent = pContent.replace(/<img/g, '<img class="image"');
			// h1-h6
			pContent = pContent.replace(/<h1>/g, '<h1 class="title is-1">');
			pContent = pContent.replace(/<h2>/g, '<h2 class="title is-2">');
			pContent = pContent.replace(/<h3>/g, '<h3 class="title is-3">');
			pContent = pContent.replace(/<h4>/g, '<h4 class="title is-4">');
			pContent = pContent.replace(/<h5>/g, '<h5 class="title is-5">');
			pContent = pContent.replace(/<h6>/g, '<h6 class="title is-6">');
		}
		return pContent;
	}
}

module.exports = MarkdownProvider;
module.exports.default_configuration = {};

},{"../../web/markdown_display/FirefoxHotkeyInstructions":1575,"headlight-dynamic-inputs-bundle/source/providers/_UserMarkdown.js":170,"marked":506,"pict-provider":552}],1594:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MaterialProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Material by ID
	 * @param {String|Number} pMaterialID - The Material ID to search for=
	 * @return {Promise<void>}
	 * @async
	 */
	getMaterialByID(pMaterialID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMaterialID)
			{
				this.pict.log.error('No Material ID provided.');
				return reject(new Error('No Material ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Material/${pMaterialID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Material: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Materials
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	async getMaterials()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Materials';

			// Check if we need to filter by customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Materials/By/IDCustomer/${this.pict.AppData.DocumentData.ReportData.IDCustomer}`;
			}

			// Make the request to get materials
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Materials list.', pError);
					reject(pError);
				}
				else
				{
					resolve(pBody);
				}
			});
		});
	}
}

module.exports = MaterialProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1595:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MixDesignProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the MixDesign by ID
	 * @param {String|Number} pMixDesignID - The MixDesign ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getMixDesignByID(pMixDesignID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMixDesignID)
			{
				this.pict.log.error('No MixDesign ID provided.');
				return reject(new Error('No MixDesign ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`MixDesign/${pMixDesignID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixDesign: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the MixDesign by ID
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getMixDesigns()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'MixDesigns';

			// Filter out by customer if we have a customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `MixDesigns/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			// Make the request to get MixDesigns
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixDesigns list: ${pError}`, pError);
					return reject(pError);
				}

				resolve(pBody);
			});
		});
	}
}

module.exports = MixDesignProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1596:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MixSpecificationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the MixSpecification by ID
	 * @param {String|Number} pMixSpecificationID - The MixSpecification ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getMixSpecificationByID(pMixSpecificationID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMixSpecificationID)
			{
				this.pict.log.error('No MixSpecification ID provided.');
				return reject(new Error('No MixSpecification ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`MixSpecification/${pMixSpecificationID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixSpecification: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = MixSpecificationProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1597:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ObservationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Load the EXIF data from an image file and attach it to an observation object
	 * @param {Object} pNewObservationObject - The observation object to attach the EXIF data to
	 * @param {Object} pFileDetails - The details of the file to upload
	 * @param {String} pDatumType - The type of the datum to upload
	 * @return {Promise<Object>} - A promise that resolves to the observation object with the EXIF data attached
	 */
	async attachEXIFDatumToObservation(pNewObservationObject, pFileDetails, pDatumType)
	{
		return new Promise((resolve, reject) =>
		{
			// fetch any EXIF data for the observation -- DOCS: https://github.com/exif-heic-js/exif-heic-js
			const readerExif = new FileReader();
			const methodName = pFileDetails.File.type.toLowerCase() === 'image/heic' ? 'findEXIFinHEIC' : 'findEXIFinJPEG';
			this.pict.log.info('[Image] Reading EXIF Data from file:', pFileDetails.File.type);
			this.pict.log.info('[Image] Using EXIF Method:', methodName);
			// on load of EXIF Data
			readerExif.onload = (buffer) =>
			{
				// take the exif data and set it on the File Object first (so we can use it later)
				const exifData = window[methodName](buffer.target.result);

				if (exifData && exifData.GPSLongitude && exifData.GPSLatitude)
				{
					let tmpLongitude = this.convertEXIFDataToGeolocation(exifData.GPSLongitude[0], exifData.GPSLongitude[1], exifData.GPSLongitude[2], exifData.GPSLongitudeRef);
					tmpLongitude = parseFloat(tmpLongitude.toFixed(8));
					let tmpLatitude = this.convertEXIFDataToGeolocation(exifData.GPSLatitude[0], exifData.GPSLatitude[1], exifData.GPSLatitude[2], exifData.GPSLatitudeRef);
					tmpLatitude = parseFloat(tmpLatitude.toFixed(8));
					this.pict.log.info('[Image] Found EXIF Data: lat/long', (tmpLatitude + ', ' + tmpLongitude));

					if (tmpLatitude && tmpLongitude)
					{
						// set the file details (used below in the generic datum fields loop for Observation Datum)
						pFileDetails.File.Latitude = tmpLatitude;
						pFileDetails.File.Longitude = tmpLongitude;
						// set the observation object's dedicated lat/long Capture fields
						pNewObservationObject.CaptureLatitude = tmpLatitude;
						pNewObservationObject.CaptureLongitude = tmpLongitude;
					}
				}
				// set altitude (store on file object)
				if (exifData && exifData.GPSAltitude && Object.keys(exifData.GPSAltitude)?.length)
				{
					pFileDetails.File.Altitude = parseFloat(exifData.GPSAltitude);
					this.pict.log.info('[Image] Found EXIF Data: altitude', exifData.GPSAltitude);
				}

				// set any additional EXIF data from the File object to the Observation Datum fields, if found
				const datumKeys = [ 'Altitude', 'DeviceTilt', 'HeadingMagnetic', 'HeadingTrue', 'HorizontalAccuracy', 'Latitude', 'Longitude', 'VerticalAccuracy' ];
				datumKeys.forEach((key) =>
				{
					if (pFileDetails.File[key])
					{
						pNewObservationObject.Details[pDatumType][0].Datum[key] = pFileDetails.File[key];
					}
				});
				resolve(pNewObservationObject);
			};
			// call the methods above by reading the file as an array buffer
			readerExif.readAsArrayBuffer(pFileDetails.File);
		});
	}

	/**
	 * Broadcast a document change to other applications listening for changes (FB Web, etc.)
	 * @param {Number} pIDDocument - The ID of the document that was changed
	 * @param {Number} pIDProject - The ID of the project that the document belongs to
	 * @return {void}
	 */
	broadcastDocumentChangeOnObservationJoin = (pIDDocument, pIDProject) =>
	{
		if (!pIDDocument && !pIDProject)
		{
			this.pict.log.warn('Cannot broadcast document change - missing required data (need either IDDocument and/or IDProject).');
			return;
		}
		if (window.localStorage)
		{
			// we are doing a set, then remove in this same browser tab, however, other browser tabs will see the set action
			// and can do a callback via the watcher they should have applied (listed below)

			// NOTE: Some of this can't be known unless we fetch the document record, so we mimic this as a courtesy to other apps for now...
			//	   The primary document/app's saving method is still the best way to refresh parent/external views watching changes.
			const tmpDocumentChange = JSON.stringify({
				action: 'ObservationsAdded',
				updateTime: new Date(),
				IDDocument: pIDDocument,
				IDProject: pIDProject,
			});
			window.localStorage.setItem('documentChange', tmpDocumentChange);
			window.localStorage.removeItem('documentChange');

			// a generic watcher with jQuery for usage

			// // the receiving method an app should use to 'catch' this broadcast
			// $(window).on('storage', function(ev) {
			//	 // if this isn't the storage we're looking for, we're done here
			//	 if (ev.originalEvent.key !== 'documentChange') {
			//		 return;
			//	 }
			//	 // parse the stringy data we should be getting
			//	 let obj = ev.originalEvent.newValue && ev.originalEvent.newValue.length ? JSON.parse(ev.originalEvent.newValue) : {};
			//	 // on save or on status change
			//	 if (obj.action === 'Save') {
			//		 console.log(`A form was saved in another tab, we should probably update/refresh data?`);
			//		 // set your app action callback here!
			//	 } else if (obj.action === 'ApprovalStatusChange') {
			//		 console.log(`A form had a status change in another tab, we should probably update/refresh data?`);
			//		 // set your app action callback here!
			//	 }
			// });
		}
	};

	/**
	 * Convert EXIF data to a geolocation
	 * @param {Number} degrees - The degrees of the geolocation
	 * @param {Number} minutes - The minutes of the geolocation
	 * @param {Number} seconds - The seconds of the geolocation
	 * @param {String} direction - The direction of the geolocation
	 * @return {Number} - The geolocation
	 * @example
	 * convertEXIFDataToGeolocation(40, 26, 46.8, 'N'); // returns 40.44633333333333
	 * convertEXIFDataToGeolocation(79, 58, 56.4, 'W'); // returns -79.98233333333333
	 */
	convertEXIFDataToGeolocation = (degrees, minutes, seconds, direction) =>
	{
		let dd = degrees + minutes/60 + seconds/(60*60);
		// Don't do anything for N or E
		if (direction == 'S' || direction == 'W')
		{
			dd = dd * -1;
		}
		return dd;
	};

	/**
	 * Get the observation by ID
	 * @param {Number} pIDObservation - The ID of the observation to get
	 * @param {Function} [pCallback] - The callback function to call when the observation is fetched
	 * @return {Promise}
	 * @async
	 */
	async getObservationByID(pIDObservation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Observation/${pIDObservation}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching observation: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching observation: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Extract file observation page info.
	 * @param {Number} pIDObservation - The ID of the document that was changed
	 * @param {Function} pCallback - Callback to return the extracted info.
	 */
	async extractInfoByID(pIDObservation, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Observation/${pIDObservation}/ExtractInfo`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error extracting info for observation: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error extracting info for observation: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Extract file observation page info.
	 * @param {Number} IDObservation - The ID of the File Observation.
	 * @param {Object} boundaries - The ID of the document that was changed.
	 * @param {Function} pCallback - Callback to return the subImage Observation.
	 */
	async extractSubImage(IDObservation, boundaries, pCallback)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `Observation/${ IDObservation }/Extract/Clone`;
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, boundaries,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating observation: `, pError);
					reject(new Error(`Error creating observation: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error creating observation: `, pBody.Error);
					reject(new Error(`Error creating observation: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					pCallback(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	async getObservationByIDList(pIDObservationList)
	{
		if (!Array.isArray(pIDObservationList) || pIDObservationList.length === 0)
		{
			return [];
		}
		// Concurrent callers asking for the same ids (several card decks marshaling at once) share one
		// request. Each gets its own record copies, since callers stamp per-namespace ordinals on them.
		const tmpRequestKey = pIDObservationList.map(String).sort().join(',');
		this._observationListRequests = this._observationListRequests || {};
		if (!this._observationListRequests[tmpRequestKey])
		{
			this._observationListRequests[tmpRequestKey] = new Promise((resolve, reject) =>
			{
				this.pict.fable.services.HeadlightRestClient.getJSON(`Observations/FilteredTo/FBL~IDObservation~INN~${pIDObservationList.join(',')}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching observations by id list: `, pError);
							reject(pError);
						}
						else
						{
							resolve(pBody);
						}
					});
			}).finally(() =>
			{
				delete this._observationListRequests[tmpRequestKey];
			});
		}
		const tmpRecords = await this._observationListRequests[tmpRequestKey];
		return Array.isArray(tmpRecords) ? tmpRecords.map((pRecord) => Object.assign({}, pRecord)) : tmpRecords;
	}

	/**
	 * Get the tag types for an observation
	 * @param {Object} pObservation - The observation to get the tag types for
	 * @param {Number} pIDObservation - The ID of the observation to get the tag types for
	 * @return {Array<Object>} - An array of tag types for the observation
	 */
	getObservationTagTypes(pObservation, pIDObservation)
	{
		const tmpObservation = pObservation;

		// Build a map of all tag types for this observation, ignoring the SAVE tag.
		const tmpTagTypes = [];
		const tmpObservationTagSet = Object.keys(tmpObservation.Labels);

		for (let i = 0; i < tmpObservationTagSet.length; i++)
		{
			if (tmpObservationTagSet[i] !== 'SAVE')
			{
				tmpTagTypes.push({ TagType: tmpObservationTagSet[i], TagCount: tmpObservation.Labels[tmpObservationTagSet[i]].length });
			}
		}

		return tmpTagTypes;
	}

	/**
	 * Get the tags for an observation of a specific type
	 * @param {Object} pObservation - The observation to get the tags for
	 * @param {String} pTagType - The type of the tags to get
	 * @return {Array<String>} - An array of tags for the observation of the specified type
	 */
	getObservationTags(pObservation, pTagType)
	{
		const tmpObservation = pObservation;

		// Build a map of the tags for this type.
		const tmpTags = [];

		if (tmpObservation.Labels[pTagType])
		{
			const tmpLabelSet = tmpObservation.Labels[pTagType];

			for (let i = 0; i < tmpLabelSet.length; i++)
			{
				tmpTags.push(tmpLabelSet[i]);
			}
		}

		return tmpTags;
	}

	/**
	 * Get the observation types for a project or customer
	 * @param {Number} [pIDProject] - The ID of the project to get the observation types for
	 * @param {Function} [pCallback] - The callback function to call when the observation types are fetched
	 * @async
	 */
	async getObservationTypeManifest(pIDProject, pCallback)
	{
		let tmpURL = ``;
		// TODO: Come back to this later for Project level manifest joins - we need to filter by customer for now
		// if (pIDProject)
		// {
		// 	tmpURL = `ProjectObservationManifestJoins/By/IDProject/${pIDProject}`;
		// }
		// else
		// {
		tmpURL = `ObservationManifests`;
		// }

		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error fetching ObservationManifests: `, pError);
					reject(new Error(`Error fetching ObservationManifests: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error fetching ObservationManifests: `, pBody.Error);
					reject(new Error(`Error fetching ObservationManifests: ` + pBody.Error));
				}
				else if (pBody)
				{
					// filter out duplicates if we have them
					const tmpUniqueObservationTypes = [];
					const tmpUniqueObservationTypeMap = {};
					pBody.forEach((item) =>
					{
						// For PROJECTS, we need to filter by the project ID
						// if (!tmpUniqueObservationTypeMap[item.ObservationManifestName]) {
						// 	tmpUniqueObservationTypeMap[item.ObservationManifestName] = true;
						// 	tmpUniqueObservationTypes.push(item);
						// }
						// For CUSTOMERS (data format is different)
						if (!tmpUniqueObservationTypeMap[item.Name])
						{
							tmpUniqueObservationTypeMap[item.Name] = true;
							tmpUniqueObservationTypes.push(item);
						}
					});
					resolve(tmpUniqueObservationTypes);
					// if we have a callback, run it now
					if (pCallback)
					{
						pCallback(tmpUniqueObservationTypes);
					}
				}
			},
		));
	}

	/**
	 * Get the class for a label based on the observation tag object
	 * @param {Object} pTagObject - The tag object to get the class for
	 * @return {String} - The class for the label
	 * @example
	 * getLabelClassFromObservationTagObject({ TagType: 'Tag' }); // returns 'is-primary-25'
	 * getLabelClassFromObservationTagObject({ TagType: 'BidItem' }); // returns 'is-info-25'
	 */
	getLabelClassFromObservationTagObject(pTagObject)
	{
		let tmpClass = 'is-dark';

		if (!pTagObject || !pTagObject.TagType)
		{
			return tmpClass;
		}
		// TODO: revisit these colors for consistency and color blindness
		switch (pTagObject.TagType)
		{
		case 'Tag':
			tmpClass = 'has-text-white has-background-primary-25';
			break;
		case 'BidItem':
			tmpClass = 'has-text-white has-background-info-25';
			break;
		case 'Contractor':
			tmpClass = 'has-text-white has-background-link-25';
			break;
		case 'LineItem':
			tmpClass = 'has-text-white has-background-link-15';
			break;
		case 'Equipment':
			tmpClass = 'has-text-white has-background-info-15';
			break;
		}
		return tmpClass;
	}

	/**
	 * Get the display mapped details of an observation type
	 * @param {String} pObservationType - The type of the observation to get details for
	 * @return {Object} - An object with the display details of the observation type
	 * @example
	 * getObservationMappedDetails('Legacy Audio'); // returns { Icon: 'fa-volume-up', Type: 'Audio' }
	 * getObservationMappedDetails('Legacy Image'); // returns { Icon: 'fa-image', Type: 'Image' }
	 */
	getObservationMappedDetails = (pObservationType) =>
	{
		// TODO: this stuff should be moved to a configuration file or a centralized location for consistency
		const observationIconMap =
		{
			'File': 'fa-file',
			'Legacy Audio': 'fa-volume-up',
			'Legacy Equipment': 'fa-hammer',
			'Legacy Image': 'fa-image',
			'Legacy Narrative': 'fa-book',
			'Legacy Personnel': 'fa-user',
			'Legacy Start/Stop Work': 'fa-clock',
			'Legacy Temperature': 'fa-thermometer-half',
			'Legacy Traffic Control': 'fa-traffic-light-stop',
			'Legacy Video': 'fa-video',
			'Legacy Weather': 'fa-cloud-sun-rain',
			'WorkItem': 'fa-tasks',
		};
		const observationTypeMap =
		{
			'File': 'File',
			'Legacy Audio': 'Audio',
			'Legacy Density': 'Density Measurement',
			'Legacy Image': 'Image',
			'Legacy Narrative': 'Narrative',
			'Legacy Equipment': 'Equipment',
			'Legacy Materials': 'Material',
			'Legacy Personnel': 'Personnel',
			'Legacy Start/Stop Work': 'Start/Stop',
			'Legacy Temperature': 'Temperature',
			'Legacy Traffic Control': 'Traffic Control',
			'Legacy Video': 'Video',
			'Legacy Weather': 'Weather',
			'WorkItem': 'Work Item',
		};
		return {
			Icon: observationIconMap[pObservationType] || 'fa-table',
			Type: observationTypeMap[pObservationType] || pObservationType,
		};
	};

	/**
	 * Get the observation search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Object} pOptions - Contains the pagination options
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getObservationSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getObservationSearchCount(pSearchQuery, pOptions, pCallback)
	{
		const tmpURL = `ObservationsFilter/Count`;
		this.pict.HeadlightRestClient.postJSON(tmpURL, pSearchQuery,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the observation search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Object} pOptions - Contains the pagination options
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getObservationSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getObservationSearchResults(pSearchQuery, pOptions, pCallback)
	{
		const tmpURL = `ObservationsFilter`;
		const currentPage = pOptions?.CurrentPage || 1;
		const limit = pOptions?.PageSize || 25;
		const startCount = (currentPage - 1) * limit;
		const endCount = currentPage * limit;
		this.pict.HeadlightRestClient.postJSON(`${tmpURL}/${startCount}/${endCount}`, pSearchQuery,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * Group all passed observations by their Observation Type, returning an object with the observations grouped by type
	 * @param {Array} pObservations - The observations to group
	 * @return {Object} - An object with the observations grouped by their Observation Type
	 */
	groupObservationsByType = (pObservations) =>
	{
		const tmpGroupedObservations = {};
		if (!pObservations || !Array.isArray(pObservations))
		{
			return tmpGroupedObservations;
		}
		pObservations?.forEach((observation) =>
		{
			const tmpType = observation.ObservationType;
			if (!tmpGroupedObservations[tmpType])
			{
				tmpGroupedObservations[tmpType] =
				{
					ObservationList: [],
					ObservationType: observation.ObservationType,
					ObservationTypeDetails: this.getObservationMappedDetails(observation.ObservationType),
				};
			}
			tmpGroupedObservations[tmpType].ObservationList.push(observation);
		});
		return tmpGroupedObservations;
	};

	/**
	 * Cache busting for observation images of type (standard, preview and thumbnail-dense) for the observation.
	 * @param {Number} idObs - The ID of the observation to refresh.
	 * @param {Array} timeSet - An array of times to trigger a refresh on.
	 */
	cacheBustObsImages(idObs, timeSet)
	{
		const images = document.querySelectorAll(`[src*="/1.0/Observation/${ idObs }/Image/"]`);
		const outLineClassThick = 'has-animated-thick-outline';
		const defaultOutlineClass = 'has-animated-outline';
		let outLineClass = defaultOutlineClass;
		if (images.length)
		{
			images.forEach((i) =>
			{
				outLineClass = defaultOutlineClass;
				if (i instanceof HTMLImageElement && i.src?.includes('Preview'))
				{
					outLineClass = outLineClassThick;
				}
				i.classList.add(outLineClass);
			});
		}
		for (const time of timeSet)
		{
			setTimeout(()=>
			{
				const images = document.querySelectorAll(`[src*="/1.0/Observation/${ idObs }/Image/"]`);
				if (images.length)
				{
					images.forEach((i) =>
					{
						if (!(i instanceof HTMLImageElement))
						{
							return;
						}
						const srcWStamp = i.src?.split('?t')?.[0] + '?t=' + new Date().getTime();
						i.src = srcWStamp;
						if (time === timeSet[timeSet.length - 1])
						{
							outLineClass = defaultOutlineClass;
							if (i.src?.includes('Preview'))
							{
								outLineClass = outLineClassThick;
							}
							i.classList.remove(outLineClass);
						}
					});
				}
			}, time);
		}
	}

	/**
	 * Do a direct observation join to a document record (vs saving the document with the observation attached)
	 * @param {Number} pIDObservation - The ID of the observation to join
	 * @param {Number} pIDDocument - The ID of the document to join the observation to
	 * @param {Function} pCallback - The callback function to call when the observation is joined
	 * @example
	 * joinObservationToDocumentRecord(123, (response) => { console.log(response); });
	 */
	async joinObservationToDocumentRecord(pIDObservation, pIDDocument, pCallback)
	{
		// If we passed a document ID, join the observations to the document
		// NOTE: if you don't want to join the observations to the document, just don't pass an IDDocument
		if (!pIDDocument)
		{
			this.pict.log.warn('No document ID provided - skipping observation join.');
			return;
		}

		const tmpURL = `Document/${pIDDocument}/AddObservation/${pIDObservation}`;
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
			async (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating document observation join: `, pError);
					reject(new Error(`Error updating document observation join: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating document observation join: `, pBody.Error);
					reject(new Error(`Error updating document observation join: ` + pBody.Error));
				}
				else if (pBody)
				{
					if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument)
					{
						const obs = await this.getObservationByID(pIDObservation);
						this.pict.AppData.DocumentData.ReportData.Observations.push(obs);
						this.pict.providers.MediaRegistry.refreshDocumentObservations();
					}
					resolve(pBody);
					// if we have a callback, run it now
					if (pCallback)
					{
						pCallback(pBody);
					}
					// broadcast the document change for FB and other apps to pick up
					this.broadcastDocumentChangeOnObservationJoin(pIDObservation, pIDDocument);
				}
			},
		));
	}

	/**
	 * Do a direct observation unjoin from a document record (vs saving the document with the observation detached)
	 * @param {Number} pIDObservation - The ID of the observation to unjoin
	 * @param {Number} pIDDocument - The ID of the document to unjoin the observation from
	 * @param {Function} pCallback - The callback function to call when the observation is unjoined
	 * @example
	 * unjoinObservationFromDocumentRecord(123, (response) => { console.log(response); });
	 */
	unjoinObservationFromDocumentRecord(pIDObservation, pIDDocument, pCallback)
	{
		// If we passed a document ID, join the observations to the document
		// NOTE: if you don't want to join the observations to the document, just don't pass an IDDocument
		if (!pIDDocument)
		{
			this.pict.log.warn('No document ID provided - skipping observation join.');
			return;
		}

		const tmpURL = `Document/${pIDDocument}/RemoveObservation/${pIDObservation}`;
		this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating document observation join: `, pError);
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating document observation join: `, pBody.Error);
				}
				else if (pBody)
				{
					if (this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument)
					{
						this.pict.AppData.DocumentData.ReportData.Observations = this.pict.AppData.DocumentData.ReportData.Observations.filter((o) => o.IDObservation !== pIDObservation);
						this.pict.providers.MediaRegistry.refreshDocumentObservations();
					}
					// if we have a callback, run it now
					if (pCallback)
					{
						pCallback(pBody);
					}
					// broadcast the document change for FB and other apps to pick up
					this.broadcastDocumentChangeOnObservationJoin(pIDObservation, pIDDocument);
				}
			},
		);
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @param {Function} pLocalCallback - The callback function to call when the search is complete
	 * @async
	 */
	async performObservationSearch(pOptions = {}, pLocalCallback)
	{
		// TODO: when adding sorting to this, add {~T:ObservationSearch-Entry-SortBy~} back to ObservationSearch-Entry template
		const tmpSearchQuery = {};
		// handle the search filters
		if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
		{
			tmpSearchQuery['SearchText'] = pOptions.SearchText;
		}
		if (pOptions?.Projects && pOptions.Projects.length > 0)
		{
			tmpSearchQuery['IDProject'] = pOptions.Projects;
		}
		if (pOptions?.ObservationTypes && pOptions.ObservationTypes.length > 0)
		{
			tmpSearchQuery['ObservationType'] = pOptions.ObservationTypes;
		}
		if (pOptions?.StartDate && pOptions.StartDate.length > 0)
		{
			tmpSearchQuery['DesignatedTime'] = {
				From: pOptions.StartDate,
			};
		}
		if (pOptions?.EndDate && pOptions.EndDate.length > 0)
		{
			if (!tmpSearchQuery['DesignatedTime'])
			{
				tmpSearchQuery['DesignatedTime'] = {};
			}
			tmpSearchQuery['DesignatedTime'] = {
				To: pOptions.EndDate,
			};
		}

		try
		{
			// get the count of results first
			this.getObservationSearchCount(tmpSearchQuery, pOptions, (pCountResults) =>
			{
				// get the results
				this.getObservationSearchResults(tmpSearchQuery, pOptions, (pSearchResults) =>
				{
					// if there is a local callback function, call it
					if (pLocalCallback)
					{
						// call the local callback with the results of both the count and the search
						pLocalCallback(pSearchResults, pCountResults);
					}
				});
			});
		}
		catch (error)
		{
			this.pict.log.error('Error performing observation search:', error);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error performing observation search:</strong><br/><em>${error.message || error}</em>`,
				type: 'is-danger',
			});
			// if there is a local callback function, call it
			if (pLocalCallback)
			{
				pLocalCallback([]);
			}
		}
	}

	/**
	 * Format the observation record to be uploaded to the server. This also attaches the EXIF data to the observation if it is available.
	 * @param {Object} pFileDetails - The details of the file to upload
	 * @param {Number} pIDProject - The ID of the project to upload the observation to
	 * @param {Function} onObservationResult - The callback function to call when the observation is posted
	 * @param {Function} onProgressChange - The callback function to call when the progress of the upload changes
	 */
	async prepareObservationObjectFromFile(pFileDetails, pIDProject, onObservationResult, onProgressChange)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const datumType = pFileDetails?.ObservationType.replace('Legacy ', ''); // probably a better way to get these (manifest?)
		let tmpObservation = {
			Name: pFileDetails.Name || pFileDetails.FileName || `New ${ pFileDetails.ObservationType } Observation`,
			Description: pFileDetails.Description,
			Tags: Array.isArray(pFileDetails.Tags) ? pFileDetails.Tags : [ pFileDetails.Tags ],
			ObservationType: pFileDetails.ObservationType,
			Details: {},
			IDObservation: 0,
			IDProject: pIDProject,
			// set by Exif data below, if available
			CaptureLatitude: '0.00000000',
			CaptureLongitude: '0.00000000',
			// TODO: add these to the UI and allow the user to set them
			UserLatitude: pFileDetails.UserLatitude || '0.00000000',
			UserLongitude: pFileDetails.UserLongitude || '0.00000000',
			AlignmentStation: pFileDetails.AlignmentStation || 0,
			AlignmentOffset: pFileDetails.AlignmentOffset || 0,
		};
		// format this for the API
		tmpObservation.Details[datumType] = [ {
			'ArtifactType': datumType,
			'IDArtifact': 0,
			'Datum': {
				'FileName': pFileDetails.FileName,
				'FileMimeType': pFileDetails.File.type,
			},
		} ];
		// additional EXIF Data fields that might be set on images needs to be processed first
		if (pFileDetails.File.type.toLowerCase() === 'image/heic' || pFileDetails.File.type.toLowerCase() === 'image/jpg' || pFileDetails.File.type.toLowerCase() === 'image/jpeg')
		{
			await this.attachEXIFDatumToObservation(tmpObservation, pFileDetails, datumType);
		}

		const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();
		tmpObservation = Object.assign(tmpObservation, geoCoords);

		try
		{
			await this.uploadObservation(tmpObservation, pFileDetails, datumType, onObservationResult, onProgressChange);
		}
		catch (e)
		{
			this.pict.log.error('Error uploading observation: ', e);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error uploading observation:</strong><br/><em>${e.message || e}</em>`,
				type: 'is-danger',
			});
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
	}

	/**
	 * This method is used to return the appropriate icon for the passed file type.
	 * @param {String} pFileType
	 * @return {String}
	 */
	returnFileIconFromFileType = (pFileType) =>
	{
		switch (pFileType)
		{
		case 'image/jpeg':
		case 'image/png':
		case 'image/gif':
		case 'image/bmp':
			return 'fa-file-image';
		case 'video/mp4':
		case 'video/mov':
		case 'video/avi':
		case 'video/wmv':
			return 'fa-file-video';
		case 'audio/mp3':
		case 'audio/wav':
		case 'audio/aac':
		case 'audio/wma':
		case 'audio/mpeg':
			return 'fa-file-audio';
		case 'application/pdf':
			return 'fa-file-pdf';
		case 'application/msword':
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			return 'fa-file-word';
		case 'application/vnd.ms-excel':
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			return 'fa-file-excel';
		case 'application/vnd.ms-powerpoint':
		case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
			return 'fa-file-powerpoint';
		case 'text/plain':
			return 'fa-file-lines';
		case 'text/csv':
			return 'fa-file-csv';
		case 'application/zip':
		case 'application/x-7z-compressed':
		case 'application/x-rar-compressed':
		case 'application/x-tar':
		case 'application/gzip':
			return 'fa-file-zipper';
		case 'text/html':
			return 'fa-file-code';
		case 'application/json':
			return 'fa-file-code';
		case 'application/xml':
			return 'fa-file-code';
		default:
			return 'fa-file';
		}
	};

	/**
	 * This method is used to return the proper Observation Type for the passed file type.
	 * @param {String} pFileType
	 * @return {String}
	 */
	returnObservationTypeFromFileType = (pFileType) =>
	{
		switch (pFileType)
		{
		case 'image/jpeg':
		case 'image/png':
		case 'image/gif':
		case 'image/bmp':
			return 'Legacy Image';
		case 'video/mp4':
		case 'video/mov':
		case 'video/avi':
		case 'video/wmv':
			return 'Legacy Video';
		case 'audio/mp3':
		case 'audio/wav':
		case 'audio/aac':
		case 'audio/wma':
		case 'audio/mpeg':
			return 'Legacy Audio';
		default:
			return 'File';
		}
	};

	/**
	 * Get the file type from an observation record
	 * @param {Object} pObservation - The observation record
	 * @return {String} - The file type of the observation
	 */
	getObservationFileType(pObservation)
	{
		if (!pObservation || typeof pObservation !== 'object')
		{
			this.pict.log.error('Invalid observation record');
			return '';
		}
		// return the file type based on the observation type
		switch (pObservation.ObservationType)
		{
		case 'File':
			return pObservation?.Details?.File?.[0]?.Datum?.FileMimeType;
		case 'Legacy Image':
			return pObservation?.Details?.Image?.[0]?.Datum?.FileMimeType;
		case 'Legacy Audio':
			return pObservation?.Details?.Audio?.[0]?.Datum?.FileMimeType;
		case 'Legacy Video':
			return pObservation?.Details?.Video?.[0]?.Datum?.FileMimeType;
		default:
			return '';
		}
	}

	/**
	 * Post a new Observation to the server and upload the associated file
	 * @param {Object} pObservationDetails - The details of the observation to post
	 * @param {Object} pFileDetails - The details of the file to upload
	 * @param {String} pDatumType - The type of the datum to upload
	 * @param {Function} onObservationResult - The callback function to call when the observation is posted
	 * @param {Function} onProgressChange - The callback function to call when the progress of the upload changes
	 */
	async uploadObservation(pObservationDetails, pFileDetails, pDatumType, onObservationResult, onProgressChange)
	{
		const tmpURL = `Observation/`;
		const newObservationRecord = await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pObservationDetails,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating observation: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: `<strong>Error creating observation:</strong><br/><em>${pError.message || pError}</em>`,
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating observation: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error creating observation: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: `<strong>Error creating observation:</strong><br/><em>${pBody.Error.message || pBody.Error}</em>`,
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error creating observation: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
				}
			},
		));
		const artifact = newObservationRecord.Details[pDatumType][0];
		const file = pFileDetails.File;
		// show the progress bar update as the file is sent
		await this.uploadWithProgress(`Artifact/Media/${artifact.IDArtifact}/${artifact.Version}`, file, onProgressChange);
		// notify the caller AFTER the binary upload completes, not just after
		// the observation record is created — otherwise the upload panel closes
		// before large files finish transferring (race condition for >100MB files)
		onObservationResult(newObservationRecord);
	}

	/**
	 * Post an update to an Observation to the server.
	 * @param {Object} pObservationDetails - The details of the observation to post
	 * @param {Function} onObservationResult - The callback function to call when the observation is posted
	 */
	async updateObservation(pObservationDetails, onObservationResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `Observation/`;
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pObservationDetails,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating observation: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the observation.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating observation: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating observation: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the observation.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating observation: ` + pBody.Error));
				}
				else if (pBody)
				{
					this.applyUpdatedObservation(pBody);
					resolve(pBody);
					onObservationResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Show a saved observation everywhere the open document displays it: swap it into the document's in-memory
	 * observation list (the Observations panel draws only from that list), redraw the panel's Included list, and
	 * redraw any File selector field or card deck card showing it.
	 * @param {Object} pObservation - the observation record the server returned
	 */
	applyUpdatedObservation(pObservation)
	{
		if (!pObservation || !pObservation.IDObservation)
		{
			return;
		}
		const tmpObservations = this.pict.AppData?.DocumentData?.ReportData?.Observations;
		const tmpIndex = Array.isArray(tmpObservations) ? tmpObservations.findIndex((pCandidate) => pCandidate && pCandidate.IDObservation == pObservation.IDObservation) : -1;
		if (tmpIndex >= 0)
		{
			tmpObservations[tmpIndex] = pObservation;
			if (this.pict.views?.ObservationIncluded)
			{
				this.pict.views.ObservationIncluded.buildIncludedObservationsList(true);
			}
		}
		if (typeof this.pict.providers?.FileSelector?.refreshObservationDisplays === 'function')
		{
			this.pict.providers.FileSelector.refreshObservationDisplays(pObservation);
		}
		if (typeof this.pict.providers?.ObservationCardDeckProvider?.refreshObservationCards === 'function')
		{
			this.pict.providers.ObservationCardDeckProvider.refreshObservationCards(pObservation);
		}
	}

	/**
	 * Upload a file to the server with progress updates.
	 *
	 * Uses HeadlightRestClient.postBinary() so the request participates
	 * in REST interception (offline mode routes to BlobStore).
	 *
	 * @param {string} pURL - The relative URL to upload the file to (e.g. /1.0/Artifact/Media/5/1)
	 * @param {File} pFile - The file to upload
	 * @param {function} fOnProgressChange - Callback with progress ratio (0.0 to 1.0)
	 * @returns {Promise<boolean>} Resolves to true if the upload was successful
	 */
	async uploadWithProgress(pURL, pFile, fOnProgressChange)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.fable.services.HeadlightRestClient.postBinary(
				pURL,
				pFile,
				pFile.type,
				(pError, pBody) =>
				{
					if (pError)
					{
						reject(pError);
					}
					else
					{
						resolve(true);
					}
				},
				fOnProgressChange
			);
		});
	}

	/**
	 * Download a binary file from an Artifact.
	 *
	 * Uses HeadlightRestClient.getBinaryBlob() so the request participates
	 * in REST interception (offline mode retrieves from BlobStore).
	 *
	 * @param {number|string} pArtifactID - The Artifact ID
	 * @param {number|string} pVersion - The Artifact version
	 * @returns {Promise<Blob>} The downloaded file as a Blob
	 */
	async downloadFileFromObservation(pArtifactID, pVersion)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.fable.services.HeadlightRestClient.getBinaryBlob(
				`Artifact/Media/${pArtifactID}/${pVersion}`,
				(pError, pBlob) =>
				{
					if (pError)
					{
						reject(pError);
					}
					else
					{
						resolve(pBlob);
					}
				}
			);
		});
	}

	/**
	 * Get a displayable URL for an observation's media.
	 *
	 * Returns a blob: URL from BlobStore if available offline,
	 * otherwise returns the server URL for online display.
	 *
	 * @param {object} pObservation - The observation record
	 * @param {string} pDatumType - The datum type key (e.g. 'Image', 'Video')
	 * @param {function} fCallback - Callback(pError, pURL)
	 */
	getObservationImageURL(pObservation, pDatumType, fCallback)
	{
		if (!pObservation || !pObservation.Details)
		{
			return fCallback(new Error('No observation or details provided'));
		}

		let tmpDetails = pObservation.Details;
		if (typeof tmpDetails === 'string')
		{
			try
			{
				tmpDetails = JSON.parse(tmpDetails);
			}
			catch (e)
			{
				return fCallback(new Error('Could not parse observation Details'));
			}
		}

		let tmpDatumEntries = tmpDetails[pDatumType];
		if (!Array.isArray(tmpDatumEntries) || tmpDatumEntries.length === 0)
		{
			return fCallback(new Error(`No ${pDatumType} datum entries found`));
		}

		let tmpEntry = tmpDatumEntries[0];
		let tmpIDArtifact = tmpEntry.IDArtifact;
		let tmpVersion = tmpEntry.Version || 1;

		if (!tmpIDArtifact)
		{
			return fCallback(new Error('No IDArtifact on datum entry'));
		}

		let tmpURL = `Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;

		// Try to get the blob through HeadlightRestClient (interceptor will
		// return from BlobStore if offline, or network if online)
		this.pict.fable.services.HeadlightRestClient.getBinaryBlob(tmpURL,
			(pError, pBlob) =>
			{
				if (pError || !pBlob)
				{
					// Fall back to the server URL for direct browser loading
					let tmpServerURL = this.pict.fable.services.HeadlightRestClient.formatUrl(tmpURL, true);
					return fCallback(null, tmpServerURL);
				}

				// Create an Object URL from the blob for display
				try
				{
					let tmpBlobURL = URL.createObjectURL(pBlob);
					return fCallback(null, tmpBlobURL);
				}
				catch (e)
				{
					let tmpServerURL = this.pict.fable.services.HeadlightRestClient.formatUrl(tmpURL, true);
					return fCallback(null, tmpServerURL);
				}
			});
	}

	getLabelTypeFromObservation(pObservation)
	{
		if (pObservation && pObservation.ObservationType)
		{
			const tmpLabelType = this.getObservationMappedDetails(pObservation.ObservationType);
			return tmpLabelType;
		}
		return null;
	}
	/**
	 * Sorts the observations by a given key and order
	 * @param {Array} pObservations - The observations to sort
	 * @param {String} pSortBy - The key to sort by
	 * @param {String} pSortOrder - The order to sort by (asc or desc)
	 * @return {Array} - The sorted observations
	 */
	sortObservationsByKey(pObservations, pSortBy, pSortOrder)
	{
		if (!pObservations || !pObservations.length)
		{
			return pObservations;
		}
		if (!pSortBy)
		{
			this.pict.log.warn('No sort key provided - returning unsorted observations.');
			return pObservations;
		}
		// TODO: Add support for Labels and Datums
		const tmpSortOrder = pSortOrder && pSortOrder.toLowerCase() === 'desc' ? -1 : 1;
		const tmpSortedObservations = pObservations.sort((a, b) =>
		{
			const aValue = a[pSortBy];
			const bValue = b[pSortBy];
			if (aValue < bValue)
			{
				return -1 * tmpSortOrder;
			}
			if (aValue > bValue)
			{
				return 1 * tmpSortOrder;
			}
			return 0;
		});
		return tmpSortedObservations;
	}

	/**
	 * Handles filtering a list of observations based on the filter options passed in.
	 * This is used to apply the filters set in the options to the observation list after we get the search results back from the server.
	 * This is used in cases where a subset list of observations is already provided locally (ex: in the document data) and we want to apply
	 * the filters from options to that list without having to make another call to the server.
	 *
	 * Expected JSON PictForm structure:
	 * "FiltersObject": {
	 *     "Include": {
	 * 			"ObservationTypes": ["Type1", "Type2"],
	 * 			"Descriptions": ["Description1", "Description2"],
	 * 			"LabelTypes": [
	 * 				{
	 * 					"LabelType": "LabelType1",
	 * 					"Values": ["Value1", "Value2"]
	 * 				},
	 * 				{
	 * 					"LabelType": "LabelType2",
	 * 					"Values": ["Value3", "Value4"]
	 * 				}
	 * 			]
	 * 		}
	 * 		"Exclude": {
	 * 			"ObservationTypes": ["Type3", "Type4"],
	 * 			"Descriptions": ["Description3", "Description4"],
	 * 			"LabelTypes": [
	 * 				{
	 * 					"LabelType": "LabelType3",
	 * 					"Values": ["Value5", "Value6"]
	 * 				},
	 * 				{
	 * 					"LabelType": "LabelType4",
	 * 					"Values": ["Value7", "Value8"]
	 * 				}
	 * 			]
	 * 		}
	 * }
	 *
	 * @param {Object} pFilters - The filter options to apply to the observation list.
	 * @param {Array} pObservationList - The list of observations to be filtered.
	 * @return {Array} - The filtered list of observations after applying the filters from options.
	 */
	handleFilteringObservationsInList(pFilters, pObservationList)
	{
		// if there are no observations in the list, we can just return the empty list without doing any filtering
		if (!pObservationList || !pObservationList.length)
		{
			return pObservationList;
		}
		if (!pFilters || !Object.keys(pFilters).length)
		{
			this.pict.log.info(`No observation filters set in options. Returning unfiltered observation list.`);
			return pObservationList;
		}
		// apply the filters from options to the observation list. We apply the "Include" filters first, and then the "Exclude" filters second,
		// so that we can first narrow down the list based on what we want to include, and then remove any observations that we want to exclude from that narrowed down list.
		const { Include, Exclude } = pFilters;
		let filteredObservationList = pObservationList;
		// apply the "Include" filters first to narrow down the list
		if (Include && Object.keys(Include).length)
		{
			if (Include.ObservationTypes && Include.ObservationTypes.length)
			{
				filteredObservationList = filteredObservationList.filter((o) => Include.ObservationTypes.includes(o.ObservationType));
			}
			// complex LabelType structure needs to be traversed for observation labels
			if (Include.LabelTypes && Include.LabelTypes.length)
			{
				for (const labelFilter of Include.LabelTypes)
				{
					filteredObservationList = filteredObservationList.filter((o) =>
					{
						if (o.Labels.hasOwnProperty(labelFilter.Type) && o.Labels[labelFilter.Type].length)
						{
							return o.Labels[labelFilter.Type].find((l) => l.TagType === labelFilter.Type && labelFilter.Values.includes(l.Tag));
						}
						return false;
					});
				}
			}
		}
		// then apply the "Exclude" filters to remove any observations we don't want in the list after we've narrowed it down with the "Include" filters
		if (Exclude && Object.keys(Exclude).length)
		{
			if (Exclude.ObservationTypes && Exclude.ObservationTypes.length)
			{
				filteredObservationList = filteredObservationList.filter((o) => !Exclude.ObservationTypes.includes(o.ObservationType));
			}
			// complex LabelType structure needs to be traversed for observation labels
			if (Exclude.LabelTypes && Exclude.LabelTypes.length)
			{
				for (const labelFilter of Exclude.LabelTypes)
				{
					filteredObservationList = filteredObservationList.filter((o) =>
					{
						if (o.Labels.hasOwnProperty(labelFilter.Type) && o.Labels[labelFilter.Type].length)
						{
							return !o.Labels[labelFilter.Type].find((l) => l.TagType === labelFilter.Type && labelFilter.Values.includes(l.Tag));
						}
						return true;
					});
				}
			}
		}
		this.pict.log.info(`Applied observation filters. Original list had ${pObservationList.length} observations, after filtering it has ${filteredObservationList.length} observations.`);
		return filteredObservationList;
	}
}

module.exports = ObservationProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1598:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
/** @typedef {import('./FileHandle.js')} FileHandle */

const PictProvider = require('pict-provider');

class ObservationSetProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/*
	 * Operations:
	 *
	 * Set level:
	 *
	 * Create (doesn't save)
	 * List (with optional filters)
	 * Load (by ID)
	 * Save
	 * Search
	 *
	 * Observation level:
	 *
	 * Add obs
	 * Remove obs
	 *
	 * Should not be here but here for now:
	 *
	 * Save file handle to observation
	 */

	/**
	 * @param {string} pName - The observation set name.
	 * @param {number} [pIDProject] - The project ID the set lives in.
	 *
	 * @return {ObservationSet} - The observation set object.
	 */
	createSet(pName, pIDProject = 0)
	{
		return { Name: pName || 'New Observation Set', Observations: [], IDProject: pIDProject };
	}

	/**
	 * @typedef {Object} ObservationSetFilters
	 * @property {number|string} [IDProject] - The project ID the set lives in.
	 * @property {number|string} [CreatingIDUser] - The ID of user who created the set.
	 * @property {string} [Name] - The name of the observation set.
	 * @property {Array<number>} [ObservationIDs] - Sets that container the specified observation IDs.
	 * @property {number} [Offset] - The offset to start at. Defaults to zero.
	 * @property {number} [PageSize] - The number of items to return. Defaults to 300.
	 * TODO: This is a brainstorm of what this could possibly do
	 */

	/**
	 * @typedef {Object} ObservationSet
	 * @property {number} [IDObservationSet] - The ID of the observation set.
	 * @property {number} [IDProject] - The project ID the set lives in.
	 * @property {string} [Name] - The name of the observation set.
	 * @property {string} [Description] - The description of the set.
	 * @property {number} [CreatingIDUser] - The ID of user who created the set.
	 * @property {Date} [CreateDate] - The date the set was created.
	 * @property {Array<Observation>} Observations - The observations in the set.
	 * TODO: whatever is in here
	 */

	/**
	 * @typedef {any} Observation
	 * TODO: placeholder for now
	 */

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON PUT request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON POST request.
	 *
	 * @param {string} uri - The URI to get.
	 * @param {any} payload - The payload to send (JSON stringified).
	 * @return {Promise<any>} - The response.
	 */
	async _post(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Perform a JSON DELETE request.
	 *
	 * @param {string} entityType - The entity type to delete.
	 * @param {number} entityID - The entity ID to delete.
	 * @return {Promise<any>} - The response.
	 */
	async _del(entityType, entityID)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.deleteEntity(entityType, entityID, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {ObservationSetFilters} pFilters - The filters to apply.
	 * @return {Promise<Array<ObservationSet>>} - The list of observation sets.
	 */
	async listSets(pFilters)
	{
		let filterStanza = '';
		if (pFilters.IDProject)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBV~IDProject~EQ~${pFilters.IDProject}`;
		}
		if (pFilters.CreatingIDUser)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBV~CreatingIDUser~EQ~${pFilters.CreatingIDUser}`;
		}
		if (pFilters.Name)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBV~Name~LK~${encodeURIComponent(`%${pFilters.Name}%`)}`;
		}
		if (pFilters.ObservationIDs)
		{
			if (filterStanza)
			{
				filterStanza += '~';
			}
			filterStanza += `FBL~ObservationIDs~INN~${pFilters.ObservationIDs.join(',')}`;
		}
		let { Offset: offset, PageSize: pageSize } = pFilters;
		if (typeof offset !== 'number' || offset < 0)
		{
			offset = 0;
		}
		if (typeof pageSize !== 'number' || pageSize < 1)
		{
			pageSize = 300;
		}
		if (filterStanza)
		{
			return await this._get(`ObservationSets/FilteredTo/${filterStanza}/${offset}/${pageSize}`);
		}
		return await this._get(`ObservationSets/${offset}/${pageSize}`);
	}

	/**
	 * @param {ObservationSet} pSet - The set to join to a Document by the current IDDocument on AppData.
	 * @return {Promise<void>}
	 */
	async joinSetToDocumentId(pSet)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;

		if (pSet.IDObservationSet && tmpIDDocument)
		{
			const documentJoins = await this._get(`DocumentPolyJoins/By/IDDocument/${tmpIDDocument}`);
			const tmpSetJoinRecord =
			{
				RemoteType: 'ObservationSet',
				IDRemote: pSet.IDObservationSet,
				IDDocument: tmpIDDocument,
			};
			// if no joins yet, then create one
			if (documentJoins.length === 0)
			{
				await this._post(`DocumentPolyJoins`, [ tmpSetJoinRecord ]);
			}
			else
			{
				// if there is a list of joins, make sure we don't have a join already by the same ID
				const existingJoin = documentJoins.find((x) => x.IDRemote == pSet.IDObservationSet);
				if (!existingJoin)
				{
					await this._post(`DocumentPolyJoins`, [ tmpSetJoinRecord ]);
				}
			}
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
	}

	/**
	 * @param {ObservationSet} pSet - The set to delete the join from a Document by the current IDDocument on AppData.
	 * @return {Promise<void>}
	 */
	async deleteDocumentSetJoin(pSet)
	{
		const tmpIDDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (pSet.IDObservationSet && tmpIDDocument)
		{
			const documentJoins = await this._get(`DocumentPolyJoins/By/IDDocument/${tmpIDDocument}`);
			const existingJoin = documentJoins.find((x) => x.IDRemote == pSet.IDObservationSet);
			if (existingJoin)
			{
				await this._del(`DocumentPolyJoins`, existingJoin.IDDocumentPolyJoin);
			}
		}
	}

	/**
	 * @param {ObservationSet} pIDDocument - The set to get the joins from a Document by the current IDDocument on AppData.
	 * @return {Promise<Array<any>>} - The list of "ObservationSet" joins for the current document.
	 */
	async getDocumentSetJoinList(pIDDocument)
	{
		const IDDocument = pIDDocument ?? this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (IDDocument)
		{
			// filter out any joins that are not "ObservationSet" type
			return await this._get(`DocumentPolyJoins/FilteredTo/FBV~IDDocument~EQ~${IDDocument}~FBV~RemoteType~EQ~ObservationSet`);
		}
		return Promise.resolve([]);
	}

	/**
	 * @param {ObservationSet} pIDDocument - The set to get the joins from a Document by the current IDDocument on AppData.
	 * @return {Promise<Array<any>>} - The list of "ObservationSet" joins for the current document.
	 */
	async getObservationSetsForDocument(pIDDocument)
	{
		const IDDocument = pIDDocument ?? this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
		if (IDDocument)
		{
			// filter out any joins that are not "ObservationSet" type
			const tmpExistingJoins = await this.getDocumentSetJoinList(IDDocument);
			if (tmpExistingJoins && tmpExistingJoins.length > 0)
			{
				return this._get(`ObservationSets/FilteredTo/FBL~IDObservationSet~INN~${tmpExistingJoins.map((x) => x.IDRemote).join(',')}`);
			}
		}
		return Promise.resolve([]);
	}

	/**
	 * NOTE: Does not save the observation records; save them first!
	 *
	 * @param {ObservationSet} pSet - The set to save.
	 * @return {Promise<ObservationSet>} - The saved set.
	 */
	async saveSet(pSet)
	{
		// check for passing the wrong thing
		if (typeof pSet !== 'object' || !pSet)
		{
			if (typeof pSet === 'string' || typeof pSet === 'number')
			{
				this.pict.log('warn', 'saveSet is expecting a passed "set", not an ID! You passed:', pSet);
				return this.loadSet(pSet);
			}
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		try
		{
			const setObservations = pSet.Observations || [];
			let setToSave = Object.assign({}, pSet);
			delete setToSave.Observations;
			if (!pSet.IDObservationSet && !this.debouncedSet)
			{
				this.debouncedSet = this._put(`ObservationSet/Upsert`, setToSave);
				setToSave = Object.assign({}, await this.debouncedSet);
			}
			else if (!pSet.IDObservationSet && this.debouncedSet)
			{
				setToSave = Object.assign(await this.debouncedSet, pSet);
			}
			else
			{
				setToSave = await this._put(`ObservationSet/Upsert`, setToSave);
				const existingObservations = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${setToSave.IDObservationSet}`);
				const desiredObservations = setObservations.map((x) => x.IDObservation).filter((x) => x > 0);
				const toAdd = setObservations.filter((x) => !existingObservations.find((y) => y.IDObservation === x.IDObservation)).map((x) => ({ IDObservation: x.IDObservation, IDObservationSet: setToSave.IDObservationSet }));
				const toRemove = existingObservations.filter((x) => !desiredObservations.includes(x.IDObservation));

				for (const obs of toRemove)
				{
					await this._del('ObservationSetObservationJoin', obs.IDObservationSetObservationJoin);
				}
				await this._post(`ObservationSetObservationJoins`, toAdd);
			}
			Object.assign(pSet, setToSave);
		}
		finally
		{
			this.debouncedSet = null;
			// join to document if it's not already joined
			this.joinSetToDocumentId(pSet);
			this.pict.providers.UploadTracking.untrackUpload(uploadID);
			return pSet;
		}
	}

	async loadSet(pIDObservationSet)
	{
		const set = await this._get(`ObservationSet/${pIDObservationSet}`);
		const joins = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${pIDObservationSet}`);
		set.Observations = await this._get(`Observations/FilteredTo/FBL~IDObservation~INN~${joins.map((x) => x.IDObservation).join(',')}`);
		return set;
	}

	async loadSetObservations(pIDObservationSet)
	{
		const set = await this.loadSet(pIDObservationSet);
		return set.Observations;
	}

	async isIncludedInSet(pIDObservationSet, pIDObservation)
	{
		const setObservations = await this.loadSetObservations(pIDObservationSet);
		return setObservations.map((o) => o.IDObservation).includes(parseInt(pIDObservation));
	}

	/**
	 * @param {ObservationSet} pSet - The set to add the observation to.
	 * @param {Observation} pObservation - The observation to add.
	 * @param {Number} pSetID - An ObservationSet ID to add the observation to.
	 * @return {Promise<ObservationSet>} - The set with the observation added.
	 */
	async addObservation(pSet, pObservation, pSetID)
	{
		if (!pObservation)
		{
			throw new Error('Observation is required');
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		if (!pSet && pSetID)
		{
			pSet =
			{
				IDObservationSet: pSetID,
				Observations: [],
			};
		}
		if (!pSet.Observations)
		{
			pSet.Observations = [];
		}
		if (pSet.IDObservationSet && pObservation.IDObservation)
		{
			const joins = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${pSet.IDObservationSet}~FBV~IDObservation~EQ~${pObservation.IDObservation}`);
			if (joins.length > 0) // already joined
			{
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
				return pSet;
			}
			await this._post(`ObservationSetObservationJoin`, { IDObservation: pObservation.IDObservation, IDObservationSet: pSet.IDObservationSet });
		}

		pSet.Observations.push(pObservation);
		if (this.pict.providers.MediaRegistry && this.pict.providers.DocumentProvider)
		{
			this.pict.providers.MediaRegistry.updateNamespacesByIDObservationSet(pSet.IDObservationSet, pSet.Observations);
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
		return pSet;
	}

	/**
	 * @param {ObservationSet} pSet - The set to remove the observation from.
	 * @param {Observation} pObservation - The observation to remove.
	 * @return {Promise<ObservationSet>} - The set with the observation removed.
	 */
	async removeObservation(pSet, pObservation)
	{
		if (!pObservation)
		{
			throw new Error('Observation is required');
		}
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		if (!pSet.Observations)
		{
			pSet.Observations = [];
		}

		const index = pSet.Observations.findIndex((x) => x === pObservation);
		if (index >= 0)
		{
			pSet.Observations.splice(index, 1);
		}
		if (pSet.IDObservationSet && pObservation.IDObservation)
		{
			const joins = await this._get(`ObservationSetObservationJoins/FilteredTo/FBV~IDObservationSet~EQ~${pSet.IDObservationSet}~FBV~IDObservation~EQ~${pObservation.IDObservation}`);
			if (joins.length > 0)
			{
				await this._del(`ObservationSetObservationJoin`, joins[0].IDObservationSetObservationJoin);
			}
		}
		if (this.pict.providers.MediaRegistry && this.pict.providers.DocumentProvider)
		{
			this.pict.providers.MediaRegistry.updateNamespacesByIDObservationSet(pSet.IDObservationSet, pSet.Observations);
		}
		this.pict.providers.UploadTracking.untrackUpload(uploadID);
		return pSet;
	}

	/**
	 * @param {Observation} pObservation - The observation to save.
	 * @param {FileHandle} pFileHandle - The file handle to save
	 * @return {Promise<Observation>} - The saved observation.
	 */
	async createObservationFromFileHandle(pObservation, pFileHandle)
	{
		throw new Error('Not implemented');
		//FIXME: implement
		// 1. create obs
		// 2. upload file
		// 3. create tracking relationship / metadata (needs definition)
	}
}

module.exports = ObservationSetProvider;
module.exports.default_configuration = {};

},{"headlight-rest-client":20,"pict-provider":552}],1599:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class PlantProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Plant by ID
	 * @param {String|Number} pPlantID - The Plant ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getPlantByID(pPlantID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pPlantID)
			{
				this.pict.log.error('No Plant ID provided.');
				return reject(new Error('No Plant ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`ProductionPlant/${pPlantID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Plant: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = PlantProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1600:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProducerProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Producer by ID
	 * @param {String|Number} pProducerID - The Producer ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getProducerByID(pProducerID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProducerID)
			{
				this.pict.log.error('No Producer ID provided.');
				return reject(new Error('No Producer ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Organization/${pProducerID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Producer: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Producers
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 */
	getProducers()
	{
		return new Promise((resolve, reject) =>
		{
			// NOTE: Producers are a subset of Organizations set by the Type field
			const tmpSearchQuery = {
				filters: [
					{
						field: 'Type',
						comparator: 'EQ',
						target: 'Producer',
					},
				],
				orderBy: 'Name',
				orderDirection: 'ASC',
			};

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpSearchQuery.filters.push({
					field: 'IDCustomer',
					comparator: 'EQ',
					target: this.pict.AppData?.DocumentData?.ReportData?.IDCustomer || 0,
				});
			}

			const tmpURL = `Organizations/` + this.pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery);

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Producers list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ProducerProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1601:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProductProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Product by ID
	 * @param {String|Number} pProductID - The Product ID to search for
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getProductByID(pProductID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProductID)
			{
				this.pict.log.error('No Product ID provided.');
				return reject(new Error('No Product ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Product/${pProductID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Product: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ProductProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1602:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
// @ts-ignore
const PictProvider = require('pict-provider');

class ProjectFileProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Get the parent folder IDs for a given folder
	 * @param {Object} folder - The folder object to get the parent IDs for
	 * @param {Object} currentDataStructureList - The current data structure list to check against
	 * @param {Array} parentFolderIDs - The array of parent folder IDs to populate
	 * @return {Array} - An array of parent folder IDs
	 */
	getParentFolderIDs(folder, currentDataStructureList, parentFolderIDs = [])
	{
		if (folder.ParentIDProjectFileFolder === 0)
		{
			return parentFolderIDs;
		}
		if (folder.ParentIDProjectFileFolder > 0 && !currentDataStructureList.ProjectFileFolders.find( (x) => x.IDProjectFileFolder === folder.ParentIDProjectFileFolder))
		{
			//console.log('[DEBUG] getParentIDs', folder.ParentIDProjectFileFolder, parentFolderIDs, currentFolderList);
			parentFolderIDs.push(folder.ParentIDProjectFileFolder);

			const parentFolder = currentDataStructureList.AllProjectFileFolders.find((x) => x.IDProjectFileFolder === folder.ParentIDProjectFileFolder);
			if (Object.keys(parentFolder).length !== 0)
			{
				//add folder to existing list of ProjectFileFolders
				currentDataStructureList.ProjectFileFolders.push(parentFolder);
				return this.getParentFolderIDs(parentFolder, currentDataStructureList, parentFolderIDs);
			}
			else
			{
				this.log.error(`Parent folder with ID ${folder.ParentIDProjectFileFolder} not found for folder ${folder.Name}`);
				return parentFolderIDs;
			}
		}
	}

	getProjectFolderMapKey(pIDProjectFolder)
	{
		return `ProjectFolderMap~${pIDProjectFolder}`;
	}

	/**
	 * @param {string} rawString with special characters to escape
	 * @description Escapes special characters in a string to be used in a regular expression.
	 * @return {string} - The escaped string.
	 */
	escapeRegExp(rawString)
	{
		return rawString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	/**
	 * Get the project files and return in a structured format
	 * @param {Number} pIDProject - ID of the project being searched in
	 * @param {Object} pSearchFilters - Object containing the search filters, e.g. SearchText for files and SearchFolder for folders
	 * @param {Function} fCallback
	 */
	getProjectFilesDataStructure(pIDProject, pSearchFilters, fCallback)
	{
		this.pict.log.info(`I am getting project files for project ${pIDProject}`);

		let fileMeadowQuery = `FBV~IDProject~EQ~${pIDProject}`;

		const folderMeadowQuery = `FBV~IDProject~EQ~${pIDProject}`;
		const hasFolderSearchFilters = pSearchFilters?.SearchFolder && pSearchFilters?.SearchFolder.trim().length > 0;
		if (pSearchFilters?.SearchText && pSearchFilters?.SearchText.trim().length > 0)
		{
			fileMeadowQuery = `FBV~IDProject~EQ~${pIDProject}~FBV~Name~LK~%25${encodeURIComponent(pSearchFilters.SearchText.replace(/\*/g, '%25'))}%25`;
		}

		// @ts-ignore
		const tmpAnticipate = this.pict.newAnticipate();

		const tmpProjectFileDataStructureState = {};

		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Expire the cache for ProjectFile
				this.pict.EntityProvider?.recordSetCache?.['ProjectFile']?.expire(`FBV~IDProject~EQ~${pIDProject}`);
				this.pict.EntityProvider.getEntitySet('ProjectFile', fileMeadowQuery,
					function(pError, pRecordSet)
					{
						if (pError)
						{
							this.log.error(`Error downloading project files for project ${pIDProject}: ${pError}`, pError);
							return fCallback(pError);
						}

						// for (let i = 0; i < pRecordSet.length; i++)
						// {
						// 	this.pict.log.info(`I found project file number ${i} for project ${pIDProject}: ${JSON.stringify(pRecordSet[i])}`);
						// }

						tmpProjectFileDataStructureState.ProjectFiles = pRecordSet;

						return fNext();
					}.bind(this));
			}.bind(this));


		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Expire the cache for ProjectFileFolder
				this.pict.EntityProvider?.recordSetCache?.['ProjectFileFolder']?.expire(`FBV~IDProject~EQ~${pIDProject}`);
				//folderMeadowQuery is set to Project ID and then filtered later to match the Name
				this.pict.EntityProvider.getEntitySet('ProjectFileFolder', folderMeadowQuery,
					function(pError, pRecordSet)
					{
						if (pError)
						{
							this.log.error(`Error downloading project file folders for project ${pIDProject}: ${pError}`, pError);
							return fCallback(pError);
						}

						// for (let i = 0; i < pRecordSet.length; i++)
						// {
						// 	this.pict.log.info(`I found project file folder number ${i} for project ${pIDProject}: ${JSON.stringify(pRecordSet[i])}`);
						// }

						tmpProjectFileDataStructureState.AllProjectFileFolders = pRecordSet;
						if (!hasFolderSearchFilters)
						{
							// if there are no search filters, just return all folders
							tmpProjectFileDataStructureState.ProjectFileFolders = pRecordSet;
							return fNext();
						}
						const regex = new RegExp(this.escapeRegExp(pSearchFilters.SearchFolder), 'i'); // 'i' flag for case-insensitive matching
						tmpProjectFileDataStructureState.ProjectFileFolders = pRecordSet.filter((folder) => regex.test(folder.Name));
						return fNext();
					}.bind(this));
			}.bind(this));

		//retrieve parent folders and add to the data structure
		tmpAnticipate.anticipate(
			function(fNext)
			{
				if (hasFolderSearchFilters)
				{
					const tmpParentFolderIDs = [];
					for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFileFolders.length; i++)
					{
						const tmpFolder = tmpProjectFileDataStructureState.ProjectFileFolders[i];
						// if the folder has a parent and Not in ProjectFolderMap, add to list
						if (tmpFolder.ParentIDProjectFileFolder > 0 && !tmpParentFolderIDs.includes(tmpFolder.ParentIDProjectFileFolder))
						{
							tmpParentFolderIDs.push(this.getParentFolderIDs(tmpFolder, tmpProjectFileDataStructureState, tmpParentFolderIDs));
						}
					}

					if (tmpParentFolderIDs.length > 0)
					{
						//sort the project files as the above array is not built in any order
						tmpProjectFileDataStructureState.ProjectFileFolders.sort((a, b) =>
						{
							return a.IDProjectFileFolder - b.IDProjectFileFolder;
						});
						return fNext();
					}
					else
					{
						// No missing parent folders
						return fNext();
					}
				}
				else
				{
					// No missing parent folders
					return fNext();
				}
			}.bind(this));

		/*
		* This is where we take both project files and folders and merge them
		* into the same data structure to make them simpler to deal with on
		* the UI.
		*
		* The data structure will be an array of objects.
		* Each object will have the following properties:
		* - Name - the file name
		* - Type - the type of the object (Folder or any of the the file types appropriate to the Headlight Program)
		* - Size - the size of the object (in bytes -- would be awesome to show how large folders are but we can make that advanced thing later)
		* - Date - the date of the object
		* - Entity - A simple string reference to which entity this came from (ProjectFile or ProjectFileFolder)
		* - ID - the ID of the Entity
		*
		* Example Objects:
		* {
		* 	Name: 'MyFile.txt',
		* 	Type: 'File',
		* 	Size: 1234,
		* 	Date: '2014-01-01 12:00:00',
		* 	Entity: 'ProjectFile',
		* 	ID: 1234
		* }
		*
		* {
		* 	Name: 'MyFolder',
		* 	Type: 'Folder',
		* 	Size: 0,
		* 	Date: '2014-01-01 12:00:00',
		* 	Entity: 'ProjectFileFolder',
		* 	ID: 1234,
		*   ParentFolder: 1233
		* }
		*/
		tmpAnticipate.anticipate(
			function(fNext)
			{
				tmpProjectFileDataStructureState.MergedProjectFiles = [];
				// The folder map is going to potentially have circular references
				// This means the data structure won't be serializable.  Too bad.
				tmpProjectFileDataStructureState.ProjectFolderMap = {};

				// First, enumerate all folders and make map of them
				for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFileFolders.length; i++)
				{
					const tmpFolder = tmpProjectFileDataStructureState.ProjectFileFolders[i];

					tmpProjectFileDataStructureState.ProjectFolderMap[this.getProjectFolderMapKey(tmpFolder.IDProjectFileFolder)] = (
						{
							Name: tmpFolder.Name,
							Type: 'Folder',
							Size: 0,
							Date: tmpFolder.UpdateDate,
							Entity: 'ProjectFileFolder',
							IsFolder: 1,
							IsCustomerFolder: 0,
							ID: tmpFolder.IDProjectFileFolder,
							ParentFolder: tmpFolder.ParentIDProjectFileFolder,
							Children: [],
							_RowID: `${tmpFolder.Name.trim().replace(/ /g, '_').replace(/'/g, '')}_${tmpFolder.IDProjectFileFolder}`,
						});
				}

				// Second, build the tree of the folders
				const tmpProjectFileFolderKeys = Object.keys(tmpProjectFileDataStructureState.ProjectFolderMap);
				for (let i = 0; i < tmpProjectFileFolderKeys.length; i++)
				{
					const tmpFolderKey = tmpProjectFileFolderKeys[i];
					const tmpFolder = tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey];

					// Add the folder to its parent
					if (tmpFolder.ParentFolder > 0)
					{
						const tmpParentFolderKey = this.getProjectFolderMapKey(tmpFolder.ParentFolder);
						if (tmpProjectFileDataStructureState.ProjectFolderMap[tmpParentFolderKey])
						{
							tmpProjectFileDataStructureState.ProjectFolderMap[tmpParentFolderKey].Children.push(tmpFolder);
						}
						else
						{
							this.log.error(`Error adding folder ${tmpFolder.Name} to parent ${tmpParentFolderKey}: Parent not found`);
						}
					}
					else
					{
						// This is a root folder
						tmpProjectFileDataStructureState.MergedProjectFiles.push(tmpFolder);
					}
				}

				// Lastly, add the files to the folder on the tree
				for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFiles.length; i++)
				{
					const tmpFile = tmpProjectFileDataStructureState.ProjectFiles[i];

					const tmpFolderKey = this.getProjectFolderMapKey(tmpFile.IDProjectFileFolder);
					if (tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey])
					{
						tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey].Children.push(
							{
								Name: tmpFile.Name,
								Type: tmpFile.FileType,
								Size: 0,
								Date: tmpFile.UpdateDate,
								Entity: 'ProjectFile',
								IsFolder: 0,
								ID: tmpFile.IDProjectFile,
								IDObservation: tmpFile.IDObservation,
								_RowID: `File-${tmpFile.IDProjectFile}_${tmpFile.IDObservation}`,
							});
					}
					// If the file is not in a folder, create a 'Customer Files' folder and add it there
					else if (tmpFile.IDProjectFileFolder === 0)
					{
						const tmpCustomerFilesFolderKey = this.getProjectFolderMapKey(0);
						if (!tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey])
						{
							tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey] = (
								{
									Name: 'Customer Files',
									Type: 'Folder',
									Size: 0,
									Date: tmpFile.UpdateDate,
									Entity: 'ProjectFileFolder',
									IsFolder: 1,
									ID: 0,
									ParentFolder: 0,
									IsCustomerFolder: 1,
									Children: [],
									_RowID: `Customer_Files_0`,
								});
							tmpProjectFileDataStructureState.MergedProjectFiles.push(tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey]);
						}
						tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey].Children.push(
							{
								Name: tmpFile.Name,
								Type: tmpFile.FileType,
								Size: 0,
								Date: tmpFile.UpdateDate,
								Entity: 'ProjectFile',
								IsFolder: 0,
								ID: tmpFile.IDProjectFile,
								IDObservation: tmpFile.IDObservation,
								_RowID: `File-${tmpFile.IDProjectFile}_${tmpFile.IDObservation}`,
							});
					}
					// If the folder is not found, log an error
					else
					{
						this.log.error(`Error adding file ${tmpFile.Name} to folder ${tmpFolderKey}: Folder not found`);
					}
				}

				// hide empty folders if we're searching for a file
				if (pSearchFilters?.SearchText && pSearchFilters?.SearchText.trim().length > 0)
				{
					const doesFolderHaveFiles = (arr) =>
					{
						for (let i = 0; i < arr.length; i++)
						{
							const element = arr[i];

							if (element.IsFolder === 0)
							{
								return element;
							}
							else if (element.Children?.length > 0)
							{
								const foundInNested = doesFolderHaveFiles(element.Children);
								if (foundInNested !== undefined)
								{
									return foundInNested;
								}
								else
								{
									delete arr[i];
								}
							}
						}
						return undefined;
					};

					for (let index = 0; index < tmpProjectFileDataStructureState.MergedProjectFiles.length; index++)
					{
						if (!doesFolderHaveFiles(tmpProjectFileDataStructureState.MergedProjectFiles[index].Children))
						{
							delete tmpProjectFileDataStructureState.MergedProjectFiles[index];
						}
					}
				}
				return fNext(tmpProjectFileDataStructureState.MergedProjectFiles);
			}.bind(this));

		tmpAnticipate.wait(fCallback);
	}


	/**
	 * Get the ProjectFile by ID
	 * @param {Number} pIDProjectFile - The ID of the ProjectFile to get
	 * @param {Function} pCallback - The callback function to call when the ProjectFile is fetched
	 * @return {Promise}
	 * @async
	 */
	async getProjectFileByID(pIDProjectFile, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(`ProjectFile/${pIDProjectFile}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFile: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFile: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	async getProjectFileByIDList(pIDProjectFileList, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(`ProjectFiles/FilteredTo/FBL~IDProjectFile~INN~${pIDProjectFileList.join(',')}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFiles by id list: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFiles by id list: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the ProjectFolders by ProjectID
	 * @param {Number} pIDProject - The ID of the Project to get
	 * @param {Function} pCallback - The callback function to call when the ProjectFolders are fetched
	 * @return {Promise}
	 * @async
	 */
	async getProjectFileFoldersByProjectID(pIDProject, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				const tmpURL = `ProjectFileFolders/By/IDProject/${pIDProject}`;

				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFileFolders: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFileFolders: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the ProjectFileFolder search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileFolderSearchCount({ IDProject: 1234, Name: '2014' }, (count) => { console.log(count); });
	 */
	async getProjectFileFolderSearchCount(pSearchQuery, pCallback)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `ProjectFileFolders/Count${tmpFilter ? `/${tmpFilter}` : ''}`;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the ProjectFileFolder search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileFolderSearchResults({ IDProject: 1234, Name: '2014' }, (results) => { console.log(results); });
	 */
	async getProjectFileFolderSearchResults(pSearchQuery, pCallback)
	{
		const tmpURL = `ProjectFileFolders/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * Get the ProjectFile search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getProjectFileSearchCount(pSearchQuery, pCallback)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `ProjectFiles/Count${tmpFilter ? `/${tmpFilter}` : ''}`;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the ProjectFile search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getProjectFileSearchResults(pSearchQuery, pCallback)
	{
		const tmpURL = `ProjectFiles/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * This method performs an ProjectFile search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @param {Function} pLocalCallback - The callback function to call when the search is complete
	 * @async
	 */
	async performProjectFileSearch(pOptions = {}, pLocalCallback)
	{
		const tmpSearchQuery = {
			filters: [],
			pagination: {
				start: pOptions?.CurrentPage || 1,
				limit: pOptions?.PageSize || 25,
			},
			sort: {
				field: pOptions.SortBy || 'CreateDate',
				direction: pOptions.SortDirection || 'DESC',
			},
		};
		const folderSearchQuery = JSON.parse(JSON.stringify(tmpSearchQuery));

		// handle the search filters
		if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
		{
			tmpSearchQuery.filters.push({
				field: 'Name',
				comparator: 'LK',
				target: pOptions.SearchText,
			});
		}
		if (pOptions?.Projects && pOptions.Projects.length > 0)
		{
			tmpSearchQuery.filters.push({
				field: 'IDProject',
				comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
				target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
			});

			folderSearchQuery.filters.push({
				field: 'IDProject',
				comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
				target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
			});
		}
		if (pOptions?.SearchFolder && pOptions.SearchFolder?.trim().length > 0)
		{
			folderSearchQuery.filters.push({
				field: 'Name',
				comparator: 'LK',
				target: pOptions.SearchFolder,
			});
		}

		try
		{
			// @ts-ignore
			this.getProjectFileFolderSearchCount(folderSearchQuery, (pFolderCountResults) =>
			{
				this.getProjectFileFolderSearchResults(folderSearchQuery, (pFolderSearchResults) =>
				{
					if (pFolderSearchResults)
					{
						tmpSearchQuery.filters.push({
							field: 'IDProjectFileFolder',
							comparator: pFolderSearchResults.length === 1 ? 'EQ' : 'INN',
							target: pFolderSearchResults.length === 1 ? pFolderSearchResults[0].IDProjectFileFolder : pFolderSearchResults.map((x) => x.IDProjectFileFolder),
						});
					}

					this.getProjectFileSearchCount(tmpSearchQuery, (pCountResults) =>
					{
						// get the results
						this.getProjectFileSearchResults(tmpSearchQuery, (pSearchResults) =>
						{
							// if there is a local callback function, call it
							if (pLocalCallback)
							{
								// call the local callback with the results of both the count and the search
								pLocalCallback(pSearchResults, pCountResults);
							}
						});
					});
				});
			});
		}
		catch (error)
		{
			this.pict.log.error('Error performing ProjectFile search:', error);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error performing ProjectFile search:</strong><br/><em>${error.message || error}</em>`,
				type: 'is-danger',
			});
			// if there is a local callback function, call it
			if (pLocalCallback)
			{
				pLocalCallback([]);
			}
		}
	}

	/**
	 * Post an update to a Project File to the server.
	 * @param {Object} pProjectFile - The updated ProjectFile to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async updateProjectFile(pProjectFile, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFile/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pProjectFile,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating file: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating file: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating file: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating file: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Add a new Project File to the server.
	 * @param {Object} pProjectFile - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async addProjectFile(pProjectFile, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFile/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pProjectFile,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding file: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding file: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error adding file: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding file: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Add a new Project Folder to the server.
	 * @param {Object} pProjectFileFolder - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async addProjectFolder(pProjectFileFolder, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFileFolder/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pProjectFileFolder,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding folder: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding folder: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error adding folder: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding folder: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Post an update to a Project Folder to the server.
	 * @param {Object} pProjectFileFolder - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async updateProjectFolder(pProjectFileFolder, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFileFolder/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pProjectFileFolder,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating folder: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating folder: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating folder: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating folder: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Opens the observation panel for the user to select/search/upload images.
	 * @param {number} pIDProjectFile - The view object.
	 * @param {Object} pCallback - The input object.
	 * @return {void}
	 */
	handleProjectFileDeletion(pIDProjectFile, pCallback)
	{
		if (!pIDProjectFile)
		{
			this.pict.log.error('IDProjectFile was not passed.');
			return;
		}
		// @ts-ignore
		this.pict.HeadlightRestClient.deleteEntity('ProjectFile', pIDProjectFile, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete project file.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete project file!',
					type: 'is-danger',
				});
				pCallback(pError);
			}
			else
			{
			this.pict.log.info('Project File deleted successfully.', pBody);
			if (typeof pCallback === 'function')
			{
				pCallback(pBody);
			}
			}
		});
	}

	/**
	 * Opens the observation search panel for the user to select/search/ observations to add as project files.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pTarget - The target of the observation addition.
	 * @return {void}
	 */
	openSearchPanel(pView, pInput, pTarget)
	{
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterDocumentJoinCallback = async (observationResult) =>
		{
			await this.pict.views.ProjectFileSearch.addObservationToProjectFolderRecord(observationResult);
		};
		pView.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', async () =>
		{
			if (pTarget && pTarget === 'add-to-folder')
			{
				// start at the upload tab
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				// set the target for the observation panel to update
				pView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(pView.Hash, pInput, pInput, 'add-to-folder');
				//FIXME: mirgate this to call the new entry point to encapsulate this state
				this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Folder';
				this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Folder';
			}
			if (pTarget && pTarget === 'add-to-root')
			{
				// start at the upload tab
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				// set the target for the observation panel to update
				pView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(pView.Hash, pInput, pInput, 'add-to-root');
				//FIXME: mirgate this to call the new entry point to encapsulate this state
				this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Project Root';
				this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Project Root';
			}
		});
	}
}

module.exports = ProjectFileProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1603:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProjectProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Project by ID
	 * @param {String|Number} pProjectID - The Project ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getProjectByID(pProjectID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProjectID)
			{
				this.pict.log.error('No Project ID provided.');
				return reject(new Error('No Project ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Project/${pProjectID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Project: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Projects
	 * @param {string} pCustomerID - The Customer ID to search for
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getProjects(pCustomerID)
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Projects';

			// Filter by customer ID if provided
			if (pCustomerID)
			{
				tmpURL = `Projects/By/IDCustomer/${pCustomerID}`;
			}

			// Make the API call
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Projects list.', pError);
					return reject(pError); // Reject the promise in case of error
				}
				resolve(pBody); // Resolve with the retrieved data
			});
		});
	}
}

module.exports = ProjectProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1604:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */

/**
 * Entities whose "Printable" manifests describe a QR label layout.
 */
const _PrintableManifestEntities = [ 'Sample', 'Location' ];

/**
 * The product that OWNS the printable manifests (`LIMS-Sample-Printable` et al).
 *
 * They are LIMS configuration, not per-consumer configuration: a form document, the panels and the LIMS
 * app all print the same customer's label. Left unset the loader would look them up under the hosting
 * app's own product (e.g. `HeadlightDynamicForm-Sample-Printable`), find nothing, and silently fall back
 * to the built-in layout. Duplicating the manifests per product would mean keeping N copies of one
 * customer's label in sync, so the product is named here instead.
 */
const _PrintableManifestProduct = 'LIMS';

const libManifestPackagingService = require('manifest-packaging-service');

const PictProvider = require('pict-provider');
const QRCodeCodec = require('headlight-qrcode/source/Headlight-QRCode-Codec.js');

const _LabelCodec = new QRCodeCodec();

// The "tall" label: a fixed drawing width, the code's share of it, the characters per printed line (which sets the
// text size), and how many printed lines one value may wrap onto before it is cut with "...".
const TALL_LABEL_WIDTH = 1200;
const TALL_LABEL_CODE_SHARE = 0.72;
const TALL_LABEL_LINE_LENGTH = 26;
const TALL_LABEL_MAX_WRAP_LINES = 3;

// Inline data URI for the HeadLight logo so QR code generation works in
// offline (iOS WKWebView) contexts where /images/ paths are unavailable.
//TODO: this is to support offline but is a bit hard to support - see if we can make this more robust
const HEADLIGHT_LOGO_BLACK_DATA_URI = 'data:image/png;base64,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';

class Dialog
{
	/**
	 *
	 * @param {Object} options
	 * @param {Object} options.body - The body of the dialog, can be a string or an HTMLElement
	 * @param {boolean} [options.closeOnBackdropClick=true] - Whether the dialog should close when the backdrop is clicked
	 */
	constructor(options)
	{
		this._dialog = document.createElement('div');
		Object.assign(this._dialog.style, {
			display: 'none',
			position: 'fixed',
			left: '50%',
			marginLeft: '-150px',
			width: '300px',
			top: '100px',
			zIndex: 1001,
			background: 'white',
		});

		this._dropShadow = document.createElement('div');
		Object.assign(this._dropShadow.style, {
			display: 'none',
			position: 'fixed',
			left: '0',
			top: '0',
			right: '0',
			bottom: '0',
			zIndex: 1000,
			backdropFilter: 'grayscale(1) blur(3px)',
			background: '#333333ba',
		});
		document.body.appendChild(this._dialog);
		document.body.appendChild(this._dropShadow);

		if (options.closeOnBackdropClick !== false)
		{
			this._dropShadow.addEventListener('click', () => this.hide());
		}

		if (typeof options.body === 'string')
		{
			this._dialog.innerHTML = options.body;
		}
		else if (options.body instanceof HTMLElement)
		{
			this._dialog.appendChild(options.body);
		}
		else
		{
			throw new Error('Unsupported options.body type: ' + typeof options.body);
		}
	}

	/**
	 * Locks scroll while dialog is open
	 * @return {void}
	 */
	lockScroll()
	{
		if (document.body.getAttribute('scroll-locked') === 'true')
		{
			return;
		}
		document.body.setAttribute('scroll-locked', 'true');
		document.body.style.overflow = 'hidden';
		document.body.style.position = 'relative';
	}

	/**
	 * Unlocks scroll when dialog is closed.
	 */
	unlockScroll()
	{
		document.body.removeAttribute('scroll-locked');
		document.body.style.overflow = '';
		document.body.style.position = '';
	}

	/**
	 * Shows the popup dialog.
	 */
	show()
	{
		this._dialog.style.display = 'block';
		this._dropShadow.style.display = 'block';
		this.lockScroll();
	}

	/**
	 * Hides the popup dialog.
	 */
	hide()
	{
		this._dialog.style.display = 'none';
		this._dropShadow.style.display = 'none';
		this.unlockScroll();
	}

	/**
	 * Destroys the popup dialog.
	 */
	destroy()
	{
		if (this._dialog.parentElement)
		{
			this._dialog.parentElement.removeChild(this._dialog);
		}
	}
}

// Documentation: https://scanapp.org/html5-qrcode-docs/docs/apis

class QRCodeProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this._dialog;
		this._qrCodeScanner;
		this._hiddenLayer;
		this._canvas;
		this._qrCodeContainer;
		this._printFrame;

		this.typeConfig = {};

		this.readerActive = false;

		this.printStyle = pOptions.printStyle || 'thin';
		this.customerLogo = null;
		this.getHeadlightLogo = null;

		this.lastCameraEvent =
		{
			time: Date.now(),
			content: '',
		};

		this.cameraKey = '';

		this.logosInitialized = false;
	}

	onAfterInitializeAsync(fCallback)
	{
		super.onAfterInitializeAsync((pError) =>
		{
			this.initializeLogos().finally(() => fCallback(pError));
		});
	}

	onBeforeLoadDataAsync(fCallback)
	{
		super.onBeforeLoadDataAsync((pError) =>
		{
			// The logos are only needed when a label prints; start loading them but do not hold up the document.
			this.initializeLogos();
			return fCallback(pError);
		});
	}

	onInitialize()
	{
		if (this.pict.providers.SessionProvider)
		{
			this.pict.providers.SessionProvider.onSessionChange((pNewSession) =>
			{
				delete this.headlightLogo;
				delete this.customerLogo;
				delete this.logosInitialized;
				delete this._logosPromise;
			});
		}
		return super.onInitialize();
	}

	/**
	 * Load the HeadLight and customer logos used on printed labels. Safe to call repeatedly: one load
	 * is shared, and the print paths await it so a label never draws before the logos arrive.
	 * @return {Promise<void>}
	 */
	initializeLogos()
	{
		if (!this.pict.PictApplication.loggedIn || this.logosInitialized)
		{
			return Promise.resolve();
		}
		if (this._logosPromise)
		{
			return this._logosPromise;
		}
		this.headlightLogo = new Image();
		this.headlightLogo.src = HEADLIGHT_LOGO_BLACK_DATA_URI;
		this._logosPromise = this.getCustomerLogo().then((res) =>
		{
			if (res)
			{
				this.customerLogo = new Image();
				this.customerLogo.src = `/1.0/Customer/Logo/${ res.IDCustomer }`;
				this.logosInitialized = true;
			}
		}).catch((err) =>
		{
			console.log('[QRCodeProvider] Error fetching customer logo, leaving logo field empty.');
		}).finally(() =>
		{
			delete this._logosPromise;
		});
		return this._logosPromise;
	}

	/**
	 * The current session, from the SessionProvider's copy when it has one (no extra CheckSession round trip).
	 * @return {Promise<any>}
	 */
	async _resolveSession()
	{
		const tmpSessionProvider = this.pict.providers?.SessionProvider;
		if (tmpSessionProvider && (typeof tmpSessionProvider.getSession === 'function'))
		{
			const tmpSession = await tmpSessionProvider.getSession();
			if (tmpSession)
			{
				return tmpSession;
			}
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('CheckSession', (pError, pResult) => (pError ? reject(pError) : resolve(pResult)));
		});
	}

	async getCustomerLogo()
	{
		const tmpSession = await this._resolveSession();
		const customerID = tmpSession?.CustomerID || tmpSession?.IDCustomer;
		return new Promise((resolve, reject) =>
		{
			let tmpRequestOptions = (
				{
					url: this.pict.HeadlightRestClient.formatUrl(`Customer/Logo/${ customerID }`),
				});
			tmpRequestOptions = this.pict.HeadlightRestClient._prepareRequestOptions(tmpRequestOptions);
			this.pict.HeadlightRestClient.restClient.getRawText(tmpRequestOptions, (pError, pResponse, pBody) =>
			{
				pError = this.pict.HeadlightRestClient._checkForError(pError, pResponse, pBody);
				if (pError)
				{
					reject(pError);
				}
				resolve(pResponse.statusCode === 200 ? { IDCustomer: customerID, Body: pBody } : null);
			});
		});
	}

	generateNewQRCode(sample)
	{
		const tmpCurrentUser = this.pict.AppData?.CurrentUser || {};
		return this.pict.fable.services.HeadlightQRCodeHash.mintForCustomer(
			{
				IDProject: sample?.IDProject,
				IDUser: tmpCurrentUser.UserID,
				ExternalSyncGUID: this.pict.AppData?.FullUserRecord?.ExternalSyncGUID,
				CustomerID: tmpCurrentUser.CustomerID,
				TimeZone: tmpCurrentUser.Timezone,
			});
	}

	/**
	 * Get an entity by its QRCode (label printing).
	 * @param {String} entity
	 * @param {String} qr
	 * @return {Promise<Object|Error>}
	 */
	getByQRCode = async (entity, qr) =>
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${ encodeURIComponent(entity) }s/By/QRCode/${ encodeURIComponent(qr) }`, (error, result) =>
			{
				if (error)
				{
					reject(error);
				}
				else
				{
					// Records sharing a code resolve to the most recently updated, as HeadlightQR.resolve and the links app do.
					if (Array.isArray(result) && result.length > 1)
					{
						console.warn(`[QRCodeProvider] ${ result.length } ${ entity } records share the code "${ qr }"; using the most recently updated.`);
						result = result.slice().sort((pA, pB) => String(pB.UpdateDate || '').localeCompare(String(pA.UpdateDate || '')));
					}
					if (entity === 'Location' && result?.[0]?.ParentIDLocation)
					{
						this.pict.HeadlightRestClient.getJSON(`${ entity }s/By/IDLocation/${ result[0].ParentIDLocation }`, (error, parentResult) =>
						{
							if (error)
							{
								reject(error);
							}
							else
							{
								if (parentResult.length)
								{
									result[0].ParentLocation = parentResult[0];
								}
								resolve(result[0]);
							}
						});
					}
					else if (result.length)
					{
						resolve(result[0]);
					}
					else
					{
						reject(new Error('No Item found with that QR Code.'));
					}
				}
			});
		});
	};

	/**
	 * Generic "get entity by ID" function.
	 * @param {String} entity - the type of entity
	 * @param {Number} ID -  the id of the entity
	 */
	getByID = async (entity, ID) =>
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${ entity }/${ ID }`, (error, result) =>
			{
				if (error)
				{
					reject(error);
				}
				else
				{
					resolve(result);
				}
			});
		});
	};

	/**
	* @typedef {object} QRCodeOptions
	* @property {string} [previewID] - The ID of a DOM element to render the preview into.
	* @property {boolean} [raw] - if true, code is used as is and not put in a URL
	* @property {string} [type] - If passed, the passed type will be included in the qr code url
	* @property {string} [printStyle] - the style of label to print, current options are 'thin', 'wide' and 'tall'
	* @property {number} [size] - same as width and height
	* @property {string[]} [footers] - additional text to print below the QR code
	* @property {string[]} [headers] - additional text to print above the QR code
	* @property {string[]} [bigRows] - lists footer rows that should be displayed in "bigger" text
	*/

	/**
	 * A code the camera read: the app's HeadlightQR provider decodes, looks up and hands it to whichever scan
	 * handler is active, exactly as it does for the keyboard scanner.
	 * @param {string} pText
	 */
	receiveCameraScan(pText)
	{
		const tmpQR = this.pict.providers.HeadlightQR;
		if (!tmpQR)
		{
			console.warn('[QRCodeProvider] Camera scan ignored: this app has no HeadlightQR provider.');
			return;
		}
		tmpQR.receiveScan(pText, { Source: 'camera' });
	}

	/**
	 * Passthrough to the "scanQRCode" method.
	 * @param {String} id
	 */
	async scan(id)
	{
		return await this.scanQrCode(id);
	}

	/**
	 * Opens a QR scanner camera instance onto an element with a given id.
	 * @param {String} id
	 * @param {Object} [options] - options for the scanner
	 */
	async openScanner(id, options = {})
	{
		// A new camera session: results from an earlier opening are ignored.
		this.cameraKey = `${ Date.now() }`;
		this.lastCameraEvent = { time: Date.now(), content: '' };
		return await this.scanQrCode(id, true, options);
	}

	/**
	 * Closes any open QR Scanner camera instance.
	 */
	async closeScanner()
	{
		this.cameraKey = '';
		if (!this._qrCodeScanner)
		{
			return;
		}
		return await new Promise((resolve, reject) =>
		{
			async function stopper(tries)
			{
				// @ts-ignore
				const localThis = _Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode;
				if (!localThis.canvasElement)
				{
					if (!tries || tries < 10)
					{
						console.log('deferring scanner stop: ', tries);
						setTimeout(()=>
						{
							stopper(tries ? tries + 1 : 1);
						}, 200);
					}
					else
					{
						console.log('Failed to stop camera, exhausted retries.');
						resolve();
					}
					return;
				}
				// @ts-ignore
				if (_Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode && _Pict.providers.QRCodeProvider._qrCodeScanner?.html5Qrcode?.stateManagerProxy?.isScanning())
				{
					// @ts-ignore
					await _Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode.stop();
				}
				resolve();
			};
			stopper();
		});
	}

	/**
	 * @param {string} code
	 * @param {QRCodeOptions} [options]
	 * @return {string} - base64 encoded image
	 */
	create(code, options = {})
	{
		const text = options.raw ? code : `${this.pict.providers.UtilityProvider.buildLinksUrl()}${ options.type ? `/${ options.type }` : '' }/qr/${encodeURIComponent(code)}`;
		return this.generateQRCodeImage({
			text: text,
			width: options.size || 256,
			height: options.size || 256,
		});
	}

	/**
	 * Formats strings for the "wide" print layout.
	 * @param {Array<String>} displayStrings
	 * @return {Array<String>}
	 */
	formatStringsForPrinting(displayStrings)
	{
		const finaldisplayStrings = [];
		displayStrings.forEach((s) =>
		{
			const tokens = s.split('COMPUTED_COLUMN');
			if (!tokens?.[1])
			{
				finaldisplayStrings.push(s.length > 80 ? s.substring(0, 77) + '...' : s);
				return;
			}
			if (tokens[0].length > 35)
			{
				tokens[0] = tokens[0].substring(0, 35) + '...';
			}
			if (tokens[1]?.length > 35)
			{
				tokens[1] = tokens[1].substring(0, 35) + '...';
			}
			finaldisplayStrings.push(`${ tokens[0].padEnd(40) }${ tokens[1] }`);
		});
		return finaldisplayStrings;
	}

	/**
	 * Using a Sample record, constructs the set of information to use while printing. Used for the "wide" template.
	 * @param {Object} record
	 * @return {Promise<Array<String>>}
	 */
	async getSamplePrintablesWide(record)
	{
		const formatLocation = (city, state, country) =>
		{
			if (!city && !state && !country)
			{
				return 'N/A';
			}
			else if (city && state)
			{
				return `${ city }, ${ state }`;
			}
			else if ((city && country) || (state && country))
			{
				return `${ city || '---' }, ${ state || '---' }, ${ country || '---' }`;
			}
			else
			{
				return city || state || country;
			}
		};
		const center = 'COMPUTED_COLUMN';
		const sampledByUser = await this.getLabelRecord('User', record.SampledByIDUser || record.CreatingIDUser);
		const displayStrings = [
			`Description: ${ record.Name || 'N/A' }`,
			`Received: ${ record.ReceivedDate ? this.pict.fable.Dates.dayJS(record.ReceivedDate).format('MM/DD/YYYY') : 'N/A' }${ center }Sampled: ${ record.DesignatedTime ? this.pict.fable.Dates.dayJS(record.DesignatedTime).format('MM/DD/YYYY') : 'N/A' }`,
			`Container: ${ record.Container || 'N/A' }${ center }Container Count: ${ record.ContainerCount || 'N/A' }`,
			`Source: ${ record.ReceivedFrom || 'N/A' }${ center }Source Loc.: ${ formatLocation(record.SourceCity, record.SourceState, record.SourceCountry) }`,
		];
		const currentSampleLocation = parseInt(record?.Extension?.StorageLocation) ? (await this.pict.providers.LocationProvider.getLocationByID(parseInt(record?.Extension?.StorageLocation)).catch(() => null)) : null;
		displayStrings.push(`Storage Loc.: ${ currentSampleLocation?.Name || 'N/A' }${ center }Logged By: ${ this.formatLabelUserName(sampledByUser) }`);
		// Probably applicable to most customers but commenting out for now for paragon.
		/*displayStrings.push(`Material: ${ record.IDMaterial ? (await this.getByID('Material', record.IDMaterial)).Name : 'N/A' }${ center }Location: ${ currentSampleLocations.map((loc)=>{ return `${ loc.Name }${ loc.ParentLocation ? ` linked to: ${ loc.ParentLocation.Name }` : '' }`; }).join(', ') || 'N/A' }`);
		if (record.IDOrganization)
		{
			const org = await this.getByID('Organization', record.IDOrganization);
			displayStrings.push(`Producer: ${ org.Name || 'N/A' }${ center }Producer Location: ${ org.City && org.State ? `${ org.City }, ${ org.State }` : 'N/A' }`);
		}*/
		// Probably applicable to most customers but commenting out for now for paragon.
		/*
		let plantString = '';
		if (record.IDProductionPlant)
		{
			const plant = await this.getByID('ProductionPlant', record.IDProductionPlant);
			plantString += `Plant: ${ plant.Name || 'N/A' }`;
		}
		if (record.IDProject)
		{
			const project = await this.getByID('Project', record.IDProject);
			plantString += plantString ? `${ center }Project: ${ project.Name || 'N/A' }` : `Project: ${ project.Name || 'N/A' }`;
		}
		if (plantString)
		{
			displayStrings.push(plantString);
		}*/
		displayStrings.push(`Notes: ${ record.Notes || 'N/A' }`);
		return this.formatStringsForPrinting(displayStrings);
	}

	/**
	 * Using a Location record, constructs the set of information to use while printing. Used for the "wide" template.
	 * @param {Object} record
	 * @return {Array<String>}
	 */
	getLocationPrintablesWide(record)
	{
		//const center = 'COMPUTED_COLUMN';
		const displayStrings =
		[
			`Name: ${ record.Name || 'N/A' }`,
		];
		return this.formatStringsForPrinting(displayStrings);
	}

	/**
	 * Using a Sample record, constructs the set of information to use while printing.
	 * @param {Object} record
	 * @param {String} [printStyleType]
	 * @return {Promise<Array<String>>}
	 */
	async getSamplePrintables(record, printStyleType)
	{
		const printStyle = printStyleType || this.printStyle;
		if (printStyle === 'wide')
		{
			return await this.getSamplePrintablesWide(record);
		}
		const sampledByUser = await this.getLabelRecord('User', record.SampledByIDUser || record.CreatingIDUser);
		const displayStrings = [
			record.QRCode,
			`Name: ${ record.Name || 'N/A' }`,
			`Sample Date: ${ this.pict.fable.Dates.dayJS(record.DesignatedTime || record.CreateDate).toISOString() }`,
			`Material: ${ (await this.getLabelRecord('Material', record.IDMaterial)).Name || 'N/A' }`,
			`Sampled By: ${ this.formatLabelUserName(sampledByUser) }`,
		];
		const currentSampleLocations = (await this.pict.providers.LocationProvider.getLocationsBySampleID(record.IDSample).catch(() => null)) || [];
		displayStrings.push(`Location: ${ currentSampleLocations.map((loc)=>
		{
			return `${ loc.Name }${ loc.ParentLocation ? ` linked to: ${ loc.ParentLocation.Name }` : '' }`;
		}).join(', ') || 'N/A' }`);
		if (record.IDProject)
		{
			const project = await this.getLabelRecord('Project', record.IDProject);
			displayStrings.push(`Project: ${ project.Name || 'N/A' }`);
		}
		if (record.IDOrganization)
		{
			const org = await this.getLabelRecord('Organization', record.IDOrganization);
			displayStrings.push(`Producer: ${ org.Name || 'N/A' }`);
			displayStrings.push(`Producer Location: ${ org.City && org.State ? `${ org.City }, ${ org.State }` : 'N/A' }`);
		}
		if (record.IDProductionPlant)
		{
			const plant = await this.getLabelRecord('ProductionPlant', record.IDProductionPlant);
			displayStrings.push(`Plant: ${ plant.Name || 'N/A' }`);
		}
		displayStrings.push(`Notes: ${ record.Notes || 'N/A' }`);
		return displayStrings;
	}

	/**
	 * Using a Location record, constructs the set of information to use while printing.
	 * @param {Object} record
	 * @param {String} [printStyleType]
	 * @return {Array<String>}
	 */
	getLocationPrintables(record, printStyleType)
	{
		const printStyle = printStyleType || this.printStyle;
		if (printStyle === 'wide')
		{
			return this.getLocationPrintablesWide(record);
		}
		const headlightLogo = 'HLLOGO';
		const color = (color) =>
		{
			return `COLORBEGIN${ color }COLOREND`;
		};
		const displayStrings =
		[
			`${ headlightLogo } ${ color('darkgrey') }Location`,
		];
		return displayStrings;
	}

	/**
	 * Marks the set of rows to apply a forced larger font to for Samples.
	 * @return {Array<String>}
	 */
	getSampleBigRows()
	{
		return [
			'Description',
		];
	}

	/**
	 * Make sure the per-customer label configuration is loaded into `typeConfig`, once.
	 *
	 * `typeConfig` drives `getTemplatedEntitySettings` — PrintStyle (thin/wide), the title template, and
	 * which fields print in which row/column. Apps that load it at startup (LIMS) leave nothing to do here;
	 * apps that never did (the panels/document context) would otherwise print the built-in fallback layout
	 * and silently ignore the customer's printer configuration.
	 *
	 * Deliberately NOT called from `printDecoratedEntity`: that would also change label output for
	 * consumers which have never loaded printable manifests and do not expect the LIMS layout (e.g.
	 * bridge_inspection_v2 printing through ImprovedTabularRecordSetProvider). Callers opt in.
	 *
	 * Never throws — a failed load leaves the built-in layout in place.
	 * @return {Promise<void>}
	 * @async
	 */
	async ensurePrintableManifests()
	{
		// an app that loaded them at startup has already populated typeConfig; nothing to do
		if (this._PrintableManifestsEnsured || Object.keys(this.typeConfig || {}).length > 0)
		{
			this._PrintableManifestsEnsured = true;
			return;
		}
		this._PrintableManifestsEnsured = true;
		try
		{
			if (!this.pict.ManifestPackagingService)
			{
				this.pict.addAndInstantiateServiceType('ManifestPackagingService', libManifestPackagingService);
			}
			await this.pict.ManifestPackagingService.loadPrintableManifests(_PrintableManifestEntities, {}, _PrintableManifestProduct);
			this.pict.log.info('Loaded the printable manifests for QR labels.');
		}
		catch (pError)
		{
			this.pict.log.warn(`Could not load the printable manifests; QR labels will use the default layout: ${pError?.message || pError}`);
		}
	}

	applyTypeConfig(tc)
	{
        this.typeConfig = Object.assign(this.typeConfig, tc);
	}

	addManifestForType(type, manifest)
	{
        this.typeConfig[type] = manifest;
	}

	_getHumanReadableEntityName(pEntity)
	{
		return pEntity.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
	}

	/**
	 * Adds the joined values a printable manifest can ask for that are not columns on the record itself, fetched only
	 * when the layout has a row for them:
	 * - `_LineItems` (Sample): the names of every LineItem attached through SampleLineItemJoin.
	 * - `_Tests` (Sample): the names of every Test the Sample has a TestInstance of (TestInstanceSampleJoin), each once.
	 * The record gets the names comma separated (for a ValueTemplate); the label prints each name on its own row.
	 * A value that cannot be looked up (no attached records, offline, or no provider in this app) prints as N/A.
	 * Names the caller already has, such as an open form's current selection, are used instead of looking them up.
	 * @param {String} entity
	 * @param {Object} record - decorated in place
	 * @param {Object<String, Array<String>>} [pKnownNames] - Names to print instead of looking them up, by field
	 * @return {Promise<Object<String, Array<String>>>} the names looked up, by field
	 */
	async addJoinedLabelFields(entity, record, pKnownNames)
	{
		const descriptors = this.typeConfig[entity]?.Descriptors || {};
		const joinedFields = (entity !== 'Sample') ? {} :
		{
			_LineItems: { Provider: 'LineItemProvider', Fetch: (pProvider) => pProvider.getLineItemsByIDSample(record.IDSample) },
			_Tests: { Provider: 'TestInstanceProvider', Fetch: (pProvider) => pProvider.getTestsForSample(record.IDSample) },
		};
		const joinedNames = {};
		await Promise.all(Object.keys(joinedFields).filter((f) => descriptors[f] && !(f in record)).map(async (f) =>
		{
			if (Array.isArray(pKnownNames?.[f]))
			{
				joinedNames[f] = pKnownNames[f].filter(Boolean);
				record[f] = joinedNames[f].join(', ') || 'N/A';
				return;
			}
			const provider = this.pict.providers?.[joinedFields[f].Provider];
			const joined = (record.IDSample && provider) ? await joinedFields[f].Fetch(provider).catch(() => null) : null;
			joinedNames[f] = (joined || []).map((j) => j.Name).filter(Boolean);
			record[f] = joinedNames[f].join(', ') || 'N/A';
		}));
		return joinedNames;
	}

	async getTemplatedEntitySettings(entity, record, pKnownNames)
	{
		if (!this.pict.services.HeadlightQuickSummaries || !this.typeConfig[entity])
		{
			return null;
		}
		const returnObject =
		{
			headers: [],
			footers: [],
			bigRows: [],
			printStyle: this.typeConfig[entity].PrintStyle || 'thin',
		};
		const joinedNames = await this.addJoinedLabelFields(entity, record, pKnownNames);
		const processedRecord = await this.pict.services.HeadlightQuickSummaries.processRecord(entity, record, 'Printable', this.typeConfig);
		returnObject.headers = [ this.typeConfig[entity].TitleTemplate ? this.fable.parseTemplate(this.typeConfig[entity].TitleTemplate, processedRecord) : this._getHumanReadableEntityName(entity) ];
		const fields = Object.keys(this.typeConfig[entity].Descriptors);
		const rows = [];
		let minRows = 0;
		for (const f of fields)
		{
			const field = this.typeConfig[entity].Descriptors[f];
			if (field.Row && field.Row > minRows)
			{
				minRows = field.Row;
			}
		}
		for (let x = 0; x < minRows; x++)
		{
			rows.push([]);
		}
		for (const f of fields)
		{
			const field = this.typeConfig[entity].Descriptors[f];
			if ((returnObject.printStyle == 'thin' || returnObject.printStyle == 'tall') && field.Column > 1)
			{
				console.warn(`Field ${ f } was not printed b/c the print style is set to "${ returnObject.printStyle }" and the Column # was greater than 1.`);
				continue;
			}
			if (returnObject.printStyle == 'wide' && field.Column > 2)
			{
				console.warn(`Field ${ f } was not printed b/c the print style is set to "wide" and the Column # was greater than 2.`);
				continue;
			}
			if (!field.Row)
			{
				console.warn(`Field ${ f } was not printed b/c a Row was not specified`);
				continue;
			}
			rows[field.Row - 1].push(Object.assign(field, { FieldAddress: f }));
			rows[field.Row - 1] = rows[field.Row - 1].sort((a, b) =>
			{
				if (a.Column > b.Column)
				{
					return 1;
				}
				else if (b.Column > a.Column)
				{
					return -1;
				}
				return 0;
			});
		}
		const generatePrintableField = (field, joinedName, unlabelled) =>
		{
			const value = joinedName ?? (field.HeadlightPrintable?.ValueTemplate ? this.fable.parseTemplate(field.HeadlightPrintable.ValueTemplate, processedRecord) : (processedRecord[field.FieldAddress] || 'N/A'));
			// A field with a blank label prints its value alone.
			return (field.Name && !unlabelled) ? `${ field.Name }: ${ value }` : `${ value }`;
		};
		// A joined field (_LineItems, _Tests) without a ValueTemplate prints one row per name, labelled on the first only;
		// the rows after it follow on.
		const generatePrintableLines = (row) =>
		{
			if (!row.length)
			{
				return [];
			}
			const names = row[0].HeadlightPrintable?.ValueTemplate ? null : joinedNames[row[0].FieldAddress];
			const lines = (names?.length ? names : [ undefined ]).map((n, i) => generatePrintableField(row[0], n, i > 0));
			if (returnObject.printStyle == 'wide' && row[1])
			{
				lines[0] += `COMPUTED_COLUMN${ generatePrintableField(row[1]) }`;
			}
			return lines;
		};
		const tempFooters = [];
		for (const r of rows)
		{
			tempFooters.push(...generatePrintableLines(r));
		}
		returnObject.footers = this.formatStringsForPrinting(tempFooters);
		return returnObject;
	}

	/**
	 * Prints a QR Code for an entity but decorated with additional information about the entity.
	 * @param {String} entity - The entity type being printed.
	 * @param {String} qr - The QR Code of that entity.
	 * @param {String} [previewID] - Tells the function this is a print preview and shouldn't open a print modal.
	 * 								 This is the DOM id of the container to place the preview in.
	 * @param {String} [printStyleOverride] - Allows overriding of the default printing style.
	 * @param {Object} [pKnownRecord] - The record the screen already has, printed when the lookup by code fails (offline).
	 * @param {Object} [pPrintOptions]
	 * @param {boolean} [pPrintOptions.ShowOptions] - Open Print options (label stock and preview) instead of printing on this device's stock.
	 * @param {Object<String, Array<String>>} [pPrintOptions.JoinedLabelNames] - Joined names to print as given, by field (e.g. `_LineItems`)
	 * @return {Promise}
	 */
	async printDecoratedEntity(entity = 'Sample', qr, previewID, printStyleOverride, pKnownRecord, pPrintOptions)
	{
		const printStyle = printStyleOverride ? printStyleOverride : entity === 'Sample' ? 'wide' : this.printStyle;
		await this.initializeLogos();
		if (this.pict.providers?.HeadlightQR && (typeof this.pict.providers.HeadlightQR.loadCustomerPrintSettings === 'function'))
		{
			await this.pict.providers.HeadlightQR.loadCustomerPrintSettings(this.pict.HeadlightRestClient);
		}
		try
		{
			const record = await this.getByQRCode(entity, qr).catch((pError) =>
			{
				if (pKnownRecord && pKnownRecord.QRCode === qr)
				{
					return Object.assign({}, pKnownRecord);
				}
				throw pError;
			});
			if (this.pict.providers.RecordExtension)
			{
				try
				{
					await this.pict.providers.RecordExtension.extendRecords(entity, [ record ]);
				}
				catch (pError)
				{
					console.log(`[QRCodeProvider] Printing ${ entity } ${ qr } without its extended fields: `, pError);
				}
				if (record.Extended)
				{
					for (const k of Object.keys(record.Extended))
					{
						record[k] = record.Extended[k];
					}
				}
			}
			let settingsObj =
			{
				previewID: previewID,
				type: entity,
				printStyle: printStyle,
				headers: entity !== 'Sample' ? record?.Name ? [ record.Name ] : [ entity ] : [],
				bigRows: this[`get${ entity }BigRows`] ? this[`get${ entity }BigRows`]() : [],
				footers: this[`get${ entity }Printables`] ? await this[`get${ entity }Printables`](record, printStyle) : [ qr ],
				showOptions: !!pPrintOptions?.ShowOptions,
			};
			if (entity === 'Sample')
			{
				settingsObj.headers.push('PSID ' + (record.LabControlNumber || '---'));
			}
			const templatedEntitySettings = await this.getTemplatedEntitySettings(entity, record, pPrintOptions?.JoinedLabelNames).catch((pError) =>
			{
				console.log(`[QRCodeProvider] Printing ${ entity } ${ qr } with the standard layout: `, pError);
				return null;
			});
			// If there is a manifest, allow that to override the printing settings.
			if (templatedEntitySettings)
			{
				settingsObj = Object.assign(settingsObj, templatedEntitySettings);
			}
			return await this.print(qr, settingsObj);
		}
		catch (e)
		{
			console.log(`Error printing ${ entity } with QR code ${ qr }: `, e);
			if (!previewID)
			{
				this.reportPrintProblem(`The label for ${ qr } could not be printed. Check your connection and try again.`);
			}
			return null;
		}
	}

	/**
	 * What a printed label's code carries: the customer's label envelope (QR profile) through the shared codec, the same
	 * encoding as the HeadlightQR print dialog. An entity the codec doesn't know keeps the links URL it always had.
	 * @param {string} pEntity
	 * @param {string} pQRCode
	 * @return {string}
	 */
	getLabelPayload(pEntity, pQRCode)
	{
		const tmpHashService = this.pict.fable?.services?.HeadlightQRCodeHash;
		const tmpProfile = (tmpHashService && typeof tmpHashService.getCustomerProfile === 'function') ? tmpHashService.getCustomerProfile() : null;
		const tmpUtility = this.pict.providers.UtilityProvider;
		try
		{
			return _LabelCodec.encode({ Entity: pEntity, Value: pQRCode, Key: 'qr' }, { Envelope: tmpProfile?.Envelope || 'LegacyLinks', Environment: tmpUtility.getEnvironment() });
		}
		catch (pError)
		{
			const tmpEntitySegment = (pEntity === 'Sample') ? '' : `/${ pEntity }`;
			return `${ tmpUtility.buildLinksUrl() }${ tmpEntitySegment }/qr/${ encodeURIComponent(pQRCode) }`;
		}
	}

	/**
	 * Tell the user a print didn't happen, where the app can show a message.
	 * @param {string} pMessage
	 */
	reportPrintProblem(pMessage)
	{
		const tmpPanels = this.pict.views?.HeadlightPanels;
		if (tmpPanels && typeof tmpPanels.toast === 'function')
		{
			tmpPanels.toast({ message: pMessage, type: 'is-danger' });
			return;
		}
		console.warn(`[QRCodeProvider] ${ pMessage }`);
	}

	/**
	 * Look up a record for a label line; a failed lookup prints "N/A" instead of stopping the print.
	 * @param {String} pEntity
	 * @param {Number} pID
	 * @return {Promise<Object>} the record, or an empty object
	 */
	async getLabelRecord(pEntity, pID)
	{
		if (!pID)
		{
			return {};
		}
		try
		{
			return (await this.getByID(pEntity, pID)) || {};
		}
		catch (pError)
		{
			console.log(`[QRCodeProvider] Label line for ${ pEntity } ${ pID } left blank: `, pError);
			return {};
		}
	}

	/**
	 * @param {Object} pUser
	 * @return {string}
	 */
	formatLabelUserName(pUser)
	{
		const tmpName = `${ pUser?.NameFirst || '' } ${ pUser?.NameLast || '' }`.trim();
		return tmpName || 'N/A';
	}

	/**
	 * @param {string} code
	 * @param {QRCodeOptions} [options]
	 *
	 * @return {Promise<'canceled' | 'printed' | undefined>}
	 */
	print(code, options = {})
	{
		const printStyle = options.printStyle || this.printStyle;
		const text = options.raw ? code : this.getLabelPayload(options.type || 'Sample', code);
		const height = 100;
		const topPadding = printStyle === 'wide' ? 100 : 50;
		const footers = [];
		const headers = [];
		let overallSize = 128;
		if (options.footers?.length)
		{
			for (const subText of options.footers)
			{
				footers.push({
					text: subText,
					padding: [ topPadding, 64, 0, 64 ],
					height: height,
				});
				overallSize += height + topPadding;
			}
		}
		if (options.headers?.length)
		{
			for (const subText of options.headers)
			{
				headers.push({
					text: subText,
					padding: [ 0, 64, topPadding, 64 ],
					height: height,
				});
				overallSize += height + topPadding;
			}
		}
		// This is the max percentage of the sticker the text should take up. QR code will take the remaining space.
		const scaleFactor = printStyle === 'wide' ? 65 : 60;

		// Calculate the size the sticker image needs to be based on the text size and scale factor.
		const adjustedScale = (overallSize / scaleFactor) * 100;

		return this.printQrCode({
			previewID: options.previewID,
			showOptions: options.showOptions,
			text: text,
			width: printStyle === 'wide' ? adjustedScale * (3/2) : adjustedScale,
			height: adjustedScale,
			padding: 64,
			footer: footers,
			header: headers,
			bigRows: options.bigRows || [],
			printStyle: printStyle,
		});
	}

	/* -- Print QR Code Methods ---------------------------------------- */

	/**
	* Converts base64 data to an object url
	* @param {string} b64Data
	* @return {string}
	* @private
	*/
	_toObjectUrl(b64Data)
	{
		if (!b64Data.startsWith('data:'))
		{
			throw new Error('Invalid base64 data, expected data:{contentType};base64,{data}');
		}
		const contentType = b64Data.substring('data:'.length, b64Data.indexOf(';'));
		const content = b64Data.substring(b64Data.indexOf(';base64,') + 8);
		const blob = this._b64toBlob(content, contentType);
		return URL.createObjectURL(blob);
	}

	/**
	* Converts a base64 string to a blob
	* @param {string} b64Data
	* @param {string} contentType
	* @param {number} sliceSize
	* @return {module:buffer.Blob}
	* @private
	*/
	_b64toBlob(b64Data, contentType='', sliceSize=512)
	{
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize)
		{
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++)
			{
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
	}

	/**
	* YOU PROBABLY DONT WANT THIS METHOD, USE `print` INSTEAD
	*
	* Prints using the newTab method, this is one of several ways to print a QR code.
	* See the `print` method for more details.
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	printInNewTab(options)
	{
		const src = this.generateQRCodeImage(options);
		const blobUrl = this._toObjectUrl(src);
		window.open('./Global/qrcode/printTab.html?v=' + blobUrl, '_blank');

		return undefined;
	}

	/**
	* "Prints" a preview of the printout into a DOM element.
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	printPreview(options)
	{
		const el = document.querySelector(`#${ options.previewID }`);
		// The preview follows the label's print style: a wide label reads horizontally, a thin or tall one vertically.
		// (A wide label prints turned sideways, see generateQRCodeImage; Print options shows the as-printed, true-size
		// label on the chosen stock.)
		const orientation = QRCodeProvider.labelPreviewOrientation(options.printStyle || this.printStyle);
		let src = this.generateQRCodeImage(options);
		const { canvas } = this.getGenerationLayers();
		if (QRCodeProvider.isPreviewTurned(orientation, canvas.width, canvas.height))
		{
			src = this._turnCanvasImage(canvas);
		}
		const blobUrl = this._toObjectUrl(src);
		if (el)
		{
			el.innerHTML = /*html*/`<img class="hl-label-preview hl-label-preview--${ orientation }" data-orientation="${ orientation }" src="${ blobUrl }" />`;
		}

		return undefined;
	}

	/**
	 * How a print style's label is previewed on screen.
	 * @param {string} [pPrintStyle] - 'wide', 'thin' or 'tall'
	 * @return {'horizontal'|'vertical'} 'horizontal' for wide (two columns), 'vertical' for thin and tall (one column)
	 */
	static labelPreviewOrientation(pPrintStyle)
	{
		return (pPrintStyle === 'wide') ? 'horizontal' : 'vertical';
	}

	/**
	 * Whether a drawn label has to be turned a quarter to show in its orientation. A square label never is.
	 * @param {'horizontal'|'vertical'} pOrientation
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @return {boolean}
	 */
	static isPreviewTurned(pOrientation, pWidth, pHeight)
	{
		if (!pWidth || !pHeight || (pWidth === pHeight))
		{
			return false;
		}
		return (pWidth > pHeight) !== (pOrientation === 'horizontal');
	}

	/**
	 * The label just drawn on the generation canvas, turned a quarter clockwise.
	 * @param {HTMLCanvasElement} pCanvas
	 * @return {string} a PNG data URL
	 */
	_turnCanvasImage(pCanvas)
	{
		const turned = document.createElement('canvas');
		turned.width = pCanvas.height;
		turned.height = pCanvas.width;
		const ctx = turned.getContext('2d');
		ctx.translate(turned.width, 0);
		ctx.rotate(Math.PI / 2);
		ctx.drawImage(pCanvas, 0, 0);
		return turned.toDataURL('image/png');
	}

	/**
	* YOU PROBABLY DONT WANT THIS METHOD, USE `print` INSTEAD
	*
	* Prints using an embedded iframe, this is one of several ways to print a QR code.
	* See the `print` method for more details.
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	printInline(options)
	{
		const src = this.generateQRCodeImage(options);

		const blobUrl = this._toObjectUrl(src);

		const { printFrame } = this.getGenerationLayers();

		let resolveDeferred;
		const deferred = new Promise(function(resolve, reject)
		{
			resolveDeferred = resolve;
		});

		printFrame.contentWindow.document.open();
		window.onfocus=function()
		{
			resolveDeferred();
		};
		window.addEventListener('focus', function(event)
		{
			resolveDeferred();
		}, { once: true });

		printFrame.contentWindow.document.write(`<html lang="en">
			<head>
				<title>QR Code</title>
				<style>
					html, body {
						overflow-x: hidden;
					}
					
					img {
						height: 100%;
						width: 100%;
						max-height: 600px; /* cant seem to get this to scale right, i give up */
						object-fit: contain;
						flex: 1;
					}
					
					.column {
						display: flex;
						flex-direction: column;
						flex: 1;
					}
					
					button {
						appearance: none;
						display: block;
						width: calc(100% - 32px);
						box-sizing: border-box;
						padding: 12px 16px;
						font-size: 36px;
						background-color: #38b2ff;
						border: 1px solid #008ee3;
						color: white;
						font-weight: bold;
						margin: 16px;
						max-width: 600px;
						align-self: center;
					}
					
					@media print {
						@page {
							size: 62mm 100mm;
							margin: 0cm !important;
							padding: 0cm !important;
						}
					
						html, body {
							padding: 0 !important;
							margin: 0 !important;
							position: relative !important;
							inset: 0 !important;
						}
					
						/*@media print {*/
						/*}*/
						* { margin: 0 !important; padding: 0 !important; }
						#controls, .footer, .footerarea{ display: none; }
						html, body {
							/*changing width to 100% causes huge overflow and wrap*/
							height:100%;
							overflow: hidden;
							background: #FFF;
							font-size: 9.5pt;
							page-break-inside: avoid;
						}
						.template { width: auto; left:0; top:0; }
						li { margin: 0 0 10px 20px !important;}
					
					
						button {
							display: none;
						}
					
						img {
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							align-self: initial;
					
							object-fit: contain;
							flex: 0;
						}
					}
				</style>
			</head>
			<body onload="print()">
				<img src="${blobUrl}" alt="${options.text}"/>
			</body>
			</html>`);
		printFrame.contentWindow.document.close();

		return deferred;
	}

	async printNative(options)
	{
		const src = this.generateQRCodeImage(options);
		return this.fable.NativeBridge.printImage({
			jobName: 'QR Code',
			base64Image: src,
		});
	}

	/**
	* Prints a QR code using the best method available for the current browser.
	*
	* @param {QRCodePrinterOptions} options
	* @return {Promise<'canceled' | 'printed' | undefined>}
	*/
	async printQrCode(options)
	{
		await this.initializeLogos();
		if (options.previewID)
		{
			return this.printPreview(options);
		}
		const method = this.getPrintMethod();
		if (method === 'native')
		{
			return this.printNative(options);
		}
		else if (method === 'window')
		{
			return this.printInNewTab(options);
		}
		else if (this.pict.views?.['HeadlightQR-PrintDialog'] && this.pict.providers?.HeadlightQR)
		{
			return options.showOptions ? this.printWithStockChoice(options) : this.printOnDeviceStock(options);
		}
		else
		{
			return this.printInline(options);
		}
	}

	/**
	* Prints straight to the browser on this device's label stock (Print options' choice, else the customer's default).
	* @param {QRCodePrinterOptions} options
	* @return {undefined}
	*/
	printOnDeviceStock(options)
	{
		this.pict.providers.HeadlightQR.printLabels([ this._labelImageItem(options) ], { Transport: 'browser' });
		return undefined;
	}

	/**
	* The label drawn for printing, as a HeadlightQR label item.
	* @param {QRCodePrinterOptions} options
	* @return {{ Payload: string, Image: string, ImageWidth: number, ImageHeight: number }}
	*/
	_labelImageItem(options)
	{
		const src = this.generateQRCodeImage(Object.assign({}, options, { previewID: undefined }));
		const { canvas } = this.getGenerationLayers();
		return { Payload: options.text, Image: src, ImageWidth: canvas.width, ImageHeight: canvas.height };
	}

	/**
	* Opens Print options, where the user picks the label stock (becomes this device's stock) and sees the
	* label at true size before printing.
	* @param {QRCodePrinterOptions} options
	* @return {undefined}
	*/
	printWithStockChoice(options)
	{
		this.pict.providers.HeadlightQR.openPrintDialog([ this._labelImageItem(options) ], { Title: 'Print options' });
		return undefined;
	}

	/**
	* Gets the ideal printing method for the given browser.
	*
	* @return {'native'|'inline'|'window'}
	*/
	getPrintMethod()
	{
		const ua = navigator.userAgent;
		const iOS = ua.match(/iPad/i) || ua.match(/iPhone/i);
		const webkit = ua.match(/WebKit/i);
		const isSafariMobile = iOS && webkit && !ua.match(/CriOS/i);

		if (this.fable.NativeBridge.hasNativeSupport())
		{
			return 'native';
		}
		else if (isSafariMobile)
		{
			return 'window';
		}
		else
		{
			return 'inline';
		}
	}

	/**
	 * This is a copy of a method inside the HTML5QRCode lib. It should be exactly the same except it has a fix to handle a bug where it can sometimes call removeChild on an element that doesn't exist.
	 * TODO: Hopefully the library fixes this bug themselves at some point, there is an open issue on their github for it.
	 * @param {Number} [tries] - how many times the scanner has tried to run. WE will give up after a few retries.
	 * @return {Promise<void>}
	 */
	localScannerStop(tries)
	{
		// @ts-ignore
		const localThis = _Pict.providers.QRCodeProvider._qrCodeScanner.html5Qrcode;
		if (!localThis.stateManagerProxy.isScanning())
		{
			console.log('Returning early, scanner is not already running.');
			return;
		}

		const toStoppedStateTransaction = localThis.stateManagerProxy.startTransition(1);

		this.shouldScan = false;
		if (localThis.foreverScanTimeout)
		{
			clearTimeout(localThis.foreverScanTimeout);
		}

		// Removes the shaded region if exists.
		const removeQrRegion = () =>
		{
			if (!localThis.element)
			{
				return;
			}
			const childElement = document.getElementById('qr-shaded-region');
			if (childElement)
			{
				localThis.element.removeChild(childElement);
			}
		};

		return localThis.renderedCamera.close().then(() =>
		{
			localThis.renderedCamera = null;

			if (localThis.element && localThis.canavsElement)
			{
				localThis.element.removeChild(localThis.canvasElement);
				localThis.canvasElement = null;
			}

			removeQrRegion();
			if (localThis.qrRegion)
			{
				localThis.qrRegion = null;
			}
			if (localThis.context)
			{
				localThis.context = null;
			}

			toStoppedStateTransaction.execute();
			try
			{
				localThis.hidePausedState();
			}
			catch (e)
			{
				console.log('Scanner ui element not present, skipping.');
			}
			localThis.isScanning = false;
			return Promise.resolve();
		});
	}

	/* -- QR Code Scan Methods ---------------------------------------- */

	/**
	* Scans a QRCode and gives you back the result
	* @param {String} [id] - optional, an id of an element to inject the scanner onto.
	* @param {Boolean} [keepOpen] - optional, keeps the camera in an open scanning mode.
	* @param {Object} [pOptions] - optional, options for the scanner
	* @return {Promise<String>}
	*/
	async scanQrCode(id, keepOpen, pOptions = {})
	{
		const Html5QrcodeScanner = window.Html5QrcodeScanner;
		if (typeof Html5QrcodeScanner === 'undefined')
		{
			throw new Error('QRCode scanning is not supported. Missing library Html5QrcodeScanner');
		}

		// The scanner draws into one container. A camera opened in a different one (the panels' cart, a page's own
		// cart) gets a scanner of its own; the earlier one's container may not be on the page any more.
		const tmpContainerID = id || 'qrcode-scanner';
		if (this._qrCodeScanner && (this._qrCodeScannerContainerID !== tmpContainerID))
		{
			this._qrCodeScanner = null;
		}
		if (!this._qrCodeScanner)
		{
			if (!id)
			{
				this._dialog = new Dialog({
					closeOnBackdropClick: true,
					body: `<div id="qrcode-scanner" style="width: 100%; height: 100%;"></div>`,
				});
			}
			this._qrCodeScannerContainerID = tmpContainerID;
			this._qrCodeScanner = new window.Html5QrcodeScanner(tmpContainerID, {
				fps: 20,
				rememberLastUsedCamera: true,
				videoConstraints: { facingMode: 'environment' },
				qrbox: {
					width: pOptions?.isPhoneDevice ? 150 : 250,
					height: pOptions?.isPhoneDevice ? 150 : 250,
				},
				// turn off file upload feature, it doesnt work well with iOS devices (safari)
				// enum found at https://github.com/mebjas/html5-qrcode/blob/master/src/core.ts#L76
				supportedScanTypes: [ 0 ],
			});
		}
		// Make sure events can't "persist" between instances of opening the cart (i.e. if an event fires before the cart closes, it should not get picked up if the cart closes and reopens).
		const instanceCameraKey = `${ this.cameraKey }`;
		if (keepOpen)
		{
			this._qrCodeScanner.render((result)=>
			{
				if (this.cameraKey && instanceCameraKey === this.cameraKey && Date.now() - this.lastCameraEvent.time > 1000 && this.lastCameraEvent.content !== result)
				{
					this.lastCameraEvent =
					{
						time: Date.now(),
						content: result,
					};
					this.receiveCameraScan(result);
				}
			});
			// html5-qrcode names its permission/camera-picker section after the container.
			const embedUI = document.querySelector(`#${tmpContainerID}__dashboard_section`);
			// Remove this for now until we have a better solution for detecting mobile.
			/*const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
			if (!isMobile)
			{
				embedUI.classList.add('is-hidden');
			}*/
			if (embedUI && embedUI.innerHTML.includes('Request Camera Permissions'))
			{
				const tmpPermissionButton = document.querySelector('#html5-qrcode-button-camera-permission');
				if (tmpPermissionButton)
				{
					// @ts-ignore
					tmpPermissionButton.click();
				}
			}
			// Replace the stop method with a local version that fixes a bug in it.
			// See method jsdoc comment for more details.
			this._qrCodeScanner.html5Qrcode.stop = this.localScannerStop;
			return Promise.resolve('');
		}
		else
		{
			return await new Promise((resolve, reject) =>
			{
				if (this._dialog)
				{
					this._dialog.show();
				}
				this._qrCodeScanner.render((result) =>
				{
					if (this._dialog)
					{
						try
						{
							this._qrCodeScanner.html5Qrcode.stop();
						}
						catch (e)
						{
							console.error('Error stopping scanner', e);
						}
						this._dialog.hide();
					}
					const tmpDecoded = _LabelCodec.decode(result);
					resolve((tmpDecoded.Kind === 'Entity') ? tmpDecoded.Value : tmpDecoded.Raw);
				});
			});
		}
	}

	/* -- QR Code Generation Methods ---------------------------------------- */

	/**
	 * @typedef {Object} Footer
	 * @property {string} footer.text - The text to put in the footer
	 * @property {number} footer.height - The height of the footer, this will be used to calculate the font size
	 * @property {number|Array<number>} [footer.padding] - The padding around the footer
	 */

	/**
	 * @typedef {Object} Header
	 * @property {string} header.text - The text to put in the header
	 * @property {number} header.height - The height of the header, this will be used to calculate the font size
	 * @property {number|Array<number>} [header.padding] - The padding around the header
	 */

	/**
	* @typedef {Object} QRCodePrinterOptions
	* @property {string} text - The text to encode in the QR code
	* @property {string} [previewID] - The ID of a DOM element to render the print preview into.
	* @property {number} [width] - The width of the QR code
	* @property {number} [height] - The height of the QR code
	* @property {string} [printStyle] - Style of label to print, current options are 'thin' and 'wide'
	* @property {number|Array<number>} [padding] - The padding around the QR code
	*
	* @property {Array<Header>} [header] - The header to put above the QR code
	*
	* @property {Array<Footer>} [footer] - The footer to put below the QR code

	* @property {Array<String>} [bigRows] - lists footer rows that should be displayed in "bigger" text
	*
	*/

	/**
	* Parse a padding format into a common output of top, left, bottom, right
	* @param {number|Array<number>} padding - The padding to parse
	* @return {{top: number, left: number, bottom: number, right: number}}
	*/
	_parsePadding(padding)
	{
		if (Array.isArray(padding))
		{
			return {
				top: padding[0] ?? 0,
				right: padding[1] ?? 0,
				bottom: padding[2] ?? padding[0] ?? 0,
				left: padding[3] ?? padding[1] ?? 0,
			};
		}
		return {
			top: padding || 0,
			bottom: padding || 0,
			left: padding || 0,
			right: padding || 0,
		};
	}

	/**
	 * @typedef {Object} TextMetrics
	 * @property {Number} usedFontSize
	 */

	/**
	* Given the text and the width and height, this will return the ideal font size for the text to fit within the given width and height
	* @param {object} ctx
	* @param {string} text
	* @param {number} width
	* @param {number} height
	* @return {TextMetrics}
	* @private
	*/
	_setIdealFontSize(ctx, text, width, height)
	{
		let size = 0; const step = .5;
		let tmpSize;
		do
		{
			size += step;
			ctx.font = 'bold ' + size + 'px "Noto Sans Mono", monospace';
			tmpSize = ctx.measureText(text);
		} while (tmpSize.width < width && (tmpSize.actualBoundingBoxAscent + tmpSize.actualBoundingBoxDescent) < height);

		// we can overshoot, check if we did then bring it down a notch
		if (tmpSize.width > width || (tmpSize.actualBoundingBoxAscent + tmpSize.actualBoundingBoxDescent) > height)
		{
			size -= step;
			ctx.font = 'bold ' + size + 'px "Noto Sans Mono", monospace';
			tmpSize = ctx.measureText(text);
		}

		tmpSize.usedFontSize = size;
		return tmpSize;
	}

	/**
	* Generates a QR code image given the provided options.
	* The QRCode library we use only does the QRCode but It's ridiculous to try and
	* get print styles to conform in a standard way. However, what is a great standard is the
	* canvas library! use that to put stuff where we want then make an image from it
	* @param {QRCodePrinterOptions} options
	* @return {string} - base64 encoded image
	*/
	generateQRCodeImage(options)
	{
		if (typeof window.QRCode === 'undefined')
		{
			throw new Error('QRCode generation is not supported. Missing library QRCode');
		}

		if ((options.printStyle || this.printStyle) === 'tall')
		{
			return this.generateTallLabelImage(options);
		}

		// init if we need to

		const { canvas, qrCodeContainer } = this.getGenerationLayers();

		const printStyle = options.printStyle || this.printStyle;

		if (printStyle === 'wide' && !options.previewID)
		{
			canvas.style.width = options.height+'px';
			canvas.style.height = options.width+'px';
			canvas.style.border = '1px solid black';

			canvas.width = options.height;
			canvas.height = options.width;
		}
		else
		{
			canvas.style.width = options.width+'px';
			canvas.style.height = options.height+'px';
			canvas.style.border = '1px solid black';

			canvas.width = options.width;
			canvas.height = options.height;
		}

		const ctx = canvas.getContext('2d');
		if (printStyle === 'wide' && options?.footer?.length && !options.previewID)
		{
			ctx.translate(canvas.width, 0);
			ctx.rotate(Math.PI/2);
		}
		ctx.fillStyle = 'white';
		ctx.fillRect(0, 0, options.width, options.height);

		ctx.save();
		const offset = this._parsePadding(options.padding);
		// given our root padding we want to move everything in by this amount
		// translate the entire thing by that offset
		ctx.translate(offset.left, offset.top);

		let { width, height } = options;
		// adjust the perceived width and height of below by our padding options
		width -= offset.left + offset.right;
		height -= offset.top + offset.bottom;

		const sanitizeText = (string) =>
		{
			const tokens = [ 'HLLOGO', 'COLORBEGIN', 'COLOREND' ];
			for (const t of tokens)
			{
				if (t === 'COLORBEGIN' && string.includes('COLORBEGIN'))
				{
					const fontColor = string.split('COLORBEGIN')[1].split('COLOREND')[0];
					string = string.replace(fontColor, '');
				}
				string = string.replace(t, '');
			}
			return string;
		};

		let ctxFont = 0;
		const textSet = [].concat(options.header || []).concat(options.footer || []);

		const sanitizeTextForTesting = (string) =>
		{
			const double = string.includes('HLLOGO');
			const tokens = [ 'HLLOGO', 'COLORBEGIN', 'COLOREND' ];
			for (const t of tokens)
			{
				if (t === 'COLORBEGIN' && string.includes('COLORBEGIN'))
				{
					const fontColor = string.split('COLORBEGIN')[1].split('COLOREND')[0];
					string = string.replace(fontColor, '');
				}
				string = string.replace(t, '');
			}
			return double && textSet.length > 1 ? string + string : string;
		};

		for (const note of textSet)
		{
			const padding = this._parsePadding(note.padding);
			const tmpInsets = this._setIdealFontSize(
				ctx,
				sanitizeTextForTesting(note.text),
				width - padding.left - padding.right,
				note.height,
			);
			if (tmpInsets.usedFontSize < ctxFont || !ctxFont)
			{
				ctxFont = tmpInsets.usedFontSize;
			}
		}

		let extraBottomOffset = 0;
		if (options?.footer?.length && printStyle === 'wide' && ctxFont)
		{
			ctx.font = 'bold ' + ctxFont + 'px "Noto Sans Mono", monospace';
			if (!options.bigRows)
			{
				options.bigRows = [];
			}
			const tmpSize = ctx.measureText('test');
			const smallFooterSize = (tmpSize.actualBoundingBoxAscent + tmpSize.actualBoundingBoxDescent + options.footer[0].padding[0]);
			ctx.font = 'bold ' + (ctxFont * 1.5) + 'px "Noto Sans Mono", monospace';
			const tmpSizeBig = ctx.measureText('test');
			const bigFooterSize = (tmpSizeBig.actualBoundingBoxAscent + tmpSizeBig.actualBoundingBoxDescent + options.footer[0].padding[0]);
			const footerBoundsCalc = (smallFooterSize * (options.footer.length - options.bigRows.length)) + (bigFooterSize * options.bigRows.length);
			if (footerBoundsCalc < (height * 0.65))
			{
				extraBottomOffset = (height * 0.65) - footerBoundsCalc;
			}
		}

		const imageInset = this._parsePadding(0);

		if (options.header)
		{
			let headerFont = printStyle === 'wide' ? ctxFont * 2.5 : ctxFont;
			if (printStyle === 'wide' && textSet.length)
			{
				// The code takes the top-right corner (up to 30% of the height, below), so the header has to fit beside it.
				for (const headNote of options.header)
				{
					const padding = this._parsePadding(headNote.padding);
					const tmpFit = this._setIdealFontSize(ctx, sanitizeText(headNote.text), width - (height * 0.3) - padding.left - padding.right, Number.MAX_SAFE_INTEGER);
					headerFont = Math.min(headerFont, tmpFit.usedFontSize);
				}
			}
			ctx.font = 'bold ' + headerFont + 'px "Noto Sans Mono", monospace';
			for (const headNote of options.header)
			{
				const padding = this._parsePadding(headNote.padding);
				const tmpInsets = ctx.measureText(sanitizeText(headNote.text));
				console.log('header insets', tmpInsets);

				imageInset.top += tmpInsets.actualBoundingBoxAscent + tmpInsets.actualBoundingBoxDescent + padding.top + padding.bottom;

				ctx.fillStyle = 'black';

				ctx.fillText(
					sanitizeText(headNote.text),
					printStyle === 'wide' && !this.customerLogo ? padding.left : width / 2 - tmpInsets.width / 2,
					imageInset.top - padding.bottom,
				);
			}
		}
		if (this.customerLogo && printStyle === 'wide')
		{
			ctx.drawImage(this.customerLogo, 0, 0, width / 4, (width / 4) * (this.customerLogo.height / this.customerLogo.width));
		}
		if (printStyle === 'wide')
		{
			ctx.font = 'bold ' + (ctxFont * 0.75) + 'px "Noto Sans Mono", monospace';
			ctx.fillText(
				'Print Date: ' + this.pict.fable.Dates.dayJS(new Date().toISOString()).format('MM/DD/YYYY'),
				(width / 5) * 3,
				height,
			);
		}

		if (options.footer)
		{
			options.footer = options.footer.reverse();
			let currentOffset = height - extraBottomOffset;
			ctx.font = 'bold ' + ctxFont + 'px "Noto Sans Mono", monospace';
			for (const footNote of options.footer)
			{
				// Measure with "N/A" still in place: a line holding only "N/A" is blank below (the grey pass draws it), and blank text has no height.
				const measuredText = sanitizeText(footNote.text);
				const tokens = footNote.text.split('N/A');
				let paddedPlaceholder = '';
				for (let x = 0; x < tokens.length; x++)
				{
					const tempSpacer = ('').padEnd(tokens[x].length);
					paddedPlaceholder = paddedPlaceholder.concat(tempSpacer);
					if ((x + 1) < tokens.length)
					{
						paddedPlaceholder = paddedPlaceholder.concat('N/A');
					}
				}
				footNote.text = tokens.join('   ');
				const bigRow = options.bigRows?.filter((r)=>
				{
					return footNote.text.startsWith(r);
				})?.length;
				let tmpFont = 'bold ' + ctxFont + 'px "Noto Sans Mono", monospace';
				if (bigRow)
				{
					const tmpBigPadding = this._parsePadding(footNote.padding);
					const tmpBigFit = this._setIdealFontSize(ctx, sanitizeText(footNote.text), width - tmpBigPadding.left - tmpBigPadding.right, Number.MAX_SAFE_INTEGER);
					tmpFont = 'bold ' + Math.max(ctxFont, Math.min(ctxFont * 1.5, tmpBigFit.usedFontSize)) + 'px "Noto Sans Mono", monospace';
				}
				ctx.font = tmpFont;
				const padding = this._parsePadding(footNote.padding);
				const tmpInsets = ctx.measureText(measuredText);
				console.log('footer insets', tmpInsets);

				const tmpTextOffset = tmpInsets.actualBoundingBoxAscent + tmpInsets.actualBoundingBoxDescent + padding.top + padding.bottom;
				imageInset.bottom += tmpTextOffset;
				currentOffset -= tmpInsets.actualBoundingBoxDescent;
				// Boxes which are helpful for debugging painting issues
				/*ctx.strokeStyle = 'green';
				ctx.strokeRect(
					width / 2 - tmpInsets.width / 2,
					height - footNote.height,
					tmpInsets.width,
					tmpInsets.actualBoundingBoxAscent + tmpInsets.actualBoundingBoxDescent);

				ctx.strokeStyle = 'red';
				ctx.strokeRect(0, height - footNote.height, width, footNote.height);*/

				let fontColor = 'black';
				if (footNote.text.includes('COLORBEGIN'))
				{
					fontColor = footNote.text.split('COLORBEGIN')[1].split('COLOREND')[0];
				}
				let imageWidth = 0;
				if (footNote.text.includes('HLLOGO'))
				{
					imageWidth = (tmpTextOffset - padding.top + padding.bottom) * (this.headlightLogo.width / this.headlightLogo.height);
					ctx.drawImage(this.headlightLogo, 0, currentOffset - tmpInsets.actualBoundingBoxAscent, imageWidth, tmpTextOffset - padding.top - padding.bottom);
				}
				ctx.fillStyle = fontColor;
				ctx.fillText(
					sanitizeText(footNote.text),
					imageWidth ? imageWidth : (printStyle === 'wide' ? padding.left : width / 2 - tmpInsets.width / 2),
					currentOffset,
				);
				ctx.fillStyle = 'grey';
				ctx.fillText(
					paddedPlaceholder,
					imageWidth ? imageWidth : (printStyle === 'wide' ? padding.left : width / 2 - tmpInsets.width / 2),
					currentOffset,
				);
				currentOffset -= tmpInsets.actualBoundingBoxAscent + padding.top + padding.bottom;
				if (printStyle === 'wide')
				{
					for (let x = 0; x < 10; x++)
					{
						ctx.moveTo(0, currentOffset + padding.top/2 + padding.bottom + x);
						ctx.lineTo(options.previewID ? canvas.width : canvas.height, currentOffset + padding.top/2 + padding.bottom + x);
						ctx.stroke();
					}
				}
			}
		}

		ctx.fillStyle = 'black';

		const availableHeight = printStyle === 'wide' ? height - imageInset.bottom : height - imageInset.top - imageInset.bottom;
		const availableWidth = width - imageInset.left - imageInset.right;

		let boundingRectSize = Math.min(availableWidth, availableHeight);
		if (printStyle === 'wide' && boundingRectSize > (height * 0.3) && textSet.length)
		{
			boundingRectSize = height * 0.3;
		}

		console.log('Done', imageInset);
		// ctx.rect(imageInset.left, imageInset.top, width-imageInset.left-imageInset.right, height-imageInset.top-imageInset.bottom);
		// ctx.stroke();
		for (const child of [ ...qrCodeContainer.children ])
		{
			qrCodeContainer.removeChild(child);
		}
		console.log('boundingRectSize', boundingRectSize);
		new window.QRCode(qrCodeContainer, {
			text: options.text,
			width: boundingRectSize,
			height: boundingRectSize,
			colorDark: '#000000',
			colorLight: '#ffffff',
			correctLevel: window.QRCode.CorrectLevel.H,
		}).makeCode(options.text);
		const qrCodeCanvas = qrCodeContainer.querySelector('canvas');

		// console.log('image', qrCodeCanvas.toDataURL());
		ctx.imageSmoothingEnabled = false;
		ctx.drawImage(
			qrCodeCanvas,
			// shift to middle of bounding box
			printStyle === 'wide' ? imageInset.left + (availableWidth - boundingRectSize) : imageInset.left + (availableWidth - boundingRectSize) / 2,
			printStyle === 'wide' ? 0 : imageInset.top + (availableHeight - boundingRectSize) / 2,
			boundingRectSize,
			boundingRectSize,
		);
		ctx.restore();

		return canvas.toDataURL('image/png');
	}

	/**
	* Draws the "tall" label, top to bottom: the header lines, a large code, then one line per footer.
	* Text is monospaced, sized so TALL_LABEL_LINE_LENGTH characters fill the width; a longer value wraps at its spaces
	* onto up to TALL_LABEL_MAX_WRAP_LINES lines. The image is only as tall as what it holds.
	* @param {QRCodePrinterOptions} options
	* @return {string} - PNG data URL
	*/
	generateTallLabelImage(options)
	{
		const { canvas, qrCodeContainer } = this.getGenerationLayers();
		const width = TALL_LABEL_WIDTH;
		const padding = Math.round(width * 0.04);
		const codeSize = Math.round(width * TALL_LABEL_CODE_SHARE);
		const fontFamily = '"Noto Sans Mono", monospace';
		const toBlocks = (pNotes) => (pNotes || [])
			.map((pNote) => this.wrapLabelText(String(pNote.text || '').replace(/COLORBEGIN.*?COLOREND/g, '').replace(/HLLOGO/g, ''), TALL_LABEL_LINE_LENGTH, TALL_LABEL_MAX_WRAP_LINES))
			.filter((pLines) => pLines.length);
		const headerBlocks = toBlocks(options.header);
		const footerBlocks = toBlocks(options.footer);

		const ctx = canvas.getContext('2d');
		ctx.font = `bold 100px ${ fontFamily }`;
		const fontSize = Math.floor(100 * (width - (padding * 2)) / ctx.measureText('M'.repeat(TALL_LABEL_LINE_LENGTH)).width);
		const lineHeight = Math.round(fontSize * 1.3);
		const blockGap = Math.round(fontSize * 0.25);
		const gap = Math.round(fontSize * 0.5);
		const blocksHeight = (pBlocks) => pBlocks.reduce((pSum, pLines) => pSum + (pLines.length * lineHeight), 0) + (Math.max(0, pBlocks.length - 1) * blockGap);

		const height = padding + blocksHeight(headerBlocks) + (headerBlocks.length ? gap : 0) + codeSize + (footerBlocks.length ? gap : 0) + blocksHeight(footerBlocks) + padding;
		canvas.width = width;
		canvas.height = height;
		canvas.style.width = width + 'px';
		canvas.style.height = height + 'px';

		ctx.fillStyle = 'white';
		ctx.fillRect(0, 0, width, height);
		ctx.font = `bold ${ fontSize }px ${ fontFamily }`;
		ctx.textAlign = 'left';
		ctx.textBaseline = 'middle';
		const drawLine = (pLine, pTop) =>
		{
			// Centred as a whole, drawn piece by piece so "N/A" can print grey.
			let tmpX = (width - ctx.measureText(pLine).width) / 2;
			const tmpParts = pLine.split('N/A');
			for (let i = 0; i < tmpParts.length; i++)
			{
				ctx.fillStyle = 'black';
				ctx.fillText(tmpParts[i], tmpX, pTop + (lineHeight / 2));
				tmpX += ctx.measureText(tmpParts[i]).width;
				if (i < tmpParts.length - 1)
				{
					ctx.fillStyle = 'grey';
					ctx.fillText('N/A', tmpX, pTop + (lineHeight / 2));
					tmpX += ctx.measureText('N/A').width;
				}
			}
		};

		const drawBlocks = (pBlocks, pTop) =>
		{
			let tmpTop = pTop;
			pBlocks.forEach((pLines, pIndex) =>
			{
				if (pIndex > 0)
				{
					tmpTop += blockGap;
				}
				for (const line of pLines)
				{
					drawLine(line, tmpTop);
					tmpTop += lineHeight;
				}
			});
			return tmpTop;
		};

		let top = drawBlocks(headerBlocks, padding);
		if (headerBlocks.length)
		{
			top += gap;
		}

		for (const child of [ ...qrCodeContainer.children ])
		{
			qrCodeContainer.removeChild(child);
		}
		new window.QRCode(qrCodeContainer, {
			text: options.text,
			width: codeSize,
			height: codeSize,
			colorDark: '#000000',
			colorLight: '#ffffff',
			correctLevel: window.QRCode.CorrectLevel.H,
		}).makeCode(options.text);
		ctx.imageSmoothingEnabled = false;
		ctx.drawImage(qrCodeContainer.querySelector('canvas'), (width - codeSize) / 2, top, codeSize, codeSize);
		top += codeSize;
		if (footerBlocks.length)
		{
			top += gap;
		}
		drawBlocks(footerBlocks, top);

		return canvas.toDataURL('image/png');
	}

	/**
	* Break text into printed lines of at most pLineLength characters, at spaces where it can (a word longer than a
	* line is split). Past pMaxLines the last line is cut with "...".
	* @param {string} pText
	* @param {number} pLineLength
	* @param {number} pMaxLines
	* @return {Array<string>}
	*/
	wrapLabelText(pText, pLineLength, pMaxLines)
	{
		const lines = [];
		let current = '';
		for (const word of String(pText || '').split(/\s+/).filter((pWord) => pWord))
		{
			let rest = word;
			while (rest)
			{
				const candidate = current ? `${ current } ${ rest }` : rest;
				if (candidate.length <= pLineLength)
				{
					current = candidate;
					rest = '';
				}
				else if (current)
				{
					lines.push(current);
					current = '';
				}
				else
				{
					lines.push(rest.substring(0, pLineLength));
					rest = rest.substring(pLineLength);
				}
			}
		}
		if (current)
		{
			lines.push(current);
		}
		if (lines.length > pMaxLines)
		{
			const last = lines[pMaxLines - 1];
			lines.length = pMaxLines;
			lines[pMaxLines - 1] = `${ (last.length > pLineLength - 3) ? last.substring(0, pLineLength - 3).trimEnd() : last }...`;
		}
		return lines;
	}

	/* -- Utility Methods ---------------------------------------- */

	/**
	* Get the layers used for generating QR codes and printing them.
	* @return {{canvas: HTMLCanvasElement, qrCodeContainer: HTMLDivElement, printFrame: HTMLIFrameElement, hiddenLayer: HTMLDivElement}}
	*/
	getGenerationLayers()
	{
		if (!this._hiddenLayer)
		{
			this._hiddenLayer = document.createElement('div');

			this._hiddenLayer.style.visibility = 'hidden';
			this._hiddenLayer.style.height = '0';
			this._hiddenLayer.style.width = '0';
			this._hiddenLayer.style.position = 'absolute';
			this._hiddenLayer.style.top = '-10000px';
			this._hiddenLayer.style.left = '-10000px';

			this._qrCodeContainer = document.createElement('div');
			this._qrCodeContainer.style.display = 'none';
			this._hiddenLayer.appendChild(this._qrCodeContainer);

			this._canvas = document.createElement('canvas');
			this._hiddenLayer.appendChild(this._canvas);

			this._printFrame = document.createElement('iframe');
			this._hiddenLayer.appendChild(this._printFrame);

			document.body.appendChild(this._hiddenLayer);
		}

		return {
			hiddenLayer: this._hiddenLayer,
			canvas: this._canvas,
			qrCodeContainer: this._qrCodeContainer,
			printFrame: this._printFrame,
		};
	}
}

module.exports = QRCodeProvider;
module.exports.default_configuration = {};

},{"headlight-qrcode/source/Headlight-QRCode-Codec.js":14,"manifest-packaging-service":25,"pict-provider":552}],1605:[function(require,module,exports){
const PictProvider = require('pict-provider');

const DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'RecordExtension-Provider',
	EntityType: 'Sample',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

class RecordExtensionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, DEFAULT_PROVIDER_CONFIGURATION, pOptions), pServiceHash);

		/** @type {import('headlight-configurable-application').Pict} */
		this.pict;
	}

	/**
	 * @param {string} uri - The URI to fetch data from.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (err, data) =>
			{
				if (err)
				{
					this.pict.log.error('Error fetching data from URI:', uri, err);
					reject(err);
					return;
				}

				resolve(data);
			});
		});
	}

	/**
	 * @param {string} entityType - The type of entity to load the schema for.
	 */
	async loadSchema(entityType)
	{
		//FIXME: add this to the fable service below (and finish it)
		const rootManifest = await this._get(`ManifestSchemas/FilteredTo/FBL~Type~EQ~RecordExtension~FBV~SubType~EQ~${entityType}`).then((manifestSchemas) => manifestSchemas[0]);
		if (!rootManifest)
		{
			return null;
		}
		const manifestSchemaPartialJoins = await this._get(`ManifestSchemaManifestSchemaPartialJoins/FilteredTo/FBL~IDManifestSchema~EQ~${rootManifest.IDManifestSchema}`);
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			await this._get(`ManifestSchemaPartials/FilteredTo/FBL~IDManifestSchemaPartial~INN~${manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial).join()}`) : [];
		const manifest = this.pict.ManifestPackagingService._mergeManifests(rootManifest, manifestPartials);
		//TODO: atm this is used for forms only, so it creates this wrapper
		return manifest?.DefaultFormManifest;
	}

	/**
	 * @param {string} entityType - The type of entity to extend records for.
	 * @param {Array<Record<string, any>>} records - The records to extend.
	 */
	async extendRecords(entityType, records)
	{
		const extensions = await this._get(`RecordExtendedSchemaDatas/FilteredTo/FBV~EntityType~EQ~${encodeURIComponent(entityType)}~FBL~IDEntity~INN~${records.map((r) => r[`ID${entityType}`]).join()}`);
		for (const record of records)
		{
			const extension = extensions.find((e) => e.IDEntity == record[`ID${entityType}`]);
			if (extension)
			{
				//TODOL keep this whole record around?
				record.Extended = extension.Data || { };
			}
			else
			{
				record.Extended = { };
			}
		}
	}

	async saveExtendedSchemaData(entityType, entityID, extended)
	{
		let recordExtendedSchemaData = await this._get(`RecordExtendedSchemaDatas/FilteredTo/FBL~IDEntity~EQ~${entityID}~FBV~EntityType~EQ~${encodeURIComponent(entityType)}`)
			.then((data) => data[0]);
		if (!recordExtendedSchemaData)
		{
			recordExtendedSchemaData = {
				EntityType: entityType,
				IDEntity: entityID,
				Data: { },
			};
		}
		Object.assign(recordExtendedSchemaData.Data, extended);
		await new Promise((resolve, reject) => this.pict.HeadlightRestClient.putJSON(`RecordExtendedSchemaData/Upsert`, recordExtendedSchemaData, (err, data) =>
		{
			if (err)
			{
				this.pict.log.error('Error saving extended schema data:', err);
				reject(err);
			}
			else
			{
				resolve(data);
			}
		}));
	}
}

module.exports = RecordExtensionProvider;
module.exports.default_configuration = DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":552}],1606:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class SampleLogProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the SampleLog by ID
	 * @param {String|Number} pSampleLogID - The SampleLog ID to search for
	 * @return {Promise<any>}
	 * @async
	 */
	getSampleLogByID(pSampleLogID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleLogID)
			{
				this.pict.log.error('No SampleLog ID provided.');
				return reject(new Error('No SampleLog ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`SampleLog/${pSampleLogID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLog: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the SampleLogs by an IDSample
     * @param {Object} pIDSample - The IDSample to search for
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getSampleLogsByIDSample(pIDSample)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pIDSample)
			{
				this.pict.log.error('No IDSample provided.');
				return reject(new Error('No IDSample provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`SampleLogs/FilteredTo/FBV~IDSample~EQ~${pIDSample}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLogs for IDSample ${pIDSample}: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the SampleLogs
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 */
	getSampleLogs()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'SampleLogs';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `SampleLogs/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get SampleLogs list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Create a new sample log entry for a given sample
	 * @param {Object} pOptions - The options to use when adding the log
	 * @return {Promise<any>}
	 * @async
	 */
	async createSampleLog(pOptions)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions?.IDSample)
			{
				this.pict.log.error('No Sample ID provided.');
				return reject(new Error('No Sample ID provided.'));
			}
			if (!pOptions?.Notes)
			{
				this.pict.log.error('No Log Entry provided.');
				return reject(new Error('No Log Entry provided.'));
			}
			const tmpOptions = {
				IDSample: pOptions?.IDSample || 0,
				Notes: pOptions?.Notes || '',
				CaptureDate: pOptions?.CaptureDate || new Date().toISOString(),
				CaptureLatitude: pOptions?.CaptureLatitude || 0,
				CaptureLongitude: pOptions?.CaptureLongitude || 0,
				IDLab: pOptions?.IDLab || 0,
			};
			if (pOptions?.IDLocation)
			{
				tmpOptions.IDLocation = pOptions.IDLocation;
			}
			for (const tmpKey of [ 'FromStatus', 'ToStatus' ])
			{
				if (pOptions?.[tmpKey])
				{
					tmpOptions[tmpKey] = pOptions[tmpKey];
				}
			}

			this.pict.HeadlightRestClient.postJSON(`SampleLog`, tmpOptions, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding Sample Log Entry: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Add a note to a sample's log, at the device's position when the browser already allows it (never asks).
	 * The sample's own coordinates are where it was taken in the field, so they are never touched.
	 * @param {number} pIDSample
	 * @param {string} pNotes
	 * @param {{ IDLocation?: number }} [pOptions] - IDLocation: where the sample sits, so the entry records it
	 * @return {Promise<any>}
	 */
	async addNote(pIDSample, pNotes, pOptions)
	{
		const tmpGeo = this.pict.providers.GeoProvider;
		const tmpPosition = tmpGeo ? await tmpGeo.getGeoCoords({ NoPrompt: true }).catch(() => null) : null;
		return this.createSampleLog(
			{
				IDSample: pIDSample,
				CaptureLatitude: tmpPosition ? tmpPosition.CaptureLatitude : undefined,
				CaptureLongitude: tmpPosition ? tmpPosition.CaptureLongitude : undefined,
				IDLocation: pOptions ? pOptions.IDLocation : undefined,
				Notes: pNotes,
			});
	}
}

module.exports = SampleLogProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1607:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libSampleScanning = require('headlight-sample-scanning');
const EntityDataBaseline = require('headlight-dynamic-inputs-bundle/source/providers/_EntityDataBaseline.js');

class SampleProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Sample Status Mapped Details - this provides a consistent breakdown of the status of a sample for display purposes
	 * @param {string} pStatusString - The status string to map
	 * @return {Object} - The mapped details of the status
	 */
	getSampleStatusMappedDetails(pStatusString)
	{
		switch (pStatusString ? pStatusString.toLowerCase() : '')
		{
		case 'pass':
		case 'sqty':
		case 'passing':
			return {
				name: 'Pass',
				color: 'is-success',
				icon: 'fa-check-circle',
				iconColor: 'has-text-success-soft',
				original: pStatusString,
			};
		case 'fail':
		case 'failing':
			return {
				name: 'Fail',
				color: 'is-danger',
				icon: 'fa-exclamation-circle',
				iconColor: 'has-text-danger-soft',
				original: pStatusString,
			};
		case 'pending':
			return {
				name: 'Pending',
				color: 'is-warning',
				icon: 'fa-clock',
				iconColor: 'has-text-warning-soft',
				original: pStatusString,
			};
		case 'void':
			return {
				name: 'Void',
				color: 'is-text',
				icon: 'fa-ban',
				iconColor: 'has-text-text-60',
				original: pStatusString,
			};
		case 'info':
			return {
				name: 'Info',
				color: 'is-info',
				icon: 'fa-info-circle',
				iconColor: 'has-text-info-soft',
				original: pStatusString,
			};
		default:
			if (pStatusString)
			{
				return {
					name: pStatusString,
					color: 'is-unknown',
					icon: 'fa-info-circle',
					iconColor: 'has-text-unkown',
					original: pStatusString,
				};
			}
			return {
				name: 'N/A',
				color: 'is-text',
				icon: 'fa-question-circle',
				iconColor: 'has-text-text-60',
				original: pStatusString,
			};
		}
	}

	/**
	 * Get the Sample by ID
	 * @param {String|Number} pSampleID - The Sample ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getSampleByID(pSampleID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleID)
			{
				this.pict.log.error('No Sample ID provided.');
				return reject(new Error('No Sample ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Sample/${pSampleID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Sample by GUID
	 * @param {String|Number} pSampleGUID - The Sample GUID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getSampleByGUID(pSampleGUID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleGUID)
			{
				this.pict.log.error('No Sample GUID provided.');
				return reject(new Error('No Sample GUID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Samples/FilteredTo/FBV~GUIDSample~EQ~${pSampleGUID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample: ${pError}`, pError);
					return reject(pError);
				}
				if (pBody.length > 1)
				{
					this.pict.log.error(`More than one Sample found for GUID: ${pSampleGUID}`, pBody);
				}
				resolve(pBody[0]);
			});
		});
	}

	/**
	 * Get the Sample by QR Code
	 * @param {Object} pQRCode - The QR Code to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getSampleByQRCode(pQRCode)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pQRCode)
			{
				this.pict.log.error('No QR Code provided.');
				return reject(new Error('No QR Code provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Samples/FilteredTo/FBV~QRCode~EQ~${pQRCode}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Samples
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getSamples()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Samples';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `Samples/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Samples list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Promise wrapper over the paged entity-set fetch.
	 * @param {String} pEntity - The entity type to fetch
	 * @param {String} pFilter - A Meadow filter string
	 * @return {Promise<Array<Object>>}
	 */
	_getEntitySet(pEntity, pFilter)
	{
		// the paged client takes per-page / progress callbacks we have no use for here
		const fNoOp = () =>
		{
			// intentionally empty
		};
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages(pEntity, pFilter, fNoOp, fNoOp, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Failed to get the ${pEntity} set.`, pError);
					return reject(pError);
				}
				resolve(pRecords || []);
			});
		});
	}

	/**
	 * Get the DocumentPolyJoin rows tying Samples to a Document. The joins are written server-side
	 * (SampleTestController), so a freshly created Sample only appears here after a save round-trip.
	 * @param {Number|String} pIDDocument - The Document to fetch Sample joins for
	 * @return {Promise<Array<Object>>}
	 * @async
	 */
	async getDocumentSampleJoins(pIDDocument)
	{
		if (!pIDDocument)
		{
			return [];
		}
		return await this._getEntitySet('DocumentPolyJoin', `FBV~RemoteType~EQ~Sample~FBV~IDDocument~EQ~${pIDDocument}`);
	}

	/**
	 * Get the Samples joined to a Document. Replaces the legacy sample-log component's raw
	 * `Samples/FilteredTo/...?Joins=DocumentPolyJoin` URL with the standard two-hop entity fetch.
	 * @param {Number|String} pIDDocument - The Document to fetch joined Samples for
	 * @return {Promise<Array<Object>>}
	 * @async
	 */
	async getDocumentJoinedSamples(pIDDocument)
	{
		const tmpJoins = await this.getDocumentSampleJoins(pIDDocument);
		const tmpSampleIDs = [ ...new Set(tmpJoins.map((pJoin) => pJoin.IDRemote).filter((pIDRemote) => !!pIDRemote)) ];
		if (!tmpSampleIDs.length)
		{
			return [];
		}
		return await this._getEntitySet('Sample', `FBL~IDSample~INN~${tmpSampleIDs.join(',')}`);
	}

	/**
	 * The Samples the open form holds, wherever its manifest keeps them. A Sample created on this device
	 * has no row to read until the document syncs, so this is the only place to find it offline.
	 * @return {Array<Object>} - Copies of the held Sample records that carry a QR code, one per code
	 */
	getFormHeldSamples()
	{
		const tmpSamples = new Map();
		for (const tmpHeld of EntityDataBaseline.collectHeldRecords(this.pict))
		{
			const tmpRecord = tmpHeld.Record;
			if (tmpHeld.Entity === 'Sample' && tmpRecord.QRCode && !tmpRecord.Deleted && !tmpSamples.has(tmpRecord.QRCode))
			{
				tmpSamples.set(tmpRecord.QRCode, Object.assign({}, tmpRecord));
			}
		}
		return Array.from(tmpSamples.values());
	}

	/**
	 * The Samples to offer for a document: those joined to it, plus any the open form holds that the join
	 * read did not return. A failed read still offers the held Samples, which is the usual offline case.
	 * @param {Number|String} [pIDDocument] - The Document to fetch joined Samples for
	 * @return {Promise<Array<Object>>}
	 * @async
	 */
	async getDocumentCurrentSamples(pIDDocument)
	{
		let tmpJoinedSamples = [];
		let tmpJoinedError = null;
		try
		{
			tmpJoinedSamples = pIDDocument ? await this.getDocumentJoinedSamples(pIDDocument) : [];
		}
		catch (pError)
		{
			tmpJoinedError = pError;
		}
		const tmpJoinedCodes = new Set(tmpJoinedSamples.map((pSample) => pSample.QRCode));
		const tmpHeldSamples = this.getFormHeldSamples().filter((pSample) => !tmpJoinedCodes.has(pSample.QRCode));
		if (tmpJoinedError && tmpHeldSamples.length < 1)
		{
			throw tmpJoinedError;
		}
		return tmpJoinedSamples.concat(tmpHeldSamples);
	}

	/**
	 * The names of the LineItems the open form has joined to a Sample it holds, in IDLineItem order as the saved joins print, or null when
	 * the form holds no joins for it (the label then reads the saved joins as before). Read from the form rather than
	 * the saved joins, so the label matches what is selected now, before a save or a sync.
	 * @param {Object} pSample - A held Sample record
	 * @return {Promise<Array<string>|null>}
	 * @async
	 */
	async getFormHeldLineItemNames(pSample)
	{
		const tmpHeld = EntityDataBaseline.collectHeldRecords(this.pict);
		const tmpIDSample = Number(pSample?.IDSample) || 0;
		const tmpLineItemIDs = [];
		for (const tmpRecord of tmpHeld)
		{
			const tmpJoin = tmpRecord.Record;
			const tmpForThisSample = (tmpIDSample > 0 && Number(tmpJoin.IDSample) === tmpIDSample) ||
				(pSample?.GUIDSample && tmpJoin.GUIDSample === pSample.GUIDSample);
			if (tmpRecord.Entity === 'SampleLineItemJoin' && tmpForThisSample && !tmpJoin.Deleted && tmpJoin.IDLineItem &&
				!tmpLineItemIDs.includes(Number(tmpJoin.IDLineItem)))
			{
				tmpLineItemIDs.push(Number(tmpJoin.IDLineItem));
			}
		}
		if (tmpLineItemIDs.length < 1)
		{
			return null;
		}
		tmpLineItemIDs.sort((pA, pB) => pA - pB);
		const tmpNames = new Map();
		for (const tmpRecord of tmpHeld)
		{
			if (tmpRecord.Entity === 'LineItem' && tmpRecord.Record.Name && tmpLineItemIDs.includes(Number(tmpRecord.Record.IDLineItem)))
			{
				tmpNames.set(Number(tmpRecord.Record.IDLineItem), tmpRecord.Record.Name);
			}
		}
		const tmpMissing = tmpLineItemIDs.filter((pID) => !tmpNames.has(pID));
		const tmpLineItemProvider = this.pict.providers?.LineItemProvider;
		if (tmpMissing.length > 0 && tmpLineItemProvider && typeof tmpLineItemProvider._getLineItemsByIDs === 'function')
		{
			const tmpLineItems = await tmpLineItemProvider._getLineItemsByIDs(tmpMissing).catch(() => []);
			for (const tmpLineItem of (tmpLineItems || []))
			{
				tmpNames.set(Number(tmpLineItem.IDLineItem), tmpLineItem.Name);
			}
		}
		return tmpLineItemIDs.map((pID) => tmpNames.get(pID)).filter(Boolean);
	}

	/**
	 * Print the label for a Sample the open form holds, using the form's record if the lookup by code fails.
	 * @param {string} pQRCode - The Sample QR code
	 * @return {Promise<void>}
	 * @async
	 */
	async printFormSample(pQRCode)
	{
		if (!pQRCode)
		{
			return;
		}
		const tmpQRCodeProvider = this.pict.providers.QRCodeProvider;
		await tmpQRCodeProvider.ensurePrintableManifests();
		const tmpKnownRecord = this.getFormHeldSamples().find((pSample) => pSample.QRCode === pQRCode);
		const tmpLineItemNames = tmpKnownRecord ? await this.getFormHeldLineItemNames(tmpKnownRecord) : null;
		await tmpQRCodeProvider.printDecoratedEntity('Sample', pQRCode, undefined, undefined, tmpKnownRecord,
			tmpLineItemNames ? { JoinedLabelNames: { _LineItems: tmpLineItemNames } } : undefined);
	}

	/**
	 * Get the Sample search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<void>}
	 * @async
	 * @example
	 * getObservationSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getSampleSearchCount(pSearchQuery)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `Samples/Count${tmpFilter ? `/${tmpFilter}` : ''}`;

		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
					reject(pError);
				}
				else
				{
					resolve(pBody?.Count || 0);
				}
			});
		});
	}

	/**
	 * Get the Sample search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @return {Promise<Array>}
	 * @async
	 * @example
	 * getSampleSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getSampleSearchResults(pSearchQuery)
	{
		const tmpURL = `Samples/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
					reject(pError);
				}
				resolve(Array.isArray(pBody) ? pBody : []);
			});
		});
	}

	/**
	 * This method performs an Sample search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @return {Promise<Object>}
	 * @async
	 */
	performSampleSearch(pOptions = {})
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions)
			{
				this.pict.log.error('No search options provided.');
				return reject(new Error('No search options provided.'));
			}

			const tmpSearchQuery = {
				filters: [ {
					field: 'IDCustomer',
					comparator: 'EQ',
					target: pOptions.IDCustomer || 0,
				} ],
				pagination: {
					start: pOptions?.CurrentPage || 1,
					limit: pOptions?.PageSize || 25,
				},
				sort: {
					field: pOptions.SortBy || 'CreateDate',
					direction: pOptions.SortDirection || 'DESC',
				},
			};

			// Handle the search filters
			if (pOptions?.Projects && pOptions.Projects.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDProject',
					comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
				});
			}

			if (pOptions?.Materials && pOptions.Materials.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDMaterial',
					comparator: pOptions.Materials.length === 1 ? 'EQ' : 'INN',
					target: pOptions.Materials.length === 1 ? pOptions.Materials[0] : pOptions.Materials,
				});
			}

			if (pOptions?.MixDesigns && pOptions.MixDesigns.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'IDMixDesign',
					comparator: pOptions.MixDesigns.length === 1 ? 'EQ' : 'INN',
					target: pOptions.MixDesigns.length === 1 ? pOptions.MixDesigns[0] : pOptions.MixDesigns,
				});
			}

			if (pOptions?.StartDate && pOptions.StartDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'CreateDate',
					comparator: 'GE',
					target: pOptions.StartDate,
				});
			}

			if (pOptions?.EndDate && pOptions.EndDate.length > 0)
			{
				tmpSearchQuery.filters.push({
					field: 'CreateDate',
					comparator: 'LE',
					target: pOptions.EndDate,
				});
			}

			// Perform the search by calling both getSampleSearchCount and getSampleSearchResults
			Promise.all([
				this.getSampleSearchCount(tmpSearchQuery),
				this.getSampleSearchResults(tmpSearchQuery),
			])
				.then(([ tmpCountResults, tmpResults ]) =>
				{
					resolve({ results: tmpResults, count: tmpCountResults });
				})
				.catch((error) =>
				{
					this.pict.log.error('Error during sample search:', error);
					reject(error);
				});
		});
	}

	/**
	 * Create a new Sample
	 * @param {Object} pSampleData - The Sample data to create
	 * @param {Function} [pCallback] - The callback function to call when the creation is complete
	 * @param {Boolean} [disableAutomaticDesignatedTime] - If true, the Sample will not get a date automatically set.
	 *
	 * @return {Promise<void>}
	 * @async
	 * FIXME: Why do we have an async method with a callback that is only invoked sometimes?
	 */
	async createSample(pSampleData, pCallback, disableAutomaticDesignatedTime)
	{
		if (!pSampleData)
		{
			this.pict.log.error('No Sample data provided.');
			throw new Error('No Sample data provided.');
		}
		// A supplied code (a pre-printed sticker, a scanned label) is kept; only empty samples get a new one.
		if (!pSampleData.QRCode)
		{
			const tmpCurrentUser = this.pict.AppData?.CurrentUser || {};
			const tmpQRCodeService = this.pict.fable.services.HeadlightQRCodeHash;
			await tmpQRCodeService.loadCustomerConfiguration(this.pict.HeadlightRestClient, tmpCurrentUser.CustomerID);
			let tmpExternalSyncGUID = this.pict.AppData?.FullUserRecord?.ExternalSyncGUID;
			if (!tmpExternalSyncGUID && tmpQRCodeService.getCustomerProfile()?.CodeFormat === 'SiteManager')
			{
				const tmpUserRecord = await new Promise((resolve) =>
				{
					this.pict.HeadlightRestClient.getJSON('User/' + tmpCurrentUser.UserID, (pError, pResult) => resolve(pError ? null : pResult));
				});
				tmpExternalSyncGUID = tmpUserRecord?.ExternalSyncGUID;
			}
			pSampleData.QRCode = tmpQRCodeService.mintForCustomer(
				{
					IDProject: pSampleData.IDProject,
					IDUser: tmpCurrentUser.UserID,
					ExternalSyncGUID: pSampleData.GUIDPrefix || tmpExternalSyncGUID,
					CustomerID: tmpCurrentUser.CustomerID,
					TimeZone: tmpCurrentUser.Timezone,
				});
		}
		if (pSampleData.DesignatedTime?.length && !pSampleData.DesignatedTime.includes('T'))
		{
			pSampleData.DesignatedTime = this.fable.Dates.dayJS(pSampleData.DesignatedTime + this.getCurrentTime()).toISOString();
		}
		// Set the Designated Time to the current time if not provided (unless explcitly disabled)
		if (!pSampleData.DesignatedTime && !disableAutomaticDesignatedTime)
		{
			this.pict.log.info('No Designated Time was passed, setting to current time.');
			pSampleData.DesignatedTime = new Date().toISOString();
		}
		// strip out any _ prefixed fields (these are internal only)
		Object.keys(pSampleData).forEach((pKey) =>
		{
			if (pKey.startsWith('_'))
			{
				delete pSampleData[pKey];
			}
		});
		// Go build us a sample record
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.postJSON('Sample', this.buildSampleAPIPayload(pSampleData), async (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error creating Sample: ${pError}`, pError);
					return reject(pError);
				}
				if (parseInt(pBody?.Extension?.StorageLocation))
				{
					await this.pict.providers.LocationProvider.addSampleToLocation(pBody.IDSample, parseInt(pBody?.Extension?.StorageLocation)).catch((pLocationError) =>
					{
						this.pict.log.error(`Sample ${pBody.IDSample} saved, but its storage location could not be recorded: ${pLocationError?.message || pLocationError}`);
					});
				}
				this.pict.log.info('Sample created successfully.');
				// go create a sample log record for the creation step
				this.pict.providers.SampleLogProvider.createSampleLog({
					IDSample: pBody.IDSample,
					IDUser: pBody.CreatingIDUser,
					IDSampleStatus: pBody.IDSampleStatus,
					Notes: 'Sample created.',
				}).catch((pError) =>
				{
					this.pict.log.error(`Error creating Sample Log for newly created sample: ${pError}`, pError);
				}).finally(() =>
				{
					resolve(pBody);
					if (pCallback)
					{
						pCallback(pBody);
					}
				});
			});
		});
	}

	getCurrentTime()
	{
		return ` ${ this.fable.Dates.dayJS(new Date()).format('HH:mm:ss') }`;
	}

	/**
	 * The Sample record as the API should see it.
	 *
	 * Entity pickers keep a `<field>__Record` snapshot beside each value so the control can paint its
	 * selection without a refetch. That is client-side display state — the Sample schema has no such
	 * column — so it is dropped here rather than posted. A COPY, deliberately: the caller's object is the
	 * live form's data, and the picker reads those snapshots, so removing them in place would blank the
	 * control after a save.
	 *
	 * @param {Object} pSampleData - The Sample data being sent.
	 * @return {Object} a shallow copy without the `__Record` snapshots.
	 */
	buildSampleAPIPayload(pSampleData)
	{
		const tmpPayload = {};
		for (const tmpKey of Object.keys(pSampleData))
		{
			if (tmpKey.endsWith('__Record'))
			{
				continue;
			}
			tmpPayload[tmpKey] = pSampleData[tmpKey];
		}
		return tmpPayload;
	}

	/**
	 * Update an existing Sample
	 * @param {Object} pSampleData - The Sample data to update
	 * @return {Promise<void>}
	 * @async
	 */
	async updateSample(pSampleData)
	{
		if (!pSampleData)
		{
			this.pict.log.error('No Sample data provided.');
			throw new Error('No Sample data provided.');
		}
		if (pSampleData.DesignatedTime?.length && !pSampleData.DesignatedTime.includes('T'))
		{
			pSampleData.DesignatedTime = this.fable.Dates.dayJS(pSampleData.DesignatedTime + this.getCurrentTime()).toISOString();
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON('Sample/Upsert', this.buildSampleAPIPayload(pSampleData), async (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating Sample: ${pError}`, pError);
					return reject(pError);
				}
				await this.recordStorageLocation(pBody).catch((pLocationError) =>
				{
					this.pict.log.error(`Sample ${pBody.IDSample} saved, but its storage location could not be recorded: ${pLocationError?.message || pLocationError}`);
				});

				resolve(pBody);
			});
		});
	}

	/**
	 * Move a saved sample to its storage location when that differs from where it is now: the same move as
	 * scanning (out of its other locations, with a log entry), without the reception status rule.
	 * @param {Object} pSample - The saved Sample record.
	 * @return {Promise<void>}
	 */
	async recordStorageLocation(pSample)
	{
		const tmpIDLocation = parseInt(pSample?.Extension?.StorageLocation);
		if (!tmpIDLocation || !pSample.IDSample)
		{
			return;
		}
		const tmpStore = new libSampleScanning.AppSampleScanStore(this.pict);
		const tmpCurrent = await tmpStore.getSampleLocations(pSample.IDSample);
		if (Array.isArray(tmpCurrent) && tmpCurrent.length && Number(tmpCurrent[0].IDLocation) === tmpIDLocation)
		{
			return;
		}
		const tmpLocation = (await tmpStore.getLocation(tmpIDLocation).catch(() => null)) || { IDLocation: tmpIDLocation };
		await libSampleScanning.moveSampleToLocation(tmpStore, pSample, tmpLocation,
			{
				CurrentLocations: tmpCurrent,
				Position: await tmpStore.getPosition(),
				Notes: `Storage location changed to ${tmpLocation.Name || tmpIDLocation}`,
			});
	}

	/**
	 * Delete an existing Sample
	 * @param {Object} pSampleId - The IDSample to delete the Sample record
	 * @return {Promise<void>}
	 * @async
	 */
	async deleteSample(pSampleId)
	{
		if (!pSampleId)
		{
			this.pict.log.error('No Sample id provided.');
			throw new Error('No Sample id provided.');
		}
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.deleteEntity('Sample', pSampleId, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error deleting Sample: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Sample schema
	 * @return {Promise<void>}
	 * @async
	 */
	async getSampleSchema()
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('Sample/Schema', (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Sample schema: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = SampleProvider;
module.exports.default_configuration = {};

},{"headlight-dynamic-inputs-bundle/source/providers/_EntityDataBaseline.js":154,"headlight-sample-scanning":294,"pict-provider":552}],1608:[function(require,module,exports){
// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

/** @typedef {import('headlight-configurable-application').Pict} Pict */
const libPictProvider = require('pict-provider');

class SessionProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		/** @type {any} */
		this._Session = null;

		this.sessionChangeCallbacks = [];
	}

	onSessionChange(fCallback)
	{
		if (typeof fCallback === 'function')
		{
			this.sessionChangeCallbacks.push(fCallback);
		}
	}

	onInitializeAsync(fCallback)
	{
		// check for initial logged in state
		this.syncLoggedInState().catch((error) =>
		{
			this.pict.log.error(`Error syncing logged in state: ${error.message || error}`);
		}).finally(fCallback);
	}

	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (error, payload) =>
			{
				if (error)
				{
					return reject(error);
				}
				resolve(payload);
			});
		});
	}

	async _triggerSessionChange(pOldSession, pNewSession)
	{
		for (const callback of this.sessionChangeCallbacks)
		{
			try
			{
				await callback(pNewSession, pOldSession);
			}
			catch (error)
			{
				this.pict.log.error(`Error in session change callback: ${error.message || error}`, { stack: error.stack });
			}
		}
	}

	/**
	 * Shape of the session object stored in memcache, and returned from CheckSession.
	 * @typedef {Object} SessionInfo
	 * @property {string} SessionID - The session ID.
	 * @property {boolean} LoggedIn - True if the user is logged in.
	 * @property {string} UserRole - The human readable role of the user.
	 * @property {number} UserRoleIndex - The user's (0-5) level.
	 * @property {number} UserID - The IDUser (database ID) of the user.
	 * @property {number} CustomerID - The IDCustomer (database ID) of the customer.
	 * @property {boolean} [Impersonation] - True when this session is impersonating another user.
	 * @property {string} Title - The title of the user.
	 * @property {string} NameFirst - The first name of the user.
	 * @property {string} NameLast - The last name of the user.
	 * @property {string} Email - The email of the user.
	 * @property {string} LoginID - The login ID of the user.
	 * @property {string} UIHash - The UI hash of the user. (not sure what this is for)
	 * @property {string} Timezone - The timezone of the user.
	 * @property {Record<string, any>} Settings - The user's settings.
	 * @property {string} LastSessionID - The user's last session ID.
	 * @property {string} LastLoginTime - The time of the user's last login.
	 * @property {Array<string>} UserRoles - The roles of the user.
	 * @property {string} DeviceID - The device ID associated with the session.
	 * @property {number} IDDevice - The IDDevice (database ID) of the device record associated with the session.
	 */

	/**
	 * @return {Promise<SessionInfo | null>}
	 */
	async syncLoggedInState()
	{
		const session = await this._get(`CheckSession`);
		if (!session || !session.LoggedIn)
		{
			if (this._Session && this._Session.LoggedIn)
			{
				await this._triggerSessionChange(this._Session, null);
			}
			this._Session = null;
			this._Permissions = null;
			return this._Session;
		}
		if (!this._Session || this._Session.UserID != session.UserID)
		{
			await this._triggerSessionChange(this._Session, session);

			// some kind of event that user changed?
			this._Permissions = null;
		}
		this._Session = session;
		// Customer permissions load lazily through getPermissions(); nothing needs them at boot.
		return this._Session;
	}

	/**
	 * @return {boolean} whether a logged-in session is cached from a previous sync.
	 */
	hasSession()
	{
		return !!(this._Session && this._Session.LoggedIn);
	}

	/**
	 * Drop the cached session so the next getSession()/syncLoggedInState() asks the server again.
	 */
	invalidateSession()
	{
		this._Session = null;
		this._Permissions = null;
	}

	async getPermissions()
	{
		if (!this._Permissions)
		{
			//FIXME: project aware permissions
			this._Permissions = await this._get(`Permissions/For/User/In/Customer/${this._Session.CustomerID}`);
		}
		return this._Permissions;
	}

	async getSession()
	{
		if (!this._Session)
		{
			this._Session = await this._get(`CheckSession`);
		}
		return this._Session;
	}
}

module.exports = SessionProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'SessionProvider',
	});

},{"pict-provider":552}],1609:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class TestInstanceProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

    /**
	 * Get Test by ID
	 * @param {String|Number} pTestID - The Test ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getTestByID(pTestID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pTestID)
			{
				this.pict.log.error('No Test ID provided.');
				return reject(new Error('No Test ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Test/${pTestID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Test: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the TestInstance by ID
	 * @param {String|Number} pTestInstanceID - The TestInstance ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getTestInstanceByID(pTestInstanceID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pTestInstanceID)
			{
				this.pict.log.error('No TestInstance ID provided.');
				return reject(new Error('No TestInstance ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`TestInstance/${pTestInstanceID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting TestInstance: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

    deleteTestInstanceByID(pTestInstanceID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pTestInstanceID)
			{
				this.pict.log.error('No TestInstance ID provided.');
				return reject(new Error('No TestInstance ID provided.'));
			}

			this.pict.HeadlightRestClient.deleteEntity('TestInstance', pTestInstanceID, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error deleting TestInstance: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

    async _getDocumentPolyJoinsForTestInstances(IDTestInstances)
    {
        // An empty IN list reaches the server as IN (''), which matches ID 0 rows that aren't this record's.
        if (!IDTestInstances?.length)
        {
            return [];
        }
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('DocumentPolyJoin', `FBV~RemoteType~EQ~TestInstance~FBL~IDRemote~INN~${ IDTestInstances.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting DocumentPolyJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getDocumentPolyJoinsForSample(IDSample)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('DocumentPolyJoin', `FBV~RemoteType~EQ~Sample~FBL~IDRemote~INN~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting DocumentPolyJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getDocumentsByIDs(IDDocuments)
    {
        // An empty IN list reaches the server as IN (''), which matches ID 0 rows that aren't this record's.
        if (!IDDocuments?.length)
        {
            return [];
        }
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('Document', `FBL~IDDocument~INN~${ IDDocuments.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Documents: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getDocumentMapForTestInstances(IDTestInstances)
    {
        const dpjs = await this._getDocumentPolyJoinsForTestInstances(IDTestInstances);
        const docs = await this._getDocumentsByIDs(dpjs.map(d => d.IDDocument));
        const docIDMap = {}
        for (let d of docs)
        {
            docIDMap[d.IDDocument] = d;
        }
        const tiDocMap = {};
        for (let t of IDTestInstances)
        {
            tiDocMap[t] = [];
        }
        for (let d of dpjs)
        {
            const doc = docIDMap[d.IDDocument];
            const tiDocs = tiDocMap[d.IDRemote];
            // Only joins to the TestInstances asked for, each document once.
            if (doc && tiDocs && !tiDocs.includes(doc))
            {
                tiDocs.push(doc);
            }
        }
        return tiDocMap;
    }

    async _getDocumentsForSample(IDSample)
    {
        const dpjs = await this._getDocumentPolyJoinsForSample(IDSample);
        return await this._getDocumentsByIDs(dpjs.map(d => d.IDDocument));
    }

    /**
	 * Get Tests by IDs
	 * @param {Array<number>} pIDTests - The Test IDs to search for
	 * @return {Promise<Array<Record<string, any>>>}
	 */
	async getTestsByIDs(pIDTests)
    {
        if (!pIDTests?.length)
        {
            return [];
        }
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('Test', `FBL~IDTest~INN~${ pIDTests.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Tests: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async getTestsByHashes(TestHashes)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('Test', `FBL~Hash~INN~${ TestHashes.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Tests: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getTestInstanceSampleJoinsForSample(IDSample)
    {
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('TestInstanceSampleJoin', `FBV~IDSample~EQ~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting TestInstanceSampleJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getTestInstancesByIDs(IDTestInstances)
    {
        // An empty IN list reaches the server as IN (''), which matches ID 0 rows that aren't this record's.
        if (!IDTestInstances?.length)
        {
            return [];
        }
        return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('TestInstance', `FBL~IDTestInstance~INN~${ IDTestInstances.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting TestInstances: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
    }

    async _getTestInstancesForSample(IDSample)
    {
        const tisjs = await this._getTestInstanceSampleJoinsForSample(IDSample);
        return await this._getTestInstancesByIDs(tisjs.map(t => t.IDTestInstance));
    }

    /**
     * The Tests a Sample is joined to (through its TestInstances), one per Test, in TestInstance order.
     * @param {number} IDSample
     * @return {Promise<Array<Object>>}
     */
    async getTestsForSample(IDSample)
    {
        const tisjs = await this._getTestInstanceSampleJoinsForSample(IDSample);
        if (!tisjs?.length)
        {
            return [];
        }
        const testInstances = await this._getTestInstancesByIDs(tisjs.map(t => t.IDTestInstance));
        const IDTests = [ ...new Set((testInstances || []).map(t => t.IDTest).filter(Boolean)) ];
        if (!IDTests.length)
        {
            return [];
        }
        const testMap = {};
        for (let t of await this.getTestsByIDs(IDTests))
        {
            testMap[t.IDTest] = t;
        }
        return IDTests.map(id => testMap[id]).filter(Boolean);
    }

	async getTestInstanceBundleForSample(IDSample)
    {
        try
        {
            const TestInstances = await this._getTestInstancesForSample(IDSample);
            if (!TestInstances?.length)
            {
                return { TestInstances: [], TestInstanceDocumentMap: {}, TestMap: {} };
            }
            const TestInstanceDocumentMap = await this._getDocumentMapForTestInstances(TestInstances.map(t => t.IDTestInstance));
            const Tests = await this.getTestsByIDs(TestInstances.map(t => t.IDTest));
            const TestMap = {};
            for (let t of Tests)
            {
                TestMap[t.IDTest] = t;
            }

            // For now, let's also check Entity Data for Test Instance associations as well.
            // RIDOT doesn't have joins from TestInstance to Document currently for example.
            const tiGUIDMap = {};
            for (let t of TestInstances)
            {
                tiGUIDMap[t.GUIDTestInstance] = t.IDTestInstance;
            }
            const DocumentsForSample = await this._getDocumentsForSample(IDSample);
            for (let d of DocumentsForSample)
            {
                if (d.EntityData?.TestInstance?.length)
                {
                    for (let t of d.EntityData.TestInstance)
                    {
                        if (typeof t?.GUIDTestInstance !== 'string')
                        {
                            continue;
                        }
                        if (t.GUIDTestInstance.includes('{IDDocument}'))
                        {
                            t.GUIDTestInstance = t.GUIDTestInstance.replace('{IDDocument}', d.IDDocument);
                        }
                        if (tiGUIDMap[t.GUIDTestInstance] && TestInstanceDocumentMap[tiGUIDMap[t.GUIDTestInstance]] && !TestInstanceDocumentMap[tiGUIDMap[t.GUIDTestInstance]].map(d => d.IDDocument).includes(d.IDDocument))
                        {
                            TestInstanceDocumentMap[tiGUIDMap[t.GUIDTestInstance]].push(d)
                        }
                    }
                }
            }

            return { TestInstances, TestInstanceDocumentMap, TestMap };
        }
        catch (e)
        {
            console.log(`Failed to get Test Instance Bundle for Sample ${ IDSample }: `, e);
            return { TestInstances: [], TestInstanceDocumentMap: {}, TestMap: {} };
        }
    }
}

module.exports = TestInstanceProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1610:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UploadTrackingProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		window.Mixins =
		{
			currentlyUploading: 0,
		};

		this.trackedUploads = [];
		this.nextUploadID = 0;
	}

	/**
	 * Adds an upload to the list of uploads being tracked, then sets the numeric flag that FB ios looks for.
	 * Gives back an id that can be used to remove the upload from the list later.
	 *
	 * @return {Number} - An id that can be used to untrack the upload later.
	 */
	trackUpload()
	{
		// Generating an error, not for the error but just to retain a copy of the stack.
		const error = new Error();
		// Monotonic rather than a timestamp: two uploads starting in the same millisecond would otherwise
		// share an id, and untracking either one would clear both while a transfer was still in flight.
		const id = ++this.nextUploadID;
		this.trackedUploads.push(
			{
				id,
				stack: error.stack,
			},
		);
		window.Mixins.currentlyUploading = this.trackedUploads.length;
		return id;
	}

	/**
	 * Removes an upload from the list of uploads being tracked using its id.
	 * @param {Number} id - An id passed from the calling function, should be the same one used to originally add the upload.
	 */
	untrackUpload(id)
	{
		this.trackedUploads = this.trackedUploads.filter((u) =>
		{
			return u.id !== id;
		});
		window.Mixins.currentlyUploading = this.trackedUploads.length;
	}
}

module.exports = UploadTrackingProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1611:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class UserProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the user by ID
	 * @param {String|Number} pUserID - The user ID to search for
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getUserByID(pUserID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pUserID)
			{
				this.pict.log.error('No User ID provided.');
				return reject(new Error('No User ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`User/${pUserID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting User: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get users by a list of user IDs
	 * @param {Array<String|Number>} pUserList - The list of user IDs to search for
	 * @return {Promise<Array>} - A promise that resolves to an array of users
	 * @async
	 * @example
	 */
	getUsersByIDList(pUserList)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pUserList || !Array.isArray(pUserList) || pUserList.length === 0)
			{
				this.pict.log.error('No User List provided.');
				return reject(new Error('No User List provided.'));
			}

			this.pict.HeadlightRestClient.getJSON('Users/FilteredTo/FBL~IDUser~INN~' + pUserList.join(','), (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Users: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = UserProvider;
module.exports.default_configuration = {};

},{"pict-provider":552}],1612:[function(require,module,exports){
/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');
const libHosts = require('headlight-qrcode/source/Headlight-QRCode-Hosts.js');

class UtilityProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	// TODO: This may be eventually replaced with the HeadlightRestClient/OfflineRestClient
	/**
	 * @param {object} options - JSON containing all the configurations for this query (including filters, sorting, etc.)
	 * @return {string} a meadow filter query stanza created from 'options' (e.g FBV~Something~EQ~Less~FSF~Else~ASC~0/0/250)
	 */
	generateMeadowFilter(options)
	{
		const queryFilter = [];
		// add filter stanzas
		for (const entry of (options.filters?? []))
		{
			const filterPrefix = entry.connector === 'OR' ? 'FBVOR' : 'FBV';
			switch (entry.comparator)
			{
			case 'FOP':
				queryFilter.push('FOP~0~(~0');
				break;
			case 'FCP':
				queryFilter.push('FCP~0~)~0');
				break;
			case 'INN':
			case 'NIN':
				const listPrefix = entry.connector === 'OR' ? 'FBLOR' : 'FBL';
				let inList = Array.isArray(entry.target) ? entry.target : [ entry.target ];
				inList = inList.map((singleTarget) => encodeURIComponent(singleTarget));
				queryFilter.push(`${listPrefix}~${entry.field}~${entry.comparator}~${inList}`);
				break;
			case 'LK':
				queryFilter.push(`${filterPrefix}~${entry.field}~LK~%25${encodeURIComponent(entry.target.replace(/\*/g, '%25'))}%25`);
				break;
			default:
				queryFilter.push(`${filterPrefix}~${entry.field}~${entry.comparator}~${encodeURIComponent(entry.target)}`);
				break;
			}
		}
		// add sorting
		if (options.hasOwnProperty('sort') && options.sort.field && options.sort.direction)
		{
			queryFilter.push(`FSF~${options.sort.field}~${options.sort.direction}~0`);
		}
		const filterString = queryFilter.join('~');
		// NOTED: Removed pagination due to issues with /Count/ fetching
		// add pagination
		// if (options.hasOwnProperty('pagination'))
		// {
		// 	filterString += `/${options.pagination.start}/${options.pagination.limit}`;
		// }
		const hasFilters = (queryFilter.length > 0) || (options.sort && options.sort?.field && options.sort?.direction);
		return (hasFilters ? 'FilteredTo/' : '') + filterString;
	}

	/**
	 * This method formats the results for the Select2 AJAX call.
	 * @param {Array} pData - The data to format.
	 * @param {string|array} pIDKey - The key(s) to use for the ID.
	 * @param {string|array} pTextKey - The key(s) to use for the text.
	 * @param {Array} pSelectedOptions - The selected options to add to the top of the list.
	 * @param {Object} pStickyOption - The sticky option to add to the top of the list.
	 * @param {Boolean} [joinTextKeys] - Should the text key array be joined together.
	 * @return {Array} The formatted results.
	 */
	formatSelect2Results(pData, pIDKey, pTextKey, pSelectedOptions, pStickyOption, joinTextKeys)
	{
		let results = $.map(pData, function(item)
		{
			const result = {};
			// if they pIDKey is an array, we need to loop through the array keys as fallback values
			if (Array.isArray(pIDKey))
			{
				for (let i = 0; i < pIDKey.length; i++)
				{
					if (item[pIDKey[i]])
					{
						result.id = item[pIDKey[i]];
						// if we have selected options, mark them as selected in the dropdown list
						if (pSelectedOptions && pSelectedOptions.includes(result.id))
						{
							result.selected = true;
						}
						break;
					}
				}
			}
			else
			{
				result.id = item?.[pIDKey] || item?.Hash || 0;
			}
			// if they pTextKey is an array, we need to loop through the array keys as fallback values
			if (Array.isArray(pTextKey))
			{
				for (let i = 0; i < pTextKey.length; i++)
				{
					if (item[pTextKey[i]])
					{
						result.text = joinTextKeys ? result.text ? (result.text + ' ' + item[pTextKey[i]]) : item[pTextKey[i]] : item[pTextKey[i]];
						if (!joinTextKeys)
						{
							break;
						}
					}
				}
			}
			else
			{
				result.text = item?.[pTextKey] || item?.Value || ' ';
			}
			return result;
		});
		// go ahead and sort by the text value before returning
		results.sort((a, b) => (a.text > b.text) ? 1 : -1);
		// if we have a sticky option, add it to the top of the dropdown list
		if (pStickyOption)
		{
			// set the sticky flag so we can style it differently in the dropdown
			pStickyOption.sticky = true;
			// remove the sticky option from the results if it already exists
			results = results.filter((item) => item.id !== pStickyOption.id);
			// then, add it to the top of the list
			results.unshift(pStickyOption);
		}
		return results;
	}

	/**
	 * Clear the date time picker.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	clearDateTimePicker(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				tmpFlatpickrInstance.clear();
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}

	/**
	 * Set the date time picker to the 'now' date/time.
	 * @param {string} pInputHTMLID The input HTML ID.
	 * @return {void}
	 */
	setDateTimePickerToNow(pInputHTMLID)
	{
		const tmpFlatpickrElement = document.querySelector(pInputHTMLID);
		if (tmpFlatpickrElement)
		{
			const tmpFlatpickrInstance = tmpFlatpickrElement['_flatpickr'];
			if (tmpFlatpickrInstance)
			{
				tmpFlatpickrInstance.setDate(new Date());
				// create a new change event to trigger the data request
				const tmpChangeEvent = new Event('change', { bubbles: true });
				tmpFlatpickrElement.dispatchEvent(tmpChangeEvent);
				tmpFlatpickrInstance.close();
			}
		}
	}

	/**
	 * This method builds the extra buttons for the flatpickr date picker.
	 * @param {Object} pInstance - The flatpickr instance.
	 * @param {string} pElementID - The ID of the date picker input element.
	 * @return {void}
	 */
	buildFlatpickrExtraButtons(pInstance, pElementID)
	{
		const template =
		`<div class="flatpicker-extras">
			<div class="buttons py-1 is-centered">
				<button class="button is-outline is-small" type="button" onclick="_Pict.providers.UtilityProvider.clearDateTimePicker('#${pElementID}')">
					<span class="icon">
						<i class="fa fa-fw fa-undo"></i>
					</span>
					<span class="icon-text">
						Clear
					</span>
				</button>
				<button class="button is-link is-small " type="button" onclick="_Pict.providers.UtilityProvider.setDateTimePickerToNow('#${pElementID}')">
					<span class="icon">
						<i class="fa fa-fw fa-calendar"></i>
					</span>
					<span class="icon-text">
						Set to Current Date
					</span>
				</button>
			</div>
		</div>`;
		// add the extra buttons to the calendar container
		if (!pInstance.calendarContainer)
		{
			console.warn('[Utility] Unable to add flatpickr extra buttons, calendarContainer is not defined.');
			return;
		}
		pInstance.calendarContainer.insertAdjacentHTML('beforeend', template);
	}

	/**
	 * This method is used to validate if a passed string is a valid latitude geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLatitude('24.034345') => '24.034345'
	 */
	isValidLatitude = (value) =>
	{
		const latReg = RegExp(/^(\+|-)?(?:90(?:(?:\.0{0,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = latReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Latitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * This method is used to validate if a passed string is a valid longitue geocoordinate.
	 * The value is not altered, but it throws out a warning in the console for invalid values.
	 * @param {string} value - the geolocation string
	 * @return {string} - the same, unaltered geolocation string
	 * @example
	 * IsValidLongitude('24.034345') => '24.034345'
	 */
	isValidLongitude = (value) =>
	{
		const longReg = RegExp(/^(\+|-)?(?:180(?:(?:\.0{0,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{0,16})?))$/);
		const pass = longReg.test(value);
		if (!pass)
		{
			console.warn(`[Utility] This is not a valid Longitude coordinate:`, value);
			return '';
		}
		return value;
	};

	/**
	 * Get a Google Maps URL for a the passed entity record.
	 * @param {Object} pEntity - The record to get the Google Maps URL for (this assume the record has a User/Capture latitude and longitude)
	 * @param {Object} pOptions - The options for the Google Maps URL
	 * @return {string} - The Google Maps URL
	 */
	getGoogleMapURLFromEntityRecord(pEntity, pOptions = {})
	{
		// Documentation for Google Maps = https://developers.google.com/maps/documentation/maps-static/dev-guide
		let staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap`;
		const tmpMarkerColor = pOptions.markerColor || 'orange';
		// map params for google maps
		const urlParams = {
			scale: pOptions.scale || 1,
			size: pOptions.size || '640x480',
			key: pOptions.key || 'AIzaSyD4ZhOfhsWIII7qOYKRS2SfKZ1iPeIeQfU',
			maptype: pOptions.maptype || 'roadmap',
		};
		// build url from params
		Object.entries(urlParams).forEach(([ key, val ]) =>
		{
			staticMapUrl += `${ key === 'scale' ? '?' : '&' }${ key }=${ val }`;
		});
		// TODO: make this better for "0.000" strings, etc
		const tmpLatitude = pEntity.Latitude || pEntity.CaptureLatitude || pEntity.UserLatitude || 0;
		const tmpLongitude = pEntity.Longitude || pEntity.CaptureLongitude || pEntity.UserLongitude || 0;

		let hasValidGeolocation = false;
		if (tmpLatitude && tmpLongitude)
		{
			hasValidGeolocation = this.isValidLatitude(tmpLatitude) && this.isValidLongitude(tmpLongitude) && (Number(tmpLatitude) !== 0 && Number(tmpLongitude) !== 0);
		}

		if (hasValidGeolocation)
		{
			staticMapUrl += `&markers=color:${ tmpMarkerColor }%7Csize:tiny%7C${ tmpLatitude },${ tmpLongitude }`;
		}
		else
		{
			console.warn(`[Utility] Unable to get Google Maps URL for entity record:`, pEntity);
			return '';
		}
		return staticMapUrl;
	};

	/**
	 * Remove all 'is-loading' classes from the document.
	 * @return {void}
	 */
	removeAllLoadingClasses()
	{
		document.querySelectorAll('.is-loading').forEach((element) =>
		{
			element.classList.remove('is-loading');
		});
	}

	/**
	 * This method generates a HSL color based on the passed string.
	 * @param {string} str - The string to generate the color from.
	 * @param {number} s - The saturation of the color (0-100).
	 * @param {number} l - The lightness of the color (0-100).
	 * @return {string} - The HSL color.
	 */
	stringToHSLColor(str, s, l)
	{
		let hash = 0;
		for (let i = 0; i < str.length; i++)
		{
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}

		const h = hash % 360;
		return 'hsl('+h+', '+s+'%, '+l+'%)';
	}

	/**
	 * This method highlights a list item row element by adding a class and scrolling it into view.
	 * @param {HTMLElement} pListItemRowElement - The list item row element to highlight.
	 * @param {string} pScrollConainerElement - The scroll container element to scroll into view (optional).
	 * @return {boolean} - Returns true if the element was highlighted, false otherwise.
	 * @example
	 * _Pict.providers.UtilityProvider.highlightListItemRowElement(document.querySelector('.list-item-row[data-obseravtion-id="123456"]'));
	 */
	highlightListItemRowElement(pListItemRowElement, pScrollConainerElement)
	{
		if (!pListItemRowElement)
		{
			console.warn('[Utility] Unable to highlight list item row element, it is null or undefined.');
			return false;
		}
		const tmpListItemRowElement = pListItemRowElement instanceof HTMLElement ? pListItemRowElement : document.querySelector(pListItemRowElement);
		if (tmpListItemRowElement)
		{
			tmpListItemRowElement.classList.add('is-selected', 'animate__animated', 'animate__pulse');
			// NOTE: Do not do "tmpListItemRowElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });" bc it scrolls the whole page, not just the list item row
			if (this.pict.ContentAssignment.hasJquery)
			{
				// if we have a scroll container element, use it to scroll the list item into view
				if (pScrollConainerElement && $(pScrollConainerElement).length > 0)
				{
					$(pScrollConainerElement).animate({
						scrollTop: $(tmpListItemRowElement).offset().top - $(pScrollConainerElement).offset().top + $(pScrollConainerElement).scrollTop(),
					}, 500);
				}
			}
			setTimeout(() =>
			{
				tmpListItemRowElement.classList.remove('is-selected', 'animate__animated', 'animate__pulse');
			}
			, 5000); // 5 seconds
			return true;
		}
		else
		{
			console.warn('[Utility] Unable to highlight list item row element, it is null or undefined.');
			return false;
		}
	}

	/**
	 * This method is used to remove the loading skeletons from an element. It tries to be smart about where he classes are on the parent element and the element itself.
	 * @param {HTMLElement|jQuery} pElement - The element to remove the loading skeletons from.
	 * @return {boolean} - Returns true if the skeletons were removed, false otherwise.
	 */
	removeLoadingSkeleton(pElement)
	{
		if (!pElement)
		{
			console.warn('[Utility] Unable to remove loading skeletons, the element is null or undefined.');
			return false;
		}
		// if the element is a jQuery object, get the first element
		if (pElement instanceof jQuery)
		{
			pElement = pElement[0];
		}
		// if the element is not an HTMLElement, return false
		if (!(pElement instanceof HTMLElement))
		{
			console.warn('[Utility] Unable to remove loading skeletons, the element is not an HTMLElement.');
			return false;
		}
		// if the parent element has the 'is-skeleton' class, remove it there
		if (pElement?.parentElement?.classList?.contains('is-skeleton'))
		{
			pElement.parentElement.classList.remove('is-skeleton');
			return true;
		}
		// if the element itself has the 'is-skeleton' class, remove it there
		else if (pElement?.classList?.contains('is-skeleton'))
		{
			pElement.classList.remove('is-skeleton');
			return true;
		}
		else
		{
			console.warn('[Utility] Unable to remove loading skeletons, the element does not have the is-skeleton class.');
			return false;
		}
	}

	/**
	 * A general utility to pause any active media on the page.
	 * @return {void}
	 */
	pauseAnyActiveMedia()
	{
		const tmpMedia = document.querySelectorAll('video, audio');
		tmpMedia.forEach(
			/**
			 * @param {HTMLMediaElement|HTMLVideoElement} media
			 */
			(media) =>
			{
				if (!media.paused)
				{
					media.pause();
				}
			});
	}

	/**
	 * The environment the page belongs to, e.g. 'QA' or 'Production'. The rule lives in headlight-qrcode
	 * (Hosts.getEnvironmentForPage), so labels printed here and by HeadlightQR point at the same host.
	 * @return {string}
	 */
	getEnvironment()
	{
		const tmpLocation = (typeof window !== 'undefined' && window.location) ? window.location : {};
		return libHosts.getEnvironmentForPage({ Protocol: tmpLocation.protocol, Hostname: tmpLocation.hostname, ServerURL: (typeof window !== 'undefined') ? window._OfflineServerBaseURL : undefined });
	}

	/**
	 * The environment label of the page, e.g. '.qa', or '' for production.
	 * @return {string} - The subdomain for the current environment.
	 */
	getEnvironmentSubdomainFromWindowLocation()
	{
		const tmpLabel = libHosts.ENVIRONMENT_LABELS[this.getEnvironment()];
		return tmpLabel ? `.${ tmpLabel }` : '';
	};

	/**
	 * This method builds the links URL based on the current environment.
	 * It uses the getEnvironmentSubdomainFromWindowLocation method to determine the subdomain.
	 * @return {string} - The links URL for the current environment.
	 */
	buildLinksUrl()
	{
		const subdomain = this.getEnvironmentSubdomainFromWindowLocation();
		return `https://links${ subdomain }.headlight.com`;
	}
}

module.exports = UtilityProvider;
module.exports.default_configuration = {};

},{"headlight-qrcode/source/Headlight-QRCode-Hosts.js":16,"pict-provider":552}]},{},[831])(831)
});

